
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequire49d7"];
var parcelRegister = parcelRequire.register;
parcelRegister("dnhKp", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $20e3d3c7990d266d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
parcelRequire("3avtZ");

var $i2Rm5 = parcelRequire("i2Rm5");

var $4R6GH = parcelRequire("4R6GH");

var $lfTZh = parcelRequire("lfTZh");

var $11dfA = parcelRequire("11dfA");

var $9kARR = parcelRequire("9kARR");

var $4dRjY = parcelRequire("4dRjY");

var $l8ruj = parcelRequire("l8ruj");

var $1bQGJ = parcelRequire("1bQGJ");

var $29QEe = parcelRequire("29QEe");
const $20e3d3c7990d266d$var$RouterWrapper = (0, $1bQGJ.withRouter)((0, $29QEe.Board));
const $20e3d3c7990d266d$var$BoardSPAApp = ()=>{
    const children = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "next-gen-board",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11dfA.NextGenBoardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kARR.SuspenseTrackerFallback), null))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dRjY.MarkProductStart), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorBoundaryFlag), {
        id: "spa-app-bootstrap.next-gen.board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20e3d3c7990d266d$var$RouterWrapper, null)));
    if ((0, $4R6GH.fg)('critical_board_query_with_relay')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "next-gen-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kARR.SuspenseTrackerProvider), null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "next-gen-board"
    }, children);
};
var $20e3d3c7990d266d$export$2e2bcd8739ae039 = $20e3d3c7990d266d$var$BoardSPAApp;

});
parcelRegister("11dfA", function(module, exports) {

$parcel$export(module.exports, "NextGenBoardSkeleton", () => $b1638a290dc4da1e$export$25a9d0fbcb127c90);
/* NextGenBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $kNTTx = parcelRequire("kNTTx");
const $b1638a290dc4da1e$var$customCssStyles = null;
const $b1638a290dc4da1e$export$25a9d0fbcb127c90 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($kNTTx))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("kNTTx", function(module, exports) {
module.exports = new URL("next-gen-board-app-skeleton.tpl.d10f8ca5.svg", import.meta.url).toString();

});


parcelRegister("9kARR", function(module, exports) {

$parcel$export(module.exports, "SuspenseTrackerProvider", () => $e05a0c2231be48ec$export$58f6796252ab3147);
$parcel$export(module.exports, "SuspenseTrackerFallback", () => $e05a0c2231be48ec$export$8637c61d65a3606b);
$parcel$export(module.exports, "useGetHasSuspended", () => $e05a0c2231be48ec$export$a143cd14d496de4d);

var $5uXOq = parcelRequire("5uXOq");
class $e05a0c2231be48ec$export$87993bf75925b3bd {
    getHasSuspended() {
        return this.suspendCount !== 0;
    }
    /**
	 * Should be called on unmount of the tracked sub-tree
	 */ reset() {
        this.suspendCount = 0;
    }
    /**
	 * Should be called when a suspend happens
	 */ onSuspend() {
        this.suspendCount += 1;
    }
    constructor(){
        this.suspendCount = 0;
    }
}
const $e05a0c2231be48ec$var$SuspenseTrackerContext = /*#__PURE__*/ (0, $5uXOq.createContext)(new $e05a0c2231be48ec$export$87993bf75925b3bd());
const $e05a0c2231be48ec$export$58f6796252ab3147 = ({ children: children })=>{
    const suspenseTrackerRef = (0, $5uXOq.useRef)(new $e05a0c2231be48ec$export$87993bf75925b3bd());
    (0, $5uXOq.useEffect)(()=>()=>{
            suspenseTrackerRef.current?.reset();
        }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e05a0c2231be48ec$var$SuspenseTrackerContext.Provider, {
        value: suspenseTrackerRef.current
    }, children);
};
const $e05a0c2231be48ec$export$8637c61d65a3606b = ()=>{
    const suspenseTracker = (0, $5uXOq.useContext)($e05a0c2231be48ec$var$SuspenseTrackerContext);
    (0, $5uXOq.useEffect)(()=>{
        suspenseTracker.onSuspend();
    }, [
        suspenseTracker
    ]);
    return null;
};
const $e05a0c2231be48ec$export$a143cd14d496de4d = ()=>{
    const suspenseTracker = (0, $5uXOq.useContext)($e05a0c2231be48ec$var$SuspenseTrackerContext);
    return suspenseTracker.getHasSuspended();
};

});

parcelRegister("4dRjY", function(module, exports) {

$parcel$export(module.exports, "PRODUCT_START_MARK", () => $9953c23a4f71adac$export$8e54fca0a680fdfd);
$parcel$export(module.exports, "MarkProductStart", () => $9953c23a4f71adac$export$2a999c5f84501025);

var $x9xyg = parcelRequire("x9xyg");
const $9953c23a4f71adac$export$8e54fca0a680fdfd = 'PRODUCT_START';
const $9953c23a4f71adac$export$2a999c5f84501025 = ()=>{
    if (!false) {
        performance.clearMarks($9953c23a4f71adac$export$8e54fca0a680fdfd);
        (0, $x9xyg.setMark)($9953c23a4f71adac$export$8e54fca0a680fdfd);
    }
    return null;
};

});

parcelRegister("29QEe", function(module, exports) {

$parcel$export(module.exports, "Board", () => $e20b36b875aef26b$export$dc537a3a3893548e);

var $5uXOq = parcelRequire("5uXOq");

var $2i4sA = parcelRequire("2i4sA");

var $4R6GH = parcelRequire("4R6GH");

var $ao2h1 = parcelRequire("ao2h1");

var $5qQ9I = parcelRequire("5qQ9I");

var $efvDm = parcelRequire("efvDm");

var $gKBVc = parcelRequire("gKBVc");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $38Y30 = parcelRequire("38Y30");

var $9OXo1 = parcelRequire("9OXo1");

var $j8DrX = parcelRequire("j8DrX");

var $5eRaS = parcelRequire("5eRaS");

var $12Sv5 = parcelRequire("12Sv5");

var $54XqP = parcelRequire("54XqP");

var $kCEVs = parcelRequire("kCEVs");

var $6Zotr = parcelRequire("6Zotr");
const $e20b36b875aef26b$var$BoardWithRouterWrapper = (props)=>{
    const isCMPBoard = (0, $12Sv5.useIsCMPBoardRoute)();
    if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $54XqP.BoardWithRouterCMP), props);
    if ((0, $4R6GH.fg)('critical_board_query_with_relay')) {
        /* eslint-disable-next-line react-hooks/rules-of-hooks */ const response = (0, $ao2h1.useRelayResource)((0, $5qQ9I.boardRelayResource));
        return response.queryReference != null ? // @ts-expect-error - TS2322 - Type 'PreloadedQuery<OperationType, Record<string, unknown>>' is not assignable to type 'PreloadedQuery<boardWithRouterRelayQuery, Record<string, unknown>>'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kCEVs.BoardWithRouterRelay), {
            ...props,
            boardQueryReference: response.queryReference
        }) : null;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Zotr.BoardWithRouter), props);
};
const $e20b36b875aef26b$export$dc537a3a3893548e = ({ route: route, match: match })=>{
    const boardId = Number(match.params.boardId);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isAuthenticated = (0, $9NiTW.checkAuthentication)(tenantContext);
    const hasSoftwareLicense = (0, $3RV1W.checkLicense)(tenantContext, 'software');
    const isCMPBoard = (0, $12Sv5.useIsCMPBoardRoute)();
    const isEmbedView = (0, $gKBVc.useIsEmbedView)();
    const isBifrost = !!(0, $5eRaS.ssr).getFeatureFlags()?.ssrViaBifrost;
    if (!isAuthenticated) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experienceId: `${boardId}`,
        experience: "viewBoard",
        analyticsSource: "board",
        edition: tenantContext.appEditions.software,
        application: (0, $efvDm.JIRA_SOFTWARE),
        additionalAttributes: {
            isClassic: isCMPBoard,
            isUIF: true,
            taskId: boardId,
            isBifrost: isBifrost,
            shard: (0, $j8DrX.default)('ajs-shard') ?? {},
            region: (0, $j8DrX.default)('ajs-region') ?? {},
            ...typeof isEmbedView === 'boolean' ? {
                isEmbed: isEmbedView
            } : {}
        }
    }, route ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e20b36b875aef26b$var$BoardWithRouterWrapper, {
        hasSoftwareLicense: hasSoftwareLicense
    }) : null);
};

});
parcelRegister("5qQ9I", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $21d99b29ea940c83$export$286b76e0f2661cfb);
$parcel$export(module.exports, "customFiltersResource", () => $21d99b29ea940c83$export$3e390340716755de);
$parcel$export(module.exports, "boardFilterRefinementResource", () => $21d99b29ea940c83$export$283d16e3e02421f0);
$parcel$export(module.exports, "boardRelayResource", () => $21d99b29ea940c83$export$81ac23db76b1f935);
// eslint-disable-next-line jira/import-whitelist -- Unclear how to change the config whilst we transition to flat config

var $6s1PB = parcelRequire("6s1PB");

var $dXq4S = parcelRequire("dXq4S");

var $ao2h1 = parcelRequire("ao2h1");

var $6mTNg = parcelRequire("6mTNg");

var $9fgCw = parcelRequire("9fgCw");

var $ke2kk = parcelRequire("ke2kk");

var $gNStA = parcelRequire("gNStA");

var $2M1hQ = parcelRequire("2M1hQ");


const $21d99b29ea940c83$export$286b76e0f2661cfb = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $2M1hQ.createResource)({
    type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>Promise.resolve((parcelRequire("11pNz"))),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
}));
const $21d99b29ea940c83$export$3e390340716755de = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$b48bcc76a0105016),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $9fgCw.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));
const $21d99b29ea940c83$export$283d16e3e02421f0 = (0, $gNStA.resourceWithCondition2)(()=>(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false), (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$339da8fd7fc0a8e9),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $ke2kk.default),
            variables: {
                cloudId: tenantContext.cloudId,
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                }),
                filterRefinementScope: {
                    board: {
                        boardId: Number(match.params.boardId)
                    }
                }
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        }),
    isBrowserOnly: true
}));
const $21d99b29ea940c83$export$81ac23db76b1f935 = (0, $gNStA.browserOnlyResourceWithCondition)(()=>false, (0, $ao2h1.createRelayResource)({
    type: (0, $a00fc8fb83f2948a$export$5cef388780439aec),
    getQuery: ({ match: match }, { tenantContext: tenantContext })=>({
            parameters: (0, $6mTNg.default),
            variables: {
                boardId: (0, $dXq4S.createAri)({
                    resourceOwner: 'jira-software',
                    cloudId: tenantContext.cloudId,
                    resourceType: 'board',
                    resourceId: String(match.params.boardId)
                })
            },
            options: {
                fetchPolicy: 'store-and-network'
            }
        })
}));

});
parcelRegister("6mTNg", function(module, exports) {

$parcel$export(module.exports, "default", () => $ddc6b6eeb5cc2255$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<916f92cb49153da25a6abe2a4d651185>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67
const $ddc6b6eeb5cc2255$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
        "metadata": {},
        "name": "boardWithRouterRelayQuery",
        "operationKind": "query",
        "text": null
    }
};
var $ddc6b6eeb5cc2255$export$2e2bcd8739ae039 = $ddc6b6eeb5cc2255$var$node;

});

parcelRegister("9fgCw", function(module, exports) {

$parcel$export(module.exports, "default", () => $59a4f75157ae0306$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3e40c06e874adef0395c5788a7d119a9>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b
const $59a4f75157ae0306$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
        "metadata": {},
        "name": "viewBoardCustomFiltersQuery",
        "operationKind": "query",
        "text": null
    }
};
var $59a4f75157ae0306$export$2e2bcd8739ae039 = $59a4f75157ae0306$var$node;

});

parcelRegister("ke2kk", function(module, exports) {

$parcel$export(module.exports, "default", () => $32c6ecabe578696e$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b2791ce93d3a0a0e17fee486ad965601>>
 * @relayHash 5c749d389bf268ee9226560ad568adcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06
const $32c6ecabe578696e$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06",
        "metadata": {},
        "name": "boardFilterRefinementQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32c6ecabe578696e$export$2e2bcd8739ae039 = $32c6ecabe578696e$var$node;

});

const $a00fc8fb83f2948a$export$a38ac7339e3f31db = 'NEXTGEN_BOARD';
const $a00fc8fb83f2948a$export$b48bcc76a0105016 = 'NEXTGEN_BOARD_CUSTOM_FILTERS';
const $a00fc8fb83f2948a$export$5cef388780439aec = 'NEXTGEN_BOARD_RELAY';
const $a00fc8fb83f2948a$export$339da8fd7fc0a8e9 = 'NEXTGEN_BOARD_FILTER_REFINEMENT';


parcelRegister("gKBVc", function(module, exports) {

$parcel$export(module.exports, "useIsEmbedView", () => $663910b24a55eb33$export$83ee417ebec96ced);

var $4R6GH = parcelRequire("4R6GH");

var $eeXsz = parcelRequire("eeXsz");

var $fEr2a = parcelRequire("fEr2a");

var $doZTA = parcelRequire("doZTA");

var $67Z81 = parcelRequire("67Z81");
const $663910b24a55eb33$export$83ee417ebec96ced = ()=>{
    const [{ route: route }] = (0, $doZTA.useRouter)();
    return (0, $4R6GH.fg)('smart_links_for_plans') ? route.name === (0, $eeXsz.softwareBoardEmbedRoute).name || route.name === (0, $fEr2a.classicSoftwareBoardEmbedRoute).name || (0, $67Z81.getIsIncrementPlanningBoardEmbed)() : route.name === (0, $eeXsz.softwareBoardEmbedRoute).name || route.name === (0, $fEr2a.classicSoftwareBoardEmbedRoute).name;
};

});
parcelRegister("eeXsz", function(module, exports) {

$parcel$export(module.exports, "softwareBoardEmbedRoute", () => $f06c20d996c477e6$export$f55626b64e3fcb4f);
const $f06c20d996c477e6$export$f55626b64e3fcb4f = {
    name: 'software-boards-embed',
    exact: true,
    path: '/jira/software/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("fEr2a", function(module, exports) {

$parcel$export(module.exports, "classicSoftwareBoardEmbedRoute", () => $4d20da2caca0ff94$export$122afcef7dfd252);
const $4d20da2caca0ff94$export$122afcef7dfd252 = {
    name: 'rapidboard-board-embed',
    path: '/jira/software/c/projects/:projectKey/boards/:boardId/embed'
};

});

parcelRegister("67Z81", function(module, exports) {

$parcel$export(module.exports, "getUi", () => $3bb2e3ee04eeeeab$export$4725deb5993d78ae);
$parcel$export(module.exports, "getEntities", () => $3bb2e3ee04eeeeab$export$e2e3f9f64b249105);
$parcel$export(module.exports, "getIssueTypes", () => $3bb2e3ee04eeeeab$export$4cf4b24b88599615);
$parcel$export(module.exports, "getIssueLinkTypes", () => $3bb2e3ee04eeeeab$export$6ddaadcbafcd26f5);
$parcel$export(module.exports, "getIssueLinkTypeById", () => $3bb2e3ee04eeeeab$export$8b0014e82b332300);
$parcel$export(module.exports, "getProjectIssueTypes", () => $3bb2e3ee04eeeeab$export$3fdf4c5c6ee04f6a);
$parcel$export(module.exports, "getIssueTypesByProject", () => $3bb2e3ee04eeeeab$export$e3c86a4bf1a35488);
$parcel$export(module.exports, "getIssueTypeInIPboard", () => $3bb2e3ee04eeeeab$export$72c541e09abc58a);
$parcel$export(module.exports, "getIssues", () => $3bb2e3ee04eeeeab$export$73a53226406d7fe);
$parcel$export(module.exports, "getRequestTypes", () => $3bb2e3ee04eeeeab$export$12f7fd1ebbcde80c);
$parcel$export(module.exports, "getStatuses", () => $3bb2e3ee04eeeeab$export$dcc5d2f98fd9404b);
$parcel$export(module.exports, "getMissingParents", () => $3bb2e3ee04eeeeab$export$44b65eb211450c23);
$parcel$export(module.exports, "getCardTransitions", () => $3bb2e3ee04eeeeab$export$c5f25828191314fe);
$parcel$export(module.exports, "getIssueTransitions", () => $3bb2e3ee04eeeeab$export$72f59a26cdbd80f7);
$parcel$export(module.exports, "getIssueProjects", () => $3bb2e3ee04eeeeab$export$be5248c466188e1e);
$parcel$export(module.exports, "getTeams", () => $3bb2e3ee04eeeeab$export$5a622455e94bac3);
$parcel$export(module.exports, "getIssueCount", () => $3bb2e3ee04eeeeab$export$56d545f19dc75191);
$parcel$export(module.exports, "getIssueProjectsPermissionGroup", () => $3bb2e3ee04eeeeab$export$ec1c8958fe62c3e0);
$parcel$export(module.exports, "getIssueProjectIds", () => $3bb2e3ee04eeeeab$export$5df97f05806d557e);
$parcel$export(module.exports, "hasMultipleProjects", () => $3bb2e3ee04eeeeab$export$fe12e63e07cfc7f1);
$parcel$export(module.exports, "getVersionData", () => $3bb2e3ee04eeeeab$export$6de24118cf63db1d);
$parcel$export(module.exports, "getBoardEntity", () => $3bb2e3ee04eeeeab$export$8933098120edcb76);
$parcel$export(module.exports, "getOrderedColumnIds", () => $3bb2e3ee04eeeeab$export$f83f9f72ba8c4f46);
$parcel$export(module.exports, "getOrderedIssueIds", () => $3bb2e3ee04eeeeab$export$6238ec962277eeda);
$parcel$export(module.exports, "getOrderedIssueChildrenIds", () => $3bb2e3ee04eeeeab$export$5cec7656a4a996e6);
$parcel$export(module.exports, "getIssueParentOrderIds", () => $3bb2e3ee04eeeeab$export$8383695e8cf09c1b);
$parcel$export(module.exports, "getBoardName", () => $3bb2e3ee04eeeeab$export$dce2562af6cbec6e);
$parcel$export(module.exports, "getAppConfiguration", () => $3bb2e3ee04eeeeab$export$cf1bba1f87489c02);
$parcel$export(module.exports, "getLocale", () => $3bb2e3ee04eeeeab$export$180605366c04f0cd);
$parcel$export(module.exports, "getBoardConfig", () => $3bb2e3ee04eeeeab$export$5f9288f90460d6e);
$parcel$export(module.exports, "isBoardRankable", () => $3bb2e3ee04eeeeab$export$a510d45029fb94ae);
$parcel$export(module.exports, "getIsIncrementPlanningBoard", () => $3bb2e3ee04eeeeab$export$58598521cc17408);
$parcel$export(module.exports, "getIsIncrementPlanningBoardEmbed", () => $3bb2e3ee04eeeeab$export$4f81bf0056c92691);
$parcel$export(module.exports, "getCanInviteOthersToProject", () => $3bb2e3ee04eeeeab$export$5124aa00ca92f2c0);
$parcel$export(module.exports, "getIncrementConfig", () => $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df);
$parcel$export(module.exports, "getPlanningUnit", () => $3bb2e3ee04eeeeab$export$7bd856f542fb6dc5);
$parcel$export(module.exports, "getIncrementPlanningEstimateFieldId", () => $3bb2e3ee04eeeeab$export$57d806afd0066281);
$parcel$export(module.exports, "getScenarioColor", () => $3bb2e3ee04eeeeab$export$e3ba46cc07a8e3c4);
$parcel$export(module.exports, "getBoardScopeFilter", () => $3bb2e3ee04eeeeab$export$794ec6fabc63d98b);
$parcel$export(module.exports, "getBoardScopeFilterType", () => $3bb2e3ee04eeeeab$export$27ef735461d030e);
$parcel$export(module.exports, "getPlanId", () => $3bb2e3ee04eeeeab$export$203ed8b65c3b2a28);
$parcel$export(module.exports, "getScenarioId", () => $3bb2e3ee04eeeeab$export$8572797243a693b9);
$parcel$export(module.exports, "getIsCMPBoard", () => $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9);
$parcel$export(module.exports, "getIsJSWBoard", () => $3bb2e3ee04eeeeab$export$7f8f378c3fc0f2e8);
$parcel$export(module.exports, "getOldDoneIssuesCutoffForTMPKanbanBoard", () => $3bb2e3ee04eeeeab$export$7d22dbc6792926ca);
$parcel$export(module.exports, "getCanEditBoard", () => $3bb2e3ee04eeeeab$export$7af50752d48bdabc);
$parcel$export(module.exports, "getBoardType", () => $3bb2e3ee04eeeeab$export$985c8cf86abe2d42);
$parcel$export(module.exports, "getBoardTypeForAnalytics", () => $3bb2e3ee04eeeeab$export$3997d54b0837aa80);
$parcel$export(module.exports, "getHierarchyNomenclature", () => $3bb2e3ee04eeeeab$export$e755a2f4c5e8ae37);
$parcel$export(module.exports, "contextPathSelector", () => $3bb2e3ee04eeeeab$export$84437322c8301f05);
$parcel$export(module.exports, "rapidViewIdSelector", () => $3bb2e3ee04eeeeab$export$718e830000b27a0e);
$parcel$export(module.exports, "currentUserAccountIdSelector", () => $3bb2e3ee04eeeeab$export$3b6693bb0269a108);
$parcel$export(module.exports, "projectKeySelector", () => $3bb2e3ee04eeeeab$export$404de5ac601b84bc);
$parcel$export(module.exports, "projectIdSelector", () => $3bb2e3ee04eeeeab$export$4c9d6034f65d22f4);
$parcel$export(module.exports, "projectNameSelector", () => $3bb2e3ee04eeeeab$export$aa9f20f9c212aac2);
$parcel$export(module.exports, "cloudIdSelector", () => $3bb2e3ee04eeeeab$export$b5a643cfff945455);
$parcel$export(module.exports, "activationIdSelector", () => $3bb2e3ee04eeeeab$export$2335b963a9875096);
$parcel$export(module.exports, "sessionIdSelector", () => $3bb2e3ee04eeeeab$export$e4acd42e3f15be28);
$parcel$export(module.exports, "projectTypeSelector", () => $3bb2e3ee04eeeeab$export$69316f88206ca90b);
$parcel$export(module.exports, "getIssueLimitExceeded", () => $3bb2e3ee04eeeeab$export$df55630d3e8d5b50);
$parcel$export(module.exports, "getSavedFilterId", () => $3bb2e3ee04eeeeab$export$61c8853134cd8886);
$parcel$export(module.exports, "getCanRankByIssue", () => $3bb2e3ee04eeeeab$export$7ee12a197503edb8);
$parcel$export(module.exports, "getIsDaysInColumnEnabled", () => $3bb2e3ee04eeeeab$export$5e459bc04e88e2ec);
$parcel$export(module.exports, "getIsEstimateEnabled", () => $3bb2e3ee04eeeeab$export$6839f41197f5a977);
$parcel$export(module.exports, "getIsPriorityEnabled", () => $3bb2e3ee04eeeeab$export$538dfd7d997a5ce3);
$parcel$export(module.exports, "getIsDevelopmentEnabled", () => $3bb2e3ee04eeeeab$export$50491a160efc0813);
$parcel$export(module.exports, "getIsDueDateEnabled", () => $3bb2e3ee04eeeeab$export$563e039f46413317);
$parcel$export(module.exports, "getIsIssueLabelsEnabled", () => $3bb2e3ee04eeeeab$export$5f0d2767bd7b902c);
$parcel$export(module.exports, "getCardExtraFields", () => $3bb2e3ee04eeeeab$export$f338837bff9d7477);
$parcel$export(module.exports, "getFirstNonEpicIssueInFirstColumn", () => $3bb2e3ee04eeeeab$export$c8b787a7644fe978);

var $alNv9 = parcelRequire("alNv9");

var $dGvGJ = parcelRequire("dGvGJ");

var $gKZoD = parcelRequire("gKZoD");

var $2vSU6 = parcelRequire("2vSU6");

var $4jAPy = parcelRequire("4jAPy");

const $3bb2e3ee04eeeeab$export$4725deb5993d78ae = (state)=>(0, $alNv9.ensureState)(state.ui);
const $3bb2e3ee04eeeeab$export$e2e3f9f64b249105 = (state)=>(0, $alNv9.ensureState)(state.entities);
const $3bb2e3ee04eeeeab$export$4cf4b24b88599615 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueTypes;
const $3bb2e3ee04eeeeab$export$6ddaadcbafcd26f5 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueLinkTypes;
const $3bb2e3ee04eeeeab$export$8b0014e82b332300 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$6ddaadcbafcd26f5
], (issueLinkTypes)=>(linkTypeId)=>issueLinkTypes.find((type)=>`${type.id}` === `${linkTypeId}`));
const $3bb2e3ee04eeeeab$export$3fdf4c5c6ee04f6a = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).projectIssueTypes;
const $3bb2e3ee04eeeeab$export$e3c86a4bf1a35488 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueTypesByProject;
const $3bb2e3ee04eeeeab$export$72c541e09abc58a = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$e3c86a4bf1a35488
], (issueTypesByProject)=>(projectId, issueTypeId)=>{
        const issueTypeArray = (issueTypesByProject[projectId] || []).filter((t)=>t.id === issueTypeId);
        return issueTypeArray.length > 0 ? issueTypeArray[0] : undefined;
    });
const $3bb2e3ee04eeeeab$export$73a53226406d7fe = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issues;
// not meant to export this function as it is the same as /selectors/issue-children/index.tsx@getIssueChildren
// it is used by getCanRankByIssue only
const $3bb2e3ee04eeeeab$var$getIssueChildren = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueChildren;
const $3bb2e3ee04eeeeab$export$12f7fd1ebbcde80c = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).requestTypes;
const $3bb2e3ee04eeeeab$export$dcc5d2f98fd9404b = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).statuses;
const $3bb2e3ee04eeeeab$export$44b65eb211450c23 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).missingParents;
const $3bb2e3ee04eeeeab$export$c5f25828191314fe = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).cardTransitions;
const $3bb2e3ee04eeeeab$export$72f59a26cdbd80f7 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueTransitions;
const $3bb2e3ee04eeeeab$export$be5248c466188e1e = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).issueProjects;
const $3bb2e3ee04eeeeab$export$5a622455e94bac3 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).teams;
const $3bb2e3ee04eeeeab$export$56d545f19dc75191 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (issues)=>Object.keys(issues).length);
const $3bb2e3ee04eeeeab$export$ec1c8958fe62c3e0 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$be5248c466188e1e
], (projects)=>{
    const projectsWithCreatePermission = [];
    const projectsWithDeletePermission = [];
    Object.values(projects).forEach((project)=>{
        const { id: id, permissions: permissions } = project;
        permissions?.CREATE_ISSUES && projectsWithCreatePermission.push(id);
        permissions?.DELETE_ISSUES && projectsWithDeletePermission.push(id);
    });
    return {
        projectsWithCreatePermission: projectsWithCreatePermission,
        projectsWithDeletePermission: projectsWithDeletePermission
    };
});
const $3bb2e3ee04eeeeab$export$5df97f05806d557e = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$be5248c466188e1e
], (projects)=>Object.keys(projects).map(Number));
const $3bb2e3ee04eeeeab$export$fe12e63e07cfc7f1 = (state)=>Object.keys($3bb2e3ee04eeeeab$export$be5248c466188e1e(state)).length > 1;
const $3bb2e3ee04eeeeab$export$6de24118cf63db1d = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).versionData;
const $3bb2e3ee04eeeeab$export$8933098120edcb76 = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).board;
const $3bb2e3ee04eeeeab$export$4adb8ed7b7e8020b = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).oldDoneIssuesCutOffConfig;
const $3bb2e3ee04eeeeab$export$f83f9f72ba8c4f46 = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).columns;
const $3bb2e3ee04eeeeab$export$6238ec962277eeda = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).issues;
const $3bb2e3ee04eeeeab$export$5cec7656a4a996e6 = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).issueChildren;
const $3bb2e3ee04eeeeab$export$8383695e8cf09c1b = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).issueParentOrder;
const $3bb2e3ee04eeeeab$export$dce2562af6cbec6e = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).config.name;
const $3bb2e3ee04eeeeab$export$cf1bba1f87489c02 = (state)=>state.configuration;
const $3bb2e3ee04eeeeab$export$180605366c04f0cd = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).locale;
const $3bb2e3ee04eeeeab$export$5f9288f90460d6e = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).config;
const $3bb2e3ee04eeeeab$export$a510d45029fb94ae = (state)=>$3bb2e3ee04eeeeab$export$5f9288f90460d6e(state).rankConfig.boardIsRankable;
const $3bb2e3ee04eeeeab$export$58598521cc17408 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).isIncrementPlanningBoard;
const $3bb2e3ee04eeeeab$export$4f81bf0056c92691 = ()=>{
    (0, $gKZoD.di)(window);
    return globalThis.window && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.includes('plans') && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.includes('scenarios') && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.includes('/embed');
};
const $3bb2e3ee04eeeeab$export$5124aa00ca92f2c0 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).canInviteOthersToProject;
const $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df = (state)=>$3bb2e3ee04eeeeab$export$e2e3f9f64b249105(state).incrementConfig;
const $3bb2e3ee04eeeeab$export$7bd856f542fb6dc5 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df
], (incrementConfig)=>incrementConfig?.planningUnit);
const $3bb2e3ee04eeeeab$export$57d806afd0066281 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$7bd856f542fb6dc5
], (planningUnit)=>planningUnit === (0, $4jAPy.IP_BOARD_STORY_POINTS_PLANNING_UNIT) ? (0, $7e733a5d4e4331fc$export$10056d7262ed95fe) : (0, $7e733a5d4e4331fc$export$b9e5c87716334747));
const $3bb2e3ee04eeeeab$export$e3ba46cc07a8e3c4 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df
], (incrementConfig)=>incrementConfig?.scenarioColor);
const $3bb2e3ee04eeeeab$export$794ec6fabc63d98b = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df
], (incrementConfig)=>incrementConfig?.boardScopeFilter);
const $3bb2e3ee04eeeeab$export$27ef735461d030e = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2cfcd96e42bc72df
], (incrementConfig)=>{
    const boardScopeFilter = incrementConfig?.boardScopeFilter;
    if (boardScopeFilter === undefined) return 0, $4jAPy.BOARD_SCOPE_FILTER_NONE;
    if (boardScopeFilter.filterFieldId === (0, $4jAPy.SYSTEM_LABEL_FIELD_ID)) return 0, $4jAPy.BOARD_SCOPE_FILTER_LABEL;
    if (boardScopeFilter.filterFieldTypeKey === (0, $4jAPy.SINGLE_CUSTOM_FIELD_TYPE_KEY)) return 0, $4jAPy.BOARD_SCOPE_FILTER_SINGLE_SELECT;
    if (boardScopeFilter.filterFieldTypeKey === (0, $4jAPy.MULTI_CUSTOM_FIELD_TYPE_KEY)) return 0, $4jAPy.BOARD_SCOPE_FILTER_MULTI_SELECT;
    return 0, $4jAPy.BOARD_SCOPE_FILTER_NONE;
});
const $3bb2e3ee04eeeeab$export$203ed8b65c3b2a28 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).planId;
const $3bb2e3ee04eeeeab$export$8572797243a693b9 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state).scenarioId;
const $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state)?.isCMPBoard === true;
const $3bb2e3ee04eeeeab$export$7f8f378c3fc0f2e8 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state)?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
const $3bb2e3ee04eeeeab$export$d8711f4b7ebb0235 = (state)=>$3bb2e3ee04eeeeab$export$5f9288f90460d6e(state).isSprintsEnabled;
const $3bb2e3ee04eeeeab$export$7d22dbc6792926ca = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$4adb8ed7b7e8020b,
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9,
    $3bb2e3ee04eeeeab$export$d8711f4b7ebb0235
], (oldDoneIssuesCutoffConfig, isCMP, isSprintsEnabled)=>{
    if (!oldDoneIssuesCutoffConfig || isCMP || isSprintsEnabled) return null;
    return {
        ...oldDoneIssuesCutoffConfig,
        oldDoneIssuesCutoff: oldDoneIssuesCutoffConfig.oldDoneIssuesCutoff === '-2w' ? '-14d' : oldDoneIssuesCutoffConfig.oldDoneIssuesCutoff
    };
});
const $3bb2e3ee04eeeeab$export$7af50752d48bdabc = (state)=>$3bb2e3ee04eeeeab$export$8933098120edcb76(state).permissions.editBoardConfig;
const $3bb2e3ee04eeeeab$export$985c8cf86abe2d42 = (state)=>$3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state)?.boardType;
const $3bb2e3ee04eeeeab$export$3997d54b0837aa80 = (state)=>{
    if ($3bb2e3ee04eeeeab$export$2d6b2800d72a04f9(state)) {
        const cmpBoardType = $3bb2e3ee04eeeeab$export$cf1bba1f87489c02(state)?.boardType?.toLowerCase();
        if (cmpBoardType === 'scrum') return 0, $7e733a5d4e4331fc$export$8ee1fad10cc70eb5;
        if (cmpBoardType === 'kanban') return 0, $7e733a5d4e4331fc$export$9f54a1518145e351;
    }
    return 0, $7e733a5d4e4331fc$export$9a2b21d55c0f061c;
};
const $3bb2e3ee04eeeeab$export$e755a2f4c5e8ae37 = (state)=>state.configuration.hierarchyNomenclature;
const $3bb2e3ee04eeeeab$export$84437322c8301f05 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.contextPath);
const $3bb2e3ee04eeeeab$export$718e830000b27a0e = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.rapidViewId);
const $3bb2e3ee04eeeeab$export$3b6693bb0269a108 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.userAccountId);
const $3bb2e3ee04eeeeab$export$404de5ac601b84bc = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.projectKey);
const $3bb2e3ee04eeeeab$export$4c9d6034f65d22f4 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.projectId);
const $3bb2e3ee04eeeeab$export$aa9f20f9c212aac2 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.projectName);
const $3bb2e3ee04eeeeab$export$b5a643cfff945455 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.cloudId);
const $3bb2e3ee04eeeeab$export$2335b963a9875096 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.activationId);
const $3bb2e3ee04eeeeab$export$e4acd42e3f15be28 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.sessionId);
const $3bb2e3ee04eeeeab$export$69316f88206ca90b = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.projectType);
const $3bb2e3ee04eeeeab$export$df55630d3e8d5b50 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9,
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (isCMPBoard, configuration)=>isCMPBoard && Boolean(configuration.issueLimitExceeded));
const $3bb2e3ee04eeeeab$export$61c8853134cd8886 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$cf1bba1f87489c02
], (configuration)=>configuration.savedFilterId);
const $3bb2e3ee04eeeeab$export$7ee12a197503edb8 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$a510d45029fb94ae,
    $3bb2e3ee04eeeeab$export$be5248c466188e1e,
    $3bb2e3ee04eeeeab$export$73a53226406d7fe,
    $3bb2e3ee04eeeeab$var$getIssueChildren,
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9
], (isRankable, issueProjects, allIssues, issueChildren, isCMPBoard)=>(issueId)=>{
        // TMP is always rankable
        if (!isCMPBoard) return true;
        if (!isRankable) return false;
        // find the issue from all issues and issue children
        const issue = allIssues[issueId] || issueChildren[issueId];
        if (!issue) return false;
        const project = issueProjects[issue.projectId];
        return Boolean(project?.canRank);
    });
const $3bb2e3ee04eeeeab$export$5e459bc04e88e2ec = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue.daysInColumn)));
const $3bb2e3ee04eeeeab$export$6839f41197f5a977 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue?.estimate?.value)));
const $3bb2e3ee04eeeeab$export$538dfd7d997a5ce3 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue?.priority)));
const $3bb2e3ee04eeeeab$export$50491a160efc0813 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue?.devStatus)));
const $3bb2e3ee04eeeeab$var$hasDueDateSet = (allIssues)=>Object.values(allIssues).some((issue)=>Boolean(issue.dueDate));
const $3bb2e3ee04eeeeab$export$563e039f46413317 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe,
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9,
    $3bb2e3ee04eeeeab$export$7f8f378c3fc0f2e8,
    $3bb2e3ee04eeeeab$export$58598521cc17408
], (allIssues, isCMPBoard, isJSWBoard, isIncrementPlanningBoard)=>{
    return !isCMPBoard && $3bb2e3ee04eeeeab$var$hasDueDateSet(allIssues) || isCMPBoard && isJSWBoard && !isIncrementPlanningBoard && $3bb2e3ee04eeeeab$var$hasDueDateSet(allIssues);
});
const $3bb2e3ee04eeeeab$export$5f0d2767bd7b902c = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe,
    $3bb2e3ee04eeeeab$export$2d6b2800d72a04f9
], (allIssues, isCMPBoard)=>!isCMPBoard && Object.values(allIssues).some((issue)=>Boolean(issue.labels?.length > 0)));
const $3bb2e3ee04eeeeab$export$f338837bff9d7477 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe
], (allIssues)=>{
    const extraFieldsMap = new Map();
    Object.values(allIssues).forEach((issue)=>{
        issue.extraFields?.forEach((field)=>extraFieldsMap.set(field.id, field));
    });
    return Array.from(extraFieldsMap.values());
});
const $3bb2e3ee04eeeeab$export$c8b787a7644fe978 = (0, $dGvGJ.createSelector)([
    $3bb2e3ee04eeeeab$export$73a53226406d7fe,
    $3bb2e3ee04eeeeab$export$f83f9f72ba8c4f46,
    $3bb2e3ee04eeeeab$export$6238ec962277eeda
], (allIssues, orderedColumnIds, orderedIssueIds)=>{
    const issueVals = Object.keys(allIssues);
    if (!orderedColumnIds || orderedColumnIds.length === 0 || !allIssues || issueVals.length === 0) return undefined;
    const firstColumnId = orderedColumnIds[0];
    const firstIssueId = orderedIssueIds.find((issueId)=>allIssues[issueId].columnId === firstColumnId);
    if (firstIssueId) return allIssues[firstIssueId].key;
    return undefined;
});

});
parcelRegister("alNv9", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.optimistic = module.exports.ensureState = module.exports.REVERT = module.exports.COMMIT = module.exports.BEGIN = undefined;
var $78924382a593567a$var$_extends = Object.assign || function(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i];
        for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
    }
    return target;
};

var $bXQuv = parcelRequire("bXQuv");
var $78924382a593567a$var$BEGIN = module.exports.BEGIN = '@@optimist/BEGIN';
var $78924382a593567a$var$COMMIT = module.exports.COMMIT = '@@optimist/COMMIT';
var $78924382a593567a$var$REVERT = module.exports.REVERT = '@@optimist/REVERT';
var $78924382a593567a$var$isOptimistState = function isOptimistState(state) {
    return state && Object.keys(state).length === 3 && state.hasOwnProperty('beforeState') && state.hasOwnProperty('history') && state.hasOwnProperty('current');
};
var $78924382a593567a$var$ensureState = module.exports.ensureState = function ensureState(state) {
    return $78924382a593567a$var$isOptimistState(state) ? state.current : state;
};
var $78924382a593567a$var$createState = function createState(state) {
    return {
        beforeState: undefined,
        history: [],
        current: state
    };
};
var $78924382a593567a$var$applyCommit = function applyCommit(state, targetActionIndex, reducer) {
    var history = state.history;
    // If the action to commit is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutCommit = history.slice(1);
        var nextOptimisticIndex = (0, $bXQuv.findIndex)(historyWithoutCommit, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic item in the queue, we're done!
        if (nextOptimisticIndex === -1) return $78924382a593567a$var$_extends({}, state, {
            history: [],
            beforeState: undefined
        });
        // Create a new history starting with the next one
        var newHistory = historyWithoutCommit.slice(nextOptimisticIndex);
        // And run every action up until that next one to get the new beforeState
        var newBeforeState = history.reduce(function(mutState, action, index) {
            return index <= nextOptimisticIndex ? reducer(mutState, action) : mutState;
        }, state.beforeState);
        return $78924382a593567a$var$_extends({}, state, {
            history: newHistory,
            beforeState: newBeforeState
        });
    } else {
        // If the committed action isn't the first in the queue, find out where it is
        var actionToCommit = history[targetActionIndex];
        // Make it a regular non-optimistic action
        var newAction = Object.assign({}, actionToCommit, {
            meta: Object.assign({}, actionToCommit.meta, {
                optimistic: null
            })
        });
        var _newHistory = state.history.slice();
        _newHistory.splice(targetActionIndex, 1, newAction);
        return $78924382a593567a$var$_extends({}, state, {
            history: _newHistory
        });
    }
};
var $78924382a593567a$var$applyRevert = function applyRevert(state, targetActionIndex, reducer) {
    var beforeState = state.beforeState, history = state.history;
    var newHistory = void 0;
    // If the action to revert is the first in the queue (most common scenario)
    if (targetActionIndex === 0) {
        var historyWithoutRevert = history.slice(1);
        var nextOptimisticIndex = (0, $bXQuv.findIndex)(historyWithoutRevert, function(action) {
            return action.meta && action.meta.optimistic && !action.meta.optimistic.isNotOptimistic && action.meta.optimistic.id;
        });
        // If this is the only optimistic action in the queue, we're done!
        if (nextOptimisticIndex === -1) return $78924382a593567a$var$_extends({}, state, {
            history: [],
            current: historyWithoutRevert.reduce(function(s, action) {
                return reducer(s, action);
            }, beforeState),
            beforeState: undefined
        });
        newHistory = historyWithoutRevert.slice(nextOptimisticIndex);
    } else {
        newHistory = history.slice();
        newHistory.splice(targetActionIndex, 1);
    }
    var newCurrent = newHistory.reduce(function(s, action) {
        return reducer(s, action);
    }, beforeState);
    return $78924382a593567a$var$_extends({}, state, {
        history: newHistory,
        current: newCurrent,
        beforeState: beforeState
    });
};
var $78924382a593567a$var$optimistic = module.exports.optimistic = function optimistic(reducer) {
    var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var config = Object.assign({
        maxHistory: 100
    }, rawConfig);
    return function(state, action) {
        if (state === undefined || !$78924382a593567a$var$isOptimistState(state)) state = $78924382a593567a$var$createState(reducer($78924382a593567a$var$ensureState(state), {}));
        var historySize = state.history.length;
        var _ref = action.meta && action.meta.optimistic || {}, type = _ref.type, id = _ref.id;
        // a historySize means there is at least 1 outstanding fetch
        if (historySize) {
            if (type !== $78924382a593567a$var$COMMIT && type !== $78924382a593567a$var$REVERT) {
                if (historySize > config.maxHistory) console.error('@@optimist: Possible memory leak detected.\n                  Verify all actions result in a commit or revert and\n                  don\'t use optimistic-UI for long-running server fetches');
                // if it's a BEGIN but we already have a historySize, treat it like a non-opt
                return $78924382a593567a$var$_extends({}, state, {
                    history: state.history.concat([
                        action
                    ]),
                    current: reducer(state.current, action)
                });
            }
            var targetActionIndex = (0, $bXQuv.findIndex)(state.history, function(action) {
                return action.meta && action.meta.optimistic && action.meta.optimistic.id === id;
            });
            if (targetActionIndex === -1) throw new Error('@@optimist: Failed to ' + (type === $78924382a593567a$var$COMMIT ? 'commit' : 'revert') + '. Transaction #' + id + ' does not exist!');
            // for resolutions, add a flag so that we know it is not an optimistic action
            action.meta.optimistic.isNotOptimistic = true;
            // include the resolution in the history & current state
            var nextState = $78924382a593567a$var$_extends({}, state, {
                history: state.history.concat([
                    action
                ]),
                current: reducer(state.current, action)
            });
            var applyFunc = type === $78924382a593567a$var$COMMIT ? $78924382a593567a$var$applyCommit : $78924382a593567a$var$applyRevert;
            return applyFunc(nextState, targetActionIndex, reducer);
        }
        // create a beforeState since one doesn't already exist
        if (type === $78924382a593567a$var$BEGIN) return $78924382a593567a$var$_extends({}, state, {
            history: state.history.concat([
                action
            ]),
            current: reducer(state.current, action),
            beforeState: state.current
        });
        // standard action escape
        return $78924382a593567a$var$_extends({}, state, {
            current: reducer(state.current, action)
        });
    };
};

});
parcelRegister("bXQuv", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.findIndex = $8b5dec00f6be39ba$var$findIndex;
function $8b5dec00f6be39ba$var$findIndex(arr, predicate) {
    var l = arr.length;
    for(var i = 0; i < l; i++){
        if (predicate(arr[i])) return i;
    }
    return -1;
}

});


parcelRegister("4jAPy", function(module, exports) {

$parcel$export(module.exports, "SCRUM_TEAM", () => $acaa4e836b6925cd$export$103a728db4a941f8);
$parcel$export(module.exports, "KANBAN_TEAM", () => $acaa4e836b6925cd$export$f43662b315e78f32);
$parcel$export(module.exports, "BOARD_ISSUE_SOURCE", () => $acaa4e836b6925cd$export$4c4602fa98384024);
$parcel$export(module.exports, "SINGLE_CUSTOM_FIELD_TYPE_KEY", () => $acaa4e836b6925cd$export$7a7b05cceb7cc8a9);
$parcel$export(module.exports, "MULTI_CUSTOM_FIELD_TYPE_KEY", () => $acaa4e836b6925cd$export$2afd90c3608e7105);
$parcel$export(module.exports, "SYSTEM_LABEL_FIELD_ID", () => $acaa4e836b6925cd$export$84bf4e4e31fe4475);
$parcel$export(module.exports, "CUSTOM_FIELD_OPTION_MISSED_ERROR", () => $acaa4e836b6925cd$export$aa4bdec93afa2924);
$parcel$export(module.exports, "FILTER_FIELD_ERROR", () => $acaa4e836b6925cd$export$a497a01fd14a64af);
$parcel$export(module.exports, "MAX_ACTIVE_BOARDS_OLD", () => $acaa4e836b6925cd$export$d9f307ebf9c533d2);
$parcel$export(module.exports, "MAX_ACTIVE_BOARDS", () => $acaa4e836b6925cd$export$70493a18b15fa2cc);
$parcel$export(module.exports, "IP_BOARD_STORY_POINTS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$e2ffaae341a16c5e);
$parcel$export(module.exports, "IP_BOARD_HOURS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$9a6e823d5b9e62be);
$parcel$export(module.exports, "IP_BOARD_DAYS_PLANNING_UNIT", () => $acaa4e836b6925cd$export$ad92792f1d38ffba);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $acaa4e836b6925cd$export$cfeee2ee86ead336);
$parcel$export(module.exports, "PACKAGE_NAME", () => $acaa4e836b6925cd$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "SERVICES_ERROR_ID", () => $acaa4e836b6925cd$export$7930b6315c134d49);
$parcel$export(module.exports, "DOC_LINKS", () => $acaa4e836b6925cd$export$f8975d2c25cd8c82);
$parcel$export(module.exports, "IPH_IDS", () => $acaa4e836b6925cd$export$253194752488840a);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_PREFIX", () => $acaa4e836b6925cd$export$c78721cd39b97424);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_START", () => $acaa4e836b6925cd$export$1bb2633f6c6f66d1);
$parcel$export(module.exports, "MARK_SYNC_SPRINTS_END", () => $acaa4e836b6925cd$export$9583c6ba8c6caee3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_NONE", () => $acaa4e836b6925cd$export$f2ee1113933b4540);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_LABEL", () => $acaa4e836b6925cd$export$3212503575d06ffd);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_SINGLE_SELECT", () => $acaa4e836b6925cd$export$ba991b7dc2732ca3);
$parcel$export(module.exports, "BOARD_SCOPE_FILTER_MULTI_SELECT", () => $acaa4e836b6925cd$export$df2129225b939441);
$parcel$export(module.exports, "DEFAULT_ITERATION_LENGTH", () => $acaa4e836b6925cd$export$8400d4ac050fc755);
$parcel$export(module.exports, "DEFAULT_ITERATIONS_COUNT", () => $acaa4e836b6925cd$export$b83f977709573647);
$parcel$export(module.exports, "ITERATIONS_COUNT_OPTIONS", () => $acaa4e836b6925cd$export$f16a2b8db5d397c);
$parcel$export(module.exports, "TEAM", () => $acaa4e836b6925cd$export$bc8b984358922f81);
$parcel$export(module.exports, "SWIMLANE_TEAMLESS", () => $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c);
$parcel$export(module.exports, "MAX_SELECTED_ISSUES_FOR_DEPENDENCY_LINES", () => $acaa4e836b6925cd$export$ca464ff38a49aee8);
$parcel$export(module.exports, "UNSCHEDULED_WORK_COLUMN_SWIMLANE_ID_SUFFIX", () => $acaa4e836b6925cd$export$184668482d48a5f3);
$parcel$export(module.exports, "SCENARIO_ISSUE_ID_PREFIX", () => $acaa4e836b6925cd$export$c8c7cce628cf5c4e);
$parcel$export(module.exports, "PLANS_USER_AUTOCOMPLETE_URL", () => $acaa4e836b6925cd$export$95c182fe3d93ab19);
const $acaa4e836b6925cd$export$103a728db4a941f8 = 'Scrum';
const $acaa4e836b6925cd$export$f43662b315e78f32 = 'Kanban';
const $acaa4e836b6925cd$export$4c4602fa98384024 = 'Board';
const $acaa4e836b6925cd$export$ab08f53e1080ee4f = 'Project';
const $acaa4e836b6925cd$export$e5b9ed989e245a1a = 'Filter';
const $acaa4e836b6925cd$export$7a7b05cceb7cc8a9 = 'com.atlassian.jira.plugin.system.customfieldtypes:select';
const $acaa4e836b6925cd$export$2afd90c3608e7105 = 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect';
const $acaa4e836b6925cd$export$84bf4e4e31fe4475 = 'labels';
const $acaa4e836b6925cd$export$aa4bdec93afa2924 = 'CUSTOM_FIELD_OPTION_MISSED';
const $acaa4e836b6925cd$export$a497a01fd14a64af = {
    NOT_FOUND: 'CUSTOM_FIELD_NOT_FOUND',
    TRASHED: 'CUSTOM_FIELD_TRASHED',
    NOT_IN_PLAN: 'CUSTOM_FIELD_NOT_IN_PLAN',
    OPTION_NOT_FOUND: 'CUSTOM_FIELD_OPTION_NOT_FOUND'
};
const $acaa4e836b6925cd$export$d9f307ebf9c533d2 = 2; // remove when jpo_adjust_program_board_active_limit is cleaned up
const $acaa4e836b6925cd$export$70493a18b15fa2cc = 10;
const $acaa4e836b6925cd$export$e2ffaae341a16c5e = 'StoryPoints';
const $acaa4e836b6925cd$export$9a6e823d5b9e62be = 'Hours';
const $acaa4e836b6925cd$export$ad92792f1d38ffba = 'Days';
const $acaa4e836b6925cd$export$cfeee2ee86ead336 = 'axolotl';
const $acaa4e836b6925cd$export$b8b9d90f9e5bd72b = 'jiraPortfolio3PlanIncrementCommon';
const $acaa4e836b6925cd$export$7930b6315c134d49 = 'services';
const $acaa4e836b6925cd$export$f8975d2c25cd8c82 = {
    PROGRAM_BOARD: 'https://support.atlassian.com/jira-software-cloud/docs/what-is-the-program-board-in-my-plan/',
    LINK_SPRINTS: 'https://support.atlassian.com/jira-software-cloud/docs/add-and-change-sprints-on-the-program-board-in-your-plan/',
    CREATION: 'https://support.atlassian.com/jira-software-cloud/docs/what-does-the-program-board-show/',
    CAPACITY_PLANNING: 'https://support.atlassian.com/jira-software-cloud/docs/enable-capacity-planning-in-advanced-roadmaps/',
    OFFTRACK_DEPENDENCIES: 'https://support.atlassian.com/jira-software-cloud/docs/what-are-dependencies-in-advanced-roadmaps/',
    PROGRAM_BOARD_RECOMMENDATIONS: 'https://support.atlassian.com/jira-software-cloud/docs/recommended-preparations-before-using-the-program-board/'
};
const $acaa4e836b6925cd$export$253194752488840a = {
    PROGRAM_BOARDS_CREATE: '6gJCMknYvLjnUgKrm4BKIj',
    PROGRAM_BOARDS_SETTINGS: '1pdnvDJUBHtLdAcH6F03rm',
    CAPACITY_PLANNING: '4kDm3TUQ7LwIEubH72m3Gk',
    OFFTRACK_DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF',
    PROGRAM_BOARD_RECOMMENDATIONS: '7CJiNQmImx2kqJa9MhpEwt'
};
const $acaa4e836b6925cd$export$c78721cd39b97424 = 'plan-increment.sync-sprints:';
const $acaa4e836b6925cd$export$1bb2633f6c6f66d1 = `${$acaa4e836b6925cd$export$c78721cd39b97424}start`;
const $acaa4e836b6925cd$export$9583c6ba8c6caee3 = `${$acaa4e836b6925cd$export$c78721cd39b97424}end`;
const $acaa4e836b6925cd$export$f2ee1113933b4540 = 'none';
const $acaa4e836b6925cd$export$3212503575d06ffd = 'label';
const $acaa4e836b6925cd$export$ba991b7dc2732ca3 = 'select';
const $acaa4e836b6925cd$export$df2129225b939441 = 'multiselect';
const $acaa4e836b6925cd$export$8400d4ac050fc755 = 2;
const $acaa4e836b6925cd$export$b83f977709573647 = 6;
const $acaa4e836b6925cd$export$f16a2b8db5d397c = [
    {
        label: '3',
        value: 3
    },
    {
        label: '4',
        value: 4
    },
    {
        label: '5',
        value: 5
    },
    {
        label: '6',
        value: 6
    },
    {
        label: '7',
        value: 7
    },
    {
        label: '8',
        value: 8
    },
    {
        label: '9',
        value: 9
    },
    {
        label: '10',
        value: 10
    },
    {
        label: '11',
        value: 11
    },
    {
        label: '12',
        value: 12
    },
    {
        label: '13',
        value: 13
    }
];
const $acaa4e836b6925cd$export$bc8b984358922f81 = 'TEAM';
const $acaa4e836b6925cd$export$b5d1b5cc4a0cc53c = '$teamless$';
const $acaa4e836b6925cd$export$ca464ff38a49aee8 = 10;
const $acaa4e836b6925cd$export$184668482d48a5f3 = '-unscheduled';
const $acaa4e836b6925cd$export$c8c7cce628cf5c4e = 'SCEN-';
const $acaa4e836b6925cd$export$95c182fe3d93ab19 = '/rest/teams/1.0/persons/find';

});

const $7e733a5d4e4331fc$export$24f467771705aaff = 'board';
const $7e733a5d4e4331fc$export$ccd6af533dc2d202 = 'programBoard';
const $7e733a5d4e4331fc$export$360e7ca29749d455 = 6;
const $7e733a5d4e4331fc$export$8ee1fad10cc70eb5 = 'Scrum';
const $7e733a5d4e4331fc$export$9f54a1518145e351 = 'Kanban';
const $7e733a5d4e4331fc$export$70f4a301e337eb0b = 600000;
const $7e733a5d4e4331fc$export$9a2b21d55c0f061c = 'Agility';
const $7e733a5d4e4331fc$export$8a5f5fbe7aeddf5 = 'IP';
const $7e733a5d4e4331fc$export$b1cb468c302d21f9 = 'labels';
const $7e733a5d4e4331fc$export$85243b761a28eea7 = '105px';
const $7e733a5d4e4331fc$export$b9e5c87716334747 = 'timeEstimate';
const $7e733a5d4e4331fc$export$10056d7262ed95fe = 'storyPoints';
const $7e733a5d4e4331fc$export$7445eb3755623031 = 'status';
const $7e733a5d4e4331fc$export$3ebc9911a79d714f = 'active';



parcelRegister("9NiTW", function(module, exports) {

$parcel$export(module.exports, "checkAuthentication", () => $ad297a7f2ce81084$export$b8dbb7d6029c5413);
$parcel$export(module.exports, "AuthenticationCheck", () => $ad297a7f2ce81084$export$e9b9096e887386fe);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $38Y30 = parcelRequire("38Y30");
const $ad297a7f2ce81084$export$b8dbb7d6029c5413 = (tenantContext)=>Boolean(tenantContext.atlassianAccountId);
const $ad297a7f2ce81084$export$e9b9096e887386fe = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        if ($ad297a7f2ce81084$export$b8dbb7d6029c5413(tenantContext)) return children;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38Y30.RedirectToLoginPage), null);
    });

});
parcelRegister("38Y30", function(module, exports) {

$parcel$export(module.exports, "RedirectToLoginPage", () => $08f8c3f776d557a9$export$938182bd3fddc3a8);

var $5uXOq = parcelRequire("5uXOq");

var $7tQej = parcelRequire("7tQej");
var $ieDtd = parcelRequire("ieDtd");
var $doZTA = parcelRequire("doZTA");
const $08f8c3f776d557a9$export$3da29de62ed7a388 = ({ to: to })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("script", {
        // eslint-disable-next-line react/no-danger
        dangerouslySetInnerHTML: {
            __html: `window.location.assign("${to}")`
        }
    });
$08f8c3f776d557a9$export$3da29de62ed7a388.displayName = 'InlineRedirect';
const $08f8c3f776d557a9$export$938182bd3fddc3a8 = ()=>{
    const [{ location: { pathname: pathname, search: search } }] = (0, $doZTA.useRouter)();
    const redirectUrl = pathname + search;
    const encodedRedirectUrl = encodeURIComponent(redirectUrl);
    let path = `/login.jsp?os_destination=${encodedRedirectUrl}`;
    const parentProductQueryName = 'parentProduct';
    const [parentProduct] = (0, $ieDtd.useQueryParam)(parentProductQueryName);
    if (pathname.endsWith('/embed')) {
        const searchParams = new URLSearchParams(search);
        // We need to remove parentProduct param as it is only used in embed urls
        searchParams.delete(parentProductQueryName);
        /**
		 * encodedLink is the link to the non embedded version of the embed url.
		 * So, we strip out the /embed suffix from path
		 */ let encodedLink = encodeURIComponent(`${pathname.slice(0, -6)}?${searchParams}`);
        /**
		 * this is the specific case for create issue embed, where we need to redirect
		 * user to your-work page with create issue as true to open GIC by default.
		 * We will remove this when we FPIC exp implemented for GIC
		 */ if (pathname.includes('/issues/create')) encodedLink = encodeURIComponent('/jira/your-work?createissue=true');
        const encodedParentProduct = encodeURIComponent(parentProduct || '');
        path = `/jira-login/embed?destination=${encodedRedirectUrl}&link=${encodedLink}&parentProduct=${encodedParentProduct}`;
    }
    return false ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08f8c3f776d557a9$export$3da29de62ed7a388, {
        to: path
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: path
    });
};

});


parcelRegister("3RV1W", function(module, exports) {

$parcel$export(module.exports, "checkLicense", () => $6334356fa938c5d8$export$fe2591be8b7e59ce);
$parcel$export(module.exports, "LicenseCheck", () => $6334356fa938c5d8$export$944be0b3bf2a6feb);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");
const $6334356fa938c5d8$var$appPermissionMapper = {
    software: 'hasSoftwareAccess',
    servicedesk: 'hasServiceDeskAccess',
    customerservice: 'hasCustomerServiceAccess'
};
const $6334356fa938c5d8$export$fe2591be8b7e59ce = (tenantContext, type)=>Boolean(tenantContext.appPermissions && tenantContext.appPermissions[$6334356fa938c5d8$var$appPermissionMapper[type]]);
const $6334356fa938c5d8$export$944be0b3bf2a6feb = ({ children: children, type: type })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const result = $6334356fa938c5d8$export$fe2591be8b7e59ce(tenantContext, type);
        return children({
            result: result
        });
    });

});

parcelRegister("12Sv5", function(module, exports) {

$parcel$export(module.exports, "useIsCMPBoardRoute", () => $ea8f3f30149f8216$export$ab192852bd2b5277);
$parcel$export(module.exports, "useIsUserBoardRoute", () => $ea8f3f30149f8216$export$8a3a1612720bac9);

var $6jY6G = parcelRequire("6jY6G");
const $ea8f3f30149f8216$export$ab192852bd2b5277 = ()=>{
    const { name: routeName } = (0, $6jY6G.useCurrentRoute)();
    return [
        'rapidboard-board',
        'rapidboard-board-embed',
        'rapidboard-user-board'
    ].includes(routeName);
};
const $ea8f3f30149f8216$export$8a3a1612720bac9 = ()=>{
    const { name: routeName } = (0, $6jY6G.useCurrentRoute)();
    return routeName === 'rapidboard-user-board';
};

});

parcelRegister("54XqP", function(module, exports) {

$parcel$export(module.exports, "BoardWithRouterCMP", () => $67067dc5743ca4c0$export$1966567fd19f5c06);

var $5uXOq = parcelRequire("5uXOq");

var $aaV7S = parcelRequire("aaV7S");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");
var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $3mYHL = parcelRequire("3mYHL");

var $f7Y15 = parcelRequire("f7Y15");

var $9dbF6 = parcelRequire("9dbF6");

var $gqLmL = parcelRequire("gqLmL");

var $9OXo1 = parcelRequire("9OXo1");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");
var $lVJAU = parcelRequire("lVJAU");

var $0z6W8 = parcelRequire("0z6W8");

var $12Sv5 = parcelRequire("12Sv5");


var $k6PKo = parcelRequire("k6PKo");

var $8XaG5 = parcelRequire("8XaG5");

var $eantU = parcelRequire("eantU");
const $67067dc5743ca4c0$export$1966567fd19f5c06 = ({ hasSoftwareLicense: hasSoftwareLicense })=>{
    const isUserBoard = (0, $12Sv5.useIsUserBoardRoute)();
    const [paramBoardId] = (0, $bmKPg.usePathParam)('boardId');
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const cmpBoardData = (0, $2YP9W.useResource)((0, $f7Y15.uifBoardResource));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const boardId = Number(paramBoardId);
    const { loading: loading, data: data, error: error } = cmpBoardData;
    const boardLocation = data?.result?.boardLocation;
    const { key: key, id: id, name: name } = boardLocation ?? {};
    const projectDetails = {
        key: key,
        id: id,
        name: name
    };
    const projectKeyFromContext = projectDetails.key || projectKey || '';
    const history = (0, $lVJAU.useRouterActions)();
    // for locationless boards with old style links like: https://domain.com/secure/RapidBoard.jspa?rapidView=10&useStoredSettings=true&locationless=true
    const [rapidViewBoardIdString] = (0, $ieDtd.useQueryParam)('rapidView');
    const rapidViewBoardId = Number(rapidViewBoardIdString);
    const [locationlessFromRapidBoardLink] = (0, $ieDtd.useQueryParam)('locationless');
    const isLocationlessRapidBoardLink = rapidViewBoardId && locationlessFromRapidBoardLink === 'true';
    const isCacheHit = Boolean(data?.isCacheHit);
    const hasShownBoardWithUnmappedErrorFlag = (0, $5uXOq.useRef)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [selectedIssue] = (0, $ieDtd.useQueryParam)('selectedIssue');
    (0, $5uXOq.useEffect)(()=>{
        if (selectedIssue) (0, $0z6W8.updatePageloadName)('classic-board-with-issue-view');
    }, [
        selectedIssue
    ]);
    const showBoardWithUnmappedColumnWarningFlag = ()=>{
        showFlag({
            messageId: 'spa-apps-next-gen-board.board.board-with-router-cmp.show-flag.warning.board-with-unmapped-column',
            messageType: 'transactional',
            id: (0, $7HGHK.toFlagId)('board_with_unmapped_column_flag'),
            type: 'warning',
            title: formatMessage((0, $eantU.default).boardWithUnmappedColumnFlagTitle),
            isAutoDismiss: false,
            description: tenantContext.isAdmin ? formatMessage((0, $eantU.default).boardWithUnmappedColumnFlagDescriptionForAdmin) : formatMessage((0, $eantU.default).boardWithUnmappedColumnFlagDescriptionForUser),
            actions: tenantContext.isAdmin ? [
                {
                    content: formatMessage((0, $eantU.default).navigateToBoardSettingsCta),
                    href: '?config=columns',
                    target: '_self'
                }
            ] : []
        });
        hasShownBoardWithUnmappedErrorFlag.current = true;
    };
    if (!hasSoftwareLicense) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XaG5.NoSoftwareLicense), null);
    if (!loading && error && error.message === (0, $d7cba9080a5695ea$export$912d9029af46d426)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aaV7S.AsyncLocationlessDialog), {
        rapidViewId: boardId
    });
    if (!loading && error && error.message === (0, $d7cba9080a5695ea$export$759edcab449d5404) && !hasShownBoardWithUnmappedErrorFlag.current) showBoardWithUnmappedColumnWarningFlag();
    if (isLocationlessRapidBoardLink) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aaV7S.AsyncLocationlessDialog), {
        rapidViewId: rapidViewBoardId,
        classicLocationless: isLocationlessRapidBoardLink
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gqLmL.Breadcrumbs), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
        subProduct: "software"
    }), (0, $4R6GH.fg)('jfp-magma-taskfail-event-multi-firing-board-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6PKo.BoardApp), {
        rapidViewId: boardId,
        projectKey: projectKeyFromContext,
        projectType: (0, $2vSU6.SOFTWARE_PROJECT),
        context: {
            tenantContext: tenantContext
        },
        cmpBoardData: cmpBoardData,
        boardData: null,
        history: history,
        isCacheHit: isCacheHit,
        isCMPBoard: true,
        isUserBoard: isUserBoard
    }) : (0, $k6PKo.renderBoardApp)({
        rapidViewId: boardId,
        projectKey: projectKeyFromContext,
        projectType: (0, $2vSU6.SOFTWARE_PROJECT),
        context: {
            tenantContext: tenantContext
        },
        cmpBoardData: cmpBoardData,
        boardData: null,
        history: history,
        isCacheHit: isCacheHit,
        isCMPBoard: true,
        isUserBoard: isUserBoard
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
        projectKey: projectKey || projectKeyFromContext || null
    }));
};

});
parcelRegister("aaV7S", function(module, exports) {

$parcel$export(module.exports, "AsyncLocationlessDialog", () => $5875e6aa9017967d$export$15ccbdebadffcb56);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// TODO: FEBA-214 - convert to use EntryPoint (see https://hello.atlassian.net/wiki/spaces/UAF/pages/2333138307/Tutorial+How+to+create+an+EntryPoint)
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $5875e6aa9017967d$var$LazyComponent = (0, $kxZPA.lazy)(()=>(parcelRequire("1JJWn")), {
    moduleId: "./src/packages/board-location-dialogs/locationless/src/app.tsx"
});
const $5875e6aa9017967d$export$15ccbdebadffcb56 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "bundle-async-locationless-dialog",
        teamName: "a4t-pandora",
        packageName: "jiraBoardLocationDialogsLocationless"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "locationless-dialog-app",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5875e6aa9017967d$var$LazyComponent, {
        baseUrl: "",
        ...props
    })));

});
parcelRegister("1JJWn", function(module, exports) {

let $143da1428aa79e81$var$load = (parcelRequire("28QjX"))(4);
module.exports = $143da1428aa79e81$var$load("9DfZr").then(()=>parcelRequire('h6olf'));

});


parcelRegister("3mYHL", function(module, exports) {

$parcel$export(module.exports, "isProjectArchivedCondition", () => $90d8776d2c89f4bd$export$34040938aec58f90);
$parcel$export(module.exports, "RedirectToArchivedPage", () => $90d8776d2c89f4bd$export$36db2ddf32573bd8);
$parcel$export(module.exports, "default", () => $90d8776d2c89f4bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $7tQej = parcelRequire("7tQej");

const $90d8776d2c89f4bd$export$34040938aec58f90 = (projectContextData)=>projectContextData && projectContextData.isProjectArchived || false;
const $90d8776d2c89f4bd$var$RedirectIfProjectArchived = ({ projectKey: projectKey })=>{
    if (projectKey === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dAfqg.ProjectContextProvider), null, (projectContext)=>$90d8776d2c89f4bd$export$34040938aec58f90(projectContext.data) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
            to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
        }) : null);
};
const $90d8776d2c89f4bd$export$36db2ddf32573bd8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: (0, $a9bebd574fd66055$export$9a6ccb84170b615b)
    });
var $90d8776d2c89f4bd$export$2e2bcd8739ae039 = $90d8776d2c89f4bd$var$RedirectIfProjectArchived;

});
const $a9bebd574fd66055$export$9a6ccb84170b615b = '/jira/errors/project-archived';


parcelRegister("9dbF6", function(module, exports) {

$parcel$export(module.exports, "SubProductUpdater", () => $5979c081afa32bfa$export$eb40d3df56aa5c53);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $3iTiR = parcelRequire("3iTiR");

var $ero6m = parcelRequire("ero6m");

var $54I24 = parcelRequire("54I24");

var $8OHH4 = parcelRequire("8OHH4");
const $5979c081afa32bfa$export$eb40d3df56aa5c53 = ({ allowMonolithDeferral: allowMonolithDeferral = false, ...props })=>{
    const subProduct = (0, $8OHH4.isSubProductProps)(props) ? props.subProduct : (0, $ero6m.getSubProductFromProjectType)(props.projectType);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
        op: (0, $54I24.default),
        args: [
            subProduct,
            allowMonolithDeferral
        ]
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3iTiR.default), {
        subProduct: subProduct
    }));
};

});
parcelRegister("3iTiR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214b0731559b377$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $hFChZ = parcelRequire("hFChZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1214b0731559b377$export$2e2bcd8739ae039 = ({ subProduct: subProduct })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: (0, $hFChZ.default),
        args: [
            subProduct
        ]
    });

});
parcelRegister("hFChZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $0e606430ead76cd8$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0e606430ead76cd8$export$2e2bcd8739ae039 = (subProduct)=>{
    (0, $eusud.performGetRequest)(`/rest/internal/2/mauTag/${subProduct}`).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('common.tag-mau.tag-mau-event', 'Error connecting to monolith mau tag endpoint', err);
    });
};

});


parcelRegister("ero6m", function(module, exports) {

$parcel$export(module.exports, "getSubProductFromProjectType", () => $0997694844c8a9e7$export$b1fe420ed15dff7b);

var $16v4H = parcelRequire("16v4H");
const $0997694844c8a9e7$export$b1fe420ed15dff7b = (projectType)=>{
    // for Analytics only 'product_discovery' is mapped to 'polaris'. In other cases it is mapped to 'software'
    if (projectType === 'product_discovery') return 'polaris';
    return (0, $16v4H.subProductFromProjectType)(projectType);
};

});

parcelRegister("54I24", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcbbcd48ca398ed4$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");


var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");
const $bcbbcd48ca398ed4$var$maybeDelayAndRace = (// @ts-expect-error - TS2304 - Cannot find name 'Deferred'.
maybeWaitPromise, getDefaultPromise, getRacePromise)=>maybeWaitPromise ? Promise.race([
        maybeWaitPromise.then(getDefaultPromise),
        getRacePromise()
    ]) : getDefaultPromise();
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bcbbcd48ca398ed4$export$2e2bcd8739ae039 = async (subProduct, allowMonolithDeferral)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        client.setSubProduct(subProduct);
        if (subProduct === 'serviceDesk') client.setUIViewedAttributes({
            solutions: [
                (0, $86344d58e71e925a$export$c8b406ad8ee0dab9)
            ]
        });
        else client.removeUIViewedAttribute('solutions');
    });
    // IMPORTANT -
    // Until such time as all pre-TTI WRM loads are removed we find that waitForHeritage() then
    // loadBridgeStrict() is too slow, resulting in `subproduct:unknown` for analytics events.
    // In that same case however, profiling shows us that polling in loadBridgeWeak() somehow
    // resolves the same AMD code faster.
    // This is not well understood, but it does allow us to work around the issue by racing these
    // two techniques.
    // Once there is no pre-TTI WRM loads we the waitForHeritage() then loadBridgeStrict() does seem
    // to be faster such that we can remove the `Promise.race()`.
    /* eslint-disable jira/wrm/no-load-bridge */ $bcbbcd48ca398ed4$var$maybeDelayAndRace(allowMonolithDeferral ? (0, $cQZXC.waitForHeritage)() : null, ()=>(0, $7T84i.loadBridgeStrict)({
            name: 'jira/analytics/sub-product-resolver',
            wrmKeys: [
                'wrc!com.atlassian.jira.jira-client-analytics-plugin:analytics-web-client'
            ]
        }), ()=>(0, $9B86Q.loadBridgeWeak)({
            name: 'jira/analytics/sub-product-resolver'
        })).then((subProductResolver)=>{
        subProductResolver.setSubProduct(subProduct);
    }).catch((e)=>(0, $2YZCu.default).safeErrorWithoutCustomerData('common.analytics-sub-product.sub-product-updater', 'Error connecting to monolith sub product resolver', e));
/* eslint-enable jira/wrm/no-load-bridge */ };

});
const $86344d58e71e925a$export$c8b406ad8ee0dab9 = 'jiraServiceManagement';


parcelRegister("8OHH4", function(module, exports) {

$parcel$export(module.exports, "isSubProductProps", () => $701d07b56c3e3574$export$c3063d6d7a8c075f);
const $701d07b56c3e3574$export$c3063d6d7a8c075f = (props)=>'subProduct' in props && typeof props.subProduct === 'string';

});


parcelRegister("gqLmL", function(module, exports) {

$parcel$export(module.exports, "Breadcrumbs", () => $89b567f441a32e03$export$2dc68d50d56fbbd);

var $5uXOq = parcelRequire("5uXOq");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $jgyQq = parcelRequire("jgyQq");

var $7waah = parcelRequire("7waah");

var $liUyW = parcelRequire("liUyW");
const $89b567f441a32e03$export$2dc68d50d56fbbd = ()=>{
    const [{ data: data, error: error }] = (0, $4DPZY.useContainerContext)();
    const { chartView: chartView, boardId: boardId, isBoardLocationless: isBoardLocationless, isReportsView: isReportsView, accountId: accountId } = (0, $jgyQq.useUrlState)();
    if (!data || error) return null;
    const boardName = data.scope && data.scope.name || '';
    if ((0, $gSBIZ.isUserContext)(data) && accountId) {
        const { user: user } = data;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $liUyW.UserBreadcrumbs), {
            accountId: accountId,
            boardId: Number(boardId),
            boardName: boardName,
            isReportsView: isReportsView,
            profileUrl: user.profileUrl,
            userName: user.name,
            chart: chartView,
            isLocationlessBoard: isBoardLocationless
        });
    }
    if ((0, $gSBIZ.isProjectContext)(data)) {
        const { project: project } = data;
        const projectKey = project.key;
        const projectName = project.name;
        const projectId = project.id;
        const isSimplifiedProject = project.isSimplified;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7waah.ProjectBreadcrumbs), {
            baseUrl: "",
            boardId: Number(boardId),
            boardName: boardName,
            chart: chartView,
            projectKey: projectKey,
            projectName: projectName,
            projectId: projectId,
            isSimplifiedProject: isSimplifiedProject
        });
    }
    return null;
};

});
parcelRegister("gSBIZ", function(module, exports) {

$parcel$export(module.exports, "isProjectContext", () => $3bb86183071b9984$export$d46e75e464bf2407);
$parcel$export(module.exports, "isUserContext", () => $3bb86183071b9984$export$8d1083037a4a6250);
const $3bb86183071b9984$export$d46e75e464bf2407 = (containerContext)=>containerContext.project !== undefined;
const $3bb86183071b9984$export$8d1083037a4a6250 = (containerContext)=>containerContext.user !== undefined;

});

parcelRegister("jgyQq", function(module, exports) {

$parcel$export(module.exports, "useUrlState", () => $1c5a5dbec5fedd96$export$6a582373474709af);

var $doZTA = parcelRequire("doZTA");

var $eZFkq = parcelRequire("eZFkq");
const $1c5a5dbec5fedd96$export$6a582373474709af = ()=>{
    const [{ query: query, route: route, match: match }] = (0, $doZTA.useRouter)();
    const { rapidView: rapidView, chart: chart, view: view, config: config, projectKey: queryProjectKey, locationless: locationless } = query;
    const { accountId: accountId } = match.params;
    const isBoardLocationless = !!locationless;
    const shouldUsePrettyUrlState = !isBoardLocationless;
    const mode = shouldUsePrettyUrlState ? (0, $eZFkq.getModeV2)(route?.name) : (0, $eZFkq.getMode)(view);
    const boardId = shouldUsePrettyUrlState ? match.params.boardId : rapidView;
    const projectKey = shouldUsePrettyUrlState ? match.params.projectKey : queryProjectKey;
    const chartView = shouldUsePrettyUrlState ? (0, $eZFkq.toCamelCaseChartView)(match.params.chartView || '') : chart;
    const isReportsView = query && query.view === 'reporting';
    return {
        accountId: accountId,
        mode: mode,
        boardId: boardId,
        chartView: chartView,
        projectKey: projectKey,
        routeName: route.name,
        config: config,
        isBoardLocationless: isBoardLocationless,
        isReportsView: isReportsView
    };
};

});
parcelRegister("eZFkq", function(module, exports) {

$parcel$export(module.exports, "toCamelCaseChartView", () => $8f9b588eed549686$export$f1cb745981250009);
$parcel$export(module.exports, "getMode", () => $8f9b588eed549686$export$1fc0f6205829e19c);
$parcel$export(module.exports, "getModeV2", () => $8f9b588eed549686$export$cc65f5a30b63da10);

var $e4eHl = parcelRequire("e4eHl");

const $8f9b588eed549686$export$f1cb745981250009 = (chartView)=>(0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(chartView);
const $8f9b588eed549686$export$1fc0f6205829e19c = (view)=>{
    switch(view){
        case 'planning':
        case 'planning.nodetail':
            return 0, $257789568f7508a4$export$c303e491e026ebc6;
        case 'reporting':
            return 0, $257789568f7508a4$export$e3d31417f21c1ce7;
        default:
            return 0, $257789568f7508a4$export$77d6f70978850641;
    }
};
const $8f9b588eed549686$export$cc65f5a30b63da10 = (routeName)=>{
    if (!routeName) return 0, $257789568f7508a4$export$77d6f70978850641;
    switch(routeName){
        case 'rapidboard-backlog':
        case 'rapidboard-user-backlog':
            return 0, $257789568f7508a4$export$c303e491e026ebc6;
        case 'rapidboard-report':
        case 'rapidboard-user-report':
            return 0, $257789568f7508a4$export$e3d31417f21c1ce7;
        default:
            return 0, $257789568f7508a4$export$77d6f70978850641;
    }
};

});
const $257789568f7508a4$export$77d6f70978850641 = 'work';
const $257789568f7508a4$export$c303e491e026ebc6 = 'plan';
const $257789568f7508a4$export$e3d31417f21c1ce7 = 'report';



parcelRegister("7waah", function(module, exports) {

$parcel$export(module.exports, "ProjectBreadcrumbs", () => $8abb6938d84ad6f7$export$38f8c59e2af08a87);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $c2D8L = parcelRequire("c2D8L");

var $gEFwt = parcelRequire("gEFwt");

var $koVbs = parcelRequire("koVbs");

var $4Fx92 = parcelRequire("4Fx92");
const $8abb6938d84ad6f7$export$38f8c59e2af08a87 = /*#__PURE__*/ (0, $5uXOq.memo)(({ baseUrl: baseUrl, boardId: boardId, boardName: boardName, projectKey: projectKey, projectName: projectName, projectId: projectId, isSimplifiedProject: isSimplifiedProject, chart: chart })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const reportsHref = (0, $4R6GH.fg)('reports-overview-page-migration') ? `/jira/software/c/projects/${projectKey}/boards/${boardId}/reports` : `/projects/${projectKey}?selectedItem=com.atlassian.jira.jira-projects-plugin:report-page`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
        baseUrl: baseUrl,
        projectKey: projectKey,
        projectName: projectName,
        projectId: projectId,
        isSimplifiedProject: isSimplifiedProject
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/software/c/projects/${projectKey}/boards/${boardId}`,
            type: 'boardName',
            analyticsAttributes: {
                nextGenProject: isSimplifiedProject,
                projectConfig: isSimplifiedProject ? 'next-gen' : 'classic'
            },
            analyticsFields: {
                name: 'navigateToSubProject',
                containerId: projectId,
                containerType: 'project'
            }
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $4Fx92.messages).projectReportBreadcrumb),
            href: reportsHref
        }
    })));
});

});
parcelRegister("4Fx92", function(module, exports) {

$parcel$export(module.exports, "messages", () => $5aafea47193ed555$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $5aafea47193ed555$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    projectReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.project.project-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});


parcelRegister("liUyW", function(module, exports) {

$parcel$export(module.exports, "UserBreadcrumbs", () => $3727e2d15103e5d8$export$74fdd5a0187b08ef);

var $5uXOq = parcelRequire("5uXOq");

var $c2D8L = parcelRequire("c2D8L");

var $75PvK = parcelRequire("75PvK");

var $koVbs = parcelRequire("koVbs");

var $ikP65 = parcelRequire("ikP65");
const $3727e2d15103e5d8$export$74fdd5a0187b08ef = /*#__PURE__*/ (0, $5uXOq.memo)(({ accountId: accountId, boardId: boardId, boardName: boardName, profileUrl: profileUrl, userName: userName, chart: chart, isLocationlessBoard: isLocationlessBoard })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isLocationlessBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75PvK.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&locationless=true`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $ikP65.messages).userReportBreadcrumb),
            href: `/secure/RapidBoard.jspa?rapidView=${boardId}&view=reporting&chart=${chart}&locationless=true`
        }
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75PvK.default), {
        profileUrl: profileUrl,
        name: userName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: boardName,
            href: `/jira/people/${accountId}/boards/${boardId}`,
            type: 'boardName'
        }
    }, chart && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c2D8L.default), {
        breadcrumb: {
            text: formatMessage((0, $ikP65.messages).userReportBreadcrumb),
            href: `/jira/people/${accountId}/boards/${boardId}/reports/${chart}`
        }
    })));
});

});
parcelRegister("ikP65", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0a2e9bc5bc00af22$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0a2e9bc5bc00af22$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    userReportBreadcrumb: {
        "id": "spa-apps-software-breadcrumbs.user.user-report-breadcrumb",
        "defaultMessage": "Reports"
    }
});

});



const $d7cba9080a5695ea$export$912d9029af46d426 = 'Board is locationless';
const $d7cba9080a5695ea$export$759edcab449d5404 = 'This board has no columns with a mapped status.';

parcelRegister("k6PKo", function(module, exports) {

$parcel$export(module.exports, "renderBoardApp", () => $ff48902f5a4fd7db$export$23d0ab3b8e29eb8a);
$parcel$export(module.exports, "BoardApp", () => $ff48902f5a4fd7db$export$4701a49c1c468509);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6BZYo = parcelRequire("6BZYo");

var $2vSU6 = parcelRequire("2vSU6");

var $i2Rm5 = parcelRequire("i2Rm5");

var $4tcSU = parcelRequire("4tcSU");

var $feJRr = parcelRequire("feJRr");

var $2YZCu = parcelRequire("2YZCu");

var $11dfA = parcelRequire("11dfA");

var $5sgUt = parcelRequire("5sgUt");

var $7LEyz = parcelRequire("7LEyz");

var $jST59 = parcelRequire("jST59");

var $8R2g1 = parcelRequire("8R2g1");

var $dZw8H = parcelRequire("dZw8H");

var $6s1PB = parcelRequire("6s1PB");
// @ts-expect-error - TS7006 - Parameter 'callback' implicitly has an 'any' type.
const $ff48902f5a4fd7db$var$bindToOnJiraGlobalIssueCreateClose = (callback)=>{
    // window.require is not available on initial script load.
    // eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: 'jira/util/events',
        wrmKeys: 'wrc!jira.webresources:jira-events'
    }).then((Events)=>{
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        Events?.bind?.('QuickCreateIssue.sessionComplete', callback);
    });
};
const $ff48902f5a4fd7db$export$23d0ab3b8e29eb8a = ({ rapidViewId: rapidViewId, projectKey: projectKey, projectType: projectType = (0, $2vSU6.SOFTWARE_PROJECT), context: { tenantContext: tenantContext }, boardData: boardData, cmpBoardData: cmpBoardData, history: history, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, boardFilterRefinementQueryRef: boardFilterRefinementQueryRef, isCMPBoard: isCMPBoard, isUserBoard: isUserBoard })=>{
    const { error: prefetchError, loading: boardPrefetchIsLoading } = boardData || cmpBoardData || {};
    const { data: data } = boardData || {};
    const isCustomFiltersReady = customFiltersQueryRef !== null || boardFilterRefinementQueryRef !== null && (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false);
    // Terminate loading cases early
    if (!isCMPBoard && (boardPrefetchIsLoading || !isCustomFiltersReady)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11dfA.NextGenBoardSkeleton), null);
    // If we find any prefetch error or the data is null/invalid for any reason this is a failure
    if (!isCMPBoard && (prefetchError || !data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8R2g1.BoardSlaTracker), {
        boardData: boardData || cmpBoardData
    }), (0, $5sgUt.isBoardSizeLimitError)(prefetchError) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LEyz.default), {
        projectKey: projectKey
    }) : // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null | undefined' is not assignable to type 'Error | null'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "next-gen-board",
        error: prefetchError
    }));
    if (data && !data.projectLocation) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.next-gen-board.board-app.prefetch-data-without-project-location', 'data.projectLocation is undefined');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        key: rapidViewId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feJRr.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jST59.default), {
        isCMPBoard: isCMPBoard === true,
        isUserBoard: isUserBoard === true,
        isCacheHit: isCacheHit,
        locale: tenantContext.locale,
        /* eslint-disable-next-line jira/deprecations/no-base-url */ contextPath: tenantContext.baseUrl,
        cloudId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        rapidViewId: rapidViewId,
        projectKey: projectKey || '',
        projectId: Number(data?.projectLocation?.id || ''),
        projectType: projectType,
        userAccountId: tenantContext.atlassianAccountId || '',
        xsrfToken: (0, $4tcSU.default)() || '',
        bindToOnJiraGlobalIssueCreateClose: $ff48902f5a4fd7db$var$bindToOnJiraGlobalIssueCreateClose,
        prefetchedData: data,
        cmpBoardData: cmpBoardData?.promise ?? null,
        siteAdminStatus: tenantContext.siteAdminStatus,
        licensedProducts: tenantContext.licensedProducts,
        productCrossSellConfig: tenantContext.productCrossSellConfig,
        onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        isServer: false,
        history: history,
        customFiltersQueryRef: customFiltersQueryRef,
        boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
        isIncrementPlanningBoard: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};
const $ff48902f5a4fd7db$export$4701a49c1c468509 = ({ rapidViewId: rapidViewId, projectKey: projectKey, projectType: projectType = (0, $2vSU6.SOFTWARE_PROJECT), context: { tenantContext: tenantContext }, boardData: boardData, cmpBoardData: cmpBoardData, history: history, isCacheHit: isCacheHit, customFiltersQueryRef: customFiltersQueryRef, boardFilterRefinementQueryRef: boardFilterRefinementQueryRef, isCMPBoard: isCMPBoard, isUserBoard: isUserBoard })=>{
    const { error: prefetchError, loading: boardPrefetchIsLoading } = boardData || cmpBoardData || {};
    const { data: data } = boardData || {};
    const isCustomFiltersReady = customFiltersQueryRef !== null || boardFilterRefinementQueryRef !== null && (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false);
    (0, $5uXOq.useEffect)(()=>{
        if (data && !data.projectLocation) (0, $2YZCu.default).safeErrorWithoutCustomerData('spa-apps.next-gen-board.board-app.prefetch-data-without-project-location', 'data.projectLocation is undefined');
    }, [
        data
    ]);
    // Terminate loading cases early
    if (!isCMPBoard && (boardPrefetchIsLoading || !isCustomFiltersReady)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11dfA.NextGenBoardSkeleton), null);
    // If we find any prefetch error or the data is null/invalid for any reason this is a failure
    if (!isCMPBoard && (prefetchError || !data)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8R2g1.BoardSlaTracker), {
        boardData: boardData || cmpBoardData
    }), (0, $5sgUt.isBoardSizeLimitError)(prefetchError) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LEyz.default), {
        projectKey: projectKey
    }) : // @ts-expect-error - TS2322 - Type 'Error | Record<string, any> | (Error & Record<string, any>) | (Record<string, any> & Error) | null | undefined' is not assignable to type 'Error | null'.
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
        id: "next-gen-board",
        error: prefetchError
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
        key: rapidViewId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $feJRr.default), {
        name: "configApiReady"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jST59.default), {
        isCMPBoard: isCMPBoard === true,
        isUserBoard: isUserBoard === true,
        isCacheHit: isCacheHit,
        locale: tenantContext.locale,
        /* eslint-disable-next-line jira/deprecations/no-base-url */ contextPath: tenantContext.baseUrl,
        cloudId: tenantContext.cloudId,
        activationId: tenantContext.activationId,
        rapidViewId: rapidViewId,
        projectKey: projectKey || '',
        projectId: Number(data?.projectLocation?.id || ''),
        projectType: projectType,
        userAccountId: tenantContext.atlassianAccountId || '',
        xsrfToken: (0, $4tcSU.default)() || '',
        bindToOnJiraGlobalIssueCreateClose: $ff48902f5a4fd7db$var$bindToOnJiraGlobalIssueCreateClose,
        prefetchedData: data,
        cmpBoardData: cmpBoardData?.promise ?? null,
        siteAdminStatus: tenantContext.siteAdminStatus,
        licensedProducts: tenantContext.licensedProducts,
        productCrossSellConfig: tenantContext.productCrossSellConfig,
        onUnmount: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        isServer: false,
        history: history,
        customFiltersQueryRef: customFiltersQueryRef,
        boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
        isIncrementPlanningBoard: false
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZw8H.SpaStatePageReady), null));
};

});
parcelRegister("feJRr", function(module, exports) {

$parcel$export(module.exports, "default", () => $aa35a5a19d0a4620$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5h5Fg = parcelRequire("5h5Fg");

var $8Qrwl = parcelRequire("8Qrwl");
class $aa35a5a19d0a4620$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { name: name } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Qrwl.default).Consumer, null, ({ pageId: pageId, onCustomMark: onCustomMark })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5h5Fg.default), {
                op: onCustomMark,
                args: [
                    name,
                    pageId
                ]
            }));
    }
}

});

parcelRegister("5sgUt", function(module, exports) {

$parcel$export(module.exports, "isBoardSizeLimitError", () => $9689f51629af798e$export$c72e0becab2a28fe);

var $9XE6b = parcelRequire("9XE6b");
const $9689f51629af798e$export$c72e0becab2a28fe = (error)=>error != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    Array.isArray(error.graphQLErrors) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    error.graphQLErrors[0] != null && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error.graphQLErrors[0], [
        'extensions',
        'statusCode'
    ]) && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error.graphQLErrors[0], [
        'extensions',
        'errorType'
    ]) === 'jsw.board-size-limit-exceeded';

});

parcelRegister("7LEyz", function(module, exports) {

$parcel$export(module.exports, "default", () => $85ba20431946ab6e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9OXo1 = parcelRequire("9OXo1");

var $5QVhk = parcelRequire("5QVhk");
/**
 * @deprecated use generic version of SizeLimitErrorEmptyStateComponent component @atlassian/jira-software-size-limit-error-empty-state
 */ const $85ba20431946ab6e$var$BoardSizeLimitErrorEmptyStateWithBaseUrl = ({ projectKey: projectKey, savedFilterId: savedFilterId, isCMPBoard: isCMPBoard = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
        const { baseUrl: baseUrl } = tenantContext;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5QVhk.default), {
            projectKey: projectKey,
            baseUrl: baseUrl,
            isCMPBoard: isCMPBoard,
            savedFilterId: savedFilterId
        });
    });
var $85ba20431946ab6e$export$2e2bcd8739ae039 = $85ba20431946ab6e$var$BoardSizeLimitErrorEmptyStateWithBaseUrl;

});
parcelRegister("5QVhk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d46e677f9d568066$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $7Xi9S = parcelRequire("7Xi9S");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $6jY6G = parcelRequire("6jY6G");

var $bMyyL = parcelRequire("bMyyL");

var $gzib5 = parcelRequire("gzib5");
const $d46e677f9d568066$var$BoardSizeLimitError = ({ intl: intl, projectKey: projectKey, baseUrl: baseUrl, isCMPBoard: isCMPBoard = false, savedFilterId: savedFilterId })=>{
    const description = isCMPBoard ? intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).descriptionCmpIssueTermRefresh : (0, $bMyyL.default).descriptionCmp) : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).descriptionIssueTermRefresh : (0, $bMyyL.default).description);
    const url = isCMPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(savedFilterId) ? `${baseUrl}/issues/?filter=${savedFilterId}` : `${baseUrl}/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`;
    const buttonText = isCMPBoard ? intl.formatMessage((0, $bMyyL.default).editBoardFilter) : intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).goToSearchIssueTermRefresh : (0, $bMyyL.default).goToSearch);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7Xi9S))),
        header: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bMyyL.default).headerIssueTermRefresh : (0, $bMyyL.default).header),
        description: description,
        primaryAction: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            href: url,
            appearance: "primary"
        }, buttonText)
    }));
};
const $d46e677f9d568066$var$BoardSizeLimitErrorEmptyState = (props)=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const showErrorWithNoCTA = name === 'servicedesk-boards';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$Container, null, showErrorWithNoCTA ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gzib5.BoardSizeLimitErrorWithNoCTA), {
        intl: props.intl
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d46e677f9d568066$var$BoardSizeLimitError, props));
};
const $d46e677f9d568066$var$BoardSizeLimitErrorEmptyStateWithIntl = (0, $az4zD.injectIntlV2)($d46e677f9d568066$var$BoardSizeLimitErrorEmptyState);
var $d46e677f9d568066$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d46e677f9d568066$var$BoardSizeLimitErrorEmptyStateWithIntl;
const $d46e677f9d568066$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7Xi9S", function(module, exports) {
module.exports = new URL("something-wrong.1260804e.svg", import.meta.url).toString();

});

parcelRegister("bMyyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfedbe69eb72a9f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $dfedbe69eb72a9f4$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.header",
        "defaultMessage": "Your board has too many issues"
    },
    goToSearch: {
        "id": "software-board-size-limit-error-empty-state.go-to-search",
        "defaultMessage": "See issues in search"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.description",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Move or delete issues to continue using your board."
    },
    descriptionCmp: {
        "id": "software-board-size-limit-error-empty-state.description-cmp",
        "defaultMessage": "Boards can only display up to 5,000 issues at a time. Try editing your board's filter query to include fewer issues, or create an additional board."
    },
    editBoardFilter: {
        "id": "software-board-size-limit-error-empty-state.edit-board-filter",
        "defaultMessage": "Edit board filter"
    },
    headerIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.header-issue-term-refresh",
        "defaultMessage": "Your board has too many work items"
    },
    goToSearchIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.go-to-search-issue-term-refresh",
        "defaultMessage": "View everything in search"
    },
    descriptionIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.description-issue-term-refresh",
        "defaultMessage": "Boards can only display up to 5,000 work items at a time. Move or delete work to continue using your board."
    },
    descriptionCmpIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.description-cmp-issue-term-refresh",
        "defaultMessage": "Boards can only display up to 5,000 work items at a time. Try editing your board's filter query to include fewer work items, or create an additional board."
    }
});
var $dfedbe69eb72a9f4$export$2e2bcd8739ae039 = $dfedbe69eb72a9f4$var$messages;

});

parcelRegister("gzib5", function(module, exports) {

$parcel$export(module.exports, "BoardSizeLimitErrorWithNoCTA", () => $6e3be43d7f71b8ae$export$67ed49fd05b7aff8);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7Xi9S = parcelRequire("7Xi9S");

var $6s1PB = parcelRequire("6s1PB");

var $9NE02 = parcelRequire("9NE02");
const $6e3be43d7f71b8ae$export$67ed49fd05b7aff8 = ({ intl: intl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6e3be43d7f71b8ae$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        imageUrl: (0, (/*@__PURE__*/$parcel$interopDefault($7Xi9S))),
        header: intl.formatMessage((0, $9NE02.default).header),
        description: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9NE02.default).descriptionIssueTermRefresh : (0, $9NE02.default).description)
    }));
const $6e3be43d7f71b8ae$var$containerStyles = (0, $8CUq3.xcss)({
    width: '100%'
});

});
parcelRegister("9NE02", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9e962dff92e62d1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $a9e962dff92e62d1$var$messages = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.header",
        "defaultMessage": "We couldn\u2019t load your board"
    },
    description: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description",
        "defaultMessage": "Boards only works in project with less than 5,000 issues. We\u2019re working on this and will let you know when it has changed."
    },
    descriptionIssueTermRefresh: {
        "id": "software-board-size-limit-error-empty-state.size-limit-error-no-cta.description-issue-term-refresh",
        "defaultMessage": "Boards only works in project with less than 5,000 work items. We\u2019re working on this and will let you know when it has changed."
    }
});
var $a9e962dff92e62d1$export$2e2bcd8739ae039 = $a9e962dff92e62d1$var$messages;

});




parcelRegister("jST59", function(module, exports) {

$parcel$export(module.exports, "default", () => $1712308f25f5ee94$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $imZsD = parcelRequire("imZsD");

var $AeWM3 = parcelRequire("AeWM3");

var $aWb5p = parcelRequire("aWb5p");

var $jD5no = parcelRequire("jD5no");

var $lKocD = parcelRequire("lKocD");

var $2vSU6 = parcelRequire("2vSU6");

var $x9xyg = parcelRequire("x9xyg");

var $bRUzT = parcelRequire("bRUzT");

var $b71gk = parcelRequire("b71gk");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $wKznQ = parcelRequire("wKznQ");

var $97Kan = parcelRequire("97Kan");

var $joFsm = parcelRequire("joFsm");

var $5sUih = parcelRequire("5sUih");

var $8PRuf = parcelRequire("8PRuf");


var $6jwh3 = parcelRequire("6jwh3");

var $c1haS = parcelRequire("c1haS");

var $bG4jy = parcelRequire("bG4jy");

var $iUagi = parcelRequire("iUagi");

var $i6HlS = parcelRequire("i6HlS");


var $4ldpW = parcelRequire("4ldpW");

var $jQCwr = parcelRequire("jQCwr");

var $jM0wW = parcelRequire("jM0wW");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $b5JVP = parcelRequire("b5JVP");

var $j0iXE = parcelRequire("j0iXE");

var $gru50 = parcelRequire("gru50");

var $a9mbK = parcelRequire("a9mbK");

var $iyXvX = parcelRequire("iyXvX");

var $buSp0 = parcelRequire("buSp0");

var $4zzhM = parcelRequire("4zzhM");

var $6ALx6 = parcelRequire("6ALx6");
const $1712308f25f5ee94$var$SoftwareApp = (props)=>{
    const { contextPath: contextPath, rapidViewId: rapidViewId, projectKey: projectKey, projectId: projectId, cloudId: cloudId, activationId: activationId, userAccountId: userAccountId, locale: locale, bindToOnJiraGlobalIssueCreateClose: bindToOnJiraGlobalIssueCreateClose, licensedProducts: licensedProducts, siteAdminStatus: siteAdminStatus, productCrossSellConfig: productCrossSellConfig, isServer: isServer, history: history, disableStoreCaches: disableStoreCaches, planId: planId, scenarioId: scenarioId, customRequestHandlers: customRequestHandlers, xsrfToken: xsrfToken, prefetchedData: prefetchedData, cmpBoardData: cmpBoardData, customFiltersQueryRef: customFiltersQueryRef, boardFilterRefinementQueryRef: boardFilterRefinementQueryRef, isCacheHit: isCacheHit, boardApiRef: boardApiRef, onUnmount: onUnmount, isCMPBoard: isCMPBoard, isUserBoard: isUserBoard, isIncrementPlanningBoard: isIncrementPlanningBoard, projectType: projectType } = props;
    const stableRef = (0, $bG4jy.useKeyedRef)((0, $67sX6.createStoreWithCache), `${String(rapidViewId)}-${String(isCMPBoard)}`); // We are just using createStoreWithCache since we only need the function as a unique identifier for this usage
    const [store, stableInitializationCleanup] = (0, $bG4jy.useStableInitialization)(stableRef, ()=>{
        const initialState = {
            configuration: {
                contextPath: contextPath,
                rapidViewId: String(rapidViewId),
                projectKey: projectKey,
                projectId: projectId,
                projectType: projectType,
                cloudId: cloudId,
                activationId: activationId,
                userAccountId: userAccountId,
                locale: locale,
                licensedProducts: licensedProducts,
                siteAdminStatus: siteAdminStatus,
                productCrossSellConfig: productCrossSellConfig,
                sessionId: (0, $7Jxgt.v4)(),
                isCMPBoard: isCMPBoard,
                isUserBoard: isUserBoard,
                isIncrementPlanningBoard: isIncrementPlanningBoard,
                planId: planId,
                scenarioId: scenarioId
            },
            ui: {
                swimlane: {
                    collapsed: (0, $jQCwr.getCollapsedSwimlanes)(rapidViewId)
                },
                ...isCMPBoard && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                !window.location.search && {
                    workFilters: {
                        values: (0, $wKznQ.getCachedFilters)('board', rapidViewId) ?? {}
                    }
                }
            }
        };
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreStartMark));
        const newStore = isCMPBoard ? (0, $67sX6.createStoreWithCache)(String(rapidViewId), initialState, {
            isCMPBoard: isCMPBoard,
            isServer: isServer,
            projectType: projectType,
            disableStoreCaches: disableStoreCaches ?? false,
            swagClient: (0, $AeWM3.getClient)(contextPath, (0, $aWb5p.default), xsrfToken)
        }) : (0, $67sX6.default)(initialState, {
            isCMPBoard: isCMPBoard,
            isServer: isServer,
            projectType: projectType,
            swagClient: (0, $AeWM3.getClient)(contextPath, (0, $aWb5p.default), xsrfToken),
            disableStoreCaches: false,
            customRequestHandlers: customRequestHandlers
        });
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreEndMark));
        if ((0, $4R6GH.fg)('jfp-magma-concurrent-board-duplicate-api-calls')) (0, $bG4jy.toBeCalledOnceFor)(newStore, ()=>{
            newStore.dispatch((0, $65C0W.softwareAppLoaded)(prefetchedData, cmpBoardData));
        });
        else newStore.dispatch((0, $65C0W.softwareAppLoaded)(prefetchedData, cmpBoardData));
        return newStore;
    }, (0, $4R6GH.fg)('jfp-magma-concurrent-board-duplicate-api-calls'));
    (0, $5uXOq.useEffect)(()=>{
        const keepNonManagedParams = isIncrementPlanningBoard || (0, $iUagi.isTailoredViewExperimentEnabled)();
        const isJqlFilterEnabled = (0, $6ALx6.shouldDisplayFilterRefinement)({
            isIncrementPlanningBoard: isIncrementPlanningBoard,
            isCMPBoard: isCMPBoard,
            isJSMBoard: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT),
            isJSWBoard: projectType === (0, $2vSU6.SOFTWARE_PROJECT)
        }) && (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false);
        const unsubscribeUrlBindings = (0, $lKocD.default)(store, [
            ...(0, $4ldpW.default)(isCMPBoard, isJqlFilterEnabled),
            ...(0, $jM0wW.default)(isIncrementPlanningBoard)
        ], keepNonManagedParams, history);
        bindToOnJiraGlobalIssueCreateClose((event, issues, triggerSource)=>{
            store.dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8cabdc85b8691f12), issues, triggerSource));
        });
        (0, $x9xyg.setMark)((0, $8PRuf.jswRenderStartMark));
        // componentWillUnmount
        return ()=>{
            unsubscribeUrlBindings();
            if (store && (0, $67Z81.getIsCMPBoard)(store.getState())) store.dispatch((0, $cW3pH.beforeDispose));
            onUnmount();
            (0, $67sX6.unmountCachedStore)();
            if ((0, $4R6GH.fg)('jfp-magma-concurrent-board-duplicate-api-calls')) {
                stableInitializationCleanup?.();
                (0, $bG4jy.toBeCalledOnceForCleanup)?.(store);
            }
        };
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aWb5p.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
        id: (0, $dcbb2bce513725b3$export$d76071d5de2774fc),
        store: store,
        teamName: (0, $dcbb2bce513725b3$export$d57b6b390e78d90f),
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: "page"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67sX6.BoardReduxProvider), {
        store: store
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sUih.default).Provider, {
        value: {
            scenarioId: scenarioId,
            planId: planId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9mbK.default), {
        isCacheHit: isCacheHit,
        rapidViewId: (0, $67Z81.rapidViewIdSelector)(store.getState()),
        xsrfToken: xsrfToken,
        hasMinimap: !isServer,
        hasModals: !isServer,
        hasFlags: !isServer,
        customFiltersQueryRef: customFiltersQueryRef,
        boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
        projectId: (0, $67Z81.projectIdSelector)(store.getState()),
        isIncrementPlanningBoard: isIncrementPlanningBoard
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
        mapper: (0, $i6HlS.flagsMapper)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async-resources-cache-wrapper",
        packageName: "software-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6jwh3.AsyncResourcesCacheWrapper), {
        origin: (0, $8631d6ce464ccf2e$export$9b8283d5878d2491)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zzhM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joFsm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5JVP.AllFieldsSync), null), (0, $4R6GH.fg)('nav4_route_aware_automation_menu') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyXvX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gru50.FiltersStorage), null), (0, $iUagi.isTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buSp0.SwimlaneModeFromUrl), null), isIncrementPlanningBoard && boardApiRef !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j0iXE.default), {
        boardApiRef: boardApiRef
    }))))));
};
// eslint-disable-next-line jira/react/no-class-components
class $1712308f25f5ee94$var$SoftwareAppOriginal extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            onUnmount: ()=>{},
            isCMPBoard: false,
            isUserBoard: false,
            isIncrementPlanningBoard: false,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT)
        };
    }
    constructor(props){
        super(props), this.hasRendered = false;
        const { contextPath: contextPath, rapidViewId: rapidViewId, projectKey: projectKey, projectId: projectId, projectType: projectType, cloudId: cloudId, activationId: activationId, userAccountId: userAccountId, locale: locale, bindToOnJiraGlobalIssueCreateClose: bindToOnJiraGlobalIssueCreateClose, licensedProducts: licensedProducts, siteAdminStatus: siteAdminStatus, productCrossSellConfig: productCrossSellConfig, isServer: isServer, history: history, isCMPBoard: isCMPBoard, isUserBoard: isUserBoard, disableStoreCaches: disableStoreCaches, isIncrementPlanningBoard: /**
			 * ARJ increment planning board
			 */ isIncrementPlanningBoard, planId: planId, scenarioId: scenarioId, customRequestHandlers: customRequestHandlers } = props;
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const initialState = {
            configuration: {
                contextPath: contextPath,
                rapidViewId: String(rapidViewId),
                projectKey: projectKey,
                projectId: projectId,
                projectType: projectType,
                cloudId: cloudId,
                activationId: activationId,
                userAccountId: userAccountId,
                locale: locale,
                licensedProducts: licensedProducts,
                siteAdminStatus: siteAdminStatus,
                productCrossSellConfig: productCrossSellConfig,
                sessionId: (0, $7Jxgt.v4)(),
                isCMPBoard: isCMPBoard,
                isUserBoard: isUserBoard,
                isIncrementPlanningBoard: /**
				 * ARJ increment planning board
				 */ isIncrementPlanningBoard,
                planId: planId,
                scenarioId: scenarioId
            },
            ui: {
                swimlane: {
                    collapsed: (0, $jQCwr.getCollapsedSwimlanes)(rapidViewId)
                },
                ...isCMPBoard && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                !window.location.search && {
                    workFilters: {
                        values: (0, $wKznQ.getCachedFilters)('board', rapidViewId) ?? {}
                    }
                }
            }
        };
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreStartMark));
        this.store = isCMPBoard ? (0, $67sX6.createStoreWithCache)(String(rapidViewId), initialState, {
            isCMPBoard: isCMPBoard,
            isServer: isServer,
            projectType: projectType,
            disableStoreCaches: disableStoreCaches ?? false,
            swagClient: (0, $AeWM3.getClient)(contextPath, (0, $aWb5p.default), this.props.xsrfToken)
        }) : (0, $67sX6.default)(initialState, {
            isCMPBoard: isCMPBoard,
            isServer: isServer,
            projectType: projectType,
            swagClient: (0, $AeWM3.getClient)(contextPath, (0, $aWb5p.default), this.props.xsrfToken),
            // noop in this position
            disableStoreCaches: false,
            customRequestHandlers: customRequestHandlers
        });
        (0, $x9xyg.setMark)((0, $8PRuf.jswCreateReduxStoreEndMark));
        // In increment planning board, there are URL params set by other packages, eg. software/view-settings
        const keepNonManagedParams = isIncrementPlanningBoard || (0, $iUagi.isTailoredViewExperimentEnabled)();
        const isJqlFilterEnabled = (0, $6ALx6.shouldDisplayFilterRefinement)({
            isIncrementPlanningBoard: isIncrementPlanningBoard,
            isCMPBoard: isCMPBoard,
            isJSMBoard: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT),
            isJSWBoard: projectType === (0, $2vSU6.SOFTWARE_PROJECT)
        }) && (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false);
        this.unsubscribeUrlBindings = (0, $lKocD.default)(this.store, [
            ...(0, $4ldpW.default)(isCMPBoard, isJqlFilterEnabled),
            ...(0, $jM0wW.default)(isIncrementPlanningBoard)
        ], keepNonManagedParams, history);
        // let's update store before it's attached to virtual DOM
        this.store.dispatch((0, $65C0W.softwareAppLoaded)(props.prefetchedData, props.cmpBoardData));
        bindToOnJiraGlobalIssueCreateClose((event, issues, triggerSource)=>{
            this.store.dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8cabdc85b8691f12), issues, triggerSource));
        });
    }
    componentDidMount() {
        this.hasRendered = true;
    }
    componentWillUnmount() {
        this.unsubscribeUrlBindings();
        if (this.store) {
            if ((0, $67Z81.getIsCMPBoard)(this.store.getState())) this.store.dispatch((0, $cW3pH.beforeDispose));
            this.store.dispatch((0, $bRUzT.DISPOSE_ACTION));
        }
        this.props.onUnmount();
        (0, $67sX6.unmountCachedStore)();
    }
    render() {
        if (!this.hasRendered) (0, $x9xyg.setMark)((0, $8PRuf.jswRenderStartMark));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
            client: (0, $aWb5p.default)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), {
            id: (0, $dcbb2bce513725b3$export$d76071d5de2774fc),
            store: this.store,
            teamName: (0, $dcbb2bce513725b3$export$d57b6b390e78d90f),
            packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
            fallback: "page"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67sX6.BoardReduxProvider), {
            store: this.store
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5sUih.default).Provider, {
            value: {
                scenarioId: this.props.scenarioId,
                planId: this.props.planId
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a9mbK.default), {
            isCacheHit: this.props.isCacheHit,
            rapidViewId: (0, $67Z81.rapidViewIdSelector)(this.store.getState()),
            xsrfToken: this.props.xsrfToken,
            hasMinimap: !this.props.isServer,
            hasModals: !this.props.isServer,
            hasFlags: !this.props.isServer,
            customFiltersQueryRef: this.props.customFiltersQueryRef,
            boardFilterRefinementQueryRef: this.props.boardFilterRefinementQueryRef,
            projectId: (0, $67Z81.projectIdSelector)(this.store.getState()),
            isIncrementPlanningBoard: this.props.isIncrementPlanningBoard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $97Kan.FlagsDispatcher), {
            mapper: (0, $i6HlS.flagsMapper)
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "async-resources-cache-wrapper",
            packageName: "software-board"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6jwh3.AsyncResourcesCacheWrapper), {
            origin: (0, $8631d6ce464ccf2e$export$9b8283d5878d2491)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4zzhM.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $joFsm.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b5JVP.AllFieldsSync), null), (0, $4R6GH.fg)('nav4_route_aware_automation_menu') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iyXvX.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gru50.FiltersStorage), null), (0, $iUagi.isTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $buSp0.SwimlaneModeFromUrl), null), this.props.isIncrementPlanningBoard && this.props.boardApiRef !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j0iXE.default), {
            boardApiRef: this.props.boardApiRef
        }))))));
    }
}
var $1712308f25f5ee94$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('jira-boards-in-strict-mode'), $1712308f25f5ee94$var$SoftwareApp, $1712308f25f5ee94$var$SoftwareAppOriginal);

});
parcelRegister("AeWM3", function(module, exports) {

$parcel$export(module.exports, "resetCache", () => $63ae5caf575c2d55$export$6e5dca841bdf93e3);
$parcel$export(module.exports, "resetCacheAsync", () => $63ae5caf575c2d55$export$cd62f60830f74ae2);
$parcel$export(module.exports, "getClient", () => $63ae5caf575c2d55$export$6bb76d6eba7e258c);
$parcel$export(module.exports, "ApolloClientProvider", () => $63ae5caf575c2d55$export$8e363dbef886ff17);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $bvsgq = parcelRequire("bvsgq");

var $9OXo1 = parcelRequire("9OXo1");
const $63ae5caf575c2d55$var$CLIENTS_CACHE = {};
const $63ae5caf575c2d55$export$6e5dca841bdf93e3 = (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId]?.clearStore();
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
};
const $63ae5caf575c2d55$export$cd62f60830f74ae2 = async (clientId)=>{
    // we need to `clearStore` directly to the InMemoryCache instance
    const client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    delete $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    await client?.clearStore();
};
const $63ae5caf575c2d55$export$44dd3e9494f887fc = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys($63ae5caf575c2d55$var$CLIENTS_CACHE).reduce((acc, key)=>Object.assign(acc, {
            [`apollo-cache/${key}`]: $63ae5caf575c2d55$var$CLIENTS_CACHE[key].extract()
        }), {});
const $63ae5caf575c2d55$export$6bb76d6eba7e258c = (baseUrl, { clientId: clientId, clientCreator: clientCreator }, xsrfToken)=>{
    let client = $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId];
    if (!client) {
        client = clientCreator(baseUrl, xsrfToken);
        $63ae5caf575c2d55$var$CLIENTS_CACHE[clientId] = client;
    }
    return client;
};
class $63ae5caf575c2d55$export$8e363dbef886ff17 extends (0, $5uXOq.Component) {
    getClient(baseUrl, xsrfToken) {
        return $63ae5caf575c2d55$export$6bb76d6eba7e258c(baseUrl, this.props.client, xsrfToken != null ? xsrfToken : undefined);
    }
    render() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(this.props, 'client.clientId')) throw new Error('Please provide a client configuration');
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9OXo1.TenantContextSubscriber), null, ({ tenantContext: tenantContext })=>{
            const client = this.getClient(tenantContext.baseUrl, tenantContext.xsrfToken);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bvsgq.ApolloProvider), {
                client: client
            }, children);
        });
    }
}

});
parcelRegister("bvsgq", function(module, exports) {

$parcel$export(module.exports, "getApolloContext", () => $02296d7a3662bd2d$export$a47505d961ee3a1);
$parcel$export(module.exports, "ApolloProvider", () => $02296d7a3662bd2d$export$c16b04c8a9956446);
$parcel$export(module.exports, "DocumentType", () => $02296d7a3662bd2d$export$d1d99cf900472499);
$parcel$export(module.exports, "operationName", () => $02296d7a3662bd2d$export$5db520940cf00715);
$parcel$export(module.exports, "parser", () => $02296d7a3662bd2d$export$8f49e4af10703ce3);

var $5uXOq = parcelRequire("5uXOq");

var $1DiV8 = parcelRequire("1DiV8");
var $02296d7a3662bd2d$var$apolloContext;
function $02296d7a3662bd2d$export$a47505d961ee3a1() {
    if (!$02296d7a3662bd2d$var$apolloContext) $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
    return $02296d7a3662bd2d$var$apolloContext;
}
function $02296d7a3662bd2d$export$c2ee824bcc89ca6a() {
    $02296d7a3662bd2d$var$apolloContext = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext({});
}
var $02296d7a3662bd2d$export$c16b04c8a9956446 = function(_a) {
    var client = _a.client, children = _a.children;
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        if (context === void 0) context = {};
        if (client && context.client !== client) context = Object.assign({}, context, {
            client: client
        });
        (0, $1DiV8.invariant)(context.client, 5);
        return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Provider, {
            value: context
        }, children);
    });
};
var $02296d7a3662bd2d$export$ed5ceab8c2bb5ce4 = function(props) {
    var ApolloContext = $02296d7a3662bd2d$export$a47505d961ee3a1();
    return (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ApolloContext.Consumer, null, function(context) {
        (0, $1DiV8.invariant)(context && context.client, 6);
        return props.children(context.client);
    });
};
var $02296d7a3662bd2d$export$d1d99cf900472499;
(function(DocumentType) {
    DocumentType[DocumentType["Query"] = 0] = "Query";
    DocumentType[DocumentType["Mutation"] = 1] = "Mutation";
    DocumentType[DocumentType["Subscription"] = 2] = "Subscription";
})($02296d7a3662bd2d$export$d1d99cf900472499 || ($02296d7a3662bd2d$export$d1d99cf900472499 = {}));
var $02296d7a3662bd2d$var$cache = new Map();
function $02296d7a3662bd2d$export$5db520940cf00715(type) {
    var name;
    switch(type){
        case $02296d7a3662bd2d$export$d1d99cf900472499.Query:
            name = 'Query';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Mutation:
            name = 'Mutation';
            break;
        case $02296d7a3662bd2d$export$d1d99cf900472499.Subscription:
            name = 'Subscription';
            break;
    }
    return name;
}
function $02296d7a3662bd2d$export$8f49e4af10703ce3(document) {
    var cached = $02296d7a3662bd2d$var$cache.get(document);
    if (cached) return cached;
    var variables, type, name;
    (0, $1DiV8.invariant)(!!document && !!document.kind, 1);
    var fragments = document.definitions.filter(function(x) {
        return x.kind === 'FragmentDefinition';
    });
    var queries = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'query';
    });
    var mutations = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'mutation';
    });
    var subscriptions = document.definitions.filter(function(x) {
        return x.kind === 'OperationDefinition' && x.operation === 'subscription';
    });
    (0, $1DiV8.invariant)(!fragments.length || queries.length || mutations.length || subscriptions.length, 2);
    (0, $1DiV8.invariant)(queries.length + mutations.length + subscriptions.length <= 1, 3);
    type = queries.length ? $02296d7a3662bd2d$export$d1d99cf900472499.Query : $02296d7a3662bd2d$export$d1d99cf900472499.Mutation;
    if (!queries.length && !mutations.length) type = $02296d7a3662bd2d$export$d1d99cf900472499.Subscription;
    var definitions = queries.length ? queries : mutations.length ? mutations : subscriptions;
    (0, $1DiV8.invariant)(definitions.length === 1, 4);
    var definition = definitions[0];
    variables = definition.variableDefinitions || [];
    if (definition.name && definition.name.kind === 'Name') name = definition.name.value;
    else name = 'data';
    var payload = {
        name: name,
        type: type,
        variables: variables
    };
    $02296d7a3662bd2d$var$cache.set(document, payload);
    return payload;
}

});


parcelRegister("aWb5p", function(module, exports) {

$parcel$export(module.exports, "default", () => $de6560d9e86b64da$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $43WKH = parcelRequire("43WKH");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $4tcSU = parcelRequire("4tcSU");

var $04zaL = parcelRequire("04zaL");

var $dxpxC = parcelRequire("dxpxC");

var $5uTwE = parcelRequire("5uTwE");



const $de6560d9e86b64da$var$retryLink = new (0, $lC4FX.RetryLink)({
    attempts: {
        max: 2,
        retryIf: (networkError, operation)=>{
            const { operationName: operationName } = operation;
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
                'statusCode'
            ], null);
            // retry once when SWAG Node is dead.
            const shouldRetry = [
                502,
                503,
                504
            ].includes(Number(statusCode));
            if (shouldRetry) (0, $04zaL.logApolloRetry)({
                queryName: operationName,
                statusCode: statusCode
            });
            return shouldRetry;
        }
    }
});
const $de6560d9e86b64da$var$errorLink = (0, $h4ppL.onError)(({ operation: operation, graphQLErrors: graphQLErrors, networkError: networkError })=>{
    const { operationName: operationName } = operation;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ path: path, extensions: extensions })=>{
            const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(extensions, [
                'statusCode'
            ], null);
            const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(extensions, [
                'errorType'
            ], null);
            return (0, $04zaL.logApolloError)(path, statusCode, operationName, errorType);
        });
        else (0, $04zaL.logRestParsingError)('Unexpected error message format', JSON.stringify(graphQLErrors));
    }
    if (networkError) {
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
            'statusCode'
        ], null);
        (0, $04zaL.logApolloNetworkError)(networkError.toString(), statusCode, operationName);
    }
});
// Exporting fragmentMatcher to use it in StoryBook examples
const $de6560d9e86b64da$var$fragmentMatcher = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($5uTwE))
});
const $de6560d9e86b64da$var$cacheConfig = {
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    freezeResults: true,
    fragmentMatcher: $de6560d9e86b64da$var$fragmentMatcher
};
const $de6560d9e86b64da$var$cache = new (0, $ivfDv.InMemoryCache)($de6560d9e86b64da$var$cacheConfig);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $de6560d9e86b64da$var$customFetch = (uri, options)=>{
    const body = options && options.body ? JSON.parse(options.body) : null;
    return fetch(`${uri}?operation=${body ? body.operationName : 'unknown'}`, options);
};
const $de6560d9e86b64da$var$xsrfLink = ()=>(0, $43WKH.setContext)((operation, previousContext)=>{
        const { headers: headers } = previousContext;
        // set empty xsrfToken for SSR as cookies are unavailable
        const xsrfToken = false ? '' : (0, $4tcSU.default)();
        if (!xsrfToken) return previousContext;
        return {
            ...previousContext,
            headers: {
                ...headers,
                'atl-xsrf-token': xsrfToken
            }
        };
    });
const $de6560d9e86b64da$var$clientCreator = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: 'SWAG',
        link: (0, $clSzL.ApolloLink).from([
            $de6560d9e86b64da$var$retryLink,
            $de6560d9e86b64da$var$xsrfLink(),
            $de6560d9e86b64da$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($de6560d9e86b64da$var$cache),
            new (0, $JPsIz.HttpLink)({
                uri: `${baseUrl}/jsw2/graphql`,
                credentials: 'same-origin',
                fetch: $de6560d9e86b64da$var$customFetch
            })
        ]),
        cache: $de6560d9e86b64da$var$cache,
        assumeImmutableResults: true
    });
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$de6560d9e86b64da$export$2e2bcd8739ae039 = {
    clientId: 'SWAG',
    clientCreator: $de6560d9e86b64da$var$clientCreator
};

});
parcelRegister("ivfDv", function(module, exports) {

$parcel$export(module.exports, "IntrospectionFragmentMatcher", () => $d7874048ca668ecb$export$3b71c6b829c99d21);
$parcel$export(module.exports, "defaultDataIdFromObject", () => $d7874048ca668ecb$export$bd03c5a9c99d6bce);
$parcel$export(module.exports, "InMemoryCache", () => $d7874048ca668ecb$export$467265324939f47f);

var $3VFsf = parcelRequire("3VFsf");

var $hzuXv = parcelRequire("hzuXv");

var $jojW6 = parcelRequire("jojW6");
var $bqMzA = parcelRequire("bqMzA");

var $gLy2H = parcelRequire("gLy2H");

var $1DiV8 = parcelRequire("1DiV8");
var $d7874048ca668ecb$var$haveWarned = false;
function $d7874048ca668ecb$var$shouldWarn() {
    var answer = !$d7874048ca668ecb$var$haveWarned;
    if (!(0, $jojW6.isTest)()) $d7874048ca668ecb$var$haveWarned = true;
    return answer;
}
var $d7874048ca668ecb$export$5d3fcf53267091de = function() {
    function HeuristicFragmentMatcher() {}
    HeuristicFragmentMatcher.prototype.ensureReady = function() {
        return Promise.resolve();
    };
    HeuristicFragmentMatcher.prototype.canBypassInit = function() {
        return true;
    };
    HeuristicFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        if (!__typename) {
            $d7874048ca668ecb$var$shouldWarn();
            return 'heuristic';
        }
        if (__typename === typeCondition) return true;
        $d7874048ca668ecb$var$shouldWarn();
        return 'heuristic';
    };
    return HeuristicFragmentMatcher;
}();
var $d7874048ca668ecb$export$3b71c6b829c99d21 = function() {
    function IntrospectionFragmentMatcher(options) {
        if (options && options.introspectionQueryResultData) {
            this.possibleTypesMap = this.parseIntrospectionResult(options.introspectionQueryResultData);
            this.isReady = true;
        } else this.isReady = false;
        this.match = this.match.bind(this);
    }
    IntrospectionFragmentMatcher.prototype.match = function(idValue, typeCondition, context) {
        (0, $1DiV8.invariant)(this.isReady, 1);
        var obj = context.store.get(idValue.id);
        var isRootQuery = idValue.id === 'ROOT_QUERY';
        if (!obj) return isRootQuery;
        var _a = obj.__typename, __typename = _a === void 0 ? isRootQuery && 'Query' : _a;
        (0, $1DiV8.invariant)(__typename, 2);
        if (__typename === typeCondition) return true;
        var implementingTypes = this.possibleTypesMap[typeCondition];
        if (__typename && implementingTypes && implementingTypes.indexOf(__typename) > -1) return true;
        return false;
    };
    IntrospectionFragmentMatcher.prototype.parseIntrospectionResult = function(introspectionResultData) {
        var typeMap = {};
        introspectionResultData.__schema.types.forEach(function(type) {
            if (type.kind === 'UNION' || type.kind === 'INTERFACE') typeMap[type.name] = type.possibleTypes.map(function(implementingType) {
                return implementingType.name;
            });
        });
        return typeMap;
    };
    return IntrospectionFragmentMatcher;
}();
var $d7874048ca668ecb$var$hasOwn = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$DepTrackingCache = function() {
    function DepTrackingCache(data) {
        var _this = this;
        if (data === void 0) data = Object.create(null);
        this.data = data;
        this.depend = (0, $gLy2H.wrap)(function(dataId) {
            return _this.data[dataId];
        }, {
            disposable: true,
            makeCacheKey: function(dataId) {
                return dataId;
            }
        });
    }
    DepTrackingCache.prototype.toObject = function() {
        return this.data;
    };
    DepTrackingCache.prototype.get = function(dataId) {
        this.depend(dataId);
        return this.data[dataId];
    };
    DepTrackingCache.prototype.set = function(dataId, value) {
        var oldValue = this.data[dataId];
        if (value !== oldValue) {
            this.data[dataId] = value;
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.delete = function(dataId) {
        if ($d7874048ca668ecb$var$hasOwn.call(this.data, dataId)) {
            delete this.data[dataId];
            this.depend.dirty(dataId);
        }
    };
    DepTrackingCache.prototype.clear = function() {
        this.replace(null);
    };
    DepTrackingCache.prototype.replace = function(newData) {
        var _this = this;
        if (newData) {
            Object.keys(newData).forEach(function(dataId) {
                _this.set(dataId, newData[dataId]);
            });
            Object.keys(this.data).forEach(function(dataId) {
                if (!$d7874048ca668ecb$var$hasOwn.call(newData, dataId)) _this.delete(dataId);
            });
        } else Object.keys(this.data).forEach(function(dataId) {
            _this.delete(dataId);
        });
    };
    return DepTrackingCache;
}();
function $d7874048ca668ecb$var$defaultNormalizedCacheFactory(seed) {
    return new $d7874048ca668ecb$var$DepTrackingCache(seed);
}
var $d7874048ca668ecb$export$628ef07ba8965f12 = function() {
    function StoreReader(_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.cacheKeyRoot, cacheKeyRoot = _c === void 0 ? new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap)) : _c, _d = _b.freezeResults, freezeResults = _d === void 0 ? false : _d;
        var _e = this, executeStoreQuery = _e.executeStoreQuery, executeSelectionSet = _e.executeSelectionSet, executeSubSelectedArray = _e.executeSubSelectedArray;
        this.freezeResults = freezeResults;
        this.executeStoreQuery = (0, $gLy2H.wrap)(function(options) {
            return executeStoreQuery.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, fragmentMatcher = _a.fragmentMatcher;
                if (contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(contextValue.store, query, fragmentMatcher, JSON.stringify(variableValues), rootValue.id);
            }
        });
        this.executeSelectionSet = (0, $gLy2H.wrap)(function(options) {
            return executeSelectionSet.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, selectionSet, execContext.fragmentMatcher, JSON.stringify(execContext.variableValues), rootValue.id);
            }
        });
        this.executeSubSelectedArray = (0, $gLy2H.wrap)(function(options) {
            return executeSubSelectedArray.call(_this, options);
        }, {
            makeCacheKey: function(_a) {
                var field = _a.field, array = _a.array, execContext = _a.execContext;
                if (execContext.contextValue.store instanceof $d7874048ca668ecb$var$DepTrackingCache) return cacheKeyRoot.lookup(execContext.contextValue.store, field, array, JSON.stringify(execContext.variableValues));
            }
        });
    }
    StoreReader.prototype.readQueryFromStore = function(options) {
        return this.diffQueryAgainstStore((0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            returnPartialData: false
        })).result;
    };
    StoreReader.prototype.diffQueryAgainstStore = function(_a) {
        var store = _a.store, query = _a.query, variables = _a.variables, previousResult = _a.previousResult, _b = _a.returnPartialData, returnPartialData = _b === void 0 ? true : _b, _c = _a.rootId, rootId = _c === void 0 ? 'ROOT_QUERY' : _c, fragmentMatcherFunction = _a.fragmentMatcherFunction, config = _a.config;
        var queryDefinition = (0, $jojW6.getQueryDefinition)(query);
        variables = (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(queryDefinition), variables);
        var context = {
            store: store,
            dataIdFromObject: config && config.dataIdFromObject,
            cacheRedirects: config && config.cacheRedirects || {}
        };
        var execResult = this.executeStoreQuery({
            query: query,
            rootValue: {
                type: 'id',
                id: rootId,
                generated: true,
                typename: 'Query'
            },
            contextValue: context,
            variableValues: variables,
            fragmentMatcher: fragmentMatcherFunction
        });
        var hasMissingFields = execResult.missing && execResult.missing.length > 0;
        if (hasMissingFields && !returnPartialData) execResult.missing.forEach(function(info) {
            if (info.tolerable) return;
            throw new (0, $1DiV8.InvariantError)(8);
        });
        if (previousResult) {
            if ((0, $bqMzA.equal)(previousResult, execResult.result)) execResult.result = previousResult;
        }
        return {
            result: execResult.result,
            complete: !hasMissingFields
        };
    };
    StoreReader.prototype.executeStoreQuery = function(_a) {
        var query = _a.query, rootValue = _a.rootValue, contextValue = _a.contextValue, variableValues = _a.variableValues, _b = _a.fragmentMatcher, fragmentMatcher = _b === void 0 ? $d7874048ca668ecb$var$defaultFragmentMatcher : _b;
        var mainDefinition = (0, $jojW6.getMainDefinition)(query);
        var fragments = (0, $jojW6.getFragmentDefinitions)(query);
        var fragmentMap = (0, $jojW6.createFragmentMap)(fragments);
        var execContext = {
            query: query,
            fragmentMap: fragmentMap,
            contextValue: contextValue,
            variableValues: variableValues,
            fragmentMatcher: fragmentMatcher
        };
        return this.executeSelectionSet({
            selectionSet: mainDefinition.selectionSet,
            rootValue: rootValue,
            execContext: execContext
        });
    };
    StoreReader.prototype.executeSelectionSet = function(_a) {
        var _this = this;
        var selectionSet = _a.selectionSet, rootValue = _a.rootValue, execContext = _a.execContext;
        var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
        var finalResult = {
            result: null
        };
        var objectsToMerge = [];
        var object = contextValue.store.get(rootValue.id);
        var typename = object && object.__typename || rootValue.id === 'ROOT_QUERY' && 'Query' || void 0;
        function handleMissing(result) {
            var _a;
            if (result.missing) {
                finalResult.missing = finalResult.missing || [];
                (_a = finalResult.missing).push.apply(_a, result.missing);
            }
            return result.result;
        }
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var fieldResult = handleMissing(_this.executeField(object, typename, selection, execContext));
                if (typeof fieldResult !== 'undefined') objectsToMerge.push((_a = {}, _a[(0, $jojW6.resultKeyNameFromField)(selection)] = fieldResult, _a));
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = fragmentMap[selection.name.value];
                    if (!fragment) throw new (0, $1DiV8.InvariantError)(9);
                }
                var typeCondition = fragment.typeCondition && fragment.typeCondition.name.value;
                var match = !typeCondition || execContext.fragmentMatcher(rootValue, typeCondition, contextValue);
                if (match) {
                    var fragmentExecResult = _this.executeSelectionSet({
                        selectionSet: fragment.selectionSet,
                        rootValue: rootValue,
                        execContext: execContext
                    });
                    if (match === 'heuristic' && fragmentExecResult.missing) fragmentExecResult = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, fragmentExecResult), {
                        missing: fragmentExecResult.missing.map(function(info) {
                            return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, info), {
                                tolerable: true
                            });
                        })
                    });
                    objectsToMerge.push(handleMissing(fragmentExecResult));
                }
            }
        });
        finalResult.result = (0, $jojW6.mergeDeepArray)(objectsToMerge);
        this.freezeResults;
        return finalResult;
    };
    StoreReader.prototype.executeField = function(object, typename, field, execContext) {
        var variables = execContext.variableValues, contextValue = execContext.contextValue;
        var fieldName = field.name.value;
        var args = (0, $jojW6.argumentsObjectFromField)(field, variables);
        var info = {
            resultKey: (0, $jojW6.resultKeyNameFromField)(field),
            directives: (0, $jojW6.getDirectiveInfoFromField)(field, variables)
        };
        var readStoreResult = $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, contextValue, info);
        if (Array.isArray(readStoreResult.result)) return this.combineExecResults(readStoreResult, this.executeSubSelectedArray({
            field: field,
            array: readStoreResult.result,
            execContext: execContext
        }));
        if (!field.selectionSet) {
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, readStoreResult.result);
            this.freezeResults;
            return readStoreResult;
        }
        if (readStoreResult.result == null) return readStoreResult;
        return this.combineExecResults(readStoreResult, this.executeSelectionSet({
            selectionSet: field.selectionSet,
            rootValue: readStoreResult.result,
            execContext: execContext
        }));
    };
    StoreReader.prototype.combineExecResults = function() {
        var execResults = [];
        for(var _i = 0; _i < arguments.length; _i++)execResults[_i] = arguments[_i];
        var missing;
        execResults.forEach(function(execResult) {
            if (execResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, execResult.missing);
            }
        });
        return {
            result: execResults.pop().result,
            missing: missing
        };
    };
    StoreReader.prototype.executeSubSelectedArray = function(_a) {
        var _this = this;
        var field = _a.field, array = _a.array, execContext = _a.execContext;
        var missing;
        function handleMissing(childResult) {
            if (childResult.missing) {
                missing = missing || [];
                missing.push.apply(missing, childResult.missing);
            }
            return childResult.result;
        }
        array = array.map(function(item) {
            if (item === null) return null;
            if (Array.isArray(item)) return handleMissing(_this.executeSubSelectedArray({
                field: field,
                array: item,
                execContext: execContext
            }));
            if (field.selectionSet) return handleMissing(_this.executeSelectionSet({
                selectionSet: field.selectionSet,
                rootValue: item,
                execContext: execContext
            }));
            $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, item);
            return item;
        });
        this.freezeResults;
        return {
            result: array,
            missing: missing
        };
    };
    return StoreReader;
}();
function $d7874048ca668ecb$var$assertSelectionSetForIdValue(field, value) {
    if (!field.selectionSet && (0, $jojW6.isIdValue)(value)) throw new (0, $1DiV8.InvariantError)(10);
}
function $d7874048ca668ecb$var$defaultFragmentMatcher() {
    return true;
}
function $d7874048ca668ecb$export$7a4899fe13f33235(idValue) {
    (0, $1DiV8.invariant)((0, $jojW6.isIdValue)(idValue), 11);
}
function $d7874048ca668ecb$var$readStoreResolver(object, typename, fieldName, args, context, _a) {
    var resultKey = _a.resultKey, directives = _a.directives;
    var storeKeyName = fieldName;
    if (args || directives) storeKeyName = (0, $jojW6.getStoreKeyName)(storeKeyName, args, directives);
    var fieldValue = void 0;
    if (object) {
        fieldValue = object[storeKeyName];
        if (typeof fieldValue === 'undefined' && context.cacheRedirects && typeof typename === 'string') {
            var type = context.cacheRedirects[typename];
            if (type) {
                var resolver = type[fieldName];
                if (resolver) fieldValue = resolver(object, args, {
                    getCacheKey: function(storeObj) {
                        var id = context.dataIdFromObject(storeObj);
                        return id && (0, $jojW6.toIdValue)({
                            id: id,
                            typename: storeObj.__typename
                        });
                    }
                });
            }
        }
    }
    if (typeof fieldValue === 'undefined') return {
        result: fieldValue,
        missing: [
            {
                object: object,
                fieldName: storeKeyName,
                tolerable: false
            }
        ]
    };
    if ((0, $jojW6.isJsonValue)(fieldValue)) fieldValue = fieldValue.json;
    return {
        result: fieldValue
    };
}
var $d7874048ca668ecb$export$ee7258b8691956a3 = function() {
    function ObjectCache(data) {
        if (data === void 0) data = Object.create(null);
        this.data = data;
    }
    ObjectCache.prototype.toObject = function() {
        return this.data;
    };
    ObjectCache.prototype.get = function(dataId) {
        return this.data[dataId];
    };
    ObjectCache.prototype.set = function(dataId, value) {
        this.data[dataId] = value;
    };
    ObjectCache.prototype.delete = function(dataId) {
        this.data[dataId] = void 0;
    };
    ObjectCache.prototype.clear = function() {
        this.data = Object.create(null);
    };
    ObjectCache.prototype.replace = function(newData) {
        this.data = newData || Object.create(null);
    };
    return ObjectCache;
}();
function $d7874048ca668ecb$export$7e2b40d1002de152(seed) {
    return new $d7874048ca668ecb$export$ee7258b8691956a3(seed);
}
var $d7874048ca668ecb$export$de4e6870dc6ac801 = function(_super) {
    (0, $3VFsf.__extends)(WriteError, _super);
    function WriteError() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.type = 'WriteError';
        return _this;
    }
    return WriteError;
}(Error);
function $d7874048ca668ecb$export$fb86e3236e77e3(error, document) {
    var enhancedError = new $d7874048ca668ecb$export$de4e6870dc6ac801("Error writing result to store for query:\n " + JSON.stringify(document));
    enhancedError.message += '\n' + error.message;
    enhancedError.stack = error.stack;
    return enhancedError;
}
var $d7874048ca668ecb$export$eb8361c5d132fb8f = function() {
    function StoreWriter() {}
    StoreWriter.prototype.writeQueryToStore = function(_a) {
        var query = _a.query, result = _a.result, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        return this.writeResultToStore({
            dataId: 'ROOT_QUERY',
            result: result,
            document: query,
            store: store,
            variables: variables,
            dataIdFromObject: dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
    };
    StoreWriter.prototype.writeResultToStore = function(_a) {
        var dataId = _a.dataId, result = _a.result, document = _a.document, _b = _a.store, store = _b === void 0 ? $d7874048ca668ecb$var$defaultNormalizedCacheFactory() : _b, variables = _a.variables, dataIdFromObject = _a.dataIdFromObject, fragmentMatcherFunction = _a.fragmentMatcherFunction;
        var operationDefinition = (0, $jojW6.getOperationDefinition)(document);
        try {
            return this.writeSelectionSetToStore({
                result: result,
                dataId: dataId,
                selectionSet: operationDefinition.selectionSet,
                context: {
                    store: store,
                    processedData: {},
                    variables: (0, $jojW6.assign)({}, (0, $jojW6.getDefaultValues)(operationDefinition), variables),
                    dataIdFromObject: dataIdFromObject,
                    fragmentMap: (0, $jojW6.createFragmentMap)((0, $jojW6.getFragmentDefinitions)(document)),
                    fragmentMatcherFunction: fragmentMatcherFunction
                }
            });
        } catch (e) {
            throw $d7874048ca668ecb$export$fb86e3236e77e3(e, document);
        }
    };
    StoreWriter.prototype.writeSelectionSetToStore = function(_a) {
        var _this = this;
        var result = _a.result, dataId = _a.dataId, selectionSet = _a.selectionSet, context = _a.context;
        var variables = context.variables, store = context.store, fragmentMap = context.fragmentMap;
        selectionSet.selections.forEach(function(selection) {
            var _a;
            if (!(0, $jojW6.shouldInclude)(selection, variables)) return;
            if ((0, $jojW6.isField)(selection)) {
                var resultFieldKey = (0, $jojW6.resultKeyNameFromField)(selection);
                var value = result[resultFieldKey];
                if (typeof value !== 'undefined') _this.writeFieldToStore({
                    dataId: dataId,
                    value: value,
                    field: selection,
                    context: context
                });
                else {
                    var isDefered = false;
                    var isClient = false;
                    if (selection.directives && selection.directives.length) {
                        isDefered = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'defer';
                        });
                        isClient = selection.directives.some(function(directive) {
                            return directive.name && directive.name.value === 'client';
                        });
                    }
                    !isDefered && !isClient && context.fragmentMatcherFunction;
                }
            } else {
                var fragment = void 0;
                if ((0, $jojW6.isInlineFragment)(selection)) fragment = selection;
                else {
                    fragment = (fragmentMap || {})[selection.name.value];
                    (0, $1DiV8.invariant)(fragment, 3);
                }
                var matches = true;
                if (context.fragmentMatcherFunction && fragment.typeCondition) {
                    var id = dataId || 'self';
                    var idValue = (0, $jojW6.toIdValue)({
                        id: id,
                        typename: undefined
                    });
                    var fakeContext = {
                        store: new $d7874048ca668ecb$export$ee7258b8691956a3((_a = {}, _a[id] = result, _a)),
                        cacheRedirects: {}
                    };
                    var match = context.fragmentMatcherFunction(idValue, fragment.typeCondition.name.value, fakeContext);
                    !(0, $jojW6.isProduction)() && match;
                    matches = !!match;
                }
                if (matches) _this.writeSelectionSetToStore({
                    result: result,
                    selectionSet: fragment.selectionSet,
                    dataId: dataId,
                    context: context
                });
            }
        });
        return store;
    };
    StoreWriter.prototype.writeFieldToStore = function(_a) {
        var _b;
        var field = _a.field, value = _a.value, dataId = _a.dataId, context = _a.context;
        var variables = context.variables, dataIdFromObject = context.dataIdFromObject, store = context.store;
        var storeValue;
        var storeObject;
        var storeFieldName = (0, $jojW6.storeKeyNameFromField)(field, variables);
        if (!field.selectionSet || value === null) storeValue = value != null && typeof value === 'object' ? {
            type: 'json',
            json: value
        } : value;
        else if (Array.isArray(value)) {
            var generatedId = dataId + "." + storeFieldName;
            storeValue = this.processArrayValue(value, generatedId, field.selectionSet, context);
        } else {
            var valueDataId = dataId + "." + storeFieldName;
            var generated = true;
            if (!$d7874048ca668ecb$var$isGeneratedId(valueDataId)) valueDataId = '$' + valueDataId;
            if (dataIdFromObject) {
                var semanticId = dataIdFromObject(value);
                (0, $1DiV8.invariant)(!semanticId || !$d7874048ca668ecb$var$isGeneratedId(semanticId), 4);
                if (semanticId || typeof semanticId === 'number' && semanticId === 0) {
                    valueDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(valueDataId, field, context.processedData)) this.writeSelectionSetToStore({
                dataId: valueDataId,
                result: value,
                selectionSet: field.selectionSet,
                context: context
            });
            var typename = value.__typename;
            storeValue = (0, $jojW6.toIdValue)({
                id: valueDataId,
                typename: typename
            }, generated);
            storeObject = store.get(dataId);
            var escapedId = storeObject && storeObject[storeFieldName];
            if (escapedId !== storeValue && (0, $jojW6.isIdValue)(escapedId)) {
                var hadTypename = escapedId.typename !== undefined;
                var hasTypename = typename !== undefined;
                var typenameChanged = hadTypename && hasTypename && escapedId.typename !== typename;
                (0, $1DiV8.invariant)(!generated || escapedId.generated || typenameChanged, 5);
                (0, $1DiV8.invariant)(!hadTypename || hasTypename, 6);
                if (escapedId.generated) {
                    if (typenameChanged) {
                        if (!generated) store.delete(escapedId.id);
                    } else $d7874048ca668ecb$var$mergeWithGenerated(escapedId.id, storeValue.id, store);
                }
            }
        }
        storeObject = store.get(dataId);
        if (!storeObject || !(0, $bqMzA.equal)(storeValue, storeObject[storeFieldName])) store.set(dataId, (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, storeObject), (_b = {}, _b[storeFieldName] = storeValue, _b)));
    };
    StoreWriter.prototype.processArrayValue = function(value, generatedId, selectionSet, context) {
        var _this = this;
        return value.map(function(item, index) {
            if (item === null) return null;
            var itemDataId = generatedId + "." + index;
            if (Array.isArray(item)) return _this.processArrayValue(item, itemDataId, selectionSet, context);
            var generated = true;
            if (context.dataIdFromObject) {
                var semanticId = context.dataIdFromObject(item);
                if (semanticId) {
                    itemDataId = semanticId;
                    generated = false;
                }
            }
            if (!$d7874048ca668ecb$var$isDataProcessed(itemDataId, selectionSet, context.processedData)) _this.writeSelectionSetToStore({
                dataId: itemDataId,
                result: item,
                selectionSet: selectionSet,
                context: context
            });
            return (0, $jojW6.toIdValue)({
                id: itemDataId,
                typename: item.__typename
            }, generated);
        });
    };
    return StoreWriter;
}();
function $d7874048ca668ecb$var$isGeneratedId(id) {
    return id[0] === '$';
}
function $d7874048ca668ecb$var$mergeWithGenerated(generatedKey, realKey, cache) {
    if (generatedKey === realKey) return false;
    var generated = cache.get(generatedKey);
    var real = cache.get(realKey);
    var madeChanges = false;
    Object.keys(generated).forEach(function(key) {
        var value = generated[key];
        var realValue = real[key];
        if ((0, $jojW6.isIdValue)(value) && $d7874048ca668ecb$var$isGeneratedId(value.id) && (0, $jojW6.isIdValue)(realValue) && !(0, $bqMzA.equal)(value, realValue) && $d7874048ca668ecb$var$mergeWithGenerated(value.id, realValue.id, cache)) madeChanges = true;
    });
    cache.delete(generatedKey);
    var newRealValue = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, generated), real);
    if ((0, $bqMzA.equal)(newRealValue, real)) return madeChanges;
    cache.set(realKey, newRealValue);
    return true;
}
function $d7874048ca668ecb$var$isDataProcessed(dataId, field, processedData) {
    if (!processedData) return false;
    if (processedData[dataId]) {
        if (processedData[dataId].indexOf(field) >= 0) return true;
        else processedData[dataId].push(field);
    } else processedData[dataId] = [
        field
    ];
    return false;
}
var $d7874048ca668ecb$var$defaultConfig = {
    fragmentMatcher: new $d7874048ca668ecb$export$5d3fcf53267091de(),
    dataIdFromObject: $d7874048ca668ecb$export$bd03c5a9c99d6bce,
    addTypename: true,
    resultCaching: true,
    freezeResults: false
};
function $d7874048ca668ecb$export$bd03c5a9c99d6bce(result) {
    if (result.__typename) {
        if (result.id !== undefined) return result.__typename + ":" + result.id;
        if (result._id !== undefined) return result.__typename + ":" + result._id;
    }
    return null;
}
var $d7874048ca668ecb$var$hasOwn$1 = Object.prototype.hasOwnProperty;
var $d7874048ca668ecb$var$OptimisticCacheLayer = function(_super) {
    (0, $3VFsf.__extends)(OptimisticCacheLayer, _super);
    function OptimisticCacheLayer(optimisticId, parent, transaction) {
        var _this = _super.call(this, Object.create(null)) || this;
        _this.optimisticId = optimisticId;
        _this.parent = parent;
        _this.transaction = transaction;
        return _this;
    }
    OptimisticCacheLayer.prototype.toObject = function() {
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.parent.toObject()), this.data);
    };
    OptimisticCacheLayer.prototype.get = function(dataId) {
        return $d7874048ca668ecb$var$hasOwn$1.call(this.data, dataId) ? this.data[dataId] : this.parent.get(dataId);
    };
    return OptimisticCacheLayer;
}($d7874048ca668ecb$export$ee7258b8691956a3);
var $d7874048ca668ecb$export$467265324939f47f = function(_super) {
    (0, $3VFsf.__extends)(InMemoryCache, _super);
    function InMemoryCache(config) {
        if (config === void 0) config = {};
        var _this = _super.call(this) || this;
        _this.watches = new Set();
        _this.typenameDocumentCache = new Map();
        _this.cacheKeyRoot = new (0, $gLy2H.KeyTrie)((0, $jojW6.canUseWeakMap));
        _this.silenceBroadcast = false;
        _this.config = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, $d7874048ca668ecb$var$defaultConfig), config);
        if (_this.config.customResolvers) _this.config.cacheRedirects = _this.config.customResolvers;
        if (_this.config.cacheResolvers) _this.config.cacheRedirects = _this.config.cacheResolvers;
        _this.addTypename = !!_this.config.addTypename;
        _this.data = _this.config.resultCaching ? new $d7874048ca668ecb$var$DepTrackingCache() : new $d7874048ca668ecb$export$ee7258b8691956a3();
        _this.optimisticData = _this.data;
        _this.storeWriter = new $d7874048ca668ecb$export$eb8361c5d132fb8f();
        _this.storeReader = new $d7874048ca668ecb$export$628ef07ba8965f12({
            cacheKeyRoot: _this.cacheKeyRoot,
            freezeResults: config.freezeResults
        });
        var cache = _this;
        var maybeBroadcastWatch = cache.maybeBroadcastWatch;
        _this.maybeBroadcastWatch = (0, $gLy2H.wrap)(function(c) {
            return maybeBroadcastWatch.call(_this, c);
        }, {
            makeCacheKey: function(c) {
                if (c.optimistic) return;
                if (c.previousResult) return;
                if (cache.data instanceof $d7874048ca668ecb$var$DepTrackingCache) return cache.cacheKeyRoot.lookup(c.query, JSON.stringify(c.variables));
            }
        });
        return _this;
    }
    InMemoryCache.prototype.restore = function(data) {
        if (data) this.data.replace(data);
        return this;
    };
    InMemoryCache.prototype.extract = function(optimistic) {
        if (optimistic === void 0) optimistic = false;
        return (optimistic ? this.optimisticData : this.data).toObject();
    };
    InMemoryCache.prototype.read = function(options) {
        if (typeof options.rootId === 'string' && typeof this.data.get(options.rootId) === 'undefined') return null;
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.readQueryFromStore({
            store: options.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(options.query),
            variables: options.variables,
            rootId: options.rootId,
            fragmentMatcherFunction: fragmentMatcherFunction,
            previousResult: options.previousResult,
            config: this.config
        }) || null;
    };
    InMemoryCache.prototype.write = function(write) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        this.storeWriter.writeResultToStore({
            dataId: write.dataId,
            result: write.result,
            variables: write.variables,
            document: this.transformDocument(write.query),
            store: this.data,
            dataIdFromObject: this.config.dataIdFromObject,
            fragmentMatcherFunction: fragmentMatcherFunction
        });
        this.broadcastWatches();
    };
    InMemoryCache.prototype.diff = function(query) {
        var fragmentMatcher = this.config.fragmentMatcher;
        var fragmentMatcherFunction = fragmentMatcher && fragmentMatcher.match;
        return this.storeReader.diffQueryAgainstStore({
            store: query.optimistic ? this.optimisticData : this.data,
            query: this.transformDocument(query.query),
            variables: query.variables,
            returnPartialData: query.returnPartialData,
            previousResult: query.previousResult,
            fragmentMatcherFunction: fragmentMatcherFunction,
            config: this.config
        });
    };
    InMemoryCache.prototype.watch = function(watch) {
        var _this = this;
        this.watches.add(watch);
        return function() {
            _this.watches.delete(watch);
        };
    };
    InMemoryCache.prototype.evict = function(query) {
        throw new (0, $1DiV8.InvariantError)(7);
    };
    InMemoryCache.prototype.reset = function() {
        this.data.clear();
        this.broadcastWatches();
        return Promise.resolve();
    };
    InMemoryCache.prototype.removeOptimistic = function(idToRemove) {
        var toReapply = [];
        var removedCount = 0;
        var layer = this.optimisticData;
        while(layer instanceof $d7874048ca668ecb$var$OptimisticCacheLayer){
            if (layer.optimisticId === idToRemove) ++removedCount;
            else toReapply.push(layer);
            layer = layer.parent;
        }
        if (removedCount > 0) {
            this.optimisticData = layer;
            while(toReapply.length > 0){
                var layer_1 = toReapply.pop();
                this.performTransaction(layer_1.transaction, layer_1.optimisticId);
            }
            this.broadcastWatches();
        }
    };
    InMemoryCache.prototype.performTransaction = function(transaction, optimisticId) {
        var _a = this, data = _a.data, silenceBroadcast = _a.silenceBroadcast;
        this.silenceBroadcast = true;
        if (typeof optimisticId === 'string') this.data = this.optimisticData = new $d7874048ca668ecb$var$OptimisticCacheLayer(optimisticId, this.optimisticData, transaction);
        try {
            transaction(this);
        } finally{
            this.silenceBroadcast = silenceBroadcast;
            this.data = data;
        }
        this.broadcastWatches();
    };
    InMemoryCache.prototype.recordOptimisticTransaction = function(transaction, id) {
        return this.performTransaction(transaction, id);
    };
    InMemoryCache.prototype.transformDocument = function(document) {
        if (this.addTypename) {
            var result = this.typenameDocumentCache.get(document);
            if (!result) {
                result = (0, $jojW6.addTypenameToDocument)(document);
                this.typenameDocumentCache.set(document, result);
                this.typenameDocumentCache.set(result, result);
            }
            return result;
        }
        return document;
    };
    InMemoryCache.prototype.broadcastWatches = function() {
        var _this = this;
        if (!this.silenceBroadcast) this.watches.forEach(function(c) {
            return _this.maybeBroadcastWatch(c);
        });
    };
    InMemoryCache.prototype.maybeBroadcastWatch = function(c) {
        c.callback(this.diff({
            query: c.query,
            variables: c.variables,
            previousResult: c.previousResult && c.previousResult(),
            optimistic: c.optimistic
        }));
    };
    return InMemoryCache;
}((0, $hzuXv.ApolloCache));

});
parcelRegister("hzuXv", function(module, exports) {

$parcel$export(module.exports, "ApolloCache", () => $ccadb856bf057658$export$5fc74f25506aa9c);

var $jojW6 = parcelRequire("jojW6");
function $ccadb856bf057658$var$queryFromPojo(obj) {
    var op = {
        kind: 'OperationDefinition',
        operation: 'query',
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            op
        ]
    };
    return out;
}
function $ccadb856bf057658$var$fragmentFromPojo(obj, typename) {
    var frag = {
        kind: 'FragmentDefinition',
        typeCondition: {
            kind: 'NamedType',
            name: {
                kind: 'Name',
                value: typename || '__FakeType'
            }
        },
        name: {
            kind: 'Name',
            value: 'GeneratedClientQuery'
        },
        selectionSet: $ccadb856bf057658$var$selectionSetFromObj(obj)
    };
    var out = {
        kind: 'Document',
        definitions: [
            frag
        ]
    };
    return out;
}
function $ccadb856bf057658$var$selectionSetFromObj(obj) {
    if (typeof obj === 'number' || typeof obj === 'boolean' || typeof obj === 'string' || typeof obj === 'undefined' || obj === null) return null;
    if (Array.isArray(obj)) return $ccadb856bf057658$var$selectionSetFromObj(obj[0]);
    var selections = [];
    Object.keys(obj).forEach(function(key) {
        var nestedSelSet = $ccadb856bf057658$var$selectionSetFromObj(obj[key]);
        var field = {
            kind: 'Field',
            name: {
                kind: 'Name',
                value: key
            },
            selectionSet: nestedSelSet || undefined
        };
        selections.push(field);
    });
    var selectionSet = {
        kind: 'SelectionSet',
        selections: selections
    };
    return selectionSet;
}
var $ccadb856bf057658$var$justTypenameQuery = {
    kind: 'Document',
    definitions: [
        {
            kind: 'OperationDefinition',
            operation: 'query',
            name: null,
            variableDefinitions: null,
            directives: [],
            selectionSet: {
                kind: 'SelectionSet',
                selections: [
                    {
                        kind: 'Field',
                        alias: null,
                        name: {
                            kind: 'Name',
                            value: '__typename'
                        },
                        arguments: [],
                        directives: [],
                        selectionSet: null
                    }
                ]
            }
        }
    ]
};
var $ccadb856bf057658$export$5fc74f25506aa9c = function() {
    function ApolloCache() {}
    ApolloCache.prototype.transformDocument = function(document) {
        return document;
    };
    ApolloCache.prototype.transformForLink = function(document) {
        return document;
    };
    ApolloCache.prototype.readQuery = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: options.query,
            variables: options.variables,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.readFragment = function(options, optimistic) {
        if (optimistic === void 0) optimistic = false;
        return this.read({
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName),
            variables: options.variables,
            rootId: options.id,
            optimistic: optimistic
        });
    };
    ApolloCache.prototype.writeQuery = function(options) {
        this.write({
            dataId: 'ROOT_QUERY',
            result: options.data,
            query: options.query,
            variables: options.variables
        });
    };
    ApolloCache.prototype.writeFragment = function(options) {
        this.write({
            dataId: options.id,
            result: options.data,
            variables: options.variables,
            query: (0, $jojW6.getFragmentQueryDocument)(options.fragment, options.fragmentName)
        });
    };
    ApolloCache.prototype.writeData = function(_a) {
        var id = _a.id, data = _a.data;
        if (typeof id !== 'undefined') {
            var typenameResult = null;
            try {
                typenameResult = this.read({
                    rootId: id,
                    optimistic: false,
                    query: $ccadb856bf057658$var$justTypenameQuery
                });
            } catch (e) {}
            var __typename = typenameResult && typenameResult.__typename || '__ClientData';
            var dataToWrite = Object.assign({
                __typename: __typename
            }, data);
            this.writeFragment({
                id: id,
                fragment: $ccadb856bf057658$var$fragmentFromPojo(dataToWrite, __typename),
                data: dataToWrite
            });
        } else this.writeQuery({
            query: $ccadb856bf057658$var$queryFromPojo(data),
            data: data
        });
    };
    return ApolloCache;
}();
var $ccadb856bf057658$export$94affb487e701bf2;
$ccadb856bf057658$export$94affb487e701bf2 || ($ccadb856bf057658$export$94affb487e701bf2 = {});

});

parcelRegister("gLy2H", function(module, exports) {

$parcel$export(module.exports, "KeyTrie", () => $c34b71496108423e$export$6bd8d8299be3ac82);
$parcel$export(module.exports, "wrap", () => $c34b71496108423e$export$4997ffc0176396a6);

var $jFbNy = parcelRequire("jFbNy");
function $c34b71496108423e$var$defaultDispose() {}
var $c34b71496108423e$var$Cache = /** @class */ function() {
    function Cache(max, dispose) {
        if (max === void 0) max = Infinity;
        if (dispose === void 0) dispose = $c34b71496108423e$var$defaultDispose;
        this.max = max;
        this.dispose = dispose;
        this.map = new Map();
        this.newest = null;
        this.oldest = null;
    }
    Cache.prototype.has = function(key) {
        return this.map.has(key);
    };
    Cache.prototype.get = function(key) {
        var entry = this.getEntry(key);
        return entry && entry.value;
    };
    Cache.prototype.getEntry = function(key) {
        var entry = this.map.get(key);
        if (entry && entry !== this.newest) {
            var older = entry.older, newer = entry.newer;
            if (newer) newer.older = older;
            if (older) older.newer = newer;
            entry.older = this.newest;
            entry.older.newer = entry;
            entry.newer = null;
            this.newest = entry;
            if (entry === this.oldest) this.oldest = newer;
        }
        return entry;
    };
    Cache.prototype.set = function(key, value) {
        var entry = this.getEntry(key);
        if (entry) return entry.value = value;
        entry = {
            key: key,
            value: value,
            newer: null,
            older: this.newest
        };
        if (this.newest) this.newest.newer = entry;
        this.newest = entry;
        this.oldest = this.oldest || entry;
        this.map.set(key, entry);
        return entry.value;
    };
    Cache.prototype.clean = function() {
        while(this.oldest && this.map.size > this.max)this.delete(this.oldest.key);
    };
    Cache.prototype.delete = function(key) {
        var entry = this.map.get(key);
        if (entry) {
            if (entry === this.newest) this.newest = entry.older;
            if (entry === this.oldest) this.oldest = entry.newer;
            if (entry.newer) entry.newer.older = entry.older;
            if (entry.older) entry.older.newer = entry.newer;
            this.map.delete(key);
            this.dispose(entry.value, key);
            return true;
        }
        return false;
    };
    return Cache;
}();
var $c34b71496108423e$var$parentEntrySlot = new (0, $jFbNy.Slot)();
var $c34b71496108423e$var$reusableEmptyArray = [];
var $c34b71496108423e$var$emptySetPool = [];
var $c34b71496108423e$var$POOL_TARGET_SIZE = 100;
// Since this package might be used browsers, we should avoid using the
// Node built-in assert module.
function $c34b71496108423e$var$assert(condition, optionalMessage) {
    if (!condition) throw new Error(optionalMessage || "assertion failure");
}
function $c34b71496108423e$var$valueIs(a, b) {
    var len = a.length;
    return(// Unknown values are not equal to each other.
    len > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    len === b.length && // The underlying value or exception must be the same.
    a[len - 1] === b[len - 1]);
}
function $c34b71496108423e$var$valueGet(value) {
    switch(value.length){
        case 0:
            throw new Error("unknown value");
        case 1:
            return value[0];
        case 2:
            throw value[1];
    }
}
function $c34b71496108423e$var$valueCopy(value) {
    return value.slice(0);
}
var $c34b71496108423e$var$Entry = /** @class */ function() {
    function Entry(fn, args) {
        this.fn = fn;
        this.args = args;
        this.parents = new Set();
        this.childValues = new Map();
        // When this Entry has children that are dirty, this property becomes
        // a Set containing other Entry objects, borrowed from emptySetPool.
        // When the set becomes empty, it gets recycled back to emptySetPool.
        this.dirtyChildren = null;
        this.dirty = true;
        this.recomputing = false;
        this.value = [];
        ++Entry.count;
    }
    // This is the most important method of the Entry API, because it
    // determines whether the cached this.value can be returned immediately,
    // or must be recomputed. The overall performance of the caching system
    // depends on the truth of the following observations: (1) this.dirty is
    // usually false, (2) this.dirtyChildren is usually null/empty, and thus
    // (3) valueGet(this.value) is usually returned without recomputation.
    Entry.prototype.recompute = function() {
        $c34b71496108423e$var$assert(!this.recomputing, "already recomputing");
        if (!$c34b71496108423e$var$rememberParent(this) && $c34b71496108423e$var$maybeReportOrphan(this)) // The recipient of the entry.reportOrphan callback decided to dispose
        // of this orphan entry by calling entry.dispose(), so we don't need to
        // (and should not) proceed with the recomputation.
        return void 0;
        return $c34b71496108423e$var$mightBeDirty(this) ? $c34b71496108423e$var$reallyRecompute(this) : $c34b71496108423e$var$valueGet(this.value);
    };
    Entry.prototype.setDirty = function() {
        if (this.dirty) return;
        this.dirty = true;
        this.value.length = 0;
        $c34b71496108423e$var$reportDirty(this);
        // We can go ahead and unsubscribe here, since any further dirty
        // notifications we receive will be redundant, and unsubscribing may
        // free up some resources, e.g. file watchers.
        $c34b71496108423e$var$maybeUnsubscribe(this);
    };
    Entry.prototype.dispose = function() {
        var _this = this;
        $c34b71496108423e$var$forgetChildren(this).forEach($c34b71496108423e$var$maybeReportOrphan);
        $c34b71496108423e$var$maybeUnsubscribe(this);
        // Because this entry has been kicked out of the cache (in index.js),
        // we've lost the ability to find out if/when this entry becomes dirty,
        // whether that happens through a subscription, because of a direct call
        // to entry.setDirty(), or because one of its children becomes dirty.
        // Because of this loss of future information, we have to assume the
        // worst (that this entry might have become dirty very soon), so we must
        // immediately mark this entry's parents as dirty. Normally we could
        // just call entry.setDirty() rather than calling parent.setDirty() for
        // each parent, but that would leave this entry in parent.childValues
        // and parent.dirtyChildren, which would prevent the child from being
        // truly forgotten.
        this.parents.forEach(function(parent) {
            parent.setDirty();
            $c34b71496108423e$var$forgetChild(parent, _this);
        });
    };
    Entry.count = 0;
    return Entry;
}();
function $c34b71496108423e$var$rememberParent(child) {
    var parent = $c34b71496108423e$var$parentEntrySlot.getValue();
    if (parent) {
        child.parents.add(parent);
        if (!parent.childValues.has(child)) parent.childValues.set(child, []);
        if ($c34b71496108423e$var$mightBeDirty(child)) $c34b71496108423e$var$reportDirtyChild(parent, child);
        else $c34b71496108423e$var$reportCleanChild(parent, child);
        return parent;
    }
}
function $c34b71496108423e$var$reallyRecompute(entry) {
    // Since this recomputation is likely to re-remember some of this
    // entry's children, we forget our children here but do not call
    // maybeReportOrphan until after the recomputation finishes.
    var originalChildren = $c34b71496108423e$var$forgetChildren(entry);
    // Set entry as the parent entry while calling recomputeNewValue(entry).
    $c34b71496108423e$var$parentEntrySlot.withValue(entry, $c34b71496108423e$var$recomputeNewValue, [
        entry
    ]);
    if ($c34b71496108423e$var$maybeSubscribe(entry)) // If we successfully recomputed entry.value and did not fail to
    // (re)subscribe, then this Entry is no longer explicitly dirty.
    $c34b71496108423e$var$setClean(entry);
    // Now that we've had a chance to re-remember any children that were
    // involved in the recomputation, we can safely report any orphan
    // children that remain.
    originalChildren.forEach($c34b71496108423e$var$maybeReportOrphan);
    return $c34b71496108423e$var$valueGet(entry.value);
}
function $c34b71496108423e$var$recomputeNewValue(entry) {
    entry.recomputing = true;
    // Set entry.value as unknown.
    entry.value.length = 0;
    try {
        // If entry.fn succeeds, entry.value will become a normal Value.
        entry.value[0] = entry.fn.apply(null, entry.args);
    } catch (e) {
        // If entry.fn throws, entry.value will become exceptional.
        entry.value[1] = e;
    }
    // Either way, this line is always reached.
    entry.recomputing = false;
}
function $c34b71496108423e$var$mightBeDirty(entry) {
    return entry.dirty || !!(entry.dirtyChildren && entry.dirtyChildren.size);
}
function $c34b71496108423e$var$setClean(entry) {
    entry.dirty = false;
    if ($c34b71496108423e$var$mightBeDirty(entry)) // This Entry may still have dirty children, in which case we can't
    // let our parents know we're clean just yet.
    return;
    $c34b71496108423e$var$reportClean(entry);
}
function $c34b71496108423e$var$reportDirty(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportDirtyChild(parent, child);
    });
}
function $c34b71496108423e$var$reportClean(child) {
    child.parents.forEach(function(parent) {
        return $c34b71496108423e$var$reportCleanChild(parent, child);
    });
}
// Let a parent Entry know that one of its children may be dirty.
function $c34b71496108423e$var$reportDirtyChild(parent, child) {
    // Must have called rememberParent(child) before calling
    // reportDirtyChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert($c34b71496108423e$var$mightBeDirty(child));
    if (!parent.dirtyChildren) parent.dirtyChildren = $c34b71496108423e$var$emptySetPool.pop() || new Set;
    else if (parent.dirtyChildren.has(child)) // If we already know this child is dirty, then we must have already
    // informed our own parents that we are dirty, so we can terminate
    // the recursion early.
    return;
    parent.dirtyChildren.add(child);
    $c34b71496108423e$var$reportDirty(parent);
}
// Let a parent Entry know that one of its children is no longer dirty.
function $c34b71496108423e$var$reportCleanChild(parent, child) {
    // Must have called rememberChild(child) before calling
    // reportCleanChild(parent, child).
    $c34b71496108423e$var$assert(parent.childValues.has(child));
    $c34b71496108423e$var$assert(!$c34b71496108423e$var$mightBeDirty(child));
    var childValue = parent.childValues.get(child);
    if (childValue.length === 0) parent.childValues.set(child, $c34b71496108423e$var$valueCopy(child.value));
    else if (!$c34b71496108423e$var$valueIs(childValue, child.value)) parent.setDirty();
    $c34b71496108423e$var$removeDirtyChild(parent, child);
    if ($c34b71496108423e$var$mightBeDirty(parent)) return;
    $c34b71496108423e$var$reportClean(parent);
}
function $c34b71496108423e$var$removeDirtyChild(parent, child) {
    var dc = parent.dirtyChildren;
    if (dc) {
        dc.delete(child);
        if (dc.size === 0) {
            if ($c34b71496108423e$var$emptySetPool.length < $c34b71496108423e$var$POOL_TARGET_SIZE) $c34b71496108423e$var$emptySetPool.push(dc);
            parent.dirtyChildren = null;
        }
    }
}
// If the given entry has a reportOrphan method, and no remaining parents,
// call entry.reportOrphan and return true iff it returns true. The
// reportOrphan function should return true to indicate entry.dispose()
// has been called, and the entry has been removed from any other caches
// (see index.js for the only current example).
function $c34b71496108423e$var$maybeReportOrphan(entry) {
    return entry.parents.size === 0 && typeof entry.reportOrphan === "function" && entry.reportOrphan() === true;
}
// Removes all children from this entry and returns an array of the
// removed children.
function $c34b71496108423e$var$forgetChildren(parent) {
    var children = $c34b71496108423e$var$reusableEmptyArray;
    if (parent.childValues.size > 0) {
        children = [];
        parent.childValues.forEach(function(_value, child) {
            $c34b71496108423e$var$forgetChild(parent, child);
            children.push(child);
        });
    }
    // After we forget all our children, this.dirtyChildren must be empty
    // and therefore must have been reset to null.
    $c34b71496108423e$var$assert(parent.dirtyChildren === null);
    return children;
}
function $c34b71496108423e$var$forgetChild(parent, child) {
    child.parents.delete(parent);
    parent.childValues.delete(child);
    $c34b71496108423e$var$removeDirtyChild(parent, child);
}
function $c34b71496108423e$var$maybeSubscribe(entry) {
    if (typeof entry.subscribe === "function") try {
        $c34b71496108423e$var$maybeUnsubscribe(entry); // Prevent double subscriptions.
        entry.unsubscribe = entry.subscribe.apply(null, entry.args);
    } catch (e) {
        // If this Entry has a subscribe function and it threw an exception
        // (or an unsubscribe function it previously returned now throws),
        // return false to indicate that we were not able to subscribe (or
        // unsubscribe), and this Entry should remain dirty.
        entry.setDirty();
        return false;
    }
    // Returning true indicates either that there was no entry.subscribe
    // function or that it succeeded.
    return true;
}
function $c34b71496108423e$var$maybeUnsubscribe(entry) {
    var unsubscribe = entry.unsubscribe;
    if (typeof unsubscribe === "function") {
        entry.unsubscribe = void 0;
        unsubscribe();
    }
}
// A trie data structure that holds object keys weakly, yet can also hold
// non-object keys, unlike the native `WeakMap`.
var $c34b71496108423e$export$6bd8d8299be3ac82 = /** @class */ function() {
    function KeyTrie(weakness) {
        this.weakness = weakness;
    }
    KeyTrie.prototype.lookup = function() {
        var array = [];
        for(var _i = 0; _i < arguments.length; _i++)array[_i] = arguments[_i];
        return this.lookupArray(array);
    };
    KeyTrie.prototype.lookupArray = function(array) {
        var node = this;
        array.forEach(function(key) {
            return node = node.getChildTrie(key);
        });
        return node.data || (node.data = Object.create(null));
    };
    KeyTrie.prototype.getChildTrie = function(key) {
        var map = this.weakness && $c34b71496108423e$var$isObjRef(key) ? this.weak || (this.weak = new WeakMap()) : this.strong || (this.strong = new Map());
        var child = map.get(key);
        if (!child) map.set(key, child = new KeyTrie(this.weakness));
        return child;
    };
    return KeyTrie;
}();
function $c34b71496108423e$var$isObjRef(value) {
    switch(typeof value){
        case "object":
            if (value === null) break;
        // Fall through to return true...
        case "function":
            return true;
    }
    return false;
}
// The defaultMakeCacheKey function is remarkably powerful, because it gives
// a unique object for any shallow-identical list of arguments. If you need
// to implement a custom makeCacheKey function, you may find it helpful to
// delegate the final work to defaultMakeCacheKey, which is why we export it
// here. However, you may want to avoid defaultMakeCacheKey if your runtime
// does not support WeakMap, or you have the ability to return a string key.
// In those cases, just write your own custom makeCacheKey functions.
var $c34b71496108423e$var$keyTrie = new $c34b71496108423e$export$6bd8d8299be3ac82(typeof WeakMap === "function");
function $c34b71496108423e$export$cd3144f8dd136006() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    return $c34b71496108423e$var$keyTrie.lookupArray(args);
}
var $c34b71496108423e$var$caches = new Set();
function $c34b71496108423e$export$4997ffc0176396a6(originalFunction, options) {
    if (options === void 0) options = Object.create(null);
    var cache = new $c34b71496108423e$var$Cache(options.max || Math.pow(2, 16), function(entry) {
        return entry.dispose();
    });
    var disposable = !!options.disposable;
    var makeCacheKey = options.makeCacheKey || $c34b71496108423e$export$cd3144f8dd136006;
    function optimistic() {
        if (disposable && !$c34b71496108423e$var$parentEntrySlot.hasValue()) // If there's no current parent computation, and this wrapped
        // function is disposable (meaning we don't care about entry.value,
        // just dependency tracking), then we can short-cut everything else
        // in this function, because entry.recompute() is going to recycle
        // the entry object without recomputing anything, anyway.
        return void 0;
        var key = makeCacheKey.apply(null, arguments);
        if (key === void 0) return originalFunction.apply(null, arguments);
        var args = Array.prototype.slice.call(arguments);
        var entry = cache.get(key);
        if (entry) entry.args = args;
        else {
            entry = new $c34b71496108423e$var$Entry(originalFunction, args);
            cache.set(key, entry);
            entry.subscribe = options.subscribe;
            if (disposable) entry.reportOrphan = function() {
                return cache.delete(key);
            };
        }
        var value = entry.recompute();
        // Move this entry to the front of the least-recently used queue,
        // since we just finished computing its value.
        cache.set(key, entry);
        $c34b71496108423e$var$caches.add(cache);
        // Clean up any excess entries in the cache, but only if there is no
        // active parent entry, meaning we're not in the middle of a larger
        // computation that might be flummoxed by the cleaning.
        if (!$c34b71496108423e$var$parentEntrySlot.hasValue()) {
            $c34b71496108423e$var$caches.forEach(function(cache) {
                return cache.clean();
            });
            $c34b71496108423e$var$caches.clear();
        }
        // If options.disposable is truthy, the caller of wrap is telling us
        // they don't care about the result of entry.recompute(), so we should
        // avoid returning the value, so it won't be accidentally used.
        return disposable ? void 0 : value;
    }
    optimistic.dirty = function() {
        var key = makeCacheKey.apply(null, arguments);
        var child = key !== void 0 && cache.get(key);
        if (child) child.setDirty();
    };
    return optimistic;
}

});
parcelRegister("jFbNy", function(module, exports) {

$parcel$export(module.exports, "Slot", () => $e50aff8f879ebe36$export$8c6ed5c666ac1360);
// This currentContext variable will only be used if the makeSlotClass
// function is called, which happens only if this is the first copy of the
// @wry/context package to be imported.
var $e50aff8f879ebe36$var$currentContext = null;
// This unique internal object is used to denote the absence of a value
// for a given Slot, and is never exposed to outside code.
var $e50aff8f879ebe36$var$MISSING_VALUE = {};
var $e50aff8f879ebe36$var$idCounter = 1;
// Although we can't do anything about the cost of duplicated code from
// accidentally bundling multiple copies of the @wry/context package, we can
// avoid creating the Slot class more than once using makeSlotClass.
var $e50aff8f879ebe36$var$makeSlotClass = function() {
    return /** @class */ function() {
        function Slot() {
            // If you have a Slot object, you can find out its slot.id, but you cannot
            // guess the slot.id of a Slot you don't have access to, thanks to the
            // randomized suffix.
            this.id = [
                "slot",
                $e50aff8f879ebe36$var$idCounter++,
                Date.now(),
                Math.random().toString(36).slice(2)
            ].join(":");
        }
        Slot.prototype.hasValue = function() {
            for(var context_1 = $e50aff8f879ebe36$var$currentContext; context_1; context_1 = context_1.parent)// We use the Slot object iself as a key to its value, which means the
            // value cannot be obtained without a reference to the Slot object.
            if (this.id in context_1.slots) {
                var value = context_1.slots[this.id];
                if (value === $e50aff8f879ebe36$var$MISSING_VALUE) break;
                if (context_1 !== $e50aff8f879ebe36$var$currentContext) // Cache the value in currentContext.slots so the next lookup will
                // be faster. This caching is safe because the tree of contexts and
                // the values of the slots are logically immutable.
                $e50aff8f879ebe36$var$currentContext.slots[this.id] = value;
                return true;
            }
            if ($e50aff8f879ebe36$var$currentContext) // If a value was not found for this Slot, it's never going to be found
            // no matter how many times we look it up, so we might as well cache
            // the absence of the value, too.
            $e50aff8f879ebe36$var$currentContext.slots[this.id] = $e50aff8f879ebe36$var$MISSING_VALUE;
            return false;
        };
        Slot.prototype.getValue = function() {
            if (this.hasValue()) return $e50aff8f879ebe36$var$currentContext.slots[this.id];
        };
        Slot.prototype.withValue = function(value, callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            var _a;
            var slots = (_a = {
                __proto__: null
            }, _a[this.id] = value, _a);
            var parent = $e50aff8f879ebe36$var$currentContext;
            $e50aff8f879ebe36$var$currentContext = {
                parent: parent,
                slots: slots
            };
            try {
                // Function.prototype.apply allows the arguments array argument to be
                // omitted or undefined, so args! is fine here.
                return callback.apply(thisArg, args);
            } finally{
                $e50aff8f879ebe36$var$currentContext = parent;
            }
        };
        // Capture the current context and wrap a callback function so that it
        // reestablishes the captured context when called.
        Slot.bind = function(callback) {
            var context = $e50aff8f879ebe36$var$currentContext;
            return function() {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = context;
                    return callback.apply(this, arguments);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            };
        };
        // Immediately run a callback function without any captured context.
        Slot.noContext = function(callback, // Given the prevalence of arrow functions, specifying arguments is likely
        // to be much more common than specifying `this`, hence this ordering:
        args, thisArg) {
            if ($e50aff8f879ebe36$var$currentContext) {
                var saved = $e50aff8f879ebe36$var$currentContext;
                try {
                    $e50aff8f879ebe36$var$currentContext = null;
                    // Function.prototype.apply allows the arguments array argument to be
                    // omitted or undefined, so args! is fine here.
                    return callback.apply(thisArg, args);
                } finally{
                    $e50aff8f879ebe36$var$currentContext = saved;
                }
            } else return callback.apply(thisArg, args);
        };
        return Slot;
    }();
};
// We store a single global implementation of the Slot class as a permanent
// non-enumerable symbol property of the Array constructor. This obfuscation
// does nothing to prevent access to the Slot class, but at least it ensures
// the implementation (i.e. currentContext) cannot be tampered with, and all
// copies of the @wry/context package (hopefully just one) will share the
// same Slot implementation. Since the first copy of the @wry/context package
// to be imported wins, this technique imposes a very high cost for any
// future breaking changes to the Slot class.
var $e50aff8f879ebe36$var$globalKey = "@wry/context:Slot";
var $e50aff8f879ebe36$var$host = Array;
var $e50aff8f879ebe36$export$8c6ed5c666ac1360 = $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] || function() {
    var Slot = $e50aff8f879ebe36$var$makeSlotClass();
    try {
        Object.defineProperty($e50aff8f879ebe36$var$host, $e50aff8f879ebe36$var$globalKey, {
            value: $e50aff8f879ebe36$var$host[$e50aff8f879ebe36$var$globalKey] = Slot,
            enumerable: false,
            writable: false,
            configurable: false
        });
    } finally{
        return Slot;
    }
}();
var $e50aff8f879ebe36$export$2385a24977818dd0 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.bind, $e50aff8f879ebe36$export$9fa6f2e300a97f8 = $e50aff8f879ebe36$export$8c6ed5c666ac1360.noContext;
function $e50aff8f879ebe36$export$831dc9f2ab0a617b(callback, delay) {
    return setTimeout($e50aff8f879ebe36$export$2385a24977818dd0(callback), delay);
}
// Turn any generator function into an async function (using yield instead
// of await), with context automatically preserved across yields.
function $e50aff8f879ebe36$export$d5d7536e965c82da(genFn) {
    return function() {
        var gen = genFn.apply(this, arguments);
        var boundNext = $e50aff8f879ebe36$export$2385a24977818dd0(gen.next);
        var boundThrow = $e50aff8f879ebe36$export$2385a24977818dd0(gen.throw);
        return new Promise(function(resolve, reject) {
            function invoke(method, argument) {
                try {
                    var result = method.call(gen, argument);
                } catch (error) {
                    return reject(error);
                }
                var next = result.done ? resolve : invokeNext;
                if ($e50aff8f879ebe36$var$isPromiseLike(result.value)) result.value.then(next, result.done ? reject : invokeThrow);
                else next(result.value);
            }
            var invokeNext = function(value) {
                return invoke(boundNext, value);
            };
            var invokeThrow = function(error) {
                return invoke(boundThrow, error);
            };
            invokeNext();
        });
    };
}
function $e50aff8f879ebe36$var$isPromiseLike(value) {
    return value && typeof value.then === "function";
}
// If you use the fibers npm package to implement coroutines in Node.js,
// you should call this function at least once to ensure context management
// remains coherent across any yields.
var $e50aff8f879ebe36$var$wrappedFibers = [];
function $e50aff8f879ebe36$export$14794f6e0a4dc6a0(Fiber) {
    // There can be only one implementation of Fiber per process, so this array
    // should never grow longer than one element.
    if ($e50aff8f879ebe36$var$wrappedFibers.indexOf(Fiber) < 0) {
        var wrap = function(obj, method) {
            var fn = obj[method];
            obj[method] = function() {
                return $e50aff8f879ebe36$export$9fa6f2e300a97f8(fn, arguments, this);
            };
        };
        // These methods can yield, according to
        // https://github.com/laverdet/node-fibers/blob/ddebed9b8ae3883e57f822e2108e6943e5c8d2a8/fibers.js#L97-L100
        wrap(Fiber, "yield");
        wrap(Fiber.prototype, "run");
        wrap(Fiber.prototype, "throwInto");
        $e50aff8f879ebe36$var$wrappedFibers.push(Fiber);
    }
    return Fiber;
}

});



parcelRegister("43WKH", function(module, exports) {

$parcel$export(module.exports, "setContext", () => $2f550436daecafe0$export$2f04de43fe27971a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $2f550436daecafe0$export$2f04de43fe27971a(setter) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        var request = (0, $3VFsf.__rest)(operation, []);
        return new (0, $clSzL.Observable)(function(observer) {
            var handle;
            Promise.resolve(request).then(function(req) {
                return setter(req, operation.getContext());
            }).then(operation.setContext).then(function() {
                handle = forward(operation).subscribe({
                    next: observer.next.bind(observer),
                    error: observer.error.bind(observer),
                    complete: observer.complete.bind(observer)
                });
            }).catch(observer.error.bind(observer));
            return function() {
                if (handle) handle.unsubscribe();
            };
        });
    });
}

});

parcelRegister("h4ppL", function(module, exports) {

$parcel$export(module.exports, "onError", () => $c6d6862dd229df53$export$2288787135a8f66e);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $c6d6862dd229df53$export$2288787135a8f66e(errorHandler) {
    return new (0, $clSzL.ApolloLink)(function(operation, forward) {
        return new (0, $clSzL.Observable)(function(observer) {
            var sub;
            var retriedSub;
            var retriedResult;
            try {
                sub = forward(operation).subscribe({
                    next: function(result) {
                        if (result.errors) {
                            retriedResult = errorHandler({
                                graphQLErrors: result.errors,
                                response: result,
                                operation: operation,
                                forward: forward
                            });
                            if (retriedResult) {
                                retriedSub = retriedResult.subscribe({
                                    next: observer.next.bind(observer),
                                    error: observer.error.bind(observer),
                                    complete: observer.complete.bind(observer)
                                });
                                return;
                            }
                        }
                        observer.next(result);
                    },
                    error: function(networkError) {
                        retriedResult = errorHandler({
                            operation: operation,
                            networkError: networkError,
                            graphQLErrors: networkError && networkError.result && networkError.result.errors,
                            forward: forward
                        });
                        if (retriedResult) {
                            retriedSub = retriedResult.subscribe({
                                next: observer.next.bind(observer),
                                error: observer.error.bind(observer),
                                complete: observer.complete.bind(observer)
                            });
                            return;
                        }
                        observer.error(networkError);
                    },
                    complete: function() {
                        if (!retriedResult) observer.complete.bind(observer)();
                    }
                });
            } catch (e) {
                errorHandler({
                    networkError: e,
                    operation: operation,
                    forward: forward
                });
                observer.error(e);
            }
            return function() {
                if (sub) sub.unsubscribe();
                if (retriedSub) sub.unsubscribe();
            };
        });
    });
}
var $c6d6862dd229df53$export$d2c8415987899609 = function(_super) {
    (0, $3VFsf.__extends)(ErrorLink, _super);
    function ErrorLink(errorHandler) {
        var _this = _super.call(this) || this;
        _this.link = $c6d6862dd229df53$export$2288787135a8f66e(errorHandler);
        return _this;
    }
    ErrorLink.prototype.request = function(operation, forward) {
        return this.link.request(operation, forward);
    };
    return ErrorLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("JPsIz", function(module, exports) {

$parcel$export(module.exports, "HttpLink", () => $089c1f6736cf7295$export$f4bbf1aec241cc1);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");

var $f0Elb = parcelRequire("f0Elb");
var $089c1f6736cf7295$export$95180a16573d6675 = function(linkOptions) {
    if (linkOptions === void 0) linkOptions = {};
    var _a = linkOptions.uri, uri = _a === void 0 ? '/graphql' : _a, fetcher = linkOptions.fetch, includeExtensions = linkOptions.includeExtensions, useGETForQueries = linkOptions.useGETForQueries, abortErrorDoesNotCauseError = linkOptions.abortErrorDoesNotCauseError, requestOptions = (0, $3VFsf.__rest)(linkOptions, [
        "uri",
        "fetch",
        "includeExtensions",
        "useGETForQueries",
        "abortErrorDoesNotCauseError"
    ]);
    (0, $f0Elb.checkFetcher)(fetcher);
    if (!fetcher) fetcher = fetch;
    var linkConfig = {
        http: {
            includeExtensions: includeExtensions
        },
        options: requestOptions.fetchOptions,
        credentials: requestOptions.credentials,
        headers: requestOptions.headers
    };
    return new (0, $clSzL.ApolloLink)(function(operation) {
        var chosenURI = (0, $f0Elb.selectURI)(operation, uri);
        var context = operation.getContext();
        var clientAwarenessHeaders = {};
        if (context.clientAwareness) {
            var _a = context.clientAwareness, name_1 = _a.name, version = _a.version;
            if (name_1) clientAwarenessHeaders['apollographql-client-name'] = name_1;
            if (version) clientAwarenessHeaders['apollographql-client-version'] = version;
        }
        var contextHeaders = (0, $3VFsf.__assign)({}, clientAwarenessHeaders, context.headers);
        var contextConfig = {
            http: context.http,
            options: context.fetchOptions,
            credentials: context.credentials,
            headers: contextHeaders
        };
        var _b = (0, $f0Elb.selectHttpOptionsAndBody)(operation, (0, $f0Elb.fallbackHttpConfig), linkConfig, contextConfig), options = _b.options, body = _b.body;
        var controller;
        if (!options.signal) {
            var _c = (0, $f0Elb.createSignalIfSupported)(), _controller = _c.controller, signal = _c.signal;
            controller = _controller;
            if (controller) options.signal = signal;
        }
        var definitionIsMutation = function(d) {
            return d.kind === 'OperationDefinition' && d.operation === 'mutation';
        };
        if (useGETForQueries && !operation.query.definitions.some(definitionIsMutation)) options.method = 'GET';
        if (options.method === 'GET') {
            var _d = $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body), newURI = _d.newURI, parseError = _d.parseError;
            if (parseError) return (0, $clSzL.fromError)(parseError);
            chosenURI = newURI;
        } else try {
            options.body = (0, $f0Elb.serializeFetchParameter)(body, 'Payload');
        } catch (parseError) {
            return (0, $clSzL.fromError)(parseError);
        }
        return new (0, $clSzL.Observable)(function(observer) {
            fetcher(chosenURI, options).then(function(response) {
                operation.setContext({
                    response: response
                });
                return response;
            }).then((0, $f0Elb.parseAndCheckHttpResponse)(operation)).then(function(result) {
                observer.next(result);
                observer.complete();
                return result;
            }).catch(function(err) {
                if (err.name === 'AbortError' && !abortErrorDoesNotCauseError) return;
                if (err.result && err.result.errors && err.result.data) observer.next(err.result);
                observer.error(err);
            });
            return function() {
                if (controller) controller.abort();
            };
        });
    });
};
function $089c1f6736cf7295$var$rewriteURIForGET(chosenURI, body) {
    var queryParams = [];
    var addQueryParam = function(key, value) {
        queryParams.push(key + "=" + encodeURIComponent(value));
    };
    if ('query' in body) addQueryParam('query', body.query);
    if (body.operationName) addQueryParam('operationName', body.operationName);
    if (body.variables) {
        var serializedVariables = void 0;
        try {
            serializedVariables = (0, $f0Elb.serializeFetchParameter)(body.variables, 'Variables map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('variables', serializedVariables);
    }
    if (body.extensions) {
        var serializedExtensions = void 0;
        try {
            serializedExtensions = (0, $f0Elb.serializeFetchParameter)(body.extensions, 'Extensions map');
        } catch (parseError) {
            return {
                parseError: parseError
            };
        }
        addQueryParam('extensions', serializedExtensions);
    }
    var fragment = '', preFragment = chosenURI;
    var fragmentStart = chosenURI.indexOf('#');
    if (fragmentStart !== -1) {
        fragment = chosenURI.substr(fragmentStart);
        preFragment = chosenURI.substr(0, fragmentStart);
    }
    var queryParamsPrefix = preFragment.indexOf('?') === -1 ? '?' : '&';
    var newURI = preFragment + queryParamsPrefix + queryParams.join('&') + fragment;
    return {
        newURI: newURI
    };
}
var $089c1f6736cf7295$export$f4bbf1aec241cc1 = function(_super) {
    (0, $3VFsf.__extends)(HttpLink, _super);
    function HttpLink(opts) {
        return _super.call(this, $089c1f6736cf7295$export$95180a16573d6675(opts).request) || this;
    }
    return HttpLink;
}((0, $clSzL.ApolloLink));

});
parcelRegister("f0Elb", function(module, exports) {

$parcel$export(module.exports, "fallbackHttpConfig", () => $aed625edf13c57eb$export$dd86f00dc866e75d);
$parcel$export(module.exports, "parseAndCheckHttpResponse", () => $aed625edf13c57eb$export$d4051215bea0639f);
$parcel$export(module.exports, "checkFetcher", () => $aed625edf13c57eb$export$8423f0cd3773115e);
$parcel$export(module.exports, "createSignalIfSupported", () => $aed625edf13c57eb$export$f5853cd1fc39aea6);
$parcel$export(module.exports, "selectHttpOptionsAndBody", () => $aed625edf13c57eb$export$a00ebfd5f1eebfb1);
$parcel$export(module.exports, "serializeFetchParameter", () => $aed625edf13c57eb$export$5f8e80ac52052e28);
$parcel$export(module.exports, "selectURI", () => $aed625edf13c57eb$export$63ccc2571850f81a);

var $3VFsf = parcelRequire("3VFsf");

var $1c8Um = parcelRequire("1c8Um");

var $1DiV8 = parcelRequire("1DiV8");
var $aed625edf13c57eb$var$defaultHttpOptions = {
    includeQuery: true,
    includeExtensions: false
};
var $aed625edf13c57eb$var$defaultHeaders = {
    accept: '*/*',
    'content-type': 'application/json'
};
var $aed625edf13c57eb$var$defaultOptions = {
    method: 'POST'
};
var $aed625edf13c57eb$export$dd86f00dc866e75d = {
    http: $aed625edf13c57eb$var$defaultHttpOptions,
    headers: $aed625edf13c57eb$var$defaultHeaders,
    options: $aed625edf13c57eb$var$defaultOptions
};
var $aed625edf13c57eb$export$c33ef9219f27efd7 = function(response, result, message) {
    var error = new Error(message);
    error.name = 'ServerError';
    error.response = response;
    error.statusCode = response.status;
    error.result = result;
    throw error;
};
var $aed625edf13c57eb$export$d4051215bea0639f = function(operations) {
    return function(response) {
        return response.text().then(function(bodyText) {
            try {
                return JSON.parse(bodyText);
            } catch (err) {
                var parseError = err;
                parseError.name = 'ServerParseError';
                parseError.response = response;
                parseError.statusCode = response.status;
                parseError.bodyText = bodyText;
                return Promise.reject(parseError);
            }
        }).then(function(result) {
            if (response.status >= 300) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Response not successful: Received status code " + response.status);
            if (!Array.isArray(result) && !result.hasOwnProperty('data') && !result.hasOwnProperty('errors')) $aed625edf13c57eb$export$c33ef9219f27efd7(response, result, "Server response was missing for query '" + (Array.isArray(operations) ? operations.map(function(op) {
                return op.operationName;
            }) : operations.operationName) + "'.");
            return result;
        });
    };
};
var $aed625edf13c57eb$export$8423f0cd3773115e = function(fetcher) {
    if (!fetcher && typeof fetch === 'undefined') {
        var library = 'unfetch';
        if (typeof window === 'undefined') library = 'node-fetch';
        throw new (0, $1DiV8.InvariantError)(1);
    }
};
var $aed625edf13c57eb$export$f5853cd1fc39aea6 = function() {
    if (typeof AbortController === 'undefined') return {
        controller: false,
        signal: false
    };
    var controller = new AbortController();
    var signal = controller.signal;
    return {
        controller: controller,
        signal: signal
    };
};
var $aed625edf13c57eb$export$a00ebfd5f1eebfb1 = function(operation, fallbackConfig) {
    var configs = [];
    for(var _i = 2; _i < arguments.length; _i++)configs[_i - 2] = arguments[_i];
    var options = (0, $3VFsf.__assign)({}, fallbackConfig.options, {
        headers: fallbackConfig.headers,
        credentials: fallbackConfig.credentials
    });
    var http = fallbackConfig.http;
    configs.forEach(function(config) {
        options = (0, $3VFsf.__assign)({}, options, config.options, {
            headers: (0, $3VFsf.__assign)({}, options.headers, config.headers)
        });
        if (config.credentials) options.credentials = config.credentials;
        http = (0, $3VFsf.__assign)({}, http, config.http);
    });
    var operationName = operation.operationName, extensions = operation.extensions, variables = operation.variables, query = operation.query;
    var body = {
        operationName: operationName,
        variables: variables
    };
    if (http.includeExtensions) body.extensions = extensions;
    if (http.includeQuery) body.query = (0, $1c8Um.print)(query);
    return {
        options: options,
        body: body
    };
};
var $aed625edf13c57eb$export$5f8e80ac52052e28 = function(p, label) {
    var serialized;
    try {
        serialized = JSON.stringify(p);
    } catch (e) {
        var parseError = new (0, $1DiV8.InvariantError)(2);
        parseError.parseError = e;
        throw parseError;
    }
    return serialized;
};
var $aed625edf13c57eb$export$63ccc2571850f81a = function(operation, fallbackURI) {
    var context = operation.getContext();
    var contextURI = context.uri;
    if (contextURI) return contextURI;
    else if (typeof fallbackURI === 'function') return fallbackURI(operation);
    else return fallbackURI || '/graphql';
};

});


parcelRegister("lC4FX", function(module, exports) {

$parcel$export(module.exports, "RetryLink", () => $fbc0c610016bf5c5$export$943d544ad120494a);

var $3VFsf = parcelRequire("3VFsf");

var $clSzL = parcelRequire("clSzL");
function $fbc0c610016bf5c5$var$buildDelayFunction(delayOptions) {
    var _a = delayOptions || {}, _b = _a.initial, initial = _b === void 0 ? 300 : _b, _c = _a.jitter, jitter = _c === void 0 ? true : _c, _d = _a.max, max = _d === void 0 ? Infinity : _d;
    var baseDelay = jitter ? initial : initial / 2;
    return function delayFunction(count) {
        var delay = Math.min(max, baseDelay * Math.pow(2, count));
        if (jitter) delay = Math.random() * delay;
        return delay;
    };
}
function $fbc0c610016bf5c5$var$buildRetryFunction(retryOptions) {
    var _a = retryOptions || {}, retryIf = _a.retryIf, _b = _a.max, max = _b === void 0 ? 5 : _b;
    return function retryFunction(count, operation, error) {
        if (count >= max) return false;
        return retryIf ? retryIf(error, operation) : !!error;
    };
}
var $fbc0c610016bf5c5$var$RetryableOperation = function() {
    function RetryableOperation(operation, nextLink, delayFor, retryIf) {
        var _this = this;
        this.operation = operation;
        this.nextLink = nextLink;
        this.delayFor = delayFor;
        this.retryIf = retryIf;
        this.retryCount = 0;
        this.values = [];
        this.complete = false;
        this.canceled = false;
        this.observers = [];
        this.currentSubscription = null;
        this.onNext = function(value) {
            _this.values.push(value);
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.next(value);
            }
        };
        this.onComplete = function() {
            _this.complete = true;
            for(var _i = 0, _a = _this.observers; _i < _a.length; _i++){
                var observer = _a[_i];
                if (!observer) continue;
                observer.complete();
            }
        };
        this.onError = function(error) {
            return (0, $3VFsf.__awaiter)(_this, void 0, void 0, function() {
                var shouldRetry, _i, _a, observer;
                return (0, $3VFsf.__generator)(this, function(_b) {
                    switch(_b.label){
                        case 0:
                            this.retryCount += 1;
                            return [
                                4,
                                this.retryIf(this.retryCount, this.operation, error)
                            ];
                        case 1:
                            shouldRetry = _b.sent();
                            if (shouldRetry) {
                                this.scheduleRetry(this.delayFor(this.retryCount, this.operation, error));
                                return [
                                    2
                                ];
                            }
                            this.error = error;
                            for(_i = 0, _a = this.observers; _i < _a.length; _i++){
                                observer = _a[_i];
                                if (!observer) continue;
                                observer.error(error);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
        };
    }
    RetryableOperation.prototype.subscribe = function(observer) {
        if (this.canceled) throw new Error("Subscribing to a retryable link that was canceled is not supported");
        this.observers.push(observer);
        for(var _i = 0, _a = this.values; _i < _a.length; _i++){
            var value = _a[_i];
            observer.next(value);
        }
        if (this.complete) observer.complete();
        else if (this.error) observer.error(this.error);
    };
    RetryableOperation.prototype.unsubscribe = function(observer) {
        var index = this.observers.indexOf(observer);
        if (index < 0) throw new Error("RetryLink BUG! Attempting to unsubscribe unknown observer!");
        this.observers[index] = null;
        if (this.observers.every(function(o) {
            return o === null;
        })) this.cancel();
    };
    RetryableOperation.prototype.start = function() {
        if (this.currentSubscription) return;
        this.try();
    };
    RetryableOperation.prototype.cancel = function() {
        if (this.currentSubscription) this.currentSubscription.unsubscribe();
        clearTimeout(this.timerId);
        this.timerId = null;
        this.currentSubscription = null;
        this.canceled = true;
    };
    RetryableOperation.prototype.try = function() {
        this.currentSubscription = this.nextLink(this.operation).subscribe({
            next: this.onNext,
            error: this.onError,
            complete: this.onComplete
        });
    };
    RetryableOperation.prototype.scheduleRetry = function(delay) {
        var _this = this;
        if (this.timerId) throw new Error("RetryLink BUG! Encountered overlapping retries");
        this.timerId = setTimeout(function() {
            _this.timerId = null;
            _this.try();
        }, delay);
    };
    return RetryableOperation;
}();
var $fbc0c610016bf5c5$export$943d544ad120494a = function(_super) {
    (0, $3VFsf.__extends)(RetryLink, _super);
    function RetryLink(options) {
        var _this = _super.call(this) || this;
        var _a = options || {}, attempts = _a.attempts, delay = _a.delay;
        _this.delayFor = typeof delay === 'function' ? delay : $fbc0c610016bf5c5$var$buildDelayFunction(delay);
        _this.retryIf = typeof attempts === 'function' ? attempts : $fbc0c610016bf5c5$var$buildRetryFunction(attempts);
        return _this;
    }
    RetryLink.prototype.request = function(operation, nextLink) {
        var retryable = new $fbc0c610016bf5c5$var$RetryableOperation(operation, nextLink, this.delayFor, this.retryIf);
        retryable.start();
        return new (0, $clSzL.Observable)(function(observer) {
            retryable.subscribe(observer);
            return function() {
                retryable.unsubscribe(observer);
            };
        });
    };
    return RetryLink;
}((0, $clSzL.ApolloLink));

});

parcelRegister("cuKXc", function(module, exports) {

$parcel$export(module.exports, "fragmentCacheRedirect", () => $918cb5692ff82562$export$5133c88128301697);
$parcel$export(module.exports, "fragmentLinkState", () => $918cb5692ff82562$export$3f9ecfb4d42ab23d);

var $jojW6 = parcelRequire("jojW6");

var $9HlP2 = parcelRequire("9HlP2");

var $ivfDv = parcelRequire("ivfDv");
function $918cb5692ff82562$export$5133c88128301697(dataIdFromObject) {
    if (dataIdFromObject === void 0) dataIdFromObject = (0, $ivfDv.defaultDataIdFromObject);
    return {
        getFragment: function(_, _a) {
            var id = _a.id, __typename = _a.__typename;
            return (0, $jojW6.toIdValue)(dataIdFromObject({
                __typename: __typename,
                id: id
            }));
        }
    };
}
function $918cb5692ff82562$export$3f9ecfb4d42ab23d(apolloCache) {
    return (0, $9HlP2.withClientState)({
        cache: apolloCache,
        resolvers: {
            Query: {
                getFragment: function(_, _a, _b) {
                    var __typename = _a.__typename, id = _a.id;
                    var cache = _b.cache;
                    var fragmentId = cache.config.dataIdFromObject({
                        __typename: __typename,
                        id: id
                    });
                    return cache.data.data[fragmentId];
                }
            }
        }
    });
}

});
parcelRegister("9HlP2", function(module, exports) {

$parcel$export(module.exports, "withClientState", () => $70f90ea50d538958$export$a13f755900e15d9e);

var $clSzL = parcelRequire("clSzL");

var $jojW6 = parcelRequire("jojW6");

var $jWd7i = parcelRequire("jWd7i");

var $b2p88 = parcelRequire("b2p88");
var $70f90ea50d538958$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    };
    return function(d, b) {
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
var $70f90ea50d538958$var$graphql = $jWd7i.graphql;
var $70f90ea50d538958$var$capitalizeFirstLetter = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};
var $70f90ea50d538958$export$a13f755900e15d9e = function(clientStateConfig) {
    if (clientStateConfig === void 0) clientStateConfig = {
        resolvers: {},
        defaults: {}
    };
    var defaults = clientStateConfig.defaults, cache = clientStateConfig.cache, typeDefs = clientStateConfig.typeDefs, fragmentMatcher = clientStateConfig.fragmentMatcher;
    if (cache && defaults) cache.writeData({
        data: defaults
    });
    return new (function(_super) {
        $70f90ea50d538958$var$__extends(StateLink, _super);
        function StateLink() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        StateLink.prototype.writeDefaults = function() {
            if (cache && defaults) cache.writeData({
                data: defaults
            });
        };
        StateLink.prototype.request = function(operation, forward) {
            if (forward === void 0) forward = function() {
                return (0, $clSzL.Observable).of({
                    data: {}
                });
            };
            if (typeDefs) {
                var directives_1 = 'directive @client on FIELD';
                var definition_1 = (0, $b2p88.normalizeTypeDefs)(typeDefs);
                operation.setContext(function(_a) {
                    var _b = _a.schemas, schemas = _b === void 0 ? [] : _b;
                    return {
                        schemas: schemas.concat([
                            {
                                definition: definition_1,
                                directives: directives_1
                            }
                        ])
                    };
                });
            }
            var isClient = (0, $jojW6.hasDirectives)([
                'client'
            ], operation.query);
            if (!isClient) return forward(operation);
            var resolvers = typeof clientStateConfig.resolvers === 'function' ? clientStateConfig.resolvers() : clientStateConfig.resolvers;
            var server = (0, $b2p88.removeClientSetsFromDocument)(operation.query);
            var query = operation.query;
            var type = $70f90ea50d538958$var$capitalizeFirstLetter(((0, $jojW6.getMainDefinition)(query) || {}).operation) || 'Query';
            var resolver = function(fieldName, rootValue, args, context, info) {
                if (rootValue === void 0) rootValue = {};
                var resultKey = info.resultKey;
                var aliasedNode = rootValue[resultKey];
                var preAliasingNode = rootValue[fieldName];
                var aliasNeeded = resultKey !== fieldName;
                if (aliasedNode !== undefined || preAliasingNode !== undefined) return aliasedNode || preAliasingNode;
                var resolverMap = resolvers[rootValue.__typename || type];
                if (resolverMap) {
                    var resolve = resolverMap[fieldName];
                    if (resolve) return resolve(rootValue, args, context, info);
                }
                return (aliasNeeded ? aliasedNode : preAliasingNode) || (defaults || {})[fieldName];
            };
            if (server) operation.query = server;
            var obs = server && forward ? forward(operation) : (0, $clSzL.Observable).of({
                data: {}
            });
            return new (0, $clSzL.Observable)(function(observer) {
                var complete = false;
                var handlingNext = false;
                obs.subscribe({
                    next: function(_a) {
                        var data = _a.data, errors = _a.errors;
                        var observerErrorHandler = observer.error.bind(observer);
                        var context = operation.getContext();
                        handlingNext = true;
                        $70f90ea50d538958$var$graphql(resolver, query, data, context, operation.variables, {
                            fragmentMatcher: fragmentMatcher
                        }).then(function(nextData) {
                            observer.next({
                                data: nextData,
                                errors: errors
                            });
                            if (complete) observer.complete();
                            handlingNext = false;
                        }).catch(observerErrorHandler);
                    },
                    error: observer.error.bind(observer),
                    complete: function() {
                        if (!handlingNext) observer.complete();
                        complete = true;
                    }
                });
            });
        };
        return StateLink;
    }((0, $clSzL.ApolloLink)))();
};

});
parcelRegister("jWd7i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $jojW6 = parcelRequire("jojW6");

var $jDjTr = parcelRequire("jDjTr");
function $e83d9bca6fb9481d$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e83d9bca6fb9481d$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e83d9bca6fb9481d$var$graphql;
function $e83d9bca6fb9481d$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var fragmentMap, contextValue, variables, result, execute;
        var _this = this;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
                    result = {};
                    execute = function(selection) {
                        return $3VFsf.__awaiter(_this, void 0, void 0, function() {
                            var fieldResult, resultFieldKey, fragment, typeCondition, fragmentResult;
                            return $3VFsf.__generator(this, function(_a) {
                                switch(_a.label){
                                    case 0:
                                        if (!$jojW6.shouldInclude(selection, variables)) return [
                                            2
                                        ];
                                        if (!$jojW6.isField(selection)) return [
                                            3,
                                            2
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeField(selection, rootValue, execContext)
                                        ];
                                    case 1:
                                        fieldResult = _a.sent();
                                        resultFieldKey = $jojW6.resultKeyNameFromField(selection);
                                        if (fieldResult !== undefined) {
                                            if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                                            else $jDjTr.merge(result[resultFieldKey], fieldResult);
                                        }
                                        return [
                                            2
                                        ];
                                    case 2:
                                        if ($jojW6.isInlineFragment(selection)) fragment = selection;
                                        else {
                                            fragment = fragmentMap[selection.name.value];
                                            if (!fragment) throw new Error("No fragment named " + selection.name.value);
                                        }
                                        typeCondition = fragment.typeCondition.name.value;
                                        if (!execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) return [
                                            3,
                                            4
                                        ];
                                        return [
                                            4,
                                            $e83d9bca6fb9481d$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext)
                                        ];
                                    case 3:
                                        fragmentResult = _a.sent();
                                        $jDjTr.merge(result, fragmentResult);
                                        _a.label = 4;
                                    case 4:
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                    };
                    return [
                        4,
                        Promise.all(selectionSet.selections.map(execute))
                    ];
                case 1:
                    _a.sent();
                    if (execContext.resultMapper) return [
                        2,
                        execContext.resultMapper(result, rootValue)
                    ];
                    return [
                        2,
                        result
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeField(field, rootValue, execContext) {
    return $3VFsf.__awaiter(this, void 0, void 0, function() {
        var variables, contextValue, resolver, fieldName, args, info, result;
        return $3VFsf.__generator(this, function(_a) {
            switch(_a.label){
                case 0:
                    variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
                    fieldName = field.name.value;
                    args = $jojW6.argumentsObjectFromField(field, variables);
                    info = {
                        isLeaf: !field.selectionSet,
                        resultKey: $jojW6.resultKeyNameFromField(field),
                        directives: $jojW6.getDirectiveInfoFromField(field, variables),
                        field: field
                    };
                    return [
                        4,
                        resolver(fieldName, rootValue, args, contextValue, info)
                    ];
                case 1:
                    result = _a.sent();
                    if (!field.selectionSet) return [
                        2,
                        result
                    ];
                    if (result == null) return [
                        2,
                        result
                    ];
                    if (Array.isArray(result)) return [
                        2,
                        $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext)
                    ];
                    return [
                        2,
                        $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, result, execContext)
                    ];
            }
        });
    });
}
function $e83d9bca6fb9481d$var$executeSubSelectedArray(field, result, execContext) {
    return Promise.all(result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e83d9bca6fb9481d$var$executeSubSelectedArray(field, item, execContext);
        return $e83d9bca6fb9481d$var$executeSelectionSet(field.selectionSet, item, execContext);
    }));
}

});
parcelRegister("jDjTr", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $jojW6 = parcelRequire("jojW6");
function $e4b11739b667b187$var$graphql(resolver, document, rootValue, contextValue, variableValues, execOptions) {
    if (variableValues === void 0) variableValues = {};
    if (execOptions === void 0) execOptions = {};
    var mainDefinition = $jojW6.getMainDefinition(document);
    var fragments = $jojW6.getFragmentDefinitions(document);
    var fragmentMap = $jojW6.createFragmentMap(fragments);
    var resultMapper = execOptions.resultMapper;
    var fragmentMatcher = execOptions.fragmentMatcher || function() {
        return true;
    };
    var execContext = {
        fragmentMap: fragmentMap,
        contextValue: contextValue,
        variableValues: variableValues,
        resultMapper: resultMapper,
        resolver: resolver,
        fragmentMatcher: fragmentMatcher
    };
    return $e4b11739b667b187$var$executeSelectionSet(mainDefinition.selectionSet, rootValue, execContext);
}
module.exports.graphql = $e4b11739b667b187$var$graphql;
function $e4b11739b667b187$var$executeSelectionSet(selectionSet, rootValue, execContext) {
    var fragmentMap = execContext.fragmentMap, contextValue = execContext.contextValue, variables = execContext.variableValues;
    var result = {};
    selectionSet.selections.forEach(function(selection) {
        if (variables && !$jojW6.shouldInclude(selection, variables)) return;
        if ($jojW6.isField(selection)) {
            var fieldResult = $e4b11739b667b187$var$executeField(selection, rootValue, execContext);
            var resultFieldKey = $jojW6.resultKeyNameFromField(selection);
            if (fieldResult !== undefined) {
                if (result[resultFieldKey] === undefined) result[resultFieldKey] = fieldResult;
                else $e4b11739b667b187$var$merge(result[resultFieldKey], fieldResult);
            }
        } else {
            var fragment = void 0;
            if ($jojW6.isInlineFragment(selection)) fragment = selection;
            else {
                fragment = fragmentMap[selection.name.value];
                if (!fragment) throw new Error("No fragment named " + selection.name.value);
            }
            var typeCondition = fragment.typeCondition.name.value;
            if (execContext.fragmentMatcher(rootValue, typeCondition, contextValue)) {
                var fragmentResult = $e4b11739b667b187$var$executeSelectionSet(fragment.selectionSet, rootValue, execContext);
                $e4b11739b667b187$var$merge(result, fragmentResult);
            }
        }
    });
    if (execContext.resultMapper) return execContext.resultMapper(result, rootValue);
    return result;
}
function $e4b11739b667b187$var$executeField(field, rootValue, execContext) {
    var variables = execContext.variableValues, contextValue = execContext.contextValue, resolver = execContext.resolver;
    var fieldName = field.name.value;
    var args = $jojW6.argumentsObjectFromField(field, variables);
    var info = {
        isLeaf: !field.selectionSet,
        resultKey: $jojW6.resultKeyNameFromField(field),
        directives: $jojW6.getDirectiveInfoFromField(field, variables),
        field: field
    };
    var result = resolver(fieldName, rootValue, args, contextValue, info);
    if (!field.selectionSet) return result;
    if (result == null) return result;
    if (Array.isArray(result)) return $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext);
    return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, result, execContext);
}
function $e4b11739b667b187$var$executeSubSelectedArray(field, result, execContext) {
    return result.map(function(item) {
        if (item === null) return null;
        if (Array.isArray(item)) return $e4b11739b667b187$var$executeSubSelectedArray(field, item, execContext);
        return $e4b11739b667b187$var$executeSelectionSet(field.selectionSet, item, execContext);
    });
}
var $e4b11739b667b187$var$hasOwn = Object.prototype.hasOwnProperty;
function $e4b11739b667b187$var$merge(dest, src) {
    if (src !== null && typeof src === 'object') Object.keys(src).forEach(function(key) {
        var srcVal = src[key];
        if (!$e4b11739b667b187$var$hasOwn.call(dest, key)) dest[key] = srcVal;
        else $e4b11739b667b187$var$merge(dest[key], srcVal);
    });
}
module.exports.merge = $e4b11739b667b187$var$merge;

});


parcelRegister("b2p88", function(module, exports) {

$parcel$export(module.exports, "removeClientSetsFromDocument", () => $80935fed9657b3c7$export$8eae69e876ee321e);
$parcel$export(module.exports, "normalizeTypeDefs", () => $80935fed9657b3c7$export$467f9c465e4ace4e);

var $1c8Um = parcelRequire("1c8Um");

var $jojW6 = parcelRequire("jojW6");
var $80935fed9657b3c7$var$connectionRemoveConfig = {
    test: function(directive) {
        return directive.name.value === 'client';
    },
    remove: true
};
var $80935fed9657b3c7$var$removed = new Map();
function $80935fed9657b3c7$export$8eae69e876ee321e(query) {
    var cached = $80935fed9657b3c7$var$removed.get(query);
    if (cached) return cached;
    (0, $jojW6.checkDocument)(query);
    var docClone = (0, $jojW6.removeDirectivesFromDocument)([
        $80935fed9657b3c7$var$connectionRemoveConfig
    ], query);
    $80935fed9657b3c7$var$removed.set(query, docClone);
    return docClone;
}
function $80935fed9657b3c7$export$467f9c465e4ace4e(typeDefs) {
    var defs = Array.isArray(typeDefs) ? typeDefs : [
        typeDefs
    ];
    return defs.map(function(typeDef) {
        return typeof typeDef === 'string' ? typeDef : (0, $1c8Um.print)(typeDef);
    }).map(function(str) {
        return str.trim();
    }).join('\n');
}

});



parcelRegister("04zaL", function(module, exports) {

$parcel$export(module.exports, "logApolloError", () => $1590485f1b901936$export$2c9c775c9aa1863d);
$parcel$export(module.exports, "logApolloNetworkError", () => $1590485f1b901936$export$45c096492076b53a);
$parcel$export(module.exports, "logRestError", () => $1590485f1b901936$export$9a40393cdc64dc7d);
$parcel$export(module.exports, "logRestNetworkError", () => $1590485f1b901936$export$b2eb9fe68368f77d);
$parcel$export(module.exports, "logRestParsingError", () => $1590485f1b901936$export$25d52be9f4671e9e);
$parcel$export(module.exports, "logRestRetry", () => $1590485f1b901936$export$e8ce08d55ac713ef);
$parcel$export(module.exports, "logApolloRetry", () => $1590485f1b901936$export$3e50530825dee9d1);

var $2YZCu = parcelRequire("2YZCu");
const $1590485f1b901936$var$logError = (type, m, extra)=>{
    const { message: message, path: path, queryName: queryName, statusCode: statusCode, errorType: errorType, errorName: errorName, hash: hash } = extra;
    const params = {
        message: message || '',
        path: JSON.stringify(path || []),
        statusCode: String(statusCode || '[unknown]'),
        queryName: queryName,
        errorType: errorType ? String(errorType) : '',
        errorName: errorName ? String(errorName) : '',
        hash: hash
    };
    return (0, $2YZCu.default).safeErrorWithoutCustomerData(type, m, params);
};
const $1590485f1b901936$var$SwagErrorPlaceholder = '[errors in SWAG response]';
const $1590485f1b901936$export$2c9c775c9aa1863d = (path, statusCode, queryName, errorType)=>$1590485f1b901936$var$logError('apollo.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
const $1590485f1b901936$export$45c096492076b53a = (networkError, statusCode, queryName)=>{
    $1590485f1b901936$var$logError('apollo.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName
    });
};
const $1590485f1b901936$export$9a40393cdc64dc7d = (path, statusCode, queryName, errorType)=>{
    $1590485f1b901936$var$logError('rest.swag.error.graphql', '[GraphQL error]', {
        message: $1590485f1b901936$var$SwagErrorPlaceholder,
        path: path,
        statusCode: statusCode,
        queryName: queryName,
        errorType: errorType
    });
};
const $1590485f1b901936$export$b2eb9fe68368f77d = (networkError, statusCode, queryName, errorName, hash)=>{
    $1590485f1b901936$var$logError('rest.swag.error.network', '[Network error]', {
        message: `[Network error]: ${networkError}`,
        statusCode: statusCode,
        queryName: queryName,
        errorName: errorName,
        hash: hash
    });
};
const $1590485f1b901936$export$25d52be9f4671e9e = (error, queryName)=>{
    $1590485f1b901936$var$logError('rest.swag.error.parsing', '[Parsing error]', {
        message: `[Parsing error]: ${error}`,
        queryName: queryName
    });
};
const $1590485f1b901936$export$e8ce08d55ac713ef = ({ queryName: queryName, statusCode: statusCode, isRetrySuccessful: isRetrySuccessful, retryStatusCode: retryStatusCode })=>(0, $2YZCu.default).safeErrorWithoutCustomerData('rest.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode || '',
        isRetrySuccessful: String(isRetrySuccessful),
        retryStatusCode: retryStatusCode || ''
    });
const $1590485f1b901936$export$3e50530825dee9d1 = ({ queryName: queryName, statusCode: statusCode })=>(0, $2YZCu.default).safeErrorWithoutCustomerData('apollo.swag.retry', '[Retry]', {
        queryName: queryName,
        statusCode: statusCode
    });

});

parcelRegister("dxpxC", function(module, exports) {

$parcel$export(module.exports, "UFOLoggerLink", () => $4350c2bcf1320fcf$export$fb326ed954631f3f);

var $clSzL = parcelRequire("clSzL");

var $bFU4G = parcelRequire("bFU4G");
const $4350c2bcf1320fcf$export$fb326ed954631f3f = new (0, $clSzL.ApolloLink)((operation, forward)=>{
    const networkStart = performance.now();
    return forward(operation).map((response)=>{
        const networkComplete = performance.now();
        const operationName = operation.operationName ?? 'unnamed';
        (0, $bFU4G.addSpanToAll)('graphql', operationName, [
            {
                name: 'network'
            }
        ], networkStart, networkComplete);
        return response;
    });
});

});

parcelRegister("5uTwE", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"Admin\",\"possibleTypes\":[{\"name\":\"JiraGroup\"},{\"name\":\"JiraUser\"}]},{\"kind\":\"UNION\",\"name\":\"BoardFeatureView\",\"possibleTypes\":[{\"name\":\"BasicBoardFeatureView\"},{\"name\":\"EstimationBoardFeatureView\"}]},{\"kind\":\"UNION\",\"name\":\"BoardLocation\",\"possibleTypes\":[{\"name\":\"Project\"},{\"name\":\"UserLocation\"}]}]}}");

});


parcelRegister("lKocD", function(module, exports) {

$parcel$export(module.exports, "default", () => $73a7c750c3dfc37c$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $kGsr8 = parcelRequire("kGsr8");

var $ebyGx = parcelRequire("ebyGx");

var $9pe79 = parcelRequire("9pe79");
function $73a7c750c3dfc37c$var$stringifySafe(queryLike) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(queryLike);
}
function $73a7c750c3dfc37c$var$parseSafe(search) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
}
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $73a7c750c3dfc37c$var$getQueryString = ()=>$73a7c750c3dfc37c$var$parseSafe(window.location.search);
function $73a7c750c3dfc37c$var$getNonManagedParams(currentParams, managedKeys) {
    const previous = {};
    Object.keys(currentParams).forEach((key)=>{
        if (managedKeys.includes(key)) return;
        previous[key] = currentParams[key];
    });
    return previous;
}
function $73a7c750c3dfc37c$var$setQueryString(params, managedKeys, history) {
    const current = $73a7c750c3dfc37c$var$getQueryString();
    const mergedParams = {
        ...managedKeys.length ? $73a7c750c3dfc37c$var$getNonManagedParams(current, managedKeys) : {},
        ...params
    };
    // do not bother updating the query string if you do not need to
    if ((0, $9pe79.default)(current, mergedParams)) return;
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const currentUrlPath = `${window.location.protocol}//${window.location.host}${window.location.pathname}`;
    const qs = Object.keys(mergedParams).length ? `?${$73a7c750c3dfc37c$var$stringifySafe(mergedParams)}` : '';
    if (history) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    history.replace(window.location.pathname + qs);
    else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.history.replaceState({}, '', currentUrlPath + qs);
}
function $73a7c750c3dfc37c$var$setStateFromUrl(dispatch, urlBindings) {
    const qs = $73a7c750c3dfc37c$var$getQueryString();
    urlBindings.forEach((binding)=>{
        let value = qs[binding.urlKey];
        if (typeof value === 'undefined') {
            const { getDefaultValue: getDefaultValue } = binding;
            value = typeof getDefaultValue === 'function' ? getDefaultValue() : undefined;
        }
        if (typeof value === 'undefined') return;
        binding.setValueFromUrl(dispatch, binding.transform.parse(value));
    });
}
function $73a7c750c3dfc37c$var$setUrlFromState(state, urlBindings, keepNonManagedParams, history) {
    const search = {};
    urlBindings.forEach((binding)=>{
        const value = binding.getValueForUrl(state);
        if (typeof value === 'undefined') return;
        search[binding.urlKey] = binding.transform.stringify(value);
    });
    const managedKeys = keepNonManagedParams ? urlBindings.map(({ urlKey: urlKey })=>urlKey) : [];
    $73a7c750c3dfc37c$var$setQueryString(search, managedKeys, history);
}
function $73a7c750c3dfc37c$export$2e2bcd8739ae039(store, urlBindings = [], keepNonManagedParams = false, history) {
    if (!urlBindings.length) return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    const urlKeys = urlBindings.map((binding)=>binding.urlKey);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(urlKeys).length !== urlKeys.length) {
        // eslint-disable-next-line no-console
        console.warn('clash found in url binding keys', urlKeys);
        return 0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz));
    }
    $73a7c750c3dfc37c$var$setStateFromUrl(store.dispatch, urlBindings);
    return store.subscribe(()=>{
        const state = store.getState();
        $73a7c750c3dfc37c$var$setUrlFromState(state, urlBindings, keepNonManagedParams, history);
    });
}

});

parcelRegister("bRUzT", function(module, exports) {

$parcel$export(module.exports, "DISPOSE_ACTION", () => $b69e8859fbb50550$export$78be82e7e063a3fb);

const $b69e8859fbb50550$export$78be82e7e063a3fb = {
    type: (0, $167b7959815986d2$export$58387e80544dbf03)
};

});
const $167b7959815986d2$export$58387e80544dbf03 = 'COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION';


parcelRegister("wKznQ", function(module, exports) {

$parcel$export(module.exports, "getCachedFilters", () => $a26a3456dc06172d$export$cc165fee46da38d4);
$parcel$export(module.exports, "setCachedFilters", () => $a26a3456dc06172d$export$fb56bc6b9e534664);

var $bSSG7 = parcelRequire("bSSG7");
const $a26a3456dc06172d$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('software');
const $a26a3456dc06172d$var$CACHED_FILTERS_KEY = 'filters';
const $a26a3456dc06172d$var$getKey = (feature, projectId)=>`${feature}-${$a26a3456dc06172d$var$CACHED_FILTERS_KEY}.${projectId}`;
function $a26a3456dc06172d$export$cc165fee46da38d4(feature, projectId) {
    return $a26a3456dc06172d$var$localStorage.get($a26a3456dc06172d$var$getKey(feature, projectId)) || undefined;
}
function $a26a3456dc06172d$export$fb56bc6b9e534664(feature, projectId, filters) {
    if (filters && Object.entries(filters).length > 0) $a26a3456dc06172d$var$localStorage.set($a26a3456dc06172d$var$getKey(feature, projectId), filters);
    else $a26a3456dc06172d$var$localStorage.remove($a26a3456dc06172d$var$getKey(feature, projectId));
}

});

parcelRegister("97Kan", function(module, exports) {

$parcel$export(module.exports, "FlagsDispatcher", () => $4ddeb9f500a62e17$export$9e60e3d40b6e758f);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $fpHHI = parcelRequire("fpHHI");
const $4ddeb9f500a62e17$export$9e60e3d40b6e758f = ({ store: store, mapper: mapper })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fpHHI.Dispatcher), {
        store: store,
        mapper: mapper,
        showFlag: (0, $pa9q9.showFlag),
        dismissFlag: (0, $pa9q9.dismissFlag)
    });

});
parcelRegister("fpHHI", function(module, exports) {

$parcel$export(module.exports, "Dispatcher", () => $eef6139685bfb64e$export$ab054a1ef92eeb01);

var $5uXOq = parcelRequire("5uXOq");

var $1kijq = parcelRequire("1kijq");
const $eef6139685bfb64e$export$ab054a1ef92eeb01 = (props)=>{
    const { store: store, ...dispatcherProps } = props;
    const [lastStore, setLastStore] = (0, $5uXOq.useState)(store);
    if (store !== lastStore) setLastStore(store);
    const DispatcherComponent = (0, $5uXOq.useMemo)(()=>(0, $1kijq.createDispatcher)(store), [
        store
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DispatcherComponent, dispatcherProps);
};

});
parcelRegister("1kijq", function(module, exports) {

$parcel$export(module.exports, "createDispatcher", () => $c324e875f8c6fe8f$export$7b259d28468da15b);

var $5uXOq = parcelRequire("5uXOq");

var $kVVL1 = parcelRequire("kVVL1");

var $pa9q9 = parcelRequire("pa9q9");
const $c324e875f8c6fe8f$export$81c2f3c810206fa9 = (store)=>{
    if (!store) throw new Error('Store not available through direct injection or Provider context');
    if (!('addActionListener' in store) || !('removeActionListener' in store) || typeof store.addActionListener !== 'function' || typeof store.removeActionListener !== 'function') throw new Error("Your store doesn't support action listeners; please use the Tangerine store initialiser.");
    return store;
};
const $c324e875f8c6fe8f$export$8a44987212de21b = (store, result, showFlag, dismissFlag)=>{
    if (!result) return;
    if ((0, $pa9q9.isDismissFlag)(result)) dismissFlag(result);
    else if ((0, $pa9q9.isFlagComponent)(result)) {
        const FlagComponent = result;
        const FlagComponentWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kVVL1.Provider), {
                store: store
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FlagComponent, props));
        showFlag(FlagComponentWithProvider);
    } else showFlag(result);
};
const $c324e875f8c6fe8f$export$2bedce6f5250e28d = (action, state, store, mapper, showFlag, dismissFlag)=>{
    // handle batch middleware
    if ((0, $pa9q9.isBatchAction)(action)) action.payload.forEach((childAction)=>{
        if (childAction.type && typeof childAction.type === 'string') {
            const childResult = mapper(childAction, state);
            $c324e875f8c6fe8f$export$8a44987212de21b(store, childResult, showFlag, dismissFlag);
        }
    });
    else {
        const result = mapper(action, state);
        $c324e875f8c6fe8f$export$8a44987212de21b(store, result, showFlag, dismissFlag);
    }
};
const $c324e875f8c6fe8f$var$Dispatcher8 = (props)=>{
    const { store: storeUnchecked, mapper: mapper, showFlag: showFlag, dismissFlag: dismissFlag } = props;
    const store = (0, $5uXOq.useMemo)(()=>$c324e875f8c6fe8f$export$81c2f3c810206fa9(storeUnchecked), [
        storeUnchecked
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const handleAction = (action, state)=>{
            $c324e875f8c6fe8f$export$2bedce6f5250e28d(action, state, store, mapper, showFlag, dismissFlag);
        };
        store.addActionListener(handleAction);
        return ()=>store.removeActionListener(handleAction);
    }, [
        store,
        mapper,
        showFlag,
        dismissFlag
    ]);
    return null;
};
const $c324e875f8c6fe8f$var$Dispatcher8DefaultStore = (props)=>{
    const store = (0, $kVVL1.useStore)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
        ...props,
        store: store
    });
};
const $c324e875f8c6fe8f$export$7b259d28468da15b = (customStore)=>{
    const Dispatcher8CustomStore = (props)=>customStore ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c324e875f8c6fe8f$var$Dispatcher8, {
            ...props,
            store: customStore
        }) : null;
    return customStore ? Dispatcher8CustomStore : $c324e875f8c6fe8f$var$Dispatcher8DefaultStore;
};

});



parcelRegister("joFsm", function(module, exports) {

$parcel$export(module.exports, "default", () => $45670090ce80d9dc$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $5jlQc = parcelRequire("5jlQc");
const $45670090ce80d9dc$var$MemoryObserver = ({ getCustomData: getCustomData })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        const memoryReporter = new (0, $5jlQc.PollingMemoryReporter)(createAnalyticsEvent, getCustomData);
        memoryReporter.start();
        memoryReporter.setBucketTimeouts();
        return ()=>{
            memoryReporter.stop();
            memoryReporter.clearBucketTimeouts();
        };
    }, [
        createAnalyticsEvent,
        getCustomData
    ]);
    return null;
};
var $45670090ce80d9dc$export$2e2bcd8739ae039 = $45670090ce80d9dc$var$MemoryObserver;

});
parcelRegister("5jlQc", function(module, exports) {

$parcel$export(module.exports, "PollingMemoryReporter", () => $621c8fa9757e42da$export$3e76404af7b93e06);

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $4wNtT = parcelRequire("4wNtT");

var $aA83m = parcelRequire("aA83m");
const $621c8fa9757e42da$var$minMs = 60000; // number of ms in a minute
const $621c8fa9757e42da$export$54912f9240c8e5db = 20 * $621c8fa9757e42da$var$minMs;
const $621c8fa9757e42da$export$9f536c7d89257714 = [
    2 * $621c8fa9757e42da$var$minMs,
    10 * $621c8fa9757e42da$var$minMs
];
const $621c8fa9757e42da$export$c63950c55adb1607 = (createAnalyticsEvent, getCustomData)=>{
    try {
        const memoryUsageReport = (0, $aA83m.getMemoryUsageReport)();
        if (memoryUsageReport == null) return;
        const { sessionTime: sessionTime, performanceMemoryEntry: { jsHeapSizeLimit: jsHeapSizeLimit, totalJSHeapSize: totalJSHeapSize, usedJSHeapSize: usedJSHeapSize } } = memoryUsageReport;
        const customData = getCustomData ? getCustomData() : {};
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'memory tracked', {
            bucket: (0, $4wNtT.memoryBucketHandler).getBucket(usedJSHeapSize),
            sessionTime: sessionTime,
            sessionTimeBucket: (0, $4wNtT.sessionTimeBucketHandler).getBucket(sessionTime),
            jsHeapSizeLimit: jsHeapSizeLimit,
            totalJSHeapSize: totalJSHeapSize,
            usedJSHeapSize: usedJSHeapSize,
            ...customData
        });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('observability.memory-metrics.measure-and-report-memory', 'Failed to poll for memory usage');
    }
};
class $621c8fa9757e42da$export$3e76404af7b93e06 {
    constructor(createAnalyticsEvent, getCustomData){
        this.pollInterval = null;
        this.bucketTimeouts = null;
        this.report = ()=>{
            $621c8fa9757e42da$export$c63950c55adb1607(this.createAnalyticsEvent, this.getCustomData);
        };
        this.onVisibilityChange = ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const isHidden = window.document?.hidden === true;
            if (isHidden) this.stop();
            else {
                this.stop();
                this.start();
            }
        };
        this.createAnalyticsEvent = createAnalyticsEvent;
        this.getCustomData = getCustomData;
    }
    start() {
        if (this.pollInterval != null) return;
        this.report();
        // @ts-expect-error - TS2322 - Type 'Timer' is not assignable to type 'number'.
        this.pollInterval = setInterval(()=>{
            if (this.pollInterval == null) return;
            this.report();
        }, $621c8fa9757e42da$export$54912f9240c8e5db);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('visibilitychange', this.onVisibilityChange);
    }
    stop() {
        if (this.pollInterval != null) {
            clearInterval(this.pollInterval);
            this.pollInterval = null;
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
    }
    setBucketTimeouts() {
        this.bucketTimeouts = $621c8fa9757e42da$export$9f536c7d89257714.map((ms)=>setTimeout(()=>{
                this.report();
            }, ms));
    }
    clearBucketTimeouts() {
        this.bucketTimeouts?.forEach((timeout)=>{
            clearTimeout(timeout);
        });
    }
}

});
parcelRegister("4wNtT", function(module, exports) {

$parcel$export(module.exports, "memoryBucketHandler", () => $2459a841a83bbb5c$export$26aac2ead17b35e5);
$parcel$export(module.exports, "sessionTimeBucketHandler", () => $2459a841a83bbb5c$export$af08fe8a31c89520);
class $2459a841a83bbb5c$export$a9fa854dd2f29162 {
    constructor(buckets, options){
        this.buckets = buckets;
        this.formatLabel = options?.formatLabel ?? ((low, high)=>`${low}-${high ?? 'Inf'}`);
    }
    /**
	 * Returns the lowest matching bucket for this measurement.
	 *
	 * For example, if buckets are [0, 10, 20, 30] and the measurement is 15,
	 * this function will return 10 meaning this measurement is in the 10-20
	 * range.
	 */ getBucket(measurement) {
        const bucketIndex = this.buckets.findIndex((bucket)=>measurement < bucket);
        if (bucketIndex < 0) return this.formatLabel(this.buckets[this.buckets.length - 1]);
        return this.formatLabel(this.buckets[bucketIndex - 1], this.buckets[bucketIndex]);
    }
}
const $2459a841a83bbb5c$var$mbBytes = 1048576; // number of bytes in a MB
const $2459a841a83bbb5c$var$minMs = 60000; // number of ms in a minute
const $2459a841a83bbb5c$export$26aac2ead17b35e5 = new $2459a841a83bbb5c$export$a9fa854dd2f29162([
    0,
    100 * $2459a841a83bbb5c$var$mbBytes,
    200 * $2459a841a83bbb5c$var$mbBytes,
    400 * $2459a841a83bbb5c$var$mbBytes,
    800 * $2459a841a83bbb5c$var$mbBytes,
    1600 * $2459a841a83bbb5c$var$mbBytes,
    3200 * $2459a841a83bbb5c$var$mbBytes
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $2459a841a83bbb5c$var$mbBytes}-${highBucket != null ? highBucket / $2459a841a83bbb5c$var$mbBytes : 'Inf'}MB`
});
const $2459a841a83bbb5c$export$af08fe8a31c89520 = new $2459a841a83bbb5c$export$a9fa854dd2f29162([
    0,
    2 * $2459a841a83bbb5c$var$minMs,
    5 * $2459a841a83bbb5c$var$minMs,
    10 * $2459a841a83bbb5c$var$minMs,
    20 * $2459a841a83bbb5c$var$minMs
], {
    formatLabel: (lowBucket, highBucket)=>`${lowBucket / $2459a841a83bbb5c$var$minMs}-${highBucket != null ? highBucket / $2459a841a83bbb5c$var$minMs : 'Inf'}MIN`
});

});



parcelRegister("5sUih", function(module, exports) {

$parcel$export(module.exports, "default", () => $4af9e7daa433ec70$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $4af9e7daa433ec70$var$Ipcontext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    planId: undefined,
    scenarioId: undefined
});
var $4af9e7daa433ec70$export$2e2bcd8739ae039 = $4af9e7daa433ec70$var$Ipcontext;

});

parcelRegister("8PRuf", function(module, exports) {

$parcel$export(module.exports, "appBundleReadyMark", () => $0ec5205bf4957ca4$export$7e50945a65dd40e);
$parcel$export(module.exports, "prefetchApiReadyMark", () => $0ec5205bf4957ca4$export$17cbe723d23101d8);
$parcel$export(module.exports, "prefetchApiStartMark", () => $0ec5205bf4957ca4$export$887fadb22e7c7735);
$parcel$export(module.exports, "jswRenderStartMark", () => $0ec5205bf4957ca4$export$bd099c0a906f4b3f);
$parcel$export(module.exports, "jswCreateReduxStoreStartMark", () => $0ec5205bf4957ca4$export$d23ef9e7633e30e7);
$parcel$export(module.exports, "jswCreateReduxStoreEndMark", () => $0ec5205bf4957ca4$export$319da6d901948a6d);
$parcel$export(module.exports, "jswTransformCriticalDataStartMark", () => $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f);
$parcel$export(module.exports, "jswTransformCriticalDataEndMark", () => $0ec5205bf4957ca4$export$37e82663aa1e79a8);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedStartMark", () => $0ec5205bf4957ca4$export$21146514eacceb12);
$parcel$export(module.exports, "jswReduxSoftwareAppLoadedEndMark", () => $0ec5205bf4957ca4$export$4eb8d44ddb14424a);


var $hXKq5 = parcelRequire("hXKq5");
const $0ec5205bf4957ca4$export$7e50945a65dd40e = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ff834eccc35b9089));
const $0ec5205bf4957ca4$export$17cbe723d23101d8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$86b05e34d462ead8));
const $0ec5205bf4957ca4$export$887fadb22e7c7735 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$d6a604a7d9a390fb));
const $0ec5205bf4957ca4$export$bd099c0a906f4b3f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$3ae43cc1782d058f));
const $0ec5205bf4957ca4$export$d23ef9e7633e30e7 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$363f6703ffa600be));
const $0ec5205bf4957ca4$export$319da6d901948a6d = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$e87b74567b79c8));
const $0ec5205bf4957ca4$export$f0b6622cdc5c7e4f = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$99fe642459a8b02));
const $0ec5205bf4957ca4$export$37e82663aa1e79a8 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$ab1f5705fc8e0571));
const $0ec5205bf4957ca4$export$21146514eacceb12 = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$8c3a9046da692c35));
const $0ec5205bf4957ca4$export$4eb8d44ddb14424a = (0, $hXKq5.getPrefixedMarkName)((0, $ce556f125dee8174$export$5aa497d1efdcc5bf));

});
const $ce556f125dee8174$export$56940a9488e85199 = 'jira.fe.spa-';
const $ce556f125dee8174$export$45c4b6bf7935c69a = `${$ce556f125dee8174$export$56940a9488e85199}start`;
const $ce556f125dee8174$export$135c96ab5afee429 = 'ssr.spa.rendered';
const $ce556f125dee8174$export$ff834eccc35b9089 = 'appBundleReady';
const $ce556f125dee8174$export$86b05e34d462ead8 = 'prefetchApiReady';
const $ce556f125dee8174$export$d6a604a7d9a390fb = 'prefetchApiStart';
const $ce556f125dee8174$export$3ae43cc1782d058f = 'jswRenderStart';
const $ce556f125dee8174$export$363f6703ffa600be = 'jswCreateReduxStoreStart';
const $ce556f125dee8174$export$e87b74567b79c8 = 'jswCreateReduxStoreEnd';
const $ce556f125dee8174$export$99fe642459a8b02 = 'jswTransformCriticalDataStart';
const $ce556f125dee8174$export$ab1f5705fc8e0571 = 'jswTransformCriticalDataEnd';
const $ce556f125dee8174$export$8c3a9046da692c35 = 'jswReduxSoftwareAppLoadedStart';
const $ce556f125dee8174$export$5aa497d1efdcc5bf = 'jswReduxSoftwareAppLoadedEnd';
const $ce556f125dee8174$export$99c08ec92759c71c = 'tti-raf-mark';
const $ce556f125dee8174$export$48552baa9db8ce1d = 'tti-raf';

parcelRegister("hXKq5", function(module, exports) {

$parcel$export(module.exports, "getPrefixedMarkName", () => $f6cddc52a08e036c$export$c8f0e9837e7e9425);

const $f6cddc52a08e036c$export$c8f0e9837e7e9425 = (name)=>`${0, $ce556f125dee8174$export$56940a9488e85199}${name}`;

});


const $8631d6ce464ccf2e$export$9b8283d5878d2491 = 'BOARD';
const $8631d6ce464ccf2e$export$dedbdcc35e955187 = 'BACKLOG';
const $8631d6ce464ccf2e$export$ffff0a2c60bf4822 = 'ROADMAPS';
const $8631d6ce464ccf2e$export$78244dbb77cfa6b6 = 'UNKNOWN';
const $8631d6ce464ccf2e$export$b7dfe28569b170a1 = 'RESOURCES_CACHE_UPDATER_SOURCE';
const $8631d6ce464ccf2e$export$889129cf7f70997b = 'resourcesCacheSource';

parcelRegister("6jwh3", function(module, exports) {

$parcel$export(module.exports, "AsyncResourcesCacheWrapper", () => $15da7f00442fe8c1$export$3e6c6a80a1f4cb5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $15da7f00442fe8c1$var$LazyResourcesCacheWrapper = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("cFrpy")), {
    moduleId: "./src/packages/software/resource-invalidator/src/ui/resources-cache-wrapper/index.tsx"
});
const $15da7f00442fe8c1$export$3e6c6a80a1f4cb5a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-resource-invalidator-cache-wrapper",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15da7f00442fe8c1$var$LazyResourcesCacheWrapper, props));

});
parcelRegister("cFrpy", function(module, exports) {

let $938e93a21867eeff$var$load = (parcelRequire("28QjX"))(4);
module.exports = $938e93a21867eeff$var$load("aQ0zx").then(()=>parcelRequire('bicfN'));

});


parcelRegister("bG4jy", function(module, exports) {

$parcel$export(module.exports, "useKeyedRef", () => $f343aa3f0b870906$export$ccad618acd581663);
$parcel$export(module.exports, "useStableInitialization", () => $f343aa3f0b870906$export$bdd844d585890c3);
$parcel$export(module.exports, "toBeCalledOnceFor", () => $f343aa3f0b870906$export$1c120bbeb174f7ba);
$parcel$export(module.exports, "toBeCalledOnceForCleanup", () => $f343aa3f0b870906$export$ce1ac8d643745731);
/**
 * This store registry logic is required to ensure that we only initialize the store once per component instance in an SSR friendly way
 *
 * useMemo unfortunately will re-run in concurrent mode, and cause us to create the store multiple times.
 * useMemo also does not listen to changes to useRef so would always run twice even if we tried to update a ref to say it has already been run
 *
 * We can't useLayoutEffect or useEffect either as this will cause SSR to fail
 *
 * This leaves us with the only option of storing refs outside of react.
 *
 * Usage:
 * - Create a ref via useKeyedRef
 * - Use useStableInitialization and pass the ref from useKeyedRef to ensure that the store is only initialized once per component instance
 * - Use toBeCalledOnceFor with the above store to ensure that a function is only called once per store
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $f343aa3f0b870906$var$keyedRefs = {};
let $f343aa3f0b870906$var$keyedRefPrefixId = 0;
const $f343aa3f0b870906$var$keyedRefPrefixIdSingleton = {
    keyedRefPrefixIdRegistry: new WeakMap()
};
const $f343aa3f0b870906$export$6be37cd271eb53f = (createStoreFunc, key)=>{
    if (!$f343aa3f0b870906$var$keyedRefPrefixIdSingleton.keyedRefPrefixIdRegistry.has(createStoreFunc)) $f343aa3f0b870906$var$keyedRefPrefixIdSingleton.keyedRefPrefixIdRegistry.set(createStoreFunc, $f343aa3f0b870906$var$keyedRefPrefixId++);
    return `${String($f343aa3f0b870906$var$keyedRefPrefixIdSingleton.keyedRefPrefixIdRegistry.get(createStoreFunc))}_${key}`;
};
const $f343aa3f0b870906$export$ccad618acd581663 = (createStoreFunc, key)=>{
    const uniqueId = $f343aa3f0b870906$export$6be37cd271eb53f(createStoreFunc, key);
    if (!$f343aa3f0b870906$var$keyedRefs[uniqueId]) $f343aa3f0b870906$var$keyedRefs[uniqueId] = {
        key: key
    };
    (0, $5uXOq.useEffect)(()=>{
        $f343aa3f0b870906$var$keyedRefs[uniqueId] = undefined;
    }, [
        uniqueId
    ]);
    return $f343aa3f0b870906$var$keyedRefs[uniqueId];
};
const $f343aa3f0b870906$var$stableRefRegistrySingleton = {
    stableRefRegistry: new WeakMap()
};
const $f343aa3f0b870906$export$bdd844d585890c3 = (ref, factoryFunction, shouldUseStable)=>{
    const useStableFactory = ()=>{
        const { stableRefRegistry: stableRefRegistry } = $f343aa3f0b870906$var$stableRefRegistrySingleton;
        // A localRef will ensure better garbage collection in the WeakMap
        const [localRef] = (0, $5uXOq.useState)(()=>ref || {
                no: 'none'
            });
        if (!stableRefRegistry.has(localRef)) stableRefRegistry.set(localRef, factoryFunction());
        const dispose = ()=>{
            if (stableRefRegistry.has(localRef)) stableRefRegistry.delete(localRef);
        };
        const result = [
            stableRefRegistry.get(localRef),
            dispose
        ];
        return result;
    };
    const useMemoryFactory = ()=>(0, $5uXOq.useMemo)(()=>[
                factoryFunction(),
                (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
            ], []);
    const factoryMethod = shouldUseStable ? useStableFactory : useMemoryFactory;
    return factoryMethod();
};
const $f343aa3f0b870906$var$storeInitializationRegistrySingleton = {
    storeInitializationRegistry: new WeakSet()
};
const $f343aa3f0b870906$export$1c120bbeb174f7ba = (callingFor, cb)=>{
    // this function contains a side effect and cannot be called once for a given store
    const storeInitializationRegistry = $f343aa3f0b870906$var$storeInitializationRegistrySingleton.storeInitializationRegistry;
    if (storeInitializationRegistry.has(callingFor)) // already initialized
    return;
    storeInitializationRegistry.add(callingFor);
    cb();
};
const $f343aa3f0b870906$export$ce1ac8d643745731 = (callingFor)=>{
    const storeInitializationRegistry = $f343aa3f0b870906$var$storeInitializationRegistrySingleton.storeInitializationRegistry;
    if (storeInitializationRegistry.has(callingFor)) storeInitializationRegistry.delete(callingFor);
};
const $f343aa3f0b870906$export$59431e9385c7d472 = ()=>{
    // keyedRefs
    Object.keys($f343aa3f0b870906$var$keyedRefs).forEach((key)=>{
        $f343aa3f0b870906$var$keyedRefs[key] = undefined;
    });
    // storeInitializationRegistry
    $f343aa3f0b870906$var$storeInitializationRegistrySingleton.storeInitializationRegistry = new WeakSet();
    // stableRefRegistry
    $f343aa3f0b870906$var$stableRefRegistrySingleton.stableRefRegistry = new WeakMap();
    // keyedRefUniquePrefixRegistry
    $f343aa3f0b870906$var$keyedRefPrefixId = 0;
    $f343aa3f0b870906$var$keyedRefPrefixIdSingleton.keyedRefPrefixIdRegistry = new WeakMap();
};

});

parcelRegister("iUagi", function(module, exports) {

$parcel$export(module.exports, "isTailoredViewExperimentEnabled", () => $6698347a19479bea$export$f8f18cae4b906873);
$parcel$export(module.exports, "isInAddPeopleButtonOpenTMPControlCohort", () => $6698347a19479bea$export$ebdf1290b0dde9e3);
$parcel$export(module.exports, "isViewSettingAsPanelExpEnabledWithNoExposure", () => $6698347a19479bea$export$6f295af995afef94);
/**
 * Feature flags convention: go/frontend-feature-flags
 */ 
var $6s1PB = parcelRequire("6s1PB");

var $co1wz = parcelRequire("co1wz");

var $4R6GH = parcelRequire("4R6GH");
const $6698347a19479bea$export$f7ab30339d40bcd = ()=>(0, $co1wz.ff)('jsw.pollinator.tenants');
const $6698347a19479bea$export$f8f18cae4b906873 = ()=>(0, $6s1PB.expValEquals)('jsw_additional_card_fields_in_view_settings', 'cohort', 'variation');
function $6698347a19479bea$export$ebdf1290b0dde9e3() {
    return (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'control');
}
const $6698347a19479bea$export$6f295af995afef94 = ()=>(0, $4R6GH.fg)('jira_view_settings_additional_fields');

});

parcelRegister("i6HlS", function(module, exports) {

$parcel$export(module.exports, "flagsMapper", () => $c00f953137ed60c6$export$4de5eb17326eea98);

var $5uXOq = parcelRequire("5uXOq");

var $6c57g = parcelRequire("6c57g");

var $4cr9K = parcelRequire("4cr9K");

var $4tEQ4 = parcelRequire("4tEQ4");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $3n582 = parcelRequire("3n582");

var $cY26q = parcelRequire("cY26q");

var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $cW3pH = parcelRequire("cW3pH");

var $3i1Rr = parcelRequire("3i1Rr");

var $gYo9d = parcelRequire("gYo9d");

var $03PHH = parcelRequire("03PHH");

var $bri2z = parcelRequire("bri2z");

var $2obSb = parcelRequire("2obSb");

var $elCuX = parcelRequire("elCuX");
const $c00f953137ed60c6$export$4de5eb17326eea98 = (action)=>{
    switch(action.type){
        case 0, $4cr9K.SHOW_ERROR_FLAG_FROM_SWAG:
            return (0, $4tEQ4.extractFlagFromAction)(action);
        case 0, $bkCF5.ISSUE_CREATE_FILTERED_V2:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bri2z.default), {
                    ...props,
                    cardKeys: action.payload.cardKeys,
                    sprints: action.payload.sprints,
                    ...(0, $4R6GH.fg)('fix-gryf-a11y-issues-2') ? {
                        isAutoDismissed: false
                    } : {}
                });
        case 0, $bkCF5.ISSUE_CREATE_MOVED_BETWEEN_SWIMLANES:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bri2z.default), {
                    ...props,
                    cardKeys: action.payload.cardKeys,
                    issueMovedBetweenSwimlanes: true
                });
        case 0, $ls4NM.CARD_CREATE_UNMAPPED:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $03PHH.default), {
                    ...props,
                    cardKeys: action.payload.cardKeys,
                    ...(0, $4R6GH.fg)('fix-gryf-a11y-issues-2') ? {
                        isAutoDismissed: false
                    } : {}
                });
        case 0, $bkCF5.CARD_CREATE_FILTERED_OUT_IN_IP_BOARD:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gYo9d.default), {
                    ...props,
                    cardTypeName: action.payload.cardTypeName
                });
        case 0, $ls4NM.CARD_CREATE_GLOBAL:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6c57g.CardCreateGlobalFlag), {
                    ...props,
                    cardKeys: action.payload.cardKeys,
                    ...(0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? {
                        issueType: action.payload.issueType
                    } : {}
                });
        case 0, $cY26q.FILTERED_CARD_FAILURE:
        case 0, $cY26q.REFILTER_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2obSb.default), props);
        case 0, $cW3pH.SHOW_MISSING_ISSUE_TYPE_MESSAGE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $elCuX.default), {
                    ...props,
                    missingIssueType: action.payload
                });
        case 0, $3n582.FETCH_CARD_COVERS_FAILURE:
            return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3i1Rr.CardCoverToggleFailedFlag), props);
        default:
            return undefined;
    }
};

});
parcelRegister("6c57g", function(module, exports) {

$parcel$export(module.exports, "CardCreateGlobalFlag", () => $44cad0f844ccec7d$export$b6918b93a6420e06);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $d4xRU = parcelRequire("d4xRU");
var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $64qgp = parcelRequire("64qgp");

var $24y3R = parcelRequire("24y3R");

var $eCbBU = parcelRequire("eCbBU");
const $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID = 'jira-issue-create.modal.create-form.success-flag';
const $44cad0f844ccec7d$export$b6918b93a6420e06 = ({ onDismissed: onDismissed, id: id, cardKeys: cardKeys, isAutoDismissed: isAutoDismissed = true, issueType: issueType })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isCopied, setCopied] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        let timeoutId;
        if (isCopied) timeoutId = setTimeout(()=>{
            setCopied(false);
        }, 2000);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        isCopied
    ]);
    const issueDiscoveryUrl = (0, $24y3R.getIssueDiscoveryUrl)(cardKeys);
    const copyToClipboard = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator')) globalThis.navigator.clipboard.writeText(`${globalThis.window.location.origin}${issueDiscoveryUrl}`);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(`${window.location.origin}${issueDiscoveryUrl}`);
        setCopied(true);
    }, [
        issueDiscoveryUrl
    ]);
    const getFlagTitle = ()=>{
        if (cardKeys.length <= 1 && issueType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return formatMessage((0, $eCbBU.default).createSuccessFlagTitleIssueTerminologyRefreshM4, {
            issueKey: cardKeys[0],
            workType: issueType
        });
        return cardKeys.length > 1 ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh : (0, $eCbBU.default).multiplesIssuesCreatedSuccessFlagTitle, {
            issueCount: cardKeys.length
        }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eCbBU.default).createSuccessFlagTitleIssueTermRefresh : (0, $eCbBU.default).createSuccessFlagTitle, {
            issueKey: cardKeys[0]
        });
    };
    const getViewMessage = ()=>{
        if (issueType && (0, $64qgp.isWorkTypeAvgLength)(issueType) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return cardKeys.length > 1 ? (0, $eCbBU.default).viewIssueLinkMultipleTextIssueTerminologyRefreshM4 : (0, $eCbBU.default).viewIssueLinkTextIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $eCbBU.default).viewIssueLinkTextIssueTermRefresh;
        return (0, $eCbBU.default).viewIssueLinkText;
    };
    const actions = [
        {
            content: formatMessage(getViewMessage(), {
                numIssues: cardKeys.length,
                workType: issueType
            }),
            href: issueDiscoveryUrl
        },
        {
            content: isCopied ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($44cad0f844ccec7d$var$CopySuccess, null, formatMessage((0, $eCbBU.default).linkCopied)) : formatMessage((0, $eCbBU.default).copyLink),
            onClick: ()=>{
                copyToClipboard();
            }
        }
    ];
    if (!isAutoDismissed && (0, $4R6GH.fg)('show-create-success-flag-once-in-backlog-page')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID,
        "data-issue-key": cardKeys[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: id,
        onDismissed: onDismissed,
        title: getFlagTitle(),
        actions: actions
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": $44cad0f844ccec7d$var$GLOBAL_CREATE_POLLINATOR_DATA_TEST_ID,
        "data-issue-key": cardKeys[0]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: getFlagTitle(),
        actions: actions
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $44cad0f844ccec7d$var$CopySuccess = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazy4f1",
            __cmplp.className
        ])
    });
});

});
parcelRegister("64qgp", function(module, exports) {

$parcel$export(module.exports, "isWorkTypeAvgLength", () => $75f802d4e52cf385$export$cc4247ae0afa23ac);
const $75f802d4e52cf385$var$WORK_TYPE_AVG_LENGTH = 30;
const $75f802d4e52cf385$export$cc4247ae0afa23ac = (workType)=>workType.length < $75f802d4e52cf385$var$WORK_TYPE_AVG_LENGTH;

});

parcelRegister("24y3R", function(module, exports) {

$parcel$export(module.exports, "getIssueDiscoveryUrl", () => $ebd8351448f87226$export$852450339fdb3b37);
const $ebd8351448f87226$export$852450339fdb3b37 = (cardKeys)=>{
    if (cardKeys.length > 1) {
        const issueKeys = cardKeys.join(',');
        const jqlSearch = encodeURIComponent(`issueKey in (${issueKeys})`);
        return `/issues/?jql=${jqlSearch}`;
    }
    return `/browse/${cardKeys[0]}`;
};

});

parcelRegister("eCbBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $a405eb29c4610c88$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a405eb29c4610c88$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createSuccessFlagTitle: {
        "id": "software-flags.card-create-global.create-success-flag-title",
        "defaultMessage": "You've created \"{issueKey}\" issue."
    },
    viewIssueLinkText: {
        "id": "software-flags.card-create-global.view-issue-link-text",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    multiplesIssuesCreatedSuccessFlagTitle: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title",
        "defaultMessage": "You've created {issueCount, plural, one {# issue} other {# issues}}."
    },
    copyLink: {
        "id": "software-flags.card-create-global.copy-link",
        "defaultMessage": "Copy link"
    },
    linkCopied: {
        "id": "software-flags.card-create-global.link-copied",
        "defaultMessage": "Copied"
    },
    createSuccessFlagTitleIssueTermRefresh: {
        "id": "software-flags.card-create-global.create-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created \"{issueKey}\" work item."
    },
    viewIssueLinkTextIssueTermRefresh: {
        "id": "software-flags.card-create-global.view-issue-link-text-issue-term-refresh",
        "defaultMessage": "View{numIssues, plural, one {} other { work items}}"
    },
    multiplesIssuesCreatedSuccessFlagTitleIssueTermRefresh: {
        "id": "software-flags.card-create-global.multiples-issues-created-success-flag-title-issue-term-refresh",
        "defaultMessage": "You've created {issueCount, plural, one {# work item} other {# work items}}."
    },
    createSuccessFlagTitleIssueTerminologyRefreshM4: {
        "id": "software-flags.card-create-global.create-success-flag-title-issue-terminology-refresh-m4",
        "defaultMessage": "Created {workType} \"{issueKey}\""
    },
    viewIssueLinkTextIssueTerminologyRefreshM4: {
        "id": "software-flags.card-create-global.view-issue-link-text-issue-terminology-refresh-m4",
        "defaultMessage": "View {workType}"
    },
    viewIssueLinkMultipleTextIssueTerminologyRefreshM4: {
        "id": "software-flags.card-create-global.view-issue-link-multiple-text-issue-terminology-refresh-m4",
        "defaultMessage": "View work items"
    }
});

});


parcelRegister("4cr9K", function(module, exports) {

$parcel$export(module.exports, "SHOW_ERROR_FLAG_FROM_SWAG", () => $dcafaf5dc15a1c9d$export$849b6aff5e6c9763);
$parcel$export(module.exports, "showErrorFlag", () => $dcafaf5dc15a1c9d$export$dfa2148cdb92917d);
$parcel$export(module.exports, "XSRF_CHECK_FAILED", () => $dcafaf5dc15a1c9d$export$653597ecd43ee3b5);
const $dcafaf5dc15a1c9d$export$849b6aff5e6c9763 = 'SHOW_ERROR_FLAG_FROM_SWAG';
const $dcafaf5dc15a1c9d$export$dfa2148cdb92917d = (error)=>({
        type: $dcafaf5dc15a1c9d$export$849b6aff5e6c9763,
        payload: error
    });
const $dcafaf5dc15a1c9d$export$653597ecd43ee3b5 = 'XSRF_CHECK_FAILED';

});

parcelRegister("4tEQ4", function(module, exports) {

$parcel$export(module.exports, "getErrorFlag", () => $854596c2afd2e9d8$export$7a23a73c35436772);
$parcel$export(module.exports, "extractFlagFromAction", () => $854596c2afd2e9d8$export$6783b18b1c9d1ab1);

var $9XE6b = parcelRequire("9XE6b");

var $467lJ = parcelRequire("467lJ");

var $4cr9K = parcelRequire("4cr9K");

var $i5xPZ = parcelRequire("i5xPZ");

var $cNrxd = parcelRequire("cNrxd");
const $854596c2afd2e9d8$export$2cf9ab1b4d75e34e = (error)=>{
    const { graphQLErrors: graphQLErrors } = error;
    if (!graphQLErrors || graphQLErrors.length === 0) return null;
    const applicationError = graphQLErrors.find((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'errorType'
        ], false));
    if (!applicationError) return null;
    return {
        errorType: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(applicationError, [
            'extensions',
            'errorType'
        ], '')
    };
};
const $854596c2afd2e9d8$export$eeae51b1c2ad1cfa = (error)=>{
    if ((0, $cNrxd.isFetchError)(error)) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null),
        userMessage: null
    };
    const { graphQLErrors: graphQLErrors, networkError: networkError } = error;
    if (networkError) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
            'statusCode'
        ], null),
        userMessage: null
    };
    if (graphQLErrors.length > 0) return {
        statusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0,
            'extensions',
            'statusCode'
        ], null),
        userMessage: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(graphQLErrors, [
            0,
            'extensions',
            'userMessage'
        ], null)
    };
    return {
        statusCode: null,
        userMessage: null
    };
};
const $854596c2afd2e9d8$var$isApplicationError = (error)=>{
    const applicationError = $854596c2afd2e9d8$export$2cf9ab1b4d75e34e(error);
    return applicationError?.errorType === (0, $4cr9K.XSRF_CHECK_FAILED);
};
const $854596c2afd2e9d8$export$7a23a73c35436772 = (error)=>{
    if (!(0, $cNrxd.isFetchError)(error)) {
        // check if any error contains "errorType", and process prior to http-status-code
        if ($854596c2afd2e9d8$var$isApplicationError(error)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return {
            type: 'error',
            title: (0, $i5xPZ.default).xsrfCheckFailedTitle,
            description: (0, $i5xPZ.default).xsrfCheckFailedDescription,
            messageId: 'software-swag.services.error-to-flag.flag.error.xsrf-check-failed',
            messageType: 'transactional',
            error: error
        };
    }
    const { statusCode: httpStatusCode, userMessage: userMessage } = $854596c2afd2e9d8$export$eeae51b1c2ad1cfa(error);
    if ((httpStatusCode === 400 || httpStatusCode === 403) && userMessage) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return {
        type: 'error',
        title: (0, $467lJ.default).genericError().title,
        description: [
            (0, $i5xPZ.default).genericErrorDescription,
            {
                userMessage: userMessage
            }
        ],
        messageId: 'software-swag.services.error-to-flag.flag.error.generic-error',
        messageType: 'transactional',
        error: error
    };
    if (httpStatusCode === 401) {
        const unauthorizedError = (0, $467lJ.default).unauthorized();
        unauthorizedError.error = error;
        return unauthorizedError;
    }
    if (httpStatusCode === 403) {
        const forbiddenError = (0, $467lJ.default).forbidden();
        forbiddenError.error = error;
        return forbiddenError;
    }
    const genericError = (0, $467lJ.default).genericError();
    genericError.error = error;
    return genericError;
};
const $854596c2afd2e9d8$export$6783b18b1c9d1ab1 = (action)=>{
    const { payload: error } = action;
    if ((0, $cNrxd.isSwagError)(error) || (0, $cNrxd.isFetchError)(error)) return $854596c2afd2e9d8$export$7a23a73c35436772(error);
    // eslint-disable-next-line no-console
    console.error('Action showErrorFlag(error) contains invalid error format. \n Make sure you are using query$() or mutation$() utils from @atlassian/jira-software-swag in /rest layer');
    return undefined;
};

});
parcelRegister("467lJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc639d9ac2372482$export$2e2bcd8739ae039);

var $8BkAH = parcelRequire("8BkAH");

var $8hiuq = parcelRequire("8hiuq");

var $l7mS2 = parcelRequire("l7mS2");

var $5jDRa = parcelRequire("5jDRa");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$dc639d9ac2372482$export$2e2bcd8739ae039 = {
    forbidden: $8BkAH.default,
    genericError: $8hiuq.default,
    serverError: $l7mS2.default,
    unauthorized: $5jDRa.default
};

});
parcelRegister("8BkAH", function(module, exports) {

$parcel$export(module.exports, "default", () => $47acdb71562a5159$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $47acdb71562a5159$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.forbidden.title",
        "defaultMessage": "You don't have permission to do that"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.forbidden.description",
        "defaultMessage": "Ask your Jira admin for help."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$47acdb71562a5159$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $47acdb71562a5159$var$messages.title,
        description: $47acdb71562a5159$var$messages.description,
        messageId: 'flags.ui.configurations.errors.forbidden.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("8hiuq", function(module, exports) {

$parcel$export(module.exports, "default", () => $ffd4533bf12eb3f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ffd4533bf12eb3f1$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.generic-error.title",
        "defaultMessage": "Something's gone wrong"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.generic-error.description",
        "defaultMessage": "Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$ffd4533bf12eb3f1$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $ffd4533bf12eb3f1$var$messages.title,
        description: $ffd4533bf12eb3f1$var$messages.description,
        messageId: 'flags.ui.configurations.errors.generic-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("l7mS2", function(module, exports) {

$parcel$export(module.exports, "default", () => $31a915dd4c1d2142$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $31a915dd4c1d2142$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.server-error.title",
        "defaultMessage": "We're having some trouble"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.server-error.description",
        "defaultMessage": "Something went wrong on our end. Refresh the page and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31a915dd4c1d2142$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $31a915dd4c1d2142$var$messages.title,
        description: $31a915dd4c1d2142$var$messages.description,
        messageId: 'flags.ui.configurations.errors.server-error.flag.error',
        messageType: 'transactional'
    });

});

parcelRegister("5jDRa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8754751d720d57d4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $8754751d720d57d4$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "platform.ui.flags.flags.errors.unauthorized.title",
        "defaultMessage": "You're logged out"
    },
    description: {
        "id": "platform.ui.flags.flags.errors.unauthorized.description",
        "defaultMessage": "Log back in and try again."
    }
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8754751d720d57d4$export$2e2bcd8739ae039 = ()=>({
        type: 'error',
        title: $8754751d720d57d4$var$messages.title,
        description: $8754751d720d57d4$var$messages.description,
        messageId: 'flags.ui.configurations.errors.unauthorized.flag.error',
        messageType: 'transactional'
    });

});


parcelRegister("i5xPZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $61a9111c121ba41d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $61a9111c121ba41d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    genericErrorDescription: {
        "id": "software-swag.common.generic-error-description",
        "defaultMessage": "{userMessage}"
    },
    xsrfCheckFailedTitle: {
        "id": "software-swag.common.xsrf-check-failed-title",
        "defaultMessage": "Our session has expired"
    },
    xsrfCheckFailedDescription: {
        "id": "software-swag.common.xsrf-check-failed-description",
        "defaultMessage": "Refresh the page and try again"
    }
});

});

parcelRegister("cNrxd", function(module, exports) {

$parcel$export(module.exports, "SwagError", () => $116bdf44a4142aa3$export$c6b77322a15ada4f);
$parcel$export(module.exports, "isJson", () => $116bdf44a4142aa3$export$952e1d8683e4d0c4);
$parcel$export(module.exports, "isFetchError", () => $116bdf44a4142aa3$export$96f7e6db4105d70c);
$parcel$export(module.exports, "isSwagError", () => $116bdf44a4142aa3$export$7d7253f3a1a7c031);

var $jJZqs = parcelRequire("jJZqs");
const $116bdf44a4142aa3$var$generateErrorMessage = (err)=>{
    let message = '';
    // If we have GraphQL errors present, add that to the error message.
    if (Array.isArray(err.graphQLErrors) && err.graphQLErrors.length !== 0) err.graphQLErrors.forEach((graphQLError)=>{
        const errorMessage = graphQLError ? graphQLError.message : 'Error message not found.';
        message += `GraphQL error: ${errorMessage}\n`;
    });
    if (err.networkError) message += `Network error: ${err.networkError.message}\n`;
    // strip newline from the end of the message
    message = message.replace(/\n$/, '');
    return message;
};
class $116bdf44a4142aa3$export$c6b77322a15ada4f extends Error {
    constructor({ graphQLErrors: graphQLErrors, networkError: networkError, errorMessage: errorMessage, traceId: traceId = '' }){
        super(errorMessage), this.graphQLErrors = [], this.networkError = null, // SWAG trace id, extracted from "atl-traceid" response-header
        // Helps to find relevant error in SWAG logs
        this.traceId = '';
        this.graphQLErrors = graphQLErrors || [];
        this.networkError = networkError || null;
        if (!errorMessage) this.message = $116bdf44a4142aa3$var$generateErrorMessage(this);
        else this.message = errorMessage;
        this.name = this.constructor.name;
        this.traceId = traceId;
        this.cause = networkError || graphQLErrors?.[0];
        if (typeof Error.captureStackTrace === 'function') Error.captureStackTrace(this, this.constructor);
        else this.stack = new Error(this.message).stack;
    }
    skipSentry() {
        return this.networkError != null || this.graphQLErrors.length > 0;
    }
}
const $116bdf44a4142aa3$export$952e1d8683e4d0c4 = (value)=>{
    try {
        JSON.parse(value);
    } catch (e) {
        return false;
    }
    return true;
};
const $116bdf44a4142aa3$export$96f7e6db4105d70c = (error)=>error !== null && typeof error === 'object' && error instanceof (0, $jJZqs.default);
const $116bdf44a4142aa3$export$7d7253f3a1a7c031 = (error)=>{
    if (error !== null && typeof error === 'object' && error instanceof $116bdf44a4142aa3$export$c6b77322a15ada4f) return 'graphQLErrors' in error || 'networkError' in error;
    return false;
};

});


parcelRegister("3n582", function(module, exports) {

$parcel$export(module.exports, "FETCH_CARD_COVERS", () => $443a314e0c613ebf$export$534c677d2df3db30);
$parcel$export(module.exports, "fetchCardCovers", () => $443a314e0c613ebf$export$a33810576a7257f6);
$parcel$export(module.exports, "FETCH_CARD_COVERS_FAILURE", () => $443a314e0c613ebf$export$d0e94650aa3d127e);
$parcel$export(module.exports, "fetchCardCoversFailure", () => $443a314e0c613ebf$export$cd46ad5e4990a08b);
const $443a314e0c613ebf$export$534c677d2df3db30 = 'state.actions.card-covers.FETCH_CARD_COVERS';
const $443a314e0c613ebf$export$a33810576a7257f6 = (payload, meta)=>({
        type: $443a314e0c613ebf$export$534c677d2df3db30,
        payload: payload,
        meta: meta
    });
const $443a314e0c613ebf$export$d0e94650aa3d127e = 'state.actions.card-covers.FETCH_CARD_COVERS_FAILURE';
const $443a314e0c613ebf$export$cd46ad5e4990a08b = (meta)=>({
        type: $443a314e0c613ebf$export$d0e94650aa3d127e,
        meta: meta
    });

});

parcelRegister("cY26q", function(module, exports) {

$parcel$export(module.exports, "FILTERED_CARD_SUCCESS", () => $0b8f662f946cb57b$export$8f5834f2d50f84b5);
$parcel$export(module.exports, "filteredCardsSuccess", () => $0b8f662f946cb57b$export$aa1ef8dc8bb1be1b);
$parcel$export(module.exports, "FILTERED_CARD_CLEAR", () => $0b8f662f946cb57b$export$507d49f4a5857f49);
$parcel$export(module.exports, "clearFilteredCards", () => $0b8f662f946cb57b$export$81b4fe421a8e6fe4);
$parcel$export(module.exports, "REFILTER_SUCCESS", () => $0b8f662f946cb57b$export$4d3b992e541cd8ce);
$parcel$export(module.exports, "refilterSuccess", () => $0b8f662f946cb57b$export$a76ad4df662ec1fb);
$parcel$export(module.exports, "REFILTER_FAILURE", () => $0b8f662f946cb57b$export$f09f82741fa84c27);
$parcel$export(module.exports, "refilterFailure", () => $0b8f662f946cb57b$export$138c508cb95b66c3);
$parcel$export(module.exports, "FILTERED_CARD_FAILURE", () => $0b8f662f946cb57b$export$a17483c6b4ef650d);
$parcel$export(module.exports, "filteredCardsFailed", () => $0b8f662f946cb57b$export$8357ffeaf5f8e6b8);
const $0b8f662f946cb57b$export$8f5834f2d50f84b5 = 'state.actions.card.filtered-cards.FILTERED_CARD_SUCCESS';
const $0b8f662f946cb57b$export$aa1ef8dc8bb1be1b = (cardIds, numCustomFiltersApplied = 0, numIssueIds = 0, analyticsEvent)=>({
        type: $0b8f662f946cb57b$export$8f5834f2d50f84b5,
        payload: cardIds,
        meta: {
            analyticsEvent: analyticsEvent,
            numIssueIds: numIssueIds,
            numCustomFiltersApplied: numCustomFiltersApplied
        }
    });
const $0b8f662f946cb57b$export$507d49f4a5857f49 = 'state.actions.card.filtered-cards.FILTERED_CARD_CLEAR';
const $0b8f662f946cb57b$export$81b4fe421a8e6fe4 = ()=>({
        type: $0b8f662f946cb57b$export$507d49f4a5857f49
    });
const $0b8f662f946cb57b$export$4d3b992e541cd8ce = 'state.actions.card.filtered-cards.REFILTER_SUCCESS';
const $0b8f662f946cb57b$export$a76ad4df662ec1fb = (excludedCardIds, filteredCardIds)=>({
        type: $0b8f662f946cb57b$export$4d3b992e541cd8ce,
        payload: {
            excludedCardIds: excludedCardIds,
            filteredCardIds: filteredCardIds
        }
    });
const $0b8f662f946cb57b$export$f09f82741fa84c27 = 'state.actions.card.filtered-cards.REFILTER_FAILURE';
const $0b8f662f946cb57b$export$138c508cb95b66c3 = (error)=>({
        type: $0b8f662f946cb57b$export$f09f82741fa84c27,
        payload: {
            error: error
        }
    });
const $0b8f662f946cb57b$export$a17483c6b4ef650d = 'state.actions.card.filtered-cards.FILTERED_CARD_FAILURE';
const $0b8f662f946cb57b$export$8357ffeaf5f8e6b8 = (error, analyticsEvent)=>({
        type: $0b8f662f946cb57b$export$a17483c6b4ef650d,
        payload: {
            error: error
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });

});

parcelRegister("bkCF5", function(module, exports) {

$parcel$export(module.exports, "FLAG_DISMISSED", () => $301f2494ee9de7ef$export$5c5fc6956b7600ea);
$parcel$export(module.exports, "dismissFlag", () => $301f2494ee9de7ef$export$900a08a292ad23cd);
$parcel$export(module.exports, "SHOW_UNDO_FLAG", () => $301f2494ee9de7ef$export$a811985861f141bb);
$parcel$export(module.exports, "showUndoFlag", () => $301f2494ee9de7ef$export$2646d8864c5ffec);
$parcel$export(module.exports, "UNDO_FLAG_PERFORM_UNDO", () => $301f2494ee9de7ef$export$898c0a8fad557fd2);
$parcel$export(module.exports, "undoFlagPerformUndo", () => $301f2494ee9de7ef$export$a09bb6e3a530a563);
$parcel$export(module.exports, "UNDO_FLAG_PERFORM_COMMIT", () => $301f2494ee9de7ef$export$e3a088c896dc9670);
$parcel$export(module.exports, "undoFlagPerformCommit", () => $301f2494ee9de7ef$export$b5092a88314b2b7d);
$parcel$export(module.exports, "FLAG_CREATED_ISSUE_IS_FILTERED", () => $301f2494ee9de7ef$export$cce2f64939b3097a);
$parcel$export(module.exports, "ISSUE_CREATE_FILTERED_V2", () => $301f2494ee9de7ef$export$3d3099932583397e);
$parcel$export(module.exports, "issueCreateFilteredV2", () => $301f2494ee9de7ef$export$fa537ae37a1502ad);
$parcel$export(module.exports, "ISSUE_CREATE_MOVED_BETWEEN_SWIMLANES", () => $301f2494ee9de7ef$export$d625226adb2f3b49);
$parcel$export(module.exports, "issueCreateMovedBetweenJqlSwimlanes", () => $301f2494ee9de7ef$export$2002a6bc80b9565e);
$parcel$export(module.exports, "CARD_CREATE_FILTERED_OUT_IN_IP_BOARD", () => $301f2494ee9de7ef$export$7cf0dcc6369bfe2b);
$parcel$export(module.exports, "cardCreateFilteredOutInIPBoard", () => $301f2494ee9de7ef$export$2c2745cdb0117bd5);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $301f2494ee9de7ef$export$5c5fc6956b7600ea = 'state.actions.flags.FLAG_DISMISSED';
const $301f2494ee9de7ef$export$900a08a292ad23cd = (flagData)=>({
        type: $301f2494ee9de7ef$export$5c5fc6956b7600ea,
        payload: flagData
    });
const $301f2494ee9de7ef$export$a811985861f141bb = 'state.actions.flags.SHOW_UNDO_FLAG';
const $301f2494ee9de7ef$export$2646d8864c5ffec = ({ id: id, titleMessage: titleMessage, descriptionMessage: descriptionMessage, links: links, context: context })=>({
        type: $301f2494ee9de7ef$export$a811985861f141bb,
        meta: (0, $sdxnu.undoFlagMeta)({
            id: `${$301f2494ee9de7ef$export$a811985861f141bb}::${id}`,
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            context: context,
            links: links
        })
    });
const $301f2494ee9de7ef$export$898c0a8fad557fd2 = 'state.actions.flags.UNDO_FLAG_PERFORM_UNDO';
const $301f2494ee9de7ef$export$a09bb6e3a530a563 = (flagId)=>({
        type: $301f2494ee9de7ef$export$898c0a8fad557fd2,
        payload: {
            flagId: flagId
        }
    });
const $301f2494ee9de7ef$export$e3a088c896dc9670 = 'state.actions.flags.UNDO_FLAG_PERFORM_COMMIT';
const $301f2494ee9de7ef$export$b5092a88314b2b7d = (flagId)=>({
        type: $301f2494ee9de7ef$export$e3a088c896dc9670,
        payload: {
            flagId: flagId
        }
    });
const $301f2494ee9de7ef$export$cce2f64939b3097a = 'state.actions.flags.FLAG_CREATED_ISSUE_IS_FILTERED';
const $301f2494ee9de7ef$export$102c376be77e2ca5 = (issue)=>({
        type: $301f2494ee9de7ef$export$cce2f64939b3097a,
        payload: issue,
        meta: (0, $sdxnu.warningFlagMeta)({
            id: $301f2494ee9de7ef$export$cce2f64939b3097a,
            titleMessage: (0, $7AVqz.default).createdIssueIsFilteredTitle,
            // Overridden
            descriptionMessage: (0, $7AVqz.default).createdIssueIsFilteredDescription,
            // Overridden
            context: {
                issueKey: issue.key,
                issueId: issue.id
            }
        })
    });
const $301f2494ee9de7ef$export$3d3099932583397e = 'state.actions.flags.ISSUE_CREATE_FILTERED_V2';
const $301f2494ee9de7ef$export$fa537ae37a1502ad = (cardKeys, sprints, filteredOnServer)=>({
        type: $301f2494ee9de7ef$export$3d3099932583397e,
        payload: {
            cardKeys: cardKeys,
            sprints: sprints,
            filteredOnServer: filteredOnServer
        }
    });
const $301f2494ee9de7ef$export$d625226adb2f3b49 = 'state.actions.flags.ISSUE_CREATE_MOVED_BETWEEN_SWIMLANES';
const $301f2494ee9de7ef$export$2002a6bc80b9565e = (cardKeys)=>({
        type: $301f2494ee9de7ef$export$d625226adb2f3b49,
        payload: {
            cardKeys: cardKeys
        }
    });
const $301f2494ee9de7ef$export$7cf0dcc6369bfe2b = 'state.actions.flags.CARD_CREATE_FILTERED_OUT_IN_IP_BOARD';
const $301f2494ee9de7ef$export$2c2745cdb0117bd5 = (cardTypeName)=>({
        type: $301f2494ee9de7ef$export$7cf0dcc6369bfe2b,
        payload: {
            cardTypeName: cardTypeName
        }
    });

});
parcelRegister("7AVqz", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f5b8de7af91e687$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4f5b8de7af91e687$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    warning: {
        "id": "software.main.flags.warning",
        "defaultMessage": "Warning"
    },
    boardLoadedFailureTitle: {
        "id": "software.main.flags.board-loaded-failure-title",
        "defaultMessage": "Board data failed to load"
    },
    boardLoadedFailureDescription: {
        "id": "software.main.flags.board-loaded-failure-description",
        "defaultMessage": "Try refreshing the page, or contact your admin"
    },
    logBackInTitle: {
        "id": "software.main.flags.log-back-in-title",
        "defaultMessage": "Anyone there?"
    },
    logBackInAnchorText: {
        "id": "software.main.flags.log-back-in-anchor-text",
        "defaultMessage": "Log back in"
    },
    logBackInDescription: {
        "id": "software.main.flags.log-back-in-description",
        "defaultMessage": "You've been inactive for a while, so we've logged you out."
    },
    genericTitle: {
        "id": "software.main.flags.generic-title",
        "defaultMessage": "Something's gone wrong"
    },
    genericDescription: {
        "id": "software.main.flags.generic-description",
        "defaultMessage": "An error occurred on our end. Refresh the page and try again"
    },
    warningLabel: {
        "id": "software.main.flags.warning-label",
        "defaultMessage": "An error occurred"
    },
    errorLabel: {
        "id": "software.main.flags.error-label",
        "defaultMessage": "An error occurred"
    },
    failureDescription: {
        "id": "software.main.flags.failure-description",
        "defaultMessage": "{error}"
    },
    columnRemoveDoneFlagTitle: {
        "id": "software.main.flags.column-remove-done-flag-title",
        "defaultMessage": "Your board has no completion columns"
    },
    columnRemoveDoneFlagDescription: {
        "id": "software.main.flags.column-remove-done-flag-description",
        "defaultMessage": "Issues on this board can't be treated as done until you set a completion column."
    },
    columnRemoveDoneFlagDescriptionIssueTermRefresh: {
        "id": "software.main.flags.column-remove-done-flag-description-issue-term-refresh",
        "defaultMessage": "Work items on this board can't be treated as done until you set a completion column."
    },
    createdIssueIsFilteredTitle: {
        "id": "software.main.flags.created-issue-is-filtered-title",
        "defaultMessage": "{issueKey} has been created."
    },
    createdIssueIsFilteredDescription: {
        "id": "software.main.flags.created-issue-is-filtered-description",
        "defaultMessage": "It's hidden by your current filter."
    },
    createdIssueIsFilteredDescriptionIssueTermRefresh: {
        "id": "software.main.flags.created-issue-is-filtered-description-issue-term-refresh",
        "defaultMessage": "It's hidden by your current filter."
    },
    createdIssueIsFilteredLink: {
        "id": "software.main.flags.created-issue-is-filtered-link",
        "defaultMessage": "View issue"
    },
    createdIssueIsFilteredLinkIssueTermRefresh: {
        "id": "software.main.flags.created-issue-is-filtered-link-issue-term-refresh",
        "defaultMessage": "View"
    },
    createdIssueIsFilteredLinkIssueTerminologyRefreshM4: {
        "id": "software.main.flags.created-issue-is-filtered-link-issue-terminology-refresh-M4",
        "defaultMessage": "View {workType}"
    },
    issueRankFailTitle: {
        "id": "software.main.flags.issue-rank-fail-title",
        "defaultMessage": "We couldn't update the issue"
    },
    issueRankFailTitleIssueTermRefresh: {
        "id": "software.main.flags.issue-rank-fail-title-issue-term-refresh",
        "defaultMessage": "We couldn't update the work item"
    },
    issueRankFailTitleIssueTerminologyRefreshM4: {
        "id": "software.main.flags.issue-rank-fail-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can't update {workType} {issueKey}"
    },
    issueRankFailDescription: {
        "id": "software.main.flags.issue-rank-fail-description",
        "defaultMessage": "We failed to reorder the issue or your admin has restricted how you can move it. Try moving the issue again or move it to a different drop zone."
    },
    issueRankFailDescriptionIssueTermRefresh: {
        "id": "software.main.flags.issue-rank-fail-description-issue-term-refresh",
        "defaultMessage": "We couldn't reorder the work item. Try moving it again or move it to a different drop zone. Your admin may have restricted how you can move it."
    },
    issueRankFailDescriptionIssueTerminologyRefreshM4: {
        "id": "software.main.flags.issue-rank-fail-description-issue-terminology-refresh-m4",
        "defaultMessage": "We couldn't reorder the {workType}. Try moving it again or move it to a different drop zone. Your admin may have restricted how you can move it."
    },
    issueRankFailFieldRequiredTitle: {
        "id": "software.main.flags.issue-rank-fail-field-required-title",
        "defaultMessage": "Issue {issueKey} couldn't be moved."
    },
    issueRankFailFieldRequiredTitleIssueTermRefresh: {
        "id": "software.main.flags.issue-rank-fail-field-required-title-issue-term-refresh",
        "defaultMessage": "Work item {issueKey} couldn't be moved."
    },
    issueRankFailFieldRequiredTitleIssueTerminologyRefreshM4: {
        "id": "software.main.flags.issue-rank-fail-field-required-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can't move {workType} {issueKey}"
    },
    issueRankFailFieldRequiredDescription: {
        "id": "software.main.flags.issue-rank-fail-field-required-description",
        "defaultMessage": "{errorMessage}"
    },
    bulkIssueRankFailTitle: {
        "id": "software.main.flags.bulk-issue-rank-fail-title",
        "defaultMessage": "Issue {issueKey} couldn't be moved."
    },
    bulkIssueRankFailTitleIssueTermRefresh: {
        "id": "software.main.flags.bulk-issue-rank-fail-title-issue-term-refresh",
        "defaultMessage": "Work item {issueKey} couldn't be moved."
    },
    devStatusFetchFailedTitle: {
        "id": "software.main.flags.dev-status-fetch-failed-title",
        "defaultMessage": "Something's gone wrong"
    },
    devStatusFetchFailedDescription: {
        "id": "software.main.flags.dev-status-fetch-failed-description",
        "defaultMessage": "Your cards' development statuses have failed to update. We'll keep trying."
    },
    boardDeferredDataFetchFailedTitle: {
        "id": "software.main.flags.board-deferred-data-fetch-failed-title",
        "defaultMessage": "Something's gone wrong"
    },
    boardDeferredDataFetchFailedDescription: {
        "id": "software.main.flags.board-deferred-data-fetch-failed-description",
        "defaultMessage": "We couldn't load some of your board data. Refresh the page and try again."
    },
    issueLabelsSaveFailed: {
        "id": "software.main.flags.issue-labels-save-failed",
        "defaultMessage": "We couldn't update some of your issues. Try again."
    },
    issueLabelsSaveFailedIssueTermRefresh: {
        "id": "software.main.flags.issue-labels-save-failed-issue-term-refresh",
        "defaultMessage": "We couldn't update some of your work items. Try again."
    },
    newPeopleAddedSuccessTitle: {
        "id": "software.main.flags.new-people-added-success-title",
        "defaultMessage": "New people added"
    },
    noColumnFailureTitle: {
        "id": "software.main.flags.no-column-failure-title",
        "defaultMessage": "Boards must have at least one column"
    },
    noColumnFailureAdminDescription: {
        "id": "software.main.flags.no-column-failure-admin-description",
        "defaultMessage": "Add at least one column to continue."
    },
    noColumnFailureNonAdminDescription: {
        "id": "software.main.flags.no-column-failure-non-admin-description",
        "defaultMessage": "Your project admin must add a column to continue."
    },
    manageStatusesLink: {
        "id": "software.main.flags.manage-statuses-link",
        "defaultMessage": "Manage columns and statuses"
    },
    deleteFailureTitle: {
        "id": "software.main.flags.delete-failure-title",
        "defaultMessage": "Failed to delete issue"
    },
    deleteFailureTitleIssueTermRefresh: {
        "id": "software.main.flags.delete-failure-title-issue-term-refresh",
        "defaultMessage": "We couldn't delete the work item"
    },
    deleteFailureTitleIssueTerminologyRefreshM4: {
        "id": "software.main.flags.delete-failure-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t delete {workType} {issueKey}"
    },
    teamSwimlaneMoveInvalidTitle: {
        "id": "software.main.flags.team-swimlane-move-invalid-title",
        "defaultMessage": "Couldn\u2019t assign issue to {teamName}"
    },
    teamSwimlaneMoveInvalidTitleIssueTermRefresh: {
        "id": "software.main.flags.team-swimlane-move-invalid-title-issue-term-refresh",
        "defaultMessage": "Couldn\u2019t assign work item to {teamName}"
    },
    teamSwimlaneMoveInvalidTitleIssueTerminologyRefreshM4: {
        "id": "software.main.flags.team-swimlane-move-invalid-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t assign {workType} {issueKey} to {teamName}"
    },
    teamSwimlaneMoveInvalidMessage: {
        "id": "software.main.flags.team-swimlane-move-invalid-message",
        "defaultMessage": "Issues can only be assigned to teams that are part of your plan."
    },
    teamSwimlaneMoveInvalidMessageIssueTermRefresh: {
        "id": "software.main.flags.team-swimlane-move-invalid-message-issue-term-refresh",
        "defaultMessage": "Work items can only be assigned to teams that are part of your plan."
    },
    swimlaneColumnClosedSprintInvalidMoveTitle: {
        "id": "software.main.flags.swimlane-column-closed-sprint-invalid-move-title",
        "defaultMessage": "Couldn\u2019t assign issue to {sprintName}"
    },
    swimlaneColumnClosedSprintInvalidMoveTitleIssueTermRefresh: {
        "id": "software.main.flags.swimlane-column-closed-sprint-invalid-move-title-issue-term-refresh",
        "defaultMessage": "Couldn\u2019t assign work item to {sprintName}"
    },
    swimlaneColumnClosedSprintInvalidMoveTitleIssueTerminologyRefreshM4: {
        "id": "software.main.flags.swimlane-column-closed-sprint-invalid-move-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can\u2019t assign the {workType} {issueKey} to {sprintName}"
    },
    swimlaneColumnClosedSprintInvalidMoveMessage: {
        "id": "software.main.flags.swimlane-column-closed-sprint-invalid-move-message",
        "defaultMessage": "Issues can\u2019t be assigned to a closed sprint."
    },
    swimlaneColumnClosedSprintInvalidMoveMessageIssueTermRefresh: {
        "id": "software.main.flags.swimlane-column-closed-sprint-invalid-move-message-issue-term-refresh",
        "defaultMessage": "Work items can\u2019t be assigned to a closed sprint."
    },
    cardMoveFailureInIpBoardTitleNoTranslate: {
        "id": "software.main.flags.card-move-failure-in-ip-board-title-no-translate",
        "defaultMessage": "We can't update the issue"
    },
    cardMoveFailureInIpBoardTitleNoTranslateIssueTermRefresh: {
        "id": "software.main.flags.card-move-failure-in-ip-board-title-no-translate-issue-term-refresh",
        "defaultMessage": "We can't update the work item"
    },
    cardMoveFailureInIpBoardTitleNoTranslateIssueTerminologyRefreshM4: {
        "id": "software.main.flags.card-move-failure-in-ip-board-title-no-translate-issue-terminology-refresh-m4",
        "defaultMessage": "We can't update {workType} {issueKey}"
    },
    cardMoveFailureInIpBoardMessageNoTranslate: {
        "id": "software.main.flags.card-move-failure-in-ip-board-message-no-translate",
        "defaultMessage": "We failed to reorder the issue. Try moving the issue again or move it to a different drop zone."
    },
    cardMoveFailureInIpBoardMessageNoTranslateIssueTermRefresh: {
        "id": "software.main.flags.card-move-failure-in-ip-board-message-no-translate-issue-term-refresh",
        "defaultMessage": "We couldn't reorder the issue. Try moving it again, or move it to a different drop zone."
    },
    cardMoveFailureInIpBoardMessageNoTranslateIssueTerminologyRefreshM4: {
        "id": "software.main.flags.card-move-failure-in-ip-board-message-no-translate-issue-terminology-refresh-m4",
        "defaultMessage": "We couldn't reorder the {workType}. Try moving it again or move it to a different drop zone. Your admin may have restricted how you can move it."
    },
    customFieldOptionMissedTitle: {
        "id": "software.main.flags.custom-field-option-missed-title",
        "defaultMessage": "Issue couldn\u2019t be created"
    },
    customFieldOptionMissedTitleIssueTermRefresh: {
        "id": "software.main.flags.custom-field-option-missed-title-issue-term-refresh",
        "defaultMessage": "Work item couldn\u2019t be created"
    },
    customFieldOptionMissedTitleIssueTerminologyRefreshM4: {
        "id": "software.main.flags.custom-field-option-missed-title-issue-terminology-refresh-m4",
        "defaultMessage": "We can't create {issueTypeName}"
    },
    customFieldOptionMissedDescription: {
        "id": "software.main.flags.custom-field-option-missed-description",
        "defaultMessage": "{fieldValue} can\u2019t be applied to {issueTypeName} type issues in {projectName}. Your admin needs to add the {fieldValue} option to the {fieldName} custom field."
    },
    customFieldOptionMissedDescriptionIssueTermRefresh: {
        "id": "software.main.flags.custom-field-option-missed-description-issue-term-refresh",
        "defaultMessage": "{fieldValue} can\u2019t be applied to {issueTypeName} type work items in {projectName}. Your admin needs to add the {fieldValue} option to the {fieldName} custom field."
    },
    reachDependencyLineLimitTitle: {
        "id": "software.main.flags.reach-dependency-line-limit-title",
        "defaultMessage": "You can only show dependencies for {limit, plural, one {# issue} other {# issues}} at one time"
    },
    reachDependencyLineLimitTitleIssueTermRefresh: {
        "id": "software.main.flags.reach-dependency-line-limit-title-issue-term-refresh",
        "defaultMessage": "You can only show dependencies for {limit, plural, one {# work item} other {# work items}} at one time"
    },
    resizeHandleLabel: {
        "id": "software.main.flags.resize-handler-label",
        "defaultMessage": "Resize Handler Slider"
    }
});

});

parcelRegister("sdxnu", function(module, exports) {

$parcel$export(module.exports, "warningFlagMeta", () => $09c88d05be3e9dcb$export$fd216f66b62fa159);
$parcel$export(module.exports, "undoFlagMeta", () => $09c88d05be3e9dcb$export$f02c70ed4364732c);
$parcel$export(module.exports, "successFlagMeta", () => $09c88d05be3e9dcb$export$a4f3d10259c20559);
$parcel$export(module.exports, "errorFlagMeta", () => $09c88d05be3e9dcb$export$10dda59e82a6948c);
$parcel$export(module.exports, "infoFlagMeta", () => $09c88d05be3e9dcb$export$96a3d0e918faf45b);

var $7Jxgt = parcelRequire("7Jxgt");

const $09c88d05be3e9dcb$export$fd216f66b62fa159 = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$3e8caae81220a92d),
            id: flagParameters.id || (0, $7Jxgt.v4)(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            rawDescriptionMessage: flagParameters.rawDescriptionMessage,
            context: flagParameters.context
        }
    });
const $09c88d05be3e9dcb$export$f02c70ed4364732c = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$b80f3194b3ff34b4),
            id: flagParameters.id || (0, $7Jxgt.v4)(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            context: flagParameters.context,
            links: flagParameters.links
        }
    });
const $09c88d05be3e9dcb$export$a4f3d10259c20559 = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$1d0740fae54799e6),
            id: flagParameters.id || (0, $7Jxgt.v4)(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            context: flagParameters.context
        }
    });
const $09c88d05be3e9dcb$export$10dda59e82a6948c = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$b0516b50882e8fbc),
            id: flagParameters.id || (0, $7Jxgt.v4)(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            errorMessages: flagParameters.errorMessages,
            context: flagParameters.context
        }
    });
const $09c88d05be3e9dcb$export$96a3d0e918faf45b = (flagParameters)=>({
        flag: {
            type: (0, $587ae274b8f0e917$export$f1471fc4e853391b),
            id: flagParameters.id || (0, $7Jxgt.v4)(),
            titleMessage: flagParameters.titleMessage,
            descriptionMessage: flagParameters.descriptionMessage,
            errorMessages: flagParameters.errorMessages,
            context: flagParameters.context
        }
    });

});
const $587ae274b8f0e917$export$3e8caae81220a92d = 'WARNING';
const $587ae274b8f0e917$export$1d0740fae54799e6 = 'SUCCESS';
const $587ae274b8f0e917$export$b0516b50882e8fbc = 'ERROR';
const $587ae274b8f0e917$export$b80f3194b3ff34b4 = 'UNDO';
const $587ae274b8f0e917$export$f1471fc4e853391b = 'INFO';



parcelRegister("ls4NM", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CREATE_REQUEST", () => $40338ac9e4bbe7a0$export$cafcbf49eb8c002);
$parcel$export(module.exports, "issueCreateRequest", () => $40338ac9e4bbe7a0$export$735389bea7eedaad);
$parcel$export(module.exports, "ISSUE_CREATE_SUCCESS", () => $40338ac9e4bbe7a0$export$fbccf9014fab045);
$parcel$export(module.exports, "issueCreateSuccess", () => $40338ac9e4bbe7a0$export$359b420f9850fc61);
$parcel$export(module.exports, "ISSUE_CREATE_FAILURE", () => $40338ac9e4bbe7a0$export$6fdf0f2026f59ec8);
$parcel$export(module.exports, "issueCreateFailure", () => $40338ac9e4bbe7a0$export$d2f4535c9fcca3f3);
$parcel$export(module.exports, "issueCreateIPValidateFailure", () => $40338ac9e4bbe7a0$export$8115d8ee3d5a2c3e);
$parcel$export(module.exports, "CARD_CREATE_UNMAPPED", () => $40338ac9e4bbe7a0$export$ac5655119bbf2fd5);
$parcel$export(module.exports, "cardCreateUnmapped", () => $40338ac9e4bbe7a0$export$2afdf25d9071462e);
$parcel$export(module.exports, "CARD_CREATE_GLOBAL", () => $40338ac9e4bbe7a0$export$7e3530b9017404ec);
$parcel$export(module.exports, "cardCreateGlobal", () => $40338ac9e4bbe7a0$export$7fd1edcce679a11d);
$parcel$export(module.exports, "customFieldMissedInIPBoard", () => $40338ac9e4bbe7a0$export$c33e3f9f36f8dbca);

var $6s1PB = parcelRequire("6s1PB");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $40338ac9e4bbe7a0$export$cafcbf49eb8c002 = 'state.actions.issue.create.ISSUE_CREATE_REQUEST';
const $40338ac9e4bbe7a0$export$735389bea7eedaad = ({ temporaryIssueIds: temporaryIssueIds, issues: issues, insertBefore: insertBefore, columnIndex: columnIndex, cardIndex: cardIndex, swimlaneId: swimlaneId, type: type, analyticsEvent: analyticsEvent, isSubtaskMissingParent: isSubtaskMissingParent, transitionInfo: transitionInfo, isSwimlaneByJql: isSwimlaneByJql })=>({
        type: $40338ac9e4bbe7a0$export$cafcbf49eb8c002,
        payload: {
            temporaryIssueIds: temporaryIssueIds,
            issues: issues,
            type: type
        },
        meta: {
            insertBefore: insertBefore,
            columnIndex: columnIndex,
            cardIndex: cardIndex,
            swimlaneId: swimlaneId,
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent,
            isSubtaskMissingParent: isSubtaskMissingParent,
            transitionInfo: transitionInfo,
            isSwimlaneByJql: isSwimlaneByJql
        }
    });
const $40338ac9e4bbe7a0$export$fbccf9014fab045 = 'state.actions.issue.create.ISSUE_CREATE_SUCCESS';
const $40338ac9e4bbe7a0$export$359b420f9850fc61 = (optimisticId, temporaryIssueIds, issues, columnIndex, cardIndex, analyticsEvent, isFilterRefinementEnabled)=>({
        type: $40338ac9e4bbe7a0$export$fbccf9014fab045,
        payload: {
            temporaryIssueIds: temporaryIssueIds,
            issues: issues
        },
        meta: {
            columnIndex: columnIndex,
            cardIndex: cardIndex,
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent,
            isFilterRefinementEnabled: isFilterRefinementEnabled
        }
    });
const $40338ac9e4bbe7a0$export$6fdf0f2026f59ec8 = 'state.actions.issue.create.ISSUE_CREATE_FAILURE';
const $40338ac9e4bbe7a0$export$d2f4535c9fcca3f3 = (optimisticId, analyticsEvent, error)=>({
        type: $40338ac9e4bbe7a0$export$6fdf0f2026f59ec8,
        // Flag handled by a concurrent action
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent,
            error: error
        }
    });
const $40338ac9e4bbe7a0$export$7bc25041dbb7f97f = 'state.actions.issue.create.IP_ISSUE_CREATE_VALIDATE_FAILURE';
const $40338ac9e4bbe7a0$export$8115d8ee3d5a2c3e = (analyticsEvent, error)=>({
        type: $40338ac9e4bbe7a0$export$7bc25041dbb7f97f,
        meta: {
            analyticsEvent: analyticsEvent,
            error: error
        }
    });
const $40338ac9e4bbe7a0$export$ac5655119bbf2fd5 = 'state.actions.issue.create.CARD_CREATE_UNMAPPED';
const $40338ac9e4bbe7a0$export$2afdf25d9071462e = (cardKeys)=>({
        type: $40338ac9e4bbe7a0$export$ac5655119bbf2fd5,
        payload: {
            cardKeys: cardKeys
        }
    });
const $40338ac9e4bbe7a0$export$7e3530b9017404ec = 'state.actions.issue.create.CARD_CREATE_GLOBAL';
const $40338ac9e4bbe7a0$export$7fd1edcce679a11d = (cardKeys, issueType)=>({
        type: $40338ac9e4bbe7a0$export$7e3530b9017404ec,
        payload: {
            cardKeys: cardKeys,
            issueType: issueType
        }
    });
const $40338ac9e4bbe7a0$export$bf24aba99d557627 = 'state.actions.issue.create.CUSTOM_FIELD_OPTIONS_MISSED_IN_IP_BOARD';
const $40338ac9e4bbe7a0$var$getTitle = ()=>{
    if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7AVqz.default).customFieldOptionMissedTitleIssueTerminologyRefreshM4;
    if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $7AVqz.default).customFieldOptionMissedTitleIssueTermRefresh;
    return (0, $7AVqz.default).customFieldOptionMissedTitle;
};
const $40338ac9e4bbe7a0$export$c33e3f9f36f8dbca = (payload)=>({
        type: $40338ac9e4bbe7a0$export$bf24aba99d557627,
        meta: {
            ...(0, $sdxnu.errorFlagMeta)({
                titleMessage: $40338ac9e4bbe7a0$var$getTitle(),
                descriptionMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).customFieldOptionMissedDescriptionIssueTermRefresh : (0, $7AVqz.default).customFieldOptionMissedDescription,
                context: {
                    ...payload
                }
            })
        }
    });

});
parcelRegister("9rND4", function(module, exports) {

$parcel$export(module.exports, "beginOptimisticUiMeta", () => $559a37778065ad75$export$ebf02a95198109b6);
$parcel$export(module.exports, "commitOptimisticUiMeta", () => $559a37778065ad75$export$76fabd640a0893d7);
$parcel$export(module.exports, "revertOptimisticUiMeta", () => $559a37778065ad75$export$732172a3c90c9446);
$parcel$export(module.exports, "revertOptimisticUiWithFlagMeta", () => $559a37778065ad75$export$62b48e9d9fa388fd);

var $alNv9 = parcelRequire("alNv9");

var $7Jxgt = parcelRequire("7Jxgt");


var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $559a37778065ad75$export$afc40f9cba31cfb3 = 'OPTIMISTIC_REVERT_FLAG';
// This is a temporary key for SSR until we can verify when we server render the board content
const $559a37778065ad75$var$getUniqueId = ()=>(0, $cdb023d06c7f62fa$export$19d68f5aa485d903) ? 'ssr-unique-id' : (0, $7Jxgt.v4)();
const $559a37778065ad75$export$ebf02a95198109b6 = ()=>({
        optimistic: {
            type: (0, $alNv9.BEGIN),
            id: $559a37778065ad75$var$getUniqueId()
        }
    });
const $559a37778065ad75$export$76fabd640a0893d7 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.COMMIT),
            id: optimisticId
        }
    });
const $559a37778065ad75$export$732172a3c90c9446 = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        }
    });
const $559a37778065ad75$export$62b48e9d9fa388fd = (optimisticId)=>({
        optimistic: {
            type: (0, $alNv9.REVERT),
            id: optimisticId
        },
        ...(0, $sdxnu.warningFlagMeta)({
            id: $559a37778065ad75$export$afc40f9cba31cfb3,
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });

});
// This constant will be true on entry-fs (modern SSR) bundles and false on jira-fe-gateway (legacy SSR) and client bundles
const $cdb023d06c7f62fa$export$19d68f5aa485d903 = false;



parcelRegister("cW3pH", function(module, exports) {

$parcel$export(module.exports, "BOARD_LOAD_FAILURE", () => $d3fec575bea28757$export$80388ad0ac612bc0);
$parcel$export(module.exports, "loadBoardFailure", () => $d3fec575bea28757$export$292130a747fcac92);
$parcel$export(module.exports, "BOARD_LOAD_FAILURE_NO_COLUMN", () => $d3fec575bea28757$export$fd087a1805a6a0b2);
$parcel$export(module.exports, "loadBoardFailureNoColumn", () => $d3fec575bea28757$export$3e8eb403d18e7d62);
$parcel$export(module.exports, "BOARD_VIEW", () => $d3fec575bea28757$export$10c63dc5c09466d2);
$parcel$export(module.exports, "boardView", () => $d3fec575bea28757$export$50191da575ef3bdf);
$parcel$export(module.exports, "BOARD_NON_CRITICAL_VIEW", () => $d3fec575bea28757$export$f85c604990de6759);
$parcel$export(module.exports, "boardNonCriticalView", () => $d3fec575bea28757$export$8a605ef273fd8c8);
$parcel$export(module.exports, "IP_BOARD_404_VIEW", () => $d3fec575bea28757$export$56ca4bd173eb29be);
$parcel$export(module.exports, "showIPBoard404View", () => $d3fec575bea28757$export$ec78e5cf35893249);
$parcel$export(module.exports, "LOG_BACK_IN_SHOW", () => $d3fec575bea28757$export$de023dc2f4184994);
$parcel$export(module.exports, "showLogBackInMessage", () => $d3fec575bea28757$export$96f05b7d0945be06);
$parcel$export(module.exports, "SHOW_MISSING_ISSUE_TYPE_MESSAGE", () => $d3fec575bea28757$export$e58aba294be0a960);
$parcel$export(module.exports, "showMissingIssueTypeMessage", () => $d3fec575bea28757$export$1f55b5c98bc5eff4);
$parcel$export(module.exports, "WORK_REFRESH_DATA", () => $d3fec575bea28757$export$328746aa1d3259d8);
$parcel$export(module.exports, "workRefreshData", () => $d3fec575bea28757$export$c65e4e12058e64e2);
$parcel$export(module.exports, "WORK_DATA_SET", () => $d3fec575bea28757$export$7e2e1da5ab64812b);
$parcel$export(module.exports, "workDataSet", () => $d3fec575bea28757$export$1afa76dc1bdfbb50);
$parcel$export(module.exports, "WORK_DATA_CRITICAL_SET", () => $d3fec575bea28757$export$6f1f5cb5b6c8d7c2);
$parcel$export(module.exports, "workDataCriticalSet", () => $d3fec575bea28757$export$703025f987f2856a);
$parcel$export(module.exports, "BEFORE_DISPOSE", () => $d3fec575bea28757$export$af5317a892490d47);
$parcel$export(module.exports, "beforeDispose", () => $d3fec575bea28757$export$ff37a62a94a80510);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $d3fec575bea28757$export$80388ad0ac612bc0 = 'state.actions.work.BOARD_LOAD_FAILURE';
const $d3fec575bea28757$export$292130a747fcac92 = (error = '', showErrorFlag = true)=>({
        type: $d3fec575bea28757$export$80388ad0ac612bc0,
        meta: showErrorFlag ? (0, $sdxnu.warningFlagMeta)({
            id: $d3fec575bea28757$export$80388ad0ac612bc0,
            titleMessage: (0, $7AVqz.default).boardLoadedFailureTitle,
            descriptionMessage: (0, $7AVqz.default).boardLoadedFailureDescription,
            context: {
                error: error || ''
            }
        }) : null
    });
const $d3fec575bea28757$export$fd087a1805a6a0b2 = 'state.actions.work.BOARD_LOAD_FAILURE_NO_COLUMN';
const $d3fec575bea28757$export$3e8eb403d18e7d62 = (showErrorFlag = true, canConfigureBoard)=>({
        type: $d3fec575bea28757$export$fd087a1805a6a0b2,
        meta: showErrorFlag ? (0, $sdxnu.warningFlagMeta)({
            id: $d3fec575bea28757$export$fd087a1805a6a0b2,
            titleMessage: (0, $7AVqz.default).noColumnFailureTitle,
            descriptionMessage: canConfigureBoard ? (0, $7AVqz.default).noColumnFailureAdminDescription : (0, $7AVqz.default).noColumnFailureNonAdminDescription,
            context: {
                canConfigureBoard: canConfigureBoard
            }
        }) : null
    });
const $d3fec575bea28757$export$10c63dc5c09466d2 = 'state.actions.work.BOARD_VIEW';
const $d3fec575bea28757$export$50191da575ef3bdf = (boardInfo, analyticsEvent)=>({
        type: $d3fec575bea28757$export$10c63dc5c09466d2,
        payload: boardInfo,
        meta: {
            analytics: analyticsEvent
        }
    });
const $d3fec575bea28757$export$f85c604990de6759 = 'state.actions.work.BOARD_NON_CRITICAL_VIEW';
const $d3fec575bea28757$export$8a605ef273fd8c8 = (analyticsEvent)=>({
        type: $d3fec575bea28757$export$f85c604990de6759,
        meta: {
            analytics: analyticsEvent
        }
    });
const $d3fec575bea28757$export$56ca4bd173eb29be = 'state.actions.work.IP_BOARD_404_VIEW';
const $d3fec575bea28757$export$ec78e5cf35893249 = ()=>({
        type: $d3fec575bea28757$export$56ca4bd173eb29be,
        meta: null
    });
const $d3fec575bea28757$export$de023dc2f4184994 = 'state.actions.work.LOG_BACK_IN_SHOW';
const $d3fec575bea28757$export$96f05b7d0945be06 = (logBackInUrl)=>({
        type: $d3fec575bea28757$export$de023dc2f4184994,
        payload: logBackInUrl,
        meta: (0, $sdxnu.warningFlagMeta)({
            id: $d3fec575bea28757$export$de023dc2f4184994,
            titleMessage: (0, $7AVqz.default).logBackInTitle,
            descriptionMessage: (0, $7AVqz.default).logBackInDescription,
            context: {
                url: logBackInUrl
            }
        })
    });
const $d3fec575bea28757$export$e58aba294be0a960 = 'state.actions.work.SHOW_MISSING_ISSUE_TYPE_MESSAGE';
const $d3fec575bea28757$export$1f55b5c98bc5eff4 = (missingIssueTypeName)=>({
        type: $d3fec575bea28757$export$e58aba294be0a960,
        payload: missingIssueTypeName
    });
const $d3fec575bea28757$export$328746aa1d3259d8 = 'state.actions.work.WORK_REFRESH_DATA';
const $d3fec575bea28757$export$c65e4e12058e64e2 = (source, issues, triggerSource, hasShownFlag)=>({
        type: $d3fec575bea28757$export$328746aa1d3259d8,
        payload: {
            source: source,
            issues: issues,
            triggerSource: triggerSource,
            hasShownFlag: hasShownFlag
        }
    });
const $d3fec575bea28757$export$7e2e1da5ab64812b = 'state.actions.work.WORK_DATA_SET';
const $d3fec575bea28757$export$1afa76dc1bdfbb50 = (workData)=>({
        type: $d3fec575bea28757$export$7e2e1da5ab64812b,
        payload: workData
    });
const $d3fec575bea28757$export$6f1f5cb5b6c8d7c2 = 'state.actions.work.WORK_DATA_CRITICAL_SET';
const $d3fec575bea28757$export$703025f987f2856a = ({ issues: issues, people: people, projects: projects, config: config, hasFilteredIssues: hasFilteredIssues, columns: columns, swimlaneModeId: swimlaneModeId, sprints: sprints, isSprintsEnabled: isSprintsEnabled, boardName: boardName, capabilities: capabilities, incrementConfig: incrementConfig, issueParents: issueParents, issueTypes: issueTypes, projectIssueTypes: projectIssueTypes, boardPermissions: boardPermissions, issueChildren: issueChildren, cardTransitions: cardTransitions, allFeatures: allFeatures, inlineCardCreate: inlineCardCreate, isInlineColumnEditEnabled: isInlineColumnEditEnabled, estimationStatistic: estimationStatistic, teams: teams, filteredCardIds: filteredCardIds })=>({
        type: $d3fec575bea28757$export$6f1f5cb5b6c8d7c2,
        payload: {
            issues: issues,
            people: people,
            projects: projects,
            config: config,
            hasFilteredIssues: hasFilteredIssues,
            columns: columns,
            swimlaneModeId: swimlaneModeId,
            sprints: sprints,
            isSprintsEnabled: isSprintsEnabled,
            boardName: boardName,
            capabilities: capabilities,
            incrementConfig: incrementConfig,
            issueParents: issueParents,
            issueTypes: issueTypes,
            projectIssueTypes: projectIssueTypes,
            boardPermissions: boardPermissions,
            issueChildren: issueChildren,
            cardTransitions: cardTransitions,
            allFeatures: allFeatures,
            inlineCardCreate: inlineCardCreate,
            isInlineColumnEditEnabled: isInlineColumnEditEnabled,
            estimationStatistic: estimationStatistic,
            teams: teams,
            filteredCardIds: filteredCardIds
        }
    });
const $d3fec575bea28757$export$af5317a892490d47 = 'state.actions.work.BEFORE_DISPOSE';
const $d3fec575bea28757$export$ff37a62a94a80510 = {
    type: $d3fec575bea28757$export$af5317a892490d47
};

});

parcelRegister("3i1Rr", function(module, exports) {

$parcel$export(module.exports, "CardCoverToggleFailedFlag", () => $f78d35f88ddcd47b$export$890869be905669a7);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $cQyPh = parcelRequire("cQyPh");
const $f78d35f88ddcd47b$export$890869be905669a7 = ({ id: id, onDismissed: onDismissed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        title: formatMessage((0, $cQyPh.default).title),
        description: formatMessage((0, $cQyPh.default).description),
        id: id,
        onDismissed: onDismissed
    });
};

});
parcelRegister("cQyPh", function(module, exports) {

$parcel$export(module.exports, "default", () => $8c5d60eddd250e02$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8c5d60eddd250e02$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.flags.card-cover-toggle-failed.title",
        "defaultMessage": "We couldn\u2019t show your card images"
    },
    description: {
        "id": "software.main.flags.card-cover-toggle-failed.description",
        "defaultMessage": "Reload the page and try again."
    }
});

});


parcelRegister("gYo9d", function(module, exports) {

$parcel$export(module.exports, "default", () => $f28405d0562ceff9$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dnW4F = parcelRequire("dnW4F");

var $11tjn = parcelRequire("11tjn");
const $f28405d0562ceff9$var$mapDispatchToProps = (dispatch)=>({
        onClearAllButtonClicked: ()=>{
            dispatch((0, $dnW4F.setAllFilters)({}));
        }
    });
var $f28405d0562ceff9$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(null, $f28405d0562ceff9$var$mapDispatchToProps)((0, $11tjn.default));

});
parcelRegister("dnW4F", function(module, exports) {

$parcel$export(module.exports, "FILTERS_SET", () => $7331c3a36486313c$export$8c6563fc087181f);
$parcel$export(module.exports, "FILTERS_JQL_SET", () => $7331c3a36486313c$export$2de8036fc246219a);
$parcel$export(module.exports, "setFilters", () => $7331c3a36486313c$export$90e9b0558f0311af);
$parcel$export(module.exports, "SET_ALL_FILTERS", () => $7331c3a36486313c$export$2771e5a27cdc85fe);
$parcel$export(module.exports, "setAllFilters", () => $7331c3a36486313c$export$1e6b2e9f0ff84131);
$parcel$export(module.exports, "setFiltersFromJql", () => $7331c3a36486313c$export$98b5780054fda941);
$parcel$export(module.exports, "SEARCH_FOCUS", () => $7331c3a36486313c$export$ac2b2941224e429b);
$parcel$export(module.exports, "searchFieldFocus", () => $7331c3a36486313c$export$a6aa455a6b69d463);
$parcel$export(module.exports, "extraAvatarMenuOpen", () => $7331c3a36486313c$export$48ffba39408a256d);
$parcel$export(module.exports, "FILTER_PANEL_MOUNTED", () => $7331c3a36486313c$export$e3c91525b0677428);
$parcel$export(module.exports, "filterPanelMounted", () => $7331c3a36486313c$export$c48d1dabfffb8ec0);
$parcel$export(module.exports, "CLEAR_ALL_FILTERS_CLICKED", () => $7331c3a36486313c$export$f9f63b3db141632b);
$parcel$export(module.exports, "clearAllFiltersClicked", () => $7331c3a36486313c$export$5845d1911d8d06dd);
$parcel$export(module.exports, "CUSTOM_FILTER_FORCE_REFRESH_START", () => $7331c3a36486313c$export$a93d3497aade82c7);
$parcel$export(module.exports, "customFilterForceRefreshStart", () => $7331c3a36486313c$export$164137b141902cad);
const $7331c3a36486313c$export$8c6563fc087181f = 'state.actions.filter.FILTERS_SET';
const $7331c3a36486313c$export$2de8036fc246219a = 'state.actions.filter.FILTERS_JQL_SET';
const $7331c3a36486313c$export$90e9b0558f0311af = (filterType, values)=>({
        type: $7331c3a36486313c$export$8c6563fc087181f,
        payload: {
            filterType: filterType,
            values: values
        }
    });
const $7331c3a36486313c$export$2771e5a27cdc85fe = 'state.actions.filter.SET_ALL_FILTERS';
const $7331c3a36486313c$export$1e6b2e9f0ff84131 = (filters, filterType, analyticsEvent)=>({
        type: $7331c3a36486313c$export$2771e5a27cdc85fe,
        payload: {
            filters: filters
        },
        meta: {
            filterType: filterType,
            analyticsEvent: analyticsEvent
        }
    });
const $7331c3a36486313c$export$98b5780054fda941 = (filters, filterType, analyticsEvent)=>({
        type: $7331c3a36486313c$export$2de8036fc246219a,
        payload: {
            filters: filters
        },
        meta: {
            filterType: filterType,
            analyticsEvent: analyticsEvent
        }
    });
const $7331c3a36486313c$export$ac2b2941224e429b = 'state.actions.filter.SEARCH_FOCUS';
const $7331c3a36486313c$export$a6aa455a6b69d463 = ()=>({
        type: $7331c3a36486313c$export$ac2b2941224e429b
    });
const $7331c3a36486313c$export$f75e48e89e1e814a = 'state.actions.filter.EXTRA_AVATAR_MENU_OPEN';
const $7331c3a36486313c$export$48ffba39408a256d = ()=>({
        type: $7331c3a36486313c$export$f75e48e89e1e814a
    });
const $7331c3a36486313c$export$e3c91525b0677428 = 'state.actions.filter.FILTER_PANEL_MOUNTED';
const $7331c3a36486313c$export$c48d1dabfffb8ec0 = ()=>({
        type: $7331c3a36486313c$export$e3c91525b0677428
    });
const $7331c3a36486313c$export$f9f63b3db141632b = 'state.actions.filter.CLEAR_ALL_FILTERS_CLICKED';
const $7331c3a36486313c$export$5845d1911d8d06dd = ()=>({
        type: $7331c3a36486313c$export$f9f63b3db141632b
    });
const $7331c3a36486313c$export$a93d3497aade82c7 = 'state.actions.filter.CUSTOM_FILTER_FORCE_REFRESH_START';
const $7331c3a36486313c$export$164137b141902cad = ()=>({
        type: $7331c3a36486313c$export$a93d3497aade82c7
    });

});

parcelRegister("11tjn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d700774fc2b35141$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $hDoXj = parcelRequire("hDoXj");
const $d700774fc2b35141$var$CardCreateUnmappedFlagInIpBoard = ({ onDismissed: onDismissed, id: id, onClearAllButtonClicked: onClearAllButtonClicked, cardTypeName: cardTypeName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const getTitle = ()=>{
        if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $hDoXj.default).updatedIssueHiddenTitleIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $hDoXj.default).updatedIssueHiddenTitleIssueTermRefresh;
        return (0, $hDoXj.default).updatedIssueHiddenTitleIssueTermRefresh;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage(getTitle(), {
            workType: cardTypeName || ''
        }),
        description: formatMessage((0, $hDoXj.default).updatedIssueHiddenDescription),
        actions: [
            {
                content: formatMessage((0, $hDoXj.default).clearFiltersActionText),
                onClick: ()=>{
                    onClearAllButtonClicked();
                    onDismissed && onDismissed(id);
                }
            }
        ]
    });
};
var $d700774fc2b35141$export$2e2bcd8739ae039 = $d700774fc2b35141$var$CardCreateUnmappedFlagInIpBoard;

});
parcelRegister("hDoXj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c796ca3e08d094e5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c796ca3e08d094e5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    updatedIssueHiddenTitle: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-title",
        "defaultMessage": "Your issue has been created, but it's hidden by a filter"
    },
    updatedIssueHiddenDescription: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-description",
        "defaultMessage": "Remove your filters to see it on your board."
    },
    clearFiltersActionText: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.clear-filters-action-text",
        "defaultMessage": "Clear filters"
    },
    updatedIssueHiddenTitleIssueTermRefresh: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Your work item has been created, but it's hidden by a filter"
    },
    updatedIssueHiddenTitleIssueTerminologyRefreshM4: {
        "id": "software.main.flags.card-create-unmapped-in-ip-board.updated-issue-hidden-title-issue-terminology-refresh-m4",
        "defaultMessage": "Your {workType} has been created, but it's hidden by a filter"
    }
});

});



parcelRegister("03PHH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80a757d1870c4fb$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $esJnl = parcelRequire("esJnl");

var $eph8m = parcelRequire("eph8m");


var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");
const $d80a757d1870c4fb$var$mapStateToProps = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    return {
        boardConfigUrl: (0, $eph8m.getColumnStatusMappingUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state)),
        isConfigureBoardEnabled: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !(0, $67Z81.getIsCMPBoard)(state)
    };
};
var $d80a757d1870c4fb$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($d80a757d1870c4fb$var$mapStateToProps, {})((0, $esJnl.CardCreateUnmappedFlag));

});
parcelRegister("esJnl", function(module, exports) {

$parcel$export(module.exports, "CardCreateUnmappedFlag", () => $39f5c9a19aa037a2$export$41f7bf5526b10063);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $d4xRU = parcelRequire("d4xRU");
var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $24y3R = parcelRequire("24y3R");

var $pvsdI = parcelRequire("pvsdI");
const $39f5c9a19aa037a2$export$41f7bf5526b10063 = ({ cardKeys: cardKeys, onDismissed: onDismissed, id: id, isAutoDismissed: isAutoDismissed = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const numIssues = cardKeys.length;
    const getFlagDescription = ()=>formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenDescriptionIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenDescription);
    const getActions = ()=>{
        const actions = [
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).issueLinkIssueTermRefresh : (0, $pvsdI.default).issueLink, {
                    numIssues: numIssues
                }),
                href: (0, $24y3R.getIssueDiscoveryUrl)(cardKeys),
                target: '_blank'
            }
        ];
        return actions;
    };
    if (!isAutoDismissed && (0, $4R6GH.fg)('fix-gryf-a11y-issues-2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenTitleIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getFlagDescription(),
        actions: getActions()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $pvsdI.default).updatedIssueHiddenTitleIssueTermRefresh : (0, $pvsdI.default).updatedIssueHiddenTitle, {
            numIssues: numIssues
        }),
        description: getFlagDescription(),
        actions: getActions()
    });
};

});
parcelRegister("pvsdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $3834fa35b5b67285$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3834fa35b5b67285$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {issue} other {issues}} not visible"
    },
    issueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description",
        "defaultMessage": "Issue {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescription: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description",
        "defaultMessage": "{numIssues, plural, one {{numIssues} issue has} other {{numIssues} issues have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLink: {
        "id": "software-flags.card-create-unmapped.issue-link",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    updatedIssueHiddenTitle: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {Issue} other {Issues}} not visible"
    },
    updatedIssueHiddenDescription: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    issueHiddenTitleIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {work item} other {work items}} not visible"
    },
    issueHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-hidden-description-issue-term-refresh",
        "defaultMessage": "Work item {linkStart}{linkEnd} has a status that\u2019s not visible on the board and backlog."
    },
    multipleIssuesHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.multiple-issues-hidden-description-issue-term-refresh",
        "defaultMessage": "{numIssues, plural, one {{numIssues} work item has} other {{numIssues} work items have}} been created, but one or more have a status that's not visible on the board and backlog"
    },
    issueLinkIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.issue-link-issue-term-refresh",
        "defaultMessage": "View {numIssues, plural, one {work item} other {work items}}"
    },
    updatedIssueHiddenTitleIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-title-issue-term-refresh",
        "defaultMessage": "Changes saved, but {numIssues, plural, one {work item} other {work items}} not visible"
    },
    updatedIssueHiddenDescriptionIssueTermRefresh: {
        "id": "software-flags.card-create-unmapped.updated-issue-hidden-description-issue-term-refresh",
        "defaultMessage": "For a work item to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    }
});

});


parcelRegister("eph8m", function(module, exports) {

$parcel$export(module.exports, "getColumnStatusMappingUrl", () => $5ab4bc978b070321$export$5eee224adec4e661);
$parcel$export(module.exports, "getManageCustomFiltersUrl", () => $5ab4bc978b070321$export$84a62bf03b005a81);
$parcel$export(module.exports, "getIssueTypesUrl", () => $5ab4bc978b070321$export$683c0f6db415ca97);
const $5ab4bc978b070321$export$5eee224adec4e661 = (projectKey, boardId, isCMPBoard = false)=>isCMPBoard ? `/jira/software/c/projects/${projectKey}/boards/${boardId}/?config=columns` : `/jira/software/projects/${projectKey}/settings/boards/${boardId}/columns`;
const $5ab4bc978b070321$export$84a62bf03b005a81 = (projectKey, boardId)=>`/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
const $5ab4bc978b070321$export$683c0f6db415ca97 = (projectKey)=>`/plugins/servlet/project-config/${projectKey}/issuetypes`;

});

const $e525e6c25695c9df$export$9f1186f5f46d05d7 = 'CAN_MANAGE_LABS';
const $e525e6c25695c9df$export$1d4594bb2516d9ef = 'CAN_RANK_COLUMNS';
const $e525e6c25695c9df$export$aadc620ce91112df = 'CAN_EDIT_BOARD';
const $e525e6c25695c9df$export$5cd553a40d575c6c = 'CAN_EDIT_ISSUE';
const $e525e6c25695c9df$export$b5cf1ddd753a0a1c = 'CAN_RENAME_COLUMNS';
const $e525e6c25695c9df$export$c5d82f9af027c432 = 'CAN_CREATE_COLUMNS';
const $e525e6c25695c9df$export$9205190dd90cb392 = 'CAN_CREATE_CARDS';
const $e525e6c25695c9df$export$d4845393d78ba468 = 'CAN_DELETE_ISSUE';
const $e525e6c25695c9df$export$112115098b6cf79b = 'CAN_MANAGE_SPRINT';
const $e525e6c25695c9df$export$7c16e92435670968 = 'CAN_MANAGE_AUTOMATION';
const $e525e6c25695c9df$export$172db259b98bcef1 = 'CAN_RELEASE';
const $e525e6c25695c9df$export$e6bcada406923d66 = 'CAN_ARCHIVE_ISSUE';
const $e525e6c25695c9df$export$c713a1185b717514 = 'CAN_ASSIGN_ISSUE';
const $e525e6c25695c9df$export$5904c54eb0bdf886 = 'CAN_SCHEDULE_ISSUE';

parcelRegister("1vXOx", function(module, exports) {

$parcel$export(module.exports, "boardPermissionsSelector", () => $c1f72d1bf425b620$export$ab9a84b9372951ab);
$parcel$export(module.exports, "getPermissionsSelector", () => $c1f72d1bf425b620$export$7517e0443a661546);
$parcel$export(module.exports, "isIncrementPlanningReadOnly", () => $c1f72d1bf425b620$export$d23d829605c420dc);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $4R6GH = parcelRequire("4R6GH");


var $67Z81 = parcelRequire("67Z81");
const $c1f72d1bf425b620$export$ab9a84b9372951ab = (state)=>(0, $67Z81.getBoardEntity)(state).permissions;
const $c1f72d1bf425b620$export$7517e0443a661546 = (0, $dGvGJ.createSelector)([
    $c1f72d1bf425b620$export$ab9a84b9372951ab
], (permissions)=>(0, $7uUwQ.freeze)({
        [(0, $e525e6c25695c9df$export$aadc620ce91112df)]: permissions.editBoardConfig,
        [(0, $e525e6c25695c9df$export$1d4594bb2516d9ef)]: permissions.editBoardConfig || false,
        [(0, $e525e6c25695c9df$export$b5cf1ddd753a0a1c)]: permissions.editBoardConfig || false,
        [(0, $e525e6c25695c9df$export$c5d82f9af027c432)]: permissions.editBoardConfig || false,
        [(0, $e525e6c25695c9df$export$9f1186f5f46d05d7)]: false,
        [(0, $e525e6c25695c9df$export$9205190dd90cb392)]: permissions.createIssue || false,
        [(0, $e525e6c25695c9df$export$5cd553a40d575c6c)]: permissions.editIssue || false,
        [(0, $e525e6c25695c9df$export$d4845393d78ba468)]: permissions.deleteIssue,
        [(0, $e525e6c25695c9df$export$112115098b6cf79b)]: permissions.manageSprint,
        [(0, $e525e6c25695c9df$export$7c16e92435670968)]: permissions.manageAutomation || false,
        [(0, $e525e6c25695c9df$export$172db259b98bcef1)]: permissions.canRelease || false,
        [(0, $e525e6c25695c9df$export$e6bcada406923d66)]: permissions.archiveIssue || false,
        [(0, $e525e6c25695c9df$export$c713a1185b717514)]: permissions.assignIssue || false,
        [(0, $e525e6c25695c9df$export$5904c54eb0bdf886)]: permissions.scheduleIssue || false
    }));
const $c1f72d1bf425b620$export$d23d829605c420dc = (0, $dGvGJ.createSelector)([
    $c1f72d1bf425b620$export$7517e0443a661546,
    (0, $67Z81.getIsIncrementPlanningBoard),
    (0, $67Z81.getIsIncrementPlanningBoardEmbed)
], (permissions, isIncrementPlanningBoard, isIncrementPlanningBoardEmbed)=>{
    if (!isIncrementPlanningBoard) return false;
    // User is read only if they don't have create cards permission
    // or if the User is access the increment board via embed
    return (0, $4R6GH.fg)('smart_links_for_plans') ? !permissions[0, $e525e6c25695c9df$export$9205190dd90cb392] || isIncrementPlanningBoardEmbed : !permissions[0, $e525e6c25695c9df$export$9205190dd90cb392];
});

});


parcelRegister("bri2z", function(module, exports) {

$parcel$export(module.exports, "default", () => $dddc1beb9d4b7c14$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $c6Bgi = parcelRequire("c6Bgi");

var $dW1HX = parcelRequire("dW1HX");

var $dkGow = parcelRequire("dkGow");

var $k8auG = parcelRequire("k8auG");
const $dddc1beb9d4b7c14$var$mapStateToProps = (state)=>({
        isAddedToSprintSuccess: (0, $k8auG.addToSprintSuccessSelector)(state),
        isAddedToSprintLoading: (0, $k8auG.addToSprintLoadingSelector)(state)
    });
const $dddc1beb9d4b7c14$var$mapDispatchToProps = {
    onViewIssue: (0, $dW1HX.openIssueModal),
    onAddToSprint: (0, $dkGow.addToSprintRequest)
};
var $dddc1beb9d4b7c14$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($dddc1beb9d4b7c14$var$mapStateToProps, $dddc1beb9d4b7c14$var$mapDispatchToProps)((0, $c6Bgi.CardFilteredFlag));

});
parcelRegister("c6Bgi", function(module, exports) {

$parcel$export(module.exports, "CardFilteredFlag", () => $85d6c211f93c7022$export$89ed935144048144);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $d4xRU = parcelRequire("d4xRU");
var $3KRpp = parcelRequire("3KRpp");

var $8Q4sF = parcelRequire("8Q4sF");

var $koVbs = parcelRequire("koVbs");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $24y3R = parcelRequire("24y3R");

var $kDbMP = parcelRequire("kDbMP");
const $85d6c211f93c7022$export$89ed935144048144 = ({ cardKeys: cardKeys, sprints: sprints, onDismissed: onDismissed, onViewIssue: onViewIssue, onAddToSprint: onAddToSprint, isAddedToSprintLoading: isAddedToSprintLoading, isAddedToSprintSuccess: isAddedToSprintSuccess, issueMovedBetweenSwimlanes: issueMovedBetweenSwimlanes, id: id, isAutoDismissed: isAutoDismissed = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, setIssueKey] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    // support for multiple active sprints
    const [selectedAddToSprintIndex, setSelectedAddToSprintIndex] = (0, $5uXOq.useState)(null);
    const numIssues = cardKeys.length;
    const getAddToSprintActionContent = (0, $5uXOq.useCallback)((selectedSprintIndex = 0)=>{
        if (selectedAddToSprintIndex === selectedSprintIndex && isAddedToSprintLoading) return formatMessage((0, $kDbMP.default).issueAddToSprintLoading);
        if (selectedAddToSprintIndex === selectedSprintIndex && isAddedToSprintSuccess) return formatMessage((0, $kDbMP.default).issueAddToSprintSuccess);
         // TODO Fail message
        return formatMessage((0, $kDbMP.default).issueAddToSprint, {
            sprintName: sprints?.[selectedSprintIndex]?.name
        });
    }, [
        isAddedToSprintLoading,
        isAddedToSprintSuccess,
        selectedAddToSprintIndex,
        sprints,
        formatMessage
    ]);
    const onViewClick = numIssues === 1 && onViewIssue ? (e)=>{
        e.preventDefault();
        onViewIssue(cardKeys[0]);
        setIssueKey(cardKeys[0]);
    } : undefined;
    const onAddToSprintClickNew = (e, index)=>{
        e.preventDefault();
        if (!onAddToSprint) return;
        setSelectedAddToSprintIndex(index);
        onAddToSprint(cardKeys[0], sprints?.length ? sprints[index]?.id : undefined);
    };
    const onAddToSprintClick = numIssues === 1 ? onAddToSprintClickNew : undefined;
    const descriptionMovedBetweenSwimlanesMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).descriptionMovedBetweenSwimlanesIssueTermRefresh : (0, $kDbMP.default).descriptionMovedBetweenSwimlanes;
    const descriptionMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).descriptionIssueTermRefresh : (0, $kDbMP.default).description;
    const flagDescriptionMessage = issueMovedBetweenSwimlanes ? descriptionMovedBetweenSwimlanesMessage : descriptionMessage;
    const flagDescription = !issueMovedBetweenSwimlanes && numIssues === 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Q4sF.FormattedI18nMessage), {
        message: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).descriptionWithLinkIssueTermRefresh : (0, $kDbMP.default).descriptionWithLink, {
            linkStart: '{linkStart}',
            linkEnd: '{linkEnd}'
        }),
        componentsMapping: {
            link: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
                    href: (0, $24y3R.getIssueDiscoveryUrl)([
                        cardKeys[0]
                    ]),
                    onClick: onViewClick,
                    target: "_blank",
                    className: (0, $bwpsq.default)([
                        (0, $4R6GH.fg)('jira-a11y-links-contrast-fix') && "_4bfu18uv _1hms8stv _ajmmnqa1"
                    ])
                }, cardKeys[0])
        }
    }) : formatMessage(flagDescriptionMessage, {
        numIssues: numIssues
    });
    const generateAddToSprintActions = ()=>sprints?.length && onAddToSprintClick ? sprints.map((sprint, index)=>({
                content: getAddToSprintActionContent(index),
                onClick: (event)=>onAddToSprintClick(event, index)
            })) : [];
    const actions = numIssues > 0 ? [
        {
            content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).issueLinkIssueTermRefresh : (0, $kDbMP.default).issueLink, {
                numIssues: numIssues
            }),
            href: (0, $24y3R.getIssueDiscoveryUrl)(cardKeys),
            onClick: onViewClick,
            target: '_blank'
        },
        ...generateAddToSprintActions()
    ] : [];
    (0, $5uXOq.useEffect)(()=>{
        getAddToSprintActionContent();
    }, [
        isAddedToSprintSuccess,
        isAddedToSprintLoading,
        getAddToSprintActionContent
    ]);
    const titleMovedBetweenSwimlanesMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).titleMovedBetweenSwimlanesIssueTermRefresh : (0, $kDbMP.default).titleMovedBetweenSwimlanes;
    const titleMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kDbMP.default).titleIssueTermRefresh : (0, $kDbMP.default).title;
    const flagTitle = issueMovedBetweenSwimlanes ? titleMovedBetweenSwimlanesMessage : titleMessage;
    if (!isAutoDismissed && (0, $4R6GH.fg)('fix-gryf-a11y-issues-2')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage(flagTitle, {
            numIssues: numIssues
        }),
        description: flagDescription,
        actions: actions
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.SuccessAutoDismissFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage(flagTitle, {
            numIssues: numIssues
        }),
        description: flagDescription,
        actions: actions
    });
};
const $85d6c211f93c7022$var$underlineLinkStyles = null;

});
parcelRegister("8Q4sF", function(module, exports) {

$parcel$export(module.exports, "FormattedI18nMessage", () => $7c8c20575fbc9bfc$export$200d7bd7633253ce);

var $5uXOq = parcelRequire("5uXOq");

var $gHDlh = parcelRequire("gHDlh");

var $9Byym = parcelRequire("9Byym");
const $7c8c20575fbc9bfc$export$200d7bd7633253ce = (props)=>{
    const { message: message, packageName: packageName, componentsMapping: componentsMapping } = props;
    const messageParts = (0, $5uXOq.useMemo)(()=>{
        const { tags: tags, openTags: openTags, closeTags: closeTags } = (0, $9Byym.getTags)(componentsMapping);
        try {
            const parts = [];
            let token = '';
            let TagComponent;
            let closeTagLookup;
            for(let i = 0; i < message.length; i += 1){
                const letter = message[i];
                token += letter;
                if ((0, $9Byym.isCloseTagDelimiter)(letter)) {
                    const firstTagFound = (0, $9Byym.findTag)(token, {
                        tags: openTags
                    });
                    if (firstTagFound !== null && firstTagFound !== undefined) {
                        // if we have a tag already means it is a malformed message since it is 2 subsequent open tags
                        if (TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                        const text = token.replace(firstTagFound, '');
                        parts.push(text);
                        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
                        const tagInfo = tags[firstTagFound];
                        TagComponent = tagInfo.component;
                        closeTagLookup = tagInfo.close;
                        token = '';
                    }
                }
                if (closeTagLookup !== null && closeTagLookup !== undefined && (0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: [
                        closeTagLookup
                    ]
                })) {
                    // this mean that we do not have an open tag for this closing tag
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                    const text = token.replace(closeTagLookup, '');
                    parts.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TagComponent, null, text));
                    TagComponent = undefined;
                    token = '';
                    closeTagLookup = undefined;
                }
                if ((0, $9Byym.isCloseTagDelimiter)(letter) && (0, $9Byym.isAnyTag)(token, {
                    tags: closeTags
                })) {
                    // if we do not have an open tag mean we are closing a tag that is not open
                    if (!TagComponent) throw new (0, $gHDlh.MalformedMessageError)();
                }
            }
            // if we reached the end and we have an open tag, mean this message is malformed
            if (TagComponent || closeTagLookup) throw new (0, $gHDlh.MalformedMessageError)();
            // flush anything we keep in the current token
            if (token.length > 0) parts.push(token);
            return parts;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            if (e instanceof (0, $gHDlh.MalformedMessageError)) {
                (0, $gHDlh.logMalformedMessageError)({
                    message: message,
                    packageName: packageName
                });
                return [
                    (0, $gHDlh.getMalformedMessage)({
                        message: message,
                        closeTags: closeTags,
                        openTags: openTags
                    })
                ];
            }
            throw e;
        }
    }, [
        message,
        packageName,
        componentsMapping
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, messageParts.map((item, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
            key: index
        }, item)));
};

});
parcelRegister("gHDlh", function(module, exports) {

$parcel$export(module.exports, "getMalformedMessage", () => $ecff24857c176a60$export$f085cf20ec1f69ab);
$parcel$export(module.exports, "logMalformedMessageError", () => $ecff24857c176a60$export$954c3e6aad1c9429);
$parcel$export(module.exports, "MalformedMessageError", () => $ecff24857c176a60$export$40d900e818b9630e);

var $2YZCu = parcelRequire("2YZCu");

var $jcw0u = parcelRequire("jcw0u");

const $ecff24857c176a60$export$f085cf20ec1f69ab = ({ message: message, openTags: openTags, closeTags: closeTags })=>[
        ...openTags,
        ...closeTags
    ].reduce((acc, tag)=>acc.replace(new RegExp(tag, 'g'), ''), message);
const $ecff24857c176a60$export$954c3e6aad1c9429 = ({ message: message, packageName: packageName })=>{
    if (packageName !== null && packageName !== undefined) {
        const errorMessage = `Malformed message: ${message}`;
        // Send error log to analytics pipeline (i.e. SFX) and Sentry
        (0, $jcw0u.default)({
            meta: {
                packageName: packageName,
                id: (0, $5514815b06163219$export$f3390a0e172fee41)
            },
            attributes: {
                message: errorMessage
            }
        });
        // Send error log to Splunk
        const location = `${packageName}.${(0, $5514815b06163219$export$f3390a0e172fee41)}`;
        (0, $2YZCu.default).unsafeErrorWithCustomerData(location, errorMessage);
    }
};
class $ecff24857c176a60$export$40d900e818b9630e extends Error {
    constructor(){
        super('Malformed i18n message');
    }
}

});
const $5514815b06163219$export$f3390a0e172fee41 = 'formattedI18NMessage';


parcelRegister("9Byym", function(module, exports) {

$parcel$export(module.exports, "getTags", () => $84498158f946a67b$export$af63d7414243dad3);
$parcel$export(module.exports, "isAnyTag", () => $84498158f946a67b$export$38ffa64fc639355f);
$parcel$export(module.exports, "findTag", () => $84498158f946a67b$export$dfca0f74034f8657);
$parcel$export(module.exports, "isCloseTagDelimiter", () => $84498158f946a67b$export$d5170904651e91b1);

const $84498158f946a67b$export$af63d7414243dad3 = (componentsMapping)=>Object.entries(componentsMapping).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (acc, [key, value])=>{
        const open = `{${key}Start}`;
        const close = `{${key}End}`;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        acc.tags[open] = {
            close: close,
            component: value
        };
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.openTags.push(open);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        acc.closeTags.push(close);
        return acc;
    }, {
        tags: {},
        openTags: [],
        closeTags: []
    });
const $84498158f946a67b$export$38ffa64fc639355f = (text, { tags: tags })=>tags.some((tag)=>text.includes(tag));
const $84498158f946a67b$export$dfca0f74034f8657 = (text, { tags: tags })=>tags.find((tag)=>text.includes(tag));
const $84498158f946a67b$export$d5170904651e91b1 = (letter)=>letter === (0, $7ed9c0b663db8b35$export$a10c567c3288a6b4);

});
const $7ed9c0b663db8b35$export$a10c567c3288a6b4 = '}';



parcelRegister("jQ7vZ", function(module, exports) {

$parcel$export(module.exports, "useQueryParam", () => $9fff0bf09ea99829$export$ae316f0eeb712a36);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9xWGk = parcelRequire("9xWGk");

var $ebyGx = parcelRequire("ebyGx");

var $doZTA = parcelRequire("doZTA");
const $9fff0bf09ea99829$export$ae316f0eeb712a36 = (queryParam)=>{
    const [{ location: { pathname: pathname }, query: query }, { push: push }] = (0, $doZTA.useRouter)();
    const queryParamValue = query[queryParam];
    const setQueryParam = (0, $5uXOq.useCallback)((newValue)=>{
        const parsedSearch = (0, (/*@__PURE__*/$parcel$interopDefault($9xWGk)))({
            ...query,
            [queryParam]: newValue
        }, (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value));
        const strSearch = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(parsedSearch);
        push(pathname + (strSearch !== '' ? `?${strSearch}` : ''));
    }, [
        pathname,
        push,
        query,
        queryParam
    ]);
    return [
        queryParamValue,
        setQueryParam
    ];
};

});

parcelRegister("kDbMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $9f493812da96b319$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9f493812da96b319$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-flags.card-filtered.title",
        "defaultMessage": "Changes are saved, but {numIssues, plural, one {issue isn't} other {issues aren't}} visible"
    },
    titleMovedBetweenSwimlanes: {
        "id": "software-flags.card-filtered.title-moved-between-swimlanes",
        "defaultMessage": "You've created {numIssues, plural, one {# issue} other {# issues}}"
    },
    descriptionMovedBetweenSwimlanes: {
        "id": "software-flags.card-filtered.description-moved-between-swimlanes",
        "defaultMessage": "{numIssues, plural, one {It's} other {They've}} been created in a different swimlane because of the board's JQL setup."
    },
    descriptionWithLink: {
        "id": "software-flags.card-filtered.description-with-link",
        "defaultMessage": "For issue {linkStart}{linkEnd} to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    description: {
        "id": "software-flags.card-filtered.description",
        "defaultMessage": "For an issue to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    issueLink: {
        "id": "software-flags.card-filtered.issue-link",
        "defaultMessage": "View {numIssues, plural, one {issue} other {issues}}"
    },
    issueAddToSprint: {
        "id": "software-flags.card-filtered.issue-add-to-sprint",
        "defaultMessage": "Add to {sprintName}"
    },
    issueAddToSprintLoading: {
        "id": "software-flags.card-filtered.issue-add-to-sprint-loading",
        "defaultMessage": "Adding..."
    },
    issueAddToSprintSuccess: {
        "id": "software-flags.card-filtered.issue-add-to-sprint-success",
        "defaultMessage": "Added to sprint"
    },
    titleIssueTermRefresh: {
        "id": "software-flags.card-filtered.title-issue-term-refresh",
        "defaultMessage": "Changes are saved, but {numIssues, plural, one {work item isn't} other {work items aren't}} visible"
    },
    titleMovedBetweenSwimlanesIssueTermRefresh: {
        "id": "software-flags.card-filtered.title-moved-between-swimlanes-issue-term-refresh",
        "defaultMessage": "You've created {numIssues, plural, one {# work item} other {# work items}}"
    },
    descriptionMovedBetweenSwimlanesIssueTermRefresh: {
        "id": "software-flags.card-filtered.description-moved-between-swimlanes-issue-term-refresh",
        "defaultMessage": "{numIssues, plural, one {It's} other {They've}} been created in a different swimlane because of the board's JQL setup."
    },
    descriptionWithLinkIssueTermRefresh: {
        "id": "software-flags.card-filtered.description-with-link-issue-term-refresh",
        "defaultMessage": "For work item {linkStart}{linkEnd} to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    descriptionIssueTermRefresh: {
        "id": "software-flags.card-filtered.description-issue-term-refresh",
        "defaultMessage": "For a work item to be visible, it must match your project and filters, and have a status that\u2019s assigned to the board."
    },
    issueLinkIssueTermRefresh: {
        "id": "software-flags.card-filtered.issue-link-issue-term-refresh",
        "defaultMessage": "View{numIssues, plural, one {} other { work items}}"
    }
});

});


parcelRegister("dW1HX", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE_MODAL", () => $8b1c17eebaa9fcb9$export$80341990b52b578a);
$parcel$export(module.exports, "openIssueModal", () => $8b1c17eebaa9fcb9$export$7aa6c7dd30954cbc);
$parcel$export(module.exports, "OPEN_PLAN_ISSUE_MODAL", () => $8b1c17eebaa9fcb9$export$9b985108e47f7d94);
$parcel$export(module.exports, "openPlanIssueModal", () => $8b1c17eebaa9fcb9$export$e7f062d9a7a48eec);
$parcel$export(module.exports, "CLOSE_PLAN_ISSUE_MODAL", () => $8b1c17eebaa9fcb9$export$d224fd2efd0fb3e7);
$parcel$export(module.exports, "closePlanIssueModal", () => $8b1c17eebaa9fcb9$export$1e7fdcc8d7bd083f);
$parcel$export(module.exports, "OPEN_ISSUE_MODAL_DEBOUNCED", () => $8b1c17eebaa9fcb9$export$113609c05439f0d1);
$parcel$export(module.exports, "openIssueModalDebounced", () => $8b1c17eebaa9fcb9$export$7395ef93f45ef532);
$parcel$export(module.exports, "CLOSE_ISSUE_MODAL", () => $8b1c17eebaa9fcb9$export$c246d364cf9f796c);
$parcel$export(module.exports, "closeIssueModal", () => $8b1c17eebaa9fcb9$export$d985da263b49e04b);
$parcel$export(module.exports, "RESET_EXTERNAL_ACTION", () => $8b1c17eebaa9fcb9$export$6c02b00db69a816);
$parcel$export(module.exports, "resetExternalAction", () => $8b1c17eebaa9fcb9$export$52fe5d486c3c9c71);
const $8b1c17eebaa9fcb9$export$80341990b52b578a = 'state.actions.issue.modal.OPEN_ISSUE_MODAL';
const $8b1c17eebaa9fcb9$export$7aa6c7dd30954cbc = (issueKey, externalAction)=>({
        type: $8b1c17eebaa9fcb9$export$80341990b52b578a,
        payload: {
            issueKey: issueKey,
            externalAction: externalAction
        }
    });
const $8b1c17eebaa9fcb9$export$9b985108e47f7d94 = 'state.actions.issue.modal.OPEN_PLAN_ISSUE_MODAL';
const $8b1c17eebaa9fcb9$export$e7f062d9a7a48eec = (issueId)=>({
        type: $8b1c17eebaa9fcb9$export$9b985108e47f7d94,
        payload: {
            issueId: issueId
        }
    });
const $8b1c17eebaa9fcb9$export$d224fd2efd0fb3e7 = 'state.actions.issue.modal.CLOSE_PLAN_ISSUE_MODAL';
const $8b1c17eebaa9fcb9$export$1e7fdcc8d7bd083f = ()=>({
        type: $8b1c17eebaa9fcb9$export$d224fd2efd0fb3e7
    });
const $8b1c17eebaa9fcb9$export$113609c05439f0d1 = 'state.actions.issue.modal.OPEN_ISSUE_MODAL_DEBOUNCED';
const $8b1c17eebaa9fcb9$export$7395ef93f45ef532 = (issueKey, externalAction)=>({
        type: $8b1c17eebaa9fcb9$export$113609c05439f0d1,
        payload: {
            issueKey: issueKey,
            externalAction: externalAction
        }
    });
const $8b1c17eebaa9fcb9$export$c246d364cf9f796c = 'state.actions.issue.modal.CLOSE_ISSUE_MODAL';
const $8b1c17eebaa9fcb9$export$d985da263b49e04b = (issuekey)=>({
        type: $8b1c17eebaa9fcb9$export$c246d364cf9f796c,
        payload: issuekey
    });
const $8b1c17eebaa9fcb9$export$6c02b00db69a816 = 'state.actions.issue.modal.RESET_EXTERNAL_ACTION';
const $8b1c17eebaa9fcb9$export$52fe5d486c3c9c71 = ()=>({
        type: $8b1c17eebaa9fcb9$export$6c02b00db69a816
    });

});

parcelRegister("dkGow", function(module, exports) {

$parcel$export(module.exports, "ADD_TO_SPRINT_REQUEST", () => $9ff718b10b6f2626$export$7bdcd99783be67bd);
$parcel$export(module.exports, "addToSprintRequest", () => $9ff718b10b6f2626$export$84c916c5eb9d94e4);
$parcel$export(module.exports, "ADD_TO_SPRINT_SUCCESS", () => $9ff718b10b6f2626$export$e9db83c78a8c2bf1);
$parcel$export(module.exports, "addToSprintSuccess", () => $9ff718b10b6f2626$export$181f94f7c9641e5b);
$parcel$export(module.exports, "ADD_TO_SPRINT_FAILURE", () => $9ff718b10b6f2626$export$55ef7a39277088c3);
$parcel$export(module.exports, "addToSprintFailure", () => $9ff718b10b6f2626$export$b8aaecf8ac2c3d6f);

var $9rND4 = parcelRequire("9rND4");
const $9ff718b10b6f2626$export$7bdcd99783be67bd = 'state.actions.sprints.add-to-sprint.ADD_TO_SPRINT_REQUEST';
function $9ff718b10b6f2626$export$84c916c5eb9d94e4(issueId, sprintId) {
    return {
        type: $9ff718b10b6f2626$export$7bdcd99783be67bd,
        payload: {
            issueId: issueId,
            sprintId: sprintId
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    };
}
const $9ff718b10b6f2626$export$e9db83c78a8c2bf1 = 'state.actions.sprints.add-to-sprint.ADD_TO_SPRINT_SUCCESS';
function $9ff718b10b6f2626$export$181f94f7c9641e5b(issueKey, sprintId, optimisticId) {
    return {
        type: $9ff718b10b6f2626$export$e9db83c78a8c2bf1,
        payload: {
            issueKey: issueKey,
            sprintId: sprintId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    };
}
const $9ff718b10b6f2626$export$55ef7a39277088c3 = 'state.actions.sprints.add-to-sprint.ADD_TO_SPRINT_FAILURE';
function $9ff718b10b6f2626$export$b8aaecf8ac2c3d6f(issueKey, sprintId, optimisticId) {
    return {
        type: $9ff718b10b6f2626$export$55ef7a39277088c3,
        payload: {
            issueKey: issueKey,
            sprintId: sprintId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    };
}

});

parcelRegister("k8auG", function(module, exports) {

$parcel$export(module.exports, "isPollingEnabled", () => $eb31a6415d2c861f$export$ded593d93e24b277);
$parcel$export(module.exports, "isDragging", () => $eb31a6415d2c861f$export$9e9bc3c487fccc00);
$parcel$export(module.exports, "isIpBoardFailed", () => $eb31a6415d2c861f$export$77e8ff16a50d05bc);
$parcel$export(module.exports, "getPreventInlineEditing", () => $eb31a6415d2c861f$export$62c58c3c18699748);
$parcel$export(module.exports, "getIsHeaderCompactMode", () => $eb31a6415d2c861f$export$da6f0d255ab51043);
$parcel$export(module.exports, "isBoardEmptySelector", () => $eb31a6415d2c861f$export$56bc3c6954b31f2);
$parcel$export(module.exports, "isBacklogEnabled", () => $eb31a6415d2c861f$export$892dff07798b1501);
$parcel$export(module.exports, "isStandupsEnabled", () => $eb31a6415d2c861f$export$dfc6249e7bef8b0d);
$parcel$export(module.exports, "operationsSelector", () => $eb31a6415d2c861f$export$5244c0030b3a418e);
$parcel$export(module.exports, "shouldAutoOpenIccAndShowCreateButton", () => $eb31a6415d2c861f$export$9e277b9da841d16f);
$parcel$export(module.exports, "isUserAtLeastMemberOfProject", () => $eb31a6415d2c861f$export$56dbce3d18728488);
$parcel$export(module.exports, "getJQLSwimlanesData", () => $eb31a6415d2c861f$export$2aca7fe5f3c872c9);
$parcel$export(module.exports, "shouldRenderSwimlaneSelector", () => $eb31a6415d2c861f$export$aa9ba823fad8376b);
$parcel$export(module.exports, "addToSprintSuccessSelector", () => $eb31a6415d2c861f$export$200898df6d6c8527);
$parcel$export(module.exports, "addToSprintLoadingSelector", () => $eb31a6415d2c861f$export$e6c1d68a0e638129);
$parcel$export(module.exports, "isFavouriteSelector", () => $eb31a6415d2c861f$export$2527c507c9238fe0);
$parcel$export(module.exports, "getBoardActionExtensionData", () => $eb31a6415d2c861f$export$d33369b2b455742f);
$parcel$export(module.exports, "shouldShowIssueTypeConfigOptions", () => $eb31a6415d2c861f$export$a5d0d496f206f332);

var $dGvGJ = parcelRequire("dGvGJ");

var $2vSU6 = parcelRequire("2vSU6");

var $k2DRb = parcelRequire("k2DRb");


var $kUSq3 = parcelRequire("kUSq3");


var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $1vXOx = parcelRequire("1vXOx");
const $eb31a6415d2c861f$export$ded593d93e24b277 = (state)=>state.ui.board.isPollingEnabled;
const $eb31a6415d2c861f$export$9e9bc3c487fccc00 = (state)=>state.ui.board.isDragging;
const $eb31a6415d2c861f$export$77e8ff16a50d05bc = (state)=>state.ui.board.isIpBoardFailed;
const $eb31a6415d2c861f$export$62c58c3c18699748 = (state)=>state.ui.board.displayOptions.preventInlineEditing;
const $eb31a6415d2c861f$export$da6f0d255ab51043 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsIncrementPlanningBoard),
    (state)=>state.ui.board.displayOptions.isHeaderCompactMode
], (isIncrementPlanningBoard, isHeaderCompactMode)=>{
    if (isIncrementPlanningBoard) return true;
    return isHeaderCompactMode;
});
const $eb31a6415d2c861f$export$56bc3c6954b31f2 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.workIssuesSelector)
], (allIssues)=>allIssues.length === 0);
const $eb31a6415d2c861f$export$892dff07798b1501 = (state)=>(0, $67Z81.getBoardConfig)(state).isBacklogEnabled || false;
const $eb31a6415d2c861f$export$dfc6249e7bef8b0d = (state)=>(0, $67Z81.getBoardConfig)(state).isStandupsEnabled || false;
const $eb31a6415d2c861f$export$4eefc3930c8615a5 = (state)=>(0, $67Z81.getBoardConfig)(state).isManageRulesEnabled;
const $eb31a6415d2c861f$export$5244c0030b3a418e = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getAppConfiguration)
], (configuration)=>configuration.extension.operations);
const $eb31a6415d2c861f$export$9e277b9da841d16f = (state)=>!(0, $67Z81.getIsCMPBoard)(state) && (0, $67Z81.projectTypeSelector)(state) === (0, $2vSU6.SOFTWARE_PROJECT) && !(0, $67Z81.getIsIncrementPlanningBoard)(state);
const $eb31a6415d2c861f$export$30f8059a9cd28e6f = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $5mTgl.isInlineColumnEditEnabled),
    (0, $5mTgl.getAppliedIssueTypeFilters)
], (swimlaneMode, inlineColumnEditEnabled, issueTypeFilters)=>(swimlaneId, isAddingSubtaskToGroup)=>{
        const isSubtaskSwimlane = swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && swimlaneId !== (0, $c79wa.ChildlessSwimlane).id && swimlaneId !== null || isAddingSubtaskToGroup;
        const hasIssueTypeFilters = issueTypeFilters ? issueTypeFilters.length > 0 : false;
        return inlineColumnEditEnabled && !isSubtaskSwimlane && !hasIssueTypeFilters;
    });
const $eb31a6415d2c861f$export$56dbce3d18728488 = (state)=>// this directly). If a user can create issues in this project, they must be at least a Member,
    // and enjoy all the privileges of a Project Member (e.g. creating and ranking issues).
    !!(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$9205190dd90cb392];
const $eb31a6415d2c861f$export$d7a4d4bd1ecde768 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (state)=>(0, $67Z81.getEntities)(state).jqlSwimlanes
], (isCMPBoard, swimlaneMode, swimlanes, jqlSwimlanes)=>{
    if (!isCMPBoard) return false;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) {
        const nonEmptySwimlanes = jqlSwimlanes.swimlanes?.filter((swimlane)=>swimlane.issueIds.length > 0);
        return nonEmptySwimlanes?.length === 1 && nonEmptySwimlanes[0].isDefaultSwimlane;
    }
    return swimlanes.length === 1 && (0, $4jZ56.isDefaultSwimlane)(swimlanes[0].id);
});
const $eb31a6415d2c861f$export$2aca7fe5f3c872c9 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $45cXl.getSwimlaneMode),
    (state)=>(0, $67Z81.getEntities)(state).jqlSwimlanes
], (isCMPBoard, swimlaneMode, jqlSwimlanes)=>{
    // is only available on CMP boards
    if (isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) return jqlSwimlanes.swimlanes;
    return undefined;
});
const $eb31a6415d2c861f$export$aa9ba823fad8376b = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    $eb31a6415d2c861f$export$56bc3c6954b31f2,
    (0, $67Z81.getIsCMPBoard),
    $eb31a6415d2c861f$export$d7a4d4bd1ecde768
], (swimlaneMode, isBoardEmpty, isCMPBoard, onlyHasDefaultSwimlane)=>{
    const hasSwimlanes = swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id;
    return isCMPBoard ? hasSwimlanes && !isBoardEmpty && !onlyHasDefaultSwimlane : hasSwimlanes;
});
const $eb31a6415d2c861f$export$200898df6d6c8527 = (state)=>state.ui.board.boardAddNewIssueToSprint?.isSuccess;
const $eb31a6415d2c861f$export$e6c1d68a0e638129 = (state)=>state.ui.board.boardAddNewIssueToSprint?.isLoading;
const $eb31a6415d2c861f$export$46339264d5c5653b = (0, $dGvGJ.createSelector)([
    $eb31a6415d2c861f$export$56bc3c6954b31f2,
    (0, $67Z81.getOrderedColumnIds),
    (0, $9OPlz.getColumnIdToKeepICCOpen)
], (isBoardEmpty, orderedIds, columnIdToKeepOpen)=>(columnId)=>isBoardEmpty && orderedIds.indexOf(columnId) === 0 && columnIdToKeepOpen === null);
const $eb31a6415d2c861f$export$2527c507c9238fe0 = (state)=>(0, $67Z81.getEntities)(state).board.boardFavourite.isFavourite;
const $eb31a6415d2c861f$export$d33369b2b455742f = (0, $dGvGJ.createSelector)([
    (0, $67Z81.rapidViewIdSelector),
    (0, $67Z81.getBoardTypeForAnalytics),
    (0, $67Z81.projectIdSelector),
    (0, $67Z81.projectKeySelector),
    (0, $67Z81.projectTypeSelector),
    (0, $ebHh7.activeSprintsSelector)
], (boardId, boardType, projectId, projectKey, projectType, activeSprints)=>({
        board: {
            id: boardId,
            type: (0, $kUSq3.getBoardTypeForREST)(boardType)
        },
        project: {
            id: projectId.toString(),
            key: projectKey,
            type: projectType
        },
        sprints: activeSprints?.map(({ id: id })=>({
                id: id.toString(),
                state: (0, $7e733a5d4e4331fc$export$3ebc9911a79d714f)
            })),
        type: (0, $k2DRb.BOARD_ACTION_MODULE)
    }));
const $eb31a6415d2c861f$export$a5d0d496f206f332 = (state)=>!(0, $67Z81.getIsCMPBoard)(state) && (0, $67Z81.projectTypeSelector)(state) === (0, $2vSU6.SOFTWARE_PROJECT) && !!(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df];

});
parcelRegister("kUSq3", function(module, exports) {

$parcel$export(module.exports, "getBoardTypeForREST", () => $db7e06e2591273dc$export$6f564f36e956826);

const $db7e06e2591273dc$export$6f564f36e956826 = (boardType)=>{
    switch(boardType){
        case 0, $7e733a5d4e4331fc$export$9f54a1518145e351:
            return 'kanban';
        case 0, $7e733a5d4e4331fc$export$8ee1fad10cc70eb5:
            return 'scrum';
        default:
            return 'simple';
    }
};

});

parcelRegister("iuuJH", function(module, exports) {

$parcel$export(module.exports, "NO_SWIMLANE", () => $f9df2e6cad45bdb6$export$601dd9e413c617ed);
$parcel$export(module.exports, "SWIMLANE_BY_ASSIGNEE", () => $f9df2e6cad45bdb6$export$c0f3aef3732a1477);
$parcel$export(module.exports, "SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST", () => $f9df2e6cad45bdb6$export$2ff7658012a5c88c);
$parcel$export(module.exports, "SWIMLANE_BY_PARENT_ISSUE", () => $f9df2e6cad45bdb6$export$947c02da00077326);
$parcel$export(module.exports, "SWIMLANE_BY_SUBTASK", () => $f9df2e6cad45bdb6$export$90710dcc49445a49);
$parcel$export(module.exports, "SWIMLANE_BY_JQL", () => $f9df2e6cad45bdb6$export$2f0ea84d02e5757f);
$parcel$export(module.exports, "SWIMLANE_BY_PROJECT", () => $f9df2e6cad45bdb6$export$4625977a5c2afe09);
$parcel$export(module.exports, "SWIMLANE_BY_TEAM", () => $f9df2e6cad45bdb6$export$60dcf85dae148a2);
$parcel$export(module.exports, "SWIMLANE_BY_REQUEST_TYPE", () => $f9df2e6cad45bdb6$export$c2f0dc0dfc7ea0cc);
$parcel$export(module.exports, "defaultSwimlanes", () => $f9df2e6cad45bdb6$export$ec433d4f27cc09fa);
$parcel$export(module.exports, "SWIMLANE_CHILDLESS", () => $f9df2e6cad45bdb6$export$fba1af95ff9008dd);
$parcel$export(module.exports, "SWIMLANE_PARENTLESS", () => $f9df2e6cad45bdb6$export$90b669333b86623f);
$parcel$export(module.exports, "SWIMLANE_UNASSIGNED", () => $f9df2e6cad45bdb6$export$c0ac84cf8e34b8ae);

var $6s1PB = parcelRequire("6s1PB");

var $5VJuY = parcelRequire("5VJuY");
const $f9df2e6cad45bdb6$export$601dd9e413c617ed = {
    id: 'NO_SWIMLANE',
    message: (0, $5VJuY.default).none
};
const $f9df2e6cad45bdb6$export$c0f3aef3732a1477 = {
    id: 'SWIMLANE_BY_ASSIGNEE',
    message: (0, $5VJuY.default).assignee
};
const $f9df2e6cad45bdb6$export$2ff7658012a5c88c = {
    id: 'SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST',
    get message () {
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5VJuY.default).assigneeunassignedfirstIssueTermRefresh : (0, $5VJuY.default).assigneeunassignedfirst;
    }
};
const $f9df2e6cad45bdb6$export$947c02da00077326 = {
    id: 'SWIMLANE_BY_PARENT_ISSUE',
    message: (0, $5VJuY.default).epic
};
const $f9df2e6cad45bdb6$export$90710dcc49445a49 = {
    id: 'SWIMLANE_BY_SUBTASK',
    message: (0, $5VJuY.default).subtask
};
const $f9df2e6cad45bdb6$export$2f0ea84d02e5757f = {
    id: 'SWIMLANE_BY_JQL',
    message: (0, $5VJuY.default).jql
};
const $f9df2e6cad45bdb6$export$4625977a5c2afe09 = {
    id: 'SWIMLANE_BY_PROJECT',
    message: (0, $5VJuY.default).project
};
const $f9df2e6cad45bdb6$export$60dcf85dae148a2 = {
    id: 'SWIMLANE_BY_TEAM'
};
const $f9df2e6cad45bdb6$export$c2f0dc0dfc7ea0cc = {
    id: 'SWIMLANE_BY_REQUEST_TYPE',
    message: (0, $5VJuY.default).requestType
};
const $f9df2e6cad45bdb6$export$ec433d4f27cc09fa = [
    $f9df2e6cad45bdb6$export$601dd9e413c617ed,
    $f9df2e6cad45bdb6$export$c0f3aef3732a1477
];
const $f9df2e6cad45bdb6$export$fba1af95ff9008dd = '$childless$';
const $f9df2e6cad45bdb6$export$90b669333b86623f = '$parentless$';
const $f9df2e6cad45bdb6$export$c0ac84cf8e34b8ae = '$unassigned$';

});
parcelRegister("5VJuY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4518803524dd7272$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4518803524dd7272$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    none: {
        "id": "software.main.model.swimlane.none",
        "defaultMessage": "None"
    },
    assignee: {
        "id": "software.main.model.swimlane.assignee",
        "defaultMessage": "Assignee"
    },
    assigneeunassignedfirst: {
        "id": "software.main.model.swimlane.assigneeunassignedfirst",
        "defaultMessage": "Assignee with unassigned issues showing above"
    },
    epic: {
        "id": "software.main.model.swimlane.epic",
        "defaultMessage": "{displayText}"
    },
    subtask: {
        "id": "software.main.model.swimlane.subtask",
        "defaultMessage": "{displayText}"
    },
    stories: {
        "id": "software.main.model.swimlane.stories",
        "defaultMessage": "Stories"
    },
    unassigned: {
        "id": "software.main.model.swimlane.unassigned",
        "defaultMessage": "Unassigned"
    },
    parentless: {
        "id": "software.main.model.swimlane.parentless",
        "defaultMessage": "Issues without {issueParentTypeName}"
    },
    jql: {
        "id": "software.main.model.swimlane.jql",
        "defaultMessage": "Queries"
    },
    project: {
        "id": "software.main.model.swimlane.project",
        "defaultMessage": "Projects"
    },
    childless: {
        "id": "software.main.model.swimlane.childless",
        "defaultMessage": "Everything else"
    },
    requestType: {
        "id": "software.main.model.swimlane.request-type",
        "defaultMessage": "Request type"
    },
    noRequestType: {
        "id": "software.main.model.swimlane.no-request-type",
        "defaultMessage": "No request type"
    },
    assigneeunassignedfirstIssueTermRefresh: {
        "id": "software.main.model.swimlane.assigneeunassignedfirst-issue-term-refresh",
        "defaultMessage": "Assignee with unassigned work items showing above"
    },
    parentlessIssueTermRefresh: {
        "id": "software.main.model.swimlane.parentless-issue-term-refresh",
        "defaultMessage": "No {issueParentTypeName}"
    }
});

});


parcelRegister("c79wa", function(module, exports) {

$parcel$export(module.exports, "ASSIGNEE", () => $c3d281ff0bb76f0d$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "PARENT", () => $c3d281ff0bb76f0d$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "STORY", () => $c3d281ff0bb76f0d$export$1ea39a3ae330045);
$parcel$export(module.exports, "JQL", () => $c3d281ff0bb76f0d$export$dc9697aa7b3a6d6f);
$parcel$export(module.exports, "PROJECT", () => $c3d281ff0bb76f0d$export$fe791c4fa892e400);
$parcel$export(module.exports, "REQUEST_TYPE", () => $c3d281ff0bb76f0d$export$92ab80c1dc9baf44);
$parcel$export(module.exports, "TeamlessSwimlane", () => $c3d281ff0bb76f0d$export$c8e393a416c39da2);
$parcel$export(module.exports, "UnassignedSwimlane", () => $c3d281ff0bb76f0d$export$94cce519f399219b);
$parcel$export(module.exports, "ParentlessSwimlane", () => $c3d281ff0bb76f0d$export$5fed833af0de9852);
$parcel$export(module.exports, "ChildlessSwimlane", () => $c3d281ff0bb76f0d$export$360035322a41fdcd);
$parcel$export(module.exports, "UnassignedRequestTypeSwimlane", () => $c3d281ff0bb76f0d$export$ff317ed97c0f34eb);

var $7uUwQ = parcelRequire("7uUwQ");

var $6s1PB = parcelRequire("6s1PB");

var $4jAPy = parcelRequire("4jAPy");

var $5VJuY = parcelRequire("5VJuY");

var $iuuJH = parcelRequire("iuuJH");
const $c3d281ff0bb76f0d$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $c3d281ff0bb76f0d$export$e0dfb65d1047c53c = 'PARENT';
const $c3d281ff0bb76f0d$export$1ea39a3ae330045 = 'STORY';
const $c3d281ff0bb76f0d$export$dc9697aa7b3a6d6f = 'JQL';
const $c3d281ff0bb76f0d$export$fe791c4fa892e400 = 'PROJECT';
const $c3d281ff0bb76f0d$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $c3d281ff0bb76f0d$export$c8e393a416c39da2 = (0, $7uUwQ.freeze)({
    id: (0, $4jAPy.SWIMLANE_TEAMLESS),
    message: (0, $5VJuY.default).unassigned,
    name: null,
    imageUrl: null,
    // set the isPlanTeam is true to hide the external lozenge
    values: {
        type: (0, $4jAPy.TEAM),
        isPlanTeam: true,
        verified: false
    },
    issueKey: null
});
const $c3d281ff0bb76f0d$export$94cce519f399219b = (0, $7uUwQ.freeze)({
    id: (0, $iuuJH.SWIMLANE_UNASSIGNED),
    message: (0, $5VJuY.default).unassigned,
    name: null,
    imageUrl: null,
    values: {
        type: $c3d281ff0bb76f0d$export$f8f7545d2bb78afb,
        assignee: null,
        assigneeAccountId: null
    },
    issueKey: null
});
const $c3d281ff0bb76f0d$export$5fed833af0de9852 = {
    id: (0, $iuuJH.SWIMLANE_PARENTLESS),
    get message () {
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5VJuY.default).parentlessIssueTermRefresh : (0, $5VJuY.default).parentless;
    },
    name: null,
    imageUrl: null,
    values: {
        type: $c3d281ff0bb76f0d$export$e0dfb65d1047c53c,
        parentId: null
    },
    issueKey: null
};
const $c3d281ff0bb76f0d$export$360035322a41fdcd = (0, $7uUwQ.freeze)({
    id: (0, $iuuJH.SWIMLANE_CHILDLESS),
    message: (0, $5VJuY.default).childless,
    name: null,
    imageUrl: null,
    values: {
        type: $c3d281ff0bb76f0d$export$1ea39a3ae330045,
        parentId: null
    },
    issueKey: null
});
const $c3d281ff0bb76f0d$export$ff317ed97c0f34eb = (0, $7uUwQ.freeze)({
    id: (0, $iuuJH.SWIMLANE_UNASSIGNED),
    message: (0, $5VJuY.default).noRequestType,
    name: null,
    imageUrl: null,
    values: {
        type: $c3d281ff0bb76f0d$export$92ab80c1dc9baf44,
        id: null
    },
    issueKey: null
});

});

parcelRegister("9OPlz", function(module, exports) {

$parcel$export(module.exports, "getCardSelection", () => $9c373a482d4254d7$export$7710a9df00706385);
$parcel$export(module.exports, "getCardDragState", () => $9c373a482d4254d7$export$d5f32efe7e74f270);
$parcel$export(module.exports, "getSelectedTransition", () => $9c373a482d4254d7$export$95f346fb59c0427f);
$parcel$export(module.exports, "isHoverIntended", () => $9c373a482d4254d7$export$3b2830cc402a5863);
$parcel$export(module.exports, "getCardAutoScroll", () => $9c373a482d4254d7$export$4eeaff5dde2f423b);
$parcel$export(module.exports, "getCardActive", () => $9c373a482d4254d7$export$85bf96ba919898ca);
$parcel$export(module.exports, "getCardActiveKey", () => $9c373a482d4254d7$export$924ece9a606bacd2);
$parcel$export(module.exports, "getCardActiveAssignee", () => $9c373a482d4254d7$export$4fb0ea66004e1b43);
$parcel$export(module.exports, "getDraggingCardId", () => $9c373a482d4254d7$export$1320f484db5f7bb0);
$parcel$export(module.exports, "isDragInSnapMode", () => $9c373a482d4254d7$export$16cd88dec02ef1bb);
$parcel$export(module.exports, "hasNonGlobalTransitions", () => $9c373a482d4254d7$export$190c87267e0826dd);
$parcel$export(module.exports, "makeGetHasConditions", () => $9c373a482d4254d7$export$a59f9b626e859644);
$parcel$export(module.exports, "hasConditionsOnTransitions", () => $9c373a482d4254d7$export$2e3730a667f8f1b6);
$parcel$export(module.exports, "hasNoTransitionSelector", () => $9c373a482d4254d7$export$9c9dc7cd33e477eb);
$parcel$export(module.exports, "isTransactionValid", () => $9c373a482d4254d7$export$b26126c87aa5db8f);
$parcel$export(module.exports, "isCardSelected", () => $9c373a482d4254d7$export$a67ae423fb9ea0f9);
$parcel$export(module.exports, "isCardFocused", () => $9c373a482d4254d7$export$525d749d966b122a);
$parcel$export(module.exports, "shouldCardShowRipple", () => $9c373a482d4254d7$export$cbe9d09100880591);
$parcel$export(module.exports, "areAnySelectedCardsIssueChildren", () => $9c373a482d4254d7$export$738ad8fdfc61d783);
$parcel$export(module.exports, "draggingCardSourceColumnIdSelector", () => $9c373a482d4254d7$export$547687b52becf582);
$parcel$export(module.exports, "draggingCardSourceSwimlaneIdSelector", () => $9c373a482d4254d7$export$a20afd2c88b78002);
$parcel$export(module.exports, "draggingCardIssueTypeId", () => $9c373a482d4254d7$export$9af5355c0a2b8eaf);
$parcel$export(module.exports, "draggingCardIssueStatusId", () => $9c373a482d4254d7$export$bd2e9e5f3d9710b6);
$parcel$export(module.exports, "getIssueIdWithAboveICCOpen", () => $9c373a482d4254d7$export$4f6134c81576f6c8);
$parcel$export(module.exports, "hasICCOpen", () => $9c373a482d4254d7$export$8f8d79952e8c1b8f);
$parcel$export(module.exports, "getColumnIdToKeepICCOpen", () => $9c373a482d4254d7$export$57e6136c07401474);
$parcel$export(module.exports, "getLastOpenedColumnId", () => $9c373a482d4254d7$export$9f41588a1efd6d68);
$parcel$export(module.exports, "keepICCOpenInColumn", () => $9c373a482d4254d7$export$5c497d1106b09e75);
$parcel$export(module.exports, "isUnscheduledColumnICCOpen", () => $9c373a482d4254d7$export$3baa40ff5c726e5e);
$parcel$export(module.exports, "draggingCardSourceStatusSelector", () => $9c373a482d4254d7$export$2cad9a22cc3d4e69);
$parcel$export(module.exports, "draggingCardTargetColumnIdSelector", () => $9c373a482d4254d7$export$ae21bfdcca8ab956);
$parcel$export(module.exports, "draggingCardHoverIntentSelector", () => $9c373a482d4254d7$export$c89387469f496cfe);
$parcel$export(module.exports, "selectedIssueKeysSelector", () => $9c373a482d4254d7$export$3084e509c1c105f7);
$parcel$export(module.exports, "selectedIssueIdsSelector", () => $9c373a482d4254d7$export$96bec1932f9604ac);
$parcel$export(module.exports, "getVisibleCardSelection", () => $9c373a482d4254d7$export$73106b7a505f2e87);
$parcel$export(module.exports, "getShouldShowParent", () => $9c373a482d4254d7$export$bf98019ef3e35fb4);
$parcel$export(module.exports, "getCardEditSummary", () => $9c373a482d4254d7$export$a4a515b62d43884e);
$parcel$export(module.exports, "getAnyCardEditingSummary", () => $9c373a482d4254d7$export$7666a8f0609019d3);
$parcel$export(module.exports, "getCardEditAssignee", () => $9c373a482d4254d7$export$65b4fa1de1c6580a);
$parcel$export(module.exports, "getActiveInlineEditCardIds", () => $9c373a482d4254d7$export$67a508d1fc8a9a23);

var $dGvGJ = parcelRequire("dGvGJ");

var $chc6P = parcelRequire("chc6P");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $kGsr8 = parcelRequire("kGsr8");

var $5rFbt = parcelRequire("5rFbt");

var $iuuJH = parcelRequire("iuuJH");

var $bwTbl = parcelRequire("bwTbl");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");
const $9c373a482d4254d7$export$7710a9df00706385 = (state)=>state.ui.cards.selected;
const $9c373a482d4254d7$var$getCardUi = (state)=>(0, $67Z81.getUi)(state).cards;
const $9c373a482d4254d7$export$d5f32efe7e74f270 = (state)=>$9c373a482d4254d7$var$getCardUi(state).drag;
const $9c373a482d4254d7$export$95f346fb59c0427f = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).selectedTransition;
const $9c373a482d4254d7$export$3b2830cc402a5863 = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).hoverIntended || false;
const $9c373a482d4254d7$export$4083f6bcc362a6f5 = (state)=>$9c373a482d4254d7$var$getCardUi(state).focused;
const $9c373a482d4254d7$export$4eeaff5dde2f423b = (state)=>$9c373a482d4254d7$var$getCardUi(state).autoScroll;
const $9c373a482d4254d7$export$85bf96ba919898ca = (state)=>{
    const focusedCard = $9c373a482d4254d7$export$4083f6bcc362a6f5(state);
    if (focusedCard !== null) return focusedCard;
    const selectedCards = $9c373a482d4254d7$export$7710a9df00706385(state);
    return selectedCards[selectedCards.length - 1];
};
const $9c373a482d4254d7$export$924ece9a606bacd2 = (state)=>{
    const activeIssueId = $9c373a482d4254d7$export$85bf96ba919898ca(state);
    const issue = activeIssueId ? (0, $d2i8f.getIssueById)(state, activeIssueId) : null;
    return issue ? issue.key : null;
};
const $9c373a482d4254d7$export$4fb0ea66004e1b43 = (state)=>{
    const activeIssueId = $9c373a482d4254d7$export$85bf96ba919898ca(state);
    const issue = activeIssueId ? (0, $d2i8f.getIssueById)(state, activeIssueId) : null;
    return issue ? issue.assigneeAccountId : null;
};
const $9c373a482d4254d7$export$1320f484db5f7bb0 = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).cardId;
const $9c373a482d4254d7$export$16cd88dec02ef1bb = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).snapMode;
const $9c373a482d4254d7$var$getCardDragShowRipple = (state)=>$9c373a482d4254d7$export$d5f32efe7e74f270(state).rippleIdsToShow;
const $9c373a482d4254d7$export$190c87267e0826dd = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>!!cardTransitions && (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(cardTransitions.columnIssueTypeTransitions, (issueTypeTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(issueTypeTransitions)).some((t)=>!(t.isGlobal || t.isInitial)));
const $9c373a482d4254d7$export$a59f9b626e859644 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    $9c373a482d4254d7$export$7710a9df00706385,
    (0, $vAfHD.boardIssuesSelector)
], (cardTransitions, cardSelection, boardIssues)=>(issueId)=>{
        const getIssueTypeHasConditions = (issueTypeId)=>{
            if (!cardTransitions) return false;
            return Object.keys(cardTransitions.columnIssueTypeTransitions).some((columnId)=>{
                const issueTypeTransitions = cardTransitions.columnIssueTypeTransitions[columnId];
                const transitions = issueTypeTransitions[issueTypeId];
                return Boolean(transitions?.some((transition)=>Boolean(transition.hasConditions)));
            });
        };
        const selectedIssueTypes = (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
            ...cardSelection,
            issueId
        ].map((id)=>boardIssues[id]?.typeId));
        return selectedIssueTypes.some(getIssueTypeHasConditions);
    });
const $9c373a482d4254d7$export$2e3730a667f8f1b6 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>!!cardTransitions && (0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(cardTransitions.columnIssueTypeTransitions, (issueTypeTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(issueTypeTransitions)).some((t)=>t.hasConditions === true));
const $9c373a482d4254d7$export$9c9dc7cd33e477eb = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>!cardTransitions || Object.values(cardTransitions.columnIssueTypeTransitions).every((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))));
const $9c373a482d4254d7$export$b26126c87aa5db8f = (state, issueId, transactionId)=>state.ui.cards.transactions[String(issueId)] === transactionId;
const $9c373a482d4254d7$export$a67ae423fb9ea0f9 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385
], (cardSelection)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>cardSelection.includes(issueId)));
const $9c373a482d4254d7$export$525d749d966b122a = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$4083f6bcc362a6f5
], (focusedCardId)=>(issueId)=>focusedCardId === issueId);
const $9c373a482d4254d7$export$d955f9a510c083e3 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$4083f6bcc362a6f5,
    (0, $vAfHD.boardIssuesSelector)
], (focusedCardId, issues)=>issues[String(focusedCardId)]);
const $9c373a482d4254d7$export$cbe9d09100880591 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$var$getCardDragShowRipple
], (rippleIdsToShow)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>rippleIdsToShow.includes(issueId)));
const $9c373a482d4254d7$export$87ae9db9bc3086e9 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385
], (cardSelection)=>cardSelection.length);
const $9c373a482d4254d7$export$66743788dd4e9bd8 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385
], (cardSelection)=>cardSelection.length > 0 ? cardSelection[cardSelection.length - 1] : null);
const $9c373a482d4254d7$export$738ad8fdfc61d783 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385,
    (0, $vAfHD.isBoardIssueAChild)
], (cardSelection, isBoardIssueAChild)=>cardSelection.some((cardId)=>isBoardIssueAChild(cardId)));
const $9c373a482d4254d7$export$547687b52becf582 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$d5f32efe7e74f270,
    (0, $vAfHD.boardIssuesSelector)
], (cardDrag, issues)=>issues[String(cardDrag.cardId)] && issues[String(cardDrag.cardId)].columnId);
const $9c373a482d4254d7$export$a20afd2c88b78002 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$d5f32efe7e74f270,
    (0, $vAfHD.boardIssuesSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getIsCMPBoard)
], (cardDrag, issues, swimlaneMode, availableSwimlanes, isCMPBoard)=>{
    const issue = issues[String(cardDrag.cardId)];
    if (!issue) return null;
    return (0, $bwTbl.getSwimlaneId)(swimlaneMode, availableSwimlanes, issue, isCMPBoard, (issueId)=>issues[issueId]);
});
const $9c373a482d4254d7$export$9af5355c0a2b8eaf = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$1320f484db5f7bb0,
    (0, $vAfHD.boardIssuesSelector)
], (issueId, boardIssues)=>issueId != null && boardIssues[String(issueId)] != null ? boardIssues[String(issueId)].typeId : undefined);
const $9c373a482d4254d7$export$bd2e9e5f3d9710b6 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$1320f484db5f7bb0,
    (0, $vAfHD.boardIssuesSelector)
], (issueId, boardIssues)=>issueId != null && boardIssues[String(issueId)] ? boardIssues[String(issueId)].statusId : undefined);
const $9c373a482d4254d7$export$4f6134c81576f6c8 = (state)=>state.ui.cards.cardWithIcc.cardIdWithAboveIccOpen ?? null;
const $9c373a482d4254d7$export$8f8d79952e8c1b8f = (state, cardId)=>cardId === $9c373a482d4254d7$export$4f6134c81576f6c8(state);
const $9c373a482d4254d7$export$57e6136c07401474 = (state)=>state.ui.cards.cardWithIcc.columnIdToKeepIccOpen ?? null;
const $9c373a482d4254d7$export$9f41588a1efd6d68 = (state)=>state.ui.cards.cardWithIcc.lastColumnIdOpen ?? null;
const $9c373a482d4254d7$export$5c497d1106b09e75 = (state, columnId)=>$9c373a482d4254d7$export$4f6134c81576f6c8(state) === null && !(0, $45cXl.hasSwimlanes)(state) && $9c373a482d4254d7$export$57e6136c07401474(state) === columnId;
const $9c373a482d4254d7$export$9c5f5305c3f51a9e = (state)=>state.ui.cards.cardWithIcc.swimlaneIdToKeepIccOpen ?? null;
const $9c373a482d4254d7$export$3baa40ff5c726e5e = (state, swimlaneId, columnId)=>columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID) && !!swimlaneId && $9c373a482d4254d7$export$9c5f5305c3f51a9e(state) === swimlaneId;
const $9c373a482d4254d7$export$2cad9a22cc3d4e69 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    $9c373a482d4254d7$export$bd2e9e5f3d9710b6,
    $9c373a482d4254d7$export$9af5355c0a2b8eaf
], (cardTransitions, statusId, issueTypeId)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statusId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueTypeId)) return undefined;
    const statusesForIssueType = cardTransitions.issueTypeStatus[issueTypeId];
    return statusesForIssueType && statusesForIssueType[statusId];
});
const $9c373a482d4254d7$export$ae21bfdcca8ab956 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$d5f32efe7e74f270
], (cardDrag)=>cardDrag.overTransition && cardDrag.overTransition.toColumnId);
const $9c373a482d4254d7$export$c89387469f496cfe = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$d5f32efe7e74f270
], (cardDrag)=>!!(cardDrag.overTransition && cardDrag.overTransition.hoverIntent));
const $9c373a482d4254d7$export$3084e509c1c105f7 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385,
    (0, $vAfHD.boardIssuesSelector)
], (selectedIssueIds, issuesById)=>selectedIssueIds.map((issueId)=>issuesById[String(issueId)]).filter((issue)=>!!issue).map((issue)=>issue.key));
const $9c373a482d4254d7$export$96bec1932f9604ac = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385
], (selectedIssueIds)=>selectedIssueIds);
const $9c373a482d4254d7$export$73106b7a505f2e87 = (0, $dGvGJ.createSelector)([
    $9c373a482d4254d7$export$7710a9df00706385,
    (0, $vAfHD.boardIssuesSelector)
], (selectedIssueIds, issuesById)=>selectedIssueIds.filter((issueId)=>!!issuesById[String(issueId)]));
const $9c373a482d4254d7$export$bf98019ef3e35fb4 = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIsCMPBoard)
], (swimlaneMode, isCMPBoard)=>isCMPBoard || swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id);
const $9c373a482d4254d7$export$a4a515b62d43884e = (state)=>(cardId)=>state.ui.cards.inlineEditing[cardId]?.summary;
const $9c373a482d4254d7$export$7666a8f0609019d3 = (state)=>Object.values(state.ui.cards.inlineEditing).some((editing)=>editing.summary);
const $9c373a482d4254d7$export$65b4fa1de1c6580a = (state)=>(cardId)=>state.ui.cards.inlineEditing[cardId]?.assignee;
const $9c373a482d4254d7$export$67a508d1fc8a9a23 = (state)=>{
    const cardIds = [];
    for (const [cardId, entries] of Object.entries(state.ui.cards.inlineEditing))if (Object.values(entries).includes(true)) cardIds.push(cardId);
    return cardIds;
};

});
parcelRegister("chc6P", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $80afZ = parcelRequire("80afZ");
/**
 * Creates a flattened array of values by running each element in `collection`
 * thru `iteratee` and flattening the mapped results. The iteratee is invoked
 * with three arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * function duplicate(n) {
 *   return [n, n];
 * }
 *
 * _.flatMap([1, 2], duplicate);
 * // => [1, 1, 2, 2]
 */ function $8f007734a6a4d9ac$var$flatMap(collection, iteratee) {
    return $ekcP3($80afZ(collection, iteratee), 1);
}
module.exports = $8f007734a6a4d9ac$var$flatMap;

});
parcelRegister("80afZ", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $bxDef = parcelRequire("bxDef");

var $jXnVG = parcelRequire("jXnVG");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */ function $5d3647a04b83e8d6$var$map(collection, iteratee) {
    var func = $8LQ84(collection) ? $1nIHN : $jXnVG;
    return func(collection, $bxDef(iteratee, 3));
}
module.exports = $5d3647a04b83e8d6$var$map;

});


parcelRegister("5rFbt", function(module, exports) {

$parcel$export(module.exports, "ColumnType", () => $2fcdffd3f24185e5$export$7ce43d0a8f00d826);
$parcel$export(module.exports, "UNSCHEDULED_COLUMN_ID", () => $2fcdffd3f24185e5$export$643b1cad600bd98c);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $2fcdffd3f24185e5$export$7ce43d0a8f00d826 = /*#__PURE__*/ function(ColumnType) {
    ColumnType["STATUS"] = "status";
    ColumnType["DATE_RANGE"] = "date-range";
    return ColumnType;
}({});
const $2fcdffd3f24185e5$export$643b1cad600bd98c = 0;

});

parcelRegister("bwTbl", function(module, exports) {

$parcel$export(module.exports, "getSwimlaneId", () => $44e0b000221912e7$export$3f1eedfdbe634808);
$parcel$export(module.exports, "transformSoftwareToPlatformIssue", () => $44e0b000221912e7$export$517177e029f89d28);
$parcel$export(module.exports, "getIssueCreateOrUpdateFields", () => $44e0b000221912e7$export$2e4d5b7d0f7ca2fb);
$parcel$export(module.exports, "getIssueAssignee", () => $44e0b000221912e7$export$f336191813f4b9e2);

var $7uUwQ = parcelRequire("7uUwQ");

var $6Csk1 = parcelRequire("6Csk1");

var $hGgHi = parcelRequire("hGgHi");


var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");
const $44e0b000221912e7$export$6383ec137697c73b = (latestDevActivity)=>{
    const { activity: activity } = latestDevActivity;
    const devStatusMap = {};
    Object.keys(activity).forEach((issueIdString)=>{
        const { dataType: dataType, count: count, stateCount: stateCount, state: prState, open: open } = activity[issueIdString];
        if (stateCount && stateCount > 0) {
            if (open || prState === 'OPEN') devStatusMap[issueIdString] = {
                activity: 'pullrequest',
                count: stateCount
            };
            else if (prState === 'MERGED') devStatusMap[issueIdString] = {
                activity: 'merged',
                count: stateCount
            };
            else if (prState === 'DECLINED') devStatusMap[issueIdString] = {
                activity: 'declined',
                count: stateCount
            };
        } else if (count > 0) {
            if (dataType === 'branch') devStatusMap[issueIdString] = {
                activity: 'branch',
                count: count
            };
            else if (dataType === 'repository') devStatusMap[issueIdString] = {
                activity: 'commit',
                count: count
            };
            else if (dataType === 'deployment') devStatusMap[issueIdString] = {
                activity: 'deployment',
                count: count
            };
            else if (dataType === 'design') devStatusMap[issueIdString] = {
                activity: 'design',
                count: count
            };
        }
    });
    return devStatusMap;
};
const $44e0b000221912e7$export$3f1eedfdbe634808 = (swimlaneMode, availableSwimlanes, issue, isCMPBoard, getIssueById)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) return issue.assigneeAccountId || (0, $c79wa.UnassignedSwimlane).id;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) {
        // Try getting the epic from a subtask
        if (isCMPBoard && getIssueById && issue.parentId) {
            const issueParentIds = availableSwimlanes.map(({ id: id })=>id);
            const isChildOfIssueParent = issueParentIds.indexOf(String(issue.parentId)) > -1;
            if (!isChildOfIssueParent) return String(getIssueById(String(issue.parentId))?.parentId || (0, $c79wa.ParentlessSwimlane).id);
        }
        return issue.parentId ? String(issue.parentId) : (0, $c79wa.ParentlessSwimlane).id;
    }
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        // in the case the a story issue has been rendered as swimlane header,
        // we should not assign it to a swimlane
        if (isCMPBoard && availableSwimlanes.map(({ id: id })=>id).includes(String(issue.id))) return null;
        return issue.parentId && availableSwimlanes.find((swimlane)=>swimlane.id === String(issue.parentId)) ? String(issue.parentId) : (0, $c79wa.ChildlessSwimlane).id;
    }
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) return availableSwimlanes.find((swimlane)=>swimlane.values?.type === 'JQL' && swimlane.values?.issueIds.includes(issue.id))?.id ?? null;
    if (isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id) return String(issue.projectId);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_TEAM).id) return issue.teamId || (0, $c79wa.TeamlessSwimlane).id;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id) return issue.requestTypeId ?? (0, $c79wa.UnassignedRequestTypeSwimlane).id;
    return null;
};
function $44e0b000221912e7$export$e8526dd1ace08941(field) {
    if (field.renderer === 'text' || field.renderer === 'epiclink' || field.renderer === 'status' || field.renderer === 'url') return !field.text || !field.text.trim();
    if (field.renderer === 'html' || field.renderer === 'date' || field.renderer === 'duration') return !field.html || field.html?.trim() === '&nbsp;';
    if (field.renderer === 'number') return field.value == null;
    if (field.renderer === 'sla') return field.value === undefined;
    // This is a type-assertion so all CustomField types are handled above
    const _invalid = field;
    // If we have an unknown custom field type assume it's non-empty
    return false;
}
const $44e0b000221912e7$export$517177e029f89d28 = (issue, swimlaneMode, availableSwimlanes, isCMPBoard, getIssueById)=>{
    const labels = {
        labels: Array.isArray(issue.labels) ? [
            ...issue.labels
        ] : []
    };
    const card = {
        id: issue.id,
        url: '',
        key: issue.key,
        summary: issue.summary,
        assigneeAccountId: issue.assigneeAccountId || null,
        typeId: String(issue.typeId),
        typeName: issue.typeName,
        typeUrl: issue.typeUrl,
        statusId: issue.statusId,
        columnId: issue.columnId,
        projectId: issue.projectId,
        swimlaneId: $44e0b000221912e7$export$3f1eedfdbe634808(swimlaneMode, availableSwimlanes, issue, isCMPBoard, getIssueById),
        isFlagged: issue.isFlagged,
        // @ts-expect-error isDone is not a part of PlatformCard
        isDone: issue.isDone,
        parentId: issue.parentId,
        estimateFieldId: issue.estimate?.fieldId,
        estimate: issue.estimate?.type === (0, $b383ed62f6689e0b$export$73bc902d1e240cad) ? issue.estimate?.valueAsText : issue.estimate?.value,
        estimateUnit: issue.estimate?.displayName,
        dueDate: issue.dueDate,
        priority: issue.priority ? {
            ...issue.priority
        } : null,
        numCompleteChildren: issue.numCompleteChildren,
        numTotalChildren: issue.numTotalChildren,
        daysInColumn: issue.daysInColumn ?? undefined,
        cardColor: issue.cardColor,
        customFields: issue.extraFields?.filter((field)=>!$44e0b000221912e7$export$e8526dd1ace08941(field)),
        issueLinks: issue.issueLinks,
        hasScenarioChanges: issue.hasScenarioChanges,
        fixVersions: issue.fixVersions,
        originals: issue.originals,
        ...labels
    };
    const { devStatus: devStatus } = issue;
    if (devStatus) {
        const deploymentDetails = devStatus.deploymentDetails ? {
            deploymentDetails: devStatus.deploymentDetails
        } : {};
        card.devStatusField = {
            activity: devStatus.activity,
            count: devStatus.count,
            ...deploymentDetails
        };
    }
    return card;
};
const $44e0b000221912e7$export$4375d65c4249ba96 = (issue, response)=>{
    if (!response) return issue;
    const { id: id, key: key, fields: { summary: summary, status: status, project: project, assignee: assignee, issuetype: issuetype, labels: labels, resolutiondate: resolutiondate, priority: priority, duedate: duedate } } = response;
    const newIssue = {
        ...issue,
        id: Number(id),
        key: key,
        summary: summary,
        statusId: Number(status.id),
        projectId: Number(project.id),
        isDone: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(resolutiondate),
        priority: priority || null,
        dueDate: duedate || null
    };
    if (assignee) (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))(newIssue, {
        assigneeAccountId: assignee.accountId,
        assigneeName: assignee.name
    });
    if (issuetype) (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))(newIssue, {
        typeId: issuetype.id,
        typeName: issuetype.name,
        typeUrl: issuetype.iconUrl
    });
    if (labels) (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))(newIssue, {
        labels: labels
    });
    return newIssue;
};
const $44e0b000221912e7$var$emptyObj = (0, $7uUwQ.freeze)({});
const $44e0b000221912e7$export$2e4d5b7d0f7ca2fb = (values)=>{
    if (values.type === (0, $c79wa.ASSIGNEE)) return {
        assignee: {
            id: values.assigneeAccountId
        }
    };
    return $44e0b000221912e7$var$emptyObj;
};
const $44e0b000221912e7$export$f336191813f4b9e2 = (swimlaneValues)=>swimlaneValues.type === (0, $c79wa.ASSIGNEE) ? {
        assigneeAccountId: swimlaneValues.assigneeAccountId
    } : $44e0b000221912e7$var$emptyObj;

});
const $b383ed62f6689e0b$export$a092d6877c35430e = 'TMP_STORY_POINTS';
const $b383ed62f6689e0b$export$73bc902d1e240cad = 'TMP_ORIGINAL_TIME_ESTIMATE';
const $b383ed62f6689e0b$export$feb32b877d96492 = 'CUSTOM_ESTIMATE_FIELD';
const $b383ed62f6689e0b$export$24c68738fb7a96c7 = 'INCREMENT_PLANNING_ESTIMATE_FIELD';


parcelRegister("vAfHD", function(module, exports) {

$parcel$export(module.exports, "issueIdsWithSubtasksSelector", () => $127094222b407ab0$export$6a593bab20bef101);
$parcel$export(module.exports, "orderedIssuesWithSubtasksSelector", () => $127094222b407ab0$export$76220d546b87854e);
$parcel$export(module.exports, "boardIssuesSelector", () => $127094222b407ab0$export$d28e3ad6b62447a8);
$parcel$export(module.exports, "boardIssuesAndChildrenSelector", () => $127094222b407ab0$export$17d58dbbb9df5b49);
$parcel$export(module.exports, "boardOrderedIssueIdsSelector", () => $127094222b407ab0$export$fbf9bc381f8dfefe);
$parcel$export(module.exports, "isBoardIssueAChild", () => $127094222b407ab0$export$25181966ab630bdc);
$parcel$export(module.exports, "makeGetIssueKeyFromIssueId", () => $127094222b407ab0$export$960526337bf0f2d9);

var $dGvGJ = parcelRequire("dGvGJ");

var $fn8B5 = parcelRequire("fn8B5");

var $4wVpT = parcelRequire("4wVpT");

var $gJBT6 = parcelRequire("gJBT6");

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");

var $iuuJH = parcelRequire("iuuJH");

var $3UY9S = parcelRequire("3UY9S");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");
const $127094222b407ab0$export$6a593bab20bef101 = (0, $dGvGJ.createSelector)([
    (0, $3UY9S.issueChildrenSelector)
], (issueChildren)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(issueChildren.map((issueChild)=>issueChild.parentId || 0).filter((parentId)=>parentId !== 0)));
const $127094222b407ab0$export$54c1dc9ca3ac499b = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues),
    $127094222b407ab0$export$6a593bab20bef101
], (issues, issueIdsWithSubtasks)=>(0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(issues, issueIdsWithSubtasks.map((issueId)=>String(issueId))));
const $127094222b407ab0$export$76220d546b87854e = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedIssueIds),
    (0, $67Z81.getIssues),
    $127094222b407ab0$export$6a593bab20bef101,
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getMissingParents)
], (orderedIssueIds, issues, issueIdsWithSubtasks, isCMPBoard, missingParents)=>{
    const allIssueIds = isCMPBoard ? [
        ...orderedIssueIds,
        ...Object.keys(missingParents).map((missingParentId)=>Number(missingParentId))
    ] : orderedIssueIds;
    const allIssues = (()=>{
        if (!isCMPBoard) return {
            ...issues
        };
        return {
            ...missingParents,
            ...issues
        };
    })();
    return (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(allIssueIds, issueIdsWithSubtasks).map((issueId)=>allIssues[String(issueId)]).filter((issue)=>issue);
});
const $127094222b407ab0$export$d28e3ad6b62447a8 = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIssues),
    $127094222b407ab0$export$54c1dc9ca3ac499b,
    (0, $3UY9S.getIssueChildren),
    (0, $67Z81.getIsCMPBoard)
], (swimlaneMode, allIssues, issuesWithoutSubtasks, children, isCMPBoard)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return isCMPBoard ? {
        ...allIssues,
        ...children
    } : {
        ...issuesWithoutSubtasks,
        ...children
    };
    if (isCMPBoard) return {
        ...allIssues,
        ...children
    };
    return allIssues;
});
const $127094222b407ab0$export$17d58dbbb9df5b49 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues),
    (0, $3UY9S.getIssueChildren)
], (allIssues, children)=>({
        ...allIssues,
        ...children
    }));
const $127094222b407ab0$export$fbf9bc381f8dfefe = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIssues),
    $127094222b407ab0$export$54c1dc9ca3ac499b,
    (0, $67Z81.getOrderedIssueIds),
    (0, $67Z81.getOrderedIssueChildrenIds),
    (0, $67Z81.getIsCMPBoard),
    (0, $3UY9S.getIssueChildren),
    (0, $67Z81.isBoardRankable)
], (swimlaneMode, allIssues, issuesWithoutSubtasks, orderedIssueIds, orderedChildrenIds, isCMPBoard, children, isRankable)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        if (isCMPBoard) {
            // ordered swimlane header issue ids. It does not include children issue id.
            const orderedSwimlaneHeaderIssueIds = orderedIssueIds.filter((id)=>id in allIssues);
            return [
                ...orderedSwimlaneHeaderIssueIds,
                ...orderedChildrenIds
            ];
        }
        const issueIdsWithoutSubtasks = Object.keys(issuesWithoutSubtasks);
        const orderedIssueWithoutSubtasksIds = orderedIssueIds.filter((id)=>issueIdsWithoutSubtasks.includes(String(id)));
        return [
            ...orderedIssueWithoutSubtasksIds,
            ...orderedChildrenIds
        ];
    }
    if (isCMPBoard && isRankable) {
        const childrenIdsByParentId = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(orderedChildrenIds, (childId)=>children[childId].parentId);
        return orderedIssueIds.flatMap((issueId)=>[
                issueId,
                ...childrenIdsByParentId[issueId] ?? []
            ]);
    }
    return orderedIssueIds;
});
const $127094222b407ab0$export$25181966ab630bdc = (0, $dGvGJ.createSelector)([
    (0, $4gt6L.issueChildrenTypeIdsSelector),
    $127094222b407ab0$export$d28e3ad6b62447a8
], (issueChildrenTypeIds, boardIssues)=>{
    const isBoardIssueAChildCheck = (issueId)=>{
        const issue = boardIssues[String(issueId)];
        if (!issue) return false;
        return issueChildrenTypeIds.includes(String(issue.typeId));
    };
    return isBoardIssueAChildCheck;
});
const $127094222b407ab0$export$960526337bf0f2d9 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>issues[issueId]?.key ?? undefined));

});
parcelRegister("fn8B5", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $b30fac385487af61$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $b30fac385487af61$var$hasOwnProperty = $b30fac385487af61$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The order of grouped values
 * is determined by the order they occur in `collection`. The corresponding
 * value of each key is an array of elements responsible for generating the
 * key. The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.groupBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': [4.2], '6': [6.1, 6.3] }
 *
 * // The `_.property` iteratee shorthand.
 * _.groupBy(['one', 'two', 'three'], 'length');
 * // => { '3': ['one', 'two'], '5': ['three'] }
 */ var $b30fac385487af61$var$groupBy = $4CZTG(function(result, value, key) {
    if ($b30fac385487af61$var$hasOwnProperty.call(result, key)) result[key].push(value);
    else $1m3dq(result, key, [
        value
    ]);
});
module.exports = $b30fac385487af61$var$groupBy;

});

parcelRegister("4wVpT", function(module, exports) {

var $1nIHN = parcelRequire("1nIHN");

var $9dThv = parcelRequire("9dThv");

var $g7i7g = parcelRequire("g7i7g");

var $d9Hx6 = parcelRequire("d9Hx6");
/**
 * Creates an array of unique values that are included in all given arrays
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons. The order and references of result values are
 * determined by the first array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of intersecting values.
 * @example
 *
 * _.intersection([2, 1], [2, 3]);
 * // => [2]
 */ var $34c6b050456654f8$var$intersection = $g7i7g(function(arrays) {
    var mapped = $1nIHN(arrays, $d9Hx6);
    return mapped.length && mapped[0] === arrays[0] ? $9dThv(mapped) : [];
});
module.exports = $34c6b050456654f8$var$intersection;

});
parcelRegister("9dThv", function(module, exports) {

var $ijRUK = parcelRequire("ijRUK");

var $fUP98 = parcelRequire("fUP98");

var $dA3tP = parcelRequire("dA3tP");

var $1nIHN = parcelRequire("1nIHN");

var $cW28x = parcelRequire("cW28x");

var $40I25 = parcelRequire("40I25");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6b7035a795ecd274$var$nativeMin = Math.min;
/**
 * The base implementation of methods like `_.intersection`, without support
 * for iteratee shorthands, that accepts an array of arrays to inspect.
 *
 * @private
 * @param {Array} arrays The arrays to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new array of shared values.
 */ function $6b7035a795ecd274$var$baseIntersection(arrays, iteratee, comparator) {
    var includes = comparator ? $dA3tP : $fUP98, length = arrays[0].length, othLength = arrays.length, othIndex = othLength, caches = Array(othLength), maxLength = Infinity, result = [];
    while(othIndex--){
        var array = arrays[othIndex];
        if (othIndex && iteratee) array = $1nIHN(array, $cW28x(iteratee));
        maxLength = $6b7035a795ecd274$var$nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new $ijRUK(othIndex && array) : undefined;
    }
    array = arrays[0];
    var index = -1, seen = caches[0];
    outer: while(++index < length && result.length < maxLength){
        var value = array[index], computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? $40I25(seen, computed) : includes(result, computed, comparator))) {
            othIndex = othLength;
            while(--othIndex){
                var cache = caches[othIndex];
                if (!(cache ? $40I25(cache, computed) : includes(arrays[othIndex], computed, comparator))) continue outer;
            }
            if (seen) seen.push(computed);
            result.push(value);
        }
    }
    return result;
}
module.exports = $6b7035a795ecd274$var$baseIntersection;

});

parcelRegister("d9Hx6", function(module, exports) {

var $f3SOL = parcelRequire("f3SOL");
/**
 * Casts `value` to an empty array if it's not an array like object.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Array|Object} Returns the cast array-like object.
 */ function $993de25d5a02863a$var$castArrayLikeObject(value) {
    return $f3SOL(value) ? value : [];
}
module.exports = $993de25d5a02863a$var$castArrayLikeObject;

});


parcelRegister("3UY9S", function(module, exports) {

$parcel$export(module.exports, "getIssueChildren", () => $cd00b884759d904f$export$9ed60bbe06bbd06b);
$parcel$export(module.exports, "issueChildrenSelector", () => $cd00b884759d904f$export$e4d41a6d0bc11e95);
$parcel$export(module.exports, "numTotalIssueChildren", () => $cd00b884759d904f$export$1b6edd941a4eaddd);
$parcel$export(module.exports, "numCompleteIssueChildren", () => $cd00b884759d904f$export$18ec94fe8e415ca5);
$parcel$export(module.exports, "getChildrenOfParent", () => $cd00b884759d904f$export$e35229fc554ba8ff);
$parcel$export(module.exports, "getParentIdByIssueChildSelector", () => $cd00b884759d904f$export$b971fb01711c101b);

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $27NS3 = parcelRequire("27NS3");

var $67Z81 = parcelRequire("67Z81");
const $cd00b884759d904f$export$9ed60bbe06bbd06b = (state)=>(0, $67Z81.getEntities)(state).issueChildren;
const $cd00b884759d904f$export$e4d41a6d0bc11e95 = (0, $dGvGJ.createSelector)($cd00b884759d904f$export$9ed60bbe06bbd06b, (issueChildren)=>Object.keys(issueChildren).map((issueId)=>({
            ...issueChildren[issueId]
        })));
const $cd00b884759d904f$export$1b6edd941a4eaddd = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(Object.keys(issues).map((key)=>issues[key]), (num, issue)=>num + issue.numTotalChildren, 0));
const $cd00b884759d904f$export$18ec94fe8e415ca5 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($27NS3)))(Object.keys(issues).map((key)=>issues[key]), (num, issue)=>num + issue.numCompleteChildren, 0));
const $cd00b884759d904f$export$e35229fc554ba8ff = (0, $dGvGJ.createSelector)([
    $cd00b884759d904f$export$e4d41a6d0bc11e95
], (issueChildren)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((parentIssueId)=>issueChildren.filter((issue)=>issue.parentId === parentIssueId).map((issue)=>issue.id)));
const $cd00b884759d904f$export$b971fb01711c101b = (0, $dGvGJ.createSelector)([
    $cd00b884759d904f$export$9ed60bbe06bbd06b,
    (0, $67Z81.getIssues),
    (0, $67Z81.getMissingParents)
], (issueChildren, issues, missingParents)=>(issueChildId)=>{
        const parentId = issueChildren[issueChildId]?.parentId;
        // make sure the parent of the child issue is available in redux context (issues or missing parents)
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[parentId] ?? missingParents[parentId])) return null;
        return parentId;
    });

});
parcelRegister("27NS3", function(module, exports) {

var $2YkAc = parcelRequire("2YkAc");

var $e7pfQ = parcelRequire("e7pfQ");

var $bxDef = parcelRequire("bxDef");

var $87mh8 = parcelRequire("87mh8");

var $8LQ84 = parcelRequire("8LQ84");
/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */ function $18c2eb891b6f17d9$var$reduce(collection, iteratee, accumulator) {
    var func = $8LQ84(collection) ? $2YkAc : $87mh8, initAccum = arguments.length < 3;
    return func(collection, $bxDef(iteratee, 4), accumulator, initAccum, $e7pfQ);
}
module.exports = $18c2eb891b6f17d9$var$reduce;

});
parcelRegister("87mh8", function(module, exports) {
/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */ function $5e90419f1ca7764f$var$baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function(value, index, collection) {
        accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
}
module.exports = $5e90419f1ca7764f$var$baseReduce;

});



parcelRegister("4gt6L", function(module, exports) {

$parcel$export(module.exports, "issueTypeIdsSelector", () => $fc9184903598526c$export$47eaf9be2ebcbbc9);
$parcel$export(module.exports, "issueBaseTypesSelector", () => $fc9184903598526c$export$3a71d66f3073758e);
$parcel$export(module.exports, "firstIssueTypeIdSelector", () => $fc9184903598526c$export$14696f459f535378);
$parcel$export(module.exports, "issueChildrenTypesSelector", () => $fc9184903598526c$export$9d03bda0ec379196);
$parcel$export(module.exports, "issueChildrenTypeIdsSelector", () => $fc9184903598526c$export$d0ca2ed0336e2f78);
$parcel$export(module.exports, "defaultIssueTypeIdSelector", () => $fc9184903598526c$export$bc7d33c61daa84f5);
$parcel$export(module.exports, "getIssueTypesGroupedByNameLevel", () => $fc9184903598526c$export$fd9bedde62940919);

var $dGvGJ = parcelRequire("dGvGJ");

var $183uB = parcelRequire("183uB");

var $fn8B5 = parcelRequire("fn8B5");

var $bH3EF = parcelRequire("bH3EF");

var $3JOCw = parcelRequire("3JOCw");

var $g4tDr = parcelRequire("g4tDr");

var $67Z81 = parcelRequire("67Z81");
const $fc9184903598526c$export$47eaf9be2ebcbbc9 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssueTypes), (issueTypes)=>Object.keys(issueTypes));
const $fc9184903598526c$export$3a71d66f3073758e = (0, $dGvGJ.createSelector)((0, $67Z81.getIssueTypes), (issueTypes)=>Object.keys(issueTypes).map((id)=>issueTypes[id]));
const $fc9184903598526c$export$14696f459f535378 = (0, $dGvGJ.createSelector)($fc9184903598526c$export$47eaf9be2ebcbbc9, (issueTypeIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($bH3EF)))(issueTypeIds));
const $fc9184903598526c$export$64a747bfcd854971 = (0, $dGvGJ.createSelector)((0, $67Z81.getProjectIssueTypes), (projectIssueTypes)=>Object.keys(projectIssueTypes).map((key)=>projectIssueTypes[key]).filter((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE)));
const $fc9184903598526c$export$9d03bda0ec379196 = (0, $dGvGJ.createSelector)((0, $67Z81.getProjectIssueTypes), (projectIssueTypes)=>Object.keys(projectIssueTypes).map((key)=>projectIssueTypes[key]).filter((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE)));
const $fc9184903598526c$export$d0ca2ed0336e2f78 = (0, $dGvGJ.createSelector)($fc9184903598526c$export$9d03bda0ec379196, (issueTypes)=>issueTypes.map((issueType)=>issueType.id));
const $fc9184903598526c$export$e8a77cfae7b2c053 = (0, $dGvGJ.createSelector)((0, $67Z81.getProjectIssueTypes), (projectIssueTypes)=>(issueTypeId)=>!!projectIssueTypes[issueTypeId]?.hasRequiredFields);
const $fc9184903598526c$var$getDefaultIssueTypeIdPure = (issueTypes)=>{
    const defaultIssueType = issueTypes.find((issueType)=>issueType.default);
    return defaultIssueType ? Number(defaultIssueType.id) : undefined;
};
const $fc9184903598526c$export$bc7d33c61daa84f5 = (0, $dGvGJ.createSelector)([
    $fc9184903598526c$export$3a71d66f3073758e
], (issueTypes)=>$fc9184903598526c$var$getDefaultIssueTypeIdPure(issueTypes));
const $fc9184903598526c$export$fd9bedde62940919 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueTypesByProject)
], (issueTypesByProject)=>{
    const allIssueTypes = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))((0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(Object.values(issueTypesByProject)), 'id').filter(Boolean);
    const grouped = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(allIssueTypes, ({ name: name, hierarchyLevelType: hierarchyLevelType })=>`${hierarchyLevelType}/${name}`);
    const issueTypeGroups = Object.entries(grouped).map(([key, issueTypes])=>({
            issueTypes: issueTypes.map(({ id: id })=>id),
            name: issueTypes[0].name,
            iconUrl: issueTypes[0].iconUrl,
            key: key
        }));
    return issueTypeGroups;
});

});
parcelRegister("bH3EF", function(module, exports) {
/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */ function $88368ba58341d518$var$head(array) {
    return array && array.length ? array[0] : undefined;
}
module.exports = $88368ba58341d518$var$head;

});


parcelRegister("45cXl", function(module, exports) {

$parcel$export(module.exports, "getSwimlaneMode", () => $6737c7e8fdf3dd27$export$3be4c2f22d918721);
$parcel$export(module.exports, "getAdminConfiguredSwimlaneMode", () => $6737c7e8fdf3dd27$export$4799e302f521d386);
$parcel$export(module.exports, "getJqlSwimlanesData", () => $6737c7e8fdf3dd27$export$5a8eaf3993ee8e01);
$parcel$export(module.exports, "getSwimlaneModes", () => $6737c7e8fdf3dd27$export$5cf50704ac4c4ed6);
$parcel$export(module.exports, "hasSwimlanes", () => $6737c7e8fdf3dd27$export$1cc4960b9362aa3);
$parcel$export(module.exports, "isSwimlanesByJqlAvailable", () => $6737c7e8fdf3dd27$export$8e8f69c56d25b276);

var $dGvGJ = parcelRequire("dGvGJ");

var $2xFXk = parcelRequire("2xFXk");

var $5VJuY = parcelRequire("5VJuY");

var $iuuJH = parcelRequire("iuuJH");

var $kc6Ry = parcelRequire("kc6Ry");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");
const $6737c7e8fdf3dd27$export$3be4c2f22d918721 = (state)=>state.ui.swimlane.mode;
const $6737c7e8fdf3dd27$export$4799e302f521d386 = (state)=>state.ui.swimlane.adminConfiguredMode;
const $6737c7e8fdf3dd27$export$5a8eaf3993ee8e01 = (state)=>(0, $67Z81.getEntities)(state).jqlSwimlanes?.swimlanes;
const $6737c7e8fdf3dd27$export$5cf50704ac4c4ed6 = (0, $dGvGJ.createSelector)((0, $bSSdD.hasIssueParentsSelector), (0, $bSSdD.firstParentIssueTypeNameSelector), (0, $4gt6L.issueChildrenTypesSelector), $6737c7e8fdf3dd27$export$5a8eaf3993ee8e01, (0, $67Z81.getIsCMPBoard), (0, $kc6Ry.getCapability), (0, $67Z81.getHierarchyNomenclature), (hasIssueParents, firstParentIssueTypeName, issueChildrenTypes, jqlSwimlanesData, isCMPBoard, hasCapability, hierarchyNomenclature)=>{
    const swimlaneModes = [
        ...(0, $iuuJH.defaultSwimlanes)
    ];
    if (hasIssueParents && hasCapability((0, $2xFXk.Capability).RENDER_EPIC_SWIMLANE_OPTION)) {
        const displayText = isCMPBoard && hierarchyNomenclature ? hierarchyNomenclature.firstLevelName : firstParentIssueTypeName;
        swimlaneModes.push({
            ...(0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE),
            values: {
                displayText: displayText
            }
        });
    }
    if (hasCapability((0, $2xFXk.Capability).RENDER_REQUEST_TYPE_SWIMLANE_OPTION)) swimlaneModes.push((0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE));
    const hasIssueChildrens = issueChildrenTypes && issueChildrenTypes.length > 0;
    if (hasIssueChildrens && isCMPBoard) {
        if (hasCapability((0, $2xFXk.Capability).RENDER_STORIES_SWIMLANE_OPTION)) swimlaneModes.push({
            ...(0, $iuuJH.SWIMLANE_BY_SUBTASK),
            message: (0, $5VJuY.default).stories
        });
    } else if (hasIssueChildrens) swimlaneModes.push({
        ...(0, $iuuJH.SWIMLANE_BY_SUBTASK),
        values: {
            displayText: issueChildrenTypes[0].name
        }
    });
    if (jqlSwimlanesData && jqlSwimlanesData.length > 0 && hasCapability((0, $2xFXk.Capability).RENDER_QUERIES_SWIMLANE_OPTION)) swimlaneModes.push((0, $iuuJH.SWIMLANE_BY_JQL));
    if (isCMPBoard && hasCapability((0, $2xFXk.Capability).RENDER_PROJECTS_SWIMLANE_OPTION)) swimlaneModes.push((0, $iuuJH.SWIMLANE_BY_PROJECT));
    return swimlaneModes;
});
const $6737c7e8fdf3dd27$export$1cc4960b9362aa3 = (state)=>$6737c7e8fdf3dd27$export$3be4c2f22d918721(state) !== (0, $iuuJH.NO_SWIMLANE).id;
const $6737c7e8fdf3dd27$export$8e8f69c56d25b276 = (0, $dGvGJ.createSelector)($6737c7e8fdf3dd27$export$5cf50704ac4c4ed6, (swimlaneModes)=>swimlaneModes.includes((0, $iuuJH.SWIMLANE_BY_JQL)));

});
parcelRegister("2xFXk", function(module, exports) {

$parcel$export(module.exports, "Capability", () => $dd24abdaf4d342ab$export$790a66df9dc00390);
$parcel$export(module.exports, "hasCapability", () => $dd24abdaf4d342ab$export$c76adb160242209c);

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
const $dd24abdaf4d342ab$export$790a66df9dc00390 = {
    /**
	 * Can be removed when the new navigation is enabled for all users
	 * and the old navigation is removed. And when jsm_views_of_work_phase_1
	 * is cleaned up.
	 */ IS_TAB_NAVIGATION: 'IS_TAB_NAVIGATION',
    RENDER_UIF_OPT_IN_FLAG: 'RENDER_UIF_OPT_IN_FLAG',
    REMOVE_FROM_SPRINT: 'REMOVE_FROM_SPRINT',
    // CMP header menu items
    RENDER_BOARD_MORE_MENU_ITEM: 'RENDER_BOARD_MORE_MENU_ITEM',
    RENDER_BOARD_SETTINGS_MENU_ITEM: 'RENDER_BOARD_SETTINGS_MENU_ITEM',
    RENDER_CREATE_BOARD_MENU_ITEM: 'RENDER_CREATE_BOARD_MENU_ITEM',
    /**
	 * When enabled, columns will expand to fit the display width. The board
	 * will be scrollable when columns are under a minimum width.
	 */ FLEXIBLE_BOARD_COLUMNS: 'FLEXIBLE_BOARD_COLUMNS',
    INLINE_COLUMN_EDIT: 'INLINE_COLUMN_EDIT',
    // TMP header menu items
    RENDER_EDIT_SPRINT_MENU_ITEM: 'RENDER_EDIT_SPRINT_MENU_ITEM',
    RENDER_MANAGE_WORKFLOW_MENU_ITEM: 'RENDER_MANAGE_WORKFLOW_MENU_ITEM',
    RENDER_MOVE_TO_BACKLOG_CONTEXT_MENU_ITEM: 'RENDER_MOVE_TO_BACKLOG_CONTEXT_MENU_ITEM',
    // header filters
    RENDER_STATUS_CATEGORIES_FILTER: 'RENDER_STATUS_CATEGORIES_FILTER',
    RENDER_VERSIONS_FILTER: 'RENDER_VERSIONS_FILTER',
    RENDER_ISSUE_PARENTS_FILTER: 'RENDER_ISSUE_PARENTS_FILTER',
    RENDER_LABELS_FILTER: 'RENDER_LABELS_FILTER',
    RENDER_ISSUE_PROJECTS_FILTER: 'RENDER_ISSUE_PROJECTS_FILTER',
    RENDER_ISSUE_TYPES_FILTER: 'RENDER_ISSUE_TYPES_FILTER',
    RENDER_COMPONENTS_FILTER: 'RENDER_COMPONENTS_FILTER',
    RENDER_SPRINTS_FILTER: 'RENDER_SPRINTS_FILTER',
    RENDER_REQUEST_TYPES_FILTER: 'RENDER_REQUEST_TYPES_FILTER',
    RENDER_STATUSES_FILTER: 'RENDER_STATUSES_FILTER',
    RENDER_DEPENDENCIES_FILTER: 'RENDER_DEPENDENCIES_FILTER',
    // Transition zone label
    HIDE_COLUMN_HEADER_OVERLAY: 'HIDE_COLUMN_HEADER_OVERLAY',
    DISABLE_TRANSITION_IN_SAME_COLUMN: 'DISABLE_TRANSITION_IN_SAME_COLUMN',
    // Card Menu Items
    RENDER_ADD_FLAG_CARD_MENU_ITEM: 'RENDER_ADD_FLAG_CARD_MENU_ITEM',
    RENDER_ADD_LABEL_CARD_MENU_ITEM: 'RENDER_ADD_LABEL_CARD_MENU_ITEM',
    RENDER_EDIT_COVER: 'RENDER_EDIT_COVER',
    RENDER_CLONE_ISSUE: 'RENDER_CLONE_ISSUE',
    // Request type icon position for service management cards.
    RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD: 'RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD',
    // Board Header Buttons
    RENDER_BOARD_AUTOMATION_HEADER_BUTTON: 'RENDER_BOARD_AUTOMATION_HEADER_BUTTON',
    RENDER_BOARD_FAVOURITE_HEADER_BUTTON: 'RENDER_BOARD_FAVOURITE_HEADER_BUTTON',
    RENDER_BOARD_RELEASE_MENU_BUTON: 'RENDER_BOARD_RELEASE_MENU_BUTON',
    RENDER_BOARD_INSIGHT_BUTTON: 'RENDER_BOARD_INSIGHT_BUTTON',
    RENDER_JSM_BOARD_INSIGHT_BUTTON: 'RENDER_JSM_BOARD_INSIGHT_BUTTON',
    RENDER_BOARD_FEEDBACK_COLLECTOR_BUTTON: 'RENDER_BOARD_FEEDBACK_COLLECTOR_BUTTON',
    RENDER_BOARD_FULLSCREEN_BUTTON: 'RENDER_BOARD_FULLSCREEN_BUTTON',
    RENDER_BOARD_FULLSCREEN_MENU_ITEM: 'RENDER_BOARD_FULLSCREEN_MENU_ITEM',
    // View Settings
    RENDER_VIEW_SETTINGS_CARD_DETAILS_OPTION: 'RENDER_VIEW_SETTINGS_CARD_DETAILS_OPTION',
    // Card devops status
    ENABLE_DEVOPS_ON_BOARD: 'ENABLE_DEVOPS_ON_BOARD',
    // Card multiselection
    MULTISELECT_CARD_ACROSS_SWIMLANES: 'MULTISELECT_CARD_ACROSS_SWIMLANES,',
    // Card context menu display
    RENDER_INCREMENT_PLANNING_CONTEXT_MENU: 'RENDER_INCREMENT_PLANNING_CONTEXT_MENU',
    RENDER_REQUEST_TYPE_SWIMLANE_OPTION: 'RENDER_REQUEST_TYPE_SWIMLANE_OPTION',
    RENDER_EPIC_SWIMLANE_OPTION: 'RENDER_EPIC_SWIMLANE_OPTION',
    RENDER_QUERIES_SWIMLANE_OPTION: 'RENDER_QUERIES_SWIMLANE_OPTION',
    RENDER_PROJECTS_SWIMLANE_OPTION: 'RENDER_PROJECTS_SWIMLANE_OPTTION',
    RENDER_STORIES_SWIMLANE_OPTION: 'RENDER_STORIES_SWIMLANE_OPTION',
    // Show flags for issue limits
    SHOW_ISSUE_LIMIT_FLAGS: 'SHOW_ISSUE_LIMIT_FLAGS',
    // Show public forms changeboarding modal
    SHOW_PUBLIC_FORMS_CHANGEBOARDING_MODAL: 'SHOW_PUBLIC_FORMS_CHANGEBOARDING_MODAL'
};
function $dd24abdaf4d342ab$export$c76adb160242209c(key, isCMPBoard, isIncrementPlanningBoard, allFeatures, projectType = (0, $2vSU6.SOFTWARE_PROJECT), isUserBoard = false) {
    const hasSprintFeatureEnabled = allFeatures?.some((feature)=>feature.key === 'SPRINTS' && feature.status === 'ENABLED') ?? false;
    switch(key){
        case $dd24abdaf4d342ab$export$790a66df9dc00390.IS_TAB_NAVIGATION:
            return (0, $3HwlS.getWillShowNav4)() && projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.REMOVE_FROM_SPRINT:
            return isCMPBoard && hasSprintFeatureEnabled;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_UIF_OPT_IN_FLAG:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_CREATE_BOARD_MENU_ITEM:
            if ((0, $3HwlS.getWillShowNav4)()) return isUserBoard;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) && isCMPBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_MORE_MENU_ITEM:
            // Increment planning/program board doesn't have more menu item
            if (isIncrementPlanningBoard && (0, $3HwlS.getWillShowNav4)()) return false;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_SETTINGS_MENU_ITEM:
            if ((0, $3HwlS.getWillShowNav4)()) return isUserBoard;
            return isCMPBoard && projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_FULLSCREEN_BUTTON:
            // Increment planning/program board have fullscreen button
            if (isIncrementPlanningBoard && (0, $3HwlS.getWillShowNav4)()) return true;
            if ((0, $3HwlS.getWillShowNav4)() && (0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
            if (!(0, $3HwlS.getWillShowNav4)() && projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) && (0, $4R6GH.fg)('jsm_nav3_full_screen_board_')) return true;
            return (0, $3HwlS.getWillShowNav4)() || projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_FULLSCREEN_MENU_ITEM:
            // Increment planning/program board doesn't have fullscreen menu item
            if (isIncrementPlanningBoard && (0, $3HwlS.getWillShowNav4)()) return false;
            return (0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header') && projectType === (0, $2vSU6.SOFTWARE_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.HIDE_COLUMN_HEADER_OVERLAY:
            return isCMPBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.FLEXIBLE_BOARD_COLUMNS:
            return isCMPBoard || isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.INLINE_COLUMN_EDIT:
            if (isIncrementPlanningBoard || projectType !== (0, $2vSU6.SOFTWARE_PROJECT)) return false;
            return true;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.DISABLE_TRANSITION_IN_SAME_COLUMN:
            // Only disable the transitions if the project is NOT service desk.
            // This should only ever be disabled for CMP software projects
            return isCMPBoard && projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.MULTISELECT_CARD_ACROSS_SWIMLANES:
            return !isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_INCREMENT_PLANNING_CONTEXT_MENU:
            return isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_EDIT_SPRINT_MENU_ITEM:
            if (isIncrementPlanningBoard) return false;
            return hasSprintFeatureEnabled;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_MANAGE_WORKFLOW_MENU_ITEM:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_MOVE_TO_BACKLOG_CONTEXT_MENU_ITEM:
            if (isIncrementPlanningBoard) return false;
            return !isCMPBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ISSUE_PROJECTS_FILTER:
            return isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_DEPENDENCIES_FILTER:
            return isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_LABELS_FILTER:
            if (isIncrementPlanningBoard) return false;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ISSUE_PARENTS_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ISSUE_TYPES_FILTER:
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT) || isIncrementPlanningBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_STATUS_CATEGORIES_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_SPRINTS_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_AUTOMATION_HEADER_BUTTON:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_FAVOURITE_HEADER_BUTTON:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_RELEASE_MENU_BUTON:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_BOARD_INSIGHT_BUTTON:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ADD_FLAG_CARD_MENU_ITEM:
            if (isIncrementPlanningBoard) return false;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_ADD_LABEL_CARD_MENU_ITEM:
            if (isIncrementPlanningBoard) return true;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_EDIT_COVER:
            return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && isCMPBoard;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_CLONE_ISSUE:
            return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && (0, $6s1PB.expVal)('cloning_tasks_entrypoints', 'isEnabled', false);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.ENABLE_DEVOPS_ON_BOARD:
            if (isIncrementPlanningBoard) return false;
            return projectType !== (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_JSM_BOARD_INSIGHT_BUTTON:
            if (isIncrementPlanningBoard) return false;
            return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD:
            return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_REQUEST_TYPES_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_STATUSES_FILTER:
            return projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_VIEW_SETTINGS_CARD_DETAILS_OPTION:
            if (isIncrementPlanningBoard) return false;
            return !(projectType === (0, $2vSU6.SERVICE_DESK_PROJECT));
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_PROJECTS_SWIMLANE_OPTION:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_STORIES_SWIMLANE_OPTION:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_EPIC_SWIMLANE_OPTION:
            if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return false;
            return true;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_QUERIES_SWIMLANE_OPTION:
            return true;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_REQUEST_TYPE_SWIMLANE_OPTION:
            if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) return true;
            return false;
        case $dd24abdaf4d342ab$export$790a66df9dc00390.SHOW_ISSUE_LIMIT_FLAGS:
            return projectType === (0, $2vSU6.SOFTWARE_PROJECT);
        case $dd24abdaf4d342ab$export$790a66df9dc00390.SHOW_PUBLIC_FORMS_CHANGEBOARDING_MODAL:
            return projectType === (0, $2vSU6.SOFTWARE_PROJECT) && (0, $4R6GH.fg)('jira_forms_public_access_changeboarding_gate');
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_VERSIONS_FILTER:
        case $dd24abdaf4d342ab$export$790a66df9dc00390.RENDER_COMPONENTS_FILTER:
        default:
            return false;
    }
}

});

parcelRegister("kc6Ry", function(module, exports) {

$parcel$export(module.exports, "getCapability", () => $383dbfdaea507d5b$export$38805c31c710553c);

var $2xFXk = parcelRequire("2xFXk");

var $67Z81 = parcelRequire("67Z81");
const $383dbfdaea507d5b$export$38805c31c710553c = (state)=>(key)=>(0, $2xFXk.hasCapability)(key, state.configuration.isCMPBoard, (0, $67Z81.getIsIncrementPlanningBoard)(state), (0, $67Z81.getEntities)(state).board.config.allFeatures, (0, $67Z81.projectTypeSelector)(state), state.configuration.isUserBoard);

});

parcelRegister("bSSdD", function(module, exports) {

$parcel$export(module.exports, "getIssueParents", () => $2eb3e41683b9322e$export$df9259146e40d32c);
$parcel$export(module.exports, "hasIssueParentsSelector", () => $2eb3e41683b9322e$export$6ee7fa79061874f6);
$parcel$export(module.exports, "issueParentTypeIdsSelector", () => $2eb3e41683b9322e$export$80f40427dc008040);
$parcel$export(module.exports, "issueParentsSelector", () => $2eb3e41683b9322e$export$27ed9219e3872aed);
$parcel$export(module.exports, "availableIssueParentsForIssueProjectSelector", () => $2eb3e41683b9322e$export$fcfc1acf491b9a49);
$parcel$export(module.exports, "filteredIssueParentsToListItemSelector", () => $2eb3e41683b9322e$export$82d321a1b1eb045c);
$parcel$export(module.exports, "issueParentIdsSelector", () => $2eb3e41683b9322e$export$e69b35537968b7e1);
$parcel$export(module.exports, "firstParentIssueTypeNameSelector", () => $2eb3e41683b9322e$export$461364b3b51e10c1);
$parcel$export(module.exports, "makeIssueParentByIdSelector", () => $2eb3e41683b9322e$export$dbff01ed0e86fffd);

var $dGvGJ = parcelRequire("dGvGJ");

var $2HfxU = parcelRequire("2HfxU");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $gJBT6 = parcelRequire("gJBT6");

var $kGsr8 = parcelRequire("kGsr8");

var $g4tDr = parcelRequire("g4tDr");


var $3UY9S = parcelRequire("3UY9S");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");
const $2eb3e41683b9322e$export$df9259146e40d32c = (state)=>(0, $67Z81.getEntities)(state).issueParents;
const $2eb3e41683b9322e$export$6ee7fa79061874f6 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$df9259146e40d32c, (issueParents)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueParents));
const $2eb3e41683b9322e$export$80f40427dc008040 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$df9259146e40d32c, (issueParents)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.values(issueParents).map((issueParent)=>Number(issueParent.issueType.id))));
const $2eb3e41683b9322e$export$27ed9219e3872aed = (0, $dGvGJ.createSelector)([
    $2eb3e41683b9322e$export$df9259146e40d32c,
    (0, $67Z81.getIssueParentOrderIds)
], (issueParents, orderedIssueParentsIds)=>orderedIssueParentsIds.reduce((issueParentIds, issueParentId)=>{
        const issueParent = issueParents[String(issueParentId)];
        issueParent && issueParentIds.push(issueParent);
        return issueParentIds;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, []));
const $2eb3e41683b9322e$export$fcfc1acf491b9a49 = (0, $dGvGJ.createSelector)([
    $2eb3e41683b9322e$export$27ed9219e3872aed,
    (0, $67Z81.getIssueProjects),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (issueParents, projects, isIncrementPlanningBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueProjectId)=>{
        if (!isIncrementPlanningBoard) return issueParents;
        if (!issueProjectId) return [];
        const issueProject = projects[issueProjectId];
        if (!issueProject.isCMP) // for TMP issues, filter the issue parents to be in the same project
        return issueParents.filter((parent)=>parent.projectId === issueProject.id);
        // for CMP issues, filter issue parents to be in any CMP project
        return issueParents.filter((parent)=>{
            const parentProject = parent.projectId ? projects[parent.projectId] : null;
            return parentProject && parentProject.isCMP;
        });
    }));
const $2eb3e41683b9322e$export$ed2bad70f85ffb04 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$27ed9219e3872aed, (issueParents)=>issueParents.map(({ id: id, summary: summary })=>({
            id: String(id),
            name: summary
        })));
const $2eb3e41683b9322e$export$82d321a1b1eb045c = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$27ed9219e3872aed, (0, $67Z81.getIssues), (0, $3UY9S.getIssueChildren), (0, $ebHh7.hasNoActiveSprintStateSelector), (0, $67Z81.getIsIncrementPlanningBoard), (0, $67Z81.getIsCMPBoard), (issueParents, boardIssues, childIssues, hasNoActiveSprint, isIncrementPlanningBoard, isCMPBoard)=>{
    if (hasNoActiveSprint) return [];
    const filteredIssueParents = !isCMPBoard ? issueParents : issueParents.filter(({ issueType: { hierarchyLevel: hierarchyLevel } })=>(0, $g4tDr.isEpicHierarchyLevel)(hierarchyLevel));
    const listItems = filteredIssueParents.map(({ id: id, summary: summary, key: key })=>({
            id: String(id),
            key: key,
            name: summary
        }));
    // in the increment planning board, we show epic cards, hence we want to show all epics in the filter
    if (isIncrementPlanningBoard) return listItems;
    const visibleParentIds = new Set(Object.values(boardIssues).map((issue)=>`${issue.parentId || issue.id}`));
    const visibleParentIdsFromSubtasks = new Set(Object.values(childIssues).map((issue)=>`${issue.parentId}`));
    // Generate a set of all distinct parentIds for all visible issues and subtasks on the board.
    const allVisibleParentIds = new Set([
        ...visibleParentIds,
        ...visibleParentIdsFromSubtasks
    ]);
    // remove issueParents that dont have any active issues on the board
    return listItems.filter((issueParent)=>allVisibleParentIds.has(issueParent.id));
});
const $2eb3e41683b9322e$export$e69b35537968b7e1 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$df9259146e40d32c, (issueParents)=>Object.keys(issueParents));
const $2eb3e41683b9322e$export$461364b3b51e10c1 = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$27ed9219e3872aed, (issueParents)=>issueParents ? (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, (/*@__PURE__*/$parcel$interopDefault($2HfxU)))(issueParents), [
        'issueType',
        'name'
    ], (0, $dcbb2bce513725b3$export$cb17e3c17bc50301)) : (0, $dcbb2bce513725b3$export$cb17e3c17bc50301));
const $2eb3e41683b9322e$export$dbff01ed0e86fffd = (0, $dGvGJ.createSelector)($2eb3e41683b9322e$export$df9259146e40d32c, (issueParents)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueParentId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(issueParents, String(issueParentId), null)));

});
parcelRegister("2HfxU", function(module, exports) {

module.exports = (parcelRequire("bH3EF"));

});

const $dcbb2bce513725b3$export$ad42fdc358b8c597 = 'MMM d, yyyy';
const $dcbb2bce513725b3$export$cb17e3c17bc50301 = 'Epic';
const $dcbb2bce513725b3$export$d29cf9c8492f955d = 'Base';
const $dcbb2bce513725b3$export$725480b44dc3539d = 'TAB_BECAME_ACTIVE';
const $dcbb2bce513725b3$export$8125ab02c04ac8e7 = 'POLLING';
const $dcbb2bce513725b3$export$af001fd9213b0b63 = 'REALTIME';
const $dcbb2bce513725b3$export$d9d2fe902bd6d9a7 = 'FAILURE';
const $dcbb2bce513725b3$export$8cabdc85b8691f12 = 'GLOBAL_ISSUE_CREATE';
const $dcbb2bce513725b3$export$a0b8ab2c9a9afaaa = 'MODAL_CLOSED';
const $dcbb2bce513725b3$export$9808bb47382c679c = 'BENTO';
const $dcbb2bce513725b3$export$8d3fdbb8c61d9d21 = 'CARD_CLEAR_UNDO';
const $dcbb2bce513725b3$export$443de2b93e4aa6c6 = 'STATUS_REMAPPED';
const $dcbb2bce513725b3$export$3b24bb12b5615667 = 'RELEASE_VERSION';
const $dcbb2bce513725b3$export$ce2132697bb05fef = 'TRANSITION';
const $dcbb2bce513725b3$export$5e8e8357f5d6fec1 = 'BULK_ISSUE_RANK';
const $dcbb2bce513725b3$export$7aa54af91613c70a = 'INLINE_CREATE';
const $dcbb2bce513725b3$export$bddadd6eeae21573 = 'COLUMN_CREATE';
const $dcbb2bce513725b3$export$d44770975cd9746d = 'COLUMN_DELETE';
const $dcbb2bce513725b3$export$97b91dd49f0a73f1 = 'ADD_FLAG';
const $dcbb2bce513725b3$export$62b6dae85d0fc668 = 'BOARD_ADD_TO_SPRINT';
const $dcbb2bce513725b3$export$17d7097367e94100 = 'BOARD_API';
const $dcbb2bce513725b3$export$ccb7bcb751e6027e = 'ARCHIVE_ISSUE';
const $dcbb2bce513725b3$export$66e48a348bf0e91e = 'ADD_ISSUE_TYPE_MODAL';
const $dcbb2bce513725b3$export$243af246b0a1a89f = 'OLD_DONE_ISSUE_CUTOFF_CHANGED';
const $dcbb2bce513725b3$export$67cc25959ff33188 = 'board.long-tasks-dnd';
const $dcbb2bce513725b3$export$d76071d5de2774fc = 'software.work';
const $dcbb2bce513725b3$export$d57b6b390e78d90f = 'a4t-tanuki';
const $dcbb2bce513725b3$export$b8b9d90f9e5bd72b = '@atlassian/jira-software-board';
const $dcbb2bce513725b3$export$912517e8555c1752 = 'a4t-pandora';
const $dcbb2bce513725b3$export$b05303cbde3e8c8c = 'CARD';
const $dcbb2bce513725b3$export$1f24f91824c6822f = 'SUBTASK';
const $dcbb2bce513725b3$export$dd0edbbd0cedc7cb = 'CARD_GROUP';
const $dcbb2bce513725b3$export$fa0622448a6f265 = 'ng-board';
const $dcbb2bce513725b3$export$3ccc579abb61693b = 'cmp-board';
const $dcbb2bce513725b3$export$e3639dbf0033629d = 'BOARD_INTERACTIVE_MARK';
const $dcbb2bce513725b3$export$405b6d72f2d243a9 = 'STORY_POINTS';
const $dcbb2bce513725b3$export$bfb354504bb547a0 = 'ORIGINAL_ESTIMATE';
const $dcbb2bce513725b3$export$8775696968c9b13c = 'ISSUE_COUNT';
const $dcbb2bce513725b3$export$d02889a654103c98 = 'timeoriginalestimate';
const $dcbb2bce513725b3$export$2683a6b6da85de4d = 50;
const $dcbb2bce513725b3$export$e5bf25b985a7619d = 'TOP_OF_CONTAINER';
const $dcbb2bce513725b3$export$e044c7349fbdcb2 = 'BOTTOM_OF_CONTAINER';
const $dcbb2bce513725b3$export$9b8283d5878d2491 = 'BOARD';
const $dcbb2bce513725b3$export$26ad7c86aba35f49 = 'DEFAULT_JQL_SWIMLANE_ID';

parcelRegister("ebHh7", function(module, exports) {

$parcel$export(module.exports, "getSprintEntities", () => $6b82a816f7cc09a6$export$99b5f08df8a22dd3);
$parcel$export(module.exports, "isSprintsEnabled", () => $6b82a816f7cc09a6$export$e9a842814803cf10);
$parcel$export(module.exports, "getSprintsSelector", () => $6b82a816f7cc09a6$export$9fa4434d31d5cb0e);
$parcel$export(module.exports, "activeSprintsSelector", () => $6b82a816f7cc09a6$export$cb586b0fb4a1e305);
$parcel$export(module.exports, "hasActiveSprintsSelector", () => $6b82a816f7cc09a6$export$cd91bbbea8056197);
$parcel$export(module.exports, "hasNoActiveSprintStateSelector", () => $6b82a816f7cc09a6$export$cc16fcf4a89b80e2);
$parcel$export(module.exports, "getSelectedSprintsKeys", () => $6b82a816f7cc09a6$export$7b1349fd52e8647a);
$parcel$export(module.exports, "activeSprintGoalSelector", () => $6b82a816f7cc09a6$export$a2ae85498e9ef7b4);
$parcel$export(module.exports, "getSelectedOrAllSprintsSelector", () => $6b82a816f7cc09a6$export$3cf5d7ead1a6863d);
$parcel$export(module.exports, "remainingDaysSelector", () => $6b82a816f7cc09a6$export$70ce2bd4b7920794);
$parcel$export(module.exports, "canCompleteSprintSelector", () => $6b82a816f7cc09a6$export$51fb954a1ccf54db);
$parcel$export(module.exports, "hasManageSprintPermission", () => $6b82a816f7cc09a6$export$e744169f0c37fc19);

var $dGvGJ = parcelRequire("dGvGJ");

var $k7m40 = parcelRequire("k7m40");
var $eZDAP = parcelRequire("eZDAP");

var $jcw0u = parcelRequire("jcw0u");

var $g5X3G = parcelRequire("g5X3G");


var $aXi41 = parcelRequire("aXi41");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");
const $6b82a816f7cc09a6$export$99b5f08df8a22dd3 = (state)=>(0, $67Z81.getEntities)(state).sprints;
const $6b82a816f7cc09a6$export$a42917320a6b1916 = (state)=>(0, $67Z81.getUi)(state).sprints ?? (0, $aXi41.initialSprintsState);
const $6b82a816f7cc09a6$export$e9a842814803cf10 = (state)=>(0, $67Z81.getBoardEntity)(state).config.isSprintsEnabled || false;
// "selected" in the context of the board entity means "active"
// vs. "selected" in the context of the sprint UI state means "selected for display" (subset of active)
// WARNING: empirically (as of 2024/09) seen "null" when there are no active sprints
// instead of [] (empty array). This behavior is debatable but is important for "activeSprintsSelector" below.
// Be careful if you change this behavior.
const $6b82a816f7cc09a6$var$getActiveSprintsIds = (state)=>(0, $67Z81.getBoardEntity)(state).selectedSprints;
const $6b82a816f7cc09a6$export$9fa4434d31d5cb0e = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$99b5f08df8a22dd3,
    $6b82a816f7cc09a6$export$e9a842814803cf10
], (sprints, sprintsEnabled)=>sprintsEnabled ? (0, $g5X3G.values)(sprints) : []);
const $6b82a816f7cc09a6$export$cb586b0fb4a1e305 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$e9a842814803cf10,
    $6b82a816f7cc09a6$export$99b5f08df8a22dd3,
    $6b82a816f7cc09a6$var$getActiveSprintsIds
], (sprintsEnabled, sprints, ids)=>sprintsEnabled && ids !== null ? Object.keys(sprints).filter((key)=>ids.includes(parseInt(key, 10))).map((key)=>sprints[key]) : null);
const $6b82a816f7cc09a6$export$cd91bbbea8056197 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$cb586b0fb4a1e305
], (activeSprints)=>activeSprints !== null);
const $6b82a816f7cc09a6$export$cc16fcf4a89b80e2 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$e9a842814803cf10,
    $6b82a816f7cc09a6$export$cd91bbbea8056197
], (sprintsEnabled, sprintActive)=>sprintsEnabled && !sprintActive);
const $6b82a816f7cc09a6$export$7b1349fd52e8647a = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$a42917320a6b1916
], (sprintUiState)=>sprintUiState.selected);
const $6b82a816f7cc09a6$export$a2ae85498e9ef7b4 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$cb586b0fb4a1e305,
    $6b82a816f7cc09a6$export$7b1349fd52e8647a
], (activeSprints, selectedSprints)=>{
    const goals = activeSprints && activeSprints.filter((sprint)=>selectedSprints && selectedSprints.length > 0 ? selectedSprints.includes(sprint.id.toString()) : true).map((sprint)=>sprint.goal || '');
    return goals && // We only want to display if there is 1 sprint or 1 sprint selected
    goals.length === 1 && goals.filter((goal)=>goal.trim() !== '').length > 0 ? goals[0] : null;
});
const $6b82a816f7cc09a6$export$3cf5d7ead1a6863d = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$cb586b0fb4a1e305,
    $6b82a816f7cc09a6$export$7b1349fd52e8647a
], (activeSprints, selectedSprints)=>{
    const hasSelectedSprints = selectedSprints && selectedSprints.length > 0;
    const sprints = activeSprints ?? [];
    return hasSelectedSprints ? sprints.filter((sprint)=>selectedSprints.includes(sprint.id.toString())) : sprints;
});
const $6b82a816f7cc09a6$var$formatDate = (date)=>(0, $k7m40.default)((0, $eZDAP.default)(date), 'yyyy-MM-dd');
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b82a816f7cc09a6$var$identity = (x)=>x;
function $6b82a816f7cc09a6$var$getValue(key, transform = $6b82a816f7cc09a6$var$identity) {
    return (selectedSprints)=>{
        const sprintsHaveEqual = (sprint)=>{
            // The transform function could potentially throw. So we need a try catch
            // eg: When the transform function uses parseISO, it will throw when an invalid date is used. i.e.: parseISO('foo') will throw an error
            try {
                // Try to minimise error throwing by checking for undefined scenarios first
                if (!sprint || !sprint[key] || !selectedSprints?.[0]?.[key]) return false;
                return transform(sprint[key]) === transform(selectedSprints[0][key]);
            } catch (e) {
                (0, $jcw0u.default)({
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    error: e,
                    meta: {
                        id: 'remainingDaysSelector',
                        packageName: 'jiraSoftwareBoard'
                    }
                });
                return false;
            }
        };
        return selectedSprints.length === 1 || selectedSprints.length > 0 && selectedSprints.every(sprintsHaveEqual) ? selectedSprints[0][key] : null;
    };
}
const $6b82a816f7cc09a6$export$70ce2bd4b7920794 = (0, $dGvGJ.createSelector)([
    $6b82a816f7cc09a6$export$cb586b0fb4a1e305,
    $6b82a816f7cc09a6$export$7b1349fd52e8647a
], (sprints, selectedSprintKeys)=>{
    if (sprints && sprints.length > 0) {
        const hasSelectedSprints = selectedSprintKeys && selectedSprintKeys.length > 0;
        const selectedSprints = sprints.length > 1 ? sprints.filter((sprint)=>hasSelectedSprints ? selectedSprintKeys.includes(sprint.id.toString()) : true) : sprints;
        const remainingDays = $6b82a816f7cc09a6$var$getValue('daysRemaining')(selectedSprints);
        const startDate = $6b82a816f7cc09a6$var$getValue('startDate', $6b82a816f7cc09a6$var$formatDate)(selectedSprints) || null;
        const endDate = $6b82a816f7cc09a6$var$getValue('endDate', $6b82a816f7cc09a6$var$formatDate)(selectedSprints) || null;
        return {
            remainingDays: remainingDays,
            startDate: startDate,
            endDate: endDate
        };
    }
    return {
        remainingDays: null,
        startDate: null,
        endDate: null
    };
});
const $6b82a816f7cc09a6$export$51fb954a1ccf54db = (0, $dGvGJ.createSelector)([
    (0, $1vXOx.getPermissionsSelector),
    $6b82a816f7cc09a6$export$cd91bbbea8056197
], (permissions, isActiveSprint)=>{
    const canManageSprint = !!permissions[0, $e525e6c25695c9df$export$112115098b6cf79b];
    return isActiveSprint && canManageSprint;
});
const $6b82a816f7cc09a6$export$e744169f0c37fc19 = (0, $dGvGJ.createSelector)([
    (0, $1vXOx.getPermissionsSelector)
], (permissions)=>!!permissions[0, $e525e6c25695c9df$export$112115098b6cf79b]);

});
parcelRegister("aXi41", function(module, exports) {

$parcel$export(module.exports, "initialSprintsState", () => $0fa1ad59b68785f4$export$dc5c1bcca875074c);
const $0fa1ad59b68785f4$export$dc5c1bcca875074c = {
    selected: []
};

});





parcelRegister("d2i8f", function(module, exports) {

$parcel$export(module.exports, "isAssignedToIssueParent", () => $3c504b6d6dc181e6$export$a9b1eabca1c583fe);
$parcel$export(module.exports, "getIssueById", () => $3c504b6d6dc181e6$export$75010363f38d9dc8);
$parcel$export(module.exports, "getIssueIndex", () => $3c504b6d6dc181e6$export$3fc2b15c8f070ca9);
$parcel$export(module.exports, "isDoneIssueSelector", () => $3c504b6d6dc181e6$export$4faaf52f6bb50544);
$parcel$export(module.exports, "getIssueByKey", () => $3c504b6d6dc181e6$export$90673c605758652a);
$parcel$export(module.exports, "getIssueOrIssueChildById", () => $3c504b6d6dc181e6$export$12ca3f76ae252a08);
$parcel$export(module.exports, "hasIssueOrIssueChild", () => $3c504b6d6dc181e6$export$b5d531bf7b799a0b);
$parcel$export(module.exports, "getRankConfig", () => $3c504b6d6dc181e6$export$f4b7bab45cfe9501);
$parcel$export(module.exports, "getOrderedIssuesByColumn", () => $3c504b6d6dc181e6$export$9e0bc259bacafb93);
$parcel$export(module.exports, "getDoneIssuesInColumn", () => $3c504b6d6dc181e6$export$6a9dec6161a76344);
$parcel$export(module.exports, "getIssueTypeLevelForBoardIssue", () => $3c504b6d6dc181e6$export$9e240be2729e2455);
$parcel$export(module.exports, "getFirstIssueInColumn", () => $3c504b6d6dc181e6$export$cf39cd1dac4bf6f1);
$parcel$export(module.exports, "getFirstIssueChildInColumnByParent", () => $3c504b6d6dc181e6$export$127dd3e8092f4ed1);
$parcel$export(module.exports, "getLastIssueInColumn", () => $3c504b6d6dc181e6$export$f996d11bfdc851b8);
$parcel$export(module.exports, "getLastIssueChildInColumnByParent", () => $3c504b6d6dc181e6$export$2dac73d418cca0de);
$parcel$export(module.exports, "isFirstIssueInColumn", () => $3c504b6d6dc181e6$export$b902a84f09e4102f);
$parcel$export(module.exports, "isLastIssueInColumn", () => $3c504b6d6dc181e6$export$63c1cd181e56ff6);
$parcel$export(module.exports, "isIssueFlagged", () => $3c504b6d6dc181e6$export$12b0817fd637143e);
$parcel$export(module.exports, "makeGetColumnIdForIssue", () => $3c504b6d6dc181e6$export$d34f58875bd9ab64);
$parcel$export(module.exports, "issueLabelsSelector", () => $3c504b6d6dc181e6$export$66a8f4f78b4fa842);
$parcel$export(module.exports, "makeIssueDevStatusSelector", () => $3c504b6d6dc181e6$export$2a446fc7a9aee050);
$parcel$export(module.exports, "issueProjectIdsSelector", () => $3c504b6d6dc181e6$export$ba5d9003371c95ce);
$parcel$export(module.exports, "issueTypeFilterSelector", () => $3c504b6d6dc181e6$export$74763dafa7432178);
$parcel$export(module.exports, "sortedIssueTypeSelector", () => $3c504b6d6dc181e6$export$744fc5e35b11a96e);
$parcel$export(module.exports, "issueTypeGroupSelector", () => $3c504b6d6dc181e6$export$e668ba5420de7f05);
$parcel$export(module.exports, "requestTypesSelector", () => $3c504b6d6dc181e6$export$813c027a6bea724b);
$parcel$export(module.exports, "statusesSelector", () => $3c504b6d6dc181e6$export$1b3e7a08cee8d1ac);
$parcel$export(module.exports, "makeDoesColumnContainDoneCardsSelector", () => $3c504b6d6dc181e6$export$fae650fc801d3a0);
$parcel$export(module.exports, "getIssueTypeById", () => $3c504b6d6dc181e6$export$49508c02463816d4);
$parcel$export(module.exports, "getIssueKeysFromIssueIds", () => $3c504b6d6dc181e6$export$792b0fb756f9c021);
$parcel$export(module.exports, "getIssueStatusSelector", () => $3c504b6d6dc181e6$export$39efdf2aa70bd5a2);
$parcel$export(module.exports, "getIsIssueDoneInClosedSprint", () => $3c504b6d6dc181e6$export$e39cb5ba3742d388);

var $dGvGJ = parcelRequire("dGvGJ");

var $hIkqU = parcelRequire("hIkqU");

var $9XE6b = parcelRequire("9XE6b");

var $fn8B5 = parcelRequire("fn8B5");

var $etyzk = parcelRequire("etyzk");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $hYfgW = parcelRequire("hYfgW");

var $gJBT6 = parcelRequire("gJBT6");

var $kGsr8 = parcelRequire("kGsr8");

var $3JOCw = parcelRequire("3JOCw");

var $8O7FC = parcelRequire("8O7FC");

var $g4tDr = parcelRequire("g4tDr");

var $3spCR = parcelRequire("3spCR");

var $fyeGd = parcelRequire("fyeGd");

var $3UY9S = parcelRequire("3UY9S");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");

var $vAfHD = parcelRequire("vAfHD");
const $3c504b6d6dc181e6$export$a9b1eabca1c583fe = (0, $dGvGJ.createSelector)((0, $vAfHD.boardIssuesSelector), (issues)=>{
    const isAssignedToIssueParentCheck = (issueIds)=>{
        const stringIds = issueIds.map((id)=>String(id));
        return Object.keys(issues).filter((id)=>stringIds.includes(id) && issues[id].parentId).length > 0;
    };
    return isAssignedToIssueParentCheck;
});
const $3c504b6d6dc181e6$export$75010363f38d9dc8 = (state, issueId)=>(0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
const $3c504b6d6dc181e6$export$5120de20e5917187 = (state, issueId)=>!!$3c504b6d6dc181e6$export$75010363f38d9dc8(state, issueId);
const $3c504b6d6dc181e6$export$3fc2b15c8f070ca9 = (state, issueId)=>(0, $vAfHD.boardOrderedIssueIdsSelector)(state).indexOf(issueId);
const $3c504b6d6dc181e6$export$4faaf52f6bb50544 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $vAfHD.boardIssuesAndChildrenSelector)
], (issuesWithoutSubtasks, allIssues)=>{
    // using the boardIssuesAndChildrenSelector here allows this selector to be used in any situation.
    // boardIssuesSelector filters out issues with subtasks when grouping by subtasks/stories and this selector couldn't access those issues.
    const isDoneIssueSelectorCheck = (issueId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(allIssues[String(issueId)], [
            'isDone'
        ], false);
    return isDoneIssueSelectorCheck;
});
const $3c504b6d6dc181e6$var$getIssuesByKeys = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, 'key'));
const $3c504b6d6dc181e6$var$getIssuesAndIssueChildrenByKeys = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesAndChildrenSelector)
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, 'key'));
const $3c504b6d6dc181e6$export$e8655af1be698e8b = (state, issueKey)=>$3c504b6d6dc181e6$var$getIssuesAndIssueChildrenByKeys(state)[issueKey] ? $3c504b6d6dc181e6$var$getIssuesAndIssueChildrenByKeys(state)[issueKey][0] : undefined;
const $3c504b6d6dc181e6$export$90673c605758652a = (state, issueKey)=>$3c504b6d6dc181e6$var$getIssuesByKeys(state)[issueKey] ? $3c504b6d6dc181e6$var$getIssuesByKeys(state)[issueKey][0] : undefined;
const $3c504b6d6dc181e6$export$12ca3f76ae252a08 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues),
    (0, $3UY9S.getIssueChildren)
], (issues, issueChildren)=>(issueId)=>issues[String(issueId)] || issueChildren[String(issueId)]);
const $3c504b6d6dc181e6$export$b5d531bf7b799a0b = (state, issueId)=>!!$3c504b6d6dc181e6$export$12ca3f76ae252a08(state)(issueId);
const $3c504b6d6dc181e6$export$f4b7bab45cfe9501 = (state)=>(0, $67Z81.getBoardEntity)(state).config.rankConfig;
const $3c504b6d6dc181e6$var$getOrderedIssues = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardOrderedIssueIdsSelector),
    (0, $vAfHD.boardIssuesSelector)
], (orderedIds, issues)=>orderedIds.map((issueId)=>issues[String(issueId)]).filter((0, (/*@__PURE__*/$parcel$interopDefault($etyzk)))));
const $3c504b6d6dc181e6$export$9e0bc259bacafb93 = (0, $dGvGJ.createSelector)($3c504b6d6dc181e6$var$getOrderedIssues, (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, (issue)=>issue.columnId));
const $3c504b6d6dc181e6$export$eb62af33a0f99619 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>Object.keys(issues).map((issueId)=>issues[issueId]).filter((issue)=>issue.isDone));
const $3c504b6d6dc181e6$export$6a9dec6161a76344 = (0, $dGvGJ.createSelector)($3c504b6d6dc181e6$export$eb62af33a0f99619, (doneIssues)=>{
    const doneIssuesInColumn = (columnId)=>doneIssues.filter((issue)=>issue.columnId === columnId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(doneIssuesInColumn);
});
const $3c504b6d6dc181e6$export$9e240be2729e2455 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getProjectIssueTypes)
], (issues, projectIssueTypes)=>{
    const issueTypeLevel = (issueId)=>{
        const issue = issues[String(issueId)];
        // If issue is not on the board then it's most likely an issue parent
        if (!issue) return 1;
        const projectIssueType = projectIssueTypes[String(issue.typeId)];
        if (projectIssueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE)) return -1;
        if (projectIssueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE)) return 1;
        return 0;
    };
    return issueTypeLevel;
});
const $3c504b6d6dc181e6$export$cf39cd1dac4bf6f1 = (state, columnId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($3c504b6d6dc181e6$export$9e0bc259bacafb93(state), [
        columnId,
        0,
        'id'
    ], null);
const $3c504b6d6dc181e6$export$127dd3e8092f4ed1 = (state, columnId, parentId)=>$3c504b6d6dc181e6$export$9e0bc259bacafb93(state)[columnId]?.find((issue)=>issue.parentId === parentId)?.id;
const $3c504b6d6dc181e6$export$f996d11bfdc851b8 = (state, columnId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))($3c504b6d6dc181e6$export$9e0bc259bacafb93(state)[columnId]), [
        'id'
    ], null);
const $3c504b6d6dc181e6$export$2dac73d418cca0de = (state, columnId, parentId)=>(0, (/*@__PURE__*/$parcel$interopDefault($hIkqU)))($3c504b6d6dc181e6$export$9e0bc259bacafb93(state)[columnId], (issue)=>issue.parentId === parentId)?.id;
const $3c504b6d6dc181e6$export$8471aa4931bcf100 = (0, $dGvGJ.createSelector)([
    $3c504b6d6dc181e6$export$9e0bc259bacafb93
], (orderedIssuesByColumn)=>(columnId, issue1, issue2)=>{
        const issueIds = orderedIssuesByColumn[columnId].map((issue)=>issue.id);
        if (!issueIds.includes(issue1) || !issueIds.includes(issue2)) return 0;
        return issueIds.indexOf(issue1) - issueIds.indexOf(issue2);
    });
const $3c504b6d6dc181e6$export$b902a84f09e4102f = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    return issue !== undefined && $3c504b6d6dc181e6$export$cf39cd1dac4bf6f1(state, issue.columnId) === issueId;
};
const $3c504b6d6dc181e6$export$63c1cd181e56ff6 = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    return issue !== undefined && $3c504b6d6dc181e6$export$f996d11bfdc851b8(state, issue.columnId) === issueId;
};
const $3c504b6d6dc181e6$export$12b0817fd637143e = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    return !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) && Boolean(issue.isFlagged);
};
const $3c504b6d6dc181e6$var$getColumnIdForIssue = (state, issueId)=>(0, $vAfHD.boardIssuesSelector)(state)[String(issueId)].columnId;
const $3c504b6d6dc181e6$export$d34f58875bd9ab64 = (0, $dGvGJ.createSelector)((0, $vAfHD.boardIssuesSelector), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>issues[String(issueId)].columnId));
const $3c504b6d6dc181e6$export$6be9e908edb1e82d = (state, issueId)=>{
    const columnId = $3c504b6d6dc181e6$var$getColumnIdForIssue(state, issueId);
    return (0, $fyeGd.getColumnIndex)(state, columnId);
};
const $3c504b6d6dc181e6$export$66a8f4f78b4fa842 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>Array.from((0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.keys(issues).map((key)=>issues[key]).reduce((labels, issue)=>issue.labels ? issue.labels.reduce((acc, label)=>{
            acc.push(label);
            return acc;
        }, labels) : labels, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    [])).sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a, b))));
const $3c504b6d6dc181e6$export$2a446fc7a9aee050 = (0, $dGvGJ.createSelector)((0, $vAfHD.boardIssuesSelector), (previousIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issues)=>issues.map((issue)=>{
            const idString = String(issue.id);
            if (previousIssues[idString] && previousIssues[idString].devStatus) {
                const { devStatus: devStatus } = previousIssues[idString];
                return {
                    ...issue,
                    devStatus: devStatus
                };
            }
            return issue;
        })));
const $3c504b6d6dc181e6$export$e04c2adc17b387c5 = (0, $dGvGJ.createSelector)((0, $vAfHD.boardIssuesSelector), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((expectedDevStatuses)=>Object.keys(issues).filter((issueId)=>{
            const { devStatus: devStatus } = issues[issueId];
            return devStatus && expectedDevStatuses.includes(devStatus.activity);
        })));
const $3c504b6d6dc181e6$export$ba5d9003371c95ce = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjects)
], (issueProjects)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.keys(issueProjects).map((key)=>String(key))));
const $3c504b6d6dc181e6$export$74763dafa7432178 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>Array.from((0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(Object.keys(issues).map((key)=>String(issues[key].typeId)))));
const $3c504b6d6dc181e6$export$c5a236f192993436 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(Object.keys(issues).map((key)=>{
        const issue = issues[key];
        return {
            id: String(issue.typeId),
            name: issue.typeName || '',
            iconUrl: issue.typeUrl || ''
        };
    }), 'id'));
const $3c504b6d6dc181e6$export$744fc5e35b11a96e = (0, $dGvGJ.createSelector)([
    $3c504b6d6dc181e6$export$c5a236f192993436
], (issues)=>issues.sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.name, b.name)));
const $3c504b6d6dc181e6$export$e668ba5420de7f05 = (0, $dGvGJ.createSelector)([
    $3c504b6d6dc181e6$export$74763dafa7432178,
    (0, $4gt6L.getIssueTypesGroupedByNameLevel)
], (issueTypes, issueTypeGroups)=>issueTypeGroups.map((group)=>({
            ...group,
            issueTypes: group.issueTypes.filter((issueType)=>issueTypes.includes(issueType))
        })).filter((group)=>group.issueTypes.length > 0));
const $3c504b6d6dc181e6$export$813c027a6bea724b = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getRequestTypes)
], (issues, requestTypes)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(requestTypes)) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(Object.keys(issues).filter((key)=>{
        const issue = issues[key];
        return !!(issue.requestTypeId && requestTypes[issue.requestTypeId]);
    }).map((key)=>{
        const issue = issues[key];
        // requestTypeId will always have a value, because we are filtering out issues without request types
        const { id: id, name: name, iconUrl: iconUrl } = requestTypes[issue.requestTypeId ?? ''];
        return {
            id: id,
            name: name,
            iconUrl: iconUrl
        };
    }), 'id').sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.name, b.name));
});
const $3c504b6d6dc181e6$export$1b3e7a08cee8d1ac = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getStatuses)
], (issues, statuses)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(statuses)) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(Object.keys(issues).filter((key)=>{
        const issue = issues[key];
        return !!statuses[issue.statusId];
    }).map((key)=>{
        const issue = issues[key];
        const { id: id, name: name } = statuses[issue.statusId];
        return {
            id: String(id),
            name: name
        };
    }), 'id').sort((a, b)=>(0, $8O7FC.alphabeticalSort)(a.name, b.name));
});
const $3c504b6d6dc181e6$export$fae650fc801d3a0 = (0, $dGvGJ.createSelector)([
    $3c504b6d6dc181e6$export$eb62af33a0f99619
], (doneCards)=>{
    const doesColumnContainDoneCardsCheck = (columnId)=>doneCards.filter((card)=>columnId === card.columnId).length > 0;
    return doesColumnContainDoneCardsCheck;
});
const $3c504b6d6dc181e6$export$49508c02463816d4 = (state, typeId)=>(0, $67Z81.getIssueTypes)(state)[typeId.toString()] || (0, $67Z81.getProjectIssueTypes)(state)[typeId.toString()];
const $3c504b6d6dc181e6$export$6572a8aea8235af8 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>{
    const getPartialIssuesFromIssueIds = (issueIds)=>issueIds.filter((issueId)=>issues[String(issueId)]).map((issueId)=>{
            const { id: id, key: key, parentId: parentId } = issues[String(issueId)];
            return {
                id: id,
                key: key,
                parentId: parentId
            };
        });
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getPartialIssuesFromIssueIds);
});
const $3c504b6d6dc181e6$export$792b0fb756f9c021 = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueIds)=>issueIds.map((issueId)=>issues[String(issueId)]?.key).filter((issueKey)=>!!issueKey)));
const $3c504b6d6dc181e6$export$39efdf2aa70bd5a2 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $fyeGd.getStatusMapSelector)
], (issues, statusMap)=>(issueId)=>{
        const issue = issues[String(issueId)];
        return statusMap[issue?.statusId];
    });
const $3c504b6d6dc181e6$export$e39cb5ba3742d388 = (state, issueId)=>{
    const issue = (0, $67Z81.getIssues)(state)[issueId];
    if (!issue) return false;
    const isDone = issue.isDone;
    const swimlane = issue.teamId;
    // teamless swimlane
    if (!swimlane) return false;
    const teamSprintsForIterations = (0, $cPGP0.getTeamSprintsForIterations)(state, swimlane);
    // no sprints associated to team
    if (teamSprintsForIterations === null) return false;
    const sprintAssociatedToSwimlaneColumn = teamSprintsForIterations[Number(issue.columnId)];
    // no sprint associated to column
    if (!sprintAssociatedToSwimlaneColumn) return false;
    return isDone && sprintAssociatedToSwimlaneColumn.state === (0, $3spCR.SPRINT_STATES).CLOSED;
};

});
parcelRegister("hIkqU", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $apUNl = parcelRequire("apUNl");
/**
 * This method is like `_.find` except that it iterates over elements of
 * `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=collection.length-1] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * _.findLast([1, 2, 3, 4], function(n) {
 *   return n % 2 == 1;
 * });
 * // => 3
 */ var $0353f9604956038c$var$findLast = $bptzf($apUNl);
module.exports = $0353f9604956038c$var$findLast;

});
parcelRegister("bptzf", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $hTJwX = parcelRequire("hTJwX");

var $66FNL = parcelRequire("66FNL");
/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */ function $84e8f705a13e859f$var$createFind(findIndexFunc) {
    return function(collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!$hTJwX(collection)) {
            var iteratee = $bxDef(predicate, 3);
            collection = $66FNL(collection);
            predicate = function(key) {
                return iteratee(iterable[key], key, iterable);
            };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
    };
}
module.exports = $84e8f705a13e859f$var$createFind;

});

parcelRegister("apUNl", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $79584b713e0c6354$var$nativeMax = Math.max, $79584b713e0c6354$var$nativeMin = Math.min;
/**
 * This method is like `_.findIndex` except that it iterates over elements
 * of `collection` from right to left.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=array.length-1] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': true },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': false }
 * ];
 *
 * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
 * // => 2
 *
 * // The `_.matches` iteratee shorthand.
 * _.findLastIndex(users, { 'user': 'barney', 'active': true });
 * // => 0
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findLastIndex(users, ['active', false]);
 * // => 2
 *
 * // The `_.property` iteratee shorthand.
 * _.findLastIndex(users, 'active');
 * // => 0
 */ function $79584b713e0c6354$var$findLastIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = length - 1;
    if (fromIndex !== undefined) {
        index = $kPZpS(fromIndex);
        index = fromIndex < 0 ? $79584b713e0c6354$var$nativeMax(length + index, 0) : $79584b713e0c6354$var$nativeMin(index, length - 1);
    }
    return $b5dwA(array, $bxDef(predicate, 3), index, true);
}
module.exports = $79584b713e0c6354$var$findLastIndex;

});


parcelRegister("3spCR", function(module, exports) {

$parcel$export(module.exports, "ACTIVE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$3ebc9911a79d714f);
$parcel$export(module.exports, "FUTURE_SPRINT_STATE", () => $113c1ed08a0bda4f$export$863e42082c6bde5);
$parcel$export(module.exports, "CLOSED_SPRINT_STATE", () => $113c1ed08a0bda4f$export$86cdef09a89e8c4b);
$parcel$export(module.exports, "SPRINT_STATES", () => $113c1ed08a0bda4f$export$73a0206a4dc59760);
const $113c1ed08a0bda4f$export$3ebc9911a79d714f = 'ACTIVE';
const $113c1ed08a0bda4f$export$863e42082c6bde5 = 'FUTURE';
const $113c1ed08a0bda4f$export$86cdef09a89e8c4b = 'CLOSED';
const $113c1ed08a0bda4f$export$73a0206a4dc59760 = {
    ACTIVE: $113c1ed08a0bda4f$export$3ebc9911a79d714f,
    CLOSED: $113c1ed08a0bda4f$export$86cdef09a89e8c4b,
    FUTURE: $113c1ed08a0bda4f$export$863e42082c6bde5
};

});

parcelRegister("fyeGd", function(module, exports) {

$parcel$export(module.exports, "isInitialColumn", () => $6a25cd9aef6b667c$export$2b76b0b5245526);
$parcel$export(module.exports, "isDoneColumn", () => $6a25cd9aef6b667c$export$844d7708d71f3c7a);
$parcel$export(module.exports, "getColumnLozenges", () => $6a25cd9aef6b667c$export$af5417af3fd8a43e);
$parcel$export(module.exports, "getStatusColumn", () => $6a25cd9aef6b667c$export$f9a77580ef71cadc);
$parcel$export(module.exports, "getColumnIndex", () => $6a25cd9aef6b667c$export$19642b3ccdd58d52);
$parcel$export(module.exports, "isLastColumn", () => $6a25cd9aef6b667c$export$e509b4c22370e953);
$parcel$export(module.exports, "getColumns", () => $6a25cd9aef6b667c$export$978e30a0fb8610d8);
$parcel$export(module.exports, "getColumnById", () => $6a25cd9aef6b667c$export$e85f3ae1437b5b1e);
$parcel$export(module.exports, "initialColumnIdSelector", () => $6a25cd9aef6b667c$export$8cca2eac80b2d07b);
$parcel$export(module.exports, "initialColumnSelector", () => $6a25cd9aef6b667c$export$8e38f35aef868f9);
$parcel$export(module.exports, "doneColumnIdSelector", () => $6a25cd9aef6b667c$export$52746a4a3c64914);
$parcel$export(module.exports, "getStatusesByColumnId", () => $6a25cd9aef6b667c$export$90275f6847b087c6);
$parcel$export(module.exports, "getStatusCategoryByStatusInColumnId", () => $6a25cd9aef6b667c$export$fdfafe8417f25b23);
$parcel$export(module.exports, "columnByStatusIdSelector", () => $6a25cd9aef6b667c$export$d387fce3079a165a);
$parcel$export(module.exports, "orderedColumnsSelector", () => $6a25cd9aef6b667c$export$797a3f448cda3e3a);
$parcel$export(module.exports, "columnStatusMappingSelector", () => $6a25cd9aef6b667c$export$3133db18f9e069b6);
$parcel$export(module.exports, "isDoneColumnSelector", () => $6a25cd9aef6b667c$export$5e7d90f7b0706af);
$parcel$export(module.exports, "makeValidateColumnSelector", () => $6a25cd9aef6b667c$export$54e158f99bd87a8c);
$parcel$export(module.exports, "hasColumnLimits", () => $6a25cd9aef6b667c$export$5473fcc76aa5870d);
$parcel$export(module.exports, "makeClosestColumnSelector", () => $6a25cd9aef6b667c$export$bade1fd14989df4);
$parcel$export(module.exports, "getUiColumnLimits", () => $6a25cd9aef6b667c$export$e011995956f16fa6);
$parcel$export(module.exports, "getUiColumnLimitsModalOpen", () => $6a25cd9aef6b667c$export$6229c4dc5d2efe61);
$parcel$export(module.exports, "makeGetAllOtherColumnsSelector", () => $6a25cd9aef6b667c$export$ba1c28f70ced5ab2);
$parcel$export(module.exports, "hasDoneColumnInLastPositionSelector", () => $6a25cd9aef6b667c$export$6177e2dff5c71e5a);
$parcel$export(module.exports, "getDoneColumnsSelector", () => $6a25cd9aef6b667c$export$ce78defaaf63f45e);
$parcel$export(module.exports, "hasMultipleStatusesPerColumn", () => $6a25cd9aef6b667c$export$f851b13c9530ca04);
$parcel$export(module.exports, "hasMoreThanFiveColumn", () => $6a25cd9aef6b667c$export$f5665e99431cf4b7);
$parcel$export(module.exports, "hasMultipleDoneColumnSelector", () => $6a25cd9aef6b667c$export$9ad385df1369641f);
$parcel$export(module.exports, "firstGlobalTransitionIdForColumnWithProjectFilteringSelector", () => $6a25cd9aef6b667c$export$2b86311255d06539);
$parcel$export(module.exports, "getStatusIdsOfColumns", () => $6a25cd9aef6b667c$export$12d7e6f3168b0074);
$parcel$export(module.exports, "getStatusMapSelector", () => $6a25cd9aef6b667c$export$606f94fde0d9e9d1);

var $dGvGJ = parcelRequire("dGvGJ");

var $1sWm7 = parcelRequire("1sWm7");

var $9UgXz = parcelRequire("9UgXz");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $biBvi = parcelRequire("biBvi");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $1ShTS = parcelRequire("1ShTS");

var $67Z81 = parcelRequire("67Z81");

var $6VRfR = parcelRequire("6VRfR");
const $6a25cd9aef6b667c$export$2b76b0b5245526 = (column)=>column?.type === (0, $5rFbt.ColumnType).STATUS && column.statuses.some(({ isInitial: isInitial })=>isInitial);
const $6a25cd9aef6b667c$export$844d7708d71f3c7a = (column)=>column?.type === (0, $5rFbt.ColumnType).STATUS && column?.statuses.length >= 1 && column?.statuses.every(({ isDone: isDone })=>isDone);
const $6a25cd9aef6b667c$export$dd393610384faf93 = (column, totalOfIssues)=>column.type === (0, $5rFbt.ColumnType).STATUS && column.maxIssueCount !== null && totalOfIssues > column.maxIssueCount;
const $6a25cd9aef6b667c$export$af5417af3fd8a43e = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueCount, maxIssueCount, minIssueCount)=>{
    const lozenges = [];
    if (minIssueCount != null) lozenges.push({
        descriptor: (0, $6VRfR.default).minIssueCount,
        values: {
            count: String(minIssueCount)
        },
        type: 'minimum',
        busted: issueCount < minIssueCount,
        tooltip: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6VRfR.default).minIssueCountTooltipIssueTermRefresh : (0, $6VRfR.default).minIssueCountTooltip
    });
    if (maxIssueCount != null) lozenges.push({
        descriptor: (0, $6VRfR.default).maxIssueCount,
        values: {
            count: String(maxIssueCount)
        },
        type: 'maximum',
        busted: issueCount > maxIssueCount,
        tooltip: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $6VRfR.default).maxIssueCountTooltipIssueTermRefresh : (0, $6VRfR.default).maxIssueCountTooltip
    });
    return lozenges;
}, (issueCount, maxIssueCount, minIssueCount)=>`${maxIssueCount}::${minIssueCount}::${issueCount}`);
const $6a25cd9aef6b667c$export$f9a77580ef71cadc = (column)=>column.type === (0, $5rFbt.ColumnType).STATUS ? column : null;
const $6a25cd9aef6b667c$export$19642b3ccdd58d52 = (state, columnId)=>(0, $67Z81.getOrderedColumnIds)(state).indexOf(columnId);
const $6a25cd9aef6b667c$export$e509b4c22370e953 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedColumnIds)
], (columnIds)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>columnIds.indexOf(columnId) === columnIds.length - 1));
const $6a25cd9aef6b667c$export$978e30a0fb8610d8 = (state)=>(0, $67Z81.getEntities)(state).columns;
const $6a25cd9aef6b667c$export$e85f3ae1437b5b1e = (state, columnId)=>$6a25cd9aef6b667c$export$978e30a0fb8610d8(state)[String(columnId)];
const $6a25cd9aef6b667c$export$8cca2eac80b2d07b = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Number((0, (/*@__PURE__*/$parcel$interopDefault($9UgXz)))(columns, $6a25cd9aef6b667c$export$2b76b0b5245526)));
const $6a25cd9aef6b667c$export$8e38f35aef868f9 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8,
    $6a25cd9aef6b667c$export$8cca2eac80b2d07b
], (columns, initialColumId)=>columns[String(initialColumId)]);
const $6a25cd9aef6b667c$export$52746a4a3c64914 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Number((0, (/*@__PURE__*/$parcel$interopDefault($9UgXz)))(columns, $6a25cd9aef6b667c$export$844d7708d71f3c7a)));
const $6a25cd9aef6b667c$export$90275f6847b087c6 = (state)=>(columnId)=>$6a25cd9aef6b667c$export$f9a77580ef71cadc($6a25cd9aef6b667c$export$978e30a0fb8610d8(state)[String(columnId)])?.statuses ?? [];
const $6a25cd9aef6b667c$export$fdfafe8417f25b23 = (state)=>(columnId, statusInColumnId)=>$6a25cd9aef6b667c$export$90275f6847b087c6(state)(columnId).find((status)=>status.id === statusInColumnId)?.category ?? 'UNDEFINED';
const $6a25cd9aef6b667c$export$227bd920fba16fc9 = (state)=>(columnId)=>$6a25cd9aef6b667c$export$90275f6847b087c6(state)(columnId).map(({ id: id })=>id);
const $6a25cd9aef6b667c$export$202ea9e4e5534381 = (state, columnId)=>$6a25cd9aef6b667c$export$978e30a0fb8610d8(state)[String(columnId)].name;
const $6a25cd9aef6b667c$export$d387fce3079a165a = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8,
    (0, (/*@__PURE__*/$parcel$interopDefault($biBvi)))(1)
], (columns, statusId)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(columns, (column)=>$6a25cd9aef6b667c$export$f9a77580ef71cadc(column)?.statuses.some((status)=>status.id === statusId) ?? false));
const $6a25cd9aef6b667c$export$797a3f448cda3e3a = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8,
    (0, $67Z81.getOrderedColumnIds)
], (columns, columnIds)=>columnIds.map((columnId)=>columns[String(columnId)]));
const $6a25cd9aef6b667c$export$3133db18f9e069b6 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$797a3f448cda3e3a
], (columns)=>{
    const mapping = {};
    columns.forEach((column)=>{
        mapping[column.id] = {
            isInitial: $6a25cd9aef6b667c$export$2b76b0b5245526(column),
            isDone: $6a25cd9aef6b667c$export$844d7708d71f3c7a(column)
        };
    });
    return mapping;
});
const $6a25cd9aef6b667c$var$isNotItSelfAndHasValidId = (entity, id)=>entity.id !== id && entity.id > 0;
const $6a25cd9aef6b667c$var$hasSameName = (entity, name)=>entity.name.toLowerCase() === name.toLowerCase();
const $6a25cd9aef6b667c$export$4c08b6f17508bf74 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedColumnIds),
    $6a25cd9aef6b667c$export$3133db18f9e069b6
], (columnIds, statusMapping)=>columnIds.some((id)=>statusMapping[id].isDone));
const $6a25cd9aef6b667c$export$5e7d90f7b0706af = (0, $dGvGJ.createSelector)($6a25cd9aef6b667c$export$3133db18f9e069b6, (columnStatusMapping)=>{
    const getIsDoneColumn = (columnId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(columnStatusMapping, [
            String(columnId),
            'isDone'
        ], false);
    return getIsDoneColumn;
});
const $6a25cd9aef6b667c$export$ec52759a7c6325ea = (columns, id, name)=>columns.filter((column)=>$6a25cd9aef6b667c$var$isNotItSelfAndHasValidId(column, id)).some((column)=>$6a25cd9aef6b667c$var$hasSameName(column, name) || $6a25cd9aef6b667c$export$f9a77580ef71cadc(column)?.statuses.some((status)=>$6a25cd9aef6b667c$var$hasSameName(status, name)));
const $6a25cd9aef6b667c$export$54e158f99bd87a8c = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$797a3f448cda3e3a
], (columns)=>{
    const makeValidateColumn = (columnId, columnName)=>{
        if ($6a25cd9aef6b667c$export$ec52759a7c6325ea(columns, columnId, columnName)) return {
            isValid: false,
            message: {
                title: (0, $6VRfR.default).nameIsTakenTitle,
                description: (0, $6VRfR.default).nameIsTakenDescription
            }
        };
        return {
            isValid: true,
            message: null
        };
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeValidateColumn, (columnId, columnName)=>`${columnId}:${columnName}`);
});
const $6a25cd9aef6b667c$export$5473fcc76aa5870d = (0, $dGvGJ.createSelector)($6a25cd9aef6b667c$export$797a3f448cda3e3a, (columns)=>columns.some((column)=>column.type === (0, $5rFbt.ColumnType).STATUS && column.maxIssueCount !== null && column.maxIssueCount >= 0));
const $6a25cd9aef6b667c$export$bade1fd14989df4 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$797a3f448cda3e3a
], (columns)=>{
    const makeClosestColumn = (columnId)=>{
        const index = columns.findIndex((column)=>column.id === columnId);
        if (index === -1 || columns.length === 1) return null;
        const isFirstColumn = index === 0;
        if (isFirstColumn) {
            const nextColumn = columns[index + 1];
            return nextColumn;
        }
        const prevColumn = columns[index - 1];
        return prevColumn;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeClosestColumn);
});
const $6a25cd9aef6b667c$export$e011995956f16fa6 = (state)=>(0, $67Z81.getUi)(state).columnLimits ?? {
        isOpen: false
    };
const $6a25cd9aef6b667c$export$6229c4dc5d2efe61 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$e011995956f16fa6
], (columnLimits)=>columnLimits.isOpen);
const $6a25cd9aef6b667c$export$ba1c28f70ced5ab2 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8,
    (0, $67Z81.getOrderedColumnIds)
], (columns, columnIds)=>{
    const makeGetAllOtherColumns = (columnId)=>columnIds.filter((id)=>id !== columnId).map((id)=>columns[String(id)]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeGetAllOtherColumns);
});
const $6a25cd9aef6b667c$export$6177e2dff5c71e5a = (0, $dGvGJ.createSelector)($6a25cd9aef6b667c$export$797a3f448cda3e3a, (columns)=>columns[columns.length - 1] ? $6a25cd9aef6b667c$export$844d7708d71f3c7a(columns[columns.length - 1]) : false);
const $6a25cd9aef6b667c$export$ce78defaaf63f45e = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$797a3f448cda3e3a
], (columns)=>columns.filter((column)=>$6a25cd9aef6b667c$export$844d7708d71f3c7a(column)));
const $6a25cd9aef6b667c$export$f851b13c9530ca04 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Object.keys(columns).some((columnId)=>{
        const column = columns[columnId];
        return column.type === (0, $5rFbt.ColumnType).STATUS && column.statuses.length > 1;
    }));
const $6a25cd9aef6b667c$export$f5665e99431cf4b7 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Object.keys(columns).length > 5);
const $6a25cd9aef6b667c$export$9ad385df1369641f = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$ce78defaaf63f45e
], (columns)=>columns.length > 1);
const $6a25cd9aef6b667c$export$2b86311255d06539 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    (0, $67Z81.getIssueProjects)
], (cardTransitions, issueProjects)=>(columnId, issue)=>{
        const transitionsForColumn = cardTransitions.columnIssueTypeTransitions[String(columnId)];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionsForColumn) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionsForColumn[String(issue?.typeId)])) return null;
        // TMP issues don't have a project id/key so we just get whatever
        const issueMissingProjectId = !issue.projectId;
        const projectKey = issue ? Object.values(issueProjects).find((project)=>project.id === issue.projectId)?.key : null;
        // TMP transitions have project keys populated dynamically but we can't show TMP issues on a
        // CMP board so if its a TMP issue, just grab ANY of the global transitions because we
        // know that TMP can't have duplicates like CMP.
        const transition = transitionsForColumn[String(issue.typeId)].find((t)=>(issueMissingProjectId || t.projectKey === projectKey) && t.isGlobal && !t.isInitial);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transition) ? transition.id : null;
    });
const $6a25cd9aef6b667c$export$12d7e6f3168b0074 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Object.keys(columns).flatMap((columnId)=>$6a25cd9aef6b667c$export$f9a77580ef71cadc(columns[columnId])?.statuses ?? []).map((status)=>status.id));
const $6a25cd9aef6b667c$export$729d92c1e0c9db28 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>Object.values(columns).filter((column)=>$6a25cd9aef6b667c$export$f9a77580ef71cadc(column)?.statuses.some((status)=>status.category && status.category.toUpperCase() === 'DONE')));
const $6a25cd9aef6b667c$export$606f94fde0d9e9d1 = (0, $dGvGJ.createSelector)([
    $6a25cd9aef6b667c$export$978e30a0fb8610d8
], (columns)=>(0, $1ShTS.entityArrayToMap)(Object.keys(columns).flatMap((columnId)=>$6a25cd9aef6b667c$export$f9a77580ef71cadc(columns[columnId])?.statuses ?? [])));

});
parcelRegister("1sWm7", function(module, exports) {

var $bptzf = parcelRequire("bptzf");

var $fW7cr = parcelRequire("fW7cr");
/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */ var $1115ac3ae60cc7bc$var$find = $bptzf($fW7cr);
module.exports = $1115ac3ae60cc7bc$var$find;

});
parcelRegister("fW7cr", function(module, exports) {

var $b5dwA = parcelRequire("b5dwA");

var $bxDef = parcelRequire("bxDef");

var $kPZpS = parcelRequire("kPZpS");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b9a1db7d7901532f$var$nativeMax = Math.max;
/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */ function $b9a1db7d7901532f$var$findIndex(array, predicate, fromIndex) {
    var length = array == null ? 0 : array.length;
    if (!length) return -1;
    var index = fromIndex == null ? 0 : $kPZpS(fromIndex);
    if (index < 0) index = $b9a1db7d7901532f$var$nativeMax(length + index, 0);
    return $b5dwA(array, $bxDef(predicate, 3), index);
}
module.exports = $b9a1db7d7901532f$var$findIndex;

});


parcelRegister("9UgXz", function(module, exports) {

var $fR2dZ = parcelRequire("fR2dZ");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * This method is like `_.find` except that it returns the key of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Object
 * @param {Object} object The object to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {string|undefined} Returns the key of the matched element,
 *  else `undefined`.
 * @example
 *
 * var users = {
 *   'barney':  { 'age': 36, 'active': true },
 *   'fred':    { 'age': 40, 'active': false },
 *   'pebbles': { 'age': 1,  'active': true }
 * };
 *
 * _.findKey(users, function(o) { return o.age < 40; });
 * // => 'barney' (iteration order is not guaranteed)
 *
 * // The `_.matches` iteratee shorthand.
 * _.findKey(users, { 'age': 1, 'active': true });
 * // => 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findKey(users, ['active', false]);
 * // => 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.findKey(users, 'active');
 * // => 'barney'
 */ function $73667fdf8c12f2c8$var$findKey(object, predicate) {
    return $fR2dZ(object, $bxDef(predicate, 3), $hDnyx);
}
module.exports = $73667fdf8c12f2c8$var$findKey;

});
parcelRegister("fR2dZ", function(module, exports) {
/**
 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
 * without support for iteratee shorthands, which iterates over `collection`
 * using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the found element or its key, else `undefined`.
 */ function $b8ad880aaae778a0$var$baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function(value, key, collection) {
        if (predicate(value, key, collection)) {
            result = key;
            return false;
        }
    });
    return result;
}
module.exports = $b8ad880aaae778a0$var$baseFindKey;

});


parcelRegister("biBvi", function(module, exports) {

var $l0M9G = parcelRequire("l0M9G");

var $g7i7g = parcelRequire("g7i7g");

var $kPZpS = parcelRequire("kPZpS");
/**
 * Creates a function that gets the argument at index `n`. If `n` is negative,
 * the nth argument from the end is returned.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {number} [n=0] The index of the argument to return.
 * @returns {Function} Returns the new pass-thru function.
 * @example
 *
 * var func = _.nthArg(1);
 * func('a', 'b', 'c', 'd');
 * // => 'b'
 *
 * var func = _.nthArg(-2);
 * func('a', 'b', 'c', 'd');
 * // => 'c'
 */ function $839e77a0b37b78b8$var$nthArg(n) {
    n = $kPZpS(n);
    return $g7i7g(function(args) {
        return $l0M9G(args, n);
    });
}
module.exports = $839e77a0b37b78b8$var$nthArg;

});
parcelRegister("l0M9G", function(module, exports) {

var $e8U1z = parcelRequire("e8U1z");
/**
 * The base implementation of `_.nth` which doesn't coerce arguments.
 *
 * @private
 * @param {Array} array The array to query.
 * @param {number} n The index of the element to return.
 * @returns {*} Returns the nth element of `array`.
 */ function $f4bef3b14fc69d11$var$baseNth(array, n) {
    var length = array.length;
    if (!length) return;
    n += n < 0 ? length : 0;
    return $e8U1z(n, length) ? array[n] : undefined;
}
module.exports = $f4bef3b14fc69d11$var$baseNth;

});


parcelRegister("1ShTS", function(module, exports) {

$parcel$export(module.exports, "entityArrayToMap", () => $434b748ab03c045f$export$5de9d608b9fa8851);
const $434b748ab03c045f$export$5de9d608b9fa8851 = (entities)=>{
    const result = {};
    entities.forEach((entity)=>{
        result[String(entity.id)] = entity;
    });
    return result;
};

});

parcelRegister("6VRfR", function(module, exports) {

$parcel$export(module.exports, "default", () => $fca6f21418cf0d40$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fca6f21418cf0d40$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    nameIsTakenTitle: {
        "id": "software.main.state.selectors.column.name-is-taken-title",
        "defaultMessage": "The name \u2018{name}\u2019 is already being used on this board"
    },
    nameIsTakenDescription: {
        "id": "software.main.state.selectors.column.name-is-taken-description",
        "defaultMessage": "You\u2019ll need to give your column a unique name. Trust us - it\u2019ll be less confusing this way"
    },
    minIssueCount: {
        "id": "software.main.state.selectors.column.min-issue-count",
        "defaultMessage": "MIN: {count}"
    },
    minIssueCountTooltip: {
        "id": "software.main.state.selectors.column.min-issue-count-tooltip",
        "defaultMessage": "This column will be highlighted when the number of issues is under this limit"
    },
    maxIssueCount: {
        "id": "software.main.state.selectors.column.max-issue-count",
        "defaultMessage": "MAX: {count}"
    },
    maxIssueCountTooltip: {
        "id": "software.main.state.selectors.column.max-issue-count-tooltip",
        "defaultMessage": "This column will be highlighted when the number of issues exceeds this limit"
    },
    minIssueCountTooltipIssueTermRefresh: {
        "id": "software.main.state.selectors.column.min-issue-count-tooltip-issue-term-refresh",
        "defaultMessage": "This column will be highlighted when the number of work items is under this limit"
    },
    maxIssueCountTooltipIssueTermRefresh: {
        "id": "software.main.state.selectors.column.max-issue-count-tooltip-issue-term-refresh",
        "defaultMessage": "This column will be highlighted when the number of work items exceeds this limit"
    }
});

});


parcelRegister("cPGP0", function(module, exports) {

$parcel$export(module.exports, "getTeams", () => $6832ab781e992eca$export$5a622455e94bac3);
$parcel$export(module.exports, "getTeamById", () => $6832ab781e992eca$export$5dcc6aff8319c1fe);
$parcel$export(module.exports, "getTeamSprintsForIterations", () => $6832ab781e992eca$export$9c3564d047dbecae);
$parcel$export(module.exports, "getSprintCapacityInfo", () => $6832ab781e992eca$export$f54f23fd5351ffad);
$parcel$export(module.exports, "getOverlappedSprintPerTeam", () => $6832ab781e992eca$export$90bff6a70efe7be5);
$parcel$export(module.exports, "getIterationCapacityInfo", () => $6832ab781e992eca$export$aa4cf32120268e72);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $g4tDr = parcelRequire("g4tDr");

var $4jAPy = parcelRequire("4jAPy");

var $3spCR = parcelRequire("3spCR");

var $4R6GH = parcelRequire("4R6GH");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");
const $6832ab781e992eca$export$5a622455e94bac3 = (state)=>(0, $67Z81.getEntities)(state).teams;
const $6832ab781e992eca$export$5dcc6aff8319c1fe = (0, $dGvGJ.createSelector)($6832ab781e992eca$export$5a622455e94bac3, (teams)=>{
    const getTeamByIdInner = (teamId)=>teams[teamId];
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getTeamByIdInner);
});
const $6832ab781e992eca$export$9c3564d047dbecae = (state, teamId)=>{
    const teams = $6832ab781e992eca$export$5a622455e94bac3(state);
    if (!teamId || !teams[teamId]) return null;
    return teams[teamId].sprintByIterationId || null;
};
const $6832ab781e992eca$var$getUsedCapacityPerSprint = (0, $dGvGJ.createSelector)((0, $67Z81.getIssues), (0, $67Z81.getProjectIssueTypes), (issues, projectIssueTypes)=>{
    let usedCapacityInfoPerSprint = {};
    const updateCapacity = (currentCapacityInfo, teamId, sprintId, issue, isDone)=>{
        const usedCapacity = (0, $7uUwQ.getIn)(currentCapacityInfo, [
            teamId,
            sprintId,
            'total'
        ]) || 0;
        const doneCapacity = (0, $7uUwQ.getIn)(currentCapacityInfo, [
            teamId,
            sprintId,
            'done'
        ]) || 0;
        let updatedCapacityInfo = (0, $7uUwQ.setIn)(currentCapacityInfo, [
            teamId,
            sprintId,
            'total'
        ], Number(usedCapacity) + (Number(issue.estimate?.value) || 0));
        if (isDone) updatedCapacityInfo = (0, $7uUwQ.setIn)(updatedCapacityInfo, [
            teamId,
            sprintId,
            'done'
        ], Number(doneCapacity) + (Number(issue.estimate?.value) || 0));
        return updatedCapacityInfo;
    };
    Object.values(issues).forEach((issue)=>{
        const { teamId: teamId, sprintId: sprintId, typeId: typeId, isDone: isDone, orderedCompletedSprintIds: orderedCompletedSprintIds } = issue;
        // if it is epic level, skip it
        const isEpicLevel = projectIssueTypes[typeId].hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
        if (!isEpicLevel && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(teamId) && (0, $4R6GH.fg)('update_sp_calculation_to_include_completed_sprints')) {
            // If issue has an assigned sprint Id
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sprintId) && sprintId !== '') usedCapacityInfoPerSprint = updateCapacity(usedCapacityInfoPerSprint, teamId, sprintId, issue, isDone);
            // If issue was done in a completed sprint and has no sprintId assigned
            if (isDone && ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sprintId) || sprintId === '') && orderedCompletedSprintIds && orderedCompletedSprintIds.length > 0) usedCapacityInfoPerSprint = updateCapacity(usedCapacityInfoPerSprint, teamId, orderedCompletedSprintIds[0], issue, isDone);
        }
        // Remove if statement and code inside when update_sp_calculation_to_include_completed_sprints is cleaned up
        if (!isEpicLevel && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(teamId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sprintId) && sprintId !== '' && !(0, $4R6GH.fg)('update_sp_calculation_to_include_completed_sprints')) {
            const usedCapacity = (0, $7uUwQ.getIn)(usedCapacityInfoPerSprint, [
                teamId,
                sprintId,
                'total'
            ]) || 0;
            const doneCapacity = (0, $7uUwQ.getIn)(usedCapacityInfoPerSprint, [
                teamId,
                sprintId,
                'done'
            ]) || 0;
            usedCapacityInfoPerSprint = (0, $7uUwQ.setIn)(usedCapacityInfoPerSprint, [
                teamId,
                sprintId,
                'total'
            ], Number(usedCapacity) + Number(issue.estimate?.value) || 0);
            if (isDone) usedCapacityInfoPerSprint = (0, $7uUwQ.setIn)(usedCapacityInfoPerSprint, [
                teamId,
                sprintId,
                'done'
            ], Number(doneCapacity) + Number(issue.estimate?.value) || 0);
        }
    });
    return usedCapacityInfoPerSprint;
});
const $6832ab781e992eca$export$f54f23fd5351ffad = (0, $dGvGJ.createSelector)([
    $6832ab781e992eca$export$5a622455e94bac3,
    $6832ab781e992eca$var$getUsedCapacityPerSprint
], (teams, usedCapacityInfoPerSprint)=>{
    let sprintCapacityInfoPerSprint = {};
    Object.values(teams).forEach((team)=>{
        const { id: teamId, capacity: defaultCapacity, capacityBySprintId: capacityBySprintId, sprintByIterationId: sprintByIterationId } = team;
        const sprintIds = sprintByIterationId ? Object.values(sprintByIterationId).map((sprint)=>`${sprint.id}`) : [];
        sprintIds.forEach((sprintId)=>{
            sprintCapacityInfoPerSprint = (0, $7uUwQ.setIn)(sprintCapacityInfoPerSprint, [
                teamId,
                sprintId
            ], {
                defaultCapacity: defaultCapacity,
                usedCapacity: (0, $7uUwQ.getIn)(usedCapacityInfoPerSprint, [
                    teamId,
                    sprintId,
                    'total'
                ]) || 0,
                doneCapacity: (0, $7uUwQ.getIn)(usedCapacityInfoPerSprint, [
                    teamId,
                    sprintId,
                    'done'
                ]) || 0,
                totalCapacity: capacityBySprintId?.[Number(sprintId)]?.capacity ?? null,
                itemKey: capacityBySprintId?.[Number(sprintId)]?.itemKey ?? undefined
            });
        });
    });
    return sprintCapacityInfoPerSprint;
});
const $6832ab781e992eca$export$f6d30755cc17452 = (sprintA, sprintB)=>{
    let startDateA = sprintA.startDate;
    let endDateA = sprintA.state === (0, $3spCR.SPRINT_STATES).CLOSED ? sprintA.completedDate : sprintA.endDate;
    let startDateB = sprintB.startDate;
    let endDateB = sprintB.state === (0, $3spCR.SPRINT_STATES).CLOSED ? sprintB.completedDate : sprintB.endDate;
    // if one of sprint doesn't have start and end date, they are not overlapped.
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateA) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateA) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateB) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateB)) return undefined;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateA) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateB)) endDateA = Number.POSITIVE_INFINITY;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateA) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateB)) endDateB = Number.POSITIVE_INFINITY;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateA) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateB)) startDateA = Number.NEGATIVE_INFINITY;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateA) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateB)) startDateB = Number.NEGATIVE_INFINITY;
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateA) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateA) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(startDateB) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(endDateB)) {
        const baseEndTime = Math.min(endDateB, endDateA);
        const baseStartTime = Math.max(startDateA, startDateB);
        const time = Math.abs(baseEndTime - baseStartTime);
        return {
            // if the time gap is less than 1 day, it is not overlapped
            isOverlapped: !(startDateB > endDateA || endDateB < startDateA) && time > 86400000,
            time: time
        };
    }
};
const $6832ab781e992eca$export$90bff6a70efe7be5 = (0, $dGvGJ.createSelector)($6832ab781e992eca$export$5a622455e94bac3, (teams)=>{
    let overlappedSprintInfo = {};
    Object.values(teams).forEach((team)=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(team.sprintByIterationId)) {
            const sprints = Object.values(team.sprintByIterationId);
            for(let i = 0; i < sprints.length; i++)for(let j = i + 1; j < sprints.length; j++){
                const isOverlappedResult = $6832ab781e992eca$export$f6d30755cc17452(sprints[i], sprints[j]);
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(isOverlappedResult) && isOverlappedResult.isOverlapped) {
                    overlappedSprintInfo = (0, $7uUwQ.setIn)(overlappedSprintInfo, [
                        team.id,
                        sprints[i].id
                    ], [
                        ...(0, $7uUwQ.getIn)(overlappedSprintInfo, [
                            team.id,
                            sprints[i].id
                        ]) || [],
                        {
                            sprintName: sprints[j].name,
                            time: isOverlappedResult.time
                        }
                    ]);
                    overlappedSprintInfo = (0, $7uUwQ.setIn)(overlappedSprintInfo, [
                        team.id,
                        sprints[j].id
                    ], [
                        ...(0, $7uUwQ.getIn)(overlappedSprintInfo, [
                            team.id,
                            sprints[j].id
                        ]) || [],
                        {
                            sprintName: sprints[i].name,
                            time: isOverlappedResult.time
                        }
                    ]);
                }
            }
        }
    });
    return overlappedSprintInfo;
});
const $6832ab781e992eca$var$getUsedCapacityPerIteration = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues),
    (0, $67Z81.getProjectIssueTypes)
], (issues, projectIssueTypes)=>{
    let usedCapacityInfoPerIteration = {};
    Object.values(issues).forEach((issue)=>{
        const { teamId: teamId, columnId: columnId, typeId: typeId } = issue;
        const team = teamId ?? (0, $4jAPy.SWIMLANE_TEAMLESS);
        // if it is epic, skip it
        const isEpicLevel = projectIssueTypes[typeId].hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
        if (!isEpicLevel && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(team) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnId)) {
            const usedCapacity = (0, $7uUwQ.getIn)(usedCapacityInfoPerIteration, [
                team,
                columnId
            ]) || 0;
            usedCapacityInfoPerIteration = (0, $7uUwQ.setIn)(usedCapacityInfoPerIteration, [
                team,
                columnId
            ], Number(usedCapacity) + Number(issue.estimate?.value) || 0);
        }
    });
    return usedCapacityInfoPerIteration;
});
const $6832ab781e992eca$export$aa4cf32120268e72 = (0, $dGvGJ.createSelector)([
    $6832ab781e992eca$export$5a622455e94bac3,
    $6832ab781e992eca$var$getUsedCapacityPerIteration,
    (0, $fyeGd.getColumns)
], (teams, usedCapacityInfoPerIteration, columns)=>{
    let capacityInfoPerIteration = {};
    [
        ...Object.values(teams),
        {
            id: (0, $4jAPy.SWIMLANE_TEAMLESS),
            capacity: null,
            capacityByIterationId: null
        }
    ].forEach((team)=>{
        const { id: teamId, capacity: defaultCapacity, capacityByIterationId: capacityByIterationId } = team;
        Object.keys(columns).forEach((iterationId)=>{
            capacityInfoPerIteration = (0, $7uUwQ.setIn)(capacityInfoPerIteration, [
                teamId,
                iterationId
            ], {
                defaultCapacity: defaultCapacity,
                usedCapacity: (0, $7uUwQ.getIn)(usedCapacityInfoPerIteration, [
                    teamId,
                    iterationId
                ]) || 0,
                totalCapacity: capacityByIterationId?.[Number(iterationId)]?.capacity ?? undefined
            });
        });
    });
    return capacityInfoPerIteration;
});

});


parcelRegister("4jZ56", function(module, exports) {

$parcel$export(module.exports, "swimlaneByTeamSelector", () => $839fb1eec13ba4e0$export$277f97a60fb97da1);
$parcel$export(module.exports, "getSwimlanes", () => $839fb1eec13ba4e0$export$612dc65e36d0eaf3);
$parcel$export(module.exports, "makeSwimlaneValuesSelector", () => $839fb1eec13ba4e0$export$42245eb297e9b819);
$parcel$export(module.exports, "isDefaultSwimlane", () => $839fb1eec13ba4e0$export$167f1fb297e78fe2);
$parcel$export(module.exports, "isInDefaultSwimlane", () => $839fb1eec13ba4e0$export$4def584ab131faf7);
$parcel$export(module.exports, "getCollapsedSwimlanes", () => $839fb1eec13ba4e0$export$676aff045298a75d);
$parcel$export(module.exports, "isSwimlaneCollapsed", () => $839fb1eec13ba4e0$export$90d7287d73f2112f);
$parcel$export(module.exports, "getIsSwimlaneCollapsed", () => $839fb1eec13ba4e0$export$37433a3d3d73dc9);
$parcel$export(module.exports, "makeIsSwimlaneCollapsed", () => $839fb1eec13ba4e0$export$9db3862b3df9c29d);
$parcel$export(module.exports, "isSwimlaneBySubtaskParentDoneSelector", () => $839fb1eec13ba4e0$export$13cce384be20a94b);
$parcel$export(module.exports, "areSwimlaneBySubtaskParentChildrenDoneSelector", () => $839fb1eec13ba4e0$export$32f30df65f500bd);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $3JOCw = parcelRequire("3JOCw");

var $g4tDr = parcelRequire("g4tDr");

var $4jAPy = parcelRequire("4jAPy");

var $4R6GH = parcelRequire("4R6GH");

var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");
const $839fb1eec13ba4e0$var$assigneeWithoutUnassignedSwimlanesSelector = (0, $dGvGJ.createSelector)([
    (0, $36pz7.getPeople),
    (0, $36pz7.getCurrentUserAccountId)
], (people, currentUserAccountId)=>Object.entries(people).map(([id, person])=>{
        const { id: assigneeId } = person;
        return {
            id: id,
            name: people[id].displayName,
            imageUrl: people[id].avatarUrl,
            values: {
                type: (0, $c79wa.ASSIGNEE),
                assigneeAccountId: assigneeId
            },
            issueKey: null
        };
    }).sort((a, b)=>{
        // Current user first and the rest of the users in alphabetical order
        if (a.id === currentUserAccountId) return -1;
        if (b.id === currentUserAccountId) return 1;
        return (a.name ?? '').localeCompare(b.name ?? '');
    }));
const $839fb1eec13ba4e0$export$1032e5fe171b1eb9 = (0, $dGvGJ.createSelector)([
    $839fb1eec13ba4e0$var$assigneeWithoutUnassignedSwimlanesSelector
], (assigneeSwimlanes)=>[
        ...assigneeSwimlanes,
        {
            ...(0, $c79wa.UnassignedSwimlane)
        }
    ]);
const $839fb1eec13ba4e0$export$b46208e06a990c41 = (0, $dGvGJ.createSelector)([
    $839fb1eec13ba4e0$var$assigneeWithoutUnassignedSwimlanesSelector
], (assigneeSwimlanes)=>[
        {
            ...(0, $c79wa.UnassignedSwimlane)
        },
        ...assigneeSwimlanes
    ]);
const $839fb1eec13ba4e0$var$swimlanesParentIssueSelector = (0, $dGvGJ.createSelector)([
    (0, $bSSdD.issueParentsSelector),
    (0, $67Z81.getIsCMPBoard)
], (issueParents, isCMPBoard)=>issueParents.filter((issue)=>issue.issueType.hierarchyLevel ? issue.issueType.hierarchyLevel === (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC) : true).map((issue)=>({
            id: String(issue.id),
            name: issue.summary,
            imageUrl: issue.issueType.iconUrl,
            values: {
                type: (0, $c79wa.PARENT),
                parentId: issue.id
            },
            issueKey: issue.key,
            isFlagged: isCMPBoard ? issue.flagged : undefined
        })).concat([
        {
            ...(0, $c79wa.ParentlessSwimlane)
        }
    ]));
const $839fb1eec13ba4e0$var$swimlanesIssueChildrenSelector = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.orderedIssuesWithSubtasksSelector)
], (issuesWithSubtasks)=>issuesWithSubtasks.map((issue)=>({
            id: String(issue.id),
            name: issue.summary,
            imageUrl: issue.typeUrl,
            values: {
                type: (0, $c79wa.STORY),
                parentId: issue.id
            },
            issueKey: issue.key,
            parentId: issue.parentId,
            assigneeAccountId: issue.assigneeAccountId,
            isFlagged: issue.isFlagged
        })).concat([
        {
            ...(0, $c79wa.ChildlessSwimlane)
        }
    ]));
const $839fb1eec13ba4e0$export$e468fcb20c90508 = (state)=>(0, $67Z81.getEntities)(state).jqlSwimlanes?.swimlanes.map((swimlane)=>({
            id: swimlane.id,
            name: swimlane.name,
            imageUrl: '',
            issueKey: null,
            values: {
                type: (0, $c79wa.JQL),
                issueIds: swimlane.issueIds
            }
        })) ?? [];
const $839fb1eec13ba4e0$export$d94a0a1f910ed9a6 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjects)
], (issueProjects)=>Object.values(issueProjects).map(({ id: id, name: name, key: key, avatar: avatar })=>{
        const url = avatar ? new URL(avatar) : undefined;
        url?.searchParams.set('size', 'xsmall');
        return {
            id: String(id),
            name: name,
            imageUrl: url?.toString(),
            issueKey: null,
            projectKey: key,
            values: {
                type: (0, $c79wa.PROJECT),
                projectId: id
            }
        };
    }).sort((a, b)=>a.projectKey.localeCompare(b.projectKey)));
const $839fb1eec13ba4e0$export$277f97a60fb97da1 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getTeams)
], (teams)=>{
    const swimlanes = Object.values(teams).map(({ id: id, name: name, isPlanTeam: isPlanTeam, externalId: externalId, avatarUrl: avatarUrl, planningStyle: planningStyle, verified: verified })=>({
            id: id,
            name: name,
            imageUrl: avatarUrl || undefined,
            issueKey: null,
            values: {
                type: (0, $4jAPy.TEAM),
                externalId: externalId,
                isPlanTeam: isPlanTeam,
                planningStyle: planningStyle,
                verified: (0, $4R6GH.fg)('plans_managed_teams_indicator_program_enabled') ? verified : false
            }
        })).sort((a, b)=>a.name.localeCompare(b.name));
    return [
        ...swimlanes,
        (0, $c79wa.TeamlessSwimlane)
    ];
});
const $839fb1eec13ba4e0$export$5e292a752aac9b8f = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getRequestTypes)
], (issues, requestTypes)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(requestTypes)) return [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(Object.keys(issues).filter((key)=>{
        const issue = issues[key];
        return !!(issue.requestTypeId && requestTypes[issue.requestTypeId]);
    }).map((key)=>{
        const issue = issues[key];
        // requestTypeId will always have a value, because we are filtering out issues without a request type
        const { id: id, name: name, iconUrl: iconUrl } = requestTypes[issue.requestTypeId ?? ''];
        return {
            id: id,
            name: name,
            imageUrl: iconUrl,
            values: {
                type: (0, $c79wa.REQUEST_TYPE),
                id: id
            },
            issueKey: null
        };
    }), 'id');
});
const $839fb1eec13ba4e0$export$b9dd5eba76fd821e = (0, $dGvGJ.createSelector)([
    $839fb1eec13ba4e0$export$5e292a752aac9b8f
], (requestTypeSwimlanes)=>[
        ...requestTypeSwimlanes,
        {
            ...(0, $c79wa.UnassignedRequestTypeSwimlane)
        }
    ]);
const $839fb1eec13ba4e0$var$noSwimlanes = (0, $7uUwQ.freeze)([]);
const $839fb1eec13ba4e0$export$612dc65e36d0eaf3 = (state)=>{
    const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
    const adminConfiguredSwimlaneMode = (0, $45cXl.getAdminConfiguredSwimlaneMode)(state);
    const isIncrementalPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    if (swimlaneMode === (0, $iuuJH.NO_SWIMLANE).id) return $839fb1eec13ba4e0$var$noSwimlanes;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id && adminConfiguredSwimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id && (0, $4R6GH.fg)('respect_unassigned_swimlane_setting')) return $839fb1eec13ba4e0$export$b46208e06a990c41(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id) return $839fb1eec13ba4e0$export$1032e5fe171b1eb9(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) return $839fb1eec13ba4e0$var$swimlanesParentIssueSelector(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return $839fb1eec13ba4e0$var$swimlanesIssueChildrenSelector(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) return $839fb1eec13ba4e0$export$e468fcb20c90508(state);
    if ((0, $67Z81.getIsCMPBoard)(state) && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id) return $839fb1eec13ba4e0$export$d94a0a1f910ed9a6(state);
    if (isIncrementalPlanningBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_TEAM).id) return $839fb1eec13ba4e0$export$277f97a60fb97da1(state);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id) return $839fb1eec13ba4e0$export$b9dd5eba76fd821e(state);
    return $839fb1eec13ba4e0$var$noSwimlanes;
};
const $839fb1eec13ba4e0$export$42245eb297e9b819 = (0, $dGvGJ.createSelector)($839fb1eec13ba4e0$export$612dc65e36d0eaf3, (swimlanes)=>{
    const makeSwimlaneValues = (swimlaneId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(swimlanes.find((swimlane)=>swimlane.id === swimlaneId), [
            'values'
        ], null);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeSwimlaneValues);
});
const $839fb1eec13ba4e0$export$167f1fb297e78fe2 = (swimlaneId)=>swimlaneId === (0, $c79wa.UnassignedSwimlane).id || swimlaneId === (0, $c79wa.ParentlessSwimlane).id || swimlaneId === (0, $c79wa.ChildlessSwimlane).id;
const $839fb1eec13ba4e0$export$4def584ab131faf7 = (state)=>{
    const inDefaultSwimlaneCheck = (swimlaneId)=>{
        if (!swimlaneId) return false;
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) return swimlaneId === (0, $c79wa.UnassignedSwimlane).id;
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) return swimlaneId === (0, $c79wa.ParentlessSwimlane).id;
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return swimlaneId === (0, $c79wa.ChildlessSwimlane).id;
        return false;
    };
    return inDefaultSwimlaneCheck;
};
const $839fb1eec13ba4e0$export$676aff045298a75d = (state)=>(0, $67Z81.getUi)(state).swimlane.collapsed;
const $839fb1eec13ba4e0$export$90d7287d73f2112f = (state, swimlaneId)=>(0, $67Z81.getUi)(state).swimlane.collapsed.includes(swimlaneId);
const $839fb1eec13ba4e0$export$37433a3d3d73dc9 = (state)=>(swimlaneId)=>(0, $67Z81.getUi)(state).swimlane.collapsed.includes(swimlaneId);
const $839fb1eec13ba4e0$export$9db3862b3df9c29d = (0, $dGvGJ.createSelector)($839fb1eec13ba4e0$export$676aff045298a75d, (collapsedSwimlanes)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((swimlaneId)=>collapsedSwimlanes.includes(swimlaneId)));
const $839fb1eec13ba4e0$export$13cce384be20a94b = (0, $dGvGJ.createSelector)([
    (0, $d2i8f.isDoneIssueSelector),
    (0, $d2i8f.getIssueStatusSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getMissingParents)
], (isDoneIssue, getIssueStatus, swimlaneMode, isCMPBoard, missingParents)=>{
    const isSwimlaneBySubtaskParentDone = (issueId)=>{
        const missingParentIssue = missingParents[issueId];
        // In certain situations, an issue's `isDone` key isn't `true` even when the issue's status' category is done.
        // But the `/transitionAndRank` endpoint (which the swimlane "Move to Done" button calls) doesn't return enough info
        // to update issue state to the new status, so only the issue's `isDone` key is set to `true` when using that functionality.
        // Using a combination of both allows us to ensures the button is always hidden correctly when the issue might be done.
        const isDone = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(missingParentIssue) ? isDoneIssue(issueId) || getIssueStatus(issueId)?.category === 'DONE' : missingParentIssue.status.category === 'DONE';
        return swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && isCMPBoard && isDone;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(isSwimlaneBySubtaskParentDone);
});
const $839fb1eec13ba4e0$export$32f30df65f500bd = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIsCMPBoard),
    (0, $3UY9S.getChildrenOfParent),
    (0, $3UY9S.getIssueChildren)
], (swimlaneMode, isCMPBoard, getChildrenOfParent, issueChildren)=>{
    const areSwimlaneBySubtaskParentChildrenDone = (swimlaneValues)=>{
        const parentChildren = swimlaneValues?.type === (0, $c79wa.STORY) && swimlaneValues?.parentId ? getChildrenOfParent(swimlaneValues?.parentId) : [];
        return swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && isCMPBoard && parentChildren.length > 0 && parentChildren.every((childId)=>issueChildren[childId]?.isDone);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(areSwimlaneBySubtaskParentChildrenDone);
});
const $839fb1eec13ba4e0$export$b3f3cf27e378fcec = (0, $dGvGJ.createSelector)([
    $839fb1eec13ba4e0$export$277f97a60fb97da1
], (swimlanesByTeam)=>(swimlaneId)=>{
        const swimlane = swimlanesByTeam.filter((s)=>s.id === swimlaneId);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return swimlane.length > 0 && !swimlane[0].values?.isPlanTeam;
    });

});
parcelRegister("36pz7", function(module, exports) {

$parcel$export(module.exports, "getPeople", () => $7ae15d96adf6163b$export$b9c97d5330cbe844);
$parcel$export(module.exports, "getPerson", () => $7ae15d96adf6163b$export$1935eb9cdd85a29d);
$parcel$export(module.exports, "getCurrentUserAccountId", () => $7ae15d96adf6163b$export$4635f55bc9feebdb);
$parcel$export(module.exports, "getAssigneeAccountIds", () => $7ae15d96adf6163b$export$57f01d0afe40b3ba);

var $dGvGJ = parcelRequire("dGvGJ");


var $67Z81 = parcelRequire("67Z81");
const $7ae15d96adf6163b$export$b9c97d5330cbe844 = (state)=>(0, $67Z81.getEntities)(state).people;
const $7ae15d96adf6163b$export$1935eb9cdd85a29d = (state, id)=>$7ae15d96adf6163b$export$b9c97d5330cbe844(state)[id];
const $7ae15d96adf6163b$export$4635f55bc9feebdb = (state)=>state.configuration.userAccountId;
const $7ae15d96adf6163b$export$57f01d0afe40b3ba = (0, $dGvGJ.createSelector)([
    $7ae15d96adf6163b$export$b9c97d5330cbe844
], (assignees)=>{
    const accountIds = Object.keys(assignees);
    return [
        ...accountIds,
        (0, $15a528573ccd89ae$export$12e572fd459c10dc)
    ];
});

});
const $15a528573ccd89ae$export$d597759d33be802e = 'TEXT';
const $15a528573ccd89ae$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $15a528573ccd89ae$export$37aee82a3cb1e8f7 = 'LABEL';
const $15a528573ccd89ae$export$2a4f270075a033de = 'ISSUE_PARENT';
const $15a528573ccd89ae$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $15a528573ccd89ae$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $15a528573ccd89ae$export$a4ad2735b021c132 = 'VERSION';
const $15a528573ccd89ae$export$af1e30ebbae9df3b = 'COMPONENT';
const $15a528573ccd89ae$export$f863b019d19144f4 = 'STATUS_CATEGORY';
const $15a528573ccd89ae$export$a316570a0dbfd2b0 = 'SPRINT';
const $15a528573ccd89ae$export$e50006273435e7d4 = 'STATUS';
const $15a528573ccd89ae$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $15a528573ccd89ae$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $15a528573ccd89ae$export$1ea95b94fb0c51d9 = 'QUICK_FILTER';
const $15a528573ccd89ae$export$871e58afc769b358 = 'GOAL';
const $15a528573ccd89ae$export$6c4d37c7f376a1de = 'CLEAR';
const $15a528573ccd89ae$export$db362e2d293fe52e = 'DEPENDENCIES';
const $15a528573ccd89ae$export$dc9697aa7b3a6d6f = 'JQL';
const $15a528573ccd89ae$export$12e572fd459c10dc = 'unassigned';
const $15a528573ccd89ae$export$ac95b4b2317d4b33 = 'unassigned';
const $15a528573ccd89ae$export$81ef49afbbead0a1 = 'label unassigned';
const $15a528573ccd89ae$export$4b7c755e61199a36 = 'unassigned';
const $15a528573ccd89ae$export$c9408e3fb31ddc71 = 'offline';
const $15a528573ccd89ae$export$7a105aa475396c65 = 'online';




parcelRegister("5mTgl", function(module, exports) {

$parcel$export(module.exports, "isBoardConfigLoaded", () => $2007c62349361047$export$d49006793d041c52);
$parcel$export(module.exports, "isCurrentUserLoaded", () => $2007c62349361047$export$6b3694fe2dc20c31);
$parcel$export(module.exports, "getEstimationStatistic", () => $2007c62349361047$export$8dc27e15988a8928);
$parcel$export(module.exports, "hasAnyActiveOptimistic", () => $2007c62349361047$export$5c9c2a640adc17da);
$parcel$export(module.exports, "getWorkFilters", () => $2007c62349361047$export$bfbfdc2dda3d42ac);
$parcel$export(module.exports, "getSelectedCustomFilters", () => $2007c62349361047$export$d28b7e8638732900);
$parcel$export(module.exports, "getJqlFilter", () => $2007c62349361047$export$38eb06a328cb92f6);
$parcel$export(module.exports, "getAssigneeFilter", () => $2007c62349361047$export$9c158e12671c7642);
$parcel$export(module.exports, "getCustomFilters", () => $2007c62349361047$export$ada7918f4af738ad);
$parcel$export(module.exports, "isFilterOnCurrentUserOrUnassignedOnly", () => $2007c62349361047$export$7ad3b274acbd80a9);
$parcel$export(module.exports, "isFilterOnCurrentUserOnly", () => $2007c62349361047$export$c13d0e4be78b916c);
$parcel$export(module.exports, "isInlineColumnEditEnabled", () => $2007c62349361047$export$9682312c5ac76dea);
$parcel$export(module.exports, "isCardMediaEnabled", () => $2007c62349361047$export$d702c21e54b7d02);
$parcel$export(module.exports, "isCardMediaAvailable", () => $2007c62349361047$export$517314af7ddca56f);
$parcel$export(module.exports, "isReleasesFeatureEnabled", () => $2007c62349361047$export$d9ef39d66b89734f);
$parcel$export(module.exports, "boardColumnConstraintTypeSelector", () => $2007c62349361047$export$3892b6ff82249ef9);
$parcel$export(module.exports, "getNumberOfCardsWithCovers", () => $2007c62349361047$export$58f6e12eca9eaacb);
$parcel$export(module.exports, "getNumberOfCardsWithDueDates", () => $2007c62349361047$export$8983c3cdc7e8c1a5);
$parcel$export(module.exports, "getTimeTrackingOptions", () => $2007c62349361047$export$cb06173d4516a1bf);
$parcel$export(module.exports, "getIsAnyStatusInCreateEnabled", () => $2007c62349361047$export$509c01424b13a8d7);
$parcel$export(module.exports, "getColumnDeleteModalColumnId", () => $2007c62349361047$export$664aa5c36021df12);
$parcel$export(module.exports, "getColumnDeleteModalIsOpen", () => $2007c62349361047$export$c97bfeafd86d3880);
$parcel$export(module.exports, "isIssueDeleteModalOpen", () => $2007c62349361047$export$ecc8f72c94c5c10f);
$parcel$export(module.exports, "getIssueDeleteModalIssueId", () => $2007c62349361047$export$5a246c8ca4516a10);
$parcel$export(module.exports, "isLastRemainingColumn", () => $2007c62349361047$export$bfc0a3b2c66f2571);
$parcel$export(module.exports, "getBoardHasFilteredIssues", () => $2007c62349361047$export$6dd0ed6404bbbe1a);
$parcel$export(module.exports, "shouldRenderCardTypesSelector", () => $2007c62349361047$export$8950057b90a7be0);
$parcel$export(module.exports, "workColumnsSelector", () => $2007c62349361047$export$4ec9b51959de43e9);
$parcel$export(module.exports, "workIssuesSelector", () => $2007c62349361047$export$f496179039a6c96a);
$parcel$export(module.exports, "workIssuesCountSelector", () => $2007c62349361047$export$cc6af36a61576fbf);
$parcel$export(module.exports, "getColumnTotalIssuesCount", () => $2007c62349361047$export$42858dbfcc0ce9c6);
$parcel$export(module.exports, "getTeamSwimlaneColumnTotalIssuesCount", () => $2007c62349361047$export$45544dfa626588d1);
$parcel$export(module.exports, "getTeamSwimlaneColumnSprint", () => $2007c62349361047$export$1f985e0e5786e956);
$parcel$export(module.exports, "getIsUnscheduledColumnVisible", () => $2007c62349361047$export$6d5a132be16d7b29);
$parcel$export(module.exports, "unscheduledColumnSelector", () => $2007c62349361047$export$89d0463c0245d2f2);
$parcel$export(module.exports, "columnsWithResolutionSelector", () => $2007c62349361047$export$502e3142eedda17e);
$parcel$export(module.exports, "orderedWorkAssigneesByAccountIdSelector", () => $2007c62349361047$export$1bbbdcc3b9f74565);
$parcel$export(module.exports, "orderedWorkAssigneesAlphabeticallySelector", () => $2007c62349361047$export$7b365bd1ab5fa00b);
$parcel$export(module.exports, "doesColumnHaveIssuesSelector", () => $2007c62349361047$export$cf831ce22df95e40);
$parcel$export(module.exports, "hasIssuesNotOnBoard", () => $2007c62349361047$export$130d5e3f88c9116d);
$parcel$export(module.exports, "isFilteredCardsLoading", () => $2007c62349361047$export$eadf838276efbfae);
$parcel$export(module.exports, "isFilterRefinementEnabled", () => $2007c62349361047$export$4035471ff3de4fa3);
$parcel$export(module.exports, "isJqlFilterActive", () => $2007c62349361047$export$6f6b70ece7d0d0a8);
$parcel$export(module.exports, "workFilteredIssuesSelector", () => $2007c62349361047$export$83704ff797ee645e);
$parcel$export(module.exports, "getColumnIssuesCount", () => $2007c62349361047$export$bdcb688a64d33e13);
$parcel$export(module.exports, "platformIssueSelector", () => $2007c62349361047$export$c3eddeee4fff0c95);
$parcel$export(module.exports, "getEstimateExtendedByIssueId", () => $2007c62349361047$export$49400d4dee597710);
$parcel$export(module.exports, "platformIssueIdsBySwimlaneSelector", () => $2007c62349361047$export$8b37d0d4754c2222);
$parcel$export(module.exports, "swimlaneHeightsSelector", () => $2007c62349361047$export$c8eb34d22f45afc2);
$parcel$export(module.exports, "filtersForInlineCardCreateCountSelector", () => $2007c62349361047$export$2f80a678ff297046);
$parcel$export(module.exports, "hasWorkFiltersSelector", () => $2007c62349361047$export$a7e88415a097d4e1);
$parcel$export(module.exports, "hasCustomFiltersSelector", () => $2007c62349361047$export$100f6402dcbc1c5);
$parcel$export(module.exports, "platformHighlightScopeSelector", () => $2007c62349361047$export$18912e4e4d90673c);
$parcel$export(module.exports, "platformSwimlanesSelector", () => $2007c62349361047$export$25cdb7cc38e01f95);
$parcel$export(module.exports, "platformSwimlaneSelector", () => $2007c62349361047$export$547cddb5216fa288);
$parcel$export(module.exports, "platformSwimlaneIdsSelector", () => $2007c62349361047$export$258129f9697957ee);
$parcel$export(module.exports, "getFirstOpenSwimlaneIdSelector", () => $2007c62349361047$export$fe8e61f95247eb77);
$parcel$export(module.exports, "getColumnTheme", () => $2007c62349361047$export$f26c3b512bbb6d6d);
$parcel$export(module.exports, "isColumnUpdating", () => $2007c62349361047$export$b7de3298691c708c);
$parcel$export(module.exports, "isAnyColumnUpdating", () => $2007c62349361047$export$8b6be5e9a544d475);
$parcel$export(module.exports, "isCardDragDisabled", () => $2007c62349361047$export$a80f3c30adc36a1b);
$parcel$export(module.exports, "getCardDndType", () => $2007c62349361047$export$4b99acc1a687df2e);
$parcel$export(module.exports, "isDraggingSubtaskSelector", () => $2007c62349361047$export$1de4ece81cabd754);
$parcel$export(module.exports, "isSwimlaneTransitionZoneEnabledForSubtask", () => $2007c62349361047$export$9020a94481968b53);
$parcel$export(module.exports, "getAppliedIssueTypeFilters", () => $2007c62349361047$export$7ea0d3589e75ea3e);
$parcel$export(module.exports, "getLastFilteredIssueTypeId", () => $2007c62349361047$export$66fc4c808781b0dd);
$parcel$export(module.exports, "getLastFilteredProjectId", () => $2007c62349361047$export$b75a7d5a0b2593df);
$parcel$export(module.exports, "getHasAppliedEpicFilters", () => $2007c62349361047$export$717522cf1f80bfcb);
$parcel$export(module.exports, "getFixVersions", () => $2007c62349361047$export$bd7f9cded888ac1b);
$parcel$export(module.exports, "validFilterValuesSelector", () => $2007c62349361047$export$a3e606d31ce14076);
$parcel$export(module.exports, "hasInvalidFilterValuesSelector", () => $2007c62349361047$export$e5ce012c8ff94f67);
$parcel$export(module.exports, "getFilteredIssueIdsByColumn", () => $2007c62349361047$export$8da24954392d0b6b);
$parcel$export(module.exports, "getFilteredIssueKeysAsRapidViewMap", () => $2007c62349361047$export$76423ca425841ce3);
$parcel$export(module.exports, "getColumnIssuesCountWithLimit", () => $2007c62349361047$export$a3d88d5fd2477a5c);
$parcel$export(module.exports, "lastFilteredIssueParentIdSelector", () => $2007c62349361047$export$8fc92f4a10e91c3b);
$parcel$export(module.exports, "workDataWithDevStatusSelector", () => $2007c62349361047$export$6d848ac469f8f1d5);
$parcel$export(module.exports, "isIssueVisible", () => $2007c62349361047$export$fc04e99ac3563a66);
$parcel$export(module.exports, "getInvisibleIssueIdsFromClientSideFiltersOnly", () => $2007c62349361047$export$bacbd1cd61f6f690);
$parcel$export(module.exports, "getInvisibleIssueKeys", () => $2007c62349361047$export$675ae7d7d995e6cd);
$parcel$export(module.exports, "getActiveIssueWithIcc", () => $2007c62349361047$export$2c3764a24d5a77a5);
$parcel$export(module.exports, "isActiveCardSelector", () => $2007c62349361047$export$45f354b7131bf0a2);
$parcel$export(module.exports, "shouldRenderIcc", () => $2007c62349361047$export$1f1c155fbe31f55a);
$parcel$export(module.exports, "getIssuesIdsForColumn", () => $2007c62349361047$export$9c38ecda34a0899c);
$parcel$export(module.exports, "makeGetIssueEntriesForColumnSelector", () => $2007c62349361047$export$138c2389bbf22c2d);
$parcel$export(module.exports, "getIssuesEntriesWithIssueLinks", () => $2007c62349361047$export$82a7a8258a5a6f48);
$parcel$export(module.exports, "getIssuesEntriesWithIssueLinksInBoard", () => $2007c62349361047$export$d7699a71638fd9d4);
$parcel$export(module.exports, "getIssuesWithIssueLinksInBoardIds", () => $2007c62349361047$export$1e1a7e899f73dc6f);
$parcel$export(module.exports, "issueColumnIdSelector", () => $2007c62349361047$export$cc6f4dd9bb04ac0a);
$parcel$export(module.exports, "issueSwimlaneIdSelector", () => $2007c62349361047$export$db5d57ea014e1a9f);
$parcel$export(module.exports, "getStatusByIssueIdSelector", () => $2007c62349361047$export$5c4dc04d949c48c3);
$parcel$export(module.exports, "getActiveIssueKey", () => $2007c62349361047$export$98d29ba803e92a0e);
$parcel$export(module.exports, "makeGetIssueParentForSwimlaneHeader", () => $2007c62349361047$export$78a44af01b2680d);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hm7zS = parcelRequire("hm7zS");

var $k8IPx = parcelRequire("k8IPx");

var $9XE6b = parcelRequire("9XE6b");

var $fn8B5 = parcelRequire("fn8B5");

var $4wVpT = parcelRequire("4wVpT");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $4Xk2W = parcelRequire("4Xk2W");

var $hYfgW = parcelRequire("hYfgW");

var $dPSWJ = parcelRequire("dPSWJ");

var $gJBT6 = parcelRequire("gJBT6");

var $4f8Oj = parcelRequire("4f8Oj");

var $kGsr8 = parcelRequire("kGsr8");

var $8QpSo = parcelRequire("8QpSo");

var $5rFbt = parcelRequire("5rFbt");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $kIDH3 = parcelRequire("kIDH3");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $g5X3G = parcelRequire("g5X3G");

var $3eGwD = parcelRequire("3eGwD");


var $6s1PB = parcelRequire("6s1PB");

var $2xFXk = parcelRequire("2xFXk");

var $esu6n = parcelRequire("esu6n");



var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $bwTbl = parcelRequire("bwTbl");

var $kc6Ry = parcelRequire("kc6Ry");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $idNc7 = parcelRequire("idNc7");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $vAfHD = parcelRequire("vAfHD");

var $iGIww = parcelRequire("iGIww");

var $2VkyK = parcelRequire("2VkyK");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $6ALx6 = parcelRequire("6ALx6");
const $2007c62349361047$export$d49006793d041c52 = (state)=>(0, $67Z81.getBoardEntity)(state).isConfigLoaded;
const $2007c62349361047$export$6b3694fe2dc20c31 = (state)=>(0, $67Z81.getBoardEntity)(state).isCurrentUserLoaded;
const $2007c62349361047$export$8dc27e15988a8928 = (state)=>(0, $67Z81.getEntities)(state).estimationStatistic;
const $2007c62349361047$export$5c9c2a640adc17da = (state)=>{
    const beforeState = state.entities && state.entities.beforeState;
    return beforeState !== undefined;
};
const $2007c62349361047$export$7b4d448d658d5a3b = (state)=>(0, $67Z81.getUi)(state).columns;
const $2007c62349361047$export$bfbfdc2dda3d42ac = (state)=>(0, $67Z81.getUi)(state).workFilters ?? {
        values: {}
    };
const $2007c62349361047$export$d28b7e8638732900 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (workFilters)=>workFilters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866]);
const $2007c62349361047$export$38eb06a328cb92f6 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (workFilters)=>workFilters.values[0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f]);
const $2007c62349361047$export$9c158e12671c7642 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (workFilters)=>workFilters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]);
const $2007c62349361047$export$ada7918f4af738ad = (state)=>(0, $67Z81.getEntities)(state).customFilters.filters;
const $2007c62349361047$export$7ad3b274acbd80a9 = (state)=>{
    const assignees = $2007c62349361047$export$bfbfdc2dda3d42ac(state).values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb];
    if (!assignees) return false;
    if (assignees.length === 1 && (0, $36pz7.getCurrentUserAccountId)(state) === assignees[0]) return true;
    if (assignees.length === 2 && assignees.includes((0, $36pz7.getCurrentUserAccountId)(state)) && assignees.includes((0, $15a528573ccd89ae$export$12e572fd459c10dc))) return true;
    return false;
};
const $2007c62349361047$export$c13d0e4be78b916c = (state)=>{
    const assignees = $2007c62349361047$export$bfbfdc2dda3d42ac(state).values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb];
    return assignees && assignees.length === 1 && (0, $36pz7.getCurrentUserAccountId)(state) === assignees[0];
};
const $2007c62349361047$export$9682312c5ac76dea = (state)=>(0, $67Z81.getBoardConfig)(state).isInlineColumnEditEnabled && (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).INLINE_COLUMN_EDIT);
const $2007c62349361047$export$d702c21e54b7d02 = (state)=>(0, $67Z81.getBoardConfig)(state).isCardMediaEnabled || false;
const $2007c62349361047$export$517314af7ddca56f = (0, $dGvGJ.createSelector)([
    (0, $2VkyK.getIssuesMedia)
], (issueMedia)=>(0, $g5X3G.values)(issueMedia).some((media)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(media, [
            'isHiddenByUser'
        ]) === false));
const $2007c62349361047$export$d9ef39d66b89734f = (state)=>(0, $67Z81.getBoardConfig)(state).isReleasesFeatureEnabled === true;
const $2007c62349361047$export$3892b6ff82249ef9 = (state)=>(0, $67Z81.getBoardConfig)(state).columnConstraintType;
const $2007c62349361047$export$58f6e12eca9eaacb = (state)=>(0, $g5X3G.values)((0, $2VkyK.getIssuesMedia)(state)).filter((media)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(media, [
            'isHiddenByUser'
        ]) === false).length;
const $2007c62349361047$export$8983c3cdc7e8c1a5 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssues)
], (allIssues)=>(0, $g5X3G.values)(allIssues).filter((issue)=>Boolean(issue.dueDate)).length);
const $2007c62349361047$export$cb06173d4516a1bf = (state)=>(0, $67Z81.getBoardConfig)(state).timeTrackingOptions;
const $2007c62349361047$export$509c01424b13a8d7 = (state)=>(0, $67Z81.getBoardConfig)(state).isAnyStatusInCreateEnabled;
const $2007c62349361047$var$getUiColumn = (state)=>(0, $67Z81.getUi)(state).column;
const $2007c62349361047$var$getColumnDeleteModal = (state)=>$2007c62349361047$var$getUiColumn(state).deleteModal;
const $2007c62349361047$export$664aa5c36021df12 = (state)=>{
    const deleteModalState = $2007c62349361047$var$getColumnDeleteModal(state);
    return deleteModalState && 'columnId' in deleteModalState ? deleteModalState.columnId : undefined;
};
const $2007c62349361047$export$c97bfeafd86d3880 = (state)=>$2007c62349361047$var$getColumnDeleteModal(state).isOpen;
const $2007c62349361047$export$ecc8f72c94c5c10f = (state)=>Boolean((0, $67Z81.getUi)(state).issueDeleteModal?.isOpen);
const $2007c62349361047$export$5a246c8ca4516a10 = (state)=>(0, $67Z81.getUi)(state).issueDeleteModal?.issueId;
const $2007c62349361047$export$bfc0a3b2c66f2571 = (state)=>Object.keys((0, $67Z81.getEntities)(state).columns).length === 1;
const $2007c62349361047$export$6dd0ed6404bbbe1a = (state)=>(0, $67Z81.getBoardEntity)(state).hasFilteredIssues;
const $2007c62349361047$export$16eaaab637a3ff60 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueTypes)
], (issueTypes)=>Object.keys(issueTypes).map((id)=>issueTypes[id]));
const $2007c62349361047$export$8950057b90a7be0 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueTypes),
    (0, $4gt6L.issueChildrenTypesSelector)
], (issueTypes, issueChildrenTypes)=>Object.keys(issueTypes).length > 1 || issueChildrenTypes.length > 0);
const $2007c62349361047$export$4ec9b51959de43e9 = (0, $dGvGJ.createSelector)([
    (0, $fyeGd.getColumns),
    (0, $67Z81.getOrderedColumnIds)
], (columns, columnIds)=>columnIds.map((columnId)=>columns[String(columnId)]));
const $2007c62349361047$export$f496179039a6c96a = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $vAfHD.boardOrderedIssueIdsSelector)
], (issueEntities, boardIssuesIds)=>boardIssuesIds.map((id)=>issueEntities[String(id)]).filter(Boolean));
const $2007c62349361047$export$cc6af36a61576fbf = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$f496179039a6c96a
], (issues)=>issues?.length || 0);
const $2007c62349361047$export$9b1ea4b9173c2926 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4ec9b51959de43e9,
    $2007c62349361047$export$f496179039a6c96a,
    $2007c62349361047$export$3892b6ff82249ef9,
    (0, $3UY9S.getIssueChildren)
], (columns, issues, columnConstraintType, issueChildren)=>{
    const countMap = {};
    columns.forEach((column)=>{
        countMap[String(column.id)] = 0;
    });
    issues.forEach((issue)=>{
        if (columnConstraintType === 'ISSUE_COUNT_EXCLUDE_SUBTASKS' && issue.id in issueChildren) return;
        countMap[String(issue.columnId)] += 1;
    });
    return countMap;
});
const $2007c62349361047$export$42858dbfcc0ce9c6 = (state, columnId)=>$2007c62349361047$export$9b1ea4b9173c2926(state)[String(columnId)];
const $2007c62349361047$export$d543024fc9769252 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4ec9b51959de43e9,
    $2007c62349361047$export$f496179039a6c96a,
    (0, $4jZ56.swimlaneByTeamSelector)
], (columns, issues, swimlanesByTeam)=>{
    const countMap = {};
    columns.forEach((column)=>{
        countMap[String(column.id)] = {};
        swimlanesByTeam.forEach((swimlane)=>{
            countMap[String(column.id)][swimlane.id] = 0;
        });
    });
    issues.forEach((issue)=>{
        const teamId = issue.teamId || (0, $4jAPy.SWIMLANE_TEAMLESS);
        countMap[String(issue.columnId)][teamId] += 1;
    });
    return countMap;
});
const $2007c62349361047$export$45544dfa626588d1 = (state, columnId, swimlaneId)=>$2007c62349361047$export$d543024fc9769252(state)[String(columnId)][swimlaneId];
const $2007c62349361047$export$1f985e0e5786e956 = (state, columnId, swimlaneId)=>{
    if (swimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) || columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID)) return undefined;
    const teams = (0, $67Z81.getTeams)(state);
    const sprintByIteration = teams[Number(swimlaneId)]?.sprintByIterationId;
    return sprintByIteration && sprintByIteration[Number(columnId)];
};
const $2007c62349361047$export$6d5a132be16d7b29 = (state)=>state.ui.board.displayOptions.showUnscheduledColumn;
const $2007c62349361047$export$89d0463c0245d2f2 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4ec9b51959de43e9
], (columns)=>columns.filter((column)=>column.type === (0, $5rFbt.ColumnType).DATE_RANGE && (0, $esu6n.isUnscheduledColumn)(column)).map((column)=>({
            id: column.id,
            name: column.name,
            isDone: false,
            isInitial: false,
            limitJql: undefined
        })));
const $2007c62349361047$export$502e3142eedda17e = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4ec9b51959de43e9,
    (0, $67Z81.getIsIncrementPlanningBoard)
], (columns, isIPBoard)=>{
    if (isIPBoard) return columns.filter((column)=>column.type === (0, $5rFbt.ColumnType).DATE_RANGE && !(0, $esu6n.isUnscheduledColumn)(column)).map((column)=>({
            id: column.id,
            name: column.name,
            isDone: false,
            isInitial: false,
            limitJql: undefined
        }));
    return columns.filter((column)=>column.type === (0, $5rFbt.ColumnType).STATUS && column.statuses && column.statuses.length > 0).map((column)=>{
        const isDone = (0, $fyeGd.isDoneColumn)(column);
        return {
            id: column.id,
            name: column.name,
            isDone: isDone,
            isInitial: (0, $fyeGd.isInitialColumn)(column),
            limitJql: column.limitJql
        };
    });
});
const $2007c62349361047$export$1bbbdcc3b9f74565 = (0, $dGvGJ.createSelector)([
    (0, $36pz7.getPeople),
    (0, $36pz7.getCurrentUserAccountId),
    $2007c62349361047$export$f496179039a6c96a
], (assignees, currentUserAccountId, allIssues)=>{
    const currentUser = assignees[currentUserAccountId];
    const assigneeList = currentUser ? [
        currentUser
    ] : [];
    const issuesWithAssignees = allIssues.filter((i)=>i.assigneeAccountId && i.assigneeAccountId !== currentUserAccountId && assignees[i.assigneeAccountId]);
    const assigneeCounts = (0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))(issuesWithAssignees, (i)=>i.assigneeAccountId);
    Object.keys(assigneeCounts).sort((a, b)=>assigneeCounts[b] - assigneeCounts[a]).forEach((assigneeId)=>assigneeList.push(assignees[assigneeId]));
    return (0, $7uUwQ.freeze)(assigneeList);
});
const $2007c62349361047$export$7b365bd1ab5fa00b = (0, $dGvGJ.createSelector)([
    (0, $36pz7.getPeople),
    (0, $36pz7.getCurrentUserAccountId)
], (assignees, currentUserAccountId)=>{
    const currentUser = assignees[currentUserAccountId];
    const assigneeList = currentUser ? [
        currentUser
    ] : [];
    const otherAssignees = Object.values(assignees).filter((assignee)=>assignee.id !== currentUserAccountId);
    const sortedOtherAssignees = otherAssignees.sort((a, b)=>a.displayName.localeCompare(b.displayName));
    return (0, $7uUwQ.freeze)([
        ...assigneeList,
        ...sortedOtherAssignees
    ]);
});
const $2007c62349361047$export$cf831ce22df95e40 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$f496179039a6c96a
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>issues.some((issue)=>issue.columnId === columnId)));
const $2007c62349361047$var$getIssuesNotOnBoard = (state)=>(0, $67Z81.getUi)(state).column.issuesNotOnBoard;
const $2007c62349361047$export$130d5e3f88c9116d = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$getIssuesNotOnBoard
], (issuesNotOnBoard)=>(columnId)=>issuesNotOnBoard[String(columnId)]);
const $2007c62349361047$export$5496a8bd76ac3cc7 = (state)=>state.ui.cards.filteredCards.filteredCardsIds;
const $2007c62349361047$export$eadf838276efbfae = (state)=>state.ui.cards.filteredCards.isLoading;
const $2007c62349361047$export$4035471ff3de4fa3 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsIncrementPlanningBoard),
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getIsJSWBoard),
    (0, $67Z81.projectTypeSelector)
], (isIPBoard, isCMPBoard, isJSWBoard, projectType)=>{
    const displayFilterRefinement = (0, $6ALx6.shouldDisplayFilterRefinement)({
        isIncrementPlanningBoard: isIPBoard,
        isCMPBoard: isCMPBoard,
        isJSMBoard: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT),
        isJSWBoard: isJSWBoard
    });
    return displayFilterRefinement && (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false);
});
const $2007c62349361047$export$6f6b70ece7d0d0a8 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4035471ff3de4fa3,
    $2007c62349361047$export$38eb06a328cb92f6
], (filterRefinementEnabled, jqlFilter)=>filterRefinementEnabled && jqlFilter != null && jqlFilter.length > 0);
const $2007c62349361047$export$83704ff797ee645e = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    $2007c62349361047$export$f496179039a6c96a,
    (0, $67Z81.getIssues),
    (0, $36pz7.getPeople),
    $2007c62349361047$export$5496a8bd76ac3cc7,
    $2007c62349361047$export$4035471ff3de4fa3
], (workFilters, issues, issueHash, people, filteredCardIds, filterRefinementEnabled)=>(0, $iGIww.filter)(workFilters.values, issues, issueHash, people, filteredCardIds || undefined, filterRefinementEnabled));
const $2007c62349361047$export$291248a61b1f3024 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e
], (issues)=>issues.filter((issue)=>!issue.assigneeAccountId).length);
const $2007c62349361047$export$26127d4a6365327c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    (0, $vAfHD.boardIssuesAndChildrenSelector),
    (0, $67Z81.getIssues),
    (0, $36pz7.getPeople),
    $2007c62349361047$export$5496a8bd76ac3cc7,
    $2007c62349361047$export$4035471ff3de4fa3
], (workFilters, issues, issueHash, people, filteredCardIds, filterRefinementEnabled)=>(0, $iGIww.filter)(workFilters.values, Object.values(issues), issueHash, people, filteredCardIds || undefined, filterRefinementEnabled));
const $2007c62349361047$export$6f94a60a61d0a7c1 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e,
    $2007c62349361047$export$26127d4a6365327c,
    (0, $67Z81.getIsCMPBoard)
], (issues, cmpEpicSwimlaneIssue, isCMPBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>isCMPBoard ? cmpEpicSwimlaneIssue.filter((issue)=>issue.columnId === columnId).map((issue)=>issue.id) : issues.filter((issue)=>issue.columnId === columnId).map((issue)=>issue.id)));
const $2007c62349361047$export$bdcb688a64d33e13 = (state, columnId)=>{
    const issueIds = $2007c62349361047$export$6f94a60a61d0a7c1(state)(columnId);
    const columnConstraintType = $2007c62349361047$export$3892b6ff82249ef9(state);
    const issueChildren = (0, $3UY9S.getIssueChildren)(state);
    const filteredIssueIds = issueIds.filter((issueId)=>columnConstraintType !== 'ISSUE_COUNT_EXCLUDE_SUBTASKS' || !(issueId in issueChildren));
    return filteredIssueIds.length;
};
const $2007c62349361047$export$6e9b8e59636a4bbf = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$f496179039a6c96a,
    (0, $67Z81.projectIdSelector)
], (issues, projectId)=>(0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(issues.map((issue)=>Number(issue.projectId)) // get project ids
    .filter((id)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id)).concat(projectId ? [
        projectId
    ] : [])));
const $2007c62349361047$export$1481a23387579796 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)
    ], null)));
const $2007c62349361047$var$getIssueById = (0, $dGvGJ.createSelector)([
    (state, props)=>props.id,
    (state)=>(0, $vAfHD.boardIssuesSelector)(state)
], (id, issues)=>{
    const foundIssue = issues[String(id)];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(foundIssue)) (0, $2YZCu.default).safeErrorWithoutCustomerData('board.getIssueById.failure', 'Failure to found issue by id', new Error(`Issue Id to find ${id} not found in context ${Object.keys(issues).join(',')}`));
    return foundIssue;
});
// JSM uses request type name and icon as typeName and typeUrl.
const $2007c62349361047$var$getIssueForProject = (issue, projectType, requestTypes = [])=>{
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) {
        const requestType = requestTypes.find((req)=>req.id === issue.requestTypeId);
        const typeName = requestType?.name;
        const typeUrl = requestType?.iconUrl;
        return {
            ...issue,
            typeName: typeName,
            typeUrl: typeUrl
        };
    }
    return issue;
};
const $2007c62349361047$export$c3eddeee4fff0c95 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.projectTypeSelector),
    (0, $d2i8f.requestTypesSelector)
], (boardIssues, swimlaneMode, availableSwimlanes, isCMPBoard, projectType, requestTypes)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>{
        const issueToBeTransformed = boardIssues[String(id)];
        if (!issueToBeTransformed) return null;
        return (0, $bwTbl.transformSoftwareToPlatformIssue)($2007c62349361047$var$getIssueForProject(issueToBeTransformed, projectType, requestTypes), swimlaneMode, availableSwimlanes, isCMPBoard, (issueId)=>boardIssues[issueId]);
    }));
const $2007c62349361047$export$b6964ddef57f801 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e,
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getIsCMPBoard),
    (0, $vAfHD.boardIssuesSelector)
], (issues, swimlaneMode, availableSwimlanes, isCMPBoard, boardIssues)=>issues.map((issue)=>(0, $bwTbl.transformSoftwareToPlatformIssue)(issue, swimlaneMode, availableSwimlanes, isCMPBoard, (issueId)=>boardIssues[issueId])));
const $2007c62349361047$export$a05529bcb9c00a96 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$b6964ddef57f801,
    (0, $67Z81.getIsIncrementPlanningBoard),
    $2007c62349361047$export$6d5a132be16d7b29
], (issues, isIPBoard, isUnscheduledColumnVisible)=>{
    if (isIPBoard && !isUnscheduledColumnVisible) return issues.filter(({ columnId: columnId })=>columnId !== (0, $5rFbt.UNSCHEDULED_COLUMN_ID));
    return issues;
});
const $2007c62349361047$export$49400d4dee597710 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$getIssueById
], (issue)=>issue?.estimate ?? null);
const $2007c62349361047$export$8b37d0d4754c2222 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$a05529bcb9c00a96,
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $bSSdD.getIssueParents)
], (issues, swimlaneMode, swimlanes, issueParents)=>{
    if (!swimlaneMode || swimlaneMode === (0, $iuuJH.NO_SWIMLANE).id) return {};
    const issuesBySwimlane = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, (issue)=>issue.swimlaneId);
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id && (0, $c79wa.ParentlessSwimlane).id in issuesBySwimlane) {
        // remove all the Epic issues as they should not be counted the parentless swimlane
        const issueParentIds = Object.values(issueParents).map((issueParent)=>issueParent.id);
        const filteredIssues = issuesBySwimlane[(0, $c79wa.ParentlessSwimlane).id]?.filter((issue)=>!issueParentIds.includes(issue.id));
        issuesBySwimlane[(0, $c79wa.ParentlessSwimlane).id] = filteredIssues || [];
    }
    swimlanes.forEach(({ id: id })=>{
        if (issuesBySwimlane[id] === undefined) issuesBySwimlane[id] = [];
    });
    return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(issuesBySwimlane, (issuesInSwimlane)=>{
        const issuesByColumnId = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issuesInSwimlane, (issue)=>issue.columnId);
        return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(issuesByColumnId, (issuesInColumn)=>issuesInColumn.map((issue)=>issue.id));
    });
});
const $2007c62349361047$export$808aa6f47af32b37 = (swimlaneColumns)=>{
    let swimlaneHeight = 0;
    Object.values(swimlaneColumns).forEach((column)=>{
        if (column.length > swimlaneHeight) swimlaneHeight = column.length;
    });
    return swimlaneHeight * (0, $3eGwD.DEFAULT_CARD_HEIGHT);
};
const $2007c62349361047$export$c8eb34d22f45afc2 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $4jZ56.getIsSwimlaneCollapsed),
    $2007c62349361047$export$8b37d0d4754c2222
], (swimlanes, isSwimlaneCollapsed, issueIdsBySwimlane)=>swimlanes.reduce((result, swimlane)=>{
        // eslint-disable-next-line no-param-reassign
        result[swimlane.id] = (0, $645AZ.swimlaneHeaderHeight) + (isSwimlaneCollapsed(swimlane.id) ? 0 : $2007c62349361047$export$808aa6f47af32b37(issueIdsBySwimlane[swimlane.id]));
        return result;
    }, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {}));
const $2007c62349361047$export$8e7b436529ceb24b = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $4jZ56.getIsSwimlaneCollapsed),
    $2007c62349361047$export$8b37d0d4754c2222
], (swimlanes, isSwimlaneCollapsed, issueIdsBySwimlane)=>()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const swimlaneHeights = [];
        swimlanes.forEach((swimlane)=>{
            // If an above swimlane is collapsed, don't count its height
            if (isSwimlaneCollapsed(swimlane.id)) return;
            swimlaneHeights.push({
                swimlaneId: swimlane.id,
                height: $2007c62349361047$export$808aa6f47af32b37(issueIdsBySwimlane[swimlane.id])
            });
        });
        const swimlaneOffsets = {};
        swimlaneHeights.forEach(({ swimlaneId: swimlaneId }, index)=>{
            if (index === 0) swimlaneOffsets[swimlaneId] = 0;
            else {
                const previousId = swimlaneHeights[index - 1].swimlaneId;
                const previousHeight = swimlaneHeights[index - 1].height;
                const previousOffset = swimlaneOffsets[previousId];
                swimlaneOffsets[swimlaneId] = previousOffset + previousHeight;
            }
        });
        return swimlaneOffsets;
    });
const $2007c62349361047$var$getCardAmount = (swimlaneId, issueIdsBySwimlane)=>(0, $g5X3G.values)(issueIdsBySwimlane[swimlaneId] || {}).reduce((amount, issueIdsInColumn)=>amount + (Array.isArray(issueIdsInColumn) ? issueIdsInColumn.length : 0), 0);
const $2007c62349361047$export$605dc12eff71b2e5 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filterObject)=>Object.keys(filterObject.values).length);
const $2007c62349361047$var$excludedFilters = [
    (0, $dcff40112356dfc1$export$d597759d33be802e),
    (0, $dcff40112356dfc1$export$ebb48b08205007c5)
];
const $2007c62349361047$export$2f80a678ff297046 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filterObject)=>Object.keys(filterObject.values).filter((type)=>!$2007c62349361047$var$excludedFilters.includes(type)).length);
const $2007c62349361047$export$a7e88415a097d4e1 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$605dc12eff71b2e5
], (appliedWorkFiltersCount)=>appliedWorkFiltersCount > 0);
const $2007c62349361047$export$100f6402dcbc1c5 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filterObject)=>filterObject.values[0, $dcff40112356dfc1$export$68d693c35a8d8866] !== undefined && filterObject.values[0, $dcff40112356dfc1$export$68d693c35a8d8866].length > 0);
const $2007c62349361047$export$18912e4e4d90673c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>{
    const filterText = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$d597759d33be802e)
    ], null);
    const filterLabels = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)
    ], null);
    if (!filterText && !filterLabels) return null;
    return {
        text: filterText,
        labels: filterLabels
    };
});
const $2007c62349361047$export$25cdb7cc38e01f95 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $45cXl.getSwimlaneMode),
    $2007c62349361047$export$8b37d0d4754c2222,
    $2007c62349361047$export$83704ff797ee645e,
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getIsIncrementPlanningBoard),
    $2007c62349361047$export$a7e88415a097d4e1
], (swimlanes, swimlaneMode, issueIdsBySwimlane, filteredIssue, isCMPBoard, isIncrementPlanningBoard, hasWorkFilters)=>{
    const subtaskSwimlaneFilter = ({ id: id, cardAmount: cardAmount })=>{
        if (isCMPBoard) {
            // do not render the bottom "Everything else" swimlane when there are no cards in it
            if (id === (0, $c79wa.ChildlessSwimlane).id && cardAmount > 0) return true;
            // render the swimlane header even it is empty
            if (filteredIssue.map((issue)=>String(issue.id)).includes(id)) return true;
            return false;
        }
        return id === (0, $c79wa.ChildlessSwimlane).id;
    };
    /*
		 * When grouping by Epic.
		 * remove the "issue without epic" swimlane when empty on a CMP board
		 * keep it on a TMP board
		 */ const epicSwimlaneFilter = ({ id: id, cardAmount: cardAmount })=>id === (0, $c79wa.ParentlessSwimlane).id && (isCMPBoard ? cardAmount > 0 : true);
    /*
		 * When grouping by Assignee.
		 * remove the "Unassigned" swimlane when empty on a CMP board
		 * keep it on a TMP board
		 */ const assigneeSwimlaneFilter = ({ id: id, cardAmount: cardAmount })=>id === (0, $c79wa.UnassignedSwimlane).id && (isCMPBoard ? cardAmount > 0 : true);
    /*
		 * When grouping by Team.
		 * show empty swimlanes only if there is no filters applied
		 * and the team is a plan team
		 */ const teamSwimlaneFilter = ({ values: swimlaneValues }, hasFilters)=>!hasFilters && swimlaneValues?.type === (0, $4jAPy.TEAM) && swimlaneValues?.isPlanTeam;
    return swimlanes.map((swimlane)=>({
            id: swimlane.id,
            name: swimlane.name,
            issueKey: swimlane.issueKey,
            mode: swimlaneMode || '',
            message: swimlane.message,
            imageUrl: swimlane.imageUrl,
            cardAmount: $2007c62349361047$var$getCardAmount(swimlane.id, issueIdsBySwimlane),
            parentId: swimlane.parentId || null,
            values: swimlane.values,
            assigneeAccountId: swimlane.assigneeAccountId ?? null,
            projectKey: swimlane.projectKey ?? null,
            isFlagged: swimlane.isFlagged
        })).filter((swimlane)=>(swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) && assigneeSwimlaneFilter(swimlane) || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id && epicSwimlaneFilter(swimlane) || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && subtaskSwimlaneFilter(swimlane) || isIncrementPlanningBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_TEAM).id && teamSwimlaneFilter(swimlane, hasWorkFilters) || swimlane.cardAmount > 0);
});
const $2007c62349361047$export$547cddb5216fa288 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$25cdb7cc38e01f95
], (swimlanes)=>{
    const platformSwimlane = (swimlaneId)=>swimlanes.find((swimlane)=>swimlane.id === swimlaneId);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(platformSwimlane);
});
const $2007c62349361047$export$258129f9697957ee = (0, $idNc7.createDeepEqualSelector)([
    (state)=>{
        const swimlanes = $2007c62349361047$export$25cdb7cc38e01f95(state);
        return swimlanes.map(({ id: id })=>id);
    }
], (swimlaneIds)=>swimlaneIds);
const $2007c62349361047$export$fe8e61f95247eb77 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$258129f9697957ee,
    (0, $4jZ56.getCollapsedSwimlanes)
], (swimlaneIds, collapsedSwimlanesIds)=>swimlaneIds.find((swimlaneId)=>!collapsedSwimlanesIds.includes(swimlaneId)));
const $2007c62349361047$export$f26c3b512bbb6d6d = (state, columnId)=>{
    if ((0, $ebHh7.hasNoActiveSprintStateSelector)(state)) return (0, $3kNE6.ColumnTheme).Default;
    const issuesCount = $2007c62349361047$export$42858dbfcc0ce9c6(state, columnId);
    const column = (0, $fyeGd.getColumnById)(state, columnId);
    if (column?.type === (0, $5rFbt.ColumnType).STATUS && column?.maxIssueCount != null && issuesCount > column?.maxIssueCount) return (0, $3kNE6.ColumnTheme).Danger;
    if (column?.type === (0, $5rFbt.ColumnType).STATUS && column?.minIssueCount != null && issuesCount < column?.minIssueCount) return (0, $3kNE6.ColumnTheme).Warning;
    return (0, $3kNE6.ColumnTheme).Default;
};
const $2007c62349361047$export$b7de3298691c708c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$7b4d448d658d5a3b
], (columnUi)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>!!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(columnUi, [
            columnId,
            'isUpdating'
        ], false)));
const $2007c62349361047$export$8b6be5e9a544d475 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$7b4d448d658d5a3b
], (columnUi)=>columnUi && Object.keys(columnUi).some((key)=>columnUi[key].isUpdating === true));
const $2007c62349361047$export$a80f3c30adc36a1b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$8b6be5e9a544d475
], // Disable card drag if column updating or ICC is not complete
(anyColumnsUpdating)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>anyColumnsUpdating || id <= 0));
const $2007c62349361047$export$4b99acc1a687df2e = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode)
], (swimlaneMode)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((isLastSwimlane)=>!isLastSwimlane && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id ? (0, $dcbb2bce513725b3$export$1f24f91824c6822f) : (0, $dcbb2bce513725b3$export$b05303cbde3e8c8c)));
const $2007c62349361047$export$1de4ece81cabd754 = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $9OPlz.getDraggingCardId),
    (0, $3UY9S.getIssueChildren)
], (swimlaneMode, draggingCardId, issueChildren)=>swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && draggingCardId != null && draggingCardId in issueChildren);
const $2007c62349361047$export$9020a94481968b53 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $45cXl.getSwimlaneMode),
    (0, $vAfHD.boardIssuesSelector),
    (0, $9OPlz.getDraggingCardId),
    (0, $67Z81.getIsCMPBoard)
], (swimlanes, swimlaneMode, boardIssues, draggingCardId, isCMPBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((isLastSwimlane)=>{
        const issue = boardIssues[String(draggingCardId)];
        const draggingCardSwimlaneId = (0, $bwTbl.getSwimlaneId)(swimlaneMode, swimlanes, issue);
        // For TMP: If parent issue is unmapped, subtasks will appear in last swimlane
        // subtask in last swimlane can transition only in that swimlane
        // also subtasks in other swimlane cannot transition to last swimlane
        return isLastSwimlane ? isCMPBoard || draggingCardSwimlaneId === (0, $c79wa.ChildlessSwimlane).id : draggingCardSwimlaneId !== (0, $c79wa.ChildlessSwimlane).id;
    }));
const $2007c62349361047$export$7ea0d3589e75ea3e = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$ebb48b08205007c5)
    ], undefined));
const $2007c62349361047$export$66fc4c808781b0dd = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$7ea0d3589e75ea3e
], (issueTypes)=>{
    if (issueTypes && issueTypes.length) return Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(issueTypes));
    return undefined;
});
const $2007c62349361047$export$a416adb3e931289c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$401f4b6eda6a369c)
    ], []));
const $2007c62349361047$export$fea75492585ff771 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$db362e2d293fe52e)
    ], []));
const $2007c62349361047$export$b75a7d5a0b2593df = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$a416adb3e931289c
], (projects)=>{
    if (projects && projects.length) return Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(projects));
    return undefined;
});
const $2007c62349361047$export$717522cf1f80bfcb = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac
], (filters)=>!!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$2a4f270075a033de)
    ], undefined)?.length);
const $2007c62349361047$export$bd7f9cded888ac1b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    $2007c62349361047$export$4035471ff3de4fa3
], (filters, filterRefinementEnabled)=>{
    if (filterRefinementEnabled) return (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$a4ad2735b021c132)
    ], []).map(Number);
    return undefined;
});
const $2007c62349361047$export$a3e606d31ce14076 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    (0, $36pz7.getAssigneeAccountIds),
    (0, $d2i8f.issueLabelsSelector),
    (0, $bSSdD.issueParentIdsSelector),
    (0, $d2i8f.issueProjectIdsSelector),
    (0, $d2i8f.issueTypeFilterSelector),
    (0, $d2i8f.requestTypesSelector),
    (0, $d2i8f.statusesSelector),
    (0, $ebHh7.activeSprintsSelector),
    $2007c62349361047$export$ada7918f4af738ad,
    (0, $67Z81.getIsCMPBoard),
    $2007c62349361047$export$4035471ff3de4fa3
], (filters, validAssigneeIds, validLabels, validIssueParentIds, validIssueProjectIds, validIssueTypes, validRequestTypes, validStatuses, activeSprints, customFilters, isCMPBoard, filterRefinementEnabled)=>{
    const filterTypeWhitelist = [
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
        (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
        (0, $dcff40112356dfc1$export$d597759d33be802e),
        (0, $dcff40112356dfc1$export$2a4f270075a033de),
        (0, $dcff40112356dfc1$export$401f4b6eda6a369c),
        (0, $dcff40112356dfc1$export$ebb48b08205007c5),
        (0, $dcff40112356dfc1$export$68d693c35a8d8866),
        (0, $dcff40112356dfc1$export$a316570a0dbfd2b0),
        (0, $dcff40112356dfc1$export$92ab80c1dc9baf44),
        (0, $dcff40112356dfc1$export$e50006273435e7d4),
        (0, $dcff40112356dfc1$export$db362e2d293fe52e),
        ...filterRefinementEnabled ? [
            (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)
        ] : [],
        ...filterRefinementEnabled ? [
            (0, $dcff40112356dfc1$export$a4ad2735b021c132)
        ] : []
    ];
    const validFilters = {};
    if (filters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validAssigneeIds, filters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] = (0, $g5X3G.toAccountIdArray)(inter);
    }
    if (filters.values[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validLabels, filters.values[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7] = inter;
    }
    if (filters.values[0, $dcff40112356dfc1$export$2a4f270075a033de]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueParentIds, filters.values[0, $dcff40112356dfc1$export$2a4f270075a033de]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$2a4f270075a033de] = (0, $g5X3G.toIssueIdArray)(inter);
    }
    if (filters.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueProjectIds, filters.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$401f4b6eda6a369c] = (0, $g5X3G.toProjectIdArray)(inter);
    }
    if (filters.values[0, $dcff40112356dfc1$export$ebb48b08205007c5]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validIssueTypes, filters.values[0, $dcff40112356dfc1$export$ebb48b08205007c5]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$ebb48b08205007c5] = (0, $g5X3G.toIssueTypeIdArray)(inter);
    }
    if (filters.values[0, $dcff40112356dfc1$export$92ab80c1dc9baf44]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validRequestTypes.map(({ id: id })=>id), filters.values[0, $dcff40112356dfc1$export$92ab80c1dc9baf44]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$92ab80c1dc9baf44] = inter;
    }
    if (filters.values[0, $dcff40112356dfc1$export$e50006273435e7d4]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(validStatuses.map(({ id: id })=>id), filters.values[0, $dcff40112356dfc1$export$e50006273435e7d4]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$e50006273435e7d4] = inter;
    }
    if (filters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0]) {
        const activeSprintIds = activeSprints?.map((sprint)=>String(sprint.id)) ?? [];
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(activeSprintIds, filters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$a316570a0dbfd2b0] = inter;
    }
    if (isCMPBoard && filters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(customFilters.map(({ id: id })=>id), filters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$68d693c35a8d8866] = inter;
    }
    if (filters.values[0, $dcff40112356dfc1$export$db362e2d293fe52e]) {
        const inter = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(Object.values((0, $kIDH3.DependencyFilterOption)), filters.values[0, $dcff40112356dfc1$export$db362e2d293fe52e]);
        if (inter.length > 0) validFilters[0, $dcff40112356dfc1$export$db362e2d293fe52e] = inter;
    }
    if (filterRefinementEnabled) {
        validFilters[0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f] = filters.values[0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f];
        if (filters.values[0, $dcff40112356dfc1$export$a4ad2735b021c132]) validFilters[0, $dcff40112356dfc1$export$a4ad2735b021c132] = filters.values[0, $dcff40112356dfc1$export$a4ad2735b021c132];
    }
    Object.keys(filters.values).filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in work selectors`);
    });
    return validFilters;
});
const $2007c62349361047$export$333b83a56fe77194 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    (0, $36pz7.getAssigneeAccountIds),
    (0, $d2i8f.issueLabelsSelector),
    (0, $bSSdD.issueParentIdsSelector),
    (0, $d2i8f.issueProjectIdsSelector),
    (0, $d2i8f.issueTypeFilterSelector),
    (0, $d2i8f.requestTypesSelector),
    (0, $d2i8f.statusesSelector),
    (0, $ebHh7.activeSprintsSelector),
    $2007c62349361047$export$ada7918f4af738ad,
    (0, $67Z81.getIsCMPBoard),
    $2007c62349361047$export$4035471ff3de4fa3
], (filters, validAssigneeIds, validLabels, validIssueParentIds, validIssueProjectIds, validIssueTypes, validRequestTypes, validStatuses, validSprints, validCustomFilters, isCMPBoard, filterRefinementEnabled)=>{
    const filterTypeWhitelist = [
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
        (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
        (0, $dcff40112356dfc1$export$d597759d33be802e),
        (0, $dcff40112356dfc1$export$2a4f270075a033de),
        (0, $dcff40112356dfc1$export$401f4b6eda6a369c),
        (0, $dcff40112356dfc1$export$ebb48b08205007c5),
        (0, $dcff40112356dfc1$export$68d693c35a8d8866),
        (0, $dcff40112356dfc1$export$a316570a0dbfd2b0),
        (0, $dcff40112356dfc1$export$92ab80c1dc9baf44),
        (0, $dcff40112356dfc1$export$e50006273435e7d4),
        (0, $dcff40112356dfc1$export$db362e2d293fe52e),
        ...filterRefinementEnabled ? [
            (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)
        ] : [],
        ...filterRefinementEnabled ? [
            (0, $dcff40112356dfc1$export$a4ad2735b021c132)
        ] : []
    ];
    const invalidFilters = {};
    if (filters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$f8f7545d2bb78afb], validAssigneeIds);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] = (0, $g5X3G.toAccountIdArray)(diff);
    }
    if (filters.values[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7], validLabels);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7] = diff;
    }
    if (filters.values[0, $dcff40112356dfc1$export$2a4f270075a033de]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$2a4f270075a033de], validIssueParentIds);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$2a4f270075a033de] = (0, $g5X3G.toIssueIdArray)(diff);
    }
    if (filters.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c], validIssueProjectIds);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$401f4b6eda6a369c] = (0, $g5X3G.toProjectIdArray)(diff);
    }
    if (filters.values[0, $dcff40112356dfc1$export$ebb48b08205007c5]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$ebb48b08205007c5], validIssueTypes);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$ebb48b08205007c5] = (0, $g5X3G.toIssueTypeIdArray)(diff);
    }
    if (filters.values[0, $dcff40112356dfc1$export$92ab80c1dc9baf44]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$92ab80c1dc9baf44], validRequestTypes.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$92ab80c1dc9baf44] = diff;
    }
    if (filters.values[0, $dcff40112356dfc1$export$e50006273435e7d4]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$e50006273435e7d4], validStatuses.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$e50006273435e7d4] = diff;
    }
    if (filters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0]) {
        const activeSprintIds = validSprints?.map((sprint)=>String(sprint.id)) ?? [];
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0], activeSprintIds);
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$a316570a0dbfd2b0] = diff;
    }
    if (isCMPBoard && filters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$68d693c35a8d8866], validCustomFilters.map(({ id: id })=>id));
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$68d693c35a8d8866] = diff;
    }
    if (filters.values[0, $dcff40112356dfc1$export$db362e2d293fe52e]) {
        const diff = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(filters.values[0, $dcff40112356dfc1$export$db362e2d293fe52e], Object.values((0, $kIDH3.DependencyFilterOption)));
        if (diff.length > 0) invalidFilters[0, $dcff40112356dfc1$export$db362e2d293fe52e] = diff;
    }
    Object.keys(filters.values).filter((filterType)=>!filterTypeWhitelist.includes(filterType)).forEach((notAllowedFilter)=>{
        throw new Error(`Please whitelist filter '${notAllowedFilter}' in work selectors`);
    });
    return invalidFilters;
});
const $2007c62349361047$export$e5ce012c8ff94f67 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$333b83a56fe77194
], (invalidFilterValues)=>Object.keys(invalidFilterValues).length > 0);
const $2007c62349361047$export$8da24954392d0b6b = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedColumnIds),
    $2007c62349361047$export$83704ff797ee645e
], (columnIds, issues)=>{
    const issueIdsByColumnMap = {};
    columnIds.forEach((columnId)=>{
        const issuesIds = issues.filter((issue)=>issue.columnId === columnId).map((issue)=>issue.id);
        issueIdsByColumnMap[String(columnId)] = issuesIds;
    });
    return issueIdsByColumnMap;
});
const $2007c62349361047$export$b8bb2f4853de2d02 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$a05529bcb9c00a96,
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes)
], (issues, swimlaneMode, swimlanes)=>{
    if (!swimlaneMode || swimlaneMode === (0, $iuuJH.NO_SWIMLANE).id) return {};
    const issuesBySwimlane = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issues, (issue)=>issue.swimlaneId);
    swimlanes.forEach(({ id: id })=>{
        if (issuesBySwimlane[id] === undefined) issuesBySwimlane[id] = [];
    });
    return Object.keys(issuesBySwimlane).reduce((accum, swimlaneId)=>{
        const issuesInSwimlane = issuesBySwimlane[swimlaneId];
        const issuesByColumnId = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(issuesInSwimlane, (issue)=>issue.columnId);
        // eslint-disable-next-line no-param-reassign
        accum[swimlaneId] = issuesByColumnId;
        return accum;
    }, {});
});
const $2007c62349361047$export$76423ca425841ce3 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getOrderedColumnIds),
    $2007c62349361047$export$b8bb2f4853de2d02,
    $2007c62349361047$export$b6964ddef57f801
], (swimlanes, columnIds, issuesBySwimlane, platformIssues)=>{
    // If there are any swimlanes, we need to call a different selector and handle it very differently
    if (swimlanes.length > 0) // NOTE that we use the swimlanes array here instead of the dictionary returned. This
    // is to preserve the ordering of the swimlanes AS they are rendered/displayed on screen.
    return columnIds.map((columnId)=>swimlanes.filter((swimlane)=>swimlane.id in issuesBySwimlane).flatMap((swimlane)=>issuesBySwimlane[swimlane.id][columnId] ?? []).map((issue)=>issue.key));
    // Otherwise we just grab all filtered issues and return them in the correct shape
    return columnIds.map((columnId)=>platformIssues.filter((issue)=>issue.columnId === columnId).map((issue)=>issue.key));
});
const $2007c62349361047$var$getCardAmountByColumn = (issueCountPerColumn, limit)=>{
    let remainingCards = limit;
    let columnCount = issueCountPerColumn.length;
    return issueCountPerColumn.map(({ key: key, amount: amount })=>{
        const columnLimit = Math.min(amount, Math.ceil(remainingCards / columnCount));
        columnCount -= 1;
        remainingCards -= columnLimit;
        return {
            key: key,
            amount: columnLimit
        };
    });
};
const $2007c62349361047$var$getTruncatedIssueIdsBySortedColumns = (issueIdsByColumn, limit)=>{
    // Sort column by issue count in ascending order so we handle the column with the least cards first.
    // This ensures that we do not have empty columns where there should be issues.
    const sortedIssueCountPerColumn = Object.keys(issueIdsByColumn).map((column)=>({
            key: column,
            amount: (0, $g5X3G.values)(issueIdsByColumn[column]).flat().length
        })).sort((a, b)=>Number(a.amount) - Number(b.amount));
    // Calculate the number of cards allowed in each column
    const allowedCardCountPerColumn = $2007c62349361047$var$getCardAmountByColumn(sortedIssueCountPerColumn, limit);
    // Populate mapping of swimlane to columns to issues with number of issues from the calculated limits
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issueIdsByColumnWithLimit = {};
    allowedCardCountPerColumn.map(({ key: key, amount: amount })=>({
            column: key,
            columnIssueLimit: amount
        })).forEach(({ column: column, columnIssueLimit: columnIssueLimit })=>{
        issueIdsByColumnWithLimit[column] = issueIdsByColumn[column].slice(0, columnIssueLimit);
    });
    return issueIdsByColumnWithLimit;
};
const $2007c62349361047$export$c42e69e614304b3b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$8da24954392d0b6b
], (issueIdsByColumn)=>$2007c62349361047$var$getTruncatedIssueIdsBySortedColumns(issueIdsByColumn, (0, $dcbb2bce513725b3$export$2683a6b6da85de4d)));
const $2007c62349361047$export$ee662c5bb14e469c = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$8b37d0d4754c2222,
    (0, $4jZ56.getSwimlanes)
], (issueIdsBySwimlane, swimlanes)=>{
    // Get a list of pairings that contain swimlane id and the calculate the number of cards allowed
    // per swimlane considering the SSR card limit. We want to greedily assign the number of cards up
    // to the limit rather than equally spreading cards among swimlanes.
    let remainingCards = (0, $dcbb2bce513725b3$export$2683a6b6da85de4d);
    const allowedCardCountPerSwimlane = swimlanes.map(({ id: id })=>({
            key: id,
            amount: (0, $g5X3G.values)(issueIdsBySwimlane[id]).flat().length
        })).map(({ key: key, amount: amount })=>{
        const swimlaneLimit = Math.min(amount, remainingCards);
        remainingCards -= swimlaneLimit;
        return {
            key: key,
            amount: swimlaneLimit
        };
    });
    // For each swimlane, iterate through each column to calculate how many and which cards to select
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const truncatedIssueIdsBySwimlane = {};
    allowedCardCountPerSwimlane.map(({ key: key, amount: amount })=>({
            swimlane: key,
            swimlaneIssueLimit: amount
        })).forEach(({ swimlane: swimlane, swimlaneIssueLimit: swimlaneIssueLimit })=>{
        truncatedIssueIdsBySwimlane[swimlane] = $2007c62349361047$var$getTruncatedIssueIdsBySortedColumns(issueIdsBySwimlane[swimlane], swimlaneIssueLimit);
    });
    return truncatedIssueIdsBySwimlane;
});
const $2007c62349361047$export$a3d88d5fd2477a5c = (state, columnId)=>{
    const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
    if (!swimlaneMode || swimlaneMode === (0, $iuuJH.NO_SWIMLANE).id) return $2007c62349361047$export$c42e69e614304b3b(state)[String(columnId)].length;
    const issueIdsBySwimlane = $2007c62349361047$export$ee662c5bb14e469c(state);
    return Object.keys(issueIdsBySwimlane).map((swimlaneId)=>issueIdsBySwimlane[swimlaneId]).reduce((acc, issueIdsByColumn)=>acc + (issueIdsByColumn[String(columnId)]?.length || 0), 0);
};
const $2007c62349361047$export$4dfb307b48a9ff4b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    (0, $67Z81.getIsIncrementPlanningBoard)
], (filters, isIncrementPlanningBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$2a4f270075a033de)
    ], []).map((issueParentId)=>// Scenario parent ids are strings on the program board
        isIncrementPlanningBoard ? issueParentId : Number(issueParentId)));
const $2007c62349361047$export$8fc92f4a10e91c3b = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$4dfb307b48a9ff4b,
    (0, $67Z81.getIsIncrementPlanningBoard)
], (filteredIssueParentIds, isIncrementPlanningBoard)=>{
    if (isIncrementPlanningBoard) {
        const lastFiltered = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filteredIssueParentIds) ? (0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(filteredIssueParentIds) : null;
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(lastFiltered) ? lastFiltered : null;
    }
    return !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filteredIssueParentIds) ? Number((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))(filteredIssueParentIds)) : null;
});
const $2007c62349361047$export$6d848ac469f8f1d5 = (0, $dGvGJ.createSelector)((0, $d2i8f.makeIssueDevStatusSelector), (issueDevStatusSelector)=>(0, $8QpSo.default)((workData)=>({
            ...workData,
            issues: issueDevStatusSelector(workData.issues)
        })));
const $2007c62349361047$export$fc04e99ac3563a66 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e
], (issues)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>issues.some((issue)=>issue.id === id)));
const $2007c62349361047$export$bacbd1cd61f6f690 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$bfbfdc2dda3d42ac,
    $2007c62349361047$export$f496179039a6c96a,
    (0, $67Z81.getIssues),
    (0, $36pz7.getPeople),
    $2007c62349361047$export$5496a8bd76ac3cc7,
    $2007c62349361047$export$4035471ff3de4fa3
], (workFilters, issues, issueHash, people, filteredCardIds, filterRefinementEnabled)=>{
    const visibleIssueIds = (0, $iGIww.filter)(workFilters.values, issues, issueHash, people, filterRefinementEnabled ? filteredCardIds || undefined : undefined, filterRefinementEnabled).map((issue)=>issue.id);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueIds)=>issueIds.filter((issueId)=>!visibleIssueIds.includes(issueId)));
});
const $2007c62349361047$export$675ae7d7d995e6cd = (0, $dGvGJ.createSelector)($2007c62349361047$export$83704ff797ee645e, (workFilteredIssues)=>{
    const visibleIssueKeys = workFilteredIssues.map((issue)=>issue.key);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueKeys)=>issueKeys.filter((issueKey)=>!visibleIssueKeys.includes(issueKey)));
});
const $2007c62349361047$export$2c3764a24d5a77a5 = (state)=>state.ui.cards.cardWithIcc.mainActiveIssue;
const $2007c62349361047$export$45f354b7131bf0a2 = (0, $dGvGJ.createSelector)([
    (state, props)=>props.issueId,
    (state)=>$2007c62349361047$export$2c3764a24d5a77a5(state)
], (targetIssueId, activeIssueId)=>targetIssueId === activeIssueId);
const $2007c62349361047$export$1f1c155fbe31f55a = (0, $dGvGJ.createSelector)([
    (state, props)=>props.issueId,
    (state)=>(0, $9OPlz.getIssueIdWithAboveICCOpen)(state),
    (state)=>$2007c62349361047$export$2c3764a24d5a77a5(state),
    (state)=>(0, $d2i8f.getOrderedIssuesByColumn)(state),
    (state)=>$2007c62349361047$export$8da24954392d0b6b(state)
], (targetIssueId, issueIdWithAboveICCOpen, activeIssueId, orderedIssuesByColumn, getVisibleIssuesForColumn)=>{
    if (issueIdWithAboveICCOpen != null && issueIdWithAboveICCOpen === targetIssueId) return true;
    if (!activeIssueId) return false;
    if (targetIssueId === activeIssueId) return true;
    const activeColumn = Object.entries(orderedIssuesByColumn).find(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ([, issues])=>Array.isArray(issues) && issues.find((issue)=>{
            // Flow currently doesn't keep types when Object.entries() is used
            // https://github.com/facebook/flow/issues/2174
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            const typedIssue = issue;
            return typedIssue.id === activeIssueId;
        }));
    if (!activeColumn) return false;
    const [activeColumnId] = activeColumn;
    const visibleIssuesOfActiveColumn = getVisibleIssuesForColumn[activeColumnId];
    if (!Array.isArray(visibleIssuesOfActiveColumn)) return false;
    const activeIssueIndex = visibleIssuesOfActiveColumn.indexOf(activeIssueId);
    const targetIssueIndex = visibleIssuesOfActiveColumn.indexOf(targetIssueId);
    return activeIssueIndex !== -1 && targetIssueIndex !== -1 && targetIssueIndex === activeIssueIndex + 1;
});
const $2007c62349361047$var$getIssuesIdsByColumn = (state, { swimlaneId: swimlaneId, isUnscheduledWorkColumn: isUnscheduledWorkColumn })=>{
    // In the Program Board, the unscheduled work column adds an additional suffix to the id of the
    // swimlane so that the swimlane collapse behaviour can be independent between the board and the
    // unscheduled work column. For all other column behaviour, we want to truncate this suffix.
    const swimlaneIdTruncated = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) ? (0, $bdYfL.truncateUnscheduledWorkSwimlaneId)(swimlaneId, isUnscheduledWorkColumn) : swimlaneId;
    if (false) return (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneIdTruncated) ? $2007c62349361047$export$c42e69e614304b3b(state) : $2007c62349361047$export$ee662c5bb14e469c(state)[swimlaneIdTruncated];
    return (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneIdTruncated) ? $2007c62349361047$export$8da24954392d0b6b(state) : $2007c62349361047$export$8b37d0d4754c2222(state)[swimlaneIdTruncated];
};
const $2007c62349361047$export$9c38ecda34a0899c = (0, $dGvGJ.createSelector)([
    (state, props)=>props.columnId,
    $2007c62349361047$var$getIssuesIdsByColumn
], (columnId, issueIdsByColumn)=>issueIdsByColumn && issueIdsByColumn[String(columnId)]);
const $2007c62349361047$export$138c2389bbf22c2d = ()=>(0, $idNc7.createDeepEqualSelector)([
        $2007c62349361047$export$9c38ecda34a0899c,
        (0, $67Z81.getIsCMPBoard),
        (0, $45cXl.getSwimlaneMode),
        (0, $3UY9S.getParentIdByIssueChildSelector),
        (0, $bSSdD.issueParentIdsSelector),
        (0, $67Z81.isBoardRankable)
    ], (issueIds, isCMPBoard, swimlaneMode, getParentIdByIssueChild, issueParentIds, isRankable)=>{
        const skipGroupingChildren = !isCMPBoard || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id;
        if (skipGroupingChildren) return issueIds?.map((issueId)=>({
                type: 'issue',
                issueId: issueId
            }));
        const issueEntries = [];
        if (!isRankable) {
            // Filter out issue children which has parent. As it should be rendered in a group
            const shouldRenderInCardGroup = (issueId)=>!!getParentIdByIssueChild(issueId);
            // An Epics are rendered as the swimlane headers when grouped by Epic
            // Otherwise Epics are rendered as cards
            const shouldRenderAsSwimlaneHeader = (issueId)=>swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id && issueParentIds.includes(String(issueId));
            issueIds?.forEach((issueId)=>{
                if (!shouldRenderInCardGroup(issueId) && !shouldRenderAsSwimlaneHeader(issueId)) {
                    issueEntries.push({
                        type: 'issue',
                        issueId: issueId
                    });
                    return;
                }
                const parentId = getParentIdByIssueChild(issueId);
                if (!parentId) return;
                const previousItem = issueEntries[issueEntries.length - 1];
                if (previousItem?.type === 'group' && previousItem.parentId === parentId) {
                    previousItem.issueIds.push(issueId);
                    return;
                }
                const group = {
                    type: 'group',
                    parentId: parentId,
                    issueIds: [
                        issueId
                    ],
                    isAttachedToParent: isRankable ? issueIds.includes(parentId) : previousItem?.type === 'issue' && previousItem.issueId === parentId
                };
                issueEntries.push(group);
            });
        } else {
            // Filter out issue children and issue parents if swimlane by epic
            const nonChildIssueIds = (issueIds || []).filter((issueId)=>!getParentIdByIssueChild(issueId) && (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id || !issueParentIds.includes(String(issueId))));
            const childIssueIds = (issueIds || []).filter((issue)=>!!getParentIdByIssueChild(issue));
            const childIdsByParent = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(childIssueIds, getParentIdByIssueChild);
            issueIds?.forEach((issueId)=>{
                if (nonChildIssueIds.includes(issueId)) {
                    issueEntries.push({
                        type: 'issue',
                        issueId: issueId
                    });
                    return;
                }
                const parentId = getParentIdByIssueChild(issueId);
                if (!parentId || !(parentId in childIdsByParent)) return;
                issueEntries.push({
                    type: 'group',
                    parentId: parentId,
                    issueIds: childIdsByParent[parentId],
                    isAttachedToParent: nonChildIssueIds.includes(parentId)
                });
                delete childIdsByParent[parentId];
            });
        }
        return issueEntries;
    });
const $2007c62349361047$var$filteredInIssuesById = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$83704ff797ee645e
], (filteredIssues)=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(filteredIssues, 'id'));
const $2007c62349361047$export$82a7a8258a5a6f48 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$filteredInIssuesById
], (issues)=>{
    const issuesWithIssueLinks = (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(issues, (issue)=>issue.issueLinks && issue.issueLinks.length > 0);
    return issuesWithIssueLinks;
});
const $2007c62349361047$export$d7699a71638fd9d4 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$filteredInIssuesById
], (issues)=>{
    const issuesWithIssueLinks = (0, (/*@__PURE__*/$parcel$interopDefault($4f8Oj)))(issues, (issue)=>issue.issueLinks && issue.issueLinks.length > 0 && issue.columnId !== (0, $5rFbt.UNSCHEDULED_COLUMN_ID));
    return issuesWithIssueLinks;
});
const $2007c62349361047$export$1e1a7e899f73dc6f = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$d7699a71638fd9d4
], (issuesEntriesWithIssueLinksInBoard)=>{
    return Object.keys(issuesEntriesWithIssueLinksInBoard);
});
const $2007c62349361047$export$b11164626e861e2e = (columnId, swimlaneId)=>`${columnId}:${swimlaneId ?? (0, $iuuJH.NO_SWIMLANE).id}`;
const $2007c62349361047$export$cc6f4dd9bb04ac0a = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector)
], (issues)=>(issueId)=>issues[String(issueId)]?.columnId);
const $2007c62349361047$export$db5d57ea014e1a9f = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getIsCMPBoard)
], (issues, swimlaneMode, availableSwimlanes, isCMPBoard)=>(boardIssueId)=>{
        const issue = issues[String(boardIssueId)];
        if (!issue) return null;
        return (0, $bwTbl.getSwimlaneId)(swimlaneMode, availableSwimlanes, issue, isCMPBoard, (issueId)=>issues[issueId]);
    });
const $2007c62349361047$export$5c4dc04d949c48c3 = (0, $dGvGJ.createSelector)([
    $2007c62349361047$var$getIssueById,
    (0, $67Z81.getStatuses)
], (issue, statuses)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) ? null : statuses[issue.statusId]);
const $2007c62349361047$export$98d29ba803e92a0e = (0, $dGvGJ.createSelector)([
    $2007c62349361047$export$2c3764a24d5a77a5,
    (0, $vAfHD.makeGetIssueKeyFromIssueId)
], (activeIssueId, issueKeyFromIssueId)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueId)) return null;
    return issueKeyFromIssueId(activeIssueId);
});
const $2007c62349361047$export$78a44af01b2680d = (0, $dGvGJ.createSelector)([
    (0, $bSSdD.getIssueParents),
    $2007c62349361047$export$547cddb5216fa288
], (issueParents, swimlaneSelector)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((swimlaneId)=>{
        const { mode: mode, parentId: parentId } = swimlaneSelector(swimlaneId) || {};
        if (mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && parentId) return issueParents[parentId] || null;
        if (mode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) return issueParents[swimlaneId] || null;
        return null;
    }));

});
parcelRegister("hm7zS", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $4CZTG = parcelRequire("4CZTG");
/** Used for built-in method references. */ var $ca2a5e84e2b42ea9$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $ca2a5e84e2b42ea9$var$hasOwnProperty = $ca2a5e84e2b42ea9$var$objectProto.hasOwnProperty;
/**
 * Creates an object composed of keys generated from the results of running
 * each element of `collection` thru `iteratee`. The corresponding value of
 * each key is the number of times the key was returned by `iteratee`. The
 * iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
 * @returns {Object} Returns the composed aggregate object.
 * @example
 *
 * _.countBy([6.1, 4.2, 6.3], Math.floor);
 * // => { '4': 1, '6': 2 }
 *
 * // The `_.property` iteratee shorthand.
 * _.countBy(['one', 'two', 'three'], 'length');
 * // => { '3': 2, '5': 1 }
 */ var $ca2a5e84e2b42ea9$var$countBy = $4CZTG(function(result, value, key) {
    if ($ca2a5e84e2b42ea9$var$hasOwnProperty.call(result, key)) ++result[key];
    else $1m3dq(result, key, 1);
});
module.exports = $ca2a5e84e2b42ea9$var$countBy;

});

parcelRegister("kIDH3", function(module, exports) {

$parcel$export(module.exports, "DependencyFilterOption", () => $ddac187df0965772$export$499848eca2db01cf);
const $ddac187df0965772$export$499848eca2db01cf = {
    OFF_TRACK: 'off-track',
    ON_TRACK: 'on-track'
};

});

parcelRegister("645AZ", function(module, exports) {

$parcel$export(module.exports, "layout", () => $a67c0a983b5112a4$export$b3219800bda33a1f);
$parcel$export(module.exports, "colors", () => $a67c0a983b5112a4$export$8f45430ccf837300);
$parcel$export(module.exports, "zIndex", () => $a67c0a983b5112a4$export$56446adcecbeec34);
$parcel$export(module.exports, "columnHeaderHeight", () => $a67c0a983b5112a4$export$b10d8d0737c2bc95);
$parcel$export(module.exports, "columnFixedWidth", () => $a67c0a983b5112a4$export$fa05dc858c5009bb);
$parcel$export(module.exports, "columnMinWidth", () => $a67c0a983b5112a4$export$dc572e5846332cb1);
$parcel$export(module.exports, "columnWithMarginWidth", () => $a67c0a983b5112a4$export$28e72c3a8a93ac77);
$parcel$export(module.exports, "swimlaneHeaderHeight", () => $a67c0a983b5112a4$export$b12ee424ee8005de);
$parcel$export(module.exports, "minCardHeight", () => $a67c0a983b5112a4$export$9c20cef8efa8ff1c);
$parcel$export(module.exports, "scrollbarWidth", () => $a67c0a983b5112a4$export$14c8a45ff6da16d);
$parcel$export(module.exports, "unscheduledColumnWidth", () => $a67c0a983b5112a4$export$e635defc4ff8e744);
$parcel$export(module.exports, "unscheduledColumnHeaderHeight", () => $a67c0a983b5112a4$export$1f19522691bf7df6);

var $gwIPs = parcelRequire("gwIPs");
const $a67c0a983b5112a4$export$b3219800bda33a1f = {
    gutter: 10,
    smallGutter: 5,
    cardRadius: 3,
    cardListRadius: 6,
    adg3smallGutter: 8,
    columnMargin: 6,
    boardBorderWidth: (0, $gwIPs.contentHorizontalSpacing)
};
const $a67c0a983b5112a4$export$8f45430ccf837300 = {
    shadow: "var(--ds-border, #091E4224)"
};
const $a67c0a983b5112a4$export$56446adcecbeec34 = {
    // Inside board
    boardBorders: 90,
    minimap: 6,
    cardDoneRipple: 5,
    transitionZoneIndicator: 5,
    stickyHeaders: 4,
    swimlaneTickMask: 3,
    stickySwimlaneBar: 2,
    icc: 1,
    transitionZones: 1,
    fullColumnHeightTransitionZones: 3
};
const $a67c0a983b5112a4$export$b10d8d0737c2bc95 = 32 + 2 * $a67c0a983b5112a4$export$b3219800bda33a1f.adg3smallGutter;
const $a67c0a983b5112a4$export$fa05dc858c5009bb = 270;
const $a67c0a983b5112a4$export$1878bafe4afef3fb = 262;
const $a67c0a983b5112a4$export$dc572e5846332cb1 = 150;
const $a67c0a983b5112a4$export$28e72c3a8a93ac77 = $a67c0a983b5112a4$export$fa05dc858c5009bb + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$f47ba5aa0a13b432 = $a67c0a983b5112a4$export$dc572e5846332cb1 + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$b12ee424ee8005de = 24 + 2 * $a67c0a983b5112a4$export$b3219800bda33a1f.adg3smallGutter;
const $a67c0a983b5112a4$export$9c20cef8efa8ff1c = (0, $gwIPs.gridSize) * 10;
const $a67c0a983b5112a4$export$73febd7a1d3f7041 = 36;
const $a67c0a983b5112a4$export$7709c197eb61e438 = 40;
const $a67c0a983b5112a4$export$a18d33b11d25b5c7 = $a67c0a983b5112a4$export$7709c197eb61e438 + $a67c0a983b5112a4$export$b3219800bda33a1f.columnMargin * 2;
const $a67c0a983b5112a4$export$14c8a45ff6da16d = '10px';
const $a67c0a983b5112a4$export$e635defc4ff8e744 = '270px';
const $a67c0a983b5112a4$var$unscheduledColumnTitleHeight = 20;
const $a67c0a983b5112a4$export$1f19522691bf7df6 = $a67c0a983b5112a4$export$b12ee424ee8005de + $a67c0a983b5112a4$var$unscheduledColumnTitleHeight;

});

parcelRegister("3kNE6", function(module, exports) {

$parcel$export(module.exports, "ColumnTheme", () => $355fce6f5fc0d1f0$export$18d9d841e20106b9);
const $355fce6f5fc0d1f0$export$18d9d841e20106b9 = {
    Default: 'default',
    Warning: 'warning',
    Danger: 'danger'
};

});

parcelRegister("bdYfL", function(module, exports) {

$parcel$export(module.exports, "getBoardScopeFilterType", () => $f1501fc223d29b95$export$27ef735461d030e);
$parcel$export(module.exports, "getPlanId", () => $f1501fc223d29b95$export$203ed8b65c3b2a28);
$parcel$export(module.exports, "urls", () => $f1501fc223d29b95$export$bcae9ba627f604b6);
$parcel$export(module.exports, "getBoardUrl", () => $f1501fc223d29b95$export$505a9f131607d070);
$parcel$export(module.exports, "getManageBoardSettingsUrl", () => $f1501fc223d29b95$export$ba13e822080a5be4);
$parcel$export(module.exports, "convertCapacity", () => $f1501fc223d29b95$export$48e790d731821dac);
$parcel$export(module.exports, "getCapacityUnitMessage", () => $f1501fc223d29b95$export$fb95ed64ed4e0e59);
$parcel$export(module.exports, "getSprintStateLabel", () => $f1501fc223d29b95$export$6f891d146561f05a);
$parcel$export(module.exports, "convertCapacityFromPlanningUnitToSeconds", () => $f1501fc223d29b95$export$acbcfbe3e761e0b4);
$parcel$export(module.exports, "isScenarioPlanonlyTeamCheck", () => $f1501fc223d29b95$export$458ffa13814d195c);
$parcel$export(module.exports, "isScenarioIssue", () => $f1501fc223d29b95$export$44ef32448ae567e6);
$parcel$export(module.exports, "getIssueLinksAnalytics", () => $f1501fc223d29b95$export$b7de722f7c014dc8);
$parcel$export(module.exports, "truncateUnscheduledWorkSwimlaneId", () => $f1501fc223d29b95$export$728fdc4d4544b775);
$parcel$export(module.exports, "appendUnscheduledWorkSwimlaneIdSuffix", () => $f1501fc223d29b95$export$1ca85b4c3d462fa1);

var $6icp6 = parcelRequire("6icp6");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $3spCR = parcelRequire("3spCR");

var $gBj4V = parcelRequire("gBj4V");

var $4jAPy = parcelRequire("4jAPy");

var $gZK1Z = parcelRequire("gZK1Z");
const $f1501fc223d29b95$export$27ef735461d030e = (boardScopeFilter)=>{
    if (boardScopeFilter === undefined) return 0, $4jAPy.BOARD_SCOPE_FILTER_NONE;
    if (boardScopeFilter.filterFieldId === (0, $4jAPy.SYSTEM_LABEL_FIELD_ID)) return 0, $4jAPy.BOARD_SCOPE_FILTER_LABEL;
    if (boardScopeFilter.filterFieldTypeKey === (0, $4jAPy.SINGLE_CUSTOM_FIELD_TYPE_KEY)) return 0, $4jAPy.BOARD_SCOPE_FILTER_SINGLE_SELECT;
    if (boardScopeFilter.filterFieldTypeKey === (0, $4jAPy.MULTI_CUSTOM_FIELD_TYPE_KEY)) return 0, $4jAPy.BOARD_SCOPE_FILTER_MULTI_SELECT;
    return 0, $4jAPy.BOARD_SCOPE_FILTER_NONE;
};
const $f1501fc223d29b95$var$PLAN_PARAMS = {
    PLAN: 'plans',
    SCENARIO: 'scenarios',
    BOARD: 'program',
    ROADMAP: 'backlog'
};
const $f1501fc223d29b95$var$parsePathParams = (path, param)=>{
    const regex = new RegExp(`/${param}/(\\w+)`, 'g');
    const matches = Array.from(path.matchAll(regex), (match)=>match[1]);
    return matches[0];
};
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $f1501fc223d29b95$var$getPathParams = (param)=>$f1501fc223d29b95$var$parsePathParams(window.location.pathname, param);
const $f1501fc223d29b95$export$203ed8b65c3b2a28 = ()=>+$f1501fc223d29b95$var$getPathParams($f1501fc223d29b95$var$PLAN_PARAMS.PLAN) || undefined;
const $f1501fc223d29b95$export$8572797243a693b9 = ()=>+$f1501fc223d29b95$var$getPathParams($f1501fc223d29b95$var$PLAN_PARAMS.SCENARIO) || undefined;
const $f1501fc223d29b95$export$bcae9ba627f604b6 = {
    managePortfolio: '/jira/plans/'
};
const $f1501fc223d29b95$export$505a9f131607d070 = (boardId, isEmbed = false)=>`/jira/${$f1501fc223d29b95$var$PLAN_PARAMS.PLAN}/${$f1501fc223d29b95$export$203ed8b65c3b2a28()}/${$f1501fc223d29b95$var$PLAN_PARAMS.SCENARIO}/${$f1501fc223d29b95$export$8572797243a693b9()}/${$f1501fc223d29b95$var$PLAN_PARAMS.BOARD}/${boardId}${isEmbed && (0, $4R6GH.fg)('smart_links_for_plans') ? '/embed' : ''}`;
const $f1501fc223d29b95$export$ba13e822080a5be4 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/program-boards`;
const $f1501fc223d29b95$export$48e790d731821dac = (capacity, planningUnit, workingHoursPerDay)=>{
    if (planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT)) return (0, (/*@__PURE__*/$parcel$interopDefault($6icp6)))(capacity / workingHoursPerDay / (0, $gBj4V.SECONDS_PER_HOUR), 2);
    if (planningUnit === (0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT)) return (0, (/*@__PURE__*/$parcel$interopDefault($6icp6)))(capacity / (0, $gBj4V.SECONDS_PER_HOUR), 2);
    return capacity;
};
const $f1501fc223d29b95$export$fb95ed64ed4e0e59 = (planningUnit, formatMessage, originalCapacity)=>{
    // if the originalCapacity is undefined, assign the capacity to 2 to get the plural unit
    const capacity = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalCapacity) ? 2 : originalCapacity;
    switch(planningUnit){
        case 0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT:
            return formatMessage((0, $gZK1Z.default).dayUnit, {
                days: capacity
            });
        case 0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT:
            return formatMessage((0, $gZK1Z.default).hourUnit, {
                hours: capacity
            });
        default:
            return formatMessage((0, $gZK1Z.default).storyPointUnit, {
                points: capacity
            });
    }
};
const $f1501fc223d29b95$export$6f891d146561f05a = (sprintState, formatMessage)=>{
    switch(sprintState){
        case (0, $3spCR.SPRINT_STATES).ACTIVE:
            return formatMessage((0, $gZK1Z.default).activeSprint);
        case (0, $3spCR.SPRINT_STATES).CLOSED:
            return formatMessage((0, $gZK1Z.default).closedSprint);
        case (0, $3spCR.SPRINT_STATES).FUTURE:
        default:
            return formatMessage((0, $gZK1Z.default).futureSprint);
    }
};
const $f1501fc223d29b95$export$acbcfbe3e761e0b4 = ({ capacity: capacity, planningUnit: planningUnit, workingHours: workingHours })=>{
    switch(planningUnit){
        case 0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT:
            return capacity * (0, $gBj4V.SECONDS_PER_HOUR) * workingHours;
        case 0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT:
            return capacity * (0, $gBj4V.SECONDS_PER_HOUR);
        default:
            return capacity;
    }
};
const $f1501fc223d29b95$export$458ffa13814d195c = (teamId)=>Number.isNaN(parseInt(teamId, 10));
const $f1501fc223d29b95$export$44ef32448ae567e6 = (issueId)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId) && String(issueId).startsWith((0, $4jAPy.SCENARIO_ISSUE_ID_PREFIX));
const $f1501fc223d29b95$export$b7de722f7c014dc8 = (issueLinks, id, issueLinkTypes, issuesWithLinksById, issueTypes)=>{
    if (!issueLinks || !id || !issueLinkTypes || !issuesWithLinksById || !issueTypes) return {};
    const attributes = issueLinks.reduce((acc, link)=>{
        const linkType = issueLinkTypes.find((l)=>l.id === link.linkTypeId);
        const isSource = link.sourceId === id;
        const linkedIssueId = isSource ? link.destinationId : link.sourceId;
        const issueTypeId = issuesWithLinksById[linkedIssueId]?.typeId;
        const isBaseLevel = issueTypes[issueTypeId]?.hierarchyLevelType === 'BASE';
        if (isSource) {
            if (linkType?.isOutward) isBaseLevel ? acc.BlockingStoriesCount++ : acc.BlockingEpicsCount++;
            else isBaseLevel ? acc.BlockedByStoriesCount++ : acc.BlockedByEpicsCount++;
        } else if (linkType?.isOutward) isBaseLevel ? acc.BlockedByStoriesCount++ : acc.BlockedByEpicsCount++;
        else isBaseLevel ? acc.BlockingStoriesCount++ : acc.BlockingEpicsCount++;
        return acc;
    }, {
        BlockedByStoriesCount: 0,
        BlockedByEpicsCount: 0,
        BlockingStoriesCount: 0,
        BlockingEpicsCount: 0
    });
    return attributes;
};
const $f1501fc223d29b95$export$728fdc4d4544b775 = (swimlaneId, isUnscheduledColumn)=>isUnscheduledColumn && swimlaneId.endsWith((0, $4jAPy.UNSCHEDULED_WORK_COLUMN_SWIMLANE_ID_SUFFIX)) ? swimlaneId.slice(0, -(0, $4jAPy.UNSCHEDULED_WORK_COLUMN_SWIMLANE_ID_SUFFIX).length) : swimlaneId;
const $f1501fc223d29b95$export$1ca85b4c3d462fa1 = (swimlaneId)=>`${swimlaneId}${0, $4jAPy.UNSCHEDULED_WORK_COLUMN_SWIMLANE_ID_SUFFIX}`;

});
parcelRegister("6icp6", function(module, exports) {

var $aza9E = parcelRequire("aza9E");
/**
 * Computes `number` rounded down to `precision`.
 *
 * @static
 * @memberOf _
 * @since 3.10.0
 * @category Math
 * @param {number} number The number to round down.
 * @param {number} [precision=0] The precision to round down to.
 * @returns {number} Returns the rounded down number.
 * @example
 *
 * _.floor(4.006);
 * // => 4
 *
 * _.floor(0.046, 2);
 * // => 0.04
 *
 * _.floor(4060, -2);
 * // => 4000
 */ var $494e0ba682121fe5$var$floor = $aza9E('floor');
module.exports = $494e0ba682121fe5$var$floor;

});
parcelRegister("aza9E", function(module, exports) {

var $1V15E = parcelRequire("1V15E");

var $kPZpS = parcelRequire("kPZpS");

var $1sXeC = parcelRequire("1sXeC");

var $jJVtR = parcelRequire("jJVtR");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $7b150cc928607d87$var$nativeIsFinite = $1V15E.isFinite, $7b150cc928607d87$var$nativeMin = Math.min;
/**
 * Creates a function like `_.round`.
 *
 * @private
 * @param {string} methodName The name of the `Math` method to use when rounding.
 * @returns {Function} Returns the new round function.
 */ function $7b150cc928607d87$var$createRound(methodName) {
    var func = Math[methodName];
    return function(number, precision) {
        number = $1sXeC(number);
        precision = precision == null ? 0 : $7b150cc928607d87$var$nativeMin($kPZpS(precision), 292);
        if (precision && $7b150cc928607d87$var$nativeIsFinite(number)) {
            // Shift with exponential notation to avoid floating-point issues.
            // See [MDN](https://mdn.io/round#Examples) for more details.
            var pair = ($jJVtR(number) + 'e').split('e'), value = func(pair[0] + 'e' + (+pair[1] + precision));
            pair = ($jJVtR(value) + 'e').split('e');
            return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
    };
}
module.exports = $7b150cc928607d87$var$createRound;

});


parcelRegister("gBj4V", function(module, exports) {

$parcel$export(module.exports, "SECONDS_PER_MINUTE", () => $f8bb2765f8828f08$export$544c576050746347);
$parcel$export(module.exports, "SECONDS_PER_HOUR", () => $f8bb2765f8828f08$export$3cc7ae4b390f50a);
$parcel$export(module.exports, "TimeFormats", () => $f8bb2765f8828f08$export$5d7ed58d46354b1);
$parcel$export(module.exports, "TimeUnits", () => $f8bb2765f8828f08$export$5d7753c8ad881494);
$parcel$export(module.exports, "defaultTimeTrackingOptions", () => $f8bb2765f8828f08$export$f8d48c1fed813e90);
const $f8bb2765f8828f08$export$544c576050746347 = 60;
const $f8bb2765f8828f08$var$MINUTES_PER_HOUR = 60;
const $f8bb2765f8828f08$export$3cc7ae4b390f50a = $f8bb2765f8828f08$var$MINUTES_PER_HOUR * $f8bb2765f8828f08$export$544c576050746347;
const $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY = 'pretty';
const $f8bb2765f8828f08$var$TIME_FORMAT_DAYS = 'days';
const $f8bb2765f8828f08$var$TIME_FORMAT_HOURS = 'hours';
const $f8bb2765f8828f08$export$5d7ed58d46354b1 = Object.freeze({
    PRETTY: $f8bb2765f8828f08$var$TIME_FORMAT_PRETTY,
    DAYS: $f8bb2765f8828f08$var$TIME_FORMAT_DAYS,
    HOURS: $f8bb2765f8828f08$var$TIME_FORMAT_HOURS
});
const $f8bb2765f8828f08$var$TIME_UNIT_WEEK = 'week';
const $f8bb2765f8828f08$var$TIME_UNIT_DAY = 'day';
const $f8bb2765f8828f08$var$TIME_UNIT_HOUR = 'hour';
const $f8bb2765f8828f08$var$TIME_UNIT_MINUTE = 'minute';
const $f8bb2765f8828f08$export$5d7753c8ad881494 = Object.freeze({
    WEEK: $f8bb2765f8828f08$var$TIME_UNIT_WEEK,
    DAY: $f8bb2765f8828f08$var$TIME_UNIT_DAY,
    HOUR: $f8bb2765f8828f08$var$TIME_UNIT_HOUR,
    MINUTE: $f8bb2765f8828f08$var$TIME_UNIT_MINUTE
});
const $f8bb2765f8828f08$export$f8d48c1fed813e90 = {
    workingHoursPerDay: 8,
    workingDaysPerWeek: 5,
    timeFormat: $f8bb2765f8828f08$export$5d7ed58d46354b1.PRETTY,
    defaultUnit: $f8bb2765f8828f08$export$5d7753c8ad881494.MINUTE
};

});

parcelRegister("gZK1Z", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb4520eab764533$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9fb4520eab764533$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backToBoards: {
        "id": "portfolio-3-plan-increment-common.common.back-to-boards",
        "defaultMessage": "Choose another board"
    },
    dayUnit: {
        "id": "portfolio-3-plan-increment-common.common.day-unit",
        "defaultMessage": "{days, plural, one {day} other {days}}"
    },
    hourUnit: {
        "id": "portfolio-3-plan-increment-common.common.hour-unit",
        "defaultMessage": "{hours, plural, one {hour} other {hours}}"
    },
    storyPointUnit: {
        "id": "portfolio-3-plan-increment-common.common.story-point-unit",
        "defaultMessage": "{points, plural, one {point} other {points}}"
    },
    activeSprint: {
        "id": "portfolio-3-plan-increment-common.common.active-sprint",
        "defaultMessage": "ACTIVE"
    },
    closedSprint: {
        "id": "portfolio-3-plan-increment-common.common.closed-sprint",
        "defaultMessage": "COMPLETED"
    },
    futureSprint: {
        "id": "portfolio-3-plan-increment-common.common.future-sprint",
        "defaultMessage": "FUTURE"
    },
    apiErrorFlagTitle: {
        "id": "portfolio-3-plan-increment-common.common.api-error-flag-title",
        "defaultMessage": "Something went wrong."
    },
    apiErrorFlagDescription: {
        "id": "portfolio-3-plan-increment-common.common.api-error-flag-description",
        "defaultMessage": "Refresh the page and try that again. "
    },
    editCapacityLabel: {
        "id": "portfolio-3-plan-increment-common.common.edit-capacity-label",
        "defaultMessage": "Edit capacity"
    },
    confirmButtonLabel: {
        "id": "portfolio-3-plan-increment-common.common.confirm-button-label",
        "defaultMessage": "Confirm"
    },
    cancelButtonLabel: {
        "id": "portfolio-3-plan-increment-common.common.cancel-button-label",
        "defaultMessage": "Cancel"
    }
});

});


parcelRegister("3eGwD", function(module, exports) {

$parcel$export(module.exports, "setBoardDetailViewMode", () => $2bcfa667ce8ad985$export$5aec23d4b2954b61);
$parcel$export(module.exports, "getBoardDetailViewMode", () => $2bcfa667ce8ad985$export$30296c2892a21468);
$parcel$export(module.exports, "getIsIssueIdValid", () => $2bcfa667ce8ad985$export$19a52456f915e7ce);
$parcel$export(module.exports, "isIssueEntryIssue", () => $2bcfa667ce8ad985$export$dd68addaaf18caa0);
$parcel$export(module.exports, "isIssueEntryGroup", () => $2bcfa667ce8ad985$export$a9cdbc0e2d3f64a7);
$parcel$export(module.exports, "getIssueEntryGroupKey", () => $2bcfa667ce8ad985$export$e5641ceb7fc8f20a);
$parcel$export(module.exports, "DEFAULT_CARD_HEIGHT", () => $2bcfa667ce8ad985$export$428a1825e984a589);
$parcel$export(module.exports, "DEFAULT_INLINE_CARD_CREATE_HEIGHT", () => $2bcfa667ce8ad985$export$209dc8eac8ec90b);
$parcel$export(module.exports, "CARD_LEFT_RIGHT_MARGIN", () => $2bcfa667ce8ad985$export$a70e2570aafabc88);

var $bSSG7 = parcelRequire("bSSG7");

var $jOSD5 = parcelRequire("jOSD5");
const $2bcfa667ce8ad985$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('software');
const $2bcfa667ce8ad985$var$GROUP_BY_SELECTION = 'gh.groupBySelection.';
const $2bcfa667ce8ad985$export$5aec23d4b2954b61 = (detailViewMode)=>$2bcfa667ce8ad985$var$localStorage.set((0, $jOSD5.BOARD_DETAIL_VIEW_MODE), detailViewMode);
const $2bcfa667ce8ad985$export$30296c2892a21468 = ()=>$2bcfa667ce8ad985$var$localStorage.get((0, $jOSD5.BOARD_DETAIL_VIEW_MODE)) || (0, $jOSD5.DETAIL_VIEW_DEFAULT);
const $2bcfa667ce8ad985$export$1708c8217a67f3f9 = (boardId)=>{
    const data = $2bcfa667ce8ad985$var$localStorage.get(`${$2bcfa667ce8ad985$var$GROUP_BY_SELECTION}${boardId}`);
    if (!data) return null;
    return data;
};
const $2bcfa667ce8ad985$export$19a52456f915e7ce = (issueId)=>{
    if (typeof issueId === 'number') return issueId > 0;
    return !!issueId;
};
const $2bcfa667ce8ad985$export$dd68addaaf18caa0 = (issueEntry)=>issueEntry.type === 'issue';
const $2bcfa667ce8ad985$export$a9cdbc0e2d3f64a7 = (issueEntry)=>issueEntry.type === 'group';
const $2bcfa667ce8ad985$export$e5641ceb7fc8f20a = ({ parentId: parentId, issueIds: issueIds })=>`${parentId}::${issueIds.join(',')}`;
const $2bcfa667ce8ad985$export$428a1825e984a589 = 84;
const $2bcfa667ce8ad985$export$209dc8eac8ec90b = 40;
const $2bcfa667ce8ad985$export$a70e2570aafabc88 = 5;

});
parcelRegister("jOSD5", function(module, exports) {

$parcel$export(module.exports, "DETAIL_VIEW_DEFAULT", () => $91937a74349ee4f3$export$ad4637adae7d3e97);
$parcel$export(module.exports, "BOARD_DETAIL_VIEW_MODE", () => $91937a74349ee4f3$export$201bf1eb7c447afa);
const $91937a74349ee4f3$export$dfb67e34e4333816 = 'SIDEBAR';
const $91937a74349ee4f3$export$1d6094128a3bfe4a = 'MODAL';
const $91937a74349ee4f3$export$ad4637adae7d3e97 = 'DEFAULT';
const $91937a74349ee4f3$export$201bf1eb7c447afa = 'board-detail-view-mode';
const $91937a74349ee4f3$export$6b0228c67b1e82cf = {
    NO_SWIMLANE: 'none',
    SWIMLANE_BY_JQL: 'jql',
    SWIMLANE_BY_ASSIGNEE: 'assignee',
    SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST: 'assigneeunassignedfirst',
    SWIMLANE_BY_PARENT_ISSUE: 'issueparent',
    SWIMLANE_BY_SUBTASK: 'issuechildren',
    SWIMLANE_BY_PROJECT: 'project',
    SWIMLANE_BY_TEAM: 'team',
    SWIMLANE_BY_REQUEST_TYPE: 'requesttype'
};

});


parcelRegister("esu6n", function(module, exports) {

$parcel$export(module.exports, "getStatusColumn", () => $91f4bd490f381404$export$f9a77580ef71cadc);
$parcel$export(module.exports, "getDateRangeColumn", () => $91f4bd490f381404$export$cddf68fa5ecd76f1);
$parcel$export(module.exports, "isUnscheduledColumn", () => $91f4bd490f381404$export$2131c06200a944a9);

var $5rFbt = parcelRequire("5rFbt");
const $91f4bd490f381404$export$f9a77580ef71cadc = (column)=>column?.type === (0, $5rFbt.ColumnType).STATUS ? column : null;
const $91f4bd490f381404$export$cddf68fa5ecd76f1 = (column)=>column?.type === (0, $5rFbt.ColumnType).DATE_RANGE ? column : null;
const $91f4bd490f381404$export$2131c06200a944a9 = (column)=>column?.type === (0, $5rFbt.ColumnType).DATE_RANGE && column?.id === (0, $5rFbt.UNSCHEDULED_COLUMN_ID);

});

const $dcff40112356dfc1$export$d597759d33be802e = 'TEXT';
const $dcff40112356dfc1$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $dcff40112356dfc1$export$37aee82a3cb1e8f7 = 'LABEL';
const $dcff40112356dfc1$export$2a4f270075a033de = 'ISSUE_PARENT';
const $dcff40112356dfc1$export$401f4b6eda6a369c = 'ISSUE_PROJECT';
const $dcff40112356dfc1$export$ebb48b08205007c5 = 'ISSUE_TYPE';
const $dcff40112356dfc1$export$92ab80c1dc9baf44 = 'REQUEST_TYPE';
const $dcff40112356dfc1$export$e50006273435e7d4 = 'STATUS';
const $dcff40112356dfc1$export$68d693c35a8d8866 = 'CUSTOM_FILTER';
const $dcff40112356dfc1$export$a316570a0dbfd2b0 = 'SPRINT';
const $dcff40112356dfc1$export$db362e2d293fe52e = 'DEPENDENCIES';
const $dcff40112356dfc1$export$a4ad2735b021c132 = 'VERSION';
const $dcff40112356dfc1$export$dc9697aa7b3a6d6f = 'JQL';

parcelRegister("idNc7", function(module, exports) {

$parcel$export(module.exports, "createDeepEqualSelector", () => $d29ef4afb46b16e9$export$4b5ed82e6a727aff);

var $dGvGJ = parcelRequire("dGvGJ");

var $ajpes = parcelRequire("ajpes");
const $d29ef4afb46b16e9$export$4b5ed82e6a727aff = (0, $dGvGJ.createSelectorCreator)((0, $dGvGJ.defaultMemoize), (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));

});

parcelRegister("iGIww", function(module, exports) {

$parcel$export(module.exports, "filter", () => $e34fce1c7e0a982f$export$3dea766d36a8935f);

var $hGgHi = parcelRequire("hGgHi");

var $g5X3G = parcelRequire("g5X3G");

var $dVREV = parcelRequire("dVREV");
const $e34fce1c7e0a982f$export$79e3f18eafd008ab = (issue)=>Number(issue.id) < 0;
const $e34fce1c7e0a982f$export$3dea766d36a8935f = (filterValues, issues, issueHash, people, filteredIssueIds, isFilterRefinementEnabled)=>{
    if (isFilterRefinementEnabled) {
        if (!filteredIssueIds) return issues;
        return issues.filter((issue)=>filteredIssueIds.has(issue.id.toString()) || // If the issue id is negative, it is an optimistic issue
            parseInt(`${issue.id}`, 10) < 0);
    }
    const toFilterableIssue = ({ id: id, key: key, summary: summary, labels: labels, typeId: typeId, typeName: typeName, parentId: parentId, assigneeAccountId: assigneeAccountId, requestTypeId: requestTypeId, statusId: statusId, sprintId: sprintId, projectId: projectId, issueLinks: issueLinks })=>{
        const assignee = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(assigneeAccountId) && assigneeAccountId in people ? {
            id: (0, $g5X3G.toAccountId)(assigneeAccountId),
            displayName: (0, $g5X3G.toDisplayName)(people[assigneeAccountId].displayName)
        } : undefined;
        return {
            id: (0, $g5X3G.toIssueId)(id.toString()),
            key: (0, $g5X3G.toIssueKey)(key),
            summary: summary,
            labels: labels,
            type: {
                id: (0, $g5X3G.toIssueTypeId)(typeId.toString()),
                name: typeName
            },
            parentId: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentId) ? (0, $g5X3G.toIssueId)(parentId.toString()) : undefined,
            requestTypeId: requestTypeId,
            statusId: statusId != null ? (0, $g5X3G.toIssueStatusId)(String(statusId)) : undefined,
            assignee: assignee,
            sprintId: sprintId,
            projectId: (0, $g5X3G.toProjectId)(projectId.toString()),
            hasOfftrackDependency: issueLinks?.some((link)=>link.isOfftrack),
            hasOntrackDependency: issueLinks?.some((link)=>!link.isOfftrack)
        };
    };
    const filterableIssues = Object.keys(issueHash).map((id)=>toFilterableIssue(issueHash[id]));
    const filterableIssuesHash = filterableIssues.reduce((acc, filterableIssue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(filterableIssue.id)) return acc;
        acc[`${filterableIssue.id}`] = filterableIssue;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
    const filterFunction = (0, $dVREV.createFilterFunction)(filterValues, {
        issues: {
            list: filterableIssues,
            hash: filterableIssuesHash
        },
        filteredIssueIds: filteredIssueIds
    }, (0, $dVREV.createDefaultMatcherCreators)(), [
        $e34fce1c7e0a982f$export$79e3f18eafd008ab
    ]);
    return issues.filter((issue)=>{
        const filterableIssue = filterableIssuesHash[issue.id] ?? toFilterableIssue(issue);
        return filterFunction(filterableIssue);
    });
};

});
parcelRegister("dVREV", function(module, exports) {

$parcel$export(module.exports, "createDefaultMatcherCreators", () => $da698aa4f276c01f$export$551eb27bf5bd708);
$parcel$export(module.exports, "createFilterFunction", () => $da698aa4f276c01f$export$5b4da3e2bd753e6);


var $83R7M = parcelRequire("83R7M");

var $9NUFF = parcelRequire("9NUFF");

var $bOpxF = parcelRequire("bOpxF");

var $2Ol4g = parcelRequire("2Ol4g");

var $kSow3 = parcelRequire("kSow3");

var $91AxA = parcelRequire("91AxA");

var $8wcaA = parcelRequire("8wcaA");

var $7vODb = parcelRequire("7vODb");

var $bliRS = parcelRequire("bliRS");

var $iZeAQ = parcelRequire("iZeAQ");

var $ly5rg = parcelRequire("ly5rg");

var $4nYh7 = parcelRequire("4nYh7");

var $gbBLn = parcelRequire("gbBLn");

var $gw6jA = parcelRequire("gw6jA");
const $da698aa4f276c01f$export$551eb27bf5bd708 = ()=>({
        [(0, $15a528573ccd89ae$export$d597759d33be802e)]: (0, $gbBLn.textMatcherCreator),
        [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, $83R7M.assigneeMatcherCreator),
        [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: (0, $7vODb.labelMatcherCreator),
        [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: (0, $kSow3.issueParentMatcherCreator),
        [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: (0, $91AxA.issueProjectMatcherCreator),
        [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: (0, $8wcaA.issueTypeMatcherCreator),
        [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, $gw6jA.versionMatcherCreator),
        [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, $9NUFF.componentMatcherCreator),
        [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: (0, $bliRS.requestTypeMatcherCreator),
        [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: (0, $ly5rg.statusCategoryMatcherCreator),
        [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: (0, $4nYh7.statusMatcherCreator),
        [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: (0, $iZeAQ.sprintMatcherCreator),
        [(0, $15a528573ccd89ae$export$871e58afc769b358)]: (0, $2Ol4g.filteredIssueIdsMatcherCreator),
        [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: (0, $bOpxF.dependenciesMatcherCreator)
    });
const $da698aa4f276c01f$var$createMatchers = (filter, context, matcherCreators)=>Object.keys(filter).reduce((acc, key)=>{
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Filters'.
        const filterValue = filter[key];
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'MatcherCreators<Issue>'.
        const matcherCreator = matcherCreators[key];
        if (filterValue === undefined || filterValue.length <= 0 || matcherCreator === undefined) return acc;
        acc.push(matcherCreator(filterValue, context));
        return acc;
    }, []);
const $da698aa4f276c01f$export$5b4da3e2bd753e6 = (filter, context, matcherCreators, overrideMatchers)=>{
    const matchers = $da698aa4f276c01f$var$createMatchers(filter, context, matcherCreators ?? $da698aa4f276c01f$export$551eb27bf5bd708());
    return (issue)=>matchers.every((matcher)=>matcher(issue)) || overrideMatchers !== undefined && overrideMatchers.some((matcher)=>matcher(issue));
};

});
parcelRegister("83R7M", function(module, exports) {

$parcel$export(module.exports, "assigneeMatcherCreator", () => $516b0f9136210863$export$5c453ff7d8a6957f);

var $g5X3G = parcelRequire("g5X3G");

const $516b0f9136210863$export$5c453ff7d8a6957f = (assigneeFilter)=>{
    const assigneeSet = new Set(assigneeFilter);
    return ({ assignee: assignee })=>assignee !== undefined && assigneeSet.has(assignee.id) || assignee === undefined && assigneeSet.has((0, $g5X3G.toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)));
};

});

parcelRegister("9NUFF", function(module, exports) {

$parcel$export(module.exports, "componentMatcherCreator", () => $f76f751e605f1ced$export$667cab6ac6c65512);

const $f76f751e605f1ced$export$667cab6ac6c65512 = (componentFilter)=>{
    const componentSet = new Set(componentFilter);
    return ({ componentIds: componentIds })=>componentIds !== undefined && (componentIds.some((componentId)=>componentSet.has(componentId)) || componentIds.length === 0 && componentSet.has((0, $15a528573ccd89ae$export$4b7c755e61199a36)));
};

});

parcelRegister("bOpxF", function(module, exports) {

$parcel$export(module.exports, "dependenciesMatcherCreator", () => $03061179e3dc93a9$export$18a8a0a9891403f1);

var $kIDH3 = parcelRequire("kIDH3");
const $03061179e3dc93a9$export$18a8a0a9891403f1 = (dependenciesFilter)=>{
    // General rule of dependencies filter is that it should include issues that has at least 1 dependency matches the selected filter.
    // So if off track is selected, it should include issues that has at least 1 off track dependency and vice versa,
    // if on track is selected, it should include issues that has at least 1 on track dependency.
    // If both off track and on track are selected, it should include issues that has at least 1 off track or on track dependency.
    if (dependenciesFilter) {
        const includeOffTrack = dependenciesFilter.includes((0, $kIDH3.DependencyFilterOption).OFF_TRACK);
        const includeOnTrack = dependenciesFilter.includes((0, $kIDH3.DependencyFilterOption).ON_TRACK);
        return (issue)=>includeOffTrack && !!issue.hasOfftrackDependency || includeOnTrack && !!issue.hasOntrackDependency;
    }
    return ()=>true;
};

});

parcelRegister("2Ol4g", function(module, exports) {

$parcel$export(module.exports, "filteredIssueIdsMatcherCreator", () => $497597637c50e49d$export$4493d922cd011b1a);
const $497597637c50e49d$export$4493d922cd011b1a = (value, { filteredIssueIds: filteredIssueIds })=>({ id: id })=>filteredIssueIds !== undefined ? id !== undefined && filteredIssueIds.has(id) : true;

});

parcelRegister("kSow3", function(module, exports) {

$parcel$export(module.exports, "issueParentMatcherCreator", () => $a81202b8afefb6ff$export$4729465fe91e6864);

const $a81202b8afefb6ff$export$4729465fe91e6864 = (issueParentFilter, { issues: issues })=>{
    const issueParentSet = new Set(issueParentFilter);
    const isAncestorInFilter = (id, checked = [])=>{
        if (id === undefined) return issueParentSet.has((0, $9ac224d9ad6eb576$export$794f07be04aca3fe));
        if (issueParentSet.has(id)) return true;
        if (checked.includes(id)) return false;
        if (issues === undefined) return false;
        const issue = issues.hash[id];
        if (issue === undefined) return false;
        const { parentId: parentId } = issue;
        return isAncestorInFilter(parentId, checked.concat(id));
    };
    return ({ id: id, parentId: parentId })=>{
        if (id === undefined) return false;
        if (issueParentSet.has(id)) return true;
        if (id === parentId) return false;
        return isAncestorInFilter(parentId, [
            id
        ]);
    };
};

});
const $9ac224d9ad6eb576$export$794f07be04aca3fe = '0';


parcelRegister("91AxA", function(module, exports) {

$parcel$export(module.exports, "issueProjectMatcherCreator", () => $4fdd97fe73369965$export$b10ee43342090204);
const $4fdd97fe73369965$export$b10ee43342090204 = (projectFilter)=>{
    const projectSet = new Set(projectFilter);
    return ({ projectId: projectId })=>!!projectId && projectSet.has(projectId);
};

});

parcelRegister("8wcaA", function(module, exports) {

$parcel$export(module.exports, "issueTypeMatcherCreator", () => $1427bf4cc0e6bee2$export$48b17418005f8b9b);
const $1427bf4cc0e6bee2$export$48b17418005f8b9b = (issueTypeFilter)=>{
    const issueTypeSet = new Set(issueTypeFilter);
    return ({ type: type })=>issueTypeSet.has(type.id);
};

});

parcelRegister("7vODb", function(module, exports) {

$parcel$export(module.exports, "labelMatcherCreator", () => $40f84c5420493f05$export$71d90ee236f2e796);

const $40f84c5420493f05$export$71d90ee236f2e796 = (labelFilter)=>{
    const labelSet = new Set(labelFilter);
    return ({ labels: labels })=>labels !== undefined && (labels.some((label)=>labelSet.has(label)) || labels.length === 0 && labelSet.has((0, $15a528573ccd89ae$export$81ef49afbbead0a1)));
};

});

parcelRegister("bliRS", function(module, exports) {

$parcel$export(module.exports, "requestTypeMatcherCreator", () => $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba);
const $0e9572c0a83b3cdc$export$d04e41d82fbfb8ba = (requestTypeFilter)=>{
    const requestTypeSet = new Set(requestTypeFilter);
    return ({ requestTypeId: requestTypeId })=>!!requestTypeId && requestTypeSet.has(requestTypeId);
};

});

parcelRegister("iZeAQ", function(module, exports) {

$parcel$export(module.exports, "sprintMatcherCreator", () => $18f99efa97d4433e$export$4706275ba29d0c7);
const $18f99efa97d4433e$export$4706275ba29d0c7 = (sprintFilter)=>({ sprintId: sprintId })=>sprintFilter.includes(sprintId || '');

});

parcelRegister("ly5rg", function(module, exports) {

$parcel$export(module.exports, "statusCategoryMatcherCreator", () => $e669431e48d4db53$export$bb986e45707c6c33);
const $e669431e48d4db53$export$bb986e45707c6c33 = (statusCategoryFilter)=>{
    const statusCategorySet = new Set(statusCategoryFilter);
    return ({ statusCategoryId: statusCategoryId })=>statusCategoryId !== undefined && statusCategorySet.has(statusCategoryId);
};

});

parcelRegister("4nYh7", function(module, exports) {

$parcel$export(module.exports, "statusMatcherCreator", () => $931417eb46388f8b$export$c61724a440d8ea1d);
const $931417eb46388f8b$export$c61724a440d8ea1d = (statusFilter)=>{
    const statusSet = new Set(statusFilter);
    return ({ statusId: statusId })=>!!statusId && statusSet.has(statusId);
};

});

parcelRegister("gbBLn", function(module, exports) {

$parcel$export(module.exports, "textMatcherCreator", () => $b425285590e5a6aa$export$71a22d4a5d2891fc);

var $8QDwl = parcelRequire("8QDwl");

var $gJBT6 = parcelRequire("gJBT6");
const $b425285590e5a6aa$export$f3f2882e8b11d731 = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $b425285590e5a6aa$var$doesSummaryContainText = (summary, lowercaseText)=>summary.toLowerCase().includes(lowercaseText) || $b425285590e5a6aa$export$f3f2882e8b11d731(summary).toLowerCase().includes(lowercaseText);
const $b425285590e5a6aa$var$doesIssueKeyMatchLoosely = (key, lowercaseText)=>key !== undefined && key?.toLowerCase().includes(lowercaseText);
const $b425285590e5a6aa$var$createDisplayNameChecker = (text)=>{
    // It transforms a text to a regular expression.
    // eg: text='mi ze', the transformed regexp would be 'mi.*\s+ze'
    // which searches for 'mi' followed by anything then 'ze'.
    const pattern = text.split(/\s+/).map((0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))).join('.*\\s+');
    const regExp = new RegExp(pattern, 'i');
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((displayName)=>regExp.test(displayName));
};
const $b425285590e5a6aa$export$71a22d4a5d2891fc = (textFilter)=>{
    const lowercaseText = textFilter.toLowerCase();
    const doesDisplayNameMatchRegExp = $b425285590e5a6aa$var$createDisplayNameChecker(textFilter);
    return ({ summary: summary, key: key, assignee: assignee })=>summary && $b425285590e5a6aa$var$doesSummaryContainText(summary, lowercaseText) || $b425285590e5a6aa$var$doesIssueKeyMatchLoosely(key, lowercaseText) || assignee !== undefined && doesDisplayNameMatchRegExp(assignee.displayName);
};

});

parcelRegister("gw6jA", function(module, exports) {

$parcel$export(module.exports, "versionMatcherCreator", () => $f7a5a8a45b854dff$export$fb114a888e0e17b4);

const $f7a5a8a45b854dff$export$fb114a888e0e17b4 = (versionFilter)=>{
    const versionSet = new Set(versionFilter);
    return ({ versionIds: versionIds })=>versionIds !== undefined && (versionIds.some((versionId)=>versionSet.has(versionId)) || versionIds.length === 0 && versionSet.has((0, $15a528573ccd89ae$export$ac95b4b2317d4b33)));
};

});



parcelRegister("2VkyK", function(module, exports) {

$parcel$export(module.exports, "getIssuesMedia", () => $044dc117eedc593d$export$f7bdab95f5be7b0a);
$parcel$export(module.exports, "getIssueMedia", () => $044dc117eedc593d$export$9596202b205d705);
$parcel$export(module.exports, "isIssueMediaHiddenByUser", () => $044dc117eedc593d$export$7ed559c90d15c6ab);

var $9XE6b = parcelRequire("9XE6b");

var $67Z81 = parcelRequire("67Z81");
const $044dc117eedc593d$export$f7bdab95f5be7b0a = (state)=>(0, $67Z81.getEntities)(state).issueMedia;
const $044dc117eedc593d$export$9596202b205d705 = (state, issueId)=>$044dc117eedc593d$export$f7bdab95f5be7b0a(state)[String(issueId)];
const $044dc117eedc593d$export$7ed559c90d15c6ab = (state, issueId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($044dc117eedc593d$export$9596202b205d705(state, issueId), [
        'isHiddenByUser'
    ], false);

});

parcelRegister("6ALx6", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayFilterRefinement", () => $d19286c78b9048ae$export$5eac60086a6ca181);
/**
 * Function to determine if the new filter refinement should be displayed
 */ const $d19286c78b9048ae$export$5eac60086a6ca181 = ({ isIncrementPlanningBoard: isIncrementPlanningBoard, isCMPBoard: isCMPBoard, isJSMBoard: isJSMBoard, isJSWBoard: isJSWBoard })=>!isIncrementPlanningBoard && !isCMPBoard && !isJSMBoard && isJSWBoard;

});




parcelRegister("2obSb", function(module, exports) {

$parcel$export(module.exports, "default", () => $0052f06985acee83$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");


var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $dNGbd = parcelRequire("dNGbd");
const $0052f06985acee83$var$mapStateToProps = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    return {
        canAccessCustomFilterSettings: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !(0, $67Z81.getIsCMPBoard)(state),
        customFiltersSettingsUrl: (0, $eph8m.getManageCustomFiltersUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state))
    };
};
var $0052f06985acee83$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($0052f06985acee83$var$mapStateToProps, {})((0, $dNGbd.default));

});
parcelRegister("dNGbd", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24d83ace57b2f3$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8igKv = parcelRequire("8igKv");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");

var $jJ5ra = parcelRequire("jJ5ra");
const $9d24d83ace57b2f3$var$CustomFilterFailed = ({ id: id, customFiltersSettingsUrl: customFiltersSettingsUrl, canAccessCustomFilterSettings: canAccessCustomFilterSettings, onDismissed: onDismissed = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dismissFlag = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $14uhY.setReturnToProjectUrl)();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'customFilterFailedFlagLink', {
            canAccessCustomFilterSettings: canAccessCustomFilterSettings
        });
        onDismissed(id);
    }, [
        canAccessCustomFilterSettings,
        id,
        onDismissed
    ]);
    return canAccessCustomFilterSettings ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        messageId: props.messageId ?? `software-board.flags.custom-filter-failed.warning-flag.adminUser.${id}`,
        messageType: props.messageType ?? 'transactional',
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $jJ5ra.default).adminUserTitle),
        description: formatMessage((0, $jJ5ra.default).adminUserDescription),
        actions: [
            {
                content: formatMessage((0, $jJ5ra.default).adminUserActionLink),
                href: customFiltersSettingsUrl,
                target: '_blank',
                onClick: dismissFlag
            }
        ]
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8igKv.default), {
        messageId: props.messageId ?? `software-board.flags.custom-filter-failed.warning-flag.endUser.${id}`,
        messageType: props.messageType ?? 'transactional',
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $jJ5ra.default).endUserTitle),
        description: formatMessage((0, $jJ5ra.default).endUserDescription),
        actions: [
            {
                content: formatMessage((0, $jJ5ra.default).endUserActionLink),
                onClick: dismissFlag
            }
        ]
    });
};
var $9d24d83ace57b2f3$export$2e2bcd8739ae039 = $9d24d83ace57b2f3$var$CustomFilterFailed;

});
parcelRegister("14uhY", function(module, exports) {

$parcel$export(module.exports, "setReturnToProjectUrl", () => $5f614763a26e8877$export$127f7bd1c092fc8f);
$parcel$export(module.exports, "getReturnToProjectUrl", () => $5f614763a26e8877$export$575dc7c4a154874b);

var $eNf8a = parcelRequire("eNf8a");
const $5f614763a26e8877$var$RETURN_TO_PROJECT_URL = 'returnToProjectUrl';
const $5f614763a26e8877$var$sessionStorage = (0, $eNf8a.createSessionExpirableStorageProvider)('navigation');
const $5f614763a26e8877$export$127f7bd1c092fc8f = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    $5f614763a26e8877$var$sessionStorage.set($5f614763a26e8877$var$RETURN_TO_PROJECT_URL, window.location.pathname + window.location.search);
};
const $5f614763a26e8877$export$575dc7c4a154874b = ()=>String($5f614763a26e8877$var$sessionStorage.get($5f614763a26e8877$var$RETURN_TO_PROJECT_URL) || '');

});

parcelRegister("jJ5ra", function(module, exports) {

$parcel$export(module.exports, "default", () => $438d52296c72073d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $438d52296c72073d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    adminUserTitle: {
        "id": "software.main.flags.custom-filter-failed.admin-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    adminUserDescription: {
        "id": "software.main.flags.custom-filter-failed.admin-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. You can check your filter queries and try again."
    },
    adminUserActionLink: {
        "id": "software.main.flags.custom-filter-failed.admin-user-action-link",
        "defaultMessage": "Manage custom filters"
    },
    endUserTitle: {
        "id": "software.main.flags.custom-filter-failed.end-user-title",
        "defaultMessage": "We couldn't load your filters"
    },
    endUserDescription: {
        "id": "software.main.flags.custom-filter-failed.end-user-description",
        "defaultMessage": "One or more of your filters can't be used right now. Contact your Jira admin to check the filter queries, then try again."
    },
    endUserActionLink: {
        "id": "software.main.flags.custom-filter-failed.end-user-action-link",
        "defaultMessage": "OK"
    }
});

});



parcelRegister("elCuX", function(module, exports) {

$parcel$export(module.exports, "default", () => $027735dadff37032$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");


var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $ldtVh = parcelRequire("ldtVh");
const $027735dadff37032$var$mapStateToProps = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    return {
        contextPath: (0, $67Z81.contextPathSelector)(state),
        canEditBoard: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !(0, $67Z81.getIsCMPBoard)(state),
        wantedUrl: (0, $eph8m.getIssueTypesUrl)((0, $67Z81.projectKeySelector)(state))
    };
};
var $027735dadff37032$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($027735dadff37032$var$mapStateToProps, {})((0, $ldtVh.default));

});
parcelRegister("ldtVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $86b41bca2ec32d00$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $7f4tk = parcelRequire("7f4tk");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $2bQEl = parcelRequire("2bQEl");

var $4OoQs = parcelRequire("4OoQs");
const $86b41bca2ec32d00$var$fetchIssueTypes = (contextPath, fetchOptions, missingIssueType)=>(0, $7f4tk.default)((0, $2bQEl.getIssueTypes)(contextPath, missingIssueType), fetchOptions);
const $86b41bca2ec32d00$var$fetchOptions = {
    method: 'GET'
};
const $86b41bca2ec32d00$var$MissingIssueTypeFlag = ({ id: id, onDismissed: onDismissed, contextPath: contextPath, canEditBoard: canEditBoard, wantedUrl: wantedUrl, missingIssueType: missingIssueType })=>{
    const flagShown = (0, $5uXOq.useRef)(false);
    const [issueType, setIssueType] = (0, $5uXOq.useState)({
        name: '',
        isName: false
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const missingIssueTypeDescriptionMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OoQs.default).missingIssueTypeDescriptionIssueTermRefresh : (0, $4OoQs.default).missingIssueTypeDescription;
    const defaultMissingIssueTypeDescriptionMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OoQs.default).defaultMissingIssueTypeDescriptionIssueTermRefresh : (0, $4OoQs.default).defaultMissingIssueTypeDescription;
    (0, $5uXOq.useEffect)(()=>{
        $86b41bca2ec32d00$var$fetchIssueTypes(contextPath, $86b41bca2ec32d00$var$fetchOptions, missingIssueType).then(({ name: name })=>{
            setIssueType({
                name: name,
                isName: true
            });
        }).catch(()=>{
            setIssueType({
                name: missingIssueType,
                isName: false
            });
        });
    }, [
        missingIssueType,
        contextPath
    ]);
    if (flagShown.current || !issueType.name) return null;
    if (!flagShown.current) flagShown.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.WarningFlag), {
        id: id,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OoQs.default).missingIssueTypeTitleIssueTermRefresh : (0, $4OoQs.default).missingIssueTypeTitle),
        description: formatMessage(issueType.isName ? missingIssueTypeDescriptionMessage : defaultMissingIssueTypeDescriptionMessage, {
            missingIssueTypeName: issueType.name,
            b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, chunks)
        }),
        actions: canEditBoard ? [
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4OoQs.default).adminIssueTypeActionLinkIssueTermRefresh : (0, $4OoQs.default).adminIssueTypeActionLink),
                href: wantedUrl,
                target: '_blank',
                onClick: ()=>onDismissed(id)
            }
        ] : []
    });
};
var $86b41bca2ec32d00$export$2e2bcd8739ae039 = $86b41bca2ec32d00$var$MissingIssueTypeFlag;

});
parcelRegister("2bQEl", function(module, exports) {

$parcel$export(module.exports, "STATUS_CATEGORY_URL", () => $0b1ad1b6b9c53193$export$5bea8fb5e10d6ac0);
$parcel$export(module.exports, "getJSWGraphQlEndpointUrl", () => $0b1ad1b6b9c53193$export$fecea24c8d34782b);
$parcel$export(module.exports, "getIssueEditUrl", () => $0b1ad1b6b9c53193$export$5d595c3dde9874c);
$parcel$export(module.exports, "getIssueTransitionWithoutColumnUrl", () => $0b1ad1b6b9c53193$export$70f64f88eb86fdc0);
$parcel$export(module.exports, "getIssueTransitionUrl", () => $0b1ad1b6b9c53193$export$5b2875d63118103e);
$parcel$export(module.exports, "getBulkIssueRankUrl", () => $0b1ad1b6b9c53193$export$29d30514d27cd4d0);
$parcel$export(module.exports, "getCurrentUserDataFromAccountIdUrl", () => $0b1ad1b6b9c53193$export$cd6324a706a70a6d);
$parcel$export(module.exports, "getCardMediaUrl", () => $0b1ad1b6b9c53193$export$8842e395ceb4fa93);
$parcel$export(module.exports, "getIssueMediaVisibilityChangeUrl", () => $0b1ad1b6b9c53193$export$88504e44da09203f);
$parcel$export(module.exports, "getBacklogIssueMoveUrl", () => $0b1ad1b6b9c53193$export$1ea50550b3eb8a6e);
$parcel$export(module.exports, "getIssuesMoveToBacklogUrl", () => $0b1ad1b6b9c53193$export$e59f8900eb9b733f);
$parcel$export(module.exports, "getFeaturesUrl", () => $0b1ad1b6b9c53193$export$979ec3e17da473a5);
$parcel$export(module.exports, "getNextGenBacklogUrl", () => $0b1ad1b6b9c53193$export$fd40fa3fee2372f8);
$parcel$export(module.exports, "getVersionUrl", () => $0b1ad1b6b9c53193$export$f6b360c59c43e332);
$parcel$export(module.exports, "getIssueTypes", () => $0b1ad1b6b9c53193$export$4cf4b24b88599615);
const $0b1ad1b6b9c53193$export$5bea8fb5e10d6ac0 = '/rest/api/2/statuscategory?operation=StatusCategory';
const $0b1ad1b6b9c53193$export$fecea24c8d34782b = (contextPath)=>`${contextPath}/jsw2/graphql`;
const $0b1ad1b6b9c53193$export$a0b9ef211caa7367 = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnCreate`;
const $0b1ad1b6b9c53193$export$145570eb57e3197c = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnDelete`;
const $0b1ad1b6b9c53193$export$7b704b3494f4d7 = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnRename`;
const $0b1ad1b6b9c53193$export$fff9fff088167caa = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnRank`;
const $0b1ad1b6b9c53193$export$5d2970d85cd0112a = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareColumnSetLimit`;
const $0b1ad1b6b9c53193$export$bf62d1e5e809d480 = (projectId, contextPath)=>`${contextPath}/rest/internal/2/invite-user/project/${projectId}/invitation-settings`;
const $0b1ad1b6b9c53193$export$5dcaad3da99bf44f = (projectId, contextPath)=>`${contextPath}/rest/internal/2/invite-user/project/${projectId}/invitation-settings`;
const $0b1ad1b6b9c53193$export$ac9729118da67b8b = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=CompleteSprintMetadata`;
const $0b1ad1b6b9c53193$export$7cb1f34c2c8b82ed = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=SoftwareBoardClearCards`;
const $0b1ad1b6b9c53193$export$796a7264fa69ddca = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=FilteredCardIds`;
const $0b1ad1b6b9c53193$export$1f40a3867ec104dd = (contextPath)=>`${$0b1ad1b6b9c53193$export$fecea24c8d34782b(contextPath)}?operation=BoardCardCreate`;
const $0b1ad1b6b9c53193$export$a92012cc19d68266 = (contextPath)=>`${contextPath}/rest/api/2/issue`;
const $0b1ad1b6b9c53193$export$5d595c3dde9874c = (contextPath, issueKey)=>`${contextPath}/rest/api/2/issue/${issueKey}?operation=IssueEdit`;
const $0b1ad1b6b9c53193$export$70f64f88eb86fdc0 = (contextPath)=>`${contextPath}/rest/greenhopper/1.0/board/issues/transition`;
const $0b1ad1b6b9c53193$export$5b2875d63118103e = ()=>'/rest/greenhopper/1.0/xboard/transitionAndRank';
const $0b1ad1b6b9c53193$export$29d30514d27cd4d0 = ()=>'/rest/greenhopper/1.0/rank';
const $0b1ad1b6b9c53193$export$cd6324a706a70a6d = (contextPath, accountId)=>`${contextPath}/rest/api/3/user?accountId=${encodeURIComponent(accountId)}&operation=UserData`;
const $0b1ad1b6b9c53193$export$505a9f131607d070 = (contextPath, rapidViewId)=>`${contextPath}/secure/RapidBoard.jspa?rapidView=${rapidViewId}`;
const $0b1ad1b6b9c53193$export$4742ff7bed4e2624 = (contextPath, rapidViewId, additionalParams = [])=>{
    const paramString = additionalParams.map((param)=>`&${param}`).join('');
    return `${contextPath}/secure/RapidBoard.jspa?rapidView=${rapidViewId}&view=planning${paramString}`;
};
const $0b1ad1b6b9c53193$export$8842e395ceb4fa93 = (contextPath, rapidViewId, display)=>`${contextPath}/rest/greenhopper/1.0/xboard/work/media?rapidViewId=${rapidViewId}&display=${String(display)}&operation=CardMedia`;
const $0b1ad1b6b9c53193$export$88504e44da09203f = (contextPath, issueId)=>`${contextPath}/rest/greenhopper/1.0/xboard/work/media/${issueId}?operation=IssueMediaVisibilityChange`;
const $0b1ad1b6b9c53193$export$c17be2774c33b6d4 = (contextPath, rapidViewId)=>`${contextPath}/rest/agile/1.0/board/${rapidViewId}/properties?operation=BoardPropertyKeys`;
const $0b1ad1b6b9c53193$export$cb1e8590d79b2c2c = (contextPath, rapidViewId, propertyKey)=>`${contextPath}/rest/agile/1.0/board/${rapidViewId}/properties/${propertyKey}`;
const $0b1ad1b6b9c53193$export$1ea50550b3eb8a6e = (contextPath)=>`${contextPath}/rest/greenhopper/1.0/xboard/migrateFirstColumnToBacklog?operation=MigrateFirstColumnToBacklog`;
const $0b1ad1b6b9c53193$export$e59f8900eb9b733f = (contextPath)=>`${contextPath}/rest/greenhopper/1.0/xboard/assignToListAndRank?operation=IssuesMoveToBacklog`;
const $0b1ad1b6b9c53193$export$33182ffdef0919b7 = ()=>'/gateway/api/pubsub/subscribe';
const $0b1ad1b6b9c53193$export$979ec3e17da473a5 = (contextPath, rapidViewId)=>`${contextPath}/rest/agile/latest/board/${rapidViewId}/features?operation=Features`;
const $0b1ad1b6b9c53193$export$fd40fa3fee2372f8 = (contextPath, projectKey, rapidViewId)=>`${contextPath}/jira/software/projects/${projectKey}/boards/${rapidViewId}/backlog`;
const $0b1ad1b6b9c53193$export$f6b360c59c43e332 = (rapidViewId)=>`/rest/greenhopper/1.0/xboard/work/versions?rapidViewId=${rapidViewId}&operation=Versions`;
const $0b1ad1b6b9c53193$export$4cf4b24b88599615 = (contextPath, issueTypeId)=>`${contextPath}/rest/api/3/issuetype/${issueTypeId}`;
const $0b1ad1b6b9c53193$export$c0b167d82b41a1c = (contextPath)=>`${contextPath}/rest/greenhopper/1.0/rapidview/addtohistory`;
const $0b1ad1b6b9c53193$export$fd09219a8cde557b = (projectId, contextPath)=>`${contextPath}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true`;
const $0b1ad1b6b9c53193$export$d5badd8c822522b9 = (projectKey, contextPath, hasCurrentMember)=>`${contextPath}/rest/api/3/project/${projectKey}/roledetails?excludeConnectAddons=true${hasCurrentMember ? '&currentMember=true' : ''}`;
const $0b1ad1b6b9c53193$export$aec63e27a1c559f6 = ()=>'/rest/api/2/user/assignable/search';
const $0b1ad1b6b9c53193$export$6ff259328e55f46 = ()=>'/rest/api/3/search';
const $0b1ad1b6b9c53193$export$a4b3b6dec5572b97 = ()=>'/rest/graphql/1';
const $0b1ad1b6b9c53193$export$bd35faba0afabad2 = ()=>'/rest/api/3/issue/:issueKey';
const $0b1ad1b6b9c53193$export$160a21daf4cb73b = ()=>'/rest/api/3/issue/:issueKey/assignee';
const $0b1ad1b6b9c53193$export$accc30140c2c7e1b = ()=>'/rest/internal/simplified/1.0/projects/:projectId/issues/:issueId/children';
const $0b1ad1b6b9c53193$export$aefb19023b2eda55 = ()=>'/rest/gira/1/';

});

parcelRegister("4OoQs", function(module, exports) {

$parcel$export(module.exports, "default", () => $5453f5c6883e143e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5453f5c6883e143e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    missingIssueTypeTitle: {
        "id": "software.main.flags.missing-issue-type.missing-issue-type-title",
        "defaultMessage": "Issue types in this board and project don't match"
    },
    missingIssueTypeDescription: {
        "id": "software.main.flags.missing-issue-type.missing-issue-type-description",
        "defaultMessage": "The <b>{missingIssueTypeName}</b> issue type is used on this board, but isn't configured for this project."
    },
    defaultMissingIssueTypeDescription: {
        "id": "software.main.flags.missing-issue-type.default-missing-issue-type-description",
        "defaultMessage": "The issue type <b>{missingIssueTypeName}</b> is used on this board, but isn't configured for this project."
    },
    adminIssueTypeActionLink: {
        "id": "software.main.flags.missing-issue-type.admin-issue-type-action-link",
        "defaultMessage": "Manage issue types"
    },
    missingIssueTypeTitleIssueTermRefresh: {
        "id": "software.main.flags.missing-issue-type.missing-issue-type-title-issue-term-refresh",
        "defaultMessage": "Work types in this board and project don't match"
    },
    missingIssueTypeDescriptionIssueTermRefresh: {
        "id": "software.main.flags.missing-issue-type.missing-issue-type-description-issue-term-refresh",
        "defaultMessage": "The <b>{missingIssueTypeName}</b> work type is used on this board, but isn't configured for this project."
    },
    defaultMissingIssueTypeDescriptionIssueTermRefresh: {
        "id": "software.main.flags.missing-issue-type.default-missing-issue-type-description-issue-term-refresh",
        "defaultMessage": "The work type <b>{missingIssueTypeName}</b> is used on this board, but isn't configured for this project."
    },
    adminIssueTypeActionLinkIssueTermRefresh: {
        "id": "software.main.flags.missing-issue-type.admin-issue-type-action-link-issue-term-refresh",
        "defaultMessage": "Manage work types"
    }
});

});




parcelRegister("4ldpW", function(module, exports) {

$parcel$export(module.exports, "default", () => $b646dc7d2474321c$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $aud83 = parcelRequire("aud83");


var $dnW4F = parcelRequire("dnW4F");

var $j6QAp = parcelRequire("j6QAp");
/**
 * Despite incorrect types due to use of the `icepick` library setIn operators
 * most filters only accept array values. The exception is the text search.
 */ function $b646dc7d2474321c$var$castToArray(queryValue) {
    if (queryValue && Array.isArray(queryValue)) return queryValue.map((value)=>String(value));
    return [
        String(queryValue)
    ];
}
function $b646dc7d2474321c$export$2e2bcd8739ae039(isCMPBoard, isJqlFilterEnabled) {
    if (isJqlFilterEnabled) {
        const filterTypesFilterRefinement = [
            {
                urlKey: 'jql',
                transform: $aud83.string,
                getValueForUrl: (state)=>state.ui.workFilters?.values[0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f] ?? undefined,
                setValueFromUrl: (dispatch, value)=>{
                    if (value) {
                        const jql = String(value);
                        dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f), jql));
                        const workFilters = (0, $j6QAp.getWorkFiltersFromJql)(jql);
                        if (workFilters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$f8f7545d2bb78afb), workFilters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb]));
                        if (workFilters[0, $dcff40112356dfc1$export$d597759d33be802e]) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$d597759d33be802e), workFilters[0, $dcff40112356dfc1$export$d597759d33be802e]));
                        if (workFilters[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7]) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$37aee82a3cb1e8f7), workFilters[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7]));
                    }
                }
            },
            {
                urlKey: 'dependencies',
                transform: $aud83.array,
                getValueForUrl: (state)=>{
                    const filters = state.ui.workFilters?.values[0, $dcff40112356dfc1$export$db362e2d293fe52e] || [];
                    return filters.length ? filters : undefined;
                },
                setValueFromUrl: (dispatch, values)=>{
                    if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$db362e2d293fe52e), $b646dc7d2474321c$var$castToArray(values)));
                }
            } /**
			 * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
			 * please refer to src/packages/software/filters/src/ui/stateless/index.tsx
			 */ ,
            {
                urlKey: 'project',
                transform: $aud83.array,
                getValueForUrl: (state)=>{
                    const filters = state.ui.workFilters?.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c] || [];
                    return filters.length ? filters : undefined;
                },
                setValueFromUrl: (dispatch, values)=>{
                    if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$401f4b6eda6a369c), $b646dc7d2474321c$var$castToArray(values)));
                }
            },
            {
                urlKey: isCMPBoard ? 'quickFilter' : 'customFilter',
                transform: isCMPBoard ? $aud83.multiple : $aud83.array,
                getValueForUrl: (state)=>{
                    const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                        'ui',
                        'workFilters',
                        'values',
                        (0, $dcff40112356dfc1$export$68d693c35a8d8866)
                    ], []);
                    return filters.length ? filters : undefined;
                },
                setValueFromUrl: (dispatch, values)=>{
                    // CMP only. TMP boards do NOT support this yet
                    if (values && isCMPBoard) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$68d693c35a8d8866), $b646dc7d2474321c$var$castToArray(values)));
                }
            }
        ];
        return filterTypesFilterRefinement;
    }
    const filterTypes = [
        {
            urlKey: isCMPBoard ? 'search' : 'text',
            transform: $aud83.string,
            getValueForUrl: (state)=>state.ui.workFilters?.values[0, $dcff40112356dfc1$export$d597759d33be802e],
            setValueFromUrl: (dispatch, value)=>{
                if (value) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$d597759d33be802e), String(value)));
            }
        },
        {
            urlKey: 'assignee',
            transform: isCMPBoard ? $aud83.multiple : $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$f8f7545d2bb78afb)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$f8f7545d2bb78afb), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'label',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$37aee82a3cb1e8f7), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'issueParent',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$2a4f270075a033de)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$2a4f270075a033de), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'issueType',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$ebb48b08205007c5)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$ebb48b08205007c5), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: isCMPBoard ? 'quickFilter' : 'customFilter',
            transform: isCMPBoard ? $aud83.multiple : $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$68d693c35a8d8866)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                // CMP only. TMP boards do NOT support this yet
                if (values && isCMPBoard) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$68d693c35a8d8866), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'sprints',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(state, [
                    'ui',
                    'workFilters',
                    'values',
                    (0, $dcff40112356dfc1$export$a316570a0dbfd2b0)
                ], []);
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$a316570a0dbfd2b0), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        /**
		 * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
		 * please refer to src/packages/software/filters/src/ui/stateless/index.tsx
		 */ {
            urlKey: 'project',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = state.ui.workFilters?.values[0, $dcff40112356dfc1$export$401f4b6eda6a369c] || [];
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$401f4b6eda6a369c), $b646dc7d2474321c$var$castToArray(values)));
            }
        },
        {
            urlKey: 'dependencies',
            transform: $aud83.array,
            getValueForUrl: (state)=>{
                const filters = state.ui.workFilters?.values[0, $dcff40112356dfc1$export$db362e2d293fe52e] || [];
                return filters.length ? filters : undefined;
            },
            setValueFromUrl: (dispatch, values)=>{
                if (values) dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$db362e2d293fe52e), $b646dc7d2474321c$var$castToArray(values)));
            }
        }
    ];
    return filterTypes;
}

});
parcelRegister("aud83", function(module, exports) {

$parcel$export(module.exports, "string", () => $b7c0843f761cef5f$export$22b082955e083ec3);
$parcel$export(module.exports, "bool", () => $b7c0843f761cef5f$export$87b259aa03e3d267);
$parcel$export(module.exports, "array", () => $b7c0843f761cef5f$export$2f23118c22fb2630);
$parcel$export(module.exports, "multiple", () => $b7c0843f761cef5f$export$939ddaa3205df08e);
$parcel$export(module.exports, "number", () => $b7c0843f761cef5f$export$98e628dec113755e);

var $etyzk = parcelRequire("etyzk");
const $b7c0843f761cef5f$export$22b082955e083ec3 = {
    stringify: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk))),
    parse: (0, (/*@__PURE__*/$parcel$interopDefault($etyzk)))
};
const $b7c0843f761cef5f$export$87b259aa03e3d267 = {
    stringify: (value)=>String(value),
    parse: (value)=>{
        if (value === 'true') return true;
        if (value === 'false') return false;
        return undefined;
    }
};
const $b7c0843f761cef5f$export$2f23118c22fb2630 = {
    stringify: (value)=>value && Array.isArray(value) ? value.join(',') : undefined,
    parse: (value)=>typeof value === 'string' ? value?.split(',') : undefined
};
const $b7c0843f761cef5f$export$939ddaa3205df08e = {
    stringify: (value)=>{
        if (!value || !Array.isArray(value)) return undefined;
        return value.length === 1 ? value[0] : value;
    },
    parse: (value)=>value && Array.isArray(value) ? value : [
            String(value)
        ]
};
const $b7c0843f761cef5f$export$98e628dec113755e = {
    stringify: (value)=>`${value}`,
    parse: (value)=>Number(value)
};

});

parcelRegister("j6QAp", function(module, exports) {

$parcel$export(module.exports, "getWorkFiltersFromJql", () => $caf41a0c198c655e$export$dcd369dc18372fc2);

var $eK6AG = parcelRequire("eK6AG");
var $7CDw0 = parcelRequire("7CDw0");

var $4R6GH = parcelRequire("4R6GH");


var $6Yo6U = parcelRequire("6Yo6U");
const $caf41a0c198c655e$export$dcd369dc18372fc2 = (jql)=>{
    const ast = new (0, $eK6AG.JastBuilder)().build(jql);
    const workFilters = {};
    (0, $7CDw0.walkAST)({
        enterTerminalClause (terminalClause) {
            const field = terminalClause.field.value.toLowerCase();
            const workFilter = $caf41a0c198c655e$var$mapFieldJqlTermToWorkFilter(field);
            if (workFilter && terminalClause.operand) {
                const operandValues = (0, $6Yo6U.getOperandValues)(terminalClause.operand);
                switch(workFilter){
                    case 0, $dcff40112356dfc1$export$f8f7545d2bb78afb:
                        workFilters[workFilter] = operandValues.map((name)=>name === 'empty' ? 'unassigned' : name);
                        break;
                    case 0, $dcff40112356dfc1$export$d597759d33be802e:
                        if ((0, $4R6GH.fg)('filter_refinement_set_work_filters_after_search')) workFilters[workFilter] = operandValues[0].replace(/\*/g, '').trim();
                        else workFilters[workFilter] = operandValues[0];
                        break;
                    case 0, $dcff40112356dfc1$export$37aee82a3cb1e8f7:
                        workFilters[workFilter] = operandValues;
                        break;
                    default:
                        break;
                }
            }
        }
    }, ast);
    return workFilters;
};
const $caf41a0c198c655e$var$mapFieldJqlTermToWorkFilter = (jqlTerm)=>{
    switch(jqlTerm){
        case 'assignee':
            return 0, $dcff40112356dfc1$export$f8f7545d2bb78afb;
        case 'textfields':
            return 0, $dcff40112356dfc1$export$d597759d33be802e;
        case 'labels':
            return 0, $dcff40112356dfc1$export$37aee82a3cb1e8f7;
        default:
            return null;
    }
};

});
parcelRegister("7CDw0", function(module, exports) {

$parcel$export(module.exports, "walkAST", () => $7a197641df0f0db3$export$a8de6ce748deffac);
const $7a197641df0f0db3$export$a8de6ce748deffac = (listener, jast)=>{
    jast.query && $7a197641df0f0db3$var$walkNode(listener, jast.query);
};
const $7a197641df0f0db3$var$walkNode = (listener, node)=>{
    listener.enterEveryNode && listener.enterEveryNode(node);
    node.enterNode(listener);
    node.getChildren().forEach((child)=>$7a197641df0f0db3$var$walkNode(listener, child));
    node.exitNode(listener);
    listener.exitEveryNode && listener.exitEveryNode(node);
};

});

parcelRegister("6Yo6U", function(module, exports) {

$parcel$export(module.exports, "getOperandValues", () => $41d763c15b456826$export$5a1240d5adb6a9cb);

var $dDkmN = parcelRequire("dDkmN");

const $41d763c15b456826$export$5a1240d5adb6a9cb = (operand)=>{
    switch(operand?.operandType){
        case 0, $49b29ef7baa2a152$export$f6049126fd97001f:
        case 0, $49b29ef7baa2a152$export$38accfc5a5d1c113:
            return [
                operand.value
            ];
        case 0, $49b29ef7baa2a152$export$fabec4aebba3f4df:
            return (0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))(...operand.values.map((operandValue)=>$41d763c15b456826$export$5a1240d5adb6a9cb(operandValue)));
        default:
            return [];
    }
};

});
parcelRegister("dDkmN", function(module, exports) {

var $ekcP3 = parcelRequire("ekcP3");

var $g7i7g = parcelRequire("g7i7g");

var $7CoLY = parcelRequire("7CoLY");

var $f3SOL = parcelRequire("f3SOL");
/**
 * Creates an array of unique values, in order, from all given arrays using
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {...Array} [arrays] The arrays to inspect.
 * @returns {Array} Returns the new array of combined values.
 * @example
 *
 * _.union([2], [1, 2]);
 * // => [2, 1]
 */ var $9eceb74c74389aa2$var$union = $g7i7g(function(arrays) {
    return $7CoLY($ekcP3(arrays, 1, $f3SOL, true));
});
module.exports = $9eceb74c74389aa2$var$union;

});

const $49b29ef7baa2a152$export$38accfc5a5d1c113 = 'value';
const $49b29ef7baa2a152$export$f6049126fd97001f = 'keyword';
const $49b29ef7baa2a152$export$19c7c729db381f9d = 'function';
const $49b29ef7baa2a152$export$fabec4aebba3f4df = 'list';
const $49b29ef7baa2a152$export$1c46dca02aac24dd = 'empty';




parcelRegister("jQCwr", function(module, exports) {

$parcel$export(module.exports, "getDetailViewWidthRatio", () => $baaf486e7d950ad6$export$5a9c556da9744b1b);
$parcel$export(module.exports, "setDetailViewWidthRatio", () => $baaf486e7d950ad6$export$d194f7c4bdc33538);
$parcel$export(module.exports, "getCollapsedSwimlanes", () => $baaf486e7d950ad6$export$676aff045298a75d);
$parcel$export(module.exports, "setCollapsedSwimlanes", () => $baaf486e7d950ad6$export$b621d43268491671);
$parcel$export(module.exports, "setSwimlaneModeSetting", () => $baaf486e7d950ad6$export$cc714c2bb2344bfd);
$parcel$export(module.exports, "getSwimlaneModeSetting", () => $baaf486e7d950ad6$export$1708c8217a67f3f9);

var $9XE6b = parcelRequire("9XE6b");

var $bSSG7 = parcelRequire("bSSG7");
// app provides it's unique prefix
const $baaf486e7d950ad6$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('software');
const $baaf486e7d950ad6$var$COLLAPSED_SWIMLANES = 'collapsed-swimlanes';
const $baaf486e7d950ad6$var$DETAIL_VIEW_WIDTH_RATIO = 'gh.detailViewWidth';
const $baaf486e7d950ad6$var$GROUP_BY_SELECTION = 'gh.groupBySelection.';
const $baaf486e7d950ad6$export$5a9c556da9744b1b = ()=>{
    const value = $baaf486e7d950ad6$var$localStorage.get($baaf486e7d950ad6$var$DETAIL_VIEW_WIDTH_RATIO);
    return value ? Number(value) : 0;
};
const $baaf486e7d950ad6$export$d194f7c4bdc33538 = (ratio)=>$baaf486e7d950ad6$var$localStorage.set($baaf486e7d950ad6$var$DETAIL_VIEW_WIDTH_RATIO, ratio);
const $baaf486e7d950ad6$export$676aff045298a75d = (boardId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($baaf486e7d950ad6$var$localStorage.get($baaf486e7d950ad6$var$COLLAPSED_SWIMLANES), [
        String(boardId)
    ], []);
const $baaf486e7d950ad6$export$b621d43268491671 = (boardId, swimlanesId)=>$baaf486e7d950ad6$var$localStorage.set($baaf486e7d950ad6$var$COLLAPSED_SWIMLANES, {
        [boardId]: swimlanesId
    });
const $baaf486e7d950ad6$export$cc714c2bb2344bfd = (boardId, groupBy)=>{
    $baaf486e7d950ad6$var$localStorage.set(`${$baaf486e7d950ad6$var$GROUP_BY_SELECTION}${boardId}`, groupBy);
};
const $baaf486e7d950ad6$export$1708c8217a67f3f9 = (boardId)=>{
    const data = $baaf486e7d950ad6$var$localStorage.get(`${$baaf486e7d950ad6$var$GROUP_BY_SELECTION}${boardId}`);
    if (!data) return null;
    return data;
};

});

parcelRegister("jM0wW", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6fb7ad3eb61a656$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $aud83 = parcelRequire("aud83");

var $d1i1b = parcelRequire("d1i1b");

var $dW1HX = parcelRequire("dW1HX");

var $2ON1s = parcelRequire("2ON1s");

var $67Z81 = parcelRequire("67Z81");
function $d6fb7ad3eb61a656$export$2e2bcd8739ae039(isIncrementPlanningBoard = false) {
    /**
	 * We won't use any of the url keys listed below in increment planning boards.
	 */ if (isIncrementPlanningBoard) return [];
    return [
        {
            urlKey: 'selectedIssue',
            transform: $aud83.string,
            getValueForUrl: (state)=>{
                const key = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $67Z81.getUi)(state), [
                    'issueModal',
                    'selectedIssueKey'
                ], undefined);
                if (key) return key;
                return undefined;
            },
            setValueFromUrl: (dispatch, value)=>{
                if (value && typeof value === 'string') {
                    dispatch((0, $dW1HX.openIssueModal)(value));
                    dispatch((0, $d1i1b.cardAutoScrollRequestOnLoad)(value));
                }
            }
        },
        {
            urlKey: 'isInsightsOpen',
            transform: $aud83.bool,
            getValueForUrl: (state)=>{
                const key = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $67Z81.getUi)(state), [
                    'panels',
                    'INSIGHTS_PANEL'
                ], undefined);
                if (key) return key;
                return undefined;
            },
            setValueFromUrl: (dispatch, value)=>{
                if (value) dispatch((0, $2ON1s.openInsightsPanel)());
            }
        }
    ];
}

});
parcelRegister("d1i1b", function(module, exports) {

$parcel$export(module.exports, "CARD_AUTO_SCROLL", () => $737bec5b19c367b3$export$21e828c0e9d1105a);
$parcel$export(module.exports, "cardAutoScroll", () => $737bec5b19c367b3$export$274e46dc8e4633e0);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_REQUEST_ON_LOAD", () => $737bec5b19c367b3$export$a7d9dbfd9ccf9cd8);
$parcel$export(module.exports, "cardAutoScrollRequestOnLoad", () => $737bec5b19c367b3$export$f894c82154cc28a0);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_REQUEST_ON_FILTER", () => $737bec5b19c367b3$export$3a965e6001d5e2e9);
$parcel$export(module.exports, "cardAutoScrollRequestOnFilter", () => $737bec5b19c367b3$export$58d9ced87e626159);
$parcel$export(module.exports, "CARD_AUTO_SCROLL_UNSCHEDULED_COLUMN_ICC", () => $737bec5b19c367b3$export$fbb1bd2388e5c263);
$parcel$export(module.exports, "cardAutoScrollUnscheduledColumnIcc", () => $737bec5b19c367b3$export$ec5c5166fa42e94d);
const $737bec5b19c367b3$export$21e828c0e9d1105a = 'state.actions.card.CARD_AUTO_SCROLL';
const $737bec5b19c367b3$export$274e46dc8e4633e0 = (issueId)=>({
        type: $737bec5b19c367b3$export$21e828c0e9d1105a,
        payload: {
            issueId: issueId
        }
    });
const $737bec5b19c367b3$export$a7d9dbfd9ccf9cd8 = 'state.actions.card.CARD_AUTO_SCROLL_REQUEST_ON_LOAD';
const $737bec5b19c367b3$export$f894c82154cc28a0 = (issueKey)=>({
        type: $737bec5b19c367b3$export$a7d9dbfd9ccf9cd8,
        payload: {
            issueKey: issueKey
        }
    });
const $737bec5b19c367b3$export$3a965e6001d5e2e9 = 'state.actions.card.CARD_AUTO_SCROLL_REQUEST_ON_FILTER';
const $737bec5b19c367b3$export$58d9ced87e626159 = ()=>({
        type: $737bec5b19c367b3$export$3a965e6001d5e2e9
    });
const $737bec5b19c367b3$export$fbb1bd2388e5c263 = 'state.actions.card.CARD_AUTO_SCROLL_UNSCHEDULED_COLUMN_ICC';
const $737bec5b19c367b3$export$ec5c5166fa42e94d = (swimlaneId, isImmediate)=>({
        type: $737bec5b19c367b3$export$fbb1bd2388e5c263,
        payload: {
            swimlaneId: swimlaneId,
            isImmediate: isImmediate
        }
    });

});

parcelRegister("2ON1s", function(module, exports) {

$parcel$export(module.exports, "TOGGLE_PANEL", () => $b52f7c84c7e591b8$export$81879e9427948bf);
$parcel$export(module.exports, "togglePanel", () => $b52f7c84c7e591b8$export$67879b1cfc177b88);
$parcel$export(module.exports, "OPEN_INSIGHTS_PANEL", () => $b52f7c84c7e591b8$export$894891eae2c7b097);
$parcel$export(module.exports, "openInsightsPanel", () => $b52f7c84c7e591b8$export$ffae5ab992b11d10);
$parcel$export(module.exports, "CLOSE_INSIGHTS_PANEL", () => $b52f7c84c7e591b8$export$8e43d92e9c342d0);
$parcel$export(module.exports, "closeInsightsPanel", () => $b52f7c84c7e591b8$export$4fda8ba2e49f8d0c);
$parcel$export(module.exports, "CLOSE_VIEW_SETTINGS_PANEL", () => $b52f7c84c7e591b8$export$b1f480ba0abd2610);
$parcel$export(module.exports, "closeViewSettingsPanel", () => $b52f7c84c7e591b8$export$ef3e4b5eca4263a7);
const $b52f7c84c7e591b8$export$81879e9427948bf = 'state.actions.panels.TOGGLE_PANEL';
const $b52f7c84c7e591b8$export$67879b1cfc177b88 = (panel)=>({
        type: $b52f7c84c7e591b8$export$81879e9427948bf,
        payload: {
            panel: panel
        }
    });
const $b52f7c84c7e591b8$export$894891eae2c7b097 = 'state.actions.panels.OPEN_INSIGHTS_PANEL';
const $b52f7c84c7e591b8$export$ffae5ab992b11d10 = ()=>({
        type: $b52f7c84c7e591b8$export$894891eae2c7b097
    });
const $b52f7c84c7e591b8$export$8e43d92e9c342d0 = 'state.actions.panels.CLOSE_INSIGHTS_PANEL';
const $b52f7c84c7e591b8$export$4fda8ba2e49f8d0c = ()=>({
        type: $b52f7c84c7e591b8$export$8e43d92e9c342d0
    });
const $b52f7c84c7e591b8$export$b1f480ba0abd2610 = 'state.actions.panels.CLOSE_VIEW_SETTINGS_PANEL';
const $b52f7c84c7e591b8$export$ef3e4b5eca4263a7 = ()=>({
        type: $b52f7c84c7e591b8$export$b1f480ba0abd2610
    });

});


parcelRegister("65C0W", function(module, exports) {

$parcel$export(module.exports, "SOFTWARE_APP_LOADED", () => $af4c703fcf2c2b34$export$e4a71ef6d3a53f9f);
$parcel$export(module.exports, "softwareAppLoaded", () => $af4c703fcf2c2b34$export$5b3b8639617316c7);
$parcel$export(module.exports, "SOFTWARE_APP_INITIAL_STATE_LOADED", () => $af4c703fcf2c2b34$export$28370bb41782563c);
$parcel$export(module.exports, "SOFTWARE_DISPLAY_WARNING", () => $af4c703fcf2c2b34$export$3bce66e79613bc5);
$parcel$export(module.exports, "displayWarning", () => $af4c703fcf2c2b34$export$fca88e81122bb575);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $af4c703fcf2c2b34$export$e4a71ef6d3a53f9f = 'state.actions.software.SOFTWARE_APP_LOADED';
const $af4c703fcf2c2b34$export$5b3b8639617316c7 = (prefetchData = null, cmpBoardData = null)=>({
        type: $af4c703fcf2c2b34$export$e4a71ef6d3a53f9f,
        payload: {
            prefetchData: prefetchData,
            cmpBoardData: cmpBoardData
        }
    });
const $af4c703fcf2c2b34$export$28370bb41782563c = 'state.actions.software.SOFTWARE_APP_INITIAL_STATE_LOADED';
const $af4c703fcf2c2b34$export$50d71bea8315649f = ()=>({
        type: $af4c703fcf2c2b34$export$28370bb41782563c
    });
const $af4c703fcf2c2b34$export$3bce66e79613bc5 = 'state.actions.software.SOFTWARE_DISPLAY_WARNING';
const $af4c703fcf2c2b34$export$fca88e81122bb575 = (error)=>({
        type: $af4c703fcf2c2b34$export$3bce66e79613bc5,
        meta: (0, $sdxnu.warningFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: error ? (0, $7AVqz.default).failureDescription : (0, $7AVqz.default).genericDescription,
            context: {
                error: Array.isArray(error) ? error.join('. ') : error
            }
        })
    });

});

parcelRegister("67sX6", function(module, exports) {

$parcel$export(module.exports, "default", () => $0386bfdf0ed24c6f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "BoardReduxProvider", () => $0386bfdf0ed24c6f$export$9a7703ca29dba112);
$parcel$export(module.exports, "useBoardSelector", () => $0386bfdf0ed24c6f$export$96e82ea2a3badaf7);
$parcel$export(module.exports, "useBoardDispatch", () => $0386bfdf0ed24c6f$export$be5272ae2502876c);
$parcel$export(module.exports, "useBoardActionCreator", () => $0386bfdf0ed24c6f$export$a6babbe6110b8b10);
$parcel$export(module.exports, "useBoardStore", () => $0386bfdf0ed24c6f$export$18a7b27690614aac);
$parcel$export(module.exports, "createStoreWithCache", () => $0386bfdf0ed24c6f$export$96feb51b037b866);
$parcel$export(module.exports, "unmountCachedStore", () => $0386bfdf0ed24c6f$export$a0196b1023d1dffd);
parcelRequire("korqb");

var $1UikQ = parcelRequire("1UikQ");

var $j2mQS = parcelRequire("j2mQS");

var $F2Mxm = parcelRequire("F2Mxm");

var $g3qyq = parcelRequire("g3qyq");

var $5Ue2S = parcelRequire("5Ue2S");

var $46ha9 = parcelRequire("46ha9");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $kt1kI = parcelRequire("kt1kI");

var $fip9w = parcelRequire("fip9w");

var $6ALx6 = parcelRequire("6ALx6");


var $5kyJ5 = parcelRequire("5kyJ5");

var $iQYKJ = parcelRequire("iQYKJ");

var $5YGyZ = parcelRequire("5YGyZ");

var $3sree = parcelRequire("3sree");
function $0386bfdf0ed24c6f$export$2e2bcd8739ae039(state, options) {
    const rootReducer = (0, $3sree.default)();
    const middlewares = [];
    let initRootEpic;
    if (options.isServer) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    initRootEpic = (0, $fip9w.default);
    else initRootEpic = (0, $j2mQS.disposableEpic)((0, $kt1kI.default)());
    const boardDependencies = {
        isCMPBoard: options.isCMPBoard,
        swagClient: options.swagClient,
        customRequestHandlers: options.customRequestHandlers
    };
    var _getState, action;
    if (!options.isServer) {
        middlewares.push((0, $5kyJ5.default));
        middlewares.push((0, $iQYKJ.actionMetricsMiddleware));
        // @ts-expect-error - Argument of type '() => (next: (action: Action) => Action) => (action: Action) => Action' is not assignable to parameter of type 'Middleware'.
        middlewares.push((0, $5YGyZ.default));
        middlewares.push((0, $g3qyq.default)((0, $dcbb2bce513725b3$export$d76071d5de2774fc)));
    }
    return (0, $F2Mxm.default)({
        appName: 'Software',
        rootReducer: rootReducer,
        rootEpic: initRootEpic,
        rootEpicDependencies: boardDependencies,
        middlewares: middlewares,
        initialState: state
    });
}
const { Provider: $0386bfdf0ed24c6f$export$9a7703ca29dba112, useSelector: $0386bfdf0ed24c6f$export$96e82ea2a3badaf7, useDispatch: $0386bfdf0ed24c6f$export$be5272ae2502876c, useActionCreator: $0386bfdf0ed24c6f$export$a6babbe6110b8b10, useStore: $0386bfdf0ed24c6f$export$18a7b27690614aac } = (0, $46ha9.createJiraSoftwareStoreContext)();
const $0386bfdf0ed24c6f$var$cachedStoreManager = new (0, $5Ue2S.CachedStoreManager)({
    mergeCachedState (cachedState, preloadedState) {
        const { projectType: projectType, isCMPBoard: isCMPBoard, isIncrementPlanningBoard: isIncrementPlanningBoard } = cachedState.configuration;
        let isJqlFilterEnabled = false;
        if ((0, $4R6GH.fg)('jfp-magma-concurrent-board-duplicate-api-calls')) isJqlFilterEnabled = (0, $6ALx6.shouldDisplayFilterRefinement)({
            isIncrementPlanningBoard: isIncrementPlanningBoard,
            isCMPBoard: isCMPBoard,
            isJSMBoard: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT),
            isJSWBoard: projectType === (0, $2vSU6.SOFTWARE_PROJECT)
        }) && (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false);
        return {
            configuration: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(preloadedState.configuration, cachedState.configuration),
            ui: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(preloadedState.ui, {
                swimlane: cachedState.ui.swimlane,
                ...isJqlFilterEnabled ? {
                    cards: {
                        filteredCards: cachedState.ui.cards.filteredCards
                    }
                } : {}
            }),
            entities: cachedState.entities
        };
    },
    storeFactory: $0386bfdf0ed24c6f$export$2e2bcd8739ae039
});
const $0386bfdf0ed24c6f$export$96feb51b037b866 = (boardId, preloadedStateParam, options)=>$0386bfdf0ed24c6f$var$cachedStoreManager.createStore(boardId, preloadedStateParam, options);
const $0386bfdf0ed24c6f$export$679865edeb4332e = (boardId)=>{
    return $0386bfdf0ed24c6f$var$cachedStoreManager.hasCachedState(boardId);
};
const $0386bfdf0ed24c6f$export$a0196b1023d1dffd = ()=>{
    $0386bfdf0ed24c6f$var$cachedStoreManager.unmount();
};
const $0386bfdf0ed24c6f$export$6e5dca841bdf93e3 = ()=>{
    $0386bfdf0ed24c6f$var$cachedStoreManager.resetCache();
};

});
parcelRegister("j2mQS", function(module, exports) {

$parcel$export(module.exports, "disposableEpic", () => $1c9d4320a4bfd294$export$e6b812e492b046b8);
parcelRequire("7qVV7");

const $1c9d4320a4bfd294$export$e6b812e492b046b8 = (rootEpic)=>(action$, store, dependencies)=>rootEpic(action$, store, dependencies).takeUntil(action$.ofType((0, $167b7959815986d2$export$58387e80544dbf03)));

});

parcelRegister("g3qyq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c091411acc86b19$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");

var $aMh57 = parcelRequire("aMh57");
/**
 * Catches errors within redux reducers and makes them available to monitoring.
 *
 * Takes an optional error action creator as a parameter to be reduced when an error is encountered.
 * This could be used to show an error flag, for example.
 *
 * Should be passed as part of the middleware array when creating the store.
 * E.g. [middlewareOne, errorHandling('your-app-name')]
 */ const $4c091411acc86b19$var$errorHandling = (appId, errorActionCreator, /**
		 * Callback for errors
		 */ onError)=>()=>(next)=>(action)=>{
                try {
                    next(action);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (error) {
                    const fullLocation = `common.redux-error.${appId}`;
                    (0, $2YZCu.default).safeErrorWithoutCustomerData(fullLocation, `Unhandled error for Redux action: '${action?.type}'`, error);
                    (0, $aMh57.captureException)(fullLocation, error);
                    errorActionCreator && next(errorActionCreator());
                    onError && onError(error);
                }
            };
var $4c091411acc86b19$export$2e2bcd8739ae039 = $4c091411acc86b19$var$errorHandling;

});

parcelRegister("5Ue2S", function(module, exports) {

$parcel$export(module.exports, "CachedStoreManager", () => $8f61412efdaebad3$export$519eb0cf9e49db0c);

var $91VA7 = parcelRequire("91VA7");
class $8f61412efdaebad3$export$519eb0cf9e49db0c {
    constructor({ storeFactory: storeFactory, mergeCachedState: mergeCachedState }){
        this.cache = null;
        this.storeFactory = storeFactory;
        this.mergeCachedState = mergeCachedState;
    }
    /**
	 * Return true if the redux state was in cache. In this case, we won't consider
	 * the resources' data.
	 */ hasCachedState(boardId) {
        return Boolean(this.cache && this.cache.boardId === boardId);
    }
    getCachedState(boardId) {
        if (this.cache && this.cache.boardId === boardId) return this.cache.state;
        return null;
    }
    /**
	 * Create a new store, merging a preloadedState with any cached state that was
	 * previously held in memory.
	 */ createStore(boardId, preloadedStateParam, options) {
        // Cast to get rid of Omit<...>. Both types are partial so this is valid
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        let preloadedState = (0, (/*@__PURE__*/$parcel$interopDefault($91VA7)))(preloadedStateParam);
        const cachedState = this.getCachedState(boardId);
        if (!options.disableStoreCaches && cachedState) preloadedState = this.mergeCachedState(cachedState, preloadedState);
        const store = this.storeFactory(preloadedState, options);
        if (options.disableStoreCaches) return store;
        // On every change copy a reference to the redux state to this
        // `cachedStoreState` object.
        this.unmount();
        this.cache = {
            boardId: boardId,
            state: store.getState(),
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unsubscribe: ()=>{}
        };
        this.cache.unsubscribe = store.subscribe(()=>{
            if (this.cache) this.cache.state = store.getState();
        });
        return store;
    }
    /**
	 * Clean-up redux store subscriptions.
	 */ unmount() {
        this.cache?.unsubscribe();
    }
    /**
	 * FOR TESTING ONLY
	 */ getCacheForTesting() {
        return this.cache;
    }
    // For testing
    resetCache() {
        this.cache = null;
    }
}

});

parcelRegister("46ha9", function(module, exports) {

$parcel$export(module.exports, "createJiraSoftwareStoreContext", () => $b414fa8c478f8909$export$884b1d3e4c97abdd);

var $5uXOq = parcelRequire("5uXOq");

var $bDWQ3 = parcelRequire("bDWQ3");

var $7D59a = parcelRequire("7D59a");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b414fa8c478f8909$var$refEquality = (a, b)=>a === b;
function $b414fa8c478f8909$export$884b1d3e4c97abdd() {
    const ctx = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
    const useStore = ()=>{
        const store = (0, $5uXOq.useContext)(ctx);
        if (!store) throw new Error('useStore called outside of redux JiraSoftwareStoreContext tree');
        return store;
    };
    function useSelector(selector, equalityFn = $b414fa8c478f8909$var$refEquality) {
        const store = useStore();
        const result = (0, $bDWQ3.useSyncExternalStoreWithSelector)(store.subscribe, store.getState, // Server state probably wont exist but we can use store.getState in case it does work.
        store.getState, selector, equalityFn);
        return result;
    }
    function useDispatch() {
        const store = useStore();
        return store.dispatch;
    }
    function useActionCreator(actionCreator) {
        const dispatch = useDispatch();
        return (0, $7D59a.useEvent)((...args)=>{
            const action = actionCreator(...args);
            dispatch(action);
        });
    }
    function ReduxProvider(props) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ctx.Provider, {
            value: props.store
        }, props.children);
    }
    return {
        Provider: ReduxProvider,
        useSelector: useSelector,
        useStore: useStore,
        useDispatch: useDispatch,
        useActionCreator: useActionCreator
    };
}

});
parcelRegister("7D59a", function(module, exports) {

$parcel$export(module.exports, "useEvent", () => $cc6c832ad15d24e3$export$90fc3a17d93f704c);

var $5uXOq = parcelRequire("5uXOq");
const $cc6c832ad15d24e3$export$90fc3a17d93f704c = (callback)=>{
    const callbackRef = (0, $5uXOq.useRef)(callback);
    (0, $5uXOq.useLayoutEffect)(()=>{
        callbackRef.current = callback;
    }, [
        callback
    ]);
    return (0, $5uXOq.useCallback)((...args)=>callbackRef.current(...args), []);
};

});


parcelRegister("kt1kI", function(module, exports) {

$parcel$export(module.exports, "default", () => $11a93b681cb84aea$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $iUagi = parcelRequire("iUagi");

var $RDO6A = parcelRequire("RDO6A");

var $c7TLG = parcelRequire("c7TLG");

var $jGHzz = parcelRequire("jGHzz");

var $gT8Nn = parcelRequire("gT8Nn");

var $9KrY0 = parcelRequire("9KrY0");

var $ivoZ6 = parcelRequire("ivoZ6");

var $iUPbp = parcelRequire("iUPbp");

var $8Wyzi = parcelRequire("8Wyzi");

var $dxMXW = parcelRequire("dxMXW");

var $kuD1K = parcelRequire("kuD1K");

var $9s50S = parcelRequire("9s50S");

var $gZyMz = parcelRequire("gZyMz");

var $8ornp = parcelRequire("8ornp");

var $c0Qhv = parcelRequire("c0Qhv");

var $7COzu = parcelRequire("7COzu");

var $f72yS = parcelRequire("f72yS");

var $41QbH = parcelRequire("41QbH");

var $fGfXq = parcelRequire("fGfXq");

var $5Farb = parcelRequire("5Farb");

var $gG0ZK = parcelRequire("gG0ZK");

var $5ZlmD = parcelRequire("5ZlmD");

var $93Fzk = parcelRequire("93Fzk");

var $i9XZM = parcelRequire("i9XZM");

var $enaRv = parcelRequire("enaRv");

var $hh3dt = parcelRequire("hh3dt");

var $erSBH = parcelRequire("erSBH");

var $dNJJS = parcelRequire("dNJJS");

var $hM7SN = parcelRequire("hM7SN");

var $kAzMD = parcelRequire("kAzMD");

var $7Tp6S = parcelRequire("7Tp6S");

var $14rCC = parcelRequire("14rCC");

var $8SGPr = parcelRequire("8SGPr");

var $8gsv0 = parcelRequire("8gsv0");

var $gMi9d = parcelRequire("gMi9d");

var $dzWxI = parcelRequire("dzWxI");

var $EGoh4 = parcelRequire("EGoh4");

var $4FKf7 = parcelRequire("4FKf7");

var $9C8b7 = parcelRequire("9C8b7");

var $iH73B = parcelRequire("iH73B");

var $2u4LO = parcelRequire("2u4LO");

var $14ODQ = parcelRequire("14ODQ");

var $a9PrS = parcelRequire("a9PrS");

var $2RHGv = parcelRequire("2RHGv");

var $4rj2F = parcelRequire("4rj2F");

var $fgxdE = parcelRequire("fgxdE");

var $6Yser = parcelRequire("6Yser");

var $2D01T = parcelRequire("2D01T");

var $5I1Fz = parcelRequire("5I1Fz");

var $eTCf8 = parcelRequire("eTCf8");

var $fElG1 = parcelRequire("fElG1");

var $4tES9 = parcelRequire("4tES9");

var $fb1Ne = parcelRequire("fb1Ne");

var $b8T1q = parcelRequire("b8T1q");

var $7UfD9 = parcelRequire("7UfD9");

var $bTMOX = parcelRequire("bTMOX");

var $9mZdS = parcelRequire("9mZdS");

var $bIfkc = parcelRequire("bIfkc");

var $jlZom = parcelRequire("jlZom");

var $8cD7G = parcelRequire("8cD7G");

var $juuG5 = parcelRequire("juuG5");

var $csUBy = parcelRequire("csUBy");

var $fip9w = parcelRequire("fip9w");

var $dEmHW = parcelRequire("dEmHW");

var $1wh3p = parcelRequire("1wh3p");

var $3usqj = parcelRequire("3usqj");

var $h07lG = parcelRequire("h07lG");

var $7QNZV = parcelRequire("7QNZV");

var $lfaRE = parcelRequire("lfaRE");

var $l4Gux = parcelRequire("l4Gux");

var $1AmgY = parcelRequire("1AmgY");

var $8wkzB = parcelRequire("8wkzB");

var $deevq = parcelRequire("deevq");

var $iAr3J = parcelRequire("iAr3J");

var $kmCzR = parcelRequire("kmCzR");

var $hnFh8 = parcelRequire("hnFh8");

var $5ThEt = parcelRequire("5ThEt");

var $dAcgL = parcelRequire("dAcgL");
const $11a93b681cb84aea$var$epicWithKillSwitch = (predicate)=>(epic)=>(action$, store, dependencies)=>epic(new (0, $e1AU2.ActionsObservable)(action$.filter(()=>!predicate())), store, dependencies);
const $11a93b681cb84aea$var$withAddPeopleButtonOpenTMPExperimentKillSwitch = $11a93b681cb84aea$var$epicWithKillSwitch((0, $iUagi.isInAddPeopleButtonOpenTMPControlCohort));
const $11a93b681cb84aea$var$getArchiveEpicWithKillSwitch = $11a93b681cb84aea$var$epicWithKillSwitch(()=>!(0, $6s1PB.expVal)('issue_deletion_a_two_step_process_ga', 'isDeleteTwoStepGaEnabled', false));
const $11a93b681cb84aea$var$getBoardUpdateOldDoneIssuesCutoffEpicWithKillSwitch = $11a93b681cb84aea$var$epicWithKillSwitch(()=>!(0, $4R6GH.fg)('horizn_490_consolidate_old_issues_in_board'));
const $11a93b681cb84aea$var$getFilterFieldValuesEpicWithKillSwitch = $11a93b681cb84aea$var$epicWithKillSwitch(()=>!(0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false));
const $11a93b681cb84aea$var$getRootEpic = ()=>(0, $e1AU2.combineEpics)((0, $RDO6A.default), (0, $c7TLG.default), (0, $h07lG.default), (0, $kAzMD.default), (0, $dNJJS.default), (0, $hM7SN.default), (0, $7Tp6S.default), (0, $14rCC.default), (0, $6Yser.default), (0, $csUBy.default), (0, $kmCzR.default)(), (0, $8cD7G.default), (0, $8cD7G.workLoadOnInitialLoadEpic), (0, $iAr3J.default), (0, $2D01T.issueFlagWithCommentEpic), (0, $gZyMz.default), (0, $fip9w.default), (0, $fb1Ne.default), (0, $EGoh4.default), (0, $a9PrS.devStatusLoadEpic), (0, $jGHzz.boardDeferredDataLoadEpic), (0, $8wkzB.default), (0, $lfaRE.default), (0, $l4Gux.default), (0, $i9XZM.default), (0, $iUPbp.default), (0, $9KrY0.default), (0, $fElG1.default), (0, $8Wyzi.default), (0, $5Farb.default), $11a93b681cb84aea$var$getArchiveEpicWithKillSwitch((0, $5ThEt.default)), (0, $41QbH.default), (0, $8ornp.cardAssignToMeEpic), (0, $8ornp.cardAssignToMeThrottledEpic), (0, $gG0ZK.default), (0, $f72yS.default), (0, $enaRv.default), (0, $fGfXq.default), (0, $hh3dt.default), (0, $7COzu.cardChangeTeamEpic), (0, $4tES9.issueMoveToBacklogEpic), (0, $4FKf7.filteredCardsEpic), (0, $dzWxI.default), (0, $juuG5.default), (0, $gMi9d.detailViewUpdateEpic), (0, $8SGPr.detailViewCloseEpic), (0, $8gsv0.detailViewOpenDebouncedEpic), (0, $bIfkc.default), (0, $2RHGv.issueBentoUpdateEpic), (0, $5I1Fz.issueIncrementPlanningUpdateEpic), (0, $7UfD9.issueRankTransitionEpic), (0, $b8T1q.issueRankTeamDateEpic), (0, $4rj2F.issueBulkUpdateEpic), (0, $eTCf8.issueLinkEpic), (0, $eTCf8.issueLinkUpdateEpic), (0, $9mZdS.issueUnlinkEpic), (0, $9C8b7.initiateIccInUnscheduledColumnEpic), (0, $erSBH.checkGlobalIssueCreateEpic), (0, $bTMOX.default), (0, $1wh3p.removeFromSprintEpic), (0, $3usqj.updatePlannedCapacityEpic), (0, $dEmHW.addToSprintEpic), (0, $deevq.versionGetEpic), (0, $fgxdE.issueChildrenInFinalColumnEpic), (0, $93Fzk.cardsMoveEpic), (0, $dxMXW.bulkIssueRankTransitionRequestEpic), (0, $5ZlmD.cardDragStartEpic), (0, $c0Qhv.cardAutoScrollOnLoadEpic), (0, $c0Qhv.cardAutoScrollOnFilterEpic), (0, $14ODQ.getIssueLinksStatsEpic), (0, $2u4LO.getIsIssueLinksStatsLoadingEpic), (0, $jlZom.missingParentResolveEpic), (0, $iH73B.getIssueLinksPermissionsEpic), $11a93b681cb84aea$var$withAddPeopleButtonOpenTMPExperimentKillSwitch((0, $kuD1K.getCanUserInviteEpic)), (0, $ivoZ6.displayFlagForIssuesFilteredOnServerEpic), (0, $7QNZV.jqlSwimlanesEpic), (0, $1AmgY.updateIterationCapacityEpic), (0, $gT8Nn.boardFavouriteEpic), (0, $9s50S.getCardCoversEpic), $11a93b681cb84aea$var$getBoardUpdateOldDoneIssuesCutoffEpicWithKillSwitch((0, $dAcgL.boardUpdateOldDoneIssuesCutoffEpic)), $11a93b681cb84aea$var$getFilterFieldValuesEpicWithKillSwitch((0, $4R6GH.fg)('tmp_filter_refinement_sprint_goals') ? (0, $hnFh8.filterUpdateFieldValuesEpic) : (0, $hnFh8.filterUpdateFieldValuesEpicOld)));
var $11a93b681cb84aea$export$2e2bcd8739ae039 = $11a93b681cb84aea$var$getRootEpic;

});
parcelRegister("RDO6A", function(module, exports) {

$parcel$export(module.exports, "default", () => $df668f8c164378df$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $2YZCu = parcelRequire("2YZCu");

var $82cU2 = parcelRequire("82cU2");

var $2bQEl = parcelRequire("2bQEl");

var $2Ysq2 = parcelRequire("2Ysq2");

var $absT5 = parcelRequire("absT5");

var $67Z81 = parcelRequire("67Z81");
const $df668f8c164378df$var$confirmEpic = (action$, store)=>action$.ofType((0, $2Ysq2.BACKLOG_ENABLE_CONFIRM)).switchMap((action)=>(0, $kVLXA.Observable).of((0, $2Ysq2.backlogEnableExecute)((0, $absT5.getFirstColumnIssueIds)(store.getState()), action.payload.push, action.payload.refresh)));
const $df668f8c164378df$var$executeEnableBacklogEpic = (action$, store)=>action$.ofType((0, $2Ysq2.BACKLOG_ENABLE_EXECUTE)).switchMap((action)=>(0, $82cU2.executeBacklogEnable)(store.getState()).switchMap(()=>(0, $kVLXA.Observable).of((0, $2Ysq2.backlogEnableExecuteSuccess)(action.payload.push, action.payload.refresh))).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.enable.failure', 'Failed to enable the backlog', error);
            return (0, $kVLXA.Observable).of((0, $2Ysq2.backlogEnableExecuteFailure)());
        }));
const $df668f8c164378df$var$executeEnableBacklogEpicSuccess = (action$, store)=>action$.ofType((0, $2Ysq2.BACKLOG_ENABLE_EXECUTE_SUCCESS)).mergeMap((action)=>{
        const contextPath = (0, $67Z81.contextPathSelector)(store.getState());
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(store.getState());
        const projectKey = (0, $67Z81.projectKeySelector)(store.getState());
        const { push: push, refresh: refresh } = action.payload;
        const url = (0, $2bQEl.getNextGenBacklogUrl)(contextPath, projectKey, rapidViewId);
        push(url);
        refresh();
        return (0, $kVLXA.Observable).empty();
    });
var $df668f8c164378df$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($df668f8c164378df$var$confirmEpic, $df668f8c164378df$var$executeEnableBacklogEpic, $df668f8c164378df$var$executeEnableBacklogEpicSuccess);

});
parcelRegister("82cU2", function(module, exports) {

$parcel$export(module.exports, "executeBacklogEnable", () => $1bbf271ff42241ac$export$690ad42fb0e955f6);

var $487fd = parcelRequire("487fd");

var $67Z81 = parcelRequire("67Z81");

var $2bQEl = parcelRequire("2bQEl");
const $1bbf271ff42241ac$export$690ad42fb0e955f6 = (state)=>{
    const contextPath = (0, $67Z81.contextPathSelector)(state);
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const url = (0, $2bQEl.getFeaturesUrl)(contextPath, rapidViewId);
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify({
            boardId: rapidViewId,
            feature: 'jsw.agility.backlog',
            enabling: true
        })
    });
};

});
parcelRegister("487fd", function(module, exports) {

$parcel$export(module.exports, "default", () => $96196282ac54fa24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fPS7b");

var $x9xyg = parcelRequire("x9xyg");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $96196282ac54fa24$var$noContentStatus = 204;
const $96196282ac54fa24$var$transformUrl = (url)=>{
    const lUrl = url.replace(/\//g, '_');
    const resUrl = lUrl.substr(0, lUrl.indexOf('?') > -1 ? lUrl.indexOf('?') : lUrl.length);
    return resUrl;
};
// This function returns a JSON stream which emits a single JSON value on success, and throws
// an error on failure
// Pass the perf object in the options in order to enable performance analytics for your request
// fetchJson$ = ('some url', { perf: { key: 'analytics_key', prefix: 'analytics_prefix' } })
// Pass the headersProcessor in the options to provide a callback function which can respond on headers.
function $96196282ac54fa24$var$fetchJson$(url, options = {}) {
    const { perf: perf, headersProcessor: headersProcessor, ...opts } = options;
    let key;
    const isPerformanceCheckEnabled = !!perf;
    if (isPerformanceCheckEnabled) {
        const mark = `REST${$96196282ac54fa24$var$transformUrl(url)}`;
        key = perf && `${perf.prefix != null && perf.prefix !== '' ? `${perf.prefix}_` : ''}${perf.key}` || mark;
        (0, $x9xyg.setMark)(`BEGIN_${key}`);
    }
    return (0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), opts), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (isPerformanceCheckEnabled) (0, $x9xyg.setMark)(`END_${key}`);
        if (!response.ok) {
            const { status: status } = response;
            return response.text().then((str)=>{
                const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
                if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, str, traceId);
                else throw new (0, $jJZqs.default)(status, str);
            });
        }
        if (typeof headersProcessor === 'function') headersProcessor(response.headers);
        if (response.status === $96196282ac54fa24$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        return response.json();
    });
}
var $96196282ac54fa24$export$2e2bcd8739ae039 = $96196282ac54fa24$var$fetchJson$;

});


parcelRegister("2Ysq2", function(module, exports) {

$parcel$export(module.exports, "BACKLOG_ENABLE_CANCEL", () => $e4e769740361c175$export$3c77343ffc194a44);
$parcel$export(module.exports, "backlogEnableCancel", () => $e4e769740361c175$export$52c00a4647b8e037);
$parcel$export(module.exports, "BACKLOG_ENABLE_CONFIRM", () => $e4e769740361c175$export$6b33e6709d7730dc);
$parcel$export(module.exports, "backlogEnableConfirm", () => $e4e769740361c175$export$32df3f70300e2871);
$parcel$export(module.exports, "BACKLOG_ENABLE_EXECUTE", () => $e4e769740361c175$export$aed41f3e4822edd);
$parcel$export(module.exports, "backlogEnableExecute", () => $e4e769740361c175$export$e9c8908c57a6a62d);
$parcel$export(module.exports, "BACKLOG_ENABLE_EXECUTE_SUCCESS", () => $e4e769740361c175$export$8806068f70c10739);
$parcel$export(module.exports, "backlogEnableExecuteSuccess", () => $e4e769740361c175$export$28d6e28e210a421d);
$parcel$export(module.exports, "backlogEnableExecuteFailure", () => $e4e769740361c175$export$faef2c83a5ea3eff);
const $e4e769740361c175$export$3c77343ffc194a44 = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_CANCEL';
const $e4e769740361c175$export$52c00a4647b8e037 = ()=>({
        type: $e4e769740361c175$export$3c77343ffc194a44
    });
const $e4e769740361c175$export$6b33e6709d7730dc = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_CONFIRM';
const $e4e769740361c175$export$32df3f70300e2871 = (push, refresh)=>({
        type: $e4e769740361c175$export$6b33e6709d7730dc,
        payload: {
            push: push,
            refresh: refresh
        }
    });
const $e4e769740361c175$export$aed41f3e4822edd = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_EXECUTE';
const $e4e769740361c175$export$e9c8908c57a6a62d = (issueIds, push, refresh)=>({
        type: $e4e769740361c175$export$aed41f3e4822edd,
        payload: {
            issueIds: issueIds,
            push: push,
            refresh: refresh
        }
    });
const $e4e769740361c175$export$8806068f70c10739 = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_EXECUTE_SUCCESS';
const $e4e769740361c175$export$28d6e28e210a421d = (push, refresh)=>({
        type: $e4e769740361c175$export$8806068f70c10739,
        payload: {
            push: push,
            refresh: refresh
        }
    });
const $e4e769740361c175$export$e1d4177958834b9d = 'state.actions.board.backlog-enable.BACKLOG_ENABLE_EXECUTE_FAILURE';
const $e4e769740361c175$export$faef2c83a5ea3eff = ()=>({
        type: $e4e769740361c175$export$e1d4177958834b9d
    });

});

parcelRegister("absT5", function(module, exports) {

$parcel$export(module.exports, "getFirstColumnIssueIds", () => $99b3e60f9f65f47a$export$96f2113557912d36);
$parcel$export(module.exports, "isOpenSelector", () => $99b3e60f9f65f47a$export$eacfcc6aba3b8af4);
$parcel$export(module.exports, "isDialogVisibleSelector", () => $99b3e60f9f65f47a$export$c130901f07b1d4e4);

var $dGvGJ = parcelRequire("dGvGJ");

var $iuuJH = parcelRequire("iuuJH");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");
const $99b3e60f9f65f47a$export$96f2113557912d36 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getOrderedColumnIds),
    (0, $d2i8f.getOrderedIssuesByColumn)
], (orderedColumnIds, orderedIssuesByColumn)=>{
    const firstColumnId = orderedColumnIds[0];
    const firstColumnIssues = orderedIssuesByColumn[firstColumnId];
    return firstColumnIssues ? firstColumnIssues.map((i)=>i.id) : [];
});
const $99b3e60f9f65f47a$export$eacfcc6aba3b8af4 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getUi)
], (ui)=>Boolean(ui.backlogIssueMoveDialog?.isOpen));
const $99b3e60f9f65f47a$export$c130901f07b1d4e4 = (0, $dGvGJ.createSelector)([
    $99b3e60f9f65f47a$export$eacfcc6aba3b8af4,
    $99b3e60f9f65f47a$export$96f2113557912d36,
    (0, $45cXl.getSwimlaneMode)
], (isOpen, firstColumnIssueIds, swimlaneMode)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return false;
    const firstColumnNotEmpty = firstColumnIssueIds.length > 0;
    return isOpen && firstColumnNotEmpty;
});

});


parcelRegister("c7TLG", function(module, exports) {

$parcel$export(module.exports, "default", () => $71f505c3631c1813$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("1oQta");
parcelRequire("d0pqD");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("hZWgu");
parcelRequire("6cbqE");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $e7Vtd = parcelRequire("e7Vtd");

var $aZavt = parcelRequire("aZavt");

var $doOdQ = parcelRequire("doOdQ");

var $cW3pH = parcelRequire("cW3pH");

var $absT5 = parcelRequire("absT5");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");
const $71f505c3631c1813$var$shouldCheckForDialogOnRefresh = (action, state)=>{
    if (action?.payload?.boardConfig == null) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.move.issue.no.board.config', 'Board config is null on enabled Swag Extended feature flag', {
            error: JSON.stringify(action, Object.getOwnPropertyNames(action))
        });
        return false;
    }
    const { boardIssueListKey: boardIssueListKey, requestColumnMigration: requestColumnMigration } = action.payload.boardConfig;
    const canEdit = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action, [
        'payload',
        'boardPermissions',
        'editBoardConfig'
    ], false) && !(0, $67Z81.getIsCMPBoard)(state);
    const isIssueListBoard = Boolean(boardIssueListKey);
    const isActiveSprint = Boolean((0, $ebHh7.activeSprintsSelector)(state));
    const isAlreadyOpen = (0, $absT5.isOpenSelector)(state);
    return (requestColumnMigration || false) && isIssueListBoard && canEdit && !isActiveSprint && !isAlreadyOpen;
};
const $71f505c3631c1813$var$checkDismissEpicOnRefresh = (action$, store)=>action$.ofType((0, $cW3pH.WORK_DATA_SET)).filter((action)=>$71f505c3631c1813$var$shouldCheckForDialogOnRefresh(action, store.getState())).switchMap(()=>(0, $kVLXA.Observable).of((0, $doOdQ.backlogIssueMoveShow)()));
const $71f505c3631c1813$var$setDismissEpic = (action$, store)=>action$.ofType((0, $doOdQ.BACKLOG_ISSUE_MOVE_CANCEL), (0, $doOdQ.BACKLOG_ISSUE_MOVE_CONFIRM)).switchMap(()=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        return (0, $aZavt.dismissMigrationModal)(contextPath, rapidViewId).ignoreElements()// impossible:
        .map(()=>({
                type: 'UNSUPPORTED_ACTION_TYPE'
            }));
    });
const $71f505c3631c1813$var$confirmEpic = (action$, store)=>action$.ofType((0, $doOdQ.BACKLOG_ISSUE_MOVE_CONFIRM)).switchMap(()=>(0, $kVLXA.Observable).of((0, $doOdQ.backlogIssueMoveExecute)((0, $absT5.getFirstColumnIssueIds)(store.getState()))));
const $71f505c3631c1813$var$executeMoveEpic = (action$, store)=>action$.ofType((0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE)).mergeMap((action)=>(0, $e7Vtd.executeBacklogIssueMove)(store.getState()).switchMap(()=>(0, $kVLXA.Observable).of((0, $doOdQ.backlogIssueMoveExecuteSuccess)(action.meta.optimistic.id))).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('backlog.move.issue.failure', 'Failed to move issues to backlog', error);
            return (0, $kVLXA.Observable).of((0, $doOdQ.backlogIssueMoveExecuteFailure)(action.meta.optimistic.id));
        }));
var $71f505c3631c1813$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($71f505c3631c1813$var$checkDismissEpicOnRefresh, $71f505c3631c1813$var$setDismissEpic, $71f505c3631c1813$var$confirmEpic, $71f505c3631c1813$var$executeMoveEpic);

});
parcelRegister("e7Vtd", function(module, exports) {

$parcel$export(module.exports, "executeBacklogIssueMove", () => $eb25df84b768bbf2$export$750a6ad19c52b3ed);

var $487fd = parcelRequire("487fd");

var $67Z81 = parcelRequire("67Z81");

var $2bQEl = parcelRequire("2bQEl");
const $eb25df84b768bbf2$export$750a6ad19c52b3ed = (state)=>{
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const contextPath = (0, $67Z81.contextPathSelector)(state);
    const url = (0, $2bQEl.getBacklogIssueMoveUrl)(contextPath);
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify({
            rapidViewId: rapidViewId
        })
    });
};

});

parcelRegister("aZavt", function(module, exports) {

$parcel$export(module.exports, "dismissMigrationModal", () => $981d6b72ff2111e1$export$e05baac531611192);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $981d6b72ff2111e1$export$716b4280dda478e9 = 'DismissFirstColumnMigrationModal';
const $981d6b72ff2111e1$export$19a8cfc9fd174c1c = (0, $ivqh1.gqlTagSwag)`
    mutation DismissFirstColumnMigrationModal($boardId: ID!) {
        dismissFirstColumnMigrationModal(input: {boardId: $boardId}) {
            boardScope {
                id
            }
        }
    }
`;
const $981d6b72ff2111e1$export$e05baac531611192 = (contextPath, boardId)=>(0, $6iJbJ.mutation$)(contextPath, $981d6b72ff2111e1$export$716b4280dda478e9, $981d6b72ff2111e1$export$19a8cfc9fd174c1c, {
        boardId: boardId
    }, (0, $CFxE9.dismissMigrationModalAnalyticsOptions));

});
parcelRegister("ivqh1", function(module, exports) {

$parcel$export(module.exports, "gqlTagSwag", () => $01c130fdc769ad97$export$c4eea1172a449e1a);

var $ftbQH = parcelRequire("ftbQH");
const $01c130fdc769ad97$export$c4eea1172a449e1a = (0, $ftbQH.gqlTagRest);

});
parcelRegister("ftbQH", function(module, exports) {

$parcel$export(module.exports, "gqlTagRest", () => $e1de9369168f5428$export$ecc155df19ba52ff);
/**
 * This file is to define tags for GraphQL queries to be identified
 * by https://github.com/apollographql/eslint-plugin-graphql
 * It returns the full query string for template literals
 */ const $e1de9369168f5428$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};

});


parcelRegister("6iJbJ", function(module, exports) {

$parcel$export(module.exports, "mutation$", () => $fd52b7b2722ec81e$export$3c168c5a8b47d553);

var $4nUsC = parcelRequire("4nUsC");
const $fd52b7b2722ec81e$export$3c168c5a8b47d553 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('mutation', baseUrl, operationName, query, variables, analyticOptions);

});
parcelRegister("4nUsC", function(module, exports) {

$parcel$export(module.exports, "operation$", () => $9d6dd91dc35e6aa9$export$cbc7c612df05bda);
parcelRequire("fp4O3");
parcelRequire("3q49N");
parcelRequire("inj9P");
parcelRequire("64ZAE");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $9XE6b = parcelRequire("9XE6b");

var $aZFhV = parcelRequire("aZFhV");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $dGrdR = parcelRequire("dGrdR");

var $2YZCu = parcelRequire("2YZCu");

var $kobfu = parcelRequire("kobfu");

var $487fd = parcelRequire("487fd");

var $fnyT4 = parcelRequire("fnyT4");

var $4tcSU = parcelRequire("4tcSU");

var $fjcgS = parcelRequire("fjcgS");

var $cNrxd = parcelRequire("cNrxd");

var $04zaL = parcelRequire("04zaL");
const $9d6dd91dc35e6aa9$var$sendOperationalEvent = (analyticKey, statusCode)=>{
    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
        const analyticsClient = client.getInstance();
        // SSR doesn't have an analytics client
        if (!analyticsClient) return;
        let statusCodeFamily = 'unknown';
        if (statusCode !== null) {
            const statusCodeAsStr = String(statusCode);
            if (statusCodeAsStr === '0' || statusCodeAsStr === '429') // special status codes
            statusCodeFamily = statusCodeAsStr;
            else if (statusCodeAsStr.match(/^[12345][0-9]{2}$/)) statusCodeFamily = `${statusCodeAsStr[0]}xx`;
        }
        analyticsClient.sendOperationalEvent({
            action: 'fetch',
            actionSubject: 'swag operation',
            attributes: {
                key: analyticKey,
                statusCode: statusCode,
                statusCodeFamily: statusCodeFamily
            },
            source: 'swagOperation'
        });
    });
};
const $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark = (analyticKey, slo, statusCode, concurrentId, // eslint-disable-next-line @typescript-eslint/no-explicit-any
bm3Interaction)=>{
    if (analyticKey !== undefined) {
        // @ts-expect-error - TS2345 - Argument of type 'string | null' is not assignable to parameter of type 'string'.
        $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, statusCode);
        if (bm3Interaction) bm3Interaction.cancel();
    }
};
const $9d6dd91dc35e6aa9$var$callSwag$ = ({ baseUrl: baseUrl, operationName: operationName, query: query, variables: variables, action: action, headersProcessor: headersProcessor })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    let headers = {};
    // set empty xsrfToken for SSR as cookies are unavailable
    const xsrfToken = false ? '' : (0, $4tcSU.default)();
    if (action === 'mutation') {
        if (!xsrfToken) (0, $2YZCu.default).safeErrorWithoutCustomerData('board.xsrf-token.load.failure', 'XSRF Token failed to load');
        headers = {
            'atl-xsrf-token': xsrfToken
        };
    }
    return (0, $487fd.default)(`${baseUrl}/jsw2/graphql?operation=${operationName}`, {
        method: 'POST',
        body: JSON.stringify({
            operationName: operationName,
            query: query,
            variables: variables
        }),
        headers: headers,
        headersProcessor: headersProcessor
    });
};
const $9d6dd91dc35e6aa9$export$cbc7c612df05bda = (action, baseUrl, operationName, query, variables, analyticOptions)=>{
    const { analyticKey: analyticKey, slo: slo, useBm3Interaction: useBm3Interaction, concurrentMetricDefinition: concurrentMetricDefinition } = analyticOptions || {};
    let traceId = '';
    const headersProcessor = (headers)=>{
        traceId = headers.get((0, $fnyT4.TRACE_ID_HEADER)) || '';
    };
    const concurrentId = (0, $7Jxgt.v4)();
    let bm3Interaction = null;
    if (analyticKey && useBm3Interaction) bm3Interaction = (0, $dGrdR.metrics).interaction({
        key: analyticKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: '1000_2000_3000_4000_5000_6000'
        }
    });
    return (0, $kVLXA.Observable).defer(()=>{
        if (bm3Interaction) bm3Interaction.start();
        if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).start();
        return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        });
    }).catch((error)=>{
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const isRetryStatusCode = [
            502,
            503,
            504
        ].includes(Number(statusCode));
        if (isRetryStatusCode && action === 'query') return $9d6dd91dc35e6aa9$var$callSwag$({
            baseUrl: baseUrl,
            operationName: operationName,
            query: query,
            variables: variables,
            action: action,
            headersProcessor: headersProcessor
        }).do(()=>{
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: true,
                retryStatusCode: null
            });
        }, (retryError)=>{
            const retryStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(retryError, [
                'statusCode'
            ], null);
            (0, $04zaL.logRestRetry)({
                queryName: operationName,
                statusCode: statusCode,
                isRetrySuccessful: false,
                retryStatusCode: retryStatusCode
            });
        });
        // throw exception to the next level
        return (0, $kVLXA.Observable).throw(error);
    })// catch network error
    .catch((error)=>{
        const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
        const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'statusCode'
        ], null);
        const errorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'name'
        ], null);
        const swagError = new (0, $cNrxd.SwagError)({
            networkError: error,
            traceId: traceId
        });
        const hash = (0, $kobfu.getErrorHash)(swagError);
        (0, $04zaL.logRestNetworkError)(e, statusCode, operationName, errorName, hash);
        $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
        return (0, $kVLXA.Observable).throw(swagError);
    }).flatMap((response)=>{
        if (!response || !response.data) (0, $04zaL.logRestParsingError)('empty response.data', operationName);
        try {
            // SWAG errors from response
            if (response.errors) {
                if (response.errors.length > 100) {
                    const genericMessage = `Too many Errors in response for ${operationName}`;
                    (0, $04zaL.logRestError)([
                        genericMessage
                    ], null, operationName, 'too-many-errors');
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, null, concurrentId, bm3Interaction);
                    return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                        graphQLErrors: [
                            {
                                message: genericMessage,
                                path: [
                                    genericMessage
                                ],
                                extensions: {
                                    statusCode: null,
                                    errorType: 'too-many-errors'
                                }
                            }
                        ],
                        traceId: traceId
                    }));
                }
                const payload = response.errors.map((e)=>{
                    const { path: path, message: message } = e;
                    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'statusCode'
                    ], null);
                    const errorType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'errorType'
                    ], undefined);
                    const userMessage = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
                        'extensions',
                        'userMessage'
                    ], undefined);
                    (0, $04zaL.logRestError)(path, statusCode, operationName, errorType);
                    $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, statusCode, concurrentId, bm3Interaction);
                    return {
                        message: message,
                        path: path,
                        extensions: {
                            statusCode: statusCode ? Number(statusCode) : null,
                            errorType: errorType,
                            userMessage: userMessage
                        }
                    };
                });
                return (0, $kVLXA.Observable).throw(new (0, $cNrxd.SwagError)({
                    graphQLErrors: payload,
                    traceId: traceId
                }));
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            const e = (0, (/*@__PURE__*/$parcel$interopDefault($aZFhV)))(error) ? error.message : `[unknown error] = ${JSON.stringify(error)}`;
            (0, $04zaL.logRestParsingError)(e, operationName);
            $9d6dd91dc35e6aa9$var$onErrorSendOpEventAndCancelMark(analyticKey, slo, 'unknown', concurrentId, bm3Interaction);
            throw error;
        }
        if (analyticKey !== undefined) {
            // @ts-expect-error - TS2339 - Property 'statusCode' does not exist on type 'Response<Data>'.
            $9d6dd91dc35e6aa9$var$sendOperationalEvent(analyticKey, response.statusCode ?? '200');
            if (bm3Interaction) bm3Interaction.stop();
            if (concurrentMetricDefinition !== undefined) concurrentMetricDefinition(concurrentId).stop();
        }
        return (0, $kVLXA.Observable).of(response.data);
    });
};

});


parcelRegister("CFxE9", function(module, exports) {

$parcel$export(module.exports, "columnCreateAnalyticsOptions", () => $1d87f422c20d6fb4$export$3009f6a98d0222d7);
$parcel$export(module.exports, "columnCreateInteraction", () => $1d87f422c20d6fb4$export$7cece60792def420);
$parcel$export(module.exports, "columnRenameAnalyticsOptions", () => $1d87f422c20d6fb4$export$e39ccf35fc62d1b);
$parcel$export(module.exports, "columnRenameInteraction", () => $1d87f422c20d6fb4$export$41003cf816bb8221);
$parcel$export(module.exports, "columnRankAnalyticsOptions", () => $1d87f422c20d6fb4$export$89b4c340d9939ed9);
$parcel$export(module.exports, "columnRankInteraction", () => $1d87f422c20d6fb4$export$b9f6994a9f080d4d);
$parcel$export(module.exports, "columnDeleteAnalyticsOptions", () => $1d87f422c20d6fb4$export$5b23342a6a197f18);
$parcel$export(module.exports, "columnDeleteInteraction", () => $1d87f422c20d6fb4$export$2c54f096c209762e);
$parcel$export(module.exports, "columnSetLimitAnalyticsOptions", () => $1d87f422c20d6fb4$export$58a3eac1c0822c79);
$parcel$export(module.exports, "columnSetLimitInteraction", () => $1d87f422c20d6fb4$export$8c79986dfa78fcdf);
$parcel$export(module.exports, "boardScopeDataNonCriticalAnalyticsOptions", () => $1d87f422c20d6fb4$export$e97ac4cb4d0a1231);
$parcel$export(module.exports, "cardCreateAnalyticsOptions", () => $1d87f422c20d6fb4$export$90f1c46b5c27e9d2);
$parcel$export(module.exports, "loadExtensionAnalyticsOptions", () => $1d87f422c20d6fb4$export$7aa6483bdb308d69);
$parcel$export(module.exports, "setUserSwimlaneAnalyticsOptions", () => $1d87f422c20d6fb4$export$d62aa526ed93638f);
$parcel$export(module.exports, "boardRenameAnalyticsOptions", () => $1d87f422c20d6fb4$export$c511eb222d867bfd);
$parcel$export(module.exports, "completeSprintModalLoad", () => $1d87f422c20d6fb4$export$281157708c6b132a);
$parcel$export(module.exports, "dismissMigrationModalAnalyticsOptions", () => $1d87f422c20d6fb4$export$aabc7f67e3ae59ef);
// Note: Metrics key need to be added to key - enum list in the data-portal registry
// - https://data-portal.internal.atlassian.com/analytics/registry/28587?tabIndex=Attributes

var $dGrdR = parcelRequire("dGrdR");
const $1d87f422c20d6fb4$var$APP_METRIC_KEY = 'software.next-gen.boards';
const $1d87f422c20d6fb4$var$COLUMN_CREATE_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.create`;
const $1d87f422c20d6fb4$var$COLUMN_CREATE_SLO = 4000;
const $1d87f422c20d6fb4$export$3009f6a98d0222d7 = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_CREATE_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_CREATE_SLO
};
const $1d87f422c20d6fb4$export$7cece60792def420 = (0, $dGrdR.metrics).concurrent.interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_CREATE_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$COLUMN_RENAME_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.rename`;
const $1d87f422c20d6fb4$var$COLUMN_RENAME_SLO = 4000;
const $1d87f422c20d6fb4$export$e39ccf35fc62d1b = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_RENAME_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_RENAME_SLO
};
const $1d87f422c20d6fb4$export$41003cf816bb8221 = (0, $dGrdR.metrics).concurrent.interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_RENAME_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$COLUMN_RANK_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.rank`;
const $1d87f422c20d6fb4$var$COLUMN_RANK_SLO = 2000;
const $1d87f422c20d6fb4$export$89b4c340d9939ed9 = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_RANK_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_RANK_SLO
};
const $1d87f422c20d6fb4$export$b9f6994a9f080d4d = (0, $dGrdR.metrics).concurrent.interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_RANK_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$COLUMN_DELETE_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.delete`;
const $1d87f422c20d6fb4$var$COLUMN_DELETE_SLO = 4000;
const $1d87f422c20d6fb4$export$5b23342a6a197f18 = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_DELETE_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_DELETE_SLO
};
const $1d87f422c20d6fb4$export$2c54f096c209762e = (0, $dGrdR.metrics).concurrent.interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_DELETE_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.column.set-limit`;
const $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_SLO = 2000;
const $1d87f422c20d6fb4$export$58a3eac1c0822c79 = {
    analyticKey: $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_SLO
};
const $1d87f422c20d6fb4$export$8c79986dfa78fcdf = (0, $dGrdR.metrics).interaction({
    key: $1d87f422c20d6fb4$var$COLUMN_SET_LIMIT_METRIC_KEY,
    histogram: {
        response: '50_100_150_200_300_500',
        result: '100_500_1000_2000_3000_4000_5000_6000'
    }
});
const $1d87f422c20d6fb4$var$BOARD_SCOPE_NON_CRITICAL_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.boardscope.non-critical`;
const $1d87f422c20d6fb4$var$BOARD_SCOPE_NON_CRITICAL_SLO = 1500;
const $1d87f422c20d6fb4$export$e97ac4cb4d0a1231 = {
    analyticKey: $1d87f422c20d6fb4$var$BOARD_SCOPE_NON_CRITICAL_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$BOARD_SCOPE_NON_CRITICAL_SLO
};
const $1d87f422c20d6fb4$var$CARD_CREATE_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.card.create`;
const $1d87f422c20d6fb4$var$CARD_CREATE_SLO = 1000;
const $1d87f422c20d6fb4$export$90f1c46b5c27e9d2 = {
    analyticKey: $1d87f422c20d6fb4$var$CARD_CREATE_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$CARD_CREATE_SLO
};
const $1d87f422c20d6fb4$var$LOAD_EXTENSION_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.load.extension`;
const $1d87f422c20d6fb4$var$LOAD_EXTENSION_SLO = 1000;
const $1d87f422c20d6fb4$export$7aa6483bdb308d69 = {
    analyticKey: $1d87f422c20d6fb4$var$LOAD_EXTENSION_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$LOAD_EXTENSION_SLO
};
const $1d87f422c20d6fb4$var$SET_USER_SWIMLANE_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.set.user.swimlane`;
const $1d87f422c20d6fb4$var$SET_USER_SWIMLANE_SLO = 1000;
const $1d87f422c20d6fb4$export$d62aa526ed93638f = {
    analyticKey: $1d87f422c20d6fb4$var$SET_USER_SWIMLANE_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$SET_USER_SWIMLANE_SLO
};
const $1d87f422c20d6fb4$var$BOARD_RENAME_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.board.rename`;
const $1d87f422c20d6fb4$var$BOARD_RENAME_SLO = 1000;
const $1d87f422c20d6fb4$export$c511eb222d867bfd = {
    analyticKey: $1d87f422c20d6fb4$var$BOARD_RENAME_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$BOARD_RENAME_SLO
};
const $1d87f422c20d6fb4$export$281157708c6b132a = (0, $dGrdR.metrics).interaction({
    key: 'jsw-complete-sprint-modal'
});
const $1d87f422c20d6fb4$var$DISMISS_MIGRATION_MODAL_METRIC_KEY = `${$1d87f422c20d6fb4$var$APP_METRIC_KEY}.board.migration.dismiss`;
const $1d87f422c20d6fb4$var$DISMISS_MIGRATION_MODAL_SLO = 1000;
const $1d87f422c20d6fb4$export$aabc7f67e3ae59ef = {
    analyticKey: $1d87f422c20d6fb4$var$DISMISS_MIGRATION_MODAL_METRIC_KEY,
    slo: $1d87f422c20d6fb4$var$DISMISS_MIGRATION_MODAL_SLO
};

});


parcelRegister("doOdQ", function(module, exports) {

$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_SHOW", () => $cca980f057656731$export$4cf2a2bfea1b391e);
$parcel$export(module.exports, "backlogIssueMoveShow", () => $cca980f057656731$export$d855544cc5ffa4f4);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_CANCEL", () => $cca980f057656731$export$94d3402bbf79157b);
$parcel$export(module.exports, "backlogIssueMoveCancel", () => $cca980f057656731$export$8ad0be7d3c5b884d);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_CONFIRM", () => $cca980f057656731$export$c7a3f3d486dc3983);
$parcel$export(module.exports, "backlogIssueMoveConfirm", () => $cca980f057656731$export$813ea7e4ff757951);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_EXECUTE", () => $cca980f057656731$export$8726de1bdb4de658);
$parcel$export(module.exports, "backlogIssueMoveExecute", () => $cca980f057656731$export$deb012b7ca9ae918);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_EXECUTE_SUCCESS", () => $cca980f057656731$export$2f753f18a8f89f7f);
$parcel$export(module.exports, "backlogIssueMoveExecuteSuccess", () => $cca980f057656731$export$306bba8cd988ac22);
$parcel$export(module.exports, "BACKLOG_ISSUE_MOVE_EXECUTE_FAILURE", () => $cca980f057656731$export$3ff51b6c3fbc7aa8);
$parcel$export(module.exports, "backlogIssueMoveExecuteFailure", () => $cca980f057656731$export$e67e8d09cf0c08f4);

var $9rND4 = parcelRequire("9rND4");
const $cca980f057656731$export$4cf2a2bfea1b391e = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_SHOW';
const $cca980f057656731$export$d855544cc5ffa4f4 = ()=>({
        type: $cca980f057656731$export$4cf2a2bfea1b391e
    });
const $cca980f057656731$export$94d3402bbf79157b = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_CANCEL';
const $cca980f057656731$export$8ad0be7d3c5b884d = ()=>({
        type: $cca980f057656731$export$94d3402bbf79157b
    });
const $cca980f057656731$export$c7a3f3d486dc3983 = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_CONFIRM';
const $cca980f057656731$export$813ea7e4ff757951 = ()=>({
        type: $cca980f057656731$export$c7a3f3d486dc3983
    });
const $cca980f057656731$export$8726de1bdb4de658 = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_EXECUTE';
const $cca980f057656731$export$deb012b7ca9ae918 = (issueIds)=>({
        type: $cca980f057656731$export$8726de1bdb4de658,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $cca980f057656731$export$2f753f18a8f89f7f = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_EXECUTE_SUCCESS';
const $cca980f057656731$export$306bba8cd988ac22 = (optimisticId)=>({
        type: $cca980f057656731$export$2f753f18a8f89f7f,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $cca980f057656731$export$3ff51b6c3fbc7aa8 = 'state.actions.board.backlog-issue-move.BACKLOG_ISSUE_MOVE_EXECUTE_FAILURE';
const $cca980f057656731$export$e67e8d09cf0c08f4 = (optimisticId)=>({
        type: $cca980f057656731$export$3ff51b6c3fbc7aa8,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("jGHzz", function(module, exports) {

$parcel$export(module.exports, "boardDeferredDataLoadEpic", () => $1f363c3ed189fc20$export$213815e477b73dd5);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("6cbqE");

var $2YZCu = parcelRequire("2YZCu");

var $itF8x = parcelRequire("itF8x");

var $127QL = parcelRequire("127QL");

var $67Z81 = parcelRequire("67Z81");
const $1f363c3ed189fc20$var$handleFailure = (error)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData('board.deferred-data.load.failure', 'Board deferred data failed to load', error);
    return (0, $kVLXA.Observable).of((0, $127QL.boardDeferredDataLoadFailure)());
};
const $1f363c3ed189fc20$var$handleSuccess = (result)=>(0, $kVLXA.Observable).of((0, $127QL.boardDeferredDataLoadSuccess)(result));
const $1f363c3ed189fc20$var$handleSuccessNoop = ()=>(0, $kVLXA.Observable).empty();
function $1f363c3ed189fc20$export$213815e477b73dd5(action$, store) {
    return action$.ofType((0, $127QL.BOARD_DEFERRED_DATA_LOAD)).switchMap(()=>{
        const state = store.getState();
        // Only applies to CMP boards
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        if (!isCMPBoard) return $1f363c3ed189fc20$var$handleSuccessNoop();
        return (0, $itF8x.boardDeferredDataService)(state).flatMap((result)=>$1f363c3ed189fc20$var$handleSuccess(result)).catch((error)=>$1f363c3ed189fc20$var$handleFailure(error));
    });
}

});
parcelRegister("itF8x", function(module, exports) {

$parcel$export(module.exports, "boardDeferredDataService", () => $0b9246f64e9774ba$export$92732d7626194f64);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("d0pqD");

var $c4Y0z = parcelRequire("c4Y0z");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");
function $0b9246f64e9774ba$var$getParamsFromState(state) {
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const isSprintsEnabled = (0, $ebHh7.isSprintsEnabled)(state);
    const isJqlSwimlanesEnabled = (0, $45cXl.isSwimlanesByJqlAvailable)(state);
    const sprintIds = isSprintsEnabled ? Object.values((0, $ebHh7.getSprintEntities)(state)).map((sprint)=>sprint.id) : undefined;
    const fields = isJqlSwimlanesEnabled ? [
        'swimlanes_query'
    ] : [];
    return {
        rapidViewId: rapidViewId,
        fields: fields,
        sprintIds: sprintIds
    };
}
function $0b9246f64e9774ba$var$transformResponse(state, { sprintsData: sprintsData, swimlanesData: swimlanesData, workflowData: workflowData }) {
    // The sprint data returned from deferred endpoint does not include everything, so fill out the sprint type with value from state, overriding updated values (canUpdateSprint).
    const existingSprints = (0, $ebHh7.getSprintEntities)(state);
    const sprints = sprintsData?.sprints.map(({ id: id, canUpdateSprint: canUpdateSprint })=>({
            ...existingSprints[id],
            canUpdateSprint: canUpdateSprint
        })) ?? undefined;
    // The swimlane data returned from the deferred endpoint is not complete, so fill out the swimlanes with value from state, while overriding updated values (query).
    const existingSwimlanes = (0, $67Z81.getEntities)(state).jqlSwimlanes.swimlanes;
    const jqlSwimlanes = swimlanesData ? existingSwimlanes.map((swimlane)=>({
            ...swimlane,
            query: swimlanesData.customSwimlanesData.swimlanes.find((s)=>String(s.id) === swimlane.id)?.query ?? swimlane.query
        })) : undefined;
    const isUsingSimplifiedWorkflow = workflowData?.isUsingSimplifiedWorkflow;
    return {
        sprints: sprints,
        jqlSwimlanes: jqlSwimlanes,
        isUsingSimplifiedWorkflow: isUsingSimplifiedWorkflow
    };
}
function $0b9246f64e9774ba$export$92732d7626194f64(state) {
    const params = $0b9246f64e9774ba$var$getParamsFromState(state);
    return params.fields.length ? (0, $c4Y0z.fetchBoardDeferredData)(params).map((response)=>$0b9246f64e9774ba$var$transformResponse(state, response)) : (0, $kVLXA.Observable).of({});
}

});
parcelRegister("c4Y0z", function(module, exports) {

$parcel$export(module.exports, "fetchBoardDeferredData", () => $8c74af111b0d8684$export$821f1f3b498e8a3a);

var $487fd = parcelRequire("487fd");
function $8c74af111b0d8684$export$821f1f3b498e8a3a({ rapidViewId: rapidViewId, fields: fields, sprintIds: sprintIds }) {
    return (0, $487fd.default)('/rest/greenhopper/1.0/xboard/work?operation=BoardDeferredData', {
        method: 'POST',
        body: JSON.stringify({
            rapidViewId: rapidViewId,
            fields: fields,
            sprintIds: sprintIds
        })
    });
}

});


parcelRegister("127QL", function(module, exports) {

$parcel$export(module.exports, "BOARD_DEFERRED_DATA_LOAD", () => $69e04667c910af41$export$488156a2acedb365);
$parcel$export(module.exports, "boardDeferredDataLoad", () => $69e04667c910af41$export$1377d0ddf952f96e);
$parcel$export(module.exports, "BOARD_DEFERRED_DATA_LOAD_SUCCESS", () => $69e04667c910af41$export$7d135eea66f1e179);
$parcel$export(module.exports, "boardDeferredDataLoadSuccess", () => $69e04667c910af41$export$aacf22e753eac02d);
$parcel$export(module.exports, "boardDeferredDataLoadFailure", () => $69e04667c910af41$export$a69030bf716a8538);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $69e04667c910af41$export$488156a2acedb365 = 'state.actions.board.deferred-data.BOARD_DEFERRED_DATA_LOAD';
const $69e04667c910af41$export$1377d0ddf952f96e = ()=>({
        type: $69e04667c910af41$export$488156a2acedb365
    });
const $69e04667c910af41$export$7d135eea66f1e179 = 'state.actions.board.deferred-data.BOARD_DEFERRED_DATA_LOAD_SUCCESS';
const $69e04667c910af41$export$aacf22e753eac02d = (data)=>({
        type: $69e04667c910af41$export$7d135eea66f1e179,
        payload: data
    });
const $69e04667c910af41$export$6127366444e01d37 = 'state.actions.board.deferred-data.BOARD_DEFERRED_DATA_LOAD_FAILURE';
const $69e04667c910af41$export$a69030bf716a8538 = ()=>({
        type: $69e04667c910af41$export$6127366444e01d37,
        meta: (0, $sdxnu.warningFlagMeta)({
            id: $69e04667c910af41$export$6127366444e01d37,
            titleMessage: (0, $7AVqz.default).boardDeferredDataFetchFailedTitle,
            descriptionMessage: (0, $7AVqz.default).boardDeferredDataFetchFailedDescription
        })
    });

});


parcelRegister("gT8Nn", function(module, exports) {

$parcel$export(module.exports, "boardFavouriteEpic", () => $023abee6a537bc22$export$4e1b6ecf03cefd35);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $1WPu2 = parcelRequire("1WPu2");

var $eXQym = parcelRequire("eXQym");

var $2xFXk = parcelRequire("2xFXk");

var $fC72p = parcelRequire("fC72p");

var $65C0W = parcelRequire("65C0W");

var $kc6Ry = parcelRequire("kc6Ry");

var $67Z81 = parcelRequire("67Z81");
function $023abee6a537bc22$export$4e1b6ecf03cefd35(action$, store) {
    return action$.ofType((0, $65C0W.SOFTWARE_APP_LOADED)).mergeMap(()=>{
        const state = store.getState();
        const rapidViewId = state.configuration.rapidViewId;
        const shouldRenderFavouriteButton = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_FAVOURITE_HEADER_BUTTON);
        if (!rapidViewId || !shouldRenderFavouriteButton) return (0, $kVLXA.Observable).empty();
        const baseUrl = (0, $67Z81.contextPathSelector)(state);
        return (0, $kVLXA.Observable).fromPromise((0, $1WPu2.getFavorite)(baseUrl, {
            id: rapidViewId,
            type: (0, $eXQym.BOARDS_ITEM_TYPE)
        })).flatMap((isFavourite)=>(0, $kVLXA.Observable).of((0, $fC72p.setIsFavourite)(isFavourite))).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board.get-favourite.failure', 'Board failed to get favourite', error);
            return (0, $kVLXA.Observable).empty();
        });
    });
}

});
parcelRegister("1WPu2", function(module, exports) {

$parcel$export(module.exports, "getFavorite", () => $1961b1823763022d$export$fce5eda070ce88d0);

var $eusud = parcelRequire("eusud");
const $1961b1823763022d$export$959ca2ee969adb8d = (baseUrl, request)=>`${baseUrl}/rest/internal/2/favourites/${request.type}/${request.id}`;
const $1961b1823763022d$export$fce5eda070ce88d0 = async (baseUrl, request)=>(0, $eusud.performGetRequest)($1961b1823763022d$export$959ca2ee969adb8d(baseUrl, request));

});

parcelRegister("fC72p", function(module, exports) {

$parcel$export(module.exports, "SET_IS_FAVOURITE", () => $2e4582cc57659349$export$beee5c21ec9e5d60);
$parcel$export(module.exports, "setIsFavourite", () => $2e4582cc57659349$export$24a32ddf7656ac02);
const $2e4582cc57659349$export$beee5c21ec9e5d60 = 'state.actions.board.board-favourite.SET_IS_FAVOURITE';
const $2e4582cc57659349$export$24a32ddf7656ac02 = (isFavourite)=>({
        type: $2e4582cc57659349$export$beee5c21ec9e5d60,
        payload: {
            isFavourite: isFavourite
        }
    });

});


parcelRegister("9KrY0", function(module, exports) {

$parcel$export(module.exports, "default", () => $5563228d2ce9baa5$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6cbqE");
parcelRequire("1oQta");
parcelRequire("fp4O3");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
const $5563228d2ce9baa5$var$showMissingIssueTypeMessageEpic = (action$, store)=>action$.ofType((0, $cW3pH.WORK_DATA_SET)).filter(({ payload: payload })=>(0, $67Z81.getIsCMPBoard)(store.getState()) && !!payload?.missingIssueType).switchMap(({ payload: payload })=>(0, $kVLXA.Observable).of((0, $cW3pH.showMissingIssueTypeMessage)(`${payload.missingIssueType}`)));
var $5563228d2ce9baa5$export$2e2bcd8739ae039 = $5563228d2ce9baa5$var$showMissingIssueTypeMessageEpic;

});

parcelRegister("ivoZ6", function(module, exports) {

$parcel$export(module.exports, "displayFlagForIssuesFilteredOnServerEpic", () => $b1635913d88ff144$export$94543f588a9945cb);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fPS7b");
parcelRequire("6cbqE");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("7mHDu");


var $bkCF5 = parcelRequire("bkCF5");

var $cW3pH = parcelRequire("cW3pH");

var $9UXXB = parcelRequire("9UXXB");
const $b1635913d88ff144$export$94543f588a9945cb = (action$, store)=>action$.ofType((0, $cW3pH.WORK_REFRESH_DATA)).filter(({ payload: payload })=>payload.source === (0, $dcbb2bce513725b3$export$7aa54af91613c70a)).filter(()=>(0, $9UXXB.getIsCustomBoardWithIcc)(store.getState())).switchMap((workRefreshDataAction)=>{
        const newIssues = workRefreshDataAction.payload.issues;
        // Do nothing if there are no new issues, or we have already shown a flag to let the user
        // know that the issue(s) is not visible on the board
        if (!newIssues?.length || workRefreshDataAction.payload.hasShownFlag) return (0, $kVLXA.Observable).empty();
        return action$.ofType((0, $cW3pH.WORK_DATA_SET)).take(1).mergeMap((workDataSetAction)=>{
            const boardIssuesSet = new Set(workDataSetAction.payload.issues.map((existingIssue)=>String(existingIssue.id)));
            const invisibleIssueKeys = newIssues.filter((newIssue)=>!boardIssuesSet.has(newIssue.issueId)).map((newIssue)=>newIssue.issueKey);
            if (invisibleIssueKeys.length) return (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateFilteredV2)(invisibleIssueKeys, undefined, true));
            return (0, $kVLXA.Observable).empty();
        });
    });

});
parcelRegister("9UXXB", function(module, exports) {

$parcel$export(module.exports, "hasInlineCardCreateConfig", () => $bf77070a4338987d$export$ba9264a1c34ce4c2);
$parcel$export(module.exports, "getInlineCardCreateConfig", () => $bf77070a4338987d$export$28108d977d110000);
$parcel$export(module.exports, "getIsCustomBoardWithIcc", () => $bf77070a4338987d$export$78757dfac0be9638);
$parcel$export(module.exports, "getInlineCreateSessionId", () => $bf77070a4338987d$export$12a9e7e0a7f5b591);
$parcel$export(module.exports, "hasInlineCreateSessionId", () => $bf77070a4338987d$export$8d0137731daaca51);
$parcel$export(module.exports, "hasAnyPartialIcc", () => $bf77070a4338987d$export$b671685f7447c75d);
$parcel$export(module.exports, "createIsIccEnabledForCardType", () => $bf77070a4338987d$export$d09efa5cd727594e);
$parcel$export(module.exports, "isIccEnabledForColumnOrSwimlane", () => $bf77070a4338987d$export$13138fa53969b181);
$parcel$export(module.exports, "getShouldCreateWithSwimlaneContext", () => $bf77070a4338987d$export$a70828438c7709f);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");

var $gJBT6 = parcelRequire("gJBT6");

var $5rFbt = parcelRequire("5rFbt");

var $bdYfL = parcelRequire("bdYfL");


var $iuuJH = parcelRequire("iuuJH");

var $k8auG = parcelRequire("k8auG");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $3WIXk = parcelRequire("3WIXk");
const $bf77070a4338987d$export$ba9264a1c34ce4c2 = (state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))($bf77070a4338987d$export$28108d977d110000(state));
const $bf77070a4338987d$export$28108d977d110000 = (state)=>(0, $67Z81.getBoardConfig)(state).inlineCardCreate;
const $bf77070a4338987d$export$78757dfac0be9638 = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$28108d977d110000
], (config)=>config?.requireJqlContext === true || false);
const $bf77070a4338987d$export$1ca4cd34e6f2914c = (state)=>(0, $67Z81.getEntities)(state).inlineCreate;
const $bf77070a4338987d$export$12a9e7e0a7f5b591 = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$1ca4cd34e6f2914c
], (inlineCreateState)=>inlineCreateState?.sessionId);
const $bf77070a4338987d$export$8d0137731daaca51 = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$12a9e7e0a7f5b591
], (sessionId)=>sessionId !== null && sessionId !== undefined);
const $bf77070a4338987d$export$b671685f7447c75d = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$28108d977d110000
], (config)=>config?.mode === (0, $c8d1b8aabfd899d6$export$c6861d2875ea3898) || Object.values(config?.columns ?? {}).some((column)=>column?.mode === (0, $c8d1b8aabfd899d6$export$c6861d2875ea3898) || Object.values(column?.issueTypes ?? {}).some((issueType)=>issueType === (0, $c8d1b8aabfd899d6$export$c6861d2875ea3898))));
const $bf77070a4338987d$export$d09efa5cd727594e = (0, $dGvGJ.createSelector)([
    $bf77070a4338987d$export$28108d977d110000
], (config)=>{
    const getConfigForCardType = (columnId, issueTypeId)=>(0, $3WIXk.isIccEnabledForBoard)(config) || (0, $3WIXk.isIccEnabledForColumn)(config?.columns?.[columnId], false) || (0, $3WIXk.isFullOrPartialMode)(config?.columns?.[columnId]?.issueTypes?.[issueTypeId]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(getConfigForCardType, (columnId, issueTypeId)=>`${columnId}-${issueTypeId}`);
});
const $bf77070a4338987d$export$90eaa0d797c99f72 = (state)=>$bf77070a4338987d$var$mapColumnIdToIsIccEnabled(state);
const $bf77070a4338987d$export$13138fa53969b181 = (state, swimlaneId, columnId)=>swimlaneId && $bf77070a4338987d$var$isIccEnabledForColumnInSwimlane(state, swimlaneId, columnId) || $bf77070a4338987d$var$mapColumnIdToIsIccEnabled(state)[columnId];
const $bf77070a4338987d$var$mapColumnIdToIsIccEnabled = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.workColumnsSelector),
    $bf77070a4338987d$export$28108d977d110000
], (columns, inlineCardCreateConfig)=>{
    const isIccEnabledInAllColumns = (0, $3WIXk.isIccEnabledForBoard)(inlineCardCreateConfig);
    return columns.reduce((acc, column)=>{
        acc[column.id] = isIccEnabledInAllColumns || (0, $3WIXk.isIccEnabledForColumn)(inlineCardCreateConfig?.columns?.[column.id]);
        return acc;
    }, {});
});
const $bf77070a4338987d$var$isIccEnabledForColumnInSwimlane = (state, swimlaneId, columnId)=>{
    const inlineCardCreate = $bf77070a4338987d$export$28108d977d110000(state);
    if (inlineCardCreate === undefined) return false;
    // Unscheduled work column swimlanes should have ICC enabled if their
    // regular swimlane is also allowed.
    const targetSwimlaneId = (0, $bdYfL.truncateUnscheduledWorkSwimlaneId)(swimlaneId, columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID));
    const config = inlineCardCreate?.swimlanes?.[targetSwimlaneId];
    if (config === undefined) return false;
    if (typeof config === 'string') return config === (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b);
    if (typeof config === 'object') return config?.[columnId]?.mode === (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b);
};
const $bf77070a4338987d$export$a70828438c7709f = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $45cXl.getSwimlaneMode),
    (0, $k8auG.getJQLSwimlanesData)
], (isCMPBoard, swimlaneMode, jqlSwimlanesData)=>(swimlaneId)=>{
        if (!swimlaneId || !isCMPBoard || swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_JQL).id) return false;
        const currentSwimlaneQuery = jqlSwimlanesData?.find((jqlSwimlane)=>jqlSwimlane.id === swimlaneId)?.query || '';
        return currentSwimlaneQuery !== '';
    });

});
const $c8d1b8aabfd899d6$export$c53d0f541b41b88e = 'NONE';
const $c8d1b8aabfd899d6$export$c6861d2875ea3898 = 'PARTIAL';
const $c8d1b8aabfd899d6$export$bb410559a65d3418 = 'MIXED';
const $c8d1b8aabfd899d6$export$3789e4b2a10baa2b = 'FULL';

parcelRegister("3WIXk", function(module, exports) {

$parcel$export(module.exports, "isFullOrPartialMode", () => $d4b1c6bd73471a37$export$b977e039f5321bc8);
$parcel$export(module.exports, "isIccEnabledForBoard", () => $d4b1c6bd73471a37$export$da5b0c54e4174c46);
$parcel$export(module.exports, "isIccEnabledForColumn", () => $d4b1c6bd73471a37$export$84781b659512b3e3);

const $d4b1c6bd73471a37$export$b977e039f5321bc8 = (mode)=>mode === 'FULL' || mode === 'PARTIAL';
const $d4b1c6bd73471a37$export$da5b0c54e4174c46 = (iccConfig)=>$d4b1c6bd73471a37$export$b977e039f5321bc8(iccConfig?.mode);
const $d4b1c6bd73471a37$export$84781b659512b3e3 = (iccColumnConfig, mixedCountsAsEnabled = true)=>$d4b1c6bd73471a37$export$b977e039f5321bc8(iccColumnConfig?.mode) || mixedCountsAsEnabled && iccColumnConfig?.mode === (0, $c8d1b8aabfd899d6$export$bb410559a65d3418);

});



parcelRegister("iUPbp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8bd03208ac61b763$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $7zmUm = parcelRequire("7zmUm");


var $2bQEl = parcelRequire("2bQEl");

var $bRqd3 = parcelRequire("bRqd3");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8bd03208ac61b763$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $bRqd3.CARD_MEDIA_TOGGLE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const { meta: { optimistic: { id: txId } }, payload: payload } = action;
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        return (0, $7zmUm.default)((0, $2bQEl.getCardMediaUrl)(contextPath, rapidViewId, payload), {
            method: 'PUT'
        }).flatMap(()=>(0, $kVLXA.Observable).of((0, $bRqd3.cardMediaToggleSuccess)(txId))).catch(()=>(0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $bRqd3.cardMediaToggleFailure)(txId), (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7))));
    });

});
parcelRegister("7zmUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $198ed207dec01cca$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $5HnTq = parcelRequire("5HnTq");

var $fnyT4 = parcelRequire("fnyT4");

var $jJZqs = parcelRequire("jJZqs");

var $8KpGl = parcelRequire("8KpGl");

var $51xpa = parcelRequire("51xpa");
const $198ed207dec01cca$var$noContentStatus = 204;
var // This function returns a stream which emits a single string value on success, and throws
// an error on failure
// eslint-disable-next-line jira/import/no-anonymous-default-export
$198ed207dec01cca$export$2e2bcd8739ae039 = (url, options = {})=>(0, $kVLXA.Observable).of(url).mergeMap(()=>fetch((0, $8KpGl.getReroutableURL)(url), (0, $7uUwQ.merge)((0, $7uUwQ.merge)((0, $5HnTq.defaultOptions), options), (0, $51xpa.makeObservabilityHeaders)(url)))).mergeMap((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = response.headers.get((0, $fnyT4.TRACE_ID_HEADER));
            if (traceId != null && traceId !== '') throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${response.status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $198ed207dec01cca$var$noContentStatus) // We want it to return a `null` value.
        // Using `Observable.empty<never>()` would just hang as `mergeMap`
        // will be waiting for values that would never come.
        return (0, $kVLXA.Observable).of(null);
        // @ts-expect-error - TS2339 - Property 'responseText' does not exist on type 'Response'.
        return (0, $kVLXA.Observable).of(response.responseText || 'OK');
    });

});

parcelRegister("bRqd3", function(module, exports) {

$parcel$export(module.exports, "CARD_MEDIA_TOGGLE_REQUEST", () => $e75e8c8203ec2d0b$export$719306e34608019a);
$parcel$export(module.exports, "cardMediaToggleRequest", () => $e75e8c8203ec2d0b$export$4b1efbebdd54c3d);
$parcel$export(module.exports, "cardMediaToggleSuccess", () => $e75e8c8203ec2d0b$export$285b5a0a83782540);
$parcel$export(module.exports, "cardMediaToggleFailure", () => $e75e8c8203ec2d0b$export$f7ec8b763e0e34a9);
$parcel$export(module.exports, "TOGGLE_EPIC_LABELS", () => $e75e8c8203ec2d0b$export$8891d4381b655683);
$parcel$export(module.exports, "TOGGLE_BOARD_MENUS", () => $e75e8c8203ec2d0b$export$5f9ed1654c2cc426);
$parcel$export(module.exports, "toggleBoardMenus", () => $e75e8c8203ec2d0b$export$243850555d503a0e);
$parcel$export(module.exports, "SET_SHOW_UNSCHEDULED_COLUMN", () => $e75e8c8203ec2d0b$export$4abd03d3963e57b5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $e75e8c8203ec2d0b$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "SET_SHOW_OFFTRACK_DEPENDENCY_LINES", () => $e75e8c8203ec2d0b$export$93995bde3b9283cd);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $e75e8c8203ec2d0b$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "SET_ISSUE_IDS_TO_SHOW_DEPENDENCIES", () => $e75e8c8203ec2d0b$export$5dae7370c17441a3);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $e75e8c8203ec2d0b$export$f7b68cb584e33d77);

var $9rND4 = parcelRequire("9rND4");
const $e75e8c8203ec2d0b$export$719306e34608019a = 'state.actions.board.menu.CARD_MEDIA_TOGGLE_REQUEST';
const $e75e8c8203ec2d0b$export$4b1efbebdd54c3d = (enabled)=>({
        type: $e75e8c8203ec2d0b$export$719306e34608019a,
        payload: enabled,
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $e75e8c8203ec2d0b$export$1fb38032498c251e = 'state.actions.board.menu.CARD_MEDIA_TOGGLE_SUCCESS';
const $e75e8c8203ec2d0b$export$285b5a0a83782540 = (optimisticId)=>({
        type: $e75e8c8203ec2d0b$export$1fb38032498c251e,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $e75e8c8203ec2d0b$export$3a6ff55415f705db = 'state.actions.board.menu.CARD_MEDIA_TOGGLE_FAILURE';
const $e75e8c8203ec2d0b$export$f7ec8b763e0e34a9 = (optimisticId)=>({
        type: $e75e8c8203ec2d0b$export$3a6ff55415f705db,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });
const $e75e8c8203ec2d0b$export$8891d4381b655683 = 'state.actions.board.menu.TOGGLE_EPIC_LABELS';
const $e75e8c8203ec2d0b$export$ee8c4e37e8444ea0 = ()=>({
        type: $e75e8c8203ec2d0b$export$8891d4381b655683
    });
const $e75e8c8203ec2d0b$export$5f9ed1654c2cc426 = 'state.actions.board.menu.TOGGLE_BOARD_MENUS';
const $e75e8c8203ec2d0b$export$243850555d503a0e = ()=>({
        type: $e75e8c8203ec2d0b$export$5f9ed1654c2cc426
    });
const $e75e8c8203ec2d0b$export$4abd03d3963e57b5 = 'state.actions.board.menu.SET_SHOW_UNSCHEDULED_COLUMN';
const $e75e8c8203ec2d0b$export$6edce735c6eb4cb0 = (isVisible)=>({
        type: $e75e8c8203ec2d0b$export$4abd03d3963e57b5,
        payload: isVisible
    });
const $e75e8c8203ec2d0b$export$93995bde3b9283cd = 'state.actions.board.menu.SET_SHOW_OFFTRACK_DEPENDENCY_LINES';
const $e75e8c8203ec2d0b$export$2c48063cd4ef1ade = (isVisible)=>({
        type: $e75e8c8203ec2d0b$export$93995bde3b9283cd,
        payload: isVisible
    });
const $e75e8c8203ec2d0b$export$5dae7370c17441a3 = 'state.actions.board.menu.SET_ISSUE_IDS_TO_SHOW_DEPENDENCIES';
const $e75e8c8203ec2d0b$export$f7b68cb584e33d77 = (issueIds)=>({
        type: $e75e8c8203ec2d0b$export$5dae7370c17441a3,
        payload: issueIds
    });

});


parcelRegister("8Wyzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $40e2e2eb84d7bcca$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");


var $53WSK = parcelRequire("53WSK");

var $7buQq = parcelRequire("7buQq");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$40e2e2eb84d7bcca$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $7buQq.RENAME_BOARD_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const { meta: { optimistic: { id: txId } }, payload: payload } = action;
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        return (0, $53WSK.boardRename)(contextPath, rapidViewId, payload).flatMap(()=>(0, $kVLXA.Observable).of((0, $7buQq.renameBoardSuccess)(txId))).catch(()=>(0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $7buQq.renameBoardFailure)(txId), (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7))));
    });

});
parcelRegister("53WSK", function(module, exports) {

$parcel$export(module.exports, "boardRename", () => $cae6afb0909c8563$export$8da1f9009157a0df);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $cae6afb0909c8563$export$fb5697ad18168ddd = 'SoftwareBoardRename';
const $cae6afb0909c8563$export$4031368f5d20bd91 = (0, $ivqh1.gqlTagSwag)`
    mutation SoftwareBoardRename($boardId: ID!, $boardName: String!) {
        setBoardName(input: {boardId: $boardId, boardName: $boardName}) {
            boardName
        }
    }
`;
const $cae6afb0909c8563$export$8da1f9009157a0df = (contextPath, boardId, boardName)=>(0, $6iJbJ.mutation$)(contextPath, $cae6afb0909c8563$export$fb5697ad18168ddd, $cae6afb0909c8563$export$4031368f5d20bd91, {
        boardId: boardId,
        boardName: boardName
    }, (0, $CFxE9.boardRenameAnalyticsOptions));

});

parcelRegister("7buQq", function(module, exports) {

$parcel$export(module.exports, "RENAME_BOARD_REQUEST", () => $36bdd2cfb2ea3f95$export$b59e884cbd8a2072);
$parcel$export(module.exports, "renameBoardRequest", () => $36bdd2cfb2ea3f95$export$43cfff342e1dcc87);
$parcel$export(module.exports, "RENAME_BOARD_SUCCESS", () => $36bdd2cfb2ea3f95$export$5a20dd2dded5bbca);
$parcel$export(module.exports, "renameBoardSuccess", () => $36bdd2cfb2ea3f95$export$21475b90a48a2c95);
$parcel$export(module.exports, "RENAME_BOARD_FAILURE", () => $36bdd2cfb2ea3f95$export$f719aabfc87bc812);
$parcel$export(module.exports, "renameBoardFailure", () => $36bdd2cfb2ea3f95$export$244d02fac7e80a83);

var $9rND4 = parcelRequire("9rND4");
const $36bdd2cfb2ea3f95$export$b59e884cbd8a2072 = 'state.actions.board.rename.RENAME_BOARD_REQUEST';
const $36bdd2cfb2ea3f95$export$43cfff342e1dcc87 = (title)=>({
        type: $36bdd2cfb2ea3f95$export$b59e884cbd8a2072,
        payload: title,
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $36bdd2cfb2ea3f95$export$5a20dd2dded5bbca = 'state.actions.board.rename.RENAME_BOARD_SUCCESS';
const $36bdd2cfb2ea3f95$export$21475b90a48a2c95 = (optimisticId)=>({
        type: $36bdd2cfb2ea3f95$export$5a20dd2dded5bbca,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $36bdd2cfb2ea3f95$export$f719aabfc87bc812 = 'state.actions.board.rename.RENAME_BOARD_FAILURE';
const $36bdd2cfb2ea3f95$export$244d02fac7e80a83 = (optimisticId)=>({
        type: $36bdd2cfb2ea3f95$export$f719aabfc87bc812,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("dxMXW", function(module, exports) {

$parcel$export(module.exports, "bulkIssueRankTransitionRequestEpic", () => $ce592a45e2208b19$export$602946aa03c7ea46);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("93e44");
parcelRequire("d6iim");
parcelRequire("1oQta");
parcelRequire("fPS7b");
parcelRequire("fjPtF");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");


var $2W0EG = parcelRequire("2W0EG");

var $9iM6y = parcelRequire("9iM6y");

var $hdmw1 = parcelRequire("hdmw1");

var $4gHuj = parcelRequire("4gHuj");

var $71oFY = parcelRequire("71oFY");

var $cW3pH = parcelRequire("cW3pH");

var $lIysR = parcelRequire("lIysR");

var $fyeGd = parcelRequire("fyeGd");

var $3UY9S = parcelRequire("3UY9S");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $cN1y7 = parcelRequire("cN1y7");
const $ce592a45e2208b19$var$checkIfAnyIssueHasScreen = (state, payload)=>{
    const { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, transitionId: transitionId } = payload;
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    for (const issueId of issueIds){
        const issue = allIssues[String(issueId)];
        const destinationTransitions = (0, $lIysR.getTransitionsByColumnAndIssueType)(state, {
            columnId: destinationColumnId,
            issueTypeId: issue.typeId,
            projectId: issue.projectId
        });
        let selectedTransitionId = transitionId;
        // Set the new value based on the project key
        selectedTransitionId = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) && sourceColumnId !== destinationColumnId ? (0, $fyeGd.firstGlobalTransitionIdForColumnWithProjectFilteringSelector)(state)(destinationColumnId, issue) : transitionId;
        const transitionIndex = selectedTransitionId != null ? destinationTransitions.findIndex((transition)=>transition.id === transitionId) : null;
        const transition = transitionIndex != null ? destinationTransitions[transitionIndex] : null;
        if (transition?.hasScreen) return true;
    }
    return false;
};
const $ce592a45e2208b19$var$handleBulkIssueRankSuccess = ({ payload: payload, optimisticId: optimisticId, boardId: boardId, analyticsEvent: analyticsEvent })=>{
    if (analyticsEvent) {
        const { issueIds: issueIds, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId, columnId: columnId } = payload;
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'bulkIssueRank success', {
            boardId: boardId,
            issueIds: issueIds,
            rankAfterId: rankAfterId,
            rankBeforeId: rankBeforeId,
            columnId: columnId
        });
    }
    return (0, $kVLXA.Observable).from([
        (0, $71oFY.bulkIssueRankSuccess)({
            payload: payload,
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent
        }),
        (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$5e8e8357f5d6fec1))
    ]);
};
const $ce592a45e2208b19$var$handleBulkIssueRankError = ({ payload: payload, optimisticId: optimisticId, boardId: boardId, error: error, analyticsEvent: analyticsEvent })=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData('bulk.issue.rank.failure', 'Failed to rank multiple issues', error);
    if (analyticsEvent && (0, $cN1y7.shouldFireFailureSLOMetric)(error)) {
        const { issueIds: issueIds, issueKeys: issueKeys, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId, columnId: columnId } = payload;
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'bulkIssueRank failed', {
            errorMessage: error.message ? error.message : error,
            statusCodeGroup: (0, $cN1y7.getStatusCodeGroup)(error),
            boardId: boardId,
            issueIds: issueIds,
            issueKeys: issueKeys,
            rankAfterId: rankAfterId,
            rankBeforeId: rankBeforeId,
            columnId: columnId
        });
    }
    return (0, $kVLXA.Observable).of((0, $71oFY.bulkIssueRankFailure)({
        payload: payload,
        optimisticId: optimisticId,
        errorMessages: (0, $2W0EG.parseJiraErrorMessages)(error),
        analyticsEvent: analyticsEvent,
        ...error && error.traceId && (0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? {
            error: error,
            traceId: error.traceId
        } : {}
    }));
};
const $ce592a45e2208b19$var$doBulkIssueRank = ({ request: request, columnId: columnId, boardId: boardId, analyticsEvent: analyticsEvent })=>{
    const { issueIds: issueIds, issueKeys: issueKeys, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId } = request;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueIds)) return (0, $kVLXA.Observable).empty();
    const bulkIssueRankOptimisticAction = (0, $71oFY.bulkIssueRankOptimistic)({
        issueIds: issueIds,
        rankAfterId: rankAfterId,
        rankBeforeId: rankBeforeId
    });
    const optimisticId = bulkIssueRankOptimisticAction.meta.optimistic.id;
    return (0, $kVLXA.Observable).merge((0, $kVLXA.Observable).of(bulkIssueRankOptimisticAction), (0, $9iM6y.bulkIssueRankService)(request).flatMap(()=>$ce592a45e2208b19$var$handleBulkIssueRankSuccess({
            payload: {
                issueIds: issueIds,
                rankAfterId: rankAfterId,
                rankBeforeId: rankBeforeId,
                columnId: columnId
            },
            boardId: boardId,
            optimisticId: optimisticId,
            analyticsEvent: analyticsEvent
        })).catch((error)=>$ce592a45e2208b19$var$handleBulkIssueRankError({
            payload: {
                issueIds: issueIds,
                issueKeys: issueKeys,
                rankAfterId: rankAfterId,
                rankBeforeId: rankBeforeId,
                columnId: columnId
            },
            boardId: boardId,
            optimisticId: optimisticId,
            error: error,
            analyticsEvent: analyticsEvent
        })));
};
function $ce592a45e2208b19$export$602946aa03c7ea46(action$, store) {
    return action$.ofType((0, $71oFY.BULK_ISSUE_RANK_TRANSITION_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const { rankCustomFieldId: rankCustomFieldId, boardIsRankable: boardIsRankable } = (0, $d2i8f.getRankConfig)(state);
        const { payload: { issueIds: issueIds, ...restPayload }, meta: { analyticsEvent: analyticsEvent } } = action;
        const { sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankAfterIssueId: rankAfterIssueId, rankBeforeIssueId: rankBeforeIssueId, transitionId: transitionId } = restPayload;
        // Transition screen check only works for single issue
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueIds) && issueIds.length > 1) {
            const canBulkRankIssues = isCMPBoard && boardIsRankable && sourceColumnId === destinationColumnId && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId);
            // TNK-628: bulk issue rank within the same column
            if (canBulkRankIssues) {
                const request = {
                    customFieldId: rankCustomFieldId,
                    issueIds: issueIds,
                    issueKeys: (0, $d2i8f.getIssueKeysFromIssueIds)(state)(issueIds),
                    rankAfterId: rankAfterIssueId ?? null,
                    rankBeforeId: rankBeforeIssueId ?? null
                };
                const { boardId: boardId } = (0, $hdmw1.makeServiceContext)(state);
                return $ce592a45e2208b19$var$doBulkIssueRank({
                    request: request,
                    columnId: destinationColumnId,
                    boardId: boardId,
                    analyticsEvent: analyticsEvent
                });
            }
            const hasScreen = $ce592a45e2208b19$var$checkIfAnyIssueHasScreen(state, action.payload);
            if (hasScreen) return (0, $kVLXA.Observable).empty();
        }
        const getSortedIssuedIds = ()=>{
            const orderedAllIssueIds = isCMPBoard ? (0, $vAfHD.boardOrderedIssueIdsSelector)(state) : [
                ...(0, $67Z81.getOrderedIssueIds)(state),
                ...(0, $67Z81.getOrderedIssueChildrenIds)(state)
            ];
            const orderedIssueIds = orderedAllIssueIds.filter((issueId)=>issueIds.includes(issueId));
            // Fire the requests in the reverse order when ranking after an issue, so we will receive the right order within optimistic update
            if (rankAfterIssueId) orderedIssueIds.reverse();
            return orderedIssueIds;
        };
        const batchId = (0, $7Jxgt.v4)();
        const shouldRetainRankingOrder = isCMPBoard && transitionId;
        const mode = shouldRetainRankingOrder ? 'TRANSITION_ONLY' : 'TRANSITION_AND_RANK';
        const bufferCount = shouldRetainRankingOrder ? 1 : issueIds.length;
        const requestActions$ = (0, $kVLXA.Observable).from(shouldRetainRankingOrder ? [
            (0, $71oFY.issueRankTransitionRequest)({
                issueIds: issueIds,
                batchId: batchId,
                mode: mode,
                ...restPayload,
                analyticsEvent: analyticsEvent
            })
        ] : getSortedIssuedIds().map((issueId)=>(0, $71oFY.issueRankTransitionRequest)({
                issueIds: [
                    issueId
                ],
                batchId: batchId,
                mode: mode,
                ...restPayload,
                analyticsEvent: analyticsEvent
            })));
        const resultActions$ = action$.ofType((0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS), (0, $71oFY.ISSUE_RANK_TRANSITION_FAILURE)).filter((resultAction)=>resultAction.payload.batchId === batchId).bufferCount(bufferCount).flatMap((bulkRankTransitionActions)=>{
            const success = bulkRankTransitionActions.every(({ type: type })=>type === (0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS));
            const actions = [];
            if (isCMPBoard && issueIds.length === 1) {
                const issueChild = (0, $3UY9S.getIssueChildren)(state)[issueIds[0]];
                const isDestinationLastColumn = (0, $fyeGd.isLastColumn)(state)(destinationColumnId);
                const isMoveIssueChildToFinalColumn = !!issueChild && isDestinationLastColumn;
                if (isMoveIssueChildToFinalColumn && issueChild?.parentId) actions.push((0, $4gHuj.issueChildrenInFinalColumnRequest)(issueChild.parentId));
            }
            if (isCMPBoard || !success) actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$ce2132697bb05fef)));
            return actions;
        });
        return requestActions$.merge(resultActions$);
    });
}

});
parcelRegister("2W0EG", function(module, exports) {

$parcel$export(module.exports, "flatErrorCollection", () => $a35e6abd1f710935$export$b3cd6c63b23466db);
$parcel$export(module.exports, "parseErrorCollection", () => $a35e6abd1f710935$export$3ff6e9345ed6c068);
$parcel$export(module.exports, "hasJiraErrorMessages", () => $a35e6abd1f710935$export$7ee986d35f407138);
$parcel$export(module.exports, "parseJiraErrorMessages", () => $a35e6abd1f710935$export$d11297bc34463f4);

var $9XE6b = parcelRequire("9XE6b");

var $g5X3G = parcelRequire("g5X3G");
const $a35e6abd1f710935$export$b3cd6c63b23466db = ({ errorMessages: errorMessages, errors: errors })=>[
        ...errorMessages,
        ...(0, $g5X3G.values)(errors).map((error)=>String(error))
    ];
const $a35e6abd1f710935$export$3ff6e9345ed6c068 = (value)=>{
    try {
        return JSON.parse(value);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return null;
    }
};
const $a35e6abd1f710935$var$parseMessage = (error)=>{
    if (error === null || typeof error !== 'object') return null;
    try {
        const message = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
            'message'
        ], null);
        return JSON.parse(message);
    } catch  {
        return null;
    }
};
const $a35e6abd1f710935$var$hasErrorMessagesProperty = (response)=>response !== null && typeof response === 'object' && 'errorMessages' in response && Array.isArray(response.errorMessages);
function $a35e6abd1f710935$export$7ee986d35f407138(error) {
    const response = $a35e6abd1f710935$var$parseMessage(error);
    return $a35e6abd1f710935$var$hasErrorMessagesProperty(response) && response.errorMessages.length > 0;
}
function $a35e6abd1f710935$export$d11297bc34463f4(error) {
    const response = $a35e6abd1f710935$var$parseMessage(error);
    if ($a35e6abd1f710935$var$hasErrorMessagesProperty(response)) return response.errorMessages;
    return [];
}

});

parcelRegister("9iM6y", function(module, exports) {

$parcel$export(module.exports, "issueRankTransitionService", () => $f3edef2c3e1d93a0$export$9d336858bcd7405d);
$parcel$export(module.exports, "issueTransitionService", () => $f3edef2c3e1d93a0$export$ba3cd808df5aa712);
$parcel$export(module.exports, "bulkIssueRankService", () => $f3edef2c3e1d93a0$export$ba8ad8c2abac62ca);
/*!
 * This module contains services to perform the "issue rank transition"
 * interaction. It is the core interation on the board triggered by DnD.
 */ 
var $6IdBA = parcelRequire("6IdBA");

var $ebtJs = parcelRequire("ebtJs");
const $f3edef2c3e1d93a0$export$9d336858bcd7405d = (ctx, params)=>(0, $ebtJs.issueRankTransitionRest)({
        ...params,
        rapidViewId: ctx.boardId
    });
const $f3edef2c3e1d93a0$export$ba3cd808df5aa712 = (ctx, params)=>(0, $ebtJs.issueTransitionRest)({
        ...params,
        rapidViewId: ctx.boardId
    });
const $f3edef2c3e1d93a0$export$7b83c1de334ef96f = (boardCardMoveInput)=>(0, $6IdBA.fetchBoardCardMoveData)(boardCardMoveInput);
const $f3edef2c3e1d93a0$export$ba8ad8c2abac62ca = (request)=>(0, $ebtJs.bulkIssuesRankRest)(request);

});
parcelRegister("6IdBA", function(module, exports) {

$parcel$export(module.exports, "fetchBoardCardMoveData", () => $2db63b1697da1157$export$80d34452c0dfeb9f);

var $cyB0k = parcelRequire("cyB0k");

var $9XE6b = parcelRequire("9XE6b");

var $8Uumt = parcelRequire("8Uumt");

var $kVLXA = parcelRequire("kVLXA");

var $jJZqs = parcelRequire("jJZqs");

var $5yJb9 = parcelRequire("5yJb9");

var $3vXOY = parcelRequire("3vXOY");
const $2db63b1697da1157$var$commitMutationPromise = (environment, config)=>new Promise((resolve, reject)=>{
        (0, $8Uumt.commitMutation)(environment, {
            ...config,
            onCompleted: (payload, errors)=>{
                if (errors && errors.length) {
                    const statusCode = (0, $3vXOY.getStatusCodeFromGraphQLErrors)(errors);
                    if (statusCode == null) {
                        reject(errors);
                        return;
                    }
                    reject(new (0, $jJZqs.default)(statusCode, ''));
                    return;
                }
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(payload, 'boardCardMove.issuesWereTransitioned')) /**
         * reponse may return 200 with issuesWereTransitioned value of false or null.
         * It indicates a card move failure due to permission limit, not an server error.
         * an example would be a board viewer (no transit/rank permission) is trying to move a card to an empty column in a private/limited board.
         */ reject(new (0, $jJZqs.default)(400, 'Either transition or rank operation has failed'));
                resolve(payload);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    });
const $2db63b1697da1157$export$80d34452c0dfeb9f = (boardCardMoveInput)=>(0, $kVLXA.Observable).fromPromise($2db63b1697da1157$var$commitMutationPromise((0, $5yJb9.default)(), {
        mutation: (0, $cyB0k.default),
        variables: {
            input: boardCardMoveInput
        }
    }));

});
parcelRegister("cyB0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $bcc86afb0e7a79a2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<bc3d20ecb89f269e5ad3b832be7a9157>>
 * @relayHash 17884dd7a2725afd1ecddbac0203e0c6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 40d424bfde4b11217f082daf833da3f2b16249a245232509f69ddfc2ece3f52d
const $bcc86afb0e7a79a2$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "input",
                    "variableName": "input"
                }
            ],
            "concreteType": "MoveCardOutput",
            "kind": "LinkedField",
            "name": "boardCardMove",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "clientMutationId"
                },
                {
                    "kind": "ScalarField",
                    "name": "statusCode"
                },
                {
                    "kind": "ScalarField",
                    "name": "issuesWereTransitioned"
                },
                {
                    "kind": "ScalarField",
                    "name": "success"
                },
                {
                    "kind": "ScalarField",
                    "name": "message"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "boardCardMoveGraphqlMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "boardCardMoveGraphqlMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "40d424bfde4b11217f082daf833da3f2b16249a245232509f69ddfc2ece3f52d",
            "metadata": {},
            "name": "boardCardMoveGraphqlMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$bcc86afb0e7a79a2$var$node.hash = "07779c221ada4d8e57caa4881dae0ab4";
var $bcc86afb0e7a79a2$export$2e2bcd8739ae039 = $bcc86afb0e7a79a2$var$node;

});

parcelRegister("3vXOY", function(module, exports) {

$parcel$export(module.exports, "getStatusCodeFromGraphQLErrors", () => $47b135a1579c5003$export$37c7f88726f3fb5e);
$parcel$export(module.exports, "extractStatusCode", () => $47b135a1579c5003$export$1fdf7c1c0741a7e7);

var $9XE6b = parcelRequire("9XE6b");

var $fEeCa = parcelRequire("fEeCa");
const $47b135a1579c5003$export$37c7f88726f3fb5e = (graphQLErrors)=>{
    const statusCodes = graphQLErrors.map((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(e, [
            'extensions',
            'statusCode'
        ])).filter((statusCode)=>!!statusCode);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($fEeCa)))(statusCodes);
    return statusCode || null;
};
const $47b135a1579c5003$export$1fdf7c1c0741a7e7 = (error)=>{
    const errorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ], null);
    const graphQLErrors = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'graphQLErrors'
    ], null);
    const networkError = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError'
    ], null);
    const statusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(networkError, [
        'statusCode'
    ], null);
    if (typeof errorStatusCode === 'number') return errorStatusCode;
    if (typeof statusCode === 'number') return statusCode;
    if (Array.isArray(graphQLErrors) && graphQLErrors.length > 0) return $47b135a1579c5003$export$37c7f88726f3fb5e(graphQLErrors);
    return null;
};

});
parcelRegister("fEeCa", function(module, exports) {

var $la2vn = parcelRequire("la2vn");

var $5JMmU = parcelRequire("5JMmU");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the maximum value of `array`. If `array` is empty or falsey,
 * `undefined` is returned.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {*} Returns the maximum value.
 * @example
 *
 * _.max([4, 2, 8, 6]);
 * // => 8
 *
 * _.max([]);
 * // => undefined
 */ function $b645ed9a7ba1767e$var$max(array) {
    return array && array.length ? $la2vn(array, $etyzk, $5JMmU) : undefined;
}
module.exports = $b645ed9a7ba1767e$var$max;

});
parcelRegister("la2vn", function(module, exports) {

var $4faK3 = parcelRequire("4faK3");
/**
 * The base implementation of methods like `_.max` and `_.min` which accepts a
 * `comparator` to determine the extremum value.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The iteratee invoked per iteration.
 * @param {Function} comparator The comparator used to compare values.
 * @returns {*} Returns the extremum value.
 */ function $f67c7999c5b61dcb$var$baseExtremum(array, iteratee, comparator) {
    var index = -1, length = array.length;
    while(++index < length){
        var value = array[index], current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !$4faK3(current) : comparator(current, computed))) var computed = current, result = value;
    }
    return result;
}
module.exports = $f67c7999c5b61dcb$var$baseExtremum;

});

parcelRegister("5JMmU", function(module, exports) {
/**
 * The base implementation of `_.gt` which doesn't coerce arguments.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if `value` is greater than `other`,
 *  else `false`.
 */ function $42d6acb577163acc$var$baseGt(value, other) {
    return value > other;
}
module.exports = $42d6acb577163acc$var$baseGt;

});




parcelRegister("ebtJs", function(module, exports) {

$parcel$export(module.exports, "issueRankTransitionRest", () => $625414a6b60d7282$export$111e8fb2c8c47d7c);
$parcel$export(module.exports, "issueTransitionRest", () => $625414a6b60d7282$export$6ad92272c657c4f2);
$parcel$export(module.exports, "bulkIssuesRankRest", () => $625414a6b60d7282$export$2a0723596931d3);
parcelRequire("d0pqD");

var $487fd = parcelRequire("487fd");

var $jJZqs = parcelRequire("jJZqs");

var $2bQEl = parcelRequire("2bQEl");
const $625414a6b60d7282$var$FAIL_TO_TRANSITION_MESSAGE = 'Either transition or rank operation has failed';
const $625414a6b60d7282$var$FAIL_TO_BULK_RANK_MESSAGE = 'Bulk rank issue has failed';
function $625414a6b60d7282$export$111e8fb2c8c47d7c(request) {
    const url = (0, $2bQEl.getIssueTransitionWithoutColumnUrl)('');
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify(request)
    }).map((response)=>{
        if (!response.issuesWereTransitioned) // The 'PUT /rest/greenhopper/1.0/board/issues/transition' may return HTTP 200 but either
        // transition or ranking may have failed.
        throw new (0, $jJZqs.default)(200, $625414a6b60d7282$var$FAIL_TO_TRANSITION_MESSAGE);
        return response;
    });
}
function $625414a6b60d7282$export$6ad92272c657c4f2(request) {
    const url = (0, $2bQEl.getIssueTransitionUrl)();
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify(request)
    }).map((response)=>{
        if (!response.issuesWereTransitioned) throw new (0, $jJZqs.default)(200, $625414a6b60d7282$var$FAIL_TO_TRANSITION_MESSAGE);
        return response;
    });
}
function $625414a6b60d7282$export$2a0723596931d3(request) {
    const url = (0, $2bQEl.getBulkIssueRankUrl)();
    return (0, $487fd.default)(url, {
        method: 'PUT',
        body: JSON.stringify(request)
    }).map((response)=>{
        if (!response.rankableChanges.every((change)=>change.wasChanged)) throw new (0, $jJZqs.default)(200, $625414a6b60d7282$var$FAIL_TO_BULK_RANK_MESSAGE);
        return response;
    });
}

});


parcelRegister("hdmw1", function(module, exports) {

$parcel$export(module.exports, "makeServiceContext", () => $dddff9ba935cce70$export$47bf8333d7adacd0);
/*!
 * `ServiceContext` should be the first parameter of all service functions.
 *
 * Its purpouse is to have a pattern for switching between CMP/TMP
 * implementations of service calls.
 */ 
var $67Z81 = parcelRequire("67Z81");
function $dddff9ba935cce70$export$47bf8333d7adacd0(state) {
    return {
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        contextPath: state.configuration.contextPath,
        isCMPBoard: state.configuration.isCMPBoard,
        projectType: state.configuration.projectType,
        /**
		 * ARJ Increment Planning Board
		 */ isIncrementPlanningBoard: state.configuration.isIncrementPlanningBoard,
        planId: state.configuration.planId,
        scenarioId: state.configuration.scenarioId
    };
}

});

parcelRegister("4gHuj", function(module, exports) {

$parcel$export(module.exports, "SET_ISSUE_CHILDREN", () => $763f0d2a873de2fb$export$bad3c245445c8a02);
$parcel$export(module.exports, "setIssueChildren", () => $763f0d2a873de2fb$export$295fd024aec9d7fc);
$parcel$export(module.exports, "SET_ISSUE_CHILDREN_RANK", () => $763f0d2a873de2fb$export$dcc4baa31a152f1f);
$parcel$export(module.exports, "setIssueChildrenRank", () => $763f0d2a873de2fb$export$ace85f775492db73);
$parcel$export(module.exports, "ISSUE_CHILDREN_IN_FINAL_COLUMN_REQUEST", () => $763f0d2a873de2fb$export$397897ffe4d78f07);
$parcel$export(module.exports, "issueChildrenInFinalColumnRequest", () => $763f0d2a873de2fb$export$8013b6ba4a423c1e);
const $763f0d2a873de2fb$export$bad3c245445c8a02 = 'state.actions.issue-children.SET_ISSUE_CHILDREN';
const $763f0d2a873de2fb$export$295fd024aec9d7fc = (issueChildren)=>({
        type: $763f0d2a873de2fb$export$bad3c245445c8a02,
        payload: issueChildren
    });
const $763f0d2a873de2fb$export$dcc4baa31a152f1f = 'state.actions.issue-children.SET_ISSUE_CHILDREN_RANK';
const $763f0d2a873de2fb$export$ace85f775492db73 = ({ issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter })=>({
        type: $763f0d2a873de2fb$export$dcc4baa31a152f1f,
        payload: {
            issueIds: issueIds,
            rankId: rankId,
            isRankAfter: isRankAfter
        }
    });
const $763f0d2a873de2fb$export$397897ffe4d78f07 = 'state.actions.issue-children.ISSUE_CHILDREN_IN_FINAL_COLUMN_REQUEST';
const $763f0d2a873de2fb$export$8013b6ba4a423c1e = (parentId)=>({
        type: $763f0d2a873de2fb$export$397897ffe4d78f07,
        payload: {
            parentId: parentId
        }
    });
const $763f0d2a873de2fb$export$178eb342582389a5 = 'state.actions.issue.mentions.CLEAR_ISSUE_CHILDREN_MENTIONS_OPTIMISTIC';
const $763f0d2a873de2fb$export$497ab62da21b0596 = (issueId)=>({
        type: $763f0d2a873de2fb$export$178eb342582389a5,
        payload: {
            issueId: issueId
        }
    });

});

parcelRegister("71oFY", function(module, exports) {

$parcel$export(module.exports, "ISSUE_MOVE_TOP_OR_BOTTOM_OF_CONTAINER", () => $9f8e1ddea3adc68b$export$b80f022994c740bc);
$parcel$export(module.exports, "issueMoveToTopOrBottomOfContainer", () => $9f8e1ddea3adc68b$export$2ff1e3c40336316d);
$parcel$export(module.exports, "ISSUE_RANK_TRANSITION_REQUEST", () => $9f8e1ddea3adc68b$export$938599f8d9ebcd04);
$parcel$export(module.exports, "issueRankTransitionRequest", () => $9f8e1ddea3adc68b$export$2ad8924ae4613236);
$parcel$export(module.exports, "ISSUE_RANK_TRANSITION_SUCCESS", () => $9f8e1ddea3adc68b$export$b3d13442a2ed1704);
$parcel$export(module.exports, "issueRankTransitionSuccess", () => $9f8e1ddea3adc68b$export$fc64d70c84553912);
$parcel$export(module.exports, "issueRankTransitionAbort", () => $9f8e1ddea3adc68b$export$5a1d2ddad6ab4718);
$parcel$export(module.exports, "ISSUE_RANK_TRANSITION_FAILURE", () => $9f8e1ddea3adc68b$export$d3e0b64e628deb4e);
$parcel$export(module.exports, "issueRankTransitionFailure", () => $9f8e1ddea3adc68b$export$ade8b8e0a05059d7);
$parcel$export(module.exports, "issueRankTransitionFailureFieldRequired", () => $9f8e1ddea3adc68b$export$d43c922db5540629);
$parcel$export(module.exports, "SET_ISSUES_RANK", () => $9f8e1ddea3adc68b$export$bf5069f2a3267b16);
$parcel$export(module.exports, "setIssuesRank", () => $9f8e1ddea3adc68b$export$fb8df558645d5a07);
$parcel$export(module.exports, "BULK_ISSUE_RANK_TRANSITION_REQUEST", () => $9f8e1ddea3adc68b$export$ac1d3ac6f7579174);
$parcel$export(module.exports, "bulkIssueRankTransitionRequest", () => $9f8e1ddea3adc68b$export$8e38daa216161e13);
$parcel$export(module.exports, "BULK_ISSUE_RANK_OPTIMISTIC", () => $9f8e1ddea3adc68b$export$9f14d1e314ad435a);
$parcel$export(module.exports, "bulkIssueRankOptimistic", () => $9f8e1ddea3adc68b$export$56be38daffc22c8e);
$parcel$export(module.exports, "bulkIssueRankSuccess", () => $9f8e1ddea3adc68b$export$6c201115eb201f20);
$parcel$export(module.exports, "bulkIssueRankFailure", () => $9f8e1ddea3adc68b$export$b60518cba10c4e49);
$parcel$export(module.exports, "ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC", () => $9f8e1ddea3adc68b$export$283d056fd81e831b);
$parcel$export(module.exports, "issueRankTransitionUpdateOptimistic", () => $9f8e1ddea3adc68b$export$6b9877d4e7f0e46e);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $4O0IR = parcelRequire("4O0IR");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $9f8e1ddea3adc68b$export$b80f022994c740bc = 'state.actions.issue.rank-transition.ISSUE_MOVE_TOP_OR_BOTTOM_OF_CONTAINER';
const $9f8e1ddea3adc68b$export$2ff1e3c40336316d = (placement, fireShortcutAnalyticsFn, analyticsEvent)=>({
        type: $9f8e1ddea3adc68b$export$b80f022994c740bc,
        payload: {
            placement: placement,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$938599f8d9ebcd04 = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_REQUEST';
const $9f8e1ddea3adc68b$export$2ad8924ae4613236 = ({ issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, isSourceDone: isSourceDone, isDestinationDone: isDestinationDone, transitionId: transitionId, sourceStatus: sourceStatus, destinationStatus: destinationStatus, isRankable: isRankable, batchId: batchId, mode: mode = 'TRANSITION_AND_RANK', analyticsEvent: analyticsEvent })=>({
        type: $9f8e1ddea3adc68b$export$938599f8d9ebcd04,
        payload: {
            issueIds: issueIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId,
            isSourceDone: isSourceDone,
            isDestinationDone: isDestinationDone,
            transitionId: transitionId,
            sourceStatus: sourceStatus,
            destinationStatus: destinationStatus,
            isRankable: isRankable,
            batchId: batchId,
            mode: mode
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$b3d13442a2ed1704 = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_SUCCESS';
const $9f8e1ddea3adc68b$export$fc64d70c84553912 = ({ optimisticId: optimisticId, issueIds: issueIds, batchId: batchId, analyticsEvent: analyticsEvent, issueKeys: issueKeys, destinationStatus: destinationStatus })=>({
        type: $9f8e1ddea3adc68b$export$b3d13442a2ed1704,
        payload: {
            issueIds: issueIds,
            batchId: batchId
        },
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            ...issueKeys && issueKeys.length === 1 && (0, $4R6GH.fg)('show-success-flag-for-jsw-board-card-transition') && (0, $sdxnu.successFlagMeta)({
                id: 'issueTransitionSuccessful',
                titleMessage: (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatus,
                descriptionMessage: (0, $4O0IR.default).issueTransitionSuccessfulFlagDescription,
                context: {
                    issueKey: issueKeys[0],
                    status: destinationStatus
                }
            }),
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$fae66629a3d8d258 = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_ABORT';
const $9f8e1ddea3adc68b$export$5a1d2ddad6ab4718 = (optimisticId)=>({
        type: $9f8e1ddea3adc68b$export$fae66629a3d8d258,
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId)
        }
    });
const $9f8e1ddea3adc68b$export$d3e0b64e628deb4e = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_FAILURE';
const $9f8e1ddea3adc68b$export$ade8b8e0a05059d7 = (optimisticId, issue, batchId, error, traceId)=>{
    const titleMessage = (()=>{
        // display issueType details only when it is present
        if (issue && issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $7AVqz.default).issueRankFailTitleIssueTerminologyRefreshM4;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).issueRankFailTitleIssueTermRefresh : (0, $7AVqz.default).issueRankFailTitle;
    })();
    const descriptionMessage = (()=>{
        // display issueType details only when it is present
        if (issue && issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $7AVqz.default).issueRankFailDescriptionIssueTerminologyRefreshM4;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).issueRankFailDescriptionIssueTermRefresh : (0, $7AVqz.default).issueRankFailDescription;
    })();
    return {
        type: $9f8e1ddea3adc68b$export$d3e0b64e628deb4e,
        payload: {
            batchId: batchId
        },
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.errorFlagMeta)({
                titleMessage: titleMessage,
                descriptionMessage: descriptionMessage,
                context: {
                    ...error && traceId && (0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? {
                        error: error,
                        traceId: traceId
                    } : {},
                    ...issue && issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false) ? {
                        workType: issue.typeName
                    } : {}
                }
            })
        }
    };
};
const $9f8e1ddea3adc68b$export$e99298839edfb128 = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_FAILURE_FIELD_REQUIRED';
const $9f8e1ddea3adc68b$export$d43c922db5540629 = (optimisticId, issue, errorMessages, error, traceId)=>{
    const titleMessage = (()=>{
        // display issueType details only when it is present
        if (issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $7AVqz.default).issueRankFailFieldRequiredTitleIssueTerminologyRefreshM4;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).issueRankFailFieldRequiredTitleIssueTermRefresh : (0, $7AVqz.default).issueRankFailFieldRequiredTitle;
    })();
    return {
        type: $9f8e1ddea3adc68b$export$e99298839edfb128,
        payload: {
            issueKey: issue.key,
            errorMessages: errorMessages
        },
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.warningFlagMeta)({
                id: $9f8e1ddea3adc68b$export$e99298839edfb128,
                titleMessage: titleMessage,
                descriptionMessage: (0, $7AVqz.default).issueRankFailFieldRequiredDescription,
                context: {
                    issueKey: issue.key,
                    errorMessage: errorMessages.join('\n\n'),
                    ...error && traceId && (0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? {
                        error: error,
                        traceId: traceId
                    } : {},
                    ...issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false) ? {
                        workType: issue.typeName
                    } : {}
                }
            })
        }
    };
};
const $9f8e1ddea3adc68b$export$bf5069f2a3267b16 = 'state.actions.issue.rank-transition.SET_ISSUES_RANK';
const $9f8e1ddea3adc68b$export$fb8df558645d5a07 = ({ issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter })=>({
        type: $9f8e1ddea3adc68b$export$bf5069f2a3267b16,
        payload: {
            issueIds: issueIds,
            rankId: rankId,
            isRankAfter: isRankAfter
        }
    });
const $9f8e1ddea3adc68b$export$ac1d3ac6f7579174 = 'state.actions.issue.rank-transition.BULK_ISSUE_RANK_TRANSITION_REQUEST';
const $9f8e1ddea3adc68b$export$8e38daa216161e13 = ({ issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, isSourceDone: isSourceDone, isDestinationDone: isDestinationDone, transitionId: transitionId, sourceStatus: sourceStatus, destinationStatus: destinationStatus, isRankable: isRankable, analyticsEvent: analyticsEvent })=>({
        type: $9f8e1ddea3adc68b$export$ac1d3ac6f7579174,
        payload: {
            issueIds: issueIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId,
            isSourceDone: isSourceDone,
            isDestinationDone: isDestinationDone,
            transitionId: transitionId,
            sourceStatus: sourceStatus,
            destinationStatus: destinationStatus,
            isRankable: isRankable
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$9f14d1e314ad435a = 'state.actions.issue.rank-transition.BULK_ISSUE_RANK_OPTIMISTIC';
const $9f8e1ddea3adc68b$export$56be38daffc22c8e = (payload)=>({
        type: $9f8e1ddea3adc68b$export$9f14d1e314ad435a,
        payload: payload,
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)()
        }
    });
const $9f8e1ddea3adc68b$export$99245ad6da62415e = 'state.actions.issue.rank-transition.BULK_ISSUE_RANK_SUCCESS';
const $9f8e1ddea3adc68b$export$6c201115eb201f20 = ({ payload: payload, optimisticId: optimisticId, analyticsEvent: analyticsEvent })=>({
        type: $9f8e1ddea3adc68b$export$99245ad6da62415e,
        payload: payload,
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$c0ad1cdc93728592 = 'state.actions.issue.rank-transition.BULK_ISSUE_RANK_FAILURE';
const $9f8e1ddea3adc68b$export$b60518cba10c4e49 = ({ payload: payload, optimisticId: optimisticId, errorMessages: errorMessages, analyticsEvent: analyticsEvent, error: error, traceId: traceId })=>({
        type: $9f8e1ddea3adc68b$export$c0ad1cdc93728592,
        payload: payload,
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.errorFlagMeta)({
                id: $9f8e1ddea3adc68b$export$c0ad1cdc93728592,
                titleMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).bulkIssueRankFailTitleIssueTermRefresh : (0, $7AVqz.default).bulkIssueRankFailTitle,
                descriptionMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).issueRankFailDescriptionIssueTermRefresh : (0, $7AVqz.default).issueRankFailDescription,
                errorMessages: errorMessages,
                context: {
                    issueKey: payload.issueKeys.join(', '),
                    errorMessage: errorMessages.join('\n\n'),
                    ...error && traceId && (0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? {
                        error: error,
                        traceId: traceId
                    } : {}
                }
            }),
            analyticsEvent: analyticsEvent
        }
    });
const $9f8e1ddea3adc68b$export$283d056fd81e831b = 'state.actions.issue.rank-transition.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC';
const $9f8e1ddea3adc68b$export$6b9877d4e7f0e46e = ({ analyticsEvent: analyticsEvent, ...payload })=>({
        type: $9f8e1ddea3adc68b$export$283d056fd81e831b,
        payload: payload,
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });

});
parcelRegister("4O0IR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d201576bd998790a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d201576bd998790a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTransitionSuccessful: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful",
        "defaultMessage": "Issue has been updated."
    },
    issueTransitionSuccessfulWithIssueKeyAndStatus: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionSuccessfulFlagDescription: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-flag-description",
        "defaultMessage": "Kudos for keeping things up-to-date!"
    },
    issueTransitionFailure: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure",
        "defaultMessage": "Issue could not be updated."
    },
    issueTransitionFailureWithKey: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key",
        "defaultMessage": "We couldn't update {issueKey}."
    },
    viewIssue: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue",
        "defaultMessage": "View issue"
    },
    issueTransitionSuccessfulIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-issue-term-refresh",
        "defaultMessage": "Work item has been updated."
    },
    issueTransitionFailureIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-issue-term-refresh",
        "defaultMessage": "Work item could not be updated."
    },
    viewIssueIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.view-issue-issue-term-refresh",
        "defaultMessage": "View"
    },
    issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-successful-with-issue-key-and-status-issue-term-refresh",
        "defaultMessage": "{issueKey} moved to {status}."
    },
    issueTransitionFailureWithKeyIssueTermRefresh: {
        "id": "issue-transition-use-show-flag.use-show-flag.issue-transition-failure-with-key-issue-term-refresh",
        "defaultMessage": "We couldn't update {issueKey}."
    }
});

});


parcelRegister("lIysR", function(module, exports) {

$parcel$export(module.exports, "activeTransitionNameSelector", () => $8871cd8632f54a14$export$e88249bdda95e0a2);
$parcel$export(module.exports, "isActiveTransitionGlobalSelector", () => $8871cd8632f54a14$export$f2578d43a9cf8c67);
$parcel$export(module.exports, "activeTransitionDestinationStatusSelector", () => $8871cd8632f54a14$export$85da65aa4d428a9a);
$parcel$export(module.exports, "cardTransitionDestinationStatusSelector", () => $8871cd8632f54a14$export$e07fcec45e31ecae);
$parcel$export(module.exports, "cardTransitionSourceStatusSelector", () => $8871cd8632f54a14$export$c0177cb7a0156468);
$parcel$export(module.exports, "draggingIssueTransitionsForColumnSelector", () => $8871cd8632f54a14$export$6493de80e7420969);
$parcel$export(module.exports, "makeGetShowAllTransitionZones", () => $8871cd8632f54a14$export$96d2b9c7793d0852);
$parcel$export(module.exports, "shouldDisableDropOnColumn", () => $8871cd8632f54a14$export$98f9342952b17976);
$parcel$export(module.exports, "hasDifferentIssueTypeTransitionsInColumns", () => $8871cd8632f54a14$export$ea5b40548774f675);
$parcel$export(module.exports, "getTransitionsByColumnAndIssueType", () => $8871cd8632f54a14$export$162369d1646e3e2d);
$parcel$export(module.exports, "transitionsByColumnIdSelector", () => $8871cd8632f54a14$export$291fa08de619b517);
$parcel$export(module.exports, "cardTransitionsColumnsSelector", () => $8871cd8632f54a14$export$dcadd9ed0184a1ec);

var $dGvGJ = parcelRequire("dGvGJ");

var $k8IPx = parcelRequire("k8IPx");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $gULOk = parcelRequire("gULOk");

var $2YZCu = parcelRequire("2YZCu");

var $iuuJH = parcelRequire("iuuJH");

var $9OPlz = parcelRequire("9OPlz");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $fyeGd = parcelRequire("fyeGd");
const $8871cd8632f54a14$export$8473f1f08dc4b3e9 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.getCardDragState)
], (dragState)=>dragState.cardId != null && dragState.overTransition != null ? dragState.overTransition : undefined);
const $8871cd8632f54a14$export$e88249bdda95e0a2 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardIssueTypeId),
    $8871cd8632f54a14$export$8473f1f08dc4b3e9,
    (0, $67Z81.getCardTransitions)
], (issueTypeId, activeTransition, cardTransitions)=>activeTransition && cardTransitions.columnIssueTypeTransitions[String(activeTransition.toColumnId)][String(issueTypeId)].filter((transition)=>transition.id === activeTransition.transitionId)[0].name);
const $8871cd8632f54a14$export$f2578d43a9cf8c67 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardIssueTypeId),
    $8871cd8632f54a14$export$8473f1f08dc4b3e9,
    (0, $67Z81.getCardTransitions)
], (issueTypeId, activeTransition, cardTransitions)=>activeTransition && cardTransitions.columnIssueTypeTransitions[String(activeTransition.toColumnId)][String(issueTypeId)].filter((transition)=>transition.id === activeTransition.transitionId)[0].isGlobal || false);
const $8871cd8632f54a14$export$85da65aa4d428a9a = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardIssueTypeId),
    $8871cd8632f54a14$export$8473f1f08dc4b3e9,
    (0, $67Z81.getCardTransitions)
], (issueTypeId, activeTransition, cardTransitions)=>{
    const destinationStatusId = activeTransition && cardTransitions.columnIssueTypeTransitions[String(activeTransition.toColumnId)][String(issueTypeId)].filter((transition)=>transition.id === activeTransition.transitionId)[0].destinationStatusId;
    return destinationStatusId != null ? cardTransitions.issueTypeStatus[String(issueTypeId)][String(destinationStatusId)] : undefined;
});
const $8871cd8632f54a14$export$e07fcec45e31ecae = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $9OPlz.getSelectedTransition),
    (0, $67Z81.getCardTransitions)
], (boardIssues, selectedTransition, cardTransitions)=>(issueId, destinationColumnId)=>{
        const issueTypeId = boardIssues[String(issueId)]?.typeId;
        if (!issueTypeId) return undefined;
        const destinationTransitions = cardTransitions.columnIssueTypeTransitions[destinationColumnId]?.[String(issueTypeId)];
        if (!destinationTransitions?.length) return undefined;
        const destinationTransition = selectedTransition ? destinationTransitions.find(({ id: id })=>id === selectedTransition.transitionId) : destinationTransitions[0];
        return destinationTransition ? cardTransitions.issueTypeStatus[String(issueTypeId)][destinationTransition.destinationStatusId] : undefined;
    });
const $8871cd8632f54a14$export$c0177cb7a0156468 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $67Z81.getCardTransitions)
], (boardIssues, cardTransitions)=>(issueId)=>{
        const issue = boardIssues[String(issueId)];
        if (!issue) return undefined;
        const { statusId: statusId, typeId: typeId } = issue;
        return cardTransitions.issueTypeStatus[typeId]?.[statusId];
    });
const $8871cd8632f54a14$var$emptyArray = [];
const $8871cd8632f54a14$var$getColumnTransitions = (cardTransitions, issueTypeId, issueStatusId, destinationColumnId, draggingCard, issueProjects)=>{
    // Per column transitions, with filtering by project key and
    // source/destination statuses.
    const columnTransitions = cardTransitions.columnIssueTypeTransitions?.[String(destinationColumnId)]?.[String(issueTypeId)];
    const projectKey = draggingCard ? Object.values(issueProjects).find((project)=>project.id === draggingCard.projectId)?.key : null;
    if (columnTransitions && Array.isArray(columnTransitions)) {
        const statuses = cardTransitions.issueTypeStatus[String(issueTypeId)];
        return {
            transitions: columnTransitions.filter((transition)=>!transition.isInitial && (transition.sourceStatusId === issueStatusId || transition.isGlobal)).filter((transition)=>projectKey == null || transition.projectKey === projectKey).filter((transition)=>statuses[String(transition.destinationStatusId)]).map((transition)=>{
                const toStatus = statuses[String(transition.destinationStatusId)];
                return {
                    transitionId: transition.id,
                    transitionName: transition.name,
                    targetStatusName: toStatus.name,
                    targetStatusId: transition.destinationStatusId,
                    targetStatusCategory: toStatus.category || (0, $gULOk.IN_PROGRESS),
                    isGlobal: transition.isGlobal,
                    isAvailable: true
                };
            })
        };
    }
    return {
        transitions: $8871cd8632f54a14$var$emptyArray
    };
};
const $8871cd8632f54a14$var$getDraggingCard = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.getDraggingCardId),
    (0, $d2i8f.getIssueOrIssueChildById)
], (draggingCardId, getIssueFn)=>getIssueFn(draggingCardId));
const $8871cd8632f54a14$export$6493de80e7420969 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardIssueTypeId),
    (0, $9OPlz.draggingCardIssueStatusId),
    (0, $67Z81.getCardTransitions),
    (0, $67Z81.getIssueTransitions),
    $8871cd8632f54a14$var$getDraggingCard,
    (0, $67Z81.getIssueProjects)
], (issueTypeId, issueStatusId, cardTransitions, issueTransitionsById, draggingCard, issueProjects)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((destinationColumnId)=>{
        // Early termination if this is called incorrectly.
        if (!draggingCard) return {
            transitions: $8871cd8632f54a14$var$emptyArray
        };
        // Check if there are transitions specifically for this issue
        const issueTransitions = issueTransitionsById?.[String(draggingCard.id)];
        // If there are transitions specifically for this card, we need to handle them
        if (issueTransitions && issueTransitions.status !== 'failure') {
            if (issueTransitions.status === 'success') {
                // Per issue available transitions, this is fetched from the
                // back-end, so doesn't require project filters.
                const selfTransitions = issueTransitions.data[String(destinationColumnId)] || [];
                const statuses = cardTransitions.issueTypeStatus[String(issueTypeId)];
                return {
                    transitions: selfTransitions.filter((transition)=>transition && !transition.isInitial).filter((transition)=>statuses[String(transition.destinationStatusId)]).filter((transition)=>transition.isAvailable).map((transition)=>{
                        const toStatus = statuses[String(transition.destinationStatusId)];
                        return {
                            transitionId: transition.id,
                            transitionName: transition.name,
                            targetStatusName: toStatus.name,
                            targetStatusId: transition.destinationStatusId,
                            targetStatusCategory: toStatus.category || (0, $gULOk.IN_PROGRESS),
                            isGlobal: transition.isGlobal,
                            isAvailable: transition.isAvailable
                        };
                    })
                };
            }
            return {
                transitions: $8871cd8632f54a14$var$emptyArray,
                isLoading: true
            };
        }
        return $8871cd8632f54a14$var$getColumnTransitions(cardTransitions, issueTypeId, issueStatusId, destinationColumnId, draggingCard, issueProjects);
    }));
const $8871cd8632f54a14$export$96d2b9c7793d0852 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $9OPlz.draggingCardSourceSwimlaneIdSelector),
    (0, $45cXl.getSwimlaneMode),
    (0, $5mTgl.isDraggingSubtaskSelector),
    (0, $67Z81.isBoardRankable)
], (isCMPBoard, draggingSwimlaneId, swimlaneMode, isDraggingSubtask, isOrderByRank)=>(swimlaneId)=>{
        const hasSwimlanes = swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id;
        const isDraggingAcrossSwimlanes = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) && draggingSwimlaneId !== swimlaneId;
        return isCMPBoard && (isDraggingSubtask || isOrderByRank) && hasSwimlanes && isDraggingAcrossSwimlanes;
    });
const $8871cd8632f54a14$export$98f9342952b17976 = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.draggingCardSourceColumnIdSelector),
    (0, $9OPlz.draggingCardTargetColumnIdSelector)
], (sourceColumnId, targetColumnId)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId)=>{
        // Drags within same column always ok
        if (sourceColumnId === columnId) return false;
        // If last hovered over column is not this one, disable.
        return targetColumnId !== columnId;
    }));
const $8871cd8632f54a14$var$getNonEmptyIssueTypeIds = (issueTypeTransitions)=>Object.keys(issueTypeTransitions).filter((issueTypeId)=>{
        const transitions = issueTypeTransitions[issueTypeId];
        return transitions.length > 0;
    });
const $8871cd8632f54a14$export$ea5b40548774f675 = (0, $dGvGJ.createSelector)((0, $67Z81.getCardTransitions), ({ columnIssueTypeTransitions: columnIssueTypeTransitions })=>{
    const columnIds = Object.keys(columnIssueTypeTransitions);
    if (columnIds.length === 0) return false;
    const firstColumnId = columnIds[0];
    const firstColumnIssueTypes = columnIssueTypeTransitions[firstColumnId];
    let previousIssueTypeIds = $8871cd8632f54a14$var$getNonEmptyIssueTypeIds(firstColumnIssueTypes);
    for(let i = 1; i < columnIds.length; i += 1){
        const columnId = columnIds[i];
        const columnIssueTypes = columnIssueTypeTransitions[columnId];
        const columnIssueTypeIds = $8871cd8632f54a14$var$getNonEmptyIssueTypeIds(columnIssueTypes);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(previousIssueTypeIds, columnIssueTypeIds).length > 0 || (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(columnIssueTypeIds, previousIssueTypeIds).length > 0) return true;
        previousIssueTypeIds = columnIssueTypeIds;
    }
    return false;
});
const $8871cd8632f54a14$export$162369d1646e3e2d = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    (0, $67Z81.getIssueProjects),
    (_, props)=>props
], (cardTransitions, issueProjects, { columnId: columnId, issueTypeId: issueTypeId, projectId: projectId })=>{
    try {
        const projectKey = Object.values(issueProjects).find((project)=>project.id === projectId)?.key;
        return cardTransitions.columnIssueTypeTransitions[String(columnId)][String(issueTypeId)].filter((transition)=>!transition.isInitial && (!projectKey || transition.projectKey === projectKey));
    } catch (_err) {
        (0, $2YZCu.default).unsafeErrorWithCustomerData('jsw.board-selectors.getTransitionsByColumnAndIssueType', 'Error retrieving issue transitions by column and issue type', {
            cardTransitions: JSON.stringify(cardTransitions),
            issueProjects: JSON.stringify(issueProjects),
            columnId: columnId,
            issueTypeId: issueTypeId
        });
        return [];
    }
});
const $8871cd8632f54a14$export$d276c2740c89d6e = (state)=>(columnId)=>(issueTypeId)=>!!(0, $67Z81.getCardTransitions)(state).columnIssueTypeTransitions[String(columnId)][String(issueTypeId)].find(({ isInitial: isInitial })=>isInitial);
const $8871cd8632f54a14$export$291fa08de619b517 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    (0, $67Z81.getIssueProjects)
], (cardTransition, issueProjects)=>(columnId, issue)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.typeId)) return null;
        const projectKey = issue ? Object.values(issueProjects).find((project)=>project.id === issue.projectId)?.key : null;
        // Filter by project key since we can get a single transition returned once for each
        // project associated with a board and we do not want to return duplicates
        // which will affect the issue parent assign modal
        const transitionsByIssueType = cardTransition.columnIssueTypeTransitions[columnId]?.[issue.typeId]?.filter((transition)=>transition.projectKey === projectKey);
        // only show transitions relevant to the parent issue moving from it's current
        // column/backlog to the specified end column
        const validTransitionsForParentIssue = transitionsByIssueType ? transitionsByIssueType.filter((transition)=>transition.sourceStatusId === issue.statusId || transition.isGlobal) : null;
        return validTransitionsForParentIssue ?? null;
    });
const $8871cd8632f54a14$export$dcadd9ed0184a1ec = (0, $dGvGJ.createSelector)([
    (_state, issue)=>issue,
    (0, $67Z81.getCardTransitions),
    (0, $fyeGd.orderedColumnsSelector),
    (0, $67Z81.getIssueProjects)
], (issue, cardTransitions, columns, issueProjects)=>{
    const { typeId: typeId, statusId: statusId } = issue;
    const allTransitions = Object.values(columns).flatMap((column)=>{
        const { transitions: transitions } = $8871cd8632f54a14$var$getColumnTransitions(cardTransitions, typeId, statusId, column.id, issue, issueProjects);
        return transitions.map((transition)=>({
                ...transition,
                destinationColumnId: column.id
            }));
    });
    const transitionsByStatusName = allTransitions.reduce((map, transition)=>{
        if (transition.targetStatusId !== statusId && !map.has(transition.targetStatusName)) map.set(transition.targetStatusName, transition);
        return map;
    }, new Map());
    return {
        transitionsByStatusName: transitionsByStatusName
    };
});

});
parcelRegister("gULOk", function(module, exports) {

$parcel$export(module.exports, "UNDEFINED", () => $e77315bf13f8b83b$export$6db089fe7b26f5b6);
$parcel$export(module.exports, "TODO", () => $e77315bf13f8b83b$export$aa456a5030160740);
$parcel$export(module.exports, "IN_PROGRESS", () => $e77315bf13f8b83b$export$5a9ac66c2785cc13);
$parcel$export(module.exports, "DONE", () => $e77315bf13f8b83b$export$71efb3495f6084f2);
$parcel$export(module.exports, "STATUS_CATEGORIES", () => $e77315bf13f8b83b$export$d9119300f9d9a815);
$parcel$export(module.exports, "StatusCategoryTypes", () => $e77315bf13f8b83b$export$5d42a08d46cffe7);
$parcel$export(module.exports, "StatusCategoryIds", () => $e77315bf13f8b83b$export$3f42f49c284d5b58);
$parcel$export(module.exports, "statusCategoryKeys", () => $e77315bf13f8b83b$export$f3f919dc0f56d9eb);
$parcel$export(module.exports, "statusCategoryForId", () => $e77315bf13f8b83b$export$3e9e3002956ff4fb);
$parcel$export(module.exports, "categoryIdForStatusCategory", () => $e77315bf13f8b83b$export$7b16b0022aac2d46);
$parcel$export(module.exports, "isValidStatusCategoryKey", () => $e77315bf13f8b83b$export$d928f247c903643a);
const $e77315bf13f8b83b$export$6db089fe7b26f5b6 = 'UNDEFINED';
const $e77315bf13f8b83b$export$aa456a5030160740 = 'TODO';
const $e77315bf13f8b83b$export$5a9ac66c2785cc13 = 'IN_PROGRESS';
const $e77315bf13f8b83b$export$71efb3495f6084f2 = 'DONE';
const $e77315bf13f8b83b$export$d9119300f9d9a815 = [
    $e77315bf13f8b83b$export$6db089fe7b26f5b6,
    $e77315bf13f8b83b$export$aa456a5030160740,
    $e77315bf13f8b83b$export$5a9ac66c2785cc13,
    $e77315bf13f8b83b$export$71efb3495f6084f2
];
const $e77315bf13f8b83b$var$statusCategories = [
    {
        id: '1',
        statusCategory: $e77315bf13f8b83b$export$6db089fe7b26f5b6
    },
    {
        id: '2',
        statusCategory: $e77315bf13f8b83b$export$aa456a5030160740
    },
    {
        id: '4',
        statusCategory: $e77315bf13f8b83b$export$5a9ac66c2785cc13
    },
    {
        id: '3',
        statusCategory: $e77315bf13f8b83b$export$71efb3495f6084f2
    }
];
const $e77315bf13f8b83b$export$5d42a08d46cffe7 = Object.freeze({
    NEW: 'new',
    INDETERMINATE: 'indeterminate',
    DONE: 'done',
    UNDEFINED: 'undefined'
});
const $e77315bf13f8b83b$export$3f42f49c284d5b58 = Object.freeze({
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.UNDEFINED]: 1,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.NEW]: 2,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.DONE]: 3,
    [$e77315bf13f8b83b$export$5d42a08d46cffe7.INDETERMINATE]: 4
});
const $e77315bf13f8b83b$export$f3f919dc0f56d9eb = Object.values($e77315bf13f8b83b$export$5d42a08d46cffe7);
const $e77315bf13f8b83b$export$3e9e3002956ff4fb = (statusCategoryId)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.id === String(statusCategoryId));
    return value ? value.statusCategory : $e77315bf13f8b83b$export$6db089fe7b26f5b6;
};
const $e77315bf13f8b83b$export$7b16b0022aac2d46 = (statusCategory)=>{
    const value = $e77315bf13f8b83b$var$statusCategories.find((sc)=>sc.statusCategory === statusCategory);
    return Number(value ? value.id : '1');
};
const $e77315bf13f8b83b$export$d928f247c903643a = (key)=>$e77315bf13f8b83b$export$f3f919dc0f56d9eb.some((statusCategoryKey)=>statusCategoryKey === key);

});


parcelRegister("cN1y7", function(module, exports) {

$parcel$export(module.exports, "shouldFireFailureSLOMetric", () => $615d454a49fa4a48$export$fe8a8e492606443e);
$parcel$export(module.exports, "getStatusCodeGroup", () => $615d454a49fa4a48$export$d14e9b22afc87cb3);

var $8J83Y = parcelRequire("8J83Y");

var $fZneA = parcelRequire("fZneA");
const $615d454a49fa4a48$export$9e972e23fe5eb411 = 'Either transition or rank operation has failed';
const $615d454a49fa4a48$var$isHttpSuccessfulButFailedToMoveCard = (error)=>error.statusCode === 200 && error.message === $615d454a49fa4a48$export$9e972e23fe5eb411;
const $615d454a49fa4a48$export$fe8a8e492606443e = (error)=>!(0, $fZneA.isHttpClientErrorResponse)(error) && !(0, $fZneA.isClientFetchError)(error) && !$615d454a49fa4a48$var$isHttpSuccessfulButFailedToMoveCard(error) && !(0, $fZneA.isHttpTooManyRequestsResponse)(error);
const $615d454a49fa4a48$export$d14e9b22afc87cb3 = (error)=>error.statusCode === 429 ? '429' : (0, $8J83Y.getHttpStatusCodeGroup)(error.statusCode);

});
parcelRegister("8J83Y", function(module, exports) {

$parcel$export(module.exports, "getHttpStatusCodeGroup", () => $48bc5fed831643fb$export$50638b58bcff17eb);
const $48bc5fed831643fb$export$e984131957e55a57 = '1xx';
const $48bc5fed831643fb$export$c82f97ba058d81c6 = '2xx';
const $48bc5fed831643fb$export$a619f875c67bad8a = '3xx';
const $48bc5fed831643fb$export$54c00699f1d3b78f = '4xx';
const $48bc5fed831643fb$export$e3bc6416e310d1b3 = '5xx';
const $48bc5fed831643fb$var$HTTP_UNKNOWN_CODE_GROUP = 'unknown';
const $48bc5fed831643fb$export$50638b58bcff17eb = (statusCode)=>{
    if (statusCode === null || statusCode === undefined) return $48bc5fed831643fb$var$HTTP_UNKNOWN_CODE_GROUP;
    if (statusCode >= 100 && statusCode < 200) return $48bc5fed831643fb$export$e984131957e55a57;
    if (statusCode >= 200 && statusCode < 300) return $48bc5fed831643fb$export$c82f97ba058d81c6;
    if (statusCode >= 300 && statusCode < 400) return $48bc5fed831643fb$export$a619f875c67bad8a;
    if (statusCode >= 400 && statusCode < 500) return $48bc5fed831643fb$export$54c00699f1d3b78f;
    if (statusCode >= 500 && statusCode < 600) return $48bc5fed831643fb$export$e3bc6416e310d1b3;
    return $48bc5fed831643fb$var$HTTP_UNKNOWN_CODE_GROUP;
};

});



parcelRegister("kuD1K", function(module, exports) {

$parcel$export(module.exports, "getCanUserInviteEpic", () => $68fe4291b413d80f$export$89828008460b535c);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $3MnpT = parcelRequire("3MnpT");

var $f3MfI = parcelRequire("f3MfI");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
const $68fe4291b413d80f$export$89828008460b535c = (action$, store)=>action$.ofType((0, $cW3pH.WORK_DATA_SET)).switchMap(()=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        if (isCMPBoard) return (0, $kVLXA.Observable).of();
        const projectId = (0, $67Z81.projectIdSelector)(state);
        return (0, $3MnpT.fetchCanUserInviteService)(projectId).mergeMap((canUserInviteResponse)=>(0, $kVLXA.Observable).of((0, $f3MfI.setCanUserInvite)(canUserInviteResponse))).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'board.can-user-invite.load.failure',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'a4t-tanuki'
                }
            });
            return (0, $kVLXA.Observable).of();
        });
    });

});
parcelRegister("3MnpT", function(module, exports) {

$parcel$export(module.exports, "fetchCanUserInviteService", () => $f91f06591f16391c$export$583ef539d905855);

var $kQMHY = parcelRequire("kQMHY");
const $f91f06591f16391c$export$583ef539d905855 = (projectId)=>(0, $kQMHY.getUserInviteCapability)(projectId);

});
parcelRegister("kQMHY", function(module, exports) {

$parcel$export(module.exports, "getUserInviteCapability", () => $ba35bcaf191891e1$export$22c733f1adfb0925);
parcelRequire("3q49N");

var $487fd = parcelRequire("487fd");
const $ba35bcaf191891e1$var$getCanInviteOthersUrl = (projectId)=>`/rest/internal/latest/invite-user/project/${projectId}/can-invite-others?operation=CanInviteOthers`;
const $ba35bcaf191891e1$export$22c733f1adfb0925 = (projectId)=>(0, $487fd.default)($ba35bcaf191891e1$var$getCanInviteOthersUrl(projectId), {
        method: 'GET'
    });

});


parcelRegister("f3MfI", function(module, exports) {

$parcel$export(module.exports, "SET_CAN_USER_INVITE", () => $9704966df89e8459$export$c09a6e8888fd28fa);
$parcel$export(module.exports, "setCanUserInvite", () => $9704966df89e8459$export$c07b821618e68774);
const $9704966df89e8459$export$c09a6e8888fd28fa = 'state.actions.can-user-invite.SET_CAN_USER_INVITE';
const $9704966df89e8459$export$c07b821618e68774 = (payload)=>({
        type: $9704966df89e8459$export$c09a6e8888fd28fa,
        payload: payload
    });

});


parcelRegister("9s50S", function(module, exports) {

$parcel$export(module.exports, "getCardCoversEpic", () => $701a8311895abbe5$export$7faa2dc8787edae1);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("3awJm");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $l5UTI = parcelRequire("l5UTI");

var $4vr5z = parcelRequire("4vr5z");

var $3n582 = parcelRequire("3n582");

var $2f454 = parcelRequire("2f454");

var $vAfHD = parcelRequire("vAfHD");
const $701a8311895abbe5$export$7faa2dc8787edae1 = (action$, store)=>action$.ofType((0, $3n582.FETCH_CARD_COVERS)).throttleTime(1000).switchMap((action)=>{
        const state = store.getState();
        // if there are no issue IDs in the payload, fetch card covers for all of the issue IDs on the board
        const issueIds = action.payload.length > 0 ? action.payload : (0, $vAfHD.boardOrderedIssueIdsSelector)(state);
        const analyticsEvent = action.meta?.analyticsEvent;
        if (issueIds.length === 0) return (0, $kVLXA.Observable).of();
        return (0, $4vr5z.fetchCardCoversService)(issueIds).mergeMap((response)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cardCovers fetchSucceeded', {
                task: 'cardCoversFetch'
            });
            return (0, $kVLXA.Observable).of((0, $2f454.cardMediaDataSet)((0, $l5UTI.transformCardCoversRestApiResponse)(response, issueIds)));
        }).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                event: analyticsEvent,
                error: error,
                meta: {
                    id: 'board.cardCovers.fetch.failure',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'A4T-Pandora'
                }
            });
            return (0, $kVLXA.Observable).of((0, $3n582.fetchCardCoversFailure)());
        });
    });

});
parcelRegister("l5UTI", function(module, exports) {

$parcel$export(module.exports, "transformMediaDataForSingleIssue", () => $91ddad88d6dd232b$export$20baab53b2c16681);
$parcel$export(module.exports, "transformCardCoversRestApiResponse", () => $91ddad88d6dd232b$export$26f54dfacebc2306);
const $91ddad88d6dd232b$export$20baab53b2c16681 = (cardMedia, media)=>({
        attachmentId: String(cardMedia.attachmentId),
        attachmentMediaApiId: cardMedia.mediaApiFileId,
        endpointUrl: media.endpointUrl,
        clientId: media.clientId,
        isHiddenByUser: false,
        token: cardMedia.mediaReadToken
    });
const $91ddad88d6dd232b$export$26f54dfacebc2306 = (cardCoversResponse, issueIdsFromRequest)=>issueIdsFromRequest.reduce((map, issueId)=>Object.assign(map, {
            [String(issueId)]: issueId in cardCoversResponse.cardMedia ? $91ddad88d6dd232b$export$20baab53b2c16681(cardCoversResponse.cardMedia[Number(issueId)], cardCoversResponse.media) : null
        }), {});

});

parcelRegister("4vr5z", function(module, exports) {

$parcel$export(module.exports, "fetchCardCoversService", () => $4ad057fc806b9136$export$9715adb13e235e9d);

var $4UCYm = parcelRequire("4UCYm");
const $4ad057fc806b9136$export$9715adb13e235e9d = (issueIds)=>(0, $4UCYm.getCardCovers)(issueIds);

});
parcelRegister("4UCYm", function(module, exports) {

$parcel$export(module.exports, "getCardCovers", () => $bdd4e9fc98827e9d$export$8fd4f4f9aa54b892);
parcelRequire("3q49N");

var $487fd = parcelRequire("487fd");
// A lightweight endpoint for retrieving only card cover data for a given set of issueIds
const $bdd4e9fc98827e9d$var$CARD_COVERS_API_URL = '/rest/greenhopper/1.0/cardCovers?operation=CardCovers';
const $bdd4e9fc98827e9d$export$8fd4f4f9aa54b892 = (issueIds)=>(0, $487fd.default)($bdd4e9fc98827e9d$var$CARD_COVERS_API_URL, {
        method: 'POST',
        body: JSON.stringify(issueIds),
        perf: {
            prefix: 'jsw.board',
            key: 'cardCovers.fetch'
        }
    });

});


parcelRegister("2f454", function(module, exports) {

$parcel$export(module.exports, "CARD_DATA_SET", () => $a8783f929f39d4cc$export$273ea1cef989293);
$parcel$export(module.exports, "cardDataSet", () => $a8783f929f39d4cc$export$c24b8bc48062c07d);
$parcel$export(module.exports, "CARD_MEDIA_DATA_SET", () => $a8783f929f39d4cc$export$7c85c65079439bf2);
$parcel$export(module.exports, "cardMediaDataSet", () => $a8783f929f39d4cc$export$1292f97e47f8c4f4);
$parcel$export(module.exports, "CARD_REFRESH_REQUEST", () => $a8783f929f39d4cc$export$a5cacf6c12c6c43b);
$parcel$export(module.exports, "cardRefreshRequestWith", () => $a8783f929f39d4cc$export$de0715285e6d5218);
$parcel$export(module.exports, "CARD_CLICK", () => $a8783f929f39d4cc$export$1f7bc7dd5a83e5d6);
$parcel$export(module.exports, "cardClick", () => $a8783f929f39d4cc$export$e7d364bce6e7eb03);
$parcel$export(module.exports, "CARD_TOGGLE_SELECTION", () => $a8783f929f39d4cc$export$5f8bf17701529b20);
$parcel$export(module.exports, "CARD_MULTI_SELECT", () => $a8783f929f39d4cc$export$674d868bde506f3c);
$parcel$export(module.exports, "cardMultiSelect", () => $a8783f929f39d4cc$export$43cca0fb4ffd3a83);
$parcel$export(module.exports, "cardToggleSelection", () => $a8783f929f39d4cc$export$bf1970aeeba42166);
$parcel$export(module.exports, "CARD_SINGLE_SELECT", () => $a8783f929f39d4cc$export$c68d63d54996a817);
$parcel$export(module.exports, "cardSingleSelect", () => $a8783f929f39d4cc$export$9df5a921382fd88e);
$parcel$export(module.exports, "CARD_CANCEL_SELECTION", () => $a8783f929f39d4cc$export$98df3a708f34d816);
$parcel$export(module.exports, "cardCancelSelection", () => $a8783f929f39d4cc$export$a9618aba37578c3a);
$parcel$export(module.exports, "CARD_CLEAR", () => $a8783f929f39d4cc$export$bc9a106375114441);
$parcel$export(module.exports, "cardClear", () => $a8783f929f39d4cc$export$bdf5dd34d7025486);
$parcel$export(module.exports, "cardClearSuccess", () => $a8783f929f39d4cc$export$c6b9b0adb28bc068);
$parcel$export(module.exports, "cardClearFailure", () => $a8783f929f39d4cc$export$4da3d14df563def7);
$parcel$export(module.exports, "cardClearRevert", () => $a8783f929f39d4cc$export$abd1d00c8fd946b8);
$parcel$export(module.exports, "CARD_CLEAR_UNDO", () => $a8783f929f39d4cc$export$9c64600376e3d373);
$parcel$export(module.exports, "cardClearUndo", () => $a8783f929f39d4cc$export$73bb242cdcb8f96);
$parcel$export(module.exports, "CARD_DELETE", () => $a8783f929f39d4cc$export$b82590935cfab60f);
$parcel$export(module.exports, "cardDelete", () => $a8783f929f39d4cc$export$ba9d764de574147c);
$parcel$export(module.exports, "CARD_DELETE_OPTIMISTIC", () => $a8783f929f39d4cc$export$60d48bfd6db6297f);
$parcel$export(module.exports, "cardDeleteOptimistic", () => $a8783f929f39d4cc$export$8c23f90a573b475d);
$parcel$export(module.exports, "CARD_DRAG_OVER_TRANSITION", () => $a8783f929f39d4cc$export$c9359f309b5f4898);
$parcel$export(module.exports, "cardDragOverTransition", () => $a8783f929f39d4cc$export$5a37155dbb24c55d);
$parcel$export(module.exports, "CARD_DRAG_OVER_TRANSITION_REQUEST", () => $a8783f929f39d4cc$export$639e98b190c1f7b7);
$parcel$export(module.exports, "cardDragOverTransitionRequest", () => $a8783f929f39d4cc$export$371faa1fb1a6bca3);
$parcel$export(module.exports, "CARD_DRAG_SELECTED_TRANSITION", () => $a8783f929f39d4cc$export$ec18418d1159cde3);
$parcel$export(module.exports, "cardDragSelectedTransition", () => $a8783f929f39d4cc$export$ee55e5ac05a9811a);
$parcel$export(module.exports, "CARD_GET_ISSUE_TRANSITIONS", () => $a8783f929f39d4cc$export$7e4b8027ee23adc0);
$parcel$export(module.exports, "cardGetIssueTransitions", () => $a8783f929f39d4cc$export$611a578ff56e22fb);
$parcel$export(module.exports, "CARD_GET_ISSUE_TRANSITIONS_FAILURE", () => $a8783f929f39d4cc$export$6ea7c16576dd08bc);
$parcel$export(module.exports, "cardGetIssueTransitionsFailure", () => $a8783f929f39d4cc$export$8df71fbcf20d401f);
$parcel$export(module.exports, "CARD_SET_ISSUE_TRANSITIONS", () => $a8783f929f39d4cc$export$713b5a2539e4ed6f);
$parcel$export(module.exports, "cardSetIssueTransitions", () => $a8783f929f39d4cc$export$31d2270f6fdce884);
$parcel$export(module.exports, "CARD_FOCUS", () => $a8783f929f39d4cc$export$7de76f693f0d3820);
$parcel$export(module.exports, "cardFocus", () => $a8783f929f39d4cc$export$e462552ef1675527);
$parcel$export(module.exports, "CARD_BLUR", () => $a8783f929f39d4cc$export$6ac448f92e1f338b);
$parcel$export(module.exports, "cardBlur", () => $a8783f929f39d4cc$export$9dea9abf478df7d7);
$parcel$export(module.exports, "CARD_ADD_SHOW_RIPPLE", () => $a8783f929f39d4cc$export$34a15cd7bcc20e7c);
$parcel$export(module.exports, "cardAddShowRipple", () => $a8783f929f39d4cc$export$d5db5f1fced5f46b);
$parcel$export(module.exports, "CARD_REMOVE_SHOW_RIPPLE", () => $a8783f929f39d4cc$export$daf49e5bace84185);
$parcel$export(module.exports, "cardRemoveShowRipple", () => $a8783f929f39d4cc$export$fa511ac22ea1432e);
$parcel$export(module.exports, "CARD_NEXT", () => $a8783f929f39d4cc$export$e780294f9cb0bbfd);
$parcel$export(module.exports, "cardNext", () => $a8783f929f39d4cc$export$d848405832f5c1d5);
$parcel$export(module.exports, "CARD_PREV", () => $a8783f929f39d4cc$export$22f722071ae1a37d);
$parcel$export(module.exports, "cardPrev", () => $a8783f929f39d4cc$export$6dc88d98f7609a22);
$parcel$export(module.exports, "CARD_NEXT_COLUMN", () => $a8783f929f39d4cc$export$a3decb2cf51ca764);
$parcel$export(module.exports, "cardNextColumn", () => $a8783f929f39d4cc$export$1c08e25c16d65f20);
$parcel$export(module.exports, "CARD_PREV_COLUMN", () => $a8783f929f39d4cc$export$15b65905b49dfb04);
$parcel$export(module.exports, "cardPrevColumn", () => $a8783f929f39d4cc$export$ff3c6f9feddb9cb4);
$parcel$export(module.exports, "SET_ACTIVE_ISSUE_WITH_ICC", () => $a8783f929f39d4cc$export$af33f44f9fd7f318);
$parcel$export(module.exports, "setActiveIssueWithIcc", () => $a8783f929f39d4cc$export$7a1001b4ab64bb5b);
$parcel$export(module.exports, "SET_ISSUE_ID_WITH_ABOVE_ICC_OPEN", () => $a8783f929f39d4cc$export$9e8acf9161cb5486);
$parcel$export(module.exports, "setIssueIdWithAboveICCOpen", () => $a8783f929f39d4cc$export$924f3c9943a9e692);
$parcel$export(module.exports, "CLEAR_SPECIFIED_ISSUE_ID_WITH_ABOVE_ICC_OPEN", () => $a8783f929f39d4cc$export$4b10725fc89d8ab2);
$parcel$export(module.exports, "clearSpecifiedIssueIdWithAboveICCOpen", () => $a8783f929f39d4cc$export$d1dc04baa99725c7);
$parcel$export(module.exports, "INITIATE_ICC_IN_UNSCHEDULED_COLUMN", () => $a8783f929f39d4cc$export$2bd1973a23529d49);
$parcel$export(module.exports, "initiateIccInUnscheduledColumn", () => $a8783f929f39d4cc$export$1eb38ee28983095);
$parcel$export(module.exports, "OPEN_ICC_IN_UNSCHEDULED_COLUMN", () => $a8783f929f39d4cc$export$a25c0f10847dde81);
$parcel$export(module.exports, "openIccInUnscheduledColumn", () => $a8783f929f39d4cc$export$ad9ede75967abe4d);
$parcel$export(module.exports, "CLOSE_ICC_IN_UNSCHEDULED_COLUMN", () => $a8783f929f39d4cc$export$1156eedf1d733b04);
$parcel$export(module.exports, "closeIccInUnscheduledColumn", () => $a8783f929f39d4cc$export$8e78d62a86915719);
$parcel$export(module.exports, "SET_INLINE_EDITING", () => $a8783f929f39d4cc$export$ef54802623416719);
$parcel$export(module.exports, "setInlineEditing", () => $a8783f929f39d4cc$export$1c5b461d4719dea6);

var $7Jxgt = parcelRequire("7Jxgt");


var $9rND4 = parcelRequire("9rND4");
const $a8783f929f39d4cc$export$273ea1cef989293 = 'state.actions.card.CARD_DATA_SET';
const $a8783f929f39d4cc$export$c24b8bc48062c07d = (issue, person, origin = (0, $f32ae13c2b9742f4$export$d46a05f8561f868a))=>({
        type: $a8783f929f39d4cc$export$273ea1cef989293,
        payload: {
            issue: issue,
            person: person,
            origin: origin
        }
    });
const $a8783f929f39d4cc$export$7c85c65079439bf2 = 'state.actions.card.CARD_MEDIA_DATA_SET';
const $a8783f929f39d4cc$export$1292f97e47f8c4f4 = (issueMedia)=>({
        type: $a8783f929f39d4cc$export$7c85c65079439bf2,
        payload: {
            issueMedia: issueMedia
        }
    });
const $a8783f929f39d4cc$export$a5cacf6c12c6c43b = 'state.actions.card.CARD_REFRESH_REQUEST';
const $a8783f929f39d4cc$export$de0715285e6d5218 = ({ issueIds: issueIds, origin: origin, transactionId: transactionId, skipTransactionUpdate: skipTransactionUpdate })=>({
        type: $a8783f929f39d4cc$export$a5cacf6c12c6c43b,
        payload: {
            issueIds: issueIds,
            origin: origin,
            skipTransactionUpdate: skipTransactionUpdate,
            transactionId: transactionId
        }
    });
const $a8783f929f39d4cc$export$54efae65153e525a = (issueIds = [], origin = (0, $f32ae13c2b9742f4$export$d46a05f8561f868a))=>$a8783f929f39d4cc$export$de0715285e6d5218({
        issueIds: issueIds,
        origin: origin,
        transactionId: (0, $7Jxgt.v4)(),
        skipTransactionUpdate: false
    });
const $a8783f929f39d4cc$export$1f7bc7dd5a83e5d6 = 'state.actions.card.CARD_CLICK';
const $a8783f929f39d4cc$export$e7d364bce6e7eb03 = (issueId, withCmd, withShift, externalAction)=>({
        type: $a8783f929f39d4cc$export$1f7bc7dd5a83e5d6,
        payload: {
            issueId: issueId,
            withCmd: withCmd,
            withShift: withShift,
            externalAction: externalAction
        }
    });
const $a8783f929f39d4cc$export$5f8bf17701529b20 = 'state.actions.card.CARD_TOGGLE_SELECTION';
const $a8783f929f39d4cc$export$674d868bde506f3c = 'state.actions.card.CARD_MULTI_SELECT';
const $a8783f929f39d4cc$export$43cca0fb4ffd3a83 = (issueIds)=>({
        type: $a8783f929f39d4cc$export$674d868bde506f3c,
        payload: {
            issueIds: issueIds
        }
    });
const $a8783f929f39d4cc$export$bf1970aeeba42166 = (issueId)=>({
        type: $a8783f929f39d4cc$export$5f8bf17701529b20,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$c68d63d54996a817 = 'state.actions.card.CARD_SINGLE_SELECT';
const $a8783f929f39d4cc$export$9df5a921382fd88e = (issueId)=>({
        type: $a8783f929f39d4cc$export$c68d63d54996a817,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$98df3a708f34d816 = 'state.actions.card.CARD_CANCEL_SELECTION';
const $a8783f929f39d4cc$export$a9618aba37578c3a = ()=>({
        type: $a8783f929f39d4cc$export$98df3a708f34d816
    });
const $a8783f929f39d4cc$export$bc9a106375114441 = 'state.actions.card.CARD_CLEAR';
const $a8783f929f39d4cc$export$bdf5dd34d7025486 = (cardIds, childCardIds)=>({
        type: $a8783f929f39d4cc$export$bc9a106375114441,
        payload: {
            cardIds: cardIds,
            childCardIds: childCardIds
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $a8783f929f39d4cc$export$b28aa61b9e4e4c13 = 'state.actions.card.CARD_CLEAR_SUCCESS';
const $a8783f929f39d4cc$export$c6b9b0adb28bc068 = (optimisticId)=>({
        type: $a8783f929f39d4cc$export$b28aa61b9e4e4c13,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $a8783f929f39d4cc$export$1add5abc4ada3dcb = 'state.actions.card.CARD_CLEAR_FAILURE';
const $a8783f929f39d4cc$export$4da3d14df563def7 = (optimisticId)=>({
        type: $a8783f929f39d4cc$export$1add5abc4ada3dcb,
        meta: (0, $9rND4.revertOptimisticUiMeta)(optimisticId)
    });
const $a8783f929f39d4cc$export$6fa90d6b83f582d7 = 'state.actions.card.CARD_CLEAR_REVERT';
const $a8783f929f39d4cc$export$abd1d00c8fd946b8 = (optimisticId)=>({
        type: $a8783f929f39d4cc$export$6fa90d6b83f582d7,
        meta: (0, $9rND4.revertOptimisticUiMeta)(optimisticId)
    });
const $a8783f929f39d4cc$export$9c64600376e3d373 = 'state.actions.card.CARD_CLEAR_UNDO';
const $a8783f929f39d4cc$export$73bb242cdcb8f96 = (undoPromise, retry, optimisticId)=>({
        type: $a8783f929f39d4cc$export$9c64600376e3d373,
        payload: {
            undoPromise: undoPromise,
            retry: retry,
            optimisticId: optimisticId
        }
    });
const $a8783f929f39d4cc$export$b82590935cfab60f = 'state.actions.card.CARD_DELETE';
const $a8783f929f39d4cc$export$ba9d764de574147c = (issueId, parentId = null, isDone = false)=>({
        type: $a8783f929f39d4cc$export$b82590935cfab60f,
        payload: {
            issueId: issueId,
            parentId: parentId,
            isDone: isDone
        }
    });
const $a8783f929f39d4cc$export$60d48bfd6db6297f = 'state.actions.card.CARD_DELETE_OPTIMISTIC';
const $a8783f929f39d4cc$export$8c23f90a573b475d = (issueId)=>({
        type: $a8783f929f39d4cc$export$60d48bfd6db6297f,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$c9359f309b5f4898 = 'state.actions.card.CARD_DRAG_OVER_TRANSITION';
const $a8783f929f39d4cc$export$5a37155dbb24c55d = (transitionId, toColumnId, hoverIntent)=>({
        type: $a8783f929f39d4cc$export$c9359f309b5f4898,
        payload: {
            transitionId: transitionId,
            toColumnId: toColumnId,
            hoverIntent: hoverIntent
        }
    });
const $a8783f929f39d4cc$export$639e98b190c1f7b7 = 'state.actions.card.CARD_DRAG_OVER_TRANSITION_REQUEST';
const $a8783f929f39d4cc$export$371faa1fb1a6bca3 = (transitionId, toColumnId, hoverIntent)=>({
        type: $a8783f929f39d4cc$export$639e98b190c1f7b7,
        payload: {
            transitionId: transitionId,
            toColumnId: toColumnId,
            hoverIntent: hoverIntent
        }
    });
const $a8783f929f39d4cc$export$ec18418d1159cde3 = 'state.actions.card.CARD_DRAG_SELECTED_TRANSITION';
const $a8783f929f39d4cc$export$ee55e5ac05a9811a = (transitionId, toColumnId, toSwimlaneId)=>({
        type: $a8783f929f39d4cc$export$ec18418d1159cde3,
        payload: {
            transitionId: transitionId,
            toColumnId: toColumnId,
            toSwimlaneId: toSwimlaneId
        }
    });
const $a8783f929f39d4cc$export$7e4b8027ee23adc0 = 'state.actions.card.CARD_GET_ISSUE_TRANSITIONS';
const $a8783f929f39d4cc$export$611a578ff56e22fb = (issueId, analyticsEvent)=>({
        type: $a8783f929f39d4cc$export$7e4b8027ee23adc0,
        payload: {
            issueId: issueId
        },
        meta: {
            analytics: analyticsEvent
        }
    });
const $a8783f929f39d4cc$export$6ea7c16576dd08bc = 'state.actions.card.CARD_GET_ISSUE_TRANSITIONS_FAILURE';
const $a8783f929f39d4cc$export$8df71fbcf20d401f = (issueId)=>({
        type: $a8783f929f39d4cc$export$6ea7c16576dd08bc,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$713b5a2539e4ed6f = 'state.actions.card.CARD_SET_ISSUE_TRANSITIONS';
const $a8783f929f39d4cc$export$31d2270f6fdce884 = (issueId, columnTransitions)=>({
        type: $a8783f929f39d4cc$export$713b5a2539e4ed6f,
        payload: {
            issueId: issueId,
            columnTransitions: columnTransitions
        }
    });
const $a8783f929f39d4cc$export$7de76f693f0d3820 = 'state.actions.card.CARD_FOCUS';
const $a8783f929f39d4cc$export$e462552ef1675527 = (issueId)=>({
        type: $a8783f929f39d4cc$export$7de76f693f0d3820,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$6ac448f92e1f338b = 'state.actions.card.CARD_BLUR';
const $a8783f929f39d4cc$export$9dea9abf478df7d7 = ()=>({
        type: $a8783f929f39d4cc$export$6ac448f92e1f338b
    });
const $a8783f929f39d4cc$export$34a15cd7bcc20e7c = 'state.actions.card.CARD_ADD_SHOW_RIPPLE';
const $a8783f929f39d4cc$export$d5db5f1fced5f46b = (issueIds)=>({
        type: $a8783f929f39d4cc$export$34a15cd7bcc20e7c,
        payload: {
            rippleIdsToShow: issueIds
        }
    });
const $a8783f929f39d4cc$export$daf49e5bace84185 = 'state.actions.card.CARD_REMOVE_SHOW_RIPPLE';
const $a8783f929f39d4cc$export$fa511ac22ea1432e = (issueId)=>({
        type: $a8783f929f39d4cc$export$daf49e5bace84185,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$e780294f9cb0bbfd = 'state.actions.card.CARD_NEXT';
const $a8783f929f39d4cc$export$d848405832f5c1d5 = (fireShortcutAnalyticsFn)=>({
        type: $a8783f929f39d4cc$export$e780294f9cb0bbfd,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $a8783f929f39d4cc$export$22f722071ae1a37d = 'state.actions.card.CARD_PREV';
const $a8783f929f39d4cc$export$6dc88d98f7609a22 = (fireShortcutAnalyticsFn)=>({
        type: $a8783f929f39d4cc$export$22f722071ae1a37d,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $a8783f929f39d4cc$export$a3decb2cf51ca764 = 'state.actions.card.CARD_NEXT_COLUMN';
const $a8783f929f39d4cc$export$1c08e25c16d65f20 = (fireShortcutAnalyticsFn)=>({
        type: $a8783f929f39d4cc$export$a3decb2cf51ca764,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $a8783f929f39d4cc$export$15b65905b49dfb04 = 'state.actions.card.CARD_PREV_COLUMN';
const $a8783f929f39d4cc$export$ff3c6f9feddb9cb4 = (fireShortcutAnalyticsFn)=>({
        type: $a8783f929f39d4cc$export$15b65905b49dfb04,
        payload: {
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $a8783f929f39d4cc$export$af33f44f9fd7f318 = 'state.actions.card.SET_ACTIVE_ISSUE_WITH_ICC';
const $a8783f929f39d4cc$export$7a1001b4ab64bb5b = (issueId)=>({
        type: $a8783f929f39d4cc$export$af33f44f9fd7f318,
        payload: {
            issueId: issueId
        }
    });
const $a8783f929f39d4cc$export$9e8acf9161cb5486 = 'state.actions.card.SET_ISSUE_ID_WITH_ABOVE_ICC_OPEN';
const $a8783f929f39d4cc$export$924f3c9943a9e692 = (issueId, columnId)=>({
        type: $a8783f929f39d4cc$export$9e8acf9161cb5486,
        payload: {
            issueId: issueId,
            columnId: columnId
        }
    });
const $a8783f929f39d4cc$export$4b10725fc89d8ab2 = 'state.actions.card.CLEAR_SPECIFIED_ISSUE_ID_WITH_ABOVE_ICC_OPEN';
const $a8783f929f39d4cc$export$d1dc04baa99725c7 = (issueId, columnId)=>({
        type: $a8783f929f39d4cc$export$4b10725fc89d8ab2,
        payload: {
            issueId: issueId,
            columnId: columnId
        }
    });
const $a8783f929f39d4cc$export$2bd1973a23529d49 = 'state.actions.card.INITIATE_ICC_IN_UNSCHEDULED_COLUMN';
const $a8783f929f39d4cc$export$1eb38ee28983095 = (swimlaneId, shouldToggleSwimlane)=>({
        type: $a8783f929f39d4cc$export$2bd1973a23529d49,
        payload: {
            swimlaneId: swimlaneId,
            shouldToggleSwimlane: shouldToggleSwimlane
        }
    });
const $a8783f929f39d4cc$export$a25c0f10847dde81 = 'state.actions.card.OPEN_ICC_IN_UNSCHEDULED_COLUMN';
const $a8783f929f39d4cc$export$ad9ede75967abe4d = (swimlaneId)=>({
        type: $a8783f929f39d4cc$export$a25c0f10847dde81,
        payload: {
            swimlaneId: swimlaneId
        }
    });
const $a8783f929f39d4cc$export$1156eedf1d733b04 = 'state.actions.card.CLOSE_ICC_IN_UNSCHEDULED_COLUMN';
const $a8783f929f39d4cc$export$8e78d62a86915719 = ()=>({
        type: $a8783f929f39d4cc$export$1156eedf1d733b04
    });
const $a8783f929f39d4cc$export$ef54802623416719 = 'state.actions.card.SET_INLINE_EDITING';
const $a8783f929f39d4cc$export$1c5b461d4719dea6 = (field, issueId, value)=>({
        type: $a8783f929f39d4cc$export$ef54802623416719,
        payload: {
            field: field,
            issueId: issueId,
            value: value
        }
    });

});
const $f32ae13c2b9742f4$export$306c754c61954570 = 'BENTO';
const $f32ae13c2b9742f4$export$f2127cf693ff3edc = 'TRANSITION';
const $f32ae13c2b9742f4$export$c1d71ceefe04e35a = 'SYNC';
const $f32ae13c2b9742f4$export$d46a05f8561f868a = 'OTHER';



parcelRegister("gZyMz", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd9a63ebcd6dfbf9$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $5bE6a = parcelRequire("5bE6a");

var $2f454 = parcelRequire("2f454");

var $9OPlz = parcelRequire("9OPlz");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
const $cd9a63ebcd6dfbf9$export$4a76ddc96cd4947 = 'card-fetch-issue-transitions.info';
const $cd9a63ebcd6dfbf9$export$9a9cdf8240af39c4 = 'card-fetch-issue-transitions.failure';
const $cd9a63ebcd6dfbf9$export$fd93422e69803b8b = (issue, issueProject, columnIssueTypeTransitions)=>(issueTransitions)=>{
        const columnIds = Object.keys(columnIssueTypeTransitions);
        const comparisonFn = (columnTransition, issueTransition)=>columnTransition.id === issueTransition.id && columnTransition.destinationStatusId === issueTransition.destinationStatusId && (issueProject === undefined || columnTransition.projectKey === issueProject.key);
        const availableColumnTransitions = {};
        columnIds.forEach((columnId)=>{
            const columnTransitions = columnIssueTypeTransitions[columnId][String(issue.typeId)] || [];
            // Match based on project KEY
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            availableColumnTransitions[columnId] = columnTransitions.map((columnTransition)=>// We retrieve the issue one because we grabbed it recently from SWAG
                issueTransitions.find((issueTransition)=>comparisonFn(columnTransition, issueTransition))).filter((columnTransition)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnTransition));
        });
        return availableColumnTransitions;
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cd9a63ebcd6dfbf9$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $2f454.CARD_GET_ISSUE_TRANSITIONS)).switchMap((action)=>{
        const { meta: { analytics: analyticsEvent } } = action;
        const state = store.getState();
        const cardId = (0, $9OPlz.getDraggingCardId)(state);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(cardId)) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData($cd9a63ebcd6dfbf9$export$9a9cdf8240af39c4, 'No dragging issue data present in state to fetch transitions');
            return (0, $kVLXA.Observable).empty();
        }
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const issue = (0, $d2i8f.getIssueById)(state, cardId);
        const cardTransitions = (0, $67Z81.getCardTransitions)(state);
        const projects = (0, $67Z81.getIssueProjects)(state);
        const issueProject = projects[issue?.projectId];
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'boardIssueTransitions fetchRequested');
        return (0, $5bE6a.fetchCardIssueTransitionsService)(contextPath, boardId, cardId).switchMap((issueTransitions)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueTransitions)) {
                (0, $2YZCu.default).safeInfoWithoutCustomerData($cd9a63ebcd6dfbf9$export$4a76ddc96cd4947, `No transitions available for issue ${cardId}`);
                return (0, $kVLXA.Observable).empty();
            }
            return (0, $kVLXA.Observable).of(issueTransitions);
        }).map($cd9a63ebcd6dfbf9$export$fd93422e69803b8b(issue, issueProject, cardTransitions.columnIssueTypeTransitions)).switchMap((availableColumnTransitions)=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'boardIssueTransitions fetchSucceeded');
            return (0, $kVLXA.Observable).of((0, $2f454.cardSetIssueTransitions)(cardId, availableColumnTransitions));
        }).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData($cd9a63ebcd6dfbf9$export$9a9cdf8240af39c4, 'Failed to get card transition data', error);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'boardIssueTransitions fetchFailed');
            return (0, $kVLXA.Observable).of((0, $2f454.cardGetIssueTransitionsFailure)(cardId));
        });
    });

});
parcelRegister("5bE6a", function(module, exports) {

$parcel$export(module.exports, "fetchCardIssueTransitionsService", () => $9590ae909268ce6b$export$accee6f68a886973);
parcelRequire("d0pqD");

var $bQEek = parcelRequire("bQEek");
const $9590ae909268ce6b$export$f51a517f410d7626 = (response = {})=>{
    const transitions = response.boardScope?.cards[0].issue?.transitions;
    if (transitions === null || transitions === undefined) return [];
    // Filter out the nulls from the array here
    const filteredTransitions = transitions.filter(// eslint-disable-next-line camelcase
    (transition)=>transition != null);
    // Convert to new type
    return filteredTransitions.map((transition)=>({
            id: Number(transition.id),
            name: transition.name,
            destinationStatusId: Number(transition.toStatusId),
            isGlobal: transition.isGlobal,
            isInitial: transition.isInitial,
            isAvailable: transition.isAvailable
        }));
};
const $9590ae909268ce6b$export$accee6f68a886973 = (contextPath, boardId, cardId)=>(0, $bQEek.fetchCardIssueTransitions)(contextPath, boardId, [
        cardId
    ]).map($9590ae909268ce6b$export$f51a517f410d7626);

});
parcelRegister("bQEek", function(module, exports) {

$parcel$export(module.exports, "fetchCardIssueTransitions", () => $7b8afae71e0ff488$export$b3aab32da3483734);

var $ivqh1 = parcelRequire("ivqh1");

var $cBLvH = parcelRequire("cBLvH");
const $7b8afae71e0ff488$export$d600414b4ff35a1 = 'CardIssueTransitions';
const $7b8afae71e0ff488$export$2b91517d6d5b4365 = (0, $ivqh1.gqlTagSwag)`
query CardIssueTransitions($boardId: ID!, $cardIds: [ID!]!) {
    boardScope(boardId: $boardId) {
        cards(cardIds: $cardIds) {
            issue {
                transitions {
                    id
                    name
                    isAvailable
                    isConditional
                    isGlobal
                    toStatusId
                    isInitial
                    hasScreen
                }
            }
        }
    }
}`;
const $7b8afae71e0ff488$export$b3aab32da3483734 = (contextPath, boardId, cardIds)=>(0, $cBLvH.query$)(contextPath, $7b8afae71e0ff488$export$d600414b4ff35a1, $7b8afae71e0ff488$export$2b91517d6d5b4365, {
        boardId: boardId,
        cardIds: cardIds
    });

});
parcelRegister("cBLvH", function(module, exports) {

$parcel$export(module.exports, "query$", () => $b2e62d4903324e0d$export$a332dd84c3221bf2);

var $4nUsC = parcelRequire("4nUsC");
const $b2e62d4903324e0d$export$a332dd84c3221bf2 = (baseUrl, operationName, query, variables, analyticOptions)=>(0, $4nUsC.operation$)('query', baseUrl, operationName, query, variables, analyticOptions);

});




parcelRegister("8ornp", function(module, exports) {

$parcel$export(module.exports, "cardAssignToMeEpic", () => $a383a3fc08d2115a$export$2bee3a5e157b7bbf);
$parcel$export(module.exports, "cardAssignToMeThrottledEpic", () => $a383a3fc08d2115a$export$5ed483b9a7992e55);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("3awJm");
parcelRequire("fPS7b");
parcelRequire("d0pqD");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $k12ix = parcelRequire("k12ix");

var $aYkSv = parcelRequire("aYkSv");

var $4G04L = parcelRequire("4G04L");

var $hz3OZ = parcelRequire("hz3OZ");

var $cAxle = parcelRequire("cAxle");
const $a383a3fc08d2115a$export$3ab433d598b5afda = {
    onStart: (action)=>{
        const { concurrentId: concurrentId, assigneeAccountId: assigneeAccountId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } = action.payload;
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.assignToMeInteraction)(String(concurrentId)).mark('feedback');
        });
        if (fireShortcutAnalyticsFn) fireShortcutAnalyticsFn({
            id: 'assignToMeKeyboardShortcut',
            key: 'i',
            attributes: {
                assignStatus: assigneeAccountId !== null ? 'assign' : 'unassign'
            }
        });
    },
    onSuccess: (action)=>{
        const { concurrentId: concurrentId } = action.payload;
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.assignToMeInteraction)(String(concurrentId)).stop({
                customData: (0, $k12ix.getNormalisedPerformanceFFs)()
            });
        });
    }
};
const $a383a3fc08d2115a$export$59640cb3aa92677 = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, action, hooks = $a383a3fc08d2115a$export$3ab433d598b5afda)=>{
    const { issueId: issueId, assigneeAccountId: assigneeAccountId } = action.payload;
    const { optimistic: { id: optimisticId } } = action.meta;
    if (hooks.onStart) hooks.onStart(action);
    const requestObservable = (0, $kVLXA.Observable).fromPromise((0, $aYkSv.assignToMe)(swagClient, {
        issueId: `${issueId}`,
        accountId: assigneeAccountId
    }));
    return requestObservable.map(()=>{
        if (hooks.onSuccess) hooks.onSuccess(action);
        return (0, $cAxle.assignToMeSucess)(optimisticId);
    }).catch(()=>{
        if (hooks.onFailure) hooks.onFailure(action);
        return (0, $e1AU2.ActionsObservable).of((0, $cAxle.assignToMeFailure)(optimisticId));
    });
};
const $a383a3fc08d2115a$export$2bee3a5e157b7bbf = (action$, state, dependencies)=>dependencies ? action$.ofType((0, $cAxle.ASSIGN_TO_ME_REQUEST)).flatMap((action)=>$a383a3fc08d2115a$export$59640cb3aa92677(dependencies.swagClient, action)) : (0, $kVLXA.Observable).empty();
const $a383a3fc08d2115a$export$5ed483b9a7992e55 = (action$)=>action$.ofType((0, $cAxle.ASSIGN_TO_ME_REQUEST_THROTTLED)).throttleTime(500).flatMap((action)=>{
        const { issueId: issueId, assigneeAccountId: assigneeAccountId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn } = action.payload;
        const concurrentId = (0, $7Jxgt.v4)();
        (0, $hz3OZ.assignToMeInteraction)(concurrentId).start();
        return (0, $kVLXA.Observable).of((0, $cAxle.assignToMeRequest)({
            issueId: issueId,
            assigneeAccountId: assigneeAccountId,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }));
    });

});
parcelRegister("k12ix", function(module, exports) {

$parcel$export(module.exports, "getPerformanceFFsString", () => $c2cbddd7f2605816$export$c983ad7dc5517558);
$parcel$export(module.exports, "getNormalisedPerformanceFFs", () => $c2cbddd7f2605816$export$de03840ff3eb49a4);

var $6eBRn = parcelRequire("6eBRn");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $y7eb2 = parcelRequire("y7eb2");
const $c2cbddd7f2605816$var$PERF_FF_PREFIX = 'jsw.perf.';
const $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST = new Set([
    'fe_platform_error_tracking_enabled_sentry'
]);
const $c2cbddd7f2605816$var$getPerformanceFFs = (0, $8QpSo.default)(()=>{
    const featureFlags = Object.entries((0, $y7eb2.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>key.startsWith($c2cbddd7f2605816$var$PERF_FF_PREFIX)) // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key.substring($c2cbddd7f2605816$var$PERF_FF_PREFIX.length),
            (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, [
                'value'
            ], null)
        ]);
    return (0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(featureFlags);
});
const $c2cbddd7f2605816$var$isConsistencyCheckValue = (value)=>value === 'NEW' || value === 'OLD' || value === 'CHECK' || value === 'CHECK_RETURN_NEW';
const $c2cbddd7f2605816$export$448575db1388a8e6 = (0, $8QpSo.default)((whitelist = $c2cbddd7f2605816$var$EXTRA_FFS_WHITELIST)=>{
    const featurePairs = Object.entries((0, $y7eb2.default)() || {})// @ts-expect-error - TS2769 - No overload matches this call.
    .filter(([key])=>whitelist.has(key)) // eslint-disable-line @typescript-eslint/no-explicit-any
    .map(([key, value])=>[
            key,
            (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(value, [
                'value'
            ], null)
        ]); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    // @ts-expect-error - TS2345 - Argument of type '([key, value]: [any, any]) => void' is not assignable to parameter of type '(value: any[], index: number, array: any[][]) => void'.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featurePairs.forEach(([key, value])=>{
        result[key] = value;
        if ($c2cbddd7f2605816$var$isConsistencyCheckValue(value)) {
            result[`${key}-new`] = value === 'NEW';
            result[`${key}-old`] = value === 'OLD';
            result[`${key}-check`] = value === 'CHECK';
            result[`${key}-check-return-new`] = value === 'CHECK_RETURN_NEW';
        }
    });
    return result;
});
const $c2cbddd7f2605816$export$c983ad7dc5517558 = (0, $8QpSo.default)(()=>JSON.stringify($c2cbddd7f2605816$var$getPerformanceFFs()));
const $c2cbddd7f2605816$export$de03840ff3eb49a4 = (0, $8QpSo.default)(()=>{
    const featureEntries = Object.entries({
        ...$c2cbddd7f2605816$var$getPerformanceFFs(),
        ...$c2cbddd7f2605816$export$448575db1388a8e6()
    });
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const map = {};
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    featureEntries.forEach(([key, value])=>{
        const normalisedKey = key.replace(/\./g, '-');
        map[normalisedKey] = value;
        return map;
    });
    return map;
});

});

parcelRegister("aYkSv", function(module, exports) {

$parcel$export(module.exports, "assignToMe", () => $4addbd3196ad60f5$export$521df9d10558315a);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $cNrxd = parcelRequire("cNrxd");

var $1EJrV = parcelRequire("1EJrV");

var $j8ZVG = parcelRequire("j8ZVG");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4addbd3196ad60f5$var$onMutationError = (error)=>{
    if ((0, $1EJrV.isExpectedGraphQLError)(error)) return;
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: 'assignToMeMutationFailed',
            packageName: 'jiraSoftwareKeyboardShortcuts'
        }
    });
};
const $4addbd3196ad60f5$export$521df9d10558315a = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
swagClient, variables)=>swagClient.mutate({
        mutation: (0, $j8ZVG.MUTATION),
        variables: variables
    }).then((result)=>{
        if (result.errors && result.errors.length || !result.data) throw new (0, $cNrxd.SwagError)({
            // @ts-expect-error - TS2322 - Type 'readonly GraphQLError[] | undefined' is not assignable to type 'GraphqlError[] | undefined'.
            graphQLErrors: result.errors,
            errorMessage: 'Assign to me failed'
        });
        return result.data;
    }).catch((err)=>{
        $4addbd3196ad60f5$var$onMutationError(err);
        throw err;
    });
const $4addbd3196ad60f5$export$5d2cd46d1c41b734 = ()=>{
    const [assignToMeMutation] = (0, $j8ZVG.useAssignToMeMutation)();
    return (0, $5uXOq.useCallback)(({ issueId: issueId, accountId: accountId })=>{
        const assignMutationPromise = assignToMeMutation({
            variables: {
                issueId: issueId,
                accountId: accountId
            }
        });
        assignMutationPromise.catch($4addbd3196ad60f5$var$onMutationError);
        return assignMutationPromise;
    }, [
        assignToMeMutation
    ]);
};

});
parcelRegister("1EJrV", function(module, exports) {

$parcel$export(module.exports, "isExpectedGraphQLError", () => $ec71481172594c19$export$9bfdf944b8987eac);
const $ec71481172594c19$export$9bfdf944b8987eac = (error)=>Boolean(error.graphQLErrors?.length > 0 && error.graphQLErrors?.every((graphQLError)=>{
        const statusCode = graphQLError?.extensions?.statusCode;
        return Boolean(statusCode);
    }));

});

parcelRegister("j8ZVG", function(module, exports) {

$parcel$export(module.exports, "MUTATION", () => $37c313ac561550fe$export$7473a9a03a67999e);
$parcel$export(module.exports, "useAssignToMeMutation", () => $37c313ac561550fe$export$9c4806aca0078faa);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $37c313ac561550fe$export$7473a9a03a67999e = (0, $5cllN.default)`
    mutation AssignIssue($issueId: ID!, $accountId: ID) {
        assignIssue(input: { issueId: $issueId, accountId: $accountId }) {
            statusCode
            message
        }
    }
`;
const $37c313ac561550fe$export$9c4806aca0078faa = ()=>(0, $5tTFS.useMutation)($37c313ac561550fe$export$7473a9a03a67999e);

});
parcelRegister("5tTFS", function(module, exports) {

$parcel$export(module.exports, "useQuery", () => $3fdad8fd02cd9507$export$dd0a697e1782aedd);
$parcel$export(module.exports, "useLazyQuery", () => $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa);
$parcel$export(module.exports, "useMutation", () => $3fdad8fd02cd9507$export$609860bf8b0084c);
$parcel$export(module.exports, "useApolloClient", () => $3fdad8fd02cd9507$export$eb9a56e7a29e494);

var $bvsgq = parcelRequire("bvsgq");

var $3VFsf = parcelRequire("3VFsf");

var $5uXOq = parcelRequire("5uXOq");

var $e3a3O = parcelRequire("e3a3O");

var $bqMzA = parcelRequire("bqMzA");

var $1DiV8 = parcelRequire("1DiV8");
var $3fdad8fd02cd9507$var$OperationData = function() {
    function OperationData(options, context) {
        this.isMounted = false;
        this.previousOptions = {};
        this.context = {};
        this.options = {};
        this.options = options || {};
        this.context = context || {};
    }
    OperationData.prototype.getOptions = function() {
        return this.options;
    };
    OperationData.prototype.setOptions = function(newOptions, storePrevious) {
        if (storePrevious === void 0) storePrevious = false;
        if (storePrevious && !(0, $bqMzA.equal)(this.options, newOptions)) this.previousOptions = this.options;
        this.options = newOptions;
    };
    OperationData.prototype.unmount = function() {
        this.isMounted = false;
    };
    OperationData.prototype.refreshClient = function() {
        var client = this.options && this.options.client || this.context && this.context.client;
        (0, $1DiV8.invariant)(!!client, 2);
        var isNew = false;
        if (client !== this.client) {
            isNew = true;
            this.client = client;
            this.cleanup();
        }
        return {
            client: this.client,
            isNew: isNew
        };
    };
    OperationData.prototype.verifyDocumentType = function(document, type) {
        var operation = (0, $bvsgq.parser)(document);
        var requiredOperationName = (0, $bvsgq.operationName)(type);
        var usedOperationName = (0, $bvsgq.operationName)(operation.type);
        (0, $1DiV8.invariant)(operation.type === type, 3);
    };
    return OperationData;
}();
var $3fdad8fd02cd9507$var$QueryData = function(_super) {
    (0, $3VFsf.__extends)(QueryData, _super);
    function QueryData(_a) {
        var options = _a.options, context = _a.context, forceUpdate = _a.forceUpdate;
        var _this = _super.call(this, options, context) || this;
        _this.previousData = {};
        _this.currentObservable = {};
        _this.runLazy = false;
        _this.runLazyQuery = function(options) {
            _this.cleanup();
            _this.runLazy = true;
            _this.lazyOptions = options;
            _this.forceUpdate();
        };
        _this.getExecuteResult = function() {
            var result = _this.getQueryResult();
            _this.startQuerySubscription();
            return result;
        };
        _this.obsRefetch = function(variables) {
            return _this.currentObservable.query.refetch(variables);
        };
        _this.obsFetchMore = function(fetchMoreOptions) {
            return _this.currentObservable.query.fetchMore(fetchMoreOptions);
        };
        _this.obsUpdateQuery = function(mapFn) {
            return _this.currentObservable.query.updateQuery(mapFn);
        };
        _this.obsStartPolling = function(pollInterval) {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.startPolling(pollInterval);
        };
        _this.obsStopPolling = function() {
            _this.currentObservable && _this.currentObservable.query && _this.currentObservable.query.stopPolling();
        };
        _this.obsSubscribeToMore = function(options) {
            return _this.currentObservable.query.subscribeToMore(options);
        };
        _this.forceUpdate = forceUpdate;
        return _this;
    }
    QueryData.prototype.execute = function() {
        this.refreshClient();
        var _a = this.getOptions(), skip = _a.skip, query = _a.query;
        if (skip || query !== this.previousData.query) {
            this.removeQuerySubscription();
            this.previousData.query = query;
        }
        this.updateObservableQuery();
        if (this.isMounted) this.startQuerySubscription();
        return this.getExecuteSsrResult() || this.getExecuteResult();
    };
    QueryData.prototype.executeLazy = function() {
        return !this.runLazy ? [
            this.runLazyQuery,
            {
                loading: false,
                networkStatus: (0, $e3a3O.NetworkStatus).ready,
                called: false,
                data: undefined
            }
        ] : [
            this.runLazyQuery,
            this.execute()
        ];
    };
    QueryData.prototype.fetchData = function() {
        var options = this.getOptions();
        if (options.skip || options.ssr === false) return false;
        var obs = this.currentObservable.query;
        var currentResult = obs.getCurrentResult();
        return currentResult.loading ? obs.result() : false;
    };
    QueryData.prototype.afterExecute = function(_a) {
        var _this = this;
        var _b = (_a === void 0 ? {} : _a).lazy, lazy = _b === void 0 ? false : _b;
        this.isMounted = true;
        if (!lazy || this.runLazy) {
            this.handleErrorOrCompleted();
            setTimeout(function() {
                _this.currentObservable.query && _this.currentObservable.query.resetQueryStoreErrors();
            });
        }
        this.previousOptions = this.getOptions();
        return this.unmount.bind(this);
    };
    QueryData.prototype.cleanup = function() {
        this.removeQuerySubscription();
        delete this.currentObservable.query;
        delete this.previousData.result;
    };
    QueryData.prototype.getOptions = function() {
        var options = _super.prototype.getOptions.call(this);
        if (this.lazyOptions) {
            options.variables = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.variables), this.lazyOptions.variables);
            options.context = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options.context), this.lazyOptions.context);
        }
        if (this.runLazy) delete options.skip;
        return options;
    };
    QueryData.prototype.getExecuteSsrResult = function() {
        var treeRenderingInitiated = this.context && this.context.renderPromises;
        var ssrDisabled = this.getOptions().ssr === false;
        var fetchDisabled = this.refreshClient().client.disableNetworkFetches;
        var ssrLoading = {
            loading: true,
            networkStatus: (0, $e3a3O.NetworkStatus).loading,
            called: true,
            data: undefined
        };
        if (ssrDisabled && (treeRenderingInitiated || fetchDisabled)) return ssrLoading;
        var result;
        if (treeRenderingInitiated) result = this.context.renderPromises.addQueryPromise(this, this.getExecuteResult) || ssrLoading;
        return result;
    };
    QueryData.prototype.prepareObservableQueryOptions = function() {
        var options = this.getOptions();
        this.verifyDocumentType(options.query, (0, $bvsgq.DocumentType).Query);
        var displayName = options.displayName || 'Query';
        if (this.context && this.context.renderPromises && (options.fetchPolicy === 'network-only' || options.fetchPolicy === 'cache-and-network')) options.fetchPolicy = 'cache-first';
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
            displayName: displayName,
            context: options.context,
            metadata: {
                reactComponent: {
                    displayName: displayName
                }
            }
        });
    };
    QueryData.prototype.initializeObservableQuery = function() {
        if (this.context && this.context.renderPromises) this.currentObservable.query = this.context.renderPromises.getSSRObservable(this.getOptions());
        if (!this.currentObservable.query) {
            var observableQueryOptions = this.prepareObservableQueryOptions();
            this.previousData.observableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, observableQueryOptions), {
                children: null
            });
            this.currentObservable.query = this.refreshClient().client.watchQuery((0, $3VFsf.__assign)({}, observableQueryOptions));
            if (this.context && this.context.renderPromises) this.context.renderPromises.registerSSRObservable(this.currentObservable.query, observableQueryOptions);
        }
    };
    QueryData.prototype.updateObservableQuery = function() {
        if (!this.currentObservable.query) {
            this.initializeObservableQuery();
            return;
        }
        var newObservableQueryOptions = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, this.prepareObservableQueryOptions()), {
            children: null
        });
        if (!(0, $bqMzA.equal)(newObservableQueryOptions, this.previousData.observableQueryOptions)) {
            this.previousData.observableQueryOptions = newObservableQueryOptions;
            this.currentObservable.query.setOptions(newObservableQueryOptions).catch(function() {});
        }
    };
    QueryData.prototype.startQuerySubscription = function() {
        var _this = this;
        if (this.currentObservable.subscription || this.getOptions().skip) return;
        var obsQuery = this.currentObservable.query;
        this.currentObservable.subscription = obsQuery.subscribe({
            next: function(_a) {
                var loading = _a.loading, networkStatus = _a.networkStatus, data = _a.data;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading === loading && previousResult.networkStatus === networkStatus && (0, $bqMzA.equal)(previousResult.data, data)) return;
                _this.forceUpdate();
            },
            error: function(error) {
                _this.resubscribeToQuery();
                if (!error.hasOwnProperty('graphQLErrors')) throw error;
                var previousResult = _this.previousData.result;
                if (previousResult && previousResult.loading || !(0, $bqMzA.equal)(error, _this.previousData.error)) {
                    _this.previousData.error = error;
                    _this.forceUpdate();
                }
            }
        });
    };
    QueryData.prototype.resubscribeToQuery = function() {
        this.removeQuerySubscription();
        var lastError = this.currentObservable.query.getLastError();
        var lastResult = this.currentObservable.query.getLastResult();
        this.currentObservable.query.resetLastResults();
        this.startQuerySubscription();
        Object.assign(this.currentObservable.query, {
            lastError: lastError,
            lastResult: lastResult
        });
    };
    QueryData.prototype.getQueryResult = function() {
        var result = this.observableQueryFields();
        var options = this.getOptions();
        if (options.skip) result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
            data: undefined,
            error: undefined,
            loading: false,
            called: true
        });
        else {
            var currentResult = this.currentObservable.query.getCurrentResult();
            var loading = currentResult.loading, partial = currentResult.partial, networkStatus = currentResult.networkStatus, errors = currentResult.errors;
            var error = currentResult.error, data = currentResult.data;
            if (errors && errors.length > 0) error = new (0, $e3a3O.ApolloError)({
                graphQLErrors: errors
            });
            result = (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, result), {
                loading: loading,
                networkStatus: networkStatus,
                error: error,
                called: true
            });
            if (loading) {
                var previousData = this.previousData.result && this.previousData.result.data;
                result.data = previousData && data ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, previousData), data) : previousData || data;
            } else if (error) Object.assign(result, {
                data: (this.currentObservable.query.getLastResult() || {}).data
            });
            else {
                var fetchPolicy = this.currentObservable.query.options.fetchPolicy;
                var partialRefetch = options.partialRefetch;
                if (partialRefetch && !data && partial && fetchPolicy !== 'cache-only') {
                    Object.assign(result, {
                        loading: true,
                        networkStatus: (0, $e3a3O.NetworkStatus).loading
                    });
                    result.refetch();
                    return result;
                }
                result.data = data;
            }
        }
        result.client = this.client;
        this.previousData.loading = this.previousData.result && this.previousData.result.loading || false;
        this.previousData.result = result;
        return result;
    };
    QueryData.prototype.handleErrorOrCompleted = function() {
        var obsQuery = this.currentObservable.query;
        if (!obsQuery) return;
        var _a = obsQuery.getCurrentResult(), data = _a.data, loading = _a.loading, error = _a.error;
        if (!loading) {
            var _b = this.getOptions(), query = _b.query, variables = _b.variables, onCompleted = _b.onCompleted, onError = _b.onError;
            if (this.previousOptions && !this.previousData.loading && (0, $bqMzA.equal)(this.previousOptions.query, query) && (0, $bqMzA.equal)(this.previousOptions.variables, variables)) return;
            if (onCompleted && !error) onCompleted(data);
            else if (onError && error) onError(error);
        }
    };
    QueryData.prototype.removeQuerySubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    QueryData.prototype.observableQueryFields = function() {
        var observable = this.currentObservable.query;
        return {
            variables: observable.variables,
            refetch: this.obsRefetch,
            fetchMore: this.obsFetchMore,
            updateQuery: this.obsUpdateQuery,
            startPolling: this.obsStartPolling,
            stopPolling: this.obsStopPolling,
            subscribeToMore: this.obsSubscribeToMore
        };
    };
    return QueryData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$var$useDeepMemo(memoFn, key) {
    var ref = (0, $5uXOq.useRef)();
    if (!ref.current || !(0, $bqMzA.equal)(key, ref.current.key)) ref.current = {
        key: key,
        value: memoFn()
    };
    return ref.current.value;
}
function $3fdad8fd02cd9507$var$useBaseQuery(query, options, lazy) {
    if (lazy === void 0) lazy = false;
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useReducer)(function(x) {
        return x + 1;
    }, 0), tick = _a[0], forceUpdate = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        query: query
    }) : {
        query: query
    };
    var queryDataRef = (0, $5uXOq.useRef)();
    if (!queryDataRef.current) queryDataRef.current = new $3fdad8fd02cd9507$var$QueryData({
        options: updatedOptions,
        context: context,
        forceUpdate: forceUpdate
    });
    var queryData = queryDataRef.current;
    queryData.setOptions(updatedOptions);
    queryData.context = context;
    var memo = {
        options: (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, updatedOptions), {
            onError: undefined,
            onCompleted: undefined
        }),
        context: context,
        tick: tick
    };
    var result = $3fdad8fd02cd9507$var$useDeepMemo(function() {
        return lazy ? queryData.executeLazy() : queryData.execute();
    }, memo);
    var queryResult = lazy ? result[1] : result;
    (0, $5uXOq.useEffect)(function() {
        return queryData.afterExecute({
            lazy: lazy
        });
    }, [
        queryResult.loading,
        queryResult.networkStatus,
        queryResult.error,
        queryResult.data
    ]);
    (0, $5uXOq.useEffect)(function() {
        return function() {
            return queryData.cleanup();
        };
    }, []);
    return result;
}
function $3fdad8fd02cd9507$export$dd0a697e1782aedd(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, false);
}
function $3fdad8fd02cd9507$export$fd83eea6ecd2d8fa(query, options) {
    return $3fdad8fd02cd9507$var$useBaseQuery(query, options, true);
}
var $3fdad8fd02cd9507$var$MutationData = function(_super) {
    (0, $3VFsf.__extends)(MutationData, _super);
    function MutationData(_a) {
        var options = _a.options, context = _a.context, result = _a.result, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.runMutation = function(mutationFunctionOptions) {
            if (mutationFunctionOptions === void 0) mutationFunctionOptions = {};
            _this.onMutationStart();
            var mutationId = _this.generateNewMutationId();
            return _this.mutate(mutationFunctionOptions).then(function(response) {
                _this.onMutationCompleted(response, mutationId);
                return response;
            }).catch(function(error) {
                _this.onMutationError(error, mutationId);
                if (!_this.getOptions().onError) throw error;
            });
        };
        _this.verifyDocumentType(options.mutation, (0, $bvsgq.DocumentType).Mutation);
        _this.result = result;
        _this.setResult = setResult;
        _this.mostRecentMutationId = 0;
        return _this;
    }
    MutationData.prototype.execute = function(result) {
        this.isMounted = true;
        this.verifyDocumentType(this.getOptions().mutation, (0, $bvsgq.DocumentType).Mutation);
        result.client = this.refreshClient().client;
        return [
            this.runMutation,
            result
        ];
    };
    MutationData.prototype.afterExecute = function() {
        this.isMounted = true;
        return this.unmount.bind(this);
    };
    MutationData.prototype.cleanup = function() {};
    MutationData.prototype.mutate = function(mutationFunctionOptions) {
        var _a = this.getOptions(), mutation = _a.mutation, variables = _a.variables, optimisticResponse = _a.optimisticResponse, update = _a.update, _b = _a.context, mutationContext = _b === void 0 ? {} : _b, _c = _a.awaitRefetchQueries, awaitRefetchQueries = _c === void 0 ? false : _c, fetchPolicy = _a.fetchPolicy;
        var mutateOptions = (0, $3VFsf.__assign)({}, mutationFunctionOptions);
        var mutateVariables = Object.assign({}, variables, mutateOptions.variables);
        delete mutateOptions.variables;
        return this.refreshClient().client.mutate((0, $3VFsf.__assign)({
            mutation: mutation,
            optimisticResponse: optimisticResponse,
            refetchQueries: mutateOptions.refetchQueries || this.getOptions().refetchQueries,
            awaitRefetchQueries: awaitRefetchQueries,
            update: update,
            context: mutationContext,
            fetchPolicy: fetchPolicy,
            variables: mutateVariables
        }, mutateOptions));
    };
    MutationData.prototype.onMutationStart = function() {
        if (!this.result.loading && !this.getOptions().ignoreResults) this.updateResult({
            loading: true,
            error: undefined,
            data: undefined,
            called: true
        });
    };
    MutationData.prototype.onMutationCompleted = function(response, mutationId) {
        var _a = this.getOptions(), onCompleted = _a.onCompleted, ignoreResults = _a.ignoreResults;
        var data = response.data, errors = response.errors;
        var error = errors && errors.length > 0 ? new (0, $e3a3O.ApolloError)({
            graphQLErrors: errors
        }) : undefined;
        var callOncomplete = function() {
            return onCompleted ? onCompleted(data) : null;
        };
        if (this.isMostRecentMutation(mutationId) && !ignoreResults) this.updateResult({
            called: true,
            loading: false,
            data: data,
            error: error
        });
        callOncomplete();
    };
    MutationData.prototype.onMutationError = function(error, mutationId) {
        var onError = this.getOptions().onError;
        if (this.isMostRecentMutation(mutationId)) this.updateResult({
            loading: false,
            error: error,
            data: undefined,
            called: true
        });
        if (onError) onError(error);
    };
    MutationData.prototype.generateNewMutationId = function() {
        return ++this.mostRecentMutationId;
    };
    MutationData.prototype.isMostRecentMutation = function(mutationId) {
        return this.mostRecentMutationId === mutationId;
    };
    MutationData.prototype.updateResult = function(result) {
        if (this.isMounted && (!this.previousResult || !(0, $bqMzA.equal)(this.previousResult, result))) {
            this.setResult(result);
            this.previousResult = result;
        }
    };
    return MutationData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$609860bf8b0084c(mutation, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var _a = (0, $5uXOq.useState)({
        called: false,
        loading: false
    }), result = _a[0], setResult = _a[1];
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        mutation: mutation
    }) : {
        mutation: mutation
    };
    var mutationDataRef = (0, $5uXOq.useRef)();
    function getMutationDataRef() {
        if (!mutationDataRef.current) mutationDataRef.current = new $3fdad8fd02cd9507$var$MutationData({
            options: updatedOptions,
            context: context,
            result: result,
            setResult: setResult
        });
        return mutationDataRef.current;
    }
    var mutationData = getMutationDataRef();
    mutationData.setOptions(updatedOptions);
    mutationData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return mutationData.afterExecute();
    });
    return mutationData.execute(result);
}
var $3fdad8fd02cd9507$var$SubscriptionData = function(_super) {
    (0, $3VFsf.__extends)(SubscriptionData, _super);
    function SubscriptionData(_a) {
        var options = _a.options, context = _a.context, setResult = _a.setResult;
        var _this = _super.call(this, options, context) || this;
        _this.currentObservable = {};
        _this.setResult = setResult;
        _this.initialize(options);
        return _this;
    }
    SubscriptionData.prototype.execute = function(result) {
        if (this.getOptions().skip === true) {
            this.cleanup();
            return {
                loading: false,
                error: undefined,
                data: undefined,
                variables: this.getOptions().variables
            };
        }
        var currentResult = result;
        if (this.refreshClient().isNew) currentResult = this.getLoadingResult();
        var shouldResubscribe = this.getOptions().shouldResubscribe;
        if (typeof shouldResubscribe === 'function') shouldResubscribe = !!shouldResubscribe(this.getOptions());
        if (shouldResubscribe !== false && this.previousOptions && Object.keys(this.previousOptions).length > 0 && (this.previousOptions.subscription !== this.getOptions().subscription || !(0, $bqMzA.equal)(this.previousOptions.variables, this.getOptions().variables) || this.previousOptions.skip !== this.getOptions().skip)) {
            this.cleanup();
            currentResult = this.getLoadingResult();
        }
        this.initialize(this.getOptions());
        this.startSubscription();
        this.previousOptions = this.getOptions();
        return (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, currentResult), {
            variables: this.getOptions().variables
        });
    };
    SubscriptionData.prototype.afterExecute = function() {
        this.isMounted = true;
    };
    SubscriptionData.prototype.cleanup = function() {
        this.endSubscription();
        delete this.currentObservable.query;
    };
    SubscriptionData.prototype.initialize = function(options) {
        if (this.currentObservable.query || this.getOptions().skip === true) return;
        this.currentObservable.query = this.refreshClient().client.subscribe({
            query: options.subscription,
            variables: options.variables,
            fetchPolicy: options.fetchPolicy
        });
    };
    SubscriptionData.prototype.startSubscription = function() {
        if (this.currentObservable.subscription) return;
        this.currentObservable.subscription = this.currentObservable.query.subscribe({
            next: this.updateCurrentData.bind(this),
            error: this.updateError.bind(this),
            complete: this.completeSubscription.bind(this)
        });
    };
    SubscriptionData.prototype.getLoadingResult = function() {
        return {
            loading: true,
            error: undefined,
            data: undefined
        };
    };
    SubscriptionData.prototype.updateResult = function(result) {
        if (this.isMounted) this.setResult(result);
    };
    SubscriptionData.prototype.updateCurrentData = function(result) {
        var onSubscriptionData = this.getOptions().onSubscriptionData;
        this.updateResult({
            data: result.data,
            loading: false,
            error: undefined
        });
        if (onSubscriptionData) onSubscriptionData({
            client: this.refreshClient().client,
            subscriptionData: result
        });
    };
    SubscriptionData.prototype.updateError = function(error) {
        this.updateResult({
            error: error,
            loading: false
        });
    };
    SubscriptionData.prototype.completeSubscription = function() {
        var onSubscriptionComplete = this.getOptions().onSubscriptionComplete;
        if (onSubscriptionComplete) onSubscriptionComplete();
        this.endSubscription();
    };
    SubscriptionData.prototype.endSubscription = function() {
        if (this.currentObservable.subscription) {
            this.currentObservable.subscription.unsubscribe();
            delete this.currentObservable.subscription;
        }
    };
    return SubscriptionData;
}($3fdad8fd02cd9507$var$OperationData);
function $3fdad8fd02cd9507$export$368b4214baeb914c(subscription, options) {
    var context = (0, $5uXOq.useContext)((0, $bvsgq.getApolloContext)());
    var updatedOptions = options ? (0, $3VFsf.__assign)((0, $3VFsf.__assign)({}, options), {
        subscription: subscription
    }) : {
        subscription: subscription
    };
    var _a = (0, $5uXOq.useState)({
        loading: !updatedOptions.skip,
        error: undefined,
        data: undefined
    }), result = _a[0], setResult = _a[1];
    var subscriptionDataRef = (0, $5uXOq.useRef)();
    function getSubscriptionDataRef() {
        if (!subscriptionDataRef.current) subscriptionDataRef.current = new $3fdad8fd02cd9507$var$SubscriptionData({
            options: updatedOptions,
            context: context,
            setResult: setResult
        });
        return subscriptionDataRef.current;
    }
    var subscriptionData = getSubscriptionDataRef();
    subscriptionData.setOptions(updatedOptions, true);
    subscriptionData.context = context;
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.afterExecute();
    });
    (0, $5uXOq.useEffect)(function() {
        return subscriptionData.cleanup.bind(subscriptionData);
    }, []);
    return subscriptionData.execute(result);
}
function $3fdad8fd02cd9507$export$eb9a56e7a29e494() {
    var client = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $bvsgq.getApolloContext)()).client;
    (0, $1DiV8.invariant)(client, 1);
    return client;
}
function $3fdad8fd02cd9507$var$makeDefaultQueryInfo() {
    return {
        seen: false,
        observable: null
    };
}
var $3fdad8fd02cd9507$export$260e90e395a79974 = function() {
    function RenderPromises() {
        this.queryPromises = new Map();
        this.queryInfoTrie = new Map();
    }
    RenderPromises.prototype.registerSSRObservable = function(observable, props) {
        this.lookupQueryInfo(props).observable = observable;
    };
    RenderPromises.prototype.getSSRObservable = function(props) {
        return this.lookupQueryInfo(props).observable;
    };
    RenderPromises.prototype.addQueryPromise = function(queryInstance, finish) {
        var info = this.lookupQueryInfo(queryInstance.getOptions());
        if (!info.seen) {
            this.queryPromises.set(queryInstance.getOptions(), new Promise(function(resolve) {
                resolve(queryInstance.fetchData());
            }));
            return null;
        }
        return finish();
    };
    RenderPromises.prototype.hasPromises = function() {
        return this.queryPromises.size > 0;
    };
    RenderPromises.prototype.consumeAndAwaitPromises = function() {
        var _this = this;
        var promises = [];
        this.queryPromises.forEach(function(promise, queryInstance) {
            _this.lookupQueryInfo(queryInstance).seen = true;
            promises.push(promise);
        });
        this.queryPromises.clear();
        return Promise.all(promises);
    };
    RenderPromises.prototype.lookupQueryInfo = function(props) {
        var queryInfoTrie = this.queryInfoTrie;
        var query = props.query, variables = props.variables;
        var varMap = queryInfoTrie.get(query) || new Map();
        if (!queryInfoTrie.has(query)) queryInfoTrie.set(query, varMap);
        var variablesString = JSON.stringify(variables);
        var info = varMap.get(variablesString) || $3fdad8fd02cd9507$var$makeDefaultQueryInfo();
        if (!varMap.has(variablesString)) varMap.set(variablesString, info);
        return info;
    };
    return RenderPromises;
}();

});



parcelRegister("4G04L", function(module, exports) {

$parcel$export(module.exports, "scheduleAfterRender", () => $2060ab97dc501826$export$a845aafd0a0e29e6);

var $gg6CF = parcelRequire("gg6CF");

var $6cAn5 = parcelRequire("6cAn5");
const $2060ab97dc501826$export$a845aafd0a0e29e6 = (callback)=>{
    if ($gg6CF && $gg6CF.unstable_scheduleCallback) // Wait a tick for renders that will still be scheduled on this event-loop tick.
    $6cAn5.nextTick(()=>{
        try {
            // Schedule an idle priority callback with react's scheduler.
            $gg6CF.unstable_scheduleCallback($gg6CF.unstable_IdlePriority, ()=>{
                callback();
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // React.js' lower priority is at minimum 0ms or a postMessage tick.
            // Waiting 1ms seems to be a good enough approximation to run after that.
            setTimeout(()=>{
                callback();
            }, 1);
        }
    });
    else setTimeout(()=>{
        callback();
    }, 1);
};

});

parcelRegister("hz3OZ", function(module, exports) {

$parcel$export(module.exports, "nextGenBoardPageLoad", () => $f8931d5d75ce11bd$export$4b801a62907d6b94);
$parcel$export(module.exports, "uifBoardNewUiPageLoad", () => $f8931d5d75ce11bd$export$f1b77d03d220d9bf);
$parcel$export(module.exports, "incrementPlanningBoardPageLoad", () => $f8931d5d75ce11bd$export$c86a9609fe658c66);
$parcel$export(module.exports, "issueViewOpenInteraction", () => $f8931d5d75ce11bd$export$412ac2e825a54154);
$parcel$export(module.exports, "issueCreateInteraction", () => $f8931d5d75ce11bd$export$be312698838f27be);
$parcel$export(module.exports, "issueDeleteInteraction", () => $f8931d5d75ce11bd$export$1b8cf3f3c2894329);
$parcel$export(module.exports, "issueRankAndTransitionInteraction", () => $f8931d5d75ce11bd$export$2e13f822f1d07fc6);
$parcel$export(module.exports, "flagToggleInteraction", () => $f8931d5d75ce11bd$export$6c532396e24c45e7);
$parcel$export(module.exports, "assignToMeInteraction", () => $f8931d5d75ce11bd$export$79f93553011c8d54);
$parcel$export(module.exports, "cardsClearInteraction", () => $f8931d5d75ce11bd$export$fa7a624cdb34cdd3);
$parcel$export(module.exports, "cardsUnclearInteraction", () => $f8931d5d75ce11bd$export$9bc31a8417066b8d);
$parcel$export(module.exports, "filterInteraction", () => $f8931d5d75ce11bd$export$8decf314e9f3b4a0);
$parcel$export(module.exports, "editSprintModalLoad", () => $f8931d5d75ce11bd$export$c39d6b5415c8a491);
$parcel$export(module.exports, "customFilterInteraction", () => $f8931d5d75ce11bd$export$ae56111e009a2b76);
$parcel$export(module.exports, "devStatusLoadInteraction", () => $f8931d5d75ce11bd$export$1adf9bab2b71f504);

var $dGrdR = parcelRequire("dGrdR");

const $f8931d5d75ce11bd$export$9fc6070c69058000 = 4000;
const $f8931d5d75ce11bd$export$f984a7a89ddef798 = 8000;
const $f8931d5d75ce11bd$var$SLO_FMP = 4000;
const $f8931d5d75ce11bd$export$3a8025f2f3e0c64 = {
    EARLY_FETCH_START: 'EARLY_FETCH_START',
    EARLY_FETCH_END: 'EARLY_FETCH_END'
};
const $f8931d5d75ce11bd$var$NEXT_GEN_BOARD = 'next-gen-board';
const $f8931d5d75ce11bd$var$UIF_BOARD_NEW_UI = 'classic-board';
const $f8931d5d75ce11bd$var$INCREMENT_PLANNING_BOARD = 'increment-planning-board';
const $f8931d5d75ce11bd$var$boardPageLoad = (key)=>(0, $dGrdR.metrics).pageLoad({
        key: key,
        featureFlags: [],
        ssr: {
            doneAsFmp: true
        },
        slo: {
            fmp: {
                initial: {
                    threshold: $f8931d5d75ce11bd$var$SLO_FMP
                },
                transition: {
                    threshold: $f8931d5d75ce11bd$var$SLO_FMP
                }
            },
            tti: {
                initial: {
                    threshold: $f8931d5d75ce11bd$export$f984a7a89ddef798
                },
                transition: {
                    threshold: $f8931d5d75ce11bd$export$f984a7a89ddef798
                }
            }
        },
        timings: [
            {
                key: 'early-fetch',
                startMark: $f8931d5d75ce11bd$export$3a8025f2f3e0c64.EARLY_FETCH_START,
                endMark: $f8931d5d75ce11bd$export$3a8025f2f3e0c64.EARLY_FETCH_END
            },
            {
                key: (0, $ce556f125dee8174$export$48552baa9db8ce1d),
                endMark: (0, $ce556f125dee8174$export$99c08ec92759c71c)
            }
        ]
    });
const $f8931d5d75ce11bd$export$4b801a62907d6b94 = $f8931d5d75ce11bd$var$boardPageLoad($f8931d5d75ce11bd$var$NEXT_GEN_BOARD);
const $f8931d5d75ce11bd$export$f1b77d03d220d9bf = $f8931d5d75ce11bd$var$boardPageLoad($f8931d5d75ce11bd$var$UIF_BOARD_NEW_UI);
const $f8931d5d75ce11bd$export$c86a9609fe658c66 = $f8931d5d75ce11bd$var$boardPageLoad($f8931d5d75ce11bd$var$INCREMENT_PLANNING_BOARD);
const $f8931d5d75ce11bd$export$412ac2e825a54154 = (0, $dGrdR.metrics).interaction({
    key: 'board.issue-view-open',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_250_300'
    },
    timings: [
        {
            key: 'feedbackPreMount',
            endMark: 'feedbackPreMountEnd'
        }
    ]
});
const $f8931d5d75ce11bd$export$be312698838f27be = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.issue-create',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_300_500'
    }
});
const $f8931d5d75ce11bd$export$1b8cf3f3c2894329 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.issue-delete'
});
const $f8931d5d75ce11bd$export$2e13f822f1d07fc6 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.issue-rank-and-transition',
    histogram: {
        result: '500_1000_1100_1200_1300_1400_1500_2000',
        response: '50_100_150_200_300_500'
    }
});
const $f8931d5d75ce11bd$export$6c532396e24c45e7 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.flag-toggle',
    histogram: {
        result: '1000_2000_3000_4000_5000_6000',
        response: '50_100_150_200_300_500'
    }
});
const $f8931d5d75ce11bd$export$79f93553011c8d54 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.assign-to-me',
    histogram: {
        result: '500_1000_2000_3000_4000',
        response: '200_300_400_500_1000_2000'
    }
});
const $f8931d5d75ce11bd$export$fa7a624cdb34cdd3 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.cards-clear',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.result]' is missing in type '{ response: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        response: '50_100_150_200_300_400_500'
    }
});
const $f8931d5d75ce11bd$export$9bc31a8417066b8d = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.cards-unclear',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.result]' is missing in type '{ response: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        response: '50_100_150_200_300_400_500'
    }
});
const $f8931d5d75ce11bd$export$8decf314e9f3b4a0 = (0, $dGrdR.metrics).interaction({
    key: 'board.filter'
});
const $f8931d5d75ce11bd$export$c39d6b5415c8a491 = (0, $dGrdR.metrics).interaction({
    key: 'edit-sprint-modal-load'
});
const $f8931d5d75ce11bd$export$ae56111e009a2b76 = (0, $dGrdR.metrics).interaction({
    key: 'board.custom-filter',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_1500_2000_2500_3000_3500_4000'
    }
});
const $f8931d5d75ce11bd$export$1adf9bab2b71f504 = (0, $dGrdR.metrics).concurrent.interaction({
    key: 'board.dev-status-load',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2000_3000_4000_5000_6000_7000_8000'
    }
});

});

parcelRegister("cAxle", function(module, exports) {

$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST", () => $11e64ffb6a72261e$export$4a7b4d6811230566);
$parcel$export(module.exports, "assignToMeRequest", () => $11e64ffb6a72261e$export$e2776354d9221c82);
$parcel$export(module.exports, "ASSIGN_TO_ME_REQUEST_THROTTLED", () => $11e64ffb6a72261e$export$f241ab4d2fe8b61e);
$parcel$export(module.exports, "assignToMeRequestThrottled", () => $11e64ffb6a72261e$export$13bfccdb4d681951);
$parcel$export(module.exports, "assignToMeSucess", () => $11e64ffb6a72261e$export$163b3f2e6c6f331d);
$parcel$export(module.exports, "assignToMeFailure", () => $11e64ffb6a72261e$export$50fd16f97611da56);

var $9rND4 = parcelRequire("9rND4");
const $11e64ffb6a72261e$export$4a7b4d6811230566 = 'state.actions.issue.assign-to-me.ASSIGN_TO_ME_REQUEST';
const $11e64ffb6a72261e$export$e2776354d9221c82 = ({ issueId: issueId, assigneeAccountId: assigneeAccountId, concurrentId: concurrentId, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn })=>({
        type: $11e64ffb6a72261e$export$4a7b4d6811230566,
        payload: {
            issueId: issueId,
            assigneeAccountId: assigneeAccountId,
            concurrentId: concurrentId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $11e64ffb6a72261e$export$f241ab4d2fe8b61e = 'state.actions.issue.assign-to-me.ASSIGN_TO_ME_REQUEST_THROTTLED';
const $11e64ffb6a72261e$export$13bfccdb4d681951 = (issueId, assigneeAccountId, fireShortcutAnalyticsFn)=>({
        type: $11e64ffb6a72261e$export$f241ab4d2fe8b61e,
        payload: {
            issueId: issueId,
            assigneeAccountId: assigneeAccountId,
            fireShortcutAnalyticsFn: fireShortcutAnalyticsFn
        }
    });
const $11e64ffb6a72261e$export$1249a100986a9489 = 'state.actions.issue.assign-to-me.ASSIGN_TO_ME_SUCCESS';
const $11e64ffb6a72261e$export$163b3f2e6c6f331d = (optimisticId)=>({
        type: $11e64ffb6a72261e$export$1249a100986a9489,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $11e64ffb6a72261e$export$1ce003be5a9445ee = 'state.actions.issue.assign-to-me.ASSIGN_TO_ME_FAILURE';
const $11e64ffb6a72261e$export$50fd16f97611da56 = (optimisticId)=>({
        type: $11e64ffb6a72261e$export$1ce003be5a9445ee,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("c0Qhv", function(module, exports) {

$parcel$export(module.exports, "cardAutoScrollOnLoadEpic", () => $3053e82f3445748a$export$b3fa7f35f3b0229c);
$parcel$export(module.exports, "cardAutoScrollOnFilterEpic", () => $3053e82f3445748a$export$1eee00ad491917f1);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("aSIuP");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $d1i1b = parcelRequire("d1i1b");

var $2f454 = parcelRequire("2f454");

var $cW3pH = parcelRequire("cW3pH");

var $9OPlz = parcelRequire("9OPlz");

var $d2i8f = parcelRequire("d2i8f");
const $3053e82f3445748a$export$b3fa7f35f3b0229c = (action$, store)=>(0, $kVLXA.Observable).zip(action$.ofType((0, $d1i1b.CARD_AUTO_SCROLL_REQUEST_ON_LOAD)), action$.ofType((0, $cW3pH.WORK_DATA_SET))).flatMap(([action])=>{
        const state = store.getState();
        const issueId = (0, $d2i8f.getIssueByKey)(state, action.payload.issueKey)?.id;
        return issueId ? (0, $kVLXA.Observable).from([
            (0, $2f454.cardSingleSelect)(issueId),
            (0, $d1i1b.cardAutoScroll)(issueId)
        ]) : (0, $kVLXA.Observable).empty();
    });
const $3053e82f3445748a$export$1eee00ad491917f1 = (action$, store)=>action$.ofType((0, $d1i1b.CARD_AUTO_SCROLL_REQUEST_ON_FILTER)).mergeMap(()=>{
        const state = store.getState();
        const selectedIssueId = (0, $9OPlz.getCardSelection)(state)[0];
        return selectedIssueId ? (0, $kVLXA.Observable).from([
            (0, $d1i1b.cardAutoScroll)(selectedIssueId)
        ]) : (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("7COzu", function(module, exports) {

$parcel$export(module.exports, "cardChangeTeamEpic", () => $623e6dcd2ed75595$export$7d0d92f19a76b6f4);
parcelRequire("fp4O3");
parcelRequire("aSIuP");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $kVLXA = parcelRequire("kVLXA");

var $3spCR = parcelRequire("3spCR");

var $3vq48 = parcelRequire("3vq48");

var $5UXId = parcelRequire("5UXId");

var $vAfHD = parcelRequire("vAfHD");

var $k50Aq = parcelRequire("k50Aq");

var $cPGP0 = parcelRequire("cPGP0");
function $623e6dcd2ed75595$export$77b9245dd5cde151(store, action) {
    const state = store.getState();
    const { sourceSwimlaneId: sourceSwimlaneId, destinationColumnId: destinationColumnId, destinationSwimlaneId: destinationSwimlaneId, issueIds: issueIds } = action.payload;
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issue = allIssues[String(issueIds[0])];
    const teamSprintsForIterations = (0, $cPGP0.getTeamSprintsForIterations)(state, destinationSwimlaneId);
    if (teamSprintsForIterations) {
        const sprint = teamSprintsForIterations[destinationColumnId];
        const isClosedSprint = sprint && sprint.state === (0, $3spCR.SPRINT_STATES).CLOSED;
        const movingToClosedSprintColumn = sourceSwimlaneId !== destinationSwimlaneId && isClosedSprint;
        if (movingToClosedSprintColumn) return (0, $kVLXA.Observable).of((0, $k50Aq.swimlaneColumnClosedSprintInvalidMove)(sprint.name, issue));
    }
    return (0, $kVLXA.Observable).of((0, $5UXId.issueRankTeamDateRequest)(action.payload));
}
function $623e6dcd2ed75595$export$7d0d92f19a76b6f4(action$, store) {
    return action$.ofType((0, $3vq48.ISSUE_CHANGE_TEAM_REQUEST)).mergeMap((action)=>$623e6dcd2ed75595$export$77b9245dd5cde151(store, action));
}

});
parcelRegister("3vq48", function(module, exports) {

$parcel$export(module.exports, "ISSUE_CHANGE_TEAM_REQUEST", () => $34f35c73a61123a4$export$c0a4cd5a1c65021);
$parcel$export(module.exports, "issueChangeTeamRequest", () => $34f35c73a61123a4$export$706aef2f190eaf8c);
const $34f35c73a61123a4$export$c0a4cd5a1c65021 = 'state.actions.issue.change-team.ISSUE_CHANGE_TEAM_REQUEST';
const $34f35c73a61123a4$export$706aef2f190eaf8c = ({ issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId })=>({
        type: $34f35c73a61123a4$export$c0a4cd5a1c65021,
        payload: {
            issueIds: issueIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId
        }
    });

});

parcelRegister("5UXId", function(module, exports) {

$parcel$export(module.exports, "ISSUE_RANK_TEAM_DATE_REQUEST", () => $4a74d8cfa0217593$export$f770861e1cd0420f);
$parcel$export(module.exports, "issueRankTeamDateRequest", () => $4a74d8cfa0217593$export$50d3ae9d4842cf2f);
$parcel$export(module.exports, "issueTeamDateRankSuccess", () => $4a74d8cfa0217593$export$9c1e4663f2a01a9c);
$parcel$export(module.exports, "issueTeamDateRankFailure", () => $4a74d8cfa0217593$export$c47a6d27a78c3859);

var $6s1PB = parcelRequire("6s1PB");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $4a74d8cfa0217593$export$f770861e1cd0420f = 'state.actions.issue.rank-team-date.ISSUE_RANK_TEAM_DATE_REQUEST';
const $4a74d8cfa0217593$export$50d3ae9d4842cf2f = ({ issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId })=>({
        type: $4a74d8cfa0217593$export$f770861e1cd0420f,
        payload: {
            issueIds: issueIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId
        }
    });
const $4a74d8cfa0217593$export$dcd2925734ee2c83 = 'state.actions.issue.rank-team-date.ISSUE_TEAM_DATE_RANK_SUCCESS';
const $4a74d8cfa0217593$export$9c1e4663f2a01a9c = ()=>({
        type: $4a74d8cfa0217593$export$dcd2925734ee2c83
    });
const $4a74d8cfa0217593$export$d5394c28a5cea4c4 = 'state.actions.issue.rank-team-date.ISSUE_TEAM_DATE_RANK_FAILURE';
const $4a74d8cfa0217593$export$c47a6d27a78c3859 = (issue)=>{
    const titleMessage = (()=>{
        // display issueType details only when it is present
        if (issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $7AVqz.default).cardMoveFailureInIpBoardTitleNoTranslateIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $7AVqz.default).cardMoveFailureInIpBoardTitleNoTranslateIssueTermRefresh;
        return (0, $7AVqz.default).cardMoveFailureInIpBoardTitleNoTranslate;
    })();
    const descriptionMessage = (()=>{
        // display issueType details only when it is present
        if (issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $7AVqz.default).cardMoveFailureInIpBoardMessageNoTranslateIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $7AVqz.default).cardMoveFailureInIpBoardMessageNoTranslateIssueTermRefresh;
        return (0, $7AVqz.default).cardMoveFailureInIpBoardMessageNoTranslate;
    })();
    return {
        type: $4a74d8cfa0217593$export$d5394c28a5cea4c4,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: titleMessage,
            descriptionMessage: descriptionMessage,
            ...issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false) ? {
                context: {
                    workType: issue.typeName
                }
            } : {}
        })
    };
};

});

parcelRegister("k50Aq", function(module, exports) {

$parcel$export(module.exports, "SWIMLANE_JQL_SET_DATA", () => $2b7bae92bddec112$export$96fac0fff9ed98fe);
$parcel$export(module.exports, "swimlaneJqlSetDataRequest", () => $2b7bae92bddec112$export$b01f1b1d735934ac);
$parcel$export(module.exports, "SWIMLANE_MODE_CHANGE_REQUEST", () => $2b7bae92bddec112$export$5fc9250064496098);
$parcel$export(module.exports, "swimlaneModeChangeRequest", () => $2b7bae92bddec112$export$a1284c964c572f87);
$parcel$export(module.exports, "swimlaneModeChangeSuccess", () => $2b7bae92bddec112$export$4b06b30aca7a7a1e);
$parcel$export(module.exports, "swimlaneModeChangeFailure", () => $2b7bae92bddec112$export$197c20a7a0293523);
$parcel$export(module.exports, "SWIMLANE_TOGGLE", () => $2b7bae92bddec112$export$69ae1c228ec01051);
$parcel$export(module.exports, "swimlaneToggle", () => $2b7bae92bddec112$export$df1a2052b3e720d8);
$parcel$export(module.exports, "SWIMLANES_TOGGLE", () => $2b7bae92bddec112$export$b3d0b922cac32f08);
$parcel$export(module.exports, "swimlanesToggle", () => $2b7bae92bddec112$export$e612403e1e93ac1d);
$parcel$export(module.exports, "SWIMLANES_COLLAPSE", () => $2b7bae92bddec112$export$2804c32308eeed21);
$parcel$export(module.exports, "swimlanesCollapse", () => $2b7bae92bddec112$export$8e93c288898e1510);
$parcel$export(module.exports, "SWIMLANES_EXPAND", () => $2b7bae92bddec112$export$ff13a00f585c347d);
$parcel$export(module.exports, "swimlanesExpand", () => $2b7bae92bddec112$export$e04c42f829645718);
$parcel$export(module.exports, "teamSwimLaneInvalidMove", () => $2b7bae92bddec112$export$933859197afb7512);
$parcel$export(module.exports, "swimlaneColumnClosedSprintInvalidMove", () => $2b7bae92bddec112$export$8547552d002c47e0);

var $6s1PB = parcelRequire("6s1PB");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $2b7bae92bddec112$export$96fac0fff9ed98fe = 'state.actions.swimlane.SWIMLANE_JQL_SET_DATA';
const $2b7bae92bddec112$export$b01f1b1d735934ac = (swimlanes)=>({
        type: $2b7bae92bddec112$export$96fac0fff9ed98fe,
        payload: swimlanes
    });
const $2b7bae92bddec112$export$5fc9250064496098 = 'state.actions.swimlane.SWIMLANE_MODE_CHANGE_REQUEST';
const $2b7bae92bddec112$export$a1284c964c572f87 = (mode)=>({
        type: $2b7bae92bddec112$export$5fc9250064496098,
        payload: mode,
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $2b7bae92bddec112$export$f8c4c2f4cf453bae = 'state.actions.swimlane.SWIMLANE_MODE_CHANGE_SUCCESS';
const $2b7bae92bddec112$export$4b06b30aca7a7a1e = (optimisticId)=>({
        type: $2b7bae92bddec112$export$f8c4c2f4cf453bae,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $2b7bae92bddec112$export$335af86bff4f19e8 = 'state.actions.swimlane.SWIMLANE_MODE_CHANGE_FAILURE';
const $2b7bae92bddec112$export$197c20a7a0293523 = (optimisticId)=>({
        type: $2b7bae92bddec112$export$335af86bff4f19e8,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });
const $2b7bae92bddec112$export$69ae1c228ec01051 = 'state.actions.swimlane.SWIMLANE_TOGGLE';
const $2b7bae92bddec112$export$df1a2052b3e720d8 = (id)=>({
        type: $2b7bae92bddec112$export$69ae1c228ec01051,
        payload: id
    });
const $2b7bae92bddec112$export$b3d0b922cac32f08 = 'state.actions.swimlane.SWIMLANES_TOGGLE';
const $2b7bae92bddec112$export$e612403e1e93ac1d = (ids)=>({
        type: $2b7bae92bddec112$export$b3d0b922cac32f08,
        payload: ids
    });
const $2b7bae92bddec112$export$2804c32308eeed21 = 'state.actions.swimlane.SWIMLANES_COLLAPSE';
const $2b7bae92bddec112$export$8e93c288898e1510 = (ids)=>({
        type: $2b7bae92bddec112$export$2804c32308eeed21,
        payload: ids
    });
const $2b7bae92bddec112$export$ff13a00f585c347d = 'state.actions.swimlane.SWIMLANES_EXPAND';
const $2b7bae92bddec112$export$e04c42f829645718 = ()=>({
        type: $2b7bae92bddec112$export$ff13a00f585c347d
    });
const $2b7bae92bddec112$export$7bae716e6e950a58 = 'state.actions.swimlane.TEAM_SWIMLANE_INVALID_MOVE';
const $2b7bae92bddec112$export$933859197afb7512 = (teamName, issue)=>{
    const titleMessage = (()=>{
        // display issueType details only when it is present
        if (issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $7AVqz.default).teamSwimlaneMoveInvalidTitleIssueTerminologyRefreshM4;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).teamSwimlaneMoveInvalidTitleIssueTermRefresh : (0, $7AVqz.default).teamSwimlaneMoveInvalidTitle;
    })();
    return {
        type: $2b7bae92bddec112$export$7bae716e6e950a58,
        meta: (0, $sdxnu.errorFlagMeta)({
            id: $2b7bae92bddec112$export$7bae716e6e950a58,
            context: {
                teamName: teamName,
                ...issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false) ? {
                    workType: issue.typeName,
                    issueKey: issue.key
                } : {}
            },
            titleMessage: titleMessage,
            descriptionMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).teamSwimlaneMoveInvalidMessageIssueTermRefresh : (0, $7AVqz.default).teamSwimlaneMoveInvalidMessage
        })
    };
};
const $2b7bae92bddec112$export$ea34e094caf902a = 'state.actions.swimlane.SWIMLANE_COLUMN_CLOSED_SPRINT_INVALID_MOVE';
const $2b7bae92bddec112$export$8547552d002c47e0 = (sprintName, issue)=>{
    const titleMessage = (()=>{
        // display issueType details only when it is present
        if (issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $7AVqz.default).swimlaneColumnClosedSprintInvalidMoveTitleIssueTerminologyRefreshM4;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).swimlaneColumnClosedSprintInvalidMoveTitleIssueTermRefresh : (0, $7AVqz.default).swimlaneColumnClosedSprintInvalidMoveTitle;
    })();
    return {
        type: $2b7bae92bddec112$export$ea34e094caf902a,
        meta: (0, $sdxnu.errorFlagMeta)({
            id: $2b7bae92bddec112$export$ea34e094caf902a,
            context: {
                sprintName: sprintName,
                ...issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false) ? {
                    workType: issue.typeName,
                    issueKey: issue.key
                } : {}
            },
            titleMessage: titleMessage,
            descriptionMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).swimlaneColumnClosedSprintInvalidMoveMessageIssueTermRefresh : (0, $7AVqz.default).swimlaneColumnClosedSprintInvalidMoveMessage
        })
    };
};

});


parcelRegister("f72yS", function(module, exports) {

$parcel$export(module.exports, "default", () => $55cee968a65092cc$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("jFVZ1");
parcelRequire("djSMA");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");


var $2f454 = parcelRequire("2f454");

var $cW3pH = parcelRequire("cW3pH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$55cee968a65092cc$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $2f454.CARD_CLEAR_UNDO)).mergeMap((action)=>{
        const { undoPromise: undoPromise, retry: retry, optimisticId: optimisticId } = action.payload;
        return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $2f454.cardClearRevert)(optimisticId)), (0, $kVLXA.Observable).fromPromise(undoPromise).takeWhile(()=>retry).map(()=>(0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8d3fdbb8c61d9d21))).catch(()=>(0, $kVLXA.Observable).of((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8d3fdbb8c61d9d21)))));
    });

});

parcelRegister("41QbH", function(module, exports) {

$parcel$export(module.exports, "default", () => $53398ea24e376224$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $2xFXk = parcelRequire("2xFXk");

var $2f454 = parcelRequire("2f454");

var $dW1HX = parcelRequire("dW1HX");

var $kc6Ry = parcelRequire("kc6Ry");

var $ptvay = parcelRequire("ptvay");

var $9OPlz = parcelRequire("9OPlz");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
function $53398ea24e376224$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $2f454.CARD_CLICK)).mergeMap((action)=>{
        const state = store.getState();
        const { issueId: issueId, withCmd: withCmd, withShift: withShift } = action.payload;
        if (withCmd) {
            const cardSelection = (0, $9OPlz.getCardSelection)(state);
            const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
            const isMultiSelectAcrossSwimlanesEnabled = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).MULTISELECT_CARD_ACROSS_SWIMLANES);
            const isAdding = cardSelection.indexOf(action.payload.issueId) === -1;
            // We only allow issues with the same column, swimlane and card type to be selected together in a CMP board
            if (isCMPBoard && cardSelection.length !== 0 && isAdding) {
                const getColumnIdByIssue = (0, $5mTgl.issueColumnIdSelector)(state);
                const getSwimlaneIdByIssue = (0, $5mTgl.issueSwimlaneIdSelector)(state);
                const isIssueAChild = (0, $vAfHD.isBoardIssueAChild)(state);
                const existingSelectedId = cardSelection[0];
                const sameColumnId = getColumnIdByIssue(existingSelectedId) === getColumnIdByIssue(issueId);
                const sameSwimlaneId = getSwimlaneIdByIssue(existingSelectedId) === getSwimlaneIdByIssue(issueId);
                const sameCardType = isIssueAChild(existingSelectedId) === isIssueAChild(issueId);
                const sameCardGroup = (0, $d2i8f.getIssueById)(state, existingSelectedId)?.parentId === (0, $d2i8f.getIssueById)(state, issueId).parentId;
                if (!sameColumnId || !sameSwimlaneId || !sameCardType || isIssueAChild(issueId) && !sameCardGroup) return (0, $kVLXA.Observable).empty();
            }
            // Don't allow issues in the same swimlane to be selected together when
            // MULTISELECT_CARD_ACROSS_SWIMLANES capability is false
            if (!isMultiSelectAcrossSwimlanesEnabled && cardSelection.length !== 0 && isAdding) {
                const getSwimlaneIdByIssue = (0, $5mTgl.issueSwimlaneIdSelector)(state);
                const existingSelectedId = cardSelection[0];
                const sameSwimlaneId = getSwimlaneIdByIssue(existingSelectedId) === getSwimlaneIdByIssue(issueId);
                if (!sameSwimlaneId) return (0, $kVLXA.Observable).empty();
            }
            return (0, $kVLXA.Observable).of((0, $2f454.cardToggleSelection)(issueId));
        }
        if (withShift) {
            const rangeSelection = (0, $ptvay.getCardShiftSelectionIds)(state)(issueId);
            if (rangeSelection) return (0, $kVLXA.Observable).of((0, $2f454.cardMultiSelect)(rangeSelection));
        }
        // open bento + select card
        const issue = (0, $d2i8f.getIssueById)(state, issueId);
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        if (isIncrementPlanningBoard) {
            if ((0, $4R6GH.fg)('issue_view_in_program_board')) return (0, $kVLXA.Observable).from([
                (0, $2f454.cardSingleSelect)(issueId),
                (0, $dW1HX.openPlanIssueModal)(issueId.toString())
            ]);
            (0, $kVLXA.Observable).from([
                (0, $2f454.cardSingleSelect)(issueId)
            ]);
        }
        return (0, $kVLXA.Observable).from([
            (0, $2f454.cardSingleSelect)(issueId),
            (0, $dW1HX.openIssueModal)(issue.key, action.payload.externalAction)
        ]);
    });
}

});
parcelRegister("ptvay", function(module, exports) {

$parcel$export(module.exports, "getCardShiftSelectionIds", () => $37b4bb4aa286c991$export$4ef555e4d871575f);

var $hGgHi = parcelRequire("hGgHi");

var $6dDSs = parcelRequire("6dDSs");

var $5mTgl = parcelRequire("5mTgl");

var $9OPlz = parcelRequire("9OPlz");
const $37b4bb4aa286c991$export$4ef555e4d871575f = (0, $6dDSs.createSelector)([
    (0, $9OPlz.getCardSelection),
    (0, $5mTgl.platformIssueSelector),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector)
], (cardSelection, getPlatformIssue, filteredIssuesByColumn, filteredIssuesBySwimlane)=>(issueId)=>{
        if (!cardSelection.length) return null;
        const lastCardId = cardSelection[cardSelection.length - 1];
        const lastCard = getPlatformIssue(lastCardId);
        const thisCard = getPlatformIssue(issueId);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(lastCard) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(thisCard) || lastCard.columnId !== thisCard.columnId || lastCard.swimlaneId !== thisCard.swimlaneId) return null;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(thisCard.swimlaneId)) // no swimlane
        return $37b4bb4aa286c991$var$rangeSelectWithinColumn(filteredIssuesByColumn[thisCard.columnId], lastCardId, issueId);
        // has swimlane
        return $37b4bb4aa286c991$var$rangeSelectWithinColumn(filteredIssuesBySwimlane[thisCard.swimlaneId][thisCard.columnId], lastCardId, issueId);
    });
const $37b4bb4aa286c991$var$rangeSelectWithinColumn = (orderedIssues, lastCardId, issueId)=>{
    const startIndex = orderedIssues.indexOf(lastCardId);
    const endIndex = orderedIssues.indexOf(issueId);
    return orderedIssues.slice(Math.min(startIndex, endIndex), Math.max(startIndex, endIndex) + 1);
};

});


parcelRegister("fGfXq", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd2c73dff3af8640$export$2e2bcd8739ae039);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("3awJm");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $d1i1b = parcelRequire("d1i1b");

var $2f454 = parcelRequire("2f454");

var $dW1HX = parcelRequire("dW1HX");

var $9OPlz = parcelRequire("9OPlz");

var $fqLDH = parcelRequire("fqLDH");

var $gR0bs = parcelRequire("gR0bs");

var $d2i8f = parcelRequire("d2i8f");
const $dd2c73dff3af8640$var$cardColumnNavigationEpic = (action$, store)=>action$.ofType((0, $2f454.CARD_NEXT_COLUMN), (0, $2f454.CARD_PREV_COLUMN)).throttleTime(200).mergeMap(({ type: type, payload: payload })=>{
        const state = store.getState();
        const activeCardId = (0, $9OPlz.getCardActive)(state);
        // Applying a filter or collapsing a swimlane does not clear the active card,
        // So we need to check manually if it is actually visible.
        const isActiveCardVisible = (0, $gR0bs.isActiveCardVisible)(state);
        const isCardNextColumn = type === (0, $2f454.CARD_NEXT_COLUMN);
        // The function to call when there's no card currently active
        const getFirstSelectableIssueFn = isCardNextColumn ? (0, $gR0bs.getFirstSelectableIssueInFirstColumn) : (0, $gR0bs.getFirstSelectableIssueInLastColumn);
        // The function to call when there's an active card
        const getNextOrPrevIssueFn = isCardNextColumn ? (0, $gR0bs.makeGetNeighbouringIssueInNextColumn) : (0, $gR0bs.makeGetNeighbouringIssueInPrevColumn);
        const newActiveIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || !isActiveCardVisible ? getFirstSelectableIssueFn(state) : getNextOrPrevIssueFn(state)(activeCardId);
        const attributes = isCardNextColumn ? {
            id: 'nextColumnKeyboardShortcut',
            key: 'n'
        } : {
            id: 'previousColumnKeyboardShortcut',
            key: 'p'
        };
        payload.fireShortcutAnalyticsFn(attributes);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(newActiveIssueId)) return (0, $kVLXA.Observable).empty();
        const actions = [
            (0, $2f454.cardSingleSelect)(newActiveIssueId),
            (0, $2f454.cardFocus)(newActiveIssueId),
            (0, $d1i1b.cardAutoScroll)(newActiveIssueId)
        ];
        if ((0, $fqLDH.isIssueModalShowingSelector)(state)) {
            const issueKey = (0, $d2i8f.getIssueById)(state, newActiveIssueId).key;
            actions.push((0, $dW1HX.openIssueModalDebounced)(issueKey));
        }
        return (0, $kVLXA.Observable).from(actions);
    });
var $dd2c73dff3af8640$export$2e2bcd8739ae039 = $dd2c73dff3af8640$var$cardColumnNavigationEpic;

});
parcelRegister("fqLDH", function(module, exports) {

$parcel$export(module.exports, "getIssueModal", () => $ca4d10cff4d8f2d0$export$d50a1e4d7624445f);
$parcel$export(module.exports, "getIssueKeyForModal", () => $ca4d10cff4d8f2d0$export$9865dacc0ccd6c8e);
$parcel$export(module.exports, "getTimestampForModal", () => $ca4d10cff4d8f2d0$export$b858c74a94f5e00b);
$parcel$export(module.exports, "getExternalActionForModal", () => $ca4d10cff4d8f2d0$export$abec5eeca0d49152);
$parcel$export(module.exports, "getIssueByIdForModal", () => $ca4d10cff4d8f2d0$export$205b1cdd95c7fd35);
$parcel$export(module.exports, "getIssueIdForModal", () => $ca4d10cff4d8f2d0$export$d6b21a93073a1a2f);
$parcel$export(module.exports, "isIssueModalShowingSelector", () => $ca4d10cff4d8f2d0$export$747dd163f6ef1912);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $67Z81 = parcelRequire("67Z81");
const $ca4d10cff4d8f2d0$export$d50a1e4d7624445f = (state)=>(0, $67Z81.getUi)(state).issueModal;
const $ca4d10cff4d8f2d0$export$9865dacc0ccd6c8e = (state)=>$ca4d10cff4d8f2d0$export$d50a1e4d7624445f(state)?.selectedIssueKey;
const $ca4d10cff4d8f2d0$export$b858c74a94f5e00b = (state)=>$ca4d10cff4d8f2d0$export$d50a1e4d7624445f(state)?.timestamp ?? 0;
const $ca4d10cff4d8f2d0$export$abec5eeca0d49152 = (state)=>$ca4d10cff4d8f2d0$export$d50a1e4d7624445f(state)?.externalAction;
const $ca4d10cff4d8f2d0$export$205b1cdd95c7fd35 = (0, $dGvGJ.createSelector)([
    (0, $bSSdD.getIssueParents),
    (0, $67Z81.getIssues),
    (0, $3UY9S.getIssueChildren)
], (issueParents, issues, issueChildren)=>{
    const issueById = (issueId)=>issueParents[String(issueId)] || issues[String(issueId)] || issueChildren[String(issueId)] || null;
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(issueById);
});
const $ca4d10cff4d8f2d0$export$3c86cc428a87aa5e = (0, $dGvGJ.createSelector)([
    (0, $bSSdD.getIssueParents),
    (0, $67Z81.getIssues),
    (0, $3UY9S.getIssueChildren)
], (issueParents, issues, issueChildren)=>{
    const issueByKeyForModal = (issueKey)=>{
        const allIssues = {
            ...issueParents,
            ...issues,
            ...issueChildren
        };
        return Object.keys(allIssues).map((key)=>allIssues[key]).find((issue)=>issue.key === issueKey) || null;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(issueByKeyForModal);
});
const $ca4d10cff4d8f2d0$export$d6b21a93073a1a2f = (state)=>{
    const issueKey = $ca4d10cff4d8f2d0$export$9865dacc0ccd6c8e(state);
    const issue = $ca4d10cff4d8f2d0$export$3c86cc428a87aa5e(state)(issueKey);
    return issue ? issue.id : null;
};
const $ca4d10cff4d8f2d0$export$747dd163f6ef1912 = (state)=>$ca4d10cff4d8f2d0$export$9865dacc0ccd6c8e(state) !== null;

});

parcelRegister("gR0bs", function(module, exports) {

$parcel$export(module.exports, "getFirstSelectableIssueAscending", () => $2b50e391ccc94ced$export$10c0b19e7f67cd54);
$parcel$export(module.exports, "getFirstSelectableIssueDescending", () => $2b50e391ccc94ced$export$66eabf17ea5e1f07);
$parcel$export(module.exports, "getNextSelectableIssue", () => $2b50e391ccc94ced$export$91f27091d99780d1);
$parcel$export(module.exports, "getPrevSelectableIssue", () => $2b50e391ccc94ced$export$890c8ca26561b146);
$parcel$export(module.exports, "getFirstSelectableIssueInFirstColumn", () => $2b50e391ccc94ced$export$743d6303a5a83c8a);
$parcel$export(module.exports, "getFirstSelectableIssueInLastColumn", () => $2b50e391ccc94ced$export$f052e308ab96dfe1);
$parcel$export(module.exports, "makeGetNeighbouringIssueInNextColumn", () => $2b50e391ccc94ced$export$9284a66d7f0ff606);
$parcel$export(module.exports, "makeGetNeighbouringIssueInPrevColumn", () => $2b50e391ccc94ced$export$f83ca7f5aff3017);
$parcel$export(module.exports, "isActiveCardVisible", () => $2b50e391ccc94ced$export$5bfea476de38a26e);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $iuuJH = parcelRequire("iuuJH");

var $bwTbl = parcelRequire("bwTbl");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");
const $2b50e391ccc94ced$var$getIsSwimlaneModeSet = (0, $dGvGJ.createSelector)((0, $45cXl.getSwimlaneMode), (swimlaneMode)=>swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id);
const $2b50e391ccc94ced$export$c7a1835f4be8a376 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$var$getIsSwimlaneModeSet,
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $67Z81.getOrderedColumnIds),
    (0, $4jZ56.getSwimlanes),
    (0, $4jZ56.makeIsSwimlaneCollapsed)
], (isSwimlaneModeSet, issuesBySwimlane, issuesByColumn, orderedColumnIds, swimlanes, isSwimlaneCollapsed)=>{
    // Ids of all columns that contain issues
    const columndIds = orderedColumnIds.filter((columnId)=>issuesByColumn[String(columnId)].length).map(String);
    if (!columndIds.length) return [];
    if (isSwimlaneModeSet) {
        // Sort swimlanes in issuesBySwimlane into correct order
        const orderedSwimlanes = swimlanes.filter(({ id: id })=>!isSwimlaneCollapsed(id)).map(({ id: id })=>issuesBySwimlane[id]).filter(Boolean);
        // Find the first column that contains issues in one of the swimlanes
        const populatedColumnId = columndIds.find((id)=>orderedSwimlanes.some((swimlane)=>!!swimlane[id]));
        // Return issue ids for all issues in the given column, respecting swimlanes
        return populatedColumnId !== undefined ? orderedSwimlanes.map((swimlane)=>swimlane[populatedColumnId]).filter(Boolean).flat() : [];
    }
    // No swimlane mode is selected, return issues in the first ordered column
    return issuesByColumn[String(columndIds[0])];
});
const $2b50e391ccc94ced$export$10c0b19e7f67cd54 = (0, $dGvGJ.createSelector)($2b50e391ccc94ced$export$c7a1835f4be8a376, (issues)=>issues[0]);
const $2b50e391ccc94ced$export$66eabf17ea5e1f07 = (0, $dGvGJ.createSelector)($2b50e391ccc94ced$export$c7a1835f4be8a376, (issues)=>issues[issues.length - 1]);
const $2b50e391ccc94ced$export$bc08a2100ab1739b = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$var$getIsSwimlaneModeSet,
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $4jZ56.getSwimlanes),
    (0, $4jZ56.makeIsSwimlaneCollapsed)
], (isSwimlaneModeSet, issuesBySwimlane, issuesByColumn, swimlanes, isSwimlaneCollapsed)=>{
    const selectableIssuesInColumn = (columnId)=>{
        if (isSwimlaneModeSet) return swimlanes.filter(({ id: id })=>!isSwimlaneCollapsed(id)).map(({ id: id })=>issuesBySwimlane[id]).map((swimlane)=>swimlane && swimlane[String(columnId)]).filter(Boolean).flat();
        // No swimlane mode is selected
        return issuesByColumn[String(columnId)] || [];
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(selectableIssuesInColumn);
});
const $2b50e391ccc94ced$export$91f27091d99780d1 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$export$bc08a2100ab1739b,
    (0, $d2i8f.makeGetColumnIdForIssue)
], (getSelectableIssuesInColumn, getColumnIdForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const columnId = getColumnIdForIssue(issueId);
        const column = getSelectableIssuesInColumn(columnId);
        const issueIndex = column.indexOf(issueId);
        return column[issueIndex + 1];
    }));
const $2b50e391ccc94ced$export$890c8ca26561b146 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$export$bc08a2100ab1739b,
    (0, $d2i8f.makeGetColumnIdForIssue)
], (getSelectableIssuesInColumn, getColumnIdForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const columnId = getColumnIdForIssue(issueId);
        const column = getSelectableIssuesInColumn(columnId);
        const issueIndex = column.indexOf(issueId);
        return column[issueIndex - 1];
    }));
const $2b50e391ccc94ced$export$1ee41e350e15bf0a = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$var$getIsSwimlaneModeSet,
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $4jZ56.getSwimlanes),
    (0, $67Z81.getOrderedColumnIds),
    (0, $4jZ56.makeIsSwimlaneCollapsed)
], (isSwimlaneModeSet, issuesBySwimlane, issuesByColumn, swimlanes, orderedColumnIds, isSwimlaneCollapsed)=>{
    if (isSwimlaneModeSet) {
        const firstSwimlane = swimlanes.filter(({ id: id })=>!isSwimlaneCollapsed(id)).map(({ id: id })=>issuesBySwimlane[id]).filter(Boolean).shift();
        // All swimlanes are collapsed or there is no populated swimlane
        // based on the current filters
        if (!firstSwimlane) return undefined;
        return orderedColumnIds.filter((id)=>firstSwimlane[String(id)]).map((id)=>firstSwimlane[String(id)]);
    }
    // No swimlane mode is selected
    return orderedColumnIds.filter((id)=>issuesByColumn[String(id)].length).map((id)=>issuesByColumn[String(id)]);
});
const $2b50e391ccc94ced$export$743d6303a5a83c8a = (0, $dGvGJ.createSelector)($2b50e391ccc94ced$export$1ee41e350e15bf0a, (columns)=>{
    if (!columns || !columns.length) return undefined;
    return columns[0][0];
});
const $2b50e391ccc94ced$export$f052e308ab96dfe1 = (0, $dGvGJ.createSelector)($2b50e391ccc94ced$export$1ee41e350e15bf0a, (columns)=>{
    if (!columns || !columns.length) return undefined;
    return columns[columns.length - 1][0];
});
const $2b50e391ccc94ced$var$makeGetSwimlaneForIssue = (0, $dGvGJ.createSelector)([
    (0, $d2i8f.makeGetColumnIdForIssue),
    (0, $4jZ56.getSwimlanes),
    (0, $5mTgl.platformIssueIdsBySwimlaneSelector)
], (getColumnIdForIssue, swimlanes, issuesBySwimlane)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const issueColumnId = getColumnIdForIssue(issueId);
        const swimlane = swimlanes.find(({ id: id })=>issuesBySwimlane[id] && issuesBySwimlane[id][String(issueColumnId)] && issuesBySwimlane[id][String(issueColumnId)].indexOf(issueId) > -1);
        return swimlane && issuesBySwimlane[swimlane.id];
    }));
const $2b50e391ccc94ced$export$1a4c2ddb73ee852d = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$var$getIsSwimlaneModeSet,
    (0, $d2i8f.makeGetColumnIdForIssue),
    (0, $67Z81.getOrderedColumnIds),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    $2b50e391ccc94ced$var$makeGetSwimlaneForIssue
], (isSwimlaneModeSet, getColumnIdForIssue, orderedColumnIds, issuesByColumn, getSwimlaneForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const issueColumnId = getColumnIdForIssue(issueId);
        // If we're using a swimlane mode, get all issues by column for this swimlane,
        // Otherwise use all issues by column
        const issues = isSwimlaneModeSet ? getSwimlaneForIssue(issueId) : issuesByColumn;
        if (!issues) return undefined;
        // Get rid of columns that are empty
        const orderedPopulatedColumnIds = orderedColumnIds.filter((id)=>issues[String(id)] && issues[String(id)].length);
        const orderedPopulatedColumns = orderedPopulatedColumnIds.map((id)=>issues[String(id)]);
        // Find the column the issue resides in, and return the columns before and after it
        const issueColumnIndex = orderedPopulatedColumnIds.indexOf(issueColumnId);
        const currColumn = orderedPopulatedColumns[issueColumnIndex];
        const nextColumn = orderedPopulatedColumns[issueColumnIndex + 1];
        const prevColumn = orderedPopulatedColumns[issueColumnIndex - 1];
        return {
            current: currColumn,
            next: nextColumn,
            prev: prevColumn
        };
    }));
// Based on the rank of the issue in the current column,
// return an issue in the new column
const $2b50e391ccc94ced$var$getIssueInNewColumn = (currentIssue, currentColumn, newColumn)=>{
    const issueColumnRank = currentColumn.indexOf(currentIssue);
    // Return an issue in the new column that is in the same rank as the current issue.
    // If the new column is shorter, then we return the last issue in that column.
    return newColumn[issueColumnRank] || newColumn[newColumn.length - 1];
};
const $2b50e391ccc94ced$export$9284a66d7f0ff606 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$export$1a4c2ddb73ee852d
], (getNeighbouringColumnsForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const neighbouringColumns = getNeighbouringColumnsForIssue(issueId);
        if (!neighbouringColumns || !neighbouringColumns.next) return undefined;
        return $2b50e391ccc94ced$var$getIssueInNewColumn(issueId, neighbouringColumns.current, neighbouringColumns.next);
    }));
const $2b50e391ccc94ced$export$f83ca7f5aff3017 = (0, $dGvGJ.createSelector)([
    $2b50e391ccc94ced$export$1a4c2ddb73ee852d
], (getNeighbouringColumnsForIssue)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((issueId)=>{
        const neighbouringColumns = getNeighbouringColumnsForIssue(issueId);
        if (!neighbouringColumns || !neighbouringColumns.prev) return undefined;
        return $2b50e391ccc94ced$var$getIssueInNewColumn(issueId, neighbouringColumns.current, neighbouringColumns.prev);
    }));
const $2b50e391ccc94ced$export$5bfea476de38a26e = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $4jZ56.getSwimlanes),
    (0, $vAfHD.boardIssuesSelector),
    (0, $9OPlz.getCardActive),
    (0, $5mTgl.isIssueVisible),
    (0, $4jZ56.makeIsSwimlaneCollapsed)
], (swimlaneMode, swimlanes, boardIssues, activeCardId, getIsIssueVisible, isSwimlaneCollapsed)=>{
    if (activeCardId === null || activeCardId === undefined) return false;
    const isVisible = getIsIssueVisible(activeCardId);
    const issue = boardIssues[String(activeCardId)];
    const issueSwimlaneId = (0, $bwTbl.getSwimlaneId)(swimlaneMode, swimlanes, issue);
    const isCollapsed = issueSwimlaneId !== null ? isSwimlaneCollapsed(issueSwimlaneId) : false;
    return isVisible && !isCollapsed;
});

});


parcelRegister("5Farb", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0e549fb3fb4ded3$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $6eDJO = parcelRequire("6eDJO");

var $hdmw1 = parcelRequire("hdmw1");

var $kXqRJ = parcelRequire("kXqRJ");

var $67Z81 = parcelRequire("67Z81");
const $c0e549fb3fb4ded3$export$f8970984cad95ae6 = (state, action)=>{
    const siteId = (0, $67Z81.cloudIdSelector)(state);
    const activationId = (0, $67Z81.activationIdSelector)(state);
    const boardId = (0, $67Z81.rapidViewIdSelector)(state);
    const cardId = action.payload.issue.id.toString();
    // TODO: Update this to use ARI library @atlassian/ari when dependency is accepted https://jdog.jira-dev.com/browse/TOTEM-3113
    const cardAri = `ari:cloud:jira-software:${siteId}:card/activation/${activationId}/${boardId}/${cardId}`;
    return {
        cardId: cardAri
    };
};
const $c0e549fb3fb4ded3$export$5b7b119918f28224 = (state, action)=>({
        cloudId: (0, $67Z81.cloudIdSelector)(state),
        issueId: action.payload.issue.id
    });
const $c0e549fb3fb4ded3$export$d3da1ecaf1206c58 = ({ error: error, issue: issue, optimisticId: optimisticId })=>{
    try {
        const response = JSON.parse(error.message);
        if (response && typeof response === 'object' && 'errorMessages' in response && response.errorMessages && Array.isArray(response.errorMessages)) {
            const errors = response.errorMessages.map((message)=>String(message));
            return (0, $kXqRJ.issueDeleteFailure)(optimisticId, issue, errors);
        }
    } catch (_parseErr) {
    /* empty */ }
    return (0, $kXqRJ.issueDeleteFailure)(optimisticId, issue);
};
const $c0e549fb3fb4ded3$var$cardDeleteEpic = (action$, store)=>action$.ofType((0, $kXqRJ.ISSUE_DELETE_REQUEST)).mergeMap((action)=>{
        const { payload: { issue: issue }, meta: { optimistic: { id: optimisticId } } } = action;
        const state = store.getState();
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        const deleteCardInput = $c0e549fb3fb4ded3$export$f8970984cad95ae6(state, action);
        const extraInput = $c0e549fb3fb4ded3$export$5b7b119918f28224(state, action);
        return (0, $6eDJO.deleteCardService)(ctx, {
            deleteCardInput: deleteCardInput,
            extraInput: extraInput
        }).flatMap(()=>(0, $kVLXA.Observable).of((0, $kXqRJ.issueDeleteSuccess)(optimisticId, issue.id))).catch((err)=>(0, $kVLXA.Observable).of($c0e549fb3fb4ded3$export$d3da1ecaf1206c58({
                error: err,
                optimisticId: optimisticId,
                issue: issue
            })));
    });
var $c0e549fb3fb4ded3$export$2e2bcd8739ae039 = $c0e549fb3fb4ded3$var$cardDeleteEpic;

});
parcelRegister("6eDJO", function(module, exports) {

$parcel$export(module.exports, "deleteCardService", () => $120e01bab0465847$export$f17f430ad1b1a795);
parcelRequire("d0pqD");

var $95uwh = parcelRequire("95uwh");
const $120e01bab0465847$export$f17f430ad1b1a795 = (ctx, { deleteCardInput: deleteCardInput, extraInput: extraInput })=>(0, $95uwh.deleteCard)(deleteCardInput, extraInput);

});
parcelRegister("95uwh", function(module, exports) {

$parcel$export(module.exports, "deleteCard", () => $109dd98e4d861aae$export$cbb49d44ad636b27);

var $6qa57 = parcelRequire("6qa57");

var $8Uumt = parcelRequire("8Uumt");

var $kVLXA = parcelRequire("kVLXA");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

var $3vXOY = parcelRequire("3vXOY");

var $iJZ8l = parcelRequire("iJZ8l");
const $109dd98e4d861aae$export$cbb49d44ad636b27 = (deleteCardInput, extraInput)=>{
    const variables = {
        input: deleteCardInput
    };
    return (0, $kVLXA.Observable).fromPromise(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    new Promise((resolve, reject)=>{
        (0, $8Uumt.commitMutation)((0, $5yJb9.default)(), {
            mutation: (0, $6qa57.default),
            variables: variables,
            updater: (store)=>{
                const { cloudId: cloudId, issueId: issueId } = extraInput;
                const issueAri = (0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    cloudId: cloudId,
                    resourceType: 'issue',
                    resourceId: issueId.toString()
                });
                const issueDataId = (0, $iJZ8l.default)({
                    id: issueAri
                }, 'SoftwareCard');
                if (issueDataId !== undefined) store.delete(issueDataId);
            },
            onCompleted: (response, errors)=>{
                if (errors && errors.length) {
                    const statusCode = (0, $3vXOY.getStatusCodeFromGraphQLErrors)(errors);
                    if (statusCode == null) {
                        reject(errors);
                        return;
                    }
                    errors.map((error)=>reject(error));
                    return;
                }
                resolve(response);
            },
            onError: (error)=>{
                reject(error);
            }
        });
    }));
};

});
parcelRegister("6qa57", function(module, exports) {

$parcel$export(module.exports, "default", () => $127a78bc27ebca2d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6c7f0c26ed76fc88a07d0b6e2727631e>>
 * @relayHash fa42f3dae449dd75a7e68c391802ede8
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7ac6e9aa13260fb57ab6309b16626fe198ec2f0135614da11dfbd6db4f09891f
const $127a78bc27ebca2d$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "concreteType": "JswMutation",
            "kind": "LinkedField",
            "name": "jsw",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "input",
                            "variableName": "input"
                        }
                    ],
                    "concreteType": "DeleteCardOutput",
                    "kind": "LinkedField",
                    "name": "deleteCard",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "clientMutationId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "statusCode"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "success"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "message"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "deleteCardMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "deleteCardMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "7ac6e9aa13260fb57ab6309b16626fe198ec2f0135614da11dfbd6db4f09891f",
            "metadata": {},
            "name": "deleteCardMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$127a78bc27ebca2d$var$node.hash = "1b3d8079ce3d693831c2e051a32abf3b";
var $127a78bc27ebca2d$export$2e2bcd8739ae039 = $127a78bc27ebca2d$var$node;

});



parcelRegister("kXqRJ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_DELETE_REQUEST", () => $41524edc0ab150e2$export$a6c1c8403721a005);
$parcel$export(module.exports, "issueDeleteRequest", () => $41524edc0ab150e2$export$6460f58b640b4012);
$parcel$export(module.exports, "ISSUE_DELETE_SUCCESS", () => $41524edc0ab150e2$export$dec6ab7199007975);
$parcel$export(module.exports, "issueDeleteSuccess", () => $41524edc0ab150e2$export$bcb7ef15796f58b0);
$parcel$export(module.exports, "ISSUE_DELETE_FAILURE", () => $41524edc0ab150e2$export$f2386abdd28c7f20);
$parcel$export(module.exports, "issueDeleteFailure", () => $41524edc0ab150e2$export$3d3a8d020fe32306);

var $6s1PB = parcelRequire("6s1PB");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $41524edc0ab150e2$export$a6c1c8403721a005 = 'state.actions.issue.delete.ISSUE_DELETE_REQUEST';
const $41524edc0ab150e2$export$6460f58b640b4012 = (issue, childIssueIds)=>({
        type: $41524edc0ab150e2$export$a6c1c8403721a005,
        payload: {
            issue: issue,
            childIssueIds: childIssueIds
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)()
        }
    });
const $41524edc0ab150e2$export$dec6ab7199007975 = 'state.actions.issue.delete.ISSUE_DELETE_SUCCESS';
const $41524edc0ab150e2$export$bcb7ef15796f58b0 = (optimisticId, issueId)=>({
        type: $41524edc0ab150e2$export$dec6ab7199007975,
        payload: {
            issueId: issueId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $41524edc0ab150e2$export$f2386abdd28c7f20 = 'state.actions.issue.delete.ISSUE_DELETE_FAILURE';
const $41524edc0ab150e2$export$3d3a8d020fe32306 = (optimisticId, issue, errorMessages = null)=>{
    const titleMessage = (()=>{
        // display issueType details only when it is present
        if (issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return (0, $7AVqz.default).deleteFailureTitleIssueTerminologyRefreshM4;
        return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).deleteFailureTitleIssueTermRefresh : (0, $7AVqz.default).deleteFailureTitle;
    })();
    return {
        type: $41524edc0ab150e2$export$f2386abdd28c7f20,
        payload: {
            issueId: issue.id
        },
        meta: errorMessages ? {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.warningFlagMeta)({
                id: 'ISSUE_DELETE_ERROR_FLAG',
                titleMessage: titleMessage,
                descriptionMessage: (0, $7AVqz.default).genericDescription,
                rawDescriptionMessage: errorMessages.join('\n\n'),
                ...issue.typeName && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false) ? {
                    context: {
                        workType: issue.typeName
                    }
                } : {}
            })
        } : (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    };
};

});


parcelRegister("gG0ZK", function(module, exports) {

$parcel$export(module.exports, "default", () => $14c6b3c1831cb426$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $2f454 = parcelRequire("2f454");

var $3UY9S = parcelRequire("3UY9S");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$14c6b3c1831cb426$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $2f454.CARD_DELETE_OPTIMISTIC)).mergeMap((action)=>{
        const state = store.getState();
        const issues = (0, $67Z81.getIssues)(state);
        const issueChildren = (0, $3UY9S.getIssueChildren)(state);
        const { issueId: issueId } = action.payload;
        const { parentId: parentId, isDone: isDone } = issues[String(issueId)] || issueChildren[String(issueId)] || {};
        return (0, $kVLXA.Observable).of((0, $2f454.cardDelete)(issueId, !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentId) && parentId !== 0 ? Number(parentId) : null, isDone || false));
    });

});

parcelRegister("5ZlmD", function(module, exports) {

$parcel$export(module.exports, "cardDragStartEpic", () => $a68f3b7618cc7f07$export$c65f66b1d098a388);
parcelRequire("fp4O3");
parcelRequire("6hSeW");

var $kVLXA = parcelRequire("kVLXA");

var $6oUms = parcelRequire("6oUms");

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");

var $9OPlz = parcelRequire("9OPlz");
const $a68f3b7618cc7f07$export$4861ae22c9708538 = (payload, state)=>{
    if (!payload) return (0, $kVLXA.Observable).empty();
    const cardId = `${(0, $6oUms.getDescriptor)(payload.draggableId).id}`;
    const selectedIds = (0, $9OPlz.getCardSelection)(state).map((id)=>`${id}`);
    if (selectedIds.length === 0 || selectedIds.includes(cardId)) return (0, $kVLXA.Observable).empty();
    return (0, $kVLXA.Observable).of((0, $2f454.cardCancelSelection)());
};
function $a68f3b7618cc7f07$export$c65f66b1d098a388(action$, store) {
    return action$.ofType((0, $eu61M.DRAG_START)).mergeMap((action)=>$a68f3b7618cc7f07$export$4861ae22c9708538(action.payload, store.getState()));
}

});
parcelRegister("6oUms", function(module, exports) {

$parcel$export(module.exports, "getDescriptor", () => $ae2b40e955a59f76$export$dd068f9289a3efeb);
$parcel$export(module.exports, "getColumnDescriptor", () => $ae2b40e955a59f76$export$37010f521c16e534);
$parcel$export(module.exports, "getCardDescriptor", () => $ae2b40e955a59f76$export$e50ce3233c010197);

const $ae2b40e955a59f76$export$dd068f9289a3efeb = (identifier)=>{
    const [type, id, swimlaneId] = identifier.split('::');
    const maybeNumberId = Number(id);
    return {
        type: type,
        id: Number.isNaN(maybeNumberId) ? id : maybeNumberId,
        swimlaneId: swimlaneId || undefined
    };
};
const $ae2b40e955a59f76$export$37010f521c16e534 = (columnId, swimlaneId)=>swimlaneId ? `${0, $589d07317c4524ed$export$7f092194d45e1f0d}::${columnId}::${swimlaneId}` : `${0, $589d07317c4524ed$export$7f092194d45e1f0d}::${columnId}`;
const $ae2b40e955a59f76$export$e50ce3233c010197 = (cardId)=>`${0, $589d07317c4524ed$export$76a449e52fa0e1e8}::${cardId}`;

});
const $589d07317c4524ed$export$76a449e52fa0e1e8 = 'ISSUE';
const $589d07317c4524ed$export$7f092194d45e1f0d = 'COLUMN';


parcelRegister("eu61M", function(module, exports) {

$parcel$export(module.exports, "DRAG_START", () => $b6559dcb336b0737$export$56a2165aef3d890f);
$parcel$export(module.exports, "dragStart", () => $b6559dcb336b0737$export$c34730c351bf3a09);
$parcel$export(module.exports, "DRAG_END", () => $b6559dcb336b0737$export$fc1141357993c252);
$parcel$export(module.exports, "dragEnd", () => $b6559dcb336b0737$export$5d38b0bd4bef40ba);
const $b6559dcb336b0737$export$56a2165aef3d890f = 'state.actions.board.drag.DRAG_START';
const $b6559dcb336b0737$export$c34730c351bf3a09 = (draggableId, mode)=>draggableId && mode ? {
        type: $b6559dcb336b0737$export$56a2165aef3d890f,
        payload: {
            draggableId: draggableId,
            mode: mode
        }
    } : {
        type: $b6559dcb336b0737$export$56a2165aef3d890f
    };
const $b6559dcb336b0737$export$fc1141357993c252 = 'state.actions.board.drag.DRAG_END';
const $b6559dcb336b0737$export$5d38b0bd4bef40ba = ()=>({
        type: $b6559dcb336b0737$export$fc1141357993c252
    });

});


parcelRegister("93Fzk", function(module, exports) {

$parcel$export(module.exports, "cardsMoveEpic", () => $607fa67f873704d7$export$e54c6a4679c869f3);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $gULOk = parcelRequire("gULOk");

var $4jAPy = parcelRequire("4jAPy");

var $3spCR = parcelRequire("3spCR");

var $iuuJH = parcelRequire("iuuJH");

var $iDcEO = parcelRequire("iDcEO");

var $2f454 = parcelRequire("2f454");

var $e1q2I = parcelRequire("e1q2I");

var $vAfHD = parcelRequire("vAfHD");

var $5UXId = parcelRequire("5UXId");

var $71oFY = parcelRequire("71oFY");

var $k50Aq = parcelRequire("k50Aq");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $3UY9S = parcelRequire("3UY9S");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $cPGP0 = parcelRequire("cPGP0");

var $5mTgl = parcelRequire("5mTgl");
const $607fa67f873704d7$export$555d348c9f201554 = (destinationCardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex, sourceSwimlaneId, destinationSwimlaneId)=>{
    if (!destinationCardIds || destinationCardIds.length === 0) return {};
    // rank. move inside same column
    if (destinationColumnId === sourceColumnId && sourceSwimlaneId === destinationSwimlaneId) {
        // move down list
        if (destinationCardIndex > sourceCardIndex) // rank after last moved item
        return {
            rankAfterCardId: destinationCardIds[destinationCardIndex]
        };
        // rank before last moved item
        return {
            rankBeforeCardId: destinationCardIds[destinationCardIndex]
        };
    }
    // rank + transition. Move from one column to another + rank inside destination column
    if (destinationCardIndex === 0) // rank before first item
    return {
        rankBeforeCardId: destinationCardIds[destinationCardIndex]
    };
    return {
        rankAfterCardId: destinationCardIds[destinationCardIndex - 1]
    };
};
const $607fa67f873704d7$export$e8f4ada03ddbca5e = ({ cardIds: cardIds, destinationCardIds: destinationCardIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId }, state)=>{
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issue = allIssues[String(cardIds[0])];
    const { rankBeforeCardId: rankBeforeCardId, rankAfterCardId: rankAfterCardId } = $607fa67f873704d7$export$555d348c9f201554(destinationCardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex, sourceSwimlaneId, destinationSwimlaneId);
    if (sourceColumnId === destinationColumnId && sourceCardIndex === destinationCardIndex && sourceSwimlaneId === destinationSwimlaneId) return (0, $kVLXA.Observable).empty();
    const destinationSwimlaneTeam = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationSwimlaneId) ? (0, $cPGP0.getTeamById)(state)(destinationSwimlaneId) : undefined;
    if (sourceSwimlaneId !== destinationSwimlaneId && !destinationSwimlaneTeam?.isPlanTeam && destinationSwimlaneId !== (0, $4jAPy.SWIMLANE_TEAMLESS)) return (0, $kVLXA.Observable).of((0, $k50Aq.teamSwimLaneInvalidMove)(destinationSwimlaneTeam?.name || '', issue));
    const sprintForTeamSwimlaneColumn = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationSwimlaneId) ? (0, $5mTgl.getTeamSwimlaneColumnSprint)(state, destinationColumnId, destinationSwimlaneId) : undefined;
    const isClosedSprint = sprintForTeamSwimlaneColumn && sprintForTeamSwimlaneColumn.state === (0, $3spCR.SPRINT_STATES).CLOSED;
    if (isClosedSprint) return (0, $kVLXA.Observable).of((0, $k50Aq.swimlaneColumnClosedSprintInvalidMove)(sprintForTeamSwimlaneColumn.name, issue));
    return (0, $kVLXA.Observable).of((0, $5UXId.issueRankTeamDateRequest)({
        issueIds: cardIds,
        sourceColumnId: sourceColumnId,
        destinationColumnId: destinationColumnId,
        rankBeforeIssueId: rankBeforeCardId,
        rankAfterIssueId: rankAfterCardId,
        sourceSwimlaneId: sourceSwimlaneId,
        destinationSwimlaneId: destinationSwimlaneId
    }));
};
const $607fa67f873704d7$export$a11ebd2d21578b3 = ({ cardIds: cardIds, destinationCardIds: destinationCardIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, analyticsEvent: analyticsEvent }, state)=>{
    const { rankBeforeCardId: rankBeforeCardId, rankAfterCardId: rankAfterCardId } = $607fa67f873704d7$export$555d348c9f201554(destinationCardIds, sourceColumnId, destinationColumnId, sourceCardIndex, destinationCardIndex, sourceSwimlaneId, destinationSwimlaneId);
    const transitionId = (0, $9OPlz.getSelectedTransition)(state)?.transitionId;
    const destinationStatus = (0, $lIysR.cardTransitionDestinationStatusSelector)(state)(cardIds[0], destinationColumnId);
    // If we drag-and-dropped the issue into exactly the same place, do nothing.
    if (sourceColumnId === destinationColumnId && sourceCardIndex === destinationCardIndex && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) && ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sourceSwimlaneId) && !destinationSwimlaneId || sourceSwimlaneId === destinationSwimlaneId)) return (0, $kVLXA.Observable).empty();
    // When there are multiple statuses per column isSourceDone represents the resolution of the issue
    // rather than the column, as an unresolved issue can be in a done column and vise versa.
    const isSourceDone = (0, $d2i8f.isDoneIssueSelector)(state)(cardIds[0]);
    let isDestinationDone = (0, $fyeGd.isDoneColumnSelector)(state)(destinationColumnId);
    // When there are multiple statuses per column a user can move an issue to a not done status even
    // though the column is considered "done", therefore we need to check the destinationStatus as it will be used
    // when selecting a status within a column that has multiple statuses
    if (destinationStatus) isDestinationDone = destinationStatus.category === (0, $gULOk.DONE);
    const actions = [
        (0, $71oFY.bulkIssueRankTransitionRequest)({
            issueIds: cardIds,
            sourceColumnId: sourceColumnId,
            destinationColumnId: destinationColumnId,
            rankBeforeIssueId: rankBeforeCardId,
            rankAfterIssueId: rankAfterCardId,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId,
            isSourceDone: isSourceDone,
            isDestinationDone: isDestinationDone,
            transitionId: transitionId,
            sourceStatus: (0, $lIysR.cardTransitionSourceStatusSelector)(state)(cardIds[0]),
            destinationStatus: destinationStatus,
            isRankable: (0, $67Z81.isBoardRankable)(state),
            analyticsEvent: analyticsEvent
        })
    ];
    if (isDestinationDone && !isSourceDone) actions.push((0, $2f454.cardAddShowRipple)(cardIds));
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationSwimlaneId) && sourceSwimlaneId !== destinationSwimlaneId) {
        const values = (0, $4jZ56.makeSwimlaneValuesSelector)(state)(destinationSwimlaneId);
        if (values) actions.push((0, $e1q2I.issueChangeSwimlane)(cardIds, destinationSwimlaneId, values));
    }
    return (0, $kVLXA.Observable).from(actions);
};
const $607fa67f873704d7$var$tryGetBulkSelectionIds = (state, cardId)=>{
    const cardSelection = (0, $9OPlz.getCardSelection)(state);
    return cardSelection.includes(cardId) ? [
        ...cardSelection
    ] : [
        cardId
    ];
};
const $607fa67f873704d7$export$8af04b1252e03f45 = ({ cardIds: cardIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, analyticsEvent: analyticsEvent }, state)=>{
    const cardsByColumn = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationSwimlaneId) ? (0, $5mTgl.platformIssueIdsBySwimlaneSelector)(state)[destinationSwimlaneId] : (0, $5mTgl.getFilteredIssueIdsByColumn)(state);
    let destinationCardIds = cardsByColumn[String(destinationColumnId)] ?? [];
    const issueChildren = (0, $3UY9S.getIssueChildren)(state);
    const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    if ((0, $67Z81.getIsCMPBoard)(state) && (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        const cardGroupParentIds = [];
        const isIssueChild = cardIds[0] in issueChildren;
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && isIssueChild) {
            const issueChild = issueChildren[cardIds[0]];
            const childrenIds = (0, $3UY9S.getChildrenOfParent)(state)(issueChild.parentId) || [];
            destinationCardIds = destinationCardIds.filter((id)=>childrenIds.includes(id));
        } else destinationCardIds = destinationCardIds.reduce((result, cardId)=>{
            const parentId = (0, $3UY9S.getParentIdByIssueChildSelector)(state)(cardId);
            if (parentId) // Get the parent id for the subtask group, because subtasks always follow their parents when ranking if the board is rankable
            {
                if (!cardGroupParentIds.includes(parentId)) {
                    cardGroupParentIds.push(parentId);
                    result.push(parentId);
                }
            } else result.push(cardId);
            return result;
        }, []);
    }
    const cardIdsToMove = $607fa67f873704d7$var$tryGetBulkSelectionIds(state, cardIds[0]);
    if (isIncrementPlanningBoard) return $607fa67f873704d7$export$e8f4ada03ddbca5e({
        cardIds: cardIdsToMove,
        destinationCardIds: destinationCardIds,
        sourceColumnId: sourceColumnId,
        destinationColumnId: destinationColumnId,
        sourceCardIndex: sourceCardIndex,
        destinationCardIndex: destinationCardIndex,
        sourceSwimlaneId: sourceSwimlaneId,
        destinationSwimlaneId: destinationSwimlaneId
    }, state);
    return $607fa67f873704d7$export$a11ebd2d21578b3({
        cardIds: cardIdsToMove,
        destinationCardIds: destinationCardIds,
        sourceColumnId: sourceColumnId,
        destinationColumnId: destinationColumnId,
        sourceCardIndex: sourceCardIndex,
        destinationCardIndex: destinationCardIndex,
        sourceSwimlaneId: sourceSwimlaneId,
        destinationSwimlaneId: destinationSwimlaneId,
        analyticsEvent: analyticsEvent
    }, state);
};
function $607fa67f873704d7$export$e54c6a4679c869f3(action$, store) {
    return action$.ofType((0, $iDcEO.CARDS_MOVE)).mergeMap((action)=>$607fa67f873704d7$export$8af04b1252e03f45(action.payload, store.getState()));
}

});
parcelRegister("iDcEO", function(module, exports) {

$parcel$export(module.exports, "CARDS_MOVE", () => $264035bd19c86665$export$b33d2f47990782ba);
$parcel$export(module.exports, "cardsMove", () => $264035bd19c86665$export$68ae240377a1a3d7);
const $264035bd19c86665$export$b33d2f47990782ba = 'state.action.card.card-move.CARDS_MOVE';
const $264035bd19c86665$export$68ae240377a1a3d7 = (payload)=>({
        type: $264035bd19c86665$export$b33d2f47990782ba,
        payload: payload
    });
const $264035bd19c86665$export$c54ee0b69949f6a9 = 'state.action.card.card-move.GROUP_CARDS_MOVE';

});

parcelRegister("e1q2I", function(module, exports) {

$parcel$export(module.exports, "DONE_ISSUES_BUTTON_CLICK", () => $afb9c731414a4c17$export$4e6e21c1d555ffb9);
$parcel$export(module.exports, "doneIssuesButtonClick", () => $afb9c731414a4c17$export$fdc4a4b0f77c4bc1);
$parcel$export(module.exports, "ISSUE_CHANGE_SWIMLANE", () => $afb9c731414a4c17$export$80573f0ea27967f9);
$parcel$export(module.exports, "issueChangeSwimlane", () => $afb9c731414a4c17$export$b1b86dea7a51e7b5);
$parcel$export(module.exports, "SET_ISSUES_NOT_ON_BOARD", () => $afb9c731414a4c17$export$26e74a859871d970);
const $afb9c731414a4c17$export$4e6e21c1d555ffb9 = 'state.actions.issue.DONE_ISSUES_BUTTON_CLICK';
const $afb9c731414a4c17$export$fdc4a4b0f77c4bc1 = ()=>({
        type: $afb9c731414a4c17$export$4e6e21c1d555ffb9
    });
const $afb9c731414a4c17$export$80573f0ea27967f9 = 'state.actions.issue.ISSUE_CHANGE_SWIMLANE';
const $afb9c731414a4c17$export$b1b86dea7a51e7b5 = (issueIds, swimlaneId, swimlaneValues)=>({
        type: $afb9c731414a4c17$export$80573f0ea27967f9,
        payload: {
            issueIds: issueIds,
            swimlaneId: swimlaneId,
            swimlaneValues: swimlaneValues
        }
    });
const $afb9c731414a4c17$export$26e74a859871d970 = 'state.actions.issue.SET_ISSUES_NOT_ON_BOARD';
const $afb9c731414a4c17$export$c80308cab8e885d8 = (payload)=>({
        type: $afb9c731414a4c17$export$26e74a859871d970,
        payload: payload
    });

});


parcelRegister("i9XZM", function(module, exports) {

$parcel$export(module.exports, "default", () => $e657e869fe364458$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("d0pqD");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $gccSB = parcelRequire("gccSB");

var $kVLXA = parcelRequire("kVLXA");

var $5rFbt = parcelRequire("5rFbt");

var $2YZCu = parcelRequire("2YZCu");

var $g5X3G = parcelRequire("g5X3G");


var $hjlQ8 = parcelRequire("hjlQ8");

var $6fpfm = parcelRequire("6fpfm");

var $252qi = parcelRequire("252qi");

var $lF9PL = parcelRequire("lF9PL");

var $2f454 = parcelRequire("2f454");

var $4gHuj = parcelRequire("4gHuj");

var $dN3Ms = parcelRequire("dN3Ms");

var $evkwq = parcelRequire("evkwq");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $e657e869fe364458$export$343b49279bcad83d = (action$, store)=>action$.ofType((0, $2f454.CARD_REFRESH_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const estimateFieldId = (0, $5mTgl.getEstimationStatistic)(state);
        const cardIds = action.payload.issueIds ? action.payload.issueIds.map((issueId)=>String(issueId)) : [];
        if ((0, $67Z81.getIsCMPBoard)(state)) return (0, $kVLXA.Observable).empty();
        // eslint-disable-next-line @atlassian/eng-health/code-evolution/ts-migration-4.9-5.4
        return (0, $6fpfm.cardRefreshBoardScopeService)(contextPath, boardId, cardIds) // @ts-expect-error([Part of upgrade 4.9-5.4]) - Argument of type '(response: CardRefreshBoardScopeResponse) => Observable<IssueUpdateFailureAction> | Observable<AnyAction>' is not assignable to parameter of type '(value: CardRefreshBoardScopeResponse, index: number) => ObservableInput<AnyAction>'.
        .flatMap((response)=>{
            const { projectLocation: { id: projectId }, cards: cards, board: board } = response.data.boardScope;
            if (cards === null) return (0, $kVLXA.Observable).of((0, $evkwq.issueUpdateFailure)(`failed to get cards ${String(cardIds)}`));
            const stateAfterRefresh = store.getState();
            return (0, $kVLXA.Observable).from(cards.reduce((actions, card)=>{
                const cardPerson = card.issue.assignee !== null ? (0, $lF9PL.cardRefreshPersonTransformer)(card.issue.assignee) : null;
                const { issue: { status: status } } = card;
                const column = (0, $fyeGd.columnByStatusIdSelector)(stateAfterRefresh, // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                Number(status.id));
                const transactionIsValid = (0, $9OPlz.isTransactionValid)(stateAfterRefresh, +card.id, action.payload.transactionId);
                if (transactionIsValid) actions.push((0, $2f454.cardDataSet)((0, $252qi.cardRefreshIssueTransformer)(projectId, // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                column, estimateFieldId, card), cardPerson, action.payload.origin), (0, $2f454.cardMediaDataSet)((0, $252qi.cardRefreshMediaTransformer)(card.id, card)));
                if (board && board.issueChildren) actions.push((0, $4gHuj.setIssueChildren)((0, $hjlQ8.getIssueChildren)(board.issueChildren, Number(projectId), (0, $g5X3G.values)((0, $fyeGd.getColumns)(state)).filter((c)=>c.type === (0, $5rFbt.ColumnType).STATUS), estimateFieldId)));
                return actions;
            }, []));
        }).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('card-refresh.failure', 'Failed to refresh card', error);
            return (0, $kVLXA.Observable).empty();
        });
    });
// listens to issue-updates (happen when Bento is closed) and triggers image refresh
const $e657e869fe364458$var$issueUpdateListenerEpic = (action$, store)=>action$.ofType((0, $evkwq.ISSUE_UPDATE_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const filterExistingIssues = (issueId)=>(0, $d2i8f.hasIssueOrIssueChild)(state, issueId);
        const issueIds = action.payload.issueIds.filter(filterExistingIssues);
        if (issueIds && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueIds)) {
            const skipTransactionUpdate = action.payload.origin === (0, $f32ae13c2b9742f4$export$f2127cf693ff3edc);
            return (0, $kVLXA.Observable).of((0, $2f454.cardRefreshRequestWith)({
                issueIds: issueIds,
                origin: action.payload.origin,
                transactionId: action.payload.transactionId,
                skipTransactionUpdate: skipTransactionUpdate
            }));
        }
        return (0, $kVLXA.Observable).empty();
    });
// listens to card menu show/hide image changes
const $e657e869fe364458$var$cardMenuClicksListenerEpic = (action$)=>action$.ofType((0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_SUCCESS)).filter((action)=>action.payload.isVisible).map((action)=>(0, $2f454.cardRefreshRequestWith)({
            issueIds: [
                action.payload.issueId
            ],
            origin: (0, $f32ae13c2b9742f4$export$d46a05f8561f868a),
            transactionId: action.meta.optimistic.id,
            skipTransactionUpdate: false
        }));
var $e657e869fe364458$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($e657e869fe364458$export$343b49279bcad83d, $e657e869fe364458$var$issueUpdateListenerEpic, $e657e869fe364458$var$cardMenuClicksListenerEpic);

});
parcelRegister("hjlQ8", function(module, exports) {

$parcel$export(module.exports, "getIssueChildren", () => $c2a0409d5db822bd$export$9ed60bbe06bbd06b);
$parcel$export(module.exports, "transformColumn", () => $c2a0409d5db822bd$export$71ab8832c85346b);
$parcel$export(module.exports, "getCardTransitions", () => $c2a0409d5db822bd$export$c5f25828191314fe);
$parcel$export(module.exports, "transformCriticalData", () => $c2a0409d5db822bd$export$9bbdc053b14eb715);
$parcel$export(module.exports, "transformNonCriticalData", () => $c2a0409d5db822bd$export$ccde3e79901f52d6);

var $6Csk1 = parcelRequire("6Csk1");

var $6eBRn = parcelRequire("6eBRn");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $5rFbt = parcelRequire("5rFbt");

var $2vSU6 = parcelRequire("2vSU6");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $6s1PB = parcelRequire("6s1PB");



var $iuuJH = parcelRequire("iuuJH");

var $bO1Vt = parcelRequire("bO1Vt");

var $cjoN4 = parcelRequire("cjoN4");

var $bDyOs = parcelRequire("bDyOs");
const $c2a0409d5db822bd$export$73a53226406d7fe = (boardScopeGQL)=>{
    const issues = (boardScopeGQL.board.columns || []).reduce((acc, col)=>acc.concat(col.cards// TODO: remove when backend fixed
        .filter((card)=>boardScopeGQL.board.issueChildren ? boardScopeGQL.board.issueChildren.every((child)=>child.issue.id !== card.issue.id) : true).map((card)=>{
            const issueCard = {
                id: Number(card.issue.id),
                key: card.issue.key,
                summary: card.issue.summary,
                assigneeAccountId: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(card, [
                    'issue',
                    'assignee',
                    'accountId'
                ], null),
                typeId: Number(card.issue.type.id),
                typeName: card.issue.type.name,
                typeUrl: card.issue.type.iconUrl,
                statusId: Number(card.issue.status.id),
                projectId: Number((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
                    'projectLocation',
                    'id'
                ], '-1')),
                columnId: Number(col.id),
                isFlagged: card.flagged,
                labels: [
                    ...card.issue.labels
                ],
                isDone: card.done,
                parentId: card.parentId ? Number(card.parentId) : null,
                estimate: (0, $bDyOs.calculateEstimateValue)(card.estimate, boardScopeGQL.estimation.current?.customFieldId),
                priority: card.priority ? {
                    ...card.priority
                } : null,
                dueDate: card.dueDate || null,
                numCompleteChildren: card.childIssuesMetadata ? card.childIssuesMetadata.complete : 0,
                numTotalChildren: card.childIssuesMetadata ? card.childIssuesMetadata.total : 0,
                sprintId: card.issue?.activeSprint?.id || ''
            };
            return issueCard;
        })), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    []);
    // We fetch the board/cards array since it as the correct ordering rather
    // than the mismash of orderings created by the joining of column.cards above
    return issues.sort((a, b)=>{
        const firstIndex = (boardScopeGQL.board.cards || []).findIndex((card)=>Number(card.id) === a.id);
        const secondIndex = (boardScopeGQL.board.cards || []).findIndex((card)=>Number(card.id) === b.id);
        return firstIndex - secondIndex;
    });
};
const $c2a0409d5db822bd$export$9ed60bbe06bbd06b = (issueChildren, projectId, columns, estimationStatistic)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columns)) return [];
    return (issueChildren || []).map((card)=>({
            id: Number(card.issue.id),
            key: card.issue.key,
            summary: card.issue.summary,
            assigneeAccountId: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(card, [
                'issue',
                'assignee',
                'accountId'
            ], null),
            typeId: Number(card.issue.type.id),
            typeName: card.issue.type.name,
            typeUrl: card.issue.type.iconUrl,
            statusId: Number(card.issue.status.id),
            projectId: projectId,
            columnId: Number((columns.find((column)=>column?.statuses.some(({ id: id })=>id === Number(card.issue.status.id))) || {}).id),
            isFlagged: card.flagged,
            labels: [
                ...card.issue.labels
            ],
            isDone: card.done,
            parentId: card.parentId ? Number(card.parentId) : null,
            estimate: (0, $bDyOs.calculateEstimateValue)(card.estimate, estimationStatistic),
            priority: card.priority ? {
                ...card.priority
            } : null,
            dueDate: card.dueDate || null,
            numCompleteChildren: 0,
            numTotalChildren: 0,
            sprintId: card.issue.activeSprint?.id || ''
        }));
};
const $c2a0409d5db822bd$export$b9c97d5330cbe844 = (boardScopeBoardGQL)=>boardScopeBoardGQL.assignees.map((a)=>({
            id: a.accountId,
            displayName: a.displayName,
            avatarUrl: a.avatarUrl
        }));
const $c2a0409d5db822bd$export$637b60a42bb03f06 = (boardScopeGQL)=>({
        id: Number((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'projectLocation',
            'id'
        ], '-1')),
        key: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'projectLocation',
            'key'
        ], 'unknown'),
        name: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'projectLocation',
            'name'
        ], 'unknown'),
        projectTypeKey: (0, $2vSU6.SOFTWARE_PROJECT)
    });
// Temporary workaround, to be removed once swag returns ids instead of keys
const $c2a0409d5db822bd$var$statusCategoryKeyIdMap = {
    undefined: 1,
    new: 2,
    indeterminate: 4,
    done: 3
};
const $c2a0409d5db822bd$var$getStatusCategoryForKey = (key)=>(0, $gULOk.statusCategoryForId)($c2a0409d5db822bd$var$statusCategoryKeyIdMap[key || 'undefined'] || $c2a0409d5db822bd$var$statusCategoryKeyIdMap.undefined);
const $c2a0409d5db822bd$export$71ab8832c85346b = (column)=>({
        type: (0, $5rFbt.ColumnType).STATUS,
        id: Number(column.id),
        name: column.name,
        maxIssueCount: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(column.maxIssueCount) ? null : column.maxIssueCount,
        statuses: column.columnStatus.map((columnStatus)=>{
            const category = $c2a0409d5db822bd$var$getStatusCategoryForKey(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            columnStatus.status.category);
            return {
                id: Number(columnStatus.status.id),
                name: columnStatus.status.name,
                isInitial: columnStatus.transitions.some((transition)=>transition.isInitial),
                isDone: category === (0, $gULOk.DONE),
                category: category
            };
        })
    });
const $c2a0409d5db822bd$export$15e690098786978a = (boardScopeGQL, projectIssueTypes)=>{
    const swimlaneStrategy = (boardScopeGQL.userSwimlaneStrategy || boardScopeGQL.board.swimlaneStrategy).toLowerCase();
    if (swimlaneStrategy === 'issuechildren' && !projectIssueTypes.some((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE))) return (0, $iuuJH.NO_SWIMLANE).id;
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'SwimlaneModeId'.
    return (0, $cjoN4.swimlaneStrategiesToMode)[swimlaneStrategy] || (0, $iuuJH.NO_SWIMLANE).id;
};
const $c2a0409d5db822bd$export$1b132ed8629e9cb0 = (boardScopeGQL)=>boardScopeGQL.sprints.map((sprint)=>({
            id: Number(sprint.id),
            name: sprint.name,
            goal: sprint.goal,
            canUpdateSprint: true,
            daysRemaining: sprint.daysRemaining,
            startDate: sprint.startDate,
            endDate: sprint.endDate
        }));
const $c2a0409d5db822bd$export$4cf4b24b88599615 = (issueTypes)=>issueTypes.map((issueType)=>({
            id: issueType.id,
            name: issueType.name,
            iconUrl: issueType.iconUrl,
            hierarchyLevelType: issueType.hierarchyLevelType || (0, $g4tDr.BASE_HIERARCHY_TYPE),
            default: false,
            description: '',
            hasRequiredFields: !!issueType.hasRequiredFields
        }));
const $c2a0409d5db822bd$export$7a0cb16aa5a43d4d = (boardScopeGQL)=>// @ts-expect-error - TS2322 - Type '{ id: number; key: string; summary: string; status: { id: string; name: string; category: StatusCategory; } | null; issueType: { id: string; name: string; iconUrl: string; }; color: Color | ... 1 more ... | undefined; }[]' is not assignable to type 'IssueParent[]'.
    (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'issueParents'
    ], []).map((issueParent)=>{
        let status = null;
        if (issueParent.issue && issueParent.issue.status) {
            const { id: id, name: name, category: category } = issueParent.issue.status;
            status = {
                id: id,
                name: name,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                category: $c2a0409d5db822bd$var$getStatusCategoryForKey(category)
            };
        }
        return {
            id: Number(issueParent.id),
            key: issueParent.key,
            summary: issueParent.summary,
            status: status,
            issueType: {
                id: issueParent.issueType.id,
                name: issueParent.issueType.name,
                iconUrl: issueParent.issueType.iconUrl
            },
            color: issueParent.color
        };
    });
const $c2a0409d5db822bd$var$isEnabled = (checkKey, features)=>features.filter(({ key: key, status: status })=>key === checkKey && status === 'ENABLED').length > 0;
const $c2a0409d5db822bd$export$61ef2ba0b96af4cf = (boardScopeGQL)=>{
    const columns = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'board',
        'columns'
    ], []);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columns)) return {};
    return (0, (/*@__PURE__*/$parcel$interopDefault($6eBRn)))(columns.map(({ id: id, cards: cards })=>[
            id,
            cards.length
        ]));
};
const $c2a0409d5db822bd$export$5f9288f90460d6e = (boardScopeGQL, jiraGQL, globalConfigGQL)=>({
        isCardMediaEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'board',
            'cardMedia',
            'enabled'
        ], false),
        boardIssueListKey: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'backlog',
            'boardIssueListKey'
        ]),
        requestColumnMigration: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'backlog',
            'requestColumnMigration'
        ]),
        issuesCountByColumn: $c2a0409d5db822bd$export$61ef2ba0b96af4cf(boardScopeGQL),
        isSprintsEnabled: $c2a0409d5db822bd$var$isEnabled('SPRINTS', boardScopeGQL.features),
        isBacklogEnabled: $c2a0409d5db822bd$var$isEnabled('BACKLOG', boardScopeGQL.features),
        ...(0, $4R6GH.fg)('jira-warepil-standup-toggle') ? {
            isStandupsEnabled: $c2a0409d5db822bd$var$isEnabled('STANDUPS', boardScopeGQL.features)
        } : {},
        isManageRulesEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'projectLocation',
            'isSimplifiedProject'
        ], false) && // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'never'.
        (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'currentUser',
            'permissions'
        ], []).includes((0, $68cf6bf1ce76db03$export$b893894941c14e43)),
        timeTrackingOptions: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(jiraGQL, [
            'timeTrackingOptions'
        ]),
        ...!(0, $4R6GH.fg)('use_backend_tmp_icc_config_') && {
            isAnyStatusInCreateEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(globalConfigGQL, [
                'applicationProperties',
                'createStatusIsEnabled'
            ])
        }
    });
const $c2a0409d5db822bd$export$24644632d725afd9 = (boardScopeGQL)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(boardScopeGQL.oldDoneIssuesCutOffConfig)) return undefined;
    return {
        options: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'oldDoneIssuesCutOffConfig',
            'options'
        ]),
        oldDoneIssuesCutoff: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'oldDoneIssuesCutOffConfig',
            'oldDoneIssuesCutoff'
        ])
    };
};
const $c2a0409d5db822bd$export$c5f25828191314fe = (projectKey, columns = [], parentHierarchyIssueTypeId)=>{
    const columnIssueTypeTransitions = {};
    const issueTypeStatus = {};
    columns.forEach((column)=>{
        columnIssueTypeTransitions[column.id] = {};
        column.columnStatus.forEach((colStatus)=>{
            // We dont show transitions related to epic issue type on board
            const filteredTransitions = parentHierarchyIssueTypeId ? colStatus.transitions.filter((transition)=>transition.cardType.id !== parentHierarchyIssueTypeId) : colStatus.transitions;
            filteredTransitions.forEach((transition)=>{
                columnIssueTypeTransitions[column.id][transition.cardType.id] = columnIssueTypeTransitions[column.id][transition.cardType.id] || [];
                issueTypeStatus[transition.cardType.id] = issueTypeStatus[transition.cardType.id] || {};
                issueTypeStatus[transition.cardType.id][colStatus.status.id] = {
                    ...colStatus.status,
                    id: Number(colStatus.status.id),
                    category: $c2a0409d5db822bd$var$getStatusCategoryForKey(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    colStatus.status.category)
                };
                const cardTransition = {
                    id: Number(transition.id),
                    name: transition.name,
                    sourceStatusId: transition.originStatus != null ? Number(transition.originStatus.id) : null,
                    destinationStatusId: Number(transition.status.id),
                    isGlobal: transition.isGlobal,
                    isInitial: transition.isInitial,
                    hasConditions: transition.hasConditions,
                    hasScreen: transition.hasScreen,
                    projectKey: projectKey
                };
                columnIssueTypeTransitions[column.id][transition.cardType.id].push(cardTransition);
            });
        });
    });
    return {
        columnIssueTypeTransitions: columnIssueTypeTransitions,
        issueTypeStatus: issueTypeStatus
    };
};
const $c2a0409d5db822bd$export$a064de9c304ad444 = (boardGQL)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(boardGQL.columns)) return {};
    return boardGQL.columns // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    .reduce((acc, column)=>acc.concat(column.cards), []).reduce((map, card)=>{
        const { coverMedia: coverMedia } = card;
        if (!coverMedia) return Object.assign(map, {
            [String(card.id)]: null
        });
        return Object.assign(map, {
            [String(card.id)]: {
                isHiddenByUser: coverMedia.hiddenByUser,
                endpointUrl: coverMedia.endpointUrl,
                clientId: coverMedia.clientId,
                token: coverMedia.token,
                attachmentId: coverMedia.attachmentId,
                attachmentMediaApiId: coverMedia.attachmentMediaApiId
            }
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $c2a0409d5db822bd$export$69903c99443079ec = (boardScopeGQL)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const issuesMedia = {};
    (boardScopeGQL.board.apolloSwimlanes || []).forEach((swimlane)=>swimlane.columnsInSwimlane.forEach((column)=>column.cards.forEach((card)=>{
                const { coverMedia: coverMedia } = card;
                issuesMedia[String(card.issue.id)] = coverMedia ? {
                    isHiddenByUser: coverMedia.hiddenByUser,
                    endpointUrl: coverMedia.endpointUrl,
                    clientId: coverMedia.clientId,
                    token: coverMedia.token,
                    attachmentId: coverMedia.attachmentId,
                    attachmentMediaApiId: coverMedia.attachmentMediaApiId
                } : null;
            })));
    return issuesMedia;
};
const $c2a0409d5db822bd$export$8c80ff32686eb3f = (boardGQL)=>boardGQL.issueChildren.reduce((map, card)=>{
        const { coverMedia: coverMedia } = card;
        if (!coverMedia) return Object.assign(map, {
            [String(card.id)]: null
        });
        return Object.assign(map, {
            [String(card.id)]: {
                isHiddenByUser: coverMedia.hiddenByUser,
                endpointUrl: coverMedia.endpointUrl,
                clientId: coverMedia.clientId,
                token: coverMedia.token,
                attachmentId: coverMedia.attachmentId,
                attachmentMediaApiId: coverMedia.attachmentMediaApiId
            }
        });
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
const $c2a0409d5db822bd$export$9bbdc053b14eb715 = (boardScopeGQL)=>{
    const issues = $c2a0409d5db822bd$export$73a53226406d7fe(boardScopeGQL);
    const people = $c2a0409d5db822bd$export$b9c97d5330cbe844(boardScopeGQL.board);
    const projects = [
        $c2a0409d5db822bd$export$637b60a42bb03f06(boardScopeGQL)
    ];
    const filteredCardIds = (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false) ? boardScopeGQL.board.filteredCardIds : undefined;
    const config = {
        rankCustomFieldId: Number(boardScopeGQL.board.rankCustomFieldId),
        boardIsRankable: true
    };
    const hasFilteredIssues = boardScopeGQL.board.hasClearedIssues;
    const columns = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(boardScopeGQL.board.columns) && boardScopeGQL.board.columns.map($c2a0409d5db822bd$export$71ab8832c85346b) || [];
    const projectIssueTypes = $c2a0409d5db822bd$export$4cf4b24b88599615((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'projectLocation',
        'issueTypes'
    ], []));
    const swimlaneModeId = $c2a0409d5db822bd$export$15e690098786978a(boardScopeGQL, projectIssueTypes);
    const sprints = $c2a0409d5db822bd$export$1b132ed8629e9cb0(boardScopeGQL);
    const features = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'features'
    ], []);
    const isSprintsEnabled = features.filter((f)=>f.key === 'SPRINTS' && f.status === 'ENABLED').length > 0;
    const isBacklogEnabled = features.filter((f)=>f.key === 'BACKLOG' && f.status === 'ENABLED').length > 0;
    const isReportsEnabled = features.filter((f)=>f.key === 'REPORTS' && f.status === 'ENABLED').length > 0;
    const isEstimationFeatureEnabled = features.filter((f)=>f.key === 'ESTIMATION' && f.status === 'ENABLED').length > 0;
    const isReleasesFeatureEnabled = features.filter((f)=>f.key === 'RELEASES' && f.status === 'ENABLED').length > 0;
    const capabilities = {
        BACKLOG: isBacklogEnabled,
        SPRINTS: isSprintsEnabled,
        REPORTS: isReportsEnabled,
        ESTIMATION: isEstimationFeatureEnabled,
        RELEASES: isReleasesFeatureEnabled,
        ...(0, $4R6GH.fg)('jira-warepil-standup-toggle') ? {
            STANDUP: $c2a0409d5db822bd$var$isEnabled('STANDUP', features)
        } : {}
    };
    const estimationStatistic = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'estimation',
        'current',
        'customFieldId'
    ]);
    // fetching the Epic issue type from all issueType
    const parentHierarchyIssueType = projectIssueTypes.find((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE));
    const boardPermissions = (0, $bO1Vt.getBoardPermissions)(boardScopeGQL.currentUser.permissions);
    let inlineCardCreate;
    if ((0, $4R6GH.fg)('use_backend_tmp_icc_config_')) inlineCardCreate = boardScopeGQL.board.inlineCardCreateConfig;
    else inlineCardCreate = $c2a0409d5db822bd$var$canHaveICC(boardPermissions, isSprintsEnabled, sprints) ? {
        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
    } : undefined;
    return {
        issues: issues,
        people: people,
        projects: projects,
        config: config,
        hasFilteredIssues: hasFilteredIssues,
        columns: columns,
        swimlaneModeId: swimlaneModeId,
        sprints: sprints,
        isSprintsEnabled: isSprintsEnabled,
        boardName: boardScopeGQL.board.name,
        capabilities: capabilities,
        inlineCardCreate: inlineCardCreate,
        isInlineColumnEditEnabled: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'board',
            'editConfig',
            'inlineColumnEdit',
            'enabled'
        ], false),
        issueParents: $c2a0409d5db822bd$export$7a0cb16aa5a43d4d(boardScopeGQL),
        issueTypes: $c2a0409d5db822bd$export$4cf4b24b88599615((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'board',
            'issueTypes'
        ], [])),
        projectIssueTypes: [
            ...projectIssueTypes
        ],
        boardPermissions: boardPermissions,
        issueChildren: $c2a0409d5db822bd$export$9ed60bbe06bbd06b((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
            'board',
            'issueChildren'
        ], []), projects[0].id, columns, estimationStatistic),
        allFeatures: [
            ...boardScopeGQL.features.map((feature)=>({
                    ...feature
                }))
        ],
        cardTransitions: $c2a0409d5db822bd$export$c5f25828191314fe(projects[0].key, boardScopeGQL.board.columns.map((column)=>({
                ...column
            })), parentHierarchyIssueType?.id),
        estimationStatistic: estimationStatistic,
        filteredCardIds: filteredCardIds
    };
};
// Defines the inline card create config for the TMP board
// Based on config, inline create experience can vary per columns and issue types (e.g. can trigger GIC with pre-filled fields)
//
// Conditions for inline create to appear:
// 1. User has create issue permission
// 2. If board is scrum board and there is an active sprint
// 3. Issues can be created in any statuses (if not, then inline create restricted to columns with initial statuses only)
// 4. If issue types have required fields, then inline create is partial (it will accept input, than open GIC with pre-filled fields)
//
// This serves as an interim solution until the ICC eligibility conditions are transferred to BE, similar to the process implemented for the CMP board
const $c2a0409d5db822bd$var$getInlineCardCreate = (boardScopeGQL, globalConfigGQL)=>{
    const boardPermissions = (0, $bO1Vt.getBoardPermissions)(boardScopeGQL.currentUser.permissions);
    const isSprintsEnabled = $c2a0409d5db822bd$var$isEnabled('SPRINTS', boardScopeGQL.features);
    const isIccEnabled = $c2a0409d5db822bd$var$canHaveICC(boardPermissions, isSprintsEnabled, $c2a0409d5db822bd$export$1b132ed8629e9cb0(boardScopeGQL));
    const { columns: columns } = boardScopeGQL.board;
    if (!isIccEnabled || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columns)) return undefined;
    const isAnyStatusInCreateEnabled = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(globalConfigGQL, [
        'applicationProperties',
        'createStatusIsEnabled'
    ]);
    const issueTypes = $c2a0409d5db822bd$export$4cf4b24b88599615((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(boardScopeGQL, [
        'projectLocation',
        'issueTypes'
    ], [])).filter(// Filter out issue types with hierarchy level PARENT or higher, to avoid unneccessary
    // logic with MIXED icc mode when only parent issue types have required fields.
    (issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.BASE_HIERARCHY_TYPE) || issueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE));
    const hasRequiredFields = issueTypes.some((issueType)=>!!issueType.hasRequiredFields);
    if (isAnyStatusInCreateEnabled !== false && !hasRequiredFields) return {
        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
    };
    const initalConfig = {
        mode: (0, $c8d1b8aabfd899d6$export$bb410559a65d3418),
        columns: {}
    };
    const issueTypesInIcc = hasRequiredFields ? issueTypes.reduce((issueTypesAcc, issueType)=>Object.assign(issueTypesAcc, {
            [issueType.id]: issueType.hasRequiredFields ? (0, $c8d1b8aabfd899d6$export$c6861d2875ea3898) : (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
        }), {}) : undefined;
    const inlineCardCreateConfig = columns.reduce((acc, column)=>{
        if (acc.columns !== undefined && (isAnyStatusInCreateEnabled !== false || column.columnStatus.some((status)=>status.transitions.some((t)=>t.isInitial)))) acc.columns[Number(column.id)] = {
            mode: hasRequiredFields ? (0, $c8d1b8aabfd899d6$export$bb410559a65d3418) : (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b),
            issueTypes: issueTypesInIcc
        };
        return acc;
    }, initalConfig);
    return inlineCardCreateConfig;
};
const $c2a0409d5db822bd$var$canHaveICC = (boardPermissions, isSprintsEnabled, sprints)=>boardPermissions.createIssue === true && (!isSprintsEnabled || sprints.length > 0);
const $c2a0409d5db822bd$export$ccde3e79901f52d6 = (nonCriticalDataResponse)=>({
        ...$c2a0409d5db822bd$export$9bbdc053b14eb715(nonCriticalDataResponse.boardScope),
        boardConfig: $c2a0409d5db822bd$export$5f9288f90460d6e(nonCriticalDataResponse.boardScope, nonCriticalDataResponse.jira, nonCriticalDataResponse.globalConfig),
        oldDoneIssuesCutOffConfig: $c2a0409d5db822bd$export$24644632d725afd9(nonCriticalDataResponse.boardScope),
        issueMedia: (0, (/*@__PURE__*/$parcel$interopDefault($6Csk1)))($c2a0409d5db822bd$export$8c80ff32686eb3f(nonCriticalDataResponse.boardScope.board), $c2a0409d5db822bd$export$a064de9c304ad444(nonCriticalDataResponse.boardScope.board)),
        requestTypes: [],
        statuses: [],
        ...!(0, $4R6GH.fg)('use_backend_tmp_icc_config_') && {
            inlineCardCreate: $c2a0409d5db822bd$var$getInlineCardCreate(nonCriticalDataResponse.boardScope, nonCriticalDataResponse.globalConfig)
        }
    });

});
// Note to maintainer: Add GraphQL enum on the server instead of using a scalar
// then replace all of this any you'll be back to what you intend
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $68cf6bf1ce76db03$export$b893894941c14e43 = 'EDIT_BOARD_CONFIG';
const $68cf6bf1ce76db03$export$4e8756b18ce4cf17 = 'DELETE_ISSUE';
const $68cf6bf1ce76db03$export$a84692caf5a334ea = 'CREATE_ISSUE';
const $68cf6bf1ce76db03$export$47e89ba04d79d88d = 'MANAGE_SPRINT';
const $68cf6bf1ce76db03$export$52f11126cce982f0 = 'EDIT_ISSUE';
const $68cf6bf1ce76db03$export$554b2c24370f61c1 = 'MANAGE_AUTOMATION';
const $68cf6bf1ce76db03$export$f6220122141a5652 = 'LINK_ISSUE';
const $68cf6bf1ce76db03$export$84886e19f4ac5f8e = 'ARCHIVE_ISSUE';
const $68cf6bf1ce76db03$export$e3e5ec492e10f340 = 'ASSIGN_ISSUE';
const $68cf6bf1ce76db03$export$176d93d775c60d1d = 'SCHEDULE_ISSUE';

parcelRegister("bO1Vt", function(module, exports) {

$parcel$export(module.exports, "getBoardPermissions", () => $7e42d3062e574a13$export$6e76d430ac3d961);

const $7e42d3062e574a13$export$6e76d430ac3d961 = (boardPermissions)=>({
        createIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$a84692caf5a334ea)),
        deleteIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$4e8756b18ce4cf17)),
        manageSprint: boardPermissions.includes((0, $68cf6bf1ce76db03$export$47e89ba04d79d88d)),
        editBoardConfig: boardPermissions.includes((0, $68cf6bf1ce76db03$export$b893894941c14e43)),
        editIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$52f11126cce982f0)),
        manageAutomation: boardPermissions.includes((0, $68cf6bf1ce76db03$export$554b2c24370f61c1)),
        archiveIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$84886e19f4ac5f8e)),
        assignIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$e3e5ec492e10f340)),
        scheduleIssue: boardPermissions.includes((0, $68cf6bf1ce76db03$export$176d93d775c60d1d))
    });

});

parcelRegister("cjoN4", function(module, exports) {

$parcel$export(module.exports, "swimlaneModeToStrategiesFilterRefinement", () => $bd901d53ae51226f$export$6942025d51df3dd1);
$parcel$export(module.exports, "swimlaneStrategiesToMode", () => $bd901d53ae51226f$export$866fc1e015e78d67);
$parcel$export(module.exports, "transformSwimlaneModeToApi", () => $bd901d53ae51226f$export$dd327d08709313eb);

var $iuuJH = parcelRequire("iuuJH");
const $bd901d53ae51226f$export$6b0228c67b1e82cf = {
    NO_SWIMLANE: 'none',
    SWIMLANE_BY_JQL: 'jql',
    SWIMLANE_BY_ASSIGNEE: 'assignee',
    SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST: 'assigneeunassignedfirst',
    SWIMLANE_BY_PARENT_ISSUE: 'issueparent',
    SWIMLANE_BY_SUBTASK: 'issuechildren',
    SWIMLANE_BY_PROJECT: 'project',
    SWIMLANE_BY_TEAM: 'team',
    SWIMLANE_BY_REQUEST_TYPE: 'requesttype'
};
const $bd901d53ae51226f$export$6942025d51df3dd1 = {
    NO_SWIMLANE: 'NONE',
    SWIMLANE_BY_JQL: 'NONE',
    SWIMLANE_BY_ASSIGNEE: 'ASSIGNEE_UNASSIGNED_LAST',
    SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST: 'ASSIGNEE_UNASSIGNED_FIRST',
    SWIMLANE_BY_PARENT_ISSUE: 'ISSUE_PARENT',
    SWIMLANE_BY_SUBTASK: 'ISSUE_CHILDREN',
    SWIMLANE_BY_PROJECT: 'PROJECT',
    SWIMLANE_BY_TEAM: 'NONE',
    SWIMLANE_BY_REQUEST_TYPE: 'REQUEST_TYPE'
};
const $bd901d53ae51226f$export$866fc1e015e78d67 = {
    none: (0, $iuuJH.NO_SWIMLANE).id,
    jql: (0, $iuuJH.SWIMLANE_BY_JQL).id,
    assignee: (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id,
    issueparent: (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id,
    assigneeunassignedfirst: (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id,
    issuechildren: (0, $iuuJH.SWIMLANE_BY_SUBTASK).id,
    project: (0, $iuuJH.SWIMLANE_BY_PROJECT).id,
    team: (0, $iuuJH.SWIMLANE_BY_TEAM).id,
    requesttype: (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id
};
const $bd901d53ae51226f$export$dd327d08709313eb = (swimlaneModeId)=>$bd901d53ae51226f$export$6b0228c67b1e82cf[swimlaneModeId] || 'none';

});

parcelRegister("bDyOs", function(module, exports) {

$parcel$export(module.exports, "calculateEstimateValue", () => $9bde04010432e1f5$export$33f32b887d0f86d3);



var $cn1Wo = parcelRequire("cn1Wo");
const $9bde04010432e1f5$export$33f32b887d0f86d3 = (estimate, estimationStatisticFieldId)=>{
    if (!estimationStatisticFieldId) return null;
    if (estimationStatisticFieldId === (0, $dcbb2bce513725b3$export$d02889a654103c98)) return {
        type: (0, $b383ed62f6689e0b$export$73bc902d1e240cad),
        displayName: (0, $cn1Wo.default).originalEstimateDisplayLabel,
        fieldId: estimationStatisticFieldId,
        value: estimate?.originalEstimate?.value,
        valueAsText: estimate?.originalEstimate?.valueAsText
    };
    return {
        type: (0, $b383ed62f6689e0b$export$a092d6877c35430e),
        fieldId: estimationStatisticFieldId,
        displayName: (0, $cn1Wo.default).storyPointsDisplayLabel,
        value: estimate?.storyPoints ?? undefined
    };
};

});
parcelRegister("cn1Wo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9e57d33efcda9b6c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9e57d33efcda9b6c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    storyPointsDisplayLabel: {
        "id": "software.main.services.utils.estimation.story-points-display-label",
        "defaultMessage": "{value, plural, one {# story point} other {# story points}}"
    },
    originalEstimateDisplayLabel: {
        "id": "software.main.services.utils.estimation.original-estimate-display-label",
        "defaultMessage": "{value} original estimate"
    },
    remainingEstimateDisplayLabel: {
        "id": "software.main.services.utils.estimation.remaining-estimate-display-label",
        "defaultMessage": "{value} remaining"
    }
});

});



parcelRegister("6fpfm", function(module, exports) {

$parcel$export(module.exports, "cardRefreshBoardScopeService", () => $aeec9a375ba45eb3$export$58e261badcfdf3ce);

var $37XVp = parcelRequire("37XVp");
const $aeec9a375ba45eb3$export$58e261badcfdf3ce = (contextPath, boardId, cardIds, shouldLoadChildren = true)=>(0, $37XVp.fetchCardRefreshBoardScopeData)(contextPath, boardId, cardIds, shouldLoadChildren);

});
parcelRegister("37XVp", function(module, exports) {

$parcel$export(module.exports, "fetchCardRefreshBoardScopeData", () => $6042aeb19b49bdfa$export$669392d2ca93f95a);

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");
const $6042aeb19b49bdfa$var$softwareBoardCardOperationName = 'SoftwareBoardCard';
const $6042aeb19b49bdfa$export$5feba1c4cb038873 = (boardId, cardIds, shouldLoadChildren)=>{
    const issueChildren = shouldLoadChildren ? `board {
            issueChildren {
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                issue {
                    id
                    key
                    summary
                    labels
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type { id, name, iconUrl }
                    status { id }
                    activeSprint { id }
                }
                coverMedia {
                    attachmentId
                    endpointUrl
                    clientId
                    token
                    attachmentMediaApiId
                    hiddenByUser
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
        }` : '';
    return `query ${$6042aeb19b49bdfa$var$softwareBoardCardOperationName} {
        boardScope(boardId:${boardId}){
            projectLocation {
                id
            }
            cards(cardIds: [${String(cardIds)}]){
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                coverMedia{
                    attachmentId
                    endpointUrl
                    clientId
                    token
                    attachmentMediaApiId
                    hiddenByUser
                }
                issue{
                    id
                    key
                    summary
                    labels
                    status{
                        id
                        name
                    }
                    assignee{
                        accountId
                        displayName
                        avatarUrl
                    }
                    type{
                        id
                        name
                        iconUrl
                    }
                    activeSprint { id }
                }
                childIssuesMetadata { complete, total }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }
            ${issueChildren}
        }
    }`;
};
const $6042aeb19b49bdfa$var$fetchBoardScopeCardData = (boardId, cardIds, shouldLoadChildren)=>({
        method: 'POST',
        body: JSON.stringify({
            operationName: $6042aeb19b49bdfa$var$softwareBoardCardOperationName,
            query: $6042aeb19b49bdfa$export$5feba1c4cb038873(boardId, cardIds, shouldLoadChildren)
        })
    });
const $6042aeb19b49bdfa$export$669392d2ca93f95a = (contextPath, boardId, cardIds, shouldLoadChildren = true)=>(0, $487fd.default)((0, $2bQEl.getJSWGraphQlEndpointUrl)(contextPath), $6042aeb19b49bdfa$var$fetchBoardScopeCardData(boardId, cardIds, shouldLoadChildren));

});


parcelRegister("252qi", function(module, exports) {

$parcel$export(module.exports, "cardRefreshMediaTransformer", () => $b487bc2022acb2c1$export$d5c84a2e797269cc);
$parcel$export(module.exports, "cardRefreshIssueTransformer", () => $b487bc2022acb2c1$export$230f7a3cfbfec489);

var $7uUwQ = parcelRequire("7uUwQ");

var $bDyOs = parcelRequire("bDyOs");
const $b487bc2022acb2c1$export$d5c84a2e797269cc = (cardId, card)=>{
    const collection = {};
    if (card === null || !card.coverMedia || card.id !== cardId) {
        collection[cardId] = {
            isHiddenByUser: true
        };
        return collection;
    }
    const { endpointUrl: endpointUrl, clientId: clientId, token: token, attachmentId: attachmentId, attachmentMediaApiId: attachmentMediaApiId } = card.coverMedia;
    collection[String(cardId)] = {
        isHiddenByUser: false,
        endpointUrl: endpointUrl,
        clientId: clientId,
        token: token,
        attachmentId: attachmentId,
        attachmentMediaApiId: String(attachmentMediaApiId)
    };
    return collection;
};
const $b487bc2022acb2c1$export$230f7a3cfbfec489 = (projectId, column, estimateFieldId, card)=>{
    const { id: id, issue: { key: key, summary: summary, labels: labels, status: status, type: { id: typeId, name: typeName, iconUrl: typeUrl }, assignee: assignee }, done: isDone, flagged: isFlagged, parentId: parentId, estimate: estimate, priority: priority, dueDate: dueDate, childIssuesMetadata: childIssuesMetadata } = card;
    const sprintId = card.issue.activeSprint?.id ?? '';
    const assigneeAccountId = assignee && {
        assigneeAccountId: assignee.accountId
    };
    const columnId = column && {
        columnId: column.id
    };
    return (0, $7uUwQ.freeze)({
        id: Number(id),
        key: key,
        summary: summary,
        statusId: Number(status.id),
        ...columnId,
        projectId: Number(projectId),
        typeId: Number(typeId),
        typeName: typeName,
        typeUrl: typeUrl,
        ...assigneeAccountId,
        isFlagged: // devStatus TODO https://jdog.jira-dev.com/browse/ABS-257
        isFlagged,
        labels: [
            ...labels
        ],
        isDone: isDone,
        parentId: Number(parentId) || null,
        estimate: (0, $bDyOs.calculateEstimateValue)(estimate, estimateFieldId),
        priority: priority ? {
            ...priority
        } : null,
        dueDate: dueDate || null,
        numCompleteChildren: childIssuesMetadata ? childIssuesMetadata.complete : 0,
        numTotalChildren: childIssuesMetadata ? childIssuesMetadata.total : 0,
        sprintId: sprintId
    });
};

});

parcelRegister("lF9PL", function(module, exports) {

$parcel$export(module.exports, "transformPerson", () => $fb948c35f99f88f8$export$6a0763407d6de4b9);
$parcel$export(module.exports, "cardRefreshPersonTransformer", () => $fb948c35f99f88f8$export$4e2039085623abd6);
const $fb948c35f99f88f8$export$6a0763407d6de4b9 = (user)=>{
    const { displayName: displayName, accountId: accountId } = user;
    return {
        id: accountId,
        displayName: displayName,
        avatarUrl: user.avatarUrls && user.avatarUrls['48x48']
    };
};
const $fb948c35f99f88f8$export$4e2039085623abd6 = (cardAssignee)=>{
    const { displayName: displayName, avatarUrl: avatarUrl, accountId: accountId } = cardAssignee;
    return {
        id: accountId,
        displayName: displayName,
        avatarUrl: avatarUrl
    };
};

});

parcelRegister("dN3Ms", function(module, exports) {

$parcel$export(module.exports, "ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST", () => $3b79a5866454876b$export$74f28ea71139942);
$parcel$export(module.exports, "ISSUE_MEDIA_VISIBILITY_CHANGE_SUCCESS", () => $3b79a5866454876b$export$2b8c4e2590a67bf6);
$parcel$export(module.exports, "issueMediaVisibilityChangeSuccess", () => $3b79a5866454876b$export$2971d39a697e3ae7);
$parcel$export(module.exports, "issueMediaVisibilityChangeFailure", () => $3b79a5866454876b$export$e96d312c45990dd1);

var $9rND4 = parcelRequire("9rND4");
const $3b79a5866454876b$export$74f28ea71139942 = 'state.actions.issue.media.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST';
const $3b79a5866454876b$export$b1b981f00a4325d = (issueId, isVisible)=>({
        type: $3b79a5866454876b$export$74f28ea71139942,
        payload: {
            issueId: issueId,
            isVisible: isVisible
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $3b79a5866454876b$export$2b8c4e2590a67bf6 = 'state.actions.issue.media.ISSUE_MEDIA_VISIBILITY_CHANGE_SUCCESS';
const $3b79a5866454876b$export$2971d39a697e3ae7 = (optimisticId, issueId, isVisible)=>({
        type: $3b79a5866454876b$export$2b8c4e2590a67bf6,
        payload: {
            issueId: issueId,
            isVisible: isVisible
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $3b79a5866454876b$export$ebff87f39ef732cb = 'state.actions.issue.media.ISSUE_MEDIA_VISIBILITY_CHANGE_FAILURE';
const $3b79a5866454876b$export$e96d312c45990dd1 = (optimisticId)=>({
        type: $3b79a5866454876b$export$ebff87f39ef732cb,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});

parcelRegister("evkwq", function(module, exports) {

$parcel$export(module.exports, "ISSUE_UPDATE_REQUEST", () => $9d6313849b2d7855$export$7285b51affc95621);
$parcel$export(module.exports, "issueUpdateRequestWithTransactionId", () => $9d6313849b2d7855$export$1203f74fc478d4cf);
$parcel$export(module.exports, "issueUpdateRequest", () => $9d6313849b2d7855$export$f30638dd71fdf98d);
$parcel$export(module.exports, "ISSUE_UPDATE_SUCCESS", () => $9d6313849b2d7855$export$e26c3ff402573522);
$parcel$export(module.exports, "issueUpdateFailure", () => $9d6313849b2d7855$export$2128979ebf312943);
$parcel$export(module.exports, "ISSUE_BENTO_UPDATE", () => $9d6313849b2d7855$export$7ab59871c3a39808);
$parcel$export(module.exports, "issueBentoUpdate", () => $9d6313849b2d7855$export$3066c3fab411604b);
$parcel$export(module.exports, "SET_ISSUE_PARENT", () => $9d6313849b2d7855$export$3acc54c28c7b46c1);
$parcel$export(module.exports, "setIssueParent", () => $9d6313849b2d7855$export$6bdf52f105cc4319);
$parcel$export(module.exports, "issueIncrementPlanningUpdateSuccess", () => $9d6313849b2d7855$export$2c7c57af8e3deb8);
$parcel$export(module.exports, "issueIncrementPlanningUpdateFailed", () => $9d6313849b2d7855$export$80e317938cb55070);
$parcel$export(module.exports, "ISSUE_INCREMENT_PLANNING_UPDATE", () => $9d6313849b2d7855$export$7f1f6552f76e0f62);
$parcel$export(module.exports, "issueIncrementPlanningUpdate", () => $9d6313849b2d7855$export$59aff2f80ca5eb52);

var $7Jxgt = parcelRequire("7Jxgt");


var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $9d6313849b2d7855$export$7285b51affc95621 = 'state.actions.issue.update.ISSUE_UPDATE_REQUEST';
const $9d6313849b2d7855$export$1203f74fc478d4cf = (issueIds, origin, transactionId)=>({
        type: $9d6313849b2d7855$export$7285b51affc95621,
        payload: {
            issueIds: issueIds,
            origin: origin,
            transactionId: transactionId
        }
    });
const $9d6313849b2d7855$export$f30638dd71fdf98d = (issueIds, origin = (0, $f32ae13c2b9742f4$export$d46a05f8561f868a))=>$9d6313849b2d7855$export$1203f74fc478d4cf(issueIds, origin, (0, $7Jxgt.v4)());
const $9d6313849b2d7855$export$e26c3ff402573522 = 'state.actions.issue.update.ISSUE_UPDATE_SUCCESS';
const $9d6313849b2d7855$export$5b5bc0de8568f975 = (issue, origin)=>({
        type: $9d6313849b2d7855$export$e26c3ff402573522,
        payload: {
            issue: issue,
            origin: origin
        }
    });
const $9d6313849b2d7855$export$8caae7a939724b26 = 'state.actions.issue.update.ISSUE_UPDATE_FAILURE';
const $9d6313849b2d7855$export$2128979ebf312943 = (errorString)=>({
        type: $9d6313849b2d7855$export$8caae7a939724b26,
        payload: {
            errorString: errorString
        }
    });
const $9d6313849b2d7855$export$7ab59871c3a39808 = 'state.actions.issue.update.ISSUE_BENTO_UPDATE';
const $9d6313849b2d7855$export$3066c3fab411604b = (payload, transactionId = (0, $7Jxgt.v4)())=>({
        type: $9d6313849b2d7855$export$7ab59871c3a39808,
        payload: payload,
        meta: {
            transactionId: transactionId
        }
    });
const $9d6313849b2d7855$export$3acc54c28c7b46c1 = 'state.actions.issue.update.SET_ISSUE_PARENT';
const $9d6313849b2d7855$export$6bdf52f105cc4319 = (issueId, issueParentId)=>({
        type: $9d6313849b2d7855$export$3acc54c28c7b46c1,
        payload: {
            issueId: issueId,
            issueParentId: issueParentId
        }
    });
const $9d6313849b2d7855$export$3457bc01094e4186 = 'state.actions.issue.update.ISSUE_INCREMENT_PLANNING_UPDATE_SUCCESS';
const $9d6313849b2d7855$export$2c7c57af8e3deb8 = ()=>({
        type: $9d6313849b2d7855$export$3457bc01094e4186
    });
const $9d6313849b2d7855$export$6240223118018833 = 'state.actions.issue.update.ISSUE_INCREMENT_PLANNING_UPDATE_FAILURE';
const $9d6313849b2d7855$export$80e317938cb55070 = ()=>({
        type: $9d6313849b2d7855$export$6240223118018833,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });
const $9d6313849b2d7855$export$7f1f6552f76e0f62 = 'state.actions.issue.update.ISSUE_INCREMENT_PLANNING_UPDATE';
const $9d6313849b2d7855$export$59aff2f80ca5eb52 = (payload)=>({
        type: $9d6313849b2d7855$export$7f1f6552f76e0f62,
        payload: payload
    });

});


parcelRegister("enaRv", function(module, exports) {

$parcel$export(module.exports, "default", () => $e5d1140138f38460$export$2e2bcd8739ae039);
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("3awJm");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $d1i1b = parcelRequire("d1i1b");

var $2f454 = parcelRequire("2f454");

var $dW1HX = parcelRequire("dW1HX");

var $9OPlz = parcelRequire("9OPlz");

var $fqLDH = parcelRequire("fqLDH");

var $gR0bs = parcelRequire("gR0bs");

var $d2i8f = parcelRequire("d2i8f");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e5d1140138f38460$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $2f454.CARD_NEXT), (0, $2f454.CARD_PREV)).throttleTime(200).mergeMap(({ type: type, payload: payload })=>{
        const state = store.getState();
        const activeCardId = (0, $9OPlz.getCardActive)(state);
        // Applying a filter or collapsing a swimlane does not clear the active card,
        // So we need to check manually if it is actually visible.
        const isActiveCardVisible = (0, $gR0bs.isActiveCardVisible)(state);
        const isCardNext = type === (0, $2f454.CARD_NEXT);
        const getFirstSelectableIssueFn = isCardNext ? (0, $gR0bs.getFirstSelectableIssueAscending) : (0, $gR0bs.getFirstSelectableIssueDescending);
        const getNextOrPrevIssueFn = isCardNext ? (0, $gR0bs.getNextSelectableIssue) : (0, $gR0bs.getPrevSelectableIssue);
        const newActiveIssueId = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeCardId) || !isActiveCardVisible ? getFirstSelectableIssueFn(state) : getNextOrPrevIssueFn(state)(activeCardId);
        const attributes = isCardNext ? {
            id: 'nextIssueKeyboardShortcut',
            key: 'j'
        } : {
            id: 'previousIssueKeyboardShortcut',
            key: 'k'
        };
        payload.fireShortcutAnalyticsFn(attributes);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(newActiveIssueId)) return (0, $kVLXA.Observable).empty();
        const actions = [
            (0, $2f454.cardSingleSelect)(newActiveIssueId),
            (0, $2f454.cardFocus)(newActiveIssueId),
            (0, $d1i1b.cardAutoScroll)(newActiveIssueId)
        ];
        if ((0, $fqLDH.isIssueModalShowingSelector)(state)) {
            const issueKey = (0, $d2i8f.getIssueById)(state, newActiveIssueId).key;
            actions.push((0, $dW1HX.openIssueModalDebounced)(issueKey));
        }
        return (0, $kVLXA.Observable).from(actions);
    });

});

parcelRegister("hh3dt", function(module, exports) {

$parcel$export(module.exports, "default", () => $d881c0d70ff61978$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $2f454 = parcelRequire("2f454");

var $67Z81 = parcelRequire("67Z81");
function $d881c0d70ff61978$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $2f454.CARD_DRAG_OVER_TRANSITION_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const { transitionId: transitionId, toColumnId: toColumnId, hoverIntent: hoverIntent } = action.payload;
        if (isCMPBoard) // We always avoid passing the hover intent in a CMP board, so the ranking mode is disabled when hovering on the transition zone
        return (0, $kVLXA.Observable).of((0, $2f454.cardDragOverTransition)(transitionId, toColumnId, false));
        return (0, $kVLXA.Observable).of((0, $2f454.cardDragOverTransition)(transitionId, toColumnId, hoverIntent));
    });
}

});

parcelRegister("erSBH", function(module, exports) {

$parcel$export(module.exports, "checkGlobalIssueCreateEpic", () => $23cee30e0dc21388$export$c92e72129db344be);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $6s1PB = parcelRequire("6s1PB");


var $iuuJH = parcelRequire("iuuJH");

var $1YOzt = parcelRequire("1YOzt");

var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $k8auG = parcelRequire("k8auG");

var $fyeGd = parcelRequire("fyeGd");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $23cee30e0dc21388$export$c92e72129db344be = (action$, store)=>// @ts-expect-error - TS2684 - The 'this' context of type 'ActionsObservable<Action>' is not assignable to method's 'this' of type 'Observable<CheckGlobalIssueCreateAction>'.
    action$.ofType((0, $1YOzt.CHECK_GLOBAL_ISSUE_CREATE)).mergeMap((action)=>{
        const { payload: { issues: globalIssues } } = action;
        if (globalIssues.length === 0) return (0, $kVLXA.Observable).empty();
        const state = store.getState();
        const cardKeys = globalIssues.map((issue)=>String(issue.issueKey));
        const columnStatusIds = (0, $fyeGd.getStatusIdsOfColumns)(state).map((statusId)=>String(statusId));
        let issueType;
        if ((0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) issueType = globalIssues[0].createdIssueDetails?.fields.issuetype.name;
        const unmappedIssuesExist = globalIssues.filter((issue)=>issue.createdIssueDetails && issue.createdIssueDetails.fields.issuetype.hierarchyLevel < 1).some((issue)=>issue.createdIssueDetails && !columnStatusIds.includes(issue.createdIssueDetails.fields.status.id));
        if (unmappedIssuesExist) return (0, $kVLXA.Observable).of((0, $ls4NM.cardCreateUnmapped)(cardKeys));
        const hasNoActiveSprint = (0, $ebHh7.hasNoActiveSprintStateSelector)(state);
        const sprints = hasNoActiveSprint ? null : (0, $ebHh7.activeSprintsSelector)(state);
        // If issues are not present on the board (not being in a current sprint) or are hidden due to any filter, show a flag as well
        const invisibleIssueKeys = (0, $5mTgl.getInvisibleIssueKeys)(state)(cardKeys);
        if (invisibleIssueKeys.length > 0) return hasNoActiveSprint ? (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateFilteredV2)(invisibleIssueKeys)) : (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateFilteredV2)(invisibleIssueKeys, sprints));
        if ((0, $45cXl.getSwimlaneMode)(state) === (0, $iuuJH.SWIMLANE_BY_JQL).id) {
            const jqlSwimlanes = (0, $k8auG.getJQLSwimlanesData)(state);
            if (!jqlSwimlanes) return (0, $kVLXA.Observable).of((0, $ls4NM.cardCreateGlobal)(cardKeys, issueType));
            const jqlSwimlanesMap = {};
            let defaultSwimlaneId = '';
            jqlSwimlanes.forEach((swimlane)=>{
                if (swimlane.isDefaultSwimlane) defaultSwimlaneId = swimlane.id;
                Object.assign(jqlSwimlanesMap, {
                    [swimlane.id]: new Set(swimlane.issueIds)
                });
            });
            // If we have not returned before this, then we know that the issue is present on the board.
            // We just need to check if any of the created issues is missing from the swimlane that it was created in,
            // and then we can infer that it has been moved to a different swimlane.
            const issuesRemovedFromSwimlane = globalIssues.find((issue)=>{
                if (!issue.jqlSwimlaneId) return false;
                const originalSwimlaneId = issue.jqlSwimlaneId === (0, $dcbb2bce513725b3$export$26ad7c86aba35f49) ? defaultSwimlaneId : issue.jqlSwimlaneId;
                return !jqlSwimlanesMap[originalSwimlaneId]?.has(issue.issueId);
            });
            if (issuesRemovedFromSwimlane) return (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateMovedBetweenJqlSwimlanes)(cardKeys));
        }
        return (0, $kVLXA.Observable).of((0, $ls4NM.cardCreateGlobal)(cardKeys, issueType));
    });

});
parcelRegister("1YOzt", function(module, exports) {

$parcel$export(module.exports, "CHECK_GLOBAL_ISSUE_CREATE", () => $94c6996ad1d1ae55$export$d3342655e6919343);
$parcel$export(module.exports, "checkGlobalIssueCreate", () => $94c6996ad1d1ae55$export$d2425890b90f3347);
const $94c6996ad1d1ae55$export$d3342655e6919343 = 'state.actions.check-global-issue-create.CHECK_GLOBAL_ISSUE_CREATE';
const $94c6996ad1d1ae55$export$d2425890b90f3347 = (issues)=>({
        type: $94c6996ad1d1ae55$export$d3342655e6919343,
        payload: {
            issues: issues
        }
    });

});


parcelRegister("dNJJS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7659694ae75062d$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("c66Ur");
parcelRequire("fPS7b");


var $cSLHE = parcelRequire("cSLHE");

var $glGhK = parcelRequire("glGhK");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
const $d7659694ae75062d$var$columnCreate = (state, action)=>{
    const contextPath = (0, $67Z81.contextPathSelector)(state);
    const boardId = (0, $67Z81.rapidViewIdSelector)(state);
    const projectKey = (0, $67Z81.projectKeySelector)(state);
    const { name: name } = action.payload;
    return (0, $cSLHE.default)(contextPath, boardId, name, projectKey);
};
const $d7659694ae75062d$var$handleFailure = (action, error)=>{
    const { meta: { analyticsEvent: analyticsEvent } } = action;
    return (0, $kVLXA.Observable).of((0, $glGhK.columnCreateFailure)(action.meta.optimistic.id, action.payload.temporaryColumnId, error, analyticsEvent));
};
const $d7659694ae75062d$var$handleSuccess = (action, result, state)=>{
    const { payload: { temporaryColumnId: temporaryColumnId }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
    const { column: column, columns: columns, cardTransitions: cardTransitions } = result;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const actions = [
        (0, $glGhK.columnCreateSuccess)(optimistic.id, temporaryColumnId, column, columns, cardTransitions, analyticsEvent)
    ];
    if (isCMPBoard) actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$bddadd6eeae21573)));
    return (0, $kVLXA.Observable).from(actions);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d7659694ae75062d$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $glGhK.COLUMN_CREATE_REQUEST)).mergeMap((action)=>$d7659694ae75062d$var$columnCreate(store.getState(), action).flatMap((result)=>$d7659694ae75062d$var$handleSuccess(action, result, store.getState())).catch((error)=>$d7659694ae75062d$var$handleFailure(action, error)));

});
parcelRegister("cSLHE", function(module, exports) {

$parcel$export(module.exports, "default", () => $096f6b6f8ee5bb24$export$2e2bcd8739ae039);
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $fo45h = parcelRequire("fo45h");

var $hjlQ8 = parcelRequire("hjlQ8");
const $096f6b6f8ee5bb24$export$51186ad6e864892a = (projectKey, data)=>({
        column: (0, $hjlQ8.transformColumn)(data.newColumn),
        columns: data.columns.map((0, $hjlQ8.transformColumn)),
        cardTransitions: (0, $hjlQ8.getCardTransitions)(projectKey, data.columns.concat(data.newColumn))
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$096f6b6f8ee5bb24$export$2e2bcd8739ae039 = (contextPath, boardId, columnName, projectKey)=>(0, $fo45h.default)(contextPath, boardId, columnName).flatMap((columnCreateData)=>(0, $kVLXA.Observable).of($096f6b6f8ee5bb24$export$51186ad6e864892a(projectKey, columnCreateData))).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.column.create.graphql.failure', 'Failed to create column via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'message'
            ], '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message'
            ], '')
        });
        return (0, $kVLXA.Observable).throw(error);
    });

});
parcelRegister("fo45h", function(module, exports) {

$parcel$export(module.exports, "default", () => $c70a0a539dbdd9ef$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $Zbn1V = parcelRequire("Zbn1V");

var $CFxE9 = parcelRequire("CFxE9");
const $c70a0a539dbdd9ef$export$d6dad7cb3d8dcedd = 'SoftwareColumnCreate';
const $c70a0a539dbdd9ef$export$66843dda88b883b6 = (0, $ivqh1.gqlTagSwag)`mutation SoftwareColumnCreate($boardId: ID!, $columnName: String!){
        createColumn(input: {boardId: $boardId, columnName: $columnName}) {
            newColumn {
                id
                name
                maxIssueCount
                status {
                    id
                    name
                }
                columnStatus {
                    ...ColumnStatusFragment
                }
                isInitial
                isDone
                transitionId
            }
            columns {
                id
                name
                maxIssueCount
                status {
                    id
                    name
                }
                columnStatus {
                    ...ColumnStatusFragment
                }
                isInitial
                isDone
                transitionId
            }
        }
    }
    
    ${(0, $Zbn1V.ColumnStatusFragment)}
`;
const $c70a0a539dbdd9ef$export$ba14d9a5a581e827 = (data)=>(0, $kVLXA.Observable).of(data.createColumn);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c70a0a539dbdd9ef$export$2e2bcd8739ae039 = (contextPath, boardId, columnName)=>(0, $6iJbJ.mutation$)(contextPath, $c70a0a539dbdd9ef$export$d6dad7cb3d8dcedd, $c70a0a539dbdd9ef$export$66843dda88b883b6, {
        boardId: boardId,
        columnName: columnName
    }, (0, $CFxE9.columnCreateAnalyticsOptions)).flatMap($c70a0a539dbdd9ef$export$ba14d9a5a581e827);

});
parcelRegister("Zbn1V", function(module, exports) {

$parcel$export(module.exports, "ColumnStatusFragment", () => $9ac8bab06ebfc0f2$export$91351318a76e5eab);

var $ivqh1 = parcelRequire("ivqh1");
const $9ac8bab06ebfc0f2$export$91351318a76e5eab = (0, $ivqh1.gqlTagSwag)`
    fragment ColumnStatusFragment on ColumnStatus {
        status {
            id
            name
            category
        }
        transitions {
            id
            name
            status { 
                id
            }
            originStatus { id }
            cardType { id }
            isGlobal
            isInitial
            hasConditions
        }
    }
`;

});



parcelRegister("glGhK", function(module, exports) {

$parcel$export(module.exports, "COLUMN_CREATE_REQUEST", () => $f9561824c85fd000$export$cb06a5725603209e);
$parcel$export(module.exports, "columnCreateRequest", () => $f9561824c85fd000$export$e17a54aca50f971e);
$parcel$export(module.exports, "COLUMN_CREATE_SUCCESS", () => $f9561824c85fd000$export$a26373aaaa8736b1);
$parcel$export(module.exports, "columnCreateSuccess", () => $f9561824c85fd000$export$4d3e535c643e516d);
$parcel$export(module.exports, "COLUMN_CREATE_FAILURE", () => $f9561824c85fd000$export$d11eec7b8f8e0cd3);
$parcel$export(module.exports, "columnCreateFailure", () => $f9561824c85fd000$export$7a6298113a6c73fb);

var $9rND4 = parcelRequire("9rND4");
const $f9561824c85fd000$export$cb06a5725603209e = 'state.actions.column.create.COLUMN_CREATE_REQUEST';
const $f9561824c85fd000$export$e17a54aca50f971e = (temporaryColumnId, name, analyticsEvent, isCMPBoard)=>({
        type: $f9561824c85fd000$export$cb06a5725603209e,
        payload: {
            temporaryColumnId: temporaryColumnId,
            name: name
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent,
            isCMPBoard: isCMPBoard
        }
    });
const $f9561824c85fd000$export$a26373aaaa8736b1 = 'state.actions.column.create.COLUMN_CREATE_SUCCESS';
const $f9561824c85fd000$export$4d3e535c643e516d = (optimisticId, temporaryColumnId, column, columns, cardTransitions, analyticsEvent)=>({
        type: $f9561824c85fd000$export$a26373aaaa8736b1,
        payload: {
            temporaryColumnId: temporaryColumnId,
            column: column,
            columns: columns,
            cardTransitions: cardTransitions
        },
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $f9561824c85fd000$export$d11eec7b8f8e0cd3 = 'state.actions.column.create.COLUMN_CREATE_FAILURE';
const $f9561824c85fd000$export$7a6298113a6c73fb = (optimisticId, temporaryColumnId, error, analyticsEvent)=>({
        type: $f9561824c85fd000$export$d11eec7b8f8e0cd3,
        payload: {
            temporaryColumnId: temporaryColumnId
        },
        error: error,
        meta: {
            ...(0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });

});


parcelRegister("hM7SN", function(module, exports) {

$parcel$export(module.exports, "default", () => $31e504f54b5cdffc$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("fg0YM");

var $8zOmE = parcelRequire("8zOmE");


var $fYPOW = parcelRequire("fYPOW");

var $63F6h = parcelRequire("63F6h");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$31e504f54b5cdffc$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $63F6h.COLUMN_DELETE_REQUEST)).concatMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const projectKey = (0, $67Z81.projectKeySelector)(state);
        const { payload: { columnId: columnId, closestColumn: closestColumn }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        return (0, $fYPOW.default)(contextPath, boardId, columnId, closestColumn && closestColumn.id, projectKey).flatMap((columnsDeleteData)=>{
            const { columns: columns, cardTransitions: cardTransitions } = columnsDeleteData;
            if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column deleted');
            const actions = [
                (0, $63F6h.columnDeleteSuccess)(optimistic.id, closestColumn, columns, cardTransitions)
            ];
            if (!closestColumn) actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d44770975cd9746d)));
            return (0, $kVLXA.Observable).from(actions);
        }).catch((error)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column deleteFailed', {
                error: error
            });
            return (0, $kVLXA.Observable).of((0, $63F6h.columnDeleteFailure)(optimistic.id, columnId), // @ts-expect-error - TS2769 - No overload matches this call.
            (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7)));
        });
    });

});
parcelRegister("fYPOW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e841e1f0c5624fc9$export$2e2bcd8739ae039);
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $hbDJg = parcelRequire("hbDJg");

var $hjlQ8 = parcelRequire("hjlQ8");
const $e841e1f0c5624fc9$export$51186ad6e864892a = (projectKey, response)=>({
        columns: response.columns.map((0, $hjlQ8.transformColumn)),
        cardTransitions: (0, $hjlQ8.getCardTransitions)(projectKey, response.columns)
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e841e1f0c5624fc9$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, replacementColumnId, projectKey)=>(0, $hbDJg.default)(contextPath, boardId, columnId, replacementColumnId).flatMap((response)=>(0, $kVLXA.Observable).of($e841e1f0c5624fc9$export$51186ad6e864892a(projectKey, response))).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.column.delete.graphql.failure', 'Failed to delete column via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'message'
            ], '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message'
            ], '')
        });
        return (0, $kVLXA.Observable).throw(error);
    });

});
parcelRegister("hbDJg", function(module, exports) {

$parcel$export(module.exports, "default", () => $42d2fa9be8f4cdb6$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $Zbn1V = parcelRequire("Zbn1V");

var $CFxE9 = parcelRequire("CFxE9");
const $42d2fa9be8f4cdb6$export$fa62bc5e5bc2b62c = 'SoftwareColumnDelete';
const $42d2fa9be8f4cdb6$export$3b6f3376f9bb8f22 = (0, $ivqh1.gqlTagSwag)`mutation SoftwareColumnDelete($boardId:ID!, $columnId: ID!, $replacementColumnId: ID) {
        deleteColumn(input: {boardId: $boardId, columnId: $columnId, replacementColumnId: $replacementColumnId}) {
            columns {
                id
                name
                maxIssueCount
                status {
                    id
                    name
                }
                columnStatus {
                    ...ColumnStatusFragment
                }
                isInitial
                isDone
                transitionId
            }
        }
    }

    ${(0, $Zbn1V.ColumnStatusFragment)}
`;
const $42d2fa9be8f4cdb6$export$ba14d9a5a581e827 = (data)=>(0, $kVLXA.Observable).of(data.deleteColumn);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$42d2fa9be8f4cdb6$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, replacementColumnId)=>(0, $6iJbJ.mutation$)(contextPath, $42d2fa9be8f4cdb6$export$fa62bc5e5bc2b62c, $42d2fa9be8f4cdb6$export$3b6f3376f9bb8f22, {
        boardId: boardId,
        columnId: columnId,
        replacementColumnId: replacementColumnId
    }, (0, $CFxE9.columnDeleteAnalyticsOptions)).flatMap($42d2fa9be8f4cdb6$export$ba14d9a5a581e827);

});


parcelRegister("63F6h", function(module, exports) {

$parcel$export(module.exports, "COLUMN_DELETE_REQUEST", () => $d967a0e2b1fbb357$export$b4535d25697f9b52);
$parcel$export(module.exports, "columnDeleteRequest", () => $d967a0e2b1fbb357$export$2d450a2a2ff1d73c);
$parcel$export(module.exports, "COLUMN_DELETE_SUCCESS", () => $d967a0e2b1fbb357$export$3120df1059711c9f);
$parcel$export(module.exports, "columnDeleteSuccess", () => $d967a0e2b1fbb357$export$a2524e4771fdebc1);
$parcel$export(module.exports, "COLUMN_DELETE_FAILURE", () => $d967a0e2b1fbb357$export$b5933586fe1ed35f);
$parcel$export(module.exports, "columnDeleteFailure", () => $d967a0e2b1fbb357$export$d12468113e6a687f);
$parcel$export(module.exports, "COLUMN_DELETE", () => $d967a0e2b1fbb357$export$da91fdc68bfa18b3);
$parcel$export(module.exports, "columnDelete", () => $d967a0e2b1fbb357$export$6897d9588103ae0);
$parcel$export(module.exports, "COLUMN_DELETE_MODAL_CLOSE", () => $d967a0e2b1fbb357$export$27782fe81bbd5131);
$parcel$export(module.exports, "columnDeleteModalClose", () => $d967a0e2b1fbb357$export$4ddfb40c6de9d0ec);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $d967a0e2b1fbb357$export$b4535d25697f9b52 = 'state.actions.column.delete.COLUMN_DELETE_REQUEST';
const $d967a0e2b1fbb357$export$2d450a2a2ff1d73c = (columnId, closestColumn, issuesInColumn = [], analyticsEvent)=>({
        type: $d967a0e2b1fbb357$export$b4535d25697f9b52,
        payload: {
            columnId: columnId,
            closestColumn: closestColumn,
            issuesInColumn: issuesInColumn
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $d967a0e2b1fbb357$export$3120df1059711c9f = 'state.actions.column.delete.COLUMN_DELETE_SUCCESS';
const $d967a0e2b1fbb357$export$a2524e4771fdebc1 = (optimisticId, closestColumn, columns, cardTransitions)=>({
        type: $d967a0e2b1fbb357$export$3120df1059711c9f,
        payload: {
            closestColumn: closestColumn,
            columns: columns,
            cardTransitions: cardTransitions
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $d967a0e2b1fbb357$export$b5933586fe1ed35f = 'state.actions.column.delete.COLUMN_DELETE_FAILURE';
const $d967a0e2b1fbb357$export$d12468113e6a687f = (optimisticId, columnId, error = '')=>({
        type: $d967a0e2b1fbb357$export$b5933586fe1ed35f,
        payload: {
            columnId: columnId
        },
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            ...(0, $sdxnu.warningFlagMeta)({
                titleMessage: (0, $7AVqz.default).genericTitle,
                descriptionMessage: error ? (0, $7AVqz.default).failureDescription : (0, $7AVqz.default).genericDescription,
                context: {
                    error: error
                }
            })
        }
    });
const $d967a0e2b1fbb357$export$da91fdc68bfa18b3 = 'state.actions.column.delete.COLUMN_DELETE';
const $d967a0e2b1fbb357$export$6897d9588103ae0 = (columnId, hasIssues, hasIssuesNotOnBoard)=>({
        type: $d967a0e2b1fbb357$export$da91fdc68bfa18b3,
        payload: {
            columnId: columnId,
            hasIssues: hasIssues,
            hasIssuesNotOnBoard: hasIssuesNotOnBoard
        }
    });
const $d967a0e2b1fbb357$export$27782fe81bbd5131 = 'state.actions.column.delete.COLUMN_DELETE_MODAL_CLOSE';
const $d967a0e2b1fbb357$export$4ddfb40c6de9d0ec = ()=>({
        type: $d967a0e2b1fbb357$export$27782fe81bbd5131
    });

});


parcelRegister("kAzMD", function(module, exports) {

$parcel$export(module.exports, "default", () => $7f13d5fb4d26dc73$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("fg0YM");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $7MDCq = parcelRequire("7MDCq");

var $55fEr = parcelRequire("55fEr");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7f13d5fb4d26dc73$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $55fEr.COLUMN_RANK_REQUEST)).concatMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const hasDoneColumnInLastPosition = (0, $fyeGd.hasDoneColumnInLastPositionSelector)(state);
        const isSprintsEnabled = (0, $ebHh7.isSprintsEnabled)(state);
        const { payload: { columnId: columnId, sourceColumnIndex: sourceColumnIndex }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        // The redux state contains optimistic order, hence we can use columnID instead of targetID
        const position = (0, $fyeGd.getColumnIndex)(state, columnId);
        return (0, $7MDCq.default)(contextPath, boardId, columnId, position).flatMap(()=>{
            if (analyticsEvent && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sourceColumnIndex)) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column moved', {
                initialPosition: sourceColumnIndex + 1,
                destinationPosition: position + 1,
                hasDoneColumnInLastPosition: hasDoneColumnInLastPosition,
                isSprintsEnabled: isSprintsEnabled
            });
            return (0, $kVLXA.Observable).of((0, $55fEr.columnRankSuccess)(optimistic.id, columnId));
        }).catch((error)=>{
            if (analyticsEvent && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sourceColumnIndex)) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column moveFailed', {
                error: error,
                initialColumn: sourceColumnIndex + 1,
                destinationColumn: position + 1
            });
            return (0, $kVLXA.Observable).of((0, $55fEr.columnRankFailure)(optimistic.id, columnId, error));
        });
    });

});
parcelRegister("7MDCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $114b7a257ed172ff$export$2e2bcd8739ae039);
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $3XBVR = parcelRequire("3XBVR");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$114b7a257ed172ff$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, position)=>(0, $3XBVR.default)(contextPath, boardId, columnId, position).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.column.rank.graphql.failure', 'Failed to rank column via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'message'
            ], '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message'
            ], '')
        });
        return (0, $kVLXA.Observable).throw(error);
    });

});
parcelRegister("3XBVR", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c5aeb5883765e44$export$2e2bcd8739ae039);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $1c5aeb5883765e44$export$b5a4bd8cd48ce8d1 = 'SoftwareColumnRank';
const $1c5aeb5883765e44$export$e808ae55ccdba094 = (0, $ivqh1.gqlTagSwag)`mutation SoftwareColumnRank($boardId: ID!, $columnId: ID!, $position: Int!){
        rankColumn(input: {boardId: $boardId, columnId: $columnId, position: $position}) {
            success
        }
    }
`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1c5aeb5883765e44$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, position)=>(0, $6iJbJ.mutation$)(contextPath, $1c5aeb5883765e44$export$b5a4bd8cd48ce8d1, $1c5aeb5883765e44$export$e808ae55ccdba094, {
        boardId: boardId,
        columnId: columnId,
        position: position
    }, (0, $CFxE9.columnRankAnalyticsOptions));

});


parcelRegister("55fEr", function(module, exports) {

$parcel$export(module.exports, "COLUMN_RANK_REQUEST", () => $9bfbfef736995cc8$export$335da9e5c94e8e13);
$parcel$export(module.exports, "columnRankRequest", () => $9bfbfef736995cc8$export$52f00a5a5ec3dade);
$parcel$export(module.exports, "COLUMN_RANK_SUCCESS", () => $9bfbfef736995cc8$export$12932c9778919ee);
$parcel$export(module.exports, "columnRankSuccess", () => $9bfbfef736995cc8$export$2011044b8a484462);
$parcel$export(module.exports, "COLUMN_RANK_FAILURE", () => $9bfbfef736995cc8$export$be97721c3848d982);
$parcel$export(module.exports, "columnRankFailure", () => $9bfbfef736995cc8$export$8c4ab2c0d8c0dc47);

var $9rND4 = parcelRequire("9rND4");
const $9bfbfef736995cc8$export$335da9e5c94e8e13 = 'state.actions.column.rank.COLUMN_RANK_REQUEST';
const $9bfbfef736995cc8$export$52f00a5a5ec3dade = (columnId, targetColumnId, sourceColumnIndex, analyticsEvent)=>({
        type: $9bfbfef736995cc8$export$335da9e5c94e8e13,
        payload: {
            columnId: columnId,
            targetColumnId: targetColumnId,
            sourceColumnIndex: sourceColumnIndex
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $9bfbfef736995cc8$export$12932c9778919ee = 'state.actions.column.rank.COLUMN_RANK_SUCCESS';
const $9bfbfef736995cc8$export$2011044b8a484462 = (optimisticId, columnId)=>({
        type: $9bfbfef736995cc8$export$12932c9778919ee,
        payload: {
            columnId: columnId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $9bfbfef736995cc8$export$be97721c3848d982 = 'state.actions.column.rank.COLUMN_RANK_FAILURE';
const $9bfbfef736995cc8$export$8c4ab2c0d8c0dc47 = (optimisticId, columnId, error)=>({
        type: $9bfbfef736995cc8$export$be97721c3848d982,
        payload: {
            columnId: columnId
        },
        error: error,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("7Tp6S", function(module, exports) {

$parcel$export(module.exports, "default", () => $e45e6f48a22a2cfb$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("fg0YM");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $esu6n = parcelRequire("esu6n");

var $2RMda = parcelRequire("2RMda");

var $63VRQ = parcelRequire("63VRQ");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$e45e6f48a22a2cfb$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $63VRQ.COLUMN_RENAME_REQUEST)).concatMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const projectKey = (0, $67Z81.projectKeySelector)(state);
        const isCMP = (0, $67Z81.getIsCMPBoard)(state) && (0, $4R6GH.fg)('jsw-board-add-iscmp-to-setcolumnname');
        const { payload: { columnId: columnId, name: name }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        const position = (0, $fyeGd.getColumnIndex)(state, columnId);
        return (0, $2RMda.default)(contextPath, boardId, columnId, name, projectKey, isCMP).flatMap((columnRenameResponse)=>{
            const { column: column, cardTransitions: cardTransitions } = columnRenameResponse;
            const statuses = (0, $esu6n.getStatusColumn)(column)?.statuses ?? [];
            if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column renamed', {
                position: position + 1
            });
            return (0, $kVLXA.Observable).of((0, $63VRQ.columnRenameSuccess)(optimistic.id, columnId, statuses, cardTransitions));
        }).catch((error)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column renameFailed', {
                error: error,
                position: position + 1
            });
            return (0, $kVLXA.Observable).of((0, $63VRQ.columnRenameFailure)(optimistic.id, columnId, error));
        });
    });

});
parcelRegister("2RMda", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf5e04400d4a7f02$export$2e2bcd8739ae039);
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $5LA50 = parcelRequire("5LA50");

var $hjlQ8 = parcelRequire("hjlQ8");
const $cf5e04400d4a7f02$export$51186ad6e864892a = (projectKey, columnRenameData)=>({
        column: (0, $hjlQ8.transformColumn)(columnRenameData.column),
        cardTransitions: (0, $hjlQ8.getCardTransitions)(projectKey, [
            columnRenameData.column
        ])
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$cf5e04400d4a7f02$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, columnName, projectKey, isCMP)=>(0, $5LA50.default)(contextPath, boardId, columnId, columnName, isCMP).flatMap((columnRenameData)=>(0, $kVLXA.Observable).of($cf5e04400d4a7f02$export$51186ad6e864892a(projectKey, columnRenameData))).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.column.rename.graphql.failure', 'Failed to rename column via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                'message'
            ], '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message'
            ], '')
        });
        return (0, $kVLXA.Observable).throw(error);
    });

});
parcelRegister("5LA50", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e5426f29097d4f0$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $Zbn1V = parcelRequire("Zbn1V");

var $CFxE9 = parcelRequire("CFxE9");
const $6e5426f29097d4f0$export$2d9274ca8bff19e7 = 'SoftwareColumnRename';
const $6e5426f29097d4f0$export$b9999446542b88b6 = (0, $ivqh1.gqlTagSwag)`
    mutation SoftwareColumnRename($boardId: ID!, $columnId: ID!, $columnName: String!, $isCMP: Boolean) {
        setColumnName(
			input: {boardId: $boardId, columnId: $columnId, columnName: $columnName}
			isCMP: $isCMP
		) {
            column {
                id
                status {
                    id
                    name
                }
                columnStatus {
                    ...ColumnStatusFragment
                }
                isDone
                isInitial
                transitionId
            }
        }
    }

    ${(0, $Zbn1V.ColumnStatusFragment)}
`;
const $6e5426f29097d4f0$export$ba14d9a5a581e827 = (data)=>(0, $kVLXA.Observable).of(data.setColumnName);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$6e5426f29097d4f0$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, columnName, isCMP)=>(0, $6iJbJ.mutation$)(contextPath, $6e5426f29097d4f0$export$2d9274ca8bff19e7, $6e5426f29097d4f0$export$b9999446542b88b6, {
        boardId: boardId,
        columnId: columnId,
        columnName: columnName,
        isCMP: isCMP
    }, (0, $CFxE9.columnRenameAnalyticsOptions)).flatMap($6e5426f29097d4f0$export$ba14d9a5a581e827);

});


parcelRegister("63VRQ", function(module, exports) {

$parcel$export(module.exports, "COLUMN_RENAME_REQUEST", () => $6bea3bff04912ecc$export$c40a1a33681bf057);
$parcel$export(module.exports, "columnRenameRequest", () => $6bea3bff04912ecc$export$26259738ac7d398);
$parcel$export(module.exports, "COLUMN_RENAME_SUCCESS", () => $6bea3bff04912ecc$export$dc8c46a85951229d);
$parcel$export(module.exports, "columnRenameSuccess", () => $6bea3bff04912ecc$export$e91d130c91c717f8);
$parcel$export(module.exports, "COLUMN_RENAME_FAILURE", () => $6bea3bff04912ecc$export$430334cf6e52a887);
$parcel$export(module.exports, "columnRenameFailure", () => $6bea3bff04912ecc$export$519e7ffdc12c083f);

var $9rND4 = parcelRequire("9rND4");
const $6bea3bff04912ecc$export$c40a1a33681bf057 = 'state.actions.column.rename.COLUMN_RENAME_REQUEST';
const $6bea3bff04912ecc$export$26259738ac7d398 = (columnId, name, analyticsEvent)=>({
        type: $6bea3bff04912ecc$export$c40a1a33681bf057,
        payload: {
            columnId: columnId,
            name: name
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $6bea3bff04912ecc$export$dc8c46a85951229d = 'state.actions.column.rename.COLUMN_RENAME_SUCCESS';
const $6bea3bff04912ecc$export$e91d130c91c717f8 = (optimisticId, columnId, statuses, cardTransitions)=>({
        type: $6bea3bff04912ecc$export$dc8c46a85951229d,
        payload: {
            columnId: columnId,
            statuses: statuses,
            cardTransitions: cardTransitions
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $6bea3bff04912ecc$export$430334cf6e52a887 = 'state.actions.column.rename.COLUMN_RENAME_FAILURE';
const $6bea3bff04912ecc$export$519e7ffdc12c083f = (optimisticId, columnId, error)=>({
        type: $6bea3bff04912ecc$export$430334cf6e52a887,
        payload: {
            columnId: columnId
        },
        error: error,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("14rCC", function(module, exports) {

$parcel$export(module.exports, "default", () => $deddf958d81ff2ce$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("fg0YM");

var $8zOmE = parcelRequire("8zOmE");

var $1ypcX = parcelRequire("1ypcX");

var $9eeht = parcelRequire("9eeht");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$deddf958d81ff2ce$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $9eeht.COLUMN_SET_LIMITS_REQUEST)).concatMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const { payload: { columnId: columnId, maxIssueCount: maxIssueCount, minIssueCount: minIssueCount }, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        const position = (0, $fyeGd.getColumnIndex)(state, columnId);
        return (0, $1ypcX.default)(contextPath, boardId, columnId, maxIssueCount, minIssueCount).flatMap(()=>{
            if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column setLimit', {
                position: position + 1,
                maxIssueCount: maxIssueCount,
                minIssueCount: minIssueCount
            });
            return (0, $kVLXA.Observable).of((0, $9eeht.columnSetLimitsSuccess)(optimistic.id, columnId));
        }).catch((error)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column setLimitFailed', {
                error: error,
                position: position + 1,
                maxIssueCount: maxIssueCount
            });
            return (0, $kVLXA.Observable).of((0, $9eeht.columnSetLimitsFailure)(optimistic.id, columnId));
        });
    });

});
parcelRegister("1ypcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $21e1a6daf9e5fc4c$export$2e2bcd8739ae039);

var $bUfxy = parcelRequire("bUfxy");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$21e1a6daf9e5fc4c$export$2e2bcd8739ae039 = (contextPath, boardId, columnId, limit, minimum)=>(0, $bUfxy.default)(contextPath, boardId, columnId, limit, minimum);

});
parcelRegister("bUfxy", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c2bcc5f22c9c3c7$export$2e2bcd8739ae039);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $1c2bcc5f22c9c3c7$export$6b26f3650e1da55a = 'SoftwareColumnSetLimit';
const $1c2bcc5f22c9c3c7$export$5298fb188d74e2c3 = (0, $ivqh1.gqlTagSwag)`mutation SoftwareColumnSetLimit($boardId:ID!, $columnId: ID!, $limit:Int, $minimum:Int){
    setColumnLimit(input: {boardId: $boardId, columnId: $columnId, limit: $limit, minimum: $minimum}) {
        success
    }
}`;
function $1c2bcc5f22c9c3c7$export$2e2bcd8739ae039(contextPath, boardId, columnId, limit, minimum) {
    return (0, $6iJbJ.mutation$)(contextPath, $1c2bcc5f22c9c3c7$export$6b26f3650e1da55a, $1c2bcc5f22c9c3c7$export$5298fb188d74e2c3, {
        boardId: boardId,
        columnId: columnId,
        limit: limit,
        minimum: minimum
    }, (0, $CFxE9.columnSetLimitAnalyticsOptions));
}

});


parcelRegister("9eeht", function(module, exports) {

$parcel$export(module.exports, "COLUMN_OPEN_LIMITS_MODAL", () => $4d13db2916dc0c09$export$6a8e8c210302f17a);
$parcel$export(module.exports, "columnOpenLimitsModal", () => $4d13db2916dc0c09$export$7db64843dc1f34b6);
$parcel$export(module.exports, "COLUMN_CLOSE_LIMITS_MODAL", () => $4d13db2916dc0c09$export$f7f89717d9dcf7fb);
$parcel$export(module.exports, "columnCloseLimitsModal", () => $4d13db2916dc0c09$export$5eb828385c591dbf);
$parcel$export(module.exports, "COLUMN_SET_LIMITS_REQUEST", () => $4d13db2916dc0c09$export$c4d8590d75985d98);
$parcel$export(module.exports, "columnSetLimitsRequest", () => $4d13db2916dc0c09$export$426784419a12c1b5);
$parcel$export(module.exports, "COLUMN_SET_LIMITS_SUCCESS", () => $4d13db2916dc0c09$export$3edc87fb0dc6ea8e);
$parcel$export(module.exports, "columnSetLimitsSuccess", () => $4d13db2916dc0c09$export$c9f0c15978432dec);
$parcel$export(module.exports, "COLUMN_SET_LIMITS_FAILURE", () => $4d13db2916dc0c09$export$b946c8d5d7849f8a);
$parcel$export(module.exports, "columnSetLimitsFailure", () => $4d13db2916dc0c09$export$3b783b9b2a0ab085);

var $9rND4 = parcelRequire("9rND4");
const $4d13db2916dc0c09$export$6a8e8c210302f17a = 'state.actions.column.limits.COLUMN_OPEN_LIMITS_MODAL';
const $4d13db2916dc0c09$export$7db64843dc1f34b6 = (columnId)=>({
        type: $4d13db2916dc0c09$export$6a8e8c210302f17a,
        payload: {
            columnId: columnId
        }
    });
const $4d13db2916dc0c09$export$f7f89717d9dcf7fb = 'state.actions.column.limits.COLUMN_CLOSE_LIMITS_MODAL';
const $4d13db2916dc0c09$export$5eb828385c591dbf = (columnId)=>({
        type: $4d13db2916dc0c09$export$f7f89717d9dcf7fb,
        payload: {
            columnId: columnId
        }
    });
const $4d13db2916dc0c09$export$c4d8590d75985d98 = 'state.actions.column.limits.COLUMN_SET_LIMITS_REQUEST';
const $4d13db2916dc0c09$export$426784419a12c1b5 = (columnId, maxIssueCount, minIssueCount, analyticsEvent)=>({
        type: $4d13db2916dc0c09$export$c4d8590d75985d98,
        payload: {
            columnId: columnId,
            maxIssueCount: maxIssueCount,
            minIssueCount: minIssueCount
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $4d13db2916dc0c09$export$3edc87fb0dc6ea8e = 'state.actions.column.limits.COLUMN_SET_LIMITS_SUCCESS';
const $4d13db2916dc0c09$export$c9f0c15978432dec = (optimisticId, columnId)=>({
        type: $4d13db2916dc0c09$export$3edc87fb0dc6ea8e,
        payload: {
            columnId: columnId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $4d13db2916dc0c09$export$b946c8d5d7849f8a = 'state.actions.column.limits.COLUMN_SET_LIMITS_FAILURE';
const $4d13db2916dc0c09$export$3b783b9b2a0ab085 = (optimisticId, columnId)=>({
        type: $4d13db2916dc0c09$export$b946c8d5d7849f8a,
        payload: {
            columnId: columnId
        },
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("8SGPr", function(module, exports) {

$parcel$export(module.exports, "detailViewCloseEpic", () => $316fb987c7134ef2$export$511093f766907f93);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");

var $kXqRJ = parcelRequire("kXqRJ");

var $dW1HX = parcelRequire("dW1HX");

var $cIqUn = parcelRequire("cIqUn");

var $fqLDH = parcelRequire("fqLDH");
const $316fb987c7134ef2$export$511093f766907f93 = (action$, store)=>action$.ofType((0, $kXqRJ.ISSUE_DELETE_REQUEST), (0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const issueId = (0, $fqLDH.getIssueIdForModal)(state);
        if (!issueId) return (0, $kVLXA.Observable).empty();
        if (action.type === (0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST) && action.payload.issueIds.includes(issueId)) return (0, $kVLXA.Observable).of((0, $dW1HX.closeIssueModal)((0, $fqLDH.getIssueKeyForModal)(state)));
        if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST) && action.payload.issue.id === issueId) return (0, $kVLXA.Observable).of((0, $dW1HX.closeIssueModal)((0, $fqLDH.getIssueKeyForModal)(state)));
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("cIqUn", function(module, exports) {

$parcel$export(module.exports, "ISSUE_MOVE_TO_BACKLOG_REQUEST", () => $19e3779f54beab8e$export$f180b23a6d76a36c);
$parcel$export(module.exports, "issueMoveToBacklogRequest", () => $19e3779f54beab8e$export$1c79b09f3075e4ea);
$parcel$export(module.exports, "ISSUE_MOVE_TO_BACKLOG_SUCCESS", () => $19e3779f54beab8e$export$d4a24bc75ec9e22b);
$parcel$export(module.exports, "issueMoveToBacklogSuccess", () => $19e3779f54beab8e$export$5a53dd39dd4e0e24);
$parcel$export(module.exports, "ISSUE_MOVE_TO_BACKLOG_FAILURE", () => $19e3779f54beab8e$export$60cf36654ed56c30);
$parcel$export(module.exports, "issueMoveToBacklogFailure", () => $19e3779f54beab8e$export$a9d1ce754cbce39);

var $9rND4 = parcelRequire("9rND4");
const $19e3779f54beab8e$export$f180b23a6d76a36c = 'state.actions.issue.move-to-backlog.ISSUE_MOVE_TO_BACKLOG_REQUEST';
const $19e3779f54beab8e$export$1c79b09f3075e4ea = (issueIds, issueKeys, columnId)=>({
        type: $19e3779f54beab8e$export$f180b23a6d76a36c,
        payload: {
            issueIds: issueIds,
            issueKeys: issueKeys,
            columnId: columnId
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $19e3779f54beab8e$export$d4a24bc75ec9e22b = 'state.actions.issue.move-to-backlog.ISSUE_MOVE_TO_BACKLOG_SUCCESS';
const $19e3779f54beab8e$export$5a53dd39dd4e0e24 = (optimisticId, issueIds, columnId)=>({
        type: $19e3779f54beab8e$export$d4a24bc75ec9e22b,
        payload: {
            issueIds: issueIds,
            columnId: columnId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $19e3779f54beab8e$export$60cf36654ed56c30 = 'state.actions.issue.move-to-backlog.ISSUE_MOVE_TO_BACKLOG_FAILURE';
const $19e3779f54beab8e$export$a9d1ce754cbce39 = (optimisticId, issueIds)=>({
        type: $19e3779f54beab8e$export$60cf36654ed56c30,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});


parcelRegister("8gsv0", function(module, exports) {

$parcel$export(module.exports, "detailViewOpenDebouncedEpic", () => $f3dab53a380a8c8b$export$2e5970b542a40342);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("eSGL3");
parcelRequire("fPS7b");

var $dW1HX = parcelRequire("dW1HX");
const $f3dab53a380a8c8b$export$2e5970b542a40342 = (action$)=>action$.ofType((0, $dW1HX.OPEN_ISSUE_MODAL_DEBOUNCED)).debounceTime(500).mergeMap((action)=>(0, $kVLXA.Observable).of((0, $dW1HX.openIssueModal)(action.payload.issueKey, action.payload.externalAction)));

});

parcelRegister("gMi9d", function(module, exports) {

$parcel$export(module.exports, "detailViewUpdateEpic", () => $3c9fa8f890559c9c$export$ddc67837ea92e238);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");


var $2f454 = parcelRequire("2f454");

var $7tJ5d = parcelRequire("7tJ5d");

var $iaYF9 = parcelRequire("iaYF9");

var $fBkjL = parcelRequire("fBkjL");

var $3n65g = parcelRequire("3n65g");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $fqLDH = parcelRequire("fqLDH");
const $3c9fa8f890559c9c$export$ddc67837ea92e238 = (action$, store)=>action$.ofType((0, $2f454.CARD_DATA_SET), (0, $evkwq.ISSUE_UPDATE_SUCCESS), (0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_SUCCESS), (0, $iaYF9.ISSUE_ADD_LABELS_SUCCESS), (0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS), (0, $3n65g.SET_PARENT_SUCCESS), (0, $3n65g.UNSET_PARENT_SUCCESS), (0, $3n65g.SET_PARENT_OPTIMISTIC)).switchMap((action)=>{
        const state = store.getState();
        const issueId = (0, $fqLDH.getIssueIdForModal)(state);
        if (!issueId) return (0, $kVLXA.Observable).empty();
        if ((action.type === (0, $2f454.CARD_DATA_SET) || action.type === (0, $evkwq.ISSUE_UPDATE_SUCCESS)) && action.payload.origin === (0, $f32ae13c2b9742f4$export$d46a05f8561f868a) && action.payload.issue.id === issueId) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        if (action.type === (0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_SUCCESS) && action.payload.issueIds.includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        if (action.type === (0, $iaYF9.ISSUE_ADD_LABELS_SUCCESS) && action.payload.includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS)) {
            const parentIds = action.payload.issueIds.flatMap((id)=>{
                const issue = (0, $fqLDH.getIssueByIdForModal)(state)(id);
                // @ts-expect-error - TS2339 - Property 'parentId' does not exist on type 'Issue | IssueParent'.
                if (issue && issue.parentId !== undefined) // @ts-expect-error - TS2339 - Property 'parentId' does not exist on type 'Issue | IssueParent'.
                return issue.parentId;
                return [];
            });
            if (action.payload.issueIds.includes(issueId) || parentIds.includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        }
        if ((action.type === (0, $3n65g.SET_PARENT_SUCCESS) || action.type === (0, $3n65g.UNSET_PARENT_SUCCESS)) && action.payload.issueIds.includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        if (action.type === (0, $3n65g.SET_PARENT_OPTIMISTIC) && action.payload.issues.map((issue)=>issue.id).includes(issueId)) return (0, $kVLXA.Observable).of((0, $7tJ5d.updateDetailView)());
        return (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("7tJ5d", function(module, exports) {

$parcel$export(module.exports, "UPDATE_DETAIL_VIEW", () => $eda17ead7b9b9550$export$e38020a85931f37e);
$parcel$export(module.exports, "updateDetailView", () => $eda17ead7b9b9550$export$d5df566661a69c2d);
const $eda17ead7b9b9550$export$e38020a85931f37e = 'state.actions.detail-view.UPDATE_DETAIL_VIEW';
const $eda17ead7b9b9550$export$d5df566661a69c2d = ()=>({
        type: $eda17ead7b9b9550$export$e38020a85931f37e
    });

});

parcelRegister("iaYF9", function(module, exports) {

$parcel$export(module.exports, "SHOW_ISSUE_ADD_LABEL_MODAL", () => $02c1e897250b17fa$export$2512ad1fa2a5cc9);
$parcel$export(module.exports, "showIssueAddLabelModal", () => $02c1e897250b17fa$export$bac21fa33dff3d0e);
$parcel$export(module.exports, "HIDE_ISSUE_ADD_LABEL_MODAL", () => $02c1e897250b17fa$export$d3b2c62cf224a7f5);
$parcel$export(module.exports, "hideIssueAddLabelModal", () => $02c1e897250b17fa$export$5314c0004ac7176c);
$parcel$export(module.exports, "ISSUE_ADD_LABELS", () => $02c1e897250b17fa$export$dcd34e7fa01d17de);
$parcel$export(module.exports, "issueAddLabels", () => $02c1e897250b17fa$export$5c330854b670e947);
$parcel$export(module.exports, "ISSUE_ADD_LABELS_SUCCESS", () => $02c1e897250b17fa$export$ff85d5b1f744d6c8);
$parcel$export(module.exports, "issueAddLabelsSuccess", () => $02c1e897250b17fa$export$128c05d32ac24ef7);
$parcel$export(module.exports, "issueAddLabelsFailure", () => $02c1e897250b17fa$export$5ba38608dc882ffb);

var $6s1PB = parcelRequire("6s1PB");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $02c1e897250b17fa$export$2512ad1fa2a5cc9 = 'state.actions.issue.add-label-modal.SHOW_ISSUE_ADD_LABEL_MODAL';
const $02c1e897250b17fa$export$bac21fa33dff3d0e = (issueIds)=>({
        type: $02c1e897250b17fa$export$2512ad1fa2a5cc9,
        payload: issueIds
    });
const $02c1e897250b17fa$export$d3b2c62cf224a7f5 = 'state.actions.issue.add-label-modal.HIDE_ISSUE_ADD_LABEL_MODAL';
const $02c1e897250b17fa$export$5314c0004ac7176c = ()=>({
        type: $02c1e897250b17fa$export$d3b2c62cf224a7f5
    });
const $02c1e897250b17fa$export$dcd34e7fa01d17de = 'state.actions.issue.add-label-modal.ISSUE_ADD_LABELS';
const $02c1e897250b17fa$export$5c330854b670e947 = (issueIds, labels)=>({
        type: $02c1e897250b17fa$export$dcd34e7fa01d17de,
        payload: {
            issueIds: issueIds,
            labels: labels
        }
    });
const $02c1e897250b17fa$export$ff85d5b1f744d6c8 = 'state.actions.issue.add-label-modal.ISSUE_ADD_LABELS_SUCCESS';
const $02c1e897250b17fa$export$128c05d32ac24ef7 = (issueIds)=>({
        type: $02c1e897250b17fa$export$ff85d5b1f744d6c8,
        payload: issueIds
    });
const $02c1e897250b17fa$export$75246e0069503880 = 'state.actions.issue.add-label-modal.ISSUE_ADD_LABELS_FAILURE';
const $02c1e897250b17fa$export$5ba38608dc882ffb = (savedIssueIds, failedIssueIds)=>({
        type: $02c1e897250b17fa$export$75246e0069503880,
        payload: {
            savedIssueIds: savedIssueIds,
            failedIssueIds: failedIssueIds
        },
        meta: {
            ...(0, $sdxnu.warningFlagMeta)({
                titleMessage: (0, $7AVqz.default).genericTitle,
                descriptionMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7AVqz.default).issueLabelsSaveFailedIssueTermRefresh : (0, $7AVqz.default).issueLabelsSaveFailed
            })
        }
    });

});

parcelRegister("fBkjL", function(module, exports) {

$parcel$export(module.exports, "ISSUE_FLAG_WITH_COMMENT_REQUEST", () => $969635107447c135$export$a1d537152eece2c6);
$parcel$export(module.exports, "issueFlagWithCommentRequest", () => $969635107447c135$export$7fa3ed92e351f9d9);
$parcel$export(module.exports, "ISSUE_FLAG_WITH_COMMENT_SUCCESS", () => $969635107447c135$export$da38bc4d28a28087);
$parcel$export(module.exports, "issueFlagWithCommentSuccess", () => $969635107447c135$export$d3d00de1178f8de8);
$parcel$export(module.exports, "issueFlagWithCommentFailure", () => $969635107447c135$export$b0866a7a86e285af);

var $9rND4 = parcelRequire("9rND4");
const $969635107447c135$export$a1d537152eece2c6 = 'state.actions.issue.flag-with-comment.ISSUE_FLAG_WITH_COMMENT_REQUEST';
const $969635107447c135$export$7fa3ed92e351f9d9 = (issueIds, flag, comment, analyticsEvent)=>({
        type: $969635107447c135$export$a1d537152eece2c6,
        payload: {
            issueIds: issueIds,
            flag: flag,
            comment: comment
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $969635107447c135$export$da38bc4d28a28087 = 'state.actions.issue.flag-with-comment.ISSUE_FLAG_WITH_COMMENT_SUCCESS';
const $969635107447c135$export$d3d00de1178f8de8 = (optimisticId, issueIds)=>({
        type: $969635107447c135$export$da38bc4d28a28087,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $969635107447c135$export$90380d57abbfaa43 = 'state.actions.issue.flag-with-comment.ISSUE_FLAG_WITH_COMMENT_FAILURE';
const $969635107447c135$export$b0866a7a86e285af = (optimisticId, issueIds)=>({
        type: $969635107447c135$export$90380d57abbfaa43,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});

parcelRegister("3n65g", function(module, exports) {

$parcel$export(module.exports, "SET_PARENT_OPTIMISTIC", () => $4a0bde56d1b17de8$export$f12fa57c5a24cc9f);
$parcel$export(module.exports, "setParentOptimistic", () => $4a0bde56d1b17de8$export$c2dcedde7d23b594);
$parcel$export(module.exports, "SET_PARENT_SUCCESS", () => $4a0bde56d1b17de8$export$4bb036ce8efdbcff);
$parcel$export(module.exports, "setParentSuccess", () => $4a0bde56d1b17de8$export$6db24407ee10b2d3);
$parcel$export(module.exports, "setParentFailure", () => $4a0bde56d1b17de8$export$c7950a8b245b9032);
$parcel$export(module.exports, "UNSET_PARENT_SUCCESS", () => $4a0bde56d1b17de8$export$fe453787af036e5f);
$parcel$export(module.exports, "SET_ISSUE_PARENT_STATUS", () => $4a0bde56d1b17de8$export$362b3491e984673e);
$parcel$export(module.exports, "setIssueParentStatus", () => $4a0bde56d1b17de8$export$6cca14d1fad7b326);
$parcel$export(module.exports, "SET_ISSUE_PARENT_SUMMARY", () => $4a0bde56d1b17de8$export$1f6b71a6b4bb1d3f);
$parcel$export(module.exports, "setIssueParentSummary", () => $4a0bde56d1b17de8$export$acf348b3d3d2f816);
$parcel$export(module.exports, "ADD_ISSUE_PARENT", () => $4a0bde56d1b17de8$export$f15f4813e6a1098b);
$parcel$export(module.exports, "addIssueParent", () => $4a0bde56d1b17de8$export$c4c252d1768346ba);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");

var $9rND4 = parcelRequire("9rND4");
const $4a0bde56d1b17de8$export$f12fa57c5a24cc9f = 'state.actions.issue.parent.SET_PARENT_OPTIMISTIC';
const $4a0bde56d1b17de8$export$c2dcedde7d23b594 = (issues, parentId, requestPromise)=>({
        type: $4a0bde56d1b17de8$export$f12fa57c5a24cc9f,
        payload: {
            issues: issues,
            parentId: parentId,
            requestPromise: requestPromise
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $4a0bde56d1b17de8$export$4bb036ce8efdbcff = 'state.actions.issue.parent.SET_PARENT_SUCCESS';
const $4a0bde56d1b17de8$export$6db24407ee10b2d3 = (optimisticId, issueIds)=>({
        type: $4a0bde56d1b17de8$export$4bb036ce8efdbcff,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $4a0bde56d1b17de8$export$5c2ad12189bbd49d = 'state.actions.issue.parent.SET_PARENT_FAILURE';
const $4a0bde56d1b17de8$export$c7950a8b245b9032 = (optimisticId)=>({
        type: $4a0bde56d1b17de8$export$5c2ad12189bbd49d,
        meta: {
            ...(0, $sdxnu.warningFlagMeta)({
                id: $4a0bde56d1b17de8$export$5c2ad12189bbd49d,
                titleMessage: (0, $7AVqz.default).genericTitle,
                descriptionMessage: (0, $7AVqz.default).genericDescription
            }),
            ...(0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
        }
    });
const $4a0bde56d1b17de8$export$fe453787af036e5f = 'state.actions.issue.parent.UNSET_PARENT_SUCCESS';
const $4a0bde56d1b17de8$export$60feaf55fd14c76a = (optimisticId, issueIds)=>({
        type: $4a0bde56d1b17de8$export$fe453787af036e5f,
        payload: {
            issueIds: issueIds
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $4a0bde56d1b17de8$export$ab972ebdce5decb = 'state.actions.issue.parent.UNSET_PARENT_FAILURE';
const $4a0bde56d1b17de8$export$df5db15564db21af = (optimisticId)=>({
        type: $4a0bde56d1b17de8$export$ab972ebdce5decb,
        meta: {
            ...(0, $sdxnu.warningFlagMeta)({
                id: $4a0bde56d1b17de8$export$ab972ebdce5decb,
                titleMessage: (0, $7AVqz.default).genericTitle,
                descriptionMessage: (0, $7AVqz.default).genericDescription
            }),
            ...(0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
        }
    });
const $4a0bde56d1b17de8$export$362b3491e984673e = 'state.actions.issue.parent.SET_ISSUE_PARENT_STATUS';
const $4a0bde56d1b17de8$export$6cca14d1fad7b326 = (issueId, status)=>({
        type: $4a0bde56d1b17de8$export$362b3491e984673e,
        payload: {
            issueId: issueId,
            status: status
        }
    });
const $4a0bde56d1b17de8$export$1f6b71a6b4bb1d3f = 'state.actions.issue.parent.SET_ISSUE_PARENT_SUMMARY';
const $4a0bde56d1b17de8$export$acf348b3d3d2f816 = (issueId, issueSummary)=>({
        type: $4a0bde56d1b17de8$export$1f6b71a6b4bb1d3f,
        payload: {
            issueId: issueId,
            issueSummary: issueSummary
        }
    });
const $4a0bde56d1b17de8$export$f15f4813e6a1098b = 'state.actions.issue.parent.ADD_ISSUE_PARENT';
const $4a0bde56d1b17de8$export$c4c252d1768346ba = ({ issue: issue })=>({
        type: $4a0bde56d1b17de8$export$f15f4813e6a1098b,
        payload: {
            issue: issue
        }
    });

});


parcelRegister("dzWxI", function(module, exports) {

$parcel$export(module.exports, "default", () => $293eba2d146d0727$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $2YZCu = parcelRequire("2YZCu");

var $2Fkae = parcelRequire("2Fkae");

var $i2eOb = parcelRequire("i2eOb");

var $eQEtH = parcelRequire("eQEtH");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
function $293eba2d146d0727$export$2e2bcd8739ae039(action$, store) {
    return action$.ofType((0, $cW3pH.WORK_REFRESH_DATA), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED), (0, $65C0W.SOFTWARE_APP_LOADED)).switchMap(()=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const baseUrl = (0, $67Z81.contextPathSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const handleError = (location, error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData(location, error.message, error);
            return (0, $kVLXA.Observable).empty();
        };
        if (isCMPBoard) return (0, $kVLXA.Observable).empty();
        return (0, $2Fkae.fetchExtensionData)(baseUrl, boardId).map((0, $i2eOb.transformOperation)).flatMap((extension)=>(0, $kVLXA.Observable).of((0, $eQEtH.extensionFetchSuccess)(extension))).catch((error)=>handleError('software.extension.operations', error));
    });
}

});
parcelRegister("2Fkae", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $e2e93974abf36621$export$5fe98ae96d282610);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");

var $CFxE9 = parcelRequire("CFxE9");
const $e2e93974abf36621$var$softwareBoardExtensionOperationName = 'SoftwareBoardExtension';
const $e2e93974abf36621$export$1d6e6c1cef4b8fcc = (boardId)=>`query ${$e2e93974abf36621$var$softwareBoardExtensionOperationName} {
        boardScope(boardId:${boardId}) {
            board {
                id
                extension {
                    operations {
                        icon {
                           url
                        }
                        name
                        url
                        tooltip
                        styleClass
                    } 
                }
            }
        }
    }`;
function $e2e93974abf36621$export$5fe98ae96d282610(contextPath, boardId) {
    return (0, $cBLvH.query$)(contextPath, $e2e93974abf36621$var$softwareBoardExtensionOperationName, $e2e93974abf36621$export$1d6e6c1cef4b8fcc(boardId), (0, $CFxE9.loadExtensionAnalyticsOptions)).flatMap((data)=>(0, $kVLXA.Observable).of(data.boardScope.board));
}

});

parcelRegister("i2eOb", function(module, exports) {

$parcel$export(module.exports, "transformOperation", () => $7c3d15bee26bc2d5$export$4f3f7df1b558c729);
const $7c3d15bee26bc2d5$export$4f3f7df1b558c729 = (boardGQLExtension)=>{
    const operations = boardGQLExtension.extension ? boardGQLExtension.extension.operations.map((op)=>({
            icon: {
                url: op.icon && op.icon.url
            },
            name: op.name,
            url: op.url,
            tooltip: op.tooltip,
            styleClass: op.styleClass
        })) : [];
    return {
        operations: operations
    };
};

});

parcelRegister("eQEtH", function(module, exports) {

$parcel$export(module.exports, "EXTENSION_FETCH_SUCCESS", () => $459dc97ab913f41a$export$4b80f261a964f809);
$parcel$export(module.exports, "extensionFetchSuccess", () => $459dc97ab913f41a$export$12037fbc95e2254d);
const $459dc97ab913f41a$export$4b80f261a964f809 = 'state.actions.extension.EXTENSION_FETCH_SUCCESS';
const $459dc97ab913f41a$export$12037fbc95e2254d = (extension)=>({
        type: $459dc97ab913f41a$export$4b80f261a964f809,
        payload: {
            extension: extension
        }
    });

});


parcelRegister("EGoh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ae057d5dada39ef$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("1oQta");
parcelRequire("zjDln");
parcelRequire("fPS7b");

var $dnW4F = parcelRequire("dnW4F");

var $5mTgl = parcelRequire("5mTgl");
const $3ae057d5dada39ef$var$makeFilter = (state)=>(0, $5mTgl.isBoardConfigLoaded)(state) && (0, $5mTgl.isCurrentUserLoaded)(state) && (0, $5mTgl.hasInvalidFilterValuesSelector)(state);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3ae057d5dada39ef$export$2e2bcd8739ae039 = (action$, store)=>action$.filter(()=>$3ae057d5dada39ef$var$makeFilter(store.getState())).mergeMap(()=>(0, $kVLXA.Observable).from([
            (0, $dnW4F.setAllFilters)((0, $5mTgl.validFilterValuesSelector)(store.getState()))
        ]));

});

parcelRegister("4FKf7", function(module, exports) {

$parcel$export(module.exports, "filteredCardsEpic", () => $2dee44e6dc4514e3$export$e2f185e35a8c9054);

var $e1AU2 = parcelRequire("e1AU2");

var $g9fl7 = parcelRequire("g9fl7");

var $20mkj = parcelRequire("20mkj");
const $2dee44e6dc4514e3$export$e2f185e35a8c9054 = (0, $e1AU2.combineEpics)((0, $g9fl7.filteredCardsRequestEpic), (0, $20mkj.refilterRequestEpic));

});
parcelRegister("g9fl7", function(module, exports) {

$parcel$export(module.exports, "filteredCardsRequestEpic", () => $02472c74f2c2db57$export$ee8377ae46706014);

var $kVLXA = parcelRequire("kVLXA");

var $hSQIY = parcelRequire("hSQIY");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("jFVZ1");
parcelRequire("eSGL3");
parcelRequire("3awJm");
parcelRequire("6cbqE");
parcelRequire("d0pqD");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $iuuJH = parcelRequire("iuuJH");

var $8KZbe = parcelRequire("8KZbe");

var $hdmw1 = parcelRequire("hdmw1");

var $d1i1b = parcelRequire("d1i1b");

var $cY26q = parcelRequire("cY26q");

var $dnW4F = parcelRequire("dnW4F");

var $k50Aq = parcelRequire("k50Aq");

var $vAfHD = parcelRequire("vAfHD");

var $45cXl = parcelRequire("45cXl");

var $6c7Tw = parcelRequire("6c7Tw");

var $5mTgl = parcelRequire("5mTgl");

var $j6QAp = parcelRequire("j6QAp");
const $02472c74f2c2db57$var$handleFilterCards = (action, store)=>{
    const state = store.getState();
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
    // If you have JQL swimlanes, you ALWAYS fetch the data even when clearing the filters
    const mustForciblyRefreshSwimlanesOnClear = ctx.isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id;
    if (!mustForciblyRefreshSwimlanesOnClear && action.meta.filterType !== (0, $dcff40112356dfc1$export$68d693c35a8d8866) && action.meta.filterType !== (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)) return (0, $kVLXA.Observable).of((0, $d1i1b.cardAutoScrollRequestOnFilter)());
    const customFilterIds = action.payload?.filters[0, $dcff40112356dfc1$export$68d693c35a8d8866] || [];
    const hasCustomFilters = customFilterIds && customFilterIds.length;
    const jql = (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false) ? action.payload?.filters[0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f] ?? null : null;
    const hasJql = (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false) ? jql && jql.length > 0 : false;
    if (!mustForciblyRefreshSwimlanesOnClear && !hasCustomFilters && !hasJql) return (0, $kVLXA.Observable).from([
        (0, $cY26q.clearFilteredCards)(),
        (0, $d1i1b.cardAutoScrollRequestOnFilter)()
    ]);
    const issueIds = (0, $vAfHD.boardOrderedIssueIdsSelector)(state);
    const { analyticsEvent: analyticsEvent } = action.meta;
    const setLoading$ = mustForciblyRefreshSwimlanesOnClear ? (0, $kVLXA.Observable).of((0, $dnW4F.customFilterForceRefreshStart)()) : (0, $kVLXA.Observable).empty();
    const request$ = (0, $8KZbe.fetchFilteredCardIds)(ctx, {
        issueIds: issueIds,
        customFilterIds: customFilterIds,
        jql: jql
    }).mergeMap(({ cardIds: cardIds, jqlSwimlanes: jqlSwimlanes })=>{
        // Always fire the action for success or the Loading animation will always play
        const actions = [
            (0, $cY26q.filteredCardsSuccess)(cardIds.map((id)=>`${id}`), customFilterIds.length, issueIds.length, analyticsEvent)
        ];
        if (jql !== null && (0, $4R6GH.fg)('filter_refinement_set_work_filters_after_search')) {
            const workFilters = (0, $5mTgl.getWorkFilters)(state);
            const newWorkFilters = (0, $j6QAp.getWorkFiltersFromJql)(jql);
            actions.push((0, $dnW4F.setAllFilters)({
                ...workFilters.values,
                ...newWorkFilters
            }));
        }
        if (!mustForciblyRefreshSwimlanesOnClear) actions.push((0, $d1i1b.cardAutoScrollRequestOnFilter)());
        if (ctx.isCMPBoard) actions.push((0, $k50Aq.swimlaneJqlSetDataRequest)(jqlSwimlanes ?? []));
        return (0, $kVLXA.Observable).from(actions);
    }).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.filtered-cards.failure', 'Fail to filter cards with custom filters on board', error);
        return (0, $kVLXA.Observable).of((0, $cY26q.filteredCardsFailed)(error, analyticsEvent), (0, $dnW4F.setAllFilters)({}));
    });
    return (0, $kVLXA.Observable).concat(setLoading$, request$);
};
const $02472c74f2c2db57$export$ee8377ae46706014 = (action$, store)=>action$.ofType((0, $dnW4F.SET_ALL_FILTERS)).throttleTime((0, $6c7Tw.getCustomFiltersDebounceTime)(), (0, $hSQIY.async), {
        leading: true,
        trailing: true
    }).switchMap((action)=>$02472c74f2c2db57$var$handleFilterCards(action, store));

});
parcelRegister("8KZbe", function(module, exports) {

$parcel$export(module.exports, "fetchFilteredCardIds", () => $1e3a1d2a5c5c391a$export$820b8754a87a4350);
parcelRequire("d0pqD");

var $9EUYU = parcelRequire("9EUYU");

var $duA0Q = parcelRequire("duA0Q");
function $1e3a1d2a5c5c391a$export$820b8754a87a4350(ctx, { issueIds: issueIds, customFilterIds: customFilterIds, jql: jql }) {
    if (ctx.isCMPBoard) return (0, $duA0Q.fetchCMPBoardScopeData)(ctx.boardId, {
        activeQuickFilters: customFilterIds,
        projectType: ctx.projectType
    }).map(({ issues: issues, issueChildren: issueChildren, jqlSwimlanes: jqlSwimlanes })=>{
        const resultSet = new Set([
            ...issues,
            ...issueChildren
        ].map(({ id: id })=>id));
        return {
            cardIds: issueIds.filter((id)=>resultSet.has(id)).map((id)=>String(id)),
            jqlSwimlanes: jqlSwimlanes
        };
    });
    return (0, $9EUYU.fetchTMPFilteredCardIds)({
        boardId: ctx.boardId,
        issueIds: issueIds,
        customFilterIds: customFilterIds,
        jql: jql
    }).map((cardIds)=>({
            cardIds: cardIds
        }));
}

});
parcelRegister("9EUYU", function(module, exports) {

$parcel$export(module.exports, "fetchTMPFilteredCardIds", () => $d978ffd94d9886f6$export$36fe402b17bbc309);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $cBLvH = parcelRequire("cBLvH");
const $d978ffd94d9886f6$var$filteredCardsQuery = 'FilteredCardIds';
const $d978ffd94d9886f6$export$71eec30d9db46a56 = ()=>`
    query ${$d978ffd94d9886f6$var$filteredCardsQuery} ($boardId: ID!, $issueIds: [ID]!, $customFilterIds: [ID]!, $jql: String) {
        boardScope(boardId: $boardId) {
            filteredCardIds(
                issueIds: $issueIds,
                customFilterIds: $customFilterIds
                filterJql: $jql
            )
        }
    }
`;
function $d978ffd94d9886f6$export$36fe402b17bbc309({ boardId: boardId, issueIds: issueIds, customFilterIds: customFilterIds, jql: jql }) {
    return (0, $cBLvH.query$)('', $d978ffd94d9886f6$var$filteredCardsQuery, $d978ffd94d9886f6$export$71eec30d9db46a56(), {
        boardId: boardId,
        issueIds: issueIds,
        customFilterIds: customFilterIds,
        jql: jql
    }).flatMap(({ boardScope: boardScope })=>(0, $kVLXA.Observable).of(boardScope.filteredCardIds));
}

});

parcelRegister("duA0Q", function(module, exports) {

$parcel$export(module.exports, "fetchCMPBoardScopeData", () => $007589a2fb3ec1c4$export$f28480bd3cf8f969);
parcelRequire("d0pqD");

var $ebyGx = parcelRequire("ebyGx");

var $2vSU6 = parcelRequire("2vSU6");

var $487fd = parcelRequire("487fd");

var $bpHwy = parcelRequire("bpHwy");

var $kjrfP = parcelRequire("kjrfP");
function $007589a2fb3ec1c4$export$f28480bd3cf8f969(boardId, { activeQuickFilters: activeQuickFilters, activeSprints: activeSprints, includeHidden: includeHidden, projectType: projectType = (0, $2vSU6.SOFTWARE_PROJECT), skipExtraFields: skipExtraFields } = {}) {
    const query = {
        moduleKey: 'agile-web-board-service',
        hideCardExtraFields: true,
        onlyUseEpicsFromIssues: true,
        includeHidden: includeHidden,
        skipExtraFields: skipExtraFields,
        skipEtag: true,
        fields: projectType === (0, $2vSU6.SERVICE_DESK_PROJECT) ? [
            'request_type',
            'status'
        ] : undefined,
        operation: 'fetchBoardData'
    };
    if (activeQuickFilters && activeQuickFilters.length) // When you pass an array, we convert the query string into:
    // ? activeQuickFilters=1&activeQuickFilters=21
    // But unfortunately the monolith endpoint only supports CSV for this query parameter.
    query.activeQuickFilters = activeQuickFilters.join(',');
    if (activeSprints && activeSprints.length) query.activeSprints = activeSprints;
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query);
    return (0, $487fd.default)(`/rest/boards/latest/board/${boardId}?${queryStr}`).map((json)=>{
        // Refresh the board cache if we are fetching all issues (eg, no filters applied)
        if (includeHidden || !(query.activeQuickFilters || query.activeSprints)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $bpHwy.refreshUIFBoardData)(boardId, json);
        return (0, $kjrfP.transformMobileResponse)(json);
    });
}

});
parcelRegister("bpHwy", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $620843ca516c403b$export$240c6c415d37cd75);
$parcel$export(module.exports, "refreshUIFBoardData", () => $620843ca516c403b$export$f34cbc63057c38be);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $620843ca516c403b$export$60a4d33615c60f8);
$parcel$export(module.exports, "refreshUIFBacklogData", () => $620843ca516c403b$export$69efc1d2bf5ce2ae);
$parcel$export(module.exports, "fetchBacklogConfigData", () => $620843ca516c403b$export$e01389e26c6cdee);
$parcel$export(module.exports, "fetchBacklogGlobalConfigData", () => $620843ca516c403b$export$7e803310d32d4164);

var $jywXF = parcelRequire("jywXF");

var $cRqmM = parcelRequire("cRqmM");

var $c1BZi = parcelRequire("c1BZi");

var $l8SKN = parcelRequire("l8SKN");

var $8XYl5 = parcelRequire("8XYl5");
async function $620843ca516c403b$export$240c6c415d37cd75(params) {
    const { cachedPromise: cachedPromise, refreshPromise: refreshPromise } = (0, $c1BZi.fetchUIFBoardDataStream)(params);
    const refreshResult = refreshPromise.then((value)=>({
            value: value,
            type: 'refresh'
        }));
    const { value: result, type: type } = await Promise.race([
        cachedPromise.then((value)=>value != null ? {
                value: value,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: isCacheHit ? refreshPromise : null,
        isCacheHit: isCacheHit
    };
}
async function $620843ca516c403b$export$f34cbc63057c38be(boardId, response) {
    (0, $l8SKN.setBoardCachedEntry)({
        boardId: boardId
    }, {
        timestamp: Date.now(),
        etag: response.etag,
        data: response
    });
}
async function $620843ca516c403b$export$60a4d33615c60f8(boardId, queryParameters) {
    const { cachedPromise: cachedPromise, requestPromise: requestPromise } = (0, $jywXF.fetchUIFBacklogData)(boardId, queryParameters);
    const refreshResult = requestPromise.then((response)=>{
        $620843ca516c403b$export$69efc1d2bf5ce2ae(boardId, response);
        return {
            result: response,
            type: 'refresh'
        };
    });
    const { result: result, type: type } = await Promise.race([
        cachedPromise.then((cachedResult)=>cachedResult != null ? {
                result: cachedResult.data,
                type: 'cache'
            } : refreshResult),
        refreshResult
    ]);
    const isCacheHit = type === 'cache';
    return {
        result: result,
        refresh: type === 'cache' ? requestPromise : null,
        isCacheHit: isCacheHit
    };
}
function $620843ca516c403b$export$69efc1d2bf5ce2ae(boardId, response) {
    return (0, $cRqmM.setBacklogCachedEntry)(boardId, {
        timestamp: Date.now(),
        data: response
    });
}
async function $620843ca516c403b$export$e01389e26c6cdee(boardId) {
    const result = await (0, $8XYl5.fetchConfigData)(boardId);
    return {
        result: result,
        refresh: null,
        isCacheHit: false
    };
}
async function $620843ca516c403b$export$7e803310d32d4164() {
    const result = await (0, $8XYl5.fetchGlobalConfigData)();
    return {
        result: result,
        refresh: null,
        isCacheHit: false
    };
}

});
parcelRegister("jywXF", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBacklogDataOld", () => $b625b9c23407900e$export$df49ad631c58a3f6);
$parcel$export(module.exports, "fetchUIFBacklogData", () => $b625b9c23407900e$export$60a4d33615c60f8);
$parcel$export(module.exports, "runUIFBacklogEarlyScript", () => $b625b9c23407900e$export$a0c2e05a12ae5621);

var $ebyGx = parcelRequire("ebyGx");

var $tcn7E = parcelRequire("tcn7E");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $4R6GH = parcelRequire("4R6GH");

var $eKonk = parcelRequire("eKonk");

var $cRqmM = parcelRequire("cRqmM");

var $aBK23 = parcelRequire("aBK23");

var $hUQ5s = parcelRequire("hUQ5s");
// Removing isIndexedDBCachingEnabledForBacklog will make this obsolete.
let $b625b9c23407900e$var$backlogResponsePromise;
let $b625b9c23407900e$var$backlogResponse = null;
const $b625b9c23407900e$export$b08a6e96e3de5356 = (response)=>{
    $b625b9c23407900e$var$backlogResponsePromise = response;
};
const $b625b9c23407900e$export$592ab10c6cb9d596 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponsePromise;
    $b625b9c23407900e$var$backlogResponsePromise = null;
    return response;
};
const $b625b9c23407900e$export$55e9294018933a18 = (response)=>{
    $b625b9c23407900e$var$backlogResponse = response;
};
const $b625b9c23407900e$export$b55ab086f6a0c481 = ()=>{
    const response = $b625b9c23407900e$var$backlogResponse;
    $b625b9c23407900e$var$backlogResponse = null;
    return response;
};
const $b625b9c23407900e$var$onEnd = ()=>{
    (0, $x9xyg.setMark)('uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch/request', 'uif-backlog-fetch-start-request', 'uif-backlog-fetch-end');
    (0, $x9xyg.setMeasure)('uif-backlog-fetch', 'uif-backlog-fetch-start', 'uif-backlog-fetch-end');
};
const $b625b9c23407900e$export$df49ad631c58a3f6 = async (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$592ab10c6cb9d596();
    if (earlyScriptResponse) return earlyScriptResponse;
    (0, $x9xyg.setMark)('uif-backlog-fetch-start');
    const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
    (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
    const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
    const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
    const headers = {
        ...enhancedCapabilityHeader ? {
            'X-Atlassian-Capability': enhancedCapabilityHeader
        } : {}
    };
    Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
    const res = await fetch(backlogDataUrl, {
        headers: headers
    });
    const json = await res.json().catch(()=>null);
    if (!res.ok) {
        $b625b9c23407900e$var$onEnd();
        const traceId = (0, $l83Uu.getTraceId)(res);
        const message = (0, $aBK23.extractErrorMessage)(json);
        if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        else throw new (0, $dO0aE.FetchError)(res.status, message);
    }
    $b625b9c23407900e$var$onEnd();
    return json;
};
const $b625b9c23407900e$export$60a4d33615c60f8 = (boardId, queryParameters)=>{
    const earlyScriptResponse = $b625b9c23407900e$export$b55ab086f6a0c481();
    if (earlyScriptResponse) return earlyScriptResponse;
    const requestPromise = (async ()=>{
        (0, $x9xyg.setMark)('uif-backlog-fetch-start');
        const fetchUIFBacklogDataParams = (0, $hUQ5s.buildPlanDataFetchOptions)(boardId, queryParameters);
        const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(fetchUIFBacklogDataParams);
        (0, $x9xyg.setMark)('uif-backlog-fetch-start-request');
        const backlogDataUrl = `/rest/greenhopper/1.0/xboard/plan/v2/backlog/data?${queryStr}`;
        const enhancedCapabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$571692eec8a399e1));
        const headers = {
            ...enhancedCapabilityHeader ? {
                'X-Atlassian-Capability': enhancedCapabilityHeader
            } : {}
        };
        Object.assign(headers, (0, $tcn7E.getActiveTraceHttpRequestHeaders)(backlogDataUrl));
        const res = await fetch(backlogDataUrl, {
            headers: headers
        });
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            $b625b9c23407900e$var$onEnd();
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        $b625b9c23407900e$var$onEnd();
        return json;
    })();
    const cachedPromise = (0, $cRqmM.getBacklogCachedEntry)(boardId);
    return {
        requestPromise: requestPromise,
        cachedPromise: cachedPromise
    };
};
function $b625b9c23407900e$export$a0c2e05a12ae5621(location) {
    const parsedResult = (0, $aBK23.parseBacklogLocation)(location);
    if (!parsedResult) return false;
    const { boardId: boardId, queryParameters: queryParameters } = parsedResult;
    if ((0, $4R6GH.fg)('indexeddb_cache_for_backlog')) {
        const backlogData = $b625b9c23407900e$export$60a4d33615c60f8(boardId, queryParameters);
        $b625b9c23407900e$export$55e9294018933a18(backlogData);
    } else {
        const backlogData = $b625b9c23407900e$export$df49ad631c58a3f6(boardId, queryParameters);
        $b625b9c23407900e$export$b08a6e96e3de5356(backlogData);
    }
    return true;
}

});
const $281cbd47ba46dd7d$export$ef94a84e2990361c = 'ISSUE_VIEW';
const $281cbd47ba46dd7d$export$fc5f182fc9019b1c = 'CLASSIC_BOARD';
const $281cbd47ba46dd7d$export$664edf77d4c76110 = 'COMPANY_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$f364828958cffad0 = 'TEAM_MANAGED_BOARD';
const $281cbd47ba46dd7d$export$93104dc4eba58ba4 = 'CLASSIC_BACKLOG';
const $281cbd47ba46dd7d$export$571692eec8a399e1 = 'COMPANY_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$c17f34c425972af1 = 'TEAM_MANAGED_BACKLOG';
const $281cbd47ba46dd7d$export$d0ad1160bb95ce50 = 'NIN_NEW_ISSUE_NAVIGATOR';
const $281cbd47ba46dd7d$export$4695c1a423ffe431 = 'DASHBOARD';
const $281cbd47ba46dd7d$export$f999749ac7a2cd1 = 'PLAN_CALENDAR';
const $281cbd47ba46dd7d$export$9a80695e72849f84 = 'X-Atlassian-Capability';

parcelRegister("cRqmM", function(module, exports) {

$parcel$export(module.exports, "setBacklogCachedEntry", () => $31c19adcc162b6bc$export$a9fe76d96b47f80a);
$parcel$export(module.exports, "getBacklogCachedEntry", () => $31c19adcc162b6bc$export$d01cbd23f4b0c290);

var $sn9QA = parcelRequire("sn9QA");

var $2FZUH = parcelRequire("2FZUH");
const $31c19adcc162b6bc$export$1ba4f312a27970c1 = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-backlog');
async function $31c19adcc162b6bc$export$a9fe76d96b47f80a(boardId, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $31c19adcc162b6bc$export$1ba4f312a27970c1.clearAll();
        return Promise.resolve();
    }
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    return $31c19adcc162b6bc$export$1ba4f312a27970c1.set(key, entry);
}
async function $31c19adcc162b6bc$export$d01cbd23f4b0c290(boardId) {
    const key = (0, $2FZUH.buildCachedEntryKey)(boardId);
    try {
        const entry = await $31c19adcc162b6bc$export$1ba4f312a27970c1.get(key);
        if (!entry) return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $31c19adcc162b6bc$export$1ba4f312a27970c1.remove(key);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});
parcelRegister("sn9QA", function(module, exports) {

$parcel$export(module.exports, "createIndexedDBStorageProvider", () => $cf3437e9474a0e2b$export$6ba36c4f5fb8919d);

var $gJBT6 = parcelRequire("gJBT6");

var $8vEj7 = parcelRequire("8vEj7");
const $cf3437e9474a0e2b$export$6ba36c4f5fb8919d = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((appPrefix, options)=>{
    if (!appPrefix) throw Error("appPrefix can not be empty. It's used to separate apps");
    const provider = (0, $8vEj7.createStorageProvider)(appPrefix);
    if (options?.shouldAutoReconnect) return (0, $8vEj7.withAutoReconnect)(provider);
    return provider;
});

});
parcelRegister("8vEj7", function(module, exports) {

$parcel$export(module.exports, "createStorageProvider", () => $33b8db71261fb346$export$8441605555fbd60c);
$parcel$export(module.exports, "withAutoReconnect", () => $33b8db71261fb346$export$8432fe49db7d8865);

var $jIIX7 = parcelRequire("jIIX7");
const $33b8db71261fb346$export$7382f85ef4ff4314 = (prefix, key)=>`${prefix.replace(/_*$/, '')}__${key || ''}`;
const $33b8db71261fb346$var$createCustomStore = ()=>(0, $jIIX7.createStore)('keyval-store', 'keyval');
let $33b8db71261fb346$var$customStore;
const $33b8db71261fb346$var$getStore = ()=>{
    let store = $33b8db71261fb346$var$customStore;
    if (!store) {
        $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        store = $33b8db71261fb346$var$customStore;
    }
    return store;
};
const $33b8db71261fb346$export$8441605555fbd60c = (appPrefix)=>{
    const KEYS_STORE_PREFIX = $33b8db71261fb346$export$7382f85ef4ff4314(appPrefix);
    const prefix = (key)=>$33b8db71261fb346$export$7382f85ef4ff4314(appPrefix, key);
    // Runtime check to ensure a key is provided as the prefix without a key
    // holds an array of all the keys that are prefixed by this store
    const assertKey = (key)=>{
        if (!key) throw Error('You must provide a key');
    };
    // Calling `clearAll` would require us to iterate over every key in the
    // indexed-db, filtering by this instance's prefix and subsequently deleting
    // all the filtered keys. As indexed-db gains traction within Jira, this
    // will quickly become an expensive operation. To counteract this, we
    // instead store all the keys that this instance has created so that when it
    // comes time to clear them all, we simply just have to clear every key in
    // this store. This removes the need for iterating and filtering all
    // together.
    const updateStoreKeys = async (key, remove = false)=>(0, $jIIX7.update)(KEYS_STORE_PREFIX, (currentKeys)=>{
            const storeKeys = new Set(currentKeys);
            if (remove) {
                storeKeys.delete(key);
                return Array.from(storeKeys.values());
            }
            storeKeys.add(key);
            return Array.from(storeKeys.values());
        }, $33b8db71261fb346$var$getStore());
    return {
        async get (key) {
            assertKey(key);
            return (0, $jIIX7.get)(prefix(key), $33b8db71261fb346$var$getStore());
        },
        async remove (key) {
            assertKey(key);
            const prefixedKey = prefix(key);
            await (0, $jIIX7.del)(prefixedKey, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey, true);
        },
        async clearAll () {
            const prefixedKeys = await (0, $jIIX7.get)(KEYS_STORE_PREFIX, $33b8db71261fb346$var$getStore());
            if (!prefixedKeys || prefixedKeys.length === 0) return undefined;
            return (0, $jIIX7.delMany)(prefixedKeys.concat(KEYS_STORE_PREFIX));
        },
        async set (key, value) {
            assertKey(key);
            const prefixedKey = prefix(key);
            if (typeof value === 'function') // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            (0, $jIIX7.update)(prefixedKey, value);
            else (0, $jIIX7.set)(prefixedKey, value, $33b8db71261fb346$var$getStore());
            return updateStoreKeys(prefixedKey);
        },
        async reconnect () {
            $33b8db71261fb346$var$customStore = $33b8db71261fb346$var$createCustomStore();
        }
    };
};
const $33b8db71261fb346$export$8432fe49db7d8865 = (storageProvider)=>({
        async get (...args) {
            try {
                return await storageProvider.get(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.get(...args);
                }
                throw e;
            }
        },
        async set (...args) {
            try {
                return await storageProvider.set(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.set(...args);
                }
                throw e;
            }
        },
        async remove (...args) {
            try {
                return await storageProvider.remove(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.remove(...args);
                }
                throw e;
            }
        },
        async clearAll (...args) {
            try {
                return await storageProvider.clearAll(...args);
            } catch (e) {
                if (e instanceof Error) {
                    await storageProvider.reconnect?.();
                    return storageProvider.clearAll(...args);
                }
                throw e;
            }
        },
        async reconnect () {
            await storageProvider.reconnect?.();
        }
    });

});
parcelRegister("jIIX7", function(module, exports) {

$parcel$export(module.exports, "createStore", () => $e5b4ff07e835609c$export$f51a9068ac82ea43);
$parcel$export(module.exports, "get", () => $e5b4ff07e835609c$export$3988ae62b71be9a3);
$parcel$export(module.exports, "set", () => $e5b4ff07e835609c$export$adaa4cf7ef1b65be);
$parcel$export(module.exports, "update", () => $e5b4ff07e835609c$export$722fbec263ad908a);
$parcel$export(module.exports, "del", () => $e5b4ff07e835609c$export$1d2f21e549771e67);
$parcel$export(module.exports, "delMany", () => $e5b4ff07e835609c$export$c8aa84257229cac8);
function $e5b4ff07e835609c$export$b327150396135fe7(request) {
    return new Promise((resolve, reject)=>{
        // @ts-ignore - file size hacks
        request.oncomplete = request.onsuccess = ()=>resolve(request.result);
        // @ts-ignore - file size hacks
        request.onabort = request.onerror = ()=>reject(request.error);
    });
}
function $e5b4ff07e835609c$export$f51a9068ac82ea43(dbName, storeName) {
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = ()=>request.result.createObjectStore(storeName);
    const dbp = $e5b4ff07e835609c$export$b327150396135fe7(request);
    return (txMode, callback)=>dbp.then((db)=>callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let $e5b4ff07e835609c$var$defaultGetStoreFunc;
function $e5b4ff07e835609c$var$defaultGetStore() {
    if (!$e5b4ff07e835609c$var$defaultGetStoreFunc) $e5b4ff07e835609c$var$defaultGetStoreFunc = $e5b4ff07e835609c$export$f51a9068ac82ea43('keyval-store', 'keyval');
    return $e5b4ff07e835609c$var$defaultGetStoreFunc;
}
/**
 * Get a value by its key.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3988ae62b71be9a3(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)));
}
/**
 * Set a value with a key.
 *
 * @param key
 * @param value
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$adaa4cf7ef1b65be(key, value, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.put(value, key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Set multiple values at once. This is faster than calling set() multiple times.
 * It's also atomic – if one of the pairs can't be added, none will be added.
 *
 * @param entries Array of entries, where each entry is an array of `[key, value]`.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$daa0a5170277c7a8(entries, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        entries.forEach((entry)=>store.put(entry[1], entry[0]));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Get multiple values by their keys
 *
 * @param keys
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$5df405cccea42673(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>Promise.all(keys.map((key)=>$e5b4ff07e835609c$export$b327150396135fe7(store.get(key)))));
}
/**
 * Update a value. This lets you see the old value and update it as an atomic operation.
 *
 * @param key
 * @param updater A callback that takes the old value and returns a new value.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$722fbec263ad908a(key, updater, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>// Need to create the promise manually.
        // If I try to chain promises, the transaction closes in browsers
        // that use a promise polyfill (IE10/11).
        new Promise((resolve, reject)=>{
            store.get(key).onsuccess = function() {
                try {
                    store.put(updater(this.result), key);
                    resolve($e5b4ff07e835609c$export$b327150396135fe7(store.transaction));
                } catch (err) {
                    reject(err);
                }
            };
        }));
}
/**
 * Delete a particular key from the store.
 *
 * @param key
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$1d2f21e549771e67(key, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.delete(key);
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Delete multiple keys at once.
 *
 * @param keys List of keys to delete.
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$c8aa84257229cac8(keys, customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        keys.forEach((key)=>store.delete(key));
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
/**
 * Clear all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$42ffd38884aecdac(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readwrite', (store)=>{
        store.clear();
        return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
    });
}
function $e5b4ff07e835609c$var$eachCursor(store, callback) {
    store.openCursor().onsuccess = function() {
        if (!this.result) return;
        callback(this.result);
        this.result.continue();
    };
    return $e5b4ff07e835609c$export$b327150396135fe7(store.transaction);
}
/**
 * Get all keys in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$ed97f33186d4b816(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAllKeys) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.key)).then(()=>items);
    });
}
/**
 * Get all values in the store.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$68c286be0e7e55b7(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        if (store.getAll) return $e5b4ff07e835609c$export$b327150396135fe7(store.getAll());
        const items = [];
        return $e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push(cursor.value)).then(()=>items);
    });
}
/**
 * Get all entries in the store. Each entry is an array of `[key, value]`.
 *
 * @param customStore Method to get a custom store. Use with caution (see the docs).
 */ function $e5b4ff07e835609c$export$3e9f948b41964866(customStore = $e5b4ff07e835609c$var$defaultGetStore()) {
    return customStore('readonly', (store)=>{
        // Fast path for modern browsers
        // (although, hopefully we'll get a simpler path some day)
        if (store.getAll && store.getAllKeys) return Promise.all([
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAllKeys()),
            $e5b4ff07e835609c$export$b327150396135fe7(store.getAll())
        ]).then(([keys, values])=>keys.map((key, i)=>[
                    key,
                    values[i]
                ]));
        const items = [];
        return customStore('readonly', (store)=>$e5b4ff07e835609c$var$eachCursor(store, (cursor)=>items.push([
                    cursor.key,
                    cursor.value
                ])).then(()=>items));
    });
}

});



parcelRegister("2FZUH", function(module, exports) {

$parcel$export(module.exports, "isValid", () => $ec6817f630f9a6c9$export$1ea939691cdc45b8);
$parcel$export(module.exports, "getAccountId", () => $ec6817f630f9a6c9$export$c1e0336bde96e2dc);
$parcel$export(module.exports, "buildCachedEntryKey", () => $ec6817f630f9a6c9$export$59c82678f286b00f);

var $8QpSo = parcelRequire("8QpSo");

var $sn9QA = parcelRequire("sn9QA");
const $ec6817f630f9a6c9$var$EXPIRATION_TIME = 259200000; // 3 days
function $ec6817f630f9a6c9$export$1ea939691cdc45b8(cachedDataEntry) {
    const timeDelta = Date.now() - cachedDataEntry.timestamp;
    const expirationTime = $ec6817f630f9a6c9$var$EXPIRATION_TIME;
    return timeDelta < expirationTime;
}
const $ec6817f630f9a6c9$export$c1e0336bde96e2dc = (0, $8QpSo.default)(()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const el = document.querySelector('meta[name="ajs-atlassian-account-id"]');
    return el?.getAttribute('content') ?? null;
});
function $ec6817f630f9a6c9$export$59c82678f286b00f(boardId) {
    const accountId = $ec6817f630f9a6c9$export$c1e0336bde96e2dc() ?? 'no-account-id';
    return `local-device-cache::${accountId}::${boardId}`;
}
const $ec6817f630f9a6c9$export$cc1314e9c2424f02 = (0, $sn9QA.createIndexedDBStorageProvider)('labs-preferences');

});


parcelRegister("aBK23", function(module, exports) {

$parcel$export(module.exports, "convertQuickFiltersToString", () => $2271887588c9e1ef$export$4f216f9114f89403);
$parcel$export(module.exports, "getCachedQuickFilters", () => $2271887588c9e1ef$export$e59cda69449c77c2);
$parcel$export(module.exports, "parseBoardLocation", () => $2271887588c9e1ef$export$97471107364bd76c);
$parcel$export(module.exports, "parseBacklogLocation", () => $2271887588c9e1ef$export$be59cb299ab0331c);
$parcel$export(module.exports, "extractErrorMessage", () => $2271887588c9e1ef$export$8cc545829c7461b0);
$parcel$export(module.exports, "View", () => $2271887588c9e1ef$export$27a5bd065ad55220);
$parcel$export(module.exports, "getViewSettings", () => $2271887588c9e1ef$export$3ae70db4a97563c);

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");
const $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX = /\/jira\/software\/c\/?projects\/\w+\/boards\/(\d+)\/?(\?.*)?$/;
const $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX = /\/jira\/people\/[^/]+\/boards\/(\d+)\/?(\?.*)?$/;
// people/project match needs to consider `...:...` ids
const $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX = /\/jira\/(?:software\/c\/)?(?:projects|people)\/[^/]+\/boards\/(\d+)\/backlog\/?(\?.*)?$/;
const $2271887588c9e1ef$var$parsePath = (pathname, pattern)=>{
    const match = pattern.exec(pathname);
    if (!match) return null;
    const boardId = match[1];
    return {
        boardId: Number(boardId)
    };
};
const $2271887588c9e1ef$export$4f216f9114f89403 = (queryParameters)=>{
    // Terminate early for the null/undefined cases
    if (!queryParameters?.quickFilter) return undefined; // This is safe to return as it means the query string will just be excluded
    if (!Array.isArray(queryParameters.quickFilter)) {
        // If for whatever reason an object gets in here
        if (typeof queryParameters.quickFilter === 'object') // Fail gracefully
        return undefined;
        // Ensure that the value is a number
        if (Number.isNaN(Number(queryParameters.quickFilter))) return undefined;
        // this isn't an array. It's probably a string or number which is fine to return as is.
        return `${queryParameters.quickFilter}`;
    }
    // Array passed in is the common case
    // If it is empty, don't include it at all.
    if (queryParameters.quickFilter.length === 0) return undefined;
    return queryParameters.quickFilter.filter((val)=>Number.isInteger(Number(val))).join(',');
};
const $2271887588c9e1ef$export$e59cda69449c77c2 = (feature, boardId)=>{
    const localStorageKey = `__storejs_software_${feature}-filters.${boardId}`;
    const updatedStorageKey = `software.${feature}-filters.${boardId}`;
    let cachedFilters;
    const storage = localStorage;
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) // if new keys does not exist, falls back to older keys
    cachedFilters = storage.getItem(updatedStorageKey) || localStorage.getItem(localStorageKey);
    else cachedFilters = storage.getItem(localStorageKey);
    if (!cachedFilters) return undefined;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { CUSTOM_FILTER: cachedQuickFilters } = JSON.parse(cachedFilters);
    return cachedQuickFilters && cachedQuickFilters.length > 0 ? cachedQuickFilters.join(',') : undefined;
};
const $2271887588c9e1ef$export$97471107364bd76c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BOARD_REGEX) ?? $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$USER_LOCATED_BOARD_REGEX);
    if (!parsedPath) return null;
    const queryStringParameters = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {};
    // Early termination if the quick filter isnt a part of the query string
    if (!queryStringParameters.quickFilter) return {
        ...parsedPath
    };
    // Guarantee that the quick filter will be returned as an array. This helps with typing further upstream
    const quickFilterArray = Array.isArray(queryStringParameters.quickFilter) ? queryStringParameters.quickFilter : [
        queryStringParameters.quickFilter
    ];
    return {
        ...parsedPath,
        queryParameters: {
            quickFilter: quickFilterArray
        }
    };
};
const $2271887588c9e1ef$export$be59cb299ab0331c = ({ pathname: pathname, search: search })=>{
    const parsedPath = $2271887588c9e1ef$var$parsePath(pathname, $2271887588c9e1ef$var$SOFTWARE_BACKLOG_REGEX);
    if (!parsedPath) return null;
    return {
        ...parsedPath,
        queryParameters: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search) ?? {}
    };
};
const $2271887588c9e1ef$var$isErrorMessagesResponse = (json)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    json?.errorMessages instanceof Array;
const $2271887588c9e1ef$export$8cc545829c7461b0 = (json)=>{
    if ($2271887588c9e1ef$var$isErrorMessagesResponse(json)) {
        const { errorMessages: errorMessages } = json;
        return errorMessages.length ? errorMessages.join(', ') : undefined;
    }
    return undefined;
};
/* Copied from jira/src/packages/software/view-settings/src/services/local-storage/index.tsx
 to reduce bundle size by using native localStorage */ const $2271887588c9e1ef$var$VIEW_SETTINGS = 'view-settings';
const $2271887588c9e1ef$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $2271887588c9e1ef$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $2271887588c9e1ef$export$36e24695f02d4503 = (view)=>{
    if (view && view === $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD) return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
    if ((0, $4R6GH.fg)('jira_view_settings_additional_fields')) switch(view){
        case $2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.INCREMENT_PLANNING_BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BACKLOG}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.BOARD}`;
        case $2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD:
            return `${$2271887588c9e1ef$var$VIEW_SETTINGS}-${$2271887588c9e1ef$export$27a5bd065ad55220.JSM_BOARD}`;
        default:
            return $2271887588c9e1ef$var$VIEW_SETTINGS;
    }
    return $2271887588c9e1ef$var$VIEW_SETTINGS;
};
const $2271887588c9e1ef$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>{
    /**
	 * This usage is excluded via package exclusion in jira/ratcheting-rules.tsx
	 * Because it is only a READ Operation, and reads are not blocked in compliant APIs.
	 * This read will be tracked via a compliant API read in following code
	 * - Initializing view-settings panel on board: jira/src/packages/software/view-settings/src/ui/index.tsx
	 * - rendering cards on the board (Implementation In Progress https://hello.jira.atlassian.cloud/browse/PNDR-1926)
	 * More context in this discussion: https://atlassian.slack.com/archives/C02785CLSTW/p1722822320190909
	 */ const localStorageKey = `__storejs_${$2271887588c9e1ef$export$752f3d44db2fbd2d}_${$2271887588c9e1ef$export$36e24695f02d4503(view)}-${boardId}`;
    const updatedStorageKey = `${$2271887588c9e1ef$export$752f3d44db2fbd2d}.${$2271887588c9e1ef$export$36e24695f02d4503(view)}-${boardId}`;
    const legacyStorageKey = `__storejs_${$2271887588c9e1ef$export$752f3d44db2fbd2d}_${$2271887588c9e1ef$var$VIEW_SETTINGS}-${boardId}`;
    const updatedLegacyStorageKey = `${$2271887588c9e1ef$export$752f3d44db2fbd2d}.${$2271887588c9e1ef$var$VIEW_SETTINGS}-${boardId}`;
    const storage = localStorage;
    let viewSettingStorageValue;
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) viewSettingStorageValue = storage.getItem(updatedStorageKey) || storage.getItem(updatedLegacyStorageKey) || // if new keys does not exist, falls back to older keys
    storage.getItem(localStorageKey) || storage.getItem(legacyStorageKey);
    else viewSettingStorageValue = storage.getItem(localStorageKey) || // return legacy view settings if prefixed storage doesn't exist
    storage.getItem(legacyStorageKey);
    return JSON.parse(viewSettingStorageValue ?? 'null');
};

});

parcelRegister("hUQ5s", function(module, exports) {

$parcel$export(module.exports, "buildPlanDataFetchOptions", () => $f874c35ef69356eb$export$dab2d96649ebf00a);

var $aBK23 = parcelRequire("aBK23");
const $f874c35ef69356eb$export$68c4c1e22c91f23f = 'fetchBacklogData';
const $f874c35ef69356eb$var$parseActiveQuickFilters = (queryParameters, boardId)=>{
    if (queryParameters?.customFilter && typeof queryParameters?.customFilter === 'string') return queryParameters.customFilter.split(',');
    return (0, $aBK23.getCachedQuickFilters)('backlog', boardId)?.split(',');
};
const $f874c35ef69356eb$export$dab2d96649ebf00a = (boardId, queryParameters)=>({
        rapidViewId: boardId,
        forceConsistency: queryParameters?.forceConsistency ? /true/i.test(String(queryParameters.forceConsistency)) : true,
        activeQuickFilters: $f874c35ef69356eb$var$parseActiveQuickFilters(queryParameters, boardId),
        operation: $f874c35ef69356eb$export$68c4c1e22c91f23f
    });

});


parcelRegister("c1BZi", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardDataStream", () => $8173307478a42629$export$92fdd848ddb362ed);

var $dO0aE = parcelRequire("dO0aE");

var $d4P1V = parcelRequire("d4P1V");

var $l8SKN = parcelRequire("l8SKN");
function $8173307478a42629$export$92fdd848ddb362ed({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    const { cachedPromise: cachedBoardData, promise: promise } = (0, $d4P1V.fetchUIFBoardData)({
        boardId: boardId,
        queryParameters: queryParameters,
        fields: fields
    });
    const cachedPromise = cachedBoardData.then((cache)=>cache?.data ?? null);
    const refreshPromise = (async ()=>{
        const response = await promise;
        if (!response) throw new (0, $dO0aE.ResponseNullError)('CMP fetchUIFBoardData returned null');
        (0, $l8SKN.setBoardCachedEntry)({
            boardId: boardId
        }, {
            timestamp: Date.now(),
            etag: response.etag,
            data: response
        });
        return response;
    })();
    return {
        cachedPromise: cachedPromise,
        refreshPromise: refreshPromise
    };
}

});
parcelRegister("d4P1V", function(module, exports) {

$parcel$export(module.exports, "fetchUIFBoardData", () => $29c6e7c438197219$export$240c6c415d37cd75);
$parcel$export(module.exports, "runUIFBoardEarlyScript", () => $29c6e7c438197219$export$4c749dee5e4e8bc6);

var $ebyGx = parcelRequire("ebyGx");


var $x9xyg = parcelRequire("x9xyg");

var $l83Uu = parcelRequire("l83Uu");

var $dO0aE = parcelRequire("dO0aE");

var $5HnTq = parcelRequire("5HnTq");

var $eKonk = parcelRequire("eKonk");

var $l8SKN = parcelRequire("l8SKN");

var $aBK23 = parcelRequire("aBK23");
const $29c6e7c438197219$export$5aec1fe89a336a5d = 'fetchBoardData';
let $29c6e7c438197219$var$combinedBoardPromises = null;
function $29c6e7c438197219$var$putBoardEarlyScriptResponse(promises) {
    $29c6e7c438197219$var$combinedBoardPromises = promises;
}
function $29c6e7c438197219$export$1601e80f8f15c5cd() {
    const promises = $29c6e7c438197219$var$combinedBoardPromises;
    $29c6e7c438197219$var$combinedBoardPromises = null;
    return promises;
}
function $29c6e7c438197219$export$3b583d36792fd1ab(boardId) {
    const isCardCoversToggled = (0, $aBK23.getViewSettings)({
        boardId: Number(boardId),
        view: (0, $aBK23.View).BOARD
    })?.showCardCovers;
    // If viewSetting isn't set, return skipCardCovers as false by default
    if (isCardCoversToggled === null || isCardCoversToggled === undefined) return false;
    return !isCardCoversToggled;
}
function $29c6e7c438197219$export$240c6c415d37cd75({ boardId: boardId, queryParameters: queryParameters, fields: fields }) {
    // It is important that there is no async operation before this first
    // return block, otherwise we may create a cycle of this fetch with itself.
    const response = $29c6e7c438197219$export$1601e80f8f15c5cd();
    if (response) return response;
    (0, $x9xyg.setMark)('uif-board-fetch-start');
    const query = {
        moduleKey: 'agile-web-board-service',
        hideCardExtraFields: true,
        onlyUseEpicsFromIssues: true,
        skipEtag: true,
        skipExtraFields: true,
        includeHidden: true,
        activeQuickFilters: (0, $aBK23.convertQuickFiltersToString)(queryParameters) ?? (0, $aBK23.getCachedQuickFilters)('board', boardId),
        fields: fields,
        operation: $29c6e7c438197219$export$5aec1fe89a336a5d,
        skipCardCovers: $29c6e7c438197219$export$3b583d36792fd1ab(boardId)
    };
    const queryStr = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(query);
    (0, $x9xyg.setMark)('uif-board-fetch-start-request');
    const boardDataUrl = `/rest/boards/latest/board/${boardId}?${queryStr}`;
    const capabilityHeader = (0, $eKonk.getEnhancedCapabilityHeader)((0, $281cbd47ba46dd7d$export$664edf77d4c76110));
    const headers = {
        ...capabilityHeader ? {
            'X-Atlassian-Capability': capabilityHeader
        } : {}
    };
    const cachedPromise = (0, $l8SKN.getBoardCachedEntry)({
        boardId: boardId
    });
    const defaultOptions = (0, $5HnTq.getDefaultOptions)(boardDataUrl);
    const options = {
        ...defaultOptions,
        headers: {
            ...defaultOptions.headers,
            ...headers
        }
    };
    const promise = fetch(boardDataUrl, options).then(async (res)=>{
        const json = await res.json().catch(()=>null);
        (0, $x9xyg.setMark)('uif-board-fetch-end');
        (0, $x9xyg.setMeasure)('uif-board-fetch/request', 'uif-board-fetch-start-request', 'uif-board-fetch-end');
        (0, $x9xyg.setMeasure)('uif-board-fetch', 'uif-board-fetch-start', 'uif-board-fetch-end');
        if (!res.ok) {
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            if (traceId) throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
            else throw new (0, $dO0aE.FetchError)(res.status, message);
        }
        return json;
    });
    return {
        cachedPromise: cachedPromise,
        promise: promise
    };
}
function $29c6e7c438197219$export$4c749dee5e4e8bc6(location) {
    const parsedResult = (0, $aBK23.parseBoardLocation)(location);
    if (!parsedResult) return false;
    $29c6e7c438197219$var$putBoardEarlyScriptResponse($29c6e7c438197219$export$240c6c415d37cd75(parsedResult));
    return true;
}

});
parcelRegister("l8SKN", function(module, exports) {

$parcel$export(module.exports, "setBoardCachedEntry", () => $378b724625452625$export$ce85349d82f1217c);
$parcel$export(module.exports, "getBoardCachedEntry", () => $378b724625452625$export$992aa38aa2da87a4);

var $sn9QA = parcelRequire("sn9QA");

var $x9xyg = parcelRequire("x9xyg");

var $2FZUH = parcelRequire("2FZUH");
const $378b724625452625$export$13bc140835202cda = (0, $sn9QA.createIndexedDBStorageProvider)('cmp-board');
function $378b724625452625$export$4c715dd110bf64d2({ boardId: boardId, accountId: accountId, queryParameters: queryParameters }) {
    const params = [
        accountId,
        boardId
    ];
    if (queryParameters) params.push(JSON.stringify(queryParameters));
    const paramString = params.join('::');
    return `local-device-cache::${paramString}`;
}
async function $378b724625452625$export$ce85349d82f1217c({ boardId: boardId, queryParameters: queryParameters }, entry) {
    if (!entry.data.localDeviceCacheEnabled) {
        $378b724625452625$export$13bc140835202cda.clearAll();
        return Promise.resolve();
    }
    const accountId = (0, $2FZUH.getAccountId)() ?? 'no-account-id';
    const key = $378b724625452625$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    return $378b724625452625$export$13bc140835202cda.set(key, entry);
}
async function $378b724625452625$export$992aa38aa2da87a4({ boardId: boardId, queryParameters: queryParameters }) {
    const accountId = (0, $2FZUH.getAccountId)() ?? 'no-account-id';
    const cacheKey = $378b724625452625$export$4c715dd110bf64d2({
        boardId: boardId,
        accountId: accountId,
        queryParameters: queryParameters
    });
    try {
        (0, $x9xyg.setMark)('uif-board-fetch-read-cache-start');
        const entry = await $378b724625452625$export$13bc140835202cda.get(cacheKey);
        if (entry) (0, $x9xyg.setMark)('uif-board-fetch-read-cache-end');
        else return null;
        if (!(0, $2FZUH.isValid)(entry)) {
            await $378b724625452625$export$13bc140835202cda.remove(cacheKey);
            return null;
        }
        return entry;
    } catch (err) {
        return null;
    }
}

});



parcelRegister("8XYl5", function(module, exports) {

$parcel$export(module.exports, "fetchConfigData", () => $88832a6b5d28007e$export$89341835c2b99b9c);
$parcel$export(module.exports, "fetchGlobalConfigData", () => $88832a6b5d28007e$export$2835d43f6465400);

var $dO0aE = parcelRequire("dO0aE");
var $l83Uu = parcelRequire("l83Uu");

var $aBK23 = parcelRequire("aBK23");
let $88832a6b5d28007e$var$configData = null;
let $88832a6b5d28007e$var$globalConfigData = null;
const $88832a6b5d28007e$var$takeEarlyScriptConfigResponse = ()=>{
    const response = $88832a6b5d28007e$var$configData;
    $88832a6b5d28007e$var$configData = null;
    return response;
};
const $88832a6b5d28007e$var$takeEarlyScriptGlobalConfigResponse = ()=>{
    const response = $88832a6b5d28007e$var$globalConfigData;
    $88832a6b5d28007e$var$globalConfigData = null;
    return response;
};
function $88832a6b5d28007e$export$89341835c2b99b9c(boardId) {
    const earlyScriptResponse = $88832a6b5d28007e$var$takeEarlyScriptConfigResponse();
    if (earlyScriptResponse) return earlyScriptResponse;
    const promise = fetch(`/rest/greenhopper/3/xboard/config?boardId=${boardId}&operation=ConfigData`).then(async (res)=>{
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        }
        return json;
    });
    const response = promise;
    $88832a6b5d28007e$var$configData = response;
    return response;
}
function $88832a6b5d28007e$export$2835d43f6465400() {
    const earlyScriptResponse = $88832a6b5d28007e$var$takeEarlyScriptGlobalConfigResponse();
    if (earlyScriptResponse) return earlyScriptResponse;
    const promise = fetch('/rest/greenhopper/3/globalconfig?operation=GlobalConfigData').then(async (res)=>{
        const json = await res.json().catch(()=>null);
        if (!res.ok) {
            const traceId = (0, $l83Uu.getTraceId)(res);
            const message = (0, $aBK23.extractErrorMessage)(json);
            throw new (0, $dO0aE.FetchError)(res.status, message, traceId);
        }
        return json;
    });
    const response = promise;
    $88832a6b5d28007e$var$globalConfigData = response;
    return response;
}

});


parcelRegister("kjrfP", function(module, exports) {

$parcel$export(module.exports, "transformMobileResponse", () => $ab45c064a6f47d86$export$811bc00fcb931acd);

var $fn8B5 = parcelRequire("fn8B5");

var $gccSB = parcelRequire("gccSB");

var $4Xk2W = parcelRequire("4Xk2W");

var $5rFbt = parcelRequire("5rFbt");

var $gULOk = parcelRequire("gULOk");

var $x9xyg = parcelRequire("x9xyg");

var $aqRY1 = parcelRequire("aqRY1");

var $4R6GH = parcelRequire("4R6GH");

var $7SCny = parcelRequire("7SCny");

var $g4tDr = parcelRequire("g4tDr");


var $iuuJH = parcelRequire("iuuJH");

var $9qXMi = parcelRequire("9qXMi");

var $8qfoo = parcelRequire("8qfoo");
function $ab45c064a6f47d86$export$227473965d2e27db(mobileResponse) {
    return Object.values(mobileResponse.projects).map((project)=>{
        const { id: id, name: name, key: key, avatar: avatar, permissions: permissions, projectTypeKey: projectTypeKey, canRank: canRank } = project;
        return {
            id: id,
            name: name,
            key: key,
            avatar: avatar,
            permissions: permissions,
            projectTypeKey: projectTypeKey,
            canRank: canRank
        };
    });
}
const $ab45c064a6f47d86$export$b8850d46e7ad663c = (mobileResponse)=>{
    const { boardLocation: boardLocation } = mobileResponse;
    return {
        type: boardLocation.type,
        id: boardLocation.id,
        name: boardLocation.name,
        avatarUrl: boardLocation.avatarUrl,
        key: boardLocation.key,
        contextualKey: boardLocation.contextualKey
    };
};
const $ab45c064a6f47d86$var$GHX_TO_EPIC_COLOR = {
    'ghx-label-1': 'DARK_GREY',
    'ghx-label-2': 'DARK_YELLOW',
    'ghx-label-3': 'YELLOW',
    'ghx-label-4': 'DARK_BLUE',
    'ghx-label-5': 'DARK_TEAL',
    'ghx-label-6': 'GREEN',
    'ghx-label-7': 'PURPLE',
    'ghx-label-8': 'DARK_PURPLE',
    'ghx-label-9': 'ORANGE',
    'ghx-label-10': 'BLUE',
    'ghx-label-11': 'TEAL',
    'ghx-label-12': 'GREY',
    'ghx-label-13': 'DARK_GREEN',
    'ghx-label-14': 'DARK_ORANGE'
};
function $ab45c064a6f47d86$export$a718b06ed585fbab(color) {
    (0, $aqRY1.assertDefined)($ab45c064a6f47d86$var$GHX_TO_EPIC_COLOR[color], 'boardEpicGhxColorAssert', 'jiraSoftwareBoard', (0, $dcbb2bce513725b3$export$912517e8555c1752));
    return $ab45c064a6f47d86$var$GHX_TO_EPIC_COLOR[color] ?? (0, $7SCny.PURPLE);
}
function $ab45c064a6f47d86$var$isValidEpicColor(color) {
    const colorsAsStrings = (0, $7SCny.COLORS);
    return colorsAsStrings.includes(color);
}
function $ab45c064a6f47d86$export$e8d914406885ae13(color) {
    (0, $aqRY1.assertDefined)(color, 'boardEpicColorAssert', 'jiraSoftwareBoard', (0, $dcbb2bce513725b3$export$912517e8555c1752));
    if (!color) return 0, $7SCny.PURPLE;
    const upperCaseColor = color?.toUpperCase();
    (0, $aqRY1.assertDefined)(upperCaseColor, 'boardUpperCaseEpicColorAssert', 'jiraSoftwareBoard', (0, $dcbb2bce513725b3$export$912517e8555c1752), false, (value)=>$ab45c064a6f47d86$var$isValidEpicColor(value));
    return $ab45c064a6f47d86$var$isValidEpicColor(upperCaseColor) ? upperCaseColor : (0, $7SCny.PURPLE);
}
function $ab45c064a6f47d86$export$dbdfe6bbd9575fbb(mobileResponse) {
    return mobileResponse.epicIssues.map((epic)=>({
            id: epic.id,
            key: epic.key,
            // This might be okay to remove when https://app.launchdarkly.com/jira/staging/features/epic-related-fields-deprecation-main-flag_plni4/targeting
            // is fully rolled-out.
            summary: epic.summary || epic.epicName,
            status: epic.status ? $ab45c064a6f47d86$export$95f71e2e6b5bd102(epic.status) : undefined,
            issueType: {
                id: String(epic.issueType.id),
                iconUrl: epic.issueType.iconUrl,
                name: epic.issueType.name,
                hierarchyLevel: epic.issueType.hierarchyLevel
            },
            color: (0, $4R6GH.fg)('jsw-epic-panel-return-non-system-epics') ? $ab45c064a6f47d86$export$e8d914406885ae13(epic.color) : $ab45c064a6f47d86$export$a718b06ed585fbab(epic.color),
            flagged: epic.flagged
        }));
}
function $ab45c064a6f47d86$export$4c05e2584b34e4d8(mobileResponse) {
    return Object.keys(mobileResponse.issueTypes).map((issueTypeId)=>{
        const issueType = mobileResponse.issueTypes[issueTypeId];
        return {
            id: String(issueType.id),
            name: issueType.name,
            iconUrl: issueType.iconUrl,
            hierarchyLevelType: (0, $g4tDr.getHierarchyLevelType)(issueType.hierarchyLevel),
            default: issueType.default,
            // TODO: Missing issue type required fields and description
            hasRequiredFields: false,
            // so messy type, why is this required? crying....
            description: 'WHAT'
        };
    });
}
function $ab45c064a6f47d86$export$d3b8217e83b5a13c(mobileResponse) {
    return Object.keys(mobileResponse.requestTypes).map((requestTypeId)=>{
        const { id: id, name: name, iconUrl: iconUrl } = mobileResponse.requestTypes[requestTypeId];
        return {
            id: id,
            name: name,
            iconUrl: iconUrl
        };
    });
}
function $ab45c064a6f47d86$export$95f71e2e6b5bd102(mobileStatus) {
    return {
        id: Number(mobileStatus.id),
        name: mobileStatus.name,
        category: (0, $gULOk.statusCategoryForId)(mobileStatus.statusCategory.id)
    };
}
function $ab45c064a6f47d86$export$20a57a5ec025f2d(mobileResponse) {
    return Object.values(mobileResponse.statuses).map((status)=>$ab45c064a6f47d86$export$95f71e2e6b5bd102(status));
}
function $ab45c064a6f47d86$export$afdec38cdd10abc(mobileResponse) {
    const transitionsByIssueType = {};
    Object.values(mobileResponse.projects).forEach((project)=>{
        Object.keys(project.transitionsPerIssueType).forEach((key)=>{
            if (!transitionsByIssueType[key]) transitionsByIssueType[key] = [];
            transitionsByIssueType[key].push(...project.transitionsPerIssueType[key]);
        });
    });
    return transitionsByIssueType;
}
function $ab45c064a6f47d86$export$22390684d5fb6120(mobileResponse) {
    const allStatuses = mobileResponse.columns.flatMap((column)=>column.statuses);
    const statusesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(allStatuses, 'id');
    const transitionsByIssueType = $ab45c064a6f47d86$export$afdec38cdd10abc(mobileResponse);
    const issueTypeStatus = {};
    Object.keys(mobileResponse.issueTypes).forEach((issueTypeId)=>{
        const issueType = mobileResponse.issueTypes[issueTypeId];
        const transitions = transitionsByIssueType[issueType.id];
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        issueTypeStatus[issueType.id] = {};
        transitions?.forEach((transition)=>{
            const status = statusesById[transition.toStatusId];
            if (!status) return;
            issueTypeStatus[issueType.id][transition.toStatusId] = {
                id: Number(status.id),
                name: status.name,
                category: (0, $gULOk.statusCategoryForId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $gULOk.StatusCategoryIds)[status.statusCategory.key])
            };
        });
    });
    return issueTypeStatus;
}
function $ab45c064a6f47d86$export$a769014d580cbcab(column, transitionsByDestinationStatus) {
    const current = {};
    // The status ID here is a destination status ID, is there any reason to map
    // it against transitions by the source
    column.statusIds.forEach((statusId)=>{
        const transitions = [
            ...transitionsByDestinationStatus[statusId] || []
        ];
        transitions.forEach(({ issueTypeId: issueTypeId, transition: transition, projectKey: projectKey })=>{
            if (!current[issueTypeId]) current[issueTypeId] = [];
            // Don't allow duplicates if they have the same transition ID, project key and
            // source/destination status.
            // In JSM, it is entirely possible for transitions to have the same ID but different
            // source and destination statuses.
            // For CMP boards you can have multiple boards per project
            if (current[issueTypeId].some((issueTransition)=>issueTransition.id === transition.transitionId && issueTransition.projectKey === projectKey && issueTransition.sourceStatusId === Number(transition.fromStatusId) && issueTransition.destinationStatusId === Number(transition.toStatusId))) // transition already added to issueTypeId, avoid duplicate entry
            return;
            current[issueTypeId].push({
                id: transition.transitionId,
                name: transition.name,
                sourceStatusId: Number(transition.fromStatusId),
                destinationStatusId: Number(transition.toStatusId),
                isGlobal: transition.global,
                isInitial: transition.initial,
                hasConditions: transition.hasConditions,
                hasScreen: transition.hasScreen,
                projectKey: projectKey
            });
        });
    });
    return current;
}
function $ab45c064a6f47d86$export$b3d38447b0b164cc(mobileResponse) {
    // Note this contains duplicate entries for the same transitions if they
    // appear on multiple projects.
    const allTransitions = Object.values(mobileResponse.projects).flatMap((project)=>Object.keys(project.transitionsPerIssueType).flatMap((issueTypeId)=>project.transitionsPerIssueType[issueTypeId].map((transition)=>({
                    transition: transition,
                    issueTypeId: issueTypeId,
                    projectKey: project.key
                }))));
    const transitionsByDestinationStatus = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(allTransitions, (t)=>t.transition.toStatusId);
    const columnIssueTypeTransitions = {};
    mobileResponse.columns.forEach((column)=>{
        const current = $ab45c064a6f47d86$export$a769014d580cbcab(column, transitionsByDestinationStatus);
        columnIssueTypeTransitions[column.id] = current;
    });
    return columnIssueTypeTransitions;
}
function $ab45c064a6f47d86$export$fa6ea2b1c2da21b8(mobileResponse) {
    const issueTypeStatus = $ab45c064a6f47d86$export$22390684d5fb6120(mobileResponse);
    const columnIssueTypeTransitions = $ab45c064a6f47d86$export$b3d38447b0b164cc(mobileResponse);
    const cardTransitions = {
        columnIssueTypeTransitions: columnIssueTypeTransitions,
        issueTypeStatus: issueTypeStatus
    };
    return cardTransitions;
}
function $ab45c064a6f47d86$export$6e8deebce7129a99(mobileResponse, columnTransitions) {
    const isColumnConstraintSet = mobileResponse.statisticsConfig?.typeId && mobileResponse.statisticsConfig.typeId !== 'none';
    return mobileResponse.columns.map((column)=>({
            type: (0, $5rFbt.ColumnType).STATUS,
            id: column.id,
            maxIssueCount: isColumnConstraintSet ? column.maxLimit ?? null : null,
            minIssueCount: isColumnConstraintSet ? column.minLimit ?? null : null,
            limitJql: column.limitJql,
            name: column.name,
            statuses: column.statuses.map((status)=>{
                const category = (0, $gULOk.statusCategoryForId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                (0, $gULOk.StatusCategoryIds)[status.statusCategory.key]);
                return {
                    id: Number(status.id),
                    name: status.name,
                    category: category,
                    isDone: category === (0, $gULOk.DONE),
                    isInitial: Object.values(columnTransitions[column.id]).flatMap((t)=>t).some(({ isInitial: isInitial })=>isInitial)
                };
            })
        }));
}
function $ab45c064a6f47d86$export$6a33be7fc7f04943(mobileResponse) {
    return mobileResponse.sprints?.map((sprint)=>({
            id: sprint.id,
            name: sprint.name,
            startDate: sprint.isoStartDate,
            endDate: sprint.isoEndDate,
            canUpdateSprint: sprint.canUpdateSprint,
            daysRemaining: sprint.daysRemaining,
            goal: sprint.goal,
            state: sprint.state
        })) ?? [];
}
const $ab45c064a6f47d86$var$CMP_SWIMLANE_STRATEGY_TO_UIF_ID = {
    assignee: (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id,
    assigneeUnassignedFirst: (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id,
    parentChild: (0, $iuuJH.SWIMLANE_BY_SUBTASK).id,
    epic: (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id,
    none: (0, $iuuJH.NO_SWIMLANE).id,
    custom: (0, $iuuJH.SWIMLANE_BY_JQL).id,
    project: (0, $iuuJH.SWIMLANE_BY_PROJECT).id,
    request_type: (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id
};
function $ab45c064a6f47d86$export$cb77b16c47800e8d(swimlaneStrategy) {
    return $ab45c064a6f47d86$var$CMP_SWIMLANE_STRATEGY_TO_UIF_ID[swimlaneStrategy] ?? (0, $iuuJH.NO_SWIMLANE).id;
}
function $ab45c064a6f47d86$export$b9be17218375befc(mobileResponse) {
    return mobileResponse.swimlaneInfo.swimlaneStrategy === 'custom' ? mobileResponse.swimlaneInfo.swimlanes?.map((swimlane)=>({
            id: String(swimlane.id),
            name: swimlane.name,
            query: swimlane.query ?? 'true',
            description: swimlane.description,
            issueIds: swimlane.issueIds,
            isDefaultSwimlane: swimlane.defaultSwimlane
        })) : undefined;
}
const $ab45c064a6f47d86$export$844d7708d71f3c7a = (column)=>column.statuses?.every((status)=>status.statusCategory.key === 'done');
const $ab45c064a6f47d86$export$56ce4f6aa58a4e44 = (issueTypesById, issueTypeId)=>issueTypesById[issueTypeId] != null;
function $ab45c064a6f47d86$export$a26a6de2e9ae64a0(mobileResponse) {
    const epicsByKey = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(mobileResponse.epicIssues, 'key');
    const issueTypesById = mobileResponse.issueTypes;
    const prioritiesById = mobileResponse.priorities;
    const isChildIssueType = (issueTypeId)=>!!mobileResponse.issueTypes[issueTypeId]?.subtask;
    let missingIssueType = '';
    const allIssuesById = new Map(mobileResponse.columns.flatMap((column)=>column.issues.filter((issue)=>{
            const requirement = $ab45c064a6f47d86$export$56ce4f6aa58a4e44(issueTypesById, issue.issueTypeId);
            if (!requirement) missingIssueType = issue.issueTypeId;
            return requirement;
        }).map((issue)=>[
                issue.id,
                (0, $8qfoo.transformIssue)({
                    issue: issue,
                    estimation: mobileResponse.estimation,
                    column: column,
                    epicsByKey: epicsByKey,
                    issueTypesById: issueTypesById,
                    prioritiesById: prioritiesById,
                    sprints: mobileResponse.sprints
                })
            ])));
    const issues = [];
    const issueChildren = [];
    // We also filter out issue ids that are with missing issue types.
    const orderedIssueIds = [];
    mobileResponse.orderedIssueIds.forEach((id)=>{
        const issue = allIssuesById.get(id);
        if (!issue) return;
        if (isChildIssueType(issue.typeId)) issueChildren.push(issue);
        else // This is actually issue + issue parent
        // We need to render epics in CMP board except for swimlane by epic, so issue parents are included here with retaining the order.
        issues.push(issue);
        orderedIssueIds.push(id);
    });
    return {
        issues: issues,
        issueChildren: issueChildren,
        orderedIssueIds: orderedIssueIds,
        missingIssueType: missingIssueType
    };
}
function $ab45c064a6f47d86$export$d43fa2529adfda6d({ typeId: typeId }) {
    switch(typeId){
        case 'issueCount':
            return 'ISSUE_COUNT';
        case 'issueCountExclSubs':
            return 'ISSUE_COUNT_EXCLUDE_SUBTASKS';
        default:
            return undefined;
    }
}
function $ab45c064a6f47d86$export$1f9b32e9db1f9511(mobileResponse) {
    const { missingParents: missingParents } = mobileResponse;
    if (!missingParents) return [];
    return missingParents.map((missingParent)=>{
        const { id: id, key: key, summary: summary, assigneeAccountId: assigneeAccountId, parentId: parentId, typeUrl: typeUrl, status: status, projectId: projectId, typeId: typeId } = missingParent;
        const category = (0, $gULOk.statusCategoryForId)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $gULOk.StatusCategoryIds)[status.statusCategory.key]);
        return {
            id: id,
            key: key,
            summary: summary,
            assigneeAccountId: assigneeAccountId,
            typeUrl: typeUrl,
            parentId: parentId,
            status: {
                id: Number(status.id),
                name: status.name,
                category: category,
                isDone: category === (0, $gULOk.DONE),
                isInitial: false
            },
            projectId: projectId,
            typeId: Number(typeId),
            statusId: Number(status.id)
        };
    });
}
const $ab45c064a6f47d86$export$6e2c69d2f1c0121 = (mobileResponse)=>{
    // for a multi-project CMP boards, check if any of the projects can rank
    const canUserRank = Object.values(mobileResponse.projects).some((project)=>project.canRank);
    return {
        boardIsRankable: mobileResponse.rankable && canUserRank,
        rankCustomFieldId: canUserRank ? Number(mobileResponse.rankingCustomField) : NaN
    };
};
const $ab45c064a6f47d86$export$3f1f00772d9a3cb3 = ({ columns: columns, media: media })=>{
    // We can potentially do nothing if card media is turned off as well
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columns) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(media)) return {};
    return columns.flatMap((column)=>column.issues).reduce((map, issue)=>{
        const { cardMedia: cardMedia } = issue;
        if (!cardMedia) return Object.assign(map, {
            [String(issue.id)]: null
        });
        return Object.assign(map, {
            [String(issue.id)]: {
                attachmentId: String(cardMedia.attachmentId),
                attachmentMediaApiId: cardMedia.mediaApiFileId,
                endpointUrl: media?.endpointUrl,
                clientId: media?.clientId,
                isHiddenByUser: false,
                token: cardMedia.mediaReadToken
            }
        });
    }, {});
};
function $ab45c064a6f47d86$export$811bc00fcb931acd(json) {
    return (0, $x9xyg.measureFunc)('uif-board-transformMobileResponse', ()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const mobileResponse = json;
        const { issues: issues, issueChildren: issueChildren, orderedIssueIds: orderedIssueIds, missingIssueType: missingIssueType } = $ab45c064a6f47d86$export$a26a6de2e9ae64a0(mobileResponse);
        const people = Object.values(mobileResponse.people).map((person)=>({
                ...person,
                id: person.accountId
            }));
        const cardTransitions = $ab45c064a6f47d86$export$fa6ea2b1c2da21b8(mobileResponse);
        const columns = $ab45c064a6f47d86$export$6e8deebce7129a99(mobileResponse, cardTransitions.columnIssueTypeTransitions);
        const issueParents = $ab45c064a6f47d86$export$dbdfe6bbd9575fbb(mobileResponse);
        const issueTypes = $ab45c064a6f47d86$export$4c05e2584b34e4d8(mobileResponse);
        const requestTypes = $ab45c064a6f47d86$export$d3b8217e83b5a13c(mobileResponse);
        const statuses = $ab45c064a6f47d86$export$20a57a5ec025f2d(mobileResponse);
        const projects = $ab45c064a6f47d86$export$227473965d2e27db(mobileResponse);
        const boardLocation = $ab45c064a6f47d86$export$b8850d46e7ad663c(mobileResponse);
        const capabilities = {
            BACKLOG: mobileResponse.capabilities.BACKLOG.enabled,
            SPRINTS: mobileResponse.capabilities.SPRINTS.enabled,
            REPORTS: mobileResponse.capabilities.REPORTS.enabled,
            ESTIMATION: mobileResponse.capabilities.ESTIMATION.enabled,
            RELEASES: mobileResponse.capabilities.RELEASES.enabled
        };
        const boardConfig = {
            isCardMediaEnabled: false,
            boardIssueListKey: undefined,
            requestColumnMigration: undefined,
            isSprintsEnabled: false,
            isBacklogEnabled: false,
            issuesCountByColumn: {},
            isManageRulesEnabled: false,
            areEpicLabelsHidden: (0, $9qXMi.getHideEpics)(mobileResponse.id),
            columnConstraintType: $ab45c064a6f47d86$export$d43fa2529adfda6d(mobileResponse.statisticsConfig)
        };
        const sprints = $ab45c064a6f47d86$export$6a33be7fc7f04943(mobileResponse);
        const swimlaneModeId = $ab45c064a6f47d86$export$cb77b16c47800e8d(mobileResponse.swimlaneInfo.swimlaneStrategy);
        return {
            issues: issues,
            people: people,
            projects: projects,
            boardLocation: boardLocation,
            boardConfig: boardConfig,
            issueMedia: $ab45c064a6f47d86$export$3f1f00772d9a3cb3(mobileResponse),
            config: $ab45c064a6f47d86$export$6e2c69d2f1c0121(mobileResponse),
            hasFilteredIssues: false,
            columns: columns,
            swimlaneModeId: swimlaneModeId,
            adminConfiguredSwimlaneModeId: swimlaneModeId,
            sprints: sprints,
            isSprintsEnabled: (sprints?.length ?? 0) > 0,
            boardName: mobileResponse.name,
            capabilities: capabilities,
            issueParents: issueParents,
            issueTypes: issueTypes,
            projectIssueTypes: issueTypes,
            requestTypes: requestTypes,
            statuses: statuses,
            boardPermissions: {
                createIssue: projects[0]?.permissions?.CREATE_ISSUES ?? true,
                // TODO: per issue permissions
                // ! project permissions doesn't include EDIT_ISSUES so will assume create issue at the moment
                editIssue: projects[0]?.permissions?.CREATE_ISSUES ?? true,
                // TODO: per issue permissions???
                deleteIssue: projects[0]?.permissions?.DELETE_ISSUES ?? true,
                archiveIssue: projects[0]?.permissions?.ARCHIVE_ISSUES ?? true,
                manageSprint: sprints.some((sprint)=>sprint.canUpdateSprint),
                editBoardConfig: mobileResponse.canEdit,
                manageAutomation: true,
                canRelease: mobileResponse.canRelease,
                scheduleIssue: projects[0]?.permissions?.SCHEDULE_ISSUES ?? false,
                assignIssue: projects[0]?.permissions?.ASSIGN_ISSUES ?? false
            },
            issueChildren: issueChildren,
            cardTransitions: cardTransitions,
            inlineCardCreate: mobileResponse.inlineCardCreate,
            isInlineColumnEditEnabled: mobileResponse.isUsingSimplifiedWorkflow === true,
            // TODO: Missing features
            allFeatures: [
                {
                    key: 'BACKLOG',
                    status: mobileResponse.capabilities.BACKLOG.enabled ? 'ENABLED' : 'DISABLED',
                    toggle: mobileResponse.capabilities.BACKLOG.enabled ? 'ENABLED' : 'DISABLED',
                    category: 'CMP STUFF'
                },
                {
                    key: 'SPRINTS',
                    status: mobileResponse.capabilities.SPRINTS.enabled ? 'ENABLED' : 'DISABLED',
                    toggle: mobileResponse.capabilities.SPRINTS.enabled ? 'ENABLED' : 'DISABLED',
                    category: 'CMP STUFF'
                }
            ],
            // THIS MUST BE NULL
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            estimationStatistic: null,
            customFilters: mobileResponse.filters?.map((filter)=>({
                    id: String(filter.id),
                    name: filter.name,
                    description: filter.description
                })),
            jqlSwimlanes: $ab45c064a6f47d86$export$b9be17218375befc(mobileResponse),
            boardType: mobileResponse.type === 'SCRUM' ? 'SCRUM' : 'KANBAN',
            etag: mobileResponse.etag,
            orderedIssueIds: orderedIssueIds,
            missingParents: $ab45c064a6f47d86$export$1f9b32e9db1f9511(mobileResponse),
            hierarchyNomenclature: mobileResponse?.flexibleNomenclatureData?.levelOneName ? {
                firstLevelName: mobileResponse.flexibleNomenclatureData.levelOneName
            } : null,
            issueLimitExceeded: mobileResponse.issueLimitExceeded,
            savedFilterId: mobileResponse.savedFilterId,
            missingIssueType: missingIssueType
        };
    });
}

});
parcelRegister("aqRY1", function(module, exports) {

$parcel$export(module.exports, "assertDefined", () => $bbb3775fa1194a41$export$9b7692f0c207a7cd);

var $jcw0u = parcelRequire("jcw0u");

const $bbb3775fa1194a41$var$cache = new Map();
const $bbb3775fa1194a41$export$3e0286bdde58984 = ()=>$bbb3775fa1194a41$var$cache.size === 0;
const $bbb3775fa1194a41$export$9b7692f0c207a7cd = (value, id, packageName, teamName, skipSentry = false, validator)=>{
    try {
        if (validator ? !validator(value) : value === undefined || value === null) {
            const cacheKey = `${packageName}.${id}`;
            if ($bbb3775fa1194a41$var$cache.has(cacheKey)) clearTimeout($bbb3775fa1194a41$var$cache.get(cacheKey));
            const handle = setTimeout(()=>{
                (0, $jcw0u.default)({
                    error: new Error(`${cacheKey} failed assert`),
                    meta: {
                        id: id,
                        packageName: packageName,
                        teamName: teamName
                    },
                    skipSentry: skipSentry
                });
                $bbb3775fa1194a41$var$cache.delete(cacheKey);
            }, (0, $954c59ba93401292$export$6b24cda34eed72ea));
            $bbb3775fa1194a41$var$cache.set(cacheKey, handle);
        }
    } catch (error) {
    // just in case
    // fireErrorAnalytics will throw if false is true
    }
};

});
const $954c59ba93401292$export$6b24cda34eed72ea = 3000;


parcelRegister("7SCny", function(module, exports) {

$parcel$export(module.exports, "PURPLE", () => $8e4230f608d6b965$export$7ffdeca4b2f927a2);
$parcel$export(module.exports, "DARK_PURPLE", () => $8e4230f608d6b965$export$c815fe495e8174a0);
$parcel$export(module.exports, "BLUE", () => $8e4230f608d6b965$export$738c3b9a44c87ecc);
$parcel$export(module.exports, "DARK_BLUE", () => $8e4230f608d6b965$export$1225f83626261b80);
$parcel$export(module.exports, "GREEN", () => $8e4230f608d6b965$export$48d4b2cd5bc0e88b);
$parcel$export(module.exports, "DARK_GREEN", () => $8e4230f608d6b965$export$c6f4cf2e5768eb78);
$parcel$export(module.exports, "TEAL", () => $8e4230f608d6b965$export$d0446fe88325854e);
$parcel$export(module.exports, "DARK_TEAL", () => $8e4230f608d6b965$export$bb848c92687e69dc);
$parcel$export(module.exports, "YELLOW", () => $8e4230f608d6b965$export$aab610c505c06a8f);
$parcel$export(module.exports, "DARK_YELLOW", () => $8e4230f608d6b965$export$466af87757d343a2);
$parcel$export(module.exports, "ORANGE", () => $8e4230f608d6b965$export$3de5e29ed1757f9b);
$parcel$export(module.exports, "DARK_ORANGE", () => $8e4230f608d6b965$export$da02e4820b6ab753);
$parcel$export(module.exports, "GREY", () => $8e4230f608d6b965$export$7d278ca694634874);
$parcel$export(module.exports, "DARK_GREY", () => $8e4230f608d6b965$export$26453300bfc61cb8);
$parcel$export(module.exports, "COLORS", () => $8e4230f608d6b965$export$56d196d2844d1ca1);
$parcel$export(module.exports, "SERVER_PURPLE", () => $8e4230f608d6b965$export$792af22a0198af8d);
$parcel$export(module.exports, "SERVER_DARK_PURPLE", () => $8e4230f608d6b965$export$588af712afdcb006);
$parcel$export(module.exports, "SERVER_BLUE", () => $8e4230f608d6b965$export$84c4918645391802);
$parcel$export(module.exports, "SERVER_DARK_BLUE", () => $8e4230f608d6b965$export$b8f1f5838352a33a);
$parcel$export(module.exports, "SERVER_GREEN", () => $8e4230f608d6b965$export$9384b7e350ee6542);
$parcel$export(module.exports, "SERVER_DARK_GREEN", () => $8e4230f608d6b965$export$87d3fb8d8656d38b);
$parcel$export(module.exports, "SERVER_TEAL", () => $8e4230f608d6b965$export$b0b4ce3e99e66aae);
$parcel$export(module.exports, "SERVER_DARK_TEAL", () => $8e4230f608d6b965$export$a89b77a449bd223e);
$parcel$export(module.exports, "SERVER_YELLOW", () => $8e4230f608d6b965$export$9a33b5e3cde94885);
$parcel$export(module.exports, "SERVER_DARK_YELLOW", () => $8e4230f608d6b965$export$33253d7862bceb8a);
$parcel$export(module.exports, "SERVER_ORANGE", () => $8e4230f608d6b965$export$6609c2b23fc42f39);
$parcel$export(module.exports, "SERVER_DARK_ORANGE", () => $8e4230f608d6b965$export$cd994662b5911917);
$parcel$export(module.exports, "SERVER_GREY", () => $8e4230f608d6b965$export$1793d43e13e078c5);
$parcel$export(module.exports, "SERVER_DARK_GREY", () => $8e4230f608d6b965$export$487a6e9145526564);
$parcel$export(module.exports, "GHX_LABEL_1", () => $8e4230f608d6b965$export$e4bdf2d4c4bbb15e);
$parcel$export(module.exports, "GHX_LABEL_2", () => $8e4230f608d6b965$export$8f5c1c5512278dc6);
$parcel$export(module.exports, "GHX_LABEL_3", () => $8e4230f608d6b965$export$94ac87c81ed074a7);
$parcel$export(module.exports, "GHX_LABEL_4", () => $8e4230f608d6b965$export$6bc9ab1f489f76f7);
$parcel$export(module.exports, "GHX_LABEL_5", () => $8e4230f608d6b965$export$610a2c132b6fcf96);
$parcel$export(module.exports, "GHX_LABEL_6", () => $8e4230f608d6b965$export$8e4997dba71f1c40);
$parcel$export(module.exports, "GHX_LABEL_7", () => $8e4230f608d6b965$export$18a545b4e69b27b4);
$parcel$export(module.exports, "GHX_LABEL_8", () => $8e4230f608d6b965$export$27fff1a0d295292a);
$parcel$export(module.exports, "GHX_LABEL_9", () => $8e4230f608d6b965$export$e57aa662a56724e1);
$parcel$export(module.exports, "GHX_LABEL_10", () => $8e4230f608d6b965$export$4b0d63e2c3be2072);
$parcel$export(module.exports, "GHX_LABEL_11", () => $8e4230f608d6b965$export$457ecb9560f2bf83);
$parcel$export(module.exports, "GHX_LABEL_12", () => $8e4230f608d6b965$export$a866db37165a696c);
$parcel$export(module.exports, "GHX_LABEL_13", () => $8e4230f608d6b965$export$9b18447c1168a1b6);
$parcel$export(module.exports, "GHX_LABEL_14", () => $8e4230f608d6b965$export$93b9ad4020e271b7);
$parcel$export(module.exports, "AGILE_COLOR_1", () => $8e4230f608d6b965$export$5cd2af17b34de3e3);
$parcel$export(module.exports, "AGILE_COLOR_2", () => $8e4230f608d6b965$export$987671fa69482a7b);
$parcel$export(module.exports, "AGILE_COLOR_3", () => $8e4230f608d6b965$export$70ba8a5b1f4c7446);
$parcel$export(module.exports, "AGILE_COLOR_4", () => $8e4230f608d6b965$export$fcd1c42d8d3ebd36);
$parcel$export(module.exports, "AGILE_COLOR_5", () => $8e4230f608d6b965$export$f80a5bd2fa0ba256);
$parcel$export(module.exports, "AGILE_COLOR_6", () => $8e4230f608d6b965$export$37ad5ce8d2aeaf78);
$parcel$export(module.exports, "AGILE_COLOR_7", () => $8e4230f608d6b965$export$9dc62d5d151cb355);
$parcel$export(module.exports, "AGILE_COLOR_8", () => $8e4230f608d6b965$export$1ed15b30f5663f92);
$parcel$export(module.exports, "AGILE_COLOR_9", () => $8e4230f608d6b965$export$5d23a84d55ac1644);
$parcel$export(module.exports, "AGILE_COLOR_10", () => $8e4230f608d6b965$export$bf08c9a6ed42e349);
$parcel$export(module.exports, "AGILE_COLOR_11", () => $8e4230f608d6b965$export$66c5d8f0b5ff279c);
$parcel$export(module.exports, "AGILE_COLOR_12", () => $8e4230f608d6b965$export$da30755a37c3a597);
$parcel$export(module.exports, "AGILE_COLOR_13", () => $8e4230f608d6b965$export$721cf84faff6bf19);
$parcel$export(module.exports, "AGILE_COLOR_14", () => $8e4230f608d6b965$export$4b8f8666bd7b61dd);
$parcel$export(module.exports, "Colors", () => $8e4230f608d6b965$export$c537fa0d021d010b);
$parcel$export(module.exports, "ServerColors", () => $8e4230f608d6b965$export$d33d39828a18210a);
$parcel$export(module.exports, "ClassicEpicColors", () => $8e4230f608d6b965$export$f476e6e43e0101e7);
$parcel$export(module.exports, "AgileColors", () => $8e4230f608d6b965$export$4b7407b8700035bd);
/**
 * @fileoverview This file was moved from `@atlassian/jira-issue-epic-color-types`
 * so that these types do not require atlaskit dependencies.
 *
 * Color constants
 */ const $8e4230f608d6b965$export$7ffdeca4b2f927a2 = 'PURPLE';
const $8e4230f608d6b965$export$c815fe495e8174a0 = 'DARK_PURPLE';
const $8e4230f608d6b965$export$738c3b9a44c87ecc = 'BLUE';
const $8e4230f608d6b965$export$1225f83626261b80 = 'DARK_BLUE';
const $8e4230f608d6b965$export$48d4b2cd5bc0e88b = 'GREEN';
const $8e4230f608d6b965$export$c6f4cf2e5768eb78 = 'DARK_GREEN';
const $8e4230f608d6b965$export$d0446fe88325854e = 'TEAL';
const $8e4230f608d6b965$export$bb848c92687e69dc = 'DARK_TEAL';
const $8e4230f608d6b965$export$aab610c505c06a8f = 'YELLOW';
const $8e4230f608d6b965$export$466af87757d343a2 = 'DARK_YELLOW';
const $8e4230f608d6b965$export$3de5e29ed1757f9b = 'ORANGE';
const $8e4230f608d6b965$export$da02e4820b6ab753 = 'DARK_ORANGE';
const $8e4230f608d6b965$export$7d278ca694634874 = 'GREY';
const $8e4230f608d6b965$export$26453300bfc61cb8 = 'DARK_GREY';
const $8e4230f608d6b965$export$56d196d2844d1ca1 = [
    $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    $8e4230f608d6b965$export$c815fe495e8174a0,
    $8e4230f608d6b965$export$738c3b9a44c87ecc,
    $8e4230f608d6b965$export$1225f83626261b80,
    $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    $8e4230f608d6b965$export$d0446fe88325854e,
    $8e4230f608d6b965$export$bb848c92687e69dc,
    $8e4230f608d6b965$export$aab610c505c06a8f,
    $8e4230f608d6b965$export$466af87757d343a2,
    $8e4230f608d6b965$export$3de5e29ed1757f9b,
    $8e4230f608d6b965$export$da02e4820b6ab753,
    $8e4230f608d6b965$export$7d278ca694634874,
    $8e4230f608d6b965$export$26453300bfc61cb8
];
const $8e4230f608d6b965$export$792af22a0198af8d = 'purple';
const $8e4230f608d6b965$export$588af712afdcb006 = 'dark_purple';
const $8e4230f608d6b965$export$84c4918645391802 = 'blue';
const $8e4230f608d6b965$export$b8f1f5838352a33a = 'dark_blue';
const $8e4230f608d6b965$export$9384b7e350ee6542 = 'green';
const $8e4230f608d6b965$export$87d3fb8d8656d38b = 'dark_green';
const $8e4230f608d6b965$export$b0b4ce3e99e66aae = 'teal';
const $8e4230f608d6b965$export$a89b77a449bd223e = 'dark_teal';
const $8e4230f608d6b965$export$9a33b5e3cde94885 = 'yellow';
const $8e4230f608d6b965$export$33253d7862bceb8a = 'dark_yellow';
const $8e4230f608d6b965$export$6609c2b23fc42f39 = 'orange';
const $8e4230f608d6b965$export$cd994662b5911917 = 'dark_orange';
const $8e4230f608d6b965$export$1793d43e13e078c5 = 'grey';
const $8e4230f608d6b965$export$487a6e9145526564 = 'dark_grey';
const $8e4230f608d6b965$export$e4bdf2d4c4bbb15e = 'ghx-label-1';
const $8e4230f608d6b965$export$8f5c1c5512278dc6 = 'ghx-label-2';
const $8e4230f608d6b965$export$94ac87c81ed074a7 = 'ghx-label-3';
const $8e4230f608d6b965$export$6bc9ab1f489f76f7 = 'ghx-label-4';
const $8e4230f608d6b965$export$610a2c132b6fcf96 = 'ghx-label-5';
const $8e4230f608d6b965$export$8e4997dba71f1c40 = 'ghx-label-6';
const $8e4230f608d6b965$export$18a545b4e69b27b4 = 'ghx-label-7';
const $8e4230f608d6b965$export$27fff1a0d295292a = 'ghx-label-8';
const $8e4230f608d6b965$export$e57aa662a56724e1 = 'ghx-label-9';
const $8e4230f608d6b965$export$4b0d63e2c3be2072 = 'ghx-label-10';
const $8e4230f608d6b965$export$457ecb9560f2bf83 = 'ghx-label-11';
const $8e4230f608d6b965$export$a866db37165a696c = 'ghx-label-12';
const $8e4230f608d6b965$export$9b18447c1168a1b6 = 'ghx-label-13';
const $8e4230f608d6b965$export$93b9ad4020e271b7 = 'ghx-label-14';
const $8e4230f608d6b965$export$5cd2af17b34de3e3 = 'color_1';
const $8e4230f608d6b965$export$987671fa69482a7b = 'color_2';
const $8e4230f608d6b965$export$70ba8a5b1f4c7446 = 'color_3';
const $8e4230f608d6b965$export$fcd1c42d8d3ebd36 = 'color_4';
const $8e4230f608d6b965$export$f80a5bd2fa0ba256 = 'color_5';
const $8e4230f608d6b965$export$37ad5ce8d2aeaf78 = 'color_6';
const $8e4230f608d6b965$export$9dc62d5d151cb355 = 'color_7';
const $8e4230f608d6b965$export$1ed15b30f5663f92 = 'color_8';
const $8e4230f608d6b965$export$5d23a84d55ac1644 = 'color_9';
const $8e4230f608d6b965$export$bf08c9a6ed42e349 = 'color_10';
const $8e4230f608d6b965$export$66c5d8f0b5ff279c = 'color_11';
const $8e4230f608d6b965$export$da30755a37c3a597 = 'color_12';
const $8e4230f608d6b965$export$721cf84faff6bf19 = 'color_13';
const $8e4230f608d6b965$export$4b8f8666bd7b61dd = 'color_14';
const $8e4230f608d6b965$export$c537fa0d021d010b = {
    PURPLE: $8e4230f608d6b965$export$7ffdeca4b2f927a2,
    DARK_PURPLE: $8e4230f608d6b965$export$c815fe495e8174a0,
    BLUE: $8e4230f608d6b965$export$738c3b9a44c87ecc,
    DARK_BLUE: $8e4230f608d6b965$export$1225f83626261b80,
    GREEN: $8e4230f608d6b965$export$48d4b2cd5bc0e88b,
    DARK_GREEN: $8e4230f608d6b965$export$c6f4cf2e5768eb78,
    TEAL: $8e4230f608d6b965$export$d0446fe88325854e,
    DARK_TEAL: $8e4230f608d6b965$export$bb848c92687e69dc,
    YELLOW: $8e4230f608d6b965$export$aab610c505c06a8f,
    DARK_YELLOW: $8e4230f608d6b965$export$466af87757d343a2,
    ORANGE: $8e4230f608d6b965$export$3de5e29ed1757f9b,
    DARK_ORANGE: $8e4230f608d6b965$export$da02e4820b6ab753,
    GREY: $8e4230f608d6b965$export$7d278ca694634874,
    DARK_GREY: $8e4230f608d6b965$export$26453300bfc61cb8
};
const $8e4230f608d6b965$export$d33d39828a18210a = {
    SERVER_PURPLE: $8e4230f608d6b965$export$792af22a0198af8d,
    SERVER_DARK_PURPLE: $8e4230f608d6b965$export$588af712afdcb006,
    SERVER_BLUE: $8e4230f608d6b965$export$84c4918645391802,
    SERVER_DARK_BLUE: $8e4230f608d6b965$export$b8f1f5838352a33a,
    SERVER_GREEN: $8e4230f608d6b965$export$9384b7e350ee6542,
    SERVER_DARK_GREEN: $8e4230f608d6b965$export$87d3fb8d8656d38b,
    SERVER_TEAL: $8e4230f608d6b965$export$b0b4ce3e99e66aae,
    SERVER_DARK_TEAL: $8e4230f608d6b965$export$a89b77a449bd223e,
    SERVER_YELLOW: $8e4230f608d6b965$export$9a33b5e3cde94885,
    SERVER_DARK_YELLOW: $8e4230f608d6b965$export$33253d7862bceb8a,
    SERVER_ORANGE: $8e4230f608d6b965$export$6609c2b23fc42f39,
    SERVER_DARK_ORANGE: $8e4230f608d6b965$export$cd994662b5911917,
    SERVER_GREY: $8e4230f608d6b965$export$1793d43e13e078c5,
    SERVER_DARK_GREY: $8e4230f608d6b965$export$487a6e9145526564
};
const $8e4230f608d6b965$export$f476e6e43e0101e7 = {
    GHX_LABEL_1: $8e4230f608d6b965$export$e4bdf2d4c4bbb15e,
    GHX_LABEL_2: $8e4230f608d6b965$export$8f5c1c5512278dc6,
    GHX_LABEL_3: $8e4230f608d6b965$export$94ac87c81ed074a7,
    GHX_LABEL_4: $8e4230f608d6b965$export$6bc9ab1f489f76f7,
    GHX_LABEL_5: $8e4230f608d6b965$export$610a2c132b6fcf96,
    GHX_LABEL_6: $8e4230f608d6b965$export$8e4997dba71f1c40,
    GHX_LABEL_7: $8e4230f608d6b965$export$18a545b4e69b27b4,
    GHX_LABEL_8: $8e4230f608d6b965$export$27fff1a0d295292a,
    GHX_LABEL_9: $8e4230f608d6b965$export$e57aa662a56724e1,
    GHX_LABEL_10: $8e4230f608d6b965$export$4b0d63e2c3be2072,
    GHX_LABEL_11: $8e4230f608d6b965$export$457ecb9560f2bf83,
    GHX_LABEL_12: $8e4230f608d6b965$export$a866db37165a696c,
    GHX_LABEL_13: $8e4230f608d6b965$export$9b18447c1168a1b6,
    GHX_LABEL_14: $8e4230f608d6b965$export$93b9ad4020e271b7
};
const $8e4230f608d6b965$export$4b7407b8700035bd = {
    AGILE_COLOR_1: $8e4230f608d6b965$export$5cd2af17b34de3e3,
    AGILE_COLOR_2: $8e4230f608d6b965$export$987671fa69482a7b,
    AGILE_COLOR_3: $8e4230f608d6b965$export$70ba8a5b1f4c7446,
    AGILE_COLOR_4: $8e4230f608d6b965$export$fcd1c42d8d3ebd36,
    AGILE_COLOR_5: $8e4230f608d6b965$export$f80a5bd2fa0ba256,
    AGILE_COLOR_6: $8e4230f608d6b965$export$37ad5ce8d2aeaf78,
    AGILE_COLOR_7: $8e4230f608d6b965$export$9dc62d5d151cb355,
    AGILE_COLOR_8: $8e4230f608d6b965$export$1ed15b30f5663f92,
    AGILE_COLOR_9: $8e4230f608d6b965$export$5d23a84d55ac1644,
    AGILE_COLOR_10: $8e4230f608d6b965$export$bf08c9a6ed42e349,
    AGILE_COLOR_11: $8e4230f608d6b965$export$66c5d8f0b5ff279c,
    AGILE_COLOR_12: $8e4230f608d6b965$export$da30755a37c3a597,
    AGILE_COLOR_13: $8e4230f608d6b965$export$721cf84faff6bf19,
    AGILE_COLOR_14: $8e4230f608d6b965$export$4b8f8666bd7b61dd
};

});

parcelRegister("9qXMi", function(module, exports) {

$parcel$export(module.exports, "getHideEpics", () => $6ae7dcaa40b8804a$export$344e252cb642fb56);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $6ae7dcaa40b8804a$var$HIDE_EPICS_KEY_PREFIX = 'gh.epicShownOnRapidBoard.';
const $6ae7dcaa40b8804a$var$storageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
function $6ae7dcaa40b8804a$export$344e252cb642fb56(boardId) {
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) return $6ae7dcaa40b8804a$var$storageProvider.get(`${$6ae7dcaa40b8804a$var$HIDE_EPICS_KEY_PREFIX}${boardId}`) === 'false';
    return localStorage.getItem(`${$6ae7dcaa40b8804a$var$HIDE_EPICS_KEY_PREFIX}${boardId}`) === 'false';
}
function $6ae7dcaa40b8804a$export$c9ac14c6e06788a3(boardId, hideEpics) {
    if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) $6ae7dcaa40b8804a$var$storageProvider.set(`${$6ae7dcaa40b8804a$var$HIDE_EPICS_KEY_PREFIX}${boardId}`, (!hideEpics).toString());
    else localStorage.setItem(`${$6ae7dcaa40b8804a$var$HIDE_EPICS_KEY_PREFIX}${boardId}`, (!hideEpics).toString());
}

});

parcelRegister("8qfoo", function(module, exports) {

$parcel$export(module.exports, "transformIssue", () => $1eb32a05a39b2409$export$2d1bde06ef9e2dcc);



var $9vSWT = parcelRequire("9vSWT");
const $1eb32a05a39b2409$var$ExtraFieldLabelDefaultEmptyValue = 'None';
function $1eb32a05a39b2409$export$e6e327a97512715e(issue, epicsByKey) {
    if (issue.epic) {
        const epicId = epicsByKey[issue.epic.key]?.id ?? null;
        return epicId === issue.id ? null : epicId;
    }
    return issue.subTaskParentId ?? null;
}
function $1eb32a05a39b2409$export$2d1bde06ef9e2dcc({ issue: issue, estimation: estimation, column: column, epicsByKey: epicsByKey, issueTypesById: issueTypesById, prioritiesById: prioritiesById, sprints: sprints }) {
    const labels = [
        ...issue.labels ?? []
    ];
    if (labels.length === 0) {
        const labelsExtraField = issue.fieldEntries?.find((field)=>field.id === (0, $7e733a5d4e4331fc$export$b1cb468c302d21f9));
        if (labelsExtraField && labelsExtraField.renderer === 'text') {
            const fieldLabels = labelsExtraField.text?.split(/,\s*/g) ?? [];
            // If there is exactly one label and it is 'None' we ignore it.
            // This could be a problem if the Customer actually sets None but
            // right now the default value returned via the mobile endpoint is 'None'
            // if it should be empty..
            if (fieldLabels.length > 1 || fieldLabels[0] !== $1eb32a05a39b2409$var$ExtraFieldLabelDefaultEmptyValue) fieldLabels.forEach((label)=>{
                labels.push(label);
            });
        }
    }
    const sprintId = sprints?.find((sprint)=>issue.sprintIds.includes(sprint.id))?.id;
    // All estimate types in CMP considered as CUSTOM_ESTIMATE_FIELD
    const estimate = estimation != null && 'field' in estimation ? {
        type: (0, $b383ed62f6689e0b$export$feb32b877d96492),
        displayName: issue.trackingStatistic ? (0, $9vSWT.messages).remainingTimeEstimate : estimation.field.displayName,
        fieldId: issue.trackingStatistic?.statFieldId ?? estimation.field.fieldId,
        value: issue.trackingStatistic?.statFieldValue.text ?? issue.estimation
    } : null;
    const daysInColumnSourceMillis = (issue.cumulativeTimeInColumnMillis ?? 0) + (issue.currentTimeInColumnMillis ?? 0);
    const dueDate = issue.dueDate ?? null;
    return {
        id: issue.id,
        key: issue.key,
        summary: issue.summary,
        statusId: Number(issue.statusId),
        requestTypeId: issue.requestTypeId,
        columnId: column.id,
        projectId: Number(issue.projectId),
        parentId: $1eb32a05a39b2409$export$e6e327a97512715e(issue, epicsByKey),
        typeId: Number(issue.issueTypeId),
        typeName: issueTypesById[issue.issueTypeId].name,
        typeUrl: issueTypesById[issue.issueTypeId].iconUrl,
        assigneeAccountId: issue.assigneeAccountId,
        isFlagged: issue.flagged,
        priority: issue.priorityId ? {
            name: prioritiesById[issue.priorityId]?.name,
            iconUrl: prioritiesById[issue.priorityId]?.iconUrl
        } : null,
        daysInColumn: daysInColumnSourceMillis != null ? daysInColumnSourceMillis / 86400000 : null,
        extraFields: issue.fieldEntries,
        cardColor: issue.cardColor,
        labels: labels,
        estimate: estimate,
        isDone: issue.isResolved ?? false,
        sprintId: sprintId != null ? String(sprintId) : 'none',
        dueDate: dueDate,
        // TODO: Missing children stats
        numCompleteChildren: 0,
        numTotalChildren: 0,
        // These are not a problem to be missing
        swimlaneId: undefined,
        devStatus: undefined,
        fixVersions: issue.fixVersions,
        isVisible: issue.isVisible ?? true
    };
}

});
parcelRegister("9vSWT", function(module, exports) {

$parcel$export(module.exports, "messages", () => $ff1e0f2420a6273f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $ff1e0f2420a6273f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    remainingTimeEstimate: {
        "id": "software.main.services.board-scope-graphql.non-critical.mobile-rest.transformer.issue.remaining-time-estimate",
        "defaultMessage": "{value} Remaining Time Estimate"
    }
});

});





parcelRegister("6c7Tw", function(module, exports) {

$parcel$export(module.exports, "getCustomFiltersDebounceTime", () => $eca1f60956407533$export$2ecac126a7851701);
const $eca1f60956407533$export$2ecac126a7851701 = ()=>500;

});


parcelRegister("20mkj", function(module, exports) {

$parcel$export(module.exports, "refilterRequestEpic", () => $1e902e1d2484cde0$export$12fb76cfeb5c0ed2);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("8n054");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("1oQta");
parcelRequire("6cbqE");

var $k8IPx = parcelRequire("k8IPx");

var $1sXeC = parcelRequire("1sXeC");

var $kVLXA = parcelRequire("kVLXA");

var $icZql = parcelRequire("icZql");

var $7aklh = parcelRequire("7aklh");

var $2YZCu = parcelRequire("2YZCu");

var $cnhn5 = parcelRequire("cnhn5");

var $8KZbe = parcelRequire("8KZbe");

var $hdmw1 = parcelRequire("hdmw1");

var $cY26q = parcelRequire("cY26q");

var $bkCF5 = parcelRequire("bkCF5");

var $d315K = parcelRequire("d315K");

var $8yiLS = parcelRequire("8yiLS");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $6c7Tw = parcelRequire("6c7Tw");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $1e902e1d2484cde0$var$isActiveTab = ()=>!document.hidden;
const $1e902e1d2484cde0$var$isCurrentUser = (state, action)=>(0, $67Z81.currentUserAccountIdSelector)(state) === action.payload.event.payload.atlassianId;
// The realtime provider returns board scope issue events as well as the issue
// created and updated events when the FF is enabled. The BSI updated event
// will be used for refreshing the board but the issue create/updated events
// are here ONLY for custom filter support
const $1e902e1d2484cde0$var$isIssueEvent = (action)=>action.payload.event.type === (0, $cnhn5.ISSUE_CREATED_EVENT) || action.payload.event.type === (0, $cnhn5.ISSUE_UPDATED_EVENT);
const $1e902e1d2484cde0$export$12fb76cfeb5c0ed2 = (action$, store)=>{
    const refilterAction$ = action$.ofType((0, $d315K.REALTIME_DISPATCH_EVENT)).filter($1e902e1d2484cde0$var$isActiveTab).filter($1e902e1d2484cde0$var$isIssueEvent).filter(()=>(0, $8yiLS.isCustomFiltersActive)(store.getState()) || (0, $5mTgl.isJqlFilterActive)(store.getState())).filter((action)=>$1e902e1d2484cde0$var$isCurrentUser(store.getState(), action));
    let debouncedActions = [];
    const newRefilterAction$ = refilterAction$.pipe((0, $icZql.buffer)(refilterAction$.pipe((0, $7aklh.debounce)((valueRaw)=>{
        // Saving debounced actions to be check if create flag should be shown
        debouncedActions.push(valueRaw);
        return (0, $kVLXA.Observable).timer((0, $6c7Tw.getCustomFiltersDebounceTime)());
    }))));
    return newRefilterAction$.switchMap((actions)=>{
        const state = store.getState();
        const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
        const jql = (0, $5mTgl.isFilterRefinementEnabled)(state) ? (0, $5mTgl.getJqlFilter)(state) ?? null : null;
        const isCreatedIssue = (cardId)=>debouncedActions.some((action)=>'issueId' in action.payload.event.payload && action.payload.event.payload.issueId === cardId && action.payload.event.type === (0, $cnhn5.ISSUE_CREATED_EVENT));
        const issueIds = [
            // remove duplicates via Set
            ...new Set(actions.map((action)=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const payload = action.payload.event.payload;
                return payload.issueId;
            }))
        ];
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        return (0, $8KZbe.fetchFilteredCardIds)(ctx, {
            issueIds: issueIds,
            customFilterIds: customFilterIds,
            jql: jql
        }).mergeMap(({ cardIds: cardIds })=>{
            const filteredCardIds = cardIds?.map((cardId)=>(0, (/*@__PURE__*/$parcel$interopDefault($1sXeC)))(cardId)); // convert str to num/IssueKey
            const excludedCardIds = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(issueIds, filteredCardIds); // diff them against the query response
            const invisibleIssueIdsSelector = (0, $5mTgl.getInvisibleIssueIdsFromClientSideFiltersOnly);
            const invisibleCardIds = [
                ...invisibleIssueIdsSelector(state)(filteredCardIds),
                ...excludedCardIds
            ];
            if (invisibleCardIds.length) {
                // we only want to show the flag for created issues
                const invisibleCreatedCardIds = invisibleCardIds.filter(isCreatedIssue);
                const invisibleCreatedCardKeys = (0, $d2i8f.getIssueKeysFromIssueIds)(state)(invisibleCreatedCardIds);
                // if we were unable to get card keys, the issue isn't present on the board at all.
                // as such, we don't want to show the flag here, as we'll already be showing a flag prior to this (due to unmapped status or not in a current sprint).
                if (invisibleCreatedCardKeys.length) {
                    debouncedActions = [];
                    return [
                        (0, $bkCF5.issueCreateFilteredV2)(invisibleCreatedCardKeys),
                        (0, $cY26q.refilterSuccess)(excludedCardIds.map((cardId)=>cardId.toString()), cardIds)
                    ];
                }
            }
            debouncedActions = [];
            return [
                (0, $cY26q.refilterSuccess)(excludedCardIds.map((cardId)=>cardId.toString()), cardIds)
            ];
        }).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board.filtered-cards.refilter.failure', 'Fail to re-filter cards with custom filters', error);
            debouncedActions = [];
            return (0, $kVLXA.Observable).of((0, $cY26q.refilterFailure)(error));
        });
    });
};

});
parcelRegister("cnhn5", function(module, exports) {

$parcel$export(module.exports, "ISSUE_ASSIGNED_EVENT", () => $09d938f04e8899c4$export$86d416e8d15777d);
$parcel$export(module.exports, "ISSUE_CREATED_EVENT", () => $09d938f04e8899c4$export$b22a14d5dac59664);
$parcel$export(module.exports, "ISSUE_DELETED_EVENT", () => $09d938f04e8899c4$export$25fa37e5059c5a99);
$parcel$export(module.exports, "ISSUE_TRANSITIONED_EVENT", () => $09d938f04e8899c4$export$d9bc8850eeef9f60);
$parcel$export(module.exports, "ISSUE_UPDATED_EVENT", () => $09d938f04e8899c4$export$b22142e61b3fdbee);
$parcel$export(module.exports, "ISSUE_COMMENTED_EVENT", () => $09d938f04e8899c4$export$773466d9acc404c0);
$parcel$export(module.exports, "ISSUE_PARENT_ASSOCIATION_EVENT", () => $09d938f04e8899c4$export$6b7e46ea0442b66c);
$parcel$export(module.exports, "BOARD_SCOPE_ISSUES_UPDATED", () => $09d938f04e8899c4$export$6024bd0c20931af3);
$parcel$export(module.exports, "SUBSCRIPTION_SUPPORTED_EVENTS", () => $09d938f04e8899c4$export$5a28ff49c25ece6e);
$parcel$export(module.exports, "BOARD_SUPPORTED_EVENTS", () => $09d938f04e8899c4$export$47ea50c123247eb0);
const $09d938f04e8899c4$export$86d416e8d15777d = 'avi:jira:assigned:issue';
const $09d938f04e8899c4$export$b22a14d5dac59664 = 'avi:jira:created:issue';
const $09d938f04e8899c4$export$25fa37e5059c5a99 = 'avi:jira:deleted:issue';
const $09d938f04e8899c4$export$d9bc8850eeef9f60 = 'avi:jira:transitioned:issue';
const $09d938f04e8899c4$export$b22142e61b3fdbee = 'avi:jira:updated:issue';
const $09d938f04e8899c4$export$773466d9acc404c0 = 'avi:jira:commented:issue';
const $09d938f04e8899c4$export$72f85a03fb1edcaf = 'avi:jira:mentioned:issue';
const $09d938f04e8899c4$export$6b7e46ea0442b66c = 'avi:jira:updated:issue_parent_association';
const $09d938f04e8899c4$export$6024bd0c20931af3 = 'avi:jira-software:update:board-scope-issues';
const $09d938f04e8899c4$export$5a28ff49c25ece6e = new Set([
    $09d938f04e8899c4$export$b22a14d5dac59664,
    $09d938f04e8899c4$export$25fa37e5059c5a99,
    $09d938f04e8899c4$export$b22142e61b3fdbee,
    $09d938f04e8899c4$export$773466d9acc404c0,
    $09d938f04e8899c4$export$72f85a03fb1edcaf,
    $09d938f04e8899c4$export$6b7e46ea0442b66c
]);
const $09d938f04e8899c4$export$47ea50c123247eb0 = new Set([
    $09d938f04e8899c4$export$6024bd0c20931af3
]);

});

parcelRegister("d315K", function(module, exports) {

$parcel$export(module.exports, "REALTIME_DISPATCH_EVENT", () => $c0dbbae35befe3e5$export$b5816ca887d8baac);
$parcel$export(module.exports, "dispatchRealtimeEvent", () => $c0dbbae35befe3e5$export$e0f58b7bfd5c1657);
const $c0dbbae35befe3e5$export$b5816ca887d8baac = 'state.actions.realtime.REALTIME_DISPATCH_EVENT';
const $c0dbbae35befe3e5$export$e0f58b7bfd5c1657 = (event)=>({
        type: $c0dbbae35befe3e5$export$b5816ca887d8baac,
        payload: {
            event: event
        }
    });

});

parcelRegister("8yiLS", function(module, exports) {

$parcel$export(module.exports, "getActiveCustomFilterIds", () => $0bf8cdb422c26644$export$82bff6cad9152357);
$parcel$export(module.exports, "isCustomFiltersActive", () => $0bf8cdb422c26644$export$42709fe30c51b78a);
const $0bf8cdb422c26644$export$82bff6cad9152357 = (state)=>state.ui.workFilters?.values.CUSTOM_FILTER ?? [];
const $0bf8cdb422c26644$export$42709fe30c51b78a = (state)=>$0bf8cdb422c26644$export$82bff6cad9152357(state).length > 0;

});



parcelRegister("9C8b7", function(module, exports) {

$parcel$export(module.exports, "initiateIccInUnscheduledColumnEpic", () => $ebc7e90c724eb587$export$c8b97467c24e77a0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fPS7b");
parcelRequire("jFVZ1");
parcelRequire("fp4O3");
parcelRequire("eV0gs");

var $bdYfL = parcelRequire("bdYfL");

var $d1i1b = parcelRequire("d1i1b");

var $2f454 = parcelRequire("2f454");

var $k50Aq = parcelRequire("k50Aq");
function $ebc7e90c724eb587$export$c8b97467c24e77a0(action$) {
    return action$.ofType((0, $2f454.INITIATE_ICC_IN_UNSCHEDULED_COLUMN)).mergeMap((action)=>{
        const { swimlaneId: swimlaneId, shouldToggleSwimlane: shouldToggleSwimlane } = action.payload;
        const truncatedSwimlaneId = (0, $bdYfL.truncateUnscheduledWorkSwimlaneId)(swimlaneId, true);
        if (shouldToggleSwimlane) return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $k50Aq.swimlaneToggle)(swimlaneId)), // Delay autoscroll after swimlane toggle so it scrolls to the right position
        (0, $kVLXA.Observable).of((0, $d1i1b.cardAutoScrollUnscheduledColumnIcc)(truncatedSwimlaneId, true)).delay(100), (0, $kVLXA.Observable).of((0, $2f454.openIccInUnscheduledColumn)(truncatedSwimlaneId)));
        // isImmediate true works better when swimlane is expanded
        return (0, $kVLXA.Observable).concat((0, $kVLXA.Observable).of((0, $d1i1b.cardAutoScrollUnscheduledColumnIcc)(truncatedSwimlaneId, true)), (0, $kVLXA.Observable).of((0, $2f454.openIccInUnscheduledColumn)(truncatedSwimlaneId)));
    });
}

});

parcelRegister("iH73B", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksPermissionsEpic", () => $0bc4c8208171d954$export$619d310548798f07);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $jcw0u = parcelRequire("jcw0u");

var $fZneA = parcelRequire("fZneA");

var $bi02m = parcelRequire("bi02m");

var $cwdC8 = parcelRequire("cwdC8");

var $67Z81 = parcelRequire("67Z81");
const $0bc4c8208171d954$export$619d310548798f07 = (action$, store)=>{
    const state = store.getState();
    const boardId = (0, $67Z81.rapidViewIdSelector)(state);
    const cloudId = (0, $67Z81.cloudIdSelector)(state);
    const isCMP = (0, $67Z81.getIsCMPBoard)(state);
    const isJSWBoard = (0, $67Z81.getIsJSWBoard)(state);
    const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    return action$.ofType((0, $cwdC8.FETCH_ISSUE_LINKS_PERMISSIONS)).switchMap(()=>{
        if (!isJSWBoard || isIPBoard) return (0, $kVLXA.Observable).of();
        return (0, $bi02m.fetchIssueLinksPermissionsService)({
            boardId: boardId,
            cloudId: cloudId,
            isCMP: isCMP
        }).mergeMap((linkedIssuesPermissionsResponse)=>(0, $kVLXA.Observable).of((0, $cwdC8.setIssueLinksPermissions)(linkedIssuesPermissionsResponse))).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'board.issueLinksPermissions.load.failure',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'a4t-tanuki'
                }
            });
            return (0, $kVLXA.Observable).of();
        });
    });
};

});
parcelRegister("bi02m", function(module, exports) {

$parcel$export(module.exports, "fetchIssueLinksPermissionsService", () => $21d8f391cc013f03$export$ef2dbb65561dba4e);

var $bWs5d = parcelRequire("bWs5d");
const $21d8f391cc013f03$export$ef2dbb65561dba4e = (props)=>(0, $bWs5d.getIssueLinksPermissions)(props);

});
parcelRegister("bWs5d", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksPermissions", () => $45f38b82b152c349$export$7b960698e444da91);

var $3fgrt = parcelRequire("3fgrt");

var $8Uumt = parcelRequire("8Uumt");

var $kVLXA = parcelRequire("kVLXA");

var $dXq4S = parcelRequire("dXq4S");

var $5yJb9 = parcelRequire("5yJb9");

const $45f38b82b152c349$export$42ba6d3bd814bf95 = (0, $3fgrt.default);
const $45f38b82b152c349$export$7b960698e444da91 = ({ boardId: boardId, cloudId: cloudId, isCMP: isCMP })=>{
    const boardIdAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    return (0, $kVLXA.Observable).fromPromise((0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), $45f38b82b152c349$export$42ba6d3bd814bf95, {
        boardIdAri: boardIdAri,
        cloudId: cloudId,
        isCMP: isCMP
    }).toPromise().then((data)=>{
        const permissionsArray = data?.boardScope?.currentUser?.permissions || [];
        const issueLinkTypes = data?.jira?.issueLinkTypes?.edges?.length ? data?.jira?.issueLinkTypes?.edges : [];
        return {
            canUserLinkIssue: permissionsArray.includes((0, $68cf6bf1ce76db03$export$f6220122141a5652)),
            issueLinkTypes: issueLinkTypes
        };
    }));
};

});
parcelRegister("3fgrt", function(module, exports) {

$parcel$export(module.exports, "default", () => $70386253e62a237d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f26e8c3b24c528914919a2150996cd25>>
 * @relayHash f48f330c176a0bc6c4d76bc83cbee746
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ac4dc58065040cf5a8f44c73a0e311e3ddca81d9d89c27266d24353f848557fe
const $70386253e62a237d$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardIdAri"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isCMP"
    }, v3 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "inwards"
    }, v6 = {
        "kind": "ScalarField",
        "name": "outwards"
    }, v7 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardIdAri"
        },
        {
            "kind": "Variable",
            "name": "isCMP",
            "variableName": "isCMP"
        }
    ], v8 = {
        "concreteType": "CurrentUser",
        "kind": "LinkedField",
        "name": "currentUser",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "permissions"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v5 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.inwards"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v6 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.outwards"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ 
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v3 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v7 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v8 /*: any*/ ,
                        v4 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ac4dc58065040cf5a8f44c73a0e311e3ddca81d9d89c27266d24353f848557fe",
            "metadata": {},
            "name": "issueLinksPermissionsData_PermissionsAndIssueLinkTypesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$70386253e62a237d$var$node.hash = "2b9e58e9f316f1a984e9838714d0ff74";
var $70386253e62a237d$export$2e2bcd8739ae039 = $70386253e62a237d$var$node;

});



parcelRegister("cwdC8", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_LINKS_PERMISSIONS", () => $50c479909b968228$export$60091d1f159f3cbc);
$parcel$export(module.exports, "fetchIssueLinksPermissions", () => $50c479909b968228$export$171a8ea28f7c89ec);
$parcel$export(module.exports, "SET_ISSUE_LINKS_PERMISSIONS", () => $50c479909b968228$export$c222f1203afb49dd);
$parcel$export(module.exports, "setIssueLinksPermissions", () => $50c479909b968228$export$93bcf6e82d828eae);
const $50c479909b968228$export$60091d1f159f3cbc = 'state.actions.issue-links-stats.FETCH_ISSUE_LINKS_PERMISSIONS';
const $50c479909b968228$export$171a8ea28f7c89ec = ()=>({
        type: $50c479909b968228$export$60091d1f159f3cbc
    });
const $50c479909b968228$export$c222f1203afb49dd = 'state.actions.issue-links-stats.SET_ISSUE_LINKS_PERMISSIONS';
const $50c479909b968228$export$93bcf6e82d828eae = (payload)=>({
        type: $50c479909b968228$export$c222f1203afb49dd,
        payload: payload
    });

});


parcelRegister("2u4LO", function(module, exports) {

$parcel$export(module.exports, "getIsIssueLinksStatsLoadingEpic", () => $89a3340f3b3d1aba$export$61c63a85112220c0);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $4RVsR = parcelRequire("4RVsR");
const $89a3340f3b3d1aba$export$61c63a85112220c0 = (action$)=>action$.ofType((0, $4RVsR.FETCH_ISSUE_LINKS_STATS)).switchMap((action)=>{
        const payloadIssueIds = action.type === (0, $4RVsR.FETCH_ISSUE_LINKS_STATS) && action.payload;
        if (payloadIssueIds) return (0, $kVLXA.Observable).of((0, $4RVsR.setIssueLinksStatsLoading)(payloadIssueIds));
        return (0, $kVLXA.Observable).of();
    });

});
parcelRegister("4RVsR", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_LINKS_STATS", () => $06296a4e0819b2a8$export$c78aaa122aa7a55a);
$parcel$export(module.exports, "fetchIssueLinksStats", () => $06296a4e0819b2a8$export$2be3f0ee613bdf6);
$parcel$export(module.exports, "SET_ISSUE_LINKS_STATS", () => $06296a4e0819b2a8$export$9f3b5a75c7d30595);
$parcel$export(module.exports, "setIssueLinksStats", () => $06296a4e0819b2a8$export$3da474195d54a10a);
$parcel$export(module.exports, "SET_ISSUE_LINKS_STATS_LOADING", () => $06296a4e0819b2a8$export$ba81d05052f97ec0);
$parcel$export(module.exports, "setIssueLinksStatsLoading", () => $06296a4e0819b2a8$export$78440f18a9d54204);
const $06296a4e0819b2a8$export$c78aaa122aa7a55a = 'state.actions.issue-links-stats.FETCH_ISSUE_LINKS_STATS';
const $06296a4e0819b2a8$export$2be3f0ee613bdf6 = (payload, meta)=>({
        type: $06296a4e0819b2a8$export$c78aaa122aa7a55a,
        payload: payload,
        meta: meta
    });
const $06296a4e0819b2a8$export$9f3b5a75c7d30595 = 'state.actions.issue-links-stats.SET_ISSUE_LINKS_STATS';
const $06296a4e0819b2a8$export$3da474195d54a10a = (payload)=>({
        type: $06296a4e0819b2a8$export$9f3b5a75c7d30595,
        payload: payload
    });
const $06296a4e0819b2a8$export$ba81d05052f97ec0 = 'state.actions.issue-links-stats.SET_ISSUE_LINKS_STATS_LOADING';
const $06296a4e0819b2a8$export$78440f18a9d54204 = (payload)=>({
        type: $06296a4e0819b2a8$export$ba81d05052f97ec0,
        payload: payload
    });

});


parcelRegister("14ODQ", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksStatsEpic", () => $f05fd26440934fad$export$28dfbb4ad1451837);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $a4XJc = parcelRequire("a4XJc");

var $8zmNw = parcelRequire("8zmNw");

var $b7xIp = parcelRequire("b7xIp");

var $4RVsR = parcelRequire("4RVsR");

var $cW3pH = parcelRequire("cW3pH");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");
const $f05fd26440934fad$export$28dfbb4ad1451837 = (action$, store)=>action$.ofType((0, $4RVsR.FETCH_ISSUE_LINKS_STATS), (0, $cW3pH.WORK_DATA_SET)).switchMap((action)=>{
        const state = store.getState();
        const isJSWBoard = (0, $67Z81.getIsJSWBoard)(state);
        const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const showIssueLinksStatsViewSettings = (0, $8zmNw.getViewSettings)({
            boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
            view: (0, $a4XJc.View).BOARD
        })?.showIssueLinksStats;
        if (!isJSWBoard || isIPBoard || !showIssueLinksStatsViewSettings) return (0, $kVLXA.Observable).of();
        const payloadIssueIds = action.type === (0, $4RVsR.FETCH_ISSUE_LINKS_STATS) && action.payload;
        const analyticsEvent = action.type === (0, $4RVsR.FETCH_ISSUE_LINKS_STATS) && action.meta?.analyticsEvent;
        const issueIds = payloadIssueIds || (0, $vAfHD.boardOrderedIssueIdsSelector)(state);
        if (!issueIds.length) return (0, $kVLXA.Observable).of();
        return (0, $b7xIp.fetchIssueLinksStatsService)(issueIds).mergeMap((linkedIssuesStatsResponse)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
                task: 'issueLinksStatsFetch'
            });
            return (0, $kVLXA.Observable).of((0, $4RVsR.setIssueLinksStats)(linkedIssuesStatsResponse));
        }).catch((error)=>{
            if (!(0, $fZneA.isClientFetchError)(error)) analyticsEvent && (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'issueLinksStatsFetch',
                isClientFetchError: false
            });
            return (0, $kVLXA.Observable).of();
        });
    });

});
parcelRegister("a4XJc", function(module, exports) {

$parcel$export(module.exports, "View", () => $3338322e4425e825$export$27a5bd065ad55220);
$parcel$export(module.exports, "KeyboardShortcut", () => $3338322e4425e825$export$47a1bf8d9994c680);
$parcel$export(module.exports, "ExpandableState", () => $3338322e4425e825$export$d0f8c009a99b9c1b);
$parcel$export(module.exports, "ViewLocation", () => $3338322e4425e825$export$7ee1cf745baadfcd);
$parcel$export(module.exports, "ViewAs", () => $3338322e4425e825$export$70549c4aef7e1632);
$parcel$export(module.exports, "QUICK_FILTERS", () => $3338322e4425e825$export$59191afd909777e0);
$parcel$export(module.exports, "COMPACT_MODE", () => $3338322e4425e825$export$abd09d2531440e47);
$parcel$export(module.exports, "SHOW_EPICS", () => $3338322e4425e825$export$f3d7917d25ca2d13);
$parcel$export(module.exports, "SHOW_STATUSES", () => $3338322e4425e825$export$933792f2c41e7c51);
$parcel$export(module.exports, "SHOW_VERSIONS", () => $3338322e4425e825$export$fe0a5eeac8bdee53);
$parcel$export(module.exports, "SHOW_ISSUE_LINKS_STATS", () => $3338322e4425e825$export$889dbf130218e8b3);
$parcel$export(module.exports, "SHOW_ISSUE_KEY", () => $3338322e4425e825$export$f199de710b228934);
$parcel$export(module.exports, "SHOW_ISSUE_TYPE", () => $3338322e4425e825$export$e8f86e49139c6abb);
$parcel$export(module.exports, "SHOW_ESTIMATE", () => $3338322e4425e825$export$e1f60d3e74825af0);
$parcel$export(module.exports, "SHOW_PRIORITY", () => $3338322e4425e825$export$bcfd60da3302536e);
$parcel$export(module.exports, "SHOW_DEVELOPMENT", () => $3338322e4425e825$export$e7b5d3d062c615d5);
$parcel$export(module.exports, "SHOW_ASSIGNEE", () => $3338322e4425e825$export$3c14ba0cd46183b);
$parcel$export(module.exports, "SHOW_DAYS_IN_COLUMN", () => $3338322e4425e825$export$8224ffeed837235e);
$parcel$export(module.exports, "SHOW_DUE_DATE", () => $3338322e4425e825$export$770e28bfe2e0208d);
$parcel$export(module.exports, "SHOW_LABELS", () => $3338322e4425e825$export$63993996bfd99919);
$parcel$export(module.exports, "SHOW_CARD_COVERS", () => $3338322e4425e825$export$b811e8bce70dd7c2);
$parcel$export(module.exports, "SHOW_BOARD_NAME", () => $3338322e4425e825$export$658afd7e43f6b440);
$parcel$export(module.exports, "Panels", () => $3338322e4425e825$export$b94e9de8950563ef);
$parcel$export(module.exports, "IncrementPlanningSettings", () => $3338322e4425e825$export$ad46e765f851721f);
const $3338322e4425e825$export$27a5bd065ad55220 = {
    BACKLOG: 'jsw-backlog',
    BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};
const $3338322e4425e825$export$47a1bf8d9994c680 = {
    ISSUE_PARENT_PANEL_SHORTCUT: 'E',
    VERSION_PANEL_SHORTCUT: 'V'
};
const $3338322e4425e825$export$d0f8c009a99b9c1b = {
    EXPANDED: 'expanded',
    COLLAPSED: 'collapsed'
};
const $3338322e4425e825$export$7ee1cf745baadfcd = {
    SIDEBAR: 'sidebar',
    MODAL: 'modal'
};
const $3338322e4425e825$export$70549c4aef7e1632 = {
    PANEL: 'Panel',
    POPUP: 'Popup'
};
const $3338322e4425e825$export$41073ac826c57195 = 'VERSION_PANEL';
const $3338322e4425e825$export$86bfe5c9d2cf6b7c = 'EPIC_PANEL';
const $3338322e4425e825$export$59191afd909777e0 = 'QUICK_FILTERS';
const $3338322e4425e825$export$abd09d2531440e47 = 'COMPACT_MODE';
const $3338322e4425e825$export$f3d7917d25ca2d13 = 'SHOW_EPICS';
const $3338322e4425e825$export$933792f2c41e7c51 = 'SHOW_STATUSES';
const $3338322e4425e825$export$fe0a5eeac8bdee53 = 'SHOW_VERSIONS';
const $3338322e4425e825$export$889dbf130218e8b3 = 'SHOW_ISSUE_LINKS_STATS';
const $3338322e4425e825$export$c3308fa11d994bc5 = 'SHOW_UNSCHEDULED_COLUMN';
const $3338322e4425e825$export$f199de710b228934 = 'SHOW_ISSUE_KEY';
const $3338322e4425e825$export$e8f86e49139c6abb = 'SHOW_ISSUE_TYPE';
const $3338322e4425e825$export$e1f60d3e74825af0 = 'SHOW_ESTIMATE';
const $3338322e4425e825$export$bcfd60da3302536e = 'SHOW_PRIORITY';
const $3338322e4425e825$export$e7b5d3d062c615d5 = 'SHOW_DEVELOPMENT';
const $3338322e4425e825$export$3c14ba0cd46183b = 'SHOW_ASSIGNEE';
const $3338322e4425e825$export$8224ffeed837235e = 'SHOW_DAYS_IN_COLUMN';
const $3338322e4425e825$export$770e28bfe2e0208d = 'SHOW_DUE_DATE';
const $3338322e4425e825$export$63993996bfd99919 = 'SHOW_LABELS';
const $3338322e4425e825$export$b811e8bce70dd7c2 = 'SHOW_CARD_COVERS';
const $3338322e4425e825$export$ecec86e489253c13 = 'SHOW_OFFTRACK_DEPENDENCY_LINES';
const $3338322e4425e825$export$79b3cada7e291288 = 'ISSUE_IDS_TO_SHOW_DEPENDENCIES';
const $3338322e4425e825$export$658afd7e43f6b440 = 'SHOW_BOARD_NAME';
const $3338322e4425e825$export$b94e9de8950563ef = {
    VERSION_PANEL: $3338322e4425e825$export$41073ac826c57195,
    EPIC_PANEL: $3338322e4425e825$export$86bfe5c9d2cf6b7c
};
const $3338322e4425e825$export$ad46e765f851721f = {
    SHOW_UNSCHEDULED_COLUMN: $3338322e4425e825$export$c3308fa11d994bc5,
    SHOW_OFFTRACK_DEPENDENCY_LINES: $3338322e4425e825$export$ecec86e489253c13,
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: $3338322e4425e825$export$79b3cada7e291288
};

});

parcelRegister("8zmNw", function(module, exports) {

$parcel$export(module.exports, "getViewSettings", () => $a5d579bc47cfed7a$export$3ae70db4a97563c);
$parcel$export(module.exports, "setViewSettingsIsFullscreen", () => $a5d579bc47cfed7a$export$322210075289ef56);
$parcel$export(module.exports, "getViewSettingsIsFullscreen", () => $a5d579bc47cfed7a$export$d2c8042121049ae8);
$parcel$export(module.exports, "getViewSettingsPanels", () => $a5d579bc47cfed7a$export$d6a5a0d616fcec93);
$parcel$export(module.exports, "setViewSettings", () => $a5d579bc47cfed7a$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setViewSettingsPanels", () => $a5d579bc47cfed7a$export$427f126b21640252);
$parcel$export(module.exports, "getViewSettingsQuickFilters", () => $a5d579bc47cfed7a$export$18eb87e1feb49f18);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $a5d579bc47cfed7a$export$60d0caf3b1c59159);
$parcel$export(module.exports, "getViewSettingsCompactMode", () => $a5d579bc47cfed7a$export$658ed39e1ffe75b);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "getViewSettingsCardDetails", () => $a5d579bc47cfed7a$export$a2a95ab43ea98277);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $a5d579bc47cfed7a$export$af2e5a35023755b5);
$parcel$export(module.exports, "getViewSettingsCardExtraFields", () => $a5d579bc47cfed7a$export$6a2173913af81755);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $a5d579bc47cfed7a$export$b54537ba70def946);
$parcel$export(module.exports, "setShowEpics", () => $a5d579bc47cfed7a$export$294c0e262bd1285a);
$parcel$export(module.exports, "setShowVersions", () => $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd);
$parcel$export(module.exports, "setShowStatuses", () => $a5d579bc47cfed7a$export$e95c7c8d7cbf6350);
$parcel$export(module.exports, "setShowIssueLinksStats", () => $a5d579bc47cfed7a$export$163e0dded7eda9d9);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $a5d579bc47cfed7a$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $a5d579bc47cfed7a$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "setShowDaysInColumn", () => $a5d579bc47cfed7a$export$68382c1a767b0133);
$parcel$export(module.exports, "setShowDueDate", () => $a5d579bc47cfed7a$export$13fed6c54275816a);
$parcel$export(module.exports, "setShowLabels", () => $a5d579bc47cfed7a$export$43aa76b69739d220);
$parcel$export(module.exports, "setExtraFields", () => $a5d579bc47cfed7a$export$b24e660e664a6bba);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $a5d579bc47cfed7a$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $a5d579bc47cfed7a$export$32c01395d25dfdcc);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $a5d579bc47cfed7a$export$f7b68cb584e33d77);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $a5d579bc47cfed7a$export$67e6bba1326e537a);

var $bSSG7 = parcelRequire("bSSG7");

var $duOMW = parcelRequire("duOMW");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $a5d579bc47cfed7a$var$browserLocalStorage = (0, $bSSG7.createLocalStorageProvider)((0, $duOMW.VIEW_SETTINGS_LOCAL_STORAGE));
const $a5d579bc47cfed7a$export$36e24695f02d4503 = (view)=>{
    if (view && view === (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).INCREMENT_PLANNING_BOARD}`;
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) switch(view){
        case (0, $a4XJc.View).INCREMENT_PLANNING_BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).INCREMENT_PLANNING_BOARD}`;
        case (0, $a4XJc.View).BACKLOG:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).BACKLOG}`;
        case (0, $a4XJc.View).BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).BOARD}`;
        case (0, $a4XJc.View).JSM_BOARD:
            return `${0, $duOMW.VIEW_SETTINGS}-${(0, $a4XJc.View).JSM_BOARD}`;
        default:
            return 0, $duOMW.VIEW_SETTINGS;
    }
    return 0, $duOMW.VIEW_SETTINGS;
};
const $a5d579bc47cfed7a$export$3ae70db4a97563c = ({ boardId: boardId, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.get(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`) || $a5d579bc47cfed7a$var$browserLocalStorage.get(`${(0, $duOMW.VIEW_SETTINGS)}-${boardId}`); // return legacy view settings if prefixed storage doesn't exist
const $a5d579bc47cfed7a$export$322210075289ef56 = ({ boardId: boardId, isFullscreen: isFullscreen, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        isFullscreen: isFullscreen
    });
};
const $a5d579bc47cfed7a$export$d2c8042121049ae8 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.isFullscreen ?? (0, $duOMW.initialState).isFullscreen;
};
const $a5d579bc47cfed7a$export$d6a5a0d616fcec93 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        EPIC_PANEL: state?.showEpicPanel ?? (0, $duOMW.initialState).showEpicPanel,
        VERSION_PANEL: state?.showVersionPanel ?? (0, $duOMW.initialState).showVersionPanel
    };
};
const $a5d579bc47cfed7a$export$99f2d9eb0b41b93 = ({ boardId: boardId, state: state, view: view })=>$a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, state);
const $a5d579bc47cfed7a$export$427f126b21640252 = ({ boardId: boardId, panelState: panelState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: panelState.EPIC_PANEL,
        showVersionPanel: panelState.VERSION_PANEL
    });
};
const $a5d579bc47cfed7a$export$7a001fa75693814b = ({ boardId: boardId, panel: panel, show: show, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    if (panel === (0, $a4XJc.Panels).EPIC_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpicPanel: show
    });
    if (panel === (0, $a4XJc.Panels).VERSION_PANEL) $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersionPanel: show
    });
};
const $a5d579bc47cfed7a$export$18eb87e1feb49f18 = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showQuickFilters ?? (0, $duOMW.initialState).showQuickFilters;
};
const $a5d579bc47cfed7a$export$60d0caf3b1c59159 = ({ boardId: boardId, showQuickFilters: showQuickFilters, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showQuickFilters: showQuickFilters
    });
};
const $a5d579bc47cfed7a$export$658ed39e1ffe75b = ({ boardId: boardId, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return state?.showCompactMode ?? (0, $duOMW.initialState).showCompactMode;
};
const $a5d579bc47cfed7a$export$9ca6e4490ca9b1fc = ({ boardId: boardId, showCompactMode: showCompactMode, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCompactMode: showCompactMode
    });
};
const $a5d579bc47cfed7a$export$a2a95ab43ea98277 = ({ boardId: boardId, view: view, isDaysInColumnEnabled: isDaysInColumnEnabled, isDueDateEnabled: isDueDateEnabled, isLabelsEnabled: isLabelsEnabled, isEstimateEnabled: isEstimateEnabled, isPriorityEnabled: isPriorityEnabled })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return {
        SHOW_EPICS: state?.showEpics ?? (0, $duOMW.initialState).showEpics,
        SHOW_STATUSES: state?.showStatuses ?? (0, $duOMW.initialState).showStatuses,
        SHOW_VERSIONS: state?.showVersions ?? (0, $duOMW.initialState).showVersions,
        SHOW_ISSUE_LINKS_STATS: state?.showIssueLinksStats ?? (0, $duOMW.initialState).showIssueLinksStats,
        SHOW_ISSUE_KEY: state?.showIssueKey ?? (0, $duOMW.initialState).showIssueKey,
        SHOW_ISSUE_TYPE: state?.showIssueType ?? (0, $duOMW.initialState).showIssueType,
        SHOW_ASSIGNEE: state?.showAssignee ?? (0, $duOMW.initialState).showAssignee,
        SHOW_PRIORITY: (isPriorityEnabled ? state?.showPriority : (0, $duOMW.initialState).showPriority) ?? (0, $duOMW.initialState).showPriority,
        SHOW_DEVELOPMENT: state?.showDevelopment ?? (0, $duOMW.initialState).showDevelopment,
        SHOW_ESTIMATE: (isEstimateEnabled ? state?.showEstimate : (0, $duOMW.initialState).showEstimate) ?? (0, $duOMW.initialState).showEstimate,
        SHOW_DAYS_IN_COLUMN: (isDaysInColumnEnabled ? state?.showDaysInColumn : (0, $duOMW.initialState).showDaysInColumn) ?? (0, $duOMW.initialState).showDaysInColumn,
        SHOW_DUE_DATE: (isDueDateEnabled ? state?.showDueDate : (0, $duOMW.initialState).showDueDate) ?? (0, $duOMW.initialState).showDueDate,
        SHOW_LABELS: (isLabelsEnabled ? state?.showLabels : (0, $duOMW.initialState).showLabels) ?? (0, $duOMW.initialState).showLabels,
        SHOW_CARD_COVERS: state?.showCardCovers ?? (0, $duOMW.initialState).showCardCovers,
        SHOW_BOARD_NAME: state?.showBoardName ?? (0, $duOMW.initialState).showBoardName
    };
};
const $a5d579bc47cfed7a$export$af2e5a35023755b5 = ({ boardId: boardId, cardDetailsState: cardDetailsState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: cardDetailsState.SHOW_EPICS,
        showStatuses: cardDetailsState.SHOW_STATUSES,
        showVersions: cardDetailsState.SHOW_VERSIONS,
        showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
        showEstimate: cardDetailsState.SHOW_ESTIMATE,
        showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
        showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
        showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
        showAssignee: cardDetailsState.SHOW_ASSIGNEE,
        showPriority: cardDetailsState.SHOW_PRIORITY,
        showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
        showDueDate: cardDetailsState.SHOW_DUE_DATE,
        showLabels: cardDetailsState.SHOW_LABELS,
        showCardCovers: cardDetailsState.SHOW_CARD_COVERS,
        showBoardName: cardDetailsState.SHOW_BOARD_NAME
    });
};
const $a5d579bc47cfed7a$export$6a2173913af81755 = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    return cardExtraFields.reduce((acc, field)=>{
        acc[field.id] = state?.cardExtraFields?.[field.id] ?? true;
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
};
const $a5d579bc47cfed7a$export$b54537ba70def946 = ({ boardId: boardId, cardExtraFieldsState: cardExtraFieldsState, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFieldsState
    });
};
const $a5d579bc47cfed7a$export$294c0e262bd1285a = ({ boardId: boardId, showEpics: showEpics, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showEpics: showEpics
    });
};
const $a5d579bc47cfed7a$export$a3ab3e2c6a6189bd = ({ boardId: boardId, showVersions: showVersions, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showVersions: showVersions
    });
};
const $a5d579bc47cfed7a$export$e95c7c8d7cbf6350 = ({ boardId: boardId, showStatuses: showStatuses, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showStatuses: showStatuses
    });
};
const $a5d579bc47cfed7a$export$163e0dded7eda9d9 = ({ boardId: boardId, showIssueLinksStats: showIssueLinksStats, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showIssueLinksStats: showIssueLinksStats
    });
};
const $a5d579bc47cfed7a$export$6edce735c6eb4cb0 = ({ boardId: boardId, showUnscheduledColumn: showUnscheduledColumn })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showUnscheduledColumn: showUnscheduledColumn
    });
};
const $a5d579bc47cfed7a$export$bf31a7b99f7bc62f = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showUnscheduledColumn ?? (0, $duOMW.initialState).showUnscheduledColumn;
};
const $a5d579bc47cfed7a$export$68382c1a767b0133 = ({ boardId: boardId, showDaysInColumn: showDaysInColumn, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDaysInColumn: showDaysInColumn
    });
};
const $a5d579bc47cfed7a$export$13fed6c54275816a = ({ boardId: boardId, showDueDate: showDueDate, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showDueDate: showDueDate
    });
};
const $a5d579bc47cfed7a$export$43aa76b69739d220 = ({ boardId: boardId, showLabels: showLabels, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showLabels: showLabels
    });
};
const $a5d579bc47cfed7a$export$b24e660e664a6bba = ({ boardId: boardId, cardExtraFields: cardExtraFields, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        cardExtraFields: cardExtraFields
    });
};
const $a5d579bc47cfed7a$export$90df0703e41f9b = ({ boardId: boardId, showCardCovers: showCardCovers, view: view })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: view
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503(view)}-${boardId}`, {
        ...state,
        showCardCovers: showCardCovers
    });
};
const $a5d579bc47cfed7a$export$2c48063cd4ef1ade = ({ boardId: boardId, showOfftrackDependencyLines: showOfftrackDependencyLines })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        showOfftrackDependencyLines: showOfftrackDependencyLines
    });
};
const $a5d579bc47cfed7a$export$32c01395d25dfdcc = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.showOfftrackDependencyLines ?? (0, $duOMW.initialState).showOfftrackDependencyLines;
};
const $a5d579bc47cfed7a$export$f7b68cb584e33d77 = ({ boardId: boardId, issueIds: issueIds })=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    $a5d579bc47cfed7a$var$browserLocalStorage.set(`${$a5d579bc47cfed7a$export$36e24695f02d4503((0, $a4XJc.View).INCREMENT_PLANNING_BOARD)}-${boardId}`, {
        ...state,
        issueIdsToShowDependencies: issueIds
    });
};
const $a5d579bc47cfed7a$export$67e6bba1326e537a = (boardId)=>{
    const state = $a5d579bc47cfed7a$export$3ae70db4a97563c({
        boardId: boardId,
        view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD
    });
    return state?.issueIdsToShowDependencies ?? (0, $duOMW.initialState).issueIdsToShowDependencies;
};

});
parcelRegister("duOMW", function(module, exports) {

$parcel$export(module.exports, "VIEW_SETTINGS", () => $6350b42865dc529c$export$f900da9acbf1ac33);
$parcel$export(module.exports, "VIEW_SETTINGS_LOCAL_STORAGE", () => $6350b42865dc529c$export$752f3d44db2fbd2d);
$parcel$export(module.exports, "initialState", () => $6350b42865dc529c$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "boardViewTestIds", () => $6350b42865dc529c$export$9cf6a064d9c55597);
$parcel$export(module.exports, "backlogViewTestIds", () => $6350b42865dc529c$export$af828cca0407ed81);
$parcel$export(module.exports, "VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID", () => $6350b42865dc529c$export$b954e2c30216a1e9);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_LG", () => $6350b42865dc529c$export$20070c180403c06a);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_SM", () => $6350b42865dc529c$export$563c80e8ea5620c4);
$parcel$export(module.exports, "VIEW_SETTINGS_BUTTON_RESPONSIVE", () => $6350b42865dc529c$export$3895498dfef21366);
$parcel$export(module.exports, "QUERY_ENABLED_VALUE", () => $6350b42865dc529c$export$c0d46007b8549aca);
const $6350b42865dc529c$export$f900da9acbf1ac33 = 'view-settings';
const $6350b42865dc529c$export$752f3d44db2fbd2d = 'jira-software-view-settings';
const $6350b42865dc529c$export$d4c72bab9d6cc13a = {
    view: null,
    isFullscreen: false,
    showEpicPanel: false,
    showVersionPanel: false,
    showQuickFilters: false,
    showEpics: true,
    showStatuses: true,
    showVersions: true,
    showCompactMode: false,
    showUnscheduledColumn: true,
    showIssueLinksStats: false,
    showIssueKey: true,
    showIssueType: true,
    showEstimate: true,
    showAssignee: true,
    showPriority: true,
    showDevelopment: true,
    showDaysInColumn: true,
    showDueDate: true,
    showLabels: true,
    showCardCovers: true,
    showOfftrackDependencyLines: true,
    showBoardName: true,
    issueIdsToShowDependencies: [],
    cardExtraFields: {}
};
const $6350b42865dc529c$export$9cf6a064d9c55597 = {
    viewSettingsBoardMenu: 'software-view-settings.ui.view-settings-menu.menu-board',
    openIssuesInSidebarToggle: 'software-view-settings.ui.view-settings-menu.views.board.open-issues-in-sidebar',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-quick-filters-toggle',
    showWorkSuggestionsToggle: 'software-view-settings.ui.view-settings-menu.views.board.work-suggestions-toggle',
    swimlaneExpandAll: 'software-view-settings.ui.view-settings-menu.views.board.expand-all',
    swimlaneCollapseAll: 'software-view-settings.ui.view-settings-menu.views.board.collapse-all',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.board.card-details-board',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-type-toggle-board',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-issue-key-toggle-board',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-epics-toggle-board',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.board.due-date-toggle-board',
    showLabelsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-labels-toggle-board',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-estimate-toggle-board',
    showDaysInColumnToggle: 'software-view-settings.ui.view-settings-menu.views.board.days-in-column-toggle-board',
    showLinkedIssueStatsToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-linked-issue-stats-toggle-board',
    showCardCoversToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-card-covers-toggle-board',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-priority-toggle-board',
    showDevelopmentToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-development-toggle-board',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.board.show-assignee-toggle-board',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.board.custom-fields-board'
};
const $6350b42865dc529c$export$af828cca0407ed81 = {
    showVersionPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-version-panel-toggle',
    showEpicPanelToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epic-panel-toggle',
    showQuickFiltersToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-quick-filters-toggle',
    cardLayoutSection: 'software-view-settings.view-settings-menu.card-layout',
    cardLayoutRadioGroup: 'software-view-settings.ui.view-settings-menu.views.backlog.card-layout',
    showCompactModeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-compact-mode-toggle',
    subtaskSection: 'software-view-settings.view-settings-menu.subtasks',
    subtaskExpandAll: 'software-view-settings.ui.view-settings-menu.views.backlog.expand-all-subtasks',
    subtaskCollapseAll: 'software-view-settings.ui.view-settings-menu.views.backlog.collapse-all-subtasks',
    cardDetailsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.card-details-backlog',
    showIssueTypeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-type-toggle-backlog',
    showIssueKeyToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-issue-key-toggle-backlog',
    showVersionsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-versions-toggle-backlog',
    showEpicsToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-epics-toggle-backlog',
    showDueDateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.due-date-toggle-backlog',
    showStatusToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-statuses-toggle-backlog',
    showEstimateToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-estimate-toggle-backlog',
    showPriorityToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-priority-toggle-backlog',
    showAssigneeToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-assignee-toggle-backlog',
    customFieldsSection: 'software-view-settings.ui.view-settings-menu.views.backlog.custom-fields-backlog',
    showBoardNameToggle: 'software-view-settings.ui.view-settings-menu.views.backlog.show-board-name-toggle-backlog'
};
const $6350b42865dc529c$export$b954e2c30216a1e9 = 'view-settings.ui.panel.header.close-button';
const $6350b42865dc529c$export$20070c180403c06a = 'view-settings-show-button.ui.view-settings-button-large';
const $6350b42865dc529c$export$563c80e8ea5620c4 = 'view-settings-show-button.ui.view-settings-button-small';
const $6350b42865dc529c$export$3895498dfef21366 = 'view-settings-show-button.ui.view-settings-button-responsive';
const $6350b42865dc529c$export$c0d46007b8549aca = 'on';
const $6350b42865dc529c$export$788a94e8107fb947 = 'off';

});

parcelRegister("cYeCp", function(module, exports) {

$parcel$export(module.exports, "parseSearchQuery", () => $e84c24ee8b7a736a$export$6298490de4ddc3eb);
$parcel$export(module.exports, "setPanels", () => $e84c24ee8b7a736a$export$d89c07c704083e54);
$parcel$export(module.exports, "parseSearchQueryForIPBoard", () => $e84c24ee8b7a736a$export$442a6f7c9ee1c18a);
$parcel$export(module.exports, "setIncrementPlanningSettingsQuery", () => $e84c24ee8b7a736a$export$8bc567645273ba46);
$parcel$export(module.exports, "isViewSettingsPanelAndTailoredViewExperimentEnabled", () => $e84c24ee8b7a736a$export$eed360eb853808ee);

var $7uUwQ = parcelRequire("7uUwQ");

var $ebyGx = parcelRequire("ebyGx");

var $4R6GH = parcelRequire("4R6GH");

const $e84c24ee8b7a736a$export$6298490de4ddc3eb = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    return {
        EPIC_PANEL: searchParams[0, $2634c0a33984ecbe$export$ec3c43b997309252] === 'visible',
        VERSION_PANEL: searchParams[0, $2634c0a33984ecbe$export$a86c1a6dde9da34f] === 'visible'
    };
};
const $e84c24ee8b7a736a$export$d89c07c704083e54 = (panels, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $2634c0a33984ecbe$export$ec3c43b997309252));
    search.unset((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f));
    if (panels.EPIC_PANEL) search.set((0, $2634c0a33984ecbe$export$ec3c43b997309252), 'visible');
    if (panels.VERSION_PANEL) search.set((0, $2634c0a33984ecbe$export$a86c1a6dde9da34f), 'visible');
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $e84c24ee8b7a736a$export$442a6f7c9ee1c18a = (search)=>{
    const searchParams = (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(search);
    const issuesQuery = searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09] ? decodeURIComponent(searchParams[0, $2634c0a33984ecbe$export$1692762d83d78f09]) : undefined;
    const issuesSplit = issuesQuery ? issuesQuery.split(',') : [];
    const issueIdsToShowDependencies = [];
    issuesSplit.forEach((issueId)=>{
        const trimmedIssueId = issueId.trim();
        if (trimmedIssueId.length) issueIdsToShowDependencies.push(trimmedIssueId);
    });
    return {
        SHOW_UNSCHEDULED_COLUMN: searchParams[0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5] === 'hidden' ? false : undefined,
        SHOW_OFFTRACK_DEPENDENCY_LINES: searchParams[0, $2634c0a33984ecbe$export$8b0819c4fa234ad] === 'hidden' ? false : undefined,
        ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
    };
};
const $e84c24ee8b7a736a$export$8bc567645273ba46 = (incrementPlanningSettings, location)=>{
    const search = (0, $7uUwQ.chain)({
        ...(0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).parse(location.search)
    });
    search.unset((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5));
    if (!incrementPlanningSettings.SHOW_UNSCHEDULED_COLUMN) search.set((0, $2634c0a33984ecbe$export$bfa26a3d2f080ac5), 'hidden');
    search.unset((0, $2634c0a33984ecbe$export$8b0819c4fa234ad));
    search.unset((0, $2634c0a33984ecbe$export$1692762d83d78f09));
    if (!incrementPlanningSettings.SHOW_OFFTRACK_DEPENDENCY_LINES) search.set((0, $2634c0a33984ecbe$export$8b0819c4fa234ad), 'hidden');
    if (incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES && incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length) search.set((0, $2634c0a33984ecbe$export$1692762d83d78f09), encodeURIComponent(incrementPlanningSettings.ISSUE_IDS_TO_SHOW_DEPENDENCIES.toString()));
    return {
        ...location,
        search: (0, (/*@__PURE__*/$parcel$interopDefault($ebyGx))).stringify(search.value())
    };
};
const $e84c24ee8b7a736a$export$eed360eb853808ee = ()=>(0, $4R6GH.fg)('jira_view_settings_additional_fields');

});
const $2634c0a33984ecbe$export$ec3c43b997309252 = 'epics';
const $2634c0a33984ecbe$export$a86c1a6dde9da34f = 'versions';
const $2634c0a33984ecbe$export$bfa26a3d2f080ac5 = 'unscheduledWork';
const $2634c0a33984ecbe$export$8b0819c4fa234ad = 'showOfftrackDependencyLines';
const $2634c0a33984ecbe$export$1692762d83d78f09 = 'issueIdsToShowDependencies';



parcelRegister("b7xIp", function(module, exports) {

$parcel$export(module.exports, "fetchIssueLinksStatsService", () => $28bc3335888782d5$export$612b8b1593c7e884);

var $3hZs5 = parcelRequire("3hZs5");
const $28bc3335888782d5$export$612b8b1593c7e884 = (issueIds)=>(0, $3hZs5.getIssueLinksStats)(issueIds);

});
parcelRegister("3hZs5", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksStats", () => $b590e08c361b9af7$export$225e8725aa4749ad);
parcelRequire("3q49N");

var $487fd = parcelRequire("487fd");
const $b590e08c361b9af7$var$LINKED_ISSUES_STATS_API_URL = '/rest/api/2/issues/linkedissues/stats?operation=IssueLinksStats';
const $b590e08c361b9af7$export$225e8725aa4749ad = (issueIds)=>(0, $487fd.default)($b590e08c361b9af7$var$LINKED_ISSUES_STATS_API_URL, {
        method: 'POST',
        body: JSON.stringify({
            issueIds: issueIds
        }),
        perf: {
            prefix: 'jsw.board',
            key: 'issueLinksStats.fetch'
        }
    });

});



parcelRegister("a9PrS", function(module, exports) {

$parcel$export(module.exports, "devStatusLoadEpic", () => $27da959b46c87683$export$dcb5545e5709681);
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");
parcelRequire("6cbqE");

var $80afZ = parcelRequire("80afZ");

var $kVLXA = parcelRequire("kVLXA");

var $7Jxgt = parcelRequire("7Jxgt");

var $k12ix = parcelRequire("k12ix");

var $2YZCu = parcelRequire("2YZCu");

var $4G04L = parcelRequire("4G04L");

var $2xFXk = parcelRequire("2xFXk");

var $2gXL1 = parcelRequire("2gXL1");

var $hdmw1 = parcelRequire("hdmw1");

var $hz3OZ = parcelRequire("hz3OZ");

var $9WrsG = parcelRequire("9WrsG");

var $kc6Ry = parcelRequire("kc6Ry");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $27da959b46c87683$export$a0e8f4d548e5896 = (result)=>Object.keys(result).length;
const $27da959b46c87683$export$3ab433d598b5afda = {
    onSuccess: (store, action, result)=>{
        const { concurrentId: concurrentId } = action.payload;
        (0, $4G04L.scheduleAfterRender)(()=>{
            const state = store.getState();
            (0, $hz3OZ.devStatusLoadInteraction)(concurrentId).stop({
                customData: {
                    ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                    numOfIssuesHasDevStatus: $27da959b46c87683$export$a0e8f4d548e5896(result),
                    numOfIssues: (0, $5mTgl.workIssuesSelector)(state).length
                }
            });
        });
    }
};
const $27da959b46c87683$var$handleFailure = (error)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData('board.dev-status.load.failure', 'Dev status failed to load', error);
    return (0, $kVLXA.Observable).of((0, $9WrsG.devStatusLoadFailure)());
};
const $27da959b46c87683$var$handleSuccessNoop = ()=>(0, $kVLXA.Observable).of((0, $9WrsG.devStatusLoadSuccess)({}));
const $27da959b46c87683$var$handleSuccess = (result)=>(0, $kVLXA.Observable).of((0, $9WrsG.devStatusLoadSuccess)(result));
const $27da959b46c87683$export$e2e71e4a11967728 = 100;
const $27da959b46c87683$export$c3864266aa54a212 = (store, action, hooks = $27da959b46c87683$export$3ab433d598b5afda)=>{
    if (hooks.onStart) hooks.onStart(store, action);
    const state = store.getState();
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    const issueIds = (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, $67Z81.getEntities)(state).issues, (issue)=>issue.id);
    const issueChildrenIds = (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, $67Z81.getEntities)(state).issueChildren, (issueChild)=>issueChild.id);
    const issueParentIds = (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))((0, $67Z81.getEntities)(state).issueParents, (issueParent)=>issueParent.id);
    let allIssueIds;
    if (ctx.isCMPBoard) allIssueIds = [
        ...issueIds,
        ...issueChildrenIds,
        ...issueParentIds
    ];
    else allIssueIds = issueIds;
    return (0, $2gXL1.devStatusService)(ctx, {
        issueIds: allIssueIds
    }).flatMap((result)=>{
        if (hooks.onSuccess) hooks.onSuccess(store, action, result);
        return $27da959b46c87683$var$handleSuccess(result);
    }).catch((error)=>{
        if (hooks.onFailure) hooks.onFailure(store, action);
        return $27da959b46c87683$var$handleFailure(error);
    });
};
function $27da959b46c87683$export$dcb5545e5709681(action$, store) {
    return action$.ofType((0, $9WrsG.DEV_STATUS_LOAD)).switchMap(()=>{
        if (!(0, $kc6Ry.getCapability)(store.getState())((0, $2xFXk.Capability).ENABLE_DEVOPS_ON_BOARD)) // No Capability to fetch status
        return $27da959b46c87683$var$handleSuccessNoop();
        const issuesCount = (0, $vAfHD.boardOrderedIssueIdsSelector)(store.getState()).length;
        if (issuesCount === 0) // No cards on the board
        return $27da959b46c87683$var$handleSuccessNoop();
        const concurrentId = (0, $7Jxgt.v4)();
        (0, $hz3OZ.devStatusLoadInteraction)(concurrentId).start();
        return $27da959b46c87683$export$c3864266aa54a212(store, (0, $9WrsG.devStatusLoadRequest)(concurrentId));
    });
}

});
parcelRegister("2gXL1", function(module, exports) {

$parcel$export(module.exports, "devStatusService", () => $ee8352428da9f97c$export$8ad62c14f77d0106);
parcelRequire("d0pqD");

var $4W1hd = parcelRequire("4W1hd");
function $ee8352428da9f97c$export$dbbd4778d05e824e(gqlActivity) {
    switch(gqlActivity){
        case 'PR_OPEN':
            return 'pullrequest';
        case 'PR_MERGED':
            return 'merged';
        case 'PR_DECLINED':
            return 'declined';
        case 'BRANCH_OPEN':
            return 'branch';
        case 'COMMIT':
            return 'commit';
        case 'DEPLOYMENT':
            return 'deployment';
        case 'DESIGN':
            return 'design';
        default:
            return null;
    }
}
function $ee8352428da9f97c$export$e21d47d83e1e84d6(response) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const devStatusMap = {};
    response.agile.board.columns.forEach((column)=>{
        column.cards.forEach((card)=>{
            const activity = card.devStatus && $ee8352428da9f97c$export$dbbd4778d05e824e(card.devStatus.activity);
            // skip when activity is unknown as we would not be able to show it anyway
            if (card.devStatus && activity) {
                const deploymentDetails = card.devStatus.properties?.state && card.devStatus.properties?.environment?.type ? {
                    deploymentDetails: {
                        deploymentState: card.devStatus.properties?.state,
                        deploymentEnvironment: card.devStatus.properties?.environment?.type
                    }
                } : {};
                devStatusMap[String(card.id)] = {
                    activity: activity,
                    count: card.devStatus.count,
                    ...deploymentDetails
                };
            }
        });
    });
    return devStatusMap;
}
function $ee8352428da9f97c$export$73ba76a6408c630a(response) {
    const devStatusMap = {};
    Object.entries(response.devOpsActivityForIssues).forEach(([issueIdStr, activity])=>{
        const issueId = Number(issueIdStr);
        const activityTag = $ee8352428da9f97c$export$dbbd4778d05e824e(activity.devOpsInfoActivityState);
        if (activityTag == null) return;
        const deploymentDetails = activity.properties?.state && activity.properties?.environment?.type ? {
            deploymentDetails: {
                deploymentState: activity.properties.state,
                deploymentEnvironment: activity.properties.environment.type
            }
        } : {};
        devStatusMap[issueId] = {
            count: activity.count,
            activity: activityTag,
            ...deploymentDetails
        };
    });
    return devStatusMap;
}
function $ee8352428da9f97c$export$8ad62c14f77d0106(ctx, { issueIds: issueIds }) {
    if (ctx.isCMPBoard) return (0, $4W1hd.fetchDevStatusFromRest)({
        boardId: ctx.boardId,
        issueIds: issueIds
    }).map((response)=>$ee8352428da9f97c$export$73ba76a6408c630a(response));
    return (0, $4W1hd.fetchDevStatusFromSwag)(ctx.contextPath, ctx.boardId).map((resp)=>$ee8352428da9f97c$export$e21d47d83e1e84d6(resp));
}

});
parcelRegister("4W1hd", function(module, exports) {

$parcel$export(module.exports, "fetchDevStatusFromSwag", () => $db6875dff46fa7c6$export$9406ec190ad97fd2);
$parcel$export(module.exports, "fetchDevStatusFromRest", () => $db6875dff46fa7c6$export$968bc8cd6063e243);

var $487fd = parcelRequire("487fd");

var $cBLvH = parcelRequire("cBLvH");
const $db6875dff46fa7c6$export$5db520940cf00715 = 'SoftwareBoardDevStatus';
const $db6875dff46fa7c6$export$2b91517d6d5b4365 = `
    query ${$db6875dff46fa7c6$export$5db520940cf00715} ($boardId: ID!) {
        agile {
            board(id: $boardId) {
                columns {
                    cards {
                        id
                        devStatus {
                            activity
                            count
                            properties {
                                state
                                environment {
                                    type
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
function $db6875dff46fa7c6$export$9406ec190ad97fd2(baseUrl, boardId) {
    return (0, $cBLvH.query$)(baseUrl, $db6875dff46fa7c6$export$5db520940cf00715, $db6875dff46fa7c6$export$2b91517d6d5b4365, {
        boardId: boardId
    });
}
function $db6875dff46fa7c6$export$968bc8cd6063e243({ boardId: boardId, issueIds: issueIds }) {
    return (0, $487fd.default)('/rest/greenhopper/1.0/xboard/work?operation=DevStatusFromRest', {
        method: 'POST',
        body: JSON.stringify({
            rapidViewId: boardId,
            fields: [
                'issues_dev_info_activity'
            ],
            issueIds: issueIds
        })
    });
}

});


parcelRegister("9WrsG", function(module, exports) {

$parcel$export(module.exports, "DEV_STATUS_LOAD", () => $ff98431a0666bbb9$export$7a3d9aad824c5875);
$parcel$export(module.exports, "devStatusLoad", () => $ff98431a0666bbb9$export$e84ac5e45ad9d43d);
$parcel$export(module.exports, "devStatusLoadRequest", () => $ff98431a0666bbb9$export$c72e6cf4c2c4fb29);
$parcel$export(module.exports, "DEV_STATUS_LOAD_SUCCESS", () => $ff98431a0666bbb9$export$ca1ef0650dff91c);
$parcel$export(module.exports, "devStatusLoadSuccess", () => $ff98431a0666bbb9$export$d5dceae9c7c7bc77);
$parcel$export(module.exports, "devStatusLoadFailure", () => $ff98431a0666bbb9$export$fcc06855ffb9341c);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $ff98431a0666bbb9$export$7a3d9aad824c5875 = 'state.actions.issue.dev-status.DEV_STATUS_LOAD';
const $ff98431a0666bbb9$export$e84ac5e45ad9d43d = (issueIds)=>({
        type: $ff98431a0666bbb9$export$7a3d9aad824c5875,
        payload: issueIds
    });
const $ff98431a0666bbb9$export$ff87d2c500ee1e70 = 'state.actions.issue.dev-status.DEV_STATUS_LOAD_REQUEST';
const $ff98431a0666bbb9$export$c72e6cf4c2c4fb29 = (concurrentId)=>({
        type: $ff98431a0666bbb9$export$ff87d2c500ee1e70,
        payload: {
            concurrentId: concurrentId
        }
    });
const $ff98431a0666bbb9$export$ca1ef0650dff91c = 'state.actions.issue.dev-status.DEV_STATUS_LOAD_SUCCESS';
const $ff98431a0666bbb9$export$d5dceae9c7c7bc77 = (activity)=>({
        type: $ff98431a0666bbb9$export$ca1ef0650dff91c,
        payload: activity
    });
const $ff98431a0666bbb9$export$c79938f4edfaa10d = 'state.actions.issue.dev-status.DEV_STATUS_LOAD_FAILURE';
const $ff98431a0666bbb9$export$fcc06855ffb9341c = ()=>({
        type: $ff98431a0666bbb9$export$c79938f4edfaa10d,
        meta: (0, $sdxnu.warningFlagMeta)({
            id: $ff98431a0666bbb9$export$c79938f4edfaa10d,
            titleMessage: (0, $7AVqz.default).devStatusFetchFailedTitle,
            descriptionMessage: (0, $7AVqz.default).devStatusFetchFailedDescription
        })
    });

});


parcelRegister("2RHGv", function(module, exports) {

$parcel$export(module.exports, "issueBentoUpdateEpic", () => $dce0b88d04659266$export$9df2b0b3d6b0f9c3);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $FTaAj = parcelRequire("FTaAj");


var $6zzBT = parcelRequire("6zzBT");

var $lSEpr = parcelRequire("lSEpr");

var $2ZOF9 = parcelRequire("2ZOF9");

var $2f454 = parcelRequire("2f454");

var $4RVsR = parcelRequire("4RVsR");

var $ls4NM = parcelRequire("ls4NM");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $67Z81 = parcelRequire("67Z81");
const $dce0b88d04659266$var$mapPayloadToActions = (state, action, isCMPBoard)=>{
    const { payload: payload } = action;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_FIELD_UPDATED) return isCMPBoard ? [
        (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c))
    ] : null;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_LINKS_CREATED) {
        const issuesToUpdate = payload.meta?.links?.reduce((acc, curr)=>{
            acc.push(curr.linkedIssueId);
            return acc;
        }, [
            payload.issueId
        ]);
        return [
            (0, $4RVsR.fetchIssueLinksStats)(issuesToUpdate)
        ];
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_LINK_DELETED) {
        const issuesToUpdate = [
            payload.issueId,
            payload.meta.linkedIssueId
        ];
        return [
            (0, $4RVsR.fetchIssueLinksStats)(issuesToUpdate)
        ];
    }
    const missingParents = (0, $67Z81.getMissingParents)(state);
    if (isCMPBoard && missingParents[Number(payload.issueId)]) {
        const mapMissingParentResult = (0, $2ZOF9.mapBentoResponseToMissingParent)(missingParents[Number(payload.issueId)], payload);
        if (!mapMissingParentResult) return null;
        return [
            mapMissingParentResult
        ];
    }
    const issueParents = (0, $bSSdD.getIssueParents)(state);
    if (issueParents[payload.issueId]) {
        const mapResult = (0, $6zzBT.mapBentoResponseToIssueParent)(issueParents[payload.issueId], state, payload, action.meta.transactionId);
        if (!mapResult) return null;
        return [
            mapResult
        ];
    }
    const issue = (0, $67Z81.getIssues)(state)[payload.issueId] || (0, $3UY9S.getIssueChildren)(state)[payload.issueId];
    if (!issue) // if issue does not exist on board, check if its status is changed to status on board and refresh data
    return (0, $lSEpr.checkIssueStatusRemapped)(state, payload) ? [
        (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$443de2b93e4aa6c6))
    ] : null;
    const mapResult = (0, $lSEpr.mapBentoResponseToIssue)(issue, state, payload, action.meta.transactionId);
    if (!mapResult) return null;
    // If the status of the issue is unmapped trigger a flag
    if ((0, $lSEpr.checkIssueStatusUnmapped)(state, payload)) return [
        mapResult,
        (0, $ls4NM.cardCreateUnmapped)([
            issue.key
        ])
    ];
    return [
        mapResult
    ];
};
const $dce0b88d04659266$var$ACTIONS_THAT_DONT_TRIGGER_REFRESH = [
    (0, $2f454.CARD_DATA_SET),
    (0, $cW3pH.WORK_REFRESH_DATA)
];
const $dce0b88d04659266$export$9df2b0b3d6b0f9c3 = (action$, store)=>action$.ofType((0, $evkwq.ISSUE_BENTO_UPDATE)).mergeMap((action)=>{
        const state = store.getState();
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const actions = $dce0b88d04659266$var$mapPayloadToActions(state, action, isCMPBoard);
        if (isCMPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(actions)) // If we get a card data set action it means we have interpretted it properly and handled it
        // internally and do NOT need to fire any APIs
        {
            if (!actions.find(({ type: type })=>$dce0b88d04659266$var$ACTIONS_THAT_DONT_TRIGGER_REFRESH.includes(type))) // Otherwise we refresh everything.....
            // NOTE: Once we have relay we can simplify this OR we could look into extending the
            // existing query used in src/packages/software/board/src/ops/card/card-refresh-epic.tsx
            actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c)));
        }
        return actions ? (0, $kVLXA.Observable).from(actions) : (0, $kVLXA.Observable).empty();
    });

});
parcelRegister("FTaAj", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $0a7f3a2a8450d0c8$export$8db21fc94823e1cc);
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED = 'ISSUE_TYPE_CHANGED';
const $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED = 'ISSUE_RELATIONSHIP_UPDATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED = 'ISSUE_LINKS_CREATED';
const $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED = 'ISSUE_LINK_DELETED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED = 'CHILD_ISSUE_ADDED';
const $0a7f3a2a8450d0c8$var$SUBTASK_ADDED = 'SUBTASK_ADDED';
const $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED = 'ISSUE_CHILDREN_ORDER_CHANGED';
const $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED = 'CHILD_ISSUE_FIELD_UPDATED';
const $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS = 'CREATE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS = 'DELETE_CONFLUENCE_PAGE_LINK_SUCCESS';
const $0a7f3a2a8450d0c8$export$8db21fc94823e1cc = {
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_REQUESTED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGE_FAILED,
    [$0a7f3a2a8450d0c8$var$FIELD_CHANGED]: $0a7f3a2a8450d0c8$var$FIELD_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_TYPE_CHANGED,
    [$0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED]: $0a7f3a2a8450d0c8$var$ISSUE_RELATIONSHIP_UPDATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED]: $0a7f3a2a8450d0c8$var$ISSUE_LINKS_CREATED,
    [$0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED]: $0a7f3a2a8450d0c8$var$ISSUE_LINK_DELETED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_ADDED,
    [$0a7f3a2a8450d0c8$var$SUBTASK_ADDED]: $0a7f3a2a8450d0c8$var$SUBTASK_ADDED,
    [$0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED]: $0a7f3a2a8450d0c8$var$ISSUE_CHILDREN_ORDER_CHANGED,
    [$0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED]: $0a7f3a2a8450d0c8$var$CHILD_ISSUE_FIELD_UPDATED,
    [$0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$CREATE_CONFLUENCE_PAGE_LINK_SUCCESS,
    [$0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS]: $0a7f3a2a8450d0c8$var$DELETE_CONFLUENCE_PAGE_LINK_SUCCESS
};

});

parcelRegister("6zzBT", function(module, exports) {

$parcel$export(module.exports, "mapBentoResponseToIssueParent", () => $3eb64125839942ef$export$71bd8f52850c3034);

var $hGgHi = parcelRequire("hGgHi");

var $gULOk = parcelRequire("gULOk");

var $FTaAj = parcelRequire("FTaAj");



var $3n65g = parcelRequire("3n65g");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");
const $3eb64125839942ef$export$4ec695d64c39a571 = [
    'description',
    'assignee',
    'status',
    'labels',
    'reporter'
];
const $3eb64125839942ef$export$71bd8f52850c3034 = (issueParent, state, payload, transactionId)=>{
    if (!payload.type || !issueParent) return null;
    const { type: type } = payload;
    /* uncomment when https://stash.atlassian.com/projects/JIRACLOUD/repos/jira-frontend/pull-requests/20736 merged */ if (type === (0, $FTaAj.ChangeEventTypes).ISSUE_TYPE_CHANGED /* || type === ChangeEventTypes.ISSUE_COVER_SET */ ) return null;
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED && payload.meta.fieldId === 'summary') return (0, $3n65g.setIssueParentSummary)(Number(payload.issueId), payload.meta.fieldValue);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_FAILED && payload.meta.fieldId === 'summary') return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issueParent.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && payload.meta.fieldId !== 'summary' && !$3eb64125839942ef$export$4ec695d64c39a571.includes(payload.meta.fieldId)) return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issueParent.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED) {
        if (payload.meta.fieldId === 'status' && payload.meta.fieldValue && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(payload.meta.fieldValue.id) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(payload.meta.fieldValue.name) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(payload.meta.fieldValue.statusCategory)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { id: id, name: name, statusCategory: statusCategory } = payload.meta.fieldValue;
            const status = {
                id: id,
                name: name,
                category: (0, $gULOk.statusCategoryForId)(statusCategory.id)
            };
            return (0, $3n65g.setIssueParentStatus)(Number(payload.issueId), status);
        }
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) {
        const meta = {
            issueIds: payload.meta.issueIds.map((id)=>Number(id)),
            rankId: payload.meta.rankId,
            isRankAfter: payload.meta.isRankAfter
        };
        return (0, $71oFY.setIssuesRank)(meta);
    }
    return null;
};

});

parcelRegister("lSEpr", function(module, exports) {

$parcel$export(module.exports, "checkIssueStatusUnmapped", () => $8a82c1f355cb7bb5$export$4db59565c47f54df);
$parcel$export(module.exports, "checkIssueStatusRemapped", () => $8a82c1f355cb7bb5$export$c6b04776cded39e0);
$parcel$export(module.exports, "mapBentoResponseToIssue", () => $8a82c1f355cb7bb5$export$e896a8751ab959a2);

var $5rFbt = parcelRequire("5rFbt");

var $FTaAj = parcelRequire("FTaAj");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");



var $2f454 = parcelRequire("2f454");

var $4gHuj = parcelRequire("4gHuj");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");

var $fyeGd = parcelRequire("fyeGd");

var $4gt6L = parcelRequire("4gt6L");
const $8a82c1f355cb7bb5$export$c6057a4504428e8e = [
    'description',
    'reporter'
];
const $8a82c1f355cb7bb5$export$c8a3dfc27ec07f10 = [
    'reporter'
];
const $8a82c1f355cb7bb5$export$fbd9c46dbe46d35d = [
    'summary',
    'assignee',
    'labels'
];
const $8a82c1f355cb7bb5$export$855877a195ad3aa9 = [
    'assignee'
];
const $8a82c1f355cb7bb5$var$FieldsWithOptimisticCardUpdate = new Set([
    (0, $5fc53.STATUS_TYPE),
    (0, $5fc53.SUMMARY_TYPE)
]);
const $8a82c1f355cb7bb5$var$updateAssignee = (meta, issue)=>{
    if (meta.fieldValue === null) return (0, $2f454.cardDataSet)({
        ...issue,
        assigneeAccountId: null
    }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
    const avatars = (0, $g5X3G.values)(meta.fieldValue.avatarUrls);
    return (0, $2f454.cardDataSet)({
        ...issue,
        assigneeAccountId: meta.fieldValue.accountId
    }, {
        id: meta.fieldValue.accountId,
        displayName: meta.fieldValue.displayName,
        avatarUrl: String(avatars[0])
    }, (0, $f32ae13c2b9742f4$export$306c754c61954570));
};
const $8a82c1f355cb7bb5$export$4db59565c47f54df = (state, payload)=>{
    // to check unmapped status make sure field being updated is status
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && payload.meta.fieldId === (0, $5fc53.STATUS_TYPE)) {
        const statusIdsOfColumns = (0, $fyeGd.getStatusIdsOfColumns)(state);
        return !statusIdsOfColumns.includes(Number(payload.meta.fieldValue.id));
    }
    return false;
};
const $8a82c1f355cb7bb5$export$c6b04776cded39e0 = (state, payload)=>{
    // Check if issue's status is changed to status mapped to board
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && payload.meta.fieldId === (0, $5fc53.STATUS_TYPE)) {
        const statusIdsOfColumns = (0, $fyeGd.getStatusIdsOfColumns)(state);
        return statusIdsOfColumns.includes(Number(payload.meta.fieldValue.id));
    }
    return false;
};
const $8a82c1f355cb7bb5$export$e896a8751ab959a2 = (issue, state, payload, transactionId)=>{
    if (!payload.type || !issue) return null;
    const { meta: meta, type: type } = payload;
    if (type === (0, $FTaAj.ChangeEventTypes).ISSUE_TYPE_CHANGED) {
        const issueTypeName = meta.typeName || null;
        if (!issueTypeName) return null;
        const issueType = (0, $4gt6L.issueBaseTypesSelector)(state).find((issueBaseType)=>issueBaseType.name === issueTypeName);
        if (!issueType) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
        return (0, $2f454.cardDataSet)({
            ...issue,
            typeId: Number(issueType.id),
            typeName: issueType.name,
            typeUrl: issueType.iconUrl
        }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
    }
    // If we get a field change request, try to handle it internally (without another API call)
    // Otherwise fire an action or do nothing for CMP
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_REQUESTED) switch(payload.meta.fieldId){
        case 'assignee':
            return $8a82c1f355cb7bb5$var$updateAssignee(payload.meta, issue);
        case 'summary':
        case 'priority':
        case 'labels':
            return (0, $2f454.cardDataSet)({
                ...issue,
                [payload.meta.fieldId]: payload.meta.fieldValue
            }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
        default:
            // Some fields have no impact on the rendering of the board so we just
            // ignore them
            if ($8a82c1f355cb7bb5$export$c8a3dfc27ec07f10.includes(payload.meta.fieldId)) return null; // null will catch in issue-bento-update-epic
            // Optimistically update bento extracted fields after an API call is requested, on FIELD_CHANGE_REQUESTED
            if ((0, $4R6GH.fg)('jira_board_bento_update_refactor')) {
                const optimisticallyUpdatableFields = $8a82c1f355cb7bb5$var$FieldsWithOptimisticCardUpdate;
                if (optimisticallyUpdatableFields.has(payload.meta.fieldId)) {
                    // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
                    const column = (0, $fyeGd.columnByStatusIdSelector)(state, Number(payload.meta.fieldValue.id));
                    if (!column || issue?.extraFields?.some((ef)=>ef.id === payload.meta.fieldId)) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
                    return (0, $2f454.cardDataSet)({
                        ...issue,
                        statusId: Number(payload.meta.fieldValue.id),
                        columnId: column.id,
                        isDone: column.type === (0, $5rFbt.ColumnType).STATUS ? column.statuses.some((status)=>status.isDone) : false
                    }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
                }
            }
            // If its CMP, There is no way to handle this yet. What happens normally in TMP
            // is we fire the `issueUpdateRequestWithTransactionId` action which in turn
            // fires a graphql query to fetch a new version of THAT card. This endpoint
            // doesn't officially support CMP as there are fields that we need for CMP
            // that aren't in the query
            return !(0, $4R6GH.fg)('jira_board_bento_update_race_condition_fix') ? (0, $evkwq.issueUpdateRequestWithTransactionId)([
                issue.id
            ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId) : null;
    }
    if (!(0, $4R6GH.fg)('jira_board_bento_update_refactor')) {
        // Bento extracted fields, that can update optimistically as they fire "FIELD_CHANGED"
        // afteru sucess API call.
        const optimisticallyUpdatableFields = $8a82c1f355cb7bb5$var$FieldsWithOptimisticCardUpdate;
        if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && optimisticallyUpdatableFields.has(payload.meta.fieldId)) {
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
            const column = (0, $fyeGd.columnByStatusIdSelector)(state, Number(payload.meta.fieldValue.id));
            if (!column || issue?.extraFields?.some((ef)=>ef.id === payload.meta.fieldId)) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
            return (0, $2f454.cardDataSet)({
                ...issue,
                statusId: Number(payload.meta.fieldValue.id),
                columnId: column.id,
                isDone: column.type === (0, $5rFbt.ColumnType).STATUS ? column.statuses.some((status)=>status.isDone) : false
            }, undefined, (0, $f32ae13c2b9742f4$export$306c754c61954570));
        }
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && (0, $4R6GH.fg)('jira_board_bento_update_refactor')) {
        if ($8a82c1f355cb7bb5$export$855877a195ad3aa9.includes(payload.meta.fieldId)) switch(payload.meta.fieldId){
            case 'assignee':
                {
                    const currentAssignee = issue.assigneeAccountId;
                    const payloadAssignee = payload.meta.fieldValue?.accountId || null;
                    if (currentAssignee !== payloadAssignee) return $8a82c1f355cb7bb5$var$updateAssignee(payload.meta, issue);
                    return null;
                }
            default:
                return null;
        }
        if (!$8a82c1f355cb7bb5$export$c6057a4504428e8e.includes(payload.meta.fieldId)) // The issueUpdateRequestWithTransactionId() action should only be
        // called after the field change request is completed
        return (0, $evkwq.issueUpdateRequestWithTransactionId)([
            issue.id
        ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && $8a82c1f355cb7bb5$export$855877a195ad3aa9.includes(payload.meta.fieldId) && !(0, $4R6GH.fg)('jira_board_bento_update_refactor')) switch(payload.meta.fieldId){
        case 'assignee':
            {
                const currentAssignee = issue.assigneeAccountId;
                const payloadAssignee = payload.meta.fieldValue?.accountId || null;
                if (currentAssignee !== payloadAssignee) return $8a82c1f355cb7bb5$var$updateAssignee(payload.meta, issue);
                return null;
            }
        default:
            return null;
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_RELATIONSHIP_UPDATED) return (0, $evkwq.setIssueParent)(issue.id, Number(payload.meta.newParentIssueId));
    if (payload.type === (0, $FTaAj.ChangeEventTypes).ISSUE_CHILDREN_ORDER_CHANGED) {
        const setIssueChildrenRankPayload = {
            issueIds: payload.meta.issueIds.map((id)=>Number(id)),
            rankId: payload.meta.rankId,
            isRankAfter: payload.meta.isRankAfter
        };
        return (0, $4gHuj.setIssueChildrenRank)(setIssueChildrenRankPayload);
    }
    if (payload.type === (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_ADDED) return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issue.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    if (payload.type === (0, $FTaAj.ChangeEventTypes).SUBTASK_ADDED) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
    if (payload?.meta && 'fieldId' in payload.meta && payload.meta.fieldId && $8a82c1f355cb7bb5$export$c6057a4504428e8e.includes(payload.meta.fieldId)) return null;
    // Bento field update succeeded but change is not committed to the board yet via ChangeEventTypes.FIELD_CHANGE_REQUESTED
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && !$8a82c1f355cb7bb5$export$fbd9c46dbe46d35d.includes(payload.meta.fieldId) && !(0, $4R6GH.fg)('jira_board_bento_update_refactor')) return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issue.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    // Bento field update failed -> revert optimistic change
    if (payload.type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGE_FAILED) return (0, $evkwq.issueUpdateRequestWithTransactionId)([
        issue.id
    ], (0, $f32ae13c2b9742f4$export$306c754c61954570), transactionId);
    return null;
};

});

parcelRegister("2ZOF9", function(module, exports) {

$parcel$export(module.exports, "mapBentoResponseToMissingParent", () => $41dc0733ef2ff99a$export$56b90e3b9a92ede);

var $FTaAj = parcelRequire("FTaAj");


var $cW3pH = parcelRequire("cW3pH");
const $41dc0733ef2ff99a$export$56b90e3b9a92ede = (missingParent, payload)=>{
    if (!payload.type || !missingParent) return null;
    /**
	 * we care about four fields change on the missing parent Bento
	 * 1.summary
	 * 2. status
	 * 3. assignee
	 * 4. epic
	 * Since the epic field is a custom field e.g. customfield_10014,
	 * we do backlisting instead of whitelisting
	 */ const ignoreFields = [
        'fixVersions',
        'labels',
        'priority',
        'timeoriginalestimate',
        'description',
        'votes'
    ];
    const { type: type, meta: meta } = payload;
    const monitoringTypes = [
        (0, $FTaAj.ChangeEventTypes).ISSUE_TYPE_CHANGED,
        (0, $FTaAj.ChangeEventTypes).SUBTASK_ADDED,
        (0, $FTaAj.ChangeEventTypes).CHILD_ISSUE_FIELD_UPDATED
    ];
    if (monitoringTypes.find((monitoringType)=>monitoringType === type) || type === (0, $FTaAj.ChangeEventTypes).FIELD_CHANGED && !ignoreFields.includes(meta.fieldId)) return (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$9808bb47382c679c));
    return null;
};

});


parcelRegister("4rj2F", function(module, exports) {

$parcel$export(module.exports, "issueBulkUpdateEpic", () => $54b8f55f8043a932$export$8039b5375000d1f4);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $dMBwz = parcelRequire("dMBwz");
function $54b8f55f8043a932$export$8039b5375000d1f4(action$, store, { customRequestHandlers: customRequestHandlers }) {
    return action$.ofType((0, $dMBwz.ISSUE_BULK_UPDATE_REQUEST)).mergeMap((action)=>{
        const success = (response)=>{
            if (action.promise) action.promise.resolve(response);
            return (0, $kVLXA.Observable).of((0, $dMBwz.issueBulkUpdateSuccess)());
        };
        const error = (err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.issue-bulk-update.failure', 'Failed to bulk update on IP board', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            if (action.promise) action.promise.reject(err);
            return (0, $kVLXA.Observable).of((0, $dMBwz.issueBulkUpdateFailed)());
        };
        if (!customRequestHandlers || !customRequestHandlers.bulkUpdateIssues) return error(new Error('no request handler found for bulk update'));
        return (0, $kVLXA.Observable).from(customRequestHandlers.bulkUpdateIssues(action.payload)).flatMap((response)=>success(response)).catch((err)=>error(err));
    });
}

});
parcelRegister("dMBwz", function(module, exports) {

$parcel$export(module.exports, "ISSUE_BULK_UPDATE_REQUEST", () => $9d161783e4afcb8e$export$5bfd2f80d856fe03);
$parcel$export(module.exports, "issueBulkUpdateRequest", () => $9d161783e4afcb8e$export$4d9d42d62d3b54f7);
$parcel$export(module.exports, "issueBulkUpdateSuccess", () => $9d161783e4afcb8e$export$4b88a56083e2ad37);
$parcel$export(module.exports, "issueBulkUpdateFailed", () => $9d161783e4afcb8e$export$383f6bf4f457791b);
const $9d161783e4afcb8e$export$5bfd2f80d856fe03 = 'state.actions.issue.bulk-update.ISSUE_BULK_UPDATE_REQUEST';
const $9d161783e4afcb8e$export$4d9d42d62d3b54f7 = (payload)=>({
        type: $9d161783e4afcb8e$export$5bfd2f80d856fe03,
        payload: payload
    });
const $9d161783e4afcb8e$export$2b99e3cfe4b3c804 = 'state.actions.issue.bulk-update.ISSUE_BULK_UPDATE_SUCCESS';
const $9d161783e4afcb8e$export$4b88a56083e2ad37 = ()=>({
        type: $9d161783e4afcb8e$export$2b99e3cfe4b3c804
    });
const $9d161783e4afcb8e$export$189459f8d84a28bc = 'state.actions.issue.bulk-update.ISSUE_BULK_UPDATE_FAILED';
const $9d161783e4afcb8e$export$383f6bf4f457791b = ()=>({
        type: $9d161783e4afcb8e$export$189459f8d84a28bc
    });

});


parcelRegister("fgxdE", function(module, exports) {

$parcel$export(module.exports, "issueChildrenInFinalColumnEpic", () => $93a9d883822ec989$export$79f7ca1c01707d22);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $5bE6a = parcelRequire("5bE6a");

var $cMQ7P = parcelRequire("cMQ7P");

var $hdmw1 = parcelRequire("hdmw1");

var $4gHuj = parcelRequire("4gHuj");

var $cdcje = parcelRequire("cdcje");

var $lIysR = parcelRequire("lIysR");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");
function $93a9d883822ec989$export$79f7ca1c01707d22(action$, store) {
    return action$.ofType((0, $4gHuj.ISSUE_CHILDREN_IN_FINAL_COLUMN_REQUEST)).mergeMap((action)=>{
        const ctx = (0, $hdmw1.makeServiceContext)(store.getState());
        return (0, $cMQ7P.issueChildrenInFinalColumnService)(ctx, action.payload.parentId).flatMap(({ subtasksInFinalColumn: subtasksInFinalColumn })=>{
            if (subtasksInFinalColumn) {
                const { getState: getState } = store;
                const state = getState();
                const issueParent = (0, $67Z81.getIssues)(state)[action.payload.parentId] ?? null;
                const missingParent = (0, $67Z81.getMissingParents)(state)[action.payload.parentId] ?? null;
                const parentIssue = issueParent || missingParent;
                if (!parentIssue) return (0, $kVLXA.Observable).empty();
                const columns = (0, $fyeGd.orderedColumnsSelector)(state);
                const lastColumn = columns[columns.length - 1];
                const transitions = (0, $lIysR.transitionsByColumnIdSelector)(state)(lastColumn.id, parentIssue);
                if (!transitions || transitions.length === 0) return (0, $kVLXA.Observable).empty();
                const transitionsHaveConditions = transitions.some((transition)=>transition.hasConditions);
                if (!transitionsHaveConditions) return (0, $kVLXA.Observable).of((0, $cdcje.showUpdateIssueParentModal)(action.payload.parentId, transitions));
                const contextPath = (0, $67Z81.contextPathSelector)(state);
                const boardId = (0, $67Z81.rapidViewIdSelector)(state);
                return (0, $5bE6a.fetchCardIssueTransitionsService)(contextPath, boardId, parentIssue.id).flatMap((issueTransitions)=>{
                    const lastColumnStatuses = 'statuses' in lastColumn ? lastColumn.statuses.map((status)=>status.id) : [];
                    const validTransitions = issueTransitions.filter((transition)=>transition.isAvailable && lastColumnStatuses.includes(transition.destinationStatusId));
                    if (validTransitions.length > 0) return (0, $kVLXA.Observable).of((0, $cdcje.showUpdateIssueParentModal)(action.payload.parentId, validTransitions));
                    return (0, $kVLXA.Observable).empty();
                }).catch((err)=>{
                    (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.issue-children-in-final-column.failure', 'Failed to check available transitions', err);
                    return (0, $kVLXA.Observable).empty();
                });
            }
            return (0, $kVLXA.Observable).empty();
        }).catch((err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.issue-children-in-final-column.failure', 'Failed to check if all issue children are in final column', err);
            return (0, $kVLXA.Observable).empty();
        });
    });
}

});
parcelRegister("cMQ7P", function(module, exports) {

$parcel$export(module.exports, "issueChildrenInFinalColumnService", () => $58d68d110824c01b$export$e8d6f9a2a40b6e2a);

var $aHvt6 = parcelRequire("aHvt6");
const $58d68d110824c01b$export$e8d6f9a2a40b6e2a = (ctx, parentId)=>(0, $aHvt6.issueChildrenInFinalColumnRest)(parentId, ctx.boardId);

});
parcelRegister("aHvt6", function(module, exports) {

$parcel$export(module.exports, "issueChildrenInFinalColumnRest", () => $3c53606ec990b560$export$3b598c13ea0c18af);

var $487fd = parcelRequire("487fd");
function $3c53606ec990b560$export$3b598c13ea0c18af(parentId, rapidViewId) {
    return (0, $487fd.default)(`/rest/greenhopper/1.0/xboard/issue/subtasksInFinalColumn.json?issueId=${parentId}&rapidViewId=${rapidViewId}&operation=IssueChildrenInFinalColumn`, {
        method: 'GET'
    });
}

});


parcelRegister("cdcje", function(module, exports) {

$parcel$export(module.exports, "SHOW_UPDATE_ISSUE_PARENT_MODAL", () => $ae592c453de648d6$export$8c94067b9b76f3d);
$parcel$export(module.exports, "showUpdateIssueParentModal", () => $ae592c453de648d6$export$eeb78f32bb6c8306);
$parcel$export(module.exports, "HIDE_UPDATE_ISSUE_PARENT_MODAL", () => $ae592c453de648d6$export$58fce3932176ed24);
$parcel$export(module.exports, "hideUpdateIssueParentModal", () => $ae592c453de648d6$export$6c8eb96d597d4f6c);
const $ae592c453de648d6$export$8c94067b9b76f3d = 'state.actions.issue.update-issue-parent-modal.SHOW_UPDATE_ISSUE_PARENT_MODAL';
const $ae592c453de648d6$export$eeb78f32bb6c8306 = (issueParentId, transitions)=>({
        type: $ae592c453de648d6$export$8c94067b9b76f3d,
        payload: {
            issueParentId: issueParentId,
            transitions: transitions
        }
    });
const $ae592c453de648d6$export$58fce3932176ed24 = 'state.actions.issue.update-issue-parent-modal.HIDE_UPDATE_ISSUE_PARENT_MODAL';
const $ae592c453de648d6$export$6c8eb96d597d4f6c = ()=>({
        type: $ae592c453de648d6$export$58fce3932176ed24
    });

});


parcelRegister("6Yser", function(module, exports) {

$parcel$export(module.exports, "default", () => $7754c640f8b7ce26$export$2e2bcd8739ae039);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $4jAPy = parcelRequire("4jAPy");

var $2W0EG = parcelRequire("2W0EG");

var $3D2mY = parcelRequire("3D2mY");

var $fTVet = parcelRequire("fTVet");

var $lWvJn = parcelRequire("lWvJn");

var $ls4NM = parcelRequire("ls4NM");

var $65C0W = parcelRequire("65C0W");

var $9UXXB = parcelRequire("9UXXB");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $7754c640f8b7ce26$var$createAndRankIssuesInIPBoard = (action, store, dependencies)=>{
    const { payload: { temporaryIssueIds: temporaryIssueIds, issues: optimisticIssues }, meta: { insertBefore: insertBefore, optimistic: { id: optimisticId }, columnIndex: columnIndex, cardIndex: cardIndex, analyticsEvent: analyticsEvent } } = action;
    const optimisticIssue = optimisticIssues[0];
    const { projectId: projectId, typeId: typeId } = optimisticIssue;
    const state = store.getState();
    const customRequestHandlers = dependencies ? dependencies.customRequestHandlers : {};
    const incrementConfig = (0, $67Z81.getIncrementConfig)(state);
    const validateError = (analyticEvent, err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('create.scenario.issue.validate.failure', 'planId, scenarioId and incrementconfig cannot be null in IP board', err);
        return (0, $kVLXA.Observable).of((0, $ls4NM.issueCreateIPValidateFailure)(analyticEvent, err));
    };
    const onError = (error, source)=>{
        const errorCollection = (0, $2W0EG.parseErrorCollection)(error.message);
        // error is a SwagError which contains nested objects
        // nested objects are not accepted by the backend
        const flattenedError = new Error(error.message);
        flattenedError.stack = error.stack;
        flattenedError.name = error.name;
        // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error'.
        flattenedError.traceId = error.traceId;
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.issue-create.failure', `Failed to ${source} when create issue in IP board`, flattenedError);
        if (error.message === (0, $4jAPy.CUSTOM_FIELD_OPTION_MISSED_ERROR)) {
            const boardScopeFilter = incrementConfig?.boardScopeFilter;
            return (0, $kVLXA.Observable).from([
                (0, $ls4NM.customFieldMissedInIPBoard)({
                    fieldValue: boardScopeFilter?.filterFieldValue || '',
                    issueTypeName: (0, $d2i8f.getIssueTypeById)(state, typeId).name,
                    projectName: (0, $67Z81.getIssueProjects)(state)[projectId].name,
                    fieldName: boardScopeFilter?.filterFieldName || ''
                }),
                (0, $ls4NM.issueCreateFailure)(optimisticId, analyticsEvent, error)
            ]);
        }
        return (0, $kVLXA.Observable).from([
            (0, $ls4NM.issueCreateFailure)(optimisticId, analyticsEvent, error),
            (0, $65C0W.displayWarning)(errorCollection ? (0, $2W0EG.flatErrorCollection)(errorCollection) : errorCollection)
        ]);
    };
    const onSuccess = (issue)=>(0, $kVLXA.Observable).of((0, $ls4NM.issueCreateSuccess)(optimisticId, temporaryIssueIds, [
            issue
        ], columnIndex, cardIndex, analyticsEvent));
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(incrementConfig)) return validateError(analyticsEvent, new Error('incrementconfig cannot be null'));
    if (!customRequestHandlers || !customRequestHandlers.rankIssue) return validateError(analyticsEvent, new Error('no request handler found for creating or ranking issues'));
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId)) return validateError(analyticsEvent, new Error('projectId for new issue cannot be null'));
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(typeId)) return validateError(analyticsEvent, new Error('issue typeId for new issue cannot be null'));
    const { rankIssue: rankIssue } = customRequestHandlers;
    const doRank = (issue)=>(0, $lWvJn.issueRankJPOService)({
            issueIds: [
                issue.id
            ],
            rankBeforeIssueId: insertBefore,
            isLastPosition: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(insertBefore),
            requestHandler: rankIssue
        }).flatMap(()=>onSuccess(issue)).catch((error)=>onError(error, 'rank'));
    return (0, $3D2mY.default)(store.getState(), incrementConfig, optimisticIssues[0], customRequestHandlers).flatMap((issue)=>doRank(issue)).catch((error)=>onError(error, 'addIssue'));
};
const $7754c640f8b7ce26$var$createAndRankIssues = (action, store)=>{
    const { payload: { temporaryIssueIds: temporaryIssueIds, issues: optimisticIssues }, meta: { insertBefore: insertBefore, optimistic: { id: optimisticId }, columnIndex: columnIndex, cardIndex: cardIndex, analyticsEvent: analyticsEvent, transitionInfo: transitionInfo, swimlaneId: swimlaneId } } = action;
    const shouldCreateWithSwimlaneContext = (0, $9UXXB.getShouldCreateWithSwimlaneContext)(store.getState())(swimlaneId);
    const state = store.getState();
    return (0, $fTVet.default)(state, insertBefore, optimisticIssues, transitionInfo, shouldCreateWithSwimlaneContext ? swimlaneId : undefined).flatMap((issues)=>(0, $kVLXA.Observable).of((0, $ls4NM.issueCreateSuccess)(optimisticId, temporaryIssueIds, issues, columnIndex, cardIndex, analyticsEvent, (0, $5mTgl.isFilterRefinementEnabled)(state)))).catch((error)=>{
        const errorCollection = (0, $2W0EG.parseErrorCollection)(error.message);
        // error is a SwagError which contains nested objects
        // nested objects are not accepted by the backend
        const flattenedError = new Error(error.message);
        flattenedError.stack = error.stack;
        flattenedError.name = error.name;
        // @ts-expect-error - TS2339 - Property 'traceId' does not exist on type 'Error'.
        flattenedError.traceId = error.traceId;
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.issue-create.failure', 'Failed to create issue', flattenedError);
        return (0, $kVLXA.Observable).from([
            (0, $ls4NM.issueCreateFailure)(optimisticId, analyticsEvent, error),
            (0, $65C0W.displayWarning)(errorCollection ? (0, $2W0EG.flatErrorCollection)(errorCollection) : errorCollection)
        ]);
    });
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7754c640f8b7ce26$export$2e2bcd8739ae039 = (action$, store, dependencies)=>action$.ofType((0, $ls4NM.ISSUE_CREATE_REQUEST)).mergeMap((action)=>{
        if ((0, $67Z81.getIsIncrementPlanningBoard)(store.getState())) return $7754c640f8b7ce26$var$createAndRankIssuesInIPBoard(action, store, dependencies);
        return $7754c640f8b7ce26$var$createAndRankIssues(action, store);
    });

});
parcelRegister("3D2mY", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f43b06f240ce3b7$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $fr1K2 = parcelRequire("fr1K2");

var $kVLXA = parcelRequire("kVLXA");

var $4R6GH = parcelRequire("4R6GH");

var $iHPnC = parcelRequire("iHPnC");

var $g4tDr = parcelRequire("g4tDr");

var $4jAPy = parcelRequire("4jAPy");

var $tZ4NF = parcelRequire("tZ4NF");

var $kgiLc = parcelRequire("kgiLc");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $6f43b06f240ce3b7$var$getTeamId = (teamId)=>teamId === (0, $4jAPy.SWIMLANE_TEAMLESS) ? null : teamId;
const $6f43b06f240ce3b7$export$78f957e4bfdb730f = (optimisticIssue, dateFields, epicLevel, sprint)=>{
    const { projectId: projectId, teamId: teamId, typeId: typeId, summary: summary, parentId: parentId, color: color, estimate: estimate, customFields: customFields, labels: labels, priority: priority } = optimisticIssue;
    const team = $6f43b06f240ce3b7$var$getTeamId(teamId);
    const customFieldsInner = {
        ...customFields || {},
        ...dateFields.customFields || {}
    };
    return {
        project: projectId,
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(team) ? {
            team: team
        } : {},
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(labels) && labels.length > 0 ? {
            labels: labels
        } : {},
        type: typeId,
        summary: summary,
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(parentId) ? {
            parent: String(parentId)
        } : {},
        estimate: estimate,
        ...epicLevel ? {
            color: $6f43b06f240ce3b7$var$getEpicColor(color)
        } : {},
        ...(0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(dateFields, 'customFields'),
        ...(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(customFieldsInner) ? {} : {
            customFields: customFieldsInner
        },
        ...sprint && !epicLevel ? {
            sprint: `${sprint.id}`
        } : {},
        ...!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priority) && (0, $4R6GH.fg)('issue_cards_in_program_board') ? {
            priority: priority.id
        } : {}
    };
};
const $6f43b06f240ce3b7$var$setCustomFieldValue = (incrementConfig, optimisticIssue)=>{
    const { projectId: projectId, typeId: issueTypeId } = optimisticIssue;
    const boardScopeFilter = incrementConfig?.boardScopeFilter;
    const filterFieldId = boardScopeFilter?.filterFieldId;
    // if there is not filterFieldId
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(filterFieldId)) return (0, $kVLXA.Observable).of(optimisticIssue);
    if (filterFieldId === (0, $4jAPy.SYSTEM_LABEL_FIELD_ID)) {
        const customFields = {
            [(0, $4jAPy.SYSTEM_LABEL_FIELD_ID)]: [
                boardScopeFilter?.filterFieldValue || ''
            ]
        };
        return (0, $kVLXA.Observable).of({
            ...optimisticIssue,
            ...customFields
        });
    }
    const regex = /^(.*)_(.*)$/g;
    const fieldIdArray = regex.exec(filterFieldId || '') || [];
    const customFieldId = fieldIdArray.length > 3 ? '' : fieldIdArray[2];
    if (customFieldId.length < 1) throw new Error("The customFieldId doesn't follow customfield_id format");
    return (0, $tZ4NF.fetchOptionsForCustomFields)({
        projectId: `${projectId}`,
        issueTypeId: `${issueTypeId}`,
        customFieldId: customFieldId
    }).flatMap((options)=>{
        const option = options.find((o)=>o.value === boardScopeFilter?.filterFieldValue);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(option)) throw new Error((0, $4jAPy.CUSTOM_FIELD_OPTION_MISSED_ERROR));
        let customFieldValue;
        if (boardScopeFilter?.filterFieldTypeKey === (0, $4jAPy.SINGLE_CUSTOM_FIELD_TYPE_KEY)) customFieldValue = option.id;
        else customFieldValue = [
            option.id
        ];
        return (0, $kVLXA.Observable).of({
            ...optimisticIssue,
            customFields: {
                [customFieldId]: customFieldValue
            }
        });
    });
};
const $6f43b06f240ce3b7$var$createCardServiceInner = (state, incrementConfig, originalOptimisticIssue, customRequestHandlers)=>{
    const optimisticIssue = {
        ...originalOptimisticIssue
    };
    const column = (0, $fyeGd.getColumnById)(state, optimisticIssue.columnId);
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const dateRange = column?.dateRange;
    const { name: typeName, iconUrl: typeUrl, hierarchyLevelType: hierarchyLevelType } = (0, $d2i8f.getIssueTypeById)(state, optimisticIssue.typeId);
    const epicLevel = hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
    let dateFields = (0, $kgiLc.transformDateRangeUpdateValues)(incrementConfig, // Only set start date for non epic issues
    !epicLevel ? (0, $kgiLc.transformDateValue)(dateRange?.start) : undefined, (0, $kgiLc.transformDateValue)(dateRange?.end));
    const { columnId: columnId, teamId: teamId } = optimisticIssue;
    const sprint = teamId ? (0, $5mTgl.getTeamSwimlaneColumnSprint)(state, columnId, teamId) : undefined;
    if (sprint) {
        if (epicLevel) // for Epic level issues, update the date range to reflect the sprint dates if they exist
        {
            if (sprint.endDate) dateFields = (0, $kgiLc.transformDateRangeUpdateValues)(incrementConfig, undefined, (0, $kgiLc.transformDateValue)(sprint.endDate));
        } else {
            // for story level issues, if sprints are associated, don't update the date range, but need to update the sprint of issue
            dateFields = {};
            optimisticIssue.sprintId = `${sprint.id}`;
        }
    }
    // Estimate is an empty placeholder value that's only needed for optimistic update in the board,
    // but would break review changes in the plan as the format is incorrect for the plan
    const { estimate: estimate, ...description } = $6f43b06f240ce3b7$export$78f957e4bfdb730f(optimisticIssue, dateFields, epicLevel, sprint);
    const issueProjects = (0, $67Z81.getIssueProjects)(state);
    const createObservable = (result)=>{
        const scenarioIssueId = result?.itemKey;
        //  we will not show the labels on the ip board issue card, so need to get rid of labels in here
        const optimisticIssueForBoard = !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(optimisticIssue.labels) ? {
            ...optimisticIssue,
            labels: []
        } : optimisticIssue;
        return (0, $kVLXA.Observable).of({
            ...optimisticIssueForBoard,
            typeName: typeName,
            typeUrl: typeUrl,
            id: scenarioIssueId,
            key: issueProjects[optimisticIssue.projectId].key
        });
    };
    if (!customRequestHandlers || !customRequestHandlers.addIssue) throw new Error('no request handler found for creating issues');
    const isCreateIssueResponse = (result)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result?.itemKey !== undefined;
    return (0, $kVLXA.Observable).from(customRequestHandlers.addIssue({
        ...description
    })).flatMap((result)=>{
        if (isCreateIssueResponse(result)) return createObservable(result);
        // It should never reach here, adding the fallback due to the typechecks above
        return (0, $kVLXA.Observable).of(optimisticIssue);
    });
};
const $6f43b06f240ce3b7$var$createCardService = (state, incrementConfig, optimisticIssue, customRequestHandlers)=>$6f43b06f240ce3b7$var$setCustomFieldValue(incrementConfig, optimisticIssue).flatMap((issue)=>$6f43b06f240ce3b7$var$createCardServiceInner(state, incrementConfig, issue, customRequestHandlers));
var $6f43b06f240ce3b7$export$2e2bcd8739ae039 = $6f43b06f240ce3b7$var$createCardService;
function $6f43b06f240ce3b7$var$getEpicColor(color) {
    return (0, $iHPnC.toBackendColor)(color ?? (0, $iHPnC.getRandomColor)());
}

});
parcelRegister("iHPnC", function(module, exports) {

$parcel$export(module.exports, "asColor", () => $e626bf77f0e696c5$export$b74af6529f09947);
$parcel$export(module.exports, "asServerColor", () => $e626bf77f0e696c5$export$442690a499ee9598);
$parcel$export(module.exports, "asClassicEpicColor", () => $e626bf77f0e696c5$export$eb754032c0b9698c);
$parcel$export(module.exports, "transformColorToTheme", () => $e626bf77f0e696c5$export$37c9bd72afe7f286);
$parcel$export(module.exports, "getValueFromColor", () => $e626bf77f0e696c5$export$a00423580059ae28);
$parcel$export(module.exports, "getColorFromValue", () => $e626bf77f0e696c5$export$6d14528e40cbe34b);
$parcel$export(module.exports, "toFrontendColor", () => $e626bf77f0e696c5$export$574e4dbf3c01f0ad);
$parcel$export(module.exports, "toBackendColor", () => $e626bf77f0e696c5$export$47af25386a01de1);
$parcel$export(module.exports, "classicToFrontendColor", () => $e626bf77f0e696c5$export$8f81207f7ac5fb9a);
$parcel$export(module.exports, "classicToBackendColor", () => $e626bf77f0e696c5$export$28fb68bb1de025d5);
$parcel$export(module.exports, "getDefaultColorPalette", () => $e626bf77f0e696c5$export$f6e067d5c418081a);
$parcel$export(module.exports, "getLozengeThemeByColor", () => $e626bf77f0e696c5$export$949dc67535a8ff2);
$parcel$export(module.exports, "getRandomColor", () => $e626bf77f0e696c5$export$e4369cabd7e84cd9);

var $ggSx2 = parcelRequire("ggSx2");

var $7SCny = parcelRequire("7SCny");

var $heWHN = parcelRequire("heWHN");

var $ehxiD = parcelRequire("ehxiD");
const $e626bf77f0e696c5$export$b74af6529f09947 = (color)=>{
    if (color == null) return (0, $7SCny.Colors).PURPLE;
    if (color in (0, $7SCny.Colors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color];
    return (0, $7SCny.Colors).PURPLE;
};
const $e626bf77f0e696c5$export$442690a499ee9598 = (color)=>{
    if (color == null) return (0, $7SCny.ServerColors).SERVER_PURPLE;
    if (color in (0, $7SCny.ServerColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    return (0, $7SCny.ServerColors).SERVER_PURPLE;
};
const $e626bf77f0e696c5$export$eb754032c0b9698c = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.ClassicEpicColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_AGILE_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_AGILE_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $heWHN.MAP_FROM_AGILE_COLOR)[color]];
    // i.e: ghx-label-7
    return (0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$1a0a4af71e00cea4 = (color)=>{
    if (color === null) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
    if (color in (0, $7SCny.AgileColors)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return color;
    if (color in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[color];
    if (color in (0, $heWHN.MAP_FROM_SERVER_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $heWHN.MAP_FROM_SERVER_COLOR)[color]];
    if (color in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color] in (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)) return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[color]];
    // i.e: color_7
    return (0, $heWHN.MAP_FROM_CLIENT_AGILE_COLOR)[(0, $7SCny.Colors).PURPLE];
};
const $e626bf77f0e696c5$export$37c9bd72afe7f286 = (transformation, colorSchemaExtension)=>{
    const newColorSchema = {
        ...(0, $heWHN.BASE_COLOR_SCHEMA),
        ...colorSchemaExtension
    };
    const extendedColors = (colorSchemaExtension ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys(colorSchemaExtension) : []).concat(Object.keys((0, $7SCny.Colors)));
    return extendedColors.reduce((obj, color)=>Object.assign(obj, {
            [color]: transformation(newColorSchema[color])
        }), // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {});
};
const $e626bf77f0e696c5$export$a00423580059ae28 = (color)=>(0, $heWHN.MAP_COLORS_TO_VALUE)[color] || (0, $heWHN.MAP_COLORS_TO_VALUE)[0, $7SCny.PURPLE];
const $e626bf77f0e696c5$export$6d14528e40cbe34b = (value)=>// NOTE: lodash invert coerce the output to Dictionary<string> instead of using a polymorphic type
    // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'Color'.
    (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))((0, $heWHN.MAP_COLORS_TO_VALUE))[value] || (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$574e4dbf3c01f0ad = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$47af25386a01de1 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_SERVER_COLOR)[color];
const $e626bf77f0e696c5$export$8f81207f7ac5fb9a = (colorStr)=>colorStr !== '' && colorStr !== undefined && colorStr !== null && colorStr in (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR) ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $heWHN.MAP_FROM_SERVER_CLASSIC_COLOR)[colorStr] : (0, $7SCny.PURPLE);
const $e626bf77f0e696c5$export$28fb68bb1de025d5 = (color)=>(0, $heWHN.MAP_FROM_CLIENT_CLASSIC_COLOR)[color];
/**
 * Return default color palette
 */ const $e626bf77f0e696c5$var$paletteColorValues = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>colorSchema.primary);
const $e626bf77f0e696c5$export$f6e067d5c418081a = (formatMessage)=>[
        {
            label: formatMessage((0, $ehxiD.default).purpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).blueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).tealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).yellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).orangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).greyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).GREY]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkPurpleLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_PURPLE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkBlueLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_BLUE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreenLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREEN]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkTealLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_TEAL]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkYellowLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_YELLOW]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkOrangeLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_ORANGE]
        },
        {
            label: formatMessage((0, $ehxiD.default).darkGreyLabel),
            value: $e626bf77f0e696c5$var$paletteColorValues[(0, $7SCny.Colors).DARK_GREY]
        }
    ];
const $e626bf77f0e696c5$export$9b822862d986dfdf = $e626bf77f0e696c5$export$37c9bd72afe7f286((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $e626bf77f0e696c5$export$949dc67535a8ff2 = (color = (0, $heWHN.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e626bf77f0e696c5$export$9b822862d986dfdf[color] ?? $e626bf77f0e696c5$export$9b822862d986dfdf[0, $heWHN.DEFAULT_EPIC_COLOR];
const $e626bf77f0e696c5$export$e4369cabd7e84cd9 = ()=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const colorKeys = Object.keys((0, $7SCny.Colors));
    return colorKeys[Math.floor(Math.random() * colorKeys.length)];
};

});
parcelRegister("ggSx2", function(module, exports) {

var $cxSdl = parcelRequire("cxSdl");

var $fxKlj = parcelRequire("fxKlj");

var $etyzk = parcelRequire("etyzk");
/** Used for built-in method references. */ var $bd8870e21c3833a0$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bd8870e21c3833a0$var$nativeObjectToString = $bd8870e21c3833a0$var$objectProto.toString;
/**
 * Creates an object composed of the inverted keys and values of `object`.
 * If `object` contains duplicate values, subsequent values overwrite
 * property assignments of previous values.
 *
 * @static
 * @memberOf _
 * @since 0.7.0
 * @category Object
 * @param {Object} object The object to invert.
 * @returns {Object} Returns the new inverted object.
 * @example
 *
 * var object = { 'a': 1, 'b': 2, 'c': 1 };
 *
 * _.invert(object);
 * // => { '1': 'c', '2': 'b' }
 */ var $bd8870e21c3833a0$var$invert = $fxKlj(function(result, value, key) {
    if (value != null && typeof value.toString != 'function') value = $bd8870e21c3833a0$var$nativeObjectToString.call(value);
    result[value] = key;
}, $cxSdl($etyzk));
module.exports = $bd8870e21c3833a0$var$invert;

});
parcelRegister("fxKlj", function(module, exports) {

var $d1nCg = parcelRequire("d1nCg");
/**
 * Creates a function like `_.invertBy`.
 *
 * @private
 * @param {Function} setter The function to set accumulator values.
 * @param {Function} toIteratee The function to resolve iteratees.
 * @returns {Function} Returns the new inverter function.
 */ function $b50de2cb57eb155c$var$createInverter(setter, toIteratee) {
    return function(object, iteratee) {
        return $d1nCg(object, setter, toIteratee(iteratee), {});
    };
}
module.exports = $b50de2cb57eb155c$var$createInverter;

});
parcelRegister("d1nCg", function(module, exports) {

var $hDnyx = parcelRequire("hDnyx");
/**
 * The base implementation of `_.invert` and `_.invertBy` which inverts
 * `object` with values transformed by `iteratee` and set by `setter`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} setter The function to set `accumulator` values.
 * @param {Function} iteratee The iteratee to transform values.
 * @param {Object} accumulator The initial inverted object.
 * @returns {Function} Returns `accumulator`.
 */ function $97adb007e27dc709$var$baseInverter(object, setter, iteratee, accumulator) {
    $hDnyx(object, function(value, key, object) {
        setter(accumulator, iteratee(value), key, object);
    });
    return accumulator;
}
module.exports = $97adb007e27dc709$var$baseInverter;

});



parcelRegister("heWHN", function(module, exports) {

$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAP_COLORS_TO_VALUE", () => $3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
$parcel$export(module.exports, "MAP_COLORS_TO_TOKEN", () => $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1);
$parcel$export(module.exports, "MAP_VALUE_TO_COLOR", () => $3a4ee6f2b0ce40ab$export$a6cb26e106674600);
$parcel$export(module.exports, "MAP_FROM_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$43264b0781f10167);
$parcel$export(module.exports, "MAP_FROM_CLIENT_SERVER_COLOR", () => $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7);
$parcel$export(module.exports, "MAP_FROM_SERVER_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
$parcel$export(module.exports, "MAP_FROM_CLIENT_CLASSIC_COLOR", () => $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8);
$parcel$export(module.exports, "MAP_FROM_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
$parcel$export(module.exports, "MAP_FROM_CLIENT_AGILE_COLOR", () => $3a4ee6f2b0ce40ab$export$db17671bf37971e7);
$parcel$export(module.exports, "MAP_COLOR_TO_AK_COLOR", () => $3a4ee6f2b0ce40ab$export$82fc3b0b98905453);
$parcel$export(module.exports, "BASE_COLOR_SCHEMA", () => $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9);

var $ggSx2 = parcelRequire("ggSx2");


var $7SCny = parcelRequire("7SCny");
const $3a4ee6f2b0ce40ab$export$c2357bec51c5cf5b = 'PURPLE';
const $3a4ee6f2b0ce40ab$export$db33d74b098e3da9 = {
    [(0, $7SCny.PURPLE)]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $7SCny.BLUE)]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $7SCny.GREEN)]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $7SCny.TEAL)]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $7SCny.YELLOW)]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $7SCny.ORANGE)]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $7SCny.GREY)]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $7SCny.DARK_PURPLE)]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $7SCny.DARK_BLUE)]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $7SCny.DARK_GREEN)]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $7SCny.DARK_TEAL)]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $7SCny.DARK_YELLOW)]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $7SCny.DARK_ORANGE)]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $7SCny.DARK_GREY)]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$fc5fe4213a5703f1 = {
    [(0, $829f609a65d26a98$exports).P200]: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    [(0, $829f609a65d26a98$exports).B200]: "var(--ds-background-accent-blue-subtle, #579DFF)",
    [(0, $829f609a65d26a98$exports).G200]: "var(--ds-background-accent-green-subtle, #4BCE97)",
    [(0, $829f609a65d26a98$exports).T200]: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    [(0, $829f609a65d26a98$exports).Y200]: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    [(0, $829f609a65d26a98$exports).R200]: "var(--ds-background-accent-red-subtle, #F87168)",
    [(0, $829f609a65d26a98$exports).N200]: "var(--ds-background-accent-gray-subtle, #8590A2)",
    [(0, $829f609a65d26a98$exports).P400]: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
    [(0, $829f609a65d26a98$exports).B400]: "var(--ds-background-accent-blue-bolder, #0C66E4)",
    [(0, $829f609a65d26a98$exports).G400]: "var(--ds-background-accent-green-bolder, #1F845A)",
    [(0, $829f609a65d26a98$exports).T400]: "var(--ds-background-accent-teal-bolder, #227D9B)",
    [(0, $829f609a65d26a98$exports).Y400]: "var(--ds-background-accent-orange-bolder, #C25100)",
    [(0, $829f609a65d26a98$exports).R400]: "var(--ds-background-accent-red-bolder, #C9372C)",
    [(0, $829f609a65d26a98$exports).N700]: "var(--ds-background-accent-gray-bolder, #626F86)"
};
const $3a4ee6f2b0ce40ab$export$a6cb26e106674600 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$db33d74b098e3da9);
const $3a4ee6f2b0ce40ab$export$43264b0781f10167 = {
    [(0, $7SCny.SERVER_PURPLE)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.SERVER_DARK_PURPLE)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.SERVER_BLUE)]: (0, $7SCny.BLUE),
    [(0, $7SCny.SERVER_DARK_BLUE)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.SERVER_GREEN)]: (0, $7SCny.GREEN),
    [(0, $7SCny.SERVER_DARK_GREEN)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.SERVER_TEAL)]: (0, $7SCny.TEAL),
    [(0, $7SCny.SERVER_DARK_TEAL)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.SERVER_YELLOW)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.SERVER_DARK_YELLOW)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.SERVER_ORANGE)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.SERVER_DARK_ORANGE)]: (0, $7SCny.DARK_ORANGE),
    [(0, $7SCny.SERVER_GREY)]: (0, $7SCny.GREY),
    [(0, $7SCny.SERVER_DARK_GREY)]: (0, $7SCny.DARK_GREY)
};
const $3a4ee6f2b0ce40ab$export$aedca9f3a1ee43d7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$43264b0781f10167);
const $3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$c13af2d9629c53d8 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$fb5d051fe1b2bccc);
const $3a4ee6f2b0ce40ab$export$994d3ffa39be04fd = {
    [(0, $7SCny.AGILE_COLOR_1)]: (0, $7SCny.DARK_GREY),
    [(0, $7SCny.AGILE_COLOR_2)]: (0, $7SCny.DARK_YELLOW),
    [(0, $7SCny.AGILE_COLOR_3)]: (0, $7SCny.YELLOW),
    [(0, $7SCny.AGILE_COLOR_4)]: (0, $7SCny.DARK_BLUE),
    [(0, $7SCny.AGILE_COLOR_5)]: (0, $7SCny.DARK_TEAL),
    [(0, $7SCny.AGILE_COLOR_6)]: (0, $7SCny.GREEN),
    [(0, $7SCny.AGILE_COLOR_7)]: (0, $7SCny.PURPLE),
    [(0, $7SCny.AGILE_COLOR_8)]: (0, $7SCny.DARK_PURPLE),
    [(0, $7SCny.AGILE_COLOR_9)]: (0, $7SCny.ORANGE),
    [(0, $7SCny.AGILE_COLOR_10)]: (0, $7SCny.BLUE),
    [(0, $7SCny.AGILE_COLOR_11)]: (0, $7SCny.TEAL),
    [(0, $7SCny.AGILE_COLOR_12)]: (0, $7SCny.GREY),
    [(0, $7SCny.AGILE_COLOR_13)]: (0, $7SCny.DARK_GREEN),
    [(0, $7SCny.AGILE_COLOR_14)]: (0, $7SCny.DARK_ORANGE)
};
const $3a4ee6f2b0ce40ab$export$db17671bf37971e7 = (0, (/*@__PURE__*/$parcel$interopDefault($ggSx2)))($3a4ee6f2b0ce40ab$export$994d3ffa39be04fd);
const $3a4ee6f2b0ce40ab$export$1fdd5a248b5f697c = {
    [(0, $7SCny.GHX_LABEL_1)]: (0, $7SCny.AGILE_COLOR_1),
    [(0, $7SCny.GHX_LABEL_2)]: (0, $7SCny.AGILE_COLOR_2),
    [(0, $7SCny.GHX_LABEL_3)]: (0, $7SCny.AGILE_COLOR_3),
    [(0, $7SCny.GHX_LABEL_4)]: (0, $7SCny.AGILE_COLOR_4),
    [(0, $7SCny.GHX_LABEL_5)]: (0, $7SCny.AGILE_COLOR_5),
    [(0, $7SCny.GHX_LABEL_6)]: (0, $7SCny.AGILE_COLOR_6),
    [(0, $7SCny.GHX_LABEL_7)]: (0, $7SCny.AGILE_COLOR_7),
    [(0, $7SCny.GHX_LABEL_8)]: (0, $7SCny.AGILE_COLOR_8),
    [(0, $7SCny.GHX_LABEL_9)]: (0, $7SCny.AGILE_COLOR_9),
    [(0, $7SCny.GHX_LABEL_10)]: (0, $7SCny.AGILE_COLOR_10),
    [(0, $7SCny.GHX_LABEL_11)]: (0, $7SCny.AGILE_COLOR_11),
    [(0, $7SCny.GHX_LABEL_12)]: (0, $7SCny.AGILE_COLOR_12),
    [(0, $7SCny.GHX_LABEL_13)]: (0, $7SCny.AGILE_COLOR_13),
    [(0, $7SCny.GHX_LABEL_14)]: (0, $7SCny.AGILE_COLOR_14)
};
const $3a4ee6f2b0ce40ab$export$82fc3b0b98905453 = {
    [(0, $7SCny.DARK_GREY)]: 'grey',
    [(0, $7SCny.DARK_YELLOW)]: 'yellow',
    [(0, $7SCny.YELLOW)]: 'yellowLight',
    [(0, $7SCny.DARK_BLUE)]: 'blue',
    [(0, $7SCny.DARK_TEAL)]: 'teal',
    [(0, $7SCny.GREEN)]: 'greenLight',
    [(0, $7SCny.PURPLE)]: 'purpleLight',
    [(0, $7SCny.DARK_PURPLE)]: 'purple',
    [(0, $7SCny.ORANGE)]: 'redLight',
    [(0, $7SCny.BLUE)]: 'blueLight',
    [(0, $7SCny.TEAL)]: 'tealLight',
    [(0, $7SCny.GREY)]: 'greyLight',
    [(0, $7SCny.DARK_GREEN)]: 'green',
    [(0, $7SCny.DARK_ORANGE)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$703aca53c431bb88 = {
    [(0, $7SCny.AGILE_COLOR_1)]: 'grey',
    [(0, $7SCny.AGILE_COLOR_2)]: 'yellow',
    [(0, $7SCny.AGILE_COLOR_3)]: 'yellowLight',
    [(0, $7SCny.AGILE_COLOR_4)]: 'blue',
    [(0, $7SCny.AGILE_COLOR_5)]: 'teal',
    [(0, $7SCny.AGILE_COLOR_6)]: 'greenLight',
    [(0, $7SCny.AGILE_COLOR_7)]: 'purpleLight',
    [(0, $7SCny.AGILE_COLOR_8)]: 'purple',
    [(0, $7SCny.AGILE_COLOR_9)]: 'redLight',
    [(0, $7SCny.AGILE_COLOR_10)]: 'blueLight',
    [(0, $7SCny.AGILE_COLOR_11)]: 'tealLight',
    [(0, $7SCny.AGILE_COLOR_12)]: 'greyLight',
    [(0, $7SCny.AGILE_COLOR_13)]: 'green',
    [(0, $7SCny.AGILE_COLOR_14)]: 'red'
};
const $3a4ee6f2b0ce40ab$export$92b6aebfb522f0d9 = {
    [(0, $7SCny.PURPLE)]: {
        primary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        secondary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        text: "var(--ds-text-accent-purple, #5E4DB2)",
        textBackground: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.BLUE)]: {
        primary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        secondary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        text: "var(--ds-text-accent-blue, #0055CC)",
        textBackground: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREEN)]: {
        primary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        secondary: "var(--ds-background-accent-green-bolder, #1F845A)",
        text: "var(--ds-text-accent-green, #216E4E)",
        textBackground: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtler, #BAF3DB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.TEAL)]: {
        primary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        secondary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        text: "var(--ds-text-accent-teal, #206A83)",
        textBackground: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.YELLOW)]: {
        primary: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
        secondary: "var(--ds-background-accent-yellow-bolder, #946F00)",
        text: "var(--ds-text-accent-yellow, #7F5F01)",
        textBackground: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        border: "var(--ds-border-accent-yellow, #B38600)",
        line: "var(--ds-border-accent-yellow, #B38600)",
        primaryGradient: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.ORANGE)]: {
        primary: "var(--ds-background-accent-red-subtle, #F87168)",
        secondary: "var(--ds-background-accent-red-bolder, #C9372C)",
        text: "var(--ds-text-accent-red, #AE2E24)",
        textBackground: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        border: "var(--ds-border-accent-red, #E2483D)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtler, #FFD5D2)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.GREY)]: {
        primary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        secondary: "var(--ds-background-accent-gray-bolder, #626F86)",
        text: "var(--ds-text-accent-gray, #44546F)",
        textBackground: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        border: "var(--ds-border-accent-gray, #758195)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
        hasContrastSecondaryGradient: true
    },
    [(0, $7SCny.DARK_PURPLE)]: {
        primary: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        secondary: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-purple-bolder, #6E5DC6)",
        border: "var(--ds-border-accent-purple, #8270DB)",
        line: "var(--ds-border-accent-purple, #8270DB)",
        primaryGradient: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_BLUE)]: {
        primary: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        secondary: "var(--ds-background-accent-blue-subtle, #579DFF)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-blue-bolder, #0C66E4)",
        border: "var(--ds-border-accent-blue, #1D7AFC)",
        line: "var(--ds-border-accent-blue, #1D7AFC)",
        primaryGradient: "var(--ds-background-accent-blue-subtle, #579DFF)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREEN)]: {
        primary: "var(--ds-background-accent-green-bolder, #1F845A)",
        secondary: "var(--ds-background-accent-green-subtle, #4BCE97)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-green-bolder, #1F845A)",
        border: "var(--ds-border-accent-green, #22A06B)",
        line: "var(--ds-border-accent-green, #22A06B)",
        primaryGradient: "var(--ds-background-accent-green-subtle, #4BCE97)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_TEAL)]: {
        primary: "var(--ds-background-accent-teal-bolder, #227D9B)",
        secondary: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-teal-bolder, #227D9B)",
        border: "var(--ds-border-accent-teal, #2898BD)",
        line: "var(--ds-border-accent-teal, #2898BD)",
        primaryGradient: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_YELLOW)]: {
        primary: "var(--ds-background-accent-orange-bolder, #C25100)",
        secondary: "var(--ds-background-accent-orange-subtle, #FEA362)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-orange-bolder, #C25100)",
        border: "var(--ds-background-accent-orange-subtle, #FEA362)",
        line: "var(--ds-border-accent-orange, #E56910)",
        primaryGradient: "var(--ds-background-accent-orange-subtle, #FEA362)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_ORANGE)]: {
        primary: "var(--ds-background-accent-red-bolder, #C9372C)",
        secondary: "var(--ds-background-accent-red-subtle, #F87168)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-red-bolder, #C9372C)",
        border: "var(--ds-background-accent-red-subtle, #F87168)",
        line: "var(--ds-border-accent-red, #E2483D)",
        primaryGradient: "var(--ds-background-accent-red-subtle, #F87168)",
        hasContrastSecondaryGradient: false
    },
    [(0, $7SCny.DARK_GREY)]: {
        primary: "var(--ds-background-accent-gray-bolder, #626F86)",
        secondary: "var(--ds-background-accent-gray-subtle, #8590A2)",
        text: "var(--ds-text-inverse, #FFFFFF)",
        textBackground: "var(--ds-background-accent-gray-bolder, #626F86)",
        border: "var(--ds-background-accent-gray-subtle, #8590A2)",
        line: "var(--ds-border-accent-gray, #758195)",
        primaryGradient: "var(--ds-background-accent-gray-subtle, #8590A2)",
        hasContrastSecondaryGradient: false
    }
};

});
var $829f609a65d26a98$exports = {};

$parcel$export($829f609a65d26a98$exports, "R50", () => $829f609a65d26a98$export$4b84fd0e2c617bd);
$parcel$export($829f609a65d26a98$exports, "R75", () => $829f609a65d26a98$export$b34b069eff244586);
$parcel$export($829f609a65d26a98$exports, "R100", () => $829f609a65d26a98$export$be802dd0d8b57f35);
$parcel$export($829f609a65d26a98$exports, "R200", () => $829f609a65d26a98$export$60847d42f9da92a6);
$parcel$export($829f609a65d26a98$exports, "R300", () => $829f609a65d26a98$export$4a7404f376229999);
$parcel$export($829f609a65d26a98$exports, "R400", () => $829f609a65d26a98$export$2010d0fb4295b346);
$parcel$export($829f609a65d26a98$exports, "R500", () => $829f609a65d26a98$export$2837b5a1a71d5c02);
$parcel$export($829f609a65d26a98$exports, "Y50", () => $829f609a65d26a98$export$8d9596b529bbb9cf);
$parcel$export($829f609a65d26a98$exports, "Y75", () => $829f609a65d26a98$export$41060a744ab0b7ae);
$parcel$export($829f609a65d26a98$exports, "Y100", () => $829f609a65d26a98$export$1cc05bbbf340e559);
$parcel$export($829f609a65d26a98$exports, "Y200", () => $829f609a65d26a98$export$5aae31392d72caaa);
$parcel$export($829f609a65d26a98$exports, "Y300", () => $829f609a65d26a98$export$c6930421db9fa514);
$parcel$export($829f609a65d26a98$exports, "Y400", () => $829f609a65d26a98$export$59619663aa6500fb);
$parcel$export($829f609a65d26a98$exports, "Y500", () => $829f609a65d26a98$export$874739ea9e379ab6);
$parcel$export($829f609a65d26a98$exports, "G50", () => $829f609a65d26a98$export$8a6341c32b6a3ee6);
$parcel$export($829f609a65d26a98$exports, "G75", () => $829f609a65d26a98$export$69a3bf21b9686c2b);
$parcel$export($829f609a65d26a98$exports, "G100", () => $829f609a65d26a98$export$afbce1382ec95f73);
$parcel$export($829f609a65d26a98$exports, "G200", () => $829f609a65d26a98$export$747d86715d4175de);
$parcel$export($829f609a65d26a98$exports, "G300", () => $829f609a65d26a98$export$940e1f69e873f202);
$parcel$export($829f609a65d26a98$exports, "G400", () => $829f609a65d26a98$export$a49394138f7b8e85);
$parcel$export($829f609a65d26a98$exports, "G500", () => $829f609a65d26a98$export$6fa04827ac68a4fb);
$parcel$export($829f609a65d26a98$exports, "B50", () => $829f609a65d26a98$export$226de0355ed012f8);
$parcel$export($829f609a65d26a98$exports, "B75", () => $829f609a65d26a98$export$8c13c2ee36917869);
$parcel$export($829f609a65d26a98$exports, "B100", () => $829f609a65d26a98$export$ecfc1dff386a3e7a);
$parcel$export($829f609a65d26a98$exports, "B200", () => $829f609a65d26a98$export$215b7063051591f1);
$parcel$export($829f609a65d26a98$exports, "B300", () => $829f609a65d26a98$export$e62e8919cca44969);
$parcel$export($829f609a65d26a98$exports, "B400", () => $829f609a65d26a98$export$b3de0ae08da2ce64);
$parcel$export($829f609a65d26a98$exports, "B500", () => $829f609a65d26a98$export$a6ee3d71bc067634);
$parcel$export($829f609a65d26a98$exports, "B600", () => $829f609a65d26a98$export$67f15409e87642a1);
$parcel$export($829f609a65d26a98$exports, "B700", () => $829f609a65d26a98$export$f0539dbc42dbb067);
$parcel$export($829f609a65d26a98$exports, "P50", () => $829f609a65d26a98$export$363e4475840015bb);
$parcel$export($829f609a65d26a98$exports, "P75", () => $829f609a65d26a98$export$4b0a4417ed59760f);
$parcel$export($829f609a65d26a98$exports, "P100", () => $829f609a65d26a98$export$6011520a64d9a187);
$parcel$export($829f609a65d26a98$exports, "P200", () => $829f609a65d26a98$export$a7175d4e9206bc80);
$parcel$export($829f609a65d26a98$exports, "P300", () => $829f609a65d26a98$export$b48405b95304b5a1);
$parcel$export($829f609a65d26a98$exports, "P400", () => $829f609a65d26a98$export$c71e4279dd54a18d);
$parcel$export($829f609a65d26a98$exports, "P500", () => $829f609a65d26a98$export$147899de772240ec);
$parcel$export($829f609a65d26a98$exports, "T50", () => $829f609a65d26a98$export$2cf711fe14c66f06);
$parcel$export($829f609a65d26a98$exports, "T75", () => $829f609a65d26a98$export$7a8f4d33f6f9772c);
$parcel$export($829f609a65d26a98$exports, "T100", () => $829f609a65d26a98$export$776c9c497ef08533);
$parcel$export($829f609a65d26a98$exports, "T200", () => $829f609a65d26a98$export$69cb3ca10c1e330e);
$parcel$export($829f609a65d26a98$exports, "T300", () => $829f609a65d26a98$export$9dc1ef0f3f48059b);
$parcel$export($829f609a65d26a98$exports, "T400", () => $829f609a65d26a98$export$7c835c78b6fcdef8);
$parcel$export($829f609a65d26a98$exports, "T500", () => $829f609a65d26a98$export$6036577f95c3877e);
$parcel$export($829f609a65d26a98$exports, "N0", () => $829f609a65d26a98$export$29a4f05edc054374);
$parcel$export($829f609a65d26a98$exports, "N10", () => $829f609a65d26a98$export$e655ef011c4aa1a2);
$parcel$export($829f609a65d26a98$exports, "N20", () => $829f609a65d26a98$export$9fdfb749e33cdf97);
$parcel$export($829f609a65d26a98$exports, "N30", () => $829f609a65d26a98$export$3e51e8f1440314ba);
$parcel$export($829f609a65d26a98$exports, "N40", () => $829f609a65d26a98$export$1ce2d1575d444ceb);
$parcel$export($829f609a65d26a98$exports, "N50", () => $829f609a65d26a98$export$8754fc7e6d8b3000);
$parcel$export($829f609a65d26a98$exports, "N60", () => $829f609a65d26a98$export$c2e91cbeada39b8b);
$parcel$export($829f609a65d26a98$exports, "N70", () => $829f609a65d26a98$export$5f71e19f3a7ad9de);
$parcel$export($829f609a65d26a98$exports, "N80", () => $829f609a65d26a98$export$eaa8c8a70ac22806);
$parcel$export($829f609a65d26a98$exports, "N90", () => $829f609a65d26a98$export$7c87d337fb91a97d);
$parcel$export($829f609a65d26a98$exports, "N100", () => $829f609a65d26a98$export$d6447c357493214f);
$parcel$export($829f609a65d26a98$exports, "N200", () => $829f609a65d26a98$export$f563ee71e9ee74cd);
$parcel$export($829f609a65d26a98$exports, "N300", () => $829f609a65d26a98$export$e2ef2124cf4024b1);
$parcel$export($829f609a65d26a98$exports, "N400", () => $829f609a65d26a98$export$eece5f492e429f08);
$parcel$export($829f609a65d26a98$exports, "N500", () => $829f609a65d26a98$export$c39c0fe0f26207ae);
$parcel$export($829f609a65d26a98$exports, "N600", () => $829f609a65d26a98$export$7090862dc3038a9f);
$parcel$export($829f609a65d26a98$exports, "N700", () => $829f609a65d26a98$export$ad0bacf983b7ddaa);
$parcel$export($829f609a65d26a98$exports, "N800", () => $829f609a65d26a98$export$7d61b15e0da132af);
$parcel$export($829f609a65d26a98$exports, "N900", () => $829f609a65d26a98$export$fbda843f0a27fe96);
$parcel$export($829f609a65d26a98$exports, "N10A", () => $829f609a65d26a98$export$791e57b27ca738ef);
$parcel$export($829f609a65d26a98$exports, "N20A", () => $829f609a65d26a98$export$8d43898f60b96a82);
$parcel$export($829f609a65d26a98$exports, "N30A", () => $829f609a65d26a98$export$920c0d5c49070351);
$parcel$export($829f609a65d26a98$exports, "N40A", () => $829f609a65d26a98$export$46987b49aab6d1a8);
$parcel$export($829f609a65d26a98$exports, "N50A", () => $829f609a65d26a98$export$7d3359664e8bb0e5);
$parcel$export($829f609a65d26a98$exports, "N60A", () => $829f609a65d26a98$export$d2d3bedfb276cac0);
$parcel$export($829f609a65d26a98$exports, "N70A", () => $829f609a65d26a98$export$6e5e7499ff054f6d);
$parcel$export($829f609a65d26a98$exports, "N80A", () => $829f609a65d26a98$export$59264b346c877fa7);
$parcel$export($829f609a65d26a98$exports, "N90A", () => $829f609a65d26a98$export$d092757d7c64925c);
$parcel$export($829f609a65d26a98$exports, "N100A", () => $829f609a65d26a98$export$486ab785e4bac3c6);
$parcel$export($829f609a65d26a98$exports, "N200A", () => $829f609a65d26a98$export$fba592bbc6419fea);
$parcel$export($829f609a65d26a98$exports, "N300A", () => $829f609a65d26a98$export$13609db0e6812ab8);
$parcel$export($829f609a65d26a98$exports, "N400A", () => $829f609a65d26a98$export$fbae4efaa892d883);
$parcel$export($829f609a65d26a98$exports, "N500A", () => $829f609a65d26a98$export$f13946d26f440ce6);
$parcel$export($829f609a65d26a98$exports, "N600A", () => $829f609a65d26a98$export$19f58225ac52a306);
$parcel$export($829f609a65d26a98$exports, "N700A", () => $829f609a65d26a98$export$6384f09da70e7b62);
$parcel$export($829f609a65d26a98$exports, "N800A", () => $829f609a65d26a98$export$d0dccc730683edc2);
$parcel$export($829f609a65d26a98$exports, "DN900", () => $829f609a65d26a98$export$2f6319cf7d736c2a);
$parcel$export($829f609a65d26a98$exports, "DN800", () => $829f609a65d26a98$export$95126bc8884d6634);
$parcel$export($829f609a65d26a98$exports, "DN700", () => $829f609a65d26a98$export$8338d8c35d44ff1);
$parcel$export($829f609a65d26a98$exports, "DN600", () => $829f609a65d26a98$export$5368d76ae4fbbda7);
$parcel$export($829f609a65d26a98$exports, "DN500", () => $829f609a65d26a98$export$9f0a771d16ec8d36);
$parcel$export($829f609a65d26a98$exports, "DN400", () => $829f609a65d26a98$export$abcf8c38338b4aa5);
$parcel$export($829f609a65d26a98$exports, "DN300", () => $829f609a65d26a98$export$97e81faa16a182c7);
$parcel$export($829f609a65d26a98$exports, "DN200", () => $829f609a65d26a98$export$bfe21c59123ecf33);
$parcel$export($829f609a65d26a98$exports, "DN100", () => $829f609a65d26a98$export$ee82aa2ea6a1558);
$parcel$export($829f609a65d26a98$exports, "DN90", () => $829f609a65d26a98$export$682927c6ed76be02);
$parcel$export($829f609a65d26a98$exports, "DN80", () => $829f609a65d26a98$export$91fd9994c5be9757);
$parcel$export($829f609a65d26a98$exports, "DN70", () => $829f609a65d26a98$export$d281fbfe3cff2df6);
$parcel$export($829f609a65d26a98$exports, "DN60", () => $829f609a65d26a98$export$3902c91d8b98a753);
$parcel$export($829f609a65d26a98$exports, "DN50", () => $829f609a65d26a98$export$8e8133c1ba5845b5);
$parcel$export($829f609a65d26a98$exports, "DN40", () => $829f609a65d26a98$export$33ff357f6620b39);
$parcel$export($829f609a65d26a98$exports, "DN30", () => $829f609a65d26a98$export$633847cf062b69e0);
$parcel$export($829f609a65d26a98$exports, "DN20", () => $829f609a65d26a98$export$9776a6e503bdbf76);
$parcel$export($829f609a65d26a98$exports, "DN10", () => $829f609a65d26a98$export$6c813d5160dff5db);
$parcel$export($829f609a65d26a98$exports, "DN0", () => $829f609a65d26a98$export$3d4f271a500072a);
$parcel$export($829f609a65d26a98$exports, "DN800A", () => $829f609a65d26a98$export$fe151285c22759ec);
$parcel$export($829f609a65d26a98$exports, "DN700A", () => $829f609a65d26a98$export$a101c6190d0da34);
$parcel$export($829f609a65d26a98$exports, "DN600A", () => $829f609a65d26a98$export$4b16f52932fda51);
$parcel$export($829f609a65d26a98$exports, "DN500A", () => $829f609a65d26a98$export$a74bcd7b9845b0d8);
$parcel$export($829f609a65d26a98$exports, "DN400A", () => $829f609a65d26a98$export$9209c179316d1751);
$parcel$export($829f609a65d26a98$exports, "DN300A", () => $829f609a65d26a98$export$88f55133f636c8dd);
$parcel$export($829f609a65d26a98$exports, "DN200A", () => $829f609a65d26a98$export$51126f85d1009512);
$parcel$export($829f609a65d26a98$exports, "DN100A", () => $829f609a65d26a98$export$a069b547bd23af78);
$parcel$export($829f609a65d26a98$exports, "DN90A", () => $829f609a65d26a98$export$40cce05af3b2600a);
$parcel$export($829f609a65d26a98$exports, "DN80A", () => $829f609a65d26a98$export$b78942185925a0d);
$parcel$export($829f609a65d26a98$exports, "DN70A", () => $829f609a65d26a98$export$e058fb44b8eaafca);
$parcel$export($829f609a65d26a98$exports, "DN60A", () => $829f609a65d26a98$export$92b0b8de26920c18);
$parcel$export($829f609a65d26a98$exports, "DN50A", () => $829f609a65d26a98$export$67564f7459d3fc9e);
$parcel$export($829f609a65d26a98$exports, "DN40A", () => $829f609a65d26a98$export$77868e1ca884ffa3);
$parcel$export($829f609a65d26a98$exports, "DN30A", () => $829f609a65d26a98$export$2afd71d7d3ea2cd5);
$parcel$export($829f609a65d26a98$exports, "DN20A", () => $829f609a65d26a98$export$f2a0acaab9972c70);
$parcel$export($829f609a65d26a98$exports, "DN10A", () => $829f609a65d26a98$export$9ab70e67d6475361);
$parcel$export($829f609a65d26a98$exports, "T30", () => $829f609a65d26a98$export$d2adc5dedf09fced);
$parcel$export($829f609a65d26a98$exports, "L50", () => $829f609a65d26a98$export$f51762073d2bb381);
$parcel$export($829f609a65d26a98$exports, "L75", () => $829f609a65d26a98$export$95e26d54def96891);
// Reds
const $829f609a65d26a98$export$4b84fd0e2c617bd = '#FFEBE6';
const $829f609a65d26a98$export$b34b069eff244586 = '#FFBDAD';
const $829f609a65d26a98$export$be802dd0d8b57f35 = '#FF8F73';
const $829f609a65d26a98$export$60847d42f9da92a6 = '#FF7452';
const $829f609a65d26a98$export$4a7404f376229999 = '#FF5630';
const $829f609a65d26a98$export$2010d0fb4295b346 = '#DE350B';
const $829f609a65d26a98$export$2837b5a1a71d5c02 = '#BF2600';
const $829f609a65d26a98$export$8d9596b529bbb9cf = '#FFFAE6';
const $829f609a65d26a98$export$41060a744ab0b7ae = '#FFF0B3';
const $829f609a65d26a98$export$1cc05bbbf340e559 = '#FFE380';
const $829f609a65d26a98$export$5aae31392d72caaa = '#FFC400';
const $829f609a65d26a98$export$c6930421db9fa514 = '#FFAB00';
const $829f609a65d26a98$export$59619663aa6500fb = '#FF991F';
const $829f609a65d26a98$export$874739ea9e379ab6 = '#FF8B00';
const $829f609a65d26a98$export$8a6341c32b6a3ee6 = '#E3FCEF';
const $829f609a65d26a98$export$69a3bf21b9686c2b = '#ABF5D1';
const $829f609a65d26a98$export$afbce1382ec95f73 = '#79F2C0';
const $829f609a65d26a98$export$747d86715d4175de = '#57D9A3';
const $829f609a65d26a98$export$940e1f69e873f202 = '#36B37E';
const $829f609a65d26a98$export$a49394138f7b8e85 = '#00875A';
const $829f609a65d26a98$export$6fa04827ac68a4fb = '#006644';
const $829f609a65d26a98$export$226de0355ed012f8 = '#DEEBFF';
const $829f609a65d26a98$export$8c13c2ee36917869 = '#B3D4FF';
const $829f609a65d26a98$export$ecfc1dff386a3e7a = '#4C9AFF';
const $829f609a65d26a98$export$215b7063051591f1 = '#2684FF';
const $829f609a65d26a98$export$e62e8919cca44969 = '#0065FF';
const $829f609a65d26a98$export$b3de0ae08da2ce64 = '#0052CC';
const $829f609a65d26a98$export$a6ee3d71bc067634 = '#0747A6';
const $829f609a65d26a98$export$67f15409e87642a1 = '#669DF1';
const $829f609a65d26a98$export$f0539dbc42dbb067 = '#8FB8F6';
const $829f609a65d26a98$export$363e4475840015bb = '#EAE6FF';
const $829f609a65d26a98$export$4b0a4417ed59760f = '#C0B6F2';
const $829f609a65d26a98$export$6011520a64d9a187 = '#998DD9';
const $829f609a65d26a98$export$a7175d4e9206bc80 = '#8777D9';
const $829f609a65d26a98$export$b48405b95304b5a1 = '#6554C0';
const $829f609a65d26a98$export$c71e4279dd54a18d = '#5243AA';
const $829f609a65d26a98$export$147899de772240ec = '#403294';
const $829f609a65d26a98$export$2cf711fe14c66f06 = '#E6FCFF';
const $829f609a65d26a98$export$7a8f4d33f6f9772c = '#B3F5FF';
const $829f609a65d26a98$export$776c9c497ef08533 = '#79E2F2';
const $829f609a65d26a98$export$69cb3ca10c1e330e = '#00C7E6';
const $829f609a65d26a98$export$9dc1ef0f3f48059b = '#00B8D9';
const $829f609a65d26a98$export$7c835c78b6fcdef8 = '#00A3BF';
const $829f609a65d26a98$export$6036577f95c3877e = '#008DA6';
const $829f609a65d26a98$export$29a4f05edc054374 = '#FFFFFF';
const $829f609a65d26a98$export$e655ef011c4aa1a2 = '#FAFBFC';
const $829f609a65d26a98$export$9fdfb749e33cdf97 = '#F4F5F7';
const $829f609a65d26a98$export$3e51e8f1440314ba = '#EBECF0';
const $829f609a65d26a98$export$1ce2d1575d444ceb = '#DFE1E6';
const $829f609a65d26a98$export$8754fc7e6d8b3000 = '#C1C7D0';
const $829f609a65d26a98$export$c2e91cbeada39b8b = '#B3BAC5';
const $829f609a65d26a98$export$5f71e19f3a7ad9de = '#A5ADBA';
const $829f609a65d26a98$export$eaa8c8a70ac22806 = '#97A0AF';
const $829f609a65d26a98$export$7c87d337fb91a97d = '#8993A4';
const $829f609a65d26a98$export$d6447c357493214f = '#7A869A';
const $829f609a65d26a98$export$f563ee71e9ee74cd = '#6B778C';
const $829f609a65d26a98$export$e2ef2124cf4024b1 = '#5E6C84';
const $829f609a65d26a98$export$eece5f492e429f08 = '#505F79';
const $829f609a65d26a98$export$c39c0fe0f26207ae = '#42526E';
const $829f609a65d26a98$export$7090862dc3038a9f = '#344563';
const $829f609a65d26a98$export$ad0bacf983b7ddaa = '#253858';
const $829f609a65d26a98$export$7d61b15e0da132af = '#172B4D';
const $829f609a65d26a98$export$fbda843f0a27fe96 = '#091E42';
const $829f609a65d26a98$export$791e57b27ca738ef = 'rgba(9, 30, 66, 0.02)';
const $829f609a65d26a98$export$8d43898f60b96a82 = 'rgba(9, 30, 66, 0.04)';
const $829f609a65d26a98$export$920c0d5c49070351 = 'rgba(9, 30, 66, 0.08)';
const $829f609a65d26a98$export$46987b49aab6d1a8 = 'rgba(9, 30, 66, 0.13)';
const $829f609a65d26a98$export$7d3359664e8bb0e5 = 'rgba(9, 30, 66, 0.25)';
const $829f609a65d26a98$export$d2d3bedfb276cac0 = 'rgba(9, 30, 66, 0.31)';
const $829f609a65d26a98$export$6e5e7499ff054f6d = 'rgba(9, 30, 66, 0.36)';
const $829f609a65d26a98$export$59264b346c877fa7 = 'rgba(9, 30, 66, 0.42)';
const $829f609a65d26a98$export$d092757d7c64925c = 'rgba(9, 30, 66, 0.48)';
const $829f609a65d26a98$export$486ab785e4bac3c6 = 'rgba(9, 30, 66, 0.54)';
const $829f609a65d26a98$export$fba592bbc6419fea = 'rgba(9, 30, 66, 0.60)';
const $829f609a65d26a98$export$13609db0e6812ab8 = 'rgba(9, 30, 66, 0.66)';
const $829f609a65d26a98$export$fbae4efaa892d883 = 'rgba(9, 30, 66, 0.71)';
const $829f609a65d26a98$export$f13946d26f440ce6 = 'rgba(9, 30, 66, 0.77)';
const $829f609a65d26a98$export$19f58225ac52a306 = 'rgba(9, 30, 66, 0.82)';
const $829f609a65d26a98$export$6384f09da70e7b62 = 'rgba(9, 30, 66, 0.89)';
const $829f609a65d26a98$export$d0dccc730683edc2 = 'rgba(9, 30, 66, 0.95)';
const $829f609a65d26a98$export$2f6319cf7d736c2a = '#E6EDFA';
const $829f609a65d26a98$export$95126bc8884d6634 = '#DCE5F5';
const $829f609a65d26a98$export$8338d8c35d44ff1 = '#CED9EB';
const $829f609a65d26a98$export$5368d76ae4fbbda7 = '#B8C7E0';
const $829f609a65d26a98$export$9f0a771d16ec8d36 = '#ABBBD6';
const $829f609a65d26a98$export$abcf8c38338b4aa5 = '#9FB0CC';
const $829f609a65d26a98$export$97e81faa16a182c7 = '#8C9CB8';
const $829f609a65d26a98$export$bfe21c59123ecf33 = '#7988A3';
const $829f609a65d26a98$export$ee82aa2ea6a1558 = '#67758F';
const $829f609a65d26a98$export$682927c6ed76be02 = '#56637A';
const $829f609a65d26a98$export$91fd9994c5be9757 = '#455166';
const $829f609a65d26a98$export$d281fbfe3cff2df6 = '#3B475C';
const $829f609a65d26a98$export$3902c91d8b98a753 = '#313D52';
const $829f609a65d26a98$export$8e8133c1ba5845b5 = '#283447';
const $829f609a65d26a98$export$33ff357f6620b39 = '#202B3D';
const $829f609a65d26a98$export$633847cf062b69e0 = '#1B2638';
const $829f609a65d26a98$export$9776a6e503bdbf76 = '#121A29';
const $829f609a65d26a98$export$6c813d5160dff5db = '#0E1624';
const $829f609a65d26a98$export$3d4f271a500072a = '#0D1424';
const $829f609a65d26a98$export$fe151285c22759ec = 'rgba(13, 20, 36, 0.06)';
const $829f609a65d26a98$export$a101c6190d0da34 = 'rgba(13, 20, 36, 0.14)';
const $829f609a65d26a98$export$4b16f52932fda51 = 'rgba(13, 20, 36, 0.18)';
const $829f609a65d26a98$export$a74bcd7b9845b0d8 = 'rgba(13, 20, 36, 0.29)';
const $829f609a65d26a98$export$9209c179316d1751 = 'rgba(13, 20, 36, 0.36)';
const $829f609a65d26a98$export$88f55133f636c8dd = 'rgba(13, 20, 36, 0.40)';
const $829f609a65d26a98$export$51126f85d1009512 = 'rgba(13, 20, 36, 0.47)';
const $829f609a65d26a98$export$a069b547bd23af78 = 'rgba(13, 20, 36, 0.53)';
const $829f609a65d26a98$export$40cce05af3b2600a = 'rgba(13, 20, 36, 0.63)';
const $829f609a65d26a98$export$b78942185925a0d = 'rgba(13, 20, 36, 0.73)';
const $829f609a65d26a98$export$e058fb44b8eaafca = 'rgba(13, 20, 36, 0.78)';
const $829f609a65d26a98$export$92b0b8de26920c18 = 'rgba(13, 20, 36, 0.81)';
const $829f609a65d26a98$export$67564f7459d3fc9e = 'rgba(13, 20, 36, 0.85)';
const $829f609a65d26a98$export$77868e1ca884ffa3 = 'rgba(13, 20, 36, 0.89)';
const $829f609a65d26a98$export$2afd71d7d3ea2cd5 = 'rgba(13, 20, 36, 0.92)';
const $829f609a65d26a98$export$f2a0acaab9972c70 = 'rgba(13, 20, 36, 0.95)';
const $829f609a65d26a98$export$9ab70e67d6475361 = 'rgba(13, 20, 36, 0.97)';
const $829f609a65d26a98$export$d2adc5dedf09fced = '#292A2E';
const $829f609a65d26a98$export$f51762073d2bb381 = '#94C748';
const $829f609a65d26a98$export$95e26d54def96891 = '#B3DF72';


parcelRegister("ehxiD", function(module, exports) {

$parcel$export(module.exports, "default", () => $50b7e3d933c7b9f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50b7e3d933c7b9f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    purpleLabel: {
        "id": "issue-epic-color.common.purple-label",
        "defaultMessage": "purple"
    },
    blueLabel: {
        "id": "issue-epic-color.common.blue-label",
        "defaultMessage": "blue"
    },
    greenLabel: {
        "id": "issue-epic-color.common.green-label",
        "defaultMessage": "green"
    },
    tealLabel: {
        "id": "issue-epic-color.common.teal-label",
        "defaultMessage": "teal"
    },
    yellowLabel: {
        "id": "issue-epic-color.common.yellow-label",
        "defaultMessage": "yellow"
    },
    orangeLabel: {
        "id": "issue-epic-color.common.orange-label",
        "defaultMessage": "orange"
    },
    greyLabel: {
        "id": "issue-epic-color.common.grey-label",
        "defaultMessage": "grey"
    },
    darkPurpleLabel: {
        "id": "issue-epic-color.common.dark-purple-label",
        "defaultMessage": "dark purple"
    },
    darkBlueLabel: {
        "id": "issue-epic-color.common.dark-blue-label",
        "defaultMessage": "dark blue"
    },
    darkGreenLabel: {
        "id": "issue-epic-color.common.dark-green-label",
        "defaultMessage": "dark green"
    },
    darkTealLabel: {
        "id": "issue-epic-color.common.dark-teal-label",
        "defaultMessage": "dark teal"
    },
    darkYellowLabel: {
        "id": "issue-epic-color.common.dark-yellow-label",
        "defaultMessage": "dark yellow"
    },
    darkOrangeLabel: {
        "id": "issue-epic-color.common.dark-orange-label",
        "defaultMessage": "dark orange"
    },
    darkGreyLabel: {
        "id": "issue-epic-color.common.dark-grey-label",
        "defaultMessage": "dark grey"
    }
});

});


parcelRegister("tZ4NF", function(module, exports) {

$parcel$export(module.exports, "fetchOptionsForCustomFields", () => $90d1bb8f1e1e143e$export$68400c67f26ee713);

var $487fd = parcelRequire("487fd");
const $90d1bb8f1e1e143e$export$68400c67f26ee713 = ({ projectId: projectId, issueTypeId: issueTypeId, customFieldId: customFieldId })=>(0, $487fd.default)('/rest/jpo/1.0/customfield/getSettableOptions', {
        method: 'POST',
        body: JSON.stringify({
            customFieldId: customFieldId,
            issueTypeId: issueTypeId,
            projectId: projectId
        })
    });

});

parcelRegister("kgiLc", function(module, exports) {

$parcel$export(module.exports, "transformDateValue", () => $06446ad58bef335e$export$baa3b72fc17cd5bb);
$parcel$export(module.exports, "transformDateRangeUpdateValues", () => $06446ad58bef335e$export$93f7fa7e723c5db9);
$parcel$export(module.exports, "wrapActionWithPromise", () => $06446ad58bef335e$export$d933127b5630afb0);

var $hGgHi = parcelRequire("hGgHi");

var $1QDGC = parcelRequire("1QDGC");
const $06446ad58bef335e$export$baa3b72fc17cd5bb = (value)=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) || value === 0 ? null : value;
const $06446ad58bef335e$export$93f7fa7e723c5db9 = (incrementConfig, startDate, endDate)=>{
    let dateFields = {};
    if (startDate !== undefined) {
        const startDateValue = {
            [incrementConfig.startDateField.key]: startDate
        };
        if (incrementConfig.startDateField.type === (0, $1QDGC.FieldType).Custom) dateFields.customFields = startDateValue;
        else dateFields = startDateValue;
    }
    const endDateValue = {
        [incrementConfig.endDateField.key]: endDate
    };
    if (incrementConfig.endDateField.type === (0, $1QDGC.FieldType).Custom) {
        if (dateFields.customFields) dateFields.customFields = {
            ...dateFields.customFields,
            ...endDateValue
        };
        else dateFields.customFields = endDateValue;
    } else dateFields = {
        ...dateFields,
        ...endDateValue
    };
    return dateFields;
};
const $06446ad58bef335e$export$d933127b5630afb0 = (dispatch, action)=>{
    const promise = new Promise((resolve, reject)=>{
        dispatch({
            ...action,
            promise: {
                resolve: resolve,
                reject: reject
            }
        });
    });
    return promise;
};

});
parcelRegister("1QDGC", function(module, exports) {

$parcel$export(module.exports, "FieldType", () => $cc6f4fa8362b8e89$export$ed12481c953b8653);
const $cc6f4fa8362b8e89$export$ed12481c953b8653 = {
    BuiltIn: 'BuiltIn',
    Custom: 'Custom'
};

});



parcelRegister("fTVet", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c2f1692294fadd4$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $4R6GH = parcelRequire("4R6GH");

var $3bjR0 = parcelRequire("3bjR0");

var $gXFr2 = parcelRequire("gXFr2");

var $9UXXB = parcelRequire("9UXXB");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
const $0c2f1692294fadd4$export$6b468dcfb64c653c = (state, response, optimisticIssues, transitionInfo)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(response.boardCardCreate)) return [];
    return response?.boardCardCreate?.newCards?.filter((card)=>card != null)?.map((card, index)=>{
        const { id: id, issue: { key: key } } = card;
        const { summary: summary, statusId: statusId, columnId: columnId, projectId: projectId, typeId: typeId, isDone: isDone, parentId: parentId, estimate: estimate, priority: priority, dueDate: dueDate, numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren, assigneeAccountId: assigneeAccountId, labels: labels, sprintId: sprintId, fixVersions: fixVersions } = optimisticIssues[index];
        const { name: typeName, iconUrl: typeUrl } = (0, $d2i8f.getIssueTypeById)(state, typeId);
        return {
            id: Number(id),
            key: String(key),
            summary: summary,
            statusId: transitionInfo ? transitionInfo.statusId : statusId,
            columnId: columnId,
            projectId: projectId,
            typeId: typeId,
            typeName: typeName,
            typeUrl: typeUrl,
            assigneeAccountId: assigneeAccountId,
            labels: labels,
            isDone: isDone,
            parentId: parentId,
            estimate: estimate,
            priority: priority,
            dueDate: dueDate,
            numCompleteChildren: numCompleteChildren,
            numTotalChildren: numTotalChildren,
            sprintId: sprintId,
            fixVersions: fixVersions
        };
    }) ?? [];
};
const $0c2f1692294fadd4$export$66141e785ca0d76 = (optimisticIssues)=>optimisticIssues.map((issue)=>{
        const { assigneeAccountId: assigneeAccountId, typeId: typeId, labels: labels, parentId: parentId, summary: summary, fixVersions: fixVersions, dueDate: dueDate } = issue;
        const fixVersionsMapped = fixVersions ? fixVersions.map((id)=>String(id)) : [];
        return {
            assigneeId: assigneeAccountId != null ? String(assigneeAccountId) : null,
            fixVersions: fixVersionsMapped,
            issueTypeId: typeId != null ? String(typeId) : '',
            labels: labels,
            parentId: parentId != null ? String(parentId) : null,
            summary: summary,
            dueDate: dueDate ? new Date(dueDate).toISOString() : null
        };
    });
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0c2f1692294fadd4$export$2e2bcd8739ae039 = (state, rankBeforeCardId = null, optimisticIssues, transitionInfo, swimlaneId)=>{
    const transitionInfoForNewIssues = transitionInfo || ((0, $4R6GH.fg)('use_backend_tmp_icc_config_') ? (0, $gXFr2.transitionIDForCardCreateSelectorNew)(state)(optimisticIssues[0].columnId, optimisticIssues[0].typeId) : (0, $gXFr2.transitionIDForCardCreateSelector)(state)(optimisticIssues[0].columnId, optimisticIssues[0].typeId));
    const { sprintId: sprintId = '' } = optimisticIssues?.[0] ?? {};
    const isCMP = (0, $4R6GH.fg)('jira_board_card_create_include_iscmp') ? (0, $67Z81.getIsCMPBoard)(state) : null;
    return (0, $3bjR0.default)((0, $67Z81.contextPathSelector)(state), {
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        cardTransitionId: transitionInfoForNewIssues?.transitionId || null,
        rankBeforeCardId: rankBeforeCardId,
        newCards: $0c2f1692294fadd4$export$66141e785ca0d76(optimisticIssues),
        ...sprintId ? {
            destinationId: sprintId
        } : {},
        requireJqlContext: (0, $9UXXB.getIsCustomBoardWithIcc)(state),
        ...swimlaneId ? {
            swimlaneId: swimlaneId
        } : {},
        isCMP: isCMP
    }).flatMap((result)=>(0, $kVLXA.Observable).of($0c2f1692294fadd4$export$6b468dcfb64c653c(state, result, optimisticIssues, transitionInfoForNewIssues)));
};

});
parcelRegister("3bjR0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aab4220ed333b77$export$2e2bcd8739ae039);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $0aab4220ed333b77$var$boardCardCreateOperationName = 'BoardCardCreate';
const $0aab4220ed333b77$export$86b8d46928cd7bbb = (0, $ivqh1.gqlTagSwag)`
mutation BoardCardCreate (
    $boardId: ID!,
    $cardTransitionId: ID,
    $rankBeforeCardId: Long,
    $newCards: [NewCard]!
    $destinationId: ID,
    $requireJqlContext: Boolean
	$swimlaneId: ID
	$isCMP: Boolean
) {
    boardCardCreate(input: {
        boardId: $boardId,
        cardTransitionId: $cardTransitionId,
        rankBeforeCardId: $rankBeforeCardId,
        newCards: $newCards
        destinationId: $destinationId
        requireJqlContext: $requireJqlContext
		swimlaneId: $swimlaneId

    }, isCMP: $isCMP) {
        newCards {
            id
            issue {
                key
            }
        }
    }
}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0aab4220ed333b77$export$2e2bcd8739ae039 = (baseUrl, input)=>{
    const { boardId: boardId, cardTransitionId: cardTransitionId, rankBeforeCardId: rankBeforeCardId, newCards: newCards, destinationId: destinationId, requireJqlContext: requireJqlContext, swimlaneId: swimlaneId, isCMP: isCMP } = input;
    const variables = {
        boardId: boardId,
        cardTransitionId: cardTransitionId,
        rankBeforeCardId: rankBeforeCardId,
        newCards: newCards,
        ...destinationId ? {
            destinationId: destinationId
        } : {},
        requireJqlContext: requireJqlContext,
        ...swimlaneId ? {
            swimlaneId: swimlaneId
        } : {},
        ...isCMP !== null ? {
            isCMP: isCMP
        } : {}
    };
    return (0, $6iJbJ.mutation$)(baseUrl, $0aab4220ed333b77$var$boardCardCreateOperationName, $0aab4220ed333b77$export$86b8d46928cd7bbb, variables, (0, $CFxE9.cardCreateAnalyticsOptions));
};

});

parcelRegister("gXFr2", function(module, exports) {

$parcel$export(module.exports, "allowedCardTypesForIccSelector", () => $8133e73592e62d8c$export$f22a16f57b3ae991);
$parcel$export(module.exports, "transitionIDForCardCreateSelector", () => $8133e73592e62d8c$export$9f36396280765a13);
$parcel$export(module.exports, "transitionIDForCardCreateSelectorNew", () => $8133e73592e62d8c$export$57f8a50673eeab03);
$parcel$export(module.exports, "getInitialTransitionsForColumn", () => $8133e73592e62d8c$export$41c8dd7cee50a968);
$parcel$export(module.exports, "makeGetStatusTransitionsForType", () => $8133e73592e62d8c$export$ec7e6959583c9985);
$parcel$export(module.exports, "manageIssueTypesLinkSelector", () => $8133e73592e62d8c$export$ddd0d47434cf9e05);
$parcel$export(module.exports, "getIssueProjectsForIssueCreation", () => $8133e73592e62d8c$export$2c1218071d6b5bb2);
$parcel$export(module.exports, "getDefaultProjectIdForIssueCreation", () => $8133e73592e62d8c$export$6b08fee64011acdb);
$parcel$export(module.exports, "getIssueTypesForIssueCreation", () => $8133e73592e62d8c$export$de67b2a86891c711);
$parcel$export(module.exports, "getParentIdForIssueCreation", () => $8133e73592e62d8c$export$8b1e452ee0e8eef0);
$parcel$export(module.exports, "getDestinationStatusSelector", () => $8133e73592e62d8c$export$26a46ce3707c0a02);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $vNXgH = parcelRequire("vNXgH");

var $2vSU6 = parcelRequire("2vSU6");

var $gULOk = parcelRequire("gULOk");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $g4tDr = parcelRequire("g4tDr");

var $02Psx = parcelRequire("02Psx");

var $eph8m = parcelRequire("eph8m");

var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $8133e73592e62d8c$export$f22a16f57b3ae991 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions),
    (0, $4gt6L.issueBaseTypesSelector),
    (0, $4gt6L.issueChildrenTypesSelector),
    (0, $5mTgl.getHasAppliedEpicFilters),
    (0, $9UXXB.createIsIccEnabledForCardType),
    (0, $67Z81.getIsCMPBoard),
    (0, $45cXl.getSwimlaneMode),
    (0, $5mTgl.getAppliedIssueTypeFilters)
], (cardTransitions, baseIssueTypes, issueChildrenIssueTypes, hasAppliedEpicFilters, isIccEnabledForCardType, isCMPBoard, swimlaneMode, issueTypeFilters)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId, swimlaneId, isAddingSubtaskToGroup)=>{
        let types = baseIssueTypes;
        let shouldFilterOutEpicIssueTypes = false;
        let shouldFilterOutChildIssueTypes = false;
        const isSubtaskSwimlane = swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && swimlaneId !== (0, $c79wa.ChildlessSwimlane).id && swimlaneId !== null;
        if (isSubtaskSwimlane || isAddingSubtaskToGroup) types = issueChildrenIssueTypes;
        else {
            shouldFilterOutEpicIssueTypes = hasAppliedEpicFilters || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id;
            shouldFilterOutChildIssueTypes = true;
        }
        return types.filter((issueType)=>{
            if (shouldFilterOutChildIssueTypes && issueType.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE)) return false;
            if (shouldFilterOutEpicIssueTypes && issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE)) return false;
            if (issueTypeFilters?.length && !issueTypeFilters.includes(issueType.id)) return false;
            // This is a temporary condition to fix a bug until use_backend_tmp_icc_config_ is rolled out
            // Delete this condition when cleaning up use_backend_tmp_icc_config_
            if (isCMPBoard) return isIccEnabledForCardType(columnId, issueType.id);
            return (0, $4R6GH.fg)('use_backend_tmp_icc_config_') ? isIccEnabledForCardType(columnId, issueType.id) : (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(cardTransitions, [
                'columnIssueTypeTransitions',
                columnId,
                issueType.id
            ], []).some((transition)=>transition.isInitial || transition.isGlobal);
        });
    }, (columnId, swimlaneId, isAddingSubtaskToGroup)=>`${columnId}:${swimlaneId || ''}${isAddingSubtaskToGroup ? ':subtask' : ''}}`));
const $8133e73592e62d8c$export$9f36396280765a13 = (0, $dGvGJ.createSelector)((0, $67Z81.getCardTransitions), (cardTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId, issueTypeId)=>{
        // check if there is an initial transition, if there is no need to pass anything
        const initialTransition = cardTransitions.columnIssueTypeTransitions[String(columnId)]?.[String(issueTypeId)]?.find((transition)=>transition.isInitial);
        if (initialTransition) return {
            transitionId: null,
            statusId: initialTransition.destinationStatusId
        };
        const globalTransition = cardTransitions.columnIssueTypeTransitions[String(columnId)]?.[String(issueTypeId)]?.find((transition)=>transition.isGlobal);
        if (globalTransition) return {
            transitionId: String(globalTransition.id),
            statusId: globalTransition.destinationStatusId
        };
        // this is an error state, card create is not possible without initial or global transition
        return null;
    }, (columnId, issueTypeId)=>`${columnId}:${issueTypeId}`));
const $8133e73592e62d8c$export$57f8a50673eeab03 = (0, $dGvGJ.createSelector)((0, $67Z81.getCardTransitions), (cardTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId, issueTypeId)=>{
        if (Object.values(cardTransitions.columnIssueTypeTransitions).every((issueTypeTransitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueTypeTransitions))) // User probably doesn't have transition permissions
        return null;
        const columnIssueTypeTransitions = cardTransitions.columnIssueTypeTransitions[String(columnId)];
        // check if there is an initial transition, if there is no need to pass anything
        const initialTransition = columnIssueTypeTransitions?.[String(issueTypeId)]?.find((transition)=>transition.isInitial);
        if (initialTransition) return {
            transitionId: null,
            statusId: initialTransition.destinationStatusId
        };
        const globalTransition = columnIssueTypeTransitions?.[String(issueTypeId)]?.find((transition)=>transition.isGlobal);
        if (globalTransition) return {
            transitionId: String(globalTransition.id),
            statusId: globalTransition.destinationStatusId
        };
        (0, $jcw0u.default)({
            error: new Error(`No initial or global transition found for column ${columnId} and issue type ${issueTypeId}`),
            meta: {
                // Remove `new` from id when cleaning up `use_backend_tmp_icc_config_`
                id: 'board.cardCreateSelectors.transitionIDForCardCreateSelectorNew.missing.transition',
                packageName: 'jiraSoftwareBoard',
                teamName: 'a4t-tanuki'
            }
        });
        // this is an error state, card create is not possible without initial or global transition
        return null;
    }, (columnId, issueTypeId)=>`${columnId}:${issueTypeId}`));
const $8133e73592e62d8c$var$checkIfTransitionIsEqual = (source, target)=>source.statusId === target.statusId;
const $8133e73592e62d8c$export$41c8dd7cee50a968 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>(columnId)=>cardTransitions.columnIssueTypeTransitions[String(columnId)]);
const $8133e73592e62d8c$export$ec7e6959583c9985 = (0, $dGvGJ.createSelector)([
    (0, $fyeGd.getColumns),
    (0, $4gt6L.defaultIssueTypeIdSelector),
    (0, $4gt6L.issueBaseTypesSelector)
], (columns, defaultIssueTypeId, projectIssueTypes)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnId, issueTypeTransitions, selectedIssueTypeId)=>{
        if (!issueTypeTransitions) return [];
        const statuses = (0, $fyeGd.getStatusColumn)(columns[String(columnId)])?.statuses ?? [];
        const issueTypeId = selectedIssueTypeId ?? defaultIssueTypeId ?? projectIssueTypes?.[0]?.id;
        if (!issueTypeId) return [];
        const transitionsForIssueType = issueTypeTransitions[String(issueTypeId)];
        const statusTransitions = transitionsForIssueType?.reduce((acc, transition)=>{
            if (transition.isInitial || transition.isGlobal) {
                const toStatus = statuses.find((status)=>status.id === transition.destinationStatusId);
                if (toStatus) acc.push({
                    transitionId: transition.id,
                    name: toStatus.name,
                    statusId: toStatus.id,
                    isInitial: transition.isInitial,
                    statusCategoryId: (0, $gULOk.categoryIdForStatusCategory)(toStatus.category)
                });
            }
            return acc;
        }, []) || [];
        const deduplicatedTransitions = (0, (/*@__PURE__*/$parcel$interopDefault($vNXgH)))(statusTransitions, $8133e73592e62d8c$var$checkIfTransitionIsEqual);
        return deduplicatedTransitions.length > 1 ? deduplicatedTransitions : [];
    }, (columnId, _, selectedIssueTypeId)=>`${columnId}:${selectedIssueTypeId}`));
const $8133e73592e62d8c$export$ddd0d47434cf9e05 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.projectKeySelector)
], (isCMPBoard, projectKey)=>isCMPBoard ? (0, $eph8m.getIssueTypesUrl)(projectKey) : (0, $02Psx.getNextgenSettingsIssueTypesUrl)((0, $2vSU6.SOFTWARE_PROJECT), projectKey));
const $8133e73592e62d8c$export$2c1218071d6b5bb2 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjects),
    (0, $67Z81.getIssueTypesByProject),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (issueProjects, issueTypesByProject, isIPBoard)=>{
    if (!isIPBoard) return issueProjects;
    const initialProjects = {};
    // Filter out projects that don't have story or epic level issue types
    return Object.entries(issueProjects).reduce((acc, [projectKey, project])=>{
        const projectIssueTypes = issueTypesByProject[project.id];
        if (projectIssueTypes?.some((issueType)=>issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE) || issueType.hierarchyLevelType === (0, $g4tDr.BASE_HIERARCHY_TYPE))) acc[projectKey] = project;
        return acc;
    }, initialProjects);
});
const $8133e73592e62d8c$export$6b08fee64011acdb = (0, $dGvGJ.createSelector)([
    $8133e73592e62d8c$export$2c1218071d6b5bb2,
    (0, $67Z81.projectIdSelector)
], (allIssueProjects, projectIdFromConfiguration)=>{
    const projectFromConfiguration = allIssueProjects[projectIdFromConfiguration];
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectFromConfiguration)) return projectIdFromConfiguration;
    const projectKeys = Object.keys(allIssueProjects);
    return projectKeys.length > 0 ? Number(projectKeys[0]) : undefined;
});
const $8133e73592e62d8c$var$emptyArray = (0, $7uUwQ.freeze)([]);
const $8133e73592e62d8c$export$de67b2a86891c711 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueTypesByProject),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (issueTypesByProject, isIPBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((projectId)=>{
        if (isIPBoard && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueTypesByProject)) return issueTypesByProject[`${projectId}`] ?? $8133e73592e62d8c$var$emptyArray;
        return $8133e73592e62d8c$var$emptyArray;
    }));
const $8133e73592e62d8c$export$8b1e452ee0e8eef0 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.lastFilteredIssueParentIdSelector),
    (0, $67Z81.getIssues),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (lastFilteredIssueParentId, issues, isIPBoard)=>(0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((projectId)=>{
        if (!isIPBoard) return lastFilteredIssueParentId;
        // for the IP board, we should check if the epic belongs to the project
        const parentIssue = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(lastFilteredIssueParentId) ? null : issues[lastFilteredIssueParentId];
        return parentIssue?.projectId === projectId ? lastFilteredIssueParentId : null;
    }));
const $8133e73592e62d8c$export$26a46ce3707c0a02 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getCardTransitions)
], (cardTransitions)=>(columnId, issueTypeId, transitionId)=>{
        const { columnIssueTypeTransitions: columnIssueTypeTransitions, issueTypeStatus: issueTypeStatus } = cardTransitions;
        const transitionsByIssueType = columnIssueTypeTransitions[columnId];
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionsByIssueType)) return null;
        const transition = transitionsByIssueType[issueTypeId]?.find((trans)=>trans.id === transitionId);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transition) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transition.destinationStatusId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueTypeStatus[issueTypeId])) return null;
        return issueTypeStatus[issueTypeId][transition.destinationStatusId];
    });

});
parcelRegister("vNXgH", function(module, exports) {

var $7CoLY = parcelRequire("7CoLY");
/**
 * This method is like `_.uniq` except that it accepts `comparator` which
 * is invoked to compare elements of `array`. The order of result values is
 * determined by the order they occur in the array.The comparator is invoked
 * with two arguments: (arrVal, othVal).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
 *
 * _.uniqWith(objects, _.isEqual);
 * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
 */ function $05f9a56040cc5a05$var$uniqWith(array, comparator) {
    comparator = typeof comparator == 'function' ? comparator : undefined;
    return array && array.length ? $7CoLY(array, undefined, comparator) : [];
}
module.exports = $05f9a56040cc5a05$var$uniqWith;

});



parcelRegister("lWvJn", function(module, exports) {

$parcel$export(module.exports, "issueUpdateService", () => $c35f5051fe4e6d5f$export$4f6796016f60fcae);
$parcel$export(module.exports, "issueRankJPOService", () => $c35f5051fe4e6d5f$export$fc0043ca24fa881a);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $binmg = parcelRequire("binmg");
function $c35f5051fe4e6d5f$export$4f6796016f60fcae(_ctx, { issueKey: issueKey, values: values }) {
    return (0, $binmg.issueUpdateRest)(issueKey, values);
}
function $c35f5051fe4e6d5f$export$cab2c8be868d8e42({ issueIds: issueIds, planId: planId, scenarioId: scenarioId, values: values }) {
    return (0, $binmg.issueUpdateJPORest)({
        issueIds: issueIds,
        planId: planId,
        scenarioId: scenarioId,
        values: values
    });
}
function $c35f5051fe4e6d5f$export$fc0043ca24fa881a({ issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, isLastPosition: isLastPosition, requestHandler: requestHandler }) {
    let relation = 'BEFORE';
    let anchor = rankBeforeIssueId;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankBeforeIssueId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankAfterIssueId)) {
        relation = 'AFTER';
        anchor = rankAfterIssueId;
    }
    let operation = {
        anchor: `${anchor}`,
        itemKeys: issueIds.filter((id)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id)).map((id)=>`${id}`),
        relation: relation
    };
    if (isLastPosition) operation = {
        itemKeys: issueIds.filter((id)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id)).map((id)=>`${id}`),
        relation: 'LAST'
    };
    return (0, $kVLXA.Observable).from(requestHandler(operation));
}

});
parcelRegister("binmg", function(module, exports) {

$parcel$export(module.exports, "issueUpdateRest", () => $a718535ca355b011$export$c0cb20b0a7c268f2);
$parcel$export(module.exports, "issueUpdateJPORest", () => $a718535ca355b011$export$b84318079028d336);

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");
function $a718535ca355b011$export$c0cb20b0a7c268f2(issueKey, values) {
    return (0, $487fd.default)((0, $2bQEl.getIssueEditUrl)('', issueKey), {
        method: 'PUT',
        body: JSON.stringify({
            fields: values
        })
    });
}
function $a718535ca355b011$export$b84318079028d336({ issueIds: issueIds, planId: planId, scenarioId: scenarioId, values: values }) {
    return (0, $487fd.default)('/rest/jpo/1.0/scenarios/updateIssues?operation=UpdateJPORest', {
        method: 'POST',
        body: JSON.stringify({
            planId: planId,
            scenarioId: scenarioId,
            itemKeys: issueIds,
            description: values
        })
    });
}

});



parcelRegister("2D01T", function(module, exports) {

$parcel$export(module.exports, "issueFlagWithCommentEpic", () => $de98bd2462700fac$export$a1a30b7a4bf55618);

var $alNv9 = parcelRequire("alNv9");

var $ajpes = parcelRequire("ajpes");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $faGMz = parcelRequire("faGMz");

var $kz2lw = parcelRequire("kz2lw");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");


var $8Fckk = parcelRequire("8Fckk");

var $hdmw1 = parcelRequire("hdmw1");

var $fBkjL = parcelRequire("fBkjL");

var $cW3pH = parcelRequire("cW3pH");

var $vAfHD = parcelRequire("vAfHD");
const $de98bd2462700fac$export$a1a30b7a4bf55618 = (action$, store)=>action$.ofType((0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_REQUEST)).mergeMap((action)=>{
        const { payload: { issueIds: issueIds, flag: flag, comment: comment }, meta: { optimistic: { id: optimisticId }, analyticsEvent: analyticsEvent } } = action;
        const state = store.getState();
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        const { issueProjects: issueProjects } = (0, $alNv9.ensureState)(state.entities);
        const issues = (0, $vAfHD.boardIssuesSelector)(state);
        const issuesToFlag = issueIds.map((id)=>issues[id]);
        const internallyCommentingIssueKeys = issuesToFlag.filter((issue)=>issueProjects[issue.projectId]?.projectTypeKey === (0, $2vSU6.SERVICE_DESK_PROJECT)).map((issue)=>issue.key);
        const publiclyCommentingIssueKeys = issuesToFlag.filter((issue)=>issueProjects[issue.projectId]?.projectTypeKey !== (0, $2vSU6.SERVICE_DESK_PROJECT)).map((issue)=>issue.key);
        const requests = [];
        if (internallyCommentingIssueKeys.length) requests.push((0, $8Fckk.default)(ctx, {
            issueKeys: internallyCommentingIssueKeys,
            flag: flag,
            comment: comment,
            internal: true
        }));
        if (publiclyCommentingIssueKeys.length) requests.push((0, $8Fckk.default)(ctx, {
            issueKeys: publiclyCommentingIssueKeys,
            flag: flag,
            comment: comment,
            internal: false
        }));
        return (0, $faGMz.forkJoin)(requests).flatMap((responses)=>{
            if (responses.every((r)=>r === null)) {
                // if we get here, all of the issues were successfully updated
                const extendedAnalyticsArgs = {};
                if ((0, $4R6GH.fg)('add_has_comment_attribute_to_cards_flagged_client')) extendedAnalyticsArgs.hasComment = !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(comment, (0, $kz2lw.getEmptyADF)());
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'cards flagged', {
                    numCards: issueIds.length,
                    flagAction: flag ? 'added' : 'removed',
                    ...extendedAnalyticsArgs
                });
                return (0, $kVLXA.Observable).from([
                    (0, $fBkjL.issueFlagWithCommentSuccess)(optimisticId, issueIds),
                    (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$97b91dd49f0a73f1))
                ]);
            }
            // if we get here, at least one of the issues failed to be updated,
            // so we treat it as a failure
            const errorMessages = responses.map((r)=>r?.errorMessages || []).flat(1);
            const error = new Error(errorMessages.join(', '));
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board.issue-flag-with-comment.partial-failure', 'Failed to flag and/or comment on some issues.', error);
            throw error;
        }).catch(()=>{
            // if we get here directly from the cardsFlagWithCommentService, none
            // of the issues were successfully updated
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskFail', {
                task: 'flagCards',
                numCards: issueIds.length,
                flagAction: flag ? 'added' : 'removed'
            });
            return (0, $kVLXA.Observable).from([
                (0, $fBkjL.issueFlagWithCommentFailure)(optimisticId, issueIds),
                (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7))
            ]);
        });
    });

});
parcelRegister("kz2lw", function(module, exports) {

$parcel$export(module.exports, "getEmptyADF", () => $06167b6274ea84aa$export$d109ab46c9575565);
// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */ 
var $ebjue = parcelRequire("ebjue");
const $06167b6274ea84aa$export$d109ab46c9575565 = ()=>({
        type: 'doc',
        version: 1,
        content: []
    });

});
parcelRegister("ebjue", function(module, exports) {

$parcel$export(module.exports, "isEmpty", () => $9e55b7d6fded4629$export$dd1bc94b04021eeb);
const $9e55b7d6fded4629$export$dd1bc94b04021eeb = (node)=>!node?.content?.length;

});


parcelRegister("8Fckk", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7540c63b11fc724$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $ikizX = parcelRequire("ikizX");
function $d7540c63b11fc724$export$2e2bcd8739ae039(ctx, { issueKeys: issueKeys, flag: flag, comment: comment, internal: internal }) {
    return (0, $kVLXA.Observable).fromPromise((0, $ikizX.makeFlagWithCommentRequest)(issueKeys, flag, comment, internal));
}

});
parcelRegister("ikizX", function(module, exports) {

$parcel$export(module.exports, "makeFlagWithCommentRequest", () => $8f07cf7f745a7bf3$export$bfe9c76f17e80968);

var $jJZqs = parcelRequire("jJZqs");

var $iwPwz = parcelRequire("iwPwz");
const $8f07cf7f745a7bf3$var$noContentStatus = 204;
const $8f07cf7f745a7bf3$export$3ae968343ffb0d2b = '/rest/greenhopper/3/xboard/issue/flag/flag';
const $8f07cf7f745a7bf3$export$bfe9c76f17e80968 = (issueKeys, flag, comment, internal = false)=>fetch($8f07cf7f745a7bf3$export$3ae968343ffb0d2b, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            issueKeys: issueKeys,
            flag: flag,
            comment: comment,
            commentProperty: internal ? '{"key": "sd.public.comment", "value": {"internal": true}}' : '',
            commentVisibility: ''
        })
    }).then((response)=>{
        if (!response.ok) {
            const { status: status } = response;
            const traceId = (0, $iwPwz.getTraceId)(response);
            if (traceId) throw new (0, $jJZqs.default)(status, `Fetch call failed with status code: ${status}`, traceId);
            else throw new (0, $jJZqs.default)(status);
        }
        if (response.status === $8f07cf7f745a7bf3$var$noContentStatus) return null;
        return response.text().then((body)=>body ? JSON.parse(body) : null);
    });
var $8f07cf7f745a7bf3$export$2e2bcd8739ae039 = $8f07cf7f745a7bf3$export$bfe9c76f17e80968;

});



parcelRegister("5I1Fz", function(module, exports) {

$parcel$export(module.exports, "issueIncrementPlanningUpdateEpic", () => $be7222332eb90898$export$b98bf9e5e594be07);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fPS7b");
parcelRequire("6hSeW");
parcelRequire("93e44");
parcelRequire("zjDln");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $dGANR = parcelRequire("dGANR");


var $evkwq = parcelRequire("evkwq");

var $7ZWvl = parcelRequire("7ZWvl");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
const $be7222332eb90898$var$error = (action, err)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.increment.planning.update', 'Failed to update IP board issue', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    err);
    if (action.promise && (0, $4R6GH.fg)('issue_view_in_program_board')) action.promise.reject(err);
    return (0, $kVLXA.Observable).of((0, $evkwq.issueIncrementPlanningUpdateFailed)());
};
const $be7222332eb90898$var$success = (action, response)=>{
    if (action.promise && (0, $4R6GH.fg)('issue_view_in_program_board')) action.promise.resolve(response);
    return (0, $kVLXA.Observable).of((0, $evkwq.issueIncrementPlanningUpdateSuccess)());
};
function $be7222332eb90898$var$updateIssueStatus(action, store, updateIssue, resetIssueStatus) {
    const { payload: { issueId: issueId, fieldValue: fieldValue } } = action;
    const state = store.getState();
    if (typeof fieldValue === 'object' && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldValue) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldValue.statusId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldValue.statusTransitionId)) {
        if (fieldValue.statusTransitionId === (0, $dGANR.ORIGINAL_STATUS_TRANSITION).id) {
            const originalIssueStatus = (0, $d2i8f.getIssueById)(state, issueId)?.originals?.statusId;
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalIssueStatus)) return $be7222332eb90898$var$error(action, new Error('The original issue status cannot be undefined when reverting issue status'));
            return (0, $kVLXA.Observable).from(resetIssueStatus({
                issueId: String(issueId),
                originalIssueStatusId: Number(originalIssueStatus)
            })).flatMap((response)=>(0, $kVLXA.Observable).merge($be7222332eb90898$var$success(action, response), (0, $kVLXA.Observable).of((0, $7ZWvl.setIssueStatusIncrementPlanning)(issueId, fieldValue)))).catch((err)=>$be7222332eb90898$var$error(action, err));
        }
        const props = {
            status: `${fieldValue.statusId}`,
            statusTransition: `${fieldValue.statusTransitionId}`
        };
        return (0, $kVLXA.Observable).from(updateIssue({
            ...props,
            id: String(issueId)
        })).flatMap((response)=>(0, $kVLXA.Observable).merge($be7222332eb90898$var$success(action, response), (0, $kVLXA.Observable).of((0, $7ZWvl.setIssueStatusIncrementPlanning)(issueId, fieldValue)))).catch((err)=>$be7222332eb90898$var$error(action, err));
    }
    return $be7222332eb90898$var$error(action, new Error('must set the correct statusId and statusTransitionId when change the issue status in IP board'));
}
function $be7222332eb90898$var$updateIssueParentEstimateSummary(action, updateIssue) {
    const { payload: { issueId: issueId, fieldValue: fieldValue, fieldId: fieldId } } = action;
    return (0, $kVLXA.Observable).from(updateIssue({
        [fieldId]: fieldValue,
        id: String(issueId)
    })).flatMap((response)=>$be7222332eb90898$var$success(action, response)).catch((err)=>$be7222332eb90898$var$error(action, err));
}
function $be7222332eb90898$export$b98bf9e5e594be07(actions, store, { customRequestHandlers: customRequestHandlers }) {
    return actions.ofType((0, $evkwq.ISSUE_INCREMENT_PLANNING_UPDATE)).mergeMap((action)=>{
        const state = store.getState();
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        if (isIncrementPlanningBoard) {
            const { payload: { issueId: issueId, fieldValue: fieldValue, fieldId: fieldId } } = action;
            // when clean up the FG issue_cards_in_program_board, remove this function
            const successOld = (0, $4R6GH.fg)('issue_view_in_program_board') ? (response)=>{
                if (action.promise) action.promise.resolve(response);
                return (0, $kVLXA.Observable).of((0, $evkwq.issueIncrementPlanningUpdateSuccess)());
            } : ()=>(0, $kVLXA.Observable).of((0, $evkwq.issueIncrementPlanningUpdateSuccess)());
            // when clean up the FG issue_cards_in_program_board, remove this function
            const errorOld = (err)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.increment.planning.update', 'Failed to update IP board issue', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                err);
                if (action.promise && (0, $4R6GH.fg)('issue_view_in_program_board')) action.promise.reject(err);
                return (0, $kVLXA.Observable).of((0, $evkwq.issueIncrementPlanningUpdateFailed)());
            };
            if ((0, $4R6GH.fg)('issue_cards_in_program_board')) {
                if (!customRequestHandlers || !customRequestHandlers?.updateIssue || !customRequestHandlers?.resetIssueStatus) return $be7222332eb90898$var$error(action, new Error('no request handler found for update issue or reset issue status'));
            } else if (!customRequestHandlers || !customRequestHandlers?.updateIssue) return errorOld(new Error('no request handler found for update issue'));
            if ((0, $4R6GH.fg)('issue_cards_in_program_board')) {
                if (fieldId === (0, $7e733a5d4e4331fc$export$7445eb3755623031)) return $be7222332eb90898$var$updateIssueStatus(action, store, customRequestHandlers.updateIssue, // @ts-expect-error - when clean up the fg issue_cards_in_program_board, customRequestHandlers.resetIssueStatus will not be null or undefined, so please remove this comment
                customRequestHandlers.resetIssueStatus);
                return $be7222332eb90898$var$updateIssueParentEstimateSummary(action, customRequestHandlers.updateIssue);
            }
            // when clean up the issue_cards_in_program_board, remove this part until to the end
            return (0, $kVLXA.Observable).from(customRequestHandlers.updateIssue({
                id: String(issueId),
                [fieldId]: fieldValue
            })).flatMap((response)=>successOld(response)).catch((err)=>errorOld(err));
        }
        return (0, $kVLXA.Observable).empty();
    });
}

});
parcelRegister("dGANR", function(module, exports) {

$parcel$export(module.exports, "ORIGINAL_STATUS_TRANSITION", () => $6e96c7f4db2365fb$export$ce125fc0306b71a0);
const $6e96c7f4db2365fb$export$7f4f2b6cde999e82 = '__original_status_transition_id__';
const $6e96c7f4db2365fb$export$ce125fc0306b71a0 = {
    id: $6e96c7f4db2365fb$export$7f4f2b6cde999e82,
    name: '__original_status_transition_name__'
};

});

parcelRegister("7ZWvl", function(module, exports) {

$parcel$export(module.exports, "SET_ISSUE_STATUS_INCREMENT_PLANNING", () => $302058a4cb98366f$export$bb79fc0399585ef);
$parcel$export(module.exports, "setIssueStatusIncrementPlanning", () => $302058a4cb98366f$export$be4a7d7d8a2df3bf);
const $302058a4cb98366f$export$bb79fc0399585ef = 'state.actions.issue.status.SET_ISSUE_STATUS_INCREMENT_PLANNING';
const $302058a4cb98366f$export$be4a7d7d8a2df3bf = (issueId, fieldValue)=>({
        type: $302058a4cb98366f$export$bb79fc0399585ef,
        payload: {
            issueId: issueId,
            fieldValue: fieldValue
        }
    });

});


parcelRegister("eTCf8", function(module, exports) {

$parcel$export(module.exports, "issueLinkEpic", () => $274edd7dd18c90e1$export$b9129588162208f8);
$parcel$export(module.exports, "issueLinkUpdateEpic", () => $274edd7dd18c90e1$export$98d01d02eac3ac51);
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $esu6n = parcelRequire("esu6n");

var $6WzWZ = parcelRequire("6WzWZ");

var $5UXId = parcelRequire("5UXId");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
function $274edd7dd18c90e1$export$b9129588162208f8(action$, store, { customRequestHandlers: customRequestHandlers }) {
    return action$.ofType((0, $6WzWZ.ISSUE_LINK_CREATE_REQUEST)).mergeMap((action)=>{
        const { sourceItemKey: sourceItemKey, targetItemKey: targetItemKey, type: type } = action.payload;
        const success = (response)=>{
            if (action.promise) action.promise.resolve(response);
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinkCreateSuccess)());
        };
        const error = (err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.issue-link-epic.failure', 'Failed to link IP board issue', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            if (action.promise) action.promise.reject(err);
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinkCreateFailed)());
        };
        if (!customRequestHandlers || !customRequestHandlers.addIssueLink) return error(new Error('no request handler found for adding dependency'));
        return (0, $kVLXA.Observable).from(customRequestHandlers.addIssueLink({
            sourceItemKey: sourceItemKey,
            targetItemKey: targetItemKey,
            type: type
        })).flatMap((response)=>success(response)).catch((err)=>error(err));
    });
}
const $274edd7dd18c90e1$export$3c3b065ce00d8564 = ({ issueLinkType: issueLinkType, sourceIssueColumnId: sourceIssueColumnId, destinationIssueColumnId: destinationIssueColumnId, isConcurrentScheduling: isConcurrentScheduling, columns: columns })=>{
    const sourceColumn = issueLinkType.isOutward ? sourceIssueColumnId : destinationIssueColumnId;
    const destinationColumn = issueLinkType.isOutward ? destinationIssueColumnId : sourceIssueColumnId;
    // mark as offtrack when issue in unscheduled column blocks scheduled work
    if ((0, $esu6n.isUnscheduledColumn)(columns[sourceColumn]) && !(0, $esu6n.isUnscheduledColumn)(columns[destinationColumn])) return true;
    // mark as ontrack when issue in scheduled column blocks unscheduled work or both issues are in unscheduled column
    if (!(0, $esu6n.isUnscheduledColumn)(columns[sourceColumn]) && (0, $esu6n.isUnscheduledColumn)(columns[destinationColumn]) || (0, $esu6n.isUnscheduledColumn)(columns[sourceColumn]) && (0, $esu6n.isUnscheduledColumn)(columns[destinationColumn])) return false;
    if (isConcurrentScheduling) return sourceColumn > destinationColumn;
    return sourceColumn >= destinationColumn;
};
const $274edd7dd18c90e1$export$63cd13864b935a4c = (originalIssueLinks, state)=>{
    const columns = (0, $fyeGd.getColumns)(state);
    const isConcurrentScheduling = (0, $67Z81.getIncrementConfig)(state)?.isConcurrentScheduling || false;
    const newIssueLinks = {};
    Object.entries(originalIssueLinks).forEach(([issueId, issueLinks])=>{
        const existingIssueLinks = (0, $d2i8f.getIssueById)(state, issueId)?.issueLinks || [];
        const newAddedIssueLinksWithOfftrack = issueLinks.map((link)=>{
            const issueLinkType = (0, $67Z81.getIssueLinkTypeById)(state)(link.linkTypeId);
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueLinkType)) throw new Error('the issue link type is not existing');
            return {
                ...link,
                isOfftrack: $274edd7dd18c90e1$export$3c3b065ce00d8564({
                    issueLinkType: issueLinkType,
                    sourceIssueColumnId: (0, $d2i8f.getIssueById)(state, link.sourceId).columnId,
                    destinationIssueColumnId: (0, $d2i8f.getIssueById)(state, link.destinationId).columnId,
                    columns: columns,
                    isConcurrentScheduling: isConcurrentScheduling
                })
            };
        });
        newIssueLinks[issueId] = existingIssueLinks.concat(newAddedIssueLinksWithOfftrack);
    });
    return newIssueLinks;
};
const $274edd7dd18c90e1$var$updateIssueLinkOfftrack = (issueLinks, issueLinkId, offtrackValue)=>{
    return issueLinks.map((link)=>link.id === issueLinkId ? {
            ...link,
            isOfftrack: offtrackValue
        } : link);
};
const $274edd7dd18c90e1$export$de9c5b7f2a5b647c = (issueIds, destinationColumnId, state)=>{
    const columns = (0, $fyeGd.getColumns)(state);
    const isConcurrentScheduling = !!(0, $67Z81.getIncrementConfig)(state)?.isConcurrentScheduling;
    const newIssueLinks = {};
    issueIds.forEach((issueId)=>{
        const issueLinks = (0, $d2i8f.getIssueById)(state, issueId)?.issueLinks || [];
        const issueLinksWithUpdatedOfftrack = issueLinks.map((link)=>{
            const issueLinkType = (0, $67Z81.getIssueLinkTypeById)(state)(link.linkTypeId);
            const isSourceIssue = link.sourceId === issueId;
            const sourceIssue = isSourceIssue ? {
                ...(0, $d2i8f.getIssueById)(state, link.sourceId),
                columnId: destinationColumnId
            } : (0, $d2i8f.getIssueById)(state, link.sourceId);
            const destinationIssue = isSourceIssue ? (0, $d2i8f.getIssueById)(state, link.destinationId) : {
                ...(0, $d2i8f.getIssueById)(state, link.destinationId),
                columnId: destinationColumnId
            };
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueLinkType)) throw new Error('the issue link type is not existing');
            const isOffTrackValue = $274edd7dd18c90e1$export$3c3b065ce00d8564({
                issueLinkType: issueLinkType,
                sourceIssueColumnId: sourceIssue.columnId,
                destinationIssueColumnId: destinationIssue.columnId,
                columns: columns,
                isConcurrentScheduling: isConcurrentScheduling
            });
            // if the dragged issue is the source issue of the link, need to update issue links of the destination issue of the link,
            // if the dragged issue is the target issue of the link, need to update issue links of the source issue of the link.
            const issueUpdated = isSourceIssue ? destinationIssue : sourceIssue;
            const issueLinksWithOfftrack = $274edd7dd18c90e1$var$updateIssueLinkOfftrack(newIssueLinks[issueUpdated.id] || issueUpdated?.issueLinks || [], link.id, isOffTrackValue);
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issueLinksWithOfftrack)) newIssueLinks[issueUpdated.id] = issueLinksWithOfftrack;
            return {
                ...link,
                isOfftrack: isOffTrackValue
            };
        });
        newIssueLinks[issueId] = issueLinksWithUpdatedOfftrack;
    });
    return newIssueLinks;
};
const $274edd7dd18c90e1$var$handleIssueLinkUpdate = (action, state)=>{
    let newIssueLinks = {};
    if (action.type === (0, $6WzWZ.ISSUE_LINKS_CREATE)) newIssueLinks = $274edd7dd18c90e1$export$63cd13864b935a4c(action.payload.newIssueLinks, state);
    if (action.type === (0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)) newIssueLinks = $274edd7dd18c90e1$export$de9c5b7f2a5b647c(action.payload.issueIds, action.payload.destinationColumnId, state);
    return newIssueLinks;
};
function $274edd7dd18c90e1$export$98d01d02eac3ac51(action$, store) {
    return action$.ofType((0, $6WzWZ.ISSUE_LINKS_CREATE), (0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        if (isIncrementPlanningBoard) return (0, $kVLXA.Observable).of($274edd7dd18c90e1$var$handleIssueLinkUpdate(action, state)).flatMap((newIssueLinks)=>{
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinksAddAndUpdateSuccess)({
                newIssueLinks: newIssueLinks
            }));
        }).catch((err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.issue-link-add-update-success-epic.failure', 'The issue links failed to update', err);
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinksAddAndUpdateFailed)());
        });
        return (0, $kVLXA.Observable).empty();
    });
}

});
parcelRegister("6WzWZ", function(module, exports) {

$parcel$export(module.exports, "ISSUE_LINKS_CREATE", () => $c497fae38ad3141e$export$9b86f34aa487330f);
$parcel$export(module.exports, "issueLinksCreate", () => $c497fae38ad3141e$export$695074c2cd38a954);
$parcel$export(module.exports, "ISSUE_LINK_CREATE_REQUEST", () => $c497fae38ad3141e$export$a360ded071b8ad75);
$parcel$export(module.exports, "issueLinkCreateRequest", () => $c497fae38ad3141e$export$daac9ff0ef08b318);
$parcel$export(module.exports, "issueLinkCreateSuccess", () => $c497fae38ad3141e$export$897cdb99a776480b);
$parcel$export(module.exports, "issueLinkCreateFailed", () => $c497fae38ad3141e$export$9629175ea4c8225f);
$parcel$export(module.exports, "ISSUE_LINKS_REMOVE_REQUEST", () => $c497fae38ad3141e$export$a11cc88ebb18ead2);
$parcel$export(module.exports, "issueLinksRemoveRequest", () => $c497fae38ad3141e$export$4e1225be108c8cc);
$parcel$export(module.exports, "ISSUE_LINKS_REMOVE_SUCCESS", () => $c497fae38ad3141e$export$9028eccea4410398);
$parcel$export(module.exports, "issueLinksRemoveSuccess", () => $c497fae38ad3141e$export$ec4e17f9ac9ec830);
$parcel$export(module.exports, "issueLinksRemoveFailed", () => $c497fae38ad3141e$export$9e26eeb7c4d4c29a);
$parcel$export(module.exports, "ISSUE_LINKS_ADD_UPDATE_SUCCESS", () => $c497fae38ad3141e$export$ffd13079184b6b1e);
$parcel$export(module.exports, "issueLinksAddAndUpdateSuccess", () => $c497fae38ad3141e$export$f9f50e91f5dd466);
$parcel$export(module.exports, "issueLinksAddAndUpdateFailed", () => $c497fae38ad3141e$export$343182dd42310851);
$parcel$export(module.exports, "reachDependencyLinesLimitInIPBoard", () => $c497fae38ad3141e$export$c48a8dd0a23a5210);

var $4R6GH = parcelRequire("4R6GH");

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $c497fae38ad3141e$export$9b86f34aa487330f = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE';
const $c497fae38ad3141e$export$695074c2cd38a954 = (payload)=>({
        type: $c497fae38ad3141e$export$9b86f34aa487330f,
        payload: payload
    });
const $c497fae38ad3141e$export$a360ded071b8ad75 = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE_REQUEST';
const $c497fae38ad3141e$export$daac9ff0ef08b318 = (payload)=>({
        type: $c497fae38ad3141e$export$a360ded071b8ad75,
        payload: payload
    });
const $c497fae38ad3141e$export$3a45528ea0878487 = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE_SUCCESS';
const $c497fae38ad3141e$export$897cdb99a776480b = ()=>({
        type: $c497fae38ad3141e$export$3a45528ea0878487
    });
const $c497fae38ad3141e$export$ca26aad29ddbd14b = 'state.actions.issue.issue-link.ISSUE_LINK_CREATE_FAILED';
const $c497fae38ad3141e$export$9629175ea4c8225f = ()=>({
        type: $c497fae38ad3141e$export$ca26aad29ddbd14b
    });
const $c497fae38ad3141e$export$a11cc88ebb18ead2 = 'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_REQUEST';
const $c497fae38ad3141e$export$4e1225be108c8cc = (payload)=>({
        type: $c497fae38ad3141e$export$a11cc88ebb18ead2,
        payload: payload
    });
const $c497fae38ad3141e$export$9028eccea4410398 = 'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_SUCCESS';
const $c497fae38ad3141e$export$ec4e17f9ac9ec830 = (payload)=>({
        type: $c497fae38ad3141e$export$9028eccea4410398,
        payload: payload
    });
const $c497fae38ad3141e$export$fcfc54069b26e23c = 'state.actions.issue.issue-link.ISSUE_LINKS_REMOVE_FAILED';
const $c497fae38ad3141e$export$9e26eeb7c4d4c29a = ()=>({
        type: $c497fae38ad3141e$export$fcfc54069b26e23c,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });
const $c497fae38ad3141e$export$ffd13079184b6b1e = 'state.actions.issue.issue-link.ISSUE_LINKS_ADD_UPDATE_SUCCESS';
const $c497fae38ad3141e$export$f9f50e91f5dd466 = (payload)=>({
        type: $c497fae38ad3141e$export$ffd13079184b6b1e,
        payload: payload
    });
const $c497fae38ad3141e$export$3224e930ca89533f = 'state.actions.issue.issue-link.ISSUE_LINKS_ADD_UPDATE_FAILED';
const $c497fae38ad3141e$export$343182dd42310851 = ()=>({
        type: $c497fae38ad3141e$export$3224e930ca89533f,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });
const $c497fae38ad3141e$export$2f3aaf81816ff1f4 = 'state.actions.flags.REACH_DEPENDENCY_LINES_LIMIT_FLAG_IP_BOARD';
const $c497fae38ad3141e$export$c48a8dd0a23a5210 = (dependencyLinesLimit)=>({
        type: $c497fae38ad3141e$export$2f3aaf81816ff1f4,
        meta: (0, $sdxnu.infoFlagMeta)({
            titleMessage: (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7AVqz.default).reachDependencyLineLimitTitleIssueTermRefresh : (0, $7AVqz.default).reachDependencyLineLimitTitle,
            context: {
                limit: dependencyLinesLimit
            }
        })
    });

});


parcelRegister("fElG1", function(module, exports) {

$parcel$export(module.exports, "default", () => $54f16bef8721ff54$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("6cbqE");

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");

var $dN3Ms = parcelRequire("dN3Ms");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$54f16bef8721ff54$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST)).switchMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const { payload: { issueId: issueId, isVisible: isVisible }, meta: { optimistic: { id: txId } } } = action;
        const fetchOptions = {
            method: isVisible ? 'PUT' : 'DELETE'
        };
        return (0, $487fd.default)((0, $2bQEl.getIssueMediaVisibilityChangeUrl)(contextPath, issueId), fetchOptions).flatMap(()=>(0, $kVLXA.Observable).of((0, $dN3Ms.issueMediaVisibilityChangeSuccess)(txId, issueId, isVisible))).catch(()=>(0, $kVLXA.Observable).of((0, $dN3Ms.issueMediaVisibilityChangeFailure)(txId)));
    });

});

parcelRegister("4tES9", function(module, exports) {

$parcel$export(module.exports, "issueMoveToBacklogEpic", () => $b1612da6359624df$export$9d05d3a44f2a11ad);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $7zmUm = parcelRequire("7zmUm");

var $2bQEl = parcelRequire("2bQEl");

var $cIqUn = parcelRequire("cIqUn");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");
const $b1612da6359624df$export$9d05d3a44f2a11ad = (action$, store)=>action$.ofType((0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        const { rankCustomFieldId: rankCustomFieldId } = (0, $d2i8f.getRankConfig)(state);
        return (0, $7zmUm.default)((0, $2bQEl.getIssuesMoveToBacklogUrl)(contextPath), {
            method: 'PUT',
            body: JSON.stringify({
                calculateNewIssuesOrder: false,
                issueKeys: action.payload.issueKeys,
                rankBeforeIssueIdOrKey: null,
                rankCustomFieldId: rankCustomFieldId,
                rapidViewId: rapidViewId,
                target: 'BACKLOG'
            })
        }).flatMap(()=>(0, $kVLXA.Observable).of((0, $cIqUn.issueMoveToBacklogSuccess)(action.meta.optimistic.id, action.payload.issueIds, action.payload.columnId))).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.move.to.backlog.failure', 'Failed to move issue to backlog', error);
            return (0, $kVLXA.Observable).of((0, $cIqUn.issueMoveToBacklogFailure)(action.meta.optimistic.id, action.payload.issueIds));
        });
    });

});

parcelRegister("fb1Ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6cfaad44a38c8fb$export$2e2bcd8739ae039);

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $7SCny = parcelRequire("7SCny");

var $g4tDr = parcelRequire("g4tDr");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("fPS7b");


var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $3n65g = parcelRequire("3n65g");

var $cW3pH = parcelRequire("cW3pH");

var $8yiLS = parcelRequire("8yiLS");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");
const $c6cfaad44a38c8fb$var$transformNewIssues = (issues)=>issues.map((issue)=>({
            issueId: String(issue.id),
            issueKey: String(issue.key),
            issueTypeId: String(issue.typeId),
            createdIssueDetails: {
                fields: {
                    status: {
                        id: String(issue.statusId)
                    },
                    project: {
                        id: String(issue.projectId)
                    },
                    issuetype: {
                        // We do not have access to hierarchy level of the new issues,
                        // but it is not used when creating via ICC, so we are hardcoding to 0
                        hierarchyLevel: 0,
                        name: issue.typeName
                    }
                }
            }
        }));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$c6cfaad44a38c8fb$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $ls4NM.ISSUE_CREATE_SUCCESS)).mergeMap((action)=>{
        const currentIssues = action.payload.issues;
        const state = store.getState();
        const actions = [];
        const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const filteredIssues = (0, $5mTgl.workFilteredIssuesSelector)(state);
        const activeSprints = (0, $ebHh7.activeSprintsSelector)(state);
        const createdAndFilteredIssues = currentIssues.filter(({ id: id })=>!filteredIssues.some((issue)=>issue.id === id));
        // don't show this flag here if custom filters are active,
        // we'll show it after the refiltering succeeds
        const shouldShowFlag = createdAndFilteredIssues.length && !(0, $8yiLS.isCustomFiltersActive)(state);
        let hasShownFlag = false;
        if (shouldShowFlag) {
            if (isIPBoard) actions.push((0, $bkCF5.cardCreateFilteredOutInIPBoard)(createdAndFilteredIssues[0].typeName));
            else actions.push((0, $bkCF5.issueCreateFilteredV2)(createdAndFilteredIssues.map(({ key: key })=>key)));
            hasShownFlag = true;
        } else if ((activeSprints?.length ?? 0) > 1 && !currentIssues.every((issue)=>issue.sprintId)) {
            // show a flag to pick sprint for issues created if there are multiple active sprints and no sprint filter applied as its value will be preset otherwise
            actions.push((0, $bkCF5.issueCreateFilteredV2)(currentIssues.map(({ key: key })=>key), activeSprints));
            hasShownFlag = true;
        }
        if (isCMPBoard) actions.push((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$7aa54af91613c70a), $c6cfaad44a38c8fb$var$transformNewIssues(action.payload.issues), undefined, hasShownFlag));
        // in the IP board, adding the newly created epic level issue to the issueParents
        if (isIPBoard) {
            const issue = currentIssues[0];
            const { typeId: typeId, projectId: projectId } = issue;
            const issueType = (0, $67Z81.getIssueTypeInIPboard)(state)(projectId, `${typeId}`);
            const color = issue.color ?? (0, $7SCny.Colors).PURPLE;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueType) && issueType?.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE)) actions.push((0, $3n65g.addIssueParent)({
                issue: {
                    id: issue.id,
                    key: issue.key,
                    summary: issue.summary,
                    issueType: {
                        iconUrl: issueType.iconUrl,
                        id: issueType.id,
                        name: issueType.name
                    },
                    color: color,
                    projectId: projectId,
                    flagged: issue?.isFlagged ?? false
                }
            }));
        }
        return (0, $kVLXA.Observable).from(actions);
    });

});

parcelRegister("b8T1q", function(module, exports) {

$parcel$export(module.exports, "issueRankTeamDateEpic", () => $f9e1d3bcbac4e8b5$export$83fa292e308a3ba);
parcelRequire("fp4O3");
parcelRequire("aSIuP");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $ifg6x = parcelRequire("ifg6x");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $g4tDr = parcelRequire("g4tDr");

var $4jAPy = parcelRequire("4jAPy");

var $esu6n = parcelRequire("esu6n");

var $kgiLc = parcelRequire("kgiLc");

var $lWvJn = parcelRequire("lWvJn");

var $dMBwz = parcelRequire("dMBwz");

var $5UXId = parcelRequire("5UXId");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");

var $vAfHD = parcelRequire("vAfHD");
const $f9e1d3bcbac4e8b5$var$error = (state, issueIds, err)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData('team.date.and.rank.failure', 'Failed to update IP board issue', err);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issue = allIssues[String(issueIds[0])];
    return (0, $kVLXA.Observable).of((0, $5UXId.issueTeamDateRankFailure)(issue));
};
const $f9e1d3bcbac4e8b5$var$success = ()=>(0, $kVLXA.Observable).of((0, $5UXId.issueTeamDateRankSuccess)());
function $f9e1d3bcbac4e8b5$var$doRank(state, { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } }, { customRequestHandlers: customRequestHandlers }) {
    if (!customRequestHandlers || !customRequestHandlers.rankIssue) return $f9e1d3bcbac4e8b5$var$error(state, issueIds, new Error('no request handler found for ranking issues'));
    return (0, $lWvJn.issueRankJPOService)({
        issueIds: issueIds,
        rankBeforeIssueId: rankBeforeIssueId,
        rankAfterIssueId: rankAfterIssueId,
        requestHandler: customRequestHandlers.rankIssue
    }).flatMap(()=>$f9e1d3bcbac4e8b5$var$success()).catch((err)=>$f9e1d3bcbac4e8b5$var$error(state, issueIds, err));
}
function $f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMove(state, action, dependencies) {
    const incrementConfig = (0, $67Z81.getIncrementConfig)(state);
    const { issueIds: issueIds, destinationColumnId: destinationColumnId, destinationSwimlaneId: destinationSwimlaneId } = action.payload;
    const teamSprintsForIterations = (0, $cPGP0.getTeamSprintsForIterations)(state, destinationSwimlaneId);
    if (incrementConfig === null) return $f9e1d3bcbac4e8b5$var$error(state, issueIds, new Error('incrementConfig cannot be null'));
    const destinationColumn = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationColumnId) && (0, $esu6n.getDateRangeColumn)((0, $fyeGd.getColumnById)(state, Number(destinationColumnId)));
    let sprint;
    // if we move the issue to a teamless swimlane (i.e. no sprints associated), we remove the sprint OR
    // if we move the issue to the unscheduled column, we clear the sprint OR
    // if the destination swimlane doesn't have sprints associated, we clear the sprint value
    if (destinationSwimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) || destinationColumn && (0, $esu6n.isUnscheduledColumn)(destinationColumn) || !teamSprintsForIterations) sprint = null;
    if (teamSprintsForIterations) sprint = teamSprintsForIterations[destinationColumnId];
    let dateRange = destinationColumn ? destinationColumn.dateRange : null;
    // If the destination column has a sprint associated and the sprint has dates set,
    // we use these dates for the dateRange instead of the iteration dates (for Epic level issues)
    if (teamSprintsForIterations !== null && dateRange !== null && sprint && sprint.startDate !== null && sprint.endDate !== null) dateRange = {
        start: sprint.startDate,
        end: sprint.endDate
    };
    // Split issues into epics and stories
    const [epicIds, storyIds] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(issueIds, (issueId)=>{
        const issue = (0, $67Z81.getIssues)(state)[issueId];
        const issueType = (0, $67Z81.getIssueTypeInIPboard)(state)(issue.projectId, `${issue.typeId}`);
        return !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueType) && issueType.hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE);
    });
    // Split epic that has existing start date and it's after the end of iteration (or sprint) end dates
    const [epicsWithClearStartDate, otherEpics] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(epicIds, (epicId)=>{
        const epic = (0, $67Z81.getIssues)(state)[epicId];
        return epic && epic.startDate && dateRange && dateRange.end !== 0 && new Date(epic.startDate) > new Date(dateRange.end);
    });
    const requests$ = [];
    // Clear start date for epics that has existing start date and it's after the end of iteration (or sprint) end dates
    if (epicsWithClearStartDate.length > 0) requests$.push($f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithStartAndEndDate(state, {
        type: action.type,
        payload: {
            ...action.payload,
            issueIds: epicsWithClearStartDate
        }
    }, dependencies, (0, $kgiLc.transformDateValue)(dateRange?.end), null));
    // Keep start date for epics that doesn't have existing start date or if it's before the end of iteration dates
    if (otherEpics.length > 0) requests$.push($f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithStartAndEndDate(state, {
        type: action.type,
        payload: {
            ...action.payload,
            issueIds: otherEpics
        }
    }, dependencies, (0, $kgiLc.transformDateValue)(dateRange?.end), undefined));
    // Set iteration start date or sprint for stories
    if (storyIds.length > 0) {
        if (sprint) requests$.push($f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithSprint(state, {
            type: action.type,
            payload: {
                ...action.payload,
                issueIds: storyIds
            }
        }, dependencies, sprint.id));
        else requests$.push($f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithStartAndEndDate(state, {
            type: action.type,
            payload: {
                ...action.payload,
                issueIds: storyIds
            }
        }, dependencies, (0, $kgiLc.transformDateValue)(dateRange?.end), (0, $kgiLc.transformDateValue)(dateRange?.start), sprint === null));
    }
    return (0, $kVLXA.Observable).forkJoin(...requests$);
}
/* This function is called for Epic level issues, or Story level issues where the destination team column does not have a sprint association */ function $f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithStartAndEndDate(state, { payload: { issueIds: issueIds, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId } }, { customRequestHandlers: customRequestHandlers }, newEndDate, newStartDate, shouldClearSprint) {
    if (!customRequestHandlers || !customRequestHandlers.bulkUpdateIssues) return $f9e1d3bcbac4e8b5$var$error(state, issueIds, new Error('no request handler found for swimlane and column move'));
    const incrementConfig = (0, $67Z81.getIncrementConfig)(state);
    if (incrementConfig === null) return $f9e1d3bcbac4e8b5$var$error(state, issueIds, new Error('incrementConfig cannot be null'));
    const destinationColumn = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationColumnId) && (0, $esu6n.getDateRangeColumn)((0, $fyeGd.getColumnById)(state, Number(destinationColumnId)));
    const destinationSwimlaneHasSprints = (0, $cPGP0.getTeamSprintsForIterations)(state, destinationSwimlaneId) !== null;
    const sourceSwimlaneHasSprints = (0, $cPGP0.getTeamSprintsForIterations)(state, sourceSwimlaneId) !== null;
    const values = (()=>{
        let innerValues = {};
        const startEndValues = (0, $kgiLc.transformDateRangeUpdateValues)(incrementConfig, newStartDate, newEndDate);
        const isColumnChange = destinationColumnId !== sourceColumnId;
        const isSwimlaneChange = destinationSwimlaneId && sourceSwimlaneId !== destinationSwimlaneId;
        const sprintSwimlaneToDateSwimlane = sourceSwimlaneHasSprints && !destinationSwimlaneHasSprints;
        // Regardless of column change, update start / end date when epics are moved to swimlanes with linked sprints
        // or when both epic and story-level issues are moved from sprint linked swimlanes to date range swimlanes
        if (sprintSwimlaneToDateSwimlane || destinationSwimlaneHasSprints || isColumnChange) {
            // Update start and end dates
            innerValues = startEndValues;
            // Clear sprints when moving to unscheduled column
            // or when epics moving to a column linked to sprints
            if (destinationColumn && ((0, $esu6n.isUnscheduledColumn)(destinationColumn) || destinationSwimlaneHasSprints)) innerValues.sprint = null;
        }
        if (isSwimlaneChange) {
            // if moving an issue from sprint associated team/column to teamless swimlane or team w/out sprint assoc we assign iteration dates
            if (sprintSwimlaneToDateSwimlane) // Update start and end dates
            innerValues = {
                ...innerValues,
                ...startEndValues
            };
            innerValues.team = destinationSwimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) ? null : destinationSwimlaneId;
        }
        if (shouldClearSprint) innerValues.sprint = null;
        return innerValues;
    })();
    return (0, $kVLXA.Observable).of((0, $dMBwz.issueBulkUpdateRequest)({
        issueIds: issueIds,
        ...values
    }));
}
/* This function is called for Story level issues where the destination team column has a sprint association */ function $f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMoveWithSprint(state, { payload: { issueIds: issueIds, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId } }, { customRequestHandlers: customRequestHandlers }, sprintId) {
    if (!customRequestHandlers || !customRequestHandlers.bulkUpdateIssues) return $f9e1d3bcbac4e8b5$var$error(state, issueIds, new Error('no request handler found for swimlane and column move'));
    const incrementConfig = (0, $67Z81.getIncrementConfig)(state);
    if (incrementConfig === null) return $f9e1d3bcbac4e8b5$var$error(state, issueIds, new Error('incrementConfig cannot be null'));
    const values = (()=>{
        const innerValues = {};
        // assign sprint value when an issue moves from a different swimlane or column
        if (sourceSwimlaneId !== destinationSwimlaneId || destinationColumnId !== sourceColumnId) innerValues.sprint = `${sprintId}`;
        // assign team value when an issue moves from a different swimlane
        if (destinationSwimlaneId && sourceSwimlaneId !== destinationSwimlaneId) innerValues.team = destinationSwimlaneId;
        return innerValues;
    })();
    return (0, $kVLXA.Observable).of((0, $dMBwz.issueBulkUpdateRequest)({
        issueIds: issueIds,
        ...values
    }));
}
function $f9e1d3bcbac4e8b5$export$e8f4ada03ddbca5e(store, action, dependencies) {
    const state = store.getState();
    const { rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } = action.payload;
    const hasRankChanged = !((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankBeforeIssueId) && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rankAfterIssueId));
    return $f9e1d3bcbac4e8b5$var$doSwimlaneAndColumnMove(state, action, dependencies).flatMap((followUpAction)=>{
        if (followUpAction) return (0, $kVLXA.Observable).merge(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        followUpAction, hasRankChanged ? $f9e1d3bcbac4e8b5$var$doRank(state, action, dependencies) : $f9e1d3bcbac4e8b5$var$success());
        return hasRankChanged ? $f9e1d3bcbac4e8b5$var$doRank(state, action, dependencies) : $f9e1d3bcbac4e8b5$var$success();
    }).catch((err)=>$f9e1d3bcbac4e8b5$var$error(state, action.payload.issueIds, err));
}
function $f9e1d3bcbac4e8b5$export$83fa292e308a3ba(action$, store, dependencies) {
    return action$.ofType((0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)).mergeMap((action)=>$f9e1d3bcbac4e8b5$export$e8f4ada03ddbca5e(store, action, dependencies));
}

});

parcelRegister("7UfD9", function(module, exports) {

$parcel$export(module.exports, "issueRankTransitionEpic", () => $e472efe013064c67$export$1768053f95c4bd6a);
parcelRequire("fp4O3");
parcelRequire("zjDln");
parcelRequire("9IWoG");
parcelRequire("6hSeW");
parcelRequire("d0pqD");
parcelRequire("93e44");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");


var $c79wa = parcelRequire("c79wa");

var $41Cb8 = parcelRequire("41Cb8");

var $4EkCk = parcelRequire("4EkCk");

var $2W0EG = parcelRequire("2W0EG");

var $9iM6y = parcelRequire("9iM6y");

var $bwTbl = parcelRequire("bwTbl");

var $lWvJn = parcelRequire("lWvJn");

var $hdmw1 = parcelRequire("hdmw1");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $lIysR = parcelRequire("lIysR");

var $fyeGd = parcelRequire("fyeGd");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");

var $cN1y7 = parcelRequire("cN1y7");

var $7mswo = parcelRequire("7mswo");
function $e472efe013064c67$export$ee82a854da62e9b7(analyticsEvent, state, { payload: { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, isDestinationDone: isDestinationDone, sourceStatus: sourceStatus, destinationStatus: destinationStatus } }) {
    const updatedItems = [];
    let rankOnlyOp = true;
    const firstStatusInDestinationColumn = (0, $fyeGd.getStatusesByColumnId)(state)(destinationColumnId)[0];
    updatedItems.push({
        name: 'statusCategory',
        oldValName: sourceStatus?.category,
        // destinationStatus is undefined when board is in default mode, retrieve first status from destination column
        newValName: destinationStatus ? destinationStatus?.category : firstStatusInDestinationColumn.category
    });
    if (sourceSwimlaneId !== destinationSwimlaneId) {
        updatedItems.push({
            name: 'assignee'
        }, {
            name: 'swimlane'
        });
        rankOnlyOp = false;
    }
    if (sourceColumnId !== destinationColumnId) {
        updatedItems.push({
            name: 'status',
            oldValId: sourceStatus?.id,
            // destinationStatus is undefined when board is in default mode, retrieve first status from destination column
            newValId: destinationStatus ? destinationStatus?.id : firstStatusInDestinationColumn.id
        });
        const isSourceDone = (0, $fyeGd.isDoneColumnSelector)(state)(sourceColumnId);
        if (isSourceDone !== isDestinationDone) updatedItems.push({
            name: 'resolution',
            oldValId: isSourceDone,
            newValId: isDestinationDone
        });
        rankOnlyOp = false;
    }
    if (rankOnlyOp) updatedItems.push({
        name: `customfield_${(0, $d2i8f.getRankConfig)(state).rankCustomFieldId}`
    });
    const issueTypeLevel = (0, $d2i8f.getIssueTypeLevelForBoardIssue)(state)(issueIds[0]);
    analyticsEvent.update({
        updatedItems: updatedItems,
        issueTypeLevel: issueTypeLevel
    });
}
function $e472efe013064c67$export$dd20008182c41b85(state, { payload: { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, transitionId: transitionId } }) {
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issueKeys = issueIds.map((issueId)=>allIssues[String(issueId)]?.key);
    const { rankCustomFieldId: rankCustomFieldId } = (0, $d2i8f.getRankConfig)(state);
    const requestPayload = {
        rapidViewId: rapidViewId,
        issueKeys: issueKeys,
        rankCustomFieldId: rankCustomFieldId,
        rankBeforeIssueIdOrKey: rankBeforeIssueId,
        rankAfterIssueIdOrKey: rankAfterIssueId
    };
    // If FF enabled, make sure we filter by project key as well
    const issue = allIssues[String(issueIds[0])];
    const selectedTransition = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) && sourceColumnId !== destinationColumnId ? (0, $fyeGd.firstGlobalTransitionIdForColumnWithProjectFilteringSelector)(state)(destinationColumnId, issue) : transitionId;
    return {
        ...requestPayload,
        selectedTransitionId: selectedTransition
    };
}
function $e472efe013064c67$export$2f1dedbab5d9015b(state, { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } }) {
    const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issueKeys = issueIds.map((issueId)=>allIssues[String(issueId)]?.key);
    const { rankCustomFieldId: rankCustomFieldId } = (0, $d2i8f.getRankConfig)(state);
    return {
        rapidViewId: rapidViewId,
        issueKeys: issueKeys,
        rankCustomFieldId: rankCustomFieldId,
        rankBeforeIssueIdOrKey: rankBeforeIssueId,
        rankAfterIssueIdOrKey: rankAfterIssueId
    };
}
/**
 * Perform all updates for a swimlane move drag operation and return an
 * observable that completes after all of the operations emit.
 *
 * If multiple issues are moved between swimlanes at the same time, this will
 * fire requests concurrently.
 */ function $e472efe013064c67$var$doSwimlaneMove(state, { payload: { issueIds: issueIds, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId } }) {
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const contextPath = (0, $67Z81.contextPathSelector)(state);
    const projectId = (0, $67Z81.projectIdSelector)(state);
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const values = destinationSwimlaneId && sourceSwimlaneId !== destinationSwimlaneId ? (0, $4jZ56.makeSwimlaneValuesSelector)(state)(destinationSwimlaneId) : null;
    if (!values) return (0, $kVLXA.Observable).empty();
    if (values.type === (0, $c79wa.ASSIGNEE)) {
        const issueFields = (0, $bwTbl.getIssueCreateOrUpdateFields)(values);
        return (0, $kVLXA.Observable).forkJoin(issueIds.map((issueId)=>(0, $lWvJn.issueUpdateService)(ctx, {
                issueKey: allIssues[String(issueId)]?.key,
                values: issueFields
            })));
    }
    if (values.type === (0, $c79wa.STORY)) {
        if (isCMPBoard) return (0, $kVLXA.Observable).forkJoin(issueIds.map((issueId)=>{
            const issueKey = (0, $d2i8f.getIssueById)(state, issueId)?.key;
            return (0, $4EkCk.fetchSetCMPIssueParent)(issueKey, Number(values.parentId));
        }));
        return (0, $4EkCk.fetchSetIssueParent)(contextPath, projectId, Number(values.parentId), {
            issueIds: issueIds
        });
    }
    if (values.type === (0, $c79wa.PARENT)) {
        if (isCMPBoard) return (0, $kVLXA.Observable).forkJoin(issueIds.map((issueId)=>{
            const issueKey = (0, $d2i8f.getIssueById)(state, issueId)?.key;
            return (0, $4EkCk.fetchSetCMPIssueParent)(issueKey, values.parentId ? Number(destinationSwimlaneId) : null);
        }));
        if (values.parentId) return (0, $4EkCk.fetchSetIssueParent)(contextPath, projectId, Number(destinationSwimlaneId), {
            issueIds: issueIds
        });
        // If parentId is null then we need to unassign the parent
        return (0, $41Cb8.default)(contextPath, projectId, {
            issueIds: issueIds
        });
    }
    return (0, $kVLXA.Observable).empty();
}
const $e472efe013064c67$export$3134aad02465a5ae = ({ issueKeys: issueKeys, issueIds: issueIds, analyticsEvent: analyticsEvent, txId: txId, extraAnalyticsAttrs: extraAnalyticsAttrs, parentIds: parentIds, batchId: batchId, isCMPBoard: isCMPBoard, destinationStatus: destinationStatus })=>{
    if (analyticsEvent) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'cards moved', {
        ...extraAnalyticsAttrs,
        issueKeys: issueKeys.toString(),
        issueIds: issueIds.toString()
    });
    if (analyticsEvent && parentIds) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueParent updated', {
        ...extraAnalyticsAttrs,
        issueKeys: issueKeys.toString(),
        issueIds: issueIds.toString(),
        parentId: parentIds.toString()
    });
    const actions = [
        (0, $71oFY.issueRankTransitionSuccess)({
            optimisticId: txId,
            issueIds: issueIds,
            batchId: batchId,
            analyticsEvent: analyticsEvent,
            issueKeys: issueKeys,
            destinationStatus: destinationStatus
        })
    ];
    if (!isCMPBoard) actions.push((0, $evkwq.issueUpdateRequestWithTransactionId)(issueIds, (0, $f32ae13c2b9742f4$export$f2127cf693ff3edc), txId));
    return (0, $kVLXA.Observable).from(actions);
};
function $e472efe013064c67$export$d2523457fef715f({ error: error, issue: issue, txId: txId, batchId: batchId, analyticsEvent: analyticsEvent }) {
    (0, $2YZCu.default).safeErrorWithoutCustomerData('transition.and.rank.failure', 'Failed to transition issue', error);
    if (analyticsEvent && (0, $cN1y7.shouldFireFailureSLOMetric)(error)) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cards moveFailed', {
        errorMessage: error.message ? error.message : error,
        statusCodeGroup: (0, $cN1y7.getStatusCodeGroup)(error)
    });
    if ((0, $fZneA.isHttpTooManyRequestsResponse)(error)) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'cards moveAborted', {
        errorMessage: error.message ? error.message : error,
        statusCodeGroup: '429'
    });
    return (0, $kVLXA.Observable).of((0, $71oFY.issueRankTransitionFailure)(txId, issue, batchId, error, error.traceId));
}
function $e472efe013064c67$export$ebec16eb1bd24c45(store, action) {
    const state = store.getState();
    const { payload: { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, batchId: batchId, transitionId: transitionId, isDestinationDone: isDestinationDone, destinationStatus: destinationStatus, rankAfterIssueId: rankAfterIssueId, rankBeforeIssueId: rankBeforeIssueId, isRankable: isRankable, mode: mode }, meta: { analyticsEvent: analyticsEvent } } = action;
    const txIdOld = String(action.meta.optimistic?.id);
    const requestPayload = $e472efe013064c67$export$dd20008182c41b85(state, action);
    $e472efe013064c67$export$ee82a854da62e9b7(analyticsEvent, state, action);
    const allIssues = (0, $vAfHD.boardIssuesSelector)(state);
    const issueParents = issueIds.map((issueId)=>allIssues[String(issueId)].parentId);
    const issue = allIssues[String(issueIds[0])];
    const destinationTransitions = (0, $lIysR.getTransitionsByColumnAndIssueType)(state, {
        columnId: destinationColumnId,
        issueTypeId: issue.typeId,
        projectId: issue.projectId
    });
    const transitionIndex = requestPayload.selectedTransitionId != null ? destinationTransitions.findIndex((transition)=>transition.id === requestPayload.selectedTransitionId) : null;
    const transition = transitionIndex != null ? destinationTransitions[transitionIndex] : null;
    const extraAnalyticsAttrs = {
        movedColumns: sourceColumnId !== destinationColumnId,
        hasMovedSwimlanes: sourceSwimlaneId !== destinationSwimlaneId,
        columnTransitionsCount: destinationTransitions.length,
        transitionIndex: transitionIndex
    };
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const transitionOptimisticUpdateAction = (0, $71oFY.issueRankTransitionUpdateOptimistic)({
        sourceColumnId: sourceColumnId,
        issueIds: issueIds,
        destinationColumnId: destinationColumnId,
        isDestinationDone: isDestinationDone,
        destinationStatus: destinationStatus,
        rankAfterIssueId: rankAfterIssueId,
        rankBeforeIssueId: rankBeforeIssueId,
        isRankable: isRankable,
        mode: mode,
        isCMPBoard: isCMPBoard,
        analyticsEvent: analyticsEvent
    });
    const txId = transitionOptimisticUpdateAction.meta.optimistic.id ?? txIdOld;
    const transitionOptimisticUpdate$ = (0, $kVLXA.Observable).of(transitionOptimisticUpdateAction);
    const error = (err)=>{
        !transition?.hasScreen && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
            triggerPointKey: (0, $7mswo.SOFTWARE_BOARD_ISSUE_TRANSITION),
            isModalOpen: false
        });
        return (0, $2W0EG.hasJiraErrorMessages)(err) ? (0, $kVLXA.Observable).of((0, $71oFY.issueRankTransitionFailureFieldRequired)(txId, issue, (0, $2W0EG.parseJiraErrorMessages)(err), err, err.traceId)) : $e472efe013064c67$export$d2523457fef715f({
            error: err,
            issue: issue,
            txId: txId,
            batchId: batchId,
            analyticsEvent: analyticsEvent
        });
    };
    const success = ()=>{
        !transition?.hasScreen && (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition success', {
            triggerPointKey: (0, $7mswo.SOFTWARE_BOARD_ISSUE_TRANSITION),
            isModalOpen: false
        });
        return $e472efe013064c67$export$3134aad02465a5ae({
            issueKeys: requestPayload.issueKeys,
            issueIds: issueIds,
            analyticsEvent: analyticsEvent,
            txId: txId,
            extraAnalyticsAttrs: extraAnalyticsAttrs,
            parentIds: issueParents,
            batchId: batchId,
            isCMPBoard: isCMPBoard,
            destinationStatus: destinationStatus?.name
        });
    };
    const hasScreen = transition?.hasScreen === true;
    const doTransitionRank = ()=>{
        const ctx = (0, $hdmw1.makeServiceContext)(store.getState());
        if (hasScreen) {
            const dispatch = store.dispatch.bind(store);
            // TODO this only works for single issue drag, also if this is
            // aborted or fails the correct behaviour would be to revert the
            // entire operation, but we will already have committed issue field
            // changes.
            return (0, $7mswo.openTransitionScreen)({
                issueId: String(issue.id),
                issueKey: issue.key,
                transitionId: transition.id,
                analyticsEvent: analyticsEvent,
                dispatch: dispatch
            }).flatMap((result)=>{
                if (result.type === (0, $7mswo.TRANSITION_SCREEN_SUCCESS)) {
                    if (!isRankable) return (0, $kVLXA.Observable).merge(transitionOptimisticUpdate$, success());
                    const shouldRankRequest = mode === 'TRANSITION_AND_RANK' && (rankBeforeIssueId || rankAfterIssueId);
                    // don't rank request if there are no issues to rank against
                    if (!shouldRankRequest) return (0, $kVLXA.Observable).merge(transitionOptimisticUpdate$, success());
                    const requestRankPayload = $e472efe013064c67$export$2f1dedbab5d9015b(state, action);
                    return (0, $kVLXA.Observable).merge(transitionOptimisticUpdate$, (0, $9iM6y.issueRankTransitionService)(ctx, requestRankPayload).flatMap(()=>success()).catch((err)=>error(err)));
                }
                if (result.type === (0, $7mswo.TRANSITION_SCREEN_CANCEL)) return (0, $kVLXA.Observable).of((0, $71oFY.issueRankTransitionAbort)(txId));
                if (result.type === (0, $7mswo.TRANSITION_SCREEN_ERROR)) return error(result.error);
                return (0, $kVLXA.Observable).empty();
            });
        }
        if (mode === 'TRANSITION_ONLY') // Call the transition API used in legacy CMP to retain the ranking order after transition,
        // remove this once issueRankTransitionService supports this
        return (0, $9iM6y.issueTransitionService)(ctx, {
            issueKeys: requestPayload.issueKeys,
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            selectedTransitionId: transitionId,
            targetColumn: destinationColumnId
        }).flatMap(()=>success()).catch((err)=>error(err));
        return (0, $9iM6y.issueRankTransitionService)(ctx, requestPayload).flatMap(()=>success()).catch((err)=>error(err));
    };
    const hasRankOrTransitionChanged = Boolean(requestPayload.rankAfterIssueIdOrKey != null || requestPayload.rankBeforeIssueIdOrKey != null || requestPayload.selectedTransitionId != null);
    const hasSwimlaneChanged = Boolean(destinationSwimlaneId && sourceSwimlaneId !== destinationSwimlaneId);
    if (!hasSwimlaneChanged) return (0, $kVLXA.Observable).merge(hasScreen ? (0, $kVLXA.Observable).empty() : transitionOptimisticUpdate$, doTransitionRank());
    return (0, $kVLXA.Observable).merge(hasScreen ? (0, $kVLXA.Observable).empty() : transitionOptimisticUpdate$, $e472efe013064c67$var$doSwimlaneMove(state, action).catch((err)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('pre.issue.transition.update.failure', 'Failed to prepare issues data to transition', err);
        if (hasRankOrTransitionChanged) return (0, $kVLXA.Observable).of(null);
        throw err;
    }).flatMap(()=>hasRankOrTransitionChanged ? doTransitionRank() : success()).catch((err)=>error(err)));
}
const $e472efe013064c67$var$concurrencyLimits = 10;
function $e472efe013064c67$export$1768053f95c4bd6a(action$, store) {
    return action$.ofType((0, $71oFY.ISSUE_RANK_TRANSITION_REQUEST)).mergeMap((action)=>$e472efe013064c67$export$ebec16eb1bd24c45(store, action), $e472efe013064c67$var$concurrencyLimits);
}

});
parcelRegister("41Cb8", function(module, exports) {

$parcel$export(module.exports, "default", () => $9040bbece1764cea$export$2e2bcd8739ae039);

var $487fd = parcelRequire("487fd");
const $9040bbece1764cea$export$65ffcd95f70c1bda = (contextPath, projectId)=>`${contextPath}/rest/internal/simplified/1.0/projects/${projectId}/issues/delete-parents?operation=DeleteIssueParent`;
var // Remove with TOTEM-2726 ff
// eslint-disable-next-line jira/import/no-anonymous-default-export
$9040bbece1764cea$export$2e2bcd8739ae039 = (contextPath, projectId, payload)=>(0, $487fd.default)($9040bbece1764cea$export$65ffcd95f70c1bda(contextPath, projectId), {
        method: 'POST',
        body: JSON.stringify(payload)
    });

});

parcelRegister("4EkCk", function(module, exports) {

$parcel$export(module.exports, "fetchSetIssueParent", () => $750c8ada738ff48c$export$822e6d48be31975);
$parcel$export(module.exports, "fetchSetCMPIssueParent", () => $750c8ada738ff48c$export$9724e1b3adad0582);

var $487fd = parcelRequire("487fd");
const $750c8ada738ff48c$var$getIssueSetParentUrl = (contextPath, projectId, parentId)=>`${contextPath}/rest/internal/simplified/1.0/projects/${projectId}/issues/${parentId}/children?operation=SetIssueParent`;
const $750c8ada738ff48c$export$822e6d48be31975 = (contextPath, projectId, parentId, payload)=>(0, $487fd.default)($750c8ada738ff48c$var$getIssueSetParentUrl(contextPath, projectId, parentId), {
        method: 'POST',
        body: JSON.stringify(payload)
    });
const $750c8ada738ff48c$export$9724e1b3adad0582 = (issueKey, parentId)=>(0, $487fd.default)(`/rest/api/3/issue/${issueKey}?operation=SetCMPIssueParent`, {
        method: 'PUT',
        body: JSON.stringify({
            fields: {
                parent: {
                    id: parentId && String(parentId)
                }
            }
        })
    });

});

parcelRegister("7mswo", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_SCREEN_SUCCESS", () => $d142bca829a4b440$export$e8f04beef9e7ac2b);
$parcel$export(module.exports, "TRANSITION_SCREEN_ERROR", () => $d142bca829a4b440$export$15efa9bd4dbe702b);
$parcel$export(module.exports, "TRANSITION_SCREEN_CANCEL", () => $d142bca829a4b440$export$96ee4dc1a27f098d);
$parcel$export(module.exports, "SOFTWARE_BOARD_ISSUE_TRANSITION", () => $d142bca829a4b440$export$f662a3f45b12c977);
$parcel$export(module.exports, "openTransitionScreen", () => $d142bca829a4b440$export$8cdda22e86b8604a);

var $kVLXA = parcelRequire("kVLXA");

var $8zOmE = parcelRequire("8zOmE");

var $1fh1A = parcelRequire("1fh1A");
const $d142bca829a4b440$export$e8f04beef9e7ac2b = 'TRANSITION_SCREEN_SUCCESS';
const $d142bca829a4b440$export$15efa9bd4dbe702b = 'TRANSITION_SCREEN_ERROR';
const $d142bca829a4b440$export$96ee4dc1a27f098d = 'TRANSITION_SCREEN_CANCEL';
const $d142bca829a4b440$export$f662a3f45b12c977 = 'software-board-issue-transition';
function $d142bca829a4b440$export$8cdda22e86b8604a({ issueId: issueId, issueKey: issueKey, transitionId: transitionId, analyticsEvent: analyticsEvent, dispatch: dispatch }) {
    return new (0, $kVLXA.Observable)((subscriber)=>{
        const handleDialogSuccess = ()=>{
            subscriber.next({
                type: $d142bca829a4b440$export$e8f04beef9e7ac2b
            });
            subscriber.complete();
            // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition success', {
                triggerPointKey: $d142bca829a4b440$export$f662a3f45b12c977,
                isModalOpen: true
            });
        };
        const handleDialogCancel = ()=>{
            subscriber.next({
                type: $d142bca829a4b440$export$96ee4dc1a27f098d
            });
            subscriber.complete();
            // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition cancel', {
                triggerPointKey: $d142bca829a4b440$export$f662a3f45b12c977,
                isModalOpen: true
            });
        };
        const handleDialogError = (error)=>{
            subscriber.next({
                type: $d142bca829a4b440$export$15efa9bd4dbe702b,
                error: error ?? new Error('Failed to execute transition screen')
            });
            subscriber.complete();
            // @ts-expect-error - Argument of type 'UIAnalyticsEvent | undefined' is not assignable to parameter of type 'UIAnalyticsEvent'.
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issueTransition failed', {
                triggerPointKey: $d142bca829a4b440$export$f662a3f45b12c977,
                isModalOpen: true
            });
        };
        dispatch((0, $1fh1A.openIssueTransitionModal)({
            issueId: issueId,
            issueKey: issueKey,
            transitionId: String(transitionId),
            onDialogCancel: handleDialogCancel,
            onDialogError: handleDialogError,
            onDialogSuccess: handleDialogSuccess
        }));
    });
}

});
parcelRegister("1fh1A", function(module, exports) {

$parcel$export(module.exports, "OPEN_ISSUE_TRANSITION_MODAL", () => $6b36abdf6f0f816d$export$8832c8eada77a7);
$parcel$export(module.exports, "openIssueTransitionModal", () => $6b36abdf6f0f816d$export$bb76131907dfafc);
$parcel$export(module.exports, "CLOSE_ISSUE_TRANSITION_MODAL", () => $6b36abdf6f0f816d$export$e15861bd6dba960e);
$parcel$export(module.exports, "closeIssueTransitionModal", () => $6b36abdf6f0f816d$export$221941c279d4f72);
const $6b36abdf6f0f816d$export$8832c8eada77a7 = 'state.actions.issue.update-issue-parent-modal.OPEN_ISSUE_TRANSITION_MODAL';
const $6b36abdf6f0f816d$export$bb76131907dfafc = (payload)=>({
        type: $6b36abdf6f0f816d$export$8832c8eada77a7,
        payload: payload
    });
const $6b36abdf6f0f816d$export$e15861bd6dba960e = 'state.actions.issue.update-issue-parent-modal.CLOSE_ISSUE_TRANSITION_MODAL';
const $6b36abdf6f0f816d$export$221941c279d4f72 = ()=>({
        type: $6b36abdf6f0f816d$export$e15861bd6dba960e
    });

});



parcelRegister("bTMOX", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c04ebdce5640308$export$2e2bcd8739ae039);
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");


var $iuuJH = parcelRequire("iuuJH");

var $bwTbl = parcelRequire("bwTbl");

var $71oFY = parcelRequire("71oFY");

var $9OPlz = parcelRequire("9OPlz");

var $cPmFH = parcelRequire("cPmFH");

var $d2i8f = parcelRequire("d2i8f");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$7c04ebdce5640308$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $71oFY.ISSUE_MOVE_TOP_OR_BOTTOM_OF_CONTAINER)).mergeMap((action)=>{
        const state = store.getState();
        const { payload: { placement: placement, fireShortcutAnalyticsFn: fireShortcutAnalyticsFn }, meta: { analyticsEvent: analyticsEvent } } = action;
        const issueIds = (0, $9OPlz.getCardSelection)(state);
        // will be removed if multi-select movement is added
        if (issueIds.length !== 1) return (0, $kVLXA.Observable).empty();
        const issueId = issueIds[0];
        const issue = (0, $d2i8f.getIssueById)(state, issueId);
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        const hasSwimlanes = swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id;
        const isTop = placement === (0, $dcbb2bce513725b3$export$e5bf25b985a7619d);
        const isBottom = placement === (0, $dcbb2bce513725b3$export$e044c7349fbdcb2);
        const isFirst = !hasSwimlanes ? (0, $d2i8f.isFirstIssueInColumn)(state, issueId) : (0, $cPmFH.isFirstIssueInSwimlane)(state, issueId);
        const isLast = !hasSwimlanes ? (0, $d2i8f.isLastIssueInColumn)(state, issueId) : (0, $cPmFH.isLastIssueInSwimlane)(state, issueId);
        if (isTop && isFirst || isBottom && isLast) return (0, $kVLXA.Observable).empty();
        const swimlaneId = hasSwimlanes ? (0, $bwTbl.getSwimlaneId)(swimlaneMode, (0, $4jZ56.getSwimlanes)(state), issue) : null;
        const firstIssueId = !hasSwimlanes || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) ? (0, $d2i8f.getFirstIssueInColumn)(state, issue.columnId) : (0, $cPmFH.getFirstIssueIdInSwimlane)(state, issue.columnId, swimlaneId);
        const lastIssueId = !hasSwimlanes || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) ? (0, $d2i8f.getLastIssueInColumn)(state, issue.columnId) : (0, $cPmFH.getLastIssueIdInSwimlane)(state, issue.columnId, swimlaneId);
        const payload = {
            issueIds: issueIds,
            sourceColumnId: issue.columnId,
            destinationColumnId: issue.columnId,
            rankBeforeIssueId: isTop ? firstIssueId : null,
            rankAfterIssueId: isBottom ? lastIssueId : null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        };
        const attributes = {
            key: isTop ? 's t' : 's b',
            id: isTop ? 'sendToTopKeyboardShortcut' : 'sendToBottomKeyboardShortcut',
            attributes: {
                isMultiSelect: issueIds.length > 1
            }
        };
        fireShortcutAnalyticsFn(attributes);
        return (0, $kVLXA.Observable).of((0, $71oFY.issueRankTransitionRequest)(payload));
    });

});
parcelRegister("cPmFH", function(module, exports) {

$parcel$export(module.exports, "getFirstIssueIdInSwimlane", () => $354fa4f988c91859$export$98ede6267b8600eb);
$parcel$export(module.exports, "getLastIssueIdInSwimlane", () => $354fa4f988c91859$export$e7018d5dca9b70f6);
$parcel$export(module.exports, "isFirstIssueInSwimlane", () => $354fa4f988c91859$export$c1b8534c3ed82c1c);
$parcel$export(module.exports, "isLastIssueInSwimlane", () => $354fa4f988c91859$export$fc100c375fce1b71);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $hYfgW = parcelRequire("hYfgW");

var $bwTbl = parcelRequire("bwTbl");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");
const $354fa4f988c91859$export$5111e8c99c5b8e11 = (0, $dGvGJ.createSelector)([
    (0, $4jZ56.getSwimlanes),
    (0, $45cXl.getSwimlaneMode),
    (0, $d2i8f.getOrderedIssuesByColumn)
], (swimlanes, swimlaneMode, issues)=>{
    const swimlaneIssuesMap = {};
    swimlanes.forEach((swimlane)=>{
        swimlaneIssuesMap[swimlane.id] = Object.keys(issues).reduce((groupedIssues, columnId)=>{
            groupedIssues.setIn([
                String(columnId)
            ], issues[Number(columnId)].filter((issue)=>(0, $bwTbl.getSwimlaneId)(swimlaneMode, swimlanes, issue) === swimlane.id));
            return groupedIssues;
        }, (0, $7uUwQ.chain)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {})).value();
    });
    return swimlaneIssuesMap;
});
const $354fa4f988c91859$export$283bde08d2f5fddb = (state, swimlaneId)=>{
    let issueCount = 0;
    const swimlane = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($354fa4f988c91859$export$5111e8c99c5b8e11(state), [
        swimlaneId
    ], null);
    if (swimlane) Object.values(swimlane).forEach((column)=>{
        issueCount += column.length;
    });
    return issueCount === 0;
};
const $354fa4f988c91859$export$98ede6267b8600eb = (state, columnId, swimlaneId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($354fa4f988c91859$export$5111e8c99c5b8e11(state), [
        swimlaneId,
        columnId,
        0,
        'id'
    ], null);
const $354fa4f988c91859$export$e7018d5dca9b70f6 = (state, columnId, swimlaneId)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))($354fa4f988c91859$export$5111e8c99c5b8e11(state), [
        swimlaneId,
        columnId
    ], [])), [
        'id'
    ], null);
const $354fa4f988c91859$export$c1b8534c3ed82c1c = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue)) return false;
    const swimlaneId = (0, $bwTbl.getSwimlaneId)((0, $45cXl.getSwimlaneMode)(state), (0, $4jZ56.getSwimlanes)(state), issue);
    return issue !== undefined && swimlaneId !== null && $354fa4f988c91859$export$98ede6267b8600eb(state, issue.columnId, swimlaneId) === issueId;
};
const $354fa4f988c91859$export$fc100c375fce1b71 = (state, issueId)=>{
    const issue = (0, $vAfHD.boardIssuesSelector)(state)[String(issueId)];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue)) return false;
    const swimlaneId = (0, $bwTbl.getSwimlaneId)((0, $45cXl.getSwimlaneMode)(state), (0, $4jZ56.getSwimlanes)(state), issue);
    return issue !== undefined && swimlaneId !== null && $354fa4f988c91859$export$e7018d5dca9b70f6(state, issue.columnId, swimlaneId) === issueId;
};

});


parcelRegister("9mZdS", function(module, exports) {

$parcel$export(module.exports, "issueUnlinkEpic", () => $ff3b15731b9213fe$export$7533c4e5f6ddb0de);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");

var $6WzWZ = parcelRequire("6WzWZ");
function $ff3b15731b9213fe$export$7533c4e5f6ddb0de(action$, store, { customRequestHandlers: customRequestHandlers }) {
    return action$.ofType((0, $6WzWZ.ISSUE_LINKS_REMOVE_REQUEST)).mergeMap((action)=>{
        const { issueId: issueId, issueLink: issueLink } = action.payload;
        const success = ()=>(0, $kVLXA.Observable).of((0, $6WzWZ.issueLinksRemoveSuccess)({
                issueLinksToRemove: {
                    [issueId]: issueLink.id
                }
            }));
        const error = (err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.issue-unlink-epic.failure', 'Failed to unlink IP board issue', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            return (0, $kVLXA.Observable).of((0, $6WzWZ.issueLinksRemoveFailed)());
        };
        if (!customRequestHandlers || !customRequestHandlers.removeIssueLink) return error(new Error('no request handler found for removing dependency'));
        return (0, $kVLXA.Observable).from(customRequestHandlers.removeIssueLink({
            itemKey: issueLink.id,
            type: issueLink.linkTypeId,
            sourceItemKey: `${issueLink.sourceId}`,
            targetItemKey: `${issueLink.destinationId}`
        })).flatMap(()=>success()).catch((err)=>error(err));
    });
}

});

parcelRegister("bIfkc", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c2ed91379dc4a3d$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $6oxJH = parcelRequire("6oxJH");

var $bScH2 = parcelRequire("bScH2");

var $kVLXA = parcelRequire("kVLXA");


var $iuuJH = parcelRequire("iuuJH");

var $4nScF = parcelRequire("4nScF");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $71oFY = parcelRequire("71oFY");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");
const $7c2ed91379dc4a3d$export$735389bea7eedaad = (action$, store)=>action$.ofType((0, $ls4NM.ISSUE_CREATE_REQUEST)).mergeMap((action)=>{
        const { payload: { issues: issues, type: type }, meta: { swimlaneId: swimlaneId } } = action;
        const allIssues = (0, $67Z81.getIssues)(store.getState());
        if (type !== (0, $dcbb2bce513725b3$export$1f24f91824c6822f)) return (0, $kVLXA.Observable).empty();
        const parent = allIssues[String(swimlaneId)];
        if (!parent) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $4nScF.setChildIssuesMetadata)([
            {
                id: parent.id,
                numTotalChildren: parent.numTotalChildren + issues.length,
                numCompleteChildren: parent.numCompleteChildren + (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(issues, (issue)=>issue.isDone ? 1 : 0)
            }
        ]));
    });
const $7c2ed91379dc4a3d$export$6460f58b640b4012 = (action$, store)=>action$.ofType((0, $kXqRJ.ISSUE_DELETE_REQUEST)).mergeMap((action)=>{
        const { payload: { issue: issue } } = action;
        const state = store.getState();
        if ((0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return (0, $kVLXA.Observable).empty();
        const issues = (0, $67Z81.getIssues)(state);
        const parent = issues[String(issue.parentId)];
        if (!parent) return (0, $kVLXA.Observable).empty();
        return (0, $kVLXA.Observable).of((0, $4nScF.setChildIssuesMetadata)([
            {
                id: parent.id,
                numTotalChildren: parent.numTotalChildren - 1,
                numCompleteChildren: parent.numCompleteChildren - (issue.isDone ? 1 : 0)
            }
        ]));
    });
const $7c2ed91379dc4a3d$export$2ad8924ae4613236 = (action$, store)=>action$.ofType((0, $71oFY.ISSUE_RANK_TRANSITION_REQUEST)).mergeMap((action)=>{
        const { payload: { issueIds: issueIds, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, isSourceDone: isSourceDone, isDestinationDone: isDestinationDone } } = action;
        const state = store.getState();
        if ((0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return (0, $kVLXA.Observable).empty();
        const issues = (0, $67Z81.getIssues)(state);
        const sourceParent = issues[String(sourceSwimlaneId)];
        const destinationParent = issues[String(destinationSwimlaneId)];
        if (!sourceParent || !destinationParent || sourceSwimlaneId === destinationSwimlaneId && isSourceDone === isDestinationDone) return (0, $kVLXA.Observable).empty();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const updatedIssues = {};
        updatedIssues[String(sourceSwimlaneId)] = {
            numTotalChildren: sourceParent.numTotalChildren,
            numCompleteChildren: sourceParent.numCompleteChildren
        };
        updatedIssues[String(destinationSwimlaneId)] = {
            numTotalChildren: destinationParent.numTotalChildren,
            numCompleteChildren: destinationParent.numCompleteChildren
        };
        if (sourceSwimlaneId !== destinationSwimlaneId) {
            (0, (/*@__PURE__*/$parcel$interopDefault($bScH2)))(updatedIssues, // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'PropertyName'.
            [
                sourceSwimlaneId,
                'numTotalChildren'
            ], (current)=>current - issueIds.length);
            (0, (/*@__PURE__*/$parcel$interopDefault($bScH2)))(updatedIssues, // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'PropertyName'.
            [
                destinationSwimlaneId,
                'numTotalChildren'
            ], (current)=>current + issueIds.length);
        }
        if (isSourceDone) (0, (/*@__PURE__*/$parcel$interopDefault($bScH2)))(updatedIssues, // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'PropertyName'.
        [
            sourceSwimlaneId,
            'numCompleteChildren'
        ], (current)=>current - issueIds.length);
        if (isDestinationDone) (0, (/*@__PURE__*/$parcel$interopDefault($bScH2)))(updatedIssues, // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'PropertyName'.
        [
            destinationSwimlaneId,
            'numCompleteChildren'
        ], (current)=>current + issueIds.length);
        const updatedItems = Object.keys(updatedIssues).map((id)=>{
            const { numTotalChildren: numTotalChildren, numCompleteChildren: numCompleteChildren } = updatedIssues[id];
            return {
                id: Number(id),
                numTotalChildren: numTotalChildren,
                numCompleteChildren: numCompleteChildren
            };
        });
        return (0, $kVLXA.Observable).of((0, $4nScF.setChildIssuesMetadata)(updatedItems));
    });
var $7c2ed91379dc4a3d$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($7c2ed91379dc4a3d$export$735389bea7eedaad, $7c2ed91379dc4a3d$export$6460f58b640b4012, $7c2ed91379dc4a3d$export$2ad8924ae4613236);

});
parcelRegister("6oxJH", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $gBzAF = parcelRequire("gBzAF");
/**
 * This method is like `_.sum` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be summed.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the sum.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.sumBy(objects, function(o) { return o.n; });
 * // => 20
 *
 * // The `_.property` iteratee shorthand.
 * _.sumBy(objects, 'n');
 * // => 20
 */ function $4a7f273a61dd10a7$var$sumBy(array, iteratee) {
    return array && array.length ? $gBzAF(array, $bxDef(iteratee, 2)) : 0;
}
module.exports = $4a7f273a61dd10a7$var$sumBy;

});
parcelRegister("gBzAF", function(module, exports) {
/**
 * The base implementation of `_.sum` and `_.sumBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the sum.
 */ function $c16bb58eedefe4cd$var$baseSum(array, iteratee) {
    var result, index = -1, length = array.length;
    while(++index < length){
        var current = iteratee(array[index]);
        if (current !== undefined) result = result === undefined ? current : result + current;
    }
    return result;
}
module.exports = $c16bb58eedefe4cd$var$baseSum;

});


parcelRegister("bScH2", function(module, exports) {

var $4tlBN = parcelRequire("4tlBN");

var $2KOtB = parcelRequire("2KOtB");
/**
 * This method is like `_.set` except that accepts `updater` to produce the
 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
 * is invoked with one argument: (value).
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 4.6.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {Function} updater The function to produce the updated value.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
 * console.log(object.a[0].b.c);
 * // => 9
 *
 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
 * console.log(object.x[0].y.z);
 * // => 0
 */ function $8a4e9576f44b63f2$var$update(object, path, updater) {
    return object == null ? object : $4tlBN(object, path, $2KOtB(updater));
}
module.exports = $8a4e9576f44b63f2$var$update;

});
parcelRegister("4tlBN", function(module, exports) {

var $fTwLR = parcelRequire("fTwLR");

var $ajB7H = parcelRequire("ajB7H");
/**
 * The base implementation of `_.update`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to update.
 * @param {Function} updater The function to produce the updated value.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $341aa1dd6380288c$var$baseUpdate(object, path, updater, customizer) {
    return $ajB7H(object, path, updater($fTwLR(object, path)), customizer);
}
module.exports = $341aa1dd6380288c$var$baseUpdate;

});


parcelRegister("4nScF", function(module, exports) {

$parcel$export(module.exports, "SET_CHILD_ISSUES_METADATA", () => $9ffdfdef102812b7$export$1a5205eaf2c29edc);
$parcel$export(module.exports, "setChildIssuesMetadata", () => $9ffdfdef102812b7$export$dc5bde40f28284aa);
const $9ffdfdef102812b7$export$1a5205eaf2c29edc = 'state.actions.issue.child-issues-metadata.SET_CHILD_ISSUES_METADATA';
const $9ffdfdef102812b7$export$dc5bde40f28284aa = (issues)=>({
        type: $9ffdfdef102812b7$export$1a5205eaf2c29edc,
        payload: issues
    });

});


parcelRegister("jlZom", function(module, exports) {

$parcel$export(module.exports, "missingParentResolveEpic", () => $927f535e38163999$export$7a4b906e63c2e974);

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");
parcelRequire("93e44");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");


var $9iM6y = parcelRequire("9iM6y");

var $hdmw1 = parcelRequire("hdmw1");

var $hDdMY = parcelRequire("hDdMY");

var $cW3pH = parcelRequire("cW3pH");

var $gXFr2 = parcelRequire("gXFr2");

var $lIysR = parcelRequire("lIysR");

var $67Z81 = parcelRequire("67Z81");

var $cN1y7 = parcelRequire("cN1y7");

var $7mswo = parcelRequire("7mswo");
const $927f535e38163999$var$handleSuccess = ({ optimisticId: optimisticId, issueId: issueId, issueKey: issueKey, transitionId: transitionId, projectId: projectId, analyticsEvent: analyticsEvent })=>{
    if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'missingParentResolution success', {
        issueKey: issueKey,
        issueId: issueId,
        transitionId: transitionId,
        projectId: projectId
    });
    return (0, $kVLXA.Observable).from([
        (0, $hDdMY.missingParentResolveSuccess)({
            optimisticId: optimisticId,
            issueId: issueId,
            analyticsEvent: analyticsEvent
        }),
        (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$ce2132697bb05fef))
    ]);
};
const $927f535e38163999$var$handleError = ({ optimisticId: optimisticId, issueId: issueId, issueKey: issueKey, transitionId: transitionId, projectId: projectId, analyticsEvent: analyticsEvent, error: error })=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData('missing.parent.resolution.failure', 'Failed to resolve missing parent', error);
    if (analyticsEvent && (0, $cN1y7.shouldFireFailureSLOMetric)(error)) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'missingParentResolution failed', {
        errorMessage: error.message ? error.message : error,
        statusCodeGroup: (0, $cN1y7.getStatusCodeGroup)(error),
        issueKey: issueKey,
        issueId: issueId,
        transitionId: transitionId,
        projectId: projectId
    });
    return (0, $kVLXA.Observable).of((0, $hDdMY.missingParentResolveFailure)({
        optimisticId: optimisticId,
        issueId: issueId,
        analyticsEvent: analyticsEvent,
        error: error
    }));
};
const $927f535e38163999$var$hasTransitionScreen = (store, action)=>{
    const state = store.getState();
    const { payload: { destinationColumnId: destinationColumnId, transitionId: transitionId, issueTypeId: issueTypeId, projectId: projectId } } = action;
    const destinationTransitions = (0, $lIysR.getTransitionsByColumnAndIssueType)(state, {
        columnId: destinationColumnId,
        issueTypeId: issueTypeId,
        projectId: projectId
    });
    const transitionIndex = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) ? destinationTransitions.findIndex((transition)=>transition.id === transitionId) : null;
    const transition = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionIndex) ? destinationTransitions[transitionIndex] : null;
    return Boolean(transition?.hasScreen);
};
const $927f535e38163999$var$handleTransitionScreen = (store, action)=>{
    const { payload: { issueId: issueId, issueKey: issueKey, transitionId: transitionId, projectId: projectId }, meta: { analyticsEvent: analyticsEvent } } = action;
    const dispatch = store.dispatch.bind(store);
    return (0, $7mswo.openTransitionScreen)({
        issueId: String(issueId),
        issueKey: issueKey,
        transitionId: transitionId,
        analyticsEvent: analyticsEvent,
        dispatch: dispatch
    }).flatMap((result)=>{
        if (result.type === (0, $7mswo.TRANSITION_SCREEN_SUCCESS)) return $927f535e38163999$var$handleMissingParentResolveAction(store, action);
        if (result.type === (0, $7mswo.TRANSITION_SCREEN_CANCEL)) return (0, $kVLXA.Observable).empty();
        if (result.type === (0, $7mswo.TRANSITION_SCREEN_ERROR)) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('missing.parent.transition.screen.error', 'Failed to resolve missing parent from transition screen', result.error);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'missingParentTransitionScreen error', {
                triggerPointKey: 'software-board-missing-parent-resolution-screen',
                isModalOpen: true,
                issueId: issueId,
                issueKey: issueKey,
                transitionId: transitionId,
                projectId: projectId
            });
            return (0, $kVLXA.Observable).empty();
        }
        return (0, $kVLXA.Observable).empty();
    });
};
function $927f535e38163999$var$handleMissingParentResolveAction(store, action) {
    const state = store.getState();
    const { payload: { issueId: issueId, issueKey: issueKey, issueTypeId: issueTypeId, destinationColumnId: destinationColumnId, transitionId: transitionId, projectId: projectId }, meta: { analyticsEvent: analyticsEvent } } = action;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(transitionId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(destinationColumnId)) return (0, $kVLXA.Observable).empty();
    const missingParents = (0, $67Z81.getMissingParents)(state);
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(missingParents)) return (0, $kVLXA.Observable).empty();
    const missingParent = missingParents[issueId];
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(missingParent) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(missingParent.projectId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(missingParent.typeId)) return (0, $kVLXA.Observable).empty();
    const destinationStatus = (0, $gXFr2.getDestinationStatusSelector)(state)(destinationColumnId, issueTypeId, transitionId);
    const transitionOptimisticAction = (0, $hDdMY.missingParentResolveOptimistic)({
        issueId: issueId,
        doneStatusName: destinationStatus?.name || ''
    });
    const optimisticId = transitionOptimisticAction.meta.optimistic.id;
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    return (0, $kVLXA.Observable).merge((0, $kVLXA.Observable).of(transitionOptimisticAction), (0, $9iM6y.issueTransitionService)(ctx, {
        issueKeys: [
            missingParent.key
        ],
        selectedTransitionId: transitionId,
        targetColumn: destinationColumnId
    }).flatMap(()=>$927f535e38163999$var$handleSuccess({
            optimisticId: optimisticId,
            issueId: issueId,
            issueKey: issueKey,
            transitionId: transitionId,
            projectId: projectId,
            analyticsEvent: analyticsEvent
        })).catch((error)=>$927f535e38163999$var$handleError({
            optimisticId: optimisticId,
            issueId: issueId,
            issueKey: issueKey,
            transitionId: transitionId,
            projectId: projectId,
            analyticsEvent: analyticsEvent,
            error: error
        })));
}
function $927f535e38163999$export$7a4b906e63c2e974(action$, store) {
    return action$.ofType((0, $hDdMY.MISSING_PARENT_RESOLVE_REQUEST)).mergeMap((action)=>{
        if ($927f535e38163999$var$hasTransitionScreen(store, action)) return $927f535e38163999$var$handleTransitionScreen(store, action);
        return $927f535e38163999$var$handleMissingParentResolveAction(store, action);
    }, 10);
}

});
parcelRegister("hDdMY", function(module, exports) {

$parcel$export(module.exports, "MISSING_PARENT_RESOLVE_REQUEST", () => $30c361e88a2ec46d$export$db5c83e3629f342f);
$parcel$export(module.exports, "missingParentResolveRequest", () => $30c361e88a2ec46d$export$27a2bf747a2129f4);
$parcel$export(module.exports, "MISSING_PARENT_RESOLVE_OPTIMISTIC", () => $30c361e88a2ec46d$export$7a3a558c75d97e52);
$parcel$export(module.exports, "missingParentResolveOptimistic", () => $30c361e88a2ec46d$export$59fc8bacf22cfc6b);
$parcel$export(module.exports, "missingParentResolveSuccess", () => $30c361e88a2ec46d$export$62d6a97ae2726424);
$parcel$export(module.exports, "missingParentResolveFailure", () => $30c361e88a2ec46d$export$1db1f02a43251cc4);

var $9rND4 = parcelRequire("9rND4");
const $30c361e88a2ec46d$export$db5c83e3629f342f = 'state.actions.issue.missing-parent-issue-transition.MISSING_PARENT_ISSUE_RESOLVE';
const $30c361e88a2ec46d$export$27a2bf747a2129f4 = ({ issueId: issueId, issueTypeId: issueTypeId, issueKey: issueKey, projectId: projectId, transitionId: transitionId, destinationColumnId: destinationColumnId, analyticsEvent: analyticsEvent })=>({
        type: $30c361e88a2ec46d$export$db5c83e3629f342f,
        payload: {
            issueId: issueId,
            issueTypeId: issueTypeId,
            issueKey: issueKey,
            transitionId: transitionId,
            projectId: projectId,
            destinationColumnId: destinationColumnId
        },
        meta: {
            analyticsEvent: analyticsEvent
        }
    });
const $30c361e88a2ec46d$export$7a3a558c75d97e52 = 'state.actions.issue.missing-parent-issue-transition.MISSING_PARENT_RESOLVE_OPTIMISTIC';
const $30c361e88a2ec46d$export$59fc8bacf22cfc6b = ({ issueId: issueId, doneStatusName: doneStatusName })=>({
        type: $30c361e88a2ec46d$export$7a3a558c75d97e52,
        payload: {
            issueId: issueId,
            doneStatusName: doneStatusName
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)()
        }
    });
const $30c361e88a2ec46d$export$8a0856a3d0c4feea = 'state.actions.issue.missing-parent-issue-transition.MISSING_PARENT_RESOLVE_SUCCESS';
const $30c361e88a2ec46d$export$62d6a97ae2726424 = ({ optimisticId: optimisticId, issueId: issueId, analyticsEvent: analyticsEvent })=>({
        type: $30c361e88a2ec46d$export$8a0856a3d0c4feea,
        payload: {
            issueId: issueId
        },
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });
const $30c361e88a2ec46d$export$32992dadde2f9ea1 = 'state.actions.issue.missing-parent-issue-transition.MISSING_PARENT_RESOLVE_FAILURE';
const $30c361e88a2ec46d$export$1db1f02a43251cc4 = ({ optimisticId: optimisticId, issueId: issueId, error: error, analyticsEvent: analyticsEvent })=>({
        type: $30c361e88a2ec46d$export$32992dadde2f9ea1,
        payload: {
            issueId: issueId,
            error: error
        },
        meta: {
            ...(0, $9rND4.revertOptimisticUiMeta)(optimisticId),
            analyticsEvent: analyticsEvent
        }
    });

});


parcelRegister("8cD7G", function(module, exports) {

$parcel$export(module.exports, "default", () => $03b4f4b6a2e902b6$export$2e2bcd8739ae039);
$parcel$export(module.exports, "workLoadOnInitialLoadEpic", () => $03b4f4b6a2e902b6$export$9b5fbdd469a3e217);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("93e44");
parcelRequire("7qVV7");
parcelRequire("76ueo");
parcelRequire("1oQta");
parcelRequire("eV0gs");
parcelRequire("bZiwb");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("2HNfr");
parcelRequire("c66Ur");

var $gccSB = parcelRequire("gccSB");

var $ajpes = parcelRequire("ajpes");

var $hGgHi = parcelRequire("hGgHi");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $6s1PB = parcelRequire("6s1PB");

var $hULKg = parcelRequire("hULKg");

var $jBiMd = parcelRequire("jBiMd");


var $hN2XX = parcelRequire("hN2XX");



var $iuuJH = parcelRequire("iuuJH");

var $3GxuF = parcelRequire("3GxuF");

var $hjlQ8 = parcelRequire("hjlQ8");

var $hdmw1 = parcelRequire("hdmw1");

var $1YOzt = parcelRequire("1YOzt");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $k8auG = parcelRequire("k8auG");

var $8yiLS = parcelRequire("8yiLS");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $4Tseb = parcelRequire("4Tseb");
function $03b4f4b6a2e902b6$var$isOptimisticOrDragging(store) {
    const state = store.getState();
    return (0, $5mTgl.hasAnyActiveOptimistic)(state) || (0, $k8auG.isDragging)(state);
}
function $03b4f4b6a2e902b6$var$shouldCloseBuffer(action$, store) {
    return action$.filter(()=>!$03b4f4b6a2e902b6$var$isOptimisticOrDragging(store));
}
function $03b4f4b6a2e902b6$var$shouldAbort(action$, store) {
    return action$.filter(()=>$03b4f4b6a2e902b6$var$isOptimisticOrDragging(store));
}
function $03b4f4b6a2e902b6$var$updateIssueDevStatus(store) {
    return (workData)=>(0, $5mTgl.workDataWithDevStatusSelector)(store.getState())(workData);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function $03b4f4b6a2e902b6$var$onFailure(error, store) {
    // when fetching with etag, backend responses 304 meaning that no data change
    // do nothing in thi case
    if (error.statusCode === 304) return (0, $kVLXA.Observable).empty();
    if (error.statusCode === 401 || error.statusCode === 403) {
        const boardUrl = (0, $jBiMd.getBoardPrettyUrl)((0, $67Z81.contextPathSelector)(store.getState()), (0, $67Z81.projectKeySelector)(store.getState()), (0, $67Z81.rapidViewIdSelector)(store.getState()));
        return (0, $kVLXA.Observable).of((0, $cW3pH.showLogBackInMessage)(boardUrl));
    }
    if (error.statusCode === 404 && (0, $67Z81.getIsIncrementPlanningBoard)(store.getState())) return (0, $kVLXA.Observable).of((0, $cW3pH.showIPBoard404View)());
    (0, $2YZCu.default).safeErrorWithoutCustomerData('board.noncritical.load.failure', 'Failure on board load', error);
    return (0, $kVLXA.Observable).of((0, $cW3pH.loadBoardFailure)(error, false));
}
/**
 * Remove swimlaneModId from refreshes for CMP boards so user based swimlanes are
 * not overridden on refresh.
 */ function $03b4f4b6a2e902b6$var$onCMPBoardRefreshResult(store, action) {
    const state = store.getState();
    const swimlaneMode = state.ui.swimlane.mode;
    const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
    const isCustomFiltersOn = customFilterIds.length > 0;
    // For JQL swimlanes in CMP boards, use admin/backend settings as only admins can configure them
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id) return (0, $4Tseb.handleCMPBoardDataSet)(action, isCustomFiltersOn);
    return (0, $4Tseb.handleCMPBoardDataSet)({
        ...action,
        payload: {
            ...action.payload,
            swimlaneModeId: swimlaneMode ?? action.payload.swimlaneModeId
        }
    }, isCustomFiltersOn);
}
function $03b4f4b6a2e902b6$var$fetchBoardScopeData(store) {
    const state = store.getState();
    const ctx = (0, $hdmw1.makeServiceContext)(state);
    const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
    // We do not pass quick filters and we do not want hidden issues for a refresh.
    return (0, $3GxuF.fetchWorkModeData)(ctx, ctx.isCMPBoard ? {
        activeQuickFilters: customFilterIds,
        includeHidden: customFilterIds.length > 0
    } : undefined).map($03b4f4b6a2e902b6$var$updateIssueDevStatus(store)).map((0, $cW3pH.workDataSet)).flatMap((action)=>{
        if (ctx.isCMPBoard) return $03b4f4b6a2e902b6$var$onCMPBoardRefreshResult(store, action);
        return (0, $kVLXA.Observable).of(action);
    }).catch((error)=>$03b4f4b6a2e902b6$var$onFailure(error, store));
}
function $03b4f4b6a2e902b6$export$7a1171f81211a01b(refreshActions) {
    const globalIssueCreateAction = refreshActions.find((action)=>action.payload.source === (0, $dcbb2bce513725b3$export$8cabdc85b8691f12));
    // GIC already shows a flag for issue create success so check if the GIC was triggered from Bento to disable the board flag
    const isTriggeredByBento = globalIssueCreateAction?.payload?.triggerSource === (0, $hULKg.JSW_ISSUE_VIEW_CREATE_SUBTASK) || globalIssueCreateAction?.payload?.triggerSource === (0, $hULKg.JSW_ISSUE_VIEW_CREATE_ISSUE_IN_EPIC);
    const globalIssues = globalIssueCreateAction?.payload?.issues;
    return (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(globalIssues) || isTriggeredByBento ? [] : [
        (0, $1YOzt.checkGlobalIssueCreate)(globalIssues)
    ];
}
function $03b4f4b6a2e902b6$var$onBoardWithNoColumn(canEditBoard) {
    return (0, $kVLXA.Observable).of((0, $cW3pH.loadBoardFailureNoColumn)(false, canEditBoard));
}
function $03b4f4b6a2e902b6$export$6a152ab28b3fdeb6(action$) {
    let failures = 0;
    const getDelay = ()=>Math.min(failures > 0 ? 1000 * Math.pow(2, failures) + Math.random() * (0, $6s1PB.expVal)('jsw_nextgen_board_jirt_jitter', 'jitterTime', 500) : 0, 60000);
    const refreshAllowedStream$ = action$.ofType((0, $cW3pH.BOARD_LOAD_FAILURE)).flatMap(()=>{
        failures += 1;
        return (0, $kVLXA.Observable).empty();
    });
    const successStream$ = action$.ofType((0, $cW3pH.WORK_DATA_SET)).flatMap(()=>{
        failures = 0;
        return (0, $kVLXA.Observable).empty();
    });
    const refreshDelayHandler$ = (0, $kVLXA.Observable).merge(refreshAllowedStream$, successStream$);
    return {
        refreshDelayHandler$: refreshDelayHandler$,
        getDelay: getDelay
    };
}
function $03b4f4b6a2e902b6$export$2e2bcd8739ae039(action$, store) {
    const { getDelay: getDelay, refreshDelayHandler$: refreshDelayHandler$ } = $03b4f4b6a2e902b6$export$6a152ab28b3fdeb6(action$);
    const epicOutput$ = action$.ofType((0, $cW3pH.WORK_REFRESH_DATA)).bufferWhen(()=>$03b4f4b6a2e902b6$var$shouldCloseBuffer(action$, store)).filter((buffer)=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(buffer)).exhaustMap((refreshActions)=>(0, $kVLXA.Observable).of(refreshActions).delay(getDelay()).flatMap(()=>$03b4f4b6a2e902b6$var$fetchBoardScopeData(store)).concat($03b4f4b6a2e902b6$export$7a1171f81211a01b(refreshActions)).takeUntil($03b4f4b6a2e902b6$var$shouldAbort(action$, store)));
    return (0, $kVLXA.Observable).merge(epicOutput$, refreshDelayHandler$);
}
function $03b4f4b6a2e902b6$export$9b5fbdd469a3e217(action$, store) {
    return action$.ofType((0, $65C0W.SOFTWARE_APP_LOADED), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).filter(()=>!(0, $5mTgl.hasAnyActiveOptimistic)(store.getState())).flatMap((action)=>{
        const state = store.getState();
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const data = action.type === (0, $65C0W.SOFTWARE_APP_LOADED) && action.payload.prefetchData != null ? action.payload.prefetchData : null;
        if (action.type === (0, $65C0W.SOFTWARE_APP_LOADED) && action.payload.cmpBoardData != null) return (0, $kVLXA.Observable).from([]);
        if (data && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(data.board?.columns)) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board.transform.critical.data', 'Board does not have any columns', {
                message: `Columns does not exist for Board with id :  ${boardId}`
            });
            // these data wont be in state , need to retrieve from payload.
            const canConfigureBoard = data.currentUser.permissions.includes((0, $68cf6bf1ce76db03$export$b893894941c14e43));
            return $03b4f4b6a2e902b6$var$onBoardWithNoColumn(canConfigureBoard);
        }
        const transformedData = data ? (0, $hjlQ8.transformCriticalData)(data) : {};
        // Get filters and put them in here
        const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
        const isCustomFiltersOn = customFilterIds.length > 0;
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        return (0, $3GxuF.fetchWorkModeData)(ctx, {
            activeQuickFilters: customFilterIds,
            includeHidden: customFilterIds.length > 0
        }).map($03b4f4b6a2e902b6$var$updateIssueDevStatus(store)).map((nonCriticalData)=>{
            // Do a comparison based on what was given by the cache and what we just retrieved
            // Not all keys will match but the ones we loaded from cache are the ones we want to compare
            const isCacheValid = // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            Object.keys(transformedData).every((key)=>{
                if (key in nonCriticalData) return (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(transformedData[key], nonCriticalData[key]);
                return true;
            });
            if (!isCacheValid) // Fire analytics;
            (0, $hN2XX.triggerCacheRefreshAnalytics)((0, $8631d6ce464ccf2e$export$9b8283d5878d2491));
            return nonCriticalData;
        }).map((0, $cW3pH.workDataSet)).flatMap((response)=>{
            if (ctx.isCMPBoard) return (0, $4Tseb.handleCMPBoardDataSet)(response, isCustomFiltersOn);
            return (0, $kVLXA.Observable).of(response);
        }).catch((error)=>$03b4f4b6a2e902b6$var$onFailure(error, store));
    });
}

});
parcelRegister("jBiMd", function(module, exports) {

$parcel$export(module.exports, "getBoardPrettyUrl", () => $e2dfb6bdf3985745$export$65019f7aa89ee0d);
const $e2dfb6bdf3985745$export$65019f7aa89ee0d = (contextPath, projectKey, rapidViewId)=>`${contextPath}/jira/software/projects/${projectKey}/boards/${rapidViewId}`;
const $e2dfb6bdf3985745$export$325baf08e53250a1 = (contextPath, projectKey, rapidViewId, isCMPBoard, additionalParams = [])=>{
    const paramString = additionalParams.map((param)=>`${param}`).join('&');
    return `${contextPath}/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${rapidViewId}/backlog${additionalParams.length ? `?${paramString}` : ''}`;
};

});

parcelRegister("hN2XX", function(module, exports) {

$parcel$export(module.exports, "default", () => $43e79ffcea087bf1$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerCacheRefreshAnalytics", () => $43e79ffcea087bf1$export$e78b5ce2eed37743);

var $cab1K = parcelRequire("cab1K");
// Standard observer pattern, when the board/backlog/roadmap is mounted and loaded cache,
// but cache is stale and is updated by live data, this will be triggered
const $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics = new (0, $cab1K.Subject)();
var $43e79ffcea087bf1$export$2e2bcd8739ae039 = $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics;
const $43e79ffcea087bf1$export$e78b5ce2eed37743 = (origin)=>{
    $43e79ffcea087bf1$var$ResourcesCacheRefreshAnalytics.next(origin);
};

});

parcelRegister("3GxuF", function(module, exports) {

$parcel$export(module.exports, "fetchWorkModeData", () => $18b8f0cae70dfc00$export$a4889071ab1c6bf9);
parcelRequire("3q49N");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");


var $gBFyV = parcelRequire("gBFyV");

var $cNk8F = parcelRequire("cNk8F");

var $j0Jg0 = parcelRequire("j0Jg0");

var $hjlQ8 = parcelRequire("hjlQ8");

var $duA0Q = parcelRequire("duA0Q");
function $18b8f0cae70dfc00$export$2e2bcd8739ae039(contextPath, boardId) {
    return (0, $cNk8F.default)(contextPath, boardId).flatMap((nonCritialDataResponse)=>{
        // Everytime we fetch this data, we can use it to hydrate the BOARD resources-cache
        (0, $gBFyV.default).next({
            origin: (0, $8631d6ce464ccf2e$export$9b8283d5878d2491),
            payload: nonCritialDataResponse
        });
        return (0, $kVLXA.Observable).of((0, $hjlQ8.transformNonCriticalData)(nonCritialDataResponse));
    }).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.non-critical.load.boardscope.graphql.failure', 'Failed to load board scope data via GraphQl', {
            message: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, 'message', '') || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
                0,
                'message',
                ''
            ])
        });
        return (0, $kVLXA.Observable).throw(error);
    });
}
function $18b8f0cae70dfc00$export$7840010629c20713(planId, scenarioId, incrementId) {
    return (0, $j0Jg0.fetchPlanDataRest)(+planId, +scenarioId, +incrementId);
}
function $18b8f0cae70dfc00$export$a4889071ab1c6bf9(ctx, parameters = {}) {
    if (ctx.isIncrementPlanningBoard) {
        if (!ctx.planId || !ctx.scenarioId || !ctx.boardId) throw new Error('planId and scenarioId must be provided for incremental planning board');
        return $18b8f0cae70dfc00$export$7840010629c20713(ctx.planId, ctx.scenarioId, ctx.boardId);
    }
    if (ctx.isCMPBoard) {
        const { boardId: boardId } = ctx;
        return (0, $duA0Q.fetchCMPBoardScopeData)(boardId, {
            projectType: ctx.projectType,
            ...parameters
        });
    }
    return $18b8f0cae70dfc00$export$2e2bcd8739ae039(ctx.contextPath, ctx.boardId);
}

});
parcelRegister("gBFyV", function(module, exports) {

$parcel$export(module.exports, "default", () => $48bba9321b275587$export$2e2bcd8739ae039);

var $cab1K = parcelRequire("cab1K");
var // Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be updated
// eslint-disable-next-line jira/import/no-anonymous-default-export
$48bba9321b275587$export$2e2bcd8739ae039 = new (0, $cab1K.Subject)();

});

parcelRegister("cNk8F", function(module, exports) {

$parcel$export(module.exports, "default", () => $63ab48391f281820$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $fy8gS = parcelRequire("fy8gS");

var $cBLvH = parcelRequire("cBLvH");

var $CFxE9 = parcelRequire("CFxE9");
const $63ab48391f281820$export$708e6644dde09094 = 'SoftwareBoardScopeData';
const $63ab48391f281820$export$f2f3dcc8e95c3168 = ()=>{
    const editConfig = `
        editConfig {
            inlineColumnEdit {
                enabled
            }
            inlineIssueCreate @skip(if: $useBackendIccConfig){
                enabled
            }
        }
    `;
    const issueChildren = `issueChildren {
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                issue {
                    id
                    key
                    summary
                    labels
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type { id, name, iconUrl }
                    status { id }
                    activeSprint { id }
                }
                coverMedia {
                    attachmentId
                    endpointUrl
                    clientId
                    token
                    attachmentMediaApiId
                    hiddenByUser
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }`;
    const timeTrackingConfig = `
    jira {
        timeTrackingOptions {
            workingHoursPerDay
            workingDaysPerWeek
            defaultUnit
            timeFormat
        }
    }`;
    const globalConfig = `
        globalConfig @skip(if: $useBackendIccConfig){
            applicationProperties {
                createStatusIsEnabled
            }
        }
    `;
    const oldDoneIssuesCutOffConfig = (0, $4R6GH.fg)('horizn_490_consolidate_old_issues_in_board') ? `
				oldDoneIssuesCutOffConfig {
					options{
						label
						value
					}
					oldDoneIssuesCutoff
				}
	` : '';
    return `query ${$63ab48391f281820$export$708e6644dde09094} ($boardId: ID!, $useBackendIccConfig: Boolean!, $showIssueTransition: Boolean!) {
            boardScope(boardId: $boardId) {
                userSwimlaneStrategy
                board {
                    name
                    swimlaneStrategy
                    hasClearedIssues
                    rankCustomFieldId
                    assignees {
                        accountId
                        displayName
                        avatarUrl
                    }
                    columns {
                        id
                        name
                        maxIssueCount
                        status {
                            id
                            name
                        }
                        ${0, $fy8gS.columnStatus}
                        isDone
                        isInitial
                        transitionId
                        cards {
                            id
                            flagged
                            done
                            parentId
                            estimate {
                                storyPoints
                                originalEstimate {
                                    value
                                    valueAsText
                                }
                            }
                            issue {
                                id
                                key
                                summary
                                labels
                                assignee {
                                    accountId
                                    displayName
                                    avatarUrl
                                }
                                type { id, name, iconUrl }
                                status { id }
                                activeSprint { id }
                            }
                            coverMedia {
                                attachmentId
                                endpointUrl
                                clientId
                                token
                                attachmentMediaApiId
                                hiddenByUser
                            }
                            priority {
                                name
                                iconUrl
                            }
                            dueDate
                            childIssuesMetadata { complete, total }
                        }
                    }
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                        hasRequiredFields @skip(if: $useBackendIccConfig)
                    }
                    inlineIssueCreate @skip(if: $useBackendIccConfig) { enabled }
                    cardMedia { enabled }
                    ${issueChildren}
                    cards { id }
                    ${editConfig}
                    inlineCardCreateConfig @include(if: $useBackendIccConfig)
                }
                backlog {
                    boardIssueListKey
                    requestColumnMigration
                }
                sprints(state: [ACTIVE]) {
                    id
                    name
                    goal
                    startDate
                    endDate
                    daysRemaining
                }
                features { key, status, toggle, category }
                projectLocation {
                    id
                    key
                    name
                    isSimplifiedProject
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                        hasRequiredFields
                    }
                }
                issueParents {
                    id
                    key
                    summary
                    issue {
                        status {
                            id
                            name
                            category
                        }
                    }
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
                currentUser { permissions }
                estimation {
                    current {
                        customFieldId
                    }
                }
                ${oldDoneIssuesCutOffConfig}
			}
            ${timeTrackingConfig}
            ${globalConfig}
        }`;
};
const $63ab48391f281820$export$ba14d9a5a581e827 = (data)=>(0, $kVLXA.Observable).of(data);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$63ab48391f281820$export$2e2bcd8739ae039 = (contextPath, boardId)=>(0, $cBLvH.query$)(contextPath, $63ab48391f281820$export$708e6644dde09094, $63ab48391f281820$export$f2f3dcc8e95c3168(), {
        boardId: boardId,
        useBackendIccConfig: (0, $4R6GH.fg)('use_backend_tmp_icc_config_'),
        showIssueTransition: (0, $4R6GH.fg)('issue_transition_screen_in_jsw_tmp_board')
    }, (0, $CFxE9.boardScopeDataNonCriticalAnalyticsOptions)).flatMap($63ab48391f281820$export$ba14d9a5a581e827);

});
parcelRegister("fy8gS", function(module, exports) {

$parcel$export(module.exports, "softwareBoardScopeCriticalDataOperationName", () => $557b489490412bcc$export$33da63e9ed5a1c48);
$parcel$export(module.exports, "columnStatus", () => $557b489490412bcc$export$48a92d19f93c7dd6);
$parcel$export(module.exports, "getBoardScopeGraphqlQuery", () => $557b489490412bcc$export$f2f3dcc8e95c3168);
/*!
 * ATTENTION
 *
 * This module is used on both the main board app and its vendorless early-script entry.
 *
 * Because of this, it can't have dependencies. Feature-flagging logic should be done outside this
 * module and values should be passed in. For now changes must happen on both calls.
 */ const $557b489490412bcc$export$33da63e9ed5a1c48 = 'SoftwareBoardScopeCriticalData';
const $557b489490412bcc$export$225522b2e3455b2 = `
        editConfig {
            inlineColumnEdit {
                enabled
            }
            inlineIssueCreate @skip(if: $useBackendIccConfig){
                enabled
            }
        }
    `;
const $557b489490412bcc$export$48a92d19f93c7dd6 = `columnStatus {
            status {
                id
                name
                category
            }
            transitions {
                id
                name
                status {
                    id
                }
                originStatus { id }
                cardType { id }
                isGlobal
                isInitial
                hasConditions
				hasScreen @include(if: $showIssueTransition)
            }
        }`;
const $557b489490412bcc$export$f2f3dcc8e95c3168 = ()=>{
    const issueChildren = `issueChildren {
                id
                flagged
                done
                parentId
                estimate {
                    storyPoints
                    originalEstimate {
                        value
                        valueAsText
                    }
                }
                issue {
                    id
                    key
                    summary
                    labels
                    assignee {
                        accountId
                        displayName
                        avatarUrl
                    }
                    type { id, name, iconUrl }
                    status { id }
                    activeSprint { id }
                }
                priority {
                    name
                    iconUrl
                }
                dueDate
            }`;
    return `query ${$557b489490412bcc$export$33da63e9ed5a1c48} ($boardId: ID!, $useBackendIccConfig: Boolean!, $showIssueTransition: Boolean!, $hasJqlFilter: Boolean!, $filterJql: String) {
            boardScope(boardId: $boardId, filterJql: $filterJql) {
                userSwimlaneStrategy
                board {
                    name
                    swimlaneStrategy
                    hasClearedIssues
                    rankCustomFieldId
                    filteredCardIds @include(if: $hasJqlFilter)
                    assignees {
                        accountId
                        displayName
                        avatarUrl
                    }
                    columns {
                        id
                        name
                        maxIssueCount
                        status {
                            id
                            name
                        }
                        ${$557b489490412bcc$export$48a92d19f93c7dd6}
                        isDone
                        isInitial
                        cards {
                            id
                            flagged
                            done
                            parentId
                            estimate {
                                storyPoints
                                originalEstimate {
                                    value
                                    valueAsText
                                }
                            }
                            issue {
                                id
                                key
                                summary
                                labels
                                assignee {
                                    accountId
                                }
                                type { id, name, iconUrl }
                                status { id }
                                activeSprint { id }
                            }
                            priority {
                                name
                                iconUrl
                            }
                            dueDate
                            childIssuesMetadata { complete, total }
                        }
                    }
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                    }
                    inlineIssueCreate @skip(if: $useBackendIccConfig) { enabled }
                    ${issueChildren}
                    cards { id }
                    ${$557b489490412bcc$export$225522b2e3455b2}
                    inlineCardCreateConfig @include(if: $useBackendIccConfig)
                }
                sprints(state: [ACTIVE]) {
                    id
                    name
                    goal
                    startDate
                    endDate
                    daysRemaining
                }
                features { key, status, toggle, category }
                projectLocation {
                    id
                    key
                    name
                    isSimplifiedProject
                    issueTypes {
                        id
                        name
                        iconUrl
                        hierarchyLevelType
                    }
                }
                issueParents {
                    id
                    key
                    summary
                    issue {
                        status {
                            id
                            name
                            category
                        }
                    }
                    issueType {
                        id
                        name
                        iconUrl
                    }
                    color
                }
                currentUser { permissions }
                estimation {
                    current {
                        customFieldId
                    }
                }
            }
        }`;
};

});


parcelRegister("j0Jg0", function(module, exports) {

$parcel$export(module.exports, "fetchPlanDataRest", () => $cd10897187a68f30$export$61eb3ebe06db86b9);
parcelRequire("aSIuP");

var $hGgHi = parcelRequire("hGgHi");

var $gZL7V = parcelRequire("gZL7V");

var $5rFbt = parcelRequire("5rFbt");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $487fd = parcelRequire("487fd");

var $4jAPy = parcelRequire("4jAPy");

var $3spCR = parcelRequire("3spCR");


var $67Z81 = parcelRequire("67Z81");
const $cd10897187a68f30$export$9e95d7af046055ce = (teams, createIssuePermission)=>{
    if (!createIssuePermission) return {
        mode: (0, $c8d1b8aabfd899d6$export$c53d0f541b41b88e)
    };
    const hasExternalTeams = teams?.some((team)=>team.isPlanTeam === false);
    let isFullMode = !hasExternalTeams;
    const initalConfig = {
        mode: (0, $c8d1b8aabfd899d6$export$bb410559a65d3418),
        swimlanes: {
            [(0, $4jAPy.SWIMLANE_TEAMLESS)]: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
        }
    };
    const inlineCardCreateConfig = teams?.reduce((acc, team)=>{
        if (acc.swimlanes !== undefined && team.isPlanTeam) {
            const sprintByIterationId = team.sprintByIterationId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sprintByIterationId)) {
                const columnsIcc = Object.keys(sprintByIterationId).reduce((columnsIccAcc, columnId)=>{
                    const sprint = sprintByIterationId[Number(columnId)];
                    if (sprint.state === (0, $3spCR.CLOSED_SPRINT_STATE)) isFullMode = false;
                    else (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(columnsIccAcc, [
                        columnId
                    ], {
                        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
                    });
                    return columnsIccAcc;
                }, {
                    [(0, $5rFbt.UNSCHEDULED_COLUMN_ID)]: {
                        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
                    }
                });
                acc.swimlanes[team.id] = columnsIcc;
            } else acc.swimlanes[team.id] = (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b);
        }
        return acc;
    }, initalConfig);
    return isFullMode ? {
        mode: (0, $c8d1b8aabfd899d6$export$3789e4b2a10baa2b)
    } : inlineCardCreateConfig;
};
function $cd10897187a68f30$var$transformStatuses(response) {
    return response.statuses.map((s)=>({
            id: s.id,
            name: s.name,
            category: (0, $gULOk.statusCategoryForId)(s.categoryId)
        }));
}
function $cd10897187a68f30$export$6e76d430ac3d961(boardPermissions, isEmbed) {
    return isEmbed ? {
        createIssue: false,
        editIssue: false,
        deleteIssue: false,
        manageSprint: false,
        editBoardConfig: false,
        manageAutomation: false,
        canRelease: false,
        createSprint: false,
        archiveIssue: false
    } : boardPermissions;
}
const $cd10897187a68f30$export$61eb3ebe06db86b9 = (planId, scenarioId, incrementId)=>(0, $487fd.default)(`/rest/jpo/2.0/plans/${planId}/increment/board/${incrementId}?scenarioId=${scenarioId}`, {
        method: 'GET'
    }).map((json)=>{
        if ((0, $4R6GH.fg)('smart_links_for_plans')) {
            const isEmbed = (0, $67Z81.getIsIncrementPlanningBoardEmbed)();
            return {
                ...json,
                statuses: $cd10897187a68f30$var$transformStatuses(json),
                inlineCardCreate: $cd10897187a68f30$export$9e95d7af046055ce(json?.teams, !isEmbed && json.boardPermissions.createIssue),
                boardPermissions: $cd10897187a68f30$export$6e76d430ac3d961(json.boardPermissions, isEmbed)
            };
        }
        return {
            ...json,
            statuses: $cd10897187a68f30$var$transformStatuses(json),
            inlineCardCreate: $cd10897187a68f30$export$9e95d7af046055ce(json?.teams, json.boardPermissions.createIssue)
        };
    });

});
parcelRegister("gZL7V", function(module, exports) {

var $ajB7H = parcelRequire("ajB7H");
/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */ function $c5f6e64373be0bfc$var$set(object, path, value) {
    return object == null ? object : $ajB7H(object, path, value);
}
module.exports = $c5f6e64373be0bfc$var$set;

});



parcelRegister("4Tseb", function(module, exports) {

$parcel$export(module.exports, "handleCMPBoardDataSet", () => $3b20dbe0a7669860$export$ed13ed88f142803b);

var $80afZ = parcelRequire("80afZ");

var $kVLXA = parcelRequire("kVLXA");

var $cY26q = parcelRequire("cY26q");

var $9WrsG = parcelRequire("9WrsG");
function $3b20dbe0a7669860$export$ed13ed88f142803b(response, isCustomFilterOn = false) {
    const { payload: workModeData } = response;
    // TODO: We can implement resources loading and then this would not need to be here.
    const issueIds = (0, (/*@__PURE__*/$parcel$interopDefault($80afZ)))(workModeData.issues, (issue)=>issue.id);
    const actions = [
        response,
        (0, $9WrsG.devStatusLoad)(issueIds)
    ];
    const allIssues = [
        ...workModeData.issues ?? [],
        ...workModeData.issueChildren ?? []
    ];
    const visibleIssueIds = allIssues.filter((issue)=>issue.isVisible === undefined || issue.isVisible) // IF not set, then visible. Otherwise check
    .map((issue)=>String(issue.id));
    // Only fire the filtered cards success (set the filtered card Ids) if there is any difference
    // or when custom filters are on
    if (isCustomFilterOn || visibleIssueIds.length !== allIssues.length) actions.push((0, $cY26q.filteredCardsSuccess)(visibleIssueIds));
    return (0, $kVLXA.Observable).from(actions);
}

});


parcelRegister("juuG5", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ff31aa6766e24a6$export$2e2bcd8739ae039);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("93e44");
parcelRequire("76ueo");
parcelRequire("c66Ur");
parcelRequire("2agIZ");
parcelRequire("eSGL3");
parcelRequire("1oQta");
parcelRequire("ihPQR");
parcelRequire("fPS7b");
parcelRequire("ifthi");
parcelRequire("59oNb");
parcelRequire("7mHDu");

var $9XE6b = parcelRequire("9XE6b");

var $kVLXA = parcelRequire("kVLXA");

var $jKX30 = parcelRequire("jKX30");

var $gSIcW = parcelRequire("gSIcW");

var $2YZCu = parcelRequire("2YZCu");

var $6s1PB = parcelRequire("6s1PB");

var $cnhn5 = parcelRequire("cnhn5");


var $d315K = parcelRequire("d315K");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");

var $btYft = parcelRequire("btYft");
const $9ff31aa6766e24a6$var$isNotCurrentUserInActiveTab = (state, action)=>(0, $67Z81.currentUserAccountIdSelector)(state) !== (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action, [
        'payload',
        'event',
        'payload',
        'atlassianId'
    ], null) || (0, $btYft.isBlurredDocument)();
const $9ff31aa6766e24a6$export$54ca11c0f992f1f = 3000;
const $9ff31aa6766e24a6$var$realtimeEpic = (action$, store)=>{
    const events$ = action$.ofType((0, $d315K.REALTIME_DISPATCH_EVENT)).filter((action)=>$9ff31aa6766e24a6$var$isNotCurrentUserInActiveTab(store.getState(), action));
    const [tabShownEvents$, tabHiddenEvents$] = events$.partition(()=>!(0, $btYft.isInactiveTab)());
    const delayedHiddenEvents$ = tabHiddenEvents$.bufferWhen(()=>(0, $gSIcW.default)().skip(1).filter(Boolean).take(1)).flatMap((actions)=>(0, $kVLXA.Observable).from(actions));
    const result$ = (0, $kVLXA.Observable).merge(tabShownEvents$, delayedHiddenEvents$).filter((action)=>{
        // We want to only listen to board scope issues updated events here since we
        // additionally get both issue create and issue update specifically for custom filters
        // So we ignore them here so custom filters still know how to react to those events
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(store.getState());
        return isCMPBoard || action.payload.event.type === (0, $cnhn5.BOARD_SCOPE_ISSUES_UPDATED);
    });
    return result$.debounce(()=>(0, $jKX30.timer)($9ff31aa6766e24a6$export$54ca11c0f992f1f + Math.random() * (0, $6s1PB.expVal)('jsw_nextgen_board_jirt_jitter', 'jitterTime', 500))).mapTo((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$af001fd9213b0b63))).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.realtime.event.process.failure', 'Failed to process realtime event', error);
        return (0, $kVLXA.Observable).empty();
    });
};
var $9ff31aa6766e24a6$export$2e2bcd8739ae039 = $9ff31aa6766e24a6$var$realtimeEpic;

});
parcelRegister("ifthi", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $65pxe = parcelRequire("65pxe");
$kVLXA.Observable.prototype.partition = $65pxe.partition;

});
parcelRegister("65pxe", function(module, exports) {

$parcel$export(module.exports, "partition", () => $46e7046de8bb9e17$export$b29f828819edca8d, (v) => $46e7046de8bb9e17$export$b29f828819edca8d = v);
var $46e7046de8bb9e17$export$b29f828819edca8d;
"use strict";

var $hU4zQ = parcelRequire("hU4zQ");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $46e7046de8bb9e17$var$partition(predicate, thisArg) {
    return $hU4zQ.partition(predicate, thisArg)(this);
}
$46e7046de8bb9e17$export$b29f828819edca8d = $46e7046de8bb9e17$var$partition;

});
parcelRegister("hU4zQ", function(module, exports) {

$parcel$export(module.exports, "partition", () => $d08b378cea94b111$export$b29f828819edca8d, (v) => $d08b378cea94b111$export$b29f828819edca8d = v);
var $d08b378cea94b111$export$b29f828819edca8d;
"use strict";

var $226Ym = parcelRequire("226Ym");

var $4cJXk = parcelRequire("4cJXk");
/**
 * Splits the source Observable into two, one with values that satisfy a
 * predicate, and another with values that don't satisfy the predicate.
 *
 * <span class="informal">It's like {@link filter}, but returns two Observables:
 * one like the output of {@link filter}, and the other with values that did not
 * pass the condition.</span>
 *
 * <img src="./img/partition.png" width="100%">
 *
 * `partition` outputs an array with two Observables that partition the values
 * from the source Observable through the given `predicate` function. The first
 * Observable in that array emits source values for which the predicate argument
 * returns true. The second Observable emits source values for which the
 * predicate returns false. The first behaves like {@link filter} and the second
 * behaves like {@link filter} with the predicate negated.
 *
 * @example <caption>Partition click events into those on DIV elements and those elsewhere</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var parts = clicks.partition(ev => ev.target.tagName === 'DIV');
 * var clicksOnDivs = parts[0];
 * var clicksElsewhere = parts[1];
 * clicksOnDivs.subscribe(x => console.log('DIV clicked: ', x));
 * clicksElsewhere.subscribe(x => console.log('Other clicked: ', x));
 *
 * @see {@link filter}
 *
 * @param {function(value: T, index: number): boolean} predicate A function that
 * evaluates each value emitted by the source Observable. If it returns `true`,
 * the value is emitted on the first Observable in the returned array, if
 * `false` the value is emitted on the second Observable in the array. The
 * `index` parameter is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {[Observable<T>, Observable<T>]} An array with two Observables: one
 * with values that passed the predicate, and another with values that did not
 * pass the predicate.
 * @method partition
 * @owner Observable
 */ function $d08b378cea94b111$var$partition(predicate, thisArg) {
    return function(source) {
        return [
            $4cJXk.filter(predicate, thisArg)(source),
            $4cJXk.filter($226Ym.not(predicate, thisArg))(source)
        ];
    };
}
$d08b378cea94b111$export$b29f828819edca8d = $d08b378cea94b111$var$partition;

});
parcelRegister("226Ym", function(module, exports) {

$parcel$export(module.exports, "not", () => $17b12d47d6027eff$export$6003a5f097c73977, (v) => $17b12d47d6027eff$export$6003a5f097c73977 = v);
var $17b12d47d6027eff$export$6003a5f097c73977;
"use strict";
function $17b12d47d6027eff$var$not(pred, thisArg) {
    function notPred() {
        return !notPred.pred.apply(notPred.thisArg, arguments);
    }
    notPred.pred = pred;
    notPred.thisArg = thisArg;
    return notPred;
}
$17b12d47d6027eff$export$6003a5f097c73977 = $17b12d47d6027eff$var$not;

});




parcelRegister("59oNb", function(module, exports) {
"use strict";

var $kVLXA = parcelRequire("kVLXA");

var $kPv2w = parcelRequire("kPv2w");
$kVLXA.Observable.prototype.skip = $kPv2w.skip;

});
parcelRegister("kPv2w", function(module, exports) {

$parcel$export(module.exports, "skip", () => $f2a0a5e10a86d5fc$export$955fc4a6c4be454d, (v) => $f2a0a5e10a86d5fc$export$955fc4a6c4be454d = v);
var $f2a0a5e10a86d5fc$export$955fc4a6c4be454d;
"use strict";

var $3ZBte = parcelRequire("3ZBte");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $f2a0a5e10a86d5fc$var$skip(count) {
    return $3ZBte.skip(count)(this);
}
$f2a0a5e10a86d5fc$export$955fc4a6c4be454d = $f2a0a5e10a86d5fc$var$skip;

});
parcelRegister("3ZBte", function(module, exports) {
"use strict";
var $2e84226f7a2e14b9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Returns an Observable that skips the first `count` items emitted by the source Observable.
 *
 * <img src="./img/skip.png" width="100%">
 *
 * @param {Number} count - The number of times, items emitted by source Observable should be skipped.
 * @return {Observable} An Observable that skips values emitted by the source Observable.
 *
 * @method skip
 * @owner Observable
 */ function $2e84226f7a2e14b9$var$skip(count) {
    return function(source) {
        return source.lift(new $2e84226f7a2e14b9$var$SkipOperator(count));
    };
}
module.exports.skip = $2e84226f7a2e14b9$var$skip;
var $2e84226f7a2e14b9$var$SkipOperator = function() {
    function SkipOperator(total) {
        this.total = total;
    }
    SkipOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $2e84226f7a2e14b9$var$SkipSubscriber(subscriber, this.total));
    };
    return SkipOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $2e84226f7a2e14b9$var$SkipSubscriber = function(_super) {
    $2e84226f7a2e14b9$var$__extends(SkipSubscriber, _super);
    function SkipSubscriber(destination, total) {
        _super.call(this, destination);
        this.total = total;
        this.count = 0;
    }
    SkipSubscriber.prototype._next = function(x) {
        if (++this.count > this.total) this.destination.next(x);
    };
    return SkipSubscriber;
}($ggvKU.Subscriber);

});



parcelRegister("gSIcW", function(module, exports) {

$parcel$export(module.exports, "default", () => $63d01e218c271471$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");

var $cab1K = parcelRequire("cab1K");
parcelRequire("jG6Un");
parcelRequire("iQCJJ");
parcelRequire("d0pqD");

var $laTox = parcelRequire("laTox");
/**
 * Returns a stream of the current page visibility state whenever it changes.
 * Emits 'true' when the page is visible and 'false' when the page is hidden.
 *
 * Will emit `null` if document is not defined.
 *
 * This Observable WILL EMIT a value at the start of the load. If you're using
 * it to trigger refreshes, you should skip 1 value.
 */ const $63d01e218c271471$var$getVisibility$ = ()=>// @ts-expect-error - TS2322 - Type 'Observable<unknown>' is not assignable to type 'Observable<boolean | null>'.
    typeof document !== 'undefined' ? (0, $kVLXA.Observable).fromEvent(document, (0, $laTox.supportedVisiblityEvent))// We want to send the current visibility on a new subscription.
    // If we use `.startWith(isPageVisible())` then new subscribers
    // will get the initial visibility at load and not the current
    // visibility as the initial value.
    .startWith(null).map((0, $laTox.isPageVisible)) : new (0, $cab1K.Subject)().startWith(null);
var $63d01e218c271471$export$2e2bcd8739ae039 = $63d01e218c271471$var$getVisibility$;

});

parcelRegister("btYft", function(module, exports) {

$parcel$export(module.exports, "isInactiveTab", () => $56264c7cca60bd31$export$ffeec43e65aaf0d2);
$parcel$export(module.exports, "isBlurredDocument", () => $56264c7cca60bd31$export$b548a2387e025fd3);
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $56264c7cca60bd31$export$ffeec43e65aaf0d2 = ()=>document.hidden;
const $56264c7cca60bd31$export$b548a2387e025fd3 = ()=>!document.hasFocus();

});


parcelRegister("csUBy", function(module, exports) {

$parcel$export(module.exports, "default", () => $5bb5eaa28912c10e$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("9o0uh");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $2YZCu = parcelRequire("2YZCu");


var $3n65g = parcelRequire("3n65g");

var $cW3pH = parcelRequire("cW3pH");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5bb5eaa28912c10e$export$2e2bcd8739ae039 = (action$)=>action$.ofType((0, $3n65g.SET_PARENT_OPTIMISTIC)).mergeMap((action)=>{
        const { payload: { issues: issues, parentId: parentId }, meta: { optimistic: optimistic } } = action;
        const changedIssueIds = issues.filter((issue)=>issue.parentId !== parentId).map((issue)=>issue.id);
        if (changedIssueIds.length === 0) return (0, $kVLXA.Observable).of((0, $3n65g.setParentSuccess)(optimistic.id, changedIssueIds));
        const cardsParentAction = (0, $kVLXA.Observable).fromPromise(action.payload.requestPromise);
        return cardsParentAction.flatMap(()=>(0, $kVLXA.Observable).of((0, $3n65g.setParentSuccess)(optimistic.id, changedIssueIds))).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.set-parent.failure', 'Failed to set issue parent', error);
            return (0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $3n65g.setParentFailure)(optimistic.id), (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7)));
        });
    });

});

parcelRegister("fip9w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ece440dec8b281$export$2e2bcd8739ae039);

var $e1AU2 = parcelRequire("e1AU2");
parcelRequire("d0pqD");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $kVLXA = parcelRequire("kVLXA");

var $8B7Oi = parcelRequire("8B7Oi");

var $gI62y = parcelRequire("gI62y");

var $bXPjr = parcelRequire("bXPjr");

var $7a5fK = parcelRequire("7a5fK");

var $aq199 = parcelRequire("aq199");

var $99gkn = parcelRequire("99gkn");

var $x9xyg = parcelRequire("x9xyg");

var $2YZCu = parcelRequire("2YZCu");

var $8PRuf = parcelRequire("8PRuf");


var $iuuJH = parcelRequire("iuuJH");

var $kjrfP = parcelRequire("kjrfP");

var $hjlQ8 = parcelRequire("hjlQ8");

var $jQCwr = parcelRequire("jQCwr");

var $127QL = parcelRequire("127QL");

var $9WrsG = parcelRequire("9WrsG");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $8yiLS = parcelRequire("8yiLS");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $4Tseb = parcelRequire("4Tseb");
// This epic will trigger when server side rendering provides a initial state
const $b9ece440dec8b281$var$onReadyWithInitializeStateEpic = (action$, store)=>action$.ofType((0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).map(()=>(0, $9WrsG.devStatusLoad)((0, $vAfHD.boardOrderedIssueIdsSelector)(store.getState())));
const $b9ece440dec8b281$export$a28f8e714e737b2e = (cmpBoardData, store)=>{
    const setDataFromCmpBoard = (response)=>{
        const action = (0, $cW3pH.workDataSet)((0, $kjrfP.transformMobileResponse)(response));
        const state = store.getState();
        const customFilterIds = (0, $8yiLS.getActiveCustomFilterIds)(state);
        const isCustomFiltersOn = customFilterIds.length > 0;
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        const swimlaneModeIdLocalStorage = (0, $jQCwr.getSwimlaneModeSetting)(rapidViewId.toString());
        if (!swimlaneModeIdLocalStorage) return (0, $4Tseb.handleCMPBoardDataSet)(action, isCustomFiltersOn);
        // For JQL swimlanes in CMP boards, use admin/backend settings as only admins can configure them
        if (swimlaneModeIdLocalStorage === (0, $iuuJH.SWIMLANE_BY_JQL).id) return (0, $4Tseb.handleCMPBoardDataSet)(action, isCustomFiltersOn);
        return (0, $4Tseb.handleCMPBoardDataSet)({
            ...action,
            payload: {
                ...action.payload,
                swimlaneModeId: swimlaneModeIdLocalStorage
            }
        }, isCustomFiltersOn);
    };
    return (0, $bXPjr.fromPromise)(cmpBoardData).flatMap((cachedDataResult)=>{
        if (!cachedDataResult) return (0, $8B7Oi.empty)();
        const { result: result, refresh: refresh } = cachedDataResult;
        const refresh$ = refresh ? (0, $bXPjr.fromPromise)(refresh) : (0, $8B7Oi.empty)();
        const refreshActions$ = refresh$.flatMap(setDataFromCmpBoard);
        // At this point, the resolved data in result could possibly from indexeddb cache.
        // Wait the refresh promise to resolve to ensure the critical data query is completed.
        const addRequestServerTime$ = (0, $bXPjr.fromPromise)(refresh || Promise.resolve(null)).flatMap(()=>{
            const serverTime = Array.from(performance.getEntriesByType('resource')).find(({ name: name })=>name.includes('fetchBoardData'))?.serverTiming.find(({ name: name })=>name === 'atl-edge')?.duration;
            (0, $99gkn.addUFOCustomData)({
                serverTime: serverTime
            });
            return (0, $kVLXA.Observable).empty();
        });
        if ((0, $5mTgl.isBoardConfigLoaded)(store.getState()) && refresh) return (0, $7a5fK.merge)((0, $kVLXA.Observable).of((0, $127QL.boardDeferredDataLoad)()), refreshActions$, addRequestServerTime$);
        return (0, $7a5fK.merge)(setDataFromCmpBoard(result), refreshActions$, (0, $kVLXA.Observable).of((0, $127QL.boardDeferredDataLoad)()), addRequestServerTime$);
    });
};
const $b9ece440dec8b281$var$onBoardScopeLoadEpic = (action$, store)=>action$.ofType((0, $65C0W.SOFTWARE_APP_LOADED)).switchMap((action)=>{
        if (action.payload.cmpBoardData) return $b9ece440dec8b281$export$a28f8e714e737b2e(action.payload.cmpBoardData, store);
        const boardScope = action.payload.prefetchData;
        // No boardScope is an error for TMP boards (means the prefetch has
        // failed). For CMP and Incremental Planning we will just no-op.
        if (!boardScope) {
            const { isCMPBoard: isCMPBoard, isIncrementPlanningBoard: isIncrementPlanningBoard } = store.getState().configuration;
            return isCMPBoard || isIncrementPlanningBoard ? (0, $gI62y.from)([]) : (0, $aq199.of)((0, $cW3pH.loadBoardFailure)());
        }
        if (boardScope && (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(boardScope.board.columns)) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board.transform.critical.data', 'Board does not have any columns', {
                message: 'Columns does not exist for Board'
            });
            // data wont be in state, need to retrieve from payload.
            const canConfigureBoard = boardScope.currentUser.permissions.includes((0, $68cf6bf1ce76db03$export$b893894941c14e43));
            return (0, $aq199.of)((0, $cW3pH.loadBoardFailureNoColumn)(true, canConfigureBoard));
        }
        // Used to gather data to see impact of transformer on performance of large boards.
        // Will be removed once enough data is gathered.
        (0, $x9xyg.setMark)((0, $8PRuf.jswTransformCriticalDataStartMark));
        const criticalData = (0, $hjlQ8.transformCriticalData)(boardScope);
        (0, $x9xyg.setMark)((0, $8PRuf.jswTransformCriticalDataEndMark));
        const actions = [
            (0, $cW3pH.workDataCriticalSet)(criticalData)
        ];
        // Async actions to kick off after the first load only
        const issues = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(criticalData, [
            'issues'
        ], null);
        if (issues) {
            const issueIds = issues.map((issue)=>issue.id);
            actions.push((0, $9WrsG.devStatusLoad)(issueIds));
        }
        return (0, $gI62y.from)(actions);
    }).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.scope.on.ready.failure', 'Failure on board scope on ready', error);
        return (0, $aq199.of)((0, $cW3pH.loadBoardFailure)());
    });
var $b9ece440dec8b281$export$2e2bcd8739ae039 = (0, $e1AU2.combineEpics)($b9ece440dec8b281$var$onReadyWithInitializeStateEpic, $b9ece440dec8b281$var$onBoardScopeLoadEpic);

});

parcelRegister("dEmHW", function(module, exports) {

$parcel$export(module.exports, "addToSprintEpic", () => $8c8c7351b59abb61$export$58f658ee7e67fdd6);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("93e44");
parcelRequire("6hSeW");
parcelRequire("7mHDu");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");


var $23D0N = parcelRequire("23D0N");

var $hdmw1 = parcelRequire("hdmw1");

var $dkGow = parcelRequire("dkGow");

var $cW3pH = parcelRequire("cW3pH");

var $ebHh7 = parcelRequire("ebHh7");
function $8c8c7351b59abb61$export$58f658ee7e67fdd6(action$, store) {
    return action$.ofType((0, $dkGow.ADD_TO_SPRINT_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const context = (0, $hdmw1.makeServiceContext)(state);
        const optimisticId = action?.meta?.optimistic.id;
        const activeSprints = (0, $ebHh7.activeSprintsSelector)(state);
        const sprint = activeSprints && activeSprints.length && activeSprints.find((sprintItem)=>sprintItem.id === action?.payload?.sprintId);
        if (!action?.payload?.issueId || !sprint) return (0, $kVLXA.Observable).empty();
        return (0, $23D0N.addToSprint)(action.payload.issueId, sprint.id, Number(context.boardId)).mergeMap(()=>(0, $kVLXA.Observable).merge((0, $kVLXA.Observable).of((0, $dkGow.addToSprintSuccess)(action.payload.issueId, sprint.id, optimisticId ?? '')), (0, $kVLXA.Observable).of((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$62b6dae85d0fc668))))).catch(()=>(0, $kVLXA.Observable).of((0, $dkGow.addToSprintFailure)(action.payload.issueId, sprint.id, optimisticId ?? '')));
    });
}

});
parcelRegister("23D0N", function(module, exports) {

$parcel$export(module.exports, "addToSprint", () => $61997d122914c9b4$export$96b61236d7221fa);

var $7zmUm = parcelRequire("7zmUm");
function $61997d122914c9b4$export$96b61236d7221fa(issueKey, sprintId, rapidViewId) {
    return (0, $7zmUm.default)('/rest/greenhopper/1.0/sprint/rank?operation=AddToSprint', {
        method: 'PUT',
        body: JSON.stringify({
            addToBacklog: false,
            sprintId: sprintId,
            rapidViewId: rapidViewId,
            calculateNewIssuesOrder: false,
            idOrKeys: [
                issueKey
            ]
        })
    });
}

});


parcelRegister("1wh3p", function(module, exports) {

$parcel$export(module.exports, "removeFromSprintEpic", () => $7f7aa3071789685b$export$eebf8a140511e790);

var $kVLXA = parcelRequire("kVLXA");

var $6s1PB = parcelRequire("6s1PB");
parcelRequire("fp4O3");
parcelRequire("93e44");
parcelRequire("6hSeW");
parcelRequire("7mHDu");
parcelRequire("d0pqD");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $4R6GH = parcelRequire("4R6GH");

var $23D0N = parcelRequire("23D0N");

var $bHNg5 = parcelRequire("bHNg5");

var $hdmw1 = parcelRequire("hdmw1");

var $bkCF5 = parcelRequire("bkCF5");

var $dkGow = parcelRequire("dkGow");

var $5G4Hb = parcelRequire("5G4Hb");

var $cW3pH = parcelRequire("cW3pH");

var $d2i8f = parcelRequire("d2i8f");

var $h0yHz = parcelRequire("h0yHz");
function $7f7aa3071789685b$var$onBeforeunload(e) {
    e.preventDefault(); // Firefox
    // The message returned in `beforeunload` handler doesn't have any effect in modern browsers
    const message = '';
    e.returnValue = message; // Chrome
    return message; // IE
}
function $7f7aa3071789685b$export$eebf8a140511e790(action$, store) {
    return action$.ofType((0, $5G4Hb.REMOVE_FROM_SPRINT_REQUEST)).flatMap((action)=>{
        const state = store.getState();
        const context = (0, $hdmw1.makeServiceContext)(state);
        const issue = (0, $d2i8f.getIssueById)(state, action.payload.issueId);
        // Ignore if issue missing, could be some sort of race condition from real-time updates
        if (!issue) return (0, $kVLXA.Observable).empty();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('beforeunload', $7f7aa3071789685b$var$onBeforeunload);
        const undoFlag = (0, $bkCF5.showUndoFlag)({
            id: action.meta.optimistic.id,
            titleMessage: (0, $h0yHz.messages).undoMessageTitle,
            descriptionMessage: (0, $h0yHz.messages).undoMessageDescription,
            context: {
                issueKey: issue.key
            },
            links: [
                {
                    content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $h0yHz.messages).undoMessageViewIssueIssueTermRefresh : (0, $h0yHz.messages).undoMessageViewIssue,
                    href: `/browse/${issue.key}`
                }
            ]
        });
        const optimisticId = action.meta.optimistic.id;
        const undoFlagId = undoFlag.meta.flag.id;
        const issueId = issue.id;
        const issueKey = issue.key;
        const sprintId = issue.sprintId;
        const remove$ = action$.ofType((0, $bkCF5.SHOW_UNDO_FLAG)).take(1).flatMap(()=>{
            if ((0, $4R6GH.fg)('jira-removefromsprint-nodelay')) return (0, $bHNg5.removeFromSprintService)(context, {
                issueKey: issueKey
            }).map(()=>(0, $5G4Hb.removeFromSprintSuccess)(issueId, issueKey, optimisticId)).catch((_err)=>(0, $kVLXA.Observable).of((0, $5G4Hb.removeFromSprintFailure)(issueKey, optimisticId)));
            return (0, $kVLXA.Observable).empty();
        });
        const finish$ = action$.ofType((0, $bkCF5.UNDO_FLAG_PERFORM_COMMIT), (0, $bkCF5.UNDO_FLAG_PERFORM_UNDO), (0, $cW3pH.BEFORE_DISPOSE)).filter((commitAction)=>commitAction.type === (0, $cW3pH.BEFORE_DISPOSE) || commitAction.payload.flagId === undoFlagId).take(1).flatMap((undoAction)=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('beforeunload', $7f7aa3071789685b$var$onBeforeunload);
            if (undoAction.type === (0, $bkCF5.UNDO_FLAG_PERFORM_UNDO)) {
                if ((0, $4R6GH.fg)('jira-removefromsprint-nodelay')) {
                    const sprintIdNumber = Number.parseInt(sprintId, 10);
                    const boardId = Number.parseInt(context.boardId, 10);
                    return (0, $23D0N.addToSprint)(issueId.toString(), sprintIdNumber, boardId).map(()=>(0, $dkGow.addToSprintSuccess)(issueId.toString(), sprintIdNumber, optimisticId)).catch((_err)=>(0, $kVLXA.Observable).of((0, $dkGow.addToSprintFailure)(issueId.toString(), sprintIdNumber, optimisticId)));
                }
                return (0, $kVLXA.Observable).of((0, $5G4Hb.removeFromSprintFailure)(issueKey, optimisticId));
            }
            if (!(0, $4R6GH.fg)('jira-removefromsprint-nodelay')) return (0, $bHNg5.removeFromSprintService)(context, {
                issueKey: issueKey
            }).map(()=>(0, $5G4Hb.removeFromSprintSuccess)(issueId, issueKey, optimisticId)).catch((_err)=>(0, $kVLXA.Observable).of((0, $5G4Hb.removeFromSprintFailure)(issueKey, optimisticId)));
            return (0, $kVLXA.Observable).empty();
        });
        return (0, $kVLXA.Observable).merge(remove$, (0, $kVLXA.Observable).of(undoFlag), finish$);
    });
}

});
parcelRegister("bHNg5", function(module, exports) {

$parcel$export(module.exports, "removeFromSprintService", () => $a15286b8733fe1e4$export$c6f196f77fdc2f20);

var $lnBKM = parcelRequire("lnBKM");
function $a15286b8733fe1e4$export$c6f196f77fdc2f20(ctx, { issueKey: issueKey }) {
    return (0, $lnBKM.removeFromSprint)(ctx.boardId, ctx.contextPath, issueKey);
}

});
parcelRegister("lnBKM", function(module, exports) {

$parcel$export(module.exports, "removeFromSprint", () => $579cdffa4308cff3$export$6fa72ebb3370c788);

var $487fd = parcelRequire("487fd");
function $579cdffa4308cff3$export$6fa72ebb3370c788(rapidViewId, contextPath, issueKey) {
    return (0, $487fd.default)(`${contextPath}/rest/greenhopper/1.0/sprint/rank/${rapidViewId}/remove?operation=RemoveFromSprint`, {
        method: 'PUT',
        body: JSON.stringify({
            rapidViewId: rapidViewId,
            idOrKeys: [
                issueKey
            ]
        })
    });
}

});


parcelRegister("5G4Hb", function(module, exports) {

$parcel$export(module.exports, "REMOVE_FROM_SPRINT_REQUEST", () => $aadb230814d99b94$export$6c875bdb249fba00);
$parcel$export(module.exports, "removeFromSprintRequest", () => $aadb230814d99b94$export$ea2399222f9b9105);
$parcel$export(module.exports, "removeFromSprintSuccess", () => $aadb230814d99b94$export$164a6a996c3b9d17);
$parcel$export(module.exports, "removeFromSprintFailure", () => $aadb230814d99b94$export$ddcd9eec6bce5fe0);

var $9rND4 = parcelRequire("9rND4");
const $aadb230814d99b94$export$6c875bdb249fba00 = 'state.actions.sprints.remove-from-sprint.REMOVE_FROM_SPRINT_REQUEST';
function $aadb230814d99b94$export$ea2399222f9b9105(issueId) {
    return {
        type: $aadb230814d99b94$export$6c875bdb249fba00,
        payload: {
            issueId: issueId
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    };
}
const $aadb230814d99b94$export$734d921bbf79186d = 'state.actions.sprints.remove-from-sprint.REMOVE_FROM_SPRINT_SUCCESS';
function $aadb230814d99b94$export$164a6a996c3b9d17(issueId, issueKey, optimisticId) {
    return {
        type: $aadb230814d99b94$export$734d921bbf79186d,
        payload: {
            issueKey: issueKey
        },
        meta: {
            ...(0, $9rND4.commitOptimisticUiMeta)(optimisticId)
        }
    };
}
const $aadb230814d99b94$export$fb018d68d0e9917b = 'state.actions.sprints.remove-from-sprint.REMOVE_FROM_SPRINT_FAILURE';
function $aadb230814d99b94$export$ddcd9eec6bce5fe0(issueKey, optimisticId) {
    return {
        type: $aadb230814d99b94$export$fb018d68d0e9917b,
        payload: {
            issueKey: issueKey
        },
        meta: (0, $9rND4.revertOptimisticUiMeta)(optimisticId)
    };
}

});

parcelRegister("h0yHz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $82fa575f4524509b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $82fa575f4524509b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    undoMessageTitle: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-title",
        "defaultMessage": "{issueKey} removed from sprint"
    },
    undoMessageDescription: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-description",
        "defaultMessage": "Sprint scope will be affected by this action"
    },
    undoMessageViewIssue: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-view-issue",
        "defaultMessage": "View issue"
    },
    undoMessageViewIssueIssueTermRefresh: {
        "id": "software.main.ops.sprint.remove-from-sprint.undo-message-view-issue-issue-term-refresh",
        "defaultMessage": "View"
    }
});

});


parcelRegister("3usqj", function(module, exports) {

$parcel$export(module.exports, "updatePlannedCapacityEpic", () => $43d8352dbd9ca057$export$f1770649aa810bf1);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $hUobS = parcelRequire("hUobS");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $bdYfL = parcelRequire("bdYfL");

var $4kOHs = parcelRequire("4kOHs");

var $cPGP0 = parcelRequire("cPGP0");
function $43d8352dbd9ca057$export$f1770649aa810bf1(action$, store, { customRequestHandlers: customRequestHandlers }) {
    return action$.ofType((0, $4kOHs.UPDATE_PLANNED_CAPACITY_REQUEST)).mergeMap((action)=>{
        const { payload: { capacity: capacity, planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay, iterationId: iterationId, teamId: teamId, totalCapacity: totalCapacity, defaultCapacity: defaultCapacity } } = action;
        const { planningStyle: planningStyle } = (0, $cPGP0.getTeamById)(store.getState())(teamId);
        const currentCapacity = totalCapacity === null ? defaultCapacity : totalCapacity;
        if (capacity !== '') {
            const newCapacity = parseFloat(capacity);
            const convertedCapacity = (0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(currentCapacity) && (0, $bdYfL.convertCapacity)(currentCapacity, planningUnit, workingHoursPerDay) || 0;
            if (Number.isNaN(newCapacity) || convertedCapacity === newCapacity) return (0, $kVLXA.Observable).empty();
        }
        const requestPayload = {
            iterationId: `${iterationId}`,
            planningUnit: planningUnit,
            teamId: teamId,
            schedulingMode: planningStyle
        };
        const success = (payload)=>(0, $kVLXA.Observable).of((0, $4kOHs.updatePlannedCapacitySuccess)(payload));
        const error = (err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('increment.planning.planned.capacity.update', 'Failed to update IP board planned capacity', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            return (0, $kVLXA.Observable).of((0, $4kOHs.updatePlannedCapacityFailed)());
        };
        if (!customRequestHandlers) return error(new Error('no request handler found for planned capacity update'));
        if (capacity === '') {
            if (!customRequestHandlers?.removePlannedCapacity) return error(new Error('no request handler found for planned capacity update'));
            return (0, $kVLXA.Observable).from(customRequestHandlers.removePlannedCapacity({
                ...requestPayload,
                capacity: null
            })).flatMap(()=>success({
                    teamId: teamId,
                    iterationId: `${iterationId}`,
                    capacity: null
                })).catch((err)=>error(err));
        }
        const parsed = parseFloat(capacity);
        const convertedCapacity = (0, $bdYfL.convertCapacityFromPlanningUnitToSeconds)({
            capacity: parsed || 0,
            planningUnit: planningUnit,
            workingHours: workingHoursPerDay
        });
        if (!customRequestHandlers?.updatePlannedCapacity) return error(new Error('no request handler found for planned capacity update'));
        return (0, $kVLXA.Observable).from(customRequestHandlers.updatePlannedCapacity({
            ...requestPayload,
            capacity: convertedCapacity
        })).flatMap(()=>success({
                teamId: teamId,
                iterationId: `${iterationId}`,
                capacity: convertedCapacity
            })).catch((err)=>error(err));
    });
}

});
parcelRegister("hUobS", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $d09a6e5a442af90c$var$numberTag = '[object Number]';
/**
 * Checks if `value` is classified as a `Number` primitive or object.
 *
 * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
 * classified as numbers, use the `_.isFinite` method.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a number, else `false`.
 * @example
 *
 * _.isNumber(3);
 * // => true
 *
 * _.isNumber(Number.MIN_VALUE);
 * // => true
 *
 * _.isNumber(Infinity);
 * // => true
 *
 * _.isNumber('3');
 * // => false
 */ function $d09a6e5a442af90c$var$isNumber(value) {
    return typeof value == 'number' || $fC1Kz(value) && $beQoo(value) == $d09a6e5a442af90c$var$numberTag;
}
module.exports = $d09a6e5a442af90c$var$isNumber;

});

parcelRegister("4kOHs", function(module, exports) {

$parcel$export(module.exports, "UPDATE_PLANNED_CAPACITY_REQUEST", () => $22a59df7f5bb3c13$export$5859d8c0e774f8e8);
$parcel$export(module.exports, "updatePlannedCapacityRequest", () => $22a59df7f5bb3c13$export$cd7a68543ecb6c);
$parcel$export(module.exports, "UPDATE_PLANNED_CAPACITY_SUCCESS", () => $22a59df7f5bb3c13$export$b9d4eb073fa690f1);
$parcel$export(module.exports, "updatePlannedCapacitySuccess", () => $22a59df7f5bb3c13$export$3f0ed55bbd56051);
$parcel$export(module.exports, "updatePlannedCapacityFailed", () => $22a59df7f5bb3c13$export$308743726309d7b7);
const $22a59df7f5bb3c13$export$5859d8c0e774f8e8 = 'state.actions.sprint.update-planned-capacity.UPDATE_PLANNED_CAPACITY_REQUEST';
const $22a59df7f5bb3c13$export$cd7a68543ecb6c = (payload)=>({
        type: $22a59df7f5bb3c13$export$5859d8c0e774f8e8,
        payload: payload
    });
const $22a59df7f5bb3c13$export$b9d4eb073fa690f1 = 'state.actions.sprint.update-planned-capacity.UPDATE_PLANNED_CAPACITY_SUCCESS';
const $22a59df7f5bb3c13$export$3f0ed55bbd56051 = (payload)=>({
        type: $22a59df7f5bb3c13$export$b9d4eb073fa690f1,
        payload: payload
    });
const $22a59df7f5bb3c13$export$ce51476e09ff4eff = 'state.actions.sprint.update-planned-capacity.UPDATE_PLANNED_CAPACITY_FAILED';
const $22a59df7f5bb3c13$export$308743726309d7b7 = ()=>({
        type: $22a59df7f5bb3c13$export$ce51476e09ff4eff
    });

});


parcelRegister("h07lG", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9be163e55c3a38$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");

var $65C0W = parcelRequire("65C0W");

var $j6rJH = parcelRequire("j6rJH");

var $67Z81 = parcelRequire("67Z81");
const $2a9be163e55c3a38$var$getUrl = (contextPath)=>`${contextPath}${0, $2bQEl.STATUS_CATEGORY_URL}`;
const $2a9be163e55c3a38$var$loadStatusCategories = (state)=>{
    const url = $2a9be163e55c3a38$var$getUrl((0, $67Z81.contextPathSelector)(state));
    return (0, $487fd.default)(url);
};
const $2a9be163e55c3a38$var$handleSuccess = (result)=>{
    const statusCategories = result.map((statusCategory)=>({
            id: statusCategory.id,
            key: statusCategory.key,
            name: statusCategory.name
        }));
    return (0, $kVLXA.Observable).of((0, $j6rJH.statusCategoryLoadSuccess)(statusCategories));
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a9be163e55c3a38$var$handleFailure = (error)=>(0, $kVLXA.Observable).of((0, $j6rJH.statusCategoryLoadFailure)(error));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2a9be163e55c3a38$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $65C0W.SOFTWARE_APP_LOADED), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).switchMap(()=>$2a9be163e55c3a38$var$loadStatusCategories(store.getState())).flatMap((result)=>$2a9be163e55c3a38$var$handleSuccess(result)).catch((error)=>$2a9be163e55c3a38$var$handleFailure(error));

});
parcelRegister("j6rJH", function(module, exports) {

$parcel$export(module.exports, "STATUS_CATEGORY_LOAD_SUCCESS", () => $03dc4b7ee6adc6c5$export$147e518ef26092bd);
$parcel$export(module.exports, "statusCategoryLoadSuccess", () => $03dc4b7ee6adc6c5$export$20ce695a9c21c055);
$parcel$export(module.exports, "statusCategoryLoadFailure", () => $03dc4b7ee6adc6c5$export$a44c75f1752a390e);
const $03dc4b7ee6adc6c5$export$147e518ef26092bd = 'state.actions.status-category.STATUS_CATEGORY_LOAD_SUCCESS';
const $03dc4b7ee6adc6c5$export$20ce695a9c21c055 = (statusCategories)=>({
        type: $03dc4b7ee6adc6c5$export$147e518ef26092bd,
        payload: {
            statusCategories: statusCategories
        }
    });
const $03dc4b7ee6adc6c5$export$114d3cbff3f74bbf = 'state.actions.status-category.STATUS_CATEGORY_LOAD_FAILURE';
const $03dc4b7ee6adc6c5$export$a44c75f1752a390e = (error)=>({
        type: $03dc4b7ee6adc6c5$export$114d3cbff3f74bbf,
        error: error
    });

});


parcelRegister("7QNZV", function(module, exports) {

$parcel$export(module.exports, "jqlSwimlanesEpic", () => $68714754f5d7237c$export$cc17f82cc987d2f3);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fPS7b");
parcelRequire("6cbqE");
parcelRequire("1oQta");
parcelRequire("6hSeW");
parcelRequire("fp4O3");
parcelRequire("7mHDu");

var $iuuJH = parcelRequire("iuuJH");

var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $cW3pH = parcelRequire("cW3pH");

var $45cXl = parcelRequire("45cXl");
const $68714754f5d7237c$export$cc17f82cc987d2f3 = (action$, store)=>action$.ofType((0, $ls4NM.ISSUE_CREATE_REQUEST)).filter(()=>(0, $45cXl.getSwimlaneMode)(store.getState()) === (0, $iuuJH.SWIMLANE_BY_JQL).id).switchMap((issueCreateRequestAction)=>{
        const { meta: { swimlaneId: swimlaneId, isSwimlaneByJql: isSwimlaneByJql } } = issueCreateRequestAction;
        const jqlSwimlanesData = (0, $45cXl.getJqlSwimlanesData)(store.getState());
        if (!isSwimlaneByJql || !jqlSwimlanesData) return (0, $kVLXA.Observable).empty();
        let originalSwimlaneId = swimlaneId;
        const jqlSwimlanesMap = {};
        jqlSwimlanesData.forEach((swimlane)=>{
            // If swimlaneId is null in the create request, then it corresponds to the default swimlane
            if (swimlaneId === null && swimlane.isDefaultSwimlane) originalSwimlaneId = swimlane.id;
            Object.assign(jqlSwimlanesMap, {
                [swimlane.id]: {
                    length: swimlane.issueIds.length,
                    issueIds: new Set(swimlane.issueIds)
                }
            });
        });
        return action$.ofType((0, $cW3pH.WORK_DATA_SET)).take(1).mergeMap((workDataSetAction)=>{
            if (!workDataSetAction.payload.jqlSwimlanes) return (0, $kVLXA.Observable).empty();
            let issuesWereRemovedFromOriginalSwimlane = false;
            const movedIssueKeys = [];
            // Here we compare the current jql swimlanes in state, with the new jql swimlanes after board refresh
            // to see if any issues were removed from the original swimlane and added to another swimlane
            workDataSetAction.payload.jqlSwimlanes.forEach(({ id: id, issueIds: issueIds })=>{
                const jqlSwimlane = jqlSwimlanesMap[id];
                // exit if the swimlane does not exist in the original state
                if (!jqlSwimlane) return;
                const oldSwimlaneLength = jqlSwimlane.length;
                const newSwimlaneLength = issueIds.length;
                if (id === originalSwimlaneId) // Check if the original swimlane has had issues removed
                {
                    if (oldSwimlaneLength > newSwimlaneLength) issuesWereRemovedFromOriginalSwimlane = true;
                } else if (oldSwimlaneLength < newSwimlaneLength) issueIds.forEach((issueId)=>{
                    if (!jqlSwimlane.issueIds.has(issueId)) {
                        // Get the issue key of any issues that were added to a swimlane, as this will be needed
                        // for the flag component
                        const issueKey = workDataSetAction.payload.issues.find((issue)=>issue.id === issueId)?.key;
                        issueKey && movedIssueKeys.push(issueKey);
                    }
                });
            });
            // We show the flag if issues were removed from the original swimlane AND added to another swimlane
            if (issuesWereRemovedFromOriginalSwimlane && movedIssueKeys.length) return (0, $kVLXA.Observable).of((0, $bkCF5.issueCreateMovedBetweenJqlSwimlanes)(movedIssueKeys));
            return (0, $kVLXA.Observable).empty();
        });
    });

});

parcelRegister("lfaRE", function(module, exports) {

$parcel$export(module.exports, "default", () => $2911ccd4c540473a$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $jQCwr = parcelRequire("jQCwr");

var $k50Aq = parcelRequire("k50Aq");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$2911ccd4c540473a$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $k50Aq.SWIMLANE_TOGGLE)).mergeMap(()=>{
        const state = store.getState();
        (0, $jQCwr.setCollapsedSwimlanes)((0, $67Z81.rapidViewIdSelector)(state), (0, $4jZ56.getCollapsedSwimlanes)(state));
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("l4Gux", function(module, exports) {

$parcel$export(module.exports, "default", () => $d11f4256b05ac949$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("fPS7b");

var $jQCwr = parcelRequire("jQCwr");

var $k50Aq = parcelRequire("k50Aq");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d11f4256b05ac949$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $k50Aq.SWIMLANES_TOGGLE)).mergeMap(()=>{
        const state = store.getState();
        (0, $jQCwr.setCollapsedSwimlanes)((0, $67Z81.rapidViewIdSelector)(state), (0, $4jZ56.getCollapsedSwimlanes)(state));
        return (0, $kVLXA.Observable).empty();
    });

});

parcelRegister("1AmgY", function(module, exports) {

$parcel$export(module.exports, "updateIterationCapacityEpic", () => $852676863afb8d79$export$fa884f29220c32ee);
parcelRequire("6hSeW");
parcelRequire("zjDln");
parcelRequire("fp4O3");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $hUobS = parcelRequire("hUobS");

var $kVLXA = parcelRequire("kVLXA");

var $2YZCu = parcelRequire("2YZCu");

var $bdYfL = parcelRequire("bdYfL");

var $iOpiy = parcelRequire("iOpiy");

var $bL0WB = parcelRequire("bL0WB");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");
function $852676863afb8d79$export$fa884f29220c32ee(action$, store) {
    return action$.ofType((0, $bL0WB.UPDATE_ITERATION_CAPACITY_REQUEST)).mergeMap((action)=>{
        const { payload: { capacity: capacity, planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay, iterationId: iterationId, teamId: teamId, totalCapacity: totalCapacity, defaultCapacity: defaultCapacity } } = action;
        const { planningStyle: planningStyle } = (0, $cPGP0.getTeamById)(store.getState())(teamId);
        const planId = (0, $67Z81.getPlanId)(store.getState());
        const incrementId = (0, $67Z81.rapidViewIdSelector)(store.getState());
        const currentCapacity = totalCapacity ?? defaultCapacity;
        if (capacity !== '') {
            const newCapacity = parseFloat(capacity);
            const convertedCapacity = (0, (/*@__PURE__*/$parcel$interopDefault($hUobS)))(currentCapacity) && (0, $bdYfL.convertCapacity)(currentCapacity, planningUnit, workingHoursPerDay) || 0;
            if (Number.isNaN(newCapacity) || convertedCapacity === newCapacity) return (0, $kVLXA.Observable).empty();
        }
        const success = (payload)=>(0, $kVLXA.Observable).of((0, $bL0WB.updateIterationCapacitySuccess)(payload));
        const error = (err)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('increment.planning.iteration.capacity.update', 'Failed to update IP board iteration capacity', // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            err);
            return (0, $kVLXA.Observable).of((0, $bL0WB.updateIterationCapacityFailed)());
        };
        if (!planId) return error(new Error('planId is empty in the update iteration capacity request'));
        if (!incrementId) return error(new Error('incrementId is empty in the update iteration capacity request'));
        const requestPayload = {
            iterationId: iterationId,
            planningUnit: planningUnit,
            teamId: teamId,
            schedulingMode: planningStyle,
            planId: planId,
            incrementId: incrementId
        };
        if (capacity === '') return (0, $iOpiy.removeIterationCapacity)(requestPayload).flatMap(()=>success({
                teamId: teamId,
                iterationId: iterationId,
                capacity: null
            })).catch((err)=>error(err));
        const parsed = parseFloat(capacity);
        const convertedCapacity = (0, $bdYfL.convertCapacityFromPlanningUnitToSeconds)({
            capacity: parsed || 0,
            planningUnit: planningUnit,
            workingHours: workingHoursPerDay
        });
        return (0, $iOpiy.updateIterationCapacity)({
            ...requestPayload,
            capacity: convertedCapacity
        }).flatMap(()=>success({
                teamId: teamId,
                iterationId: iterationId,
                capacity: convertedCapacity
            })).catch((err)=>error(err));
    });
}

});
parcelRegister("iOpiy", function(module, exports) {

$parcel$export(module.exports, "updateIterationCapacity", () => $aaaf310c869d7c09$export$10e76591bc519cd7);
$parcel$export(module.exports, "removeIterationCapacity", () => $aaaf310c869d7c09$export$be150319b39796ad);

var $7zmUm = parcelRequire("7zmUm");
function $aaaf310c869d7c09$export$10e76591bc519cd7({ iterationId: iterationId, teamId: teamId, planningUnit: planningUnit, planId: planId, incrementId: incrementId, capacity: capacity }) {
    return (0, $7zmUm.default)(`/rest/jpo/2.0/plans/${planId}/increments/${incrementId}/capacity/add?operation=UpdateIterationCapacity`, {
        method: 'POST',
        body: JSON.stringify({
            iterationId: iterationId,
            teamId: teamId,
            planningUnit: planningUnit,
            capacity: capacity
        })
    });
}
function $aaaf310c869d7c09$export$be150319b39796ad({ iterationId: iterationId, teamId: teamId, planningUnit: planningUnit, planId: planId, incrementId: incrementId }) {
    return (0, $7zmUm.default)(`/rest/jpo/2.0/plans/${planId}/increments/${incrementId}/capacity/delete?operation=RemoveIterationCapacity`, {
        method: 'POST',
        body: JSON.stringify({
            iterationId: iterationId,
            teamId: teamId,
            planningUnit: planningUnit
        })
    });
}

});

parcelRegister("bL0WB", function(module, exports) {

$parcel$export(module.exports, "UPDATE_ITERATION_CAPACITY_REQUEST", () => $1bfbc9662e37081d$export$6a88665027e1b4e8);
$parcel$export(module.exports, "updateIterationCapacityRequest", () => $1bfbc9662e37081d$export$fe39897c107ee69b);
$parcel$export(module.exports, "UPDATE_ITERATION_CAPACITY_SUCCESS", () => $1bfbc9662e37081d$export$9d109fc28006a62);
$parcel$export(module.exports, "updateIterationCapacitySuccess", () => $1bfbc9662e37081d$export$1f3c13015efad73d);
$parcel$export(module.exports, "updateIterationCapacityFailed", () => $1bfbc9662e37081d$export$4a9a123cabbe169);

var $7AVqz = parcelRequire("7AVqz");

var $sdxnu = parcelRequire("sdxnu");
const $1bfbc9662e37081d$export$6a88665027e1b4e8 = 'state.actions.team.UPDATE_ITERATION_CAPACITY_REQUEST';
const $1bfbc9662e37081d$export$fe39897c107ee69b = (payload)=>({
        type: $1bfbc9662e37081d$export$6a88665027e1b4e8,
        payload: payload
    });
const $1bfbc9662e37081d$export$9d109fc28006a62 = 'state.actions.team.UPDATE_ITERATION_CAPACITY_SUCCESS';
const $1bfbc9662e37081d$export$1f3c13015efad73d = (payload)=>({
        type: $1bfbc9662e37081d$export$9d109fc28006a62,
        payload: payload
    });
const $1bfbc9662e37081d$export$9a57682116a37e4c = 'state.actions.team.UPDATE_ITERATION_CAPACITY_FAILED';
const $1bfbc9662e37081d$export$4a9a123cabbe169 = ()=>({
        type: $1bfbc9662e37081d$export$9a57682116a37e4c,
        meta: (0, $sdxnu.errorFlagMeta)({
            titleMessage: (0, $7AVqz.default).genericTitle,
            descriptionMessage: (0, $7AVqz.default).genericDescription
        })
    });

});


parcelRegister("8wkzB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1357d07a1f414a1$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $4cr9K = parcelRequire("4cr9K");


var $hdmw1 = parcelRequire("hdmw1");

var $jQCwr = parcelRequire("jQCwr");

var $FARqm = parcelRequire("FARqm");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");

var $67Z81 = parcelRequire("67Z81");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1357d07a1f414a1$export$2e2bcd8739ae039 = (action$, store)=>action$.ofType((0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST)).mergeMap((action)=>{
        const state = store.getState();
        const { meta: { optimistic: { id: txId } }, payload: swimlaneMode } = action;
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const rapidViewId = (0, $67Z81.rapidViewIdSelector)(state);
        const ctx = (0, $hdmw1.makeServiceContext)(state);
        if (ctx.isCMPBoard) {
            (0, $jQCwr.setSwimlaneModeSetting)(rapidViewId, action.payload);
            return (0, $kVLXA.Observable).of((0, $k50Aq.swimlaneModeChangeSuccess)(txId));
        }
        return (0, $FARqm.default)(contextPath, rapidViewId, swimlaneMode).flatMap(()=>(0, $kVLXA.Observable).of((0, $k50Aq.swimlaneModeChangeSuccess)(txId))).catch((error)=>(0, $kVLXA.Observable).of(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            (0, $k50Aq.swimlaneModeChangeFailure)(txId), (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$d9d2fe902bd6d9a7)), (0, $4cr9K.showErrorFlag)(error)));
    });

});
parcelRegister("FARqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $15ab360a2a7cca30$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("3q49N");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $jVaxm = parcelRequire("jVaxm");

var $cjoN4 = parcelRequire("cjoN4");
const $15ab360a2a7cca30$export$51186ad6e864892a = (data)=>data.strategy;
function $15ab360a2a7cca30$export$2e2bcd8739ae039(contextPath, boardId, swimlaneStrategy) {
    return (0, $jVaxm.default)(contextPath, boardId, (0, $cjoN4.transformSwimlaneModeToApi)(swimlaneStrategy)).catch((error)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('board.user.swimlane.strategy.mutate.graphql.failure', 'Failed to mutate user swimlane strategy via GraphQL');
        return (0, $kVLXA.Observable).throw(error);
    });
}

});
parcelRegister("jVaxm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f2d44a0443e31c43$export$2e2bcd8739ae039);

var $6iJbJ = parcelRequire("6iJbJ");

var $CFxE9 = parcelRequire("CFxE9");
const $f2d44a0443e31c43$export$fb8289a9b8ee99a3 = 'SetUserSwimlaneStrategy';
const $f2d44a0443e31c43$export$192cb43903d0219e = `mutation ${$f2d44a0443e31c43$export$fb8289a9b8ee99a3} ($boardId: ID!, $strategy: SwimlaneStrategy!) {
    setUserSwimlaneStrategy(input: {boardId: $boardId, strategy: $strategy}) {
        statusCode
        strategy
        message
    }
}`;
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f2d44a0443e31c43$export$2e2bcd8739ae039 = (contextPath, boardId, swimlaneStrategy)=>{
    const transformedSwimlaneStrategyForMutation = swimlaneStrategy.toUpperCase();
    return (0, $6iJbJ.mutation$)(contextPath, $f2d44a0443e31c43$export$fb8289a9b8ee99a3, $f2d44a0443e31c43$export$192cb43903d0219e, {
        boardId: boardId,
        strategy: transformedSwimlaneStrategyForMutation
    }, (0, $CFxE9.setUserSwimlaneAnalyticsOptions));
};

});



parcelRegister("deevq", function(module, exports) {

$parcel$export(module.exports, "versionGetEpic", () => $fc3f54ec18d59e66$export$dc3a899b72eaca08);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $2YZCu = parcelRequire("2YZCu");

var $hdmw1 = parcelRequire("hdmw1");

var $71cRN = parcelRequire("71cRN");

var $65C0W = parcelRequire("65C0W");

var $j00DX = parcelRequire("j00DX");
const $fc3f54ec18d59e66$export$dc3a899b72eaca08 = (action$, store)=>action$.ofType((0, $j00DX.FETCH_VERSION_DATA), (0, $65C0W.SOFTWARE_APP_LOADED), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).switchMap(()=>{
        const ctx = (0, $hdmw1.makeServiceContext)(store.getState());
        if (!ctx.isCMPBoard) return (0, $kVLXA.Observable).of();
        return (0, $71cRN.fetchVersionDataService)(ctx).mergeMap((versionResponse)=>(0, $kVLXA.Observable).of((0, $j00DX.setVersionData)(versionResponse))).catch((error)=>{
            (0, $2YZCu.default).safeErrorWithoutCustomerData('board.version.load.failure', 'Failure on version data load', error);
            return (0, $kVLXA.Observable).of();
        });
    });

});
parcelRegister("71cRN", function(module, exports) {

$parcel$export(module.exports, "fetchVersionDataService", () => $25180b01382befb7$export$367efd4995472a7);

var $cXzOE = parcelRequire("cXzOE");
const $25180b01382befb7$export$367efd4995472a7 = (ctx)=>(0, $cXzOE.fetchVersionDataRest)(ctx.boardId).map((response)=>response.versionData);

});
parcelRegister("cXzOE", function(module, exports) {

$parcel$export(module.exports, "fetchVersionDataRest", () => $bf1e80b0da2c3f61$export$3d5af46d1a00703d);

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");
const $bf1e80b0da2c3f61$export$3d5af46d1a00703d = (boardId)=>(0, $487fd.default)((0, $2bQEl.getVersionUrl)(boardId));

});


parcelRegister("j00DX", function(module, exports) {

$parcel$export(module.exports, "FETCH_VERSION_DATA", () => $8e4f38cd90396a7f$export$eb55b6af2b295f7f);
$parcel$export(module.exports, "SET_VERSION_DATA", () => $8e4f38cd90396a7f$export$19e17d103ff6d4c6);
$parcel$export(module.exports, "setVersionData", () => $8e4f38cd90396a7f$export$2e9c1519373ac155);
const $8e4f38cd90396a7f$export$eb55b6af2b295f7f = 'state.actions.version.FETCH_VERSION_DATA';
const $8e4f38cd90396a7f$export$52600acdc8e4fd18 = ()=>({
        type: $8e4f38cd90396a7f$export$eb55b6af2b295f7f
    });
const $8e4f38cd90396a7f$export$19e17d103ff6d4c6 = 'state.actions.version.SET_VERSION_DATA';
const $8e4f38cd90396a7f$export$2e9c1519373ac155 = (payload)=>({
        type: $8e4f38cd90396a7f$export$19e17d103ff6d4c6,
        payload: payload
    });

});


parcelRegister("iAr3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $1446920092f2369d$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6hSeW");
parcelRequire("fPS7b");
parcelRequire("6cbqE");

var $jcw0u = parcelRequire("jcw0u");

var $487fd = parcelRequire("487fd");

var $2bQEl = parcelRequire("2bQEl");

var $lF9PL = parcelRequire("lF9PL");

var $hoX5N = parcelRequire("hoX5N");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");
const $1446920092f2369d$var$workGetCurrentUserEpic = (action$, store)=>action$.ofType((0, $cW3pH.WORK_REFRESH_DATA), (0, $65C0W.SOFTWARE_APP_LOADED), (0, $65C0W.SOFTWARE_APP_INITIAL_STATE_LOADED)).switchMap(()=>{
        const state = store.getState();
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const currentUserAccountId = (0, $67Z81.currentUserAccountIdSelector)(state);
        const people = (0, $36pz7.getPeople)(state);
        if (people[currentUserAccountId]) return (0, $kVLXA.Observable).empty();
        return (0, $487fd.default)((0, $2bQEl.getCurrentUserDataFromAccountIdUrl)(contextPath, currentUserAccountId)).flatMap((response)=>(0, $kVLXA.Observable).of((0, $hoX5N.setPerson)({
                ...(0, $lF9PL.transformPerson)(response)
            }))).catch((error)=>{
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'board.getCurrentUser.failure',
                    packageName: 'jiraSoftwareBoard',
                    teamName: 'a4t-tanuki'
                }
            });
            return (0, $kVLXA.Observable).empty();
        });
    });
var $1446920092f2369d$export$2e2bcd8739ae039 = $1446920092f2369d$var$workGetCurrentUserEpic;

});
parcelRegister("hoX5N", function(module, exports) {

$parcel$export(module.exports, "PERSON_SET", () => $a6b6d53e57e67328$export$5ea066dfbb9cdc4d);
$parcel$export(module.exports, "setPerson", () => $a6b6d53e57e67328$export$89eefa97e3be5ee3);
const $a6b6d53e57e67328$export$5ea066dfbb9cdc4d = 'state.actions.people.PERSON_SET';
const $a6b6d53e57e67328$export$89eefa97e3be5ee3 = (person)=>({
        type: $a6b6d53e57e67328$export$5ea066dfbb9cdc4d,
        payload: person
    });

});


parcelRegister("kmCzR", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3324163fd5cdf9f$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("2JdQp");
parcelRequire("huL2s");
parcelRequire("3awJm");
parcelRequire("iQCJJ");
parcelRequire("ihPQR");
parcelRequire("1oQta");
parcelRequire("kxK5F");
parcelRequire("eSGL3");
parcelRequire("6cbqE");

var $gSIcW = parcelRequire("gSIcW");



var $cW3pH = parcelRequire("cW3pH");

var $k8auG = parcelRequire("k8auG");

var $5mTgl = parcelRequire("5mTgl");
/**
 * Start with marker, so that we guarantee there are no
 * polls or visibility changed refresh actions emitted
 * without throttling.
 */ const $d3324163fd5cdf9f$var$STREAM_START_MARKER = Symbol('STREAM_START_MARKER');
// This stream controls whether the board will poll the server for data.
// The stream will create BOARD_GET_DATA actions:
// 1. On start up to populate the board with initial data.
const $d3324163fd5cdf9f$var$workRefreshDataEpic = (scheduler, debounceScheduler)=>(action$, store)=>{
        const refresh$ = (0, $gSIcW.default)().distinctUntilChanged().debounceTime(500, debounceScheduler) // prevent multiple requests when ppl play around the tabs
        .switchMap((shouldPoll, idx)=>{
            if (!shouldPoll) return (0, $kVLXA.Observable).never();
            const refreshStream = (0, $kVLXA.Observable).interval((0, $7e733a5d4e4331fc$export$70f4a301e337eb0b), scheduler).mapTo((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$8125ab02c04ac8e7))).filter(()=>!(0, $5mTgl.hasAnyActiveOptimistic)(store.getState())).filter(()=>(0, $k8auG.isPollingEnabled)(store.getState()));
            if (idx === 0) return refreshStream.startWith($d3324163fd5cdf9f$var$STREAM_START_MARKER);
            return refreshStream.startWith((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$725480b44dc3539d)));
        });
        return refresh$.throttleTime((0, $7e733a5d4e4331fc$export$70f4a301e337eb0b), scheduler).filter((action)=>action !== $d3324163fd5cdf9f$var$STREAM_START_MARKER);
    };
var $d3324163fd5cdf9f$export$2e2bcd8739ae039 = $d3324163fd5cdf9f$var$workRefreshDataEpic;

});

parcelRegister("hnFh8", function(module, exports) {

$parcel$export(module.exports, "filterUpdateFieldValuesEpicOld", () => $f434bca185ef2dc8$export$e0ae41c261da5d88);
$parcel$export(module.exports, "filterUpdateFieldValuesEpic", () => $f434bca185ef2dc8$export$a5e6958c4e7d3e1f);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("6cbqE");
parcelRequire("fPS7b");
parcelRequire("c66Ur");
parcelRequire("eSGL3");

var $4cJXk = parcelRequire("4cJXk");

var $5tEcX = parcelRequire("5tEcX");

var $jEfnV = parcelRequire("jEfnV");

var $dnW4F = parcelRequire("dnW4F");

var $6c7Tw = parcelRequire("6c7Tw");


var $5Ia1y = parcelRequire("5Ia1y");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $f434bca185ef2dc8$var$handleFilterFieldValuesUpdate = (action, store)=>{
    const state = store.getState();
    const cloudId = (0, $67Z81.cloudIdSelector)(state);
    const projectKey = (0, $67Z81.projectKeySelector)(state);
    const filterRefinementEnabled = (0, $5mTgl.isFilterRefinementEnabled)(state);
    if (filterRefinementEnabled && (action.type === (0, $dnW4F.SET_ALL_FILTERS) && action.meta.filterType === (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f) || action.type === (0, $dnW4F.FILTERS_SET) && action.payload.filterType === (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f))) {
        const jql = action.type === (0, $dnW4F.SET_ALL_FILTERS) ? action.payload.filters[0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f] : action.payload.values;
        if (jql && jql.length > 0) return (0, $5Ia1y.fetchFieldValues)({
            cloudId: cloudId,
            jql: `project = ${projectKey} and ${jql}`
        }).mergeMap((response)=>(0, $kVLXA.Observable).of((0, $dnW4F.setFiltersFromJql)(response)));
    }
    return (0, $kVLXA.Observable).of();
};
const $f434bca185ef2dc8$export$e0ae41c261da5d88 = (action$, store)=>action$.ofType((0, $dnW4F.SET_ALL_FILTERS), (0, $dnW4F.FILTERS_SET)).debounceTime((0, $6c7Tw.getCustomFiltersDebounceTime)()).switchMap((action)=>$f434bca185ef2dc8$var$handleFilterFieldValuesUpdate(action, store));
const $f434bca185ef2dc8$export$a5e6958c4e7d3e1f = (action$, store)=>action$.pipe((0, $4cJXk.filter)((action)=>action.type === (0, $dnW4F.SET_ALL_FILTERS) && action.meta.filterType === (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f) || action.type === (0, $dnW4F.FILTERS_SET) && action.payload.filterType === (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)), (0, $5tEcX.debounceTime)((0, $6c7Tw.getCustomFiltersDebounceTime)()), (0, $jEfnV.switchMap)((action)=>$f434bca185ef2dc8$var$handleFilterFieldValuesUpdate(action, store)));

});
parcelRegister("5Ia1y", function(module, exports) {

$parcel$export(module.exports, "fetchFieldValues", () => $6bf0396e6132855d$export$bbe5800608fab068);

var $8PDh9 = parcelRequire("8PDh9");
const $6bf0396e6132855d$export$bbe5800608fab068 = ({ cloudId: cloudId, jql: jql })=>(0, $8PDh9.hydrateJqlBuilderQuery)({
        cloudId: cloudId,
        jql: jql
    });

});
parcelRegister("8PDh9", function(module, exports) {

$parcel$export(module.exports, "hydrateJqlBuilderQuery", () => $2f8ba20a2bebca45$export$589639c077b1eca6);

var $bEpXV = parcelRequire("bEpXV");

var $8Uumt = parcelRequire("8Uumt");

var $kVLXA = parcelRequire("kVLXA");

var $jcw0u = parcelRequire("jcw0u");

var $5yJb9 = parcelRequire("5yJb9");


var $3a7pU = parcelRequire("3a7pU");
parcelRequire("3q49N");
const $2f8ba20a2bebca45$export$3361e9be8093ddcc = (response, jql)=>{
    const fields = response?.jira?.jqlBuilder?.hydrateJqlQuery?.fields;
    // clear stored filters with creating an empty map
    const hydratedValues = {
        [(0, $dcff40112356dfc1$export$d597759d33be802e)]: '',
        [(0, $dcff40112356dfc1$export$f8f7545d2bb78afb)]: [],
        [(0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)]: [],
        [(0, $dcff40112356dfc1$export$a316570a0dbfd2b0)]: [],
        [(0, $dcff40112356dfc1$export$ebb48b08205007c5)]: [],
        [(0, $dcff40112356dfc1$export$2a4f270075a033de)]: [],
        [(0, $dcff40112356dfc1$export$a4ad2735b021c132)]: []
    };
    fields && fields.forEach((hydratedField)=>{
        if (!hydratedField) return;
        const { field: field, values: values } = hydratedField;
        if (!field || !values) return;
        const fieldTypeName = (0, $3a7pU.getFieldTypeName)(field.type);
        if (fieldTypeName == null) return;
        hydratedValues[fieldTypeName] = values.map((item)=>(item && item.values && item.values[0]) ?? null).filter(Boolean).map((item)=>(0, $3a7pU.getFieldId)(item, field.type));
    });
    if (hydratedValues[0, $dcff40112356dfc1$export$d597759d33be802e] && typeof hydratedValues[0, $dcff40112356dfc1$export$d597759d33be802e] === 'object') // only use text not array
    // @ts-expect-error missing type for text
    hydratedValues[0, $dcff40112356dfc1$export$d597759d33be802e] = hydratedValues[0, $dcff40112356dfc1$export$d597759d33be802e][0];
    // we can't use hydratedResponse because it does not return an empty object for 'empty' assignee
    const assignees = (0, $3a7pU.getSelectedFieldValues)(jql, 'assignee').map((name)=>name === 'empty' ? 'unassigned' : name);
    if (assignees.length > 0) hydratedValues[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] = assignees;
    return hydratedValues;
};
const $2f8ba20a2bebca45$export$589639c077b1eca6 = ({ cloudId: cloudId, jql: jql })=>(0, $kVLXA.Observable).fromPromise((0, $8Uumt.fetchQuery)((0, $5yJb9.default)(), /* eslint-disable @atlassian/relay/unused-fields */ (0, $bEpXV.default), {
        cloudId: cloudId,
        jql: jql
    }).toPromise().then((response)=>$2f8ba20a2bebca45$export$3361e9be8093ddcc(response, jql)).catch((error)=>{
        (0, $jcw0u.default)({
            meta: {
                id: 'HydrateJqlQuery',
                packageName: 'jiraSoftwareBoards',
                teamName: 'A4T-Tanuki'
            },
            error: error
        });
        throw error;
    }));

});
parcelRegister("bEpXV", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c049e0258e182dc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a9ccfec6988f79abe5e58838fee25119>>
 * @relayHash 1df190b3de2cd775733c9f02ce9d4bce
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9f7933cf223046e0e75ddad0db0ddea25aecf83e31b6dfa9b2709b73e8b3907c
const $7c049e0258e182dc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jql"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = [
        {
            "kind": "Variable",
            "name": "query",
            "variableName": "jql"
        }
    ], v3 = {
        "kind": "ScalarField",
        "name": "jqlTerm"
    }, v4 = {
        "kind": "ScalarField",
        "name": "displayName"
    }, v5 = {
        "concreteType": "JiraJqlField",
        "kind": "LinkedField",
        "name": "field",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            v4 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "fieldId"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            }
        ]
    }, v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v9 = {
        "kind": "ScalarField",
        "name": "sprintId"
    }, v10 = {
        "kind": "ScalarField",
        "name": "versionId"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "hydrateJqlQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v4 /*: any*/ ,
                                                                                        v3 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "sprint",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlSprintFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "version",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlVersionFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "hydrateJqlQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": v2 /*: any*/ ,
                                    "kind": "LinkedField",
                                    "name": "hydrateJqlQuery",
                                    "plural": false,
                                    "selections": [
                                        v6 /*: any*/ ,
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "fields",
                                                    "plural": true,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                v5 /*: any*/ ,
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "values",
                                                                    "plural": true,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "InlineFragment",
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "LinkedField",
                                                                                    "name": "values",
                                                                                    "plural": true,
                                                                                    "selections": [
                                                                                        v4 /*: any*/ ,
                                                                                        v3 /*: any*/ ,
                                                                                        v6 /*: any*/ ,
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssue",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issue",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v7 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraIssueType",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "issueTypes",
                                                                                                    "plural": true,
                                                                                                    "selections": [
                                                                                                        v8 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlIssueTypeFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraSprint",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "sprint",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v9 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlSprintFieldValue"
                                                                                        },
                                                                                        {
                                                                                            "kind": "InlineFragment",
                                                                                            "selections": [
                                                                                                {
                                                                                                    "concreteType": "JiraVersion",
                                                                                                    "kind": "LinkedField",
                                                                                                    "name": "version",
                                                                                                    "plural": false,
                                                                                                    "selections": [
                                                                                                        v10 /*: any*/ ,
                                                                                                        v11 /*: any*/ 
                                                                                                    ]
                                                                                                }
                                                                                            ],
                                                                                            "type": "JiraJqlVersionFieldValue"
                                                                                        }
                                                                                    ]
                                                                                }
                                                                            ],
                                                                            "type": "JiraJqlQueryHydratedValue"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlQueryHydratedField"
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlHydratedQuery"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "9f7933cf223046e0e75ddad0db0ddea25aecf83e31b6dfa9b2709b73e8b3907c",
            "metadata": {},
            "name": "hydrateJqlQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$7c049e0258e182dc$var$node.hash = "e0ea44cfdbf7f7f2b9f2cd672a8eee79";
var $7c049e0258e182dc$export$2e2bcd8739ae039 = $7c049e0258e182dc$var$node;

});

parcelRegister("3a7pU", function(module, exports) {

$parcel$export(module.exports, "getSelectedFieldValues", () => $a060958838aeff4b$export$13e554d2722c452d);
$parcel$export(module.exports, "getFieldTypeName", () => $a060958838aeff4b$export$cb21d82ee7d6ce78);
$parcel$export(module.exports, "getFieldId", () => $a060958838aeff4b$export$f4457e83c74ac000);

var $eK6AG = parcelRequire("eK6AG");

var $hZ2JJ = parcelRequire("hZ2JJ");

var $3gmJB = parcelRequire("3gmJB");

const $a060958838aeff4b$var$SPRINT_TYPE = 'com.pyxis.greenhopper.jira:gh-sprint';
const $a060958838aeff4b$var$getClauseMap = (jql)=>{
    const ast = new (0, $eK6AG.JastBuilder)().build(jql);
    let clauseMap = {};
    if (ast.query) ({ clauseMap: clauseMap } = new (0, $3gmJB.JqlClauseCollectingVisitor)(jql).visit(ast.query));
    else throw new Error();
    return clauseMap;
};
const $a060958838aeff4b$export$13e554d2722c452d = (jql, fieldName)=>{
    const clauses = $a060958838aeff4b$var$getClauseMap(jql);
    return (0, $hZ2JJ.getSelectedValuesForField)(clauses[fieldName], fieldName, jql);
};
const $a060958838aeff4b$export$cb21d82ee7d6ce78 = (fieldType)=>{
    switch(fieldType){
        case $a060958838aeff4b$var$SPRINT_TYPE:
            return 0, $dcff40112356dfc1$export$a316570a0dbfd2b0;
        case 'issuetype':
            return 0, $dcff40112356dfc1$export$ebb48b08205007c5;
        case 'parent':
            return 0, $dcff40112356dfc1$export$2a4f270075a033de;
        case 'text':
            return 0, $dcff40112356dfc1$export$d597759d33be802e;
        case 'labels':
            return 0, $dcff40112356dfc1$export$37aee82a3cb1e8f7;
        case 'fixVersions':
            return 0, $dcff40112356dfc1$export$a4ad2735b021c132;
        default:
            return null;
    }
};
const $a060958838aeff4b$export$f4457e83c74ac000 = (item, fieldType)=>{
    switch(fieldType){
        case $a060958838aeff4b$var$SPRINT_TYPE:
            return 'sprint' in item && item.sprint.sprintId;
        case 'issuetype':
            return 'issueTypes' in item && item.issueTypes[0].issueTypeId;
        case 'parent':
            return 'issue' in item && item.issue?.issueId;
        case 'fixVersions':
            return 'version' in item && item.version.versionId;
        case 'text':
            return 'displayName' in item && item.displayName?.replace(/\*/g, '').trim();
        case 'labels':
            return 'jqlTerm' in item && item.jqlTerm;
        default:
            return item;
    }
};

});
parcelRegister("hZ2JJ", function(module, exports) {

$parcel$export(module.exports, "getSelectedValuesForField", () => $f920bbdea936446c$export$fe49a65c8a85d36a);
$parcel$export(module.exports, "useSelectedValues", () => $f920bbdea936446c$export$e10928cdf9450649);
$parcel$export(module.exports, "useNumberOfSelectedValues", () => $f920bbdea936446c$export$112a146b7cdf1f28);

var $5uXOq = parcelRequire("5uXOq");

var $dDkmN = parcelRequire("dDkmN");


var $4R6GH = parcelRequire("4R6GH");

var $hOHOl = parcelRequire("hOHOl");

var $8zf6J = parcelRequire("8zf6J");

var $lPhuO = parcelRequire("lPhuO");
const $f920bbdea936446c$var$getOperands = (clauseName, operand, jql)=>{
    switch(operand?.operandType){
        case 0, $49b29ef7baa2a152$export$f6049126fd97001f:
        case 0, $49b29ef7baa2a152$export$38accfc5a5d1c113:
            return [
                operand.value
            ];
        case 0, $49b29ef7baa2a152$export$fabec4aebba3f4df:
            return (0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))(...operand.values.map((operandValue)=>$f920bbdea936446c$var$getOperands(clauseName, operandValue, jql)));
        default:
            if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(jql, `Unsupported operand type (${operand?.operandType}) for ${clauseName}`);
            else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)(`Unsupported operand type (${operand?.operandType}) for ${clauseName}`);
    }
};
const $f920bbdea936446c$export$fe49a65c8a85d36a = (clauses, clauseName, jql)=>{
    if (!clauses || clauses.length === 0) return [];
    if (clauses.length > 1) {
        if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(jql, `Too many clauses for ${clauseName}`);
        else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)(`Too many clauses for ${clauseName}`);
    }
    const [clause] = clauses;
    if (clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) {
        if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(jql, `Unsupported clause type (${clause.clauseType}) for ${clauseName}`);
        else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)(`Unsupported clause type (${clause.clauseType}) for ${clauseName}`);
    }
    const { operand: operand } = clause;
    if (!operand) {
        if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(jql, `No operand for ${clauseName}`);
        else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)(`No operand for ${clauseName}`);
    }
    return $f920bbdea936446c$var$getOperands(clauseName, operand, jql);
};
const $f920bbdea936446c$export$e10928cdf9450649 = (clauseName)=>{
    const clauseMap = (0, $hOHOl.useClauseMap)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const jql = (0, $4R6GH.fg)('filter_refinement_error_logging') ? (0, $hOHOl.useJQL)() : '';
    const clauses = clauseMap[clauseName.toLowerCase()];
    return (0, $5uXOq.useMemo)(()=>{
        return $f920bbdea936446c$export$fe49a65c8a85d36a(clauses, clauseName, jql);
    }, [
        clauses,
        clauseName,
        jql
    ]);
};
const $f920bbdea936446c$export$112a146b7cdf1f28 = ()=>{
    const clauseMap = (0, $hOHOl.useClauseMap)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const jql = (0, $4R6GH.fg)('filter_refinement_error_logging') ? (0, $hOHOl.useJQL)() : '';
    return (0, $5uXOq.useMemo)(()=>{
        let numberOfSelectedValues = 0;
        const clauseName = Object.keys(clauseMap);
        clauseName.forEach((name)=>{
            const clauses = clauseMap[name];
            const fieldValues = $f920bbdea936446c$export$fe49a65c8a85d36a(clauses, name, jql);
            numberOfSelectedValues += fieldValues.length;
        });
        return numberOfSelectedValues;
    }, [
        clauseMap,
        jql
    ]);
};

});
const $e9a0ef16a223cbc7$export$7a58b23488ea076b = 'compound';
const $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a = 'terminal';
const $e9a0ef16a223cbc7$export$e356b89f8c8d2fcb = 'not';

parcelRegister("hOHOl", function(module, exports) {

$parcel$export(module.exports, "AstContainer", () => $818db402308c9db3$export$dcfee42898727fa1);
$parcel$export(module.exports, "useASTActions", () => $818db402308c9db3$export$7dd76c55b7b9f711);
$parcel$export(module.exports, "useAST", () => $818db402308c9db3$export$2d94ebd7e6bbb03c);
$parcel$export(module.exports, "useJQL", () => $818db402308c9db3$export$91ca6f3fe5087246);
$parcel$export(module.exports, "useClauseMap", () => $818db402308c9db3$export$32019dca04f1bace);
$parcel$export(module.exports, "useTextSearchInputClause", () => $818db402308c9db3$export$53c45c55dec81810);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $b9LTS = parcelRequire("b9LTS");
const $818db402308c9db3$var$initialState = {
    ast: {
        query: undefined,
        represents: '',
        errors: []
    },
    clauseMap: {},
    jql: '',
    textSearchInputClause: undefined
};
const $818db402308c9db3$export$dcfee42898727fa1 = (0, $gg7kZ.createContainer)();
const $818db402308c9db3$var$Store = (0, $iXqE5.createStore)({
    containedBy: $818db402308c9db3$export$dcfee42898727fa1,
    initialState: $818db402308c9db3$var$initialState,
    actions: {
        updateJql: ({ jql: jql, fieldType: fieldType, amountOfSelectedOptionsOfFieldType: amountOfSelectedOptionsOfFieldType })=>({ setState: setState }, { onJqlChange: onJqlChange })=>{
                const updatedResult = (0, $b9LTS.getStateFromJQL)(jql);
                setState(updatedResult);
                onJqlChange && onJqlChange(jql, fieldType, amountOfSelectedOptionsOfFieldType);
            }
    },
    handlers: {
        onInit: ()=>({ setState: setState }, { defaultJql: defaultJql })=>{
                setState((0, $b9LTS.getStateFromJQL)(defaultJql));
            },
        onContainerUpdate: (nextProps, prevProps)=>({ setState: setState })=>{
                if (nextProps.defaultJql !== prevProps.defaultJql) setState((0, $b9LTS.getStateFromJQL)(nextProps.defaultJql));
            }
    },
    name: 'jira-filter-refinement-ast'
});
const $818db402308c9db3$export$7dd76c55b7b9f711 = (0, $3sQ5x.createActionsHook)($818db402308c9db3$var$Store);
const $818db402308c9db3$export$2d94ebd7e6bbb03c = (0, $3sQ5x.createStateHook)($818db402308c9db3$var$Store, {
    selector: ({ ast: ast })=>ast
});
const $818db402308c9db3$export$91ca6f3fe5087246 = (0, $3sQ5x.createStateHook)($818db402308c9db3$var$Store, {
    selector: ({ jql: jql })=>jql
});
const $818db402308c9db3$export$32019dca04f1bace = (0, $3sQ5x.createStateHook)($818db402308c9db3$var$Store, {
    selector: ({ clauseMap: clauseMap })=>clauseMap
});
const $818db402308c9db3$export$53c45c55dec81810 = (0, $3sQ5x.createStateHook)($818db402308c9db3$var$Store, {
    selector: ({ textSearchInputClause: textSearchInputClause })=>textSearchInputClause
});

});
parcelRegister("b9LTS", function(module, exports) {

$parcel$export(module.exports, "getStateFromJQL", () => $f008d5c491e1bf43$export$de14f4893f7a5441);

var $eK6AG = parcelRequire("eK6AG");

var $3gmJB = parcelRequire("3gmJB");
const $f008d5c491e1bf43$export$de14f4893f7a5441 = (jql)=>{
    const ast = new (0, $eK6AG.JastBuilder)().build(jql);
    let clauseMap = {};
    let textSearchInputClause;
    if (ast.query) ({ clauseMap: clauseMap, textSearchInputClause: textSearchInputClause } = new (0, $3gmJB.JqlClauseCollectingVisitor)(jql).visit(ast.query));
    else throw new Error();
    return {
        ast: ast,
        clauseMap: clauseMap,
        jql: jql,
        textSearchInputClause: textSearchInputClause
    };
};

});
parcelRegister("3gmJB", function(module, exports) {

$parcel$export(module.exports, "JqlClauseCollectingVisitor", () => $a7b8c31801aad442$export$566c7abb4018442d);

var $3dHKF = parcelRequire("3dHKF");

var $bv7J5 = parcelRequire("bv7J5");
var $bzbto = parcelRequire("bzbto");

var $4R6GH = parcelRequire("4R6GH");


var $8zf6J = parcelRequire("8zf6J");

var $lPhuO = parcelRequire("lPhuO");
class $a7b8c31801aad442$export$566c7abb4018442d extends (0, $bv7J5.AbstractJastVisitor) {
    constructor(jql){
        super(), this.visitCompoundClause = (compoundClause)=>{
            const operator = compoundClause.operator.value;
            if (operator === (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97)) return compoundClause.clauses.reduce((result, clause)=>this.aggregateResult(clause.accept(this), result), {
                clauseMap: {}
            });
            if (operator === (0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753)) // The only supported OR clause is for the text search refinement. Downstream validators are responsible for
            // checking if the compound clause is valid for text search.
            // If future refinements emerge that also use OR clauses then this logic would need to change to perform some
            // type of shape matching against the clause to find the correct refinement key.
            return {
                clauseMap: {},
                textSearchInputClause: compoundClause
            };
            if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(this.jql, `Unsupported operator '${operator}' in compound clause`);
            else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)(`Unsupported operator '${operator}' in compound clause`);
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            if (fieldName === (0, $c2106d117ddd8c57$export$b2dcd38723ba8c75)) return {
                clauseMap: {},
                textSearchInputClause: terminalClause
            };
            if (terminalClause.operator?.value !== (0, $bzbto.OPERATOR_EQUALS) && terminalClause.operator?.value !== (0, $bzbto.OPERATOR_IN)) {
                if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(this.jql, `Unsupported operator '${terminalClause.operator}' in terminal clause`);
                else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)(`Unsupported operator '${terminalClause.operator}' in terminal clause`);
            }
            return {
                clauseMap: {
                    [terminalClause.field.value.toLowerCase()]: [
                        terminalClause
                    ]
                }
            };
        };
        if ((0, $4R6GH.fg)('filter_refinement_error_logging')) this.jql = jql;
    }
    visitNotClause() {
        if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(this.jql, 'Unsupported NOT clause');
        else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)('Unsupported NOT clause');
    }
    defaultResult() {
        return {
            clauseMap: {}
        };
    }
    /**
	 * @param aggregate new ClauseMap to add into nextResult
	 * @param nextResult ClauseMap with previous results
	 * @returns ClauseMap with the merged results adding the aggregate at the end
	 */ aggregateResult(aggregate, nextResult) {
        if (nextResult.textSearchInputClause && aggregate.textSearchInputClause) {
            if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(this.jql, 'Too many text search input clauses');
            else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)('Too many text search input clauses');
        }
        // First parameter is the object where we want to add the values and the second the new values to merge into the first object.
        return {
            clauseMap: (0, (/*@__PURE__*/$parcel$interopDefault($3dHKF)))(nextResult.clauseMap, aggregate.clauseMap, (destValue, srcValue)=>srcValue.concat(destValue ?? [])),
            textSearchInputClause: aggregate.textSearchInputClause === undefined ? nextResult.textSearchInputClause : aggregate.textSearchInputClause
        };
    }
}

});
const $3cef51f82b2cbe1d$export$6d6d48d210d3ca97 = 'and';
const $3cef51f82b2cbe1d$export$7b8f0a728d79a753 = 'or';

const $c2106d117ddd8c57$export$b8b9d90f9e5bd72b = 'jiraFilterRefinement';
const $c2106d117ddd8c57$export$d57b6b390e78d90f = 'empanada';
const $c2106d117ddd8c57$export$a3821bc63538b210 = 'filterRefinement';
const $c2106d117ddd8c57$export$f8f7545d2bb78afb = 'assignee';
const $c2106d117ddd8c57$export$5daa28d10e23592 = 'issuekey';
const $c2106d117ddd8c57$export$b2dcd38723ba8c75 = 'textfields';

parcelRegister("8zf6J", function(module, exports) {

$parcel$export(module.exports, "UnsupportedRefinementError", () => $0ca4d0993476bb66$export$251a1c8599975384);

var $eK6AG = parcelRequire("eK6AG");
var $fhHBZ = parcelRequire("fhHBZ");
class $0ca4d0993476bb66$export$251a1c8599975384 extends Error {
    constructor(jql, message){
        super(message);
        if (jql) this.jql = new (0, $eK6AG.JastBuilder)().build(jql).query?.accept(new (0, $fhHBZ.JqlAnonymizerVisitor)());
    }
}

});

parcelRegister("lPhuO", function(module, exports) {

$parcel$export(module.exports, "UnsupportedRefinementErrorOld", () => $abdd5db711ed771b$export$c52151ef6813d367);
/**
 * This represents an error when trying to map a JQL AST to a collection of refinements supported by the component.
 * If the AST contains syntax or fields not supported by the filter refinement then this error will be thrown.
 */ class $abdd5db711ed771b$export$c52151ef6813d367 extends Error {
}

});









parcelRegister("5ThEt", function(module, exports) {

$parcel$export(module.exports, "default", () => $57655f61a591479f$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("c66Ur");
parcelRequire("fPS7b");

var $gI62y = parcelRequire("gI62y");

var $8WBJ8 = parcelRequire("8WBJ8");

var $9da86 = parcelRequire("9da86");
const $57655f61a591479f$var$archiveIssueObservable = (issueKey)=>{
    return (0, $gI62y.from)((0, $8WBJ8.archiveIssue)(issueKey));
};
const $57655f61a591479f$var$cardArchiveEpic = (action$)=>action$.ofType((0, $9da86.ISSUE_ARCHIVE_REQUEST)).mergeMap((action)=>{
        const { payload: { issue: issue, onArchivalSuccess: onArchivalSuccess, onArchivalFailure: onArchivalFailure }, meta: { optimistic: { id: optimisticId } } } = action;
        return $57655f61a591479f$var$archiveIssueObservable(issue.key).mergeMap(()=>{
            onArchivalSuccess(issue.key);
            return (0, $kVLXA.Observable).of((0, $9da86.issueArchiveSuccess)(optimisticId, issue.id));
        }).catch(()=>{
            onArchivalFailure(issue.key, issue.typeName);
            return (0, $kVLXA.Observable).of((0, $9da86.issueArchiveFailure)(optimisticId, issue.id));
        });
    });
var $57655f61a591479f$export$2e2bcd8739ae039 = $57655f61a591479f$var$cardArchiveEpic;

});
parcelRegister("8WBJ8", function(module, exports) {

$parcel$export(module.exports, "archiveIssue", () => $54539fb566615b96$export$b866145c825403dc);

var $eusud = parcelRequire("eusud");

var $5ING5 = parcelRequire("5ING5");
const $54539fb566615b96$export$b866145c825403dc = async (issueKey)=>{
    await (0, $eusud.performPutRequest)((0, $5ING5.ISSUE_ARCHIVE_API), {
        body: JSON.stringify({
            issueIdsOrKeys: [
                issueKey
            ]
        })
    });
};

});
parcelRegister("5ING5", function(module, exports) {

$parcel$export(module.exports, "ARCHIVE_ISSUE_MODAL_WIDTH_CATEGORY", () => $f2d76d919b5758cc$export$2ac06baa43be057);
$parcel$export(module.exports, "ESC_KEY", () => $f2d76d919b5758cc$export$45f4d5e73efcfde8);
$parcel$export(module.exports, "ISSUE_VIEW_URL_REGEX", () => $f2d76d919b5758cc$export$cbf34536d6076514);
$parcel$export(module.exports, "ISSUE_ARCHIVE_API", () => $f2d76d919b5758cc$export$1c9d135d7bb1047);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_VIEW", () => $f2d76d919b5758cc$export$501c618f5224bbb);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_ISSUE_NAVIGATOR", () => $f2d76d919b5758cc$export$f64573f447a64548);
$parcel$export(module.exports, "TRIGGER_POINT_KEY_BOARD_VIEW", () => $f2d76d919b5758cc$export$a1eb5fb00be2a7d1);
const $f2d76d919b5758cc$export$2ac06baa43be057 = 'small';
const $f2d76d919b5758cc$export$45f4d5e73efcfde8 = 'Escape';
const $f2d76d919b5758cc$export$cbf34536d6076514 = /.*\/browse\/[^/]+/;
const $f2d76d919b5758cc$export$1c9d135d7bb1047 = '/rest/api/2/issue/archive';
const $f2d76d919b5758cc$export$501c618f5224bbb = 'issue-view';
const $f2d76d919b5758cc$export$f64573f447a64548 = 'issue-navigator';
const $f2d76d919b5758cc$export$a1eb5fb00be2a7d1 = 'board-view';

});


parcelRegister("9da86", function(module, exports) {

$parcel$export(module.exports, "ISSUE_ARCHIVE_REQUEST", () => $71ee796b6e541062$export$c09fa3b49e6ff7f1);
$parcel$export(module.exports, "issueArchiveRequest", () => $71ee796b6e541062$export$e0274dfbf4927673);
$parcel$export(module.exports, "issueArchiveSuccess", () => $71ee796b6e541062$export$8129c1e73f858f2a);
$parcel$export(module.exports, "issueArchiveFailure", () => $71ee796b6e541062$export$8ad72b4e462e8f8c);

var $9rND4 = parcelRequire("9rND4");
const $71ee796b6e541062$export$c09fa3b49e6ff7f1 = 'state.actions.issue.archive.ISSUE_ARCHIVE_REQUEST';
const $71ee796b6e541062$export$e0274dfbf4927673 = (issue, childIssueIds, onArchivalSuccess, onArchivalFailure)=>({
        type: $71ee796b6e541062$export$c09fa3b49e6ff7f1,
        payload: {
            issue: issue,
            childIssueIds: childIssueIds,
            onArchivalSuccess: onArchivalSuccess,
            onArchivalFailure: onArchivalFailure
        },
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)()
        }
    });
const $71ee796b6e541062$export$13e1767ffef6b91a = 'state.actions.issue.archive.ISSUE_ARCHIVE_SUCCESS';
const $71ee796b6e541062$export$8129c1e73f858f2a = (optimisticId, issueId)=>({
        type: $71ee796b6e541062$export$13e1767ffef6b91a,
        payload: {
            issueId: issueId
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $71ee796b6e541062$export$4cd3e2b5d502b79b = 'state.actions.issue.archive.ISSUE_ARCHIVE_FAILURE';
const $71ee796b6e541062$export$8ad72b4e462e8f8c = (optimisticId, issueId)=>({
        type: $71ee796b6e541062$export$4cd3e2b5d502b79b,
        payload: {
            issueId: issueId
        },
        meta: (0, $9rND4.revertOptimisticUiMeta)(optimisticId)
    });

});


parcelRegister("dAcgL", function(module, exports) {

$parcel$export(module.exports, "boardUpdateOldDoneIssuesCutoffEpic", () => $30fdd2a0b3655138$export$4011eaf70bd32633);
parcelRequire("fg0YM");

var $jjMJk = parcelRequire("jjMJk");

var $aq199 = parcelRequire("aq199");

var $gI62y = parcelRequire("gI62y");

var $8zOmE = parcelRequire("8zOmE");

var $67Z81 = parcelRequire("67Z81");

var $bdfJC = parcelRequire("bdfJC");

var $cC1ol = parcelRequire("cC1ol");


var $cW3pH = parcelRequire("cW3pH");
const $30fdd2a0b3655138$export$4011eaf70bd32633 = (action$, store)=>action$.ofType((0, $bdfJC.UPDATE_OLD_DONE_ISSUES_CUTOFF)).concatMap((action)=>{
        const state = store.getState();
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const contextPath = (0, $67Z81.contextPathSelector)(state);
        const { payload: oldDoneIssuesCutoff, meta: { optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        return (0, $cC1ol.updateOldDoneIssuesCutoffService)(contextPath, boardId, oldDoneIssuesCutoff).pipe((0, $jjMJk.flatMap)(()=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'OldDoneIssuesCutoffUpdate Success', {
                boardId: boardId,
                oldDoneIssuesCutoff: oldDoneIssuesCutoff
            });
            return (0, $gI62y.from)([
                (0, $bdfJC.updateOldDoneIssuesCutoffRequestSuccess)(optimistic.id),
                (0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$243af246b0a1a89f))
            ]);
        }), (0, $jjMJk.catchError)((error)=>{
            if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'OldDoneIssuesCutoffUpdate Failed', {
                error: error,
                boardId: boardId,
                oldDoneIssuesCutoff: oldDoneIssuesCutoff
            });
            return (0, $aq199.of)((0, $bdfJC.updateOldDoneIssuesCutoffRequestFailure)(optimistic.id));
        }));
    });

});
parcelRegister("jjMJk", function(module, exports) {

$parcel$export(module.exports, "catchError", () => $e1059775f18d6292$export$3dede90624df3ba9, (v) => $e1059775f18d6292$export$3dede90624df3ba9 = v);
$parcel$export(module.exports, "mergeMap", () => $e1059775f18d6292$export$6b9f6c0d32c093f9, (v) => $e1059775f18d6292$export$6b9f6c0d32c093f9 = v);
$parcel$export(module.exports, "flatMap", () => $e1059775f18d6292$export$5b8affa63fc6df16, (v) => $e1059775f18d6292$export$5b8affa63fc6df16 = v);
$parcel$export(module.exports, "switchMap", () => $e1059775f18d6292$export$9f6ea8e48bc26eab, (v) => $e1059775f18d6292$export$9f6ea8e48bc26eab = v);
$parcel$export(module.exports, "throttleTime", () => $e1059775f18d6292$export$4efe28f192921dd4, (v) => $e1059775f18d6292$export$4efe28f192921dd4 = v);
var $e1059775f18d6292$export$d779b02e6b68c3e8;
var $e1059775f18d6292$export$719c70722b10e5ff;
var $e1059775f18d6292$export$ab1029bcae9ddb4a;
var $e1059775f18d6292$export$8916d2c8119541bb;
var $e1059775f18d6292$export$d6b40c95035461c7;
var $e1059775f18d6292$export$91115bdd8709945f;
var $e1059775f18d6292$export$9e55760d3282e08c;
var $e1059775f18d6292$export$3dede90624df3ba9;
var $e1059775f18d6292$export$29ae691b7de52fe3;
var $e1059775f18d6292$export$77fa7d86f5204e8a;
var $e1059775f18d6292$export$ee1b3e54f0441b22;
var $e1059775f18d6292$export$b314777ae20abca9;
var $e1059775f18d6292$export$c28c8388be0ab31a;
var $e1059775f18d6292$export$82fbd7a2841d2484;
var $e1059775f18d6292$export$85b9a36db797e02b;
var $e1059775f18d6292$export$61fc7d43ac8f84b0;
var $e1059775f18d6292$export$7843a4469d64c07e;
var $e1059775f18d6292$export$e4ca6d7b7a6dcf9b;
var $e1059775f18d6292$export$1391212d75b2ee65;
var $e1059775f18d6292$export$286ca829307725c9;
var $e1059775f18d6292$export$ab9a5985b741fa7a;
var $e1059775f18d6292$export$983a3b5fb2f7202e;
var $e1059775f18d6292$export$779c5fb865a0172e;
var $e1059775f18d6292$export$571da16e28367bde;
var $e1059775f18d6292$export$91d69c7761a17bbc;
var $e1059775f18d6292$export$7ecc1a3b11b57dab;
var $e1059775f18d6292$export$31039f1fbd797b9c;
var $e1059775f18d6292$export$d70d492cd31004c0;
var $e1059775f18d6292$export$9f77e0932fb78f72;
var $e1059775f18d6292$export$3dea766d36a8935f;
var $e1059775f18d6292$export$578723aef62d92f5;
var $e1059775f18d6292$export$71aa6c912b956294;
var $e1059775f18d6292$export$de3a4d4a0d731119;
var $e1059775f18d6292$export$43128fadae87b74a;
var $e1059775f18d6292$export$3f063810d7bf01bd;
var $e1059775f18d6292$export$6953b97c7d866605;
var $e1059775f18d6292$export$dd1bc94b04021eeb;
var $e1059775f18d6292$export$4c7897fafd92b108;
var $e1059775f18d6292$export$871de8747c9eaa88;
var $e1059775f18d6292$export$e0eaf3a86c03b2ad;
var $e1059775f18d6292$export$76dbd6ffd832405d;
var $e1059775f18d6292$export$8960430cfd85939f;
var $e1059775f18d6292$export$4950aa0f605343fb;
var $e1059775f18d6292$export$18aef43295bbe906;
var $e1059775f18d6292$export$6b9f6c0d32c093f9;
var $e1059775f18d6292$export$5b8affa63fc6df16;
var $e1059775f18d6292$export$bd7cfc9a42b8a412;
var $e1059775f18d6292$export$c1fc905202bced53;
var $e1059775f18d6292$export$96ec731ed4dcb222;
var $e1059775f18d6292$export$1364843af8d5a963;
var $e1059775f18d6292$export$9007f49c319d1ac7;
var $e1059775f18d6292$export$5fba66d61591f42;
var $e1059775f18d6292$export$8f9d79d42bff1aac;
var $e1059775f18d6292$export$b29f828819edca8d;
var $e1059775f18d6292$export$c44985b87d605eff;
var $e1059775f18d6292$export$89b472e03be495df;
var $e1059775f18d6292$export$16ae46fda9567053;
var $e1059775f18d6292$export$42d9b6b38c68d989;
var $e1059775f18d6292$export$1f3342bf81d92d52;
var $e1059775f18d6292$export$236c05de452bec2;
var $e1059775f18d6292$export$533b26079ad0b4b;
var $e1059775f18d6292$export$76d90c956114f2c2;
var $e1059775f18d6292$export$b39ac5b4ffd1415a;
var $e1059775f18d6292$export$9369b12211e1fce4;
var $e1059775f18d6292$export$1281551253cfee02;
var $e1059775f18d6292$export$18d0766d894cba0c;
var $e1059775f18d6292$export$4812e460280c6ef2;
var $e1059775f18d6292$export$fe33c7b2002d97b0;
var $e1059775f18d6292$export$c87d910e63d22ed6;
var $e1059775f18d6292$export$d0a07e60ae428313;
var $e1059775f18d6292$export$ed80d9de1d9df928;
var $e1059775f18d6292$export$db61d692014e534e;
var $e1059775f18d6292$export$863d7ca51b416cee;
var $e1059775f18d6292$export$955fc4a6c4be454d;
var $e1059775f18d6292$export$635f6273df29ea1c;
var $e1059775f18d6292$export$facc584867c26fde;
var $e1059775f18d6292$export$175dedd748069215;
var $e1059775f18d6292$export$a4fe86229b0e9bdd;
var $e1059775f18d6292$export$6a45284a4b0bf33a;
var $e1059775f18d6292$export$9f6ea8e48bc26eab;
var $e1059775f18d6292$export$a439dc30c845238;
var $e1059775f18d6292$export$b7df5d561049483a;
var $e1059775f18d6292$export$1b47ad771ce5af5e;
var $e1059775f18d6292$export$ac8dfd3a7ad06e80;
var $e1059775f18d6292$export$9384c7afe4015e42;
var $e1059775f18d6292$export$3f23594af5f37336;
var $e1059775f18d6292$export$de363e709c412c8a;
var $e1059775f18d6292$export$4efe28f192921dd4;
var $e1059775f18d6292$export$1a539c8b2950ab40;
var $e1059775f18d6292$export$83e74882c5df8fe1;
var $e1059775f18d6292$export$86fe999fba7953f2;
var $e1059775f18d6292$export$fc00ee57782020aa;
var $e1059775f18d6292$export$45b10814cc054894;
var $e1059775f18d6292$export$8291e5b88f90ce4;
var $e1059775f18d6292$export$f3a19e933f377396;
var $e1059775f18d6292$export$1284415effa79ee0;
var $e1059775f18d6292$export$3182be990e0eeaad;
var $e1059775f18d6292$export$6a5dea797879f644;
var $e1059775f18d6292$export$d449030e5c10edf7;
var $e1059775f18d6292$export$8901015135f2fb22;
var $e1059775f18d6292$export$adddb6a2fa3864e9;
"use strict";

var $eqNaQ = parcelRequire("eqNaQ");
$e1059775f18d6292$export$d779b02e6b68c3e8 = $eqNaQ.audit;

var $imTmw = parcelRequire("imTmw");
$e1059775f18d6292$export$719c70722b10e5ff = $imTmw.auditTime;

var $icZql = parcelRequire("icZql");
$e1059775f18d6292$export$ab1029bcae9ddb4a = $icZql.buffer;

var $9RLLl = parcelRequire("9RLLl");
$e1059775f18d6292$export$8916d2c8119541bb = $9RLLl.bufferCount;

var $34zHs = parcelRequire("34zHs");
$e1059775f18d6292$export$d6b40c95035461c7 = $34zHs.bufferTime;

var $aWZX4 = parcelRequire("aWZX4");
$e1059775f18d6292$export$91115bdd8709945f = $aWZX4.bufferToggle;

var $kkXTB = parcelRequire("kkXTB");
$e1059775f18d6292$export$9e55760d3282e08c = $kkXTB.bufferWhen;

var $e6C7w = parcelRequire("e6C7w");
$e1059775f18d6292$export$3dede90624df3ba9 = $e6C7w.catchError;

var $kKZko = parcelRequire("kKZko");
$e1059775f18d6292$export$29ae691b7de52fe3 = $kKZko.combineAll;

var $cuNVo = parcelRequire("cuNVo");
$e1059775f18d6292$export$77fa7d86f5204e8a = $cuNVo.combineLatest;

var $azHuT = parcelRequire("azHuT");
$e1059775f18d6292$export$ee1b3e54f0441b22 = $azHuT.concat;

var $6moha = parcelRequire("6moha");
$e1059775f18d6292$export$b314777ae20abca9 = $6moha.concatAll;

var $ib0Rz = parcelRequire("ib0Rz");
$e1059775f18d6292$export$c28c8388be0ab31a = $ib0Rz.concatMap;

var $i1FL0 = parcelRequire("i1FL0");
$e1059775f18d6292$export$82fbd7a2841d2484 = $i1FL0.concatMapTo;

var $dKj3R = parcelRequire("dKj3R");
$e1059775f18d6292$export$85b9a36db797e02b = $dKj3R.count;

var $7aklh = parcelRequire("7aklh");
$e1059775f18d6292$export$61fc7d43ac8f84b0 = $7aklh.debounce;

var $5tEcX = parcelRequire("5tEcX");
$e1059775f18d6292$export$7843a4469d64c07e = $5tEcX.debounceTime;

var $dd7Pj = parcelRequire("dd7Pj");
$e1059775f18d6292$export$e4ca6d7b7a6dcf9b = $dd7Pj.defaultIfEmpty;

var $8EnuM = parcelRequire("8EnuM");
$e1059775f18d6292$export$1391212d75b2ee65 = $8EnuM.delay;

var $2cpnk = parcelRequire("2cpnk");
$e1059775f18d6292$export$286ca829307725c9 = $2cpnk.delayWhen;

var $cmRJk = parcelRequire("cmRJk");
$e1059775f18d6292$export$ab9a5985b741fa7a = $cmRJk.dematerialize;

var $1bPST = parcelRequire("1bPST");
$e1059775f18d6292$export$983a3b5fb2f7202e = $1bPST.distinct;

var $gIcfQ = parcelRequire("gIcfQ");
$e1059775f18d6292$export$779c5fb865a0172e = $gIcfQ.distinctUntilChanged;

var $kUQOu = parcelRequire("kUQOu");
$e1059775f18d6292$export$571da16e28367bde = $kUQOu.distinctUntilKeyChanged;

var $hLOVc = parcelRequire("hLOVc");
$e1059775f18d6292$export$91d69c7761a17bbc = $hLOVc.elementAt;

var $6bgMW = parcelRequire("6bgMW");
$e1059775f18d6292$export$7ecc1a3b11b57dab = $6bgMW.every;

var $86pSk = parcelRequire("86pSk");
$e1059775f18d6292$export$31039f1fbd797b9c = $86pSk.exhaust;

var $4mCND = parcelRequire("4mCND");
$e1059775f18d6292$export$d70d492cd31004c0 = $4mCND.exhaustMap;

var $iG5sS = parcelRequire("iG5sS");
$e1059775f18d6292$export$9f77e0932fb78f72 = $iG5sS.expand;

var $4cJXk = parcelRequire("4cJXk");
$e1059775f18d6292$export$3dea766d36a8935f = $4cJXk.filter;

var $k4nsZ = parcelRequire("k4nsZ");
$e1059775f18d6292$export$578723aef62d92f5 = $k4nsZ.finalize;

var $5c9n9 = parcelRequire("5c9n9");
$e1059775f18d6292$export$71aa6c912b956294 = $5c9n9.find;

var $c12op = parcelRequire("c12op");
$e1059775f18d6292$export$de3a4d4a0d731119 = $c12op.findIndex;

var $fVAsD = parcelRequire("fVAsD");
$e1059775f18d6292$export$43128fadae87b74a = $fVAsD.first;

var $kUcWn = parcelRequire("kUcWn");
$e1059775f18d6292$export$3f063810d7bf01bd = $kUcWn.groupBy;

var $iSACE = parcelRequire("iSACE");
$e1059775f18d6292$export$6953b97c7d866605 = $iSACE.ignoreElements;

var $2zIk2 = parcelRequire("2zIk2");
$e1059775f18d6292$export$dd1bc94b04021eeb = $2zIk2.isEmpty;

var $jYVp8 = parcelRequire("jYVp8");
$e1059775f18d6292$export$4c7897fafd92b108 = $jYVp8.last;

var $cVFxd = parcelRequire("cVFxd");
$e1059775f18d6292$export$871de8747c9eaa88 = $cVFxd.map;

var $bAfvi = parcelRequire("bAfvi");
$e1059775f18d6292$export$e0eaf3a86c03b2ad = $bAfvi.mapTo;

var $5krLg = parcelRequire("5krLg");
$e1059775f18d6292$export$76dbd6ffd832405d = $5krLg.materialize;

var $iE370 = parcelRequire("iE370");
$e1059775f18d6292$export$8960430cfd85939f = $iE370.max;

var $kO8p6 = parcelRequire("kO8p6");
$e1059775f18d6292$export$4950aa0f605343fb = $kO8p6.merge;

var $f62NZ = parcelRequire("f62NZ");
$e1059775f18d6292$export$18aef43295bbe906 = $f62NZ.mergeAll;

var $80gxR = parcelRequire("80gxR");
$e1059775f18d6292$export$6b9f6c0d32c093f9 = $80gxR.mergeMap;

var $80gxR = parcelRequire("80gxR");
$e1059775f18d6292$export$5b8affa63fc6df16 = $80gxR.mergeMap;

var $jUshS = parcelRequire("jUshS");
$e1059775f18d6292$export$bd7cfc9a42b8a412 = $jUshS.mergeMapTo;

var $a4CFW = parcelRequire("a4CFW");
$e1059775f18d6292$export$c1fc905202bced53 = $a4CFW.mergeScan;

var $bsM3P = parcelRequire("bsM3P");
$e1059775f18d6292$export$96ec731ed4dcb222 = $bsM3P.min;

var $eGi4b = parcelRequire("eGi4b");
$e1059775f18d6292$export$1364843af8d5a963 = $eGi4b.multicast;

var $9plom = parcelRequire("9plom");
$e1059775f18d6292$export$9007f49c319d1ac7 = $9plom.observeOn;

var $9YhCb = parcelRequire("9YhCb");
$e1059775f18d6292$export$5fba66d61591f42 = $9YhCb.onErrorResumeNext;

var $kN9sY = parcelRequire("kN9sY");
$e1059775f18d6292$export$8f9d79d42bff1aac = $kN9sY.pairwise;

var $hU4zQ = parcelRequire("hU4zQ");
$e1059775f18d6292$export$b29f828819edca8d = $hU4zQ.partition;

var $98ptb = parcelRequire("98ptb");
$e1059775f18d6292$export$c44985b87d605eff = $98ptb.pluck;

var $dZ4Ky = parcelRequire("dZ4Ky");
$e1059775f18d6292$export$89b472e03be495df = $dZ4Ky.publish;

var $gqcmX = parcelRequire("gqcmX");
$e1059775f18d6292$export$16ae46fda9567053 = $gqcmX.publishBehavior;

var $4J0vA = parcelRequire("4J0vA");
$e1059775f18d6292$export$42d9b6b38c68d989 = $4J0vA.publishLast;

var $18m9t = parcelRequire("18m9t");
$e1059775f18d6292$export$1f3342bf81d92d52 = $18m9t.publishReplay;

var $k9N6P = parcelRequire("k9N6P");
$e1059775f18d6292$export$236c05de452bec2 = $k9N6P.race;

var $1hf9S = parcelRequire("1hf9S");
$e1059775f18d6292$export$533b26079ad0b4b = $1hf9S.reduce;

var $eytwZ = parcelRequire("eytwZ");
$e1059775f18d6292$export$76d90c956114f2c2 = $eytwZ.repeat;

var $dy5FK = parcelRequire("dy5FK");
$e1059775f18d6292$export$b39ac5b4ffd1415a = $dy5FK.repeatWhen;

var $cy6Ro = parcelRequire("cy6Ro");
$e1059775f18d6292$export$9369b12211e1fce4 = $cy6Ro.retry;

var $5v6N2 = parcelRequire("5v6N2");
$e1059775f18d6292$export$1281551253cfee02 = $5v6N2.retryWhen;

var $6UJhT = parcelRequire("6UJhT");
$e1059775f18d6292$export$18d0766d894cba0c = $6UJhT.refCount;

var $cv9dl = parcelRequire("cv9dl");
$e1059775f18d6292$export$4812e460280c6ef2 = $cv9dl.sample;

var $9Blm5 = parcelRequire("9Blm5");
$e1059775f18d6292$export$fe33c7b2002d97b0 = $9Blm5.sampleTime;

var $9Fl1U = parcelRequire("9Fl1U");
$e1059775f18d6292$export$c87d910e63d22ed6 = $9Fl1U.scan;

var $eeEii = parcelRequire("eeEii");
$e1059775f18d6292$export$d0a07e60ae428313 = $eeEii.sequenceEqual;

var $7UXWF = parcelRequire("7UXWF");
$e1059775f18d6292$export$ed80d9de1d9df928 = $7UXWF.share;

var $cmzwd = parcelRequire("cmzwd");
$e1059775f18d6292$export$db61d692014e534e = $cmzwd.shareReplay;

var $8n116 = parcelRequire("8n116");
$e1059775f18d6292$export$863d7ca51b416cee = $8n116.single;

var $3ZBte = parcelRequire("3ZBte");
$e1059775f18d6292$export$955fc4a6c4be454d = $3ZBte.skip;

var $eDK1x = parcelRequire("eDK1x");
$e1059775f18d6292$export$635f6273df29ea1c = $eDK1x.skipLast;

var $eZ5AN = parcelRequire("eZ5AN");
$e1059775f18d6292$export$facc584867c26fde = $eZ5AN.skipUntil;

var $bLNAF = parcelRequire("bLNAF");
$e1059775f18d6292$export$175dedd748069215 = $bLNAF.skipWhile;

var $hOuOc = parcelRequire("hOuOc");
$e1059775f18d6292$export$a4fe86229b0e9bdd = $hOuOc.startWith;

var $2GSzx = parcelRequire("2GSzx");
$e1059775f18d6292$export$6a45284a4b0bf33a = $2GSzx.switchAll;

var $jEfnV = parcelRequire("jEfnV");
$e1059775f18d6292$export$9f6ea8e48bc26eab = $jEfnV.switchMap;

var $ixMxd = parcelRequire("ixMxd");
$e1059775f18d6292$export$a439dc30c845238 = $ixMxd.switchMapTo;

var $cQZy3 = parcelRequire("cQZy3");
$e1059775f18d6292$export$b7df5d561049483a = $cQZy3.take;

var $1Zayq = parcelRequire("1Zayq");
$e1059775f18d6292$export$1b47ad771ce5af5e = $1Zayq.takeLast;

var $d98nf = parcelRequire("d98nf");
$e1059775f18d6292$export$ac8dfd3a7ad06e80 = $d98nf.takeUntil;

var $dqok3 = parcelRequire("dqok3");
$e1059775f18d6292$export$9384c7afe4015e42 = $dqok3.takeWhile;

var $j7Dz8 = parcelRequire("j7Dz8");
$e1059775f18d6292$export$3f23594af5f37336 = $j7Dz8.tap;

var $kBrBP = parcelRequire("kBrBP");
$e1059775f18d6292$export$de363e709c412c8a = $kBrBP.throttle;

var $hhdWx = parcelRequire("hhdWx");
$e1059775f18d6292$export$4efe28f192921dd4 = $hhdWx.throttleTime;

var $cvLsC = parcelRequire("cvLsC");
$e1059775f18d6292$export$1a539c8b2950ab40 = $cvLsC.timeInterval;

var $imafm = parcelRequire("imafm");
$e1059775f18d6292$export$83e74882c5df8fe1 = $imafm.timeout;

var $aWA2c = parcelRequire("aWA2c");
$e1059775f18d6292$export$86fe999fba7953f2 = $aWA2c.timeoutWith;

var $21QZF = parcelRequire("21QZF");
$e1059775f18d6292$export$fc00ee57782020aa = $21QZF.timestamp;

var $iQUbM = parcelRequire("iQUbM");
$e1059775f18d6292$export$45b10814cc054894 = $iQUbM.toArray;

var $aJFCj = parcelRequire("aJFCj");
$e1059775f18d6292$export$8291e5b88f90ce4 = $aJFCj.window;

var $1e4sA = parcelRequire("1e4sA");
$e1059775f18d6292$export$f3a19e933f377396 = $1e4sA.windowCount;

var $9nNIL = parcelRequire("9nNIL");
$e1059775f18d6292$export$1284415effa79ee0 = $9nNIL.windowTime;

var $d327T = parcelRequire("d327T");
$e1059775f18d6292$export$3182be990e0eeaad = $d327T.windowToggle;

var $2evIr = parcelRequire("2evIr");
$e1059775f18d6292$export$6a5dea797879f644 = $2evIr.windowWhen;

var $huLMT = parcelRequire("huLMT");
$e1059775f18d6292$export$d449030e5c10edf7 = $huLMT.withLatestFrom;

var $cKFwQ = parcelRequire("cKFwQ");
$e1059775f18d6292$export$8901015135f2fb22 = $cKFwQ.zip;

var $050GT = parcelRequire("050GT");
$e1059775f18d6292$export$adddb6a2fa3864e9 = $050GT.zipAll;

});
parcelRegister("eqNaQ", function(module, exports) {
"use strict";
var $a819a3507909eb98$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Ignores source values for a duration determined by another Observable, then
 * emits the most recent value from the source Observable, then repeats this
 * process.
 *
 * <span class="informal">It's like {@link auditTime}, but the silencing
 * duration is determined by a second Observable.</span>
 *
 * <img src="./img/audit.png" width="100%">
 *
 * `audit` is similar to `throttle`, but emits the last value from the silenced
 * time window, instead of the first value. `audit` emits the most recent value
 * from the source Observable on the output Observable as soon as its internal
 * timer becomes disabled, and ignores source values while the timer is enabled.
 * Initially, the timer is disabled. As soon as the first source value arrives,
 * the timer is enabled by calling the `durationSelector` function with the
 * source value, which returns the "duration" Observable. When the duration
 * Observable emits a value or completes, the timer is disabled, then the most
 * recent source value is emitted on the output Observable, and this process
 * repeats for the next source value.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.audit(ev => Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounce}
 * @see {@link delayWhen}
 * @see {@link sample}
 * @see {@link throttle}
 *
 * @param {function(value: T): SubscribableOrPromise} durationSelector A function
 * that receives a value from the source Observable, for computing the silencing
 * duration, returned as an Observable or a Promise.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method audit
 * @owner Observable
 */ function $a819a3507909eb98$var$audit(durationSelector) {
    return function auditOperatorFunction(source) {
        return source.lift(new $a819a3507909eb98$var$AuditOperator(durationSelector));
    };
}
module.exports.audit = $a819a3507909eb98$var$audit;
var $a819a3507909eb98$var$AuditOperator = function() {
    function AuditOperator(durationSelector) {
        this.durationSelector = durationSelector;
    }
    AuditOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a819a3507909eb98$var$AuditSubscriber(subscriber, this.durationSelector));
    };
    return AuditOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a819a3507909eb98$var$AuditSubscriber = function(_super) {
    $a819a3507909eb98$var$__extends(AuditSubscriber, _super);
    function AuditSubscriber(destination, durationSelector) {
        _super.call(this, destination);
        this.durationSelector = durationSelector;
        this.hasValue = false;
    }
    AuditSubscriber.prototype._next = function(value) {
        this.value = value;
        this.hasValue = true;
        if (!this.throttled) {
            var duration = $5PCwK.tryCatch(this.durationSelector)(value);
            if (duration === $iZPYv.errorObject) this.destination.error($iZPYv.errorObject.e);
            else {
                var innerSubscription = $558qb.subscribeToResult(this, duration);
                if (innerSubscription.closed) this.clearThrottle();
                else this.add(this.throttled = innerSubscription);
            }
        }
    };
    AuditSubscriber.prototype.clearThrottle = function() {
        var _a = this, value = _a.value, hasValue = _a.hasValue, throttled = _a.throttled;
        if (throttled) {
            this.remove(throttled);
            this.throttled = null;
            throttled.unsubscribe();
        }
        if (hasValue) {
            this.value = null;
            this.hasValue = false;
            this.destination.next(value);
        }
    };
    AuditSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex) {
        this.clearThrottle();
    };
    AuditSubscriber.prototype.notifyComplete = function() {
        this.clearThrottle();
    };
    return AuditSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("imTmw", function(module, exports) {

$parcel$export(module.exports, "auditTime", () => $d5f539d78db073f3$export$719c70722b10e5ff, (v) => $d5f539d78db073f3$export$719c70722b10e5ff = v);
var $d5f539d78db073f3$export$719c70722b10e5ff;
"use strict";

var $hSQIY = parcelRequire("hSQIY");

var $eqNaQ = parcelRequire("eqNaQ");

var $jKX30 = parcelRequire("jKX30");
/**
 * Ignores source values for `duration` milliseconds, then emits the most recent
 * value from the source Observable, then repeats this process.
 *
 * <span class="informal">When it sees a source values, it ignores that plus
 * the next ones for `duration` milliseconds, and then it emits the most recent
 * value from the source.</span>
 *
 * <img src="./img/auditTime.png" width="100%">
 *
 * `auditTime` is similar to `throttleTime`, but emits the last value from the
 * silenced time window, instead of the first value. `auditTime` emits the most
 * recent value from the source Observable on the output Observable as soon as
 * its internal timer becomes disabled, and ignores source values while the
 * timer is enabled. Initially, the timer is disabled. As soon as the first
 * source value arrives, the timer is enabled. After `duration` milliseconds (or
 * the time unit determined internally by the optional `scheduler`) has passed,
 * the timer is disabled, then the most recent source value is emitted on the
 * output Observable, and this process repeats for the next source value.
 * Optionally takes a {@link IScheduler} for managing timers.
 *
 * @example <caption>Emit clicks at a rate of at most one click per second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.auditTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link audit}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sampleTime}
 * @see {@link throttleTime}
 *
 * @param {number} duration Time to wait before emitting the most recent source
 * value, measured in milliseconds or the time unit determined internally
 * by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the rate-limiting behavior.
 * @return {Observable<T>} An Observable that performs rate-limiting of
 * emissions from the source Observable.
 * @method auditTime
 * @owner Observable
 */ function $d5f539d78db073f3$var$auditTime(duration, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return $eqNaQ.audit(function() {
        return $jKX30.timer(duration, scheduler);
    });
}
$d5f539d78db073f3$export$719c70722b10e5ff = $d5f539d78db073f3$var$auditTime;

});

parcelRegister("kKZko", function(module, exports) {

$parcel$export(module.exports, "combineAll", () => $f1c7acf7b8f94afc$export$29ae691b7de52fe3, (v) => $f1c7acf7b8f94afc$export$29ae691b7de52fe3 = v);
var $f1c7acf7b8f94afc$export$29ae691b7de52fe3;
"use strict";

var $cuNVo = parcelRequire("cuNVo");
function $f1c7acf7b8f94afc$var$combineAll(project) {
    return function(source) {
        return source.lift(new $cuNVo.CombineLatestOperator(project));
    };
}
$f1c7acf7b8f94afc$export$29ae691b7de52fe3 = $f1c7acf7b8f94afc$var$combineAll;

});

parcelRegister("i1FL0", function(module, exports) {

$parcel$export(module.exports, "concatMapTo", () => $d1f8b612dc7f744d$export$82fbd7a2841d2484, (v) => $d1f8b612dc7f744d$export$82fbd7a2841d2484 = v);
var $d1f8b612dc7f744d$export$82fbd7a2841d2484;
"use strict";

var $ib0Rz = parcelRequire("ib0Rz");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in a serialized fashion on the output Observable.
 *
 * <span class="informal">It's like {@link concatMap}, but maps each value
 * always to the same inner Observable.</span>
 *
 * <img src="./img/concatMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then flattens those resulting Observables into one
 * single Observable, which is the output Observable. Each new `innerObservable`
 * instance emitted on the output Observable is concatenated with the previous
 * `innerObservable` instance.
 *
 * __Warning:__ if source values arrive endlessly and faster than their
 * corresponding inner Observables can complete, it will result in memory issues
 * as inner Observables amass in an unbounded buffer waiting for their turn to
 * be subscribed to.
 *
 * Note: `concatMapTo` is equivalent to `mergeMapTo` with concurrency parameter
 * set to `1`.
 *
 * @example <caption>For each click event, tick every second from 0 to 3, with no concurrency</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.concatMapTo(Rx.Observable.interval(1000).take(4));
 * result.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // (results are not concurrent)
 * // For every click on the "document" it will emit values 0 to 3 spaced
 * // on a 1000ms interval
 * // one click = 1000ms-> 0 -1000ms-> 1 -1000ms-> 2 -1000ms-> 3
 *
 * @see {@link concat}
 * @see {@link concatAll}
 * @see {@link concatMap}
 * @see {@link mergeMapTo}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @return {Observable} An observable of values merged together by joining the
 * passed observable with itself, one after the other, for each value emitted
 * from the source.
 * @method concatMapTo
 * @owner Observable
 */ function $d1f8b612dc7f744d$var$concatMapTo(innerObservable, resultSelector) {
    return $ib0Rz.concatMap(function() {
        return innerObservable;
    }, resultSelector);
}
$d1f8b612dc7f744d$export$82fbd7a2841d2484 = $d1f8b612dc7f744d$var$concatMapTo;

});

parcelRegister("dKj3R", function(module, exports) {
"use strict";
var __extends = this && this.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Counts the number of emissions on the source and emits that number when the
 * source completes.
 *
 * <span class="informal">Tells how many values were emitted, when the source
 * completes.</span>
 *
 * <img src="./img/count.png" width="100%">
 *
 * `count` transforms an Observable that emits values into an Observable that
 * emits a single value that represents the number of values emitted by the
 * source Observable. If the source Observable terminates with an error, `count`
 * will pass this error notification along without emitting a value first. If
 * the source Observable does not terminate at all, `count` will neither emit
 * a value nor terminate. This operator takes an optional `predicate` function
 * as argument, in which case the output emission will represent the number of
 * source values that matched `true` with the `predicate`.
 *
 * @example <caption>Counts how many seconds have passed before the first click happened</caption>
 * var seconds = Rx.Observable.interval(1000);
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var secondsBeforeClick = seconds.takeUntil(clicks);
 * var result = secondsBeforeClick.count();
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Counts how many odd numbers are there between 1 and 7</caption>
 * var numbers = Rx.Observable.range(1, 7);
 * var result = numbers.count(i => i % 2 === 1);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 4
 *
 * @see {@link max}
 * @see {@link min}
 * @see {@link reduce}
 *
 * @param {function(value: T, i: number, source: Observable<T>): boolean} [predicate] A
 * boolean function to select what values are to be counted. It is provided with
 * arguments of:
 * - `value`: the value from the source Observable.
 * - `index`: the (zero-based) "index" of the value from the source Observable.
 * - `source`: the source Observable instance itself.
 * @return {Observable} An Observable of one number that represents the count as
 * described above.
 * @method count
 * @owner Observable
 */ function count(predicate) {
    return function(source) {
        return source.lift(new CountOperator(predicate, source));
    };
}
exports.count = count;
var CountOperator = function() {
    function CountOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    CountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new CountSubscriber(subscriber, this.predicate, this.source));
    };
    return CountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var CountSubscriber = function(_super) {
    __extends(CountSubscriber, _super);
    function CountSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.count = 0;
        this.index = 0;
    }
    CountSubscriber.prototype._next = function(value) {
        if (this.predicate) this._tryPredicate(value);
        else this.count++;
    };
    CountSubscriber.prototype._tryPredicate = function(value) {
        var result;
        try {
            result = this.predicate(value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (result) this.count++;
    };
    CountSubscriber.prototype._complete = function() {
        this.destination.next(this.count);
        this.destination.complete();
    };
    return CountSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("2cpnk", function(module, exports) {
"use strict";
var $19a062c4cc2da585$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $kVLXA = parcelRequire("kVLXA");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Delays the emission of items from the source Observable by a given time span
 * determined by the emissions of another Observable.
 *
 * <span class="informal">It's like {@link delay}, but the time span of the
 * delay duration is determined by a second Observable.</span>
 *
 * <img src="./img/delayWhen.png" width="100%">
 *
 * `delayWhen` time shifts each emitted value from the source Observable by a
 * time span determined by another Observable. When the source emits a value,
 * the `delayDurationSelector` function is called with the source value as
 * argument, and should return an Observable, called the "duration" Observable.
 * The source value is emitted on the output Observable only when the duration
 * Observable emits a value or completes.
 *
 * Optionally, `delayWhen` takes a second argument, `subscriptionDelay`, which
 * is an Observable. When `subscriptionDelay` emits its first value or
 * completes, the source Observable is subscribed to and starts behaving like
 * described in the previous paragraph. If `subscriptionDelay` is not provided,
 * `delayWhen` will subscribe to the source Observable as soon as the output
 * Observable is subscribed.
 *
 * @example <caption>Delay each click by a random amount of time, between 0 and 5 seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var delayedClicks = clicks.delayWhen(event =>
 *   Rx.Observable.interval(Math.random() * 5000)
 * );
 * delayedClicks.subscribe(x => console.log(x));
 *
 * @see {@link debounce}
 * @see {@link delay}
 *
 * @param {function(value: T): Observable} delayDurationSelector A function that
 * returns an Observable for each value emitted by the source Observable, which
 * is then used to delay the emission of that item on the output Observable
 * until the Observable returned from this function emits a value.
 * @param {Observable} subscriptionDelay An Observable that triggers the
 * subscription to the source Observable once it emits any value.
 * @return {Observable} An Observable that delays the emissions of the source
 * Observable by an amount of time specified by the Observable returned by
 * `delayDurationSelector`.
 * @method delayWhen
 * @owner Observable
 */ function $19a062c4cc2da585$var$delayWhen(delayDurationSelector, subscriptionDelay) {
    if (subscriptionDelay) return function(source) {
        return new $19a062c4cc2da585$var$SubscriptionDelayObservable(source, subscriptionDelay).lift(new $19a062c4cc2da585$var$DelayWhenOperator(delayDurationSelector));
    };
    return function(source) {
        return source.lift(new $19a062c4cc2da585$var$DelayWhenOperator(delayDurationSelector));
    };
}
module.exports.delayWhen = $19a062c4cc2da585$var$delayWhen;
var $19a062c4cc2da585$var$DelayWhenOperator = function() {
    function DelayWhenOperator(delayDurationSelector) {
        this.delayDurationSelector = delayDurationSelector;
    }
    DelayWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $19a062c4cc2da585$var$DelayWhenSubscriber(subscriber, this.delayDurationSelector));
    };
    return DelayWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$DelayWhenSubscriber = function(_super) {
    $19a062c4cc2da585$var$__extends(DelayWhenSubscriber, _super);
    function DelayWhenSubscriber(destination, delayDurationSelector) {
        _super.call(this, destination);
        this.delayDurationSelector = delayDurationSelector;
        this.completed = false;
        this.delayNotifierSubscriptions = [];
        this.values = [];
    }
    DelayWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.destination.next(outerValue);
        this.removeSubscription(innerSub);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DelayWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        var value = this.removeSubscription(innerSub);
        if (value) this.destination.next(value);
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype._next = function(value) {
        try {
            var delayNotifier = this.delayDurationSelector(value);
            if (delayNotifier) this.tryDelay(delayNotifier, value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    DelayWhenSubscriber.prototype._complete = function() {
        this.completed = true;
        this.tryComplete();
    };
    DelayWhenSubscriber.prototype.removeSubscription = function(subscription) {
        subscription.unsubscribe();
        var subscriptionIdx = this.delayNotifierSubscriptions.indexOf(subscription);
        var value = null;
        if (subscriptionIdx !== -1) {
            value = this.values[subscriptionIdx];
            this.delayNotifierSubscriptions.splice(subscriptionIdx, 1);
            this.values.splice(subscriptionIdx, 1);
        }
        return value;
    };
    DelayWhenSubscriber.prototype.tryDelay = function(delayNotifier, value) {
        var notifierSubscription = $558qb.subscribeToResult(this, delayNotifier, value);
        if (notifierSubscription && !notifierSubscription.closed) {
            this.add(notifierSubscription);
            this.delayNotifierSubscriptions.push(notifierSubscription);
        }
        this.values.push(value);
    };
    DelayWhenSubscriber.prototype.tryComplete = function() {
        if (this.completed && this.delayNotifierSubscriptions.length === 0) this.destination.complete();
    };
    return DelayWhenSubscriber;
}($RlQRN.OuterSubscriber);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$SubscriptionDelayObservable = function(_super) {
    $19a062c4cc2da585$var$__extends(SubscriptionDelayObservable, _super);
    function SubscriptionDelayObservable(/** @deprecated internal use only */ source, subscriptionDelay) {
        _super.call(this);
        this.source = source;
        this.subscriptionDelay = subscriptionDelay;
    }
    /** @deprecated internal use only */ SubscriptionDelayObservable.prototype._subscribe = function(subscriber) {
        this.subscriptionDelay.subscribe(new $19a062c4cc2da585$var$SubscriptionDelaySubscriber(subscriber, this.source));
    };
    return SubscriptionDelayObservable;
}($kVLXA.Observable);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $19a062c4cc2da585$var$SubscriptionDelaySubscriber = function(_super) {
    $19a062c4cc2da585$var$__extends(SubscriptionDelaySubscriber, _super);
    function SubscriptionDelaySubscriber(parent, source) {
        _super.call(this);
        this.parent = parent;
        this.source = source;
        this.sourceSubscribed = false;
    }
    SubscriptionDelaySubscriber.prototype._next = function(unused) {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype._error = function(err) {
        this.unsubscribe();
        this.parent.error(err);
    };
    SubscriptionDelaySubscriber.prototype._complete = function() {
        this.subscribeToSource();
    };
    SubscriptionDelaySubscriber.prototype.subscribeToSource = function() {
        if (!this.sourceSubscribed) {
            this.sourceSubscribed = true;
            this.unsubscribe();
            this.source.subscribe(this.parent);
        }
    };
    return SubscriptionDelaySubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("cmRJk", function(module, exports) {
"use strict";
var $901137cd6740bf13$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Converts an Observable of {@link Notification} objects into the emissions
 * that they represent.
 *
 * <span class="informal">Unwraps {@link Notification} objects as actual `next`,
 * `error` and `complete` emissions. The opposite of {@link materialize}.</span>
 *
 * <img src="./img/dematerialize.png" width="100%">
 *
 * `dematerialize` is assumed to operate an Observable that only emits
 * {@link Notification} objects as `next` emissions, and does not emit any
 * `error`. Such Observable is the output of a `materialize` operation. Those
 * notifications are then unwrapped using the metadata they contain, and emitted
 * as `next`, `error`, and `complete` on the output Observable.
 *
 * Use this operator in conjunction with {@link materialize}.
 *
 * @example <caption>Convert an Observable of Notifications to an actual Observable</caption>
 * var notifA = new Rx.Notification('N', 'A');
 * var notifB = new Rx.Notification('N', 'B');
 * var notifE = new Rx.Notification('E', void 0,
 *   new TypeError('x.toUpperCase is not a function')
 * );
 * var materialized = Rx.Observable.of(notifA, notifB, notifE);
 * var upperCase = materialized.dematerialize();
 * upperCase.subscribe(x => console.log(x), e => console.error(e));
 *
 * // Results in:
 * // A
 * // B
 * // TypeError: x.toUpperCase is not a function
 *
 * @see {@link Notification}
 * @see {@link materialize}
 *
 * @return {Observable} An Observable that emits items and notifications
 * embedded in Notification objects emitted by the source Observable.
 * @method dematerialize
 * @owner Observable
 */ function $901137cd6740bf13$var$dematerialize() {
    return function dematerializeOperatorFunction(source) {
        return source.lift(new $901137cd6740bf13$var$DeMaterializeOperator());
    };
}
module.exports.dematerialize = $901137cd6740bf13$var$dematerialize;
var $901137cd6740bf13$var$DeMaterializeOperator = function() {
    function DeMaterializeOperator() {}
    DeMaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $901137cd6740bf13$var$DeMaterializeSubscriber(subscriber));
    };
    return DeMaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $901137cd6740bf13$var$DeMaterializeSubscriber = function(_super) {
    $901137cd6740bf13$var$__extends(DeMaterializeSubscriber, _super);
    function DeMaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    DeMaterializeSubscriber.prototype._next = function(value) {
        value.observe(this.destination);
    };
    return DeMaterializeSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("1bPST", function(module, exports) {
"use strict";
var $0ddf10adfec7988e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");

var $dwKPr = parcelRequire("dwKPr");
/**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from previous items.
 *
 * If a keySelector function is provided, then it will project each value from the source observable into a new value that it will
 * check for equality with previously projected values. If a keySelector function is not provided, it will use each value from the
 * source observable directly with an equality check against previous values.
 *
 * In JavaScript runtimes that support `Set`, this operator will use a `Set` to improve performance of the distinct value checking.
 *
 * In other runtimes, this operator will use a minimal implementation of `Set` that relies on an `Array` and `indexOf` under the
 * hood, so performance will degrade as more values are checked for distinction. Even in newer browsers, a long-running `distinct`
 * use might result in memory leaks. To help alleviate this in some scenarios, an optional `flushes` parameter is also provided so
 * that the internal `Set` can be "flushed", basically clearing it of values.
 *
 * @example <caption>A simple example with numbers</caption>
 * Observable.of(1, 1, 2, 2, 2, 1, 2, 3, 4, 3, 2, 1)
 *   .distinct()
 *   .subscribe(x => console.log(x)); // 1, 2, 3, 4
 *
 * @example <caption>An example using a keySelector function</caption>
 * interface Person {
 *    age: number,
 *    name: string
 * }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'})
 *     .distinct((p: Person) => p.name)
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 *
 * @see {@link distinctUntilChanged}
 * @see {@link distinctUntilKeyChanged}
 *
 * @param {function} [keySelector] Optional function to select which value you want to check as distinct.
 * @param {Observable} [flushes] Optional Observable for flushing the internal HashSet of the operator.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values.
 * @method distinct
 * @owner Observable
 */ function $0ddf10adfec7988e$var$distinct(keySelector, flushes) {
    return function(source) {
        return source.lift(new $0ddf10adfec7988e$var$DistinctOperator(keySelector, flushes));
    };
}
module.exports.distinct = $0ddf10adfec7988e$var$distinct;
var $0ddf10adfec7988e$var$DistinctOperator = function() {
    function DistinctOperator(keySelector, flushes) {
        this.keySelector = keySelector;
        this.flushes = flushes;
    }
    DistinctOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0ddf10adfec7988e$var$DistinctSubscriber(subscriber, this.keySelector, this.flushes));
    };
    return DistinctOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0ddf10adfec7988e$var$DistinctSubscriber = function(_super) {
    $0ddf10adfec7988e$var$__extends(DistinctSubscriber, _super);
    function DistinctSubscriber(destination, keySelector, flushes) {
        _super.call(this, destination);
        this.keySelector = keySelector;
        this.values = new $dwKPr.Set();
        if (flushes) this.add($558qb.subscribeToResult(this, flushes));
    }
    DistinctSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.values.clear();
    };
    DistinctSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    DistinctSubscriber.prototype._next = function(value) {
        if (this.keySelector) this._useKeySelector(value);
        else this._finalizeNext(value, value);
    };
    DistinctSubscriber.prototype._useKeySelector = function(value) {
        var key;
        var destination = this.destination;
        try {
            key = this.keySelector(value);
        } catch (err) {
            destination.error(err);
            return;
        }
        this._finalizeNext(key, value);
    };
    DistinctSubscriber.prototype._finalizeNext = function(key, value) {
        var values = this.values;
        if (!values.has(key)) {
            values.add(key);
            this.destination.next(value);
        }
    };
    return DistinctSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.DistinctSubscriber = $0ddf10adfec7988e$var$DistinctSubscriber;

});
parcelRegister("dwKPr", function(module, exports) {

$parcel$export(module.exports, "Set", () => $9d9296b95471d13c$export$bdf4ff5a442cbbc5, (v) => $9d9296b95471d13c$export$bdf4ff5a442cbbc5 = v);
var $9d9296b95471d13c$export$ac57f2e66ff143c0;
var $9d9296b95471d13c$export$bdf4ff5a442cbbc5;
"use strict";

var $hdgV4 = parcelRequire("hdgV4");
function $9d9296b95471d13c$var$minimalSetImpl() {
    // THIS IS NOT a full impl of Set, this is just the minimum
    // bits of functionality we need for this library.
    return function() {
        function MinimalSet() {
            this._values = [];
        }
        MinimalSet.prototype.add = function(value) {
            if (!this.has(value)) this._values.push(value);
        };
        MinimalSet.prototype.has = function(value) {
            return this._values.indexOf(value) !== -1;
        };
        Object.defineProperty(MinimalSet.prototype, "size", {
            get: function() {
                return this._values.length;
            },
            enumerable: true,
            configurable: true
        });
        MinimalSet.prototype.clear = function() {
            this._values.length = 0;
        };
        return MinimalSet;
    }();
}
$9d9296b95471d13c$export$ac57f2e66ff143c0 = $9d9296b95471d13c$var$minimalSetImpl;
$9d9296b95471d13c$export$bdf4ff5a442cbbc5 = $hdgV4.root.Set || $9d9296b95471d13c$var$minimalSetImpl();

});


parcelRegister("kUQOu", function(module, exports) {

$parcel$export(module.exports, "distinctUntilKeyChanged", () => $f3a2013de9cd2068$export$571da16e28367bde, (v) => $f3a2013de9cd2068$export$571da16e28367bde = v);
var $f3a2013de9cd2068$export$571da16e28367bde;
"use strict";

var $gIcfQ = parcelRequire("gIcfQ");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that emits all items emitted by the source Observable that are distinct by comparison from the previous item,
 * using a property accessed by using the key provided to check if the two items are distinct.
 *
 * If a comparator function is provided, then it will be called for each item to test for whether or not that value should be emitted.
 *
 * If a comparator function is not provided, an equality check is used by default.
 *
 * @example <caption>An example comparing the name of persons</caption>
 *
 *  interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo'},
 *     { age: 6, name: 'Foo'})
 *     .distinctUntilKeyChanged('name')
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo' }
 *
 * @example <caption>An example comparing the first letters of the name</caption>
 *
 * interface Person {
 *     age: number,
 *     name: string
 *  }
 *
 * Observable.of<Person>(
 *     { age: 4, name: 'Foo1'},
 *     { age: 7, name: 'Bar'},
 *     { age: 5, name: 'Foo2'},
 *     { age: 6, name: 'Foo3'})
 *     .distinctUntilKeyChanged('name', (x: string, y: string) => x.substring(0, 3) === y.substring(0, 3))
 *     .subscribe(x => console.log(x));
 *
 * // displays:
 * // { age: 4, name: 'Foo1' }
 * // { age: 7, name: 'Bar' }
 * // { age: 5, name: 'Foo2' }
 *
 * @see {@link distinct}
 * @see {@link distinctUntilChanged}
 *
 * @param {string} key String key for object property lookup on each item.
 * @param {function} [compare] Optional comparison function called to test if an item is distinct from the previous item in the source.
 * @return {Observable} An Observable that emits items from the source Observable with distinct values based on the key specified.
 * @method distinctUntilKeyChanged
 * @owner Observable
 */ function $f3a2013de9cd2068$var$distinctUntilKeyChanged(key, compare) {
    return $gIcfQ.distinctUntilChanged(function(x, y) {
        return compare ? compare(x[key], y[key]) : x[key] === y[key];
    });
}
$f3a2013de9cd2068$export$571da16e28367bde = $f3a2013de9cd2068$var$distinctUntilKeyChanged;

});

parcelRegister("hLOVc", function(module, exports) {
"use strict";
var $cefe537100800401$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $cRqdv = parcelRequire("cRqdv");
/**
 * Emits the single value at the specified `index` in a sequence of emissions
 * from the source Observable.
 *
 * <span class="informal">Emits only the i-th value, then completes.</span>
 *
 * <img src="./img/elementAt.png" width="100%">
 *
 * `elementAt` returns an Observable that emits the item at the specified
 * `index` in the source Observable, or a default value if that `index` is out
 * of range and the `default` argument is provided. If the `default` argument is
 * not given and the `index` is out of range, the output Observable will emit an
 * `ArgumentOutOfRangeError` error.
 *
 * @example <caption>Emit only the third click event</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.elementAt(2);
 * result.subscribe(x => console.log(x));
 *
 * // Results in:
 * // click 1 = nothing
 * // click 2 = nothing
 * // click 3 = MouseEvent object logged to console
 *
 * @see {@link first}
 * @see {@link last}
 * @see {@link skip}
 * @see {@link single}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `elementAt(i)`, it delivers an
 * ArgumentOutOrRangeError to the Observer's `error` callback if `i < 0` or the
 * Observable has completed before emitting the i-th `next` notification.
 *
 * @param {number} index Is the number `i` for the i-th source emission that has
 * happened since the subscription, starting from the number `0`.
 * @param {T} [defaultValue] The default value returned for missing indices.
 * @return {Observable} An Observable that emits a single item, if it is found.
 * Otherwise, will emit the default value if given. If not, then emits an error.
 * @method elementAt
 * @owner Observable
 */ function $cefe537100800401$var$elementAt(index, defaultValue) {
    return function(source) {
        return source.lift(new $cefe537100800401$var$ElementAtOperator(index, defaultValue));
    };
}
module.exports.elementAt = $cefe537100800401$var$elementAt;
var $cefe537100800401$var$ElementAtOperator = function() {
    function ElementAtOperator(index, defaultValue) {
        this.index = index;
        this.defaultValue = defaultValue;
        if (index < 0) throw new $cRqdv.ArgumentOutOfRangeError;
    }
    ElementAtOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $cefe537100800401$var$ElementAtSubscriber(subscriber, this.index, this.defaultValue));
    };
    return ElementAtOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $cefe537100800401$var$ElementAtSubscriber = function(_super) {
    $cefe537100800401$var$__extends(ElementAtSubscriber, _super);
    function ElementAtSubscriber(destination, index, defaultValue) {
        _super.call(this, destination);
        this.index = index;
        this.defaultValue = defaultValue;
    }
    ElementAtSubscriber.prototype._next = function(x) {
        if (this.index-- === 0) {
            this.destination.next(x);
            this.destination.complete();
        }
    };
    ElementAtSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index >= 0) {
            if (typeof this.defaultValue !== 'undefined') destination.next(this.defaultValue);
            else destination.error(new $cRqdv.ArgumentOutOfRangeError);
        }
        destination.complete();
    };
    return ElementAtSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("6bgMW", function(module, exports) {
"use strict";
var $4800caf82bf1be15$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Returns an Observable that emits whether or not every item of the source satisfies the condition specified.
 *
 * @example <caption>A simple example emitting true if all elements are less than 5, false otherwise</caption>
 *  Observable.of(1, 2, 3, 4, 5, 6)
 *     .every(x => x < 5)
 *     .subscribe(x => console.log(x)); // -> false
 *
 * @param {function} predicate A function for determining if an item meets a specified condition.
 * @param {any} [thisArg] Optional object to use for `this` in the callback.
 * @return {Observable} An Observable of booleans that determines if all items of the source Observable meet the condition specified.
 * @method every
 * @owner Observable
 */ function $4800caf82bf1be15$var$every(predicate, thisArg) {
    return function(source) {
        return source.lift(new $4800caf82bf1be15$var$EveryOperator(predicate, thisArg, source));
    };
}
module.exports.every = $4800caf82bf1be15$var$every;
var $4800caf82bf1be15$var$EveryOperator = function() {
    function EveryOperator(predicate, thisArg, source) {
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
    }
    EveryOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $4800caf82bf1be15$var$EverySubscriber(observer, this.predicate, this.thisArg, this.source));
    };
    return EveryOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $4800caf82bf1be15$var$EverySubscriber = function(_super) {
    $4800caf82bf1be15$var$__extends(EverySubscriber, _super);
    function EverySubscriber(destination, predicate, thisArg, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.thisArg = thisArg;
        this.source = source;
        this.index = 0;
        this.thisArg = thisArg || this;
    }
    EverySubscriber.prototype.notifyComplete = function(everyValueMatch) {
        this.destination.next(everyValueMatch);
        this.destination.complete();
    };
    EverySubscriber.prototype._next = function(value) {
        var result = false;
        try {
            result = this.predicate.call(this.thisArg, value, this.index++, this.source);
        } catch (err) {
            this.destination.error(err);
            return;
        }
        if (!result) this.notifyComplete(false);
    };
    EverySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return EverySubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("86pSk", function(module, exports) {
"use strict";
var $5e62f491e8caf9f6$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Converts a higher-order Observable into a first-order Observable by dropping
 * inner Observables while the previous inner Observable has not yet completed.
 *
 * <span class="informal">Flattens an Observable-of-Observables by dropping the
 * next inner Observables while the current inner is still executing.</span>
 *
 * <img src="./img/exhaust.png" width="100%">
 *
 * `exhaust` subscribes to an Observable that emits Observables, also known as a
 * higher-order Observable. Each time it observes one of these emitted inner
 * Observables, the output Observable begins emitting the items emitted by that
 * inner Observable. So far, it behaves like {@link mergeAll}. However,
 * `exhaust` ignores every new inner Observable if the previous Observable has
 * not yet completed. Once that one completes, it will accept and flatten the
 * next inner Observable and repeat this process.
 *
 * @example <caption>Run a finite timer for each click, only if there is no currently active timer</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var higherOrder = clicks.map((ev) => Rx.Observable.interval(1000).take(5));
 * var result = higherOrder.exhaust();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link combineAll}
 * @see {@link concatAll}
 * @see {@link switch}
 * @see {@link mergeAll}
 * @see {@link exhaustMap}
 * @see {@link zipAll}
 *
 * @return {Observable} An Observable that takes a source of Observables and propagates the first observable
 * exclusively until it completes before subscribing to the next.
 * @method exhaust
 * @owner Observable
 */ function $5e62f491e8caf9f6$var$exhaust() {
    return function(source) {
        return source.lift(new $5e62f491e8caf9f6$var$SwitchFirstOperator());
    };
}
module.exports.exhaust = $5e62f491e8caf9f6$var$exhaust;
var $5e62f491e8caf9f6$var$SwitchFirstOperator = function() {
    function SwitchFirstOperator() {}
    SwitchFirstOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $5e62f491e8caf9f6$var$SwitchFirstSubscriber(subscriber));
    };
    return SwitchFirstOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $5e62f491e8caf9f6$var$SwitchFirstSubscriber = function(_super) {
    $5e62f491e8caf9f6$var$__extends(SwitchFirstSubscriber, _super);
    function SwitchFirstSubscriber(destination) {
        _super.call(this, destination);
        this.hasCompleted = false;
        this.hasSubscription = false;
    }
    SwitchFirstSubscriber.prototype._next = function(value) {
        if (!this.hasSubscription) {
            this.hasSubscription = true;
            this.add($558qb.subscribeToResult(this, value));
        }
    };
    SwitchFirstSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (!this.hasSubscription) this.destination.complete();
    };
    SwitchFirstSubscriber.prototype.notifyComplete = function(innerSub) {
        this.remove(innerSub);
        this.hasSubscription = false;
        if (this.hasCompleted) this.destination.complete();
    };
    return SwitchFirstSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("iG5sS", function(module, exports) {
"use strict";
var $d9906367a8064856$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/* tslint:enable:max-line-length */ /**
 * Recursively projects each source value to an Observable which is merged in
 * the output Observable.
 *
 * <span class="informal">It's similar to {@link mergeMap}, but applies the
 * projection function to every source value as well as every output value.
 * It's recursive.</span>
 *
 * <img src="./img/expand.png" width="100%">
 *
 * Returns an Observable that emits items based on applying a function that you
 * supply to each item emitted by the source Observable, where that function
 * returns an Observable, and then merging those resulting Observables and
 * emitting the results of this merger. *Expand* will re-emit on the output
 * Observable every source value. Then, each output value is given to the
 * `project` function which returns an inner Observable to be merged on the
 * output Observable. Those output values resulting from the projection are also
 * given to the `project` function to produce new output values. This is how
 * *expand* behaves recursively.
 *
 * @example <caption>Start emitting the powers of two on every click, at most 10 of them</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var powersOfTwo = clicks
 *   .mapTo(1)
 *   .expand(x => Rx.Observable.of(2 * x).delay(1000))
 *   .take(10);
 * powersOfTwo.subscribe(x => console.log(x));
 *
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 *
 * @param {function(value: T, index: number) => Observable} project A function
 * that, when applied to an item emitted by the source or the output Observable,
 * returns an Observable.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @param {Scheduler} [scheduler=null] The IScheduler to use for subscribing to
 * each projected inner Observable.
 * @return {Observable} An Observable that emits the source values and also
 * result of applying the projection function to each value emitted on the
 * output Observable and and merging the results of the Observables obtained
 * from this transformation.
 * @method expand
 * @owner Observable
 */ function $d9906367a8064856$var$expand(project, concurrent, scheduler) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (scheduler === void 0) scheduler = undefined;
    concurrent = (concurrent || 0) < 1 ? Number.POSITIVE_INFINITY : concurrent;
    return function(source) {
        return source.lift(new $d9906367a8064856$var$ExpandOperator(project, concurrent, scheduler));
    };
}
module.exports.expand = $d9906367a8064856$var$expand;
var $d9906367a8064856$var$ExpandOperator = function() {
    function ExpandOperator(project, concurrent, scheduler) {
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
    }
    ExpandOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d9906367a8064856$var$ExpandSubscriber(subscriber, this.project, this.concurrent, this.scheduler));
    };
    return ExpandOperator;
}();
module.exports.ExpandOperator = $d9906367a8064856$var$ExpandOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d9906367a8064856$var$ExpandSubscriber = function(_super) {
    $d9906367a8064856$var$__extends(ExpandSubscriber, _super);
    function ExpandSubscriber(destination, project, concurrent, scheduler) {
        _super.call(this, destination);
        this.project = project;
        this.concurrent = concurrent;
        this.scheduler = scheduler;
        this.index = 0;
        this.active = 0;
        this.hasCompleted = false;
        if (concurrent < Number.POSITIVE_INFINITY) this.buffer = [];
    }
    ExpandSubscriber.dispatch = function(arg) {
        var subscriber = arg.subscriber, result = arg.result, value = arg.value, index = arg.index;
        subscriber.subscribeToProjection(result, value, index);
    };
    ExpandSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (destination.closed) {
            this._complete();
            return;
        }
        var index = this.index++;
        if (this.active < this.concurrent) {
            destination.next(value);
            var result = $5PCwK.tryCatch(this.project)(value, index);
            if (result === $iZPYv.errorObject) destination.error($iZPYv.errorObject.e);
            else if (!this.scheduler) this.subscribeToProjection(result, value, index);
            else {
                var state = {
                    subscriber: this,
                    result: result,
                    value: value,
                    index: index
                };
                this.add(this.scheduler.schedule(ExpandSubscriber.dispatch, 0, state));
            }
        } else this.buffer.push(value);
    };
    ExpandSubscriber.prototype.subscribeToProjection = function(result, value, index) {
        this.active++;
        this.add($558qb.subscribeToResult(this, result, value, index));
    };
    ExpandSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    ExpandSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this._next(innerValue);
    };
    ExpandSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer && buffer.length > 0) this._next(buffer.shift());
        if (this.hasCompleted && this.active === 0) this.destination.complete();
    };
    return ExpandSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.ExpandSubscriber = $d9906367a8064856$var$ExpandSubscriber;

});

parcelRegister("5c9n9", function(module, exports) {
"use strict";
var $3c8557ea635e24ec$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Emits only the first value emitted by the source Observable that meets some
 * condition.
 *
 * <span class="informal">Finds the first value that passes some test and emits
 * that.</span>
 *
 * <img src="./img/find.png" width="100%">
 *
 * `find` searches for the first item in the source Observable that matches the
 * specified condition embodied by the `predicate`, and returns the first
 * occurrence in the source. Unlike {@link first}, the `predicate` is required
 * in `find`, and does not emit an error if a valid value is not found.
 *
 * @example <caption>Find and emit the first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.find(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link first}
 * @see {@link findIndex}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable<T>} An Observable of the first item that matches the
 * condition.
 * @method find
 * @owner Observable
 */ function $3c8557ea635e24ec$var$find(predicate, thisArg) {
    if (typeof predicate !== 'function') throw new TypeError('predicate is not a function');
    return function(source) {
        return source.lift(new $3c8557ea635e24ec$var$FindValueOperator(predicate, source, false, thisArg));
    };
}
module.exports.find = $3c8557ea635e24ec$var$find;
var $3c8557ea635e24ec$var$FindValueOperator = function() {
    function FindValueOperator(predicate, source, yieldIndex, thisArg) {
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
    }
    FindValueOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $3c8557ea635e24ec$var$FindValueSubscriber(observer, this.predicate, this.source, this.yieldIndex, this.thisArg));
    };
    return FindValueOperator;
}();
module.exports.FindValueOperator = $3c8557ea635e24ec$var$FindValueOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3c8557ea635e24ec$var$FindValueSubscriber = function(_super) {
    $3c8557ea635e24ec$var$__extends(FindValueSubscriber, _super);
    function FindValueSubscriber(destination, predicate, source, yieldIndex, thisArg) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.yieldIndex = yieldIndex;
        this.thisArg = thisArg;
        this.index = 0;
    }
    FindValueSubscriber.prototype.notifyComplete = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    FindValueSubscriber.prototype._next = function(value) {
        var _a = this, predicate = _a.predicate, thisArg = _a.thisArg;
        var index = this.index++;
        try {
            var result = predicate.call(thisArg || this, value, index, this.source);
            if (result) this.notifyComplete(this.yieldIndex ? index : value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    FindValueSubscriber.prototype._complete = function() {
        this.notifyComplete(this.yieldIndex ? -1 : undefined);
    };
    return FindValueSubscriber;
}($ggvKU.Subscriber);
module.exports.FindValueSubscriber = $3c8557ea635e24ec$var$FindValueSubscriber;

});

parcelRegister("c12op", function(module, exports) {

$parcel$export(module.exports, "findIndex", () => $8bf76f276d4706d4$export$de3a4d4a0d731119, (v) => $8bf76f276d4706d4$export$de3a4d4a0d731119 = v);
var $8bf76f276d4706d4$export$de3a4d4a0d731119;
"use strict";

var $5c9n9 = parcelRequire("5c9n9");
/**
 * Emits only the index of the first value emitted by the source Observable that
 * meets some condition.
 *
 * <span class="informal">It's like {@link find}, but emits the index of the
 * found value, not the value itself.</span>
 *
 * <img src="./img/findIndex.png" width="100%">
 *
 * `findIndex` searches for the first item in the source Observable that matches
 * the specified condition embodied by the `predicate`, and returns the
 * (zero-based) index of the first occurrence in the source. Unlike
 * {@link first}, the `predicate` is required in `findIndex`, and does not emit
 * an error if a valid value is not found.
 *
 * @example <caption>Emit the index of first click that happens on a DIV element</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.findIndex(ev => ev.target.tagName === 'DIV');
 * result.subscribe(x => console.log(x));
 *
 * @see {@link filter}
 * @see {@link find}
 * @see {@link first}
 * @see {@link take}
 *
 * @param {function(value: T, index: number, source: Observable<T>): boolean} predicate
 * A function called with each item to test for condition matching.
 * @param {any} [thisArg] An optional argument to determine the value of `this`
 * in the `predicate` function.
 * @return {Observable} An Observable of the index of the first item that
 * matches the condition.
 * @method find
 * @owner Observable
 */ function $8bf76f276d4706d4$var$findIndex(predicate, thisArg) {
    return function(source) {
        return source.lift(new $5c9n9.FindValueOperator(predicate, source, true, thisArg));
    };
}
$8bf76f276d4706d4$export$de3a4d4a0d731119 = $8bf76f276d4706d4$var$findIndex;

});

parcelRegister("2zIk2", function(module, exports) {
"use strict";
var $1e013b1fb62a8872$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
function $1e013b1fb62a8872$var$isEmpty() {
    return function(source) {
        return source.lift(new $1e013b1fb62a8872$var$IsEmptyOperator());
    };
}
module.exports.isEmpty = $1e013b1fb62a8872$var$isEmpty;
var $1e013b1fb62a8872$var$IsEmptyOperator = function() {
    function IsEmptyOperator() {}
    IsEmptyOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $1e013b1fb62a8872$var$IsEmptySubscriber(observer));
    };
    return IsEmptyOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1e013b1fb62a8872$var$IsEmptySubscriber = function(_super) {
    $1e013b1fb62a8872$var$__extends(IsEmptySubscriber, _super);
    function IsEmptySubscriber(destination) {
        _super.call(this, destination);
    }
    IsEmptySubscriber.prototype.notifyComplete = function(isEmpty) {
        var destination = this.destination;
        destination.next(isEmpty);
        destination.complete();
    };
    IsEmptySubscriber.prototype._next = function(value) {
        this.notifyComplete(false);
    };
    IsEmptySubscriber.prototype._complete = function() {
        this.notifyComplete(true);
    };
    return IsEmptySubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("5krLg", function(module, exports) {
"use strict";
var $3e145ad44b0c8f28$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $cigS2 = parcelRequire("cigS2");
/**
 * Represents all of the notifications from the source Observable as `next`
 * emissions marked with their original types within {@link Notification}
 * objects.
 *
 * <span class="informal">Wraps `next`, `error` and `complete` emissions in
 * {@link Notification} objects, emitted as `next` on the output Observable.
 * </span>
 *
 * <img src="./img/materialize.png" width="100%">
 *
 * `materialize` returns an Observable that emits a `next` notification for each
 * `next`, `error`, or `complete` emission of the source Observable. When the
 * source Observable emits `complete`, the output Observable will emit `next` as
 * a Notification of type "complete", and then it will emit `complete` as well.
 * When the source Observable emits `error`, the output will emit `next` as a
 * Notification of type "error", and then `complete`.
 *
 * This operator is useful for producing metadata of the source Observable, to
 * be consumed as `next` emissions. Use it in conjunction with
 * {@link dematerialize}.
 *
 * @example <caption>Convert a faulty Observable to an Observable of Notifications</caption>
 * var letters = Rx.Observable.of('a', 'b', 13, 'd');
 * var upperCase = letters.map(x => x.toUpperCase());
 * var materialized = upperCase.materialize();
 * materialized.subscribe(x => console.log(x));
 *
 * // Results in the following:
 * // - Notification {kind: "N", value: "A", error: undefined, hasValue: true}
 * // - Notification {kind: "N", value: "B", error: undefined, hasValue: true}
 * // - Notification {kind: "E", value: undefined, error: TypeError:
 * //   x.toUpperCase is not a function at MapSubscriber.letters.map.x
 * //   [as project] (http://1…, hasValue: false}
 *
 * @see {@link Notification}
 * @see {@link dematerialize}
 *
 * @return {Observable<Notification<T>>} An Observable that emits
 * {@link Notification} objects that wrap the original emissions from the source
 * Observable with metadata.
 * @method materialize
 * @owner Observable
 */ function $3e145ad44b0c8f28$var$materialize() {
    return function materializeOperatorFunction(source) {
        return source.lift(new $3e145ad44b0c8f28$var$MaterializeOperator());
    };
}
module.exports.materialize = $3e145ad44b0c8f28$var$materialize;
var $3e145ad44b0c8f28$var$MaterializeOperator = function() {
    function MaterializeOperator() {}
    MaterializeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $3e145ad44b0c8f28$var$MaterializeSubscriber(subscriber));
    };
    return MaterializeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $3e145ad44b0c8f28$var$MaterializeSubscriber = function(_super) {
    $3e145ad44b0c8f28$var$__extends(MaterializeSubscriber, _super);
    function MaterializeSubscriber(destination) {
        _super.call(this, destination);
    }
    MaterializeSubscriber.prototype._next = function(value) {
        this.destination.next($cigS2.Notification.createNext(value));
    };
    MaterializeSubscriber.prototype._error = function(err) {
        var destination = this.destination;
        destination.next($cigS2.Notification.createError(err));
        destination.complete();
    };
    MaterializeSubscriber.prototype._complete = function() {
        var destination = this.destination;
        destination.next($cigS2.Notification.createComplete());
        destination.complete();
    };
    return MaterializeSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("iE370", function(module, exports) {

$parcel$export(module.exports, "max", () => $d92e606630772716$export$8960430cfd85939f, (v) => $d92e606630772716$export$8960430cfd85939f = v);
var $d92e606630772716$export$8960430cfd85939f;
"use strict";

var $1hf9S = parcelRequire("1hf9S");
/**
 * The Max operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the largest value.
 *
 * <img src="./img/max.png" width="100%">
 *
 * @example <caption>Get the maximal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .max()
 *   .subscribe(x => console.log(x)); // -> 8
 *
 * @example <caption>Use a comparer function to get the maximal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .max<Person>((a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Beer'
 * }
 *
 * @see {@link min}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable} An Observable that emits item with the largest value.
 * @method max
 * @owner Observable
 */ function $d92e606630772716$var$max(comparer) {
    var max = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) > 0 ? x : y;
    } : function(x, y) {
        return x > y ? x : y;
    };
    return $1hf9S.reduce(max);
}
$d92e606630772716$export$8960430cfd85939f = $d92e606630772716$var$max;

});

parcelRegister("jUshS", function(module, exports) {
"use strict";
var $e7e9308f95d0e13e$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/* tslint:enable:max-line-length */ /**
 * Projects each source value to the same Observable which is merged multiple
 * times in the output Observable.
 *
 * <span class="informal">It's like {@link mergeMap}, but maps each value always
 * to the same inner Observable.</span>
 *
 * <img src="./img/mergeMapTo.png" width="100%">
 *
 * Maps each source value to the given Observable `innerObservable` regardless
 * of the source value, and then merges those resulting Observables into one
 * single Observable, which is the output Observable.
 *
 * @example <caption>For each click event, start an interval Observable ticking every 1 second</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.mergeMapTo(Rx.Observable.interval(1000));
 * result.subscribe(x => console.log(x));
 *
 * @see {@link concatMapTo}
 * @see {@link merge}
 * @see {@link mergeAll}
 * @see {@link mergeMap}
 * @see {@link mergeScan}
 * @see {@link switchMapTo}
 *
 * @param {ObservableInput} innerObservable An Observable to replace each value from
 * the source Observable.
 * @param {function(outerValue: T, innerValue: I, outerIndex: number, innerIndex: number): any} [resultSelector]
 * A function to produce the value on the output Observable based on the values
 * and the indices of the source (outer) emission and the inner Observable
 * emission. The arguments passed to this function are:
 * - `outerValue`: the value that came from the source
 * - `innerValue`: the value that came from the projected Observable
 * - `outerIndex`: the "index" of the value that came from the source
 * - `innerIndex`: the "index" of the value from the projected Observable
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of input
 * Observables being subscribed to concurrently.
 * @return {Observable} An Observable that emits items from the given
 * `innerObservable` (and optionally transformed through `resultSelector`) every
 * time a value is emitted on the source Observable.
 * @method mergeMapTo
 * @owner Observable
 */ function $e7e9308f95d0e13e$var$mergeMapTo(innerObservable, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    if (typeof resultSelector === 'number') {
        concurrent = resultSelector;
        resultSelector = null;
    }
    return function(source) {
        return source.lift(new $e7e9308f95d0e13e$var$MergeMapToOperator(innerObservable, resultSelector, concurrent));
    };
}
module.exports.mergeMapTo = $e7e9308f95d0e13e$var$mergeMapTo;
// TODO: Figure out correct signature here: an Operator<Observable<T>, R>
//       needs to implement call(observer: Subscriber<R>): Subscriber<Observable<T>>
var $e7e9308f95d0e13e$var$MergeMapToOperator = function() {
    function MergeMapToOperator(ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
    }
    MergeMapToOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $e7e9308f95d0e13e$var$MergeMapToSubscriber(observer, this.ish, this.resultSelector, this.concurrent));
    };
    return MergeMapToOperator;
}();
module.exports.MergeMapToOperator = $e7e9308f95d0e13e$var$MergeMapToOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e7e9308f95d0e13e$var$MergeMapToSubscriber = function(_super) {
    $e7e9308f95d0e13e$var$__extends(MergeMapToSubscriber, _super);
    function MergeMapToSubscriber(destination, ish, resultSelector, concurrent) {
        if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
        _super.call(this, destination);
        this.ish = ish;
        this.resultSelector = resultSelector;
        this.concurrent = concurrent;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeMapToSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var resultSelector = this.resultSelector;
            var index = this.index++;
            var ish = this.ish;
            var destination = this.destination;
            this.active++;
            this._innerSub(ish, destination, resultSelector, value, index);
        } else this.buffer.push(value);
    };
    MergeMapToSubscriber.prototype._innerSub = function(ish, destination, resultSelector, value, index) {
        this.add($558qb.subscribeToResult(this, ish, value, index));
    };
    MergeMapToSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) this.destination.complete();
    };
    MergeMapToSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        if (resultSelector) this.trySelectResult(outerValue, innerValue, outerIndex, innerIndex);
        else destination.next(innerValue);
    };
    MergeMapToSubscriber.prototype.trySelectResult = function(outerValue, innerValue, outerIndex, innerIndex) {
        var _a = this, resultSelector = _a.resultSelector, destination = _a.destination;
        var result;
        try {
            result = resultSelector(outerValue, innerValue, outerIndex, innerIndex);
        } catch (err) {
            destination.error(err);
            return;
        }
        destination.next(result);
    };
    MergeMapToSubscriber.prototype.notifyError = function(err) {
        this.destination.error(err);
    };
    MergeMapToSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) this.destination.complete();
    };
    return MergeMapToSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.MergeMapToSubscriber = $e7e9308f95d0e13e$var$MergeMapToSubscriber;

});

parcelRegister("a4CFW", function(module, exports) {
"use strict";
var $755847397ce7390d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $558qb = parcelRequire("558qb");

var $RlQRN = parcelRequire("RlQRN");
/**
 * Applies an accumulator function over the source Observable where the
 * accumulator function itself returns an Observable, then each intermediate
 * Observable returned is merged into the output Observable.
 *
 * <span class="informal">It's like {@link scan}, but the Observables returned
 * by the accumulator are merged into the outer Observable.</span>
 *
 * @example <caption>Count the number of click events</caption>
 * const click$ = Rx.Observable.fromEvent(document, 'click');
 * const one$ = click$.mapTo(1);
 * const seed = 0;
 * const count$ = one$.mergeScan((acc, one) => Rx.Observable.of(acc + one), seed);
 * count$.subscribe(x => console.log(x));
 *
 * // Results:
 * 1
 * 2
 * 3
 * 4
 * // ...and so on for each click
 *
 * @param {function(acc: R, value: T): Observable<R>} accumulator
 * The accumulator function called on each source value.
 * @param seed The initial accumulation value.
 * @param {number} [concurrent=Number.POSITIVE_INFINITY] Maximum number of
 * input Observables being subscribed to concurrently.
 * @return {Observable<R>} An observable of the accumulated values.
 * @method mergeScan
 * @owner Observable
 */ function $755847397ce7390d$var$mergeScan(accumulator, seed, concurrent) {
    if (concurrent === void 0) concurrent = Number.POSITIVE_INFINITY;
    return function(source) {
        return source.lift(new $755847397ce7390d$var$MergeScanOperator(accumulator, seed, concurrent));
    };
}
module.exports.mergeScan = $755847397ce7390d$var$mergeScan;
var $755847397ce7390d$var$MergeScanOperator = function() {
    function MergeScanOperator(accumulator, seed, concurrent) {
        this.accumulator = accumulator;
        this.seed = seed;
        this.concurrent = concurrent;
    }
    MergeScanOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $755847397ce7390d$var$MergeScanSubscriber(subscriber, this.accumulator, this.seed, this.concurrent));
    };
    return MergeScanOperator;
}();
module.exports.MergeScanOperator = $755847397ce7390d$var$MergeScanOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $755847397ce7390d$var$MergeScanSubscriber = function(_super) {
    $755847397ce7390d$var$__extends(MergeScanSubscriber, _super);
    function MergeScanSubscriber(destination, accumulator, acc, concurrent) {
        _super.call(this, destination);
        this.accumulator = accumulator;
        this.acc = acc;
        this.concurrent = concurrent;
        this.hasValue = false;
        this.hasCompleted = false;
        this.buffer = [];
        this.active = 0;
        this.index = 0;
    }
    MergeScanSubscriber.prototype._next = function(value) {
        if (this.active < this.concurrent) {
            var index = this.index++;
            var ish = $5PCwK.tryCatch(this.accumulator)(this.acc, value);
            var destination = this.destination;
            if (ish === $iZPYv.errorObject) destination.error($iZPYv.errorObject.e);
            else {
                this.active++;
                this._innerSub(ish, value, index);
            }
        } else this.buffer.push(value);
    };
    MergeScanSubscriber.prototype._innerSub = function(ish, value, index) {
        this.add($558qb.subscribeToResult(this, ish, value, index));
    };
    MergeScanSubscriber.prototype._complete = function() {
        this.hasCompleted = true;
        if (this.active === 0 && this.buffer.length === 0) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    MergeScanSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        var destination = this.destination;
        this.acc = innerValue;
        this.hasValue = true;
        destination.next(innerValue);
    };
    MergeScanSubscriber.prototype.notifyComplete = function(innerSub) {
        var buffer = this.buffer;
        this.remove(innerSub);
        this.active--;
        if (buffer.length > 0) this._next(buffer.shift());
        else if (this.active === 0 && this.hasCompleted) {
            if (this.hasValue === false) this.destination.next(this.acc);
            this.destination.complete();
        }
    };
    return MergeScanSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.MergeScanSubscriber = $755847397ce7390d$var$MergeScanSubscriber;

});

parcelRegister("bsM3P", function(module, exports) {

$parcel$export(module.exports, "min", () => $8587971a238a0187$export$96ec731ed4dcb222, (v) => $8587971a238a0187$export$96ec731ed4dcb222 = v);
var $8587971a238a0187$export$96ec731ed4dcb222;
"use strict";

var $1hf9S = parcelRequire("1hf9S");
/**
 * The Min operator operates on an Observable that emits numbers (or items that can be compared with a provided function),
 * and when source Observable completes it emits a single item: the item with the smallest value.
 *
 * <img src="./img/min.png" width="100%">
 *
 * @example <caption>Get the minimal value of a series of numbers</caption>
 * Rx.Observable.of(5, 4, 7, 2, 8)
 *   .min()
 *   .subscribe(x => console.log(x)); // -> 2
 *
 * @example <caption>Use a comparer function to get the minimal item</caption>
 * interface Person {
 *   age: number,
 *   name: string
 * }
 * Observable.of<Person>({age: 7, name: 'Foo'},
 *                       {age: 5, name: 'Bar'},
 *                       {age: 9, name: 'Beer'})
 *           .min<Person>( (a: Person, b: Person) => a.age < b.age ? -1 : 1)
 *           .subscribe((x: Person) => console.log(x.name)); // -> 'Bar'
 * }
 *
 * @see {@link max}
 *
 * @param {Function} [comparer] - Optional comparer function that it will use instead of its default to compare the
 * value of two items.
 * @return {Observable<R>} An Observable that emits item with the smallest value.
 * @method min
 * @owner Observable
 */ function $8587971a238a0187$var$min(comparer) {
    var min = typeof comparer === 'function' ? function(x, y) {
        return comparer(x, y) < 0 ? x : y;
    } : function(x, y) {
        return x < y ? x : y;
    };
    return $1hf9S.reduce(min);
}
$8587971a238a0187$export$96ec731ed4dcb222 = $8587971a238a0187$var$min;

});

parcelRegister("9YhCb", function(module, exports) {
"use strict";
var $7427619b50d20877$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $b2CJi = parcelRequire("b2CJi");

var $8hxVz = parcelRequire("8hxVz");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/* tslint:enable:max-line-length */ /**
 * When any of the provided Observable emits an complete or error notification, it immediately subscribes to the next one
 * that was passed.
 *
 * <span class="informal">Execute series of Observables no matter what, even if it means swallowing errors.</span>
 *
 * <img src="./img/onErrorResumeNext.png" width="100%">
 *
 * `onErrorResumeNext` is an operator that accepts a series of Observables, provided either directly as
 * arguments or as an array. If no single Observable is provided, returned Observable will simply behave the same
 * as the source.
 *
 * `onErrorResumeNext` returns an Observable that starts by subscribing and re-emitting values from the source Observable.
 * When its stream of values ends - no matter if Observable completed or emitted an error - `onErrorResumeNext`
 * will subscribe to the first Observable that was passed as an argument to the method. It will start re-emitting
 * its values as well and - again - when that stream ends, `onErrorResumeNext` will proceed to subscribing yet another
 * Observable in provided series, no matter if previous Observable completed or ended with an error. This will
 * be happening until there is no more Observables left in the series, at which point returned Observable will
 * complete - even if the last subscribed stream ended with an error.
 *
 * `onErrorResumeNext` can be therefore thought of as version of {@link concat} operator, which is more permissive
 * when it comes to the errors emitted by its input Observables. While `concat` subscribes to the next Observable
 * in series only if previous one successfully completed, `onErrorResumeNext` subscribes even if it ended with
 * an error.
 *
 * Note that you do not get any access to errors emitted by the Observables. In particular do not
 * expect these errors to appear in error callback passed to {@link subscribe}. If you want to take
 * specific actions based on what error was emitted by an Observable, you should try out {@link catch} instead.
 *
 *
 * @example <caption>Subscribe to the next Observable after map fails</caption>
 * Rx.Observable.of(1, 2, 3, 0)
 *   .map(x => {
 *       if (x === 0) { throw Error(); }
         return 10 / x;
 *   })
 *   .onErrorResumeNext(Rx.Observable.of(1, 2, 3))
 *   .subscribe(
 *     val => console.log(val),
 *     err => console.log(err),          // Will never be called.
 *     () => console.log('that\'s it!')
 *   );
 *
 * // Logs:
 * // 10
 * // 5
 * // 3.3333333333333335
 * // 1
 * // 2
 * // 3
 * // "that's it!"
 *
 * @see {@link concat}
 * @see {@link catch}
 *
 * @param {...ObservableInput} observables Observables passed either directly or as an array.
 * @return {Observable} An Observable that emits values from source Observable, but - if it errors - subscribes
 * to the next passed Observable and so on, until it completes or runs out of Observables.
 * @method onErrorResumeNext
 * @owner Observable
 */ function $7427619b50d20877$var$onErrorResumeNext() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    if (nextSources.length === 1 && $8hxVz.isArray(nextSources[0])) nextSources = nextSources[0];
    return function(source) {
        return source.lift(new $7427619b50d20877$var$OnErrorResumeNextOperator(nextSources));
    };
}
module.exports.onErrorResumeNext = $7427619b50d20877$var$onErrorResumeNext;
/* tslint:enable:max-line-length */ function $7427619b50d20877$var$onErrorResumeNextStatic() {
    var nextSources = [];
    for(var _i = 0; _i < arguments.length; _i++)nextSources[_i - 0] = arguments[_i];
    var source = null;
    if (nextSources.length === 1 && $8hxVz.isArray(nextSources[0])) nextSources = nextSources[0];
    source = nextSources.shift();
    return new $b2CJi.FromObservable(source, null).lift(new $7427619b50d20877$var$OnErrorResumeNextOperator(nextSources));
}
module.exports.onErrorResumeNextStatic = $7427619b50d20877$var$onErrorResumeNextStatic;
var $7427619b50d20877$var$OnErrorResumeNextOperator = function() {
    function OnErrorResumeNextOperator(nextSources) {
        this.nextSources = nextSources;
    }
    OnErrorResumeNextOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7427619b50d20877$var$OnErrorResumeNextSubscriber(subscriber, this.nextSources));
    };
    return OnErrorResumeNextOperator;
}();
var $7427619b50d20877$var$OnErrorResumeNextSubscriber = function(_super) {
    $7427619b50d20877$var$__extends(OnErrorResumeNextSubscriber, _super);
    function OnErrorResumeNextSubscriber(destination, nextSources) {
        _super.call(this, destination);
        this.destination = destination;
        this.nextSources = nextSources;
    }
    OnErrorResumeNextSubscriber.prototype.notifyError = function(error, innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.notifyComplete = function(innerSub) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._error = function(err) {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype._complete = function() {
        this.subscribeToNextSource();
    };
    OnErrorResumeNextSubscriber.prototype.subscribeToNextSource = function() {
        var next = this.nextSources.shift();
        if (next) this.add($558qb.subscribeToResult(this, next));
        else this.destination.complete();
    };
    return OnErrorResumeNextSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("dZ4Ky", function(module, exports) {

$parcel$export(module.exports, "publish", () => $a2e4a81c568bee89$export$89b472e03be495df, (v) => $a2e4a81c568bee89$export$89b472e03be495df = v);
var $a2e4a81c568bee89$export$89b472e03be495df;
"use strict";

var $cab1K = parcelRequire("cab1K");

var $eGi4b = parcelRequire("eGi4b");
/* tslint:enable:max-line-length */ /**
 * Returns a ConnectableObservable, which is a variety of Observable that waits until its connect method is called
 * before it begins emitting items to those Observers that have subscribed to it.
 *
 * <img src="./img/publish.png" width="100%">
 *
 * @param {Function} [selector] - Optional selector function which can use the multicasted source sequence as many times
 * as needed, without causing multiple subscriptions to the source sequence.
 * Subscribers to the given source will receive all notifications of the source from the time of the subscription on.
 * @return A ConnectableObservable that upon connection causes the source Observable to emit items to its Observers.
 * @method publish
 * @owner Observable
 */ function $a2e4a81c568bee89$var$publish(selector) {
    return selector ? $eGi4b.multicast(function() {
        return new $cab1K.Subject();
    }, selector) : $eGi4b.multicast(new $cab1K.Subject());
}
$a2e4a81c568bee89$export$89b472e03be495df = $a2e4a81c568bee89$var$publish;

});

parcelRegister("gqcmX", function(module, exports) {

$parcel$export(module.exports, "publishBehavior", () => $bf48ab57968dc8ce$export$16ae46fda9567053, (v) => $bf48ab57968dc8ce$export$16ae46fda9567053 = v);
var $bf48ab57968dc8ce$export$16ae46fda9567053;
"use strict";

var $dOAU7 = parcelRequire("dOAU7");

var $eGi4b = parcelRequire("eGi4b");
/**
 * @param value
 * @return {ConnectableObservable<T>}
 * @method publishBehavior
 * @owner Observable
 */ function $bf48ab57968dc8ce$var$publishBehavior(value) {
    return function(source) {
        return $eGi4b.multicast(new $dOAU7.BehaviorSubject(value))(source);
    };
}
$bf48ab57968dc8ce$export$16ae46fda9567053 = $bf48ab57968dc8ce$var$publishBehavior;

});

parcelRegister("4J0vA", function(module, exports) {

$parcel$export(module.exports, "publishLast", () => $370bc2605c2c0a12$export$42d9b6b38c68d989, (v) => $370bc2605c2c0a12$export$42d9b6b38c68d989 = v);
var $370bc2605c2c0a12$export$42d9b6b38c68d989;
"use strict";

var $iHuWn = parcelRequire("iHuWn");

var $eGi4b = parcelRequire("eGi4b");
function $370bc2605c2c0a12$var$publishLast() {
    return function(source) {
        return $eGi4b.multicast(new $iHuWn.AsyncSubject())(source);
    };
}
$370bc2605c2c0a12$export$42d9b6b38c68d989 = $370bc2605c2c0a12$var$publishLast;

});
parcelRegister("iHuWn", function(module, exports) {
"use strict";
var $d9d43e498bd4a03b$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $aZdZn = parcelRequire("aZdZn");
/**
 * @class AsyncSubject<T>
 */ var $d9d43e498bd4a03b$var$AsyncSubject = function(_super) {
    $d9d43e498bd4a03b$var$__extends(AsyncSubject, _super);
    function AsyncSubject() {
        _super.apply(this, arguments);
        this.value = null;
        this.hasNext = false;
        this.hasCompleted = false;
    }
    /** @deprecated internal use only */ AsyncSubject.prototype._subscribe = function(subscriber) {
        if (this.hasError) {
            subscriber.error(this.thrownError);
            return $aZdZn.Subscription.EMPTY;
        } else if (this.hasCompleted && this.hasNext) {
            subscriber.next(this.value);
            subscriber.complete();
            return $aZdZn.Subscription.EMPTY;
        }
        return _super.prototype._subscribe.call(this, subscriber);
    };
    AsyncSubject.prototype.next = function(value) {
        if (!this.hasCompleted) {
            this.value = value;
            this.hasNext = true;
        }
    };
    AsyncSubject.prototype.error = function(error) {
        if (!this.hasCompleted) _super.prototype.error.call(this, error);
    };
    AsyncSubject.prototype.complete = function() {
        this.hasCompleted = true;
        if (this.hasNext) _super.prototype.next.call(this, this.value);
        _super.prototype.complete.call(this);
    };
    return AsyncSubject;
}($cab1K.Subject);
module.exports.AsyncSubject = $d9d43e498bd4a03b$var$AsyncSubject;

});


parcelRegister("18m9t", function(module, exports) {

$parcel$export(module.exports, "publishReplay", () => $0d37b8adb7daa492$export$1f3342bf81d92d52, (v) => $0d37b8adb7daa492$export$1f3342bf81d92d52 = v);
var $0d37b8adb7daa492$export$1f3342bf81d92d52;
"use strict";

var $dZ0DN = parcelRequire("dZ0DN");

var $eGi4b = parcelRequire("eGi4b");
/* tslint:enable:max-line-length */ function $0d37b8adb7daa492$var$publishReplay(bufferSize, windowTime, selectorOrScheduler, scheduler) {
    if (selectorOrScheduler && typeof selectorOrScheduler !== 'function') scheduler = selectorOrScheduler;
    var selector = typeof selectorOrScheduler === 'function' ? selectorOrScheduler : undefined;
    var subject = new $dZ0DN.ReplaySubject(bufferSize, windowTime, scheduler);
    return function(source) {
        return $eGi4b.multicast(function() {
            return subject;
        }, selector)(source);
    };
}
$0d37b8adb7daa492$export$1f3342bf81d92d52 = $0d37b8adb7daa492$var$publishReplay;

});

parcelRegister("k9N6P", function(module, exports) {

$parcel$export(module.exports, "race", () => $eacabdf976c32cd1$export$236c05de452bec2, (v) => $eacabdf976c32cd1$export$236c05de452bec2 = v);
var $eacabdf976c32cd1$export$236c05de452bec2;
"use strict";

var $8hxVz = parcelRequire("8hxVz");

var $k4aBr = parcelRequire("k4aBr");
/* tslint:enable:max-line-length */ /**
 * Returns an Observable that mirrors the first source Observable to emit an item
 * from the combination of this Observable and supplied Observables.
 * @param {...Observables} ...observables Sources used to race for which Observable emits first.
 * @return {Observable} An Observable that mirrors the output of the first Observable to emit an item.
 * @method race
 * @owner Observable
 */ function $eacabdf976c32cd1$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    return function raceOperatorFunction(source) {
        // if the only argument is an array, it was most likely called with
        // `pair([obs1, obs2, ...])`
        if (observables.length === 1 && $8hxVz.isArray(observables[0])) observables = observables[0];
        return source.lift.call($k4aBr.race.apply(void 0, [
            source
        ].concat(observables)));
    };
}
$eacabdf976c32cd1$export$236c05de452bec2 = $eacabdf976c32cd1$var$race;

});
parcelRegister("k4aBr", function(module, exports) {
"use strict";
var $e9bc67e14bd0a7e5$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $8hxVz = parcelRequire("8hxVz");

var $dY7et = parcelRequire("dY7et");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
function $e9bc67e14bd0a7e5$var$race() {
    var observables = [];
    for(var _i = 0; _i < arguments.length; _i++)observables[_i - 0] = arguments[_i];
    // if the only argument is an array, it was most likely called with
    // `race([obs1, obs2, ...])`
    if (observables.length === 1) {
        if ($8hxVz.isArray(observables[0])) observables = observables[0];
        else return observables[0];
    }
    return new $dY7et.ArrayObservable(observables).lift(new $e9bc67e14bd0a7e5$var$RaceOperator());
}
module.exports.race = $e9bc67e14bd0a7e5$var$race;
var $e9bc67e14bd0a7e5$var$RaceOperator = function() {
    function RaceOperator() {}
    RaceOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $e9bc67e14bd0a7e5$var$RaceSubscriber(subscriber));
    };
    return RaceOperator;
}();
module.exports.RaceOperator = $e9bc67e14bd0a7e5$var$RaceOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $e9bc67e14bd0a7e5$var$RaceSubscriber = function(_super) {
    $e9bc67e14bd0a7e5$var$__extends(RaceSubscriber, _super);
    function RaceSubscriber(destination) {
        _super.call(this, destination);
        this.hasFirst = false;
        this.observables = [];
        this.subscriptions = [];
    }
    RaceSubscriber.prototype._next = function(observable) {
        this.observables.push(observable);
    };
    RaceSubscriber.prototype._complete = function() {
        var observables = this.observables;
        var len = observables.length;
        if (len === 0) this.destination.complete();
        else {
            for(var i = 0; i < len && !this.hasFirst; i++){
                var observable = observables[i];
                var subscription = $558qb.subscribeToResult(this, observable, observable, i);
                if (this.subscriptions) this.subscriptions.push(subscription);
                this.add(subscription);
            }
            this.observables = null;
        }
    };
    RaceSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (!this.hasFirst) {
            this.hasFirst = true;
            for(var i = 0; i < this.subscriptions.length; i++)if (i !== outerIndex) {
                var subscription = this.subscriptions[i];
                subscription.unsubscribe();
                this.remove(subscription);
            }
            this.subscriptions = null;
        }
        this.destination.next(innerValue);
    };
    return RaceSubscriber;
}($RlQRN.OuterSubscriber);
module.exports.RaceSubscriber = $e9bc67e14bd0a7e5$var$RaceSubscriber;

});


parcelRegister("eytwZ", function(module, exports) {
"use strict";
var $a98b25f15eca4f40$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $48SuO = parcelRequire("48SuO");
/**
 * Returns an Observable that repeats the stream of items emitted by the source Observable at most count times.
 *
 * <img src="./img/repeat.png" width="100%">
 *
 * @param {number} [count] The number of times the source Observable items are repeated, a count of 0 will yield
 * an empty Observable.
 * @return {Observable} An Observable that repeats the stream of items emitted by the source Observable at most
 * count times.
 * @method repeat
 * @owner Observable
 */ function $a98b25f15eca4f40$var$repeat(count) {
    if (count === void 0) count = -1;
    return function(source) {
        if (count === 0) return new $48SuO.EmptyObservable();
        else if (count < 0) return source.lift(new $a98b25f15eca4f40$var$RepeatOperator(-1, source));
        else return source.lift(new $a98b25f15eca4f40$var$RepeatOperator(count - 1, source));
    };
}
module.exports.repeat = $a98b25f15eca4f40$var$repeat;
var $a98b25f15eca4f40$var$RepeatOperator = function() {
    function RepeatOperator(count, source) {
        this.count = count;
        this.source = source;
    }
    RepeatOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a98b25f15eca4f40$var$RepeatSubscriber(subscriber, this.count, this.source));
    };
    return RepeatOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a98b25f15eca4f40$var$RepeatSubscriber = function(_super) {
    $a98b25f15eca4f40$var$__extends(RepeatSubscriber, _super);
    function RepeatSubscriber(destination, count, source) {
        _super.call(this, destination);
        this.count = count;
        this.source = source;
    }
    RepeatSubscriber.prototype.complete = function() {
        if (!this.isStopped) {
            var _a = this, source = _a.source, count = _a.count;
            if (count === 0) return _super.prototype.complete.call(this);
            else if (count > -1) this.count = count - 1;
            source.subscribe(this._unsubscribeAndRecycle());
        }
    };
    return RepeatSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("dy5FK", function(module, exports) {
"use strict";
var $9dd2d9b93d3bba53$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Returns an Observable that mirrors the source Observable with the exception of a `complete`. If the source
 * Observable calls `complete`, this method will emit to the Observable returned from `notifier`. If that Observable
 * calls `complete` or `error`, then this method will call `complete` or `error` on the child subscription. Otherwise
 * this method will resubscribe to the source Observable.
 *
 * <img src="./img/repeatWhen.png" width="100%">
 *
 * @param {function(notifications: Observable): Observable} notifier - Receives an Observable of notifications with
 * which a user can `complete` or `error`, aborting the repetition.
 * @return {Observable} The source Observable modified with repeat logic.
 * @method repeatWhen
 * @owner Observable
 */ function $9dd2d9b93d3bba53$var$repeatWhen(notifier) {
    return function(source) {
        return source.lift(new $9dd2d9b93d3bba53$var$RepeatWhenOperator(notifier));
    };
}
module.exports.repeatWhen = $9dd2d9b93d3bba53$var$repeatWhen;
var $9dd2d9b93d3bba53$var$RepeatWhenOperator = function() {
    function RepeatWhenOperator(notifier) {
        this.notifier = notifier;
    }
    RepeatWhenOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $9dd2d9b93d3bba53$var$RepeatWhenSubscriber(subscriber, this.notifier, source));
    };
    return RepeatWhenOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $9dd2d9b93d3bba53$var$RepeatWhenSubscriber = function(_super) {
    $9dd2d9b93d3bba53$var$__extends(RepeatWhenSubscriber, _super);
    function RepeatWhenSubscriber(destination, notifier, source) {
        _super.call(this, destination);
        this.notifier = notifier;
        this.source = source;
        this.sourceIsBeingSubscribedTo = true;
    }
    RepeatWhenSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.sourceIsBeingSubscribedTo = true;
        this.source.subscribe(this);
    };
    RepeatWhenSubscriber.prototype.notifyComplete = function(innerSub) {
        if (this.sourceIsBeingSubscribedTo === false) return _super.prototype.complete.call(this);
    };
    RepeatWhenSubscriber.prototype.complete = function() {
        this.sourceIsBeingSubscribedTo = false;
        if (!this.isStopped) {
            if (!this.retries) this.subscribeToRetries();
            if (!this.retriesSubscription || this.retriesSubscription.closed) return _super.prototype.complete.call(this);
            this._unsubscribeAndRecycle();
            this.notifications.next();
        }
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribe = function() {
        var _a = this, notifications = _a.notifications, retriesSubscription = _a.retriesSubscription;
        if (notifications) {
            notifications.unsubscribe();
            this.notifications = null;
        }
        if (retriesSubscription) {
            retriesSubscription.unsubscribe();
            this.retriesSubscription = null;
        }
        this.retries = null;
    };
    /** @deprecated internal use only */ RepeatWhenSubscriber.prototype._unsubscribeAndRecycle = function() {
        var _a = this, notifications = _a.notifications, retries = _a.retries, retriesSubscription = _a.retriesSubscription;
        this.notifications = null;
        this.retries = null;
        this.retriesSubscription = null;
        _super.prototype._unsubscribeAndRecycle.call(this);
        this.notifications = notifications;
        this.retries = retries;
        this.retriesSubscription = retriesSubscription;
        return this;
    };
    RepeatWhenSubscriber.prototype.subscribeToRetries = function() {
        this.notifications = new $cab1K.Subject();
        var retries = $5PCwK.tryCatch(this.notifier)(this.notifications);
        if (retries === $iZPYv.errorObject) return _super.prototype.complete.call(this);
        this.retries = retries;
        this.retriesSubscription = $558qb.subscribeToResult(this, retries);
    };
    return RepeatWhenSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("9Blm5", function(module, exports) {
"use strict";
var $6fd82278c235c8da$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $hSQIY = parcelRequire("hSQIY");
/**
 * Emits the most recently emitted value from the source Observable within
 * periodic time intervals.
 *
 * <span class="informal">Samples the source Observable at periodic time
 * intervals, emitting what it samples.</span>
 *
 * <img src="./img/sampleTime.png" width="100%">
 *
 * `sampleTime` periodically looks at the source Observable and emits whichever
 * value it has most recently emitted since the previous sampling, unless the
 * source has not emitted anything since the previous sampling. The sampling
 * happens periodically in time every `period` milliseconds (or the time unit
 * defined by the optional `scheduler` argument). The sampling starts as soon as
 * the output Observable is subscribed.
 *
 * @example <caption>Every second, emit the most recent click at most once</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.sampleTime(1000);
 * result.subscribe(x => console.log(x));
 *
 * @see {@link auditTime}
 * @see {@link debounceTime}
 * @see {@link delay}
 * @see {@link sample}
 * @see {@link throttleTime}
 *
 * @param {number} period The sampling period expressed in milliseconds or the
 * time unit determined internally by the optional `scheduler`.
 * @param {Scheduler} [scheduler=async] The {@link IScheduler} to use for
 * managing the timers that handle the sampling.
 * @return {Observable<T>} An Observable that emits the results of sampling the
 * values emitted by the source Observable at the specified time interval.
 * @method sampleTime
 * @owner Observable
 */ function $6fd82278c235c8da$var$sampleTime(period, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return function(source) {
        return source.lift(new $6fd82278c235c8da$var$SampleTimeOperator(period, scheduler));
    };
}
module.exports.sampleTime = $6fd82278c235c8da$var$sampleTime;
var $6fd82278c235c8da$var$SampleTimeOperator = function() {
    function SampleTimeOperator(period, scheduler) {
        this.period = period;
        this.scheduler = scheduler;
    }
    SampleTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6fd82278c235c8da$var$SampleTimeSubscriber(subscriber, this.period, this.scheduler));
    };
    return SampleTimeOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6fd82278c235c8da$var$SampleTimeSubscriber = function(_super) {
    $6fd82278c235c8da$var$__extends(SampleTimeSubscriber, _super);
    function SampleTimeSubscriber(destination, period, scheduler) {
        _super.call(this, destination);
        this.period = period;
        this.scheduler = scheduler;
        this.hasValue = false;
        this.add(scheduler.schedule($6fd82278c235c8da$var$dispatchNotification, period, {
            subscriber: this,
            period: period
        }));
    }
    SampleTimeSubscriber.prototype._next = function(value) {
        this.lastValue = value;
        this.hasValue = true;
    };
    SampleTimeSubscriber.prototype.notifyNext = function() {
        if (this.hasValue) {
            this.hasValue = false;
            this.destination.next(this.lastValue);
        }
    };
    return SampleTimeSubscriber;
}($ggvKU.Subscriber);
function $6fd82278c235c8da$var$dispatchNotification(state) {
    var subscriber = state.subscriber, period = state.period;
    subscriber.notifyNext();
    this.schedule(state, period);
}

});

parcelRegister("eeEii", function(module, exports) {
"use strict";
var $a5d1a111eaafe481$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");
/**
 * Compares all values of two observables in sequence using an optional comparor function
 * and returns an observable of a single boolean value representing whether or not the two sequences
 * are equal.
 *
 * <span class="informal">Checks to see of all values emitted by both observables are equal, in order.</span>
 *
 * <img src="./img/sequenceEqual.png" width="100%">
 *
 * `sequenceEqual` subscribes to two observables and buffers incoming values from each observable. Whenever either
 * observable emits a value, the value is buffered and the buffers are shifted and compared from the bottom
 * up; If any value pair doesn't match, the returned observable will emit `false` and complete. If one of the
 * observables completes, the operator will wait for the other observable to complete; If the other
 * observable emits before completing, the returned observable will emit `false` and complete. If one observable never
 * completes or emits after the other complets, the returned observable will never complete.
 *
 * @example <caption>figure out if the Konami code matches</caption>
 * var code = Rx.Observable.from([
 *  "ArrowUp",
 *  "ArrowUp",
 *  "ArrowDown",
 *  "ArrowDown",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "ArrowLeft",
 *  "ArrowRight",
 *  "KeyB",
 *  "KeyA",
 *  "Enter" // no start key, clearly.
 * ]);
 *
 * var keys = Rx.Observable.fromEvent(document, 'keyup')
 *  .map(e => e.code);
 * var matches = keys.bufferCount(11, 1)
 *  .mergeMap(
 *    last11 =>
 *      Rx.Observable.from(last11)
 *        .sequenceEqual(code)
 *   );
 * matches.subscribe(matched => console.log('Successful cheat at Contra? ', matched));
 *
 * @see {@link combineLatest}
 * @see {@link zip}
 * @see {@link withLatestFrom}
 *
 * @param {Observable} compareTo The observable sequence to compare the source sequence to.
 * @param {function} [comparor] An optional function to compare each value pair
 * @return {Observable} An Observable of a single boolean value representing whether or not
 * the values emitted by both observables were equal in sequence.
 * @method sequenceEqual
 * @owner Observable
 */ function $a5d1a111eaafe481$var$sequenceEqual(compareTo, comparor) {
    return function(source) {
        return source.lift(new $a5d1a111eaafe481$var$SequenceEqualOperator(compareTo, comparor));
    };
}
module.exports.sequenceEqual = $a5d1a111eaafe481$var$sequenceEqual;
var $a5d1a111eaafe481$var$SequenceEqualOperator = function() {
    function SequenceEqualOperator(compareTo, comparor) {
        this.compareTo = compareTo;
        this.comparor = comparor;
    }
    SequenceEqualOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $a5d1a111eaafe481$var$SequenceEqualSubscriber(subscriber, this.compareTo, this.comparor));
    };
    return SequenceEqualOperator;
}();
module.exports.SequenceEqualOperator = $a5d1a111eaafe481$var$SequenceEqualOperator;
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $a5d1a111eaafe481$var$SequenceEqualSubscriber = function(_super) {
    $a5d1a111eaafe481$var$__extends(SequenceEqualSubscriber, _super);
    function SequenceEqualSubscriber(destination, compareTo, comparor) {
        _super.call(this, destination);
        this.compareTo = compareTo;
        this.comparor = comparor;
        this._a = [];
        this._b = [];
        this._oneComplete = false;
        this.add(compareTo.subscribe(new $a5d1a111eaafe481$var$SequenceEqualCompareToSubscriber(destination, this)));
    }
    SequenceEqualSubscriber.prototype._next = function(value) {
        if (this._oneComplete && this._b.length === 0) this.emit(false);
        else {
            this._a.push(value);
            this.checkValues();
        }
    };
    SequenceEqualSubscriber.prototype._complete = function() {
        if (this._oneComplete) this.emit(this._a.length === 0 && this._b.length === 0);
        else this._oneComplete = true;
    };
    SequenceEqualSubscriber.prototype.checkValues = function() {
        var _c = this, _a = _c._a, _b = _c._b, comparor = _c.comparor;
        while(_a.length > 0 && _b.length > 0){
            var a = _a.shift();
            var b = _b.shift();
            var areEqual = false;
            if (comparor) {
                areEqual = $5PCwK.tryCatch(comparor)(a, b);
                if (areEqual === $iZPYv.errorObject) this.destination.error($iZPYv.errorObject.e);
            } else areEqual = a === b;
            if (!areEqual) this.emit(false);
        }
    };
    SequenceEqualSubscriber.prototype.emit = function(value) {
        var destination = this.destination;
        destination.next(value);
        destination.complete();
    };
    SequenceEqualSubscriber.prototype.nextB = function(value) {
        if (this._oneComplete && this._a.length === 0) this.emit(false);
        else {
            this._b.push(value);
            this.checkValues();
        }
    };
    return SequenceEqualSubscriber;
}($ggvKU.Subscriber);
module.exports.SequenceEqualSubscriber = $a5d1a111eaafe481$var$SequenceEqualSubscriber;
var $a5d1a111eaafe481$var$SequenceEqualCompareToSubscriber = function(_super) {
    $a5d1a111eaafe481$var$__extends(SequenceEqualCompareToSubscriber, _super);
    function SequenceEqualCompareToSubscriber(destination, parent) {
        _super.call(this, destination);
        this.parent = parent;
    }
    SequenceEqualCompareToSubscriber.prototype._next = function(value) {
        this.parent.nextB(value);
    };
    SequenceEqualCompareToSubscriber.prototype._error = function(err) {
        this.parent.error(err);
    };
    SequenceEqualCompareToSubscriber.prototype._complete = function() {
        this.parent._complete();
    };
    return SequenceEqualCompareToSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("cmzwd", function(module, exports) {

$parcel$export(module.exports, "shareReplay", () => $90031758facaa8d9$export$db61d692014e534e, (v) => $90031758facaa8d9$export$db61d692014e534e = v);
var $90031758facaa8d9$export$db61d692014e534e;
"use strict";

var $dZ0DN = parcelRequire("dZ0DN");
/**
 * @method shareReplay
 * @owner Observable
 */ function $90031758facaa8d9$var$shareReplay(bufferSize, windowTime, scheduler) {
    return function(source) {
        return source.lift($90031758facaa8d9$var$shareReplayOperator(bufferSize, windowTime, scheduler));
    };
}
$90031758facaa8d9$export$db61d692014e534e = $90031758facaa8d9$var$shareReplay;
function $90031758facaa8d9$var$shareReplayOperator(bufferSize, windowTime, scheduler) {
    var subject;
    var refCount = 0;
    var subscription;
    var hasError = false;
    var isComplete = false;
    return function shareReplayOperation(source) {
        refCount++;
        if (!subject || hasError) {
            hasError = false;
            subject = new $dZ0DN.ReplaySubject(bufferSize, windowTime, scheduler);
            subscription = source.subscribe({
                next: function(value) {
                    subject.next(value);
                },
                error: function(err) {
                    hasError = true;
                    subject.error(err);
                },
                complete: function() {
                    isComplete = true;
                    subject.complete();
                }
            });
        }
        var innerSub = subject.subscribe(this);
        return function() {
            refCount--;
            innerSub.unsubscribe();
            if (subscription && refCount === 0 && isComplete) subscription.unsubscribe();
        };
    };
}

});

parcelRegister("8n116", function(module, exports) {
"use strict";
var $6181429aead68e3f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $bZBGW = parcelRequire("bZBGW");
/**
 * Returns an Observable that emits the single item emitted by the source Observable that matches a specified
 * predicate, if that Observable emits one such item. If the source Observable emits more than one such item or no
 * such items, notify of an IllegalArgumentException or NoSuchElementException respectively.
 *
 * <img src="./img/single.png" width="100%">
 *
 * @throws {EmptyError} Delivers an EmptyError to the Observer's `error`
 * callback if the Observable completes before any `next` notification was sent.
 * @param {Function} predicate - A predicate function to evaluate items emitted by the source Observable.
 * @return {Observable<T>} An Observable that emits the single item emitted by the source Observable that matches
 * the predicate.
 .
 * @method single
 * @owner Observable
 */ function $6181429aead68e3f$var$single(predicate) {
    return function(source) {
        return source.lift(new $6181429aead68e3f$var$SingleOperator(predicate, source));
    };
}
module.exports.single = $6181429aead68e3f$var$single;
var $6181429aead68e3f$var$SingleOperator = function() {
    function SingleOperator(predicate, source) {
        this.predicate = predicate;
        this.source = source;
    }
    SingleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6181429aead68e3f$var$SingleSubscriber(subscriber, this.predicate, this.source));
    };
    return SingleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6181429aead68e3f$var$SingleSubscriber = function(_super) {
    $6181429aead68e3f$var$__extends(SingleSubscriber, _super);
    function SingleSubscriber(destination, predicate, source) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.source = source;
        this.seenValue = false;
        this.index = 0;
    }
    SingleSubscriber.prototype.applySingleValue = function(value) {
        if (this.seenValue) this.destination.error('Sequence contains more than one element');
        else {
            this.seenValue = true;
            this.singleValue = value;
        }
    };
    SingleSubscriber.prototype._next = function(value) {
        var index = this.index++;
        if (this.predicate) this.tryNext(value, index);
        else this.applySingleValue(value);
    };
    SingleSubscriber.prototype.tryNext = function(value, index) {
        try {
            if (this.predicate(value, index, this.source)) this.applySingleValue(value);
        } catch (err) {
            this.destination.error(err);
        }
    };
    SingleSubscriber.prototype._complete = function() {
        var destination = this.destination;
        if (this.index > 0) {
            destination.next(this.seenValue ? this.singleValue : undefined);
            destination.complete();
        } else destination.error(new $bZBGW.EmptyError);
    };
    return SingleSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("eDK1x", function(module, exports) {
"use strict";
var $aa88688eacca56e4$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $cRqdv = parcelRequire("cRqdv");
/**
 * Skip the last `count` values emitted by the source Observable.
 *
 * <img src="./img/skipLast.png" width="100%">
 *
 * `skipLast` returns an Observable that accumulates a queue with a length
 * enough to store the first `count` values. As more values are received,
 * values are taken from the front of the queue and produced on the result
 * sequence. This causes values to be delayed.
 *
 * @example <caption>Skip the last 2 values of an Observable with many values</caption>
 * var many = Rx.Observable.range(1, 5);
 * var skipLastTwo = many.skipLast(2);
 * skipLastTwo.subscribe(x => console.log(x));
 *
 * // Results in:
 * // 1 2 3
 *
 * @see {@link skip}
 * @see {@link skipUntil}
 * @see {@link skipWhile}
 * @see {@link take}
 *
 * @throws {ArgumentOutOfRangeError} When using `skipLast(i)`, it throws
 * ArgumentOutOrRangeError if `i < 0`.
 *
 * @param {number} count Number of elements to skip from the end of the source Observable.
 * @returns {Observable<T>} An Observable that skips the last count values
 * emitted by the source Observable.
 * @method skipLast
 * @owner Observable
 */ function $aa88688eacca56e4$var$skipLast(count) {
    return function(source) {
        return source.lift(new $aa88688eacca56e4$var$SkipLastOperator(count));
    };
}
module.exports.skipLast = $aa88688eacca56e4$var$skipLast;
var $aa88688eacca56e4$var$SkipLastOperator = function() {
    function SkipLastOperator(_skipCount) {
        this._skipCount = _skipCount;
        if (this._skipCount < 0) throw new $cRqdv.ArgumentOutOfRangeError;
    }
    SkipLastOperator.prototype.call = function(subscriber, source) {
        if (this._skipCount === 0) // If we don't want to skip any values then just subscribe
        // to Subscriber without any further logic.
        return source.subscribe(new $ggvKU.Subscriber(subscriber));
        else return source.subscribe(new $aa88688eacca56e4$var$SkipLastSubscriber(subscriber, this._skipCount));
    };
    return SkipLastOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $aa88688eacca56e4$var$SkipLastSubscriber = function(_super) {
    $aa88688eacca56e4$var$__extends(SkipLastSubscriber, _super);
    function SkipLastSubscriber(destination, _skipCount) {
        _super.call(this, destination);
        this._skipCount = _skipCount;
        this._count = 0;
        this._ring = new Array(_skipCount);
    }
    SkipLastSubscriber.prototype._next = function(value) {
        var skipCount = this._skipCount;
        var count = this._count++;
        if (count < skipCount) this._ring[count] = value;
        else {
            var currentIndex = count % skipCount;
            var ring = this._ring;
            var oldValue = ring[currentIndex];
            ring[currentIndex] = value;
            this.destination.next(oldValue);
        }
    };
    return SkipLastSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("eZ5AN", function(module, exports) {
"use strict";
var $ae8b19bf9da600d2$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Returns an Observable that skips items emitted by the source Observable until a second Observable emits an item.
 *
 * <img src="./img/skipUntil.png" width="100%">
 *
 * @param {Observable} notifier - The second Observable that has to emit an item before the source Observable's elements begin to
 * be mirrored by the resulting Observable.
 * @return {Observable<T>} An Observable that skips items from the source Observable until the second Observable emits
 * an item, then emits the remaining items.
 * @method skipUntil
 * @owner Observable
 */ function $ae8b19bf9da600d2$var$skipUntil(notifier) {
    return function(source) {
        return source.lift(new $ae8b19bf9da600d2$var$SkipUntilOperator(notifier));
    };
}
module.exports.skipUntil = $ae8b19bf9da600d2$var$skipUntil;
var $ae8b19bf9da600d2$var$SkipUntilOperator = function() {
    function SkipUntilOperator(notifier) {
        this.notifier = notifier;
    }
    SkipUntilOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $ae8b19bf9da600d2$var$SkipUntilSubscriber(subscriber, this.notifier));
    };
    return SkipUntilOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $ae8b19bf9da600d2$var$SkipUntilSubscriber = function(_super) {
    $ae8b19bf9da600d2$var$__extends(SkipUntilSubscriber, _super);
    function SkipUntilSubscriber(destination, notifier) {
        _super.call(this, destination);
        this.hasValue = false;
        this.isInnerStopped = false;
        this.add($558qb.subscribeToResult(this, notifier));
    }
    SkipUntilSubscriber.prototype._next = function(value) {
        if (this.hasValue) _super.prototype._next.call(this, value);
    };
    SkipUntilSubscriber.prototype._complete = function() {
        if (this.isInnerStopped) _super.prototype._complete.call(this);
        else this.unsubscribe();
    };
    SkipUntilSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.hasValue = true;
    };
    SkipUntilSubscriber.prototype.notifyComplete = function() {
        this.isInnerStopped = true;
        if (this.isStopped) _super.prototype._complete.call(this);
    };
    return SkipUntilSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("bLNAF", function(module, exports) {
"use strict";
var $891a8d1da4eedcb9$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");
/**
 * Returns an Observable that skips all items emitted by the source Observable as long as a specified condition holds
 * true, but emits all further source items as soon as the condition becomes false.
 *
 * <img src="./img/skipWhile.png" width="100%">
 *
 * @param {Function} predicate - A function to test each item emitted from the source Observable.
 * @return {Observable<T>} An Observable that begins emitting items emitted by the source Observable when the
 * specified predicate becomes false.
 * @method skipWhile
 * @owner Observable
 */ function $891a8d1da4eedcb9$var$skipWhile(predicate) {
    return function(source) {
        return source.lift(new $891a8d1da4eedcb9$var$SkipWhileOperator(predicate));
    };
}
module.exports.skipWhile = $891a8d1da4eedcb9$var$skipWhile;
var $891a8d1da4eedcb9$var$SkipWhileOperator = function() {
    function SkipWhileOperator(predicate) {
        this.predicate = predicate;
    }
    SkipWhileOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $891a8d1da4eedcb9$var$SkipWhileSubscriber(subscriber, this.predicate));
    };
    return SkipWhileOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $891a8d1da4eedcb9$var$SkipWhileSubscriber = function(_super) {
    $891a8d1da4eedcb9$var$__extends(SkipWhileSubscriber, _super);
    function SkipWhileSubscriber(destination, predicate) {
        _super.call(this, destination);
        this.predicate = predicate;
        this.skipping = true;
        this.index = 0;
    }
    SkipWhileSubscriber.prototype._next = function(value) {
        var destination = this.destination;
        if (this.skipping) this.tryCallPredicate(value);
        if (!this.skipping) destination.next(value);
    };
    SkipWhileSubscriber.prototype.tryCallPredicate = function(value) {
        try {
            var result = this.predicate(value, this.index++);
            this.skipping = Boolean(result);
        } catch (err) {
            this.destination.error(err);
        }
    };
    return SkipWhileSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("2GSzx", function(module, exports) {

$parcel$export(module.exports, "switchAll", () => $1f59d5e853eec281$export$6a45284a4b0bf33a, (v) => $1f59d5e853eec281$export$6a45284a4b0bf33a = v);
var $1f59d5e853eec281$export$6a45284a4b0bf33a;
"use strict";

var $jEfnV = parcelRequire("jEfnV");

var $4v1QD = parcelRequire("4v1QD");
function $1f59d5e853eec281$var$switchAll() {
    return $jEfnV.switchMap($4v1QD.identity);
}
$1f59d5e853eec281$export$6a45284a4b0bf33a = $1f59d5e853eec281$var$switchAll;

});

parcelRegister("cvLsC", function(module, exports) {
"use strict";
var $91bd31fba290f269$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $hSQIY = parcelRequire("hSQIY");
function $91bd31fba290f269$var$timeInterval(scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return function(source) {
        return source.lift(new $91bd31fba290f269$var$TimeIntervalOperator(scheduler));
    };
}
module.exports.timeInterval = $91bd31fba290f269$var$timeInterval;
var $91bd31fba290f269$var$TimeInterval = function() {
    function TimeInterval(value, interval) {
        this.value = value;
        this.interval = interval;
    }
    return TimeInterval;
}();
module.exports.TimeInterval = $91bd31fba290f269$var$TimeInterval;
var $91bd31fba290f269$var$TimeIntervalOperator = function() {
    function TimeIntervalOperator(scheduler) {
        this.scheduler = scheduler;
    }
    TimeIntervalOperator.prototype.call = function(observer, source) {
        return source.subscribe(new $91bd31fba290f269$var$TimeIntervalSubscriber(observer, this.scheduler));
    };
    return TimeIntervalOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $91bd31fba290f269$var$TimeIntervalSubscriber = function(_super) {
    $91bd31fba290f269$var$__extends(TimeIntervalSubscriber, _super);
    function TimeIntervalSubscriber(destination, scheduler) {
        _super.call(this, destination);
        this.scheduler = scheduler;
        this.lastTime = 0;
        this.lastTime = scheduler.now();
    }
    TimeIntervalSubscriber.prototype._next = function(value) {
        var now = this.scheduler.now();
        var span = now - this.lastTime;
        this.lastTime = now;
        this.destination.next(new $91bd31fba290f269$var$TimeInterval(value, span));
    };
    return TimeIntervalSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("imafm", function(module, exports) {
"use strict";
var $d5d23adf7cd1097c$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hSQIY = parcelRequire("hSQIY");

var $3Oax8 = parcelRequire("3Oax8");

var $ggvKU = parcelRequire("ggvKU");

var $wboEv = parcelRequire("wboEv");
/**
 *
 * Errors if Observable does not emit a value in given time span.
 *
 * <span class="informal">Timeouts on Observable that doesn't emit values fast enough.</span>
 *
 * <img src="./img/timeout.png" width="100%">
 *
 * `timeout` operator accepts as an argument either a number or a Date.
 *
 * If number was provided, it returns an Observable that behaves like a source
 * Observable, unless there is a period of time where there is no value emitted.
 * So if you provide `100` as argument and first value comes after 50ms from
 * the moment of subscription, this value will be simply re-emitted by the resulting
 * Observable. If however after that 100ms passes without a second value being emitted,
 * stream will end with an error and source Observable will be unsubscribed.
 * These checks are performed throughout whole lifecycle of Observable - from the moment
 * it was subscribed to, until it completes or errors itself. Thus every value must be
 * emitted within specified period since previous value.
 *
 * If provided argument was Date, returned Observable behaves differently. It throws
 * if Observable did not complete before provided Date. This means that periods between
 * emission of particular values do not matter in this case. If Observable did not complete
 * before provided Date, source Observable will be unsubscribed. Other than that, resulting
 * stream behaves just as source Observable.
 *
 * `timeout` accepts also a Scheduler as a second parameter. It is used to schedule moment (or moments)
 * when returned Observable will check if source stream emitted value or completed.
 *
 * @example <caption>Check if ticks are emitted within certain timespan</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(1100) // Let's use bigger timespan to be safe,
 *                       // since `interval` might fire a bit later then scheduled.
 * .subscribe(
 *     value => console.log(value), // Will emit numbers just as regular `interval` would.
 *     err => console.log(err) // Will never be called.
 * );
 *
 * seconds.timeout(900).subscribe(
 *     value => console.log(value), // Will never be called.
 *     err => console.log(err) // Will emit error before even first value is emitted,
 *                             // since it did not arrive within 900ms period.
 * );
 *
 * @example <caption>Use Date to check if Observable completed</caption>
 * const seconds = Rx.Observable.interval(1000);
 *
 * seconds.timeout(new Date("December 17, 2020 03:24:00"))
 * .subscribe(
 *     value => console.log(value), // Will emit values as regular `interval` would
 *                                  // until December 17, 2020 at 03:24:00.
 *     err => console.log(err) // On December 17, 2020 at 03:24:00 it will emit an error,
 *                             // since Observable did not complete by then.
 * );
 *
 * @see {@link timeoutWith}
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source, unless timeout checks fail.
 * @method timeout
 * @owner Observable
 */ function $d5d23adf7cd1097c$var$timeout(due, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    var absoluteTimeout = $3Oax8.isDate(due);
    var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
    return function(source) {
        return source.lift(new $d5d23adf7cd1097c$var$TimeoutOperator(waitFor, absoluteTimeout, scheduler, new $wboEv.TimeoutError()));
    };
}
module.exports.timeout = $d5d23adf7cd1097c$var$timeout;
var $d5d23adf7cd1097c$var$TimeoutOperator = function() {
    function TimeoutOperator(waitFor, absoluteTimeout, scheduler, errorInstance) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
    }
    TimeoutOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $d5d23adf7cd1097c$var$TimeoutSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.scheduler, this.errorInstance));
    };
    return TimeoutOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $d5d23adf7cd1097c$var$TimeoutSubscriber = function(_super) {
    $d5d23adf7cd1097c$var$__extends(TimeoutSubscriber, _super);
    function TimeoutSubscriber(destination, absoluteTimeout, waitFor, scheduler, errorInstance) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.scheduler = scheduler;
        this.errorInstance = errorInstance;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutSubscriber.dispatchTimeout = function(subscriber) {
        subscriber.error(subscriber.errorInstance);
    };
    TimeoutSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.errorInstance = null;
    };
    return TimeoutSubscriber;
}($ggvKU.Subscriber);

});
parcelRegister("wboEv", function(module, exports) {
"use strict";
var $060bd46798dfd391$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
/**
 * An error thrown when duetime elapses.
 *
 * @see {@link timeout}
 *
 * @class TimeoutError
 */ var $060bd46798dfd391$var$TimeoutError = function(_super) {
    $060bd46798dfd391$var$__extends(TimeoutError, _super);
    function TimeoutError() {
        var err = _super.call(this, 'Timeout has occurred');
        this.name = err.name = 'TimeoutError';
        this.stack = err.stack;
        this.message = err.message;
    }
    return TimeoutError;
}(Error);
module.exports.TimeoutError = $060bd46798dfd391$var$TimeoutError;

});


parcelRegister("aWA2c", function(module, exports) {
"use strict";
var $7f7b45db3fbc039d$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $hSQIY = parcelRequire("hSQIY");

var $3Oax8 = parcelRequire("3Oax8");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/* tslint:enable:max-line-length */ /**
 *
 * Errors if Observable does not emit a value in given time span, in case of which
 * subscribes to the second Observable.
 *
 * <span class="informal">It's a version of `timeout` operator that let's you specify fallback Observable.</span>
 *
 * <img src="./img/timeoutWith.png" width="100%">
 *
 * `timeoutWith` is a variation of `timeout` operator. It behaves exactly the same,
 * still accepting as a first argument either a number or a Date, which control - respectively -
 * when values of source Observable should be emitted or when it should complete.
 *
 * The only difference is that it accepts a second, required parameter. This parameter
 * should be an Observable which will be subscribed when source Observable fails any timeout check.
 * So whenever regular `timeout` would emit an error, `timeoutWith` will instead start re-emitting
 * values from second Observable. Note that this fallback Observable is not checked for timeouts
 * itself, so it can emit values and complete at arbitrary points in time. From the moment of a second
 * subscription, Observable returned from `timeoutWith` simply mirrors fallback stream. When that
 * stream completes, it completes as well.
 *
 * Scheduler, which in case of `timeout` is provided as as second argument, can be still provided
 * here - as a third, optional parameter. It still is used to schedule timeout checks and -
 * as a consequence - when second Observable will be subscribed, since subscription happens
 * immediately after failing check.
 *
 * @example <caption>Add fallback observable</caption>
 * const seconds = Rx.Observable.interval(1000);
 * const minutes = Rx.Observable.interval(60 * 1000);
 *
 * seconds.timeoutWith(900, minutes)
 *     .subscribe(
 *         value => console.log(value), // After 900ms, will start emitting `minutes`,
 *                                      // since first value of `seconds` will not arrive fast enough.
 *         err => console.log(err) // Would be called after 900ms in case of `timeout`,
 *                                 // but here will never be called.
 *     );
 *
 * @param {number|Date} due Number specifying period within which Observable must emit values
 *                          or Date specifying before when Observable should complete
 * @param {Observable<T>} withObservable Observable which will be subscribed if source fails timeout check.
 * @param {Scheduler} [scheduler] Scheduler controlling when timeout checks occur.
 * @return {Observable<T>} Observable that mirrors behaviour of source or, when timeout check fails, of an Observable
 *                          passed as a second parameter.
 * @method timeoutWith
 * @owner Observable
 */ function $7f7b45db3fbc039d$var$timeoutWith(due, withObservable, scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return function(source) {
        var absoluteTimeout = $3Oax8.isDate(due);
        var waitFor = absoluteTimeout ? +due - scheduler.now() : Math.abs(due);
        return source.lift(new $7f7b45db3fbc039d$var$TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler));
    };
}
module.exports.timeoutWith = $7f7b45db3fbc039d$var$timeoutWith;
var $7f7b45db3fbc039d$var$TimeoutWithOperator = function() {
    function TimeoutWithOperator(waitFor, absoluteTimeout, withObservable, scheduler) {
        this.waitFor = waitFor;
        this.absoluteTimeout = absoluteTimeout;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
    }
    TimeoutWithOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $7f7b45db3fbc039d$var$TimeoutWithSubscriber(subscriber, this.absoluteTimeout, this.waitFor, this.withObservable, this.scheduler));
    };
    return TimeoutWithOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $7f7b45db3fbc039d$var$TimeoutWithSubscriber = function(_super) {
    $7f7b45db3fbc039d$var$__extends(TimeoutWithSubscriber, _super);
    function TimeoutWithSubscriber(destination, absoluteTimeout, waitFor, withObservable, scheduler) {
        _super.call(this, destination);
        this.absoluteTimeout = absoluteTimeout;
        this.waitFor = waitFor;
        this.withObservable = withObservable;
        this.scheduler = scheduler;
        this.action = null;
        this.scheduleTimeout();
    }
    TimeoutWithSubscriber.dispatchTimeout = function(subscriber) {
        var withObservable = subscriber.withObservable;
        subscriber._unsubscribeAndRecycle();
        subscriber.add($558qb.subscribeToResult(subscriber, withObservable));
    };
    TimeoutWithSubscriber.prototype.scheduleTimeout = function() {
        var action = this.action;
        if (action) // Recycle the action if we've already scheduled one. All the production
        // Scheduler Actions mutate their state/delay time and return themeselves.
        // VirtualActions are immutable, so they create and return a clone. In this
        // case, we need to set the action reference to the most recent VirtualAction,
        // to ensure that's the one we clone from next time.
        this.action = action.schedule(this, this.waitFor);
        else this.add(this.action = this.scheduler.schedule(TimeoutWithSubscriber.dispatchTimeout, this.waitFor, this));
    };
    TimeoutWithSubscriber.prototype._next = function(value) {
        if (!this.absoluteTimeout) this.scheduleTimeout();
        _super.prototype._next.call(this, value);
    };
    /** @deprecated internal use only */ TimeoutWithSubscriber.prototype._unsubscribe = function() {
        this.action = null;
        this.scheduler = null;
        this.withObservable = null;
    };
    return TimeoutWithSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("21QZF", function(module, exports) {
"use strict";

var $hSQIY = parcelRequire("hSQIY");

var $cVFxd = parcelRequire("cVFxd");
/**
 * @param scheduler
 * @return {Observable<Timestamp<any>>|WebSocketSubject<T>|Observable<T>}
 * @method timestamp
 * @owner Observable
 */ function timestamp(scheduler) {
    if (scheduler === void 0) scheduler = $hSQIY.async;
    return $cVFxd.map(function(value) {
        return new Timestamp(value, scheduler.now());
    });
// return (source: Observable<T>) => source.lift(new TimestampOperator(scheduler));
}
exports.timestamp = timestamp;
var Timestamp = function() {
    function Timestamp(value, timestamp) {
        this.value = value;
        this.timestamp = timestamp;
    }
    return Timestamp;
}();
exports.Timestamp = Timestamp;

});

parcelRegister("1e4sA", function(module, exports) {
"use strict";
var $0e4a8eee8029db54$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $ggvKU = parcelRequire("ggvKU");

var $cab1K = parcelRequire("cab1K");
/**
 * Branch out the source Observable values as a nested Observable with each
 * nested Observable emitting at most `windowSize` values.
 *
 * <span class="informal">It's like {@link bufferCount}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowCount.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows every `startWindowEvery`
 * items, each containing no more than `windowSize` items. When the source
 * Observable completes or encounters an error, the output Observable emits
 * the current window and propagates the notification from the source
 * Observable. If `startWindowEvery` is not provided, then new windows are
 * started immediately at the start of the source and when each window completes
 * with size `windowSize`.
 *
 * @example <caption>Ignore every 3rd click event, starting from the first one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(3)
 *   .map(win => win.skip(1)) // skip first of every 3 clicks
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @example <caption>Ignore every 3rd click event, starting from the third one</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks.windowCount(2, 3)
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link windowWhen}
 * @see {@link bufferCount}
 *
 * @param {number} windowSize The maximum number of values emitted by each
 * window.
 * @param {number} [startWindowEvery] Interval at which to start a new window.
 * For example if `startWindowEvery` is `2`, then a new window will be started
 * on every other value from the source. A new window is started at the
 * beginning of the source by default.
 * @return {Observable<Observable<T>>} An Observable of windows, which in turn
 * are Observable of values.
 * @method windowCount
 * @owner Observable
 */ function $0e4a8eee8029db54$var$windowCount(windowSize, startWindowEvery) {
    if (startWindowEvery === void 0) startWindowEvery = 0;
    return function windowCountOperatorFunction(source) {
        return source.lift(new $0e4a8eee8029db54$var$WindowCountOperator(windowSize, startWindowEvery));
    };
}
module.exports.windowCount = $0e4a8eee8029db54$var$windowCount;
var $0e4a8eee8029db54$var$WindowCountOperator = function() {
    function WindowCountOperator(windowSize, startWindowEvery) {
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
    }
    WindowCountOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $0e4a8eee8029db54$var$WindowCountSubscriber(subscriber, this.windowSize, this.startWindowEvery));
    };
    return WindowCountOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $0e4a8eee8029db54$var$WindowCountSubscriber = function(_super) {
    $0e4a8eee8029db54$var$__extends(WindowCountSubscriber, _super);
    function WindowCountSubscriber(destination, windowSize, startWindowEvery) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowSize = windowSize;
        this.startWindowEvery = startWindowEvery;
        this.windows = [
            new $cab1K.Subject()
        ];
        this.count = 0;
        destination.next(this.windows[0]);
    }
    WindowCountSubscriber.prototype._next = function(value) {
        var startWindowEvery = this.startWindowEvery > 0 ? this.startWindowEvery : this.windowSize;
        var destination = this.destination;
        var windowSize = this.windowSize;
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len && !this.closed; i++)windows[i].next(value);
        var c = this.count - windowSize + 1;
        if (c >= 0 && c % startWindowEvery === 0 && !this.closed) windows.shift().complete();
        if (++this.count % startWindowEvery === 0 && !this.closed) {
            var window_1 = new $cab1K.Subject();
            windows.push(window_1);
            destination.next(window_1);
        }
    };
    WindowCountSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowCountSubscriber.prototype._complete = function() {
        var windows = this.windows;
        if (windows) while(windows.length > 0 && !this.closed)windows.shift().complete();
        this.destination.complete();
    };
    /** @deprecated internal use only */ WindowCountSubscriber.prototype._unsubscribe = function() {
        this.count = 0;
        this.windows = null;
    };
    return WindowCountSubscriber;
}($ggvKU.Subscriber);

});

parcelRegister("9nNIL", function(module, exports) {
"use strict";
var $6d4cd492ea733e7f$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $hSQIY = parcelRequire("hSQIY");

var $ggvKU = parcelRequire("ggvKU");

var $kKyYR = parcelRequire("kKyYR");

var $4zTe9 = parcelRequire("4zTe9");
function $6d4cd492ea733e7f$var$windowTime(windowTimeSpan) {
    var scheduler = $hSQIY.async;
    var windowCreationInterval = null;
    var maxWindowSize = Number.POSITIVE_INFINITY;
    if ($4zTe9.isScheduler(arguments[3])) scheduler = arguments[3];
    if ($4zTe9.isScheduler(arguments[2])) scheduler = arguments[2];
    else if ($kKyYR.isNumeric(arguments[2])) maxWindowSize = arguments[2];
    if ($4zTe9.isScheduler(arguments[1])) scheduler = arguments[1];
    else if ($kKyYR.isNumeric(arguments[1])) windowCreationInterval = arguments[1];
    return function windowTimeOperatorFunction(source) {
        return source.lift(new $6d4cd492ea733e7f$var$WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler));
    };
}
module.exports.windowTime = $6d4cd492ea733e7f$var$windowTime;
var $6d4cd492ea733e7f$var$WindowTimeOperator = function() {
    function WindowTimeOperator(windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
    }
    WindowTimeOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $6d4cd492ea733e7f$var$WindowTimeSubscriber(subscriber, this.windowTimeSpan, this.windowCreationInterval, this.maxWindowSize, this.scheduler));
    };
    return WindowTimeOperator;
}();
var $6d4cd492ea733e7f$var$CountedSubject = function(_super) {
    $6d4cd492ea733e7f$var$__extends(CountedSubject, _super);
    function CountedSubject() {
        _super.apply(this, arguments);
        this._numberOfNextedValues = 0;
    }
    CountedSubject.prototype.next = function(value) {
        this._numberOfNextedValues++;
        _super.prototype.next.call(this, value);
    };
    Object.defineProperty(CountedSubject.prototype, "numberOfNextedValues", {
        get: function() {
            return this._numberOfNextedValues;
        },
        enumerable: true,
        configurable: true
    });
    return CountedSubject;
}($cab1K.Subject);
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $6d4cd492ea733e7f$var$WindowTimeSubscriber = function(_super) {
    $6d4cd492ea733e7f$var$__extends(WindowTimeSubscriber, _super);
    function WindowTimeSubscriber(destination, windowTimeSpan, windowCreationInterval, maxWindowSize, scheduler) {
        _super.call(this, destination);
        this.destination = destination;
        this.windowTimeSpan = windowTimeSpan;
        this.windowCreationInterval = windowCreationInterval;
        this.maxWindowSize = maxWindowSize;
        this.scheduler = scheduler;
        this.windows = [];
        var window = this.openWindow();
        if (windowCreationInterval !== null && windowCreationInterval >= 0) {
            var closeState = {
                subscriber: this,
                window: window,
                context: null
            };
            var creationState = {
                windowTimeSpan: windowTimeSpan,
                windowCreationInterval: windowCreationInterval,
                subscriber: this,
                scheduler: scheduler
            };
            this.add(scheduler.schedule($6d4cd492ea733e7f$var$dispatchWindowClose, windowTimeSpan, closeState));
            this.add(scheduler.schedule($6d4cd492ea733e7f$var$dispatchWindowCreation, windowCreationInterval, creationState));
        } else {
            var timeSpanOnlyState = {
                subscriber: this,
                window: window,
                windowTimeSpan: windowTimeSpan
            };
            this.add(scheduler.schedule($6d4cd492ea733e7f$var$dispatchWindowTimeSpanOnly, windowTimeSpan, timeSpanOnlyState));
        }
    }
    WindowTimeSubscriber.prototype._next = function(value) {
        var windows = this.windows;
        var len = windows.length;
        for(var i = 0; i < len; i++){
            var window_1 = windows[i];
            if (!window_1.closed) {
                window_1.next(value);
                if (window_1.numberOfNextedValues >= this.maxWindowSize) this.closeWindow(window_1);
            }
        }
    };
    WindowTimeSubscriber.prototype._error = function(err) {
        var windows = this.windows;
        while(windows.length > 0)windows.shift().error(err);
        this.destination.error(err);
    };
    WindowTimeSubscriber.prototype._complete = function() {
        var windows = this.windows;
        while(windows.length > 0){
            var window_2 = windows.shift();
            if (!window_2.closed) window_2.complete();
        }
        this.destination.complete();
    };
    WindowTimeSubscriber.prototype.openWindow = function() {
        var window = new $6d4cd492ea733e7f$var$CountedSubject();
        this.windows.push(window);
        var destination = this.destination;
        destination.next(window);
        return window;
    };
    WindowTimeSubscriber.prototype.closeWindow = function(window) {
        window.complete();
        var windows = this.windows;
        windows.splice(windows.indexOf(window), 1);
    };
    return WindowTimeSubscriber;
}($ggvKU.Subscriber);
function $6d4cd492ea733e7f$var$dispatchWindowTimeSpanOnly(state) {
    var subscriber = state.subscriber, windowTimeSpan = state.windowTimeSpan, window = state.window;
    if (window) subscriber.closeWindow(window);
    state.window = subscriber.openWindow();
    this.schedule(state, windowTimeSpan);
}
function $6d4cd492ea733e7f$var$dispatchWindowCreation(state) {
    var windowTimeSpan = state.windowTimeSpan, subscriber = state.subscriber, scheduler = state.scheduler, windowCreationInterval = state.windowCreationInterval;
    var window = subscriber.openWindow();
    var action = this;
    var context = {
        action: action,
        subscription: null
    };
    var timeSpanState = {
        subscriber: subscriber,
        window: window,
        context: context
    };
    context.subscription = scheduler.schedule($6d4cd492ea733e7f$var$dispatchWindowClose, windowTimeSpan, timeSpanState);
    action.add(context.subscription);
    action.schedule(state, windowCreationInterval);
}
function $6d4cd492ea733e7f$var$dispatchWindowClose(state) {
    var subscriber = state.subscriber, window = state.window, context = state.context;
    if (context && context.action && context.subscription) context.action.remove(context.subscription);
    subscriber.closeWindow(window);
}

});

parcelRegister("d327T", function(module, exports) {
"use strict";
var $97fd34677c87a2d0$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $aZdZn = parcelRequire("aZdZn");

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Branch out the source Observable values as a nested Observable starting from
 * an emission from `openings` and ending when the output of `closingSelector`
 * emits.
 *
 * <span class="informal">It's like {@link bufferToggle}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowToggle.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits windows that contain those items
 * emitted by the source Observable between the time when the `openings`
 * Observable emits an item and when the Observable returned by
 * `closingSelector` emits an item.
 *
 * @example <caption>Every other second, emit the click events from the next 500ms</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var openings = Rx.Observable.interval(1000);
 * var result = clicks.windowToggle(openings, i =>
 *   i % 2 ? Rx.Observable.interval(500) : Rx.Observable.empty()
 * ).mergeAll();
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowWhen}
 * @see {@link bufferToggle}
 *
 * @param {Observable<O>} openings An observable of notifications to start new
 * windows.
 * @param {function(value: O): Observable} closingSelector A function that takes
 * the value emitted by the `openings` observable and returns an Observable,
 * which, when it emits (either `next` or `complete`), signals that the
 * associated window should complete.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowToggle
 * @owner Observable
 */ function $97fd34677c87a2d0$var$windowToggle(openings, closingSelector) {
    return function(source) {
        return source.lift(new $97fd34677c87a2d0$var$WindowToggleOperator(openings, closingSelector));
    };
}
module.exports.windowToggle = $97fd34677c87a2d0$var$windowToggle;
var $97fd34677c87a2d0$var$WindowToggleOperator = function() {
    function WindowToggleOperator(openings, closingSelector) {
        this.openings = openings;
        this.closingSelector = closingSelector;
    }
    WindowToggleOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $97fd34677c87a2d0$var$WindowToggleSubscriber(subscriber, this.openings, this.closingSelector));
    };
    return WindowToggleOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $97fd34677c87a2d0$var$WindowToggleSubscriber = function(_super) {
    $97fd34677c87a2d0$var$__extends(WindowToggleSubscriber, _super);
    function WindowToggleSubscriber(destination, openings, closingSelector) {
        _super.call(this, destination);
        this.openings = openings;
        this.closingSelector = closingSelector;
        this.contexts = [];
        this.add(this.openSubscription = $558qb.subscribeToResult(this, openings, openings));
    }
    WindowToggleSubscriber.prototype._next = function(value) {
        var contexts = this.contexts;
        if (contexts) {
            var len = contexts.length;
            for(var i = 0; i < len; i++)contexts[i].window.next(value);
        }
    };
    WindowToggleSubscriber.prototype._error = function(err) {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.error(err);
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._error.call(this, err);
    };
    WindowToggleSubscriber.prototype._complete = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.complete();
                context.subscription.unsubscribe();
            }
        }
        _super.prototype._complete.call(this);
    };
    /** @deprecated internal use only */ WindowToggleSubscriber.prototype._unsubscribe = function() {
        var contexts = this.contexts;
        this.contexts = null;
        if (contexts) {
            var len = contexts.length;
            var index = -1;
            while(++index < len){
                var context = contexts[index];
                context.window.unsubscribe();
                context.subscription.unsubscribe();
            }
        }
    };
    WindowToggleSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        if (outerValue === this.openings) {
            var closingSelector = this.closingSelector;
            var closingNotifier = $5PCwK.tryCatch(closingSelector)(innerValue);
            if (closingNotifier === $iZPYv.errorObject) return this.error($iZPYv.errorObject.e);
            else {
                var window_1 = new $cab1K.Subject();
                var subscription = new $aZdZn.Subscription();
                var context = {
                    window: window_1,
                    subscription: subscription
                };
                this.contexts.push(context);
                var innerSubscription = $558qb.subscribeToResult(this, closingNotifier, context);
                if (innerSubscription.closed) this.closeWindow(this.contexts.length - 1);
                else {
                    innerSubscription.context = context;
                    subscription.add(innerSubscription);
                }
                this.destination.next(window_1);
            }
        } else this.closeWindow(this.contexts.indexOf(outerValue));
    };
    WindowToggleSubscriber.prototype.notifyError = function(err) {
        this.error(err);
    };
    WindowToggleSubscriber.prototype.notifyComplete = function(inner) {
        if (inner !== this.openSubscription) this.closeWindow(this.contexts.indexOf(inner.context));
    };
    WindowToggleSubscriber.prototype.closeWindow = function(index) {
        if (index === -1) return;
        var contexts = this.contexts;
        var context = contexts[index];
        var window = context.window, subscription = context.subscription;
        contexts.splice(index, 1);
        window.complete();
        subscription.unsubscribe();
    };
    return WindowToggleSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("2evIr", function(module, exports) {
"use strict";
var $1a057dae5e829efd$var$__extends = module.exports && module.exports.__extends || function(d, b) {
    for(var p in b)if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};

var $cab1K = parcelRequire("cab1K");

var $5PCwK = parcelRequire("5PCwK");

var $iZPYv = parcelRequire("iZPYv");

var $RlQRN = parcelRequire("RlQRN");

var $558qb = parcelRequire("558qb");
/**
 * Branch out the source Observable values as a nested Observable using a
 * factory function of closing Observables to determine when to start a new
 * window.
 *
 * <span class="informal">It's like {@link bufferWhen}, but emits a nested
 * Observable instead of an array.</span>
 *
 * <img src="./img/windowWhen.png" width="100%">
 *
 * Returns an Observable that emits windows of items it collects from the source
 * Observable. The output Observable emits connected, non-overlapping windows.
 * It emits the current window and opens a new one whenever the Observable
 * produced by the specified `closingSelector` function emits an item. The first
 * window is opened immediately when subscribing to the output Observable.
 *
 * @example <caption>Emit only the first two clicks events in every window of [1-5] random seconds</caption>
 * var clicks = Rx.Observable.fromEvent(document, 'click');
 * var result = clicks
 *   .windowWhen(() => Rx.Observable.interval(1000 + Math.random() * 4000))
 *   .map(win => win.take(2)) // each window has at most 2 emissions
 *   .mergeAll(); // flatten the Observable-of-Observables
 * result.subscribe(x => console.log(x));
 *
 * @see {@link window}
 * @see {@link windowCount}
 * @see {@link windowTime}
 * @see {@link windowToggle}
 * @see {@link bufferWhen}
 *
 * @param {function(): Observable} closingSelector A function that takes no
 * arguments and returns an Observable that signals (on either `next` or
 * `complete`) when to close the previous window and start a new one.
 * @return {Observable<Observable<T>>} An observable of windows, which in turn
 * are Observables.
 * @method windowWhen
 * @owner Observable
 */ function $1a057dae5e829efd$var$windowWhen(closingSelector) {
    return function windowWhenOperatorFunction(source) {
        return source.lift(new $1a057dae5e829efd$var$WindowOperator(closingSelector));
    };
}
module.exports.windowWhen = $1a057dae5e829efd$var$windowWhen;
var $1a057dae5e829efd$var$WindowOperator = function() {
    function WindowOperator(closingSelector) {
        this.closingSelector = closingSelector;
    }
    WindowOperator.prototype.call = function(subscriber, source) {
        return source.subscribe(new $1a057dae5e829efd$var$WindowSubscriber(subscriber, this.closingSelector));
    };
    return WindowOperator;
}();
/**
 * We need this JSDoc comment for affecting ESDoc.
 * @ignore
 * @extends {Ignored}
 */ var $1a057dae5e829efd$var$WindowSubscriber = function(_super) {
    $1a057dae5e829efd$var$__extends(WindowSubscriber, _super);
    function WindowSubscriber(destination, closingSelector) {
        _super.call(this, destination);
        this.destination = destination;
        this.closingSelector = closingSelector;
        this.openWindow();
    }
    WindowSubscriber.prototype.notifyNext = function(outerValue, innerValue, outerIndex, innerIndex, innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype.notifyError = function(error, innerSub) {
        this._error(error);
    };
    WindowSubscriber.prototype.notifyComplete = function(innerSub) {
        this.openWindow(innerSub);
    };
    WindowSubscriber.prototype._next = function(value) {
        this.window.next(value);
    };
    WindowSubscriber.prototype._error = function(err) {
        this.window.error(err);
        this.destination.error(err);
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype._complete = function() {
        this.window.complete();
        this.destination.complete();
        this.unsubscribeClosingNotification();
    };
    WindowSubscriber.prototype.unsubscribeClosingNotification = function() {
        if (this.closingNotification) this.closingNotification.unsubscribe();
    };
    WindowSubscriber.prototype.openWindow = function(innerSub) {
        if (innerSub === void 0) innerSub = null;
        if (innerSub) {
            this.remove(innerSub);
            innerSub.unsubscribe();
        }
        var prevWindow = this.window;
        if (prevWindow) prevWindow.complete();
        var window = this.window = new $cab1K.Subject();
        this.destination.next(window);
        var closingNotifier = $5PCwK.tryCatch(this.closingSelector)();
        if (closingNotifier === $iZPYv.errorObject) {
            var err = $iZPYv.errorObject.e;
            this.destination.error(err);
            this.window.error(err);
        } else this.add(this.closingNotification = $558qb.subscribeToResult(this, closingNotifier));
    };
    return WindowSubscriber;
}($RlQRN.OuterSubscriber);

});

parcelRegister("050GT", function(module, exports) {

$parcel$export(module.exports, "zipAll", () => $00f100e8dd191728$export$adddb6a2fa3864e9, (v) => $00f100e8dd191728$export$adddb6a2fa3864e9 = v);
var $00f100e8dd191728$export$adddb6a2fa3864e9;
"use strict";

var $cKFwQ = parcelRequire("cKFwQ");
function $00f100e8dd191728$var$zipAll(project) {
    return function(source) {
        return source.lift(new $cKFwQ.ZipOperator(project));
    };
}
$00f100e8dd191728$export$adddb6a2fa3864e9 = $00f100e8dd191728$var$zipAll;

});


parcelRegister("bdfJC", function(module, exports) {

$parcel$export(module.exports, "UPDATE_OLD_DONE_ISSUES_CUTOFF", () => $c5406e5925933ca6$export$74c8158e06b60b4f);
$parcel$export(module.exports, "updateOldDoneIssuesCutoffRequest", () => $c5406e5925933ca6$export$c46ffe36f592af78);
$parcel$export(module.exports, "updateOldDoneIssuesCutoffRequestSuccess", () => $c5406e5925933ca6$export$26e1fb5db3301414);
$parcel$export(module.exports, "updateOldDoneIssuesCutoffRequestFailure", () => $c5406e5925933ca6$export$f02d3e7dcb2b4b06);

var $9rND4 = parcelRequire("9rND4");
const $c5406e5925933ca6$export$74c8158e06b60b4f = 'state.actions.board.old-done-issues-cutoff.UPDATE_OLD_DONE_ISSUES_CUTOFF';
const $c5406e5925933ca6$export$c46ffe36f592af78 = (oldDoneIssuesCutoff, analyticsEvent)=>({
        type: $c5406e5925933ca6$export$74c8158e06b60b4f,
        payload: oldDoneIssuesCutoff,
        meta: {
            ...(0, $9rND4.beginOptimisticUiMeta)(),
            analyticsEvent: analyticsEvent
        }
    });
const $c5406e5925933ca6$export$976193a7ba2df0df = 'state.actions.board.old-done-issues-cutoff.UPDATE_OLD_DONE_ISSUES_CUTOFF_SUCCESS';
const $c5406e5925933ca6$export$26e1fb5db3301414 = (optimisticId)=>({
        type: $c5406e5925933ca6$export$976193a7ba2df0df,
        meta: (0, $9rND4.commitOptimisticUiMeta)(optimisticId)
    });
const $c5406e5925933ca6$export$ed5f849ec99da9b0 = 'state.actions.board.old-done-issues-cutoff.UPDATE_OLD_DONE_ISSUES_CUTOFF_FAILURE';
const $c5406e5925933ca6$export$f02d3e7dcb2b4b06 = (optimisticId)=>({
        type: $c5406e5925933ca6$export$ed5f849ec99da9b0,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(optimisticId)
    });

});

parcelRegister("cC1ol", function(module, exports) {

$parcel$export(module.exports, "updateOldDoneIssuesCutoffService", () => $384cb26c4d2edb4c$export$f8558577641631e5);

var $ls1wR = parcelRequire("ls1wR");
const $384cb26c4d2edb4c$export$f8558577641631e5 = (contextPath, rapidViewId, oldDoneIssuesCutoff)=>(0, $ls1wR.default)(contextPath, rapidViewId, oldDoneIssuesCutoff);

});
parcelRegister("ls1wR", function(module, exports) {

$parcel$export(module.exports, "default", () => $04f019203ed9258f$export$2e2bcd8739ae039);

var $ivqh1 = parcelRequire("ivqh1");

var $6iJbJ = parcelRequire("6iJbJ");
const $04f019203ed9258f$export$f844be344ad9e379 = 'UpdateOldDoneIssuesCutoff';
const $04f019203ed9258f$export$43e60cf4d5609fcc = (0, $ivqh1.gqlTagSwag)`mutation UpdateOldDoneIssuesCutoff($boardId: ID!, $oldDoneIssueCutoff: String!){
		setOldDoneIssuesCutoff(input: {boardId: $boardId, oldDoneIssuesCutoff: $oldDoneIssueCutoff}) {
			boardId,
			oldDoneIssuesCutoff
		}
}
`;
const $04f019203ed9258f$var$oldDoneIssuesCutoffMutation = (contextPath, boardId, oldDoneIssueCutoff)=>(0, $6iJbJ.mutation$)(contextPath, $04f019203ed9258f$export$f844be344ad9e379, $04f019203ed9258f$export$43e60cf4d5609fcc, {
        boardId: boardId,
        oldDoneIssueCutoff: oldDoneIssueCutoff
    });
var $04f019203ed9258f$export$2e2bcd8739ae039 = $04f019203ed9258f$var$oldDoneIssuesCutoffMutation;

});




parcelRegister("5kyJ5", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2bd300124c49df2$export$2e2bcd8739ae039);

var $gccSB = parcelRequire("gccSB");

var $hhweD = parcelRequire("hhweD");

var $knz2T = parcelRequire("knz2T");
const $b2bd300124c49df2$var$shouldTriggerAnalytics = ({ type: type } = {})=>(0, $knz2T.default)()[type ?? ''] !== undefined;
const $b2bd300124c49df2$var$getAnalyticsForAction = (preActionState, postActionState, // eslint-disable-next-line @typescript-eslint/no-explicit-any
action)=>(0, $knz2T.default)()[action.type].map((createAnalytic)=>createAnalytic((0, $knz2T.ANALYTIC_PREFIX))(preActionState, postActionState, action)).filter((analyticEvent)=>analyticEvent !== null);
const $b2bd300124c49df2$var$triggerAnalyticsForAction = (analyticEvents)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(analyticEvents)) return;
    analyticEvents.forEach(({ trackEvents: trackEvents = [] })=>{
        trackEvents.forEach((trackEvent)=>(0, $hhweD.fireTrackAnalytics)(trackEvent, {
                action: trackEvent.payload.action
            }));
    });
};
// @ts-expect-error - Type 'MiddlewareAPI<S>' is not assignable to type 'MiddlewareAPI'.
const $b2bd300124c49df2$var$analyticsMiddleware = (store)=>(next)=>(action)=>{
            if (!$b2bd300124c49df2$var$shouldTriggerAnalytics(action)) return next(action);
            const preActionState = store.getState();
            const result = next(action);
            const postActionState = store.getState();
            const analyticEvents = $b2bd300124c49df2$var$getAnalyticsForAction(preActionState, postActionState, action);
            $b2bd300124c49df2$var$triggerAnalyticsForAction(analyticEvents);
            return result;
        };
var $b2bd300124c49df2$export$2e2bcd8739ae039 = $b2bd300124c49df2$var$analyticsMiddleware;

});
parcelRegister("knz2T", function(module, exports) {

$parcel$export(module.exports, "ANALYTIC_PREFIX", () => $03a8ef826366cb8d$export$c88107e5c6decd92);
$parcel$export(module.exports, "default", () => $03a8ef826366cb8d$export$2e2bcd8739ae039);

var $doOdQ = parcelRequire("doOdQ");

var $bRqd3 = parcelRequire("bRqd3");

var $7buQq = parcelRequire("7buQq");

var $cY26q = parcelRequire("cY26q");

var $2f454 = parcelRequire("2f454");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $9eeht = parcelRequire("9eeht");

var $55fEr = parcelRequire("55fEr");

var $63VRQ = parcelRequire("63VRQ");

var $dnW4F = parcelRequire("dnW4F");

var $bkCF5 = parcelRequire("bkCF5");

var $ls4NM = parcelRequire("ls4NM");

var $5s6yC = parcelRequire("5s6yC");

var $kXqRJ = parcelRequire("kXqRJ");

var $9WrsG = parcelRequire("9WrsG");

var $fBkjL = parcelRequire("fBkjL");

var $e1q2I = parcelRequire("e1q2I");

var $dN3Ms = parcelRequire("dN3Ms");

var $dW1HX = parcelRequire("dW1HX");

var $cIqUn = parcelRequire("cIqUn");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");

var $30dmz = parcelRequire("30dmz");

var $3Nbzx = parcelRequire("3Nbzx");

var $kegsr = parcelRequire("kegsr");

var $kVgZQ = parcelRequire("kVgZQ");

var $ccYou = parcelRequire("ccYou");

var $anKCl = parcelRequire("anKCl");

var $a8X4R = parcelRequire("a8X4R");

var $dOmSg = parcelRequire("dOmSg");

var $7PXr3 = parcelRequire("7PXr3");

var $6qosr = parcelRequire("6qosr");

var $6KwKW = parcelRequire("6KwKW");

var $c0Kii = parcelRequire("c0Kii");

var $hpG0x = parcelRequire("hpG0x");

var $8yIXy = parcelRequire("8yIXy");

var $jYl7U = parcelRequire("jYl7U");
const $03a8ef826366cb8d$export$c88107e5c6decd92 = 'board';
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$03a8ef826366cb8d$export$2e2bcd8739ae039 = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ({
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_SHOW)]: [
            (0, $30dmz.backlogIssueMoveShow)
        ],
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_CANCEL)]: [
            (0, $30dmz.backlogIssueMoveCancel)
        ],
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE)]: [
            (0, $30dmz.backlogIssueMoveExecute)
        ],
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE_FAILURE)]: [
            (0, $30dmz.backlogIssueMoveExecuteFailure)
        ],
        [(0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE_SUCCESS)]: [
            (0, $30dmz.backlogIssueMoveExecuteSuccess)
        ],
        [(0, $cW3pH.BOARD_LOAD_FAILURE)]: [
            (0, $jYl7U.boardLoadFailure)
        ],
        [(0, $cW3pH.BOARD_LOAD_FAILURE_NO_COLUMN)]: [
            (0, $jYl7U.boardLoadNoColumnFailure)
        ],
        [(0, $cW3pH.BOARD_VIEW)]: [
            (0, $jYl7U.boardView)
        ],
        [(0, $cW3pH.BOARD_NON_CRITICAL_VIEW)]: [
            (0, $jYl7U.boardNonCriticalView)
        ],
        [(0, $cW3pH.WORK_DATA_SET)]: [
            (0, $6KwKW.issueLabelsAmount)
        ],
        [(0, $cW3pH.WORK_DATA_CRITICAL_SET)]: [
            (0, $6KwKW.issueLabelsAmount)
        ],
        [(0, $cW3pH.WORK_REFRESH_DATA)]: [
            (0, $jYl7U.workRefreshData)
        ],
        [(0, $7buQq.RENAME_BOARD_FAILURE)]: [
            (0, $kegsr.renameBoardFailure)
        ],
        [(0, $7buQq.RENAME_BOARD_REQUEST)]: [
            (0, $kegsr.renameBoardRequest)
        ],
        [(0, $7buQq.RENAME_BOARD_SUCCESS)]: [
            (0, $kegsr.renameBoardSuccess)
        ],
        [(0, $bRqd3.CARD_MEDIA_TOGGLE_REQUEST)]: [
            (0, $3Nbzx.cardMediaToggled)
        ],
        [(0, $55fEr.COLUMN_RANK_REQUEST)]: [
            (0, $ccYou.columnRankRequest),
            (0, $kVgZQ.columnRankRequestPerformance)
        ],
        [(0, $55fEr.COLUMN_RANK_SUCCESS)]: [
            (0, $ccYou.columnRankSuccess),
            (0, $kVgZQ.columnRankSuccessPerformance)
        ],
        [(0, $55fEr.COLUMN_RANK_FAILURE)]: [
            (0, $ccYou.columnRankFailure)
        ],
        [(0, $63VRQ.COLUMN_RENAME_REQUEST)]: [
            (0, $ccYou.columnRenameRequest),
            (0, $kVgZQ.columnRenameRequestPerformance)
        ],
        [(0, $63VRQ.COLUMN_RENAME_SUCCESS)]: [
            (0, $ccYou.columnRenameSuccess),
            (0, $kVgZQ.columnRenameSuccessPerformance)
        ],
        [(0, $63VRQ.COLUMN_RENAME_FAILURE)]: [
            (0, $ccYou.columnRenameFailure)
        ],
        [(0, $glGhK.COLUMN_CREATE_REQUEST)]: [
            (0, $ccYou.columnCreateRequest),
            (0, $kVgZQ.columnCreateRequestPerformance)
        ],
        [(0, $glGhK.COLUMN_CREATE_SUCCESS)]: [
            (0, $ccYou.columnCreateSuccess),
            (0, $kVgZQ.columnCreateSuccessPerformance)
        ],
        [(0, $glGhK.COLUMN_CREATE_FAILURE)]: [
            (0, $ccYou.columnCreateFailure)
        ],
        [(0, $63F6h.COLUMN_DELETE)]: [
            (0, $ccYou.columnDelete)
        ],
        [(0, $63F6h.COLUMN_DELETE_REQUEST)]: [
            (0, $ccYou.columnDeleteRequest),
            (0, $kVgZQ.columnDeleteRequestPerformance)
        ],
        [(0, $63F6h.COLUMN_DELETE_SUCCESS)]: [
            (0, $ccYou.columnDeleteSuccess),
            (0, $kVgZQ.columnDeleteSuccessPerformance)
        ],
        [(0, $63F6h.COLUMN_DELETE_FAILURE)]: [
            (0, $ccYou.columnDeleteFailure)
        ],
        [(0, $9eeht.COLUMN_OPEN_LIMITS_MODAL)]: [
            (0, $ccYou.columnOpenLimitsModal)
        ],
        [(0, $9eeht.COLUMN_CLOSE_LIMITS_MODAL)]: [
            (0, $ccYou.columnCloseLimitsModal)
        ],
        [(0, $9eeht.COLUMN_SET_LIMITS_REQUEST)]: [
            (0, $ccYou.columnSetLimitsRequest),
            (0, $ccYou.columnBustStatus),
            (0, $kVgZQ.columnLimitRequestPerformance)
        ],
        [(0, $9eeht.COLUMN_SET_LIMITS_SUCCESS)]: [
            (0, $ccYou.columnSetLimitsSuccess),
            (0, $kVgZQ.columnLimitSuccessPerformance)
        ],
        [(0, $9eeht.COLUMN_SET_LIMITS_FAILURE)]: [
            (0, $ccYou.columnSetLimitsFailure)
        ],
        [(0, $e1q2I.DONE_ISSUES_BUTTON_CLICK)]: [
            (0, $6KwKW.doneIssuesButtonClick)
        ],
        [(0, $ls4NM.ISSUE_CREATE_REQUEST)]: [
            (0, $6KwKW.issueCreateRequest),
            (0, $6qosr.issueCreateRequestPerformance)
        ],
        [(0, $ls4NM.ISSUE_CREATE_SUCCESS)]: [
            (0, $6KwKW.issueCreateSuccess),
            (0, $6qosr.issueCreateSuccessPerformance)
        ],
        [(0, $ls4NM.ISSUE_CREATE_FAILURE)]: [
            (0, $6KwKW.issueCreateFailure)
        ],
        [(0, $kXqRJ.ISSUE_DELETE_REQUEST)]: [
            (0, $6qosr.issueDeleteRequestPerformance)
        ],
        [(0, $kXqRJ.ISSUE_DELETE_SUCCESS)]: [
            (0, $6KwKW.issueDeleteSuccess)
        ],
        [(0, $kXqRJ.ISSUE_DELETE_FAILURE)]: [
            (0, $6KwKW.issueDeleteFailure)
        ],
        [(0, $5s6yC.ISSUE_DELETE_MODAL_OPEN)]: [
            (0, $c0Kii.issueDeleteModalOpen)
        ],
        [(0, $5s6yC.ISSUE_DELETE_MODAL_CLOSE)]: [
            (0, $c0Kii.issueDeleteModalClose)
        ],
        [(0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_REQUEST)]: [
            (0, $6qosr.issueFlagToggleRequestPerformance)
        ],
        [(0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)]: [
            (0, $6KwKW.issueMoveToBacklogRequest)
        ],
        [(0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_SUCCESS)]: [
            (0, $6KwKW.issueMoveToBacklogSuccess)
        ],
        [(0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_FAILURE)]: [
            (0, $6KwKW.issueMoveToBacklogFailure)
        ],
        [(0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)]: [
            (0, $6KwKW.issueRankTransitionRequest),
            (0, $ccYou.columnBustStatus),
            (0, $6qosr.issueRankTransitionRequestPerformance)
        ],
        [(0, $71oFY.ISSUE_RANK_TRANSITION_SUCCESS)]: [
            (0, $6KwKW.issueRankTransitionSuccess),
            (0, $6qosr.issueRankTransitionSuccessPerformance)
        ],
        [(0, $71oFY.ISSUE_RANK_TRANSITION_FAILURE)]: [
            (0, $6KwKW.issueRankTransitionFailure)
        ],
        [(0, $evkwq.ISSUE_UPDATE_SUCCESS)]: [
            (0, $6KwKW.issueLabelsAmount)
        ],
        [(0, $e1q2I.ISSUE_CHANGE_SWIMLANE)]: [
            (0, $6KwKW.issueChangeSwimlane)
        ],
        [(0, $9WrsG.DEV_STATUS_LOAD_SUCCESS)]: [
            (0, $6KwKW.devStatusLoadSuccess)
        ],
        [(0, $dnW4F.FILTER_PANEL_MOUNTED)]: [
            (0, $a8X4R.filterPanelMounted)
        ],
        [(0, $dnW4F.SEARCH_FOCUS)]: [
            (0, $a8X4R.searchFocus)
        ],
        [(0, $dnW4F.SET_ALL_FILTERS)]: [
            (0, $a8X4R.setAllFilters),
            (0, $a8X4R.setAllFiltersPerformance)
        ],
        [(0, $dnW4F.CLEAR_ALL_FILTERS_CLICKED)]: [
            (0, $a8X4R.clearAllFiltersClicked)
        ],
        [(0, $bkCF5.FLAG_DISMISSED)]: [
            (0, $dOmSg.flagDismissed)
        ],
        [(0, $bkCF5.FLAG_CREATED_ISSUE_IS_FILTERED)]: [
            (0, $dOmSg.flagCreatedIssueIsFiltered)
        ],
        [(0, $bkCF5.ISSUE_CREATE_FILTERED_V2)]: [
            (0, $dOmSg.flagIssueCreateFilteredV2)
        ],
        [(0, $bkCF5.ISSUE_CREATE_MOVED_BETWEEN_SWIMLANES)]: [
            (0, $dOmSg.flagIssueCreateMovedBetweenJqlSwimlanes)
        ],
        [(0, $dW1HX.OPEN_ISSUE_MODAL)]: [
            (0, $6KwKW.openIssueCreate)
        ],
        [(0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST)]: [
            (0, $8yIXy.swimlaneModeChanged)
        ],
        [(0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST)]: [
            (0, $hpG0x.issueMediaVisibilityChange)
        ],
        [(0, $2f454.CARD_CLICK)]: [
            (0, $7PXr3.issueViewOpenPerformance)
        ],
        [(0, $cY26q.FILTERED_CARD_SUCCESS)]: [
            (0, $anKCl.setCustomFiltersPerformance),
            (0, $anKCl.setCustomFiltersSuccess)
        ],
        [(0, $cY26q.FILTERED_CARD_FAILURE)]: [
            (0, $anKCl.setCustomFiltersFailure)
        ],
        [(0, $cY26q.REFILTER_SUCCESS)]: [
            (0, $anKCl.setCustomFiltersRefilterSuccess)
        ],
        [(0, $cY26q.REFILTER_FAILURE)]: [
            (0, $anKCl.setCustomFiltersRefilterFailure)
        ]
    });

});
parcelRegister("5s6yC", function(module, exports) {

$parcel$export(module.exports, "ISSUE_DELETE_MODAL_OPEN", () => $2265289d779cbe46$export$976c1e3393aa0887);
$parcel$export(module.exports, "issueDeleteModalOpen", () => $2265289d779cbe46$export$4807059b0e0495d2);
$parcel$export(module.exports, "ISSUE_DELETE_MODAL_CLOSE", () => $2265289d779cbe46$export$8201bc2c56389a43);
$parcel$export(module.exports, "issueDeleteModalClose", () => $2265289d779cbe46$export$b8ef0a3642381);
const $2265289d779cbe46$export$976c1e3393aa0887 = 'state.actions.issue.delete-modal.ISSUE_DELETE_MODAL_OPEN';
const $2265289d779cbe46$export$4807059b0e0495d2 = (issueId, columnIndex)=>({
        type: $2265289d779cbe46$export$976c1e3393aa0887,
        payload: {
            issueId: issueId,
            columnIndex: columnIndex
        }
    });
const $2265289d779cbe46$export$8201bc2c56389a43 = 'state.actions.issue.delete-modal.ISSUE_DELETE_MODAL_CLOSE';
const $2265289d779cbe46$export$b8ef0a3642381 = ()=>({
        type: $2265289d779cbe46$export$8201bc2c56389a43
    });

});

parcelRegister("30dmz", function(module, exports) {

$parcel$export(module.exports, "backlogIssueMoveShow", () => $d2eaa2ff91065976$export$d855544cc5ffa4f4);
$parcel$export(module.exports, "backlogIssueMoveCancel", () => $d2eaa2ff91065976$export$8ad0be7d3c5b884d);
$parcel$export(module.exports, "backlogIssueMoveExecute", () => $d2eaa2ff91065976$export$deb012b7ca9ae918);
$parcel$export(module.exports, "backlogIssueMoveExecuteSuccess", () => $d2eaa2ff91065976$export$306bba8cd988ac22);
$parcel$export(module.exports, "backlogIssueMoveExecuteFailure", () => $d2eaa2ff91065976$export$e67e8d09cf0c08f4);

var $absT5 = parcelRequire("absT5");
const $d2eaa2ff91065976$export$d855544cc5ffa4f4 = (eventPrefix)=>(preState, state)=>({
            name: `${eventPrefix}.backlog-issue-move.show`,
            data: {
                numIssues: (0, $absT5.getFirstColumnIssueIds)(state).length
            }
        });
const $d2eaa2ff91065976$export$8ad0be7d3c5b884d = (eventPrefix)=>(preState, state)=>({
            name: `${eventPrefix}.backlog-issue-move.cancel`,
            data: {
                numIssues: (0, $absT5.getFirstColumnIssueIds)(state).length
            }
        });
const $d2eaa2ff91065976$export$deb012b7ca9ae918 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.backlog-issue-move.execute`,
            data: {
                numIssues: action.payload.issueIds.length,
                transactionId: action.meta.optimistic.id
            }
        });
const $d2eaa2ff91065976$export$306bba8cd988ac22 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.backlog-issue-move.execute.success`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $d2eaa2ff91065976$export$e67e8d09cf0c08f4 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.backlog-issue-move.execute.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });

});

parcelRegister("3Nbzx", function(module, exports) {

$parcel$export(module.exports, "cardMediaToggled", () => $dc97f64e23967130$export$c679084c7b832b31);

var $5mTgl = parcelRequire("5mTgl");
const $dc97f64e23967130$export$c679084c7b832b31 = (eventPrefix)=>(preState, state)=>{
        const enabled = (0, $5mTgl.isCardMediaEnabled)(state);
        return {
            name: `${eventPrefix}.card.media.toggled.global`,
            data: {
                enabled: enabled
            }
        };
    };

});

parcelRegister("kegsr", function(module, exports) {

$parcel$export(module.exports, "renameBoardSuccess", () => $49ba23132ca991f0$export$21475b90a48a2c95);
$parcel$export(module.exports, "renameBoardFailure", () => $49ba23132ca991f0$export$244d02fac7e80a83);
$parcel$export(module.exports, "renameBoardRequest", () => $49ba23132ca991f0$export$43cfff342e1dcc87);
const $49ba23132ca991f0$export$21475b90a48a2c95 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.rename-board.success`,
            data: {}
        });
const $49ba23132ca991f0$export$244d02fac7e80a83 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.rename-board.failure`,
            data: {}
        });
const $49ba23132ca991f0$export$43cfff342e1dcc87 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.rename-board.request`,
            data: {}
        });

});

parcelRegister("kVgZQ", function(module, exports) {

$parcel$export(module.exports, "columnRankRequestPerformance", () => $885dae14e264453f$export$d837df4151f4ad93);
$parcel$export(module.exports, "columnRankSuccessPerformance", () => $885dae14e264453f$export$9a2c8aae5b38c5a0);
$parcel$export(module.exports, "columnRenameRequestPerformance", () => $885dae14e264453f$export$814d029099d0e639);
$parcel$export(module.exports, "columnRenameSuccessPerformance", () => $885dae14e264453f$export$8da4a68fc37a7a04);
$parcel$export(module.exports, "columnCreateRequestPerformance", () => $885dae14e264453f$export$4be72e44b849cf1b);
$parcel$export(module.exports, "columnCreateSuccessPerformance", () => $885dae14e264453f$export$9dd5fbdc332952a1);
$parcel$export(module.exports, "columnDeleteRequestPerformance", () => $885dae14e264453f$export$43717ed5e4b52002);
$parcel$export(module.exports, "columnDeleteSuccessPerformance", () => $885dae14e264453f$export$dc19c78b5b2c0920);
$parcel$export(module.exports, "columnLimitRequestPerformance", () => $885dae14e264453f$export$5adc931e85a4c8d);
$parcel$export(module.exports, "columnLimitSuccessPerformance", () => $885dae14e264453f$export$d7542d74bd8f75b6);

var $CFxE9 = parcelRequire("CFxE9");
const $885dae14e264453f$export$d837df4151f4ad93 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $CFxE9.columnRankInteraction)(concurrentId).start();
        return null;
    };
const $885dae14e264453f$export$9a2c8aae5b38c5a0 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $CFxE9.columnRankInteraction)(concurrentId).stop();
        return null;
    };
const $885dae14e264453f$export$814d029099d0e639 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $CFxE9.columnRenameInteraction)(concurrentId).start();
        return null;
    };
const $885dae14e264453f$export$8da4a68fc37a7a04 = ()=>(preState, state, action)=>{
        const concurrentId = action.meta.optimistic.id;
        (0, $CFxE9.columnRenameInteraction)(concurrentId).stop();
        return null;
    };
const $885dae14e264453f$export$4be72e44b849cf1b = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryColumnId);
        (0, $CFxE9.columnCreateInteraction)(concurrentId).start();
        return null;
    };
const $885dae14e264453f$export$9dd5fbdc332952a1 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryColumnId);
        (0, $CFxE9.columnCreateInteraction)(concurrentId).stop();
        return null;
    };
const $885dae14e264453f$export$43717ed5e4b52002 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $CFxE9.columnDeleteInteraction)(concurrentId).start();
        return null;
    };
const $885dae14e264453f$export$dc19c78b5b2c0920 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $CFxE9.columnDeleteInteraction)(concurrentId).stop();
        return null;
    };
const $885dae14e264453f$export$5adc931e85a4c8d = ()=>()=>{
        (0, $CFxE9.columnSetLimitInteraction).start();
        return null;
    };
const $885dae14e264453f$export$d7542d74bd8f75b6 = ()=>()=>{
        (0, $CFxE9.columnSetLimitInteraction).stop();
        return null;
    };

});

parcelRegister("ccYou", function(module, exports) {

$parcel$export(module.exports, "columnRankRequest", () => $4ccbfd59385b6fff$export$52f00a5a5ec3dade);
$parcel$export(module.exports, "columnRankSuccess", () => $4ccbfd59385b6fff$export$2011044b8a484462);
$parcel$export(module.exports, "columnRankFailure", () => $4ccbfd59385b6fff$export$8c4ab2c0d8c0dc47);
$parcel$export(module.exports, "columnRenameRequest", () => $4ccbfd59385b6fff$export$26259738ac7d398);
$parcel$export(module.exports, "columnRenameSuccess", () => $4ccbfd59385b6fff$export$e91d130c91c717f8);
$parcel$export(module.exports, "columnRenameFailure", () => $4ccbfd59385b6fff$export$519e7ffdc12c083f);
$parcel$export(module.exports, "columnCreateRequest", () => $4ccbfd59385b6fff$export$e17a54aca50f971e);
$parcel$export(module.exports, "columnCreateSuccess", () => $4ccbfd59385b6fff$export$4d3e535c643e516d);
$parcel$export(module.exports, "columnCreateFailure", () => $4ccbfd59385b6fff$export$7a6298113a6c73fb);
$parcel$export(module.exports, "columnDelete", () => $4ccbfd59385b6fff$export$6897d9588103ae0);
$parcel$export(module.exports, "columnDeleteRequest", () => $4ccbfd59385b6fff$export$2d450a2a2ff1d73c);
$parcel$export(module.exports, "columnDeleteSuccess", () => $4ccbfd59385b6fff$export$a2524e4771fdebc1);
$parcel$export(module.exports, "columnDeleteFailure", () => $4ccbfd59385b6fff$export$d12468113e6a687f);
$parcel$export(module.exports, "columnOpenLimitsModal", () => $4ccbfd59385b6fff$export$7db64843dc1f34b6);
$parcel$export(module.exports, "columnCloseLimitsModal", () => $4ccbfd59385b6fff$export$5eb828385c591dbf);
$parcel$export(module.exports, "columnSetLimitsRequest", () => $4ccbfd59385b6fff$export$426784419a12c1b5);
$parcel$export(module.exports, "columnSetLimitsSuccess", () => $4ccbfd59385b6fff$export$c9f0c15978432dec);
$parcel$export(module.exports, "columnSetLimitsFailure", () => $4ccbfd59385b6fff$export$3b783b9b2a0ab085);
$parcel$export(module.exports, "columnBustStatus", () => $4ccbfd59385b6fff$export$9c3af719b5697422);

var $8zOmE = parcelRequire("8zOmE");

var $esu6n = parcelRequire("esu6n");

var $9eeht = parcelRequire("9eeht");

var $71oFY = parcelRequire("71oFY");

var $fyeGd = parcelRequire("fyeGd");

var $5mTgl = parcelRequire("5mTgl");

var $8ECQ2 = parcelRequire("8ECQ2");
const $4ccbfd59385b6fff$export$52f00a5a5ec3dade = (eventPrefix)=>(preState, state, action)=>{
        const { columnId: columnId } = action.payload;
        const { isInitial: isInitial, isDone: isDone } = (0, $fyeGd.columnStatusMappingSelector)(state)[columnId];
        return {
            name: `${eventPrefix}.column.rank`,
            data: {
                startIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(preState, columnId)),
                endIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, columnId)),
                hasInitialStatus: isInitial,
                isResolutionDone: isDone
            }
        };
    };
const $4ccbfd59385b6fff$export$2011044b8a484462 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.column.rank.success`,
            data: {}
        });
const $4ccbfd59385b6fff$export$8c4ab2c0d8c0dc47 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.column.rank.failure`,
            data: {}
        });
const $4ccbfd59385b6fff$export$26259738ac7d398 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column-header.edit.request`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$e91d130c91c717f8 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column-header.edit.success`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$519e7ffdc12c083f = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column-header.edit.failure`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$e17a54aca50f971e = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.add`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.temporaryColumnId))
            }
        });
const $4ccbfd59385b6fff$export$4d3e535c643e516d = (eventPrefix)=>(preState, state, action)=>{
        const { payload: { column: { id: id } }, meta: { analyticsEvent: analyticsEvent } } = action;
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'column created', {
            columnId: id
        });
        return {
            name: `${eventPrefix}.column.add.success`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.temporaryColumnId))
            }
        };
    };
const $4ccbfd59385b6fff$export$7a6298113a6c73fb = (eventPrefix)=>(preState, state, action)=>{
        const { error: error, meta: { analyticsEvent: analyticsEvent } } = action;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'column createFailed', {
            errorMessage: error
        });
        return {
            name: `${eventPrefix}.column.add.failure`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.temporaryColumnId))
            }
        };
    };
const $4ccbfd59385b6fff$export$6897d9588103ae0 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.delete`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                hasIssues: action.payload.hasIssues,
                hasIssuesNotOnBoard: action.payload.hasIssuesNotOnBoard
            }
        });
const $4ccbfd59385b6fff$export$2d450a2a2ff1d73c = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.delete.request`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId))
            }
        });
const $4ccbfd59385b6fff$export$a2524e4771fdebc1 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.delete.success`,
            data: {
                columnIndexes: action.payload.columns.map((column)=>(0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, column.id)))
            }
        });
const $4ccbfd59385b6fff$export$d12468113e6a687f = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.delete.failure`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId))
            }
        });
const $4ccbfd59385b6fff$export$7db64843dc1f34b6 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.dialog.open`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId))
            }
        });
const $4ccbfd59385b6fff$export$5eb828385c591dbf = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.dialog.close`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId))
            }
        });
const $4ccbfd59385b6fff$export$426784419a12c1b5 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.set.request`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                maxIssueCount: action.payload.maxIssueCount,
                minIssueCount: action.payload.minIssueCount,
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$c9f0c15978432dec = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.set.success`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$export$3b783b9b2a0ab085 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.column.limits.set.failure`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(state, action.payload.columnId)),
                transactionId: action.meta.optimistic.id
            }
        });
const $4ccbfd59385b6fff$var$getColumnBustedEvent = (eventName, checkState, payloadState, columnId)=>(0, $5mTgl.getColumnTheme)(checkState, columnId) !== 'default' ? {
        name: eventName,
        data: {
            columnIndex: (0, $8ECQ2.toOneBasedIndex)((0, $fyeGd.getColumnIndex)(payloadState, columnId)),
            maxIssueCount: (0, $esu6n.getStatusColumn)((0, $fyeGd.getColumnById)(payloadState, columnId))?.maxIssueCount,
            issueCount: (0, $5mTgl.getColumnTotalIssuesCount)(payloadState, columnId)
        }
    } : null;
const $4ccbfd59385b6fff$export$9c3af719b5697422 = (eventPrefix)=>(preState, state, action)=>{
        const bustedEventName = `${eventPrefix}.column.limits.busted`;
        const unbustedEventName = `${eventPrefix}.column.limits.unbusted`;
        if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_REQUEST)) {
            const { payload: { destinationColumnId: destinationColumnId, sourceColumnId: sourceColumnId } } = action;
            return $4ccbfd59385b6fff$var$getColumnBustedEvent(bustedEventName, state, state, destinationColumnId) || $4ccbfd59385b6fff$var$getColumnBustedEvent(unbustedEventName, preState, state, sourceColumnId) || null;
        }
        if (action.type === (0, $9eeht.COLUMN_SET_LIMITS_REQUEST)) {
            const { payload: { columnId: columnId } } = action;
            return $4ccbfd59385b6fff$var$getColumnBustedEvent(bustedEventName, state, state, columnId) || $4ccbfd59385b6fff$var$getColumnBustedEvent(unbustedEventName, preState, state, columnId) || null;
        }
        return null;
    };

});
parcelRegister("8ECQ2", function(module, exports) {

$parcel$export(module.exports, "toOneBasedIndex", () => $1d31b46bd10c4912$export$7b5012c669f99025);
const $1d31b46bd10c4912$export$7b5012c669f99025 = (index)=>index + 1;
const $1d31b46bd10c4912$export$7cc93f0f60c50950 = (indexes)=>indexes.map($1d31b46bd10c4912$export$7b5012c669f99025);

});


parcelRegister("anKCl", function(module, exports) {

$parcel$export(module.exports, "setCustomFiltersPerformance", () => $d03e6a22240c3a0e$export$a4497c4897069a2b);
$parcel$export(module.exports, "setCustomFiltersFailure", () => $d03e6a22240c3a0e$export$b6336fdfea9c7130);
$parcel$export(module.exports, "setCustomFiltersSuccess", () => $d03e6a22240c3a0e$export$807bc3d6fd05a3f8);
$parcel$export(module.exports, "setCustomFiltersRefilterSuccess", () => $d03e6a22240c3a0e$export$be433321d98a3ffa);
$parcel$export(module.exports, "setCustomFiltersRefilterFailure", () => $d03e6a22240c3a0e$export$d76e8115781031ba);

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $fjcgS = parcelRequire("fjcgS");

var $4G04L = parcelRequire("4G04L");

var $gNaDq = parcelRequire("gNaDq");

var $67Z81 = parcelRequire("67Z81");
const $d03e6a22240c3a0e$export$a4497c4897069a2b = ()=>(preState, state, action)=>{
        const { meta: { numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        const isCompanyManaged = (0, $67Z81.getIsCMPBoard)(state);
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $gNaDq.stopCustomFilterInteraction)(numCustomFiltersApplied, numIssueIds, isCompanyManaged);
        });
        return null;
    };
const $d03e6a22240c3a0e$export$b6336fdfea9c7130 = ()=>(preState, state, action)=>{
        const { payload: { error: error }, meta: { analyticsEvent: analyticsEvent } } = action;
        if (analyticsEvent) (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'customFilters failed', {
            isClientFetchError: (0, $fZneA.isClientFetchError)(error),
            errorMessage: error?.message
        });
        (0, $gNaDq.cancelCustomFilterInteraction)();
        return null;
    };
const $d03e6a22240c3a0e$export$807bc3d6fd05a3f8 = ()=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent, numCustomFiltersApplied: numCustomFiltersApplied, numIssueIds: numIssueIds } } = action;
        if (analyticsEvent) (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'customFilters applied', {
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds
        });
        return null;
    };
const $d03e6a22240c3a0e$export$be433321d98a3ffa = ()=>(preState, state, action)=>{
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'boardScreen',
                actionSubject: 'customFiltersRefilter',
                action: 'applied',
                attributes: {
                    excludedCards: excludedCardIds.length,
                    filteredCards: filteredCardIds.length
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return null;
    };
const $d03e6a22240c3a0e$export$d76e8115781031ba = ()=>(preState, state, action)=>{
        const { error: error } = action.payload;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                source: 'boardScreen',
                actionSubject: 'customFiltersRefilter',
                action: 'failed',
                attributes: {
                    isClientFetchError: (0, $fZneA.isClientFetchError)(error),
                    errorMessage: error?.message
                }
            };
            client.getInstance().sendOperationalEvent(payload);
        });
        return null;
    };

});
parcelRegister("gNaDq", function(module, exports) {

$parcel$export(module.exports, "setCustomFilterInteractionFeedbackMark", () => $c297c1d837604846$export$5dd87a22b8e2c81c);
$parcel$export(module.exports, "setCustomFilterInteractionStartMark", () => $c297c1d837604846$export$600569a4fb9e5675);
$parcel$export(module.exports, "cancelCustomFilterInteraction", () => $c297c1d837604846$export$178f6b8399be6909);
$parcel$export(module.exports, "stopCustomFilterInteraction", () => $c297c1d837604846$export$90db63ac5c02197a);

var $k12ix = parcelRequire("k12ix");

var $hz3OZ = parcelRequire("hz3OZ");
const $c297c1d837604846$export$5dd87a22b8e2c81c = ()=>{
    (0, $hz3OZ.customFilterInteraction).mark('feedback');
};
const $c297c1d837604846$export$600569a4fb9e5675 = ()=>{
    (0, $hz3OZ.customFilterInteraction).start();
};
const $c297c1d837604846$export$178f6b8399be6909 = ()=>{
    (0, $hz3OZ.customFilterInteraction).cancel();
};
const $c297c1d837604846$export$90db63ac5c02197a = (numCustomFiltersApplied, numIssueIds, isCompanyManaged)=>{
    (0, $hz3OZ.customFilterInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            numCustomFiltersApplied: numCustomFiltersApplied,
            numIssueIds: numIssueIds,
            isCompanyManaged: isCompanyManaged
        }
    });
};

});


parcelRegister("a8X4R", function(module, exports) {

$parcel$export(module.exports, "filterPanelMounted", () => $a46544a5d194c56f$export$c48d1dabfffb8ec0);
$parcel$export(module.exports, "searchFocus", () => $a46544a5d194c56f$export$556a5ff7bd7ac86);
$parcel$export(module.exports, "clearAllFiltersClicked", () => $a46544a5d194c56f$export$5845d1911d8d06dd);
$parcel$export(module.exports, "setAllFilters", () => $a46544a5d194c56f$export$1e6b2e9f0ff84131);
$parcel$export(module.exports, "setAllFiltersPerformance", () => $a46544a5d194c56f$export$338d2cd01a36c93d);

var $9XE6b = parcelRequire("9XE6b");

var $k12ix = parcelRequire("k12ix");

var $4G04L = parcelRequire("4G04L");



var $hz3OZ = parcelRequire("hz3OZ");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $a46544a5d194c56f$export$c48d1dabfffb8ec0 = (eventPrefix)=>(preState, state)=>{
        const totalAssigneeCount = (0, $5mTgl.orderedWorkAssigneesByAccountIdSelector)(state).length;
        return {
            name: `${eventPrefix}.filters.show`,
            data: {
                numAvatarsDisplayed: totalAssigneeCount > (0, $7e733a5d4e4331fc$export$360e7ca29749d455) ? (0, $7e733a5d4e4331fc$export$360e7ca29749d455) : totalAssigneeCount
            }
        };
    };
const $a46544a5d194c56f$export$556a5ff7bd7ac86 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.filters.search-field.focus`,
            data: {}
        });
const $a46544a5d194c56f$export$5845d1911d8d06dd = (eventPrefix)=>(preState)=>{
        const selectedFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5mTgl.getWorkFilters)(preState), [
            'values'
        ]);
        return {
            name: `${eventPrefix}.filters.clear-button.click`,
            data: {
                numSelectedAvatars: (selectedFilters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] || []).length
            }
        };
    };
const $a46544a5d194c56f$var$getFilterAnalyticsData = (state)=>{
    const filters = (0, $5mTgl.getWorkFilters)(state).values;
    const assigneeFilters = filters[0, $dcff40112356dfc1$export$f8f7545d2bb78afb] || [];
    const labelFilters = filters[0, $dcff40112356dfc1$export$37aee82a3cb1e8f7] || [];
    const issueParentFilters = filters[0, $dcff40112356dfc1$export$2a4f270075a033de] || [];
    const issueTypeFilters = filters[0, $dcff40112356dfc1$export$ebb48b08205007c5] || [];
    const sprintFilters = filters[0, $dcff40112356dfc1$export$a316570a0dbfd2b0] || [];
    return {
        numSelectedAvatars: assigneeFilters.length,
        isAssignedToMeSelected: assigneeFilters.indexOf((0, $67Z81.currentUserAccountIdSelector)(state)) > -1,
        numSelectedLabels: labelFilters.length,
        numVisibleIssues: (0, $5mTgl.workFilteredIssuesSelector)(state).length,
        numSelectedIssueParents: issueParentFilters.length,
        numSelectedIssueTypes: issueTypeFilters.length,
        numSelectedSprints: sprintFilters.length
    };
};
const $a46544a5d194c56f$export$1e6b2e9f0ff84131 = (eventPrefix)=>(preState, state, action)=>{
        const { filterType: filterType } = action.meta;
        if (filterType) {
            let actionName = 'select';
            const filters = (0, $5mTgl.getWorkFilters)(state).values;
            if (filterType === (0, $dcff40112356dfc1$export$d597759d33be802e) && !filters[0, $dcff40112356dfc1$export$d597759d33be802e]) actionName = 'deselect';
            else {
                const preFilters = (0, $5mTgl.getWorkFilters)(preState).values;
                actionName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
                    filterType
                ], []).length < (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(preFilters, [
                    filterType
                ], []).length ? 'deselect' : actionName;
            }
            return {
                name: `${eventPrefix}.filters.${filterType}.${actionName}`,
                data: $a46544a5d194c56f$var$getFilterAnalyticsData(state)
            };
        }
        return null;
    };
const $a46544a5d194c56f$export$338d2cd01a36c93d = ()=>()=>{
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.filterInteraction).stop({
                customData: (0, $k12ix.getNormalisedPerformanceFFs)()
            });
        });
        return null;
    };

});

parcelRegister("dOmSg", function(module, exports) {

$parcel$export(module.exports, "flagDismissed", () => $efad231c4bf847fc$export$1dd1bd800908fb39);
$parcel$export(module.exports, "flagCreatedIssueIsFiltered", () => $efad231c4bf847fc$export$a5b2adda95b0f64);
$parcel$export(module.exports, "flagIssueCreateFilteredV2", () => $efad231c4bf847fc$export$979d979cc98fe9a4);
$parcel$export(module.exports, "flagIssueCreateMovedBetweenJqlSwimlanes", () => $efad231c4bf847fc$export$45aa6b129599aaa1);

var $9XE6b = parcelRequire("9XE6b");

var $fjcgS = parcelRequire("fjcgS");


var $bkCF5 = parcelRequire("bkCF5");

var $8yiLS = parcelRequire("8yiLS");

var $9UXXB = parcelRequire("9UXXB");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $efad231c4bf847fc$export$1dd1bd800908fb39 = (eventPrefix)=>(preState, state, action)=>{
        const flag = action.payload;
        if (flag.id === (0, $bkCF5.FLAG_CREATED_ISSUE_IS_FILTERED)) {
            const issueId = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(flag, [
                'context',
                'issueId'
            ]);
            return {
                name: `${eventPrefix}.filter.flag.new-issue-filtered.dismissed`,
                data: {
                    issueId: issueId
                }
            };
        }
        // Don't fire analytic events when any other kind of flag is dismissed
        return null;
    };
const $efad231c4bf847fc$export$a5b2adda95b0f64 = (eventPrefix)=>(preState, state, action)=>{
        const issue = action.payload;
        const filterValues = (0, $5mTgl.getWorkFilters)(state).values;
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-issue-filtered.shown`,
            data: {
                issueId: issue.id,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $efad231c4bf847fc$export$979d979cc98fe9a4 = (eventPrefix)=>(preState, state, action)=>{
        const issueKeys = action.payload.cardKeys;
        const filterValues = (0, $5mTgl.getWorkFilters)(state).values;
        if (action.payload.filteredOnServer) {
            const isCustomBoardWithIcc = (0, $9UXXB.getIsCustomBoardWithIcc)(state);
            const hasCustomFilters = (0, $8yiLS.isCustomFiltersActive)(state);
            const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                const payload = {
                    action: 'filteredOnServer',
                    actionSubject: 'newIssues',
                    source: 'boardScreen',
                    attributes: {
                        isCustomBoardWithIcc: isCustomBoardWithIcc,
                        hasCustomFilters: hasCustomFilters,
                        swimlaneMode: swimlaneMode
                    }
                };
                client.getInstance().sendTrackEvent(payload);
            });
            return null;
        }
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        return {
            name: `${eventPrefix}.filter.flag.new-issue-filtered.shown`,
            data: {
                issueKeys: issueKeys,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            }
        };
    };
const $efad231c4bf847fc$export$45aa6b129599aaa1 = ()=>(preState, state)=>{
        const isCustomBoardWithIcc = (0, $9UXXB.getIsCustomBoardWithIcc)(state);
        const hasCustomFilters = (0, $8yiLS.isCustomFiltersActive)(state);
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'movedBetweenSwimlanes',
                actionSubject: 'newIssues',
                source: 'boardScreen',
                attributes: {
                    isCustomBoardWithIcc: isCustomBoardWithIcc,
                    hasCustomFilters: hasCustomFilters,
                    swimlaneMode: swimlaneMode
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return null;
    };

});

parcelRegister("7PXr3", function(module, exports) {

$parcel$export(module.exports, "issueViewOpenPerformance", () => $150727174c17eda7$export$2da4dabf4eeee402);

var $eTXmK = parcelRequire("eTXmK");

var $hz3OZ = parcelRequire("hz3OZ");
const $150727174c17eda7$export$2da4dabf4eeee402 = ()=>(prevState, state, action)=>{
        if (!action.payload.withCmd && !action.payload.withShift) {
            (0, $eTXmK.default)('board.issue-view-opened');
            (0, $hz3OZ.issueViewOpenInteraction).start();
        }
        return null;
    };

});

parcelRegister("6qosr", function(module, exports) {

$parcel$export(module.exports, "issueCreateRequestPerformance", () => $7fbf29447c28ca04$export$d3a6a79448f0e45);
$parcel$export(module.exports, "issueCreateSuccessPerformance", () => $7fbf29447c28ca04$export$c06b8e463871bb27);
$parcel$export(module.exports, "issueRankTransitionRequestPerformance", () => $7fbf29447c28ca04$export$7bbea59c986ad3b9);
$parcel$export(module.exports, "issueRankTransitionSuccessPerformance", () => $7fbf29447c28ca04$export$e5f6ae46e503f358);
$parcel$export(module.exports, "issueDeleteRequestPerformance", () => $7fbf29447c28ca04$export$6772d78aa70edaf8);
$parcel$export(module.exports, "issueFlagToggleRequestPerformance", () => $7fbf29447c28ca04$export$2ca02dd8a0e8a281);

var $k12ix = parcelRequire("k12ix");

var $4G04L = parcelRequire("4G04L");

var $5yzdy = parcelRequire("5yzdy");

var $hz3OZ = parcelRequire("hz3OZ");
const $7fbf29447c28ca04$export$d3a6a79448f0e45 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryIssueIds[0]);
        (0, $hz3OZ.issueCreateInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.issueCreateInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $7fbf29447c28ca04$export$c06b8e463871bb27 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.payload.temporaryIssueIds[0]);
        (0, $hz3OZ.issueCreateInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $5yzdy.getBoardExtraData)(state)
            }
        });
        return null;
    };
const $7fbf29447c28ca04$export$7bbea59c986ad3b9 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic?.id);
        (0, $hz3OZ.issueRankAndTransitionInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.issueRankAndTransitionInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $7fbf29447c28ca04$export$e5f6ae46e503f358 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.issueRankAndTransitionInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $5yzdy.getBoardExtraData)(state)
            }
        });
        return null;
    };
const $7fbf29447c28ca04$export$6772d78aa70edaf8 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.issueDeleteInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.issueDeleteInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };
const $7fbf29447c28ca04$export$2ca02dd8a0e8a281 = ()=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.flagToggleInteraction)(concurrentId).start();
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.flagToggleInteraction)(concurrentId).mark('feedback');
        });
        return null;
    };

});
parcelRegister("5yzdy", function(module, exports) {

$parcel$export(module.exports, "getBoardExtraData", () => $1f2884452d611059$export$736611f042606509);

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $1f2884452d611059$export$736611f042606509 = (state)=>({
        issuesCount: (0, $vAfHD.boardOrderedIssueIdsSelector)(state).length,
        filteredIssuesCount: (0, $5mTgl.workFilteredIssuesSelector)(state).length,
        columnsCount: (0, $67Z81.getOrderedColumnIds)(state).length,
        isCompanyManaged: (0, $67Z81.getIsCMPBoard)(state)
    });

});


parcelRegister("6KwKW", function(module, exports) {

$parcel$export(module.exports, "openIssueCreate", () => $8d4d6905372db5ee$export$c235e9bafca0cdee);
$parcel$export(module.exports, "doneIssuesButtonClick", () => $8d4d6905372db5ee$export$fdc4a4b0f77c4bc1);
$parcel$export(module.exports, "issueCreateRequest", () => $8d4d6905372db5ee$export$735389bea7eedaad);
$parcel$export(module.exports, "issueCreateSuccess", () => $8d4d6905372db5ee$export$359b420f9850fc61);
$parcel$export(module.exports, "issueCreateFailure", () => $8d4d6905372db5ee$export$d2f4535c9fcca3f3);
$parcel$export(module.exports, "issueDeleteSuccess", () => $8d4d6905372db5ee$export$bcb7ef15796f58b0);
$parcel$export(module.exports, "issueDeleteFailure", () => $8d4d6905372db5ee$export$3d3a8d020fe32306);
$parcel$export(module.exports, "issueRankTransitionRequest", () => $8d4d6905372db5ee$export$2ad8924ae4613236);
$parcel$export(module.exports, "issueRankTransitionSuccess", () => $8d4d6905372db5ee$export$fc64d70c84553912);
$parcel$export(module.exports, "issueRankTransitionFailure", () => $8d4d6905372db5ee$export$ade8b8e0a05059d7);
$parcel$export(module.exports, "issueLabelsAmount", () => $8d4d6905372db5ee$export$2653a763eb1e7ed2);
$parcel$export(module.exports, "devStatusLoadSuccess", () => $8d4d6905372db5ee$export$d5dceae9c7c7bc77);
$parcel$export(module.exports, "issueChangeSwimlane", () => $8d4d6905372db5ee$export$b1b86dea7a51e7b5);
$parcel$export(module.exports, "issueMoveToBacklogRequest", () => $8d4d6905372db5ee$export$1c79b09f3075e4ea);
$parcel$export(module.exports, "issueMoveToBacklogSuccess", () => $8d4d6905372db5ee$export$5a53dd39dd4e0e24);
$parcel$export(module.exports, "issueMoveToBacklogFailure", () => $8d4d6905372db5ee$export$a9d1ce754cbce39);

var $hm7zS = parcelRequire("hm7zS");

var $9XE6b = parcelRequire("9XE6b");

var $iThRn = parcelRequire("iThRn");

var $h4EJ8 = parcelRequire("h4EJ8");

var $k12ix = parcelRequire("k12ix");

var $fZneA = parcelRequire("fZneA");

var $f2NGE = parcelRequire("f2NGE");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $3eGwD = parcelRequire("3eGwD");

var $01j5n = parcelRequire("01j5n");

var $3vXOY = parcelRequire("3vXOY");

var $6s1PB = parcelRequire("6s1PB");


var $iuuJH = parcelRequire("iuuJH");

var $5yzdy = parcelRequire("5yzdy");

var $hz3OZ = parcelRequire("hz3OZ");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $8ECQ2 = parcelRequire("8ECQ2");
const $8d4d6905372db5ee$export$d516175c274e4e4b = (state, issueId)=>{
    const issue = (0, $d2i8f.getIssueById)(state, issueId);
    return {
        actionSubjectId: issueId,
        objectType: 'issue',
        objectId: issueId,
        issueTypeId: issue.typeId,
        issueTypeLevel: (0, $d2i8f.getIssueTypeLevelForBoardIssue)(state)(issueId)
    };
};
const $8d4d6905372db5ee$var$getIssueTrackEventAttributes = (state, issueId, updatedItems)=>{
    const issue = (0, $d2i8f.getIssueById)(state, issueId);
    return {
        updatedItems: updatedItems,
        issueTypeId: issue.typeId,
        issueTypeLevel: (0, $d2i8f.getIssueTypeLevelForBoardIssue)(state)(issueId),
        devInfoActivityState: issue.devStatus?.activity
    };
};
const $8d4d6905372db5ee$export$c235e9bafca0cdee = (eventPrefix)=>(preState, state, action)=>{
        const issue = (0, $d2i8f.getIssueByKey)(state, action.payload.issueKey);
        if (issue) return {
            name: `${eventPrefix}.issue.view`,
            data: {
                issueId: issue.id,
                viewMode: (0, $3eGwD.getBoardDetailViewMode)()
            }
        };
        return null;
    };
const $8d4d6905372db5ee$export$fdc4a4b0f77c4bc1 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.looking.for.old.issues.to.pin`,
            data: {}
        });
const $8d4d6905372db5ee$export$735389bea7eedaad = (eventPrefix)=>(preState, state, action)=>{
        const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(preState) !== (0, $iuuJH.NO_SWIMLANE).id;
        return {
            name: `${eventPrefix}.issue.create.request`,
            data: {
                columnIndex: (0, $8ECQ2.toOneBasedIndex)(action.meta.columnIndex),
                cardIndex: (0, $8ECQ2.toOneBasedIndex)(action.meta.cardIndex),
                transactionId: action.meta.optimistic.id,
                hasSwimlanes: hasSwimlanes,
                numSwimlanes: hasSwimlanes ? (0, $4jZ56.getSwimlanes)(preState).length : 0,
                inDefaultSwimlane: (0, $4jZ56.isInDefaultSwimlane)(preState)(action.meta.swimlaneId)
            }
        };
    };
const $8d4d6905372db5ee$export$359b420f9850fc61 = (eventPrefix)=>(preState, state, action)=>{
        // GET THE SESSION ID & EVERYTHING ELSE HERE.
        const { payload: { issues: issues }, meta: { columnIndex: columnIndex, cardIndex: cardIndex, optimistic: optimistic, analyticsEvent: analyticsEvent } } = action;
        /* session id set in useOnCreate to avoid update for autoOpenedICC - if undefined use from state */ const { sessionId: sessionId } = analyticsEvent.payload;
        const filterValues = (0, $5mTgl.getWorkFilters)(state).values;
        const trackEvents = [];
        issues.forEach((issue)=>{
            const clonedEvent = analyticsEvent.clone();
            if (clonedEvent) {
                /** Have to cast the state here as it is an optimistic state at this point in time. */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                const sessionIdFromState = state.entities.current?.inlineCreate?.sessionId;
                let improvedAnalyticsAttributes = {};
                if (sessionId !== undefined || sessionIdFromState !== undefined) {
                    // Fields inputted by the user
                    const issueCreateFieldsUsed = [
                        {
                            gqlType: 'JiraSingleLineTextField',
                            issueFieldId: 'summary',
                            issueFieldType: 'summary',
                            isPopulated: true
                        }
                    ];
                    const [PICExperimentConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_powerful_inline_create_for_software_board');
                    const isPICExperimentEnabled = PICExperimentConfig.get('isEnabled', false);
                    // Fields that can be populated automatically e.g. by filters, swimlanes or inline card create selections
                    const fieldsPopulated = {
                        ASSIGNEE: !!issue.assigneeAccountId,
                        PARENT: !!issue.parentId,
                        PRIORITY: !!issue.priority,
                        SPRINT: !!issue.sprintId,
                        FIX_VERSIONS: (0, $f2NGE.getFieldLengthForAnalytics)(issue.fixVersions?.length),
                        LABELS: (0, $f2NGE.getFieldLengthForAnalytics)(issue.labels?.length),
                        STATUS_CATEGORY: (0, $fyeGd.getStatusCategoryByStatusInColumnId)(state)(issue.columnId, issue.statusId),
                        ...isPICExperimentEnabled ? {
                            DUEDATE: !!issue.dueDate
                        } : {}
                    };
                    improvedAnalyticsAttributes = {
                        sessionId: sessionId || sessionIdFromState,
                        issueCreateFieldsUsed: issueCreateFieldsUsed,
                        boardType: (0, $67Z81.getBoardTypeForAnalytics)(state),
                        fieldsPopulated: fieldsPopulated,
                        isAnyStatusInCreateEnabled: (0, $5mTgl.getIsAnyStatusInCreateEnabled)(state) !== false
                    };
                }
                trackEvents.push(clonedEvent.update({
                    ...$8d4d6905372db5ee$export$d516175c274e4e4b(state, issue.id),
                    appliedFilters: Object.keys(filterValues),
                    ...improvedAnalyticsAttributes,
                    isCustomBoardWithIcc: (0, $9UXXB.getIsCustomBoardWithIcc)(state),
                    swimlaneMode: (0, $45cXl.getSwimlaneMode)(state)
                }));
            }
        });
        const swimlanes = (0, $45cXl.getSwimlaneMode)(state) || (0, $iuuJH.NO_SWIMLANE).id;
        // There is only ever at most 1 text filter
        const textFilter = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$d597759d33be802e),
            'length'
        ], 0) > 0;
        const numAssigneeFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$f8f7545d2bb78afb),
            'length'
        ], 0);
        const numLabelFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filterValues, [
            (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7),
            'length'
        ], 0);
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'ui taskSuccess', {
            task: 'createIssue'
        });
        return {
            name: `${eventPrefix}.issue.create.success`,
            data: {
                issueId: issues[0].id,
                numIssues: issues.length,
                columnIndex: (0, $8ECQ2.toOneBasedIndex)(columnIndex),
                cardIndex: (0, $8ECQ2.toOneBasedIndex)(cardIndex),
                transactionId: optimistic.id,
                swimlanes: swimlanes,
                textFilter: textFilter,
                numAssigneeFilters: numAssigneeFilters,
                numLabelFilters: numLabelFilters
            },
            trackEvents: trackEvents
        };
    };
const $8d4d6905372db5ee$export$d2f4535c9fcca3f3 = (eventPrefix)=>(preState, state, action)=>{
        const { meta: { analyticsEvent: analyticsEvent, error: error } } = action;
        const statusCode = error ? (0, $3vXOY.extractStatusCode)(error) : 200;
        if (analyticsEvent) {
            const sloResultType = error && ((0, $fZneA.isClientFetchError)(error) || (0, $01j5n.isUserNetworkError)(error)) ? 'taskAbort' : 'taskFail';
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `ui ${sloResultType}`, {
                task: 'createIssue',
                statusCode: statusCode,
                isClassic: (0, $67Z81.getIsCMPBoard)(state),
                errorMessage: error?.message ? (0, (/*@__PURE__*/$parcel$interopDefault($h4EJ8)))(error.message, {
                    length: 140
                }) : ''
            });
        }
        return {
            name: `${eventPrefix}.issue.create.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        };
    };
const $8d4d6905372db5ee$export$bcb7ef15796f58b0 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.issueDeleteInteraction)(concurrentId).stop({
            customData: {
                ...(0, $k12ix.getNormalisedPerformanceFFs)(),
                ...(0, $5yzdy.getBoardExtraData)(state)
            }
        });
        return {
            name: `${eventPrefix}.issue.delete.success`,
            data: {
                issueId: action.payload.issueId
            }
        };
    };
const $8d4d6905372db5ee$export$3d3a8d020fe32306 = (eventPrefix)=>(preState, state, action)=>{
        const concurrentId = String(action.meta.optimistic.id);
        (0, $hz3OZ.issueDeleteInteraction)(concurrentId).cancel();
        return {
            name: `${eventPrefix}.issue.delete.failure`,
            data: {
                issueId: action.payload.issueId
            }
        };
    };
const $8d4d6905372db5ee$export$2ad8924ae4613236 = (eventPrefix)=>(preState, state, action)=>{
        const { issueIds: issueIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId } = action.payload;
        const beforeRankIssueIndex = (0, $d2i8f.getIssueIndex)(preState, action.payload.issueIds[0]);
        const afterRankIssueIndex = (0, $d2i8f.getIssueIndex)(state, action.payload.issueIds[0]);
        const sourceColumnIndex = (0, $fyeGd.getColumnIndex)(state, sourceColumnId);
        const destinationColumnIndex = (0, $fyeGd.getColumnIndex)(state, destinationColumnId);
        return {
            name: `${eventPrefix}.issue.move`,
            data: {
                numIssues: issueIds.length,
                oldIssueIndex: (0, $8ECQ2.toOneBasedIndex)(beforeRankIssueIndex),
                newRankIssueIndex: (0, $8ECQ2.toOneBasedIndex)(afterRankIssueIndex),
                oldColumnIndex: (0, $8ECQ2.toOneBasedIndex)(sourceColumnIndex),
                newColumnIndex: (0, $8ECQ2.toOneBasedIndex)(destinationColumnIndex),
                hasTransitioned: sourceColumnId !== destinationColumnId,
                transactionId: action.meta.optimistic?.id
            }
        };
    };
const $8d4d6905372db5ee$export$fc64d70c84553912 = (eventPrefix)=>(preState, state, action)=>{
        const { payload: { issueIds: issueIds }, meta: { analyticsEvent: analyticsEvent, optimistic: optimistic } } = action;
        const trackEvents = [];
        issueIds.forEach((issueId)=>(0, $8zOmE.fireTrackAnalytics)(// @ts-expect-error - Argument of type 'UIAnalyticsEvent | null' is not assignable to parameter of type 'UIAnalyticsEvent'.
            analyticsEvent.clone(), 'issue updated', issueId.toString(), $8d4d6905372db5ee$var$getIssueTrackEventAttributes(state, issueId, analyticsEvent.payload.updatedItems)));
        return {
            name: `${eventPrefix}.issue.move.success`,
            data: {
                transactionId: optimistic.id
            },
            trackEvents: trackEvents
        };
    };
const $8d4d6905372db5ee$export$ade8b8e0a05059d7 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.issue.move.failure`,
            data: {
                transactionId: action.meta.optimistic.id
            }
        });
const $8d4d6905372db5ee$export$2653a763eb1e7ed2 = (eventPrefix)=>(preState, state)=>{
        const issuesByLabel = (0, (/*@__PURE__*/$parcel$interopDefault($hm7zS)))((0, $5mTgl.workIssuesSelector)(state), (issue)=>issue.labels.length > 10 ? 10 : issue.labels.length);
        const numIssues = (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))((0, $g5X3G.values)(issuesByLabel));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const issueLabelsFlatten = {};
        Array(11).fill(0).forEach((value, labelsCount)=>{
            const issuesCount = issuesByLabel[String(labelsCount)] || 0;
            const labelCountPropName = labelsCount > 9 ? '10AndMore' : String(labelsCount);
            issueLabelsFlatten[`numIssuesWith${labelCountPropName}Labels`] = issuesCount;
        });
        return {
            name: `${eventPrefix}.issue.labels`,
            data: {
                numIssues: numIssues,
                ...issueLabelsFlatten
            }
        };
    };
const $8d4d6905372db5ee$export$d5dceae9c7c7bc77 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.dev-status.load.success`,
            data: {
                statusCount: Object.keys(action.payload).length
            }
        });
const $8d4d6905372db5ee$export$b1b86dea7a51e7b5 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.issue.swimlane-change`
        });
const $8d4d6905372db5ee$export$1c79b09f3075e4ea = (eventPrefix)=>(preState, state, action)=>{
        const { issueIds: issueIds, columnId: columnId } = action.payload;
        const columnIndex = (0, $fyeGd.getColumnIndex)(state, columnId);
        return {
            name: `${eventPrefix}.issue.move-to-backlog.request`,
            data: {
                issueIds: issueIds,
                columnIndex: (0, $8ECQ2.toOneBasedIndex)(columnIndex)
            }
        };
    };
const $8d4d6905372db5ee$export$5a53dd39dd4e0e24 = (eventPrefix)=>(preState, state, action)=>{
        const { issueIds: issueIds, columnId: columnId } = action.payload;
        const columnIndex = (0, $fyeGd.getColumnIndex)(state, columnId);
        return {
            name: `${eventPrefix}.issue.move-to-backlog.success`,
            data: {
                issueIds: issueIds,
                columnIndex: (0, $8ECQ2.toOneBasedIndex)(columnIndex)
            }
        };
    };
const $8d4d6905372db5ee$export$a9d1ce754cbce39 = (eventPrefix)=>(preState, state, action)=>{
        const { issueIds: issueIds } = action.payload;
        return {
            name: `${eventPrefix}.issue.move-to-backlog.failure`,
            data: {
                issueIds: issueIds
            }
        };
    };

});
parcelRegister("iThRn", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");

var $etyzk = parcelRequire("etyzk");
/**
 * Computes the sum of the values in `array`.
 *
 * @static
 * @memberOf _
 * @since 3.4.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @returns {number} Returns the sum.
 * @example
 *
 * _.sum([4, 2, 8, 6]);
 * // => 20
 */ function $dc0b37ac120f9bb6$var$sum(array) {
    return array && array.length ? $gBzAF(array, $etyzk) : 0;
}
module.exports = $dc0b37ac120f9bb6$var$sum;

});

parcelRegister("h4EJ8", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $k0qYG = parcelRequire("k0qYG");

var $cErmc = parcelRequire("cErmc");

var $ifYxh = parcelRequire("ifYxh");

var $jx6Tp = parcelRequire("jx6Tp");

var $kPZpS = parcelRequire("kPZpS");

var $jJVtR = parcelRequire("jJVtR");
/** Used as default options for `_.truncate`. */ var $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH = 30, $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION = '...';
/** Used to match `RegExp` flags from their coerced string values. */ var $c6e266ef199f8e9f$var$reFlags = /\w*$/;
/**
 * Truncates `string` if it's longer than the given maximum string length.
 * The last characters of the truncated string are replaced with the omission
 * string which defaults to "...".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to truncate.
 * @param {Object} [options={}] The options object.
 * @param {number} [options.length=30] The maximum string length.
 * @param {string} [options.omission='...'] The string to indicate text is omitted.
 * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
 * @returns {string} Returns the truncated string.
 * @example
 *
 * _.truncate('hi-diddly-ho there, neighborino');
 * // => 'hi-diddly-ho there, neighbo...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': ' '
 * });
 * // => 'hi-diddly-ho there,...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'length': 24,
 *   'separator': /,? +/
 * });
 * // => 'hi-diddly-ho there...'
 *
 * _.truncate('hi-diddly-ho there, neighborino', {
 *   'omission': ' [...]'
 * });
 * // => 'hi-diddly-ho there, neig [...]'
 */ function $c6e266ef199f8e9f$var$truncate(string, options) {
    var length = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_LENGTH, omission = $c6e266ef199f8e9f$var$DEFAULT_TRUNC_OMISSION;
    if ($k0qYG(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? $kPZpS(options.length) : length;
        omission = 'omission' in options ? $kHBB0(options.omission) : omission;
    }
    string = $jJVtR(string);
    var strLength = string.length;
    if ($axH2S(string)) {
        var strSymbols = $jx6Tp(string);
        strLength = strSymbols.length;
    }
    if (length >= strLength) return string;
    var end = length - $ifYxh(omission);
    if (end < 1) return omission;
    var result = strSymbols ? $gvFfr(strSymbols, 0, end).join('') : string.slice(0, end);
    if (separator === undefined) return result + omission;
    if (strSymbols) end += result.length - end;
    if ($cErmc(separator)) {
        if (string.slice(end).search(separator)) {
            var match, substring = result;
            if (!separator.global) separator = RegExp(separator.source, $jJVtR($c6e266ef199f8e9f$var$reFlags.exec(separator)) + 'g');
            separator.lastIndex = 0;
            while(match = separator.exec(substring))var newEnd = match.index;
            result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
    } else if (string.indexOf($kHBB0(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) result = result.slice(0, index);
    }
    return result + omission;
}
module.exports = $c6e266ef199f8e9f$var$truncate;

});
parcelRegister("cErmc", function(module, exports) {

var $3euyi = parcelRequire("3euyi");

var $cW28x = parcelRequire("cW28x");

var $lMQGH = parcelRequire("lMQGH");
/* Node.js helper references. */ var $935e70fe57caa939$var$nodeIsRegExp = $lMQGH && $lMQGH.isRegExp;
/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */ var $935e70fe57caa939$var$isRegExp = $935e70fe57caa939$var$nodeIsRegExp ? $cW28x($935e70fe57caa939$var$nodeIsRegExp) : $3euyi;
module.exports = $935e70fe57caa939$var$isRegExp;

});
parcelRegister("3euyi", function(module, exports) {

var $beQoo = parcelRequire("beQoo");

var $fC1Kz = parcelRequire("fC1Kz");
/** `Object#toString` result references. */ var $25aa60f3dfdc1028$var$regexpTag = '[object RegExp]';
/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */ function $25aa60f3dfdc1028$var$baseIsRegExp(value) {
    return $fC1Kz(value) && $beQoo(value) == $25aa60f3dfdc1028$var$regexpTag;
}
module.exports = $25aa60f3dfdc1028$var$baseIsRegExp;

});


parcelRegister("ifYxh", function(module, exports) {

var $dkmPN = parcelRequire("dkmPN");

var $axH2S = parcelRequire("axH2S");

var $61ekh = parcelRequire("61ekh");
/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */ function $d4a895dd16218f22$var$stringSize(string) {
    return $axH2S(string) ? $61ekh(string) : $dkmPN(string);
}
module.exports = $d4a895dd16218f22$var$stringSize;

});
parcelRegister("dkmPN", function(module, exports) {

var $8hdQS = parcelRequire("8hdQS");
/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ var $9b3edb0cff432526$var$asciiSize = $8hdQS('length');
module.exports = $9b3edb0cff432526$var$asciiSize;

});

parcelRegister("61ekh", function(module, exports) {
/** Used to compose unicode character classes. */ var $461df2ef275f3803$var$rsAstralRange = '\\ud800-\\udfff', $461df2ef275f3803$var$rsComboMarksRange = '\\u0300-\\u036f', $461df2ef275f3803$var$reComboHalfMarksRange = '\\ufe20-\\ufe2f', $461df2ef275f3803$var$rsComboSymbolsRange = '\\u20d0-\\u20ff', $461df2ef275f3803$var$rsComboRange = $461df2ef275f3803$var$rsComboMarksRange + $461df2ef275f3803$var$reComboHalfMarksRange + $461df2ef275f3803$var$rsComboSymbolsRange, $461df2ef275f3803$var$rsVarRange = '\\ufe0e\\ufe0f';
/** Used to compose unicode capture groups. */ var $461df2ef275f3803$var$rsAstral = '[' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsCombo = '[' + $461df2ef275f3803$var$rsComboRange + ']', $461df2ef275f3803$var$rsFitz = '\\ud83c[\\udffb-\\udfff]', $461df2ef275f3803$var$rsModifier = '(?:' + $461df2ef275f3803$var$rsCombo + '|' + $461df2ef275f3803$var$rsFitz + ')', $461df2ef275f3803$var$rsNonAstral = '[^' + $461df2ef275f3803$var$rsAstralRange + ']', $461df2ef275f3803$var$rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}', $461df2ef275f3803$var$rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]', $461df2ef275f3803$var$rsZWJ = '\\u200d';
/** Used to compose unicode regexes. */ var $461df2ef275f3803$var$reOptMod = $461df2ef275f3803$var$rsModifier + '?', $461df2ef275f3803$var$rsOptVar = '[' + $461df2ef275f3803$var$rsVarRange + ']?', $461df2ef275f3803$var$rsOptJoin = '(?:' + $461df2ef275f3803$var$rsZWJ + '(?:' + [
    $461df2ef275f3803$var$rsNonAstral,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair
].join('|') + ')' + $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + ')*', $461df2ef275f3803$var$rsSeq = $461df2ef275f3803$var$rsOptVar + $461df2ef275f3803$var$reOptMod + $461df2ef275f3803$var$rsOptJoin, $461df2ef275f3803$var$rsSymbol = '(?:' + [
    $461df2ef275f3803$var$rsNonAstral + $461df2ef275f3803$var$rsCombo + '?',
    $461df2ef275f3803$var$rsCombo,
    $461df2ef275f3803$var$rsRegional,
    $461df2ef275f3803$var$rsSurrPair,
    $461df2ef275f3803$var$rsAstral
].join('|') + ')';
/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */ var $461df2ef275f3803$var$reUnicode = RegExp($461df2ef275f3803$var$rsFitz + '(?=' + $461df2ef275f3803$var$rsFitz + ')|' + $461df2ef275f3803$var$rsSymbol + $461df2ef275f3803$var$rsSeq, 'g');
/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */ function $461df2ef275f3803$var$unicodeSize(string) {
    var result = $461df2ef275f3803$var$reUnicode.lastIndex = 0;
    while($461df2ef275f3803$var$reUnicode.test(string))++result;
    return result;
}
module.exports = $461df2ef275f3803$var$unicodeSize;

});



parcelRegister("f2NGE", function(module, exports) {

$parcel$export(module.exports, "getFieldLengthForAnalytics", () => $b46d240c3082c919$export$e337040f61dd6dff);
const $b46d240c3082c919$export$e337040f61dd6dff = (length)=>{
    if (!length) return '0';
    if (length > 3) return '>3';
    return String(length);
};

});

parcelRegister("01j5n", function(module, exports) {

$parcel$export(module.exports, "isUserNetworkError", () => $5ca31bd2f34603ab$export$34bc86f6bf17f1e0);
$parcel$export(module.exports, "isClientSideThirdPartyAppError", () => $5ca31bd2f34603ab$export$ed0f33c09abc69f3);
$parcel$export(module.exports, "isFailureStatusCode", () => $5ca31bd2f34603ab$export$790c76b8c83c3421);
$parcel$export(module.exports, "default", () => $5ca31bd2f34603ab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $g0Gtc = parcelRequire("g0Gtc");

var $2YZCu = parcelRequire("2YZCu");

var $kobfu = parcelRequire("kobfu");

var $fZneA = parcelRequire("fZneA");

var $7tQej = parcelRequire("7tQej");

var $4R6GH = parcelRequire("4R6GH");

var $hdE8g = parcelRequire("hdE8g");

var $3vXOY = parcelRequire("3vXOY");

var $e2KRD = parcelRequire("e2KRD");

const $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus = ({ location: location, statusCode: statusCode, traceId: traceId, hash: hash, buildKey: buildKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReasonWithStatusCode)((0, $3e83829bdc9c581d$export$a3bb34ea5a520df8), statusCode),
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
const $5ca31bd2f34603ab$export$34bc86f6bf17f1e0 = (error)=>{
    const networkErrorName = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'name'
    ], null);
    const networkErrorStatusCode = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'networkError',
        'statusCode'
    ], null);
    if (networkErrorName && !networkErrorStatusCode) (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.network.error.unknown.error.name', networkErrorName);
    // A fetch() promise will reject with a TypeError when a network error is encountered or CORS is misconfigured on the server-side,
    // although this usually means permission issues or similar — a 404 does not constitute a network error
    // more https://developer.mozilla.org/en-US/docs/Web/API/Fetch_API/Using_Fetch#Checking_that_the_fetch_was_successful
    return networkErrorName === 'TypeError' || networkErrorName === 'AbortError';
};
const $5ca31bd2f34603ab$export$8a5d666d6e5b82fc = (error)=>{
    if (error?.name === 'ChunkLoadError') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.chunk.load.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$export$7193151b5738a995 = (error)=>{
    if (error?.name === 'ResponseNullError') {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.response.null.error', error?.name, {
            message: error.message
        });
        return true;
    }
    return false;
};
const $5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS = [
    'FPClassifier is not defined'
];
const $5ca31bd2f34603ab$export$ed0f33c09abc69f3 = (error)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(error.message) && !!$5ca31bd2f34603ab$var$KNOWN_CLIENT_SIDE_THIRD_PARTY_APP_ERRORS.find((errorMessage)=>error?.message?.includes(errorMessage));
const $5ca31bd2f34603ab$export$790c76b8c83c3421 = (statusCode)=>{
    if (statusCode == null || statusCode === 429 || statusCode >= 500) // jira is too busy, unknown error or server error
    return true;
    if (statusCode >= 400 && statusCode < 500) return false;
    return true;
};
const $5ca31bd2f34603ab$var$detectLocalNetworkErrors = (errorResponse)=>{
    if ($5ca31bd2f34603ab$export$34bc86f6bf17f1e0(errorResponse)) return 0, $3e83829bdc9c581d$export$3c39b2049cd1acb3;
    if ($5ca31bd2f34603ab$export$8a5d666d6e5b82fc(errorResponse)) return 0, $3e83829bdc9c581d$export$fdfe3175a0c7be80;
    if ((0, $fZneA.isClientFetchError)(errorResponse)) return 0, $3e83829bdc9c581d$export$38fe4329f59f7ac5;
    if ($5ca31bd2f34603ab$export$7193151b5738a995(errorResponse)) return 0, $3e83829bdc9c581d$export$49d11848b43d6dbf;
    if ($5ca31bd2f34603ab$export$ed0f33c09abc69f3(errorResponse)) return 0, $3e83829bdc9c581d$export$32e56551129a1642;
    return null;
};
const $5ca31bd2f34603ab$var$responseToSla = (errorResponse, location)=>{
    const statusCode = (0, $3vXOY.extractStatusCode)(errorResponse);
    const abortFailureReason = $5ca31bd2f34603ab$var$detectLocalNetworkErrors(errorResponse);
    const traceId = (0, $hdE8g.extractTraceId)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const hash = (0, $kobfu.getErrorHash)(errorResponse) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const buildKey = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(window, [
        'BUILD_KEY'
    ]) || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    const errorResponseMessage = errorResponse?.message || (0, $3e83829bdc9c581d$export$fa14a20fcf1b1eb4);
    if (abortFailureReason) // Fire SLA Abort event to monitor the volume of client-side issues without impacting SLO
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)(abortFailureReason),
            error: errorResponseMessage,
            statusCode: statusCode || '',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === null) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('nextgen.sla.unknown.failure', (0, $3e83829bdc9c581d$export$b4f05a271d0831dc), {
            networkErrorName: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'name'
            ], ''),
            networkStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'networkError',
                'statusCode'
            ], ''),
            graphqlStatusCode: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(errorResponse, [
                'graphQLErrors',
                0,
                'extensions',
                'statusCode'
            ], ''),
            location: location,
            error: JSON.stringify(errorResponse, Object.getOwnPropertyNames(errorResponse)),
            hash: hash
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceFailureTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$b4f05a271d0831dc)),
                traceId: traceId,
                buildKey: buildKey,
                error: JSON.stringify({
                    message: errorResponseMessage
                }),
                hash: hash
            }
        });
    }
    // based on https://hello.atlassian.net/wiki/spaces/agile/pages/512782292/SWAG+response+handling+on+the+client
    // `EXPERIENCE_TRACKER_LOCATION_BACKLOG`, defined in `src/packages/software/backlog/src/common/constants/analytics.tsx`
    if (location === 'ng-backlog' && (0, $4R6GH.fg)('jira-backlog-tmp-add-status-code-to-taskabort')) {
        if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
            location: location,
            failureEventAttributes: {
                ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$c4493605407b2630)),
                error: errorResponseMessage,
                statusCode: statusCode.toString(),
                buildKey: buildKey,
                traceId: traceId,
                hash: hash
            }
        });
    }
    if (statusCode === 400 || statusCode === 401 || statusCode === 403) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode === 429) // jira is too busy
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceAbortTracker), {
        location: location,
        failureEventAttributes: {
            ...(0, $e2KRD.createFailureReason)((0, $3e83829bdc9c581d$export$7b9f56c34c008ec2)),
            error: errorResponseMessage,
            statusCode: '429',
            buildKey: buildKey,
            traceId: traceId,
            hash: hash
        }
    });
    if (statusCode === 404) // redirect to "all-projects" page or error page, when page is not found
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7tQej.Redirect), {
        to: "/jira/software/projects/not-found"
    });
    if (statusCode > 400 && statusCode < 500) // the rest of 40X
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: location
    });
    if (statusCode >= 500) return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
    return $5ca31bd2f34603ab$var$renderExperienceFailureWithStatus({
        location: location,
        statusCode: statusCode,
        traceId: traceId,
        hash: hash,
        buildKey: buildKey
    });
};
var $5ca31bd2f34603ab$export$2e2bcd8739ae039 = $5ca31bd2f34603ab$var$responseToSla;

});
parcelRegister("hdE8g", function(module, exports) {

$parcel$export(module.exports, "extractTraceId", () => $6db1ddf832c04f2d$export$431eacb6aecbacdf);
const $6db1ddf832c04f2d$export$431eacb6aecbacdf = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
error)=>String(error?.traceId || error?.networkError?.traceId || '');

});

parcelRegister("e2KRD", function(module, exports) {

$parcel$export(module.exports, "createFailureReason", () => $360af9265ac477eb$export$b9e48ed6f1b092c7);
$parcel$export(module.exports, "createFailureReasonWithStatusCode", () => $360af9265ac477eb$export$cc7dce678df87fe9);
const $360af9265ac477eb$export$b9e48ed6f1b092c7 = (reason)=>({
        failureReason: reason,
        errorMessage: reason
    });
const $360af9265ac477eb$export$cc7dce678df87fe9 = (reason, statusCode)=>{
    if (statusCode === undefined || statusCode === null) return {
        failureReason: reason,
        statusCode: '[unknown]',
        errorMessage: `${reason}-unknown`
    };
    return {
        failureReason: reason,
        statusCode: `${statusCode}`,
        errorMessage: `${reason}-${statusCode}`
    };
};

});

const $3e83829bdc9c581d$export$b4f05a271d0831dc = 'critical-data-failed-unknown-reason';
const $3e83829bdc9c581d$export$a3bb34ea5a520df8 = 'critical-data-failed-with-status-code';
const $3e83829bdc9c581d$export$7b9f56c34c008ec2 = '429-error';
const $3e83829bdc9c581d$export$c4493605407b2630 = 'client-error';
const $3e83829bdc9c581d$export$3c39b2049cd1acb3 = 'user-network-error';
const $3e83829bdc9c581d$export$fdfe3175a0c7be80 = 'chunk-load-error';
const $3e83829bdc9c581d$export$38fe4329f59f7ac5 = 'client-fetch-error';
const $3e83829bdc9c581d$export$49d11848b43d6dbf = 'response-null-error';
const $3e83829bdc9c581d$export$32e56551129a1642 = 'client-third-party-app-error';
const $3e83829bdc9c581d$export$fa14a20fcf1b1eb4 = 'unknown';



parcelRegister("c0Kii", function(module, exports) {

$parcel$export(module.exports, "issueDeleteModalOpen", () => $3445d9a636e939f1$export$4807059b0e0495d2);
$parcel$export(module.exports, "issueDeleteModalClose", () => $3445d9a636e939f1$export$b8ef0a3642381);
const $3445d9a636e939f1$export$4807059b0e0495d2 = (eventPrefix)=>(preState, state, action)=>({
            name: `${eventPrefix}.issue.delete.modal.open`,
            data: {
                issueId: action.payload.issueId,
                columnIndex: action.payload.columnIndex
            }
        });
const $3445d9a636e939f1$export$b8ef0a3642381 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.issue.delete.modal.close`
        });

});

parcelRegister("hpG0x", function(module, exports) {

$parcel$export(module.exports, "issueMediaVisibilityChange", () => $c00e88311800c1a3$export$729fe6d4b853e2ab);
const $c00e88311800c1a3$export$729fe6d4b853e2ab = (eventPrefix)=>(preState, state, action)=>{
        const { issueId: issueId, isVisible: isVisible } = action.payload;
        return {
            name: `${eventPrefix}.card.media.toggled.card`,
            data: {
                issueId: issueId,
                enabled: isVisible
            }
        };
    };

});

parcelRegister("8yIXy", function(module, exports) {

$parcel$export(module.exports, "swimlaneModeChanged", () => $740bbfadba4b444f$export$ddc71706a3b45faf);

var $iuuJH = parcelRequire("iuuJH");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");
const $740bbfadba4b444f$export$ddc71706a3b45faf = (eventPrefix)=>(preState, state)=>{
        const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
        return {
            name: `${eventPrefix}.swimlane.mode.changed`,
            data: {
                hasSwimlanes: hasSwimlanes,
                numSwimlanes: hasSwimlanes ? (0, $4jZ56.getSwimlanes)(state).length : 0
            }
        };
    };

});

parcelRegister("jYl7U", function(module, exports) {

$parcel$export(module.exports, "boardNonCriticalView", () => $c0680dad691ef4f6$export$8a605ef273fd8c8);
$parcel$export(module.exports, "boardView", () => $c0680dad691ef4f6$export$50191da575ef3bdf);
$parcel$export(module.exports, "boardLoadFailure", () => $c0680dad691ef4f6$export$dd70b93515666e3a);
$parcel$export(module.exports, "boardLoadNoColumnFailure", () => $c0680dad691ef4f6$export$dd59f805aee5f1b7);
$parcel$export(module.exports, "workRefreshData", () => $c0680dad691ef4f6$export$c65e4e12058e64e2);

var $9XE6b = parcelRequire("9XE6b");

var $gccSB = parcelRequire("gccSB");

var $cuHs1 = parcelRequire("cuHs1");

var $hhweD = parcelRequire("hhweD");

var $2YZCu = parcelRequire("2YZCu");

var $fjcgS = parcelRequire("fjcgS");

var $6uzgj = parcelRequire("6uzgj");

var $a4XJc = parcelRequire("a4XJc");

var $8zmNw = parcelRequire("8zmNw");


var $iuuJH = parcelRequire("iuuJH");

var $1vXOx = parcelRequire("1vXOx");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");
const $c0680dad691ef4f6$export$21761b53d261ebd0 = (estimationStatisticFieldId)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(estimationStatisticFieldId)) return 0, $dcbb2bce513725b3$export$8775696968c9b13c;
    if (estimationStatisticFieldId === (0, $dcbb2bce513725b3$export$d02889a654103c98)) return 0, $dcbb2bce513725b3$export$bfb354504bb547a0;
    if (!estimationStatisticFieldId.startsWith('customfield_')) (0, $2YZCu.default).safeErrorWithoutCustomerData('board.critical.load.boardscope.transform.failure', `Could not map estimation with field id ${estimationStatisticFieldId} to supported estimation types`);
    return 0, $dcbb2bce513725b3$export$405b6d72f2d243a9;
};
const $c0680dad691ef4f6$export$8a605ef273fd8c8 = (eventPrefix)=>(preState, state, action)=>{
        const isCMP = (0, $67Z81.getIsCMPBoard)(state);
        const isClassicCardCoverViewSettingEnabled = (0, $8zmNw.getViewSettings)({
            boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
            view: (0, $a4XJc.View).BOARD
        })?.showCardCovers;
        const hasCovers = isCMP ? isClassicCardCoverViewSettingEnabled : (0, $5mTgl.isCardMediaEnabled)(state);
        const issueLinkStatsViewSettings = {
            showIssueLinksStatsViewSettings: Boolean((0, $8zmNw.getViewSettings)({
                boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
                view: (0, $a4XJc.View).BOARD
            })?.showIssueLinksStats)
        };
        const dueDateStats = {
            showDueDateViewSettings: (0, $67Z81.getIsDueDateEnabled)(state) && Boolean((0, $8zmNw.getViewSettings)({
                boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
                view: (0, $a4XJc.View).BOARD
            })?.showDueDate),
            numCardsWithDueDates: (0, $5mTgl.getNumberOfCardsWithDueDates)(state)
        };
        const attributes = {
            numCards: (0, $5mTgl.workIssuesSelector)(state).length,
            numCardsWithCovers: hasCovers ? (0, $5mTgl.getNumberOfCardsWithCovers)(state) : 0,
            hasCovers: hasCovers,
            ...issueLinkStatsViewSettings,
            ...dueDateStats
        };
        const cardCoverAnalyticsAttributes = {
            action: 'viewed',
            containerType: 'project',
            containerId: String((0, $67Z81.projectIdSelector)(state)),
            objectType: 'board',
            objectId: String((0, $67Z81.rapidViewIdSelector)(state)),
            attributes: attributes
        };
        (0, $hhweD.fireTrackAnalytics)(action.meta.analytics, cardCoverAnalyticsAttributes);
        return {
            name: `${eventPrefix}.view`,
            data: {}
        };
    };
const $c0680dad691ef4f6$export$50191da575ef3bdf = (eventPrefix)=>(preState, state, action)=>{
        // Performance based marks on board view
        const issueNo = (0, $5mTgl.workIssuesSelector)(state).length;
        const people = (0, $36pz7.getPeople)(state);
        const doneColumnId = (0, $fyeGd.doneColumnIdSelector)(state);
        const numIssuesInDoneColumn = {
            numIssuesInDoneColumn: (0, $5mTgl.getColumnTotalIssuesCount)(state, doneColumnId)
        };
        const toDoColumnId = (0, $fyeGd.initialColumnIdSelector)(state);
        const numIssuesInToDoColumn = {
            numIssuesInToDoColumn: (0, $5mTgl.getColumnTotalIssuesCount)(state, toDoColumnId)
        };
        const featureAttributes = (0, $6uzgj.getFeatureAnalyticsAttributes)((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $67Z81.getEntities)(state), [
            'board',
            'config',
            'allFeatures'
        ], []));
        const permissions = (0, (/*@__PURE__*/$parcel$interopDefault($cuHs1)))((0, $1vXOx.boardPermissionsSelector)(state), (permission, key)=>`has_${key}_permission`);
        const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
        const swimlanesPayload = {
            hasSwimlanes: hasSwimlanes,
            numSwimlanes: hasSwimlanes ? (0, $4jZ56.getSwimlanes)(state).length : 0,
            numVisibleSwimlanes: hasSwimlanes ? (0, $4jZ56.getSwimlanes)(state).length : 0
        };
        const estimationType = $c0680dad691ef4f6$export$21761b53d261ebd0((0, $5mTgl.getEstimationStatistic)(state));
        const isCompanyManaged = (0, $67Z81.getIsCMPBoard)(state);
        const isQuickFiltersBarToggled = (0, $8zmNw.getViewSettings)({
            boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
            view: (0, $a4XJc.View).BOARD
        })?.showQuickFilters;
        const numQuickFilters = (0, $5mTgl.getCustomFilters)(state).length;
        const cmpAttributes = isCompanyManaged && {
            numQuickFilters: numQuickFilters,
            isQuickFiltersBarToggled: isQuickFiltersBarToggled
        };
        const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        let ipAttributes;
        if (isIPBoard) {
            const { iterationLength: iterationLength, iterationsCount: iterationsCount } = (0, $67Z81.getIncrementConfig)(state) ?? {};
            ipAttributes = {
                iterationLength: iterationLength,
                iterationsCount: iterationsCount
            };
        }
        const isUnscheduledWorkColumnPanel = action.payload.isUnscheduledWorkColumnPanel;
        const boardViewAnalyticsAttributes = {
            action: 'viewed',
            containerType: 'project',
            containerId: String((0, $67Z81.projectIdSelector)(state)),
            objectType: 'board',
            objectId: String((0, $67Z81.rapidViewIdSelector)(state)),
            attributes: {
                ...featureAttributes,
                ...permissions,
                boardId: (0, $67Z81.rapidViewIdSelector)(state),
                boardType: (0, $67Z81.getBoardTypeForAnalytics)(state),
                numIssues: issueNo,
                numSubtasks: (0, $3UY9S.numTotalIssueChildren)(state),
                numCompleteSubtasks: (0, $3UY9S.numCompleteIssueChildren)(state),
                numIssueParents: (0, $bSSdD.issueParentIdsSelector)(state).length,
                numIssueTypes: (0, $4gt6L.issueTypeIdsSelector)(state).length,
                numColumns: (0, $5mTgl.workColumnsSelector)(state).length,
                numLabels: (0, $d2i8f.issueLabelsSelector)(state).length,
                hasHorizontalScrollbar: action.payload.hasHorizontalScrollbar,
                hasFilteredIssues: (0, $5mTgl.getBoardHasFilteredIssues)(state),
                hasColumnLimits: (0, $fyeGd.hasColumnLimits)(state),
                hasNonGlobalTransitions: (0, $9OPlz.hasNonGlobalTransitions)(state),
                hasConditionsOnTransitions: (0, $9OPlz.hasConditionsOnTransitions)(state),
                hasDoneColumnInLastPosition: (0, $fyeGd.hasDoneColumnInLastPositionSelector)(state),
                hasMoreThanFiveColumn: (0, $fyeGd.hasMoreThanFiveColumn)(state),
                hasMultipleDoneColumns: (0, $fyeGd.hasMultipleDoneColumnSelector)(state),
                swimlaneMode: (0, $45cXl.getSwimlaneMode)(state),
                numberOfAssigneesOnBoard: Object.keys(people).length,
                numDoneColumns: (0, $fyeGd.getDoneColumnsSelector)(state).length,
                hasInlineColumnEdit: (0, $5mTgl.isInlineColumnEditEnabled)(state),
                hasInlineCardCreate: (0, $9UXXB.hasInlineCardCreateConfig)(state),
                isCustomBoardWithIcc: (0, $9UXXB.getIsCustomBoardWithIcc)(state),
                inlineCardCreateMode: (0, $9UXXB.getInlineCardCreateConfig)(state)?.mode,
                ...numIssuesInDoneColumn,
                ...numIssuesInToDoColumn,
                ...swimlanesPayload,
                estimationStatistic: estimationType,
                issueResultProjectIds: (0, $67Z81.getIssueProjectIds)(state),
                ...cmpAttributes,
                ...ipAttributes
            }
        };
        if (!isUnscheduledWorkColumnPanel) // we don't want to fire analytics if the board is the unscheduled work panel (increment planning)
        // as this is unneccessarily doubling the analytics events on the page
        (0, $hhweD.fireTrackAnalytics)(action.meta.analytics, boardViewAnalyticsAttributes);
        return {
            name: `${eventPrefix}.view`,
            data: {
                hasHorizontalScrollbar: action.payload.hasHorizontalScrollbar,
                hasFilteredIssues: (0, $5mTgl.getBoardHasFilteredIssues)(state),
                hasColumnLimits: (0, $fyeGd.hasColumnLimits)(state),
                numIssues: issueNo,
                numIssueParents: (0, $bSSdD.issueParentIdsSelector)(state).length,
                numIssueTypes: (0, $4gt6L.issueTypeIdsSelector)(state).length,
                numColumns: (0, $5mTgl.workColumnsSelector)(state).length,
                numLabels: (0, $d2i8f.issueLabelsSelector)(state).length,
                ...swimlanesPayload
            }
        };
    };
const $c0680dad691ef4f6$export$dd70b93515666e3a = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load.failure`,
            data: {}
        });
const $c0680dad691ef4f6$export$dd59f805aee5f1b7 = (eventPrefix)=>()=>({
            name: `${eventPrefix}.load.failure.no-column`,
            data: {}
        });
const $c0680dad691ef4f6$export$c65e4e12058e64e2 = (eventPrefix)=>(preState, state, action)=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const payload = {
                action: 'triggered',
                actionSubject: 'workRefreshData',
                actionSubjectId: `${eventPrefix}.refresh`,
                source: 'boardScreen',
                attributes: {
                    source: action.payload.source
                }
            };
            client.getInstance().sendTrackEvent(payload);
        });
        return {
            name: `${eventPrefix}.refresh`,
            data: {
                source: action.payload.source
            }
        };
    };

});
parcelRegister("cuHs1", function(module, exports) {

var $1m3dq = parcelRequire("1m3dq");

var $hDnyx = parcelRequire("hDnyx");

var $bxDef = parcelRequire("bxDef");
/**
 * The opposite of `_.mapValues`; this method creates an object with the
 * same values as `object` and keys generated by running each own enumerable
 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
 * with three arguments: (value, key, object).
 *
 * @static
 * @memberOf _
 * @since 3.8.0
 * @category Object
 * @param {Object} object The object to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Object} Returns the new mapped object.
 * @see _.mapValues
 * @example
 *
 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
 *   return key + value;
 * });
 * // => { 'a1': 1, 'b2': 2 }
 */ function $0258ef72e36fbfcb$var$mapKeys(object, iteratee) {
    var result = {};
    iteratee = $bxDef(iteratee, 3);
    $hDnyx(object, function(value, key, object) {
        $1m3dq(result, iteratee(value, key, object), value);
    });
    return result;
}
module.exports = $0258ef72e36fbfcb$var$mapKeys;

});

parcelRegister("6uzgj", function(module, exports) {

$parcel$export(module.exports, "getFeatureAnalyticsAttributes", () => $130d3cc5b8e064da$export$ac70e171fbeaebce);
const $130d3cc5b8e064da$export$4517b897375f940f = (key)=>`is_${key}_enabled`;
const $130d3cc5b8e064da$export$ac70e171fbeaebce = (allFeatures)=>{
    const result = {};
    allFeatures.forEach((feature)=>{
        result[$130d3cc5b8e064da$export$4517b897375f940f(feature.key)] = feature.status === 'ENABLED';
    });
    return result;
};

});




parcelRegister("iQYKJ", function(module, exports) {

$parcel$export(module.exports, "actionMetricsMiddleware", () => $98e159e32061235a$export$86019bcfe40705fe);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $65C0W = parcelRequire("65C0W");
const $98e159e32061235a$export$86019bcfe40705fe = ()=>(next)=>(action)=>{
            let result;
            if (action.type === (0, $65C0W.SOFTWARE_APP_LOADED)) {
                // Measure how long it takes to execute the action when the software app is loaded
                // to get better insight into performance of large boards.
                (0, $x9xyg.setMark)((0, $8PRuf.jswReduxSoftwareAppLoadedStartMark));
                result = next(action);
                (0, $x9xyg.setMark)((0, $8PRuf.jswReduxSoftwareAppLoadedEndMark));
            } else result = next(action);
            return result;
        };

});

parcelRegister("5YGyZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae1ac2a5e90639e8$export$2e2bcd8739ae039);


var $hi6AJ = parcelRequire("hi6AJ");

var $4R6GH = parcelRequire("4R6GH");

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $7tJ5d = parcelRequire("7tJ5d");

var $dnW4F = parcelRequire("dnW4F");

var $bkCF5 = parcelRequire("bkCF5");

var $bZ9IJ = parcelRequire("bZ9IJ");

var $9WrsG = parcelRequire("9WrsG");

var $dN3Ms = parcelRequire("dN3Ms");

var $dW1HX = parcelRequire("dW1HX");

var $2ON1s = parcelRequire("2ON1s");

var $hoX5N = parcelRequire("hoX5N");

var $d315K = parcelRequire("d315K");

var $65C0W = parcelRequire("65C0W");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");

var $cwdC8 = parcelRequire("cwdC8");

var $f3MfI = parcelRequire("f3MfI");

var $fC72p = parcelRequire("fC72p");
// We ignore the success and failure mutations, we just invalidate them as soon as the request
// is fired. That way if someone navigates away before the SUCCESS/FAILURE mutation returns they
// won't get an incorrect cached version
const $ae1ac2a5e90639e8$var$BOARD_IGNORE_REGEX = /^(state\.actions\.).+(_SUCCESS|_FAILURE)$/;
// This one helps us ignore junk like COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION
const $ae1ac2a5e90639e8$var$ELIGIBLE_FOR_INVALIDATION = /^(state\.actions\.).+$/;
const $ae1ac2a5e90639e8$export$d4b7dead01a52ae = ({ type: type })=>{
    // There are a lot of mutations that just get fired on startup which will immediately
    // invalidate the cache. Just ignore those
    switch(type){
        case 0, $cW3pH.WORK_REFRESH_DATA:
        case 0, $hoX5N.PERSON_SET:
        case 0, $65C0W.SOFTWARE_APP_LOADED:
        case 0, $9WrsG.DEV_STATUS_LOAD:
        case 0, $cW3pH.BOARD_VIEW:
        case 0, $cW3pH.BOARD_NON_CRITICAL_VIEW:
        case 0, $cW3pH.WORK_DATA_SET:
        case 0, $cW3pH.WORK_DATA_CRITICAL_SET:
        case 0, $d315K.REALTIME_DISPATCH_EVENT:
        case 0, $dnW4F.FILTER_PANEL_MOUNTED:
        case 0, $dW1HX.CLOSE_ISSUE_MODAL:
        case 0, $dW1HX.OPEN_ISSUE_MODAL:
        case 0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST:
        case 0, $2f454.CARD_MEDIA_DATA_SET:
        case 0, $2f454.CARD_REFRESH_REQUEST:
        case 0, $2f454.SET_ACTIVE_ISSUE_WITH_ICC:
        case 0, $2f454.CARD_CLICK:
        case 0, $2f454.CARD_TOGGLE_SELECTION:
        case 0, $2f454.CARD_MULTI_SELECT:
        case 0, $2f454.CARD_SINGLE_SELECT:
        case 0, $2f454.CARD_DRAG_SELECTED_TRANSITION:
        case 0, $2f454.CARD_DRAG_OVER_TRANSITION:
        case 0, $2f454.CARD_DRAG_OVER_TRANSITION_REQUEST:
        case 0, $dnW4F.SEARCH_FOCUS:
        case 0, $2f454.SET_ISSUE_ID_WITH_ABOVE_ICC_OPEN:
        case 0, $dnW4F.CLEAR_ALL_FILTERS_CLICKED:
        case 0, $2f454.CARD_FOCUS:
        case 0, $bZ9IJ.SHOW_ASSIGN_ISSUE_PARENT_MODAL:
        case 0, $bZ9IJ.HIDE_ASSIGN_ISSUE_PARENT_MODAL:
        case 0, $63F6h.COLUMN_DELETE_MODAL_CLOSE:
        case 0, $dnW4F.FILTERS_SET:
        case 0, $dnW4F.SET_ALL_FILTERS:
        case 0, $dnW4F.FILTERS_JQL_SET:
        case 0, $2f454.CARD_REMOVE_SHOW_RIPPLE:
        case 0, $2f454.CARD_ADD_SHOW_RIPPLE:
        case 0, $2f454.CARD_GET_ISSUE_TRANSITIONS:
        case 0, $2f454.CARD_SET_ISSUE_TRANSITIONS:
        case 0, $7tJ5d.UPDATE_DETAIL_VIEW:
        case 0, $2ON1s.TOGGLE_PANEL:
        case 0, $bkCF5.FLAG_DISMISSED:
        case 0, $k50Aq.SWIMLANES_TOGGLE:
        case 0, $k50Aq.SWIMLANE_TOGGLE:
        case 0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST:
        case 0, $eu61M.DRAG_START:
        case 0, $eu61M.DRAG_END:
        case 0, $2f454.CARD_BLUR:
        case 0, $2f454.CARD_PREV:
        case 0, $2f454.CARD_NEXT:
        case 0, $2f454.CARD_PREV_COLUMN:
        case 0, $2f454.CARD_NEXT_COLUMN:
        case 0, $65C0W.SOFTWARE_DISPLAY_WARNING:
        case 0, $2f454.SET_INLINE_EDITING:
        case 0, $cwdC8.FETCH_ISSUE_LINKS_PERMISSIONS:
        case 0, $cwdC8.SET_ISSUE_LINKS_PERMISSIONS:
        case 0, $fC72p.SET_IS_FAVOURITE:
        case 0, $f3MfI.SET_CAN_USER_INVITE:
            return false;
        default:
            break;
    }
    if ((0, $4R6GH.fg)('fix_backlog_board_transition_cache')) switch(type){
        case 0, $cwdC8.FETCH_ISSUE_LINKS_PERMISSIONS:
        case 0, $cwdC8.SET_ISSUE_LINKS_PERMISSIONS:
        case 0, $fC72p.SET_IS_FAVOURITE:
        case 0, $f3MfI.SET_CAN_USER_INVITE:
            return false;
        default:
            break;
    }
    // Ignore stuff that isn't applicable to the board (e.g. COMMON/REDUX_DISPOSABLE/DISPOSE_ACTION)
    // Or If it is one that we ignore (SUCCESS/FAILURE)
    if (!$ae1ac2a5e90639e8$var$ELIGIBLE_FOR_INVALIDATION.exec(type) || $ae1ac2a5e90639e8$var$BOARD_IGNORE_REGEX.exec(type)) return false;
    // DEFAULT TO TRUE. It's better to forcibly refresh the cache if someone forgets to add
    // their mutation here
    return true;
};
var $ae1ac2a5e90639e8$export$2e2bcd8739ae039 = (0, $hi6AJ.default)((0, $8631d6ce464ccf2e$export$9b8283d5878d2491), $ae1ac2a5e90639e8$export$d4b7dead01a52ae);

});
parcelRegister("hi6AJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $1904eee7acf3b502$export$2e2bcd8739ae039);

var $b0yad = parcelRequire("b0yad");
const $1904eee7acf3b502$export$41c940a04807c68c = (subject)=>(origin, invalidationFunction)=>()=>(next)=>(action)=>{
                    // There is a potential that the action gets passed as undefined
                    if (action && invalidationFunction(action)) {
                        // Trigger cache invalidation. Let the listeners handle everything else
                        subject.next(origin);
                        (0, $b0yad.addInvalidationReason)(origin, action.type ?? 'UNKNOWN');
                    }
                    return next(action);
                };
var $1904eee7acf3b502$export$2e2bcd8739ae039 = $1904eee7acf3b502$export$41c940a04807c68c((0, $b0yad.default));

});
parcelRegister("b0yad", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d7966c085fcd143$export$2e2bcd8739ae039);
$parcel$export(module.exports, "triggerResourceCacheInvalidation", () => $0d7966c085fcd143$export$76c3549b2288ab5d);
$parcel$export(module.exports, "addInvalidationReason", () => $0d7966c085fcd143$export$77045c8772786aca);
$parcel$export(module.exports, "getAndClearInvalidationReasons", () => $0d7966c085fcd143$export$c5ab3b0612bd31b4);

var $cab1K = parcelRequire("cab1K");


var $h8O2U = parcelRequire("h8O2U");
const $0d7966c085fcd143$var$invalidationTracker = new (0, $h8O2U.CacheInvalidationTracker)();
// Standard observer pattern, the middleware in board/backlog will invoke this
// when it comes across a matching redux mutation that requires the cache
// to be purged
const $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject = new (0, $cab1K.Subject)();
var $0d7966c085fcd143$export$2e2bcd8739ae039 = $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject;
const $0d7966c085fcd143$export$76c3549b2288ab5d = (origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6))=>{
    $0d7966c085fcd143$var$ResourcesCacheInvalidationSubject.next(origin);
    $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
};
const $0d7966c085fcd143$export$77045c8772786aca = (origin, reason)=>{
    $0d7966c085fcd143$var$invalidationTracker.addReason(origin, reason);
};
const $0d7966c085fcd143$export$c5ab3b0612bd31b4 = (origin)=>$0d7966c085fcd143$var$invalidationTracker.getAndClearReasons(origin);

});
parcelRegister("h8O2U", function(module, exports) {

$parcel$export(module.exports, "CacheInvalidationTracker", () => $42c3911f8f33a9e0$export$71900622f425a7c3);

class $42c3911f8f33a9e0$export$71900622f425a7c3 {
    /**
	 * Pushes an invalidation reason to be tracked on the next cache-miss.
	 */ addReason(origin, reason = (0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)) {
        const reasonString = `${origin}:${reason}`;
        Object.keys(this.reasons).forEach((key)=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            if (this.reasons[key].size >= 10) return;
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type 'Partial<Record<CacheInvalidationType, Set<string>>>'.
            this.reasons[key].add(reasonString);
        });
    }
    /**
	 * Fetch invalidation reasons from the reasons set.
	 *
	 * If an experience does not read / clear reasons there's still only a bounded number of strings
	 * (10) that will be added into the Set; e.g. it's not a memory concern.
	 *
	 * The reasons are sorted.
	 */ getAndClearReasons(origin) {
        const reasonsSet = this.reasons[origin];
        const reasons = Array.from(reasonsSet);
        reasons.sort();
        reasonsSet.clear();
        return reasons;
    }
    constructor(){
        /**
	 * Holds reasons cache has been invalidated as a set of strings, for example:
	 *
	 * * BOARD:state.ISSUE_MOVE
	 * * BACKLOG:CREATE_SPRINT
	 *
	 * Reasons are kept separately for each page because they'll be cleared when the page is loaded.
	 *
	 * The reasoning can be exemplified by:
	 *
	 * * Visit board
	 * * Visit backlog
	 * * Visit roadmaps
	 * * Visit backlog - Load from cache
	 * * Make a BACKLOG:CARD_MOVE invalidation reason in backlog
	 *   * All 3 caches are now cleared
	 * * Visit board - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit roadmaps - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Visit backlog - reason is BACKLOG:CARD_MOVE - reasons are cleared;
	 * * Make a BACKLOG:SPRINT_COMPLETE invalidation reason in backlog
	 * * Visit board - reason is BACKLOG:SPRINT_COMPLETE **only**
	 */ this.reasons = {
            [(0, $8631d6ce464ccf2e$export$9b8283d5878d2491)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$dedbdcc35e955187)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$ffff0a2c60bf4822)]: new Set(),
            [(0, $8631d6ce464ccf2e$export$78244dbb77cfa6b6)]: new Set()
        };
    }
}

});



parcelRegister("bZ9IJ", function(module, exports) {

$parcel$export(module.exports, "SHOW_ASSIGN_ISSUE_PARENT_MODAL", () => $57b16eab1c65412b$export$a1239bded0580595);
$parcel$export(module.exports, "showAssignIssueParentModal", () => $57b16eab1c65412b$export$bde7b0aee6aed1e);
$parcel$export(module.exports, "HIDE_ASSIGN_ISSUE_PARENT_MODAL", () => $57b16eab1c65412b$export$5a2556acdb3df33b);
$parcel$export(module.exports, "hideAssignIssueParentModal", () => $57b16eab1c65412b$export$bac41e77c8fec802);
const $57b16eab1c65412b$export$a1239bded0580595 = 'state.actions.issue.assign-issue-parent-modal.SHOW_ASSIGN_ISSUE_PARENT_MODAL';
const $57b16eab1c65412b$export$bde7b0aee6aed1e = (issueIds)=>({
        type: $57b16eab1c65412b$export$a1239bded0580595,
        payload: {
            issueIds: issueIds
        }
    });
const $57b16eab1c65412b$export$5a2556acdb3df33b = 'state.actions.issue.assign-issue-parent-modal.HIDE_ASSIGN_ISSUE_PARENT_MODAL';
const $57b16eab1c65412b$export$bac41e77c8fec802 = ()=>({
        type: $57b16eab1c65412b$export$5a2556acdb3df33b
    });

});


parcelRegister("3sree", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2911f7d75948388$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $ja5ob = parcelRequire("ja5ob");

var $gJesu = parcelRequire("gJesu");

var $88zgs = parcelRequire("88zgs");
function $c2911f7d75948388$export$2e2bcd8739ae039() {
    return (0, $3f2cs.combineReducers)({
        configuration: (0, $ja5ob.configurationReducer),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        entities: (0, $gJesu.default)(),
        ui: (0, $88zgs.default)()
    });
}

});
parcelRegister("ja5ob", function(module, exports) {

$parcel$export(module.exports, "configurationReducer", () => $6720da300ed73b3e$export$d089b7f237574d6);

var $hGgHi = parcelRequire("hGgHi");

var $icGZu = parcelRequire("icGZu");

var $2vSU6 = parcelRequire("2vSU6");

var $lzeFL = parcelRequire("lzeFL");

var $l2T6l = parcelRequire("l2T6l");

var $f3MfI = parcelRequire("f3MfI");

var $cW3pH = parcelRequire("cW3pH");

var $fR6rG = parcelRequire("fR6rG");
const $6720da300ed73b3e$var$initialState = {
    contextPath: '',
    rapidViewId: '',
    cloudId: '',
    activationId: '',
    userAccountId: '',
    locale: (0, $lzeFL.defaultLocale),
    projectKey: '',
    projectId: 0,
    projectName: '',
    projectType: (0, $2vSU6.SOFTWARE_PROJECT),
    siteAdminStatus: 'unknown',
    licensedProducts: {},
    productCrossSellConfig: 'unknown',
    extension: {
        operations: []
    },
    sessionId: '',
    isCMPBoard: false,
    isUserBoard: false,
    isIncrementPlanningBoard: false,
    issueLimitExceeded: false,
    missingIssueType: '',
    canInviteOthersToProject: false
};
const $6720da300ed73b3e$export$953600079080052e = (projects, boardLocation)=>{
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(boardLocation) && boardLocation.type === 'PROJECT' && (0, (/*@__PURE__*/$parcel$interopDefault($icGZu)))(projects, {
        id: boardLocation.id
    })) return {
        id: boardLocation.id,
        key: boardLocation.key,
        name: boardLocation.name
    };
    // Fallback to the first project if the board location is not a project type
    // this is the original behavior from UIF migration
    return {
        id: projects[0]?.id ?? 0,
        key: projects[0]?.key ?? '',
        name: projects[0]?.name ?? ''
    };
};
const $6720da300ed73b3e$export$d089b7f237574d6 = (state = $6720da300ed73b3e$var$initialState, action)=>{
    const newState = (0, $l2T6l.chainUnsafe)(state).set('extension', (0, $fR6rG.default)(state.extension, action)).value();
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { projects: projects, boardLocation: boardLocation } = action.payload;
        const projectDetails = $6720da300ed73b3e$export$953600079080052e(projects, boardLocation);
        return {
            ...newState,
            projectName: projectDetails.name,
            projectId: projectDetails.id,
            projectKey: projectDetails.key,
            boardType: action.payload.boardType,
            etag: action.payload.etag,
            hierarchyNomenclature: action.payload.hierarchyNomenclature,
            issueLimitExceeded: action.payload.issueLimitExceeded ?? false,
            savedFilterId: action.payload.savedFilterId
        };
    }
    if (action.type === (0, $f3MfI.SET_CAN_USER_INVITE)) return {
        ...newState,
        canInviteOthersToProject: action.payload.canInviteOthersToProject
    };
    return newState;
};

});
parcelRegister("l2T6l", function(module, exports) {

$parcel$export(module.exports, "assocUnsafe", () => $10cc07b888293773$export$a759ec8fde46de77);
$parcel$export(module.exports, "dissocUnsafe", () => $10cc07b888293773$export$e0867c1b5da854fe);
$parcel$export(module.exports, "assocInUnsafe", () => $10cc07b888293773$export$1bfac1118aad2c2f);
$parcel$export(module.exports, "updateInUnsafe", () => $10cc07b888293773$export$f920b8c255ec1192);
$parcel$export(module.exports, "chainUnsafe", () => $10cc07b888293773$export$181c753256d1c9a0);

var $7uUwQ = parcelRequire("7uUwQ");
const $10cc07b888293773$export$a759ec8fde46de77 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assoc(collection, key, value);
const $10cc07b888293773$export$9b65d21cdbb50a87 = (collection, key, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.set(collection, key, value);
const $10cc07b888293773$export$e0867c1b5da854fe = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.dissoc(collection, key);
const $10cc07b888293773$export$958195bad0a3dbcf = (collection, key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.unset(collection, key);
const $10cc07b888293773$export$1bfac1118aad2c2f = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.assocIn(collection, path, value);
const $10cc07b888293773$export$565e6fa2e54b66b3 = (collection, path, value)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.setIn(collection, path, value);
const $10cc07b888293773$export$75197f11bfe5de5f = (collection, path)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    $7uUwQ.getIn(collection, path);
const $10cc07b888293773$export$f920b8c255ec1192 = (collection, path, callback)=>$7uUwQ.updateIn(collection, path, callback);
class $10cc07b888293773$var$IcepickUnsafeWrapper {
    constructor(collection){
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        this.wrapper = $7uUwQ.chain(collection);
    }
    value() {
        return this.wrapper.value();
    }
    freeze() {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.freeze().value());
    }
    assoc(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assoc(key, value).value());
    }
    set(key, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.set(key, value).value());
    }
    dissoc(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.dissoc(key).value());
    }
    unset(key) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.unset(key).value());
    }
    assocIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assocIn(path, value).value());
    }
    setIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.setIn(path, value).value());
    }
    getIn(path, value) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.getIn(path, value).value());
    }
    updateIn(path, callback) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.updateIn(path, callback).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    assign(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.assign(s1, s2, s3, s4).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(source).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3).value());
    }
    // @ts-expect-error - TS2393 - Duplicate function implementation.
    extend(s1, s2, s3, s4) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.extend(s1, s2, s3, s4).value());
    }
    merge(source) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.merge(source).value());
    }
    thru(val) {
        return new $10cc07b888293773$var$IcepickUnsafeWrapper(this.wrapper.thru(val).value());
    }
}
const $10cc07b888293773$export$181c753256d1c9a0 = (collection)=>new $10cc07b888293773$var$IcepickUnsafeWrapper(collection);

});

parcelRegister("fR6rG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3350f6b2dc8e67d$export$2e2bcd8739ae039);

var $eQEtH = parcelRequire("eQEtH");
const $c3350f6b2dc8e67d$var$initialState = {
    operations: []
};
function $c3350f6b2dc8e67d$export$2e2bcd8739ae039(state = $c3350f6b2dc8e67d$var$initialState, action) {
    if (action.type === (0, $eQEtH.EXTENSION_FETCH_SUCCESS)) return {
        ...state,
        ...action.payload.extension
    };
    return state;
}

});


parcelRegister("gJesu", function(module, exports) {

$parcel$export(module.exports, "default", () => $fe0e0555959d2fb0$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $alNv9 = parcelRequire("alNv9");

var $8J1tE = parcelRequire("8J1tE");

var $f8jqi = parcelRequire("f8jqi");

var $lAVlQ = parcelRequire("lAVlQ");

var $1cp3g = parcelRequire("1cp3g");

var $b4Neb = parcelRequire("b4Neb");

var $4AaHD = parcelRequire("4AaHD");

var $6v6W4 = parcelRequire("6v6W4");

var $7ANej = parcelRequire("7ANej");

var $9YkOZ = parcelRequire("9YkOZ");

var $8UrfO = parcelRequire("8UrfO");

var $7UqIo = parcelRequire("7UqIo");

var $2ZUt8 = parcelRequire("2ZUt8");

var $jVK6B = parcelRequire("jVK6B");

var $9Rk3Z = parcelRequire("9Rk3Z");

var $e3PD9 = parcelRequire("e3PD9");

var $qY0zX = parcelRequire("qY0zX");

var $11N2b = parcelRequire("11N2b");

var $ilheH = parcelRequire("ilheH");

var $eeFib = parcelRequire("eeFib");

var $gnRwu = parcelRequire("gnRwu");

var $1gv2w = parcelRequire("1gv2w");

var $8DmOP = parcelRequire("8DmOP");

var $cidFT = parcelRequire("cidFT");

var $kLXNe = parcelRequire("kLXNe");

var $6S8mJ = parcelRequire("6S8mJ");

var $3IVsJ = parcelRequire("3IVsJ");

var $9i87f = parcelRequire("9i87f");

var $lEneF = parcelRequire("lEneF");

var $8YtrK = parcelRequire("8YtrK");

var $2o5W8 = parcelRequire("2o5W8");
function $fe0e0555959d2fb0$export$2e2bcd8739ae039() {
    return (0, $alNv9.optimistic)((0, $3f2cs.combineReducers)({
        board: (0, $8J1tE.default)(),
        columns: (0, $lAVlQ.columnsReducer),
        issueChildren: (0, $7ANej.issueChildrenReducer),
        issueMedia: (0, $2ZUt8.issueMediaReducer),
        issueParents: (0, $jVK6B.default),
        issueProjects: (0, $e3PD9.issueProjectsReducer),
        issueTypes: (0, $ilheH.issueTypesReducer),
        projectIssueTypes: (0, $cidFT.projectIssueTypesReducer),
        requestTypes: (0, $kLXNe.requestTypesReducer),
        issues: (0, $eeFib.issueEntitiesReducer),
        people: (0, $8DmOP.peopleReducer),
        sprints: (0, $6S8mJ.sprintsReducer),
        statusCategories: (0, $3IVsJ.statusCategoriesReducer),
        statuses: (0, $9i87f.statusesReducer),
        cardTransitions: (0, $f8jqi.cardTransitionsReducer),
        issueTransitions: (0, $qY0zX.default),
        estimationStatistic: (0, $b4Neb.estimationStatisticReducer),
        inlineCreate: (0, $6v6W4.inlineCreateReducer),
        customFilters: (0, $1cp3g.customFiltersReducer),
        jqlSwimlanes: (0, $gnRwu.jqlSwimlanesReducer),
        versionData: (0, $8YtrK.versionDataReducer),
        missingParents: (0, $1gv2w.missingParentsReducer),
        teams: (0, $lEneF.teamsReducer),
        incrementConfig: (0, $4AaHD.incrementConfigReducer),
        issueTypesByProject: (0, $11N2b.issueTypesByProjectReducer),
        issueLinksStats: (0, $7UqIo.issueLinksStatsReducer),
        issueLinkTypes: (0, $9YkOZ.IssueLinkTypesReducer),
        issueLinksPermissions: (0, $8UrfO.issueLinksPermissionsReducer),
        issuePriorityInformation: (0, $9Rk3Z.issuePriorityInformationReducer),
        oldDoneIssuesCutOffConfig: (0, $2o5W8.oldOneIssuesCutOffConfigReducer)
    }));
}

});
parcelRegister("8J1tE", function(module, exports) {

$parcel$export(module.exports, "default", () => $46a2470043bf5078$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $bM8Kn = parcelRequire("bM8Kn");

var $w3nA1 = parcelRequire("w3nA1");

var $heNh0 = parcelRequire("heNh0");

var $6nzKY = parcelRequire("6nzKY");

var $gg51X = parcelRequire("gg51X");

var $cAwia = parcelRequire("cAwia");

var $57YkG = parcelRequire("57YkG");

var $h6HH2 = parcelRequire("h6HH2");

var $8nEK3 = parcelRequire("8nEK3");

var $5NCzb = parcelRequire("5NCzb");

var $94E7k = parcelRequire("94E7k");
function $46a2470043bf5078$export$2e2bcd8739ae039() {
    return (0, $3f2cs.combineReducers)({
        columns: (0, $bM8Kn.boardColumnsReducer),
        config: (0, $w3nA1.boardConfigReducer),
        hasFilteredIssues: (0, $6nzKY.hasFilteredIssuesReducer),
        issues: (0, $8nEK3.boardIssuesReducer),
        selectedSprints: (0, $94E7k.selectedSprintsReducer),
        isConfigLoaded: (0, $gg51X.isConfigLoadedReducer),
        isCurrentUserLoaded: (0, $cAwia.isCurrentUserLoadedReducer),
        permissions: (0, $5NCzb.permissionsReducer),
        issueChildren: (0, $57YkG.boardIssueChildrenReducer),
        issueParentOrder: (0, $h6HH2.boardIssueParentReducer),
        boardFavourite: (0, $heNh0.boardFavouriteReducer)
    });
}

});
parcelRegister("bM8Kn", function(module, exports) {

$parcel$export(module.exports, "boardColumnsReducer", () => $7d59f6c43d60b4f1$export$203a64aa0627727a);

var $7uUwQ = parcelRequire("7uUwQ");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $55fEr = parcelRequire("55fEr");

var $cW3pH = parcelRequire("cW3pH");
const $7d59f6c43d60b4f1$export$203a64aa0627727a = (state = (0, $7uUwQ.freeze)([]), action)=>{
    if ((action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) && action.payload.columns) return (0, $7uUwQ.freeze)(action.payload.columns.map((column)=>column.id));
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.filter)((id)=>id !== columnId, state);
    }
    if (action.type === (0, $55fEr.COLUMN_RANK_REQUEST)) {
        let columnIds = state;
        const { columnId: columnId, targetColumnId: targetColumnId } = action.payload;
        const currentIndex = columnIds.indexOf(columnId);
        const newIndex = columnIds.indexOf(targetColumnId);
        columnIds = (0, $7uUwQ.splice)(columnIds, currentIndex, 1);
        columnIds = (0, $7uUwQ.splice)(columnIds, newIndex, 0, columnId);
        return columnIds;
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_REQUEST)) {
        const { temporaryColumnId: temporaryColumnId } = action.payload;
        // For CMP boards, we put the new column before the final Done column
        if (action.meta.isCMPBoard) return (0, $7uUwQ.splice)(state, state.length - 1, 0, temporaryColumnId);
        return (0, $7uUwQ.push)(state, temporaryColumnId);
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS)) {
        const { temporaryColumnId: temporaryColumnId, column: column } = action.payload;
        const currentIndex = state.indexOf(temporaryColumnId);
        return (0, $7uUwQ.splice)(state, currentIndex, 1, column.id);
    }
    return state;
};

});

parcelRegister("w3nA1", function(module, exports) {

$parcel$export(module.exports, "boardConfigReducer", () => $f8055b3084354013$export$c160cae4040278a0);

var $7uUwQ = parcelRequire("7uUwQ");

var $9XE6b = parcelRequire("9XE6b");

var $4R6GH = parcelRequire("4R6GH");

var $127QL = parcelRequire("127QL");

var $bRqd3 = parcelRequire("bRqd3");

var $7buQq = parcelRequire("7buQq");

var $65C0W = parcelRequire("65C0W");

var $cW3pH = parcelRequire("cW3pH");
const $f8055b3084354013$var$initialState = {
    name: '',
    rankConfig: {
        boardIsRankable: true,
        rankCustomFieldId: 1234
    },
    isInlineColumnEditEnabled: false,
    isCardMediaEnabled: false,
    isSprintsEnabled: false,
    isStandupsEnabled: false,
    isBacklogEnabled: false,
    isEstimationEnabled: false,
    isManageRulesEnabled: false,
    isReleasesFeatureEnabled: false,
    allFeatures: [],
    timeTrackingOptions: {
        workingHoursPerDay: 8,
        workingDaysPerWeek: 5,
        timeFormat: 'pretty',
        defaultUnit: 'minute'
    },
    isAnyStatusInCreateEnabled: true
};
const $f8055b3084354013$export$c160cae4040278a0 = (state = $f8055b3084354013$var$initialState, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { config: config, boardName: boardName, capabilities: capabilities, boardConfig: boardConfig, inlineCardCreate: inlineCardCreate, isInlineColumnEditEnabled: isInlineColumnEditEnabled, allFeatures: allFeatures } = action.payload;
        const { isCardMediaEnabled: isCardMediaEnabled, boardIssueListKey: boardIssueListKey, isManageRulesEnabled: isManageRulesEnabled, timeTrackingOptions: timeTrackingOptions, columnConstraintType: columnConstraintType, isAnyStatusInCreateEnabled: isAnyStatusInCreateEnabled } = boardConfig;
        const newState = (0, $7uUwQ.chain)(state).set('rankConfig', config).set('name', boardName).set('isBacklogEnabled', capabilities && capabilities.BACKLOG).set('isSprintsEnabled', capabilities && capabilities.SPRINTS).set('isStandupsEnabled', (0, $4R6GH.fg)('jira-warepil-standup-toggle') ? capabilities && capabilities.STANDUP : undefined).set('inlineCardCreate', inlineCardCreate).set('isInlineColumnEditEnabled', isInlineColumnEditEnabled).set('isCardMediaEnabled', isCardMediaEnabled).set('boardIssueListKey', boardIssueListKey).set('isManageRulesEnabled', isManageRulesEnabled).set('isReleasesFeatureEnabled', capabilities && capabilities.RELEASES).set('allFeatures', allFeatures).set('timeTrackingOptions', timeTrackingOptions).set('columnConstraintType', columnConstraintType).set('isAnyStatusInCreateEnabled', isAnyStatusInCreateEnabled).value();
        return newState;
    }
    if (action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { config: config, boardName: boardName, capabilities: capabilities, inlineCardCreate: inlineCardCreate, isInlineColumnEditEnabled: isInlineColumnEditEnabled, allFeatures: allFeatures } = action.payload;
        const newState = (0, $7uUwQ.chain)(state).set('rankConfig', config).set('name', boardName).set('isBacklogEnabled', capabilities && capabilities.BACKLOG).set('isSprintsEnabled', capabilities && capabilities.SPRINTS).set('isStandupsEnabled', (0, $4R6GH.fg)('jira-warepil-standup-toggle') ? capabilities && capabilities.STANDUP : undefined).set('isEstimationEnabled', capabilities && capabilities.ESTIMATION).set('inlineCardCreate', inlineCardCreate).set('isInlineColumnEditEnabled', isInlineColumnEditEnabled).set('isReleasesFeatureEnabled', capabilities && capabilities.RELEASES).set('allFeatures', allFeatures).value();
        return newState;
    }
    if (action.type === (0, $bRqd3.CARD_MEDIA_TOGGLE_REQUEST)) return (0, $7uUwQ.set)(state, 'isCardMediaEnabled', action.payload);
    if (action.type === (0, $7buQq.RENAME_BOARD_REQUEST)) return (0, $7uUwQ.set)(state, 'name', action.payload);
    if (action.type === (0, $65C0W.SOFTWARE_APP_LOADED)) return (0, $7uUwQ.set)(state, 'name', (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(action.payload.prefetchData, [
        'boardData',
        'boardName'
    ], state.name));
    if (action.type === (0, $127QL.BOARD_DEFERRED_DATA_LOAD_SUCCESS)) {
        const { payload: { isUsingSimplifiedWorkflow: isUsingSimplifiedWorkflow } } = action;
        // For CMP boards, we allow inline column editing only with simplified workflow boards
        if (isUsingSimplifiedWorkflow !== undefined) return (0, $7uUwQ.set)(state, 'isInlineColumnEditEnabled', isUsingSimplifiedWorkflow);
    }
    return state;
};

});

parcelRegister("heNh0", function(module, exports) {

$parcel$export(module.exports, "boardFavouriteReducer", () => $0879794f84f656e7$export$e44a04a90b9b0017);

var $fC72p = parcelRequire("fC72p");
const $0879794f84f656e7$var$initialState = {
    isFavourite: undefined
};
const $0879794f84f656e7$export$e44a04a90b9b0017 = (state = $0879794f84f656e7$var$initialState, action)=>{
    switch(action.type){
        case 0, $fC72p.SET_IS_FAVOURITE:
            return {
                isFavourite: action.payload.isFavourite
            };
        default:
            return state;
    }
};

});

parcelRegister("6nzKY", function(module, exports) {

$parcel$export(module.exports, "hasFilteredIssuesReducer", () => $1d4b2fa673705b1e$export$9c25a54b5e38e3ae);

var $cW3pH = parcelRequire("cW3pH");
const $1d4b2fa673705b1e$export$9c25a54b5e38e3ae = (state = false, action)=>{
    switch(action.type){
        case 0, $cW3pH.WORK_DATA_SET:
        case 0, $cW3pH.WORK_DATA_CRITICAL_SET:
            return action.payload.hasFilteredIssues;
        default:
            return state;
    }
};

});

parcelRegister("gg51X", function(module, exports) {

$parcel$export(module.exports, "isConfigLoadedReducer", () => $153f872a117427a8$export$8da0e005528236f5);

var $cW3pH = parcelRequire("cW3pH");
const $153f872a117427a8$export$8da0e005528236f5 = (state = false, action)=>{
    switch(action.type){
        case 0, $cW3pH.WORK_DATA_SET:
            return true;
        default:
            return state;
    }
};

});

parcelRegister("cAwia", function(module, exports) {

$parcel$export(module.exports, "isCurrentUserLoadedReducer", () => $b8b157d0c919f365$export$49f02b71768c5e88);

var $hoX5N = parcelRequire("hoX5N");
const $b8b157d0c919f365$export$49f02b71768c5e88 = (state = false, action)=>{
    switch(action.type){
        case 0, $hoX5N.PERSON_SET:
            return true;
        default:
            {
                // @ts-expect-error - TS2322: Type 'ShowErrorFlagAction | AddToSprintRequestAction | AddToSprintSuccessAction | AddToSprintFailureAction | ... 256 more ... | UnsupportedAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("57YkG", function(module, exports) {

$parcel$export(module.exports, "boardIssueChildrenReducer", () => $632455f55662c841$export$dff3145c7f53c7db);

var $7uUwQ = parcelRequire("7uUwQ");

var $k8IPx = parcelRequire("k8IPx");

var $4wVpT = parcelRequire("4wVpT");


var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $4gHuj = parcelRequire("4gHuj");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $71oFY = parcelRequire("71oFY");

var $cW3pH = parcelRequire("cW3pH");

var $9da86 = parcelRequire("9da86");
const $632455f55662c841$var$rankChildIssues = ({ state: state, issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId })=>{
    const availableIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(state, issueIds);
    if (availableIssues.length === 0) return state;
    const newState = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, availableIssues);
    let destinationIndex;
    if (rankBeforeIssueId) destinationIndex = newState.indexOf(rankBeforeIssueId);
    else if (rankAfterIssueId) destinationIndex = newState.indexOf(rankAfterIssueId) + 1;
    else return state;
    return (0, $7uUwQ.splice)(newState, destinationIndex, 0, ...issueIds);
};
const $632455f55662c841$export$dff3145c7f53c7db = (state = [], action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issueChildren: issueChildren } } = action;
        return issueChildren.map((issue)=>issue.id);
    }
    if (action.type === (0, $4gHuj.SET_ISSUE_CHILDREN)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: issueChildren } = action;
        return issueChildren.map((issue)=>issue.id);
    }
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST) || action.type === (0, $9da86.ISSUE_ARCHIVE_REQUEST)) {
        const { payload: { issue: issue, childIssueIds: childIssueIds } } = action;
        const childIssueToDelete = issue.id;
        const childIssueOfDeletedParent = childIssueIds;
        return state.filter((childIssueId)=>childIssueId !== childIssueToDelete && childIssueOfDeletedParent.indexOf(childIssueId) < 0);
    }
    if (action.type === (0, $2f454.CARD_CLEAR)) {
        const { payload: { childCardIds: childCardIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        childCardIds.forEach((cardId)=>{
            const index = newState.value().indexOf(cardId);
            if (index >= 0) // @ts-expect-error - TS2339 - Property 'splice' does not exist on type 'IcepickWrapper<IssueChildrenState>'.
            newState.splice(index, 1);
        });
        return newState.value();
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId } } = action;
        const index = state.indexOf(issueId);
        if (index < 0) return state;
        return (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues, type: type }, meta: { insertBefore: insertBefore } } = action;
        if (type !== (0, $dcbb2bce513725b3$export$1f24f91824c6822f)) return state;
        const issueIds = issues.map(({ id: id })=>id);
        const insertionPoint = insertBefore ? state.indexOf(insertBefore) : state.length;
        return (0, $7uUwQ.splice)(state, insertionPoint, 0, ...issueIds);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS)) {
        const { payload: { temporaryIssueIds: temporaryIssueIds, issues: issues } } = action;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const translation = {};
        temporaryIssueIds.forEach((id, index)=>{
            if (issues[index]) translation[id] = issues[index].id;
        });
        // Assume that no temporary id will ever be falsey (0).
        return Object.keys(translation).length > 0 ? (0, $7uUwQ.map)((oldId)=>translation[oldId] || oldId, state) : state;
    }
    if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, mode: mode } } = action;
        /**
		 * We won't update the ranking if the moving card is transition only
		 * */ if (mode === 'TRANSITION_ONLY') return state;
        return $632455f55662c841$var$rankChildIssues({
            state: state,
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId
        });
    }
    if (action.type === (0, $71oFY.BULK_ISSUE_RANK_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId } } = action;
        return $632455f55662c841$var$rankChildIssues({
            state: state,
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeId,
            rankAfterIssueId: rankAfterId
        });
    }
    if (action.type === (0, $4gHuj.SET_ISSUE_CHILDREN_RANK)) {
        const { payload: { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter } } = action;
        const availableIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(state, issueIds);
        if (!availableIssues.length) return state;
        const newState = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, availableIssues);
        const rankItemIndex = newState.indexOf(rankId);
        const destinationIndex = isRankAfter ? rankItemIndex + 1 : rankItemIndex;
        return (0, $7uUwQ.splice)(newState, destinationIndex, 0, ...issueIds);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { payload: { closestColumn: closestColumn, issuesInColumn: issuesInColumn } } = action;
        if (!closestColumn) {
            const issueIdsInColumn = new Set(issuesInColumn.map((issue)=>issue.id));
            return state.filter((id)=>!issueIdsInColumn.has(id));
        }
    }
    return state;
};

});

parcelRegister("h6HH2", function(module, exports) {

$parcel$export(module.exports, "boardIssueParentReducer", () => $ecf8ac1a8e63a493$export$2c22cce5c981884b);

var $7uUwQ = parcelRequire("7uUwQ");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $3n65g = parcelRequire("3n65g");

var $cW3pH = parcelRequire("cW3pH");
const $ecf8ac1a8e63a493$export$2c22cce5c981884b = (state = [], action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issueParents: issueParents } } = action;
        return issueParents.map((issue)=>issue.id);
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId } } = action;
        const index = state.indexOf(issueId);
        return index < 0 ? state : (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $3n65g.ADD_ISSUE_PARENT)) return [
        ...state,
        action.payload?.issue.id
    ];
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { payload: { closestColumn: closestColumn, issuesInColumn: issuesInColumn } } = action;
        if (!closestColumn) {
            const issueIdsInColumn = new Set(issuesInColumn.map((issue)=>issue.id));
            return state.filter((id)=>!issueIdsInColumn.has(id));
        }
    }
    return state;
};

});

parcelRegister("8nEK3", function(module, exports) {

$parcel$export(module.exports, "boardIssuesReducer", () => $2c591dbfe53e913a$export$4cb59de18fd154ba);

var $7uUwQ = parcelRequire("7uUwQ");

var $k8IPx = parcelRequire("k8IPx");

var $4wVpT = parcelRequire("4wVpT");

var $4R6GH = parcelRequire("4R6GH");


var $doOdQ = parcelRequire("doOdQ");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $cIqUn = parcelRequire("cIqUn");

var $5UXId = parcelRequire("5UXId");

var $71oFY = parcelRequire("71oFY");

var $dkGow = parcelRequire("dkGow");

var $5G4Hb = parcelRequire("5G4Hb");

var $cW3pH = parcelRequire("cW3pH");

var $9da86 = parcelRequire("9da86");
const $2c591dbfe53e913a$var$rankIssues = (state, payload)=>{
    const { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } = payload;
    const availableIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(state, issueIds);
    if (availableIssues.length === 0) return state;
    const newState = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, availableIssues);
    let destinationIndex;
    if (rankBeforeIssueId) destinationIndex = newState.indexOf(rankBeforeIssueId);
    else if (rankAfterIssueId) destinationIndex = newState.indexOf(rankAfterIssueId) + 1;
    else return state;
    return (0, $7uUwQ.splice)(newState, destinationIndex, 0, ...issueIds);
};
const $2c591dbfe53e913a$export$4cb59de18fd154ba = (state = [], action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issues: issues, config: { boardIsRankable: boardIsRankable } } } = action;
        /* For a CMP project, the ordered issues include in:
		 * - issues and orphan subtasks if the board is rankable
		 * - issues and subtasks if the board is not rankable
		 * */ if (action.type === (0, $cW3pH.WORK_DATA_SET) && action.payload.orderedIssueIds) {
            if (!boardIsRankable) return action.payload.orderedIssueIds;
            const issueChildrenIdsWithParent = action.payload.issueChildren.filter(({ parentId: parentId })=>!!parentId && action.payload.orderedIssueIds?.includes(parentId)).map(({ id: id })=>id);
            return action.payload.orderedIssueIds.filter((id)=>!issueChildrenIdsWithParent.includes(id));
        }
        return issues.map((issue)=>issue.id);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues, type: type }, meta: { insertBefore: insertBefore, isSubtaskMissingParent: isSubtaskMissingParent = false } } = action;
        if (type !== (0, $dcbb2bce513725b3$export$b05303cbde3e8c8c) && !isSubtaskMissingParent) return state;
        const issueIds = issues.map(({ id: id })=>id);
        const insertionPoint = insertBefore ? state.indexOf(insertBefore) : state.length;
        return (0, $7uUwQ.splice)(state, insertionPoint, 0, ...issueIds);
    }
    if (action.type === (0, $5G4Hb.REMOVE_FROM_SPRINT_REQUEST)) {
        const { payload: { issueId: issueId } } = action;
        const index = state.indexOf(issueId);
        return index < 0 ? state : (0, $7uUwQ.splice)(state, index, 1);
    }
    if ((0, $4R6GH.fg)('jira-removefromsprint-nodelay')) {
        if (action.type === (0, $dkGow.ADD_TO_SPRINT_SUCCESS)) {
            const { payload: { issueKey: issueKey } } = action;
            return (0, $7uUwQ.splice)(state, state.length, 0, issueKey);
        }
    }
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST) || action.type === (0, $9da86.ISSUE_ARCHIVE_REQUEST)) {
        const { payload: { issue: issue } } = action;
        const index = state.indexOf(issue.id);
        if (index < 0) return state;
        return (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId } } = action;
        const index = state.indexOf(issueId);
        if (index < 0) return state;
        return (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $2f454.CARD_CLEAR)) {
        const { payload: { cardIds: cardIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        cardIds.forEach((cardId)=>{
            const index = newState.value().indexOf(cardId);
            if (index >= 0) // @ts-expect-error - TS2339 - Property 'splice' does not exist on type 'IcepickWrapper<IssuesState>'.
            newState.splice(index, 1);
        });
        return newState.value();
    }
    if (action.type === (0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)) {
        const { payload: { issueIds: issueIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            const index = newState.value().indexOf(issueId);
            if (index >= 0) // @ts-expect-error - TS2339 - Property 'splice' does not exist on type 'IcepickWrapper<IssuesState>'.
            newState.splice(index, 1);
        });
        return newState.value();
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS)) {
        const { payload: { temporaryIssueIds: temporaryIssueIds, issues: issues } } = action;
        const translation = {};
        temporaryIssueIds.forEach((id, index)=>{
            if (issues[index]) translation[id] = issues[index].id;
        });
        // Assume that no temporary id will ever be falsey (0).
        return Object.keys(translation).length > 0 ? (0, $7uUwQ.map)((oldId)=>translation[oldId] || oldId, state) : state;
    }
    if (action.type === (0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)) {
        const { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId } } = action;
        return $2c591dbfe53e913a$var$rankIssues(state, {
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId
        });
    }
    if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, rankBeforeIssueId: rankBeforeIssueId, rankAfterIssueId: rankAfterIssueId, mode: mode } } = action;
        /**
		 * We won't update the ranking if the moving card is transition only
		 * */ if (mode === 'TRANSITION_ONLY' || [
            rankBeforeIssueId,
            rankAfterIssueId
        ].includes(issueIds[0])) return state;
        return $2c591dbfe53e913a$var$rankIssues(state, {
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeIssueId,
            rankAfterIssueId: rankAfterIssueId
        });
    }
    if (action.type === (0, $71oFY.BULK_ISSUE_RANK_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, rankAfterId: rankAfterId, rankBeforeId: rankBeforeId } } = action;
        return $2c591dbfe53e913a$var$rankIssues(state, {
            issueIds: issueIds,
            rankBeforeIssueId: rankBeforeId,
            rankAfterIssueId: rankAfterId
        });
    }
    if (action.type === (0, $71oFY.SET_ISSUES_RANK)) {
        const { payload: { issueIds: issueIds, rankId: rankId, isRankAfter: isRankAfter } } = action;
        const availableIssues = (0, (/*@__PURE__*/$parcel$interopDefault($4wVpT)))(state, issueIds);
        if (!availableIssues.length) return state;
        const newState = (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, availableIssues);
        const rankItemIndex = newState.indexOf(rankId);
        const destinationIndex = isRankAfter ? rankItemIndex + 1 : rankItemIndex;
        return (0, $7uUwQ.splice)(newState, destinationIndex, 0, ...issueIds);
    }
    if (action.type === (0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE)) {
        const { payload: { issueIds: issueIds } } = action;
        return (0, (/*@__PURE__*/$parcel$interopDefault($k8IPx)))(state, issueIds);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { payload: { closestColumn: closestColumn, issuesInColumn: issuesInColumn } } = action;
        if (!closestColumn) {
            const issueIdsInColumn = new Set(issuesInColumn.map((issue)=>issue.id));
            return state.filter((id)=>!issueIdsInColumn.has(id));
        }
    }
    return state;
};

});

parcelRegister("5NCzb", function(module, exports) {

$parcel$export(module.exports, "permissionsReducer", () => $561e00495f5b1795$export$b37cab870badc2b9);

var $127QL = parcelRequire("127QL");

var $cW3pH = parcelRequire("cW3pH");
const $561e00495f5b1795$export$d4c72bab9d6cc13a = {
    createIssue: false,
    deleteIssue: false,
    editIssue: false,
    manageSprint: false,
    editBoardConfig: false,
    manageAutomation: false,
    canRelease: false,
    createSprint: false,
    archiveIssue: false
};
const $561e00495f5b1795$export$b37cab870badc2b9 = (state = $561e00495f5b1795$export$d4c72bab9d6cc13a, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.boardPermissions;
    if (action.type === (0, $127QL.BOARD_DEFERRED_DATA_LOAD_SUCCESS) && action.payload.sprints) return {
        ...state,
        manageSprint: action.payload.sprints.some((sprint)=>sprint.canUpdateSprint)
    };
    return state;
};

});

parcelRegister("94E7k", function(module, exports) {

$parcel$export(module.exports, "selectedSprintsReducer", () => $f14f71dca75bd65b$export$631001c1ce1d2568);

var $cW3pH = parcelRequire("cW3pH");
const $f14f71dca75bd65b$export$631001c1ce1d2568 = (state = null, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { sprints: sprints } = action.payload;
        return sprints && sprints.length > 0 ? sprints.map((sprint)=>sprint.id) : null;
    }
    return state;
};

});


parcelRegister("f8jqi", function(module, exports) {

$parcel$export(module.exports, "cardTransitionsReducer", () => $88394d411a7227ba$export$5d84a78ff63fb23c);

var $7uUwQ = parcelRequire("7uUwQ");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $63VRQ = parcelRequire("63VRQ");

var $cW3pH = parcelRequire("cW3pH");
const $88394d411a7227ba$var$initialState = (0, $7uUwQ.freeze)({
    columnIssueTypeTransitions: {},
    issueTypeStatus: {}
});
const $88394d411a7227ba$export$5d84a78ff63fb23c = (state = $88394d411a7227ba$var$initialState, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { cardTransitions: cardTransitions } } = action;
        return (0, $7uUwQ.freeze)(cardTransitions || $88394d411a7227ba$var$initialState);
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS)) {
        const { payload: { cardTransitions: cardTransitions } } = action;
        if (cardTransitions) return (0, $7uUwQ.freeze)(cardTransitions);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_SUCCESS)) {
        const { payload: { cardTransitions: cardTransitions } } = action;
        if (cardTransitions) return (0, $7uUwQ.freeze)(cardTransitions);
    }
    if (action.type === (0, $63VRQ.COLUMN_RENAME_SUCCESS)) {
        const { payload: { cardTransitions: cardTransitions } } = action;
        if (cardTransitions) return (0, $7uUwQ.merge)(state, cardTransitions);
    }
    return state;
};

});

parcelRegister("lAVlQ", function(module, exports) {

$parcel$export(module.exports, "columnsReducer", () => $0a5b0d53133a989d$export$e965e01e388e7003);

var $7uUwQ = parcelRequire("7uUwQ");

var $91VA7 = parcelRequire("91VA7");

var $hGgHi = parcelRequire("hGgHi");

var $5rFbt = parcelRequire("5rFbt");

var $esu6n = parcelRequire("esu6n");

var $1ShTS = parcelRequire("1ShTS");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $9eeht = parcelRequire("9eeht");

var $63VRQ = parcelRequire("63VRQ");

var $cW3pH = parcelRequire("cW3pH");
const $0a5b0d53133a989d$export$e965e01e388e7003 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if ((action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) && action.payload.columns) return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(action.payload.columns));
    if (action.type === (0, $63VRQ.COLUMN_RENAME_REQUEST)) {
        const { columnId: columnId, name: name } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            columnId,
            'name'
        ], name);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.unset)(state, columnId);
    }
    if (action.type === (0, $63VRQ.COLUMN_RENAME_SUCCESS)) {
        const { columnId: columnId, statuses: statuses } = action.payload;
        const newStatuses = [
            ...statuses
        ];
        return (0, $7uUwQ.setIn)(state, [
            columnId,
            'statuses'
        ], newStatuses);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_SUCCESS) || action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS)) {
        let newState = (0, (/*@__PURE__*/$parcel$interopDefault($91VA7)))(state);
        if (action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS)) {
            const { temporaryColumnId: temporaryColumnId, column: column } = action.payload;
            newState = (0, $7uUwQ.unset)(newState, temporaryColumnId);
            newState = (0, $7uUwQ.set)(newState, column.id, column);
        }
        action.payload.columns.filter((column)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(newState[column.id]) && column.type === (0, $5rFbt.ColumnType).STATUS).forEach((column)=>{
            newState = (0, $7uUwQ.setIn)(newState, [
                column.id,
                'statuses'
            ], (0, $7uUwQ.map)((status)=>({
                    ...status,
                    category: column.statuses[0].category,
                    isInitial: column.statuses[0].isInitial,
                    isDone: column.statuses[0].isDone
                }), (0, $esu6n.getStatusColumn)(newState[column.id])?.statuses ?? []));
        });
        return newState;
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_REQUEST)) {
        const { temporaryColumnId: id, name: name } = action.payload;
        const newState = (0, $7uUwQ.merge)(state, {
            [id]: {
                id: id,
                name: name,
                statuses: [
                    {
                        id: id,
                        name: name,
                        isInitial: false,
                        isDone: false
                    }
                ],
                maxIssueCount: null
            }
        });
        return newState;
    }
    if (action.type === (0, $9eeht.COLUMN_SET_LIMITS_REQUEST)) {
        const { columnId: columnId, maxIssueCount: maxIssueCount, minIssueCount: minIssueCount } = action.payload;
        const newState = (0, $7uUwQ.merge)(state, {
            [columnId]: {
                maxIssueCount: maxIssueCount,
                minIssueCount: minIssueCount
            }
        });
        return newState;
    }
    return state;
};

});

parcelRegister("1cp3g", function(module, exports) {

$parcel$export(module.exports, "customFiltersReducer", () => $6965c6a3cdfa88e9$export$dbd98ee5f91df1a);

var $cW3pH = parcelRequire("cW3pH");
const $6965c6a3cdfa88e9$var$initialState = {
    filters: []
};
function $6965c6a3cdfa88e9$export$dbd98ee5f91df1a(state = $6965c6a3cdfa88e9$var$initialState, action) {
    if (action.type === (0, $cW3pH.WORK_DATA_SET) && action.payload.customFilters) return {
        filters: action.payload.customFilters
    };
    return state;
}

});

parcelRegister("b4Neb", function(module, exports) {

$parcel$export(module.exports, "estimationStatisticReducer", () => $e3162cc4f5f52d29$export$f90c5d49c06c31b6);

var $cW3pH = parcelRequire("cW3pH");
const $e3162cc4f5f52d29$export$f90c5d49c06c31b6 = (state = '', action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.estimationStatistic;
    return state;
};

});

parcelRegister("4AaHD", function(module, exports) {

$parcel$export(module.exports, "incrementConfigReducer", () => $6d5928cf94d48ee0$export$c12241c4f89682f);

var $cW3pH = parcelRequire("cW3pH");
const $6d5928cf94d48ee0$export$c12241c4f89682f = (state = null, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.incrementConfig || null;
    return state;
};

});

parcelRegister("6v6W4", function(module, exports) {

$parcel$export(module.exports, "inlineCreateReducer", () => $e87fe470f7fcfd99$export$1b02c7a713d71ddd);

var $l67YV = parcelRequire("l67YV");
const $e87fe470f7fcfd99$var$defaultState = {
    sessionId: undefined
};
const $e87fe470f7fcfd99$export$1b02c7a713d71ddd = (state = $e87fe470f7fcfd99$var$defaultState, action)=>{
    switch(action.type){
        case 0, $l67YV.SET_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: action.payload.sessionId
            };
        case 0, $l67YV.CLEAR_INLINE_CREATE_SESSION_ID:
            return {
                ...state,
                sessionId: undefined
            };
        case 0, $l67YV.CLEAR_SPECIFIED_INLINE_CREATE_SESSION_ID:
            if (state.sessionId === action.payload.sessionId) return {
                ...state,
                sessionId: undefined
            };
            return state;
        default:
            return state;
    }
};

});
parcelRegister("l67YV", function(module, exports) {

$parcel$export(module.exports, "SET_INLINE_CREATE_SESSION_ID", () => $9350534239458f71$export$b7afd69edc8efc16);
$parcel$export(module.exports, "setInlineCreateSessionId", () => $9350534239458f71$export$69abc158578163fc);
$parcel$export(module.exports, "CLEAR_INLINE_CREATE_SESSION_ID", () => $9350534239458f71$export$932498ee6899f22a);
$parcel$export(module.exports, "clearInlineCreateSessionId", () => $9350534239458f71$export$138f7b7b7eb9ceaa);
$parcel$export(module.exports, "CLEAR_SPECIFIED_INLINE_CREATE_SESSION_ID", () => $9350534239458f71$export$e75d189ade2eae90);
$parcel$export(module.exports, "clearSpecifiedInlineCreateSessionId", () => $9350534239458f71$export$952fdba8e3c500b1);
const $9350534239458f71$export$b7afd69edc8efc16 = 'state.actions.inline-create.SET_INLINE_CREATE_SESSION_ID';
const $9350534239458f71$export$69abc158578163fc = (sessionId)=>({
        type: $9350534239458f71$export$b7afd69edc8efc16,
        payload: {
            sessionId: sessionId
        }
    });
const $9350534239458f71$export$49df3fa957b0423b = 'state.actions.inline-create.SET_SELECTED_PROJECT_ID_IN_ICC';
const $9350534239458f71$export$a77c5a113697f11b = (projectId)=>({
        type: $9350534239458f71$export$49df3fa957b0423b,
        payload: {
            projectId: projectId
        }
    });
const $9350534239458f71$export$932498ee6899f22a = 'state.actions.inline-create.CLEAR_INLINE_CREATE_SESSION_ID';
const $9350534239458f71$export$138f7b7b7eb9ceaa = ()=>({
        type: $9350534239458f71$export$932498ee6899f22a
    });
const $9350534239458f71$export$e75d189ade2eae90 = 'state.actions.inline-create.CLEAR_SPECIFIED_INLINE_CREATE_SESSION_ID';
const $9350534239458f71$export$952fdba8e3c500b1 = (sessionId)=>({
        type: $9350534239458f71$export$e75d189ade2eae90,
        payload: {
            sessionId: sessionId
        }
    });

});


parcelRegister("7ANej", function(module, exports) {

$parcel$export(module.exports, "issueChildrenReducer", () => $cea454cbf4b26b1a$export$fef692bb0099f36);

var $7uUwQ = parcelRequire("7uUwQ");

var $dDkmN = parcelRequire("dDkmN");

var $5rFbt = parcelRequire("5rFbt");


var $c79wa = parcelRequire("c79wa");

var $1ShTS = parcelRequire("1ShTS");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $4gHuj = parcelRequire("4gHuj");

var $iaYF9 = parcelRequire("iaYF9");

var $cAxle = parcelRequire("cAxle");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $9WrsG = parcelRequire("9WrsG");

var $fBkjL = parcelRequire("fBkjL");

var $e1q2I = parcelRequire("e1q2I");

var $3n65g = parcelRequire("3n65g");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $cW3pH = parcelRequire("cW3pH");

var $9da86 = parcelRequire("9da86");
const $cea454cbf4b26b1a$export$fef692bb0099f36 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return (0, $1ShTS.entityArrayToMap)(action.payload.issueChildren);
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues, type: type } } = action;
        if (type !== (0, $dcbb2bce513725b3$export$1f24f91824c6822f)) return state;
        const newState = {
            ...state
        };
        issues.forEach((issue)=>{
            newState[String(issue.id)] = issue;
        });
        return (0, $7uUwQ.freeze)(newState);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS)) {
        const { payload: { temporaryIssueIds: temporaryIssueIds, issues: issues } } = action;
        const newState = {
            ...state
        };
        if (temporaryIssueIds.some((id)=>state[String(id)])) {
            temporaryIssueIds.forEach((temporaryId)=>{
                delete newState[String(temporaryId)];
            });
            issues.forEach((issue)=>{
                newState[String(issue.id)] = issue;
            });
            return (0, $7uUwQ.freeze)(newState);
        }
        return state;
    }
    if (action.type === (0, $4gHuj.SET_ISSUE_CHILDREN)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: issueChildren } = action;
        return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(issueChildren));
    }
    if (action.type === (0, $evkwq.ISSUE_UPDATE_SUCCESS)) {
        const { payload: { issue: issue } } = action;
        const issueId = String(issue.id);
        if (state[issueId]) return (0, $7uUwQ.set)(state, issueId, issue);
        return state;
    }
    if (action.type === (0, $2f454.CARD_CLEAR)) {
        const { payload: { childCardIds: childCardIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        childCardIds.forEach((cardId)=>{
            newState.unset(cardId);
        });
        return newState.value();
    }
    if (action.type === (0, $2f454.CARD_DATA_SET)) {
        const { payload: { issue: issue } } = action;
        const issueId = String(issue.id);
        if (state[issueId]) return (0, $7uUwQ.set)(state, issueId, issue);
        return state;
    }
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST) || action.type === (0, $9da86.ISSUE_ARCHIVE_REQUEST)) {
        const { payload: { issue: { id: id }, childIssueIds: childIssueIds } } = action;
        const subtaskIssueId = String(id);
        if (state[subtaskIssueId]) return (0, $7uUwQ.unset)(state, subtaskIssueId);
        if (childIssueIds.length > 0) {
            const changeChain = (0, $7uUwQ.chain)(state);
            childIssueIds.forEach((childIssueId)=>{
                changeChain.unset(String(childIssueId));
            });
            return changeChain.value();
        }
        return state;
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.unset)(state, String(issueId));
        return state;
    }
    if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, destinationColumnId: destinationColumnId, isDestinationDone: isDestinationDone, destinationStatus: destinationStatus } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            changeChain.setIn([
                String(issueId),
                'columnId'
            ], destinationColumnId);
            if (destinationStatus) changeChain.setIn([
                String(issueId),
                'statusId'
            ], Number(destinationStatus.id));
            const currentIssue = state[String(issueId)];
            if (currentIssue.columnId !== destinationColumnId) changeChain.setIn([
                String(issueId),
                'isDone'
            ], isDestinationDone);
        });
        return changeChain.value();
    }
    if (action.type === (0, $e1q2I.ISSUE_CHANGE_SWIMLANE)) {
        const { payload: { issueIds: issueIds, swimlaneValues: swimlaneValues } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            if (swimlaneValues.type === (0, $c79wa.STORY)) changeChain.setIn([
                String(issueId),
                'parentId'
            ], swimlaneValues.parentId);
            if (swimlaneValues.type === (0, $c79wa.ASSIGNEE)) changeChain.setIn([
                String(issueId),
                'assigneeAccountId'
            ], swimlaneValues.assigneeAccountId);
        });
        return changeChain.value();
    }
    if (action.type === (0, $9WrsG.DEV_STATUS_LOAD_SUCCESS)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        const newState = (0, $7uUwQ.chain)(state);
        Object.keys(payload).forEach((issueIdString)=>{
            if (!state[String(issueIdString)]) return;
            newState.setIn([
                issueIdString,
                'devStatus'
            ], payload[issueIdString]);
        });
        return newState.value();
    }
    if (action.type === (0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_REQUEST)) {
        const { payload: { issueIds: issueIds, flag: flag } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>{
            if (state[String(id)]) newState.setIn([
                String(id),
                'isFlagged'
            ], flag);
        });
        return newState.value();
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const newState = {
            ...state
        };
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        Object.keys(state).filter((issueKey)=>state[issueKey].columnId === payload.columnId).forEach((issueKey)=>{
            if (!payload.closestColumn) delete newState[issueKey];
            else if (payload.closestColumn.type === (0, $5rFbt.ColumnType).STATUS) newState[issueKey] = {
                ...newState[issueKey],
                columnId: payload.closestColumn.id,
                statusId: payload.closestColumn.statuses[0].id
            };
        });
        return newState;
    }
    if (action.type === (0, $iaYF9.ISSUE_ADD_LABELS)) {
        const { payload: { issueIds: issueIds, labels: labels } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>{
            if (!state[String(id)]) return;
            const currentLabels = state[String(id)].labels || [];
            newState.setIn([
                String(id),
                'labels'
            ], (0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))(currentLabels, labels));
        });
        return newState.value();
    }
    if (action.type === (0, $3n65g.SET_PARENT_OPTIMISTIC)) {
        const { payload: { issues: issues, parentId: parentId } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issues.forEach((issue)=>{
            if (!state[String(issue.id)]) return;
            newState.setIn([
                String(issue.id),
                'parentId'
            ], parentId);
        });
        return newState.value();
    }
    if (action.type === (0, $evkwq.SET_ISSUE_PARENT)) {
        const { payload: { issueId: issueId, issueParentId: issueParentId } } = action;
        return state[String(issueId)] ? (0, $7uUwQ.setIn)(state, [
            String(issueId),
            'parentId'
        ], issueParentId) : state;
    }
    if (action.type === (0, $cAxle.ASSIGN_TO_ME_REQUEST)) {
        const { payload: { issueId: issueId, assigneeAccountId: assigneeAccountId } } = action;
        return state[String(issueId)] ? (0, $7uUwQ.setIn)(state, [
            String(issueId),
            'assigneeAccountId'
        ], assigneeAccountId) : state;
    }
    return state;
};

});

parcelRegister("9YkOZ", function(module, exports) {

$parcel$export(module.exports, "IssueLinkTypesReducer", () => $9048799d461b8027$export$8ae1bfe9b50d49e1);

var $cW3pH = parcelRequire("cW3pH");
const $9048799d461b8027$export$8ae1bfe9b50d49e1 = (state = [], action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.issueLinkTypes || [];
    return state;
};

});

parcelRegister("8UrfO", function(module, exports) {

$parcel$export(module.exports, "issueLinksPermissionsReducer", () => $5badfcd4f6059ce4$export$c36129b79b23648c);

var $cwdC8 = parcelRequire("cwdC8");
const $5badfcd4f6059ce4$var$initialState = {
    canUserLinkIssue: false,
    issueLinkTypes: []
};
const $5badfcd4f6059ce4$export$c36129b79b23648c = (state = $5badfcd4f6059ce4$var$initialState, action)=>{
    if (action.type === (0, $cwdC8.SET_ISSUE_LINKS_PERMISSIONS)) {
        const { payload: payload } = action;
        return payload;
    }
    return state;
};

});

parcelRegister("7UqIo", function(module, exports) {

$parcel$export(module.exports, "issueLinksStatsReducer", () => $2739d03280fa896b$export$2d8536f954ee93c4);

var $4RVsR = parcelRequire("4RVsR");
const $2739d03280fa896b$var$initialState = {
    statisticItems: {},
    loadingStatisticsItems: []
};
const $2739d03280fa896b$export$2d8536f954ee93c4 = (state = $2739d03280fa896b$var$initialState, action)=>{
    if (action.type === (0, $4RVsR.SET_ISSUE_LINKS_STATS)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return {
            statisticItems: {
                ...state.statisticItems,
                ...payload.statisticItems
            },
            loadingStatisticsItems: []
        };
    }
    if (action.type === (0, $4RVsR.SET_ISSUE_LINKS_STATS_LOADING)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return {
            ...state,
            loadingStatisticsItems: payload
        };
    }
    return state;
};

});

parcelRegister("2ZUt8", function(module, exports) {

$parcel$export(module.exports, "issueMediaReducer", () => $065f4ee1be2c8dd1$export$f10a05bd85382e68);

var $7uUwQ = parcelRequire("7uUwQ");

var $2f454 = parcelRequire("2f454");

var $dN3Ms = parcelRequire("dN3Ms");

var $cW3pH = parcelRequire("cW3pH");
const $065f4ee1be2c8dd1$export$f10a05bd85382e68 = (state = {}, action)=>{
    if (action.type === (0, $dN3Ms.ISSUE_MEDIA_VISIBILITY_CHANGE_REQUEST)) {
        const { issueId: issueId, isVisible: isVisible } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            `${issueId}`,
            'isHiddenByUser'
        ], !isVisible);
    }
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { payload: { issueMedia: issueMedia } } = action;
        return (0, $7uUwQ.merge)(state, issueMedia);
    }
    if (action.type === (0, $2f454.CARD_MEDIA_DATA_SET)) {
        const { payload: { issueMedia: issueMedia } } = action;
        return (0, $7uUwQ.merge)(state, issueMedia);
    }
    return state;
};

});

parcelRegister("jVK6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $1043ebaae86b63b4$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $1ShTS = parcelRequire("1ShTS");

var $2f454 = parcelRequire("2f454");

var $3n65g = parcelRequire("3n65g");

var $4l4AL = parcelRequire("4l4AL");

var $cW3pH = parcelRequire("cW3pH");
const $1043ebaae86b63b4$var$reducer = (state = {}, action)=>{
    switch(action.type){
        case 0, $cW3pH.WORK_DATA_SET:
        case 0, $cW3pH.WORK_DATA_CRITICAL_SET:
            return (0, $1ShTS.entityArrayToMap)(action.payload.issueParents);
        case 0, $3n65g.SET_ISSUE_PARENT_SUMMARY:
            {
                const { issueId: issueId, issueSummary: issueSummary } = action.payload;
                if (state[String(issueId)]) return (0, $7uUwQ.setIn)(state, [
                    String(issueId),
                    'summary'
                ], issueSummary);
                return state;
            }
        case 0, $4l4AL.SET_SUMMARY:
            {
                const { payload: { issueId: issueId, summary: summary } } = action;
                if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
                    String(issueId),
                    'summary'
                ], summary).value();
                return state;
            }
        case 0, $3n65g.SET_ISSUE_PARENT_STATUS:
            {
                const { issueId: issueId, status: status } = action.payload;
                if (state[String(issueId)]) return (0, $7uUwQ.setIn)(state, [
                    String(issueId),
                    'status'
                ], status);
                return state;
            }
        case 0, $2f454.CARD_DELETE:
            {
                const { payload: { issueId: issueId } } = action;
                return state[String(issueId)] ? (0, $7uUwQ.unset)(state, String(issueId)) : state;
            }
        case 0, $3n65g.ADD_ISSUE_PARENT:
            {
                const { issue: issue } = action.payload;
                return (0, $7uUwQ.setIn)(state, [
                    String(issue.id)
                ], issue);
            }
        default:
            return state;
    }
};
var $1043ebaae86b63b4$export$2e2bcd8739ae039 = $1043ebaae86b63b4$var$reducer;

});
parcelRegister("4l4AL", function(module, exports) {

$parcel$export(module.exports, "SET_SUMMARY", () => $8493049eed778780$export$f10628d1e68d9122);
$parcel$export(module.exports, "setSummary", () => $8493049eed778780$export$73eb0ea85742026e);
const $8493049eed778780$export$f10628d1e68d9122 = 'state.actions.issue.summary.SET_SUMMARY';
const $8493049eed778780$export$73eb0ea85742026e = (issueId, summary)=>({
        type: $8493049eed778780$export$f10628d1e68d9122,
        payload: {
            issueId: issueId,
            summary: summary
        }
    });

});


parcelRegister("9Rk3Z", function(module, exports) {

$parcel$export(module.exports, "issuePriorityInformationReducer", () => $919f59a89417de75$export$60827b86fb797c41);

var $cW3pH = parcelRequire("cW3pH");
const $919f59a89417de75$export$d4c72bab9d6cc13a = {
    issuePriorities: {},
    issuePrioritySchemes: {},
    projectToPrioritySchemeAssociations: {}
};
const $919f59a89417de75$export$60827b86fb797c41 = (state = $919f59a89417de75$export$d4c72bab9d6cc13a, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        if (action.payload.issuePriorityInformation !== undefined) return action.payload.issuePriorityInformation;
    }
    return state;
};

});

parcelRegister("e3PD9", function(module, exports) {

$parcel$export(module.exports, "issueProjectsReducer", () => $03b0cf5266a48e76$export$389f8d361922f42f);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $03b0cf5266a48e76$export$389f8d361922f42f = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return (0, $1ShTS.entityArrayToMap)(action.payload.projects);
    return state;
};

});

parcelRegister("qY0zX", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cf6a330964f9ec0$export$2e2bcd8739ae039);

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");
const $1cf6a330964f9ec0$var$emptyState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$1cf6a330964f9ec0$export$2e2bcd8739ae039 = (state = $1cf6a330964f9ec0$var$emptyState, action)=>{
    switch(action.type){
        case 0, $2f454.CARD_GET_ISSUE_TRANSITIONS:
            return {
                [String(action.payload.issueId)]: {
                    status: 'loading'
                }
            };
        case 0, $2f454.CARD_SET_ISSUE_TRANSITIONS:
            return {
                [String(action.payload.issueId)]: {
                    status: 'success',
                    data: action.payload.columnTransitions
                }
            };
        case 0, $2f454.CARD_GET_ISSUE_TRANSITIONS_FAILURE:
            return {
                [String(action.payload.issueId)]: {
                    status: 'failure'
                }
            };
        case 0, $eu61M.DRAG_END:
            return $1cf6a330964f9ec0$var$emptyState;
        default:
            return state;
    }
};

});

parcelRegister("11N2b", function(module, exports) {

$parcel$export(module.exports, "issueTypesByProjectReducer", () => $7beb707e6ea337be$export$1ca1e60461ab7ad0);

var $cW3pH = parcelRequire("cW3pH");
const $7beb707e6ea337be$export$1ca1e60461ab7ad0 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return action.payload.issueTypesByProject || {};
    return state;
};

});

parcelRegister("ilheH", function(module, exports) {

$parcel$export(module.exports, "issueTypesReducer", () => $ec796d54b4bd0aa3$export$336eabad729f8d11);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $ec796d54b4bd0aa3$export$336eabad729f8d11 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issueTypes: issueTypes } } = action;
        return (0, $1ShTS.entityArrayToMap)(issueTypes);
    }
    return state;
};

});

parcelRegister("eeFib", function(module, exports) {

$parcel$export(module.exports, "issueEntitiesReducer", () => $3466276f37f06248$export$cef6d2e3275b53a3);

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $dDkmN = parcelRequire("dDkmN");

var $5rFbt = parcelRequire("5rFbt");

var $4R6GH = parcelRequire("4R6GH");

var $4jAPy = parcelRequire("4jAPy");

var $g5X3G = parcelRequire("g5X3G");

var $dGANR = parcelRequire("dGANR");


var $c79wa = parcelRequire("c79wa");

var $1ShTS = parcelRequire("1ShTS");

var $doOdQ = parcelRequire("doOdQ");

var $2f454 = parcelRequire("2f454");

var $63F6h = parcelRequire("63F6h");

var $iaYF9 = parcelRequire("iaYF9");

var $cAxle = parcelRequire("cAxle");

var $dMBwz = parcelRequire("dMBwz");

var $4nScF = parcelRequire("4nScF");

var $ls4NM = parcelRequire("ls4NM");

var $kXqRJ = parcelRequire("kXqRJ");

var $9WrsG = parcelRequire("9WrsG");

var $9jMeJ = parcelRequire("9jMeJ");

var $bLC9D = parcelRequire("bLC9D");

var $fBkjL = parcelRequire("fBkjL");

var $e1q2I = parcelRequire("e1q2I");

var $6WzWZ = parcelRequire("6WzWZ");

var $cIqUn = parcelRequire("cIqUn");

var $3n65g = parcelRequire("3n65g");

var $5UXId = parcelRequire("5UXId");

var $71oFY = parcelRequire("71oFY");

var $4l4AL = parcelRequire("4l4AL");

var $evkwq = parcelRequire("evkwq");

var $7ZWvl = parcelRequire("7ZWvl");

var $cW3pH = parcelRequire("cW3pH");

var $9da86 = parcelRequire("9da86");
const $3466276f37f06248$export$cef6d2e3275b53a3 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { issues: issues } } = action;
        return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(issues));
    }
    if (action.type === (0, $5UXId.ISSUE_RANK_TEAM_DATE_REQUEST)) {
        const { payload: { issueIds: issueIds, destinationColumnId: destinationColumnId, destinationSwimlaneId: destinationSwimlaneId } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            changeChain.setIn([
                String(issueId),
                'columnId'
            ], destinationColumnId);
            changeChain.setIn([
                String(issueId),
                'teamId'
            ], destinationSwimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) ? undefined : destinationSwimlaneId);
            changeChain.setIn([
                String(issueId),
                'hasScenarioChanges'
            ], true);
        });
        return changeChain.value();
    }
    if (action.type === (0, $dMBwz.ISSUE_BULK_UPDATE_REQUEST)) {
        const { payload: { issueIds: issueIds, sprint: sprint } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)] || sprint === undefined) return;
            changeChain.setIn([
                String(issueId),
                'sprintId'
            ], sprint);
        });
        return changeChain.value();
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues, type: type } } = action;
        if (type !== (0, $dcbb2bce513725b3$export$b05303cbde3e8c8c)) return state;
        const newState = {
            ...state
        };
        issues.forEach((issue)=>{
            newState[String(issue.id)] = issue;
        });
        return (0, $7uUwQ.freeze)(newState);
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS)) {
        const { payload: { temporaryIssueIds: temporaryIssueIds, issues: issues } } = action;
        const newState = {
            ...state
        };
        if (temporaryIssueIds.some((id)=>state[String(id)])) {
            temporaryIssueIds.forEach((temporaryId)=>{
                delete newState[String(temporaryId)];
            });
            issues.forEach((issue)=>{
                newState[String(issue.id)] = issue;
            });
            return (0, $7uUwQ.freeze)(newState);
        }
        return state;
    }
    if (action.type === (0, $evkwq.ISSUE_UPDATE_SUCCESS)) {
        const { payload: { issue: issue } } = action;
        const issueId = String(issue.id);
        if (state[issueId]) return (0, $7uUwQ.set)(state, issueId, issue);
        return state;
    }
    if (action.type === (0, $2f454.CARD_DATA_SET)) {
        const { payload: { issue: issue } } = action;
        const issueId = String(issue.id);
        const issueInState = state[issueId];
        if (issueInState) return (0, $7uUwQ.set)(state, issueId, {
            ...issue,
            devStatus: issue.devStatus || issueInState.devStatus
        });
        if (state[issueId]) return (0, $7uUwQ.set)(state, issueId, issue);
        return state;
    }
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST) || action.type === (0, $9da86.ISSUE_ARCHIVE_REQUEST)) {
        const { payload: { issue: issue } } = action;
        return (0, $7uUwQ.unset)(state, String(issue.id));
    }
    if (action.type === (0, $2f454.CARD_DELETE)) {
        const { payload: { issueId: issueId, parentId: parentId, isDone: isDone } } = action;
        // if the deleted issue is a base level issue, remove the issue right away
        if (state[String(issueId)]) return (0, $7uUwQ.unset)(state, String(issueId));
        // if the deleted issue is a subtask, update children properties of the issue
        if (state[String(parentId)]) return (0, $7uUwQ.chain)(state).updateIn([
            String(parentId),
            'numCompleteChildren'
        ], (value)=>isDone ? Math.max(value - 1, 0) : value).updateIn([
            String(parentId),
            'numTotalChildren'
        ], (value)=>Math.max(value - 1, 0)).value();
        // if the deleted issue is an epic, update the issues that are children of the epic
        const newState = (0, $7uUwQ.chain)(state);
        (0, $g5X3G.values)(state).forEach(({ id: id, parentId: issueParentId })=>{
            if (issueId && issueId === issueParentId) newState.setIn([
                String(id),
                'parentId'
            ], null);
        });
        return newState.value();
    }
    if (action.type === (0, $2f454.CARD_CLEAR)) {
        const { payload: { cardIds: cardIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        cardIds.forEach((cardId)=>{
            newState.unset(String(cardId));
        });
        return newState.value();
    }
    if (action.type === (0, $cIqUn.ISSUE_MOVE_TO_BACKLOG_REQUEST)) {
        const { payload: { issueIds: issueIds } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            newState.unset(String(issueId));
        });
        return newState.value();
    }
    if (action.type === (0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC)) {
        const { payload: { issueIds: issueIds, destinationColumnId: destinationColumnId, isDestinationDone: isDestinationDone, destinationStatus: destinationStatus, isCMPBoard: isCMPBoard } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            changeChain.setIn([
                String(issueId),
                'columnId'
            ], destinationColumnId);
            if (destinationStatus) changeChain.setIn([
                String(issueId),
                'statusId'
            ], Number(destinationStatus.id));
            if (!isCMPBoard) // We use `isDone` to show issue key strikethrough as an indicator of issue resolution.
            // Only for TMP, status' category equaling `Done` means the issue is resolved.
            // For CMP, we cannot determine an issue's resolution completely client-side due to the complexities of non-simplified workflows.
            // As we fire a data refresh request on each issue transition for CMP, the correct `isDone` value will be pulled from the server anyway with a slight delay.
            changeChain.setIn([
                String(issueId),
                'isDone'
            ], isDestinationDone);
        });
        return changeChain.value();
    }
    if (action.type === (0, $doOdQ.BACKLOG_ISSUE_MOVE_EXECUTE)) {
        const { payload: { issueIds: issueIds } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>changeChain.unset(String(id)));
        return changeChain.value();
    }
    if (action.type === (0, $e1q2I.ISSUE_CHANGE_SWIMLANE)) {
        const { payload: { issueIds: issueIds, swimlaneValues: swimlaneValues } } = action;
        const changeChain = (0, $7uUwQ.chain)(state);
        issueIds.forEach((issueId)=>{
            if (!state[String(issueId)]) return;
            if (swimlaneValues.type === (0, $c79wa.ASSIGNEE)) changeChain.setIn([
                String(issueId),
                'assigneeAccountId'
            ], swimlaneValues.assigneeAccountId);
            if (swimlaneValues.type === (0, $c79wa.PARENT)) changeChain.setIn([
                String(issueId),
                'parentId'
            ], swimlaneValues.parentId);
        });
        return changeChain.value();
    }
    if (action.type === (0, $9WrsG.DEV_STATUS_LOAD_SUCCESS)) {
        const { payload: payload } = action;
        const newState = (0, $7uUwQ.chain)(state);
        Object.keys(payload).forEach((issueIdString)=>{
            if (!state[String(issueIdString)]) return;
            newState.setIn([
                issueIdString,
                'devStatus'
            ], payload[issueIdString]);
        });
        return newState.value();
    }
    if (action.type === (0, $fBkjL.ISSUE_FLAG_WITH_COMMENT_REQUEST)) {
        const { payload: { issueIds: issueIds, flag: flag } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>{
            if (state[String(id)]) newState.setIn([
                String(id),
                'isFlagged'
            ], flag);
        });
        return newState.value();
    }
    if (action.type === (0, $cAxle.ASSIGN_TO_ME_REQUEST)) {
        const { payload: { issueId: issueId, assigneeAccountId: assigneeAccountId } } = action;
        return state[String(issueId)] ? (0, $7uUwQ.setIn)(state, [
            String(issueId),
            'assigneeAccountId'
        ], assigneeAccountId) : state;
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const newState = {
            ...state
        };
        const { payload: payload } = action;
        Object.keys(state).filter((issueKey)=>state[issueKey].columnId === payload.columnId).forEach((issueKey)=>{
            if (!payload.closestColumn) delete newState[issueKey];
            else if (payload.closestColumn.type === (0, $5rFbt.ColumnType).STATUS) newState[issueKey] = {
                ...newState[issueKey],
                columnId: payload.closestColumn.id,
                statusId: payload.closestColumn.statuses[0].id
            };
        });
        return newState;
    }
    if (action.type === (0, $iaYF9.ISSUE_ADD_LABELS)) {
        const { payload: { issueIds: issueIds, labels: labels } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issueIds.forEach((id)=>{
            if (!state[String(id)]) return;
            const currentLabels = state[String(id)].labels || [];
            newState.setIn([
                String(id),
                'labels'
            ], (0, (/*@__PURE__*/$parcel$interopDefault($dDkmN)))(currentLabels, labels));
        });
        return newState.value();
    }
    if (action.type === (0, $3n65g.SET_PARENT_OPTIMISTIC)) {
        const { payload: { issues: issues, parentId: parentId } } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issues.forEach((issue)=>{
            if (!state[String(issue.id)]) return;
            newState.setIn([
                String(issue.id),
                'parentId'
            ], parentId);
            newState.setIn([
                String(issue.id),
                'hasScenarioChanges'
            ], true);
        });
        return newState.value();
    }
    if (action.type === (0, $9jMeJ.SET_ESTIMATE)) {
        const { payload: { issueId: issueId, estimate: estimate } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'estimate'
        ], estimate).setIn([
            String(issueId),
            'hasScenarioChanges'
        ], true).value();
        return state;
    }
    if (action.type === (0, $bLC9D.SET_PRIORITY) && (0, $4R6GH.fg)('issue_cards_in_program_board')) {
        const { payload: { issueId: issueId, priority: priority } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'priority'
        ], priority).value();
        return state;
    }
    if (action.type === (0, $evkwq.SET_ISSUE_PARENT)) {
        const { payload: { issueId: issueId, issueParentId: issueParentId } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'parentId'
        ], issueParentId).setIn([
            String(issueId),
            'hasScenarioChanges'
        ], true).value();
        return state;
    }
    if (action.type === (0, $4nScF.SET_CHILD_ISSUES_METADATA)) {
        const { payload: issues } = action;
        const newState = (0, $7uUwQ.chain)(state);
        issues.forEach((issue)=>{
            if (!state[String(issue.id)]) return;
            newState.setIn([
                String(issue.id),
                'numTotalChildren'
            ], issue.numTotalChildren || 0);
            newState.setIn([
                String(issue.id),
                'numCompleteChildren'
            ], issue.numCompleteChildren || 0);
        });
        return newState.value();
    }
    if (action.type === (0, $4l4AL.SET_SUMMARY)) {
        const { payload: { issueId: issueId, summary: summary } } = action;
        if (state[String(issueId)]) return (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'summary'
        ], summary).setIn([
            String(issueId),
            'hasScenarioChanges'
        ], true).value();
        return state;
    }
    if (action.type === (0, $6WzWZ.ISSUE_LINKS_ADD_UPDATE_SUCCESS)) {
        const { payload: { newIssueLinks: newIssueLinks } } = action;
        const newIssueLinksGroups = Object.entries(newIssueLinks);
        const newState = (0, $7uUwQ.chain)(state);
        newIssueLinksGroups.forEach(([issueId, issueLinks])=>{
            newState.setIn([
                String(issueId),
                'issueLinks'
            ], issueLinks);
            newState.setIn([
                String(issueId),
                'hasScenarioChanges'
            ], true);
        });
        return newState.value();
    }
    if (action.type === (0, $6WzWZ.ISSUE_LINKS_REMOVE_SUCCESS)) {
        const { payload: { issueLinksToRemove: issueLinksToRemove } } = action;
        const issueLinksGroups = Object.entries(issueLinksToRemove);
        const newState = (0, $7uUwQ.chain)(state);
        const updateState = (issueId, issueLinkIdToRemove)=>{
            if (issueId) {
                const issueLinks = state[String(issueId)]?.issueLinks ?? [];
                newState.setIn([
                    String(issueId),
                    'issueLinks'
                ], issueLinks.filter((issueLink)=>issueLinkIdToRemove !== issueLink.id));
                newState.setIn([
                    String(issueId),
                    'hasScenarioChanges'
                ], true);
            }
        };
        issueLinksGroups.forEach(([issueId, issueLinkId])=>{
            const issueLinks = state[String(issueId)]?.issueLinks ?? [];
            const issueLinkToRemove = issueLinks.find((issueLink)=>issueLinkId === issueLink.id);
            // Update issue links state in the source issue
            updateState(issueLinkToRemove?.sourceId, issueLinkId);
            // Update issue links state in the destination issue
            updateState(issueLinkToRemove?.destinationId, issueLinkId);
        });
        return newState.value();
    }
    // for the IP board, when editing the assignee,estimate,parent,priority, summary,
    // instead of directly updating these fields of the issue in this action ISSUE_INCREMENT_PLANNING_UPDATE,
    // making use the `src/packages/software/board/src/view/all-fields-sync/field-sync/*` to sync values of these fields
    // from the fields sweet state to the board which will call corresponding action, like setPriority, setSummary etc.
    // for updating status in the IP board, there is not a field sync, so need to manually to update the issue status after ISSUE_INCREMENT_PLANNING_UPDATE
    if (action.type === (0, $evkwq.ISSUE_INCREMENT_PLANNING_UPDATE) && (0, $4R6GH.fg)('issue_cards_in_program_board')) {
        const { payload: { issueId: issueId } } = action;
        return state[String(issueId)] ? (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'hasScenarioChanges'
        ], true).value() : state;
    }
    if (action.type === (0, $7ZWvl.SET_ISSUE_STATUS_INCREMENT_PLANNING) && (0, $4R6GH.fg)('issue_cards_in_program_board')) {
        const { payload: { issueId: issueId, fieldValue: fieldValue } } = action;
        // for revert status
        if (fieldValue.statusTransitionId === (0, $dGANR.ORIGINAL_STATUS_TRANSITION).id) return state[String(issueId)] ? (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'statusId'
        ], fieldValue.statusId).setIn([
            String(issueId),
            'originals',
            'statusId'
        ], undefined).setIn([
            String(issueId),
            'isDone'
        ], fieldValue.isDone).value() : state;
        const originalStatus = (0, $7uUwQ.getIn)(state, [
            String(issueId),
            'originals',
            'statusId'
        ]);
        const statusId = (0, $7uUwQ.getIn)(state, [
            String(issueId),
            'statusId'
        ]);
        return state[String(issueId)] ? (0, $7uUwQ.chain)(state).setIn([
            String(issueId),
            'statusId'
        ], fieldValue.statusId).setIn([
            String(issueId),
            'hasScenarioChanges'
        ], true).setIn([
            String(issueId),
            'isDone'
        ], fieldValue.isDone).setIn([
            String(issueId),
            'originals',
            'statusId'
        ], (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalStatus) ? statusId : originalStatus).value() : state;
    }
    return state;
};

});
parcelRegister("9jMeJ", function(module, exports) {

$parcel$export(module.exports, "SET_ESTIMATE", () => $05cbc5c61ca66428$export$c2ccd34996aa2a3);
$parcel$export(module.exports, "setEstimate", () => $05cbc5c61ca66428$export$c07ffb1ffa646b52);
const $05cbc5c61ca66428$export$c2ccd34996aa2a3 = 'state.actions.issue.SET_ESTIMATE';
const $05cbc5c61ca66428$export$c07ffb1ffa646b52 = (issueId, estimate)=>({
        type: $05cbc5c61ca66428$export$c2ccd34996aa2a3,
        payload: {
            issueId: issueId,
            estimate: estimate
        }
    });

});

parcelRegister("bLC9D", function(module, exports) {

$parcel$export(module.exports, "SET_PRIORITY", () => $f5dcc94cb2264f4a$export$30014b3e5df6c0df);
$parcel$export(module.exports, "setPriority", () => $f5dcc94cb2264f4a$export$313bf5dbe7a1196e);
const $f5dcc94cb2264f4a$export$30014b3e5df6c0df = 'state.actions.issue.SET_PRIORITY';
const $f5dcc94cb2264f4a$export$313bf5dbe7a1196e = (issueId, priority)=>({
        type: $f5dcc94cb2264f4a$export$30014b3e5df6c0df,
        payload: {
            issueId: issueId,
            priority: priority
        }
    });

});


parcelRegister("gnRwu", function(module, exports) {

$parcel$export(module.exports, "jqlSwimlanesReducer", () => $45dac62359d26ad8$export$1198b282f759ee69);

var $7uUwQ = parcelRequire("7uUwQ");

var $127QL = parcelRequire("127QL");

var $ls4NM = parcelRequire("ls4NM");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");
const $45dac62359d26ad8$var$initialState = {
    swimlanes: []
};
function $45dac62359d26ad8$export$1198b282f759ee69(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
state = $45dac62359d26ad8$var$initialState, action) {
    if (action.type === (0, $cW3pH.WORK_DATA_SET) && action.payload.jqlSwimlanes) {
        const { jqlSwimlanes: jqlSwimlanes } = action.payload;
        return {
            swimlanes: jqlSwimlanes
        };
    }
    if (action.type === (0, $k50Aq.SWIMLANE_JQL_SET_DATA) && action.payload != null) return {
        swimlanes: action.payload
    };
    if (action.type === (0, $127QL.BOARD_DEFERRED_DATA_LOAD_SUCCESS) && action.payload.jqlSwimlanes) {
        const { jqlSwimlanes: jqlSwimlanes } = action.payload;
        return {
            swimlanes: jqlSwimlanes
        };
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_REQUEST)) {
        const { payload: { issues: issues }, meta: { insertBefore: insertBefore, swimlaneId: swimlaneId, isSwimlaneByJql: isSwimlaneByJql } } = action;
        if (!isSwimlaneByJql || !state) return state || $45dac62359d26ad8$var$initialState;
        const swimlaneWithNewIssuesIndex = state.swimlanes.findIndex((sw)=>{
            // If swimlaneId is null in the create request, then it corresponds to the default swimlane
            if (swimlaneId === null) return sw.isDefaultSwimlane;
            return String(sw.id) === String(swimlaneId);
        });
        if (swimlaneWithNewIssuesIndex === -1) return state || $45dac62359d26ad8$var$initialState;
        const swimlaneIssueIds = state.swimlanes[swimlaneWithNewIssuesIndex].issueIds;
        const insertionPoint = insertBefore ? swimlaneIssueIds.indexOf(insertBefore) : swimlaneIssueIds.length;
        const issueIds = issues.map(({ id: id })=>id);
        const chainState = (0, $7uUwQ.chain)(state);
        chainState.setIn([
            'swimlanes',
            swimlaneWithNewIssuesIndex,
            'issueIds'
        ], (0, $7uUwQ.splice)(swimlaneIssueIds, insertionPoint, 0, ...issueIds));
        return chainState.value();
    }
    return state || $45dac62359d26ad8$var$initialState;
}

});

parcelRegister("1gv2w", function(module, exports) {

$parcel$export(module.exports, "missingParentsReducer", () => $b10ef32ddec0b98d$export$8807809ac34c19b3);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $4Xk2W = parcelRequire("4Xk2W");

var $hDdMY = parcelRequire("hDdMY");

var $cW3pH = parcelRequire("cW3pH");
const $b10ef32ddec0b98d$export$8807809ac34c19b3 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) && action.payload.missingParents) return (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(action.payload.missingParents, 'id');
    if (action.type === (0, $hDdMY.MISSING_PARENT_RESOLVE_OPTIMISTIC)) {
        const { payload: { issueId: issueId, doneStatusName: doneStatusName } } = action;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(state) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(state[issueId] && (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(doneStatusName))) return (0, $7uUwQ.chain)(state).setIn([
            issueId,
            'status',
            'name'
        ], doneStatusName)// update this for displaying correct status color and strikethrough on issue key
        .setIn([
            issueId,
            'status',
            'category'
        ], 'DONE').value();
    }
    return state;
};

});

parcelRegister("8DmOP", function(module, exports) {

$parcel$export(module.exports, "peopleReducer", () => $8a3c043ce49ee73f$export$932ae1ae35decba3);

var $7uUwQ = parcelRequire("7uUwQ");

var $1ShTS = parcelRequire("1ShTS");

var $2f454 = parcelRequire("2f454");

var $hoX5N = parcelRequire("hoX5N");

var $cW3pH = parcelRequire("cW3pH");
const $8a3c043ce49ee73f$export$932ae1ae35decba3 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return (0, $7uUwQ.merge)(state, (0, $1ShTS.entityArrayToMap)(action.payload.people));
    if (action.type === (0, $hoX5N.PERSON_SET)) return (0, $7uUwQ.merge)(state, {
        [action.payload.id]: action.payload
    });
    if (action.type === (0, $2f454.CARD_DATA_SET)) {
        const { payload: { person: person } } = action;
        if (person) return (0, $7uUwQ.merge)(state, {
            [person.id]: person
        });
    }
    return state;
};

});

parcelRegister("cidFT", function(module, exports) {

$parcel$export(module.exports, "projectIssueTypesReducer", () => $348d978c6ff3e4fc$export$a7ff3ce1c63497a1);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $348d978c6ff3e4fc$export$a7ff3ce1c63497a1 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        const { payload: { projectIssueTypes: projectIssueTypes } } = action;
        return (0, $1ShTS.entityArrayToMap)(projectIssueTypes);
    }
    return state;
};

});

parcelRegister("kLXNe", function(module, exports) {

$parcel$export(module.exports, "requestTypesReducer", () => $ec11ba9c8eef2662$export$dae3c1635063e9bf);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $ec11ba9c8eef2662$export$dae3c1635063e9bf = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { payload: { requestTypes: requestTypes } } = action;
        return (0, $1ShTS.entityArrayToMap)(requestTypes);
    }
    return state;
};

});

parcelRegister("6S8mJ", function(module, exports) {

$parcel$export(module.exports, "sprintsReducer", () => $60d381dec2296b87$export$4b86860ac786fd91);

var $7uUwQ = parcelRequire("7uUwQ");

var $1ShTS = parcelRequire("1ShTS");

var $127QL = parcelRequire("127QL");

var $e0GMz = parcelRequire("e0GMz");

var $cW3pH = parcelRequire("cW3pH");
const $60d381dec2296b87$export$4b86860ac786fd91 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if ((action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) && action.payload.sprints) return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(action.payload.sprints));
    if (action.type === (0, $e0GMz.EDIT_SPRINT_REQUEST)) {
        const { id: id, name: name, goal: goal, startDate: startDate, endDate: endDate } = action.payload;
        const newState = (0, $7uUwQ.chain)(state).setIn([
            id,
            'name'
        ], name).setIn([
            id,
            'goal'
        ], goal).setIn([
            id,
            'startDate'
        ], startDate).setIn([
            id,
            'endDate'
        ], endDate).value();
        return newState;
    }
    if (action.type === (0, $e0GMz.EDIT_SPRINT_SUCCESS)) {
        const { id: id, daysRemaining: daysRemaining } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            id,
            'daysRemaining'
        ], daysRemaining);
    }
    if (action.type === (0, $127QL.BOARD_DEFERRED_DATA_LOAD_SUCCESS)) {
        const { sprints: sprints } = action.payload;
        if (sprints) return (0, $7uUwQ.freeze)((0, $1ShTS.entityArrayToMap)(sprints));
    }
    return state;
};

});
parcelRegister("e0GMz", function(module, exports) {

$parcel$export(module.exports, "EDIT_SPRINT_REQUEST", () => $a0b30c282ed6c8d9$export$123abdbc4d2e52b2);
$parcel$export(module.exports, "editSprintRequest", () => $a0b30c282ed6c8d9$export$f1ede94f3f629cd9);
$parcel$export(module.exports, "EDIT_SPRINT_SUCCESS", () => $a0b30c282ed6c8d9$export$e043c26cf23a5c18);
$parcel$export(module.exports, "editSprintSuccess", () => $a0b30c282ed6c8d9$export$3b274a040443f185);
$parcel$export(module.exports, "editSprintFailure", () => $a0b30c282ed6c8d9$export$193b8520faf6f6b0);

var $9rND4 = parcelRequire("9rND4");
const $a0b30c282ed6c8d9$export$123abdbc4d2e52b2 = 'state.actions.sprints.edit.EDIT_SPRINT_REQUEST';
const $a0b30c282ed6c8d9$export$f1ede94f3f629cd9 = (id, name, goal, startDate, endDate)=>({
        type: $a0b30c282ed6c8d9$export$123abdbc4d2e52b2,
        payload: {
            id: id,
            name: name,
            goal: goal,
            startDate: startDate,
            endDate: endDate
        },
        meta: (0, $9rND4.beginOptimisticUiMeta)()
    });
const $a0b30c282ed6c8d9$export$e043c26cf23a5c18 = 'state.actions.sprints.edit.EDIT_SPRINT_SUCCESS';
const $a0b30c282ed6c8d9$export$3b274a040443f185 = (txId, id, daysRemaining)=>({
        type: $a0b30c282ed6c8d9$export$e043c26cf23a5c18,
        payload: {
            id: id,
            daysRemaining: daysRemaining
        },
        meta: (0, $9rND4.commitOptimisticUiMeta)(txId)
    });
const $a0b30c282ed6c8d9$export$c58baca64c75a779 = 'state.actions.sprints.edit.EDIT_SPRINT_FAILURE';
const $a0b30c282ed6c8d9$export$193b8520faf6f6b0 = (txId)=>({
        type: $a0b30c282ed6c8d9$export$c58baca64c75a779,
        meta: (0, $9rND4.revertOptimisticUiWithFlagMeta)(txId)
    });

});


parcelRegister("3IVsJ", function(module, exports) {

$parcel$export(module.exports, "statusCategoriesReducer", () => $fa7d382cb4f206fe$export$871c8938e4e152c3);

var $7uUwQ = parcelRequire("7uUwQ");

var $1ShTS = parcelRequire("1ShTS");

var $j6rJH = parcelRequire("j6rJH");
const $fa7d382cb4f206fe$export$871c8938e4e152c3 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if (action.type === (0, $j6rJH.STATUS_CATEGORY_LOAD_SUCCESS)) {
        const { statusCategories: statusCategories } = action.payload;
        return (0, $7uUwQ.merge)(state, (0, $1ShTS.entityArrayToMap)(statusCategories));
    }
    return state;
};

});

parcelRegister("9i87f", function(module, exports) {

$parcel$export(module.exports, "statusesReducer", () => $305df271d28d9124$export$3839708f801ae842);

var $1ShTS = parcelRequire("1ShTS");

var $cW3pH = parcelRequire("cW3pH");
const $305df271d28d9124$export$3839708f801ae842 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { payload: { statuses: statuses } } = action;
        return (0, $1ShTS.entityArrayToMap)(statuses);
    }
    return state;
};

});

parcelRegister("lEneF", function(module, exports) {

$parcel$export(module.exports, "teamsReducer", () => $f57d90a115faafdb$export$dfa96653a810691);

var $7uUwQ = parcelRequire("7uUwQ");

var $h2cxV = parcelRequire("h2cxV");

var $1ShTS = parcelRequire("1ShTS");

var $4kOHs = parcelRequire("4kOHs");

var $bL0WB = parcelRequire("bL0WB");

var $cW3pH = parcelRequire("cW3pH");
const $f57d90a115faafdb$export$dfa96653a810691 = (state = {}, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) return (0, $1ShTS.entityArrayToMap)(action.payload.teams || []);
    if (action.type === (0, $4kOHs.UPDATE_PLANNED_CAPACITY_SUCCESS)) {
        const { teamId: teamId, iterationId: iterationId, capacity: capacity } = action.payload;
        if (capacity === null) // if the capacity has been removed, we remove the entry from state so that we fall back to the default capacity
        return (0, $h2cxV.default)(state, [
            teamId,
            'capacityBySprintId',
            iterationId
        ]);
        const newState = (0, $7uUwQ.chain)(state).setIn([
            teamId,
            'capacityBySprintId',
            iterationId,
            'capacity'
        ], capacity).value();
        return newState;
    }
    if (action.type === (0, $bL0WB.UPDATE_ITERATION_CAPACITY_SUCCESS)) {
        const { teamId: teamId, iterationId: iterationId, capacity: capacity } = action.payload;
        if (capacity === null) // if the capacity has been removed, we remove the entry from state so that we fall back to the default capacity
        return (0, $h2cxV.default)(state, [
            teamId,
            'capacityByIterationId',
            iterationId
        ]);
        const newState = (0, $7uUwQ.chain)(state).setIn([
            teamId,
            'capacityByIterationId',
            iterationId,
            'capacity'
        ], capacity).value();
        return newState;
    }
    return state;
};

});
parcelRegister("h2cxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $b2606ddc7a8f25b8$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b2606ddc7a8f25b8$var$unsetInSingle = (state, pathToParent, key)=>{
    if (pathToParent.length === 0) return (0, $7uUwQ.unset)(state, key);
    const ret = (0, $7uUwQ.updateIn)(state, pathToParent, (parent)=>parent ? (0, $7uUwQ.unset)(parent, key) : undefined);
    return ret;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b2606ddc7a8f25b8$var$unsetInMulti = (state, pathToParent, keys)=>// @ts-expect-error - TS7006 - Parameter 'folded' implicitly has an 'any' type. | TS7006 - Parameter 'subkey' implicitly has an 'any' type.
    keys.reduce((folded, subkey)=>$b2606ddc7a8f25b8$var$unsetInSingle(folded, pathToParent, subkey), state);
var //   ['a', 'b', 'c'] - removes values at 'a/b/c'
//   ['a', ['b', 'c']] - removes values at 'a/b' and 'a/c'
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$b2606ddc7a8f25b8$export$2e2bcd8739ae039 = (state, path)=>{
    if (path.length === 0) return state;
    const pathToParent = path.slice(0, path.length - 1);
    const lastPathItem = path.slice(-1)[0];
    if (Array.isArray(lastPathItem)) return $b2606ddc7a8f25b8$var$unsetInMulti(state, pathToParent, lastPathItem);
    return $b2606ddc7a8f25b8$var$unsetInSingle(state, pathToParent, lastPathItem);
};

});


parcelRegister("8YtrK", function(module, exports) {

$parcel$export(module.exports, "versionDataReducer", () => $4679910da2681cca$export$a5073c7abdddbae4);

var $j00DX = parcelRequire("j00DX");
const $4679910da2681cca$var$initVersionDataState = {
    versionsPerProject: {},
    canCreateVersion: false
};
const $4679910da2681cca$export$a5073c7abdddbae4 = (state = $4679910da2681cca$var$initVersionDataState, action)=>{
    if (action.type === (0, $j00DX.SET_VERSION_DATA)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return {
            ...payload
        };
    }
    return state;
};

});

parcelRegister("2o5W8", function(module, exports) {

$parcel$export(module.exports, "oldOneIssuesCutOffConfigReducer", () => $1e7a61a518a5c263$export$8fa5dcb3cac7ffa5);

var $7uUwQ = parcelRequire("7uUwQ");

var $bdfJC = parcelRequire("bdfJC");

var $cW3pH = parcelRequire("cW3pH");
const $1e7a61a518a5c263$export$8fa5dcb3cac7ffa5 = (state = null, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { payload: { oldDoneIssuesCutOffConfig: oldDoneIssuesCutOffConfig } } = action;
        return oldDoneIssuesCutOffConfig ?? null;
    }
    if (action.type === (0, $bdfJC.UPDATE_OLD_DONE_ISSUES_CUTOFF)) {
        const oldDoneIssuesCutoff = action.payload;
        const newState = (0, $7uUwQ.chain)(state).setIn([
            'oldDoneIssuesCutoff'
        ], oldDoneIssuesCutoff).value();
        return newState;
    }
    return state;
};

});


parcelRegister("88zgs", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b344137c61b107e$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $4ZaWM = parcelRequire("4ZaWM");

var $69epK = parcelRequire("69epK");

var $8HqML = parcelRequire("8HqML");

var $bZSiz = parcelRequire("bZSiz");

var $98a9H = parcelRequire("98a9H");

var $4WnRS = parcelRequire("4WnRS");

var $5xTT6 = parcelRequire("5xTT6");

var $96rsq = parcelRequire("96rsq");

var $eRAwv = parcelRequire("eRAwv");

var $2hNE6 = parcelRequire("2hNE6");

var $jRjcj = parcelRequire("jRjcj");

var $kVppN = parcelRequire("kVppN");

var $i1NTq = parcelRequire("i1NTq");

var $ge2Re = parcelRequire("ge2Re");

var $iGgUa = parcelRequire("iGgUa");

var $gXQl3 = parcelRequire("gXQl3");

var $d9fmE = parcelRequire("d9fmE");

var $fJuCu = parcelRequire("fJuCu");

var $6dO4m = parcelRequire("6dO4m");

var $8V3MB = parcelRequire("8V3MB");

var $3Nx75 = parcelRequire("3Nx75");

var $7N9ZT = parcelRequire("7N9ZT");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$4b344137c61b107e$export$2e2bcd8739ae039 = ()=>(0, $3f2cs.combineReducers)({
        backlogIssueMoveDialog: (0, $8HqML.backlogIssueMoveDialogReducer),
        backlogEnableDialog: (0, $69epK.backlogEnableDialogReducer),
        board: (0, $bZSiz.default),
        column: (0, $5xTT6.default),
        columns: (0, $96rsq.columnsUIReducer),
        flags: (0, $eRAwv.flagsReducer),
        issueModal: (0, $ge2Re.issueModalReducer),
        planIssueModal: (0, $d9fmE.planIssueModalReducer),
        issueDeleteModal: (0, $kVppN.issueDeleteModalReducer),
        swimlane: (0, $8V3MB.default),
        workFilters: (0, $7N9ZT.workFiltersReducer),
        cards: (0, $98a9H.default),
        issueAddLabelModal: $jRjcj.default,
        issueTransitionModal: $iGgUa.default,
        assignIssueParentModal: $4ZaWM.default,
        columnLimits: (0, $4WnRS.default),
        panels: (0, $gXQl3.default),
        sprints: (0, $6dO4m.sprintsReducer),
        globalIssueCreate: (0, $2hNE6.default),
        updateIssueParentModal: (0, $3Nx75.updateIssueParentModalReducer),
        issueFlagWithCommentModal: (0, $i1NTq.issueFlagWithCommentModalReducer),
        sprintAssociationModal: (0, $fJuCu.sprintAssociationModalReducer)
    });

});
parcelRegister("4ZaWM", function(module, exports) {

$parcel$export(module.exports, "default", () => $d95d5fefbfd65b15$export$2e2bcd8739ae039);

var $bZ9IJ = parcelRequire("bZ9IJ");
const $d95d5fefbfd65b15$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d95d5fefbfd65b15$export$2e2bcd8739ae039 = (state = $d95d5fefbfd65b15$var$defaultState, action)=>{
    if (action.type === (0, $bZ9IJ.SHOW_ASSIGN_ISSUE_PARENT_MODAL)) return {
        isOpen: true,
        issueIds: action.payload.issueIds
    };
    if (action.type === (0, $bZ9IJ.HIDE_ASSIGN_ISSUE_PARENT_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("69epK", function(module, exports) {

$parcel$export(module.exports, "backlogEnableDialogReducer", () => $214b4c0a561a3326$export$75630e0069e51f4e);

var $7uUwQ = parcelRequire("7uUwQ");

var $2Ysq2 = parcelRequire("2Ysq2");
const $214b4c0a561a3326$var$closedState = (0, $7uUwQ.freeze)({
    isOpen: false
});
const $214b4c0a561a3326$var$openState = (0, $7uUwQ.freeze)({
    isOpen: true
});
const $214b4c0a561a3326$export$75630e0069e51f4e = (state = $214b4c0a561a3326$var$openState, action)=>{
    switch(action.type){
        case 0, $2Ysq2.BACKLOG_ENABLE_CANCEL:
            return $214b4c0a561a3326$var$closedState;
        case 0, $2Ysq2.BACKLOG_ENABLE_CONFIRM:
            return $214b4c0a561a3326$var$closedState;
        default:
            return state;
    }
};

});

parcelRegister("8HqML", function(module, exports) {

$parcel$export(module.exports, "backlogIssueMoveDialogReducer", () => $d8f17807cb00e8fb$export$c7f896523fc95ea3);

var $7uUwQ = parcelRequire("7uUwQ");

var $doOdQ = parcelRequire("doOdQ");
const $d8f17807cb00e8fb$var$closedState = (0, $7uUwQ.freeze)({
    isOpen: false
});
const $d8f17807cb00e8fb$var$openState = (0, $7uUwQ.freeze)({
    isOpen: true
});
const $d8f17807cb00e8fb$export$c7f896523fc95ea3 = (state = $d8f17807cb00e8fb$var$closedState, action)=>{
    switch(action.type){
        case 0, $doOdQ.BACKLOG_ISSUE_MOVE_SHOW:
            return $d8f17807cb00e8fb$var$openState;
        case 0, $doOdQ.BACKLOG_ISSUE_MOVE_CANCEL:
            return $d8f17807cb00e8fb$var$closedState;
        case 0, $doOdQ.BACKLOG_ISSUE_MOVE_CONFIRM:
            return $d8f17807cb00e8fb$var$closedState;
        default:
            return state;
    }
};

});

parcelRegister("bZSiz", function(module, exports) {

$parcel$export(module.exports, "default", () => $0745563943afa1e3$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $dXb3J = parcelRequire("dXb3J");

var $aX9AQ = parcelRequire("aX9AQ");

var $k8w9P = parcelRequire("k8w9P");

var $bEgEd = parcelRequire("bEgEd");

var $4Hgc5 = parcelRequire("4Hgc5");
var $0745563943afa1e3$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    isPollingEnabled: (0, $4Hgc5.isPollingEnabledReducer),
    isDragging: (0, $k8w9P.isDraggingReducer),
    displayOptions: (0, $aX9AQ.displayOptionsReducer),
    boardAddNewIssueToSprint: (0, $dXb3J.boardAddNewIssueToSprintReducer),
    isIpBoardFailed: (0, $bEgEd.isIpBoardFailedReducer)
});

});
parcelRegister("dXb3J", function(module, exports) {

$parcel$export(module.exports, "boardAddNewIssueToSprintReducer", () => $9c88adf8c3b03a8a$export$ae55eb7d73dbc5c7);

var $dkGow = parcelRequire("dkGow");
const $9c88adf8c3b03a8a$var$initialState = {
    isLoading: false,
    isSuccess: false
};
const $9c88adf8c3b03a8a$export$ae55eb7d73dbc5c7 = (state = $9c88adf8c3b03a8a$var$initialState, action)=>{
    switch(action.type){
        case 0, $dkGow.ADD_TO_SPRINT_REQUEST:
            return {
                isLoading: true,
                isSuccess: false
            };
        case 0, $dkGow.ADD_TO_SPRINT_SUCCESS:
            return {
                isLoading: false,
                isSuccess: true
            };
        case 0, $dkGow.ADD_TO_SPRINT_FAILURE:
            return {
                isLoading: false,
                isSuccess: false
            };
        default:
            break;
    }
    return state;
};

});

parcelRegister("aX9AQ", function(module, exports) {

$parcel$export(module.exports, "displayOptionsReducer", () => $7806877f42df5f5b$export$ac9a4de53985de9f);

var $bRqd3 = parcelRequire("bRqd3");

var $cTkW0 = parcelRequire("cTkW0");

var $cW3pH = parcelRequire("cW3pH");
const $7806877f42df5f5b$var$initialState = {
    areEpicLabelsHidden: false,
    isHeaderCompactMode: false,
    preventInlineEditing: false,
    // Display option for Increment planning board
    showUnscheduledColumn: true,
    showOfftrackDependencyLines: true,
    issueIdsToShowDependencies: []
};
function $7806877f42df5f5b$export$ac9a4de53985de9f(state = $7806877f42df5f5b$var$initialState, action) {
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) return {
        ...state,
        areEpicLabelsHidden: Boolean(action.payload.boardConfig.areEpicLabelsHidden)
    };
    if (action.type === (0, $bRqd3.TOGGLE_BOARD_MENUS)) return {
        ...state,
        isHeaderCompactMode: !state.isHeaderCompactMode
    };
    if (action.type === (0, $bRqd3.TOGGLE_EPIC_LABELS)) return {
        ...state,
        areEpicLabelsHidden: !state.areEpicLabelsHidden
    };
    if (action.type === (0, $cTkW0.PREVENT_INLINE_EDITING)) return {
        ...state,
        preventInlineEditing: action.payload.preventInlineEditing
    };
    if (action.type === (0, $bRqd3.SET_SHOW_UNSCHEDULED_COLUMN)) return {
        ...state,
        showUnscheduledColumn: action.payload
    };
    if (action.type === (0, $bRqd3.SET_SHOW_OFFTRACK_DEPENDENCY_LINES)) return {
        ...state,
        showOfftrackDependencyLines: action.payload
    };
    if (action.type === (0, $bRqd3.SET_ISSUE_IDS_TO_SHOW_DEPENDENCIES)) return {
        ...state,
        issueIdsToShowDependencies: action.payload
    };
    return state;
}

});
parcelRegister("cTkW0", function(module, exports) {

$parcel$export(module.exports, "PREVENT_INLINE_EDITING", () => $5ff3a4f82008cbb5$export$8bc7fdd820d3843);
$parcel$export(module.exports, "preventInlineEditingAction", () => $5ff3a4f82008cbb5$export$5a98a6267260ac54);
const $5ff3a4f82008cbb5$export$8bc7fdd820d3843 = 'state.actions.board.PREVENT_INLINE_EDITING';
const $5ff3a4f82008cbb5$export$5a98a6267260ac54 = (preventInlineEditing)=>({
        type: $5ff3a4f82008cbb5$export$8bc7fdd820d3843,
        payload: {
            preventInlineEditing: preventInlineEditing
        }
    });

});


parcelRegister("k8w9P", function(module, exports) {

$parcel$export(module.exports, "isDraggingReducer", () => $da895b06ac1cab47$export$80e81a739b833d9b);

var $eu61M = parcelRequire("eu61M");
const $da895b06ac1cab47$export$80e81a739b833d9b = (state = false, action)=>{
    if (action.type === (0, $eu61M.DRAG_START)) return true;
    if (action.type === (0, $eu61M.DRAG_END)) return false;
    return state;
};

});

parcelRegister("bEgEd", function(module, exports) {

$parcel$export(module.exports, "isIpBoardFailedReducer", () => $ae0035cbc719904b$export$6c7ed8b976c677d8);

var $cW3pH = parcelRequire("cW3pH");
const $ae0035cbc719904b$export$6c7ed8b976c677d8 = (state = false, action)=>{
    if (action.type === (0, $cW3pH.IP_BOARD_404_VIEW)) return true;
    return state;
};

});

parcelRegister("4Hgc5", function(module, exports) {

$parcel$export(module.exports, "isPollingEnabledReducer", () => $37fc91adcc46c2be$export$d3425b8c9fd351d8);

var $eu61M = parcelRequire("eu61M");
const $37fc91adcc46c2be$export$d3425b8c9fd351d8 = (state = true, action)=>{
    if (action.type === (0, $eu61M.DRAG_START)) return false;
    if (action.type === (0, $eu61M.DRAG_END)) return true;
    return state;
};

});


parcelRegister("98a9H", function(module, exports) {

$parcel$export(module.exports, "default", () => $85fdeaa32d3a0d6a$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $5SWy0 = parcelRequire("5SWy0");

var $9scgE = parcelRequire("9scgE");

var $ciATa = parcelRequire("ciATa");

var $694Tc = parcelRequire("694Tc");

var $1Kv4W = parcelRequire("1Kv4W");

var $2eHlb = parcelRequire("2eHlb");

var $fMV8U = parcelRequire("fMV8U");

var $aqN9l = parcelRequire("aqN9l");
var $85fdeaa32d3a0d6a$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    selected: (0, $fMV8U.cardSelectionReducer),
    transactions: (0, $aqN9l.cardTransactionsReducer),
    drag: (0, $ciATa.cardDragReducer),
    focused: (0, $1Kv4W.default),
    cardWithIcc: (0, $9scgE.cardWithIccReducer),
    filteredCards: (0, $694Tc.filteredCardsReducer),
    autoScroll: (0, $5SWy0.default),
    inlineEditing: (0, $2eHlb.cardInlineEditingReducer)
});

});
parcelRegister("5SWy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d87785e631a6181$export$2e2bcd8739ae039);

var $d1i1b = parcelRequire("d1i1b");
const $1d87785e631a6181$var$initialAutoScrollState = {
    issueId: null,
    unscheduledColumnSwimlaneId: null,
    isImmediate: false
};
const $1d87785e631a6181$var$cardAutoScrollReducer = (state = $1d87785e631a6181$var$initialAutoScrollState, action)=>{
    if (action.type === (0, $d1i1b.CARD_AUTO_SCROLL)) return {
        ...state,
        issueId: action.payload.issueId
    };
    if (action.type === (0, $d1i1b.CARD_AUTO_SCROLL_UNSCHEDULED_COLUMN_ICC)) return {
        ...state,
        unscheduledColumnSwimlaneId: action.payload.swimlaneId,
        isImmediate: action.payload.isImmediate ?? false
    };
    return state;
};
var $1d87785e631a6181$export$2e2bcd8739ae039 = $1d87785e631a6181$var$cardAutoScrollReducer;

});

parcelRegister("9scgE", function(module, exports) {

$parcel$export(module.exports, "cardWithIccReducer", () => $68603d7d461b5d3d$export$22c3cac0160e001a);

var $2f454 = parcelRequire("2f454");

var $kXqRJ = parcelRequire("kXqRJ");
const $68603d7d461b5d3d$export$d4c72bab9d6cc13a = {
    mainActiveIssue: null,
    cardIdWithAboveIccOpen: null,
    columnIdToKeepIccOpen: null,
    lastColumnIdOpen: null,
    // used in program board unscheduled column
    swimlaneIdToKeepIccOpen: null
};
const $68603d7d461b5d3d$export$22c3cac0160e001a = (state, action)=>{
    switch(action.type){
        case 0, $2f454.SET_ACTIVE_ISSUE_WITH_ICC:
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                mainActiveIssue: action.payload.issueId
            };
        case 0, $2f454.SET_ISSUE_ID_WITH_ABOVE_ICC_OPEN:
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                cardIdWithAboveIccOpen: action.payload.issueId,
                columnIdToKeepIccOpen: action.payload.columnId,
                lastColumnIdOpen: action.payload.columnId || state?.lastColumnIdOpen || null
            };
        case 0, $2f454.CLEAR_SPECIFIED_ISSUE_ID_WITH_ABOVE_ICC_OPEN:
            {
                const issueIdMatches = !state?.cardIdWithAboveIccOpen && !action.payload.issueId || state?.cardIdWithAboveIccOpen === action.payload.issueId;
                const columnIdMatches = !state?.columnIdToKeepIccOpen && !action.payload.columnId || state?.columnIdToKeepIccOpen === action.payload.columnId;
                if (columnIdMatches && issueIdMatches) return {
                    ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                    cardIdWithAboveIccOpen: null,
                    columnIdToKeepIccOpen: null,
                    lastColumnIdOpen: null
                };
                return state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a;
            }
        case 0, $kXqRJ.ISSUE_DELETE_SUCCESS:
            // Reset the lastColumnIdOpen on deletion so if the board is empty again, the ICC will pop open
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                lastColumnIdOpen: null
            };
        case 0, $2f454.OPEN_ICC_IN_UNSCHEDULED_COLUMN:
            // Used in program board unscheduled column to open ICC in column footer
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                swimlaneIdToKeepIccOpen: action.payload.swimlaneId
            };
        case 0, $2f454.CLOSE_ICC_IN_UNSCHEDULED_COLUMN:
            // Close ICC in program board unscheduled column
            return {
                ...state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a,
                swimlaneIdToKeepIccOpen: null
            };
        default:
            {
                // @ts-expect-error - TS2322: Type 'ShowErrorFlagAction | SetPersonAction | AddToSprintRequestAction | AddToSprintSuccessAction | ... 255 more ... | UnsupportedAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state || $68603d7d461b5d3d$export$d4c72bab9d6cc13a;
            }
    }
};

});

parcelRegister("ciATa", function(module, exports) {

$parcel$export(module.exports, "cardDragReducer", () => $9ab2999199893664$export$bfd76de3490d0a87);

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $6oUms = parcelRequire("6oUms");

var $eu61M = parcelRequire("eu61M");

var $2f454 = parcelRequire("2f454");
const $9ab2999199893664$export$97c487b880ccd37d = {
    cardId: null,
    overTransition: undefined,
    snapMode: false,
    rippleIdsToShow: []
};
const $9ab2999199893664$var$makeCardUiState = (draggableId, mode, rippleIdsToShow)=>{
    const cardId = (0, $6oUms.getDescriptor)(draggableId).id;
    if (Number.isNaN(cardId)) return $9ab2999199893664$export$97c487b880ccd37d;
    return {
        cardId: Number(cardId),
        snapMode: mode === 'SNAP',
        hoverIntended: false,
        rippleIdsToShow: rippleIdsToShow
    };
};
const $9ab2999199893664$export$bfd76de3490d0a87 = (state = $9ab2999199893664$export$97c487b880ccd37d, action)=>{
    if (action.type === (0, $eu61M.DRAG_START)) {
        if (action.payload) return $9ab2999199893664$var$makeCardUiState(action.payload.draggableId, action.payload.mode, state.rippleIdsToShow);
        return {
            ...$9ab2999199893664$export$97c487b880ccd37d,
            rippleIdsToShow: state.rippleIdsToShow
        };
    }
    if (action.type === (0, $2f454.CARD_DRAG_OVER_TRANSITION) && state.cardId) {
        const { toColumnId: toColumnId, transitionId: transitionId, hoverIntent: hoverIntent } = action.payload;
        const newTransitionState = transitionId ? {
            transitionId: transitionId,
            toColumnId: toColumnId,
            hoverIntent: hoverIntent
        } : null;
        const hoverState = {
            ...newTransitionState && {
                // HoverIntended is set to true if hover intent is true once during the drag event later to be used in analytics
                // hoverIntent && transitionId to exclude hover intents to TransitionTo area
                hoverIntended: state.hoverIntended || hoverIntent && !!transitionId
            }
        };
        return (0, $7uUwQ.freeze)({
            ...state,
            overTransition: newTransitionState,
            ...hoverState
        });
    }
    if (action.type === (0, $2f454.CARD_DRAG_SELECTED_TRANSITION)) {
        const { transitionId: transitionId, toColumnId: toColumnId, toSwimlaneId: toSwimlaneId } = action.payload;
        return (0, $7uUwQ.freeze)({
            ...state,
            selectedTransition: {
                transitionId: transitionId,
                toColumnId: toColumnId,
                toSwimlaneId: toSwimlaneId
            }
        });
    }
    if (action.type === (0, $2f454.CARD_SET_ISSUE_TRANSITIONS)) {
        const { columnTransitions: columnTransitions } = action.payload;
        const { overTransition: overTransition } = state;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(overTransition) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(overTransition.transitionId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(overTransition.toColumnId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnTransitions[overTransition.toColumnId])) return state;
        const selectedTransition = columnTransitions[overTransition.toColumnId].find((transition)=>transition.id === overTransition.transitionId);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(selectedTransition) || selectedTransition.isAvailable) return state;
        return (0, $7uUwQ.freeze)({
            ...state,
            selectedTransition: undefined,
            overTransition: null
        });
    }
    if (action.type === (0, $eu61M.DRAG_END)) return (0, $7uUwQ.freeze)({
        ...state,
        ...$9ab2999199893664$export$97c487b880ccd37d
    });
    if (action.type === (0, $2f454.CARD_ADD_SHOW_RIPPLE)) {
        const { rippleIdsToShow: rippleIdsToShow } = action.payload;
        return (0, $7uUwQ.freeze)({
            ...state,
            rippleIdsToShow: [
                ...state.rippleIdsToShow,
                ...rippleIdsToShow
            ]
        });
    }
    if (action.type === (0, $2f454.CARD_REMOVE_SHOW_RIPPLE)) {
        const { issueId: issueId } = action.payload;
        return (0, $7uUwQ.freeze)({
            ...state,
            rippleIdsToShow: [
                ...state.rippleIdsToShow.filter((id)=>id !== issueId)
            ]
        });
    }
    return state;
};

});

parcelRegister("694Tc", function(module, exports) {

$parcel$export(module.exports, "filteredCardsReducer", () => $e6cd39f4878a15e1$export$a42af41a01ab9b7a);

var $6s1PB = parcelRequire("6s1PB");


var $cY26q = parcelRequire("cY26q");

var $dnW4F = parcelRequire("dnW4F");

var $cW3pH = parcelRequire("cW3pH");

var $ls4NM = parcelRequire("ls4NM");
const $e6cd39f4878a15e1$export$d4c72bab9d6cc13a = {
    isLoading: false,
    filteredCardsIds: null
};
const $e6cd39f4878a15e1$export$a42af41a01ab9b7a = (state = $e6cd39f4878a15e1$export$d4c72bab9d6cc13a, action)=>{
    if (action.type === (0, $dnW4F.SET_ALL_FILTERS) && (action.meta.filterType === (0, $dcff40112356dfc1$export$68d693c35a8d8866) || action.meta.filterType === (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f))) return {
        ...state,
        isLoading: true
    };
    if (action.type === (0, $dnW4F.CUSTOM_FILTER_FORCE_REFRESH_START)) return {
        ...state,
        isLoading: true
    };
    if (action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET) && action.payload.filteredCardIds && (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false)) return {
        isLoading: false,
        filteredCardsIds: new Set(action.payload.filteredCardIds)
    };
    if (action.type === (0, $cY26q.FILTERED_CARD_SUCCESS)) return {
        isLoading: false,
        filteredCardsIds: new Set(action.payload)
    };
    if (action.type === (0, $cY26q.FILTERED_CARD_FAILURE)) return {
        isLoading: false,
        filteredCardsIds: null
    };
    if (action.type === (0, $cY26q.FILTERED_CARD_CLEAR)) return $e6cd39f4878a15e1$export$d4c72bab9d6cc13a;
    if (action.type === (0, $cY26q.REFILTER_SUCCESS)) {
        const { excludedCardIds: excludedCardIds, filteredCardIds: filteredCardIds } = action.payload;
        const updatedFilteredCardIds = new Set([
            ...state.filteredCardsIds || [],
            ...filteredCardIds
        ]);
        excludedCardIds.forEach((cardId)=>updatedFilteredCardIds.delete(cardId)); // delete is faster than filtering on state
        return {
            isLoading: false,
            filteredCardsIds: updatedFilteredCardIds
        };
    }
    if (action.type === (0, $ls4NM.ISSUE_CREATE_SUCCESS) && action.meta.isFilterRefinementEnabled) {
        const { payload: { issues: issues } } = action;
        return {
            ...state,
            ...state.filteredCardsIds ? {
                filteredCardsIds: new Set([
                    ...state.filteredCardsIds || [],
                    ...issues.map((issue)=>issue.id.toString())
                ])
            } : {}
        };
    }
    return state;
};

});

parcelRegister("1Kv4W", function(module, exports) {

$parcel$export(module.exports, "default", () => $032efb4f27485b10$export$2e2bcd8739ae039);

var $2f454 = parcelRequire("2f454");
const $032efb4f27485b10$var$cardFocusReducer = (state = null, action)=>{
    if (action.type === (0, $2f454.CARD_FOCUS)) return action.payload.issueId;
    if (action.type === (0, $2f454.CARD_BLUR)) return null;
    return state;
};
var $032efb4f27485b10$export$2e2bcd8739ae039 = $032efb4f27485b10$var$cardFocusReducer;

});

parcelRegister("2eHlb", function(module, exports) {

$parcel$export(module.exports, "cardInlineEditingReducer", () => $7609277707c0efdf$export$b81c30b4d16a65d);

var $4R6GH = parcelRequire("4R6GH");

var $2f454 = parcelRequire("2f454");
const $7609277707c0efdf$export$d4c72bab9d6cc13a = {};
const $7609277707c0efdf$export$b81c30b4d16a65d = (state = $7609277707c0efdf$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $2f454.SET_INLINE_EDITING:
            // don't change state if the value is the same
            if (state[action.payload.issueId] && state[action.payload.issueId][action.payload.field] === action.payload.value && (0, $4R6GH.fg)('render_program_board_card_in_popup')) return state;
            return {
                ...state,
                [action.payload.issueId]: {
                    // Setting all fields to false except the one we are setting
                    assignee: false,
                    summary: false,
                    priority: false,
                    parentField: false,
                    status: false,
                    dependencies: false,
                    estimate: false,
                    contextMenu: false,
                    [action.payload.field]: action.payload.value
                }
            };
        default:
            return state;
    }
};

});

parcelRegister("fMV8U", function(module, exports) {

$parcel$export(module.exports, "cardSelectionReducer", () => $5d0402a1c51be99a$export$bef5bad89d1f8b41);

var $7uUwQ = parcelRequire("7uUwQ");

var $kGsr8 = parcelRequire("kGsr8");

var $2f454 = parcelRequire("2f454");

var $k50Aq = parcelRequire("k50Aq");
const $5d0402a1c51be99a$var$initialState = [];
const $5d0402a1c51be99a$export$bef5bad89d1f8b41 = (state = $5d0402a1c51be99a$var$initialState, action)=>{
    if (action.type === (0, $2f454.CARD_TOGGLE_SELECTION)) {
        const { issueId: issueId } = action.payload;
        const selectedCardIndex = state.indexOf(action.payload.issueId);
        return selectedCardIndex === -1 ? (0, $7uUwQ.push)(state, issueId) : (0, $7uUwQ.splice)(state, selectedCardIndex, 1);
    }
    if (action.type === (0, $2f454.CARD_MULTI_SELECT)) {
        const { issueIds: issueIds } = action.payload;
        return (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))(state.concat(issueIds));
    }
    if (action.type === (0, $2f454.CARD_SINGLE_SELECT)) {
        const { issueId: issueId } = action.payload;
        return [
            issueId
        ];
    }
    if (action.type === (0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST)) return $5d0402a1c51be99a$var$initialState;
    if (action.type === (0, $2f454.CARD_CANCEL_SELECTION)) return $5d0402a1c51be99a$var$initialState;
    return state;
};

});

parcelRegister("aqN9l", function(module, exports) {

$parcel$export(module.exports, "cardTransactionsReducer", () => $1c8787c4dbca4995$export$6639e0d78731564c);

var $2f454 = parcelRequire("2f454");

var $71oFY = parcelRequire("71oFY");
const $1c8787c4dbca4995$export$d4c72bab9d6cc13a = {};
const $1c8787c4dbca4995$export$619c15727cd4c9af = (state, issueIds, transactionId)=>{
    const newTransactions = {};
    issueIds.forEach((issueId)=>{
        newTransactions[issueId] = transactionId;
    });
    return {
        // @ts-expect-error - TS2698 - Spread types may only be created from object types.
        ...state.transactions,
        ...newTransactions
    };
};
const $1c8787c4dbca4995$export$6639e0d78731564c = (state = $1c8787c4dbca4995$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $71oFY.ISSUE_RANK_TRANSITION_UPDATE_OPTIMISTIC:
            return $1c8787c4dbca4995$export$619c15727cd4c9af(state, action.payload.issueIds.map((id)=>String(id)), action.meta.optimistic.id);
        case 0, $2f454.CARD_REFRESH_REQUEST:
            if (action.payload.skipTransactionUpdate) return state;
            return $1c8787c4dbca4995$export$619c15727cd4c9af(state, action.payload.issueIds.map((id)=>String(id)), action.payload.transactionId);
        default:
            return state;
    }
};

});


parcelRegister("4WnRS", function(module, exports) {

$parcel$export(module.exports, "default", () => $86db4ea08a83be24$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $9eeht = parcelRequire("9eeht");
const $86db4ea08a83be24$export$d4c72bab9d6cc13a = (0, $7uUwQ.freeze)({
    isOpen: false
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$86db4ea08a83be24$export$2e2bcd8739ae039 = (state = $86db4ea08a83be24$export$d4c72bab9d6cc13a, action)=>{
    switch(action.type){
        case 0, $9eeht.COLUMN_OPEN_LIMITS_MODAL:
            return (0, $7uUwQ.freeze)({
                isOpen: true,
                columnId: action.payload.columnId
            });
        case 0, $9eeht.COLUMN_SET_LIMITS_REQUEST:
        case 0, $9eeht.COLUMN_CLOSE_LIMITS_MODAL:
            return (0, $7uUwQ.freeze)({
                isOpen: false
            });
        default:
            {
                // @ts-expect-error - TS2322: Type 'ShowErrorFlagAction | SetPersonAction | AddToSprintRequestAction | AddToSprintSuccessAction | ... 254 more ... | UnsupportedAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});

parcelRegister("5xTT6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3801bc28497742dc$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $a8wAH = parcelRequire("a8wAH");

var $kr8Rv = parcelRequire("kr8Rv");
var $3801bc28497742dc$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    deleteModal: (0, $a8wAH.columnDeleteModalReducer),
    issuesNotOnBoard: (0, $kr8Rv.issuesNotOnBoardReducer)
});

});
parcelRegister("a8wAH", function(module, exports) {

$parcel$export(module.exports, "columnDeleteModalReducer", () => $1a3bdda22ea95f01$export$b62fd9e48bba962a);

var $63F6h = parcelRequire("63F6h");
const $1a3bdda22ea95f01$export$b62fd9e48bba962a = (state = {
    isOpen: false
}, action)=>{
    if (action.type === (0, $63F6h.COLUMN_DELETE)) {
        const { columnId: columnId } = action.payload;
        return {
            isOpen: true,
            columnId: columnId
        };
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_MODAL_CLOSE)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("kr8Rv", function(module, exports) {

$parcel$export(module.exports, "issuesNotOnBoardReducer", () => $84807d2e57a3c923$export$2667ef7905a994f5);

var $e1q2I = parcelRequire("e1q2I");
const $84807d2e57a3c923$export$2667ef7905a994f5 = (state = {}, action)=>{
    if (action.type === (0, $e1q2I.SET_ISSUES_NOT_ON_BOARD)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return payload;
    }
    return state;
};

});


parcelRegister("96rsq", function(module, exports) {

$parcel$export(module.exports, "columnsUIReducer", () => $4c7e4e4d6fa086c1$export$bc16d83eead4beb6);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

var $glGhK = parcelRequire("glGhK");

var $63F6h = parcelRequire("63F6h");

var $55fEr = parcelRequire("55fEr");

var $63VRQ = parcelRequire("63VRQ");
const $4c7e4e4d6fa086c1$export$bc16d83eead4beb6 = (state = (0, $7uUwQ.freeze)({}), action)=>{
    if (action.type === (0, $63VRQ.COLUMN_RENAME_REQUEST)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(columnId),
            'isUpdating'
        ], true);
    }
    if (action.type === (0, $63VRQ.COLUMN_RENAME_SUCCESS) || action.type === (0, $63VRQ.COLUMN_RENAME_FAILURE)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(columnId),
            'isUpdating'
        ], false);
    }
    if (action.type === (0, $55fEr.COLUMN_RANK_REQUEST)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(columnId),
            'isUpdating'
        ], true);
    }
    if (action.type === (0, $55fEr.COLUMN_RANK_SUCCESS) || action.type === (0, $55fEr.COLUMN_RANK_FAILURE)) {
        const { columnId: columnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(columnId),
            'isUpdating'
        ], false);
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_REQUEST)) {
        const { temporaryColumnId: temporaryColumnId } = action.payload;
        return (0, $7uUwQ.setIn)(state, [
            String(temporaryColumnId),
            'isUpdating'
        ], true);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_REQUEST)) {
        const { closestColumn: closestColumn } = action.payload;
        if (closestColumn) return (0, $7uUwQ.setIn)(state, [
            String(closestColumn.id),
            'isUpdating'
        ], true);
    }
    if (action.type === (0, $63F6h.COLUMN_DELETE_SUCCESS)) {
        const { closestColumn: closestColumn } = action.payload;
        if (closestColumn) return (0, $7uUwQ.unset)(state, String(closestColumn.id));
    }
    if (action.type === (0, $glGhK.COLUMN_CREATE_SUCCESS) || action.type === (0, $glGhK.COLUMN_CREATE_FAILURE)) {
        const { temporaryColumnId: temporaryColumnId } = action.payload;
        const columnStates = (0, $7uUwQ.unset)(state[String(temporaryColumnId)], 'isUpdating');
        if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(columnStates)) return (0, $7uUwQ.unset)(state, String(temporaryColumnId));
        return (0, $7uUwQ.setIn)(state, [
            String(temporaryColumnId)
        ], columnStates);
    }
    return state;
};

});

parcelRegister("eRAwv", function(module, exports) {

$parcel$export(module.exports, "flagsReducer", () => $91d7a4795f84532d$export$64fc5b4c35b25733);

var $7uUwQ = parcelRequire("7uUwQ");

var $bkCF5 = parcelRequire("bkCF5");
const $91d7a4795f84532d$export$623276a11554670b = (state, flag)=>!!state.find((stateFlag)=>stateFlag.id === flag.id);
const $91d7a4795f84532d$export$64fc5b4c35b25733 = (state = [], action)=>{
    if (action.type === (0, $bkCF5.FLAG_DISMISSED)) {
        if (action.payload) {
            const { id: id } = action.payload;
            return (0, $7uUwQ.filter)((flag)=>flag.id !== id, state);
        }
    }
    // Add a flag to state if it is passed in the action's meta
    if (action.meta && action.meta.flag) {
        if (!$91d7a4795f84532d$export$623276a11554670b(state, action.meta.flag)) return state.concat(action.meta.flag);
    }
    return state;
};

});

parcelRegister("2hNE6", function(module, exports) {

$parcel$export(module.exports, "default", () => $34af0c29c51d6f18$export$2e2bcd8739ae039);

var $blI7M = parcelRequire("blI7M");
const $34af0c29c51d6f18$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$34af0c29c51d6f18$export$2e2bcd8739ae039 = (state = $34af0c29c51d6f18$var$defaultState, action)=>{
    if (action.type === (0, $blI7M.OPEN_GLOBAL_ISSUE_CREATE)) return {
        isOpen: true,
        inputs: action.payload
    };
    if (action.type === (0, $blI7M.CLOSE_GLOBAL_ISSUE_CREATE)) return {
        isOpen: false
    };
    return state;
};

});
parcelRegister("blI7M", function(module, exports) {

$parcel$export(module.exports, "OPEN_GLOBAL_ISSUE_CREATE", () => $38473b0b2c8870f1$export$63ec531cc5ba8d9d);
$parcel$export(module.exports, "openGlobalIssueCreate", () => $38473b0b2c8870f1$export$85199c96cd869e6b);
$parcel$export(module.exports, "CLOSE_GLOBAL_ISSUE_CREATE", () => $38473b0b2c8870f1$export$3e9c51b746b35e9b);
$parcel$export(module.exports, "closeGlobalIssueCreate", () => $38473b0b2c8870f1$export$9a6ec6b262e11f76);
const $38473b0b2c8870f1$export$63ec531cc5ba8d9d = 'state.actions.global-issue-create.OPEN_GLOBAL_ISSUE_CREATE';
const $38473b0b2c8870f1$export$85199c96cd869e6b = (inputs)=>({
        type: $38473b0b2c8870f1$export$63ec531cc5ba8d9d,
        payload: inputs
    });
const $38473b0b2c8870f1$export$3e9c51b746b35e9b = 'state.actions.global-issue-create.CLOSE_GLOBAL_ISSUE_CREATE';
const $38473b0b2c8870f1$export$9a6ec6b262e11f76 = ()=>({
        type: $38473b0b2c8870f1$export$3e9c51b746b35e9b
    });

});


parcelRegister("jRjcj", function(module, exports) {

$parcel$export(module.exports, "default", () => $216d18064c0e67b5$export$2e2bcd8739ae039);

var $iaYF9 = parcelRequire("iaYF9");
const $216d18064c0e67b5$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$216d18064c0e67b5$export$2e2bcd8739ae039 = (state = $216d18064c0e67b5$var$defaultState, action)=>{
    if (action.type === (0, $iaYF9.SHOW_ISSUE_ADD_LABEL_MODAL)) return {
        isOpen: true,
        issueIds: action.payload
    };
    if (action.type === (0, $iaYF9.HIDE_ISSUE_ADD_LABEL_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("kVppN", function(module, exports) {

$parcel$export(module.exports, "issueDeleteModalReducer", () => $3f1f7edb9109e2d5$export$f375b7c512c770b9);

var $2f454 = parcelRequire("2f454");

var $5s6yC = parcelRequire("5s6yC");

var $kXqRJ = parcelRequire("kXqRJ");
const $3f1f7edb9109e2d5$export$f375b7c512c770b9 = (state = {
    isOpen: false
}, action)=>{
    if (action.type === (0, $5s6yC.ISSUE_DELETE_MODAL_OPEN)) {
        const { issueId: issueId } = action.payload;
        return {
            isOpen: true,
            issueId: issueId
        };
    }
    if (action.type === (0, $5s6yC.ISSUE_DELETE_MODAL_CLOSE)) return {
        isOpen: false
    };
    if (action.type === (0, $kXqRJ.ISSUE_DELETE_REQUEST) || action.type === (0, $2f454.CARD_DELETE)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("i1NTq", function(module, exports) {

$parcel$export(module.exports, "issueFlagWithCommentModalReducer", () => $4cf26fba19e758c6$export$ee446224d0f5ef56);

var $7W4VK = parcelRequire("7W4VK");
const $4cf26fba19e758c6$var$defaultState = {
    isOpen: false
};
const $4cf26fba19e758c6$export$ee446224d0f5ef56 = (state = $4cf26fba19e758c6$var$defaultState, action)=>{
    if (action.type === (0, $7W4VK.SHOW_ISSUE_FLAG_WITH_COMMENT_MODAL)) return {
        isOpen: true,
        issueId: action.payload.issueId
    };
    if (action.type === (0, $7W4VK.HIDE_ISSUE_FLAG_WITH_COMMENT_MODAL)) return {
        isOpen: false
    };
    return state;
};

});
parcelRegister("7W4VK", function(module, exports) {

$parcel$export(module.exports, "SHOW_ISSUE_FLAG_WITH_COMMENT_MODAL", () => $7215d345484740d8$export$808b6606cd4c70af);
$parcel$export(module.exports, "showIssueFlagWithCommentModal", () => $7215d345484740d8$export$e4093de7ee2f0f39);
$parcel$export(module.exports, "HIDE_ISSUE_FLAG_WITH_COMMENT_MODAL", () => $7215d345484740d8$export$8f697207934c85c6);
$parcel$export(module.exports, "hideIssueFlagWithCommentModal", () => $7215d345484740d8$export$5c957528a61ef5de);
const $7215d345484740d8$export$808b6606cd4c70af = 'state.actions.issue.flag-with-comment-modal.SHOW_ISSUE_FLAG_WITH_COMMENT_MODAL';
const $7215d345484740d8$export$e4093de7ee2f0f39 = (issueId)=>({
        type: $7215d345484740d8$export$808b6606cd4c70af,
        payload: {
            issueId: issueId
        }
    });
const $7215d345484740d8$export$8f697207934c85c6 = 'state.actions.issue.flag-with-comment-modal.HIDE_ISSUE_FLAG_WITH_COMMENT_MODAL';
const $7215d345484740d8$export$5c957528a61ef5de = ()=>({
        type: $7215d345484740d8$export$8f697207934c85c6
    });

});


parcelRegister("ge2Re", function(module, exports) {

$parcel$export(module.exports, "issueModalReducer", () => $d562b13d393fa419$export$7353a8150fe3dca8);

var $7uUwQ = parcelRequire("7uUwQ");

var $7tJ5d = parcelRequire("7tJ5d");

var $dW1HX = parcelRequire("dW1HX");
const $d562b13d393fa419$var$initialState = (0, $7uUwQ.freeze)({
    selectedIssueKey: null,
    timestamp: 0,
    externalAction: undefined
});
const $d562b13d393fa419$export$7353a8150fe3dca8 = (state = $d562b13d393fa419$var$initialState, action)=>{
    if (action.type === (0, $dW1HX.OPEN_ISSUE_MODAL)) {
        if (state.selectedIssueKey !== action.payload.issueKey) return {
            ...state,
            selectedIssueKey: action.payload.issueKey,
            externalAction: action.payload.externalAction
        };
        return state;
    }
    if (action.type === (0, $7tJ5d.UPDATE_DETAIL_VIEW)) return {
        ...state,
        timestamp: Date.now()
    };
    if (action.type === (0, $dW1HX.CLOSE_ISSUE_MODAL)) return $d562b13d393fa419$var$initialState;
    if (action.type === (0, $dW1HX.RESET_EXTERNAL_ACTION)) return {
        ...state,
        externalAction: undefined
    };
    return state;
};

});

parcelRegister("iGgUa", function(module, exports) {

$parcel$export(module.exports, "default", () => $3442316de377b4a9$export$2e2bcd8739ae039);

var $1fh1A = parcelRequire("1fh1A");
const $3442316de377b4a9$var$defaultState = {
    isOpen: false
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$3442316de377b4a9$export$2e2bcd8739ae039 = (state = $3442316de377b4a9$var$defaultState, action)=>{
    if (action.type === (0, $1fh1A.OPEN_ISSUE_TRANSITION_MODAL)) return {
        isOpen: true,
        ...action.payload
    };
    if (action.type === (0, $1fh1A.CLOSE_ISSUE_TRANSITION_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("gXQl3", function(module, exports) {

$parcel$export(module.exports, "default", () => $fceda3f618083c4a$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");


var $2ON1s = parcelRequire("2ON1s");
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $fceda3f618083c4a$var$initialState = {};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$fceda3f618083c4a$export$2e2bcd8739ae039 = (state = $fceda3f618083c4a$var$initialState, action)=>{
    switch(action.type){
        case 0, $2ON1s.TOGGLE_PANEL:
            {
                const { payload: { panel: panel } } = action;
                // For other panels that exist in future, we can close them here if needed
                return state[panel] === true ? (0, $7uUwQ.unset)(state, panel) : (0, $7uUwQ.set)(state, panel, true);
            }
        case 0, $2ON1s.OPEN_INSIGHTS_PANEL:
            return (0, $7uUwQ.set)(state, (0, $8cd646738f5ee7ac$export$29d7f2210b16d662), true);
        case 0, $2ON1s.CLOSE_INSIGHTS_PANEL:
            return (0, $7uUwQ.unset)(state, (0, $8cd646738f5ee7ac$export$29d7f2210b16d662));
        case 0, $2ON1s.CLOSE_VIEW_SETTINGS_PANEL:
            return (0, $7uUwQ.unset)(state, (0, $8cd646738f5ee7ac$export$ba1da943283b9900));
        default:
            {
                // @ts-expect-error - TS2322: Type 'ShowErrorFlagAction | SetPersonAction | AddToSprintRequestAction | AddToSprintSuccessAction | ... 253 more ... | UnsupportedAction' is not assignable to type 'never'.
                const _exhaustiveCheck = action;
                return state;
            }
    }
};

});
const $8cd646738f5ee7ac$export$29d7f2210b16d662 = 'INSIGHTS_PANEL';
const $8cd646738f5ee7ac$export$ba1da943283b9900 = 'VIEW_SETTINGS_PANEL';


parcelRegister("d9fmE", function(module, exports) {

$parcel$export(module.exports, "planIssueModalReducer", () => $3eccc506dbb1126a$export$56368bd004520bf4);

var $7uUwQ = parcelRequire("7uUwQ");

var $dW1HX = parcelRequire("dW1HX");
const $3eccc506dbb1126a$var$initialState = (0, $7uUwQ.freeze)({
    selectedIssueId: null
});
const $3eccc506dbb1126a$export$56368bd004520bf4 = (state = $3eccc506dbb1126a$var$initialState, action)=>{
    if (action.type === (0, $dW1HX.OPEN_PLAN_ISSUE_MODAL)) {
        if (state.selectedIssueId !== action.payload.issueId) return {
            ...state,
            selectedIssueId: action.payload.issueId
        };
        return state;
    }
    if (action.type === (0, $dW1HX.CLOSE_PLAN_ISSUE_MODAL)) return $3eccc506dbb1126a$var$initialState;
    return state;
};

});

parcelRegister("fJuCu", function(module, exports) {

$parcel$export(module.exports, "sprintAssociationModalReducer", () => $6889dbed4cdbc28d$export$2ef4e466a189fe0d);

var $jbAX5 = parcelRequire("jbAX5");
const $6889dbed4cdbc28d$var$defaultState = {
    isOpen: false
};
const $6889dbed4cdbc28d$export$2ef4e466a189fe0d = (state = $6889dbed4cdbc28d$var$defaultState, action)=>{
    if (action.type === (0, $jbAX5.OPEN_TEAM_SPRINT_ASSOCIATION_MODEL)) return {
        isOpen: true,
        ...action.payload
    };
    if (action.type === (0, $jbAX5.CLOSE_TEAM_SPRINT_ASSOCIATION_MODEL)) return {
        isOpen: false
    };
    return state;
};

});
parcelRegister("jbAX5", function(module, exports) {

$parcel$export(module.exports, "OPEN_TEAM_SPRINT_ASSOCIATION_MODEL", () => $e94921d318e3de92$export$a294b2632c80a061);
$parcel$export(module.exports, "openTeamAssociationModal", () => $e94921d318e3de92$export$f76f2b553b612cfa);
$parcel$export(module.exports, "CLOSE_TEAM_SPRINT_ASSOCIATION_MODEL", () => $e94921d318e3de92$export$9477d66d294f5655);
$parcel$export(module.exports, "closeTeamAssociationModal", () => $e94921d318e3de92$export$c00be92b9b94c0ab);
const $e94921d318e3de92$export$a294b2632c80a061 = 'state.actions.sprint.sprint-association-modal.OPEN_TEAM_SPRINT_ASSOCIATION_MODEL';
const $e94921d318e3de92$export$f76f2b553b612cfa = (teamId)=>({
        type: $e94921d318e3de92$export$a294b2632c80a061,
        payload: {
            teamId: teamId
        }
    });
const $e94921d318e3de92$export$9477d66d294f5655 = 'state.actions.sprint.sprint-association-modal.CLOSE_TEAM_SPRINT_ASSOCIATION_MODEL';
const $e94921d318e3de92$export$c00be92b9b94c0ab = ()=>({
        type: $e94921d318e3de92$export$9477d66d294f5655
    });

});


parcelRegister("6dO4m", function(module, exports) {

$parcel$export(module.exports, "sprintsReducer", () => $3b0a41db2272b0ce$export$4b86860ac786fd91);


var $4R6GH = parcelRequire("4R6GH");

var $cY26q = parcelRequire("cY26q");

var $dnW4F = parcelRequire("dnW4F");

var $Nogwi = parcelRequire("Nogwi");

var $aXi41 = parcelRequire("aXi41");
const $3b0a41db2272b0ce$export$4b86860ac786fd91 = (state = (0, $aXi41.initialSprintsState), action)=>{
    if (action.type === (0, $Nogwi.SELECT_SPRINTS)) {
        const { sprintFilterIds: sprintFilterIds } = action.payload;
        return {
            selected: sprintFilterIds
        };
    }
    if (action.type === (0, $Nogwi.CLEAR_SELECTED_SPRINTS) || action.type === (0, $cY26q.FILTERED_CARD_CLEAR)) return {
        selected: []
    };
    if (action.type === (0, $dnW4F.FILTERS_SET) && action.payload.filterType === 'SPRINT') {
        const { values: values } = action.payload;
        return {
            selected: Array.isArray(values) ? values : [
                values
            ]
        };
    }
    if (action.type === (0, $dnW4F.SET_ALL_FILTERS) || action.type === (0, $dnW4F.FILTERS_JQL_SET) && (0, $4R6GH.fg)('tmp_filter_refinement_sprint_goals')) return {
        selected: action.payload.filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0] || []
    };
    return state;
};

});
parcelRegister("Nogwi", function(module, exports) {

$parcel$export(module.exports, "SELECT_SPRINTS", () => $827df433191f4525$export$e465b141afd3c3ea);
$parcel$export(module.exports, "selectSprint", () => $827df433191f4525$export$e075700f212b976d);
$parcel$export(module.exports, "CLEAR_SELECTED_SPRINTS", () => $827df433191f4525$export$c15dc8c4e6333b71);
const $827df433191f4525$export$e465b141afd3c3ea = 'state.actions.sprints.select.SELECT_SPRINTS';
const $827df433191f4525$export$e075700f212b976d = ({ sprintFilterIds: sprintFilterIds })=>({
        type: $827df433191f4525$export$e465b141afd3c3ea,
        payload: {
            sprintFilterIds: sprintFilterIds
        }
    });
const $827df433191f4525$export$c15dc8c4e6333b71 = 'state.actions.sprints.select.CLEAR_SELECTED_SPRINTS';

});


parcelRegister("8V3MB", function(module, exports) {

$parcel$export(module.exports, "default", () => $18b85d16dd61ecdd$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $8Cue0 = parcelRequire("8Cue0");

var $jFOhg = parcelRequire("jFOhg");

var $achtv = parcelRequire("achtv");
var $18b85d16dd61ecdd$export$2e2bcd8739ae039 = (0, $3f2cs.combineReducers)({
    collapsed: (0, $jFOhg.swimlanesCollapsedReducer),
    mode: (0, $achtv.swimlaneModeReducer),
    adminConfiguredMode: (0, $8Cue0.swimlaneAdminConfiguredModeReducer)
});

});
parcelRegister("8Cue0", function(module, exports) {

$parcel$export(module.exports, "swimlaneAdminConfiguredModeReducer", () => $2dd75fe08e942d9e$export$517e5b797afe6549);

var $iuuJH = parcelRequire("iuuJH");

var $cW3pH = parcelRequire("cW3pH");
const $2dd75fe08e942d9e$export$517e5b797afe6549 = (state = (0, $iuuJH.NO_SWIMLANE).id, action)=>{
    if (action.type === (0, $cW3pH.WORK_DATA_SET)) {
        const { payload: payload } = action;
        return payload.adminConfiguredSwimlaneModeId || state;
    }
    return state;
};

});

parcelRegister("jFOhg", function(module, exports) {

$parcel$export(module.exports, "swimlanesCollapsedReducer", () => $9001dca2ff0fb738$export$46d9063a28b5d3fc);

var $7uUwQ = parcelRequire("7uUwQ");

var $k50Aq = parcelRequire("k50Aq");
const $9001dca2ff0fb738$export$46d9063a28b5d3fc = (state = [], action)=>{
    if (action.type === (0, $k50Aq.SWIMLANE_TOGGLE)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        const index = state.indexOf(payload);
        if (index === -1) return (0, $7uUwQ.push)(state, payload);
        return (0, $7uUwQ.splice)(state, index, 1);
    }
    if (action.type === (0, $k50Aq.SWIMLANES_TOGGLE)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        if (state.length === payload.length) return [];
        return payload;
    }
    if (action.type === (0, $k50Aq.SWIMLANES_EXPAND)) return [];
    if (action.type === (0, $k50Aq.SWIMLANES_COLLAPSE)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return payload;
    }
    return state;
};

});

parcelRegister("achtv", function(module, exports) {

$parcel$export(module.exports, "swimlaneModeReducer", () => $c1ec1b5315c94439$export$be1415bc49b4143e);

var $iuuJH = parcelRequire("iuuJH");

var $k50Aq = parcelRequire("k50Aq");

var $cW3pH = parcelRequire("cW3pH");
const $c1ec1b5315c94439$export$be1415bc49b4143e = (state = (0, $iuuJH.NO_SWIMLANE).id, action)=>{
    if (action.type === (0, $k50Aq.SWIMLANE_MODE_CHANGE_REQUEST)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return payload;
    }
    if (action.type === (0, $cW3pH.WORK_DATA_SET) || action.type === (0, $cW3pH.WORK_DATA_CRITICAL_SET)) {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const { payload: payload } = action;
        return payload.swimlaneModeId;
    }
    return state;
};

});


parcelRegister("3Nx75", function(module, exports) {

$parcel$export(module.exports, "updateIssueParentModalReducer", () => $f445cfcba4d7248d$export$d3e9746491c4a22f);

var $cdcje = parcelRequire("cdcje");
const $f445cfcba4d7248d$export$d3e9746491c4a22f = (state = {
    isOpen: false
}, action)=>{
    if (action.type === (0, $cdcje.SHOW_UPDATE_ISSUE_PARENT_MODAL)) {
        const { issueParentId: issueParentId, transitions: transitions } = action.payload;
        return {
            isOpen: true,
            issueParentId: issueParentId,
            transitions: transitions
        };
    }
    if (action.type === (0, $cdcje.HIDE_UPDATE_ISSUE_PARENT_MODAL)) return {
        isOpen: false
    };
    return state;
};

});

parcelRegister("7N9ZT", function(module, exports) {

$parcel$export(module.exports, "workFiltersReducer", () => $fa3be4c7e8b97005$export$4315784b09c1b241);

var $7uUwQ = parcelRequire("7uUwQ");

var $dnW4F = parcelRequire("dnW4F");
const $fa3be4c7e8b97005$var$initialState = {
    values: {}
};
const $fa3be4c7e8b97005$export$4315784b09c1b241 = (state = $fa3be4c7e8b97005$var$initialState, action)=>{
    if (action.type === (0, $dnW4F.FILTERS_JQL_SET)) return (0, $7uUwQ.setIn)(state, [
        'values'
    ], {
        ...state.values,
        ...action.payload.filters
    });
    if (action.type === (0, $dnW4F.FILTERS_SET)) return (0, $7uUwQ.setIn)(state, [
        'values',
        action.payload.filterType
    ], action.payload.values);
    if (action.type === (0, $dnW4F.SET_ALL_FILTERS)) return (0, $7uUwQ.setIn)(state, [
        'values'
    ], action.payload.filters);
    return state;
};

});




parcelRegister("b5JVP", function(module, exports) {

$parcel$export(module.exports, "AllFieldsSync", () => $2f7e3abd37eb7923$export$1d61766e46edfc2e);

var $5uXOq = parcelRequire("5uXOq");


var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $vAfHD = parcelRequire("vAfHD");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $gFlSp = parcelRequire("gFlSp");
const $2f7e3abd37eb7923$var$CMP_SYNC_SETTINGS = {
    syncAssignee: true,
    syncEstimate: false,
    syncParent: false,
    syncSummary: false
};
const $2f7e3abd37eb7923$export$1d61766e46edfc2e = ()=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const canEditCards = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$5cd553a40d575c6c] === true;
    const allIssueIds = (0, $67sX6.useBoardSelector)((state)=>(0, $vAfHD.boardOrderedIssueIdsSelector)(state));
    const activeCardId = (0, $67sX6.useBoardSelector)((0, $5mTgl.getActiveIssueWithIcc));
    const richCards = (0, $5uXOq.useRef)(new Set());
    if (!canEditCards) return null;
    if (activeCardId != null) richCards.current?.add(activeCardId);
    // to exclude deleted rich cards
    const ids = allIssueIds.filter((id)=>richCards.current.has(id));
    /**
	 * For TMP all fields will be synced by default
	 * Note - CMP will abort above when jsw.uif.board.cmp-inline-editable-assignee is disabled
	 * */ const syncSettings = isCMPBoard ? $2f7e3abd37eb7923$var$CMP_SYNC_SETTINGS : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, ids.map((id)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gFlSp.FieldSync), {
            key: id,
            issueId: id,
            ...syncSettings
        })));
};

});
parcelRegister("63LqY", function(module, exports) {

$parcel$export(module.exports, "useIsCMPBoard", () => $36d4379301ea45f0$export$73b6b1815a310030);
$parcel$export(module.exports, "useIsJSMBoard", () => $36d4379301ea45f0$export$caf439d171aab0ca);
$parcel$export(module.exports, "useCanEditBoard", () => $36d4379301ea45f0$export$310084e0477bf957);
$parcel$export(module.exports, "useIsJSWBoard", () => $36d4379301ea45f0$export$94abecd95414f165);
$parcel$export(module.exports, "useIsIncrementPlanningBoard", () => $36d4379301ea45f0$export$27d7b2052e1750a7);
$parcel$export(module.exports, "useCapability", () => $36d4379301ea45f0$export$12f4a5dc7ca76777);
$parcel$export(module.exports, "useIsFreeJswProject", () => $36d4379301ea45f0$export$d532405742ba81bf);
/*!
 * This module contains a "CAPABILITIES" API and model for JSW UIF board.
 *
 * Any feature that is "gated" and only available on certain cases should be
 * added here.
 */ 
var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $2xFXk = parcelRequire("2xFXk");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");
function $36d4379301ea45f0$export$73b6b1815a310030() {
    return (0, $67sX6.useBoardSelector)((state)=>state.configuration.isCMPBoard);
}
function $36d4379301ea45f0$export$dfcc354e2b20d8f4() {
    return (0, $67sX6.useBoardSelector)((state)=>state.configuration.isUserBoard);
}
function $36d4379301ea45f0$export$caf439d171aab0ca() {
    return (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector)) === (0, $2vSU6.SERVICE_DESK_PROJECT);
}
function $36d4379301ea45f0$export$310084e0477bf957() {
    return (0, $67sX6.useBoardSelector)((0, $67Z81.getCanEditBoard));
}
function $36d4379301ea45f0$export$94abecd95414f165() {
    return (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector)) === (0, $2vSU6.SOFTWARE_PROJECT);
}
function $36d4379301ea45f0$export$27d7b2052e1750a7() {
    return (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
}
function $36d4379301ea45f0$export$12f4a5dc7ca76777(key) {
    const isCMPBoard = $36d4379301ea45f0$export$73b6b1815a310030();
    const isUserBoard = $36d4379301ea45f0$export$dfcc354e2b20d8f4();
    const isIncrementPlanningBoard = $36d4379301ea45f0$export$27d7b2052e1750a7();
    const allFeatures = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getEntities)(state).board.config.allFeatures);
    const projectType = (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector));
    return (0, $2xFXk.hasCapability)(key, isCMPBoard, isIncrementPlanningBoard, allFeatures, projectType, isUserBoard);
}
function $36d4379301ea45f0$export$d532405742ba81bf() {
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const { appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const isInsideFreeJswProject = appEditions.software === (0, $ldyPw.FREE_EDITION) && projectContext?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    return isInsideFreeJswProject;
}
const $36d4379301ea45f0$var$_getJSMJSWProductKey = (subProduct, explicitlyLicensedProducts)=>{
    if (subProduct === 'software') return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
    if (subProduct === 'serviceDesk') return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
    // If subproduct is null, we are probably on a JSM, Jira Core or product-agnostic page
    // Just to be safe, we will allow the banner to render if there is only one product on the instance
    if (explicitlyLicensedProducts.length === 1) {
        if (explicitlyLicensedProducts[0] === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)) return 0, $c06e1abca7c13910$export$1346c9aa3cbb477d;
        if (explicitlyLicensedProducts[0] === (0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61)) return 0, $c06e1abca7c13910$export$c8c1c8c3f8ddba61;
    }
    return null;
};

});
const $c06e1abca7c13910$export$c8c1c8c3f8ddba61 = 'jira-servicedesk';
const $c06e1abca7c13910$export$e9c56aa3b027d98f = 'jira-customer-service';
const $c06e1abca7c13910$export$1346c9aa3cbb477d = 'jira-software';
const $c06e1abca7c13910$export$202f50ee62667e32 = 'jira-product-discovery';
const $c06e1abca7c13910$export$db515c8cec1e6f79 = 'jira-core';
const $c06e1abca7c13910$export$c811f21c9ad05dc2 = 'confluence';
const $c06e1abca7c13910$export$961148c98d198270 = 'opsgenie';


parcelRegister("gFlSp", function(module, exports) {

$parcel$export(module.exports, "FieldSync", () => $4f1f5db90d381e85$export$9ca22efe8785da27);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $67sX6 = parcelRequire("67sX6");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $ajjUL = parcelRequire("ajjUL");

var $2CN17 = parcelRequire("2CN17");

var $d7KqV = parcelRequire("d7KqV");

var $7MspI = parcelRequire("7MspI");

var $iKnzg = parcelRequire("iKnzg");
const $4f1f5db90d381e85$export$9ca22efe8785da27 = ({ issueId: issueId, syncAssignee: syncAssignee = true, syncEstimate: syncEstimate = true, syncParent: syncParent = true, syncSummary: syncSummary = true, syncPriority: syncPriority = true })=>{
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const estimationStatistic = (0, $67sX6.useBoardSelector)((0, $5mTgl.getEstimationStatistic));
    const incrementPlanningEstimateFieldId = (0, $67sX6.useBoardSelector)((0, $67Z81.getIncrementPlanningEstimateFieldId));
    const estimateFieldId = isIPBoard ? incrementPlanningEstimateFieldId : estimationStatistic;
    const projects = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueProjects));
    const projectKey = issue && projects[issue.projectId]?.key;
    if (!issue) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (!(0, $4R6GH.fg)('relay-migration-issue-fields-summary') || isIPBoard) && syncSummary && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MspI.FieldSyncSummary), {
        issue: issue,
        projectKey: projectKey
    }), syncParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d7KqV.FieldSyncParent), {
        issue: issue,
        projectKey: projectKey
    }), syncAssignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajjUL.FieldSyncAssignee), {
        issue: issue,
        ...(0, $4R6GH.fg)('issue_cards_in_program_board') && {
            projectKey: projectKey
        }
    }), syncPriority && isIPBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKnzg.FieldSyncPriority), {
        issue: issue,
        projectKey: projectKey
    }), syncEstimate && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateFieldId) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2CN17.FieldSyncEstimate), {
        issue: issue,
        estimateFieldId: estimateFieldId,
        projectKey: projectKey
    }));
};

});
parcelRegister("ajjUL", function(module, exports) {

$parcel$export(module.exports, "FieldSyncAssignee", () => $db25ad5a6a5695e7$export$3b271f574456338d);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $fhSLy = parcelRequire("fhSLy");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $2P7AF = parcelRequire("2P7AF");


var $2f454 = parcelRequire("2f454");

var $67sX6 = parcelRequire("67sX6");

var $36pz7 = parcelRequire("36pz7");

var $63LqY = parcelRequire("63LqY");
const $db25ad5a6a5695e7$export$3b271f574456338d = ({ issue: issue, projectKey: projectKey })=>{
    const { key: key, assigneeAccountId: assigneeAccountId, id: id } = issue;
    const assigneeIdFromBoard = (0, $5uXOq.useMemo)(()=>assigneeAccountId ? String(assigneeAccountId) : '', [
        assigneeAccountId
    ]);
    const assigneeFromBoard = (0, $67sX6.useBoardSelector)((state)=>(0, $36pz7.getPerson)(state, assigneeIdFromBoard));
    const setAssigneeInBoard = (0, $67sX6.useBoardActionCreator)((assignee)=>(0, $2f454.cardDataSet)({
            ...issue,
            assigneeAccountId: assignee?.id ?? null
        }, assignee, (0, $f32ae13c2b9742f4$export$c1d71ceefe04e35a)));
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const uniqueKey = isIPBoard && key === projectKey && (0, $4R6GH.fg)('issue_cards_in_program_board') ? `${id}` : key;
    const [assigneeFromIssueField, { setFieldValue: setAssigneeInIssueField }] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: (0, $5fc53.ASSIGNEE_TYPE)
    });
    const assigneeIdFromIssueField = (0, $5uXOq.useMemo)(()=>assigneeFromIssueField?.accountId || null, [
        assigneeFromIssueField?.accountId
    ]);
    const assigneeFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        assigneeIdFromBoard
    ]);
    const assigneeFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        assigneeIdFromIssueField
    ]);
    const storesNeedToSync = assigneeIdFromBoard !== assigneeIdFromIssueField;
    // Board -> Issue Field Sync
    (0, $5uXOq.useEffect)(()=>{
        if (assigneeFromBoardChanged && storesNeedToSync) setAssigneeInIssueField(uniqueKey, (0, $5fc53.ASSIGNEE_TYPE), assigneeFromBoard ? (0, $fhSLy.getUserShape)(assigneeFromBoard.id, assigneeFromBoard.displayName, assigneeFromBoard.avatarUrl || '') : null);
    }, [
        uniqueKey,
        assigneeFromBoardChanged,
        storesNeedToSync,
        setAssigneeInIssueField,
        assigneeFromBoard
    ]);
    // Issue Field -> Board Sync
    (0, $5uXOq.useEffect)(()=>{
        if (!assigneeFromBoardChanged && assigneeFromIssueFieldChanged && storesNeedToSync) {
            const issueFieldPerson = assigneeFromIssueField ? {
                ...assigneeFromIssueField,
                avatarUrl: assigneeFromIssueField?.avatarUrls?.['48x48'],
                id: assigneeFromIssueField.accountId
            } : null;
            setAssigneeInBoard(issueFieldPerson);
        }
    }, [
        assigneeFromBoardChanged,
        assigneeFromIssueField,
        assigneeFromIssueFieldChanged,
        setAssigneeInBoard,
        storesNeedToSync
    ]);
    return null;
};

});
parcelRegister("fhSLy", function(module, exports) {

$parcel$export(module.exports, "getUnassignedUser", () => $bdabf260f25df73f$export$42c5a0b65ef9ee80);
$parcel$export(module.exports, "getAutomaticUserOption", () => $bdabf260f25df73f$export$8d7a63500893c8c);
$parcel$export(module.exports, "getInvitePeopleOption", () => $bdabf260f25df73f$export$84a82764cf0a696e);
$parcel$export(module.exports, "getUserOptionFromUser", () => $bdabf260f25df73f$export$16086438354dcc85);
$parcel$export(module.exports, "getUserFromUserOption", () => $bdabf260f25df73f$export$78a8bcc5bd21caa2);
$parcel$export(module.exports, "getUserAvatarUrl", () => $bdabf260f25df73f$export$7d801d84202c7743);
$parcel$export(module.exports, "getUserShape", () => $bdabf260f25df73f$export$322b6ab8c29a006e);

var $7lGt2 = parcelRequire("7lGt2");

var $gRwYv = parcelRequire("gRwYv");

const $bdabf260f25df73f$export$42c5a0b65ef9ee80 = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463),
        displayName: formatMessage((0, $7lGt2.default).unassignedOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$8d7a63500893c8c = ({ formatMessage: formatMessage })=>({
        accountId: (0, $c1e3a0a8493b8e86$export$f5d5f6bb902f1027),
        displayName: formatMessage((0, $7lGt2.default).automaticOption),
        avatarUrls: {}
    });
const $bdabf260f25df73f$export$84a82764cf0a696e = ({ formatMessage: formatMessage }, isAdmin)=>({
        accountId: (0, $c1e3a0a8493b8e86$export$d875316cb0cd94f7),
        displayName: formatMessage(isAdmin ? (0, $7lGt2.default).invitePeopleOptionAdmin : (0, $7lGt2.default).invitePeopleOption),
        avatarUrls: {
            '48x48': (0, (/*@__PURE__*/$parcel$interopDefault($gRwYv)))
        }
    });
const $bdabf260f25df73f$export$16086438354dcc85 = ({ accountId: accountId, displayName: displayName, avatarUrls: avatarUrls, emailAddress: emailAddress })=>({
        id: accountId || '',
        name: displayName,
        avatarUrl: avatarUrls['48x48'],
        // @ts-expect-error Will be part of JIV-13488; `user.emailAddress` returned by the REST API can be null depending on their privacy settings
        byline: emailAddress
    });
const $bdabf260f25df73f$export$78a8bcc5bd21caa2 = ({ id: id, name: name, avatarUrl: avatarUrl })=>({
        accountId: id,
        displayName: name,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });
const $bdabf260f25df73f$export$7d801d84202c7743 = ({ avatarUrls: avatarUrls })=>avatarUrls['48x48'];
const $bdabf260f25df73f$export$322b6ab8c29a006e = (accountId, displayName, avatarUrl)=>({
        accountId: accountId,
        displayName: displayName,
        avatarUrls: {
            '48x48': avatarUrl
        }
    });

});
parcelRegister("7lGt2", function(module, exports) {

$parcel$export(module.exports, "default", () => $e2aaed3328149e1d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e2aaed3328149e1d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unassignedOption: {
        "id": "issue-field-assignee.unassigned-option",
        "defaultMessage": "Unassigned"
    },
    automaticOption: {
        "id": "issue-field-assignee.automatic-option",
        "defaultMessage": "Automatic"
    },
    assignToMe: {
        "id": "issue-field-assignee.assign-to-me",
        "defaultMessage": "Assign to me"
    },
    searchForAssignee: {
        "id": "issue-field-assignee.search-for-assignee",
        "defaultMessage": "Search for assignee"
    },
    invitePeopleOption: {
        "id": "issue-field-assignee.invite-people-option",
        "defaultMessage": "Add teammate to Jira"
    },
    invitePeopleOptionAdmin: {
        "id": "issue-field-assignee.invite-people-option-admin",
        "defaultMessage": "Invite teammate to Jira"
    }
});

});

parcelRegister("gRwYv", function(module, exports) {
module.exports = new URL("add.b8fea212.png", import.meta.url).toString();

});

const $c1e3a0a8493b8e86$export$bdab9bfb39981463 = '__UNASSIGNED_ID__';
const $c1e3a0a8493b8e86$export$d875316cb0cd94f7 = '__INVITE_PEOPLE_ID__';
const $c1e3a0a8493b8e86$export$f5d5f6bb902f1027 = '-1';


parcelRegister("3fAi8", function(module, exports) {

$parcel$export(module.exports, "useFieldValue", () => $ddbc380ab4ee430c$export$b79fae7fbe3ac392);
$parcel$export(module.exports, "useFieldsValues", () => $ddbc380ab4ee430c$export$25b73e671fe7a8fa);
$parcel$export(module.exports, "useMultiFieldValuesForIssues", () => $ddbc380ab4ee430c$export$915cdeec521b54f7);
$parcel$export(module.exports, "FieldValueSubscriber", () => $ddbc380ab4ee430c$export$4e5f1f4ed08d155e);
$parcel$export(module.exports, "useFieldsValuesActions", () => $ddbc380ab4ee430c$export$612d9bcb0c9d8976);

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
const $ddbc380ab4ee430c$var$setIssue = (issueKey, fields)=>({ setState: setState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: fields
        });
    };
const $ddbc380ab4ee430c$var$setIssues = (issues)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState(newIssues);
    };
const $ddbc380ab4ee430c$var$setFieldValue = (issueKey, fieldKey, value)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: value
            }
        });
    };
const $ddbc380ab4ee430c$var$getFieldValue = (issueKey, fieldKey)=>({ getState: getState })=>{
        const issueFieldValues = getState()[issueKey];
        return issueFieldValues && issueFieldValues[fieldKey];
    };
const $ddbc380ab4ee430c$var$mergeIssue = (issueKey, fields)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], fields)
        });
    };
const $ddbc380ab4ee430c$export$11aa02e14fdf7753 = (issues)=>({ setState: setState, getState: getState })=>{
        if (issues.length === 0) return;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = {};
        issues.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $ddbc380ab4ee430c$var$actions = {
    setFieldValue: $ddbc380ab4ee430c$var$setFieldValue,
    getFieldValue: $ddbc380ab4ee430c$var$getFieldValue,
    setIssue: $ddbc380ab4ee430c$var$setIssue,
    mergeIssue: $ddbc380ab4ee430c$var$mergeIssue,
    setIssues: $ddbc380ab4ee430c$var$setIssues,
    mergeIssues: $ddbc380ab4ee430c$export$11aa02e14fdf7753
};
// this is a global store
const $ddbc380ab4ee430c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-fields',
    initialState: {},
    actions: $ddbc380ab4ee430c$var$actions
});
const $ddbc380ab4ee430c$var$getFieldValueSelector = (state, { issueKey: issueKey, fieldKey: fieldKey })=>{
    const issueFieldValues = state[issueKey];
    return issueFieldValues && issueFieldValues[fieldKey];
};
const $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKey: fieldKey })=>(issueKeys || []).map((issueKey)=>$ddbc380ab4ee430c$var$getFieldValueSelector(state, {
            fieldKey: fieldKey,
            issueKey: issueKey
        }));
const $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector = (state, { issueKeys: issueKeys, fieldKeys: fieldKeys })=>(issueKeys || []).reduce((accumulator, issueKey)=>{
        if (!state[issueKey]) return accumulator;
        const fieldValue = fieldKeys.reduce((acc, fieldKey)=>{
            acc[fieldKey] = $ddbc380ab4ee430c$var$getFieldValueSelector(state, {
                fieldKey: fieldKey,
                issueKey: issueKey
            });
            return acc;
        }, {});
        accumulator[issueKey] = fieldValue;
        return accumulator;
    }, {});
const $ddbc380ab4ee430c$var$getAllFields = (state, issueKey)=>state[issueKey];
const $ddbc380ab4ee430c$export$b79fae7fbe3ac392 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$export$25b73e671fe7a8fa = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getAllFields
});
const $ddbc380ab4ee430c$export$ac289b84121829df = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$915cdeec521b54f7 = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getMultiFieldValuesForIssuesSelector
});
const $ddbc380ab4ee430c$export$4e5f1f4ed08d155e = (0, $51nlc.createSubscriber)($ddbc380ab4ee430c$var$store, {
    selector: $ddbc380ab4ee430c$var$getFieldValueSelector
});
const $ddbc380ab4ee430c$var$useFieldValueStoreActions = (0, $3sQ5x.createHook)($ddbc380ab4ee430c$var$store, {
    selector: null
});
const $ddbc380ab4ee430c$export$612d9bcb0c9d8976 = ()=>{
    const [, fieldValueStoreActions] = $ddbc380ab4ee430c$var$useFieldValueStoreActions();
    const fieldsValuesActions = (0, $5uXOq.useMemo)(()=>{
        const setIssueAction = (issueKey, fields)=>fieldValueStoreActions.setIssue(issueKey, fields);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const setFieldValueAction = (issueKey, fieldKey, value)=>fieldValueStoreActions.setFieldValue(issueKey, fieldKey, value);
        const getFieldValueAction = (issueKey, fieldKey)=>fieldValueStoreActions.getFieldValue(issueKey, fieldKey);
        const mergeIssueAction = (issueKey, fields)=>fieldValueStoreActions.mergeIssue(issueKey, fields);
        const setIssuesAction = (issues)=>fieldValueStoreActions.setIssues(issues);
        const mergeIssuesAction = (issues)=>fieldValueStoreActions.mergeIssues(issues);
        return {
            setIssue: setIssueAction,
            setFieldValue: setFieldValueAction,
            getFieldValue: getFieldValueAction,
            mergeIssue: mergeIssueAction,
            setIssues: setIssuesAction,
            mergeIssues: mergeIssuesAction
        };
    }, [
        fieldValueStoreActions
    ]);
    return [
        null,
        fieldsValuesActions
    ];
};

});

parcelRegister("2P7AF", function(module, exports) {

$parcel$export(module.exports, "useDiffCheck", () => $a41630f4c93ddc10$export$5ade32966816005f);

var $5uXOq = parcelRequire("5uXOq");
const $a41630f4c93ddc10$export$5ade32966816005f = (nextValues = [])=>{
    const ref = (0, $5uXOq.useRef)([]);
    const prevValues = ref.current;
    (0, $5uXOq.useEffect)(()=>{
        ref.current = nextValues;
    }, [
        nextValues
    ]);
    return prevValues.length ? prevValues.some((value, i)=>nextValues[i] !== value) : false;
};

});


parcelRegister("2CN17", function(module, exports) {

$parcel$export(module.exports, "FieldSyncEstimate", () => $fe40f4fda2aacd3a$export$4539ee47feb9709a);

var $5uXOq = parcelRequire("5uXOq");


var $gNIhI = parcelRequire("gNIhI");

var $eNXt6 = parcelRequire("eNXt6");
const $fe40f4fda2aacd3a$export$4539ee47feb9709a = ({ issue: issue, estimateFieldId: estimateFieldId, projectKey: projectKey })=>{
    if (estimateFieldId === (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gNIhI.FieldSyncOriginalEstimate), {
        issue: issue,
        originalEstimateFieldId: estimateFieldId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNXt6.FieldSyncStoryPoint), {
        issue: issue,
        storypointsFieldId: estimateFieldId,
        projectKey: projectKey
    });
};

});
const $e9be48d6d2c01760$export$e18419056f3d184a = 'assignee';
const $e9be48d6d2c01760$export$45cafdfd629c3ca1 = 'reporter';
const $e9be48d6d2c01760$export$d5bc879e3b748593 = 'description';
const $e9be48d6d2c01760$export$a68dbc90211df1a8 = 'fixVersions';
const $e9be48d6d2c01760$export$93605f2a09aa8d26 = 'labels';
const $e9be48d6d2c01760$export$4420b7468f889692 = 'status';
const $e9be48d6d2c01760$export$e7cf1830fe735d1f = 'summary';
const $e9be48d6d2c01760$export$5fbd3b15555b9ef2 = 'timeoriginalestimate';
const $e9be48d6d2c01760$export$a5fc282ab2bf9b89 = 'issuelinks';
const $e9be48d6d2c01760$export$b52547457d714bc0 = 'epic-issues';
const $e9be48d6d2c01760$export$3cca6e37a5823d5a = 'children-issues';
const $e9be48d6d2c01760$export$98a935eb30de54ab = 'components';
const $e9be48d6d2c01760$export$f7a17147527dd688 = 'flag';

parcelRegister("gNIhI", function(module, exports) {

$parcel$export(module.exports, "FieldSyncOriginalEstimate", () => $b152a2e0f20a9e95$export$f3b2ab9abc70b1c8);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $koVbs = parcelRequire("koVbs");

var $3fAi8 = parcelRequire("3fAi8");

var $etKNj = parcelRequire("etKNj");

var $2P7AF = parcelRequire("2P7AF");


var $9jMeJ = parcelRequire("9jMeJ");

var $67sX6 = parcelRequire("67sX6");

var $5mTgl = parcelRequire("5mTgl");
const $b152a2e0f20a9e95$export$f3b2ab9abc70b1c8 = ({ issue: { id: id, key: key, estimate: estimate }, originalEstimateFieldId: originalEstimateFieldId })=>{
    const intl = (0, $koVbs.default)();
    const timeTrackingOptions = (0, $67sX6.useBoardSelector)((0, $5mTgl.getTimeTrackingOptions));
    const setEstimateInBoard = (0, $67sX6.useBoardActionCreator)((issueId, value)=>(0, $9jMeJ.setEstimate)(issueId, value));
    const originalEstimateFromBoard = estimate?.value ?? null;
    const [originalEstimateFromIssueField, { setFieldValue: setOriginalEstimateInExtractedField }] = (0, $3fAi8.useFieldValue)({
        issueKey: key,
        fieldKey: originalEstimateFieldId
    });
    const originalEstimateFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        originalEstimateFromBoard
    ]);
    const originalEstimateFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        originalEstimateFromIssueField
    ]);
    const storesNeedToSync = originalEstimateFromBoard !== originalEstimateFromIssueField;
    (0, $5uXOq.useEffect)(()=>{
        // Board -> Issue Field Sync
        if (originalEstimateFromBoardChanged && storesNeedToSync) setOriginalEstimateInExtractedField(key, originalEstimateFieldId, originalEstimateFromBoard);
    }, [
        key,
        originalEstimateFromBoard,
        originalEstimateFromBoardChanged,
        originalEstimateFieldId,
        setOriginalEstimateInExtractedField,
        storesNeedToSync,
        timeTrackingOptions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Issue Field -> Board Sync
        if (// Ensure no sync will be called by Board as Board is the driver
        !originalEstimateFromBoardChanged && originalEstimateFromIssueFieldChanged && storesNeedToSync) setEstimateInBoard(id, !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(originalEstimateFromIssueField) ? {
            type: (0, $b383ed62f6689e0b$export$73bc902d1e240cad),
            fieldId: originalEstimateFieldId,
            value: originalEstimateFromIssueField,
            valueAsText: (0, $etKNj.timeTrackingFormatter)(originalEstimateFromIssueField, timeTrackingOptions, intl)
        } : null);
    }, [
        id,
        setEstimateInBoard,
        storesNeedToSync,
        originalEstimateFromBoardChanged,
        originalEstimateFromIssueField,
        originalEstimateFromIssueFieldChanged,
        timeTrackingOptions,
        intl,
        originalEstimateFieldId
    ]);
    return null;
};

});
parcelRegister("etKNj", function(module, exports) {

$parcel$export(module.exports, "timeTrackingFormatter", () => $5d7d4350edc91a82$export$5169d8c8f9327e33);
$parcel$export(module.exports, "timeTrackingFormatterWithDefaults", () => $5d7d4350edc91a82$export$71be3aa954f6065b);
$parcel$export(module.exports, "timeTrackingFormatterLongForm", () => $5d7d4350edc91a82$export$bb4e82d8c2aeeff1);
$parcel$export(module.exports, "transformAGGToJiraTimeFormat", () => $5d7d4350edc91a82$export$9dccd3a07969375d);
$parcel$export(module.exports, "transformAGGToJiraTimeUnit", () => $5d7d4350edc91a82$export$8516173ab945b52f);

var $gBj4V = parcelRequire("gBj4V");

var $lgkxY = parcelRequire("lgkxY");

var $4TB2x = parcelRequire("4TB2x");
const $5d7d4350edc91a82$var$validate = (condition)=>(distance)=>condition ? distance : 0;
// Format time to be 2 decimal places without trailing zeros
const $5d7d4350edc91a82$var$timeFormatter = (time, unit)=>time > 0 ? `${time.toFixed(2).replace(/\.?0+$/, '')}${unit}` : `0${unit}`;
const $5d7d4350edc91a82$var$timePrettyFormatter = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0${formatMessage(units[3].suffix)}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        const secondsRemaining = currentTimeValue > 0 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 0 ? `${timeObj.time} ${currentTimeValue}${formatMessage(unit.suffix)}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$var$timePrettyFormatterLongForm = (timeInSeconds, units, formatMessage)=>{
    const timeForZero = `0 ${formatMessage(units[3].suffix, {
        [units[3].type]: 0
    })}`;
    if (timeInSeconds <= 0) return timeForZero;
    const initialTimeObj = {
        secondsRemaining: timeInSeconds,
        time: ''
    };
    const result = units.reduce((timeObj, unit)=>{
        if (unit.seconds <= 0) return timeObj;
        const { suffix: suffix, type: type } = unit;
        const currentTimeValue = Math.floor(timeObj.secondsRemaining / unit.seconds);
        if (currentTimeValue === 1) return {
            secondsRemaining: timeObj.secondsRemaining % unit.seconds,
            time: `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
                [type]: currentTimeValue
            })}`
        };
        const secondsRemaining = currentTimeValue > 1 ? timeObj.secondsRemaining % unit.seconds : timeObj.secondsRemaining;
        const time = currentTimeValue > 1 ? `${timeObj.time} ${currentTimeValue} ${formatMessage(suffix, {
            [type]: currentTimeValue
        })}` : timeObj.time;
        return {
            secondsRemaining: secondsRemaining,
            time: time
        };
    }, initialTimeObj);
    return result.time.trim() || timeForZero;
};
const $5d7d4350edc91a82$export$5169d8c8f9327e33 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, formatMessage(units[1].suffix));
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, formatMessage(units[2].suffix));
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatter(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$71be3aa954f6065b = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat }, intl)=>{
    const timeTrackingSettings = {
        workingHoursPerDay: workingHoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay,
        workingDaysPerWeek: workingDaysPerWeek || (0, $gBj4V.defaultTimeTrackingOptions).workingDaysPerWeek,
        timeFormat: timeFormat || (0, $gBj4V.defaultTimeTrackingOptions).timeFormat,
        defaultUnit: (0, $gBj4V.defaultTimeTrackingOptions).defaultUnit
    };
    return $5d7d4350edc91a82$export$5169d8c8f9327e33(timeInSeconds || 0, timeTrackingSettings, intl);
};
const $5d7d4350edc91a82$export$bb4e82d8c2aeeff1 = (timeInSeconds, { workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, timeFormat: timeFormat } = (0, $gBj4V.defaultTimeTrackingOptions), { formatMessage: formatMessage })=>{
    const isTimeValid = timeInSeconds > 0;
    const isTimeInDaysValid = isTimeValid && workingHoursPerDay > 0;
    const unit = (0, $4TB2x.createUnit)(timeInSeconds);
    const units = [
        unit({
            type: 'week',
            suffix: (0, $lgkxY.default).timeUnitLongWeek,
            seconds: Math.max(workingDaysPerWeek, 0) * Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'day',
            suffix: (0, $lgkxY.default).timeUnitLongDay,
            transform: $5d7d4350edc91a82$var$validate(isTimeInDaysValid),
            seconds: Math.max(workingHoursPerDay, 0) * (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'hour',
            suffix: (0, $lgkxY.default).timeUnitLongHour,
            transform: $5d7d4350edc91a82$var$validate(isTimeValid),
            seconds: (0, $gBj4V.SECONDS_PER_HOUR)
        }),
        unit({
            type: 'minute',
            suffix: (0, $lgkxY.default).timeUnitLongMinute,
            seconds: (0, $gBj4V.SECONDS_PER_MINUTE)
        })
    ];
    switch(timeFormat){
        case (0, $gBj4V.TimeFormats).DAYS:
            return $5d7d4350edc91a82$var$timeFormatter(units[1].time, ` ${formatMessage(units[1].suffix, {
                day: units[1].time
            })}`);
        case (0, $gBj4V.TimeFormats).HOURS:
            return $5d7d4350edc91a82$var$timeFormatter(units[2].time, ` ${formatMessage(units[2].suffix, {
                hour: units[2].time
            })}`);
        case (0, $gBj4V.TimeFormats).PRETTY:
        default:
            return $5d7d4350edc91a82$var$timePrettyFormatterLongForm(timeInSeconds, units, formatMessage);
    }
};
const $5d7d4350edc91a82$export$9dccd3a07969375d = (format)=>{
    switch(String(format).toLowerCase()){
        case (0, $gBj4V.TimeFormats).DAYS:
            return (0, $gBj4V.TimeFormats).DAYS;
        case (0, $gBj4V.TimeFormats).HOURS:
            return (0, $gBj4V.TimeFormats).HOURS;
        case (0, $gBj4V.TimeFormats).PRETTY:
            return (0, $gBj4V.TimeFormats).PRETTY;
        default:
            return (0, $gBj4V.TimeFormats).DAYS;
    }
};
const $5d7d4350edc91a82$export$8516173ab945b52f = (defaultUnit)=>{
    switch(String(defaultUnit).toLowerCase()){
        case (0, $gBj4V.TimeUnits).DAY:
            return (0, $gBj4V.TimeUnits).DAY;
        case (0, $gBj4V.TimeUnits).HOUR:
            return (0, $gBj4V.TimeUnits).HOUR;
        case (0, $gBj4V.TimeUnits).MINUTE:
            return (0, $gBj4V.TimeUnits).MINUTE;
        case (0, $gBj4V.TimeUnits).WEEK:
            return (0, $gBj4V.TimeUnits).WEEK;
        default:
            return (0, $gBj4V.TimeUnits).DAY;
    }
};

});
parcelRegister("lgkxY", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e424f4a1d744f3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $00e424f4a1d744f3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    timeUnitWeek: {
        "id": "time-tracking-formatter.time-unit-week",
        "defaultMessage": "w"
    },
    timeUnitDay: {
        "id": "time-tracking-formatter.time-unit-day",
        "defaultMessage": "d"
    },
    timeUnitHour: {
        "id": "time-tracking-formatter.time-unit-hour",
        "defaultMessage": "h"
    },
    timeUnitMinute: {
        "id": "time-tracking-formatter.time-unit-minute",
        "defaultMessage": "m"
    },
    timeUnitLongWeek: {
        "id": "time-tracking-formatter.time-unit-long-week",
        "defaultMessage": "{week, plural, zero {weeks} one {week} other {weeks} }"
    },
    timeUnitLongDay: {
        "id": "time-tracking-formatter.time-unit-long-day",
        "defaultMessage": "{day, plural, zero {days} one {day} other {days} }"
    },
    timeUnitLongHour: {
        "id": "time-tracking-formatter.time-unit-long-hour",
        "defaultMessage": "{hour, plural, zero {hours} one {hour} other {hours} }"
    },
    timeUnitLongMinute: {
        "id": "time-tracking-formatter.time-unit-long-minute",
        "defaultMessage": "{minute, plural, zero {minutes} one {minute} other {minutes} }"
    }
});

});

parcelRegister("4TB2x", function(module, exports) {

$parcel$export(module.exports, "createUnit", () => $d8f5ee4c356dec74$export$aab44654646f3ccc);
const $d8f5ee4c356dec74$export$aab44654646f3ccc = (timeInSeconds)=>({ suffix: suffix, seconds: seconds, type: type, transform: transform })=>{
        const distance = timeInSeconds / seconds;
        const time = transform ? transform(distance) : distance;
        return {
            seconds: seconds,
            suffix: suffix,
            time: time,
            type: type
        };
    };

});



parcelRegister("eNXt6", function(module, exports) {

$parcel$export(module.exports, "FieldSyncStoryPoint", () => $f04848d24e7c0dcc$export$82efc4b6933fada0);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $3fAi8 = parcelRequire("3fAi8");

var $2P7AF = parcelRequire("2P7AF");


var $9jMeJ = parcelRequire("9jMeJ");

var $67sX6 = parcelRequire("67sX6");

var $63LqY = parcelRequire("63LqY");
const $f04848d24e7c0dcc$export$82efc4b6933fada0 = ({ issue: { id: id, key: key, estimate: estimate }, storypointsFieldId: storypointsFieldId, projectKey: projectKey })=>{
    const setEstimateInBoard = (0, $67sX6.useBoardActionCreator)((issueId, value)=>(0, $9jMeJ.setEstimate)(issueId, value));
    const storyPointFromBoard = estimate?.value ?? null;
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const uniqueKey = isIPBoard && key === projectKey ? `${id}` : key;
    const [storyPointFromIssueField, { setFieldValue: setStoryPointInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: storypointsFieldId
    });
    const storyPointFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        storyPointFromBoard
    ]);
    const storyPointFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        storyPointFromIssueField
    ]);
    const storesNeedToSync = storyPointFromBoard !== storyPointFromIssueField;
    (0, $5uXOq.useEffect)(()=>{
        // Board -> Issue Field Sync
        if (storyPointFromBoardChanged && storesNeedToSync) setStoryPointInExtractedFields(uniqueKey, storypointsFieldId, storyPointFromBoard);
    }, [
        storypointsFieldId,
        key,
        setStoryPointInExtractedFields,
        storesNeedToSync,
        storyPointFromBoard,
        storyPointFromBoardChanged,
        uniqueKey
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Issue Field -> Board Sync
        if (// Ensure no sync will be called by Board as Board is the driver
        !storyPointFromBoardChanged && storyPointFromIssueFieldChanged && storesNeedToSync) {
            let estimateFieldValue = null;
            if (isIPBoard) estimateFieldValue = {
                type: (0, $b383ed62f6689e0b$export$24c68738fb7a96c7),
                fieldId: storypointsFieldId,
                value: storyPointFromIssueField || ''
            };
            else if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(storyPointFromIssueField)) estimateFieldValue = {
                type: (0, $b383ed62f6689e0b$export$a092d6877c35430e),
                fieldId: storypointsFieldId,
                value: storyPointFromIssueField
            };
            setEstimateInBoard(id, estimateFieldValue);
        }
    }, [
        storypointsFieldId,
        id,
        setEstimateInBoard,
        storesNeedToSync,
        storyPointFromBoardChanged,
        storyPointFromIssueField,
        storyPointFromIssueFieldChanged,
        isIPBoard
    ]);
    return null;
};

});


parcelRegister("d7KqV", function(module, exports) {

$parcel$export(module.exports, "FieldSyncParent", () => $40be629fe9e48f30$export$68e0e835c0241644);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $7Fute = parcelRequire("7Fute");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $4R6GH = parcelRequire("4R6GH");

var $2P7AF = parcelRequire("2P7AF");

var $evkwq = parcelRequire("evkwq");

var $67sX6 = parcelRequire("67sX6");

var $bSSdD = parcelRequire("bSSdD");

var $63LqY = parcelRequire("63LqY");
const $40be629fe9e48f30$export$68e0e835c0241644 = ({ issue: { id: id, key: key, parentId: parentId }, projectKey: projectKey })=>{
    const parentIdFromBoard = (0, $5uXOq.useMemo)(()=>parentId ? String(parentId) : null, [
        parentId
    ]);
    const issueParentFromBoard = (0, $67sX6.useBoardSelector)((state)=>(0, $bSSdD.makeIssueParentByIdSelector)(state)(parentIdFromBoard));
    const setParentInBoard = (0, $67sX6.useBoardActionCreator)((issueId, issueParentId)=>(0, $evkwq.setIssueParent)(issueId, issueParentId));
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const uniqueKey = isIPBoard && key === projectKey ? `${id}` : key;
    const [parentFromIssueField, { setFieldValue: setParentInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    const [, { setFieldValue: setValueInExtractedField }] = (0, $3fAi8.useFieldsValuesActions)();
    const parentIdFromIssueField = (0, $5uXOq.useMemo)(()=>parentFromIssueField?.id || null, [
        parentFromIssueField?.id
    ]);
    const parentFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        parentIdFromBoard
    ]);
    const parentFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        parentIdFromIssueField
    ]);
    const parentSummaryFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        issueParentFromBoard?.summary
    ]);
    // parent field should only sync on increment planning board for story level issues
    const issueIsParentInIPBoard = (parentIdFromBoard === id || parentIdFromIssueField === id) && isIPBoard;
    const storesNeedToSync = parentIdFromBoard !== parentIdFromIssueField && !issueIsParentInIPBoard;
    // parent summary can be edited on the program board via the issue modal
    // and should be synced to the extracted fields
    const storesNeedToSyncParentSummary = isIPBoard && (0, $4R6GH.fg)('issue_view_in_program_board');
    // PARENT SYNC: BOARD -> EXTRACTED FIELDS
    (0, $5uXOq.useEffect)(()=>{
        if (parentFromBoardChanged && storesNeedToSync || parentSummaryFromBoardChanged && storesNeedToSyncParentSummary) {
            setParentInExtractedFields(uniqueKey, (0, $5fc53.PARENT_TYPE), issueParentFromBoard ? (0, $7Fute.getParentShape)((0, $g5X3G.toIssueId)(String(issueParentFromBoard.id)), issueParentFromBoard.key, issueParentFromBoard.summary, {
                id: issueParentFromBoard.issueType.id,
                name: issueParentFromBoard.issueType.name,
                iconUrl: issueParentFromBoard.issueType.iconUrl
            }, issueParentFromBoard.color) : null);
            if (issueParentFromBoard) setValueInExtractedField(uniqueKey, (0, $5fc53.HIERARCHY_LEVEL_ABOVE), (0, $7Fute.getHierarchyShape)({
                id: issueParentFromBoard.issueType.id,
                name: issueParentFromBoard.issueType.name,
                iconUrl: issueParentFromBoard.issueType.iconUrl
            }));
        }
    }, [
        issueParentFromBoard,
        parentFromBoardChanged,
        setValueInExtractedField,
        setParentInExtractedFields,
        storesNeedToSync,
        uniqueKey,
        parentSummaryFromBoardChanged,
        storesNeedToSyncParentSummary
    ]);
    // PARENT SYNC: EXTRACTED FIELDS -> BOARD
    (0, $5uXOq.useEffect)(()=>{
        if (!parentFromBoardChanged && parentFromIssueFieldChanged && storesNeedToSync) setParentInBoard(id, parentFromIssueField?.id || null);
    }, [
        id,
        parentFromBoardChanged,
        parentFromIssueField?.id,
        parentFromIssueFieldChanged,
        setParentInBoard,
        storesNeedToSync
    ]);
    return null;
};

});
parcelRegister("7Fute", function(module, exports) {

$parcel$export(module.exports, "getLozengeThemeByColor", () => $92894d61150c3ebf$export$949dc67535a8ff2);
$parcel$export(module.exports, "getParentShape", () => $92894d61150c3ebf$export$1a0682c86bbf9e96);
$parcel$export(module.exports, "getHierarchyShape", () => $92894d61150c3ebf$export$5f81302d25451851);
$parcel$export(module.exports, "formatOptionList", () => $92894d61150c3ebf$export$48f827b6d0c5862);
$parcel$export(module.exports, "transformToEpic", () => $92894d61150c3ebf$export$11773371cf35c9f8);

var $iHPnC = parcelRequire("iHPnC");

var $k8qVk = parcelRequire("k8qVk");
const $92894d61150c3ebf$export$9b822862d986dfdf = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $92894d61150c3ebf$export$949dc67535a8ff2 = (color = (0, $k8qVk.DEFAULT_EPIC_COLOR))=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $92894d61150c3ebf$export$9b822862d986dfdf[color] ?? $92894d61150c3ebf$export$9b822862d986dfdf[0, $k8qVk.DEFAULT_EPIC_COLOR];
const $92894d61150c3ebf$export$1a0682c86bbf9e96 = (id, key, summary, issuetype, color)=>({
        id: id,
        key: key,
        color: color,
        fields: {
            summary: summary,
            issuetype: issuetype
        }
    });
const $92894d61150c3ebf$export$5f81302d25451851 = ({ id: id, name: name, iconUrl: iconUrl })=>({
        name: 'Epic',
        level: 1,
        issueTypeIds: [
            Number(id)
        ],
        issueTypes: [
            {
                id: id,
                name: name,
                iconUrl: iconUrl
            }
        ]
    });
const $92894d61150c3ebf$export$48f827b6d0c5862 = (unformattedOptions, currentParent, label)=>{
    const filteredOptions = unformattedOptions.filter((option)=>option.key !== currentParent);
    const parentList = filteredOptions.slice(0, (0, $k8qVk.MAX_SUGGESTIONS)).map((option)=>({
            label: `${option.key} ${option.fields.summary}`,
            value: option.fields.summary,
            iconUrl: option.fields.issuetype.iconUrl,
            ...option
        }));
    return {
        options: parentList.length > 0 ? [
            {
                label: label,
                options: parentList
            }
        ] : [],
        hasMoreOptions: filteredOptions.length > (0, $k8qVk.MAX_SUGGESTIONS)
    };
};
const $92894d61150c3ebf$export$11773371cf35c9f8 = ({ id: id, key: key, summary: summary, color: color, issueType: { id: issueTypeId, name: issueTypeName, iconUrl: iconUrl } })=>({
        id: id,
        key: key,
        summary: summary,
        color: color,
        issueType: {
            id: issueTypeId,
            name: issueTypeName,
            iconUrl: iconUrl
        }
    });

});
parcelRegister("k8qVk", function(module, exports) {

$parcel$export(module.exports, "PACKAGE_NAME", () => $93cb8f2923e7410b$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "DEFAULT_EPIC_COLOR", () => $93cb8f2923e7410b$export$c2357bec51c5cf5b);
$parcel$export(module.exports, "MAX_SUGGESTIONS", () => $93cb8f2923e7410b$export$eb8d067f048699c8);
$parcel$export(module.exports, "MENU_WIDTH", () => $93cb8f2923e7410b$export$2467bcf8f6d5c6b6);
$parcel$export(module.exports, "MENU_EMPTY_WIDTH", () => $93cb8f2923e7410b$export$84f510916a7dff2e);
$parcel$export(module.exports, "LONG_LABEL_LIMIT", () => $93cb8f2923e7410b$export$29ec59bc4d551a41);
$parcel$export(module.exports, "PARENT_SWITCHER_LOZENGE_TEST_ID", () => $93cb8f2923e7410b$export$680faa54dc6da799);
$parcel$export(module.exports, "PARENT_SWITCHER_LOADING_SPINNER_TEST_ID", () => $93cb8f2923e7410b$export$11e2185ebbcf7235);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_ACTIONS_TEST_ID", () => $93cb8f2923e7410b$export$2aa213773f04da8f);
$parcel$export(module.exports, "PARENT_SWITCHER_LABEL_TEST_ID", () => $93cb8f2923e7410b$export$bccc9d1ffeb474d3);
$parcel$export(module.exports, "PARENT_SWITCHER_ADD_PARENT_BUTTON_TEST_ID", () => $93cb8f2923e7410b$export$cc185b35b5eb5c92);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_REMOVE_PARENT_TEST_ID", () => $93cb8f2923e7410b$export$31b523708d2a8acb);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_VIEW_ALL_PARENTS_TEST_ID", () => $93cb8f2923e7410b$export$ac3a223c1d7cac9a);
$parcel$export(module.exports, "PARENT_SWITCHER_SUGGESTED_PARENTS_EMPTY_TEST_ID", () => $93cb8f2923e7410b$export$beb7535f4921d585);
$parcel$export(module.exports, "PARENT_SWITCHER_OPEN_ISSUE_CREATE_LINK_TEST_ID", () => $93cb8f2923e7410b$export$a019f396c99849dc);

var $7SCny = parcelRequire("7SCny");

var $3XO6n = parcelRequire("3XO6n");
const $93cb8f2923e7410b$export$b8b9d90f9e5bd72b = (0, $3XO6n.toPackageName)('jiraParentSwitcherField');
const $93cb8f2923e7410b$export$c2357bec51c5cf5b = (0, $7SCny.PURPLE);
const $93cb8f2923e7410b$export$eb8d067f048699c8 = 5;
const $93cb8f2923e7410b$export$2467bcf8f6d5c6b6 = 345;
const $93cb8f2923e7410b$export$84f510916a7dff2e = 180;
const $93cb8f2923e7410b$export$29ec59bc4d551a41 = 40;
const $93cb8f2923e7410b$export$680faa54dc6da799 = 'issue-field-parent-switcher.common.ui.epic-lozenge.epic-lozenge';
const $93cb8f2923e7410b$export$2082958b673f1f66 = 'issue-field-parent-switcher.common.ui.epic-tag.tag';
const $93cb8f2923e7410b$export$11813783c408cdf1 = `[data-testid="${$93cb8f2923e7410b$export$680faa54dc6da799}"]`;
const $93cb8f2923e7410b$export$11e2185ebbcf7235 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.loading-content.parent-switcher-suggested-parents-loading-spinner';
const $93cb8f2923e7410b$export$2aa213773f04da8f = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.actions';
const $93cb8f2923e7410b$export$bccc9d1ffeb474d3 = 'issue-field-parent.edit-view.options.';
const $93cb8f2923e7410b$export$cc185b35b5eb5c92 = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.add-parent-button';
const $93cb8f2923e7410b$export$31b523708d2a8acb = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.remove-parent';
const $93cb8f2923e7410b$export$986b8ef30a6bdca7 = `[data-testid="${$93cb8f2923e7410b$export$31b523708d2a8acb}"]`;
const $93cb8f2923e7410b$export$ac3a223c1d7cac9a = 'issue-field-parent-switcher.ui.edit.view-all-parents';
const $93cb8f2923e7410b$export$6494872dab91ac11 = `[data-testid="${$93cb8f2923e7410b$export$ac3a223c1d7cac9a}"]`;
const $93cb8f2923e7410b$export$beb7535f4921d585 = 'issue-field-parent-switcher.ui.edit.empty-container';
const $93cb8f2923e7410b$export$c0432cfce03a69a8 = `[data-testid="${$93cb8f2923e7410b$export$beb7535f4921d585}"]`;
const $93cb8f2923e7410b$export$a019f396c99849dc = 'issue-field-parent-switcher.ui.edit.suggested-parents-dropdown.empty-content.open-issue-create';

});



parcelRegister("7MspI", function(module, exports) {

$parcel$export(module.exports, "FieldSyncSummary", () => $f38acd997060fe0a$export$e5eb14bcd03ae390);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $2P7AF = parcelRequire("2P7AF");

var $4l4AL = parcelRequire("4l4AL");

var $67sX6 = parcelRequire("67sX6");

var $63LqY = parcelRequire("63LqY");
const $f38acd997060fe0a$export$e5eb14bcd03ae390 = ({ issue: { id: id, key: key, summary: summaryFromBoard }, projectKey: projectKey })=>{
    const setSummaryInBoard = (0, $67sX6.useBoardActionCreator)((issueId, summary)=>(0, $4l4AL.setSummary)(issueId, summary));
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const uniqueKey = isIPBoard && key === projectKey ? `${id}` : key;
    const [summaryFromIssueField, { setFieldValue: setSummaryInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: (0, $5fc53.SUMMARY_TYPE)
    });
    const summaryFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        summaryFromBoard
    ]);
    const summaryFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        summaryFromIssueField
    ]);
    const storesNeedToSync = summaryFromBoard !== summaryFromIssueField;
    // SUMMARY SYNC: BOARD -> EXTRACTED FIELDS
    (0, $5uXOq.useEffect)(()=>{
        if (summaryFromBoardChanged && storesNeedToSync) setSummaryInExtractedFields(uniqueKey, (0, $5fc53.SUMMARY_TYPE), summaryFromBoard);
    }, [
        uniqueKey,
        setSummaryInExtractedFields,
        storesNeedToSync,
        summaryFromBoard,
        summaryFromBoardChanged
    ]);
    // SUMMARY SYNC: EXTRACTED FIELDS -> BOARD
    (0, $5uXOq.useEffect)(()=>{
        if (!summaryFromBoardChanged && summaryFromIssueFieldChanged && storesNeedToSync) setSummaryInBoard(id, summaryFromIssueField);
    }, [
        id,
        setSummaryInBoard,
        storesNeedToSync,
        summaryFromBoardChanged,
        summaryFromIssueField,
        summaryFromIssueFieldChanged
    ]);
    return null;
};

});

parcelRegister("iKnzg", function(module, exports) {

$parcel$export(module.exports, "FieldSyncPriority", () => $d28a593bd36ca2a7$export$32a891753e1d9d91);

var $5uXOq = parcelRequire("5uXOq");

var $3fAi8 = parcelRequire("3fAi8");

var $5fc53 = parcelRequire("5fc53");

var $2P7AF = parcelRequire("2P7AF");

var $bLC9D = parcelRequire("bLC9D");

var $67sX6 = parcelRequire("67sX6");

var $63LqY = parcelRequire("63LqY");
const $d28a593bd36ca2a7$export$32a891753e1d9d91 = ({ issue: { id: id, key: key, priority: issuePriority }, projectKey: projectKey })=>{
    const setPriorityInBoard = (0, $67sX6.useBoardActionCreator)((issueId, priority)=>(0, $bLC9D.setPriority)(issueId, priority));
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const uniqueKey = isIPBoard && key === projectKey ? `${id}` : key;
    const [priorityFromIssueField, { setFieldValue: setPriorityInExtractedFields }] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: (0, $5fc53.PRIORITY_TYPE)
    });
    const priorityFromBoard = issuePriority ?? null;
    const priorityFromBoardChanged = (0, $2P7AF.useDiffCheck)([
        priorityFromBoard?.id
    ]);
    const priorityFromIssueFieldChanged = (0, $2P7AF.useDiffCheck)([
        priorityFromIssueField?.id
    ]);
    const storesNeedToSync = priorityFromBoard !== priorityFromIssueField;
    // PRIORITY SYNC: BOARD -> EXTRACTED FIELDS
    (0, $5uXOq.useEffect)(()=>{
        if (priorityFromBoardChanged && storesNeedToSync) setPriorityInExtractedFields(uniqueKey, (0, $5fc53.PRIORITY_TYPE), priorityFromBoard);
    }, [
        uniqueKey,
        setPriorityInExtractedFields,
        storesNeedToSync,
        priorityFromBoard,
        priorityFromBoardChanged
    ]);
    // PRIORITY SYNC: EXTRACTED FIELDS -> BOARD
    (0, $5uXOq.useEffect)(()=>{
        if (!priorityFromBoardChanged && priorityFromIssueFieldChanged && storesNeedToSync) setPriorityInBoard(id, priorityFromIssueField);
    }, [
        id,
        setPriorityInBoard,
        storesNeedToSync,
        priorityFromBoardChanged,
        priorityFromIssueField,
        priorityFromIssueFieldChanged
    ]);
    return null;
};

});



parcelRegister("j0iXE", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d7abc75528822b9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $cW3pH = parcelRequire("cW3pH");

var $67sX6 = parcelRequire("67sX6");
const $5d7abc75528822b9$var$BoardAPI = ({ boardApiRef: boardApiRef })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const boardApi = (0, $5uXOq.useMemo)(()=>({
            refresh: ()=>dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$17d7097367e94100)))
        }), [
        dispatch
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line no-param-reassign
        boardApiRef.current = boardApi;
    }, [
        boardApiRef,
        boardApi
    ]);
    return null;
};
var $5d7abc75528822b9$export$2e2bcd8739ae039 = $5d7abc75528822b9$var$BoardAPI;

});

parcelRegister("gru50", function(module, exports) {

$parcel$export(module.exports, "FiltersStorage", () => $1a2ece435715d48f$export$311c7d3073893ae);

var $5uXOq = parcelRequire("5uXOq");

var $wKznQ = parcelRequire("wKznQ");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $63LqY = parcelRequire("63LqY");
const $1a2ece435715d48f$export$311c7d3073893ae = ()=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const filters = (0, $67sX6.useBoardSelector)((state)=>state.ui.workFilters?.values);
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBoard) (0, $wKznQ.setCachedFilters)('board', boardId, filters);
    }, [
        boardId,
        filters,
        isCMPBoard
    ]);
    return null;
};

});

parcelRegister("a9mbK", function(module, exports) {

$parcel$export(module.exports, "default", () => $84663b95f9134fad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $daJ0i = parcelRequire("daJ0i");

var $8lxl7 = parcelRequire("8lxl7");

var $hZHze = parcelRequire("hZHze");

var $5rFbt = parcelRequire("5rFbt");


var $bC2fB = parcelRequire("bC2fB");

var $dFfIn = parcelRequire("dFfIn");

var $kxZPA = parcelRequire("kxZPA");

var $j4MnI = parcelRequire("j4MnI");

var $fqLDH = parcelRequire("fqLDH");

var $d2i8f = parcelRequire("d2i8f");

var $6g14V = parcelRequire("6g14V");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $cPGP0 = parcelRequire("cPGP0");

var $5mTgl = parcelRequire("5mTgl");

var $gfv3x = parcelRequire("gfv3x");

var $gGhzv = parcelRequire("gGhzv");

var $dHKcT = parcelRequire("dHKcT");

var $hOou0 = parcelRequire("hOou0");

var $gdLuI = parcelRequire("gdLuI");

var $lkgHI = parcelRequire("lkgHI");

var $7CZZJ = parcelRequire("7CZZJ");

var $eqAt8 = parcelRequire("eqAt8");

var $jFKZt = parcelRequire("jFKZt");

var $i9WnN = parcelRequire("i9WnN");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $84663b95f9134fad$var$AfterPaintModals = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("ctiKF")), {
    ssr: false,
    moduleId: "./src/packages/software/board/src/view/modals/index.tsx"
});
const $84663b95f9134fad$var$incrementPlanningBoardAnalyticsAttributes = (state)=>{
    const issuesByColumn = (0, $d2i8f.getOrderedIssuesByColumn)(state);
    const totalUnplannedIssues = issuesByColumn[0, $5rFbt.UNSCHEDULED_COLUMN_ID] ? Object.keys(issuesByColumn[0, $5rFbt.UNSCHEDULED_COLUMN_ID]).length : 0;
    const boardScopeFilterType = (0, $67Z81.getBoardScopeFilterType)(state);
    return {
        teamsWithLinkedSprints: Object.keys((0, $cPGP0.getSprintCapacityInfo)(state)).length,
        appliedFilters: (0, $5mTgl.getWorkFilters)(state),
        boardScopeFilterType: boardScopeFilterType,
        totalIssues: Object.keys((0, $67Z81.getIssues)(state)).length,
        totalUnplannedIssues: totalUnplannedIssues,
        totalDependencies: Object.keys((0, $5mTgl.getIssuesEntriesWithIssueLinks)(state)).length,
        scheduledDependencies: (0, $5mTgl.getIssuesWithIssueLinksInBoardIds)(state).length,
        showOffTrackDependencies: (0, $j4MnI.getShowOfftrackDependencyLines)(state),
        individualDependenciesSelected: (0, $j4MnI.getIssueIdsToShowDependencies)(state).length
    };
};
// define separate analytics source and subject for JSW board and Plan program board (aka increment planning board)
const $84663b95f9134fad$var$BoardAnalyticsHOC = ()=>(WrappedComponent)=>(props)=>{
            const analyticsSource = props.isIncrementPlanningBoard ? 'programBoard' : 'board';
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
                data: {
                    actionSubject: analyticsSource,
                    source: `${analyticsSource}${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props));
        };
const $84663b95f9134fad$var$App = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $bC2fB.connect)((state, ownProps)=>({
        isCacheHit: ownProps.isCacheHit,
        customFiltersQueryRef: ownProps.customFiltersQueryRef,
        boardFilterRefinementQueryRef: ownProps.boardFilterRefinementQueryRef,
        Header: $7CZZJ.default,
        Modals: $84663b95f9134fad$var$AfterPaintModals,
        Flags: $gdLuI.default,
        Board: (0, $gfv3x.default),
        ViewTracker: $hZHze.default,
        DocumentTitle: $dHKcT.default,
        PrefetchIssues: (0, $eqAt8.default),
        DetailView: $gGhzv.default,
        Realtime: $jFKZt.default,
        AddBoardToHistory: $dFfIn.default,
        GlobalSearchTracker: $lkgHI.default,
        isInsightsPanelOpen: (0, $6g14V.getInsightsPanel)(state),
        baseUrl: (0, $67Z81.contextPathSelector)(state),
        projectKey: (0, $67Z81.projectKeySelector)(state),
        estimationStatistic: (0, $5mTgl.getEstimationStatistic)(state),
        currentUserAccountId: (0, $36pz7.getCurrentUserAccountId)(state),
        issueLimitExceeded: (0, $67Z81.getIssueLimitExceeded)(state),
        savedFilterId: (0, $67Z81.getSavedFilterId)(state),
        selectedSprintsOrAllSprints: (0, $ebHh7.getSelectedOrAllSprintsSelector)(state),
        externalActionForIssueView: (0, $fqLDH.getExternalActionForModal)(state)
    }), {}), $84663b95f9134fad$var$BoardAnalyticsHOC(), (0, $8lxl7.default)((state)=>({
        containerType: 'project',
        containerId: String((0, $67Z81.projectIdSelector)(state)),
        attributes: {
            projectId: (0, $67Z81.projectIdSelector)(state),
            boardId: (0, $67Z81.rapidViewIdSelector)(state),
            isIssueDetailVisible: (0, $fqLDH.isIssueModalShowingSelector)(state),
            isUIF: true,
            isClassic: (0, $67Z81.getIsCMPBoard)(state),
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            isInactiveTab: document.hidden,
            boardType: (0, $67Z81.getBoardTypeForAnalytics)(state),
            projectType: (0, $67Z81.projectTypeSelector)(state),
            swimlaneMode: (0, $45cXl.getSwimlaneMode)(state),
            ...(0, $67Z81.getIsIncrementPlanningBoard)(state) ? $84663b95f9134fad$var$incrementPlanningBoardAnalyticsAttributes(state) : {}
        }
    })))((0, $i9WnN.default));
var $84663b95f9134fad$export$2e2bcd8739ae039 = (0, $hOou0.withViewExperienceTracker)($84663b95f9134fad$var$App);

});
parcelRegister("8lxl7", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3768e8b105140d5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $daJ0i = parcelRequire("daJ0i");

var $bC2fB = parcelRequire("bC2fB");

var $cAj1I = parcelRequire("cAj1I");

var $i4iBk = parcelRequire("i4iBk");
const $d3768e8b105140d5$var$ReduxAnalyticsData = (// eslint-disable-next-line @typescript-eslint/no-explicit-any
mapStateToAnalytics, connectOptions = {})=>(WrappedComponent)=>{
        // eslint-disable-next-line jira/react/no-class-components
        class ComponentWrappedInAnalytics extends (0, $5uXOq.Component) {
            static{
                this.displayName = `ReduxAnalyticsData(${WrappedComponent.displayName || WrappedComponent.name})`;
            }
            static{
                this.defaultProps = {
                    analyticsContext: {}
                };
            }
            render() {
                const { analyticsContext: analyticsContext, ...componentProps } = this.props;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
                    data: analyticsContext
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, componentProps));
            }
        }
        const mapStateToPropsFactory = ()=>{
            const analyticsContextSelectorInstance = (0, $8QpSo.default)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
            (state, ownProps)=>(0, $i4iBk.default)(mapStateToAnalytics(state, ownProps)));
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            return (state, ownProps)=>({
                    analyticsContext: analyticsContextSelectorInstance(state, ownProps)
                });
        };
        return (0, $bC2fB.connect)(mapStateToPropsFactory, ()=>({}), null, {
            // to prevent connected component from unnecessary re-render
            areStatePropsEqual: (nextProps, prevProps)=>{
                const { attributes: prevAttributes, ...prevFields } = prevProps.analyticsContext;
                const { attributes: nextAttributes, ...nextFields } = nextProps.analyticsContext;
                return (0, $cAj1I.default)(prevAttributes, nextAttributes) && (0, $cAj1I.default)(prevFields, nextFields);
            },
            ...connectOptions
        })(ComponentWrappedInAnalytics);
    };
var $d3768e8b105140d5$export$2e2bcd8739ae039 = $d3768e8b105140d5$var$ReduxAnalyticsData;

});
parcelRegister("cAj1I", function(module, exports) {

$parcel$export(module.exports, "default", () => $95d580e76a13b783$export$2e2bcd8739ae039);
const $95d580e76a13b783$var$isArrayEqual = (array1 = [], array2 = [])=>{
    if (array1 === array2) return true;
    // check one level deep
    return array1.length === array2.length && array1.every((item, index)=>item === array2[index]);
};
var // one level check to see if object references are equal
// eslint-disable-next-line @typescript-eslint/no-explicit-any, jira/import/no-anonymous-default-export
$95d580e76a13b783$export$2e2bcd8739ae039 = (obj1, obj2)=>{
    if (obj1 === obj2) return true;
    if (!obj1 || !obj2) return false;
    const item1Keys = Object.keys(obj1).sort();
    const item2Keys = Object.keys(obj2).sort();
    // are keys equal?
    // @ts-expect-error - TS2345 - Argument of type 'string[]' is not assignable to parameter of type 'never[]'.
    if (!$95d580e76a13b783$var$isArrayEqual(item1Keys, item2Keys)) return false;
    // are the values equal?
    const areValuesEqual = item2Keys.every((key)=>{
        const value = obj1[key];
        const nextValue = obj2[key];
        if (value === nextValue) return true;
        // @ts-expect-error - TS2345 - Argument of type 'any[]' is not assignable to parameter of type 'never[]'.
        return Array.isArray(nextValue) && Array.isArray(value) && $95d580e76a13b783$var$isArrayEqual(value, nextValue);
    });
    return areValuesEqual;
};

});


// SCREENS
const $4d5e0871c06cee03$export$f636b5b56f1d624a = 'Screen';
const $4d5e0871c06cee03$export$9d2de6eebf7462b5 = 'Drawer';
const $4d5e0871c06cee03$export$1171103ea9083ffa = 'Modal';
const $4d5e0871c06cee03$export$cae2783c9279926 = 'InlineDialog';
const $4d5e0871c06cee03$export$d1123261ca8831d2 = 'Dropdown';
const $4d5e0871c06cee03$export$238d30785c4bca84 = 'Banner';
const $4d5e0871c06cee03$export$a1562d08625f5d7e = 'UI';
const $4d5e0871c06cee03$export$947dac6c72b26f81 = 'TRACK';
const $4d5e0871c06cee03$export$f1d537d508d2945a = 'SCREEN';
const $4d5e0871c06cee03$export$12346a674644c156 = 'OPERATIONAL';

parcelRegister("dFfIn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c54faa42ed76e90b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $01Rn4 = parcelRequire("01Rn4");

var $cACkL = parcelRequire("cACkL");
const $c54faa42ed76e90b$var$AddBoardToHistory = ({ baseUrl: baseUrl, boardId: boardId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $01Rn4.default), {
        op: ()=>(0, $cACkL.addBoardToHistory)(baseUrl, boardId)
    });
var $c54faa42ed76e90b$export$2e2bcd8739ae039 = $c54faa42ed76e90b$var$AddBoardToHistory;

});
parcelRegister("cACkL", function(module, exports) {

$parcel$export(module.exports, "addBoardToHistory", () => $350fcc2e90657d19$export$eef897770c591084);

var $2YZCu = parcelRequire("2YZCu");

var $eusud = parcelRequire("eusud");
const $350fcc2e90657d19$export$eef897770c591084 = (baseUrl, boardId)=>(0, $eusud.performPostRequest)(`${baseUrl}/rest/greenhopper/1.0/rapidview/addtohistory`, {
        body: JSON.stringify({
            rapidViewId: boardId
        })
    }).catch((e)=>{
        (0, $2YZCu.default).safeErrorWithoutCustomerData('software.view-history.src.services', 'Cannot add board to recent history', e);
    });

});


parcelRegister("j4MnI", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksForDependenciesFlyout", () => $00394967ab8d168e$export$1ba4fd422cd0d38a);
$parcel$export(module.exports, "getIssueLinksForDependenciesModal", () => $00394967ab8d168e$export$e1d999e347b7a491);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $00394967ab8d168e$export$32c01395d25dfdcc);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $00394967ab8d168e$export$67e6bba1326e537a);
$parcel$export(module.exports, "isDependencyVisualisationVisible", () => $00394967ab8d168e$export$f0b1353512cd0c8);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");

var $4Xk2W = parcelRequire("4Xk2W");

var $gULOk = parcelRequire("gULOk");

var $bkUsp = parcelRequire("bkUsp");

var $67Z81 = parcelRequire("67Z81");
const $00394967ab8d168e$export$5c81e28e234f06c2 = (issue, issueLinkId, { name: name, category: category }, offtrackLabel)=>({
        key: issue.key,
        issueTypeName: issue.typeName,
        issueTypeIconUrl: issue.typeUrl,
        text: issue.summary,
        statusCategoryId: `${(0, $gULOk.categoryIdForStatusCategory)(category)}`,
        statusName: name,
        issueLinkId: issueLinkId,
        offtrackLabel: offtrackLabel
    });
const $00394967ab8d168e$export$1ba4fd422cd0d38a = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getStatuses),
    (0, $67Z81.getIssueLinkTypes),
    (0, $67Z81.getIssues)
], (statuses, issueLinkTypes, issues)=>(issueId, offtrackLabel)=>{
        // todo - currently showing basic count for external issues (not in the board and not in the plan),
        // need to decided to how to handle the external issues https://hello.atlassian.net/wiki/spaces/AG/pages/3299676769/2024-01-30+IP+Weekly+Sync+Meeting+Notes
        const issue = issues[issueId];
        const issueLinks = issue?.issueLinks || [];
        const issueLinkTypesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issueLinkTypes, 'id');
        const internalAndExternalIssueLinks = issueLinks.reduce((acc, issueLink)=>{
            const { id: id, sourceId: sourceId, destinationId: destinationId, linkTypeId: linkTypeId, isOfftrack: isOfftrack } = issueLink;
            // filter out the external issue
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[sourceId]) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[destinationId])) {
                acc.external += 1;
                return acc;
            }
            const direction = `${destinationId}` === `${issueId}` ? 'inward' : 'outward';
            const resultIssue = direction === 'inward' ? issues[sourceId] : issues[destinationId];
            const resultIssueStatus = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(resultIssue.statusId) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(statuses[resultIssue.statusId]) ? {
                name: '',
                category: (0, $gULOk.UNDEFINED)
            } : statuses[resultIssue.statusId];
            const resultIssueLink = $00394967ab8d168e$export$5c81e28e234f06c2(resultIssue, id, resultIssueStatus, isOfftrack ? offtrackLabel : undefined);
            const group = issueLinkTypesById[`${linkTypeId}`][direction];
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(acc.internal[group])) acc.internal[group] = [
                resultIssueLink
            ];
            else acc.internal[group].push(resultIssueLink);
            return acc;
        }, {
            internal: {},
            external: 0
        });
        return internalAndExternalIssueLinks;
    });
const $00394967ab8d168e$export$e1d999e347b7a491 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueLinkTypes),
    (0, $67Z81.getIssues)
], (issueLinkTypes, issues)=>(issueId)=>{
        const issue = issues[issueId];
        const issueLinks = issue?.issueLinks || [];
        const issueLinkTypesById = (0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(issueLinkTypes, 'id');
        const issueLinksByTypeAndDirection = issueLinks.filter(({ sourceId: sourceId, destinationId: destinationId })=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[sourceId]) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issues[destinationId])).reduce((acc, issueLink)=>{
            const { sourceId: sourceId, destinationId: destinationId, linkTypeId: linkTypeId } = issueLink;
            const { isOutward: isOutward } = issueLinkTypesById[linkTypeId] ?? {};
            const direction = isOutward && sourceId === issueId || !isOutward && destinationId === issueId ? (0, $bkUsp.OUTWARD_LINK_DIRECTION) : (0, $bkUsp.INWARD_LINK_DIRECTION);
            const dependencyId = sourceId === issueId ? destinationId : sourceId;
            const updatedAcc = (0, $7uUwQ.setIn)(acc, [
                linkTypeId,
                direction
            ], [
                ...(0, $7uUwQ.getIn)(acc, [
                    linkTypeId,
                    direction
                ]) ?? [],
                dependencyId
            ]);
            return updatedAcc;
        }, {});
        return issueLinksByTypeAndDirection;
    });
const $00394967ab8d168e$export$32c01395d25dfdcc = (state)=>state.ui.board.displayOptions.showOfftrackDependencyLines;
const $00394967ab8d168e$export$67e6bba1326e537a = (state)=>state.ui.board.displayOptions.issueIdsToShowDependencies;
const $00394967ab8d168e$export$f0b1353512cd0c8 = (state)=>{
    return $00394967ab8d168e$export$32c01395d25dfdcc(state) || $00394967ab8d168e$export$67e6bba1326e537a(state).length > 0;
};

});
parcelRegister("bkUsp", function(module, exports) {

$parcel$export(module.exports, "INWARD_LINK_DIRECTION", () => $1e4a31a537751af2$export$b5e2b68b0fa7f1c8);
$parcel$export(module.exports, "OUTWARD_LINK_DIRECTION", () => $1e4a31a537751af2$export$5dec99d71ec794ba);
$parcel$export(module.exports, "BOTH_LINK_DIRECTION", () => $1e4a31a537751af2$export$6cdcf74878b11d34);
$parcel$export(module.exports, "IssueLinkDirectionTypes", () => $1e4a31a537751af2$export$4b7bcc27238c61b9);
const $1e4a31a537751af2$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $1e4a31a537751af2$export$5dec99d71ec794ba = 'OUTWARD';
const $1e4a31a537751af2$export$6cdcf74878b11d34 = 'BOTH';
const $1e4a31a537751af2$export$4b7bcc27238c61b9 = {
    [$1e4a31a537751af2$export$b5e2b68b0fa7f1c8]: $1e4a31a537751af2$export$b5e2b68b0fa7f1c8,
    [$1e4a31a537751af2$export$5dec99d71ec794ba]: $1e4a31a537751af2$export$5dec99d71ec794ba,
    [$1e4a31a537751af2$export$6cdcf74878b11d34]: $1e4a31a537751af2$export$6cdcf74878b11d34
};

});


parcelRegister("6g14V", function(module, exports) {

$parcel$export(module.exports, "getInsightsPanel", () => $584bed1ec95aed7d$export$806d34b644f1954d);
$parcel$export(module.exports, "getViewSettingsPanel", () => $584bed1ec95aed7d$export$a0b20e22a1f77091);

const $584bed1ec95aed7d$export$be078297eeb6e8a2 = (state)=>state.ui.panels;
const $584bed1ec95aed7d$export$806d34b644f1954d = (state)=>state.ui.panels?.[0, $8cd646738f5ee7ac$export$29d7f2210b16d662] || false;
const $584bed1ec95aed7d$export$a0b20e22a1f77091 = (state)=>state.ui.panels?.[0, $8cd646738f5ee7ac$export$ba1da943283b9900] || false;

});

parcelRegister("gfv3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c40f3b7b1ffd9f0$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $jzjy1 = parcelRequire("jzjy1");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");

var $2vSU6 = parcelRequire("2vSU6");

var $2xFXk = parcelRequire("2xFXk");


var $iuuJH = parcelRequire("iuuJH");

var $cTkW0 = parcelRequire("cTkW0");

var $cW3pH = parcelRequire("cW3pH");

var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $kc6Ry = parcelRequire("kc6Ry");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $gHXMJ = parcelRequire("gHXMJ");

var $aYlA2 = parcelRequire("aYlA2");

var $luiFO = parcelRequire("luiFO");

var $3nIju = parcelRequire("3nIju");

var $d6mgg = parcelRequire("d6mgg");

var $4z5Te = parcelRequire("4z5Te");

var $8ydSK = parcelRequire("8ydSK");

var $22mIG = parcelRequire("22mIG");

var $3nXC3 = parcelRequire("3nXC3");
const $7c40f3b7b1ffd9f0$export$c31df4bd766f9c35 = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
    const boardSessionId = (0, $67Z81.sessionIdSelector)(state);
    const isNonCriticalWorksetLoaded = (0, $5mTgl.isBoardConfigLoaded)(state);
    const locale = (0, $67Z81.getLocale)(state);
    const preventInlineEditing = (0, $k8auG.getPreventInlineEditing)(state);
    const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    const isUnscheduledColumnVisible = isIncrementPlanningBoard ? (0, $5mTgl.getIsUnscheduledColumnVisible)(state) : undefined;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    // This hides the ColumnConfiguration button for CMP
    const isColumnConfigurationButtonEnabled = !isCMPBoard;
    const isJSWBoard = (0, $67Z81.projectTypeSelector)(state) === (0, $2vSU6.SOFTWARE_PROJECT);
    const hasAssigneeFilter = !!(0, $5mTgl.getAssigneeFilter)(state);
    return {
        isColumnCreateAllowed: permissions[0, $e525e6c25695c9df$export$c5d82f9af027c432] || false,
        isInlineColumnEditEnabled: (0, $5mTgl.isInlineColumnEditEnabled)(state),
        isFlexibleColumns: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS),
        hasSwimlanes: hasSwimlanes,
        isNonCriticalWorksetLoaded: isNonCriticalWorksetLoaded,
        boardSessionId: boardSessionId,
        locale: locale,
        preventInlineEditing: preventInlineEditing,
        shouldRenderSwimlane: (0, $k8auG.shouldRenderSwimlaneSelector)(state),
        isSprintsEnabled: (0, $ebHh7.isSprintsEnabled)(state),
        isIncrementPlanningBoard: isIncrementPlanningBoard,
        isColumnConfigurationButtonEnabled: isColumnConfigurationButtonEnabled,
        isUnscheduledColumnVisible: isUnscheduledColumnVisible,
        isJSWBoard: isJSWBoard,
        hasAssigneeFilter: hasAssigneeFilter,
        isFilterRefinementEnabled: (0, $5mTgl.isFilterRefinementEnabled)(state)
    };
};
const $7c40f3b7b1ffd9f0$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $7c40f3b7b1ffd9f0$var$onBoardNonCriticalViewedFactory = (0, $8QpSo.default)((dispatch)=>(analyticsEvent)=>// @ts-expect-error - Argument of type 'BoardNonCriticalViewAction' is not assignable to parameter of type 'Action'.
        dispatch((0, $cW3pH.boardNonCriticalView)(analyticsEvent)));
const $7c40f3b7b1ffd9f0$var$onPreventInlineEditingFactory = (0, $8QpSo.default)((dispatch)=>(shouldPreventInlineEditing)=>dispatch((0, $cTkW0.preventInlineEditingAction)(shouldPreventInlineEditing)));
const $7c40f3b7b1ffd9f0$var$mergeProps = (stateProps, dispatchProps, ownProps)=>{
    const { isCacheHit: isCacheHit } = ownProps;
    return {
        ...ownProps,
        ...stateProps,
        isCacheHit: isCacheHit,
        Board: $3nIju.default,
        BacklogIssueMoveDialog: $gHXMJ.default,
        KeyboardShortcuts: $d6mgg.default,
        ColumnCreate: $luiFO.default,
        ColumnConfigurationButton: $aYlA2.default,
        BoardMinimap: $4z5Te.default,
        SubmitApdex: $22mIG.default,
        ScrollObserver: $8ydSK.default,
        onBoardNonCriticalViewed: $7c40f3b7b1ffd9f0$var$onBoardNonCriticalViewedFactory(dispatchProps.dispatch),
        onPreventInlineEditing: $7c40f3b7b1ffd9f0$var$onPreventInlineEditingFactory(dispatchProps.dispatch)
    };
};
const $7c40f3b7b1ffd9f0$var$connector = (0, $bC2fB.connect)($7c40f3b7b1ffd9f0$export$c31df4bd766f9c35, $7c40f3b7b1ffd9f0$export$9e6a17cf56877796, $7c40f3b7b1ffd9f0$var$mergeProps);
var $7c40f3b7b1ffd9f0$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('board', {
    onBoardNonCriticalViewed: 'viewed'
}), $7c40f3b7b1ffd9f0$var$connector, (0, $jzjy1.AnalyticsSubject)('boardNonCritical'))((0, $3nXC3.default));

});
parcelRegister("gHXMJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0c05f281d0d42b3$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $doOdQ = parcelRequire("doOdQ");

var $absT5 = parcelRequire("absT5");

var $gDIL3 = parcelRequire("gDIL3");
var $f0c05f281d0d42b3$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        isOpen: (0, $absT5.isDialogVisibleSelector)(state)
    }), {
    onCancel: (0, $doOdQ.backlogIssueMoveCancel),
    onConfirm: (0, $doOdQ.backlogIssueMoveConfirm)
})((0, $gDIL3.default));

});
parcelRegister("gDIL3", function(module, exports) {

$parcel$export(module.exports, "default", () => $4835bb9ec70dd0b9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $eHJxW = parcelRequire("eHJxW");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $3hUhs = parcelRequire("3hUhs");

var $j3NDp = parcelRequire("j3NDp");
class $4835bb9ec70dd0b9$export$3ef6f240d074403 extends (0, $5uXOq.Component) {
    renderContent() {
        const { intl: intl } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4835bb9ec70dd0b9$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "xsmall",
            as: "h5"
        }, intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $j3NDp.default).titleIssueTermRefresh : (0, $j3NDp.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4835bb9ec70dd0b9$var$DescriptionStyle, null, intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $j3NDp.default).descriptionIssueTermRefresh : (0, $j3NDp.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: this.onConfirm,
            appearance: "primary"
        }, intl.formatMessage((0, $j3NDp.default).confirm)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            onClick: this.onCancel,
            appearance: "subtle"
        }, intl.formatMessage((0, $j3NDp.default).cancel))));
    }
    render() {
        return this.props.isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4835bb9ec70dd0b9$var$StickyPosition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            messageId: "software-board.board-container.board.backlog-issue-move-dialog.inline-dialog",
            messageType: "transactional",
            content: this.renderContent(),
            isOpen: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null))) : null;
    }
    constructor(...args){
        super(...args), // Strip arguments from event handlers
        this.onConfirm = ()=>this.props.onConfirm(), this.onCancel = ()=>this.props.onCancel();
    }
}
var $4835bb9ec70dd0b9$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($4835bb9ec70dd0b9$export$3ef6f240d074403);
const $4835bb9ec70dd0b9$var$columnDialogZindex = (0, $3hUhs.sharedStyles).zIndex.stickyHeaders + 1; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4835bb9ec70dd0b9$var$StickyPosition = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1cl78iz": (0, $lD23V.default)((0, $3hUhs.sharedStyles).columnWithMarginWidth / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154ipxbi _1ltvlz7i _w4h21if8 _z2g7pxbi _7bfnqfx8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4835bb9ec70dd0b9$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _o5724jg8 _1bsb13s2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4835bb9ec70dd0b9$var$DescriptionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eHJxW", function(module, exports) {

$parcel$export(module.exports, "JiraInlineDialog", () => $51c10262cffee11f$export$7ab52478615504b3);

var $5uXOq = parcelRequire("5uXOq");

var $ctg8C = parcelRequire("ctg8C");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $5uVz7 = parcelRequire("5uVz7");
const $51c10262cffee11f$export$7ab52478615504b3 = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uVz7.ChoreographerInlineDialog), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), rest);
};

});
parcelRegister("5uVz7", function(module, exports) {

$parcel$export(module.exports, "ChoreographerInlineDialog", () => $aa901de21f3fc2ba$export$44a404f218b0e66e);

var $ctg8C = parcelRequire("ctg8C");

var $fG5AJ = parcelRequire("fG5AJ");
const $aa901de21f3fc2ba$export$44a404f218b0e66e = (0, $fG5AJ.withChoreographedToggle)((0, $ctg8C.default), 'isOpen', 'content');

});


parcelRegister("3hUhs", function(module, exports) {

$parcel$export(module.exports, "sharedStyles", () => $3c6d8d54a7e2976d$export$c95b305c73224681);

var $645AZ = parcelRequire("645AZ");







































const $3c6d8d54a7e2976d$export$c95b305c73224681 = {
    columnWithMarginWidth: $645AZ.columnWithMarginWidth,
    zIndex: $645AZ.zIndex,
    columnFixedWidth: $645AZ.columnFixedWidth,
    columnMinWidth: $645AZ.columnMinWidth,
    columnHeaderHeight: $645AZ.columnHeaderHeight
};

});

parcelRegister("j3NDp", function(module, exports) {

$parcel$export(module.exports, "default", () => $e9282217a70d57e3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e9282217a70d57e3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.title",
        "defaultMessage": "Move your issues?"
    },
    description: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.description",
        "defaultMessage": "We can move your first column's issues straight into your new backlog."
    },
    confirm: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.confirm",
        "defaultMessage": "Yes, move"
    },
    cancel: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.cancel",
        "defaultMessage": "No thanks"
    },
    titleIssueTermRefresh: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.title-issue-term-refresh",
        "defaultMessage": "Move your work items?"
    },
    descriptionIssueTermRefresh: {
        "id": "software.main.board-container.board.backlog-issue-move-dialog.description-issue-term-refresh",
        "defaultMessage": "We can move your first column's work items straight into your new backlog."
    }
});

});



parcelRegister("aYlA2", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0cf70f53c95fbad$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $gKiL2 = parcelRequire("gKiL2");
const $b0cf70f53c95fbad$var$mapStateToProps = (state)=>({
        url: (0, $eph8m.getColumnStatusMappingUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state), (0, $67Z81.getIsCMPBoard)(state)),
        isKanbanBoard: !(0, $ebHh7.isSprintsEnabled)(state),
        isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
    });
const $b0cf70f53c95fbad$var$ConnectedColumnConfiguration = (0, $bC2fB.connect)($b0cf70f53c95fbad$var$mapStateToProps, {})((0, $gKiL2.default));
var $b0cf70f53c95fbad$export$2e2bcd8739ae039 = $b0cf70f53c95fbad$var$ConnectedColumnConfiguration;

});
parcelRegister("gKiL2", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d2b154f39b85b4f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $cE2Qr = parcelRequire("cE2Qr");

var $geikO = parcelRequire("geikO");

var $8zOmE = parcelRequire("8zOmE");

var $lvgJK = parcelRequire("lvgJK");

var $3t5QD = parcelRequire("3t5QD");

var $4Z21W = parcelRequire("4Z21W");

var $lVJAU = parcelRequire("lVJAU");
const $9d2b154f39b85b4f$var$ColumnConfiguration = ({ url: url, isKanbanBoard: isKanbanBoard, isCMPBoard: isCMPBoard })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clickColumnConfigurationButton');
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        isCMPBoard ? window.open(url, '_self') : push(url);
    }, [
        push,
        url,
        isCMPBoard
    ]);
    const AsyncNudgeComponent = isKanbanBoard ? (0, $4Z21W.BoardCreateColumnKanbanTourNudgeAsync) : (0, $lvgJK.BoardCreateColumnButtonWrapperNudgeAsync);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        conditionsToApplyWrapper: !isOnboardingDismissed,
        Wrapper: AsyncNudgeComponent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $geikO.default), {
        onClick: onClick
    }));
};
var $9d2b154f39b85b4f$export$2e2bcd8739ae039 = $9d2b154f39b85b4f$var$ColumnConfiguration;

});
parcelRegister("geikO", function(module, exports) {

$parcel$export(module.exports, "default", () => $04d788fd7adea69a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $epOG5 = parcelRequire("epOG5");

var $lzUP9 = parcelRequire("lzUP9");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hCCtP = parcelRequire("hCCtP");

var $a2e2Q = parcelRequire("a2e2Q");

var $dTEu0 = parcelRequire("dTEu0");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$04d788fd7adea69a$export$2e2bcd8739ae039 = ({ onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04d788fd7adea69a$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04d788fd7adea69a$var$Sticky, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $dTEu0.default).description)
    }, isSoftwareFullTheming ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
        interactionName: "column-configuration-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($epOG5))),
        label: formatMessage((0, $dTEu0.default).description),
        onClick: onClick,
        testId: "platform-board-kit.ui.column.column-configuration.button",
        isTooltipDisabled: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "platform-board-kit.ui.column.column-configuration.button",
        "aria-label": formatMessage((0, $dTEu0.default).description),
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($epOG5))), {
            label: formatMessage((0, $dTEu0.default).description),
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lzUP9))),
            LEGACY_size: "medium",
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: onClick
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04d788fd7adea69a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04d788fd7adea69a$var$Sticky = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _154iidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hCCtP", function(module, exports) {

$parcel$export(module.exports, "ThemedButtonWrapper", () => $34060b1367424582$export$269674ad0c604d30);
$parcel$export(module.exports, "ThemedButtonNew", () => $34060b1367424582$export$15536ee0f9ee7c0b);
$parcel$export(module.exports, "ThemedIconButton", () => $34060b1367424582$export$d9c2d067feb61447);
$parcel$export(module.exports, "ThemedLinkButton", () => $34060b1367424582$export$b0b5aeed52623827);
$parcel$export(module.exports, "ThemedLinkIconButton", () => $34060b1367424582$export$a1ab08e79d264ec8);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $6cG4N = parcelRequire("6cG4N");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");
const $34060b1367424582$export$269674ad0c604d30 = ({ children: children })=>(0, $lmBAt.getIsSoftwareThemingEnabled)() || (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $34060b1367424582$var$overrideStyles
    }, children) : children;
const $34060b1367424582$export$15536ee0f9ee7c0b = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$d9c2d067feb61447 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$b0b5aeed52623827 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$export$a1ab08e79d264ec8 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($34060b1367424582$export$269674ad0c604d30, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krXdA.default), {
        ...props,
        ref: ref
    }))));
const $34060b1367424582$var$overrideStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error Object literal may only specify known properties, and ''--ds-background-brand-bold'' does not exist in type 'SafeCSSObject'.ts(2353)
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-brand-bold-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_BRAND_BOLD_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-disabled': (0, $6cG4N.Tokens).COLOR_BACKGROUND_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-selected-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-background-neutral-subtle-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-icon': (0, $6cG4N.Tokens).COLOR_TEXT,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link': (0, $6cG4N.Tokens).COLOR_LINK,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-link-pressed': (0, $6cG4N.Tokens).COLOR_LINK_PRESSED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-disabled': (0, $6cG4N.Tokens).COLOR_TEXT_DISABLED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-inverse': (0, $6cG4N.Tokens).COLOR_TEXT_INVERSE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-selected': (0, $6cG4N.Tokens).COLOR_TEXT_SELECTED,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-text-subtle': (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border': (0, $6cG4N.Tokens).COLOR_BORDER,
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    '--ds-border-selected': (0, $6cG4N.Tokens).COLOR_BORDER_SELECTED
});

});

parcelRegister("dTEu0", function(module, exports) {

$parcel$export(module.exports, "default", () => $0cc65c54df09db11$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0cc65c54df09db11$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    description: {
        "id": "platform-board-kit.column.column-configuration.description",
        "defaultMessage": "Configure board"
    }
});

});


parcelRegister("lvgJK", function(module, exports) {

$parcel$export(module.exports, "BoardCreateColumnButtonWrapperNudgeAsync", () => $600f4743e2a0ebd8$export$bf4765843368c29);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $600f4743e2a0ebd8$var$BoardCreateColumnButtonLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("g9Flc")).then((exportedModule)=>exportedModule.BoardCreateColumnButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/board-create-column/index.tsx"
});
const $600f4743e2a0ebd8$export$bf4765843368c29 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$a8d62e500b59f31e),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$a8d62e500b59f31e)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-board-create-column-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($600f4743e2a0ebd8$var$BoardCreateColumnButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$a8d62e500b59f31e)
    }, children)));

});
// Session storage constants used between going through initial onboarding screens
// and landing in JIRA
// Note this key used to be 'should-show-scrum-modal' but was changed to prevent a bug where experienced users
// Could see the modal if they were previously enrolled into ISO
const $6784cbc7d62e5d7c$export$67abe0a3b8dfe03f = 'should-show-scrum-modal-v2';
const $6784cbc7d62e5d7c$export$4e1360a3e7785935 = 'should-show-kanban-modal';
const $6784cbc7d62e5d7c$export$e3884212029f7bef = 'should-show-welcome-modal';
const $6784cbc7d62e5d7c$export$c45d2ea50af63a85 = 'showed-welcome-modal-during-signup';
const $6784cbc7d62e5d7c$export$c9dc4cb209930823 = 'can-enroll-in-config-wizard-view';
const $6784cbc7d62e5d7c$export$891ca65264b256bb = 'should-show-personlized-sample-data-for-kanban';
const $6784cbc7d62e5d7c$export$f47dca9dda77d157 = 'should-hide-quickstart-for-personalized-sample-data';
const $6784cbc7d62e5d7c$export$16588d2012f3f89b = 'should-show-business-sample-data-nudge';
const $6784cbc7d62e5d7c$export$928ffae10e4c0006 = 'template-key-to-show-onboarding-modal';
const $6784cbc7d62e5d7c$export$6e69f8dc03075ef8 = 'team-type';
const $6784cbc7d62e5d7c$export$c06666264cd35603 = 'team-type-shorthand';
const $6784cbc7d62e5d7c$export$8a00ecf6498ee2fe = 'onboarding-selected-project-template-type';
const $6784cbc7d62e5d7c$export$6973064a898f5989 = 'should-show-list-view-type-cell-spotlight';
const $6784cbc7d62e5d7c$export$115fac1f1144bda1 = 'should-show-list-view-fields-dropdown-spotlight';
const $6784cbc7d62e5d7c$export$69fe8832c4f79a32 = 'onboarding_started_timestamp';
const $6784cbc7d62e5d7c$export$a8d62e500b59f31e = 'boardCreateColumnButtonNudge';
const $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98 = 'assigneeFilterAddPeopleButtonNudge';
const $6784cbc7d62e5d7c$export$dd63d0099d95ba4f = 'navigationAppsNavItemNudge';
const $6784cbc7d62e5d7c$export$aba87e019f5ccb8d = 'navigationCreateIssueButtonNudge';
const $6784cbc7d62e5d7c$export$46d9a3d441dfd22b = 'navigationPlansNavItemNudge';
const $6784cbc7d62e5d7c$export$e20072f7d0c5357f = 'roadmapCreateEpicButtonNudge';
const $6784cbc7d62e5d7c$export$1e39959907a7f359 = 'roadmapCreateEpicChildIssueButtonNudge';
const $6784cbc7d62e5d7c$export$b74a8fdb2c75b869 = 'navigationPeopleNavItemNudge';
const $6784cbc7d62e5d7c$export$b1a6ab17737f33e = 'backlogAccordionNudge';
const $6784cbc7d62e5d7c$export$eb64d5f1a091478b = 'backlogCreateSprintIssueNudge';
const $6784cbc7d62e5d7c$export$64d75060ee6ba425 = 'backlogCreateIssueNudge';
const $6784cbc7d62e5d7c$export$3366ddefe77d5112 = 'boardCreateColumnNudge';
const $6784cbc7d62e5d7c$export$9d9e95a66a2c6abe = 'addItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$69aca8ebee0d34c8 = 'trelloCrossflowAddItemsCalendarNudge';
const $6784cbc7d62e5d7c$export$7aa8bceae32c7862 = 'navigationAppsProfileItemNudge';
const $6784cbc7d62e5d7c$export$c6df9a2c7447e12d = 'getStartedListNudge';
const $6784cbc7d62e5d7c$export$468488291ccd988 = 'timelineAddItemNudge';
const $6784cbc7d62e5d7c$export$7a33548109ac931d = 'createFormNudge';
const $6784cbc7d62e5d7c$export$b65ba9ea0c0ced43 = 'jsw-onboarding-checklist.open';
const $6784cbc7d62e5d7c$export$3b5d230b66f60471 = 'jsw-onboarding-checklist.visibility';
const $6784cbc7d62e5d7c$export$594d3436316492be = 'summaryViewNudge';
const $6784cbc7d62e5d7c$export$f93b83d735f01fa3 = 'pagesCreatePageNudge';
const $6784cbc7d62e5d7c$export$77bc79debbf5c069 = 'inviteTeamNudge';
const $6784cbc7d62e5d7c$export$6ffa29e74c0304c4 = 'tailorBoardColumnsNudge';
const $6784cbc7d62e5d7c$export$699265ec8ad9a740 = 'Software Development';
const $6784cbc7d62e5d7c$export$e07d1fa2da8ed874 = 'Customer Service';
const $6784cbc7d62e5d7c$export$76dcec3f438d9e56 = 'IT Support';
const $6784cbc7d62e5d7c$export$9a574c301f67ba30 = 'Human Resources';
const $6784cbc7d62e5d7c$export$363ec144a94029c8 = 'Finance';
const $6784cbc7d62e5d7c$export$df0fb32d68ae1e78 = 'Legal';
const $6784cbc7d62e5d7c$export$d9c0e3e59442fb4 = 'Marketing';
const $6784cbc7d62e5d7c$export$27dbc7d7ce66e6e3 = 'Operations';
const $6784cbc7d62e5d7c$export$a5dce388adf922bd = 'Sales';
const $6784cbc7d62e5d7c$export$e1473b31a257caff = 'Data Science';
const $6784cbc7d62e5d7c$export$85657457db93c2c2 = 'Product Management';
const $6784cbc7d62e5d7c$export$c0c2d1dfaeba89dd = 'Project Management';
const $6784cbc7d62e5d7c$export$2e6a7ad3ab9c82a3 = 'Design';
const $6784cbc7d62e5d7c$export$7b60378c3b4372e9 = 'Other or Personal';
const $6784cbc7d62e5d7c$export$572242e58bd07594 = 'CS';
const $6784cbc7d62e5d7c$export$d7de553940261eba = 'ITS';
const $6784cbc7d62e5d7c$export$4c29d0d04c15e55d = 'HR';
const $6784cbc7d62e5d7c$export$3950f7f841bf94b6 = 'FNC';
const $6784cbc7d62e5d7c$export$881249b988b6030f = 'LGL';
const $6784cbc7d62e5d7c$export$e4824f74b9879164 = 'MKT';
const $6784cbc7d62e5d7c$export$4f3cb0844009af52 = 'OPS';
const $6784cbc7d62e5d7c$export$1a65d50c4a641bb4 = 'SAL';
const $6784cbc7d62e5d7c$export$9ee64e8fbd8b03a2 = 'DS';
const $6784cbc7d62e5d7c$export$b8b1ac856ba1434b = 'DEV';
const $6784cbc7d62e5d7c$export$4f54a09a24fd1d74 = 'PDM';
const $6784cbc7d62e5d7c$export$79685802e8ff1098 = 'PJM';
const $6784cbc7d62e5d7c$export$e5c438b7501b5a24 = 'DES';
const $6784cbc7d62e5d7c$export$cbc0e551d91a692d = 'OTR';

parcelRegister("g9Flc", function(module, exports) {

let $bc2d8e0d1c22a5bb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bc2d8e0d1c22a5bb$var$load("z9M77").then(()=>parcelRequire('fw919'));

});


parcelRegister("4Z21W", function(module, exports) {

$parcel$export(module.exports, "BoardCreateColumnKanbanTourNudgeAsync", () => $bf8f0652ab055ff6$export$f360ae4e917d43c0);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bf8f0652ab055ff6$var$BoardCreateColumnNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("eAr2F")).then((exportedModule)=>exportedModule.BoardCreateColumnNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/kanban-onboarding-tour/board-create-column/index.tsx"
});
const $bf8f0652ab055ff6$export$f360ae4e917d43c0 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$f2fe211acb4aa81a),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$3366ddefe77d5112)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-kanban-onboarding-board-create-column-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bf8f0652ab055ff6$var$BoardCreateColumnNudgeLazy, null, children)));
$bf8f0652ab055ff6$export$f360ae4e917d43c0.displayName = 'BoardCreateColumnKanbanTourNudgeAsync';

});
const $dbbf68c32d8c4308$export$e0197e09cccd4e50 = 'backlogCreateSprintNudge';
const $dbbf68c32d8c4308$export$6770a2081a63fc15 = 'backlogStartSprintNudge';
const $dbbf68c32d8c4308$export$63b61f654ce3da3d = 'backlogCompleteSprintNudge';
const $dbbf68c32d8c4308$export$1c7a80b00ad9619 = 'backlogInsightsNudge';
const $dbbf68c32d8c4308$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingNudges';
const $dbbf68c32d8c4308$export$65fb0c4e534f03fc = 'asyncScrumTourNudge';
const $dbbf68c32d8c4308$export$f2fe211acb4aa81a = 'asyncKanbanTourNudge';
const $dbbf68c32d8c4308$export$fb9c6e63a7490968 = 'asyncJWMCalendarTourNudge';
const $dbbf68c32d8c4308$export$df53a339af97f102 = 'asyncJWMCalendarAndTimelineTourNudge';
const $dbbf68c32d8c4308$export$573d4bf1da6d2bc6 = 'asyncJWMBoardTourNudge';
const $dbbf68c32d8c4308$export$501e36925fa10eef = 'asyncJWMListTourNudge';
const $dbbf68c32d8c4308$export$2f06a16c987cc1a2 = 'asyncJWMTimelineTourNudge';
const $dbbf68c32d8c4308$export$226bdcb034c75951 = 'asyncJWMFormTourNudge';
const $dbbf68c32d8c4308$export$b72fce9f4cf11b5c = 'asyncJWMTrelloKeyDifferencesTourNudge';
const $dbbf68c32d8c4308$export$306510c7b1760652 = 'asyncJWMSummaryAndReportsTabNudge';
const $dbbf68c32d8c4308$export$cf1943561be3a3c2 = 'asyncJWMSummaryViewNudge';
const $dbbf68c32d8c4308$export$f8bf435a6066832c = 'button clicked';
const $dbbf68c32d8c4308$export$3bc551fe07069f89 = 'asyncJWMInviteTeamNudge';
const $dbbf68c32d8c4308$export$d99767a37baddfc = 'sampleProjectDataNudge';
const $dbbf68c32d8c4308$export$2ef41782ca91324c = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$4db327e1949c2108 = 'boardInProgressColumnNudge';
const $dbbf68c32d8c4308$export$a402f2c11da96cd7 = 'boardCreateIssueNudge';
const $dbbf68c32d8c4308$export$1e174cd1e0212f3a = 'navigateCalendarNudge';
const $dbbf68c32d8c4308$export$a1398a6ef9526001 = 'inlineEditListNudge';
const $dbbf68c32d8c4308$export$5908fa8acd2c0739 = 'filterListNudge';
const $dbbf68c32d8c4308$export$50192b0fdc9bdacf = 'moreDropdownListNudge';
const $dbbf68c32d8c4308$export$e34e81ed4f255f6e = 'timelineAddDateNudge';
const $dbbf68c32d8c4308$export$aac6e5779d47ef37 = 'timelineAddChildItemNudge';
const $dbbf68c32d8c4308$export$dd4b359b5a58cdc0 = 'trelloCrossflowTimelineTabNudge';
const $dbbf68c32d8c4308$export$1e0e647cc08bb4d8 = 'trelloKeyDifferencesIssueNudge';
const $dbbf68c32d8c4308$export$762576896c225bd6 = 'trelloKeyDifferencesSummaryNudge';
const $dbbf68c32d8c4308$export$5a96f813312dc7fa = 'trelloKeyDifferencesBoardNudge';
const $dbbf68c32d8c4308$export$ae8eeb04e0b1e9af = 'availableFieldsFormNudge';
const $dbbf68c32d8c4308$export$a54d77300f1dddea = 'changeIssueTypeFormNudge';
const $dbbf68c32d8c4308$export$6afdc7e5f6d2e915 = 'previewSaveFormNudge';
const $dbbf68c32d8c4308$export$eb0b199de90a7ec2 = 'backgroundColorNudge';
const $dbbf68c32d8c4308$export$e9e47a7ad42e71f5 = 'feedbackNudge';
const $dbbf68c32d8c4308$export$791f56b3d78403cc = 'calendarReleasesNudge';
const $dbbf68c32d8c4308$export$a1be34032ee24f78 = 'shareProjectNudge';
const $dbbf68c32d8c4308$export$29fe6611cc093756 = 'summaryTabNudge';
const $dbbf68c32d8c4308$export$f107c06c0830f09d = 'reportsTabNudge';
const $dbbf68c32d8c4308$export$9749a972a54ad7ba = 'boardContainerNudge';
const $dbbf68c32d8c4308$export$fb4f98ca3ff0420 = 'businessSampleDataNudge';
const $dbbf68c32d8c4308$export$b7fd448c62b5fb97 = 'listview';
const $dbbf68c32d8c4308$export$10c63dc5c09466d2 = 'boardview';
const $dbbf68c32d8c4308$export$75b8d65228d517e9 = 'sampleProjectScrumTourNudge';
const $dbbf68c32d8c4308$export$59a47f76d45b99 = 'sampleProjectScrumSprintNudge';
const $dbbf68c32d8c4308$export$513a9459cd6c3f96 = 'sampleProjectScrumBacklogNudge';
const $dbbf68c32d8c4308$export$657cdc4d7e8d9e5f = 'sampleProjectScrumBoardNudge';
const $dbbf68c32d8c4308$export$e16b25a220be9f3b = 'sampleProjectBoardNudge';
const $dbbf68c32d8c4308$export$c2f124710ac3a3ab = 'sampleProjectListNudge';
const $dbbf68c32d8c4308$export$b1c1e2ff4cbedbe = 'sampleProjectScrumSprintNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b230ed22c9a186d5 = 'sampleProjectScrumBacklogNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$a321b777cf077071 = 'sampleProjectScrumBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$b51b409cb5508624 = 'sampleProjectBoardNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$9757a1f68dc7a9b = 'sampleProjectListNudgeErrorBoundary';
const $dbbf68c32d8c4308$export$63a886637b84800 = 'sampleProjectNavTourNudge';
const $dbbf68c32d8c4308$export$bb40993d16db4a4b = 'SampleProjectNavNudge';
const $dbbf68c32d8c4308$export$8c300ac9d8c53332 = 'SampleProjectNavNudgeErrorBoundary';

parcelRegister("eAr2F", function(module, exports) {

let $a9e967751a7ef75c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a9e967751a7ef75c$var$load("iAmtO").then(()=>parcelRequire('8iGYP'));

});




parcelRegister("luiFO", function(module, exports) {

$parcel$export(module.exports, "default", () => $85d8c1dd25ccb1d7$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $c0aEF = parcelRequire("c0aEF");

var $dZbEw = parcelRequire("dZbEw");

var $cE2Qr = parcelRequire("cE2Qr");

var $ggqQe = parcelRequire("ggqQe");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $lmBAt = parcelRequire("lmBAt");

var $hCCtP = parcelRequire("hCCtP");

var $bC2fB = parcelRequire("bC2fB");

var $lvgJK = parcelRequire("lvgJK");

var $3t5QD = parcelRequire("3t5QD");

var $4Z21W = parcelRequire("4Z21W");

var $glGhK = parcelRequire("glGhK");

var $67sX6 = parcelRequire("67sX6");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $aXl6d = parcelRequire("aXl6d");
const $85d8c1dd25ccb1d7$var$connector = (0, $bC2fB.connect)((state)=>({
        // analytics
        externalId: 'software.board.column.add.title',
        onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        validate: (0, $fyeGd.makeValidateColumnSelector)(state),
        isDisabled: (0, $5mTgl.isAnyColumnUpdating)(state),
        isKanbanBoard: !(0, $ebHh7.isSprintsEnabled)(state)
    }), (dispatch, ownProps)=>({
        onSubmit: (temporaryColumnId, name, analyticsEvent)=>{
            const action = (0, $glGhK.columnCreateRequest)(temporaryColumnId, name, analyticsEvent, ownProps.isCMPBoard);
            dispatch(action);
        },
        onEditStart: (analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent),
        onEditCancel: (columnId, type, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                type: type,
                columnId: columnId
            })
    }));
const $85d8c1dd25ccb1d7$export$6e4f4821910a1df5 = ({ ariaLabel: ariaLabel, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
        ...props,
        label: ariaLabel
    });
const $85d8c1dd25ccb1d7$export$efb2b0a453ca73f6 = (WrappedComponent)=>(ownProps)=>{
        const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
        const AsyncNudgeComponent = ownProps.isKanbanBoard ? (0, $4Z21W.BoardCreateColumnKanbanTourNudgeAsync) : (0, $lvgJK.BoardCreateColumnButtonWrapperNudgeAsync);
        const hasGrouping = (0, $aXl6d.useHasGroupingStyle)();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: !isOnboardingDismissed,
            Wrapper: AsyncNudgeComponent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
            grow: "hug"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...ownProps,
            ...(0, $lmBAt.getIsSoftwareThemingEnabled)() && {
                renderCustomButton: $85d8c1dd25ccb1d7$export$6e4f4821910a1df5,
                isMatrixLayout: hasGrouping
            }
        })));
    };
const $85d8c1dd25ccb1d7$var$ColumnCreate = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($85d8c1dd25ccb1d7$export$efb2b0a453ca73f6, (0, $2OMDV.AnalyticsEventToProps)('columnCreate', {
    onEditStart: 'editStarted',
    onEditCancel: 'editCanceled'
}), $85d8c1dd25ccb1d7$var$connector)((0, $ggqQe.default));
const $85d8c1dd25ccb1d7$var$ColumnCreateWrapper = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isCMPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard));
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBoard) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'columnCreateButton mounted');
        }
    }, [
        isCMPBoard,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85d8c1dd25ccb1d7$var$ColumnCreate, {
        isCMPBoard: isCMPBoard
    });
};
var $85d8c1dd25ccb1d7$export$2e2bcd8739ae039 = $85d8c1dd25ccb1d7$var$ColumnCreateWrapper;

});
parcelRegister("ggqQe", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfa60e0dd6b35d8f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $k9tnV = parcelRequire("k9tnV");

var $gwIPs = parcelRequire("gwIPs");

var $645AZ = parcelRequire("645AZ");

var $ilwFs = parcelRequire("ilwFs");

var $eL3Mi = parcelRequire("eL3Mi");

var $4kZpX = parcelRequire("4kZpX");
const $cfa60e0dd6b35d8f$var$columnMarginRight = (0, $645AZ.layout).columnMargin * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfa60e0dd6b35d8f$var$StyledDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _4cvr1fhb _1e0c1txw _2lx21bp4 _16jlkb7n _1n261q9c _1bah1y6m _1cs8stnw _1mp4i2wt",
            __cmplp.className
        ])
    });
});
class $cfa60e0dd6b35d8f$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            spotlightTargetId: '',
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isFormVisible !== prevState.isFormVisible) this.scrollIntoView();
    }
    scrollIntoView() {
        if (!(0, $ilwFs.isStickySupported)) // Scroll the column into view with a method which works with IE11
        this.container.scrollIntoView();
        else {
            // padding required due to BoardScroll (32px wide + column margin(12px))
            this.container.style.paddingRight = `${(0, $gwIPs.gridSize) * 4 + $cfa60e0dd6b35d8f$var$columnMarginRight}px`;
            (0, $k9tnV.default)(this.container);
            this.container.style.paddingRight = '0px';
        }
    }
    render() {
        const { onEditStart: onEditStart, validate: validate, isDisabled: isDisabled, spotlightTargetId: spotlightTargetId, renderCustomButton: renderCustomButton, onCreateButtonClick: onCreateButtonClick } = this.props;
        const { isFormVisible: isFormVisible } = this.state;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfa60e0dd6b35d8f$var$StyledDiv, {
            ref: this.setContainer
        }, isFormVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4kZpX.default), {
            onEditStart: onEditStart,
            onCancel: this.onCancel,
            onSubmit: this.onSubmit,
            validate: validate
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eL3Mi.ColumnCreateButtonWithEngagement), {
            targetId: spotlightTargetId,
            onClick: onCreateButtonClick || this.showForm,
            isDisabled: isDisabled,
            renderCustomButton: renderCustomButton
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isFormVisible: false
        }, this.onSubmit = (temporaryId, name, analyticsEvent)=>{
            this.setState({
                isFormVisible: false
            });
            this.props.onSubmit(temporaryId, name, analyticsEvent);
        }, this.onCancel = (columnId, type)=>{
            this.setState({
                isFormVisible: false
            });
            this.props.onEditCancel && this.props.onEditCancel(columnId, type);
        }, this.setContainer = (ref)=>{
            this.container = ref;
        }, this.showForm = ()=>{
            this.setState({
                isFormVisible: true
            });
        };
    }
}

});
parcelRegister("ilwFs", function(module, exports) {

$parcel$export(module.exports, "isStickySupported", () => $8de077a9f4c8dc48$export$f0b84f0bbcabd5ca);
/**
 * Browsers allowed to run sticky position are:
 * Firefox (any version)
 * Chrome > 58
 * Any other which supports non prefixed version of sticky
 */ let $8de077a9f4c8dc48$var$isSupported = false;
const $8de077a9f4c8dc48$var$isCSSStickySupported = ()=>typeof window !== 'undefined' && window.CSS && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.CSS.supports && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.CSS.supports('position', 'sticky');
const $8de077a9f4c8dc48$var$chromeInfo = typeof navigator !== 'undefined' ? navigator.userAgent.match(/Chrome\/(\d+)/) : null;
if ($8de077a9f4c8dc48$var$chromeInfo) // Chrome <= 58 has buggy sticky support
{
    if (Array.isArray($8de077a9f4c8dc48$var$chromeInfo) && $8de077a9f4c8dc48$var$chromeInfo.length === 2) {
        const chromeVersion = Number($8de077a9f4c8dc48$var$chromeInfo[1]);
        const isBrowserBuggy = chromeVersion < 59;
        $8de077a9f4c8dc48$var$isSupported = !isBrowserBuggy && $8de077a9f4c8dc48$var$isCSSStickySupported();
    }
} else $8de077a9f4c8dc48$var$isSupported = $8de077a9f4c8dc48$var$isCSSStickySupported();
const $8de077a9f4c8dc48$export$f0b84f0bbcabd5ca = $8de077a9f4c8dc48$var$isSupported;

});

parcelRegister("eL3Mi", function(module, exports) {

$parcel$export(module.exports, "ColumnCreateButtonWithEngagement", () => $a9e755b291cf91b8$export$549ac82938941987);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");

var $3bDjY = parcelRequire("3bDjY");

var $iQv12 = parcelRequire("iQv12");

var $9vPRK = parcelRequire("9vPRK");

var $ousew = parcelRequire("ousew");

var $ilwFs = parcelRequire("ilwFs");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a9e755b291cf91b8$var$StyledStickyPlaceholder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _154iidpf _1pbyegat",
            __cmplp.className
        ])
    });
});
class $a9e755b291cf91b8$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(...args){
        super(...args), this.onClick = (event, analyticsEvent)=>{
            this.props.onClick(analyticsEvent);
        }, this.renderButton = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
                id: "platform-board.column.add-button-tooltip",
                defaultMessage: "Create column"
            }, (formattedMessage)=>{
                const message = typeof formattedMessage[0] === 'string' ? formattedMessage[0] : 'Create column';
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    position: "left",
                    content: message
                }, this.props.renderCustomButton ? this.props.renderCustomButton({
                    onClick: this.onClick,
                    testId: 'platform-board-kit.ui.column.column-create.button.styled-button',
                    isDisabled: this.props.isDisabled,
                    ariaLabel: message
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    onClick: this.onClick,
                    testId: "platform-board-kit.ui.column.column-create.button.styled-button",
                    isDisabled: this.props.isDisabled,
                    "aria-label": message,
                    iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        label: "",
                        spacing: "spacious",
                        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
                        LEGACY_size: "medium",
                        color: "var(--ds-icon, #44546F)"
                    })
                }));
            }), this.render = ()=>{
            if (!(0, $ilwFs.isStickySupported)) return this.renderButton();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9e755b291cf91b8$var$StyledStickyPlaceholder, null, this.renderButton());
        };
    }
}
const $a9e755b291cf91b8$var$ColumnCreateButtonWithAnalytics = (0, $iQv12.default)({
    onClick: ()=>({
            name: 'addColumn'
        })
})($a9e755b291cf91b8$export$2e2bcd8739ae039);
const $a9e755b291cf91b8$export$549ac82938941987 = (0, $9vPRK.default)($a9e755b291cf91b8$var$ColumnCreateButtonWithAnalytics);

});
parcelRegister("9vPRK", function(module, exports) {

$parcel$export(module.exports, "default", () => $7938f3de3467cdb8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $5Fk4Z = parcelRequire("5Fk4Z");
function $7938f3de3467cdb8$export$2e2bcd8739ae039(BaseComponent) {
    // eslint-disable-next-line jira/react/no-class-components
    return class WithEngagement extends (0, $5uXOq.Component) {
        render() {
            const { targetId: targetId, ...componentProps } = this.props;
            if (!targetId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BaseComponent, componentProps);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: targetId
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BaseComponent, componentProps)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
                engagementId: targetId
            }));
        }
    };
}

});


parcelRegister("4kZpX", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc379fba6e707c79$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $b8gJu = parcelRequire("b8gJu");

var $7KmE2 = parcelRequire("7KmE2");

var $3kNE6 = parcelRequire("3kNE6");

var $6crUM = parcelRequire("6crUM");

var $16E0T = parcelRequire("16E0T");

var $g503o = parcelRequire("g503o");

var $5k6Fi = parcelRequire("5k6Fi");
class $fc379fba6e707c79$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onSubmit: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(...args){
        super(...args), this.state = {
            column: (0, $7KmE2.newColumn)()
        }, this.onColumnTitleEditChange = (isEditingTitle)=>{
            if (isEditingTitle && this.props.onEditStart) this.props.onEditStart();
        }, this.render = ()=>{
            const columnTitle = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6crUM.default), {
                text: "",
                columnId: this.state.column.id,
                isEditing: true,
                onConfirm: this.props.onSubmit,
                onCancel: this.props.onCancel,
                onEditChange: this.onColumnTitleEditChange,
                // @ts-expect-error - Type 'ValidateColumnCallback' is not assignable to type '() => { isValid: boolean; message: null; }'.
                validateColumn: this.props.validate
            });
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
                theme: (0, $g503o.columnThemes).default
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g503o.ColumnWrapper), {
                "data-testid": (0, $b8gJu.COLUMN_WRAPPER_FORM_SELECTOR_NAME),
                appearance: (0, $3kNE6.ColumnTheme).Default
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16E0T.ColumnHeaderWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5k6Fi.default), {
                id: this.state.column.id,
                title: columnTitle
            }))));
        };
    }
}

});
parcelRegister("b8gJu", function(module, exports) {

$parcel$export(module.exports, "LOZENGE_APPEARANCE", () => $5730f4b91f5d7ebc$export$7e4a71985d57222c);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$7608524551986a84);
$parcel$export(module.exports, "CARD_CONTAINER_SELECTOR", () => $5730f4b91f5d7ebc$export$fb374ae0d58ab29b);
$parcel$export(module.exports, "COLUMN_TITLE_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$c2a2d9d97661439b);
$parcel$export(module.exports, "COLUMN_TITLE_LOZENGES_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$675d25966b2d2499);
$parcel$export(module.exports, "COLUMN_WRAPPER_FORM_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$6c814df87e7543d5);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR_NAME", () => $5730f4b91f5d7ebc$export$4167d13afb6ba84b);
$parcel$export(module.exports, "DRAGGABLE_COLUMN_SELECTOR", () => $5730f4b91f5d7ebc$export$9d54b3872a1af680);
$parcel$export(module.exports, "UPDATE_BOARD_SCROLL_POSITION", () => $5730f4b91f5d7ebc$export$d339f9637e1ca3b4);
$parcel$export(module.exports, "DATA_ANNOUNCED_IGNORE_DND_TYPE", () => $5730f4b91f5d7ebc$export$e1beb09058b7dca1);
$parcel$export(module.exports, "DATA_ANNOUNCED_COLUMN_HEADER", () => $5730f4b91f5d7ebc$export$eb11bcee172fa7de);
$parcel$export(module.exports, "DATA_ANNOUNCED_CARD_HEADER", () => $5730f4b91f5d7ebc$export$f06ed7eae652ab20);
$parcel$export(module.exports, "BoardView", () => $5730f4b91f5d7ebc$export$373e09b633948dc);

const $5730f4b91f5d7ebc$export$7e4a71985d57222c = {
    default: 'default',
    inprogress: 'inprogress',
    moved: 'moved',
    new: 'default',
    removed: 'removed',
    success: 'success'
};
const $5730f4b91f5d7ebc$export$7608524551986a84 = 'platform-board-kit.ui.card-container';
const $5730f4b91f5d7ebc$export$fb374ae0d58ab29b = `[data-component-selector="${$5730f4b91f5d7ebc$export$7608524551986a84}"]`;
const $5730f4b91f5d7ebc$export$c2a2d9d97661439b = 'platform-board-kit.ui.column-title';
const $5730f4b91f5d7ebc$export$bb13afdd2dbe0316 = `[data-component-selector="${$5730f4b91f5d7ebc$export$c2a2d9d97661439b}"]`;
const $5730f4b91f5d7ebc$export$675d25966b2d2499 = 'platform-board-kit.ui.column-title.lozenges';
const $5730f4b91f5d7ebc$export$1be96bcf0abb2b8e = `[data-component-selector="${$5730f4b91f5d7ebc$export$675d25966b2d2499}"]`;
const $5730f4b91f5d7ebc$export$6c814df87e7543d5 = 'platform-board-kit.ui.column.column-create.form.column-wrapper';
const $5730f4b91f5d7ebc$export$4167d13afb6ba84b = 'platform-board-kit.ui.column.draggable-column';
const $5730f4b91f5d7ebc$export$9d54b3872a1af680 = `[data-component-selector="${$5730f4b91f5d7ebc$export$4167d13afb6ba84b}"]`;
const $5730f4b91f5d7ebc$export$d339f9637e1ca3b4 = 'update-board-scroll-position';
const $5730f4b91f5d7ebc$export$e1beb09058b7dca1 = 'data-announced-ignore-dnd-type';
const $5730f4b91f5d7ebc$export$eb11bcee172fa7de = 'data-announced-column-header';
const $5730f4b91f5d7ebc$export$f06ed7eae652ab20 = 'data-announced-card-header';
const $5730f4b91f5d7ebc$export$373e09b633948dc = {
    JSW_BOARD: 'jsw-board',
    INCREMENT_PLANNING_BOARD: 'increment-planning-board',
    JSM_BOARD: 'jsm-board'
};

});

parcelRegister("7KmE2", function(module, exports) {

$parcel$export(module.exports, "newColumn", () => $7bb1f5607fb553eb$export$da89f2663ee4541c);
const $7bb1f5607fb553eb$var$INITIAL_COLUMN_ID = 0;
let $7bb1f5607fb553eb$var$lastColumnId = $7bb1f5607fb553eb$var$INITIAL_COLUMN_ID;
const $7bb1f5607fb553eb$var$generateId = ()=>{
    $7bb1f5607fb553eb$var$lastColumnId -= 1;
    return $7bb1f5607fb553eb$var$lastColumnId;
};
const $7bb1f5607fb553eb$export$da89f2663ee4541c = ()=>({
        id: $7bb1f5607fb553eb$var$generateId(),
        name: '',
        isDone: false,
        clearedOutCardsUrl: null,
        totalCardsCount: 0,
        isUpdating: true,
        isInitial: false
    });

});

parcelRegister("6crUM", function(module, exports) {

$parcel$export(module.exports, "default", () => $df4de5071d7a54c9$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $lFKmC = parcelRequire("lFKmC");

var $8Rkzz = parcelRequire("8Rkzz");

var $l1N8i = parcelRequire("l1N8i");

var $34Rrn = parcelRequire("34Rrn");

var $gtreQ = parcelRequire("gtreQ");

var $ctg8C = parcelRequire("ctg8C");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $dRKyO = parcelRequire("dRKyO");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $645AZ = parcelRequire("645AZ");

var $kbA3u = parcelRequire("kbA3u");

var $lVBgn = parcelRequire("lVBgn");

var $8BBAt = parcelRequire("8BBAt");
const $df4de5071d7a54c9$var$CANCEL_BUTTON_CLICKED = 'button-clicked';
const $df4de5071d7a54c9$var$CANCEL_CLICKED_OUT = 'clicked-out';
const $df4de5071d7a54c9$var$isBlank = (value)=>value.length === 0;
const $df4de5071d7a54c9$var$hasNotChanged = (current, previous)=>current === previous;
const $df4de5071d7a54c9$var$isNewColumn = (columnId)=>Number(columnId) < 0;
const $df4de5071d7a54c9$var$getCleanColumnName = (name)=>name.replace(/\s{2,}/g, ' ').trim();
const $df4de5071d7a54c9$export$cb9b233debb52c9f = 30;
const $df4de5071d7a54c9$export$86f9d799207827d5 = 200;
class $df4de5071d7a54c9$export$11c45455ee9d37df extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            isDone: false,
            isEditing: false,
            totalCount: 0,
            visibleCount: 0,
            showTotalCount: false,
            validateColumn: ()=>({
                    isValid: true,
                    message: null
                }),
            onEditChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onConfirm: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isCMPBoard: false,
            shouldRemoveSpaceForMenu: false
        };
    }
    render() {
        const { isEditing: isEditing } = this.state;
        const { isDisabled: isDisabled } = this.props;
        const interactionProps = !isDisabled ? {
            onFocus: ()=>this.setState({
                    hasInteracted: true
                }),
            onMouseEnter: ()=>this.setState({
                    hasInteracted: true
                }),
            tabIndex: this.state.hasInteracted ? -1 : 0
        } : {};
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $df4de5071d7a54c9$var$headerRowStyles,
            ref: this.setContainer
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            testId: "platform-board-kit.common.ui.column-header.editable-title.inline-edit-part-wrapper",
            xcss: [
                isEditing ? $df4de5071d7a54c9$var$inlineEditPartWrapperEditingStyles : $df4de5071d7a54c9$var$inlineEditPartWrapperNotEditingStyles
            ],
            ...interactionProps
        }, this.renderInlineEditPart()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$InlineEditPartWrapper, {
            "data-testid": "platform-board-kit.common.ui.column-header.editable-title.inline-edit-part-wrapper",
            isEditing: isEditing,
            shouldRemoveSpaceForMenu: this.props.shouldRemoveSpaceForMenu,
            ...interactionProps
        }, this.renderInlineEditPart()));
    }
    constructor(...args){
        super(...args), this.state = {
            isEditing: this.props.isEditing || false,
            isValid: true,
            errorMessage: null,
            hasInteracted: false
        }, this.onTitleOuterClick = (event)=>{
            if (!(event.target instanceof Node) || !this.container?.contains(event.target)) // cancel inline edit on outer click
            this.handleCancel($df4de5071d7a54c9$var$CANCEL_CLICKED_OUT);
        }, this.onEditChange = (isEditing)=>{
            this.props.onEditChange(isEditing);
            this.setState({
                isEditing: isEditing
            });
        }, this.setContainer = (container)=>{
            this.container = container;
        }, this.validateColumn = (name)=>{
            const { isValid: isValid, message: message = null } = this.props.validateColumn(this.props.columnId, $df4de5071d7a54c9$var$getCleanColumnName(name));
            this.setState({
                isValid: isValid,
                errorMessage: message
            });
        }, this.delayValidateColumn = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((name)=>{
            this.validateColumn(name);
        }, $df4de5071d7a54c9$export$86f9d799207827d5) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        , this.formatMessage = (message, values)=>{
            if (typeof message === 'string') return message;
            const result = this.props.intl.formatMessage(message, values);
            return result;
        }, this.handleEditChange = ()=>{
            this.onEditChange(true);
        }, this.handleConfirm = (value, analyticsEvent)=>{
            const { columnId: columnId, text: text } = this.props;
            const newValue = $df4de5071d7a54c9$var$getCleanColumnName(value);
            this.delayValidateColumn.cancel();
            const { isValid: isValid } = this.props.validateColumn(columnId, newValue);
            if (!isValid) return;
            if ($df4de5071d7a54c9$var$isBlank(newValue) || $df4de5071d7a54c9$var$hasNotChanged(newValue, text)) this.handleCancel($df4de5071d7a54c9$var$CANCEL_CLICKED_OUT);
            else {
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'column');
                this.props.onConfirm(columnId, newValue, analyticsEvent);
                this.onEditChange(false);
                this.setState({
                    isEditing: false
                });
            }
        }, this.handleCancel = (type)=>{
            const { columnId: columnId } = this.props;
            if (!$df4de5071d7a54c9$var$isNewColumn(columnId)) this.onEditChange(false);
            this.setState({
                isValid: true,
                errorMessage: null
            });
            this.props.onCancel(columnId, type);
        }, this.renderReadOnly = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $df4de5071d7a54c9$var$readOnlyStyles
            }, this.renderReadView()), this.renderReadView = ()=>{
            const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbA3u.default), {
                text: this.props.text,
                isEditing: this.state.isEditing,
                showTotalCount: this.props.showTotalCount,
                visibleCount: this.props.visibleCount,
                totalCount: this.props.totalCount,
                isDisabled: this.props.isDisabled,
                isCMPBoard: this.props.isCMPBoard
            }), this.props.lozenges, this.props.isDone && !this.props.isCMPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVBgn.default), null) : null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$Reading, null, content);
        }, this.renderEditView = ({ errorMessage: errorMessage, ...fieldProps })=>{
            const { isValid: isValid } = this.state; // we want to exclude 'aria-labelledby' from the restProps, but we don't need its value so am using an _.
            // We can't use just 'aria-labelledby' without an assignment as it results in a syntax error.
            const { 'aria-labelledby': _, ...restProps } = fieldProps;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ctg8C.default), {
                isOpen: !isValid,
                content: this.renderValidation(fieldProps.value),
                placement: "bottom"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...restProps,
                testId: "platform-board-kit.common.ui.column-header.editable-title.textfield",
                elemAfterInput: !isValid && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
                    label: "error",
                    color: "var(--ds-icon-warning, #E56910)",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
                    LEGACY_primaryColor: "var(--ds-icon-warning, #E56910)"
                })),
                maxLength: $df4de5071d7a54c9$export$cb9b233debb52c9f,
                autoFocus: true,
                autoComplete: "off",
                "aria-label": this.props.intl.formatMessage((0, $dRKyO.default).columnTitleAriaLabel)
            }));
        }, this.formatErrorMessage = (message, values)=>{
            if (typeof message === 'string') return message;
            return this.props.intl.formatMessage(message, values);
        }, this.renderValidation = (name)=>{
            const { isValid: isValid, errorMessage: errorMessage } = this.state;
            if (isValid || !errorMessage) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$InlineDialogHeader, null, this.formatErrorMessage(errorMessage.title, {
                name: name.toUpperCase()
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $df4de5071d7a54c9$var$inlineDialogBodyStyles
            }, this.formatErrorMessage(errorMessage.description)));
        }, this.renderInlineEditPart = ()=>{
            const { isEditing: isEditing, isValid: isValid } = this.state;
            const { isDisabled: isDisabled, intl: intl, text: text, columnId: columnId } = this.props; // the readonly view will be rendered if the column is:
            // 1. disabled
            // 2. a new column (id < 0) and is no longer being edited
            // 3. an existing column and has not been interacted with
            const shouldRenderReadOnly = isDisabled || !$df4de5071d7a54c9$var$isNewColumn(columnId) && !this.state.hasInteracted || $df4de5071d7a54c9$var$isNewColumn(columnId) && !isEditing;
            return shouldRenderReadOnly ? this.renderReadOnly() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8BBAt.default), {
                defaultValue: text,
                isEditing: isEditing,
                editView: this.renderEditView,
                validate: this.delayValidateColumn,
                readView: this.renderReadView,
                onConfirm: this.handleConfirm,
                onCancel: ()=>this.handleCancel($df4de5071d7a54c9$var$CANCEL_BUTTON_CLICKED),
                onEdit: this.handleEditChange,
                onOuterClick: this.onTitleOuterClick,
                hideActionButtons: !isValid,
                readViewFitContainerWidth: true,
                editButtonLabel: text,
                confirmButtonLabel: intl.formatMessage((0, $dRKyO.default).confirmButtonLabel, {
                    fieldName: ''
                }),
                cancelButtonLabel: intl.formatMessage((0, $dRKyO.default).cancelButtonLabel, {
                    fieldName: ''
                })
            });
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof ColumnEditableTitle' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props>> & typeof ColumnEditableTitle'.
$df4de5071d7a54c9$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($df4de5071d7a54c9$export$11c45455ee9d37df);
const $df4de5071d7a54c9$var$InlineDialogHeader = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($df4de5071d7a54c9$var$InlineDialogHeaderInternal, props)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineDialogHeaderInternalOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _19pkze3t _otyrutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineDialogHeaderInternalNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _19pkze3t _otyrutpp",
            __cmplp.className
        ])
    });
});
const $df4de5071d7a54c9$var$InlineDialogHeaderInternal = (0, $gSExi.styledComponentWithCondition)(()=>true, $df4de5071d7a54c9$var$InlineDialogHeaderInternalNew, $df4de5071d7a54c9$var$InlineDialogHeaderInternalOld);
const $df4de5071d7a54c9$var$inlineDialogBodyStyles = (0, $8CUq3.xcss)({
    font: 'font.body',
    color: 'color.text'
});
const $df4de5071d7a54c9$var$headerRowStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.075',
    paddingRight: 'space.075',
    maxWidth: '100%',
    boxSizing: 'border-box'
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineEditPartWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1fjeglf-0"
})`${({ shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu })=>shouldRemoveSpaceForMenu ? 'max-width: auto;' : `max-width: calc(100% - ${32 + (0, $gwIPs.gridSize) + (0, $645AZ.layout).smallGutter}px);`};${({ isEditing: isEditing })=>isEditing ? `
        flex: 1;
        max-width: 100%;
        ` : `
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
    `};`;
const $df4de5071d7a54c9$var$inlineEditPartWrapperEditingStyles = (0, $8CUq3.xcss)({
    flex: 1,
    maxWidth: '100%'
});
const $df4de5071d7a54c9$var$inlineEditPartWrapperNotEditingStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$InlineEditPartWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu, isEditing: isEditing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.shouldRemoveSpaceForMenu ? "_p12f1wug" : "_p12fskta",
            __cmplp.className
        ])
    });
});
const $df4de5071d7a54c9$var$InlineEditPartWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $df4de5071d7a54c9$var$InlineEditPartWrapperExperiment, $df4de5071d7a54c9$var$InlineEditPartWrapperControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$Reading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ul9idpf _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $df4de5071d7a54c9$var$WarningIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f312x7 _vwz41osq",
            __cmplp.className
        ])
    });
});
const $df4de5071d7a54c9$var$readOnlyStyles = (0, $8CUq3.xcss)({
    margin: 'space.025'
});

});
parcelRegister("dRKyO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6e52bd6588bf986$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d6e52bd6588bf986$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    confirmButtonLabel: {
        "id": "inline-edit.confirm-button-label",
        "defaultMessage": "Confirm {fieldName}"
    },
    cancelButtonLabel: {
        "id": "inline-edit.cancel-button-label",
        "defaultMessage": "Cancel {fieldName}"
    },
    editButtonLabel: {
        "id": "inline-edit.edit-button-label",
        "defaultMessage": "Edit {fieldName}"
    },
    addButtonLabel: {
        "id": "inline-edit.add-button-label",
        "defaultMessage": "Add {fieldName}"
    },
    extendedEditButtonLabel: {
        "id": "inline-edit.extended-edit-button-label",
        "defaultMessage": "{inputFieldValue}- edit {fieldName}"
    },
    disabledEditButtonLabel: {
        "id": "inline-edit.disabled-edit-button-label",
        "defaultMessage": "{fieldName} - can\u2019t be edited"
    },
    disabledReporterTooltip: {
        "id": "inline-edit.disabled-inline-edit-tooltip",
        "defaultMessage": "{fieldName} can\u2019t be edited"
    },
    columnTitleAriaLabel: {
        "id": "inline-edit.column-title-aria-label",
        "defaultMessage": "Add column name"
    }
});

});

parcelRegister("gSExi", function(module, exports) {

$parcel$export(module.exports, "styledComponentWithCondition", () => $cd06fcc13efa32a5$export$62d8d8fbf238d6af);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $cd06fcc13efa32a5$export$62d8d8fbf238d6af = (useCompiled, CompiledComponent, StyledComponent)=>// Couldn't destructure like {innerRef, ...rest} as
    // typescript is suspcious on destructing generics
    ({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });
const $cd06fcc13efa32a5$export$f5b752428255ba78 = (useCompiled, CompiledComponent, StyledComponent)=>({ innerRef: innerRef, ...rest })=>useCompiled() ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompiledComponent, {
            ...rest,
            ref: innerRef
        }) : // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(StyledComponent, {
            ...rest,
            innerRef: innerRef
        });

});

parcelRegister("kbA3u", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1c2bb1a174f6a8f$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ // On jsw_compiled_migration_tanuki FF cleanup, remove styled-component-order disable ^

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $8SlfA = parcelRequire("8SlfA");

var $dCm1o = parcelRequire("dCm1o");

var $b8gJu = parcelRequire("b8gJu");

var $hvGbV = parcelRequire("hvGbV");
const $e1c2bb1a174f6a8f$var$ColumnTitle = ({ isDisabled: isDisabled, isEditing: isEditing, isCMPBoard: isCMPBoard, showTotalCount: showTotalCount, text: text, totalCount: totalCount, visibleCount: visibleCount })=>{
    const convertedText = text.split(' ').join('-').toLowerCase();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1c2bb1a174f6a8f$var$Text, {
        isDisabled: isDisabled,
        "aria-label": text,
        // `__board-test-hook__column-title` is used in pollinator tests
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: `__board-test-hook__column-title ${$8SlfA.compactColumnTitle}`,
        "data-testid": "platform-board-kit.common.ui.column-header.editable-title.column-title.column-title",
        "data-component-selector": (0, $b8gJu.COLUMN_TITLE_SELECTOR_NAME)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1c2bb1a174f6a8f$var$FlexWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1c2bb1a174f6a8f$var$ColumnName, {
        title: text,
        "data-testid": "platform-board-kit.common.ui.column-header.editable-title.column-title.column-name",
        id: (0, $4R6GH.fg)('remove_aria_labelled_by_on_column_ul') ? undefined : `platform-board-kit.ui.column-title-${convertedText}`
    }, text), !!visibleCount && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e1c2bb1a174f6a8f$var$CountWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hvGbV.default), {
        isEditing: isEditing,
        showTotalCount: showTotalCount,
        totalCount: totalCount,
        visibleCount: visibleCount,
        isCMPBoard: isCMPBoard
    }))));
};
var $e1c2bb1a174f6a8f$export$2e2bcd8739ae039 = $e1c2bb1a174f6a8f$var$ColumnTitle;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e1c2bb1a174f6a8f$var$ColumnName = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _o5721q9c _1bto1l2s _p12f1osq _wmna1osq",
            __cmplp.className
        ])
    });
});
const $e1c2bb1a174f6a8f$var$CountWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u01b66 _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $e1c2bb1a174f6a8f$var$Text = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h2", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81vhk _1reo15vq _18m915vq _1e0c1txw _1p1dangw _syaz131l _k48p1wq8 _4t3i1osq _18u0u2gc _2hwxu2gc _1aha1pd9",
            __cmplp.className
        ])
    });
});
const $e1c2bb1a174f6a8f$var$FlexWrapperStyles = (0, $8CUq3.xcss)({
    overflowX: 'hidden'
});
// When cleaning up jsw_compiled_migration_tanuki align, 'alignContent: center' could be added to the styled H2. It wasn't possible due to Eslint error when using isVisualRefreshEnabled()
const $e1c2bb1a174f6a8f$var$FlexWrapper = ({ children: children })=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        xcss: $e1c2bb1a174f6a8f$var$FlexWrapperStyles
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});
parcelRegister("8SlfA", function(module, exports) {

$parcel$export(module.exports, "column-header", () => $6763d9c6617c8d17$export$7177d480608b4128, (v) => $6763d9c6617c8d17$export$7177d480608b4128 = v);
$parcel$export(module.exports, "compactColumnTitle", () => $6763d9c6617c8d17$export$b690eaa5578df8ab, (v) => $6763d9c6617c8d17$export$b690eaa5578df8ab = v);
$parcel$export(module.exports, "compactLozenge", () => $6763d9c6617c8d17$export$74295e7ce4ff29bf, (v) => $6763d9c6617c8d17$export$74295e7ce4ff29bf = v);
$parcel$export(module.exports, "defaultLozenge", () => $6763d9c6617c8d17$export$af9878e03870ea4a, (v) => $6763d9c6617c8d17$export$af9878e03870ea4a = v);
$parcel$export(module.exports, "defaultLozengeContainer", () => $6763d9c6617c8d17$export$8ed778aa4998d971, (v) => $6763d9c6617c8d17$export$8ed778aa4998d971 = v);
var $6763d9c6617c8d17$export$7177d480608b4128;
var $6763d9c6617c8d17$export$b690eaa5578df8ab;
var $6763d9c6617c8d17$export$74295e7ce4ff29bf;
var $6763d9c6617c8d17$export$af9878e03870ea4a;
var $6763d9c6617c8d17$export$8ed778aa4998d971;
$6763d9c6617c8d17$export$7177d480608b4128 = `j-BFpW_column-header`;
$6763d9c6617c8d17$export$b690eaa5578df8ab = `j-BFpW_compactColumnTitle`;
$6763d9c6617c8d17$export$74295e7ce4ff29bf = `j-BFpW_compactLozenge`;
$6763d9c6617c8d17$export$af9878e03870ea4a = `j-BFpW_defaultLozenge`;
$6763d9c6617c8d17$export$8ed778aa4998d971 = `j-BFpW_defaultLozengeContainer`;

});

parcelRegister("hvGbV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1cf9b19799953994$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $3JT92 = parcelRequire("3JT92");

var $dC5iT = parcelRequire("dC5iT");

var $ousew = parcelRequire("ousew");

var $dCm1o = parcelRequire("dCm1o");

var $ek9Ll = parcelRequire("ek9Ll");

var $a2e2Q = parcelRequire("a2e2Q");
const $1cf9b19799953994$var$countStyles = {
    root: "_1reo15vq _18m915vq _syaz131l _1ul9idpf _16jlidpf _1o9zidpf _2hwx1b66"
};
const $1cf9b19799953994$var$badgeStyles = {
    root: "_2rkoglpi _18zr1b66 _bfhkm7j4 _syaz1fxt _1ul91tcg _y3gn1h6o"
};
const $1cf9b19799953994$var$CountWrapper = ({ children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return isSoftwareFullTheming ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $3JT92.cx)($1cf9b19799953994$var$countStyles.root)
    }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$export$5c31959b0a6b6e24, null, children);
};
const $1cf9b19799953994$var$ColumnCardCount = ({ isCMPBoard: isCMPBoard, isEditing: isEditing, totalCount: totalCount, showTotalCount: showTotalCount, visibleCount: visibleCount })=>{
    if (isEditing || totalCount === 0) return null;
    if (showTotalCount) {
        if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$CountWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.column-header-count-uif",
            defaultMessage: "{visibleCountNumber}/{totalCountNumber}",
            values: {
                visibleCountNumber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, visibleCount),
                totalCountNumber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, totalCount)
            }
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$CountWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.column-header-count",
            defaultMessage: "{visibleCountNumber} of {totalCountNumber}",
            values: {
                visibleCountNumber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, visibleCount),
                totalCountNumber: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, totalCount)
            }
        })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$CountWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1cf9b19799953994$var$BadgeWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ek9Ll))), null, visibleCount)));
};
var $1cf9b19799953994$export$2e2bcd8739ae039 // remove Count styled component on clean up - jira_theming_milestone_1
 = $1cf9b19799953994$var$ColumnCardCount;
const $1cf9b19799953994$export$5c31959b0a6b6e24 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _1ul9idpf _16jlidpf _1o9zidpf _2hwx1b66",
            __cmplp.className
        ])
    });
});
const $1cf9b19799953994$var$BadgeWrapper = ({ children: children })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        if (isSoftwareFullTheming) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $1cf9b19799953994$var$badgeStyles.root
        }, children, " ");
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), null, children, " ");
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};

});
parcelRegister("ek9Ll", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");
var $a6da819578d899ff$var$D = $5uXOq.createElement;

var $8NBjW = parcelRequire("8NBjW");

var $apVjs = parcelRequire("apVjs");
var $a6da819578d899ff$var$symbol = $5uXOq.createElement.bind(null, $apVjs);
var $a6da819578d899ff$var$TransitiveNumber = $8NBjW({
    getDefaultProps: function() {
        return {
            className: null,
            enableInitialAnimation: false
        };
    },
    render: function() {
        var value = this.props.children.toString();
        // Invert animation direction when negative number is supplied.
        var inverted = value[0] === '-';
        return $a6da819578d899ff$var$D('span', {
            className: this.props.className,
            style: {
                whiteSpace: 'pre'
            }
        }, value.split('').map(function(s, index) {
            return $a6da819578d899ff$var$symbol({
                symbol: s,
                inverted: inverted,
                enableInitialAnimation: this.props.enableInitialAnimation,
                key: index
            });
        }, this));
    }
});
module.exports = $a6da819578d899ff$var$TransitiveNumber;

});
parcelRegister("8NBjW", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $6Ksdh = parcelRequire("6Ksdh");
if (typeof $5uXOq === 'undefined') throw Error("create-react-class could not find the React object. If you are using script tags, make sure that React is being loaded before create-react-class.");
// Hack to grab NoopUpdateQueue from isomorphic React
var $667fd96c41381c5b$var$ReactNoopUpdateQueue = new $5uXOq.Component().updater;
module.exports = $6Ksdh($5uXOq.Component, $5uXOq.isValidElement, $667fd96c41381c5b$var$ReactNoopUpdateQueue);

});
parcelRegister("6Ksdh", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */ 'use strict';

var $9rcQv = parcelRequire("9rcQv");
// -- Inlined from fbjs --
var $4e9cec82047801f6$var$emptyObject = {};
var $4e9cec82047801f6$var$validateFormat = function validateFormat(format) {};
function $4e9cec82047801f6$var$_invariant(condition, format, a, b, c, d, e, f) {
    $4e9cec82047801f6$var$validateFormat(format);
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
}
var $4e9cec82047801f6$var$warning = function() {};
var $4e9cec82047801f6$var$printWarning;
// /-- Inlined from fbjs --
var $4e9cec82047801f6$var$MIXINS_KEY = 'mixins';
// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function $4e9cec82047801f6$var$identity(fn) {
    return fn;
}
var $4e9cec82047801f6$var$ReactPropTypeLocationNames;
$4e9cec82047801f6$var$ReactPropTypeLocationNames = {};
function $4e9cec82047801f6$var$factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
    /**
   * Policies that describe methods in `ReactClassInterface`.
   */ var injectedMixins = [];
    /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */ var ReactClassInterface = {
        /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */ mixins: 'DEFINE_MANY',
        /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */ statics: 'DEFINE_MANY',
        /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */ propTypes: 'DEFINE_MANY',
        /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */ contextTypes: 'DEFINE_MANY',
        /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */ childContextTypes: 'DEFINE_MANY',
        // ==== Definition methods ====
        /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */ getDefaultProps: 'DEFINE_MANY_MERGED',
        /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */ getInitialState: 'DEFINE_MANY_MERGED',
        /**
     * @return {object}
     * @optional
     */ getChildContext: 'DEFINE_MANY_MERGED',
        /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */ render: 'DEFINE_ONCE',
        // ==== Delegate methods ====
        /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */ componentWillMount: 'DEFINE_MANY',
        /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidMount: 'DEFINE_MANY',
        /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */ componentWillReceiveProps: 'DEFINE_MANY',
        /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */ shouldComponentUpdate: 'DEFINE_ONCE',
        /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */ componentWillUpdate: 'DEFINE_MANY',
        /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */ componentDidUpdate: 'DEFINE_MANY',
        /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */ componentWillUnmount: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */ UNSAFE_componentWillMount: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */ UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',
        /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */ UNSAFE_componentWillUpdate: 'DEFINE_MANY',
        // ==== Advanced methods ====
        /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */ updateComponent: 'OVERRIDE_BASE'
    };
    /**
   * Similar to ReactClassInterface but for static methods.
   */ var ReactClassStaticInterface = {
        /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */ getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
    };
    /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */ var RESERVED_SPEC_KEYS = {
        displayName: function(Constructor, displayName) {
            Constructor.displayName = displayName;
        },
        mixins: function(Constructor, mixins) {
            if (mixins) for(var i = 0; i < mixins.length; i++)mixSpecIntoComponent(Constructor, mixins[i]);
        },
        childContextTypes: function(Constructor, childContextTypes) {
            Constructor.childContextTypes = $9rcQv({}, Constructor.childContextTypes, childContextTypes);
        },
        contextTypes: function(Constructor, contextTypes) {
            Constructor.contextTypes = $9rcQv({}, Constructor.contextTypes, contextTypes);
        },
        /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */ getDefaultProps: function(Constructor, getDefaultProps) {
            if (Constructor.getDefaultProps) Constructor.getDefaultProps = createMergedResultFunction(Constructor.getDefaultProps, getDefaultProps);
            else Constructor.getDefaultProps = getDefaultProps;
        },
        propTypes: function(Constructor, propTypes) {
            Constructor.propTypes = $9rcQv({}, Constructor.propTypes, propTypes);
        },
        statics: function(Constructor, statics) {
            mixStaticSpecIntoComponent(Constructor, statics);
        },
        autobind: function() {}
    };
    function validateTypeDef(Constructor, typeDef, location) {
        for(var propName in typeDef)typeDef.hasOwnProperty(propName);
    }
    function validateMethodOverride(isAlreadyDefined, name) {
        var specPolicy = ReactClassInterface.hasOwnProperty(name) ? ReactClassInterface[name] : null;
        // Disallow overriding of base class methods unless explicitly allowed.
        if (ReactClassMixin.hasOwnProperty(name)) $4e9cec82047801f6$var$_invariant(specPolicy === 'OVERRIDE_BASE', "ReactClassInterface: You are attempting to override `%s` from your class specification. Ensure that your method names do not overlap with React methods.", name);
        // Disallow defining methods more than once unless explicitly allowed.
        if (isAlreadyDefined) $4e9cec82047801f6$var$_invariant(specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED', "ReactClassInterface: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
    }
    /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */ function mixSpecIntoComponent(Constructor, spec) {
        if (!spec) {
            var typeofSpec, isMixinValid;
            return;
        }
        $4e9cec82047801f6$var$_invariant(typeof spec !== 'function', "ReactClass: You're attempting to use a component class or function as a mixin. Instead, just use a regular object.");
        $4e9cec82047801f6$var$_invariant(!isValidElement(spec), "ReactClass: You're attempting to use a component as a mixin. Instead, just use a regular object.");
        var proto = Constructor.prototype;
        var autoBindPairs = proto.__reactAutoBindPairs;
        // By handling mixins before any other properties, we ensure the same
        // chaining order is applied to methods with DEFINE_MANY policy, whether
        // mixins are listed before or after these methods in the spec.
        if (spec.hasOwnProperty($4e9cec82047801f6$var$MIXINS_KEY)) RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
        for(var name in spec){
            if (!spec.hasOwnProperty(name)) continue;
            if (name === $4e9cec82047801f6$var$MIXINS_KEY) continue;
            var property = spec[name];
            var isAlreadyDefined = proto.hasOwnProperty(name);
            validateMethodOverride(isAlreadyDefined, name);
            if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) RESERVED_SPEC_KEYS[name](Constructor, property);
            else {
                // Setup methods on prototype:
                // The following member methods should not be automatically bound:
                // 1. Expected ReactClass methods (in the "interface").
                // 2. Overridden methods (that were mixed in).
                var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
                var isFunction = typeof property === 'function';
                var shouldAutoBind = isFunction && !isReactClassMethod && !isAlreadyDefined && spec.autobind !== false;
                if (shouldAutoBind) {
                    autoBindPairs.push(name, property);
                    proto[name] = property;
                } else if (isAlreadyDefined) {
                    var specPolicy = ReactClassInterface[name];
                    // These cases should already be caught by validateMethodOverride.
                    $4e9cec82047801f6$var$_invariant(isReactClassMethod && (specPolicy === 'DEFINE_MANY_MERGED' || specPolicy === 'DEFINE_MANY'), "ReactClass: Unexpected spec policy %s for key %s when mixing in component specs.", specPolicy, name);
                    // For methods which are defined more than once, call the existing
                    // methods before calling the new property, merging if appropriate.
                    if (specPolicy === 'DEFINE_MANY_MERGED') proto[name] = createMergedResultFunction(proto[name], property);
                    else if (specPolicy === 'DEFINE_MANY') proto[name] = createChainedFunction(proto[name], property);
                } else proto[name] = property;
            }
        }
    }
    function mixStaticSpecIntoComponent(Constructor, statics) {
        if (!statics) return;
        for(var name in statics){
            var property = statics[name];
            if (!statics.hasOwnProperty(name)) continue;
            var isReserved = name in RESERVED_SPEC_KEYS;
            $4e9cec82047801f6$var$_invariant(!isReserved, 'ReactClass: You are attempting to define a reserved property, `%s`, that shouldn\'t be on the "statics" key. Define it as an instance property instead; it will still be accessible on the constructor.', name);
            var isAlreadyDefined = name in Constructor;
            if (isAlreadyDefined) {
                var specPolicy = ReactClassStaticInterface.hasOwnProperty(name) ? ReactClassStaticInterface[name] : null;
                $4e9cec82047801f6$var$_invariant(specPolicy === 'DEFINE_MANY_MERGED', "ReactClass: You are attempting to define `%s` on your component more than once. This conflict may be due to a mixin.", name);
                Constructor[name] = createMergedResultFunction(Constructor[name], property);
                return;
            }
            Constructor[name] = property;
        }
    }
    /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */ function mergeIntoWithNoDuplicateKeys(one, two) {
        $4e9cec82047801f6$var$_invariant(one && two && typeof one === 'object' && typeof two === 'object', 'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.');
        for(var key in two)if (two.hasOwnProperty(key)) {
            $4e9cec82047801f6$var$_invariant(one[key] === undefined, "mergeIntoWithNoDuplicateKeys(): Tried to merge two objects with the same key: `%s`. This conflict may be due to a mixin; in particular, this may be caused by two getInitialState() or getDefaultProps() methods returning objects with clashing keys.", key);
            one[key] = two[key];
        }
        return one;
    }
    /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createMergedResultFunction(one, two) {
        return function mergedResult() {
            var a = one.apply(this, arguments);
            var b = two.apply(this, arguments);
            if (a == null) return b;
            else if (b == null) return a;
            var c = {};
            mergeIntoWithNoDuplicateKeys(c, a);
            mergeIntoWithNoDuplicateKeys(c, b);
            return c;
        };
    }
    /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */ function createChainedFunction(one, two) {
        return function chainedFunction() {
            one.apply(this, arguments);
            two.apply(this, arguments);
        };
    }
    /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */ function bindAutoBindMethod(component, method) {
        var boundMethod = method.bind(component);
        var componentName, _bind;
        return boundMethod;
    }
    /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */ function bindAutoBindMethods(component) {
        var pairs = component.__reactAutoBindPairs;
        for(var i = 0; i < pairs.length; i += 2){
            var autoBindKey = pairs[i];
            var method = pairs[i + 1];
            component[autoBindKey] = bindAutoBindMethod(component, method);
        }
    }
    var IsMountedPreMixin = {
        componentDidMount: function() {
            this.__isMounted = true;
        }
    };
    var IsMountedPostMixin = {
        componentWillUnmount: function() {
            this.__isMounted = false;
        }
    };
    /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */ var ReactClassMixin = {
        /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */ replaceState: function(newState, callback) {
            this.updater.enqueueReplaceState(this, newState, callback);
        },
        /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */ isMounted: function() {
            return !!this.__isMounted;
        }
    };
    var ReactClassComponent = function() {};
    $9rcQv(ReactClassComponent.prototype, ReactComponent.prototype, ReactClassMixin);
    /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */ function createClass(spec) {
        // To keep our warnings more understandable, we'll use a little hack here to
        // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
        // unnecessarily identify a class without displayName as 'Constructor'.
        var Constructor = $4e9cec82047801f6$var$identity(function(props, context, updater) {
            // Wire up auto-binding
            if (this.__reactAutoBindPairs.length) bindAutoBindMethods(this);
            this.props = props;
            this.context = context;
            this.refs = $4e9cec82047801f6$var$emptyObject;
            this.updater = updater || ReactNoopUpdateQueue;
            this.state = null;
            // ReactClasses doesn't have constructors. Instead, they use the
            // getInitialState and componentWillMount methods for initialization.
            var initialState = this.getInitialState ? this.getInitialState() : null;
            $4e9cec82047801f6$var$_invariant(typeof initialState === 'object' && !Array.isArray(initialState), '%s.getInitialState(): must return an object or null', Constructor.displayName || 'ReactCompositeComponent');
            this.state = initialState;
        });
        Constructor.prototype = new ReactClassComponent();
        Constructor.prototype.constructor = Constructor;
        Constructor.prototype.__reactAutoBindPairs = [];
        injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
        mixSpecIntoComponent(Constructor, IsMountedPreMixin);
        mixSpecIntoComponent(Constructor, spec);
        mixSpecIntoComponent(Constructor, IsMountedPostMixin);
        // Initialize the defaultProps property after all mixins have been merged.
        if (Constructor.getDefaultProps) Constructor.defaultProps = Constructor.getDefaultProps();
        $4e9cec82047801f6$var$_invariant(Constructor.prototype.render, 'createClass(...): Class specification must implement a `render` method.');
        // Reduce time spent doing lookups by setting these on the prototype.
        for(var methodName in ReactClassInterface)if (!Constructor.prototype[methodName]) Constructor.prototype[methodName] = null;
        return Constructor;
    }
    return createClass;
}
module.exports = $4e9cec82047801f6$var$factory;

});


parcelRegister("apVjs", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");
var $7958b2515b96b0db$var$D = $5uXOq.createElement;

var $7nsd3 = parcelRequire("7nsd3");
var $7958b2515b96b0db$require$findDOMNode = $7nsd3.findDOMNode;

var $8NBjW = parcelRequire("8NBjW");

var $4AVfd = parcelRequire("4AVfd");
var $7958b2515b96b0db$var$transition = $5uXOq.createElement.bind(null, $4AVfd);
var $7958b2515b96b0db$var$Symbol = $8NBjW({
    getInitialState: function() {
        return {
            previous: null,
            decrementing: false,
            initialRender: true
        };
    },
    componentDidMount: function() {
        $7958b2515b96b0db$require$findDOMNode(this).addEventListener('transitionend', this.removePrevious);
    },
    componentWillUnmount: function() {
        $7958b2515b96b0db$require$findDOMNode(this).removeEventListener('transitionend', this.removePrevious);
    },
    componentWillReceiveProps: function(nextProps) {
        if (nextProps.symbol !== this.props.symbol) {
            var decrementing = $7958b2515b96b0db$var$isDecrementing(this.props.symbol, nextProps.symbol);
            this.setState({
                previous: this.props.symbol,
                decrementing: this.props.inverted ? !decrementing : decrementing,
                initialRender: false
            });
        }
    },
    shouldComponentUpdate: function(nextProps, nextState) {
        return nextProps.symbol !== this.props.symbol || nextState.previous !== this.state.previous;
    },
    removePrevious: function() {
        this.setState({
            previous: null
        });
    },
    render: function() {
        return $7958b2515b96b0db$var$D('span', {
            style: {
                position: 'relative',
                display: 'inline-block'
            }
        }, // Have to render this transparent spacer span to mitigate the issue
        // when Safari would not animate transition if changing `position`
        // from `absolute` to `static`.
        this.renderSpacer(), this.renderTransitionIn(), this.renderTransitionOut());
    },
    renderSpacer: function() {
        return $7958b2515b96b0db$var$D('span', {
            style: {
                visibility: 'hidden'
            }
        }, this.props.symbol);
    },
    renderTransitionIn: function() {
        return $7958b2515b96b0db$var$transition({
            value: this.props.symbol,
            goingUp: this.state.decrementing,
            animateEntrance: this.state.initialRender ? this.props.enableInitialAnimation : true,
            key: this.props.symbol
        });
    },
    renderTransitionOut: function() {
        if (this.state.previous !== null) return $7958b2515b96b0db$var$transition({
            value: this.state.previous,
            goingUp: this.state.decrementing,
            out: true,
            key: this.state.previous
        });
        return null;
    }
});
module.exports = $7958b2515b96b0db$var$Symbol;
function $7958b2515b96b0db$var$isDecrementing(a, b) {
    var numberA = Number(a);
    var numberB = Number(b);
    // Special case when going from 9 or 6 to 0 (and back).
    if (Math.abs(numberB - numberA) !== 1) return numberA === 0;
    else return numberB < numberA;
}

});
parcelRegister("4AVfd", function(module, exports) {

var $5uXOq = parcelRequire("5uXOq");
var $3586edc556045d57$var$D = $5uXOq.createElement;

var $7nsd3 = parcelRequire("7nsd3");
var $3586edc556045d57$require$findDOMNode = $7nsd3.findDOMNode;

var $8NBjW = parcelRequire("8NBjW");
var $3586edc556045d57$var$Transition = $8NBjW({
    getInitialState: function() {
        return {
            in: this.props.out ? true : !this.props.animateEntrance
        };
    },
    componentDidMount: function() {
        this._timeout = $3586edc556045d57$var$raf(this.tada);
    },
    componentWillUnmount: function() {
        $3586edc556045d57$var$caf(this._timeout);
    },
    tada: function() {
        // Force element reflow to ensure correct animation in FF.
        $3586edc556045d57$require$findDOMNode(this).offsetWidth;
        this.setState({
            in: true
        });
    },
    getAppearance: function() {
        var transform = this.getTransform();
        return {
            display: 'inline-block',
            // Can't dynamically change `position` from `absolute` to `static` -
            // it will break transition animation in Safari.
            position: 'absolute',
            left: 0,
            WebkitTransition: '-webkit-transform 0.2s, opacity 0.2s',
            transition: 'transform 0.2s, opacity 0.2s',
            WebkitTransform: transform,
            transform: transform,
            opacity: this.isHidden() ? 0 : 1,
            pointerEvents: 'none'
        };
    },
    getTransform: function() {
        if (this.props.out) return $3586edc556045d57$var$translateY(this.props.goingUp);
        if (!this.state.in) return $3586edc556045d57$var$translateY(!this.props.goingUp);
        // This has better text rendering in FF than simply `none`.
        return 'translateY(0) translateZ(0)';
    },
    isHidden: function() {
        return this.props.out || !this.state.in;
    },
    render: function() {
        return $3586edc556045d57$var$D('span', {
            style: this.getAppearance()
        }, this.props.value);
    }
});
module.exports = $3586edc556045d57$var$Transition;
function $3586edc556045d57$var$raf(fn) {
    if (typeof window.requestAnimationFrame === 'function') return window.requestAnimationFrame(fn);
    else return setTimeout(fn, 0);
}
function $3586edc556045d57$var$caf(timer) {
    if (typeof window.cancelAnimationFrame === 'function') return window.cancelAnimationFrame(timer);
    else return clearTimeout(timer);
}
function $3586edc556045d57$var$translateY(isUp) {
    return 'translateY(' + (isUp ? '-' : '') + '60%) translateZ(0)';
}

});





parcelRegister("lVBgn", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9ad1ae8340c6e0a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bjo8S = parcelRequire("bjo8S");

var $kbxJz = parcelRequire("kbxJz");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $3eBvl = parcelRequire("3eBvl");
const $d9ad1ae8340c6e0a$var$DoneColumnTick = ()=>{
    const intl = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9ad1ae8340c6e0a$var$Container, {
        "data-test-id": "platform-board-kit.common.ui.column-header.editable-title.done-column-tick.done-column-tick",
        "data-testid": "platform-board-kit.common.ui.column-header.editable-title.done-column-tick.done-column-tick"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3eBvl.messages).doneTickTooltipIssueTermRefresh : (0, $3eBvl.messages).doneTickTooltip)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bjo8S))), {
        label: "",
        color: "var(--ds-icon-success, #22A06B)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($kbxJz))),
        LEGACY_primaryColor: "var(--ds-icon-success, #22A06B)",
        LEGACY_size: "small"
    })));
};
var $d9ad1ae8340c6e0a$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $d9ad1ae8340c6e0a$var$DoneColumnTick;
const $d9ad1ae8340c6e0a$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bjo8S", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a3e71f4112aeb66b16fbd284cc49bbc6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $83c43234bc70a485$var$_react = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $83c43234bc70a485$var$_baseNew = $83c43234bc70a485$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $83c43234bc70a485$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $83c43234bc70a485$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $83c43234bc70a485$var$_react.default.createElement($83c43234bc70a485$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m15.076 3.23-8.75 10.5a.75.75 0 0 1-1.159-.008l-4.25-5.25 1.166-.944 3.675 4.54 8.166-9.798z" clip-rule="evenodd"/>`
    }, props));
$83c43234bc70a485$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $83c43234bc70a485$var$_default = module.exports.default = $83c43234bc70a485$var$CheckMarkIcon;

});

parcelRegister("kbxJz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $eb1f0098e5a023eb$var$_react = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $eb1f0098e5a023eb$var$_checkMark = $eb1f0098e5a023eb$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $eb1f0098e5a023eb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $eb1f0098e5a023eb$var$CheckIcon = (props)=>/*#__PURE__*/ $eb1f0098e5a023eb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6.735 12.322a1 1 0 0 0-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2336 2336 0 0 0 3.939-3.883l.04-.04a493 493 0 0 0 3.658-3.643 1 1 0 0 0-1.424-1.404 518 518 0 0 1-3.64 3.625l-.04.04a2049 2049 0 0 1-3.775 3.722z"/></svg>`
    }, props, {
        newIcon: $eb1f0098e5a023eb$var$_checkMark.default
    }));
$eb1f0098e5a023eb$var$CheckIcon.displayName = 'CheckIcon';
var $eb1f0098e5a023eb$var$_default = module.exports.default = $eb1f0098e5a023eb$var$CheckIcon;

});

parcelRegister("3eBvl", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f9d9c0ba3f191971$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f9d9c0ba3f191971$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    doneTickTooltip: {
        "id": "platform-board-kit.common.column-header.editable-title.done-column-tick.done-tick-tooltip",
        "defaultMessage": "Issues moved to this column are marked as done"
    },
    doneTickTooltipIssueTermRefresh: {
        "id": "platform-board-kit.common.column-header.editable-title.done-column-tick.done-tick-tooltip-issue-term-refresh",
        "defaultMessage": "Work items moved to this column are marked as done"
    }
});

});


parcelRegister("8BBAt", function(module, exports) {

$parcel$export(module.exports, "default", () => $47d471dd5033fa83$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $47d471dd5033fa83$var$AsyncInlineEdit = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("hmRlM")), {
    moduleId: "../platform/packages/design-system/inline-edit/src/index.ts"
});
class $47d471dd5033fa83$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            onOuterClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        if (this.props.isEditing) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('click', this.onWindowMouseClick, true);
    }
    UNSAFE_componentWillReceiveProps(nextProps) {
        if (this.props.isEditing !== nextProps.isEditing) {
            if (nextProps.isEditing) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('click', this.onWindowMouseClick, true);
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('click', this.onWindowMouseClick, true);
        }
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('click', this.onWindowMouseClick, true);
    }
    render() {
        const { readView: readView, onConfirm: onConfirm, onCancel: onCancel, onOuterClick: onOuterClick, ...otherProps } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "async-column-inline-edit",
            packageName: "JiraPlatformBoardKit"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d471dd5033fa83$var$InlineEditContainer, {
            ref: this.setContainer,
            onClick: (event)=>event.stopPropagation()
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "async-board-inline-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $47d471dd5033fa83$var$readViewWrapperStyles
            }, readView())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47d471dd5033fa83$var$AsyncInlineEdit, {
            readView: readView,
            onCancel: onCancel,
            onConfirm: onConfirm,
            ...otherProps
        }))));
    }
    constructor(...args){
        super(...args), this.onWindowMouseClick = (event)=>{
            if (!(event.target instanceof Node) || !this.container?.contains(event.target)) this.props.onOuterClick(event);
        }, this.setContainer = (container)=>{
            this.container = container;
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $47d471dd5033fa83$var$InlineEditContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _19pkx0bf _1u1tidpf _b64vr5cr _mp8c3acm",
            __cmplp.className
        ])
    });
});
const $47d471dd5033fa83$var$readViewWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginLeft: 'space.100',
    marginRight: 'space.025',
    paddingLeft: 'space.025'
});

});
parcelRegister("hmRlM", function(module, exports) {

let $ca4ddffbd1acb201$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ca4ddffbd1acb201$var$load("lbV1I").then(()=>parcelRequire('97SvH'));

});



parcelRegister("16E0T", function(module, exports) {

$parcel$export(module.exports, "ColumnHeaderWrapper", () => $dfaa058e2b80d56e$export$381ca84651f316ee);
$parcel$export(module.exports, "default", () => $dfaa058e2b80d56e$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8SlfA = parcelRequire("8SlfA");

var $lmBAt = parcelRequire("lmBAt");

var $euZim = parcelRequire("euZim");

var $3kNE6 = parcelRequire("3kNE6");

var $ilwFs = parcelRequire("ilwFs");

var $guHkC = parcelRequire("guHkC");

var $8gMyk = parcelRequire("8gMyk");

var $6crUM = parcelRequire("6crUM");

var $5k6Fi = parcelRequire("5k6Fi");
class $dfaa058e2b80d56e$export$5667c09b71ee0f05 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            isRenamable: true,
            isShadowVisible: false,
            isDragging: false,
            isUpdating: false,
            isDisabled: false,
            isDone: false,
            cardsCount: 0,
            totalCardsCount: 0,
            showTotalCardsCount: false,
            lozenges: null,
            validateRename: ()=>({
                    isValid: true,
                    message: null
                }),
            appearance: 'default',
            isCMPboard: false,
            isFlexibleColumns: false,
            shouldRemoveSpaceForMenu: false
        };
    }
    getColumnLozenges(lozenges) {
        if (!lozenges || lozenges.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8gMyk.default), {
            lozenges: lozenges,
            appearance: this.props.appearance
        });
    }
    render() {
        const { id: id, title: title, lozenges: lozenges, isShadowVisible: isShadowVisible, isUpdating: isUpdating, isDisabled: isDisabled, isDragging: isDragging, isRenamable: isRenamable, isDraggable: isDraggable, cardsCount: cardsCount, totalCardsCount: totalCardsCount, showTotalCardsCount: showTotalCardsCount, validateRename: validateRename, menu: menu, OverlayContent: OverlayContent, isMenuShown: isMenuShown, isDone: isDone, isCMPBoard: isCMPBoard, shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu, isFlexibleColumns: isFlexibleColumns, columnHeaderWrapperRef: columnHeaderWrapperRef } = this.props;
        const { isEditingTitle: isEditingTitle } = this.state;
        const isTitleDisabled = isDisabled || isDragging || !isRenamable;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dfaa058e2b80d56e$export$381ca84651f316ee, {
            isDragging: isDragging,
            isShadowVisible: isShadowVisible,
            isFlexibleColumns: isFlexibleColumns,
            ref: columnHeaderWrapperRef,
            ...(0, $lmBAt.getIsSoftwareThemingM2Enabled)() && {
                isMatrixLayout: this.props.isMatrixLayout
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5k6Fi.default), {
            id: id,
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6crUM.default), {
                columnId: id,
                text: title,
                visibleCount: cardsCount || 0,
                totalCount: totalCardsCount,
                showTotalCount: showTotalCardsCount,
                isDisabled: isTitleDisabled,
                onEditChange: this.onColumnTitleEditChange,
                onConfirm: this.props.onRename,
                onCancel: this.onColumnTitleEditCancel,
                lozenges: this.getColumnLozenges(lozenges),
                // @ts-expect-error - Type 'ValidateColumnCallback | undefined' is not assignable to type '(() => { isValid: boolean; message: null; }) | undefined'.
                validateColumn: validateRename,
                isDone: isDone,
                isCMPBoard: isCMPBoard,
                shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu
            }),
            titleHeadingText: title,
            isEditingTitle: isEditingTitle,
            isMenuShown: isMenuShown,
            isSpinnerVisible: isUpdating,
            isDragging: isDragging,
            isDraggable: isDraggable,
            menu: menu,
            onClick: this.onHeaderClick,
            OverlayContent: OverlayContent,
            appearance: this.props.appearance,
            isMatrixLayout: this.props.isMatrixLayout
        }), (isUpdating || isDisabled) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $guHkC.Overlay), {
            appearance: this.props.appearance ?? (0, $3kNE6.ColumnTheme).Default
        }));
    }
    constructor(...args){
        super(...args), this.state = {
            isEditingTitle: false
        }, this.onColumnTitleEditChange = (isEditingTitle)=>{
            this.setState({
                isEditingTitle: isEditingTitle
            });
            if (isEditingTitle && this.props.onEditStart) this.props.onEditStart();
        }, this.onColumnTitleEditCancel = (columnId, type)=>{
            this.props.onEditCancel && this.props.onEditCancel(columnId, type);
        }, this.onHeaderClick = ()=>{
            this.props.onHeaderClick && this.props.onHeaderClick();
        };
    }
}
const $dfaa058e2b80d56e$var$ColumnHeaderMain = ({ showShadowOnScroll: showShadowOnScroll, ...props })=>{
    const [hasScrollTop] = (0, $euZim.useBoardHasScrollTop)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dfaa058e2b80d56e$export$5667c09b71ee0f05, {
        ...props,
        isShadowVisible: showShadowOnScroll && hasScrollTop
    });
};
var $dfaa058e2b80d56e$export$2e2bcd8739ae039 = $dfaa058e2b80d56e$var$ColumnHeaderMain;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $dfaa058e2b80d56e$var$getColumnHeaderContainerBackground = (isDragging)=>{
    if (isDragging) return 'none';
    return "var(--ds-background-neutral, #091E420F)";
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dfaa058e2b80d56e$var$ColumnHeaderWrapperBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMatrixLayout: isMatrixLayout, isFlexibleColumns: isFlexibleColumns, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1o3jvi5": (0, $lD23V.default)($8SlfA["column-header"])
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1n261q9c _4t3in7od _1e0c1txw _1bah1y6m _4cvr1fhb",
            __cmplp.isMatrixLayout && (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? "_1pbykb7n" : "_1pbyegat",
            __cmplp.isFlexibleColumns && "_ylxr1dzp",
            __cmplp.className
        ])
    });
});
const $dfaa058e2b80d56e$export$381ca84651f316ee = (0, $ilwFs.isStickySupported) ? /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $dfaa058e2b80d56e$var$ColumnHeaderWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _2rkoi2wt _pdyk1p41 _1kt9b3bt _1cs8stnw _19wo1i6y _qnecidpf _oounidpf _kfgtyh40 _dsq4glyw _1rus10xm",
            __cmplp.isDragging ? "_kqswh2mm" : "_kqsw1if8",
            __cmplp.isMatrixLayout && (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? "_154i1ylp" : "_154iidpf",
            __cmplp.isShadowVisible ? "_154psxj9" : "_154pidpf",
            __cmplp.className
        ])
    });
}) : /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $dfaa058e2b80d56e$var$ColumnHeaderWrapperBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("euZim", function(module, exports) {

$parcel$export(module.exports, "useBoardScroll", () => $dbab512fdb684fa5$export$e8a9c7f59d1400dd);
$parcel$export(module.exports, "useBoardScrollLeft", () => $dbab512fdb684fa5$export$42c9508d539e562f);
$parcel$export(module.exports, "useBoardHasScrollLeft", () => $dbab512fdb684fa5$export$e9583811d4961272);
$parcel$export(module.exports, "useBoardScrollTop", () => $dbab512fdb684fa5$export$a4a2ab28f4bdd36b);
$parcel$export(module.exports, "useBoardHasScrollTop", () => $dbab512fdb684fa5$export$20ef285042532517);
$parcel$export(module.exports, "useBoardScrollIsAtRightEdge", () => $dbab512fdb684fa5$export$cac9ff2d8629bfb2);
$parcel$export(module.exports, "useBoardScrollApi", () => $dbab512fdb684fa5$export$be9b8d6afde7d0af);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $dbab512fdb684fa5$var$actions = {
    getBoardScroll: ()=>({ getState: getState })=>{
            const { onHorizontalScroll: onHorizontalScroll, ...state } = getState();
            return state;
        },
    onBoardScroll: (boardScrollPosition)=>({ setState: setState })=>{
            setState(boardScrollPosition);
        },
    onBoardScrollInit: (boardScrollPosition, onHorizontalScroll)=>({ setState: setState })=>{
            setState({
                ...boardScrollPosition,
                onHorizontalScroll: onHorizontalScroll
            });
        },
    onHorizontalScroll: (scrollLeft)=>({ getState: getState })=>{
            const { onHorizontalScroll: onHorizontalScroll } = getState();
            onHorizontalScroll(scrollLeft);
        }
};
const $dbab512fdb684fa5$var$boardScrollStore = (0, $iXqE5.createStore)({
    name: 'board-scroll',
    initialState: {
        scrollLeft: 0,
        scrollTop: 0,
        scrollWidth: 0,
        clientWidth: 0,
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onHorizontalScroll: ()=>{}
    },
    actions: $dbab512fdb684fa5$var$actions
});
const $dbab512fdb684fa5$export$e8a9c7f59d1400dd = (0, $3sQ5x.createHook)($dbab512fdb684fa5$var$boardScrollStore);
const $dbab512fdb684fa5$export$42c9508d539e562f = (0, $3sQ5x.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ scrollLeft: scrollLeft })=>scrollLeft
});
const $dbab512fdb684fa5$export$e9583811d4961272 = (0, $3sQ5x.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ scrollLeft: scrollLeft })=>!!scrollLeft
});
const $dbab512fdb684fa5$export$a4a2ab28f4bdd36b = (0, $3sQ5x.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ scrollTop: scrollTop })=>scrollTop
});
const $dbab512fdb684fa5$export$20ef285042532517 = (0, $3sQ5x.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ scrollTop: scrollTop })=>!!scrollTop
});
const $dbab512fdb684fa5$export$cac9ff2d8629bfb2 = (0, $3sQ5x.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: ({ clientWidth: clientWidth, scrollLeft: scrollLeft, scrollWidth: scrollWidth })=>scrollLeft === scrollWidth - clientWidth
});
const $dbab512fdb684fa5$export$be9b8d6afde7d0af = (0, $3sQ5x.createHook)($dbab512fdb684fa5$var$boardScrollStore, {
    selector: null
});

});

parcelRegister("guHkC", function(module, exports) {

$parcel$export(module.exports, "Overlay", () => $424069e3781e7d10$export$c6fdb837b070b4ff);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $g503o = parcelRequire("g503o");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424069e3781e7d10$export$c6fdb837b070b4ff = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { appearance: appearance, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_12nboa5": (0, $lD23V.default)((0, $g503o.columnThemes)[__cmplp.appearance].background)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _154iidpf _94n5idpf _tzy4105o",
            __cmplp.appearance ? "_bfhkqo2f" : "_bfhk73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g503o", function(module, exports) {

$parcel$export(module.exports, "columnThemes", () => $fe22a2a49fd3e2ba$export$18626b6d0fe527f4);
$parcel$export(module.exports, "ColumnWrapper", () => $fe22a2a49fd3e2ba$export$b904459935723643);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6cG4N = parcelRequire("6cG4N");

var $lmBAt = parcelRequire("lmBAt");

var $3kNE6 = parcelRequire("3kNE6");
const $fe22a2a49fd3e2ba$export$18626b6d0fe527f4 = {
    [(0, $3kNE6.ColumnTheme).Default]: {
        backgroundNew: (0, $6cG4N.Tokens).COLOR_ELEVATION_SURFACE_SUNKEN,
        background: "var(--ds-surface-sunken, #F7F8F9)",
        headerHover: "var(--ds-background-neutral-hovered, #091E4224)",
        btnHover: "var(--ds-background-neutral-hovered, #091E4224)",
        btnActive: "var(--ds-background-neutral-pressed, #091E424F)",
        btnIconHover: "var(--ds-background-neutral-hovered, #091E4224)",
        btnIconActive: "var(--ds-text-inverse, #FFFFFF)",
        titleEditHover: "var(--ds-background-neutral-subtle-hovered, #091E420F)"
    },
    [(0, $3kNE6.ColumnTheme).Warning]: {
        backgroundNew: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        background: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
        headerHover: "var(--ds-background-neutral-hovered, #091E4224)",
        btnHover: "var(--ds-background-warning-hovered, #F8E6A0)",
        btnActive: "var(--ds-background-warning-pressed, #F5CD47)",
        btnIconHover: "var(--ds-background-neutral-bold, #44546F)",
        btnIconActive: "var(--ds-text-inverse, #FFFFFF)",
        titleEditHover: "var(--ds-background-warning-hovered, #F8E6A0)"
    },
    [(0, $3kNE6.ColumnTheme).Danger]: {
        backgroundNew: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        background: "var(--ds-background-accent-red-subtlest, #FFECEB)",
        headerHover: "var(--ds-background-neutral-hovered, #091E4224)",
        btnHover: "var(--ds-background-warning-hovered, #F8E6A0)",
        btnActive: "var(--ds-background-warning-pressed, #F5CD47)",
        btnIconHover: "var(--ds-background-neutral-bold, #44546F)",
        btnIconActive: "var(--ds-text-inverse, #FFFFFF)",
        titleEditHover: "var(--ds-background-warning-hovered, #F8E6A0)"
    }
};
const $fe22a2a49fd3e2ba$var$getBackgroundColor = ()=>{
    if ((0, $lmBAt.getIsSoftwareThemingEnabled)()) return $fe22a2a49fd3e2ba$export$18626b6d0fe527f4[(0, $3kNE6.ColumnTheme).Default]?.backgroundNew ? $fe22a2a49fd3e2ba$export$18626b6d0fe527f4[(0, $3kNE6.ColumnTheme).Default]?.backgroundNew : "var(--ds-surface-sunken, #F7F8F9)";
    return $fe22a2a49fd3e2ba$export$18626b6d0fe527f4[(0, $3kNE6.ColumnTheme).Default]?.background ? $fe22a2a49fd3e2ba$export$18626b6d0fe527f4[(0, $3kNE6.ColumnTheme).Default]?.background : "var(--ds-surface-sunken, #F7F8F9)";
};
const $fe22a2a49fd3e2ba$export$b904459935723643 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCollapsed: isCollapsed, isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1jtound": (0, $lD23V.default)($fe22a2a49fd3e2ba$var$getBackgroundColor())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _16jlkb7n _1o9zkb7n _i0dl1wug _v5643711 _bfhkroa3 _kqswh2mm _1wpz1fhb _p12f1ogy _1ul91ogy",
            __cmplp.isCollapsed && "_bfhk18uv _1ul91ylp _p12f1ylp",
            __cmplp.isFlexible && "_1ul91w81 _p12fglyw",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ylp _p12fglyw",
            __cmplp.className
        ])
    });
});

});


parcelRegister("8gMyk", function(module, exports) {

$parcel$export(module.exports, "default", () => $47152e7cdab543be$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3u0c5 = parcelRequire("3u0c5");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8SlfA = parcelRequire("8SlfA");

var $dCm1o = parcelRequire("dCm1o");

var $b8gJu = parcelRequire("b8gJu");

var $3kNE6 = parcelRequire("3kNE6");
const $47152e7cdab543be$var$lozengeTypeAppearance = {
    maximum: 'removed',
    minimum: 'moved'
};
const $47152e7cdab543be$var$lozengeAppearanceMap = {
    default: 'default',
    warning: 'moved',
    danger: 'removed'
};
function $47152e7cdab543be$export$89e31ef8e83a0330(message, formatMessage) {
    if (message instanceof Object) return formatMessage(message.tooltip);
    return String(message);
}
function $47152e7cdab543be$export$d1dcfd32a1d228ca(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
columnAppearance, lozenge) {
    if (typeof lozenge !== 'object' || !('type' in lozenge)) return $47152e7cdab543be$var$lozengeAppearanceMap[columnAppearance ?? (0, $3kNE6.ColumnTheme).Default];
    if (columnAppearance === (0, $3kNE6.ColumnTheme).Default || lozenge.type == null) return 'default';
    const typeToAp = {
        maximum: 'danger',
        minimum: 'warning'
    };
    if (lozenge.type && typeToAp[lozenge.type] === columnAppearance) return $47152e7cdab543be$var$lozengeTypeAppearance[lozenge.type];
    return 'default';
}
function $47152e7cdab543be$export$4420ac7a34197e42(// eslint-disable-next-line @typescript-eslint/no-invalid-void-type
columnAppearance, lozenge) {
    // We need to override warning colors on this case only because of design
    // system differences with our warning color design.
    const minimumBustedColumn = columnAppearance === (0, $3kNE6.ColumnTheme).Warning && typeof lozenge === 'object' && 'type' in lozenge && lozenge.type === 'minimum' && lozenge.busted;
    return minimumBustedColumn ? "var(--ds-background-warning-bold, #F5CD47)" : undefined;
}
function $47152e7cdab543be$export$e69df631f99524e6(lozenge) {
    return typeof lozenge === 'object' && 'busted' in lozenge ? Boolean(lozenge.busted) : false;
}
function $47152e7cdab543be$export$7084996b13185bfe({ lozenge: lozenge, appearance: columnAppearance }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const lozengeAppearance = $47152e7cdab543be$export$d1dcfd32a1d228ca(columnAppearance, lozenge);
    const isBold = $47152e7cdab543be$export$e69df631f99524e6(lozenge);
    const style = {
        backgroundColor: $47152e7cdab543be$export$4420ac7a34197e42(columnAppearance, lozenge)
    };
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: lozengeAppearance === 'default' ? $8SlfA.defaultLozengeContainer : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: $47152e7cdab543be$export$89e31ef8e83a0330(lozenge, formatMessage)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: lozengeAppearance,
        isBold: isBold,
        testId: "platform-board-kit.common.ui.column-header.editable-title.column-title.lozanges.lozenge" // eslint-disable-next-line jira/react/no-style-attribute -- Ignored via go/DSP-18766
        ,
        style: style
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: $8SlfA.defaultLozenge
    }, lozenge instanceof Object ? formatMessage(lozenge.descriptor, lozenge.values) : String(lozenge)), lozengeAppearance !== 'default' && // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        className: $8SlfA.compactLozenge
    }, lozenge instanceof Object ? lozenge.values.count : String(lozenge))))));
}
function $47152e7cdab543be$var$ColumnTitleLozenges({ appearance: appearance, lozenges: lozenges }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47152e7cdab543be$var$LozengeWrapper, {
        "data-testid": "platform-board-kit.common.ui.column-header.editable-title.column-title.lozanges.lozenge-wrapper",
        "data-component-selector": (0, $b8gJu.COLUMN_TITLE_LOZENGES_SELECTOR_NAME),
        withVr: (0, $dCm1o.isVisualRefreshEnabled)()
    }, lozenges.map((lozenge, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($47152e7cdab543be$export$7084996b13185bfe, {
            appearance: appearance,
            lozenge: lozenge,
            key: index
        })));
}
var $47152e7cdab543be$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $47152e7cdab543be$var$ColumnTitleLozenges;
const $47152e7cdab543be$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpftgi _1e0c1txw",
            __cmplp ? "_19bvidpf" : "_19bvu2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("5k6Fi", function(module, exports) {

$parcel$export(module.exports, "default", () => $6987b2aef6aceebd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $84Tib = parcelRequire("84Tib");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $3JT92 = parcelRequire("3JT92");

var $lmBAt = parcelRequire("lmBAt");

var $dCm1o = parcelRequire("dCm1o");

var $3kNE6 = parcelRequire("3kNE6");

var $g503o = parcelRequire("g503o");
const $6987b2aef6aceebd$var$ColumnHeader = ({ id: id, menu: menu, title: title, onClick: onClick, isDragging: isDragging, appearance: appearance, isDraggable: isDraggable, isMenuShown: isMenuShown, isMenuEnabled: isMenuEnabled, OverlayContent: OverlayContent, isEditingTitle: isEditingTitle, titleHeadingText: titleHeadingText, isSpinnerVisible: isSpinnerVisible, isMatrixLayout: isMatrixLayout })=>{
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const [isContainerFocused, setIsContainerFocused] = (0, $5uXOq.useState)(false);
    const hasTemporaryId = (0, $5uXOq.useMemo)(()=>Number(id) <= 0, [
        id
    ]);
    const backgroundColor = (0, $5uXOq.useMemo)(()=>$6987b2aef6aceebd$var$getBackgroundColor(appearance ?? (0, $3kNE6.ColumnTheme).Default), [
        appearance
    ]);
    const isMenuTriggerShown = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($84Tib)))(isMenuShown) ? isMenuShown : isContainerFocused || isMenuOpen, [
        isMenuShown,
        isContainerFocused,
        isMenuOpen
    ]);
    const canShowMenu = (0, $5uXOq.useMemo)(()=>isMenuEnabled && !hasTemporaryId && !isEditingTitle && !isDragging, [
        isMenuEnabled,
        isEditingTitle,
        isDragging,
        hasTemporaryId
    ]);
    const dynamicBackgroundColorStyleOverride = null;
    const onMenuOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        setIsMenuOpen(attrs.isOpen);
    }, []);
    const renderMenu = (0, $5uXOq.useCallback)(()=>menu ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "platform-board-kit.common.ui.column-header.header.meatball",
            className: (0, $bwpsq.default)([
                $6987b2aef6aceebd$var$headerStyleMap.menuWrapperBase,
                canShowMenu && $6987b2aef6aceebd$var$headerStyleMap.menuWrapperVisibility,
                isMenuTriggerShown && $6987b2aef6aceebd$var$headerStyleMap.menuWrapperOpacity,
                "_fkwnaxbu"
            ]),
            style: {
                "--_1ly4823": (0, $lD23V.default)(backgroundColor)
            }
        }, /*#__PURE__*/ (0, $5uXOq.cloneElement)(menu, {
            title: titleHeadingText,
            onOpenChange: onMenuOpenChange
        })) : null, [
        canShowMenu,
        dynamicBackgroundColorStyleOverride,
        isMenuTriggerShown,
        menu,
        onMenuOpenChange,
        titleHeadingText
    ]);
    const onContainerFocus = (0, $5uXOq.useCallback)(()=>{
        if (canShowMenu) setIsContainerFocused(true);
    }, [
        canShowMenu
    ]);
    const onContainerBlur = ()=>{
        setIsContainerFocused(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onClick: onClick,
        testId: "platform-board-kit.common.ui.column-header.header.column-header-container",
        onFocus: onContainerFocus,
        onBlur: onContainerBlur,
        onMouseEnter: onContainerFocus,
        onMouseLeave: onContainerBlur,
        xcss: (0, $3JT92.cx)($6987b2aef6aceebd$var$headerStyleMap.columnHeaderContainerBase, isDraggable && $6987b2aef6aceebd$var$headerStyleMap.cursorGrab, // eslint-disable-next-line no-nested-ternary
        isMatrixLayout ? (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? $6987b2aef6aceebd$var$headerStyleMap.roundedBox : $6987b2aef6aceebd$var$headerStyleMap.roundedBoxOld : $6987b2aef6aceebd$var$headerStyleMap.roundedTopBorder),
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            backgroundColor: backgroundColor
        }
    }, OverlayContent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(OverlayContent, null), (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        alignBlock: "center",
        xcss: [
            $6987b2aef6aceebd$var$ColumnHeaderStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $6987b2aef6aceebd$var$headerStyleMap.titleWrapper
        ])
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $6987b2aef6aceebd$var$menuWrapperStyles
        ],
        // Prevent menu click to bubble up and fire header analytic event.
        onClick: (event)=>event.stopPropagation()
    }, renderMenu(), isSpinnerVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6987b2aef6aceebd$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6987b2aef6aceebd$var$TitleWrapperOld, null, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6987b2aef6aceebd$var$ColumnHeaderActionsOld, {
        // Prevent menu click to bubble up and fire header analytic event.
        onClick: (event)=>event.stopPropagation()
    }, renderMenu(), isSpinnerVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6987b2aef6aceebd$var$SpinnerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    })))));
};
$6987b2aef6aceebd$var$ColumnHeader.defaultProps = {
    isDragging: false,
    isDraggable: false,
    isSpinnerVisible: false,
    isMenuEnabled: true,
    isEditingTitle: false
};
var $6987b2aef6aceebd$export$2e2bcd8739ae039 = $6987b2aef6aceebd$var$ColumnHeader;
const $6987b2aef6aceebd$var$getBackgroundColor = (appearance)=>{
    return (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $g503o.columnThemes)[appearance].backgroundNew : (0, $g503o.columnThemes)[appearance].background;
};
const $6987b2aef6aceebd$var$SpinnerContainer = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6987b2aef6aceebd$var$refactoredSpinnerStyle
    }, children);
const $6987b2aef6aceebd$var$headerStyleMap = {
    columnHeaderContainerBase: "_v564mfn2 _uiztglyw _1bsb1osq _p12f1osq _vchhusvi _4t3ickbl _kqswh2mm",
    cursorGrab: "_80om1qgj",
    menuWrapperBase: "_3um015vq _tzy4idpf _1bsbidpf",
    menuWrapperVisibility: "_3um0ewfl",
    menuWrapperOpacity: "_tzy4kb7n _1bsb1wug _u5f31b66",
    titleWrapper: "_16jlkb7n _1o9zkb7n _i0dl1wug _1ul9idpf _nt751r31 _49pcglyw _1hvw1o36 _7ehi9g9j",
    roundedBox: "_2rkoi2wt",
    roundedBoxOld: "_2rkoi2wt _otyru2gc",
    roundedTopBorder: "_13lii2wt _qrwqi2wt"
};
const $6987b2aef6aceebd$var$refactoredSpinnerStyle = (0, $8CUq3.xcss)({
    paddingRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6987b2aef6aceebd$var$ColumnHeaderActionsOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1xi2u2gc _154i1ejb _t9ec1i34",
            __cmplp.className
        ])
    });
});
const $6987b2aef6aceebd$var$ColumnHeaderStyles = (0, $8CUq3.xcss)({
    height: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6987b2aef6aceebd$var$TitleWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx21bp4 _1n261q9c _16jlkb7n _1o9zkb7n _i0dl1wug _1e0c1txw _1bah1h6o _4cvr1fhb _1wpz1wug _p12f1osq _ca0qpxbi _u5f3idpf _n3tdpxbi _19bvidpf _1bsb1osq _4t3i1j2a _nt751r31 _49pcglyw _1hvw1o36 _7ehi64oc",
            __cmplp.className
        ])
    });
});
const $6987b2aef6aceebd$var$menuWrapperStyles = (0, $8CUq3.xcss)({
    flexShrink: 0,
    width: "var(--ds-space-400, 32px)"
});

});




parcelRegister("aXl6d", function(module, exports) {

$parcel$export(module.exports, "useHasGroupingStyle", () => $9c83e3542e0affa6$export$b4a1496f12b8cd95);

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $67sX6 = parcelRequire("67sX6");

var $45cXl = parcelRequire("45cXl");
const $9c83e3542e0affa6$export$b4a1496f12b8cd95 = ()=>{
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    if (!(0, $lmBAt.getIsSoftwareThemingEnabled)() || !hasSoftwareTheming) return false;
    if (!!swimlaneMode && swimlaneMode !== 'NO_SWIMLANE') return true;
    return false;
};

});


parcelRegister("3nIju", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad74bb09a2893594$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $2gCtH = parcelRequire("2gCtH");

var $5Emok = parcelRequire("5Emok");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $4R6GH = parcelRequire("4R6GH");

var $lmBAt = parcelRequire("lmBAt");

var $67Z81 = parcelRequire("67Z81");

var $2xFXk = parcelRequire("2xFXk");

var $cW3pH = parcelRequire("cW3pH");

var $kc6Ry = parcelRequire("kc6Ry");

var $fqLDH = parcelRequire("fqLDH");

var $6g14V = parcelRequire("6g14V");

var $9OPlz = parcelRequire("9OPlz");
const $ad74bb09a2893594$export$c31df4bd766f9c35 = (state)=>({
        getIssueKeyForModal: (0, $fqLDH.getIssueKeyForModal)(state),
        isInsightsPanelOpen: (0, $6g14V.getInsightsPanel)(state),
        flexibleColumns: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS),
        showTransitionZones: !!(0, $9OPlz.getDraggingCardId)(state),
        isCMPBoard: (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $67Z81.getIsCMPBoard)(state) : undefined
    });
const $ad74bb09a2893594$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $ad74bb09a2893594$var$onBoardViewFactory = (0, $8QpSo.default)((dispatch)=>(boardInfo, analyticsEvent)=>dispatch((0, $cW3pH.boardView)({
            ...boardInfo
        }, analyticsEvent)));
const $ad74bb09a2893594$var$onScrollFactory = (0, $8QpSo.default)(()=>(boardScrollInfo, analyticsEvent)=>{
        const { reachedLeftEdge: reachedLeftEdge, reachedRightEdge: reachedRightEdge } = boardScrollInfo;
        if (reachedLeftEdge || reachedRightEdge) {
            const payload = {
                reachedLeftEdge: reachedLeftEdge,
                reachedRightEdge: reachedRightEdge
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, payload);
        }
    });
const $ad74bb09a2893594$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        getIssueKeyForModal: stateProps.getIssueKeyForModal,
        isInsightsPanelOpen: stateProps.isInsightsPanelOpen,
        flexibleColumns: stateProps.flexibleColumns,
        showTransitionZones: (0, $4R6GH.fg)('avoid_board_scroll_container_style_changes') ? stateProps.showTransitionZones : undefined,
        onBoardView: $ad74bb09a2893594$var$onBoardViewFactory(dispatchProps.dispatch),
        externalId: 'software.board',
        onScroll: $ad74bb09a2893594$var$onScrollFactory(),
        isCMPBoard: (0, $lmBAt.getIsSoftwareThemingEnabled)() ? stateProps.isCMPBoard : undefined
    });
const $ad74bb09a2893594$var$withOffsetRightPaddingByWidth = (WrappedComponent)=>(props)=>{
        const viewMode = (0, $2gCtH.useViewMode)();
        const { getIssueKeyForModal: getIssueKeyForModalProp, isInsightsPanelOpen: isInsightsPanelOpenProp, ...rest } = props;
        const offsetRightPaddingByWidth = viewMode === 'SIDEBAR' && getIssueKeyForModalProp || isInsightsPanelOpenProp;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...rest,
            offsetRightPaddingByWidth: offsetRightPaddingByWidth
        });
    };
const $ad74bb09a2893594$var$connector = (0, $bC2fB.connect)($ad74bb09a2893594$export$c31df4bd766f9c35, $ad74bb09a2893594$export$9e6a17cf56877796, $ad74bb09a2893594$export$9d1611c77c2fe928);
var $ad74bb09a2893594$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('board', {
    onBoardView: 'viewed',
    onScroll: 'scrolled'
}), $ad74bb09a2893594$var$withOffsetRightPaddingByWidth, $ad74bb09a2893594$var$connector)((0, $5Emok.default));

});
parcelRegister("5Emok", function(module, exports) {

$parcel$export(module.exports, "default", () => $0618b4b5c0e926e8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $645AZ = parcelRequire("645AZ");

var $43IRS = parcelRequire("43IRS");

var $d1Nys = parcelRequire("d1Nys");

var $haPqS = parcelRequire("haPqS");
// TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0618b4b5c0e926e8$var$BoardContainerControl = /*#__PURE__*/ (0, $47bDC.default).section.withConfig({
    componentId: "hszmvp-0"
})`display:flex;flex-flow:row nowrap;justify-content:flex-start;align-items:stretch;user-select:none;padding:${(props)=>{
    if (props.isVisualRefresh) return `0 ${props.offsetRightPaddingByWidth ? "var(--ds-space-300, 24px)" : '0'} ${"var(--ds-space-300, 24px)"} ${"var(--ds-space-250, 20px)"}`;
    if (props.flexibleColumns) return `0 ${props.offsetRightPaddingByWidth ? "var(--ds-space-300, 24px)" : `${(0, $645AZ.layout).boardBorderWidth}px`} ${(0, $645AZ.layout).boardBorderWidth}px ${(0, $645AZ.layout).boardBorderWidth - (0, $645AZ.layout).columnMargin}px`;
    return `0 0 ${(0, $645AZ.layout).boardBorderWidth}px ${(0, $645AZ.layout).boardBorderWidth - (0, $645AZ.layout).cardListRadius}px`;
}};${(props)=>props.noBottomPadding ? 'padding-bottom: 0' : ''};min-width:fit-content;`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0618b4b5c0e926e8$var$BoardContainerExperimentBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "section", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { flexibleColumns: flexibleColumns, noBottomPadding: noBottomPadding, isVisualRefresh: isVisualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1da43ya": (0, $lD23V.default)(!__cmplp.flexibleColumns && "var(--ds-space-0, 0px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx2vrvc _1n261q9c _1e0c1txw _1bah1y6m _4cvr1fhb _uiztglyw _ca0qze3t _u5f31r1l _1ul91ns9",
            __cmplp.noBottomPadding ? "_n3tdze3t" : __cmplp.isVisualRefresh ? "_n3td1ejb" : "_n3td1ylp",
            __cmplp.isVisualRefresh ? "_19bvv47k" : __cmplp.flexibleColumns ? "_19bv1u1b" : "_19bv1u1b",
            (0, $4R6GH.fg)('avoid_board_scroll_container_style_changes') && "_1tke1osq",
            (0, $4R6GH.fg)('avoid_board_scroll_container_style_changes') && "_vchhusvi",
            __cmplp.className
        ])
    });
});
const $0618b4b5c0e926e8$var$BoardContainerExperiment = // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0618b4b5c0e926e8$var$BoardContainerExperimentBase, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.offsetRightPaddingByWidth || __cmplp.isVisualRefresh ? "_u5f31ejb" : "_u5f31ylp",
            __cmplp.isSoftwareThemingEnabled && __cmplp.isCMPBoard && "_zulpu2gc",
            __cmplp.className
        ])
    });
}); // Reduced left padding for the board if we have both the unscheduled work panel
const $0618b4b5c0e926e8$var$BoardContainerWithUnscheduledWorkPanel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0618b4b5c0e926e8$var$BoardContainerExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0618b4b5c0e926e8$var$UnscheduledWorkBoardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $0618b4b5c0e926e8$var$BoardContainerExperiment, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bvze3t _u5f3ze3t",
            __cmplp.className
        ])
    });
});
const $0618b4b5c0e926e8$var$BoardContainer = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $0618b4b5c0e926e8$var$BoardContainerExperiment, $0618b4b5c0e926e8$var$BoardContainerControl);
class $0618b4b5c0e926e8$export$dc537a3a3893548e extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            offsetRightPaddingByWidth: false,
            offsetLeftPaddingByWidth: false,
            noBottomPadding: false,
            onScroll: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onBoardView: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            flexibleColumns: false,
            isDropDisabled: false,
            isUnscheduledWorkColumnPanel: false,
            isBoardWithVisibleUnscheduledWorkPanel: false,
            isCMPBoard: false
        };
    }
    render() {
        const { flexibleColumns: flexibleColumns, noBottomPadding: noBottomPadding, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, isBoardWithVisibleUnscheduledWorkPanel: isBoardWithVisibleUnscheduledWorkPanel, showTransitionZones: showTransitionZones } = this.props;
        const leftBorder = !flexibleColumns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1Nys.LeftBorder), {
            offsetLeftPaddingByWidth: this.props.offsetLeftPaddingByWidth
        });
        const rightBorder = !flexibleColumns && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d1Nys.RightBorder), {
            offsetRightPaddingByWidth: this.props.offsetRightPaddingByWidth
        });
        const boardContainerChild = flexibleColumns ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $43IRS.TransitionZoneIndicatorContainerProvider), null, leftBorder, this.props.children, rightBorder) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, leftBorder, this.props.children, rightBorder);
        const shouldUseBoardWithUnscheduledWorkPanelPadding = !isUnscheduledWorkColumnPanel && !!isBoardWithVisibleUnscheduledWorkPanel;
        const BoardContainerWithAdjustedPadding = shouldUseBoardWithUnscheduledWorkPanelPadding ? $0618b4b5c0e926e8$var$BoardContainerWithUnscheduledWorkPanel : $0618b4b5c0e926e8$var$BoardContainer;
        const Container = isUnscheduledWorkColumnPanel ? $0618b4b5c0e926e8$var$UnscheduledWorkBoardContainer : BoardContainerWithAdjustedPadding;
        const boardContainer = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Container, {
            flexibleColumns: flexibleColumns,
            noBottomPadding: noBottomPadding,
            offsetRightPaddingByWidth: this.props.offsetRightPaddingByWidth,
            isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
            isSoftwareThemingEnabled: (0, $lmBAt.getIsSoftwareThemingEnabled)(),
            isCMPBoard: (0, $lmBAt.getIsSoftwareThemingEnabled)() ? this.props.isCMPBoard : undefined
        }, boardContainerChild);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haPqS.default), {
            innerRef: this.props.scrollRef,
            onScroll: this.onScroll,
            onInit: this.onScrollInit,
            flexibleColumns: flexibleColumns,
            showTransitionZones: showTransitionZones
        }, boardContainer);
    }
    constructor(...args){
        super(...args), this.topEdge = true, this.leftEdge = true, this.rightEdge = true, this.onScrollInit = ({ hasHorizontalScrollbar: hasHorizontalScrollbar })=>{
            this.props.onBoardView({
                hasHorizontalScrollbar: hasHorizontalScrollbar,
                isUnscheduledWorkColumnPanel: this.props.isUnscheduledWorkColumnPanel
            });
        }, this.onScroll = (scrollInfo)=>{
            const { topEdge: topEdge, leftEdge: leftEdge, rightEdge: rightEdge } = this;
            if (scrollInfo.topEdge !== topEdge) this.topEdge = scrollInfo.topEdge;
            if (scrollInfo.leftEdge !== leftEdge) this.leftEdge = scrollInfo.leftEdge;
            if (scrollInfo.rightEdge !== rightEdge) this.rightEdge = scrollInfo.rightEdge;
            const boardScrollInfo = {
                scrollLeft: scrollInfo.scrollLeft,
                scrollTop: scrollInfo.scrollTop,
                scrollWidth: scrollInfo.scrollWidth,
                clientWidth: scrollInfo.clientWidth,
                reachedLeftEdge: !leftEdge && scrollInfo.leftEdge,
                reachedRightEdge: !rightEdge && scrollInfo.rightEdge
            };
            this.props.onScroll(boardScrollInfo);
        };
    }
}
var $0618b4b5c0e926e8$export$2e2bcd8739ae039 = $0618b4b5c0e926e8$export$dc537a3a3893548e;

});
parcelRegister("43IRS", function(module, exports) {

$parcel$export(module.exports, "TransitionZoneIndicatorContainerContext", () => $6fa57b6df684876d$export$b355823f25623ef7);
$parcel$export(module.exports, "TransitionZoneIndicatorContainerProvider", () => $6fa57b6df684876d$export$ebac9eb10481c829);

var $5uXOq = parcelRequire("5uXOq");
const $6fa57b6df684876d$export$b355823f25623ef7 = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $6fa57b6df684876d$export$ebac9eb10481c829 = ({ children: children })=>{
    const contextValue = (0, $5uXOq.useMemo)(()=>{
        const transitionZoneIndicatorRefMap = {};
        return {
            setRef: (id, ref)=>{
                transitionZoneIndicatorRefMap[id] = ref;
            },
            getRef: (id)=>transitionZoneIndicatorRefMap[id],
            removeRef: (id)=>{
                delete transitionZoneIndicatorRefMap[id];
            }
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6fa57b6df684876d$export$b355823f25623ef7.Provider, {
        value: contextValue
    }, children);
};

});

parcelRegister("d1Nys", function(module, exports) {

$parcel$export(module.exports, "LeftBorder", () => $381c281f5cbbb40a$export$2fa3cb6a784774af);
$parcel$export(module.exports, "RightBorder", () => $381c281f5cbbb40a$export$e6fd94403eb46f0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dCm1o = parcelRequire("dCm1o");

var $a2e2Q = parcelRequire("a2e2Q");

var $ilwFs = parcelRequire("ilwFs");

var $euZim = parcelRequire("euZim");
const $381c281f5cbbb40a$var$shadowWidth = 7;
const $381c281f5cbbb40a$export$2fa3cb6a784774af = ({ offsetLeftPaddingByWidth: offsetLeftPaddingByWidth })=>{
    const [hasScrollLeft] = (0, $euZim.useBoardHasScrollLeft)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($381c281f5cbbb40a$var$BoardBorderLeftStyle, {
        isShadowVisible: hasScrollLeft,
        offsetLeftPaddingByWidth: offsetLeftPaddingByWidth,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
        isThemed: isSoftwareFullTheming
    });
};
const $381c281f5cbbb40a$export$e6fd94403eb46f0 = ({ offsetRightPaddingByWidth: offsetRightPaddingByWidth })=>{
    const [isAtRightScrollEdge] = (0, $euZim.useBoardScrollIsAtRightEdge)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($381c281f5cbbb40a$var$BoardBorderRightStyle, {
        isShadowVisible: !isSoftwareFullTheming && !isAtRightScrollEdge,
        offsetRightPaddingByWidth: offsetRightPaddingByWidth,
        isVisualRefresh: (0, $dCm1o.isVisualRefreshEnabled)(),
        isThemed: isSoftwareFullTheming
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $381c281f5cbbb40a$var$BoardBorderStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisualRefresh: isVisualRefresh, isShadowVisible: isShadowVisible, isThemed: isThemed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_x2xsiy": (0, $lD23V.default)(!(0, $ilwFs.isStickySupported) ? 'none' : '')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v5641p41 _1e0ctqga _kqsw1if8 _1pby1yp1",
            __cmplp.isVisualRefresh ? "_1bsb1ejb" : "_1bsb1ylp",
            __cmplp.isShadowVisible ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.isShadowVisible ? "_lcxv1wug" : "_lcxvglyw",
            !__cmplp.isThemed && "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $381c281f5cbbb40a$var$BoardBorderLeftStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $381c281f5cbbb40a$var$BoardBorderStyle, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ltvidpf _16qs10uo _mkrzvwc9",
            __cmplp.isVisualRefresh ? "_18u010v4" : "_18u010j7",
            __cmplp.offsetLeftPaddingByWidth && "_1bsb1v6z",
            __cmplp.className
        ])
    });
});
const $381c281f5cbbb40a$var$BoardBorderRightStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $381c281f5cbbb40a$var$BoardBorderStyle, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16qs1ist _mkrz1998",
            __cmplp.offsetRightPaddingByWidth ? "_1bsb1v6z _18u016fl _1xi216fl" : "_1xi2idpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("haPqS", function(module, exports) {

$parcel$export(module.exports, "default", () => $7c4966d4198ff79c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $lODMY = parcelRequire("lODMY");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $eeXsz = parcelRequire("eeXsz");

var $fEr2a = parcelRequire("fEr2a");

var $b8gJu = parcelRequire("b8gJu");

var $645AZ = parcelRequire("645AZ");

var $euZim = parcelRequire("euZim");
class $7c4966d4198ff79c$export$142e061c8a488301 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), // scrollElementHeight is used to calculate the height of transition zone
        // set to minCardHeight by default
        // Remove when cleaning up avoid_board_scroll_container_style_changes
        this.state = {
            scrollElementHeight: (0, $645AZ.minCardHeight),
            scrollElementWidth: 0
        }, this.scrollElementDimensionFrameId = null, this.scrollElementResizeCallback = ()=>{
            this.handleScrollEvent();
            if (!(0, $4R6GH.fg)('avoid_board_scroll_container_style_changes')) this.setScrollElementDimension();
        }, // Remove when cleaning up avoid_board_scroll_container_style_changes
        this.setScrollElementDimension = ()=>{
            if (!this.props.flexibleColumns) return;
            if (this.scrollElementDimensionFrameId != null) cancelAnimationFrame(this.scrollElementDimensionFrameId);
            this.scrollElementDimensionFrameId = requestAnimationFrame(()=>{
                const scrollElement = this.getScrollElement();
                if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(scrollElement) && (scrollElement.clientHeight !== this.state.scrollElementHeight || scrollElement.clientWidth !== this.state.scrollElementWidth)) {
                    if ((0, $3HwlS.getWillShowNav4)()) // When using Nav4 we need to subtract 32 from the height to prevent the scroll element height from
                    // infinitely growing, see https://jplat.atlassian.net/browse/BLU-3447
                    this.setState({
                        scrollElementHeight: scrollElement.clientHeight - 32,
                        scrollElementWidth: scrollElement.clientWidth
                    });
                    else this.setState({
                        scrollElementHeight: scrollElement.clientHeight,
                        scrollElementWidth: scrollElement.clientWidth
                    });
                }
            });
        }, this.resizeObserver = null, this.getScrollElement = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage, @typescript-eslint/no-non-null-assertion
            (!false ? this.scrollElRef.current : this.scrollEl) ?? window.document.body, this.onHorizontalScroll = (scrollLeft)=>{
            requestAnimationFrame(()=>{
                if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) return;
                this.getScrollElement().scrollLeft = scrollLeft;
            });
        }, this.setScrollEl = (scrollEl)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(scrollEl)) return;
            if (!false) this.scrollElRef.current = scrollEl;
            else this.scrollEl = scrollEl;
            // Only notify any other listeners if we have any
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.props.innerRef)) return;
            const { innerRef: innerRef } = this.props;
            if (typeof innerRef === 'function') innerRef(this.getScrollElement()); // ref={ref => someRef = ref}
            else // WindowRef passed from BoardContainer -> Board -> This
            innerRef.current = this.getScrollElement();
        }, this.getBoardScrollPosition = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) return {
                scrollTop: 0,
                scrollLeft: 0,
                scrollWidth: 0,
                clientWidth: 0
            };
            const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.getScrollElement();
            return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft,
                scrollWidth: scrollWidth,
                clientWidth: clientWidth
            };
        }, this.getLegacyBoardScrollInfo = ()=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) return {
                scrollTop: 0,
                scrollLeft: 0,
                scrollWidth: 0,
                clientWidth: 0,
                leftEdge: true,
                topEdge: true,
                rightEdge: false
            };
            const { scrollLeft: scrollLeft, scrollTop: scrollTop, scrollWidth: scrollWidth, clientWidth: clientWidth } = this.getScrollElement();
            return {
                scrollTop: scrollTop,
                scrollLeft: scrollLeft,
                scrollWidth: scrollWidth,
                clientWidth: clientWidth,
                leftEdge: scrollLeft === 0,
                topEdge: scrollTop === 0,
                rightEdge: scrollLeft === scrollWidth - clientWidth
            };
        }, this.handleScrollEvent = ()=>{
            if (this.scrollMeasureFrameId != null) cancelAnimationFrame(this.scrollMeasureFrameId);
            this.scrollMeasureFrameId = requestAnimationFrame(()=>{
                this.props.onBoardScroll(this.getBoardScrollPosition());
                this.props.onScroll(this.getLegacyBoardScrollInfo());
            });
        }, this.scrollMeasureFrameId = null, this.scrollEl = null, this.hideOverflow = (0, $4R6GH.fg)('jira_board_embed_scroll_bar_bugfix') && !!this.props.isEmbedView;
        this.scrollElRef = /*#__PURE__*/ (0, $5uXOq.createRef)();
    }
    componentDidMount() {
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) this.getScrollElement().addEventListener('scroll', this.handleScrollEvent);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener((0, $b8gJu.UPDATE_BOARD_SCROLL_POSITION), this.handleScrollEvent);
        if (this.scrollElRef.current && typeof ResizeObserver !== 'undefined') {
            this.resizeObserver = new ResizeObserver(this.scrollElementResizeCallback);
            this.resizeObserver.observe(this.scrollElRef.current);
        }
        this.props.onBoardScrollInit(this.getBoardScrollPosition(), this.onHorizontalScroll);
        this.props.onInit({
            hasHorizontalScrollbar: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement()) && this.getScrollElement().scrollWidth > this.getScrollElement().clientWidth
        });
    }
    componentWillUnmount() {
        if (this.scrollMeasureFrameId != null) cancelAnimationFrame(this.scrollMeasureFrameId);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(this.getScrollElement())) this.getScrollElement().removeEventListener('scroll', this.handleScrollEvent);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener((0, $b8gJu.UPDATE_BOARD_SCROLL_POSITION), this.handleScrollEvent);
        this.resizeObserver?.disconnect();
    }
    render() {
        if (!(0, $4R6GH.fg)('avoid_board_scroll_container_style_changes')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c4966d4198ff79c$var$StyledBoard, {
            ref: this.setScrollEl,
            "data-testid": "platform-board-kit.ui.board.scroll.board-scroll",
            // eslint-disable-next-line jira/react/no-style-attribute -- Ignored via go/DSP-18766
            style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            {
                '--board-scroll-element-height': this.state.scrollElementHeight,
                '--board-scroll-element-width': this.state.scrollElementWidth,
                overflow: this.hideOverflow ? 'hidden' : 'auto'
            }
        }, this.props.children);
        if (this.props.showTransitionZones) {
            const scrollElement = this.getScrollElement();
            const adjustedScrollElementHeight = Math.max((0, $3HwlS.getWillShowNav4)() ? scrollElement.clientHeight - 32 : scrollElement.clientHeight, (0, $645AZ.minCardHeight));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                ref: this.setScrollEl,
                "data-testid": "platform-board-kit.ui.board.scroll.board-scroll",
                // eslint-disable-next-line jira/react/no-style-attribute
                style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    '--board-scroll-element-height': adjustedScrollElementHeight,
                    '--board-scroll-element-width': scrollElement.clientWidth
                },
                className: (0, $bwpsq.default)([
                    "_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _c71l1osq _4t3i1osq _kqswh2mm _m6k4brmi",
                    this.hideOverflow ? "_1reo15vq _18m915vq" : "_1reo1wug _18m91wug"
                ])
            }, this.props.children);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: this.setScrollEl,
            "data-testid": "platform-board-kit.ui.board.scroll.board-scroll",
            className: (0, $bwpsq.default)([
                "_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _c71l1osq _4t3i1osq _kqswh2mm _m6k4brmi",
                this.hideOverflow ? "_1reo15vq _18m915vq" : "_1reo1wug _18m91wug"
            ])
        }, this.props.children);
    }
}
const $7c4966d4198ff79c$var$BoardScrollMain = (props)=>{
    const [, { onBoardScroll: onBoardScroll, onBoardScrollInit: onBoardScrollInit }] = (0, $euZim.useBoardScrollApi)();
    const isEmbedRoute = (0, $lODMY.useIsActiveRoute)(new Set([
        (0, $eeXsz.softwareBoardEmbedRoute).name,
        (0, $fEr2a.classicSoftwareBoardEmbedRoute).name
    ]));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7c4966d4198ff79c$export$142e061c8a488301, {
        ...props,
        isEmbedView: isEmbedRoute,
        onBoardScrollInit: onBoardScrollInit,
        onBoardScroll: onBoardScroll
    });
};
var $7c4966d4198ff79c$export$2e2bcd8739ae039 = $7c4966d4198ff79c$var$BoardScrollMain;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7c4966d4198ff79c$var$StyledBoard = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1bsb1osq _c71l1osq _4t3i1osq _kqswh2mm _m6k4brmi",
            __cmplp.className
        ])
    });
});
const $7c4966d4198ff79c$var$scrollContainerStyles = null;
const $7c4966d4198ff79c$var$hiddenScrollStyles = null;
const $7c4966d4198ff79c$var$autoScrollStyles = null;

});



parcelRegister("d6mgg", function(module, exports) {

$parcel$export(module.exports, "default", () => $10e952bed2e94360$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $2NMNM = parcelRequire("2NMNM");

var $bC2fB = parcelRequire("bC2fB");

var $fUHZ2 = parcelRequire("fUHZ2");


var $iuuJH = parcelRequire("iuuJH");

var $bRqd3 = parcelRequire("bRqd3");

var $2f454 = parcelRequire("2f454");

var $cAxle = parcelRequire("cAxle");

var $dW1HX = parcelRequire("dW1HX");

var $71oFY = parcelRequire("71oFY");

var $k50Aq = parcelRequire("k50Aq");

var $9OPlz = parcelRequire("9OPlz");

var $fqLDH = parcelRequire("fqLDH");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $5v2jP = parcelRequire("5v2jP");

var $gZTZk = parcelRequire("gZTZk");
const $10e952bed2e94360$export$c31df4bd766f9c35 = (state)=>{
    const activeIssueKey = (0, $9OPlz.getCardActiveKey)(state);
    const activeIssueId = (0, $9OPlz.getCardActive)(state);
    const activeIssueAssignee = (0, $9OPlz.getCardActiveAssignee)(state);
    const currentUserAccountId = (0, $36pz7.getCurrentUserAccountId)(state);
    const issueKeyForModal = (0, $fqLDH.getIssueKeyForModal)(state);
    const swimlaneIds = (0, $5mTgl.platformSwimlaneIdsSelector)(state);
    const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    return {
        activeIssueKey: activeIssueKey,
        activeIssueId: activeIssueId,
        activeIssueAssignee: activeIssueAssignee,
        currentUserAccountId: currentUserAccountId,
        issueKeyForModal: issueKeyForModal,
        swimlaneIds: swimlaneIds,
        hasSwimlanes: hasSwimlanes,
        isCMPBoard: isCMPBoard
    };
};
const $10e952bed2e94360$var$bentoShortcutsAnalyticsMap = {
    [(0, $e7036201fc72e756$export$e2291655ce717023)]: 'assignIssueKeyboardShortcut',
    [(0, $e7036201fc72e756$export$4834da14f7c856f4)]: 'editIssueLabelsKeyboardShortcut',
    [(0, $e7036201fc72e756$export$1303babe27c61a83)]: 'commentIssueKeyboardShortcut'
};
const $10e952bed2e94360$export$9e6a17cf56877796 = (dispatch, { fireShortcutAnalytics: fireShortcutAnalytics, analyticsEvent: analyticsEvent })=>{
    const onNextIssue = ()=>{
        // @ts-expect-error - Argument of type '{ type: string; payload: { fireShortcutAnalyticsFn: FireShortcutAnalyticsFn; }; }' is not assignable to parameter of type 'Action'.
        dispatch((0, $2f454.cardNext)(fireShortcutAnalytics));
    };
    const onPrevIssue = ()=>{
        // @ts-expect-error - Argument of type '{ type: string; payload: { fireShortcutAnalyticsFn: FireShortcutAnalyticsFn; }; }' is not assignable to parameter of type 'Action'.
        dispatch((0, $2f454.cardPrev)(fireShortcutAnalytics));
    };
    const onNextColumn = ()=>{
        // @ts-expect-error - Argument of type '{ type: string; payload: { fireShortcutAnalyticsFn: FireShortcutAnalyticsFn; }; }' is not assignable to parameter of type 'Action'.
        dispatch((0, $2f454.cardNextColumn)(fireShortcutAnalytics));
    };
    const onPrevColumn = ()=>{
        // @ts-expect-error - Argument of type '{ type: string; payload: { fireShortcutAnalyticsFn: FireShortcutAnalyticsFn; }; }' is not assignable to parameter of type 'Action'.
        dispatch((0, $2f454.cardPrevColumn)(fireShortcutAnalytics));
    };
    // @ts-expect-error - TS7006 - Parameter 'placement' implicitly has an 'any' type.
    const onMoveToTopOrBottomOfContainer = (placement)=>{
        dispatch((0, $71oFY.issueMoveToTopOrBottomOfContainer)(placement, fireShortcutAnalytics, analyticsEvent));
    };
    const onAssignToMe = (activeIssueId, activeIssueAssignee, currentUserAccountId)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueId)) return;
        const assigneeAccountId = currentUserAccountId === activeIssueAssignee ? null : currentUserAccountId;
        dispatch((0, $cAxle.assignToMeRequestThrottled)(activeIssueId, assigneeAccountId, fireShortcutAnalytics));
    };
    const onToggleBentoViewForFocusedCard = (activeIssueKey, issueKeyForModal, isDetailViewInSidebar)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueKey)) return;
        let isOpeningDetailsView;
        if (issueKeyForModal === activeIssueKey) {
            // If modal is currently open, this shortcut does not close the modal,
            // (since Bento would be in control). This however will close an open sidebar.
            dispatch((0, $dW1HX.closeIssueModal)(activeIssueKey));
            isOpeningDetailsView = false;
        } else {
            dispatch((0, $dW1HX.openIssueModal)(activeIssueKey));
            isOpeningDetailsView = true;
        }
        fireShortcutAnalytics({
            key: 't',
            id: 'toggleDetailsViewKeyboardShortcut',
            attributes: {
                toggled: isOpeningDetailsView ? 'open' : 'closed',
                issueView: isDetailViewInSidebar ? 'sideView' : 'modalView'
            }
        });
    };
    const onOpenAndFocusBentoField = (shortcutKey, activeIssueKey)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueKey)) return;
        const externalAction = (0, $5v2jP.getExternalActionForKey)(shortcutKey);
        if (!externalAction) return;
        dispatch((0, $dW1HX.openIssueModal)(activeIssueKey, externalAction));
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly a: "assignIssueKeyboardShortcut"; readonly l: "editIssueLabelsKeyboardShortcut"; readonly m: "commentIssueKeyboardShortcut"; }'.
        if ($10e952bed2e94360$var$bentoShortcutsAnalyticsMap[shortcutKey]) fireShortcutAnalytics({
            key: shortcutKey,
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly a: "assignIssueKeyboardShortcut"; readonly l: "editIssueLabelsKeyboardShortcut"; readonly m: "commentIssueKeyboardShortcut"; }'.
            id: $10e952bed2e94360$var$bentoShortcutsAnalyticsMap[shortcutKey]
        });
    };
    // remove onShowHideMenu when removing Capability.IS_TAB_NAVIGATION
    const onShowHideMenu = ()=>{
        dispatch((0, $bRqd3.toggleBoardMenus)());
        fireShortcutAnalytics({
            key: 'z',
            id: 'toggleMenuKeyboardShortcut'
        });
    };
    return {
        onNextIssue: onNextIssue,
        onPrevIssue: onPrevIssue,
        onNextColumn: onNextColumn,
        onPrevColumn: onPrevColumn,
        onAssignToMe: onAssignToMe,
        onToggleBentoViewForFocusedCard: onToggleBentoViewForFocusedCard,
        onOpenAndFocusBentoField: onOpenAndFocusBentoField,
        onMoveToTopOrBottomOfContainer: onMoveToTopOrBottomOfContainer,
        onSwimlanesToggle: (swimlaneIds)=>{
            dispatch((0, $k50Aq.swimlanesToggle)(swimlaneIds));
            fireShortcutAnalytics({
                id: 'toggleSwimlanesKeyboardShortcut',
                key: '-'
            });
        },
        onOpenFocusedCard: (activeIssueKey)=>{
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(activeIssueKey)) return;
            dispatch((0, $dW1HX.openIssueModal)(activeIssueKey));
            fireShortcutAnalytics({
                id: 'viewIssueKeyboardShortcut',
                key: 'o'
            });
        },
        onShowHideMenu: onShowHideMenu
    };
};
const $10e952bed2e94360$var$ConnectedKeyboardShortcuts = (0, $bC2fB.connect)($10e952bed2e94360$export$c31df4bd766f9c35, $10e952bed2e94360$export$9e6a17cf56877796)((0, $gZTZk.KeyboardShortcuts));
const $10e952bed2e94360$var$KeyboardShortcutsWithAnalytics = (props)=>{
    const fireShortcutAnalytics = (0, $fUHZ2.useShortcutAnalytics)('board');
    /*
        new analyticsEvent required to use existing card reranking actions
    */ const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        actionSubject: 'keyboardShortcut',
        action: 'pressed'
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($10e952bed2e94360$var$ConnectedKeyboardShortcuts, {
        ...props,
        fireShortcutAnalytics: fireShortcutAnalytics,
        analyticsEvent: analyticsEvent
    });
};
var $10e952bed2e94360$export$2e2bcd8739ae039 = $10e952bed2e94360$var$KeyboardShortcutsWithAnalytics;

});
parcelRegister("fUHZ2", function(module, exports) {

$parcel$export(module.exports, "useShortcutAnalytics", () => $a45625fee4d71e0e$export$cd482f0b72849b2c);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $8zOmE = parcelRequire("8zOmE");
const $a45625fee4d71e0e$export$56c266726b07692d = (createAnalyticsEvent, { id: id, key: key, attributes: attributes }, shortcutSource)=>{
    const attrs = {
        ...attributes,
        key: key,
        shortcutSource: shortcutSource,
        nextGenProject: true
    };
    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
        action: 'pressed',
        actionSubject: 'keyboardShortcut'
    }), id, attrs);
};
const $a45625fee4d71e0e$export$cd482f0b72849b2c = (shortcutSource)=>{
    // Will fix on FF cleanup
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireAnalytics = (0, $5uXOq.useCallback)((payload)=>{
        $a45625fee4d71e0e$export$56c266726b07692d(createAnalyticsEvent, payload, shortcutSource);
    }, [
        createAnalyticsEvent,
        shortcutSource
    ]);
    return fireAnalytics;
};

});

const $e7036201fc72e756$export$e2291655ce717023 = 'a';
const $e7036201fc72e756$export$4834da14f7c856f4 = 'l';
const $e7036201fc72e756$export$1303babe27c61a83 = 'm';

parcelRegister("5v2jP", function(module, exports) {

$parcel$export(module.exports, "getExternalActionForKey", () => $162c5bc4e348e7a8$export$c8673ee45279f35b);

var $d68jx = parcelRequire("d68jx");

var $5fc53 = parcelRequire("5fc53");

const $162c5bc4e348e7a8$export$c8673ee45279f35b = (key)=>{
    switch(key){
        case 0, $e7036201fc72e756$export$e2291655ce717023:
            return (0, $d68jx.externalEditFieldAction)((0, $5fc53.ASSIGNEE_TYPE));
        case 0, $e7036201fc72e756$export$4834da14f7c856f4:
            return (0, $d68jx.externalEditFieldAction)((0, $5fc53.LABELS_TYPE));
        case 0, $e7036201fc72e756$export$1303babe27c61a83:
            return (0, $d68jx.externalAddCommentAction)();
        default:
            return null;
    }
};

});
parcelRegister("d68jx", function(module, exports) {

$parcel$export(module.exports, "externalEditFieldAction", () => $9aec05de8de4c511$export$5d020593666779fc);
$parcel$export(module.exports, "externalAddCommentAction", () => $9aec05de8de4c511$export$c70036fd42f0ed99);
$parcel$export(module.exports, "externalAssignToMeAction", () => $9aec05de8de4c511$export$8f1d4f64b4b74146);
$parcel$export(module.exports, "FIELD_EDIT_REQUEST_EXTERNAL", () => $9aec05de8de4c511$export$c72c6bc149df5e02);
$parcel$export(module.exports, "ASSIGN_TO_ME_EXTERNAL", () => $9aec05de8de4c511$export$c60815f29b5cfb6d);
$parcel$export(module.exports, "transformExternalAction", () => $9aec05de8de4c511$export$78aa3108fdac0ac3);

var $akbnA = parcelRequire("akbnA");

var $8dFNe = parcelRequire("8dFNe");
const $9aec05de8de4c511$export$5834f946a995a2ca = 'REFRESH_ISSUE';
const $9aec05de8de4c511$export$316a97ea1161ac5a = (type)=>({
        type: $9aec05de8de4c511$export$5834f946a995a2ca,
        payload: {
            type: type
        }
    });
const $9aec05de8de4c511$export$256eddbefbf4b2ce = 'EDIT_FIELD';
const $9aec05de8de4c511$export$5d020593666779fc = (fieldId)=>({
        type: $9aec05de8de4c511$export$256eddbefbf4b2ce,
        payload: {
            fieldId: fieldId
        }
    });
const $9aec05de8de4c511$export$35aff3ed3a26081d = 'ADD_COMMENT';
const $9aec05de8de4c511$export$c70036fd42f0ed99 = ()=>({
        type: $9aec05de8de4c511$export$35aff3ed3a26081d
    });
const $9aec05de8de4c511$export$ae8a4274289f40bb = 'ASSIGN_TO_ME';
const $9aec05de8de4c511$export$8f1d4f64b4b74146 = ()=>({
        type: $9aec05de8de4c511$export$ae8a4274289f40bb
    });
const $9aec05de8de4c511$export$c72c6bc149df5e02 = 'FIELD_EDIT_REQUEST_EXTERNAL';
const $9aec05de8de4c511$export$c3ca6bc94e6e6b5c = (fieldId)=>({
        type: $9aec05de8de4c511$export$c72c6bc149df5e02,
        payload: {
            fieldId: fieldId
        }
    });
const $9aec05de8de4c511$export$c60815f29b5cfb6d = 'ASSIGN_TO_ME_EXTERNAL';
const $9aec05de8de4c511$export$e3035a7e8a739325 = ()=>({
        type: $9aec05de8de4c511$export$c60815f29b5cfb6d
    });
const $9aec05de8de4c511$export$78aa3108fdac0ac3 = (action)=>{
    switch(action.type){
        case $9aec05de8de4c511$export$35aff3ed3a26081d:
            return (0, $8dFNe.addCommentFormExpand)();
        case $9aec05de8de4c511$export$ae8a4274289f40bb:
            return $9aec05de8de4c511$export$e3035a7e8a739325();
        case $9aec05de8de4c511$export$256eddbefbf4b2ce:
            return $9aec05de8de4c511$export$c3ca6bc94e6e6b5c(action.payload.fieldId);
        case $9aec05de8de4c511$export$5834f946a995a2ca:
            return (0, $akbnA.refreshIssueRequest)({
                // todo: swap between soft reload and hard (aka on-demand)
                reason: 'ON_DEMAND'
            });
        default:
            // @ts-expect-error - TS2339 - Property 'type' does not exist on type 'never'.
            throw new Error(`Unhandled external action type: ${action.type}`);
    }
};

});
parcelRegister("akbnA", function(module, exports) {

$parcel$export(module.exports, "FETCH_ISSUE_REQUEST", () => $96f907481cd25e73$export$afc8565512ebbf99);
$parcel$export(module.exports, "fetchIssueRequest", () => $96f907481cd25e73$export$ff7cd1a46115d8ca);
$parcel$export(module.exports, "FETCH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$c32d0e1f370b7914);
$parcel$export(module.exports, "fetchIssueSuccess", () => $96f907481cd25e73$export$1e39a30e3f37e9d1);
$parcel$export(module.exports, "FETCH_ISSUE_FAILURE", () => $96f907481cd25e73$export$700ca24f76d5bbe6);
$parcel$export(module.exports, "fetchIssueFailure", () => $96f907481cd25e73$export$625e6e61fad65793);
$parcel$export(module.exports, "REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$b48f53bf5b842d57);
$parcel$export(module.exports, "refreshIssueRequest", () => $96f907481cd25e73$export$ccd0db94940d9159);
$parcel$export(module.exports, "CANCEL_REFRESH_ISSUE_REQUEST", () => $96f907481cd25e73$export$6b6ca6acd76420d1);
$parcel$export(module.exports, "cancelRefreshIssueRequest", () => $96f907481cd25e73$export$a7629a657f902cbc);
$parcel$export(module.exports, "REFRESH_ISSUE_SUCCESS", () => $96f907481cd25e73$export$de11c913f06a7952);
$parcel$export(module.exports, "refreshIssueSuccess", () => $96f907481cd25e73$export$cbd1c08fb706639c);
$parcel$export(module.exports, "FETCH_FORGE_REQUEST", () => $96f907481cd25e73$export$36b76b7384d868f3);
$parcel$export(module.exports, "fetchForgeRequest", () => $96f907481cd25e73$export$6ce2430992033a55);
const $96f907481cd25e73$export$afc8565512ebbf99 = 'FETCH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ff7cd1a46115d8ca = ()=>({
        type: $96f907481cd25e73$export$afc8565512ebbf99
    });
const $96f907481cd25e73$export$c32d0e1f370b7914 = 'FETCH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$1e39a30e3f37e9d1 = (entities)=>({
        type: $96f907481cd25e73$export$c32d0e1f370b7914,
        payload: entities
    });
const $96f907481cd25e73$export$700ca24f76d5bbe6 = 'FETCH_ISSUE_FAILURE';
const $96f907481cd25e73$export$625e6e61fad65793 = (failureDescription)=>({
        type: $96f907481cd25e73$export$700ca24f76d5bbe6,
        payload: failureDescription
    });
const $96f907481cd25e73$export$b48f53bf5b842d57 = 'REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$ccd0db94940d9159 = (payload, meta)=>({
        type: $96f907481cd25e73$export$b48f53bf5b842d57,
        payload: payload,
        meta: meta
    });
const $96f907481cd25e73$export$6b6ca6acd76420d1 = 'CANCEL_REFRESH_ISSUE_REQUEST';
const $96f907481cd25e73$export$a7629a657f902cbc = ()=>({
        type: $96f907481cd25e73$export$6b6ca6acd76420d1
    });
const $96f907481cd25e73$export$de11c913f06a7952 = 'REFRESH_ISSUE_SUCCESS';
const $96f907481cd25e73$export$cbd1c08fb706639c = (entities)=>({
        type: $96f907481cd25e73$export$de11c913f06a7952,
        payload: entities
    });
const $96f907481cd25e73$export$36b76b7384d868f3 = 'FETCH_FORGE_REQUEST';
const $96f907481cd25e73$export$6ce2430992033a55 = ()=>({
        type: $96f907481cd25e73$export$36b76b7384d868f3
    });

});

parcelRegister("8dFNe", function(module, exports) {

$parcel$export(module.exports, "ADD_COMMENT_FORM_EXPAND", () => $17d2ae7757c211f3$export$71d398107e783d48);
$parcel$export(module.exports, "addCommentFormExpand", () => $17d2ae7757c211f3$export$2b19aad250b973d);
$parcel$export(module.exports, "ADD_COMMENT_FORM_COLLAPSE", () => $17d2ae7757c211f3$export$85ff14da4a33157b);
$parcel$export(module.exports, "addCommentFormCollapse", () => $17d2ae7757c211f3$export$835c1049633b19d4);
$parcel$export(module.exports, "ADD_COMMENT_FORM_CANCEL", () => $17d2ae7757c211f3$export$2a743018e170b1c5);
$parcel$export(module.exports, "addCommentFormCancel", () => $17d2ae7757c211f3$export$cbb43c6e2782f713);
$parcel$export(module.exports, "SAVE_COMMENT_RETRY", () => $17d2ae7757c211f3$export$f1da94dd8f2d20f8);
$parcel$export(module.exports, "saveCommentRetry", () => $17d2ae7757c211f3$export$8fe4d7a3b02197cb);
$parcel$export(module.exports, "SAVE_COMMENT_EDIT", () => $17d2ae7757c211f3$export$81e9c11b794a58cd);
$parcel$export(module.exports, "saveCommentEdit", () => $17d2ae7757c211f3$export$854252150d2da91c);
$parcel$export(module.exports, "saveCommentSuccessWithPastedContent", () => $17d2ae7757c211f3$export$74f24e144289c0bf);
$parcel$export(module.exports, "SAVE_COMMENT_REQUEST", () => $17d2ae7757c211f3$export$18d19e9df123c7d4);
$parcel$export(module.exports, "saveCommentRequest", () => $17d2ae7757c211f3$export$180890d02f5569ee);
$parcel$export(module.exports, "SAVE_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$68a9d3a587260864);
$parcel$export(module.exports, "saveCommentSuccess", () => $17d2ae7757c211f3$export$e25b399b9ba134a2);
$parcel$export(module.exports, "SAVE_COMMENT_FAILURE", () => $17d2ae7757c211f3$export$181640cafd83e422);
$parcel$export(module.exports, "saveCommentFailure", () => $17d2ae7757c211f3$export$c9acef2c154290a0);
$parcel$export(module.exports, "SAVE_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$9188109a1be76d1a);
$parcel$export(module.exports, "saveCommentCancel", () => $17d2ae7757c211f3$export$6971a9cf19e7bff0);
$parcel$export(module.exports, "FETCH_OLDER_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$8759655e9c2c6d63);
$parcel$export(module.exports, "FETCH_NEWER_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$d55056f931f514de);
$parcel$export(module.exports, "fetchOlderCommentsRequest", () => $17d2ae7757c211f3$export$89824d2d0989262b);
$parcel$export(module.exports, "fetchNewerCommentsRequest", () => $17d2ae7757c211f3$export$ccf1730684d88fc7);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$1c31d581a6bc6013);
$parcel$export(module.exports, "fetchMoreCommentsSuccess", () => $17d2ae7757c211f3$export$a06e5ade6af52efd);
$parcel$export(module.exports, "FETCH_MORE_COMMENTS_FAILURE", () => $17d2ae7757c211f3$export$b0ac6cc6abb21a3c);
$parcel$export(module.exports, "fetchMoreCommentsFailure", () => $17d2ae7757c211f3$export$c3ffb947d06519d4);
$parcel$export(module.exports, "FETCH_OLDER_CHILD_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$feb4fdaa519a4bac);
$parcel$export(module.exports, "FETCH_NEWER_CHILD_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$760810a204a10072);
$parcel$export(module.exports, "fetchOlderChildCommentsRequest", () => $17d2ae7757c211f3$export$1ca8a4c5d1d1794d);
$parcel$export(module.exports, "fetchNewerChildCommentsRequest", () => $17d2ae7757c211f3$export$1f6295e53f67b612);
$parcel$export(module.exports, "FETCH_MORE_CHILD_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$85be09e36020cd88);
$parcel$export(module.exports, "fetchMoreChildCommentsSuccess", () => $17d2ae7757c211f3$export$c4a3e9e0909e77e7);
$parcel$export(module.exports, "FETCH_MORE_CHILD_COMMENTS_FAILURE", () => $17d2ae7757c211f3$export$a9baf80ea458ad1b);
$parcel$export(module.exports, "fetchMoreChildCommentsFailure", () => $17d2ae7757c211f3$export$d570cadd6de8a833);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_REQUEST", () => $17d2ae7757c211f3$export$47acda4b8d2cc300);
$parcel$export(module.exports, "fetchSortedCommentsRequest", () => $17d2ae7757c211f3$export$4805c80809193e58);
$parcel$export(module.exports, "FETCH_SORTED_COMMENTS_SUCCESS", () => $17d2ae7757c211f3$export$f72e87877cdff1d3);
$parcel$export(module.exports, "fetchSortedCommentsSuccess", () => $17d2ae7757c211f3$export$248225c0816f92b1);
$parcel$export(module.exports, "fetchSortedCommentsFailure", () => $17d2ae7757c211f3$export$2f204bc36c94722d);
$parcel$export(module.exports, "CHANGE_COMMENT_VISIBILITY", () => $17d2ae7757c211f3$export$27e53ffab4bb4105);
$parcel$export(module.exports, "changeCommentVisibility", () => $17d2ae7757c211f3$export$bdd605e26cb557a);
$parcel$export(module.exports, "EDIT_COMMENT_BEGIN", () => $17d2ae7757c211f3$export$52ec13a9878fb210);
$parcel$export(module.exports, "editCommentBegin", () => $17d2ae7757c211f3$export$b59e3ef618f3f5a4);
$parcel$export(module.exports, "EDIT_COMMENT_COLLAPSE", () => $17d2ae7757c211f3$export$ee24a9af79550b9a);
$parcel$export(module.exports, "editCommentCollapse", () => $17d2ae7757c211f3$export$76f4fdc85b3c4983);
$parcel$export(module.exports, "EDIT_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$34cbc41a86b4aebb);
$parcel$export(module.exports, "editCommentCancel", () => $17d2ae7757c211f3$export$b42a5c3d327fad1a);
$parcel$export(module.exports, "EDIT_COMMENT_UPDATE", () => $17d2ae7757c211f3$export$eae8689994a83d11);
$parcel$export(module.exports, "editCommentUpdate", () => $17d2ae7757c211f3$export$ccfcbe3e4607ec26);
$parcel$export(module.exports, "EDIT_COMMENT_VISIBILITY", () => $17d2ae7757c211f3$export$9a3bec84654d3d8b);
$parcel$export(module.exports, "editCommentVisibility", () => $17d2ae7757c211f3$export$2cbe8c5e21dff6d6);
$parcel$export(module.exports, "EDIT_COMMENT_EVENT_OCCURRED_AT", () => $17d2ae7757c211f3$export$f84d12595d214d0e);
$parcel$export(module.exports, "editCommentEventOccurredAt", () => $17d2ae7757c211f3$export$6b71370b88eec9f);
$parcel$export(module.exports, "DELETE_COMMENT_REQUEST", () => $17d2ae7757c211f3$export$32f9b2d50e470721);
$parcel$export(module.exports, "DELETE_COMMENT_SUCCESS", () => $17d2ae7757c211f3$export$ad9d0372e68e413d);
$parcel$export(module.exports, "deleteCommentSuccess", () => $17d2ae7757c211f3$export$88e6cb2a45e9c67b);
$parcel$export(module.exports, "DELETE_COMMENT_FAILURE", () => $17d2ae7757c211f3$export$17bfad3338f45e82);
$parcel$export(module.exports, "deleteCommentFailure", () => $17d2ae7757c211f3$export$f1282c6c2bcc0a44);
$parcel$export(module.exports, "PASTED_INTO_COMMENT_FORM", () => $17d2ae7757c211f3$export$7ef9a590ab69319e);
$parcel$export(module.exports, "pastedIntoCommentForm", () => $17d2ae7757c211f3$export$8ac8e8de3bb0d3);
$parcel$export(module.exports, "SET_COMMENT_ATTACHMENT_IN_PROGRESS", () => $17d2ae7757c211f3$export$ec38bcd617424c64);
$parcel$export(module.exports, "setCommentAttachmentInProgress", () => $17d2ae7757c211f3$export$d7ed3c847a4656f7);
$parcel$export(module.exports, "SET_COMMENT_VALUE", () => $17d2ae7757c211f3$export$66f932c47f92031b);
$parcel$export(module.exports, "setCommentValue", () => $17d2ae7757c211f3$export$ef0e64b81798a6f2);
$parcel$export(module.exports, "SET_COMMENT_SCROLL_STATUS", () => $17d2ae7757c211f3$export$f7592333993e8ac2);
$parcel$export(module.exports, "setCommentScrollStatus", () => $17d2ae7757c211f3$export$1dda1a9962bdad5f);
$parcel$export(module.exports, "SET_COMMENT_SCROLL_STATUS_FOR_REALTIME_UPDATES", () => $17d2ae7757c211f3$export$34b38b5759da4e0f);
$parcel$export(module.exports, "setCommentScrollStatusForRealTimeUpdates", () => $17d2ae7757c211f3$export$854c59860d860f02);
$parcel$export(module.exports, "REPLY_COMMENT_BEGIN", () => $17d2ae7757c211f3$export$d5ede80029a6397e);
$parcel$export(module.exports, "replyCommentBegin", () => $17d2ae7757c211f3$export$f1a18b29fe2549e9);
$parcel$export(module.exports, "REPLY_COMMENT_UPDATE", () => $17d2ae7757c211f3$export$25a7e12fd2d783a3);
$parcel$export(module.exports, "replyCommentUpdate", () => $17d2ae7757c211f3$export$ecea73f83f50bca0);
$parcel$export(module.exports, "REPLY_COMMENT_CANCEL", () => $17d2ae7757c211f3$export$f87250d72435d6b4);
$parcel$export(module.exports, "replyCommentCancel", () => $17d2ae7757c211f3$export$9dc83707765a3fa8);
$parcel$export(module.exports, "COMMENT_VIEW_INTERACTION_TIME_MARKER", () => $17d2ae7757c211f3$export$5e3e51c84e58e772);
$parcel$export(module.exports, "COMMENTS_VIEWED_EVENT_TRIGGERED", () => $17d2ae7757c211f3$export$d6e7985d27b430af);
$parcel$export(module.exports, "updateCommentViewInteractionTimeMarker", () => $17d2ae7757c211f3$export$3db8138f281d271e);
$parcel$export(module.exports, "updateCommentsViewedEventTriggered", () => $17d2ae7757c211f3$export$a532038d9e5044e0);
$parcel$export(module.exports, "REAL_TIME_COMMENT_UPDATED", () => $17d2ae7757c211f3$export$641829044314d379);

var $fOGZN = parcelRequire("fOGZN");

var $4R6GH = parcelRequire("4R6GH");
const $17d2ae7757c211f3$export$71d398107e783d48 = 'ADD_COMMENT_FORM_EXPAND';
const $17d2ae7757c211f3$export$2b19aad250b973d = ()=>({
        type: $17d2ae7757c211f3$export$71d398107e783d48
    });
const $17d2ae7757c211f3$export$85ff14da4a33157b = 'ADD_COMMENT_FORM_COLLAPSE';
const $17d2ae7757c211f3$export$835c1049633b19d4 = ()=>({
        type: $17d2ae7757c211f3$export$85ff14da4a33157b
    });
const $17d2ae7757c211f3$export$2a743018e170b1c5 = 'ADD_COMMENT_FORM_CANCEL';
const $17d2ae7757c211f3$export$cbb43c6e2782f713 = ()=>({
        type: $17d2ae7757c211f3$export$2a743018e170b1c5
    });
const $17d2ae7757c211f3$export$f1da94dd8f2d20f8 = 'SAVE_COMMENT_RETRY';
const $17d2ae7757c211f3$export$8fe4d7a3b02197cb = (optimisticId, createdDate, isNewComment)=>({
        type: $17d2ae7757c211f3$export$f1da94dd8f2d20f8,
        payload: {
            optimisticId: optimisticId,
            createdDate: createdDate,
            isNewComment: isNewComment
        }
    });
const $17d2ae7757c211f3$export$81e9c11b794a58cd = 'SAVE_COMMENT_EDIT';
const $17d2ae7757c211f3$export$854252150d2da91c = (optimisticId)=>({
        type: $17d2ae7757c211f3$export$81e9c11b794a58cd,
        payload: {
            optimisticId: optimisticId
        }
    });
const $17d2ae7757c211f3$export$eca5dde908b0cf94 = 'SAVE_COMMENT_SUCCESS_WITH_PASTED_CONTENT';
const $17d2ae7757c211f3$export$74f24e144289c0bf = (comment, pastedContent)=>({
        type: $17d2ae7757c211f3$export$eca5dde908b0cf94,
        payload: {
            comment: comment,
            pastedContent: pastedContent
        }
    });
const $17d2ae7757c211f3$export$18d19e9df123c7d4 = 'SAVE_COMMENT_REQUEST';
const $17d2ae7757c211f3$export$180890d02f5569ee = (comment, analyticsEvent, commentSessionId)=>({
        type: $17d2ae7757c211f3$export$18d19e9df123c7d4,
        payload: {
            comment: comment,
            analyticsEvent: analyticsEvent,
            commentSessionId: commentSessionId,
            updatedField: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$68a9d3a587260864 = 'SAVE_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$e25b399b9ba134a2 = (comment, optimisticId, isNewComment, analyticsEvent, commentSessionId, meta, eventOccurredAt, jsdIncidentActivityViewHidden, fullIssueUrl, triggerIncidentSaveCommentFlag, parentId)=>({
        type: $17d2ae7757c211f3$export$68a9d3a587260864,
        payload: {
            fieldId: (0, $fOGZN.COMMENT),
            comment: comment,
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            analyticsEvent: analyticsEvent,
            commentSessionId: commentSessionId,
            parentId: parentId,
            eventOccurredAt: eventOccurredAt,
            jsdIncidentActivityViewHidden: jsdIncidentActivityViewHidden,
            ...fullIssueUrl ? {
                fullIssueUrl: fullIssueUrl
            } : {},
            triggerIncidentSaveCommentFlag: triggerIncidentSaveCommentFlag
        },
        meta: meta
    });
const $17d2ae7757c211f3$export$181640cafd83e422 = 'SAVE_COMMENT_FAILURE';
const $17d2ae7757c211f3$export$c9acef2c154290a0 = (payload)=>({
        type: $17d2ae7757c211f3$export$181640cafd83e422,
        payload: payload
    });
const $17d2ae7757c211f3$export$9188109a1be76d1a = 'SAVE_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$6971a9cf19e7bff0 = (optimisticId, isNewComment, parentId)=>({
        type: $17d2ae7757c211f3$export$9188109a1be76d1a,
        payload: {
            optimisticId: optimisticId,
            isNewComment: isNewComment,
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$8759655e9c2c6d63 = 'FETCH_OLDER_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$d55056f931f514de = 'FETCH_NEWER_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$89824d2d0989262b = ()=>({
        type: $17d2ae7757c211f3$export$8759655e9c2c6d63
    });
const $17d2ae7757c211f3$export$ccf1730684d88fc7 = ()=>({
        type: $17d2ae7757c211f3$export$d55056f931f514de
    });
const $17d2ae7757c211f3$export$1c31d581a6bc6013 = 'FETCH_MORE_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$a06e5ade6af52efd = (comments)=>({
        type: $17d2ae7757c211f3$export$1c31d581a6bc6013,
        payload: comments
    });
const $17d2ae7757c211f3$export$b0ac6cc6abb21a3c = 'FETCH_MORE_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$c3ffb947d06519d4 = ()=>({
        type: $17d2ae7757c211f3$export$b0ac6cc6abb21a3c
    });
const $17d2ae7757c211f3$export$feb4fdaa519a4bac = 'FETCH_OLDER_CHILD_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$760810a204a10072 = 'FETCH_NEWER_CHILD_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$1ca8a4c5d1d1794d = (parentId)=>({
        type: $17d2ae7757c211f3$export$feb4fdaa519a4bac,
        payload: {
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$1f6295e53f67b612 = (parentId)=>({
        type: $17d2ae7757c211f3$export$760810a204a10072,
        payload: {
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$85be09e36020cd88 = 'FETCH_MORE_CHILD_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$c4a3e9e0909e77e7 = (comments, parentId)=>({
        type: $17d2ae7757c211f3$export$85be09e36020cd88,
        payload: {
            ...comments,
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$a9baf80ea458ad1b = 'FETCH_MORE_CHILD_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$d570cadd6de8a833 = (parentId)=>({
        type: $17d2ae7757c211f3$export$a9baf80ea458ad1b,
        payload: {
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$47acda4b8d2cc300 = 'FETCH_SORTED_COMMENTS_REQUEST';
const $17d2ae7757c211f3$export$4805c80809193e58 = (commentId, bypassLoader)=>({
        type: $17d2ae7757c211f3$export$47acda4b8d2cc300,
        payload: commentId,
        bypassLoader: bypassLoader
    });
const $17d2ae7757c211f3$export$f72e87877cdff1d3 = 'FETCH_SORTED_COMMENTS_SUCCESS';
const $17d2ae7757c211f3$export$248225c0816f92b1 = (comments)=>({
        type: $17d2ae7757c211f3$export$f72e87877cdff1d3,
        payload: comments
    });
const $17d2ae7757c211f3$export$5ae0e03aaca20486 = 'FETCH_SORTED_COMMENTS_FAILURE';
const $17d2ae7757c211f3$export$2f204bc36c94722d = ()=>({
        type: $17d2ae7757c211f3$export$5ae0e03aaca20486
    });
const $17d2ae7757c211f3$export$27e53ffab4bb4105 = 'CHANGE_COMMENT_VISIBILITY';
const $17d2ae7757c211f3$export$bdd605e26cb557a = (id, isInternal)=>({
        type: $17d2ae7757c211f3$export$27e53ffab4bb4105,
        payload: {
            id: id,
            isInternal: isInternal
        }
    });
const $17d2ae7757c211f3$export$52ec13a9878fb210 = 'EDIT_COMMENT_BEGIN';
const $17d2ae7757c211f3$export$b59e3ef618f3f5a4 = (id, isInternal, commentSessionId)=>({
        type: $17d2ae7757c211f3$export$52ec13a9878fb210,
        payload: {
            id: id,
            isInternal: isInternal,
            commentSessionId: commentSessionId
        }
    });
const $17d2ae7757c211f3$export$ee24a9af79550b9a = 'EDIT_COMMENT_COLLAPSE';
const $17d2ae7757c211f3$export$76f4fdc85b3c4983 = (id)=>({
        type: $17d2ae7757c211f3$export$ee24a9af79550b9a,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$34cbc41a86b4aebb = 'EDIT_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$b42a5c3d327fad1a = (id)=>({
        type: $17d2ae7757c211f3$export$34cbc41a86b4aebb,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$eae8689994a83d11 = 'EDIT_COMMENT_UPDATE';
const $17d2ae7757c211f3$export$ccfcbe3e4607ec26 = (id, value)=>({
        type: $17d2ae7757c211f3$export$eae8689994a83d11,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$9a3bec84654d3d8b = 'EDIT_COMMENT_VISIBILITY';
const $17d2ae7757c211f3$export$2cbe8c5e21dff6d6 = (id, visibility)=>({
        type: $17d2ae7757c211f3$export$9a3bec84654d3d8b,
        payload: {
            id: id,
            visibility: visibility
        }
    });
const $17d2ae7757c211f3$export$f84d12595d214d0e = 'EDIT_COMMENT_EVENT_OCCURRED_AT';
const $17d2ae7757c211f3$export$6b71370b88eec9f = (id, eventOccurredAt)=>({
        type: $17d2ae7757c211f3$export$f84d12595d214d0e,
        payload: {
            id: id,
            eventOccurredAt: eventOccurredAt
        }
    });
const $17d2ae7757c211f3$export$32f9b2d50e470721 = 'DELETE_COMMENT_REQUEST';
const $17d2ae7757c211f3$export$ed74b3a5f1c036c2 = (id, analyticsEvent, parentId, hasReplies)=>({
        type: $17d2ae7757c211f3$export$32f9b2d50e470721,
        payload: {
            id: id,
            analyticsEvent: analyticsEvent,
            parentId: parentId,
            hasReplies: hasReplies,
            updatedField: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$ad9d0372e68e413d = 'DELETE_COMMENT_SUCCESS';
const $17d2ae7757c211f3$export$88e6cb2a45e9c67b = (id, parentId, hasReplies)=>({
        type: $17d2ae7757c211f3$export$ad9d0372e68e413d,
        payload: {
            id: id,
            fieldId: (0, $fOGZN.COMMENT),
            parentId: parentId,
            hasReplies: hasReplies
        }
    });
const $17d2ae7757c211f3$export$17bfad3338f45e82 = 'DELETE_COMMENT_FAILURE';
const $17d2ae7757c211f3$export$f1282c6c2bcc0a44 = (id, errorConfig)=>{
    return {
        type: $17d2ae7757c211f3$export$17bfad3338f45e82,
        payload: {
            id: id,
            ...errorConfig ?? {}
        }
    };
};
const $17d2ae7757c211f3$export$7ef9a590ab69319e = 'PASTED_INTO_COMMENT_FORM';
const $17d2ae7757c211f3$export$8ac8e8de3bb0d3 = (id, pastedContent)=>({
        type: $17d2ae7757c211f3$export$7ef9a590ab69319e,
        payload: {
            id: id,
            pastedContent: pastedContent
        }
    });
const $17d2ae7757c211f3$export$ec38bcd617424c64 = 'SET_COMMENT_ATTACHMENT_IN_PROGRESS';
const $17d2ae7757c211f3$export$d7ed3c847a4656f7 = (id, isInProgress)=>({
        type: $17d2ae7757c211f3$export$ec38bcd617424c64,
        payload: {
            id: id,
            isInProgress: isInProgress
        }
    });
const $17d2ae7757c211f3$export$66f932c47f92031b = 'SET_COMMENT_VALUE';
const $17d2ae7757c211f3$export$ef0e64b81798a6f2 = (id, value)=>({
        type: $17d2ae7757c211f3$export$66f932c47f92031b,
        payload: {
            id: id,
            value: value,
            fieldId: (0, $fOGZN.COMMENT)
        }
    });
const $17d2ae7757c211f3$export$f7592333993e8ac2 = 'SET_COMMENT_SCROLL_STATUS';
const $17d2ae7757c211f3$export$1dda1a9962bdad5f = (status)=>({
        type: $17d2ae7757c211f3$export$f7592333993e8ac2,
        payload: {
            status: status
        }
    });
const $17d2ae7757c211f3$export$34b38b5759da4e0f = 'SET_COMMENT_SCROLL_STATUS_FOR_REALTIME_UPDATES';
const $17d2ae7757c211f3$export$854c59860d860f02 = (commentScrollStatusForRealTimeUpdates)=>({
        type: $17d2ae7757c211f3$export$34b38b5759da4e0f,
        payload: {
            commentScrollStatusForRealTimeUpdates: commentScrollStatusForRealTimeUpdates
        }
    });
const $17d2ae7757c211f3$export$d5ede80029a6397e = 'REPLY_COMMENT_BEGIN';
const $17d2ae7757c211f3$export$f1a18b29fe2549e9 = (commentId, authorId, authorDisplayName, visibility, commentSessionId, extraCommentContent)=>({
        type: $17d2ae7757c211f3$export$d5ede80029a6397e,
        payload: {
            commentId: commentId,
            authorId: authorId,
            authorDisplayName: authorDisplayName,
            visibility: visibility,
            commentSessionId: commentSessionId,
            ...(0, $4R6GH.fg)('work_item_create_from_comment_and_pin_comment_gate') ? {
                extraCommentContent: extraCommentContent
            } : {}
        }
    });
const $17d2ae7757c211f3$export$25a7e12fd2d783a3 = 'REPLY_COMMENT_UPDATE';
const $17d2ae7757c211f3$export$ecea73f83f50bca0 = (parentId, value)=>({
        type: $17d2ae7757c211f3$export$25a7e12fd2d783a3,
        payload: {
            parentId: parentId,
            value: value
        }
    });
const $17d2ae7757c211f3$export$f87250d72435d6b4 = 'REPLY_COMMENT_CANCEL';
const $17d2ae7757c211f3$export$9dc83707765a3fa8 = (parentId)=>({
        type: $17d2ae7757c211f3$export$f87250d72435d6b4,
        payload: {
            parentId: parentId
        }
    });
const $17d2ae7757c211f3$export$5e3e51c84e58e772 = 'COMMENT_VIEW_INTERACTION_TIME_MARKER';
const $17d2ae7757c211f3$export$d6e7985d27b430af = 'COMMENTS_VIEWED_EVENT_TRIGGERED';
const $17d2ae7757c211f3$export$3db8138f281d271e = (time)=>({
        type: $17d2ae7757c211f3$export$5e3e51c84e58e772,
        payload: {
            latestCommentViewInteractedTime: time
        }
    });
const $17d2ae7757c211f3$export$a532038d9e5044e0 = (value)=>({
        type: $17d2ae7757c211f3$export$d6e7985d27b430af,
        payload: {
            commentsViewedEventTriggered: value
        }
    });
const $17d2ae7757c211f3$export$641829044314d379 = 'REAL_TIME_COMMENT_UPDATED';
const $17d2ae7757c211f3$export$407f50fa80d50d11 = (isRealTimeCommentUpdated)=>({
        type: $17d2ae7757c211f3$export$641829044314d379,
        payload: {
            isRealTimeCommentUpdated: isRealTimeCommentUpdated
        }
    });

});
parcelRegister("fOGZN", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE", () => $1df76d38eb6e3f90$export$ebb48b08205007c5);
$parcel$export(module.exports, "ISSUE_SUMMARY", () => $1df76d38eb6e3f90$export$a464614f8f5fe986);
$parcel$export(module.exports, "SUBTASK_PARENT", () => $1df76d38eb6e3f90$export$a311a3c9b207604e);
$parcel$export(module.exports, "WATCHES", () => $1df76d38eb6e3f90$export$289917d9a7031e1d);
$parcel$export(module.exports, "VOTES", () => $1df76d38eb6e3f90$export$81614f6dc3be5b00);
$parcel$export(module.exports, "SECURITY", () => $1df76d38eb6e3f90$export$72a5630aa398d6b4);
$parcel$export(module.exports, "ISSUE_RESTRICTION", () => $1df76d38eb6e3f90$export$caf1ff54fbdf44bf);
$parcel$export(module.exports, "ASSIGNEE", () => $1df76d38eb6e3f90$export$f8f7545d2bb78afb);
$parcel$export(module.exports, "REPORTER", () => $1df76d38eb6e3f90$export$6d7021166edc895c);
$parcel$export(module.exports, "DUE_DATE", () => $1df76d38eb6e3f90$export$cf7e173386d30cdd);
$parcel$export(module.exports, "PRIORITY", () => $1df76d38eb6e3f90$export$bb34f3538ba26c7e);
$parcel$export(module.exports, "LABELS", () => $1df76d38eb6e3f90$export$79b91d4669dcadcb);
$parcel$export(module.exports, "EPIC", () => $1df76d38eb6e3f90$export$3cb4a99a332e4186);
$parcel$export(module.exports, "FIX_VERSIONS", () => $1df76d38eb6e3f90$export$d7e18f5730074533);
$parcel$export(module.exports, "AFFECTS_VERSIONS", () => $1df76d38eb6e3f90$export$c435f0000304e508);
$parcel$export(module.exports, "TIME_TRACKING", () => $1df76d38eb6e3f90$export$ee99ef6ee562a446);
$parcel$export(module.exports, "TIME_ESTIMATE", () => $1df76d38eb6e3f90$export$a6a74b4bc927d39f);
$parcel$export(module.exports, "STATUS", () => $1df76d38eb6e3f90$export$e50006273435e7d4);
$parcel$export(module.exports, "CREATED", () => $1df76d38eb6e3f90$export$ff39ebd4bb12b718);
$parcel$export(module.exports, "UPDATED", () => $1df76d38eb6e3f90$export$cd8e68094cb5c3cb);
$parcel$export(module.exports, "SUMMARY", () => $1df76d38eb6e3f90$export$913055729e1380b2);
$parcel$export(module.exports, "DESCRIPTION", () => $1df76d38eb6e3f90$export$d44826c816b5619b);
$parcel$export(module.exports, "COMMENT", () => $1df76d38eb6e3f90$export$a29989082612d0d9);
$parcel$export(module.exports, "EPIC_ISSUES", () => $1df76d38eb6e3f90$export$8fe3d5be8cb17459);
$parcel$export(module.exports, "CHILDREN_ISSUES", () => $1df76d38eb6e3f90$export$3b3d0889022c85b3);
$parcel$export(module.exports, "ENVIRONMENT", () => $1df76d38eb6e3f90$export$be46596bc6608f3b);
$parcel$export(module.exports, "SUBTASKS", () => $1df76d38eb6e3f90$export$f528fadbfdb3c25e);
$parcel$export(module.exports, "DATA_CLASSIFICATION_FIELD", () => $1df76d38eb6e3f90$export$f10e53e8928b61bd);
$parcel$export(module.exports, "PARENT", () => $1df76d38eb6e3f90$export$e0dfb65d1047c53c);
$parcel$export(module.exports, "PORTFOLIO_CHILD_ISSUES", () => $1df76d38eb6e3f90$export$aba22e09a66f6826);
$parcel$export(module.exports, "SELECT_CUSTOM_FIELD_TYPE", () => $1df76d38eb6e3f90$export$826d657005bbe54c);
$parcel$export(module.exports, "FLAG_ACTIONS", () => $1df76d38eb6e3f90$export$cdbd1eb3b05729e0);
$parcel$export(module.exports, "CARD_COVER_ACTIONS", () => $1df76d38eb6e3f90$export$c161a774ec2e7e56);
$parcel$export(module.exports, "specialFields", () => $1df76d38eb6e3f90$export$89e5c40c0f5c7561);
$parcel$export(module.exports, "ecosystemCustomFields", () => $1df76d38eb6e3f90$export$87934b3672715c91);
$parcel$export(module.exports, "customFieldsToDisplay", () => $1df76d38eb6e3f90$export$efd443bccc4c01ed);
$parcel$export(module.exports, "itemDocumentationUrls", () => $1df76d38eb6e3f90$export$a18b3a656ee9c709);
$parcel$export(module.exports, "emptyConfiguration", () => $1df76d38eb6e3f90$export$a52507e68e7aeeb);
$parcel$export(module.exports, "softwareConfiguration", () => $1df76d38eb6e3f90$export$27e0678365e5dcff);
$parcel$export(module.exports, "simpleSoftwareBoardConfiguration", () => $1df76d38eb6e3f90$export$aebf676dfa727a1c);
$parcel$export(module.exports, "standardRoadmapConfiguration", () => $1df76d38eb6e3f90$export$1afca4d3eb6b218b);
$parcel$export(module.exports, "bitbucketConfiguration", () => $1df76d38eb6e3f90$export$8a060ed6f66c43b0);
$parcel$export(module.exports, "mobileConfiguration", () => $1df76d38eb6e3f90$export$78a2cb921e46f5eb);
$parcel$export(module.exports, "serviceDeskConfiguration", () => $1df76d38eb6e3f90$export$db1115186532f6d5);
$parcel$export(module.exports, "connectConfiguration", () => $1df76d38eb6e3f90$export$557d5094ec5cf234);
$parcel$export(module.exports, "getIssueConfiguration", () => $1df76d38eb6e3f90$export$902f6c5cc939598a);

var $65mz3 = parcelRequire("65mz3");

var $2vSU6 = parcelRequire("2vSU6");

var $5fc53 = parcelRequire("5fc53");
const $1df76d38eb6e3f90$export$ebb48b08205007c5 = 'issuetype';
const $1df76d38eb6e3f90$export$a464614f8f5fe986 = 'summary';
const $1df76d38eb6e3f90$export$a311a3c9b207604e = 'parent';
const $1df76d38eb6e3f90$export$2a4f270075a033de = 'parent-issue';
const $1df76d38eb6e3f90$export$4561a4960baf1b2b = 'parent'; // new Hierarchy unification parent field
const $1df76d38eb6e3f90$export$289917d9a7031e1d = 'watches';
const $1df76d38eb6e3f90$export$81614f6dc3be5b00 = 'votes';
const $1df76d38eb6e3f90$export$72a5630aa398d6b4 = 'security';
const $1df76d38eb6e3f90$export$caf1ff54fbdf44bf = 'issuerestriction';
const $1df76d38eb6e3f90$export$f8f7545d2bb78afb = 'assignee';
const $1df76d38eb6e3f90$export$6d7021166edc895c = 'reporter';
const $1df76d38eb6e3f90$export$cf7e173386d30cdd = 'duedate';
const $1df76d38eb6e3f90$export$bb34f3538ba26c7e = 'priority';
const $1df76d38eb6e3f90$export$79b91d4669dcadcb = 'labels';
const $1df76d38eb6e3f90$export$cbedbfe2cd0caec7 = 'components';
const $1df76d38eb6e3f90$export$950d47e775e208ee = 'devSummary';
const $1df76d38eb6e3f90$export$f91d2bb4cc99fa5e = 'releases';
const $1df76d38eb6e3f90$export$a316570a0dbfd2b0 = 'sprint';
const $1df76d38eb6e3f90$export$405b6d72f2d243a9 = 'storyPointsField';
const $1df76d38eb6e3f90$export$3cb4a99a332e4186 = 'epic';
const $1df76d38eb6e3f90$export$d7e18f5730074533 = 'fixVersions';
const $1df76d38eb6e3f90$export$c435f0000304e508 = 'versions';
const $1df76d38eb6e3f90$export$ee99ef6ee562a446 = 'timetracking';
const $1df76d38eb6e3f90$export$a6a74b4bc927d39f = 'timeoriginalestimate';
const $1df76d38eb6e3f90$export$e50006273435e7d4 = 'status';
const $1df76d38eb6e3f90$export$f1a6ce22cbb7eb32 = 'resolution';
const $1df76d38eb6e3f90$export$ff39ebd4bb12b718 = 'created';
const $1df76d38eb6e3f90$export$cd8e68094cb5c3cb = 'updated';
const $1df76d38eb6e3f90$export$1d0e0bb6a21b800b = 'SLA_PANEL';
const $1df76d38eb6e3f90$export$340fac260c3e3637 = 'LINKED_ALERTS';
const $1df76d38eb6e3f90$export$24ec4dcc8e5b08ef = 'CHAT_CHANNEL';
const $1df76d38eb6e3f90$export$8631065e0909313 = 'MSTEAMS_CHANNEL';
const $1df76d38eb6e3f90$export$3c4dccba7d7e0acb = 'ZOOM_MEETING';
const $1df76d38eb6e3f90$export$cd5e9246357daec3 = 'CONFERENCE_CALL';
const $1df76d38eb6e3f90$export$9c83bd19c3ffd90d = 'SENTIMENT';
const $1df76d38eb6e3f90$export$c5c04443c6097d6e = 'ASSET_ONBOARDING';
const $1df76d38eb6e3f90$export$26d855f4cd7e5fe9 = 'MANAGE_STAKEHOLDERS';
const $1df76d38eb6e3f90$export$913055729e1380b2 = 'summary';
const $1df76d38eb6e3f90$export$d44826c816b5619b = 'description';
const $1df76d38eb6e3f90$export$a29989082612d0d9 = 'comment';
const $1df76d38eb6e3f90$export$8fe3d5be8cb17459 = 'epic-issues'; // this field is only served in classic projects
const $1df76d38eb6e3f90$export$3b3d0889022c85b3 = 'children-issues';
const $1df76d38eb6e3f90$export$be46596bc6608f3b = 'environment';
const $1df76d38eb6e3f90$export$f528fadbfdb3c25e = 'subtasks';
const $1df76d38eb6e3f90$export$f10e53e8928b61bd = 'dataclassification';
const $1df76d38eb6e3f90$export$e0dfb65d1047c53c = (0, $5fc53.PARENT_CF_TYPE);
const $1df76d38eb6e3f90$export$aba22e09a66f6826 = 'portfolio-child-issues';
const $1df76d38eb6e3f90$export$826d657005bbe54c = (0, $5fc53.SELECT_CF_TYPE);
const $1df76d38eb6e3f90$export$cdbd1eb3b05729e0 = 'flagActions';
const $1df76d38eb6e3f90$export$c161a774ec2e7e56 = 'cardCoverActions';
const $1df76d38eb6e3f90$export$89e5c40c0f5c7561 = ()=>{
    const fields = {
        [$1df76d38eb6e3f90$export$3cb4a99a332e4186]: 'com.pyxis.greenhopper.jira:gh-epic-link',
        [$1df76d38eb6e3f90$export$a316570a0dbfd2b0]: 'com.pyxis.greenhopper.jira:gh-sprint',
        [$1df76d38eb6e3f90$export$405b6d72f2d243a9]: 'com.atlassian.jira.plugin.system.customfieldtypes:storypoint',
        [(0, $5fc53.TEAM_CF_TYPE)]: (0, $5fc53.TEAM_CF_TYPE),
        [(0, $5fc53.PARENT_CF_TYPE)]: (0, $5fc53.PARENT_CF_TYPE),
        [(0, $5fc53.BASELINE_START_CF_TYPE)]: (0, $5fc53.BASELINE_START_CF_TYPE),
        [(0, $5fc53.BASELINE_END_CF_TYPE)]: (0, $5fc53.BASELINE_END_CF_TYPE),
        [(0, $5fc53.COLOR_CF_TYPE)]: (0, $5fc53.COLOR_CF_TYPE),
        [(0, $5fc53.EPIC_COLOR_TYPE)]: (0, $5fc53.EPIC_COLOR_TYPE),
        [(0, $5fc53.EPIC_NAME_TYPE)]: (0, $5fc53.EPIC_NAME_TYPE)
    };
    return fields;
};
const $1df76d38eb6e3f90$export$87934b3672715c91 = [
    (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
    (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
];
const $1df76d38eb6e3f90$var$serviceDeskCustomFields = [
    (0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE),
    (0, $5fc53.ORGANIZATIONS_CF_TYPE),
    (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
    (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
    (0, $5fc53.APPROVALS_CF_TYPE),
    (0, $5fc53.APPROVERS_LIST_CF_TYPE),
    (0, $5fc53.REQUEST_TYPE_CF_TYPE),
    (0, $5fc53.CMDB_OBJECT_CF_TYPE),
    (0, $5fc53.RESPONDERS_CF_TYPE),
    (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
    (0, $5fc53.ENTITLEMENT_CF_TYPE),
    (0, $5fc53.SENTIMENT_CF_TYPE),
    (0, $5fc53.ORGANIZATION_CF_TYPE)
];
const $1df76d38eb6e3f90$export$efd443bccc4c01ed = ()=>[
        (0, $5fc53.LABELS_CF_TYPE),
        (0, $5fc53.TEXT_CF_TYPE),
        (0, $5fc53.MULTI_USER_CF_TYPE),
        (0, $5fc53.PARTICIPANTS_CF_TYPE),
        (0, $5fc53.URL_CF_TYPE),
        (0, $5fc53.NUMBER_CF_TYPE),
        (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
        (0, $5fc53.SELECT_CF_TYPE),
        (0, $5fc53.MULTI_SELECT_CF_TYPE),
        (0, $5fc53.VERSION_CF_TYPE),
        (0, $5fc53.TEXT_AREA_CF_TYPE),
        (0, $5fc53.MULTI_VERSION_CF_TYPE),
        (0, $5fc53.DATE_CF_TYPE),
        (0, $5fc53.GROUP_CF_TYPE),
        (0, $5fc53.MULTI_GROUP_CF_TYPE),
        (0, $5fc53.USER_CF_TYPE),
        (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE),
        (0, $5fc53.RADIO_BUTTONS_CF_TYPE),
        (0, $5fc53.DATETIME_CF_TYPE),
        (0, $5fc53.ASSETS_CF_TYPE),
        (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
        (0, $5fc53.PEOPLE_CF_TYPE),
        (0, $5fc53.CASCADING_SELECT_CF_TYPE),
        (0, $5fc53.PROJECT_PICKER_CF_TYPE),
        (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
        (0, $5fc53.READ_ONLY_CF_TYPE),
        (0, $5fc53.EPIC_STATUS_TYPE),
        (0, $5fc53.MESSAGE_VIEW_CF_TYPE),
        (0, $5fc53.MESSAGE_EDIT_CF_TYPE),
        (0, $5fc53.CATEGORY_TYPE),
        (0, $5fc53.GOALS_CF_TYPE),
        ...$1df76d38eb6e3f90$export$87934b3672715c91,
        ...$1df76d38eb6e3f90$var$serviceDeskCustomFields
    ];
const $1df76d38eb6e3f90$export$a18b3a656ee9c709 = {
    [(0, $2vSU6.SOFTWARE_PROJECT)]: 'https://confluence.atlassian.com/jirasoftwarecloud/configure-field-layout-in-the-issue-view-961798059.html',
    [(0, $2vSU6.CORE_PROJECT)]: 'https://confluence.atlassian.com/jiracorecloud/configure-field-layout-in-the-issue-view-961798123.html',
    [(0, $2vSU6.SERVICE_DESK_PROJECT)]: 'https://support.atlassian.com/jira-service-desk-cloud/docs/what-are-the-different-sections-in-the-issue-view/'
};
const $1df76d38eb6e3f90$export$a52507e68e7aeeb = ()=>({
        issueActions: []
    });
const $1df76d38eb6e3f90$export$381ce08838c53afa = ()=>({
        applicationKey: (0, $65mz3.default).CORE_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$27e0678365e5dcff = ()=>({
        applicationKey: (0, $65mz3.default).SOFTWARE_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$aebf676dfa727a1c = ()=>({
        applicationKey: (0, $65mz3.default).SIMPLE_SOFTWARE_BOARD,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0,
            $1df76d38eb6e3f90$export$c161a774ec2e7e56
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$1afca4d3eb6b218b = ()=>({
        applicationKey: (0, $65mz3.default).STANDARD_ROADMAP_ISSUE,
        issueActions: [
            $1df76d38eb6e3f90$export$cdbd1eb3b05729e0
        ],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$8a060ed6f66c43b0 = ()=>({
        applicationKey: (0, $65mz3.default).BITBUCKET_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$78a2cb921e46f5eb = ()=>({
        applicationKey: (0, $65mz3.default).MOBILE_ISSUE,
        issueActions: []
    });
const $1df76d38eb6e3f90$export$db1115186532f6d5 = ()=>({
        applicationKey: (0, $65mz3.default).SERVICE_DESK,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$557d5094ec5cf234 = ()=>({
        applicationKey: (0, $65mz3.default).CONNECT_ISSUE,
        issueActions: [],
        ecosystemEnabled: true
    });
const $1df76d38eb6e3f90$export$902f6c5cc939598a = (config)=>{
    if (config) switch(config.projectType){
        case 0, $2vSU6.SOFTWARE_PROJECT:
            if (config.isSimplified) return $1df76d38eb6e3f90$export$aebf676dfa727a1c();
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
        case 0, $2vSU6.CORE_PROJECT:
            return $1df76d38eb6e3f90$export$381ce08838c53afa();
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return $1df76d38eb6e3f90$export$db1115186532f6d5();
        default:
            // fallback to sofware config
            return $1df76d38eb6e3f90$export$27e0678365e5dcff();
    }
    return $1df76d38eb6e3f90$export$27e0678365e5dcff();
};

});




parcelRegister("gZTZk", function(module, exports) {

$parcel$export(module.exports, "KeyboardShortcuts", () => $6f06148fa1f95cf3$export$5176144edf2bef2b);

var $5uXOq = parcelRequire("5uXOq");

var $3Tty1 = parcelRequire("3Tty1");

var $2gCtH = parcelRequire("2gCtH");

var $8CVvd = parcelRequire("8CVvd");


const $6f06148fa1f95cf3$var$bentoShortcutKeys = [
    (0, $e7036201fc72e756$export$e2291655ce717023),
    (0, $e7036201fc72e756$export$4834da14f7c856f4),
    (0, $e7036201fc72e756$export$1303babe27c61a83)
];
const $6f06148fa1f95cf3$export$5176144edf2bef2b = ({ activeIssueId: activeIssueId, activeIssueKey: activeIssueKey, activeIssueAssignee: activeIssueAssignee, currentUserAccountId: currentUserAccountId, issueKeyForModal: issueKeyForModal, hasSwimlanes: hasSwimlanes, swimlaneIds: swimlaneIds, isCMPBoard: isCMPBoard, onOpenFocusedCard: onOpenFocusedCard, onToggleBentoViewForFocusedCard: onToggleBentoViewForFocusedCard, onSwimlanesToggle: onSwimlanesToggle, onNextIssue: onNextIssue, onPrevIssue: onPrevIssue, onNextColumn: onNextColumn, onPrevColumn: onPrevColumn, onOpenAndFocusBentoField: onOpenAndFocusBentoField, onAssignToMe: onAssignToMe, onMoveToTopOrBottomOfContainer: onMoveToTopOrBottomOfContainer, onShowHideMenu: onShowHideMenu })=>{
    const viewMode = (0, $2gCtH.useViewMode)();
    const isDetailViewInSidebar = viewMode === 'SIDEBAR';
    const keyMap = {
        ...hasSwimlanes && {
            '-': {
                callback: ()=>onSwimlanesToggle(swimlaneIds)
            }
        },
        o: {
            callback: ()=>onOpenFocusedCard(activeIssueKey)
        },
        t: {
            callback: ()=>onToggleBentoViewForFocusedCard(activeIssueKey, issueKeyForModal, isDetailViewInSidebar)
        },
        j: {
            callback: onNextIssue
        },
        k: {
            callback: onPrevIssue
        },
        n: {
            callback: onNextColumn
        },
        p: {
            callback: onPrevColumn
        },
        i: {
            callback: ()=>onAssignToMe(activeIssueId, activeIssueAssignee, currentUserAccountId)
        },
        // Show/Hide menu is also called Compact mode, this whole section should be removed when cleaning up getWillShowNav3
        // as the z key is already used for the FullscreenButton (see @atlassian/jira-fullscreen-button) and
        // compact mode does not exist in nav4
        ...(0, $8CVvd.getWillShowNav3)() && isCMPBoard ? {
            z: {
                callback: onShowHideMenu
            }
        } : {},
        's t': {
            callback: ()=>onMoveToTopOrBottomOfContainer((0, $dcbb2bce513725b3$export$e5bf25b985a7619d))
        },
        's b': {
            callback: ()=>onMoveToTopOrBottomOfContainer((0, $dcbb2bce513725b3$export$e044c7349fbdcb2))
        }
    };
    $6f06148fa1f95cf3$var$bentoShortcutKeys.forEach((shortcutKey)=>{
        keyMap[shortcutKey] = {
            callback: ()=>{
                onOpenAndFocusBentoField(shortcutKey, activeIssueKey);
            }
        };
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap,
        location: "software.board.keyboard-shortcuts"
    });
};

});


parcelRegister("4z5Te", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0d6e715a08c4bca$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $8QpSo = parcelRequire("8QpSo");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $ls5Mw = parcelRequire("ls5Mw");
const $a0d6e715a08c4bca$var$onScrollAttemptedFactory = (0, $8QpSo.default)((columnCount, rapidViewId)=>(scrollChanged, analyticsEvent)=>{
        analyticsEvent.update({
            action: scrollChanged ? 'scrolled' : 'clicked'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            columnCount: columnCount,
            rapidViewId: rapidViewId
        });
    });
const $a0d6e715a08c4bca$var$onShowFactory = (0, $8QpSo.default)((columnCount, rapidViewId)=>(analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
            columnCount: columnCount,
            rapidViewId: rapidViewId
        });
    });
const $a0d6e715a08c4bca$var$mergeProps = (stateProps, dispatchProps, ownProps)=>{
    const { rapidViewId: rapidViewId, columnCount: columnCount } = stateProps;
    return {
        ...stateProps,
        ...dispatchProps,
        ...ownProps,
        onScrollAttempted: $a0d6e715a08c4bca$var$onScrollAttemptedFactory(columnCount, rapidViewId),
        onShow: $a0d6e715a08c4bca$var$onShowFactory(columnCount, rapidViewId)
    };
};
var $a0d6e715a08c4bca$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('minimap', {
    onScrollAttempted: 'scrollAttempted',
    onShow: 'showed'
}), (0, $bC2fB.connect)((state)=>({
        externalId: 'software.board.minimap',
        rapidViewId: (0, $67Z81.rapidViewIdSelector)(state),
        columnCount: (0, $5mTgl.columnsWithResolutionSelector)(state).length
    }), null, $a0d6e715a08c4bca$var$mergeProps))((0, $ls5Mw.default));

});
parcelRegister("ls5Mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $972f34c73d65dd85$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fr1K2 = parcelRequire("fr1K2");

var $fOVFI = parcelRequire("fOVFI");

var $7CMCs = parcelRequire("7CMCs");

var $axmY8 = parcelRequire("axmY8");

var $f8CI1 = parcelRequire("f8CI1");

var $lfTZh = parcelRequire("lfTZh");

var $b8gJu = parcelRequire("b8gJu");

var $8wbel = parcelRequire("8wbel");

var $29z1D = parcelRequire("29z1D");

const $972f34c73d65dd85$var$BoardMinimap = (props)=>{
    const { isOpen: isNextBestTaskPanelOpen } = (0, $f8CI1.useNextBestTaskPanel)();
    const didMountRef = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (didMountRef.current) // only execute the logic at state update, not on initial mount.
        // important to delay to wait the animation complete so we get accurate measure of NBT panel for scrollWidth !!!
        setTimeout(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        ()=>window.dispatchEvent(new Event((0, $b8gJu.UPDATE_BOARD_SCROLL_POSITION))), (0, $axmY8.ANIMATION_TIMEOUT) + 100);
        didMountRef.current = true;
    }, [
        isNextBestTaskPanelOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $29z1D.default), (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(props, 'columnCount'), isNextBestTaskPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($972f34c73d65dd85$var$NextBestTaskColumn, null), (0, (/*@__PURE__*/$parcel$interopDefault($fOVFI)))(props.columnCount, (key)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wbel.default), {
            key: key
        })));
};
const $972f34c73d65dd85$var$MiniMap = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-minimap",
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "board-minimap"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($972f34c73d65dd85$var$BoardMinimap, props)));
var $972f34c73d65dd85$export$2e2bcd8739ae039 = $972f34c73d65dd85$var$MiniMap;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $972f34c73d65dd85$var$NextBestTaskColumn = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _16jlkb7n _1o9zidpf _i0dl1wug _1dqonqa1 _1h6dm7j4 _bfhk1w7a _2hwxv77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fOVFI", function(module, exports) {

var $l2xln = parcelRequire("l2xln");

var $2KOtB = parcelRequire("2KOtB");

var $kPZpS = parcelRequire("kPZpS");
/** Used as references for various `Number` constants. */ var $b84842ed891355b2$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used as references for the maximum length and index of an array. */ var $b84842ed891355b2$var$MAX_ARRAY_LENGTH = 4294967295;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $b84842ed891355b2$var$nativeMin = Math.min;
/**
 * Invokes the iteratee `n` times, returning an array of the results of
 * each invocation. The iteratee is invoked with one argument; (index).
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 * @example
 *
 * _.times(3, String);
 * // => ['0', '1', '2']
 *
 *  _.times(4, _.constant(0));
 * // => [0, 0, 0, 0]
 */ function $b84842ed891355b2$var$times(n, iteratee) {
    n = $kPZpS(n);
    if (n < 1 || n > $b84842ed891355b2$var$MAX_SAFE_INTEGER) return [];
    var index = $b84842ed891355b2$var$MAX_ARRAY_LENGTH, length = $b84842ed891355b2$var$nativeMin(n, $b84842ed891355b2$var$MAX_ARRAY_LENGTH);
    iteratee = $2KOtB(iteratee);
    n -= $b84842ed891355b2$var$MAX_ARRAY_LENGTH;
    var result = $l2xln(length, iteratee);
    while(++index < n)iteratee(index);
    return result;
}
module.exports = $b84842ed891355b2$var$times;

});

parcelRegister("axmY8", function(module, exports) {

$parcel$export(module.exports, "WORK_SUGGESTIONS_TASK_TYPES", () => $1c70475fc99a2c16$export$3fee72c065a0af0e);
$parcel$export(module.exports, "PACKAGE_NAME", () => $1c70475fc99a2c16$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "ITEMS_PER_BATCH", () => $1c70475fc99a2c16$export$9e952e4d801fa8ed);
$parcel$export(module.exports, "NEXT_BEST_TASK_ANALYTICS", () => $1c70475fc99a2c16$export$55230ca85072e545);
$parcel$export(module.exports, "ERROR_BOUNDARY_PACKAGE", () => $1c70475fc99a2c16$export$e6c43e0cbc9a213a);
$parcel$export(module.exports, "PANEL_WIDTH", () => $1c70475fc99a2c16$export$e05cfff20e9274e6);
$parcel$export(module.exports, "PANEL_WIDTH_WITH_MARGIN", () => $1c70475fc99a2c16$export$8603bff3dda8aaad);
$parcel$export(module.exports, "PANEL_HEADER_HEIGHT", () => $1c70475fc99a2c16$export$c33dba4345ee2db8);
$parcel$export(module.exports, "ANIMATION_TIMEOUT", () => $1c70475fc99a2c16$export$fdd30d204cbe80e6);
$parcel$export(module.exports, "ARTICLE_ID", () => $1c70475fc99a2c16$export$7147685613ef9998);
$parcel$export(module.exports, "DEV_DETAILS_DIALOG_SCOPE_ID", () => $1c70475fc99a2c16$export$6bc465585d114926);
$parcel$export(module.exports, "DEV_DETAILS_DEPLOYMENT_PANEL_TYPE", () => $1c70475fc99a2c16$export$5653d49c1e9688e9);
$parcel$export(module.exports, "DEV_DETAILS_BUILD_PANEL_TYPE", () => $1c70475fc99a2c16$export$43925e5456315f);
$parcel$export(module.exports, "NEXT_BEST_TASK_USER_PROPERTIES_SCOPE", () => $1c70475fc99a2c16$export$ec5e18bceb05348c);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME", () => $1c70475fc99a2c16$export$a038bf8f85264e8b);
$parcel$export(module.exports, "WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME", () => $1c70475fc99a2c16$export$3a12d4773adf4b46);
$parcel$export(module.exports, "GITHUB_ONBOARDING_LOCAL_STORAGE_FINISHED_NAMESPACE", () => $1c70475fc99a2c16$export$a95989662296427);
$parcel$export(module.exports, "GITHUB_ONBOARDING_FINISHED_LOCAL_STORAGE_TTL_IN_MS", () => $1c70475fc99a2c16$export$4a742eb709905e27);
$parcel$export(module.exports, "WORK_SUGGESTIONS_SPOTLIGHT_MESSAGE_ID", () => $1c70475fc99a2c16$export$7d212d7793dfc186);


const $1c70475fc99a2c16$var$TASK_TYPES = {
    PULL_REQUEST_REVIEW: 'PR_REVIEW',
    PULL_REQUEST_NEEDS_WORK: 'PR_NEEDS_WORK',
    FAILED_DEPLOYMENT: 'DEPLOYMENT_FAILED',
    FAILED_BUILD: 'BUILD_FAILED',
    CRIT_VULN: 'CRIT_VULN',
    BLOCKING_ISSUE: 'BLOCKING_ISSUE',
    PR_DRAFT: 'PR_DRAFT',
    PR_STALE: 'PR_STALE',
    PR_MERGEABLE: 'PR_MERGEABLE',
    PR_COMMENTS: 'PR_COMMENTS',
    ISSUE_DUE_SOON: 'ISSUE_DUE_SOON'
};
const $1c70475fc99a2c16$export$3fee72c065a0af0e = {
    WorkSuggestionsBuildTask: 'BUILD_FAILED',
    WorkSuggestionsDeploymentTask: 'DEPLOYMENT_FAILED',
    WorkSuggestionsPullRequestReviewTask: 'PR_REVIEW',
    WorkSuggestionsPullRequestNeedsWorkTask: 'PR_NEEDS_WORK',
    WorkSuggestionsCriticalVulnerabilityTask: 'CRIT_VULN',
    WorkSuggestionsBlockingIssueTask: 'BLOCKING_ISSUE',
    WorkSuggestionsPullRequestDraftTask: 'PR_DRAFT',
    WorkSuggestionsPullRequestInactiveTask: 'PR_STALE',
    WorkSuggestionsPRMergeableTask: 'PR_MERGEABLE',
    WorkSuggestionsPRCommentsTask: 'PR_COMMENTS',
    WorkSuggestionsIssueDueSoonTask: 'ISSUE_DUE_SOON'
};
const $1c70475fc99a2c16$export$206ba94a466bfde8 = {
    REPO: 'repo',
    APPROVALS: 'approvals',
    COMMENT: 'comment',
    ISSUEKEY: 'issuekey',
    ENVIRONMENT: 'environment',
    UPDATED: 'updated',
    SECURITY_CONTAINER_NAME: 'securityContainerName',
    STATUS: 'status',
    TITLE: 'title',
    INTRODUCED_DATE: 'introducedDate'
};
const $1c70475fc99a2c16$export$b8b9d90f9e5bd72b = 'jira.next-best-task';
const $1c70475fc99a2c16$export$9e952e4d801fa8ed = 3;
const $1c70475fc99a2c16$var$NEXT_BEST_TASK_ID = 'nextBestTask';
const $1c70475fc99a2c16$export$55230ca85072e545 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${$1c70475fc99a2c16$var$NEXT_BEST_TASK_ID}`;
const $1c70475fc99a2c16$var$LOGGING_KEY = 'jira.next-best-task';
const $1c70475fc99a2c16$export$e6c43e0cbc9a213a = $1c70475fc99a2c16$var$LOGGING_KEY;
const $1c70475fc99a2c16$export$e05cfff20e9274e6 = 272;
const $1c70475fc99a2c16$export$8603bff3dda8aaad = $1c70475fc99a2c16$export$e05cfff20e9274e6 + 2;
const $1c70475fc99a2c16$var$panelHeaderHeight = 49;
const $1c70475fc99a2c16$export$c33dba4345ee2db8 = $1c70475fc99a2c16$var$panelHeaderHeight;
const $1c70475fc99a2c16$export$fdd30d204cbe80e6 = 600;
const $1c70475fc99a2c16$export$7147685613ef9998 = '2HtqtVTfYoilHIuYJIGD1T';
const $1c70475fc99a2c16$export$6bc465585d114926 = 'jira-insights-next-best-task';
const $1c70475fc99a2c16$export$5653d49c1e9688e9 = (0, $61a2cd6236d50c20$export$90cac6260ae9ced5);
const $1c70475fc99a2c16$export$43925e5456315f = (0, $61a2cd6236d50c20$export$74a388a09f2a004e);
const $1c70475fc99a2c16$export$ec5e18bceb05348c = 'jira.insights.next-best-task.user-properties';
const $1c70475fc99a2c16$export$a038bf8f85264e8b = 'workSuggestionsViewSettingsSpotlightPanel';
const $1c70475fc99a2c16$export$3a12d4773adf4b46 = 'workSuggestionsViewSettingsSpotlightViewSettings';
const $1c70475fc99a2c16$export$a95989662296427 = 'work-suggestions-github-onboarding-finished';
const $1c70475fc99a2c16$export$4a742eb709905e27 = 259200000; // 3 days
const $1c70475fc99a2c16$export$7d212d7793dfc186 = 'jira-work-suggestions-spotlight';

});
const $61a2cd6236d50c20$export$e18d81f044132a0e = 'branch';
const $61a2cd6236d50c20$export$74a388a09f2a004e = 'build';
const $61a2cd6236d50c20$export$2e42513c7764d5f3 = 'repository';
const $61a2cd6236d50c20$export$3f1e2b276d607490 = 'review';
const $61a2cd6236d50c20$export$90cac6260ae9ced5 = 'deployment-environment';
const $61a2cd6236d50c20$export$6f74b53d652f13f3 = 'pullrequest';
const $61a2cd6236d50c20$export$c69477f358d30f7e = 'feature-flags';
const $61a2cd6236d50c20$export$56470bdd9cd798d0 = 'remote-links';
const $61a2cd6236d50c20$export$b4bb784d069c9ab = 'development.details.details-header';

const $b0e6fec6a4686296$export$d3996f57ffa8448f = 'jira.insights';
const $b0e6fec6a4686296$export$c9290acd1ba498ff = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board`;
const $b0e6fec6a4686296$export$2fd6d7f902b01d67 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog`;
const $b0e6fec6a4686296$export$8e66b21ec141a0bd = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.board-simplified`;
const $b0e6fec6a4686296$export$75eb9639a5b0ba25 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.backlog-simplified`;
const $b0e6fec6a4686296$export$1269ea4f2b198811 = `${$b0e6fec6a4686296$export$d3996f57ffa8448f}.error-boundary`;


parcelRegister("f8CI1", function(module, exports) {

$parcel$export(module.exports, "useNextBestTaskPanel", () => $077be93b9454ff5d$export$9fac49065b5c5925);

var $ipmBb = parcelRequire("ipmBb");

var $2YP9W = parcelRequire("2YP9W");

var $6s1PB = parcelRequire("6s1PB");

var $02beV = parcelRequire("02beV");
const $077be93b9454ff5d$export$9fac49065b5c5925 = ()=>{
    const [{ isAutoOpened: isAutoOpened, isHiddenByUser: isHiddenByUser, isNbtToggleButtonVisible: isNbtToggleButtonVisible, isOnlyCurrentUserSelected: isOnlyCurrentUserSelected, isOnlyNBTEnabledAvatarSelected: isOnlyNBTEnabledAvatarSelected }, { setIsAutoOpened: setIsAutoOpened, setIsNbtToggleButtonVisible: setIsNbtToggleButtonVisible }] = (0, $02beV.useNextBestTaskContainer)();
    const { data: isWorkSuggestionsEnabledData } = (0, $2YP9W.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const hasUserOptedIn = !!isWorkSuggestionsEnabledData?.hasUserOptedIn;
    const NBTAvatarSelected = (0, $6s1PB.expVal)('jira-work-suggestions-unassigned-avatar-exp', 'isEnabled', false) ? isOnlyNBTEnabledAvatarSelected : isOnlyCurrentUserSelected;
    const isReadyToFetchNBT = NBTAvatarSelected && hasUserOptedIn && !isHiddenByUser;
    const isOpen = isReadyToFetchNBT && isAutoOpened;
    return {
        isReadyToFetchNBT: isReadyToFetchNBT,
        isOpen: isOpen,
        isAutoOpened: isAutoOpened,
        isNbtToggleButtonVisible: isNbtToggleButtonVisible,
        setIsAutoOpened: setIsAutoOpened,
        isHiddenByUser: isHiddenByUser,
        setIsNbtToggleButtonVisible: setIsNbtToggleButtonVisible
    };
};

});
parcelRegister("02beV", function(module, exports) {

$parcel$export(module.exports, "NextBestTaskContainer", () => $b515259196675246$export$d36ece0b77b25b77);
$parcel$export(module.exports, "useNextBestTaskContainer", () => $b515259196675246$export$4e9c40fce9aa102);
$parcel$export(module.exports, "useNextBestTaskActions", () => $b515259196675246$export$7f6f764b43177343);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $bKpgX = parcelRequire("bKpgX");

var $5VKYm = parcelRequire("5VKYm");
const $b515259196675246$export$7dd0e8f7db9f5f6f = [];
// This is the value of the store on initialisation
const $b515259196675246$var$initialState = {
    sprints: $b515259196675246$export$7dd0e8f7db9f5f6f,
    isAutoOpened: false,
    isNbtToggleButtonVisible: false,
    isOnlyCurrentUserSelected: false,
    isOnlyNBTEnabledAvatarSelected: false,
    isHiddenByUser: false,
    queryGithubOnboardingRef: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onIssueOpen: ()=>{}
};
const $b515259196675246$var$Store = (0, $iXqE5.createStore)({
    initialState: $b515259196675246$var$initialState,
    actions: $5VKYm.actions,
    name: 'jira.insights.next-best-task-store'
});
const $b515259196675246$export$78c85c0bf5f7e99b = ()=>(0, $bKpgX.defaultRegistry).deleteStore($b515259196675246$var$Store);
const $b515259196675246$var$handlePropsChange = ()=>({ setState: setState }, { accountId: accountId, boardId: boardId, isCMPBoard: isCMPBoard, sprints: sprints, onIssueOpen: onIssueOpen })=>{
        setState({
            accountId: accountId,
            boardId: boardId,
            isCMPBoard: isCMPBoard,
            sprints: sprints,
            onIssueOpen: onIssueOpen
        });
    };
const $b515259196675246$export$e26874c6341f398 = (0, $3sQ5x.createHook)($b515259196675246$var$Store, {
    selector: (state)=>state.sprints || $b515259196675246$export$7dd0e8f7db9f5f6f
});
const $b515259196675246$export$d36ece0b77b25b77 = (0, $gg7kZ.createContainer)($b515259196675246$var$Store, {
    onInit: $b515259196675246$var$handlePropsChange,
    onUpdate: $b515259196675246$var$handlePropsChange
});
const $b515259196675246$export$4e9c40fce9aa102 = (0, $3sQ5x.createHook)($b515259196675246$var$Store);
const $b515259196675246$export$7f6f764b43177343 = (0, $3sQ5x.createActionsHook)($b515259196675246$var$Store);

});
parcelRegister("5VKYm", function(module, exports) {

$parcel$export(module.exports, "actions", () => $c86e62d820c3f13d$export$e324594224ef24da);
const $c86e62d820c3f13d$export$e324594224ef24da = {
    setIsAutoOpened: (isAutoOpened)=>({ setState: setState })=>{
            setState({
                isAutoOpened: isAutoOpened
            });
        },
    setIsNbtToggleButtonVisible: (isNbtToggleButtonVisible)=>({ setState: setState })=>{
            setState({
                isNbtToggleButtonVisible: isNbtToggleButtonVisible
            });
        },
    setIsOnlyCurrentUserSelected: (isOnlyCurrentUserSelected)=>({ setState: setState })=>{
            if (!isOnlyCurrentUserSelected) setState({
                isOnlyCurrentUserSelected: isOnlyCurrentUserSelected,
                isAutoOpened: false,
                isHiddenByUser: false
            });
            else setState({
                isOnlyCurrentUserSelected: isOnlyCurrentUserSelected
            });
        },
    setIsOnlyNBTEnabledAvatarSelected: (isOnlyNBTEnabledAvatarSelected)=>({ setState: setState })=>{
            if (!isOnlyNBTEnabledAvatarSelected) setState({
                isOnlyNBTEnabledAvatarSelected: isOnlyNBTEnabledAvatarSelected,
                isAutoOpened: false,
                isHiddenByUser: false
            });
            else setState({
                isOnlyNBTEnabledAvatarSelected: isOnlyNBTEnabledAvatarSelected
            });
        },
    setQueryGithubOnboardingRef: (queryGithubOnboardingRef)=>({ getState: getState, setState: setState })=>{
            if (getState().queryGithubOnboardingRef == null) setState({
                queryGithubOnboardingRef: queryGithubOnboardingRef
            });
        },
    setIsHiddenByUser: (isHiddenByUser)=>({ setState: setState })=>{
            setState({
                isHiddenByUser: isHiddenByUser
            });
        }
};

});



parcelRegister("8wbel", function(module, exports) {

$parcel$export(module.exports, "default", () => $28fe4393b090c277$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $28fe4393b090c277$var$SC1 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _16jlkb7n _1o9zidpf _i0dl1wug _bfhkm7j4 _1s87v77o",
            __cmplp.className
        ])
    });
});
var $28fe4393b090c277$export$2e2bcd8739ae039 = $28fe4393b090c277$var$SC1;

});

parcelRegister("29z1D", function(module, exports) {

$parcel$export(module.exports, "default", () => $108e7ab3bfa0ea7c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $euZim = parcelRequire("euZim");


var $clPgE = parcelRequire("clPgE");
const $108e7ab3bfa0ea7c$var$shouldShowMap = ({ scrollWidth: scrollWidth, clientWidth: clientWidth })=>// @ts-expect-error - TS2532 - Object is possibly 'undefined'. | TS2532 - Object is possibly 'undefined'.
    scrollWidth / clientWidth > (0, $40c34f06e626eecd$export$7acdcdf60f910755);
class $108e7ab3bfa0ea7c$export$a8b4308ba35ee473 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.UNSAFE_componentWillReceiveProps = (nextProps)=>{
            const { isShowing: isShowing } = this.state;
            const shouldShow = $108e7ab3bfa0ea7c$var$shouldShowMap(nextProps);
            if (shouldShow !== isShowing) {
                if (shouldShow) this.props.onShow();
                this.setState({
                    isShowing: shouldShow
                });
            }
        }, this.onScroll = (newOffset)=>{
            const scalingFactor = this.getScalingFactor(this.props.scrollWidth);
            this.props.setHorizontalScroll(newOffset * scalingFactor);
        }, this.getScalingFactor = (0, $8QpSo.default)((scrollWidth)=>{
            const maxSizeScalingFactor = scrollWidth / (0, $40c34f06e626eecd$export$35f810a0d3987157);
            return Math.max((0, $40c34f06e626eecd$export$a5b78b73dbea576), maxSizeScalingFactor);
        });
        const isShowing = $108e7ab3bfa0ea7c$var$shouldShowMap(props);
        if (isShowing) this.props.onShow();
        this.state = {
            isShowing: isShowing
        };
    }
    getDimensions() {
        const scalingFactor = this.getScalingFactor(this.props.scrollWidth);
        return {
            outerWidth: this.props.scrollWidth / scalingFactor,
            innerWidth: this.props.clientWidth / scalingFactor,
            innerOffset: this.props.scrollLeft / scalingFactor
        };
    }
    render() {
        if (!this.state.isShowing) return null;
        const { outerWidth: outerWidth, innerWidth: innerWidth, innerOffset: innerOffset } = this.getDimensions();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $clPgE.default), {
            onScrollAttempted: this.props.onScrollAttempted,
            onScroll: this.onScroll,
            outerWidth: outerWidth,
            innerWidth: innerWidth,
            innerOffset: innerOffset
        }, this.props.children);
    }
}
const $108e7ab3bfa0ea7c$var$MinimapMain = (props)=>{
    const [{ clientWidth: clientWidth, scrollLeft: scrollLeft, scrollWidth: scrollWidth }, { onHorizontalScroll: onHorizontalScroll }] = (0, $euZim.useBoardScroll)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($108e7ab3bfa0ea7c$export$a8b4308ba35ee473, {
        clientWidth: clientWidth,
        scrollLeft: scrollLeft,
        scrollWidth: scrollWidth,
        setHorizontalScroll: onHorizontalScroll,
        ...props
    });
};
var $108e7ab3bfa0ea7c$export$2e2bcd8739ae039 = $108e7ab3bfa0ea7c$var$MinimapMain;

});
/**
 * The width of the map is determined by the board size / scaling factor.
 * A lower number means a wider minimap.
 * The map will not exceed the maxMapWidth defined below.
 */ const $40c34f06e626eecd$export$a5b78b73dbea576 = 14;
const $40c34f06e626eecd$export$35f810a0d3987157 = 100;
const $40c34f06e626eecd$export$7acdcdf60f910755 = 1.1;

parcelRegister("clPgE", function(module, exports) {

$parcel$export(module.exports, "default", () => $c221fc28899be2cf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $9TMLn = parcelRequire("9TMLn");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c221fc28899be2cf$var$RelativePositionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $c221fc28899be2cf$export$60ba57ef3cc9f0b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoftgi _1e0c116y _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _bfhk1bhr _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $c221fc28899be2cf$var$OuterViewStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { outerWidth: outerWidth, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_qlyx8j": (0, $lD23V.default)(`${__cmplp.outerWidth}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189et94y _1h6d1bhr _1bsbrmio _1e0c1txw _4t3i14no",
            __cmplp.className
        ])
    });
});
class $c221fc28899be2cf$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c221fc28899be2cf$export$60ba57ef3cc9f0b, {
            "data-testid": "platform-board-kit.ui.minimap"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c221fc28899be2cf$var$RelativePositionStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9TMLn.default), {
            onScroll: this.props.onScroll,
            onScrollAttempted: this.props.onScrollAttempted,
            innerOffset: this.props.innerOffset,
            innerWidth: this.props.innerWidth
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c221fc28899be2cf$var$OuterViewStyle, {
            outerWidth: this.props.outerWidth
        }, this.props.children));
    }
}

});
parcelRegister("9TMLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $c336701012e01494$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c336701012e01494$var$InnerViewStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { innerWidth: innerWidth, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1ekimo8": (0, $lD23V.default)(__cmplp.innerWidth, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _189eyh40 _1dqonqa1 _154i1i6y _1ltv1i6y _kqswstnw _1bsb1mf3 _4t3i14no _80om15ng",
            __cmplp.isDragging ? "_1h6d1p6i" : "_1h6d13er",
            __cmplp.className
        ])
    });
});
class $c336701012e01494$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    constructor(props){
        super(props), this.onMouseDown = (e)=>{
            if (e.button === 0) this.setState({
                isDragging: true,
                mouseStart: e.clientX,
                initialOffset: this.props.innerOffset
            });
        }, this.onMouseUp = ()=>{
            // Because we have two mouseup event handlers, this can be fired twice
            // if the mouseup is over the minimap square.
            if (this.state.isDragging) {
                const scrollChanged = this.props.innerOffset !== this.state.initialOffset;
                this.props.onScrollAttempted(scrollChanged);
                this.setState({
                    isDragging: false
                });
            }
        }, this.onMouseMove = (e)=>{
            if (this.state.isDragging && this.state.mouseStart !== null) {
                const mouseCurrent = e.clientX;
                this.props.onScroll(this.state.initialOffset + mouseCurrent - this.state.mouseStart);
            }
        }, this.setElement = (element)=>{
            this.element = element;
            this.updateInnerViewPosition();
        }, this.updateInnerViewPosition = ()=>{
            if (this.element) this.element.style.marginLeft = `${this.props.innerOffset}px`;
        }, this.element = null;
        this.state = {
            isDragging: false,
            mouseStart: null,
            initialOffset: 0
        };
    }
    componentDidUpdate(prevProps, prevState) {
        if (this.state.isDragging && !prevState.isDragging) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener('mousemove', this.onMouseMove);
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.addEventListener('mouseup', this.onMouseUp);
        } else if (!this.state.isDragging && !prevState.isDragging) this.cleanupListeners();
        this.updateInnerViewPosition();
    }
    componentWillUnmount() {
        this.cleanupListeners();
    }
    cleanupListeners() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousemove', this.onMouseMove);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mouseup', this.onMouseUp);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c336701012e01494$var$InnerViewStyle, {
            "data-testid": "platform-board-kit.ui.minimap.inner-view",
            ref: this.setElement,
            onMouseDown: this.onMouseDown,
            onMouseUp: this.onMouseUp,
            onMouseMove: this.onMouseMove,
            isDragging: this.state.isDragging,
            innerWidth: this.props.innerWidth
        });
    }
}

});





parcelRegister("8ydSK", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd6e5a7a8081ebaf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7wqBZ = parcelRequire("7wqBZ");

var $i9qZF = parcelRequire("i9qZF");

var $4wg4d = parcelRequire("4wg4d");

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $bd6e5a7a8081ebaf$export$c7cad6b3e396923a = ({ columns: columns, swimlanes: swimlanes, boardSessionId: boardSessionId })=>{
    const onStartScrollingObserver = (0, $5uXOq.useCallback)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)('scroll').start('board', undefined, {
            swimlaneCount: swimlanes.length,
            columnCount: columns.length,
            boardSessionId: boardSessionId
        });
    }, [
        swimlanes,
        columns,
        boardSessionId
    ]);
    const onStopScrollingObserver = (0, $5uXOq.useCallback)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)('scroll').stop((0, $i9qZF.boardScrollReporter));
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4wg4d.default), {
        onScrollStart: onStartScrollingObserver,
        onScrollStop: onStopScrollingObserver
    });
};
const $bd6e5a7a8081ebaf$var$mapStateToProps = (state)=>({
        columns: (0, $5mTgl.columnsWithResolutionSelector)(state),
        swimlanes: (0, $5mTgl.platformSwimlanesSelector)(state),
        boardSessionId: (0, $67Z81.sessionIdSelector)(state)
    });
const $bd6e5a7a8081ebaf$var$ScrollObserverConnected = (0, $bC2fB.connect)($bd6e5a7a8081ebaf$var$mapStateToProps, {})($bd6e5a7a8081ebaf$export$c7cad6b3e396923a);
var $bd6e5a7a8081ebaf$export$2e2bcd8739ae039 = $bd6e5a7a8081ebaf$var$ScrollObserverConnected;

});
parcelRegister("7wqBZ", function(module, exports) {

$parcel$export(module.exports, "getLongTasksMetrics", () => $f85af650a825558e$export$b092a8653a66aa5e);

var $gJBT6 = parcelRequire("gJBT6");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $cJpFl = parcelRequire("cJpFl");
let $f85af650a825558e$var$observer = null;
const $f85af650a825558e$var$stopObserver = ()=>{
    if ($f85af650a825558e$var$observer) {
        $f85af650a825558e$var$observer.disconnect();
        $f85af650a825558e$var$observer = null;
    }
};
const $f85af650a825558e$export$b092a8653a66aa5e = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((type)=>{
    const clearData = {
        type: type
    };
    let isStarted = false;
    let observationData = {
        ...clearData
    };
    const isDnd = /dnd$/.test(type.toLowerCase());
    return {
        start: (appName, startPerformanceMark, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (window.PerformanceObserver && !isStarted) try {
                const startTimestamp = (0, $6RCeq.default).now();
                observationData = {
                    type: observationData.type,
                    startTimestamp: startTimestamp,
                    dragStartEndTimestamp: startTimestamp,
                    eventStartPerformanceMark: startPerformanceMark,
                    events: [],
                    appName: appName,
                    extra: extra
                };
                isStarted = true;
                $f85af650a825558e$var$stopObserver();
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                $f85af650a825558e$var$observer = new window.PerformanceObserver((list)=>{
                    list.getEntries().forEach((entry)=>{
                        if (entry.entryType === 'longtask') {
                            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || observationData.events.find((item)=>item.timestamp === entry.startTime && item.duration === entry.duration)) return;
                            observationData.events.push({
                                timestamp: entry.startTime,
                                duration: entry.duration
                            });
                        } else if (entry.entryType === 'event' && entry.name === 'dragstart') /**
								 * Use the observed event to compute the "end" timestamp of the dragstart event,
								 * which will be used for splitting the long tasks for dragstart and dragmove.
								 */ observationData.dragStartEndTimestamp = entry.startTime + entry.duration;
                    });
                });
                $f85af650a825558e$var$observer.observe({
                    type: 'longtask'
                });
                if (isDnd) /**
						 * Observe events with >48ms duration.
						 * https://developer.mozilla.org/en-US/docs/Web/API/PerformanceObserver/observe
						 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                $f85af650a825558e$var$observer.observe({
                    type: 'event',
                    durationThreshold: 48
                });
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, no-empty
            } catch (e) {}
        },
        stop: (callback, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        extra = {})=>{
            if ((0, $6RCeq.default).now && isStarted) {
                const stopTimestamp = (0, $6RCeq.default).now();
                setTimeout(()=>{
                    $f85af650a825558e$var$stopObserver();
                    callback({
                        ...observationData
                    }, extra, stopTimestamp);
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                });
            }
        },
        stopIfNoMark: (performanceMark)=>{
            if ($f85af650a825558e$var$observer && performanceMark) {
                const perfMark = (0, $x9xyg.getMark)(performanceMark);
                if (!perfMark) {
                    $f85af650a825558e$var$stopObserver();
                    observationData = {
                        ...clearData
                    };
                    isStarted = false;
                }
            }
        }
    };
});

});
parcelRegister("cJpFl", function(module, exports) {

$parcel$export(module.exports, "isExpandedObservationData", () => $3e1de7ace69512d1$export$3d38a87309e205a4);
const $3e1de7ace69512d1$export$3d38a87309e205a4 = (observationData)=>observationData !== undefined && 'events' in observationData && observationData.events !== undefined;

});


parcelRegister("i9qZF", function(module, exports) {

$parcel$export(module.exports, "boardScrollReporter", () => $c45b7a8a0198825d$export$8ac1de4fb430c833);

var $gZFbt = parcelRequire("gZFbt");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $c45b7a8a0198825d$var$aggregatedDataTimeout = {};
const $c45b7a8a0198825d$export$8ac1de4fb430c833 = (observationData)=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $if7bx.generateLongTaskAnalyticsContinuousActionSummary)('boardScroll', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
        };
        const { appName: appName } = observationData;
        if ($c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`]) $c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`].data.push(analyticsData);
        else $c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`] = {
            data: [
                analyticsData
            ],
            extra: observationData.extra,
            timeout: setTimeout(()=>{
                const { data: data, extra: extraData } = $c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`];
                const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${appName}`);
                triggerSoftwareAnalytics('long-tasks-board-scroll', {
                    ...(0, $if7bx.getAverageResultsFromContinuousActions)('boardScroll', data),
                    ...extraData,
                    avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, 'measureTimespan')
                });
                delete $c45b7a8a0198825d$var$aggregatedDataTimeout[`software.${appName}.boardScroll`];
            }, 7000)
        };
    }
};

});
parcelRegister("gZFbt", function(module, exports) {

var $bxDef = parcelRequire("bxDef");

var $520Yb = parcelRequire("520Yb");
/**
 * This method is like `_.mean` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the value to be averaged.
 * The iteratee is invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 4.7.0
 * @category Math
 * @param {Array} array The array to iterate over.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {number} Returns the mean.
 * @example
 *
 * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
 *
 * _.meanBy(objects, function(o) { return o.n; });
 * // => 5
 *
 * // The `_.property` iteratee shorthand.
 * _.meanBy(objects, 'n');
 * // => 5
 */ function $c5f24a2590a3cbef$var$meanBy(array, iteratee) {
    return $520Yb(array, $bxDef(iteratee, 2));
}
module.exports = $c5f24a2590a3cbef$var$meanBy;

});
parcelRegister("520Yb", function(module, exports) {

var $gBzAF = parcelRequire("gBzAF");
/** Used as references for various `Number` constants. */ var $3a9de433504d679a$var$NAN = 0 / 0;
/**
 * The base implementation of `_.mean` and `_.meanBy` without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {number} Returns the mean.
 */ function $3a9de433504d679a$var$baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? $gBzAF(array, iteratee) / length : $3a9de433504d679a$var$NAN;
}
module.exports = $3a9de433504d679a$var$baseMean;

});


parcelRegister("if7bx", function(module, exports) {

$parcel$export(module.exports, "triggerAnalytics", () => $3a39af364070fc96$export$2c57de8a70f64057);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummary", () => $3a39af364070fc96$export$2be2635781d23aab);
$parcel$export(module.exports, "generateLongTaskAnalyticsSummaryWithSlo", () => $3a39af364070fc96$export$c674a20081e82c6a);
$parcel$export(module.exports, "getAverageResultsFromContinuousActions", () => $3a39af364070fc96$export$c36fdc326d0c207c);
$parcel$export(module.exports, "generateLongTaskAnalyticsContinuousActionSummary", () => $3a39af364070fc96$export$7e5f2df95eca342a);

var $gZFbt = parcelRequire("gZFbt");

var $iThRn = parcelRequire("iThRn");

var $6oxJH = parcelRequire("6oxJH");
const $3a39af364070fc96$export$2c57de8a70f64057 = (_appName)=>(_eventNameSuffix, _eventData)=>Promise.resolve(undefined);
const $3a39af364070fc96$export$2be2635781d23aab = (prefix, longTasks)=>{
    const durations = longTasks.map((task)=>task.duration);
    return {
        [`${prefix}LongTaskCount`]: longTasks.length,
        [`${prefix}LongTaskAvg`]: longTasks.length > 0 ? durations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0,
        [`${prefix}LongTaskMax`]: longTasks.length > 0 ? Math.max(...durations) : 0
    };
};
const $3a39af364070fc96$export$c674a20081e82c6a = (prefix, longTasks, sloSettings)=>{
    const summary = $3a39af364070fc96$export$2be2635781d23aab(prefix, longTasks);
    if (!sloSettings) return summary;
    const framerate = summary[`${prefix}LongTaskCount`] === 0 ? 20 : 1000 / summary[`${prefix}LongTaskAvg`];
    const blocktime = summary[`${prefix}LongTaskCount`] === 0 ? 0 : summary[`${prefix}LongTaskCount`] * summary[`${prefix}LongTaskAvg`];
    const isSuccess = framerate >= sloSettings.framerateThreshold && blocktime < sloSettings.blocktimeThreshold;
    return {
        [`${prefix}LongTaskSloIsSuccess`]: isSuccess,
        ...summary
    };
};
const $3a39af364070fc96$export$c36fdc326d0c207c = (prefix, data)=>{
    // Do NOT inline this variable into its usage site below - it is here to mitigate an Atlaspack bug: https://product-fabric.atlassian.net/browse/AFB-1057 & https://atlassian.slack.com/archives/C0288U06PGC/p1736811949973719
    const avgLongTaskCountSum = (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterAvgLongTaskCount`);
    return {
        [`${prefix}ClusterCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($6oxJH)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterCountAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterCount`) || 0,
        [`${prefix}ClusterAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvg`) || 0,
        [`${prefix}ClusterDistanceAvg`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterDistanceAvg`) || 0,
        [`${prefix}ClusterAvgLongTaskCount`]: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, `${prefix}ClusterAvgLongTaskCount`) || 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: data.length > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($iThRn)))(data.map((entry)=>entry[`${prefix}ClusterAvgLongTaskCount`] * entry[`${prefix}ClusterAvgLongTaskAvg`])) / avgLongTaskCountSum : 0,
        [`${prefix}Count`]: data.length
    };
};
const $3a39af364070fc96$export$7e5f2df95eca342a = (prefix, longTasks)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const clusters = longTasks.reduce((foundClusters, task)=>{
        if (foundClusters.length === 0) foundClusters.push({
            tasks: [],
            start: 0,
            stop: 0
        });
        const prevCluster = foundClusters[foundClusters.length - 1];
        const taskEnd = task.timestamp + task.duration;
        if (prevCluster.tasks.length === 0) {
            prevCluster.tasks.push(task);
            prevCluster.start = task.timestamp;
            prevCluster.stop = taskEnd;
        } else if (task.timestamp - prevCluster.stop < 100) {
            prevCluster.tasks.push(task);
            prevCluster.stop = taskEnd;
        } else foundClusters.push({
            tasks: [
                task
            ],
            start: task.timestamp,
            stop: taskEnd
        });
        return foundClusters;
    }, []);
    const clusterDurations = clusters.map((cluster)=>cluster.stop - cluster.start);
    const tasksDurations = longTasks.map((task)=>task.duration);
    const gapsBetweenClusters = clusters.length > 1 ? clusters // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .reduce((gaps, cluster, i)=>{
        if (gaps.length === 0) {
            gaps.push({
                start: cluster.stop,
                stop: null
            });
            return gaps;
        }
        // eslint-disable-next-line no-param-reassign
        gaps[gaps.length - 1].stop = cluster.start;
        if (i !== clusters.length - 1) gaps.push({
            start: cluster.stop,
            stop: null
        });
        return gaps;
    }, []).map((gap)=>gap.stop - gap.start) : [];
    return {
        [`${prefix}ClusterCount`]: clusters.length,
        [`${prefix}ClusterAvg`]: clusters.length > 0 ? clusterDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / clusters.length : 0,
        [`${prefix}ClusterDistanceAvg`]: gapsBetweenClusters.length > 0 ? gapsBetweenClusters.reduce((sumAcc, duration)=>sumAcc + duration, 0) / gapsBetweenClusters.length : 0,
        [`${prefix}ClusterAvgLongTaskCount`]: clusters.length > 0 ? clusters.map((cluster)=>cluster.tasks.length).reduce((sumAcc, count)=>sumAcc + count, 0) / clusters.length : 0,
        [`${prefix}ClusterAvgLongTaskAvg`]: longTasks.length > 0 ? tasksDurations.reduce((sumAcc, duration)=>sumAcc + duration, 0) / longTasks.length : 0
    };
};

});


parcelRegister("4wg4d", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a090f1e04d3c553$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $euZim = parcelRequire("euZim");
const $2a090f1e04d3c553$var$MAX_GAP_BETWEEN_SCROLL_EVENTS = 500;
// eslint-disable-next-line jira/react/no-class-components
class $2a090f1e04d3c553$var$Notifier extends (0, $5uXOq.PureComponent) {
    componentDidUpdate(prevProps) {
        if (this.props.scrollTop === prevProps.scrollTop && this.props.scrollLeft === prevProps.scrollLeft) return;
        if (!this.scrollStarted) {
            this.scrollStarted = true;
            this.props.onScrollStart();
        }
        this.scrollStop();
    }
    render() {
        return null;
    }
    constructor(...args){
        super(...args), this.scrollStarted = false, this.scrollStop = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.scrollStarted = false;
            this.props.onScrollStop();
        }, $2a090f1e04d3c553$var$MAX_GAP_BETWEEN_SCROLL_EVENTS);
    }
}
const $2a090f1e04d3c553$var$BoardScrollNotifier = (props)=>{
    const [scrollLeft] = (0, $euZim.useBoardScrollLeft)();
    const [scrollTop] = (0, $euZim.useBoardScrollTop)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a090f1e04d3c553$var$Notifier, {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop,
        ...props
    });
};
var $2a090f1e04d3c553$export$2e2bcd8739ae039 = $2a090f1e04d3c553$var$BoardScrollNotifier;

});


parcelRegister("22mIG", function(module, exports) {

$parcel$export(module.exports, "default", () => $35bf80f71813811a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dGvGJ = parcelRequire("dGvGJ");

var $8QpSo = parcelRequire("8QpSo");

var $k12ix = parcelRequire("k12ix");

var $2gCtH = parcelRequire("2gCtH");

var $jp5kW = parcelRequire("jp5kW");

var $5rqex = parcelRequire("5rqex");

var $bC2fB = parcelRequire("bC2fB");

var $9wkw7 = parcelRequire("9wkw7");

var $6uzgj = parcelRequire("6uzgj");


var $b0yad = parcelRequire("b0yad");

var $ieDtd = parcelRequire("ieDtd");


var $hz3OZ = parcelRequire("hz3OZ");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $35bf80f71813811a$var$getHasServiceWorkerController = ()=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return !!navigator?.serviceWorker?.controller;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        return false;
    }
};
const $35bf80f71813811a$export$d7d8aff642f69970 = (filters)=>Object.entries(filters).filter(([, value])=>!!value && (!Array.isArray(value) || value.length > 0)).map(([key])=>key).join(',');
const $35bf80f71813811a$var$getExtra = (0, $8QpSo.default)((isCacheHit, issueNo, boardSessionId, boardId, allFeatures, isCMPBoard, canCompleteSprint, canEditColumns, filters, swimlaneMode)=>{
    const allFeaturesReadOnly = {
        ...allFeatures
    };
    return {
        ...(0, $k12ix.getNormalisedPerformanceFFs)(),
        ...allFeaturesReadOnly,
        isCacheHit: isCacheHit,
        cacheInvalidationReasons: (0, $b0yad.getAndClearInvalidationReasons)((0, $8631d6ce464ccf2e$export$9b8283d5878d2491)).join(','),
        issueNo: issueNo,
        boardSessionId: boardSessionId,
        boardId: boardId,
        hasServiceWorkerController: $35bf80f71813811a$var$getHasServiceWorkerController(),
        isSentryEnabled: !(0, $jp5kW.default)('fe_platform_error_tracking_enabled_sentry'),
        isClassic: isCMPBoard,
        canCompleteSprint: canCompleteSprint,
        canEditColumns: canEditColumns,
        filters: $35bf80f71813811a$export$d7d8aff642f69970(filters),
        swimlaneMode: swimlaneMode
    };
});
const $35bf80f71813811a$var$getFeatureAnalyticsAttributesMemoized = ()=>(0, $dGvGJ.createSelector)((allFeatures)=>(0, $6uzgj.getFeatureAnalyticsAttributes)(allFeatures), (res)=>res);
const $35bf80f71813811a$export$c31df4bd766f9c35 = ()=>{
    const getFeatureAnalyticsAttributesInstance = $35bf80f71813811a$var$getFeatureAnalyticsAttributesMemoized();
    return (state, ownProps)=>{
        const { isCacheHit: isCacheHit } = ownProps;
        const issueNo = (0, $5mTgl.workIssuesSelector)(state).length;
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const boardSessionId = (0, $67Z81.sessionIdSelector)(state);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const allFeatures = getFeatureAnalyticsAttributesInstance((0, $67Z81.getBoardConfig)(state).allFeatures);
        const columns = (0, $5mTgl.columnsWithResolutionSelector)(state);
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const canCompleteSprint = (0, $ebHh7.canCompleteSprintSelector)(state);
        const canEditColumns = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$b5cf1ddd753a0a1c] && (0, $5mTgl.isInlineColumnEditEnabled)(state);
        const filters = (0, $5mTgl.getWorkFilters)(state).values;
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state) ?? 'NO_SWIMLANE';
        return {
            extra: $35bf80f71813811a$var$getExtra(isCacheHit, issueNo, boardSessionId, boardId, allFeatures, isCMPBoard, canCompleteSprint, canEditColumns, filters, swimlaneMode),
            columns: columns,
            isCMPBoard: isCMPBoard,
            isIncrementPlanningBoard: isIncrementPlanningBoard
        };
    };
};
const $35bf80f71813811a$export$1c42276fb052f443 = ({ columns: columns, extra: extra, isCMPBoard: isCMPBoard, isIncrementPlanningBoard: isIncrementPlanningBoard })=>{
    const issueViewMode = (0, $2gCtH.useViewMode)() || '';
    const [issueKey] = (0, $ieDtd.useQueryParam)('selectedIssue');
    const extraIssueViewData = (0, $5uXOq.useMemo)(()=>({
            issueViewMode: issueViewMode,
            isIssueViewOpen: !!issueKey
        }), [
        issueKey,
        issueViewMode
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBoard) (0, $9wkw7.pushEarlyMarksToBrowserMetrics)((0, $hz3OZ.uifBoardNewUiPageLoad));
        else if (isIncrementPlanningBoard) (0, $9wkw7.pushEarlyMarksToBrowserMetrics)((0, $hz3OZ.incrementPlanningBoardPageLoad));
        else (0, $9wkw7.pushEarlyMarksToBrowserMetrics)((0, $hz3OZ.nextGenBoardPageLoad));
    }, [
        isCMPBoard,
        isIncrementPlanningBoard
    ]);
    let metric;
    switch(true){
        case isCMPBoard:
            metric = (0, $hz3OZ.uifBoardNewUiPageLoad);
            break;
        case isIncrementPlanningBoard:
            metric = (0, $hz3OZ.incrementPlanningBoardPageLoad);
            break;
        default:
            metric = (0, $hz3OZ.nextGenBoardPageLoad);
    }
    if (columns.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5rqex.default), {
        extra: {
            ...extra,
            ...extraIssueViewData
        },
        appName: "software-board",
        // @ts-expect-error - TS2322 - Type 'PageLoadMetric' is not assignable to type 'BM3Metric'.
        metric: metric,
        testId: "software-board.board-container.submit-apdex.submit-apdex"
    });
    return null;
};
var $35bf80f71813811a$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($35bf80f71813811a$export$c31df4bd766f9c35, {})($35bf80f71813811a$export$1c42276fb052f443);

});
parcelRegister("5rqex", function(module, exports) {

$parcel$export(module.exports, "checkAndEmitApdexSignal", () => $ab527e70454bab7e$export$3082c88b693a5230);
$parcel$export(module.exports, "default", () => $ab527e70454bab7e$export$2e2bcd8739ae039);
$parcel$export(module.exports, "baseDefaultProps", () => $ab527e70454bab7e$export$9b3029ee6188a41f);

var $5uXOq = parcelRequire("5uXOq");

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $1u4q7 = parcelRequire("1u4q7");

var $1AZST = parcelRequire("1AZST");

var $6G6w0 = parcelRequire("6G6w0");

var $3wLoG = parcelRequire("3wLoG");

var $gtdbK = parcelRequire("gtdbK");

var $zbAs4 = parcelRequire("zbAs4");

var $3B7oW = parcelRequire("3B7oW");
const $ab527e70454bab7e$export$3082c88b693a5230 = (appName, metricKey)=>{
    var emitSignal;
};
class $ab527e70454bab7e$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isExpectedToHaveSsr: false,
            withMarks: [],
            extra: {},
            emitOnAnimationFrame: false
        };
    }
    render() {
        const { appName: appName, metricKey: metricKey, extra: extra, metric: metric, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        $ab527e70454bab7e$export$3082c88b693a5230(appName, metricKey);
        const isUFODefined = (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId !== 'UNKNOWN';
        if (isUFODefined) (0, $zbAs4.addUFOSSRDoneAsFMPToInteraction)();
        if (metric) {
            // https://product-fabric.atlassian.net/browse/UFO-323
            (0, $gtdbK.addBM3SSRDoneAsFMPToInteraction)(metric);
            (0, $3B7oW.trackBM3FeatureFlagsAccessed)(metric);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
            data: extra
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aOr3t.UFOBM3TimingsToUFO), {
            marks: metric?.getData()?.marks,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            timings: metric?.getData()?.config?.timings
        }), isUFODefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3wLoG.StopUfo), {
            appName: appName,
            customData: extra,
            key: (0, $1u4q7.getInteractionId)().current
        }) : metric && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6G6w0.StopBrowserMetrics3), {
            metric: metric,
            customData: extra,
            emitOnAnimationFrame: emitOnAnimationFrame
        }));
    }
}
const $ab527e70454bab7e$export$9b3029ee6188a41f = $ab527e70454bab7e$export$2e2bcd8739ae039.defaultProps;

});
parcelRegister("aOr3t", function(module, exports) {

$parcel$export(module.exports, "getBm3Timings", () => $a3e67858f0c2f8da$export$f02972da195a43bb);
$parcel$export(module.exports, "UFOBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$30f0b5e5acd268bf);
$parcel$export(module.exports, "addBM3TimingsToUFO", () => $a3e67858f0c2f8da$export$d93d677ef2f33c5c);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingConfigs) {
    const bm3Timings = {};
    if (!marks || !timingConfigs) return bm3Timings;
    timingConfigs.forEach((item)=>{
        if (!item.startMark || !item.endMark) return;
        const startTime = marks[item.startMark];
        if (!startTime) return;
        const endTime = marks[item.endMark];
        if (!endTime) return;
        bm3Timings[item.key] = {
            startTime: startTime,
            endTime: endTime
        };
    });
    return bm3Timings;
}
function $a3e67858f0c2f8da$export$30f0b5e5acd268bf({ marks: marks, timings: timings }) {
    const interactionContext = (0, $5uXOq.useContext)((0, $1tcYS.default));
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    (0, $5uXOq.useMemo)(()=>{
        if (interactionContext != null && interactionId != null && marks != null && timings != null) {
            const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
            if (interactionType === 'press') return;
            const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timings);
            interactionContext.addCustomTimings(bm3Timings);
        }
    }, [
        interactionContext,
        interactionId,
        marks,
        timings
    ]);
    return null;
}
function $a3e67858f0c2f8da$export$d93d677ef2f33c5c(marks, timingsConfig) {
    const interactionId = (0, $1u4q7.getInteractionId)().current;
    if (interactionId) {
        const interactionType = (0, $bFU4G.getCurrentInteractionType)(interactionId);
        if (interactionType === 'press') return;
        const bm3Timings = $a3e67858f0c2f8da$export$f02972da195a43bb(marks, timingsConfig);
        (0, $bFU4G.addCustomTiming)(interactionId, [], bm3Timings);
    }
}

});

parcelRegister("6G6w0", function(module, exports) {

$parcel$export(module.exports, "StopBrowserMetrics3", () => $84d0d168ebb35c8a$export$575e93c0f9905999);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $21pfT = parcelRequire("21pfT");

var $x9xyg = parcelRequire("x9xyg");

var $7N30e = parcelRequire("7N30e");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $6b6Tk = parcelRequire("6b6Tk");

const $84d0d168ebb35c8a$var$emitMetrics = (metric, customData, stopTime)=>{
    (0, $2SVPM.setInitialPageLoadTimingFromPerformanceMarks)('batch-js-heritage.eval', 'jira.heritage_batch_file_eval:start', 'jira.heritage_batch_file_eval:end');
    if (stopTime !== undefined) metric.stop({
        customData: customData,
        stopTime: stopTime
    });
    else metric.stop({
        customData: customData
    });
    if ((0, $6b6Tk.isAutomaticExposureCollectionEnabled)()) (0, $7N30e.stopLowPriorityEventDelay)();
};
class $84d0d168ebb35c8a$export$575e93c0f9905999 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { metric: metric, customData: customData, emitOnAnimationFrame: emitOnAnimationFrame } = this.props;
        if (!metric) return;
        const start = (0, $21pfT.browserMetrics).getPageLoadMetric()?.getData()?.start || 0;
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_START', {
            startTime: start
        });
        (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_END');
        (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_END');
        const bm3Data = metric.getData();
        if (emitOnAnimationFrame) {
            const stopTime = performance.now();
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: stopTime
            });
            if (typeof queueMicrotask !== 'undefined') queueMicrotask(()=>{
                (0, $x9xyg.setMark)('BROWSER_METRICS_TTI_TASK_END');
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_TASK', 'BROWSER_METRICS_TTI_START', 'BROWSER_METRICS_TTI_TASK_END');
            });
            requestAnimationFrame(()=>{
                metric.mark((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMark)((0, $ce556f125dee8174$export$99c08ec92759c71c));
                (0, $x9xyg.setMeasure)('BROWSER_METRICS_TTI_RAF', 'BROWSER_METRICS_TTI_START', (0, $ce556f125dee8174$export$99c08ec92759c71c));
                setTimeout(()=>{
                    $84d0d168ebb35c8a$var$emitMetrics(metric, customData, stopTime);
                }, 500);
            });
        } else {
            if (bm3Data) this.context?.addApdex({
                key: bm3Data.key,
                startTime: bm3Data.start,
                stopTime: performance.now()
            });
            (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
            $84d0d168ebb35c8a$var$emitMetrics(metric, customData);
        }
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("3wLoG", function(module, exports) {

$parcel$export(module.exports, "StopUfo", () => $bc9c50f4292c4530$export$d91154f099475c5);

var $5uXOq = parcelRequire("5uXOq");

var $1tcYS = parcelRequire("1tcYS");

var $1AZST = parcelRequire("1AZST");
class $bc9c50f4292c4530$export$d91154f099475c5 extends (0, $5uXOq.Component) {
    componentDidMount() {
        const { customData: customData, appName: appName } = this.props;
        (0, $1AZST.GlobalPageLoadExperience).success({
            force: true,
            metadata: customData
        });
        const name = appName || (0, $1AZST.GlobalPageLoadExperience).loadingPageLoadId;
        if (name) this.context?.addApdex({
            key: name,
            stopTime: performance.now()
        });
    }
    static{
        this.contextType = (0, $1tcYS.default);
    }
    render() {
        return null;
    }
}

});

parcelRegister("gtdbK", function(module, exports) {

$parcel$export(module.exports, "addBM3SSRDoneAsFMPToInteraction", () => $9088c71f7c9189f4$export$bf239ac2bfb04967);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");
function $9088c71f7c9189f4$export$bf239ac2bfb04967(metric) {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // Use BM3 SSR mark as FMP config for UFO if it exists, temporarily.
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && data?.isInitial) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__bm3ConfigSSRDoneAsFmp: config.ssr?.doneAsFmp || false
    });
}

});

parcelRegister("zbAs4", function(module, exports) {

$parcel$export(module.exports, "addUFOSSRDoneAsFMPToInteraction", () => $30d390cd1767d57f$export$e63862cd888fe05a);

var $1u4q7 = parcelRequire("1u4q7");

var $bFU4G = parcelRequire("bFU4G");

var $1AZST = parcelRequire("1AZST");
var $49z18 = parcelRequire("49z18");
async function $30d390cd1767d57f$export$e63862cd888fe05a() {
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    // Use UFO SSR mark as FMP config for rUFO if it exists, temporarily.
    const data = await (0, $1AZST.GlobalPageLoadExperience).exportData();
    const fmpMark = data.metrics.marks.find((mark)=>mark.name === 'fmp') || (0, $49z18.payloadPublisher).ssr?.getDoneMark();
    if (data.initial && fmpMark) (0, $bFU4G.addMetadata)(currentInteractionId, {
        __legacy__ufoConfigSSRDoneAsFmp: true
    });
}

});

parcelRegister("3B7oW", function(module, exports) {

$parcel$export(module.exports, "trackBM3FeatureFlagsAccessed", () => $afa764d83f81f55e$export$f00f1e874ce869e9);

var $1u4q7 = parcelRequire("1u4q7");

var $y7eb2 = parcelRequire("y7eb2");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$startsAsObject = (value)=>{
    try {
        if (value.charAt(0) === '{') return true;
    } catch (e) {
        return false;
    }
    return false;
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isObject = (value)=>value && typeof value === 'object' && value.constructor === Object;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $afa764d83f81f55e$var$isString = (input)=>{
    let result;
    try {
        result = typeof input === 'string' || input instanceof String;
    } catch (err) {
        // swallow any errors
        result = false;
    }
    return result;
};
const $afa764d83f81f55e$export$7b4abba432e57989 = (value)=>$afa764d83f81f55e$var$isString(value) && $afa764d83f81f55e$var$startsAsObject(value) || $afa764d83f81f55e$var$isObject(value);
const $afa764d83f81f55e$export$fcc03ee4c944962f = (featureFlagValue)=>$afa764d83f81f55e$export$7b4abba432e57989(featureFlagValue) ? 'non_boolean' : featureFlagValue;
const $afa764d83f81f55e$export$d2818866b4acbea4 = new Map();
const $afa764d83f81f55e$export$f00f1e874ce869e9 = (metric)=>{
    const interactionId = (0, $1u4q7.getInteractionId)();
    const currentInteractionId = interactionId.current;
    if (!currentInteractionId) return;
    const data = metric.getData();
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const config = data?.config;
    if (config && config?.featureFlags?.length) {
        const allFeatureFlags = (0, $y7eb2.default)();
        config.featureFlags.forEach((featureFlagName)=>{
            const value = allFeatureFlags[featureFlagName];
            if (value === undefined) return;
            const featureFlagValue = $afa764d83f81f55e$export$fcc03ee4c944962f(value);
            $afa764d83f81f55e$export$d2818866b4acbea4.set(featureFlagName, featureFlagValue);
        });
    }
};

});


parcelRegister("9wkw7", function(module, exports) {

$parcel$export(module.exports, "pushEarlyMarksToBrowserMetrics", () => $18c0c41d8db3822c$export$b7c0f32f0c63e86b);
const $18c0c41d8db3822c$export$2f0748f9bcbd5ff0 = {
    'jira.fe-spa.software.early-preload:start': 'EARLY_FETCH_START',
    'jira.fe-spa.software.early-preload:end': 'EARLY_FETCH_END'
};
const $18c0c41d8db3822c$export$b7c0f32f0c63e86b = (metric, options)=>{
    const marks = {
        ...$18c0c41d8db3822c$export$2f0748f9bcbd5ff0,
        ...options?.marks ?? {}
    };
    Object.keys(marks).forEach((mark)=>{
        const startTime = performance.getEntriesByName(mark)[0]?.startTime;
        if (startTime != null) metric.mark(marks[mark], startTime);
    });
};

});


parcelRegister("3nXC3", function(module, exports) {

$parcel$export(module.exports, "default", () => $0efa9b497dd51ee9$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $jzjy1 = parcelRequire("jzjy1");

var $k12ix = parcelRequire("k12ix");

var $7wqBZ = parcelRequire("7wqBZ");

var $dhsbO = parcelRequire("dhsbO");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $ieDtd = parcelRequire("ieDtd");

var $ACELo = parcelRequire("ACELo");

var $2BvBY = parcelRequire("2BvBY");

var $cNbZY = parcelRequire("cNbZY");

var $9Ik53 = parcelRequire("9Ik53");

var $g3RsK = parcelRequire("g3RsK");

var $l8ruj = parcelRequire("l8ruj");

var $c1haS = parcelRequire("c1haS");


var $47POI = parcelRequire("47POI");

var $gM0Co = parcelRequire("gM0Co");

var $btiFk = parcelRequire("btiFk");

var $aJnM9 = parcelRequire("aJnM9");

var $4lizL = parcelRequire("4lizL");

var $4uy3J = parcelRequire("4uy3J");

var $hnOnj = parcelRequire("hnOnj");

var $2h6St = parcelRequire("2h6St");
// eslint-disable-next-line jira/react/no-class-components
class $0efa9b497dd51ee9$var$SoftwareBoard extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            hasMinimap: true,
            onBoardNonCriticalViewed: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    constructor(props){
        super(props), this.handleMouseEvents = (event)=>{
            if (event.metaKey || event.altKey || event.ctrlKey) this.props.onPreventInlineEditing(true);
            else if (this.props.preventInlineEditing) this.props.onPreventInlineEditing?.(false);
        };
        this.state = {
            scrollingElementRef: /*#__PURE__*/ (0, $5uXOq.createRef)(),
            boardNonCriticalViewEventFired: false
        };
        (0, $6s1PB.expVal)('jira_aa_test', 'cohort', 'not-enrolled');
        (0, $6s1PB.expVal)('jira_aa_test_with_targeting', 'cohort', 'not-enrolled');
    }
    componentDidMount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mousedown', this.handleMouseEvents, true);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('mouseup', this.handleMouseEvents, true);
    }
    componentDidUpdate() {
        (0, $7wqBZ.getLongTasksMetrics)('filter').stop((0, $dhsbO.filterReporter), {
            boardSessionId: this.props.boardSessionId
        });
        if (!this.state.boardNonCriticalViewEventFired && this.props.isNonCriticalWorksetLoaded) {
            this.props.onBoardNonCriticalViewed();
            this.setState({
                boardNonCriticalViewEventFired: true
            });
        }
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mousedown', this.handleMouseEvents);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('mouseup', this.handleMouseEvents);
    }
    getInitialScrollState() {
        return {
            height: globalThis.innerHeight,
            width: 0,
            scrollHeight: globalThis.innerHeight,
            scrollWidth: 0,
            scrollTop: 0,
            scrollLeft: 0,
            isScrolling: false,
            scrollElement: null
        };
    }
    render() {
        const { isCacheHit: isCacheHit, isColumnCreateAllowed: isColumnCreateAllowed, isInlineColumnEditEnabled: isInlineColumnEditEnabled, isFlexibleColumns: isFlexibleColumns, hasSwimlanes: hasSwimlanes, hasMinimap: hasMinimap, Board: Board, BacklogIssueMoveDialog: BacklogIssueMoveDialog, KeyboardShortcuts: KeyboardShortcuts, ColumnCreate: ColumnCreate, ColumnConfigurationButton: ColumnConfigurationButton, BoardMinimap: BoardMinimap, SubmitApdex: SubmitApdex, ScrollObserver: ScrollObserver, shouldRenderSwimlane: shouldRenderSwimlane, isColumnConfigurationButtonEnabled: isColumnConfigurationButtonEnabled, isUnscheduledColumnVisible: isUnscheduledColumnVisible, isIncrementPlanningBoard: isIncrementPlanningBoard, hasAssigneeFilter: hasAssigneeFilter, isJSWBoard: isJSWBoard } = this.props;
        const isBoardWithVisibleUnscheduledWorkPanel = isIncrementPlanningBoard && isUnscheduledColumnVisible;
        const boardChildren = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Board, {
            scrollRef: this.state.scrollingElementRef,
            isBoardWithVisibleUnscheduledWorkPanel: isBoardWithVisibleUnscheduledWorkPanel
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(KeyboardShortcuts, {
            // @ts-expect-error TS2322 - hasSwimlanes possibly is dead-code
            hasSwimlanes: hasSwimlanes
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btiFk.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BacklogIssueMoveDialog, null), hasAssigneeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47POI.NextBestTaskPanel), null), this.props.isIncrementPlanningBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4uy3J.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0efa9b497dd51ee9$var$BoardContainer, {
            isFlexible: isFlexibleColumns,
            ...isBoardWithVisibleUnscheduledWorkPanel && {
                'data-testid': 'software-board.board-container.scheduled-work-board'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ik53.ScrollStateContextProvider), {
            scrollRef: this.state.scrollingElementRef,
            initialScrollState: isJSWBoard && !isIncrementPlanningBoard && (0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('fix_board_content_rendering_delay') ? this.getInitialScrollState() : undefined
        }, shouldRenderSwimlane ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnOnj.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lizL.default), {
            swimlaneId: null,
            isLastSwimlane: true,
            isUnscheduledWorkColumn: false
        }))), isColumnCreateAllowed && isInlineColumnEditEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ColumnCreate, null), isColumnCreateAllowed && !isInlineColumnEditEnabled && isColumnConfigurationButtonEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ColumnConfigurationButton, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0efa9b497dd51ee9$var$ScrollInterceptorWrapper, {
            scrollEl: this.state.scrollingElementRef.current
        }), // LongTasksScrollObserver for software board
        !isIncrementPlanningBoard && (0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3RsK.LongTasksScrollObserver), {
            appName: (0, $7e733a5d4e4331fc$export$24f467771705aaff),
            scrollEl: this.state.scrollingElementRef.current,
            attributes: (0, $k12ix.getNormalisedPerformanceFFs)()
        }), // LongTasksScrollObserver for program board
        isIncrementPlanningBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3RsK.LongTasksScrollObserver), {
            appName: (0, $7e733a5d4e4331fc$export$ccd6af533dc2d202),
            scrollEl: this.state.scrollingElementRef.current,
            attributes: (0, $k12ix.getNormalisedPerformanceFFs)(),
            logAttributes: {
                isDependencyVisualisationEnabled: true
            }
        })), hasMinimap && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ACELo.JiraBottomRightCornerOutlet), {
            orderFromRight: 2,
            id: "software-board-minimp"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardMinimap, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SubmitApdex, {
            isCacheHit: isCacheHit
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ScrollObserver, null), (0, $4R6GH.fg)('unassigned_filter_kill_switch') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2h6St.UnassignedWorkAnalytics), null));
        const boardWithUnscheduledColumn = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $0efa9b497dd51ee9$var$BoardWithUnscheduledColumnWrapperStyles
        }, isUnscheduledColumnVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gM0Co.UnscheduledWorkPanel), null), boardChildren);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "board-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0efa9b497dd51ee9$var$BoardWrapper, {
            "data-onboarding-observer-id": "board-wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2BvBY.BoardProvider), null, isIncrementPlanningBoard && isUnscheduledColumnVisible ? boardWithUnscheduledColumn : boardChildren)));
    }
}
const $0efa9b497dd51ee9$var$ScrollInterceptorWrapper = ({ scrollEl: scrollEl })=>{
    (0, $cNbZY.useScrollUpdateHandler)(scrollEl);
    return null;
};
const $0efa9b497dd51ee9$var$SoftwareBoardWithDragDropContext = (props)=>{
    (0, $aJnM9.useBoardDragDropContext)({
        onDragEnd: props.onDragEnd
    });
    const [assigneeFilter] = (0, $ieDtd.useQueryParam)('assignee');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0efa9b497dd51ee9$var$SoftwareBoard, {
        ...props,
        ...!props.isFilterRefinementEnabled ? {
            hasAssigneeFilter: !!assigneeFilter
        } : {}
    });
};
var $0efa9b497dd51ee9$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSubject)('board')($0efa9b497dd51ee9$var$SoftwareBoardWithDragDropContext);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0efa9b497dd51ee9$var$BoardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1ul9idpf _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $0efa9b497dd51ee9$var$BoardWithUnscheduledColumnWrapperStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    width: '100%',
    height: '100%',
    paddingLeft: 'space.500'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $0efa9b497dd51ee9$var$BoardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFlexible ? "_16jlkb7n _1o9zkb7n _i0dlf1ug" : "_16jlidpf _1o9zkb7n _i0dl1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dhsbO", function(module, exports) {

$parcel$export(module.exports, "filterReporter", () => $f7989144fec0a9cf$export$facf842185aa645c);

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $f7989144fec0a9cf$export$facf842185aa645c = (observationData, // eslint-disable-next-line @typescript-eslint/no-explicit-any
featureFlags = {})=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...(0, $if7bx.generateLongTaskAnalyticsSummary)('filter', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            ...featureFlags,
            performanceFFs: (0, $k12ix.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-filter', analyticsData);
        try {
            performance.measure('filterBarResponsiveness', 'filterBarStart', 'filterBarStop');
            triggerSoftwareAnalytics('performance-filter-bar', performance.getEntriesByName('filterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        try {
            performance.measure('oldFilterBarResponsiveness', 'oldFilterBarStart', 'oldFilterBarStop');
            triggerSoftwareAnalytics('performance-old-filter-bar', performance.getEntriesByName('oldFilterBarResponsiveness')[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
        // do nothing
        }
        performance.clearMeasures();
    }
};

});

parcelRegister("2BvBY", function(module, exports) {

$parcel$export(module.exports, "BoardProvider", () => $f3903c1d72f98e72$export$70255033b788b22c);

var $5uXOq = parcelRequire("5uXOq");

var $jD5no = parcelRequire("jD5no");

var $2Z6La = parcelRequire("2Z6La");
const $f3903c1d72f98e72$export$70255033b788b22c = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jD5no.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z6La.IccProvider), null, children));
});

});
parcelRegister("2Z6La", function(module, exports) {

$parcel$export(module.exports, "IccContext", () => $093fa356b2a966b6$export$2f62d2dfd027123d);
$parcel$export(module.exports, "useIccContext", () => $093fa356b2a966b6$export$f7b8d088c9ea045e);
$parcel$export(module.exports, "IccProvider", () => $093fa356b2a966b6$export$4a7497397d7465fc);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");
const $093fa356b2a966b6$var$defaultValue = {
    initialSummary: '',
    initialCardTypeId: null,
    initialFieldValues: new Map(),
    initialProjectId: null,
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeFieldValue: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
const $093fa356b2a966b6$export$2f62d2dfd027123d = /*#__PURE__*/ (0, $5uXOq.createContext)($093fa356b2a966b6$var$defaultValue);
const $093fa356b2a966b6$export$f7b8d088c9ea045e = ()=>(0, $5uXOq.useContext)($093fa356b2a966b6$export$2f62d2dfd027123d);
const $093fa356b2a966b6$export$4a7497397d7465fc = ({ children: children })=>{
    const [initialSummary, setInitialSummary] = (0, $5uXOq.useState)($093fa356b2a966b6$var$defaultValue.initialSummary);
    const [initialCardTypeId, setInitialCardTypeId] = (0, $5uXOq.useState)($093fa356b2a966b6$var$defaultValue.initialCardTypeId);
    const [initialFieldValues, setInitialFieldValues] = (0, $5uXOq.useState)($093fa356b2a966b6$var$defaultValue.initialFieldValues);
    const [initialProjectId, setInitialProjectId] = (0, $5uXOq.useState)($093fa356b2a966b6$var$defaultValue.initialProjectId);
    const onChangeSummary = (0, $5uXOq.useCallback)((summary)=>{
        setInitialSummary(summary);
    }, []);
    const onChangeProject = (0, $5uXOq.useCallback)((projectId)=>{
        setInitialProjectId(projectId);
    }, []);
    const onChangeCardType = (0, $5uXOq.useCallback)((cardTypeId)=>{
        setInitialCardTypeId(cardTypeId);
    }, []);
    const onChangeFieldValue = (0, $5uXOq.useCallback)((fieldKey, fieldValue)=>{
        setInitialFieldValues((prevFieldValues)=>{
            const updatedFieldValues = new Map(prevFieldValues);
            updatedFieldValues.set(fieldKey, fieldValue);
            return updatedFieldValues;
        });
    }, []);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        setInitialSummary('');
        setInitialCardTypeId(null);
    }, []);
    const onCreate = (0, $5uXOq.useCallback)(()=>{
        setInitialSummary('');
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($093fa356b2a966b6$export$2f62d2dfd027123d.Provider, {
        value: {
            initialSummary: initialSummary,
            initialCardTypeId: initialCardTypeId,
            initialFieldValues: initialFieldValues,
            initialProjectId: initialProjectId,
            onChangeCardType: onChangeCardType,
            onChangeSummary: onChangeSummary,
            onChangeFieldValue: onChangeFieldValue,
            onChangeProject: onChangeProject,
            onCancel: onCancel,
            onCreate: onCreate
        }
    }, children);
};

});


parcelRegister("cNbZY", function(module, exports) {

$parcel$export(module.exports, "useScrollUpdateHandler", () => $46fb1b92cbb2f8d7$export$24ee9c57c84f616c);

var $5uXOq = parcelRequire("5uXOq");

var $ftJce = parcelRequire("ftJce");

var $3HhiT = parcelRequire("3HhiT");
const $46fb1b92cbb2f8d7$export$24ee9c57c84f616c = (scrollEl)=>{
    (0, $5uXOq.useEffect)(()=>{
        if (scrollEl == null) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const showEventHandler = ()=>{
            Object.assign(scrollEl.style, {
                overflowX: 'auto',
                overflowY: 'auto'
            });
        };
        const hideEventHandler = ()=>{
            Object.assign(scrollEl.style, {
                overflowX: 'hidden',
                overflowY: 'hidden'
            });
        };
        const scrollToEventHandler = (payload = {
            x: 0,
            y: 0
        })=>{
            Object.assign(scrollEl, {
                scrollLeft: payload.x,
                scrollTop: payload.y
            });
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorHandler = (error)=>{
            (0, $ftJce.fireErrorAnalytic)({
                error: error
            });
        };
        (0, $3HhiT.default).on('show', showEventHandler);
        (0, $3HhiT.default).on('hide', hideEventHandler);
        (0, $3HhiT.default).on('scrollTo', scrollToEventHandler);
        (0, $3HhiT.default).on('error', errorHandler);
        return ()=>{
            (0, $3HhiT.default)?.removeListener('show', showEventHandler);
            (0, $3HhiT.default)?.removeListener('hide', hideEventHandler);
            (0, $3HhiT.default)?.removeListener('scrollTo', scrollToEventHandler);
            (0, $3HhiT.default)?.removeListener('error', errorHandler);
        };
    }, [
        scrollEl
    ]);
};

});
parcelRegister("ftJce", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytic", () => $2f542d00f6e2e618$export$e4e69593f7c9f3b7);

var $jcw0u = parcelRequire("jcw0u");
const $2f542d00f6e2e618$export$e4e69593f7c9f3b7 = (attributes)=>{
    (0, $jcw0u.default)({
        meta: {
            id: 'scrollInterceptor',
            packageName: 'jiraScrollInterceptor',
            teamName: 'jlove-makkuro'
        },
        // @ts-expect-error - TS2322 - Type '{ message?: string | undefined; error?: Error | undefined; }' is not assignable to type 'AnalyticsAttributes'.
        attributes: {
            ...attributes
        }
    });
};

});

parcelRegister("3HhiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1879957ed125520$export$2e2bcd8739ae039);

var $6Oghe = parcelRequire("6Oghe");
var // Standard observer pattern, the nudges will invoke this
// to change visibility of scroll element or scroll to the point
// eslint-disable-next-line jira/import/no-anonymous-default-export
$a1879957ed125520$export$2e2bcd8739ae039 = new (0, (/*@__PURE__*/$parcel$interopDefault($6Oghe)))();

});
parcelRegister("6Oghe", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
'use strict';
var $4f5409da028b4771$var$R = typeof Reflect === 'object' ? Reflect : null;
var $4f5409da028b4771$var$ReflectApply = $4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.apply === 'function' ? $4f5409da028b4771$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $4f5409da028b4771$var$ReflectOwnKeys;
if ($4f5409da028b4771$var$R && typeof $4f5409da028b4771$var$R.ownKeys === 'function') $4f5409da028b4771$var$ReflectOwnKeys = $4f5409da028b4771$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $4f5409da028b4771$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $4f5409da028b4771$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $4f5409da028b4771$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $4f5409da028b4771$var$EventEmitter() {
    $4f5409da028b4771$var$EventEmitter.init.call(this);
}
module.exports = $4f5409da028b4771$var$EventEmitter;
module.exports.once = $4f5409da028b4771$var$once;
// Backwards-compat with node 0.10.x
$4f5409da028b4771$var$EventEmitter.EventEmitter = $4f5409da028b4771$var$EventEmitter;
$4f5409da028b4771$var$EventEmitter.prototype._events = undefined;
$4f5409da028b4771$var$EventEmitter.prototype._eventsCount = 0;
$4f5409da028b4771$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $4f5409da028b4771$var$defaultMaxListeners = 10;
function $4f5409da028b4771$var$checkListener(listener) {
    if (typeof listener !== 'function') throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($4f5409da028b4771$var$EventEmitter, 'defaultMaxListeners', {
    enumerable: true,
    get: function() {
        return $4f5409da028b4771$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== 'number' || arg < 0 || $4f5409da028b4771$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + '.');
        $4f5409da028b4771$var$defaultMaxListeners = arg;
    }
});
$4f5409da028b4771$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$4f5409da028b4771$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== 'number' || n < 0 || $4f5409da028b4771$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + '.');
    this._maxListeners = n;
    return this;
};
function $4f5409da028b4771$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $4f5409da028b4771$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$4f5409da028b4771$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $4f5409da028b4771$var$_getMaxListeners(this);
};
$4f5409da028b4771$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === 'error';
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error('Unhandled error.' + (er ? ' (' + er.message + ')' : ''));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === 'function') $4f5409da028b4771$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $4f5409da028b4771$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$4f5409da028b4771$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $4f5409da028b4771$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $4f5409da028b4771$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit('newListener', type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === 'function') // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $4f5409da028b4771$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error('Possible EventEmitter memory leak detected. ' + existing.length + ' ' + String(type) + ' listeners ' + 'added. Use emitter.setMaxListeners() to ' + 'increase limit');
            w.name = 'MaxListenersExceededWarning';
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $4f5409da028b4771$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$4f5409da028b4771$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, false);
};
$4f5409da028b4771$var$EventEmitter.prototype.on = $4f5409da028b4771$var$EventEmitter.prototype.addListener;
$4f5409da028b4771$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $4f5409da028b4771$var$_addListener(this, type, listener, true);
};
function $4f5409da028b4771$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $4f5409da028b4771$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $4f5409da028b4771$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$4f5409da028b4771$var$EventEmitter.prototype.once = function once(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.on(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $4f5409da028b4771$var$checkListener(listener);
    this.prependListener(type, $4f5409da028b4771$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$4f5409da028b4771$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $4f5409da028b4771$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit('removeListener', type, list.listener || listener);
        }
    } else if (typeof list !== 'function') {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $4f5409da028b4771$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit('removeListener', type, originalListener || listener);
    }
    return this;
};
$4f5409da028b4771$var$EventEmitter.prototype.off = $4f5409da028b4771$var$EventEmitter.prototype.removeListener;
$4f5409da028b4771$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === 'removeListener') continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners('removeListener');
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === 'function') this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $4f5409da028b4771$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === 'function') return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $4f5409da028b4771$var$unwrapListeners(evlistener) : $4f5409da028b4771$var$arrayClone(evlistener, evlistener.length);
}
$4f5409da028b4771$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, true);
};
$4f5409da028b4771$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $4f5409da028b4771$var$_listeners(this, type, false);
};
$4f5409da028b4771$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === 'function') return emitter.listenerCount(type);
    else return $4f5409da028b4771$var$listenerCount.call(emitter, type);
};
$4f5409da028b4771$var$EventEmitter.prototype.listenerCount = $4f5409da028b4771$var$listenerCount;
function $4f5409da028b4771$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === 'function') return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$4f5409da028b4771$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $4f5409da028b4771$var$ReflectOwnKeys(this._events) : [];
};
function $4f5409da028b4771$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $4f5409da028b4771$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $4f5409da028b4771$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $4f5409da028b4771$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === 'function') emitter.removeListener('error', errorListener);
            resolve([].slice.call(arguments));
        }
        $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== 'error') $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $4f5409da028b4771$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === 'function') $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, 'error', handler, flags);
}
function $4f5409da028b4771$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === 'function') {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === 'function') // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});



parcelRegister("9Ik53", function(module, exports) {

$parcel$export(module.exports, "useScrollState", () => $c77424cc0be42400$export$98084ad349e2edae);
$parcel$export(module.exports, "ScrollStateContextProvider", () => $c77424cc0be42400$export$7cc0055278d35041);
/*!
 * Adding too many scroll listeners adds overhead to both the initial
 * "bootstrap" phase, when the listeners are added, and all scroll events.
 *
 * Some virtualisation use-cases such as boards may have a large number of
 * virtual lists instances. Sharing a scroll element through context avoids
 * attaching one listener per list.
 */ 
var $5uXOq = parcelRequire("5uXOq");
const $c77424cc0be42400$export$50b6b7783d156e1b = 200;
const $c77424cc0be42400$var$DEFAULT_SCROLL_STATE = {
    height: 0,
    width: 0,
    scrollHeight: 0,
    scrollWidth: 0,
    scrollTop: 0,
    scrollLeft: 0,
    isScrolling: false,
    scrollElement: null
};
const $c77424cc0be42400$var$ScrollStateContext = /*#__PURE__*/ (0, $5uXOq.createContext)($c77424cc0be42400$var$DEFAULT_SCROLL_STATE);
const $c77424cc0be42400$export$98084ad349e2edae = ()=>(0, $5uXOq.useContext)($c77424cc0be42400$var$ScrollStateContext);
const $c77424cc0be42400$var$attachResizeObserver = (callback, targetEl)=>{
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    if (!targetEl) return ()=>{};
    let resizeObserver = null;
    // SSR fix. Do not instantiate for SSR
    if (typeof ResizeObserver !== 'undefined') resizeObserver = new ResizeObserver(()=>callback());
    // When mounting our listener, if its the Window object, treat it as such.
    // This can happen in Storybook but not in any other scenario
    if (targetEl instanceof Window) targetEl.addEventListener('resize', callback);
    else resizeObserver?.observe(targetEl);
    return ()=>{
        // Cleanup the resize callback we have attached
        if (targetEl instanceof Window) targetEl.removeEventListener('resize', callback);
        else resizeObserver?.disconnect();
    };
};
/**
 * Listens for scroll events on the `HTMLElement` `scrollRef.current` and updates a state
 * variable with the scroll state, which is returned.
 */ const $c77424cc0be42400$var$useElementScrollState = (scrollRef, shouldSkipFirstResize, initialScrollState)=>{
    const [scrollState, setScrollState] = (0, $5uXOq.useState)(initialScrollState ?? $c77424cc0be42400$var$DEFAULT_SCROLL_STATE);
    const isFirstResize = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        const targetEl = scrollRef.current;
        if (!targetEl) return undefined;
        let clearScrollingTimeoutId;
        const onScroll = ()=>{
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $c77424cc0be42400$export$50b6b7783d156e1b);
        };
        const onResize = ()=>{
            if (shouldSkipFirstResize && isFirstResize.current) {
                isFirstResize.current = false;
                return;
            }
            setScrollState((state)=>({
                    ...state,
                    scrollTop: targetEl.scrollTop,
                    scrollLeft: targetEl.scrollLeft,
                    height: targetEl.clientHeight,
                    width: targetEl.clientWidth,
                    scrollHeight: targetEl.scrollHeight,
                    scrollWidth: targetEl.scrollWidth,
                    isScrolling: true
                }));
            clearTimeout(clearScrollingTimeoutId);
            clearScrollingTimeoutId = setTimeout(()=>{
                setScrollState((state)=>({
                        ...state,
                        scrollTop: targetEl.scrollTop,
                        scrollLeft: targetEl.scrollLeft,
                        isScrolling: false
                    }));
            }, $c77424cc0be42400$export$50b6b7783d156e1b);
        };
        // We want to know when the scroll element/container itself resizes as this impacts
        // the number of rows we show
        const cleanupResizeObserver = $c77424cc0be42400$var$attachResizeObserver(onResize, targetEl);
        targetEl.addEventListener('scroll', onScroll);
        setScrollState({
            height: targetEl.clientHeight,
            width: targetEl.clientWidth,
            scrollHeight: targetEl.scrollHeight,
            scrollWidth: targetEl.scrollWidth,
            scrollTop: targetEl.scrollTop,
            scrollLeft: targetEl.scrollLeft,
            isScrolling: false,
            scrollElement: targetEl
        });
        return ()=>{
            targetEl.removeEventListener('scroll', onScroll);
            cleanupResizeObserver();
            clearTimeout(clearScrollingTimeoutId);
        };
    }, [
        scrollRef,
        shouldSkipFirstResize
    ]);
    return scrollState;
};
const $c77424cc0be42400$export$7cc0055278d35041 = ({ scrollRef: scrollRef, shouldSkipFirstResize: shouldSkipFirstResize, children: children, initialScrollState: initialScrollState })=>{
    const scrollState = $c77424cc0be42400$var$useElementScrollState(scrollRef, shouldSkipFirstResize, initialScrollState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c77424cc0be42400$var$ScrollStateContext.Provider, {
        value: scrollState
    }, children);
};

});

parcelRegister("g3RsK", function(module, exports) {

$parcel$export(module.exports, "LongTasksScrollObserver", () => $fe64e9d70a250807$export$55bf40af27443842);

var $5uXOq = parcelRequire("5uXOq");

var $7wqBZ = parcelRequire("7wqBZ");

var $4R6GH = parcelRequire("4R6GH");

var $bv8GQ = parcelRequire("bv8GQ");

var $gi25H = parcelRequire("gi25H");
/**
 * Tracks long-tasks that happen while scrolling on a certain 'scrollEl'.
 */ const $fe64e9d70a250807$var$LongTasksScrollObserverBase = ({ observationType: observationType, attributes: attributes, appName: appName, logAttributes: logAttributes = {}, ...rest })=>{
    const onScrollStart = (0, $5uXOq.useCallback)(()=>{
        (0, $7wqBZ.getLongTasksMetrics)(observationType).start(appName, undefined, attributes);
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) performance.mark(`${appName}:scrolling-task:start`);
    }, [
        attributes,
        appName,
        observationType
    ]);
    const onScrollEnd = (0, $5uXOq.useCallback)((lastScrollTime)=>{
        (0, $7wqBZ.getLongTasksMetrics)(observationType).stop((0, $bv8GQ.softwareGenericLongTasksReporter)('scroll', lastScrollTime, logAttributes));
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) {
            performance.mark(`${appName}:scrolling-task:end`);
            performance.measure(`${appName}:scrolling-task`, `${appName}:scrolling-task:start`, `${appName}:scrolling-task:end`);
        }
    }, [
        observationType,
        appName,
        logAttributes
    ]);
    (0, $gi25H.useScrollStateObserver)({
        ...rest,
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd
    });
    return null;
};
$fe64e9d70a250807$var$LongTasksScrollObserverBase.defaultProps = {
    observationType: 'scroll',
    attributes: {}
};
const $fe64e9d70a250807$export$55bf40af27443842 = /*#__PURE__*/ (0, $5uXOq.memo)($fe64e9d70a250807$var$LongTasksScrollObserverBase);

});
parcelRegister("bv8GQ", function(module, exports) {

$parcel$export(module.exports, "softwareGenericLongTasksReporter", () => $2795c9afa9443b8c$export$b78c92c0ba709033);

var $gZFbt = parcelRequire("gZFbt");

var $if7bx = parcelRequire("if7bx");

var $cJpFl = parcelRequire("cJpFl");

var $4R6GH = parcelRequire("4R6GH");


var $fjcgS = parcelRequire("fjcgS");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2795c9afa9443b8c$var$aggregatedDataTimeout = {};
const $2795c9afa9443b8c$export$b78c92c0ba709033 = (observationType, observationEndTime, logAttributes = {})=>(observationData)=>{
        if ((0, $4R6GH.fg)('jsw_refactor_long-tasks_monitoring')) {
            if (!(0, $cJpFl.isExpandedObservationData)(observationData) || !('appName' in observationData)) return;
            const { appName: appName, startTimestamp: startTimestamp, events: events } = observationData;
            const startTime = startTimestamp;
            const endTime = observationEndTime ?? performance.now();
            const duration = endTime - startTime;
            if (duration < 100) return;
            const rawLongTasks = events ?? [];
            const longTasks = rawLongTasks.filter((event)=>event.timestamp >= startTime && event.timestamp + event.duration <= endTime).map((event)=>({
                    timestamp: event.timestamp - startTime,
                    duration: event.duration
                }));
            const minimumBlockedDuration = longTasks.reduce((sum, longTask)=>sum + longTask.duration, 0);
            const frameRateTarget = 60;
            const budgetPerFrame = 1000 / frameRateTarget;
            const timeOverBudget = longTasks.map((event)=>event.duration - budgetPerFrame).reduce((sum, time)=>sum + time, 0);
            const summary = {
                qualityIndex: 1 - timeOverBudget / duration,
                hasLongTasks: longTasks.length > 0,
                hasExtraLongTasks: longTasks.filter((l)=>l.duration >= 100).length > 0,
                longTasks: longTasks,
                rawLongTaskCount: rawLongTasks.length,
                longTaskCount: longTasks.length,
                minimumBlockedDuration: minimumBlockedDuration,
                timeOverBudget: timeOverBudget,
                duration: duration,
                startTime: startTime,
                endTime: endTime
            };
            (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                client.sendEvent({
                    type: (0, $4d5e0871c06cee03$export$12346a674644c156),
                    payload: {
                        source: appName,
                        action: 'longTask',
                        actionSubject: 'ui',
                        actionSubjectId: `${appName}-${observationType}`,
                        attributes: {
                            key: appName,
                            ...summary,
                            ...logAttributes
                        }
                    }
                });
            });
        } else {
            if (!(0, $cJpFl.isExpandedObservationData)(observationData)) return;
            const startTime = observationData.events.map((event)=>event.timestamp);
            const analyticsData = {
                ...(0, $if7bx.generateLongTaskAnalyticsContinuousActionSummary)(observationType, observationData.events),
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime)
            };
            const { appName: appName } = observationData;
            if ($2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`]) $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`].data.push(analyticsData);
            else $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`] = {
                data: [
                    analyticsData
                ],
                extra: observationData.extra,
                timeout: setTimeout(()=>{
                    (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                        const { data: data, extra: extraData } = $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                        client.sendEvent({
                            type: (0, $4d5e0871c06cee03$export$12346a674644c156),
                            payload: {
                                source: appName,
                                action: 'longTask',
                                actionSubject: 'ui',
                                actionSubjectId: `${appName}-${observationType}`,
                                attributes: {
                                    key: appName,
                                    ...(0, $if7bx.getAverageResultsFromContinuousActions)(observationType, data),
                                    ...extraData,
                                    avgScrollTimespan: (0, (/*@__PURE__*/$parcel$interopDefault($gZFbt)))(data, 'measureTimespan'),
                                    ...logAttributes
                                }
                            }
                        });
                        delete $2795c9afa9443b8c$var$aggregatedDataTimeout[`software.${appName}.${observationType}`];
                    });
                }, 7000)
            };
        }
    };

});

parcelRegister("gi25H", function(module, exports) {

$parcel$export(module.exports, "useScrollStateObserver", () => $5c14c3e1741ffda3$export$51374614020e4579);

var $5uXOq = parcelRequire("5uXOq");
const $5c14c3e1741ffda3$var$DEFAULT_SCROLL_STOP_INTERVAL_MS = 500;
const $5c14c3e1741ffda3$export$53d63bb2b7d56f77 = ({ onScrollStart: onScrollStart, onScrollEnd: onScrollEnd, scrollStopIntervalMs: scrollStopIntervalMs })=>{
    const isScrollingRef = (0, $5uXOq.useRef)(false);
    const scrollStopTimerRef = (0, $5uXOq.useRef)(null);
    const onScroll = (0, $5uXOq.useCallback)(()=>{
        if (!isScrollingRef.current) {
            isScrollingRef.current = true;
            onScrollStart();
        }
        const lastScrollTime = performance.now();
        // @ts-expect-error - TS2769 - No overload matches this call.
        clearTimeout(scrollStopTimerRef.current);
        scrollStopTimerRef.current = setTimeout(()=>{
            isScrollingRef.current = false;
            onScrollEnd(lastScrollTime);
        }, scrollStopIntervalMs);
        return ()=>{
            if (isScrollingRef.current) onScrollEnd(lastScrollTime);
            // @ts-expect-error - TS2769 - No overload matches this call.
            clearTimeout(scrollStopTimerRef.current);
        };
    }, [
        isScrollingRef,
        scrollStopTimerRef,
        scrollStopIntervalMs,
        onScrollStart,
        onScrollEnd
    ]);
    return {
        onScroll: onScroll,
        isScrollingRef: isScrollingRef
    };
};
const $5c14c3e1741ffda3$export$51374614020e4579 = ({ scrollStopIntervalMs: scrollStopIntervalMs, scrollElRef: scrollElRef, scrollEl: scrollEl, onScrollStart: onScrollStart, onScrollEnd: onScrollEnd })=>{
    const { onScroll: onScroll, isScrollingRef: isScrollingRef } = $5c14c3e1741ffda3$export$53d63bb2b7d56f77({
        onScrollStart: onScrollStart,
        onScrollEnd: onScrollEnd,
        scrollStopIntervalMs: scrollStopIntervalMs ?? $5c14c3e1741ffda3$var$DEFAULT_SCROLL_STOP_INTERVAL_MS
    });
    (0, $5uXOq.useEffect)(()=>{
        const el = scrollEl ?? scrollElRef?.current;
        if (!el) return undefined;
        el.addEventListener('scroll', onScroll);
        return ()=>{
            el.removeEventListener('scroll', onScroll);
        };
    }, [
        scrollEl,
        scrollElRef,
        isScrollingRef,
        onScroll,
        onScrollEnd
    ]);
};

});


parcelRegister("47POI", function(module, exports) {

$parcel$export(module.exports, "NextBestTaskPanel", () => $edae1958fffec47f$export$f8261b34b83700d1);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $aIZdc = parcelRequire("aIZdc");

var $7CMCs = parcelRequire("7CMCs");

var $kaHBi = parcelRequire("kaHBi");

var $6s1PB = parcelRequire("6s1PB");

var $fZneA = parcelRequire("fZneA");


var $hkiaF = parcelRequire("hkiaF");

var $axmY8 = parcelRequire("axmY8");

var $02beV = parcelRequire("02beV");

var $dF42q = parcelRequire("dF42q");

var $f8CI1 = parcelRequire("f8CI1");

var $aD3zD = parcelRequire("aD3zD");

var $4HjdZ = parcelRequire("4HjdZ");

var $lfTZh = parcelRequire("lfTZh");

var $3YuEU = parcelRequire("3YuEU");

var $ipmBb = parcelRequire("ipmBb");

var $01j5n = parcelRequire("01j5n");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $2YP9W = parcelRequire("2YP9W");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $edae1958fffec47f$export$f2a226a16525c6e0 = ()=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const onStart = (0, $kaHBi.useExperienceStart)({
        experience: (0, $axmY8.NEXT_BEST_TASK_ANALYTICS),
        analyticsSource: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    });
    (0, $5uXOq.useEffect)(()=>{
        onStart();
    }, [
        onStart
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4HjdZ.AsyncNBTPanel), {
        isSimplifiedProject: !isCMPBoard,
        boardId: boardId
    });
};
const $edae1958fffec47f$export$8b530858cadfa678 = ()=>{
    const accountId = (0, $90yGq.useAccountId)();
    if (!accountId) throw new Error('accountId could not be found');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkiaF.UserPropertiesContainer), {
        scope: (0, $axmY8.NEXT_BEST_TASK_USER_PROPERTIES_SCOPE),
        accountId: accountId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edae1958fffec47f$export$f2a226a16525c6e0, null));
};
const $edae1958fffec47f$export$f8261b34b83700d1 = ()=>{
    const { data: data, loading: loading } = (0, $2YP9W.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const isOnlyCurrentUserSelected = (0, $67sX6.useBoardSelector)((0, $5mTgl.isFilterOnCurrentUserOnly)) || false;
    const isOnlyCurrentUserOrUnassignedSelected = (0, $67sX6.useBoardSelector)((0, $5mTgl.isFilterOnCurrentUserOrUnassignedOnly)) || false;
    const cloudId = (0, $koeKL.useCloudId)();
    const { projectAri: projectAri } = (0, $dF42q.useContextAri)();
    const mountedNBTRef = (0, $5uXOq.useRef)(false);
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const [queryRef, loadGitHubOnboardingQuery] = (0, $8Uumt.useQueryLoader)((0, $3YuEU.default));
    const { setQueryGithubOnboardingRef: setQueryGithubOnboardingRef } = (0, $02beV.useNextBestTaskActions)();
    const isOptedIn = !!data?.hasUserOptedIn;
    const isNBTEnabled = !loading && data != null && isOptedIn && isJSWBoard;
    const { isOpen: isOpen } = (0, $f8CI1.useNextBestTaskPanel)();
    if (isNBTEnabled && (0, $6s1PB.expVal)('jira-work-suggestions-unassigned-avatar-exp', 'isEnabled', false) ? isOnlyCurrentUserOrUnassignedSelected : isOnlyCurrentUserSelected) mountedNBTRef.current = true;
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && queryRef != null) setQueryGithubOnboardingRef(queryRef);
    }, [
        queryRef,
        setQueryGithubOnboardingRef,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isNBTEnabled && isOpen && projectAri && queryRef == null) loadGitHubOnboardingQuery({
            cloudId: cloudId,
            projectAri: projectAri
        });
    }, [
        isNBTEnabled,
        loadGitHubOnboardingQuery,
        cloudId,
        isOpen,
        queryRef,
        projectAri
    ]);
    const addAnalyticAttributes = (error)=>({
            isClientFetchError: (0, $fZneA.isClientFetchError)(error) || (0, $01j5n.isClientSideThirdPartyAppError)(error) || (0, $fZneA.isHttpClientErrorResponse)(error)
        });
    return isNBTEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira.insights.next-best-task-panel",
        packageName: (0, $axmY8.PACKAGE_NAME),
        fallback: "flag",
        attributes: addAnalyticAttributes,
        teamName: "nova"
    }, (0, $6s1PB.expVal)('jira-work-suggestions-unassigned-avatar-exp', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD3zD.SafeNBTDataLoaderForOnlyNBTEnabledAvatarSelected), {
        isOnlyNBTEnabledAvatarSelected: isOnlyCurrentUserOrUnassignedSelected
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD3zD.SafeNBTDataLoaderForOnlyCurrentUserSelected), {
        isOnlyCurrentUserSelected: isOnlyCurrentUserSelected
    }), mountedNBTRef.current && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        fallback: null,
        name: "next-best-task-panel"
    }, !(0, $aIZdc.isFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($edae1958fffec47f$export$8b530858cadfa678, null))) : null;
};

});
parcelRegister("hkiaF", function(module, exports) {

$parcel$export(module.exports, "useUserPropertyObject", () => $0a661d6e69ba699f$export$665203e55622a29c);
$parcel$export(module.exports, "UserPropertiesContainer", () => $0a661d6e69ba699f$export$6a3da208e4d7c782);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $hcLTR = parcelRequire("hcLTR");
const $0a661d6e69ba699f$var$initialState = {
    properties: {}
};
const $0a661d6e69ba699f$export$42a9887a08055e31 = (0, $iXqE5.createStore)({
    initialState: $0a661d6e69ba699f$var$initialState,
    actions: $hcLTR.default,
    name: 'InsightsUserPropertiesStore'
});
const $0a661d6e69ba699f$export$8e7336a0b77711a8 = (0, $3sQ5x.createActionsHook)($0a661d6e69ba699f$export$42a9887a08055e31);
const $0a661d6e69ba699f$export$fbe59e5a949d942d = (0, $3sQ5x.createHook)($0a661d6e69ba699f$export$42a9887a08055e31, {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    selector: (state, propertyKey)=>{
        const isLoading = state.properties[propertyKey]?.isLoading;
        const currentValue = state.properties[propertyKey]?.value;
        const error = state.properties[propertyKey]?.error;
        const value = isLoading === false && currentValue !== undefined ? currentValue : null;
        return {
            value: value,
            isLoading: isLoading ?? false,
            error: error ?? null
        };
    }
});
const $0a661d6e69ba699f$export$4599ff36ff959988 = (propertyValue)=>{
    const currentDate = new Date().getTime();
    return Object.fromEntries(Object.entries(propertyValue).filter(([_, value])=>value.expireAt == null || new Date(value.expireAt).getTime() > currentDate));
};
const $0a661d6e69ba699f$var$getExpireAt = (ttl)=>new Date(new Date().getTime() + ttl).toISOString();
const $0a661d6e69ba699f$export$665203e55622a29c = (propertyKey, defaultTtlInMs)=>{
    const [{ value: propertyValue, isLoading: isLoading, error: error }, { saveProperty: saveProperty, loadProperty: loadProperty, savePropertyWithoutSendRequest: savePropertyWithoutSendRequest, sendUpdatePropertyRequest: sendUpdatePropertyRequest }] = $0a661d6e69ba699f$export$fbe59e5a949d942d(propertyKey);
    const debouncedSendUpdatePropertyRequestRef = (0, $5uXOq.useRef)(null);
    const save = (0, $5uXOq.useCallback)((saveKey, savePropertyValue, ttlInMs, options)=>{
        const ttl = ttlInMs || defaultTtlInMs || undefined;
        const newProperty = {
            ...propertyValue,
            [saveKey]: {
                value: savePropertyValue,
                ...ttl ? {
                    expireAt: $0a661d6e69ba699f$var$getExpireAt(ttl)
                } : {}
            }
        };
        const propertyValueNotExpired = $0a661d6e69ba699f$export$4599ff36ff959988(newProperty);
        if (options?.debounceMs) {
            if (debouncedSendUpdatePropertyRequestRef.current) debouncedSendUpdatePropertyRequestRef.current.cancel();
            debouncedSendUpdatePropertyRequestRef.current = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(sendUpdatePropertyRequest, options.debounceMs || 0);
            savePropertyWithoutSendRequest(propertyKey, propertyValueNotExpired);
            debouncedSendUpdatePropertyRequestRef.current(propertyKey, propertyValueNotExpired);
        } else saveProperty(propertyKey, propertyValueNotExpired, options?.isResetOnFailEnabled);
    }, [
        defaultTtlInMs,
        propertyValue,
        sendUpdatePropertyRequest,
        savePropertyWithoutSendRequest,
        propertyKey,
        saveProperty
    ]);
    const load = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>loadProperty.bind(null, propertyKey)(...args), [
        loadProperty,
        propertyKey
    ]);
    if (!isLoading && !error && propertyValue != null) {
        const propertyValueNotExpired = $0a661d6e69ba699f$export$4599ff36ff959988(propertyValue);
        return [
            {
                value: propertyValueNotExpired,
                isLoading: isLoading,
                error: error
            },
            {
                save: save,
                loadProperty: load
            }
        ];
    }
    return [
        {
            value: propertyValue,
            isLoading: isLoading,
            error: error
        },
        {
            save: save,
            loadProperty: load
        }
    ];
};
const $0a661d6e69ba699f$var$handlePropsChange = ()=>({ dispatch: dispatch }, { preloadPropertyKeys: preloadPropertyKeys })=>{
        preloadPropertyKeys?.forEach((propertyKey)=>dispatch((0, $hcLTR.default).loadProperty(propertyKey)));
    };
const $0a661d6e69ba699f$export$6a3da208e4d7c782 = (0, $gg7kZ.createContainer)($0a661d6e69ba699f$export$42a9887a08055e31, {
    onInit: $0a661d6e69ba699f$var$handlePropsChange,
    onUpdate: $0a661d6e69ba699f$var$handlePropsChange
});

});
parcelRegister("hcLTR", function(module, exports) {

$parcel$export(module.exports, "default", () => $360c6a312ca4d0b8$export$2e2bcd8739ae039);

var $307Mb = parcelRequire("307Mb");

var $3VioW = parcelRequire("3VioW");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$360c6a312ca4d0b8$export$2e2bcd8739ae039 = {
    loadProperty: $307Mb.loadProperty,
    saveProperty: $3VioW.saveProperty,
    savePropertyWithoutSendRequest: $3VioW.savePropertyWithoutSendRequest,
    sendUpdatePropertyRequest: $3VioW.sendUpdatePropertyRequest
};

});
parcelRegister("307Mb", function(module, exports) {

$parcel$export(module.exports, "loadProperty", () => $68074ed537d2904c$export$7bfbec0ee20deb4b);

var $89SaW = parcelRequire("89SaW");

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");

const $68074ed537d2904c$export$7bfbec0ee20deb4b = (propertyKey, isRefetch = false)=>async ({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        const property = getState().properties[propertyKey];
        const isLoading = property?.isLoading === true;
        const hasLoadedSuccessfully = property?.isLoading === false && property?.error == null;
        // skip, if already loaded or loading
        if (isLoading || hasLoadedSuccessfully && !isRefetch) return;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    isLoading: true,
                    error: null,
                    value: null
                }
            }
        });
        try {
            const value = await (0, $89SaW.getUserProperty)(accountId, propertyKey);
            setState({
                properties: {
                    ...getState().properties,
                    [propertyKey]: {
                        isLoading: false,
                        error: null,
                        value: value
                    }
                }
            });
        } catch (error) {
            if (error instanceof (0, $jJZqs.default)) {
                setState({
                    properties: {
                        ...getState().properties,
                        [propertyKey]: {
                            isLoading: false,
                            error: error,
                            value: null
                        }
                    }
                });
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to load user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };

});

parcelRegister("3VioW", function(module, exports) {

$parcel$export(module.exports, "saveProperty", () => $5edadaba4936d90d$export$3d751d226e9d1512);
$parcel$export(module.exports, "savePropertyWithoutSendRequest", () => $5edadaba4936d90d$export$588b3a5c6ec210);
$parcel$export(module.exports, "sendUpdatePropertyRequest", () => $5edadaba4936d90d$export$f83f0aadc36cc25f);

var $2YZCu = parcelRequire("2YZCu");

var $jJZqs = parcelRequire("jJZqs");


var $cj007 = parcelRequire("cj007");
const $5edadaba4936d90d$export$3d751d226e9d1512 = (propertyKey, value, isResetOnFailEnabled = true)=>async ({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        const oldValue = getState().properties[propertyKey]?.value;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    value: value,
                    isLoading: false,
                    error: null
                }
            }
        });
        try {
            await (0, $cj007.setUserProperties)(accountId, propertyKey, value);
        } catch (error) {
            if (error instanceof (0, $jJZqs.default)) {
                // rollback optimistic update on setUserProperties failure
                if (isResetOnFailEnabled) setState({
                    properties: {
                        ...getState().properties,
                        [propertyKey]: {
                            value: oldValue,
                            isLoading: false,
                            error: null
                        }
                    }
                });
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to save user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };
const $5edadaba4936d90d$export$588b3a5c6ec210 = (propertyKey, value)=>({ setState: setState, getState: getState }, { accountId: accountId })=>{
        if (!accountId) return;
        setState({
            properties: {
                ...getState().properties,
                [propertyKey]: {
                    value: value,
                    isLoading: false,
                    error: null
                }
            }
        });
    };
const $5edadaba4936d90d$export$f83f0aadc36cc25f = (propertyKey, value)=>async (_, { accountId: accountId })=>{
        if (!accountId) return;
        try {
            await (0, $cj007.setUserProperties)(accountId, propertyKey, value);
        } catch (error) {
            if (error instanceof (0, $jJZqs.default)) {
                if (error.statusCode >= 500 && error.statusCode <= 599) (0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.user-properties-error`, `Failed to save user property with key: ${propertyKey}`, error);
            } else throw error;
        }
    };

});
parcelRegister("cj007", function(module, exports) {

$parcel$export(module.exports, "setUserProperties", () => $a89ffbd38185429d$export$d0e176862bf869b8);

var $89SaW = parcelRequire("89SaW");

var $jJZqs = parcelRequire("jJZqs");
const $a89ffbd38185429d$export$d0e176862bf869b8 = async (accountId, propertyKey, value)=>{
    const res = await (0, $89SaW.setUserProperties)(accountId, propertyKey, JSON.stringify(value) || '');
    if (res.status >= 400 && res.status <= 599) {
        const errResp = await res.text();
        throw new (0, $jJZqs.default)(res.status, errResp);
    }
    return res;
};

});




parcelRegister("dF42q", function(module, exports) {

$parcel$export(module.exports, "useContextAri", () => $acd3615aed58e2d5$export$f461ed30dc3378ed);

var $5uXOq = parcelRequire("5uXOq");

var $j5YhT = parcelRequire("j5YhT");

var $8SUBG = parcelRequire("8SUBG");

var $dAfqg = parcelRequire("dAfqg");

var $fY39E = parcelRequire("fY39E");

var $koeKL = parcelRequire("koeKL");

var $02beV = parcelRequire("02beV");
const $acd3615aed58e2d5$export$f461ed30dc3378ed = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const activationId = (0, $fY39E.useActivationId)();
    const [{ sprints: activeSprints }] = (0, $02beV.useNextBestTaskContainer)();
    const { data: project, loading: loading, error: error } = (0, $dAfqg.useProjectContext)();
    const projectAri = (0, $5uXOq.useMemo)(()=>{
        if (project?.projectId && String(project?.projectId) !== 'undefined' && !loading && !error) return (0, $j5YhT.JiraProjectAri).create({
            siteId: cloudId,
            projectId: String(project?.projectId)
        }).toString();
        return null;
    }, [
        cloudId,
        error,
        loading,
        project?.projectId
    ]);
    const sprintAri = (0, $5uXOq.useMemo)(()=>{
        // Note: for now we only generate sprintAri if there is only one active sprint in the list
        if (activeSprints && activeSprints.length === 1) {
            const sprintId = activeSprints[0].id;
            return (0, $8SUBG.JiraSprintAri).create({
                siteId: cloudId,
                activationId: activationId,
                sprintId: sprintId.toString()
            }).toString();
        }
        return null;
    }, [
        cloudId,
        activationId,
        activeSprints
    ]);
    return {
        sprintAri: sprintAri,
        projectAri: projectAri
    };
};

});
parcelRegister("8SUBG", function(module, exports) {

$parcel$export(module.exports, "JiraSprintAri", () => $677f46c83dcb83ba$export$7b39a2c7a06d5820);

var $dM1kq = parcelRequire("dM1kq");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/sprint/manifest.ts
var $677f46c83dcb83ba$var$jiraSprintAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $dM1kq.JiraSprintAriResourceOwner),
    resourceType: (0, $dM1kq.JiraSprintAriResourceType),
    resourceIdSlug: "activation/{activationId}/{sprintId}",
    resourceIdSegmentFormats: {
        activationId: /[a-zA-Z0-9\-]+/,
        // eslint-disable-line no-useless-escape
        sprintId: /[!a-zA-Z0-9\-_.~@:{}=]+(\/[!a-zA-Z0-9\-_.~@:{}=]+)*/
    }
};
// src/jira/sprint/index.ts
var $677f46c83dcb83ba$export$7b39a2c7a06d5820 = class _JiraSprintAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._activationId = opts.resourceIdSegmentValues.activationId, this._sprintId = opts.resourceIdSegmentValues.sprintId;
    }
    get siteId() {
        return this._siteId;
    }
    get activationId() {
        return this._activationId;
    }
    get sprintId() {
        return this._sprintId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $677f46c83dcb83ba$var$jiraSprintAriStaticOpts.qualifier,
            platformQualifier: $677f46c83dcb83ba$var$jiraSprintAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $677f46c83dcb83ba$var$jiraSprintAriStaticOpts.resourceOwner,
            resourceType: $677f46c83dcb83ba$var$jiraSprintAriStaticOpts.resourceType,
            resourceId: `activation/${opts.activationId}/${opts.sprintId}`,
            resourceIdSegmentValues: {
                activationId: opts.activationId,
                sprintId: opts.sprintId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $677f46c83dcb83ba$var$jiraSprintAriStaticOpts);
        return new _JiraSprintAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $677f46c83dcb83ba$var$jiraSprintAriStaticOpts);
        return new _JiraSprintAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            activationId: this.activationId,
            sprintId: this.sprintId
        };
    }
};

});
parcelRegister("dM1kq", function(module, exports) {

$parcel$export(module.exports, "JiraSprintAriResourceOwner", () => $a070c9dd2f319faf$export$7cac38a1fdf1a8f6);
$parcel$export(module.exports, "JiraSprintAriResourceType", () => $a070c9dd2f319faf$export$d4fabededca793c1);
// src/jira/sprint/types.ts
var $a070c9dd2f319faf$export$7cac38a1fdf1a8f6 = "jira", $a070c9dd2f319faf$export$d4fabededca793c1 = "sprint";

});



parcelRegister("aD3zD", function(module, exports) {

$parcel$export(module.exports, "SafeNBTDataLoaderForOnlyNBTEnabledAvatarSelected", () => $e0198580478994e1$export$4f89be031da57938);
$parcel$export(module.exports, "SafeNBTDataLoaderForOnlyCurrentUserSelected", () => $e0198580478994e1$export$3b59968555fe80f7);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $axmY8 = parcelRequire("axmY8");

var $02beV = parcelRequire("02beV");
const $e0198580478994e1$var$NBTDataLoaderForOnlyCurrentUserSelected = ({ isOnlyCurrentUserSelected: isOnlyCurrentUserSelected })=>{
    const { setIsOnlyCurrentUserSelected: setIsOnlyCurrentUserSelected } = (0, $02beV.useNextBestTaskActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (setIsOnlyCurrentUserSelected != null) setIsOnlyCurrentUserSelected(isOnlyCurrentUserSelected);
    }, [
        isOnlyCurrentUserSelected,
        setIsOnlyCurrentUserSelected
    ]);
    return null;
};
const $e0198580478994e1$var$NBTDataLoaderForOnlyNBTEnabledAvatarSelected = ({ isOnlyNBTEnabledAvatarSelected: isOnlyNBTEnabledAvatarSelected })=>{
    const { setIsOnlyNBTEnabledAvatarSelected: setIsOnlyNBTEnabledAvatarSelected } = (0, $02beV.useNextBestTaskActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (setIsOnlyNBTEnabledAvatarSelected != null) setIsOnlyNBTEnabledAvatarSelected(isOnlyNBTEnabledAvatarSelected);
    }, [
        setIsOnlyNBTEnabledAvatarSelected,
        isOnlyNBTEnabledAvatarSelected
    ]);
    return null;
};
const $e0198580478994e1$export$4f89be031da57938 = ({ isOnlyNBTEnabledAvatarSelected: isOnlyNBTEnabledAvatarSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "filter-data-loader",
        packageName: (0, $axmY8.ERROR_BOUNDARY_PACKAGE),
        fallback: "unmount",
        teamName: "nova"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0198580478994e1$var$NBTDataLoaderForOnlyNBTEnabledAvatarSelected, {
        isOnlyNBTEnabledAvatarSelected: isOnlyNBTEnabledAvatarSelected
    }));
const $e0198580478994e1$export$3b59968555fe80f7 = ({ isOnlyCurrentUserSelected: isOnlyCurrentUserSelected })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "filter-data-loader",
        packageName: (0, $axmY8.ERROR_BOUNDARY_PACKAGE),
        fallback: "unmount",
        teamName: "nova"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e0198580478994e1$var$NBTDataLoaderForOnlyCurrentUserSelected, {
        isOnlyCurrentUserSelected: isOnlyCurrentUserSelected
    }));

});

parcelRegister("4HjdZ", function(module, exports) {

$parcel$export(module.exports, "AsyncNBTPanel", () => $aac7c2e9161bad1a$export$f4c33ceeb2de61e0);

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $lfTZh = parcelRequire("lfTZh");

var $2cyaj = parcelRequire("2cyaj");

var $koeKL = parcelRequire("koeKL");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

var $6s1PB = parcelRequire("6s1PB");

var $dF42q = parcelRequire("dF42q");

var $f8CI1 = parcelRequire("f8CI1");

const $aac7c2e9161bad1a$export$f30b963d245a3fa8 = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("kY5LH")).then(({ TaskPanel: TaskPanel })=>TaskPanel), {
    ssr: false,
    moduleId: "./src/packages/platform/ui/insights/next-best-task/src/ui/panel/index.tsx"
});
const $aac7c2e9161bad1a$export$f4c33ceeb2de61e0 = (props)=>{
    const [queryRef, loadQuery, dispose] = (0, $8Uumt.useQueryLoader)((0, $2cyaj.default));
    const { sprintAri: sprintAri, projectAri: projectAri } = (0, $dF42q.useContextAri)();
    const cloudId = (0, $koeKL.useCloudId)();
    const contextAri = (0, $5uXOq.useMemo)(()=>{
        if (projectAri == null) return null;
        const ari = sprintAri ? {
            sprintAri: sprintAri,
            projectAri: projectAri
        } : {
            projectAri: projectAri
        };
        return ari;
    }, [
        sprintAri,
        projectAri
    ]);
    const errorCallbackRef = (0, $5uXOq.useRef)(null);
    const { isReadyToFetchNBT: isReadyToFetchNBT } = (0, $f8CI1.useNextBestTaskPanel)();
    const hasPanelAnimation = props.isSimplifiedProject;
    const fetchGraphEndpoint = (0, $5uXOq.useCallback)(()=>{
        if (contextAri == null) return;
        loadQuery({
            cloudId: cloudId,
            projectAri: contextAri.projectAri,
            isPrRecentCommentEnabled: (0, $4R6GH.fg)('jira-board-work-suggestions-recent-pr-comments'),
            contextAri: contextAri,
            count: 12,
            cursor: null,
            isIssueDueSoonEnabled: (0, $6s1PB.expVal)('jira-board-work-suggestion-issue-due-soon-exp', 'isEnabled', false)
        }, {
            fetchPolicy: 'network-only'
        });
    }, [
        loadQuery,
        contextAri,
        cloudId
    ]);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (isReadyToFetchNBT) {
            if (errorCallbackRef.current !== null) {
                errorCallbackRef.current();
                errorCallbackRef.current = null;
            }
            fetchGraphEndpoint();
        } else if (!hasPanelAnimation) // We will cleanup the data immediately because we don't need to wait for the animation to finish.
        dispose();
    }, [
        isReadyToFetchNBT,
        fetchGraphEndpoint,
        dispose,
        hasPanelAnimation,
        errorCallbackRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "next-best-task-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-nbt-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aac7c2e9161bad1a$export$f30b963d245a3fa8, {
        ...props,
        queryRef: queryRef,
        fetchGraphEndpoint: fetchGraphEndpoint,
        dispose: dispose,
        errorCallbackRef: errorCallbackRef
    })));
};

});
parcelRegister("2cyaj", function(module, exports) {

$parcel$export(module.exports, "default", () => $c930680b1f6ba133$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<8962a21aa3eece1945533a1010dd7199>>
 * @relayHash c08a73673f7cce695a80b29ecd0e93d1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 0b45a969020533b8c00a24c1589be0d7bc838f5f3f7c46fc0f3d16186de0473c
const $c930680b1f6ba133$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contextAri"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "count"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cursor"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isIssueDueSoonEnabled"
    }, v5 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isPrRecentCommentEnabled"
    }, v6 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectAri"
    }, v7 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v8 = {
        "kind": "Variable",
        "name": "contextAri",
        "variableName": "contextAri"
    }, v9 = [
        {
            "kind": "Variable",
            "name": "after",
            "variableName": "cursor"
        },
        v8 /*: any*/ ,
        {
            "kind": "Variable",
            "name": "first",
            "variableName": "count"
        }
    ], v10 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v11 = {
        "kind": "ScalarField",
        "name": "id"
    }, v12 = {
        "concreteType": "WorkSuggestionsOrderScore",
        "kind": "LinkedField",
        "name": "orderScore",
        "plural": false,
        "selections": [
            {
                "concreteType": "WorkSuggestionsOrderScores",
                "kind": "LinkedField",
                "name": "byTaskType",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "major"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "minor"
                    }
                ]
            }
        ]
    }, v13 = {
        "kind": "ScalarField",
        "name": "title"
    }, v14 = {
        "kind": "ScalarField",
        "name": "issueKey"
    }, v15 = {
        "kind": "ScalarField",
        "name": "issueId"
    }, v16 = {
        "kind": "ScalarField",
        "name": "lastUpdated"
    }, v17 = {
        "kind": "ScalarField",
        "name": "url"
    }, v18 = {
        "kind": "ScalarField",
        "name": "approvalsCount"
    }, v19 = {
        "kind": "ScalarField",
        "name": "commentCount"
    }, v20 = {
        "kind": "ScalarField",
        "name": "repositoryName"
    }, v21 = {
        "kind": "ScalarField",
        "name": "providerName"
    }, v22 = [
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v17 /*: any*/ ,
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        v20 /*: any*/ 
    ], v23 = {
        "kind": "ScalarField",
        "name": "name"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "main_boardWorkSuggestions_Query",
            "selections": [
                {
                    "args": [
                        v7 /*: any*/ ,
                        v8 /*: any*/ ,
                        {
                            "kind": "Variable",
                            "name": "count",
                            "variableName": "count"
                        },
                        {
                            "kind": "Variable",
                            "name": "cursor",
                            "variableName": "cursor"
                        },
                        {
                            "kind": "Variable",
                            "name": "isIssueDueSoonEnabled",
                            "variableName": "isIssueDueSoonEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "isPrRecentCommentEnabled",
                            "variableName": "isPrRecentCommentEnabled"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectAri",
                            "variableName": "projectAri"
                        }
                    ],
                    "kind": "FragmentSpread",
                    "name": "main_insightsNextBestTask_TaskPanelController_dataGql"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v6 /*: any*/ ,
                v1 /*: any*/ ,
                v5 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "main_boardWorkSuggestions_Query",
            "selections": [
                {
                    "concreteType": "WorkSuggestions",
                    "kind": "LinkedField",
                    "name": "workSuggestions",
                    "plural": false,
                    "selections": [
                        {
                            "args": v9 /*: any*/ ,
                            "concreteType": "WorkSuggestionsConnection",
                            "kind": "LinkedField",
                            "name": "workSuggestionsByContextAri",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "WorkSuggestionsEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                {
                                                    "kind": "TypeDiscriminator",
                                                    "abstractKey": "__isWorkSuggestionsCommon"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "numberOfFailedBuilds"
                                                        },
                                                        v16 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsBuildTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "numberOfFailedDeployments"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "environmentType"
                                                        },
                                                        v16 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsDeploymentTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        v18 /*: any*/ ,
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsPullRequestReviewTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v17 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "needsWorkCount"
                                                        },
                                                        v19 /*: any*/ ,
                                                        v20 /*: any*/ ,
                                                        v21 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsPullRequestNeedsWorkTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v15 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "securityContainerName"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "status"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "introducedDate"
                                                        }
                                                    ],
                                                    "type": "WorkSuggestionsCriticalVulnerabilityTask"
                                                },
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        {
                                                            "concreteType": "WorkSuggestionsBlockedIssue",
                                                            "kind": "LinkedField",
                                                            "name": "blockedIssues",
                                                            "plural": true,
                                                            "selections": [
                                                                v14 /*: any*/ ,
                                                                v13 /*: any*/ 
                                                            ]
                                                        },
                                                        v15 /*: any*/ 
                                                    ],
                                                    "type": "WorkSuggestionsBlockingIssueTask"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "cursor"
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "PageInfo",
                                    "kind": "LinkedField",
                                    "name": "pageInfo",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "endCursor"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "hasNextPage"
                                        }
                                    ]
                                }
                            ]
                        },
                        {
                            "args": v9 /*: any*/ ,
                            "filters": [
                                "contextAri"
                            ],
                            "handle": "connection",
                            "key": "panel_workSuggestionsByContextAri",
                            "kind": "LinkedHandle",
                            "name": "workSuggestionsByContextAri"
                        },
                        {
                            "args": [
                                v7 /*: any*/ ,
                                {
                                    "items": [
                                        {
                                            "kind": "Variable",
                                            "name": "projectAris.0",
                                            "variableName": "projectAri"
                                        }
                                    ],
                                    "kind": "ListValue",
                                    "name": "projectAris"
                                },
                                {
                                    "kind": "Literal",
                                    "name": "sprintAutoDiscoveryLimit",
                                    "value": 0
                                }
                            ],
                            "concreteType": "WorkSuggestionsByProjectsResponse",
                            "kind": "LinkedField",
                            "name": "suggestionsByProjects",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "WorkSuggestionsPullRequestDraftTask",
                                    "kind": "LinkedField",
                                    "name": "draftPRSuggestions",
                                    "plural": true,
                                    "selections": v22 /*: any*/ 
                                },
                                {
                                    "concreteType": "WorkSuggestionsPullRequestInactiveTask",
                                    "kind": "LinkedField",
                                    "name": "inactivePRSuggestions",
                                    "plural": true,
                                    "selections": v22 /*: any*/ 
                                },
                                {
                                    "condition": "isIssueDueSoonEnabled",
                                    "kind": "Condition",
                                    "passingValue": true,
                                    "selections": [
                                        {
                                            "concreteType": "WorkSuggestionsIssueDueSoonTask",
                                            "kind": "LinkedField",
                                            "name": "issueDueSoonSuggestions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                {
                                                    "concreteType": "WorkSuggestionsJiraAssignee",
                                                    "kind": "LinkedField",
                                                    "name": "assigneeProfile",
                                                    "plural": false,
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "pictureUrl"
                                                        },
                                                        v23 /*: any*/ 
                                                    ]
                                                },
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "dueDate"
                                                },
                                                {
                                                    "concreteType": "WorkSuggestionsIssueStatus",
                                                    "kind": "LinkedField",
                                                    "name": "status",
                                                    "plural": false,
                                                    "selections": [
                                                        v23 /*: any*/ 
                                                    ]
                                                },
                                                v14 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "WorkSuggestionsPullRequestSuggestionsResponse",
                                    "kind": "LinkedField",
                                    "name": "recentPullRequests",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "WorkSuggestionsPRMergeableTask",
                                            "kind": "LinkedField",
                                            "name": "mergeableSuggestions",
                                            "plural": true,
                                            "selections": [
                                                v10 /*: any*/ ,
                                                v11 /*: any*/ ,
                                                v12 /*: any*/ ,
                                                v13 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                v20 /*: any*/ ,
                                                v21 /*: any*/ 
                                            ]
                                        },
                                        {
                                            "condition": "isPrRecentCommentEnabled",
                                            "kind": "Condition",
                                            "passingValue": true,
                                            "selections": [
                                                {
                                                    "concreteType": "WorkSuggestionsPRCommentsTask",
                                                    "kind": "LinkedField",
                                                    "name": "newCommentsSuggestions",
                                                    "plural": true,
                                                    "selections": v22 /*: any*/ 
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "0b45a969020533b8c00a24c1589be0d7bc838f5f3f7c46fc0f3d16186de0473c",
            "metadata": {},
            "name": "main_boardWorkSuggestions_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c930680b1f6ba133$var$node.hash = "5c5a2c0c5b5ca2389af8606d0572c150";
var $c930680b1f6ba133$export$2e2bcd8739ae039 = $c930680b1f6ba133$var$node;

});

parcelRegister("kY5LH", function(module, exports) {

let $f43de2b6e8c04983$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f43de2b6e8c04983$var$load("fliVL"),
    $f43de2b6e8c04983$var$load("aeKlK")
]).then(()=>parcelRequire('59yQa'));

});


parcelRegister("3YuEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff8fb8e9f134eba5$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<dcb257e1cc9333db271a6c7ab209c1a3>>
 * @relayHash 7b417b148a22cb5f455f01e8c88fdf27
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2358cc71b341e57461e0da2ffe1740e7c5582aae7edf9810cb457628285df47e
const $ff8fb8e9f134eba5$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "projectAri"
        }
    ], v1 = [
        {
            "concreteType": "Insights",
            "kind": "LinkedField",
            "name": "insights",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectAri",
                            "variableName": "projectAri"
                        }
                    ],
                    "concreteType": "InsightsGithubOnboardingDetails",
                    "kind": "LinkedField",
                    "name": "githubOnboardingDetails",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "recommendationVisibility"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "outboundAuthUrl"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "footer_NBTPanelGithubOnboardingDetails_Query",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "footer_NBTPanelGithubOnboardingDetails_Query",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "2358cc71b341e57461e0da2ffe1740e7c5582aae7edf9810cb457628285df47e",
            "metadata": {},
            "name": "footer_NBTPanelGithubOnboardingDetails_Query",
            "operationKind": "query",
            "text": null
        }
    };
}();
$ff8fb8e9f134eba5$var$node.hash = "f769c58fa1d409f05a59bfa11acc5e27";
var $ff8fb8e9f134eba5$export$2e2bcd8739ae039 = $ff8fb8e9f134eba5$var$node;

});


parcelRegister("gM0Co", function(module, exports) {

$parcel$export(module.exports, "UnscheduledWorkPanel", () => $15bfb297b8d29908$export$dbae7400c5347762);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $645AZ = parcelRequire("645AZ");

var $9Ik53 = parcelRequire("9Ik53");

var $cNbZY = parcelRequire("cNbZY");

var $3nIju = parcelRequire("3nIju");

var $a6xVS = parcelRequire("a6xVS");

var $8ydSK = parcelRequire("8ydSK");
const $15bfb297b8d29908$export$dbae7400c5347762 = ()=>{
    const scrollingElementRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $15bfb297b8d29908$var$UnscheduledWorkContainerStyles,
        testId: "software-board.board-panels.unscheduled-work-panel"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3nIju.default), {
        scrollRef: scrollingElementRef,
        isUnscheduledWorkColumnPanel: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9Ik53.ScrollStateContextProvider), {
        scrollRef: scrollingElementRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a6xVS.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($15bfb297b8d29908$var$ScrollInterceptorWrapper, {
        scrollEl: scrollingElementRef.current
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ydSK.default), null)));
};
const $15bfb297b8d29908$var$ScrollInterceptorWrapper = ({ scrollEl: scrollEl })=>{
    (0, $cNbZY.useScrollUpdateHandler)(scrollEl);
    return null;
};
const $15bfb297b8d29908$var$UnscheduledWorkContainerStyles = (0, $8CUq3.xcss)({
    // Calculate inner content width plus padding on each side and scrollbar width
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `calc(${(0, $645AZ.unscheduledColumnWidth)} + ${(0, $645AZ.scrollbarWidth)} + (${"var(--ds-space-050, 4px)"} * 2))`,
    height: '100%',
    overflowY: 'auto',
    overflowX: 'hidden',
    display: 'flex',
    backgroundColor: 'elevation.surface',
    zIndex: 'card',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: 'border.radius.200',
    position: 'relative',
    flexShrink: 0
});

});
parcelRegister("a6xVS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8874e22468986660$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $i28qQ = parcelRequire("i28qQ");

var $lLLkM = parcelRequire("lLLkM");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $4CeiT = parcelRequire("4CeiT");

var $92yNu = parcelRequire("92yNu");

var $4jAPy = parcelRequire("4jAPy");

var $guFRy = parcelRequire("guFRy");

var $iDGXn = parcelRequire("iDGXn");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $aH5JS = parcelRequire("aH5JS");

var $grktj = parcelRequire("grktj");

var $cxtbC = parcelRequire("cxtbC");
const $8874e22468986660$var$SHOW_IPH_ISSUE_LIMIT = 500;
const $8874e22468986660$var$UnscheduledWorkSwimlanesContainer = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const swimlaneIds = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneIdsSelector));
    const swimlaneHeights = (0, $67sX6.useBoardSelector)((0, $5mTgl.swimlaneHeightsSelector));
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const { setShowUnscheduledColumn: setShowUnscheduledColumn } = (0, $iDGXn.useViewSettingsActions)();
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: new Map(),
            getCacheKey: (index)=>swimlaneIds[index]
        }), [
        swimlaneIds
    ]);
    const { rows: rows, totalSize: totalSize, scrollTo: scrollTo } = (0, $guFRy.useVirtual)({
        rowCount: swimlaneIds.length,
        getDefaultRowSize: (index)=>swimlaneHeights[swimlaneIds[index]],
        offsetTop: 0,
        cacheOptions: cacheOptions
    });
    (0, $aH5JS.useAutoScrollSwimlane)(swimlaneIds, scrollTo);
    const renderSwimlanes = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, rows.map(({ index: index, top: top, forceRemeasure: forceRemeasure, measure: measure })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $grktj.default), {
                key: swimlaneIds[index],
                id: swimlaneIds[index],
                index: index,
                top: top,
                measure: measure,
                forceRemeasure: forceRemeasure,
                isLastSwimlane: index === swimlaneIds.length - 1,
                isUnscheduledWorkColumnPanel: true
            })));
    const renderButtonIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($i28qQ))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM))),
            LEGACY_size: "small",
            label: (0, $4R6GH.fg)('jpo_a11y_pb_fixes') ? '' : formatMessage((0, $cxtbC.default).closeColumnLabel),
            color: "var(--ds-icon, #44546F)"
        });
    const closeUnscheduledWork = ()=>setShowUnscheduledColumn(Number(boardId), false);
    const boardScopeFilter = (0, $67sX6.useBoardSelector)((0, $67Z81.getBoardScopeFilter));
    const workIssuesCount = (0, $67sX6.useBoardSelector)((0, $5mTgl.workIssuesCountSelector));
    const showHelpLink = !boardScopeFilter && workIssuesCount > $8874e22468986660$var$SHOW_IPH_ISSUE_LIMIT && (0, $4R6GH.fg)('program_board_misc_improvements');
    const onClickHelpLink = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        }), 'programBoardScopeFilterIph');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8874e22468986660$var$UnscheduledWorkSwimlanesContainerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CeiT.SwimlaneColumnHeaderContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "space-between",
        xcss: $8874e22468986660$var$UnscheduledColumnHeaderContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxtbC.default).columnHeaderIssueTermRefresh : (0, $cxtbC.default).columnHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "software-board.board-container.board.unscheduled-work-swimlanes-container.close-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: renderButtonIcon,
        label: formatMessage((0, $cxtbC.default).closeColumnLabel),
        appearance: "subtle",
        onClick: closeUnscheduledWork
    })))), showHelpLink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8874e22468986660$var$UnscheduledColumnIPHStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
        articleId: (0, $4jAPy.IPH_IDS).PROGRAM_BOARD_RECOMMENDATIONS,
        fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: (0, $4jAPy.DOC_LINKS).PROGRAM_BOARD_RECOMMENDATIONS
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxtbC.default).filterIssuesHelpLinkIssueTermRefresh : (0, $cxtbC.default).filterIssuesHelpLink)),
        appearance: "link",
        spacing: "none",
        onClick: onClickHelpLink
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cxtbC.default).filterIssuesHelpLinkIssueTermRefresh : (0, $cxtbC.default).filterIssuesHelpLink))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92yNu.default), {
        minHeight: totalSize,
        isVirtualised: true,
        hideTickMask: true
    }, renderSwimlanes()));
};
var $8874e22468986660$export$2e2bcd8739ae039 = $8874e22468986660$var$UnscheduledWorkSwimlanesContainer;
const $8874e22468986660$var$UnscheduledWorkSwimlanesContainerWrapperStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    paddingInline: 'space.050'
});
const $8874e22468986660$var$UnscheduledColumnHeaderContentStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingBlock: 'space.200',
    paddingLeft: 'space.150',
    paddingRight: 'space.100',
    backgroundColor: 'elevation.surface'
});
const $8874e22468986660$var$UnscheduledColumnIPHStyles = (0, $8CUq3.xcss)({
    paddingBottom: 'space.150',
    paddingLeft: 'space.150'
});

});
parcelRegister("4CeiT", function(module, exports) {

$parcel$export(module.exports, "default", () => $1be59ae149867274$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SwimlaneColumnHeaderContainer", () => $1be59ae149867274$export$e7cea2f75fe1edbf);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $4R6GH = parcelRequire("4R6GH");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $5B6CN = parcelRequire("5B6CN");

var $g503o = parcelRequire("g503o");

var $43IRS = parcelRequire("43IRS");

var $gn6gY = parcelRequire("gn6gY");
const $1be59ae149867274$var$SwimlaneColumnHeader = (props)=>{
    const { id: id, header: header, isDraggable: isDraggable, appearance: appearance = (0, $3kNE6.ColumnTheme).Default, draggableIndex: draggableIndex, flexibleColumns: flexibleColumns } = props;
    const context = (0, $5uXOq.useContext)((0, $43IRS.TransitionZoneIndicatorContainerContext));
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const transitionZoneIndicatorContainerRef = (0, $5uXOq.useRef)(null);
    const { isSoftwareFullTheming: isSoftwareFullTheming } = // eslint-disable-next-line jira/ff/no-preconditioning -- we are rolling out the fast follows after the experiment has started
    (0, $4R6GH.fg)('jira_theming_milestone_1_fast_follows') && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    (0, $5uXOq.useEffect)(()=>{
        if (context) context.setRef(id, transitionZoneIndicatorContainerRef);
        return ()=>{
            if (context) // remove the ref from the context to prevent memory leak
            context.removeRef(id);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const { dragPreview: dragPreview, closestEdge: closestEdge } = (0, $gn6gY.useDraggableColumn)({
        isDraggable: isDraggable,
        elementRef: wrapperRef,
        columnId: id,
        columnIndex: draggableIndex,
        renderPreview: ()=>header
    });
    const getTheme = (theme)=>{
        if (theme && (0, $g503o.columnThemes)[theme]) return (0, $g503o.columnThemes)[theme];
        return (0, $g503o.columnThemes).default;
    };
    const columnTheme = getTheme(appearance);
    const handleOnMouseDown = ()=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getSelection()?.removeAllRanges();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1be59ae149867274$export$1f99da106a398c44, {
        ref: wrapperRef,
        flexibleColumns: flexibleColumns,
        onMouseDown: handleOnMouseDown
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1be59ae149867274$export$f7a080d02e441007, {
        flexibleColumns: flexibleColumns,
        isThemed: (0, $4R6GH.fg)('dee_7519_fix_column_header_alignment') ? (0, $lmBAt.getIsSoftwareThemingEnabled)() : isSoftwareFullTheming
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
        theme: columnTheme
    }, header && /*#__PURE__*/ (0, $5uXOq.cloneElement)(header, {
        appearance: appearance
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1be59ae149867274$var$TransitionZoneIndicatorContainer, {
        ref: transitionZoneIndicatorContainerRef
    })), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5B6CN.ColumnDropIndicator), {
        edge: closestEdge
    }), dragPreview);
};
var $1be59ae149867274$export$2e2bcd8739ae039 = $1be59ae149867274$var$SwimlaneColumnHeader;
const $1be59ae149867274$export$1f99da106a398c44 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { flexibleColumns: flexibleColumns, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1wug",
            __cmplp.flexibleColumns ? "_1ul91qnl" : "_1ul91t53",
            __cmplp.flexibleColumns ? "_p12f1osq" : "_p12f1t53",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $1be59ae149867274$export$f7a080d02e441007 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, flexibleColumns: flexibleColumns, isDragging: isDragging, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1or8g5z": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values
            __cmplp.isThemed && __cmplp.flexibleColumns ? undefined : "var(--ds-space-050, 4px)"),
            "--_8wvihs": (0, $lD23V.default)(__cmplp.flexibleColumns ? (0, $645AZ.columnMinWidth) : (0, $645AZ.columnFixedWidth), "px"),
            "--_a3w2g5": (0, $lD23V.default)(__cmplp.flexibleColumns ? '100%' : `${0, $645AZ.columnFixedWidth}px`),
            "--_1rh94qy": (0, $lD23V.default)(__cmplp.isDragging ? `0px 3px 3px 0px ${(0, $645AZ.colors).shadow}` : '')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _16jlkb7n _1o9zkb7n _i0dl1wug _18u01rpx _2hwx1rpx _1e0c1txw _2lx21bp4 _1wpz1wug _1ul91uck _p12fsdva _16qs1rk5",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1be59ae149867274$var$TransitionZoneIndicatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pbyqfx8 _154i8ed9 _1ltvidpf _1xi2idpf",
            __cmplp.className
        ])
    });
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
const $1be59ae149867274$export$e7cea2f75fe1edbf = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "gnltj8-0"
})`display:${({ flexibleColumns: flexibleColumns })=>flexibleColumns ? 'grid' : 'flex'};grid-template-columns:${({ flexibleColumns: flexibleColumns })=>{
    if (!flexibleColumns) return 'initial';
    return `repeat(auto-fit,minmax(${0, $645AZ.columnMinWidth}px,1fr))`;
}};grid-auto-flow:column;flex-flow:row nowrap;position:sticky;top:0;z-index:${(0, $645AZ.zIndex).stickyHeaders};width:${({ flexibleColumns: flexibleColumns })=>flexibleColumns ? '100%' : 'auto'};gap:${({ isThemed: isThemed, flexibleColumns: flexibleColumns })=>isThemed && flexibleColumns ? "var(--ds-space-100, 8px)" : undefined};padding:${({ isThemed: isThemed, flexibleColumns: flexibleColumns })=>isThemed && flexibleColumns ? `0 ${"var(--ds-space-050, 4px)"}` : undefined};box-sizing:${({ isThemed: isThemed, flexibleColumns: flexibleColumns })=>isThemed && flexibleColumns ? 'border-box' : undefined};`;

});
parcelRegister("5B6CN", function(module, exports) {

$parcel$export(module.exports, "ColumnDropIndicator", () => $9cca81087fb7633f$export$265e69d63cbbbb15);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $9cca81087fb7633f$export$265e69d63cbbbb15 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iu2gc _1bsbyh40 _1pbyqfx8 _bfhkbku0 _lcxvglyw _t9ecmdz7 _4t3i16ig _rfx31ssb _3l88yh40 _kzdanqa1 _15m613er _1kt9b3bt _1cs8stnw _1auk16fl _qnecj39m _kfgt1y44 _1mp41y44",
            __cmplp.edge === 'left' ? "_1ltvze3t" : "_1ltv1wug",
            __cmplp.edge === 'right' ? "_1xi21i6y" : "_1xi21wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gn6gY", function(module, exports) {

$parcel$export(module.exports, "useDraggableColumn", () => $c5ed4c81aa88a1f1$export$a2d73877a5476992);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7nsd3 = parcelRequire("7nsd3");

var $hGgHi = parcelRequire("hGgHi");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");

var $i8wwL = parcelRequire("i8wwL");

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c5ed4c81aa88a1f1$var$ColumnDragPreviewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isMatrixLayout: isMatrixLayout, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.isMatrixLayout ? "_1bsbq9yo" : "_1bsb1ogy",
            __cmplp.className
        ])
    });
});
const $c5ed4c81aa88a1f1$var$defaultIsCardDroppable = ()=>false;
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c5ed4c81aa88a1f1$var$defaultOnDragLeave = ()=>{};
const $c5ed4c81aa88a1f1$export$a2d73877a5476992 = ({ isDraggable: isDraggable, elementRef: elementRef, columnId: columnId, swimlaneId: swimlaneId, columnIndex: columnIndex, renderPreview: renderPreview, onDragLeave: onDragLeave = $c5ed4c81aa88a1f1$var$defaultOnDragLeave, isCardDroppable: isCardDroppable = $c5ed4c81aa88a1f1$var$defaultIsCardDroppable, isMatrixLayout: isMatrixLayout })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const batchSetDragState = (0, $5uXOq.useCallback)((state)=>autobatch(()=>setDragState(state)), [
        autobatch
    ]);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const batchSetClosestEdge = (0, $5uXOq.useCallback)((edge)=>autobatch(()=>setClosestEdge(edge)), [
        autobatch
    ]);
    const onDragLeaveStable = (0, $7D59a.useEvent)(onDragLeave);
    const isCardDroppableStable = (0, $7D59a.useEvent)(isCardDroppable);
    const { setIsOverColumn: setIsOverColumn } = (0, $i8wwL.useIsCardOverColumn)();
    (0, $5uXOq.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnIndex) || !elementRef.current) return undefined;
        return (0, $4hDdm.combine)(isDraggable ? (0, $7gWdR.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91),
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    columnIndex: columnIndex
                }),
            onDrop: ()=>batchSetDragState({
                    type: 'idle'
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: ()=>({
                            x: 8,
                            y: 8
                        }),
                    render ({ container: container }) {
                        batchSetDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>batchSetDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            }
        }) : // eslint-disable-next-line @typescript-eslint/no-empty-function
        ()=>{}, (0, $7gWdR.dropTargetForElements)({
            element: elementRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>(0, $biEfA.attachClosestEdge)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    type: 'COLUMN',
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    columnIndex: columnIndex
                }, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'left',
                        'right'
                    ]
                }),
            canDrop: ({ source: source })=>{
                const { type: type } = source.data;
                if (type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91)) return true;
                if (type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                return isCardDroppableStable(source.data) ?? false;
                return false;
            },
            onDrag: ({ source: { data: data }, self: self, location: location })=>{
                if (data.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91) && data.columnId !== columnId) batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
                if (data.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) && location.current.dropTargets[0]?.data.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91)) {
                    setIsOverColumn(true);
                    return;
                }
                setIsOverColumn(false);
            },
            onDragEnter: ({ source: { data: data }, self: self })=>{
                if (data.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91) && data.columnId !== columnId) batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragLeave: ({ source: { data: data } })=>{
                batchSetClosestEdge(null);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                onDragLeaveStable(data.type);
                setIsOverColumn(false);
            },
            onDrop: ()=>{
                batchSetClosestEdge(null);
                setIsOverColumn(false);
            }
        }));
    }, [
        batchSetClosestEdge,
        batchSetDragState,
        closestEdge,
        columnId,
        columnIndex,
        elementRef,
        isCardDroppableStable,
        isDraggable,
        onDragLeaveStable,
        swimlaneId,
        setIsOverColumn
    ]);
    return {
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c5ed4c81aa88a1f1$var$ColumnDragPreviewContainer, {
            isMatrixLayout: isMatrixLayout
        }, renderPreview()), dragState.container) : null,
        closestEdge: closestEdge
    };
};

});
parcelRegister("biEfA", function(module, exports) {

$parcel$export(module.exports, "attachClosestEdge", () => $934cfe81468fb31a$export$f0cafff222395e89);
$parcel$export(module.exports, "extractClosestEdge", () => $934cfe81468fb31a$export$945a571f3b658bf);
const $934cfe81468fb31a$var$getDistanceToEdge = {
    top: (rect, client)=>Math.abs(client.y - rect.top),
    right: (rect, client)=>Math.abs(rect.right - client.x),
    bottom: (rect, client)=>Math.abs(rect.bottom - client.y),
    left: (rect, client)=>Math.abs(client.x - rect.left)
};
// using a symbol so we can guarantee a key with a unique value
const $934cfe81468fb31a$var$uniqueKey = Symbol('closestEdge');
function $934cfe81468fb31a$export$f0cafff222395e89(userData, { element: element, input: input, allowedEdges: allowedEdges }) {
    const client = {
        x: input.clientX,
        y: input.clientY
    };
    // I tried caching the result of `getBoundingClientRect()` for a single
    // frame in order to improve performance.
    // However, on measurement I saw no improvement. So no longer caching
    const rect = element.getBoundingClientRect();
    const entries = allowedEdges.map((edge)=>{
        return {
            edge: edge,
            value: $934cfe81468fb31a$var$getDistanceToEdge[edge](rect, client)
        };
    });
    // edge can be `null` when `allowedEdges` is []
    const addClosestEdge = entries.sort((a, b)=>a.value - b.value)[0]?.edge ?? null;
    return {
        ...userData,
        [$934cfe81468fb31a$var$uniqueKey]: addClosestEdge
    };
}
function $934cfe81468fb31a$export$945a571f3b658bf(userData) {
    return userData[$934cfe81468fb31a$var$uniqueKey] ?? null;
}

});

parcelRegister("erBEN", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => (parcelRequire("kpXwZ")).setCustomNativeDragPreview);

var $kpXwZ = parcelRequire("kpXwZ");

});
parcelRegister("kpXwZ", function(module, exports) {

$parcel$export(module.exports, "setCustomNativeDragPreview", () => $39163240d699f88a$export$52d889c66db0f96e);

var $40DDD = parcelRequire("40DDD");

var $6aABs = parcelRequire("6aABs");

/** By default we use the build in values for the native drag preview: {x: 0, y: 0} */ function $39163240d699f88a$var$defaultOffset() {
    return {
        x: 0,
        y: 0
    };
}
function $39163240d699f88a$export$52d889c66db0f96e({ render: render, nativeSetDragImage: nativeSetDragImage, getOffset: getOffset = $39163240d699f88a$var$defaultOffset }) {
    const container = document.createElement('div');
    Object.assign(container.style, {
        // Ensuring we don't cause reflow when adding the element to the page
        // Using `position:fixed` rather than `position:absolute` so we are
        // positioned on the current viewport.
        // `position:fixed` also creates a new stacking context, so we don't need to do that here
        position: 'fixed',
        // According to `mdn`, the element can be offscreen:
        // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/setDragImage#imgelement
        //
        // However, that  information does not appear in the specs:
        // https://html.spec.whatwg.org/multipage/dnd.html#dom-datatransfer-setdragimage-dev
        //
        // If the element is _completely_ offscreen, Safari@17.1 will cancel the drag
        top: 0,
        left: 0,
        // Using maximum possible z-index so that this element will always be on top
        // https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
        // Did not use `layers` in `@atlaskit/theme` because:
        // 1. This element is not a 'layer' in the conventional sense, as this element
        //    is only created for a single frame for the browser to take a photo of it,
        //    and then it is destroyed
        // 2. Did not want to add a dependency onto `@atlaskit/theme`
        // 3. Want to always be on top of product UI which might have higher z-index's
        zIndex: (0, $ff68169bc3de57ec$export$7d0a15ee70427305),
        // Avoiding any additional events caused by the new element (being super safe)
        pointerEvents: 'none'
    });
    document.body.append(container);
    const unmount = render({
        container: container
    });
    /**
	 * Some frameworks (eg `react`) don't render into the container until the next microtask.
	 * - This will run before the browser takes it's picture of the element
	 * - This will run before the animation frame that removes `container`.
	 * */ queueMicrotask(()=>{
        const previewOffset = getOffset({
            container: container
        });
        /**
		 * **Problem**
		 * On `Safari@17.1` if a drag preview element has some opacity,
		 * Safari will include elements behind the drag preview element
		 * in the drag preview.
		 * Bug: https://bugs.webkit.org/show_bug.cgi?id=266025
		 *
		 * **Fix**
		 * We push the drag preview so it is _almost_ completely offscreen so that
		 * there won't be any elements behind the drag preview element.
		 * If the element is _completely_ offscreen, then the drag is cancelled by Safari.
		 *
		 * Using `-0.0001` so that any potential "see through" on the drag preview element
		 * is effectively invisible 👻
		 *
		 * **Unsuccessful alternatives**
		 * Setting a background color (eg "white") on the `container`
		 * → Wrecks the opacity of the drag preview element
		 *
		 * Adding a parent element of the `container` with a background color (eg "white")
		 * → Wrecks the opacity of the drag preview element
		 */ if ((0, $6aABs.isSafari)()) {
            const rect = container.getBoundingClientRect();
            // We cannot apply this fix if nothing has been rendered into the `container`
            if (rect.width === 0) return;
            container.style.left = `-${rect.width - 0.0001}px`;
        }
        nativeSetDragImage?.(container, previewOffset.x, previewOffset.y);
    });
    function cleanup() {
        unbindMonitor();
        unmount?.();
        document.body.removeChild(container);
    }
    const unbindMonitor = (0, $40DDD.monitorForElements)({
        // Remove portal in the dragstart event so that the user will never see it
        onDragStart: cleanup,
        // Backup: remove portal when the drop finishes (this would be an error case)
        onDrop: cleanup
    });
}

});
// Maximum possible z-index
// https://stackoverflow.com/questions/491052/minimum-and-maximum-value-of-z-index
const $ff68169bc3de57ec$export$7d0a15ee70427305 = 2147483647;



parcelRegister("1fZVH", function(module, exports) {

$parcel$export(module.exports, "autobatch", () => $befa27b0681ab6bc$export$46f5568dd7916109);
$parcel$export(module.exports, "useAutobatch", () => $befa27b0681ab6bc$export$5b8ae94abd7adcf);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $4R6GH = parcelRequire("4R6GH");
const $befa27b0681ab6bc$var$queue = new Set();
let $befa27b0681ab6bc$var$hasQueuedFlush = false;
function $befa27b0681ab6bc$var$flush() {
    const tasks = Array.from($befa27b0681ab6bc$var$queue);
    $befa27b0681ab6bc$var$queue.clear();
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        tasks.forEach((task)=>{
            task();
        });
    });
}
function $befa27b0681ab6bc$export$46f5568dd7916109(task) {
    $befa27b0681ab6bc$var$queue.add(task);
    if (!$befa27b0681ab6bc$var$hasQueuedFlush) {
        $befa27b0681ab6bc$var$hasQueuedFlush = true;
        queueMicrotask(()=>{
            $befa27b0681ab6bc$var$hasQueuedFlush = false;
            $befa27b0681ab6bc$var$flush();
        });
    }
    return ()=>{
        $befa27b0681ab6bc$var$queue.delete(task);
    };
}
function $befa27b0681ab6bc$export$5b8ae94abd7adcf() {
    if (!(0, $4R6GH.fg)('jsw_backlog_pragmatic_dnd_automatic_batching')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $5uXOq.useCallback)((task)=>task(), []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const cancelFunctions = (0, $5uXOq.useRef)([]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const batchingFunction = (0, $5uXOq.useCallback)((task)=>{
        const cancel = $befa27b0681ab6bc$export$46f5568dd7916109(task);
        cancelFunctions.current.push(cancel);
    }, []);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>()=>{
            cancelFunctions.current.forEach((cancel)=>{
                cancel();
            });
        }, []);
    return batchingFunction;
}

});

parcelRegister("i8wwL", function(module, exports) {

$parcel$export(module.exports, "useIsCardOverColumn", () => $a176ed67c26fc146$export$4fc42d4fdca2b55c);
$parcel$export(module.exports, "ColumnEdgeContextProvider", () => $a176ed67c26fc146$export$582bb25f0ee3befd);

var $5uXOq = parcelRequire("5uXOq");

var $1fZVH = parcelRequire("1fZVH");
const $a176ed67c26fc146$var$ColumnEdgeContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOverColumn: false,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setIsOverColumn: ()=>{}
});
const $a176ed67c26fc146$export$4fc42d4fdca2b55c = ()=>(0, $5uXOq.useContext)($a176ed67c26fc146$var$ColumnEdgeContext);
const $a176ed67c26fc146$export$582bb25f0ee3befd = ({ children: children })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [isOverColumn, setIsOverColumn] = (0, $5uXOq.useState)(false);
    const batchSetIsOverColumn = (0, $5uXOq.useCallback)((edge)=>autobatch(()=>setIsOverColumn(edge)), [
        autobatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a176ed67c26fc146$var$ColumnEdgeContext.Provider, {
        value: {
            isOverColumn: isOverColumn,
            setIsOverColumn: batchSetIsOverColumn
        }
    }, children);
};

});

const $25c2ea87c2b04bf9$export$b05303cbde3e8c8c = 'CARD';
const $25c2ea87c2b04bf9$export$57d0ef745f304b91 = 'COLUMN';
const $25c2ea87c2b04bf9$export$2927f4d423091b16 = 'TRANSITION_ZONE';



parcelRegister("92yNu", function(module, exports) {

$parcel$export(module.exports, "default", () => $66f2ba16fe3bc973$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $a2e2Q = parcelRequire("a2e2Q");

var $cSD7y = parcelRequire("cSD7y");
function $66f2ba16fe3bc973$export$2e2bcd8739ae039({ flexibleColumns: flexibleColumns, minHeight: minHeight, isVirtualised: isVirtualised, hideTickMask: hideTickMask, children: // Hide tick mask when the swimlane header is not rendered
children }) {
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66f2ba16fe3bc973$var$Wrapper, {
        flexibleColumns: flexibleColumns,
        isVirtualised: isVirtualised,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: isVirtualised && minHeight ? {
            minHeight: minHeight
        } : {}
    }, !hideTickMask && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66f2ba16fe3bc973$var$SwimlaneTickMask, {
        isThemed: isSoftwareFullTheming
    }), children);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66f2ba16fe3bc973$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVirtualised: isVirtualised, flexibleColumns: flexibleColumns, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_m6k41e03",
            __cmplp.isVirtualised ? "_1e0c1ule" : "_1e0c1bgi",
            __cmplp.isVirtualised ? "_kqswh2mm" : "_kqswpfqs",
            __cmplp.flexibleColumns ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});
const $66f2ba16fe3bc973$var$SwimlaneTickMaskOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _154iidpf _19pk1uiu _4t3ickbl _1pby11wp _18u0idpf",
            !__cmplp.isThemed && "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $66f2ba16fe3bc973$var$swimlaneTickmaskStyle = {
    default: "_kqsw1if8 _154iidpf _19pkdzxt _4t3ioahv _1pby11wp _18u0idpf",
    notThemed: "_bfhkvuon"
};
const $66f2ba16fe3bc973$var$SwimlaneTickMask = (0, $cSD7y.componentWithFG)('tanuki_padding_margin_use_token', ({ isThemed: isThemed, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $66f2ba16fe3bc973$var$swimlaneTickmaskStyle.default,
            !isThemed && $66f2ba16fe3bc973$var$swimlaneTickmaskStyle.notThemed
        ])
    }, children);
}, $66f2ba16fe3bc973$var$SwimlaneTickMaskOld);

});

parcelRegister("guFRy", function(module, exports) {

$parcel$export(module.exports, "useVirtual", () => $8a37cce55cc85701$export$ebc1863da693699a);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $itWjr = parcelRequire("itWjr");

var $9Ik53 = parcelRequire("9Ik53");

var $2PIRw = parcelRequire("2PIRw");
const $8a37cce55cc85701$export$c61d420d8ad72523 = (rowCount, offsetTop, getDefaultRowSize, cacheOptions)=>{
    const states = new Array(rowCount);
    let currentTop = offsetTop;
    for(let i = 0; i < rowCount; i += 1){
        const height = cacheOptions?.cache.get(cacheOptions.getCacheKey(i))?.height ?? getDefaultRowSize(i);
        const result = {
            height: height,
            top: currentTop,
            bottom: currentTop + height
        };
        currentTop = result.bottom;
        states[i] = result;
    }
    return states;
};
const $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT = 0.05;
function $8a37cce55cc85701$export$fd7df3dcf242e12a({ cacheOptions: cacheOptions, index: index, rowStates: rowStates, setRowHeight: setRowHeight, isVisible: isVisible }) {
    const forceRemeasure = (el, withCache = false)=>{
        if (!el) return;
        if (withCache && cacheOptions?.cache?.has(cacheOptions.getCacheKey(index))) return;
        const { height: height } = el.getBoundingClientRect();
        const roundedHeight = Math.round(height * 100) / 100;
        // TODO: React DnD will set row height to 0 on pick-up, that update must be ignored.
        // This is not a clean solution.
        if (roundedHeight > $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT && cacheOptions) {
            const cacheKey = cacheOptions.getCacheKey(index);
            if (cacheKey !== undefined) cacheOptions.cache.set(cacheKey, {
                height: height
            });
        }
        if (height != null && height > $8a37cce55cc85701$var$MINIMUM_CARD_HEIGHT && rowStates[index].height !== height) setRowHeight(index, height);
    };
    return {
        key: index,
        index: index,
        top: rowStates[index].top,
        isVisible: isVisible,
        measure (el) {
            forceRemeasure(el, true);
        },
        forceRemeasure: forceRemeasure
    };
}
const $8a37cce55cc85701$var$EMPTY_ROW_DESCRIPTOR = [];
function $8a37cce55cc85701$export$824e0ab10a990d7b({ start: start, end: end, rowStates: rowStates, cacheOptions: cacheOptions, setRowHeight: setRowHeight, startVisible: startVisible, endVisible: endVisible }) {
    if (start === end) return $8a37cce55cc85701$var$EMPTY_ROW_DESCRIPTOR;
    const numRows = end - start;
    // This code is structured in a way that allows it to be changed into stable indexes and support element recycling.
    const result = new Array(Math.max(numRows, 0));
    for(let offset = 0; offset < numRows; offset += 1){
        const index = start + offset;
        const isVisible = index >= startVisible && index <= endVisible;
        result[offset] = $8a37cce55cc85701$export$fd7df3dcf242e12a({
            cacheOptions: cacheOptions,
            index: index,
            rowStates: rowStates,
            setRowHeight: setRowHeight,
            isVisible: isVisible
        });
    }
    return result;
}
function $8a37cce55cc85701$var$useRows(scrollState, rowStates, // eslint-disable-next-line @typescript-eslint/no-invalid-void-type
cacheOptions, setRowHeight, overscanHeight) {
    const { start: start, end: end } = (0, $5uXOq.useMemo)(()=>(0, $itWjr.getRenderedRange)(scrollState, rowStates, overscanHeight), [
        scrollState,
        rowStates,
        overscanHeight
    ]);
    const { start: startVisible, end: endVisible } = (0, $5uXOq.useMemo)(()=>(0, $itWjr.getRenderedRange)(scrollState, rowStates, 0), [
        scrollState,
        rowStates
    ]);
    return (0, $5uXOq.useMemo)(()=>$8a37cce55cc85701$export$824e0ab10a990d7b({
            start: start,
            end: end,
            rowStates: rowStates,
            cacheOptions: cacheOptions,
            setRowHeight: setRowHeight,
            startVisible: startVisible,
            endVisible: endVisible
        }), [
        start,
        end,
        rowStates,
        cacheOptions,
        setRowHeight,
        startVisible,
        endVisible
    ]);
}
function $8a37cce55cc85701$export$ebc1863da693699a({ rowCount: rowCount, getDefaultRowSize: getDefaultRowSize, offsetTop: offsetTop = 0, overscanHeight: overscanHeight = 0, cacheOptions: cacheOptions, version: version }) {
    const scrollState = (0, $9Ik53.useScrollState)();
    const [rowStates, setRowStates] = (0, $5uXOq.useState)(()=>$8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitialize = ()=>setRowStates($8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions));
    const reinitializeRef = (0, $5uXOq.useRef)(reinitialize);
    reinitializeRef.current = reinitialize;
    const reinitializeCb = (0, $5uXOq.useCallback)(()=>reinitializeRef.current(), []);
    const lastOffsetTop = (0, $5uXOq.useRef)(null);
    const lastVersion = (0, $5uXOq.useRef)(null);
    /**
	 * checking rowCount, offsetTop and version to rebuild the rowStates
	 * if the version is undefined, null or empty string, it will not be used
	 */ const shouldRebuildRowStates = rowCount !== rowStates.length || offsetTop !== lastOffsetTop.current || !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(version) && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(version) && version !== lastVersion.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (shouldRebuildRowStates) {
            lastVersion.current = version;
            lastOffsetTop.current = offsetTop;
            const states = $8a37cce55cc85701$export$c61d420d8ad72523(rowCount, offsetTop, getDefaultRowSize, cacheOptions);
            setRowStates(states);
        }
    }, [
        rowStates,
        rowCount,
        offsetTop,
        cacheOptions,
        getDefaultRowSize,
        shouldRebuildRowStates,
        version
    ]);
    const scrollTo = (0, $2PIRw.useScrollTo)(rowStates);
    const setRowHeight = (0, $5uXOq.useCallback)((row, height)=>{
        setRowStates((currentRowStates)=>{
            let currentTop = offsetTop;
            return currentRowStates.map((state, index)=>{
                const newState = {
                    ...state
                };
                if (index === row) newState.height = height;
                newState.top = currentTop;
                newState.bottom = currentTop + newState.height;
                currentTop = newState.bottom;
                return newState;
            });
        });
    }, [
        offsetTop
    ]);
    const totalSize = (0, $5uXOq.useMemo)(()=>{
        let sum = 0;
        rowStates.forEach(({ height: height })=>{
            sum += height; // This is a float
        });
        // We don't want to end up with a totalSize that is floating point. It results in the
        // ResizeObserver in useElementOffset triggering for pixel changes below 1px
        return Math.ceil(sum);
    }, [
        rowStates
    ]);
    const rows = $8a37cce55cc85701$var$useRows(scrollState, rowStates, cacheOptions, setRowHeight, overscanHeight);
    return (0, $5uXOq.useMemo)(()=>({
            rows: rows,
            rowStates: rowStates,
            scrollTo: scrollTo,
            totalSize: totalSize,
            isScrolling: scrollState.isScrolling,
            reinitialize: reinitializeCb
        }), [
        rows,
        rowStates,
        scrollTo,
        totalSize,
        scrollState.isScrolling,
        reinitializeCb
    ]);
}

});
parcelRegister("itWjr", function(module, exports) {

$parcel$export(module.exports, "getRenderedRange", () => $cbe28e6cb7ea4dcb$export$303e1fc2567e8469);
/**
 * Binary search for the nearest value to a `needle`, given high and low indexes
 * and a `getValue` function to get the value at a certain index.
 */ const $cbe28e6cb7ea4dcb$export$b961f15adda64c7b = (lowIndexDontRead, highIndexDontRead, getValue, needle)=>{
    // JFE linting doesn't allow changing the arg as a local.
    let low = lowIndexDontRead;
    let high = highIndexDontRead;
    while(low < high){
        const middleIndex = Math.floor((high + low) / 2);
        const candidate = getValue(middleIndex);
        if (candidate > needle) high = middleIndex - 1;
        else if (candidate < needle) low = middleIndex + 1;
        else return middleIndex;
    }
    return low;
};
const $cbe28e6cb7ea4dcb$export$303e1fc2567e8469 = (viewportRectangle, rowPositions, overscanHeight)=>{
    if (rowPositions.length === 0) return {
        start: 0,
        end: 0
    };
    // Render elements starting at the top edge of the scroll container, minus
    // some overscan height.
    const startPositionTop = viewportRectangle.scrollTop - overscanHeight;
    // And up to elements at the bottom edge of the scroll container, plus some
    // overscan height.
    // NOTE: This needs to default to 0 otherwise it is NaN which means that isAbove is true.
    const endPositionTop = (viewportRectangle?.scrollTop ?? 0) + (viewportRectangle?.height ?? 0) + overscanHeight;
    // If the viewport fully above or under the rows, render nothing
    const isAbove = endPositionTop < rowPositions[0].top;
    const isUnder = startPositionTop > rowPositions[rowPositions.length - 1].bottom;
    if (isAbove || isUnder) return {
        start: 0,
        end: 0
    };
    const startIndex = $cbe28e6cb7ea4dcb$export$b961f15adda64c7b(0, rowPositions.length, (i)=>rowPositions[i].bottom, startPositionTop);
    let endIndex = startIndex;
    while(endIndex < rowPositions.length && rowPositions[endIndex].top <= endPositionTop)endIndex += 1;
    return {
        start: startIndex,
        end: endIndex
    };
};

});

parcelRegister("2PIRw", function(module, exports) {

$parcel$export(module.exports, "useScrollTo", () => $6575a25f747838db$export$d774db9fe736aa73);

var $5uXOq = parcelRequire("5uXOq");

var $9Ik53 = parcelRequire("9Ik53");

var $kTgNN = parcelRequire("kTgNN");
const $6575a25f747838db$export$e1700fccdc2280c5 = 80;
const $6575a25f747838db$var$SCROLLING_INTERVAL = 50;
const $6575a25f747838db$var$SCROLLING_ATTEMPT = 5;
const $6575a25f747838db$export$d774db9fe736aa73 = (rowStates)=>{
    // scrollState CONSTANTLY changes
    // Just grabbing out the scrollElement will hardly change
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    // We do NOT want to regenerate the return function everytime so we should use REFs
    // here instead
    const scrollElementRef = (0, $5uXOq.useRef)(null);
    const rowStatesRef = (0, $5uXOq.useRef)([]);
    (0, $5uXOq.useEffect)(()=>{
        // Only bind to the scrollElementRef once. We don't need it anymore once we have it
        if (scrollElementRef.current === null && scrollElement) scrollElementRef.current = scrollElement;
        // Always ensure our rowStates ref is up to date
        rowStatesRef.current = rowStates ?? rowStatesRef.current;
    }, [
        rowStates,
        scrollElement
    ]);
    const scrollTo = (0, $5uXOq.useCallback)((index, options, attempt = 1)=>{
        let timeoutId = null;
        // Early termination for invalid data
        if (index === -1 || attempt > $6575a25f747838db$var$SCROLLING_ATTEMPT) {
            options?.onComplete?.();
            return;
        }
        if (rowStatesRef?.current == null || // Can be null on first pass
        scrollElementRef?.current == null || // Can be null on first pass
        index >= rowStatesRef.current.length) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            timeoutId = window.setTimeout(()=>{
                scrollTo(index, options, attempt + 1);
            }, $6575a25f747838db$var$SCROLLING_INTERVAL);
            return ()=>{
                timeoutId && clearTimeout(timeoutId);
            };
        }
        const scrollElementEl = scrollElementRef.current;
        const rowState = rowStatesRef.current;
        // Complete scrolling when the target is on screen.
        if ((0, $kTgNN.hasScrolledIntoView)(scrollElementRef.current, rowStatesRef.current[index])) {
            options?.onComplete?.();
            return;
        }
        const scrollToPosition = (0, $kTgNN.getScrollToPosition)(scrollElementEl, rowState[index], options);
        if (options?.immediate) scrollElementEl.scrollTop = scrollToPosition;
        else scrollElementEl.scrollTo({
            top: scrollToPosition,
            behavior: 'smooth'
        });
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        timeoutId = window.setTimeout(()=>scrollTo(index, options, attempt + 1), $6575a25f747838db$var$SCROLLING_INTERVAL);
        return ()=>{
            timeoutId && clearTimeout(timeoutId);
        };
    }, [
        scrollElementRef,
        rowStatesRef
    ]);
    return scrollTo;
};

});
parcelRegister("kTgNN", function(module, exports) {

$parcel$export(module.exports, "hasScrolledIntoView", () => $abb1a9602db1b1f8$export$6ced3bc78dcece56);
$parcel$export(module.exports, "getScrollToPosition", () => $abb1a9602db1b1f8$export$dfe56cb366876f29);
const $abb1a9602db1b1f8$var$VIEWPORT_BUFFER = 50;
const $abb1a9602db1b1f8$export$6ced3bc78dcece56 = (scrollElementEl, rowState)=>{
    if (!scrollElementEl || !rowState) return false;
    const topOfRow = rowState.top;
    const bottomOfRow = rowState.top + rowState.height;
    // Make the viewport a bit smaller so the card won't stick to the edge of the screen
    const topOfView = scrollElementEl.scrollTop + $abb1a9602db1b1f8$var$VIEWPORT_BUFFER;
    const bottomOfView = scrollElementEl.scrollTop + scrollElementEl.clientHeight - $abb1a9602db1b1f8$var$VIEWPORT_BUFFER;
    return topOfRow > topOfView && topOfRow < bottomOfView || bottomOfRow > topOfView && bottomOfRow < bottomOfView || topOfRow < topOfView && bottomOfRow > bottomOfView;
};
const $abb1a9602db1b1f8$export$dfe56cb366876f29 = (scrollElementEl, rowState, options)=>{
    if (!scrollElementEl || !rowState) return 0;
    if (options?.hasVirtualisedChildren) return rowState.top - scrollElementEl.clientHeight;
    return rowState.top + rowState.height / 2 - scrollElementEl.clientHeight / 3;
};

});



parcelRegister("iDGXn", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsContainer", () => $ca78323127435ce7$export$920204d7413f6fe1);
$parcel$export(module.exports, "useViewSettings", () => $ca78323127435ce7$export$704cffd05c51e2b6);
$parcel$export(module.exports, "useViewSettingsActions", () => $ca78323127435ce7$export$d6a70239aff099b8);
$parcel$export(module.exports, "useIsFullscreen", () => $ca78323127435ce7$export$d397eccea5f37b0a);
$parcel$export(module.exports, "useShowVersionPanel", () => $ca78323127435ce7$export$459b400687bc0f20);
$parcel$export(module.exports, "useShowEpicPanel", () => $ca78323127435ce7$export$203c9a05aebea04a);
$parcel$export(module.exports, "useShowQuickFilters", () => $ca78323127435ce7$export$714ba21e90859f45);
$parcel$export(module.exports, "useShowCompactMode", () => $ca78323127435ce7$export$8a591bb42a805814);
$parcel$export(module.exports, "useShowPanels", () => $ca78323127435ce7$export$736bfa164a60e240);
$parcel$export(module.exports, "useShowEpics", () => $ca78323127435ce7$export$ecaca052f9755b4e);
$parcel$export(module.exports, "useShowVersions", () => $ca78323127435ce7$export$10178a1fc177e27a);
$parcel$export(module.exports, "useShowStatuses", () => $ca78323127435ce7$export$7a14d92e68e42de1);
$parcel$export(module.exports, "useShowUnscheduledColumn", () => $ca78323127435ce7$export$afb23457b0007ce7);
$parcel$export(module.exports, "useShowIssueLinksStats", () => $ca78323127435ce7$export$1d584d816be8e0fd);
$parcel$export(module.exports, "useShowAssignee", () => $ca78323127435ce7$export$be6bf1e24771efde);
$parcel$export(module.exports, "useShowCardCovers", () => $ca78323127435ce7$export$77ff271d002b6f7e);
$parcel$export(module.exports, "useShowBoardName", () => $ca78323127435ce7$export$59b3ccd51053cf7e);
$parcel$export(module.exports, "useHasCardExtraFields", () => $ca78323127435ce7$export$9e1ece2ef34a030);
$parcel$export(module.exports, "useCardFieldsSettings", () => $ca78323127435ce7$export$e41d531469117029);
$parcel$export(module.exports, "useShowOfftrackDependencyLines", () => $ca78323127435ce7$export$e709b26074f3a4a5);
$parcel$export(module.exports, "useIssueIdsToShowDependencies", () => $ca78323127435ce7$export$b6fb171038a9e77e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $duOMW = parcelRequire("duOMW");

var $6zihU = parcelRequire("6zihU");

var $ffHmx = parcelRequire("ffHmx");
const $ca78323127435ce7$var$Store = (0, $iXqE5.createStore)({
    name: 'ViewSettings',
    initialState: $duOMW.initialState,
    actions: $6zihU.actions
});
const $ca78323127435ce7$export$920204d7413f6fe1 = (0, $gg7kZ.createContainer)($ca78323127435ce7$var$Store, {
    onInit: (0, $6zihU.actions).initState
});
const $ca78323127435ce7$export$704cffd05c51e2b6 = (0, $3sQ5x.createHook)($ca78323127435ce7$var$Store);
const $ca78323127435ce7$export$d6a70239aff099b8 = (0, $3sQ5x.createActionsHook)($ca78323127435ce7$var$Store);
const $ca78323127435ce7$export$d397eccea5f37b0a = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getIsFullscreen)
});
const $ca78323127435ce7$export$459b400687bc0f20 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowVersionPanel)
});
const $ca78323127435ce7$export$203c9a05aebea04a = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEpicPanel)
});
const $ca78323127435ce7$export$714ba21e90859f45 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowQuickFilters)
});
const $ca78323127435ce7$export$8a591bb42a805814 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCompactMode)
});
const $ca78323127435ce7$export$736bfa164a60e240 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowPanels)
});
const $ca78323127435ce7$export$ecaca052f9755b4e = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEpics)
});
const $ca78323127435ce7$export$10178a1fc177e27a = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowVersions)
});
const $ca78323127435ce7$export$7a14d92e68e42de1 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowStatuses)
});
const $ca78323127435ce7$export$afb23457b0007ce7 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowUnscheduledColumn)
});
const $ca78323127435ce7$export$1d584d816be8e0fd = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueLinksStats)
});
const $ca78323127435ce7$export$c94c02788702c7e4 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueType)
});
const $ca78323127435ce7$export$8007ae8b25a75629 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowIssueKey)
});
const $ca78323127435ce7$export$75223d65852dc3c0 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowPriority)
});
const $ca78323127435ce7$export$eac20fb60c7f35ac = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowDevelopment)
});
const $ca78323127435ce7$export$be6bf1e24771efde = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowAssignee)
});
const $ca78323127435ce7$export$b5a76590347456cc = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowEstimate)
});
const $ca78323127435ce7$export$5e8e69c97a3cd45b = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCardExtraField)
});
const $ca78323127435ce7$export$a53839ab3a916ce3 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowDaysInColumn)
});
const $ca78323127435ce7$export$77ff271d002b6f7e = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowCardCovers)
});
const $ca78323127435ce7$export$59b3ccd51053cf7e = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowBoardName)
});
const $ca78323127435ce7$export$9e1ece2ef34a030 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getHasCardExtraFields)
});
const $ca78323127435ce7$export$e41d531469117029 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getCardFieldsSettings)
});
const $ca78323127435ce7$export$e709b26074f3a4a5 = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getShowOfftrackDependencyLines)
});
const $ca78323127435ce7$export$b6fb171038a9e77e = (0, $3sQ5x.createStateHook)($ca78323127435ce7$var$Store, {
    selector: (0, $ffHmx.getIssueIdsToShowDependencies)
});

});
parcelRegister("6zihU", function(module, exports) {

$parcel$export(module.exports, "actions", () => $718ecccac1489fb2$export$e324594224ef24da);

var $3whhk = parcelRequire("3whhk");
const $718ecccac1489fb2$export$e324594224ef24da = {
    setViewSettings: $3whhk.setViewSettings,
    setIsFullscreen: $3whhk.setIsFullscreen,
    setViewSettingsPanels: $3whhk.setViewSettingsPanels,
    setViewSettingsQuickFilters: $3whhk.setViewSettingsQuickFilters,
    setViewSettingsCardDetails: $3whhk.setViewSettingsCardDetails,
    setViewSettingsCardExtraFields: $3whhk.setViewSettingsCardExtraFields,
    setViewSettingsCompactMode: $3whhk.setViewSettingsCompactMode,
    setShowUnscheduledColumn: $3whhk.setShowUnscheduledColumn,
    setShowOfftrackDependencyLines: $3whhk.setShowOfftrackDependencyLines,
    setIssueIdsToShowDependencies: $3whhk.setIssueIdsToShowDependencies,
    setViewSettingsShowCardCovers: $3whhk.setViewSettingsShowCardCovers,
    toggleViewSetting: $3whhk.toggleViewSetting,
    toggleShowEpics: $3whhk.toggleShowEpics,
    toggleShowVersions: $3whhk.toggleShowVersions,
    toggleShowStatuses: $3whhk.toggleShowStatuses,
    toggleShowLinkedIssuesStats: $3whhk.toggleShowLinkedIssuesStats,
    toggleExtraField: $3whhk.toggleExtraField,
    toggleShowDaysInColumn: $3whhk.toggleShowDaysInColumn,
    toggleShowDueDate: $3whhk.toggleShowDueDate,
    toggleShowLabels: $3whhk.toggleShowLabels,
    initState: $3whhk.initState
};

});
parcelRegister("3whhk", function(module, exports) {

$parcel$export(module.exports, "initState", () => $b6bf5ef387c9e297$export$f6196a6c6bb539b4);
$parcel$export(module.exports, "setViewSettings", () => $b6bf5ef387c9e297$export$99f2d9eb0b41b93);
$parcel$export(module.exports, "setIsFullscreen", () => $b6bf5ef387c9e297$export$9c73b2f282069160);
$parcel$export(module.exports, "setViewSettingsPanels", () => $b6bf5ef387c9e297$export$427f126b21640252);
$parcel$export(module.exports, "setViewSettingsQuickFilters", () => $b6bf5ef387c9e297$export$60d0caf3b1c59159);
$parcel$export(module.exports, "setViewSettingsCompactMode", () => $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc);
$parcel$export(module.exports, "setViewSettingsCardDetails", () => $b6bf5ef387c9e297$export$af2e5a35023755b5);
$parcel$export(module.exports, "setViewSettingsCardExtraFields", () => $b6bf5ef387c9e297$export$b54537ba70def946);
$parcel$export(module.exports, "setViewSettingsShowCardCovers", () => $b6bf5ef387c9e297$export$d166622a8f3a93f0);
$parcel$export(module.exports, "toggleViewSetting", () => $b6bf5ef387c9e297$export$779d9a10b8826796);
$parcel$export(module.exports, "toggleShowEpics", () => $b6bf5ef387c9e297$export$c1bb93dcfa07c797);
$parcel$export(module.exports, "toggleShowVersions", () => $b6bf5ef387c9e297$export$582a65f6c8cb93ab);
$parcel$export(module.exports, "toggleShowStatuses", () => $b6bf5ef387c9e297$export$ac311ca7d5df1d03);
$parcel$export(module.exports, "toggleShowLinkedIssuesStats", () => $b6bf5ef387c9e297$export$580abda923c30dc5);
$parcel$export(module.exports, "setShowUnscheduledColumn", () => $b6bf5ef387c9e297$export$6edce735c6eb4cb0);
$parcel$export(module.exports, "toggleShowDaysInColumn", () => $b6bf5ef387c9e297$export$2849cc68d8e521b7);
$parcel$export(module.exports, "toggleShowDueDate", () => $b6bf5ef387c9e297$export$ef2b1a307fba6e8a);
$parcel$export(module.exports, "toggleShowLabels", () => $b6bf5ef387c9e297$export$229260fb852e61e0);
$parcel$export(module.exports, "toggleExtraField", () => $b6bf5ef387c9e297$export$6acb0c83c20a20);
$parcel$export(module.exports, "setShowOfftrackDependencyLines", () => $b6bf5ef387c9e297$export$2c48063cd4ef1ade);
$parcel$export(module.exports, "setIssueIdsToShowDependencies", () => $b6bf5ef387c9e297$export$f7b68cb584e33d77);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $9pP0g = parcelRequire("9pP0g");

var $8zmNw = parcelRequire("8zmNw");
const $b6bf5ef387c9e297$export$f6196a6c6bb539b4 = ()=>({ setState: setState }, { view: view })=>{
        setState({
            view: view
        });
    };
const $b6bf5ef387c9e297$export$99f2d9eb0b41b93 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };
const $b6bf5ef387c9e297$export$9c73b2f282069160 = ({ boardId: boardId, view: view, isFullscreen: isFullscreen })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreen,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            isFullscreen: isFullscreen
        });
    };
const $b6bf5ef387c9e297$export$427f126b21640252 = ({ boardId: boardId, view: view, panelState: panelState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsPanels({
            boardId: boardId,
            panelState: panelState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpicPanel: panelState.EPIC_PANEL,
            showVersionPanel: panelState.VERSION_PANEL
        });
    };
const $b6bf5ef387c9e297$export$60d0caf3b1c59159 = ({ boardId: boardId, view: view, showQuickFilters: showQuickFilters })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsQuickFilters({
            boardId: boardId,
            showQuickFilters: showQuickFilters,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showQuickFilters: showQuickFilters
        });
    };
const $b6bf5ef387c9e297$export$9ca6e4490ca9b1fc = ({ boardId: boardId, view: view, showCompactMode: showCompactMode })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCompactMode({
            boardId: boardId,
            showCompactMode: showCompactMode,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showCompactMode: showCompactMode
        });
    };
const $b6bf5ef387c9e297$export$af2e5a35023755b5 = ({ boardId: boardId, view: view, cardDetailsState: cardDetailsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCardDetails({
            boardId: boardId,
            cardDetailsState: cardDetailsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: cardDetailsState.SHOW_EPICS,
            showVersions: cardDetailsState.SHOW_VERSIONS,
            showStatuses: cardDetailsState.SHOW_STATUSES,
            showIssueLinksStats: cardDetailsState.SHOW_ISSUE_LINKS_STATS,
            showDaysInColumn: cardDetailsState.SHOW_DAYS_IN_COLUMN,
            showIssueType: cardDetailsState.SHOW_ISSUE_TYPE,
            showIssueKey: cardDetailsState.SHOW_ISSUE_KEY,
            showEstimate: cardDetailsState.SHOW_ESTIMATE,
            showPriority: cardDetailsState.SHOW_PRIORITY,
            showDevelopment: cardDetailsState.SHOW_DEVELOPMENT,
            showAssignee: cardDetailsState.SHOW_ASSIGNEE,
            showDueDate: cardDetailsState.SHOW_DUE_DATE,
            showLabels: cardDetailsState.SHOW_LABELS,
            showCardCovers: cardDetailsState.SHOW_CARD_COVERS,
            showBoardName: cardDetailsState.SHOW_BOARD_NAME
        });
    };
const $b6bf5ef387c9e297$export$b54537ba70def946 = ({ boardId: boardId, view: view, cardExtraFieldsState: cardExtraFieldsState })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: cardExtraFieldsState
        });
    };
const $b6bf5ef387c9e297$export$d166622a8f3a93f0 = ({ boardId: boardId, view: view, showCardCovers: showCardCovers })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const newState = {
            ...currentSettings,
            showCardCovers: showCardCovers
        };
        $8zmNw.setViewSettings({
            boardId: boardId,
            state: newState,
            view: view || currentSettings.view || undefined
        });
        setState(newState);
    };
const $b6bf5ef387c9e297$export$779d9a10b8826796 = ({ boardId: boardId, view: view, setting: setting })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const set = (newState)=>{
            setState(newState);
            $8zmNw.setViewSettings({
                boardId: boardId,
                state: newState,
                view: view || currentSettings.view || undefined
            });
        };
        switch(setting){
            case (0, $9pP0g.ViewSetting).VERSION_PANEL:
                set({
                    ...currentSettings,
                    showVersionPanel: !currentSettings.showVersionPanel
                });
                break;
            case (0, $9pP0g.ViewSetting).EPIC_PANEL:
                set({
                    ...currentSettings,
                    showEpicPanel: !currentSettings.showEpicPanel
                });
                break;
            case (0, $9pP0g.ViewSetting).QUICK_FILTERS:
                set({
                    ...currentSettings,
                    showQuickFilters: !currentSettings.showQuickFilters
                });
                break;
            case (0, $9pP0g.ViewSetting).COMPACT_MODE:
                set({
                    ...currentSettings,
                    showCompactMode: !currentSettings.showCompactMode
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_EPICS:
                set({
                    ...currentSettings,
                    showEpics: !currentSettings.showEpics
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_STATUSES:
                set({
                    ...currentSettings,
                    showStatuses: !currentSettings.showStatuses
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_VERSIONS:
                set({
                    ...currentSettings,
                    showVersions: !currentSettings.showVersions
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_UNSCHEDULED_COLUMN:
                set({
                    ...currentSettings,
                    showUnscheduledColumn: !currentSettings.showUnscheduledColumn
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY:
                set({
                    ...currentSettings,
                    showIssueKey: !currentSettings.showIssueKey
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE:
                set({
                    ...currentSettings,
                    showIssueType: !currentSettings.showIssueType
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_PRIORITY:
                set({
                    ...currentSettings,
                    showPriority: !currentSettings.showPriority
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT:
                set({
                    ...currentSettings,
                    showDevelopment: !currentSettings.showDevelopment
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE:
                set({
                    ...currentSettings,
                    showAssignee: !currentSettings.showAssignee
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_ESTIMATE:
                set({
                    ...currentSettings,
                    showEstimate: !currentSettings.showEstimate
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN:
                set({
                    ...currentSettings,
                    showDaysInColumn: !currentSettings.showDaysInColumn
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_DUE_DATE:
                set({
                    ...currentSettings,
                    showDueDate: !currentSettings.showDueDate
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_LABELS:
                set({
                    ...currentSettings,
                    showLabels: !currentSettings.showLabels
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_CARD_COVERS:
                set({
                    ...currentSettings,
                    showCardCovers: !currentSettings.showCardCovers
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_OFFTRACK_DEPENDENCY_LINES:
                set({
                    ...currentSettings,
                    showOfftrackDependencyLines: !currentSettings.showOfftrackDependencyLines
                });
                break;
            case (0, $9pP0g.ViewSetting).SHOW_BOARD_NAME:
                set({
                    ...currentSettings,
                    showBoardName: !currentSettings.showBoardName
                });
                break;
            default:
                break;
        }
    };
const $b6bf5ef387c9e297$export$c1bb93dcfa07c797 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowEpics({
            boardId: boardId,
            showEpics: !currentSettings.showEpics,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showEpics: !currentSettings.showEpics
        });
    };
const $b6bf5ef387c9e297$export$582a65f6c8cb93ab = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowVersions({
            boardId: boardId,
            showVersions: !currentSettings.showVersions,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showVersions: !currentSettings.showVersions
        });
    };
const $b6bf5ef387c9e297$export$ac311ca7d5df1d03 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowStatuses({
            boardId: boardId,
            showStatuses: !currentSettings.showStatuses,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showStatuses: !currentSettings.showStatuses
        });
    };
const $b6bf5ef387c9e297$export$580abda923c30dc5 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowIssueLinksStats({
            boardId: boardId,
            showIssueLinksStats: !currentSettings.showIssueLinksStats,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showIssueLinksStats: !currentSettings.showIssueLinksStats
        });
    };
const $b6bf5ef387c9e297$export$6edce735c6eb4cb0 = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowUnscheduledColumn({
            boardId: boardId,
            showUnscheduledColumn: isVisible
        });
        setState({
            ...currentSettings,
            showUnscheduledColumn: isVisible
        });
    };
const $b6bf5ef387c9e297$export$2849cc68d8e521b7 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowDaysInColumn({
            boardId: boardId,
            showDaysInColumn: !currentSettings.showDaysInColumn,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDaysInColumn: !currentSettings.showDaysInColumn
        });
    };
const $b6bf5ef387c9e297$export$ef2b1a307fba6e8a = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowDueDate({
            boardId: boardId,
            showDueDate: !currentSettings.showDueDate,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showDueDate: !currentSettings.showDueDate
        });
    };
const $b6bf5ef387c9e297$export$229260fb852e61e0 = ({ boardId: boardId, view: view })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowLabels({
            boardId: boardId,
            showLabels: !currentSettings.showLabels,
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            showLabels: !currentSettings.showLabels
        });
    };
const $b6bf5ef387c9e297$export$6acb0c83c20a20 = ({ boardId: boardId, view: view, fieldId: fieldId })=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        const currentExtraFields = currentSettings.cardExtraFields;
        $8zmNw.setExtraFields({
            boardId: boardId,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            },
            view: view || currentSettings.view || undefined
        });
        setState({
            ...currentSettings,
            cardExtraFields: {
                ...currentExtraFields,
                [fieldId]: !currentExtraFields[fieldId]
            }
        });
    };
const $b6bf5ef387c9e297$export$2c48063cd4ef1ade = (boardId, isVisible)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setShowOfftrackDependencyLines({
            boardId: boardId,
            showOfftrackDependencyLines: isVisible
        });
        setState({
            ...currentSettings,
            showOfftrackDependencyLines: isVisible
        });
    };
const $b6bf5ef387c9e297$export$f7b68cb584e33d77 = (boardId, issueIds)=>({ setState: setState, getState: getState })=>{
        const currentSettings = getState();
        $8zmNw.setIssueIdsToShowDependencies({
            boardId: boardId,
            issueIds: issueIds
        });
        setState({
            ...currentSettings,
            issueIdsToShowDependencies: issueIds
        });
    };

});
parcelRegister("9pP0g", function(module, exports) {

$parcel$export(module.exports, "ViewSetting", () => $23bab0da4eba41c6$export$b6da678b61e4982c);

var $a4XJc = parcelRequire("a4XJc");

var $iJgHp = parcelRequire("iJgHp");
const $23bab0da4eba41c6$export$b6da678b61e4982c = {
    ...(0, $a4XJc.Panels),
    ...(0, $iJgHp.CardDetails),
    ...(0, $a4XJc.IncrementPlanningSettings),
    QUICK_FILTERS: $a4XJc.QUICK_FILTERS,
    COMPACT_MODE: $a4XJc.COMPACT_MODE
};

});
parcelRegister("iJgHp", function(module, exports) {

$parcel$export(module.exports, "CardDetails", () => $a1cb757db25241b3$export$741386389156bf07);

var $a4XJc = parcelRequire("a4XJc");
const $a1cb757db25241b3$export$741386389156bf07 = {
    SHOW_ISSUE_KEY: $a4XJc.SHOW_ISSUE_KEY,
    SHOW_ISSUE_TYPE: $a4XJc.SHOW_ISSUE_TYPE,
    SHOW_EPICS: $a4XJc.SHOW_EPICS,
    SHOW_STATUSES: $a4XJc.SHOW_STATUSES,
    SHOW_VERSIONS: $a4XJc.SHOW_VERSIONS,
    SHOW_ISSUE_LINKS_STATS: $a4XJc.SHOW_ISSUE_LINKS_STATS,
    SHOW_PRIORITY: $a4XJc.SHOW_PRIORITY,
    SHOW_DEVELOPMENT: $a4XJc.SHOW_DEVELOPMENT,
    SHOW_ASSIGNEE: $a4XJc.SHOW_ASSIGNEE,
    SHOW_ESTIMATE: $a4XJc.SHOW_ESTIMATE,
    SHOW_DAYS_IN_COLUMN: $a4XJc.SHOW_DAYS_IN_COLUMN,
    SHOW_DUE_DATE: $a4XJc.SHOW_DUE_DATE,
    SHOW_LABELS: $a4XJc.SHOW_LABELS,
    SHOW_CARD_COVERS: $a4XJc.SHOW_CARD_COVERS,
    SHOW_BOARD_NAME: $a4XJc.SHOW_BOARD_NAME
};

});




parcelRegister("ffHmx", function(module, exports) {

$parcel$export(module.exports, "getIsFullscreen", () => $fc378329dceca517$export$b061161f83abaf15);
$parcel$export(module.exports, "getShowVersionPanel", () => $fc378329dceca517$export$cdf1158c8123d31c);
$parcel$export(module.exports, "getShowEpicPanel", () => $fc378329dceca517$export$fc9a39e5c1906367);
$parcel$export(module.exports, "getShowQuickFilters", () => $fc378329dceca517$export$732caa9fcae1c5ff);
$parcel$export(module.exports, "getShowCompactMode", () => $fc378329dceca517$export$72bae49530cc02bb);
$parcel$export(module.exports, "getShowPanels", () => $fc378329dceca517$export$e2483fb3e0d0ff4b);
$parcel$export(module.exports, "getShowEpics", () => $fc378329dceca517$export$b631ebb4887e6060);
$parcel$export(module.exports, "getShowVersions", () => $fc378329dceca517$export$2cb6de520195dbf5);
$parcel$export(module.exports, "getShowStatuses", () => $fc378329dceca517$export$b5f1c34af9498ea);
$parcel$export(module.exports, "getShowUnscheduledColumn", () => $fc378329dceca517$export$bf31a7b99f7bc62f);
$parcel$export(module.exports, "getShowIssueLinksStats", () => $fc378329dceca517$export$266785c43d094472);
$parcel$export(module.exports, "getShowIssueType", () => $fc378329dceca517$export$a079b5f709c4d237);
$parcel$export(module.exports, "getShowIssueKey", () => $fc378329dceca517$export$cb710ef8b1ccd94b);
$parcel$export(module.exports, "getShowPriority", () => $fc378329dceca517$export$5abfbf16fb2cec7b);
$parcel$export(module.exports, "getShowDevelopment", () => $fc378329dceca517$export$d89a1b3e54af627e);
$parcel$export(module.exports, "getShowAssignee", () => $fc378329dceca517$export$ad1a6d247a05049d);
$parcel$export(module.exports, "getShowEstimate", () => $fc378329dceca517$export$d21c0b83591460c9);
$parcel$export(module.exports, "getShowCardExtraField", () => $fc378329dceca517$export$7549550e839e6e0c);
$parcel$export(module.exports, "getShowDaysInColumn", () => $fc378329dceca517$export$9a608cd91e68c95c);
$parcel$export(module.exports, "getShowCardCovers", () => $fc378329dceca517$export$983376245b8547dc);
$parcel$export(module.exports, "getShowOfftrackDependencyLines", () => $fc378329dceca517$export$32c01395d25dfdcc);
$parcel$export(module.exports, "getShowBoardName", () => $fc378329dceca517$export$e3335f300fcfef70);
$parcel$export(module.exports, "getIssueIdsToShowDependencies", () => $fc378329dceca517$export$67e6bba1326e537a);
$parcel$export(module.exports, "getCardFieldsSettings", () => $fc378329dceca517$export$e9dfc10bd434fabb);
$parcel$export(module.exports, "getHasCardExtraFields", () => $fc378329dceca517$export$1e24fae4497ff7e0);
const $fc378329dceca517$export$b061161f83abaf15 = (state)=>state.isFullscreen;
const $fc378329dceca517$export$cdf1158c8123d31c = (state)=>state.showVersionPanel;
const $fc378329dceca517$export$fc9a39e5c1906367 = (state)=>state.showEpicPanel;
const $fc378329dceca517$export$732caa9fcae1c5ff = (state)=>state.showQuickFilters;
const $fc378329dceca517$export$72bae49530cc02bb = (state)=>state.showCompactMode;
const $fc378329dceca517$export$e2483fb3e0d0ff4b = (state)=>({
        EPIC_PANEL: state.showEpicPanel,
        VERSION_PANEL: state.showVersionPanel
    });
const $fc378329dceca517$export$b631ebb4887e6060 = (state)=>state.showEpics;
const $fc378329dceca517$export$2cb6de520195dbf5 = (state)=>state.showVersions;
const $fc378329dceca517$export$b5f1c34af9498ea = (state)=>state.showStatuses;
const $fc378329dceca517$export$bf31a7b99f7bc62f = (state)=>state.showUnscheduledColumn;
const $fc378329dceca517$export$266785c43d094472 = (state)=>state.showIssueLinksStats;
const $fc378329dceca517$export$a079b5f709c4d237 = (state)=>state.showIssueType;
const $fc378329dceca517$export$cb710ef8b1ccd94b = (state)=>state.showIssueKey;
const $fc378329dceca517$export$5abfbf16fb2cec7b = (state)=>state.showPriority;
const $fc378329dceca517$export$d89a1b3e54af627e = (state)=>state.showDevelopment;
const $fc378329dceca517$export$ad1a6d247a05049d = (state)=>state.showAssignee;
const $fc378329dceca517$export$d21c0b83591460c9 = (state)=>state.showEstimate;
const $fc378329dceca517$export$7549550e839e6e0c = (state)=>state.cardExtraFields;
const $fc378329dceca517$export$9a608cd91e68c95c = (state)=>state.showDaysInColumn;
const $fc378329dceca517$export$983376245b8547dc = (state)=>state.showCardCovers;
const $fc378329dceca517$export$32c01395d25dfdcc = (state)=>state.showOfftrackDependencyLines;
const $fc378329dceca517$export$e3335f300fcfef70 = (state)=>state.showBoardName;
const $fc378329dceca517$export$67e6bba1326e537a = (state)=>state.issueIdsToShowDependencies;
const $fc378329dceca517$export$e9dfc10bd434fabb = (state)=>({
        showIssueType: state.showIssueType,
        showIssueKey: state.showIssueKey,
        showPriority: state.showPriority,
        showDevelopment: state.showDevelopment,
        showAssignee: state.showAssignee,
        showEstimate: state.showEstimate,
        cardExtraFields: state.cardExtraFields,
        showDaysInColumn: state.showDaysInColumn,
        showDueDate: state.showDueDate,
        showLabels: state.showLabels,
        showCardCovers: state.showCardCovers,
        showStatuses: state.showStatuses
    });
const $fc378329dceca517$export$1e24fae4497ff7e0 = (state)=>Object.values(state.cardExtraFields).length > 0 && Object.values(state.cardExtraFields).some((value)=>value === true);

});


parcelRegister("aH5JS", function(module, exports) {

$parcel$export(module.exports, "useAutoScrollSwimlane", () => $94eba0273c8c9106$export$8760bae08e9c84b7);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $5mTgl = parcelRequire("5mTgl");
const $94eba0273c8c9106$export$8760bae08e9c84b7 = (swimlaneIds, scrollTo)=>{
    const autoScroll = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardAutoScroll));
    const getPlatformIssue = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformIssueSelector));
    (0, $5uXOq.useEffect)(()=>{
        const autoScrollIssueId = autoScroll?.issueId;
        const autoScrollSwimlaneId = autoScrollIssueId ? getPlatformIssue(autoScrollIssueId)?.swimlaneId : undefined;
        if (!autoScrollSwimlaneId) return;
        const swimlaneIndex = swimlaneIds.indexOf(autoScrollSwimlaneId);
        if (swimlaneIndex === -1) return;
        return scrollTo(swimlaneIndex, {
            immediate: true,
            hasVirtualisedChildren: true
        });
    }, [
        autoScroll,
        getPlatformIssue,
        scrollTo,
        swimlaneIds
    ]);
};

});

parcelRegister("grktj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a2f76db5f44fdad$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2m0b6 = parcelRequire("2m0b6");

var $7D59a = parcelRequire("7D59a");

var $bdYfL = parcelRequire("bdYfL");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $63LqY = parcelRequire("63LqY");

var $4lizL = parcelRequire("4lizL");

var $f3HGL = parcelRequire("f3HGL");

var $eBkhA = parcelRequire("eBkhA");

var $hASys = parcelRequire("hASys");

var $aXl6d = parcelRequire("aXl6d");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");
const $2a2f76db5f44fdad$var$VirtualizedSwimlane = ({ id: id, index: index, top: top, measure: measure, forceRemeasure: forceRemeasure, isLastSwimlane: isLastSwimlane, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel })=>{
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const isCMPBoard = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard)) : undefined;
    const onResize = (0, $7D59a.useEvent)(()=>{
        forceRemeasure(wrapperRef.current);
    });
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (wrapperRef.current) measure(wrapperRef.current);
    }, [
        wrapperRef,
        measure
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: wrapperRef,
        onResize: onResize
    });
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const swimlaneId = isUnscheduledWorkColumnPanel ? (0, $bdYfL.appendUnscheduledWorkSwimlaneIdSuffix)(id) : id;
    const hasGrouping = (0, $aXl6d.useHasGroupingStyle)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const customRightContent = (0, $5uXOq.useMemo)(()=>{
        if (!isIPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f3HGL.SwimlaneMoveToDoneButton), {
            id: id
        });
        return null;
    }, [
        id,
        isIPBoard
    ]);
    const swimlane = isIPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eBkhA.IncrementPlanningSwimlane), {
        id: swimlaneId,
        innerRef: wrapperRef,
        isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
        top: top
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lizL.default), {
        swimlaneId: id,
        isLastSwimlane: isLastSwimlane,
        offsetTop: top,
        isUnscheduledWorkColumn: isUnscheduledWorkColumnPanel
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hASys.default), {
        id: swimlaneId,
        key: swimlaneId,
        isFirstSwimlane: index === 0,
        wrapperStyle: {
            position: 'absolute',
            top: top,
            ...isSoftwareFullTheming ? {
                boxSizing: 'border-box',
                padding: isCMPBoard ? `0 ${"var(--ds-space-050, 4px)"}` : `0 0 0 ${"var(--ds-space-050, 4px)"}`
            } : {
                width: '100%'
            },
            ...isSoftwareFullTheming && (isCMPBoard ? {
                width: '100%'
            } : {
                width: `calc(100% - ${"var(--ds-space-050, 4px)"}`
            })
        },
        innerRef: wrapperRef,
        customRightContent: customRightContent,
        isMatrixLayout: hasGrouping,
        isThemed: isSoftwareFullTheming
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4lizL.default), {
        swimlaneId: id,
        isLastSwimlane: isLastSwimlane,
        offsetTop: top,
        isUnscheduledWorkColumn: isUnscheduledWorkColumnPanel
    }));
    return swimlane;
};
var $2a2f76db5f44fdad$export$2e2bcd8739ae039 = $2a2f76db5f44fdad$var$VirtualizedSwimlane;

});
parcelRegister("2m0b6", function(module, exports) {

$parcel$export(module.exports, "createResizeObserverHook", () => $072291c9ed048772$export$87a9d3e287304ae4);
$parcel$export(module.exports, "useResizeObserver", () => $072291c9ed048772$export$683480f191c0e3ea);
$parcel$export(module.exports, "flushResizeObservers", () => $072291c9ed048772$export$a181ef2a6d0a1bb6);
$parcel$export(module.exports, "useRectObserver", () => $072291c9ed048772$export$e58143dc89297272);

var $5uXOq = parcelRequire("5uXOq");

var $eUdQc = parcelRequire("eUdQc");
function $072291c9ed048772$export$87a9d3e287304ae4(params) {
    const group = new (0, $eUdQc.ResizeObserverGroup)(params?.debouncePeriod);
    /**
	 * This hook uses a shared ResizeObserver instance.
	 *
	 * When a resize notification comes in, a single batched React update will be
	 * dispatched after a debounce period only for the elements that have been
	 * resized.
	 *
	 * This does NOT react to updates to REF
	 */ function useResizeObserver({ ref: ref, onResize: onResize }) {
        const onResizeRef = (0, $5uXOq.useRef)(onResize);
        (0, $5uXOq.useEffect)(()=>{
            onResizeRef.current = onResize;
        });
        const stableOnResize = (0, $5uXOq.useCallback)(()=>onResizeRef.current(), []);
        (0, $5uXOq.useLayoutEffect)(()=>group.observe(ref, stableOnResize), [
            ref,
            stableOnResize
        ]);
    }
    return {
        useResizeObserver: useResizeObserver,
        flushResizeObservers: ()=>group.flush()
    };
}
const { useResizeObserver: $072291c9ed048772$export$683480f191c0e3ea, flushResizeObservers: $072291c9ed048772$export$a181ef2a6d0a1bb6 } = $072291c9ed048772$export$87a9d3e287304ae4();
function $072291c9ed048772$export$e58143dc89297272({ ref: ref, useResizeObserverDI: useResizeObserverDI = $072291c9ed048772$export$683480f191c0e3ea }) {
    const [rect, setRect] = (0, $5uXOq.useState)(null);
    const onResize = ()=>{
        if (ref.current) setRect(ref.current.getBoundingClientRect());
    };
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!ref.current) throw new Error([
            'useRectObserver: ref is not available on mount.',
            'This means you are attaching refs conditionally onto your elements, for example in with an early return.',
            'This will not work properly. Please update your code so that refs are always attached to components on mount.'
        ].join('\n'));
        setRect(ref.current.getBoundingClientRect());
    }, [
        ref
    ]);
    useResizeObserverDI({
        ref: ref,
        onResize: onResize
    });
    return rect;
}

});
parcelRegister("eUdQc", function(module, exports) {

$parcel$export(module.exports, "ResizeObserverGroup", () => $52e6ab4254804b44$export$607798bbe2869c0);

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");
class $52e6ab4254804b44$export$607798bbe2869c0 {
    constructor(debouncePeriod = 16){
        this.subscribers = new Map();
        this.pendingUpdates = new Map();
        this.onResize = (entries)=>{
            entries.forEach((entry)=>{
                const subscriber = this.subscribers.get(entry.target);
                if (subscriber) this.pendingUpdates.set(subscriber.element, subscriber);
            });
            this.scheduleFlush();
        };
        this.observer = typeof ResizeObserver !== 'undefined' ? new ResizeObserver(this.onResize) : null;
        this.scheduleFlush = debouncePeriod > 0 ? (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
            this.flush();
        }, debouncePeriod, {
            trailing: true,
            maxWait: 32
        }) : ()=>{
            this.flush();
        };
    }
    observe(ref, callback) {
        if (!ref.current) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        this.subscribers.set(ref.current, {
            element: ref.current,
            callback: callback
        });
        this.observer?.observe(ref.current);
        return ()=>{
            if (!ref.current) return;
            this.subscribers.delete(ref.current);
            this.pendingUpdates.delete(ref.current);
            this.observer?.unobserve(ref.current);
        };
    }
    flush() {
        const entries = Array.from(this.pendingUpdates.values()).filter((entry)=>this.subscribers.has(entry.element));
        this.pendingUpdates.clear();
        (0, $7nsd3.unstable_batchedUpdates)(()=>{
            entries.forEach(({ callback: callback })=>{
                callback();
            });
        });
    }
}

});


parcelRegister("4lizL", function(module, exports) {

$parcel$export(module.exports, "default", () => $aed62d78335d31c0$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $hGgHi = parcelRequire("hGgHi");

var $9dZ1c = parcelRequire("9dZ1c");

var $jldZL = parcelRequire("jldZL");


var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $3hUhs = parcelRequire("3hUhs");

var $2Z6La = parcelRequire("2Z6La");

var $fraBZ = parcelRequire("fraBZ");

var $lmBAt = parcelRequire("lmBAt");

var $kQXnt = parcelRequire("kQXnt");


var $kbXtc = parcelRequire("kbXtc");

var $2xFXk = parcelRequire("2xFXk");

var $fG4NG = parcelRequire("fG4NG");

var $iuuJH = parcelRequire("iuuJH");

var $67sX6 = parcelRequire("67sX6");

var $gXFr2 = parcelRequire("gXFr2");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $8iBOe = parcelRequire("8iBOe");

var $cZdmg = parcelRequire("cZdmg");

var $aXl6d = parcelRequire("aXl6d");

var $67Z81 = parcelRequire("67Z81");

var $1DV2S = parcelRequire("1DV2S");

var $aanra = parcelRequire("aanra");
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $aed62d78335d31c0$var$shouldDisableVirtualisation = !!window.DISABLE_VIRTUALISATION;
const $aed62d78335d31c0$var$EMPTY_ARRAY = [];
const $aed62d78335d31c0$var$ColumnsContainer = ({ swimlaneId: swimlaneId, isLastSwimlane: isLastSwimlane, isUnscheduledWorkColumn: isUnscheduledWorkColumn = false, offsetTop: offsetTop = 0 })=>{
    const { sampleProjectDataNudgeRef: sampleProjectDataNudgeRef, shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataNudge } = (0, $fG4NG.usePersonalizedSampleData)();
    const isFlexible = (0, $63LqY.useCapability)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS);
    const columns = (0, $67sX6.useBoardSelector)(isUnscheduledWorkColumn ? (0, $5mTgl.unscheduledColumnSelector) : (0, $5mTgl.columnsWithResolutionSelector));
    const lastFilteredIssueTypeId = (0, $67sX6.useBoardSelector)((0, $5mTgl.getLastFilteredIssueTypeId));
    const lastFilteredProjectId = (0, $67sX6.useBoardSelector)((0, $5mTgl.getLastFilteredProjectId));
    const defaultProjectId = (0, $67sX6.useBoardSelector)((0, $gXFr2.getDefaultProjectIdForIssueCreation));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const getProjectFromSwimlaneId = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneSelector));
    const { screenReaderText: screenReaderText } = (0, $cZdmg.useScreenReader)();
    const ref = (0, $5uXOq.useRef)(null);
    const { initialProjectId: projectId, onChangeCardType: onChangeCardType, onChangeProject: onChangeProject } = (0, $2Z6La.useIccContext)();
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const hasGrouping = (0, $aXl6d.useHasGroupingStyle)(); // eslint-disable-next-line react-hooks/rules-of-hooks
    const isCMPBoard = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard)) : undefined;
    const projectIdToSync = (0, $5uXOq.useMemo)(()=>{
        if (isIPBoard) {
            // Return the last filtered project ID if it exists
            if (lastFilteredProjectId) return lastFilteredProjectId;
             // Otherwise return defaultProjectId if projectId has not been set in inline card create context
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(defaultProjectId)) return defaultProjectId;
        }
        if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id && swimlaneId) {
            const swimlaneProjectId = getProjectFromSwimlaneId(swimlaneId)?.id;
            return swimlaneProjectId ? Number(swimlaneProjectId) : null;
        }
        return null;
    }, [
        isIPBoard,
        swimlaneMode,
        lastFilteredProjectId,
        projectId,
        defaultProjectId,
        getProjectFromSwimlaneId,
        swimlaneId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectIdToSync)) onChangeProject(projectIdToSync);
    }, [
        onChangeProject,
        projectIdToSync
    ]);
    const projectIdForIssueType = isIPBoard ? projectId : defaultProjectId;
    const getIssueTypesForIssueCreationFn = (0, $67sX6.useBoardSelector)((0, $gXFr2.getIssueTypesForIssueCreation));
    const issueTypes = (0, $67sX6.useBoardSelector)(()=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(projectIdForIssueType) ? getIssueTypesForIssueCreationFn(projectIdForIssueType) : $aed62d78335d31c0$var$EMPTY_ARRAY); // when the issue type filter changed, for IP board, will verify if the lastFilteredIssueTypeId is
    // the valid issue type of the project.
    (0, $5uXOq.useEffect)(()=>{
        if (isIPBoard) {
            const isValidIssueType = (issueType)=>issueTypes.filter((_issueType)=>Number(_issueType.id) === issueType).length > 0;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(lastFilteredIssueTypeId) && isValidIssueType(lastFilteredIssueTypeId)) onChangeCardType(lastFilteredIssueTypeId);
        } else onChangeCardType(lastFilteredIssueTypeId || null);
    }, [
        lastFilteredIssueTypeId,
        onChangeCardType,
        issueTypes,
        isIPBoard
    ]); // We need to check the local storage view mode value when navigating back from backlog where view mode is always set to sidebar
    (0, $aanra.useSetViewModeFromLocalStorage)();
    const { shouldShowSampleProjectItem: shouldShowSampleProjectItem } = (0, $4R6GH.fg)('jfind-mature-example-project-gate') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kbXtc.default)((0, $2b25ecc91c46c84c$export$f4d6e7f0ba21581), defaultProjectId) : {
        shouldShowSampleProjectItem: false
    };
    const { ref: sampleProjectBoardNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$e16b25a220be9f3b), shouldShowSampleProjectItem && (0, $4R6GH.fg)('jfind-mature-example-project-gate'));
    let boardContainerRef = ref;
    if (shouldShowSampleProjectDataNudge) boardContainerRef = sampleProjectDataNudgeRef;
    else if (shouldShowSampleProjectItem) boardContainerRef = sampleProjectBoardNudgeRef;
    const shouldShowSampleProjectDataOrBoardNudge = shouldShowSampleProjectDataNudge || shouldShowSampleProjectItem;
    const renderAnnouncer = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fraBZ.AnnouncerV2), {
            liveMode: "polite",
            message: screenReaderText,
            shouldAnnounce: screenReaderText !== ''
        }));
    if (!false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aed62d78335d31c0$export$d61fab72474d20f0, {
        innerRef: boardContainerRef,
        isFlexible: isFlexible,
        isSwimlaneMode: Boolean(swimlaneId),
        shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataOrBoardNudge,
        isMatrixLayout: hasGrouping,
        isCMPBoard: isCMPBoard,
        isIPBoard: isIPBoard,
        isSoftwareThemingEnabled: (0, $lmBAt.getIsSoftwareThemingEnabled)()
    }, columns.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DV2S.default), {
            useVirtualisation: !$aed62d78335d31c0$var$shouldDisableVirtualisation,
            key: column.id,
            columnIndex: index,
            column: column,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            offsetTop: offsetTop,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumn
        })), shouldShowSampleProjectDataNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iBOe.SampleProjectDataNudgeWrapper), null), shouldShowSampleProjectItem && (0, $4R6GH.fg)('jfind-mature-example-project-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kQXnt.SampleProjectBoardNudgeAsync), null), renderAnnouncer());
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aed62d78335d31c0$export$d61fab72474d20f0, {
        innerRef: boardContainerRef,
        isFlexible: isFlexible,
        isSwimlaneMode: Boolean(swimlaneId),
        shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataOrBoardNudge,
        isMatrixLayout: hasGrouping,
        isCMPBoard: isCMPBoard,
        isIPBoard: isIPBoard,
        isSoftwareThemingEnabled: (0, $lmBAt.getIsSoftwareThemingEnabled)()
    }, columns.map((column, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DV2S.default), {
            useVirtualisation: false,
            key: column.id,
            columnIndex: index,
            column: column,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            offsetTop: offsetTop,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumn
        })), shouldShowSampleProjectDataNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8iBOe.SampleProjectDataNudgeWrapper), null), shouldShowSampleProjectItem && (0, $4R6GH.fg)('jfind-mature-example-project-gate') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kQXnt.SampleProjectBoardNudgeAsync), null), renderAnnouncer());
};
const $aed62d78335d31c0$var$ColumnsContainerWithProvider = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cZdmg.ScreenReaderProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($aed62d78335d31c0$var$ColumnsContainer, props));
var $aed62d78335d31c0$export$2e2bcd8739ae039 // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
 = /*#__PURE__*/ (0, $5uXOq.memo)($aed62d78335d31c0$var$ColumnsContainerWithProvider);
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $aed62d78335d31c0$var$BoardContainerControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-12fexja-0"
})`display:${(props)=>props.isFlexible ? 'grid' : 'flex'};grid-template-columns:${({ isFlexible: isFlexible })=>{
    if (!isFlexible) return 'initial';
    return `repeat(auto-fit,minmax(${(0, $3hUhs.sharedStyles).columnMinWidth}px,1fr))`;
}};grid-auto-flow:column;flex:1 1 auto;${({ isFlexible: isFlexible, isSwimlaneMode: isSwimlaneMode })=>isFlexible && !isSwimlaneMode && 'min-height: calc(var(--board-scroll-element-height) * 1px - 8px)'};width:${(shouldShowSampleProjectDataNudge)=>shouldShowSampleProjectDataNudge ? 'max-content' : undefined};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $aed62d78335d31c0$var$BoardContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, isSwimlaneMode: isSwimlaneMode, shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataNudge, isSoftwareThemingEnabled: isSoftwareThemingEnabled, isMatrixLayout: isMatrixLayout, isCMPBoard: isCMPBoard, isIPBoard: isIPBoard, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1cgxlvv": (0, $lD23V.default)(__cmplp.isMatrixLayout ? "var(--ds-space-0, 0px)" : "var(--ds-space-050, 4px)"),
            "--_3eixo4": (0, $lD23V.default)(__cmplp.isMatrixLayout || __cmplp.isCMPBoard || __cmplp.isIPBoard ? "var(--ds-space-100, 8px)" : "var(--ds-space-0, 0px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _wij21bp4",
            __cmplp.isFlexible ? "_1e0c11p5" : "_1e0c1txw",
            !__cmplp.isFlexible ? "_yv0eglyw" : "_yv0e16td",
            __cmplp.isFlexible && !__cmplp.isSwimlaneMode && ((0, $4R6GH.fg)('avoid_board_scroll_container_style_changes') ? "_1tke1osq" : "_1tkei63v"),
            __cmplp.shouldShowSampleProjectDataNudge && "_1bsb1ris",
            __cmplp.isSoftwareThemingEnabled && "_zulp1peh _19bv1cq2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $aed62d78335d31c0$export$d61fab72474d20f0 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $aed62d78335d31c0$var$BoardContainerExperiment, $aed62d78335d31c0$var$BoardContainerControl);

});
parcelRegister("kQXnt", function(module, exports) {

$parcel$export(module.exports, "SampleProjectBoardNudgeAsync", () => $8734032c1a046233$export$f27509f6d293665a);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");


var $7x05J = parcelRequire("7x05J");
const $8734032c1a046233$var$entryPointParams = {};
const $8734032c1a046233$var$runtimeProps = {};
const $8734032c1a046233$export$f27509f6d293665a = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7x05J.sampleProjectBoardEntryPoint), $8734032c1a046233$var$entryPointParams);
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$b51b409cb5508624),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $8734032c1a046233$var$runtimeProps
    });
};

});
parcelRegister("7x05J", function(module, exports) {

$parcel$export(module.exports, "sampleProjectBoardEntryPoint", () => $75da4f0a9ebe7daa$export$6bb2caecccf8958d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $75da4f0a9ebe7daa$export$6bb2caecccf8958d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("iutwM")), {
        moduleId: "36cba37c"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("iutwM", function(module, exports) {

let $d761eee6db525d40$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d761eee6db525d40$var$load("9YoOA").then(()=>parcelRequire('2MRfj'));

});



const $2b25ecc91c46c84c$export$46125b321d7cdb6 = 'jira.onboarding.view.sample.project.cta.tenant.CLOUD_ID';
const $2b25ecc91c46c84c$export$65c55b7261b144a9 = 'sampleProjectSessionStoreKey';
const $2b25ecc91c46c84c$export$41ddad417ac84137 = 'sampleProjectCtaProperty';
const $2b25ecc91c46c84c$export$f4d6e7f0ba21581 = 'sampleProjectNudgesProperty';
const $2b25ecc91c46c84c$export$d74727f7d111b288 = 'sampleProjectNavNudgeProperty';

parcelRegister("kbXtc", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8ae3e07c26bd3af$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

const $c8ae3e07c26bd3af$var$useSampleProjectSessionStorage = (sessionVariableKey, projectId)=>{
    const store = (0, $eNf8a.createSessionStorageProvider)((0, $2b25ecc91c46c84c$export$65c55b7261b144a9));
    const viewSampleProjectUserProperty = store.get(sessionVariableKey);
    const removeSessionVariable = ()=>{
        store.remove(sessionVariableKey);
    };
    if (!viewSampleProjectUserProperty) return {
        removeSessionVariable: removeSessionVariable,
        shouldShowSampleProjectCta: false,
        shouldShowSampleProjectItem: false,
        projectIds: []
    };
    const parsedSampleProjectUserProperty = JSON.parse(viewSampleProjectUserProperty);
    const status = parsedSampleProjectUserProperty.status;
    const projectIds = parsedSampleProjectUserProperty.projectIds;
    const shouldShowSampleProjectCta = !!(status === 'ENABLED');
    const shouldShowSampleProjectItem = !!(status === 'ENABLED' && projectIds.includes(projectId));
    return {
        removeSessionVariable: removeSessionVariable,
        projectIds: projectIds,
        shouldShowSampleProjectCta: shouldShowSampleProjectCta,
        shouldShowSampleProjectItem: shouldShowSampleProjectItem
    };
};
var $c8ae3e07c26bd3af$export$2e2bcd8739ae039 = $c8ae3e07c26bd3af$var$useSampleProjectSessionStorage;

});

parcelRegister("fG4NG", function(module, exports) {

$parcel$export(module.exports, "usePersonalizedSampleData", () => $6e8b9fa0b9fa34e4$export$137ac62e7360b6f6);

var $5uXOq = parcelRequire("5uXOq");

var $9dZ1c = parcelRequire("9dZ1c");

var $4R6GH = parcelRequire("4R6GH");


var $9yQlD = parcelRequire("9yQlD");

var $4pxa7 = parcelRequire("4pxa7");

const $6e8b9fa0b9fa34e4$export$137ac62e7360b6f6 = ()=>{
    const isModalClosed = (0, $4pxa7.useKeepIccOpenState)();
    const { ref: sampleProjectDataNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $dbbf68c32d8c4308$export$9749a972a54ad7ba), (0, $4R6GH.fg)('jfind-personalized-sample-data-kill-switch'));
    const result = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('jfind-personalized-sample-data-kill-switch') === false || isModalClosed === false) return {
            sampleProjectDataNudgeRef: sampleProjectDataNudgeRef,
            shouldShowSampleProjectDataNudge: false
        };
        const shouldShowSampleProjectDataNudge = (0, $9yQlD.sessionStorageProvider).get((0, $6784cbc7d62e5d7c$export$891ca65264b256bb));
        return {
            sampleProjectDataNudgeRef: sampleProjectDataNudgeRef,
            shouldShowSampleProjectDataNudge: shouldShowSampleProjectDataNudge
        };
    }, [
        isModalClosed,
        sampleProjectDataNudgeRef
    ]);
    return result;
};

});
parcelRegister("4pxa7", function(module, exports) {

$parcel$export(module.exports, "useKeepIccOpenState", () => $e01b50e33333395d$export$991bb5f828c64eee);
$parcel$export(module.exports, "useKeepIccOpenStateOnListView", () => $e01b50e33333395d$export$aff5da39850e1282);
$parcel$export(module.exports, "useKeepIccOpenActions", () => $e01b50e33333395d$export$bbdeb5b20a0dc1c1);
$parcel$export(module.exports, "useTriggerEventState", () => $e01b50e33333395d$export$438ab5dbdf55872);


var $9yQlD = parcelRequire("9yQlD");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $g7fKq = parcelRequire("g7fKq");
const $e01b50e33333395d$var$isModalVisible = (key)=>(0, $9yQlD.sessionStorage).get(key) !== undefined;
// If either modal is visible, then don't open the ICC
const $e01b50e33333395d$var$setInitialState = ()=>!($e01b50e33333395d$var$isModalVisible((0, $6784cbc7d62e5d7c$export$4e1360a3e7785935)) || $e01b50e33333395d$var$isModalVisible((0, $6784cbc7d62e5d7c$export$e3884212029f7bef)));
const $e01b50e33333395d$export$d4c72bab9d6cc13a = {
    get keepIccOpen () {
        return $e01b50e33333395d$var$setInitialState();
    },
    hasCreatedIssueICC: true,
    triggerReason: 'emptyBoard',
    keepIccOpenOnListView: false
};
const $e01b50e33333395d$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-onboarding-keep-icc-open',
    initialState: $e01b50e33333395d$export$d4c72bab9d6cc13a,
    actions: $g7fKq.actions
});
const $e01b50e33333395d$export$991bb5f828c64eee = (0, $3sQ5x.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>state.keepIccOpen
});
const $e01b50e33333395d$export$aff5da39850e1282 = (0, $3sQ5x.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>state.keepIccOpenOnListView
});
const $e01b50e33333395d$export$bbdeb5b20a0dc1c1 = (0, $3sQ5x.createActionsHook)($e01b50e33333395d$var$store);
const $e01b50e33333395d$export$438ab5dbdf55872 = (0, $3sQ5x.createStateHook)($e01b50e33333395d$var$store, {
    selector: (state)=>({
            hasCreatedIssueICC: state.hasCreatedIssueICC,
            triggerReason: state.triggerReason
        })
});

});
parcelRegister("g7fKq", function(module, exports) {

$parcel$export(module.exports, "actions", () => $22684fd1187cb60b$export$e324594224ef24da);

var $5hyrq = parcelRequire("5hyrq");

var $ePMUR = parcelRequire("ePMUR");

var $cr2Jb = parcelRequire("cr2Jb");

var $lWd86 = parcelRequire("lWd86");

var $47sVO = parcelRequire("47sVO");
const $22684fd1187cb60b$export$e324594224ef24da = {
    toggleKeepIccOpen: $lWd86.toggleKeepIccOpen,
    setKeepIccOpenOnListView: $47sVO.setKeepIccOpenOnListView,
    setHasCreatedIssueICC: $ePMUR.setHasCreatedIssueICC,
    setTriggerReason: $cr2Jb.setTriggerReason,
    closeICC: $5hyrq.closeICC
};

});
parcelRegister("5hyrq", function(module, exports) {

$parcel$export(module.exports, "closeICC", () => $a1f8bda87b6ffc9a$export$e6c10955f11a7b51);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a1f8bda87b6ffc9a$export$e6c10955f11a7b51 = ()=>({ setState: setState })=>{
        setState({
            keepIccOpen: false
        });
    };

});

parcelRegister("ePMUR", function(module, exports) {

$parcel$export(module.exports, "setHasCreatedIssueICC", () => $a1b9adc891c00dd5$export$4bb464fc9800c324);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $a1b9adc891c00dd5$export$4bb464fc9800c324 = (hasCreatedIssueICC)=>({ getState: getState, setState: setState })=>{
        const { hasCreatedIssueICC: currentHasCreatedIssueICC } = getState();
        if (hasCreatedIssueICC === currentHasCreatedIssueICC) return;
        setState({
            hasCreatedIssueICC: hasCreatedIssueICC
        });
    };

});

parcelRegister("cr2Jb", function(module, exports) {

$parcel$export(module.exports, "setTriggerReason", () => $b662b9cea36b43af$export$8b8ceaca9e30bc48);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $b662b9cea36b43af$export$8b8ceaca9e30bc48 = (triggerReason)=>({ getState: getState, setState: setState })=>{
        const { triggerReason: currentTriggerReason } = getState();
        if (triggerReason === currentTriggerReason) return;
        setState({
            triggerReason: triggerReason
        });
    };

});

parcelRegister("lWd86", function(module, exports) {

$parcel$export(module.exports, "toggleKeepIccOpen", () => $071bcdbf7bb018d8$export$d09b33ff198a059);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $071bcdbf7bb018d8$export$d09b33ff198a059 = ()=>({ getState: getState, setState: setState })=>{
        const { keepIccOpen: iccOpenState } = getState();
        setState({
            keepIccOpen: !iccOpenState
        });
    };

});

parcelRegister("47sVO", function(module, exports) {

$parcel$export(module.exports, "setKeepIccOpenOnListView", () => $4e5de3e3ef2ed84f$export$72785f36e8a63554);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $4e5de3e3ef2ed84f$export$72785f36e8a63554 = (value)=>({ setState: setState })=>{
        setState({
            keepIccOpenOnListView: value
        });
    };

});




parcelRegister("8iBOe", function(module, exports) {

$parcel$export(module.exports, "SampleProjectDataNudgeWrapper", () => $2b14675f156a1014$export$63e89a2bc57668b5);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");


var $1RLyf = parcelRequire("1RLyf");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");
const $2b14675f156a1014$export$63e89a2bc57668b5 = ()=>{
    const issueKey = (0, $67sX6.useBoardSelector)((0, $67Z81.getFirstNonEpicIssueInFirstColumn));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$d99767a37baddfc),
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$9749a972a54ad7ba)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RLyf.SampleProjectDataNudge), {
        issueKey: issueKey
    }));
};

});
parcelRegister("1RLyf", function(module, exports) {

$parcel$export(module.exports, "SampleProjectDataNudge", () => $bd4b1eeb51b614f4$export$b3622ec7236b1f80);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");


var $9yQlD = parcelRequire("9yQlD");

var $8Bc5A = parcelRequire("8Bc5A");

var $cZ5k3 = parcelRequire("cZ5k3");

var $dAfqg = parcelRequire("dAfqg");

var $4pxa7 = parcelRequire("4pxa7");

var $lVJAU = parcelRequire("lVJAU");

var $8zOmE = parcelRequire("8zOmE");


var $ajlSd = parcelRequire("ajlSd");

var $iGBUU = parcelRequire("iGBUU");

var $hkYqK = parcelRequire("hkYqK");

var $gMHXs = parcelRequire("gMHXs");
const $bd4b1eeb51b614f4$var$position = (0, $cZ5k3.POSITION_RIGHT_START);
const $bd4b1eeb51b614f4$var$nudgeSpotlightProps = {
    width: (0, $8Bc5A.DEFAULT_NUDGE_WIDTH),
    position: $bd4b1eeb51b614f4$var$position
};
const $bd4b1eeb51b614f4$export$b3622ec7236b1f80 = ({ issueKey: issueKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isHidden, setIsHidden] = (0, $5uXOq.useState)(false);
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const isModalClosed = (0, $4pxa7.useKeepIccOpenState)();
    const hide = (0, $5uXOq.useCallback)(()=>{
        (0, $9yQlD.sessionStorageProvider).remove((0, $6784cbc7d62e5d7c$export$891ca65264b256bb));
        setIsHidden(true);
    }, [
        setIsHidden
    ]);
    const openTicket = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        hide();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewTask');
        if (window) {
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            const redirectUrl = new URL(window.location.href);
            if (issueKey) redirectUrl.searchParams.set('selectedIssue', issueKey);
            else redirectUrl.searchParams.set('selectedIssue', `${data?.projectKey}-1`);
            push(redirectUrl.href);
        }
    }, [
        data,
        hide,
        push,
        issueKey
    ]);
    const onboardingSpotlightProps = {
        actions: [
            {
                content: formatMessage((0, $gMHXs.default).spotlightDismissAction),
                onClick: hide,
                appearance: 'subtle'
            },
            {
                content: formatMessage((0, $gMHXs.default).spotlightCtaAction),
                onClick: openTicket,
                appearance: 'primary'
            }
        ],
        headingMessage: formatMessage((0, $gMHXs.default).spotlightHeading),
        contentMessage: formatMessage((0, $gMHXs.default).spotlightContent),
        image: (0, $hkYqK.ViewTooltipSvg)()
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iGBUU.PortalledNudge), {
        nudgeIdForAnalytics: (0, $dbbf68c32d8c4308$export$9749a972a54ad7ba),
        nudgeTargetId: (0, $dbbf68c32d8c4308$export$9749a972a54ad7ba),
        ...$bd4b1eeb51b614f4$var$nudgeSpotlightProps,
        hidden: isHidden,
        setHidden: hide,
        onOutsideClick: ()=>{
            if (!isModalClosed) return;
            hide();
        },
        spotlightCard: (0, $ajlSd.createOnboardingSpotlight)({
            ...onboardingSpotlightProps
        })
    });
};

});
parcelRegister("cZ5k3", function(module, exports) {

$parcel$export(module.exports, "POSITION_RIGHT", () => $450da094f06efa02$export$4ed9c122bcc20157);
$parcel$export(module.exports, "POSITION_BOTTOM", () => $450da094f06efa02$export$cec9b06edc71d96c);
$parcel$export(module.exports, "POSITION_TOP_START", () => $450da094f06efa02$export$3409cd2decbff80c);
$parcel$export(module.exports, "POSITION_TOP_END", () => $450da094f06efa02$export$1a430e6e8a1cbf17);
$parcel$export(module.exports, "POSITION_BOTTOM_START", () => $450da094f06efa02$export$663d1c5ad4215eb0);
$parcel$export(module.exports, "POSITION_BOTTOM_END", () => $450da094f06efa02$export$9c417155181792ae);
$parcel$export(module.exports, "POSITION_RIGHT_START", () => $450da094f06efa02$export$84a134a88de18270);
$parcel$export(module.exports, "POSITION_LEFT_START", () => $450da094f06efa02$export$b67243f02ceac890);
$parcel$export(module.exports, "POSITION_LEFT_END", () => $450da094f06efa02$export$9ed28c4aa79d6398);
$parcel$export(module.exports, "DEFAULT_SCROLL_TO_NUDGE", () => $450da094f06efa02$export$27ce92ea48cacd56);
const $450da094f06efa02$export$b0758137ee643e7 = 'left';
const $450da094f06efa02$export$4ed9c122bcc20157 = 'right';
const $450da094f06efa02$export$cec9b06edc71d96c = 'bottom';
const $450da094f06efa02$export$4fb34bdcd97adf85 = 'top';
const $450da094f06efa02$export$3409cd2decbff80c = 'top-start';
const $450da094f06efa02$export$1a430e6e8a1cbf17 = 'top-end';
const $450da094f06efa02$export$663d1c5ad4215eb0 = 'bottom-start';
const $450da094f06efa02$export$9c417155181792ae = 'bottom-end';
const $450da094f06efa02$export$84a134a88de18270 = 'right-start';
const $450da094f06efa02$export$b71f6a080452c5e8 = 'right-end';
const $450da094f06efa02$export$b67243f02ceac890 = 'left-start';
const $450da094f06efa02$export$9ed28c4aa79d6398 = 'left-end';
const $450da094f06efa02$export$27ce92ea48cacd56 = {
    scrollIntoViewOptions: {
        inline: 'end',
        behavior: 'smooth'
    }
};

});

parcelRegister("ajlSd", function(module, exports) {

$parcel$export(module.exports, "createOnboardingSpotlight", () => $208acef035d7cdaa$export$3de3bbc64fe39fe6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ao4Ml = parcelRequire("ao4Ml");

var $9yOBd = parcelRequire("9yOBd");
var $fVnbM = parcelRequire("fVnbM");

var $5ujeO = parcelRequire("5ujeO");

var $8Bc5A = parcelRequire("8Bc5A");

var $4R6GH = parcelRequire("4R6GH");
const $208acef035d7cdaa$var$NudgeHeading = ({ formattedMessage: formattedMessage })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$Title, {
        id: "nudge-spot-light-card-heading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$CustomHeading, null, formattedMessage));
const $208acef035d7cdaa$var$NudgeAction = ({ appearance: appearance, content: content, onClick: onClick })=>{
    // if appearance is primary, override styles with custom button
    // note CustomThemeButton is advised against and we need a better solution
    // (potentially even going with the blue button). Leaving this code for the experiment
    if (appearance === 'primary') {
        const customTheme = (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: `${"var(--ds-icon-discovery, #8270DB)"}`,
                    minWidth: '84px',
                    margin: `0 ${"var(--ds-space-050, 4px)"}`,
                    color: `${"var(--ds-text-inverse, #FFFFFF)"}`
                },
                spinnerStyles: spinnerStyles
            };
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
            appearance: appearance,
            onClick: onClick,
            theme: customTheme
        }, content);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: appearance,
        onClick: onClick
    }, content);
};
const $208acef035d7cdaa$var$NudgeActions = ({ actions: actions })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$Footer, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeAction, {
            key: index,
            ...action
        })));
const $208acef035d7cdaa$var$NudgeActionsNewAndImproved = ({ actions: actions, actionsBeforeElement: actionsBeforeElement })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$ActionsBeforeFooter, null, actionsBeforeElement || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$ActionWrapper, null, actions.map((action, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeAction, {
            key: index,
            ...action
        }))));
const $208acef035d7cdaa$export$3de3bbc64fe39fe6 = ({ actions: actions, contentMessage: contentMessage, headingMessage: headingMessage, image: image, width: width = (0, $8Bc5A.DEFAULT_NUDGE_WIDTH), CustomWrapper: CustomWrapper, actionsBeforeElement: actionsBeforeElement })=>{
    const Wrapper = CustomWrapper || $208acef035d7cdaa$var$SpotlightCardWrapper;
    return /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
            image: image,
            heading: headingMessage ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeHeading, {
                formattedMessage: headingMessage
            }) : null,
            width: width,
            ...!(0, $4R6GH.fg)('jfind-spotlight-step-counter-refactor') ? {
                actionsBeforeElement: actionsBeforeElement
            } : {}
        }, contentMessage, (0, $4R6GH.fg)('jfind-spotlight-step-counter-refactor') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeActionsNewAndImproved, {
            actions: actions,
            actionsBeforeElement: actionsBeforeElement
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($208acef035d7cdaa$var$NudgeActions, {
            actions: actions
        }))));
};
const $208acef035d7cdaa$export$cbbb2ee263b2a558 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ focusLock: focusLock, ...rest }, ref)=>{
    const Spotlight = $208acef035d7cdaa$export$3de3bbc64fe39fe6({
        ...rest
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ao4Ml.default), {
        disabled: !focusLock
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Spotlight, {
        ref: ref
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $208acef035d7cdaa$var$SpotlightCardWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_fkwn1bhr _tml11fxt _19yu1fxt",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$CustomHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nbxd _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$Footer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$ActionsBeforeFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o _ca0qu2gc",
            __cmplp.className
        ])
    });
});
const $208acef035d7cdaa$var$ActionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iGBUU", function(module, exports) {

$parcel$export(module.exports, "PortalledNudge", () => $12474d131146ee43$export$74f8d45d75dfda4f);

var $5uXOq = parcelRequire("5uXOq");

var $eX4sQ = parcelRequire("eX4sQ");

var $k5uoT = parcelRequire("k5uoT");

var $10xFf = parcelRequire("10xFf");

var $cSWNW = parcelRequire("cSWNW");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $12474d131146ee43$var$PortalledNudgeInternal = ({ onRender: onRender, nudgeTargetId: nudgeTargetId, nudgeIdForAnalytics: nudgeIdForAnalytics, analyticsAttributes: analyticsAttributes = {}, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onRenderNudge = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'nudgeSpotlightCard viewed', nudgeIdForAnalytics ?? nudgeTargetId, analyticsAttributes);
        if (onRender) onRender();
    }, [
        createAnalyticsEvent,
        nudgeIdForAnalytics,
        nudgeTargetId,
        analyticsAttributes,
        onRender
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eX4sQ.PortalledNudge), {
        onRender: onRenderNudge,
        nudgeTargetId: nudgeTargetId,
        zIndex: (0, $k5uoT.layers).dialog(),
        ...props
    });
};
const $12474d131146ee43$var$PortalledNudgeWithChoreograph = (0, $cSWNW.withChoreographedRender)($12474d131146ee43$var$PortalledNudgeInternal);
const $12474d131146ee43$export$74f8d45d75dfda4f = (props)=>{
    const { messageType: messageType, ...restProps } = props;
    const { nudgeTargetId: nudgeTargetId } = restProps;
    if ((0, $10xFf.shouldBeChoreographed)({
        messageType: messageType
    })) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12474d131146ee43$var$PortalledNudgeWithChoreograph, {
        messageId: nudgeTargetId,
        ...props
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($12474d131146ee43$var$PortalledNudgeInternal, restProps);
};

});
parcelRegister("eX4sQ", function(module, exports) {

$parcel$export(module.exports, "PortalledNudge", () => $b324ff99d51fd3d9$export$74f8d45d75dfda4f);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $fqbGj = parcelRequire("fqbGj");

var $9dZ1c = parcelRequire("9dZ1c");
/**
 * Creates a subscription into this component, that will return a boolean stating if
 * the HTML DOM node is associated with a given target ID.
 */ const $b324ff99d51fd3d9$var$useHasNudgeTargetNode = (id)=>{
    const controller = (0, $9dZ1c.useNudgeController)();
    const [hasRefValue, setHasRefValue] = (0, $5uXOq.useState)(!!controller.nudgeTargetsMap.get(id)?.current);
    (0, $5uXOq.useLayoutEffect)(()=>{
        setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        const unsubscribe = controller.subscribe(id, ()=>{
            setHasRefValue(!!controller.nudgeTargetsMap.get(id)?.current);
        });
        return ()=>{
            unsubscribe();
        };
    }, [
        controller,
        id
    ]);
    return hasRefValue;
};
/**
 * When the nudge is shown, get and track the rectangle of the target element.
 */ const $b324ff99d51fd3d9$var$useNudgeRectangle = (isShown, id, nudgeContainer)=>{
    const [innerRectangle, setInnerRectangle] = (0, $5uXOq.useState)(null);
    const frameId = (0, $5uXOq.useRef)(null);
    const controller = (0, $9dZ1c.useNudgeController)();
    const nudgeTarget = controller.nudgeTargetsMap.get(id)?.current;
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!isShown || !nudgeTarget || !nudgeContainer.current) {
            // Reset rectangle to eliminate risk of Spotlight rendering at
            // old position when nudge is e.g. hidden then shown in a different place.
            if (innerRectangle !== null) setInnerRectangle(null);
            return undefined;
        }
        // This is one approach to tracking the elements moving. See https://hello.atlassian.net/wiki/spaces/JST/pages/1759637849/Rendering+performance+Async+component+wrappers
        // for other options.
        const loop = ()=>{
            const targetRectangle = controller.nudgeTargetsMap.get(id)?.current?.getBoundingClientRect();
            if (!targetRectangle) return undefined;
            const newRectangle = {
                top: targetRectangle.top,
                left: targetRectangle.left,
                width: targetRectangle.width,
                height: targetRectangle.height
            };
            if (innerRectangle == null || innerRectangle.top !== newRectangle.top || innerRectangle.left !== newRectangle.left || innerRectangle.width !== newRectangle.width || innerRectangle.height !== newRectangle.height) setInnerRectangle(newRectangle);
            else frameId.current = requestAnimationFrame(loop);
        };
        frameId.current = requestAnimationFrame(loop);
        return ()=>{
            if (frameId.current != null) cancelAnimationFrame(frameId.current);
        };
    }, [
        isShown,
        nudgeContainer,
        innerRectangle,
        nudgeTarget,
        controller.nudgeTargetsMap,
        id
    ]);
    return innerRectangle;
};
/**
 * Create and append a DOM node to use for the nudge. This is on a separate root to the rest of the app.
 */ const $b324ff99d51fd3d9$var$usePortalContainer = ()=>{
    const nudgeContainer = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (!nudgeContainer.current) {
            nudgeContainer.current = document.createElement('div');
            document.body.appendChild(nudgeContainer.current);
        }
        return ()=>{
            if (nudgeContainer.current) document.body.removeChild(nudgeContainer.current);
        };
    }, []);
    return nudgeContainer;
};
const $b324ff99d51fd3d9$export$74f8d45d75dfda4f = (props)=>{
    const nudgeContainer = $b324ff99d51fd3d9$var$usePortalContainer();
    const hasRefValue = $b324ff99d51fd3d9$var$useHasNudgeTargetNode(props.nudgeTargetId);
    const innerRectangle = $b324ff99d51fd3d9$var$useNudgeRectangle(!props.hidden, props.nudgeTargetId, nudgeContainer);
    const innerRectanglePrevious = (0, $5uXOq.useRef)(innerRectangle);
    const spotlightRef = (0, $5uXOq.useRef)(null);
    // Force update the Popper spotlight when the innerRectangle (nudge position) changes
    (0, $5uXOq.useEffect)(()=>{
        if (innerRectangle !== null && innerRectanglePrevious.current !== innerRectangle && spotlightRef.current !== null) {
            innerRectanglePrevious.current = innerRectangle;
            if (spotlightRef.current.forceUpdateCardPosition) spotlightRef.current.forceUpdateCardPosition();
        }
    }, [
        innerRectangle
    ]);
    const hasNudgeTarget = hasRefValue;
    if (!nudgeContainer.current || !hasNudgeTarget || !innerRectangle) return null;
    return /*#__PURE__*/ (0, $7nsd3.createPortal)(/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            position: 'fixed',
            top: innerRectangle.top,
            left: innerRectangle.left,
            height: innerRectangle.height,
            width: innerRectangle.width,
            zIndex: props.zIndex
        },
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $fqbGj.NudgeSpotlight), {
            ...props,
            ref: spotlightRef,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                style: {
                    height: innerRectangle.height,
                    width: innerRectangle.width
                }
            })
        })
    }), nudgeContainer.current);
};

});
parcelRegister("fqbGj", function(module, exports) {

$parcel$export(module.exports, "NudgeSpotlight", () => $8ea39cee960047f1$export$eebbda33f5d4d735);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $jC4R5 = parcelRequire("jC4R5");

var $k8nZq = parcelRequire("k8nZq");

var $4oNEb = parcelRequire("4oNEb");

var $cBeZP = parcelRequire("cBeZP");

var $4AhK0 = parcelRequire("4AhK0");

var $4aeUu = parcelRequire("4aeUu");

var $ao4Ml = parcelRequire("ao4Ml");
const $8ea39cee960047f1$var$blinkNudge = (nudgeBlinkId, eventTarget, setAnimateIn)=>{
    const nudgeBlinkTriggers = Array.from(document.querySelectorAll(`[data-nudge-blink='${nudgeBlinkId}']`));
    const clickIsInsideTrigger = nudgeBlinkTriggers?.some((triggerElement)=>{
        return triggerElement && triggerElement.contains(eventTarget);
    });
    if (clickIsInsideTrigger) {
        // Blink the nudge
        setAnimateIn(true);
        return true;
    }
    return false;
};
const $8ea39cee960047f1$export$eebbda33f5d4d735 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hidden: externalHidden, setHidden: setHidden, hideNudgeOnClick: hideNudgeOnClick = true, hideSpotlightCardOnOutsideClick: hideSpotlightCardOnOutsideClick = true, concealSpotlightOnReferenceHidden: concealSpotlightOnReferenceHidden = false, showSpotlightCardOnFirstRender: showSpotlightCardOnFirstRender = true, children: children, spotlightCard: Spotlight = (0, $4AhK0.default), nudge: Nudge = (0, $jC4R5.DefaultNudge), position: position = 'bottom', offset: offset, zIndex: zIndex = 800, onRender: onRender, onShow: onShow, onHide: onHide, onClick: onClick, onOutsideClick: onOutsideClick, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor, pulseBorderRadius: pulseBorderRadius, nudgeBlinkId: nudgeBlinkId, nudgeTestId: nudgeTestId, nudgeTag: nudgeTag, headingId: headingId, ...spotlightCardProps }, nudgeSpotlightRef)=>{
    // Put all listeners inside a ref to avoid misfiring events
    // When the listener functions themselves change.
    const handlers = (0, $5uXOq.useRef)();
    handlers.current = {
        onRender: onRender,
        onHide: onHide,
        onShow: onShow,
        onClick: onClick,
        onOutsideClick: onOutsideClick
    };
    const nudgeRef = (0, $5uXOq.useRef)(null);
    const spotlightCardRef = (0, $5uXOq.useRef)(null);
    const showNudge = !externalHidden;
    const [canShowSpotlight, setCanShowSpotlight] = (0, $5uXOq.useState)(showSpotlightCardOnFirstRender);
    const [showSpotlight, setShowSpotlight] = (0, $5uXOq.useState)(false);
    const [shouldBlink, setShouldBlink] = (0, $5uXOq.useState)(false);
    const stopBlink = (0, $5uXOq.useCallback)(()=>setShouldBlink(false), []);
    const forceUpdateFnRef = (0, $5uXOq.useRef)({
        fn: ()=>{}
    });
    (0, $5uXOq.useImperativeHandle)(nudgeSpotlightRef, ()=>({
            toggleCardVisibility: setCanShowSpotlight,
            forceUpdateCardPosition: ()=>forceUpdateFnRef.current.fn()
        }), [
        setCanShowSpotlight
    ]);
    const markReadyToShow = (0, $5uXOq.useCallback)(()=>showNudge && setCanShowSpotlight(true), [
        showNudge
    ]);
    const onTargetClick = (0, $5uXOq.useCallback)((event)=>{
        if (!externalHidden) {
            if (hideNudgeOnClick) setHidden(event);
            handlers.current?.onClick?.();
        }
    }, [
        externalHidden,
        hideNudgeOnClick,
        setHidden,
        handlers
    ]);
    // Effect for show/hide the spotlight
    (0, $5uXOq.useEffect)(()=>{
        setShowSpotlight(showNudge && canShowSpotlight);
    }, [
        showNudge,
        canShowSpotlight
    ]);
    // Effect for onRender and onHide
    (0, $5uXOq.useEffect)(()=>{
        if (!externalHidden) {
            handlers.current?.onRender?.();
            return ()=>handlers.current?.onHide?.();
        }
    }, [
        externalHidden,
        handlers
    ]);
    // Effect for onShow
    (0, $5uXOq.useEffect)(()=>{
        if (showSpotlight) handlers.current?.onShow?.();
    }, [
        showSpotlight,
        handlers
    ]);
    // Effect to reset showSpotlightCardOnFirstRender when hidden
    (0, $5uXOq.useEffect)(()=>{
        if (externalHidden) setCanShowSpotlight(showSpotlightCardOnFirstRender);
    }, [
        externalHidden,
        showSpotlightCardOnFirstRender
    ]);
    // Effect to hide spotlight on outside click
    (0, $5uXOq.useEffect)(()=>{
        let unbind;
        let timeout;
        if (showSpotlight && hideSpotlightCardOnOutsideClick) timeout = window.setTimeout(()=>{
            unbind = (0, $cBeZP.bind)(window, {
                type: 'click',
                listener: (event)=>{
                    const eventTarget = event.target;
                    if (nudgeRef.current && spotlightCardRef.current && eventTarget instanceof Node && !nudgeRef.current.contains(eventTarget) && !spotlightCardRef.current.contains(eventTarget)) {
                        if (nudgeBlinkId) {
                            const didBlink = $8ea39cee960047f1$var$blinkNudge(nudgeBlinkId, eventTarget, setShouldBlink);
                            if (didBlink) return;
                        }
                        setCanShowSpotlight(false);
                        handlers.current?.onOutsideClick?.();
                        unbind?.();
                    }
                },
                options: {
                    capture: true,
                    passive: true
                }
            });
        });
        return ()=>{
            unbind?.();
            window.clearTimeout(timeout);
        };
    }, [
        showSpotlight,
        hideSpotlightCardOnOutsideClick,
        setHidden,
        handlers,
        nudgeBlinkId
    ]);
    const concealSpotlightOnScrollStyles = (isReferenceHidden)=>concealSpotlightOnReferenceHidden && isReferenceHidden ? {
            display: 'none'
        } : {};
    const cardConfig = (0, $5uXOq.useMemo)(()=>Spotlight === (0, $4AhK0.default) ? {
            ...spotlightCardProps,
            id: nudgeBlinkId
        } : {
            cardTestId: spotlightCardProps.cardTestId
        }, [
        Spotlight,
        spotlightCardProps,
        nudgeBlinkId
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)(Nudge, {
                ref: nudgeRef,
                hasPulse: showNudge,
                onClickCapture: onTargetClick,
                onMouseEnter: markReadyToShow,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor,
                pulseBorderRadius: pulseBorderRadius,
                nudgeTestId: nudgeTestId,
                tag: nudgeTag,
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    placement: position,
                    referenceElement: nudgeRef.current || undefined,
                    offset: offset,
                    children: ({ ref: ref, style: popperStyles, forceUpdate: forceUpdate, isReferenceHidden: isReferenceHidden })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $4aeUu.SpotlightContainer), {
                            showSpotlight: showSpotlight,
                            shouldBlink: shouldBlink,
                            stopBlink: stopBlink,
                            zIndex: zIndex,
                            ref: ref,
                            containerStyles: {
                                ...popperStyles,
                                ...concealSpotlightOnScrollStyles(isReferenceHidden)
                            },
                            role: "dialog",
                            ariaLabelledBy: headingId || 'nudge-spot-light-card-heading',
                            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $ao4Ml.default), {
                                children: [
                                    (forceUpdateFnRef.current.fn = forceUpdate) && null,
                                    /*#__PURE__*/ (0, $2OMIu.jsx)(Spotlight, {
                                        ...cardConfig,
                                        ref: spotlightCardRef
                                    })
                                ]
                            })
                        })
                })
            })
        ]
    });
});
var $8ea39cee960047f1$export$2e2bcd8739ae039 = $8ea39cee960047f1$export$eebbda33f5d4d735;

});
parcelRegister("jC4R5", function(module, exports) {

$parcel$export(module.exports, "DefaultNudge", () => $d88355bc6c5eb74c$export$b7d614104f4a4a7c);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5XLZB = parcelRequire("5XLZB");
const $d88355bc6c5eb74c$export$b7d614104f4a4a7c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, nudgeTestId: nudgeTestId, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $5XLZB.NudgeTooltipPulse), {
        ...rest,
        ref: ref,
        "data-testid": nudgeTestId,
        children: children
    }));

});
parcelRegister("5XLZB", function(module, exports) {

$parcel$export(module.exports, "NudgeTooltipPulse", () => $589071e97cffed79$export$2d11151259bb3b10);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $f8Sb3 = parcelRequire("f8Sb3");

var $k5uoT = parcelRequire("k5uoT");

var $VSDnB = parcelRequire("VSDnB");
function $589071e97cffed79$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $589071e97cffed79$var$baseShadow = '0 0 0 3px';
const $589071e97cffed79$var$basePulseColor = `var(--ds-border-accent-purple, ${(0, $829f609a65d26a98$exports).P75})`;
const $589071e97cffed79$var$basePulseShadowColor = "var(--ds-border-accent-purple, rgba(101, 84, 192, 1))";
const $589071e97cffed79$var$easing = 'cubic-bezier(0.55, 0.055, 0.675, 0.19)';
const $589071e97cffed79$var$pulseAnimation = /*#__PURE__*/ (0, $f8Sb3.css)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
    '@keyframes pulseKeyframes': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '0%': {
            opacity: 0
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '50%': {
            opacity: 1
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '100%': {
            opacity: 0
        }
    },
    animationName: 'pulseKeyframes',
    animationDuration: '3000ms',
    animationTimingFunction: $589071e97cffed79$var$easing,
    animationIterationCount: 'infinite'
});
const $589071e97cffed79$var$pseudoStyle = {
    name: "24nntw",
    styles: "content:'';position:absolute;top:0;left:0;width:100%;height:100%"
};
const $589071e97cffed79$export$814d9bf8c56ac913 = ({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius, pulseColor: pulseColor, pulseShadowColor: pulseShadowColor })=>/*#__PURE__*/ (0, $f8Sb3.css)({
        display: 'block',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
        '> *': {
            position: 'relative',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::before': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}`,
                    opacity: hasPulse ? 1 : 0,
                    transition: 'opacity 0.1s ease-in-out',
                    pointerEvents: 'none'
                }
            ],
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
            '&::after': [
                $589071e97cffed79$var$pseudoStyle,
                {
                    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
                    borderRadius: `${pulseBorderRadius}px`,
                    boxShadow: `${$589071e97cffed79$var$baseShadow} ${pulseColor}, 0 0 11px ${pulseShadowColor}`,
                    opacity: 0,
                    pointerEvents: 'none'
                },
                hasPulse && $589071e97cffed79$var$pulseAnimation
            ]
        }
    });
const $589071e97cffed79$export$2d11151259bb3b10 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ hasPulse: hasPulse, pulseBorderRadius: pulseBorderRadius = (0, $k5uoT.borderRadius)(), pulseColor: pulseColor = $589071e97cffed79$var$basePulseColor, pulseShadowColor: pulseShadowColor = $589071e97cffed79$var$basePulseShadowColor, tag: TargetContainer = 'span', ...rest }, ref)=>{
    // Doing a cast because typescript is struggling to narrow the type
    const CastTargetContainer = TargetContainer;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(CastTargetContainer, {
        css: [
            $589071e97cffed79$export$814d9bf8c56ac913({
                hasPulse: hasPulse,
                pulseBorderRadius: pulseBorderRadius,
                pulseColor: pulseColor,
                pulseShadowColor: pulseShadowColor
            }),
            (0, $VSDnB.fg)('jira_onboarding_experiences_a11y_fixes') && $589071e97cffed79$var$inHeritWidthStyles
        ],
        ref: ref,
        ...rest
    });
});
const $589071e97cffed79$var$inHeritWidthStyles = {
    name: "6n1ert",
    styles: "width:inherit"
};

});


parcelRegister("4AhK0", function(module, exports) {

$parcel$export(module.exports, "default", () => $b690ab706aa80c88$export$2e2bcd8739ae039);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $5uXOq = parcelRequire("5uXOq");


var $f8Sb3 = parcelRequire("f8Sb3");
function $b690ab706aa80c88$var$_EMOTION_STRINGIFIED_CSS_ERROR__() {
    return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop).";
}
const $b690ab706aa80c88$var$borderRadius = 3;
const $b690ab706aa80c88$var$containerStyles = {
    color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
    boxShadow: `var(--ds-shadow-overlay, ${`0 4px 8px -2px ${(0, $829f609a65d26a98$export$7d3359664e8bb0e5)}, 0 0 1px ${(0, $829f609a65d26a98$export$d2d3bedfb276cac0)}`})`,
    backgroundColor: `var(--ds-background-discovery-bold, ${(0, $829f609a65d26a98$export$b48405b95304b5a1)})`,
    borderRadius: `${$b690ab706aa80c88$var$borderRadius}px`,
    overflow: 'auto'
};
const $b690ab706aa80c88$var$bodyStyles = {
    display: 'flex',
    flexDirection: 'column',
    padding: `${"var(--ds-space-200, 16px)"} ${"var(--ds-space-250, 20px)"}`
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$headingStyles = {
    name: "1m05p0r",
    styles: "font-size:1.42857em;font-style:inherit;line-height:1.2;font-weight:var(--ds-font-weight-medium, 500);margin-top:28px;color:inherit;&:first-child{margin-top:0;}"
};
const $b690ab706aa80c88$var$headerStyles = {
    display: 'flex',
    paddingBottom: "var(--ds-space-100, 8px)",
    alignItems: `baseline`,
    justifyContent: `space-between`
};
const $b690ab706aa80c88$var$footerStyles = {
    display: 'flex',
    paddingTop: "var(--ds-space-100, 8px)",
    alignItems: 'center',
    justifyContent: 'space-between'
};
// eslint-disable-next-line @atlaskit/design-system/ensure-design-token-usage
const $b690ab706aa80c88$var$actionItemStyles = (index)=>/*#__PURE__*/ (0, $f8Sb3.css)({
        margin: `0 ${"var(--ds-space-050, 4px)"}`,
        cursor: 'pointer',
        alignItems: 'baseline',
        borderWidth: '0px',
        borderRadius: '3px',
        boxSizing: 'border-box',
        display: 'inline-flex',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography -- TODO: https://product-fabric.atlassian.net/browse/PYX-881
        fontSize: 'inherit',
        fontStyle: 'normal',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        fontFamily: 'inherit',
        fontWeight: "var(--ds-font-weight-medium, 500)",
        maxWidth: '100%',
        position: 'relative',
        textAlign: 'center',
        textDecoration: 'none',
        transition: 'background 0.1s ease-out 0s, box-shadow 0.15s cubic-bezier(0.47, 0.03, 0.49, 1.38) 0s',
        whiteSpace: 'nowrap',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        background: index ? `var(--ds-background-discovery-bold, ${0, $829f609a65d26a98$export$b48405b95304b5a1})` : `var(--ds-background-inverse-subtle, ${0, $829f609a65d26a98$export$c71e4279dd54a18d})`,
        height: '2.28571em',
        // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
        lineHeight: '2.28571em',
        padding: '0px 10px',
        verticalAlign: 'middle',
        width: 'auto',
        justifyContent: 'center',
        color: `var(--ds-text-inverse, ${(0, $829f609a65d26a98$export$29a4f05edc054374)})`,
        '&:hover': {
            backgroundColor: `var(--ds-interaction-hovered, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        },
        '&:active': {
            backgroundColor: `var(--ds-interaction-pressed, ${(0, $829f609a65d26a98$export$a7175d4e9206bc80)})`
        }
    });
const $b690ab706aa80c88$var$ActionItem = ({ index: index, ...rest })=>/*#__PURE__*/ (0, $f8Sb3.jsx)("button", {
        css: $b690ab706aa80c88$var$actionItemStyles(index),
        ...rest
    });
const $b690ab706aa80c88$var$actionItemContainerStyles = {
    display: 'flex',
    margin: `${"var(--ds-space-negative-050, -4px)"}`,
    flexDirection: 'row-reverse'
};
const $b690ab706aa80c88$export$b3ae98194e057550 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ image: image, heading: heading, actions: actions, actionsBeforeElement: actionsBeforeElement, width: width = 300, cardTestId: cardTestId, content: content, id: id }, ref)=>{
    const renderedActions = (0, $5uXOq.useMemo)(()=>actions?.map(({ text: text, onClick: onClick }, index)=>/*#__PURE__*/ (0, $f8Sb3.jsx)($b690ab706aa80c88$var$ActionItem, {
                index: index,
                onClick: onClick,
                key: `${text}-${index}`
            }, text)), [
        actions
    ]);
    const renderHeader = !!heading;
    const renderFooter = !!actionsBeforeElement || !!actions;
    return /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        ref: ref,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: {
            ...$b690ab706aa80c88$var$containerStyles,
            width: `${width}px`
        },
        "data-testid": cardTestId
    }, typeof image === 'string' ? /*#__PURE__*/ (0, $f8Sb3.jsx)("img", {
        src: image,
        alt: ""
    }) : image, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$bodyStyles,
        id: id
    }, renderHeader && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$headerStyles
    }, /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        id: "nudge-spot-light-card-heading",
        css: $b690ab706aa80c88$var$headingStyles
    }, heading)), content, renderFooter && // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$footerStyles
    }, actionsBeforeElement || /*#__PURE__*/ (0, $f8Sb3.jsx)("span", null), /*#__PURE__*/ (0, $f8Sb3.jsx)("div", {
        style: $b690ab706aa80c88$var$actionItemContainerStyles
    }, renderedActions))));
});
var $b690ab706aa80c88$export$2e2bcd8739ae039 = $b690ab706aa80c88$export$b3ae98194e057550;

});

parcelRegister("4aeUu", function(module, exports) {

$parcel$export(module.exports, "SpotlightContainer", () => $99a240fc01f7ca0b$export$d0f55839b708c0a0);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $ahdj0 = parcelRequire("ahdj0");

var $k8nZq = parcelRequire("k8nZq");
const $99a240fc01f7ca0b$export$474e8ee88cc7cd8f = 200;
const $99a240fc01f7ca0b$export$3d6f334bf7dc4597 = 120;
const $99a240fc01f7ca0b$var$defaultTransitionStyles = {
    opacity: 0,
    transitionProperty: 'opacity',
    transitionTimingFunction: 'ease-in-out',
    transitionDuration: `${$99a240fc01f7ca0b$export$474e8ee88cc7cd8f}ms`
};
const $99a240fc01f7ca0b$var$statefulTransitionStyles = {
    entering: {},
    entered: {
        opacity: 1
    },
    exiting: {
        transitionDuration: `${$99a240fc01f7ca0b$export$3d6f334bf7dc4597}ms`,
        opacity: 0
    },
    exited: {},
    unmounted: {}
};
const $99a240fc01f7ca0b$var$timeoutDurations = {
    enter: 0,
    exit: $99a240fc01f7ca0b$export$3d6f334bf7dc4597
};
const $99a240fc01f7ca0b$export$d0f55839b708c0a0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ containerStyles: containerStyles, showSpotlight: showSpotlight, shouldBlink: shouldBlink, zIndex: zIndex, stopBlink: stopBlink, ariaLabelledBy: ariaLabelledBy, ...rest }, ref)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $ahdj0.default), {
        appear: true,
        in: showSpotlight && !shouldBlink,
        timeout: $99a240fc01f7ca0b$var$timeoutDurations,
        onExited: stopBlink,
        unmountOnExit: !shouldBlink,
        children: (state)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $k8nZq.default), {
                zIndex: zIndex,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    style: {
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...containerStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$99a240fc01f7ca0b$var$defaultTransitionStyles,
                        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                        ...$99a240fc01f7ca0b$var$statefulTransitionStyles[state]
                    },
                    ref: ref,
                    "aria-labelledby": ariaLabelledBy,
                    ...rest
                })
            })
    }));

});




parcelRegister("hkYqK", function(module, exports) {

$parcel$export(module.exports, "ViewTooltipSvg", () => $1ad364a9db6c1b55$export$d4e6a9d2e665cf2);

var $5uXOq = parcelRequire("5uXOq");
const $1ad364a9db6c1b55$export$d4e6a9d2e665cf2 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "320",
        height: "161",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#a)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 0h320v161H0V0Z",
        fill: "#F7F8F9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#b)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M320 0H0v230.761h320V0Z",
        fill: "#C97CF4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
        id: "c",
        maskUnits: "userSpaceOnUse",
        x: "0",
        y: "0",
        width: "320",
        height: "231"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M320 0H0v230.761h320V0Z",
        fill: "#fff"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        mask: "url(#c)",
        strokeWidth: "1.803",
        strokeMiterlimit: "10"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m36.27 60.944-4.365 98.603 335.128 166.326 4.947-111.748L36.27 60.945ZM76.568-1.634c.658-3.682 1.003-7.599 1.003-11.743 0-4.203-.347-8.171-1.017-11.9-3.982-22.198-19.398-35.884-41.018-39.408-3.69-.602-7.559-.91-11.583-.913-4.199 0-8.226.332-12.061.972-21.638 3.605-37.032 17.248-41.034 39.319-.677 3.73-1.028 7.698-1.03 11.9 0 4.143.342 8.06 1.003 11.744 3.961 22.046 19.362 35.72 41.034 39.342 3.835.64 7.86.976 12.06.976 4.026 0 7.895-.307 11.584-.904C57.167 34.236 72.604 20.534 76.57-1.634h-.002Z",
        stroke: "#D8A0F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.944 52.257c-27.14-4.284-59.155-14.132-83.906-30.504l-10.044 63.635c27.484 17.287 61.52 26.493 89.596 30.923 98.28 15.511 168.622-20.036 195.245-96.273L123.597 8.164C106.003 44.047 68.881 61.873 7.944 52.254v.003ZM267.923-35.671c-27.139-4.284-59.155-14.132-83.905-30.504L173.974-2.537c27.484 17.286 61.519 26.492 89.596 30.922C361.85 43.896 432.192 8.35 458.815-67.887l-75.239-11.874c-17.593 35.883-54.715 53.708-115.653 44.09Z",
        stroke: "#D8A0F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M219.806-18.698v141.359h61.273V-18.697h-61.273Z",
        stroke: "#D8A0F7"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M219.804 18.28v-36.975h61.273v49.44",
        stroke: "#BF63F3"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m36.645 60.126-1.215-.554-2.612 58.999c.602.034 1.201.066 1.8.097l2.495-56.347 88.584 40.419c.665-.317 1.327-.637 1.985-.964.039-.018.077-.039.115-.059l-91.153-41.59Z",
        fill: "#BF63F3"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M281.979 29.819c-.6-.057-1.202-.118-1.803-.18v1.813c.601.061 1.203.118 1.803.174v-1.81.003ZM220.705 17.505c-.599-.189-1.201-.383-1.803-.577v1.896c.602.193 1.204.383 1.803.572V17.505Z",
        fill: "#D8A0F7"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M33 23.889h222.867v153.1H33z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F7F8F9",
        d: "M46.507 37.396h50.809v18.476H46.507z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M100.693 37.396h68.13v18.476h-68.13z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M172.2 43.257h20.261v6.754H172.2zM195.838 43.257h20.261v6.754h-20.261zM219.475 43.257h20.261v6.754h-20.261zM46.507 60.937h60.782v102.545H46.507z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M49.884 64.314H85.68v4.619H49.884v-4.62Z",
        fill: "#D9D9D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M49.884 72.31h54.028v27.013H49.884z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M54.949 77.375h47.345v2.309H54.949z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#82B536",
        d: "M54.949 89.193h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M49.884 102.701h54.028v27.014H49.884z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M54.949 107.766h47.345v2.309H54.949z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#82B536",
        d: "M54.949 119.584h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M49.884 133.091h54.028v27.014H49.884z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M54.949 138.157h47.345v2.309H54.949z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFA900",
        d: "M54.949 149.975h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M114.043 60.937h60.782v102.545h-60.782z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M117.42 64.314h35.797v4.619H117.42v-4.62Z",
        fill: "#D9D9D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M117.42 72.31h54.028v27.013H117.42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M122.485 77.375h47.345v2.309h-47.345z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#0C66E4",
        d: "M122.485 89.193h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M117.42 102.701h54.028v27.014H117.42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M122.485 107.766h47.345v2.309h-47.345z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#0C66E4",
        d: "M122.485 119.584h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M117.42 133.091h54.028v27.014H117.42z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M122.485 138.157h47.345v2.309h-47.345z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#82B536",
        d: "M122.485 149.975h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M181.578 60.937h60.782v102.545h-60.782z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M184.955 64.314h35.797v4.619h-35.797v-4.62Z",
        fill: "#D9D9D9"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M184.955 72.31h54.028v27.013h-54.028z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M190.02 77.375h47.345v2.309H190.02z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#82B536",
        d: "M190.02 89.193h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M204.723 108.09h16.884v16.884h-16.884z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M213.798 115.899v-5.276h-1.267v5.276h-5.276v1.266h5.276v5.276h1.267v-5.276h5.276v-1.266h-5.276Z",
        fill: "#F1F2F4"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M184.955 133.091h54.028v27.014h-54.028z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "M190.02 138.157h47.345v2.309H190.02z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#0C66E4",
        d: "M190.02 149.975h6.754v6.754h-6.754z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M221.76 126.193c-.724-1.475-1.281-3.14-2.004-4.776l.504.277c.339.178.669.376.999.582l.261.161.275.135.561.266c.192.083.379.177.578.237.202.059.407.108.615.152.006-.113.079-.185.115-.118l-.047.131c.293-.008.539.048.78.074.238.027.458.07.68.109.22.034.439.074.666.056.229-.023.468-.082.724-.198 0 0-.119.178-.121.183 1.753-.003 3.813-.361 5.715-1.203a13.694 13.694 0 0 0 4.819-3.515h-.029l-.009-.021c-.084.036-.224.132-.391.243-.174.106-.376.233-.564.353l-.496.328c-.133.085-.221.13-.221.13.139-.305.295-.589.514-.812.212-.23.466-.419.712-.625.253-.202.528-.391.783-.597a5.46 5.46 0 0 0 .674-.696l.135.116a5.59 5.59 0 0 0-.69 1.06c.757-.668 1.795-1.829 2.502-3.192.729-1.348 1.158-2.832 1.242-3.813-.145.016-.011.675-.477.703.121-.475.202-.957.266-1.412.285.053.143.302.185.362.055-.093.154-.426.279-.94.07-.255.088-.563.134-.903.018-.172.042-.351.061-.54.011-.189.007-.385.01-.592.001-.408.015-.845-.056-1.296-.054-.45-.096-.922-.227-1.389l-.174-.708c-.056-.239-.162-.462-.242-.691-.089-.23-.173-.458-.26-.685-.094-.223-.216-.435-.326-.647-.882-1.702-2.09-3.006-2.918-3.574-.817-.601-1.139-.622-.673.259l-.171.043c.158.18.312.35.462.521.149.168.291.338.404.529.23.38.476.758.634 1.242.096.099.08.13.203.042.04.016.11.044.15-.006.287-.219.346.126.432.233-.263.119-.293.342-.193.608.094.273.272.617.514.955.061.086.121.171.187.259.054.088.109.18.159.27.112.179.217.349.312.506.208.307.324.575.341.683-.249.113-.204.316-.115.529.09.213.226.448.123.594-.023-.015-.155-.104-.18-.114-.076.074-.044.344.038.696.034.179.108.374.135.584.036.212.073.426.107.634.088.415.088.797.067 1-.024.207-.092.232-.237-.044-.101.268-.152.549-.262.834-.102.285-.197.58-.283.884-.226.596-.431 1.234-.718 1.873-.545 1.286-1.269 2.627-2.204 3.848-.932 1.218-2.074 2.308-3.302 3.089-.314.181-.612.385-.93.527-.319.143-.629.286-.938.404-.318.096-.627.182-.925.258-.299.072-.606.086-.886.114l.051.053c-.041-.008-.138.054-.183-.014-.177.186-.558.338-.89.478a6.763 6.763 0 0 1-.437.163l-.187.046-.624.181-.317.088-.322.057-.361-.036c-.222-.018-.532-.031-.861-.09a7.596 7.596 0 0 0-.513-.055c-.175-.013-.349-.018-.514-.047-.334-.04-.65-.047-.903.007-.278-.073-.532-.217-.797-.319-.261-.12-.534-.202-.777-.359-.348-.199-1.667-.799-2.578-1.262.931-.672 3.646-.932 4.14-1.744l1.35-.178c.791-.214 1.007-1.978-.23-1.601-2.156.727-5.142.706-6.949 2.574l.022.003s-.464.306-.47.234c-.199.241-.353.638-.353.638-.113 1.06.982 2.654 1.676 3.02-.248.038 2.829 5.395 3.238 3.591l.001.003Z",
        fill: "#101214"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "m225.817 78.054 63.459-6.2 3.039 31.106-63.46 6.199z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        stroke: "#F0F1F2",
        strokeWidth: "1.255",
        d: "m225.817 78.054 63.459-6.2 3.039 31.106-63.46 6.199z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#F1F2F4",
        d: "m231.791 82.964 39.182-3.812.186 1.91-39.182 3.813z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#FFA900",
        d: "m233.173 97.119 8.089-.79.79 8.088-8.089.79z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M0 0h320v161H0z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "b"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#fff",
        d: "M0 0h320v230.763H0z"
    }))));

});

parcelRegister("gMHXs", function(module, exports) {

$parcel$export(module.exports, "default", () => $78ef2a6e39111a7c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $78ef2a6e39111a7c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    spotlightHeading: {
        "id": "software-onboarding-nudges--next.sample-project-data.spotlight-heading",
        "defaultMessage": "Let\u2019s start with your tasks"
    },
    spotlightContent: {
        "id": "software-onboarding-nudges--next.sample-project-data.spotlight-content",
        "defaultMessage": "We\u2019ve created some starter tasks for you. Make them your own, or create a blank task to start tracking your work in Jira."
    },
    spotlightDismissAction: {
        "id": "software-onboarding-nudges--next.sample-project-data.spotlight-dismiss-action",
        "defaultMessage": "Dismiss"
    },
    spotlightCtaAction: {
        "id": "software-onboarding-nudges--next.sample-project-data.spotlight-cta-action",
        "defaultMessage": "View task"
    }
});

});



parcelRegister("cZdmg", function(module, exports) {

$parcel$export(module.exports, "useScreenReader", () => $787d17f41ff0d006$export$4641ed6a3a6bab38);
$parcel$export(module.exports, "ScreenReaderProvider", () => $787d17f41ff0d006$export$1f8a68f8ff4b88c2);

var $5uXOq = parcelRequire("5uXOq");
const $787d17f41ff0d006$var$ScreenReaderContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    screenReaderText: '',
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setScreenReaderText: ()=>{}
});
const $787d17f41ff0d006$export$4641ed6a3a6bab38 = ()=>(0, $5uXOq.useContext)($787d17f41ff0d006$var$ScreenReaderContext);
const $787d17f41ff0d006$export$1f8a68f8ff4b88c2 = ({ children: children })=>{
    const [screenReaderText, setScreenReaderTextState] = (0, $5uXOq.useState)('');
    const setScreenReaderText = (message)=>{
        setScreenReaderTextState('');
        setTimeout(()=>setScreenReaderTextState(message), 100);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($787d17f41ff0d006$var$ScreenReaderContext.Provider, {
        value: {
            screenReaderText: screenReaderText,
            setScreenReaderText: setScreenReaderText
        }
    }, children);
};

});

parcelRegister("1DV2S", function(module, exports) {

$parcel$export(module.exports, "default", () => $34bb2b89537ef497$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");



var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $gcoP6 = parcelRequire("gcoP6");

var $9UXXB = parcelRequire("9UXXB");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $59p3c = parcelRequire("59p3c");

var $5mTgl = parcelRequire("5mTgl");

var $23uyL = parcelRequire("23uyL");
const $34bb2b89537ef497$export$c31df4bd766f9c35 = ()=>{
    const getIssueEntries = (0, $5mTgl.makeGetIssueEntriesForColumnSelector)();
    return (state, { swimlaneId: swimlaneId, column: column, columnIndex: columnIndex, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel })=>{
        const features = (0, $59p3c.getPlatformFeatures)(state);
        const permissions = (0, $1vXOx.getPermissionsSelector)(state);
        const issueEntries = getIssueEntries(state, {
            swimlaneId: swimlaneId,
            columnId: column.id,
            isUnscheduledWorkColumn: isUnscheduledWorkColumnPanel
        });
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const isDropCardInstantlyBounceBackEnabled = isCMPBoard && (0, $45cXl.hasSwimlanes)(state);
        return {
            isBoardEmpty: (0, $k8auG.isBoardEmptySelector)(state),
            isDoneCardsButtonVisible: (0, $5mTgl.getBoardHasFilteredIssues)(state),
            isSprintsEnabled: features[0, $b2dceb3b951c6bc2$export$c298045b43b64630] || false,
            isUserAtLeastMember: (0, $k8auG.isUserAtLeastMemberOfProject)(state),
            canEditBoard: (permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] || false) && !isCMPBoard,
            issueEntries: issueEntries,
            isCMPKanbanBoard: isCMPBoard && (0, $67Z81.getBoardType)(state) === 'KANBAN',
            isCMPBoard: isCMPBoard,
            isColumnIccEnabled: (0, $9UXXB.isIccEnabledForColumnOrSwimlane)(state, swimlaneId, column.id),
            isDropCardInstantlyBounceBackEnabled: isDropCardInstantlyBounceBackEnabled,
            placeholderType: (0, $gcoP6.makeShowPlaceHolderSelector)(state)(columnIndex)
        };
    };
};
const $34bb2b89537ef497$var$ColumnConnected = (0, $bC2fB.connect)($34bb2b89537ef497$export$c31df4bd766f9c35, {})((0, $23uyL.default));
var $34bb2b89537ef497$export$2e2bcd8739ae039 = $34bb2b89537ef497$var$ColumnConnected;

});
const $b2dceb3b951c6bc2$export$c298045b43b64630 = 'IS_SPRINTS_ENABLED';
const $b2dceb3b951c6bc2$export$18bf536c6eb8b5b2 = 'IS_POLLING_ENABLED';
const $b2dceb3b951c6bc2$export$1aba2b155ad227f8 = 'IS_CARD_MEDIA_SWITCH_ENABLED';

parcelRegister("gcoP6", function(module, exports) {

$parcel$export(module.exports, "NO_ACTIVE_SPRINT_PLACEHOLDER", () => $377259b9e292890c$export$4a8150e8503dbe2d);
$parcel$export(module.exports, "NO_PLACEHOLDER", () => $377259b9e292890c$export$fcfc126393e31487);
$parcel$export(module.exports, "makeShowPlaceHolderSelector", () => $377259b9e292890c$export$6b890dc22b669e50);

var $dGvGJ = parcelRequire("dGvGJ");

var $gJBT6 = parcelRequire("gJBT6");

var $k8auG = parcelRequire("k8auG");

var $9UXXB = parcelRequire("9UXXB");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");
const $377259b9e292890c$export$4a8150e8503dbe2d = 'NO_ACTIVE_SPRINT';
const $377259b9e292890c$export$770895c648f5e479 = 'CMP_EMPTY_KANBAN';
const $377259b9e292890c$export$fcfc126393e31487 = 'NONE';
const $377259b9e292890c$export$6b890dc22b669e50 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getBoardType),
    (0, $k8auG.isBoardEmptySelector),
    (0, $9UXXB.hasInlineCardCreateConfig),
    (0, $ebHh7.hasNoActiveSprintStateSelector)
], (isCMPBoard, boardType, isBoardEmpty, hasInlineCardCreate, hasNoActiveSprint)=>{
    const makeShowPlaceholder = (columnIndex)=>{
        const isCMPKanbanBoard = isCMPBoard && boardType === 'KANBAN';
        const isFirstColumn = columnIndex === 0;
        if (!isFirstColumn) return $377259b9e292890c$export$fcfc126393e31487;
        if (isCMPKanbanBoard) return isBoardEmpty && !hasInlineCardCreate ? $377259b9e292890c$export$770895c648f5e479 : $377259b9e292890c$export$fcfc126393e31487;
        return hasNoActiveSprint ? $377259b9e292890c$export$4a8150e8503dbe2d : $377259b9e292890c$export$fcfc126393e31487;
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))(makeShowPlaceholder);
});

});

parcelRegister("59p3c", function(module, exports) {

$parcel$export(module.exports, "getPlatformFeatures", () => $bf8d0a87725f714b$export$a1ed8f6fbe38c842);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");


var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");
const $bf8d0a87725f714b$export$a1ed8f6fbe38c842 = (0, $dGvGJ.createSelector)([
    (0, $ebHh7.isSprintsEnabled),
    (0, $5mTgl.isCardMediaAvailable)
], (isSprintsFeatureEnabled, isAnyCardMediaAvailable)=>(0, $7uUwQ.freeze)({
        [(0, $b2dceb3b951c6bc2$export$c298045b43b64630)]: isSprintsFeatureEnabled,
        [(0, $b2dceb3b951c6bc2$export$18bf536c6eb8b5b2)]: true,
        [(0, $b2dceb3b951c6bc2$export$1aba2b155ad227f8)]: isAnyCardMediaAvailable
    }));

});

parcelRegister("23uyL", function(module, exports) {

$parcel$export(module.exports, "default", () => $a12eb39f16847da5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $7iJwP = parcelRequire("7iJwP");

var $4R6GH = parcelRequire("4R6GH");

var $4jAPy = parcelRequire("4jAPy");

var $3eGwD = parcelRequire("3eGwD");

var $lmBAt = parcelRequire("lmBAt");


var $67sX6 = parcelRequire("67sX6");

var $gcoP6 = parcelRequire("gcoP6");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $drQJq = parcelRequire("drQJq");

var $g94HQ = parcelRequire("g94HQ");

var $5nhUs = parcelRequire("5nhUs");

var $dRpFy = parcelRequire("dRpFy");

var $iTH7p = parcelRequire("iTH7p");

var $50AZv = parcelRequire("50AZv");

var $lBRY4 = parcelRequire("lBRY4");

var $hXOH1 = parcelRequire("hXOH1");

var $2lkEP = parcelRequire("2lkEP");

var $aXl6d = parcelRequire("aXl6d");

var $7p3wz = parcelRequire("7p3wz");
const $a12eb39f16847da5$var$EMPTY_ARRAY = [];
const $a12eb39f16847da5$var$Column = ({ column: column, columnIndex: columnIndex, swimlaneId: swimlaneId, isLastSwimlane: isLastSwimlane, isSprintsEnabled: isSprintsEnabled, isBoardEmpty: isBoardEmpty, isDoneCardsButtonVisible: isDoneCardsButtonVisible, isUserAtLeastMember: isUserAtLeastMember, canEditBoard: canEditBoard, useVirtualisation: useVirtualisation, issueEntries: issueEntries = [], dropZoneType: dropZoneType, offsetTop: offsetTop, isCMPKanbanBoard: isCMPKanbanBoard, isCMPBoard: isCMPBoard, isColumnIccEnabled: isColumnIccEnabled, placeholderType: placeholderType, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel })=>{
    // We use the ref of the header to make sure ICC doesn't render if it's under the header.
    const headerRef = (0, $5uXOq.useRef)(null);
    const { id: id, isInitial: isInitial, isDone: isDone, limitJql: limitJql, name: name } = column;
    const [menusShown, setMenusShowns] = (0, $5uXOq.useState)({});
    const setMenuVisibility = (columnId)=>(visible)=>{
            setMenusShowns({
                [columnId]: visible
            });
        };
    const MAX_CARDS_TO_SHOW_ICC_NUDGE = 3;
    const isIncrementPlanningBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const issuesWithIssueLinksIds = (0, $67sX6.useBoardSelector)((state)=>isIncrementPlanningBoard ? (0, $5mTgl.getIssuesWithIssueLinksInBoardIds)(state) : $a12eb39f16847da5$var$EMPTY_ARRAY);
    const openInitialColumnIcc = isInitial && isBoardEmpty && isColumnIccEnabled;
    const showDoneCardsButtonCMP = isCMPKanbanBoard && isLastSwimlane && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(limitJql);
    const showDoneCardsButtonTMP = isDone && !isSprintsEnabled && isLastSwimlane && isDoneCardsButtonVisible;
    const showDoneCardsButton = isCMPBoard ? showDoneCardsButtonCMP : showDoneCardsButtonTMP;
    const canShowIccNudgeInBoard = isInitial && issueEntries.length > MAX_CARDS_TO_SHOW_ICC_NUDGE;
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const hasGrouping = (0, $aXl6d.useHasGroupingStyle)();
    const renderCardFunction = (0, $5uXOq.useCallback)((issueEntry, index, isScrolling, onResizeCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cardOffsetTop)=>{
        const userCanViewMenu = canEditBoard || isUserAtLeastMember;
        if ((0, $3eGwD.isIssueEntryGroup)(issueEntry)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g94HQ.default), {
            key: issueEntry.issueIds.toString(),
            index: index,
            issueIdGroup: issueEntry,
            canShowIccNudge: false,
            columnId: id,
            isColumnIccEnabled: isColumnIccEnabled,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            userCanViewMenu: userCanViewMenu,
            onIssueChange: onResizeCallback,
            isScrolling: isScrolling,
            headerRef: headerRef,
            offsetTop: cardOffsetTop
        });
        const isIssueIdValid = (0, $3eGwD.getIsIssueIdValid)(issueEntry.issueId);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQJq.default), {
            key: issueEntry.issueId,
            id: issueEntry.issueId,
            canShowIccNudge: canShowIccNudgeInBoard,
            columnId: id,
            index: index,
            isColumnIccEnabled: isColumnIccEnabled,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            userCanViewMenu: userCanViewMenu && isIssueIdValid,
            onIssueChange: onResizeCallback,
            isScrolling: isScrolling,
            headerRef: headerRef
        });
    }, [
        canEditBoard,
        id,
        isColumnIccEnabled,
        isLastSwimlane,
        isUserAtLeastMember,
        swimlaneId,
        canShowIccNudgeInBoard
    ]);
    // Please make any changes to the `header` component below on line 167-197
    // This header is for an experiment and not for integrating production feature.
    const header = (0, $5uXOq.useMemo)(()=>{
        if (isIPBoard && swimlaneId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "program-swimlane-column-header",
            packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
            sendToPrivacyUnsafeSplunk: true,
            teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXOH1.default), {
            swimlaneId: swimlaneId,
            columnId: id,
            count: issueEntries.length,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
            ref: headerRef
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRpFy.default), {
            id: id,
            isMenuShown: menusShown[id],
            menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTH7p.default), {
                columnId: id,
                onVisibilityChange: setMenuVisibility(id)
            }),
            showShadowOnScroll: true
        });
    }, [
        swimlaneId,
        id,
        menusShown,
        isIPBoard,
        isUnscheduledWorkColumnPanel,
        issueEntries.length
    ]);
    const headerOld = (0, $5uXOq.useMemo)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRpFy.default), {
            id: id,
            isMenuShown: menusShown[id],
            menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTH7p.default), {
                columnId: id,
                onVisibilityChange: setMenuVisibility(id)
            }),
            showShadowOnScroll: true
        });
        if (isIPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
            id: "program-swimlane-column-header",
            packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
            sendToPrivacyUnsafeSplunk: true,
            teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hXOH1.default), {
            swimlaneId: swimlaneId,
            columnId: id,
            count: issueEntries.length,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
            ref: headerRef
        }));
        return null;
    }, [
        swimlaneId,
        id,
        menusShown,
        isIPBoard,
        isUnscheduledWorkColumnPanel,
        issueEntries.length
    ]);
    const footer = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7p3wz.default), {
            columnId: id,
            isInitialColumn: isInitial,
            canShowIccNudge: isInitial && issueEntries.length <= MAX_CARDS_TO_SHOW_ICC_NUDGE,
            showDoneCardsButton: showDoneCardsButton,
            isColumnIccEnabled: isColumnIccEnabled,
            isLastSwimlane: isLastSwimlane,
            cardIndex: issueEntries.length,
            openInitialColumnIcc: openInitialColumnIcc,
            swimlaneId: swimlaneId,
            limitJql: limitJql,
            columnName: name
        }), [
        id,
        isColumnIccEnabled,
        isInitial,
        isLastSwimlane,
        issueEntries.length,
        openInitialColumnIcc,
        showDoneCardsButton,
        swimlaneId,
        limitJql,
        name
    ]);
    const virtualListFooter = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, footer, placeholderType === (0, $gcoP6.NO_ACTIVE_SPRINT_PLACEHOLDER) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBRY4.default), null)), [
        footer,
        placeholderType
    ]);
    const placeHolder = (0, $5uXOq.useMemo)(()=>{
        if (placeholderType === (0, $gcoP6.NO_PLACEHOLDER)) return null;
        return placeholderType === (0, $gcoP6.NO_ACTIVE_SPRINT_PLACEHOLDER) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBRY4.default), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5nhUs.default), null);
    }, [
        placeholderType
    ]);
    if (!false && useVirtualisation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50AZv.default), {
        id: id,
        key: id,
        header: (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? header : headerOld,
        swimlaneId: swimlaneId ?? undefined,
        draggableIndex: columnIndex,
        footer: footer,
        isLastSwimlane: isLastSwimlane,
        dropZoneType: dropZoneType,
        isMatrixLayout: hasGrouping
    }, ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2lkEP.FastVirtualList), {
            name: (0, $4R6GH.fg)('remove_aria_labelled_by_on_column_ul') ? undefined : name,
            showFooter: isColumnIccEnabled || showDoneCardsButton,
            issueEntries: issueEntries,
            issuesWithIssueLinksIds: issuesWithIssueLinksIds,
            footer: virtualListFooter,
            renderCard: renderCardFunction,
            placeholder: placeHolder,
            columnId: id,
            swimlaneId: swimlaneId,
            offsetTop: offsetTop,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50AZv.default), {
        id: id,
        key: id,
        header: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRpFy.default), {
            id: id,
            menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTH7p.default), {
                columnId: id
            }),
            showShadowOnScroll: true
        }) : null,
        swimlaneId: swimlaneId ?? undefined,
        draggableIndex: columnIndex,
        footer: footer,
        isLastSwimlane: isLastSwimlane,
        isMatrixLayout: hasGrouping
    }, issueEntries.map((issueEntry, index)=>{
        if ((0, $3eGwD.isIssueEntryGroup)(issueEntry)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g94HQ.default), {
            key: issueEntry.issueIds.toString(),
            index: index,
            issueIdGroup: issueEntry,
            canShowIccNudge: false,
            columnId: id,
            isColumnIccEnabled: isColumnIccEnabled,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            userCanViewMenu: canEditBoard || isUserAtLeastMember,
            onIssueChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isScrolling: false,
            offsetTop: 0,
            headerRef: headerRef
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQJq.default), {
            key: issueEntry.issueId,
            id: issueEntry.issueId,
            columnId: id,
            canShowIccNudge: canShowIccNudgeInBoard,
            index: index,
            isColumnIccEnabled: isColumnIccEnabled,
            swimlaneId: swimlaneId,
            isLastSwimlane: isLastSwimlane,
            userCanViewMenu: canEditBoard || isUserAtLeastMember,
            onIssueChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isScrolling: false,
            headerRef: headerRef
        });
    }), placeholderType === (0, $gcoP6.NO_ACTIVE_SPRINT_PLACEHOLDER) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lBRY4.default), null));
};
var $a12eb39f16847da5$export$2e2bcd8739ae039 = $a12eb39f16847da5$var$Column;

});
parcelRegister("drQJq", function(module, exports) {

$parcel$export(module.exports, "default", () => $4bd6e366c8f72404$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");


var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $9OPlz = parcelRequire("9OPlz");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $byfXQ = parcelRequire("byfXQ");

var $ljbvM = parcelRequire("ljbvM");

var $hsHM4 = parcelRequire("hsHM4");

var $1YTEX = parcelRequire("1YTEX");

var $5KVmP = parcelRequire("5KVmP");

var $52TPO = parcelRequire("52TPO");
const $4bd6e366c8f72404$var$CardPreview = ({ cardId: cardId })=>{
    const selectedCards = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardSelection));
    // Check that the card is in the selected cards in case there are some cards selected
    // and the user drags a different card.
    if (selectedCards.length > 1 && selectedCards.includes(cardId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4bd6e366c8f72404$var$CardPreviewContainer, {
        "data-count": selectedCards.length
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byfXQ.default), {
        id: cardId
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byfXQ.default), {
        id: cardId
    });
};
const $4bd6e366c8f72404$var$CardContainer = ({ id: id, index: index, columnId: columnId, swimlaneId: swimlaneId, userCanViewMenu: userCanViewMenu, isColumnIccEnabled: isColumnIccEnabled, isLastSwimlane: isLastSwimlane, onIssueChange: onIssueChange, isScrolling: isScrolling, canShowIccNudge: canShowIccNudge, isDraggable: isDraggable = true, groupParentId: groupParentId, headerRef: headerRef })=>{
    const shouldRenderCardLite = (0, $52TPO.useShouldRenderCardLite)(isScrolling);
    const canEditIssue = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$5cd553a40d575c6c];
    const isActiveCard = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.isActiveCardSelector)(state, {
            issueId: id
        }));
    const isSummaryEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.getCardEditSummary)(state)(id));
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const isIncrementPlanningCardDraggable = (0, $67sX6.useBoardSelector)((state)=>!(0, $d2i8f.getIsIssueDoneInClosedSprint)(state, id));
    const isIPBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    let cardIsDraggable = isDraggable && !isSummaryEditing;
    if (isIPBoard) cardIsDraggable = cardIsDraggable && isIncrementPlanningCardDraggable && !isIPBoardReadOnly;
    if (shouldRenderCardLite) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byfXQ.default), {
        id: id
    });
    const issueCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KVmP.default), {
        key: `card-${id}`,
        id: id,
        isLoading: // @ts-expect-error ([Part of upgrade 4.9-5.4]) - Operator '<=' cannot be applied to types 'CardId' and 'number'.
        id <= 0,
        draggableIndex: index,
        userCanViewMenu: userCanViewMenu,
        Cover: (0, $1YTEX.default),
        onIssueChange: onIssueChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        isDraggable: cardIsDraggable,
        columnId: columnId,
        swimlaneId: swimlaneId,
        CardPreview: $4bd6e366c8f72404$var$CardPreview,
        isActive: isActiveCard
    });
    const cardWithRich = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hsHM4.default), {
        key: `card-with-rich-${id}`,
        id: id,
        cardIndex: index,
        userCanViewMenu: userCanViewMenu,
        onIssueChange: onIssueChange,
        isDraggable: cardIsDraggable,
        columnId: columnId,
        swimlaneId: swimlaneId,
        CardPreview: $4bd6e366c8f72404$var$CardPreview
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ljbvM.CardWithIcc), {
        key: `card-with-icc-${id}`,
        isColumnIccEnabled: isColumnIccEnabled,
        id: id,
        cardIndex: index,
        columnId: columnId,
        swimlaneId: swimlaneId,
        isLastSwimlane: isLastSwimlane,
        onIssueChange: onIssueChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        canShowIccNudge: canShowIccNudge,
        forceIccRender: canShowIccNudge && index === 1,
        groupParentId: groupParentId,
        headerRef: headerRef,
        ...(0, $4R6GH.fg)('render_program_board_card_in_popup') ? {
            isScrolling: isScrolling
        } : {}
    }, canEditIssue ? cardWithRich : issueCard);
};
var $4bd6e366c8f72404$export$2e2bcd8739ae039 = $4bd6e366c8f72404$var$CardContainer;
// No real need to have the data attribute here, it's just for type safety
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4bd6e366c8f72404$var$CardPreviewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _otyr1ejb _1tesidpf _rfx316jk _1mpyu2gc _1kt9b3bt _1cs8stnw _cfu11ule _1rus15ej _kfgt1osq _7dwz3cjl _txdo1er8 _1h9udcr7 _14mjviql _18postnw _1ywu1nu9 _15l2idpf _32rxidpf _aetr2r13 _clh31tul _1hfkc8cv _uoe3v77o _1rec12x7 _70xrv77o _1k9612x7 _14rn15cr _1lwzkb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("byfXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $08014dce77bdf55e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hGgHi = parcelRequire("hGgHi");

var $e16Mp = parcelRequire("e16Mp");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $2vSU6 = parcelRequire("2vSU6");

var $gULOk = parcelRequire("gULOk");

var $gwIPs = parcelRequire("gwIPs");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $iHPnC = parcelRequire("iHPnC");

var $fQeLt = parcelRequire("fQeLt");

var $cm8xi = parcelRequire("cm8xi");

var $bbQQn = parcelRequire("bbQQn");

var $cfZh8 = parcelRequire("cfZh8");

var $8nii0 = parcelRequire("8nii0");

var $dHqFt = parcelRequire("dHqFt");

var $bC2fB = parcelRequire("bC2fB");

var $4VpT2 = parcelRequire("4VpT2");

var $iDGXn = parcelRequire("iDGXn");

var $dCm1o = parcelRequire("dCm1o");

var $33c4b = parcelRequire("33c4b");

var $2xFXk = parcelRequire("2xFXk");

var $acAaD = parcelRequire("acAaD");

var $iUagi = parcelRequire("iUagi");

var $iuuJH = parcelRequire("iuuJH");

var $2VkyK = parcelRequire("2VkyK");

var $d2i8f = parcelRequire("d2i8f");

var $bSSdD = parcelRequire("bSSdD");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $aTBle = parcelRequire("aTBle");

var $aeiE5 = parcelRequire("aeiE5");

const $08014dce77bdf55e$export$43d19547b9847fe4 = ({ mediaId: mediaId, issue: issue, parentSummary: parentSummary, parentColor: parentColor, showParent: showParent, assignee: assignee, isCMPBoard: isCMPBoard, isDone: isDone, status: status })=>{
    const showEpicLabels = (0, $iDGXn.useShowEpics)();
    const shouldRenderEpic = showParent && showEpicLabels;
    const viewSettings = (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $iDGXn.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showPriority: true,
        showDevelopment: true,
        showAssignee: true,
        showDaysInColumn: true,
        cardExtraFields: undefined,
        showStatuses: true
    };
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const hasCompactIssueType = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD);
    if (!issue) return null;
    const shouldRenderIssueLinksIndicator = issue.issueLinks && issue.issueLinks.length > 0;
    const shouldShowCMPCardFooter = (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? [
        viewSettings.showIssueType,
        viewSettings.showIssueKey,
        viewSettings.showDevelopment,
        viewSettings.showPriority,
        viewSettings.showAssignee && !!assignee?.avatarUrl,
        viewSettings.showDaysInColumn
    ].some((field)=>!!field) : true;
    const shouldShowTMPCardFooter = (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? [
        viewSettings.showIssueType,
        viewSettings.showIssueKey,
        viewSettings.showAssignee,
        viewSettings.showPriority,
        shouldRenderIssueLinksIndicator
    ].some((field)=>!!field) : true;
    const showLozengeContainer = shouldRenderEpic && parentSummary !== null && parentColor !== null;
    const showLabels = issue.labels !== undefined && issue.labels.length > 0;
    const customFields = issue?.customFields;
    const statusDetails = status?.id ? {
        id: status.id.toString(),
        name: status.name,
        statusCategory: {
            id: (0, $gULOk.categoryIdForStatusCategory)(status.category)
        }
    } : null;
    const ipBoardIssueKey = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $08014dce77bdf55e$var$ipBoardCard.issueKeyContainer
        ])
    }, isDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $08014dce77bdf55e$var$ipBoardCard.issueKeyDone
        ])
    }, issue.key) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $08014dce77bdf55e$var$ipBoardCard.issueKey
        ])
    }, issue.key));
    const ipBoardCardLite = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContainer, {
            isCMPBoard: Boolean(isCMPBoard),
            useContainerQuery: false
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteWrapper, {
            isFlagged: false
        }, mediaId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTBle.default), {
            mediaId: mediaId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContent, {
            className: $4VpT2.content
        }, issue.hasScenarioChanges && issue.cardColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: issue.cardColor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$Summary, {
            shouldTruncate: false
        }, issue.summary), (showLozengeContainer || showLabels) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, shouldRenderEpic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acAaD.IssueParentFieldStatic), {
            summary: parentSummary,
            color: parentColor,
            maxWidth: "100%"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHqFt.CardLabels), {
            labels: issue.labels ?? []
        })), statusDetails && (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozengeWithDropdownIndicator), {
            value: statusDetails
        })), shouldShowTMPCardFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                $08014dce77bdf55e$var$ipBoardCard.footer
            ])
        }, viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$f315b19fd9da0750, {
            src: issue.typeUrl
        }), viewSettings.showIssueKey && (0, $4R6GH.fg)('issue_cards_in_program_board') ? ipBoardIssueKey : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$IssueKey, {
            isDone: isDone
        }, issue.key), shouldRenderIssueLinksIndicator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aeiE5.IssueLinksIndicator), {
            issueId: issue.id,
            issueKey: issue.key
        }), issue.priority && viewSettings.showPriority && (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$IconWrapper, {
            "data-testid": (0, $e5a504d18c288d62$export$676116062bf0b86c)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$PriorityIcon, {
            alt: issue.priority.name,
            src: issue.priority?.iconUrl
        })), viewSettings.showAssignee && (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$a7c304b17e9dec26, {
            url: assignee?.avatarUrl,
            isIPBoard: isIPBoard
        })))));
    const tmpCardLite = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContainer, {
            isCMPBoard: Boolean(isCMPBoard),
            useContainerQuery: Boolean(!isIPBoard)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteWrapper, {
            isFlagged: Boolean(issue.isFlagged)
        }, mediaId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTBle.default), {
            mediaId: mediaId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContent, {
            className: $4VpT2.content
        }, issue.cardColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: issue.cardColor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$Summary, {
            shouldTruncate: false
        }, issue.summary), statusDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: statusDetails
        }))), (showLozengeContainer || showLabels) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, shouldRenderEpic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acAaD.IssueParentFieldStatic), {
            summary: parentSummary,
            color: parentColor,
            maxWidth: "100%"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHqFt.CardLabels), {
            labels: issue.labels ?? []
        })), shouldShowTMPCardFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardFooter, null, viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$f315b19fd9da0750, {
            src: issue.typeUrl
        }), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$IssueKey, {
            isDone: isDone
        }, issue.key), viewSettings.showAssignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$a7c304b17e9dec26, {
            url: assignee?.avatarUrl,
            isIPBoard: isIPBoard
        })))));
    const cmpCardLite = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContainer, {
            isCMPBoard: Boolean(isCMPBoard),
            useContainerQuery: Boolean(!isIPBoard)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteWrapper, {
            isFlagged: Boolean(issue.isFlagged)
        }, mediaId !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTBle.default), {
            mediaId: mediaId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CardLiteContentCMP, {
            className: $4VpT2.content
        }, issue.cardColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: issue.cardColor
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$Summary, {
            shouldTruncate: true,
            className: $4VpT2.summary
        }, issue.summary)), statusDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: statusDetails
        }))), showLozengeContainer && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$3f380ec5cee53f21, null, shouldRenderEpic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$2e623d726e27c97, {
            summary: parentSummary,
            color: parentColor,
            maxWidth: "100%"
        })), customFields && customFields.some((config)=>config.id && ((0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? viewSettings.cardExtraFields?.[config.id] !== false : true)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbQQn.CardCustomFields), {
            isCMPBoard: isCMPBoard,
            fields: customFields.filter((config)=>config.id && ((0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? viewSettings.cardExtraFields?.[config.id] !== false : true))
        })), shouldShowCMPCardFooter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$FooterSection, {
            className: $4VpT2.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$FooterPrimarySection, {
            className: $4VpT2.footerChildSection
        }, !hasCompactIssueType && viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$f315b19fd9da0750, {
            src: issue.typeUrl
        }), viewSettings.showIssueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$IssueKey, {
            isDone: isDone
        }, issue.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$FooterTertiarySection, {
            className: $4VpT2.footerChildSection
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nii0.Container), null, hasCompactIssueType && viewSettings.showIssueType && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$export$f315b19fd9da0750, {
            src: issue.typeUrl
        }), issue.devStatusField && viewSettings.showDevelopment && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$DevStatusPlaceholder, {
            "data-testid": (0, $e5a504d18c288d62$export$eee2e9bddfbbaf6f)
        }), typeof issue.daysInColumn === 'number' && viewSettings.showDaysInColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfZh8.CardDaysInColumn), {
            days: issue.daysInColumn
        }), issue.priority && viewSettings.showPriority && /* eslint-disable-next-line jira/integration/test-id-by-folder-structure */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$IconWrapper, {
            "data-testid": "software-board.board-container.board.card-container.card-lite.priority-icon.wrapper"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$PriorityIcon, {
            alt: issue.priority.name,
            src: issue.priority?.iconUrl
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$FooterSecondarySection, null, assignee?.avatarUrl != null && viewSettings.showAssignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$CMPAvatar, {
            url: assignee?.avatarUrl,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: $4VpT2.cmpAvatar,
            "data-testid": "software-board.board-container.board.card-container.card-lite.cmp-avatar"
        })))))));
    const otherCardLite = isIPBoard ? ipBoardCardLite() : tmpCardLite();
    return isCMPBoard ? cmpCardLite() : otherCardLite;
};
function $08014dce77bdf55e$var$getShouldShowParent(state) {
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    if (isCMPBoard) return !state.ui.board.displayOptions.areEpicLabelsHidden;
    return (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id;
}
const $08014dce77bdf55e$export$c31df4bd766f9c35 = (state, { id: id })=>{
    const issue = (0, $5mTgl.platformIssueSelector)(state)(id);
    const issueParents = (0, $bSSdD.getIssueParents)(state);
    const parentId = (()=>{
        if (!issue) return null;
        if (id in issueParents) return id;
        return issue.parentId;
    })();
    const issueMedia = (0, $5mTgl.isCardMediaEnabled)(state) && !(0, $2VkyK.isIssueMediaHiddenByUser)(state, id) ? (0, $2VkyK.getIssueMedia)(state, id) : null;
    const mediaId = !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia) && 'attachmentMediaApiId' in issueMedia ? issueMedia.attachmentMediaApiId : null;
    const parent = parentId !== null ? (0, $bSSdD.makeIssueParentByIdSelector)(state)(parentId) : null;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const showParent = $08014dce77bdf55e$var$getShouldShowParent(state);
    const isJSMBoard = (0, $67Z81.projectTypeSelector)(state) === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const isIPBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    return {
        issue: issue,
        assignee: issue?.assigneeAccountId ? (0, $36pz7.getPerson)(state, issue.assigneeAccountId) : null,
        mediaId: mediaId,
        parentSummary: parent?.summary ?? null,
        parentColor: parent?.color ?? null,
        showParent: // Hide parent when grouping by epic
        showParent,
        isCMPBoard: isCMPBoard,
        status: isJSMBoard || isIPBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') ? (0, $5mTgl.getStatusByIssueIdSelector)(state, {
            id: id
        }) ?? null : null,
        isDone: (0, $d2i8f.isDoneIssueSelector)(state)(id)
    };
};
const $08014dce77bdf55e$var$CardLiteConnected = (0, $bC2fB.connect)($08014dce77bdf55e$export$c31df4bd766f9c35, {})($08014dce77bdf55e$export$43d19547b9847fe4);
var $08014dce77bdf55e$export$2e2bcd8739ae039 = $08014dce77bdf55e$var$CardLiteConnected;
const $08014dce77bdf55e$var$LOZENGE_THEMES = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        textColor: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $08014dce77bdf55e$export$3f380ec5cee53f21 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexDirection: 'row',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            overflow: 'hidden'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            flexFlow: 'row wrap',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            boxAlign: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            maxWidth: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            gap: "var(--ds-space-100, 8px)"
        }
    }, children));
const $08014dce77bdf55e$export$2e623d726e27c97 = ({ summary: summary, color: color, maxWidth: maxWidth })=>{
    if (summary !== null && color !== null) {
        // @ts-expect-error - TS2538 - Type 'undefined' cannot be used as an index type.
        const theme = $08014dce77bdf55e$var$LOZENGE_THEMES[color];
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'inline-block',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                boxSizing: 'border-box',
                maxWidth: maxWidth,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
                textTransform: 'uppercase',
                padding: `0 ${"var(--ds-space-050, 4px)"}`,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                fontWeight: "var(--ds-font-weight-bold, 700)",
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                borderRadius: '3px',
                color: theme.textColor,
                background: theme.backgroundColor,
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                whiteSpace: 'nowrap',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                textOverflow: 'ellipsis',
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                overflow: 'hidden'
            }
        }, summary);
    }
    return null;
};
const $08014dce77bdf55e$export$c9ed62821215deda = ({ labels: labels })=>{
    if (labels == null || !labels.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'inline-flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            gap: "var(--ds-space-100, 8px)"
        }
    }, labels.map((label)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$Label, {
            key: label
        }, label)));
};
const $08014dce77bdf55e$export$f315b19fd9da0750 = ({ src: src })=>{
    if (src !== undefined) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: src,
        alt: "",
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '16px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '16px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            verticalAlign: 'text-bottom'
        }
    });
    return null;
};
const $08014dce77bdf55e$var$AvatarWrapperOld = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            backgroundColor: "var(--ds-icon-subtle, #626F86)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '50%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            justifyContent: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            alignItems: 'center'
        }
    }, children);
const $08014dce77bdf55e$var$AvatarWrapperNew = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        alignItems: "center",
        justifyContent: "center",
        xcss: $08014dce77bdf55e$var$AvatarWrapperStylesNew
    }, children);
const $08014dce77bdf55e$var$AvatarWrapper = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $08014dce77bdf55e$var$AvatarWrapperNew, $08014dce77bdf55e$var$AvatarWrapperOld);
const $08014dce77bdf55e$export$a7c304b17e9dec26 = ({ url: url, isIPBoard: isIPBoard })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '24px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '24px',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            padding: "var(--ds-space-025, 2px)",
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            display: 'flex',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            alignItems: 'center',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            justifyContent: 'center'
        },
        "data-testid": "software-board.board-container.board.card-container.card-lite.tmp-avatar"
    }, !url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isIPBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33c4b.AssigneeFieldStatic), {
        value: null
    }), !isIPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08014dce77bdf55e$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($e16Mp))), {
        label: "",
        color: "var(--ds-icon-subtle, #626F86)",
        LEGACY_primaryColor: "var(--ds-text-inverse, #FFFFFF)",
        LEGACY_secondaryColor: "var(--ds-text-subtle, #44546F)"
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            height: '100%',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            borderRadius: '50%',
            background: `url(${url})`,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            backgroundSize: 'cover',
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            width: '100%'
        }
    }));
const $08014dce77bdf55e$var$iconSize = (0, $gwIPs.gridSize) * 2;
const $08014dce77bdf55e$var$gridAreas = ()=>{
    if ($4VpT2.primary && $4VpT2.tertiary && $4VpT2.secondary) return `"${$4VpT2.primary} ${$4VpT2.tertiary} ${$4VpT2.secondary}"`;
    return '"primary tertiary secondary"';
};
const $08014dce77bdf55e$var$ipBoardCard = {
    issueKeyContainer: "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _o5721q9c",
    issueKey: "_1reo15vq _18m915vq _11c81vhk _1e0c1ule _4cvr1h6o _1bto1l2s _syaz131l _1eim1xrj",
    issueKeyDone: "_1reo15vq _18m915vq _11c81vhk _4bfu18uv _1hms1911 _ajmmnqa1 _1e0c1ule _4cvr1h6o _1bto1l2s _syaz131l _1eim1xrj",
    footer: "_1e0c1txw _4cvr1h6o _1tke1f4h _1p57pxbi _gy1pu2gc"
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $08014dce77bdf55e$var$CardLiteContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCMPBoard: isCMPBoard, useContainerQuery: useContainerQuery, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_akq0kr": (0, $lD23V.default)($4VpT2["card-content-container"])
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _vchhusvi",
            __cmplp.isCMPBoard ? "_1yt4ze3t" : "_1yt4x7n9",
            __cmplp.isCMPBoard ? "_18s8x7n9" : "_19pkidpf _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.useContainerQuery && "_ylxr1hpx",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CardLiteWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlagged: isFlagged, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _4t3i1osq _kqswh2mm _16qszucj",
            __cmplp.isFlagged ? "_11q71tzq" : "_11q7hp5a",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CardLiteContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _4t3i1osq _vchhusvi _1e0c1txw _2lx21bp4 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _lf631b66",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$Summary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldTruncate: shouldTruncate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _u5f3xy5q _1nmz1hna _1i4q1hna",
            __cmplp.shouldTruncate ? "_1yyj11wp" : "_1yyjn7od",
            __cmplp.shouldTruncate ? "_1e0ccj1k" : "_1e0c1nu9",
            __cmplp.shouldTruncate ? "_1reo15vq _18m915vq" : "_1reon7od _18m9n7od",
            __cmplp.shouldTruncate ? "_sudp1e54" : "_sudpn7od",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CardFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _1tke1f4h",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDone: isDone, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81vhk _16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _4t3igktf _1bto1l2s _syaz131l",
            __cmplp.isDone ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsn7od _ajmmnqa1",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CardLiteContentCMP = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _4t3i1osq _vchhusvi _1e0c1txw _2lx21bp4 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$CMPAvatar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { url: url, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_12kfzft": (0, $lD23V.default)(`url(${__cmplp.url}) 0/cover`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _11q7gkke _4t3i1tcg _1bsb1tcg _19pkv77o _2hwxv77o _otyrv77o _18u0v77o",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$ContentSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$FooterSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_o48r1v": (0, $lD23V.default)($08014dce77bdf55e$var$gridAreas())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulphyhw _1e0c11p5 _1bsb1osq _1tke1f4h _2z05hkll _yv0e1xhj _1lmc1r3e",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$FooterPrimarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_yr074y": (0, $lD23V.default)($4VpT2.primary ? $4VpT2.primary : 'primary')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5lkgrd _zulp1b66 _p12f1ns9 _vchhusvi _1e0c11p5 _wij21bp4 _4cvr1h6o _1bahv2br",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$FooterSecondarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_y1a6xm": (0, $lD23V.default)($4VpT2.secondary ? $4VpT2.secondary : 'secondary')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5l1vev _zulp1b66 _vchhusvi _1e0c11p5 _wij21bp4 _4cvr1h6o _1bahv2br",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$FooterTertiarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_tgx8yt": (0, $lD23V.default)($4VpT2.tertiary ? $4VpT2.tertiary : 'tertiary')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5l1xse _zulpu2gc _1tke1tcg _vchhusvi _1e0c11p5 _wij21bp4 _4cvr1h6o _1bahv2br",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$PriorityIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$DevStatusPlaceholder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1tcg _4t3i1tcg _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _2rko1l7b _1reo15vq _18m915vq _1e0c116y _vchhusvi _4t3igktf _p12fmgvx _1bto1l2s _o5721q9c _bfhkm7j4 _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $08014dce77bdf55e$var$AvatarWrapperStylesNew = (0, $8CUq3.xcss)({
    width: '100%',
    height: '100%',
    backgroundColor: 'color.background.accent.gray.subtler',
    borderRadius: '50%'
});

});
parcelRegister("fQeLt", function(module, exports) {

$parcel$export(module.exports, "StatusLozenge", () => $e065d549cea5a7d0$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "StatusLozengeWithDropdownIndicator", () => $e065d549cea5a7d0$export$9f5070a985b0679b);

var $5uXOq = parcelRequire("5uXOq");

var $17mYr = parcelRequire("17mYr");
const $e065d549cea5a7d0$export$f72db4ad1e9b3e6d = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        contentRef: props.contentRef
    });
};
const $e065d549cea5a7d0$export$9f5070a985b0679b = (props)=>{
    const status = props.value || props.initialValue;
    if (!status) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        status: status,
        isEditable: false,
        hasHoverState: false,
        focused: false,
        shouldShowDropdownIndication: true
    });
};

});
parcelRegister("17mYr", function(module, exports) {

$parcel$export(module.exports, "TEST_ID_PREFIX", () => $390c5e7bc7d9c77b$export$9cbc201c09a37b3f);
$parcel$export(module.exports, "StatusLozenge", () => $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d);
$parcel$export(module.exports, "WrappedStatusLozenge", () => $390c5e7bc7d9c77b$export$69ea4907eefa8e7b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $9yOBd = parcelRequire("9yOBd");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $aQhlk = parcelRequire("aQhlk");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $5Ax7l = parcelRequire("5Ax7l");

var $4YeLF = parcelRequire("4YeLF");
const $390c5e7bc7d9c77b$export$9cbc201c09a37b3f = 'issue.fields.status.common.ui.status-lozenge.';
const $390c5e7bc7d9c77b$var$CustomChevronDownGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 12,
        height: 12,
        viewBox: "5 5 13 13"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.292 10.293a1.009 1.009 0 0 0 0 1.419l2.939 2.965c.218.215.5.322.779.322s.556-.107.769-.322l2.93-2.955a1.01 1.01 0 0 0 0-1.419.987.987 0 0 0-1.406 0l-2.298 2.317-2.307-2.327a.99.99 0 0 0-1.406 0z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $390c5e7bc7d9c77b$var$StatusLozengeNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`,
        ref: ref
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, name, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Ax7l.Lozenge), {
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, name)), hasHoverState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $390c5e7bc7d9c77b$var$hoverOverlayStyles
    })));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, contentRef: contentRef, triggerProps: triggerProps = {}, ...others } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        xcss: $390c5e7bc7d9c77b$var$pressableStyles,
        ref: targetRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeNew, {
        ...others,
        isEditable: isEditable,
        ref: contentRef
    }));
};
const $390c5e7bc7d9c77b$var$EditableLozenge = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozengeContentWrapper, null, children, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $390c5e7bc7d9c77b$var$CustomChevronDownGlyph,
        label: ""
    })));
const $390c5e7bc7d9c77b$var$StatusLozengeOld = ({ status: { name: name, statusCategory: statusCategory }, isEditable: isEditable, hasHoverState: hasHoverState, targetRef: targetRef, shouldShowDropdownIndication: shouldShowDropdownIndication, isDisabled: isDisabled = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StyledLozenge, {
        hasHoverState: hasHoverState,
        statusCategoryId: statusCategory.id,
        isDisabled: isDisabled
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusContentWrapper, {
        ref: targetRef,
        "data-testid": `${$390c5e7bc7d9c77b$export$9cbc201c09a37b3f}${statusCategory.id}`
    }, isEditable === true || shouldShowDropdownIndication === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$EditableLozenge, null, name) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4YeLF.LozengeOld), null, name)));
const $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld = (props)=>{
    const { ariaLabel: ariaLabel, error: error, isEditable: isEditable, isOpen: isOpen, targetRef: targetRef, triggerProps: triggerProps = {}, ...other } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ref: targetRef,
        appearance: "subtle",
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        theme: (currentTheme, themeProps)=>{
            const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
            return {
                buttonStyles: {
                    ...buttonStyles,
                    backgroundColor: 'transparent',
                    margin: 0,
                    width: 'auto',
                    height: 'auto',
                    padding: 0,
                    border: `2px solid ${error ? "var(--ds-border-danger, #E2483D)" : 'transparent'}`,
                    borderRadius: '5px',
                    ...isEditable === true ? undefined : {
                        cursor: 'auto'
                    },
                    outline: 0,
                    boxShadow: `0 0 0 2px ${isOpen === true ? "var(--ds-border-focused, #388BFF)" : 'transparent'}`,
                    '& > span': {
                        margin: 0
                    },
                    '&:focus, &:focus-within': {
                        boxShadow: `0 0 0 2px ${"var(--ds-border-focused, #388BFF)"}`
                    }
                },
                spinnerStyles: spinnerStyles
            };
        },
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($390c5e7bc7d9c77b$var$StatusLozengeOld, {
        ...other,
        isEditable: isEditable
    }));
};
const $390c5e7bc7d9c77b$export$f72db4ad1e9b3e6d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$StatusLozengeNew, $390c5e7bc7d9c77b$var$StatusLozengeOld);
const $390c5e7bc7d9c77b$export$69ea4907eefa8e7b = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $390c5e7bc7d9c77b$var$WrappedStatusLozengeNew, $390c5e7bc7d9c77b$var$WrappedStatusLozengeOld); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozenge = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "wv585u-0"
})`display:flex;align-items:center;> div{display:flex;line-height:initial;outline:0;> span{padding:${"var(--ds-space-025, 2px)"} 0;vertical-align:text-bottom;color:${(props)=>// eslint-disable-next-line no-nested-ternary
    props.isDisabled ? (0, $aQhlk.disabledColor).text : !(0, $dCm1o.isVisualRefreshEnabled)() ? (0, $aQhlk.textColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]] : (0, $aQhlk.textColorOld)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};background-color:${(props)=>props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};${(props)=>props.hasHoverState ? `&:hover {
                        color: ${props.isDisabled ? (0, $aQhlk.disabledColor).text : (0, $aQhlk.textHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                        background-color: ${props.isDisabled ? (0, $aQhlk.disabledColor).bg : (0, $aQhlk.bgHoverColor)[(0, $aQhlk.statusCategoryToThemeMap)[props.statusCategoryId]]};
                    }` : ''};${(props)=>props.isDisabled && (0, $47bDC.css)({
        pointerEvents: 'none'
    })}}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StyledLozengeContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1bgi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $390c5e7bc7d9c77b$var$StatusContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $390c5e7bc7d9c77b$var$pressableStyles = (0, $8CUq3.xcss)({
    border: 'none',
    padding: 'space.0',
    borderRadius: '3px',
    background: 'transparent',
    position: 'relative',
    maxWidth: '100%',
    marginLeft: 'space.025'
});
const $390c5e7bc7d9c77b$var$hoverOverlayStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    inset: '0',
    borderRadius: '3px',
    marginRight: 'space.025',
    ':hover': {
        opacity: 0.3,
        backgroundColor: 'color.background.inverse.subtle'
    }
});

});
parcelRegister("aQhlk", function(module, exports) {

$parcel$export(module.exports, "statusCategoryToThemeMap", () => $58bc751e3aa4b554$export$d9e35f42afe1e488);
$parcel$export(module.exports, "bgColor", () => $58bc751e3aa4b554$export$7dcbec377a25efc6);
$parcel$export(module.exports, "textColor", () => $58bc751e3aa4b554$export$32f78bffcd82ff28);
$parcel$export(module.exports, "textColorOld", () => $58bc751e3aa4b554$export$26ac04004fa4ead4);
$parcel$export(module.exports, "bgHoverColor", () => $58bc751e3aa4b554$export$69fdf3ba928b4c77);
$parcel$export(module.exports, "textHoverColor", () => $58bc751e3aa4b554$export$99ec0cf2cf1b2082);
$parcel$export(module.exports, "disabledColor", () => $58bc751e3aa4b554$export$b70f10fc4a6ba453);
const $58bc751e3aa4b554$export$61137dce61763ec3 = 'default';
const $58bc751e3aa4b554$export$132676d06d92ad48 = 'success';
const $58bc751e3aa4b554$export$5c1f3b72419aa125 = 'inprogress';
const $58bc751e3aa4b554$export$d9e35f42afe1e488 = {
    '1': $58bc751e3aa4b554$export$61137dce61763ec3,
    '2': $58bc751e3aa4b554$export$61137dce61763ec3,
    '3': $58bc751e3aa4b554$export$132676d06d92ad48,
    '4': $58bc751e3aa4b554$export$5c1f3b72419aa125
};
const $58bc751e3aa4b554$export$7dcbec377a25efc6 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral, #091E420F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success, #DCFFF1)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information, #E9F2FF)"
};
const $58bc751e3aa4b554$export$32f78bffcd82ff28 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text-subtle, #44546F)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$26ac04004fa4ead4 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$69fdf3ba928b4c77 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-background-neutral-hovered, #091E4224)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-background-success-hovered, #BAF3DB)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-background-information-hovered, #CCE0FF)"
};
const $58bc751e3aa4b554$export$99ec0cf2cf1b2082 = {
    [$58bc751e3aa4b554$export$61137dce61763ec3]: "var(--ds-text, #172B4D)",
    [$58bc751e3aa4b554$export$132676d06d92ad48]: "var(--ds-text-success, #216E4E)",
    [$58bc751e3aa4b554$export$5c1f3b72419aa125]: "var(--ds-text-information, #0055CC)"
};
const $58bc751e3aa4b554$export$b70f10fc4a6ba453 = {
    bg: "var(--ds-background-neutral, #091E420F)",
    text: "var(--ds-text-disabled, #091E424F)"
};

});

parcelRegister("5Ax7l", function(module, exports) {

$parcel$export(module.exports, "Lozenge", () => $bcba81c28add5d02$export$a31cbe1bf5463979);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $aQhlk = parcelRequire("aQhlk");

const $bcba81c28add5d02$export$a31cbe1bf5463979 = ({ children: children, statusCategoryId: statusCategoryId, isDisabled: isDisabled })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        appearance: (0, $aQhlk.statusCategoryToThemeMap)[statusCategoryId],
        isBold: true,
        ...isDisabled ? {
            style: {
                color: (0, $aQhlk.disabledColor).text,
                backgroundColor: (0, $aQhlk.disabledColor).bg
            }
        } : {}
    }, children);

});

parcelRegister("4YeLF", function(module, exports) {

$parcel$export(module.exports, "LozengeOld", () => $bbacf745a667099a$export$26089816624d22fc);
// TODO - delete this file when cleaning up visual-refresh

var $5uXOq = parcelRequire("5uXOq");
const $bbacf745a667099a$var$containerStyles = {
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    boxSizing: 'border-box',
    display: 'inline-block',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    maxWidth: '100%',
    padding: 0,
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    verticalAlign: 'top'
};
const $bbacf745a667099a$var$contentStyles = {
    boxSizing: 'border-box',
    display: 'inline-block',
    maxWidth: 200,
    overflow: 'hidden',
    padding: `0 ${"var(--ds-space-050, 4px)"}`,
    textOverflow: 'ellipsis',
    verticalAlign: 'top',
    whiteSpace: 'nowrap',
    width: '100%'
};
const $bbacf745a667099a$export$26089816624d22fc = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
        style: $bbacf745a667099a$var$contentStyles
    }, children));
$bbacf745a667099a$export$26089816624d22fc.displayName = 'Lozenge';

});



parcelRegister("cm8xi", function(module, exports) {

$parcel$export(module.exports, "CardColor", () => $6a8934f3f04ad0f9$export$d6da217c85de72a2);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4VpT2 = parcelRequire("4VpT2");
const $6a8934f3f04ad0f9$export$d6da217c85de72a2 = ({ color: color, testId: testId })=>{
    if (!color) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6a8934f3f04ad0f9$var$CardColorInner, {
        color: color,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $4VpT2.cardColorInner,
        ...testId ? {
            'data-testid': testId
        } : {}
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6a8934f3f04ad0f9$var$CardColorInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk1cj8 _4t3i1osq _kqswstnw _1ltvidpf _154iidpf _1bsb1y44 _13li1l7b _mrkb1l7b",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4VpT2", function(module, exports) {

$parcel$export(module.exports, "avatarContainer", () => $396090d7f3a366db$export$4ea799498ef4a755, (v) => $396090d7f3a366db$export$4ea799498ef4a755 = v);
$parcel$export(module.exports, "card-content-container", () => $396090d7f3a366db$export$b097e1489ce64e3a, (v) => $396090d7f3a366db$export$b097e1489ce64e3a = v);
$parcel$export(module.exports, "cardColorInner", () => $396090d7f3a366db$export$e2907b219480f02f, (v) => $396090d7f3a366db$export$e2907b219480f02f = v);
$parcel$export(module.exports, "cmpAvatar", () => $396090d7f3a366db$export$114c94adbfe142fc, (v) => $396090d7f3a366db$export$114c94adbfe142fc = v);
$parcel$export(module.exports, "content", () => $396090d7f3a366db$export$a7db06668cad9adb, (v) => $396090d7f3a366db$export$a7db06668cad9adb = v);
$parcel$export(module.exports, "customCardFieldList", () => $396090d7f3a366db$export$8b6db2f2076ae2a6, (v) => $396090d7f3a366db$export$8b6db2f2076ae2a6 = v);
$parcel$export(module.exports, "footer", () => $396090d7f3a366db$export$adb608be33961c98, (v) => $396090d7f3a366db$export$adb608be33961c98 = v);
$parcel$export(module.exports, "footerChildSection", () => $396090d7f3a366db$export$1907b6af328e1b13, (v) => $396090d7f3a366db$export$1907b6af328e1b13 = v);
$parcel$export(module.exports, "primary", () => $396090d7f3a366db$export$9ad721cf3b3debe0, (v) => $396090d7f3a366db$export$9ad721cf3b3debe0 = v);
$parcel$export(module.exports, "secondary", () => $396090d7f3a366db$export$745c6f71a1e0e6f7, (v) => $396090d7f3a366db$export$745c6f71a1e0e6f7 = v);
$parcel$export(module.exports, "summary", () => $396090d7f3a366db$export$9a2dbef7a17e2e58, (v) => $396090d7f3a366db$export$9a2dbef7a17e2e58 = v);
$parcel$export(module.exports, "tertiary", () => $396090d7f3a366db$export$5668677bb0c0ed27, (v) => $396090d7f3a366db$export$5668677bb0c0ed27 = v);
var $396090d7f3a366db$export$4ea799498ef4a755;
var $396090d7f3a366db$export$b097e1489ce64e3a;
var $396090d7f3a366db$export$e2907b219480f02f;
var $396090d7f3a366db$export$114c94adbfe142fc;
var $396090d7f3a366db$export$a7db06668cad9adb;
var $396090d7f3a366db$export$8b6db2f2076ae2a6;
var $396090d7f3a366db$export$adb608be33961c98;
var $396090d7f3a366db$export$1907b6af328e1b13;
var $396090d7f3a366db$export$3f4216a049dd4cce;
var $396090d7f3a366db$export$9ad721cf3b3debe0;
var $396090d7f3a366db$export$745c6f71a1e0e6f7;
var $396090d7f3a366db$export$9a2dbef7a17e2e58;
var $396090d7f3a366db$export$5668677bb0c0ed27;
$396090d7f3a366db$export$4ea799498ef4a755 = `yse7za_avatarContainer`;
$396090d7f3a366db$export$b097e1489ce64e3a = `yse7za_card-content-container`;
$396090d7f3a366db$export$e2907b219480f02f = `yse7za_cardColorInner`;
$396090d7f3a366db$export$114c94adbfe142fc = `yse7za_cmpAvatar`;
$396090d7f3a366db$export$a7db06668cad9adb = `yse7za_content`;
$396090d7f3a366db$export$8b6db2f2076ae2a6 = `yse7za_customCardFieldList`;
$396090d7f3a366db$export$adb608be33961c98 = `yse7za_footer`;
$396090d7f3a366db$export$1907b6af328e1b13 = `yse7za_footerChildSection`;
$396090d7f3a366db$export$3f4216a049dd4cce = `yse7za_iconsPlaceHolder`;
$396090d7f3a366db$export$9ad721cf3b3debe0 = `yse7za_primary`;
$396090d7f3a366db$export$745c6f71a1e0e6f7 = `yse7za_secondary`;
$396090d7f3a366db$export$9a2dbef7a17e2e58 = `yse7za_summary`;
$396090d7f3a366db$export$5668677bb0c0ed27 = `yse7za_tertiary`;

});


parcelRegister("bbQQn", function(module, exports) {

$parcel$export(module.exports, "CardCustomFields", () => $3d8f972b9298b134$export$9070bf61c3b8c828);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $b71gk = parcelRequire("b71gk");

var $4VpT2 = parcelRequire("4VpT2");

var $1U6hS = parcelRequire("1U6hS");
const $3d8f972b9298b134$export$9070bf61c3b8c828 = ({ fields: fields, isCMPBoard: isCMPBoard, fixVersions: fixVersions })=>{
    if (!fields || fields.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-platform-card-custom-field",
        packageName: "jira-platform-card"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3d8f972b9298b134$var$CustomCardFieldList, {
        "data-testid": "platform-card.common.ui.custom-fields.custom-card-field-list",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $4VpT2.customCardFieldList
    }, fields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1U6hS.CardCustomField), {
            field: field,
            key: field.id,
            isCMPBoard: isCMPBoard,
            fixVersions: fixVersions
        }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3d8f972b9298b134$var$CustomCardFieldList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1bsb1osq _p12f1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1U6hS", function(module, exports) {

$parcel$export(module.exports, "CardCustomField", () => $0c0d9ba3933dcea9$export$2059d37a79d2fa46);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $2rgYg = parcelRequire("2rgYg");

var $khuza = parcelRequire("khuza");

var $71sS1 = parcelRequire("71sS1");

var $9yDQx = parcelRequire("9yDQx");

var $21RvA = parcelRequire("21RvA");

var $g3il2 = parcelRequire("g3il2");

var $jdK9h = parcelRequire("jdK9h");
const $0c0d9ba3933dcea9$export$2059d37a79d2fa46 = ({ field: field, isCMPBoard: isCMPBoard, fixVersions: fixVersions })=>{
    const content = (()=>{
        if (field.renderer === 'number') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yDQx.TextCardCustomFieldContent), {
            field: {
                text: field.value != null ? String(field.value) : undefined
            }
        });
        if (field.renderer === 'sla') return field.value !== undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2rgYg.default), {
            ...field.value,
            "data-testid": "platform-card.common.ui.custom-fields.card-custom-field.sla"
        }) : null;
        // TMP renders labels outside of custom fields
        if (isCMPBoard && field.renderer === 'text' && field.id === (0, $g3il2.CUSTOM_FIELD_LABELS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g3il2.TextLabelCustomFieldContent), {
            field: field
        });
        if (field.renderer === 'text' && field.id === (0, $21RvA.CUSTOM_FIELD_FIX_VERSIONS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $21RvA.TextFixVersionsCustomFieldContent), {
            field: field,
            fixVersions: fixVersions
        });
        if (field.renderer === 'text' || field.renderer === 'status' || field.renderer === 'epiclink') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yDQx.TextCardCustomFieldContent), {
            field: field
        });
        if (field.renderer === 'url' && (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdK9h.TextSmartLinkCustomFieldContent), {
            field: field
        });
        if (field.renderer === 'html' || field.renderer === 'date' || field.renderer === 'duration' || field.renderer === 'url') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71sS1.HtmlCardCustomFieldContent), {
            field: field
        });
        // This is a type assertion that will make TypeScript make sure all
        // `renderers` are checked above and that it's impossible to render
        // null for known types.
        const _unreachable = field;
        return null;
    })();
    if (content == null) return null;
    const isSmartLink = (0, $6s1PB.expValEquals)('jsw_perf_format-links-in-custom-fields', 'board-and-backlog', true) && field.renderer === 'url';
    // Hiding tooltip for html fields that already have tooltips
    const hideTooltip = field.label === 'Development' || isSmartLink;
    if (hideTooltip) return content;
    if (field.renderer === 'text' && field.id === (0, $21RvA.CUSTOM_FIELD_FIX_VERSIONS)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: field.text,
        position: "bottom-start"
    }, content);
    // all type of custom fields have renderer of html
    // except the label custom field which has renderer of text
    return field.renderer === 'html' || field.renderer === 'text' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khuza.CustomFieldTooltip), {
        field: field
    }, content) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: field.label
    }, content);
};

});
parcelRegister("2rgYg", function(module, exports) {

$parcel$export(module.exports, "default", () => $5236efa409cf0c4b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $ewfjW = parcelRequire("ewfjW");

var $i6DtB = parcelRequire("i6DtB");
const $5236efa409cf0c4b$export$71bf8c15c1931c45 = (props)=>{
    const transformedSla = (0, $i6DtB.transformSlaResponse)(props);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5236efa409cf0c4b$var$SlaContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewfjW.AsyncLazySla), {
        value: transformedSla.value,
        viewMode: (0, $bb10fe9d5bb31c29$export$a63db8d18dae0c68)
    }));
};
var $5236efa409cf0c4b$export$2e2bcd8739ae039 = $5236efa409cf0c4b$export$71bf8c15c1931c45;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5236efa409cf0c4b$var$SlaContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m",
            __cmplp.className
        ])
    });
});

});
const $bb10fe9d5bb31c29$export$a63db8d18dae0c68 = 'card';
const $bb10fe9d5bb31c29$export$2e5e3c3156fc4c3c = 'queue';
const $bb10fe9d5bb31c29$export$6b218e85068d9955 = 'insights';

parcelRegister("ewfjW", function(module, exports) {

$parcel$export(module.exports, "AsyncLazySla", () => $becd35c254cf8313$export$e4c697b53a973eb5);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $b71gk = parcelRequire("b71gk");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

const $becd35c254cf8313$var$AsyncSla = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("4Bwn0")), {
    moduleId: "./src/packages/jira-issue-sla/src/ui/sla/main.tsx"
});
const $becd35c254cf8313$export$e4c697b53a973eb5 = (props)=>{
    const { viewMode: viewMode, onError: onError } = props;
    const boundary = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(`sla ${viewMode} View`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: boundary,
        packageName: "jira-issue-sla",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($becd35c254cf8313$var$AsyncSla, props)));
};

});
parcelRegister("4Bwn0", function(module, exports) {

let $35a3ba2687a944ef$var$load = (parcelRequire("28QjX"))(4);
module.exports = $35a3ba2687a944ef$var$load("6bCMi").then(()=>parcelRequire('hN8Ee'));

});


parcelRegister("i6DtB", function(module, exports) {

$parcel$export(module.exports, "getStyles", () => $2be00e693919d411$export$ffd58b7f6f099a57);
$parcel$export(module.exports, "createUUID", () => $2be00e693919d411$export$5dbf9a24b655dde4);
$parcel$export(module.exports, "transformSlaResponse", () => $2be00e693919d411$export$40936768e55efbd7);

var $7Jxgt = parcelRequire("7Jxgt");

var $fkIan = parcelRequire("fkIan");

var $gVtcM = parcelRequire("gVtcM");

const $2be00e693919d411$export$ffd58b7f6f099a57 = (isBreached, status, timeRemainingInMinutes)=>{
    if (status === (0, $b25eb0ff361bcea0$export$fc332a617fd34192) && !isBreached) return 0, $fkIan.SUCCESS_STYLE;
    if (status === (0, $b25eb0ff361bcea0$export$fc332a617fd34192) && isBreached) return 0, $fkIan.FAILURE_STYLE;
    if (status === (0, $b25eb0ff361bcea0$export$3ad39751a33c16b8)) {
        if (timeRemainingInMinutes < 0) return 0, $fkIan.PAUSED_BREACHED_STYLE;
        if (timeRemainingInMinutes < 30) return 0, $fkIan.PAUSED_UNDER_THIRTY_REMAINING_STYLE;
        return 0, $fkIan.PAUSED_STYLE;
    }
    if (timeRemainingInMinutes < 0) return 0, $fkIan.ONGOING_BREACHED_STYLE;
    if (timeRemainingInMinutes < 30) return 0, $fkIan.ONGOING_UNDER_THIRTY_REMAINING_STYLE;
    return 0, $fkIan.ONGOING_STYLE;
};
const $2be00e693919d411$export$5dbf9a24b655dde4 = ()=>{
    //  Here session is one scroll, session is destroyed on component unmount.
    let sessionUuid;
    return (reset = false)=>{
        if (reset) sessionUuid = undefined;
        if (sessionUuid !== undefined) return sessionUuid;
        sessionUuid = (0, $7Jxgt.v4)();
        return sessionUuid;
    };
};
const $2be00e693919d411$export$40936768e55efbd7 = (slaProps)=>{
    const props = {
        storedValue: {
            // @ts-expect-error Type 'SlaFieldResponse' is not assignable to type 'Sla | SlaError'.ts(2322)
            value: slaProps
        }
    };
    return (0, $gVtcM.SlaFieldTransformer)(props);
};

});
parcelRegister("fkIan", function(module, exports) {

$parcel$export(module.exports, "SUCCESS_STYLE", () => $aed6bfb6da5b8978$export$e0b777e1e3a27f60);
$parcel$export(module.exports, "FAILURE_STYLE", () => $aed6bfb6da5b8978$export$979e63416456f996);
$parcel$export(module.exports, "PAUSED_STYLE", () => $aed6bfb6da5b8978$export$31c01b2337a4e7bc);
$parcel$export(module.exports, "PAUSED_BREACHED_STYLE", () => $aed6bfb6da5b8978$export$ca3b08ed23a07398);
$parcel$export(module.exports, "PAUSED_UNDER_THIRTY_REMAINING_STYLE", () => $aed6bfb6da5b8978$export$2866aae38e6ee5dc);
$parcel$export(module.exports, "ONGOING_STYLE", () => $aed6bfb6da5b8978$export$867e46b264a774ee);
$parcel$export(module.exports, "ONGOING_BREACHED_STYLE", () => $aed6bfb6da5b8978$export$a8f25d0554ec3ad7);
$parcel$export(module.exports, "ONGOING_UNDER_THIRTY_REMAINING_STYLE", () => $aed6bfb6da5b8978$export$700ee37c8cfc07d8);
const $aed6bfb6da5b8978$var$defaultBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $aed6bfb6da5b8978$var$successFailureBackgroundColor = "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
const $aed6bfb6da5b8978$var$defaultTextColor = "var(--ds-text-subtle, #44546F)";
const $aed6bfb6da5b8978$export$e0b777e1e3a27f60 = {
    backgroundColor: $aed6bfb6da5b8978$var$successFailureBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    iconColor: "var(--ds-icon-success, #22A06B)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$979e63416456f996 = {
    backgroundColor: $aed6bfb6da5b8978$var$successFailureBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    iconColor: "var(--ds-icon-danger, #C9372C)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$31c01b2337a4e7bc = {
    backgroundColor: $aed6bfb6da5b8978$var$defaultBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    iconColor: "var(--ds-icon-subtle, #626F86)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$ca3b08ed23a07398 = {
    backgroundColor: $aed6bfb6da5b8978$var$defaultBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    iconColor: "var(--ds-icon-inverse, #FFFFFF)",
    backgroundIconColor: "var(--ds-icon-danger, #C9372C)"
};
const $aed6bfb6da5b8978$export$2866aae38e6ee5dc = {
    backgroundColor: $aed6bfb6da5b8978$var$defaultBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    iconColor: "var(--ds-icon-inverse, #FFFFFF)",
    backgroundIconColor: "var(--ds-icon-warning, #E56910)"
};
const $aed6bfb6da5b8978$export$867e46b264a774ee = {
    backgroundColor: $aed6bfb6da5b8978$var$defaultBackgroundColor,
    textColor: $aed6bfb6da5b8978$var$defaultTextColor,
    iconColor: "var(--ds-icon-subtle, #626F86)",
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$a8f25d0554ec3ad7 = {
    backgroundColor: "var(--ds-background-danger-bold, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    iconColor: "var(--ds-icon-inverse, #FFFFFF)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    backgroundIconColor: 'transparent'
};
const $aed6bfb6da5b8978$export$700ee37c8cfc07d8 = {
    backgroundColor: "var(--ds-background-warning-bold, #F5CD47)",
    textColor: "var(--ds-text-warning-inverse, #172B4D)",
    iconColor: "var(--ds-text-warning-inverse, #172B4D)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    backgroundIconColor: 'transparent'
};

});

parcelRegister("gVtcM", function(module, exports) {

$parcel$export(module.exports, "SlaFieldTransformer", () => $2d5607b6fb0646db$export$631ca5fe503ed873);

var $gwejS = parcelRequire("gwejS");
var $it1wb = parcelRequire("it1wb");
var $pyK8a = parcelRequire("pyK8a");

var $dwDIK = parcelRequire("dwDIK");
var $7CMcV = parcelRequire("7CMcV");

var $2YZCu = parcelRequire("2YZCu");

var $aWse0 = parcelRequire("aWse0");


var $DVljb = parcelRequire("DVljb");

var $leRCk = parcelRequire("leRCk");

var $3UxsC = parcelRequire("3UxsC");

const $2d5607b6fb0646db$var$LOCATION = 'servicedesk.queues.selectors.fields-transformers.json-fields.custom-fields';
const $2d5607b6fb0646db$var$checkCycleValidity = (cycle)=>{
    const { remainingTime: remainingTime, goalDuration: goalDuration, elapsedTime: elapsedTime } = cycle;
    const undefinedValues = [];
    if (!remainingTime) undefinedValues.push('remainingTime');
    if (!goalDuration) undefinedValues.push('goalDuration');
    if (!elapsedTime) undefinedValues.push('elapsedTime');
    return undefinedValues;
};
const $2d5607b6fb0646db$var$isCompletedCycleValid = (cycle)=>{
    const undefinedValues = $2d5607b6fb0646db$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData($2d5607b6fb0646db$var$LOCATION, `[FD-4303] CompletedCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $2d5607b6fb0646db$var$isOngoingCycleValid = (cycle)=>{
    const undefinedValues = $2d5607b6fb0646db$var$checkCycleValidity(cycle);
    if (undefinedValues.length > 0) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData($2d5607b6fb0646db$var$LOCATION, `[FD-4303] OngoingCycle data is invalid: ${String(undefinedValues)}`);
        return false;
    }
    return true;
};
const $2d5607b6fb0646db$var$getLastCompletedCycle = (completedCycles)=>{
    let lastCompletedCycle = completedCycles[0];
    completedCycles.forEach((cycle)=>{
        if (cycle.stopTime.epochMillis > lastCompletedCycle.stopTime.epochMillis) lastCompletedCycle = cycle;
    });
    return lastCompletedCycle;
};
const $2d5607b6fb0646db$var$getDays = (timezone)=>{
    const date = (0, $7CMcV.default)(new Date(), timezone);
    return [
        (0, $it1wb.default)(date),
        (0, $it1wb.default)((0, $gwejS.default)(date, 1)),
        (0, $it1wb.default)((0, $pyK8a.default)(date, 1))
    ];
};
// This shall be deleted when localised time shown feature is fully rolled out
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2d5607b6fb0646db$var$getMatchingDay = (receivedDate, timezone, formatMessage)=>{
    const [today, tomorrow, yesterday] = $2d5607b6fb0646db$var$getDays(timezone);
    const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
    const isToday = isSame(today, receivedDate);
    const isTomorrow = isSame(tomorrow, receivedDate);
    const isYesterday = isSame(yesterday, receivedDate);
    let defaultDayFormat = (0, $dwDIK.default)(receivedDate, 'd MMM');
    isToday && (defaultDayFormat = formatMessage((0, $3UxsC.default).today));
    isTomorrow && (defaultDayFormat = formatMessage((0, $3UxsC.default).tomorrow));
    isYesterday && (defaultDayFormat = formatMessage((0, $3UxsC.default).yesterday));
    return defaultDayFormat;
};
const $2d5607b6fb0646db$export$9015300e6978c54b = (timeInEpochMillis, userTimezone, formatMessage)=>{
    if (timeInEpochMillis) {
        const breachTimeTz = (0, $7CMcV.default)(timeInEpochMillis, userTimezone);
        return `${$2d5607b6fb0646db$var$getMatchingDay(breachTimeTz, userTimezone, formatMessage)} ${(0, $dwDIK.default)(breachTimeTz, 'hh:mm a', {
            timeZone: userTimezone
        })}`;
    }
    return '';
};
const $2d5607b6fb0646db$export$631ca5fe503ed873 = ({ storedValue: storedValue })=>{
    const { value: responseValue } = storedValue;
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    const userTimezone = loggedInUser?.timeZone || 'America/Toronto';
    const { formatMessage: formatMessage, formatDate: formatDate } = (0, $aWse0.useIntlV2)();
    let locale = (0, $DVljb.useLocale)();
    if (locale === undefined) locale = 'en_US';
    const localeString = locale.replace('_', '-');
    const dateTimeFormat = new Intl.DateTimeFormat(localeString, {
        hour: 'numeric'
    });
    const isBrowserLocale24h = ()=>!dateTimeFormat.format(0).match(/[A/P]M/);
    const getMatchingDayForLocale = (receivedDate, timeInEpochMillis)=>{
        const [today, tomorrow, yesterday] = $2d5607b6fb0646db$var$getDays(userTimezone);
        const isSame = (dateOne, dateTwo)=>dateOne.getDate() === dateTwo.getDate() && dateOne.getMonth() === dateTwo.getMonth() && dateOne.getFullYear() === dateTwo.getFullYear();
        const isToday = isSame(today, receivedDate);
        const isTomorrow = isSame(tomorrow, receivedDate);
        const isYesterday = isSame(yesterday, receivedDate);
        let defaultDayFormat = formatDate(timeInEpochMillis, {
            timeZone: userTimezone,
            day: '2-digit',
            month: 'short'
        });
        isToday && (defaultDayFormat = formatMessage((0, $3UxsC.default).today));
        isTomorrow && (defaultDayFormat = formatMessage((0, $3UxsC.default).tomorrow));
        isYesterday && (defaultDayFormat = formatMessage((0, $3UxsC.default).yesterday));
        return defaultDayFormat;
    };
    const getTimeInSlaFriendlierFormatForLocale = (timeInEpochMillis)=>{
        if (timeInEpochMillis) {
            const breachTimeTz = (0, $7CMcV.default)(timeInEpochMillis, userTimezone);
            return `${getMatchingDayForLocale(breachTimeTz, timeInEpochMillis)} ${formatDate(timeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                hour: '2-digit',
                minute: '2-digit'
            })}`;
        }
        return '';
    };
    const getTimeRemainingInMinutes = (timeInHourSpaceMinutes)=>{
        const isTimeInMinus = timeInHourSpaceMinutes.indexOf('-') === 0;
        const absoluteTime = isTimeInMinus ? timeInHourSpaceMinutes.substring(1) : timeInHourSpaceMinutes;
        const millis = parseInt(absoluteTime, 10);
        const totalMinutes = millis / 60000;
        return isTimeInMinus ? -1 * totalMinutes : totalMinutes;
    };
    const getPercentageOfTimeTaken = (goalTime, remainingTime)=>{
        const goalTimeInMinutes = getTimeRemainingInMinutes(goalTime);
        const remainingTimeInMinutes = getTimeRemainingInMinutes(remainingTime);
        let percentage = (goalTimeInMinutes - remainingTimeInMinutes) / goalTimeInMinutes;
        // @ts-expect-error - TS2322 - Type 'string' is not assignable to type 'number'.
        percentage = (percentage * 100).toFixed(2);
        // @ts-expect-error - TS2345 - Argument of type 'number' is not assignable to parameter of type 'string'.
        return Math.round(parseInt(percentage, 10)).toString();
    };
    const getBreachTimeInLocalStringForLocale = (breachTimeInEpochMillis)=>{
        if (breachTimeInEpochMillis) {
            const BREACH_DATE = (0, $7CMcV.default)(breachTimeInEpochMillis, userTimezone);
            return `${formatDate(breachTimeInEpochMillis, {
                hour12: !isBrowserLocale24h(),
                timeZone: userTimezone,
                year: 'numeric',
                month: '2-digit',
                day: '2-digit',
                hour: '2-digit',
                minute: '2-digit'
            })} GMT${(0, $dwDIK.default)(BREACH_DATE, 'xx', {
                timeZone: userTimezone
            })}`;
        }
        return `${formatMessage((0, $3UxsC.default).notApplicable)}`;
    };
    const getHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly)=>{
        const isTimeInMinus = remainingTimeFriendly.indexOf('-') === 0;
        let remainingTimeString;
        let timeStatus;
        if (isTimeInMinus) {
            remainingTimeString = remainingTimeFriendly.substring(1);
            timeStatus = formatMessage((0, $3UxsC.default).past);
        } else {
            remainingTimeString = remainingTimeFriendly;
            timeStatus = formatMessage((0, $3UxsC.default).left);
        }
        if (closed === true) {
            timeStatus = isTimeInMinus ? formatMessage((0, $3UxsC.default).breached) : formatMessage((0, $3UxsC.default).met);
            const percentage = getPercentageOfTimeTaken(goalTimeMillis, remainingTimeMillis);
            const hoverContentCompleted = `${isTimeInMinus ? `-${remainingTimeString}` : remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${percentage}% of ${goalTimeLongFriendly} ${String.fromCodePoint(0x2022)} ${getBreachTimeInLocalStringForLocale(breachTime)}`;
            return hoverContentCompleted;
        }
        const hoverContent = `${remainingTimeString} ${timeStatus ?? ''} ${String.fromCodePoint(0x2022)} ${formatMessage((0, $3UxsC.default).due) ?? ''}: ${getBreachTimeInLocalStringForLocale(breachTime)}`;
        return hoverContent;
    };
    const friendlierHoverContent = (closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly, slaDisplayFormat)=>slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? getHoverContent(closed, remainingTimeMillis, breachTime, goalTimeMillis, goalTimeLongFriendly, remainingTimeFriendly) : undefined;
    // @ts-expect-error - TS2339 - Property 'errorMessage' does not exist on type 'Sla | SlaError'.
    if (responseValue && responseValue.errorMessage) return {
        fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b),
        value: responseValue
    };
    if (responseValue && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    responseValue.ongoingCycle && // @ts-expect-error - TS2339 - Property 'ongoingCycle' does not exist on type 'Sla | SlaError'.
    $2d5607b6fb0646db$var$isOngoingCycleValid(responseValue.ongoingCycle)) {
        const { paused: paused, remainingTime: remainingTime, breached: breached, breachTime: breachTime, goalDuration: goalDuration, elapsedTime: elapsedTime, withinCalendarHours: withinCalendarHours } = responseValue.ongoingCycle;
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $c8b70567b277fe50$export$13ecaaf97b049384);
        // When an SLA is paused due to being outside of working hours, the paused value is false
        const status = paused || !withinCalendarHours ? (0, $b25eb0ff361bcea0$export$3ad39751a33c16b8) : (0, $b25eb0ff361bcea0$export$d1917132a74c7b93);
        const timeRemainingInMinutes = Math.floor(remainingTime.millis / 60000);
        const breachTimeFriendly = breachTime ? breachTime.friendly : undefined;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(breachTime?.epochMillis).toString();
        return {
            fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b),
            value: {
                status: status,
                timeRemainingFriendly: slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                breachTime: breachTimeFriendly,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: withinCalendarHours,
                hoverContent: friendlierHoverContent(false, `${remainingTime.millis}`, breachTime?.epochMillis, goalDuration.millis, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    if (responseValue && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles && // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
    responseValue.completedCycles.length !== 0) {
        const slaDisplayFormat = // @ts-expect-error - TS2339 - Property 'slaDisplayFormat' does not exist on type 'Sla | SlaError'.
        responseValue.slaDisplayFormat ?? (0, $c8b70567b277fe50$export$13ecaaf97b049384);
        // @ts-expect-error - TS2339 - Property 'completedCycles' does not exist on type 'Sla | SlaError'.
        const lastCompletedCycle = $2d5607b6fb0646db$var$getLastCompletedCycle(responseValue.completedCycles);
        if (!$2d5607b6fb0646db$var$isCompletedCycleValid(lastCompletedCycle)) return {
            fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b)
        };
        const timeRemainingInMinutes = Math.floor(lastCompletedCycle.remainingTime.millis / 60000);
        const { remainingTime: remainingTime, breached: breached, goalDuration: goalDuration, elapsedTime: elapsedTime, stopTime: stopTime, breachTime: breachTime } = lastCompletedCycle;
        const timeInFriendlyFormat = ()=>getTimeInSlaFriendlierFormatForLocale(stopTime.epochMillis).toString();
        return {
            fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b),
            value: {
                status: (0, $b25eb0ff361bcea0$export$fc332a617fd34192),
                timeRemainingFriendly: slaDisplayFormat === (0, $c8b70567b277fe50$export$13ecaaf97b049384) ? timeInFriendlyFormat() : remainingTime.friendly,
                isBreached: breached,
                timeRemainingInMinutes: timeRemainingInMinutes,
                // A completed cycle doesn't have a breachTime value
                breachTime: undefined,
                elapsedTime: elapsedTime.friendly,
                goalDuration: goalDuration.friendly,
                withinCalendarHours: undefined,
                hoverContent: friendlierHoverContent(true, `${remainingTime.millis}`, breachTime?.epochMillis, `${goalDuration.millis}`, goalDuration.friendly, remainingTime.friendly, slaDisplayFormat),
                slaDisplayFormat: slaDisplayFormat
            }
        };
    }
    return {
        fieldType: (0, $b25eb0ff361bcea0$export$f790c24298ed441b)
    };
};

});
const $c8b70567b277fe50$export$aad60a8e044b5914 = 'OLD_SLA_FORMAT';
const $c8b70567b277fe50$export$13ecaaf97b049384 = 'NEW_SLA_FORMAT';

parcelRegister("DVljb", function(module, exports) {

$parcel$export(module.exports, "useLocale", () => $7c760643dc748494$export$43bb16f9c6d9e3f7);
$parcel$export(module.exports, "useNativeLocale", () => $7c760643dc748494$export$31652d9c30d7d3f3);

var $5uXOq = parcelRequire("5uXOq");

var $lzeFL = parcelRequire("lzeFL");

var $9OXo1 = parcelRequire("9OXo1");
const $7c760643dc748494$export$43bb16f9c6d9e3f7 = ()=>{
    const tenantContext = (0, $9OXo1.useTenantContext)();
    return tenantContext && tenantContext.locale || (0, $lzeFL.defaultLocale);
};
const $7c760643dc748494$export$31652d9c30d7d3f3 = ()=>{
    const locale = $7c760643dc748494$export$43bb16f9c6d9e3f7();
    const standardizedLocale = (0, $5uXOq.useMemo)(()=>(0, $lzeFL.standardizeLocale)(locale), [
        locale
    ]);
    return standardizedLocale;
};

});

parcelRegister("3UxsC", function(module, exports) {

$parcel$export(module.exports, "default", () => $052279bee594c9ad$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $052279bee594c9ad$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.title",
        "defaultMessage": "SLAs"
    },
    past: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.past",
        "defaultMessage": "past"
    },
    left: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.left",
        "defaultMessage": "left"
    },
    met: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.met",
        "defaultMessage": "met"
    },
    breached: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.breached",
        "defaultMessage": "breached"
    },
    due: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.due",
        "defaultMessage": "Due"
    },
    today: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.today",
        "defaultMessage": "Today"
    },
    tomorrow: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.tomorrow",
        "defaultMessage": "Tomorrow"
    },
    yesterday: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.yesterday",
        "defaultMessage": "Yesterday"
    },
    notApplicable: {
        "id": "servicedesk.queues.common.state.selectors.issues.field-transformers.json-fields.custom-fields.not-applicable",
        "defaultMessage": "Breach time not found"
    }
});

});

const $b25eb0ff361bcea0$export$d1917132a74c7b93 = 'ONGOING';
const $b25eb0ff361bcea0$export$fc332a617fd34192 = 'COMPLETED';
const $b25eb0ff361bcea0$export$3ad39751a33c16b8 = 'PAUSED';
const $b25eb0ff361bcea0$export$f790c24298ed441b = 'com.atlassian.servicedesk:sd-sla-field';




parcelRegister("khuza", function(module, exports) {

$parcel$export(module.exports, "CustomFieldTooltip", () => $52d0364850dc7782$export$5ab920ffa0a3e029);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");
const $52d0364850dc7782$export$5ab920ffa0a3e029 = ({ field: field, children: children })=>{
    const { label: label } = field;
    const [tooltipContent, setTooltipContent] = (0, $5uXOq.useState)(label);
    const ref = (0, $5uXOq.useRef)(null);
    const onShow = ()=>{
        if (ref.current && ref.current.innerText) {
            const toolTipString = `${label}: ${ref.current.innerText}`;
            if (toolTipString !== tooltipContent) setTooltipContent(toolTipString);
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        onShow: onShow,
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref
    }, children));
};

});

parcelRegister("71sS1", function(module, exports) {

$parcel$export(module.exports, "HtmlCardCustomFieldContent", () => $1ee715bf797bb541$export$b0d54fd3c476d26b);
$parcel$export(module.exports, "CustomCardFieldContainer", () => $1ee715bf797bb541$export$6ba966c410f0ea4);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hXLCJ = parcelRequire("hXLCJ");

var $cSD7y = parcelRequire("cSD7y");
const $1ee715bf797bb541$export$b0d54fd3c476d26b = ({ field: field })=>{
    const stopIssueModalOpen = (event)=>{
        if (field.label === 'Development') event.stopPropagation();
    };
    // filter out jQuery LiveStamp hooks which replace desired time html with a relative date in CMP UIF Kanban
    const htmlWithJQueryLiveStampClassesRemoved = field?.html && field.html.replace('livestamp allow-future', '');
    return field.html ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ee715bf797bb541$export$6ba966c410f0ea4, {
        "data-testid": "platform-card.common.ui.custom-fields.card-custom-field.html-card-custom-field-content.html-field",
        "data-issuefieldid": field.id,
        dangerouslySetInnerHTML: {
            __html: (0, (/*@__PURE__*/$parcel$interopDefault($hXLCJ))).sanitize(htmlWithJQueryLiveStampClassesRemoved ?? '')
        },
        disablePointerEvents: field.id === 'thumbnail',
        onClick: stopIssueModalOpen
    }) : null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1ee715bf797bb541$var$CustomCardFieldContainerBase = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNone: isNone, disablePointerEvents: disablePointerEvents, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _o5721q9c _p12f1osq _2hwx1wug _1bto1l2s _syaz131l _1bsk1osq _1y8m1wug _1maq1b66 _14991b66 _w9a21wug _bbhg1wug _1rjkglyw _1rxbnkob _1jbznkob _umv415vq _wwzv15vq _w77h1osq _5rkt1l2s _1suh1wug _xnkt1wug _rtysuuw1 _19l353f4 _1md0idpf _qehnidpf _18vridpf _1nlwidpf _12isidpf _ql9ct94y _1ci4idpf _1qwe1ule _1npa1y44 _pokj1osq _gzx61wug _knrj1l7b _1urb1y44 _7998idpf _18pvidpf _11o7idpf _17l5idpf _1mmrt94y",
            __cmplp.isNone ? "_zg8l1m30" : "_zg8l1kw7",
            __cmplp.isNone ? "_tzy4txnc" : "_tzy4kb7n",
            __cmplp.disablePointerEvents ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $1ee715bf797bb541$export$6ba966c410f0ea4 = (0, $cSD7y.componentWithFG)('tanuki_a11y_q4', // On tanuki_a11y_q4 cleanup, merge `color` rule inside CustomCardFieldContainerBase
(props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1ee715bf797bb541$var$CustomCardFieldContainerBase, {
        ...props,
        className: (0, $bwpsq.default)([
            "_syaz1gjq"
        ])
    }), $1ee715bf797bb541$var$CustomCardFieldContainerBase);

});
parcelRegister("hXLCJ", function(module, exports) {
/*! @license DOMPurify 2.5.7 | (c) Cure53 and other contributors | Released under the Apache license 2.0 and Mozilla Public License 2.0 | github.com/cure53/DOMPurify/blob/2.5.7/LICENSE */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    'use strict';
    function _typeof(obj) {
        "@babel/helpers - typeof";
        return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(obj) {
            return typeof obj;
        } : function(obj) {
            return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
        }, _typeof(obj);
    }
    function _setPrototypeOf(o, p) {
        _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
            o.__proto__ = p;
            return o;
        };
        return _setPrototypeOf(o, p);
    }
    function _isNativeReflectConstruct() {
        if (typeof Reflect === "undefined" || !Reflect.construct) return false;
        if (Reflect.construct.sham) return false;
        if (typeof Proxy === "function") return true;
        try {
            Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
            return true;
        } catch (e) {
            return false;
        }
    }
    function _construct(Parent, args, Class) {
        if (_isNativeReflectConstruct()) _construct = Reflect.construct;
        else _construct = function _construct(Parent, args, Class) {
            var a = [
                null
            ];
            a.push.apply(a, args);
            var Constructor = Function.bind.apply(Parent, a);
            var instance = new Constructor();
            if (Class) _setPrototypeOf(instance, Class.prototype);
            return instance;
        };
        return _construct.apply(null, arguments);
    }
    function _toConsumableArray(arr) {
        return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
    }
    function _arrayWithoutHoles(arr) {
        if (Array.isArray(arr)) return _arrayLikeToArray(arr);
    }
    function _iterableToArray(iter) {
        if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
    }
    function _unsupportedIterableToArray(o, minLen) {
        if (!o) return;
        if (typeof o === "string") return _arrayLikeToArray(o, minLen);
        var n = Object.prototype.toString.call(o).slice(8, -1);
        if (n === "Object" && o.constructor) n = o.constructor.name;
        if (n === "Map" || n === "Set") return Array.from(o);
        if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
    }
    function _arrayLikeToArray(arr, len) {
        if (len == null || len > arr.length) len = arr.length;
        for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
        return arr2;
    }
    function _nonIterableSpread() {
        throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var hasOwnProperty = Object.hasOwnProperty, setPrototypeOf = Object.setPrototypeOf, isFrozen = Object.isFrozen, getPrototypeOf = Object.getPrototypeOf, getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
    var freeze = Object.freeze, seal = Object.seal, create = Object.create; // eslint-disable-line import/no-mutable-exports
    var _ref = typeof Reflect !== 'undefined' && Reflect, apply = _ref.apply, construct = _ref.construct;
    if (!apply) apply = function apply(fun, thisValue, args) {
        return fun.apply(thisValue, args);
    };
    if (!freeze) freeze = function freeze(x) {
        return x;
    };
    if (!seal) seal = function seal(x) {
        return x;
    };
    if (!construct) construct = function construct(Func, args) {
        return _construct(Func, _toConsumableArray(args));
    };
    var arrayForEach = unapply(Array.prototype.forEach);
    var arrayPop = unapply(Array.prototype.pop);
    var arrayPush = unapply(Array.prototype.push);
    var stringToLowerCase = unapply(String.prototype.toLowerCase);
    var stringToString = unapply(String.prototype.toString);
    var stringMatch = unapply(String.prototype.match);
    var stringReplace = unapply(String.prototype.replace);
    var stringIndexOf = unapply(String.prototype.indexOf);
    var stringTrim = unapply(String.prototype.trim);
    var regExpTest = unapply(RegExp.prototype.test);
    var typeErrorCreate = unconstruct(TypeError);
    function unapply(func) {
        return function(thisArg) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            return apply(func, thisArg, args);
        };
    }
    function unconstruct(func) {
        return function() {
            for(var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)args[_key2] = arguments[_key2];
            return construct(func, args);
        };
    }
    /* Add properties to a lookup table */ function addToSet(set, array, transformCaseFunc) {
        var _transformCaseFunc;
        transformCaseFunc = (_transformCaseFunc = transformCaseFunc) !== null && _transformCaseFunc !== void 0 ? _transformCaseFunc : stringToLowerCase;
        if (setPrototypeOf) // Make 'in' and truthy checks like Boolean(set.constructor)
        // independent of any properties defined on Object.prototype.
        // Prevent prototype setters from intercepting set as a this value.
        setPrototypeOf(set, null);
        var l = array.length;
        while(l--){
            var element = array[l];
            if (typeof element === 'string') {
                var lcElement = transformCaseFunc(element);
                if (lcElement !== element) {
                    // Config presets (e.g. tags.js, attrs.js) are immutable.
                    if (!isFrozen(array)) array[l] = lcElement;
                    element = lcElement;
                }
            }
            set[element] = true;
        }
        return set;
    }
    /* Shallow clone an object */ function clone(object) {
        var newObject = create(null);
        var property;
        for(property in object)if (apply(hasOwnProperty, object, [
            property
        ]) === true) newObject[property] = object[property];
        return newObject;
    }
    /* IE10 doesn't support __lookupGetter__ so lets'
   * simulate it. It also automatically checks
   * if the prop is function or getter and behaves
   * accordingly. */ function lookupGetter(object, prop) {
        while(object !== null){
            var desc = getOwnPropertyDescriptor(object, prop);
            if (desc) {
                if (desc.get) return unapply(desc.get);
                if (typeof desc.value === 'function') return unapply(desc.value);
            }
            object = getPrototypeOf(object);
        }
        function fallbackValue(element) {
            console.warn('fallback value for', element);
            return null;
        }
        return fallbackValue;
    }
    var html$1 = freeze([
        'a',
        'abbr',
        'acronym',
        'address',
        'area',
        'article',
        'aside',
        'audio',
        'b',
        'bdi',
        'bdo',
        'big',
        'blink',
        'blockquote',
        'body',
        'br',
        'button',
        'canvas',
        'caption',
        'center',
        'cite',
        'code',
        'col',
        'colgroup',
        'content',
        'data',
        'datalist',
        'dd',
        'decorator',
        'del',
        'details',
        'dfn',
        'dialog',
        'dir',
        'div',
        'dl',
        'dt',
        'element',
        'em',
        'fieldset',
        'figcaption',
        'figure',
        'font',
        'footer',
        'form',
        'h1',
        'h2',
        'h3',
        'h4',
        'h5',
        'h6',
        'head',
        'header',
        'hgroup',
        'hr',
        'html',
        'i',
        'img',
        'input',
        'ins',
        'kbd',
        'label',
        'legend',
        'li',
        'main',
        'map',
        'mark',
        'marquee',
        'menu',
        'menuitem',
        'meter',
        'nav',
        'nobr',
        'ol',
        'optgroup',
        'option',
        'output',
        'p',
        'picture',
        'pre',
        'progress',
        'q',
        'rp',
        'rt',
        'ruby',
        's',
        'samp',
        'section',
        'select',
        'shadow',
        'small',
        'source',
        'spacer',
        'span',
        'strike',
        'strong',
        'style',
        'sub',
        'summary',
        'sup',
        'table',
        'tbody',
        'td',
        'template',
        'textarea',
        'tfoot',
        'th',
        'thead',
        'time',
        'tr',
        'track',
        'tt',
        'u',
        'ul',
        'var',
        'video',
        'wbr'
    ]);
    // SVG
    var svg$1 = freeze([
        'svg',
        'a',
        'altglyph',
        'altglyphdef',
        'altglyphitem',
        'animatecolor',
        'animatemotion',
        'animatetransform',
        'circle',
        'clippath',
        'defs',
        'desc',
        'ellipse',
        'filter',
        'font',
        'g',
        'glyph',
        'glyphref',
        'hkern',
        'image',
        'line',
        'lineargradient',
        'marker',
        'mask',
        'metadata',
        'mpath',
        'path',
        'pattern',
        'polygon',
        'polyline',
        'radialgradient',
        'rect',
        'stop',
        'style',
        'switch',
        'symbol',
        'text',
        'textpath',
        'title',
        'tref',
        'tspan',
        'view',
        'vkern'
    ]);
    var svgFilters = freeze([
        'feBlend',
        'feColorMatrix',
        'feComponentTransfer',
        'feComposite',
        'feConvolveMatrix',
        'feDiffuseLighting',
        'feDisplacementMap',
        'feDistantLight',
        'feFlood',
        'feFuncA',
        'feFuncB',
        'feFuncG',
        'feFuncR',
        'feGaussianBlur',
        'feImage',
        'feMerge',
        'feMergeNode',
        'feMorphology',
        'feOffset',
        'fePointLight',
        'feSpecularLighting',
        'feSpotLight',
        'feTile',
        'feTurbulence'
    ]);
    // List of SVG elements that are disallowed by default.
    // We still need to know them so that we can do namespace
    // checks properly in case one wants to add them to
    // allow-list.
    var svgDisallowed = freeze([
        'animate',
        'color-profile',
        'cursor',
        'discard',
        'fedropshadow',
        'font-face',
        'font-face-format',
        'font-face-name',
        'font-face-src',
        'font-face-uri',
        'foreignobject',
        'hatch',
        'hatchpath',
        'mesh',
        'meshgradient',
        'meshpatch',
        'meshrow',
        'missing-glyph',
        'script',
        'set',
        'solidcolor',
        'unknown',
        'use'
    ]);
    var mathMl$1 = freeze([
        'math',
        'menclose',
        'merror',
        'mfenced',
        'mfrac',
        'mglyph',
        'mi',
        'mlabeledtr',
        'mmultiscripts',
        'mn',
        'mo',
        'mover',
        'mpadded',
        'mphantom',
        'mroot',
        'mrow',
        'ms',
        'mspace',
        'msqrt',
        'mstyle',
        'msub',
        'msup',
        'msubsup',
        'mtable',
        'mtd',
        'mtext',
        'mtr',
        'munder',
        'munderover'
    ]);
    // Similarly to SVG, we want to know all MathML elements,
    // even those that we disallow by default.
    var mathMlDisallowed = freeze([
        'maction',
        'maligngroup',
        'malignmark',
        'mlongdiv',
        'mscarries',
        'mscarry',
        'msgroup',
        'mstack',
        'msline',
        'msrow',
        'semantics',
        'annotation',
        'annotation-xml',
        'mprescripts',
        'none'
    ]);
    var text = freeze([
        '#text'
    ]);
    var html = freeze([
        'accept',
        'action',
        'align',
        'alt',
        'autocapitalize',
        'autocomplete',
        'autopictureinpicture',
        'autoplay',
        'background',
        'bgcolor',
        'border',
        'capture',
        'cellpadding',
        'cellspacing',
        'checked',
        'cite',
        'class',
        'clear',
        'color',
        'cols',
        'colspan',
        'controls',
        'controlslist',
        'coords',
        'crossorigin',
        'datetime',
        'decoding',
        'default',
        'dir',
        'disabled',
        'disablepictureinpicture',
        'disableremoteplayback',
        'download',
        'draggable',
        'enctype',
        'enterkeyhint',
        'face',
        'for',
        'headers',
        'height',
        'hidden',
        'high',
        'href',
        'hreflang',
        'id',
        'inputmode',
        'integrity',
        'ismap',
        'kind',
        'label',
        'lang',
        'list',
        'loading',
        'loop',
        'low',
        'max',
        'maxlength',
        'media',
        'method',
        'min',
        'minlength',
        'multiple',
        'muted',
        'name',
        'nonce',
        'noshade',
        'novalidate',
        'nowrap',
        'open',
        'optimum',
        'pattern',
        'placeholder',
        'playsinline',
        'poster',
        'preload',
        'pubdate',
        'radiogroup',
        'readonly',
        'rel',
        'required',
        'rev',
        'reversed',
        'role',
        'rows',
        'rowspan',
        'spellcheck',
        'scope',
        'selected',
        'shape',
        'size',
        'sizes',
        'span',
        'srclang',
        'start',
        'src',
        'srcset',
        'step',
        'style',
        'summary',
        'tabindex',
        'title',
        'translate',
        'type',
        'usemap',
        'valign',
        'value',
        'width',
        'xmlns',
        'slot'
    ]);
    var svg = freeze([
        'accent-height',
        'accumulate',
        'additive',
        'alignment-baseline',
        'ascent',
        'attributename',
        'attributetype',
        'azimuth',
        'basefrequency',
        'baseline-shift',
        'begin',
        'bias',
        'by',
        'class',
        'clip',
        'clippathunits',
        'clip-path',
        'clip-rule',
        'color',
        'color-interpolation',
        'color-interpolation-filters',
        'color-profile',
        'color-rendering',
        'cx',
        'cy',
        'd',
        'dx',
        'dy',
        'diffuseconstant',
        'direction',
        'display',
        'divisor',
        'dur',
        'edgemode',
        'elevation',
        'end',
        'fill',
        'fill-opacity',
        'fill-rule',
        'filter',
        'filterunits',
        'flood-color',
        'flood-opacity',
        'font-family',
        'font-size',
        'font-size-adjust',
        'font-stretch',
        'font-style',
        'font-variant',
        'font-weight',
        'fx',
        'fy',
        'g1',
        'g2',
        'glyph-name',
        'glyphref',
        'gradientunits',
        'gradienttransform',
        'height',
        'href',
        'id',
        'image-rendering',
        'in',
        'in2',
        'k',
        'k1',
        'k2',
        'k3',
        'k4',
        'kerning',
        'keypoints',
        'keysplines',
        'keytimes',
        'lang',
        'lengthadjust',
        'letter-spacing',
        'kernelmatrix',
        'kernelunitlength',
        'lighting-color',
        'local',
        'marker-end',
        'marker-mid',
        'marker-start',
        'markerheight',
        'markerunits',
        'markerwidth',
        'maskcontentunits',
        'maskunits',
        'max',
        'mask',
        'media',
        'method',
        'mode',
        'min',
        'name',
        'numoctaves',
        'offset',
        'operator',
        'opacity',
        'order',
        'orient',
        'orientation',
        'origin',
        'overflow',
        'paint-order',
        'path',
        'pathlength',
        'patterncontentunits',
        'patterntransform',
        'patternunits',
        'points',
        'preservealpha',
        'preserveaspectratio',
        'primitiveunits',
        'r',
        'rx',
        'ry',
        'radius',
        'refx',
        'refy',
        'repeatcount',
        'repeatdur',
        'restart',
        'result',
        'rotate',
        'scale',
        'seed',
        'shape-rendering',
        'specularconstant',
        'specularexponent',
        'spreadmethod',
        'startoffset',
        'stddeviation',
        'stitchtiles',
        'stop-color',
        'stop-opacity',
        'stroke-dasharray',
        'stroke-dashoffset',
        'stroke-linecap',
        'stroke-linejoin',
        'stroke-miterlimit',
        'stroke-opacity',
        'stroke',
        'stroke-width',
        'style',
        'surfacescale',
        'systemlanguage',
        'tabindex',
        'targetx',
        'targety',
        'transform',
        'transform-origin',
        'text-anchor',
        'text-decoration',
        'text-rendering',
        'textlength',
        'type',
        'u1',
        'u2',
        'unicode',
        'values',
        'viewbox',
        'visibility',
        'version',
        'vert-adv-y',
        'vert-origin-x',
        'vert-origin-y',
        'width',
        'word-spacing',
        'wrap',
        'writing-mode',
        'xchannelselector',
        'ychannelselector',
        'x',
        'x1',
        'x2',
        'xmlns',
        'y',
        'y1',
        'y2',
        'z',
        'zoomandpan'
    ]);
    var mathMl = freeze([
        'accent',
        'accentunder',
        'align',
        'bevelled',
        'close',
        'columnsalign',
        'columnlines',
        'columnspan',
        'denomalign',
        'depth',
        'dir',
        'display',
        'displaystyle',
        'encoding',
        'fence',
        'frame',
        'height',
        'href',
        'id',
        'largeop',
        'length',
        'linethickness',
        'lspace',
        'lquote',
        'mathbackground',
        'mathcolor',
        'mathsize',
        'mathvariant',
        'maxsize',
        'minsize',
        'movablelimits',
        'notation',
        'numalign',
        'open',
        'rowalign',
        'rowlines',
        'rowspacing',
        'rowspan',
        'rspace',
        'rquote',
        'scriptlevel',
        'scriptminsize',
        'scriptsizemultiplier',
        'selection',
        'separator',
        'separators',
        'stretchy',
        'subscriptshift',
        'supscriptshift',
        'symmetric',
        'voffset',
        'width',
        'xmlns'
    ]);
    var xml = freeze([
        'xlink:href',
        'xml:id',
        'xlink:title',
        'xml:space',
        'xmlns:xlink'
    ]);
    // eslint-disable-next-line unicorn/better-regex
    var MUSTACHE_EXPR = seal(/\{\{[\w\W]*|[\w\W]*\}\}/gm); // Specify template detection regex for SAFE_FOR_TEMPLATES mode
    var ERB_EXPR = seal(/<%[\w\W]*|[\w\W]*%>/gm);
    var TMPLIT_EXPR = seal(/\${[\w\W]*}/gm);
    var DATA_ATTR = seal(/^data-[\-\w.\u00B7-\uFFFF]/); // eslint-disable-line no-useless-escape
    var ARIA_ATTR = seal(/^aria-[\-\w]+$/); // eslint-disable-line no-useless-escape
    var IS_ALLOWED_URI = seal(/^(?:(?:(?:f|ht)tps?|mailto|tel|callto|cid|xmpp):|[^a-z]|[a-z+.\-]+(?:[^a-z+.\-:]|$))/i // eslint-disable-line no-useless-escape
    );
    var IS_SCRIPT_OR_DATA = seal(/^(?:\w+script|data):/i);
    var ATTR_WHITESPACE = seal(/[\u0000-\u0020\u00A0\u1680\u180E\u2000-\u2029\u205F\u3000]/g // eslint-disable-line no-control-regex
    );
    var DOCTYPE_NAME = seal(/^html$/i);
    var CUSTOM_ELEMENT = seal(/^[a-z][.\w]*(-[.\w]+)+$/i);
    var getGlobal = function getGlobal() {
        return typeof window === 'undefined' ? null : window;
    };
    /**
   * Creates a no-op policy for internal use only.
   * Don't export this function outside this module!
   * @param {?TrustedTypePolicyFactory} trustedTypes The policy factory.
   * @param {Document} document The document object (to determine policy name suffix)
   * @return {?TrustedTypePolicy} The policy created (or null, if Trusted Types
   * are not supported).
   */ var _createTrustedTypesPolicy = function _createTrustedTypesPolicy(trustedTypes, document) {
        if (_typeof(trustedTypes) !== 'object' || typeof trustedTypes.createPolicy !== 'function') return null;
        // Allow the callers to control the unique policy name
        // by adding a data-tt-policy-suffix to the script element with the DOMPurify.
        // Policy creation with duplicate names throws in Trusted Types.
        var suffix = null;
        var ATTR_NAME = 'data-tt-policy-suffix';
        if (document.currentScript && document.currentScript.hasAttribute(ATTR_NAME)) suffix = document.currentScript.getAttribute(ATTR_NAME);
        var policyName = 'dompurify' + (suffix ? '#' + suffix : '');
        try {
            return trustedTypes.createPolicy(policyName, {
                createHTML: function createHTML(html) {
                    return html;
                },
                createScriptURL: function createScriptURL(scriptUrl) {
                    return scriptUrl;
                }
            });
        } catch (_) {
            // Policy creation failed (most likely another DOMPurify script has
            // already run). Skip creating the policy, as this will only cause errors
            // if TT are enforced.
            console.warn('TrustedTypes policy ' + policyName + ' could not be created.');
            return null;
        }
    };
    function createDOMPurify() {
        var window1 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : getGlobal();
        var DOMPurify = function DOMPurify(root) {
            return createDOMPurify(root);
        };
        /**
     * Version label, exposed for easier checks
     * if DOMPurify is up to date or not
     */ DOMPurify.version = '2.5.7';
        /**
     * Array of elements that DOMPurify removed during sanitation.
     * Empty if nothing was removed.
     */ DOMPurify.removed = [];
        if (!window1 || !window1.document || window1.document.nodeType !== 9) {
            // Not running in a browser, provide a factory function
            // so that you can pass your own Window
            DOMPurify.isSupported = false;
            return DOMPurify;
        }
        var originalDocument = window1.document;
        var document = window1.document;
        var DocumentFragment = window1.DocumentFragment, HTMLTemplateElement = window1.HTMLTemplateElement, Node = window1.Node, Element = window1.Element, NodeFilter = window1.NodeFilter, _window$NamedNodeMap = window1.NamedNodeMap, NamedNodeMap = _window$NamedNodeMap === void 0 ? window1.NamedNodeMap || window1.MozNamedAttrMap : _window$NamedNodeMap, HTMLFormElement = window1.HTMLFormElement, DOMParser = window1.DOMParser, trustedTypes = window1.trustedTypes;
        var ElementPrototype = Element.prototype;
        var cloneNode = lookupGetter(ElementPrototype, 'cloneNode');
        var getNextSibling = lookupGetter(ElementPrototype, 'nextSibling');
        var getChildNodes = lookupGetter(ElementPrototype, 'childNodes');
        var getParentNode = lookupGetter(ElementPrototype, 'parentNode');
        // As per issue #47, the web-components registry is inherited by a
        // new document created via createHTMLDocument. As per the spec
        // (http://w3c.github.io/webcomponents/spec/custom/#creating-and-passing-registries)
        // a new empty registry is used when creating a template contents owner
        // document, so we use that as our parent document to ensure nothing
        // is inherited.
        if (typeof HTMLTemplateElement === 'function') {
            var template = document.createElement('template');
            if (template.content && template.content.ownerDocument) document = template.content.ownerDocument;
        }
        var trustedTypesPolicy = _createTrustedTypesPolicy(trustedTypes, originalDocument);
        var emptyHTML = trustedTypesPolicy ? trustedTypesPolicy.createHTML('') : '';
        var _document = document, implementation = _document.implementation, createNodeIterator = _document.createNodeIterator, createDocumentFragment = _document.createDocumentFragment, getElementsByTagName = _document.getElementsByTagName;
        var importNode = originalDocument.importNode;
        var documentMode = {};
        try {
            documentMode = clone(document).documentMode ? document.documentMode : {};
        } catch (_) {}
        var hooks = {};
        /**
     * Expose whether this browser supports running the full DOMPurify.
     */ DOMPurify.isSupported = typeof getParentNode === 'function' && implementation && implementation.createHTMLDocument !== undefined && documentMode !== 9;
        var MUSTACHE_EXPR$1 = MUSTACHE_EXPR, ERB_EXPR$1 = ERB_EXPR, TMPLIT_EXPR$1 = TMPLIT_EXPR, DATA_ATTR$1 = DATA_ATTR, ARIA_ATTR$1 = ARIA_ATTR, IS_SCRIPT_OR_DATA$1 = IS_SCRIPT_OR_DATA, ATTR_WHITESPACE$1 = ATTR_WHITESPACE, CUSTOM_ELEMENT$1 = CUSTOM_ELEMENT;
        var IS_ALLOWED_URI$1 = IS_ALLOWED_URI;
        /**
     * We consider the elements and attributes below to be safe. Ideally
     * don't add any new ones but feel free to remove unwanted ones.
     */ /* allowed element names */ var ALLOWED_TAGS = null;
        var DEFAULT_ALLOWED_TAGS = addToSet({}, [].concat(_toConsumableArray(html$1), _toConsumableArray(svg$1), _toConsumableArray(svgFilters), _toConsumableArray(mathMl$1), _toConsumableArray(text)));
        /* Allowed attribute names */ var ALLOWED_ATTR = null;
        var DEFAULT_ALLOWED_ATTR = addToSet({}, [].concat(_toConsumableArray(html), _toConsumableArray(svg), _toConsumableArray(mathMl), _toConsumableArray(xml)));
        /*
     * Configure how DOMPUrify should handle custom elements and their attributes as well as customized built-in elements.
     * @property {RegExp|Function|null} tagNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any custom elements)
     * @property {RegExp|Function|null} attributeNameCheck one of [null, regexPattern, predicate]. Default: `null` (disallow any attributes not on the allow list)
     * @property {boolean} allowCustomizedBuiltInElements allow custom elements derived from built-ins if they pass CUSTOM_ELEMENT_HANDLING.tagNameCheck. Default: `false`.
     */ var CUSTOM_ELEMENT_HANDLING = Object.seal(Object.create(null, {
            tagNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            attributeNameCheck: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: null
            },
            allowCustomizedBuiltInElements: {
                writable: true,
                configurable: false,
                enumerable: true,
                value: false
            }
        }));
        /* Explicitly forbidden tags (overrides ALLOWED_TAGS/ADD_TAGS) */ var FORBID_TAGS = null;
        /* Explicitly forbidden attributes (overrides ALLOWED_ATTR/ADD_ATTR) */ var FORBID_ATTR = null;
        /* Decide if ARIA attributes are okay */ var ALLOW_ARIA_ATTR = true;
        /* Decide if custom data attributes are okay */ var ALLOW_DATA_ATTR = true;
        /* Decide if unknown protocols are okay */ var ALLOW_UNKNOWN_PROTOCOLS = false;
        /* Decide if self-closing tags in attributes are allowed.
     * Usually removed due to a mXSS issue in jQuery 3.0 */ var ALLOW_SELF_CLOSE_IN_ATTR = true;
        /* Output should be safe for common template engines.
     * This means, DOMPurify removes data attributes, mustaches and ERB
     */ var SAFE_FOR_TEMPLATES = false;
        /* Output should be safe even for XML used within HTML and alike.
     * This means, DOMPurify removes comments when containing risky content.
     */ var SAFE_FOR_XML = true;
        /* Decide if document with <html>... should be returned */ var WHOLE_DOCUMENT = false;
        /* Track whether config is already set on this instance of DOMPurify. */ var SET_CONFIG = false;
        /* Decide if all elements (e.g. style, script) must be children of
     * document.body. By default, browsers might move them to document.head */ var FORCE_BODY = false;
        /* Decide if a DOM `HTMLBodyElement` should be returned, instead of a html
     * string (or a TrustedHTML object if Trusted Types are supported).
     * If `WHOLE_DOCUMENT` is enabled a `HTMLHtmlElement` will be returned instead
     */ var RETURN_DOM = false;
        /* Decide if a DOM `DocumentFragment` should be returned, instead of a html
     * string  (or a TrustedHTML object if Trusted Types are supported) */ var RETURN_DOM_FRAGMENT = false;
        /* Try to return a Trusted Type object instead of a string, return a string in
     * case Trusted Types are not supported  */ var RETURN_TRUSTED_TYPE = false;
        /* Output should be free from DOM clobbering attacks?
     * This sanitizes markups named with colliding, clobberable built-in DOM APIs.
     */ var SANITIZE_DOM = true;
        /* Achieve full DOM Clobbering protection by isolating the namespace of named
     * properties and JS variables, mitigating attacks that abuse the HTML/DOM spec rules.
     *
     * HTML/DOM spec rules that enable DOM Clobbering:
     *   - Named Access on Window (§7.3.3)
     *   - DOM Tree Accessors (§3.1.5)
     *   - Form Element Parent-Child Relations (§4.10.3)
     *   - Iframe srcdoc / Nested WindowProxies (§4.8.5)
     *   - HTMLCollection (§4.2.10.2)
     *
     * Namespace isolation is implemented by prefixing `id` and `name` attributes
     * with a constant string, i.e., `user-content-`
     */ var SANITIZE_NAMED_PROPS = false;
        var SANITIZE_NAMED_PROPS_PREFIX = 'user-content-';
        /* Keep element content when removing element? */ var KEEP_CONTENT = true;
        /* If a `Node` is passed to sanitize(), then performs sanitization in-place instead
     * of importing it into a new Document and returning a sanitized copy */ var IN_PLACE = false;
        /* Allow usage of profiles like html, svg and mathMl */ var USE_PROFILES = {};
        /* Tags to ignore content of when KEEP_CONTENT is true */ var FORBID_CONTENTS = null;
        var DEFAULT_FORBID_CONTENTS = addToSet({}, [
            'annotation-xml',
            'audio',
            'colgroup',
            'desc',
            'foreignobject',
            'head',
            'iframe',
            'math',
            'mi',
            'mn',
            'mo',
            'ms',
            'mtext',
            'noembed',
            'noframes',
            'noscript',
            'plaintext',
            'script',
            'style',
            'svg',
            'template',
            'thead',
            'title',
            'video',
            'xmp'
        ]);
        /* Tags that are safe for data: URIs */ var DATA_URI_TAGS = null;
        var DEFAULT_DATA_URI_TAGS = addToSet({}, [
            'audio',
            'video',
            'img',
            'source',
            'image',
            'track'
        ]);
        /* Attributes safe for values like "javascript:" */ var URI_SAFE_ATTRIBUTES = null;
        var DEFAULT_URI_SAFE_ATTRIBUTES = addToSet({}, [
            'alt',
            'class',
            'for',
            'id',
            'label',
            'name',
            'pattern',
            'placeholder',
            'role',
            'summary',
            'title',
            'value',
            'style',
            'xmlns'
        ]);
        var MATHML_NAMESPACE = 'http://www.w3.org/1998/Math/MathML';
        var SVG_NAMESPACE = 'http://www.w3.org/2000/svg';
        var HTML_NAMESPACE = 'http://www.w3.org/1999/xhtml';
        /* Document namespace */ var NAMESPACE = HTML_NAMESPACE;
        var IS_EMPTY_INPUT = false;
        /* Allowed XHTML+XML namespaces */ var ALLOWED_NAMESPACES = null;
        var DEFAULT_ALLOWED_NAMESPACES = addToSet({}, [
            MATHML_NAMESPACE,
            SVG_NAMESPACE,
            HTML_NAMESPACE
        ], stringToString);
        /* Parsing of strict XHTML documents */ var PARSER_MEDIA_TYPE;
        var SUPPORTED_PARSER_MEDIA_TYPES = [
            'application/xhtml+xml',
            'text/html'
        ];
        var DEFAULT_PARSER_MEDIA_TYPE = 'text/html';
        var transformCaseFunc;
        /* Keep a reference to config to pass to hooks */ var CONFIG = null;
        /* Ideally, do not touch anything below this line */ /* ______________________________________________ */ var formElement = document.createElement('form');
        var isRegexOrFunction = function isRegexOrFunction(testValue) {
            return testValue instanceof RegExp || testValue instanceof Function;
        };
        /**
     * _parseConfig
     *
     * @param  {Object} cfg optional config literal
     */ // eslint-disable-next-line complexity
        var _parseConfig = function _parseConfig(cfg) {
            if (CONFIG && CONFIG === cfg) return;
            /* Shield configuration object from tampering */ if (!cfg || _typeof(cfg) !== 'object') cfg = {};
            /* Shield configuration object from prototype pollution */ cfg = clone(cfg);
            PARSER_MEDIA_TYPE = // eslint-disable-next-line unicorn/prefer-includes
            SUPPORTED_PARSER_MEDIA_TYPES.indexOf(cfg.PARSER_MEDIA_TYPE) === -1 ? PARSER_MEDIA_TYPE = DEFAULT_PARSER_MEDIA_TYPE : PARSER_MEDIA_TYPE = cfg.PARSER_MEDIA_TYPE;
            // HTML tags and attributes are not case-sensitive, converting to lowercase. Keeping XHTML as is.
            transformCaseFunc = PARSER_MEDIA_TYPE === 'application/xhtml+xml' ? stringToString : stringToLowerCase;
            /* Set configuration parameters */ ALLOWED_TAGS = 'ALLOWED_TAGS' in cfg ? addToSet({}, cfg.ALLOWED_TAGS, transformCaseFunc) : DEFAULT_ALLOWED_TAGS;
            ALLOWED_ATTR = 'ALLOWED_ATTR' in cfg ? addToSet({}, cfg.ALLOWED_ATTR, transformCaseFunc) : DEFAULT_ALLOWED_ATTR;
            ALLOWED_NAMESPACES = 'ALLOWED_NAMESPACES' in cfg ? addToSet({}, cfg.ALLOWED_NAMESPACES, stringToString) : DEFAULT_ALLOWED_NAMESPACES;
            URI_SAFE_ATTRIBUTES = 'ADD_URI_SAFE_ATTR' in cfg ? addToSet(clone(DEFAULT_URI_SAFE_ATTRIBUTES), // eslint-disable-line indent
            cfg.ADD_URI_SAFE_ATTR, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_URI_SAFE_ATTRIBUTES;
            DATA_URI_TAGS = 'ADD_DATA_URI_TAGS' in cfg ? addToSet(clone(DEFAULT_DATA_URI_TAGS), // eslint-disable-line indent
            cfg.ADD_DATA_URI_TAGS, // eslint-disable-line indent
            transformCaseFunc // eslint-disable-line indent
            ) // eslint-disable-line indent
             : DEFAULT_DATA_URI_TAGS;
            FORBID_CONTENTS = 'FORBID_CONTENTS' in cfg ? addToSet({}, cfg.FORBID_CONTENTS, transformCaseFunc) : DEFAULT_FORBID_CONTENTS;
            FORBID_TAGS = 'FORBID_TAGS' in cfg ? addToSet({}, cfg.FORBID_TAGS, transformCaseFunc) : {};
            FORBID_ATTR = 'FORBID_ATTR' in cfg ? addToSet({}, cfg.FORBID_ATTR, transformCaseFunc) : {};
            USE_PROFILES = 'USE_PROFILES' in cfg ? cfg.USE_PROFILES : false;
            ALLOW_ARIA_ATTR = cfg.ALLOW_ARIA_ATTR !== false; // Default true
            ALLOW_DATA_ATTR = cfg.ALLOW_DATA_ATTR !== false; // Default true
            ALLOW_UNKNOWN_PROTOCOLS = cfg.ALLOW_UNKNOWN_PROTOCOLS || false; // Default false
            ALLOW_SELF_CLOSE_IN_ATTR = cfg.ALLOW_SELF_CLOSE_IN_ATTR !== false; // Default true
            SAFE_FOR_TEMPLATES = cfg.SAFE_FOR_TEMPLATES || false; // Default false
            SAFE_FOR_XML = cfg.SAFE_FOR_XML !== false; // Default true
            WHOLE_DOCUMENT = cfg.WHOLE_DOCUMENT || false; // Default false
            RETURN_DOM = cfg.RETURN_DOM || false; // Default false
            RETURN_DOM_FRAGMENT = cfg.RETURN_DOM_FRAGMENT || false; // Default false
            RETURN_TRUSTED_TYPE = cfg.RETURN_TRUSTED_TYPE || false; // Default false
            FORCE_BODY = cfg.FORCE_BODY || false; // Default false
            SANITIZE_DOM = cfg.SANITIZE_DOM !== false; // Default true
            SANITIZE_NAMED_PROPS = cfg.SANITIZE_NAMED_PROPS || false; // Default false
            KEEP_CONTENT = cfg.KEEP_CONTENT !== false; // Default true
            IN_PLACE = cfg.IN_PLACE || false; // Default false
            IS_ALLOWED_URI$1 = cfg.ALLOWED_URI_REGEXP || IS_ALLOWED_URI$1;
            NAMESPACE = cfg.NAMESPACE || HTML_NAMESPACE;
            CUSTOM_ELEMENT_HANDLING = cfg.CUSTOM_ELEMENT_HANDLING || {};
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck)) CUSTOM_ELEMENT_HANDLING.tagNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.tagNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && isRegexOrFunction(cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck)) CUSTOM_ELEMENT_HANDLING.attributeNameCheck = cfg.CUSTOM_ELEMENT_HANDLING.attributeNameCheck;
            if (cfg.CUSTOM_ELEMENT_HANDLING && typeof cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements === 'boolean') CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements = cfg.CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements;
            if (SAFE_FOR_TEMPLATES) ALLOW_DATA_ATTR = false;
            if (RETURN_DOM_FRAGMENT) RETURN_DOM = true;
            /* Parse profile info */ if (USE_PROFILES) {
                ALLOWED_TAGS = addToSet({}, _toConsumableArray(text));
                ALLOWED_ATTR = [];
                if (USE_PROFILES.html === true) {
                    addToSet(ALLOWED_TAGS, html$1);
                    addToSet(ALLOWED_ATTR, html);
                }
                if (USE_PROFILES.svg === true) {
                    addToSet(ALLOWED_TAGS, svg$1);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.svgFilters === true) {
                    addToSet(ALLOWED_TAGS, svgFilters);
                    addToSet(ALLOWED_ATTR, svg);
                    addToSet(ALLOWED_ATTR, xml);
                }
                if (USE_PROFILES.mathMl === true) {
                    addToSet(ALLOWED_TAGS, mathMl$1);
                    addToSet(ALLOWED_ATTR, mathMl);
                    addToSet(ALLOWED_ATTR, xml);
                }
            }
            /* Merge configuration parameters */ if (cfg.ADD_TAGS) {
                if (ALLOWED_TAGS === DEFAULT_ALLOWED_TAGS) ALLOWED_TAGS = clone(ALLOWED_TAGS);
                addToSet(ALLOWED_TAGS, cfg.ADD_TAGS, transformCaseFunc);
            }
            if (cfg.ADD_ATTR) {
                if (ALLOWED_ATTR === DEFAULT_ALLOWED_ATTR) ALLOWED_ATTR = clone(ALLOWED_ATTR);
                addToSet(ALLOWED_ATTR, cfg.ADD_ATTR, transformCaseFunc);
            }
            if (cfg.ADD_URI_SAFE_ATTR) addToSet(URI_SAFE_ATTRIBUTES, cfg.ADD_URI_SAFE_ATTR, transformCaseFunc);
            if (cfg.FORBID_CONTENTS) {
                if (FORBID_CONTENTS === DEFAULT_FORBID_CONTENTS) FORBID_CONTENTS = clone(FORBID_CONTENTS);
                addToSet(FORBID_CONTENTS, cfg.FORBID_CONTENTS, transformCaseFunc);
            }
            /* Add #text in case KEEP_CONTENT is set to true */ if (KEEP_CONTENT) ALLOWED_TAGS['#text'] = true;
            /* Add html, head and body to ALLOWED_TAGS in case WHOLE_DOCUMENT is true */ if (WHOLE_DOCUMENT) addToSet(ALLOWED_TAGS, [
                'html',
                'head',
                'body'
            ]);
            /* Add tbody to ALLOWED_TAGS in case tables are permitted, see #286, #365 */ if (ALLOWED_TAGS.table) {
                addToSet(ALLOWED_TAGS, [
                    'tbody'
                ]);
                delete FORBID_TAGS.tbody;
            }
            // Prevent further manipulation of configuration.
            // Not available in IE8, Safari 5, etc.
            if (freeze) freeze(cfg);
            CONFIG = cfg;
        };
        var MATHML_TEXT_INTEGRATION_POINTS = addToSet({}, [
            'mi',
            'mo',
            'mn',
            'ms',
            'mtext'
        ]);
        var HTML_INTEGRATION_POINTS = addToSet({}, [
            'annotation-xml'
        ]);
        // Certain elements are allowed in both SVG and HTML
        // namespace. We need to specify them explicitly
        // so that they don't get erroneously deleted from
        // HTML namespace.
        var COMMON_SVG_AND_HTML_ELEMENTS = addToSet({}, [
            'title',
            'style',
            'font',
            'a',
            'script'
        ]);
        /* Keep track of all possible SVG and MathML tags
     * so that we can perform the namespace checks
     * correctly. */ var ALL_SVG_TAGS = addToSet({}, svg$1);
        addToSet(ALL_SVG_TAGS, svgFilters);
        addToSet(ALL_SVG_TAGS, svgDisallowed);
        var ALL_MATHML_TAGS = addToSet({}, mathMl$1);
        addToSet(ALL_MATHML_TAGS, mathMlDisallowed);
        /**
     *
     *
     * @param  {Element} element a DOM element whose namespace is being checked
     * @returns {boolean} Return false if the element has a
     *  namespace that a spec-compliant parser would never
     *  return. Return true otherwise.
     */ var _checkValidNamespace = function _checkValidNamespace(element) {
            var parent = getParentNode(element);
            // In JSDOM, if we're inside shadow DOM, then parentNode
            // can be null. We just simulate parent in this case.
            if (!parent || !parent.tagName) parent = {
                namespaceURI: NAMESPACE,
                tagName: 'template'
            };
            var tagName = stringToLowerCase(element.tagName);
            var parentTagName = stringToLowerCase(parent.tagName);
            if (!ALLOWED_NAMESPACES[element.namespaceURI]) return false;
            if (element.namespaceURI === SVG_NAMESPACE) {
                // The only way to switch from HTML namespace to SVG
                // is via <svg>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'svg';
                // The only way to switch from MathML to SVG is via`
                // svg if parent is either <annotation-xml> or MathML
                // text integration points.
                if (parent.namespaceURI === MATHML_NAMESPACE) return tagName === 'svg' && (parentTagName === 'annotation-xml' || MATHML_TEXT_INTEGRATION_POINTS[parentTagName]);
                // We only allow elements that are defined in SVG
                // spec. All others are disallowed in SVG namespace.
                return Boolean(ALL_SVG_TAGS[tagName]);
            }
            if (element.namespaceURI === MATHML_NAMESPACE) {
                // The only way to switch from HTML namespace to MathML
                // is via <math>. If it happens via any other tag, then
                // it should be killed.
                if (parent.namespaceURI === HTML_NAMESPACE) return tagName === 'math';
                // The only way to switch from SVG to MathML is via
                // <math> and HTML integration points
                if (parent.namespaceURI === SVG_NAMESPACE) return tagName === 'math' && HTML_INTEGRATION_POINTS[parentTagName];
                // We only allow elements that are defined in MathML
                // spec. All others are disallowed in MathML namespace.
                return Boolean(ALL_MATHML_TAGS[tagName]);
            }
            if (element.namespaceURI === HTML_NAMESPACE) {
                // The only way to switch from SVG to HTML is via
                // HTML integration points, and from MathML to HTML
                // is via MathML text integration points
                if (parent.namespaceURI === SVG_NAMESPACE && !HTML_INTEGRATION_POINTS[parentTagName]) return false;
                if (parent.namespaceURI === MATHML_NAMESPACE && !MATHML_TEXT_INTEGRATION_POINTS[parentTagName]) return false;
                // We disallow tags that are specific for MathML
                // or SVG and should never appear in HTML namespace
                return !ALL_MATHML_TAGS[tagName] && (COMMON_SVG_AND_HTML_ELEMENTS[tagName] || !ALL_SVG_TAGS[tagName]);
            }
            // For XHTML and XML documents that support custom namespaces
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && ALLOWED_NAMESPACES[element.namespaceURI]) return true;
            // The code should never reach this place (this means
            // that the element somehow got namespace that is not
            // HTML, SVG, MathML or allowed via ALLOWED_NAMESPACES).
            // Return false just in case.
            return false;
        };
        /**
     * _forceRemove
     *
     * @param  {Node} node a DOM node
     */ var _forceRemove = function _forceRemove(node) {
            arrayPush(DOMPurify.removed, {
                element: node
            });
            try {
                // eslint-disable-next-line unicorn/prefer-dom-node-remove
                node.parentNode.removeChild(node);
            } catch (_) {
                try {
                    node.outerHTML = emptyHTML;
                } catch (_) {
                    node.remove();
                }
            }
        };
        /**
     * _removeAttribute
     *
     * @param  {String} name an Attribute name
     * @param  {Node} node a DOM node
     */ var _removeAttribute = function _removeAttribute(name, node) {
            try {
                arrayPush(DOMPurify.removed, {
                    attribute: node.getAttributeNode(name),
                    from: node
                });
            } catch (_) {
                arrayPush(DOMPurify.removed, {
                    attribute: null,
                    from: node
                });
            }
            node.removeAttribute(name);
            // We void attribute values for unremovable "is"" attributes
            if (name === 'is' && !ALLOWED_ATTR[name]) {
                if (RETURN_DOM || RETURN_DOM_FRAGMENT) try {
                    _forceRemove(node);
                } catch (_) {}
                else try {
                    node.setAttribute(name, '');
                } catch (_) {}
            }
        };
        /**
     * _initDocument
     *
     * @param  {String} dirty a string of dirty markup
     * @return {Document} a DOM, filled with the dirty markup
     */ var _initDocument = function _initDocument(dirty) {
            /* Create a HTML document */ var doc;
            var leadingWhitespace;
            if (FORCE_BODY) dirty = '<remove></remove>' + dirty;
            else {
                /* If FORCE_BODY isn't used, leading whitespace needs to be preserved manually */ var matches = stringMatch(dirty, /^[\r\n\t ]+/);
                leadingWhitespace = matches && matches[0];
            }
            if (PARSER_MEDIA_TYPE === 'application/xhtml+xml' && NAMESPACE === HTML_NAMESPACE) // Root of XHTML doc must contain xmlns declaration (see https://www.w3.org/TR/xhtml1/normative.html#strict)
            dirty = '<html xmlns="http://www.w3.org/1999/xhtml"><head></head><body>' + dirty + '</body></html>';
            var dirtyPayload = trustedTypesPolicy ? trustedTypesPolicy.createHTML(dirty) : dirty;
            /*
       * Use the DOMParser API by default, fallback later if needs be
       * DOMParser not work for svg when has multiple root element.
       */ if (NAMESPACE === HTML_NAMESPACE) try {
                doc = new DOMParser().parseFromString(dirtyPayload, PARSER_MEDIA_TYPE);
            } catch (_) {}
            /* Use createHTMLDocument in case DOMParser is not available */ if (!doc || !doc.documentElement) {
                doc = implementation.createDocument(NAMESPACE, 'template', null);
                try {
                    doc.documentElement.innerHTML = IS_EMPTY_INPUT ? emptyHTML : dirtyPayload;
                } catch (_) {
                // Syntax error if dirtyPayload is invalid xml
                }
            }
            var body = doc.body || doc.documentElement;
            if (dirty && leadingWhitespace) body.insertBefore(document.createTextNode(leadingWhitespace), body.childNodes[0] || null);
            /* Work on whole document or just its body */ if (NAMESPACE === HTML_NAMESPACE) return getElementsByTagName.call(doc, WHOLE_DOCUMENT ? 'html' : 'body')[0];
            return WHOLE_DOCUMENT ? doc.documentElement : body;
        };
        /**
     * _createIterator
     *
     * @param  {Document} root document/fragment to create iterator for
     * @return {Iterator} iterator instance
     */ var _createIterator = function _createIterator(root) {
            return createNodeIterator.call(root.ownerDocument || root, root, // eslint-disable-next-line no-bitwise
            NodeFilter.SHOW_ELEMENT | NodeFilter.SHOW_COMMENT | NodeFilter.SHOW_TEXT | NodeFilter.SHOW_PROCESSING_INSTRUCTION | NodeFilter.SHOW_CDATA_SECTION, null, false);
        };
        /**
     * _isClobbered
     *
     * @param  {Node} elm element to check for clobbering attacks
     * @return {Boolean} true if clobbered, false if safe
     */ var _isClobbered = function _isClobbered(elm) {
            return elm instanceof HTMLFormElement && (typeof elm.nodeName !== 'string' || typeof elm.textContent !== 'string' || typeof elm.removeChild !== 'function' || !(elm.attributes instanceof NamedNodeMap) || typeof elm.removeAttribute !== 'function' || typeof elm.setAttribute !== 'function' || typeof elm.namespaceURI !== 'string' || typeof elm.insertBefore !== 'function' || typeof elm.hasChildNodes !== 'function');
        };
        /**
     * _isNode
     *
     * @param  {Node} obj object to check whether it's a DOM node
     * @return {Boolean} true is object is a DOM node
     */ var _isNode = function _isNode(object) {
            return _typeof(Node) === 'object' ? object instanceof Node : object && _typeof(object) === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string';
        };
        /**
     * _executeHook
     * Execute user configurable hooks
     *
     * @param  {String} entryPoint  Name of the hook's entry point
     * @param  {Node} currentNode node to work on with the hook
     * @param  {Object} data additional hook parameters
     */ var _executeHook = function _executeHook(entryPoint, currentNode, data) {
            if (!hooks[entryPoint]) return;
            arrayForEach(hooks[entryPoint], function(hook) {
                hook.call(DOMPurify, currentNode, data, CONFIG);
            });
        };
        /**
     * _sanitizeElements
     *
     * @protect nodeName
     * @protect textContent
     * @protect removeChild
     *
     * @param   {Node} currentNode to check for permission to exist
     * @return  {Boolean} true if node was killed, false if left alive
     */ var _sanitizeElements = function _sanitizeElements(currentNode) {
            var content;
            /* Execute a hook if present */ _executeHook('beforeSanitizeElements', currentNode, null);
            /* Check if element is clobbered or can clobber */ if (_isClobbered(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Check if tagname contains Unicode */ if (regExpTest(/[\u0080-\uFFFF]/, currentNode.nodeName)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Now let's check the element's type and name */ var tagName = transformCaseFunc(currentNode.nodeName);
            /* Execute a hook if present */ _executeHook('uponSanitizeElement', currentNode, {
                tagName: tagName,
                allowedTags: ALLOWED_TAGS
            });
            /* Detect mXSS attempts abusing namespace confusion */ if (currentNode.hasChildNodes() && !_isNode(currentNode.firstElementChild) && (!_isNode(currentNode.content) || !_isNode(currentNode.content.firstElementChild)) && regExpTest(/<[/\w]/g, currentNode.innerHTML) && regExpTest(/<[/\w]/g, currentNode.textContent)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Mitigate a problem with templates inside select */ if (tagName === 'select' && regExpTest(/<template/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any ocurrence of processing instructions */ if (currentNode.nodeType === 7) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove any kind of possibly harmful comments */ if (SAFE_FOR_XML && currentNode.nodeType === 8 && regExpTest(/<[/\w]/g, currentNode.data)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Remove element if anything forbids its presence */ if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) {
                /* Check if we have a custom element to handle */ if (!FORBID_TAGS[tagName] && _basicCustomElementTest(tagName)) {
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, tagName)) return false;
                    if (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(tagName)) return false;
                }
                /* Keep content except for bad-listed elements */ if (KEEP_CONTENT && !FORBID_CONTENTS[tagName]) {
                    var parentNode = getParentNode(currentNode) || currentNode.parentNode;
                    var childNodes = getChildNodes(currentNode) || currentNode.childNodes;
                    if (childNodes && parentNode) {
                        var childCount = childNodes.length;
                        for(var i = childCount - 1; i >= 0; --i){
                            var childClone = cloneNode(childNodes[i], true);
                            childClone.__removalCount = (currentNode.__removalCount || 0) + 1;
                            parentNode.insertBefore(childClone, getNextSibling(currentNode));
                        }
                    }
                }
                _forceRemove(currentNode);
                return true;
            }
            /* Check whether element has a valid namespace */ if (currentNode instanceof Element && !_checkValidNamespace(currentNode)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Make sure that older browsers don't get fallback-tag mXSS */ if ((tagName === 'noscript' || tagName === 'noembed' || tagName === 'noframes') && regExpTest(/<\/no(script|embed|frames)/i, currentNode.innerHTML)) {
                _forceRemove(currentNode);
                return true;
            }
            /* Sanitize element content to be template-safe */ if (SAFE_FOR_TEMPLATES && currentNode.nodeType === 3) {
                /* Get the element's text content */ content = currentNode.textContent;
                content = stringReplace(content, MUSTACHE_EXPR$1, ' ');
                content = stringReplace(content, ERB_EXPR$1, ' ');
                content = stringReplace(content, TMPLIT_EXPR$1, ' ');
                if (currentNode.textContent !== content) {
                    arrayPush(DOMPurify.removed, {
                        element: currentNode.cloneNode()
                    });
                    currentNode.textContent = content;
                }
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeElements', currentNode, null);
            return false;
        };
        /**
     * _isValidAttribute
     *
     * @param  {string} lcTag Lowercase tag name of containing element.
     * @param  {string} lcName Lowercase attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid, otherwise false.
     */ // eslint-disable-next-line complexity
        var _isValidAttribute = function _isValidAttribute(lcTag, lcName, value) {
            /* Make sure attribute cannot clobber */ if (SANITIZE_DOM && (lcName === 'id' || lcName === 'name') && (value in document || value in formElement)) return false;
            /* Allow valid data-* attributes: At least one character after "-"
          (https://html.spec.whatwg.org/multipage/dom.html#embedding-custom-non-visible-data-with-the-data-*-attributes)
          XML-compatible (https://html.spec.whatwg.org/multipage/infrastructure.html#xml-compatible and http://www.w3.org/TR/xml/#d0e804)
          We don't need to check the value; it's always URI safe. */ if (ALLOW_DATA_ATTR && !FORBID_ATTR[lcName] && regExpTest(DATA_ATTR$1, lcName)) ;
            else if (ALLOW_ARIA_ATTR && regExpTest(ARIA_ATTR$1, lcName)) ;
            else if (!ALLOWED_ATTR[lcName] || FORBID_ATTR[lcName]) {
                if (// First condition does a very basic check if a) it's basically a valid custom element tagname AND
                // b) if the tagName passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                // and c) if the attribute name passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.attributeNameCheck
                _basicCustomElementTest(lcTag) && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, lcTag) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(lcTag)) && (CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.attributeNameCheck, lcName) || CUSTOM_ELEMENT_HANDLING.attributeNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.attributeNameCheck(lcName)) || // Alternative, second condition checks if it's an `is`-attribute, AND
                // the value passes whatever the user has configured for CUSTOM_ELEMENT_HANDLING.tagNameCheck
                lcName === 'is' && CUSTOM_ELEMENT_HANDLING.allowCustomizedBuiltInElements && (CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof RegExp && regExpTest(CUSTOM_ELEMENT_HANDLING.tagNameCheck, value) || CUSTOM_ELEMENT_HANDLING.tagNameCheck instanceof Function && CUSTOM_ELEMENT_HANDLING.tagNameCheck(value))) ;
                else return false;
            /* Check value is safe. First, is attr inert? If so, is safe */ } else if (URI_SAFE_ATTRIBUTES[lcName]) ;
            else if (regExpTest(IS_ALLOWED_URI$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if ((lcName === 'src' || lcName === 'xlink:href' || lcName === 'href') && lcTag !== 'script' && stringIndexOf(value, 'data:') === 0 && DATA_URI_TAGS[lcTag]) ;
            else if (ALLOW_UNKNOWN_PROTOCOLS && !regExpTest(IS_SCRIPT_OR_DATA$1, stringReplace(value, ATTR_WHITESPACE$1, ''))) ;
            else if (value) return false;
            return true;
        };
        /**
     * _basicCustomElementCheck
     * checks if at least one dash is included in tagName, and it's not the first char
     * for more sophisticated checking see https://github.com/sindresorhus/validate-element-name
     * @param {string} tagName name of the tag of the node to sanitize
     */ var _basicCustomElementTest = function _basicCustomElementTest(tagName) {
            return tagName !== 'annotation-xml' && stringMatch(tagName, CUSTOM_ELEMENT$1);
        };
        /**
     * _sanitizeAttributes
     *
     * @protect attributes
     * @protect nodeName
     * @protect removeAttribute
     * @protect setAttribute
     *
     * @param  {Node} currentNode to sanitize
     */ var _sanitizeAttributes = function _sanitizeAttributes(currentNode) {
            var attr;
            var value;
            var lcName;
            var l;
            /* Execute a hook if present */ _executeHook('beforeSanitizeAttributes', currentNode, null);
            var attributes = currentNode.attributes;
            /* Check if we have attributes; if not we might have a text node */ if (!attributes) return;
            var hookEvent = {
                attrName: '',
                attrValue: '',
                keepAttr: true,
                allowedAttributes: ALLOWED_ATTR
            };
            l = attributes.length;
            /* Go backwards over all attributes; safely remove bad ones */ while(l--){
                attr = attributes[l];
                var _attr = attr, name = _attr.name, namespaceURI = _attr.namespaceURI;
                value = name === 'value' ? attr.value : stringTrim(attr.value);
                lcName = transformCaseFunc(name);
                /* Execute a hook if present */ hookEvent.attrName = lcName;
                hookEvent.attrValue = value;
                hookEvent.keepAttr = true;
                hookEvent.forceKeepAttr = undefined; // Allows developers to see this is a property they can set
                _executeHook('uponSanitizeAttribute', currentNode, hookEvent);
                value = hookEvent.attrValue;
                /* Did the hooks approve of the attribute? */ if (hookEvent.forceKeepAttr) continue;
                /* Remove attribute */ _removeAttribute(name, currentNode);
                /* Did the hooks approve of the attribute? */ if (!hookEvent.keepAttr) continue;
                /* Work around a security issue in jQuery 3.0 */ if (!ALLOW_SELF_CLOSE_IN_ATTR && regExpTest(/\/>/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Sanitize attribute content to be template-safe */ if (SAFE_FOR_TEMPLATES) {
                    value = stringReplace(value, MUSTACHE_EXPR$1, ' ');
                    value = stringReplace(value, ERB_EXPR$1, ' ');
                    value = stringReplace(value, TMPLIT_EXPR$1, ' ');
                }
                /* Is `value` valid for this attribute? */ var lcTag = transformCaseFunc(currentNode.nodeName);
                if (!_isValidAttribute(lcTag, lcName, value)) continue;
                /* Full DOM Clobbering protection via namespace isolation,
         * Prefix id and name attributes with `user-content-`
         */ if (SANITIZE_NAMED_PROPS && (lcName === 'id' || lcName === 'name')) {
                    // Remove the attribute with this value
                    _removeAttribute(name, currentNode);
                    // Prefix the value and later re-create the attribute with the sanitized value
                    value = SANITIZE_NAMED_PROPS_PREFIX + value;
                }
                /* Work around a security issue with comments inside attributes */ if (SAFE_FOR_XML && regExpTest(/((--!?|])>)|<\/(style|title)/i, value)) {
                    _removeAttribute(name, currentNode);
                    continue;
                }
                /* Handle attributes that require Trusted Types */ if (trustedTypesPolicy && _typeof(trustedTypes) === 'object' && typeof trustedTypes.getAttributeType === 'function') {
                    if (namespaceURI) ;
                    else switch(trustedTypes.getAttributeType(lcTag, lcName)){
                        case 'TrustedHTML':
                            value = trustedTypesPolicy.createHTML(value);
                            break;
                        case 'TrustedScriptURL':
                            value = trustedTypesPolicy.createScriptURL(value);
                            break;
                    }
                }
                /* Handle invalid data-* attribute set by try-catching it */ try {
                    if (namespaceURI) currentNode.setAttributeNS(namespaceURI, name, value);
                    else /* Fallback to setAttribute() for browser-unrecognized namespaces e.g. "x-schema". */ currentNode.setAttribute(name, value);
                    if (_isClobbered(currentNode)) _forceRemove(currentNode);
                    else arrayPop(DOMPurify.removed);
                } catch (_) {}
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeAttributes', currentNode, null);
        };
        /**
     * _sanitizeShadowDOM
     *
     * @param  {DocumentFragment} fragment to iterate over recursively
     */ var _sanitizeShadowDOM = function _sanitizeShadowDOM(fragment) {
            var shadowNode;
            var shadowIterator = _createIterator(fragment);
            /* Execute a hook if present */ _executeHook('beforeSanitizeShadowDOM', fragment, null);
            while(shadowNode = shadowIterator.nextNode()){
                /* Execute a hook if present */ _executeHook('uponSanitizeShadowNode', shadowNode, null);
                /* Sanitize tags and elements */ if (_sanitizeElements(shadowNode)) continue;
                /* Deep shadow DOM detected */ if (shadowNode.content instanceof DocumentFragment) _sanitizeShadowDOM(shadowNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(shadowNode);
            }
            /* Execute a hook if present */ _executeHook('afterSanitizeShadowDOM', fragment, null);
        };
        /**
     * Sanitize
     * Public method providing core sanitation functionality
     *
     * @param {String|Node} dirty string or DOM node
     * @param {Object} configuration object
     */ // eslint-disable-next-line complexity
        DOMPurify.sanitize = function(dirty) {
            var cfg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var body;
            var importedNode;
            var currentNode;
            var oldNode;
            var returnNode;
            /* Make sure we have a string to sanitize.
        DO NOT return early, as this will return the wrong type if
        the user has requested a DOM object rather than a string */ IS_EMPTY_INPUT = !dirty;
            if (IS_EMPTY_INPUT) dirty = '<!-->';
            /* Stringify, in case dirty is an object */ if (typeof dirty !== 'string' && !_isNode(dirty)) {
                if (typeof dirty.toString === 'function') {
                    dirty = dirty.toString();
                    if (typeof dirty !== 'string') throw typeErrorCreate('dirty is not a string, aborting');
                } else throw typeErrorCreate('toString is not a function');
            }
            /* Check we can run. Otherwise fall back or ignore */ if (!DOMPurify.isSupported) {
                if (_typeof(window1.toStaticHTML) === 'object' || typeof window1.toStaticHTML === 'function') {
                    if (typeof dirty === 'string') return window1.toStaticHTML(dirty);
                    if (_isNode(dirty)) return window1.toStaticHTML(dirty.outerHTML);
                }
                return dirty;
            }
            /* Assign config vars */ if (!SET_CONFIG) _parseConfig(cfg);
            /* Clean up removed elements */ DOMPurify.removed = [];
            /* Check if dirty is correctly typed for IN_PLACE */ if (typeof dirty === 'string') IN_PLACE = false;
            if (IN_PLACE) /* Do some early pre-sanitization to avoid unsafe root nodes */ {
                if (dirty.nodeName) {
                    var tagName = transformCaseFunc(dirty.nodeName);
                    if (!ALLOWED_TAGS[tagName] || FORBID_TAGS[tagName]) throw typeErrorCreate('root node is forbidden and cannot be sanitized in-place');
                }
            } else if (dirty instanceof Node) {
                /* If dirty is a DOM element, append to an empty document to avoid
           elements being stripped by the parser */ body = _initDocument('<!---->');
                importedNode = body.ownerDocument.importNode(dirty, true);
                if (importedNode.nodeType === 1 && importedNode.nodeName === 'BODY') /* Node is already a body, use as is */ body = importedNode;
                else if (importedNode.nodeName === 'HTML') body = importedNode;
                else // eslint-disable-next-line unicorn/prefer-dom-node-append
                body.appendChild(importedNode);
            } else {
                /* Exit directly if we have nothing to do */ if (!RETURN_DOM && !SAFE_FOR_TEMPLATES && !WHOLE_DOCUMENT && // eslint-disable-next-line unicorn/prefer-includes
                dirty.indexOf('<') === -1) return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(dirty) : dirty;
                /* Initialize the document to work on */ body = _initDocument(dirty);
                /* Check we have a DOM node from the data */ if (!body) return RETURN_DOM ? null : RETURN_TRUSTED_TYPE ? emptyHTML : '';
            }
            /* Remove first element node (ours) if FORCE_BODY is set */ if (body && FORCE_BODY) _forceRemove(body.firstChild);
            /* Get node iterator */ var nodeIterator = _createIterator(IN_PLACE ? dirty : body);
            /* Now start iterating over the created document */ while(currentNode = nodeIterator.nextNode()){
                /* Fix IE's strange behavior with manipulated textNodes #89 */ if (currentNode.nodeType === 3 && currentNode === oldNode) continue;
                /* Sanitize tags and elements */ if (_sanitizeElements(currentNode)) continue;
                /* Shadow DOM detected, sanitize it */ if (currentNode.content instanceof DocumentFragment) _sanitizeShadowDOM(currentNode.content);
                /* Check attributes, sanitize if necessary */ _sanitizeAttributes(currentNode);
                oldNode = currentNode;
            }
            oldNode = null;
            /* If we sanitized `dirty` in-place, return it. */ if (IN_PLACE) return dirty;
            /* Return sanitized string or DOM */ if (RETURN_DOM) {
                if (RETURN_DOM_FRAGMENT) {
                    returnNode = createDocumentFragment.call(body.ownerDocument);
                    while(body.firstChild)// eslint-disable-next-line unicorn/prefer-dom-node-append
                    returnNode.appendChild(body.firstChild);
                } else returnNode = body;
                if (ALLOWED_ATTR.shadowroot || ALLOWED_ATTR.shadowrootmod) /*
            AdoptNode() is not used because internal state is not reset
            (e.g. the past names map of a HTMLFormElement), this is safe
            in theory but we would rather not risk another attack vector.
            The state that is cloned by importNode() is explicitly defined
            by the specs.
          */ returnNode = importNode.call(originalDocument, returnNode, true);
                return returnNode;
            }
            var serializedHTML = WHOLE_DOCUMENT ? body.outerHTML : body.innerHTML;
            /* Serialize doctype if allowed */ if (WHOLE_DOCUMENT && ALLOWED_TAGS['!doctype'] && body.ownerDocument && body.ownerDocument.doctype && body.ownerDocument.doctype.name && regExpTest(DOCTYPE_NAME, body.ownerDocument.doctype.name)) serializedHTML = '<!DOCTYPE ' + body.ownerDocument.doctype.name + '>\n' + serializedHTML;
            /* Sanitize final string template-safe */ if (SAFE_FOR_TEMPLATES) {
                serializedHTML = stringReplace(serializedHTML, MUSTACHE_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, ERB_EXPR$1, ' ');
                serializedHTML = stringReplace(serializedHTML, TMPLIT_EXPR$1, ' ');
            }
            return trustedTypesPolicy && RETURN_TRUSTED_TYPE ? trustedTypesPolicy.createHTML(serializedHTML) : serializedHTML;
        };
        /**
     * Public method to set the configuration once
     * setConfig
     *
     * @param {Object} cfg configuration object
     */ DOMPurify.setConfig = function(cfg) {
            _parseConfig(cfg);
            SET_CONFIG = true;
        };
        /**
     * Public method to remove the configuration
     * clearConfig
     *
     */ DOMPurify.clearConfig = function() {
            CONFIG = null;
            SET_CONFIG = false;
        };
        /**
     * Public method to check if an attribute value is valid.
     * Uses last set config, if any. Otherwise, uses config defaults.
     * isValidAttribute
     *
     * @param  {string} tag Tag name of containing element.
     * @param  {string} attr Attribute name.
     * @param  {string} value Attribute value.
     * @return {Boolean} Returns true if `value` is valid. Otherwise, returns false.
     */ DOMPurify.isValidAttribute = function(tag, attr, value) {
            /* Initialize shared config vars if necessary. */ if (!CONFIG) _parseConfig({});
            var lcTag = transformCaseFunc(tag);
            var lcName = transformCaseFunc(attr);
            return _isValidAttribute(lcTag, lcName, value);
        };
        /**
     * AddHook
     * Public method to add DOMPurify hooks
     *
     * @param {String} entryPoint entry point for the hook to add
     * @param {Function} hookFunction function to execute
     */ DOMPurify.addHook = function(entryPoint, hookFunction) {
            if (typeof hookFunction !== 'function') return;
            hooks[entryPoint] = hooks[entryPoint] || [];
            arrayPush(hooks[entryPoint], hookFunction);
        };
        /**
     * RemoveHook
     * Public method to remove a DOMPurify hook at a given entryPoint
     * (pops it from the stack of hooks if more are present)
     *
     * @param {String} entryPoint entry point for the hook to remove
     * @return {Function} removed(popped) hook
     */ DOMPurify.removeHook = function(entryPoint) {
            if (hooks[entryPoint]) return arrayPop(hooks[entryPoint]);
        };
        /**
     * RemoveHooks
     * Public method to remove all DOMPurify hooks at a given entryPoint
     *
     * @param  {String} entryPoint entry point for the hooks to remove
     */ DOMPurify.removeHooks = function(entryPoint) {
            if (hooks[entryPoint]) hooks[entryPoint] = [];
        };
        /**
     * RemoveAllHooks
     * Public method to remove all DOMPurify hooks
     *
     */ DOMPurify.removeAllHooks = function() {
            hooks = {};
        };
        return DOMPurify;
    }
    var purify = createDOMPurify();
    return purify;
});

});


parcelRegister("9yDQx", function(module, exports) {

$parcel$export(module.exports, "TextCardCustomFieldContent", () => $fdd358c8a9939852$export$7f2a6a62bcd53a5);

var $5uXOq = parcelRequire("5uXOq");

var $71sS1 = parcelRequire("71sS1");
const $fdd358c8a9939852$export$7f2a6a62bcd53a5 = ({ field: field })=>field.text ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $71sS1.CustomCardFieldContainer), {
        isNone: field.text === 'None',
        "data-testid": "platform-card.common.ui.custom-fields.card-custom-field.text-card-custom-field-content.field"
    }, field.text) : null;

});

parcelRegister("21RvA", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELD_FIX_VERSIONS", () => $cd555e029573e1b8$export$24107c98bc621912);
$parcel$export(module.exports, "TextFixVersionsCustomFieldContent", () => $cd555e029573e1b8$export$e26fa5af79e17a9b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $3u0c5 = parcelRequire("3u0c5");

var $koVbs = parcelRequire("koVbs");

var $1mAp4 = parcelRequire("1mAp4");
const $cd555e029573e1b8$export$24107c98bc621912 = 'fixVersions';
const $cd555e029573e1b8$export$e26fa5af79e17a9b = ({ field: field, fixVersions: fixVersions = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(field) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(field.text) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(field.text)) return null;
    const versionsCount = fixVersions.length;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cd555e029573e1b8$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, versionsCount > 1 ? formatMessage((0, $1mAp4.messages).multipleVersionsContent, {
        versionsCount: versionsCount
    }) : field.text));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $cd555e029573e1b8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _1e0c1txw _1bah1y6m _4cvr1h6o _13t37vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1mAp4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $416469f8d99e1748$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $416469f8d99e1748$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    multipleVersionsContent: {
        "id": "card.common.custom-fields.card-custom-field.text-fix-versions-custom-field-content.multiple-versions-content",
        "defaultMessage": "{versionsCount} versions"
    }
});

});


parcelRegister("g3il2", function(module, exports) {

$parcel$export(module.exports, "CUSTOM_FIELD_LABELS", () => $9874ac763561bf35$export$b1cb468c302d21f9);
$parcel$export(module.exports, "TextLabelCustomFieldContent", () => $9874ac763561bf35$export$1babf298bf81c364);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $dHqFt = parcelRequire("dHqFt");
const $9874ac763561bf35$export$b1cb468c302d21f9 = 'labels';
const $9874ac763561bf35$export$1babf298bf81c364 = ({ field: field })=>{
    if (!field?.text) return null;
    const labels = field.text.split(',');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $9874ac763561bf35$var$overflowOuterStyles,
        "data-testId": "text-label-custom-field-content-card-labels"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $9874ac763561bf35$var$overflowInnerStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $9874ac763561bf35$var$overflowInnerExtraStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHqFt.CardLabels), {
        isCMPBoard: true,
        labels: labels
    })));
};
const $9874ac763561bf35$var$overflowOuterStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    overflow: 'hidden'
});
const $9874ac763561bf35$var$overflowInnerStyles = (0, $8CUq3.xcss)({
    boxAlign: 'center',
    flexFlow: 'row wrap',
    alignItems: 'center',
    maxWidth: '100%',
    gap: 'space.100'
});
// Combine styles when clean up fg visual-refresh
const $9874ac763561bf35$var$overflowInnerExtraStyles = (0, $8CUq3.xcss)({
    flexGrow: '1'
});

});
parcelRegister("dHqFt", function(module, exports) {

$parcel$export(module.exports, "CardLabels", () => $6ba71143138ad30e$export$ece436c5ee6469bd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $dCm1o = parcelRequire("dCm1o");

var $arvGN = parcelRequire("arvGN");
const $6ba71143138ad30e$var$CmpCardLabels = ({ labels: labels, highlight: highlight = [] })=>!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(labels) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$Overflow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: labels.join(', '),
        position: "bottom-start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$Gradient, null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6ba71143138ad30e$var$CmpContainerStyles
    }, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $arvGN.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$CmpContainer, null, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $arvGN.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        })))))) : null;
const $6ba71143138ad30e$var$TmpCardLabels = ({ labels: labels, highlight: highlight = [] })=>// eslint-disable-next-line no-nested-ternary
    !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(labels) ? (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6ba71143138ad30e$var$ContainerStyles
    }, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $arvGN.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$Container, null, labels.map((label, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $arvGN.CardLabel), {
            key: index,
            text: label,
            highlight: highlight
        }))) : null;
const $6ba71143138ad30e$export$ece436c5ee6469bd = ({ labels: labels, isCMPBoard: isCMPBoard = false, highlight: highlight = [] })=>isCMPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$CmpCardLabels, {
        labels: labels,
        highlight: highlight
    }) // now renders within custom fields
     : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ba71143138ad30e$var$TmpCardLabels, {
        labels: labels,
        highlight: highlight
    });
var $6ba71143138ad30e$export$2e2bcd8739ae039 = $6ba71143138ad30e$export$ece436c5ee6469bd;
const $6ba71143138ad30e$var$ContainerStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'none',
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    margin: 'space.negative.050',
    width: '100%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ba71143138ad30e$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2lx2vrvc _1n261g80 _lcxvglyw _1e0c1txw _4cvr1h6o _19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr",
            __cmplp.className
        ])
    });
});
const $6ba71143138ad30e$var$CmpContainerStyles = (0, $8CUq3.xcss)({
    alignItems: 'center',
    display: 'inline-flex',
    margin: 'space.negative.050',
    width: '100%',
    flexWrap: 'wrap'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6ba71143138ad30e$var$CmpContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4cvr1h6o _1e0c116y _19pkr5cr _2hwxr5cr _otyrr5cr _18u0r5cr",
            __cmplp.className
        ])
    });
});
const $6ba71143138ad30e$var$Gradient = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq _kqswh2mm _qc5omo3v _16r23cth _aetrb3bt _15l2idpf _19doidpf _1ywu1ule _1qdg1osq _z0ai1osq _18postnw _e9q69hw4",
            __cmplp.className
        ])
    });
});
const $6ba71143138ad30e$var$Overflow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsb1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("arvGN", function(module, exports) {

$parcel$export(module.exports, "CardLabel", () => $a5ee2d76601b7fd8$export$e13aaac4037b0914);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $d9xxV = parcelRequire("d9xxV");

var $dCm1o = parcelRequire("dCm1o");

var $7ldcY = parcelRequire("7ldcY");

var $6s1PB = parcelRequire("6s1PB");

var $ek97b = parcelRequire("ek97b");
const $a5ee2d76601b7fd8$export$e13aaac4037b0914 = (props)=>{
    const { text: text, highlight: highlight } = props;
    const isSelected = !!highlight && highlight.includes(text);
    if ((0, $6s1PB.expVal)('adding-color-to-labels-field-in-jira-experiment', 'isColoredLabelsEnabled', false)) {
        const { backgroundColor: borderColor } = (0, $ek97b.getColorMetadata)((0, $7ldcY.memoizeGetAutoGeneratedColorForLabels)(text));
        return /*#__PURE__*/ $5uXOq.createElement("span", {
            // eslint-disable-next-line jira/react/no-style-attribute, @typescript-eslint/consistent-type-assertions
            style: {
                '--tag-border-color': borderColor
            },
            className: (0, $bwpsq.default)([
                "_14ownqa1 _7x4ft94y _kr194o00 _1plv18uv _zmp81fxt _1blw1fxt"
            ])
        }, /*#__PURE__*/ $5uXOq.createElement((0, $d9xxV.default), {
            text: text
        }));
    }
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ $5uXOq.createElement((0, $d9xxV.default), {
        text: text,
        color: isSelected ? 'blue' : 'standard'
    });
    return /*#__PURE__*/ $5uXOq.createElement($a5ee2d76601b7fd8$var$Container, {
        isSelected: isSelected
    }, /*#__PURE__*/ $5uXOq.createElement($a5ee2d76601b7fd8$var$Content, null, text));
};
$a5ee2d76601b7fd8$export$e13aaac4037b0914.defaultProps = {
    highlight: []
};
var $a5ee2d76601b7fd8$export$2e2bcd8739ae039 = $a5ee2d76601b7fd8$export$e13aaac4037b0914;
const $a5ee2d76601b7fd8$var$tagBorderStyles = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a5ee2d76601b7fd8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSelected: isSelected, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _2rko1l7b _1e0c116y _4t3igktf _19pk1b66 _2hwx1b66 _otyr1b66 _18u01b66 _kqswh2mm _80om73ad _vwz4kb7n",
            __cmplp.isSelected ? "_bfhk4v9p" : "_bfhkm7j4",
            __cmplp.isSelected ? "_syazpnps" : "_syaz1fxt",
            __cmplp.className
        ])
    });
});
const $a5ee2d76601b7fd8$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _p12fmgvx _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("d9xxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $87927dab24395a15$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $5oSQr = parcelRequire("5oSQr");

var $aXLIT = parcelRequire("aXLIT");

var $eYXIO = parcelRequire("eYXIO");
const $87927dab24395a15$var$SimpleTagComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ appearance: appearance, elemBefore: elemBefore = null, color: color = 'standard', href: href, testId: testId, text: text = '', linkComponent: linkComponent }, ref)=>{
    const content = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYXIO.default), {
        elemBefore: elemBefore,
        isRemovable: false,
        text: text,
        color: color,
        href: href,
        linkComponent: linkComponent
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $5oSQr.default), {
        ref: ref,
        testId: testId,
        href: href,
        appearance: appearance,
        color: color,
        before: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $aXLIT.default), {
            elemBefore: elemBefore
        }),
        contentElement: content
    });
});
/**
 * __Simple tag__
 *
 * A tag labels UI objects for quick recognition and navigation.
 *
 * `SimpleTag` is the default form of a tag, where text is required. Tags with static text can be used as a flag or as a reference to an object or attribute.
 *
 * - [Examples](https://atlassian.design/components/tag/examples)
 * - [Code](https://atlassian.design/components/tag/code)
 * - [Usage](https://atlassian.design/components/tag/usage)
 */ const $87927dab24395a15$var$SimpleTag = /*#__PURE__*/ (0, $5uXOq.memo)($87927dab24395a15$var$SimpleTagComponent);
var $87927dab24395a15$export$2e2bcd8739ae039 = $87927dab24395a15$var$SimpleTag;

});
parcelRegister("5oSQr", function(module, exports) {

$parcel$export(module.exports, "default", () => $db35d9df42c66ff0$export$2e2bcd8739ae039);
/* base.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $VSDnB = parcelRequire("VSDnB");

var $2hnSR = parcelRequire("2hnSR");
const $db35d9df42c66ff0$var$borderColorCssVar = '--ds-bc';
const $db35d9df42c66ff0$var$focusRingCssVar = '--ds-cfr';
const $db35d9df42c66ff0$var$textLinkCssVar = '--ds-ctl';
const $db35d9df42c66ff0$var$textDefaultCssVar = '--ds-ct';
const $db35d9df42c66ff0$var$textHoverCssVar = '--ds-cth';
const $db35d9df42c66ff0$var$textActiveCssVar = '--ds-ctp';
const $db35d9df42c66ff0$var$backgroundDefaultCssVar = '--ds-cb';
const $db35d9df42c66ff0$var$backgroundHoverCssVar = '--ds-cbh';
const $db35d9df42c66ff0$var$backgroundActiveCssVar = '--ds-cba';
const $db35d9df42c66ff0$var$removeButtonDefaultCssVar = '--ds-rb';
const $db35d9df42c66ff0$var$removeButtonHoverCssVar = '--ds-rbh';
const $db35d9df42c66ff0$var$borderRadiusCssVar = '--ds-br';
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$baseStylesOld = null;
const $db35d9df42c66ff0$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$interactiveStylesOld = null;
const $db35d9df42c66ff0$var$interactiveStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$focusRingStylesOld = null;
const $db35d9df42c66ff0$var$focusRingStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $db35d9df42c66ff0$var$nonStandardLinkStyles = null;
const $db35d9df42c66ff0$var$BaseTag = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(function BaseTag({ before: before, contentElement: contentElement, after: after, testId: testId, appearance: appearance = 'default', style: style, color: color = 'standard', href: href, className: className, ...other }, ref) {
    const isLink = Boolean(href);
    const isRemovable = Boolean(after);
    const isInteractive = isLink || isRemovable;
    const isStandardLink = isLink && color === 'standard';
    // Change link text color if  the tag is standard color
    const textLinkColors = isStandardLink ? (0, $2hnSR.textColors)['standardLink'] : (0, $2hnSR.textColors)[color];
    const backgroundHoverColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkHoverBackgroundColors)[color];
    const backgroundActiveColors = isRemovable && !isLink ? (0, $2hnSR.backgroundColors)[color] : (0, $2hnSR.linkActiveBackgroundColors)[color];
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("span", {
        ...other,
        ref: ref,
        style: {
            // NOTE: The vast majority of these styles have zero purpose to be runtime computed
            // This can all be migrated to statically distributed atomic CSS with Compiled in the future
            // The main reason for not touching this is there is to avoid excessive changes in the same PR on non-visual-refresh code
            /* eslint-disable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values */ [$db35d9df42c66ff0$var$borderColorCssVar]: (0, $2hnSR.borderColors)[color],
            [$db35d9df42c66ff0$var$textDefaultCssVar]: (0, $2hnSR.textColors)[color],
            [$db35d9df42c66ff0$var$textHoverCssVar]: (0, $2hnSR.textHoverColors)[color],
            [$db35d9df42c66ff0$var$textActiveCssVar]: (0, $2hnSR.textActiveColors)[color],
            [$db35d9df42c66ff0$var$textLinkCssVar]: textLinkColors,
            [$db35d9df42c66ff0$var$backgroundDefaultCssVar]: (0, $2hnSR.backgroundColors)[color],
            [$db35d9df42c66ff0$var$backgroundHoverCssVar]: backgroundHoverColors,
            [$db35d9df42c66ff0$var$backgroundActiveCssVar]: backgroundActiveColors,
            [$db35d9df42c66ff0$var$focusRingCssVar]: (0, $2hnSR.focusRingColors),
            [$db35d9df42c66ff0$var$removeButtonDefaultCssVar]: (0, $2hnSR.removeButtonColors)[color],
            [$db35d9df42c66ff0$var$removeButtonHoverCssVar]: (0, $2hnSR.removeButtonHoverColors)[color],
            [$db35d9df42c66ff0$var$borderRadiusCssVar]: appearance === 'rounded' ? '10px' : '3px',
            /* eslint-enable @atlaskit/ui-styling-standard/enforce-style-prop */ /* eslint-enable @atlaskit/ui-styling-standard/no-imported-style-values */ // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ...style
        },
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_zulp1b66 _2rko1sit _1h6d2fso _1dqonqa1 _189ee4h9 _1mou1b66 _195g1b66 _18zr1b66 _1e0c116y _vchhusvi _1ul9idpf _4t3iv47k _kqswh2mm _4cvr1h6o _bfhk1w7a _syaz1fxt _80om73ad" : "_2rko1l5z _1mou1b66 _195g1b66 _1rjcze3t _18zrze3t _1e0c116y _1ul9idpf _4t3iv47k _kqswh2mm _bfhklsll _syaz148y _80om73ad",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e38ugt7 _7glxv77o" : "_1guj1r31 _pbhaglyw _11ow1o36 _1u6lnr64",
            isLink && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_irr3166n _1di61dty",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isLink && !isStandardLink && "_9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && isInteractive && "_irr31lyj _1di6oo20",
            className
        ]),
        "data-testid": testId,
        children: [
            before,
            contentElement,
            after
        ]
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$db35d9df42c66ff0$export$2e2bcd8739ae039 = $db35d9df42c66ff0$var$BaseTag;

});
parcelRegister("2hnSR", function(module, exports) {

$parcel$export(module.exports, "textColors", () => $5b444d8505b9cc3c$export$daa0ace263cb20d2);
$parcel$export(module.exports, "borderColors", () => $5b444d8505b9cc3c$export$1c1b571cf296eca7);
$parcel$export(module.exports, "textHoverColors", () => $5b444d8505b9cc3c$export$7c7104a5f052cab7);
$parcel$export(module.exports, "textActiveColors", () => $5b444d8505b9cc3c$export$382469baad253eb7);
$parcel$export(module.exports, "backgroundColors", () => $5b444d8505b9cc3c$export$b9d7c59a579c23c6);
$parcel$export(module.exports, "linkHoverBackgroundColors", () => $5b444d8505b9cc3c$export$4410079763249c74);
$parcel$export(module.exports, "linkActiveBackgroundColors", () => $5b444d8505b9cc3c$export$76be99c5e13e3566);
$parcel$export(module.exports, "focusRingColors", () => $5b444d8505b9cc3c$export$2a31dbe82788f940);
$parcel$export(module.exports, "removalHoverBackgroundColors", () => $5b444d8505b9cc3c$export$1202b7eb21da7b58);
$parcel$export(module.exports, "removalActiveBackgroundColors", () => $5b444d8505b9cc3c$export$62ace793ebb16bda);
$parcel$export(module.exports, "removalTextColors", () => $5b444d8505b9cc3c$export$17d206ccea111bbb);
$parcel$export(module.exports, "removeButtonColors", () => $5b444d8505b9cc3c$export$f64c7641cbc22da7);
$parcel$export(module.exports, "removeButtonHoverColors", () => $5b444d8505b9cc3c$export$b03fbc2a369c563e);
// Text colors
const $5b444d8505b9cc3c$export$daa0ace263cb20d2 = {
    standard: "var(--ds-text, #253858)",
    standardLink: "var(--ds-link, #0052CC)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$1c1b571cf296eca7 = {
    standard: '#B7B9BE',
    blue: '#669DF1',
    red: '#F87168',
    yellow: '#DDB30E',
    green: '#4BCE97',
    teal: '#6CC3E0',
    purple: '#C97CF4',
    lime: '#94C748',
    magenta: '#E774BB',
    orange: '#FCA700',
    grey: '#B7B9BE',
    standardLink: '#B7B9BE',
    blueLight: '#669DF1',
    redLight: '#F87168',
    yellowLight: '#DDB30E',
    greenLight: '#4BCE97',
    tealLight: '#6CC3E0',
    purpleLight: '#C97CF4',
    limeLight: '#94C748',
    magentaLight: '#E774BB',
    orangeLight: '#FCA700',
    greyLight: '#B7B9BE'
};
const $5b444d8505b9cc3c$export$7c7104a5f052cab7 = {
    standard: "var(--ds-link, #0065FF)",
    blue: "var(--ds-text-accent-blue-bolder, #172B4D)",
    red: "var(--ds-text-accent-red-bolder, #172B4D)",
    yellow: "var(--ds-text-accent-yellow-bolder, #172B4D)",
    green: "var(--ds-text-accent-green-bolder, #172B4D)",
    teal: "var(--ds-text-accent-teal-bolder, #172B4D)",
    purple: "var(--ds-text-accent-purple-bolder, #172B4D)",
    lime: "var(--ds-text-accent-lime-bolder, #37471F)",
    magenta: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orange: "var(--ds-text-accent-orange-bolder, #5F3811)",
    grey: "var(--ds-text-accent-gray-bolder, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue, #0747A6)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #006644)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #403294)",
    limeLight: "var(--ds-text-accent-lime, #4C6B1F)",
    magentaLight: "var(--ds-text-accent-magenta, #943D73)",
    orangeLight: "var(--ds-text-accent-orange, #974F0C)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$382469baad253eb7 = {
    standard: "var(--ds-link-pressed, #0065FF)",
    blue: "var(--ds-text-accent-blue, #172B4D)",
    red: "var(--ds-text-accent-red, #172B4D)",
    yellow: "var(--ds-text-accent-yellow, #172B4D)",
    green: "var(--ds-text-accent-green, #172B4D)",
    teal: "var(--ds-text-accent-teal, #172B4D)",
    purple: "var(--ds-text-accent-purple, #172B4D)",
    lime: "var(--ds-text-accent-lime, #4C6B1F)",
    magenta: "var(--ds-text-accent-magenta, #943D73)",
    orange: "var(--ds-text-accent-orange, #974F0C)",
    grey: "var(--ds-text-accent-gray, #FFFFFF)",
    blueLight: "var(--ds-text-accent-blue-bolder, #0747A6)",
    redLight: "var(--ds-text-accent-red-bolder, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow-bolder, #42526E)",
    greenLight: "var(--ds-text-accent-green-bolder, #006644)",
    tealLight: "var(--ds-text-accent-teal-bolder, #42526E)",
    purpleLight: "var(--ds-text-accent-purple-bolder, #403294)",
    limeLight: "var(--ds-text-accent-lime-bolder, #37471F)",
    magentaLight: "var(--ds-text-accent-magenta-bolder, #50253F)",
    orangeLight: "var(--ds-text-accent-orange-bolder, #5F3811)",
    greyLight: "var(--ds-text-accent-gray-bolder, #42526E)"
};
const $5b444d8505b9cc3c$export$b9d7c59a579c23c6 = {
    standard: "var(--ds-background-neutral, #F4F5F7)",
    blue: "var(--ds-background-accent-blue-subtle, #4C9AFF)",
    red: "var(--ds-background-accent-red-subtle, #FF8F73)",
    yellow: "var(--ds-background-accent-yellow-subtle, #FFC400)",
    green: "var(--ds-background-accent-green-subtle, #57D9A3)",
    teal: "var(--ds-background-accent-teal-subtle, #00C7E6)",
    purple: "var(--ds-background-accent-purple-subtle, #998DD9)",
    lime: "var(--ds-background-accent-lime-subtle, #94C748)",
    magenta: "var(--ds-background-accent-magenta-subtle, #E774BB)",
    orange: "var(--ds-background-accent-orange-subtle, #FAA53D)",
    grey: "var(--ds-background-accent-gray-subtle, #42526E)",
    blueLight: "var(--ds-background-accent-blue-subtler, #B3D4FF)",
    redLight: "var(--ds-background-accent-red-subtler, #FFBDAD)",
    yellowLight: "var(--ds-background-accent-yellow-subtler, #FFE380)",
    greenLight: "var(--ds-background-accent-green-subtler, #79F2C0)",
    tealLight: "var(--ds-background-accent-teal-subtler, #79E2F2)",
    purpleLight: "var(--ds-background-accent-purple-subtler, #C0B6F2)",
    limeLight: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    magentaLight: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    orangeLight: "var(--ds-background-accent-orange-subtler, #FFE2BD)",
    greyLight: "var(--ds-background-accent-gray-subtler, #EBECF0)"
};
const $5b444d8505b9cc3c$export$4410079763249c74 = {
    standard: "var(--ds-background-neutral-hovered, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-hovered, #B3D4FF)",
    red: "var(--ds-background-accent-red-subtle-hovered, #FFBDAD)",
    yellow: "var(--ds-background-accent-yellow-subtle-hovered, #FFE380)",
    green: "var(--ds-background-accent-green-subtle-hovered, #79F2C0)",
    teal: "var(--ds-background-accent-teal-subtle-hovered, #79E2F2)",
    purple: "var(--ds-background-accent-purple-subtle-hovered, #C0B6F2)",
    lime: "var(--ds-background-accent-lime-subtle-hovered, #B3DF72)",
    magenta: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    orange: "var(--ds-background-accent-orange-subtle-hovered, #FEC57B)",
    grey: "var(--ds-background-accent-gray-subtle-hovered, #505F79)",
    blueLight: "var(--ds-background-accent-blue-subtler-hovered, #DEEBFF)",
    redLight: "var(--ds-background-accent-red-subtler-hovered, #FFEBE6)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-hovered, #FFF0B3)",
    greenLight: "var(--ds-background-accent-green-subtler-hovered, #ABF5D1)",
    tealLight: "var(--ds-background-accent-teal-subtler-hovered, #B3F5FF)",
    purpleLight: "var(--ds-background-accent-purple-subtler-hovered, #EAE6FF)",
    limeLight: "var(--ds-background-accent-lime-subtler-hovered, #B3DF72)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-hovered, #F797D2)",
    orangeLight: "var(--ds-background-accent-orange-subtler-hovered, #FEC57B)",
    greyLight: "var(--ds-background-accent-gray-subtler-hovered, #DFE1E6)"
};
const $5b444d8505b9cc3c$export$76be99c5e13e3566 = {
    standard: "var(--ds-background-neutral-pressed, #EBECF0)",
    blue: "var(--ds-background-accent-blue-subtle-pressed, #DEEBFF)",
    red: "var(--ds-background-accent-red-subtle-pressed, #FFEBE6)",
    yellow: "var(--ds-background-accent-yellow-subtle-pressed, #FFF0B3)",
    green: "var(--ds-background-accent-green-subtle-pressed, #ABF5D1)",
    teal: "var(--ds-background-accent-teal-subtle-pressed, #B3F5FF)",
    purple: "var(--ds-background-accent-purple-subtle-pressed, #EAE6FF)",
    grey: "var(--ds-background-accent-gray-subtle-pressed, #5E6C84)",
    lime: "var(--ds-background-accent-lime-subtle-pressed, #D3F1A7)",
    magenta: "var(--ds-background-accent-magenta-subtle-pressed, #FDD0EC)",
    orange: "var(--ds-background-accent-orange-subtle-pressed, #FFE2BD)",
    blueLight: "var(--ds-background-accent-blue-subtler-pressed, #4C9AFF)",
    redLight: "var(--ds-background-accent-red-subtler-pressed, #FF8F73)",
    yellowLight: "var(--ds-background-accent-yellow-subtler-pressed, #FFC400)",
    greenLight: "var(--ds-background-accent-green-subtler-pressed, #57D9A3)",
    tealLight: "var(--ds-background-accent-teal-subtler-pressed, #00C7E6)",
    purpleLight: "var(--ds-background-accent-purple-subtler-pressed, #998DD9)",
    limeLight: "var(--ds-background-accent-lime-subtler-pressed, #94C748)",
    magentaLight: "var(--ds-background-accent-magenta-subtler-pressed, #E774BB)",
    orangeLight: "var(--ds-background-accent-orange-subtler-pressed, #FAA53D)",
    greyLight: "var(--ds-background-accent-gray-subtler-pressed, #C1C7D0)"
};
const $5b444d8505b9cc3c$export$2a31dbe82788f940 = "var(--ds-border-focused, #4C9AFF)";
const $5b444d8505b9cc3c$export$1202b7eb21da7b58 = "var(--ds-background-danger, #FFEBE6)";
const $5b444d8505b9cc3c$export$62ace793ebb16bda = "var(--ds-background-danger-hovered, #FFEBE6)";
const $5b444d8505b9cc3c$export$17d206ccea111bbb = "var(--ds-text-danger, #BF2600)";
const $5b444d8505b9cc3c$export$f64c7641cbc22da7 = {
    standard: "var(--ds-text, #42526E)",
    blue: "var(--ds-text-accent-blue-bolder, #42526E)",
    red: "var(--ds-text-accent-red-bolder, #42526E)",
    yellow: "var(--ds-text-accent-yellow-bolder, #42526E)",
    green: "var(--ds-text-accent-green-bolder, #42526E)",
    teal: "var(--ds-text-accent-teal-bolder, #42526E)",
    purple: "var(--ds-text-accent-purple-bolder, #42526E)",
    lime: "var(--ds-text-accent-lime-bolder, #42526E)",
    magenta: "var(--ds-text-accent-magenta-bolder, #42526E)",
    orange: "var(--ds-text-accent-orange-bolder, #42526E)",
    grey: "var(--ds-text-accent-gray-bolder, #42526E)",
    blueLight: "var(--ds-text-accent-blue, #42526E)",
    redLight: "var(--ds-text-accent-red, #42526E)",
    yellowLight: "var(--ds-text-accent-yellow, #42526E)",
    greenLight: "var(--ds-text-accent-green, #42526E)",
    tealLight: "var(--ds-text-accent-teal, #42526E)",
    purpleLight: "var(--ds-text-accent-purple, #42526E)",
    limeLight: "var(--ds-text-accent-lime, #42526E)",
    magentaLight: "var(--ds-text-accent-magenta, #42526E)",
    orangeLight: "var(--ds-text-accent-orange, #42526E)",
    greyLight: "var(--ds-text-accent-gray, #42526E)"
};
const $5b444d8505b9cc3c$export$b03fbc2a369c563e = {
    standard: "var(--ds-text-danger, #253858)",
    standardLink: "var(--ds-text-danger, #0052CC)",
    blue: "var(--ds-text-danger, #172B4D)",
    red: "var(--ds-text-danger, #172B4D)",
    yellow: "var(--ds-text-danger, #172B4D)",
    green: "var(--ds-text-danger, #172B4D)",
    teal: "var(--ds-text-danger, #172B4D)",
    purple: "var(--ds-text-danger, #172B4D)",
    lime: "var(--ds-text-danger, #172B4D)",
    magenta: "var(--ds-text-danger, #172B4D)",
    orange: "var(--ds-text-danger, #172B4D)",
    grey: "var(--ds-text-danger, #FFFFFF)",
    blueLight: "var(--ds-text-danger, #0747A6)",
    redLight: "var(--ds-text-danger, #42526E)",
    yellowLight: "var(--ds-text-danger, #42526E)",
    greenLight: "var(--ds-text-danger, #006644)",
    tealLight: "var(--ds-text-danger, #42526E)",
    purpleLight: "var(--ds-text-danger, #403294)",
    limeLight: "var(--ds-text-danger, #403294)",
    magentaLight: "var(--ds-text-danger, #403294)",
    orangeLight: "var(--ds-text-danger, #403294)",
    greyLight: "var(--ds-text-danger, #42526E)"
};

});


parcelRegister("aXLIT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4b11e671062d0fc5$export$2e2bcd8739ae039);
/* before.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
const $4b11e671062d0fc5$var$beforeElementStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $4b11e671062d0fc5$var$beforeElementStylesOld = null;
const $4b11e671062d0fc5$var$Before = ({ elemBefore: elemBefore })=>elemBefore ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_1e0c1txw _4t3i7vkz _4cvr1h6o _1bah1h6o _152tze3t" : "_2rko1l5z _1e0c1txw _kqswstnw _4cvr1h6o _1bah1h6o _152tze3t"
        ]),
        children: elemBefore
    }) : null;
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$4b11e671062d0fc5$export$2e2bcd8739ae039 = $4b11e671062d0fc5$var$Before;

});

parcelRegister("eYXIO", function(module, exports) {

$parcel$export(module.exports, "default", () => $c46b06918fbe54e8$export$2e2bcd8739ae039);
/* content.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $VSDnB = parcelRequire("VSDnB");
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$baseStylesOld = null;
const $c46b06918fbe54e8$var$baseStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$linkStylesOld = null;
const $c46b06918fbe54e8$var$linkStyles = null;
const $c46b06918fbe54e8$var$hasAfterStylesOld = null;
const $c46b06918fbe54e8$var$hasAfterStyles = null;
// To be removed with platform-component-visual-refresh (BLU-2992)
const $c46b06918fbe54e8$var$hasBeforeStyles = null;
const $c46b06918fbe54e8$var$Content = ({ elemBefore: elemBefore = null, isRemovable: isRemovable = true, text: text = '', color: color = 'standard', href: href, linkComponent: linkComponent })=>{
    const Link = linkComponent ?? 'a';
    if (href) return /*#__PURE__*/ (0, $2OMIu.jsx)(Link, {
        href: href,
        "data-color": color,
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_4bfu18uv _1hmsglyw _ajmmnqa1 _syaz1fxt _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l31fxt _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1fxt" : "_4bfu18uv _1hmsglyw _ajmmnqa1 _syazs5nr _lcxv1wug _nt751r31 _49pcglyw _1hvw1o36 _9oik18uv _1bnx8stv _jf4cnqa1 _30l3117u _1nrm18uv _c2wa8stv _1iohnqa1 _9h8h1348",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
    else return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            (0, $VSDnB.fg)('platform-component-visual-refresh') ? "_11c82smr _1reo15vq _18m915vq _p12fmgvx _1bto1l2s _o5721q9c" : "_11c82smr _1reo15vq _18m915vq _p12fmgvx _y4ti1b66 _bozg1b66 _1bto1l2s _o5721q9c",
            !(0, $VSDnB.fg)('platform-component-visual-refresh') && elemBefore && "_ahbqv47k",
            isRemovable && (0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit",
            isRemovable && !(0, $VSDnB.fg)('platform-component-visual-refresh') && "_p12f1lit _y4tipxbi"
        ]),
        children: text
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$c46b06918fbe54e8$export$2e2bcd8739ae039 = $c46b06918fbe54e8$var$Content;

});


parcelRegister("7ldcY", function(module, exports) {

$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabels", () => $7fa3a87d53177c9e$export$8100203285e9ab92);
$parcel$export(module.exports, "memoizeGetAutoGeneratedColorForLabelsTag", () => $7fa3a87d53177c9e$export$a80529ae8ec44f02);

var $gJBT6 = parcelRequire("gJBT6");

var $1L3S5 = parcelRequire("1L3S5");

var $fzY6y = parcelRequire("fzY6y");

var $96pcJ = parcelRequire("96pcJ");
const $7fa3a87d53177c9e$export$97056d4b28203ee9 = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
    }
    return (0, $1L3S5.GREY_META).name;
};
const $7fa3a87d53177c9e$export$a3f5334e7a13e57a = (option)=>{
    if (option) {
        const hashValue = (0, $fzY6y.getHashValueForText)(option);
        const randomIndex = (0, $96pcJ.getRandomIndex)(hashValue);
        return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].tagColor;
    }
    return (0, $1L3S5.GREY_META).tagColor;
};
const $7fa3a87d53177c9e$export$8100203285e9ab92 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$97056d4b28203ee9);
const $7fa3a87d53177c9e$export$a80529ae8ec44f02 = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($7fa3a87d53177c9e$export$a3f5334e7a13e57a);

});
parcelRegister("1L3S5", function(module, exports) {

$parcel$export(module.exports, "GREY_META", () => $0d4a83e59182b411$export$11b75436f568ab00);
$parcel$export(module.exports, "CHECK_MARK_COLOR_DARK", () => $0d4a83e59182b411$export$270aee965367aeb3);
$parcel$export(module.exports, "CHECK_MARK_COLOR_LIGHT", () => $0d4a83e59182b411$export$941ef40ef5fdd2b1);
$parcel$export(module.exports, "OPTION_COLOR_THEMES", () => $0d4a83e59182b411$export$7f42563469df7e01);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT", () => $0d4a83e59182b411$export$2c649adf8351b065);
$parcel$export(module.exports, "OPTION_COLOR_THEMES_MAP", () => $0d4a83e59182b411$export$7c14120abebd4749);

var $9GtPC = parcelRequire("9GtPC");
const $0d4a83e59182b411$var$GREY_LIGHTEST_META = {
    name: 'GREY_LIGHTEST',
    backgroundColor: "var(--ds-background-neutral, #091E420F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLightest
};
const $0d4a83e59182b411$var$GREY_LIGHTER_META = {
    name: 'GREY_LIGHTER',
    backgroundColor: "var(--ds-background-neutral-hovered, #091E4224)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).greyLighter
};
const $0d4a83e59182b411$export$11b75436f568ab00 = {
    name: 'GREY',
    tagColor: 'grey',
    backgroundColor: "var(--ds-background-neutral-pressed, #091E424F)",
    textColor: "var(--ds-text-accent-gray-bolder, #091E42)",
    messageLabel: (0, $9GtPC.default).grey
};
const $0d4a83e59182b411$var$GREY_DARKER_META = {
    name: 'GREY_DARKER',
    tagColor: 'greyDarker',
    backgroundColor: "var(--ds-background-neutral-bold, #44546F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarker
};
const $0d4a83e59182b411$var$GREY_DARKEST_META = {
    name: 'GREY_DARKEST',
    backgroundColor: "var(--ds-background-neutral-bold-pressed, #172B4D)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greyDarkest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTEST_META = {
    name: 'PURPLE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-purple-subtlest, #F3F0FF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLightest
};
const $0d4a83e59182b411$var$PURPLE_LIGHTER_META = {
    name: 'PURPLE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-purple-subtler, #DFD8FD)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purpleLighter
};
const $0d4a83e59182b411$var$PURPLE_META = {
    name: 'PURPLE',
    tagColor: 'purple',
    backgroundColor: "var(--ds-background-accent-purple-subtle, #9F8FEF)",
    textColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    messageLabel: (0, $9GtPC.default).purple
};
const $0d4a83e59182b411$export$7c314e2461a7241b = {
    name: 'PURPLE_DARKER',
    backgroundColor: "var(--ds-text-accent-purple, #5E4DB2)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarker
};
const $0d4a83e59182b411$var$PURPLE_DARKEST_META = {
    name: 'PURPLE_DARKEST',
    backgroundColor: "var(--ds-text-accent-purple-bolder, #352C63)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).purpleDarkest
};
const $0d4a83e59182b411$var$BLUE_LIGHTEST_META = {
    name: 'BLUE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLightest
};
const $0d4a83e59182b411$var$BLUE_LIGHTER_META = {
    name: 'BLUE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-blue-subtler, #CCE0FF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blueLighter
};
const $0d4a83e59182b411$var$BLUE_META = {
    name: 'BLUE',
    backgroundColor: "var(--ds-background-accent-blue-subtle, #579DFF)",
    textColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    messageLabel: (0, $9GtPC.default).blue
};
const $0d4a83e59182b411$var$BLUE_DARKER_META = {
    name: 'BLUE_DARKER',
    backgroundColor: "var(--ds-text-accent-blue, #0055CC)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarker
};
const $0d4a83e59182b411$export$69c4eac71b813fba = {
    name: 'BLUE_DARKEST',
    backgroundColor: "var(--ds-text-accent-blue-bolder, #09326C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).blueDarkest
};
const $0d4a83e59182b411$var$TEAL_LIGHTEST_META = {
    name: 'TEAL_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-teal-subtlest, #E7F9FF)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLightest
};
const $0d4a83e59182b411$var$TEAL_LIGHTER_META = {
    name: 'TEAL_LIGHTER',
    backgroundColor: "var(--ds-background-accent-teal-subtler, #C6EDFB)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).tealLighter
};
const $0d4a83e59182b411$var$TEAL_META = {
    name: 'TEAL',
    tagColor: 'teal',
    backgroundColor: "var(--ds-background-accent-teal-subtle, #6CC3E0)",
    textColor: "var(--ds-text-accent-teal-bolder, #164555)",
    messageLabel: (0, $9GtPC.default).teal
};
const $0d4a83e59182b411$export$6daaa1cc3f46f41 = {
    name: 'TEAL_DARKER',
    backgroundColor: "var(--ds-text-accent-teal, #206A83)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarker
};
const $0d4a83e59182b411$var$TEAL_DARKEST_META = {
    name: 'TEAL_DARKEST',
    backgroundColor: "var(--ds-text-accent-teal-bolder, #164555)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).tealDarkest
};
const $0d4a83e59182b411$var$GREEN_LIGHTEST_META = {
    name: 'GREEN_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-green-subtlest, #DCFFF1)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLightest
};
const $0d4a83e59182b411$var$GREEN_LIGHTER_META = {
    name: 'GREEN_LIGHTER',
    backgroundColor: "var(--ds-background-accent-green-subtler, #BAF3DB)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).greenLighter
};
const $0d4a83e59182b411$var$GREEN_META = {
    name: 'GREEN',
    tagColor: 'green',
    backgroundColor: "var(--ds-background-accent-green-subtle, #4BCE97)",
    textColor: "var(--ds-text-accent-green-bolder, #164B35)",
    messageLabel: (0, $9GtPC.default).green
};
const $0d4a83e59182b411$var$GREEN_DARKER_META = {
    name: 'GREEN_DARKER',
    backgroundColor: "var(--ds-background-accent-green-bolder, #1F845A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarker
};
const $0d4a83e59182b411$var$GREEN_DARKEST_META = {
    name: 'GREEN_DARKEST',
    backgroundColor: "var(--ds-text-accent-green-bolder, #164B35)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).greenDarkest
};
const $0d4a83e59182b411$var$LIME_LIGHTEST_META = {
    name: 'LIME_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-lime-subtlest, #EFFFD6)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLightest
};
const $0d4a83e59182b411$var$LIME_LIGHTER_META = {
    name: 'LIME_LIGHTER',
    backgroundColor: "var(--ds-background-accent-lime-subtler, #D3F1A7)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).limeLighter
};
const $0d4a83e59182b411$var$LIME_META = {
    name: 'LIME',
    backgroundColor: "var(--ds-background-accent-lime-subtle, #94C748)",
    textColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    messageLabel: (0, $9GtPC.default).lime
};
const $0d4a83e59182b411$var$LIME_DARKER_META = {
    name: 'LIME_DARKER',
    backgroundColor: "var(--ds-text-accent-lime, #4C6B1F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarker
};
const $0d4a83e59182b411$var$LIME_DARKEST_META = {
    name: 'LIME_DARKEST',
    backgroundColor: "var(--ds-text-accent-lime-bolder, #37471F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).limeDarkest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTEST_META = {
    name: 'YELLOW_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-yellow-subtlest, #FFF7D6)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLightest
};
const $0d4a83e59182b411$var$YELLOW_LIGHTER_META = {
    name: 'YELLOW_LIGHTER',
    backgroundColor: "var(--ds-background-accent-yellow-subtler, #F8E6A0)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellowLighter
};
const $0d4a83e59182b411$var$YELLOW_META = {
    name: 'YELLOW',
    tagColor: 'yellow',
    backgroundColor: "var(--ds-background-accent-yellow-subtle, #F5CD47)",
    textColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    messageLabel: (0, $9GtPC.default).yellow
};
const $0d4a83e59182b411$var$YELLOW_DARKER_META = {
    name: 'YELLOW_DARKER',
    backgroundColor: "var(--ds-text-accent-yellow, #7F5F01)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarker
};
const $0d4a83e59182b411$var$YELLOW_DARKEST_META = {
    name: 'YELLOW_DARKEST',
    backgroundColor: "var(--ds-text-accent-yellow-bolder, #533F04)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).yellowDarkest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTEST_META = {
    name: 'ORANGE_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-orange-subtlest, #FFF3EB)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLightest
};
const $0d4a83e59182b411$var$ORANGE_LIGHTER_META = {
    name: 'ORANGE_LIGHTER',
    backgroundColor: "var(--ds-background-accent-orange-subtler, #FEDEC8)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orangeLighter
};
const $0d4a83e59182b411$var$ORANGE_META = {
    name: 'ORANGE',
    tagColor: 'orange',
    backgroundColor: "var(--ds-background-accent-orange-subtle, #FEA362)",
    textColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    messageLabel: (0, $9GtPC.default).orange
};
const $0d4a83e59182b411$var$ORANGE_DARKER_META = {
    name: 'ORANGE_DARKER',
    backgroundColor: "var(--ds-background-accent-orange-bolder, #C25100)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarker
};
const $0d4a83e59182b411$var$ORANGE_DARKEST_META = {
    name: 'ORANGE_DARKEST',
    backgroundColor: "var(--ds-text-accent-orange-bolder, #702E00)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).orangeDarkest
};
const $0d4a83e59182b411$var$RED_LIGHTEST_META = {
    name: 'RED_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLightest
};
const $0d4a83e59182b411$var$RED_LIGHTER_META = {
    name: 'RED_LIGHTER',
    backgroundColor: "var(--ds-background-accent-red-subtler, #FFD5D2)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).redLighter
};
const $0d4a83e59182b411$var$RED_META = {
    name: 'RED',
    tagColor: 'red',
    backgroundColor: "var(--ds-background-accent-red-subtle, #F87168)",
    textColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    messageLabel: (0, $9GtPC.default).red
};
const $0d4a83e59182b411$var$RED_DARKER_META = {
    name: 'RED_DARKER',
    backgroundColor: "var(--ds-background-accent-red-bolder, #C9372C)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarker
};
const $0d4a83e59182b411$var$RED_DARKEST_META = {
    name: 'RED_DARKEST',
    backgroundColor: "var(--ds-text-accent-red-bolder, #5D1F1A)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).redDarkest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META = {
    name: 'MAGENTA_LIGHTEST',
    backgroundColor: "var(--ds-background-accent-magenta-subtlest, #FFECF8)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLightest
};
const $0d4a83e59182b411$var$MAGENTA_LIGHTER_META = {
    name: 'MAGENTA_LIGHTER',
    backgroundColor: "var(--ds-background-accent-magenta-subtler, #FDD0EC)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magentaLighter
};
const $0d4a83e59182b411$var$MAGENTA_META = {
    name: 'MAGENTA',
    tagColor: 'magenta',
    backgroundColor: "var(--ds-background-accent-magenta-subtle-hovered, #F797D2)",
    textColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    messageLabel: (0, $9GtPC.default).magenta
};
const $0d4a83e59182b411$var$MAGENTA_DARKER_META = {
    name: 'MAGENTA_DARKER',
    backgroundColor: "var(--ds-text-accent-magenta, #943D73)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarker
};
const $0d4a83e59182b411$var$MAGENTA_DARKEST_META = {
    name: 'MAGENTA_DARKEST',
    backgroundColor: "var(--ds-text-accent-magenta-bolder, #50253F)",
    textColor: "var(--ds-text-inverse, #FFFFFF)",
    messageLabel: (0, $9GtPC.default).magentaDarkest
};
const $0d4a83e59182b411$export$270aee965367aeb3 = "var(--ds-text-inverse, #FFFFFF)";
const $0d4a83e59182b411$export$941ef40ef5fdd2b1 = "var(--ds-text, #172B4D)";
const $0d4a83e59182b411$export$7f42563469df7e01 = [
    $0d4a83e59182b411$var$GREY_LIGHTEST_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTEST_META,
    $0d4a83e59182b411$var$BLUE_LIGHTEST_META,
    $0d4a83e59182b411$var$TEAL_LIGHTEST_META,
    $0d4a83e59182b411$var$GREEN_LIGHTEST_META,
    $0d4a83e59182b411$var$LIME_LIGHTEST_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTEST_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTEST_META,
    $0d4a83e59182b411$var$RED_LIGHTEST_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTEST_META,
    $0d4a83e59182b411$var$GREY_LIGHTER_META,
    $0d4a83e59182b411$var$PURPLE_LIGHTER_META,
    $0d4a83e59182b411$var$BLUE_LIGHTER_META,
    $0d4a83e59182b411$var$TEAL_LIGHTER_META,
    $0d4a83e59182b411$var$GREEN_LIGHTER_META,
    $0d4a83e59182b411$var$LIME_LIGHTER_META,
    $0d4a83e59182b411$var$YELLOW_LIGHTER_META,
    $0d4a83e59182b411$var$ORANGE_LIGHTER_META,
    $0d4a83e59182b411$var$RED_LIGHTER_META,
    $0d4a83e59182b411$var$MAGENTA_LIGHTER_META,
    $0d4a83e59182b411$export$11b75436f568ab00,
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$BLUE_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$LIME_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$7c314e2461a7241b,
    $0d4a83e59182b411$var$BLUE_DARKER_META,
    $0d4a83e59182b411$export$6daaa1cc3f46f41,
    $0d4a83e59182b411$var$GREEN_DARKER_META,
    $0d4a83e59182b411$var$LIME_DARKER_META,
    $0d4a83e59182b411$var$YELLOW_DARKER_META,
    $0d4a83e59182b411$var$ORANGE_DARKER_META,
    $0d4a83e59182b411$var$RED_DARKER_META,
    $0d4a83e59182b411$var$MAGENTA_DARKER_META,
    $0d4a83e59182b411$var$GREY_DARKEST_META,
    $0d4a83e59182b411$var$PURPLE_DARKEST_META,
    $0d4a83e59182b411$export$69c4eac71b813fba,
    $0d4a83e59182b411$var$TEAL_DARKEST_META,
    $0d4a83e59182b411$var$GREEN_DARKEST_META,
    $0d4a83e59182b411$var$LIME_DARKEST_META,
    $0d4a83e59182b411$var$YELLOW_DARKEST_META,
    $0d4a83e59182b411$var$ORANGE_DARKEST_META,
    $0d4a83e59182b411$var$RED_DARKEST_META,
    $0d4a83e59182b411$var$MAGENTA_DARKEST_META
];
const $0d4a83e59182b411$export$2c649adf8351b065 = [
    $0d4a83e59182b411$var$PURPLE_META,
    $0d4a83e59182b411$var$YELLOW_META,
    $0d4a83e59182b411$var$GREEN_META,
    $0d4a83e59182b411$var$TEAL_META,
    $0d4a83e59182b411$var$RED_META,
    $0d4a83e59182b411$var$ORANGE_META,
    $0d4a83e59182b411$var$MAGENTA_META,
    $0d4a83e59182b411$var$GREY_DARKER_META,
    $0d4a83e59182b411$export$11b75436f568ab00
];
const $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP = {};
$0d4a83e59182b411$export$2c649adf8351b065.forEach((option)=>{
    $0d4a83e59182b411$var$OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT_MAP[option.name] = option;
});
const $0d4a83e59182b411$export$7c14120abebd4749 = {};
$0d4a83e59182b411$export$7f42563469df7e01.forEach((option)=>{
    $0d4a83e59182b411$export$7c14120abebd4749[option.name] = option;
});

});
parcelRegister("9GtPC", function(module, exports) {

$parcel$export(module.exports, "default", () => $8610941b4777e2f7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8610941b4777e2f7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    greyLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lightest",
        "defaultMessage": "Grey lightest"
    },
    greyLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-lighter",
        "defaultMessage": "Grey lighter"
    },
    grey: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey",
        "defaultMessage": "Grey"
    },
    greyDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darker",
        "defaultMessage": "Grey darker"
    },
    greyDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.grey-darkest",
        "defaultMessage": "Grey darkest"
    },
    purpleLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lightest",
        "defaultMessage": "Purple lightest"
    },
    purpleLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-lighter",
        "defaultMessage": "Purple lighter"
    },
    purple: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple",
        "defaultMessage": "Purple"
    },
    purpleDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darker",
        "defaultMessage": "Purple darker"
    },
    purpleDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.purple-darkest",
        "defaultMessage": "Purple darkest"
    },
    blueLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lightest",
        "defaultMessage": "Blue lightest"
    },
    blueLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-lighter",
        "defaultMessage": "Blue lighter"
    },
    blue: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue",
        "defaultMessage": "Blue"
    },
    blueDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darker",
        "defaultMessage": "Blue darker"
    },
    blueDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.blue-darkest",
        "defaultMessage": "Blue darkest"
    },
    tealLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lightest",
        "defaultMessage": "Teal lightest"
    },
    tealLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-lighter",
        "defaultMessage": "Teal lighter"
    },
    teal: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal",
        "defaultMessage": "Teal"
    },
    tealDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darker",
        "defaultMessage": "Teal darker"
    },
    tealDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.teal-darkest",
        "defaultMessage": "Teal darkest"
    },
    greenLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lightest",
        "defaultMessage": "Green lightest"
    },
    greenLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-lighter",
        "defaultMessage": "Green lighter"
    },
    green: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green",
        "defaultMessage": "Green"
    },
    greenDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darker",
        "defaultMessage": "Green darker"
    },
    greenDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.green-darkest",
        "defaultMessage": "Green darkest"
    },
    limeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lightest",
        "defaultMessage": "Lime lightest"
    },
    limeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-lighter",
        "defaultMessage": "Lime lighter"
    },
    lime: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime",
        "defaultMessage": "Lime"
    },
    limeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darker",
        "defaultMessage": "Lime darker"
    },
    limeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.lime-darkest",
        "defaultMessage": "Lime darkest"
    },
    yellowLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lightest",
        "defaultMessage": "Yellow lightest"
    },
    yellowLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-lighter",
        "defaultMessage": "Yellow lighter"
    },
    yellow: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow",
        "defaultMessage": "Yellow"
    },
    yellowDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darker",
        "defaultMessage": "Yellow darker"
    },
    yellowDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.yellow-darkest",
        "defaultMessage": "Yellow darkest"
    },
    orangeLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lightest",
        "defaultMessage": "Orange lightest"
    },
    orangeLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-lighter",
        "defaultMessage": "Orange lighter"
    },
    orange: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange",
        "defaultMessage": "Orange"
    },
    orangeDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darker",
        "defaultMessage": "Orange darker"
    },
    orangeDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.orange-darkest",
        "defaultMessage": "Orange darkest"
    },
    redLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lightest",
        "defaultMessage": "Red lightest"
    },
    redLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-lighter",
        "defaultMessage": "Red lighter"
    },
    red: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red",
        "defaultMessage": "Red"
    },
    redDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darker",
        "defaultMessage": "Red darker"
    },
    redDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.red-darkest",
        "defaultMessage": "Red darkest"
    },
    magentaLightest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lightest",
        "defaultMessage": "Magenta lightest"
    },
    magentaLighter: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-lighter",
        "defaultMessage": "Magenta lighter"
    },
    magenta: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta",
        "defaultMessage": "Magenta"
    },
    magentaDarker: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darker",
        "defaultMessage": "Magenta darker"
    },
    magentaDarkest: {
        "id": "@atlassian/jira-option-color-picker.color-picker.magenta-darkest",
        "defaultMessage": "Magenta darkest"
    }
});

});


parcelRegister("fzY6y", function(module, exports) {

$parcel$export(module.exports, "getHashValueForText", () => $899e3507d4080274$export$e352defce701b36e);

const $899e3507d4080274$export$e352defce701b36e = (text)=>{
    let hashValue = 0;
    for(let i = 0; i < text.length; i++)hashValue = (hashValue * (0, $37d3405989cb4520$export$d15e38bcd75fda7c) + text.charCodeAt(i)) % (0, $37d3405989cb4520$export$e143f4b09221a374);
    return hashValue;
};

});
/*
 * This is used to calculate the hash value of the provided text,
 * allowing us to generate random hash values for the options in the Labels field.
 * As a result, we enhance the randomization of color assignments to Labels.
 */ const $37d3405989cb4520$export$d15e38bcd75fda7c = 256;
const $37d3405989cb4520$export$e143f4b09221a374 = 1000000007;


parcelRegister("96pcJ", function(module, exports) {

$parcel$export(module.exports, "getRandomIndex", () => $9ffc042ff38af51a$export$cb0dffe2d2ae675a);

var $1L3S5 = parcelRequire("1L3S5");
const $9ffc042ff38af51a$export$cb0dffe2d2ae675a = (hashValue)=>{
    const colorThemesLength = (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length;
    const randomIndex = hashValue % colorThemesLength;
    return randomIndex;
};

});


parcelRegister("ek97b", function(module, exports) {

$parcel$export(module.exports, "getRandomColor", () => $c5f14892c9125c93$export$e4369cabd7e84cd9);
$parcel$export(module.exports, "getColorNameFromValue", () => $c5f14892c9125c93$export$b5ccbadd112d8ce9);
$parcel$export(module.exports, "getValueFromColorName", () => $c5f14892c9125c93$export$9eff62e8ee2aaa2c);
$parcel$export(module.exports, "getColorMetadata", () => $c5f14892c9125c93$export$49fce7fdcf55f26d);

var $1L3S5 = parcelRequire("1L3S5");
const $c5f14892c9125c93$export$e4369cabd7e84cd9 = ()=>{
    const randomIndex = Math.floor(Math.random() * (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT).length);
    return (0, $1L3S5.OPTION_COLOR_THEMES_COLORFUL_SINGLE_SELECT)[randomIndex].name;
};
const $c5f14892c9125c93$export$b5ccbadd112d8ce9 = (colorValue)=>(0, $1L3S5.OPTION_COLOR_THEMES).find((item)=>item.backgroundColor === colorValue)?.name ?? '';
const $c5f14892c9125c93$export$9eff62e8ee2aaa2c = (colorName)=>(0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName]?.backgroundColor ?? '';
const $c5f14892c9125c93$export$49fce7fdcf55f26d = (colorName)=>{
    if (!colorName) return 0, $1L3S5.GREY_META;
    return (0, $1L3S5.OPTION_COLOR_THEMES_MAP)[colorName] ?? (0, $1L3S5.GREY_META);
};
const $c5f14892c9125c93$export$4ef6b7574883e63d = ()=>(0, $1L3S5.OPTION_COLOR_THEMES).map((item)=>item.name);

});




parcelRegister("jdK9h", function(module, exports) {

$parcel$export(module.exports, "TextSmartLinkCustomFieldContent", () => $04b5197ce11033cf$export$ec046456ac8ae97b);

var $5uXOq = parcelRequire("5uXOq");

var $iZOJ9 = parcelRequire("iZOJ9");

var $1RMb0 = parcelRequire("1RMb0");

var $khuza = parcelRequire("khuza");

var $9yDQx = parcelRequire("9yDQx");
const $04b5197ce11033cf$export$ec046456ac8ae97b = ({ field: field })=>field.text && (0, $iZOJ9.isSafeUrl)(field.text) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1RMb0.LazySingleLineSmartLink), {
        anchorTarget: "_blank",
        url: field.text
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $khuza.CustomFieldTooltip), {
        field: field
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yDQx.TextCardCustomFieldContent), {
        field: field
    }));

});
parcelRegister("iZOJ9", function(module, exports) {

$parcel$export(module.exports, "isSafeUrl", () => $dd4545da25e52dce$export$c9f92f5469372e0f);
$parcel$export(module.exports, "linkify", () => $dd4545da25e52dce$export$8ccbde94d5c7f8e7);
$parcel$export(module.exports, "linkifyMatch", () => $dd4545da25e52dce$export$6f7d7761b97f967);
$parcel$export(module.exports, "getLinkMatch", () => $dd4545da25e52dce$export$ce9ae45aed3e4ec);
$parcel$export(module.exports, "normalizeUrl", () => $dd4545da25e52dce$export$6535eb414fa2c8b6);
$parcel$export(module.exports, "isRootRelative", () => $dd4545da25e52dce$export$23579274a7a24f7b);
/**
 * This file has been partially duplicated in packages/linking-platform/linking-common/src/url.ts
 * Any changes made here should be mirrored there.
 * Ticket for dedeplication: https://product-fabric.atlassian.net/browse/EDM-7138
 * Ticket for fixing linkification of filename-like urls: https://product-fabric.atlassian.net/browse/EDM-7190
 */ 
var $i6xkD = parcelRequire("i6xkD");
const $dd4545da25e52dce$var$whitelistedURLPatterns = [
    /^https?:\/\//im,
    /^ftps?:\/\//im,
    /^gopher:\/\//im,
    /^integrity:\/\//im,
    /^file:\/\//im,
    /^smb:\/\//im,
    /^dynamicsnav:\/\//im,
    /^jamfselfservice:\/\//im,
    /^\//im,
    /^mailto:/im,
    /^skype:/im,
    /^callto:/im,
    /^facetime:/im,
    /^git:/im,
    /^irc6?:/im,
    /^news:/im,
    /^nntp:/im,
    /^feed:/im,
    /^cvs:/im,
    /^svn:/im,
    /^mvn:/im,
    /^ssh:/im,
    /^scp:\/\//im,
    /^sftp:\/\//im,
    /^itms:/im,
    // This is not a valid notes link, but we support this pattern for backwards compatibility
    /^notes:/im,
    /^notes:\/\//im,
    /^hipchat:\/\//im,
    // This is not a valid sourcetree link, but we support this pattern for backwards compatibility
    /^sourcetree:/im,
    /^sourcetree:\/\//im,
    /^urn:/im,
    /^tel:/im,
    /^xmpp:/im,
    /^telnet:/im,
    /^vnc:/im,
    /^rdp:/im,
    /^whatsapp:/im,
    /^slack:/im,
    /^sips?:/im,
    /^magnet:/im,
    /^#/im
];
const $dd4545da25e52dce$export$c9f92f5469372e0f = (url)=>{
    const urlTrimmed = url.trim();
    if (urlTrimmed.length === 0) return true;
    return $dd4545da25e52dce$var$whitelistedURLPatterns.some((p)=>p.test(urlTrimmed));
};
const $dd4545da25e52dce$export$8ccbde94d5c7f8e7 = (0, (/*@__PURE__*/$parcel$interopDefault($i6xkD)))();
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('sourcetree:', 'http:');
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('jamfselfservice:', 'http:');
const $dd4545da25e52dce$var$urlWithoutSpacesValidator = {
    validate: /[^\s]+/
};
// `tel:` URI spec is https://datatracker.ietf.org/doc/html/rfc3966
// We're not validating the phone number or separators - but if there's a space it definitely isn't a valid `tel:` URI
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('tel:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
// https://datatracker.ietf.org/doc/html/rfc8089
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('file:', $dd4545da25e52dce$var$urlWithoutSpacesValidator);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.add('notes:', 'http:');
const $dd4545da25e52dce$var$tlds = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
const $dd4545da25e52dce$var$tlds2Char = 'a[cdefgilmnoqrtuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrtuvwxyz]|n[acefgilopruz]|om|p[aefghkmnrtw]|qa|r[eosuw]|s[abcdegijklmnrtuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
$dd4545da25e52dce$var$tlds.push($dd4545da25e52dce$var$tlds2Char);
$dd4545da25e52dce$export$8ccbde94d5c7f8e7.tlds($dd4545da25e52dce$var$tlds, false);
const $dd4545da25e52dce$export$746d02eae03c72e1 = /(https?|ftp|jamfselfservice|gopher|dynamicsnav|integrity|file|smb):\/\/[^\s]+/;
const $dd4545da25e52dce$export$6f7d7761b97f967 = (text)=>{
    if (!$dd4545da25e52dce$export$746d02eae03c72e1.test(text)) return [];
    const matches = [];
    let startpos = 0;
    let substr;
    while(substr = text.substr(startpos)){
        const link = (substr.match($dd4545da25e52dce$export$746d02eae03c72e1) || [
            ''
        ])[0];
        if (link) {
            const index = substr.search($dd4545da25e52dce$export$746d02eae03c72e1);
            const start = index >= 0 ? index + startpos : index;
            const end = start + link.length;
            matches.push({
                index: start,
                lastIndex: end,
                raw: link,
                url: link,
                text: link,
                schema: ''
            });
            startpos += end;
        } else break;
    }
    return matches;
};
function $dd4545da25e52dce$export$ce9ae45aed3e4ec(str) {
    if (!str) return null;
    // linkify-it mishandles closing braces on long urls, so we preference using our own regex first:
    // https://product-fabric.atlassian.net/browse/ED-13669
    let match = $dd4545da25e52dce$export$6f7d7761b97f967(str);
    if (!match.length) match = $dd4545da25e52dce$export$8ccbde94d5c7f8e7.match(str);
    return match && match[0];
}
function $dd4545da25e52dce$export$6535eb414fa2c8b6(url) {
    const match = $dd4545da25e52dce$export$ce9ae45aed3e4ec(url);
    return match && match.url || '';
}
function $dd4545da25e52dce$export$23579274a7a24f7b(url) {
    // Support `#top` and `#` special references as per:
    // https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#linking_to_an_element_on_the_same_page
    return url.startsWith('/') || url === '#top' || url === '#';
}

});
parcelRegister("i6xkD", function(module, exports) {
'use strict';
////////////////////////////////////////////////////////////////////////////////
// Helpers
// Merge objects
//
function $d2e2a485107d561a$var$assign(obj /*from1, from2, from3, ...*/ ) {
    var sources = Array.prototype.slice.call(arguments, 1);
    sources.forEach(function(source) {
        if (!source) return;
        Object.keys(source).forEach(function(key) {
            obj[key] = source[key];
        });
    });
    return obj;
}
function $d2e2a485107d561a$var$_class(obj) {
    return Object.prototype.toString.call(obj);
}
function $d2e2a485107d561a$var$isString(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object String]';
}
function $d2e2a485107d561a$var$isObject(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Object]';
}
function $d2e2a485107d561a$var$isRegExp(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object RegExp]';
}
function $d2e2a485107d561a$var$isFunction(obj) {
    return $d2e2a485107d561a$var$_class(obj) === '[object Function]';
}
function $d2e2a485107d561a$var$escapeRE(str) {
    return str.replace(/[.?*+^$[\]\\(){}|-]/g, '\\$&');
}
////////////////////////////////////////////////////////////////////////////////
var $d2e2a485107d561a$var$defaultOptions = {
    fuzzyLink: true,
    fuzzyEmail: true,
    fuzzyIP: false
};
function $d2e2a485107d561a$var$isOptionsObj(obj) {
    return Object.keys(obj || {}).reduce(function(acc, k) {
        return acc || $d2e2a485107d561a$var$defaultOptions.hasOwnProperty(k);
    }, false);
}
var $d2e2a485107d561a$var$defaultSchemas = {
    'http:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.http = new RegExp('^\\/\\/' + self.re.src_auth + self.re.src_host_port_strict + self.re.src_path, 'i');
            if (self.re.http.test(tail)) return tail.match(self.re.http)[0].length;
            return 0;
        }
    },
    'https:': 'http:',
    'ftp:': 'http:',
    '//': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.no_http) // compile lazily, because "host"-containing variables can change on tlds update.
            self.re.no_http = new RegExp('^' + self.re.src_auth + // Don't allow single-level domains, because of false positives like '//test'
            // with code comments
            '(?:localhost|(?:(?:' + self.re.src_domain + ')\\.)+' + self.re.src_domain_root + ')' + self.re.src_port + self.re.src_host_terminator + self.re.src_path, 'i');
            if (self.re.no_http.test(tail)) {
                // should not be `://` & `///`, that protects from errors in protocol name
                if (pos >= 3 && text[pos - 3] === ':') return 0;
                if (pos >= 3 && text[pos - 3] === '/') return 0;
                return tail.match(self.re.no_http)[0].length;
            }
            return 0;
        }
    },
    'mailto:': {
        validate: function(text, pos, self) {
            var tail = text.slice(pos);
            if (!self.re.mailto) self.re.mailto = new RegExp('^' + self.re.src_email_name + '@' + self.re.src_host_strict, 'i');
            if (self.re.mailto.test(tail)) return tail.match(self.re.mailto)[0].length;
            return 0;
        }
    }
};
/*eslint-disable max-len*/ // RE pattern for 2-character tlds (autogenerated by ./support/tlds_2char_gen.js)
var $d2e2a485107d561a$var$tlds_2ch_src_re = 'a[cdefgilmnoqrstuwxz]|b[abdefghijmnorstvwyz]|c[acdfghiklmnoruvwxyz]|d[ejkmoz]|e[cegrstu]|f[ijkmor]|g[abdefghilmnpqrstuwy]|h[kmnrtu]|i[delmnoqrst]|j[emop]|k[eghimnprwyz]|l[abcikrstuvy]|m[acdeghklmnopqrstuvwxyz]|n[acefgilopruz]|om|p[aefghklmnrstwy]|qa|r[eosuw]|s[abcdeghijklmnortuvxyz]|t[cdfghjklmnortvwz]|u[agksyz]|v[aceginu]|w[fs]|y[et]|z[amw]';
// DON'T try to make PRs with changes. Extend TLDs with LinkifyIt.tlds() instead
var $d2e2a485107d561a$var$tlds_default = "biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|\u0440\u0444".split('|');
/*eslint-enable max-len*/ ////////////////////////////////////////////////////////////////////////////////
function $d2e2a485107d561a$var$resetScanCache(self) {
    self.__index__ = -1;
    self.__text_cache__ = '';
}
function $d2e2a485107d561a$var$createValidator(re) {
    return function(text, pos) {
        var tail = text.slice(pos);
        if (re.test(tail)) return tail.match(re)[0].length;
        return 0;
    };
}
function $d2e2a485107d561a$var$createNormalizer() {
    return function(match, self) {
        self.normalize(match);
    };
}

// Schemas compiler. Build regexps.
//
function $d2e2a485107d561a$var$compile(self) {
    // Load & clone RE patterns.
    var re = self.re = (parcelRequire("9mKTr"))(self.__opts__);
    // Define dynamic patterns
    var tlds = self.__tlds__.slice();
    self.onCompile();
    if (!self.__tlds_replaced__) tlds.push($d2e2a485107d561a$var$tlds_2ch_src_re);
    tlds.push(re.src_xn);
    re.src_tlds = tlds.join('|');
    function untpl(tpl) {
        return tpl.replace('%TLDS%', re.src_tlds);
    }
    re.email_fuzzy = RegExp(untpl(re.tpl_email_fuzzy), 'i');
    re.link_fuzzy = RegExp(untpl(re.tpl_link_fuzzy), 'i');
    re.link_no_ip_fuzzy = RegExp(untpl(re.tpl_link_no_ip_fuzzy), 'i');
    re.host_fuzzy_test = RegExp(untpl(re.tpl_host_fuzzy_test), 'i');
    //
    // Compile each schema
    //
    var aliases = [];
    self.__compiled__ = {}; // Reset compiled data
    function schemaError(name, val) {
        throw new Error('(LinkifyIt) Invalid schema "' + name + '": ' + val);
    }
    Object.keys(self.__schemas__).forEach(function(name) {
        var val = self.__schemas__[name];
        // skip disabled methods
        if (val === null) return;
        var compiled = {
            validate: null,
            link: null
        };
        self.__compiled__[name] = compiled;
        if ($d2e2a485107d561a$var$isObject(val)) {
            if ($d2e2a485107d561a$var$isRegExp(val.validate)) compiled.validate = $d2e2a485107d561a$var$createValidator(val.validate);
            else if ($d2e2a485107d561a$var$isFunction(val.validate)) compiled.validate = val.validate;
            else schemaError(name, val);
            if ($d2e2a485107d561a$var$isFunction(val.normalize)) compiled.normalize = val.normalize;
            else if (!val.normalize) compiled.normalize = $d2e2a485107d561a$var$createNormalizer();
            else schemaError(name, val);
            return;
        }
        if ($d2e2a485107d561a$var$isString(val)) {
            aliases.push(name);
            return;
        }
        schemaError(name, val);
    });
    //
    // Compile postponed aliases
    //
    aliases.forEach(function(alias) {
        if (!self.__compiled__[self.__schemas__[alias]]) // Silently fail on missed schemas to avoid errons on disable.
        // schemaError(alias, self.__schemas__[alias]);
        return;
        self.__compiled__[alias].validate = self.__compiled__[self.__schemas__[alias]].validate;
        self.__compiled__[alias].normalize = self.__compiled__[self.__schemas__[alias]].normalize;
    });
    //
    // Fake record for guessed links
    //
    self.__compiled__[''] = {
        validate: null,
        normalize: $d2e2a485107d561a$var$createNormalizer()
    };
    //
    // Build schema condition
    //
    var slist = Object.keys(self.__compiled__).filter(function(name) {
        // Filter disabled & fake schemas
        return name.length > 0 && self.__compiled__[name];
    }).map($d2e2a485107d561a$var$escapeRE).join('|');
    // (?!_) cause 1.5x slowdown
    self.re.schema_test = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'i');
    self.re.schema_search = RegExp('(^|(?!_)(?:[><\uff5c]|' + re.src_ZPCc + '))(' + slist + ')', 'ig');
    self.re.pretest = RegExp('(' + self.re.schema_test.source + ')|' + '(' + self.re.host_fuzzy_test.source + ')|' + '@', 'i');
    //
    // Cleanup
    //
    $d2e2a485107d561a$var$resetScanCache(self);
}
/**
 * class Match
 *
 * Match result. Single element of array, returned by [[LinkifyIt#match]]
 **/ function $d2e2a485107d561a$var$Match(self, shift) {
    var start = self.__index__, end = self.__last_index__, text = self.__text_cache__.slice(start, end);
    /**
   * Match#schema -> String
   *
   * Prefix (protocol) for matched string.
   **/ this.schema = self.__schema__.toLowerCase();
    /**
   * Match#index -> Number
   *
   * First position of matched string.
   **/ this.index = start + shift;
    /**
   * Match#lastIndex -> Number
   *
   * Next position after matched string.
   **/ this.lastIndex = end + shift;
    /**
   * Match#raw -> String
   *
   * Matched string.
   **/ this.raw = text;
    /**
   * Match#text -> String
   *
   * Notmalized text of matched string.
   **/ this.text = text;
    /**
   * Match#url -> String
   *
   * Normalized url of matched string.
   **/ this.url = text;
}
function $d2e2a485107d561a$var$createMatch(self, shift) {
    var match = new $d2e2a485107d561a$var$Match(self, shift);
    self.__compiled__[match.schema].normalize(match, self);
    return match;
}
/**
 * class LinkifyIt
 **/ /**
 * new LinkifyIt(schemas, options)
 * - schemas (Object): Optional. Additional schemas to validate (prefix/validator)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Creates new linkifier instance with optional additional schemas.
 * Can be called without `new` keyword for convenience.
 *
 * By default understands:
 *
 * - `http(s)://...` , `ftp://...`, `mailto:...` & `//...` links
 * - "fuzzy" links and emails (example.com, foo@bar.com).
 *
 * `schemas` is an object, where each key/value describes protocol/rule:
 *
 * - __key__ - link prefix (usually, protocol name with `:` at the end, `skype:`
 *   for example). `linkify-it` makes shure that prefix is not preceeded with
 *   alphanumeric char and symbols. Only whitespaces and punctuation allowed.
 * - __value__ - rule to check tail after link prefix
 *   - _String_ - just alias to existing rule
 *   - _Object_
 *     - _validate_ - validator function (should return matched length on success),
 *       or `RegExp`.
 *     - _normalize_ - optional function to normalize text & url of matched result
 *       (for example, for @twitter mentions).
 *
 * `options`:
 *
 * - __fuzzyLink__ - recognige URL-s without `http(s):` prefix. Default `true`.
 * - __fuzzyIP__ - allow IPs in fuzzy links above. Can conflict with some texts
 *   like version numbers. Default `false`.
 * - __fuzzyEmail__ - recognize emails without `mailto:` prefix.
 *
 **/ function $d2e2a485107d561a$var$LinkifyIt(schemas, options) {
    if (!(this instanceof $d2e2a485107d561a$var$LinkifyIt)) return new $d2e2a485107d561a$var$LinkifyIt(schemas, options);
    if (!options) {
        if ($d2e2a485107d561a$var$isOptionsObj(schemas)) {
            options = schemas;
            schemas = {};
        }
    }
    this.__opts__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultOptions, options);
    // Cache last tested result. Used to skip repeating steps on next `match` call.
    this.__index__ = -1;
    this.__last_index__ = -1; // Next scan position
    this.__schema__ = '';
    this.__text_cache__ = '';
    this.__schemas__ = $d2e2a485107d561a$var$assign({}, $d2e2a485107d561a$var$defaultSchemas, schemas);
    this.__compiled__ = {};
    this.__tlds__ = $d2e2a485107d561a$var$tlds_default;
    this.__tlds_replaced__ = false;
    this.re = {};
    $d2e2a485107d561a$var$compile(this);
}
/** chainable
 * LinkifyIt#add(schema, definition)
 * - schema (String): rule name (fixed pattern prefix)
 * - definition (String|RegExp|Object): schema definition
 *
 * Add new rule definition. See constructor description for details.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.add = function add(schema, definition) {
    this.__schemas__[schema] = definition;
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/** chainable
 * LinkifyIt#set(options)
 * - options (Object): { fuzzyLink|fuzzyEmail|fuzzyIP: true|false }
 *
 * Set recognition options for links without schema.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.set = function set(options) {
    this.__opts__ = $d2e2a485107d561a$var$assign(this.__opts__, options);
    return this;
};
/**
 * LinkifyIt#test(text) -> Boolean
 *
 * Searches linkifiable pattern and returns `true` on success or `false` on fail.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.test = function test(text) {
    // Reset scan cache
    this.__text_cache__ = text;
    this.__index__ = -1;
    if (!text.length) return false;
    var m, ml, me, len, shift, next, re, tld_pos, at_pos;
    // try to scan for link with schema - that's the most simple rule
    if (this.re.schema_test.test(text)) {
        re = this.re.schema_search;
        re.lastIndex = 0;
        while((m = re.exec(text)) !== null){
            len = this.testSchemaAt(text, m[2], re.lastIndex);
            if (len) {
                this.__schema__ = m[2];
                this.__index__ = m.index + m[1].length;
                this.__last_index__ = m.index + m[0].length + len;
                break;
            }
        }
    }
    if (this.__opts__.fuzzyLink && this.__compiled__['http:']) {
        // guess schemaless links
        tld_pos = text.search(this.re.host_fuzzy_test);
        if (tld_pos >= 0) {
            // if tld is located after found link - no need to check fuzzy pattern
            if (this.__index__ < 0 || tld_pos < this.__index__) {
                if ((ml = text.match(this.__opts__.fuzzyIP ? this.re.link_fuzzy : this.re.link_no_ip_fuzzy)) !== null) {
                    shift = ml.index + ml[1].length;
                    if (this.__index__ < 0 || shift < this.__index__) {
                        this.__schema__ = '';
                        this.__index__ = shift;
                        this.__last_index__ = ml.index + ml[0].length;
                    }
                }
            }
        }
    }
    if (this.__opts__.fuzzyEmail && this.__compiled__['mailto:']) {
        // guess schemaless emails
        at_pos = text.indexOf('@');
        if (at_pos >= 0) // We can't skip this check, because this cases are possible:
        // 192.168.1.1@gmail.com, my.in@example.com
        {
            if ((me = text.match(this.re.email_fuzzy)) !== null) {
                shift = me.index + me[1].length;
                next = me.index + me[0].length;
                if (this.__index__ < 0 || shift < this.__index__ || shift === this.__index__ && next > this.__last_index__) {
                    this.__schema__ = 'mailto:';
                    this.__index__ = shift;
                    this.__last_index__ = next;
                }
            }
        }
    }
    return this.__index__ >= 0;
};
/**
 * LinkifyIt#pretest(text) -> Boolean
 *
 * Very quick check, that can give false positives. Returns true if link MAY BE
 * can exists. Can be used for speed optimization, when you need to check that
 * link NOT exists.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.pretest = function pretest(text) {
    return this.re.pretest.test(text);
};
/**
 * LinkifyIt#testSchemaAt(text, name, position) -> Number
 * - text (String): text to scan
 * - name (String): rule (schema) name
 * - position (Number): text offset to check from
 *
 * Similar to [[LinkifyIt#test]] but checks only specific protocol tail exactly
 * at given position. Returns length of found pattern (0 on fail).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.testSchemaAt = function testSchemaAt(text, schema, pos) {
    // If not supported schema check requested - terminate
    if (!this.__compiled__[schema.toLowerCase()]) return 0;
    return this.__compiled__[schema.toLowerCase()].validate(text, pos, this);
};
/**
 * LinkifyIt#match(text) -> Array|null
 *
 * Returns array of found link descriptions or `null` on fail. We strongly
 * recommend to use [[LinkifyIt#test]] first, for best speed.
 *
 * ##### Result match description
 *
 * - __schema__ - link schema, can be empty for fuzzy links, or `//` for
 *   protocol-neutral  links.
 * - __index__ - offset of matched text
 * - __lastIndex__ - index of next char after mathch end
 * - __raw__ - matched text
 * - __text__ - normalized text
 * - __url__ - link, generated from matched text
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.match = function match(text) {
    var shift = 0, result = [];
    // Try to take previous element from cache, if .test() called before
    if (this.__index__ >= 0 && this.__text_cache__ === text) {
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        shift = this.__last_index__;
    }
    // Cut head if cache was used
    var tail = shift ? text.slice(shift) : text;
    // Scan string until end reached
    while(this.test(tail)){
        result.push($d2e2a485107d561a$var$createMatch(this, shift));
        tail = tail.slice(this.__last_index__);
        shift += this.__last_index__;
    }
    if (result.length) return result;
    return null;
};
/** chainable
 * LinkifyIt#tlds(list [, keepOld]) -> this
 * - list (Array): list of tlds
 * - keepOld (Boolean): merge with current list if `true` (`false` by default)
 *
 * Load (or merge) new tlds list. Those are user for fuzzy links (without prefix)
 * to avoid false positives. By default this algorythm used:
 *
 * - hostname with any 2-letter root zones are ok.
 * - biz|com|edu|gov|net|org|pro|web|xxx|aero|asia|coop|info|museum|name|shop|рф
 *   are ok.
 * - encoded (`xn--...`) root zones are ok.
 *
 * If list is replaced, then exact match for 2-chars root zones will be checked.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.tlds = function tlds(list, keepOld) {
    list = Array.isArray(list) ? list : [
        list
    ];
    if (!keepOld) {
        this.__tlds__ = list.slice();
        this.__tlds_replaced__ = true;
        $d2e2a485107d561a$var$compile(this);
        return this;
    }
    this.__tlds__ = this.__tlds__.concat(list).sort().filter(function(el, idx, arr) {
        return el !== arr[idx - 1];
    }).reverse();
    $d2e2a485107d561a$var$compile(this);
    return this;
};
/**
 * LinkifyIt#normalize(match)
 *
 * Default normalizer (if schema does not define it's own).
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.normalize = function normalize(match) {
    // Do minimal possible changes by default. Need to collect feedback prior
    // to move forward https://github.com/markdown-it/linkify-it/issues/1
    if (!match.schema) match.url = 'http://' + match.url;
    if (match.schema === 'mailto:' && !/^mailto:/i.test(match.url)) match.url = 'mailto:' + match.url;
};
/**
 * LinkifyIt#onCompile()
 *
 * Override to modify basic RegExp-s.
 **/ $d2e2a485107d561a$var$LinkifyIt.prototype.onCompile = function onCompile() {};
module.exports = $d2e2a485107d561a$var$LinkifyIt;

});
parcelRegister("9mKTr", function(module, exports) {
'use strict';




module.exports = function(opts) {
    var re = {};
    // Use direct extract instead of `regenerate` to reduse browserified size
    re.src_Any = (parcelRequire("b9ep3")).source;
    re.src_Cc = (parcelRequire("23ErL")).source;
    re.src_Z = (parcelRequire("oRY4m")).source;
    re.src_P = (parcelRequire("9bBmm")).source;
    // \p{\Z\P\Cc\CF} (white spaces + control + format + punctuation)
    re.src_ZPCc = [
        re.src_Z,
        re.src_P,
        re.src_Cc
    ].join('|');
    // \p{\Z\Cc} (white spaces + control)
    re.src_ZCc = [
        re.src_Z,
        re.src_Cc
    ].join('|');
    // Experimental. List of chars, completely prohibited in links
    // because can separate it from other part of text
    var text_separators = '[><\uff5c]';
    // All possible word characters (everything without punctuation, spaces & controls)
    // Defined via punctuation & spaces to save space
    // Should be something like \p{\L\N\S\M} (\w but without `_`)
    re.src_pseudo_letter = '(?:(?!' + text_separators + '|' + re.src_ZPCc + ')' + re.src_Any + ')';
    // The same as abothe but without [0-9]
    // var src_pseudo_letter_non_d = '(?:(?![0-9]|' + src_ZPCc + ')' + src_Any + ')';
    ////////////////////////////////////////////////////////////////////////////////
    re.src_ip4 = '(?:(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\\.){3}(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)';
    // Prohibit any of "@/[]()" in user/pass to avoid wrong domain fetch.
    re.src_auth = '(?:(?:(?!' + re.src_ZCc + '|[@/\\[\\]()]).)+@)?';
    re.src_port = '(?::(?:6(?:[0-4]\\d{3}|5(?:[0-4]\\d{2}|5(?:[0-2]\\d|3[0-5])))|[1-5]?\\d{1,4}))?';
    re.src_host_terminator = '(?=$|' + text_separators + '|' + re.src_ZPCc + ')(?!-|_|:\\d|\\.-|\\.(?!$|' + re.src_ZPCc + '))';
    re.src_path = "(?:[/?#](?:(?!" + re.src_ZCc + '|' + text_separators + '|[()[\\]{}.,"\'?!\\-]).|' + '\\[(?:(?!' + re.src_ZCc + '|\\]).)*\\]|' + '\\((?:(?!' + re.src_ZCc + '|[)]).)*\\)|' + '\\{(?:(?!' + re.src_ZCc + '|[}]).)*\\}|' + '\\"(?:(?!' + re.src_ZCc + '|["]).)+\\"|' + "\\'(?:(?!" + re.src_ZCc + "|[']).)+\\'|" + "\\'(?=" + re.src_pseudo_letter + '|[-]).|' + // allow `I'm_king` if no pair found
    '\\.{2,3}[a-zA-Z0-9%/]|' + // github has ... in commit range links. Restrict to
    // - english
    // - percent-encoded
    // - parts of file path
    // until more examples found.
    '\\.(?!' + re.src_ZCc + '|[.]).|' + (opts && opts['---'] ? '\\-(?!--(?:[^-]|$))(?:-*)|' // `---` => long dash, terminate
     : '\\-+|') + '\\,(?!' + re.src_ZCc + ').|' + // allow `,,,` in paths
    '\\!(?!' + re.src_ZCc + '|[!]).|' + '\\?(?!' + re.src_ZCc + '|[?]).' + ')+' + '|\\/' + ')?';
    re.src_email_name = '[\\-;:&=\\+\\$,\\"\\.a-zA-Z0-9_]+';
    re.src_xn = 'xn--[a-z0-9\\-]{1,59}';
    // More to read about domain names
    // http://serverfault.com/questions/638260/
    re.src_domain_root = // Allow letters & digits (http://test1)
    '(?:' + re.src_xn + '|' + re.src_pseudo_letter + '{1,63}' + ')';
    re.src_domain = '(?:' + re.src_xn + '|' + '(?:' + re.src_pseudo_letter + ')' + '|' + // don't allow `--` in domain names, because:
    // - that can conflict with markdown &mdash; / &ndash;
    // - nobody use those anyway
    '(?:' + re.src_pseudo_letter + '(?:-(?!-)|' + re.src_pseudo_letter + '){0,61}' + re.src_pseudo_letter + ')' + ')';
    re.src_host = "(?:(?:(?:(?:" + re.src_domain + ')\\.)*' + re.src_domain /*_root*/  + ')' + ')';
    re.tpl_host_fuzzy = '(?:' + re.src_ip4 + '|' + '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))' + ')';
    re.tpl_host_no_ip_fuzzy = '(?:(?:(?:' + re.src_domain + ')\\.)+(?:%TLDS%))';
    re.src_host_strict = re.src_host + re.src_host_terminator;
    re.tpl_host_fuzzy_strict = re.tpl_host_fuzzy + re.src_host_terminator;
    re.src_host_port_strict = re.src_host + re.src_port + re.src_host_terminator;
    re.tpl_host_port_fuzzy_strict = re.tpl_host_fuzzy + re.src_port + re.src_host_terminator;
    re.tpl_host_port_no_ip_fuzzy_strict = re.tpl_host_no_ip_fuzzy + re.src_port + re.src_host_terminator;
    ////////////////////////////////////////////////////////////////////////////////
    // Main rules
    // Rude test fuzzy links by host, for quick deny
    re.tpl_host_fuzzy_test = 'localhost|www\\.|\\.\\d{1,3}\\.|(?:\\.(?:%TLDS%)(?:' + re.src_ZPCc + '|>|$))';
    re.tpl_email_fuzzy = '(^|' + text_separators + '|\\(|' + re.src_ZCc + ')(' + re.src_email_name + '@' + re.tpl_host_fuzzy_strict + ')';
    re.tpl_link_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_fuzzy_strict + re.src_path + ')';
    re.tpl_link_no_ip_fuzzy = // Fuzzy link can't be prepended with .:/\- and non punctuation.
    // but can start with > (markdown blockquote)
    '(^|(?![.:/\\-_@])(?:[$+<=>^`|\uff5c]|' + re.src_ZPCc + '))' + '((?![$+<=>^`|\uff5c])' + re.tpl_host_port_no_ip_fuzzy_strict + re.src_path + ')';
    return re;
};

});
parcelRegister("b9ep3", function(module, exports) {
module.exports = /[\0-\uD7FF\uE000-\uFFFF]|[\uD800-\uDBFF][\uDC00-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF]/;

});

parcelRegister("23ErL", function(module, exports) {
module.exports = /[\0-\x1F\x7F-\x9F]/;

});

parcelRegister("oRY4m", function(module, exports) {
module.exports = /[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/;

});

parcelRegister("9bBmm", function(module, exports) {
module.exports = /[!-#%-\*,-/:;\?@\[-\]_\{\}\xA1\xA7\xAB\xB6\xB7\xBB\xBF\u037E\u0387\u055A-\u055F\u0589\u058A\u05BE\u05C0\u05C3\u05C6\u05F3\u05F4\u0609\u060A\u060C\u060D\u061B\u061E\u061F\u066A-\u066D\u06D4\u0700-\u070D\u07F7-\u07F9\u0830-\u083E\u085E\u0964\u0965\u0970\u09FD\u0AF0\u0DF4\u0E4F\u0E5A\u0E5B\u0F04-\u0F12\u0F14\u0F3A-\u0F3D\u0F85\u0FD0-\u0FD4\u0FD9\u0FDA\u104A-\u104F\u10FB\u1360-\u1368\u1400\u166D\u166E\u169B\u169C\u16EB-\u16ED\u1735\u1736\u17D4-\u17D6\u17D8-\u17DA\u1800-\u180A\u1944\u1945\u1A1E\u1A1F\u1AA0-\u1AA6\u1AA8-\u1AAD\u1B5A-\u1B60\u1BFC-\u1BFF\u1C3B-\u1C3F\u1C7E\u1C7F\u1CC0-\u1CC7\u1CD3\u2010-\u2027\u2030-\u2043\u2045-\u2051\u2053-\u205E\u207D\u207E\u208D\u208E\u2308-\u230B\u2329\u232A\u2768-\u2775\u27C5\u27C6\u27E6-\u27EF\u2983-\u2998\u29D8-\u29DB\u29FC\u29FD\u2CF9-\u2CFC\u2CFE\u2CFF\u2D70\u2E00-\u2E2E\u2E30-\u2E49\u3001-\u3003\u3008-\u3011\u3014-\u301F\u3030\u303D\u30A0\u30FB\uA4FE\uA4FF\uA60D-\uA60F\uA673\uA67E\uA6F2-\uA6F7\uA874-\uA877\uA8CE\uA8CF\uA8F8-\uA8FA\uA8FC\uA92E\uA92F\uA95F\uA9C1-\uA9CD\uA9DE\uA9DF\uAA5C-\uAA5F\uAADE\uAADF\uAAF0\uAAF1\uABEB\uFD3E\uFD3F\uFE10-\uFE19\uFE30-\uFE52\uFE54-\uFE61\uFE63\uFE68\uFE6A\uFE6B\uFF01-\uFF03\uFF05-\uFF0A\uFF0C-\uFF0F\uFF1A\uFF1B\uFF1F\uFF20\uFF3B-\uFF3D\uFF3F\uFF5B\uFF5D\uFF5F-\uFF65]|\uD800[\uDD00-\uDD02\uDF9F\uDFD0]|\uD801\uDD6F|\uD802[\uDC57\uDD1F\uDD3F\uDE50-\uDE58\uDE7F\uDEF0-\uDEF6\uDF39-\uDF3F\uDF99-\uDF9C]|\uD804[\uDC47-\uDC4D\uDCBB\uDCBC\uDCBE-\uDCC1\uDD40-\uDD43\uDD74\uDD75\uDDC5-\uDDC9\uDDCD\uDDDB\uDDDD-\uDDDF\uDE38-\uDE3D\uDEA9]|\uD805[\uDC4B-\uDC4F\uDC5B\uDC5D\uDCC6\uDDC1-\uDDD7\uDE41-\uDE43\uDE60-\uDE6C\uDF3C-\uDF3E]|\uD806[\uDE3F-\uDE46\uDE9A-\uDE9C\uDE9E-\uDEA2]|\uD807[\uDC41-\uDC45\uDC70\uDC71]|\uD809[\uDC70-\uDC74]|\uD81A[\uDE6E\uDE6F\uDEF5\uDF37-\uDF3B\uDF44]|\uD82F\uDC9F|\uD836[\uDE87-\uDE8B]|\uD83A[\uDD5E\uDD5F]/;

});




parcelRegister("1RMb0", function(module, exports) {

$parcel$export(module.exports, "LazySingleLineSmartLink", () => $1520f3a29774e13a$export$80092fcb07ccc4b4);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7c22Q = parcelRequire("7c22Q");
const $1520f3a29774e13a$var$entryPointParams = {};
const $1520f3a29774e13a$export$80092fcb07ccc4b4 = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7c22Q.SingleLineSmartLinkEntryPoint), $1520f3a29774e13a$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.issue-field.single-line-smart-link",
        packageName: "issue-field-smart-link",
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("7c22Q", function(module, exports) {

$parcel$export(module.exports, "SingleLineSmartLinkEntryPoint", () => $5f4ae65db2a1976a$export$e236c9b35543c8d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5f4ae65db2a1976a$export$e236c9b35543c8d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("lEZC9")).then((module)=>module.SingleLineSmartLink), {
        moduleId: "97818dc4"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("lEZC9", function(module, exports) {

let $fc4d20b9422643e9$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $fc4d20b9422643e9$var$load("fliVL"),
    $fc4d20b9422643e9$var$load("eVTNs")
]).then(()=>parcelRequire('k2J4N'));

});






parcelRegister("cfZh8", function(module, exports) {

$parcel$export(module.exports, "CardDaysInColumn", () => $ed1b32948e6895dc$export$f04590cce2f79373);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $h6USi = parcelRequire("h6USi");
function $ed1b32948e6895dc$export$f04590cce2f79373({ days: days }) {
    let dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    if (days >= 20) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }));
    else if (days >= 12) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }));
    else if (days >= 8) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }));
    else if (days >= 5) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('danger')
    }));
    else if (days >= 3) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('warning')
    }));
    else if (days >= 2) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtleDark')
    }));
    else if (days >= 1) dots = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$Circle, {
        color: $ed1b32948e6895dc$var$getColor('subtle')
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const content = formatMessage((0, $h6USi.messages).daysInColumn, {
        days: Math.floor(days)
    });
    return days < 1 ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed1b32948e6895dc$var$DaysInColumnContainer, {
        role: "tooltip",
        "aria-label": content,
        tabIndex: 0
    }, dots));
}
const $ed1b32948e6895dc$var$Circle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1osq _bfhk1cj8 _1bsbi2wt _4t3ii2wt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed1b32948e6895dc$var$DaysInColumnContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpv77o _4t3i1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $ed1b32948e6895dc$var$getColor = (mode)=>{
    if (mode === 'danger') return "var(--ds-icon-danger, #C9372C)";
    if (mode === 'warning') return "var(--ds-icon-warning, #E56910)";
    if (mode === 'subtleDark' && (0, $4R6GH.fg)('tanuki_a11y_fixes_drop_2')) return "var(--ds-icon-subtle, #626F86)";
    if (mode === 'subtleDark') return "var(--ds-background-accent-gray-subtle, #8590A2)";
    return (0, $4R6GH.fg)('tanuki_a11y_fixes_drop_2') ? "var(--ds-icon-accent-gray, #758195)" : "var(--ds-icon-disabled, #091E424F)";
};

});
parcelRegister("h6USi", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0a0238dda0e414cf$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0a0238dda0e414cf$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    daysInColumn: {
        "id": "card.common.days-in-column.days-in-column",
        "defaultMessage": "{days, plural, one {# day} other {# days}} in this column"
    }
});

});


parcelRegister("8nii0", function(module, exports) {

$parcel$export(module.exports, "CardIcons", () => $0e1e23d3fd48a837$export$27b853f1f7815a63);
$parcel$export(module.exports, "Container", () => $0e1e23d3fd48a837$export$42a852a2b6b56249);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $0e1e23d3fd48a837$export$27b853f1f7815a63 = (props)=>{
    const { children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0e1e23d3fd48a837$export$42a852a2b6b56249, null, children);
};
var $0e1e23d3fd48a837$export$2e2bcd8739ae039 = $0e1e23d3fd48a837$export$27b853f1f7815a63;
const $0e1e23d3fd48a837$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _1e0c1txw _1bah1b1v _4cvr1h6o _1nvfidpf _1nei1b66 _rt2pidpf _bmksidpf _fhioidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("33c4b", function(module, exports) {

$parcel$export(module.exports, "AssigneeFieldStatic", () => $6457a47baf887e46$export$20dedc39b82b5168);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $5ovlb = parcelRequire("5ovlb");
const $6457a47baf887e46$export$20dedc39b82b5168 = ({ value: value })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const name = (0, $5uXOq.useMemo)(()=>value?.id ? formatMessage((0, $5ovlb.default).assigneeTooltip, {
            name: value.displayName
        }) : formatMessage((0, $5ovlb.default).assigneeTooltipUnassigned), [
        value,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6457a47baf887e46$var$AvatarWrapper, {
        "data-testid": "software-board.common.fields.assignee-field-static.avatar-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        src: value?.avatarUrl,
        name: name,
        size: "small",
        borderColor: "transparent"
    })));
};
var $6457a47baf887e46$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($6457a47baf887e46$export$20dedc39b82b5168);
const $6457a47baf887e46$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5ovlb", function(module, exports) {

$parcel$export(module.exports, "default", () => $7591000e305eadbb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7591000e305eadbb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "software.main.common.fields.assignee-field-static.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    },
    assigneeTooltipUnassigned: {
        "id": "software.main.common.fields.assignee-field-static.assignee-tooltip-unassigned",
        "defaultMessage": "Unassigned"
    }
});

});


parcelRegister("acAaD", function(module, exports) {

$parcel$export(module.exports, "IssueParentFieldStatic", () => $c0cd7d95915b3900$export$d366f2026d61a000);

var $5uXOq = parcelRequire("5uXOq");

var $koOOC = parcelRequire("koOOC");
const $c0cd7d95915b3900$export$d366f2026d61a000 = ({ color: color, summary: summary, maxWidth: maxWidth })=>{
    if (color === null || summary === null) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $koOOC.EpicLozenge), {
        color: color,
        summary: summary,
        maxWidth: maxWidth
    });
};

});
parcelRegister("koOOC", function(module, exports) {

$parcel$export(module.exports, "EpicLozenge", () => $415a24051fa911e5$export$2e623d726e27c97);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3u0c5 = parcelRequire("3u0c5");

var $3bDjY = parcelRequire("3bDjY");

var $7XYc4 = parcelRequire("7XYc4");

var $iHPnC = parcelRequire("iHPnC");

var $dCm1o = parcelRequire("dCm1o");

var $k8qVk = parcelRequire("k8qVk");

var $7Fute = parcelRequire("7Fute");
const $415a24051fa911e5$export$2e623d726e27c97 = ({ color: color, summary: summary, maxWidth: maxWidth, isCompactView: isCompactView })=>{
    const paletteColorValues = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.primary);
    const selectedColor = color && paletteColorValues[color] || '';
    return isCompactView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary
    }, selectedColor && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($415a24051fa911e5$export$d9d9ccbf5da84ba4, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        color: selectedColor
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($415a24051fa911e5$var$LozengeWrapper, {
        "data-component-selector": "parent-switcher-epic-lozenge-wrapper",
        "data-testid": (0, $k8qVk.PARENT_SWITCHER_LOZENGE_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: summary,
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop, @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
        style: (0, $7Fute.getLozengeThemeByColor)(color),
        maxWidth: maxWidth,
        testId: "issue-field-parent-switcher.common.ui.epic-lozenge.lozenge"
    }, summary)));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $415a24051fa911e5$var$LozengeWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _6ndb1osq _1ksmjp4b",
            __cmplp.className
        ])
    });
});
const $415a24051fa911e5$var$LozengeWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _p12f1osq _vwz4kb7n _8x2o1r31 _ce7mglyw _7r681o36 _1ksmjp4b _6ndb1osq",
            __cmplp.className
        ])
    });
});
const $415a24051fa911e5$var$LozengeWrapper = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $415a24051fa911e5$var$LozengeWrapperNew, $415a24051fa911e5$var$LozengeWrapperOld);
const $415a24051fa911e5$export$d9d9ccbf5da84ba4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11q71cj8 _19pkidpf _2hwxidpf _otyridpf _18u0idpf _1o9zidpf _1bsb7vkz _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("aTBle", function(module, exports) {

$parcel$export(module.exports, "default", () => $d0c8ddd8c062199c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6XiwG = parcelRequire("6XiwG");
const $d0c8ddd8c062199c$var$Placeholder = ({ mediaId: mediaId })=>{
    const [height] = (0, $6XiwG.useCardMediaHeightById)({
        mediaId: mediaId
    });
    if (height === null) return null;
    // eslint-disable-next-line jira/react/no-style-attribute
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d0c8ddd8c062199c$var$PlaceholderContainer, {
        style: {
            height: `${height}px`
        }
    });
};
var $d0c8ddd8c062199c$export$2e2bcd8739ae039 = $d0c8ddd8c062199c$var$Placeholder;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d0c8ddd8c062199c$var$PlaceholderContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkome6u _1bsb1osq _bfhkqbzx",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6XiwG", function(module, exports) {

$parcel$export(module.exports, "useCardMediaHeightById", () => $390f7f1ec234c9a0$export$32a8960ab7cdab5d);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $bYSCr = parcelRequire("bYSCr");
const $390f7f1ec234c9a0$var$getCardMediaHeightById = (state, { mediaId: mediaId })=>{
    if (!state[mediaId]) return null;
    return state[mediaId].height;
};
const $390f7f1ec234c9a0$export$32a8960ab7cdab5d = (0, $3sQ5x.createHook)((0, $bYSCr.Store), {
    selector: $390f7f1ec234c9a0$var$getCardMediaHeightById
});

});
parcelRegister("bYSCr", function(module, exports) {

$parcel$export(module.exports, "Store", () => $a8fc5a0390027126$export$390f32400eaf98c9);
$parcel$export(module.exports, "useCardMediaActions", () => $a8fc5a0390027126$export$b6c16ead0e8ed8e7);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $iEhb0 = parcelRequire("iEhb0");

var $3DmOE = parcelRequire("3DmOE");
const $a8fc5a0390027126$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $3DmOE.initialState,
    actions: $iEhb0.default
});
const $a8fc5a0390027126$export$b6c16ead0e8ed8e7 = (0, $3sQ5x.createHook)($a8fc5a0390027126$export$390f32400eaf98c9, {
    selector: null
});

});
parcelRegister("iEhb0", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9520b52250d5694$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3DmOE = parcelRequire("3DmOE");
const $d9520b52250d5694$var$actions = {
    setMediaHeight: (mediaId, height)=>({ setState: setState })=>{
            setState({
                [mediaId]: {
                    height: height
                }
            });
        },
    clearCardMedia: ()=>({ setState: setState })=>setState((0, $3DmOE.initialState))
};
var $d9520b52250d5694$export$2e2bcd8739ae039 = $d9520b52250d5694$var$actions;

});
parcelRegister("3DmOE", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $253cc0fbdd4559f4$export$d4c72bab9d6cc13a);
const $253cc0fbdd4559f4$export$d4c72bab9d6cc13a = {};

});





parcelRegister("aeiE5", function(module, exports) {

$parcel$export(module.exports, "IssueLinksIndicator", () => $c03398e8f4d51854$export$4be8a1ac20d299ac);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $lIgcn = parcelRequire("lIgcn");

var $1I7E8 = parcelRequire("1I7E8");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $67sX6 = parcelRequire("67sX6");

var $j4MnI = parcelRequire("j4MnI");

var $d2i8f = parcelRequire("d2i8f");

var $2f454 = parcelRequire("2f454");

var $49E4m = parcelRequire("49E4m");

var $dlhFx = parcelRequire("dlhFx");
const $c03398e8f4d51854$var$DependencyIndicatorContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isOfftrack: false,
    isSelected: false
});
const $c03398e8f4d51854$var$stopPropagation = (e)=>e.stopPropagation();
const $c03398e8f4d51854$var$DependencyIndicatorIcon = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isOfftrack: isOfftrack, isSelected: isSelected } = (0, $5uXOq.useContext)($c03398e8f4d51854$var$DependencyIndicatorContext);
    const message = formatMessage((0, $dlhFx.default).viewDependencyDetails);
    if (!(0, $dCm1o.isVisualRefreshEnabled)()) {
        const { primaryColor: primaryColor, secondaryColor: secondaryColor } = (()=>{
            if (isSelected) return {
                primaryColor: "var(--ds-icon-selected, #0C66E4)",
                secondaryColor: "var(--ds-icon-inverse, #FFFFFF)"
            };
            if (isOfftrack) return {
                primaryColor: "var(--ds-background-accent-red-subtlest, #FFECEB)",
                secondaryColor: "var(--ds-icon-danger, #C9372C)"
            };
            return {
                primaryColor: "var(--ds-background-neutral, #091E420F)",
                secondaryColor: "var(--ds-text, #172B4D)"
            };
        })();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lIgcn))), {
            ...props,
            label: message,
            color: "var(--ds-icon, #44546F)",
            LEGACY_size: "medium",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor
        });
    }
    const iconColor = (()=>{
        if (isSelected) // Setting the color to undefined will reset to the default behaviour to automatically adjust based on the background color
        return undefined;
        if (isOfftrack) return "var(--ds-icon-danger, #C9372C)";
        return "var(--ds-icon, #44546F)";
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lIgcn))), {
        ...props,
        label: message,
        color: iconColor
    });
};
const $c03398e8f4d51854$export$4be8a1ac20d299ac = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [popupOpen, setPopupOpen] = (0, $5uXOq.useState)(false);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const isOfftrack = (0, $67sX6.useBoardSelector)((state)=>{
        const issueLinks = (0, $d2i8f.getIssueById)(state, props.issueId)?.issueLinks || [];
        let flag = false;
        for(let i = 0; i < issueLinks.length; i++)if (issueLinks[i].isOfftrack) {
            flag = true;
            break;
        }
        return flag;
    });
    const isSelected = (0, $67sX6.useBoardSelector)((state)=>(0, $j4MnI.getIssueIdsToShowDependencies)(state).includes(`${props.issueId}`));
    const flyoutContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $49E4m.default), {
            issueKey: props.issueKey,
            issueId: props.issueId
        }), [
        props.issueKey,
        props.issueId
    ]);
    const onIndicatorBtnClick = (0, $5uXOq.useCallback)(()=>{
        setPopupOpen(!popupOpen);
        if ((0, $4R6GH.fg)('render_program_board_card_in_popup')) dispatch((0, $2f454.setInlineEditing)('dependencies', props.issueId, true));
    }, [
        popupOpen,
        setPopupOpen,
        dispatch,
        props.issueId
    ]);
    const onPopUpClose = (0, $5uXOq.useCallback)(()=>{
        setPopupOpen(false);
        if ((0, $4R6GH.fg)('render_program_board_card_in_popup')) dispatch((0, $2f454.setInlineEditing)('dependencies', props.issueId, false));
    }, [
        setPopupOpen,
        dispatch,
        props.issueId
    ]);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const message = formatMessage((0, $dlhFx.default).viewDependencyDetails);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c03398e8f4d51854$var$DependencyIndicatorContext.Provider, {
            value: {
                isOfftrack: isOfftrack,
                isSelected: isSelected
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            onClick: $c03398e8f4d51854$var$stopPropagation,
            onKeyDown: $c03398e8f4d51854$var$stopPropagation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: message
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            appearance: isSelected && (0, $dCm1o.isVisualRefreshEnabled)() ? 'primary' : 'subtle',
            spacing: "compact",
            shape: "circle",
            onClick: onIndicatorBtnClick,
            isSelected: popupOpen,
            label: message,
            icon: $c03398e8f4d51854$var$DependencyIndicatorIcon,
            testId: "software-board.board-container.board.card-container.card.issue-links-indicator.icon-button"
        }))));
    }, [
        isOfftrack,
        isSelected,
        onIndicatorBtnClick,
        popupOpen,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c03398e8f4d51854$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: popupOpen,
        content: flyoutContent,
        trigger: trigger,
        onClose: onPopUpClose,
        shouldUseCaptureOnOutsideClick: true
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c03398e8f4d51854$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
var $c03398e8f4d51854$export$2e2bcd8739ae039 = $c03398e8f4d51854$export$4be8a1ac20d299ac;

});
parcelRegister("lIgcn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::545cceb35ec45eaa251081b0ec9fada0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fcea45b858675c59$var$_react = $fcea45b858675c59$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fcea45b858675c59$var$_link = $fcea45b858675c59$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $fcea45b858675c59$var$_linkFilled = $fcea45b858675c59$var$_interopRequireDefault((parcelRequire("7a6BY")));
function $fcea45b858675c59$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkFilledIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fcea45b858675c59$var$LinkIcon = (props)=>/*#__PURE__*/ $fcea45b858675c59$var$_react.default.createElement($fcea45b858675c59$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $fcea45b858675c59$var$_linkFilled.default
    }, props));
$fcea45b858675c59$var$LinkIcon.Name = 'LinkIconMigration';
var $fcea45b858675c59$var$_default = module.exports.default = $fcea45b858675c59$var$LinkIcon;

});
parcelRegister("1f9bV", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7acdc4638dae9667d9917d02594abf75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0e7e525cdad15340$var$_react = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0e7e525cdad15340$var$_baseNew = $0e7e525cdad15340$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0e7e525cdad15340$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Link".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0e7e525cdad15340$var$LinkIcon = (props)=>/*#__PURE__*/ $0e7e525cdad15340$var$_react.default.createElement($0e7e525cdad15340$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8.22 2.22a3.932 3.932 0 1 1 5.56 5.56l-2.25 2.25-1.06-1.06 2.25-2.25a2.432 2.432 0 0 0-3.44-3.44L7.03 5.53 5.97 4.47zm3.06 3.56-5.5 5.5-1.06-1.06 5.5-5.5zM2.22 8.22l2.25-2.25 1.06 1.06-2.25 2.25a2.432 2.432 0 0 0 3.44 3.44l2.25-2.25 1.06 1.06-2.25 2.25a3.932 3.932 0 1 1-5.56-5.56" clip-rule="evenodd"/>`
    }, props));
$0e7e525cdad15340$var$LinkIcon.displayName = 'LinkIcon';
var $0e7e525cdad15340$var$_default = module.exports.default = $0e7e525cdad15340$var$LinkIcon;

});

parcelRegister("7a6BY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $536e987ca6b29465$var$_react = $536e987ca6b29465$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $536e987ca6b29465$var$_link = $536e987ca6b29465$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $536e987ca6b29465$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $536e987ca6b29465$var$LinkFilledIcon = (props)=>/*#__PURE__*/ $536e987ca6b29465$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><circle cx="12" cy="12" r="10" fill="currentcolor"/><path fill="inherit" d="m11.75 16.15.548-.537a.585.585 0 0 0 0-.838.61.61 0 0 0-.854 0l-.574.564c-.564.553-1.483.662-2.101.168a1.482 1.482 0 0 1-.119-2.223l1.694-1.663a1.543 1.543 0 0 1 2.156 0l.647.635.853-.839-.646-.635a2.775 2.775 0 0 0-3.863 0l-1.694 1.664a2.66 2.66 0 0 0 .208 3.979c1.104.884 2.738.715 3.746-.275"/><path fill="inherit" d="m12.25 7.85-.547.537a.585.585 0 0 0 0 .838.61.61 0 0 0 .853 0l.574-.564c.564-.553 1.483-.662 2.101-.168.71.57.75 1.603.119 2.223l-1.694 1.663a1.543 1.543 0 0 1-2.156 0l-.647-.635-.853.839.646.635a2.775 2.775 0 0 0 3.863 0l1.695-1.664a2.66 2.66 0 0 0-.209-3.979c-1.104-.884-2.738-.715-3.746.275"/></g></svg>`
    }, props, {
        newIcon: $536e987ca6b29465$var$_link.default
    }));
$536e987ca6b29465$var$LinkFilledIcon.displayName = 'LinkFilledIcon';
var $536e987ca6b29465$var$_default = module.exports.default = $536e987ca6b29465$var$LinkFilledIcon;

});


parcelRegister("49E4m", function(module, exports) {

$parcel$export(module.exports, "default", () => $4569487d8abf03f1$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $183uB = parcelRequire("183uB");

var $dPSWJ = parcelRequire("dPSWJ");

var $2NMNM = parcelRequire("2NMNM");

var $99M5v = parcelRequire("99M5v");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $HeOPt = parcelRequire("HeOPt");

var $9kb7x = parcelRequire("9kb7x");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $8zOmE = parcelRequire("8zOmE");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $4cYhQ = parcelRequire("4cYhQ");

var $3uPqt = parcelRequire("3uPqt");

var $iDGXn = parcelRequire("iDGXn");

var $kgiLc = parcelRequire("kgiLc");

var $6WzWZ = parcelRequire("6WzWZ");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $j4MnI = parcelRequire("j4MnI");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");


var $2Nvkb = parcelRequire("2Nvkb");
const $4569487d8abf03f1$var$IssueLinksDetailsGroupWrapper = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const selectedIssueIdsForShowDependencyLines = (0, $iDGXn.useIssueIdsToShowDependencies)();
    const { setIssueIdsToShowDependencies: setIssueIdsToShowDependencies } = (0, $iDGXn.useViewSettingsActions)();
    const boardId = Number((0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector)));
    const [isShowLinesChecked, setIsShowLinesChecked] = (0, $5uXOq.useState)(selectedIssueIdsForShowDependencyLines.includes(`${props.issueId}`));
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, props.issueId));
    const issueType = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueTypeById)(state, issue.typeId));
    const issues = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getIssues)(state));
    const issuesArray = (0, $5uXOq.useMemo)(()=>Object.values(issues), [
        issues
    ]);
    const { internal: issueLinks, external: external } = (0, $67sX6.useBoardSelector)((state)=>(0, $j4MnI.getIssueLinksForDependenciesFlyout)(state)(props.issueId, formatMessage((0, $2Nvkb.default).offtrackLabel)));
    const issueLinkAndDirectionMap = (0, $67sX6.useBoardSelector)((state)=>(0, $j4MnI.getIssueLinksForDependenciesModal)(state)(props.issueId));
    const [maxIssuesToDisplay, setMaxIssuesToDisplay] = (0, $5uXOq.useState)(undefined);
    const allInternalLinks = (0, (/*@__PURE__*/$parcel$interopDefault($183uB)))(Object.values(issueLinks));
    const isIPBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const issuesWithLinksById = (0, $67sX6.useBoardSelector)((0, $5mTgl.getIssuesEntriesWithIssueLinks));
    const issueLinkTypes = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueLinkTypes));
    const issueTypes = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueTypes)); // this is a hacky way to aviod cyclic dependency between view-settings and software board. It can go away if Issue type and CardType type gets extracted to board common.
    const issuesWithLinksByIdAnalytics = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(issuesWithLinksById, (i)=>({
                typeId: i.typeId,
                issueLinks: i.issueLinks
            })), [
        issuesWithLinksById
    ]);
    const issueTypesAnalytics = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(issueTypes, (t)=>({
                hierarchyLevelType: t.hierarchyLevelType
            })), [
        issueTypes
    ]);
    const { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject } = (0, $HeOPt.useIssueLinkedModalEntrypointActions)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onUnlinkIssueAction = (0, $67sX6.useBoardActionCreator)((boardIssueLink)=>(0, $6WzWZ.issueLinksRemoveRequest)({
            issueId: props.issueId,
            issueLink: boardIssueLink
        }));
    const planId = (0, $67sX6.useBoardSelector)((0, $67Z81.getPlanId));
    const scenarioId = (0, $67sX6.useBoardSelector)((0, $67Z81.getScenarioId));
    const onUnlinkIssue = (0, $5uXOq.useCallback)(async (issueLink)=>{
        if (issueLink.issueLinkId) {
            const boardIssueLink = issue.issueLinks ? issue.issueLinks.find((link)=>link.id === issueLink.issueLinkId) : undefined;
            if (boardIssueLink) {
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button'
                }), 'unlinkIssue');
                return onUnlinkIssueAction(boardIssueLink);
            }
        }
    }, [
        onUnlinkIssueAction,
        issue.issueLinks,
        createAnalyticsEvent
    ]);
    const onLinkIssueRequest = (0, $5uXOq.useCallback)(async (issueId, newIssueLinks, issueLinkType)=>{
        const isInwards = issueLinkType.direction === (0, $7ea9780e1aa4575d$export$b5e2b68b0fa7f1c8);
        return Promise.all(newIssueLinks.map(({ value: value })=>(0, $kgiLc.wrapActionWithPromise)(dispatch, (0, $6WzWZ.issueLinkCreateRequest)({
                sourceItemKey: `${isInwards ? value : issueId}`,
                targetItemKey: `${isInwards ? issueId : value}`,
                type: Number(issueLinkType.id)
            }))));
    }, [
        dispatch
    ]);
    const renderExternalLinksMessage = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050",
            xcss: [
                allInternalLinks.length > 0 && $4569487d8abf03f1$var$externalIssueLinksStyles
            ]
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4569487d8abf03f1$var$titleStyles
        }, formatMessage((0, $2Nvkb.default).externalIssueLinksTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            paddingBlockEnd: "space.075"
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2Nvkb.default).externalIssueLinksDescriptionIssueTermRefresh : (0, $2Nvkb.default).externalIssueLinksDescription, {
            externalIssueLinksCount: external
        })));
    const handleShowLinesToggleChange = (0, $5uXOq.useCallback)((event)=>{
        const isChecked = event.target.checked;
        const attributes = (0, $bdYfL.getIssueLinksAnalytics)(issue.issueLinks, props.issueId, issueLinkTypes, issuesWithLinksByIdAnalytics, issueTypesAnalytics);
        if (!isShowLinesChecked && selectedIssueIdsForShowDependencyLines.length >= (0, $4jAPy.MAX_SELECTED_ISSUES_FOR_DEPENDENCY_LINES)) {
            setIsShowLinesChecked(false);
            dispatch((0, $6WzWZ.reachDependencyLinesLimitInIPBoard)((0, $4jAPy.MAX_SELECTED_ISSUES_FOR_DEPENDENCY_LINES)));
            sendAnalyticsEvent((0, $4cYhQ.Action).CHANGED, (0, $4cYhQ.ActionSubject).TOGGLE, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).ISSUE_IDS_TO_SHOW_DEPENDENCIES,
                NumberOfCardDependencies: issue.issueLinks?.length,
                ToggledOn: isChecked,
                ToggleFailed: true,
                isScenarioIssue: (0, $bdYfL.isScenarioIssue)(props.issueId),
                ...attributes
            }, 'increment-planning-board');
            return;
        }
        setIsShowLinesChecked(isChecked);
        if (isChecked) {
            const newIds = [
                ...selectedIssueIdsForShowDependencyLines,
                `${props.issueId}`
            ];
            setIssueIdsToShowDependencies(boardId, Array.from(new Set(newIds)));
        } else setIssueIdsToShowDependencies(boardId, selectedIssueIdsForShowDependencyLines.filter((id)=>`${id}` !== `${props.issueId}`));
        sendAnalyticsEvent((0, $4cYhQ.Action).CHANGED, (0, $4cYhQ.ActionSubject).TOGGLE, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).ISSUE_IDS_TO_SHOW_DEPENDENCIES,
            NumberOfCardDependencies: issue.issueLinks?.length,
            ToggledOn: isChecked,
            isScenarioIssue: (0, $bdYfL.isScenarioIssue)(props.issueId),
            ...attributes
        }, 'increment-planning-board');
    }, [
        issue.issueLinks,
        props.issueId,
        issueLinkTypes,
        issuesWithLinksByIdAnalytics,
        issueTypesAnalytics,
        isShowLinesChecked,
        selectedIssueIdsForShowDependencyLines,
        sendAnalyticsEvent,
        dispatch,
        setIssueIdsToShowDependencies,
        boardId
    ]);
    const renderToggleDependencyLinesAction = ()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            size: "small",
            color: "color.text.subtlest"
        }, formatMessage((0, $2Nvkb.default).showLinesTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $2Nvkb.default).tooltipForShowLinesToggleIssueTermRefresh : (0, $2Nvkb.default).tooltipForShowLinesToggle)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
            isChecked: isShowLinesChecked,
            onChange: handleShowLinesToggleChange,
            label: formatMessage((0, $2Nvkb.default).labelForShowLinesToggle),
            testId: "software-board.board-container.board.card-container.card.issue-links-indicator.flyout.toggle"
        })));
    };
    const flyoutOnClick = (event)=>{
        // Stop the flyout from triggering the onClick of the issue card, preventing the issue view modal from appearing
        event.stopPropagation();
    };
    const canViewInReport = props.issueId && planId && scenarioId;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.200",
        xcss: $4569487d8abf03f1$var$flyoutWrapper,
        onClick: (0, $4R6GH.fg)('issue_view_in_program_board') ? flyoutOnClick : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9kb7x.IssueLinksDetailsGroup), {
        unlinkIssueButtonTooltipText: formatMessage((0, $2Nvkb.default).removeDependency),
        title: formatMessage((0, $2Nvkb.default).title),
        onUnlinkIssue: onUnlinkIssue,
        showBlockedTime: false,
        maxIssuesToDisplay: maxIssuesToDisplay,
        exceedMaxSizeLinkOptions: {
            text: formatMessage((0, $2Nvkb.default).viewAllDependencies),
            onClick: ()=>{
                setMaxIssuesToDisplay(Infinity);
            }
        },
        ...canViewInReport && (0, $4R6GH.fg)('smart_links_for_plans') && {
            viewInReportLinkOptions: {
                text: formatMessage((0, $2Nvkb.default).viewInDependenciesTab),
                href: `/jira/plans/${planId}/scenarios/${scenarioId}/dependencies?issueFilter=${props.issueId}`
            }
        },
        leftFooterLinkOptions: !isIPBoardReadOnly ? {
            text: formatMessage((0, $2Nvkb.default).addDependency),
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                label: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $2Nvkb.default).unlinkIssuesIssueTermRefresh : (0, $2Nvkb.default).unlinkIssues),
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: ()=>{
                setIssueLinkModalEntryPointSubject({
                    issueData: {
                        issueId: String(issue.id),
                        issueKey: issue.key,
                        issueSummary: issue.summary,
                        issueType: issueType
                    },
                    modalContent: {
                        title: formatMessage((0, $2Nvkb.default).addDependencyKey),
                        showDescription: false,
                        showCreateIssueLinkButton: false,
                        showFeedbackCollector: false,
                        localIssuesOnly: true,
                        confirmLabel: formatMessage((0, $2Nvkb.default).addDependencyCta),
                        issues: issuesArray,
                        onLinkIssueRequest: onLinkIssueRequest,
                        issueLinks: issueLinkAndDirectionMap
                    }
                });
            }
        } : undefined,
        issueLinkGroups: issueLinks,
        showFeedbackCollector: false,
        ...external > 0 && {
            renderExternalLinksMessage: renderExternalLinksMessage
        },
        hideTitleWhenEmpty: true,
        canUserLinkIssue: !isIPBoardReadOnly,
        rightHeaderActions: renderToggleDependencyLinesAction()
    })));
};
var $4569487d8abf03f1$export$2e2bcd8739ae039 = $4569487d8abf03f1$var$IssueLinksDetailsGroupWrapper;
const $4569487d8abf03f1$var$externalIssueLinksStyles = (0, $8CUq3.xcss)({
    paddingBlockStart: 'space.100'
});
const $4569487d8abf03f1$var$titleStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)"
});
const $4569487d8abf03f1$var$flyoutWrapper = (0, $8CUq3.xcss)({
    minWidth: '360px',
    maxWidth: '528px'
});

});
parcelRegister("dTlW6", function(module, exports) {

$parcel$export(module.exports, "default", () => $3db77843cf29c460$export$2e2bcd8739ae039);
/* toggle.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $cBeZP = parcelRequire("cBeZP");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $7fA4P = parcelRequire("7fA4P");

var $aFYTH = parcelRequire("aFYTH");

var $VSDnB = parcelRequire("VSDnB");

var $lahQ6 = parcelRequire("lahQ6");
const $3db77843cf29c460$var$basicStyles = null;
const $3db77843cf29c460$var$borderStyles = null;
const $3db77843cf29c460$var$iconStyles = null;
const $3db77843cf29c460$var$sizeStyles = {
    regular: "_2rkopxbi _4t3ipxbi _1bsbxy5q _kfgtutpp _1mp41crf _p9c41fbe",
    large: "_2rkov47k _4t3iv47k _1bsb1jfw _kfgtpxbi _1mp47vkz _p9c4w12q"
};
const $3db77843cf29c460$var$noop = (0, $eGmKJ.default);
const $3db77843cf29c460$var$analyticsAttributes = {
    componentName: 'toggle',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $3db77843cf29c460$var$iconSizeMap = {
    regular: 'small',
    large: 'medium'
}; /**
    * __Toggle__
    *
    * A toggle is used to view or switch between enabled or disabled states.
    *
    * - [Examples](https://atlassian.design/components/toggle/examples)
    * - [Code](https://atlassian.design/components/toggle/code)
    * - [Usage](https://atlassian.design/components/toggle/usage)
    */ 
const $3db77843cf29c460$var$Toggle = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { defaultChecked: defaultChecked = false, isDisabled: isDisabled = false, onBlur: providedOnBlur = $3db77843cf29c460$var$noop, onChange: providedChange = $3db77843cf29c460$var$noop, onFocus: providedFocus = $3db77843cf29c460$var$noop, size: size = 'regular', name: name = '', value: value = '', isChecked: isChecked, analyticsContext: analyticsContext, id: id, testId: testId, label: label, descriptionId: descriptionId } = props;
    const isControlled = typeof isChecked === 'undefined';
    const [checked, setChecked] = (0, $5uXOq.useState)(defaultChecked);
    const [isKeyboardUsed, setIsKeyboardUsed] = (0, $5uXOq.useState)(true);
    const wrapperRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (id && wrapperRef.current && wrapperRef.current.parentElement) {
            /*
      	DSP-21524 Handling the click on <label> that is linked via "for" attribute.
      	By default click on the label fires absolutely same onclick event as click on the input element.
      	To differentiate keyboard click from mouse we need this additional listener.
      */ const linkedLabel = wrapperRef.current.parentElement.querySelector(`label[for="${id}"]`);
            if (linkedLabel) {
                const unbind = (0, $cBeZP.bindAll)(linkedLabel, [
                    {
                        type: 'click',
                        listener: (event)=>{
                            setIsKeyboardUsed(false);
                            if (event?.detail > 1) /*
              DSP-21524 double or triple click on label initiating the text selection for label text and adds additional step to tab order.
              So here we set the isKeyboardUsed to true, to display focus ring on next Tab press
              */ setIsKeyboardUsed(true);
                        }
                    }
                ]);
                return unbind;
            }
        }
    }, [
        id,
        wrapperRef,
        isKeyboardUsed
    ]);
    const handleBlur = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (!isKeyboardUsed) setIsKeyboardUsed(true);
            providedOnBlur(event, analyticsEvent);
        },
        action: 'blur',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleFocus = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedFocus,
        action: 'focus',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const handleChange = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event, analyticsEvent)=>{
            if (isControlled) setChecked((checked)=>!checked);
            return providedChange(event, analyticsEvent);
        },
        action: 'change',
        analyticsData: analyticsContext,
        ...$3db77843cf29c460$var$analyticsAttributes
    });
    const onLabelKeyDown = (event)=>{
        if ([
            ' ',
            'Tab',
            'Space'
        ].includes(event.key)) setIsKeyboardUsed(true);
    };
    const shouldChecked = isControlled ? checked : isChecked;
    const controlProps = {
        'data-checked': shouldChecked ? shouldChecked : undefined,
        'data-disabled': isDisabled ? isDisabled : undefined,
        'data-size': size,
        'data-testid': testId ? testId : undefined,
        // DSP-21524 Because label gets focus ring via focus-within and focus-within also triggers by mouse click we have to manually control the ring appearance.
        onKeyDown: onLabelKeyDown,
        onMouseDown: ()=>{
            setIsKeyboardUsed(false);
        }
    };
    const legacyIconSize = $3db77843cf29c460$var$iconSizeMap[size];
    const labelId = (0, $9KnKW.useId)();
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        ...controlProps,
        ref: wrapperRef,
        className: (0, $bwpsq.default)([
            "_v564kete _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1o8l _vchh18uv _kqswh2mm _1y1m1ntv _bfhk76s1 _syaz5w2r _6rthv77o _1pfhv77o _12l2v77o _ahbqv77o _85i5v77o _1q51v77o _y4tiv77o _bozgv77o _1i2uidpf _1i3tidpf _se28idpf _3tunidpf _1423idpf _1hrtidpf _1bz2idpf _rqfvidpf _1yc0glyw _onsr1snc _1vgmagmp _1av610yn _1ulhidpf _rfx31q5u _pdykkete _1cs8stnw _1rus5w2r _1kt9b3bt _1fkr1y44 _z5wt1y44 _7dwzglyw _1bki1y1w _1flt1y1w _3xv21y1w _9471g4a2 _ucab5w2r _mqf815t7 _3dj215t7 _1dl915t7 _1div5w2r _1il8kb7n _y54d5w2r _irr353wy _d0altlke _19ja13gf _8muf13gf _1k1q13gf _1plud4ly _1uo853wy _178c1y1w _16rslghj _ogf41r31 _1rtbnqa1 _5gg9t94y",
            isKeyboardUsed && "_jyzf194a _1r4mnqa1 _1t9pyh40",
            size === 'large' && !(0, $VSDnB.fg)('platform-visual-refresh-icons') && "_1n82gktf _19vpgktf",
            $3db77843cf29c460$var$sizeStyles[size]
        ]),
        children: [
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                id: labelId,
                hidden: true,
                children: label
            }) : null,
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ref: ref,
                checked: shouldChecked,
                disabled: isDisabled,
                id: id,
                name: name,
                onBlur: handleBlur,
                onChange: handleChange,
                onFocus: handleFocus,
                type: "checkbox",
                value: value,
                "data-testid": testId && `${testId}--input`,
                "aria-labelledby": label ? labelId : undefined,
                "aria-describedby": descriptionId
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: !shouldChecked,
                position: "left",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($7fA4P))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-check-icon`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lahQ6.default), {
                size: size,
                isHidden: shouldChecked,
                position: "right",
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($aFYTH))), {
                    label: "",
                    color: "currentColor",
                    LEGACY_size: legacyIconSize,
                    testId: testId && `${testId}--toggle-cross-icon`
                })
            })
        ]
    });
}));
$3db77843cf29c460$var$Toggle.displayName = 'Toggle';
var $3db77843cf29c460$export$2e2bcd8739ae039 = $3db77843cf29c460$var$Toggle;

});
parcelRegister("7fA4P", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::90a6c328ce4531920c578790d71561aa>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5475eb3f94e0b044$var$_react = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5475eb3f94e0b044$var$_checkMark = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("f22iM")));

var $5475eb3f94e0b044$var$_done = $5475eb3f94e0b044$var$_interopRequireDefault((parcelRequire("4DXCl")));
function $5475eb3f94e0b044$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "EditorDoneIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5475eb3f94e0b044$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $5475eb3f94e0b044$var$_react.default.createElement($5475eb3f94e0b044$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $5475eb3f94e0b044$var$_done.default
    }, props));
$5475eb3f94e0b044$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $5475eb3f94e0b044$var$_default = module.exports.default = $5475eb3f94e0b044$var$CheckMarkIcon;

});
parcelRegister("f22iM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4f681ccdbe722d68d6bd374c0928f0bd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $af18d40ba5b744b4$var$_react = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $af18d40ba5b744b4$var$_baseNew = $af18d40ba5b744b4$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $af18d40ba5b744b4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CheckMark".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $af18d40ba5b744b4$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $af18d40ba5b744b4$var$_react.default.createElement($af18d40ba5b744b4$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m11.06 3-6.25 7a.75.75 0 0 1-1.15-.037l-2.75-3.5 1.18-.926 2.197 2.796L9.94 2z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$af18d40ba5b744b4$var$CheckMarkIcon.displayName = 'CheckMarkIcon';
var $af18d40ba5b744b4$var$_default = module.exports.default = $af18d40ba5b744b4$var$CheckMarkIcon;

});

parcelRegister("4DXCl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $36190cbd288fec69$var$_react = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $36190cbd288fec69$var$_checkMark = $36190cbd288fec69$var$_interopRequireDefault((parcelRequire("bjo8S")));
function $36190cbd288fec69$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $36190cbd288fec69$var$EditorDoneIcon = (props)=>/*#__PURE__*/ $36190cbd288fec69$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M7.356 10.942a.497.497 0 0 0-.713 0l-.7.701a.5.5 0 0 0-.003.71l3.706 3.707a.5.5 0 0 0 .705.003l7.712-7.712a.493.493 0 0 0-.006-.708l-.7-.7a.504.504 0 0 0-.714 0l-6.286 6.286a.506.506 0 0 1-.713 0z"/></svg>`
    }, props, {
        newIcon: $36190cbd288fec69$var$_checkMark.default
    }));
$36190cbd288fec69$var$EditorDoneIcon.displayName = 'EditorDoneIcon';
var $36190cbd288fec69$var$_default = module.exports.default = $36190cbd288fec69$var$EditorDoneIcon;

});


parcelRegister("lahQ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $ca1cdaa1eb34599d$export$2e2bcd8739ae039);
/* icon-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $3JT92 = parcelRequire("3JT92");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
const $ca1cdaa1eb34599d$var$styles = {
    iconContainer: "_v5641hrg _1e0c116y _4cvr1h6o _1bah1h6o _kqswstnw _152tv77o",
    iconContainerRegular: "_1bsb7vkz _4t3i7vkz",
    iconContainerLarge: "_1bsbgktf _4t3igktf",
    hidden: "_tzy4idpf",
    left: "_1e021l7b",
    right: "_rjxp1l7b"
};
/**
 * __Icon container__
 *
 * Positions a toggle's check and close icons.
 */ const $ca1cdaa1eb34599d$var$IconContainer = ({ children: children, size: size, isHidden: isHidden, position: position })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "span",
        xcss: (0, $3JT92.cx)($ca1cdaa1eb34599d$var$styles.iconContainer, isHidden && (0, $VSDnB.fg)('platform-visual-refresh-icons') && $ca1cdaa1eb34599d$var$styles.hidden, size === 'regular' && $ca1cdaa1eb34599d$var$styles.iconContainerRegular, size === 'large' && $ca1cdaa1eb34599d$var$styles.iconContainerLarge, position === 'left' && $ca1cdaa1eb34599d$var$styles.left, position === 'right' && $ca1cdaa1eb34599d$var$styles.right),
        children: children
    });
};
var $ca1cdaa1eb34599d$export$2e2bcd8739ae039 = $ca1cdaa1eb34599d$var$IconContainer;

});


parcelRegister("HeOPt", function(module, exports) {

$parcel$export(module.exports, "useIssueLinkedModalEntrypointActions", () => $ddf76c53d76224b8$export$c03a98393d952aa6);
$parcel$export(module.exports, "useIssueLinkedModalEntrypointStore", () => $ddf76c53d76224b8$export$84102b9a2118d337);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $8ueAK = parcelRequire("8ueAK");

const $ddf76c53d76224b8$export$d4c72bab9d6cc13a = {
    issueData: undefined,
    modalContent: undefined
};
const $ddf76c53d76224b8$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $ddf76c53d76224b8$export$d4c72bab9d6cc13a,
    actions: $8ueAK.actions,
    name: 'issue-links-modal-entrypoint-store'
});
const $ddf76c53d76224b8$export$5f9d819cda534167 = (0, $gg7kZ.createContainer)($ddf76c53d76224b8$export$6f57813fe9f31bf9, {
    onInit: ()=>({ setState: setState })=>{
            setState($ddf76c53d76224b8$export$d4c72bab9d6cc13a);
        }
});
const $ddf76c53d76224b8$export$c03a98393d952aa6 = (0, $3sQ5x.createActionsHook)($ddf76c53d76224b8$export$6f57813fe9f31bf9);
const $ddf76c53d76224b8$export$84102b9a2118d337 = (0, $3sQ5x.createHook)($ddf76c53d76224b8$export$6f57813fe9f31bf9);

});
parcelRegister("8ueAK", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5d5b9c6990e0d0e0$export$e324594224ef24da);
const $5d5b9c6990e0d0e0$export$ec7c0f6064933276 = ({ issueData: issueData, modalContent: modalContent, trackOriginSource: trackOriginSource })=>({ setState: setState })=>{
        setState({
            issueData: issueData,
            modalContent: modalContent,
            trackOriginSource: trackOriginSource
        });
    };
const $5d5b9c6990e0d0e0$export$e324594224ef24da = {
    setIssueLinkModalEntryPointSubject: $5d5b9c6990e0d0e0$export$ec7c0f6064933276
};

});


parcelRegister("9kb7x", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsGroup", () => $0a0bb7c7aa37aeeb$export$3ce52db778d29451);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $e4yMr = parcelRequire("e4yMr");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $eGcSe = parcelRequire("eGcSe");

var $gwIPs = parcelRequire("gwIPs");

var $kAFLN = parcelRequire("kAFLN");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");


var $a0Rqo = parcelRequire("a0Rqo");

var $QVt8g = parcelRequire("QVt8g");
const $0a0bb7c7aa37aeeb$export$3ce52db778d29451 = ({ issueLinkGroups: issueLinkGroups, title: title, maxIssuesToDisplay: maxIssuesToDisplay = 50, exceedMaxSizeLinkOptions: exceedMaxSizeLinkOptions, leftFooterLinkOptions: leftFooterLinkOptions, rightFooterLinkOptions: rightFooterLinkOptions, viewInReportLinkOptions: viewInReportLinkOptions, showFeedbackCollector: showFeedbackCollector = true, feedbackCollectorPrefix: feedbackCollectorPrefix, renderExternalLinksMessage: renderExternalLinksMessage, hideTitleWhenEmpty: hideTitleWhenEmpty = false, issueTypeName: issueTypeName, canUserLinkIssue: canUserLinkIssue, rightHeaderActions: rightHeaderActions, ...rest })=>{
    const totalIssuesCount = (0, $5uXOq.useMemo)(()=>issueLinkGroups ? Object.values(issueLinkGroups).reduce((count, value)=>count + value.length, 0) : 0, [
        issueLinkGroups
    ]);
    const shouldHideTitleBlock = totalIssuesCount === 0 && hideTitleWhenEmpty;
    const renderContent = ()=>{
        let count = 0;
        if (!issueLinkGroups) return null;
        return Object.entries(issueLinkGroups).map(([key, issueLinkGroup], index)=>{
            if (count < maxIssuesToDisplay) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
                key: index
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a0bb7c7aa37aeeb$var$GroupTitle, null, key), issueLinkGroup.map((issue)=>{
                if (count < maxIssuesToDisplay) {
                    count++;
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $QVt8g.IssueLinksDetailsContent), {
                        ...rest,
                        key: issue.key,
                        issueLink: issue,
                        canUserLinkIssue: canUserLinkIssue
                    });
                }
                return null;
            }));
            return null;
        });
    };
    const screenAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>{
        if (!issueLinkGroups) return {};
        const issueLinkGroupsKeys = Object.keys(issueLinkGroups);
        // Get number of issues for each issue status
        const issuesByStatus = {};
        issueLinkGroupsKeys.forEach((issueLinkType)=>{
            issueLinkGroups[issueLinkType].forEach((issue)=>{
                if (issue.statusName) {
                    const statusAttributeName = `status_${$0a0bb7c7aa37aeeb$var$safeStatusName(issue.statusName)}_issues_count`;
                    issuesByStatus[statusAttributeName] = issuesByStatus[statusAttributeName] + 1 || 1;
                }
            });
        });
        return {
            numberOfRelationships: issueLinkGroupsKeys.length,
            relationships: issueLinkGroupsKeys.map((0, $eGcSe.safeLinkTypeName)),
            totalIssuesCount: totalIssuesCount,
            issueTypeName: (0, $a0Rqo.getAnalyticsIssueType)(issueTypeName),
            ...issuesByStatus
        };
    }, [
        issueLinkGroups,
        totalIssuesCount,
        issueTypeName
    ]);
    const feedbackCollectorLocation = feedbackCollectorPrefix ? `${feedbackCollectorPrefix}-issue-links-popup` : 'issue-links-popup';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        sourceName: "IssueLinksDetails"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "issue-links-details.ui.box"
    }, !shouldHideTitleBlock && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rightHeaderActions) ? $0a0bb7c7aa37aeeb$var$headingStyles : $0a0bb7c7aa37aeeb$var$headingStyleForHeaderWithRightAction,
        spread: "space-between",
        alignInline: "start"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "h2"
    }, title), showFeedbackCollector && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kAFLN.LinkIssueFeedbackCollector), {
        feedbackCollectorLocation: feedbackCollectorLocation,
        appearance: "icon"
    }), rightHeaderActions), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $0a0bb7c7aa37aeeb$var$bodyContainerStyles,
            shouldHideTitleBlock && $0a0bb7c7aa37aeeb$var$bodyContainerHeaderHiddenStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, renderContent()), renderExternalLinksMessage && (!exceedMaxSizeLinkOptions || exceedMaxSizeLinkOptions && totalIssuesCount <= maxIssuesToDisplay) && renderExternalLinksMessage(), exceedMaxSizeLinkOptions && totalIssuesCount >= maxIssuesToDisplay && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.100",
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: (0, $bf53f283f093ab9b$export$d2a0b679ff0ef23d),
        onClick: exceedMaxSizeLinkOptions.onClick,
        appearance: "link",
        spacing: "none"
    }, exceedMaxSizeLinkOptions.text)), viewInReportLinkOptions && (!exceedMaxSizeLinkOptions || exceedMaxSizeLinkOptions && totalIssuesCount <= maxIssuesToDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.100",
        paddingBlockStart: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        testId: (0, $bf53f283f093ab9b$export$78e3d79ce6e9d391),
        href: viewInReportLinkOptions.href
    }, viewInReportLinkOptions.text))), (leftFooterLinkOptions || rightFooterLinkOptions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: [
            $0a0bb7c7aa37aeeb$var$footerStyles,
            shouldHideTitleBlock && !renderExternalLinksMessage && $0a0bb7c7aa37aeeb$var$footerHeaderHiddenStyles
        ],
        spread: leftFooterLinkOptions ? 'space-between' : undefined,
        alignInline: leftFooterLinkOptions ? 'start' : 'end'
    }, leftFooterLinkOptions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $0a0bb7c7aa37aeeb$var$leftFooterButtonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: (0, $bf53f283f093ab9b$export$1a190d368bdba126),
        ref: leftFooterLinkOptions?.ref,
        iconBefore: leftFooterLinkOptions.icon,
        onClick: leftFooterLinkOptions?.onClick,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $0a0bb7c7aa37aeeb$var$leftFooterButtonTextStyles
    }, leftFooterLinkOptions?.text))) : null, rightFooterLinkOptions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: (0, $bf53f283f093ab9b$export$75bada35ed68fe7c),
        onClick: rightFooterLinkOptions.onClick,
        iconBefore: rightFooterLinkOptions.icon,
        appearance: "subtle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $0a0bb7c7aa37aeeb$var$rightFooterButtonStyles
    }, rightFooterLinkOptions.text))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: screenAnalyticsAttributes
    })));
};
const $0a0bb7c7aa37aeeb$var$safeStatusName = (statusName)=>{
    const status = [
        'to do',
        'in progress',
        'done'
    ];
    return status.includes(statusName.toLowerCase()) ? statusName.toLowerCase().replaceAll(' ', '_') : 'custom';
};
const $0a0bb7c7aa37aeeb$var$bodyContainerStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error - TS2322 - Type 'number' is not assignable to type 'AutoComplete<"100%" | "size.100" | "size.200" | "size.300" | "size.400" | "size.500" | "size.600" | "size.1000"> | undefined'.
    maxHeight: 310,
    marginTop: 'space.100',
    overflowY: 'auto',
    overflowX: 'hidden'
});
const $0a0bb7c7aa37aeeb$var$bodyContainerHeaderHiddenStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.0'
});
const $0a0bb7c7aa37aeeb$var$footerStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 50}px`
});
const $0a0bb7c7aa37aeeb$var$footerHeaderHiddenStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.0'
});
const $0a0bb7c7aa37aeeb$var$leftFooterButtonStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.075'
});
const $0a0bb7c7aa37aeeb$var$leftFooterButtonTextStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.100'
});
const $0a0bb7c7aa37aeeb$var$rightFooterButtonStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a0bb7c7aa37aeeb$var$GroupTitle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz131l",
            __cmplp.className
        ])
    });
});
const $0a0bb7c7aa37aeeb$var$headingStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 64}px`,
    marginRight: 'space.100'
});
const $0a0bb7c7aa37aeeb$var$headingStyleForHeaderWithRightAction = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${(0, $gwIPs.gridSize) * 64}px`
});

});
parcelRegister("eGcSe", function(module, exports) {

$parcel$export(module.exports, "safeLinkTypeName", () => $91e1e3fc148721cd$export$3562d6fc9209c3a9);

var $4R6GH = parcelRequire("4R6GH");
const $91e1e3fc148721cd$var$LINK_IS_BLOCKED_BY = 'is blocked by';
const $91e1e3fc148721cd$var$NEW_LINK_BLOCKS = 'blocks';
const $91e1e3fc148721cd$var$LINK_IS_DUPLICATED_BY = 'is duplicated by';
const $91e1e3fc148721cd$var$LINK_BLOCKS = 'BLOCKS';
const $91e1e3fc148721cd$var$LINK_IS_CLONED_BY = 'is cloned by';
const $91e1e3fc148721cd$var$LINK_CLONES = 'clones';
const $91e1e3fc148721cd$var$LINK_IS_CAUSED_BY = 'is caused by';
const $91e1e3fc148721cd$var$LINK_CAUSES = 'causes';
const $91e1e3fc148721cd$var$LINK_RELATES_TO = 'relates to';
const $91e1e3fc148721cd$var$LINK_DUPLICATES = 'duplicates';
const $91e1e3fc148721cd$var$LINK_IMPLEMENTS = 'implements';
const $91e1e3fc148721cd$var$LINK_IMPLEMENTED_BY = 'is implemented by';
// use LINK_CUSTOM for all custom type name
const $91e1e3fc148721cd$var$LINK_CUSTOM = 'custom';
const $91e1e3fc148721cd$var$LINK_ISSUE_TYPE = [
    $91e1e3fc148721cd$var$LINK_IS_BLOCKED_BY,
    $91e1e3fc148721cd$var$LINK_IS_DUPLICATED_BY,
    $91e1e3fc148721cd$var$LINK_BLOCKS,
    $91e1e3fc148721cd$var$LINK_IS_CLONED_BY,
    $91e1e3fc148721cd$var$LINK_CLONES,
    $91e1e3fc148721cd$var$LINK_IS_CAUSED_BY,
    $91e1e3fc148721cd$var$LINK_CAUSES,
    $91e1e3fc148721cd$var$LINK_RELATES_TO,
    $91e1e3fc148721cd$var$LINK_DUPLICATES
];
const $91e1e3fc148721cd$var$NEW_LINK_ISSUE_TYPE = [
    $91e1e3fc148721cd$var$LINK_IS_BLOCKED_BY,
    $91e1e3fc148721cd$var$NEW_LINK_BLOCKS,
    $91e1e3fc148721cd$var$LINK_IS_DUPLICATED_BY,
    $91e1e3fc148721cd$var$LINK_DUPLICATES,
    $91e1e3fc148721cd$var$LINK_IS_CLONED_BY,
    $91e1e3fc148721cd$var$LINK_CLONES,
    $91e1e3fc148721cd$var$LINK_IS_CAUSED_BY,
    $91e1e3fc148721cd$var$LINK_CAUSES,
    $91e1e3fc148721cd$var$LINK_RELATES_TO,
    $91e1e3fc148721cd$var$LINK_IMPLEMENTED_BY,
    $91e1e3fc148721cd$var$LINK_IMPLEMENTS
];
const $91e1e3fc148721cd$export$3562d6fc9209c3a9 = (value)=>{
    if ((0, $4R6GH.fg)('jira_issue_links_analytics')) // Using type coercion to handle type mismatch between string and NewLinkIssueType
    return $91e1e3fc148721cd$var$NEW_LINK_ISSUE_TYPE.some((linkType)=>linkType === value?.toLowerCase()) ? value : $91e1e3fc148721cd$var$LINK_CUSTOM;
    // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'LinkIssueType'.
    return $91e1e3fc148721cd$var$LINK_ISSUE_TYPE.includes(value) ? value : $91e1e3fc148721cd$var$LINK_CUSTOM;
};

});

parcelRegister("kAFLN", function(module, exports) {

$parcel$export(module.exports, "LinkIssueFeedbackCollector", () => $0a7075a3dc3139de$export$feb08f9ac25c1d45);

var $5uXOq = parcelRequire("5uXOq");

var $7iULw = parcelRequire("7iULw");

var $coTzA = parcelRequire("coTzA");
const $0a7075a3dc3139de$export$feb08f9ac25c1d45 = ({ feedbackCollectorLocation: feedbackCollectorLocation, appearance: appearance })=>{
    const additionalFields = [
        {
            id: (0, $7iULw.EntryKeys).FEEDBACK_COLLECTOR_LOCATION,
            value: feedbackCollectorLocation
        }
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coTzA.FeedbackCollectorButton), {
        entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_SOFTWARE_PROJECT),
        feedbackGroupId: feedbackCollectorLocation,
        additionalFields: additionalFields,
        buttonAppearance: appearance
    });
};

});
parcelRegister("coTzA", function(module, exports) {

$parcel$export(module.exports, "FeedbackCollectorButton", () => $85f5e51eda76fbac$export$b39479f42d974760);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $aEHvW = parcelRequire("aEHvW");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $koeKL = parcelRequire("koeKL");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $4uMrp = parcelRequire("4uMrp");
const $85f5e51eda76fbac$var$TooltipWrapper = ({ children: children, appearance: appearance, customLabel: customLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (appearance === 'icon') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: customLabel || formatMessage((0, $4uMrp.messages).leaveFeedback),
        position: "top"
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $85f5e51eda76fbac$export$b39479f42d974760 = ({ buttonAppearance: buttonAppearance = 'normal', testId: testId, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($aEHvW))), feedbackButtonCustomLabel: feedbackButtonCustomLabel, ...feedbackCollectorProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const buttonRef = (0, $5uXOq.useRef)(null);
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        // Check if feedbackContext already contains the cloud ID entry
        const hasCloudId = feedbackCollectorProps?.feedbackContext?.some((entry)=>entry.id === (0, $7iULw.EntryKeys).CLOUD_ID);
        // If not, add cloud id to feedback context
        const updatedFeedbackContext = hasCloudId ? feedbackCollectorProps.feedbackContext : [
            ...feedbackCollectorProps.feedbackContext || [],
            {
                id: (0, $7iULw.EntryKeys).CLOUD_ID,
                value: cloudId
            }
        ];
        openFeedbackCollector({
            ...feedbackCollectorProps,
            feedbackContext: updatedFeedbackContext,
            triggerRef: buttonRef
        });
    }, [
        cloudId,
        feedbackCollectorProps,
        openFeedbackCollector
    ]);
    const displayAsLink = buttonAppearance === 'link';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$TooltipWrapper, {
        appearance: buttonAppearance,
        customLabel: feedbackButtonCustomLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($85f5e51eda76fbac$var$StyledButton, {
        testId: testId,
        ref: buttonRef,
        appearance: displayAsLink ? 'link' : 'subtle',
        isHighlight: buttonAppearance === 'highlight',
        spacing: displayAsLink ? 'none' : 'default',
        onClick: onOpen,
        iconBefore: displayAsLink ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
            color: buttonAppearance === 'highlight' ? "var(--ds-text-discovery, #5E4DB2)" : "var(--ds-text, #172B4D)",
            label: ""
        }),
        "aria-label": // Only add aria-label if this is an icon button
        buttonAppearance === 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback)) || '',
        ...(0, $4R6GH.fg)('jfp_a11y_autodev_feedback_collector_aria_popup') ? {
            'aria-haspopup': 'dialog'
        } : {}
    }, buttonAppearance !== 'icon' && (feedbackButtonCustomLabel || formatMessage((0, $4uMrp.messages).leaveFeedback))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $85f5e51eda76fbac$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isHighlight && "_1w901u28 _16hgp7j4 _1fh11u28 _u1mb1jkz _r7smdh45 _1l5a1gfe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aEHvW", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c129a0bf5d2aeea221ba2044e3fd85fd>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7c1f64cf4f9c421f$var$_react = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7c1f64cf4f9c421f$var$_feedback = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("5dqGX")));

var $7c1f64cf4f9c421f$var$_feedback2 = $7c1f64cf4f9c421f$var$_interopRequireDefault((parcelRequire("3g1Fk")));
function $7c1f64cf4f9c421f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for FeedbackIcon.
 * This component is FeedbackIcon, with `UNSAFE_fallbackIcon` set to "FeedbackIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7c1f64cf4f9c421f$var$FeedbackIcon = (props)=>/*#__PURE__*/ $7c1f64cf4f9c421f$var$_react.default.createElement($7c1f64cf4f9c421f$var$_feedback.default, Object.assign({
        LEGACY_fallbackIcon: $7c1f64cf4f9c421f$var$_feedback2.default
    }, props));
$7c1f64cf4f9c421f$var$FeedbackIcon.Name = 'FeedbackIconMigration';
var $7c1f64cf4f9c421f$var$_default = module.exports.default = $7c1f64cf4f9c421f$var$FeedbackIcon;

});
parcelRegister("5dqGX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f238518c984ab5d0530bd2cff7eccbeb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3cc2df171aca9493$var$_react = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3cc2df171aca9493$var$_baseNew = $3cc2df171aca9493$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3cc2df171aca9493$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Feedback".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Known uses: customer feedback.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3cc2df171aca9493$var$FeedbackIcon = (props)=>/*#__PURE__*/ $3cc2df171aca9493$var$_react.default.createElement($3cc2df171aca9493$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H6.221l-4.064 2.63A.75.75 0 0 1 1 15V9.5h1.5v4.121l3.093-2A.75.75 0 0 1 6 11.5h7a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5H3a.5.5 0 0 0-.5.5v2.75a.5.5 0 0 0 .5.5h5.44L7.22 5.03l1.06-1.06 2.5 2.5a.75.75 0 0 1 0 1.06l-2.5 2.5-1.06-1.06 1.22-1.22H3a2 2 0 0 1-2-2z" clip-rule="evenodd"/>`
    }, props));
$3cc2df171aca9493$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $3cc2df171aca9493$var$_default = module.exports.default = $3cc2df171aca9493$var$FeedbackIcon;

});

parcelRegister("3g1Fk", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25f4287f17f73dc4$var$_react = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $25f4287f17f73dc4$var$_feedback = $25f4287f17f73dc4$var$_interopRequireDefault((parcelRequire("5dqGX")));
function $25f4287f17f73dc4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $25f4287f17f73dc4$var$FeedbackIcon = (props)=>/*#__PURE__*/ $25f4287f17f73dc4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="m10.88 5.48-8.43 6.83c-.4.32-.58.96-.41 1.42l.1.27c.17.46.73.83 1.23.82l1.13-.02 6.06-.1 3.65-.06c.51-.01.79-.38.62-.86l-2.92-8.03c-.1-.29-.32-.44-.57-.44a.73.73 0 0 0-.46.18m-5.9 10.46 1.75 4.82a1 1 0 1 0 1.88-.68l-1.54-4.23zm13.71-9.11-2.82 1.03a1 1 0 1 0 .68 1.88l2.82-1.03a1 1 0 1 0-.68-1.88m-1.79 3.85a1 1 0 0 0-.64.77 1 1 0 0 0 .81 1.16l2.96.52a1 1 0 0 0 1.12-1.3l-.02-.05a1 1 0 0 0-.76-.62l-2.95-.52a.97.97 0 0 0-.51.05m-.56-7.65-1.93 2.3a1 1 0 0 0 1.53 1.29l1.93-2.3a1 1 0 0 0-.76-1.64 1 1 0 0 0-.77.36"/></svg>`
    }, props, {
        newIcon: $25f4287f17f73dc4$var$_feedback.default
    }));
$25f4287f17f73dc4$var$FeedbackIcon.displayName = 'FeedbackIcon';
var $25f4287f17f73dc4$var$_default = module.exports.default = $25f4287f17f73dc4$var$FeedbackIcon;

});


parcelRegister("4uMrp", function(module, exports) {

$parcel$export(module.exports, "messages", () => $0c42512912e196d1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $0c42512912e196d1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    leaveFeedback: {
        "id": "platform.feedback.feedback-collector.button.leave-feedback",
        "defaultMessage": "Give feedback"
    }
});

});



const $bf53f283f093ab9b$export$8ec69a8a56d70607 = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.linked-issue-card-content';
const $bf53f283f093ab9b$export$d2a0b679ff0ef23d = '@atlassian/jira-issue-links-details.ui.linked-issue-card-group.exceed-max-size-button';
const $bf53f283f093ab9b$export$75bada35ed68fe7c = '@atlassian/jira-issue-links-details.ui.linked-issue-card-group.right-footer-button';
const $bf53f283f093ab9b$export$1a190d368bdba126 = '@atlassian/jira-issue-links-details.ui.linked-issue-card-group.left-footer-button';
const $bf53f283f093ab9b$export$78e3d79ce6e9d391 = '@atlassian/jira-issue-links-details.ui.linked-issue-card-group.view-in-report-button';
const $bf53f283f093ab9b$export$3b6b525e30ff6d4b = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.unlink-button';
const $bf53f283f093ab9b$export$f9035ef9c11822fa = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.issue-link';
const $bf53f283f093ab9b$export$e7ecdd781ae061df = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.issue-due-date-lozenge';
const $bf53f283f093ab9b$export$beb0fe4c494e9224 = '@atlassian/jira-issue-links-details.ui.linked-issue-card-content.issue-status-lozenge';

parcelRegister("a0Rqo", function(module, exports) {

$parcel$export(module.exports, "getAnalyticsIssueType", () => $7bcb330a0bb1411d$export$385bf01e57223a7c);
const $7bcb330a0bb1411d$var$allowedIssueTypeValues = [
    'bug',
    'story',
    'task',
    'subtask',
    'epic'
];
const $7bcb330a0bb1411d$export$385bf01e57223a7c = (issueType)=>{
    const issueTypeLabel = issueType?.toLowerCase();
    return issueTypeLabel && $7bcb330a0bb1411d$var$allowedIssueTypeValues.includes(issueTypeLabel) ? issueTypeLabel : 'custom';
};

});

parcelRegister("QVt8g", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsContent", () => $5e621e5008c354c5$export$84ac7728cacc4b04);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $5k1dC = parcelRequire("5k1dC");

var $3u0c5 = parcelRequire("3u0c5");

var $jhmo0 = parcelRequire("jhmo0");
var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $9mUbn = parcelRequire("9mUbn");

var $dZHIT = parcelRequire("dZHIT");

var $itzcE = parcelRequire("itzcE");

const $5e621e5008c354c5$var$unlinkButtonSelector = 'issue-links-details-content-unlink-button';
const $5e621e5008c354c5$export$84ac7728cacc4b04 = ({ issueLink: issueLink, onIssueClicked: onIssueClicked, onUnlinkIssue: onUnlinkIssue, unlinkIssueButtonTooltipText: unlinkIssueButtonTooltipText, showBlockedTime: showBlockedTime, canUserLinkIssue: canUserLinkIssue })=>{
    const onIssueClickedCallback = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        onIssueClicked?.(analyticsEvent);
    }, [
        onIssueClicked
    ]);
    const [isIssueFocused, setIsIssueFocused] = (0, $5uXOq.useState)(false);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e621e5008c354c5$var$IssueDetailsRow, {
        key: issueLink.key
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.050",
        xcss: $5e621e5008c354c5$var$componentStyles,
        testId: (0, $bf53f283f093ab9b$export$8ec69a8a56d70607)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dZHIT.IssueType), {
        issueTypeName: issueLink.issueTypeName,
        issueTypeIconUrl: issueLink.issueTypeIconUrl,
        isDraggable: false,
        isActionVisible: false,
        restrictedReorderingMessage: issueLink.issueTypeName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5e621e5008c354c5$var$issueContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        xcss: $5e621e5008c354c5$var$anchorStyles,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        href: `${window.location.protocol}//${window.location.hostname}/browse/${issueLink.key}`,
        target: "_blank",
        testId: (0, $bf53f283f093ab9b$export$f9035ef9c11822fa),
        onClick: onIssueClickedCallback,
        onFocus: ()=>setIsIssueFocused(true),
        onBlur: ()=>setIsIssueFocused(false),
        id: `${issueLink.key}-link`
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueLink.key
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e621e5008c354c5$var$IssueKey, tooltipProps, issueLink.key)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueLink.text
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e621e5008c354c5$var$IssueText, tooltipProps, issueLink.text))))), issueLink.dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: (0, $bf53f283f093ab9b$export$e7ecdd781ae061df),
        justifyContent: "end",
        gap: issueLink.offtrackLabel ? 'space.100' : undefined,
        xcss: $5e621e5008c354c5$var$dueDateStyles,
        alignItems: issueLink.offtrackLabel ? 'center' : undefined
    }, issueLink.offtrackLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.danger"
    }, " ", issueLink.offtrackLabel, " "), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzcE.CardDueDate), {
        dueDate: issueLink.dueDate
    })) : null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: (0, $bf53f283f093ab9b$export$beb0fe4c494e9224),
        justifyContent: "end",
        gap: issueLink.offtrackLabel ? 'space.100' : undefined,
        alignItems: issueLink.offtrackLabel ? 'center' : undefined,
        xcss: $5e621e5008c354c5$var$lozengeWrapperStyles
    }, !issueLink.dueDate && issueLink.offtrackLabel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "color.text.danger"
    }, " ", issueLink.offtrackLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: issueLink.statusName
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: (0, $9mUbn.toAppearance)(issueLink.statusCategoryId)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", tooltipProps, issueLink.statusName)))), showBlockedTime && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5e621e5008c354c5$var$BlockedTimeText, null, issueLink.blockedTime), canUserLinkIssue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $5e621e5008c354c5$var$unlinkButtonContainerStyles,
            isIssueFocused && $5e621e5008c354c5$var$unlinkButtonContainerForceFocusStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: unlinkIssueButtonTooltipText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        "data-styled-selector": $5e621e5008c354c5$var$unlinkButtonSelector,
        testId: (0, $bf53f283f093ab9b$export$3b6b525e30ff6d4b),
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($5k1dC))),
        label: unlinkIssueButtonTooltipText,
        onClick: (event)=>onUnlinkIssue(issueLink, event),
        appearance: "subtle",
        spacing: "compact",
        id: `${issueLink.key}-btn`,
        "aria-labelledby": `${issueLink.key}-link ${issueLink.key}-btn`
    })))));
};
const $5e621e5008c354c5$var$dueDateStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
const $5e621e5008c354c5$var$lozengeWrapperStyles = (0, $8CUq3.xcss)({
    flexShrink: 0,
    flexGrow: 1
});
const $5e621e5008c354c5$var$componentStyles = (0, $8CUq3.xcss)({
    color: 'color.text',
    height: 'size.300',
    paddingRight: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5e621e5008c354c5$var$BlockedTimeText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _19pkidpf _1bsbymf6 _1o9zidpf",
            __cmplp.className
        ])
    });
});
const $5e621e5008c354c5$var$issueContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    minWidth: '0%'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $5e621e5008c354c5$var$IssueText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _syaz1fxt _k48pi7a9 _1bto1l2s _o5721q9c _y3gn1e5h _19pkidpf",
            __cmplp.className
        ])
    });
});
const $5e621e5008c354c5$var$IssueKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _4bfu18uv _1hmsglyw _ajmmnqa1 _1reo15vq _18m915vq _k48p1wq8 _o5721q9c _1bsbt9kd _1o9zidpf _1bto1l2s _y3gn1e5h _1eim1xrj _syaz14q2 _ca0qv77o",
            __cmplp.className
        ])
    });
});
const $5e621e5008c354c5$var$unlinkButtonContainerStyles = (0, $8CUq3.xcss)({
    button: {
        opacity: 0,
        ':focus': {
            opacity: 1
        }
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values, @typescript-eslint/consistent-type-assertions, @atlaskit/design-system/consistent-css-prop-usage
const $5e621e5008c354c5$var$unlinkButtonContainerForceFocusStyles = (0, $8CUq3.xcss)({
    button: {
        opacity: 1
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5e621e5008c354c5$var$IssueDetailsRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_dx7nkb7n",
            __cmplp.className
        ])
    });
});
const $5e621e5008c354c5$var$anchorStyles = (0, $8CUq3.xcss)({
    textDecoration: 'none',
    ':hover': {
        textDecoration: 'underline'
    }
});

});
parcelRegister("5k1dC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f974263d6792e563f31a788c1da2025e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3dffc3febc1a6df3$var$_react = $3dffc3febc1a6df3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3dffc3febc1a6df3$var$_linkBroken = $3dffc3febc1a6df3$var$_interopRequireDefault((parcelRequire("90mMF")));

var $3dffc3febc1a6df3$var$_unlink = $3dffc3febc1a6df3$var$_interopRequireDefault((parcelRequire("fKe1H")));
function $3dffc3febc1a6df3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkBrokenIcon.
 * This component is LinkBrokenIcon, with `UNSAFE_fallbackIcon` set to "UnlinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3dffc3febc1a6df3$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $3dffc3febc1a6df3$var$_react.default.createElement($3dffc3febc1a6df3$var$_linkBroken.default, Object.assign({
        LEGACY_fallbackIcon: $3dffc3febc1a6df3$var$_unlink.default
    }, props));
$3dffc3febc1a6df3$var$LinkBrokenIcon.Name = 'LinkBrokenIconMigration';
var $3dffc3febc1a6df3$var$_default = module.exports.default = $3dffc3febc1a6df3$var$LinkBrokenIcon;

});
parcelRegister("90mMF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d32cfb464fc797f765cf705a7186f08e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $68e5c989bea2984f$var$_react = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $68e5c989bea2984f$var$_baseNew = $68e5c989bea2984f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $68e5c989bea2984f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LinkBroken".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for removing a link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $68e5c989bea2984f$var$LinkBrokenIcon = (props)=>/*#__PURE__*/ $68e5c989bea2984f$var$_react.default.createElement($68e5c989bea2984f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M6 1v3H4.5V1zm2.22 1.22a3.932 3.932 0 1 1 5.56 5.56l-.75.75-1.06-1.06.75-.75a2.432 2.432 0 0 0-3.44-3.44l-.75.75-1.06-1.06zM1 4.5h3V6H1zm1.22 3.72.75-.75 1.06 1.06-.75.75a2.432 2.432 0 0 0 3.44 3.44l.75-.75 1.06 1.06-.75.75a3.932 3.932 0 1 1-5.56-5.56M15 11.5h-3V10h3zM10 15v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$68e5c989bea2984f$var$LinkBrokenIcon.displayName = 'LinkBrokenIcon';
var $68e5c989bea2984f$var$_default = module.exports.default = $68e5c989bea2984f$var$LinkBrokenIcon;

});

parcelRegister("fKe1H", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b766083acbc37908$var$_react = $b766083acbc37908$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $b766083acbc37908$var$_linkBroken = $b766083acbc37908$var$_interopRequireDefault((parcelRequire("90mMF")));
function $b766083acbc37908$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $b766083acbc37908$var$UnlinkIcon = (props)=>/*#__PURE__*/ $b766083acbc37908$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.72 14.43a.97.97 0 0 0-1.37 0l-2.09 2.06a1.93 1.93 0 0 1-1.37.57c-.59 0-1.13-.26-1.52-.74-.63-.78-.5-1.93.2-2.64l1.32-1.32.69-.69a.97.97 0 0 0 0-1.38.97.97 0 0 0-1.37 0l-2.07 2.07a3.89 3.89 0 0 0 0 5.5l.01.01A3.87 3.87 0 0 0 8.89 19a3.87 3.87 0 0 0 2.75-1.14l2.08-2.08a.95.95 0 0 0 0-1.34m-3.44-4.87a.97.97 0 0 0 1.37 0l2.09-2.06c.37-.37.85-.57 1.37-.57.59 0 1.14.26 1.53.74.63.78.51 1.93-.2 2.64l-1.32 1.32-.69.69a.97.97 0 0 0 0 1.38c.38.38 1 .38 1.38 0l2.07-2.07a3.89 3.89 0 0 0 0-5.5l-.01-.01A3.87 3.87 0 0 0 15.11 5a3.87 3.87 0 0 0-2.75 1.14l-2.08 2.09a.95.95 0 0 0 0 1.35M8.92 4.62l.4.97a1 1 0 1 1-1.85.77l-.4-.97a1 1 0 1 1 1.85-.76M5.38 7.08l.97.4a1 1 0 0 1-.77 1.85l-.97-.4a1 1 0 0 1 .77-1.85m9.94 10.41a1 1 0 0 0-.54 1.31l.4.97a1 1 0 1 0 1.84-.77l-.4-.97a1 1 0 0 0-1.31-.54m2.18-2.17a1 1 0 0 0 .54 1.31l.97.4a1 1 0 0 0 .77-1.85l-.97-.4a1 1 0 0 0-1.31.54"/></svg>`
    }, props, {
        newIcon: $b766083acbc37908$var$_linkBroken.default
    }));
$b766083acbc37908$var$UnlinkIcon.displayName = 'UnlinkIcon';
var $b766083acbc37908$var$_default = module.exports.default = $b766083acbc37908$var$UnlinkIcon;

});


parcelRegister("9mUbn", function(module, exports) {

$parcel$export(module.exports, "toAppearance", () => $9dc895705c6c17d4$export$cbc76b787f60c037);

var $gULOk = parcelRequire("gULOk");
const $9dc895705c6c17d4$var$appearanceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
const $9dc895705c6c17d4$export$cbc76b787f60c037 = (categoryId)=>categoryId ? $9dc895705c6c17d4$var$appearanceMap[(0, $gULOk.statusCategoryForId)(categoryId)] : $9dc895705c6c17d4$var$appearanceMap[0, $gULOk.UNDEFINED];

});

parcelRegister("dZHIT", function(module, exports) {

$parcel$export(module.exports, "IssueType", () => $e085c81809328c83$export$dce4ecf18820e992);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8laHj = parcelRequire("8laHj");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $jjlQu = parcelRequire("jjlQu");

var $aWse0 = parcelRequire("aWse0");

var $dnq3H = parcelRequire("dnq3H");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $e085c81809328c83$var$InnerActionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5l1n2u _1e0c116y _4cvr1h6o _1bah1h6o _tzy41aa5",
            __cmplp.className
        ])
    });
});
const $e085c81809328c83$var$InnerIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5l1n2u _1e0c116y _tzy41y4k _lcxvglyw",
            __cmplp.className
        ])
    });
});
const $e085c81809328c83$var$TypeIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isActionVisible: isActionVisible, isRestricted: isRestricted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _6a6z1h6o _1bsb7vkz _1e0c11p5 _1lmc1n2u _otawkb7n _a8tgkb7n",
            __cmplp.isActionVisible ? "_1telkb7n" : "_1telidpf",
            __cmplp.isRestricted && "_80om13gf _16l4105o",
            __cmplp.className
        ])
    });
});
const $e085c81809328c83$export$dce4ecf18820e992 = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueTypeName: issueTypeName, issueTypeIconUrl: issueTypeIconUrl, isDraggable: isDraggable, isActionVisible: isActionVisible, restrictedReorderingMessage: restrictedReorderingMessage, onHandleUserClickAnalytics: onHandleUserClickAnalytics, reorderMenu: reorderMenu, issueTypeIcon: issueTypeIcon })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const title = intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $dnq3H.default).issueTypeTitleIssueTerminologyRefreshM4 : (0, $dnq3H.default).issueTypeTitle, {
        issueTypeName: issueTypeName
    });
    const hasValidRestrictedMessage = restrictedReorderingMessage !== '';
    const tooltipContent = issueTypeName || '';
    const action = reorderMenu || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8laHj))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-subtle, #626F86)"
    }); // Using an intermediate div(TypeIconContainer) since AKTooltip needs an element to bind to
    // We aren't wrapping just ListIcon or AsyncIcon since AKTooltip is stateful
    // and we don't want it to unmount as the mouseHover changes
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: !isDraggable && hasValidRestrictedMessage ? String(restrictedReorderingMessage) : tooltipContent,
        hideTooltipOnMouseDown: isDraggable,
        position: "top" // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        ,
        testId: "issue-line-card.issue-type.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e085c81809328c83$var$TypeIconContainer, {
        onClick: ()=>onHandleUserClickAnalytics?.('typeIcon'),
        "data-testid": "issue-line-card-issue-type.issue-type",
        isActionVisible: isDraggable && isActionVisible,
        isRestricted: hasValidRestrictedMessage
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e085c81809328c83$var$InnerIconContainer, null, issueTypeIcon ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
        alt: title,
        url: issueTypeIconUrl
    })), isDraggable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e085c81809328c83$var$InnerActionContainer, null, action)));
});

});
parcelRegister("8laHj", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d8e199447618ebf9961e7eca7a27c952>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6128953930f836bb$var$_react = $6128953930f836bb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6128953930f836bb$var$_dragHandleVertical = $6128953930f836bb$var$_interopRequireDefault((parcelRequire("aQg6X")));

var $6128953930f836bb$var$_dragHandler = $6128953930f836bb$var$_interopRequireDefault((parcelRequire("78tet")));
function $6128953930f836bb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for DragHandleVerticalIcon.
 * This component is DragHandleVerticalIcon, with `UNSAFE_fallbackIcon` set to "DragHandlerIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6128953930f836bb$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $6128953930f836bb$var$_react.default.createElement($6128953930f836bb$var$_dragHandleVertical.default, Object.assign({
        LEGACY_fallbackIcon: $6128953930f836bb$var$_dragHandler.default
    }, props));
$6128953930f836bb$var$DragHandleVerticalIcon.Name = 'DragHandleVerticalIconMigration';
var $6128953930f836bb$var$_default = module.exports.default = $6128953930f836bb$var$DragHandleVerticalIcon;

});
parcelRegister("aQg6X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::37637907bc962c27c98c216148025653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e4b4215d4b0ee00$var$_react = $7e4b4215d4b0ee00$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $7e4b4215d4b0ee00$var$_baseNew = $7e4b4215d4b0ee00$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $7e4b4215d4b0ee00$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "DragHandleVertical".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for dragging elements along a vertical axis.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $7e4b4215d4b0ee00$var$DragHandleVerticalIcon = (props)=>/*#__PURE__*/ $7e4b4215d4b0ee00$var$_react.default.createElement($7e4b4215d4b0ee00$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="M7 2.75a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0M7 8a1.75 1.75 0 1 1-3.5 0A1.75 1.75 0 0 1 7 8m5.5 0A1.75 1.75 0 1 1 9 8a1.75 1.75 0 0 1 3.5 0M7 13.25a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0m5.5 0a1.75 1.75 0 1 1-3.5 0 1.75 1.75 0 0 1 3.5 0"/>`
    }, props));
$7e4b4215d4b0ee00$var$DragHandleVerticalIcon.displayName = 'DragHandleVerticalIcon';
var $7e4b4215d4b0ee00$var$_default = module.exports.default = $7e4b4215d4b0ee00$var$DragHandleVerticalIcon;

});

parcelRegister("78tet", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $531ff4bbcd008815$var$_react = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $531ff4bbcd008815$var$_dragHandleVertical = $531ff4bbcd008815$var$_interopRequireDefault((parcelRequire("aQg6X")));
function $531ff4bbcd008815$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $531ff4bbcd008815$var$DragHandlerIcon = (props)=>/*#__PURE__*/ $531ff4bbcd008815$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><circle cx="10" cy="8" r="1"/><circle cx="14" cy="8" r="1"/><circle cx="10" cy="16" r="1"/><circle cx="14" cy="16" r="1"/><circle cx="10" cy="12" r="1"/><circle cx="14" cy="12" r="1"/></g></svg>`
    }, props, {
        newIcon: $531ff4bbcd008815$var$_dragHandleVertical.default
    }));
$531ff4bbcd008815$var$DragHandlerIcon.displayName = 'DragHandlerIcon';
var $531ff4bbcd008815$var$_default = module.exports.default = $531ff4bbcd008815$var$DragHandlerIcon;

});


parcelRegister("jjlQu", function(module, exports) {

$parcel$export(module.exports, "default", () => $e7f7206d8a029d15$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/react/handler-naming */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");
const $e7f7206d8a029d15$export$c6d2b2df39d78e5b = (0, $gwIPs.gridSize) * 2;
class $e7f7206d8a029d15$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            url: undefined,
            title: undefined,
            alt: undefined,
            width: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            height: $e7f7206d8a029d15$export$c6d2b2df39d78e5b,
            fallback: undefined
        };
    }
    render() {
        const { title: title, url: url, alt: alt, fallback: fallback } = this.props;
        const width = this.convertSize(this.props.width);
        const height = this.convertSize(this.props.height);
        if (this.state.isBroken && fallback) return fallback();
        if (url) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e7f7206d8a029d15$var$Image, {
            src: url,
            width: width,
            height: height,
            title: title ?? undefined,
            alt: alt ?? '',
            onError: this.onError,
            /**
       * Disabling dragging so drags happen on the parent instead of this icon.
       */ draggable: false,
            "data-vc": "common-components-async-icon"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $e7f7206d8a029d15$var$placeholderStyles,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                height: height,
                width: width
            },
            backgroundColor: "color.background.input.hovered",
            testId: "common-components-async-icon.placeholder"
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isBroken: false
        }, this.onError = ()=>{
            this.setState({
                isBroken: true
            });
        }, this.convertSize = (size)=>size ? `${size}px` : '0';
    }
}
const $e7f7206d8a029d15$var$placeholderStyles = (0, $8CUq3.xcss)({
    borderRadius: '3px',
    display: 'flex',
    flex: 'none'
});
// Firefox displays the alt text when the image can't load, the narrow provided width
// means this alt text leaks into the summary vertically if overflow is allowed
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e7f7206d8a029d15$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dnq3H", function(module, exports) {

$parcel$export(module.exports, "default", () => $5472b54f8b4cd33c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5472b54f8b4cd33c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTypeTitle: {
        "id": "issue-line-card-issue-type.issue-type-title",
        "defaultMessage": "Issue type: {issueTypeName}"
    },
    issueTypeTitleIssueTerminologyRefreshM4: {
        "id": "issue-line-card-issue-type.issue-type-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work type: {issueTypeName}"
    }
});

});


parcelRegister("itzcE", function(module, exports) {

$parcel$export(module.exports, "CardDueDate", () => $1f73e6aec72eb1bf$export$9e242219cf1cc36c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4mBKK = parcelRequire("4mBKK");
var $70Rr2 = parcelRequire("70Rr2");
var $k7m40 = parcelRequire("k7m40");
var $eZDAP = parcelRequire("eZDAP");
var $it1wb = parcelRequire("it1wb");

var $3u0c5 = parcelRequire("3u0c5");

var $3bDjY = parcelRequire("3bDjY");

var $d9xxV = parcelRequire("d9xxV");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $f1akg = parcelRequire("f1akg");

var $8uZt8 = parcelRequire("8uZt8");


var $eDs1Y = parcelRequire("eDs1Y");
const $1f73e6aec72eb1bf$export$9e242219cf1cc36c = (props)=>{
    const { isCompleted: isCompleted, dueDate: dueDate, dateFormat: dateFormat, isShortFormat: isShortFormat = false } = props;
    const dueDateEndOfDay = (0, $70Rr2.default)((0, $eZDAP.default)(dueDate));
    const currentDate = (0, $it1wb.default)(new Date());
    const diffInDays = (0, $4mBKK.default)(dueDateEndOfDay, currentDate);
    const isDueBeforeToday = diffInDays <= 0;
    const isOverDue = isCompleted !== true && isDueBeforeToday;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formattedDueDate = dateFormat !== undefined && dateFormat !== null ? (0, $k7m40.default)(dueDateEndOfDay, dateFormat) : (0, $k7m40.default)(dueDateEndOfDay, 'dd MMM');
    const formattedTooltip = formatMessage((0, $eDs1Y.messages).text, {
        date: (0, $k7m40.default)(dueDateEndOfDay, 'dd MMMM yyyy')
    });
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        if (!dueDate) return null;
        return (0, $6s1PB.expVal)('color_due_date_all_views', 'showColoredDueDate', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f1akg.ColoredDueDate), {
            dateString: dueDate,
            pastDue: isCompleted !== true && diffInDays < 0,
            dueToday: diffInDays === 0,
            warningIconTestId: "platform-card.common.ui.due-date.warning-icon",
            clockIconTestId: "platform-card.common.ui.due-date.clock-icon",
            calendarIconTestId: "platform-card.common.ui.due-date.calendar-icon",
            tooltipTestId: "platform-card.common.ui.due-date.tooltip",
            isShortFormat: isShortFormat
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formattedTooltip,
            testId: "platform-card.common.ui.due-date.tooltip"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f73e6aec72eb1bf$var$TagHack, {
            tagColor: $1f73e6aec72eb1bf$var$dueDateLozengeStyle(isOverDue).color
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9xxV.default), {
            testId: "platform-card.common.ui.due-date.tag",
            elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
                type: (0, $6d6eac2504286faf$export$d4ee7b46933c494f),
                label: formattedTooltip
            }),
            text: formattedDueDate
        })));
    }
    /* eslint-disable jira/react/no-style-attribute */ return dueDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    ), {
        style: $1f73e6aec72eb1bf$var$dueDateLozengeStyle(isOverDue),
        testId: "platform-card.common.ui.due-date.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formattedTooltip,
        testId: "platform-card.common.ui.due-date.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f73e6aec72eb1bf$var$Content, {
        "aria-label": formattedTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$d4ee7b46933c494f),
        label: formattedTooltip
    }), formattedDueDate))) : null; /* eslint-enable jira/react/no-style-attribute */ 
};
$1f73e6aec72eb1bf$export$9e242219cf1cc36c.defaultProps = {
    isCompleted: false
};
var $1f73e6aec72eb1bf$export$2e2bcd8739ae039 //! This is used to override the default theme as Tag doesn't support custom styles.
 = $1f73e6aec72eb1bf$export$9e242219cf1cc36c;
const $1f73e6aec72eb1bf$var$tagHackStyles = null;
const $1f73e6aec72eb1bf$var$TagHack = ({ tagColor: tagColor, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        {
            '--due-date-tag-color': tagColor
        },
        className: (0, $bwpsq.default)([
            "_1e0c116y _1npcidpf _1gicidpf _1e09idpf _1mspidpf _1h4r19ik _1m9k19ik"
        ])
    }, children);
const $1f73e6aec72eb1bf$var$dueDateLozengeStyle = (isOverDue)=>isOverDue ? {
        color: "var(--ds-text-accent-red, #AE2E24)",
        backgroundColor: "var(--ds-background-danger, #FFECEB)"
    } : {
        color: "var(--ds-text-subtle, #44546F)",
        backgroundColor: "var(--ds-background-neutral, #091E420F)"
    }; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f73e6aec72eb1bf$var$ContentOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f73e6aec72eb1bf$var$ContentNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o _1n261g80 _1x821ts4 _1ul9t9kd",
            __cmplp.className
        ])
    });
});
const $1f73e6aec72eb1bf$var$Content = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $1f73e6aec72eb1bf$var$ContentNew, $1f73e6aec72eb1bf$var$ContentOld);

});
parcelRegister("f1akg", function(module, exports) {

$parcel$export(module.exports, "ColoredDueDate", () => $3f739dd1d004c9d2$export$63c54814247cca36);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jpopi = parcelRequire("jpopi");

var $acknU = parcelRequire("acknU");

var $hyKRO = parcelRequire("hyKRO");

var $jCESp = parcelRequire("jCESp");

var $3bDjY = parcelRequire("3bDjY");

var $DVljb = parcelRequire("DVljb");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $1eyaH = parcelRequire("1eyaH");

var $cpjnU = parcelRequire("cpjnU");

var $CKlOf = parcelRequire("CKlOf");
const $3f739dd1d004c9d2$var$RecurringWorkItemIcon = ({ testId: testId })=>{
    const { issueProperties: issueProperties, isUpdatingRule: isUpdatingRule } = (0, $1eyaH.useRecurWorkItemState)();
    if (!issueProperties && !isUpdatingRule || (0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jpopi))), {
        label: "",
        testId: testId
    });
};
const $3f739dd1d004c9d2$export$63c54814247cca36 = ({ dateString: dateString, pastDue: pastDue, dueToday: dueToday, warningIconTestId: warningIconTestId, clockIconTestId: clockIconTestId, calendarIconTestId: calendarIconTestId, tooltipTestId: tooltipTestId, isShortFormat: isShortFormat = false, maybeShowRecurIcon: maybeShowRecurIcon = false, recurIconTestId: recurIconTestId })=>{
    const locale = (0, $DVljb.useLocale)();
    const localeString = locale.replace('_', '-');
    const formatter = new Intl.DateTimeFormat(localeString, {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'UTC',
        timeZoneName: 'short'
    });
    const parts = formatter.formatToParts(new Date(dateString));
    const formatDateParts = ({ dateParts: dateParts, includeYear: includeYear = true, includeTimezone: includeTimezone = false })=>{
        let result = '';
        dateParts.forEach((part, index)=>{
            const nextPart = dateParts[index + 1];
            const skipCurrentPart = !includeTimezone && nextPart?.type === 'timeZoneName' && part.type === 'literal' && part.value === ', ';
            if (!skipCurrentPart && (part.type === 'year' && includeYear || part.type === 'timeZoneName' && includeTimezone || part.type !== 'year' && part.type !== 'timeZoneName')) result += part.value;
        });
        return result;
    };
    const displayDate = isShortFormat ? formatDateParts({
        dateParts: parts,
        includeYear: false
    }) : formatDateParts({
        dateParts: parts
    });
    const tooltipDate = formatDateParts({
        dateParts: parts,
        includeYear: true,
        includeTimezone: true
    });
    const dueMessage = pastDue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).overdue,
        values: {
            date: tooltipDate
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $CKlOf.messages).due,
        values: {
            date: tooltipDate
        }
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const iconLabel = pastDue ? formatMessage((0, $CKlOf.messages).overdue, {
        date: tooltipDate
    }) : formatMessage((0, $CKlOf.messages).due, {
        date: tooltipDate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: dueMessage,
        position: "top",
        testId: tooltipTestId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $3f739dd1d004c9d2$var$styles.dateTag,
            $3f739dd1d004c9d2$var$styles.flexContainer,
            pastDue ? $3f739dd1d004c9d2$var$styles.overdue : undefined,
            dueToday ? $3f739dd1d004c9d2$var$styles.dueToday : undefined,
            !pastDue && !dueToday ? $3f739dd1d004c9d2$var$styles.normalDate : undefined
        ],
        testId: "coloured-due-date.ui.colored-due-date-container",
        tabIndex: 0,
        role: "button",
        "aria-label": iconLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3f739dd1d004c9d2$var$styles.dueDateIcon,
        testId: "coloured-due-date.ui.tooltip-container"
    }, pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jCESp))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-danger, #AE2E24)",
        testId: warningIconTestId
    }), dueToday && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        LEGACY_size: "medium",
        label: iconLabel,
        color: "var(--ds-text-warning, #A54800)",
        testId: clockIconTestId
    }), !dueToday && !pastDue && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
        label: iconLabel,
        color: "var(--ds-text, #172B4D)",
        LEGACY_size: "medium",
        testId: calendarIconTestId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "aria-hidden": "true"
    }, displayDate), maybeShowRecurIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f739dd1d004c9d2$var$RecurringWorkItemIcon, {
        testId: recurIconTestId
    })));
};
const $3f739dd1d004c9d2$var$styles = {
    dateTag: (0, $8CUq3.xcss)({
        paddingLeft: 'space.075',
        paddingRight: 'space.075',
        borderStyle: 'solid',
        borderRadius: 'border.radius.100',
        borderWidth: 'border.width',
        color: 'color.text',
        cursor: 'pointer'
    }),
    flexContainer: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center',
        gap: 'space.050'
    }),
    overdue: (0, $8CUq3.xcss)({
        color: 'color.text.danger',
        borderColor: 'color.border.danger'
    }),
    dueToday: (0, $8CUq3.xcss)({
        color: 'color.text.warning',
        borderColor: 'color.border.warning'
    }),
    normalDate: (0, $8CUq3.xcss)({
        color: 'color.text',
        borderColor: 'color.border'
    }),
    dueDateIcon: (0, $8CUq3.xcss)({
        display: 'flex',
        alignItems: 'center'
    })
};

});
parcelRegister("jpopi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a88758e67a65d8683bdcd5e828d8b686>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e21348dd48989821$var$_react = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e21348dd48989821$var$_baseNew = $e21348dd48989821$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e21348dd48989821$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Repeat".
 * Category: single-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Reserved for setting objects to recur (eg Work items, Forms)
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e21348dd48989821$var$RepeatIcon = (props)=>/*#__PURE__*/ $e21348dd48989821$var$_react.default.createElement($e21348dd48989821$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m8.78 3.72-3-3-1.06 1.06L6.44 3.5H4.5a4.5 4.5 0 0 0 0 9h1V11h-1a3 3 0 0 1 0-6h1.94L4.72 6.72l1.06 1.06 3-3a.75.75 0 0 0 0-1.06M11.5 5a3 3 0 1 1 0 6H9.56l1.72-1.72-1.06-1.06-3 3a.75.75 0 0 0 0 1.06l3 3 1.06-1.06-1.72-1.72h1.94a4.5 4.5 0 1 0 0-9h-1V5z" clip-rule="evenodd"/>`
    }, props));
$e21348dd48989821$var$RepeatIcon.displayName = 'RepeatIcon';
var $e21348dd48989821$var$_default = module.exports.default = $e21348dd48989821$var$RepeatIcon;

});

parcelRegister("acknU", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9571ec76557171a7f54748c218c48225>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $76cad653a4883392$var$_react = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $76cad653a4883392$var$_calendar = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("3fesp")));

var $76cad653a4883392$var$_calendar2 = $76cad653a4883392$var$_interopRequireDefault((parcelRequire("cTemL")));
function $76cad653a4883392$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CalendarIcon.
 * This component is CalendarIcon, with `UNSAFE_fallbackIcon` set to "CalendarIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $76cad653a4883392$var$CalendarIcon = (props)=>/*#__PURE__*/ $76cad653a4883392$var$_react.default.createElement($76cad653a4883392$var$_calendar.default, Object.assign({
        LEGACY_fallbackIcon: $76cad653a4883392$var$_calendar2.default
    }, props));
$76cad653a4883392$var$CalendarIcon.Name = 'CalendarIconMigration';
var $76cad653a4883392$var$_default = module.exports.default = $76cad653a4883392$var$CalendarIcon;

});
parcelRegister("3fesp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::43a4f9fcd22489798c1322bda48936cf>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $25cdfcb8bb836404$var$_react = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $25cdfcb8bb836404$var$_baseNew = $25cdfcb8bb836404$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $25cdfcb8bb836404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Calendar".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: date metadata, date input field, calendar view, jira status.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $25cdfcb8bb836404$var$CalendarIcon = (props)=>/*#__PURE__*/ $25cdfcb8bb836404$var$_react.default.createElement($25cdfcb8bb836404$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.5 2.5v2H6v-2h4v2h1.5v-2H13a.5.5 0 0 1 .5.5v3h-11V3a.5.5 0 0 1 .5-.5zm-2 5V13a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V7.5zm9-6.5H13a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3a2 2 0 0 1 2-2h1.5V0H6v1h4V0h1.5z" clip-rule="evenodd"/>`
    }, props));
$25cdfcb8bb836404$var$CalendarIcon.displayName = 'CalendarIcon';
var $25cdfcb8bb836404$var$_default = module.exports.default = $25cdfcb8bb836404$var$CalendarIcon;

});

parcelRegister("cTemL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9625c3edd02eaf26$var$_react = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $9625c3edd02eaf26$var$_calendar = $9625c3edd02eaf26$var$_interopRequireDefault((parcelRequire("3fesp")));
function $9625c3edd02eaf26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9625c3edd02eaf26$var$CalendarIcon = (props)=>/*#__PURE__*/ $9625c3edd02eaf26$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0 1 19.005 21H4.995A1.995 1.995 0 0 1 3 19.006V6.994C3 5.893 3.892 5 4.995 5M5 9v9a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1V9zm1-5a1 1 0 0 1 2 0v1H6zm10 0a1 1 0 0 1 2 0v1h-2zm-9 9v-2.001h2V13zm8 0v-2.001h2V13zm-4 0v-2.001h2.001V13zm-4 4v-2h2v2zm4 0v-2h2.001v2zm4 0v-2h2v2z"/></svg>`
    }, props, {
        newIcon: $9625c3edd02eaf26$var$_calendar.default
    }));
$9625c3edd02eaf26$var$CalendarIcon.displayName = 'CalendarIcon';
var $9625c3edd02eaf26$var$_default = module.exports.default = $9625c3edd02eaf26$var$CalendarIcon;

});


parcelRegister("jCESp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::22f154a5d93289d4bcc4dadb1207abea>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e49146301a0d3a89$var$_react = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e49146301a0d3a89$var$_baseNew = $e49146301a0d3a89$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e49146301a0d3a89$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "WarningOutline".
 * Category: multi-purpose
 * Location: @atlaskit/icon-lab
 * Usage guidance: Low-impact warnings. Overdue dates in Atlassian Home.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e49146301a0d3a89$var$WarningOutlineIcon = (props)=>/*#__PURE__*/ $e49146301a0d3a89$var$_react.default.createElement($e49146301a0d3a89$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5.7 1.384c.996-1.816 3.605-1.818 4.602-.003l5.35 9.73C16.612 12.86 15.346 15 13.35 15H2.667C.67 15-.594 12.862.365 11.113zm3.288.72a1.125 1.125 0 0 0-1.972 0l-5.336 9.73c-.41.75.132 1.666.987 1.666H13.35c.855 0 1.398-.917.986-1.667z" clip-rule="evenodd"/><path fill="currentcolor" fill-rule="evenodd" d="M7.25 9V4h1.5v5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 11.25a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$e49146301a0d3a89$var$WarningOutlineIcon.displayName = 'WarningOutlineIcon';
var $e49146301a0d3a89$var$_default = module.exports.default = $e49146301a0d3a89$var$WarningOutlineIcon;

});

parcelRegister("1eyaH", function(module, exports) {

$parcel$export(module.exports, "RecurWorkItemContainer", () => $299cd71373520f02$export$32458a51e0870d6c);
$parcel$export(module.exports, "useRecurWorkItemState", () => $299cd71373520f02$export$5730c874dfb9803f);
$parcel$export(module.exports, "useRecurWorkItemActions", () => $299cd71373520f02$export$eb9ad4e1e739768e);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $koeKL = parcelRequire("koeKL");

var $2tT7R = parcelRequire("2tT7R");

var $93Yeu = parcelRequire("93Yeu");

var $cYlk7 = parcelRequire("cYlk7");

var $2YZCu = parcelRequire("2YZCu");

var $hVn1P = parcelRequire("hVn1P");

var $lQupu = parcelRequire("lQupu");
const $299cd71373520f02$var$RecurWorkItemStoreContainer = (0, $gg7kZ.createContainer)();
const $299cd71373520f02$export$32458a51e0870d6c = ({ children: children, issueKey: issueKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const environment = (0, $2tT7R.useEnvironment)();
    const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
    const projectId = (0, $93Yeu.useProjectId)(projectKey);
    const { data: currentUser } = (0, $cYlk7.useCurrentUser)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    if (!projectId) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('jira-recur-work-item.src.controllers.RecurWorkItemContainer', 'Error initialising RecurWorkItemContainer, could not retrieve projectId');
        return children;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($299cd71373520f02$var$RecurWorkItemStoreContainer, {
        scope: `recur-${issueKey}`,
        issueKey: issueKey,
        environment: environment,
        cloudId: cloudId,
        currentUserAccountId: currentUser.user.accountId,
        projectId: projectId,
        createAnalyticsEvent: createAnalyticsEvent
    }, children);
};
const $299cd71373520f02$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'RecurWorkItemStore',
    initialState: (0, $lQupu.INITIAL_STATE),
    actions: $hVn1P.actions,
    containedBy: $299cd71373520f02$var$RecurWorkItemStoreContainer,
    handlers: {
        onInit: ()=>async ({ dispatch: dispatch })=>{
                await dispatch((0, $hVn1P.actions).fetch());
            }
    }
});
const $299cd71373520f02$export$6630e454597fb59c = (0, $3sQ5x.createHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$5730c874dfb9803f = (0, $3sQ5x.createStateHook)($299cd71373520f02$export$390f32400eaf98c9);
const $299cd71373520f02$export$eb9ad4e1e739768e = (0, $3sQ5x.createActionsHook)($299cd71373520f02$export$390f32400eaf98c9);

});
parcelRegister("hVn1P", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a7f343d49f172fdb$export$e324594224ef24da);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $7Sl82 = parcelRequire("7Sl82");

var $l9xxv = parcelRequire("l9xxv");

var $bvhsR = parcelRequire("bvhsR");

var $c8g0F = parcelRequire("c8g0F");
const $a7f343d49f172fdb$export$5153917efea4a83d = (issueProperties)=>({ setState: setState })=>{
        setState({
            issueProperties: issueProperties
        });
    };
const $a7f343d49f172fdb$export$e324594224ef24da = {
    fetch: $7Sl82.fetch,
    setIssueProperties: $a7f343d49f172fdb$export$5153917efea4a83d,
    setAsNonRecurringIssue: $l9xxv.setAsNonRecurringIssue,
    setAsRecurringIssue: $bvhsR.setAsRecurringIssue,
    updateRule: $c8g0F.updateRule
};

});
parcelRegister("7Sl82", function(module, exports) {

$parcel$export(module.exports, "fetch", () => $88fd35b220315252$export$e7aa7bc5c1b3cfb3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $4R6GH = parcelRequire("4R6GH");

var $m8SHd = parcelRequire("m8SHd");

var $ahBjy = parcelRequire("ahBjy");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $cpjnU = parcelRequire("cpjnU");
const $88fd35b220315252$export$e7aa7bc5c1b3cfb3 = ()=>async ({ setState: setState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId, currentUserAccountId: currentUserAccountId })=>{
        setState({
            isFetching: true,
            errors: null
        });
        try {
            // First fetch issue-properties
            const { value: issueProperties } = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchIssueProperties)(issueKey), 'fetchIssueProperties');
            let ruleSummary;
            // Only fetch rule summary if a rule exists in issue-properties and not a grandfathered recur-on-complete rule
            if (issueProperties?.automationRuleUuid) {
                ruleSummary = await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $m8SHd.fetchRuleSummary)(environment, cloudId, projectId, issueProperties.automationRuleUuid), 'fetchRuleSummary');
                // If rule doesn't exist or is disabled, delete issue-properties
                if (!ruleSummary || ruleSummary?.ruleState === (0, $ahBjy.RuleState).DISABLED) {
                    await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                        issueKey: issueKey
                    }), 'deleteIssueProperties');
                    setState({
                        isFetching: false,
                        hasFetched: true,
                        issueProperties: null
                    });
                    return;
                }
            }
            let isRuleOwner;
            if ((0, $cpjnU.isRecurOnCompleteToggleRule)(issueProperties)) isRuleOwner = true;
            else if (ruleSummary) isRuleOwner = ruleSummary.authorAccountId === currentUserAccountId;
            else isRuleOwner = null;
            setState({
                isFetching: false,
                hasFetched: true,
                issueProperties: issueProperties,
                isRuleOwner: isRuleOwner,
                ...(0, $4R6GH.fg)('jira-recur-single-work-item-on-sched-due-date-gate') && {
                    hasBootstrapError: false
                }
            });
        } catch (error) {
            setState({
                isFetching: false,
                hasFetched: true,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    error
                ],
                hasBootstrapError: true
            });
        }
    };

});
parcelRegister("m8SHd", function(module, exports) {

$parcel$export(module.exports, "fetchIssueProperties", () => $85e12c64cfd21e7a$export$efa35964e975bd30);
$parcel$export(module.exports, "fetchRuleSummary", () => $85e12c64cfd21e7a$export$3cada9835f092161);

var $c5wox = parcelRequire("c5wox");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $85e12c64cfd21e7a$export$efa35964e975bd30 = async (issueKey)=>{
    const recurrenceConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    try {
        return await (0, $eusud.performGetRequest)(recurrenceConfigEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return Promise.resolve({
            value: null
        });
        throw error;
    }
};
const $85e12c64cfd21e7a$export$3cada9835f092161 = async (environment, cloudId, projectId, ruleUuid)=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const summaryEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/summary`;
    try {
        return await (0, $eusud.performGetRequest)(summaryEndpoint);
    } catch (error) {
        if (error instanceof (0, $jJZqs.default) && error.statusCode === 404) return null;
        throw error;
    }
};

});
parcelRegister("c5wox", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $8833cfad9f41bd36$export$6123178d3f5fb24d);
$parcel$export(module.exports, "getAutomationRecommendationsUrl", () => $8833cfad9f41bd36$export$38f41aa7b608011d);
$parcel$export(module.exports, "getBaseAutomationUrl", () => $8833cfad9f41bd36$export$8e479e490e1e69bc);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $8833cfad9f41bd36$var$localStorage = (0, $bSSG7.createLocalStorageProvider)('automation-menu');
const $8833cfad9f41bd36$var$getLatestStack = async (cloudId)=>fetch(`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`).then((response)=>response.json()).then((response)=>{
        const stacks = response.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        return stacks.length > 0 ? stacks[0] : null;
    }).catch(()=>null);
const $8833cfad9f41bd36$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') {
        if ((0, $4R6GH.fg)('automation-platform-pre-prod-instance')) {
            const stack = await $8833cfad9f41bd36$var$getLatestStack(cloudId);
            return stack ?? 'pro';
        }
        return 'pro';
    }
    // Set this manually to your Automation dev stack e.g. devesukmajaya. The full key is: __storejs_automation-menu_automationStack
    const stackOverride = $8833cfad9f41bd36$var$localStorage.get('automationStack');
    return stackOverride || 'staging';
};
const $8833cfad9f41bd36$export$45ce04a98782e28a = async (env, cloudId, projectId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${projectId}`;
};
const $8833cfad9f41bd36$export$f8e019b45a22d26a = async (env, cloudId, ruleId)=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/rules/invocation/${ruleId}`;
};
const $8833cfad9f41bd36$export$38f41aa7b608011d = async ({ env: env, cloudId: cloudId, target: target })=>{
    const automationStack = await $8833cfad9f41bd36$export$6123178d3f5fb24d(env, cloudId);
    return `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/v1/recommendation/templates?target=${target}`;
};
const $8833cfad9f41bd36$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if ((0, $4R6GH.fg)('jcs_project_type_m3')) switch(projectType){
        case 'customer_service':
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});


parcelRegister("ahBjy", function(module, exports) {

$parcel$export(module.exports, "RuleState", () => $50cbc517c5c98dcf$export$c22ef3527b5f5563);
$parcel$export(module.exports, "CONDITION", () => $50cbc517c5c98dcf$export$1cfe08df32bc8f76);
$parcel$export(module.exports, "FORM_TITLE_ID", () => $50cbc517c5c98dcf$export$66f4c6e4b9206abf);
$parcel$export(module.exports, "SOFTWARE_END_USER_TEMPLATE_2", () => $50cbc517c5c98dcf$export$c07ca23c166d6344);
const $50cbc517c5c98dcf$export$c22ef3527b5f5563 = {
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    MISSING_PERMS: 'MISSING_PERMS'
};
const $50cbc517c5c98dcf$export$1cfe08df32bc8f76 = {
    SCHEDULE: 'SCHEDULE',
    SCHEDULE_IF_COMPLETE: 'SCHEDULE_IF_COMPLETE'
};
const $50cbc517c5c98dcf$export$f7109619a5e9e0d6 = 'recurWorkItemForm';
const $50cbc517c5c98dcf$export$66f4c6e4b9206abf = 'recur-work-item-form-title';
const $50cbc517c5c98dcf$export$c07ca23c166d6344 = 'software_end_user_template_2';

});

parcelRegister("fAJ3G", function(module, exports) {

$parcel$export(module.exports, "deleteRule", () => $dcc2b085f6f8ace7$export$988cba38e738f27d);
$parcel$export(module.exports, "deleteIssueProperties", () => $dcc2b085f6f8ace7$export$3906c12f20991cd1);
$parcel$export(module.exports, "disableRule", () => $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a);

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");
const $dcc2b085f6f8ace7$export$988cba38e738f27d = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const DELETE_RULE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}`;
    return (0, $eusud.performDeleteRequest)(DELETE_RULE_URL);
};
const $dcc2b085f6f8ace7$export$3906c12f20991cd1 = async ({ issueKey: issueKey })=>{
    const ruleConfigEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    return (0, $eusud.performDeleteRequest)(ruleConfigEndpoint);
};
const $dcc2b085f6f8ace7$export$44bd9fdb7edbb04a = async ({ environment: environment, cloudId: cloudId, projectId: projectId, ruleUuid: ruleUuid })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const disableRuleEndpoint = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/rest/${projectId}/rule/${ruleUuid}/disable`;
    return (0, $eusud.performPatchRequest)(disableRuleEndpoint);
};

});

parcelRegister("519t2", function(module, exports) {

$parcel$export(module.exports, "callServiceWithAnalytics", () => $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c);

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
const $ad2a8aebaff4128f$var$getErrorAttributes = (error)=>{
    if (error instanceof Error) return {
        errorMessage: error.message,
        ...error instanceof (0, $jJZqs.default) && {
            statusCode: error.statusCode
        }
    };
    return {};
};
const $ad2a8aebaff4128f$export$7ad2acdaf7d8c23c = async (analyticsEvent, requestPromise, requestName, attributes = {})=>{
    try {
        const response = await requestPromise;
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} succeeded`, {
            ...attributes
        });
        return response;
    } catch (err) {
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${requestName} failed`, {
            ...attributes,
            ...$ad2a8aebaff4128f$var$getErrorAttributes(err)
        });
        throw err;
    }
};

});

parcelRegister("cpjnU", function(module, exports) {

$parcel$export(module.exports, "mapFrequencyToRRule", () => $c35d2016d68e7b8d$export$e01411a3db8dd3d7);
$parcel$export(module.exports, "mapFrequencyToSmartOffsetValue", () => $c35d2016d68e7b8d$export$777fffdd861d4f20);
$parcel$export(module.exports, "getFrequencyFromRRule", () => $c35d2016d68e7b8d$export$71b17ee07540e13b);
$parcel$export(module.exports, "getRecurMenuItemLabel", () => $c35d2016d68e7b8d$export$c7198a7e75d4478b);
$parcel$export(module.exports, "getSuccessFlagContent", () => $c35d2016d68e7b8d$export$8eef89c3d24cb712);
$parcel$export(module.exports, "isRecurOnCompleteToggleRule", () => $c35d2016d68e7b8d$export$b57843f38b80b500);
$parcel$export(module.exports, "hasRuleChanged", () => $c35d2016d68e7b8d$export$8dc77b9e863f46b);
$parcel$export(module.exports, "applyUserTimezone", () => $c35d2016d68e7b8d$export$555109634e8a63b6);

var $ajpes = parcelRequire("ajpes");

var $1GF3c = parcelRequire("1GF3c");

var $gwejS = parcelRequire("gwejS");

var $7jns1 = parcelRequire("7jns1");

var $bbVsP = parcelRequire("bbVsP");
var $jpR5P = parcelRequire("jpR5P");

var $9eJ96 = parcelRequire("9eJ96");

var $5D9Ji = parcelRequire("5D9Ji");
const $c35d2016d68e7b8d$export$e01411a3db8dd3d7 = (timeframe, recurWeeklyConfig)=>{
    switch(timeframe){
        case 'DAILY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                interval: 1
            };
        case 'WEEKDAY':
            return {
                frequency: (0, $9eJ96.Frequencies).DAILY,
                byDay: [
                    (0, $9eJ96.Days).MO,
                    (0, $9eJ96.Days).TU,
                    (0, $9eJ96.Days).WE,
                    (0, $9eJ96.Days).TH,
                    (0, $9eJ96.Days).FR
                ],
                interval: 1
            };
        case 'WEEKLY':
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 1
            };
        case 'FORTNIGHTLY':
            // There is no native FORTNIGHTLY frequency for ical, so we need to combine WEEKLY with interval 2
            return {
                frequency: (0, $9eJ96.Frequencies).WEEKLY,
                byDay: recurWeeklyConfig,
                interval: 2
            };
        default:
            throw new Error(`Unknown timeframe: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$777fffdd861d4f20 = (timeframe)=>{
    switch(timeframe){
        case 'DAILY':
            return '{{now.plusDays(1)}}';
        case 'WEEKDAY':
            return '{{now.plusBusinessDays(1)}}';
        case 'WEEKLY':
            return '{{now.plusWeeks(1)}}';
        case 'FORTNIGHTLY':
            return '{{now.plusWeeks(2)}}';
        default:
            throw new Error(`Could not calculate due date smart offset value: ${timeframe}`);
    }
};
const $c35d2016d68e7b8d$export$71b17ee07540e13b = (rrule)=>{
    if (rrule.frequency === (0, $9eJ96.Frequencies).DAILY) {
        if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(rrule.byDay, [
            (0, $9eJ96.Days).MO,
            (0, $9eJ96.Days).TU,
            (0, $9eJ96.Days).WE,
            (0, $9eJ96.Days).TH,
            (0, $9eJ96.Days).FR
        ])) return 'WEEKDAY';
        return 'DAILY';
    }
    if (rrule.frequency === (0, $9eJ96.Frequencies).WEEKLY) {
        if (rrule.interval === 2) return 'FORTNIGHTLY';
        return 'WEEKLY';
    }
};
const $c35d2016d68e7b8d$export$c7198a7e75d4478b = (rrule, isRecurOnComplete = false)=>{
    if (isRecurOnComplete) return (0, $5D9Ji.default).recursOnComplete;
    const frequency = $c35d2016d68e7b8d$export$71b17ee07540e13b(rrule);
    // Every business day (Monday to Friday)
    if (frequency === 'WEEKDAY') return (0, $5D9Ji.default).recursEveryWeekday;
    // Daily
    if (frequency === 'DAILY') return (0, $5D9Ji.default).recursDaily;
    // Fortnightly
    if (frequency === 'FORTNIGHTLY') return (0, $5D9Ji.default).recursEveryTwoWeeks;
    // Weekly
    if (frequency === 'WEEKLY') return (0, $5D9Ji.default).recursWeekly;
    return (0, $5D9Ji.default).setToRecur;
};
const $c35d2016d68e7b8d$var$byDayOptions = Object.values((0, $9eJ96.Days));
const $c35d2016d68e7b8d$var$getWeekDayNameFromByDay = (byDayValue, intl)=>{
    const dayIndex = $c35d2016d68e7b8d$var$byDayOptions.indexOf(byDayValue);
    if (dayIndex < 0) throw new Error(`Invalid ByDay value provided: ${byDayValue}. Valid options: ${$c35d2016d68e7b8d$var$byDayOptions}`);
    const firstDayOfWeek = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: 1
    });
    const day = (0, $gwejS.default)(firstDayOfWeek, dayIndex);
    return intl.formatDate(day, {
        weekday: 'long'
    });
};
const $c35d2016d68e7b8d$export$5c6d45150d1588c0 = ({ byDayValues: byDayValues, intl: intl, standardizedLocale: standardizedLocale })=>new Intl.ListFormat(standardizedLocale, {
        style: 'long',
        type: 'conjunction'
    }).format(Array.from(byDayValues, (byDayValue)=>$c35d2016d68e7b8d$var$getWeekDayNameFromByDay(byDayValue, intl)));
const $c35d2016d68e7b8d$export$8eef89c3d24cb712 = ({ frequency: frequency, recurCondition: recurCondition, recurWeeklyConfig: recurWeeklyConfig, intl: intl, standardizedLocale: standardizedLocale, issueKey: issueKey, issueType: issueType })=>{
    const issueTypeLowercase = issueType.toLocaleLowerCase(standardizedLocale);
    switch(recurCondition){
        case 'SCHEDULE_IF_COMPLETE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteDaily, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteDaily, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekday, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekday, {
                            issueType: issueTypeLowercase
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteWeekly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteWeekly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleIfCompleteFortnightly, {
                            issueKey: issueKey
                        }),
                        description: intl.formatMessage((0, $5D9Ji.default).successFlagDescriptionRecurOnScheduleIfCompleteFortnightly, {
                            issueType: issueTypeLowercase,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        case 'SCHEDULE':
            switch(frequency){
                case 'DAILY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleDaily, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKDAY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekday, {
                            issueKey: issueKey
                        })
                    };
                case 'WEEKLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleWeekly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                case 'FORTNIGHTLY':
                    return {
                        title: intl.formatMessage((0, $5D9Ji.default).successFlagTitleRecurOnScheduleFortnightly, {
                            issueKey: issueKey,
                            weekDayNames: $c35d2016d68e7b8d$export$5c6d45150d1588c0({
                                byDayValues: recurWeeklyConfig ?? [],
                                intl: intl,
                                standardizedLocale: standardizedLocale
                            })
                        })
                    };
                default:
                    throw new Error(`Unknown frequency: ${frequency}`);
            }
        default:
            throw new Error(`Unknown recur condition: ${recurCondition}`);
    }
};
const $c35d2016d68e7b8d$export$b57843f38b80b500 = (issueProperties)=>{
    return !!issueProperties && !!issueProperties.token && (issueProperties.recurOnScheduleConfig === null || issueProperties.recurOnScheduleConfig === undefined);
};
const $c35d2016d68e7b8d$var$areByDaysEqual = ({ byDays: byDays, anotherByDays: anotherByDays })=>{
    // assumes lists have a consistent order
    if (byDays === undefined) return anotherByDays === undefined;
    if (anotherByDays === undefined) return false;
    if (byDays.length !== anotherByDays.length) return false;
    return byDays.every((byDay, index)=>byDay === anotherByDays[index]);
};
const $c35d2016d68e7b8d$var$areDatesEqual = (date1, date2)=>{
    if (date1 === undefined || date2 === undefined) return date1 === date2;
    // We only care about checking the date equality, not the time
    return date1.getFullYear() === date2.getFullYear() && date1.getMonth() === date2.getMonth() && date1.getDate() === date2.getDate();
};
const $c35d2016d68e7b8d$export$8dc77b9e863f46b = ({ formInput: formInput, formOutput: formOutput })=>{
    // comparing 2 recur-on-schedule rules
    if (formInput.frequency !== formOutput.frequency || formInput.condition !== formOutput.condition || !$c35d2016d68e7b8d$var$areDatesEqual(formInput.endsOn, formOutput.endsOn)) return true;
    if (formInput.frequency === 'WEEKLY' || formInput.frequency === 'FORTNIGHTLY') return !$c35d2016d68e7b8d$var$areByDaysEqual({
        byDays: formInput.byDay,
        anotherByDays: formOutput.byDay
    });
    return false;
};
const $c35d2016d68e7b8d$export$555109634e8a63b6 = (date, browserTimezone, userTimezone)=>{
    const browserTimezoneOffsetMs = (0, $7jns1.default)(browserTimezone);
    const userTimezoneOffsetMs = (0, $7jns1.default)(userTimezone);
    return (0, $bbVsP.default)((0, $jpR5P.default)(date, browserTimezoneOffsetMs), userTimezoneOffsetMs);
};

});
parcelRegister("9eJ96", function(module, exports) {

$parcel$export(module.exports, "NEWLINE_REGEX", () => $1079d16957e265b2$export$665ca7211e0c33c);
$parcel$export(module.exports, "FOLD_LINES_REGEX", () => $1079d16957e265b2$export$4b7f22f32fbb5949);
$parcel$export(module.exports, "LF", () => $1079d16957e265b2$export$606cfc2a8896c91f);
$parcel$export(module.exports, "NewlineCharacters", () => $1079d16957e265b2$export$ccae594c20078277);
$parcel$export(module.exports, "NewlineCharacterValues", () => $1079d16957e265b2$export$c3edd2b21ac02f88);
$parcel$export(module.exports, "Frequencies", () => $1079d16957e265b2$export$895ee510b2e84ade);
$parcel$export(module.exports, "Days", () => $1079d16957e265b2$export$d3134eff2123aadb);
$parcel$export(module.exports, "BEGIN_VEVENT", () => $1079d16957e265b2$export$67de00e87412dc6f);
$parcel$export(module.exports, "END_VEVENT", () => $1079d16957e265b2$export$987d86d2e891c4cb);
$parcel$export(module.exports, "DTSTART", () => $1079d16957e265b2$export$fd1a0e011a586e26);
$parcel$export(module.exports, "RRULE", () => $1079d16957e265b2$export$d86ed937a45b0291);
$parcel$export(module.exports, "ICalSpecificationFields", () => $1079d16957e265b2$export$98eba4d8ff00c139);
$parcel$export(module.exports, "ICalSupportedFields", () => $1079d16957e265b2$export$38b1323f325ffd22);
$parcel$export(module.exports, "TZID", () => $1079d16957e265b2$export$5b9a78912028c06d);
$parcel$export(module.exports, "DTStartProperties", () => $1079d16957e265b2$export$20184b745430719e);
$parcel$export(module.exports, "FREQ", () => $1079d16957e265b2$export$fb124b4fa837b262);
$parcel$export(module.exports, "UNTIL", () => $1079d16957e265b2$export$4cc4f35131ed029c);
$parcel$export(module.exports, "INTERVAL", () => $1079d16957e265b2$export$7dea0e6e08f87a8a);
$parcel$export(module.exports, "BYHOUR", () => $1079d16957e265b2$export$a764ed9c4884f76d);
$parcel$export(module.exports, "BYMINUTE", () => $1079d16957e265b2$export$7a96578de7a037b6);
$parcel$export(module.exports, "BYSECOND", () => $1079d16957e265b2$export$55bcca3bd8d3041f);
$parcel$export(module.exports, "BYDAY", () => $1079d16957e265b2$export$f512ea3e90612d03);
$parcel$export(module.exports, "BYMONTH", () => $1079d16957e265b2$export$b3203f635d74ce88);
$parcel$export(module.exports, "BYMONTHDAY", () => $1079d16957e265b2$export$15623ad945e92c4c);
$parcel$export(module.exports, "RRuleProperties", () => $1079d16957e265b2$export$7898bd020dba0a27);
$parcel$export(module.exports, "MISSING", () => $1079d16957e265b2$export$64c81710c321f252);
$parcel$export(module.exports, "EMPTY", () => $1079d16957e265b2$export$ccb33e29d92c9a58);
$parcel$export(module.exports, "INVALID", () => $1079d16957e265b2$export$9a105a556e65c2c0);
$parcel$export(module.exports, "VALID", () => $1079d16957e265b2$export$f3abe3d006c81602);
const $1079d16957e265b2$export$665ca7211e0c33c = /\r?\n/;
const $1079d16957e265b2$export$4b7f22f32fbb5949 = /\r?\n[ \t]/g; // match line breaks followed by a whitespace character (space or tab)
const $1079d16957e265b2$export$ae9ea0d00d3d8982 = 'CRLF';
const $1079d16957e265b2$export$a1f3f1ef020bdc3a = '\r\n';
const $1079d16957e265b2$export$606cfc2a8896c91f = 'LF';
const $1079d16957e265b2$export$477fea8aa280bb1e = '\n';
const $1079d16957e265b2$export$ccae594c20078277 = {
    CRLF: $1079d16957e265b2$export$ae9ea0d00d3d8982,
    LF: $1079d16957e265b2$export$606cfc2a8896c91f
};
const $1079d16957e265b2$export$c3edd2b21ac02f88 = {
    [$1079d16957e265b2$export$ae9ea0d00d3d8982]: $1079d16957e265b2$export$a1f3f1ef020bdc3a,
    [$1079d16957e265b2$export$606cfc2a8896c91f]: $1079d16957e265b2$export$477fea8aa280bb1e
};
const $1079d16957e265b2$export$895ee510b2e84ade = {
    SECONDLY: 'SECONDLY',
    MINUTELY: 'MINUTELY',
    HOURLY: 'HOURLY',
    DAILY: 'DAILY',
    WEEKLY: 'WEEKLY',
    MONTHLY: 'MONTHLY',
    YEARLY: 'YEARLY'
};
const $1079d16957e265b2$export$d3134eff2123aadb = {
    MO: 'MO',
    TU: 'TU',
    WE: 'WE',
    TH: 'TH',
    FR: 'FR',
    SA: 'SA',
    SU: 'SU'
};
const $1079d16957e265b2$export$f62540a8bebc4ed3 = 'BEGIN';
const $1079d16957e265b2$export$32239d68d9c6cb49 = 'END';
const $1079d16957e265b2$export$67de00e87412dc6f = 'BEGIN:VEVENT';
const $1079d16957e265b2$export$987d86d2e891c4cb = 'END:VEVENT';
const $1079d16957e265b2$export$fd1a0e011a586e26 = 'DTSTART';
const $1079d16957e265b2$export$d86ed937a45b0291 = 'RRULE';
const $1079d16957e265b2$export$913055729e1380b2 = 'SUMMARY';
const $1079d16957e265b2$export$87d0ca22edb7493a = 'LOCATION';
const $1079d16957e265b2$export$d44826c816b5619b = 'DESCRIPTION';
const $1079d16957e265b2$export$c8b4a4d253b84ce0 = 'UID';
const $1079d16957e265b2$export$34694f8d8b23ee2a = 'SEQUENCE';
const $1079d16957e265b2$export$e50006273435e7d4 = 'STATUS';
const $1079d16957e265b2$export$36034111438e3f25 = 'TRANSP';
const $1079d16957e265b2$export$bb34f3538ba26c7e = 'PRIORITY';
const $1079d16957e265b2$export$30dbcad954808285 = 'DTEND';
const $1079d16957e265b2$export$bacc88974c736870 = 'DURATION';
const $1079d16957e265b2$export$da3a32b38cbf59ba = 'ATTACH';
const $1079d16957e265b2$export$5e0bdf8bba8d5088 = 'ATTENDEE';
const $1079d16957e265b2$export$a513ea61a7bee91c = 'CATEGORIES';
const $1079d16957e265b2$export$a29989082612d0d9 = 'COMMENT';
const $1079d16957e265b2$export$11038cc09fdccb91 = 'CONTACT';
const $1079d16957e265b2$export$133ffe3c8efbf133 = 'EXDATE';
const $1079d16957e265b2$export$7e27a94778a9d7d7 = 'EXRULE';
const $1079d16957e265b2$export$3d166b1dacd2503a = 'RDATE';
const $1079d16957e265b2$export$47a1d4cd38dddc05 = 'RELATED-TO';
const $1079d16957e265b2$export$4e841128923ef26 = 'RESOURCES';
const $1079d16957e265b2$export$1c0dd28c42f2741e = 'RECURRENCE-ID';
const $1079d16957e265b2$export$61abde59b50deb8e = 'URL';
const $1079d16957e265b2$export$ff39ebd4bb12b718 = 'CREATED';
const $1079d16957e265b2$export$2ebcefe61501d5fe = 'DTSTAMP';
const $1079d16957e265b2$export$90812500f628da64 = 'LAST-MODIFIED';
const $1079d16957e265b2$export$5409f4c14bda7ac = 'ORGANIZER';
const $1079d16957e265b2$export$9fe99b3b71be9378 = 'REQUEST-STATUS';
const $1079d16957e265b2$export$98eba4d8ff00c139 = {
    BEGIN: $1079d16957e265b2$export$f62540a8bebc4ed3,
    END: $1079d16957e265b2$export$32239d68d9c6cb49,
    BEGIN_VEVENT: $1079d16957e265b2$export$67de00e87412dc6f,
    END_VEVENT: $1079d16957e265b2$export$987d86d2e891c4cb,
    SUMMARY: $1079d16957e265b2$export$913055729e1380b2,
    LOCATION: $1079d16957e265b2$export$87d0ca22edb7493a,
    DESCRIPTION: $1079d16957e265b2$export$d44826c816b5619b,
    UID: $1079d16957e265b2$export$c8b4a4d253b84ce0,
    SEQUENCE: $1079d16957e265b2$export$34694f8d8b23ee2a,
    STATUS: $1079d16957e265b2$export$e50006273435e7d4,
    TRANSP: $1079d16957e265b2$export$36034111438e3f25,
    PRIORITY: $1079d16957e265b2$export$bb34f3538ba26c7e,
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291,
    DTEND: $1079d16957e265b2$export$30dbcad954808285,
    DURATION: $1079d16957e265b2$export$bacc88974c736870,
    ATTACH: $1079d16957e265b2$export$da3a32b38cbf59ba,
    ATTENDEE: $1079d16957e265b2$export$5e0bdf8bba8d5088,
    CATEGORIES: $1079d16957e265b2$export$a513ea61a7bee91c,
    COMMENT: $1079d16957e265b2$export$a29989082612d0d9,
    CONTACT: $1079d16957e265b2$export$11038cc09fdccb91,
    EXDATE: $1079d16957e265b2$export$133ffe3c8efbf133,
    EXRULE: $1079d16957e265b2$export$7e27a94778a9d7d7,
    RDATE: $1079d16957e265b2$export$3d166b1dacd2503a,
    RELATED_TO: $1079d16957e265b2$export$47a1d4cd38dddc05,
    RESOURCES: $1079d16957e265b2$export$4e841128923ef26,
    RECURRENCE_ID: $1079d16957e265b2$export$1c0dd28c42f2741e,
    URL: $1079d16957e265b2$export$61abde59b50deb8e,
    CREATED: $1079d16957e265b2$export$ff39ebd4bb12b718,
    DTSTAMP: $1079d16957e265b2$export$2ebcefe61501d5fe,
    LAST_MODIFIED: $1079d16957e265b2$export$90812500f628da64,
    ORGANIZER: $1079d16957e265b2$export$5409f4c14bda7ac,
    REQUEST_STATUS: $1079d16957e265b2$export$9fe99b3b71be9378
};
const $1079d16957e265b2$export$38b1323f325ffd22 = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    RRULE: $1079d16957e265b2$export$d86ed937a45b0291
};
const $1079d16957e265b2$export$5b9a78912028c06d = 'TZID';
const $1079d16957e265b2$export$20184b745430719e = {
    DTSTART: $1079d16957e265b2$export$fd1a0e011a586e26,
    TZID: $1079d16957e265b2$export$5b9a78912028c06d
};
const $1079d16957e265b2$export$fb124b4fa837b262 = 'FREQ';
const $1079d16957e265b2$export$4cc4f35131ed029c = 'UNTIL';
const $1079d16957e265b2$export$7dea0e6e08f87a8a = 'INTERVAL';
const $1079d16957e265b2$export$a764ed9c4884f76d = 'BYHOUR';
const $1079d16957e265b2$export$7a96578de7a037b6 = 'BYMINUTE';
const $1079d16957e265b2$export$55bcca3bd8d3041f = 'BYSECOND';
const $1079d16957e265b2$export$f512ea3e90612d03 = 'BYDAY';
const $1079d16957e265b2$export$b3203f635d74ce88 = 'BYMONTH';
const $1079d16957e265b2$export$15623ad945e92c4c = 'BYMONTHDAY';
const $1079d16957e265b2$export$7898bd020dba0a27 = {
    FREQ: $1079d16957e265b2$export$fb124b4fa837b262,
    UNTIL: $1079d16957e265b2$export$4cc4f35131ed029c,
    INTERVAL: $1079d16957e265b2$export$7dea0e6e08f87a8a,
    BYHOUR: $1079d16957e265b2$export$a764ed9c4884f76d,
    BYMINUTE: $1079d16957e265b2$export$7a96578de7a037b6,
    BYSECOND: $1079d16957e265b2$export$55bcca3bd8d3041f,
    BYDAY: $1079d16957e265b2$export$f512ea3e90612d03,
    BYMONTH: $1079d16957e265b2$export$b3203f635d74ce88,
    BYMONTHDAY: $1079d16957e265b2$export$15623ad945e92c4c
};
const $1079d16957e265b2$export$64c81710c321f252 = 'MISSING';
const $1079d16957e265b2$export$ccb33e29d92c9a58 = 'EMPTY';
const $1079d16957e265b2$export$9a105a556e65c2c0 = 'INVALID';
const $1079d16957e265b2$export$f3abe3d006c81602 = 'VALID';

});

parcelRegister("5D9Ji", function(module, exports) {

$parcel$export(module.exports, "default", () => $f056e68da25dd6c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f056e68da25dd6c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    formTitle: {
        "id": "recur-work-item.form-title",
        "defaultMessage": "Set to recur"
    },
    saveButtonText: {
        "id": "recur-work-item.save-button-text",
        "defaultMessage": "Save"
    },
    cancelButtonText: {
        "id": "recur-work-item.cancel-button-text",
        "defaultMessage": "Cancel"
    },
    deleteButtonText: {
        "id": "recur-work-item.delete-button-text",
        "defaultMessage": "Delete"
    },
    recurFieldsLabel: {
        "id": "recur-work-item.recur-fields-label",
        "defaultMessage": "Recur"
    },
    setToRecur: {
        "id": "recur-work-item.set-to-recur",
        "defaultMessage": "Set to recur"
    },
    recursDaily: {
        "id": "recur-work-item.recurs-daily",
        "defaultMessage": "Recurs daily"
    },
    recursEveryWeekday: {
        "id": "recur-work-item.recurs-every-weekday",
        "defaultMessage": "Every weekday (Monday to Friday)"
    },
    recursWeekly: {
        "id": "recur-work-item.recurs-weekly",
        "defaultMessage": "Recurs weekly"
    },
    recursEveryTwoWeeks: {
        "id": "recur-work-item.recurs-every-two-weeks",
        "defaultMessage": "Recurs every 2 weeks"
    },
    recursOnComplete: {
        "id": "recur-work-item.recurs-on-complete",
        "defaultMessage": "Recurs when completed"
    },
    successFlagTitleRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "{issueKey} recurs every week"
    },
    successFlagTitleRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteDaily: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-daily",
        "defaultMessage": "This {issueType} recurs daily when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekday: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekday",
        "defaultMessage": "This {issueType} recurs every weekday when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteWeekly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-weekly",
        "defaultMessage": "This {issueType} recurs weekly on {weekDayNames} when completed"
    },
    successFlagDescriptionRecurOnScheduleIfCompleteFortnightly: {
        "id": "recur-work-item.success-flag-description-recur-on-schedule-if-complete-fortnightly",
        "defaultMessage": "This {issueType} recurs every 2 weeks on {weekDayNames} when completed"
    },
    successFlagTitleRecurOnScheduleDaily: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-daily",
        "defaultMessage": "{issueKey} recurs every day"
    },
    successFlagTitleRecurOnScheduleWeekday: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekday",
        "defaultMessage": "{issueKey} recurs every weekday"
    },
    successFlagTitleRecurOnScheduleWeekly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-weekly",
        "defaultMessage": "{issueKey} recurs every week on {weekDayNames}"
    },
    successFlagTitleRecurOnScheduleFortnightly: {
        "id": "recur-work-item.success-flag-title-recur-on-schedule-fortnightly",
        "defaultMessage": "{issueKey} recurs every 2 weeks on {weekDayNames}"
    },
    goBackLabel: {
        "id": "recur-work-item.go-back-label",
        "defaultMessage": "Go back"
    },
    errorFlagReloadPageButton: {
        "id": "recur-work-item.error-flag-reload-page-button",
        "defaultMessage": "Reload page"
    },
    errorFlagDescription: {
        "id": "recur-work-item.error-flag-description",
        "defaultMessage": "If this keeps happening, share this information with your admin, who should <link>contact support</link>."
    },
    errorFlagTitle: {
        "id": "recur-work-item.error-flag-title",
        "defaultMessage": "Something went wrong on our end"
    }
});

});



parcelRegister("l9xxv", function(module, exports) {

$parcel$export(module.exports, "setAsNonRecurringIssue", () => $867e9b1c0261db63$export$7b76980c59e9a391);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $lQupu = parcelRequire("lQupu");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");
const $867e9b1c0261db63$export$7b76980c59e9a391 = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, skipDeletingIssueProperties: skipDeletingIssueProperties = false })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { issueProperties: issueProperties, errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        // this can't be !automationRuleUuid because recur-on-complete rules won't have an
        // automationRuleUuid, but they will have issueProperties
        if (!issueProperties) {
            const error = new Error('User is trying to delete a rule before the rule data has been stored.');
            setState({
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (!isSiteAdmin && !isProjectAdmin && !isRuleOwner) {
            const error = new Error('User does not have permission to set issue as non-recurring.');
            setState({
                // TODO: decide if we want to be appending to this list or overwriting it
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId, recurOnScheduleConfig: recurOnScheduleConfig } = issueProperties;
        if (skipDeletingIssueProperties && !ruleUuid) // nothing to do
        return;
        setState({
            isDeletingRule: true
        });
        const analyticsEvent = createAnalyticsEvent({});
        // delete or disable the rule if we know the rule UUID
        if (ruleUuid) try {
            if (isRuleOwner || isSiteAdmin) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'deleteRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule deleted', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            } else {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.disableRule)({
                    environment: environment,
                    cloudId: cloudId,
                    projectId: projectId,
                    ruleUuid: ruleUuid
                }), 'disableRule');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule disabled', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: ruleUuid,
                    templateId: templateId,
                    recurCondition: recurOnScheduleConfig?.recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
            }
        } catch (error) {
            // abort if the rule cannot be deleted/disabled
            setState({
                isDeletingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
        if (skipDeletingIssueProperties) {
            // we only get here if we've successfully deleted/disabled a recur-on-schedule rule.
            // it's not possible to re-enable disabled rules, so we can assume that the rule will
            // no longer generate future work items. this means that the issue's issue properties
            // are no longer important to store.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
            return;
        }
        try {
            await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $fAJ3G.deleteIssueProperties)({
                issueKey: issueKey
            }), 'deleteIssueProperties');
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE)
            });
        } catch (error) {
            if (!ruleUuid) {
                // in this case, we haven't deleted or disabled the rule, so the rule can still generate
                // future work items. we leave the rule stored in state unchanged and rethrow the error.
                setState({
                    isDeletingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
                throw error;
            }
            // don't rethrow because from the user's perspective, the work item is no longer recurring.
            setState({
                isDeletingRule: false,
                ...(0, $lQupu.NO_RULE_PARTIAL_STATE),
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
        }
    };

});
parcelRegister("lQupu", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $6bdecc95b0135cf9$export$36d128238e6b60f5);
$parcel$export(module.exports, "NO_RULE_PARTIAL_STATE", () => $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70);
const $6bdecc95b0135cf9$export$36d128238e6b60f5 = {
    hasFetched: false,
    isFetching: false,
    isCreatingRule: false,
    isDeletingRule: false,
    isUpdatingRule: false,
    errors: null,
    hasBootstrapError: false,
    isRuleOwner: null,
    issueProperties: null
};
const $6bdecc95b0135cf9$export$a1b15f9b9ceb0f70 = {
    isRuleOwner: null,
    issueProperties: null
};

});


parcelRegister("bvhsR", function(module, exports) {

$parcel$export(module.exports, "setAsRecurringIssue", () => $fe7808073e642503$export$5d9cc8e9f9314f21);

var $7Jxgt = parcelRequire("7Jxgt");

var $8zOmE = parcelRequire("8zOmE");

var $cS75I = parcelRequire("cS75I");

var $ahBjy = parcelRequire("ahBjy");

var $519t2 = parcelRequire("519t2");
const $fe7808073e642503$export$5d9cc8e9f9314f21 = ({ recurOnScheduleConfig: { rRule: rRule, recurCondition: recurCondition, dueDateOffsetSmartValue: dueDateOffsetSmartValue } })=>async ({ setState: setState, getState: getState }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey, environment: environment, cloudId: cloudId, projectId: projectId })=>{
        const { errors: errors, isUpdatingRule: isUpdatingRule } = getState();
        setState({
            isCreatingRule: true
        });
        const recurrenceToken = (0, $7Jxgt.v4)();
        const templateId = (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2);
        const analyticsEvent = createAnalyticsEvent({});
        try {
            const createTemplateResponse = await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.createTemplate)({
                environment: environment,
                cloudId: cloudId,
                projectId: projectId,
                recurrenceToken: recurrenceToken,
                recurCondition: recurCondition,
                rRule: rRule,
                dueDateOffsetSmartValue: dueDateOffsetSmartValue
            }), 'createTemplate');
            if (createTemplateResponse?.ruleUuid) {
                await (0, $519t2.callServiceWithAnalytics)(analyticsEvent, (0, $cS75I.setIssueProperties)({
                    issueKey: issueKey,
                    recurrenceToken: recurrenceToken,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    recurCondition: recurCondition,
                    rRule: rRule,
                    templateId: templateId,
                    dueDateOffsetSmartValue: dueDateOffsetSmartValue
                }), 'setIssueProperties');
                (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'recurringRule created', {
                    issueKey: // TODO: add ruleId attribute
                    issueKey,
                    ruleUuid: createTemplateResponse.ruleUuid,
                    templateId: templateId,
                    recurCondition: recurCondition,
                    isUpdateForExistingRule: isUpdatingRule
                });
                const issueProperties = {
                    automationRuleUuid: createTemplateResponse.ruleUuid,
                    token: recurrenceToken,
                    templateId: templateId,
                    recurOnScheduleConfig: {
                        rRule: rRule,
                        dueDateOffsetSmartValue: dueDateOffsetSmartValue,
                        recurCondition: recurCondition
                    }
                };
                setState({
                    isCreatingRule: false,
                    issueProperties: issueProperties,
                    isRuleOwner: true
                });
            } else throw new Error('New rule failed to be created.');
        } catch (error) {
            setState({
                isCreatingRule: false,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                errors: [
                    ...errors ?? [],
                    error
                ]
            });
            throw error;
        }
    };

});
parcelRegister("cS75I", function(module, exports) {

$parcel$export(module.exports, "createTemplate", () => $d425ed86c31f35f6$export$7b7ae612b60e1630);
$parcel$export(module.exports, "setIssueProperties", () => $d425ed86c31f35f6$export$5153917efea4a83d);

var $j5YhT = parcelRequire("j5YhT");

var $c5wox = parcelRequire("c5wox");

var $eusud = parcelRequire("eusud");

var $ahBjy = parcelRequire("ahBjy");
const $d425ed86c31f35f6$export$7b7ae612b60e1630 = async ({ environment: environment, cloudId: cloudId, projectId: projectId, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const automationStack = await (0, $c5wox.getAutomationStack)(environment, cloudId);
    const CREATE_TEMPLATE_URL = `/gateway/api/automation/internal-api/jira/${cloudId}/${automationStack}/public/rest/v1/template/create`;
    const ruleHomeARI = (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: String(projectId)
    });
    const payload = {
        ruleHome: ruleHomeARI,
        templateId: (0, $ahBjy.SOFTWARE_END_USER_TEMPLATE_2),
        parameters: {
            recurrenceToken: {
                value: recurrenceToken,
                type: 'TEXT'
            },
            rRule: {
                value: rRule,
                type: 'TEXT'
            },
            dueDateOffsetSmartValue: {
                value: dueDateOffsetSmartValue,
                type: 'TEXT'
            },
            recurCondition: {
                value: recurCondition,
                type: 'TEXT'
            }
        }
    };
    return (0, $eusud.performPostRequest)(CREATE_TEMPLATE_URL, {
        body: JSON.stringify(payload)
    });
};
const $d425ed86c31f35f6$export$5153917efea4a83d = async ({ issueKey: issueKey, ruleUuid: ruleUuid, recurrenceToken: recurrenceToken, recurCondition: recurCondition, rRule: rRule, templateId: templateId, dueDateOffsetSmartValue: dueDateOffsetSmartValue })=>{
    const issuePropertiesEndpoint = `/rest/api/2/issue/${issueKey}/properties/recurrence-config`;
    const requestBody = {
        automationRuleUuid: ruleUuid,
        token: recurrenceToken,
        templateId: templateId,
        recurOnScheduleConfig: {
            rRule: rRule,
            dueDateOffsetSmartValue: dueDateOffsetSmartValue,
            recurCondition: recurCondition
        }
    };
    return (0, $eusud.performPutRequest)(issuePropertiesEndpoint, {
        body: JSON.stringify(requestBody)
    });
};

});


parcelRegister("c8g0F", function(module, exports) {

$parcel$export(module.exports, "updateRule", () => $257e932348ccd8c0$export$b2ebf395d72c5a4c);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $8zOmE = parcelRequire("8zOmE");

var $fAJ3G = parcelRequire("fAJ3G");

var $519t2 = parcelRequire("519t2");

var $bvhsR = parcelRequire("bvhsR");

var $l9xxv = parcelRequire("l9xxv");
const $257e932348ccd8c0$export$b2ebf395d72c5a4c = ({ isProjectAdmin: isProjectAdmin, isRuleOwner: isRuleOwner, isSiteAdmin: isSiteAdmin, recurOnScheduleConfig: recurOnScheduleConfig })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { createAnalyticsEvent: createAnalyticsEvent, issueKey: issueKey })=>{
        const { issueProperties: issueProperties, errors: errors } = getState();
        if (!issueProperties) {
            // if there is no existing rule, then create a new rule and update issue properties
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            return;
        }
        const { automationRuleUuid: ruleUuid, templateId: templateId } = issueProperties;
        setState({
            isUpdatingRule: true
        });
        try {
            await dispatch((0, $l9xxv.setAsNonRecurringIssue)({
                isProjectAdmin: isProjectAdmin,
                isRuleOwner: isRuleOwner,
                isSiteAdmin: isSiteAdmin,
                // we'll update issue properties later
                skipDeletingIssueProperties: true
            }));
        } catch (error) {
            // don't need to save the error to state because setAsNonRecurringIssue should already do this
            setState({
                isUpdatingRule: false
            });
            throw error;
        }
        // create the new rule
        try {
            await dispatch((0, $bvhsR.setAsRecurringIssue)({
                recurOnScheduleConfig: recurOnScheduleConfig
            }));
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'recurringRule updated', {
                issueKey: // TODO: add ruleId attribute
                issueKey,
                ruleUuid: ruleUuid,
                templateId: templateId,
                recurCondition: recurOnScheduleConfig?.recurCondition,
                isUpdateForExistingRule: true
            });
            setState({
                isUpdatingRule: false
            });
        } catch (error) {
            // if we fail to create the rule and update issue properties, then we need to go back and remove the
            // original recurring rule config from issue properties
            try {
                setState({
                    isDeletingRule: true
                });
                await (0, $519t2.callServiceWithAnalytics)(createAnalyticsEvent({}), (0, $fAJ3G.deleteIssueProperties)({
                    issueKey: issueKey
                }), 'deleteIssueProperties');
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    issueProperties: null,
                    isRuleOwner: null,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error
                    ]
                });
            } catch (anotherError) {
                // we've made no changes to the rule config since we called `setAsNonRecurringIssue` above,
                // so we don't need to update ruleSummary or issueProperties.
                setState({
                    isDeletingRule: false,
                    isUpdatingRule: false,
                    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    errors: [
                        ...errors ?? [],
                        error,
                        anotherError
                    ]
                });
                throw anotherError;
            }
            // we've just successfully deleted the existing rule; we haven't actually created a new one.
            throw error;
        }
    };

});



parcelRegister("CKlOf", function(module, exports) {

$parcel$export(module.exports, "messages", () => $d9e9728e1365538b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $d9e9728e1365538b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    overdue: {
        "id": "business.list.ui.list-view.date-cell.overdue",
        "defaultMessage": "Overdue since {date}"
    },
    due: {
        "id": "business.list.ui.list-view.date-cell.due",
        "defaultMessage": "Due on {date}"
    }
});

});


parcelRegister("8uZt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $72d11d6903be96d2$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $3fesp = parcelRequire("3fesp");

var $9ADwJ = parcelRequire("9ADwJ");

var $dC5iT = parcelRequire("dC5iT");

var $dCm1o = parcelRequire("dCm1o");

var $6OCZm = parcelRequire("6OCZm");

const $72d11d6903be96d2$var$renderIcon = (type)=>{
    switch(type){
        case 0, $6d6eac2504286faf$export$3b43f1ca008dad23:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.ChildIssuesGlyph), null);
        case 0, $6d6eac2504286faf$export$aac403da0d127706:
            return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ADwJ))), {
                color: "var(--ds-icon-danger, #C9372C)",
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.FlagGlyph), null);
        case 0, $6d6eac2504286faf$export$540a31b23d6b9abd:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.CheckGlyph), null);
        case 0, $6d6eac2504286faf$export$352da558a3a09227:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.UploadGlyph), null);
        case 0, $6d6eac2504286faf$export$178cb2e5b5fc68e8:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketBranchesGlyph), null);
        case 0, $6d6eac2504286faf$export$a153e0417183b79:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketCommitsGlyph), null);
        case 0, $6d6eac2504286faf$export$555f9a88a8c5f309:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.BitbucketPullrequestsGlyph), null);
        case 0, $6d6eac2504286faf$export$82a1ca282cb5e4e5:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.EmojiFrequentGlyph), null);
        case 0, $6d6eac2504286faf$export$423cd243bf1888bc:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.MoreGlyph), null);
        case 0, $6d6eac2504286faf$export$30a9be92cbb6f382:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.PersonGlyph), null);
        case 0, $6d6eac2504286faf$export$d4ee7b46933c494f:
            return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                paddingInlineEnd: "space.050",
                paddingBlock: "space.025"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3fesp))), {
                label: "",
                color: "currentColor"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OCZm.DueDateGlyph), null);
        default:
            throw Error(`Invalid Icon type - ${type}`);
    }
};
const $72d11d6903be96d2$var$CardIcon = (props)=>{
    const { label: label, primaryColor: primaryColor, type: type } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($72d11d6903be96d2$var$Container, {
        role: "img",
        "aria-label": label,
        primaryColor: primaryColor
    }, $72d11d6903be96d2$var$renderIcon(type));
};
var $72d11d6903be96d2$export$2e2bcd8739ae039 = $72d11d6903be96d2$var$CardIcon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $72d11d6903be96d2$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { primaryColor: primaryColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_yk4yla": (0, $lD23V.default)(__cmplp.primaryColor || undefined)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _1o9zidpf _vwz4kb7n _1veoyfq0 _1ksv19wz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9ADwJ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::88c1f65a7c2db6559a42eb4e9e9ef8e7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6fb6230d529aad86$var$_react = $6fb6230d529aad86$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6fb6230d529aad86$var$_baseNew = $6fb6230d529aad86$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6fb6230d529aad86$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "FlagFilled".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: active feature flags.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6fb6230d529aad86$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $6fb6230d529aad86$var$_react.default.createElement($6fb6230d529aad86$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 1.75A.75.75 0 0 1 2.75 1H14a.75.75 0 0 1 .6 1.2l-2.662 3.55L14.6 9.3a.75.75 0 0 1-.6 1.2H3.5V15H2z" clip-rule="evenodd"/>`
    }, props));
$6fb6230d529aad86$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $6fb6230d529aad86$var$_default = module.exports.default = $6fb6230d529aad86$var$FlagFilledIcon;

});

parcelRegister("6OCZm", function(module, exports) {

$parcel$export(module.exports, "ChildIssuesGlyph", () => $9f38e13816957edc$export$e45c85830644abc5);
$parcel$export(module.exports, "FlagGlyph", () => $9f38e13816957edc$export$cef8dc8280f1c02c);
$parcel$export(module.exports, "CheckGlyph", () => $9f38e13816957edc$export$50963481dc57ac5c);
$parcel$export(module.exports, "UploadGlyph", () => $9f38e13816957edc$export$330e95d855f0ff0);
$parcel$export(module.exports, "BitbucketBranchesGlyph", () => $9f38e13816957edc$export$5aa1ec710367c05);
$parcel$export(module.exports, "BitbucketCommitsGlyph", () => $9f38e13816957edc$export$4f751361dc2785a8);
$parcel$export(module.exports, "BitbucketPullrequestsGlyph", () => $9f38e13816957edc$export$314907f846d12b79);
$parcel$export(module.exports, "EmojiFrequentGlyph", () => $9f38e13816957edc$export$e6da30a8001300c0);
$parcel$export(module.exports, "MoreGlyph", () => $9f38e13816957edc$export$f291c054d6e2e898);
$parcel$export(module.exports, "PersonGlyph", () => $9f38e13816957edc$export$b59bd42a398a2b3c);
$parcel$export(module.exports, "DueDateGlyph", () => $9f38e13816957edc$export$45e4820251213456);

var $5uXOq = parcelRequire("5uXOq");
const $9f38e13816957edc$export$e45c85830644abc5 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 7h2v5h-2zm5 6h2v3h-2zM6 13h2v3H6z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7 11h10a1 1 0 011 1v1H6v-1a1 1 0 011-1z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5 18v1h4v-1H5zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2H5a2 2 0 01-2-2v-1a2 2 0 012-2zm10 2v1h4v-1h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2v-1a2 2 0 012-2zM10 5v1h4V5h-4zm0-2h4a2 2 0 012 2v1a2 2 0 01-2 2h-4a2 2 0 01-2-2V5a2 2 0 012-2z",
        fillRule: "nonzero"
    })));
const $9f38e13816957edc$export$cef8dc8280f1c02c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.73 5.73 0 002.547-.567 1 1 0 00.563-.9V5.466a.998.998 0 00-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 006 5.466v6.769z",
        fill: "currentColor"
    }));
const $9f38e13816957edc$export$50963481dc57ac5c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6.735 12.322a1 1 0 00-1.47 1.356l3.612 3.919c.537.526 1.337.526 1.834.03l.364-.359a2335.638 2335.638 0 003.939-3.883l.04-.04a492.598 492.598 0 003.658-3.643 1 1 0 00-1.424-1.404 518.42 518.42 0 01-3.64 3.625l-.04.04a2049.114 2049.114 0 01-3.775 3.722l-3.098-3.363z",
        fill: "currentColor"
    }));
const $9f38e13816957edc$export$330e95d855f0ff0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.208 9.32L9.29 11.253a1 1 0 000 1.409.982.982 0 001.397 0l1.29-1.301 1.336 1.347a.982.982 0 001.397.001 1.002 1.002 0 00.001-1.408l-1.965-1.98a1.08 1.08 0 00-1.538-.001z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11 10.007l.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.938 5.481a4.8 4.8 0 00-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 014.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481z"
    })));
const $9f38e13816957edc$export$5aa1ec710367c05 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M19 11c0 1.3-.8 2.4-2 2.8V15c0 2.2-1.8 4-4 4h-2.2c-.4 1.2-1.5 2-2.8 2-1.7 0-3-1.3-3-3 0-1.3.8-2.4 2-2.8V8.8C5.9 8.4 5 7.3 5 6c0-1.7 1.3-3 3-3s3 1.3 3 3c0 1.3-.8 2.4-2.1 2.8v6.4c.9.3 1.6.9 1.9 1.8H13c1.1 0 2-.9 2-2v-1.2c-1.2-.4-2-1.5-2-2.8 0-1.7 1.3-3 3-3s3 1.3 3 3zM8 5c-.5 0-1 .4-1 1s.4 1 1 1 1-.4 1-1-.4-1-1-1zm8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1zm-8 7c.6 0 1-.4 1-1s-.4-1-1-1-1 .4-1 1 .4 1 1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$4f751361dc2785a8 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 12c0-1.9-1.3-3.4-3-3.9V4c0-.6-.4-1-1-1s-1 .4-1 1v4.1c-1.7.4-3 2-3 3.9s1.3 3.4 3 3.9V20c0 .6.4 1 1 1s1-.4 1-1v-4.1c1.7-.5 3-2 3-3.9zm-4 2c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$314907f846d12b79 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1-.3-.3-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2s.4-.1.6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8zM17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1zM7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3zm0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$e6da30a8001300c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "16",
        width: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8zm0 14.222A6.23 6.23 0 015.778 12 6.23 6.23 0 0112 5.778 6.23 6.23 0 0118.222 12 6.23 6.23 0 0112 18.222zm.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.891.891 0 001.257 0 .891.891 0 000-1.256l-1.942-1.943z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $9f38e13816957edc$export$f291c054d6e2e898 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "5",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "12",
        cy: "12",
        r: "2"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "19",
        cy: "12",
        r: "2"
    })));
const $9f38e13816957edc$export$b59bd42a398a2b3c = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        height: "24",
        width: "24",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M6 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0V14z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("circle", {
        cx: "12",
        cy: "7",
        r: "4"
    })));
const $9f38e13816957edc$export$45e4820251213456 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "0 0 24 24",
        role: "presentation"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M4.995 5h14.01C20.107 5 21 5.895 21 6.994v12.012A1.994 1.994 0 0119.005 21H4.995A1.995 1.995 0 013 19.006V6.994C3 5.893 3.892 5 4.995 5zM5 9v9a1 1 0 001 1h12a1 1 0 001-1V9H5zm1-5a1 1 0 012 0v1H6V4zm10 0a1 1 0 012 0v1h-2V4zm-9 9v-2.001h2V13H7zm8 0v-2.001h2V13h-2zm-4 0v-2.001h2.001V13H11zm-4 4v-2h2v2H7zm4 0v-2h2.001v2H11zm4 0v-2h2v2h-2z",
        fill: "currentColor",
        fillRule: "evenodd"
    }));

});

const $6d6eac2504286faf$export$3b43f1ca008dad23 = 'child-issues';
const $6d6eac2504286faf$export$aac403da0d127706 = 'flag';
const $6d6eac2504286faf$export$540a31b23d6b9abd = 'tick';
const $6d6eac2504286faf$export$352da558a3a09227 = 'upload';
const $6d6eac2504286faf$export$178cb2e5b5fc68e8 = 'bitbucket-branches';
const $6d6eac2504286faf$export$a153e0417183b79 = 'bitbucket-commits';
const $6d6eac2504286faf$export$555f9a88a8c5f309 = 'bitbucket-pullrequests';
const $6d6eac2504286faf$export$82a1ca282cb5e4e5 = 'emoji-frequent';
const $6d6eac2504286faf$export$423cd243bf1888bc = 'more';
const $6d6eac2504286faf$export$30a9be92cbb6f382 = 'person';
const $6d6eac2504286faf$export$d4ee7b46933c494f = 'due-date';


parcelRegister("eDs1Y", function(module, exports) {

$parcel$export(module.exports, "messages", () => $9d2a4fa84ab79be6$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $9d2a4fa84ab79be6$export$593a022a1631ee1e = 'Due Date: ';
const $9d2a4fa84ab79be6$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    text: {
        "id": "due-date.text",
        "defaultMessage": "Due Date: {date}"
    }
});

});




parcelRegister("4cYhQ", function(module, exports) {

$parcel$export(module.exports, "Action", () => $9022cae0997d5594$export$e19cd5f9376f8cee);
$parcel$export(module.exports, "ActionSubject", () => $9022cae0997d5594$export$7f97440769de1377);
$parcel$export(module.exports, "AnalyticsEvent", () => $9022cae0997d5594$export$30b7662faa307ee);
$parcel$export(module.exports, "ToggleKey", () => $9022cae0997d5594$export$3679582258ad0fad);
$parcel$export(module.exports, "IncrementPlanningAnalyticsKey", () => $9022cae0997d5594$export$75cb7f2b113e0230);
const $9022cae0997d5594$export$e19cd5f9376f8cee = {
    CLICKED: 'clicked',
    CHANGED: 'changed'
};
const $9022cae0997d5594$export$7f97440769de1377 = {
    BUTTON: 'button',
    TOGGLE: 'toggle',
    SELECT: 'select'
};
const $9022cae0997d5594$export$30b7662faa307ee = {
    UI_EVENT: 'UI_EVENT',
    OPERATIONAL_EVENT: 'OPERATIONAL_EVENT',
    TRACK_EVENT: 'TRACK_EVENT'
};
const $9022cae0997d5594$export$3679582258ad0fad = {
    VERSION_PANEL_TOGGLE: 'versionPanel',
    EPIC_PANEL_TOGGLE: 'epicPanel',
    QUICK_FILTERS_TOGGLE: 'quickFilters',
    COMPACT_MODE_TOGGLE: 'compactMode',
    CARD_DENSITY: 'cardDensity',
    SHOW_VERSIONS_TOGGLE: 'showVersions',
    SHOW_EPICS_TOGGLE: 'showEpics',
    SHOW_STATUSES_TOGGLE: 'showStatuses',
    SHOW_ISSUE_TYPE: 'showIssueType',
    SHOW_ISSUE_KEY: 'showIssueKey',
    SHOW_ESTIMATE: 'showEstimate',
    SHOW_PRIORITY: 'showPriority',
    SHOW_DEVELOPMENT: 'showDevelopment',
    SHOW_ASSIGNEE: 'showAssignee',
    SHOW_ISSUE_LINKS_STATS: 'showIssueLinksStats',
    OPEN_ISSUES_IN_SIDEBAR_TOGGLE: 'openIssuesInSidebar',
    SUBTASKS_EXPAND_ALL: 'subtasksExpandAll',
    SUBTASKS_COLLAPSE_ALL: 'subtasksCollapseAll',
    SWIMLANE_EXPAND_ALL: 'swimlaneExpandAll',
    SWIMLANE_COLLAPSE_ALL: 'swimlaneCollapseAll',
    SHOW_DAYS_IN_COLUMN: 'showDaysInColumn',
    SHOW_DUE_DATE: 'showDueDate',
    SHOW_LABELS: 'showLabels',
    SHOW_EXTRA_FIELD: 'showExtraField',
    WORK_SUGGESTIONS_TOGGLE: 'workSuggestions',
    SHOW_CARD_COVERS: 'showCardCovers',
    SHOW_BOARD_NAME: 'showBoardName'
};
const $9022cae0997d5594$export$75cb7f2b113e0230 = {
    UNSCHEDULED_COLUMN_TOGGLE: 'unscheduledColumnToggle',
    ISSUE_IDS_TO_SHOW_DEPENDENCIES: 'issueIdsToShowDependencies',
    SHOW_OFFTRACK_DEPENDENCY_LINES: 'showOfftrackDependencyLines'
};
const $9022cae0997d5594$export$d87506c7d891276d = {
    ...$9022cae0997d5594$export$3679582258ad0fad,
    ...$9022cae0997d5594$export$75cb7f2b113e0230
};

});

parcelRegister("3uPqt", function(module, exports) {

$parcel$export(module.exports, "useSendAnalyticsEvent", () => $2125a8f3d8eb70be$export$4b1735907ca3ab2f);

var $fjcgS = parcelRequire("fjcgS");

var $4cYhQ = parcelRequire("4cYhQ");
const $2125a8f3d8eb70be$export$7d2f3f483d8e6742 = 'viewSettings';
const $2125a8f3d8eb70be$export$4b1735907ca3ab2f = ()=>{
    const sendAnalyticsEvent = (action, actionSubject, eventType, attributes = {}, source)=>{
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
            const analyticsClient = client.getInstance();
            if (!analyticsClient) return Promise.resolve();
            const event = {
                action: action,
                actionSubject: actionSubject,
                actionSubjectId: $2125a8f3d8eb70be$export$7d2f3f483d8e6742,
                attributes: {
                    ...attributes
                },
                source: source
            };
            switch(eventType){
                case (0, $4cYhQ.AnalyticsEvent).UI_EVENT:
                    return analyticsClient.sendUIEvent(event);
                case (0, $4cYhQ.AnalyticsEvent).OPERATIONAL_EVENT:
                    return analyticsClient.sendOperationalEvent(event);
                case (0, $4cYhQ.AnalyticsEvent).TRACK_EVENT:
                    return analyticsClient.sendTrackEvent(event);
                default:
            }
            return undefined;
        });
    };
    return sendAnalyticsEvent;
};

});

const $7ea9780e1aa4575d$export$b5e2b68b0fa7f1c8 = 'INWARD';
const $7ea9780e1aa4575d$export$5dec99d71ec794ba = 'OUTWARD';
const $7ea9780e1aa4575d$export$6cdcf74878b11d34 = 'BOTH';

parcelRegister("2Nvkb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c0c51f151bc35cd$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c0c51f151bc35cd$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.title",
        "defaultMessage": "DEPENDENCIES"
    },
    addDependency: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.add-dependency",
        "defaultMessage": "Add dependency"
    },
    viewAllDependencies: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.view-all-dependencies",
        "defaultMessage": "View all dependencies"
    },
    viewInDependenciesTab: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.view-in-dependencies-tab",
        "defaultMessage": "View in Dependencies tab"
    },
    removeDependency: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.remove-dependency",
        "defaultMessage": "Remove dependency"
    },
    addDependencyKey: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.add-dependency-key",
        "defaultMessage": "Add dependency"
    },
    addDependencyCta: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.add-dependency-cta",
        "defaultMessage": "Add"
    },
    externalIssueLinksDescription: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.external-issue-links-description",
        "defaultMessage": "{externalIssueLinksCount} {externalIssueLinksCount, plural, one {dependency} other {dependencies}} not shown on this board"
    },
    externalIssueLinksTitle: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.external-issue-links-title",
        "defaultMessage": "Not on this board"
    },
    showLinesTitle: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.show-lines-title",
        "defaultMessage": "Show lines"
    },
    unlinkIssues: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.unlink-issues",
        "defaultMessage": "Unlink issues"
    },
    externalIssueLinksDescriptionIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.external-issue-links-description-issue-term-refresh",
        "defaultMessage": "{externalIssueLinksCount} {externalIssueLinksCount, plural, one {dependency} other {dependencies}} not shown on this board"
    },
    labelForShowLinesToggle: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.label-for-show-lines-toggle",
        "defaultMessage": "Changing this toggle will show or hide the dependency lines"
    },
    tooltipForShowLinesToggle: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.tooltip-for-show-lines-toggle",
        "defaultMessage": "Lines only show once an issue has been scheduled."
    },
    offtrackLabel: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.offtrack-label",
        "defaultMessage": "off-track"
    },
    unlinkIssuesIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.unlink-issues-issue-term-refresh",
        "defaultMessage": "Unlink work items"
    },
    tooltipForShowLinesToggleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.flyout.tooltip-for-show-lines-toggle-issue-term-refresh",
        "defaultMessage": "Lines only show once a work item has been scheduled."
    }
});

});


parcelRegister("dlhFx", function(module, exports) {

$parcel$export(module.exports, "default", () => $a40f7ef1d74e6fe9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a40f7ef1d74e6fe9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewDependencyDetails: {
        "id": "software.main.board-container.board.card-container.card.issue-links-indicator.view-dependency-details",
        "defaultMessage": "View dependency details"
    }
});

});


const $e5a504d18c288d62$export$676116062bf0b86c = 'software-board.board-container.board.card-container.card-lite.priority-icon.wrapper';
const $e5a504d18c288d62$export$9b1957b51b1a5a8a = 'software-board.board-container.board.card-container.card-lite.cmp-avatar';
const $e5a504d18c288d62$export$15fb3e7bf3bea766 = 'software-board.board-container.board.card-container.card-lite.tmp-avatar';
const $e5a504d18c288d62$export$eee2e9bddfbbaf6f = 'software-board.board-container.board.card-container.card-lite.dev-status-placeholder';


parcelRegister("ljbvM", function(module, exports) {

$parcel$export(module.exports, "CardWithIcc", () => $93a4914688f2c5a7$export$828bc8c020948a5b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $lFKmC = parcelRequire("lFKmC");

var $MHKc7 = parcelRequire("MHKc7");

var $krmH9 = parcelRequire("krmH9");


var $5rFbt = parcelRequire("5rFbt");

var $2Z6La = parcelRequire("2Z6La");

var $4R6GH = parcelRequire("4R6GH");

var $5X72x = parcelRequire("5X72x");

var $2f454 = parcelRequire("2f454");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $f8Y0z = parcelRequire("f8Y0z");

var $iC4Jt = parcelRequire("iC4Jt");

var $aBTGv = parcelRequire("aBTGv");
const $93a4914688f2c5a7$var$renderRichCardDelay = 200;
const $93a4914688f2c5a7$export$828bc8c020948a5b = (props)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const { entryPointActions: programBoardParentSwitcherEntrypointActions } = (0, $5uXOq.useContext)((0, $krmH9.ProgramBoardParentSwitcherEntrypointContext));
    const iccRef = (0, $aBTGv.useIccRef)();
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isUnscheduledColumn = props.columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID);
    const isIPBoardScheduledColumns = isIPBoard && !isUnscheduledColumn;
    const { initialProjectId: projectId } = (0, $2Z6La.useIccContext)();
    const pendingHoverAction = (0, $5uXOq.useRef)(null);
    const hoverDebounce = (0, $5uXOq.useRef)(null);
    const hasRenderedIcc = (0, $5uXOq.useRef)(false);
    const { isColumnIccEnabled: isColumnIccEnabled, id: id, cardIndex: cardIndex, columnId: columnId, swimlaneId: swimlaneId, isLastSwimlane: isLastSwimlane, children: children = null, onIssueChange: onIssueChange, canShowIccNudge: canShowIccNudge, forceIccRender: forceIccRender, groupParentId: groupParentId, headerRef: headerRef, isScrolling: isScrolling = false } = props;
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const boardStore = (0, $67sX6.useBoardStore)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const shouldRenderCardInPopper = (0, $aBTGv.useShouldRenderCardInPopper)({
        columnId: columnId,
        cardId: id,
        isScrolling: isScrolling
    });
    const isActualIcc = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.shouldRenderIcc)(state, {
            issueId: id
        }));
    const activeInlineEditCardIds = (0, $67sX6.useBoardSelector)((0, $9OPlz.getActiveInlineEditCardIds));
    const isCardInInlineEditing = activeInlineEditCardIds.includes(String(id));
    const isCardActive = (0, $5mTgl.isActiveCardSelector)(boardStore.getState(), {
        issueId: id
    });
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const [isTabFocused, setIsTabFocused] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>()=>{
            // Clean up timer
            if (pendingHoverAction.current != null) clearTimeout(pendingHoverAction.current);
            if ((0, $4R6GH.fg)('render_program_board_card_in_popup')) {
                if (hoverDebounce.current != null) hoverDebounce.current.cancel();
                setIsHovered(false);
                setIsTabFocused(false);
            }
        }, []);
    (0, $5uXOq.useEffect)(()=>{
        // Reset is hovered if the conditions to render card in popper is failed
        if (!shouldRenderCardInPopper && isHovered && (0, $4R6GH.fg)('render_program_board_card_in_popup')) setIsHovered(false);
    }, [
        shouldRenderCardInPopper,
        isHovered
    ]);
    const onKeyboardTab = (0, $5uXOq.useCallback)((event)=>{
        if (isIPBoardScheduledColumns && event.key === 'Tab' && (0, $4R6GH.fg)('render_program_board_card_in_popup')) setIsTabFocused(true);
    }, [
        isIPBoardScheduledColumns
    ]);
    const onMouseOver = (0, $5uXOq.useCallback)(()=>{
        if (isIPBoardScheduledColumns && (0, $4R6GH.fg)('render_program_board_card_in_popup')) setIsTabFocused(false);
        // Set hover state for IP board scheduled columns
        if (shouldRenderCardInPopper && !isHovered && (0, $4R6GH.fg)('render_program_board_card_in_popup')) {
            hoverDebounce.current = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
                setIsHovered(true);
            }, $93a4914688f2c5a7$var$renderRichCardDelay);
            hoverDebounce.current();
        }
        // Early return if card is rich already
        if (isCardActive) return;
        // Delay setting the richActiveCard to avoid unneccessary renders when scrolling or moving the mouse around
        pendingHoverAction.current = setTimeout(()=>{
            dispatch((0, $2f454.setActiveIssueWithIcc)(id));
        }, $93a4914688f2c5a7$var$renderRichCardDelay);
        if (isIPBoard) programBoardParentSwitcherEntrypointActions.load();
    }, [
        id,
        dispatch,
        shouldRenderCardInPopper,
        isHovered,
        isCardActive,
        isIPBoardScheduledColumns,
        programBoardParentSwitcherEntrypointActions,
        isIPBoard
    ]);
    const onFocus = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setActiveIssueWithIcc)(id));
        if (isIPBoard) programBoardParentSwitcherEntrypointActions.load();
    }, [
        dispatch,
        id,
        isIPBoard,
        programBoardParentSwitcherEntrypointActions
    ]);
    const onMouseLeave = (0, $5uXOq.useCallback)(()=>{
        // Clear hover state for IP board scheduled columns
        if (isHovered && (0, $4R6GH.fg)('render_program_board_card_in_popup')) {
            setIsHovered(false);
            if (hoverDebounce.current) {
                hoverDebounce.current.cancel();
                hoverDebounce.current = null;
            }
        }
        const containerElement = containerRef.current;
        if (!containerElement) return;
        // Remove pending setActiveIssueWithIcc if it hasn't already fired
        if (pendingHoverAction.current) {
            clearTimeout(pendingHoverAction.current);
            pendingHoverAction.current = null;
        }
        const activeElement = (0, $aBTGv.getActiveElement)();
        // Ignore event if focused on a child
        if (activeElement instanceof Node && containerElement.contains(activeElement)) return;
        dispatch((0, $2f454.setActiveIssueWithIcc)(null));
    }, [
        containerRef,
        dispatch,
        isHovered
    ]);
    const onBlur = (0, $5uXOq.useCallback)((e)=>{
        const { relatedTarget: relatedTarget } = e;
        if (containerRef.current && relatedTarget instanceof Node && !containerRef.current.contains(relatedTarget)) dispatch((0, $2f454.setActiveIssueWithIcc)(null));
    }, [
        dispatch
    ]);
    if (isActualIcc && !hasRenderedIcc.current) hasRenderedIcc.current = true;
    const canUseIcc = isIPBoard ? !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(id) : typeof id === 'number' && id > 0;
    const iccIntersectingWithHeader = isIPBoard && (0, $aBTGv.isIccIntersectingWithHeader)(headerRef, iccRef, cardIndex === 0);
    const shouldRenderIccAbove = canUseIcc && !iccIntersectingWithHeader && (cardIndex === 0 || forceIccRender || isActualIcc || hasRenderedIcc.current);
    const icc = isColumnIccEnabled && shouldRenderIccAbove ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8Y0z.default), {
        canShowIccNudge: canShowIccNudge,
        columnId: columnId,
        swimlaneId: swimlaneId,
        cardIndex: cardIndex,
        triggerAppearance: (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208),
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error id is string but insertBefore is wanting a number
        insertBefore: id,
        isLastSwimlane: isLastSwimlane,
        onChangeFormVisible: onIssueChange,
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error groupParentId is string but inline-card-create is wanting a number
        groupParentId: groupParentId,
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error projectID expects number but it is number | null
        projectId: projectId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC4Jt.ICCPlaceholder), null);
    // Render card in a popup on mouse hover, or if any of the inline edit is active.
    // Currently we don't support render card in popup on keyboard focus. A ticket in the backlog has been created to support this https://hello.jira.atlassian.cloud/browse/JPO-31230
    const shouldRenderPopper = (0, $5uXOq.useMemo)(()=>{
        const value = shouldRenderCardInPopper && (isHovered && isCardActive || isCardInInlineEditing && !isTabFocused);
        return value;
    }, [
        shouldRenderCardInPopper,
        isHovered,
        isCardActive,
        isCardInInlineEditing,
        isTabFocused
    ]);
    const onIccHover = ()=>{
        setIsHovered(false);
    };
    const ipBoardContent = (0, $4R6GH.fg)('render_program_board_card_in_popup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        ref: iccRef,
        onMouseOver: onIccHover
    }, icc), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5X72x.CardPopper), {
        shouldRenderPopper: shouldRenderPopper
    }, children)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        ref: iccRef
    }, icc), children);
    const boardContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, icc, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93a4914688f2c5a7$var$CardWithICC, {
        "data-testid": "software-board.board-container.board.card-container.card-with-icc",
        onFocus: onFocus,
        onBlur: onBlur,
        onKeyDown: onKeyboardTab,
        ref: containerRef,
        ...!isCMPBoard ? {
            onMouseOver: onMouseOver,
            onMouseLeave: onMouseLeave
        } : {
            onMouseEnter: onMouseOver,
            onMouseLeave: onMouseLeave
        }
    }, isIPBoard ? ipBoardContent : boardContent);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $93a4914688f2c5a7$var$CardWithICC = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _kqswh2mm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("krmH9", function(module, exports) {

$parcel$export(module.exports, "ProgramBoardParentSwitcherEntrypointContext", () => $a4625ad51466f639$export$104724087100de84);
$parcel$export(module.exports, "ProgramBoardParentSwitcherEntrypointContextProvider", () => $a4625ad51466f639$export$7097ef7664dd87da);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $4SC5x = parcelRequire("4SC5x");
const $a4625ad51466f639$export$104724087100de84 = (0, $l37qh.createUseEntryPointContext)();
const $a4625ad51466f639$export$7097ef7664dd87da = ({ children: children })=>{
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $4SC5x.programBoardParentSwitcherEntryPoint), {});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a4625ad51466f639$export$104724087100de84.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("l37qh", function(module, exports) {

$parcel$export(module.exports, "createUseEntryPointContext", () => $6e7e19c2d291c94c$export$41bce2223126846b);

var $5uXOq = parcelRequire("5uXOq");
const $6e7e19c2d291c94c$export$41bce2223126846b = ()=>/*#__PURE__*/ (0, $5uXOq.createContext)({
        entryPointActions: {
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            cancelPreload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            load () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            preload () {},
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            unload () {}
        },
        entryPointReferenceSubject: {
            getValue: ()=>null,
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            subscribe: ()=>()=>{}
        },
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        stopMetric () {}
    });

});

parcelRegister("4SC5x", function(module, exports) {

$parcel$export(module.exports, "programBoardParentSwitcherEntryPoint", () => $132ff5961d221c19$export$16f7c403be76b1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $132ff5961d221c19$export$16f7c403be76b1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2dTTK")), {
        moduleId: "f91ea5b9"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2dTTK", function(module, exports) {

let $19e827dd8198ac49$var$load = (parcelRequire("28QjX"))(4);
module.exports = $19e827dd8198ac49$var$load("klozw").then(()=>parcelRequire('kxY6j'));

});



const $7462c685f739ed5a$export$3789e4b2a10baa2b = 'full';
const $7462c685f739ed5a$export$db1cdb8627b81f84 = 'compact';
const $7462c685f739ed5a$export$aca095bc476d426f = 'simple';
const $7462c685f739ed5a$export$1aad44a7533f8ad8 = 'table_row';
const $7462c685f739ed5a$export$d2f7b3f0efb6e208 = 'hidden';
const $7462c685f739ed5a$export$dda6912361cddac9 = 'visible';
const $7462c685f739ed5a$export$565566e3df4dad53 = 'blur';
const $7462c685f739ed5a$export$806b905ec7df742f = 'enter';
const $7462c685f739ed5a$export$2bb790b9008907b4 = 'escape';
const $7462c685f739ed5a$export$ba9f60edfdf2e66 = 'create_button';
const $7462c685f739ed5a$export$193356664cd84c83 = 255;
const $7462c685f739ed5a$export$f9e3e7ede9ba929d = 500;
const $7462c685f739ed5a$export$e0bc602b327f818b = 'add-issue-type-option';

parcelRegister("5X72x", function(module, exports) {

$parcel$export(module.exports, "CardPopper", () => $b0bb4b2aac42b2d6$export$8a50423467fafbee);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $k8nZq = parcelRequire("k8nZq");

var $gkD4s = parcelRequire("gkD4s");
var $1V7PR = parcelRequire("1V7PR");

var $7pDxf = parcelRequire("7pDxf");
const $b0bb4b2aac42b2d6$var$styles = {
    popperReference: "_1bsb1osq",
    cardContainer: "_bfhkqbzx"
};
const $b0bb4b2aac42b2d6$var$HEIGHT_PADDING = 4;
const $b0bb4b2aac42b2d6$export$8a50423467fafbee = ({ shouldRenderPopper: shouldRenderPopper = true, cardHeight: cardHeight, children: children })=>{
    const triggerRef = (0, $5uXOq.useRef)(null);
    const contentRef = (0, $5uXOq.useRef)(null);
    const contentHeight = contentRef.current?.offsetHeight;
    const triggerHeight = contentHeight ? contentHeight + $b0bb4b2aac42b2d6$var$HEIGHT_PADDING : cardHeight;
    const popperUpdateRef = (0, $5uXOq.useRef)(null);
    const triggerTop = triggerRef.current?.getBoundingClientRect().top;
    (0, $5uXOq.useEffect)(()=>{
        // Update content popper position when trigger position changes, for example when ICC in the same column opens and closes
        const timeoutId = setTimeout(()=>{
            if (popperUpdateRef.current) popperUpdateRef.current();
        }, 100);
        return ()=>clearTimeout(timeoutId);
    }, [
        triggerTop
    ]);
    if (!shouldRenderPopper) return children;
    return /*#__PURE__*/ $5uXOq.createElement((0, $gkD4s.Manager), null, /*#__PURE__*/ $5uXOq.createElement((0, $1V7PR.Reference), null, ({ ref: ref })=>{
        return /*#__PURE__*/ $5uXOq.createElement("div", {
            ref: ref
        }, /*#__PURE__*/ $5uXOq.createElement("div", {
            ref: triggerRef,
            // need to match the height of the card content as it might grow when inline edit is active
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                height: triggerHeight ? `${triggerHeight}px` : 'auto'
            },
            className: (0, $bwpsq.default)([
                $b0bb4b2aac42b2d6$var$styles.popperReference
            ])
        }));
    }), /*#__PURE__*/ $5uXOq.createElement((0, $7pDxf.JiraPopper), {
        messageId: "portfolio-3-plan-increment-common.ui.card-popper.popper",
        messageType: "transactional",
        placement: "bottom-start",
        offset: [
            0,
            -1 * (triggerHeight || 0)
        ],
        // It is intentional to disable preventOverflow and flip modifiers so the card is not repositioned when it's partially outside the viewport
        modifiers: [
            {
                name: 'preventOverflow',
                enabled: false
            },
            {
                name: 'flip',
                enabled: false
            }
        ]
    }, ({ ref: ref, style: style, placement: placement, isReferenceHidden: isReferenceHidden, update: update })=>{
        popperUpdateRef.current = update;
        if (isReferenceHidden) return children;
        const triggerWidth = triggerRef?.current?.offsetWidth;
        return /*#__PURE__*/ $5uXOq.createElement((0, $k8nZq.default), null, /*#__PURE__*/ $5uXOq.createElement("div", {
            ref: ref,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
                ...style,
                // match the width of the trigger element, which will be the column width
                width: triggerWidth ? `${triggerWidth}px` : 'auto'
            },
            "data-placement": placement,
            className: (0, $bwpsq.default)([
                $b0bb4b2aac42b2d6$var$styles.cardContainer
            ])
        }, /*#__PURE__*/ $5uXOq.createElement("div", {
            ref: contentRef
        }, children)));
    }));
};
var $b0bb4b2aac42b2d6$export$2e2bcd8739ae039 = $b0bb4b2aac42b2d6$export$8a50423467fafbee;

});
parcelRegister("7pDxf", function(module, exports) {

$parcel$export(module.exports, "JiraPopper", () => $5dfb0b72e9322fa3$export$23789575ac361b5d);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $4oNEb = parcelRequire("4oNEb");

var $10xFf = parcelRequire("10xFf");

var $jW2j1 = parcelRequire("jW2j1");
const $5dfb0b72e9322fa3$export$23789575ac361b5d = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jW2j1.ChoreographerPopper), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4oNEb.Popper), rest);
};

});
parcelRegister("jW2j1", function(module, exports) {

$parcel$export(module.exports, "ChoreographerPopper", () => $577b12f0a509cc55$export$6077de4a190b560c);
// eslint-disable-next-line jira/restricted/react-component-props

var $4oNEb = parcelRequire("4oNEb");

var $cSWNW = parcelRequire("cSWNW");
const $577b12f0a509cc55$export$6077de4a190b560c = (0, $cSWNW.withChoreographedRender)((0, $4oNEb.Popper));

});



parcelRegister("f8Y0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbf48ee69da288e1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $gJBT6 = parcelRequire("gJBT6");

var $1jWct = parcelRequire("1jWct");

var $3bDjY = parcelRequire("3bDjY");

var $jzjy1 = parcelRequire("jzjy1");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $cE2Qr = parcelRequire("cE2Qr");


var $iXVV6 = parcelRequire("iXVV6");

var $3t5QD = parcelRequire("3t5QD");

var $2QOGE = parcelRequire("2QOGE");

var $67sX6 = parcelRequire("67sX6");

var $gXFr2 = parcelRequire("gXFr2");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $iGszW = parcelRequire("iGszW");

var $iC4Jt = parcelRequire("iC4Jt");

var $1JBgu = parcelRequire("1JBgu");

var $fwQRP = parcelRequire("fwQRP");

var $9fzgs = parcelRequire("9fzgs");
const $bbf48ee69da288e1$export$2f9c4649b3f871a3 = /*#__PURE__*/ (0, $5uXOq.memo)(({ canShowIccNudge: canShowIccNudge, issueHierarchyLevel: // TODO-BOARD-REFACTOR-TYPES: this isn't a type error yet, but this is not set anywhere although it's marked as required
// @ts-expect-error issueHierarchyLevel it was marked as required
issueHierarchyLevel, triggerAppearance: triggerAppearance = (0, $7462c685f739ed5a$export$dda6912361cddac9), triggerAriaLabel: triggerAriaLabel, cardIndex: cardIndex, columnId: columnId, swimlaneId: swimlaneId, groupParentId: groupParentId, isLastSwimlane: isLastSwimlane, onChangeFormVisible: onChangeFormVisible, insertBefore: insertBefore, projectId: projectId, showOnHover: showOnHover, isFooter: isFooter })=>{
    const [showInlineCardCreate, setInlineCardCreateVisibility] = (0, $5uXOq.useState)(false);
    const [isDismissed] = (0, $cE2Qr.useIsDismissed)();
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const firstOpenSwimlaneId = (0, $67sX6.useBoardSelector)((0, $5mTgl.getFirstOpenSwimlaneIdSelector));
    const columnIndex = (0, $67sX6.useBoardSelector)((state)=>(0, $fyeGd.getColumnIndex)(state, columnId));
    const isTheFirstCurrentSwimlaneOpen = swimlaneId === null || firstOpenSwimlaneId === swimlaneId;
    const intl = (0, $koVbs.default)();
    const cardTypes = (0, $67sX6.useBoardSelector)((state)=>{
        if (isIPBoard) return (0, $gXFr2.getIssueTypesForIssueCreation)(state)(projectId).map((issueType)=>({
                ...issueType,
                isDisabled: false
            }));
        return (0, $gXFr2.allowedCardTypesForIccSelector)(state)(columnId, swimlaneId, !!groupParentId);
    });
    const mappedCardTypes = (0, $5uXOq.useMemo)(()=>cardTypes.map((cardType)=>(0, $fwQRP.mapInlineCardCreateCardType)(cardType)), [
        cardTypes
    ]);
    const externalValues = $bbf48ee69da288e1$var$getExternalValues(cardIndex, columnIndex);
    const renderAdditionalTypeSelectOptionContent = (0, $5uXOq.useCallback)((cardType)=>{
        if (!cardType.isDisabled) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: intl.formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $iGszW.default).disabledIssueTypeTooltipIssueTermRefresh : (0, $iGszW.default).disabledIssueTypeTooltip),
            position: "bottom-start"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC4Jt.TooltipIconWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
            spacing: "spacious",
            color: "var(--ds-text-discovery, #5E4DB2)",
            label: ""
        })));
    }, [
        intl
    ]);
    if (mappedCardTypes.length < 1) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iC4Jt.ICCPlaceholder), null);
    const showHiddenCardForNudge = ()=>{
        setInlineCardCreateVisibility(true);
    };
    const hideHiddenCardForNudge = ()=>{
        setInlineCardCreateVisibility(false);
    };
    const canDisplayNudge = (0, $fwQRP.shouldDisplayNudge)({
        isTheFirstCurrentSwimlaneOpen: isTheFirstCurrentSwimlaneOpen,
        triggerAppearance: triggerAppearance,
        canShowIccNudge: canShowIccNudge,
        cardIndex: externalValues.cardIndex,
        isDismissed: isDismissed
    });
    const IconLabel = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.create-button-text.icon-label-v2-issue-term-refresh",
            defaultMessage: "Create"
        }, (formattedMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JBgu.Trigger), {
                onClick: hideHiddenCardForNudge,
                label: typeof formattedMessage[0] === 'string' ? formattedMessage[0] : 'Create'
            })) : ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.create-button-text.icon-label-v2",
            defaultMessage: "Create issue"
        }, (formattedMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1JBgu.Trigger), {
                onClick: hideHiddenCardForNudge,
                label: typeof formattedMessage[0] === 'string' ? formattedMessage[0] : 'Create issue'
            }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issueHierarchyLevel: issueHierarchyLevel
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $2QOGE.BoardKanbanCreateIssueNudgeAsync),
        conditionsToApplyWrapper: canDisplayNudge,
        onShow: showHiddenCardForNudge,
        onHide: hideHiddenCardForNudge,
        attributes: {
            triggerAppearance: triggerAppearance
        }
    }, showInlineCardCreate && triggerAppearance === (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconLabel, null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9fzgs.VisibleIcc), {
        renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
        cardIndex: cardIndex,
        cardTypes: cardTypes,
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error CardType is not compatible with BoardCardType
        mappedCardTypes: mappedCardTypes,
        columnId: columnId,
        groupParentId: groupParentId,
        swimlaneId: swimlaneId,
        triggerAppearance: triggerAppearance,
        triggerAriaLabel: triggerAriaLabel,
        isLastSwimlane: isLastSwimlane,
        insertBefore: insertBefore,
        onChangeFormVisible: onChangeFormVisible,
        showOnHover: showOnHover,
        projectId: projectId,
        isFooter: isFooter
    })));
});
const $bbf48ee69da288e1$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((cardIndex, columnIndex)=>({
        cardIndex: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(cardIndex) ? cardIndex + 1 : null,
        columnIndex: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnIndex) ? columnIndex + 1 : null
    }), (cardIndex, columnIndex)=>`${cardIndex}.${columnIndex}`);
var $bbf48ee69da288e1$export$2e2bcd8739ae039 = (0, $jzjy1.AnalyticsSubject)('issue')($bbf48ee69da288e1$export$2f9c4649b3f871a3);

});
parcelRegister("2QOGE", function(module, exports) {

$parcel$export(module.exports, "BoardKanbanCreateIssueNudgeAsync", () => $98e223871a1aaf15$export$b06df4865174af62);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $98e223871a1aaf15$var$BoardAccordionNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("CeWVM")).then((exportedModule)=>exportedModule.CreateIssueAccordionNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/kanban-onboarding-tour/board-create-issue/index.tsx"
});
const $98e223871a1aaf15$export$b06df4865174af62 = ({ children: children, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$f2fe211acb4aa81a),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$a402f2c11da96cd7)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-kanban-onboarding-create-issues-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98e223871a1aaf15$var$BoardAccordionNudgeLazy, restProps, children)));
$98e223871a1aaf15$export$b06df4865174af62.displayName = 'BoardKanbanCreateIssueNudgeAsync';

});
parcelRegister("CeWVM", function(module, exports) {

let $072f2562452189cc$var$load = (parcelRequire("28QjX"))(4);
module.exports = $072f2562452189cc$var$load("69Jsf").then(()=>parcelRequire('f0wJ8'));

});


parcelRegister("iGszW", function(module, exports) {

$parcel$export(module.exports, "default", () => $8baf230ff450c07d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8baf230ff450c07d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    disabledIssueTypeTooltip: {
        "id": "software.main.board-container.board.inline-card-create.disabled-issue-type-tooltip",
        "defaultMessage": "Due to required fields, this issue type can only be created from the workflow's initial status"
    },
    disabledIccTriggerTooltip: {
        "id": "software.main.board-container.board.inline-card-create.disabled-icc-trigger-tooltip",
        "defaultMessage": "Due to required fields on all issue types, new issues can only be created from the workflow\u2019s initial status"
    },
    disabledIssueTypeTooltipIssueTermRefresh: {
        "id": "software.main.board-container.board.inline-card-create.disabled-issue-type-tooltip-issue-term-refresh",
        "defaultMessage": "Due to required fields, this work type can only be created from the workflow's initial status"
    },
    disabledIccTriggerTooltipIssueTermRefresh: {
        "id": "software.main.board-container.board.inline-card-create.disabled-icc-trigger-tooltip-issue-term-refresh",
        "defaultMessage": "Due to required fields on all work types, new work items can only be created from the workflow\u2019s initial status"
    }
});

});

parcelRegister("iC4Jt", function(module, exports) {

$parcel$export(module.exports, "ICCPlaceholder", () => $86f4dcea1a6cd6d9$export$7418306a16b7f3e6);
$parcel$export(module.exports, "TooltipIconWrapper", () => $86f4dcea1a6cd6d9$export$d8fe6814885155a8);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $86f4dcea1a6cd6d9$export$7418306a16b7f3e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3iftgi _19pkr5cr _2hwxidpf _otyrr5cr _18u0idpf _lcxvglyw _uiztglyw",
            __cmplp.className
        ])
    });
});
const $86f4dcea1a6cd6d9$export$d8fe6814885155a8 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1JBgu", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $17ad1bba8a80a931$export$41fb9f06171c75f4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $gBq9h = parcelRequire("gBq9h");
// z-index is because the trigger must appear above a focused card
const $17ad1bba8a80a931$var$triggerElementStyles = null;
const $17ad1bba8a80a931$var$TriggerWrapper = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1e0c1ule _kqswh2mm _1pbykb7n _19pkr5cr _2hwxidpf _otyrr5cr _18u0idpf _4t3iftgi _1bsb1osq _bfhk18uv _tzy4kb7n _qj9aglyw _1pjhtlke _1mygkb7n _3feiglyw"
        ])
    });
const $17ad1bba8a80a931$export$41fb9f06171c75f4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gBq9h.default), {
        TriggerWrapper: $17ad1bba8a80a931$var$TriggerWrapper,
        ...props
    });

});
parcelRegister("gBq9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0a1afa644007482$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $faod6 = parcelRequire("faod6");

var $dCm1o = parcelRequire("dCm1o");

const $e0a1afa644007482$var$fadeInAnimation = null;
const $e0a1afa644007482$var$triggerStyles = null;
const $e0a1afa644007482$var$TriggerFallback = (props)=>/*#__PURE__*/ $5uXOq.createElement("div", {
        ...props,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itglyw _12ji1r31 _1qu2glyw _12y31o36 _1e0c1ule _kqswh2mm _1pbykb7n _19pkr5cr _2hwxidpf _otyrr5cr _18u0idpf _4t3iu2gc _1bsb1osq _bfhk18uv _tzy4idpf _qj9aglyw _1pjhtlke _1mygkb7n _d0altlke _11om1wwu _7psyfnf5 _1uy0fnf5 _bir2q7pw"
        ])
    });
const $e0a1afa644007482$export$9496cf78b8451731 = ({ label: label, onClick: onClick, TriggerWrapper: TriggerWrapper = $e0a1afa644007482$var$TriggerFallback, shouldFocusTrigger: shouldFocusTrigger = false })=>/*#__PURE__*/ $5uXOq.createElement(TriggerWrapper, {
        onClick: onClick
    }, /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
        content: label,
        position: "left",
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ $5uXOq.createElement("button", {
        "data-testid": "platform-inline-card-create.ui.trigger.hidden.button",
        autoFocus: shouldFocusTrigger,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _19itglyw _2rkoglpi _1e0c1ule _kqswstnw _t9ec1w5p _1pbykb7n _4t3i1ejb _1bsb1ejb _bfhkb29m _80om1kw7",
            "_19itzgxb _bfhk1bhr _irr316qz"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
        label: label,
        color: "var(--ds-icon, #44546F)"
    })) : /*#__PURE__*/ $5uXOq.createElement("button", {
        "data-testid": "platform-inline-card-create.ui.trigger.hidden.button",
        autoFocus: shouldFocusTrigger,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _12ji1r31 _1qu2glyw _12y31o36 _19itglyw _2rkoglpi _1e0c1ule _kqswstnw _t9ec1w5p _1pbykb7n _4t3i1ejb _1bsb1ejb _bfhkb29m _80om1kw7"
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $e0a1afa644007482$var$centeredIconStyles
    }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($faod6))), {
        spacing: "spacious",
        label: label,
        color: "var(--ds-icon-inverse, #FFFFFF)"
    })))), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $e0a1afa644007482$var$dividerStyles,
        backgroundColor: "color.background.brand.bold"
    }));
var $e0a1afa644007482$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e0a1afa644007482$export$9496cf78b8451731);
const $e0a1afa644007482$var$dividerStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    transform: 'translateY(3px)',
    height: "var(--ds-space-025, 2px)",
    width: '100%'
});
const $e0a1afa644007482$var$centeredIconStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    height: "var(--ds-space-300, 24px)",
    width: "var(--ds-space-300, 24px)"
});
const $e0a1afa644007482$var$buttonStyles = null;
const $e0a1afa644007482$var$visualRefreshStyles = null;

});


parcelRegister("fwQRP", function(module, exports) {

$parcel$export(module.exports, "shouldDisplayNudge", () => $9fd6bbea3aac6f96$export$fb74206c86afd6c8);
$parcel$export(module.exports, "mapInlineCardCreateCardType", () => $9fd6bbea3aac6f96$export$412240769d99b76c);
$parcel$export(module.exports, "isPartialIccMode", () => $9fd6bbea3aac6f96$export$41ec910c4a4c5cb4);

const $9fd6bbea3aac6f96$export$fb74206c86afd6c8 = ({ isTheFirstCurrentSwimlaneOpen: isTheFirstCurrentSwimlaneOpen, triggerAppearance: triggerAppearance, cardIndex: cardIndex, canShowIccNudge: canShowIccNudge, isDismissed: isDismissed })=>{
    if (!isTheFirstCurrentSwimlaneOpen || !canShowIccNudge) return false;
    if (isDismissed) return false;
    const displayNudgeInBetweenCards = triggerAppearance === (0, $7462c685f739ed5a$export$d2f7b3f0efb6e208) && cardIndex === 2;
    const displayNudgeOnVisibleButton = triggerAppearance === (0, $7462c685f739ed5a$export$dda6912361cddac9);
    return displayNudgeInBetweenCards || displayNudgeOnVisibleButton;
};
const $9fd6bbea3aac6f96$export$412240769d99b76c = ({ id: id, name: name, iconUrl: iconUrl })=>({
        id: Number(id),
        name: name,
        iconUrl: iconUrl,
        isDisabled: false
    });
const $9fd6bbea3aac6f96$export$41ec910c4a4c5cb4 = (columnId, cardTypeId, config)=>config?.mode === 'PARTIAL' || config?.columns?.[columnId]?.mode === 'PARTIAL' || config?.columns?.[columnId]?.issueTypes?.[cardTypeId] === 'PARTIAL';

});

parcelRegister("9fzgs", function(module, exports) {

$parcel$export(module.exports, "VisibleIcc", () => $46a47ad99fef883e$export$b499b8d3bd236f88);

var $5uXOq = parcelRequire("5uXOq");

var $dMEgP = parcelRequire("dMEgP");

var $jzjy1 = parcelRequire("jzjy1");

var $5rFbt = parcelRequire("5rFbt");

var $4R6GH = parcelRequire("4R6GH");

var $27WcV = parcelRequire("27WcV");

var $2Z6La = parcelRequire("2Z6La");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4pxa7 = parcelRequire("4pxa7");

var $5X72x = parcelRequire("5X72x");


var $6s1PB = parcelRequire("6s1PB");


var $2f454 = parcelRequire("2f454");

var $l67YV = parcelRequire("l67YV");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $36pz7 = parcelRequire("36pz7");

var $k8auG = parcelRequire("k8auG");

var $gXFr2 = parcelRequire("gXFr2");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $45cXl = parcelRequire("45cXl");

var $3ZtL7 = parcelRequire("3ZtL7");

var $b6Ykj = parcelRequire("b6Ykj");

var $cP1xj = parcelRequire("cP1xj");
const $46a47ad99fef883e$var$EMPTY_ARRAY = [];
const $46a47ad99fef883e$var$EMPTY_PROJECTS_ARRAY = [];
const $46a47ad99fef883e$var$VisibleIccComponent = ({ columnId: columnId, cardTypes: cardTypes, cardIndex: cardIndex, insertBefore: insertBefore, isLastSwimlane: isLastSwimlane, projectId: projectId, swimlaneId: swimlaneId, groupParentId: groupParentId, mappedCardTypes: mappedCardTypes, onChangeFormVisible: onChangeFormVisible, showOnHover: showOnHover, triggerAppearance: triggerAppearance, triggerAriaLabel: triggerAriaLabel, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, isFooter: isFooter })=>{
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(false);
    const sessionIdRef = (0, $5uXOq.useRef)();
    const { initialCardTypeId: initialCardTypeId } = (0, $2Z6La.useIccContext)();
    const keepIccOpen = (0, $4pxa7.useKeepIccOpenState)();
    const { triggerReason: triggerReason } = (0, $4pxa7.useTriggerEventState)();
    const { setTriggerReason: setTriggerReason } = (0, $4pxa7.useKeepIccOpenActions)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const hasCustomFilters = (0, $67sX6.useBoardSelector)((0, $5mTgl.hasCustomFiltersSelector));
    const appliedFilterCount = (0, $67sX6.useBoardSelector)((state)=>hasCustomFilters ? 0 : (0, $5mTgl.filtersForInlineCardCreateCountSelector)(state));
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const canEditBoard = (0, $67sX6.useBoardSelector)((state)=>(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df]);
    const manageIssueTypesLink = (0, $67sX6.useBoardSelector)((state)=>canEditBoard ? (0, $gXFr2.manageIssueTypesLinkSelector)(state) : null);
    const getStatusTransitions = (0, $67sX6.useBoardSelector)((0, $gXFr2.makeGetStatusTransitionsForType));
    const projectKey = (0, $67sX6.useBoardSelector)((0, $67Z81.projectKeySelector));
    const defaultIssueTypeId = (0, $67sX6.useBoardSelector)((0, $4gt6L.defaultIssueTypeIdSelector));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const getPersonByAccountId = (0, $67sX6.useBoardSelector)((state)=>(0, $36pz7.getPerson)(state, swimlaneId ?? ''));
    const assignee = (0, $67sX6.useBoardSelector)((0, $3ZtL7.getAssignee));
    const isUnscheduledColumn = isIPBoard && columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID);
    const shouldStayOpen = (0, $67sX6.useBoardSelector)((state)=>{
        if (isUnscheduledColumn) return !!isFooter && (0, $9OPlz.isUnscheduledColumnICCOpen)(state, swimlaneId, columnId);
        if ((0, $k8auG.shouldAutoOpenIccAndShowCreateButton)(state)) {
            if ((0, $k8auG.isBoardEmptySelector)(state) && (0, $fyeGd.getColumnIndex)(state, columnId) === 0 && (0, $9OPlz.getColumnIdToKeepICCOpen)(state) === null && (0, $9OPlz.getLastOpenedColumnId)(state) === null) {
                if (triggerReason !== 'emptyBoard') setTriggerReason('emptyBoard');
                dispatch((0, $2f454.setIssueIdWithAboveICCOpen)(null, columnId));
                return true;
            }
            // This is an existing code path and is not part of the
            // changes in the variation cohort, so no checks needed
            if (insertBefore) return (0, $9OPlz.hasICCOpen)(state, insertBefore);
            return (0, $9OPlz.keepICCOpenInColumn)(state, columnId);
        }
        return (0, $9OPlz.hasICCOpen)(state, insertBefore);
    });
    const projects = (0, $67sX6.useBoardSelector)((state)=>isIPBoard ? (0, (/*@__PURE__*/$parcel$interopDefault($dMEgP)))((0, $gXFr2.getIssueProjectsForIssueCreation)(state)) : $46a47ad99fef883e$var$EMPTY_PROJECTS_ARRAY);
    const issueTypeTransitions = (0, $67sX6.useBoardSelector)((state)=>!isIPBoard ? (0, $gXFr2.getInitialTransitionsForColumn)(state)(columnId) : undefined);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onAutoOpen = (0, $5uXOq.useCallback)((sessionId)=>{
        if (isIPBoard && (0, $4R6GH.fg)('render_program_board_card_in_popup')) sessionIdRef.current = sessionId;
        // start event for auto open icc
        const startAutoOpenICCAnalyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        });
        // firing start event for icc that is auto open - same as onTriggerClickCallback
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $8zOmE.fireUIAnalytics)(startAutoOpenICCAnalyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: triggerAppearance,
            sessionId: sessionId,
            isAutoOpen: true
        });
        dispatch((0, $l67YV.setInlineCreateSessionId)(sessionId));
    }, [
        createAnalyticsEvent,
        dispatch,
        isFormVisible,
        isIPBoard,
        triggerAppearance
    ]);
    const onTriggerClick = (0, $5uXOq.useCallback)((sessionId)=>{
        setIsFormVisible(true);
        if (isIPBoard && (0, $4R6GH.fg)('render_program_board_card_in_popup')) sessionIdRef.current = sessionId;
        if (isIPBoard) {
            // When other create button is clicked, close ICC in unscheduled column
            dispatch((0, $2f454.closeIccInUnscheduledColumn)());
            if (isUnscheduledColumn && isFooter && swimlaneId) // If the button clicked in unscheduled column and footer, sync the swimlane ID to the state
            // This is so the create button in the header is disabled
            dispatch((0, $2f454.openIccInUnscheduledColumn)(swimlaneId));
        }
        dispatch((0, $l67YV.setInlineCreateSessionId)(sessionId));
        dispatch((0, $2f454.setIssueIdWithAboveICCOpen)(insertBefore, columnId));
    }, [
        dispatch,
        insertBefore,
        columnId,
        swimlaneId,
        isIPBoard,
        isUnscheduledColumn,
        isFooter
    ]);
    const onCancelOrBlur = (0, $5uXOq.useCallback)(()=>{
        setIsFormVisible(false);
        if (isIPBoard && (0, $4R6GH.fg)('render_program_board_card_in_popup')) sessionIdRef.current = undefined;
        if (isUnscheduledColumn) dispatch((0, $2f454.closeIccInUnscheduledColumn)());
        dispatch((0, $l67YV.clearInlineCreateSessionId)());
        dispatch((0, $2f454.setIssueIdWithAboveICCOpen)(null, null));
    }, [
        dispatch,
        isUnscheduledColumn,
        isIPBoard
    ]);
    const onCreate = (0, $b6Ykj.useOnCreate)({
        columnId: columnId,
        cardTypes: cardTypes,
        cardIndex: cardIndex,
        insertBefore: insertBefore,
        isLastSwimlane: isLastSwimlane,
        projectId: projectId,
        swimlaneId: swimlaneId,
        groupParentId: groupParentId,
        isUnscheduledColumn: isUnscheduledColumn
    });
    // TODO: WOLVES-1889 - After experiment cleanup these callbacks can be replaced with the original ones (ie onCreateWithExperimentMeasure -> onCreate)
    const { onChangeFormVisibleWithExperimentMeasure: onChangeFormVisibleWithExperimentMeasure, onCreateWithExperimentMeasure: onCreateWithExperimentMeasure } = (0, $cP1xj.useCallbacksWrappersForPICExperimentMeasures)({
        onChangeFormVisible: onChangeFormVisible,
        onCreate: onCreate
    });
    const statusTransitions = (0, $5uXOq.useMemo)(()=>{
        if ((shouldStayOpen || isFormVisible) && !isIPBoard) return getStatusTransitions(columnId, issueTypeTransitions, initialCardTypeId);
        return $46a47ad99fef883e$var$EMPTY_ARRAY;
    }, [
        columnId,
        getStatusTransitions,
        initialCardTypeId,
        isFormVisible,
        isIPBoard,
        issueTypeTransitions,
        shouldStayOpen
    ]);
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_powerful_inline_create_for_software_board');
    const isPICInBoardViewExperimentEnabled = expConfig.get('isEnabled', false);
    const shouldShowDueDatePicker = isPICInBoardViewExperimentEnabled ? (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$5904c54eb0bdf886] : false;
    const shouldShowAssigneePicker = isPICInBoardViewExperimentEnabled ? (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$c713a1185b717514] : false;
    const shouldShowAdditionalFields = (0, $5uXOq.useCallback)(()=>statusTransitions.length === 0 && (shouldShowDueDatePicker || shouldShowAssigneePicker) && (0, $6s1PB.expVal)('jira_powerful_inline_create_for_software_board', 'isEnabled', false), [
        shouldShowAssigneePicker,
        shouldShowDueDatePicker,
        statusTransitions.length
    ]);
    const shouldShowCreateButton = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.shouldAutoOpenIccAndShowCreateButton)(state) ? projects.length === 0 : false);
    let defaultAssignee;
    if (swimlaneMode === 'SWIMLANE_BY_ASSIGNEE' || swimlaneMode === 'SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST') {
        const groupedByAssignee = isPICInBoardViewExperimentEnabled && shouldShowAssigneePicker ? getPersonByAccountId : null;
        groupedByAssignee !== null && groupedByAssignee !== undefined ? defaultAssignee = {
            accountId: groupedByAssignee.id,
            avatarUrls: {
                '48x48': groupedByAssignee.avatarUrl || ''
            },
            displayName: groupedByAssignee.displayName
        } : undefined;
    }
    if (isPICInBoardViewExperimentEnabled && assignee) defaultAssignee = {
        accountId: assignee.id,
        avatarUrls: {
            '48x48': assignee.avatarUrl || ''
        },
        displayName: assignee.displayName
    };
    (0, $5uXOq.useEffect)(()=>{
        if (isUnscheduledColumn) setIsFormVisible(shouldStayOpen);
        else if (shouldStayOpen) // Checking if it's undefined here because we should still be setting it to
        // false if keepIccOpen is false
        setIsFormVisible(keepIccOpen);
        else setIsFormVisible(shouldStayOpen);
    }, [
        keepIccOpen,
        shouldStayOpen,
        isUnscheduledColumn
    ]);
    const showIssueTypeConfigOptions = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.shouldShowIssueTypeConfigOptions)(state));
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            // Clean up state and session ID when component unmounts prior cancel or blur (eg. when board is scrolled)
            if (isIPBoard && sessionIdRef.current && (0, $4R6GH.fg)('render_program_board_card_in_popup')) {
                setIsFormVisible(false);
                dispatch((0, $l67YV.clearSpecifiedInlineCreateSessionId)(sessionIdRef.current));
                dispatch((0, $2f454.clearSpecifiedIssueIdWithAboveICCOpen)(insertBefore, columnId));
            }
        };
    }, [
        isIPBoard,
        dispatch,
        insertBefore,
        columnId
    ]);
    const icc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $27WcV.default), {
        defaultCardTypeId: defaultIssueTypeId,
        cardTypes: mappedCardTypes,
        // appliedFilterCount is used to show the info dialog with the X filters applied message
        // hide it if we have custom filters active as it'll be misleading
        appliedFilterCount: appliedFilterCount,
        manageIssueTypesLink: manageIssueTypesLink,
        shouldStayOpen: shouldStayOpen,
        isIPBoard: isIPBoard,
        statusTransitions: statusTransitions,
        isFormVisible: isFormVisible,
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error inconsistent types between IssueProject and Project
        projects: projects,
        onCreate: onCreateWithExperimentMeasure,
        onTriggerClick: onTriggerClick,
        onCancel: onCancelOrBlur,
        onBlur: onCancelOrBlur,
        onChangeFormVisible: onChangeFormVisibleWithExperimentMeasure,
        renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
        showOnHover: showOnHover,
        triggerAppearance: triggerAppearance,
        triggerAriaLabel: triggerAriaLabel,
        shouldShowCreateButton: shouldShowCreateButton,
        ...isUnscheduledColumn && {
            shouldScrollIntoView: true
        },
        onAutoOpen: onAutoOpen,
        showIssueTypeConfigOptions: showIssueTypeConfigOptions,
        configSource: (0, $f1340a435190eeda$export$7f04bd1df3763938),
        projectKey: projectKey,
        getShouldShowAdditionalFields: shouldShowAdditionalFields,
        shouldShowDueDatePicker: shouldShowDueDatePicker,
        shouldShowAssigneePicker: shouldShowAssigneePicker,
        defaultAssignee: defaultAssignee
    });
    const shouldRenderPopper = (0, $b6Ykj.useShouldRenderIccInPopper)({
        columnId: columnId,
        isFormVisible: isFormVisible
    });
    return isIPBoard && (0, $4R6GH.fg)('render_program_board_card_in_popup') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5X72x.CardPopper), {
        shouldRenderPopper: shouldRenderPopper,
        cardHeight: 100
    }, icc) : icc;
};
const $46a47ad99fef883e$export$b499b8d3bd236f88 = (0, $jzjy1.AnalyticsSubject)('issue')($46a47ad99fef883e$var$VisibleIccComponent);

});
parcelRegister("27WcV", function(module, exports) {

$parcel$export(module.exports, "default", () => $24371841a711ab69$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $9vPRK = parcelRequire("9vPRK");


var $hNJJt = parcelRequire("hNJJt");

var $hIWd8 = parcelRequire("hIWd8");

var $cVImo = parcelRequire("cVImo");
const $24371841a711ab69$export$d072fca0df9c8916 = (0, $9vPRK.default)((0, $hIWd8.default));
const $24371841a711ab69$var$InlineCardCreate = (props)=>{
    const [isFormOpen, setIsFormOpen] = (0, $5uXOq.useState)(props.shouldStayOpen);
    const { shouldStayOpen: shouldStayOpen, isFormVisible: isFormVisibleProp, cardTypes: cardTypes, showOnHover: showOnHover, triggerAppearance: triggerAppearance, triggerAriaLabel: triggerAriaLabel, buttonSpotlightTargetId: buttonSpotlightTargetId, manageIssueTypesLink: manageIssueTypesLink, appliedFilterCount: appliedFilterCount, selectedCardTypeId: selectedCardTypeId, defaultCardTypeId: defaultCardTypeId, onTriggerClick: onTriggerClick, onChangeFormVisible: onChangeFormVisible, onCancel: onCancel, onBlur: onBlur, onCreate: onCreate, onChangeProject: onChangeProject, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, statusTransitions: statusTransitions, isIPBoard: isIPBoard, projects: projects, initialProjectId: initialProjectId, TypeSelect: TypeSelect, shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside, shouldShowCreateButton: shouldShowCreateButton, shouldScrollIntoView: shouldScrollIntoView, onAutoOpen: onAutoOpen, showIssueTypeConfigOptions: showIssueTypeConfigOptions, configSource: configSource, projectKey: projectKey, getShouldShowAdditionalFields: getShouldShowAdditionalFields, defaultAssignee: defaultAssignee, shouldShowDueDatePicker: shouldShowDueDatePicker, shouldShowAssigneePicker: shouldShowAssigneePicker } = props;
    const onCreateHandler = (0, $5uXOq.useCallback)((createPayload)=>{
        const createCallbackPayload = createPayload.map(({ summary: summary, cardTypeId: cardTypeId, fields: fields, projectId: projectId, assigneeId: assigneeId, dueDate: dueDate })=>{
            const project = isIPBoard ? {
                projectId: projectId
            } : {};
            return {
                summary: summary,
                cardType: String(cardTypeId),
                transition: fields?.get((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS)),
                ...project,
                assigneeId: assigneeId,
                dueDate: dueDate
            };
        });
        onCreate(createCallbackPayload);
    }, [
        isIPBoard,
        onCreate
    ]);
    const onChangeFormVisibleHandler = (0, $5uXOq.useCallback)((isFormVisible)=>{
        onChangeFormVisible(isFormVisible);
        setIsFormOpen(isFormVisible);
    }, [
        onChangeFormVisible,
        setIsFormOpen
    ]);
    const extraItems = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(manageIssueTypesLink) ? [] : [
            {
                url: manageIssueTypesLink
            }
        ], [
        manageIssueTypesLink
    ]);
    if (false) return null;
    const IICComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($24371841a711ab69$export$d072fca0df9c8916, {
        // @ts-expect-error - TS2322 - Type '{ cardTypes: CardTypeShape[]; extraItems: { url: string; }[]; numFilters: number; onCreate: (createPayload: CreatePayload) => void; appearance: "full"; triggerAppearance: TriggerAppearance; ... 8 more ...; onBlur: BlurCallback; }' is not assignable to type 'IntrinsicAttributes & WithEngagementProps & { children?: ReactNode; }'.
        cardTypes: cardTypes,
        shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside,
        extraItems: extraItems,
        TypeSelect: TypeSelect,
        numFilters: appliedFilterCount,
        onCreate: onCreateHandler,
        appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
        triggerAppearance: triggerAppearance,
        triggerAriaLabel: triggerAriaLabel,
        areActionButtonsVisible: true,
        isFormVisibleDefault: shouldStayOpen,
        isFormVisible: isFormVisibleProp,
        targetId: buttonSpotlightTargetId,
        selectedCardTypeId: selectedCardTypeId,
        defaultCardTypeId: defaultCardTypeId,
        onChangeFormVisible: onChangeFormVisibleHandler,
        onTriggerClick: onTriggerClick,
        onCancel: onCancel,
        onBlur: onBlur,
        renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
        statusTransitions: statusTransitions,
        projects: projects,
        initialProjectId: initialProjectId,
        onChangeProject: onChangeProject,
        shouldShowCreateButton: shouldShowCreateButton,
        onAutoOpen: onAutoOpen,
        shouldScrollIntoView: shouldScrollIntoView,
        showIssueTypeConfigOptions: showIssueTypeConfigOptions,
        configSource: configSource,
        projectKey: projectKey,
        getShouldShowAdditionalFields: getShouldShowAdditionalFields,
        defaultAssignee: defaultAssignee,
        shouldShowDueDatePicker: shouldShowDueDatePicker,
        shouldShowAssigneePicker: shouldShowAssigneePicker,
        isCompactDueDatePicker: true
    });
    return showOnHover ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cVImo.HiddenButtonWrapper), {
        isICCFormOpen: isFormOpen
    }, IICComponent) : IICComponent;
};
$24371841a711ab69$var$InlineCardCreate.defaultProps = {
    shouldStayOpen: false,
    appliedFilterCount: 0,
    cardTypes: [],
    statusTransitions: [],
    showOnHover: false,
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    buttonSpotlightTargetId: '',
    manageIssueTypesLink: null,
    selectedCardTypeId: undefined,
    defaultCardTypeId: undefined
};
var $24371841a711ab69$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($24371841a711ab69$var$InlineCardCreate);

});
parcelRegister("hNJJt", function(module, exports) {

$parcel$export(module.exports, "FIELD_KEY_STATUS_TRANSITIONS", () => $e682d994c4b3be50$export$9f9b866ee3adcf04);
$parcel$export(module.exports, "default", () => $e682d994c4b3be50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gZL7V = parcelRequire("gZL7V");

var $c8Oei = parcelRequire("c8Oei");

var $dC5iT = parcelRequire("dC5iT");
var $5ILhZ = parcelRequire("5ILhZ");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $85BdV = parcelRequire("85BdV");
const $e682d994c4b3be50$var$ANALYTICS_SUBJECT = 'iccStatusSelect';
const $e682d994c4b3be50$export$9f9b866ee3adcf04 = 'statusTransitions';
const $e682d994c4b3be50$var$getStatusTheme = (id)=>$e682d994c4b3be50$var$statusCategoryToThemeMap[id] || 'default';
const $e682d994c4b3be50$var$statusCategoryToThemeMap = {
    '1': 'default',
    '2': 'default',
    '3': 'success',
    '4': 'inprogress'
};
const $e682d994c4b3be50$var$Option = ({ children: children, ...props })=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const { statusInfo: statusInfo } = props.data;
    const buttonTheme = $e682d994c4b3be50$var$getStatusTheme(String(statusInfo?.statusCategoryId));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "platform-inline-card-create.ui.form.status-select.option",
        xcss: [
            $e682d994c4b3be50$var$optionContentStyles,
            $e682d994c4b3be50$var$buttonThemeStyle[buttonTheme]
        ]
    }, children));
};
const $e682d994c4b3be50$var$transformOptions = (statusTransitions, selectedTransitionId)=>{
    let value;
    const options = [];
    statusTransitions.forEach((transition)=>{
        const option = {
            label: transition.name,
            value: transition.transitionId,
            statusInfo: transition
        };
        if (transition.transitionId === selectedTransitionId) value = option;
        else options.push(option);
    });
    if (!value) value = options?.[0];
    return {
        options: options,
        value: value
    };
};
const $e682d994c4b3be50$var$buttonThemeStyle = {
    default: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.neutral',
        color: 'color.text',
        ':hover': {
            color: 'color.text',
            backgroundColor: 'color.background.neutral.hovered'
        }
    }),
    success: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.success',
        color: 'color.text.success',
        ':hover': {
            color: 'color.text.success',
            backgroundColor: 'color.background.success.hovered'
        }
    }),
    inprogress: (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.information',
        color: 'color.text.information',
        ':hover': {
            color: 'color.text.information',
            backgroundColor: 'color.background.information.hovered'
        }
    })
};
const $e682d994c4b3be50$var$StatusTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ value: value, isOpen: isOpen, ...triggerProps }, ref)=>{
    const buttonTheme = $e682d994c4b3be50$var$getStatusTheme(String(value?.statusInfo?.statusCategoryId));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$statusContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$statusButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: value.label ?? null,
        delay: (0, $7462c685f739ed5a$export$f9e3e7ede9ba929d),
        hideTooltipOnClick: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        key: "pressable",
        ...triggerProps,
        ref: ref,
        xcss: [
            $e682d994c4b3be50$var$buttonContentStyles,
            $e682d994c4b3be50$var$buttonThemeStyle[buttonTheme]
        ],
        "aria-label": formatMessage((0, $85BdV.default).ariaLabel, {
            value: value.label ?? formatMessage((0, $85BdV.default).invalid)
        }),
        testId: "platform-inline-card-create.ui.form.status-select.trigger"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        maxLines: 1,
        weight: "bold",
        size: "small",
        color: "inherit"
    }, value.label), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e682d994c4b3be50$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
        LEGACY_size: "medium",
        label: "",
        "aria-hidden": "true",
        color: "currentColor"
    }))))));
});
const $e682d994c4b3be50$var$StatusSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ statusTransitions: statusTransitions, selectedTransitionId: selectedTransitionId, onSelectTransition: onSelectTransition }, ref)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { value: value, options: options } = (0, $5uXOq.useMemo)(()=>$e682d994c4b3be50$var$transformOptions(statusTransitions, selectedTransitionId), [
        statusTransitions,
        selectedTransitionId
    ]);
    const onChange = (0, $5uXOq.useCallback)((option)=>{
        option && onSelectTransition(option.statusInfo.transitionId);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown changed',
            actionSubject: $e682d994c4b3be50$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent,
        onSelectTransition
    ]);
    const onMenuOpen = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'dropdown opened',
            actionSubject: $e682d994c4b3be50$var$ANALYTICS_SUBJECT
        }), {});
    }, [
        createAnalyticsEvent
    ]);
    const setRefNode = (0, $5uXOq.useCallback)((popupSelectRef)=>{
        ref && popupSelectRef && (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(ref, 'current.node', popupSelectRef);
    }, [
        ref
    ]);
    const renderTrigger = (0, $5uXOq.useCallback)((props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e682d994c4b3be50$var$StatusTrigger, {
            ...props,
            value: value
        }), [
        value
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        ref: setRefNode,
        components: {
            Option: $e682d994c4b3be50$var$Option
        },
        target: renderTrigger,
        options: options,
        value: value,
        onChange: onChange,
        onMenuOpen: onMenuOpen,
        isSearchable: false,
        // DSP-2990 - PopupSelect doesn't respect isSearchable, searchThreshold is required
        searchThreshold: Number.MAX_SAFE_INTEGER,
        minMenuWidth: "auto",
        classNamePrefix: "inline-card-create-status-select",
        testId: "platform-inline-card-create.ui.form.status-select.status-select"
    });
});
var $e682d994c4b3be50$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e682d994c4b3be50$var$StatusSelect);
const $e682d994c4b3be50$var$statusContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    minWidth: '0px',
    position: 'relative'
});
const $e682d994c4b3be50$var$statusButtonWrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    paddingLeft: 'space.100'
});
const $e682d994c4b3be50$export$548912fb31084970 = /*#__PURE__*/ (0, $5uXOq.memo)($e682d994c4b3be50$var$StatusSelect);
const $e682d994c4b3be50$var$buttonContentStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingBlock: 'space.0',
    paddingLeft: 'space.100',
    paddingRight: 'space.0',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)",
    textAlign: 'left',
    width: '100%'
});
const $e682d994c4b3be50$var$iconContainerStyles = (0, $8CUq3.xcss)({
    minWidth: '24px',
    height: '24px',
    display: 'flex',
    flex: '1',
    alignItems: 'center',
    justifyContent: 'center'
});
const $e682d994c4b3be50$var$optionContentStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    width: 'auto',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    textTransform: 'uppercase',
    font: "var(--ds-font-body-small, normal 400 11px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    fontWeight: "var(--ds-font-weight-bold, 700)",
    paddingBlock: 'space.0',
    paddingInline: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "4px" and fallback "3px" do not match and can't be replaced automatically.
    borderRadius: "var(--ds-border-radius, 3px)"
});

});
parcelRegister("85BdV", function(module, exports) {

$parcel$export(module.exports, "default", () => $9dac99c767b21e7c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9dac99c767b21e7c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "inline-card-create.form.status-select.aria-label",
        "defaultMessage": "The current status is {value}. Press the 'Space' key to change the status."
    },
    invalid: {
        "id": "inline-card-create.form.status-select.invalid",
        "defaultMessage": "invalid"
    }
});

});


parcelRegister("hIWd8", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d06f081c1e675aa$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7Jxgt = parcelRequire("7Jxgt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1XJ20 = parcelRequire("1XJ20");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5knXz = parcelRequire("5knXz");

var $4pxa7 = parcelRequire("4pxa7");

var $c4UiF = parcelRequire("c4UiF");

var $6s1PB = parcelRequire("6s1PB");


var $2Z6La = parcelRequire("2Z6La");

var $dhszq = parcelRequire("dhszq");

var $hNJJt = parcelRequire("hNJJt");

var $l94uE = parcelRequire("l94uE");
// exact trigger height
const $0d06f081c1e675aa$var$TRIGGER_HEIGHT = 40;
const $0d06f081c1e675aa$var$withMarginTopStyles = null;
const $0d06f081c1e675aa$var$withTransparentStyles = null;
const $0d06f081c1e675aa$export$c283de3a59c46bc6 = (cardTypes, cardTypeId, defaultCardTypeId)=>{
    const selectedCardType = cardTypes.find(({ id: id })=>id === cardTypeId);
    const fallbackCardTypeId = defaultCardTypeId && cardTypes.some(({ id: id, isDisabled: isDisabled })=>id === defaultCardTypeId && isDisabled !== true) ? defaultCardTypeId : null;
    if (selectedCardType?.isDisabled === true) return fallbackCardTypeId;
    // To prevent setting invalid value when user switches to another ICC component that have different cardTypes
    return selectedCardType !== undefined ? cardTypeId : fallbackCardTypeId;
};
const $0d06f081c1e675aa$var$InlineCardCreate = (props)=>{
    const { isFormVisible: isFormVisibleProp, isFormVisibleDefault: isFormVisibleDefault = false, isDisabled: isDisabled = false, shouldScrollIntoView: shouldScrollIntoView, onChangeFormVisible: onChangeFormVisible = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), triggerAppearance: triggerAppearance, onTriggerClick: onTriggerClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCancel: onCancel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCreate: onCreate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeCardType: onChangeCardType = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeSummary: onChangeSummary = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeStatusTransition: onChangeStatusTransition = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeProject: onChangeProject = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), cardTypes: cardTypes = [], defaultCardTypeId: defaultCardTypeId, autoFocus: autoFocus, extraItems: extraItems, shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside, triggerLabel: triggerLabel, triggerAriaLabel: triggerAriaLabel, ariaLabelledBy: ariaLabelledBy, appearance: appearance, placeholderText: placeholderText, numFilters: numFilters, messages: messages, saveOnBlur: saveOnBlur, renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent, renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter, renderCompactViewEditorExperimental: renderCompactViewEditorExperimental, renderCompactViewActionButtonExperimental: renderCompactViewActionButtonExperimental, onBlur: onBlur = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), TypeSelect: TypeSelect, StatusSelect: StatusSelect, statusTransitions: statusTransitions, projects: projects, isModalTrigger: isModalTrigger, shouldShowCreateButton: shouldShowCreateButton, onAutoOpen: onAutoOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), containerRef: containerRef, showIssueTypeConfigOptions: showIssueTypeConfigOptions, configSource: configSource, projectKey: projectKey, getShouldShowAdditionalFields: getShouldShowAdditionalFields, defaultAssignee: defaultAssignee, shouldShowDueDatePicker: shouldShowDueDatePicker, shouldShowAssigneePicker: shouldShowAssigneePicker, isCompactDueDatePicker: isCompactDueDatePicker = false } = props;
    const [isFormVisible, setIsFormVisible] = (0, $5uXOq.useState)(isFormVisibleProp ?? isFormVisibleDefault);
    const [triggerUnmountTimeoutId, setTriggerUnmountTimeoutId] = (0, $5uXOq.useState)(null);
    const previousIsFormVisibleProp = (0, $1XJ20.usePreviousWithInitial)(isFormVisibleProp);
    const previousIsFormVisible = (0, $1XJ20.usePreviousWithInitial)(isFormVisible);
    const [shouldFocusTrigger, setShouldFocusTrigger] = (0, $5uXOq.useState)(false);
    const setFocusOnTrigger = (0, $5uXOq.useCallback)(()=>{
        setShouldFocusTrigger(true);
    }, []);
    const { showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull } = (0, $5knXz.useStorageEnforcement)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { hasCreatedIssueICC: hasCreatedIssueICC, triggerReason: triggerReason } = (0, $4pxa7.useTriggerEventState)();
    const { setHasCreatedIssueICC: setHasCreatedIssueICC, setTriggerReason: setTriggerReason } = (0, $4pxa7.useKeepIccOpenActions)();
    const [isConfiguringIssueType, setIsConfiguringIssueType] = (0, $5uXOq.useState)(false);
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_powerful_inline_create_for_software_board');
    const isPICInBoardViewExperimentEnabled = expConfig.get('isEnabled', false);
    const { fetchFields: fetchFields, iccProps: additionalIccProps } = isPICInBoardViewExperimentEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $c4UiF.useLazyIssueTypesAndFieldsForICC)({
        projectKey: projectKey
    }) : {
        fetchFields: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        iccProps: null
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!false && (previousIsFormVisibleProp !== isFormVisibleProp || previousIsFormVisible !== isFormVisible)) // invoke callback everytime isFormVisibleProp or internal isFormVisible state changes
        onChangeFormVisible(isFormVisibleProp ?? isFormVisible);
    }, [
        isFormVisible,
        isFormVisibleProp,
        onChangeFormVisible,
        previousIsFormVisible,
        previousIsFormVisibleProp
    ]);
    const onTriggerClickCallback = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        const sessionId = (0, $7Jxgt.v4)();
        setHasCreatedIssueICC(false);
        // @ts-expect-error Second argument should be of format "actionSubject action"
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'triggerClicked', 'triggerButton', {
            formWasOpen: isFormVisible,
            triggerAppearance: triggerAppearance,
            sessionId: sessionId,
            isAutoOpen: false
        });
        if (isFormVisibleProp === undefined) {
            setTriggerUnmountTimeoutId(null);
            setIsFormVisible(true);
        }
        setShouldFocusTrigger(false);
        onTriggerClick(sessionId);
    }, [
        setHasCreatedIssueICC,
        isFormVisible,
        triggerAppearance,
        isFormVisibleProp,
        onTriggerClick
    ]);
    const onCancelCallback = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'blurred',
            actionSubject: 'inlineCardCreate'
        }), {
            cancelledBy: (0, $7462c685f739ed5a$export$2bb790b9008907b4)
        });
        if (isFormVisibleProp === undefined) {
            if (triggerUnmountTimeoutId) {
                clearTimeout(triggerUnmountTimeoutId);
                setTriggerUnmountTimeoutId(null);
            }
            setIsFormVisible(false);
        }
        onCancel();
    }, [
        createAnalyticsEvent,
        triggerUnmountTimeoutId,
        isFormVisibleProp,
        onCancel
    ]);
    const makeOnBlur = (0, $5uXOq.useCallback)((context)=>(summary)=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'blurred',
                actionSubject: 'inlineCardCreate'
            }), {
                cancelledBy: (0, $7462c685f739ed5a$export$565566e3df4dad53),
                withContent: !!summary
            });
            context.onChangeSummary(summary);
            if (isFormVisibleProp === undefined) {
                if (triggerUnmountTimeoutId) {
                    clearTimeout(triggerUnmountTimeoutId);
                    setTriggerUnmountTimeoutId(null);
                }
                setIsFormVisible(false);
            }
            onBlur();
            setHasCreatedIssueICC(true);
        }, [
        createAnalyticsEvent,
        isFormVisibleProp,
        onBlur,
        setHasCreatedIssueICC,
        triggerUnmountTimeoutId
    ]);
    const makeOnCreate = (0, $5uXOq.useCallback)((context)=>(issues, metadata)=>{
            // analytic event name will be changed in the future to match other events
            const analyticsEvent = createAnalyticsEvent({
                action: 'confirmed',
                actionSubject: 'input'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                createdBy: metadata.createdBy
            });
            context.onCreate();
            onCreate(issues, metadata, analyticsEvent);
            showEnforcementIfStorageIsFull({
                touchpoint: 'inline-card-create'
            });
            setHasCreatedIssueICC(true);
            setTriggerReason('lastIssueCreated');
        }, [
        createAnalyticsEvent,
        onCreate,
        showEnforcementIfStorageIsFull,
        setHasCreatedIssueICC,
        setTriggerReason
    ]);
    const makeOnCancel = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onCancel) return ()=>{
            context.onCancel();
            onCancelCallback();
        };
        return onCancelCallback;
    }, [
        onCancelCallback
    ]);
    const makeOnChangeCardType = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeCardType) return (issueTypeId)=>{
            context.onChangeCardType(issueTypeId);
            additionalIccProps?.onChangeCardType(issueTypeId);
            onChangeCardType(issueTypeId);
        };
        return onChangeCardType;
    }, [
        onChangeCardType,
        additionalIccProps
    ]);
    const makeOnChangeStatusTransition = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeFieldValue) return (transitionId)=>{
            context.onChangeFieldValue((0, $hNJJt.FIELD_KEY_STATUS_TRANSITIONS), transitionId);
            onChangeStatusTransition(transitionId);
        };
        return onChangeStatusTransition;
    }, [
        onChangeStatusTransition
    ]);
    const makeOnChangeSummary = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeSummary) return (summary)=>{
            context.onChangeSummary(summary);
            onChangeSummary(summary);
        };
        return onChangeSummary;
    }, [
        onChangeSummary
    ]);
    const makeOnChangeProject = (0, $5uXOq.useCallback)((context)=>{
        if (context && context.onChangeProject) return (projectId)=>{
            context.onChangeProject(projectId);
            onChangeProject(projectId);
        };
        return onChangeProject;
    }, [
        onChangeProject
    ]);
    const isCardTypesEmptyOrAllDisabled = cardTypes.every(({ isDisabled: isCardTypeDisabled })=>Boolean(isCardTypeDisabled));
    const isTriggerDisabled = cardTypes?.length ? isDisabled || isCardTypesEmptyOrAllDisabled : isDisabled;
    const shouldRenderForm = (isFormVisibleProp ?? isFormVisible) && !isTriggerDisabled;
    (0, $5uXOq.useEffect)(()=>{
        /* 	below block is intended for case where icc is automatically opened after icc issue
    	created when user opens originally opens icc in-between two existing issues */ if (shouldRenderForm === true && hasCreatedIssueICC) {
            // unique sessionId for each icc
            const sessionId = (0, $7Jxgt.v4)();
            // fires start event and sets sessionId for end event
            onAutoOpen(sessionId);
            const autoFocusAnalyticsEvent = createAnalyticsEvent({
                action: 'focused',
                actionSubject: 'input',
                actionSubjectId: 'inlineCreateCard'
            });
            (0, $8zOmE.fireUIAnalytics)(autoFocusAnalyticsEvent, {
                triggeredBy: 'autoFocus',
                reason: triggerReason
            });
            setHasCreatedIssueICC(false);
        }
    }, [
        createAnalyticsEvent,
        hasCreatedIssueICC,
        setHasCreatedIssueICC,
        shouldRenderForm,
        triggerReason,
        isFormVisible,
        triggerAppearance,
        onTriggerClick,
        onAutoOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "inline-card-create",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            appearance: appearance,
            numFilters: numFilters
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        /** fetchFields is only used for ICC experiment and will be undefined if experiment is not enabled */ onMouseOver: fetchFields,
        xcss: [
            $0d06f081c1e675aa$var$containerStyles,
            triggerUnmountTimeoutId !== null && $0d06f081c1e675aa$var$withTriggerUnmountStyles
        ],
        testId: "platform-inline-card-create.ui.container",
        ref: containerRef
    }, shouldRenderForm && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Z6La.IccContext).Consumer, null, (value)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dhszq.AsyncInlineCardCreateForm), {
            isCompactDueDatePicker: isCompactDueDatePicker,
            autoFocus: autoFocus ?? true,
            shouldScrollIntoView: shouldScrollIntoView ?? false,
            onSubmit: makeOnCreate(value),
            onCancel: makeOnCancel(value),
            onBlur: makeOnBlur(value),
            onChangeSummary: makeOnChangeSummary(value),
            numFilters: numFilters ?? 0,
            messages: messages ?? [],
            cardTypes: cardTypes,
            extraItems: extraItems,
            shouldKeepFormOpenOnClickOutside: shouldKeepFormOpenOnClickOutside || isConfiguringIssueType,
            selectedCardTypeId: $0d06f081c1e675aa$export$c283de3a59c46bc6(cardTypes, value.initialCardTypeId, defaultCardTypeId),
            selectedFieldValues: value.initialFieldValues,
            appearance: appearance ?? 'full',
            placeholderText: placeholderText ?? '',
            saveOnBlur: saveOnBlur ?? false,
            onChangeCardType: makeOnChangeCardType(value),
            onChangeStatusTransition: makeOnChangeStatusTransition(value),
            onChangeProject: makeOnChangeProject(value),
            initialSummary: value.initialSummary,
            renderAdditionalTypeSelectOptionContent: renderAdditionalTypeSelectOptionContent,
            renderAdditionalInlineCreateFooter: renderAdditionalInlineCreateFooter,
            renderCompactViewEditorExperimental: renderCompactViewEditorExperimental,
            renderCompactViewActionButtonExperimental: renderCompactViewActionButtonExperimental,
            TypeSelect: TypeSelect,
            StatusSelect: StatusSelect,
            statusTransitions: statusTransitions,
            selectedProjectId: value.initialProjectId,
            projects: projects,
            shouldShowCreateButton: shouldShowCreateButton,
            setFocusOnTrigger: setFocusOnTrigger,
            showIssueTypeConfigOptions: showIssueTypeConfigOptions,
            configSource: configSource,
            setIsConfiguringIssueType: setIsConfiguringIssueType,
            isConfiguringIssueType: isConfiguringIssueType,
            projectKey: projectKey,
            getShouldShowAdditionalFields: getShouldShowAdditionalFields,
            defaultAssignee: defaultAssignee,
            shouldShowDueDatePicker: shouldShowDueDatePicker && additionalIccProps?.shouldShowDueDatePicker,
            shouldShowAssigneePicker: shouldShowAssigneePicker && additionalIccProps?.shouldShowAssigneePicker,
            onInitialCardTypeSet: additionalIccProps?.onChangeCardType
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            triggerUnmountTimeoutId !== null && "_19pk10j7",
            !(!shouldRenderForm && triggerUnmountTimeoutId === null) && "_tzy4idpf"
        ])
    }, (!shouldRenderForm || triggerUnmountTimeoutId !== null) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l94uE.default), {
        isModalTrigger: isModalTrigger,
        isSticky: appearance === (0, $7462c685f739ed5a$export$aca095bc476d426f),
        triggerAppearance: triggerAppearance,
        label: triggerLabel,
        ariaLabel: triggerAriaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onTriggerClickCallback,
        isDisabled: isTriggerDisabled,
        shouldFocusTrigger: shouldFocusTrigger
    }))));
};
$0d06f081c1e675aa$var$InlineCardCreate.defaultProps = {
    isFormVisibleDefault: false,
    isDisabled: false,
    autoFocus: true,
    saveOnBlur: false,
    appearance: (0, $7462c685f739ed5a$export$3789e4b2a10baa2b),
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    triggerLabel: '',
    placeholderText: '',
    numFilters: 0,
    messages: [],
    cardTypes: [],
    extraItems: undefined,
    onCreate: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onBlur: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTriggerClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeSummary: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeCardType: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeStatusTransition: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeFormVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onChangeProject: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAutoOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    renderAdditionalInlineCreateFooter: undefined,
    renderCompactViewEditorExperimental: undefined,
    renderCompactViewActionButtonExperimental: undefined,
    shouldShowCreateButton: false,
    showIssueTypeConfigOptions: false,
    configSource: undefined
};
var $0d06f081c1e675aa$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($0d06f081c1e675aa$var$InlineCardCreate);
const $0d06f081c1e675aa$var$containerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '100%'
});
const $0d06f081c1e675aa$var$withTriggerUnmountStyles = (0, $8CUq3.xcss)({
    minHeight: `${$0d06f081c1e675aa$var$TRIGGER_HEIGHT}px`
});

});
parcelRegister("5knXz", function(module, exports) {

$parcel$export(module.exports, "useStorageEnforcement", () => $a61178001d7e3bbc$export$fa2c25e1ed13a1a8);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $dAfqg = parcelRequire("dAfqg");


var $RnWyv = parcelRequire("RnWyv");

var $l2AwX = parcelRequire("l2AwX");
const $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS = 86400000; // 1 day in ms
const $a61178001d7e3bbc$export$fa2c25e1ed13a1a8 = ()=>{
    const [currentState, { setIsOpen: setEnforceStorageModalIsOpen }] = (0, $l2AwX.useEnforceStorageModal)();
    const issueViewMode = (0, $2gCtH.useViewMode)();
    const { data: projectContextData } = (0, $dAfqg.useProjectContext)();
    const isInJSWProject = projectContextData?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const openModalIfNotOnCooldown = (0, $5uXOq.useCallback)((touchpoint)=>{
        const isOnCooldown = Date.now() - ((0, $RnWyv.localStorage).get((0, $3f79643dcab1adf8$export$ed785d2382d0101d)) || 0) < $a61178001d7e3bbc$var$MODAL_COOLDOWN_MS;
        if (isOnCooldown) {
            if (currentState.isOpen === 'pending') // Reset pending state if modal is on cooldown when it should be shown
            setEnforceStorageModalIsOpen({
                isOpen: 'closed',
                touchpoint: undefined
            });
        } else setEnforceStorageModalIsOpen({
            isOpen: 'open',
            touchpoint: touchpoint
        });
    }, [
        setEnforceStorageModalIsOpen,
        currentState.isOpen
    ]);
    const showEnforcementIfStorageIsFull = (0, $5uXOq.useCallback)(({ delayShow: delayShow = false, shouldOnlyShowInJSWContext: shouldOnlyShowInJSWContext = true, touchpoint: touchpoint })=>{
        if (shouldOnlyShowInJSWContext && !isInJSWProject) return;
        // Issue view use case is checked internally here rather than passed in, to avoid polluting consumer code
        if (delayShow || issueViewMode === 'MODAL') setEnforceStorageModalIsOpen({
            isOpen: 'pending',
            touchpoint: touchpoint
        });
        else openModalIfNotOnCooldown(touchpoint);
    }, [
        isInJSWProject,
        issueViewMode,
        setEnforceStorageModalIsOpen,
        openModalIfNotOnCooldown
    ]);
    // Used to show enforcement modal after modals are dismissed, to avoid modal on modal UX
    const showEnforcementIfPendingToShow = (0, $5uXOq.useCallback)(()=>{
        if (currentState.isOpen === 'pending') // Use the trigger from created the JSW issue
        openModalIfNotOnCooldown(currentState.touchpoint);
    }, [
        currentState.isOpen,
        openModalIfNotOnCooldown,
        currentState.touchpoint
    ]);
    return {
        showEnforcementIfStorageIsFull: showEnforcementIfStorageIsFull,
        showEnforcementIfPendingToShow: showEnforcementIfPendingToShow
    };
};

});
const $3f79643dcab1adf8$export$b8b9d90f9e5bd72b = 'jira-enforce-storage-limits';
const $3f79643dcab1adf8$export$ed785d2382d0101d = 'lastStorageEnforcement';

parcelRegister("RnWyv", function(module, exports) {

$parcel$export(module.exports, "localStorage", () => $5fd7f3930a81124f$export$c2ed3351cac403d1);

var $bSSG7 = parcelRequire("bSSG7");
const $5fd7f3930a81124f$export$c2ed3351cac403d1 = (0, $bSSG7.createLocalStorageProvider)('enforce-storage-limits');

});

parcelRegister("l2AwX", function(module, exports) {

$parcel$export(module.exports, "useEnforceStorageModal", () => $377250c350eb1ea3$export$56beb4c2629d6615);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $7FEwN = parcelRequire("7FEwN");
const $377250c350eb1ea3$var$initialState = {
    isOpen: 'closed',
    touchpoint: undefined
};
const $377250c350eb1ea3$var$store = (0, $iXqE5.createStore)({
    name: 'jsw-enforce-storage-limit-modal',
    initialState: $377250c350eb1ea3$var$initialState,
    actions: $7FEwN.actions
});
const $377250c350eb1ea3$export$56beb4c2629d6615 = (0, $3sQ5x.createHook)($377250c350eb1ea3$var$store);

});
parcelRegister("7FEwN", function(module, exports) {

$parcel$export(module.exports, "actions", () => $a1630f6ff8f7879d$export$e324594224ef24da);

var $aBMM9 = parcelRequire("aBMM9");
const $a1630f6ff8f7879d$export$e324594224ef24da = {
    setIsOpen: $aBMM9.setIsOpen
};

});
parcelRegister("aBMM9", function(module, exports) {

$parcel$export(module.exports, "setIsOpen", () => $bd4df525f1eeff62$export$dcf23146e0a40195);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
const $bd4df525f1eeff62$export$dcf23146e0a40195 = (newState)=>({ setState: setState })=>{
        setState(newState);
    };

});




parcelRegister("c4UiF", function(module, exports) {

$parcel$export(module.exports, "useLazyIssueTypesAndFieldsForICC", () => $d48cbb3e2c023f1d$export$dc13f1a4fac3d00c);

var $5uXOq = parcelRequire("5uXOq");

var $bQ0kt = parcelRequire("bQ0kt");
const $d48cbb3e2c023f1d$export$dc13f1a4fac3d00c = ({ projectKey: projectKey })=>{
    const [selectedCardTypeId, setSelectedCardTypeId] = (0, $5uXOq.useState)(null);
    const fieldsUtil = (0, $bQ0kt.useLazyIssueTypesFieldsMap)({
        projectKey: projectKey
    });
    return {
        fetchFields: fieldsUtil.load,
        iccProps: (0, $5uXOq.useMemo)(()=>({
                shouldShowDueDatePicker: fieldsUtil.checkIssueTypeHasField(selectedCardTypeId, 'duedate'),
                shouldShowAssigneePicker: fieldsUtil.checkIssueTypeHasField(selectedCardTypeId, 'assignee'),
                onChangeCardType: setSelectedCardTypeId
            }), [
            fieldsUtil,
            selectedCardTypeId
        ])
    };
};

});
parcelRegister("bQ0kt", function(module, exports) {

$parcel$export(module.exports, "useLazyIssueTypesFieldsMap", () => $172181ad15050282$export$6e72d76da900f375);

var $5uXOq = parcelRequire("5uXOq");

var $34uA1 = parcelRequire("34uA1");
const $172181ad15050282$export$6e72d76da900f375 = ({ projectKey: projectKey })=>{
    // This state is kept per individual ICC trigger (each footer "+ Create" and sibling "+" (hidden) button)
    // Use shared state instead of local state for "dirty" to avoid re-fetching between cards
    const [dirty, setDirty] = (0, $5uXOq.useState)(false);
    const [issueTypeMap, setIssueTypeMap] = (0, $5uXOq.useState)(null);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const loading = dirty && !issueTypeMap && !error;
    const done = dirty && !loading;
    const load = (0, $5uXOq.useCallback)(()=>{
        // define caching strategy here. For now there's none and it won't be called twice for each button
        if (dirty || !projectKey) return;
        setDirty(true);
        (0, $34uA1.getIssueTypesAndFields)({
            projectKey: projectKey
        }).then(setIssueTypeMap).catch(setError);
    }, [
        dirty,
        projectKey
    ]);
    const checkIssueTypeHasField = (0, $5uXOq.useCallback)((issueTypeId, fieldId)=>{
        if (!issueTypeId || !issueTypeMap || !issueTypeMap[issueTypeId]) return false;
        return issueTypeMap[issueTypeId].fields.some((f)=>f.fieldId === fieldId);
    }, [
        issueTypeMap
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            load: load,
            error: error,
            done: done,
            loading: loading,
            issueTypeMap: issueTypeMap,
            checkIssueTypeHasField: checkIssueTypeHasField
        }), [
        load,
        error,
        done,
        loading,
        issueTypeMap,
        checkIssueTypeHasField
    ]);
};

});
parcelRegister("34uA1", function(module, exports) {

$parcel$export(module.exports, "getIssueTypesAndFields", () => $fb687dab2c5ae1cd$export$9205dae0ca81a60c);

var $eusud = parcelRequire("eusud");

const $fb687dab2c5ae1cd$export$9205dae0ca81a60c = ({ projectKey: projectKey })=>{
    return (0, $eusud.performPostRequest)('/rest/gira/1/?operation=JiraBusinessProjectDetails', {
        body: JSON.stringify({
            query: (0, $f62684c4bc22b630$export$e94926d83673c36b),
            variables: {
                projectKey: projectKey,
                issueOperation: 'CREATE',
                first: 100
            }
        })
    }).then($fb687dab2c5ae1cd$export$eca82dd5c4bcf11e);
};
const $fb687dab2c5ae1cd$export$eca82dd5c4bcf11e = (response)=>{
    const resultingMap = {};
    response.data.jiraBusinessAvailableFields.edges.forEach(({ node: typeNode })=>{
        const { issueTypeId: issueTypeId } = typeNode.issueType;
        resultingMap[issueTypeId] = {
            issueTypeId: issueTypeId,
            fields: typeNode.fields.edges.map(({ node: fieldNode })=>({
                    fieldId: fieldNode.fieldId
                }))
        };
    });
    return resultingMap;
};

});
const $f62684c4bc22b630$export$e94926d83673c36b = `query JiraWorkTypeFieldAssociation($projectKey: String!, $issueOperation: JiraBusinessIssueOperation, $first: Int, $last: Int, $before: String, $after: String) {
  jiraBusinessAvailableFields(
    projectKey: $projectKey
    issueOperation: $issueOperation
    first: $first
    last: $last
    before: $before
    after: $after
  ) {
    edges {
      node {
        issueType {
          issueTypeId
        }
        fields {
          edges {
            node {
              fieldId
            }
          }
        }
      }
    }
  }
}`;




parcelRegister("dhszq", function(module, exports) {

$parcel$export(module.exports, "AsyncInlineCardCreateForm", () => $a64c6427d6c752bd$export$4f2abfdfd1993102);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $a64c6427d6c752bd$var$AsyncInlineCardCreateFormComp = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("e5Ne6")), {
    moduleId: "./src/packages/platform/ui/inline-card-create/src/ui/form/main.tsx"
});
const $a64c6427d6c752bd$export$4f2abfdfd1993102 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async-inline-card-create-form",
        packageName: "JiraPlatformBoardKit"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-inline-card-create-form",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a64c6427d6c752bd$var$AsyncInlineCardCreateFormComp, props)));

});
parcelRegister("e5Ne6", function(module, exports) {

let $a427b7ac67822718$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $a427b7ac67822718$var$load("76n7a"),
    $a427b7ac67822718$var$load("l253H"),
    $a427b7ac67822718$var$load("ffQaD"),
    $a427b7ac67822718$var$load("kvRbA"),
    $a427b7ac67822718$var$load("7YwPO")
]).then(()=>parcelRequire('kNtWa'));

});


parcelRegister("l94uE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9719a5afff7fc59d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");


var $gBq9h = parcelRequire("gBq9h");

var $egFHr = parcelRequire("egFHr");

var $5Qqfj = parcelRequire("5Qqfj");
function $9719a5afff7fc59d$export$41fb9f06171c75f4({ isDisabled: isDisabled, triggerAppearance: triggerAppearance, isSticky: isSticky, label: label, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, onClick: onClick, intl: { formatMessage: formatMessage }, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false }) {
    const defaultLabel = label || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $egFHr.default).labelIssueTermRefresh : (0, $egFHr.default).label);
    if (triggerAppearance === (0, $7462c685f739ed5a$export$dda6912361cddac9)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Qqfj.default), {
        isModalTrigger: isModalTrigger,
        isSticky: isSticky,
        label: defaultLabel,
        ariaLabel: ariaLabel,
        ariaLabelledBy: ariaLabelledBy,
        onClick: onClick,
        isDisabled: isDisabled,
        shouldFocusTrigger: shouldFocusTrigger
    });
    if (isDisabled !== true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gBq9h.default), {
        label: defaultLabel,
        onClick: onClick,
        shouldFocusTrigger: shouldFocusTrigger
    });
    return null;
}
$9719a5afff7fc59d$export$41fb9f06171c75f4.defaultProps = {
    isDisabled: false,
    isSticky: false,
    triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
    label: '',
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    shouldFocusTrigger: false
};
var $9719a5afff7fc59d$export$2e2bcd8739ae039 = (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
})((0, $az4zD.injectIntlV2)($9719a5afff7fc59d$export$41fb9f06171c75f4));

});
parcelRegister("egFHr", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f56794831a7b04b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0f56794831a7b04b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "inline-card-create.trigger.label",
        "defaultMessage": "Create issue"
    },
    labelIssueTermRefresh: {
        "id": "inline-card-create.trigger.label-issue-term-refresh",
        "defaultMessage": "Create"
    }
});

});

parcelRegister("5Qqfj", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd137c52878495bb$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");

var $99M5v = parcelRequire("99M5v");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $iKdRC = parcelRequire("iKdRC");
const $cd137c52878495bb$var$labelWrapperStyles = null;
const $cd137c52878495bb$var$contentWrapperStyles = null;
const $cd137c52878495bb$export$305831e851c35a16 = ({ isDisabled: isDisabled = false, isSticky: isSticky = false, label: label, ariaLabel: ariaLabel, ariaLabelledBy: ariaLabelledBy, onClick: onClick, isModalTrigger: isModalTrigger, shouldFocusTrigger: shouldFocusTrigger = false })=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const iccButtonTheme = (currentTheme, props)=>{
        const themeProps = {
            ...props
        };
        const { buttonStyles: buttonStyles, spinnerStyles: spinnerStyles } = currentTheme(themeProps);
        return {
            buttonStyles: {
                ...buttonStyles,
                marginTop: "var(--ds-space-025, 2px)",
                marginBottom: "var(--ds-space-025, 2px)",
                height: `${(0, $gwIPs.gridSize) * 4.5}px`,
                alignItems: 'center'
            },
            spinnerStyles: spinnerStyles
        };
    };
    const iconColor = isDisabled ? "var(--ds-icon-disabled, #091E424F)" : "var(--ds-icon, #44546F)";
    const shouldShowTooltip = label.length > 16;
    const renderStickyContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
            className: (0, $bwpsq.default)([
                "_1e0c1txw _2lx2vrvc _4cvr1h6o _1bah1e5h"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
            label: "",
            color: iconColor,
            LEGACY_size: "small"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1ule _18u01b66 _1reo15vq _1wnr15vq"
            ])
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cd137c52878495bb$var$labelContextStyles,
            as: "span"
        }, label)));
    const ButtonComponent = isModalTrigger ? (0, $iKdRC.ModalTriggerButton) : (0, $9yOBd.default);
    const renderButtonComponent = (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
            ...triggerProps,
            iconBefore: isSticky ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
                testId: "platform-inline-card-create.ui.trigger.visible.add-icon",
                label: "",
                color: iconColor,
                LEGACY_size: "small"
            }),
            appearance: "subtle",
            theme: iccButtonTheme,
            shouldFitContainer: true,
            onClick: onClick,
            isDisabled: isDisabled,
            testId: "platform-inline-card-create.ui.trigger.visible.button",
            "aria-labelledby": ariaLabelledBy,
            "aria-label": ariaLabel || label,
            autoFocus: shouldFocusTrigger
        }, isSticky ? renderStickyContent() : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $cd137c52878495bb$var$labelContextStyles,
            as: "span"
        }, label));
    return shouldShowTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        tag: "span"
    }, renderButtonComponent) : renderButtonComponent();
};
const $cd137c52878495bb$var$labelContextStyles = (0, $8CUq3.xcss)({
    display: 'block',
    textAlign: 'left',
    textOverflow: 'ellipsis',
    overflowX: 'hidden'
});
var $cd137c52878495bb$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($cd137c52878495bb$export$305831e851c35a16);

});
parcelRegister("iKdRC", function(module, exports) {

$parcel$export(module.exports, "ModalTriggerButton", () => $dd7ef71db2053b80$export$f69d15d2f52857d);

var $5uXOq = parcelRequire("5uXOq");

var $9yOBd = parcelRequire("9yOBd");
var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $hCCtP = parcelRequire("hCCtP");

var $lu5k0 = parcelRequire("lu5k0");
const $dd7ef71db2053b80$export$f69d15d2f52857d = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const internalRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const handleRef = (0, $5uXOq.useCallback)((element)=>{
        if (ref) {
            if (typeof ref === 'function') ref(element);
            else {
                // We need to proxy ref to avoid an eslint error (no-param-reassign)
                const mutableRef = ref;
                mutableRef.current = element;
            }
        }
        internalRef.current = element;
    }, [
        ref
    ]);
    const isIconProp = 'icon' in props;
    const onClickHandler = !isIconProp ? props.onClick : undefined;
    const iconButtonOnClickHandler = isIconProp ? props.onClick : undefined;
    const onClick = (0, $5uXOq.useCallback)((...args)=>{
        if (!isIconProp) {
            // @ts-expect-error - Type 'HTMLElement' is missing the following properties from type 'HTMLButtonElement': disabled, form, formAction, formEnctype, and 15 more.ts(2345)
            onClickHandler?.(...args);
            setReturnFocusTo(internalRef);
        }
    }, [
        isIconProp,
        setReturnFocusTo,
        internalRef,
        onClickHandler
    ]);
    const onIconButtonClick = (0, $5uXOq.useCallback)((...args)=>{
        if (isIconProp) {
            iconButtonOnClickHandler?.(...args);
            setReturnFocusTo(internalRef);
        }
    }, [
        isIconProp,
        setReturnFocusTo,
        internalRef,
        iconButtonOnClickHandler
    ]);
    if ('icon' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...props,
        ref: handleRef,
        onClick: onIconButtonClick
    });
    if ('theme' in props) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        ...props,
        ref: handleRef,
        onClick: onClick
    });
    if ('isThemed' in props) {
        // TODO: this is a temporary solution to make sure themed button only exist for board
        // we should clean up this component so the types don't need to be suppressed
        // https://hello.jira.atlassian.cloud/browse/DEE-6985
        const { isThemed: isThemed, ...others } = props;
        if (isThemed) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedButtonNew), {
            ...others,
            ref: handleRef,
            onClick: onClick
        });
    }
    // @ts-expect-error - TS2322 - Type 'Props' is not assignable to type 'ButtonProps'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ...props,
        ref: handleRef,
        onClick: onClick
    });
});

});




parcelRegister("cVImo", function(module, exports) {

$parcel$export(module.exports, "HiddenButtonWrapper", () => $0f59c12b565bfb9d$export$d0ba86f106688d98);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
const $0f59c12b565bfb9d$var$withToolTip = (component, message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$var$StyledButton, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message,
        position: "bottom"
    }, component));
class $0f59c12b565bfb9d$export$d22c1bb6554a6b47 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            appearance: 'button'
        };
    }
    render() {
        const { appearance: appearance } = this.props;
        if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.create-button-text.icon-label-v2-issue-term-refresh",
            defaultMessage: "Create"
        }, (formattedMessage)=>{
            const message = typeof formattedMessage[0] === 'string' ? formattedMessage[0] : 'Create';
            const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$var$CreateButton, {
                onClick: this.props.onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                label: message,
                color: "var(--ds-text-subtlest, #626F86)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
                LEGACY_size: "small",
                LEGACY_primaryColor: "var(--ds-text-subtlest, #626F86)"
            }));
            if (appearance === 'hidden-button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$export$d0ba86f106688d98, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$var$ButtonWrapper, null, button));
            return $0f59c12b565bfb9d$var$withToolTip(button, String(message));
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            id: "platform-board.create-button-text.icon-label-v2",
            defaultMessage: "Create issue"
        }, (formattedMessage)=>{
            const message = typeof formattedMessage[0] === 'string' ? formattedMessage[0] : 'Create issue';
            const button = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$var$CreateButton, {
                onClick: this.props.onClick
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                label: message,
                color: "var(--ds-text-subtlest, #626F86)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
                LEGACY_size: "small",
                LEGACY_primaryColor: "var(--ds-text-subtlest, #626F86)"
            }));
            if (appearance === 'hidden-button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$export$d0ba86f106688d98, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0f59c12b565bfb9d$var$ButtonWrapper, null, button));
            return $0f59c12b565bfb9d$var$withToolTip(button, String(message));
        });
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$CreateButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _19itglyw _bfhk18uv _1bsb1osq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf _4t3i1tcg _80omtlke _nt751r31 _49pcglyw _1hvw1o36 _7ehi1vm4 _irr315ej",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk14y2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk14y2",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-exported-styles -- To migrate as part of go/ui-styling-standard
const $0f59c12b565bfb9d$export$d0ba86f106688d98 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isICCFormOpen: isICCFormOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ep9kb7n _t7oxkb7n _173kkb7n _1h7hkb7n _1mygkb7n _16l4kb7n",
            __cmplp.isICCFormOpen ? "_tzy4kb7n" : "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});


const $f1340a435190eeda$export$c766acff4513a976 = 'summaryView';
const $f1340a435190eeda$export$4edb790587638895 = 'listView';
const $f1340a435190eeda$export$cafb161c2b21b455 = 'issueView';
const $f1340a435190eeda$export$66397ed56abea4ca = 'gicView';
const $f1340a435190eeda$export$a1077f863a923e94 = 'gicViewNoResults';
const $f1340a435190eeda$export$7f04bd1df3763938 = 'jswBoard';
const $f1340a435190eeda$export$bd8f63529bb9357f = 'jswBacklog';
const $f1340a435190eeda$export$57eacdfdee901d4c = 'jswTimeline';
const $f1340a435190eeda$export$8f4fd516b77f8d43 = 'unknown';
const $f1340a435190eeda$export$334975a13cb19c35 = 'editIssueTypeButton';
const $f1340a435190eeda$export$e970abb363c8ec67 = 'deleteIssueTypeButton';

parcelRegister("3ZtL7", function(module, exports) {

$parcel$export(module.exports, "getAssigneeId", () => $b5078a902783c47f$export$5629498a3f321816);
$parcel$export(module.exports, "getAppliedLabelFilters", () => $b5078a902783c47f$export$60ee89f2718fc651);
$parcel$export(module.exports, "getLastFilteredSprintId", () => $b5078a902783c47f$export$1ba531d8735fc55c);
$parcel$export(module.exports, "getAssignee", () => $b5078a902783c47f$export$faae7c2d4768067b);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $9XE6b = parcelRequire("9XE6b");

var $hYfgW = parcelRequire("hYfgW");


var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");
const $b5078a902783c47f$export$70530ceddeedcded = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getBoardConfig)
], (config)=>config.boardIssueListKey ? {
        issueList: {
            addTo: [
                config.boardIssueListKey
            ]
        }
    } : null);
const $b5078a902783c47f$var$getRankPayloadWithInsertBefore = (0, $dGvGJ.createSelector)([
    (0, $d2i8f.getRankConfig),
    (0, $vAfHD.boardIssuesSelector)
], (rankConfig, allIssues)=>(insertBefore)=>rankConfig.boardIsRankable ? {
            [`customfield_${rankConfig.rankCustomFieldId}`]: {
                rankBeforeIssue: allIssues[String(insertBefore)].key
            }
        } : null);
const $b5078a902783c47f$export$eb06069093b28292 = (state, insertBefore)=>insertBefore ? $b5078a902783c47f$var$getRankPayloadWithInsertBefore(state)(insertBefore) : null;
const $b5078a902783c47f$var$emptyArray = (0, $7uUwQ.freeze)([]);
const $b5078a902783c47f$var$getAppliedAssigneeFilters = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.getWorkFilters)
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$f8f7545d2bb78afb)
    ], $b5078a902783c47f$var$emptyArray));
const $b5078a902783c47f$export$a2066b677dcc0c86 = (0, $dGvGJ.createSelector)([
    $b5078a902783c47f$var$getAppliedAssigneeFilters,
    (0, $36pz7.getPeople)
], (assignees, people)=>{
    if (assignees.length > 0) {
        const { id: id } = people[assignees[assignees.length - 1]] || {};
        return id == null ? null : {
            assignee: {
                id: id
            }
        };
    }
    return null;
});
const $b5078a902783c47f$export$5629498a3f321816 = (state)=>$b5078a902783c47f$export$a2066b677dcc0c86(state)?.assignee?.id || null;
const $b5078a902783c47f$export$60ee89f2718fc651 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.getWorkFilters)
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$37aee82a3cb1e8f7)
    ], $b5078a902783c47f$var$emptyArray));
const $b5078a902783c47f$export$1ba531d8735fc55c = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.getWorkFilters)
], (filters)=>(0, (/*@__PURE__*/$parcel$interopDefault($hYfgW)))((0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filters, [
        'values',
        (0, $dcff40112356dfc1$export$a316570a0dbfd2b0)
    ], $b5078a902783c47f$var$emptyArray)));
const $b5078a902783c47f$export$faae7c2d4768067b = (0, $dGvGJ.createSelector)([
    (0, $36pz7.getPeople),
    $b5078a902783c47f$export$5629498a3f321816
], (people, assigneeId)=>assigneeId && people ? people[assigneeId] : null);

});

parcelRegister("b6Ykj", function(module, exports) {

$parcel$export(module.exports, "useOnCreate", () => $0cc1261bd7dd1bf5$export$b0b39ca6034d00d8);
$parcel$export(module.exports, "useShouldRenderIccInPopper", () => $0cc1261bd7dd1bf5$export$a36f3ef251552351);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $9XE6b = parcelRequire("9XE6b");

var $k7m40 = parcelRequire("k7m40");

var $4R6GH = parcelRequire("4R6GH");

var $iHPnC = parcelRequire("iHPnC");

var $g4tDr = parcelRequire("g4tDr");

var $4jAPy = parcelRequire("4jAPy");

var $2NMNM = parcelRequire("2NMNM");

var $5rFbt = parcelRequire("5rFbt");



var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $bwTbl = parcelRequire("bwTbl");

var $cvIZ8 = parcelRequire("cvIZ8");

var $2f454 = parcelRequire("2f454");

var $blI7M = parcelRequire("blI7M");

var $ls4NM = parcelRequire("ls4NM");

var $67sX6 = parcelRequire("67sX6");

var $gXFr2 = parcelRequire("gXFr2");

var $fyeGd = parcelRequire("fyeGd");

var $9UXXB = parcelRequire("9UXXB");

var $3ZtL7 = parcelRequire("3ZtL7");

var $3EsnH = parcelRequire("3EsnH");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $fwQRP = parcelRequire("fwQRP");

var $j4MnI = parcelRequire("j4MnI");
const $0cc1261bd7dd1bf5$var$emptyObj = (0, $7uUwQ.freeze)({});
const $0cc1261bd7dd1bf5$var$emptyArray = [];
const $0cc1261bd7dd1bf5$export$b0b39ca6034d00d8 = ({ cardIndex: cardIndex, cardTypes: cardTypes, columnId: columnId, insertBefore: insertBefore, projectId: projectIdArg, swimlaneId: swimlaneId, groupParentId: groupParentId, isLastSwimlane: isLastSwimlane, isUnscheduledColumn: isUnscheduledColumn })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const programBoardEstimateFieldId = (0, $67sX6.useBoardSelector)((0, $67Z81.getIncrementPlanningEstimateFieldId));
    const getSwimlaneValues = (0, $67sX6.useBoardSelector)((0, $4jZ56.makeSwimlaneValuesSelector));
    const inlineCreateSessionId = (0, $67sX6.useBoardSelector)((0, $9UXXB.getInlineCreateSessionId));
    const getInitialTransitionsForColumn = (0, $67sX6.useBoardSelector)((0, $gXFr2.getInitialTransitionsForColumn));
    const config = (0, $67sX6.useBoardSelector)((0, $9UXXB.getInlineCardCreateConfig));
    const getParentId = (0, $67sX6.useBoardSelector)((0, $gXFr2.getParentIdForIssueCreation));
    const assigneeAccountId = (0, $67sX6.useBoardSelector)((0, $3ZtL7.getAssigneeId));
    const columnStatuses = (0, $67sX6.useBoardSelector)((state)=>(0, $fyeGd.getStatusColumn)((0, $fyeGd.getColumns)(state)[String(columnId)])?.statuses ?? $0cc1261bd7dd1bf5$var$emptyArray);
    const scenarioColor = (0, $67sX6.useBoardSelector)((0, $67Z81.getScenarioColor));
    const labels = (0, $67sX6.useBoardSelector)((0, $3ZtL7.getAppliedLabelFilters));
    const lastFilteredSprintId = (0, $67sX6.useBoardSelector)((0, $3ZtL7.getLastFilteredSprintId));
    const columnStatusMapping = (0, $67sX6.useBoardSelector)((0, $fyeGd.columnStatusMappingSelector));
    const columnIndex = (0, $67sX6.useBoardSelector)((state)=>(0, $fyeGd.getColumnIndex)(state, columnId));
    const getCardDndType = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCardDndType));
    const missingParents = (0, $67sX6.useBoardSelector)((0, $67Z81.getMissingParents));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const activeSprints = (0, $67sX6.useBoardSelector)((0, $ebHh7.activeSprintsSelector));
    const fixVersions = (0, $67sX6.useBoardSelector)((0, $5mTgl.getFixVersions));
    const getDefaultPriority = (0, $67sX6.useBoardSelector)((0, $3EsnH.getDefaultPriorityByProjectId));
    const onCreate = (0, $5uXOq.useCallback)(// TODO-BOARD-REFACTOR-TYPES
    // @ts-expect-error inconsistent first argument
    (partialIssues, // TODO: WOLVES-1889 this argument can be removed after experiment is over
    onCreateOptions = {})=>{
        const { issueCreatedAnalyticsEventAttributes: issueCreatedAnalyticsEventAttributes = {} } = onCreateOptions;
        const analyticsEvent = createAnalyticsEvent({
            action: 'created'
        });
        let swimlaneFields = $0cc1261bd7dd1bf5$var$emptyObj;
        const swimlaneValues = swimlaneId ? getSwimlaneValues(swimlaneId) : null;
        const parentId = getParentId(projectIdArg);
        const cardDndType = groupParentId ? (0, $dcbb2bce513725b3$export$1f24f91824c6822f) : getCardDndType(isLastSwimlane);
        const isSubtaskMissingParent = groupParentId ? !!missingParents[groupParentId] : false;
        if (swimlaneValues && swimlaneValues.type === (0, $c79wa.ASSIGNEE)) swimlaneFields = (0, $bwTbl.getIssueAssignee)(swimlaneValues);
        // parent is epic
        if (swimlaneValues && swimlaneValues.type === (0, $c79wa.PARENT)) swimlaneFields = {
            parentId: swimlaneValues.parentId
        };
        // story is subtask
        if (swimlaneValues && swimlaneValues.type === (0, $c79wa.STORY) && swimlaneValues.parentId != null) swimlaneFields = {
            parentId: swimlaneValues.parentId
        };
        // in IP board
        if (swimlaneValues && swimlaneValues.type === (0, $4jAPy.TEAM)) swimlaneFields = {
            teamId: swimlaneId
        };
        // Create subtask in issue group. It has to override the swimlane value.
        if (groupParentId) swimlaneFields = {
            ...swimlaneFields,
            parentId: groupParentId
        };
        const { cardType: cardType } = partialIssues[0];
        const cardTypeEntity = cardTypes.find(({ id: id })=>id === cardType);
        const isSubtask = cardTypeEntity?.hierarchyLevelType === (0, $g4tDr.CHILD_HIERARCHY_TYPE);
        let transitionEntity;
        const { transition: transition } = partialIssues[0];
        if (cardTypeEntity) {
            const issueTypeTransitions = !isIPBoard ? getInitialTransitionsForColumn(columnId) : null;
            transitionEntity = issueTypeTransitions?.[cardTypeEntity.id]?.find(({ id: id })=>id === transition);
        }
        let sprintId = '';
        if (activeSprints) {
            if (activeSprints.length === 1) sprintId = activeSprints[0].id.toString();
            else if (activeSprints.length > 1) sprintId = lastFilteredSprintId ?? '';
        }
        if ((0, $fwQRP.isPartialIccMode)(columnId, cardTypeEntity?.id ?? '', config)) {
            const statusIds = !isIPBoard ? columnStatuses.map(({ id: id })=>id) : undefined;
            dispatch((0, $blI7M.openGlobalIssueCreate)({
                cardSummary: partialIssues[0].summary,
                cardTypeId: Number(cardType),
                rankBeforeCardId: insertBefore || null,
                cardParentId: swimlaneFields.parentId || parentId,
                assigneeId: swimlaneFields.assigneeAccountId || assigneeAccountId,
                isSubtask: isSubtask,
                sessionId: inlineCreateSessionId,
                statusId: transitionEntity?.destinationStatusId || statusIds?.[0],
                ...sprintId ? {
                    sprintId: sprintId
                } : {},
                ...swimlaneId ? {
                    swimlaneId: swimlaneId
                } : {},
                cardTypeName: cardTypeEntity?.name || ''
            }));
            return;
        }
        const issues = partialIssues.map((item)=>{
            const issueType = cardTypes.filter((c)=>Number(c.id) === Number(item.cardType));
            // only set the default issue priority in the IP board
            const priority = isIPBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') ? getDefaultPriority(`${item.projectId}`) ?? null : null;
            const issueParentId = (()=>{
                if (isIPBoard && issueType.length > 0 && issueType[0].hierarchyLevelType !== (0, $g4tDr.BASE_HIERARCHY_TYPE)) return null;
                return parentId;
            })();
            const cardColor = isIPBoard ? {
                cardColor: scenarioColor
            } : {};
            const hasScenarioChanges = isIPBoard ? {
                hasScenarioChanges: true
            } : {};
            const color = isIPBoard && issueType.length > 0 && issueType[0].hierarchyLevelType === (0, $g4tDr.PARENT_HIERARCHY_TYPE) ? {
                color: (0, $iHPnC.getRandomColor)()
            } : {};
            const projectId = (isIPBoard ? item.projectId : projectIdArg) || 0;
            const estimate = isIPBoard && programBoardEstimateFieldId ? {
                fieldId: programBoardEstimateFieldId,
                type: (0, $b383ed62f6689e0b$export$24c68738fb7a96c7),
                value: ''
            } : null;
            const issue = {
                id: (0, $cvIZ8.generateId)(),
                key: '',
                summary: item.summary,
                columnId: columnId,
                projectId: projectId,
                typeId: Number(item.cardType),
                statusId: 0,
                assigneeAccountId: item.assigneeId || assigneeAccountId,
                typeName: cardTypeEntity?.name,
                typeUrl: cardTypeEntity?.iconUrl,
                parentId: issueParentId,
                labels: labels,
                isDone: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(columnStatusMapping, [
                    String(columnId),
                    'isDone'
                ], false),
                estimate: estimate,
                priority: priority,
                dueDate: item.dueDate ? (0, $k7m40.default)(new Date(item.dueDate), 'yyyy-MM-dd') : null,
                numCompleteChildren: 0,
                numTotalChildren: 0,
                fixVersions: fixVersions,
                sprintId: sprintId,
                ...cardColor,
                ...hasScenarioChanges,
                ...swimlaneFields,
                ...color
            };
            return issue;
        });
        const issueIds = issues.map((issue)=>issue.id);
        const action = (0, $ls4NM.issueCreateRequest)({
            temporaryIssueIds: issueIds,
            issues: issues,
            insertBefore: insertBefore || null,
            columnIndex: columnIndex,
            cardIndex: cardIndex,
            swimlaneId: swimlaneId,
            type: cardDndType,
            isSubtaskMissingParent: isSubtaskMissingParent,
            analyticsEvent: analyticsEvent.update({
                ...issueCreatedAnalyticsEventAttributes,
                swimlaneMode: swimlaneMode,
                swimlaneId: swimlaneId,
                sessionId: inlineCreateSessionId
            }),
            transitionInfo: transitionEntity ? {
                transitionId: String(transitionEntity.id),
                statusId: transitionEntity.destinationStatusId
            } : null,
            isSwimlaneByJql: swimlaneMode === (0, $iuuJH.SWIMLANE_BY_JQL).id
        });
        dispatch(action);
        if (isIPBoard && isUnscheduledColumn) dispatch((0, $2f454.closeIccInUnscheduledColumn)());
    }, [
        createAnalyticsEvent,
        swimlaneId,
        getSwimlaneValues,
        getParentId,
        projectIdArg,
        groupParentId,
        getCardDndType,
        isLastSwimlane,
        missingParents,
        cardTypes,
        activeSprints,
        columnId,
        config,
        insertBefore,
        columnIndex,
        cardIndex,
        swimlaneMode,
        inlineCreateSessionId,
        dispatch,
        isIPBoard,
        isUnscheduledColumn,
        getInitialTransitionsForColumn,
        lastFilteredSprintId,
        columnStatuses,
        assigneeAccountId,
        getDefaultPriority,
        scenarioColor,
        programBoardEstimateFieldId,
        labels,
        columnStatusMapping,
        fixVersions
    ]);
    return onCreate;
};
const $0cc1261bd7dd1bf5$export$a36f3ef251552351 = ({ isFormVisible: isFormVisible, columnId: columnId })=>{
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const isUnscheduledColumn = isIPBoard && columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID);
    const isIPBoardScheduledColumns = isIPBoard && !isUnscheduledColumn;
    const isDependencyVisualisationVisible = (0, $67sX6.useBoardSelector)((0, $j4MnI.isDependencyVisualisationVisible));
    return (0, $5uXOq.useMemo)(()=>isDependencyVisualisationVisible && isIPBoardScheduledColumns && isFormVisible && (0, $4R6GH.fg)('render_program_board_card_in_popup'), [
        isDependencyVisualisationVisible,
        isIPBoardScheduledColumns,
        isFormVisible
    ]);
};

});
parcelRegister("cvIZ8", function(module, exports) {

$parcel$export(module.exports, "generateId", () => $76839e08867b356b$export$567fc7097e064344);
// hacky way to generate optimistic issue id, not ideal but have to do it for now
// to react backwards compatibility with current ICC
let $76839e08867b356b$var$lastCardId = 0;
const $76839e08867b356b$export$567fc7097e064344 = ()=>{
    $76839e08867b356b$var$lastCardId -= 1;
    return $76839e08867b356b$var$lastCardId;
};

});

parcelRegister("3EsnH", function(module, exports) {

$parcel$export(module.exports, "getPrioritiesByProjectId", () => $221cbce20794f980$export$93d98ef29ff716e3);
$parcel$export(module.exports, "getDefaultPriorityByProjectId", () => $221cbce20794f980$export$aa133cc609dff0f);

var $alNv9 = parcelRequire("alNv9");

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");
const $221cbce20794f980$export$4e6a0813404f870a = (state)=>(0, $alNv9.ensureState)(state.entities).issuePriorityInformation;
const $221cbce20794f980$export$e1d6919e7f1f3060 = (0, $dGvGJ.createSelector)([
    $221cbce20794f980$export$4e6a0813404f870a
], (issuePriorityInformation)=>(projectId)=>{
        const schemeId = (0, $7uUwQ.getIn)(issuePriorityInformation, [
            'projectToPrioritySchemeAssociations',
            projectId
        ]);
        return (0, $7uUwQ.getIn)(issuePriorityInformation, [
            'issuePrioritySchemes',
            schemeId
        ]);
    });
const $221cbce20794f980$export$489e9c0d7da0a5e2 = (0, $dGvGJ.createSelector)([
    $221cbce20794f980$export$4e6a0813404f870a
], (issuePriorityInformation)=>issuePriorityInformation?.issuePriorities || {});
const $221cbce20794f980$export$93d98ef29ff716e3 = (0, $dGvGJ.createSelector)([
    $221cbce20794f980$export$e1d6919e7f1f3060,
    $221cbce20794f980$export$489e9c0d7da0a5e2
], (getSchemeByProjectId, priorities)=>(projectId)=>{
        const scheme = getSchemeByProjectId(projectId);
        const priorityIds = scheme?.issuePriorityIds || [];
        return priorityIds.map((id)=>priorities[id]);
    });
const $221cbce20794f980$export$aa133cc609dff0f = (0, $dGvGJ.createSelector)([
    $221cbce20794f980$export$e1d6919e7f1f3060,
    $221cbce20794f980$export$489e9c0d7da0a5e2
], (getSchemeByProjectId, priorities)=>(projectId)=>{
        const scheme = getSchemeByProjectId(projectId);
        const defaultIssuePriorityId = scheme?.defaultIssuePriorityId;
        return (0, $7uUwQ.getIn)(priorities, [
            defaultIssuePriorityId
        ]);
    });

});


parcelRegister("cP1xj", function(module, exports) {

$parcel$export(module.exports, "useCallbacksWrappersForPICExperimentMeasures", () => $7ad3374b26e77df2$export$afcf49ca3d5849e0);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $x9xyg = parcelRequire("x9xyg");

const $7ad3374b26e77df2$export$afcf49ca3d5849e0 = ({ onChangeFormVisible: onChangeFormVisible, onCreate: onCreate })=>{
    const [PICExperimentConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jira_powerful_inline_create_for_software_board');
    const isPICExperimentEnabled = PICExperimentConfig.get('isEnabled', false);
    const onChangeFormVisibleWithExperimentMeasure = isPICExperimentEnabled ? (0, $5uXOq.useCallback)((isFormVisible)=>{
        if (isFormVisible) // Whenever this form is made visible, set a mark to measure the delay between form open and onCreate
        // being called. This is to quantify the experience between seeing the form and creating an issue
        (0, $x9xyg.setMark)((0, $3fcafa70dda2ad19$export$3c53e2610a4054e2));
        else // Whenever this form is closed, clear the mark, as the experience is over
        performance.clearMarks((0, $3fcafa70dda2ad19$export$3c53e2610a4054e2));
        onChangeFormVisible(isFormVisible);
    }, [
        onChangeFormVisible
    ]) : onChangeFormVisible;
    const onCreateWithExperimentMeasure = isPICExperimentEnabled ? (0, $5uXOq.useCallback)((partialIssues)=>{
        // On create is the end of the ICC experience, so we set the end mark, measure the delay, log the results (in onCreateWithEventAttributes)
        // and at the end clear the marks and measures, so it can start over
        (0, $x9xyg.setMark)((0, $3fcafa70dda2ad19$export$e1682a3dbec77762));
        (0, $x9xyg.setMeasure)((0, $3fcafa70dda2ad19$export$94554a43bdc62f9f), (0, $3fcafa70dda2ad19$export$3c53e2610a4054e2), (0, $3fcafa70dda2ad19$export$e1682a3dbec77762));
        const measurePerformanceEntries = performance.getEntriesByName((0, $3fcafa70dda2ad19$export$94554a43bdc62f9f));
        const mostRecentMeasure = measurePerformanceEntries.at(-1) ?? null;
        onCreate(partialIssues, {
            issueCreatedAnalyticsEventAttributes: {
                timeMsSinceFocus: mostRecentMeasure && Math.round(mostRecentMeasure.duration)
            }
        });
        performance.clearMarks((0, $3fcafa70dda2ad19$export$e1682a3dbec77762));
        performance.clearMeasures((0, $3fcafa70dda2ad19$export$94554a43bdc62f9f));
    }, [
        onCreate
    ]) : onCreate;
    return {
        onCreateWithExperimentMeasure: onCreateWithExperimentMeasure,
        onChangeFormVisibleWithExperimentMeasure: onChangeFormVisibleWithExperimentMeasure
    };
};

});
const $3fcafa70dda2ad19$export$94554a43bdc62f9f = 'focus-text-area-to-issue-create-duration';
const $3fcafa70dda2ad19$export$3c53e2610a4054e2 = `${$3fcafa70dda2ad19$export$94554a43bdc62f9f}:start`;
const $3fcafa70dda2ad19$export$e1682a3dbec77762 = `${$3fcafa70dda2ad19$export$94554a43bdc62f9f}:end`;




parcelRegister("aBTGv", function(module, exports) {

$parcel$export(module.exports, "getActiveElement", () => $a17f7972495a1d26$export$cd4e5573fbe2b576);
$parcel$export(module.exports, "useIccRef", () => $a17f7972495a1d26$export$f083cfcda40a4972);
$parcel$export(module.exports, "isIccIntersectingWithHeader", () => $a17f7972495a1d26$export$a0217b33347e94a9);
$parcel$export(module.exports, "useShouldRenderCardInPopper", () => $a17f7972495a1d26$export$3870c57647f52993);

var $5uXOq = parcelRequire("5uXOq");

var $5rFbt = parcelRequire("5rFbt");

var $4R6GH = parcelRequire("4R6GH");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $j4MnI = parcelRequire("j4MnI");

var $9UXXB = parcelRequire("9UXXB");

var $63LqY = parcelRequire("63LqY");
const $a17f7972495a1d26$export$cd4e5573fbe2b576 = ()=>document.activeElement;
const $a17f7972495a1d26$export$f083cfcda40a4972 = ()=>(0, $5uXOq.useRef)(null);
const $a17f7972495a1d26$export$a0217b33347e94a9 = (headerRefObject, iccRefObject, isFirstCard)=>{
    // We allow a small amount of margin if the ICC is above the first card because the header is overlapping it by default
    // we still want to allow the ICC to be rendered in this case.
    const FIRST_CARD_ICC_MARGIN = 5;
    if (headerRefObject.current && iccRefObject.current) {
        const headerRect = headerRefObject.current.getBoundingClientRect();
        const iccRect = iccRefObject.current.getBoundingClientRect();
        return !((isFirstCard ? headerRect.bottom - FIRST_CARD_ICC_MARGIN : headerRect.bottom) < iccRect.top);
    }
    return false;
};
const $a17f7972495a1d26$export$3870c57647f52993 = ({ columnId: columnId, cardId: cardId, isScrolling: isScrolling })=>{
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isUnscheduledColumn = columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID);
    const isIPBoardScheduledColumns = isIPBoard && !isUnscheduledColumn;
    const activeInlineEditCardIds = (0, $67sX6.useBoardSelector)((0, $9OPlz.getActiveInlineEditCardIds));
    const isCardInInlineEditing = activeInlineEditCardIds.includes(String(cardId));
    const isDependencyVisualisationVisible = (0, $67sX6.useBoardSelector)((0, $j4MnI.isDependencyVisualisationVisible));
    const hasInlineCreateSessionId = (0, $67sX6.useBoardSelector)((0, $9UXXB.hasInlineCreateSessionId));
    return (0, $5uXOq.useMemo)(()=>{
        if (!isDependencyVisualisationVisible || !isIPBoardScheduledColumns || !(0, $4R6GH.fg)('render_program_board_card_in_popup')) return false;
        const noOtherActiveCard = (activeInlineEditCardIds.length === 0 || isCardInInlineEditing) && !hasInlineCreateSessionId;
        return !isScrolling && noOtherActiveCard;
    }, [
        isDependencyVisualisationVisible,
        isIPBoardScheduledColumns,
        isScrolling,
        activeInlineEditCardIds,
        isCardInInlineEditing,
        hasInlineCreateSessionId
    ]);
};

});


parcelRegister("hsHM4", function(module, exports) {

$parcel$export(module.exports, "default", () => $81786a1fd1f1895d$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $5mTgl = parcelRequire("5mTgl");

var $1YTEX = parcelRequire("1YTEX");

var $5KVmP = parcelRequire("5KVmP");
const $81786a1fd1f1895d$var$CardWithRich = (props)=>{
    const hasRenderedRichCard = (0, $5uXOq.useRef)(false);
    const { id: id, cardIndex: cardIndex, onIssueChange: onIssueChange, userCanViewMenu: userCanViewMenu, isDraggable: isDraggable, columnId: columnId, swimlaneId: swimlaneId, CardPreview: CardPreview } = props;
    const isActiveCard = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.isActiveCardSelector)(state, {
            issueId: id
        }));
    // @ts-expect-error([Part of upgrade 4.9-5.4]) - Operator '<=' cannot be applied to types 'IssueId' and 'number'.
    const isLoading = id <= 0;
    const shouldRenderRichCardRequirements = isActiveCard && !isLoading;
    if (shouldRenderRichCardRequirements && !hasRenderedRichCard.current) hasRenderedRichCard.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5KVmP.NewCard), {
        key: id,
        id: id,
        isLoading: isLoading,
        draggableIndex: cardIndex,
        userCanViewMenu: userCanViewMenu,
        Cover: (0, $1YTEX.default),
        onIssueChange: onIssueChange,
        isDraggable: isDraggable,
        shouldRenderRichCard: shouldRenderRichCardRequirements || hasRenderedRichCard.current,
        isActive: isActiveCard,
        columnId: columnId,
        swimlaneId: swimlaneId,
        CardPreview: CardPreview
    });
};
var $81786a1fd1f1895d$export$2e2bcd8739ae039 = $81786a1fd1f1895d$var$CardWithRich;

});
parcelRegister("1YTEX", function(module, exports) {

$parcel$export(module.exports, "default", () => $d13ba9163b4ea7ca$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $2vNgC = parcelRequire("2vNgC");

var $bTFSo = parcelRequire("bTFSo");

var $bC2fB = parcelRequire("bC2fB");

var $iDGXn = parcelRequire("iDGXn");

var $2VkyK = parcelRequire("2VkyK");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $bYSCr = parcelRequire("bYSCr");

var $aTBle = parcelRequire("aTBle");
class $d13ba9163b4ea7ca$export$e2eb4441932fd7a1 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isClassic: false,
            issueMedia: null,
            setMediaHeight: undefined,
            onImageLoad: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    renderPlaceholder() {
        const { issueMedia: issueMedia } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia) && 'attachmentMediaApiId' in issueMedia && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia.attachmentMediaApiId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aTBle.default), {
            mediaId: issueMedia.attachmentMediaApiId
        });
        return null;
    }
    render() {
        const { issueMedia: issueMedia, isClassic: isClassic } = this.props;
        if (isClassic) {
            if (!issueMedia || issueMedia.isHiddenByUser) return null;
            const media = {
                fileName: issueMedia?.fileName,
                mediaApiFileId: issueMedia?.attachmentMediaApiId,
                mediaClientId: issueMedia?.clientId,
                mediaExternalEndpointUrl: issueMedia?.endpointUrl,
                mediaReadToken: issueMedia?.token,
                width: null
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2vNgC.CardCoverBackgroundImg), media);
        }
        if (issueMedia && !issueMedia.isHiddenByUser) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bTFSo.default), {
            mediaId: issueMedia.attachmentMediaApiId,
            clientId: issueMedia.clientId,
            token: issueMedia.token,
            serviceHost: issueMedia.endpointUrl,
            onImageLoad: this.onImageLoad,
            placeholder: this.renderPlaceholder()
        });
        return null;
    }
    constructor(...args){
        super(...args), this.onImageLoad = (e)=>{
            const { onImageLoad: onImageLoad, setMediaHeight: setMediaHeight, issueMedia: issueMedia } = this.props;
            onImageLoad();
            if (setMediaHeight && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia) && 'attachmentMediaApiId' in issueMedia && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueMedia.attachmentMediaApiId)) setMediaHeight(issueMedia.attachmentMediaApiId, e.currentTarget.height);
        };
    }
}
const $d13ba9163b4ea7ca$export$c31df4bd766f9c35 = (state, ownProps)=>{
    const isClassic = (0, $67Z81.getIsCMPBoard)(state);
    if (isClassic) {
        if (!ownProps.showCardCovers) return {
            issueMedia: null
        };
        return {
            issueMedia: (0, $2VkyK.getIssueMedia)(state, ownProps.id),
            isClassic: isClassic
        };
    }
    return {
        issueMedia: (0, $5mTgl.isCardMediaEnabled)(state) && !(0, $2VkyK.isIssueMediaHiddenByUser)(state, ownProps.id) ? (0, $2VkyK.getIssueMedia)(state, ownProps.id) : null
    };
};
const $d13ba9163b4ea7ca$var$ConnectedComponent = (0, $bC2fB.connect)($d13ba9163b4ea7ca$export$c31df4bd766f9c35, {})($d13ba9163b4ea7ca$export$e2eb4441932fd7a1);
const $d13ba9163b4ea7ca$export$9a6bebe541d59c5d = (props)=>{
    const [, { setMediaHeight: setMediaHeight }] = (0, $bYSCr.useCardMediaActions)();
    const showCardCovers = (0, $iDGXn.useShowCardCovers)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d13ba9163b4ea7ca$var$ConnectedComponent, {
        ...props,
        setMediaHeight: setMediaHeight,
        showCardCovers: showCardCovers
    });
};
var $d13ba9163b4ea7ca$export$2e2bcd8739ae039 = $d13ba9163b4ea7ca$export$9a6bebe541d59c5d;

});
parcelRegister("2vNgC", function(module, exports) {

$parcel$export(module.exports, "CardCoverBackgroundImg", () => $20913bc98becf269$export$9dcd30985034eb6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $itjxJ = parcelRequire("itjxJ");

var $fHEdP = parcelRequire("fHEdP");
const $20913bc98becf269$var$CARD_COVER_IMAGE_HEIGHT = 140;
/**
 * A card in Software TMP & Business boards has fixed with (260px) at the moment,
 * but we want to load the image at a higher resolution and then scale it down to avoid blurry images.
 * If you use 260px, there will be a gap between the image and the card border.
 */ const $20913bc98becf269$var$COLUMN_FIXED_WIDTH = 270;
const $20913bc98becf269$export$9dcd30985034eb6f = ({ fileName: fileName, mediaApiFileId: mediaApiFileId, mediaClientId: mediaClientId, mediaExternalEndpointUrl: mediaExternalEndpointUrl, mediaReadToken: mediaReadToken, width: width = $20913bc98becf269$var$COLUMN_FIXED_WIDTH })=>{
    const imageRef = (0, $5uXOq.useRef)(null);
    const imgUrl = (0, $5uXOq.useMemo)(()=>{
        if (!mediaApiFileId || !mediaClientId || !mediaExternalEndpointUrl || !(0, $itjxJ.default)) return null;
        return (0, $fHEdP.generateMediaImageUrl)({
            mediaApiFileId: mediaApiFileId,
            mediaClientId: mediaClientId,
            mediaExternalEndpointUrl: mediaExternalEndpointUrl,
            token: mediaReadToken,
            mediaEndpoint: 'image',
            ...width && {
                width: width
            },
            'max-age': Number.MAX_SAFE_INTEGER
        });
    }, [
        mediaApiFileId,
        mediaClientId,
        mediaExternalEndpointUrl,
        mediaReadToken,
        width
    ]);
    if (!imgUrl) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($20913bc98becf269$var$MemoizedCardImageCover, {
        ref: imageRef,
        "data-testid": "platform-board-kit.ui.card.card-cover.background-img.card-cover-image",
        src: imgUrl,
        title: fileName
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $20913bc98becf269$var$CardImageCoverImg = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_13orr8u": (0, $lD23V.default)(`url(${__cmplp.src})`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1itk2pcs _bfhkm7j4 _1lrw1dfr _12vemgnk _ouxl1ssb _4t3i11ux _1bsb1osq _13liglpi _qrwqglpi",
            __cmplp.className
        ])
    });
});
const $20913bc98becf269$var$urlWithoutToken = (url)=>{
    const parsedUrl = new URL(url);
    parsedUrl.searchParams.delete('token');
    return parsedUrl.toString();
}; /**
    * Since the board items are refetched after any board changes, we receive a new token
    * every time. As a result, the image is refetched and causes a flicker. We don't need
    * to rerender the image in that case. The cases we need to are when the image is removed
    * or added, in which case we will retrieve a token separately and rerender.
    */ 
const $20913bc98becf269$var$MemoizedCardImageCover = /*#__PURE__*/ (0, $5uXOq.memo)($20913bc98becf269$var$CardImageCoverImg, (prevProps, nextProps)=>$20913bc98becf269$var$urlWithoutToken(prevProps.src) === $20913bc98becf269$var$urlWithoutToken(nextProps.src));

});
parcelRegister("itjxJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $901dcd98bf2abc00$export$2e2bcd8739ae039);



var $hAKJr = parcelRequire("hAKJr");

var $f8twK = parcelRequire("f8twK");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * Takes a dot-separated token name and an optional fallback, and returns the CSS custom property for the corresponding token.
 * This should be used to implement design decisions throughout your application.
 *
 * Note: With `@atlaskit/babel-plugin-tokens`, this function can be pre-compiled and a fallback value automatically inserted.
 *
 * @param {string} path - A dot-separated token name (example: `'color.background.brand'` or `'spacing.scale.100'`).
 * @param {string} [fallback] - The fallback value that should render when token CSS is not present in your app.
 *
 * @example
 * ```
 * <div
 *   css={{
 *     backgroundColor: token('elevation.surface.raised', N0),
 *     boxShadow: token('elevation.shadow.raised', `0 20px 32px -8px ${N50A}, 0 0 1px ${N60A}`),
 *     padding: token('spacing.scale.100', '8px'),
 *     fontWeight: token('font.weight.regular', '400'),
 *   }}
 * />
 * ```
 *
 */ function $901dcd98bf2abc00$var$token(path, fallback) {
    let token = (0, $hAKJr.default)[path];
    typeof $6cAn5;
    // if the token is not found - replacing it with variable name without any value, to avoid it being undefined which would result in invalid css
    if (!token) token = (0, $f8twK.TOKEN_NOT_FOUND_CSS_VAR);
    const tokenCall = fallback ? `var(${token}, ${fallback})` : `var(${token})`;
    return tokenCall;
}
var $901dcd98bf2abc00$export$2e2bcd8739ae039 = $901dcd98bf2abc00$var$token;

});


parcelRegister("bTFSo", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbc7fc92a3761f95$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b9JiI = parcelRequire("b9JiI");

var // eslint-disable-next-line jira/import/no-anonymous-default-export
$bbc7fc92a3761f95$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9JiI.default), props);

});
parcelRegister("b9JiI", function(module, exports) {

$parcel$export(module.exports, "Cover", () => $d9ca957b4df1ae3b$export$64da1bd56a7c875f);
$parcel$export(module.exports, "CoverContainer", () => $d9ca957b4df1ae3b$export$10346bc3559fd590);
$parcel$export(module.exports, "default", () => $d9ca957b4df1ae3b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kOLg6 = parcelRequire("kOLg6");
const $d9ca957b4df1ae3b$var$coverMaxSize = 260;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9ca957b4df1ae3b$export$64da1bd56a7c875f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rkocoyv _1e0c1txw _2lx21bp4 _1bah1h6o _4cvr1h6o _1xdf1ule _1p611osq _axc3gx0z",
            __cmplp.className
        ])
    });
});
const $d9ca957b4df1ae3b$export$10346bc3559fd590 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _6a6z1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
// HOT-90084: we want to reuse mediaClientConfigs across all CardCovers to avoid extra http requests
// MediaImage internally checks for object equality to prevent image refetch.
// That's why we need to check for the individual parameters equality at this level
// and prevent the property mediaClientConfig to change
const $d9ca957b4df1ae3b$var$mediaClientConfigs = new Map();
const $d9ca957b4df1ae3b$var$getMediaClientConfig = ({ token: authToken, clientId: clientId, serviceHost: serviceHost })=>{
    const key = `${authToken}:${clientId}:${serviceHost}`;
    if ($d9ca957b4df1ae3b$var$mediaClientConfigs.has(key)) return $d9ca957b4df1ae3b$var$mediaClientConfigs.get(key);
    const mediaClientConfig = {
        authProvider: ()=>{
            const auth = Promise.resolve({
                clientId: clientId,
                token: authToken,
                baseUrl: serviceHost
            });
            return auth;
        }
    };
    $d9ca957b4df1ae3b$var$mediaClientConfigs.set(key, mediaClientConfig);
    return mediaClientConfig;
};
const $d9ca957b4df1ae3b$var$hasAuth = ({ token: authToken, clientId: clientId, serviceHost: serviceHost })=>authToken && clientId && serviceHost;
class $d9ca957b4df1ae3b$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const mediaClientConfig = $d9ca957b4df1ae3b$var$hasAuth(this.props) ? $d9ca957b4df1ae3b$var$getMediaClientConfig(this.props) : undefined;
        if (!mediaClientConfig) return null;
        const { mediaId: mediaId, collectionName: collectionName } = this.props;
        const mediaImageProps = {
            identifier: {
                mediaItemType: 'file',
                id: mediaId,
                collectionName: collectionName
            },
            mediaClientConfig: mediaClientConfig
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9ca957b4df1ae3b$export$64da1bd56a7c875f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9ca957b4df1ae3b$export$10346bc3559fd590, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kOLg6.MediaImageWithErrorBoundary), mediaImageProps, ({ loading: loading, error: error, data: data })=>{
            if (loading && this.prevScr) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                src: this.prevScr,
                alt: ""
            });
            if (!data || loading || error) {
                if (this.props.placeholder !== undefined) return this.props.placeholder;
                return null;
            }
            // @ts-expect-error - TS2322 - Type 'string | undefined' is not assignable to type 'string'.
            this.prevScr = data.src;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
                src: data.src,
                onLoad: this.props.onImageLoad ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                alt: "",
                role: "presentation",
                "data-testid": "platform-board-kit.ui.card.card-cover.card-cover-image"
            });
        })));
    }
}

});
parcelRegister("kOLg6", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithErrorBoundary", () => $27dd12b02502711d$export$758a2fef95a29ad0);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $f4cXA = parcelRequire("f4cXA");

var $eYKm8 = parcelRequire("eYKm8");
const $27dd12b02502711d$export$758a2fef95a29ad0 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $f4cXA.ErrorBoundary), {
        fallback: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
            children: props.children({
                loading: false,
                error: true
            })
        }),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eYKm8.MediaImageWithMediaClient), {
            ...props
        })
    });

});
parcelRegister("eYKm8", function(module, exports) {

$parcel$export(module.exports, "MediaImageWithMediaClient", () => $eecef2c1b93fb3db$export$8acd7eecc88dfeb5);
/* mediaImage.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iArlU = parcelRequire("iArlU");

var $10b0h = parcelRequire("10b0h");

var $VSDnB = parcelRequire("VSDnB");
const $eecef2c1b93fb3db$var$copyDivStyles = null;
const $eecef2c1b93fb3db$var$MediaImageBase = ({ identifier: identifier, apiConfig: apiConfig = {}, children: children, ssr: ssr })=>{
    const { width: width, height: height, mode: mode, allowAnimated: allowAnimated, upscale: upscale, 'max-age': maxAge } = apiConfig;
    const dimensions = {
        width: width,
        height: height
    };
    const { preview: preview, error: error, copyNodeRef: copyNodeRef, getSsrScriptProps: getSsrScriptProps } = (0, $10b0h.useFilePreview)({
        identifier: identifier,
        dimensions: dimensions,
        ssr: ssr,
        resizeMode: mode,
        allowAnimated: allowAnimated,
        upscale: upscale,
        maxAge: maxAge
    });
    //----------------------------------------------------------------
    // RENDER
    //----------------------------------------------------------------
    let status = 'loading';
    if (preview?.dataURI) status = 'succeeded';
    else if (error) status = 'error';
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children({
                loading: status === 'loading',
                error: status === 'error',
                data: status === 'succeeded' ? {
                    status: status,
                    src: preview?.dataURI
                } : undefined
            }),
            (0, $VSDnB.fg)('platform_media_cross_client_copy') && /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ref: copyNodeRef,
                className: (0, $bwpsq.default)([
                    "_1e0cglyw"
                ])
            }),
            getSsrScriptProps && /*#__PURE__*/ (0, $2OMIu.jsx)("script", {
                ...getSsrScriptProps()
            })
        ]
    });
};
const $eecef2c1b93fb3db$export$8acd7eecc88dfeb5 = (props)=>{
    const MediaImageComponent = (0, $5uXOq.useMemo)(()=>(0, $iArlU.withMediaClient)($eecef2c1b93fb3db$var$MediaImageBase), []);
    return /*#__PURE__*/ (0, $2OMIu.jsx)(MediaImageComponent, {
        ...props
    });
};

});
parcelRegister("iArlU", function(module, exports) {

$parcel$export(module.exports, "withMediaClient", () => $104af301cec809a6$export$9f7977d4a2561bee);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");
const $104af301cec809a6$export$9f7977d4a2561bee = (Component)=>({ mediaClientConfig: mediaClientConfig, ...otherProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Consumer, {
            children: (value)=>value ? /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                    ...otherProps,
                    mediaClient: value
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientProvider), {
                    clientConfig: mediaClientConfig,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $cEHh7.MediaClientContext).Consumer, {
                        children: (client)=>/*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
                                ...otherProps,
                                mediaClient: client
                            })
                    })
                })
        });

});
parcelRegister("cEHh7", function(module, exports) {

$parcel$export(module.exports, "MediaClientContext", () => $2a03c62fd3cc05ea$export$ba5d7212f2b4619f);
$parcel$export(module.exports, "MediaClientProvider", () => $2a03c62fd3cc05ea$export$5bff351c86f56d97);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");
const $2a03c62fd3cc05ea$export$ba5d7212f2b4619f = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $2a03c62fd3cc05ea$export$5bff351c86f56d97 = ({ children: children, clientConfig: clientConfig })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>(0, $85xkt.getMediaClient)(clientConfig), [
        clientConfig
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($2a03c62fd3cc05ea$export$ba5d7212f2b4619f.Provider, {
        value: mediaClient,
        children: children
    });
};

});


parcelRegister("10b0h", function(module, exports) {

$parcel$export(module.exports, "useFilePreview", () => $baceb2843b357d39$export$4eaebdef02112fe4);

var $5uXOq = parcelRequire("5uXOq");

var $1Pp1U = parcelRequire("1Pp1U");
var $gFZHi = parcelRequire("gFZHi");

var $93kaw = parcelRequire("93kaw");
var $24tOd = parcelRequire("24tOd");
var $dTQMj = parcelRequire("dTQMj");

var $8GKRF = parcelRequire("8GKRF");

var $kGpuq = parcelRequire("kGpuq");

var $01sWe = parcelRequire("01sWe");

var $3JWNV = parcelRequire("3JWNV");
var $4n1NZ = parcelRequire("4n1NZ");
var $7xRaJ = parcelRequire("7xRaJ");

var $3JZCV = parcelRequire("3JZCV");
var $jR4hE = parcelRequire("jR4hE");

var $8Kbwv = parcelRequire("8Kbwv");
const $baceb2843b357d39$export$4eaebdef02112fe4 = ({ resizeMode: resizeMode = 'crop', identifier: identifier, ssr: ssr, dimensions: dimensions, traceContext: traceContext, skipRemote: skipRemote, mediaBlobUrlAttrs: mediaBlobUrlAttrs, allowAnimated: allowAnimated = true, upscale: upscale, maxAge: maxAge, source: source })=>{
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const [status, setStatus] = (0, $5uXOq.useState)('loading');
    const [error, setError] = (0, $5uXOq.useState)();
    const [nonCriticalError, setNonCriticalError] = (0, $5uXOq.useState)();
    const [isBannedLocalPreview, setIsBannedLocalPreview] = (0, $5uXOq.useState)(false);
    const [upfrontPreviewStatus, setUpfrontPreviewStatus] = (0, $5uXOq.useState)('not-resolved');
    const ssrReliabilityRef = (0, $5uXOq.useRef)({
        server: {
            status: 'unknown'
        },
        client: {
            status: 'unknown'
        }
    });
    const requestDimensions = (0, $5uXOq.useMemo)(()=>dimensions ? (0, $8Kbwv.createRequestDimensions)(dimensions) : undefined, [
        dimensions
    ]);
    const requestDimensionsRef = (0, $8Kbwv.useCurrentValueRef)(requestDimensions);
    let imageURLParams = {
        collection: identifier.collectionName,
        mode: resizeMode,
        ...requestDimensions,
        allowAnimated: allowAnimated,
        upscale: upscale,
        'max-age': maxAge
    };
    imageURLParams = {
        ...imageURLParams,
        source: source
    };
    const previewInitializer = ()=>{
        const preview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        if (preview) return preview;
        if (ssr) {
            const ssrData = (0, $jR4hE.getSSRData)(identifier);
            if (ssrData?.error) ssrReliabilityRef.current.server = {
                status: 'fail',
                ...ssrData.error
            };
            if (!ssrData?.dataURI) try {
                return (0, $3JWNV.getSSRPreview)(ssr, mediaClient, identifier.id, imageURLParams, mediaBlobUrlAttrs);
            } catch (e) {
                ssrReliabilityRef.current[ssr] = {
                    status: 'fail',
                    ...(0, $kGpuq.extractErrorInfo)(e, traceContext)
                };
            }
            else {
                const { dimensions: dimensions, dataURI: dataURI } = ssrData;
                return {
                    dataURI: dataURI,
                    dimensions: dimensions,
                    source: 'ssr-data'
                };
            }
        }
    };
    const [preview, setPreview] = (0, $5uXOq.useState)(previewInitializer);
    //----------------------------------------------------------------
    // FILE STATE
    //----------------------------------------------------------------
    const { fileState: fileState } = (0, $24tOd.useFileState)(identifier.id, {
        skipRemote: skipRemote,
        collectionName: identifier.collectionName,
        occurrenceKey: identifier.occurrenceKey
    });
    // Derived from File State
    const isBackendPreviewReady = !!fileState && (0, $1Pp1U.isImageRepresentationReady)(fileState);
    const fileStateErrorMessage = fileState?.status === 'error' ? fileState.message : undefined;
    const { preview: localBinary, mediaType: mediaType, mimeType: mimeType } = fileState && fileState?.status !== 'error' ? fileState : {};
    //----------------------------------------------------------------
    // Update status
    //----------------------------------------------------------------
    // TOOD: make a full hook reset (remount) on New identifier or client
    (0, $5uXOq.useEffect)(()=>{
        setStatus('loading');
    }, [
        identifier
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (status !== 'error') {
            if (preview || fileState?.status === 'processed' && !isBackendPreviewReady) setStatus('complete');
            else if (!preview && fileState?.status === 'failed-processing' && !isBackendPreviewReady) {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('failed-processing'));
            } else if (!preview && fileState?.status === 'error' && upfrontPreviewStatus === 'resolved') {
                setStatus('error');
                setError(new (0, $01sWe.MediaFilePreviewError)('metadata-fetch', (0, $gFZHi.toCommonMediaClientError)(fileState)));
            } else setStatus('loading');
        }
    }, [
        preview,
        status,
        fileState,
        isBackendPreviewReady,
        fileStateErrorMessage,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Preview Fetch Helper
    //----------------------------------------------------------------
    const getAndCacheRemotePreviewRef = (0, $8Kbwv.useCurrentValueRef)(()=>{
        return (0, $3JWNV.getAndCacheRemotePreview)(mediaClient, identifier.id, requestDimensions || {}, imageURLParams, mediaBlobUrlAttrs, traceContext);
    });
    //----------------------------------------------------------------
    // Upfront Preview
    //----------------------------------------------------------------
    (0, $5uXOq.useEffect)(()=>{
        // Only fetch upfront (no file state) if there is no preview in the state already
        if (preview) setUpfrontPreviewStatus('resolved');
        else if (!preview && upfrontPreviewStatus === 'not-resolved' && !skipRemote) {
            // We block any possible future call to this method regardless of the outcome (success or fail)
            // If it fails, the normal preview fetch should occur after the file state is fetched anyways
            setUpfrontPreviewStatus('resolving');
            const fetchedDimensions = {
                ...requestDimensions
            };
            getAndCacheRemotePreviewRef.current().then((newPreview)=>{
                // If there are new and bigger dimensions in the props, and the upfront preview is still resolving,
                // the fetched preview is no longer valid, and thus, we dismiss it
                if (!(0, $8Kbwv.isBigger)(fetchedDimensions, requestDimensionsRef.current)) setPreview(newPreview);
            }).catch(()=>{
            // NO need to log error. If this call fails, a refetch will happen after
            }).finally(()=>{
                setUpfrontPreviewStatus('resolved');
            });
        }
    }, [
        getAndCacheRemotePreviewRef,
        preview,
        requestDimensions,
        requestDimensionsRef,
        skipRemote,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // Cache, Local & Remote Preview
    //----------------------------------------------------------------
    const mediaBlobUrlAttrsRef = (0, $8Kbwv.useCurrentValueRef)(mediaBlobUrlAttrs);
    (0, $5uXOq.useEffect)(()=>{
        const cachedPreview = (0, $7xRaJ.mediaFilePreviewCache).get(identifier.id, resizeMode);
        // Cached Preview ----------------------------------------------------------------
        if (!preview && cachedPreview && !(0, $8Kbwv.isBigger)(cachedPreview?.dimensions, requestDimensions)) setPreview(cachedPreview);
        else if (!preview && !isBannedLocalPreview && localBinary && (0, $4n1NZ.isSupportedLocalPreview)(mediaType) && (0, $8GKRF.isMimeTypeSupportedByBrowser)(mimeType || '')) // Local preview is available only if it's supported by browser and supported by Media Card (isSupportedLocalPreview)
        // For example, SVGs are mime type NOT supported by browser but media type supported by Media Card (image)
        // Then, local Preview NOT available
        (0, $3JWNV.getAndCacheLocalPreview)(identifier.id, localBinary, requestDimensions || {}, resizeMode, mediaBlobUrlAttrsRef.current).then(setPreview).catch((e)=>{
            setIsBannedLocalPreview(true);
            // CXP-2723 TODO: We might have to wrap this error in MediaCardError
            setNonCriticalError(e);
        });
        else if (!error && !nonCriticalError && (!preview || (0, $8Kbwv.isBigger)(preview.dimensions, requestDimensions) || // We always refetch SSR preview to be able to browser-cache a version without the token in the query parameters
        (0, $3JWNV.isSSRPreview)(preview)) && !skipRemote && upfrontPreviewStatus === 'resolved' && isBackendPreviewReady) getAndCacheRemotePreviewRef.current().then(setPreview).catch((e)=>{
            const wrappedError = (0, $01sWe.ensureMediaFilePreviewError)('preview-fetch', e);
            if (!preview) {
                setStatus('error');
                setError(wrappedError);
            } else // If there is already a preview, we consider it a non-critical error
            setNonCriticalError(wrappedError);
        });
    }, [
        error,
        nonCriticalError,
        getAndCacheRemotePreviewRef,
        identifier.id,
        resizeMode,
        isBannedLocalPreview,
        mediaBlobUrlAttrsRef,
        preview,
        requestDimensions,
        skipRemote,
        isBackendPreviewReady,
        localBinary,
        mediaType,
        mimeType,
        upfrontPreviewStatus
    ]);
    //----------------------------------------------------------------
    // RETURN
    //----------------------------------------------------------------
    const onImageError = (0, $5uXOq.useCallback)((failedPreview)=>{
        if (!failedPreview) return;
        if ((0, $3JWNV.isSSRClientPreview)(failedPreview)) ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        // If the preview failed and it comes from server (global scope / ssrData), it means that we have reused it in client and the error counts for both: server & client.
        if ((0, $3JWNV.isSSRDataPreview)(failedPreview)) {
            ssrReliabilityRef.current.server = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
            ssrReliabilityRef.current.client = (0, $kGpuq.createFailedSSRObject)(failedPreview, traceContext);
        }
        // If the dataURI has been replaced, we can dismiss this error
        if (failedPreview.dataURI !== preview?.dataURI) return;
        const isLocal = (0, $3JWNV.isLocalPreview)(failedPreview);
        const isRemote = (0, $3JWNV.isRemotePreview)(failedPreview);
        if (isLocal || isRemote) {
            const error = new (0, $01sWe.ImageLoadError)(failedPreview?.source);
            (0, $7xRaJ.mediaFilePreviewCache).remove(identifier.id, resizeMode);
            if (isLocal) setIsBannedLocalPreview(true);
            if (isRemote) {
                setStatus('error');
                setError(error);
            }
            setPreview(undefined);
        }
    }, [
        identifier.id,
        preview?.dataURI,
        resizeMode,
        traceContext
    ]);
    const onImageLoad = (0, $5uXOq.useCallback)((newPreview)=>{
        if (newPreview) {
            if ((0, $3JWNV.isSSRClientPreview)(newPreview) && ssrReliabilityRef.current.client.status === 'unknown') ssrReliabilityRef.current.client = {
                status: 'success'
            };
            /*
        If the image loads successfully and it comes from server (global scope / ssrData), it means that we have reused it in client and the success counts for both: server & client.
      */ if ((0, $3JWNV.isSSRDataPreview)(newPreview) && ssrReliabilityRef.current.server.status === 'unknown') {
                ssrReliabilityRef.current.server = {
                    status: 'success'
                };
                ssrReliabilityRef.current.client = {
                    status: 'success'
                };
            }
        }
        // If the dataURI has been replaced, we can dismiss this callback
        if (newPreview?.dataURI !== preview?.dataURI) return;
    }, [
        preview?.dataURI
    ]);
    // FOR SSR
    const getSsrScriptProps = ssr === 'server' ? ()=>(0, $3JZCV.generateScriptProps)(identifier, preview?.dataURI, requestDimensions, ssrReliabilityRef.current.server?.status === 'fail' ? ssrReliabilityRef.current.server : undefined) : undefined;
    const { copyNodeRef: copyNodeRef } = (0, $93kaw.useCopyIntent)(identifier.id, {
        collectionName: identifier.collectionName
    });
    // CXP-2723 TODO: should consider simplifying our analytics, and how
    // we might get rid of ssrReliabiltyRef from our hook
    return {
        preview: preview,
        status: status,
        error: error,
        nonCriticalError: nonCriticalError,
        ssrReliability: ssrReliabilityRef.current,
        onImageError: onImageError,
        onImageLoad: onImageLoad,
        getSsrScriptProps: getSsrScriptProps,
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("93kaw", function(module, exports) {

$parcel$export(module.exports, "useCopyIntent", () => $d123d92fa0d5c1a9$export$46fd859414de9d62);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $VSDnB = parcelRequire("VSDnB");

var $dTQMj = parcelRequire("dTQMj");

var $7wsJE = parcelRequire("7wsJE");

var $eaxUQ = parcelRequire("eaxUQ");
function $d123d92fa0d5c1a9$var$useCurrentValueRef(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}
const $d123d92fa0d5c1a9$export$46fd859414de9d62 = (id, options = {})=>{
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const innerRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const registerCopyIntentRef = $d123d92fa0d5c1a9$var$useCurrentValueRef(async ()=>{
        try {
            await mediaClient.file.registerCopyIntent(id, options.collectionName);
            createAnalyticsEvent((0, $7wsJE.getCopyIntentSuccessPayload)(id));
        } catch (err) {
            createAnalyticsEvent((0, $7wsJE.getCopyIntentErrorPayload)(err, id));
        }
    });
    const copyNodeRef = (0, $5uXOq.useCallback)((elem)=>{
        innerRef.current = elem;
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) elem?.addEventListener('contextmenu', ()=>{
            registerCopyIntentRef.current();
        });
    }, [
        registerCopyIntentRef
    ]);
    const onGlobalCopy = (0, $5uXOq.useCallback)(async ()=>{
        const currentCopyTarget = innerRef.current;
        const currentSelectionContainsNode = currentCopyTarget && getSelection()?.containsNode(currentCopyTarget, true);
        if (currentSelectionContainsNode) registerCopyIntentRef.current();
    }, [
        registerCopyIntentRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $VSDnB.fg)('platform_media_cross_client_copy')) (0, $eaxUQ.getDocument)()?.addEventListener('copy', onGlobalCopy);
        return ()=>(0, $eaxUQ.getDocument)()?.removeEventListener('copy', onGlobalCopy);
    }, [
        onGlobalCopy
    ]);
    return {
        copyNodeRef: copyNodeRef
    };
};

});
parcelRegister("dTQMj", function(module, exports) {

$parcel$export(module.exports, "useMediaClient", () => $b143d4e1474eae5f$export$8b3e87ea56c3a345);

var $5uXOq = parcelRequire("5uXOq");

var $cEHh7 = parcelRequire("cEHh7");

var $j9aMR = parcelRequire("j9aMR");
const $b143d4e1474eae5f$export$8b3e87ea56c3a345 = ()=>{
    const mediaClient = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $cEHh7.MediaClientContext));
    const { mediaClient: altMediaClient } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).useContext((0, $j9aMR.MediaContext)) || {};
    if (!mediaClient && !altMediaClient) throw new Error('No MediaClient set, use MediaClientProvider or MediaProvider to set one');
    // WARNING: typescript can't infer that at least one mediaClient is defined here. Adding the `!` is a hack to make typescript happy.
    return mediaClient || altMediaClient;
};

});
parcelRegister("j9aMR", function(module, exports) {

$parcel$export(module.exports, "MediaContext", () => $67e1b660defdb678$export$c94ff18a59d4c4d);
$parcel$export(module.exports, "MediaProvider", () => $67e1b660defdb678$export$57164260bc1f1218);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $85xkt = parcelRequire("85xkt");

var $6MEeI = parcelRequire("6MEeI");
const $67e1b660defdb678$export$c94ff18a59d4c4d = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createContext(undefined);
const $67e1b660defdb678$export$57164260bc1f1218 = ({ children: children, mediaClientConfig: mediaClientConfig, mediaSettings: mediaSettings })=>{
    const mediaClient = (0, $5uXOq.useMemo)(()=>(0, $85xkt.getMediaClient)(mediaClientConfig), [
        mediaClientConfig
    ]);
    const settings = (0, $6MEeI.useMediaParsedSettings)(mediaSettings);
    return /*#__PURE__*/ (0, $2OMIu.jsx)($67e1b660defdb678$export$c94ff18a59d4c4d.Provider, {
        value: {
            mediaClient: mediaClient,
            settings: settings
        },
        children: children
    });
};

});
parcelRegister("6MEeI", function(module, exports) {

$parcel$export(module.exports, "useMediaParsedSettings", () => $8fe91b921518e593$export$d54af28440a5efc0);

var $5uXOq = parcelRequire("5uXOq");

var $g6aUe = parcelRequire("g6aUe");
const $8fe91b921518e593$export$d54af28440a5efc0 = (mediaSettings = {})=>{
    const settings = (0, $5uXOq.useMemo)(()=>{
        const newSettings = {
            ...mediaSettings
        };
        newSettings.mediaUserPreferences = (0, $g6aUe.defaultMediaUserPreferences);
        return newSettings;
    }, [
        mediaSettings
    ]);
    return settings;
};

});
parcelRegister("g6aUe", function(module, exports) {

$parcel$export(module.exports, "defaultMediaUserPreferences", () => $216d5498643172f0$export$2d23ed2854ac1650);
// Currently only supports boolean, string. Uncomment below to support number
const $216d5498643172f0$var$MediaUserPreferencesTypes = {
    videoCaptionsEnabled: 'boolean',
    videoCaptionsPreferredLocale: 'string'
};
const $216d5498643172f0$export$7e209e67b965bc63 = (userPreferences)=>({
        set: (key, value)=>{
            userPreferences.set(key, value.toString());
        },
        get: (key)=>{
            const value = userPreferences.get(key);
            if (value === null || value === undefined) return undefined;
            if ($216d5498643172f0$var$MediaUserPreferencesTypes[key] === 'boolean') return value === 'true';
            // Uncomment to support number
            // if (MediaUserSettingsTypes[key] === 'number') {
            // 	return Number(value) as MediaSettingsTypeMap[K];
            // }
            return value;
        }
    });
const $216d5498643172f0$var$defaultUserPreferences = {
    set: (key, value)=>{
        const MEDIA_KEY = 'media';
        localStorage.setItem(`${MEDIA_KEY}-${key}`, value);
    },
    get: (key)=>{
        const MEDIA_KEY = 'media';
        return localStorage.getItem(`${MEDIA_KEY}-${key}`);
    }
};
const $216d5498643172f0$export$2d23ed2854ac1650 = $216d5498643172f0$export$7e209e67b965bc63($216d5498643172f0$var$defaultUserPreferences);

});




parcelRegister("7wsJE", function(module, exports) {

$parcel$export(module.exports, "getCopyIntentErrorPayload", () => $9a6af4835a9857e5$export$3ab52330b662b987);
$parcel$export(module.exports, "getCopyIntentSuccessPayload", () => $9a6af4835a9857e5$export$aacb463551da2e8f);

var $1As4I = parcelRequire("1As4I");
const $9a6af4835a9857e5$var$getRequestErrorDetails = (err)=>{
    if ((0, $1As4I.isRequestError)(err)) return {
        request: {
            statusCode: err.metadata?.statusCode,
            traceContext: err.metadata?.traceContext,
            mediaEnv: err.metadata?.mediaEnv,
            mediaRegion: err.metadata?.mediaRegion
        }
    };
};
const $9a6af4835a9857e5$export$3ab52330b662b987 = (error, fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'failed',
        actionSubject: 'mediaCopyIntent',
        failReason: (0, $1As4I.isRequestError)(error) ? error.reason : 'nativeError',
        attributes: {
            status: 'fail',
            fileAttributes: {
                fileId: fileId
            },
            ...$9a6af4835a9857e5$var$getRequestErrorDetails(error)
        }
    };
};
const $9a6af4835a9857e5$export$aacb463551da2e8f = (fileId = '')=>{
    return {
        eventType: 'operational',
        action: 'succeeded',
        actionSubject: 'mediaCopyIntent',
        attributes: {
            fileAttributes: {
                fileId: fileId
            }
        }
    };
};

});

parcelRegister("eaxUQ", function(module, exports) {

$parcel$export(module.exports, "getDocument", () => $9ea95d3f3a6b1d04$export$f65ca476c09acec0);
const $9ea95d3f3a6b1d04$export$f65ca476c09acec0 = ()=>{
    if (typeof window === 'undefined') return;
    if (typeof window.document === 'undefined') return;
    return window.document;
};

});


parcelRegister("24tOd", function(module, exports) {

$parcel$export(module.exports, "useFileState", () => $768d10f5fd62ab89$export$90ff537b0999afb);

var $5uXOq = parcelRequire("5uXOq");

var $dTQMj = parcelRequire("dTQMj");

var $k4CmR = parcelRequire("k4CmR");
function $768d10f5fd62ab89$export$90ff537b0999afb(id, options = {}) {
    const { collectionName: collectionName, occurrenceKey: occurrenceKey, skipRemote: skipRemote = false, includeHashForDuplicateFiles: includeHashForDuplicateFiles } = options;
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const fileState = (0, $k4CmR.useMediaStore)((state)=>state.files[id]);
    (0, $5uXOq.useEffect)(()=>{
        // No need to resubscribe if there is a fileState already
        if (!fileState && !skipRemote) mediaClient.file.getFileState(id, {
            collectionName: collectionName,
            occurrenceKey: occurrenceKey,
            includeHashForDuplicateFiles: includeHashForDuplicateFiles
        });
    }, [
        id,
        mediaClient,
        collectionName,
        occurrenceKey,
        skipRemote,
        fileState,
        includeHashForDuplicateFiles
    ]);
    return {
        fileState: fileState
    };
}

});
parcelRegister("k4CmR", function(module, exports) {

$parcel$export(module.exports, "useMediaStore", () => $a907ffa2ecfaf54d$export$8a9cc8c330400af8);

var $6esDR = parcelRequire("6esDR");

var $dTQMj = parcelRequire("dTQMj");
const $a907ffa2ecfaf54d$var$createBoundedUseStore = (store)=>(selector, equals)=>(0, $6esDR.useStore)(store, selector, equals);
function $a907ffa2ecfaf54d$export$8a9cc8c330400af8(selector, equals) {
    const mediaClient = (0, $dTQMj.useMediaClient)();
    const store = mediaClient.__DO_NOT_USE__getMediaStore();
    const useBoundStore = $a907ffa2ecfaf54d$var$createBoundedUseStore(store);
    return useBoundStore(selector, equals);
}

});
parcelRegister("6esDR", function(module, exports) {

$parcel$export(module.exports, "useStore", () => $489a4492a45245b1$export$6ccbb43953eebf8);

var $ee7sp = parcelRequire("ee7sp");

var $5uXOq = parcelRequire("5uXOq");

var $lNQti = parcelRequire("lNQti");
var $489a4492a45245b1$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/zustand/esm/index.mjs"
});
const { useDebugValue: $489a4492a45245b1$var$useDebugValue } = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq)));
const { useSyncExternalStoreWithSelector: $489a4492a45245b1$var$useSyncExternalStoreWithSelector } = (0, (/*@__PURE__*/$parcel$interopDefault($lNQti)));
let $489a4492a45245b1$var$didWarnAboutEqualityFn = false;
const $489a4492a45245b1$var$identity = (arg)=>arg;
function $489a4492a45245b1$export$6ccbb43953eebf8(api, selector = $489a4492a45245b1$var$identity, equalityFn) {
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && equalityFn && !$489a4492a45245b1$var$didWarnAboutEqualityFn) {
        console.warn("[DEPRECATED] Use `createWithEqualityFn` instead of `create` or use `useStoreWithEqualityFn` instead of `useStore`. They can be imported from 'zustand/traditional'. https://github.com/pmndrs/zustand/discussions/1937");
        $489a4492a45245b1$var$didWarnAboutEqualityFn = true;
    }
    const slice = $489a4492a45245b1$var$useSyncExternalStoreWithSelector(api.subscribe, api.getState, api.getServerState || api.getInitialState, selector, equalityFn);
    $489a4492a45245b1$var$useDebugValue(slice);
    return slice;
}
const $489a4492a45245b1$var$createImpl = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production" && typeof createState !== "function") console.warn("[DEPRECATED] Passing a vanilla store will be unsupported in a future version. Instead use `import { useStore } from 'zustand'`.");
    const api = typeof createState === "function" ? (0, $ee7sp.createStore)(createState) : createState;
    const useBoundStore = (selector, equalityFn)=>$489a4492a45245b1$export$6ccbb43953eebf8(api, selector, equalityFn);
    Object.assign(useBoundStore, api);
    return useBoundStore;
};
const $489a4492a45245b1$export$185802fd694ee1f5 = (createState)=>createState ? $489a4492a45245b1$var$createImpl(createState) : $489a4492a45245b1$var$createImpl;
var $489a4492a45245b1$export$2e2bcd8739ae039 = (createState)=>{
    if (($489a4492a45245b1$import_meta.env ? $489a4492a45245b1$import_meta.env.MODE : void 0) !== "production") console.warn("[DEPRECATED] Default export is deprecated. Instead use `import { create } from 'zustand'`.");
    return $489a4492a45245b1$export$185802fd694ee1f5(createState);
};

});
parcelRegister("lNQti", function(module, exports) {
'use strict';

module.exports = (parcelRequire("hUiTL"));

});
parcelRegister("hUiTL", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStoreWithSelector", () => $d096537a1780f6c5$export$bf730a2d8bf68b42, (v) => $d096537a1780f6c5$export$bf730a2d8bf68b42 = v);
/**
 * @license React
 * use-sync-external-store-shim/with-selector.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d096537a1780f6c5$export$bf730a2d8bf68b42;
'use strict';

var $5uXOq = parcelRequire("5uXOq");

var $goz36 = parcelRequire("goz36");
function $d096537a1780f6c5$var$p(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $d096537a1780f6c5$var$q = "function" === typeof Object.is ? Object.is : $d096537a1780f6c5$var$p, $d096537a1780f6c5$var$r = $goz36.useSyncExternalStore, $d096537a1780f6c5$var$t = $5uXOq.useRef, $d096537a1780f6c5$var$u = $5uXOq.useEffect, $d096537a1780f6c5$var$v = $5uXOq.useMemo, $d096537a1780f6c5$var$w = $5uXOq.useDebugValue;
$d096537a1780f6c5$export$bf730a2d8bf68b42 = function(a, b, e, l, g) {
    var c = $d096537a1780f6c5$var$t(null);
    if (null === c.current) {
        var f = {
            hasValue: !1,
            value: null
        };
        c.current = f;
    } else f = c.current;
    c = $d096537a1780f6c5$var$v(function() {
        function a(a) {
            if (!c) {
                c = !0;
                d = a;
                a = l(a);
                if (void 0 !== g && f.hasValue) {
                    var b = f.value;
                    if (g(b, a)) return k = b;
                }
                return k = a;
            }
            b = k;
            if ($d096537a1780f6c5$var$q(d, a)) return b;
            var e = l(a);
            if (void 0 !== g && g(b, e)) return b;
            d = a;
            return k = e;
        }
        var c = !1, d, k, m = void 0 === e ? null : e;
        return [
            function() {
                return a(b());
            },
            null === m ? void 0 : function() {
                return a(m());
            }
        ];
    }, [
        b,
        e,
        l,
        g
    ]);
    var d = $d096537a1780f6c5$var$r(a, c[0], c[1]);
    $d096537a1780f6c5$var$u(function() {
        f.hasValue = !0;
        f.value = d;
    }, [
        d
    ]);
    $d096537a1780f6c5$var$w(d);
    return d;
};

});
parcelRegister("goz36", function(module, exports) {
'use strict';

module.exports = (parcelRequire("jcmQl"));

});
parcelRegister("jcmQl", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", () => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16, (v) => $dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = v);
/**
 * @license React
 * use-sync-external-store-shim.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $dfa0db7ec3fca60b$export$306c0aa65ff9ec16;
'use strict';

var $5uXOq = parcelRequire("5uXOq");
function $dfa0db7ec3fca60b$var$h(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $dfa0db7ec3fca60b$var$k = "function" === typeof Object.is ? Object.is : $dfa0db7ec3fca60b$var$h, $dfa0db7ec3fca60b$var$l = $5uXOq.useState, $dfa0db7ec3fca60b$var$m = $5uXOq.useEffect, $dfa0db7ec3fca60b$var$n = $5uXOq.useLayoutEffect, $dfa0db7ec3fca60b$var$p = $5uXOq.useDebugValue;
function $dfa0db7ec3fca60b$var$q(a, b) {
    var d = b(), f = $dfa0db7ec3fca60b$var$l({
        inst: {
            value: d,
            getSnapshot: b
        }
    }), c = f[0].inst, g = f[1];
    $dfa0db7ec3fca60b$var$n(function() {
        c.value = d;
        c.getSnapshot = b;
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
    }, [
        a,
        d,
        b
    ]);
    $dfa0db7ec3fca60b$var$m(function() {
        $dfa0db7ec3fca60b$var$r(c) && g({
            inst: c
        });
        return a(function() {
            $dfa0db7ec3fca60b$var$r(c) && g({
                inst: c
            });
        });
    }, [
        a
    ]);
    $dfa0db7ec3fca60b$var$p(d);
    return d;
}
function $dfa0db7ec3fca60b$var$r(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var d = b();
        return !$dfa0db7ec3fca60b$var$k(a, d);
    } catch (f) {
        return !0;
    }
}
function $dfa0db7ec3fca60b$var$t(a, b) {
    return b();
}
var $dfa0db7ec3fca60b$var$u = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $dfa0db7ec3fca60b$var$t : $dfa0db7ec3fca60b$var$q;
$dfa0db7ec3fca60b$export$306c0aa65ff9ec16 = void 0 !== $5uXOq.useSyncExternalStore ? $5uXOq.useSyncExternalStore : $dfa0db7ec3fca60b$var$u;

});







parcelRegister("kGpuq", function(module, exports) {

$parcel$export(module.exports, "extractErrorInfo", () => $d93d75d54376e990$export$74aaf4784c2edb2c);
$parcel$export(module.exports, "createFailedSSRObject", () => $d93d75d54376e990$export$768c370ed0dbaeb3);

var $gFZHi = parcelRequire("gFZHi");

var $01sWe = parcelRequire("01sWe");
const $d93d75d54376e990$export$29aa614726672b2e = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.metadata?.traceContext;
};
const $d93d75d54376e990$export$4af9d71992e89714 = (error)=>{
    return error.primaryReason || 'nativeError';
};
const $d93d75d54376e990$export$88c61dcad53762da = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.reason;
    return 'nativeError';
};
const $d93d75d54376e990$export$9ccc5365d056da4b = (error)=>{
    const { secondaryError: secondaryError } = error;
    if ((0, $gFZHi.isCommonMediaClientError)(secondaryError)) return secondaryError.message;
    return error.message;
};
const $d93d75d54376e990$export$74aaf4784c2edb2c = (error, metadataTraceContext)=>{
    return {
        failReason: $d93d75d54376e990$export$4af9d71992e89714(error),
        error: $d93d75d54376e990$export$88c61dcad53762da(error),
        errorDetail: $d93d75d54376e990$export$9ccc5365d056da4b(error),
        metadataTraceContext: metadataTraceContext ?? $d93d75d54376e990$export$29aa614726672b2e(error)
    };
};
const $d93d75d54376e990$export$768c370ed0dbaeb3 = (preview, metadataTraceContext)=>({
        status: 'fail',
        ...$d93d75d54376e990$export$74aaf4784c2edb2c(new (0, $01sWe.ImageLoadError)(preview.source), metadataTraceContext)
    });

});
parcelRegister("01sWe", function(module, exports) {

$parcel$export(module.exports, "MediaFilePreviewError", () => $fcceba16863dd854$export$96e559194c287cf4);
$parcel$export(module.exports, "LocalPreviewError", () => $fcceba16863dd854$export$2c035820a31723e);
$parcel$export(module.exports, "RemotePreviewError", () => $fcceba16863dd854$export$10ab445310d30114);
$parcel$export(module.exports, "SsrPreviewError", () => $fcceba16863dd854$export$18e89b7e50818288);
$parcel$export(module.exports, "ImageLoadError", () => $fcceba16863dd854$export$d0a45ab59b4606b);
$parcel$export(module.exports, "ensureMediaFilePreviewError", () => $fcceba16863dd854$export$7156ce7b78b49bd7);
class $fcceba16863dd854$export$96e559194c287cf4 extends Error {
    constructor(primaryReason, secondaryError){
        super(primaryReason), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
        // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
        Object.setPrototypeOf(this, new.target.prototype);
        // https://v8.dev/docs/stack-trace-api
        if ('captureStackTrace' in Error) Error.captureStackTrace(this, new.target);
    }
}
class $fcceba16863dd854$export$2c035820a31723e extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$10ab445310d30114 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
class $fcceba16863dd854$export$18e89b7e50818288 extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(primaryReason, secondaryError){
        super(primaryReason, secondaryError), this.primaryReason = primaryReason, this.secondaryError = secondaryError;
    }
}
const $fcceba16863dd854$var$getImageLoadPrimaryReason = (source)=>{
    switch(source){
        case 'cache-remote':
            return 'cache-remote-uri';
        case 'cache-local':
            return 'cache-local-uri';
        case 'external':
            return 'external-uri';
        case 'local':
            return 'local-uri';
        case 'remote':
            return 'remote-uri';
        case 'ssr-client':
            return 'ssr-client-uri';
        case 'ssr-server':
        case 'ssr-data':
            return 'ssr-server-uri';
        // This fail reason will come from a bug, most likely.
        default:
            return `unknown-uri`;
    }
};
class $fcceba16863dd854$export$d0a45ab59b4606b extends $fcceba16863dd854$export$96e559194c287cf4 {
    constructor(source){
        super($fcceba16863dd854$var$getImageLoadPrimaryReason(source));
    }
}
function $fcceba16863dd854$export$553696a6e769784c(err) {
    return err instanceof $fcceba16863dd854$export$96e559194c287cf4;
}
const $fcceba16863dd854$export$b380593ba3516c6f = (err)=>err instanceof $fcceba16863dd854$export$2c035820a31723e;
const $fcceba16863dd854$export$e1d87830b3784f94 = (err)=>err instanceof $fcceba16863dd854$export$10ab445310d30114;
const $fcceba16863dd854$export$443aeb298d35d79d = (err)=>$fcceba16863dd854$export$553696a6e769784c(err) && err.primaryReason === 'local-preview-unsupported';
const $fcceba16863dd854$export$7156ce7b78b49bd7 = (primaryReason, error, updatePrimaryReason)=>{
    if ($fcceba16863dd854$export$553696a6e769784c(error)) {
        if (updatePrimaryReason && error.primaryReason !== primaryReason) return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error.secondaryError);
        return error;
    }
    return new $fcceba16863dd854$export$96e559194c287cf4(primaryReason, error);
};

});


parcelRegister("3JWNV", function(module, exports) {

$parcel$export(module.exports, "getSSRPreview", () => $609060e8f7210c63$export$faf1c301c59a1bdc);
$parcel$export(module.exports, "isLocalPreview", () => $609060e8f7210c63$export$78ad02c5efc361c9);
$parcel$export(module.exports, "isRemotePreview", () => $609060e8f7210c63$export$87442a14a8a19e0);
$parcel$export(module.exports, "isSSRClientPreview", () => $609060e8f7210c63$export$36aae1afbc0a9661);
$parcel$export(module.exports, "isSSRDataPreview", () => $609060e8f7210c63$export$f366c2c8a792cce6);
$parcel$export(module.exports, "isSSRPreview", () => $609060e8f7210c63$export$dea79d05143ccf4);
$parcel$export(module.exports, "getAndCacheRemotePreview", () => $609060e8f7210c63$export$49721bcc26fb9388);
$parcel$export(module.exports, "getAndCacheLocalPreview", () => $609060e8f7210c63$export$98e935d981c884d);

var $9KG2L = parcelRequire("9KG2L");

var $01sWe = parcelRequire("01sWe");

var $7xRaJ = parcelRequire("7xRaJ");

var $4n1NZ = parcelRequire("4n1NZ");
const $609060e8f7210c63$var$extendAndCachePreview = (id, mode, preview, mediaBlobUrlAttrs)=>{
    let source;
    switch(preview.source){
        case 'local':
            source = 'cache-local';
            break;
        case 'remote':
            source = 'cache-remote';
            break;
        default:
            source = preview.source;
    }
    // We want to embed some meta context into dataURI for Copy/Paste to work.
    const dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(preview.dataURI, mediaBlobUrlAttrs) : preview.dataURI;
    // We store new cardPreview into cache
    (0, $7xRaJ.mediaFilePreviewCache).set(id, mode, {
        ...preview,
        source: source,
        dataURI: dataURI
    });
    return {
        ...preview,
        dataURI: dataURI
    };
};
const $609060e8f7210c63$export$faf1c301c59a1bdc = (ssr, mediaClient, id, params, mediaBlobUrlAttrs)=>{
    let dataURI;
    try {
        const rawDataURI = mediaClient.getImageUrlSync(id, params);
        // We want to embed some meta context into dataURI for Copy/Paste to work.
        dataURI = mediaBlobUrlAttrs ? (0, $9KG2L.addFileAttrsToUrl)(rawDataURI, mediaBlobUrlAttrs) : rawDataURI;
        const source = ssr === 'client' ? 'ssr-client' : 'ssr-server';
        return {
            dataURI: dataURI,
            source: source,
            orientation: 1
        };
    } catch (e) {
        const reason = ssr === 'server' ? 'ssr-server-uri' : 'ssr-client-uri';
        throw new (0, $01sWe.SsrPreviewError)(reason, e instanceof Error ? e : undefined);
    }
};
const $609060e8f7210c63$export$78ad02c5efc361c9 = (preview)=>{
    const localSources = [
        'local',
        'cache-local'
    ];
    return localSources.includes(preview.source);
};
const $609060e8f7210c63$export$87442a14a8a19e0 = (preview)=>{
    const remoteSources = [
        'remote',
        'cache-remote'
    ];
    return remoteSources.includes(preview.source);
};
const $609060e8f7210c63$export$36aae1afbc0a9661 = (preview)=>preview.source === 'ssr-client';
const $609060e8f7210c63$export$f366c2c8a792cce6 = (preview)=>preview.source === 'ssr-data';
const $609060e8f7210c63$export$dea79d05143ccf4 = (preview)=>{
    const ssrClientSources = [
        'ssr-client',
        'ssr-server',
        'ssr-data'
    ];
    return ssrClientSources.includes(preview.source);
};
const $609060e8f7210c63$export$49721bcc26fb9388 = async (mediaClient, id, dimensions, params, mediaBlobUrlAttrs, traceContext)=>{
    const remotePreview = await (0, $4n1NZ.getRemotePreview)(mediaClient, id, params, traceContext);
    return $609060e8f7210c63$var$extendAndCachePreview(id, params.mode, {
        ...remotePreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};
const $609060e8f7210c63$export$98e935d981c884d = async (id, filePreview, dimensions, mode, mediaBlobUrlAttrs)=>{
    const localPreview = await (0, $4n1NZ.getLocalPreview)(filePreview);
    return $609060e8f7210c63$var$extendAndCachePreview(id, mode, {
        ...localPreview,
        dimensions: dimensions
    }, mediaBlobUrlAttrs);
};

});
parcelRegister("9KG2L", function(module, exports) {

$parcel$export(module.exports, "isMediaBlobUrl", () => $3193ea5c2295e37f$export$e1e8ad57ada2d90);
$parcel$export(module.exports, "getAttrsFromUrl", () => $3193ea5c2295e37f$export$b91a9e94ff0cbb29);
$parcel$export(module.exports, "addFileAttrsToUrl", () => $3193ea5c2295e37f$export$e51a8146182600b8);
const $3193ea5c2295e37f$var$mediaBlobUrlIdentifier = 'media-blob-url';
const $3193ea5c2295e37f$export$e1e8ad57ada2d90 = (url)=>{
    return url.indexOf(`${$3193ea5c2295e37f$var$mediaBlobUrlIdentifier}=true`) > -1;
};
const $3193ea5c2295e37f$var$getNumberFromParams = (params, name)=>{
    const value = params.get(name);
    return typeof value === 'string' && !isNaN(parseInt(value)) ? parseInt(value) : undefined;
};
const $3193ea5c2295e37f$var$getStringFromParams = (params, name)=>{
    const value = params.get(name);
    if (!value) return;
    return decodeURIComponent(value);
};
const $3193ea5c2295e37f$export$b91a9e94ff0cbb29 = (blobUrl)=>{
    const url = new URL(blobUrl);
    const hash = url.hash.replace('#', '');
    const params = new URLSearchParams(hash);
    const id = params.get('id');
    const contextId = params.get('contextId');
    // check if we have the required params
    if (!id || !contextId) return;
    return {
        id: id,
        contextId: contextId,
        collection: $3193ea5c2295e37f$var$getStringFromParams(params, 'collection'),
        alt: $3193ea5c2295e37f$var$getStringFromParams(params, 'alt'),
        height: $3193ea5c2295e37f$var$getNumberFromParams(params, 'height'),
        width: $3193ea5c2295e37f$var$getNumberFromParams(params, 'width'),
        size: $3193ea5c2295e37f$var$getNumberFromParams(params, 'size'),
        name: $3193ea5c2295e37f$var$getStringFromParams(params, 'name'),
        mimeType: $3193ea5c2295e37f$var$getStringFromParams(params, 'mimeType')
    };
};
const $3193ea5c2295e37f$export$89a7e74069fbb7af = (json)=>{
    return Object.keys(json).filter((attrName)=>typeof json[attrName] !== 'undefined' && json[attrName] !== null).map((key)=>{
        const value = json[key];
        if (typeof value === 'undefined' || value === null) return;
        return `${encodeURIComponent(key)}=${encodeURIComponent(value.toString())}`;
    }).join('&');
};
const $3193ea5c2295e37f$export$e51a8146182600b8 = (url, fileAttrs)=>{
    const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
    if (isSafari) return url;
    const mediaIdentifierAttr = {
        [$3193ea5c2295e37f$var$mediaBlobUrlIdentifier]: 'true'
    };
    const mergedAttrs = {
        ...mediaIdentifierAttr,
        ...fileAttrs
    };
    const queryAttrs = $3193ea5c2295e37f$export$89a7e74069fbb7af(mergedAttrs);
    // we can't use '?' separator for blob url params
    return `${url}#${queryAttrs}`;
};

});

parcelRegister("7xRaJ", function(module, exports) {

$parcel$export(module.exports, "mediaFilePreviewCache", () => $abbc266dbfedc514$export$b7e8ee3f7a41459);

var $aAIop = parcelRequire("aAIop");
const $abbc266dbfedc514$export$611736262b635f8d = (id, mode)=>{
    const resizeMode = mode || 'crop';
    return [
        id,
        resizeMode
    ].join('-');
};
class $abbc266dbfedc514$export$7b50526c091bb915 {
    constructor(previewCache){
        this.previewCache = previewCache;
        this.get = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            return this.previewCache.get(cacheKey);
        };
        this.set = (id, mode, cardPreview)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.set(cacheKey, cardPreview);
        };
        this.remove = (id, mode)=>{
            const cacheKey = $abbc266dbfedc514$export$611736262b635f8d(id, mode);
            this.previewCache.remove(cacheKey);
        };
        this.clear = ()=>{
            this.previewCache.clear();
        };
    }
}
const $abbc266dbfedc514$export$b7e8ee3f7a41459 = new $abbc266dbfedc514$export$7b50526c091bb915((0, $aAIop.createObjectURLCache)());

});
parcelRegister("aAIop", function(module, exports) {

$parcel$export(module.exports, "createObjectURLCache", () => $0cfc22aea6c15367$export$ba71be67d5c32535);

var $7n9mn = parcelRequire("7n9mn");

var $iwKVT = parcelRequire("iwKVT");
const $0cfc22aea6c15367$export$36d0f9859761643d = 50;
class $0cfc22aea6c15367$var$ExtendedLRUCache extends (0, $iwKVT.LRUMap) {
    constructor(limit){
        super(limit);
        this.eventEmitter = new (0, $7n9mn.EventEmitter2)();
    }
    shift() {
        const entry = super.shift();
        this.eventEmitter.emit('shift', entry);
        return entry;
    }
    on(event, callback) {
        this.eventEmitter.on(event, callback);
    }
}
class $0cfc22aea6c15367$export$75d1c8c9ba1d0773 {
    constructor(size){
        this.cache = new $0cfc22aea6c15367$var$ExtendedLRUCache(size);
        this.cache.on('shift', (entry)=>{
            if (entry && entry[1].dataURI) URL.revokeObjectURL(entry[1].dataURI);
        });
    }
    has(key) {
        return !!this.cache.find(key);
    }
    get(key) {
        return this.cache.get(key);
    }
    set(key, value) {
        this.cache.set(key, value);
    }
    remove(key) {
        const removed = this.cache.delete(key);
        removed && URL.revokeObjectURL(removed.dataURI);
    }
    clear() {
        this.cache.clear();
    }
}
const $0cfc22aea6c15367$export$ba71be67d5c32535 = ()=>new $0cfc22aea6c15367$export$75d1c8c9ba1d0773($0cfc22aea6c15367$export$36d0f9859761643d);

});


parcelRegister("4n1NZ", function(module, exports) {

$parcel$export(module.exports, "isSupportedLocalPreview", () => $3b75ec6170865ae7$export$1fa85b75e8662d54);
$parcel$export(module.exports, "getLocalPreview", () => $3b75ec6170865ae7$export$3d6ed68e437b8c99);
$parcel$export(module.exports, "getRemotePreview", () => $3b75ec6170865ae7$export$bfe20bd01db02b3);

var $jzW7G = parcelRequire("jzW7G");

var $48aIR = parcelRequire("48aIR");

var $01sWe = parcelRequire("01sWe");

var $Nl5sY = parcelRequire("Nl5sY");
const $3b75ec6170865ae7$export$1fa85b75e8662d54 = (mediaType)=>mediaType === 'image' || mediaType === 'video';
const $3b75ec6170865ae7$var$getImageLocalPreview = async (value)=>{
    try {
        const orientation = await (0, $48aIR.getOrientation)(value);
        const dataURI = URL.createObjectURL(value);
        return {
            dataURI: dataURI,
            orientation: orientation,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-image', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$var$getVideoLocalPreview = async (value)=>{
    try {
        const dataURI = await (0, $Nl5sY.takeSnapshot)(value);
        return {
            dataURI: dataURI,
            orientation: 1,
            source: 'local'
        };
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-video', e instanceof Error ? e : undefined);
    }
};
const $3b75ec6170865ae7$export$3d6ed68e437b8c99 = async (filePreview)=>{
    let value;
    try {
        const resolvedFilePreview = await filePreview;
        value = resolvedFilePreview.value;
    } catch (e) {
        throw new (0, $01sWe.LocalPreviewError)('local-preview-rejected', e instanceof Error ? e : undefined);
    }
    if (typeof value === 'string') return {
        dataURI: value,
        orientation: 1,
        source: 'local'
    };
    else if (value instanceof Blob) {
        const { type: type } = value;
        const mediaType = (0, $jzW7G.getMediaTypeFromMimeType)(type);
        switch(mediaType){
            case 'image':
                return $3b75ec6170865ae7$var$getImageLocalPreview(value);
            case 'video':
                return $3b75ec6170865ae7$var$getVideoLocalPreview(value);
            default:
                throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
        }
    }
    throw new (0, $01sWe.LocalPreviewError)('local-preview-unsupported');
};
const $3b75ec6170865ae7$export$bfe20bd01db02b3 = async (mediaClient, id, params, traceContext)=>{
    try {
        const blob = await mediaClient.getImage(id, params, undefined, undefined, traceContext);
        return {
            dataURI: URL.createObjectURL(blob),
            orientation: 1,
            source: 'remote'
        };
    } catch (e) {
        throw new (0, $01sWe.RemotePreviewError)('remote-preview-fetch', e instanceof Error ? e : undefined);
    }
};

});
parcelRegister("48aIR", function(module, exports) {

$parcel$export(module.exports, "getImageInfo", () => $93f6c931eebc2be3$export$2176b0e68c10508f);
$parcel$export(module.exports, "getOrientation", () => $93f6c931eebc2be3$export$67689507e8404821);

var $k9Ch0 = parcelRequire("k9Ch0");

var $5m9mt = parcelRequire("5m9mt");

var $1xbJn = parcelRequire("1xbJn");

var $hNjKA = parcelRequire("hNjKA");
const { Orientation: $93f6c931eebc2be3$var$Orientation, XResolution: $93f6c931eebc2be3$var$XResolution } = (0, $k9Ch0.SupportedImageMetaTag);
// http://bonfx.com/why-is-the-web-72-dpi-and-print-300-dpi/
const $93f6c931eebc2be3$var$DPI_WEB_BASELINE = 72;
async function $93f6c931eebc2be3$export$2176b0e68c10508f(fileInfo) {
    const metadata = await $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo);
    if (!metadata) return null;
    const { width: width, height: height, tags: tags } = metadata;
    const scaleFactor = $93f6c931eebc2be3$export$dd08dbbf61041ccd(fileInfo.file, tags);
    return {
        scaleFactor: scaleFactor,
        width: width,
        height: height
    };
}
function $93f6c931eebc2be3$export$dd08dbbf61041ccd(file, tags) {
    const scaleFactorFromFilename = $93f6c931eebc2be3$export$11cb6a214555dd36(file);
    if (scaleFactorFromFilename !== null) return scaleFactorFromFilename;
    else if (tags) {
        /**
		 * Scale Factor is actually a 2D thing, but in practice X & Y are same in 99% cases.
		 * So we are only relying on X axis.
		 */ if (typeof tags['PixelPerUnitX'] === 'number') // 1 inch = 0.0254 meters
        return Math.round(tags['PixelPerUnitX'] * 0.0254) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
        else return $93f6c931eebc2be3$export$268f92356524130b(tags, $93f6c931eebc2be3$var$XResolution, $93f6c931eebc2be3$var$DPI_WEB_BASELINE) / $93f6c931eebc2be3$var$DPI_WEB_BASELINE;
    } else return 1;
}
const $93f6c931eebc2be3$var$getOrientationFromTags = (tags)=>{
    if (tags && tags[$93f6c931eebc2be3$var$Orientation]) {
        const tagValue = tags[$93f6c931eebc2be3$var$Orientation];
        if (tagValue) {
            const numericValue = parseInt(tagValue, 10);
            if (isNaN(numericValue)) return (0, $k9Ch0.ExifOrientation)[tagValue];
            return numericValue;
        }
    }
    return 1;
};
async function $93f6c931eebc2be3$export$67689507e8404821(file) {
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    return $93f6c931eebc2be3$var$getOrientationFromTags(tags);
}
function $93f6c931eebc2be3$export$268f92356524130b(tags, key, defaultValue) {
    try {
        const num = parseFloat(`${tags[key]}`);
        if (!isNaN(num)) return num;
    } catch (e) {
    //
    }
    return defaultValue;
}
function $93f6c931eebc2be3$export$11cb6a214555dd36(file) {
    try {
        // filenames with scale ratio in name take precedence - eg. filename@2x.png
        const match = file.name.trim().match(/@([0-9\.]+)x\.[a-z]{3}$/);
        if (match) return parseFloat(match[1]);
    } catch (e) {
    // parse problem, return null
    }
    return null;
}
async function $93f6c931eebc2be3$export$c142eb1c8c5c79c(fileInfo) {
    const { file: file, src: src } = fileInfo;
    const type = file.type;
    let width = 0;
    let height = 0;
    const tags = await (0, $5m9mt.readImageMetaTags)(file);
    // since we're reading metadata anyway, try to get dimensions from there...
    if (tags && tags.PixelXDimension) width = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelXDimension', 0);
    if (tags && tags.PixelXDimension) height = $93f6c931eebc2be3$export$268f92356524130b(tags, 'PixelYDimension', 0);
    const data = {
        type: type,
        width: width,
        height: height,
        naturalWidth: width,
        naturalHeight: height,
        tags: tags
    };
    /*
	 * The PixelXDimension and PixelYDimension of image tags can mean something different than just width and height, especially when images are compressed or for other reasons.
	 * https://imagemagick.org/discourse-server/viewtopic.php?t=27037
	 * We've also received JAC tickets reporting incorrect dimensions because of this
	 * https://jira.atlassian.com/browse/CONFCLOUD-78275
	 * The best way to get accurate dimensions is by loading images into the HTML, which reflects the actual dimensions the browser will render
	 */ try {
        const img = await (0, $1xbJn.loadImage)(src);
        const { width: width, height: height } = (0, $1xbJn.readImageNaturalOrientationFromDOM)(img);
        data.width = width;
        data.height = height;
        data.naturalWidth = img.naturalWidth;
        data.naturalHeight = img.naturalHeight;
    } catch (e) {
        return null;
    }
    return data;
}

});
parcelRegister("k9Ch0", function(module, exports) {

$parcel$export(module.exports, "ImageType", () => $8ba626f637ae3df3$export$48c85e6e32ef0825);
$parcel$export(module.exports, "SupportedImageMetaTag", () => $8ba626f637ae3df3$export$e369bb48cf33e564);
$parcel$export(module.exports, "ExifOrientation", () => $8ba626f637ae3df3$export$f6ea0c89fd7d156);
var $8ba626f637ae3df3$export$48c85e6e32ef0825 = /*#__PURE__*/ function(ImageType) {
    ImageType["JPEG"] = "image/jpeg";
    ImageType["PNG"] = "image/png";
    return ImageType;
}({});
var $8ba626f637ae3df3$export$e369bb48cf33e564 = /*#__PURE__*/ function(SupportedImageMetaTag) {
    SupportedImageMetaTag["XResolution"] = "XResolution";
    SupportedImageMetaTag["YResolution"] = "YResolution";
    SupportedImageMetaTag["Orientation"] = "Orientation";
    return SupportedImageMetaTag;
}({});
const $8ba626f637ae3df3$export$f6ea0c89fd7d156 = {
    'top-left': 1,
    'top-right': 2,
    'bottom-right': 3,
    'bottom-left': 4,
    'left-top': 5,
    'right-top': 6,
    'right-bottom': 7,
    'left-bottom': 8
};

});

parcelRegister("5m9mt", function(module, exports) {

$parcel$export(module.exports, "readImageMetaTags", () => $6da5c9a89db4de84$export$41982b5c7acb23c4);

var $k9Ch0 = parcelRequire("k9Ch0");

var $jkveD = parcelRequire("jkveD");

var $kINoG = parcelRequire("kINoG");

var $2edT6 = parcelRequire("2edT6");
async function $6da5c9a89db4de84$export$41982b5c7acb23c4(file) {
    const type = file.type;
    try {
        if (type === (0, $k9Ch0.ImageType).PNG) {
            // http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
            // iTXt = XML text with metadata
            // pHYs = Physical pixel dimensions
            const { iTXt: iTXt, pHYs: pHYs } = await (0, $kINoG.readPNGXMPMetaData)(file);
            const xmpMetaData = {
                ...(0, $2edT6.parseXMPMetaData)(iTXt),
                ...pHYs
            };
            return xmpMetaData;
        } else if (file.type === (0, $k9Ch0.ImageType).JPEG) return await (0, $jkveD.readJPEGExifMetaData)(file);
    } catch (e) {
    // problem parsing metadata
    }
    return null;
}

});
parcelRegister("jkveD", function(module, exports) {

$parcel$export(module.exports, "readJPEGExifMetaData", () => $537aa8dc852a8555$export$556b2ccec62d7f2a);

var $k9Ch0 = parcelRequire("k9Ch0");
const { XResolution: $537aa8dc852a8555$var$XResolution, YResolution: $537aa8dc852a8555$var$YResolution } = (0, $k9Ch0.SupportedImageMetaTag);
let $537aa8dc852a8555$var$loadImage;

function $537aa8dc852a8555$export$556b2ccec62d7f2a(file) {
    return new Promise(async (resolve, reject)=>{
        if (!$537aa8dc852a8555$var$loadImage) {
            const module = await (parcelRequire("iErjn"));
            $537aa8dc852a8555$var$loadImage = module.default || module;
        }
        $537aa8dc852a8555$var$loadImage.parseMetaData(file, (data)=>{
            try {
                const tags = data && data.exif ? data.exif.getAll() : {};
                Object.keys(tags).forEach((key)=>{
                    const value = tags[key];
                    if (typeof value === 'object' && (key === $537aa8dc852a8555$var$XResolution || key === $537aa8dc852a8555$var$YResolution) && 'numerator' in value) // some test images had this structure, so just take the numerator value to simplify returned value
                    tags[key] = value.numerator;
                    if (typeof tags[key] === 'number') // in case numbers types were auto-converted, keep everything the same between jpeg & png we keep as strings
                    tags[key] = `${tags[key]}`;
                });
                resolve(tags);
            } catch (e) {
                reject(e);
            }
        });
    });
}

});
parcelRegister("iErjn", function(module, exports) {

let $d94125e60802a764$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d94125e60802a764$var$load("i57oW").then(()=>parcelRequire('8aLn9'));

});


parcelRegister("kINoG", function(module, exports) {

$parcel$export(module.exports, "readPNGXMPMetaData", () => $013315ab2d0cc3cf$export$5fb37736440fca6f);

var $1xbJn = parcelRequire("1xbJn");
let $013315ab2d0cc3cf$var$pngChunksExtract;

async function $013315ab2d0cc3cf$export$5fb37736440fca6f(file) {
    if (!$013315ab2d0cc3cf$var$pngChunksExtract) {
        const module = await (parcelRequire("jegge"));
        $013315ab2d0cc3cf$var$pngChunksExtract = module.default || module;
    }
    const buffer = await (0, $1xbJn.fileToArrayBuffer)(file);
    const chunks = $013315ab2d0cc3cf$var$pngChunksExtract(buffer);
    return await $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks);
}
async function $013315ab2d0cc3cf$export$9185743fdd58ce45(chunks) {
    let iTXt = '';
    let pHYs = {};
    /**
	 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Summary-of-standard-chunks
	 * Order of every chunk is not guaranteed.
	 * And both iTXt and pHYs are Ancillary chunks.
	 */ for(let i = 0; i < chunks.length; ++i){
        const chunk = chunks[i];
        // Must be last
        if (chunk.name === 'IEND') break;
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.Anc-text
		 * iTXt contains the useful XMP/XML string data of meta tags
		 */ if (chunk.name === 'iTXt') iTXt = String.fromCharCode.apply(null, Array.from(chunk.data));
        /**
		 * http://www.libpng.org/pub/png/spec/1.2/PNG-Chunks.html#C.pHYs
		 * Pixels per unit, X axis: 4 bytes (unsigned integer)
		 * Pixels per unit, Y axis: 4 bytes (unsigned integer)
		 * Unit specifier:          1 byte  (0: unit is unknown 1: unit is the meter)
		 */ if (chunk.name === 'pHYs') {
            const dv = new DataView(chunk.data.buffer);
            const unitSpecifier = dv.getUint8(8);
            // meter
            if (unitSpecifier === 1) {
                const PixelPerUnitX = dv.getUint32(0);
                const PixelPerUnitY = dv.getUint32(4);
                pHYs = {
                    PixelPerUnitX: PixelPerUnitX,
                    PixelPerUnitY: PixelPerUnitY
                };
            }
        }
    }
    return {
        iTXt: iTXt,
        pHYs: pHYs
    };
}

});
parcelRegister("1xbJn", function(module, exports) {

$parcel$export(module.exports, "dataURItoFile", () => $3c9a3ebb8ee397f0$export$80d19edb7b1ae293);
$parcel$export(module.exports, "fileToDataURI", () => $3c9a3ebb8ee397f0$export$849633012686f7ee);
$parcel$export(module.exports, "getFileInfo", () => $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4);
$parcel$export(module.exports, "fileToArrayBuffer", () => $3c9a3ebb8ee397f0$export$956310555b96755a);
$parcel$export(module.exports, "loadImage", () => $3c9a3ebb8ee397f0$export$fe58198efe02b173);
$parcel$export(module.exports, "readImageNaturalOrientationFromDOM", () => $3c9a3ebb8ee397f0$export$325d46491952db2d);
$parcel$export(module.exports, "findParentByClassname", () => $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03);
$parcel$export(module.exports, "getMimeIcon", () => $3c9a3ebb8ee397f0$export$61a1de0822e2820);

var $2tm8x = parcelRequire("2tm8x");

var $RiK2l = parcelRequire("RiK2l");

var $cHwqN = parcelRequire("cHwqN");

var $2sfBf = parcelRequire("2sfBf");

var $iABw2 = parcelRequire("iABw2");

var $7hpMa = parcelRequire("7hpMa");

var $dGYEZ = parcelRequire("dGYEZ");

var $iBOon = parcelRequire("iBOon");

var $jdlqN = parcelRequire("jdlqN");

var $c70Lr = parcelRequire("c70Lr");

var $2osAJ = parcelRequire("2osAJ");

var $7zjHG = parcelRequire("7zjHG");

var $8SPcB = parcelRequire("8SPcB");

var $es8mD = parcelRequire("es8mD");

var $gYsK7 = parcelRequire("gYsK7");

var $8RqHP = parcelRequire("8RqHP");
function $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(dataURI, filename = 'untitled') {
    if (dataURI.length === 0) throw new Error('dataURI not found');
    // convert base64/URLEncoded data component to raw binary data held in a string
    const dataURIParts = dataURI.split(',');
    const byteString = dataURIParts[0].indexOf('base64') >= 0 ? atob(dataURIParts[1]) : decodeURIComponent(dataURIParts[1]);
    // separate out the mime component
    let mimeString;
    try {
        mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    } catch (e) {
        // https://stackoverflow.com/questions/1176022/unknown-file-type-mime
        mimeString = 'application/octet-stream';
    }
    // write the bytes of the string to a typed array
    const intArray = new Uint8Array(byteString.length);
    for(let i = 0; i < byteString.length; i++)intArray[i] = byteString.charCodeAt(i);
    const blob = new Blob([
        intArray
    ], {
        type: mimeString
    });
    try {
        return new File([
            blob
        ], filename, {
            type: mimeString
        });
    } catch (e) {
        // IE11 does not allow the File constructor (yay!)
        // we get around this by decorating the blob instance with File properties
        // effectively casting up from Blob to File.
        const ie11File = blob;
        const date = new Date();
        ie11File.lastModified = date.getTime();
        ie11File.lastModifiedDate = date;
        ie11File.name = filename;
        ie11File.webkitRelativePath = '';
        return ie11File;
    }
}
function $3c9a3ebb8ee397f0$export$849633012686f7ee(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const result = reader.result;
            if (typeof result === 'string') resolve(result);
            else if (result === null) reject();
        });
        reader.addEventListener('error', reject);
        reader.readAsDataURL(blob);
    });
}
async function $3c9a3ebb8ee397f0$export$ca39f27fe4f7d9b4(file, src) {
    return {
        file: file,
        src: src || await $3c9a3ebb8ee397f0$export$849633012686f7ee(file)
    };
}
async function $3c9a3ebb8ee397f0$export$d727e14d7168c14(src, file) {
    return {
        file: file || await $3c9a3ebb8ee397f0$export$80d19edb7b1ae293(src),
        src: src
    };
}
function $3c9a3ebb8ee397f0$export$956310555b96755a(file) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.addEventListener('load', ()=>{
            const array = new Uint8Array(reader.result);
            resolve(array);
        });
        reader.addEventListener('error', reject);
        reader.readAsArrayBuffer(file);
    });
}
function $3c9a3ebb8ee397f0$export$fe58198efe02b173(src) {
    return new Promise((resolve, reject)=>{
        const img = new Image();
        img.src = src;
        img.onload = ()=>{
            resolve(img);
        };
        img.onerror = reject;
    });
}
function $3c9a3ebb8ee397f0$export$325d46491952db2d(img) {
    img.style.position = 'absolute';
    img.style.visibility = 'hidden';
    document.body.appendChild(img);
    const { width: width, height: height } = img.getBoundingClientRect();
    document.body.removeChild(img);
    return {
        width: width,
        height: height
    };
}
const $3c9a3ebb8ee397f0$export$89ff65f1d45dfb03 = (element, className, maxParentElement = document.body)=>{
    if (element.classList.contains(className)) return element;
    let currentElement = element;
    while(currentElement.parentElement !== maxParentElement){
        if (currentElement.parentElement) {
            currentElement = currentElement.parentElement;
            if (currentElement.classList.contains(className)) return currentElement;
        } else return undefined;
    }
    return undefined;
};
const $3c9a3ebb8ee397f0$var$mimeTypes = [
    {
        label: 'pdf',
        mimeTypes: [
            'application/pdf'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2tm8x)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-slides',
        mimeTypes: [
            'application/vnd.google-apps.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2osAJ)))
    },
    {
        label: 'google-form',
        mimeTypes: [
            'application/vnd.google-apps.form'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($jdlqN)))
    },
    {
        label: 'google-sheets',
        mimeTypes: [
            'application/vnd.google-apps.spreadsheet'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($c70Lr)))
    },
    {
        label: 'google-docs',
        mimeTypes: [
            'application/vnd.google-apps.document',
            'application/vnd.google-apps.kix'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iBOon)))
    },
    {
        label: 'microsoft-word',
        mimeTypes: [
            'application/msword',
            'application/vnd.openxmlformats-officedocument.word'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2sfBf)))
    },
    {
        label: 'presentation',
        mimeTypes: [
            'application/x-iwork-keynote-sffkey',
            'application/vnd.oasis.opendocument.presentation'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($es8mD)))
    },
    {
        label: 'powerpoint-presentation',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.presentationml.presentation',
            'application/vnd.ms-powerpoint'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($cHwqN)))
    },
    {
        label: 'giphy',
        mimeTypes: [
            'image/gif'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($RiK2l)))
    },
    {
        label: 'spreadsheet',
        mimeTypes: [
            'text/csv'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($8SPcB)))
    },
    {
        label: 'excel-spreadsheet',
        mimeTypes: [
            'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            'application/vnd.ms-excel',
            'application/x-iwork-keynote-sffnumbers'
        ],
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7zjHG)))
    }
];
function $3c9a3ebb8ee397f0$export$61a1de0822e2820(mimeType, fileName) {
    // based on the mimeType, determine the corresponding icon and label
    const iconInfo = $3c9a3ebb8ee397f0$var$mimeTypes.find((file)=>file.mimeTypes.indexOf(mimeType) > -1);
    //return the appropriate icon and its label if we have it
    if (iconInfo) return iconInfo;
    if ((0, $8RqHP.isCodeViewerItem)(fileName, mimeType)) return {
        label: 'source-code',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($gYsK7)))
    };
    // we are not able to determine what icon to render based on the mimeType
    // hence we render the icon based on the filename
    if (fileName.match(/.*\.sketch$/)) return {
        label: 'sketch',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($iABw2)))
    };
    if (fileName.match(/.*\.fig$/)) return {
        label: 'figma',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($7hpMa)))
    };
    if (fileName.match(/.*\.exe$/) || fileName.match(/.*\.dmg$/)) return {
        label: 'executable',
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dGYEZ)))
    };
    // cannot find a corresponding mimeType icon.
    return undefined;
}

});
parcelRegister("2tm8x", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1ccf7616b127308b$var$_react = $1ccf7616b127308b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1ccf7616b127308b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1ccf7616b127308b$var$PdfDocument24Icon = (props)=>/*#__PURE__*/ $1ccf7616b127308b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff5630" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.846 12.17h.483c1.116 0 1.203-.322 1.203-.776 0-.518-.268-.771-.817-.771h-.869zm6.29 2.183h.664c.742 0 1.501-.22 1.501-1.855 0-1.65-.802-1.86-1.501-1.86h-.665zM4.462 15.99h-1.08A.384.384 0 0 1 3 15.606V9.383c0-.21.171-.383.383-.383h2.494c1.483 0 2.52.984 2.52 2.394 0 1.43-1.015 2.39-2.525 2.39H4.846v1.822a.384.384 0 0 1-.383.384m7.45 0h-2.24a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h2.242c2.107 0 3.268 1.237 3.268 3.484 0 2.26-1.16 3.506-3.268 3.506m5.776 0h-1.08a.384.384 0 0 1-.384-.384V9.383c0-.21.172-.383.383-.383h4.009c.21 0 .383.172.383.383v.88a.383.383 0 0 1-.383.383h-2.545v1.14h2.292c.212 0 .383.172.383.383v.867c0 .21-.171.383-.383.383h-2.292v2.187a.384.384 0 0 1-.383.384"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1ccf7616b127308b$var$PdfDocument24Icon.displayName = 'PdfDocument24Icon';
var $1ccf7616b127308b$var$_default = module.exports.default = $1ccf7616b127308b$var$PdfDocument24Icon;

});

parcelRegister("RiK2l", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $0a037d07967bfa4f$var$_react = $0a037d07967bfa4f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $0a037d07967bfa4f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0a037d07967bfa4f$var$Gif24Icon = (props)=>/*#__PURE__*/ $0a037d07967bfa4f$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffab00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m10.564 16.636h-1.93a.243.243 0 0 1-.244-.243V8.384c0-.135.108-.243.243-.243h1.93c.135 0 .244.108.244.243v8.009a.243.243 0 0 1-.243.243m3.79 0h-1.931a.243.243 0 0 1-.243-.243V8.384c0-.135.109-.243.243-.243h5.334c.133 0 .243.108.243.243v1.573c0 .134-.11.243-.243.243h-3.16v1.42h2.848c.135 0 .244.11.244.244v1.518a.243.243 0 0 1-.244.244h-2.847v2.767c0 .134-.11.243-.244.243m-10.567.146C4.416 16.782 3 15.31 3 12.843v-.962C3 9.487 4.453 8 6.793 8c2.314 0 3.436 1.467 3.522 2.922a.24.24 0 0 1-.242.258H8.195a.24.24 0 0 1-.24-.2c-.1-.55-.552-.892-1.18-.892-1.108 0-1.34.985-1.34 1.81v.94c0 1.231.467 1.856 1.393 1.856.885 0 1.2-.538 1.2-1v-.092H6.874a.243.243 0 0 1-.243-.243v-1.373c0-.134.11-.243.243-.243h3.216c.134 0 .243.109.243.243v1.555c0 1.496-.929 3.241-3.546 3.241"/></svg>`
    }, props, {
        size: 'medium'
    }));
$0a037d07967bfa4f$var$Gif24Icon.displayName = 'Gif24Icon';
var $0a037d07967bfa4f$var$_default = module.exports.default = $0a037d07967bfa4f$var$Gif24Icon;

});

parcelRegister("cHwqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $93f2a85309224bbe$var$_react = $93f2a85309224bbe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $93f2a85309224bbe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $93f2a85309224bbe$var$PowerpointPresentation24Icon = (props)=>/*#__PURE__*/ $93f2a85309224bbe$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ca5010" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM7.854 8.454h2.94c1.45 0 2.441.972 2.441 2.437 0 1.45-1.03 2.422-2.514 2.422H9.329V15.5H7.854zM9.33 9.665v2.451h1.07c.844 0 1.337-.43 1.337-1.22 0-.801-.483-1.231-1.333-1.231z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$93f2a85309224bbe$var$PowerpointPresentation24Icon.displayName = 'PowerpointPresentation24Icon';
var $93f2a85309224bbe$var$_default = module.exports.default = $93f2a85309224bbe$var$PowerpointPresentation24Icon;

});

parcelRegister("2sfBf", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1c9a4c12d2fc4227$var$_react = $1c9a4c12d2fc4227$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1c9a4c12d2fc4227$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1c9a4c12d2fc4227$var$WordDocument24Icon = (props)=>/*#__PURE__*/ $1c9a4c12d2fc4227$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#1d7afc" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zm5.629 5.324L8.687 16H7.295L5.43 8.954h1.533l1.099 4.966h.078l1.284-4.966h1.245l1.309 4.966h.078l1.089-4.966h1.523L12.798 16h-1.382l-1.333-4.663zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1c9a4c12d2fc4227$var$WordDocument24Icon.displayName = 'WordDocument24Icon';
var $1c9a4c12d2fc4227$var$_default = module.exports.default = $1c9a4c12d2fc4227$var$WordDocument24Icon;

});

parcelRegister("iABw2", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d888b0a1557aa645$var$_react = $d888b0a1557aa645$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d888b0a1557aa645$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d888b0a1557aa645$var$Sketch24Icon = (props)=>/*#__PURE__*/ $d888b0a1557aa645$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ff8b00" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m9.03 20c.29-.001.562-.126.752-.343l6.971-8a1 1 0 0 0 .095-1.185l-2.485-4a1 1 0 0 0-.85-.472h-8.84c-.334 0-.646.167-.832.444l-2.674 4a1 1 0 0 0 .081 1.216l7.03 8c.188.216.462.34.75.34"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d888b0a1557aa645$var$Sketch24Icon.displayName = 'Sketch24Icon';
var $d888b0a1557aa645$var$_default = module.exports.default = $d888b0a1557aa645$var$Sketch24Icon;

});

parcelRegister("7hpMa", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $54ce1d7bd56eb231$var$_react = $54ce1d7bd56eb231$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $54ce1d7bd56eb231$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $54ce1d7bd56eb231$var$Figma24Icon = (props)=>/*#__PURE__*/ $54ce1d7bd56eb231$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3.248 0A3.25 3.25 0 0 0 0 3.248v17.504A3.25 3.25 0 0 0 3.248 24h17.504A3.25 3.25 0 0 0 24 20.752V3.248A3.25 3.25 0 0 0 20.752 0zm8.755 17.013a2.506 2.506 0 0 1-2.505 2.506 2.506 2.506 0 0 1 0-5.013 2.506 2.506 0 0 1 0-5.012 2.506 2.506 0 0 1 0-5.013h5.009a2.506 2.506 0 0 1 0 5.013h-2.504v2.5a2.506 2.506 0 0 1 2.504-2.5 2.506 2.506 0 0 1 0 5.012 2.506 2.506 0 0 1-2.504-2.5z" clip-rule="evenodd"/></svg>`
    }, props, {
        size: 'medium'
    }));
$54ce1d7bd56eb231$var$Figma24Icon.displayName = 'Figma24Icon';
var $54ce1d7bd56eb231$var$_default = module.exports.default = $54ce1d7bd56eb231$var$Figma24Icon;

});

parcelRegister("dGYEZ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $9f7e406d5bea49df$var$_react = $9f7e406d5bea49df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $9f7e406d5bea49df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $9f7e406d5bea49df$var$Executable24Icon = (props)=>/*#__PURE__*/ $9f7e406d5bea49df$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#758195" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 13v5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-5zm1.883-8a1 1 0 0 0-.992.876L5 13h14l-.89-7.124A1 1 0 0 0 17.116 5zM8 15h8a1 1 0 0 1 0 2H8a1 1 0 0 1 0-2"/></svg>`
    }, props, {
        size: 'medium'
    }));
$9f7e406d5bea49df$var$Executable24Icon.displayName = 'Executable24Icon';
var $9f7e406d5bea49df$var$_default = module.exports.default = $9f7e406d5bea49df$var$Executable24Icon;

});

parcelRegister("iBOon", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $d8c2c58dddf5fcc0$var$_react = $d8c2c58dddf5fcc0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d8c2c58dddf5fcc0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d8c2c58dddf5fcc0$var$GoogleDoc24Icon = (props)=>/*#__PURE__*/ $d8c2c58dddf5fcc0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#2196f3" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$d8c2c58dddf5fcc0$var$GoogleDoc24Icon.displayName = 'GoogleDoc24Icon';
var $d8c2c58dddf5fcc0$var$_default = module.exports.default = $d8c2c58dddf5fcc0$var$GoogleDoc24Icon;

});

parcelRegister("jdlqN", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $dfcfdb061c664b77$var$_react = $dfcfdb061c664b77$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $dfcfdb061c664b77$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $dfcfdb061c664b77$var$GoogleForm24Icon = (props)=>/*#__PURE__*/ $dfcfdb061c664b77$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$dfcfdb061c664b77$var$GoogleForm24Icon.displayName = 'GoogleForm24Icon';
var $dfcfdb061c664b77$var$_default = module.exports.default = $dfcfdb061c664b77$var$GoogleForm24Icon;

});

parcelRegister("c70Lr", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $8d16bb363c31083e$var$_react = $8d16bb363c31083e$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $8d16bb363c31083e$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $8d16bb363c31083e$var$GoogleSheet24Icon = (props)=>/*#__PURE__*/ $8d16bb363c31083e$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#0a9d58" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$8d16bb363c31083e$var$GoogleSheet24Icon.displayName = 'GoogleSheet24Icon';
var $8d16bb363c31083e$var$_default = module.exports.default = $8d16bb363c31083e$var$GoogleSheet24Icon;

});

parcelRegister("2osAJ", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $1be4005185ae78d9$var$_react = $1be4005185ae78d9$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $1be4005185ae78d9$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $1be4005185ae78d9$var$GoogleSlide24Icon = (props)=>/*#__PURE__*/ $1be4005185ae78d9$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#ffc107" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m12.049 5-5.422.055 4.677 8.15 5.422-.055zM4 14.108l2.757 4.697 4.677-8.15-2.757-4.697zm6.646.141L7.982 19h9.354L20 14.249z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$1be4005185ae78d9$var$GoogleSlide24Icon.displayName = 'GoogleSlide24Icon';
var $1be4005185ae78d9$var$_default = module.exports.default = $1be4005185ae78d9$var$GoogleSlide24Icon;

});

parcelRegister("7zjHG", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $582b1603b710ea90$var$_react = $582b1603b710ea90$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $582b1603b710ea90$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $582b1603b710ea90$var$ExcelSpreadsheet24Icon = (props)=>/*#__PURE__*/ $582b1603b710ea90$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#22a06b" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m1.376 6.013A.44.44 0 0 0 4 6.446v11.15c0 .219.161.404.378.434l11.125 1.538a.437.437 0 0 0 .497-.434V4.868a.437.437 0 0 0-.499-.434zM17 7v10h2.5a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5zM6.93 15.5l2.25-3.55-2.236-3.496h1.734l1.47 2.466h.087l1.485-2.466h1.65l-2.32 3.52 2.286 3.526h-1.68l-1.513-2.388h-.088L8.52 15.5z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$582b1603b710ea90$var$ExcelSpreadsheet24Icon.displayName = 'ExcelSpreadsheet24Icon';
var $582b1603b710ea90$var$_default = module.exports.default = $582b1603b710ea90$var$ExcelSpreadsheet24Icon;

});

parcelRegister("8SPcB", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $677b15938c7d624c$var$_react = $677b15938c7d624c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $677b15938c7d624c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $677b15938c7d624c$var$Spreadsheet24Icon = (props)=>/*#__PURE__*/ $677b15938c7d624c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#36b37e" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m2 5a1 1 0 1 0 0 2h3a1 1 0 1 0 0-2zm0 4a1 1 0 1 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h3a1 1 0 0 0 0-2zm7-12a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2zm0 4a1 1 0 0 0 0 2h7a1 1 0 0 0 0-2z"/></svg>`
    }, props, {
        size: 'medium'
    }));
$677b15938c7d624c$var$Spreadsheet24Icon.displayName = 'Spreadsheet24Icon';
var $677b15938c7d624c$var$_default = module.exports.default = $677b15938c7d624c$var$Spreadsheet24Icon;

});

parcelRegister("es8mD", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $a85a2b23143ceb75$var$_react = $a85a2b23143ceb75$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $a85a2b23143ceb75$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a85a2b23143ceb75$var$Presentation24Icon = (props)=>/*#__PURE__*/ $a85a2b23143ceb75$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#8270db" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m3 14a1 1 0 0 0-1 1v3a1 1 0 0 0 2 0v-3a1 1 0 0 0-1-1m8-6a1 1 0 0 0-1 1v9a1 1 0 0 0 2 0V9a1 1 0 0 0-1-1m-4 4a1 1 0 0 0-1 1v5a1 1 0 0 0 2 0v-5a1 1 0 0 0-1-1m8-7a1 1 0 0 0-1 1v12a1 1 0 0 0 2 0V6a1 1 0 0 0-1-1"/></svg>`
    }, props, {
        size: 'medium'
    }));
$a85a2b23143ceb75$var$Presentation24Icon.displayName = 'Presentation24Icon';
var $a85a2b23143ceb75$var$_default = module.exports.default = $a85a2b23143ceb75$var$Presentation24Icon;

});

parcelRegister("gYsK7", function(module, exports) {
'use strict';
Object.defineProperty(module.exports, '__esModule', {
    value: true
});
module.exports.default = void 0;

var $c5b88baa981b1084$var$_react = $c5b88baa981b1084$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $c5b88baa981b1084$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c5b88baa981b1084$var$SourceCode24Icon = (props)=>/*#__PURE__*/ $c5b88baa981b1084$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="#00b8d9" fill-rule="evenodd" d="M3 0h18a3 3 0 0 1 3 3v18a3 3 0 0 1-3 3H3a3 3 0 0 1-3-3V3a3 3 0 0 1 3-3m5.017 12.265-2.58-2.501L8.236 7.05a.999.999 0 1 0-1.392-1.436l-3.54 3.432a1 1 0 0 0 0 1.436l3.32 3.219a1 1 0 1 0 1.393-1.436m6.638-8.21a1 1 0 0 0-1.271.62l-4.83 14.046a1 1 0 0 0 1.892.65l4.829-14.045a1 1 0 0 0-.62-1.271m6.081 9.776-3.32-3.219a.999.999 0 1 0-1.393 1.436l2.58 2.501-2.799 2.714a.999.999 0 1 0 1.392 1.436l3.54-3.432a1 1 0 0 0 0-1.436"/></svg>`
    }, props, {
        size: 'medium'
    }));
$c5b88baa981b1084$var$SourceCode24Icon.displayName = 'SourceCode24Icon';
var $c5b88baa981b1084$var$_default = module.exports.default = $c5b88baa981b1084$var$SourceCode24Icon;

});

parcelRegister("8RqHP", function(module, exports) {

$parcel$export(module.exports, "getExtension", () => $60b93921782d6d1e$export$78d71f9ed5534abe);
$parcel$export(module.exports, "isCodeViewerItem", () => $60b93921782d6d1e$export$bb139b46f345ca28);
$parcel$export(module.exports, "getLanguageType", () => $60b93921782d6d1e$export$ba4368c844580f9e);
function $60b93921782d6d1e$export$78d71f9ed5534abe(filename) {
    if (filename.indexOf('.') > -1) return filename.split('.').pop();
    return '';
}
const $60b93921782d6d1e$var$codeViewerMimeTypes = [
    {
        mimetype: 'application/json',
        language: 'json'
    },
    {
        mimetype: 'text/html',
        language: 'html'
    }
];
function $60b93921782d6d1e$export$bb139b46f345ca28(name, mimetype = 'unknown') {
    return $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) !== null;
}
function $60b93921782d6d1e$export$ba4368c844580f9e(name, mimetype) {
    if (mimetype) {
        const languageForMimeType = $60b93921782d6d1e$var$codeViewerMimeTypes.find((x)=>x.mimetype === mimetype);
        if (languageForMimeType) return languageForMimeType.language;
    }
    const ext = $60b93921782d6d1e$export$78d71f9ed5534abe(name);
    switch(ext){
        case 'abap':
        case 'ada':
        case 'c':
        case 'css':
        case 'd':
        case 'dart':
        case 'go':
        case 'graphql':
        case 'groovy':
        case 'html':
        case 'java':
        case 'json':
        case 'matlab':
        case 'xml':
        case 'lua':
        case 'puppet':
        case 'qml':
        case 'sass':
        case 'sql':
        case 'php':
        case 'r':
        case 'swift':
        case 'tcl':
        case 'vala':
        case 'vhdl':
        case 'xquery':
            return ext;
        case 'as':
        case 'asc':
            return 'actionscript';
        case 'ino':
            return 'arduino';
        case 'au3':
            return 'autoit';
        case 'cpp':
        case 'h':
        case 'c++':
            return 'c++';
        case 'coffee':
            return 'coffeescript';
        case 'cs':
            return 'csharp';
        case 'cu':
            return 'cuda';
        case 'pas':
        case 'dpr':
        case 'dproj':
        case 'dpk':
            return 'delphi';
        case 'ex':
        case 'exs':
            return 'elixir';
        case 'erl':
        case 'hrl':
            return 'erlang';
        case 'f90':
        case 'for':
        case 'f':
        case 'fpp':
        case 'i':
        case 'i90':
        case 'ftn':
            return 'fortran';
        case 'dbc':
            return 'foxpro';
        case 'hs':
        case 'has':
            return 'haskell';
        case 'hx':
            return 'haxe';
        case 'js':
        case 'jsx':
            return 'javascript';
        case 'jl':
            return 'julia';
        case 'kt':
            return 'kotlin';
        case 'm':
        case 'mm':
            return 'objective-c';
        case 'j':
            return 'objective-j';
        case 'tex':
            return 'latex';
        case 'nb':
        case 'cdf':
            return 'mathematica';
        case 'cma':
            return 'ocaml';
        case 'pl':
            return 'perl';
        case 'py':
            return 'python';
        case 'ps1':
        case 'psd1':
        case 'psm1':
            return 'powershell';
        case 'rb':
            return 'ruby';
        case 'rst':
            return 'restructuredtext';
        case 'rs':
            return 'rust';
        case 'rkt':
            return 'racket';
        case 'sh':
            return 'shell';
        case 'sc':
        case 'sch':
            return 'scheme';
        case 'txt':
        case 'msg':
        case 'log':
        case 'csv':
        case 'md':
            return 'text';
        case 'ts':
        case 'tsx':
            return 'typescript';
        case 'v':
            return 'verilog';
        case 'xq':
        case 'xql':
        case 'xqm':
        case 'xqy':
            return 'xquery';
        case 'lock':
        case 'yaml':
        case 'yml':
            return 'yaml';
        default:
            return null;
    }
}

});


parcelRegister("jegge", function(module, exports) {

let $dffbf02b1eb2951b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $dffbf02b1eb2951b$var$load("4tH5n").then(()=>parcelRequire('eYIux'));

});


parcelRegister("2edT6", function(module, exports) {

$parcel$export(module.exports, "parseXMPMetaData", () => $1cac606283e05089$export$55c3bc9841b19de2);
function $1cac606283e05089$export$55c3bc9841b19de2(xmpMetaData) {
    const metadata = {};
    const tags = xmpMetaData.match(/<(tiff|exif):.+>/gi);
    if (tags) tags.forEach((tag)=>{
        const match = tag.match(/<(tiff|exif):([^>]+)>([^<]+)/i);
        if (match) {
            const name = match[2];
            metadata[name] = match[3];
        }
    });
    return metadata;
}

});


parcelRegister("hNjKA", function(module, exports) {

$parcel$export(module.exports, "isRotated", () => $81d3fceca65be0fc$export$8af433705f41088f);
$parcel$export(module.exports, "getCssFromImageOrientation", () => $81d3fceca65be0fc$export$43142f95b8de7a91);
const $81d3fceca65be0fc$var$ORIENT_TRANSFORMS = {
    1: 'none',
    2: 'rotateY(180deg)',
    3: 'rotate(180deg)',
    4: 'rotate(180deg) rotateY(180deg)',
    5: 'rotate(270deg) rotateY(180deg)',
    6: 'rotate(90deg)',
    7: 'rotate(90deg) rotateY(180deg)',
    8: 'rotate(270deg)'
};
const $81d3fceca65be0fc$export$8af433705f41088f = (orientation)=>orientation >= 5;
const $81d3fceca65be0fc$export$43142f95b8de7a91 = (orientation)=>{
    return $81d3fceca65be0fc$var$ORIENT_TRANSFORMS[orientation];
};

});


parcelRegister("Nl5sY", function(module, exports) {

$parcel$export(module.exports, "takeSnapshot", () => $33ec34d1173165de$export$4269d30173168e5c);
const $33ec34d1173165de$export$4269d30173168e5c = async (blob)=>{
    return new Promise((resolve, reject)=>{
        const url = URL.createObjectURL(blob);
        const video = document.createElement('video');
        video.preload = 'metadata';
        video.src = url;
        video.muted = true;
        video.play().catch(()=>{
            return reject(new Error('failed to play video'));
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('timeupdate', function timeUpdateHandler() {
            // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
            video.removeEventListener('timeupdate', timeUpdateHandler);
            video.pause();
            URL.revokeObjectURL(url);
            //create canvas to draw our first frame on.
            if (!video.videoWidth && !video.videoHeight) return reject(new Error('error retrieving video dimensions'));
            const canvas = document.createElement('canvas');
            canvas.width = video.videoWidth;
            canvas.height = video.videoHeight;
            const context = canvas.getContext('2d');
            if (!context) return reject(new Error('error creating canvas context'));
            context.drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataURL = canvas.toDataURL('image/jpeg', 0.85);
            resolve(dataURL);
        });
        // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
        video.addEventListener('error', ()=>{
            reject(new Error('failed to load video'));
            URL.revokeObjectURL(url);
        });
    });
};

});



parcelRegister("3JZCV", function(module, exports) {

$parcel$export(module.exports, "getMediaCardSSR", () => $293d53ca8ea6912a$export$ede93d4564eaa8da);
$parcel$export(module.exports, "getKey", () => $293d53ca8ea6912a$export$a47fb462a08de82f);
$parcel$export(module.exports, "generateScriptProps", () => $293d53ca8ea6912a$export$de7c49925e44d75d);

var $1QRxp = parcelRequire("1QRxp");
const $293d53ca8ea6912a$export$21c2ece80f3e3137 = 'mediaCardSsr';
const $293d53ca8ea6912a$export$5b1a163e413609f8 = '__MEDIA_INTERNAL';
function $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope = window) {
    // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
    const namespace = '__MEDIA_INTERNAL';
    if (!globalScope[namespace]) globalScope[namespace] = {};
    return globalScope[namespace];
}
function $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope = window) {
    const globalMedia = $293d53ca8ea6912a$export$96a3cfb3a41e9bb2(globalScope);
    // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
    const key = 'mediaCardSsr';
    if (!globalMedia[key]) globalMedia[key] = {};
    return globalMedia[key];
}
const $293d53ca8ea6912a$var$dashed = (param)=>param ? `-${param}` : '';
const $293d53ca8ea6912a$export$a47fb462a08de82f = ({ id: id, collectionName: collectionName, occurrenceKey: occurrenceKey })=>`${id}${$293d53ca8ea6912a$var$dashed(collectionName)}${$293d53ca8ea6912a$var$dashed(occurrenceKey)}`;
const $293d53ca8ea6912a$export$4310981e0aa4ce67 = (key, dataURI, dimensions, error, globalScope = window)=>{
    const mediaCardSsr = $293d53ca8ea6912a$export$ede93d4564eaa8da(globalScope);
    mediaCardSsr[key] = {
        dataURI: dataURI,
        dimensions: dimensions,
        error: error
    };
};
const $293d53ca8ea6912a$var$generateScript = (identifier, dataURI, dimensions, error)=>{
    const functionCall = (0, $1QRxp.printFunctionCall)($293d53ca8ea6912a$export$4310981e0aa4ce67, $293d53ca8ea6912a$export$a47fb462a08de82f(identifier), dataURI, dimensions, error);
    return (0, $1QRxp.printScript)([
        $293d53ca8ea6912a$export$ede93d4564eaa8da.toString(),
        $293d53ca8ea6912a$export$96a3cfb3a41e9bb2.toString(),
        functionCall
    ]);
};
const $293d53ca8ea6912a$export$de7c49925e44d75d = (identifier, dataURI, dimensions, error)=>({
        dangerouslySetInnerHTML: {
            __html: $293d53ca8ea6912a$var$generateScript(identifier, dataURI, dimensions, error)
        }
    });

});
parcelRegister("1QRxp", function(module, exports) {

$parcel$export(module.exports, "printFunctionCall", () => $56ce1649d25a132b$export$3742967cc82ac85a);
$parcel$export(module.exports, "printScript", () => $56ce1649d25a132b$export$8b902fb69a2f17c1);

var $VSDnB = parcelRequire("VSDnB");
const $56ce1649d25a132b$var$printParam = (param)=>{
    if (typeof param === 'string') return `'${param}'`;
    else if (typeof param === 'object') return JSON.stringify(param);
    else if (param === undefined) return 'undefined';
    return param;
};
const $56ce1649d25a132b$var$printParams = (args)=>args.map((arg)=>$56ce1649d25a132b$var$printParam(arg)).join(',');
const $56ce1649d25a132b$export$3742967cc82ac85a = (fn, ...args)=>`(${fn.toString()})(${$56ce1649d25a132b$var$printParams(args)});`;
const $56ce1649d25a132b$export$8b902fb69a2f17c1 = (statements)=>(0, $VSDnB.fg)('platform_remove_media_script_after_execution') ? `(function(){
 			 ${statements.join(';')}
  			document.currentScript.remove();
		})();
		` : `(function(){
   			${statements.join(';')}
 		})();`;

});


parcelRegister("jR4hE", function(module, exports) {

$parcel$export(module.exports, "getSSRData", () => $815e3e27cebcb154$export$d3a890b0f7844b6f);

var $3JZCV = parcelRequire("3JZCV");
const $815e3e27cebcb154$export$d3a890b0f7844b6f = (identifier)=>{
    const mediaCardSsr = (0, $3JZCV.getMediaCardSSR)();
    if (!mediaCardSsr) return;
    return mediaCardSsr[(0, $3JZCV.getKey)(identifier)];
};

});

parcelRegister("8Kbwv", function(module, exports) {

$parcel$export(module.exports, "isBigger", () => $7b6d905fc3b6f0e9$export$912a00e9a5470d9a);
$parcel$export(module.exports, "createRequestDimensions", () => $7b6d905fc3b6f0e9$export$3063221e86a58f9);
$parcel$export(module.exports, "useCurrentValueRef", () => $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db);

var $5uXOq = parcelRequire("5uXOq");
const $7b6d905fc3b6f0e9$export$912a00e9a5470d9a = (current, next)=>{
    const { width: currentWidth, height: currentHeight } = current || {};
    const { width: nextWidth, height: nextHeight } = next || {};
    if (!!currentWidth && !!currentHeight && !!nextWidth && !!nextHeight) {
        const nextIsWider = currentWidth < nextWidth;
        const nextIsHigher = currentHeight < nextHeight;
        return nextIsHigher || nextIsWider;
    } else return false;
};
/** Verifies if the current screen is retina display */ function $7b6d905fc3b6f0e9$var$isRetina() {
    const mediaQuery = '(-webkit-min-device-pixel-ratio: 1.5), (min--moz-device-pixel-ratio: 1.5), (-o-min-device-pixel-ratio: 3/2), (min-resolution: 1.5dppx)';
    return window.devicePixelRatio > 1 || window.matchMedia && window.matchMedia(mediaQuery).matches;
}
const $7b6d905fc3b6f0e9$export$3063221e86a58f9 = (dimensions)=>{
    if (!dimensions) return;
    const retinaFactor = $7b6d905fc3b6f0e9$var$isRetina() ? 2 : 1;
    const { width: width, height: height } = dimensions;
    const result = {};
    if (width) result.width = width * retinaFactor;
    if (height) result.height = height * retinaFactor;
    return result;
};
function $7b6d905fc3b6f0e9$export$b3e10e1f0fbb71db(value) {
    const ref = (0, $5uXOq.useRef)(value);
    ref.current = value;
    return ref;
}

});







parcelRegister("5KVmP", function(module, exports) {

$parcel$export(module.exports, "NewCard", () => $11fafa1598e26c74$export$909f8fb1bfc9b07);
$parcel$export(module.exports, "default", () => $11fafa1598e26c74$export$2e2bcd8739ae039);

var $7uUwQ = parcelRequire("7uUwQ");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $jzjy1 = parcelRequire("jzjy1");

var $2vSU6 = parcelRequire("2vSU6");

var $7wqBZ = parcelRequire("7wqBZ");

var $4R6GH = parcelRequire("4R6GH");

var $bC2fB = parcelRequire("bC2fB");



var $iuuJH = parcelRequire("iuuJH");

var $2f454 = parcelRequire("2f454");

var $dW1HX = parcelRequire("dW1HX");

var $evkwq = parcelRequire("evkwq");

var $2ON1s = parcelRequire("2ON1s");

var $9OPlz = parcelRequire("9OPlz");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $fqLDH = parcelRequire("fqLDH");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $7OmGs = parcelRequire("7OmGs");
const $11fafa1598e26c74$var$defaultHighlightLabelsOnCard = (0, $7uUwQ.freeze)([]);
const $11fafa1598e26c74$export$293240b492ab7f40 = ({ draggingCardData: draggingCardData, droppingCardData: droppingCardData, isCMPBoard: isCMPBoard, isRankable: isRankable, swimlaneMode: swimlaneMode, issueChildren: issueChildren, selectedCards: selectedCards, isIncrementPlanningBoard: isIncrementPlanningBoard })=>{
    // Childless cards cannot be moved to a subtask type swimlane and vice-versa
    const sourceSwimlaneId = draggingCardData.swimlaneId;
    const targetSwimlaneId = droppingCardData.swimlaneId;
    if (targetSwimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS) && sourceSwimlaneId !== (0, $iuuJH.SWIMLANE_CHILDLESS) || targetSwimlaneId !== (0, $iuuJH.SWIMLANE_CHILDLESS) && sourceSwimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS)) return false;
    // In Increment planning board, allow the user to rank issues by drop on card
    if (isIncrementPlanningBoard) return true;
    if (!isCMPBoard) return true;
    if (!isRankable) return false;
    if (draggingCardData.swimlaneId !== droppingCardData.swimlaneId) return false;
    if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        const draggingIssueChild = issueChildren[draggingCardData.cardId];
        const droppingIssueChild = issueChildren[droppingCardData.cardId];
        if (draggingIssueChild || droppingIssueChild) return draggingIssueChild?.parentId === droppingIssueChild?.parentId;
    }
    if (selectedCards?.includes(droppingCardData.cardId)) return false;
    return true;
};
const $11fafa1598e26c74$export$c31df4bd766f9c35 = ()=>{
    const isDroppableOnCardFactory = (0, $8QpSo.default)((isCMPBoard, isRankable, swimlaneMode, issueChildren, selectedCards, isIncrementPlanningBoard)=>(draggingCardData, droppingCardData)=>$11fafa1598e26c74$export$293240b492ab7f40({
                draggingCardData: draggingCardData,
                droppingCardData: droppingCardData,
                isCMPBoard: isCMPBoard,
                isRankable: isRankable,
                swimlaneMode: swimlaneMode,
                issueChildren: issueChildren,
                selectedCards: selectedCards,
                isIncrementPlanningBoard: isIncrementPlanningBoard
            }));
    return (state, ownProps)=>{
        const { id: id } = ownProps;
        const issue = (0, $5mTgl.platformIssueSelector)(state)(id);
        const highlight = (0, $5mTgl.platformHighlightScopeSelector)(state);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const issueParents = (0, $bSSdD.issueParentsSelector)(state);
        const availableIssueParentsForIssueProject = (0, $bSSdD.availableIssueParentsForIssueProjectSelector)(state)(issue?.projectId);
        const issueParentsObj = (0, $bSSdD.getIssueParents)(state);
        const isParent = id in issueParentsObj;
        const parentId = (()=>{
            if (!issue) return null;
            if (isParent) return id;
            return issue.parentId;
        })();
        const parent = parentId !== null ? (0, $bSSdD.makeIssueParentByIdSelector)(state)(parentId) : null;
        const isJSMBoard = (0, $67Z81.projectTypeSelector)(state) === (0, $2vSU6.SERVICE_DESK_PROJECT);
        const isRankable = (0, $67Z81.isBoardRankable)(state);
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        const issueChildren = (0, $3UY9S.getIssueChildren)(state);
        const selectedCards = (0, $9OPlz.getCardSelection)(state);
        const projects = (0, $67Z81.getIssueProjects)(state);
        const projectKey = issue && Object.values(projects).find((project)=>project.id === issue.projectId)?.key;
        const isDroppableOnCard = isDroppableOnCardFactory(isCMPBoard, isRankable, swimlaneMode, issueChildren, selectedCards, isIncrementPlanningBoard);
        const statusId = issue?.statusId ?? null;
        return {
            issue: issue,
            assignee: issue && issue?.assigneeAccountId !== null ? (0, $36pz7.getPerson)(state, issue.assigneeAccountId) : null,
            parent: parent,
            issueParents: isIncrementPlanningBoard ? availableIssueParentsForIssueProject : issueParents,
            estimate: (0, $5mTgl.getEstimateExtendedByIssueId)(state, {
                id: id
            }),
            shouldShowParent: (0, $9OPlz.getShouldShowParent)(state),
            shouldShowRipple: (0, $9OPlz.shouldCardShowRipple)(state)(id),
            isDone: (0, $d2i8f.isDoneIssueSelector)(state)(id),
            isSelected: (0, $9OPlz.isCardSelected)(state)(id),
            isFocused: (0, $9OPlz.isCardFocused)(state)(id),
            isFlagged: issue?.isFlagged || false,
            isIssueViewOpen: (0, $fqLDH.isIssueModalShowingSelector)(state),
            shouldRenderCardType: (0, $5mTgl.shouldRenderCardTypesSelector)(state),
            highlightTextOnCard: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(highlight, 'text', '') || '',
            // defaultHighlightLabelsOnCard is used to avoid unnecessary re-renderings.
            // If you use [] instead "Card" component would be re-rendered every time when connect function is executed
            highlightLabelsOnCard: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(highlight, 'labels', $11fafa1598e26c74$var$defaultHighlightLabelsOnCard) || $11fafa1598e26c74$var$defaultHighlightLabelsOnCard,
            isDragDisabled: (0, $5mTgl.isCardDragDisabled)(state)(id),
            hideEpic: isCMPBoard && state.ui.board.displayOptions.areEpicLabelsHidden,
            projectIds: (0, $67Z81.getIssueProjectIds)(state),
            projectKey: projectKey,
            isCMPBoard: isCMPBoard,
            status: isJSMBoard || isIncrementPlanningBoard && statusId && (0, $4R6GH.fg)('issue_cards_in_program_board') ? (0, $5mTgl.getStatusByIssueIdSelector)(state, {
                id: id
            }) ?? null : null,
            isDroppableOnCard: isDroppableOnCard,
            ...isIncrementPlanningBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') && {
                issueStatuses: (0, $67Z81.getStatuses)(state)
            }
        };
    };
};
const $11fafa1598e26c74$export$9e6a17cf56877796 = (dispatch)=>({
        onClick: (id, withCmd, withShift, externalAction)=>{
            if (!withCmd && !withShift) (0, $7wqBZ.getLongTasksMetrics)('bento').start('board');
            dispatch((0, $2f454.cardClick)(id, withCmd, withShift, externalAction));
        },
        onEnterPress: (issueKey)=>{
            dispatch((0, $dW1HX.openIssueModal)(issueKey));
        },
        onMouseDown: ()=>{
            (0, $7wqBZ.getLongTasksMetrics)('dnd').start('board', (0, $dcbb2bce513725b3$export$67cc25959ff33188));
        },
        onMouseUp: ()=>{
            (0, $7wqBZ.getLongTasksMetrics)('dnd').stopIfNoMark((0, $dcbb2bce513725b3$export$67cc25959ff33188));
        },
        onRippleEnd: (id)=>{
            dispatch((0, $2f454.cardRemoveShowRipple)(id));
        },
        onFocus: (id)=>{
            dispatch((0, $2f454.cardFocus)(id));
        },
        onBlur: ()=>{
            dispatch((0, $2f454.cardBlur)());
        },
        onCloseOtherPanels: ()=>{
            dispatch((0, $2ON1s.closeInsightsPanel)());
            dispatch((0, $2ON1s.closeViewSettingsPanel)());
        },
        onChangeIssueStatus: (issueId, transition, isDone)=>{
            dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
                issueId: issueId,
                fieldId: (0, $7e733a5d4e4331fc$export$7445eb3755623031),
                fieldValue: {
                    statusId: Number(transition.to.id),
                    statusTransitionId: `${transition.id}`,
                    isDone: isDone
                }
            }));
        }
    });
/**
 * Non editable card - Use NewCard if possible
 * */ const $11fafa1598e26c74$var$CardConnected = (0, $bC2fB.connect)($11fafa1598e26c74$export$c31df4bd766f9c35, $11fafa1598e26c74$export$9e6a17cf56877796)((0, $jzjy1.AnalyticsSubject)('issue')((0, $7OmGs.default)));
const $11fafa1598e26c74$export$909f8fb1bfc9b07 = (0, $bC2fB.connect)($11fafa1598e26c74$export$c31df4bd766f9c35, $11fafa1598e26c74$export$9e6a17cf56877796)((0, $jzjy1.AnalyticsSubject)('issue')((0, $7OmGs.NewCardWithNullableIssue)));
var $11fafa1598e26c74$export$2e2bcd8739ae039 = $11fafa1598e26c74$var$CardConnected;

});
parcelRegister("7OmGs", function(module, exports) {

$parcel$export(module.exports, "NewCardWithNullableIssue", () => $c4fa088541c3ca24$export$9f96343954949053);
$parcel$export(module.exports, "default", () => $c4fa088541c3ca24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $2NMNM = parcelRequire("2NMNM");

var $5rFbt = parcelRequire("5rFbt");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $54wEF = parcelRequire("54wEF");

var $3fAi8 = parcelRequire("3fAi8");

var $b8gJu = parcelRequire("b8gJu");

var $58K4A = parcelRequire("58K4A");

var $iXVV6 = parcelRequire("iXVV6");



var $lu5k0 = parcelRequire("lu5k0");

var $iDGXn = parcelRequire("iDGXn");

var $dCm1o = parcelRequire("dCm1o");

var $2xFXk = parcelRequire("2xFXk");

var $4kv6l = parcelRequire("4kv6l");

var $iUagi = parcelRequire("iUagi");


var $7mkyN = parcelRequire("7mkyN");

var $4RVsR = parcelRequire("4RVsR");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $5wBpE = parcelRequire("5wBpE");

var $kJtdN = parcelRequire("kJtdN");

var $aeiE5 = parcelRequire("aeiE5");

var $2H35T = parcelRequire("2H35T");

var $hnyd8 = parcelRequire("hnyd8");

var $fBeRa = parcelRequire("fBeRa");

var $POab5 = parcelRequire("POab5");

var $9uH2Z = parcelRequire("9uH2Z");

var $2Gmm7 = parcelRequire("2Gmm7");

var $UJNvI = parcelRequire("UJNvI");

var $aLb7D = parcelRequire("aLb7D");
const $c4fa088541c3ca24$var$selectedCardIds = [];
const $c4fa088541c3ca24$export$2ad76717ee8b873f = ({ id: id, issue: issue, isFocused: isFocused, onEnterPress: onEnterPress, onFocus: onFocus, onRippleEnd: onRippleEnd, userCanViewMenu: userCanViewMenu, isSummaryEditing: isSummaryEditing, Cover: Cover, parent: parent, onIssueChange: onIssueChange, onClick: onClick, onCloseOtherPanels: onCloseOtherPanels, isCMPBoard: isCMPBoard, isFlagged: isFlagged, isActive: isActive = false, isIssueViewOpen: isIssueViewOpen, issueStatuses: issueStatuses, onChangeIssueStatus: onChangeIssueStatus, ...props })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const transformedIssueStatuses = (0, $5uXOq.useMemo)(()=>(0, $aLb7D.transformStatusesStateToIssueStatusesById)(issueStatuses ?? {}), [
        issueStatuses
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)() ?? false;
    const isIPBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)() ?? false;
    const isJSMBoard = (0, $63LqY.useIsJSMBoard)() ?? false;
    const viewSettings = (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() ? (0, $iDGXn.useCardFieldsSettings)() : {
        showIssueType: true,
        showIssueKey: true,
        showEstimate: true,
        showPriority: true,
        showDevelopment: true,
        showAssignee: true,
        showDaysInColumn: true,
        showDueDate: true,
        showLabels: true,
        cardExtraFields: undefined,
        showStatuses: true
    };
    const returnFocusTo = (0, $lu5k0.useReturnFocusTo)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const menuTriggerRef = (0, $5uXOq.useRef)(null);
    const triggerIsFocused = Boolean(returnFocusTo?.current && menuTriggerRef.current && returnFocusTo?.current === menuTriggerRef.current);
    const handleMenuOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if (isOpen && menuTriggerRef?.current) setReturnFocusTo(menuTriggerRef);
        // Restore focus to the meatball button when the menu closes for better accessibility.
        if (!isOpen && menuTriggerRef?.current) menuTriggerRef.current.focus();
    }, [
        setReturnFocusTo
    ]);
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $7mkyN.PlanModalEntrypointContext));
    const renderContextMenu = ()=>{
        const isNotOptimisticIssue = (0, $4R6GH.fg)('program_board_misc_improvements') ? Number(issue.id) > 0 || isIncrementPlanningBoard : Number(issue.id) > 0;
        // Do not render in optimistic cards
        return isNotOptimisticIssue ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJtdN.ContextMenu), {
            issueId: issue.id,
            issueKey: issue.key,
            summary: issue.summary,
            selectedCardIds: $c4fa088541c3ca24$var$selectedCardIds,
            appearance: (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b),
            onOpenChange: handleMenuOpenChange,
            triggerRef: menuTriggerRef
        }) : null;
    };
    const renderMenu = ()=>{
        if (!userCanViewMenu || isSummaryEditing) return null;
        return renderContextMenu();
    };
    const onEnterPressCb = (0, $5uXOq.useCallback)(()=>{
        onEnterPress(issue.key);
    }, [
        onEnterPress,
        issue.key
    ]);
    const onFocusCb = (0, $5uXOq.useCallback)(()=>{
        onFocus(id);
    }, [
        id,
        onFocus
    ]);
    const onRippleEndCb = (0, $5uXOq.useCallback)(()=>{
        onRippleEnd(id);
    }, [
        id,
        onRippleEnd
    ]);
    const viewMode = (0, $2gCtH.useViewMode)();
    const onClickCb = (0, $5uXOq.useCallback)((issueId, withCmd, withShift, externalAction)=>{
        if (isIncrementPlanningBoard && !withCmd && !withShift && (0, $4R6GH.fg)('issue_view_in_program_board')) {
            if (!issueId || issueId === -1) return;
            entryPointActions.load();
        }
        onClick(issueId, withCmd, withShift, externalAction);
        if (viewMode === 'SIDEBAR' && !withCmd) onCloseOtherPanels();
    }, [
        entryPointActions,
        isIncrementPlanningBoard,
        onClick,
        onCloseOtherPanels,
        viewMode
    ]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const cover = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Cover, {
            id: id,
            onImageLoad: onIssueChange
        }), [
        id,
        onIssueChange
    ]);
    const issueParent = (0, $5uXOq.useMemo)(()=>parent ? {
            ...parent,
            issueType: {
                ...parent.issueType
            }
        } : null, [
        parent
    ]);
    const shouldRenderEpic = (0, $iDGXn.useShowEpics)();
    const isFlexible = (0, $63LqY.useCapability)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS);
    const hasCompactIssueType = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_COMPACT_ISSUE_TYPE_ICON_ON_CARD);
    let dateFormat = null;
    if (issue?.dueDate) dateFormat = (0, $dCm1o.isVisualRefreshEnabled)() ? 'dd MMM yyyy' : (0, $4kv6l.getDateFormat)(issue.dueDate);
    const renderIssueLinksIndicator = (0, $5uXOq.useCallback)(()=>{
        if (!isIncrementPlanningBoard || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(issue.issueLinks)) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aeiE5.IssueLinksIndicator), {
            ...(0, $4R6GH.fg)('concurrent-rendering-fix-unique-list-key') ? {
                key: `${issue.id}-links-indicator`
            } : {},
            issueId: issue.id,
            issueKey: issue.key
        });
    }, [
        isIncrementPlanningBoard,
        issue.id,
        issue.key,
        issue.issueLinks
    ]);
    const onIssueUnlink = (0, $5uXOq.useCallback)((issueIds)=>dispatch((0, $4RVsR.fetchIssueLinksStats)(issueIds, {
            analyticsEvent: createAnalyticsEvent({})
        })), [
        createAnalyticsEvent,
        dispatch
    ]);
    // Card should not steal focus away from the issue view
    const shouldFocus = isFocused && !isIssueViewOpen;
    const renderIssueLinksStats = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2H35T.IssueLinksStats), {
            id: issue.id,
            issueKey: issue.key,
            summary: issue.summary,
            typeId: issue.typeId,
            onIssueUnlink: onIssueUnlink
        });
    const renderStatusField = (0, $5uXOq.useCallback)(()=>{
        if (isIncrementPlanningBoard && viewSettings.showStatuses && (0, $4R6GH.fg)('issue_cards_in_program_board')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9uH2Z.IssueStatusField), {
            issue: issue,
            issueStatuses: transformedIssueStatuses,
            onChange: onChangeIssueStatus,
            isReadOnly: isIPBoardReadOnly
        });
        return null;
    }, [
        isIncrementPlanningBoard,
        issue,
        transformedIssueStatuses,
        onChangeIssueStatus,
        isIPBoardReadOnly,
        viewSettings.showStatuses
    ]);
    const getBoardViewType = ()=>{
        if (isJSWBoard && !isIncrementPlanningBoard) return (0, $b8gJu.BoardView).JSW_BOARD;
        if (isIncrementPlanningBoard) return (0, $b8gJu.BoardView).INCREMENT_PLANNING_BOARD;
        if (isJSMBoard) return (0, $b8gJu.BoardView).JSM_BOARD;
        // default to JSW_BOARD
        return (0, $b8gJu.BoardView).JSW_BOARD;
    };
    const showLabelsOutsideOfCustomFieldsList = (0, $aLb7D.getShouldShowLabels)(viewSettings.showLabels, isCMPBoard);
    // change to just onClickCb on issue_view_in_program_board clean up
    const clickCbWithFG = ()=>{
        if ((0, $4R6GH.fg)('issue_view_in_program_board')) return onClickCb;
        return !isIPBoardReadOnly ? onClickCb : undefined;
    };
    const shouldPersistActions = isActive || triggerIsFocused;
    const showDueDate = (0, $aLb7D.shouldShowDueDate)({
        viewSettingsShowDueDate: viewSettings.showDueDate,
        isCMPBoard: isCMPBoard,
        boardType: getBoardViewType()
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58K4A.Card), {
        ...props,
        id: id,
        issue: issue,
        parent: shouldRenderEpic ? issueParent : null,
        shouldFocus: shouldFocus,
        isFlexible: isFlexible,
        onClick: clickCbWithFG(),
        onEnterPress: onEnterPressCb,
        onFocus: onFocusCb,
        onRippleEnd: onRippleEndCb,
        cover: cover,
        CustomContextMenu: !isIPBoardReadOnly && userCanViewMenu ? (0, $kJtdN.ContextMenu) : undefined,
        renderCustomMenu: renderMenu,
        onSizeChange: onIssueChange,
        isCMPBoard: isCMPBoard,
        selectedCardIds: $c4fa088541c3ca24$var$selectedCardIds,
        dateFormat: dateFormat,
        hasCompactIssueType: hasCompactIssueType,
        isIPBoard: isIncrementPlanningBoard,
        isFlagged: !isIncrementPlanningBoard && isFlagged,
        renderIssueLinksIndicator: renderIssueLinksIndicator,
        renderIssueLinksStats: renderIssueLinksStats,
        persistActions: shouldPersistActions,
        showDaysInColumn: viewSettings.showDaysInColumn,
        shouldRenderCardType: viewSettings.showIssueType,
        showIssueKey: viewSettings.showIssueKey,
        showEstimate: viewSettings.showEstimate,
        showPriority: viewSettings.showPriority,
        showDevelopment: viewSettings.showDevelopment,
        showCardExtraFields: viewSettings.cardExtraFields,
        showAssignee: viewSettings.showAssignee,
        showDueDate: showDueDate,
        boardType: getBoardViewType(),
        showLabels: showLabelsOutsideOfCustomFieldsList,
        renderStatusField: renderStatusField
    });
};
const $c4fa088541c3ca24$export$909f8fb1bfc9b07 = (props)=>{
    const { issue: issue, assignee: assignee, parent: parent, issueParents: issueParents, onIssueChange: onIssueChange, shouldRenderRichCard: shouldRenderRichCard, projectIds: projectIds, isCMPBoard: isCMPBoard, estimate: estimateExtended, projectKey: projectKey } = props;
    const [isSummaryEditing, setIsSummaryEditing] = (0, $5uXOq.useState)(false);
    const [, { setIssue: setIssue }] = (0, $3fAi8.useFieldsValuesActions)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    // In the increment planning board, scenario issue keys do not yet have a numeric identifier as
    // they have not been created in Jira yet. In this case, the key is equal to the projectKey,
    // and thus not unique. Instead, we pass the issue id to the field config service (as it
    // requires a unique identifier for each issue).
    const key = isIncrementPlanningBoard && issue.key === projectKey ? `${issue.id}` : issue.key;
    const [issueFieldsValues] = (0, $3fAi8.useFieldsValues)(key);
    const [{ value: issueFieldConfig }] = (0, $54wEF.useIssueFieldConfigWithoutRefetch)(key);
    const [, { setIssueConfig: setIssueConfig }] = (0, $54wEF.useFieldConfigActions)();
    const canEditIssues = (0, $67sX6.useBoardSelector)((state)=>(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$5cd553a40d575c6c]);
    const timeTrackingOptions = (0, $67sX6.useBoardSelector)((0, $5mTgl.getTimeTrackingOptions));
    const inlineEditPlacement = isIncrementPlanningBoard && issue.columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID) ? 'top-end' : undefined;
    const renderSummary = (0, $5uXOq.useCallback)((renderSummaryProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $UJNvI.Summary), {
            issueId: issue.id,
            issueKey: key,
            onSizeChange: onIssueChange,
            isSummaryEditing: isSummaryEditing,
            setIsSummaryEditing: setIsSummaryEditing,
            shouldRenderRichField: shouldRenderRichCard,
            dialogPlacement: inlineEditPlacement,
            ...renderSummaryProps
        }), [
        issue.id,
        key,
        onIssueChange,
        isSummaryEditing,
        shouldRenderRichCard,
        inlineEditPlacement
    ]);
    const renderEstimateField = (0, $5uXOq.useCallback)(()=>{
        // when estimate feature is disabled
        if (!estimateExtended || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimateExtended.fieldId)) return null;
        if (estimateExtended.fieldId === (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fBeRa.OriginalEstimateField), {
            key: `card-estimate-${issue.estimate}`,
            issueId: issue.id,
            issueKey: issue.key,
            timeTrackingOptions: timeTrackingOptions,
            estimate: issue.estimate,
            shouldRenderRichField: shouldRenderRichCard
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Gmm7.StoryPointField), {
            key: `card-estimate-${issue.estimate}`,
            issueId: issue.id,
            issueKey: key,
            workType: issue.typeName,
            estimate: issue.estimate,
            storyPointFieldId: estimateExtended.fieldId,
            shouldRenderRichField: shouldRenderRichCard,
            dialogPlacement: inlineEditPlacement
        });
    }, [
        estimateExtended,
        issue.estimate,
        issue.id,
        issue.key,
        key,
        shouldRenderRichCard,
        timeTrackingOptions,
        inlineEditPlacement,
        issue.typeName
    ]);
    const renderIssueParentField = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hnyd8.IssueParentField), {
            issueId: issue.id,
            issueKey: issue.key,
            currentProjectId: issue.projectId,
            projectIds: projectIds,
            isCompanyManaged: isCMPBoard,
            isIncrementPlanningBoard: isIncrementPlanningBoard,
            parentSummary: parent?.summary || null,
            parentColor: parent?.color || null,
            issueParents: issueParents,
            shouldRenderRichField: shouldRenderRichCard,
            projectKey: projectKey,
            workType: issue.typeName
        }), [
        isCMPBoard,
        issue.id,
        issue.key,
        issue.projectId,
        issueParents,
        parent,
        projectIds,
        shouldRenderRichCard,
        isIncrementPlanningBoard,
        projectKey,
        issue.typeName
    ]);
    const renderAssignee = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5wBpE.AssigneeField), {
            issueKey: key,
            assignee: assignee,
            shouldRenderRichField: shouldRenderRichCard,
            isCMPBoard: isCMPBoard,
            issueId: isIncrementPlanningBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') ? issue.id : Number(issue.id)
        }), [
        key,
        assignee,
        shouldRenderRichCard,
        isCMPBoard,
        issue.id,
        isIncrementPlanningBoard
    ]);
    const renderPriorityField = (0, $5uXOq.useCallback)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.priority) && (0, $4R6GH.fg)('issue_cards_in_program_board')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $POab5.PriorityField), {
            issueKey: key,
            shouldRenderRichField: shouldRenderRichCard,
            priority: issue.priority,
            issueId: issue.id,
            projectId: issue?.projectId
        });
    }, [
        key,
        issue.id,
        issue.priority,
        issue.projectId,
        shouldRenderRichCard
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRenderRichCard && !issueFieldsValues) setIssue(key, (0, $aLb7D.transformToIssueFieldValues)({
            issue: issue,
            assignee: assignee,
            parent: parent,
            estimateExtended: estimateExtended
        }));
    }, [
        shouldRenderRichCard,
        issueFieldsValues,
        issue.key,
        setIssue,
        parent,
        issue,
        assignee,
        timeTrackingOptions,
        estimateExtended,
        key
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRenderRichCard && !issueFieldConfig) setIssueConfig(key, (0, $aLb7D.transformToIssueFieldConfigValues)({
            issue: issue,
            estimateExtended: estimateExtended,
            isEditable: canEditIssues
        }));
    }, [
        canEditIssues,
        estimateExtended,
        issue,
        issueFieldConfig,
        parent,
        setIssueConfig,
        shouldRenderRichCard,
        key,
        issueFieldsValues
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            issueId: props.issue.id
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4fa088541c3ca24$export$2ad76717ee8b873f, {
        ...props,
        ...!isCMPBoard && {
            renderSummary: renderSummary,
            userCanViewMenu: props.userCanViewMenu,
            isSummaryEditing: isSummaryEditing
        },
        renderIssueParentField: isCMPBoard ? undefined : renderIssueParentField,
        renderAssignee: renderAssignee,
        ...!isCMPBoard && {
            renderEstimateField: renderEstimateField
        },
        isDragDisabled: props.isDragDisabled || isSummaryEditing,
        renderPriorityField: renderPriorityField
    }));
};
const $c4fa088541c3ca24$export$9f96343954949053 = (props)=>{
    const { issue: issue, ...rest } = props;
    if (issue !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4fa088541c3ca24$export$909f8fb1bfc9b07, {
        ...rest,
        issue: issue
    });
    return null;
};
const $c4fa088541c3ca24$var$Card = (props)=>{
    const { issue: issue, ...rest } = props;
    if (issue !== null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c4fa088541c3ca24$export$2ad76717ee8b873f, {
        ...rest,
        issue: issue
    });
    return null;
};
var $c4fa088541c3ca24$export$2e2bcd8739ae039 = $c4fa088541c3ca24$var$Card;

});
parcelRegister("54wEF", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfig", () => $a5085d8f4019d625$export$5406c21e0d275680);
$parcel$export(module.exports, "useIssueFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$217a0e2f2962f4ae);
$parcel$export(module.exports, "useIssueFieldConfigWithoutUimOverrides", () => $a5085d8f4019d625$export$5f641a998c6dfa06);
$parcel$export(module.exports, "useFieldConfig", () => $a5085d8f4019d625$export$70da50df1be2dbe1);
$parcel$export(module.exports, "useFieldConfigWithoutRefetch", () => $a5085d8f4019d625$export$1eed575f8f3334eb);
$parcel$export(module.exports, "useFieldConfigActions", () => $a5085d8f4019d625$export$28a22fd0dedf31b7);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");

var $iZIvy = parcelRequire("iZIvy");

var $eDXka = parcelRequire("eDXka");

var $gXz4p = parcelRequire("gXz4p");

var $biQrn = parcelRequire("biQrn");

var $2N3tQ = parcelRequire("2N3tQ");
const $a5085d8f4019d625$export$9715ac6597e498fd = ()=>`
  query fieldConfigurationQuery($issueKey: String) {
    issue(issueIdOrKey: $issueKey, latestVersion: true, screen: "view") {
      fields {
        key
        schema {
          type
          custom
          customId
          system
          renderer
        }
        autoCompleteUrl
        allowedValues
        operations
        required
        editable
        title
        description
      }
    }
  }`;
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription = ({ wasExperienceSuccessful: wasExperienceSuccessful, errorMessage: errorMessage, traceId: traceId })=>{
    const errorMessageItem = errorMessage != null ? {
        errorMessage: errorMessage
    } : {};
    const traceIdItem = traceId != null ? {
        traceId: traceId
    } : {};
    return {
        experience: (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION,
        wasExperienceSuccesful: wasExperienceSuccessful,
        analyticsSource: 'Issue View Field Configuration Query',
        additionalAttributes: {
            method: 'GET',
            ...errorMessageItem,
            ...traceIdItem
        },
        application: null,
        edition: null
    };
};
const $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking = ({ wasExperienceSuccessful: wasExperienceSuccessful, error: error })=>{
    (0, $gXz4p.sendExperienceAnalytics)($a5085d8f4019d625$var$fieldConfigurationQueryExperienceDescription({
        wasExperienceSuccessful: wasExperienceSuccessful,
        ...error?.message != null ? {
            errorMessage: error.message
        } : {},
        ...error instanceof (0, $jJZqs.default) && error.traceId != null ? {
            traceId: error.traceId
        } : {}
    }));
};
const $a5085d8f4019d625$var$fetchData = async (issueKey)=>{
    try {
        const response = await (0, $eusud.performPostRequest)((0, $iZIvy.getGraphQlUrl)('', (0, $eDXka.IssueViewFetchOperations).FIELD_CONFIGURATION), {
            body: JSON.stringify({
                query: $a5085d8f4019d625$export$9715ac6597e498fd(),
                variables: {
                    issueKey: issueKey
                }
            })
        });
        if (response?.data?.issue?.fields) {
            const fieldConfigData = response.data.issue.fields.reduce(// @ts-expect-error - TS7006 - Parameter 'result' implicitly has an 'any' type. | TS7006 - Parameter 'field' implicitly has an 'any' type.
            (result, field)=>({
                    // eslint-disable-next-line jira/js/no-reduce-accumulator-spread
                    ...result,
                    [field.key]: {
                        autoCompleteUrl: field.autoCompleteUrl,
                        allowedValues: field.allowedValues,
                        isEditable: field.editable,
                        isRequired: field.required,
                        schema: field.schema,
                        title: field.title,
                        ...field.description ? {
                            description: field.description
                        } : {}
                    }
                }), {});
            $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
                wasExperienceSuccessful: true
            });
            return fieldConfigData;
        }
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: new Error('Unexpected field configuration response')
        });
        return null;
    } catch (error) {
        $a5085d8f4019d625$var$fieldConfigurationQueryExperienceTracking({
            wasExperienceSuccessful: false,
            error: error instanceof (0, $jJZqs.default) ? error : undefined
        });
        return null;
    }
};
const $a5085d8f4019d625$var$requestSet = new Set();
const $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions = {
    skipRefresh: false
};
const $a5085d8f4019d625$var$useIssueFieldConfigRefetch = (issueKey, value, { skipRefresh: skipRefresh } = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const isMounted = (0, $biQrn.useIsMounted)();
    const [, { setIssueConfig: setIssueConfig }] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const [loading, setLoading] = (0, $5uXOq.useState)(()=>!skipRefresh && value === undefined && !$a5085d8f4019d625$var$requestSet.has(issueKey));
    const getData = (0, $5uXOq.useCallback)(async ()=>{
        setLoading(true);
        $a5085d8f4019d625$var$requestSet.add(issueKey);
        const result = await $a5085d8f4019d625$var$fetchData(issueKey);
        setIssueConfig(issueKey, result);
        $a5085d8f4019d625$var$requestSet.delete(issueKey);
        if (isMounted.current) setLoading(false);
    }, [
        isMounted,
        issueKey,
        setIssueConfig
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const shouldGetData = (0, $4R6GH.fg)('jiv-19312-fix-fieldconfigurationquery-refetch') ? !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined && issueKey !== '' : !skipRefresh && !$a5085d8f4019d625$var$requestSet.has(issueKey) && value === undefined;
        if (shouldGetData) getData();
    }, [
        issueKey,
        value,
        getData,
        skipRefresh
    ]);
    return [
        {
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [overrides] = (0, $2N3tQ.useIssueOverridesStore)({
        issueKey: issueKey
    });
    return (0, $5uXOq.useMemo)(()=>{
        if (// When fields configurations are not valid, we don't want overrides
        !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
        overrides !== undefined) {
            // Iteration over the base fields (`value`) prevents creation of partial configs with just UIM overrides.
            const issueWithOverrides = Object.entries(value).reduce((acc, [fieldKey, fieldValues])=>{
                acc[fieldKey] = {
                    ...fieldValues,
                    ...overrides[fieldKey]
                };
                return acc;
            }, {});
            return [
                issueWithOverrides
            ];
        }
        return [
            value
        ];
    }, [
        value,
        overrides
    ]);
};
const $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides = ({ issueKey: issueKey, fieldKey: fieldKey })=>{
    const [value] = (0, $2N3tQ.useFieldConfigStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [overrides] = (0, $2N3tQ.useFieldOverridesStore)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    if (// When fields configurations are not valid, we don't want overrides
    !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(value) && // We should not override if UI modifications is not available in general or for the field
    overrides !== undefined) return [
        {
            ...value,
            ...overrides
        }
    ];
    return [
        value
    ];
};
const $a5085d8f4019d625$export$5406c21e0d275680 = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$217a0e2f2962f4ae = (issueKey)=>{
    const [value] = $a5085d8f4019d625$var$useIssueFieldConfigStoreWithUimOverrides({
        issueKey: issueKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$5f641a998c6dfa06 = ({ issueKey: issueKey })=>{
    const [value] = (0, $2N3tQ.useIssueFieldConfigStore)({
        issueKey: issueKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$70da50df1be2dbe1 = (issueKey, fieldKey, options = $a5085d8f4019d625$var$issueFieldConfigServiceDefaultOptions)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const [{ loading: loading }] = $a5085d8f4019d625$var$useIssueFieldConfigRefetch(issueKey, value, options);
    return [
        {
            value: value,
            loading: loading
        }
    ];
};
const $a5085d8f4019d625$export$1eed575f8f3334eb = (issueKey, fieldKey)=>{
    const [value] = $a5085d8f4019d625$var$useFieldConfigStoreWithUimOverrides({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    return [
        {
            value: value
        }
    ];
};
const $a5085d8f4019d625$export$28a22fd0dedf31b7 = ()=>{
    const [, setIssueConfigActions] = (0, $2N3tQ.useFieldConfigStoreActions)();
    const actions = (0, $5uXOq.useMemo)(()=>{
        const setIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.setIssueConfig(issueKey, issueConfig);
        const setIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.setIssuesConfig(issuesWithConfigurations);
        const mergeIssueConfig = (issueKey, issueConfig)=>setIssueConfigActions.mergeIssueConfig(issueKey, issueConfig);
        const mergeIssuesConfig = (issuesWithConfigurations)=>setIssueConfigActions.mergeIssuesConfig(issuesWithConfigurations);
        const setFieldConfigValue = (issueKey, fieldKey, fieldConfigValue)=>setIssueConfigActions.setFieldConfigValue(issueKey, fieldKey, fieldConfigValue);
        return {
            setIssueConfig: setIssueConfig,
            setIssuesConfig: setIssuesConfig,
            mergeIssueConfig: mergeIssueConfig,
            mergeIssuesConfig: mergeIssuesConfig,
            setFieldConfigValue: setFieldConfigValue
        };
    }, [
        setIssueConfigActions
    ]);
    return [
        null,
        actions
    ];
};

});
parcelRegister("iZIvy", function(module, exports) {

$parcel$export(module.exports, "getGraphQlUrl", () => $ef2130f553e5234b$export$5647e6bbf2b3526f);
$parcel$export(module.exports, "getFieldDataOptions", () => $ef2130f553e5234b$export$f2fec0cacdfabaaf);

var $96nmc = parcelRequire("96nmc");

var $chLKn = parcelRequire("chLKn");

const $ef2130f553e5234b$export$5647e6bbf2b3526f = (baseUrl, operation)=>`${baseUrl}/rest/graphql/1/${(0, $96nmc.appendOperationQuery)(operation)}`;
const $ef2130f553e5234b$export$f2fec0cacdfabaaf = (issueKey, projectKey)=>({
        method: 'POST',
        body: JSON.stringify({
            query: (0, $chLKn.default)(issueKey, projectKey)
        })
    });

});
parcelRegister("96nmc", function(module, exports) {

$parcel$export(module.exports, "appendOperationQuery", () => $8119dcf59ebfcad5$export$69694c3add0f6058);
const $8119dcf59ebfcad5$export$69694c3add0f6058 = (operation)=>operation ? `?operation=${operation}` : '';

});

parcelRegister("chLKn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c7dcb170a6dfaf0$export$2e2bcd8739ae039);
const $2c7dcb170a6dfaf0$export$ecc155df19ba52ff = (literals, ...substitutions)=>{
    let result = '';
    // run the loop only for the substitution count
    substitutions.forEach((key, i)=>{
        result += literals[i];
        result += key.toString();
    });
    // add the last literal
    result += literals[literals.length - 1];
    return result;
};
const $2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery = ()=>`
    isHybridAgilityProject
    `;
const $2c7dcb170a6dfaf0$var$getEnvironmentQuery = ()=>`environmentAdf {
        value
    }`;
const $2c7dcb170a6dfaf0$var$getAgileQuery = ()=>`
    agile {
        epic {
          key
        },
    }`;
const $2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration = ()=>`configuration {
        key
        value
    }
    `;
const $2c7dcb170a6dfaf0$var$getProjectQuery = (projectKey)=>`
        project(projectIdOrKey: "${projectKey}") {
            id
            name
            key
            projectTypeKey
            simplified
            avatarUrls {
                key
                value
            }
            archived
            deleted
        }`;
var // Disable this eslint rule temporarily so we can query for configuration
// eslint-disable-next-line jira/import/no-anonymous-default-export
$2c7dcb170a6dfaf0$export$2e2bcd8739ae039 = (issueKey, projectKey)=>$2c7dcb170a6dfaf0$export$ecc155df19ba52ff`query issueDataQuery {
        issue(issueIdOrKey: "${issueKey}", latestVersion: true, screen: "view") {
            id
            viewScreenId
            fields {
                key
                title
                editable
                required
                autoCompleteUrl
                allowedValues
                content
                renderedContent
                schema {
                    custom
                    system
                    ${$2c7dcb170a6dfaf0$var$getCustomFieldSchemaConfiguration()}
                    items
                    type
                    renderer
                }
                configuration
            }
            expandAssigneeInSubtasks
            expandAssigneeInIssuelinks
            expandTimeTrackingInSubtasks
            systemFields {
                descriptionAdf {
                    value
                }
                ${$2c7dcb170a6dfaf0$var$getEnvironmentQuery()}
            }
            customFields {
                textareaAdf {
                    key
                    value
                }
            }
            ${$2c7dcb170a6dfaf0$var$getIsHybridAgilityProjectQuery()}
            ${$2c7dcb170a6dfaf0$var$getAgileQuery()}
        }
        ${$2c7dcb170a6dfaf0$var$getProjectQuery(projectKey)}
    }`;

});


parcelRegister("eDXka", function(module, exports) {

$parcel$export(module.exports, "TIMESTAMP_DISPLAY_SETTING", () => $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55);
$parcel$export(module.exports, "CHILD_ISSUES_LIMIT_BEST_PRACTICE_FLAG_DISMISSED", () => $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df);
$parcel$export(module.exports, "IssueViewFetchOperations", () => $9f0f96bc04f1e77a$export$b38f30d67f730bc4);
const $9f0f96bc04f1e77a$export$9f4ee8e6dc9a0a55 = 'jira.user.issue.details.timestamp-display-setting';
const $9f0f96bc04f1e77a$export$e7d75f9d93dfa3df = 'jira.user.issue.child-issues-limit.best-practice-flag.dismissed';
const $9f0f96bc04f1e77a$export$b38f30d67f730bc4 = {
    EARLY_FETCH_GRAPHQL: 'earlyFetchIssueDataQuery',
    INITIAL_GRAPHQL: 'issueDataQuery',
    EARLY_FETCH_GIRA: 'earlyFetchIssueViewInteractiveQuery',
    INITIAL_GIRA: 'issueViewInteractiveQuery',
    EARLY_FETCH_AGG: 'earlyFetchMainIssueAggQuery',
    INITIAL_AGG: 'mainIssueAggQuery',
    EARLY_FETCH_NON_CRITICAL_GIRA: 'earlyFetchIssueViewNonCriticalGiraQuery',
    NON_CRITICAL_GIRA: 'issueViewNonCriticalGiraQuery',
    VIEW_SCREEN_ID: 'viewScreenIdQuery',
    FIELD_CONFIGURATION: 'fieldConfigurationQuery',
    FIELD_DESCRIPTION: 'fieldDescriptionQuery',
    ATTACHMENT: 'attachmentsQuery'
};

});

parcelRegister("gXz4p", function(module, exports) {

$parcel$export(module.exports, "sendExperienceAnalytics", () => $b28eb6b892a8c2f7$export$4a95ada1b8228562);

var $1UikQ = parcelRequire("1UikQ");

var $gSA3s = parcelRequire("gSA3s");

var $hh0bW = parcelRequire("hh0bW");

var $j8DrX = parcelRequire("j8DrX");

var $4R6GH = parcelRequire("4R6GH");
const $b28eb6b892a8c2f7$var$isSynthetic = ()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true';
const $b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute = (experienceDescription)=>{
    // Return false if feature flag is off
    if (!(0, $4R6GH.fg)('thor_refine_taskfail_offline_failed_events')) return false;
    // Return false if not a taskFail action
    if (experienceDescription.wasExperienceSuccesful) return false;
    const isKnownExperience = [
        'transitionIssue',
        'getTransitions',
        'startWatching',
        'stopWatching'
    ].includes(experienceDescription.experience);
    // Return false if not a known experience
    if (!isKnownExperience) return false;
    const hasStatusCode = !!experienceDescription.additionalAttributes?.statusCode;
    // Return false if status code is present
    return !hasStatusCode;
};
function $b28eb6b892a8c2f7$export$4a95ada1b8228562(experienceDescription) {
    const additionalContext = {};
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    Object.assign(additionalContext, {
        shard: shard,
        region: region
    });
    const enabledFeatureFlags = Object.fromEntries([
        ...(0, $gSA3s.allFeatureFlagsAccessed)
    ].filter(([, value])=>value));
    Object.assign(additionalContext, {
        enabledFeatureFlags: enabledFeatureFlags
    });
    if ($b28eb6b892a8c2f7$var$shouldAddConnectivityAttribute(experienceDescription)) {
        const isOnline = typeof globalThis.window !== 'undefined' && globalThis.window?.navigator?.onLine;
        Object.assign(additionalContext, {
            isOnline: isOnline
        });
    }
    const synthetics = {
        additionalAttributes: {
            synthetic: $b28eb6b892a8c2f7$var$isSynthetic(),
            ...additionalContext
        }
    };
    (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))(experienceDescription, synthetics);
    (0, $hh0bW.default)(experienceDescription);
}

});

parcelRegister("biQrn", function(module, exports) {

$parcel$export(module.exports, "useIsMounted", () => $c6adaed2787020bf$export$80c2a3957bcb42ea);

var $5uXOq = parcelRequire("5uXOq");
const $c6adaed2787020bf$export$80c2a3957bcb42ea = ()=>{
    const isMounted = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
        };
    }, [
        isMounted
    ]);
    return isMounted;
};

});

parcelRegister("2N3tQ", function(module, exports) {

$parcel$export(module.exports, "useIssueFieldConfigStore", () => $0471f3f4df57179c$export$52f51db4e2b3da57);
$parcel$export(module.exports, "useFieldConfigStore", () => $0471f3f4df57179c$export$f9beb98c7488fd61);
$parcel$export(module.exports, "useFieldConfigStoreActions", () => $0471f3f4df57179c$export$314199caf05d245);
$parcel$export(module.exports, "useIssueOverridesStore", () => $0471f3f4df57179c$export$ff357cf5a96ec0c6);
$parcel$export(module.exports, "useFieldOverridesStore", () => $0471f3f4df57179c$export$6e41e9c34587d557);
$parcel$export(module.exports, "useFieldOverridesStoreWithLabel", () => $0471f3f4df57179c$export$e704d739927bd1d6);
$parcel$export(module.exports, "useOverridesStoreActions", () => $0471f3f4df57179c$export$d94ae842140da412);
$parcel$export(module.exports, "useFieldOptionsOverrides", () => $0471f3f4df57179c$export$bfea9bb9bad7bc8f);
$parcel$export(module.exports, "useIsFieldBusy", () => $0471f3f4df57179c$export$982ff1008c2e2780);
/* eslint-disable jira/js/no-reduce-accumulator-spread */ 
var $dGvGJ = parcelRequire("dGvGJ");

var $1UikQ = parcelRequire("1UikQ");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $0471f3f4df57179c$var$setIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState })=>{
        // @ts-expect-error - TS2345 - Argument of type '{ [x: string]: IssueConfiguration | null; }' is not assignable to parameter of type 'Partial<Partial<Record<string, IssueConfiguration>>>'.
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: issueConfiguration
        });
    };
const $0471f3f4df57179c$var$mergeIssueConfig = (issueKey, issueConfiguration)=>({ setState: setState, getState: getState })=>{
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: (0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState()[issueKey], issueConfiguration)
        });
    };
const $0471f3f4df57179c$var$setIssuesConfig = (issuesWithConfigurations)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const newIssues = issuesWithConfigurations.reduce((acc, issue)=>({
                ...acc,
                ...issue
            }), {});
        setState(newIssues);
    };
const $0471f3f4df57179c$var$mergeIssuesConfig = (issuesWithConfigurations)=>({ setState: setState, getState: getState })=>{
        if (issuesWithConfigurations.length === 0) return;
        const newIssues = {};
        issuesWithConfigurations.forEach((issue)=>{
            Object.assign(newIssues, issue);
        });
        setState((0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))({}, getState(), newIssues));
    };
const $0471f3f4df57179c$var$setFieldConfigValue = (issueKey, fieldKey, fieldConfiguration)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfiguration = getState()[issueKey];
        if (issueKeyFieldConfiguration && issueKeyFieldConfiguration[fieldKey]) setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...getState()[issueKey],
                [fieldKey]: {
                    ...getState()[issueKey][fieldKey],
                    ...fieldConfiguration
                }
            }
        });
    };
const $0471f3f4df57179c$var$actions = {
    setIssueConfig: $0471f3f4df57179c$var$setIssueConfig,
    setIssuesConfig: $0471f3f4df57179c$var$setIssuesConfig,
    mergeIssueConfig: $0471f3f4df57179c$var$mergeIssueConfig,
    mergeIssuesConfig: $0471f3f4df57179c$var$mergeIssuesConfig,
    setFieldConfigValue: $0471f3f4df57179c$var$setFieldConfigValue
};
// this is a global state
const $0471f3f4df57179c$var$store = (0, $iXqE5.createStore)({
    name: 'issue-field-config',
    initialState: {},
    actions: $0471f3f4df57179c$var$actions
});
const $0471f3f4df57179c$var$getIssueFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (issue)=>issue);
const $0471f3f4df57179c$export$52f51db4e2b3da57 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$var$getFieldConfig = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey] : null;
});
const $0471f3f4df57179c$var$getFieldConfigWithLabel = (0, $dGvGJ.createSelector)($0471f3f4df57179c$var$getFieldConfig, (fieldConfig)=>{
    if (fieldConfig?.title === undefined) return fieldConfig;
    return {
        ...fieldConfig,
        label: fieldConfig.title
    };
});
const $0471f3f4df57179c$var$getFieldOptionsOverrides = (0, $dGvGJ.createSelector)((state, props)=>state[props.issueKey], (state, props)=>props.fieldKey, (issue, fieldKey)=>{
    // issue being undefined means we haven't fetched it yet
    // issue being null means it doesn't exist.
    // either way we just return that value
    if (issue == null) return issue;
    // if we have the field key, return it. Otherwise return null to show
    // we have done a data fetch of the issue but the field doesn't exist
    return issue[fieldKey] ? issue[fieldKey].allowedValuesOverrides : null;
});
const $0471f3f4df57179c$export$f9beb98c7488fd61 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$314199caf05d245 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$store, {
    selector: null
});
const $0471f3f4df57179c$var$setOverrides = (issueKey, fieldKey, fieldConfigOverrides)=>({ setState: setState, getState: getState })=>{
        const issueKeyFieldConfigurationWithOverrides = getState()[issueKey] ?? {};
        setState({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            [issueKey]: {
                ...issueKeyFieldConfigurationWithOverrides,
                [fieldKey]: {
                    ...issueKeyFieldConfigurationWithOverrides[fieldKey],
                    ...fieldConfigOverrides
                }
            }
        });
    };
const $0471f3f4df57179c$var$resetOverridesStore = (issueKey)=>({ setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        setState({
            [issueKey]: undefined
        });
    };
const $0471f3f4df57179c$var$overridesActions = {
    setFieldConfigOverridesValue: $0471f3f4df57179c$var$setOverrides,
    resetOverridesStore: $0471f3f4df57179c$var$resetOverridesStore
};
// Store contains overrides to the field config. It is used by UI modifications to override field config properties by apps.
// UI modifications is a Forge extension point providing apps JS API to override field's properties: name, description, isEditable
// and limit visibility of select fields options.
const $0471f3f4df57179c$var$overridesStore = (0, $iXqE5.createStore)({
    name: 'issue-field-overrides',
    initialState: {},
    actions: $0471f3f4df57179c$var$overridesActions
});
const $0471f3f4df57179c$export$ff357cf5a96ec0c6 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIssueFieldConfig
});
const $0471f3f4df57179c$export$6e41e9c34587d557 = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfig
});
const $0471f3f4df57179c$export$e704d739927bd1d6 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldConfigWithLabel
});
const $0471f3f4df57179c$export$d94ae842140da412 = (0, $3sQ5x.createActionsHook)($0471f3f4df57179c$var$overridesStore);
const $0471f3f4df57179c$export$bfea9bb9bad7bc8f = (0, $3sQ5x.createHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getFieldOptionsOverrides
});
const $0471f3f4df57179c$var$getIsFieldBusySelector = (state, args)=>{
    const { fieldId: fieldId, issueKey: issueKey } = args;
    return fieldId !== undefined && !!state[issueKey]?.[fieldId]?.isBusy;
};
const $0471f3f4df57179c$export$982ff1008c2e2780 = (0, $3sQ5x.createStateHook)($0471f3f4df57179c$var$overridesStore, {
    selector: $0471f3f4df57179c$var$getIsFieldBusySelector
});

});


parcelRegister("58K4A", function(module, exports) {

$parcel$export(module.exports, "Card", () => $fc23183dae006f40$export$60332b2344f7fe41);
$parcel$export(module.exports, "CardDropIndicator", () => $fc23183dae006f40$export$5a1a2d64cf6af79f);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $b8gJu = parcelRequire("b8gJu");

var $fClFb = parcelRequire("fClFb");

var $3Lg0k = parcelRequire("3Lg0k");

var $gRpCe = parcelRequire("gRpCe");
const $fc23183dae006f40$export$60332b2344f7fe41 = ({ id: id, issue: issue, parent: parent, assignee: assignee, status: status, menu: menu, cover: cover, dateFormat: dateFormat, draggableIndex: draggableIndex, isDraggable: isDraggable, isDone: isDone = false, isSelected: isSelected = false, isLoading: isLoading = false, isFlagged: isFlagged = false, isFlexible: isFlexible = false, isPlaceholder: isPlaceholder = false, shouldShowParent: shouldShowParent = false, shouldShowRipple: shouldShowRipple = false, shouldRenderCardType: shouldRenderCardType = true, shouldFocus: shouldFocus = false, persistActions: persistActions = false, highlightTextOnCard: highlightTextOnCard = '', highlightLabelsOnCard: highlightLabelsOnCard = [], onClick: onClickProp, onEnterPress: onEnterPressProp, onMouseDown: onMouseDownProp, onMouseUp: onMouseUp = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onRippleEnd: onRippleEnd = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSizeChange: onSizeChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFocus: onFocusProp, onBlur: onBlur, renderEstimateField: renderEstimateField, renderIssueParentField: renderIssueParentField, renderSummary: renderSummary, renderAssignee: renderAssignee, renderIssueLinksIndicator: renderIssueLinksIndicator, CustomContextMenu: CustomContextMenu, renderCustomMenu: renderCustomMenu, isCMPBoard: isCMPBoard = false, isIPBoard: isIPBoard = false, selectedCardIds: selectedCardIds = [], cardRef: cardRefProp, CardPreview: CardPreview, hasCompactIssueType: hasCompactIssueType, isDroppableOnCard: isDroppableOnCard, renderIssueLinksStats: renderIssueLinksStats, showDaysInColumn: showDaysInColumn, showIssueKey: showIssueKey, showEstimate: showEstimate, showPriority: showPriority, showDevelopment: showDevelopment, showDueDate: showDueDate, showAssignee: showAssignee, showLabels: showLabels, showCardExtraFields: showCardExtraFields, boardType: boardType, renderStatusField: renderStatusField, renderPriorityField: renderPriorityField })=>{
    const cardContainerRef = (0, $5uXOq.useRef)(null);
    const internalCardRef = (0, $5uXOq.useRef)(null);
    const cardRef = cardRefProp || internalCardRef;
    const { dragPreview: dragPreview, closestEdge: closestEdge } = (0, $gRpCe.useDraggableCard)({
        isDraggable: isDraggable ?? true,
        elementRef: (0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements') ? cardContainerRef : cardRef,
        cardId: id,
        cardIndex: draggableIndex,
        columnId: issue.columnId,
        swimlaneId: issue.swimlaneId,
        CardPreview: CardPreview,
        shouldShowRipple: shouldShowRipple,
        isDroppable: isDroppableOnCard
    });
    (0, $5uXOq.useEffect)(()=>{
        // In a virtualised environment we can't guarantee that these components
        // will exist when we focus them. As a result, we need to fire the focus
        // function on mount for scenarios where we focus an off screen element
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (shouldFocus && cardRef.current !== null && document.activeElement !== cardRef.current) cardRef.current.focus();
    }, [
        cardRef,
        shouldFocus
    ]);
    let mouseDownTarget = null;
    const onClick = (0, $5uXOq.useCallback)((e, externalAction)=>{
        e.stopPropagation();
        // best practice to use for react-beautiful-dnd (https://github.com/atlassian/react-beautiful-dnd/blob/master/docs/guides/how-we-use-dom-events.md)
        if (e.defaultPrevented === true && e.currentTarget?.nodeName !== 'A') return;
        // Prevent (eg) mouse down on text-field within card, then mouse up on card firing onClick unexpectedly
        if (mouseDownTarget && e.target !== mouseDownTarget) return;
        const withCmd = e.ctrlKey || e.metaKey;
        const withShift = e.shiftKey;
        onClickProp?.(id, withCmd, withShift, externalAction);
    }, [
        id,
        mouseDownTarget,
        onClickProp
    ]);
    const onMouseDown = (e)=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getSelection()?.removeAllRanges();
        mouseDownTarget = e.target;
        onMouseDownProp?.();
    };
    const onKeyDown = (e)=>{
        if (e.key === 'Enter') {
            e.stopPropagation();
            onEnterPressProp?.(id);
        }
    };
    const onFocus = (0, $5uXOq.useCallback)((e)=>{
        // Ensure the focus event originated from the card container,
        // and didn't bubble up from an element within it
        if (!onFocusProp || cardRef.current === null || e.target !== cardRef.current) return;
        onFocusProp(e);
    }, [
        cardRef,
        onFocusProp
    ]);
    const cardProps = {
        id: id,
        issue: issue,
        shouldShowParent: shouldShowParent,
        parent: parent,
        assignee: assignee,
        isDone: isDone,
        isSelected: isSelected,
        isFlagged: isFlagged,
        isFlexible: isFlexible,
        shouldRenderCardType: shouldRenderCardType,
        highlightTextOnCard: highlightTextOnCard,
        highlightLabelsOnCard: highlightLabelsOnCard,
        menu: menu,
        cover: cover,
        dateFormat: dateFormat,
        isLoading: isLoading,
        onClick: onClick,
        onFocus: onFocus,
        onBlur: onBlur,
        cardRef: cardRef,
        ...(0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements') && {
            cardContainerRef: cardContainerRef
        },
        onSizeChange: onSizeChange,
        isPlaceholder: isPlaceholder,
        renderEstimateField: renderEstimateField,
        renderIssueParentField: renderIssueParentField,
        renderSummary: renderSummary,
        renderIssueLinksIndicator: renderIssueLinksIndicator,
        renderAssignee: renderAssignee,
        isCMPBoard: isCMPBoard,
        isIPBoard: isIPBoard,
        CustomContextMenu: CustomContextMenu,
        renderCustomMenu: renderCustomMenu,
        selectedCardIds: selectedCardIds,
        status: status,
        hasCompactIssueType: hasCompactIssueType,
        renderIssueLinksStats: renderIssueLinksStats,
        persistActions: persistActions,
        showDaysInColumn: showDaysInColumn,
        showIssueKey: showIssueKey,
        showEstimate: showEstimate,
        showPriority: showPriority,
        showDevelopment: showDevelopment,
        showDueDate: showDueDate,
        showAssignee: showAssignee,
        showLabels: showLabels,
        showCardExtraFields: showCardExtraFields,
        boardType: boardType,
        ...isIPBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') && {
            renderStatusField: renderStatusField,
            renderPriorityField: renderPriorityField
        }
    };
    // @ts-expect-error - Type '{ onSizeChange: () => void; isPlaceholder: boolean; renderEstimateField: (() => ReactNode) | undefined; renderIssueParentField: (() => ReactNode) | undefined; renderSummary: RenderSummary | undefined; ... 42 more ...; key: string; }' is not assignable to type 'Pick<Pick<Omit<{ ref?: unknown; }, "intl">, "ref"> & InexactPartial<Pick<Omit<{ ref?: unknown; }, "intl">, never>> & InexactPartial<Pick<{ isDragging: boolean; isLoading: boolean; ... 41 more ...; shouldShowLozengeForOptimisticParent: boolean; }, "status" | ... 42 more ... | "shouldShowLozengeForOptimisticParent">> ...'.
    const jiraCardContents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fClFb.default), {
        key: `card-${issue.key}-card`,
        ...cardProps
    });
    if (!isDraggable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc23183dae006f40$var$CardContainer, {
        id: `card-${issue.key}`,
        key: `card-${issue.key}-container`,
        "data-testid": "platform-board-kit.ui.card.card",
        "aria-describedby": `card-description-${issue.key}`,
        optimistic: false
    }, jiraCardContents);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc23183dae006f40$var$CardContainer, {
        id: `card-${issue.key}`,
        key: `card-${issue.key}-container`,
        "data-component-selector": (0, $b8gJu.CARD_CONTAINER_SELECTOR_NAME),
        optimistic: false,
        isProcessing: false,
        "data-testid": "platform-board-kit.ui.card.card",
        onClick: onClick,
        onMouseDown: onMouseDown,
        onMouseUp: onMouseUp,
        onKeyDown: onKeyDown,
        "aria-describedby": `card-description-${issue.key}`,
        tabIndex: -1
    }, shouldShowRipple ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Lg0k.default), {
        onAnimationEnd: onRippleEnd
    }, jiraCardContents) : jiraCardContents, closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc23183dae006f40$export$5a1a2d64cf6af79f, {
        edge: closestEdge
    }), dragPreview);
};
const $fc23183dae006f40$export$5a1a2d64cf6af79f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1e0c1txw _1bah1y6m _1ltvidpf _1xi2idpf _4t3iyh40 _1pbycs5v _bfhkbku0 _lcxvglyw _rfx31ssb _3l88yh40 _kzdanqa1 _15m613er _1cs8stnw _1kt9b3bt _cfu11txw _6w5g1h6o _kfgt1y44 _1mp41y44 _qnecx0bf",
            __cmplp.edge === 'bottom' && "_94n5j39m",
            __cmplp.edge === 'top' && "_154ij39m",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc23183dae006f40$var$CardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { optimistic: optimistic, isProcessing: isProcessing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _2hwxidpf _otyrv77o _18u0idpf",
            __cmplp.optimistic && "_19pkidpf",
            __cmplp.isProcessing ? "_1e0cglyw" : "_1e0c1ule",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fClFb", function(module, exports) {

$parcel$export(module.exports, "default", () => $1573e5e4e2e6fae4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $gccSB = parcelRequire("gccSB");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $8U6zd = parcelRequire("8U6zd");

var $3oUqw = parcelRequire("3oUqw");

var $3bDjY = parcelRequire("3bDjY");

var $gULOk = parcelRequire("gULOk");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $fQeLt = parcelRequire("fQeLt");

var $9JGeS = parcelRequire("9JGeS");

var $hOvWQ = parcelRequire("hOvWQ");

var $cfZh8 = parcelRequire("cfZh8");

var $f5Alb = parcelRequire("f5Alb");

var $itzcE = parcelRequire("itzcE");

var $akGDz = parcelRequire("akGDz");

var $dHqFt = parcelRequire("dHqFt");

var $l1jvZ = parcelRequire("l1jvZ");

var $20vaL = parcelRequire("20vaL");

var $9yMbF = parcelRequire("9yMbF");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");


var $b8gJu = parcelRequire("b8gJu");

var $gjUWL = parcelRequire("gjUWL");
const $1573e5e4e2e6fae4$var$DropdownMenuWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('dropdown-menu', {
    onOpenChange: 'openChanged'
})((0, $BLPHT.default)); // eslint-disable-next-line jira/react/no-class-components
class $1573e5e4e2e6fae4$var$JiraCardContents extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            isDragging: false,
            isLoading: false,
            isDone: false,
            isSelected: false,
            isFlagged: false,
            isFlexible: false,
            isDisabled: false,
            hasTransitioned: false,
            shouldShowParent: false,
            shouldRenderCardType: true,
            persistActions: false,
            parent: null,
            assignee: null,
            highlightTextOnCard: '',
            highlightLabelsOnCard: [],
            labels: null,
            menu: null,
            selectedCardIds: [],
            CustomContextMenu: null,
            renderCustomMenu: null,
            cover: null,
            color: null,
            customFields: null,
            children: null,
            dateFormat: null,
            renderIssueParentField: null,
            renderSummary: null,
            renderIssueLinksIndicator: null,
            renderAssignee: null,
            renderEstimate: null,
            isCMPBoard: false,
            status: null,
            onSizeChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onEnterPress: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            showDaysInColumn: true,
            showDueDate: true,
            showIssueKey: true,
            showEstimate: true,
            showPriority: true,
            showDevelopment: true,
            showAssignee: true,
            showLabels: true,
            showCardExtraFields: null,
            shouldShowLozengeForOptimisticParent: false,
            renderStatusField: null,
            renderPriorityField: null
        };
    }
    componentDidMount() {
        if (false) return;
        this.mounted = true; // Note whenever we drag or modify a list we'll fire this. The plus side of having it here is
        // when we render a proper card instead of the scrolling placeholder we'll store the real height in the
        // cache for our future placeholders
        (this.props.onSizeChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))))();
    }
    componentDidUpdate() {
        if (false) return;
        if (this.getShouldRenderMenuState() && this.state.shouldRenderMenu === false) this.setShouldRenderMenu();
         // Notify listeners of any update to this component. The CellCacheMeasurer remeasure
        // is faster than doing a deepEquals here.
        // NOTE: This actually gets procced via onFocus for unrelated cards due to some re-render shinanigans.
        this.notifyListenersOfSizeChange();
    }
    componentWillUnmount() {
        this.mounted = false;
        if (this.requestAnimationFrameId != null) cancelAnimationFrame(this.requestAnimationFrameId);
    }
    notifyListenersOfSizeChange() {
        (this.props.onSizeChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))))();
    }
    getShouldRenderMenuState() {
        return !!(this.props.boardType === (0, $b8gJu.BoardView).JSW_BOARD && this.props.persistActions && (0, $4R6GH.fg)('jsw_cmp_card_covers_changeboarding'));
    }
    renderDevStatus() {
        const { issue: { id: id, devStatusField: devStatusField }, showDevelopment: showDevelopment } = this.props;
        if (!showDevelopment) return null;
        return devStatusField ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5Alb.default), {
            issueId: id,
            key: `dev-status-${devStatusField.activity}-${devStatusField.count}`,
            type: devStatusField.activity,
            deploymentDetails: devStatusField.deploymentDetails
        }) : null;
    }
    renderIssueParent() {
        const { shouldShowParent: shouldShowParent, parent: parent, renderIssueParentField: renderIssueParentField } = this.props;
        if (!shouldShowParent || !parent) return null;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(renderIssueParentField)) return renderIssueParentField();
        return(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            tag: $1573e5e4e2e6fae4$var$TooltipContainer,
            content: parent.summary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1jvZ.CardLozenge), {
            color: parent.color
        }, parent.summary)));
    }
    renderChildIssuesMetadata() {
        const { issue: { numCompleteChildren: numCompleteChildren, numTotalChildren: numTotalChildren } } = this.props;
        if (numTotalChildren == null || numTotalChildren === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9JGeS.CardChildIssues), {
            key: `card-children-${numCompleteChildren}-${numTotalChildren}`,
            complete: numCompleteChildren,
            total: numTotalChildren
        });
    }
    renderLabels() {
        const { issue: { labels: labels }, highlightLabelsOnCard: highlightLabelsOnCard, isCMPBoard: isCMPBoard, showLabels: showLabels } = this.props;
        const shouldShowLabels = showLabels && !isCMPBoard;
        return labels && shouldShowLabels && !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(labels) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dHqFt.CardLabels), {
            labels: labels,
            highlight: highlightLabelsOnCard,
            isCMPBoard: isCMPBoard
        });
    }
    renderEstimate() {
        const { issue: { estimate: estimate, estimateUnit: estimateUnit }, showEstimate: showEstimate } = this.props;
        if (!showEstimate) return null;
        const { renderEstimateField: renderEstimateField } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(renderEstimateField)) return renderEstimateField();
        if (estimate == null) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $akGDz.CardEstimate), {
            key: `card-estimate-${estimate}`,
            estimate: estimate,
            units: estimateUnit ?? (0, $gjUWL.default).storyPointsUnitsPluralisedLabel
        });
    }
    renderPriority() {
        const { issue: { priority: priority }, showPriority: showPriority, renderPriorityField: renderPriorityField } = this.props;
        if (!showPriority) return null;
        if (priority && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(renderPriorityField) && (0, $4R6GH.fg)('issue_cards_in_program_board')) return renderPriorityField();
        return priority && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $20vaL.CardPriority), {
            key: `card-priority-${priority.name}`,
            name: priority.name,
            uri: priority.iconUrl
        });
    }
    renderDueDate() {
        const { issue: issue, isDone: isDone, dateFormat: dateFormat, showDueDate: showDueDate } = this.props;
        return showDueDate && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.dueDate) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $itzcE.CardDueDate), {
            dateFormat: dateFormat,
            dueDate: issue.dueDate,
            isCompleted: isDone
        }) : null;
    }
    renderDaysInColumn() {
        const { issue: { id: id, daysInColumn: daysInColumn }, showDaysInColumn: showDaysInColumn } = this.props;
        return daysInColumn != null && daysInColumn > 1 && Boolean(showDaysInColumn) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cfZh8.CardDaysInColumn), {
            ...(0, $4R6GH.fg)('concurrent-rendering-fix-unique-list-key') ? {
                key: `days-in-column-${id}`
            } : {},
            days: daysInColumn
        }) : null;
    }
    renderIcons() {
        const { boardType: boardType, renderIssueLinksIndicator: renderIssueLinksIndicator } = this.props;
        const isIPBoard = boardType === (0, $b8gJu.BoardView).INCREMENT_PLANNING_BOARD;
        if (isIPBoard) return [
            this.renderEstimate(),
            ...renderIssueLinksIndicator ? [
                renderIssueLinksIndicator()
            ] : [
                undefined
            ],
            (0, $4R6GH.fg)('issue_cards_in_program_board') && this.renderPriority()
        ];
        return [
            this.renderEstimate(),
            this.renderDevStatus(),
            this.renderChildIssuesMetadata(),
            this.renderDaysInColumn(),
            this.renderPriority()
        ];
    }
    renderStatus() {
        const { status: status, boardType: boardType, renderStatusField: renderStatusField } = this.props;
        const isIPBoard = boardType === (0, $b8gJu.BoardView).INCREMENT_PLANNING_BOARD;
        if (isIPBoard && (0, $4R6GH.fg)('issue_cards_in_program_board')) return renderStatusField?.() ?? null;
        if (!status) return null;
        const statusField = {
            id: status.id.toString(),
            name: status.name,
            statusCategory: {
                id: (0, $gULOk.categoryIdForStatusCategory)(status.category)
            }
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1573e5e4e2e6fae4$var$StatusContainer, {
            "data-testid": "platform-board-kit.ui.card.jira-card-contents.status"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            tag: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            $1573e5e4e2e6fae4$var$TooltipContainer,
            content: statusField.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: statusField
        })));
    }
    render() {
        const { issue: issue, assignee: assignee, isSelected: isSelected, isDragging: isDragging, isFlagged: isFlagged, isFlexible: isFlexible, menu: menu, highlightTextOnCard: highlightTextOnCard, shouldRenderCardType: shouldRenderCardType, cover: cover, isDone: isDone, isLoading: isLoading, onBlur: onBlur, cardRef: cardRef, cardContainerRef: cardContainerRef, onSizeChange: onSizeChange, onClick: onClick, isDisabled: isDisabled, children: children, renderSummary: renderSummary, renderAssignee: renderAssignee, isCMPBoard: isCMPBoard, status: status, hasCompactIssueType: hasCompactIssueType, selectedCardIds: selectedCardIds, CustomContextMenu: CustomContextMenu, renderIssueLinksStats: renderIssueLinksStats, persistActions: persistActions, showIssueKey: showIssueKey, showCardExtraFields: showCardExtraFields, showAssignee: showAssignee } = this.props;
        const isIPBoard = this.props.boardType === (0, $b8gJu.BoardView).INCREMENT_PLANNING_BOARD;
        const { shouldRenderMenu: shouldRenderMenu, isMenuOpen: isMenuOpen } = this.state;
        const onContextMenuChange = (isContextMenuOpen)=>this.setState({
                shouldMenuOpen: !isContextMenuOpen
            });
        const typeUrl = issue.typeUrl !== undefined ? issue.typeUrl : null;
        const contextMenu = shouldRenderMenu ? menu : null;
        const dropdownMenu = shouldRenderMenu ? this.renderMenu() : null;
        const cardContents = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yMbF.Card), {
            id: issue.id,
            summary: issue.summary,
            cardKey: showIssueKey ? issue.key : null,
            typeName: shouldRenderCardType ? issue.typeName : null,
            typeUri: shouldRenderCardType ? typeUrl : null,
            avatarUri: showAssignee ? assignee && assignee.avatarUrl : null,
            avatarName: showAssignee ? assignee && assignee.displayName : null,
            isSelected: isSelected || isDragging,
            isFlagged: isFlagged,
            isFlexible: isFlexible,
            isDone: isDone,
            actions: dropdownMenu,
            cover: cover,
            color: issue.cardColor,
            customFields: issue.customFields?.filter((field)=>showCardExtraFields?.[field.id] !== false),
            isLoading: isLoading,
            icons: this.renderIcons(),
            highlightText: highlightTextOnCard ? [
                highlightTextOnCard
            ] : undefined,
            onClick: onClick,
            onFocus: this.onFocus,
            onBlur: onBlur,
            onMouseEnter: this.setShouldRenderMenu,
            onSizeChange: onSizeChange,
            isDisabled: isDisabled,
            cardRef: cardRef,
            cardContainerRef: cardContainerRef,
            persistActions: persistActions || isMenuOpen,
            renderSummary: renderSummary,
            isCMPBoard: isCMPBoard,
            isIPBoard: isIPBoard,
            status: status,
            hasCompactIssueType: hasCompactIssueType,
            hasScenarioChanges: issue.hasScenarioChanges,
            renderIssueLinksStats: renderIssueLinksStats,
            renderAssignee: showAssignee ? renderAssignee : undefined,
            fixVersions: issue.fixVersions
        }, this.renderIssueParent(), children, (0, $4R6GH.fg)('issue_cards_in_program_board') ? this.renderStatus() : status && this.renderStatus(), this.renderLabels(), !isIPBoard && this.renderDueDate());
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(CustomContextMenu)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomContextMenu, {
            appearance: (0, $d9cdb1c71f9dbf8c$export$bb79bd28759ee895),
            issueId: issue.id,
            issueKey: issue.key,
            selectedCardIds: selectedCardIds
        }, cardContents);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOvWQ.default), {
            items: contextMenu,
            onContextMenuChange: onContextMenuChange
        }, cardContents);
    }
    constructor(...args){
        super(...args), this.state = {
            shouldMenuOpen: true,
            shouldRenderMenu: this.getShouldRenderMenuState(),
            isMenuOpen: false
        }, this.mounted = false, this.requestAnimationFrameId = null, this.setShouldRenderMenu = ()=>{
            this.setState({
                shouldRenderMenu: true
            });
        }, this.onFocus = (event)=>{
            this.props.onFocus && this.props.onFocus(event);
            this.setShouldRenderMenu();
        }, this.renderMenu = ()=>{
            const { menu: menu, issue: { summary: summary }, intl: { formatMessage: formatMessage }, renderCustomMenu: renderCustomMenu } = this.props;
            const { shouldMenuOpen: shouldMenuOpen } = this.state;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(renderCustomMenu)) return renderCustomMenu();
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(menu) || !shouldMenuOpen) return null;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1573e5e4e2e6fae4$var$DropdownMenuWithAnalytics, {
                trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                        ...props,
                        ref: triggerRef,
                        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                            spacing: "spacious",
                            label: "Menu",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                            color: "var(--ds-icon, #44546F)"
                        }),
                        "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gjUWL.default).actionsMenuTriggerLabelIssueTermRefresh : (0, $gjUWL.default).actionsMenuTriggerLabel, {
                            summary: summary
                        })
                    }),
                spacing: "compact",
                placement: "bottom-end",
                onOpenChange: ({ isOpen: isOpen })=>{
                    this.setState({
                        isMenuOpen: isOpen
                    });
                }
            }, menu));
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof JiraCardContents' is not assignable to parameter of type 'ComponentType<WithIntlProvided<Props>> & typeof JiraCardContents'.
$1573e5e4e2e6fae4$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($1573e5e4e2e6fae4$var$JiraCardContents);
const $1573e5e4e2e6fae4$var$TooltipContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1573e5e4e2e6fae4$var$StatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _1e0c1txw _2lx21bp4 _4cvr1y6m _stfgagmp",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9JGeS", function(module, exports) {

$parcel$export(module.exports, "CardChildIssues", () => $9342bd2080922354$export$34d755500cd8440e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $8uZt8 = parcelRequire("8uZt8");


var $fTggM = parcelRequire("fTggM");
const $9342bd2080922354$export$34d755500cd8440e = (props)=>{
    const { complete: complete, total: total } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (total === null || total === 0) return null;
    const message = formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fTggM.default).childIssuesMetadataIssueTermRefresh : (0, $fTggM.default).childIssuesMetadata, {
        complete: complete,
        total: total
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9342bd2080922354$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$3b43f1ca008dad23),
        label: message,
        primaryColor: "var(--ds-icon, #44546F)"
    })));
};
var $9342bd2080922354$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $9342bd2080922354$export$34d755500cd8440e;
const $9342bd2080922354$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fTggM", function(module, exports) {

$parcel$export(module.exports, "default", () => $c5dc23d8c9309847$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c5dc23d8c9309847$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childIssuesMetadata: {
        "id": "card.common.child-issues.child-issues-metadata",
        "defaultMessage": "{complete} of {total} child issues complete"
    },
    childIssuesMetadataIssueTermRefresh: {
        "id": "card.common.child-issues.child-issues-metadata-issue-term-refresh",
        "defaultMessage": "{complete} of {total} child work items complete"
    }
});

});


parcelRegister("hOvWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $375ebd4f2b182bd6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $7Vvqa = parcelRequire("7Vvqa");
const $375ebd4f2b182bd6$var$ContextMenuWrapper = ({ children: children, onClick: onClick, onSetRef: onSetRef, onContextMenu: onContextMenu })=>// eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions, @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: onSetRef,
        onClick: onClick,
        onContextMenu: onContextMenu,
        "data-testid": "platform-card.common.ui.context-menu.wrapper"
    }, children);
const $375ebd4f2b182bd6$var$WrapperWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('contextMenu', {
    onContextMenu: 'open'
})($375ebd4f2b182bd6$var$ContextMenuWrapper); // eslint-disable-next-line jira/react/no-class-components
class $375ebd4f2b182bd6$var$CardContextMenu extends (0, $5uXOq.Component) {
    componentDidUpdate(prevProps, prevState) {
        if (prevState.isContextMenuOpen === false && this.state.isContextMenuOpen === true) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('mousedown', this.onMouseDownOutside);
        if (prevState.isContextMenuOpen === true && this.state.isContextMenuOpen === false) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousedown', this.onMouseDownOutside);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.removeEventListener('mousedown', this.onMouseDownOutside);
    }
    render() {
        const { children: children, items: items } = this.props;
        const { isContextMenuOpen: isContextMenuOpen, contextMenuPositionX: contextMenuPositionX, contextMenuPositionY: contextMenuPositionY } = this.state; /*
                    * First we don't have the ref anymore, so we can't detect clicks outside of the
                    	menu (this is made worse by the fact that the menu is in a portal, because
                    	previously the menu was inside of the card / container)
                    * Second, because the menu is in a portal, it does't update its position when
                    	the parent is moved
                    */ 
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ebd4f2b182bd6$var$WrapperWithAnalytics, {
            onSetRef: this.onWrapperRefSet,
            onContextMenu: this.onContextMenu
        }, items === null ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ebd4f2b182bd6$var$ActionsSection, {
            x: contextMenuPositionX,
            y: contextMenuPositionY,
            onClick: this.onMouseDownInside
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            key: `${contextMenuPositionX}:${contextMenuPositionY}`,
            spacing: "compact",
            isOpen: isContextMenuOpen,
            trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($375ebd4f2b182bd6$var$TriggerWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    ...props,
                    ref: triggerRef,
                    appearance: "subtle",
                    "aria-label": this.props.intl?.formatMessage((0, $7Vvqa.messages).label)
                })),
            onOpenChange: this.onOpenChange
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: this.onDropDownRefSet
        }, items))), children));
    }
    constructor(...args){
        super(...args), this.state = {
            isContextMenuOpen: false,
            contextMenuPositionX: 0,
            contextMenuPositionY: 0
        }, this.isClickOutside = (e)=>{
            if (!(e.target instanceof Node)) return true;
            const isClickInside = this.refWrapper && this.refWrapper.contains(e.target) || this.refDropDownMenu && this.refDropDownMenu.contains(e.target);
            return !isClickInside;
        }, this.onMouseDownOutside = (e)=>{
            if (this.isClickOutside(e)) this.onContextMenuClose();
        }, this.onMouseDownInside = (e)=>{
            // prevents click on the context menu item to bubble up and fire card click
            e.preventDefault();
            e.stopPropagation();
        }, this.onContextMenu = (e, analyticsEvent)=>{
            if (this.isClickOutside(e)) return;
            e.stopPropagation();
            e.preventDefault();
            if (this.props.items === null) return;
            if (this.refWrapper) {
                const { onContextMenuChange: onContextMenuChange } = this.props;
                const { top: top, left: left } = this.refWrapper.getBoundingClientRect();
                this.setState({
                    isContextMenuOpen: true,
                    contextMenuPositionX: e.clientX - left,
                    contextMenuPositionY: e.clientY - top - 15
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openedContextMenu');
                onContextMenuChange(true);
            }
            if (this.refDropDownMenu) this.refDropDownMenu.focus();
        }, this.onContextMenuClose = ()=>{
            const { onContextMenuChange: onContextMenuChange } = this.props;
            this.setState({
                isContextMenuOpen: false
            });
            onContextMenuChange(false);
        }, this.onOpenChange = ({ isOpen: isOpen })=>{
            if (!isOpen) this.onContextMenuClose();
        }, this.onWrapperRefSet = (ref)=>{
            this.refWrapper = ref;
        }, this.onDropDownRefSet = (ref)=>{
            this.refDropDownMenu = ref;
        }, this.refWrapper = null, this.refDropDownMenu = null;
    }
}
var $375ebd4f2b182bd6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($375ebd4f2b182bd6$var$CardContextMenu);
const $375ebd4f2b182bd6$var$TriggerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_jq8gidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $375ebd4f2b182bd6$var$ActionsSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_bajtf7": (0, $lD23V.default)(`${__cmplp.y}px`),
            "--_172sugn": (0, $lD23V.default)(`${__cmplp.x}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1pby1nn1 _154i1wux _1ltv1j37",
            __cmplp.className
        ])
    });
});

});
parcelRegister("7Vvqa", function(module, exports) {

$parcel$export(module.exports, "messages", () => $40b2c9c72867436a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $40b2c9c72867436a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    label: {
        "id": "card.common.context-menu.trigger-label",
        "defaultMessage": "Open card actions menu"
    }
});

});


parcelRegister("f5Alb", function(module, exports) {

$parcel$export(module.exports, "default", () => $06e6b9674d7045f8$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $Iny5X = parcelRequire("Iny5X");

var $8phmQ = parcelRequire("8phmQ");
const $06e6b9674d7045f8$var$CardDevStatus = (props)=>{
    const { type: type, issueId: issueId, deploymentDetails: deploymentDetails } = props;
    const hasSupportedType = (0, $8phmQ.SUPPORTED_DEV_STATUSES).includes(type);
    if (!hasSupportedType) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($06e6b9674d7045f8$var$Container, null, issueId && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $Iny5X.default), {
        issueId: issueId,
        devInfoType: type,
        allowNativeContextMenu: true,
        deploymentDetails: deploymentDetails,
        location: (0, $4ebd35f903e92a1a$export$9b8283d5878d2491)
    }));
};
var $06e6b9674d7045f8$export$2e2bcd8739ae039 = $06e6b9674d7045f8$var$CardDevStatus;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $06e6b9674d7045f8$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
const $4ebd35f903e92a1a$export$9b8283d5878d2491 = 'board';
const $4ebd35f903e92a1a$export$76a449e52fa0e1e8 = 'issue';
const $4ebd35f903e92a1a$export$ede40e627a0cbf14 = 'version_details';
const $4ebd35f903e92a1a$export$464c50016d069471 = 'issue_view_child_issues_list';
const $4ebd35f903e92a1a$export$3a46c5b594c0f84c = 'issue_view_linked_issues_list';

parcelRegister("Iny5X", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9451438a3e9bf76$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8QpSo = parcelRequire("8QpSo");

var $9yOBd = parcelRequire("9yOBd");

var $4iPF3 = parcelRequire("4iPF3");

var $ePJ5X = parcelRequire("ePJ5X");

var $bFklq = parcelRequire("bFklq");

var $ksIER = parcelRequire("ksIER");

var $91Cn3 = parcelRequire("91Cn3");

var $hXgVM = parcelRequire("hXgVM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $4gmb8 = parcelRequire("4gmb8");

var $2YZCu = parcelRequire("2YZCu");


var $8YTUU = parcelRequire("8YTUU");

var $lxrPB = parcelRequire("lxrPB");

var $kcaDR = parcelRequire("kcaDR");

var $7MIrF = parcelRequire("7MIrF");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $7CMCs = parcelRequire("7CMCs");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $lXSZ8 = parcelRequire("lXSZ8");

var $koVbs = parcelRequire("koVbs");

var $7IEKg = parcelRequire("7IEKg");

var $dXq4S = parcelRequire("dXq4S");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");

var $fiv1r = parcelRequire("fiv1r");

var $fcSLY = parcelRequire("fcSLY");

var $kfztd = parcelRequire("kfztd");

var $9OXo1 = parcelRequire("9OXo1");

var $gicL9 = parcelRequire("gicL9");

var $4Dyci = parcelRequire("4Dyci");
const $a9451438a3e9bf76$var$DEV_INFO_BUTTON_ID = 'development-board-dev-info-icon.button-text';
const $a9451438a3e9bf76$var$DevInfoIconsMapping = (0, $8QpSo.default)((formatMessage)=>({
        [(0, $8YTUU.DevInfoTypes).BRANCH]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4iPF3))), {
            label: formatMessage((0, $4Dyci.default).branchIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).COMMIT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bFklq))), {
            label: formatMessage((0, $4Dyci.default).commitIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hXgVM))), {
            label: formatMessage((0, $4Dyci.default).openPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).DECLINED]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ksIER))), {
            label: formatMessage((0, $4Dyci.default).declinedPullRequestIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).MERGED]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($91Cn3))), {
            label: formatMessage((0, $4Dyci.default).mergedPullRequestIconLabel),
            color: "var(--ds-icon-accent-green, #22A06B)"
        }),
        [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ePJ5X))), {
            label: formatMessage((0, $4Dyci.default).deploymentIconLabel),
            color: "var(--ds-icon, #44546F)"
        }),
        [(0, $8YTUU.DevInfoTypes).DESIGN]: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $a9451438a3e9bf76$var$DesignIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lXSZ8.default), {
            label: formatMessage((0, $4Dyci.default).designIconLabel)
        }))
    }));
const $a9451438a3e9bf76$var$getDevInfoIcon = (devInfoType, formatMessage, deploymentDetails)=>{
    if (deploymentDetails?.deploymentState && deploymentDetails?.deploymentEnvironment) {
        if (deploymentDetails.deploymentEnvironment === (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentProdSuccess), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment === (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentProdFailed), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentProductionFailedIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).SUCCESSFUL) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentNonProdSuccess), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentNonProductionSuccessIconLabel)
        });
        if (deploymentDetails.deploymentEnvironment !== (0, $gicL9.DeploymentEnvironment).PRODUCTION && deploymentDetails.deploymentState === (0, $gicL9.DeploymentState).FAILED) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7MIrF.DeploymentNonProdFailed), {
            size: "small",
            label: formatMessage((0, $4Dyci.default).deploymentNonProductionFailedIconLabel)
        });
    }
    return $a9451438a3e9bf76$var$DevInfoIconsMapping(formatMessage)[devInfoType];
};
const $a9451438a3e9bf76$var$TriggerComponent = ({ triggerProps: triggerProps, customTrigger: customTrigger })=>{
    const omitProp = (prop, { [prop]: _, ...rest })=>rest;
    const modifierTriggerProps = omitProp('aria-expanded', triggerProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", modifierTriggerProps, customTrigger);
};
const $a9451438a3e9bf76$export$b98af1fb6b8b345e = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement = 'bottom-start', offset: offset, zIndex: /* Setting zIndex slighlty lower than the default so that other popups (like the right-click context menu) appear on top of this */ zIndex = (0, $gwIPs.layers).layer - 1 })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isHoverMode, setIsHoverMode] = (0, $5uXOq.useState)(true);
    const [shouldAutoFocus, setShouldAutoFocus] = (0, $5uXOq.useState)(true);
    const timeoutRef = (0, $5uXOq.useRef)(undefined);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const issueAri = (0, $5uXOq.useMemo)(()=>(0, $kcaDR.createIssueAri)(cloudId, issueId.toString()), [
        cloudId,
        issueId
    ]);
    const siteAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        resourceType: 'site',
        resourceId: cloudId
    });
    const initialTrigger = (0, $5uXOq.useRef)(null);
    const devInfoIcon = $a9451438a3e9bf76$var$getDevInfoIcon(devInfoType, formatMessage, deploymentDetails);
    const popupType = devInfoType === (0, $8YTUU.DevInfoTypes).MERGED || devInfoType === (0, $8YTUU.DevInfoTypes).DECLINED ? (0, $8YTUU.DevInfoTypes).PULLREQUEST : devInfoType;
    const { id: experienceId, name: experienceName } = (0, $gicL9.experienceDetails)[popupType];
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experienceName
    });
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            issueId: issueAri
        }), [
        issueAri
    ]); // eslint-disable-next-line @atlassian/react-entrypoint/prefer-entrypoint-file-import
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $gicL9.popupEntryPoints)[popupType], entryPointParams, (0, $gicL9.metrics)[popupType]); // Entry point for the design modal that is used in the design details popup
    const designEntrypoint = (0, $4mO32.useEntryPoint)((0, $7IEKg.designModalEntryPoint), {
        siteAri: siteAri,
        issueAri: issueAri,
        cloudId: cloudId
    });
    const designModalTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(designEntrypoint.entryPointActions);
    const entryPointErrorBoundaryProps = (0, $5uXOq.useMemo)(()=>({
            ...(0, $gicL9.packageDetails)[popupType],
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lxrPB.default), {
                    devInfoType: devInfoType,
                    issueAri: issueAri,
                    scopeId: scopeId
                })
        }), [
        devInfoType,
        issueAri,
        popupType,
        scopeId
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueAri: issueAri,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            devInfoType: devInfoType,
            trigger: initialTrigger.current ?? undefined,
            onReady: ()=>{
                stopMetric();
                onExperienceSuccess();
            },
            scopeId: scopeId,
            modalTriggerRef: devInfoType === (0, $8YTUU.DevInfoTypes).DESIGN ? designModalTriggerRef : undefined
        }), [
        issueAri,
        devInfoType,
        scopeId,
        designModalTriggerRef,
        stopMetric,
        onExperienceSuccess
    ]);
    const handleDevIconClick = (0, $5uXOq.useCallback)(()=>{
        clearTimeout(timeoutRef.current);
        if (initialTrigger.current === null) initialTrigger.current = 'click';
        if (isOpen && isHoverMode) setIsHoverMode(false);
        else if (isOpen && !isHoverMode) {
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        } else {
            entryPointActions.load();
            setShouldAutoFocus(true);
            setIsOpen(true);
            setIsHoverMode(false);
        }
    }, [
        entryPointActions,
        isHoverMode,
        isOpen
    ]);
    const handleMouseEnter = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        setShouldAutoFocus(false);
        if (!isOpen) {
            entryPointActions.preload();
            timeoutRef.current = undefined;
            timeoutRef.current = setTimeout(()=>{
                if (initialTrigger.current === null) initialTrigger.current = 'hover';
                entryPointActions.load();
                setIsOpen(true);
            }, (0, $gicL9.HOVER_TIMEOUT_MS));
        }
    };
    const handleMouseLeave = ()=>{
        if (!isHoverMode) return;
        clearTimeout(timeoutRef.current);
        entryPointActions.cancelPreload();
        timeoutRef.current = undefined;
        if (isOpen) timeoutRef.current = setTimeout(()=>{
            initialTrigger.current = null;
            setShouldAutoFocus(true);
            setIsHoverMode(true);
            setIsOpen(false);
        }, (0, $gicL9.HOVER_TIMEOUT_MS));
    };
    if ((0, $gicL9.iconColor)[devInfoType] === undefined) (0, $2YZCu.default).safeErrorWithoutCustomerData('packages.development.board.dev-info-icon', 'unexpected devInfoType', {
        devInfoType: devInfoType
    });
    const customTheme = (0, $4gmb8.getTheme)({
        buttonStyles: {
            subtle: {
                color: {
                    // @ts-expect-error - TS2322 - Type '{ color: { default: string | undefined; hover: string | undefined; active: string | undefined; }; }' is not assignable to type 'CSSInterpolation'. | TS2532 - Object is possibly 'undefined'.
                    default: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).DEFAULT],
                    hover: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).HOVER],
                    active: (0, $gicL9.iconColor)[devInfoType][(0, $8YTUU.ButtonStatus).ACTIVE]
                }
            }
        }
    });
    const devInfoTextId = `${$a9451438a3e9bf76$var$DEV_INFO_BUTTON_ID}-${issueId}`;
    return(// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        role: "presentation",
        "data-testid": "development-board-dev-info-icon.container",
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
        onClick: (e)=>{
            // Prevents clicks on the icon from opening the Issue view
            if (isStopPropagationOnClick) e.stopPropagation();
        },
        onKeyDown: (e)=>{
            // Prevents using keyboard to open the Issue view
            e.stopPropagation();
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        placement: placement,
        shouldFlip: true,
        autoFocus: shouldAutoFocus,
        shouldUseCaptureOnOutsideClick: true,
        testId: "development-board-dev-info-icon.popup",
        messageId: "development-board-dev-info-icon.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>customTrigger != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$var$TriggerComponent, {
                triggerProps: triggerProps,
                customTrigger: customTrigger
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
                ...triggerProps,
                onClick: handleDevIconClick,
                isSelected: isOpen && !isHoverMode,
                theme: customTheme,
                appearance: "subtle",
                spacing: "compact",
                iconBefore: devInfoIcon,
                "aria-describedby": devInfoTextId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$var$DevInfoButtonText, {
                id: devInfoTextId
            }, (0, $gicL9.DevInfoButtonLabelMapping)(formatMessage)[devInfoType])),
        isOpen: isOpen,
        onClose: ()=>{
            initialTrigger.current = null;
            setIsOpen(false);
            setIsHoverMode(true);
        },
        offset: offset,
        zIndex: zIndex,
        content: ()=>// eslint-disable-next-line jsx-a11y/no-static-element-interactions
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // We are stopping right-click event propagation to not show the custom context menu from the Jira Issue Card
            , {
                // and instead use the event default
                onContextMenu: (event)=>{
                    if (!allowNativeContextMenu) event.preventDefault();
                }
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kaHBi.ExperienceStart), {
                analyticsSource: experienceName,
                experience: experienceName,
                experienceId: experienceId
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
                entryPointReferenceSubject: entryPointReferenceSubject,
                ...entryPointErrorBoundaryProps,
                fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fcSLY.DevInfoDetailsPopupSkeleton), {
                    devinfoType: popupType
                }),
                runtimeProps: runtimeProps
            }))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: designEntrypoint.entryPointReferenceSubject,
        id: "jiraDesignModal",
        packageName: "design-modal",
        entryPointActions: designEntrypoint.entryPointActions,
        runtimeProps: {
            initialSelectedDesign: 0
        }
    })));
};
const $a9451438a3e9bf76$var$ERROR_ID = 'renderDevInfoIcon';
const $a9451438a3e9bf76$var$PACKAGE_NAME = 'jiraDevelopmentBoardDevInfoIcon';
const $a9451438a3e9bf76$var$DevInfoIcon = ({ issueId: issueId, devInfoType: devInfoType, allowNativeContextMenu: allowNativeContextMenu, customTrigger: customTrigger, scopeId: scopeId, deploymentDetails: deploymentDetails, isStopPropagationOnClick: isStopPropagationOnClick = true, placement: placement, offset: offset, zIndex: zIndex, location: location = (0, $4ebd35f903e92a1a$export$9b8283d5878d2491) })=>{
    const attributes = {
        devInfoType: devInfoType ?? 'unexpected',
        location: location
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: $a9451438a3e9bf76$var$ERROR_ID,
        packageName: $a9451438a3e9bf76$var$PACKAGE_NAME,
        teamName: "nova",
        fallback: "unmount",
        attributes: attributes,
        extraEventData: attributes,
        sendToPrivacyUnsafeSplunk: true
    }, !(0, $kfztd.isDevopsFeatureDisabledInFedRamp)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fiv1r.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$cae2783c9279926),
        sourceName: "DevInfoIcon",
        attributes: attributes
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a9451438a3e9bf76$export$b98af1fb6b8b345e, {
        issueId: issueId,
        devInfoType: devInfoType,
        allowNativeContextMenu: allowNativeContextMenu,
        customTrigger: customTrigger,
        scopeId: scopeId,
        deploymentDetails: deploymentDetails,
        isStopPropagationOnClick: isStopPropagationOnClick,
        placement: placement,
        offset: offset,
        zIndex: zIndex
    }))));
};
var $a9451438a3e9bf76$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $a9451438a3e9bf76$var$DevInfoIcon;
const $a9451438a3e9bf76$var$DevInfoButtonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $a9451438a3e9bf76$var$DesignIconStyles = (0, $8CUq3.xcss)({
    height: '16px',
    width: '16px',
    display: 'flex',
    justifyContent: 'center'
});

});
parcelRegister("4iPF3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6bb7d4b05cefe88d0219507dc0673c3e>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3220eab15e59539d$var$_react = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3220eab15e59539d$var$_baseNew = $3220eab15e59539d$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3220eab15e59539d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Branch".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3220eab15e59539d$var$BranchIcon = (props)=>/*#__PURE__*/ $3220eab15e59539d$var$_react.default.createElement($3220eab15e59539d$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122V9H3.5V5.372A2.25 2.25 0 0 1 2 3.25m9.75-.75a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m-2.25.75a2.25 2.25 0 1 1 3 2.122v4.878a3.25 3.25 0 0 1-3.25 3.25H6.372a2.25 2.25 0 1 1 0-1.5H9.25A1.75 1.75 0 0 0 11 10.25V5.372A2.25 2.25 0 0 1 9.5 3.25M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$3220eab15e59539d$var$BranchIcon.displayName = 'BranchIcon';
var $3220eab15e59539d$var$_default = module.exports.default = $3220eab15e59539d$var$BranchIcon;

});

parcelRegister("ePJ5X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7e83f76db2e7ada7e0358014b5e026a9>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $acc8cf07db1d2dba$var$_react = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $acc8cf07db1d2dba$var$_baseNew = $acc8cf07db1d2dba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $acc8cf07db1d2dba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "CloudArrowUp".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $acc8cf07db1d2dba$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $acc8cf07db1d2dba$var$_react.default.createElement($acc8cf07db1d2dba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 3a4.25 4.25 0 0 0-4.236 3.9.75.75 0 0 1-.565.668A2.251 2.251 0 0 0 3.75 12v1.5a3.75 3.75 0 0 1-1.418-7.222 5.751 5.751 0 0 1 11.239-.458A4 4 0 0 1 12 13.5V12a2.5 2.5 0 0 0 .712-4.897.75.75 0 0 1-.526-.59A4.25 4.25 0 0 0 8 3m0 4a.75.75 0 0 1 .53.22l3 3-1.06 1.06-1.72-1.72V16h-1.5V9.56l-1.72 1.72-1.06-1.06 3-3A.75.75 0 0 1 8 7" clip-rule="evenodd"/>`
    }, props));
$acc8cf07db1d2dba$var$CloudArrowUpIcon.displayName = 'CloudArrowUpIcon';
var $acc8cf07db1d2dba$var$_default = module.exports.default = $acc8cf07db1d2dba$var$CloudArrowUpIcon;

});

parcelRegister("bFklq", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06952e599791aaa8e8e82dba5053d210>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $87e34e0db8f20450$var$_react = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $87e34e0db8f20450$var$_baseNew = $87e34e0db8f20450$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $87e34e0db8f20450$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Commit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for commits in Jira or Bitbucket.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $87e34e0db8f20450$var$CommitIcon = (props)=>/*#__PURE__*/ $87e34e0db8f20450$var$_react.default.createElement($87e34e0db8f20450$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M7.25 5.354a2.751 2.751 0 0 0 0 5.292V16h1.5v-5.353a2.751 2.751 0 0 0 0-5.293V0h-1.5zM8 6.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5" clip-rule="evenodd"/>`
    }, props));
$87e34e0db8f20450$var$CommitIcon.displayName = 'CommitIcon';
var $87e34e0db8f20450$var$_default = module.exports.default = $87e34e0db8f20450$var$CommitIcon;

});

parcelRegister("ksIER", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::46425de68e3cee71ad4d509963568bdb>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee5910529ff74451$var$_react = $ee5910529ff74451$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee5910529ff74451$var$_baseNew = $ee5910529ff74451$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee5910529ff74451$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MergeFailure".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have failed to merge.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee5910529ff74451$var$MergeFailureIcon = (props)=>/*#__PURE__*/ $ee5910529ff74451$var$_react.default.createElement($ee5910529ff74451$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M3.19 3.25 1.47 1.53 2.53.47l1.72 1.72L5.97.47l1.06 1.06-1.72 1.72 1.72 1.72-1.06 1.06-1.72-1.72-1.72 1.72-1.06-1.06zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$ee5910529ff74451$var$MergeFailureIcon.displayName = 'MergeFailureIcon';
var $ee5910529ff74451$var$_default = module.exports.default = $ee5910529ff74451$var$MergeFailureIcon;

});

parcelRegister("91Cn3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::7365ce82afc8d12ffbc163f3aafca653>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6921f8b1fecd6128$var$_react = $6921f8b1fecd6128$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $6921f8b1fecd6128$var$_baseNew = $6921f8b1fecd6128$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $6921f8b1fecd6128$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "MergeSuccess".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for branches in Bitbucket and Jira that have successfully merged.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $6921f8b1fecd6128$var$MergeSuccessIcon = (props)=>/*#__PURE__*/ $6921f8b1fecd6128$var$_react.default.createElement($6921f8b1fecd6128$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.174.77 1.152.96-3.333 4a.75.75 0 0 1-1.152 0l-1.667-2 1.152-.96 1.09 1.308zM8.5 2.5h1.25a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8.5zm-5 8.128V7.5H5v3.128a2.251 2.251 0 1 1-1.5 0M4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$6921f8b1fecd6128$var$MergeSuccessIcon.displayName = 'MergeSuccessIcon';
var $6921f8b1fecd6128$var$_default = module.exports.default = $6921f8b1fecd6128$var$MergeSuccessIcon;

});

parcelRegister("hXgVM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a083285ccf5836110a489694f045affe>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d1251477351c10fe$var$_react = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d1251477351c10fe$var$_baseNew = $d1251477351c10fe$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d1251477351c10fe$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PullRequest".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d1251477351c10fe$var$PullRequestIcon = (props)=>/*#__PURE__*/ $d1251477351c10fe$var$_react.default.createElement($d1251477351c10fe$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.25 2.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5M2 3.25a2.25 2.25 0 1 1 3 2.122v5.256a2.251 2.251 0 1 1-1.5 0V5.372A2.25 2.25 0 0 1 2 3.25m6-.75h1.75a2.75 2.75 0 0 1 2.75 2.75v5.378a2.251 2.251 0 1 1-1.5 0V5.25C11 4.56 10.44 4 9.75 4H8zM4.25 12a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5m7.5 0a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5" clip-rule="evenodd"/>`
    }, props));
$d1251477351c10fe$var$PullRequestIcon.displayName = 'PullRequestIcon';
var $d1251477351c10fe$var$_default = module.exports.default = $d1251477351c10fe$var$PullRequestIcon;

});

parcelRegister("4gmb8", function(module, exports) {

$parcel$export(module.exports, "getTheme", () => $26e3b01c3b885768$export$89cbf1a0881c8b9c);
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ // @ts-expect-error - TS2614 - Module '"@atlaskit/button"' has no exported member 'ButtonTheme'. Did you mean to use 'import ButtonTheme from "@atlaskit/button"' instead?

const $26e3b01c3b885768$export$9e61512f2dc2cbb0 = (currentTheme, props)=>{
    const { buttonStyles: buttonStyles, ...rest } = currentTheme(props);
    const theme = {
        ...rest,
        buttonStyles: {
            ...buttonStyles,
            backgroundColor: (0, $829f609a65d26a98$exports).P400,
            '> span': {
                color: (0, $829f609a65d26a98$exports).N0
            }
        }
    };
    return theme;
};
const $26e3b01c3b885768$export$f9380c9a627682d3 = (newTheme, themeProps)=>{
    const { appearance: appearance, mode: mode, state: state } = themeProps;
    if (!appearance || !newTheme[appearance]) return undefined;
    const root = newTheme[appearance];
    // @ts-expect-error - TS2739 - Type 'Record<string, any>' is missing the following properties from type 'ThemeTokens': buttonStyles, spinnerStyles
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.keys(root).reduce((acc, val)=>{
        let node = root;
        [
            val,
            state,
            mode
        ].forEach((item)=>{
            if (!item) return;
            if (!node[item] && node[item] !== 0) return;
            if (typeof node[item] !== 'object') {
                acc[val] = node[item];
                return;
            }
            // @ts-expect-error - TS2322 - Type 'string | number | { [key: string]: string | number; } | T' is not assignable to type '{ [key: string]: string | number; } | T'.
            node = node[item];
        });
        return acc;
    }, {});
};
const $26e3b01c3b885768$export$89cbf1a0881c8b9c = (overrides)=>(currentTheme, themeProps)=>{
        const theme = currentTheme(themeProps);
        // @ts-expect-error - TS2322 - Type 'Record<string, any>' is not assignable to type 'ThemeTokens'.
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const styles = Object.entries(theme).reduce(// eslint-disable-next-line @typescript-eslint/no-explicit-any
        (acc, [key, value])=>{
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            if (!overrides?.[key]) {
                acc[key] = value;
                return acc;
            }
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'any' can't be used to index type 'Partial<ThemeTokens>'.
            const overriddenStyles = $26e3b01c3b885768$export$f9380c9a627682d3(overrides[key], themeProps);
            acc[key] = {
                ...value,
                ...overriddenStyles
            };
            return acc;
        }, {});
        return styles;
    };

});

parcelRegister("8YTUU", function(module, exports) {

$parcel$export(module.exports, "DevInfoTypes", () => $ba5542dc32884ee4$export$a100703e17b2650a);
$parcel$export(module.exports, "DevInfoTypeMap", () => $ba5542dc32884ee4$export$39c00ace65e13f2d);
$parcel$export(module.exports, "ButtonStatus", () => $ba5542dc32884ee4$export$477d4d2d93581a40);
const $ba5542dc32884ee4$export$a100703e17b2650a = Object.freeze({
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DECLINED: 'declined',
    MERGED: 'merged',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
});
const $ba5542dc32884ee4$export$39c00ace65e13f2d = {
    [$ba5542dc32884ee4$export$a100703e17b2650a.BRANCH]: 'branch',
    [$ba5542dc32884ee4$export$a100703e17b2650a.COMMIT]: 'commit',
    [$ba5542dc32884ee4$export$a100703e17b2650a.PULLREQUEST]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.MERGED]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DECLINED]: 'pull request',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DEPLOYMENT]: 'deployment',
    [$ba5542dc32884ee4$export$a100703e17b2650a.DESIGN]: 'design'
};
const $ba5542dc32884ee4$export$477d4d2d93581a40 = Object.freeze({
    ACTIVE: 'active',
    HOVER: 'hover',
    DEFAULT: 'default'
});

});

parcelRegister("lxrPB", function(module, exports) {

$parcel$export(module.exports, "default", () => $cfd87e1125ba31c4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $dD7Zc = parcelRequire("dD7Zc");

var $koVbs = parcelRequire("koVbs");

var $ifS9h = parcelRequire("ifS9h");

var $8YTUU = parcelRequire("8YTUU");

var $dt6Va = parcelRequire("dt6Va");

var $el2W3 = parcelRequire("el2W3");
const $cfd87e1125ba31c4$var$ErrorFallback = ({ devInfoType: devInfoType, issueAri: issueAri, scopeId: scopeId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showDevDetailDialogForPopup: showDevDetailDialogForPopup } = (0, $dt6Va.useShowDevDetailDialogForPopup)(scopeId);
    const handleLinkClick = ()=>{
        showDevDetailDialogForPopup(devInfoType, issueAri);
    };
    const devInfoTypeName = (0, $8YTUU.DevInfoTypeMap)[devInfoType];
    const errorMessage = devInfoType === (0, $8YTUU.DevInfoTypes).DESIGN ? formatMessage((0, $el2W3.default).designErrorDescription, {
        devInfoType: devInfoTypeName
    }) : formatMessage((0, $el2W3.default).errorDescription, {
        devInfoType: devInfoTypeName
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ifS9h.PopupTitle), null, formatMessage((0, $el2W3.default).errorPopupTitle, {
        devInfoType: (0, $8YTUU.DevInfoTypeMap)[devInfoType]
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Title, null, formatMessage((0, $el2W3.default).errorTitle)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$Description, null, errorMessage, devInfoType !== (0, $8YTUU.DevInfoTypes).DESIGN && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cfd87e1125ba31c4$var$StyledButton, {
        appearance: "link",
        onClick: handleLinkClick
    }, formatMessage((0, $el2W3.default).developmentErrorDescriptionCta))));
};
var $cfd87e1125ba31c4$export$2e2bcd8739ae039 = $cfd87e1125ba31c4$var$ErrorFallback;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cfd87e1125ba31c4$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$Description = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _18u0u2gc",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _1yxxidpf _12r2i7a9 _if291ule",
            __cmplp.className
        ])
    });
});
const $cfd87e1125ba31c4$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _syaz131l _19pku2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ifS9h", function(module, exports) {

$parcel$export(module.exports, "PopupContainer", () => $88fc3594fd7e78a2$export$cca08eed9de89ba9);
$parcel$export(module.exports, "LinkContainer", () => $88fc3594fd7e78a2$export$af2ec3aa21d10ab7);
$parcel$export(module.exports, "PopupHeader", () => $88fc3594fd7e78a2$export$b11ea9d6e8111404);
$parcel$export(module.exports, "StyledDate", () => $88fc3594fd7e78a2$export$30301703d55848e7);
$parcel$export(module.exports, "RepositoryInfo", () => $88fc3594fd7e78a2$export$fde5e3d077213a6f);
$parcel$export(module.exports, "PopupTitle", () => $88fc3594fd7e78a2$export$b834616c6081368f);
$parcel$export(module.exports, "StyledLink", () => $88fc3594fd7e78a2$export$9048d548939551ee);
$parcel$export(module.exports, "PopupOverflowSection", () => $88fc3594fd7e78a2$export$9e3158dc6a3a0f92);
$parcel$export(module.exports, "PopupKeyline", () => $88fc3594fd7e78a2$export$a0765d4427758c62);
$parcel$export(module.exports, "PopupOverflowButton", () => $88fc3594fd7e78a2$export$aeb11758c9d29e5c);
$parcel$export(module.exports, "TimeDisplay", () => $88fc3594fd7e78a2$export$9b3df3d60caed5f9);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $41j30 = parcelRequire("41j30");
const $88fc3594fd7e78a2$export$cca08eed9de89ba9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _1bsbnklw _1tkeys9h _vchhusvi",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$af2ec3aa21d10ab7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c _otyr1b66",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$b11ea9d6e8111404 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$30301703d55848e7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _otyridpf _1e0c1txw _o5724jg8",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$fde5e3d077213a6f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _syaz131l _o5724jg8",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$80b51772092eddc0 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l _1p1dangw _otyr1b66",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$b834616c6081368f = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($88fc3594fd7e78a2$export$80b51772092eddc0, props));
const $88fc3594fd7e78a2$export$9048d548939551ee = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $41j30.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81ixg _k48pmoej _syaz14q2 _otyru2gc",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$9e3158dc6a3a0f92 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkpxbi",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$a0765d4427758c62 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it94y _bfhkmuej _otyrutpp",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$aeb11758c9d29e5c = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ytiidpf _7yhbidpf _1bdkidpf _24rcidpf _1yxxidpf _12r2i7a9",
            __cmplp.className
        ])
    });
});
const $88fc3594fd7e78a2$export$9b3df3d60caed5f9 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66 _80omtlke",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dt6Va", function(module, exports) {

$parcel$export(module.exports, "useShowDevDetailDialogForPopup", () => $71478bde10e2ba46$export$cdc75a6c65207319);

var $4HJKb = parcelRequire("4HJKb");


var $dXq4S = parcelRequire("dXq4S");

var $8YTUU = parcelRequire("8YTUU");
const $71478bde10e2ba46$export$166d6c8e7de25541 = (issueAri)=>(0, $dXq4S.parseAri)(issueAri)?.resourceId;
const $71478bde10e2ba46$var$devInfoTypeToPanelDataType = (devInfoType)=>{
    if (devInfoType === (0, $8YTUU.DevInfoTypes).COMMIT) return 0, $61a2cd6236d50c20$export$2e42513c7764d5f3;
    if (devInfoType === (0, $8YTUU.DevInfoTypes).DEPLOYMENT) return 0, $61a2cd6236d50c20$export$90cac6260ae9ced5;
    return devInfoType;
};
function $71478bde10e2ba46$export$cdc75a6c65207319(scopeId) {
    const { showDevDetailDialog: showDevDetailDialog } = (0, $4HJKb.useDevOpsDetailsDialogLoaderActions)(scopeId || 'software-board.board');
    const showDevDetailDialogForPopup = (devInfoType, issueAri)=>{
        const type = $71478bde10e2ba46$var$devInfoTypeToPanelDataType(devInfoType);
        const issueId = $71478bde10e2ba46$export$166d6c8e7de25541(issueAri);
        // @ts-expect-error - TS2345 - Argument of type 'string' is not assignable to parameter of type 'PanelDataTypes'.
        showDevDetailDialog(type, undefined, '', issueId);
    };
    return {
        showDevDetailDialogForPopup: showDevDetailDialogForPopup
    };
}

});
parcelRegister("4HJKb", function(module, exports) {

$parcel$export(module.exports, "loadDialogBridge", () => $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderContainer", () => $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55);
$parcel$export(module.exports, "DevOpsDetailsDialogLoaderSubscriber", () => $ccf4b85a4aaf3a68$export$693f51ab225dff94);
$parcel$export(module.exports, "useDevOpsDetailsDialogLoaderActions", () => $ccf4b85a4aaf3a68$export$506ad06ecf691cd3);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");


var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
var $51nlc = parcelRequire("51nlc");
var $bKpgX = parcelRequire("bKpgX");

var $62M1I = parcelRequire("62M1I");
const $ccf4b85a4aaf3a68$export$7e12f7cd0f50fe5a = async ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: (0, $62M1I.DEV_DETAILS_WRM_RESOURCE),
        wrmKeys: [
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devstatus-wrm',
            'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources'
        ]
    });
const $ccf4b85a4aaf3a68$export$e324594224ef24da = {
    resetState: (stateOverrides)=>({ setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...(0, $62M1I.INITIAL_STATE),
                ...stateOverrides
            });
        },
    updateState: (stateUpdates)=>({ getState: getState, setState: setState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'. | TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                ...getState(),
                ...stateUpdates
            });
        },
    showDevDetailDialog: (itemType, legacyData, targetIssueKey, targetIssueId)=>({ setState: setState, getState: getState })=>{
            if (itemType === (0, $61a2cd6236d50c20$export$3f1e2b276d607490)) // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                legacyDevPanelDetailsDialogShownCounter: // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                getState().legacyDevPanelDetailsDialogShownCounter + 1,
                isDevPanelDetailsDialogShown: false,
                dataTypeSelected: itemType,
                legacyData: legacyData,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
            else // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                isDevPanelDetailsDialogShown: true,
                dataTypeSelected: itemType,
                issueKey: targetIssueKey,
                issueId: targetIssueId
            });
        },
    closeDetailDialog: ()=>({ setState: setState, getState: getState })=>{
            // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
            setState({
                // @ts-expect-error - TS2722 - Cannot invoke an object which is possibly 'undefined'.
                ...getState(),
                // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes | undefined'.
                dataTypeSelected: '',
                isDevPanelDetailsDialogShown: false,
                issueKey: undefined,
                issueId: undefined
            });
        }
};
const $ccf4b85a4aaf3a68$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: 'DetailsDialogLoaderRemoteState',
    initialState: (0, $62M1I.INITIAL_STATE),
    actions: $ccf4b85a4aaf3a68$export$e324594224ef24da
});
const $ccf4b85a4aaf3a68$export$5e6e4cfb89bdcb55 = (0, $gg7kZ.createContainer)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$693f51ab225dff94 = (0, $51nlc.createSubscriber)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
const $ccf4b85a4aaf3a68$export$550d4b3c29100112 = (0, $3sQ5x.createHook)($ccf4b85a4aaf3a68$export$390f32400eaf98c9);
function $ccf4b85a4aaf3a68$export$506ad06ecf691cd3(scopeId) {
    return (0, $bKpgX.defaultRegistry).getStore($ccf4b85a4aaf3a68$export$390f32400eaf98c9, scopeId)?.actions;
}

});
parcelRegister("62M1I", function(module, exports) {

$parcel$export(module.exports, "INITIAL_STATE", () => $bf37254db56efc10$export$36d128238e6b60f5);
$parcel$export(module.exports, "DEV_DETAILS_WRM_RESOURCE", () => $bf37254db56efc10$export$43a8ab4f373ff0ee);
const $bf37254db56efc10$export$36d128238e6b60f5 = {
    issueId: '',
    issueKey: undefined,
    locale: 'en_US',
    // @ts-expect-error - TS2322 - Type '""' is not assignable to type 'PanelDataTypes'.
    dataTypeSelected: '',
    legacyData: undefined,
    isDevPanelDetailsDialogShown: false,
    legacyDevPanelDetailsDialogShownCounter: 0
};
const $bf37254db56efc10$export$b5ed55f3ed234f95 = 'wrc!com.atlassian.jira.plugins.jira-development-integration-plugin:devsummarycf-resources';
const $bf37254db56efc10$export$43a8ab4f373ff0ee = 'jira-development-status/releasereport/dev-status-dialog-bridge';
const $bf37254db56efc10$export$432f9ff6c01431e3 = 'jira-development-status/util/WRM';

});



parcelRegister("el2W3", function(module, exports) {

$parcel$export(module.exports, "default", () => $06bd70345536382a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $06bd70345536382a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorPopupTitle: {
        "id": "development-board-common.error-fallback.error-popup-title",
        "defaultMessage": "{devInfoType}"
    },
    errorTitle: {
        "id": "development-board-common.error-fallback.error-title",
        "defaultMessage": "Something went wrong"
    },
    errorDescription: {
        "id": "development-board-common.error-fallback.error-description",
        "defaultMessage": "For some reason we couldn't load this {devInfoType}."
    },
    developmentErrorDescriptionCta: {
        "id": "development-board-common.error-fallback.development-error-description-cta",
        "defaultMessage": "View all development information."
    },
    designErrorDescription: {
        "id": "development-board-common.error-fallback.design-error-description",
        "defaultMessage": "For some reason we couldn't load this design. Refresh your page to try again."
    }
});

});


parcelRegister("kcaDR", function(module, exports) {

$parcel$export(module.exports, "createIssueAri", () => $f1bea1631292edff$export$6b0ec881a3540845);

var $dXq4S = parcelRequire("dXq4S");
const $f1bea1631292edff$export$6b0ec881a3540845 = (cloudId, issueId)=>(0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId
    });

});

parcelRegister("7MIrF", function(module, exports) {

$parcel$export(module.exports, "DeploymentProdSuccess", () => $7a25946f9b14c935$export$8409a6d16fd5ac8e);
$parcel$export(module.exports, "DeploymentNonProdSuccess", () => $7a25946f9b14c935$export$814ebe75b826c47b);
$parcel$export(module.exports, "DeploymentProdFailed", () => $7a25946f9b14c935$export$22f2b1620b38359);
$parcel$export(module.exports, "DeploymentNonProdFailed", () => $7a25946f9b14c935$export$5b461fe0712c5c45);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $7a25946f9b14c935$export$3800ce670a7fa29b = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                width: "24",
                height: "24",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h24v24H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
                fill: "var(--ds-icon-success, #22A06B)",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 6a3 3 0 1 1 4 2.83V20a1 1 0 1 1-2 0V8.83A3.001 3.001 0 0 1 4 6z"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 7a1 1 0 0 1 1 1v2a7.001 7.001 0 0 0 6.188 6.953 3.001 3.001 0 1 1-.03 2.008A9.001 9.001 0 0 1 6 10V8a1 1 0 0 1 1-1zm10 10a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM20.707 4.293a1 1 0 0 1 0 1.414l-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L16 7.586l3.293-3.293a1 1 0 0 1 1.414 0z"
            })))
    });
const $7a25946f9b14c935$export$9a767285e35d722a = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24",
                width: "24",
                height: "24",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h24v24H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
                fill: "var(--ds-icon-danger, #C9372C)",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                d: "M7 5a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM4 6a3 3 0 1 1 4 2.8V20a1 1 0 1 1-2 0V8.8A3 3 0 0 1 4 6zM17 11c.6 0 1 .4 1 1v3.2a3 3 0 1 1-2 0V12c0-.6.4-1 1-1zm0 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2zM13.8 2.8a1 1 0 0 1 1.4 0L17 4.6l1.8-1.8a1 1 0 1 1 1.4 1.4L18.4 6l1.8 1.8a1 1 0 0 1-1.4 1.4L17 7.4l-1.8 1.8a1 1 0 1 1-1.4-1.4L15.6 6l-1.8-1.8a1 1 0 0 1 0-1.4z"
            })))
    });
const $7a25946f9b14c935$export$8409a6d16fd5ac8e = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-success, #22A06B)",
                d: "M1 9.75a3.15 3.15 0 0 0 2.8 3.13v.02h8.4v-.02a3.15 3.15 0 0 0 .533-6.155 4.902 4.902 0 0 0-9.466 0A3.151 3.151 0 0 0 1 9.75Zm5.85-1.8a.669.669 0 1 0-.946.946l1.15 1.15a.67.67 0 0 0 .946 0l2.096-2.096a.67.67 0 1 0-.946-.946L7.527 8.627 6.85 7.95Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }))
    });
const $7a25946f9b14c935$export$814ebe75b826c47b = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "a",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-success, #22A06B)",
                d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-success, #22A06B)",
                d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                mask: "url(#a)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-success, #22A06B)",
                d: "M6.8 7.9 7 8l.6.6L9 7.2a.6.6 0 1 1 .8.8L8 9.8a.6.6 0 0 1-.8 0l-1-1a.6.6 0 0 1 .6-1Z"
            }))
    });
const $7a25946f9b14c935$export$22f2b1620b38359 = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: ".01"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.88a3.15 3.15 0 0 1-.53-6.15 4.9 4.9 0 0 1 9.46 0 3.15 3.15 0 0 1-.53 6.15v.02H3.8v-.02Zm3.55-6.63a.75.75 0 0 1 1.5 0v2a.75.75 0 0 1-1.5 0v-2ZM8.1 9.5a.75.75 0 1 0 0 1.5.75.75 0 0 0 0-1.5Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            }))
    });
const $7a25946f9b14c935$export$5b461fe0712c5c45 = ({ size: size, label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        size: size,
        label: label,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 16 16",
                width: "16",
                height: "16",
                fill: "none"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-inverse, #FFFFFF)",
                d: "M0 0h16v16H0z",
                fillOpacity: "0"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("mask", {
                id: "a",
                fill: "var(--ds-icon-inverse, #FFFFFF)"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.9a3.2 3.2 0 0 1-.5-6.2 4.9 4.9 0 0 1 9.4 0 3.2 3.2 0 0 1-.5 6.2H3.8Z",
                clipRule: "evenodd",
                fillRule: "evenodd"
            })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
                fill: "var(--ds-icon-danger, #C9372C)",
                d: "M3.8 12.9h1.5v-1.4L4 11.4l-.2 1.5Zm-.5-6.2.4 1.5.8-.3.2-.8-1.4-.4Zm9.4 0-1.4.4.2.8.8.3.4-1.5Zm-.5 6.2-.2-1.5-1.3.1V13h1.5Zm0 0v1.5h1.5v-1.5h-1.5Zm-8.4 0H2.3v1.5h1.5v-1.5Zm.2-1.5c-.9-.1-1.5-.8-1.5-1.7h-3c0 2.4 1.8 4.4 4.1 4.7l.4-3ZM2.5 9.7c0-.7.5-1.3 1.2-1.5l-.9-3C1 5.9-.5 7.7-.5 9.8h3Zm2.2-2.6A3.4 3.4 0 0 1 8 4.6v-3c-3 0-5.4 2-6.2 4.7l3 .8ZM8 4.6c1.6 0 2.9 1 3.3 2.5l2.9-.8A6.4 6.4 0 0 0 8 1.6v3Zm4.3 3.6c.7.2 1.2.8 1.2 1.5h3c0-2-1.4-3.9-3.3-4.4l-.9 2.9Zm1.2 1.5c0 .9-.6 1.6-1.5 1.7l.4 3a4.7 4.7 0 0 0 4.1-4.7h-3ZM10.7 13h3-3Zm1.5-1.5H3.8v3h8.4v-3Zm-6.9 1.5h-3 3Z",
                mask: "url(#a)"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "1.5",
                height: "3.5",
                x: "7.4",
                y: "5.5",
                fill: "var(--ds-icon-danger, #C9372C)",
                rx: ".8"
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
                width: "1.5",
                height: "1.5",
                x: "7.4",
                y: "9.5",
                fill: "var(--ds-icon-danger, #C9372C)",
                rx: ".8"
            }))
    });

});

parcelRegister("lXSZ8", function(module, exports) {

$parcel$export(module.exports, "default", () => $bacacc98904ab4af$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $bacacc98904ab4af$var$DesignIconSVG = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentcolor",
        d: "M9.864 10.736c.77-.746 1.893-.536 2.72.265.826.8 1.043 1.888.273 2.634-1.816 1.76-5.482 2.002-4.765 1.207 1.587-1.76.578-2.949 1.772-4.106M19.968 4.03c.402.378-3.1 4.732-4.427 5.98-.659.62-1.012.826-1.276 1.016-.115.082-.15-.027-.177-.076a3.7 3.7 0 0 0-.63-.801c-.236-.222-.607-.445-.867-.572-.053-.025-.169-.058-.08-.166.201-.249.421-.58 1.08-1.2 1.327-1.247 5.974-4.56 6.377-4.181M18.38 19.946a1 1 0 0 1-.332.054.95.95 0 0 1-.913-.628c-.343-.957-1.14-1.642-2.257-1.933-2.182-.568-3.22-.264-5.053.995l-.16.11a9 9 0 0 1-1.049.644c-1.477.755-2.632.825-3.482.419-.586-.28-.989-.794-1.1-1.407-.254-1.403.93-2.647 2.602-3.156a.906.906 0 0 1 1.155.601.92.92 0 0 1-.62 1.186c-.33.1-.717.311-.978.533-.195.165-.33.355-.306.434.042.138.088.185.16.214.155.063.445.029.818-.096q.247-.083.524-.21c.196-.088.348-.165.58-.287.076-.04.177-.11.445-.303 1.09-.784 1.802-1.198 2.845-1.52 1.562-.482 3.18-.39 4.802.272 1.399.57 2.399 1.589 2.883 2.94.174.483-.07.97-.564 1.138"
    }));
const $bacacc98904ab4af$var$DesignIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        ...props,
        glyph: $bacacc98904ab4af$var$DesignIconSVG
    });
var $bacacc98904ab4af$export$2e2bcd8739ae039 = $bacacc98904ab4af$var$DesignIcon;

});

parcelRegister("7IEKg", function(module, exports) {

$parcel$export(module.exports, "designModalEntryPoint", () => $1a95bcb1a4c0b956$export$b98395a806b85a49);

var $69fJl = parcelRequire("69fJl");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1a95bcb1a4c0b956$export$b98395a806b85a49 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("b751e")), {
        moduleId: "576d28f0"
    }),
    getPreloadProps: ({ siteAri: siteAri, issueAri: issueAri, cloudId: cloudId, designAri: designAri })=>({
            queries: {
                designModal: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $69fJl.default),
                    variables: {
                        siteAri: siteAri,
                        issueAri: issueAri,
                        cloudId: cloudId,
                        designAri: designAri
                    }
                }
            }
        })
});

});
parcelRegister("69fJl", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20e9923143cad3f$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1775dc6f451f5aa08f2de993d8e993cc>>
 * @relayHash f75963656ac83b6e4f5b855b41942d4f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b
const $c20e9923143cad3f$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "5455aa42cc5ba971a154b4555e76f70cb6faf70a0f41a193d62856efb789841b",
        "metadata": {},
        "name": "ui_DesignModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $c20e9923143cad3f$export$2e2bcd8739ae039 = $c20e9923143cad3f$var$node;

});

parcelRegister("b751e", function(module, exports) {

let $81743dcfcda247f8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $81743dcfcda247f8$var$load("a5wLx").then(()=>parcelRequire('ebk7x'));

});


parcelRegister("fcSLY", function(module, exports) {

$parcel$export(module.exports, "DevInfoDetailsPopupSkeleton", () => $035c776c62f1033d$export$9044eba4855892a5);
/* DevInfoDetailsPopupSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $3MeBY = parcelRequire("3MeBY");

var $6lSRL = parcelRequire("6lSRL");

var $46wcL = parcelRequire("46wcL");

var $ifLw4 = parcelRequire("ifLw4");

var $khjtp = parcelRequire("khjtp");
// Try to keep SPA JS bundle as small as possible, skeletons should not have dependencies, so here we use hard coding instead of import gridSize
const $035c776c62f1033d$var$customCssStyles = null;
const $035c776c62f1033d$var$skeletonStyles = null;
const $035c776c62f1033d$export$ae7439e01588d047 = {
    BRANCH: 'branch',
    COMMIT: 'commit',
    PULLREQUEST: 'pullrequest',
    DEPLOYMENT: 'deployment',
    DESIGN: 'design'
};
const $035c776c62f1033d$var$skeletonAsset = {
    [$035c776c62f1033d$export$ae7439e01588d047.BRANCH]: (0, (/*@__PURE__*/$parcel$interopDefault($3MeBY))),
    [$035c776c62f1033d$export$ae7439e01588d047.COMMIT]: (0, (/*@__PURE__*/$parcel$interopDefault($6lSRL))),
    [$035c776c62f1033d$export$ae7439e01588d047.PULLREQUEST]: (0, (/*@__PURE__*/$parcel$interopDefault($khjtp))),
    [$035c776c62f1033d$export$ae7439e01588d047.DEPLOYMENT]: (0, (/*@__PURE__*/$parcel$interopDefault($46wcL))),
    [$035c776c62f1033d$export$ae7439e01588d047.DESIGN]: (0, (/*@__PURE__*/$parcel$interopDefault($ifLw4)))
};
const $035c776c62f1033d$export$9044eba4855892a5 = ({ devinfoType: devinfoType })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.BRANCH && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.COMMIT && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.PULLREQUEST && "_1bsbnklw _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi _4t3imgvx",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.DEPLOYMENT && "_1bsbnklw _4t3i1lit",
            devinfoType === $035c776c62f1033d$export$ae7439e01588d047.DESIGN && "_1bsbnklw _4t3i1lit _ca0qze3t _u5f3pxbi _n3tdze3t _19bvpxbi _vchhusvi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: $035c776c62f1033d$var$skeletonAsset[devinfoType],
        className: (0, $bwpsq.default)([
            "_1wgmglyw _rcujmgjw"
        ])
    }));

});
parcelRegister("3MeBY", function(module, exports) {
module.exports = new URL("branch-details-popup.tpl.90980aef.svg", import.meta.url).toString();

});

parcelRegister("6lSRL", function(module, exports) {
module.exports = new URL("commit-details-popup.tpl.ef7b25c8.svg", import.meta.url).toString();

});

parcelRegister("46wcL", function(module, exports) {
module.exports = new URL("deployment-details-popup.tpl.d0e045e6.svg", import.meta.url).toString();

});

parcelRegister("ifLw4", function(module, exports) {
module.exports = new URL("design-details-popup.tpl.da785a24.svg", import.meta.url).toString();

});

parcelRegister("khjtp", function(module, exports) {
module.exports = new URL("pr-details-popup.tpl.2fd71422.svg", import.meta.url).toString();

});


parcelRegister("kfztd", function(module, exports) {

$parcel$export(module.exports, "isDevopsFeatureDisabledInFedRamp", () => $064393a36b21cb6e$export$18bfef4995ec57b7);

var $aIZdc = parcelRequire("aIZdc");
const $064393a36b21cb6e$export$18bfef4995ec57b7 = ()=>(0, $aIZdc.isFedRamp)();

});

parcelRegister("gicL9", function(module, exports) {

$parcel$export(module.exports, "HOVER_TIMEOUT_MS", () => $045105c41d1dfec6$export$bbec45119b804b4d);
$parcel$export(module.exports, "DevInfoButtonLabelMapping", () => $045105c41d1dfec6$export$41f3316f17440396);
$parcel$export(module.exports, "iconColor", () => $045105c41d1dfec6$export$3797a580396e3639);
$parcel$export(module.exports, "experienceDetails", () => $045105c41d1dfec6$export$ba2604b0fdde2542);
$parcel$export(module.exports, "metrics", () => $045105c41d1dfec6$export$b0c5c2fac8144e54);
$parcel$export(module.exports, "packageDetails", () => $045105c41d1dfec6$export$48b44d9f3c6e15de);
$parcel$export(module.exports, "popupEntryPoints", () => $045105c41d1dfec6$export$1452632269dce6);
$parcel$export(module.exports, "DeploymentState", () => $045105c41d1dfec6$export$a12a01ce2571070a);
$parcel$export(module.exports, "DeploymentEnvironment", () => $045105c41d1dfec6$export$618f130aff825d2b);

var $8QpSo = parcelRequire("8QpSo");

var $4Dm5W = parcelRequire("4Dm5W");

var $6KTxo = parcelRequire("6KTxo");

var $8YTUU = parcelRequire("8YTUU");

var $6dYOr = parcelRequire("6dYOr");

var $jH32b = parcelRequire("jH32b");

var $890PS = parcelRequire("890PS");

var $4Dyci = parcelRequire("4Dyci");

var $8GnxT = parcelRequire("8GnxT");
const $045105c41d1dfec6$export$bbec45119b804b4d = 300;
const $045105c41d1dfec6$export$41f3316f17440396 = (0, $8QpSo.default)((formatMessage)=>({
        [(0, $8YTUU.DevInfoTypes).BRANCH]: formatMessage((0, $4Dyci.default).branchIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).COMMIT]: formatMessage((0, $4Dyci.default).commitIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).MERGED]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DECLINED]: formatMessage((0, $4Dyci.default).pullRequestIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: formatMessage((0, $4Dyci.default).deploymentIconButtonLabel),
        [(0, $8YTUU.DevInfoTypes).DESIGN]: formatMessage((0, $4Dyci.default).designIconButtonLabel)
    }));
const $045105c41d1dfec6$export$3797a580396e3639 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    },
    [(0, $8YTUU.DevInfoTypes).MERGED]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-success, #22A06B)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-success, #22A06B)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-success, #22A06B)"
    },
    [(0, $8YTUU.DevInfoTypes).DECLINED]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-danger, #C9372C)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-danger, #C9372C)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-danger, #C9372C)"
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        [(0, $8YTUU.ButtonStatus).ACTIVE]: "var(--ds-icon-inverse, #FFFFFF)",
        [(0, $8YTUU.ButtonStatus).HOVER]: "var(--ds-icon-subtle, #626F86)",
        [(0, $8YTUU.ButtonStatus).DEFAULT]: "var(--ds-icon-subtle, #626F86)"
    }
};
const $045105c41d1dfec6$export$ba2604b0fdde2542 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        id: 'branchDetailsPopup',
        name: 'jiraSoftwareBoardBranchDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        id: 'commitDetailsPopup',
        name: 'jiraSoftwareBoardCommitDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        id: 'deploymentDetailsPopup',
        name: 'jiraSoftwareBoardDeploymentDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        id: 'prDetailsPopup',
        name: 'jiraSoftwareBoardPrDetailsPopup'
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        id: 'designDetailsPopup',
        name: 'jiraSoftwareBoardDesignDetailsPopup'
    }
};
const $045105c41d1dfec6$export$b0c5c2fac8144e54 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: (0, $8GnxT.branchDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $8GnxT.commitDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: (0, $8GnxT.deploymentDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $8GnxT.prDetailsPopupLoad),
    [(0, $8YTUU.DevInfoTypes).DESIGN]: (0, $8GnxT.designDetailsPopupLoad)
};
const $045105c41d1dfec6$export$48b44d9f3c6e15de = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: {
        id: 'renderBranchDetailsPopup',
        packageName: 'jiraDevelopmentBoardBranchDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).COMMIT]: {
        id: 'renderCommitDetailsPopup',
        packageName: 'jiraDevelopmentBoardCommitDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: {
        id: 'renderDeploymentDetailsPopup',
        packageName: 'jiraDevelopmentBoardDeploymentDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: {
        id: 'renderPRDetailsPopup',
        packageName: 'jiraDevelopmentBoardPrDetailsPopup',
        teamName: 'nova'
    },
    [(0, $8YTUU.DevInfoTypes).DESIGN]: {
        id: 'renderDesignDetailsPopup',
        packageName: 'jiraDevelopmentBoardDesignDetailsPopup',
        teamName: 'helios-headcoach'
    }
};
const $045105c41d1dfec6$export$1452632269dce6 = {
    [(0, $8YTUU.DevInfoTypes).BRANCH]: (0, $4Dm5W.branchDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).COMMIT]: (0, $6KTxo.commitDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).DEPLOYMENT]: (0, $6dYOr.deploymentDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).PULLREQUEST]: (0, $890PS.pullRequestDetailsEntryPoint),
    [(0, $8YTUU.DevInfoTypes).DESIGN]: (0, $jH32b.designDetailsEntryPoint)
};
const $045105c41d1dfec6$export$a12a01ce2571070a = Object.freeze({
    SUCCESSFUL: 'SUCCESSFUL',
    FAILED: 'FAILED'
});
const $045105c41d1dfec6$export$618f130aff825d2b = Object.freeze({
    PRODUCTION: 'PRODUCTION',
    STAGING: 'STAGING',
    TESTING: 'TESTING'
});

});
parcelRegister("4Dm5W", function(module, exports) {

$parcel$export(module.exports, "branchDetailsEntryPoint", () => $36e1f5ea1b2544c9$export$4e1fb223e6b994ad);

var $8lY7K = parcelRequire("8lY7K");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $36e1f5ea1b2544c9$export$4e1fb223e6b994ad = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("ipjUl")), {
        moduleId: "24c6676c"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                branchDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $8lY7K.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("8lY7K", function(module, exports) {

$parcel$export(module.exports, "default", () => $1485287fd69790ca$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<53221fefa0f4443cf65a4215c479359b>>
 * @relayHash 369bf10bb8009c658a35cf0bdf685efa
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6
const $1485287fd69790ca$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "50d8c5a327ce393f92430f04532d211b7f0cc460a938b554e063e4a413b3c9b6",
        "metadata": {},
        "name": "mainJiraBoardFetchBranchDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $1485287fd69790ca$export$2e2bcd8739ae039 = $1485287fd69790ca$var$node;

});

parcelRegister("ipjUl", function(module, exports) {

let $d66a01121c677158$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d66a01121c677158$var$load("lcY00").then(()=>parcelRequire('93XNc'));

});


parcelRegister("6KTxo", function(module, exports) {

$parcel$export(module.exports, "commitDetailsEntryPoint", () => $9842290edc643ca7$export$543707906869c79b);

var $kmK4e = parcelRequire("kmK4e");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $9842290edc643ca7$export$543707906869c79b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("bdUYl")), {
        moduleId: "c43c4a0f"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                commitDetailsForIssue: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $kmK4e.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("kmK4e", function(module, exports) {

$parcel$export(module.exports, "default", () => $e1a92de7c94d3b0d$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<1084bead4ae00878b2af2c8348929c25>>
 * @relayHash eed264a6d119fbca146eb1de817b2b96
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b
const $e1a92de7c94d3b0d$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "2ca7f0754b23691dc5194f86cd173cbad109ceb27dcdfea5465741efb60afa5b",
        "metadata": {},
        "name": "mainJiraBoardFetchCommitDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $e1a92de7c94d3b0d$export$2e2bcd8739ae039 = $e1a92de7c94d3b0d$var$node;

});

parcelRegister("bdUYl", function(module, exports) {

let $82bd1a2348ffaf0f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $82bd1a2348ffaf0f$var$load("dROov").then(()=>parcelRequire('1ml2E'));

});


parcelRegister("6dYOr", function(module, exports) {

$parcel$export(module.exports, "deploymentDetailsEntryPoint", () => $f735f9faccd14399$export$bb44df517ead129f);

var $k022a = parcelRequire("k022a");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $f735f9faccd14399$export$bb44df517ead129f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("g56zb")), {
        moduleId: "12f43749"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                deployments: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $k022a.default,
                    variables: {
                        issueAris: [
                            issueId
                        ]
                    }
                }
            }
        })
});

});
parcelRegister("k022a", function(module, exports) {

$parcel$export(module.exports, "default", () => $efb931bb8db9b600$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<ae0585790b98faa6f42e78cd820a35d3>>
 * @relayHash 14ad3dca732756dca6246ef351d7319c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7c7de3e7f6623bcc94de30375e35240729aa179a60490aef983d5b1350f9cd75
const $efb931bb8db9b600$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "7c7de3e7f6623bcc94de30375e35240729aa179a60490aef983d5b1350f9cd75",
        "metadata": {},
        "name": "uiDevOpsBoardQuery",
        "operationKind": "query",
        "text": null
    }
};
var $efb931bb8db9b600$export$2e2bcd8739ae039 = $efb931bb8db9b600$var$node;

});

parcelRegister("g56zb", function(module, exports) {

let $bb5234f14bef38f6$var$load = (parcelRequire("28QjX"))(4);
module.exports = $bb5234f14bef38f6$var$load("bUzCQ").then(()=>parcelRequire('asD4H'));

});


parcelRegister("jH32b", function(module, exports) {

$parcel$export(module.exports, "designDetailsEntryPoint", () => $4f00e6184ecff192$export$9b838851ea165d28);

var $cN09Q = parcelRequire("cN09Q");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $4f00e6184ecff192$export$9b838851ea165d28 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("gNfHg")), {
        moduleId: "b9d22806"
    }),
    getPreloadProps: ({ issueId: issueId })=>({
            queries: {
                designDetailsPopup: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $cN09Q.default,
                    variables: {
                        issueAri: issueId
                    }
                }
            }
        })
});

});
parcelRegister("cN09Q", function(module, exports) {

$parcel$export(module.exports, "default", () => $37545b8a0156af47$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<5b69286dc3d574c4254b644a20345969>>
 * @relayHash 19dd9f9578703995725a17532527b663
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db
const $37545b8a0156af47$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "f1f10befcdb537dd4ab4ac9c44e5edcb51d6b3f4306fd285cc82de529ebae8db",
        "metadata": {},
        "name": "uiDesignDetailsPopupQuery",
        "operationKind": "query",
        "text": null
    }
};
var $37545b8a0156af47$export$2e2bcd8739ae039 = $37545b8a0156af47$var$node;

});

parcelRegister("gNfHg", function(module, exports) {

let $c39d6606de9ea3e8$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c39d6606de9ea3e8$var$load("6FreV").then(()=>parcelRequire('9bEVC'));

});


parcelRegister("890PS", function(module, exports) {

$parcel$export(module.exports, "pullRequestDetailsEntryPoint", () => $0896cca9b8d893af$export$37ab544e7066c095);

var $5E8Mw = parcelRequire("5E8Mw");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $0896cca9b8d893af$export$37ab544e7066c095 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aZi5Z")), {
        moduleId: "1b74db53"
    }),
    getPreloadProps: ({ issueId: issueId, isNetworkOnly: isNetworkOnly = false })=>({
            queries: {
                pullRequestDetailsForIssue: {
                    options: {
                        fetchPolicy: isNetworkOnly ? 'network-only' : 'store-and-network'
                    },
                    parameters: $5E8Mw.default,
                    variables: {
                        issueId: issueId
                    }
                }
            }
        })
});

});
parcelRegister("5E8Mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a4d40ac042e33e2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<e18ba82933463bea77a039cb31341c83>>
 * @relayHash ec62760f3d36372780325706797b1fb2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0
const $6a4d40ac042e33e2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "91484d5c2ad4c1c580a3b56066bfe36c5fe9798b2804e958c3c96ecd098886b0",
        "metadata": {},
        "name": "mainJiraBoardFetchPullRequestDetailsForIssueQuery",
        "operationKind": "query",
        "text": null
    }
};
var $6a4d40ac042e33e2$export$2e2bcd8739ae039 = $6a4d40ac042e33e2$var$node;

});

parcelRegister("aZi5Z", function(module, exports) {

let $7ffda351df524733$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7ffda351df524733$var$load("aefuM").then(()=>parcelRequire('cnLAn'));

});


parcelRegister("4Dyci", function(module, exports) {

$parcel$export(module.exports, "default", () => $436dc0db7ef24cd0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $436dc0db7ef24cd0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    branchIconLabel: {
        "id": "development-board-dev-info-icon.branch-icon-label",
        "defaultMessage": "branch"
    },
    commitIconLabel: {
        "id": "development-board-dev-info-icon.commit-icon-label",
        "defaultMessage": "commit"
    },
    designIconLabel: {
        "id": "development-board-dev-info-icon.design-icon-label",
        "defaultMessage": "Linked design data"
    },
    deploymentIconLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-label",
        "defaultMessage": "Linked deployment data."
    },
    deploymentProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-success-icon-label",
        "defaultMessage": "Successful deployment to production."
    },
    deploymentProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-production-failed-icon-label",
        "defaultMessage": "Failed deployment to production."
    },
    deploymentNonProductionSuccessIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-success-icon-label",
        "defaultMessage": "Successful deployment to non-production environment."
    },
    deploymentNonProductionFailedIconLabel: {
        "id": "development-board-dev-info-icon.deployment-non-production-failed-icon-label",
        "defaultMessage": "Failed deployment to non-production environment."
    },
    openPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.open-pull-request-icon-label",
        "defaultMessage": "pull request"
    },
    mergedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.merged-pull-request-icon-label",
        "defaultMessage": "merged pull request"
    },
    declinedPullRequestIconLabel: {
        "id": "development-board-dev-info-icon.declined-pull-request-icon-label",
        "defaultMessage": "declined pull request"
    },
    branchIconButtonLabel: {
        "id": "development-board-dev-info-icon.branch-icon-button-label",
        "defaultMessage": "Select to open branch details."
    },
    commitIconButtonLabel: {
        "id": "development-board-dev-info-icon.commit-icon-button-label",
        "defaultMessage": "Select to open commit details."
    },
    pullRequestIconButtonLabel: {
        "id": "development-board-dev-info-icon.pull-request-icon-button-label",
        "defaultMessage": "Select to open pull request details."
    },
    deploymentIconButtonLabel: {
        "id": "development-board-dev-info-icon.deployment-icon-button-label",
        "defaultMessage": "Select to open deployment details."
    },
    designIconButtonLabel: {
        "id": "development-board-dev-info-icon.design-icon-button-label",
        "defaultMessage": "Select to open design details."
    }
});

});

parcelRegister("8GnxT", function(module, exports) {

$parcel$export(module.exports, "branchDetailsPopupLoad", () => $a8d6a72aae83d56f$export$1e45f095e94fd8a);
$parcel$export(module.exports, "commitDetailsPopupLoad", () => $a8d6a72aae83d56f$export$e3af05dcf8f03d06);
$parcel$export(module.exports, "deploymentDetailsPopupLoad", () => $a8d6a72aae83d56f$export$205c7cad3de97a2);
$parcel$export(module.exports, "prDetailsPopupLoad", () => $a8d6a72aae83d56f$export$3ca761127f6f2822);
$parcel$export(module.exports, "designDetailsPopupLoad", () => $a8d6a72aae83d56f$export$935f70f8029ab734);

var $dGrdR = parcelRequire("dGrdR");
const $a8d6a72aae83d56f$export$1e45f095e94fd8a = (0, $dGrdR.metrics).interaction({
    key: 'board.branch-details-popup-load'
});
const $a8d6a72aae83d56f$export$e3af05dcf8f03d06 = (0, $dGrdR.metrics).interaction({
    key: 'board.commit-details-popup-load'
});
const $a8d6a72aae83d56f$export$205c7cad3de97a2 = (0, $dGrdR.metrics).interaction({
    key: 'board.deployment-details-popup-load'
});
const $a8d6a72aae83d56f$export$3ca761127f6f2822 = (0, $dGrdR.metrics).interaction({
    key: 'board.pr-details-popup-load'
});
const $a8d6a72aae83d56f$export$935f70f8029ab734 = (0, $dGrdR.metrics).interaction({
    key: 'board.design-details-popup-load'
});

});



parcelRegister("8phmQ", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_DEV_STATUSES", () => $688d85ce74250816$export$10747a90e85a7b42);
const $688d85ce74250816$export$5798ea324a4dbe0e = 'branch';
const $688d85ce74250816$export$3d5e90ff634296d7 = 'commit';
const $688d85ce74250816$export$986d2ff2c9fcfdae = 'pullrequest';
const $688d85ce74250816$export$2fda0856fe66a3c9 = 'declined';
const $688d85ce74250816$export$26d1e2e6f089e8e4 = 'merged';
const $688d85ce74250816$export$1d7b9dd92d94f047 = 'deployment';
const $688d85ce74250816$export$a568421f41916e78 = 'design';
const $688d85ce74250816$export$10747a90e85a7b42 = [
    $688d85ce74250816$export$5798ea324a4dbe0e,
    $688d85ce74250816$export$3d5e90ff634296d7,
    $688d85ce74250816$export$986d2ff2c9fcfdae,
    $688d85ce74250816$export$2fda0856fe66a3c9,
    $688d85ce74250816$export$26d1e2e6f089e8e4,
    $688d85ce74250816$export$1d7b9dd92d94f047,
    $688d85ce74250816$export$a568421f41916e78
];

});


parcelRegister("akGDz", function(module, exports) {

$parcel$export(module.exports, "CardEstimate", () => $9413a1b03685da5e$export$b243ada76671bb54);
$parcel$export(module.exports, "Container", () => $9413a1b03685da5e$export$42a852a2b6b56249);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $16T6Y = parcelRequire("16T6Y");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");
const $9413a1b03685da5e$export$b243ada76671bb54 = (props)=>{
    const { estimate: estimate, units: units } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let tooltipContent = null;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(units)) tooltipContent = estimate;
    else if (typeof units === 'string') tooltipContent = `${estimate} ${units}`;
    else tooltipContent = formatMessage(units, {
        value: estimate
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9413a1b03685da5e$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent,
        testId: "platform-card.common.ui.estimate.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "default",
        testId: "platform-card.common.ui.estimate.badge"
    }, estimate.toString())));
};
var $9413a1b03685da5e$export$2e2bcd8739ae039 = $9413a1b03685da5e$export$b243ada76671bb54;
const $9413a1b03685da5e$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("l1jvZ", function(module, exports) {

$parcel$export(module.exports, "CardLozenge", () => $4fdae51feb9c93fe$export$a89483470d2d782c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $7SCny = parcelRequire("7SCny");

var $iHPnC = parcelRequire("iHPnC");
const $4fdae51feb9c93fe$export$a89483470d2d782c = (props)=>{
    const { color: color, children: children } = props;
    const epicLozengeStyle = color && $4fdae51feb9c93fe$var$epicLozengeThemes[color] || undefined; /* eslint-disable jira/react/no-style-attribute */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fdae51feb9c93fe$export$42a852a2b6b56249, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fdae51feb9c93fe$var$LozengeContainer, {
        style: epicLozengeStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4fdae51feb9c93fe$var$LozengeContent, null, children)));
/* eslint-enable jira/react/no-style-attribute */ };
$4fdae51feb9c93fe$export$a89483470d2d782c.defaultProps = {
    // not using tokens - this is a key to get predefined color schema, not actual color string
    color: (0, $7SCny.PURPLE)
};
var $4fdae51feb9c93fe$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $4fdae51feb9c93fe$export$a89483470d2d782c;
const $4fdae51feb9c93fe$var$ContainerControl = /*#__PURE__*/ (0, $47bDC.default).span.withConfig({
    componentId: "l1vxah-0"
})({
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'flex-start',
    alignItems: 'center',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors
    '& span': {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/use-tokens-typography -- Ignored via go/DSP-18766
        lineHeight: `${(0, $gwIPs.gridSize) * 2}px`
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fdae51feb9c93fe$var$ContainerExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq _1e0c1txw _1bah1y6m _4cvr1h6o _13t37vkz",
            __cmplp.className
        ])
    });
});
const $4fdae51feb9c93fe$export$42a852a2b6b56249 = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $4fdae51feb9c93fe$var$ContainerExperiment, $4fdae51feb9c93fe$var$ContainerControl);
const $4fdae51feb9c93fe$var$epicLozengeThemes = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fdae51feb9c93fe$var$LozengeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c81o8v _p12f1osq _k48pmoej _1p1dangw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4fdae51feb9c93fe$var$LozengeContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1o8l _1bto1l2s _s7n4jp4b _o5721q9c _vchhusvi _p12f1osq _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66",
            __cmplp.className
        ])
    });
});

});

parcelRegister("20vaL", function(module, exports) {

$parcel$export(module.exports, "CardPriority", () => $cc5d64f9a1c4db88$export$92d93d4ee23c212c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $jsE5o = parcelRequire("jsE5o");
const $cc5d64f9a1c4db88$export$92d93d4ee23c212c = (props)=>{
    const { name: name, uri: uri } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const priorityLevel = formatMessage((0, $jsE5o.default).priorityTooltip, {
        priorityLevel: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc5d64f9a1c4db88$var$Icon, {
        "data-testid": "platform-card.common.ui.priority.icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: priorityLevel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cc5d64f9a1c4db88$export$3e431a229df88919, {
        alt: priorityLevel,
        src: uri
    })));
};
var $cc5d64f9a1c4db88$export$2e2bcd8739ae039 = $cc5d64f9a1c4db88$export$92d93d4ee23c212c;
const $cc5d64f9a1c4db88$var$iconSize = (0, $gwIPs.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $cc5d64f9a1c4db88$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $cc5d64f9a1c4db88$export$3e431a229df88919 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jsE5o", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd4384d9d4bf039b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fd4384d9d4bf039b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityTooltip: {
        "id": "platform-ui-card.common.priority.priority-tooltip",
        "defaultMessage": "{priorityLevel} priority"
    }
});

});


parcelRegister("9yMbF", function(module, exports) {

$parcel$export(module.exports, "Card", () => $b4c35803d9223712$export$60332b2344f7fe41);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1NPPK = parcelRequire("1NPPK");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $az4zD = parcelRequire("az4zD");

var $cm8xi = parcelRequire("cm8xi");

var $fCMrQ = parcelRequire("fCMrQ");

var $fXjor = parcelRequire("fXjor");

var $7YpGJ = parcelRequire("7YpGJ");

var $4And4 = parcelRequire("4And4");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b4c35803d9223712$var$stopPropagation = (event)=>event.stopPropagation();
class $b4c35803d9223712$export$60332b2344f7fe41 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDisabled: false,
            isDone: false,
            isSelected: false,
            isFlagged: false,
            isLoading: false,
            persistActions: false,
            typeName: null,
            typeUri: null,
            cardKey: null,
            coverUri: null,
            cover: null,
            avatarName: null,
            avatarUri: null,
            icons: null,
            highlightText: [],
            actions: null,
            color: null,
            customFields: null,
            children: null,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onSizeChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            renderAssignee: undefined,
            isCMPBoard: false,
            isIPBoard: false,
            status: null,
            hasCompactIssueType: false,
            hasScenarioChanges: false,
            id: null,
            renderIssueLinksStats: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
        };
    }
    renderMenu() {
        const { actions: actions, isLoading: isLoading, persistActions: persistActions } = this.props;
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return !isLoading && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(actions) && // eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            testId: "platform-card.ui.card.actions-section",
            "data-component-selector": $b4c35803d9223712$var$ACTIONS_SECTION_CONTENT_SELECTOR,
            onClick: $b4c35803d9223712$var$stopPropagation,
            xcss: [
                $b4c35803d9223712$var$actionsSectionStyles,
                persistActions ? $b4c35803d9223712$var$visibilityStyles.initial : $b4c35803d9223712$var$visibilityStyles.hidden
            ]
        }, actions);
        return !isLoading && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(actions) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4c35803d9223712$var$ActionsSection, {
            "data-test-id": "platform-card.ui.card.actions-section",
            "data-testid": "platform-card.ui.card.actions-section",
            persistActions: persistActions,
            onClick: $b4c35803d9223712$var$stopPropagation
        }, actions);
    }
    renderCardColor() {
        const { color: color, hasScenarioChanges: hasScenarioChanges, isIPBoard: isIPBoard } = this.props; /**
                     * In increment planning boards, we render the card color only if the issue:
                     * * is a new issue created in Plans that doesn't yet exist in Jira
                     * * has scenario changes not yet saved to Jira
                     *
                     * The card color is wrapped with a tooltip to inform the user about the fact that
                     * changes only exist in Plans and need to be saved to Jira to be reflected there.
                     */ 
        if (isIPBoard) {
            if (hasScenarioChanges) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4And4.default).scenarioChangeTooltip)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
                color: color
            }));
            return null;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: color
        });
    }
    render() {
        const { isDisabled: isDisabled, isDone: isDone, isFlagged: isFlagged, isSelected: isSelected, isFlexible: isFlexible, isLoading: isLoading, summary: summary, typeName: typeName, typeUri: typeUri, cardKey: cardKey, cardRef: cardRef, cardContainerRef: cardContainerRef, coverUri: coverUri, cover: cover, color: color, customFields: customFields, avatarName: avatarName, avatarUri: avatarUri, icons: icons, highlightText: highlightText, children: children, onSizeChange: onSizeChange, onBlur: onBlur, onFocus: onFocus, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, renderSummary: renderSummary, renderAssignee: renderAssignee, isCMPBoard: isCMPBoard, isIPBoard: isIPBoard, status: status, hasCompactIssueType: hasCompactIssueType, renderIssueLinksStats: renderIssueLinksStats, id: id, hasScenarioChanges: hasScenarioChanges, fixVersions: fixVersions } = this.props;
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCMrQ.Theme).Provider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NPPK.default).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCMrQ.Theme).Consumer, {
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFlagged: isFlagged,
                mode: mode
            }, ({ backgroundColor: backgroundColor, textColor: textColor, hoverBackgroundColor: hoverBackgroundColor, hoverTextColor: hoverTextColor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4c35803d9223712$var$ContainerNew // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                , {
                    ref: cardContainerRef,
                    isDisabled: isDisabled,
                    isFlexible: Boolean(isFlexible),
                    textColor: textColor,
                    backgroundColor: backgroundColor,
                    hoverBackgroundColor: hoverBackgroundColor,
                    hoverTextColor: hoverTextColor
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7YpGJ.InteractionLayer), {
                    onClick: this.onClick,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    cardRef: cardRef,
                    summary: summary,
                    cardKey: cardKey
                }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXjor.CardContent), {
                    id: id,
                    isDone: isDone,
                    isFlagged: isFlagged,
                    isLoading: isLoading,
                    summary: summary,
                    typeName: typeName,
                    typeUri: typeUri,
                    cardKey: cardKey,
                    coverUri: coverUri,
                    cover: cover,
                    customFields: customFields,
                    avatarName: avatarName,
                    avatarUri: avatarUri,
                    icons: icons,
                    highlightText: highlightText,
                    onImageLoad: onSizeChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    shouldMenuRender: true,
                    renderSummary: renderSummary,
                    onClick: this.onClick,
                    isCMPBoard: isCMPBoard,
                    isIPBoard: isIPBoard,
                    status: status,
                    hasCompactIssueType: hasCompactIssueType,
                    renderAssignee: renderAssignee,
                    renderIssueLinksStats: renderIssueLinksStats,
                    color: color,
                    hasScenarioChanges: hasScenarioChanges,
                    fixVersions: fixVersions
                }, children), !isLoading && this.renderMenu()))));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCMrQ.Theme).Provider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NPPK.default).Consumer, null, ({ mode: mode })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fCMrQ.Theme).Consumer, {
                isDisabled: isDisabled,
                isSelected: isSelected,
                isFlagged: isFlagged,
                mode: mode
            }, (themeTokens)=>// eslint-disable-next-line styled-components-a11y/click-events-have-key-events, styled-components-a11y/no-static-element-interactions
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b4c35803d9223712$var$Container, {
                    ...themeTokens,
                    isDisabled: isDisabled,
                    isFlexible: isFlexible,
                    onClick: this.onClick,
                    tabIndex: 0,
                    onFocus: onFocus,
                    onBlur: onBlur,
                    onMouseEnter: onMouseEnter,
                    onMouseLeave: onMouseLeave,
                    innerRef: cardRef,
                    "data-test-id": "platform-card.ui.card.focus-container",
                    "data-testid": "platform-card.ui.card.focus-container"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fXjor.CardContent), {
                    id: id,
                    isDone: isDone,
                    isFlagged: isFlagged,
                    isLoading: isLoading,
                    summary: summary,
                    typeName: typeName,
                    typeUri: typeUri,
                    cardKey: cardKey,
                    coverUri: coverUri,
                    cover: cover,
                    customFields: customFields,
                    avatarName: avatarName,
                    avatarUri: avatarUri,
                    icons: icons,
                    highlightText: highlightText,
                    onImageLoad: onSizeChange ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                    shouldMenuRender: true,
                    renderSummary: renderSummary,
                    onClick: this.onClick,
                    isCMPBoard: isCMPBoard,
                    isIPBoard: isIPBoard,
                    status: status,
                    hasCompactIssueType: hasCompactIssueType,
                    renderAssignee: renderAssignee,
                    renderIssueLinksStats: renderIssueLinksStats,
                    color: color,
                    hasScenarioChanges: hasScenarioChanges,
                    fixVersions: fixVersions
                }, children), !isLoading && this.renderMenu()))));
    }
    constructor(...args){
        super(...args), this.onClick = (event, externalAction)=>{
            const { isDisabled: isDisabled, onClick: onClick } = this.props;
            if (!isDisabled) onClick(event, externalAction);
        };
    }
}
var // @ts-expect-error - Argument of type 'typeof Card' is not assignable to parameter of type 'ComponentType<WithIntlProvided<CardProps>> & typeof Card'.
$b4c35803d9223712$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($b4c35803d9223712$export$60332b2344f7fe41);
const $b4c35803d9223712$var$EDIT_ICON_CONTENT_SELECTOR = 'issue-field-summary-inline-edit.ui.read.edit-icon';
const $b4c35803d9223712$var$STATIC_SUMMARY_CONTENT_SELECTOR = 'issue-field-summary-inline-edit.ui.read.static-summary';
const $b4c35803d9223712$var$EDITABLE_SUMMARY_CONTENT_SELECTOR = 'issue-field-summary-inline-edit.ui.read.editable-summary';
const $b4c35803d9223712$var$ACTIONS_SECTION_CONTENT_SELECTOR = 'issue-field-summary-inline-edit.ui.read.actions-section';
const $b4c35803d9223712$var$maxCardWidth = 270;
const $b4c35803d9223712$var$boxShadow = "var(--ds-shadow-raised, 0px 1px 1px #091E4240, 0px 0px 1px #091E424f)"; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $b4c35803d9223712$var$ActionsSection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m44sy3-0"
})((props)=>({
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.persistActions ? 'initial' : 'hidden',
        position: 'absolute',
        right: "var(--ds-space-100, 8px)",
        top: "var(--ds-space-100, 8px)",
        backgroundColor: "var(--ds-surface-raised, #FFFFFF)",
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        borderRadius: `${0, $gwIPs.borderRadius}px`
    }));
const $b4c35803d9223712$var$actionsSectionStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'auto',
    position: 'absolute',
    // @ts-expect-error Type '"var(--ds-UNSAFE-transparent)"' is not assignable to type '"color.background.accent.lime.subtlest" | "color.background.accent.lime.subtlest.hovered" | "color.background.accent.lime.subtlest.pressed" | "color.background.accent.lime.subtler" | ... 193 more ... | undefined'.
    backgroundColor: "var(--ds-UNSAFE-transparent, transparent)",
    borderRadius: 'border.radius',
    right: 'space.150',
    top: 'space.150'
}); // eslint-disable-next-line @atlaskit/design-system/no-css-tagged-template-expression
const $b4c35803d9223712$var$mixinVisibleActionsStyles = /*#__PURE__*/ (0, $47bDC.css)`${$b4c35803d9223712$var$ActionsSection}{visibility:visible;}`; // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b4c35803d9223712$var$Container = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1m44sy3-1"
})`cursor:pointer;user-select:none;box-sizing:border-box;display:flex;flex-direction:column;position:relative;margin:${"var(--ds-space-025, 2px)"} 0;border-radius:${(0, $gwIPs.borderRadius)}px;box-shadow:${$b4c35803d9223712$var$boxShadow};transition:background-color 140ms ease-in-out,color 140ms ease-in-out;background-color:${(props)=>props.backgroundColor};--jsw-card-background-color:${({ backgroundColor: backgroundColor, isDisabled: isDisabled })=>isDisabled ? "var(--ds-surface-raised, #FFFFFF)" : backgroundColor};color:${(props)=>props.textColor};filter:${(props)=>props.isDisabled ? 'grayscale(100%)' : 'none'};max-width:${(props)=>props.isFlexible ? '100%' : `${$b4c35803d9223712$var$maxCardWidth}px`};&:hover{background-color:${(props)=>props.hoverBackgroundColor};--jsw-card-background-color:${(props)=>props.hoverBackgroundColor};color:${(props)=>props.hoverTextColor};}&:focus{box-shadow:inset 0 0 0 ${(0, $gwIPs.gridSize) / 4}px ${"var(--ds-text-brand, #0C66E4)"};outline:none;}&:hover,&:focus,&:focus-within{${$b4c35803d9223712$var$mixinVisibleActionsStyles};[data-component-selector='${$b4c35803d9223712$var$STATIC_SUMMARY_CONTENT_SELECTOR}']{display:none;}[data-component-selector='${$b4c35803d9223712$var$EDITABLE_SUMMARY_CONTENT_SELECTOR}'],[data-component-selector='${$b4c35803d9223712$var$EDIT_ICON_CONTENT_SELECTOR}']{display:inline;}}`;
const $b4c35803d9223712$var$containerStyles = null; // Rename when cleaning up fix_jira_board_card_nested_interactive_elements
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-unsafe-values
const $b4c35803d9223712$var$ContainerNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor),
            "--_1qrlcdp": (0, $lD23V.default)(__cmplp.textColor),
            "--_1so9372": (0, $lD23V.default)(__cmplp.hoverBackgroundColor),
            "--_13t8k8z": (0, $lD23V.default)(__cmplp.hoverTextColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _v56419bn _lcxvglyw _80omtlke _uiztglyw _vchhusvi _1e0c1txw _2lx21bp4 _19pkv77o _16qszucj _bfhk3qkl _syazijt0 _nt751r31 _49pcglyw _1hvw1o36 _7ehi2cxi _irr3gm1p _30l31t6v _1itrewfl _zd1zewfl _1x9aewfl _128oglyw _1ae2glyw _192yglyw _1ont1nu9 _83tc1nu9 _1n4l1nu9 _1ryf1nu9 _fyi61nu9 _f8hb1nu9",
            __cmplp.isDisabled ? "_kdam7g3v" : "_kdamglyw",
            __cmplp.isFlexible ? "_p12f1osq" : "_p12f1ogy",
            __cmplp.className
        ])
    });
});
const $b4c35803d9223712$var$visibilityStyles = {
    initial: (0, $8CUq3.xcss)({
        visibility: 'initial'
    }),
    visible: (0, $8CUq3.xcss)({
        visibility: 'visible'
    }),
    hidden: (0, $8CUq3.xcss)({
        visibility: 'hidden'
    })
};

});
parcelRegister("fCMrQ", function(module, exports) {

$parcel$export(module.exports, "Theme", () => $54ad41c8d271f56c$export$14faa19a0f3bbeb2);

var $82itC = parcelRequire("82itC");

var $6cG4N = parcelRequire("6cG4N");

var $lmBAt = parcelRequire("lmBAt");

const $54ad41c8d271f56c$var$selectedDisabledAndDefaultThemeState = {
    [(0, $244c28c342c7cd47$export$21e4c437265127a0)]: {
        [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-selected, #E9F2FF)",
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-brand-bold, #0C66E4)"
        },
        [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
            // remove on cleanup - jira_theming_milestone_1
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-selected-hovered, #CCE0FF)",
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-neutral-bold-hovered, #2C3E5D)"
        },
        [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-selected-hovered, #CCE0FF)",
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-neutral-bold-hovered, #2C3E5D)"
        }
    },
    [(0, $244c28c342c7cd47$export$2c03afff1a06da0a)]: {
        [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-disabled, #091E4208)",
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-disabled, #091E4208)"
        },
        [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
            // remove on cleanup - jira_theming_milestone_1
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-disabled, #091E4208)",
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-disabled, #091E4208)"
        },
        [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-disabled, #091E4208)",
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-disabled, #091E4208)"
        }
    },
    [(0, $244c28c342c7cd47$export$d9c479c03363a52b)]: {
        [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-surface-raised, #FFFFFF)",
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-surface-raised, #FFFFFF)"
        },
        [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
            // remove on cleanup - jira_theming_milestone_1
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-neutral-subtle-hovered, #091E420F)",
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-neutral-bold-hovered, #2C3E5D)"
        },
        [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
            [(0, $244c28c342c7cd47$export$61582641a3c37669)]: (0, $6cG4N.Tokens).COLOR_BACKGROUND_NEUTRAL_SUBTLE_HOVERED_CONTRAST,
            [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-neutral-bold-hovered, #2C3E5D)"
        }
    }
};
const $54ad41c8d271f56c$var$cardTheme = {
    [(0, $244c28c342c7cd47$export$9c09a6bee099a4c9)]: {
        [(0, $244c28c342c7cd47$export$fe8539b22f3ed137)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-warning-pressed, #F5CD47)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-warning-pressed, #F5CD47)"
            },
            [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
                // remove on cleanup - jira_theming_milestone_1
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-warning-hovered, #F8E6A0)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-warning-hovered, #F8E6A0)"
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-warning-hovered, #F8E6A0)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-warning-hovered, #F8E6A0)"
            }
        },
        [(0, $244c28c342c7cd47$export$a64d05a08c3ad905)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-warning, #FFF7D6)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-warning, #FFF7D6)"
            },
            [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
                // remove on cleanup - jira_theming_milestone_1
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-warning-hovered, #F8E6A0)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-warning-hovered, #F8E6A0)"
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-background-warning-hovered, #F8E6A0)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-background-warning-hovered, #F8E6A0)"
            }
        },
        ...$54ad41c8d271f56c$var$selectedDisabledAndDefaultThemeState
    },
    [(0, $244c28c342c7cd47$export$7a5e3175d433dcb5)]: {
        [(0, $244c28c342c7cd47$export$fe8539b22f3ed137)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
                // remove on cleanup - jira_theming_milestone_1
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            }
        },
        [(0, $244c28c342c7cd47$export$a64d05a08c3ad905)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
                // remove on cleanup - jira_theming_milestone_1
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            }
        },
        [(0, $244c28c342c7cd47$export$21e4c437265127a0)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
                // remove on cleanup - jira_theming_milestone_1
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            }
        },
        [(0, $244c28c342c7cd47$export$2c03afff1a06da0a)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
                // remove on cleanup - jira_theming_milestone_1
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            }
        },
        [(0, $244c28c342c7cd47$export$d9c479c03363a52b)]: {
            [(0, $244c28c342c7cd47$export$d6fd561d6f3bd529)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)]: {
                // remove on cleanup - jira_theming_milestone_1
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            },
            [(0, $244c28c342c7cd47$export$b8f05781b7d4583c)]: {
                [(0, $244c28c342c7cd47$export$61582641a3c37669)]: "var(--ds-text, #172B4D)",
                [(0, $244c28c342c7cd47$export$af4146eb5bbb1672)]: "var(--ds-text, #172B4D)"
            }
        }
    }
};
const $54ad41c8d271f56c$var$getCssPropValue = ({ cssProp: cssProp, isSelected: isSelected = false, isFlagged: isFlagged = false, isDisabled: isDisabled = false, hoverState: hoverState = (0, $244c28c342c7cd47$export$d6fd561d6f3bd529), mode: mode })=>{
    if (isFlagged && isSelected) return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$fe8539b22f3ed137][hoverState][mode];
    if (isFlagged) return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$a64d05a08c3ad905][hoverState][mode];
    if (isSelected) return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$21e4c437265127a0][hoverState][mode];
    if (isDisabled) return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$2c03afff1a06da0a][hoverState][mode];
    return $54ad41c8d271f56c$var$cardTheme[cssProp][0, $244c28c342c7cd47$export$d9c479c03363a52b][hoverState][mode];
};
const $54ad41c8d271f56c$var$getBackgroundColor = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>$54ad41c8d271f56c$var$getCssPropValue({
        cssProp: (0, $244c28c342c7cd47$export$9c09a6bee099a4c9),
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDisabled: isDisabled,
        mode: mode
    });
const $54ad41c8d271f56c$var$getTextColor = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>$54ad41c8d271f56c$var$getCssPropValue({
        cssProp: (0, $244c28c342c7cd47$export$7a5e3175d433dcb5),
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDisabled: isDisabled,
        mode: mode
    });
const $54ad41c8d271f56c$var$getHoverBackgroundColor = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>$54ad41c8d271f56c$var$getCssPropValue({
        cssProp: (0, $244c28c342c7cd47$export$9c09a6bee099a4c9),
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDisabled: isDisabled,
        mode: mode,
        hoverState: (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $244c28c342c7cd47$export$b8f05781b7d4583c) : (0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)
    });
const $54ad41c8d271f56c$var$getHoverTextColor = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>$54ad41c8d271f56c$var$getCssPropValue({
        cssProp: (0, $244c28c342c7cd47$export$7a5e3175d433dcb5),
        isSelected: isSelected,
        isFlagged: isFlagged,
        isDisabled: isDisabled,
        mode: mode,
        hoverState: (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $244c28c342c7cd47$export$b8f05781b7d4583c) : (0, $244c28c342c7cd47$export$5b292a8ea9e4f1c9)
    });
const $54ad41c8d271f56c$var$defaultTheme = ({ isSelected: isSelected, isFlagged: isFlagged, isDisabled: isDisabled, mode: mode })=>({
        backgroundColor: $54ad41c8d271f56c$var$getBackgroundColor({
            isSelected: isSelected,
            isFlagged: isFlagged,
            isDisabled: isDisabled,
            mode: mode
        }),
        textColor: $54ad41c8d271f56c$var$getTextColor({
            isSelected: isSelected,
            isFlagged: isFlagged,
            isDisabled: isDisabled,
            mode: mode
        }),
        hoverBackgroundColor: $54ad41c8d271f56c$var$getHoverBackgroundColor({
            isSelected: isSelected,
            isFlagged: isFlagged,
            isDisabled: isDisabled,
            mode: mode
        }),
        hoverTextColor: $54ad41c8d271f56c$var$getHoverTextColor({
            isSelected: isSelected,
            isFlagged: isFlagged,
            isDisabled: isDisabled,
            mode: mode
        })
    });
const $54ad41c8d271f56c$export$14faa19a0f3bbeb2 = (0, $82itC.createTheme)($54ad41c8d271f56c$var$defaultTheme);

});
const $244c28c342c7cd47$export$61582641a3c37669 = 'light';
const $244c28c342c7cd47$export$af4146eb5bbb1672 = 'dark';
const $244c28c342c7cd47$export$fe8539b22f3ed137 = 'flaggedAndSelected';
const $244c28c342c7cd47$export$a64d05a08c3ad905 = 'flagged';
const $244c28c342c7cd47$export$21e4c437265127a0 = 'selected';
const $244c28c342c7cd47$export$2c03afff1a06da0a = 'disabled';
const $244c28c342c7cd47$export$d9c479c03363a52b = 'default';
const $244c28c342c7cd47$export$5b292a8ea9e4f1c9 = 'enterOld'; // remove on cleanup - jira_theming_milestone_1
const $244c28c342c7cd47$export$b8f05781b7d4583c = 'enter';
const $244c28c342c7cd47$export$d6fd561d6f3bd529 = 'leave';
const $244c28c342c7cd47$export$9c09a6bee099a4c9 = 'backgroundColor';
const $244c28c342c7cd47$export$7a5e3175d433dcb5 = 'textColor';
const $244c28c342c7cd47$export$b1cb468c302d21f9 = 'labels';


parcelRegister("fXjor", function(module, exports) {

$parcel$export(module.exports, "CardContent", () => $424382f922ab5f57$export$64ef9b8c11710c47);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $gccSB = parcelRequire("gccSB");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $4VpT2 = parcelRequire("4VpT2");

var $dCm1o = parcelRequire("dCm1o");


var $cPpj5 = parcelRequire("cPpj5");

var $cm8xi = parcelRequire("cm8xi");

var $7K6nB = parcelRequire("7K6nB");

var $bbQQn = parcelRequire("bbQQn");

var $gRghR = parcelRequire("gRghR");

var $8nii0 = parcelRequire("8nii0");

var $k3Hho = parcelRequire("k3Hho");

var $fsT6h = parcelRequire("fsT6h");

var $1vEOb = parcelRequire("1vEOb");

var $1NiGE = parcelRequire("1NiGE");

var $1d3ex = parcelRequire("1d3ex");

var $4And4 = parcelRequire("4And4");
const $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR = 'platform-card.ui.card.card-content.content-section'; // eslint-disable-next-line jira/react/no-class-components
class $424382f922ab5f57$export$64ef9b8c11710c47 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            isDone: false,
            isFlagged: false,
            isLoading: false,
            shouldMenuRender: false,
            typeName: null,
            typeUri: null,
            cardKey: null,
            coverUri: null,
            cover: null,
            avatarName: null,
            avatarUri: null,
            icons: null,
            highlightText: [],
            customFields: null,
            children: null,
            onImageLoad: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isCMPBoard: false,
            isIPBoard: false,
            status: null,
            hasCompactIssueType: false,
            color: null,
            hasScenarioChanges: false
        };
    }
    shouldRenderFooter() {
        const { isFlagged: isFlagged, isDone: isDone, typeName: typeName, typeUri: typeUri, cardKey: cardKey, icons: icons, avatarName: avatarName, avatarUri: avatarUri, isLoading: isLoading, renderAssignee: renderAssignee } = this.props;
        if ((0, $4R6GH.fg)('jira_view_settings_additional_fields')) return [
            isFlagged,
            typeName,
            typeUri,
            cardKey,
            avatarName,
            avatarUri,
            isLoading,
            renderAssignee,
            !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(icons) && icons.some((icon)=>!!icon)
        ].some((component)=>!!component);
        return [
            isFlagged,
            isDone,
            typeName,
            typeUri,
            cardKey,
            !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(icons),
            avatarName,
            avatarUri,
            isLoading
        ].some((component)=>!!component);
    }
    renderCover() {
        const { coverUri: coverUri, cover: cover, onImageLoad: onImageLoad } = this.props;
        if (coverUri) return coverUri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K6nB.CardCover), {
            onLoad: onImageLoad,
            uri: coverUri
        });
        return cover;
    }
    renderSummary() {
        if (this.props.renderSummary) {
            const { summary: text, highlightText: highlight, shouldMenuRender: shouldMenuRender, renderSummary: renderSummary } = this.props;
            if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $424382f922ab5f57$var$contentSectionStyles,
                "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR
            }, renderSummary({
                text: text,
                highlight: highlight,
                shouldMenuRender: shouldMenuRender
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, null, renderSummary({
                text: text,
                highlight: highlight,
                shouldMenuRender: shouldMenuRender
            }));
        }
        const { summary: summary, highlightText: highlightText, shouldMenuRender: shouldMenuRender, isCMPBoard: isCMPBoard } = this.props;
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$contentSectionStyles,
            "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vEOb.CardSummary), {
            text: summary,
            highlight: highlightText,
            shouldMenuRender: shouldMenuRender,
            shouldTruncate: Boolean(isCMPBoard)
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vEOb.CardSummary), {
            text: summary,
            highlight: highlightText,
            shouldMenuRender: shouldMenuRender,
            shouldTruncate: Boolean(isCMPBoard)
        }));
    }
    renderFields() {
        const { children: children } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, $5uXOq.Children).toArray(children)) && (0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$contentSectionStyles,
            "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR
        }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            gap: "space.100",
            direction: "column",
            alignItems: "start",
            xcss: $424382f922ab5f57$var$contentSectionInnerStyles
        }, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FieldsSection, null, children));
        return !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))((0, $5uXOq.Children).toArray(children)) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FieldsSection, null, children));
    }
    renderCustomFields() {
        const { customFields: customFields, isCMPBoard: isCMPBoard, fixVersions: fixVersions } = this.props; // TMP labels are rendred directly from issues.lables in a fixed card position
        // CMP labels are reorderable in user settings and therefore need to come from custom fields
        const customFieldsToDisplay = isCMPBoard ? customFields : customFields?.filter((cf)=>cf.id !== (0, $244c28c342c7cd47$export$b1cb468c302d21f9));
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(customFieldsToDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$contentSectionStyles,
            "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbQQn.CardCustomFields), {
            fields: customFieldsToDisplay,
            isCMPBoard: isCMPBoard,
            fixVersions: fixVersions
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(customFieldsToDisplay) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bbQQn.CardCustomFields), {
            fields: customFieldsToDisplay,
            isCMPBoard: isCMPBoard,
            fixVersions: fixVersions
        })));
    }
    renderType() {
        const { typeName: typeName, typeUri: typeUri } = this.props;
        return typeName && typeUri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1d3ex.CardType), {
            text: typeName,
            uri: typeUri
        });
    }
    renderKey() {
        const { cardKey: cardKey, highlightText: highlightText, isDone: isDone, isIPBoard: isIPBoard, onClick: onClick } = this.props;
        return cardKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3Hho.CardKey), {
            text: cardKey,
            highlight: highlightText,
            isDone: Boolean(isDone),
            onClick: onClick,
            openInNewTab: isIPBoard
        });
    }
    renderIcons() {
        const { isDone: isDone, isFlagged: isFlagged, icons: icons, isLoading: isLoading, isCMPBoard: isCMPBoard, isIPBoard: isIPBoard } = this.props;
        const hasIcons = icons?.some((icon)=>!!icon);
        return !isLoading && (isDone || isFlagged || hasIcons) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nii0.CardIcons), null, !isCMPBoard && !isIPBoard && !isFlagged && isDone && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1NiGE.CardTick), {
            key: "card-ticked"
        }), isFlagged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gRghR.CardFlag), {
            key: "card-flagged"
        }), icons);
    }
    renderAvatar() {
        if (this.props.renderAssignee) return this.props.renderAssignee();
        const { avatarName: avatarName, avatarUri: avatarUri, highlightText: highlightText } = this.props;
        return avatarName && avatarUri && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPpj5.CardAvatar), {
            name: avatarName,
            uri: avatarUri,
            highlight: highlightText
        });
    }
    renderLoading() {
        const { isLoading: isLoading } = this.props;
        return isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fsT6h.CardSpinner), null);
    }
    renderIssueLinksStats() {
        return this.props.renderIssueLinksStats?.();
    }
    renderCardColor() {
        const { color: color, hasScenarioChanges: hasScenarioChanges, isIPBoard: isIPBoard } = this.props; /**
                     * In increment planning boards, we render the card color only if the issue:
                     * * is a new issue created in Plans that doesn't yet exist in Jira
                     * * has scenario changes not yet saved to Jira
                     *
                     * The card color is wrapped with a tooltip to inform the user about the fact that
                     * changes only exist in Plans and need to be saved to Jira to be reflected there.
                     */ 
        if (!isIPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            color: color
        });
        if (hasScenarioChanges) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4And4.default).scenarioChangeTooltip)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cm8xi.CardColor), {
            testId: "platform-card.ui.card.card-content.program-board-scenario-indicator",
            color: color
        }));
        return null;
    }
    renderFooter() {
        // When adding new items into the footer, remember to update the `shouldRenderFooter()`
        if (!this.shouldRenderFooter()) return null;
        const { hasCompactIssueType: hasCompactIssueType, isIPBoard: isIPBoard } = this.props;
        if ((0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            testId: "platform-card.ui.card.card-content.footer",
            "data-component-selector": $424382f922ab5f57$var$CONTENT_SECTION_SELECTOR,
            xcss: $424382f922ab5f57$var$contentSectionStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterSection, {
            className: $4VpT2.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterPrimarySection, {
            className: $4VpT2.footerChildSection
        }, !hasCompactIssueType && this.renderType(), this.renderKey()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterTertiarySection, {
            className: $4VpT2.footerChildSection
        }, this.renderIssueLinksStats(), Boolean(hasCompactIssueType) && this.renderType(), !isIPBoard && this.renderIcons()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterSecondarySection, null, isIPBoard && this.renderIcons(), (!isIPBoard || (0, $4R6GH.fg)('issue_cards_in_program_board')) && this.renderAvatar(), this.renderLoading())));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$ContentSection, {
            "data-testid": "platform-card.ui.card.card-content.footer"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterSection, {
            className: $4VpT2.footer
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterPrimarySection, {
            className: $4VpT2.footerChildSection
        }, !hasCompactIssueType && this.renderType(), this.renderKey()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterTertiarySection, {
            className: $4VpT2.footerChildSection
        }, this.renderIssueLinksStats(), Boolean(hasCompactIssueType) && this.renderType(), !isIPBoard && this.renderIcons()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$FooterSecondarySection, null, isIPBoard && this.renderIcons(), (!isIPBoard || (0, $4R6GH.fg)('issue_cards_in_program_board')) && this.renderAvatar(), this.renderLoading())));
    }
    render() {
        const isCMPBoard = Boolean(this.props.isCMPBoard);
        const cardContent = (0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$containerStyles
        }, this.renderCover(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$Content // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: $4VpT2.content,
            isCMPBoard: isCMPBoard,
            hasStatus: this.props.status !== null,
            visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
        }, this.renderSummary(), this.renderFields(), this.renderCustomFields(), this.renderCardColor(), this.renderFooter())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.renderCover(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($424382f922ab5f57$var$Content // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: $4VpT2.content,
            isCMPBoard: isCMPBoard,
            hasStatus: this.props.status !== null,
            visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
        }, this.renderSummary(), this.renderFields(), this.renderCustomFields(), this.renderCardColor(), this.renderFooter()));
        return isCMPBoard ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $424382f922ab5f57$var$contentContainerStyles
        }, cardContent) : cardContent;
    }
}
var $424382f922ab5f57$export$2e2bcd8739ae039 // eslint-disable-next-line jira/styled/styled-component-order
 = $424382f922ab5f57$export$64ef9b8c11710c47;
const $424382f922ab5f57$var$contentContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    container: `${$4VpT2["card-content-container"]} / inline-size`
});
const $424382f922ab5f57$var$gutterSize = (0, $gwIPs.gridSize) / 2;
const $424382f922ab5f57$var$footerMinHeight = 28;
const $424382f922ab5f57$var$gridareas = ()=>{
    if ($4VpT2.primary && $4VpT2.tertiary && $4VpT2.secondary) return `"${$4VpT2.primary} ${$4VpT2.tertiary} ${$4VpT2.secondary}"`;
    return '"primary tertiary secondary"';
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$ContentSection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-0"
})({
    display: 'flex',
    flexDirection: 'row',
    width: '100%'
});
const $424382f922ab5f57$var$contentSectionStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    position: 'relative',
    pointerEvents: 'auto'
});
const $424382f922ab5f57$var$contentSectionInnerStyles = (0, $8CUq3.xcss)({
    width: '100%'
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$ContentControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-1"
})`box-sizing:border-box;display:flex;flex-direction:column;padding:${"var(--ds-space-150, 12px)"};${$424382f922ab5f57$var$ContentSection}{margin-bottom:${"var(--ds-space-100, 8px)"};&:last-child{margin-bottom:0;}${(props)=>(!props.isCMPBoard || props.visualRefresh) && `&:nth-of-type(2):last-of-type {
            margin-top: ${"var(--ds-space-050, 4px)"};
        }`} ${(props)=>props.hasStatus && `&:nth-child(2) {
                margin-bottom: ${"var(--ds-space-050, 4px)"};
            }
            &:nth-last-child(2) {
                margin-bottom: ${"var(--ds-space-100, 8px)"};
            }
        `}}`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $424382f922ab5f57$var$ContentExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isCMPBoard: isCMPBoard, visualRefresh: visualRefresh, hasStatus: hasStatus, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vchhusvi _1e0c1txw _2lx21bp4 _ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _7y2iu2gc _12tyidpf",
            (!__cmplp.isCMPBoard || __cmplp.visualRefresh) && "_pg611b66",
            __cmplp.hasStatus && "_1dkc1b66",
            __cmplp.hasStatus && "_u0k4u2gc",
            __cmplp.className
        ])
    });
});
const $424382f922ab5f57$var$Content = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('fix_jira_board_card_nested_interactive_elements'), $424382f922ab5f57$var$ContentExperiment, $424382f922ab5f57$var$ContentControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FieldsSection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-2"
})({
    display: 'flex',
    flexFlow: 'row wrap',
    alignItems: 'center',
    gap: "var(--ds-space-100, 8px)",
    width: '100%'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FooterSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1rr33ui": (0, $lD23V.default)($424382f922ab5f57$var$gridareas())
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpoqx6 _1e0c11p5 _1bsb1osq _1tke1f4h _2z05hkll _yv0e1xhj _1lmc6ou8",
            __cmplp.className
        ])
    });
});
const $424382f922ab5f57$var$footerSectionMixinStyles = /*#__PURE__*/ (0, $47bDC.css)({
    boxSizing: 'border-box',
    display: 'grid',
    gridAutoFlow: 'column',
    alignItems: 'center',
    justifyContent: 'start',
    gap: "var(--ds-space-100, 8px)"
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FooterPrimarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_yr074y": (0, $lD23V.default)($4VpT2.primary ? $4VpT2.primary : 'primary')
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_nd5lkgrd _zulp1b66 _p12f1ns9 _vchhusvi _1e0c11p5 _wij21bp4 _4cvr1h6o _1bahv2br",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FooterSecondarySection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-3"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: $4VpT2.secondary ? $4VpT2.secondary : 'secondary'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
()=>$424382f922ab5f57$var$footerSectionMixinStyles); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $424382f922ab5f57$var$FooterTertiarySection = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1e1lt9n-4"
})({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    gridArea: $4VpT2.tertiary ? $4VpT2.tertiary : 'tertiary',
    minHeight: '24px'
}, // eslint-disable-next-line @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
()=>$424382f922ab5f57$var$footerSectionMixinStyles);
const $424382f922ab5f57$var$containerStyles = (0, $8CUq3.xcss)({
    pointerEvents: 'none'
});

});
parcelRegister("cPpj5", function(module, exports) {

$parcel$export(module.exports, "CardAvatar", () => $40c355940ac43905$export$96ed66090abd01b1);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $4VpT2 = parcelRequire("4VpT2");

var $8uZt8 = parcelRequire("8uZt8");

const $40c355940ac43905$var$hasKeywords = (name)=>(keyword)=>name && keyword && name.toLowerCase().includes(keyword.toLowerCase());
const $40c355940ac43905$export$96ed66090abd01b1 = (props)=>{
    const { name: name, uri: uri, highlight: highlight } = props;
    const [hasImageErrored, setHasImageErrored] = (0, $5uXOq.useState)(false);
    const isImageValid = !!uri && !hasImageErrored;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40c355940ac43905$var$Container, {
        isHighlighted: highlight && highlight.some($40c355940ac43905$var$hasKeywords(name)),
        "data-testid": "platform-card.common.ui.avatar.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40c355940ac43905$var$AvatarContainer, {
        className: $4VpT2.avatarContainer
    }, isImageValid ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40c355940ac43905$var$Image, {
        loading: "lazy",
        alt: name,
        src: uri,
        onError: ()=>setHasImageErrored(true)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$30a9be92cbb6f382),
        label: name,
        primaryColor: "var(--ds-icon-subtle, #626F86)"
    }))));
};
var $40c355940ac43905$export$2e2bcd8739ae039 = $40c355940ac43905$export$96ed66090abd01b1;
const $40c355940ac43905$var$size = (0, $gwIPs.gridSize) * 3;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40c355940ac43905$var$AvatarContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1reo15vq _18m915vq _2rko1l7b _1e0c116y _4t3i1tcg _1bsb1tcg _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _kqswh2mm _80om73ad _vwz4kb7n",
            __cmplp.className
        ])
    });
});
const $40c355940ac43905$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _s7n4nkob _1bsb1osq _4t3i1osq",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40c355940ac43905$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHighlighted: isHighlighted, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _zdxoidpf _v5ynkb7n _13ls1wug _d0dz1txw _brcx1h6o _1ouwidpf",
            __cmplp.isHighlighted ? "_16qsa9gh" : "_16qsglyw",
            __cmplp.className
        ])
    });
});
const $40c355940ac43905$export$7ed12d2a5241e393 = {
    Container: $40c355940ac43905$var$Container
};

});

parcelRegister("7K6nB", function(module, exports) {

$parcel$export(module.exports, "CardCover", () => $4ed524f132b65d0c$export$1a2d6d8c98d2c941);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");
const $4ed524f132b65d0c$export$1a2d6d8c98d2c941 = (props)=>{
    const { uri: uri, onLoad: onLoad } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ed524f132b65d0c$var$Cover, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ed524f132b65d0c$var$Image, {
        src: uri,
        onLoad: onLoad ?? (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        alt: ""
    }));
};
var $4ed524f132b65d0c$export$2e2bcd8739ae039 = $4ed524f132b65d0c$export$1a2d6d8c98d2c941;
const $4ed524f132b65d0c$var$coverMaxHeight = 260;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ed524f132b65d0c$var$Cover = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _2rko1k7a _lcxvglyw _1e0c1txw _1bah1h6o",
            __cmplp.className
        ])
    });
});
const $4ed524f132b65d0c$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _p12f1osq _1ul9idpf _c71lgx0z _1tkeidpf",
            __cmplp.className
        ])
    });
});

});

parcelRegister("gRghR", function(module, exports) {

$parcel$export(module.exports, "CardFlag", () => $215dcd50a4cec540$export$c551eb098ad78be9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8uZt8 = parcelRequire("8uZt8");


var $9dnfu = parcelRequire("9dnfu");
const $215dcd50a4cec540$export$c551eb098ad78be9 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage((0, $9dnfu.default).done);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($215dcd50a4cec540$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$aac403da0d127706),
        label: message,
        primaryColor: "var(--ds-icon-danger, #C9372C)"
    })));
};
var $215dcd50a4cec540$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $215dcd50a4cec540$export$c551eb098ad78be9;
const $215dcd50a4cec540$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9dnfu", function(module, exports) {

$parcel$export(module.exports, "default", () => $c30141b180911976$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c30141b180911976$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    done: {
        "id": "card.common.flag.done",
        "defaultMessage": "Flagged"
    }
});

});


parcelRegister("k3Hho", function(module, exports) {

$parcel$export(module.exports, "CardKey", () => $ff81caf4d7800ecf$export$5bcc49a1014b751b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $gVhaI = parcelRequire("gVhaI");

var $g1YKS = parcelRequire("g1YKS");
const $ff81caf4d7800ecf$export$5bcc49a1014b751b = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, highlight: highlight = [], onClick: onClick, isDone: isDone = false, stopEventPropagation: stopEventPropagation = true, openInNewTab: openInNewTab = false, renderAsText: renderAsText = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const highlightedText = highlight && (0, $gVhaI.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVhaI.HighlightText), {
        phrases: highlight,
        content: text
    }) : text;
    const onClickKey = (0, $5uXOq.useCallback)((event)=>{
        const isModifierClick = event.ctrlKey || event.altKey || event.metaKey || event.shiftKey;
        stopEventPropagation && event.stopPropagation();
        if (!isModifierClick && !openInNewTab) {
            event.preventDefault();
            onClick?.(event);
        }
    }, [
        onClick,
        openInNewTab,
        stopEventPropagation
    ]);
    // prevent the context menu and Bento from opening
    const onContextMenu = (0, $5uXOq.useCallback)((event)=>event.stopPropagation(), []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff81caf4d7800ecf$export$42a852a2b6b56249, {
        "data-testid": "platform-card.common.ui.key.key"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff81caf4d7800ecf$var$StyledLink, {
        isLineThrough: Boolean(isDone),
        ...!renderAsText && {
            href: `/browse/${text}`,
            target: '_blank'
        },
        onContextMenu: onContextMenu,
        onClick: onClickKey,
        ...Boolean(isDone) && {
            'aria-label': formatMessage((0, $g1YKS.default).label, {
                issueKey: text
            })
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $ff81caf4d7800ecf$var$KeyStyles,
            (0, $dCm1o.isVisualRefreshEnabled)() && $ff81caf4d7800ecf$var$KeyRefreshStyles
        ]
    }, highlightedText))));
});
var $ff81caf4d7800ecf$export$2e2bcd8739ae039 = $ff81caf4d7800ecf$export$5bcc49a1014b751b;
const $ff81caf4d7800ecf$var$StyledLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "a", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isLineThrough: isLineThrough, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_uizt1wug _syaz1gjq",
            __cmplp.isLineThrough ? "_4bfu18uv _1hms1911 _ajmmnqa1" : "_4bfu18uv _1hmsglyw _ajmmnqa1",
            __cmplp.isLineThrough ? "_1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2wa1911 _4fpr1911 _1bnx1911 _13jx1911 _1x281911 _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1" : "_1nrm18uv _1a3b18uv _9oik18uv _5bd618uv _1ydc18uv _c2waglyw _4fprglyw _1bnxglyw _13jxglyw _1x28glyw _1iohnqa1 _5goinqa1 _jf4cnqa1 _xatrnqa1 _1726nqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ff81caf4d7800ecf$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zkb7n _i0dl1wug _1reo15vq _18m915vq _1eim1xrj _o5721q9c _1e381q09",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ff81caf4d7800ecf$export$cd0f44441c3b7719 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8dcr7 _1e0c1ule _1bto1l2s _k48p1pd9 _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $ff81caf4d7800ecf$var$KeyStyles = (0, $8CUq3.xcss)({
    display: 'block',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    font: 'font.body.UNSAFE_small',
    fontWeight: "var(--ds-font-weight-semibold, 600)",
    color: 'color.text.subtle'
});
const $ff81caf4d7800ecf$var$KeyRefreshStyles = (0, $8CUq3.xcss)({
    fontWeight: "var(--ds-font-weight-medium, 500)"
});

});
parcelRegister("gVhaI", function(module, exports) {

$parcel$export(module.exports, "shouldHighlightText", () => $07b54d3092611445$export$dceb4ab0bd0273b3);
$parcel$export(module.exports, "HighlightText", () => $07b54d3092611445$export$bb02e7bc6e1a7119);

var $5uXOq = parcelRequire("5uXOq");

var $1H6kL = parcelRequire("1H6kL");

var $k2wwp = parcelRequire("k2wwp");
const $07b54d3092611445$export$dceb4ab0bd0273b3 = (text = '', keywords = [])=>text && text.length > 0 && keywords.filter((keyword)=>keyword !== '').length > 0 && keywords.some((keyword)=>(0, $1H6kL.removeAccents)(text).toLowerCase().includes(keyword.toLowerCase()) || text.toLowerCase().includes(keyword.toLowerCase()));
const $07b54d3092611445$export$bb02e7bc6e1a7119 = ({ content: content, phrases: phrases })=>{
    if (!phrases || !phrases.length) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2wwp.default), {
        highlight: phrases,
        text: content
    });
};
var $07b54d3092611445$export$2e2bcd8739ae039 = $07b54d3092611445$export$bb02e7bc6e1a7119;

});
parcelRegister("1H6kL", function(module, exports) {

$parcel$export(module.exports, "removeAccents", () => $0b92ef830f5aa8e4$export$f3f2882e8b11d731);
$parcel$export(module.exports, "getParts", () => $0b92ef830f5aa8e4$export$a3aee8a24a54661f);

var $8QDwl = parcelRequire("8QDwl");

var $ajpes = parcelRequire("ajpes");

var $3JOCw = parcelRequire("3JOCw");

var $8QpSo = parcelRequire("8QpSo");
const $0b92ef830f5aa8e4$export$f3f2882e8b11d731 = (0, $8QpSo.default)((text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, ''));
const $0b92ef830f5aa8e4$export$1633667427d99697 = (0, $8QpSo.default)((highlight)=>{
    const escapedFilter = highlight.map((phrase)=>(0, (/*@__PURE__*/$parcel$interopDefault($8QDwl)))(phrase)).join('|');
    return new RegExp(escapedFilter, 'gmi');
}, (newArgs, lastArgs)=>{
    if (newArgs.length !== lastArgs.length) return false;
    const equalityFn = (0, (/*@__PURE__*/$parcel$interopDefault($ajpes)));
    return newArgs.every((newArg, index)=>equalityFn(newArg, lastArgs[index]));
});
const $0b92ef830f5aa8e4$export$2235873b95f89ea = (content)=>({
        type: 'text',
        content: content
    });
const $0b92ef830f5aa8e4$export$39ae7d355c29b45f = (content)=>({
        type: 'highlight',
        content: content
    });
const $0b92ef830f5aa8e4$export$c05c39859172f90c = (str, regExp)=>{
    const ms = [];
    let m = regExp.exec(str);
    while(m){
        ms.push(m);
        m = regExp.exec(str);
    }
    return ms;
};
const $0b92ef830f5aa8e4$export$a3aee8a24a54661f = (highlight, text)=>{
    if (highlight == null || highlight.filter((phrase)=>phrase !== '').length === 0) return [
        $0b92ef830f5aa8e4$export$2235873b95f89ea(text)
    ];
    const parts = [];
    // Long text lengths will cause "Invalid regular expression" error
    const truncatedHighlight = highlight.map((phrase)=>phrase.substring(0, 255));
    const highlightRegExp = $0b92ef830f5aa8e4$export$1633667427d99697(truncatedHighlight.filter((phrase)=>phrase !== ''));
    const textWithoutAccents = $0b92ef830f5aa8e4$export$f3f2882e8b11d731(text);
    const textMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(text, highlightRegExp);
    const textWithoutAccentsMatches = $0b92ef830f5aa8e4$export$c05c39859172f90c(textWithoutAccents, highlightRegExp);
    const highlightMatches = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))([
        ...textWithoutAccentsMatches,
        ...textMatches
    ], 'index');
    let currentPosition = 0;
    highlightMatches.forEach((match)=>{
        const matchText = text.slice(match.index, match.index + match[0].length);
        const leading = text.slice(currentPosition, match.index);
        if (leading !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(leading));
        parts.push($0b92ef830f5aa8e4$export$39ae7d355c29b45f(matchText));
        currentPosition = match.index + matchText.length;
    });
    const trailing = text.slice(currentPosition);
    if (trailing !== '') parts.push($0b92ef830f5aa8e4$export$2235873b95f89ea(trailing));
    return parts;
};

});

parcelRegister("k2wwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e37bd657627b5db$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1H6kL = parcelRequire("1H6kL");

var $cM7El = parcelRequire("cM7El");
const $5e37bd657627b5db$var$HighlightTextWithParser = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, highlight: highlight })=>{
    const parts = (0, $1H6kL.getParts)(highlight, text);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM7El.default), {
        parts: parts
    });
});
var $5e37bd657627b5db$export$2e2bcd8739ae039 = $5e37bd657627b5db$var$HighlightTextWithParser;

});
parcelRegister("cM7El", function(module, exports) {

$parcel$export(module.exports, "default", () => $328475be93221885$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $328475be93221885$var$Mark = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "mark", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhki1yw _syaz1fxt",
            __cmplp.className
        ])
    });
});
const $328475be93221885$var$HighlightText = ({ parts: parts })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, parts.map((part, i)=>{
        if (part.type === 'text') return part.content;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($328475be93221885$var$Mark, {
            key: i
        }, part.content);
    }));
var $328475be93221885$export$2e2bcd8739ae039 = $328475be93221885$var$HighlightText;

});



parcelRegister("g1YKS", function(module, exports) {

$parcel$export(module.exports, "default", () => $812fbcd4b3060f19$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $812fbcd4b3060f19$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "platform-card.common.ui.key.key.styled-link.aria-label",
        "defaultMessage": "{issueKey} is resolved"
    }
});

});


parcelRegister("fsT6h", function(module, exports) {

$parcel$export(module.exports, "CardSpinner", () => $d9514f248a861844$export$cbd2bb5b02f5fd3a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $2h3PP = parcelRequire("2h3PP");
const $d9514f248a861844$export$cbd2bb5b02f5fd3a = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage((0, $2h3PP.default).loading);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d9514f248a861844$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        label: message,
        size: "small"
    })));
};
var $d9514f248a861844$export$2e2bcd8739ae039 = $d9514f248a861844$export$cbd2bb5b02f5fd3a;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d9514f248a861844$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2h3PP", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c63e872e5284154$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5c63e872e5284154$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    loading: {
        "id": "card.common.spinner.loading",
        "defaultMessage": "Loading"
    }
});

});


parcelRegister("1vEOb", function(module, exports) {

$parcel$export(module.exports, "CardSummary", () => $fc0aeaf09a85019e$export$f2e6e773bb9ca12a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $4VpT2 = parcelRequire("4VpT2");

var $gVhaI = parcelRequire("gVhaI");
const $fc0aeaf09a85019e$export$f2e6e773bb9ca12a = ({ text: text, highlight: highlight, shouldMenuRender: shouldMenuRender, shouldTruncate: shouldTruncate = false })=>{
    const HighlightedText = highlight && (0, $gVhaI.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVhaI.HighlightText), {
        phrases: highlight,
        content: text
    }) : text;
    const summary = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fc0aeaf09a85019e$var$Summary, {
        shouldMenuRender: shouldMenuRender || false,
        shouldTruncate: shouldTruncate,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: $4VpT2.summary
    }, HighlightedText);
    if (!shouldTruncate) return summary;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: text,
        position: "bottom"
    }, summary);
};
$fc0aeaf09a85019e$export$f2e6e773bb9ca12a.defaultProps = {
    shouldMenuRender: false,
    highlight: []
};
var $fc0aeaf09a85019e$export$2e2bcd8739ae039 = $fc0aeaf09a85019e$export$f2e6e773bb9ca12a;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fc0aeaf09a85019e$var$Summary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldMenuRender: shouldMenuRender, shouldTruncate: shouldTruncate, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_slp31hna _1i4q1hna _1nmz1hna",
            __cmplp.shouldMenuRender ? "_u5f3xy5q" : "_u5f3ze3t",
            __cmplp.shouldTruncate ? "_1yyj11wp" : "_1yyjn7od",
            __cmplp.shouldTruncate ? "_1e0ccj1k" : "_1e0c1nu9",
            __cmplp.shouldTruncate ? "_1reo15vq _18m915vq" : "_1reon7od _18m9n7od",
            __cmplp.shouldTruncate ? "_sudp1e54" : "_sudpn7od",
            __cmplp.className
        ])
    });
});

});

parcelRegister("1NiGE", function(module, exports) {

$parcel$export(module.exports, "CardTick", () => $5f276ea5833a7960$export$711ec40e911e6898);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8uZt8 = parcelRequire("8uZt8");


var $9lrvF = parcelRequire("9lrvF");
const $5f276ea5833a7960$export$711ec40e911e6898 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage((0, $9lrvF.default).done);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f276ea5833a7960$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8uZt8.default), {
        type: (0, $6d6eac2504286faf$export$540a31b23d6b9abd),
        label: message,
        primaryColor: "var(--ds-icon-success, #22A06B)"
    })));
};
var $5f276ea5833a7960$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $5f276ea5833a7960$export$711ec40e911e6898;
const $5f276ea5833a7960$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _4cvr1h6o _vwz4kb7n",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9lrvF", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba0be14bc0b262f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ba0be14bc0b262f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    done: {
        "id": "card.common.tick.done",
        "defaultMessage": "Done"
    }
});

});


parcelRegister("1d3ex", function(module, exports) {

$parcel$export(module.exports, "CardType", () => $af4046f987350b01$export$f1a79bffad3377cd);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");
const $af4046f987350b01$export$f1a79bffad3377cd = /*#__PURE__*/ (0, $5uXOq.memo)(({ text: text, uri: uri })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af4046f987350b01$var$Icon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: text
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($af4046f987350b01$export$3e431a229df88919, {
        alt: text,
        src: uri
    })));
});
var $af4046f987350b01$export$2e2bcd8739ae039 = $af4046f987350b01$export$f1a79bffad3377cd;
const $af4046f987350b01$var$iconSize = (0, $gwIPs.gridSize) * 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $af4046f987350b01$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $af4046f987350b01$export$3e431a229df88919 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb7vkz _4t3i7vkz _s7n41ndm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4And4", function(module, exports) {

$parcel$export(module.exports, "default", () => $480bb196a9a74550$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $480bb196a9a74550$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    scenarioChangeTooltip: {
        "id": "platform-card.card.scenario-change-tooltip",
        "defaultMessage": "This change is only saved in your plan. Review this change, then save it in Jira."
    }
});

});


parcelRegister("7YpGJ", function(module, exports) {

$parcel$export(module.exports, "InteractionLayer", () => $badc2a28b0033d9a$export$4b508ff96d264be7);

var $5uXOq = parcelRequire("5uXOq");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $6HLFF = parcelRequire("6HLFF");
const $badc2a28b0033d9a$export$4b508ff96d264be7 = ({ onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onFocus: onFocus, onBlur: onBlur, cardRef: cardRef, cardKey: cardKey, summary: summary })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const handleClick = (e)=>onClick && onClick(e);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
        // eslint-disable-next-line jira/integration/test-id-by-folder-structure
        testId: "platform-card.ui.card.focus-container",
        "aria-label": formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $6HLFF.default).interactionLayerLabelIssueTermRefresh : (0, $6HLFF.default).interactionLayerLabel, {
            issueKey: cardKey ?? '',
            issueSummary: summary
        }),
        onClick: handleClick,
        onMouseEnter: onMouseEnter,
        onMouseLeave: onMouseLeave,
        onFocus: onFocus,
        onBlur: onBlur,
        ref: cardRef,
        xcss: $badc2a28b0033d9a$var$interactionLayerStyles
    });
};
const $badc2a28b0033d9a$var$interactionLayerStyles = (0, $8CUq3.xcss)({
    all: 'unset',
    pointerEvents: 'auto',
    position: 'absolute',
    left: 'space.0',
    right: 'space.0',
    top: 'space.0',
    bottom: 'space.0',
    borderRadius: 'border.radius',
    ':focus': {
        outlineOffset: 'space.0'
    },
    ':focus-visible': {
        outlineOffset: 'space.0'
    },
    ':focus-within': {
        outlineOffset: 'space.0'
    }
});

});
parcelRegister("6HLFF", function(module, exports) {

$parcel$export(module.exports, "default", () => $de20ccba60efa5f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $de20ccba60efa5f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    interactionLayerLabel: {
        "id": "platform-card.card.interaction-layer-label",
        "defaultMessage": "{issueKey} {issueSummary}. Use the enter key to load the issue view."
    },
    interactionLayerLabelIssueTermRefresh: {
        "id": "platform-card.card.interaction-layer-label-issue-term-refresh",
        "defaultMessage": "{issueKey} {issueSummary}. Use the enter key to load the work item."
    }
});

});



const $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9 = 32;
const $d9cdb1c71f9dbf8c$export$dce8cd449abd1f77 = 5;
const $d9cdb1c71f9dbf8c$export$1ec3328eed0aedd9 = 300;
const $d9cdb1c71f9dbf8c$export$6b4c950ad6cadf50 = 200;
const $d9cdb1c71f9dbf8c$export$bb89c9064245f005 = 500;
const $d9cdb1c71f9dbf8c$export$f4f3847a7eaec9e9 = 'software-context-menu.ui.context-menu-inner.context-menu-inner-container';
const $d9cdb1c71f9dbf8c$export$b3f11e5d123cdbe9 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-submenu';
const $d9cdb1c71f9dbf8c$export$ef86d72244e00c00 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.chevron-icon';
const $d9cdb1c71f9dbf8c$export$8e765acf3440e0b = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-item.context-menu-item';
const $d9cdb1c71f9dbf8c$export$75f77b2251314894 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.overflow-visible-popup-container';
const $d9cdb1c71f9dbf8c$export$602eb83148423ac6 = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.tooltip';
const $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f = 'software-context-menu.ui.menu-renderer.context-menu-inner.context-menu-node.context-menu-item.context-menu-label';
const $d9cdb1c71f9dbf8c$export$90350df905144507 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search';
const $d9cdb1c71f9dbf8c$export$328d05d650390cfd = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.content';
const $d9cdb1c71f9dbf8c$export$1245780b529c0d82 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.loading';
const $d9cdb1c71f9dbf8c$export$803f51dcf576f554 = 'software-context-menu.ui.context-menu-inner.context-menu-node.context-menu-search.no-results';
const $d9cdb1c71f9dbf8c$export$bb79bd28759ee895 = 'context';
const $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b = 'meatball';

parcelRegister("gjUWL", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ed3e610183061c2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8ed3e610183061c2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    actionsMenuTriggerLabel: {
        "id": "platform-board-kit.card.jira-card-contents.actions-menu-trigger-label",
        "defaultMessage": "issue actions, { summary }"
    },
    storyPointsUnitsLabel: {
        "id": "platform-board-kit.card.jira-card-contents.story-points-units-label",
        "defaultMessage": "story points"
    },
    storyPointsUnitsPluralisedLabel: {
        "id": "platform-board-kit.card.jira-card-contents.story-points-units-pluralised-label",
        "defaultMessage": "{value, plural, one {# story point} other {# story points}}"
    },
    actionsMenuTriggerLabelIssueTermRefresh: {
        "id": "platform-board-kit.card.jira-card-contents.actions-menu-trigger-label-issue-term-refresh",
        "defaultMessage": "work item actions, { summary }"
    }
});

});


parcelRegister("3Lg0k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d474a688d3cc6a5a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $645AZ = parcelRequire("645AZ");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$d474a688d3cc6a5a$export$2e2bcd8739ae039 = ({ onAnimationEnd: onAnimationEnd, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d474a688d3cc6a5a$var$RippleContainer, {
        onAnimationEnd: onAnimationEnd
    }, children);
const $d474a688d3cc6a5a$var$RippleAnimation = /*#__PURE__*/ (0, $47bDC.keyframes)({
    from: {
        boxShadow: '0 0 0 0 #14892c'
    },
    to: {
        boxShadow: '0 0 0 15px rgba(0, 0, 0, 0)'
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d474a688d3cc6a5a$var$RippleContainer = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "p2za2h-0"
})({
    position: 'relative',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    zIndex: (0, $645AZ.zIndex).cardDoneRipple ? (0, $645AZ.zIndex).cardDoneRipple : 'auto',
    borderRadius: '3px',
    animationName: $d474a688d3cc6a5a$var$RippleAnimation,
    animationDuration: '1.45s',
    animationIterationCount: 1,
    animationTimingFunction: 'cubic-bezier(0.14, 1.17, 0.95, 0.99)'
});

});

parcelRegister("gRpCe", function(module, exports) {

$parcel$export(module.exports, "useDraggableCard", () => $0a4eba09c94c83c9$export$ee9f6369c1b523a9);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7nsd3 = parcelRequire("7nsd3");

var $hGgHi = parcelRequire("hGgHi");

var $biEfA = parcelRequire("biEfA");

var $4hDdm = parcelRequire("4hDdm");

var $7gWdR = parcelRequire("7gWdR");
parcelRequire("2Uxmu");
var $hJNa8 = parcelRequire("hJNa8");
parcelRequire("erBEN");
var $kpXwZ = parcelRequire("kpXwZ");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");

const $0a4eba09c94c83c9$var$MAX_CARD_WIDTH = 270;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0a4eba09c94c83c9$var$CardDragPreviewContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_6f8077": (0, $lD23V.default)(`${__cmplp.width}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsb1hdq",
            __cmplp.className
        ])
    });
});
const $0a4eba09c94c83c9$var$defaultIsDroppable = ()=>true;
const $0a4eba09c94c83c9$export$ee9f6369c1b523a9 = ({ isDraggable: isDraggable, elementRef: elementRef, cardId: cardId, cardIndex: cardIndex, columnId: columnId, swimlaneId: swimlaneId, CardPreview: CardPreview, shouldShowRipple: shouldShowRipple, isDroppable: isDroppable = $0a4eba09c94c83c9$var$defaultIsDroppable })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [dragState, setDragState] = (0, $5uXOq.useState)({
        type: 'idle'
    });
    const batchSetDragState = (0, $5uXOq.useCallback)((state)=>autobatch(()=>setDragState(state)), [
        autobatch
    ]);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const batchSetClosestEdge = (0, $5uXOq.useCallback)((edge)=>autobatch(()=>setClosestEdge(edge)), [
        autobatch
    ]);
    const [cardWidth, setCardWidth] = (0, $5uXOq.useState)($0a4eba09c94c83c9$var$MAX_CARD_WIDTH);
    const batchSetCardWidth = (0, $5uXOq.useCallback)((width)=>autobatch(()=>setCardWidth(width)), [
        autobatch
    ]);
    const isDroppableStable = (0, $7D59a.useEvent)(isDroppable);
    (0, $5uXOq.useEffect)(()=>{
        if (!isDraggable || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(cardIndex) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(columnId) || !elementRef.current) return undefined;
        return (0, $4hDdm.combine)((0, $7gWdR.draggable)({
            element: elementRef.current,
            getInitialData: ()=>({
                    type: (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
                    cardId: cardId,
                    cardIndex: cardIndex,
                    columnId: columnId,
                    swimlaneId: swimlaneId
                }),
            onDrop: ()=>batchSetDragState({
                    type: 'idle'
                }),
            onGenerateDragPreview: ({ nativeSetDragImage: nativeSetDragImage })=>{
                const previewWidth = elementRef.current?.offsetWidth;
                if (previewWidth && previewWidth < $0a4eba09c94c83c9$var$MAX_CARD_WIDTH) batchSetCardWidth(previewWidth);
                (0, $kpXwZ.setCustomNativeDragPreview)({
                    getOffset: (0, $hJNa8.pointerOutsideOfPreview)({
                        x: '8px',
                        y: '8px'
                    }),
                    render ({ container: container }) {
                        batchSetDragState({
                            type: 'dragging',
                            container: container
                        });
                        return ()=>batchSetDragState({
                                type: 'idle'
                            });
                    },
                    nativeSetDragImage: nativeSetDragImage
                });
            },
            canDrag: ()=>{
                if (typeof cardId === 'number') return cardId > 0;
                return !!cardId;
            }
        }), (0, $7gWdR.dropTargetForElements)({
            element: elementRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>(0, $biEfA.attachClosestEdge)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    type: (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
                    cardId: cardId,
                    cardIndex: cardIndex,
                    columnId: columnId,
                    swimlaneId: swimlaneId
                }, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                }),
            canDrop: (args)=>{
                // If card is in optimistic state
                if (typeof cardId === 'number' && cardId < 0) return false;
                if (args.source.data.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) return isDroppableStable(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                args.source.data, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    type: (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
                    cardId: cardId,
                    cardIndex: cardIndex,
                    columnId: columnId,
                    swimlaneId: swimlaneId
                }) ?? true;
                return false;
            },
            onDrag: ({ source: { data: data }, self: self })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                if (data.cardId !== cardId) batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragEnter: ({ source: { data: data }, self: self })=>{
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                if (data.cardId !== cardId) batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragLeave: ()=>batchSetClosestEdge(null),
            onDrop: ()=>batchSetClosestEdge(null)
        }));
    }, [
        cardId,
        cardIndex,
        closestEdge,
        columnId,
        elementRef,
        isDraggable,
        swimlaneId,
        shouldShowRipple,
        isDroppableStable,
        batchSetDragState,
        batchSetClosestEdge,
        batchSetCardWidth
    ]);
    return {
        dragPreview: dragState.type === 'dragging' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0a4eba09c94c83c9$var$CardDragPreviewContainer, {
            width: cardWidth
        }, CardPreview ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CardPreview, {
            cardId: cardId
        }) : null), dragState.container) : null,
        closestEdge: closestEdge
    };
};

});
parcelRegister("2Uxmu", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => (parcelRequire("hJNa8")).pointerOutsideOfPreview);

var $hJNa8 = parcelRequire("hJNa8");

});
parcelRegister("hJNa8", function(module, exports) {

$parcel$export(module.exports, "pointerOutsideOfPreview", () => $4030604dbfde028c$export$427e20518819fabc);

var $6NnQH = parcelRequire("6NnQH");
function $4030604dbfde028c$export$427e20518819fabc(point) {
    return ({ container: container })=>{
        /**
		 * **Approach: transparent borders.**
		 *
		 * The only reliable cross browser technique found to push a
		 * drag preview away from the cursor is to use transparent borders on the container.
		 *
		 * **🙅📱 Not pushing the preview away on iOS**
		 *
		 * On iOS, the browser will set the transparent border color to be black. We can provide a
		 * more polished experience not using the transparent border on iOS.
		 *
		 * While dragging, iOS will shift the drag preview under the center of the users pointer,
		 * so the "pushing away" of the preview is short lived on iOS anyway.
		 *
		 * Notes:
		 *
		 * - Tested on `iOS@18.4.1` on May 7th 2025
		 * - If you set the background color on the `container` the border color will be that
		 * - Setting a transparent background color on the `container` still results in a black border
		 * - The `<body>` text or background color does not change the black border color
		 */ if (!(0, $6NnQH.isSafariOnIOS)()) Object.assign(container.style, {
            borderInlineStart: `${point.x} solid transparent`,
            borderTop: `${point.y} solid transparent`
        });
        // Unfortunate that we need to use `getComputedStyle`,
        // but it's only a single call when the drag is starting.
        const computed = window.getComputedStyle(container);
        if (computed.direction === 'rtl') {
            // The DOMRect will include the new border we added
            const box = container.getBoundingClientRect();
            // Use the top right corner (including the new border) as the offset.
            // The border will push the preview away from the pointer.
            return {
                x: box.width,
                y: 0
            };
        }
        // Use the top left corner as the offset. The border will
        // push the preview away from the pointer.
        return {
            x: 0,
            y: 0
        };
    };
}

});
parcelRegister("6NnQH", function(module, exports) {

$parcel$export(module.exports, "isSafariOnIOS", () => $023dae56098ed162$export$52fc40c68fea4952);

var $jjNE9 = parcelRequire("jjNE9");

var $6aABs = parcelRequire("6aABs");
const $023dae56098ed162$export$52fc40c68fea4952 = (0, $jjNE9.once)(function isSafariOnIOS() {
    return (0, $6aABs.isSafari)() && 'ontouchend' in document;
});

});





parcelRegister("4kv6l", function(module, exports) {

$parcel$export(module.exports, "getDateFormat", () => $6f2828a68ab85a09$export$fa96065c64444af6);

var $iFXjF = parcelRequire("iFXjF");
var $2753q = parcelRequire("2753q");
const $6f2828a68ab85a09$var$DATE_FORMAT_CURRENT_YEAR = 'dd MMM';
const $6f2828a68ab85a09$var$DATE_FORMAT_NOT_CURRENT_YEAR = 'dd MMM yyyy';
const $6f2828a68ab85a09$export$fa96065c64444af6 = (dueDate)=>{
    const currentYear = (0, $iFXjF.default)(new Date());
    const parsedDateDueDateString = (0, $2753q.default)(dueDate, 'yyyy-mm-dd', new Date());
    const dueDateYear = (0, $iFXjF.default)(parsedDateDueDateString);
    return dueDateYear === currentYear ? $6f2828a68ab85a09$var$DATE_FORMAT_CURRENT_YEAR : $6f2828a68ab85a09$var$DATE_FORMAT_NOT_CURRENT_YEAR;
};

});

parcelRegister("7mkyN", function(module, exports) {

$parcel$export(module.exports, "PlanModalEntrypointContext", () => $cd73bf853ceccf39$export$226c547af23d8b2b);

var $l37qh = parcelRequire("l37qh");
const $cd73bf853ceccf39$export$226c547af23d8b2b = (0, $l37qh.createUseEntryPointContext)();

});

parcelRegister("5wBpE", function(module, exports) {

$parcel$export(module.exports, "AssigneeField", () => $2e790c3544e64069$export$7c52097ee36bd91);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $hepPB = parcelRequire("hepPB");

var $2eMTS = parcelRequire("2eMTS");

var $54wEF = parcelRequire("54wEF");

var $3XQR5 = parcelRequire("3XQR5");

var $lfTZh = parcelRequire("lfTZh");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $l8ruj = parcelRequire("l8ruj");

var $33c4b = parcelRequire("33c4b");

var $eGVUJ = parcelRequire("eGVUJ");


var $2f454 = parcelRequire("2f454");

var $evkwq = parcelRequire("evkwq");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $9OPlz = parcelRequire("9OPlz");

var $2yqcU = parcelRequire("2yqcU");

const $2e790c3544e64069$var$stopClickPropagation = (e)=>{
    e.stopPropagation();
};
const $2e790c3544e64069$var$fieldKey = 'assignee';
const $2e790c3544e64069$var$AssigneeFieldInner = ({ issueKey: issueKey, onSubmit: onSubmit, onUpdate: onUpdate, onFailure: onFailure, onOpen: onOpen, onClose: onClose, onSaveField: onSaveField })=>{
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const shouldApplyInviteAndAssign = (0, $hepPB.useShouldApplyInviteAndAssign)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $2e790c3544e64069$var$fieldKey,
            fieldType: 'userpicker',
            origin: 'issueCard'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e790c3544e64069$var$AssigneeFieldWrapper, {
        onClick: $2e790c3544e64069$var$stopClickPropagation,
        onKeyDown: $2e790c3544e64069$var$stopClickPropagation,
        "data-testid": (0, $60f83ce4791d4554$export$eb4bdbeb6f6a0217),
        disableClick: preventInlineEditing
    }, shouldApplyInviteAndAssign ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2yqcU.AsyncLazyIssueAssigneeFieldWithInviteAssign), {
        actionSubject: "inlineEdit",
        issueKey: issueKey,
        shouldPreloadAssignToMe: true,
        popupPlacement: "bottom-end",
        onSubmit: onSubmit,
        onUpdate: onUpdate,
        onFailure: onFailure,
        onOpen: onOpen,
        onClose: onClose,
        customFetchUsers: isIncrementPlanningBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') ? (0, $3XQR5.fetchAssigneeSuggestions) : undefined,
        ...isIncrementPlanningBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') && {
            onSaveField: onSaveField,
            enableAutomaticOption: false
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eMTS.AsyncLazyIssueAssigneeField), {
        actionSubject: "inlineEdit",
        issueKey: issueKey,
        shouldPreloadAssignToMe: true,
        popupPlacement: "bottom-end",
        onSubmit: onSubmit,
        onUpdate: onUpdate,
        onFailure: onFailure,
        onOpen: onOpen,
        onClose: onClose,
        customFetchUsers: isIncrementPlanningBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') ? (0, $3XQR5.fetchAssigneeSuggestions) : undefined,
        ...isIncrementPlanningBoard && (0, $4R6GH.fg)('issue_cards_in_program_board') && {
            onSaveField: onSaveField,
            enableAutomaticOption: false
        }
    })));
};
const $2e790c3544e64069$export$7c52097ee36bd91 = ({ shouldRenderRichField: shouldRenderRichField, assignee: assignee, isCMPBoard: isCMPBoard, issueKey: issueKey, ...props })=>{
    const activeIssueKey = (0, $67sX6.useBoardSelector)((0, $5mTgl.getActiveIssueKey));
    const isEditing = Boolean((0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.getCardEditAssignee)(state)(props.issueId)));
    // Using a ref so it doesn't trigger the useEffect cleanup on every render
    const isEditingRef = (0, $5uXOq.useRef)(isEditing);
    const [{ value: assigneeFieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $5fc53.ASSIGNEE_TYPE), {
        skipRefresh: !isCMPBoard || activeIssueKey !== issueKey
    });
    const shouldRenderRich = Boolean(shouldRenderRichField && assigneeFieldConfig);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $33c4b.AssigneeFieldStatic), {
            value: assignee
        }), [
        assignee
    ]);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('assignee', props.issueId, true));
        if ((0, $4R6GH.fg)('issue_cards_in_program_board')) isEditingRef.current = true;
    }, [
        dispatch,
        props.issueId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('assignee', props.issueId, false));
        if ((0, $4R6GH.fg)('issue_cards_in_program_board')) isEditingRef.current = false;
    }, [
        dispatch,
        props.issueId
    ]);
    const onSaveField = (0, $5uXOq.useCallback)(async (_, fieldId, fieldValue)=>{
        dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
            issueId: props.issueId,
            fieldId: fieldId,
            fieldValue: fieldValue ? fieldValue.accountId : null
        }));
    }, [
        dispatch,
        props.issueId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            const isEditingInternal = isEditingRef.current;
            if (!isEditingInternal || !(0, $4R6GH.fg)('issue_cards_in_program_board')) return;
            // if the inline edit state is still active after the card has been unmounted by the virtualizer,
            // a higher z-index is applied to the issue card, causing it to overlap with some swimlane headers.
            // We need to clear the inline edit state on unmount to prevent this.
            onClose();
        };
    }, [
        onClose
    ]);
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2eMTS.IssueAssigneeFieldBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback,
        onError: editableField.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.assignee-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "assignee-field-inner",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2e790c3544e64069$var$AssigneeFieldInner, {
        ...props,
        ...editableField,
        issueKey: issueKey,
        onOpen: onOpen,
        onClose: onClose,
        onSaveField: onSaveField
    }))));
    return fallback;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2e790c3544e64069$var$AssigneeFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { disableClick: disableClick, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_80omtlke _1gp47079 _1di411wp",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("hepPB", function(module, exports) {

$parcel$export(module.exports, "useShouldApplyInviteAndAssign", () => $22f2f1b13e03abbe$export$dd717a0a6d95d97d);

var $2vSU6 = parcelRequire("2vSU6");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");
const $22f2f1b13e03abbe$export$dd717a0a6d95d97d = ()=>{
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isJSW = project?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const isTMP = !!project?.simplified;
    const isFreeInstance = software === (0, $ldyPw.FREE_EDITION);
    return isJSW && isFreeInstance && isTMP && isSiteAdmin;
};

});

parcelRegister("2eMTS", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyIssueAssigneeField", () => $40ac4b7314747a71$export$3eed76542de607d2);
$parcel$export(module.exports, "AsyncIssueAssigneeField", () => $40ac4b7314747a71$export$5cdab73b9e0803a1);
$parcel$export(module.exports, "IssueAssigneeFieldBoundary", () => $40ac4b7314747a71$export$9b541007f4ef3ffe);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $fE0Ry = parcelRequire("fE0Ry");

const $40ac4b7314747a71$export$3eed76542de607d2 = (0, $kxZPA.lazy)(()=>(parcelRequire("TXhYQ")), {
    moduleId: "./src/packages/issue/fields/assignee/src/ui/popover/index.tsx"
});
const $40ac4b7314747a71$export$5cdab73b9e0803a1 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-field-assignee",
        packageName: "jira-issue-field-assignee",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fE0Ry.AssigneePickerView), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40ac4b7314747a71$export$3eed76542de607d2, props)));
const $40ac4b7314747a71$export$9b541007f4ef3ffe = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-assignee-field",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-assignee-field-boundary",
        fallback: fallback
    }, children));

});
parcelRegister("fE0Ry", function(module, exports) {

$parcel$export(module.exports, "AssigneePickerView", () => $7dd7529f3295a136$export$7df43f1214c1ab94);
$parcel$export(module.exports, "AvatarWrapper", () => $7dd7529f3295a136$export$f7513421c53ce141);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $aWse0 = parcelRequire("aWse0");


var $fhSLy = parcelRequire("fhSLy");

var $evUrF = parcelRequire("evUrF");
const $7dd7529f3295a136$export$7df43f1214c1ab94 = ({ value: value })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const unassigned = (0, $fhSLy.getUnassignedUser)(intl);
    const user = value || unassigned;
    const assigneeName = user.accountId === (0, $c1e3a0a8493b8e86$export$bdab9bfb39981463) ? user.displayName : intl.formatMessage((0, $evUrF.default).assigneeTooltip, {
        name: user.displayName
    });
    const avatarUrl = (0, $fhSLy.getUserAvatarUrl)(user);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dd7529f3295a136$export$f7513421c53ce141, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: assigneeName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        testId: "issue-field-assignee.common.ui.read-view.popover.avatar",
        size: "small",
        src: avatarUrl,
        name: assigneeName,
        borderColor: "transparent"
    })));
};
var $7dd7529f3295a136$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
 = $7dd7529f3295a136$export$7df43f1214c1ab94;
const $7dd7529f3295a136$export$f7513421c53ce141 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1bsb1f4h _4t3i1f4h _vchhusvi _80om73ad",
            __cmplp.className
        ])
    });
});

});
parcelRegister("evUrF", function(module, exports) {

$parcel$export(module.exports, "default", () => $027660e13143d610$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $027660e13143d610$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    assigneeTooltip: {
        "id": "issue-field-assignee.common.read-view.popover.assignee-tooltip",
        "defaultMessage": "Assignee: {name}"
    }
});

});


parcelRegister("TXhYQ", function(module, exports) {

let $0a8320bb08c13612$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0a8320bb08c13612$var$load("2i2PS").then(()=>parcelRequire('278RC'));

});


parcelRegister("3XQR5", function(module, exports) {

$parcel$export(module.exports, "fetchAssigneeSuggestions", () => $6b8cde8c5aa2fa10$export$6d3197eb2375d7);

var $7f4tk = parcelRequire("7f4tk");

var $4jAPy = parcelRequire("4jAPy");
const $6b8cde8c5aa2fa10$var$transformPlanAssigneeUserResponse = (response)=>response && response.results && response.results.map((user)=>({
            accountId: user.jiraUser.accountId,
            avatarUrls: {
                '48x48': user.jiraUser.avatarUrl
            },
            displayName: user.jiraUser.title,
            emailAddress: user.jiraUser.email
        })) || [];
const $6b8cde8c5aa2fa10$export$6d3197eb2375d7 = (query)=>(0, $7f4tk.default)((0, $4jAPy.PLANS_USER_AUTOCOMPLETE_URL), {
        method: 'POST',
        body: JSON.stringify({
            excludedIds: [],
            maxResults: 50,
            query: query
        })
    }).then((response)=>{
        return $6b8cde8c5aa2fa10$var$transformPlanAssigneeUserResponse(response);
    });

});

parcelRegister("eGVUJ", function(module, exports) {

$parcel$export(module.exports, "useEditableField", () => $28a21524984548e7$export$1e71fae6ea31d88a);

var $5uXOq = parcelRequire("5uXOq");

var $fNyAs = parcelRequire("fNyAs");

var $67sX6 = parcelRequire("67sX6");

var $3F1Hq = parcelRequire("3F1Hq");
function $28a21524984548e7$export$1e71fae6ea31d88a({ isExperienceAvailable: isExperienceAvailable }) {
    const [experience] = (0, $5uXOq.useState)((0, $3F1Hq.getUpdateFieldExperience)());
    (0, $5uXOq.useEffect)(()=>{
        if (isExperienceAvailable) experience.start();
    }, [
        experience,
        isExperienceAvailable
    ]);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onSubmit = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $fNyAs.fieldUpdateOptimistic)());
    }, [
        dispatch
    ]);
    const onUpdate = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $fNyAs.fieldUpdateSuccess)());
        experience.success();
    }, [
        dispatch,
        experience
    ]);
    const onFailure = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $fNyAs.fieldUpdateFailure)());
        experience.failure();
    }, [
        dispatch,
        experience
    ]);
    /**
	 * onFailure will be due to an error from backend
	 * onError will be due to an error in frontend, so we dont want to rollback
	 * an update that succeeded in the backend (which we would do in the onFailure)
	 */ const onError = (0, $5uXOq.useCallback)(()=>{
        experience.failure();
    }, [
        experience
    ]);
    return {
        onSubmit: onSubmit,
        onUpdate: onUpdate,
        onFailure: onFailure,
        onError: onError
    };
}

});
parcelRegister("fNyAs", function(module, exports) {

$parcel$export(module.exports, "fieldUpdateOptimistic", () => $aab3ed3017a6c78a$export$d965a01bc4fa38c1);
$parcel$export(module.exports, "fieldUpdateSuccess", () => $aab3ed3017a6c78a$export$899485f80311f013);
$parcel$export(module.exports, "fieldUpdateFailure", () => $aab3ed3017a6c78a$export$8072373a4c28f6d7);

var $9rND4 = parcelRequire("9rND4");
const $aab3ed3017a6c78a$export$eae15d434a3467c2 = 'state.actions.issue.SET_FIELD_UPDATE_OPTIMISTIC';
const $aab3ed3017a6c78a$var$fieldUpdateOptimisticMeta = (0, $9rND4.beginOptimisticUiMeta)();
const $aab3ed3017a6c78a$export$d965a01bc4fa38c1 = ()=>({
        type: $aab3ed3017a6c78a$export$eae15d434a3467c2,
        meta: $aab3ed3017a6c78a$var$fieldUpdateOptimisticMeta
    });
const $aab3ed3017a6c78a$export$e5930a022fd09c89 = 'state.actions.issue.SET_FIELD_UPDATE_SUCCESS';
const $aab3ed3017a6c78a$export$899485f80311f013 = ()=>({
        type: $aab3ed3017a6c78a$export$e5930a022fd09c89,
        meta: (0, $9rND4.commitOptimisticUiMeta)($aab3ed3017a6c78a$var$fieldUpdateOptimisticMeta.optimistic.id)
    });
const $aab3ed3017a6c78a$export$b99b79c1483ed977 = 'state.actions.issue.SET_FIELD_UPDATE_FAILURE';
const $aab3ed3017a6c78a$export$8072373a4c28f6d7 = ()=>({
        type: $aab3ed3017a6c78a$export$b99b79c1483ed977,
        meta: (0, $9rND4.revertOptimisticUiMeta)($aab3ed3017a6c78a$var$fieldUpdateOptimisticMeta.optimistic.id)
    });

});

parcelRegister("3F1Hq", function(module, exports) {

$parcel$export(module.exports, "getUpdateFieldExperience", () => $8b4329ff101ead82$export$540f316847a4d488);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");

const $8b4329ff101ead82$export$540f316847a4d488 = ()=>new (0, $duUGa.UFOExperience)(`${(0, $dcbb2bce513725b3$export$fa0622448a6f265)}.field.update`, {
        performanceType: (0, $atdLB.ExperiencePerformanceTypes).InlineResult,
        type: (0, $atdLB.ExperienceTypes).Experience
    });

});


parcelRegister("2yqcU", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyIssueAssigneeFieldWithInviteAssign", () => $d08db32a683a93d6$export$abcd1fef1544cf07);

var $kxZPA = parcelRequire("kxZPA");

const $d08db32a683a93d6$export$abcd1fef1544cf07 = (0, $kxZPA.lazy)(()=>(parcelRequire("4keI1")).then(({ AssigneeFieldInviteAndAssignExperiment: AssigneeFieldInviteAndAssignExperiment })=>AssigneeFieldInviteAndAssignExperiment), {
    moduleId: "./src/packages/software/board/src/view/board-container/board/card-container/card/assignee-field/assignee-field-with-invite-assign/index.tsx"
});

});
parcelRegister("4keI1", function(module, exports) {

let $3264709a53d154ac$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3264709a53d154ac$var$load("hBQJN").then(()=>parcelRequire('g7CwV'));

});


const $60f83ce4791d4554$export$eb4bdbeb6f6a0217 = 'software-board.board-container.board.card-container.card.assignee-field.button';
const $60f83ce4791d4554$export$ba6ac93c5196802a = 'software-board.common.fields.assignee-field-static.avatar-wrapper';


parcelRegister("kJtdN", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $6ec468c162141f11$export$8dc6765e8be191c7);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $7dRcU = parcelRequire("7dRcU");

var $4tD4f = parcelRequire("4tD4f");

var $fhtW3 = parcelRequire("fhtW3");


var $jUyjb = parcelRequire("jUyjb");

var $2xFXk = parcelRequire("2xFXk");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $63LqY = parcelRequire("63LqY");

var $2f454 = parcelRequire("2f454");

var $aqBCK = parcelRequire("aqBCK");

var $9dYAD = parcelRequire("9dYAD");

var $6TWRP = parcelRequire("6TWRP");

var $dlx3i = parcelRequire("dlx3i");

var $jQS76 = parcelRequire("jQS76");

var $7RDtv = parcelRequire("7RDtv");

var $4HeNL = parcelRequire("4HeNL");

var $4HOBK = parcelRequire("4HOBK");

var $8cT3J = parcelRequire("8cT3J");

var $2Ogtn = parcelRequire("2Ogtn");

var $cMdeq = parcelRequire("cMdeq");

var $1Akg6 = parcelRequire("1Akg6");

var $3usya = parcelRequire("3usya");

var $9QvG1 = parcelRequire("9QvG1");

var $j49Di = parcelRequire("j49Di");

var $9gxbP = parcelRequire("9gxbP");

var $iokTG = parcelRequire("iokTG");

var $l1G1t = parcelRequire("l1G1t");

var $fg8U1 = parcelRequire("fg8U1");

var $kOuTq = parcelRequire("kOuTq");

var $9nGbv = parcelRequire("9nGbv");
const $6ec468c162141f11$export$c087a1fcddb96d21 = ({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, returnFocusRef: returnFocusRef })=>{
    const cardIds = selectedCardIds.includes(issueId) ? selectedCardIds : [
        issueId
    ];
    const isMultiSelectMode = cardIds.length > 1;
    const projectType = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.projectTypeSelector)(state));
    const isSoftwareProject = projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    const header = (0, $3usya.useHeader)({
        selectedCards: cardIds
    });
    const shouldRenderMoveTo = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getCanRankByIssue)(state)(issueId));
    const moveTo = (0, $9gxbP.useMoveTo)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    const shouldRenderAddLabelCardMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ADD_LABEL_CARD_MENU_ITEM);
    const shouldRenderAddFlagCardMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ADD_FLAG_CARD_MENU_ITEM);
    const shouldRenderEditCoverCardMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_EDIT_COVER);
    const shouldRenderCloneCardMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_CLONE_ISSUE);
    const label = (0, $9QvG1.useAddLabel)({
        issueId: issueId,
        selectedCardIds: cardIds
    });
    const flag = (0, $1Akg6.useFlag)({
        issueId: issueId,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') ? {
            selectedCardIds: cardIds
        } : {}
    });
    const linkIssue = (0, $j49Di.useLinkIssue)({
        issueId: issueId,
        issueKey: issueKey,
        ...(0, $4R6GH.fg)('jfp_a11y_fix_jsw_board') ? {
            returnFocusRef: returnFocusRef
        } : {}
    });
    const changeParent = (0, $jQS76.useChangeParent)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    const changeStatus = (0, $9nGbv.useChangeStatus)({
        issueId: issueId
    });
    const bulkChange = (0, $6TWRP.useBulkChange)({
        isMultiSelectMode: isMultiSelectMode
    });
    const editCover = (0, $cMdeq.useEditCover)({
        issueId: issueId
    });
    const copyIssueLink = (0, $8cT3J.useCopyIssueLink)({
        issueKey: issueKey,
        isMultiSelectMode: isMultiSelectMode
    });
    const copyIssueKey = (0, $4HOBK.useCopyIssueKey)({
        issueKey: issueKey,
        isMultiSelectMode: isMultiSelectMode
    });
    const viewInIssueSearch = (0, $fg8U1.useViewIssueSearch)({
        isMultiSelectMode: isMultiSelectMode
    });
    const removeFromSprint = (0, $iokTG.useRemoveFromSprint)({
        issueId: issueId,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') ? {
            selectedCardIds: cardIds
        } : {}
    });
    const cloneIssue = (0, $4HeNL.useCloneIssue)({
        issueKey: issueKey,
        issueId: issueId
    });
    const archiveIssue = (0, $9dYAD.useArchiveIssue)({
        issueKey: issueKey,
        issueId: issueId,
        isMultiSelectMode: isMultiSelectMode
    });
    const deleteIssue = (0, $2Ogtn.useDeleteIssue)({
        issueId: issueId,
        isMultiSelectMode: isMultiSelectMode
    });
    const cardActions = [
        ...shouldRenderAddFlagCardMenu ? flag : [],
        ...shouldRenderAddLabelCardMenu ? label : [],
        ...isSoftwareProject && !isMultiSelectMode ? linkIssue : [],
        ...changeParent,
        ...bulkChange,
        ...shouldRenderEditCoverCardMenu && !isMultiSelectMode ? editCover : []
    ];
    const otherActions = [
        ...copyIssueLink,
        ...copyIssueKey,
        ...viewInIssueSearch
    ];
    const deletionActions = [
        ...removeFromSprint,
        ...shouldRenderCloneCardMenu && !isMultiSelectMode ? cloneIssue : [],
        ...archiveIssue || [],
        ...deleteIssue
    ];
    return [
        ...header,
        ...shouldRenderMoveTo ? moveTo : [],
        ...!isMultiSelectMode && changeStatus.length > 0 && (0, $4R6GH.fg)('card_menu_item_change_status') ? changeStatus : [],
        ...shouldRenderMoveTo && moveTo.length > 0 || changeStatus.length > 0 && (0, $4R6GH.fg)('card_menu_item_change_status') ? [
            (0, $l1G1t.createSeparator)('move-actions')
        ] : [],
        ...otherActions,
        ...otherActions.length > 0 && cardActions.length > 0 ? [
            (0, $l1G1t.createSeparator)('other-actions')
        ] : [],
        ...cardActions,
        ...deletionActions.length > 0 ? [
            (0, $l1G1t.createSeparator)('delete-actions')
        ] : [],
        ...deletionActions
    ];
};
const $6ec468c162141f11$export$6fdab4f20d43bd5c = ({ issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, returnFocusRef: returnFocusRef })=>{
    const cardIds = selectedCardIds.includes(issueId) ? selectedCardIds : [
        issueId
    ];
    const isMultiSelectMode = cardIds.length > 1;
    const header = (0, $3usya.useHeader)({
        selectedCards: cardIds
    });
    const changeDateRange = (0, $dlx3i.useChangeDateRange)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    const isIssueDoneInClosedSprint = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIsIssueDoneInClosedSprint)(state, issueId));
    const linkIssue = (0, $j49Di.useLinkIssueIPBoard)({
        issueId: issueId,
        issueKey: issueKey,
        returnFocusRef: returnFocusRef
    });
    const changeParent = (0, $jQS76.useChangeParent)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    const changeTeam = (0, $7RDtv.useChangeTeam)({
        issueId: issueId,
        selectedCardIds: cardIds,
        isMultiSelectMode: isMultiSelectMode
    });
    return [
        ...header,
        ...!isIssueDoneInClosedSprint ? changeDateRange : [],
        ...!isIssueDoneInClosedSprint && changeDateRange.length > 0 ? [
            (0, $l1G1t.createSeparator)('move-actions')
        ] : [],
        ...!isMultiSelectMode ? linkIssue : [],
        ...changeParent,
        ...!isIssueDoneInClosedSprint ? changeTeam : []
    ];
};
const $6ec468c162141f11$var$MenuRendererWithMenuItems = /*#__PURE__*/ (0, $5uXOq.memo)(({ issueId: issueId, issueKey: issueKey, scope: scope, triggerRef: triggerRef })=>{
    const selectedCardIdFromState = (0, $67sX6.useBoardSelector)((0, $9OPlz.getVisibleCardSelection));
    const shouldUseIncrementPlanningContextMenu = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_INCREMENT_PLANNING_CONTEXT_MENU);
    const useContextMenuItemsFn = shouldUseIncrementPlanningContextMenu ? $6ec468c162141f11$export$6fdab4f20d43bd5c : $6ec468c162141f11$export$c087a1fcddb96d21;
    const menuItems = useContextMenuItemsFn({
        issueId: issueId,
        issueKey: issueKey,
        selectedCardIds: selectedCardIdFromState,
        returnFocusRef: triggerRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4tD4f.AsyncMenuRenderer), {
        scope: scope,
        menuItems: menuItems,
        triggerRef: triggerRef,
        ...shouldUseIncrementPlanningContextMenu ? {
            shouldRenderToParent: false
        } : {}
    });
});
const $6ec468c162141f11$export$8dc6765e8be191c7 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { issueId: issueId, issueKey: issueKey, selectedCardIds: selectedCardIds, appearance: appearance } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { handleOnClose: handleOnIssueLinkedStatsClose } = (0, $7dRcU.useIssueLinkedStatsActions)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const renderMenu = (0, $5uXOq.useCallback)((scope, menuTriggerRef)=>{
        handleOnIssueLinkedStatsClose();
        if (appearance === (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b)) {
            const { triggerRef: triggerRef } = props;
            if (triggerRef && menuTriggerRef?.current) triggerRef.current = menuTriggerRef.current;
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ec468c162141f11$var$MenuRendererWithMenuItems, {
            scope: scope,
            issueId: issueId,
            issueKey: issueKey,
            triggerRef: menuTriggerRef
        });
    }, [
        handleOnIssueLinkedStatsClose,
        appearance,
        issueId,
        issueKey,
        props
    ]);
    const onOpenChange = appearance === (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b) ? props.onOpenChange : null;
    const handleOnOpenChange = (0, $5uXOq.useCallback)((isOpen)=>{
        if ((0, $4R6GH.fg)('render_program_board_card_in_popup')) {
            if (isOpen) dispatch((0, $2f454.setInlineEditing)('contextMenu', issueId, true));
            else dispatch((0, $2f454.setInlineEditing)('contextMenu', issueId, false));
        }
        if (onOpenChange) onOpenChange(isOpen);
    }, [
        onOpenChange,
        dispatch,
        issueId
    ]);
    if (appearance === (0, $d9cdb1c71f9dbf8c$export$bb79bd28759ee895)) {
        const { children: children } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jUyjb.SoftwareContextMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            selectedCardIds: selectedCardIds,
            analyticsMapping: (0, $aqBCK.ANALYTICS_MAPPING_TABLE),
            cardId: issueId,
            jsErrorBoundaryProps: {
                id: 'boardCardContextMenu',
                packageName: 'software-board',
                teamName: 'a4t-tanuki'
            }
        }, children);
    }
    if (appearance === (0, $d9cdb1c71f9dbf8c$export$ee5015c6ad52cf0b)) {
        const { summary: summary } = props;
        const menuTriggerMoreCardsMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kOuTq.default).menuTriggerMoreCardsIssueTermRefresh : (0, $kOuTq.default).menuTriggerMoreCards;
        const menuTriggerOneCardMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kOuTq.default).menuTriggerOneCardIssueTermRefresh : (0, $kOuTq.default).menuTriggerOneCard;
        const ariaLabelMessage = formatMessage(selectedCardIds.length > 1 ? menuTriggerMoreCardsMessage : menuTriggerOneCardMessage, {
            summary: summary,
            issueKey: issueKey
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fhtW3.MeatballMenu), {
            scope: `${issueId}`,
            renderMenu: renderMenu,
            selectedCardIds: selectedCardIds,
            cardId: issueId,
            ariaLabel: ariaLabelMessage,
            analyticsMapping: (0, $aqBCK.ANALYTICS_MAPPING_TABLE),
            onOpenChange: handleOnOpenChange,
            jsErrorBoundaryProps: {
                id: 'boardCardMeatballMenu',
                packageName: 'software-board',
                teamName: 'a4t-tanuki'
            }
        });
    }
    return null;
});

});
parcelRegister("7dRcU", function(module, exports) {

$parcel$export(module.exports, "IssueLinkedStatsContainer", () => $9a68f043454281c4$export$505b706e3d6d12a5);
$parcel$export(module.exports, "useIsIssueLinkDetailsPopupOpen", () => $9a68f043454281c4$export$8676fe1451c567fe);
$parcel$export(module.exports, "useIssueLinkedStatsActions", () => $9a68f043454281c4$export$422d63f0d398cbef);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $1N3ww = parcelRequire("1N3ww");
const $9a68f043454281c4$export$d4c72bab9d6cc13a = {
    openedIssueKey: ''
};
const $9a68f043454281c4$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $9a68f043454281c4$export$d4c72bab9d6cc13a,
    actions: $1N3ww.actions,
    name: 'issue-links-stats-store'
});
const $9a68f043454281c4$export$505b706e3d6d12a5 = (0, $gg7kZ.createContainer)($9a68f043454281c4$export$6f57813fe9f31bf9, {
    onInit: ()=>({ setState: setState })=>{
            setState($9a68f043454281c4$export$d4c72bab9d6cc13a);
        }
});
const $9a68f043454281c4$var$getIsIssueLinkDetailsPopupOpen = (state, { openedIssueKey: openedIssueKey })=>state.openedIssueKey === openedIssueKey;
const $9a68f043454281c4$export$8676fe1451c567fe = (0, $3sQ5x.createStateHook)($9a68f043454281c4$export$6f57813fe9f31bf9, {
    selector: $9a68f043454281c4$var$getIsIssueLinkDetailsPopupOpen
});
const $9a68f043454281c4$export$bcae2c091ad340de = (0, $3sQ5x.createHook)($9a68f043454281c4$export$6f57813fe9f31bf9);
const $9a68f043454281c4$export$422d63f0d398cbef = (0, $3sQ5x.createActionsHook)($9a68f043454281c4$export$6f57813fe9f31bf9);

});
parcelRegister("1N3ww", function(module, exports) {

$parcel$export(module.exports, "actions", () => $9033a4e50ad01cf1$export$e324594224ef24da);
const $9033a4e50ad01cf1$export$2c8fecc3dc2f2779 = ()=>({ setState: setState })=>{
        setState({
            openedIssueKey: ''
        });
    };
const $9033a4e50ad01cf1$export$a49541cb3ca2f8cf = (openedIssueKey)=>({ setState: setState })=>{
        setState({
            openedIssueKey: openedIssueKey
        });
    };
const $9033a4e50ad01cf1$export$e324594224ef24da = {
    handleOnClose: $9033a4e50ad01cf1$export$2c8fecc3dc2f2779,
    handleOnOpenLinkedIssueDetailsPopup: $9033a4e50ad01cf1$export$a49541cb3ca2f8cf
};

});


parcelRegister("4tD4f", function(module, exports) {

$parcel$export(module.exports, "MeatballMenuLazy", () => $65fdd06020fea880$export$e5a84b368c677a12);
$parcel$export(module.exports, "AsyncMeatballMenu", () => $65fdd06020fea880$export$dad57d856f7c40e9);
$parcel$export(module.exports, "AsyncMenuRenderer", () => $65fdd06020fea880$export$481d980aecfdabe6);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $h9HNs = parcelRequire("h9HNs");

var $6GBq8 = parcelRequire("6GBq8");

const $65fdd06020fea880$export$e5a84b368c677a12 = (0, $kxZPA.lazy)(()=>Promise.resolve((parcelRequire("fhtW3"))).then((module)=>module.MeatballMenu), {
    moduleId: "./src/packages/software/context-menu/src/ui/MeatballMenu.tsx"
});

/* istanbul ignore next */ // eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $65fdd06020fea880$var$AsyncMenuRendererLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("dUtxn")).then((module)=>module.MenuRenderer), {
    moduleId: "./src/packages/software/context-menu/src/ui/menu-renderer/index.tsx"
});
const $65fdd06020fea880$var$InternalAsyncMeatballMenu = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu-meatball-menu",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$export$e5a84b368c677a12, props));
const $65fdd06020fea880$export$dad57d856f7c40e9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9HNs.ContextMenuErrorBoundary), {
        id: "jira-software-context-menu-meatball-menu",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$InternalAsyncMeatballMenu, props));
const $65fdd06020fea880$export$481d980aecfdabe6 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "async-software-context-menu-menu-renderer",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6GBq8.MenuRendererPlaceholder), {
            menuItems: props.menuItems
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($65fdd06020fea880$var$AsyncMenuRendererLazy, props));

});
parcelRegister("h9HNs", function(module, exports) {

$parcel$export(module.exports, "ContextMenuErrorBoundary", () => $0bf642946ee45d6d$export$9253ba2022568501);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $0bf642946ee45d6d$export$9253ba2022568501 = ({ id: id, children: children, fallback: fallback })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: "jiraSoftwareContextMenu",
        fallback: fallback || 'unmount',
        teamName: "deliveroo"
    }, children);

});

parcelRegister("6GBq8", function(module, exports) {

$parcel$export(module.exports, "MenuRendererPlaceholder", () => $03bf8ee5a763f135$export$9c3503516e6b2b03);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $1HF4Y = parcelRequire("1HF4Y");

var $6ssLS = parcelRequire("6ssLS");

var $clxlA = parcelRequire("clxlA");
const $03bf8ee5a763f135$var$getChildren = (children)=>{
    return Array.isArray(children) ? children : [
        children
    ];
};
const $03bf8ee5a763f135$export$b12353dcfd2c40d3 = (menuItems)=>menuItems.reduce((acc, menuItem)=>{
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Separator) return acc + $clxlA.SEPARATOR_PLACEHOLDER_HEIGHT;
        if (menuItem.type === (0, $1HF4Y.MenuNodeType).Section) return acc + $clxlA.SECTION_HEADER_PLACEHOLDER_HEIGHT + ((0, $4R6GH.fg)('jfp_a11y_team_boards_list_markup_used_incorrectly') ? $03bf8ee5a763f135$export$b12353dcfd2c40d3($03bf8ee5a763f135$var$getChildren(menuItem.children)) : $03bf8ee5a763f135$export$b12353dcfd2c40d3(menuItem.children || []));
        return acc + $clxlA.MENU_ITEM_PLACEHOLDER_HEIGHT;
    }, 0);
const $03bf8ee5a763f135$export$9c3503516e6b2b03 = /*#__PURE__*/ (0, $5uXOq.memo)(({ menuItems: menuItems })=>{
    const height = $03bf8ee5a763f135$export$b12353dcfd2c40d3(menuItems);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03bf8ee5a763f135$var$Container, {
        "data-testid": $clxlA.CONTEXT_MENU_PLACEHOLDER_TESTID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03bf8ee5a763f135$var$InnerItems, {
        height: height
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $03bf8ee5a763f135$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $6ssLS.MenuContainer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bsbuuw1",
            __cmplp.className
        ])
    });
});
const $03bf8ee5a763f135$var$InnerItems = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1neqek2": (0, $lD23V.default)(`${__cmplp.height}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i2nrh _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1HF4Y", function(module, exports) {

$parcel$export(module.exports, "MenuNodeType", () => $8e9d98803c1f1230$export$d6a3c2c57b227e3b);
const $8e9d98803c1f1230$export$d6a3c2c57b227e3b = {
    Item: 'item',
    Node: 'node',
    Separator: 'separator',
    Section: 'section',
    Search: 'search',
    BulkIndicator: 'bulkIndicator'
};

});

parcelRegister("6ssLS", function(module, exports) {

$parcel$export(module.exports, "MenuContainer", () => $c700ae4c66d12196$export$b286f91cddfedb5a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $c700ae4c66d12196$export$b286f91cddfedb5a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1ul9uuw1 _c71ldgin _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf _vchhusvi _bfhk1bhr",
            __cmplp.className
        ])
    });
});

});

parcelRegister("clxlA", function(module, exports) {

$parcel$export(module.exports, "CONTEXT_MENU_PLACEHOLDER_TESTID", () => $be0729fb178ee569$export$d0775d7ba1f28e6);
$parcel$export(module.exports, "SEPARATOR_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$49b3e4b8a0edc9b7);
$parcel$export(module.exports, "SECTION_HEADER_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$71999dec35730ebd);
$parcel$export(module.exports, "MENU_ITEM_PLACEHOLDER_HEIGHT", () => $be0729fb178ee569$export$f9717b5566f9ac9f);

var $gwIPs = parcelRequire("gwIPs");

const $be0729fb178ee569$export$d0775d7ba1f28e6 = 'software-context-menu.ui.menu-renderer-placeholder';
const $be0729fb178ee569$export$49b3e4b8a0edc9b7 = (0, $gwIPs.gridSize) + 1;
const $be0729fb178ee569$export$71999dec35730ebd = (0, $gwIPs.gridSize) * 2;
const $be0729fb178ee569$export$f9717b5566f9ac9f = (0, $d9cdb1c71f9dbf8c$export$b9e05b29ae05bdd9);

});


parcelRegister("fhtW3", function(module, exports) {

$parcel$export(module.exports, "MeatballMenu", () => $8f2eab45fd3069e5$export$ef4a0fdddd7eccb7);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $6U9Sv = parcelRequire("6U9Sv");

var $ewaBk = parcelRequire("ewaBk");

var $2g5oC = parcelRequire("2g5oC");

var $g74eh = parcelRequire("g74eh");
const $8f2eab45fd3069e5$export$ef4a0fdddd7eccb7 = ({ cardId: cardId, selectedCardIds: selectedCardIds, analyticsMapping: analyticsMapping, scope: scope, ...props })=>{
    const fullScope = (0, $g74eh.makeScope)(scope, 'meatball');
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewaBk.ContextMenuContainer), {
        isGlobal: true,
        selectedCardIds: selectedCardIds,
        analyticsMapping: analyticsMapping,
        cardId: cardId,
        bulkOpsFlow: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U9Sv.ContextMenuAnalytics), {
        scope: fullScope,
        cardId: cardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2g5oC.MeatballMenu), {
        scope: fullScope,
        ...props
    })));
};

});
parcelRegister("iAbh9", function(module, exports) {

$parcel$export(module.exports, "BulkOpsAnalyticsProvider", () => $477c8df705ed825f$export$8ab440f197429d1e);
$parcel$export(module.exports, "useBulkOpsSessionContext", () => $477c8df705ed825f$export$95271787b6ae4d3c);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

var $8p26c = parcelRequire("8p26c");
const $477c8df705ed825f$var$BulkOpsAnalyticsContext = /*#__PURE__*/ (0, $5uXOq.createContext)(null);
const $477c8df705ed825f$export$8ab440f197429d1e = (props)=>{
    const [bulkOpsFlow] = (0, $5uXOq.useState)(new (0, $8p26c.DefaultBulkOpsFlow)());
    const [bulkOpsSessionID, setBulkOpsSessionID] = (0, $5uXOq.useState)(bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID || undefined);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = bulkOpsFlow?.registerAnalyticsEventPublisher((sessionId)=>{
            setBulkOpsSessionID(sessionId);
        });
        return ()=>{
            unsubscribe?.();
        };
    }, [
        bulkOpsFlow
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($477c8df705ed825f$var$BulkOpsAnalyticsContext.Provider, {
        value: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            bulkOpsSessionID: bulkOpsSessionID
        }
    }, props.children));
};
const $477c8df705ed825f$export$95271787b6ae4d3c = ()=>(0, $5uXOq.useContext)($477c8df705ed825f$var$BulkOpsAnalyticsContext);

});
parcelRegister("8p26c", function(module, exports) {

$parcel$export(module.exports, "DefaultBulkOpsFlow", () => $66219c4f12f760b8$export$74bf75c57acfbb74);

var $7Jxgt = parcelRequire("7Jxgt");
class $66219c4f12f760b8$export$74bf75c57acfbb74 {
    isInFlow() {
        return this.bulkOpsSessionID !== undefined;
    }
    get sessionID() {
        return this.bulkOpsSessionID;
    }
    get bulkActionsCompleted() {
        return this.numBulkActionsCompleted;
    }
    get bulkOperationType() {
        return this.bulkOperationTypeValue;
    }
    notifyAnalyticsEventPublishers(sessionID) {
        let index = 0;
        this.analyticsEventPublishers.forEach((listener)=>{
            listener(sessionID, index);
            index += 1;
        });
        this.analyticsEventPublishers.clear();
    }
    start(_attributes) {
        if (this.isInFlow()) return;
        this.bulkOpsSessionID = (0, $7Jxgt.v4)();
        this.notifyAnalyticsEventPublishers(this.bulkOpsSessionID);
    }
    end(_attributes) {
        this.bulkOpsSessionID = undefined;
        this.numBulkActionsCompleted = 0;
    }
    executeAction() {
        if (!this.isInFlow()) this.start();
        this.numBulkActionsCompleted += 1;
    }
    setBulkOperationType(bulkOperationType) {
        this.bulkOperationTypeValue = bulkOperationType;
    }
    getFlowAttributes() {
        if (this.bulkOpsSessionID && this.numBulkActionsCompleted !== 0) return {
            bulkOpsSessionID: this.bulkOpsSessionID,
            numBulkActionsCompleted: this.numBulkActionsCompleted
        };
        return this.bulkOpsSessionID ? {
            bulkOpsSessionID: this.bulkOpsSessionID
        } : {};
    }
    registerAnalyticsEventPublisher(analyticsEventPublisher) {
        this.analyticsEventPublishers.add(analyticsEventPublisher);
        return ()=>{
            this.analyticsEventPublishers.delete(analyticsEventPublisher);
        };
    }
    constructor(){
        this.numBulkActionsCompleted = 0;
        this.analyticsEventPublishers = new Set();
    }
}

});


parcelRegister("6U9Sv", function(module, exports) {

$parcel$export(module.exports, "useContextMenuAnalytics", () => $bd5d557ceb1e8011$export$e3e152955394305b);
$parcel$export(module.exports, "ContextMenuAnalytics", () => $bd5d557ceb1e8011$export$eceb0d68a993ec5c);
$parcel$export(module.exports, "ContextualAnalyticsDataFromNode", () => $bd5d557ceb1e8011$export$f9d8ab9f9d913310);
$parcel$export(module.exports, "useFireCheckboxAnalytics", () => $bd5d557ceb1e8011$export$41c45cbb6f557de5);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $iAbh9 = parcelRequire("iAbh9");

var $jcw0u = parcelRequire("jcw0u");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $ewaBk = parcelRequire("ewaBk");

var $gj8F1 = parcelRequire("gj8F1");
const $bd5d557ceb1e8011$export$e3e152955394305b = ()=>{
    const analyticsMapping = (0, $ewaBk.useAnalyticsMapping)();
    const getAnalyticsMapping = (0, $5uXOq.useMemo)(()=>(0, $gj8F1.createGetAnalyticsMapping)(analyticsMapping), [
        analyticsMapping
    ]);
    const addMappedAnalyticsToEvent = (0, $5uXOq.useCallback)((event, id, updater)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        if (mappedAnalytics && typeof mappedAnalytics === 'object') {
            const { actionSubjectId: actionSubjectId, attributes: attributes, ...analytics } = mappedAnalytics;
            event.update(analytics);
        }
        if (updater) {
            if (typeof updater === 'function') event.update(updater);
            else {
                const { actionSubjectId: actionSubjectId, attributes: attributes, ...analytics } = updater;
                event.update(analytics);
            }
        }
        return event;
    }, [
        getAnalyticsMapping
    ]);
    const getAttributesForId = (0, $5uXOq.useCallback)((id, updater)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        const mappedAttributes = typeof mappedAnalytics === 'object' ? mappedAnalytics.attributes : undefined;
        return typeof updater === 'object' ? {
            ...mappedAttributes,
            ...updater?.attributes
        } : mappedAttributes;
    }, [
        getAnalyticsMapping
    ]);
    const fireUIAnalyticsForNode = (0, $5uXOq.useCallback)((event, id, updater, attributes)=>{
        const mappedAnalytics = getAnalyticsMapping(id);
        let subjectId = typeof updater === 'function' ? updater(event.payload).actionSubjectId : updater?.actionSubjectId;
        if (!subjectId && mappedAnalytics) subjectId = typeof mappedAnalytics === 'string' ? mappedAnalytics : mappedAnalytics.actionSubjectId;
        if (attributes) subjectId ? (0, $8zOmE.fireUIAnalytics)(event, subjectId, attributes) : (0, $8zOmE.fireUIAnalytics)(event, attributes);
        else subjectId ? (0, $8zOmE.fireUIAnalytics)(event, subjectId) : (0, $8zOmE.fireUIAnalytics)(event);
    }, [
        getAnalyticsMapping
    ]);
    const values = (0, $5uXOq.useMemo)(()=>({
            fireUIAnalyticsForNode: fireUIAnalyticsForNode,
            getAttributesForId: getAttributesForId,
            addMappedAnalyticsToEvent: addMappedAnalyticsToEvent
        }), [
        fireUIAnalyticsForNode,
        getAttributesForId,
        addMappedAnalyticsToEvent
    ]);
    return values;
};
const $bd5d557ceb1e8011$export$eceb0d68a993ec5c = ({ scope: scope, children: children, cardId: cardId })=>{
    const attributes = (0, $ewaBk.useAnalyticsAttributes)({
        scope: scope,
        cardId: cardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, children);
};
const $bd5d557ceb1e8011$export$f9d8ab9f9d913310 = ({ id: id, updater: updater, children: children })=>{
    const { getAttributesForId: getAttributesForId } = $bd5d557ceb1e8011$export$e3e152955394305b();
    const attributes = (0, $5uXOq.useMemo)(()=>getAttributesForId(id, updater), [
        getAttributesForId,
        id,
        updater
    ]);
    if (!attributes) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: attributes
    }, children);
};
const $bd5d557ceb1e8011$export$41c45cbb6f557de5 = ()=>{
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    const subscriptionHandle = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    const fireCheckboxAnalytics = (0, $5uXOq.useCallback)((event, actionSubjectId, attributes)=>{
        if (!bulkOpsFlow) {
            (0, $jcw0u.default)({
                error: new Error('Trying to fire checkbox analytics when bulkOpsFlow is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-analytics-use-fire-checkbox-analytics',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                },
                attributes: {
                    actionSubjectId: actionSubjectId,
                    attributes: attributes
                }
            });
            (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, {
                ...attributes,
                bulkOpsSessionID: 'unknown'
            });
            return;
        }
        if (bulkOpsFlow.isInFlow()) (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributes);
        else subscriptionHandle.current = bulkOpsFlow.registerAnalyticsEventPublisher((sessionID)=>{
            const attributesWithSessionId = {
                ...attributes,
                bulkOpsSessionID: sessionID
            };
            (0, $8zOmE.fireUIAnalytics)(event, actionSubjectId, attributesWithSessionId);
        });
    }, [
        bulkOpsFlow,
        subscriptionHandle
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            return subscriptionHandle.current();
        }, []);
    return fireCheckboxAnalytics;
};

});
parcelRegister("ewaBk", function(module, exports) {

$parcel$export(module.exports, "useContextMenuStore", () => $1b2687c2318490cf$export$d1b2e16030b3efbf);
$parcel$export(module.exports, "useContextMenuActions", () => $1b2687c2318490cf$export$fb508b9bcc816326);
$parcel$export(module.exports, "ContextMenuContainer", () => $1b2687c2318490cf$export$4f48a5067cf73390);
$parcel$export(module.exports, "useMenuItemCheckOpen", () => $1b2687c2318490cf$export$60c643cac8887fbe);
$parcel$export(module.exports, "useShouldForceFocus", () => $1b2687c2318490cf$export$ac348ec4828a6056);
$parcel$export(module.exports, "useIsMenuOpen", () => $1b2687c2318490cf$export$3eef7351bd308de1);
$parcel$export(module.exports, "useAnalyticsAttributes", () => $1b2687c2318490cf$export$1fd8522aeddaccda);
$parcel$export(module.exports, "useAnalyticsMapping", () => $1b2687c2318490cf$export$aeb28cc7c774c3ed);
$parcel$export(module.exports, "useIsAnyMenuOpen", () => $1b2687c2318490cf$export$91d90cb66ff7a71e);
$parcel$export(module.exports, "useIsPersistentFocus", () => $1b2687c2318490cf$export$1e85791d95627e79);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $jwhNt = parcelRequire("jwhNt");

var $f19dW = parcelRequire("f19dW");

var $5tijM = parcelRequire("5tijM");
const $1b2687c2318490cf$var$ContextMenuStore = (0, $iXqE5.createStore)({
    name: 'software-context-menu',
    initialState: (0, $f19dW.getInitialState)(),
    actions: $f19dW.actions
});
const $1b2687c2318490cf$export$d1b2e16030b3efbf = (0, $3sQ5x.createHook)($1b2687c2318490cf$var$ContextMenuStore);
const $1b2687c2318490cf$export$fb508b9bcc816326 = (0, $3sQ5x.createActionsHook)($1b2687c2318490cf$var$ContextMenuStore);
const $1b2687c2318490cf$export$4f48a5067cf73390 = (0, $gg7kZ.createContainer)($1b2687c2318490cf$var$ContextMenuStore, {
    onInit: (0, $5tijM.onContainerInit),
    onUpdate: (0, $5tijM.onContainerUpdate)
});
const $1b2687c2318490cf$var$getMenuItemOpen = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.openPath?.startsWith(menuItem.id);
const $1b2687c2318490cf$export$60c643cac8887fbe = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getMenuItemOpen
});
const $1b2687c2318490cf$var$getIsFocusForced = (state, { menuItem: menuItem, scope: scope })=>state.menus[scope]?.forcedFocusPath === menuItem.id;
const $1b2687c2318490cf$export$ac348ec4828a6056 = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsFocusForced
});
const $1b2687c2318490cf$var$getIsMenuOpen = (state, { scope: scope })=>state.openMenu === scope;
const $1b2687c2318490cf$export$3eef7351bd308de1 = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsMenuOpen
});
const $1b2687c2318490cf$var$getAnalyticsAttributes = (state, { scope: scope, cardId: cardId })=>{
    const isMenuOpen = $1b2687c2318490cf$var$getIsMenuOpen(state, {
        scope: scope
    });
    const { analytics: { selectedCardIds: selectedCardIds } } = state;
    return (0, $jwhNt.getCardSelectionAnalytics)(selectedCardIds, cardId, isMenuOpen);
};
const $1b2687c2318490cf$export$1fd8522aeddaccda = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getAnalyticsAttributes
});
const $1b2687c2318490cf$var$getAnalyticsMapping = (state)=>state.analytics.analyticsMapping;
const $1b2687c2318490cf$export$aeb28cc7c774c3ed = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getAnalyticsMapping
});
const $1b2687c2318490cf$export$d8b7614abf2894d6 = (state)=>!!state.openMenu;
const $1b2687c2318490cf$export$91d90cb66ff7a71e = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$export$d8b7614abf2894d6
});
const $1b2687c2318490cf$var$getIsPersistentFocus = (state)=>!!state?.persistentFocus;
const $1b2687c2318490cf$export$1e85791d95627e79 = (0, $3sQ5x.createStateHook)($1b2687c2318490cf$var$ContextMenuStore, {
    selector: $1b2687c2318490cf$var$getIsPersistentFocus
});

});
parcelRegister("jwhNt", function(module, exports) {

$parcel$export(module.exports, "hasUserStartedSelecting", () => $17a2da3770fdd915$export$5195d9082487fa42);
$parcel$export(module.exports, "hasUserUnselectedAll", () => $17a2da3770fdd915$export$3b8cd3ffacc95e4f);
$parcel$export(module.exports, "getCardSelectionAnalytics", () => $17a2da3770fdd915$export$f96eca8ded123f8b);
$parcel$export(module.exports, "shouldFlowBeEnded", () => $17a2da3770fdd915$export$539307982a715ea8);
const $17a2da3770fdd915$export$5195d9082487fa42 = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length === 0 && contextMenuContainerAnalytics.selectedCardIds.length > 0;
const $17a2da3770fdd915$export$3b8cd3ffacc95e4f = (analytics, contextMenuContainerAnalytics)=>analytics.selectedCardIds.length > 0 && contextMenuContainerAnalytics.selectedCardIds.length === 0;
const $17a2da3770fdd915$export$f96eca8ded123f8b = (selectedCardIds, cardId, isMenuOpen)=>{
    let cardIds;
    if (isMenuOpen) cardIds = selectedCardIds.includes(cardId) ? selectedCardIds : [
        cardId
    ];
    else cardIds = selectedCardIds;
    const numSelectedCards = cardIds.length;
    return {
        numSelectedCards: numSelectedCards,
        issue_ids: cardIds,
        issue_id: cardId
    };
};
const $17a2da3770fdd915$export$539307982a715ea8 = (analytics, contextMenuContainerAnalytics, bulkOpsFlow)=>{
    const sessionID = !!bulkOpsFlow?.getFlowAttributes().bulkOpsSessionID;
    return sessionID && contextMenuContainerAnalytics.selectedCardIds.length === 0;
};

});

parcelRegister("f19dW", function(module, exports) {

$parcel$export(module.exports, "getInitialState", () => $c2d99694a10aebe1$export$53ac33307b5acee9);
$parcel$export(module.exports, "actions", () => $c2d99694a10aebe1$export$e324594224ef24da);

var $jcw0u = parcelRequire("jcw0u");

var $5tijM = parcelRequire("5tijM");
const $c2d99694a10aebe1$export$53ac33307b5acee9 = ()=>({
        menus: {},
        openMenu: null,
        analytics: {
            selectedCardIds: []
        },
        lastAction: {
            action: 'init',
            scope: undefined
        }
    });
const $c2d99694a10aebe1$export$aad8462122ac592b = (lastAction)=>({ setState: setState })=>{
        const { analytics: analytics, ...initialState } = $c2d99694a10aebe1$export$53ac33307b5acee9();
        initialState.lastAction = lastAction || {
            action: 'reset'
        };
        setState(initialState);
    };
const $c2d99694a10aebe1$var$setPersistentFocus = (persistentFocus)=>({ setState: setState })=>{
        setState({
            persistentFocus: persistentFocus
        });
    };
const $c2d99694a10aebe1$var$openMenu = ({ position: position, scope: scope, analyticsEvent: analyticsEvent, persistentFocus: persistentFocus, openedFrom: openedFrom })=>({ setState: setState }, { selectedCardIds: selectedCardIds, cardId: cardId })=>{
        (0, $5tijM.fireOpenMenuAnalyticsEvent)({
            event: analyticsEvent,
            selectedCardIds: selectedCardIds,
            cardId: cardId,
            openedFrom: openedFrom
        });
        setState({
            openMenu: scope,
            persistentFocus: persistentFocus,
            menus: {
                [scope]: {
                    openPath: undefined,
                    scope: scope,
                    position: position,
                    forcedFocusPath: undefined
                }
            },
            lastAction: {
                action: 'openMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$11ed9b7b8045d408 = (scope, menuItem)=>({ setState: setState, getState: getState })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-open-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: menuItem.id
                }
            },
            lastAction: {
                action: 'openSubMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$69ff42680518db68 = (scope)=>({ getState: getState, dispatch: dispatch })=>{
        const { menus: menus, lastAction: lastAction } = getState();
        const menuState = menus[scope];
        if (!menuState) {
            if (lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${lastAction?.action}) scopes(${lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        dispatch($c2d99694a10aebe1$export$aad8462122ac592b({
            action: 'closeMenu',
            scope: scope
        }));
    };
const $c2d99694a10aebe1$var$closeSubMenu = (scope)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope})`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-close-sub-menu-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    openPath: undefined
                }
            },
            lastAction: {
                action: 'closeSubMenu',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$var$setForcedFocusPath = (scope, id)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const menuState = state.menus[scope];
        if (!menuState) {
            if (state.lastAction?.action === 'closeMenu') return;
            const errorMessage = `Menu state is not defined - last action(${state.lastAction?.action}) scopes(${state.lastAction?.scope}-${scope}`;
            const error = new Error(errorMessage);
            (0, $jcw0u.default)({
                error: error,
                meta: {
                    id: 'jira-software-context-menu-controller-set-focused-path-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        setState({
            menus: {
                [scope]: {
                    ...menuState,
                    forcedFocusPath: id
                }
            },
            lastAction: {
                action: 'setForcedFocusPath',
                scope: scope
            }
        });
    };
const $c2d99694a10aebe1$export$e324594224ef24da = {
    openMenu: $c2d99694a10aebe1$var$openMenu,
    closeMenu: $c2d99694a10aebe1$export$69ff42680518db68,
    openSubMenu: $c2d99694a10aebe1$export$11ed9b7b8045d408,
    closeSubMenu: $c2d99694a10aebe1$var$closeSubMenu,
    setForcedFocusPath: $c2d99694a10aebe1$var$setForcedFocusPath,
    reset: $c2d99694a10aebe1$export$aad8462122ac592b,
    setPersistentFocus: $c2d99694a10aebe1$var$setPersistentFocus
};

});
parcelRegister("5tijM", function(module, exports) {

$parcel$export(module.exports, "onContainerInit", () => $61c942cebc868b99$export$34f4621b58d3fbc8);
$parcel$export(module.exports, "onContainerUpdate", () => $61c942cebc868b99$export$ab8f0de40a3a2d2d);
$parcel$export(module.exports, "fireOpenMenuAnalyticsEvent", () => $61c942cebc868b99$export$d4ad71c555abd3c8);

var $ajpes = parcelRequire("ajpes");

var $jcw0u = parcelRequire("jcw0u");

var $8zOmE = parcelRequire("8zOmE");

var $4R6GH = parcelRequire("4R6GH");

var $jwhNt = parcelRequire("jwhNt");
const $61c942cebc868b99$export$34f4621b58d3fbc8 = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        if ((0, $4R6GH.fg)('jira-concurrent-contextual-menu-fix')) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(getState().analytics, analyticsContainerProps)) setState({
                analytics: {
                    ...analyticsContainerProps
                }
            });
        } else setState({
            analytics: {
                ...analyticsContainerProps
            }
        });
        if (bulkOpsFlow && (0, $jwhNt.shouldFlowBeEnded)(analytics, analyticsContainerProps, bulkOpsFlow)) bulkOpsFlow?.end();
        else if (bulkOpsFlow && (0, $jwhNt.hasUserStartedSelecting)(analytics, analyticsContainerProps)) bulkOpsFlow?.start();
    };
const $61c942cebc868b99$export$ab8f0de40a3a2d2d = ()=>({ setState: setState, getState: getState }, { cardId: cardId, bulkOpsFlow: bulkOpsFlow, ...analyticsContainerProps })=>{
        const { analytics: analytics } = getState();
        if ((0, $jwhNt.hasUserStartedSelecting)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $jcw0u.default)({
                error: new Error('Trying to start a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.start();
        } else if ((0, $jwhNt.hasUserUnselectedAll)(analytics, analyticsContainerProps)) {
            if (!bulkOpsFlow) (0, $jcw0u.default)({
                error: new Error('Trying to end a flow while bulkOpsSession is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-end-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            else bulkOpsFlow?.end();
        }
        setState({
            analytics: {
                ...analytics,
                ...analyticsContainerProps
            }
        });
    };
const $61c942cebc868b99$export$d4ad71c555abd3c8 = ({ event: event, cardId: cardId, selectedCardIds: selectedCardIds, openedFrom: openedFrom })=>{
    const attributes = {
        ...(0, $jwhNt.getCardSelectionAnalytics)(selectedCardIds, cardId, true),
        isLinkIssueFromBoardCardEnabled: true,
        openedFrom: openedFrom
    };
    // Attributes normally get merged together. We want to override the issue_ids attribute instead
    event.context.push({
        attributes: {
            issue_ids: null
        }
    });
    (0, $8zOmE.fireUIAnalytics)(event, 'cardActions', attributes);
};

});



parcelRegister("gj8F1", function(module, exports) {

$parcel$export(module.exports, "createGetAnalyticsMapping", () => $84e9c18cb7a7bed7$export$836ec4673aac623f);

var $gJBT6 = parcelRequire("gJBT6");
const $84e9c18cb7a7bed7$export$7b036678329a3ea2 = (id, analyticsMapping)=>{
    let result = analyticsMapping[id];
    if (!result) {
        const matchedId = Object.keys(analyticsMapping).find((key)=>key.startsWith(id) || id.startsWith(key));
        if (matchedId) result = analyticsMapping[matchedId];
    }
    return result;
};
const $84e9c18cb7a7bed7$export$836ec4673aac623f = (analyticsMapping)=>{
    if (!analyticsMapping) return (_id)=>undefined;
    // Sorting the analytics mapping by key length ensures that the shortest key is matched first - shortest key means best match
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const sortedAnalyticsMapping = Object.fromEntries(Object.entries(analyticsMapping).sort(([keyA], [keyB])=>keyA.length - keyB.length));
    const memoizedGetterFunction = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))($84e9c18cb7a7bed7$export$7b036678329a3ea2);
    return (id)=>memoizedGetterFunction(id, sortedAnalyticsMapping);
};

});


parcelRegister("2g5oC", function(module, exports) {

$parcel$export(module.exports, "MeatballMenu", () => $13a9ebb12169281b$export$ef4a0fdddd7eccb7);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $8U6zd = parcelRequire("8U6zd");

var $bJeNF = parcelRequire("bJeNF");

var $7CMCs = parcelRequire("7CMCs");

var $jgJNO = parcelRequire("jgJNO");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $ewaBk = parcelRequire("ewaBk");


var $2bK3l = parcelRequire("2bK3l");
const $13a9ebb12169281b$export$ef4a0fdddd7eccb7 = ({ onOpenChange: onOpenChange, scope: scope, renderMenu: renderMenu, ariaLabel: ariaLabel, isCompact: isCompact, jsErrorBoundaryProps: jsErrorBoundaryProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { openMenu: openMenu, closeMenu: closeMenu } = (0, $ewaBk.useContextMenuActions)();
    const isOpen = (0, $ewaBk.useIsMenuOpen)({
        scope: scope
    });
    const triggerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        onOpenChange?.(isOpen);
    }, [
        isOpen,
        onOpenChange
    ]);
    const renderContent = (0, $5uXOq.useCallback)(({ isOpen: isContentOpen })=>isContentOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            fallback: "unmount",
            ...jsErrorBoundaryProps
        }, ' ', renderMenu(scope, triggerRef)) : null, [
        renderMenu,
        scope,
        jsErrorBoundaryProps
    ]);
    const onClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        e.stopPropagation();
        analyticsEvent.update({
            action: 'opened',
            actionSubject: 'contextMenu'
        });
        if (!isOpen) openMenu({
            scope: scope,
            position: {
                x: 0,
                y: 0
            },
            analyticsEvent: analyticsEvent,
            persistentFocus: e.detail === 0 || undefined,
            openedFrom: 'meatball'
        });
        else closeMenu(scope);
    }, [
        closeMenu,
        isOpen,
        openMenu,
        scope
    ]);
    const handleKeyDown = (0, $5uXOq.useCallback)((e)=>{
        if (e.key === 'Enter') e.stopPropagation();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        placement: "bottom-end",
        content: renderContent,
        shouldRenderToParent: true,
        messageId: "software-context-menu.ui.meatball-menu.popup",
        messageType: "transactional",
        trigger: ({ ref: popupRef, ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
                attributes: {
                    inputSource: 'threeDot'
                }
            }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...triggerProps,
                appearance: "subtle",
                spacing: // eslint-disable-next-line no-nested-ternary
                (0, $dCm1o.isVisualRefreshEnabled)() ? 'compact' : isCompact ? 'compact' : 'default',
                testId: (0, $00df11e79838cf5e$export$7449a807b3ce7b1c),
                icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                onClick: onClick,
                onKeyDown: handleKeyDown,
                label: ariaLabel,
                ref: (r)=>{
                    if (popupRef) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    popupRef(r);
                    triggerRef.current = r;
                },
                ...(0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? {
                    isTooltipDisabled: false,
                    tooltip: {
                        content: formatMessage((0, $2bK3l.default).moreActionsTooltip),
                        hideTooltipOnClick: true
                    }
                } : {}
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                ...triggerProps,
                spacing: isCompact ? 'compact' : 'default',
                testId: (0, $00df11e79838cf5e$export$7449a807b3ce7b1c),
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
                onClick: onClick,
                onKeyDown: handleKeyDown,
                "aria-label": ariaLabel,
                ref: (r)=>{
                    if (popupRef) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                    popupRef(r);
                    triggerRef.current = r;
                }
            }))
    });
};

});
const $00df11e79838cf5e$export$7449a807b3ce7b1c = 'software-context-menu.meatball-menu';

parcelRegister("2bK3l", function(module, exports) {

$parcel$export(module.exports, "default", () => $784647cebaff00a0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $784647cebaff00a0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moreActionsTooltip: {
        "id": "jira.platform.software.context-menu.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});


parcelRegister("g74eh", function(module, exports) {

$parcel$export(module.exports, "makeScope", () => $ce0e9067ffc1f4fc$export$79c43e8605ed7f8f);
const $ce0e9067ffc1f4fc$export$79c43e8605ed7f8f = (scope, menuType)=>`${scope}-${menuType}`;

});


parcelRegister("dUtxn", function(module, exports) {

let $a2076ad63adba6fe$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2076ad63adba6fe$var$load("9NWgM").then(()=>parcelRequire('6hc7I'));

});


parcelRegister("jUyjb", function(module, exports) {

$parcel$export(module.exports, "SoftwareContextMenu", () => $b46123cf94546d90$export$b89cae60b0c2d978);

var $5uXOq = parcelRequire("5uXOq");

var $c1wAv = parcelRequire("c1wAv");

var $g5XcP = parcelRequire("g5XcP");

var $gjL94 = parcelRequire("gjL94");
const $b46123cf94546d90$export$b89cae60b0c2d978 = (props)=>{
    const openContextMenuRef = (0, $5uXOq.useRef)(null);
    const childrenRef = (0, $5uXOq.useRef)(null);
    const { onContextMenu: onContextMenu } = (0, $g5XcP.useOnContextMenu)({
        childrenRef: childrenRef,
        openContextMenuRef: openContextMenuRef
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1wAv.ChildrenWrapperWithAnalytics), {
        onChildrenContextMenu: onContextMenu,
        ref: childrenRef
    }, props.children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjL94.ContextMenu), {
        ...props,
        openContextMenuRef: openContextMenuRef
    }));
};

});
parcelRegister("c1wAv", function(module, exports) {

$parcel$export(module.exports, "ChildrenWrapperWithAnalytics", () => $5fcbc6bc21c0dd31$export$1249ce36e893a19b);

var $5uXOq = parcelRequire("5uXOq");

var $2OMDV = parcelRequire("2OMDV");
var $iXVV6 = parcelRequire("iXVV6");

const $5fcbc6bc21c0dd31$var$WrapperWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('contextMenu', {
    onContextMenu: 'opened'
})(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ...props,
        ref: ref
    })));
const $5fcbc6bc21c0dd31$export$1249ce36e893a19b = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, onChildrenContextMenu: onChildrenContextMenu }, ref)=>{
    const WrapperWithAnalyticsComponent = $5fcbc6bc21c0dd31$var$WrapperWithAnalytics;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            inputSource: 'rightClick'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrapperWithAnalyticsComponent, {
        ref: ref,
        onContextMenu: onChildrenContextMenu,
        "data-testid": (0, $c261fa84ee29a782$export$1790245723dd00ad)
    }, children));
});

});
const $c261fa84ee29a782$export$1790245723dd00ad = 'software-context-menu.ui.context-menu.children-wrapper';


parcelRegister("g5XcP", function(module, exports) {

$parcel$export(module.exports, "useOnContextMenu", () => $f82fb67b9a97c056$export$ca7798d25343efd8);

var $jcw0u = parcelRequire("jcw0u");

var $7D59a = parcelRequire("7D59a");
const $f82fb67b9a97c056$export$ca7798d25343efd8 = ({ childrenRef: childrenRef, openContextMenuRef: openContextMenuRef })=>{
    const onContextMenu = (0, $7D59a.useEvent)((e, analyticsEvent)=>{
        e.stopPropagation();
        if (!childrenRef?.current || !openContextMenuRef?.current) {
            !childrenRef?.current && (0, $jcw0u.default)({
                error: new Error('Trying to open a context menu while childrenRef is undefined'),
                meta: {
                    id: 'jira-software-context-menu-controller-on-container-update-flow-start-error',
                    packageName: 'jiraSoftwareContextMenu',
                    teamName: 'deliveroo'
                }
            });
            return;
        }
        e.preventDefault();
        const { top: top, left: left } = childrenRef.current.getBoundingClientRect();
        const position = {
            x: e.clientX - left,
            y: e.clientY - top
        };
        openContextMenuRef.current.onOpenContextMenu({
            position: position,
            analyticsEvent: analyticsEvent
        });
    });
    return {
        onContextMenu: onContextMenu
    };
};

});

parcelRegister("gjL94", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $4b3b6d0eac56b850$export$8dc6765e8be191c7);

var $5uXOq = parcelRequire("5uXOq");

var $iAbh9 = parcelRequire("iAbh9");

var $6U9Sv = parcelRequire("6U9Sv");

var $ewaBk = parcelRequire("ewaBk");

var $2sMT6 = parcelRequire("2sMT6");

var $g74eh = parcelRequire("g74eh");
const $4b3b6d0eac56b850$export$8dc6765e8be191c7 = ({ cardId: cardId, selectedCardIds: selectedCardIds, analyticsMapping: analyticsMapping, scope: scope, ...props })=>{
    const fullScope = (0, $g74eh.makeScope)(scope, 'context');
    const bulkOpsFlow = (0, $iAbh9.useBulkOpsSessionContext)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewaBk.ContextMenuContainer), {
        isGlobal: true,
        selectedCardIds: selectedCardIds,
        analyticsMapping: analyticsMapping,
        cardId: cardId,
        bulkOpsFlow: bulkOpsFlow
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6U9Sv.ContextMenuAnalytics), {
        scope: fullScope,
        cardId: cardId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2sMT6.ContextMenu), {
        scope: fullScope,
        ...props
    })));
};

});
parcelRegister("2sMT6", function(module, exports) {

$parcel$export(module.exports, "ContextMenu", () => $a851f60f5a7b5635$export$8dc6765e8be191c7);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $4R6GH = parcelRequire("4R6GH");

var $ewaBk = parcelRequire("ewaBk");

var $5rXNu = parcelRequire("5rXNu");


var $58mnS = parcelRequire("58mnS");
const $a851f60f5a7b5635$export$8dc6765e8be191c7 = ({ renderMenu: renderMenu, scope: scope, openContextMenuRef: openContextMenuRef, jsErrorBoundaryProps: jsErrorBoundaryProps })=>{
    (0, $5rXNu.useSetOpenContextMenuRef)({
        scope: scope,
        openContextMenuRef: openContextMenuRef
    });
    const [{ menus: menus }] = (0, $ewaBk.useContextMenuStore)();
    const position = menus[scope]?.position || {
        x: 0,
        y: 0
    };
    const isOpen = (0, $ewaBk.useIsMenuOpen)({
        scope: scope
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderContent = (0, $5uXOq.useCallback)(({ isOpen: isContentOpen })=>isContentOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
            fallback: "unmount",
            ...jsErrorBoundaryProps
        }, renderMenu(scope)) : null, [
        jsErrorBoundaryProps,
        renderMenu,
        scope
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        offset: [
            0,
            0
        ],
        placement: "bottom-start",
        content: renderContent,
        shouldRenderToParent: true,
        messageId: "software-context-menu.ui.context-menu.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a851f60f5a7b5635$export$fa7a3a6ce2191e98, {
                "data-testid": (0, $f46d826c522a20f8$export$5694c1f4d72b68ad),
                position: position,
                role: "button",
                "aria-hidden": (0, $4R6GH.fg)('tanuki_a11y_q4') ? true : undefined,
                ...triggerProps,
                "aria-label": formatMessage((0, $58mnS.default).contextMenuAriaLabel)
            })
    });
};
const $a851f60f5a7b5635$export$fa7a3a6ce2191e98 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { position: position, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_16yv8lz": (0, $lD23V.default)(__cmplp.position.y, "px"),
            "--_1fbn7yv": (0, $lD23V.default)(__cmplp.position.x, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw",
            !!__cmplp.position && __cmplp.position.x && __cmplp.position.y && "_154is04s _1ltvkw7u",
            __cmplp.className
        ])
    });
});

});
parcelRegister("5rXNu", function(module, exports) {

$parcel$export(module.exports, "useSetOpenContextMenuRef", () => $04235c4c7bb590da$export$d7bda04d92fd2eab);

var $5uXOq = parcelRequire("5uXOq");

var $ewaBk = parcelRequire("ewaBk");
const $04235c4c7bb590da$export$d7bda04d92fd2eab = ({ scope: scope, openContextMenuRef: openContextMenuRef })=>{
    const { openMenu: openMenu } = (0, $ewaBk.useContextMenuActions)();
    const onOpenContextMenu = ({ position: position, analyticsEvent: analyticsEvent })=>{
        openMenu({
            position: position,
            analyticsEvent: analyticsEvent,
            scope: scope,
            openedFrom: 'rightClick'
        });
    };
    (0, $5uXOq.useImperativeHandle)(openContextMenuRef, ()=>({
            onOpenContextMenu: onOpenContextMenu
        }));
};

});

const $f46d826c522a20f8$export$5694c1f4d72b68ad = 'software-context-menu.ui.context-menu';

parcelRegister("58mnS", function(module, exports) {

$parcel$export(module.exports, "default", () => $c731817a43b6474e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c731817a43b6474e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    contextMenuAriaLabel: {
        "id": "software-context-menu.context-menu.context-menu-aria-label",
        "defaultMessage": "Open menu"
    }
});

});




parcelRegister("aqBCK", function(module, exports) {

$parcel$export(module.exports, "MOVE_TO_MENU_ID", () => $c96743ce387bce58$export$5645be38d58b5483);
$parcel$export(module.exports, "MOVE_TO_TOP_OF_COLUMN_MENU_ID", () => $c96743ce387bce58$export$b7199a4fda4563e9);
$parcel$export(module.exports, "MOVE_TO_BOTTOM_OF_COLUMN_MENU_ID", () => $c96743ce387bce58$export$facab7e3869721f4);
$parcel$export(module.exports, "MOVE_UP_WITHIN_COLUMN_MENU_ID", () => $c96743ce387bce58$export$87ea0460c4d87bd0);
$parcel$export(module.exports, "MOVE_DOWN_WITHIN_COLUMN_MENU_ID", () => $c96743ce387bce58$export$feaf1d369b7b2ef);
$parcel$export(module.exports, "MOVE_TO_BACKLOG_MENU_ID", () => $c96743ce387bce58$export$32afee5bddfb614a);
$parcel$export(module.exports, "CHANGE_STATUS_MENU_ID", () => $c96743ce387bce58$export$c908f2e659b099b1);
$parcel$export(module.exports, "FLAG_MENU_ID", () => $c96743ce387bce58$export$63cb4152f50d2665);
$parcel$export(module.exports, "ADD_LABEL_ID", () => $c96743ce387bce58$export$d0e98113904dfa9);
$parcel$export(module.exports, "COPY_ISSUE_LINK_MENU_ID", () => $c96743ce387bce58$export$34b38d58090a7162);
$parcel$export(module.exports, "COPY_ISSUE_KEY_MENU_ID", () => $c96743ce387bce58$export$2e74ac183d49087);
$parcel$export(module.exports, "VIEW_IN_ISSUE_SEARCH_MENU_ID", () => $c96743ce387bce58$export$4231ab934953c1bc);
$parcel$export(module.exports, "HEADER_BULK_INDICATOR_MENU_ID", () => $c96743ce387bce58$export$bdfa217711a39d8d);
$parcel$export(module.exports, "DELETE_ISSUE_MENU_ID", () => $c96743ce387bce58$export$b35363b92f22bb89);
$parcel$export(module.exports, "ARCHIVE_ISSUE_MENU_ID", () => $c96743ce387bce58$export$fc49978f895ec203);
$parcel$export(module.exports, "CLONE_ISSUE_MENU_ID", () => $c96743ce387bce58$export$45f7afb383d46279);
$parcel$export(module.exports, "REMOVE_FROM_SPRINT_MENU_ID", () => $c96743ce387bce58$export$e47c565bdec2e2fb);
$parcel$export(module.exports, "LINK_ISSUE_MENU_ID", () => $c96743ce387bce58$export$a62eb3479b356078);
$parcel$export(module.exports, "SEPARATOR_MENU_ID", () => $c96743ce387bce58$export$1fa1533b8d6efd51);
$parcel$export(module.exports, "CHANGE_PARENT_MENU_ID", () => $c96743ce387bce58$export$f823757fde5bc834);
$parcel$export(module.exports, "BULK_CHANGE_MENU_ID", () => $c96743ce387bce58$export$d8dbd75dd44821b);
$parcel$export(module.exports, "CHANGE_TEAM_MENU_ID", () => $c96743ce387bce58$export$e51c7bc6816555b2);
$parcel$export(module.exports, "CHANGE_TEAM_SEARCH_MENU_ID", () => $c96743ce387bce58$export$9c672767be29c0ac);
$parcel$export(module.exports, "CHANGE_TEAM_UNASSIGN_MENU_ID", () => $c96743ce387bce58$export$aea369fa6803ebd);
$parcel$export(module.exports, "CHANGE_DATE_RANGE_MENU_ID", () => $c96743ce387bce58$export$1435067cc5065f6a);
$parcel$export(module.exports, "UNSCHEDULE_DATE_RANGE_MENU_ID", () => $c96743ce387bce58$export$6d7ac6c2960a1ce6);
$parcel$export(module.exports, "SCHEDULE_DATE_RANGE_MENU_ID", () => $c96743ce387bce58$export$d36e4a2ba747e549);
$parcel$export(module.exports, "EDIT_COVER_MENU_ID", () => $c96743ce387bce58$export$2e6bc5997111e31f);
$parcel$export(module.exports, "ANALYTICS_MAPPING_TABLE", () => $c96743ce387bce58$export$77ab83fd54e2c3c);
const $c96743ce387bce58$export$5645be38d58b5483 = 'actions/move-to';
const $c96743ce387bce58$export$b7199a4fda4563e9 = 'actions/move-to/top-of-column';
const $c96743ce387bce58$export$facab7e3869721f4 = 'actions/move-to/bottom-of-column';
const $c96743ce387bce58$export$87ea0460c4d87bd0 = 'actions/move-to/up';
const $c96743ce387bce58$export$feaf1d369b7b2ef = 'actions/move-to/down';
const $c96743ce387bce58$export$32afee5bddfb614a = 'actions/move-to/backlog';
const $c96743ce387bce58$export$c908f2e659b099b1 = 'actions/change-status/';
const $c96743ce387bce58$export$63cb4152f50d2665 = 'actions/flag';
const $c96743ce387bce58$export$d0e98113904dfa9 = 'actions/add-label';
const $c96743ce387bce58$export$34b38d58090a7162 = 'actions/copy-issue-link';
const $c96743ce387bce58$export$2e74ac183d49087 = 'actions/copy-issue-key';
const $c96743ce387bce58$export$4231ab934953c1bc = 'actions/view-in-issue-search';
const $c96743ce387bce58$export$bdfa217711a39d8d = 'bulk-indicator';
const $c96743ce387bce58$export$b35363b92f22bb89 = 'actions/delete-issue';
const $c96743ce387bce58$export$fc49978f895ec203 = 'actions/archive-issue';
const $c96743ce387bce58$export$45f7afb383d46279 = 'actions/clone-issue';
const $c96743ce387bce58$export$e47c565bdec2e2fb = 'actions/remove-from-sprint';
const $c96743ce387bce58$export$a62eb3479b356078 = 'actions/link-issue';
const $c96743ce387bce58$export$1fa1533b8d6efd51 = 'separator';
const $c96743ce387bce58$export$f823757fde5bc834 = 'actions/change-parent';
const $c96743ce387bce58$export$d8dbd75dd44821b = 'actions/bulk-change';
const $c96743ce387bce58$export$e51c7bc6816555b2 = 'actions/change-team';
const $c96743ce387bce58$export$9c672767be29c0ac = 'actions/change-team/search';
const $c96743ce387bce58$export$aea369fa6803ebd = 'actions/change-team/unassign';
const $c96743ce387bce58$export$1435067cc5065f6a = 'actions/change-date-range';
const $c96743ce387bce58$export$6d7ac6c2960a1ce6 = 'actions/change-date-range/unschedule';
const $c96743ce387bce58$export$d36e4a2ba747e549 = 'actions/change-date-range/schedule-column';
const $c96743ce387bce58$export$2e6bc5997111e31f = 'actions/edit-cover';
const $c96743ce387bce58$var$MOVE_ANALYTICS = {
    attributes: {
        actionGroup: 'move'
    }
};
const $c96743ce387bce58$var$UPDATE_ANALYTICS = {
    attributes: {
        actionGroup: 'update'
    }
};
const $c96743ce387bce58$export$77ab83fd54e2c3c = {
    [$c96743ce387bce58$export$5645be38d58b5483]: {
        actionSubjectId: 'moveToDropdownItem',
        ...$c96743ce387bce58$var$MOVE_ANALYTICS
    },
    [$c96743ce387bce58$export$32afee5bddfb614a]: {
        actionSubjectId: 'moveToBacklogDropdownItem',
        ...$c96743ce387bce58$var$MOVE_ANALYTICS
    },
    [$c96743ce387bce58$export$4231ab934953c1bc]: 'viewIssueSearchDropdownItem',
    [$c96743ce387bce58$export$b35363b92f22bb89]: 'deleteDropdownItem',
    [$c96743ce387bce58$export$45f7afb383d46279]: 'cloneIssueDropdownItem',
    [$c96743ce387bce58$export$34b38d58090a7162]: 'copyIssueLink',
    [$c96743ce387bce58$export$2e74ac183d49087]: 'copyIssueKey',
    [$c96743ce387bce58$export$fc49978f895ec203]: 'archiveDropdownItem',
    [$c96743ce387bce58$export$63cb4152f50d2665]: {
        actionSubjectId: 'addFlagDropdownItem',
        ...$c96743ce387bce58$var$UPDATE_ANALYTICS
    },
    [$c96743ce387bce58$export$d0e98113904dfa9]: 'addLabelDropdownItem'
};

});

parcelRegister("9dYAD", function(module, exports) {

$parcel$export(module.exports, "useArchiveIssue", () => $786d858708e6a24d$export$8726fa65ba085232);

var $koVbs = parcelRequire("koVbs");

var $5ING5 = parcelRequire("5ING5");

var $cDZaH = parcelRequire("cDZaH");

var $2gCtH = parcelRequire("2gCtH");

var $g4tDr = parcelRequire("g4tDr");

var $ldyPw = parcelRequire("ldyPw");

var $1HF4Y = parcelRequire("1HF4Y");

var $k9JTq = parcelRequire("k9JTq");



var $cW3pH = parcelRequire("cW3pH");

var $67sX6 = parcelRequire("67sX6");

var $d2i8f = parcelRequire("d2i8f");

var $1vXOx = parcelRequire("1vXOx");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");
const $786d858708e6a24d$export$c4b948cf20152586 = ({ isArchiveEnabled: isArchiveEnabled, onArchiveIssue: onArchiveIssue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isArchiveEnabled) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).archive),
            id: (0, $aqBCK.ARCHIVE_ISSUE_MENU_ID),
            onClick: onArchiveIssue
        }
    ];
};
const $786d858708e6a24d$export$8726fa65ba085232 = ({ issueKey: issueKey, issueId: issueId, isMultiSelectMode: isMultiSelectMode })=>{
    const isArchived = (0, $2gCtH.useIsArchived)();
    const issueIdArg = issueId.toString();
    const hierarchyLevel = (0, $67sX6.useBoardSelector)((0, $d2i8f.getIssueTypeLevelForBoardIssue))(issueId);
    const isSubtask = (0, $g4tDr.isSubtaskHierarchyLevel)(hierarchyLevel);
    const canArchiveIssue = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))?.[0, $e525e6c25695c9df$export$e6bcada406923d66];
    const edition = (0, $k9JTq.useAppEditions)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const isPremium = edition?.software === (0, $ldyPw.PREMIUM_EDITION);
    const issue = (0, $67sX6.useBoardSelector)((state)=>{
        return (0, $d2i8f.getIssueByKey)(state, issueKey);
    });
    const canArchive = !isArchived && (canArchiveIssue ?? false) && !isSubtask && isPremium;
    const { openArchiveIssueModal: openArchiveIssueModal } = (0, $cDZaH.useArchiveIssueModalActions)();
    const onIssueArchiveSuccess = ()=>{
        dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$ccb7bcb751e6027e)));
    };
    return $786d858708e6a24d$export$c4b948cf20152586({
        isArchiveEnabled: canArchive && !isMultiSelectMode,
        onArchiveIssue: ()=>{
            openArchiveIssueModal({
                issueKey: issueKey,
                issueId: issueIdArg,
                triggerPointKey: (0, $5ING5.TRIGGER_POINT_KEY_BOARD_VIEW),
                onIssueArchiveSuccess: onIssueArchiveSuccess,
                workType: issue?.typeName
            });
        }
    });
};

});
parcelRegister("cDZaH", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalStore", () => $40459da096a405f9$export$c5cad849002b274b);
$parcel$export(module.exports, "useArchiveIssueModalActions", () => $40459da096a405f9$export$b7e685898567f722);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $iP93q = parcelRequire("iP93q");

var $tr6Ns = parcelRequire("tr6Ns");
const $40459da096a405f9$export$c5cad849002b274b = (0, $iXqE5.createStore)({
    initialState: $tr6Ns.initialState,
    actions: (0, $iP93q.ArchiveIssueModalActions),
    name: 'archiveIssueModalStore'
});
const $40459da096a405f9$export$b7e685898567f722 = (0, $3sQ5x.createActionsHook)($40459da096a405f9$export$c5cad849002b274b);

});
parcelRegister("iP93q", function(module, exports) {

$parcel$export(module.exports, "ArchiveIssueModalActions", () => $0edc0fbae339598b$export$69579d834733fb34);
const $0edc0fbae339598b$export$69579d834733fb34 = {
    openArchiveIssueModal: ({ issueKey: issueKey, issueId: issueId, onIssueArchiveSuccess: onIssueArchiveSuccess, onCloseIssueViewModal: onCloseIssueViewModal, triggerPointKey: triggerPointKey, workType: workType, issueHierarchyLevel: issueHierarchyLevel })=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: true,
                issueKey: issueKey,
                issueId: issueId,
                onIssueArchiveSuccess: onIssueArchiveSuccess,
                onCloseIssueViewModal: onCloseIssueViewModal,
                triggerPointKey: triggerPointKey,
                workType: workType,
                issueHierarchyLevel: issueHierarchyLevel
            });
        },
    closeArchiveIssueModal: ()=>({ setState: setState })=>{
            setState({
                isArchiveIssueModalOpen: false,
                issueKey: null,
                issueId: null,
                onIssueArchiveSuccess: null,
                onCloseIssueViewModal: null,
                triggerPointKey: null,
                workType: null
            });
        }
};

});

parcelRegister("tr6Ns", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $75b2be9671247dca$export$d4c72bab9d6cc13a);
const $75b2be9671247dca$export$d4c72bab9d6cc13a = {
    isArchiveIssueModalOpen: false,
    issueKey: null,
    issueId: null,
    onIssueArchiveSuccess: null,
    onCloseIssueViewModal: null,
    triggerPointKey: null,
    workType: null
};

});


parcelRegister("kOuTq", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bd68f44a2c417d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0bd68f44a2c417d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveTo: {
        "id": "software.main.board-container.board.card-container.card.context-menu.move-to",
        "defaultMessage": "Move to"
    },
    column: {
        "id": "software.main.board-container.board.card-container.card.context-menu.column",
        "defaultMessage": "Column {columnName}"
    },
    topOfTheColumnOld: {
        "id": "software.main.board-container.board.card-container.card.context-menu.top-of-the-column-old",
        "defaultMessage": "Top of column"
    },
    movedToTopOfTheColumnOld: {
        "id": "backlog.card-list.card.context-menu.moved-item-to-top-old",
        "defaultMessage": "Moved card to top of the column"
    },
    bottomOfTheColumnOld: {
        "id": "software.main.board-container.board.card-container.card.context-menu.bottom-of-the-column-old",
        "defaultMessage": "Bottom of column"
    },
    movedToBottomOfTheColumnOld: {
        "id": "backlog.card-list.card.context-menu.moved-item-to-bottom-old",
        "defaultMessage": "Moved card to bottom of the column"
    },
    moveWorkItem: {
        "id": "software.main.board-container.board.card-container.card.context-menu.move-work-item",
        "defaultMessage": "Move work item"
    },
    topOfTheColumn: {
        "id": "software.main.board-container.board.card-container.card.context-menu.top-of-the-column",
        "defaultMessage": "To the top"
    },
    movedToTopOfTheColumn: {
        "id": "backlog.card-list.card.context-menu.moved-item-to-top",
        "defaultMessage": "Moved work item to top of the column"
    },
    bottomOfTheColumn: {
        "id": "software.main.board-container.board.card-container.card.context-menu.bottom-of-the-column",
        "defaultMessage": "To the bottom"
    },
    movedToBottomOfTheColumn: {
        "id": "backlog.card-list.card.context-menu.moved-item-to-bottom",
        "defaultMessage": "Moved work item to bottom of the column"
    },
    down: {
        "id": "software.main.board-container.board.card-container.card.context-menu.down",
        "defaultMessage": "Down"
    },
    movedDown: {
        "id": "backlog.card-list.card.context-menu.moved-work-item-down",
        "defaultMessage": "Moved work item down"
    },
    up: {
        "id": "software.main.board-container.board.card-container.card.context-menu.up",
        "defaultMessage": "Up"
    },
    movedUp: {
        "id": "backlog.card-list.card.context-menu.moved-work-item-up",
        "defaultMessage": "Moved work item up"
    },
    backlog: {
        "id": "software.main.board-container.board.card-container.card.context-menu.backlog-old",
        "defaultMessage": "To backlog"
    },
    backlogOld: {
        "id": "software.main.board-container.board.card-container.card.context-menu.backlog",
        "defaultMessage": "Backlog"
    },
    changeStatus: {
        "id": "software.main.board-container.board.card-container.card.context-menu.change-status",
        "defaultMessage": "Change status"
    },
    changedStatusTo: {
        "id": "software.main.board-container.board.card-container.card.context-menu.changed-status-to",
        "defaultMessage": "Changed work item status to {statusName}"
    },
    viewInIssueSearch: {
        "id": "software.main.board-container.board.card-container.card.context-menu.view-in-issue-search",
        "defaultMessage": "View in issue search"
    },
    label: {
        "id": "software.main.board-container.board.card-container.card.context-menu.label",
        "defaultMessage": "Add label"
    },
    flag: {
        "id": "software.main.board-container.board.card-container.card.context-menu.flag",
        "defaultMessage": "Flag"
    },
    addFlag: {
        "id": "software.main.board-container.board.card-container.card.context-menu.add-flag",
        "defaultMessage": "Add flag"
    },
    removeFlag: {
        "id": "software.main.board-container.board.card-container.card.context-menu.remove-flag",
        "defaultMessage": "Remove flag"
    },
    addIssueParent: {
        "id": "software.main.board-container.board.card-container.card.context-menu.add-issue-parent",
        "defaultMessage": "Add parent"
    },
    changeIssueParent: {
        "id": "software.main.board-container.board.card-container.card.context-menu.change-issue-parent",
        "defaultMessage": "Change parent"
    },
    bulkChange: {
        "id": "software.main.board-container.board.card-container.card.context-menu.bulk-change",
        "defaultMessage": "Bulk change"
    },
    bulkChangeIconLabel: {
        "id": "software.main.board-container.board.card-container.card.context-menu.bulk-change-icon-label",
        "defaultMessage": "Open in new window"
    },
    removeFromSprint: {
        "id": "software.main.board-container.board.card-container.card.context-menu.remove-from-sprint",
        "defaultMessage": "Remove from sprint"
    },
    delete: {
        "id": "software.main.board-container.board.card-container.card.context-menu.delete",
        "defaultMessage": "Delete"
    },
    archive: {
        "id": "software.main.board-container.board.card-container.card.context-menu.archive",
        "defaultMessage": "Archive"
    },
    clone: {
        "id": "software.main.board-container.board.card-container.card.context-menu.clone",
        "defaultMessage": "Clone"
    },
    menuTriggerOneCard: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-trigger-one-card",
        "defaultMessage": "More actions for {issueKey} {summary}"
    },
    menuTriggerMoreCards: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-trigger-more-cards",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected issues"
    },
    unscheduleIncrement: {
        "id": "software.main.board-container.board.card-container.card.context-menu.unschedule-increment",
        "defaultMessage": "Unschedule"
    },
    changeTeam: {
        "id": "software.main.board-container.board.card-container.card.context-menu.change-team",
        "defaultMessage": "Change team"
    },
    unassign: {
        "id": "software.main.board-container.board.card-container.card.context-menu.unassign",
        "defaultMessage": "Unassign"
    },
    viewInIssueSearchIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.view-in-issue-search-issue-term-refresh",
        "defaultMessage": "View in work item search"
    },
    menuTriggerOneCardIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-trigger-one-card-issue-term-refresh",
        "defaultMessage": "More actions for {issueKey} {summary}"
    },
    menuTriggerMoreCardsIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-trigger-more-cards-issue-term-refresh",
        "defaultMessage": "More actions for {issueKey} {summary} and other selected work items"
    }
});

});


parcelRegister("6TWRP", function(module, exports) {

$parcel$export(module.exports, "useBulkChange", () => $6b742bfb150e953b$export$5b8e045dd5a63047);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7paD5 = parcelRequire("7paD5");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");
const $6b742bfb150e953b$export$8b35b75ab8090a99 = ({ onBulkChange: onBulkChange, isBulkChangeVisible: isBulkChangeVisible })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isBulkChangeVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b742bfb150e953b$var$LabelWrapper, null, formatMessage((0, $kOuTq.default).bulkChange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6b742bfb150e953b$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
                    LEGACY_size: "small",
                    LEGACY_primaryColor: "var(--ds-icon, #44546F)",
                    label: formatMessage((0, $kOuTq.default).bulkChangeIconLabel),
                    color: "var(--ds-icon, #44546F)"
                }))),
            id: (0, $aqBCK.BULK_CHANGE_MENU_ID),
            onClick: onBulkChange
        }
    ];
};
const $6b742bfb150e953b$export$5b8e045dd5a63047 = ({ isMultiSelectMode: isMultiSelectMode })=>{
    const selectedIssueKeys = (0, $67sX6.useBoardSelector)((0, $9OPlz.selectedIssueKeysSelector));
    const onBulkChange = ()=>{
        const url = `/secure/GHBulkChange.jspa?issueKeys=${encodeURIComponent(selectedIssueKeys.join(','))}`; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.open(url, '_blank');
    };
    return $6b742bfb150e953b$export$8b35b75ab8090a99({
        onBulkChange: onBulkChange,
        isBulkChangeVisible: isMultiSelectMode
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b742bfb150e953b$var$LabelWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6b742bfb150e953b$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154iv77o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("dlx3i", function(module, exports) {

$parcel$export(module.exports, "useChangeDateRange", () => $c2819c5f68a11a24$export$860b796192eb463e);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $3spCR = parcelRequire("3spCR");

var $bwTbl = parcelRequire("bwTbl");

var $5UXId = parcelRequire("5UXId");

var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $fyeGd = parcelRequire("fyeGd");

var $vAfHD = parcelRequire("vAfHD");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $cPGP0 = parcelRequire("cPGP0");

var $2jlDO = parcelRequire("2jlDO");
const $c2819c5f68a11a24$export$860b796192eb463e = ({ issueId: issueId, selectedCardIds: selectedCardIds, isMultiSelectMode: isMultiSelectMode })=>{
    const allIssues = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardIssuesSelector));
    const triggerIssue = allIssues[String(issueId)];
    const columns = (0, $67sX6.useBoardSelector)((0, $fyeGd.orderedColumnsSelector));
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const swimlaneId = (0, $67sX6.useBoardSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(triggerIssue) ? (0, $bwTbl.getSwimlaneId)(swimlaneMode, (0, $4jZ56.getSwimlanes)(state), triggerIssue) : null);
    const teamSprintsForIterations = (0, $67sX6.useBoardSelector)((state)=>(0, $cPGP0.getTeamSprintsForIterations)(state, swimlaneId));
    let filteredColumns = isMultiSelectMode ? columns : columns.filter((column)=>column.id !== triggerIssue.columnId);
    if (teamSprintsForIterations !== null) /* if there are sprints associated with columns, we need an extra layer of filtering
            to remove closed sprints from the available options */ filteredColumns = filteredColumns.filter((column)=>teamSprintsForIterations[Number(column.id)]?.state !== (0, $3spCR.SPRINT_STATES).CLOSED);
    const onDateRangeChange = (0, $5uXOq.useCallback)((destinationColumn)=>{
        const moveCardsAction = (0, $5UXId.issueRankTeamDateRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: triggerIssue.columnId,
            destinationColumnId: destinationColumn.id,
            rankBeforeIssueId: null,
            rankAfterIssueId: null,
            sourceSwimlaneId: swimlaneId,
            destinationSwimlaneId: swimlaneId
        });
        dispatch(moveCardsAction);
        dispatch((0, $2f454.cardSingleSelect)(issueId));
        dispatch((0, $2f454.cardFocus)(issueId));
    }, [
        dispatch,
        issueId,
        selectedCardIds,
        swimlaneId,
        triggerIssue.columnId
    ]);
    return (0, $2jlDO.useChangeDateRangeContent)({
        onDateRangeChange: onDateRangeChange,
        columns: filteredColumns,
        teamSprintsForIterations: teamSprintsForIterations
    });
};

});
parcelRegister("2jlDO", function(module, exports) {

$parcel$export(module.exports, "useChangeDateRangeContent", () => $f59d5f2ddbf7c200$export$acdcc8c3b5267f9a);

var $ifg6x = parcelRequire("ifg6x");

var $5rFbt = parcelRequire("5rFbt");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");

var $l1G1t = parcelRequire("l1G1t");
const $f59d5f2ddbf7c200$export$acdcc8c3b5267f9a = ({ onDateRangeChange: onDateRangeChange, columns: columns, teamSprintsForIterations: teamSprintsForIterations })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [unplanned, planned] = (0, (/*@__PURE__*/$parcel$interopDefault($ifg6x)))(columns, (column)=>column.id === (0, $5rFbt.UNSCHEDULED_COLUMN_ID));
    const getLabelForDestinationColumn = (column)=>{
        const sprintForIterationName = teamSprintsForIterations?.[Number(column.id)]?.name;
        if (!sprintForIterationName) return formatMessage((0, $kOuTq.default).column, {
            columnName: column.name
        });
        return sprintForIterationName;
    };
    const scheduleActions = planned.map((column)=>({
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: `${0, $aqBCK.SCHEDULE_DATE_RANGE_MENU_ID}/${column.id}`,
            label: getLabelForDestinationColumn(column),
            onClick: ()=>onDateRangeChange(column)
        }));
    let unscheduleAction = [];
    if (unplanned.length > 0) unscheduleAction = [
        (0, $l1G1t.createSeparator)('unschedule-action'),
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $aqBCK.UNSCHEDULE_DATE_RANGE_MENU_ID),
            label: formatMessage((0, $kOuTq.default).unscheduleIncrement),
            onClick: ()=>onDateRangeChange(unplanned[0])
        }
    ];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).moveTo),
            id: (0, $aqBCK.CHANGE_DATE_RANGE_MENU_ID),
            children: [
                ...scheduleActions,
                ...unscheduleAction
            ]
        }
    ];
};

});
parcelRegister("l1G1t", function(module, exports) {

$parcel$export(module.exports, "createSeparator", () => $41b78e9fb023b9d3$export$2f446885d1462a2f);

var $gJBT6 = parcelRequire("gJBT6");

var $1HF4Y = parcelRequire("1HF4Y");

var $aqBCK = parcelRequire("aqBCK");
const $41b78e9fb023b9d3$export$2f446885d1462a2f = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((id)=>({
        id: `${0, $aqBCK.SEPARATOR_MENU_ID}/${id}`,
        type: (0, $1HF4Y.MenuNodeType).Separator
    }));

});



parcelRegister("jQS76", function(module, exports) {

$parcel$export(module.exports, "useChangeParent", () => $345fd96e65a4abbc$export$cdb4de092267a86b);

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $1HF4Y = parcelRequire("1HF4Y");

var $bZ9IJ = parcelRequire("bZ9IJ");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $eDggU = parcelRequire("eDggU");

var $d2i8f = parcelRequire("d2i8f");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");

var $1sCjz = parcelRequire("1sCjz");
const $345fd96e65a4abbc$export$59801eb0ac139f86 = ({ onChangeParent: onChangeParent, isAssignParentVisible: isAssignParentVisible, isReassigning: isReassigning, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1sCjz.useMenuItemWithStartAnalytics)({
        fieldKey: (0, $5fc53.PARENT_TYPE),
        fieldType: (0, $5fc53.PARENT_TYPE),
        shouldFireAnalytics: selectedCardIds?.length === 1,
        firstSelectedCardId: selectedCardIds && (0, $4R6GH.fg)('one_event_improvements_1') ? selectedCardIds[0] : undefined,
        menuItemProps: {
            label: isReassigning ? formatMessage((0, $kOuTq.default).changeIssueParent) : formatMessage((0, $kOuTq.default).addIssueParent),
            id: (0, $aqBCK.CHANGE_PARENT_MENU_ID),
            onClick: onChangeParent
        },
        shouldHide: !isAssignParentVisible
    });
    if (!isAssignParentVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: isReassigning ? formatMessage((0, $kOuTq.default).changeIssueParent) : formatMessage((0, $kOuTq.default).addIssueParent),
            id: (0, $aqBCK.CHANGE_PARENT_MENU_ID),
            onClick: onChangeParent
        }
    ];
};
const $345fd96e65a4abbc$export$cdb4de092267a86b = ({ isMultiSelectMode: isMultiSelectMode, issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const isSelected = (0, $67sX6.useBoardSelector)((0, $9OPlz.isCardSelected))(issueId);
    const selectedIds = isSelected ? selectedCardIds : [
        issueId
    ];
    const isReassigning = (0, $67sX6.useBoardSelector)((0, $d2i8f.isAssignedToIssueParent))(selectedIds);
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const isAssignParentVisible = (0, $67sX6.useBoardSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue) && (0, $eDggU.isAssignIssueParentActionVisible)(state)(issue, isMultiSelectMode));
    const onChangeParent = (0, $67sX6.useBoardActionCreator)(()=>(0, $bZ9IJ.showAssignIssueParentModal)(selectedIds));
    return $345fd96e65a4abbc$export$59801eb0ac139f86({
        onChangeParent: onChangeParent,
        isAssignParentVisible: isAssignParentVisible,
        isReassigning: isReassigning,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') ? {
            selectedCardIds: selectedIds
        } : {}
    });
};

});
parcelRegister("eDggU", function(module, exports) {

$parcel$export(module.exports, "isAssignIssueParentModalOpen", () => $ce18a23f10981df7$export$964aa9f8b115dff5);
$parcel$export(module.exports, "getSelectedIssues", () => $ce18a23f10981df7$export$5e52d79ee962d3c1);
$parcel$export(module.exports, "isAssignIssueParentActionVisible", () => $ce18a23f10981df7$export$743083fb6d05b9ac);
$parcel$export(module.exports, "areSelectedIssuesSubtasksSelector", () => $ce18a23f10981df7$export$52994f7db52fcd73);
$parcel$export(module.exports, "issueHierarchyLevelSelector", () => $ce18a23f10981df7$export$877c3c60e0259f4b);
$parcel$export(module.exports, "parentIssueLevelNameSelector", () => $ce18a23f10981df7$export$b217594d8e40ead5);
$parcel$export(module.exports, "getIssueParentsForReparentModal", () => $ce18a23f10981df7$export$1fbde0645e5442db);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $hGgHi = parcelRequire("hGgHi");


var $iuuJH = parcelRequire("iuuJH");

var $9OPlz = parcelRequire("9OPlz");

var $3UY9S = parcelRequire("3UY9S");

var $bSSdD = parcelRequire("bSSdD");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $vAfHD = parcelRequire("vAfHD");
const $ce18a23f10981df7$export$964aa9f8b115dff5 = (state)=>Boolean((0, $67Z81.getUi)(state).assignIssueParentModal?.isOpen);
const $ce18a23f10981df7$export$92346131cbbbfbec = (state)=>(0, $67Z81.getUi)(state).assignIssueParentModal?.issueIds ?? [];
const $ce18a23f10981df7$export$5e52d79ee962d3c1 = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    (0, $vAfHD.boardIssuesAndChildrenSelector),
    $ce18a23f10981df7$export$92346131cbbbfbec
], (boardIssues, boardIssuesAndChildren, selectedIssueIds)=>{
    if (selectedIssueIds) return selectedIssueIds.filter((id)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(boardIssuesAndChildren[id])).map((id)=>({
            id: boardIssuesAndChildren[id].id,
            key: boardIssuesAndChildren[id].key,
            parentId: boardIssuesAndChildren[id].parentId,
            projectId: boardIssuesAndChildren[id].projectId
        }));
    return (0, $7uUwQ.freeze)([]);
});
const $ce18a23f10981df7$export$23405beefba8b9e = (levelIssueTypeIds, typeIds)=>typeIds.every((typeId)=>levelIssueTypeIds.includes(String(typeId)));
const $ce18a23f10981df7$export$743083fb6d05b9ac = (0, $dGvGJ.createSelector)([
    (0, $9OPlz.getVisibleCardSelection),
    (0, $vAfHD.boardIssuesSelector),
    (0, $4gt6L.issueTypeIdsSelector),
    (0, $4gt6L.issueChildrenTypeIdsSelector),
    (0, $bSSdD.issueParentsSelector),
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (visibleSelectedCards, boardIssues, baseIssueTypes, childrenIssueTypes, issueParents, isCMPBoard, isIncrementPlanningBoard)=>(issue, isMultiSelect)=>{
        const issueParentsPresent = issueParents.length > 0;
        const selectedCards = visibleSelectedCards;
        if (isCMPBoard && isMultiSelect) // Changing parent for cards in bulk is not supported yet in CMP projects
        return false;
        if ((isCMPBoard || isIncrementPlanningBoard) && issueParents.find((issueParent)=>issueParent.id === issue.id)) // This issue is already an issue parent (Epic). It doesn't support Add Parent feature
        return false;
        if (isIncrementPlanningBoard && isMultiSelect && selectedCards.some((id)=>issueParents.find((issueParent)=>issueParent.id === id))) // The increment planning board doesn't support Add Parent if any issue parent is included in the selection
        return false;
        if (!isMultiSelect) return baseIssueTypes.includes(String(issue.typeId)) ? issueParentsPresent : true;
        const typeIds = selectedCards.map((issueId)=>boardIssues[String(issueId)].typeId);
        return $ce18a23f10981df7$export$23405beefba8b9e(baseIssueTypes, typeIds) ? issueParentsPresent : $ce18a23f10981df7$export$23405beefba8b9e(childrenIssueTypes, typeIds);
    });
const $ce18a23f10981df7$export$52994f7db52fcd73 = (0, $dGvGJ.createSelector)([
    $ce18a23f10981df7$export$92346131cbbbfbec,
    (0, $3UY9S.getIssueChildren)
], (selectedIssueIds, issueChildren)=>selectedIssueIds && selectedIssueIds.length > 0 && selectedIssueIds.every((issueId)=>issueChildren[issueId]));
const $ce18a23f10981df7$export$877c3c60e0259f4b = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    $ce18a23f10981df7$export$52994f7db52fcd73,
    (0, $67Z81.getIsCMPBoard)
], (swimlaneMode, areSelectedIssuesSubtasks, isCMPBoard)=>{
    if (isCMPBoard && areSelectedIssuesSubtasks) return -1;
    // when you switch swimlanes and nothing is selected we still want the issueHierarchyLevel for ICC
    if (areSelectedIssuesSubtasks === undefined) return swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id ? -1 : 0;
    return swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && areSelectedIssuesSubtasks ? -1 : 0;
});
const $ce18a23f10981df7$export$b217594d8e40ead5 = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    $ce18a23f10981df7$export$52994f7db52fcd73,
    (0, $bSSdD.firstParentIssueTypeNameSelector),
    (0, $67Z81.getIsCMPBoard)
], (swimlaneMode, areSelectedIssuesSubtasks, firstParentIssueTypeName, isCMPBoard)=>{
    if (areSelectedIssuesSubtasks && (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id || isCMPBoard)) return 0, $dcbb2bce513725b3$export$d29cf9c8492f955d;
    return firstParentIssueTypeName;
});
const $ce18a23f10981df7$var$getNormalizedIssueType = (id, name, iconUrl)=>({
        id: id,
        name: name || '',
        iconUrl: iconUrl || ''
    });
const $ce18a23f10981df7$export$1fbde0645e5442db = (0, $dGvGJ.createSelector)([
    (0, $45cXl.getSwimlaneMode),
    (0, $bSSdD.issueParentsSelector),
    (0, $67Z81.getIssues),
    (0, $67Z81.getIssueProjects),
    $ce18a23f10981df7$export$5e52d79ee962d3c1,
    $ce18a23f10981df7$export$52994f7db52fcd73,
    (0, $67Z81.getIsCMPBoard),
    (0, $67Z81.getIsIncrementPlanningBoard)
], (swimlaneMode, issueParents, issues, projects, selectedIssues, areSelectedIssuesSubtasks, isCMPBoard, isIncrementPlanningBoard)=>{
    if (areSelectedIssuesSubtasks && (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id || isCMPBoard)) {
        // return base issues excluding epics as available parents for subtasks
        const issueParentKeys = issueParents.map((parent)=>parent.id.toString());
        return Object.keys(issues).filter((key)=>!issueParentKeys.includes(key)).map((key)=>issues[key]).map(({ id: id, summary: summary, key: key, typeId: typeId, typeName: typeName, typeUrl: typeUrl })=>({
                id: id,
                summary: summary,
                key: key,
                issueType: $ce18a23f10981df7$var$getNormalizedIssueType(typeId, typeName, typeUrl)
            }));
    }
    let filteredIssueParents = issueParents;
    if (isIncrementPlanningBoard) {
        const selectedProjects = selectedIssues.map((issue)=>issue.projectId ? projects[issue.projectId] : null);
        const selectedTmpProjects = selectedProjects.filter((project)=>project && !project.isCMP);
        const hasCmpProjectSelected = selectedProjects.some((project)=>project && project.isCMP);
        if (selectedTmpProjects.length > 0 && hasCmpProjectSelected || selectedTmpProjects.length > 1) // Return empty if there are mixed TMP and CMP issues selected or mixed TMP projects issues selected
        filteredIssueParents = [];
        else if (selectedTmpProjects.length === 1) // If there's only 1 TMP project on selected issues, filter the issue parents to be in the same project
        filteredIssueParents = issueParents.filter((parent)=>parent.projectId === selectedTmpProjects[0]?.id);
        else // Filter issue parents to be in CMP project
        filteredIssueParents = issueParents.filter((parent)=>{
            const parentProject = parent.projectId ? projects[parent.projectId] : null;
            return parentProject && parentProject.isCMP;
        });
    }
    return filteredIssueParents.map(({ id: id, summary: summary, key: key, issueType: issueType, projectId: projectId })=>({
            id: id,
            summary: summary,
            key: key,
            projectId: projectId,
            issueType: {
                id: parseInt(issueType.id, 10),
                name: issueType.name,
                iconUrl: issueType.iconUrl
            }
        }));
});

});

parcelRegister("1sCjz", function(module, exports) {

$parcel$export(module.exports, "useMenuItemWithStartAnalytics", () => $c91d19a675cc33cc$export$fc60a94c1884fa66);

var $5uXOq = parcelRequire("5uXOq");

var $ctrpc = parcelRequire("ctrpc");

var $2NMNM = parcelRequire("2NMNM");

var $1HF4Y = parcelRequire("1HF4Y");

var $4R6GH = parcelRequire("4R6GH");
const $c91d19a675cc33cc$export$fc60a94c1884fa66 = ({ fieldKey: fieldKey, fieldType: fieldType, shouldFireAnalytics: shouldFireAnalytics, shouldHide: shouldHide = false, menuItemProps: { onClick: onClickFn, ...others }, firstSelectedCardId: firstSelectedCardId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)((...args)=>{
        if (shouldFireAnalytics) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart(fieldKey, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: fieldType,
                ...(0, $4R6GH.fg)('one_event_fast_follow_fg') && {
                    isContextMenuEditing: true,
                    ...firstSelectedCardId && (0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: Number(firstSelectedCardId)
                    }
                }
            }
        });
        onClickFn?.(...args);
    }, [
        createAnalyticsEvent,
        fieldKey,
        fieldType,
        onClickFn,
        shouldFireAnalytics,
        firstSelectedCardId
    ]);
    return shouldHide ? [] : [
        {
            ...others,
            type: (0, $1HF4Y.MenuNodeType).Item,
            onClick: onClick
        }
    ];
};

});


parcelRegister("7RDtv", function(module, exports) {

$parcel$export(module.exports, "useChangeTeam", () => $4e2dd0472a59c365$export$95c8804dc6557b12);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $ujWmd = parcelRequire("ujWmd");

var $c781K = parcelRequire("c781K");

var $h8cgU = parcelRequire("h8cgU");

var $fuhQD = parcelRequire("fuhQD");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $4jAPy = parcelRequire("4jAPy");

var $1HF4Y = parcelRequire("1HF4Y");

var $gu244 = parcelRequire("gu244");

var $bwTbl = parcelRequire("bwTbl");

var $3vq48 = parcelRequire("3vq48");

var $67sX6 = parcelRequire("67sX6");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");

var $9d0c4 = parcelRequire("9d0c4");
const $4e2dd0472a59c365$var$getTeamIcon = (imageUrl)=>{
    if (imageUrl) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        size: "small",
        src: imageUrl
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e2dd0472a59c365$var$PeopleIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))),
        LEGACY_size: "small",
        color: "var(--ds-icon, #44546F)"
    }));
};
const $4e2dd0472a59c365$var$getTeamVerifiedIcon = (team)=>{
    if (team.verified && (0, $4R6GH.fg)('plans_managed_teams_indicator_program_enabled')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fuhQD.VerifiedTeamIcon), {
        showTooltip: true
    });
    return null;
};
const $4e2dd0472a59c365$export$95c8804dc6557b12 = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allIssues = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardIssuesSelector));
    const triggerIssue = allIssues[String(issueId)];
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const swimlaneId = (0, $67sX6.useBoardSelector)((state)=>!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(triggerIssue) ? (0, $bwTbl.getSwimlaneId)(swimlaneMode, (0, $4jZ56.getSwimlanes)(state), triggerIssue) : null);
    const teams = Object.values((0, $67sX6.useBoardSelector)((0, $67Z81.getTeams))).filter(({ isPlanTeam: isPlanTeam, id: id })=>id !== swimlaneId && isPlanTeam);
    const options = teams.map((team)=>({
            elemAfterLabel: $4e2dd0472a59c365$var$getTeamVerifiedIcon(team),
            icon: $4e2dd0472a59c365$var$getTeamIcon(team.avatarUrl),
            id: `${0, $aqBCK.CHANGE_TEAM_MENU_ID}/${team.id}`,
            label: team.name,
            onClick: ()=>onChangeTeam(team),
            type: (0, $1HF4Y.MenuNodeType).Item
        }));
    const unassignOption = {
        id: (0, $aqBCK.CHANGE_TEAM_UNASSIGN_MENU_ID),
        label: formatMessage((0, $kOuTq.default).unassign),
        onClick: ()=>onChangeTeam(),
        type: (0, $1HF4Y.MenuNodeType).Item
    };
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(triggerIssue.teamId)) options.unshift(unassignOption);
     // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const transformOptionToString = ({ label: label })=>label;
    const [filteredOptions, updateFilter] = (0, $gu244.useTextFilter)(options, transformOptionToString);
    const onChangeTeam = (0, $67sX6.useBoardActionCreator)((destinationTeam)=>(0, $3vq48.issueChangeTeamRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: triggerIssue.columnId,
            destinationColumnId: triggerIssue.columnId,
            rankBeforeIssueId: null,
            rankAfterIssueId: null,
            sourceSwimlaneId: swimlaneId,
            destinationSwimlaneId: destinationTeam === undefined ? (0, $4jAPy.SWIMLANE_TEAMLESS) : destinationTeam.id
        }));
    return (0, $9d0c4.useChangeTeamContent)({
        setQuery: updateFilter,
        options: filteredOptions
    });
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4e2dd0472a59c365$var$PeopleIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66 _bfhkm7j4 _19pkidpf _2hwxv77o _otyridpf _18u0v77o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("gu244", function(module, exports) {

$parcel$export(module.exports, "useTextFilter", () => $5d5db767318aa751$export$de949492119ddd44);

var $5uXOq = parcelRequire("5uXOq");
const $5d5db767318aa751$var$removeAccents = (text)=>text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
const $5d5db767318aa751$var$doesStringContainText = (itemString, text)=>itemString.toLowerCase().includes(text.toLowerCase()) || $5d5db767318aa751$var$removeAccents(itemString).toLowerCase().includes(text.toLowerCase());
const $5d5db767318aa751$export$de949492119ddd44 = (items, itemToStringTransformer, defaultFilterValue = '')=>{
    const [filterValue, setFilterValue] = (0, $5uXOq.useState)(defaultFilterValue);
    const filteredItems = (0, $5uXOq.useMemo)(()=>{
        if (!filterValue) return items;
        return items.filter((item)=>$5d5db767318aa751$var$doesStringContainText(itemToStringTransformer(item), filterValue));
    }, [
        filterValue,
        itemToStringTransformer,
        items
    ]);
    return [
        filteredItems,
        setFilterValue
    ];
};

});

parcelRegister("9d0c4", function(module, exports) {

$parcel$export(module.exports, "useChangeTeamContent", () => $95b9b47ef814f894$export$d4383f748ea8e1c4);

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $1HF4Y = parcelRequire("1HF4Y");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");

var $lrwLB = parcelRequire("lrwLB");
const $95b9b47ef814f894$export$d4383f748ea8e1c4 = ({ setQuery: setQuery, options: options })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const subMenu = (0, $4R6GH.fg)('plans_program_board_a11y_fixes') ? {
        type: (0, $1HF4Y.MenuNodeType).Search,
        id: (0, $aqBCK.CHANGE_TEAM_SEARCH_MENU_ID),
        children: options,
        hasSearch: true,
        isLoading: false,
        onChange: setQuery,
        ariaLabel: (0, $4R6GH.fg)('jpo_a11y_pb_fixes') ? formatMessage((0, $lrwLB.default).teamSearchLabel) : undefined,
        isAsyncSearch: false
    } : [
        {
            type: (0, $1HF4Y.MenuNodeType).Search,
            id: (0, $aqBCK.CHANGE_TEAM_SEARCH_MENU_ID),
            children: options,
            hasSearch: true,
            isLoading: false,
            onChange: setQuery,
            ariaLabel: (0, $4R6GH.fg)('jpo_a11y_pb_fixes') ? formatMessage((0, $lrwLB.default).teamSearchLabel) : undefined,
            isAsyncSearch: false
        }
    ];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).changeTeam),
            id: (0, $aqBCK.CHANGE_TEAM_MENU_ID),
            submenuWidth: 284,
            children: subMenu
        }
    ];
};

});
parcelRegister("lrwLB", function(module, exports) {

$parcel$export(module.exports, "default", () => $9038bf69ae04a816$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9038bf69ae04a816$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    teamSearchLabel: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.change-team.team-search-label",
        "defaultMessage": "Search for a team"
    }
});

});



parcelRegister("4HeNL", function(module, exports) {

$parcel$export(module.exports, "useCloneIssue", () => $37992074e60c24f7$export$7027dc5eeff1ac8c);

var $5uXOq = parcelRequire("5uXOq");

var $jDDM6 = parcelRequire("jDDM6");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $93Yeu = parcelRequire("93Yeu");

var $1HF4Y = parcelRequire("1HF4Y");

var $2KAtx = parcelRequire("2KAtx");

var $8l12q = parcelRequire("8l12q");

var $byRc1 = parcelRequire("byRc1");


var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $d2i8f = parcelRequire("d2i8f");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");
const $37992074e60c24f7$export$737c881ed115dc13 = ({ issueId: issueId, issueKey: issueKey, isCloneEnabled: isCloneEnabled, onCloneIssue: onCloneIssue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isCloneEnabled) return [];
    if ((0, $4R6GH.fg)('jira_context_menu_clone_dialog')) return [
        {
            type: (0, $1HF4Y.MenuNodeType).Node,
            id: (0, $aqBCK.CLONE_ISSUE_MENU_ID),
            node: ({ closeMenu: closeMenu })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
                    entryPoint: (0, $8l12q.asyncIssueCloneModalEntryPoint),
                    entryPointProps: {
                        issueKey: issueKey,
                        issueId: issueId.toString()
                    },
                    interactionName: (0, $aqBCK.CLONE_ISSUE_MENU_ID),
                    useInternalModal: false
                }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $byRc1.ContextMenuItemButton), {
                        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                        ref: ref,
                        menuItem: {
                            type: (0, $1HF4Y.MenuNodeType).Item,
                            id: `${(0, $aqBCK.CLONE_ISSUE_MENU_ID)}-item`,
                            label: formatMessage((0, $kOuTq.default).clone)
                        },
                        onClick: closeMenu,
                        hasChildren: false
                    }))
        }
    ];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).clone),
            id: (0, $aqBCK.CLONE_ISSUE_MENU_ID),
            onClick: onCloneIssue
        }
    ];
};
const $37992074e60c24f7$export$7027dc5eeff1ac8c = ({ issueKey: issueKey, issueId: issueId })=>{
    const canClone = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$9205190dd90cb392];
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const projectKey = (0, $2gCtH.useProjectKey)();
    const projectType = (0, $93Yeu.useProjectType)(projectKey);
    const [, makeCloneRequest] = (0, $jDDM6.useCloneService)(issueKey, projectType || null);
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const onCloneIssue = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'cloneIssue');
        if ((0, $4R6GH.fg)('jira_context_menu_clone_dialog')) return;
        // Given previous logic is summary = meta?.defaultPrefix && issue?.summary ? `${meta.defaultPrefix} ${issue.summary}` : '';
        // I will use a fallback of empty string if `issue.summary` is undefined
        makeCloneRequest({
            summary: issue?.summary ? `CLONE - ${issue.summary}` : ''
        });
    }, [
        createAnalyticsEvent,
        makeCloneRequest,
        issue?.summary
    ]);
    return $37992074e60c24f7$export$737c881ed115dc13({
        issueId: issueId,
        issueKey: issueKey,
        isCloneEnabled: canClone,
        onCloneIssue: onCloneIssue
    });
};

});
parcelRegister("jDDM6", function(module, exports) {

$parcel$export(module.exports, "useCloneService", () => $e9ee8f289c652c3e$export$8b487a17f0174b06);

var $alF9a = parcelRequire("alF9a");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $pa9q9 = parcelRequire("pa9q9");

var $gXz4p = parcelRequire("gXz4p");

var $k9JTq = parcelRequire("k9JTq");

var $koeKL = parcelRequire("koeKL");

var $6s1PB = parcelRequire("6s1PB");

var $koiRX = parcelRequire("koiRX");

var $64qgp = parcelRequire("64qgp");

var $7EJw7 = parcelRequire("7EJw7");

var $1GpXU = parcelRequire("1GpXU");

var $7hFxW = parcelRequire("7hFxW");

var $dMdDY = parcelRequire("dMdDY");
const $e9ee8f289c652c3e$var$getCloneUrl = (issueKey)=>`/rest/internal/2/issue/${issueKey}/clone`;
const $e9ee8f289c652c3e$var$getCloneProgressUrl = (taskId)=>`/rest/api/3/task/${taskId}`;
const $e9ee8f289c652c3e$var$getIssueKeyUrl = (issueId)=>`/rest/api/3/issue/${issueId}?fields=key`;
const $e9ee8f289c652c3e$var$getYourWorkUrl = ()=>'/jira/your-work';
const $e9ee8f289c652c3e$export$8b487a17f0174b06 = (issueKey, projectType)=>{
    const cloneUrl = $e9ee8f289c652c3e$var$getCloneUrl(issueKey);
    const appEditions = (0, $k9JTq.useAppEditions)();
    const [cloneFetchStatus, { setCloneFetchStatus: setCloneFetchStatus }] = (0, $dMdDY.useCloneStatus)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const flagId = (0, $5uXOq.useRef)();
    const progressTaskId = (0, $5uXOq.useRef)('0');
    const cloudId = (0, $koeKL.useCloudId)();
    // For retries
    const payloadRef = (0, $5uXOq.useRef)();
    const onTryAgainClicked = (0, $5uXOq.useRef)();
    const [commit] = (0, $8Uumt.useMutation)((0, $alF9a.default));
    const dismissFlagIfNeeded = (0, $5uXOq.useCallback)(()=>{
        if (flagId.current) dismissFlag(flagId.current);
    }, [
        dismissFlag
    ]);
    const onFailure = (0, $5uXOq.useCallback)((stage, errorMessage, errorStatusCode, failedReason, traceId)=>{
        setCloneFetchStatus((0, $7EJw7.CloneStatus).FAILED);
        dismissFlagIfNeeded();
        // For 4xx erros, we will send it as taskFail events but at SLO level we will filter it
        if (errorStatusCode !== null && errorStatusCode !== undefined && errorStatusCode !== 0) {
            const successStatusCodes = (0, $4R6GH.fg)('bento_send_4xx_to_task_fail_gate_1') ? [
                200,
                201,
                202
            ] : [
                200,
                401,
                403,
                404
            ];
            const wasSuccessful = successStatusCodes.includes(errorStatusCode);
            const errorMessageIfFailed = wasSuccessful ? undefined : `${errorMessage} (Status: ${errorStatusCode})`;
            (0, $gXz4p.sendExperienceAnalytics)((0, $1GpXU.cloneIssueExperienceDescription)(wasSuccessful, stage, 'clone-issue', projectType, appEditions, errorMessageIfFailed, errorStatusCode, traceId));
        }
        flagId.current = showFlag({
            messageId: 'clone-issue.services.clone.show-flag.error.clone-failed',
            messageType: 'transactional',
            type: 'error',
            isAutoDismiss: false,
            title: [
                (0, $7hFxW.default).cloneFailedTitle,
                {
                    issueKey: issueKey
                }
            ],
            description: failedReason ? [
                (0, $7hFxW.default).cloneFailedWorkflow,
                {
                    failedReason: failedReason
                }
            ] : (0, $7hFxW.default).cloneStartFailed,
            actions: [
                {
                    onClick: onTryAgainClicked.current,
                    content: (0, $7hFxW.default).tryAgain
                }
            ]
        });
    }, [
        setCloneFetchStatus,
        dismissFlagIfNeeded,
        projectType,
        showFlag,
        issueKey,
        appEditions
    ]);
    const [workType] = (0, $koiRX.useIssueTypeName)();
    const showVagueSuccessFlag = (0, $5uXOq.useCallback)(()=>{
        // Clone was successful but we somehow lost the result or don't have the cloned issue key
        flagId.current = showFlag({
            messageId: 'clone-issue.services.clone.show-flag.success.clone-success',
            messageType: 'transactional',
            type: 'success',
            isAutoDismiss: true,
            title: [
                workType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? (0, $7hFxW.default).cloneSuccessTitleIssueTerminologyRefreshM4 : (0, $7hFxW.default).cloneSuccessTitle,
                {
                    workType: workType,
                    issueKey: issueKey
                }
            ],
            description: [
                (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7hFxW.default).cloneSuccessButLostResultDescriptionIssueTermRefresh : (0, $7hFxW.default).cloneSuccessButLostResultDescription,
                {
                    oldIssueKey: issueKey
                }
            ],
            actions: [
                {
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    onClick: ()=>window.open($e9ee8f289c652c3e$var$getYourWorkUrl(), '_blank'),
                    content: (0, $7hFxW.default).goToYourWork
                }
            ]
        });
    }, [
        issueKey,
        showFlag,
        workType
    ]);
    const onSuccess = (0, $5uXOq.useCallback)((result)=>{
        dismissFlagIfNeeded();
        (0, $gXz4p.sendExperienceAnalytics)((0, $1GpXU.cloneIssueExperienceDescription)(true, 'CLONE', 'clone-issue', projectType, appEditions));
        if (!result || typeof result === 'string') {
            showVagueSuccessFlag();
            return;
        }
        fetch($e9ee8f289c652c3e$var$getIssueKeyUrl(result.issueId), {
            headers: {
                'Content-Type': 'application/json'
            }
        }).then((response)=>{
            if (!response.ok) {
                const traceId = (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? response.headers.get('Atl-Traceid') || undefined : undefined;
                throw new (0, $jJZqs.default)(response.status, response.statusText, traceId);
            }
            return response.json();
        }).then(({ key: clonedKey })=>{
            const getSuccessFlagDescription = ()=>{
                if (workType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7hFxW.default).cloneSuccessDescriptionIssueTerminologyRefreshM4;
                if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return (0, $7hFxW.default).cloneSuccessDescriptionIssueTermRefresh;
                return (0, $7hFxW.default).cloneSuccessDescription;
            };
            const getSuccessFlagAction = ()=>{
                if (workType && (0, $64qgp.isWorkTypeAvgLength)(workType) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7hFxW.default).cloneSuccessLinkIssueTerminologyRefreshM4;
                if ((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3')) return (0, $7hFxW.default).cloneSuccessLinkIssueTermRefresh;
                return (0, $7hFxW.default).cloneSuccessLink;
            };
            const clonedIssueLink = `/browse/${clonedKey}`;
            flagId.current = showFlag({
                messageId: 'clone-issue.services.clone.show-flag.success.clone-success.1',
                messageType: 'transactional',
                type: 'success',
                isAutoDismiss: false,
                title: [
                    workType && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false) ? (0, $7hFxW.default).cloneSuccessTitleIssueTerminologyRefreshM4 : (0, $7hFxW.default).cloneSuccessTitle,
                    {
                        workType: workType,
                        issueKey: issueKey
                    }
                ],
                description: [
                    getSuccessFlagDescription(),
                    {
                        clonedIssueKey: clonedKey,
                        oldIssueKey: issueKey,
                        workType: workType
                    }
                ],
                actions: [
                    {
                        onClick: ()=>{
                            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                            window.open(clonedIssueLink, '_blank');
                            dismissFlagIfNeeded();
                        },
                        content: [
                            getSuccessFlagAction(),
                            {
                                workType: workType
                            }
                        ]
                    }
                ]
            });
        }).catch(()=>{
            showVagueSuccessFlag();
        });
    }, [
        dismissFlagIfNeeded,
        issueKey,
        projectType,
        showFlag,
        showVagueSuccessFlag,
        appEditions,
        workType
    ]);
    const pollProgressAfterMs = (0, $5uXOq.useCallback)((delayMs)=>{
        const progressUrl = $e9ee8f289c652c3e$var$getCloneProgressUrl(progressTaskId.current);
        setTimeout(()=>{
            fetch(progressUrl, {
                headers: {
                    'Content-Type': 'application/json'
                }
            }).then((response)=>{
                if (!response.ok) {
                    const traceId = (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? response.headers.get('Atl-Traceid') || undefined : undefined;
                    throw new (0, $jJZqs.default)(response.status, response.statusText, traceId);
                }
                return response.json();
            }).then((json)=>{
                const { status: status, message: message, result: result } = json;
                setCloneFetchStatus(status);
                if ((0, $7EJw7.cloneStatusIsInProgress)(status)) pollProgressAfterMs(Math.min(delayMs + 2000, 10000));
                else if ((0, $7EJw7.cloneStatusIsComplete)(status)) onSuccess(result);
                else if ((0, $7EJw7.cloneStatusIsFailed)(status) || (0, $7EJw7.cloneStatusIsCancelled)(status)) onFailure('CLONE', `${status || 'NO_STATUS'}: ${message}`, 200, typeof result === 'string' ? result : undefined);
            }).catch((error)=>{
                onFailure('FETCH', error.message, error.statusCode, undefined, error.traceId);
            });
        }, delayMs);
    }, [
        onFailure,
        onSuccess,
        setCloneFetchStatus
    ]);
    const makeCloneRequest = (0, $5uXOq.useCallback)(async (payload)=>{
        setCloneFetchStatus((0, $7EJw7.CloneStatus).ENQUEUED);
        dismissFlagIfNeeded();
        // Saved for retries if needed
        payloadRef.current = payload;
        flagId.current = showFlag({
            messageId: 'clone-issue.services.clone.show-flag.info.clone-start',
            messageType: 'transactional',
            type: 'info',
            isAutoDismiss: true,
            title: [
                (0, $7hFxW.default).cloneStartTitle,
                {
                    issueKey: issueKey
                }
            ],
            description: [
                (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $7hFxW.default).cloneStartDescriptionIssueTermRefresh : (0, $7hFxW.default).cloneStartDescription,
                {
                    issueKey: issueKey
                }
            ]
        });
        /**
     * issueId does not exist in the previous payload. Hence, using this to differentiate between the old and new clone call.
     */ if (payload?.issueId && (0, $6s1PB.expVal)('enhance-clone-issue-capability-jracloud-5052-ga', 'enhancedIssueCloneEnabled', false)) {
            const optionalFields = Object.keys(payload.optionalFields ?? {})?.map((key)=>({
                    fieldId: key,
                    shouldClone: payload.optionalFields?.[key] ?? false
                }));
            commit({
                variables: {
                    input: {
                        issueId: `ari:cloud:jira:${cloudId}:issue/${payload.issueId}`,
                        summary: payload?.summary,
                        includeAttachments: payload?.includeAttachments ?? false,
                        includeLinks: payload?.includeLinks ?? false,
                        includeComments: payload?.includeComments ?? false,
                        includeSubtasksOrChildren: payload?.includeSubtasksOrChildren ?? false,
                        ...(0, $4R6GH.fg)('jira-clone-epic-child-issues-and-subtasks') ? {
                            includeChildrenWithSubtasks: payload?.includeChildrenWithSubtasks ?? false
                        } : {},
                        assignee: payload?.assignee,
                        reporter: payload?.reporter,
                        optionalFields: optionalFields
                    }
                },
                onCompleted: (response)=>{
                    if (response?.jira?.cloneIssue?.errors && response.jira.cloneIssue.errors.length > 0) {
                        const errors = response.jira.cloneIssue.errors;
                        const error = errors[0];
                        onFailure('CLONE', error.message ?? 'No error returned', error.extensions?.statusCode ?? 0);
                        return;
                    }
                    progressTaskId.current = response?.jira?.cloneIssue?.taskId ?? '';
                    pollProgressAfterMs(1000);
                },
                onError: (error)=>{
                    let statusCode = 0;
                    if (error instanceof (0, $jJZqs.default)) statusCode = error.statusCode;
                    onFailure('CLONE', error.message, statusCode);
                }
            });
        } else fetch(cloneUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then((response)=>{
            if (!response.ok) {
                const traceId = (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? response.headers.get('Atl-Traceid') || undefined : undefined;
                throw new (0, $jJZqs.default)(response.status, response.statusText, traceId);
            }
            return response.json();
        }).then((json)=>{
            const { status: status, taskId: taskId } = json;
            // Failure on initiation is very unlikely
            if ((0, $7EJw7.cloneStatusIsFailed)(status) || !taskId) throw new Error(`Clone task (ID: ${taskId}) failed on initiation with status: ${status || 'null'}`);
            progressTaskId.current = taskId;
            pollProgressAfterMs(1000);
        }).catch((error)=>{
            onFailure('CLONE', error.message, error.statusCode, undefined, error.traceId);
        });
    }, [
        setCloneFetchStatus,
        dismissFlagIfNeeded,
        showFlag,
        issueKey,
        cloneUrl,
        pollProgressAfterMs,
        onFailure,
        commit,
        cloudId
    ]);
    onTryAgainClicked.current = (0, $5uXOq.useCallback)(()=>{
        const payload = payloadRef.current || {};
        makeCloneRequest(payload);
    }, [
        makeCloneRequest
    ]);
    return [
        cloneFetchStatus,
        makeCloneRequest
    ];
};

});
parcelRegister("alF9a", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2949eaec2540442$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<da1463290e86a01242e846443d4243e7>>
 * @relayHash 2338b790df7ebc66fe2543fb4c270170
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a5881abf38b02300f367b288249bcf7115bf7b130ca999a33676b1422ffdbc7f
const $c2949eaec2540442$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "kind": "ScalarField",
        "name": "message"
    }, v4 = {
        "kind": "ScalarField",
        "name": "statusCode"
    }, v5 = {
        "kind": "ScalarField",
        "name": "errorType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "taskId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "taskStatus"
    }, v8 = {
        "kind": "ScalarField",
        "name": "taskDescription"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "cloneIssueMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCloneIssueResponse",
                            "kind": "LinkedField",
                            "name": "cloneIssue",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "cloneIssueMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraCloneIssueResponse",
                            "kind": "LinkedField",
                            "name": "cloneIssue",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "concreteType": "MutationError",
                                    "kind": "LinkedField",
                                    "name": "errors",
                                    "plural": true,
                                    "selections": [
                                        v3 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "extensions",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "__typename"
                                                },
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                {
                                                    "kind": "InlineFragment",
                                                    "selections": [
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "id"
                                                        }
                                                    ],
                                                    "type": "BulkMutationErrorExtension"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "a5881abf38b02300f367b288249bcf7115bf7b130ca999a33676b1422ffdbc7f",
            "metadata": {},
            "name": "cloneIssueMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$c2949eaec2540442$var$node.hash = "bcc3082af70fed04b401430419a8fc63";
var $c2949eaec2540442$export$2e2bcd8739ae039 = $c2949eaec2540442$var$node;

});

parcelRegister("7EJw7", function(module, exports) {

$parcel$export(module.exports, "CloneStatus", () => $dfad5f02f36a9ef6$export$44ea4f4230515e14);
$parcel$export(module.exports, "cloneStatusIsFailed", () => $dfad5f02f36a9ef6$export$7c807819f8838495);
$parcel$export(module.exports, "cloneStatusIsCancelled", () => $dfad5f02f36a9ef6$export$c1692c1b24576a1c);
$parcel$export(module.exports, "cloneStatusIsComplete", () => $dfad5f02f36a9ef6$export$c37ed04c1f512796);
$parcel$export(module.exports, "cloneStatusIsInProgress", () => $dfad5f02f36a9ef6$export$ce5efaea28f8601d);
const $dfad5f02f36a9ef6$export$44ea4f4230515e14 = {
    ENQUEUED: 'ENQUEUED',
    RUNNING: 'RUNNING',
    COMPLETE: 'COMPLETE',
    FAILED: 'FAILED',
    CANCEL_REQUESTED: 'CANCEL_REQUESTED',
    CANCELLED: 'CANCELLED',
    DEAD: 'DEAD'
};
const $dfad5f02f36a9ef6$export$7c807819f8838495 = (status)=>{
    switch(status){
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.ENQUEUED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.RUNNING:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.COMPLETE:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.CANCEL_REQUESTED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.CANCELLED:
            return false;
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.FAILED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.DEAD:
        default:
            return true;
    }
};
const $dfad5f02f36a9ef6$export$c1692c1b24576a1c = (status)=>status === $dfad5f02f36a9ef6$export$44ea4f4230515e14.CANCELLED;
const $dfad5f02f36a9ef6$export$c37ed04c1f512796 = (status)=>status === $dfad5f02f36a9ef6$export$44ea4f4230515e14.COMPLETE;
const $dfad5f02f36a9ef6$export$ce5efaea28f8601d = (status)=>{
    switch(status){
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.ENQUEUED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.CANCEL_REQUESTED:
        case $dfad5f02f36a9ef6$export$44ea4f4230515e14.RUNNING:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("1GpXU", function(module, exports) {

$parcel$export(module.exports, "cloneIssueExperienceDescription", () => $0654dd154b6ded25$export$f35e6f9d40f5647e);

var $4R6GH = parcelRequire("4R6GH");

var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");
const $0654dd154b6ded25$export$f35e6f9d40f5647e = (wasSuccessful, stage, analyticsSource, projectType, appEditions, errorMessage, statusCode, traceId)=>{
    let application = null;
    let edition = null;
    if (projectType !== null) try {
        application = (0, $efvDm.getApplicationForProject)(projectType);
        edition = (0, $ldyPw.getEdition)(application, appEditions);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
    // application and edition already default to null.
    }
    return {
        experience: 'cloneIssue',
        wasExperienceSuccesful: wasSuccessful,
        analyticsSource: analyticsSource,
        application: application,
        edition: edition,
        additionalAttributes: {
            stage: stage,
            ...errorMessage !== undefined && errorMessage !== null ? {
                errorMessage: errorMessage
            } : {},
            ...statusCode && (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? {
                statusCode: statusCode
            } : {},
            ...traceId && (0, $4R6GH.fg)('thor_add_missing_attributes_across_issue_view_1') ? {
                traceId: traceId
            } : {}
        }
    };
};

});

parcelRegister("7hFxW", function(module, exports) {

$parcel$export(module.exports, "default", () => $e600e726d7f34a86$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e600e726d7f34a86$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    cloneFailedTitle: {
        "id": "clone-issue.services.clone-failed-title",
        "defaultMessage": "We couldn't clone {issueKey}"
    },
    cloneStartFailed: {
        "id": "clone-issue.services.clone-start-failed",
        "defaultMessage": "Check your connection and then try again."
    },
    cloneFailedWorkflow: {
        "id": "clone-issue.services.clone-failed-workflow",
        "defaultMessage": "{failedReason}"
    },
    tryAgain: {
        "id": "clone-issue.services.try-again",
        "defaultMessage": "Try again"
    },
    cloneStartTitle: {
        "id": "clone-issue.services.clone-start-title",
        "defaultMessage": "Cloning {issueKey}"
    },
    cloneStartDescription: {
        "id": "clone-issue.services.clone-start-description",
        "defaultMessage": "When cloning is complete, the cloned issue will be linked to {issueKey} and you'll receive another pop-up here just like this one."
    },
    cloneSuccessTitle: {
        "id": "clone-issue.services.clone-success-title",
        "defaultMessage": "Cloning complete"
    },
    cloneSuccessLink: {
        "id": "clone-issue.services.clone-success-link",
        "defaultMessage": "Open cloned issue"
    },
    cloneSuccessDescription: {
        "id": "clone-issue.services.clone-success-description",
        "defaultMessage": "You can find the cloned issue {clonedIssueKey} linked to {oldIssueKey} or by clicking the link below."
    },
    cloneSuccessButLostResultDescription: {
        "id": "clone-issue.services.clone-success-but-lost-result-description",
        "defaultMessage": "You can find the cloned issue linked to {oldIssueKey} or by opening it from Your work."
    },
    goToYourWork: {
        "id": "clone-issue.services.go-to-your-work",
        "defaultMessage": "Go to 'Your work'"
    },
    cloneStartDescriptionIssueTermRefresh: {
        "id": "clone-issue.services.clone-start-description-issue-term-refresh",
        "defaultMessage": "When cloning is complete, the cloned work item will be linked to {issueKey} and you'll receive another pop-up here just like this one."
    },
    cloneSuccessLinkIssueTermRefresh: {
        "id": "clone-issue.services.clone-success-link-issue-term-refresh",
        "defaultMessage": "Open cloned work item"
    },
    cloneSuccessDescriptionIssueTermRefresh: {
        "id": "clone-issue.services.clone-success-description-issue-term-refresh",
        "defaultMessage": "You can find the cloned work item {clonedIssueKey} linked to {oldIssueKey} or by clicking the link below."
    },
    cloneSuccessButLostResultDescriptionIssueTermRefresh: {
        "id": "clone-issue.services.clone-success-but-lost-result-description-issue-term-refresh",
        "defaultMessage": "You can find the cloned work item linked to {oldIssueKey} or by opening it from Your work."
    },
    cloneSuccessTitleIssueTerminologyRefreshM4: {
        "id": "clone-issue.services.clone-success-title-issue-terminology-refresh-m4",
        "defaultMessage": "{workType} {issueKey} cloned"
    },
    cloneSuccessLinkIssueTerminologyRefreshM4: {
        "id": "clone-issue.services.clone-success-link-issue-terminology-refresh-m4",
        "defaultMessage": "View cloned {workType}"
    },
    cloneSuccessDescriptionIssueTerminologyRefreshM4: {
        "id": "clone-issue.services.clone-success-description-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} is linked to {clonedIssueKey}. Please translate as \u201Cwork type {workType}\u201D"
    }
});

});

parcelRegister("dMdDY", function(module, exports) {

$parcel$export(module.exports, "useCloneStatus", () => $2ece5f1150cbf7c4$export$956a07703075dbac);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");

var $gMecq = parcelRequire("gMecq");
const $2ece5f1150cbf7c4$var$getCloneStatus = (state)=>state.cloneFetchStatus;
const $2ece5f1150cbf7c4$export$956a07703075dbac = (0, $3sQ5x.createHook)((0, $gMecq.store), {
    selector: $2ece5f1150cbf7c4$var$getCloneStatus
});

});
parcelRegister("gMecq", function(module, exports) {

$parcel$export(module.exports, "store", () => $bb7b52dfd424c119$export$6f57813fe9f31bf9);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $iXqE5 = parcelRequire("iXqE5");

var $4Xm86 = parcelRequire("4Xm86");
const $bb7b52dfd424c119$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-clone',
    initialState: {
        canModifyReporter: true,
        cloneFetchStatus: null
    },
    actions: $4Xm86
});

});
parcelRegister("4Xm86", function(module, exports) {

$parcel$export(module.exports, "setCloneFetchStatus", () => (parcelRequire("bGZsq")).setCloneFetchStatus);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $bGZsq = parcelRequire("bGZsq");

});
parcelRegister("bGZsq", function(module, exports) {

$parcel$export(module.exports, "setCloneFetchStatus", () => $5be5ce0212d36e0a$export$354b4b5426518f74);
const $5be5ce0212d36e0a$export$354b4b5426518f74 = (cloneFetchStatus)=>({ setState: setState })=>{
        setState({
            cloneFetchStatus: cloneFetchStatus
        });
    };

});





parcelRegister("8l12q", function(module, exports) {

$parcel$export(module.exports, "asyncIssueCloneModalEntryPoint", () => $a1396a6eb1234278$export$c1f75d3cbc44ebc);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $a1396a6eb1234278$export$c1f75d3cbc44ebc = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5tHRd")).then(({ AsyncCloneModal: AsyncCloneModal })=>AsyncCloneModal), {
        moduleId: "07604322"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5tHRd", function(module, exports) {

let $3fd1ae58e1dad643$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $3fd1ae58e1dad643$var$load("kNFvF"),
    $3fd1ae58e1dad643$var$load("ffQaD"),
    $3fd1ae58e1dad643$var$load("kvRbA"),
    $3fd1ae58e1dad643$var$load("ad2ge")
]).then(()=>parcelRequire('fsX0a'));

});


parcelRegister("byRc1", function(module, exports) {

$parcel$export(module.exports, "ContextMenuItemButton", () => $e9c66628c383ba02$export$c41377fb9346496d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hWZau = parcelRequire("hWZau");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $2OMDV = parcelRequire("2OMDV");

var $7D59a = parcelRequire("7D59a");

var $4R6GH = parcelRequire("4R6GH");

// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
const $e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper = (0, $2OMDV.AnalyticsEventToProps)('dropdownItem', {
    onClick: 'clicked'
})(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ createAnalyticsEvent: createAnalyticsEvent, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$StyledContextMenuItemButton, {
        ...props,
        ref: ref
    })));
const $e9c66628c383ba02$export$90c1cb250e648e1f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ menuItem: menuItem, hasChildren: hasChildren }, ref)=>{
    const getContextMenuLabel = ()=>{
        const menuItemLabel = typeof menuItem.label === 'string' ? menuItem.label : menuItem.label();
        if (menuItem.elemAfterLabel) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            as: "span",
            ref: ref,
            testId: (0, $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f),
            xcss: $e9c66628c383ba02$var$menuItemLabelWrapperStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            maxLines: 1
        }, menuItemLabel), menuItem.elemAfterLabel);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuLabel, {
            ref: ref,
            "data-testid": (0, $d9cdb1c71f9dbf8c$export$ae734f89618d3c5f)
        }, menuItemLabel);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, menuItem.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e9c66628c383ba02$var$contextMenuIconStyles
    }, menuItem.icon), getContextMenuLabel(), hasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        spacing: "spacious",
        label: (0, $4R6GH.fg)('jpo_a11y_pb_fixes') ? '' : menuItem.id,
        testId: (0, $d9cdb1c71f9dbf8c$export$ef86d72244e00c00)
    }));
});
const $e9c66628c383ba02$export$7387ff9c7ca7b0ae = ()=>(0, $5uXOq.useRef)(null);
const $e9c66628c383ba02$export$c41377fb9346496d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ menuItem: menuItem, isOpen: isOpen, onMouseEnter: onMouseEnter, onClick: onClick, hasChildren: hasChildren, onOpenWithKeyboard: onOpenWithKeyboard }, ref)=>{
    const [hasEllipsis, setHasEllipsis] = (0, $5uXOq.useState)(false);
    const labelRef = $e9c66628c383ba02$export$7387ff9c7ca7b0ae();
    const onMouseEnterHandler = (0, $7D59a.useEvent)(()=>onMouseEnter && onMouseEnter(menuItem));
    const onHandleClick = (0, $7D59a.useEvent)((e, analyticsEvent)=>{
        e.preventDefault();
        e.stopPropagation();
        if (e.detail === 0) onOpenWithKeyboard?.();
        onClick(menuItem, analyticsEvent);
    });
    const onHandleKeyDown = (0, $7D59a.useEvent)((e)=>{
        if (e.key === 'Enter') e.stopPropagation();
    });
    (0, $5uXOq.useEffect)(()=>{
        if (labelRef.current) {
            const isContentOverflowing = labelRef.current.scrollWidth > labelRef.current.clientWidth;
            setHasEllipsis(isContentOverflowing);
        }
    }, [
        labelRef
    ]);
    const commonProps = {
        'data-testid': (0, $d9cdb1c71f9dbf8c$export$8e765acf3440e0b),
        ref: ref,
        isOpen: isOpen,
        onClick: onHandleClick,
        onMouseEnter: onMouseEnterHandler,
        onKeyDown: onHandleKeyDown
    };
    return hasEllipsis ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        testId: (0, $d9cdb1c71f9dbf8c$export$602eb83148423ac6),
        content: typeof menuItem.label === 'string' ? menuItem.label : menuItem.label()
    }, ({ ref: tooltipRef, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper, {
            ...rest,
            ...commonProps,
            ...hasChildren && {
                'aria-expanded': !!isOpen
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$export$90c1cb250e648e1f, {
            hasChildren: hasChildren,
            menuItem: menuItem,
            ref: (r)=>{
                labelRef.current = r;
                tooltipRef(r);
            }
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$var$ContextMenuItemButtonAnalyticsWrapper, {
        ...commonProps,
        ...hasChildren && {
            'aria-expanded': !!isOpen
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e9c66628c383ba02$export$90c1cb250e648e1f, {
        hasChildren: hasChildren,
        menuItem: menuItem,
        ref: labelRef
    }));
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e9c66628c383ba02$var$StyledContextMenuItemButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOpen: isOpen, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _zulp1b66 _1bsb1osq _y3gn1e5h _ca0qu2gc _u5f3v47k _n3tdu2gc _19bvv47k _1e0c1txw _1bah1h6o _4cvr1h6o _4t3izwfg _7ehiglyw _1bg41i6y",
            __cmplp.isOpen ? "_bfhkfg4m" : "_bfhk1kw7",
            __cmplp.isOpen ? "_syazaqb7" : "_syaz1fxt",
            __cmplp.isOpen ? "_irr3fg4m" : "_irr3166n",
            __cmplp.className
        ])
    });
});
const $e9c66628c383ba02$var$ContextMenuLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $e9c66628c383ba02$var$menuItemLabelWrapperStyles = (0, $8CUq3.xcss)({
    flex: 1,
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"
});
const $e9c66628c383ba02$var$contextMenuIconStyles = (0, $8CUq3.xcss)({
    paddingRight: 'space.100'
});

});


parcelRegister("4HOBK", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueKey", () => $aa01723f1053ec90$export$e5e3fbcc29675793);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $aqBCK = parcelRequire("aqBCK");

var $3h2Of = parcelRequire("3h2Of");
const $aa01723f1053ec90$var$copySuccessfulFlagConfiguration = {
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-successful-flag-configuration.success.show-flag.copy-success',
    messageType: 'transactional',
    type: 'success',
    title: (0, $3h2Of.default).copySuccessTitle,
    description: (0, $3h2Of.default).copySuccessMessage
};
const $aa01723f1053ec90$var$copySuccessfulFlagConfigurationIssueTermRefresh = {
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-successful-flag-configuration-issue-term-refresh.success.show-flag.copy-success-issue-term-refresh',
    messageType: 'transactional',
    type: 'success',
    title: (0, $3h2Of.default).copySuccessTitleIssueTermRefresh,
    description: (0, $3h2Of.default).copySuccessMessageIssueTermRefresh
};
const $aa01723f1053ec90$var$copyFailureFlagConfiguration = {
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-failure-flag-configuration.error.show-flag.copy-failure',
    messageType: 'transactional',
    type: 'error',
    title: (0, $3h2Of.default).copyFailureTitle,
    description: (0, $3h2Of.default).copyFailureMessage
};
const $aa01723f1053ec90$var$copyFailureFlagConfigurationIssueTermRefresh = {
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-failure-flag-configuration-issue-term-refresh.error.show-flag.copy-failure-issue-term-refresh',
    messageType: 'transactional',
    type: 'error',
    title: (0, $3h2Of.default).copyFailureTitleIssueTermRefresh,
    description: (0, $3h2Of.default).copyFailureMessage
};
const $aa01723f1053ec90$export$41456a7ac047c934 = ({ isCopyKeyVisible: isCopyKeyVisible, onCopyIssueKey: onCopyIssueKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isCopyKeyVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3h2Of.default).copyIssueKeyIssueTermRefresh : (0, $3h2Of.default).copyIssueKey),
            id: (0, $aqBCK.COPY_ISSUE_KEY_MENU_ID),
            onClick: onCopyIssueKey
        }
    ];
};
const $aa01723f1053ec90$export$e5e3fbcc29675793 = ({ isMultiSelectMode: isMultiSelectMode, issueKey: issueKey })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onCopyIssueKey = async ()=>{
        try {
            if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator')) await globalThis.navigator.clipboard.writeText(issueKey);
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            await navigator.clipboard.writeText(issueKey);
            showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $aa01723f1053ec90$var$copySuccessfulFlagConfigurationIssueTermRefresh : $aa01723f1053ec90$var$copySuccessfulFlagConfiguration);
        } catch (err) {
            showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $aa01723f1053ec90$var$copyFailureFlagConfigurationIssueTermRefresh : $aa01723f1053ec90$var$copyFailureFlagConfiguration);
        }
    };
    return $aa01723f1053ec90$export$41456a7ac047c934({
        isCopyKeyVisible: !isMultiSelectMode,
        onCopyIssueKey: onCopyIssueKey
    });
};

});
parcelRegister("3h2Of", function(module, exports) {

$parcel$export(module.exports, "default", () => $07026daa28aaeca8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $07026daa28aaeca8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyIssueKey: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-issue-key",
        "defaultMessage": "Copy issue key"
    },
    copySuccessTitle: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-success-title",
        "defaultMessage": "Issue key copied"
    },
    copySuccessMessage: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-success-message",
        "defaultMessage": "You\u2019ve copied the issue key to your clipboard."
    },
    copyFailureTitle: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-failure-title",
        "defaultMessage": "We couldn\u2019t copy the issue key"
    },
    copyFailureMessage: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-failure-message",
        "defaultMessage": "Refresh the page or check your browser settings, then try again."
    },
    copyIssueKeyIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-issue-key-issue-term-refresh",
        "defaultMessage": "Copy key"
    },
    copySuccessTitleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-success-title-issue-term-refresh",
        "defaultMessage": "Key copied"
    },
    copySuccessMessageIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-success-message-issue-term-refresh",
        "defaultMessage": "You\u2019ve copied the work item key to your clipboard."
    },
    copyFailureTitleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-key.copy-failure-title-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t copy the work item key"
    }
});

});


parcelRegister("8cT3J", function(module, exports) {

$parcel$export(module.exports, "useCopyIssueLink", () => $7fc75373cb7684a8$export$8fa8485fafd17cef);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $aqBCK = parcelRequire("aqBCK");

var $93IFw = parcelRequire("93IFw");
const $7fc75373cb7684a8$var$copySuccessfulFlagConfiguration = {
    type: 'success',
    title: (0, $93IFw.default).copySuccessTitle,
    description: (0, $93IFw.default).copySuccessMessage,
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-successful-flag-configuration.success.flag.copy-success',
    messageType: 'transactional'
};
const $7fc75373cb7684a8$var$copyFailureFlagConfiguration = {
    type: 'error',
    title: (0, $93IFw.default).copyFailureTitle,
    description: (0, $93IFw.default).copyFailureMessage,
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-failure-flag-configuration.error.flag.copy-failure',
    messageType: 'transactional'
};
const $7fc75373cb7684a8$var$copySuccessfulFlagConfigurationIssueTerminologyRefresh = {
    type: 'success',
    title: (0, $93IFw.default).copySuccessTitleIssueTermRefresh,
    description: (0, $93IFw.default).copySuccessMessageIssueTermRefresh,
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-successful-flag-configuration-issue-terminology-refresh.success.flag.copy-success-issue-terminology-refresh',
    messageType: 'transactional'
};
const $7fc75373cb7684a8$var$copySuccessfulFlagConfigurationIssueTerminologyRefreshM4 = {
    type: 'success',
    title: (0, $93IFw.default).copySuccessTitleIssueTerminologyRefreshM4,
    description: (0, $93IFw.default).copySuccessMessageIssueTermRefresh,
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-successful-flag-configuration-issue-terminology-refresh-m4.success.flag.copy-success-issue-terminology-refresh-m4',
    messageType: 'transactional'
};
const $7fc75373cb7684a8$var$copyFailureFlagConfigurationIssueTerminologyRefresh = {
    type: 'error',
    title: (0, $93IFw.default).copyFailureTitleIssueTermRefresh,
    description: (0, $93IFw.default).copyFailureMessage,
    messageId: 'software-board.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-failure-flag-configuration-issue-terminology-refresh.error.flag.copy-failure-issue-terminology-refresh',
    messageType: 'transactional'
};
const $7fc75373cb7684a8$export$30a9fe39fb33160d = ({ isCopyLinkVisible: isCopyLinkVisible, onCopyIssueLink: onCopyIssueLink })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isCopyLinkVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $93IFw.default).copyIssueLinkIssueTermRefresh : (0, $93IFw.default).copyIssueLink),
            id: (0, $aqBCK.COPY_ISSUE_LINK_MENU_ID),
            onClick: onCopyIssueLink
        }
    ];
};
const $7fc75373cb7684a8$export$8fa8485fafd17cef = ({ isMultiSelectMode: isMultiSelectMode, issueKey: issueKey })=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const onCopyIssueLink = async ()=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const issueUrl = `${window.location.protocol}//${window.location.hostname}/browse/${issueKey}`;
        try {
            if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator')) await globalThis.navigator.clipboard.writeText(issueUrl);
            else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            await navigator.clipboard.writeText(issueUrl);
            if ((0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) showFlag($7fc75373cb7684a8$var$copySuccessfulFlagConfigurationIssueTerminologyRefreshM4);
            else if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) showFlag($7fc75373cb7684a8$var$copySuccessfulFlagConfigurationIssueTerminologyRefresh);
            else showFlag($7fc75373cb7684a8$var$copySuccessfulFlagConfiguration);
        } catch (err) {
            showFlag((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $7fc75373cb7684a8$var$copyFailureFlagConfigurationIssueTerminologyRefresh : $7fc75373cb7684a8$var$copyFailureFlagConfiguration);
        }
    };
    return $7fc75373cb7684a8$export$30a9fe39fb33160d({
        isCopyLinkVisible: !isMultiSelectMode,
        onCopyIssueLink: onCopyIssueLink
    });
};

});
parcelRegister("93IFw", function(module, exports) {

$parcel$export(module.exports, "default", () => $312d8d1deb5e8415$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $312d8d1deb5e8415$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    copyIssueLink: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-issue-link",
        "defaultMessage": "Copy issue link"
    },
    copySuccessTitle: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-title",
        "defaultMessage": "Issue link copied"
    },
    copySuccessMessage: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-message",
        "defaultMessage": "You\u2019ve copied the issue link to your clipboard."
    },
    copyFailureTitle: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-failure-title",
        "defaultMessage": "We couldn\u2019t copy the issue link"
    },
    copyFailureMessage: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-failure-message",
        "defaultMessage": "Refresh the page or check your browser settings, then try again."
    },
    copyIssueLinkIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-issue-link-issue-term-refresh",
        "defaultMessage": "Copy link"
    },
    copySuccessTitleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-title-issue-term-refresh",
        "defaultMessage": "Link copied"
    },
    copySuccessTitleIssueTerminologyRefreshM4: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-title-issue-terminology-refresh-m4",
        "defaultMessage": "Copied link"
    },
    copySuccessMessageIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-success-message-issue-term-refresh",
        "defaultMessage": "You\u2019ve copied the link to the work item to your clipboard. "
    },
    copyFailureTitleIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.copy-issue-link.copy-failure-title-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t copy the link to the work item."
    }
});

});


parcelRegister("2Ogtn", function(module, exports) {

$parcel$export(module.exports, "useDeleteIssue", () => $2e9e341917d07813$export$43383fdc9fe04fe6);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");


var $5s6yC = parcelRequire("5s6yC");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");
const $2e9e341917d07813$export$33577be3a49c7499 = ({ isDeleteEnabled: isDeleteEnabled, onDeleteIssue: onDeleteIssue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isDeleteEnabled) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).delete),
            id: (0, $aqBCK.DELETE_ISSUE_MENU_ID),
            onClick: onDeleteIssue
        }
    ];
};
const $2e9e341917d07813$export$43383fdc9fe04fe6 = ({ issueId: issueId, isMultiSelectMode: isMultiSelectMode })=>{
    const canDelete = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector))[0, $e525e6c25695c9df$export$d4845393d78ba468];
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const columnIndex = (0, $67sX6.useBoardSelector)((state)=>(0, $fyeGd.getColumnIndex)(state, issue?.columnId));
    const onDeleteIssue = (0, $67sX6.useBoardActionCreator)(()=>(0, $5s6yC.issueDeleteModalOpen)(issueId, columnIndex));
    return $2e9e341917d07813$export$33577be3a49c7499({
        isDeleteEnabled: canDelete && !isMultiSelectMode,
        onDeleteIssue: onDeleteIssue
    });
};

});

parcelRegister("cMdeq", function(module, exports) {

$parcel$export(module.exports, "useEditCover", () => $b98301b87d0ea8f6$export$3ad2d6a068dd2f0e);

var $5uXOq = parcelRequire("5uXOq");

var $8S2Xh = parcelRequire("8S2Xh");

var $4yhWy = parcelRequire("4yhWy");

var $huDJi = parcelRequire("huDJi");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $6MyIZ = parcelRequire("6MyIZ");

var $4R6GH = parcelRequire("4R6GH");

var $1HF4Y = parcelRequire("1HF4Y");

var $ewaBk = parcelRequire("ewaBk");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $koeKL = parcelRequire("koeKL");


var $3n582 = parcelRequire("3n582");

var $2f454 = parcelRequire("2f454");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $aqBCK = parcelRequire("aqBCK");

var $g9agn = parcelRequire("g9agn");

var $4mdFU = parcelRequire("4mdFU");
const $b98301b87d0ea8f6$export$58bbde0bd11b3269 = 900;
const $b98301b87d0ea8f6$export$c9056a07d77f30a8 = 65534;
const $b98301b87d0ea8f6$export$ea4bdeb9cc3af63d = 364;
const $b98301b87d0ea8f6$export$be56acfbf0fe3cb2 = /*#__PURE__*/ (0, $5uXOq.memo)(({ entryPointReferenceSubject: entryPointReferenceSubject, scope: scope, onUpdated: onUpdated, onAttachmentSuccess: onAttachmentSuccess })=>{
    const { closeSubMenu: closeSubMenu } = (0, $ewaBk.useContextMenuActions)();
    const onClose = (0, $5uXOq.useCallback)(()=>closeSubMenu(scope), [
        closeSubMenu,
        scope
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            durationInSeconds: $b98301b87d0ea8f6$export$58bbde0bd11b3269,
            maxTokenLength: $b98301b87d0ea8f6$export$c9056a07d77f30a8,
            onClose: onClose,
            onUpdated: onUpdated,
            onAttachmentSuccess: onAttachmentSuccess
        }), [
        onClose,
        onUpdated,
        onAttachmentSuccess
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira.board.context-menu.card-covers.popover",
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $huDJi.CardCoverSkeleton), null),
        errorFallback: "flag",
        runtimeProps: runtimeProps
    });
});
const $b98301b87d0ea8f6$export$619791f8b7ad4665 = ({ entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions, onUpdated: onUpdated, onAttachmentSuccess: onAttachmentSuccess })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const popoverNode = {
        type: (0, $1HF4Y.MenuNodeType).Node,
        id: `${(0, $aqBCK.EDIT_COVER_MENU_ID)}/popover`,
        node: ({ scope: scope })=>{
            entryPointActions.load();
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b98301b87d0ea8f6$export$be56acfbf0fe3cb2, {
                entryPointReferenceSubject: entryPointReferenceSubject,
                scope: scope,
                onUpdated: onUpdated,
                onAttachmentSuccess: onAttachmentSuccess
            });
        }
    };
    const children = (0, $4R6GH.fg)('jfp_a11y_team_boards_list_markup_used_incorrectly') ? popoverNode : [
        popoverNode
    ];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $aqBCK.EDIT_COVER_MENU_ID),
            label: formatMessage((0, $4mdFU.default).editCover),
            submenuWidth: $b98301b87d0ea8f6$export$ea4bdeb9cc3af63d,
            onMouseEnter: entryPointActions.preload,
            children: children,
            analytics: {
                attributes: {
                    selectedOption: (0, $aqBCK.EDIT_COVER_MENU_ID)
                }
            }
        }
    ];
};
const $b98301b87d0ea8f6$export$3ad2d6a068dd2f0e = ({ issueId: issueId })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            durationInSeconds: $b98301b87d0ea8f6$export$58bbde0bd11b3269,
            maxTokenLength: $b98301b87d0ea8f6$export$c9056a07d77f30a8,
            issueId: (0, $8S2Xh.JiraIssueAri).create({
                issueId: String(issueId),
                siteId: cloudId
            }).toString()
        }), [
        cloudId,
        issueId
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $4yhWy.cardCoverManagerEntryPoint), entryPointParams);
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const { showCardCovers: showCardCovers } = state;
    const { setViewSettingsShowCardCovers: setViewSettingsShowCardCovers } = actions;
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $6MyIZ.useAnalyticsEvents)();
    const setCardCoverAction = (0, $67sX6.useBoardActionCreator)((0, $2f454.cardMediaDataSet));
    const fetchCardCoversAction = (0, $67sX6.useBoardActionCreator)(()=>(0, $3n582.fetchCardCovers)([], {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const showCardCoversRef = (0, $5uXOq.useRef)(showCardCovers);
    (0, $5uXOq.useEffect)(()=>{
        if (!showCardCoversRef.current && showCardCovers) // start fetching card cover data if the user turned on toggle
        fetchCardCoversAction();
        showCardCoversRef.current = showCardCovers;
    }, [
        showCardCovers,
        fetchCardCoversAction
    ]);
    const onUpdated = (coverMedia)=>{
        // update the stored card cover data for the issue that has been updated
        setCardCoverAction((0, $g9agn.transformCardCoverPopoverData)(coverMedia, String(issueId)));
    };
    const onAttachmentSuccess = ()=>{
        setViewSettingsShowCardCovers({
            boardId: Number(boardId),
            view: (0, $a4XJc.View).BOARD,
            showCardCovers: true
        });
    };
    return $b98301b87d0ea8f6$export$619791f8b7ad4665({
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        onUpdated: onUpdated,
        onAttachmentSuccess: onAttachmentSuccess
    });
};

});
parcelRegister("8S2Xh", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAri", () => $6755a8b1c7a21b87$export$1da6808e89ee03e);

var $bQ5aj = parcelRequire("bQ5aj");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/issue/manifest.ts
var $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $bQ5aj.JiraIssueAriResourceOwner),
    resourceType: (0, $bQ5aj.JiraIssueAriResourceType),
    resourceIdSlug: "{issueId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/
    }
};
// src/jira/issue/index.ts
var $6755a8b1c7a21b87$export$1da6808e89ee03e = class _JiraIssueAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.qualifier,
            platformQualifier: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.resourceOwner,
            resourceType: $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $6755a8b1c7a21b87$var$jiraIssueAriStaticOpts);
        return new _JiraIssueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId
        };
    }
};

});
parcelRegister("bQ5aj", function(module, exports) {

$parcel$export(module.exports, "JiraIssueAriResourceOwner", () => $89e88ec215209f61$export$665a39f1b4e29e0a);
$parcel$export(module.exports, "JiraIssueAriResourceType", () => $89e88ec215209f61$export$76beb4d0da177ad4);
// src/jira/issue/types.ts
var $89e88ec215209f61$export$665a39f1b4e29e0a = "jira", $89e88ec215209f61$export$76beb4d0da177ad4 = "issue";

});


parcelRegister("4yhWy", function(module, exports) {

$parcel$export(module.exports, "cardCoverManagerEntryPoint", () => $49e978a3baf35b00$export$1bdd83c991cbfdc5);

var $3Ke8J = parcelRequire("3Ke8J");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $49e978a3baf35b00$export$1bdd83c991cbfdc5 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("hNyQA")).then((module)=>module.CardCoverManagerWithAnalyticsContext), {
        moduleId: "d44881bb",
        moduleName: "CardCoverManager"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueId: issueId, durationInSeconds: durationInSeconds, maxTokenLength: maxTokenLength })=>({
            queries: {
                cardCoverManagerQuery: {
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: (0, $3Ke8J.default),
                    variables: {
                        cloudId: cloudId,
                        issueId: issueId,
                        durationInSeconds: durationInSeconds,
                        maxTokenLength: maxTokenLength
                    }
                }
            }
        })
});

});
parcelRegister("3Ke8J", function(module, exports) {

$parcel$export(module.exports, "default", () => $4e3967e552f45b17$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<82fe0e3ffda7907f5c795008092299b0>>
 * @relayHash d927164e1eea08cda69ef17eaefb40d6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 65107db5e70b4f85f75ce98067325e1d7b83135c90375d668c7c57609c3457a0
const $4e3967e552f45b17$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "65107db5e70b4f85f75ce98067325e1d7b83135c90375d668c7c57609c3457a0",
        "metadata": {},
        "name": "CardCoverManagerQuery",
        "operationKind": "query",
        "text": null
    }
};
var $4e3967e552f45b17$export$2e2bcd8739ae039 = $4e3967e552f45b17$var$node;

});

parcelRegister("hNyQA", function(module, exports) {

let $cf520b2c906b7df3$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cf520b2c906b7df3$var$load("76n7a"),
    $cf520b2c906b7df3$var$load("l253H"),
    $cf520b2c906b7df3$var$load("jOxGs")
]).then(()=>parcelRequire('2ImW2'));

});


parcelRegister("huDJi", function(module, exports) {

$parcel$export(module.exports, "CardCoverSkeleton", () => $b2cc4f4b955ee5d3$export$50810a0aaf8b3a16);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $b2cc4f4b955ee5d3$export$50810a0aaf8b3a16 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.100",
        paddingBlockEnd: "space.100",
        xcss: $b2cc4f4b955ee5d3$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "center",
        alignItems: "center",
        xcss: $b2cc4f4b955ee5d3$var$skeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "medium"
    })));
const $b2cc4f4b955ee5d3$var$skeletonStyles = (0, $8CUq3.xcss)({
    width: '366px',
    height: '300px'
});

});

parcelRegister("6MyIZ", function(module, exports) {

$parcel$export(module.exports, "useAnalyticsEvents", () => $4907e27f6a484433$export$5bf35293e545f20c);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");

const $4907e27f6a484433$var$AnalyticsContext = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
const $4907e27f6a484433$export$198470770171c65 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const data = (0, $iXVV6.extractContextualData)(props);
    // @ts-expect-error - TS2741 - Property 'children' is missing in type 'Dictionary<string | string[] | { [containerName: string]: Container; } | { [key: string]: any; } | undefined>' but required in type 'AnalyticsContextData'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4907e27f6a484433$var$AnalyticsContext, {
        data: data
    }, props.children);
});
const $4907e27f6a484433$export$64eb47d7b94ba089 = ()=>null;
const $4907e27f6a484433$export$5a67e7291fd4569e = (_props)=>null;
const $4907e27f6a484433$export$5f0d7aae8dfa8b86 = (_props)=>null;
const $4907e27f6a484433$export$b71c3ada5d4ec5da = (_props)=>null;
const $4907e27f6a484433$export$2ccf161b817b43b = (_props)=>null;
const $4907e27f6a484433$export$34ac71ce24cddec2 = (_event, _type, _payload = {})=>undefined;
const $4907e27f6a484433$export$79f423cc3fd39762 = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$6bb7ef8f82969e8f = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$6f46fb37ad7d962b = (_event, _attributes)=>undefined;
const $4907e27f6a484433$export$59b89d5a711a4fa = (_event, _attributes)=>undefined;
const $4907e27f6a484433$export$13990ad4625571ed = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$b6c00a2e59d74c5e = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$5d00cd31b1bf8e94 = (_event, ..._rest)=>undefined;
const $4907e27f6a484433$export$ee2085e97a04e027 = (_event)=>({
        type: undefined,
        payload: {}
    });
class $4907e27f6a484433$var$UIAnalyticsEventServer {
    constructor(){
        this.payload = {};
        this.context = [];
        this.handlers = [];
        this.hasFired = false;
        // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
        this.clone = ()=>new $4907e27f6a484433$var$UIAnalyticsEventServer();
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        this.fire = (_channel)=>{};
        // @ts-expect-error TS2416: Property 'update' in type 'UIAnalyticsEventServer' is not assignable to the same property in base type 'UIAnalyticsEvent'. Type 'UIAnalyticsEventServer' is not assignable to type 'this'. 'UIAnalyticsEventServer' is assignable to the constraint of type 'this', but 'this' could be instantiated with a different subtype of constraint 'UIAnalyticsEventServer'.
        this.update = ()=>new $4907e27f6a484433$var$UIAnalyticsEventServer();
    }
}
const $4907e27f6a484433$var$createAnalyticsEvent = (_payload)=>// @ts-expect-error - Type 'UIAnalyticsEventServer' is not assignable to type 'UIAnalyticsEvent'.
    new $4907e27f6a484433$var$UIAnalyticsEventServer();
const $4907e27f6a484433$export$5bf35293e545f20c = ()=>({
        createAnalyticsEvent: $4907e27f6a484433$var$createAnalyticsEvent
    });
const $4907e27f6a484433$var$withAnalyticsEvents = ()=>(WrappedComponent)=>{
        const WithAnalyticsEvents = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// @ts-expect-error Spread types may only be created from object types.ts(2698)
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                ref: ref,
                createAnalyticsEvent: $4907e27f6a484433$var$createAnalyticsEvent
            }));
        WithAnalyticsEvents.displayName = 'WithAnalyticsEvents('.concat(WrappedComponent.displayName != null ? WrappedComponent.displayName : WrappedComponent.name || '', ')');
        return WithAnalyticsEvents;
    };
const $4907e27f6a484433$export$3e9ef96ba97ea9dc = (_componentName, _eventActions)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (component)=>$4907e27f6a484433$var$withAnalyticsEvents()(component);
const $4907e27f6a484433$var$MountEventComponent = ({ onMount: onMount })=>{
    // @ts-expect-error TS2554: Expected 1 arguments, but got 0.
    (0, $5uXOq.useLayoutEffect)(()=>onMount(new $4907e27f6a484433$var$UIAnalyticsEventServer()), [
        onMount
    ]);
    return null;
};
const $4907e27f6a484433$export$2c6963927dbc68f1 = $4907e27f6a484433$var$withAnalyticsEvents()($4907e27f6a484433$var$MountEventComponent);

});

parcelRegister("g9agn", function(module, exports) {

$parcel$export(module.exports, "transformCardCoverPopoverData", () => $d210078ca02f0fb7$export$3e6afbc9f79f8ddc);

var $l5UTI = parcelRequire("l5UTI");
const $d210078ca02f0fb7$export$3e6afbc9f79f8ddc = (coverMedia, issueId)=>{
    if (!coverMedia) // Clear card cover data for the issue if coverMedia is null
    return {
        [issueId]: null
    };
    if (coverMedia.__typename !== 'JiraAttachmentBackground' || !coverMedia.mediaConfig) /*
		Don't do anything if we've received invalid or incomplete data. This could be because:
			1. a ColorCover gets passed in here. This is unlikely, but there's no typecheck preventing
			this from happening because type CoverMedia = ColorCover | AttachmentCover | null and CoverMedia
			is the prescribed input type for the onUpdated function that triggers this function call.
			2. coverMedia.mediaConfig is null. This is possible if we land here after uploading a new
			card cover because the data required to populate the mediaConfig might be missing.
		*/ return {};
    return {
        [issueId]: (0, $l5UTI.transformMediaDataForSingleIssue)(coverMedia.attachment, coverMedia.mediaConfig)
    };
};

});

parcelRegister("4mdFU", function(module, exports) {

$parcel$export(module.exports, "default", () => $bbe3123d5d8a691d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bbe3123d5d8a691d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editCover: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.edit-cover.edit-cover",
        "defaultMessage": "Edit cover image"
    }
});

});


parcelRegister("1Akg6", function(module, exports) {

$parcel$export(module.exports, "useFlag", () => $5b7f821cf9727350$export$983b9b54330812cb);

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $5fc53 = parcelRequire("5fc53");

var $1HF4Y = parcelRequire("1HF4Y");

var $7W4VK = parcelRequire("7W4VK");

var $67sX6 = parcelRequire("67sX6");

var $d2i8f = parcelRequire("d2i8f");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");

var $1sCjz = parcelRequire("1sCjz");
const $5b7f821cf9727350$export$64037f4178ea2950 = ({ onToggleFlag: onToggleFlag, isFlagged: isFlagged, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1sCjz.useMenuItemWithStartAnalytics)({
        fieldKey: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.FLAGGED_CF_TYPE],
        fieldType: (0, $5fc53.FLAGGED_CF_TYPE),
        shouldFireAnalytics: selectedCardIds?.length === 1,
        menuItemProps: {
            label: isFlagged ? formatMessage((0, $kOuTq.default).removeFlag) : formatMessage((0, $kOuTq.default).addFlag),
            id: (0, $aqBCK.FLAG_MENU_ID),
            onClick: onToggleFlag
        },
        firstSelectedCardId: selectedCardIds && (0, $4R6GH.fg)('one_event_improvements_1') ? selectedCardIds[0] : undefined
    });
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: isFlagged ? formatMessage((0, $kOuTq.default).removeFlag) : formatMessage((0, $kOuTq.default).addFlag),
            id: (0, $aqBCK.FLAG_MENU_ID),
            onClick: onToggleFlag
        }
    ];
};
const $5b7f821cf9727350$export$983b9b54330812cb = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const isFlagged = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.isIssueFlagged)(state, issueId));
    const onToggleFlag = (0, $67sX6.useBoardActionCreator)(()=>(0, $7W4VK.showIssueFlagWithCommentModal)(issueId));
    return $5b7f821cf9727350$export$64037f4178ea2950({
        onToggleFlag: onToggleFlag,
        isFlagged: isFlagged,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            selectedCardIds: selectedCardIds
        }
    });
};

});

parcelRegister("3usya", function(module, exports) {

$parcel$export(module.exports, "useHeader", () => $8ec3661e809a543d$export$ae602290ebd82f8e);

var $1HF4Y = parcelRequire("1HF4Y");

var $aqBCK = parcelRequire("aqBCK");

var $l1G1t = parcelRequire("l1G1t");
const $8ec3661e809a543d$export$ae602290ebd82f8e = ({ selectedCards: selectedCards })=>{
    const separator = (0, $l1G1t.createSeparator)((0, $aqBCK.HEADER_BULK_INDICATOR_MENU_ID));
    return selectedCards?.length > 1 ? [
        {
            id: (0, $aqBCK.HEADER_BULK_INDICATOR_MENU_ID),
            type: (0, $1HF4Y.MenuNodeType).BulkIndicator,
            selectedCount: selectedCards.length
        },
        separator
    ] : [];
};

});

parcelRegister("9QvG1", function(module, exports) {

$parcel$export(module.exports, "useAddLabel", () => $d623d901f7c55f34$export$36eeafb75308a374);

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $5fc53 = parcelRequire("5fc53");

var $1HF4Y = parcelRequire("1HF4Y");

var $iaYF9 = parcelRequire("iaYF9");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");

var $1sCjz = parcelRequire("1sCjz");
const $d623d901f7c55f34$export$36eeafb75308a374 = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isSelected = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.isCardSelected)(state)(issueId));
    const issueIds = isSelected ? selectedCardIds : [
        issueId
    ];
    const onAddLabel = (0, $67sX6.useBoardActionCreator)(()=>(0, $iaYF9.showIssueAddLabelModal)(issueIds));
    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1sCjz.useMenuItemWithStartAnalytics)({
        fieldKey: (0, $5fc53.LABELS_TYPE),
        fieldType: (0, $5fc53.LABELS_TYPE),
        shouldFireAnalytics: selectedCardIds?.length === 1,
        menuItemProps: {
            label: formatMessage((0, $kOuTq.default).label),
            id: (0, $aqBCK.ADD_LABEL_ID),
            onClick: onAddLabel
        },
        firstSelectedCardId: (0, $4R6GH.fg)('one_event_improvements_1') ? issueIds[0] : undefined
    });
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).label),
            id: (0, $aqBCK.ADD_LABEL_ID),
            onClick: onAddLabel
        }
    ];
};

});

parcelRegister("j49Di", function(module, exports) {

$parcel$export(module.exports, "useLinkIssue", () => $d31a8940381f4f2b$export$8503aa22241098ff);
$parcel$export(module.exports, "useLinkIssueIPBoard", () => $d31a8940381f4f2b$export$a0a7145930e6bd78);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $HeOPt = parcelRequire("HeOPt");

var $c1DxF = parcelRequire("c1DxF");

var $kgiLc = parcelRequire("kgiLc");

var $6WzWZ = parcelRequire("6WzWZ");

var $67sX6 = parcelRequire("67sX6");

var $j4MnI = parcelRequire("j4MnI");

var $4vVV6 = parcelRequire("4vVV6");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");


var $bd4XH = parcelRequire("bd4XH");

var $8KcVO = parcelRequire("8KcVO");
const $d31a8940381f4f2b$export$8503aa22241098ff = (props)=>{
    const { canUserLinkIssue: canUserLinkIssue, issueLinkTypes: issueLinkTypes } = (0, $67sX6.useBoardSelector)((state)=>(0, $4vVV6.getIssueLinksPermissions)(state));
    const { issue: issue, issueType: issueType } = (0, $67sX6.useBoardSelector)((state)=>{
        const issueItem = (0, $d2i8f.getIssueById)(state, props.issueId);
        if (!issueItem) return {
            issue: undefined,
            issueType: undefined
        };
        return {
            issue: issueItem,
            issueType: (0, $d2i8f.getIssueTypeById)(state, issueItem.typeId)
        };
    });
    const { entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $c1DxF.linkIssueEntryPoint), {});
    const onMouseEnter = entryPointActions.preload;
    const { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject } = (0, $HeOPt.useIssueLinkedModalEntrypointActions)();
    const onClick = ()=>{
        setIssueLinkModalEntryPointSubject({
            issueData: {
                issueId: String(issue?.id),
                issueKey: issue?.key,
                issueSummary: issue?.summary,
                issueType: issueType,
                returnFocusRef: (0, $4R6GH.fg)('jfp_a11y_fix_jsw_board') ? props.returnFocusRef : undefined
            },
            trackOriginSource: 'fromJSWBoardCardContextMenu'
        });
    };
    const menuNodes = (0, $8KcVO.useLinkContent)({
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        canUserLinkIssue: canUserLinkIssue,
        hasIssueLinkTypes: issueLinkTypes.length > 0,
        issueId: (0, $4R6GH.fg)('one_event_improvements_1') ? issue?.id : undefined
    });
    // if issue or issue type are undefined the menu nodes may have issues so we return an empty list instead
    if (!issue || !issueType) return [];
    return menuNodes;
};
const $d31a8940381f4f2b$export$a0a7145930e6bd78 = (props)=>{
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, props.issueId));
    const issueType = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueTypeById)(state, issue.typeId));
    const issues = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getIssues)(state));
    const issuesArray = (0, $5uXOq.useMemo)(()=>Object.values(issues), [
        issues
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const title = formatMessage((0, $bd4XH.default).addDependencyKey);
    const confirmLabel = formatMessage((0, $bd4XH.default).addDependencyCta);
    const issueLinkTypes = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getIssueLinkTypes)(state));
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const issueLinkAndDirectionMap = (0, $67sX6.useBoardSelector)((state)=>(0, $j4MnI.getIssueLinksForDependenciesModal)(state)(props.issueId));
    const { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject } = (0, $HeOPt.useIssueLinkedModalEntrypointActions)();
    const onLinkIssueRequest = (0, $5uXOq.useCallback)(async (issueId, newIssueLinks, issueLinkType)=>{
        const isInwards = issueLinkType.direction === (0, $7ea9780e1aa4575d$export$b5e2b68b0fa7f1c8);
        return Promise.all(newIssueLinks.map(({ value: value })=>(0, $kgiLc.wrapActionWithPromise)(dispatch, (0, $6WzWZ.issueLinkCreateRequest)({
                sourceItemKey: `${isInwards ? value : issueId}`,
                targetItemKey: `${isInwards ? issueId : value}`,
                type: Number(issueLinkType.id)
            }))));
    }, [
        dispatch
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIssueLinkModalEntryPointSubject({
            issueData: {
                issueId: String(issue.id),
                issueKey: issue.key,
                issueSummary: issue.summary,
                issueType: issueType
            },
            modalContent: {
                title: title,
                showDescription: false,
                showCreateIssueLinkButton: false,
                showFeedbackCollector: false,
                localIssuesOnly: true,
                confirmLabel: confirmLabel,
                issues: issuesArray,
                onLinkIssueRequest: onLinkIssueRequest,
                issueLinks: issueLinkAndDirectionMap,
                returnFocusRef: props.returnFocusRef
            }
        });
    }, [
        issue,
        title,
        confirmLabel,
        setIssueLinkModalEntryPointSubject,
        issuesArray,
        onLinkIssueRequest,
        issueType,
        issueLinkAndDirectionMap,
        props.returnFocusRef
    ]);
    const { entryPointActions: entryPointActions } = (0, $4mO32.useEntryPoint)((0, $c1DxF.linkIssueEntryPoint), {});
    const onMouseEnter = entryPointActions.preload;
    return (0, $8KcVO.useLinkContent)({
        onClick: onClick,
        onMouseEnter: onMouseEnter,
        canUserLinkIssue: true,
        hasIssueLinkTypes: issueLinkTypes.length > 0,
        message: formatMessage((0, $bd4XH.default).addDependencyKey)
    });
};

});
parcelRegister("c1DxF", function(module, exports) {

$parcel$export(module.exports, "linkIssueEntryPoint", () => $52b5893121b7514f$export$a6cecab8ef1c82a1);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $52b5893121b7514f$export$a6cecab8ef1c82a1 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("7FauB")), {
        moduleId: "078752d7"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("7FauB", function(module, exports) {

let $5944805f0f0d9d06$var$load = (parcelRequire("28QjX"))(4);
module.exports = $5944805f0f0d9d06$var$load("9YQZU").then(()=>parcelRequire('b4pP3'));

});


parcelRegister("4vVV6", function(module, exports) {

$parcel$export(module.exports, "getIssueLinksPermissions", () => $33c81f284084ea09$export$7b960698e444da91);

var $dGvGJ = parcelRequire("dGvGJ");

var $67Z81 = parcelRequire("67Z81");
const $33c81f284084ea09$export$63a1d96e57383a2 = (state)=>(0, $67Z81.getEntities)(state).issueLinksPermissions;
const $33c81f284084ea09$export$7b960698e444da91 = (0, $dGvGJ.createSelector)([
    $33c81f284084ea09$export$63a1d96e57383a2
], (issueLinksPermissions)=>issueLinksPermissions);

});

parcelRegister("bd4XH", function(module, exports) {

$parcel$export(module.exports, "default", () => $68a644bc1e970d2d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $68a644bc1e970d2d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    linkIssueKey: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.link-issue.link-issue-key",
        "defaultMessage": "Link issue"
    },
    addDependencyKey: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.link-issue.add-dependency-key",
        "defaultMessage": "Add dependency"
    },
    addDependencyCta: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.link-issue.add-dependency-cta",
        "defaultMessage": "Add"
    },
    linkIssueKeyIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.context-menu.menu-items.link-issue.link-issue-key-issue-term-refresh",
        "defaultMessage": "Link work item"
    }
});

});

parcelRegister("8KcVO", function(module, exports) {

$parcel$export(module.exports, "useLinkContent", () => $407dda63ef57658a$export$a87cf02a22618b39);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $1HF4Y = parcelRequire("1HF4Y");

var $aqBCK = parcelRequire("aqBCK");

var $1sCjz = parcelRequire("1sCjz");

var $bd4XH = parcelRequire("bd4XH");
const $407dda63ef57658a$export$a87cf02a22618b39 = ({ onClick: onClick, onMouseEnter: onMouseEnter, canUserLinkIssue: canUserLinkIssue, hasIssueLinkTypes: hasIssueLinkTypes, message: message, issueId: issueId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) // eslint-disable-next-line react-hooks/rules-of-hooks
    return (0, $1sCjz.useMenuItemWithStartAnalytics)({
        fieldKey: (0, $8ikZj.ENTITY_FIELD_KEYS).ISSUE_LINKS,
        fieldType: (0, $8ikZj.ENTITY_FIELD_KEYS).ISSUE_LINKS,
        shouldFireAnalytics: true,
        menuItemProps: {
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                    alignBlock: "center",
                    space: "space.100",
                    xcss: $407dda63ef57658a$var$messageContainerStyles
                }, message ?? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bd4XH.default).linkIssueKeyIssueTermRefresh : (0, $bd4XH.default).linkIssueKey)),
            id: (0, $aqBCK.LINK_ISSUE_MENU_ID),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            analytics: {
                attributes: {
                    selectedOption: (0, $aqBCK.LINK_ISSUE_MENU_ID)
                }
            }
        },
        shouldHide: !hasIssueLinkTypes || !canUserLinkIssue,
        firstSelectedCardId: (0, $4R6GH.fg)('one_event_improvements_1') ? issueId : undefined
    });
    return hasIssueLinkTypes && canUserLinkIssue ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                    alignBlock: "center",
                    space: "space.100",
                    xcss: $407dda63ef57658a$var$messageContainerStyles
                }, message ?? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bd4XH.default).linkIssueKeyIssueTermRefresh : (0, $bd4XH.default).linkIssueKey)),
            id: (0, $aqBCK.LINK_ISSUE_MENU_ID),
            onClick: onClick,
            onMouseEnter: onMouseEnter,
            analytics: {
                attributes: {
                    selectedOption: (0, $aqBCK.LINK_ISSUE_MENU_ID)
                }
            }
        }
    ] : [];
};
const $407dda63ef57658a$var$messageContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});

});


parcelRegister("9gxbP", function(module, exports) {

$parcel$export(module.exports, "useMoveTo", () => $0de9ffe9ad3e7cbb$export$f91d8f33a4d36cb0);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $2xFXk = parcelRequire("2xFXk");

var $iuuJH = parcelRequire("iuuJH");

var $bwTbl = parcelRequire("bwTbl");

var $cIqUn = parcelRequire("cIqUn");

var $71oFY = parcelRequire("71oFY");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

var $9OPlz = parcelRequire("9OPlz");

var $3UY9S = parcelRequire("3UY9S");

var $vAfHD = parcelRequire("vAfHD");

var $cPmFH = parcelRequire("cPmFH");

var $d2i8f = parcelRequire("d2i8f");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $63LqY = parcelRequire("63LqY");

var $iPDOH = parcelRequire("iPDOH");
const $0de9ffe9ad3e7cbb$var$FIELD_KEY = (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE];
const $0de9ffe9ad3e7cbb$export$f91d8f33a4d36cb0 = ({ issueId: issueId, selectedCardIds: selectedCardIds, isMultiSelectMode: isMultiSelectMode })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const allIssues = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardIssuesSelector));
    const orderedIssueIds = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardOrderedIssueIdsSelector));
    const selectedIssueIndex = orderedIssueIds.indexOf(issueId);
    const nextIssueId = orderedIssueIds[selectedIssueIndex + 1];
    const previousIssueId = orderedIssueIds[selectedIssueIndex - 1];
    const selectedIssue = allIssues[String(issueId)];
    const selectedCardsContainSubtasks = (0, $67sX6.useBoardSelector)((state)=>isMultiSelectMode ? (0, $9OPlz.areAnySelectedCardsIssueChildren)(state) : (0, $vAfHD.isBoardIssueAChild)(state)(issueId));
    const isSelected = (0, $67sX6.useBoardSelector)((0, $9OPlz.isCardSelected))(issueId);
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const hasSwimlanes = swimlaneMode !== (0, $iuuJH.NO_SWIMLANE).id;
    const swimlaneId = (0, $67sX6.useBoardSelector)((state)=>hasSwimlanes && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(selectedIssue) ? (0, $bwTbl.getSwimlaneId)(swimlaneMode, (0, $4jZ56.getSwimlanes)(state), selectedIssue) : null);
    const issueChildren = (0, $67sX6.useBoardSelector)((0, $3UY9S.getIssueChildren));
    const isMoveGroupCard = swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && issueId in issueChildren;
    const tryGetRankableIssueId = (id)=>{
        if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && id && id in issueChildren) return issueChildren[id].parentId;
        return id;
    };
    const firstIssueChildInColumnByParent = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getFirstIssueChildInColumnByParent)(state, selectedIssue?.columnId, selectedIssue?.parentId));
    const lastIssueChildInColumnByParent = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getLastIssueChildInColumnByParent)(state, selectedIssue?.columnId, selectedIssue?.parentId));
    const firstIssueIdInColumn = (0, $67sX6.useBoardSelector)((state)=>!hasSwimlanes || !swimlaneId ? (0, $d2i8f.getFirstIssueInColumn)(state, selectedIssue?.columnId) : (0, $cPmFH.getFirstIssueIdInSwimlane)(state, selectedIssue?.columnId, swimlaneId));
    const lastIssueIdInColumn = (0, $67sX6.useBoardSelector)((state)=>!hasSwimlanes || !swimlaneId ? (0, $d2i8f.getLastIssueInColumn)(state, selectedIssue?.columnId) : (0, $cPmFH.getLastIssueIdInSwimlane)(state, selectedIssue?.columnId, swimlaneId));
    const firstIssueId = isMoveGroupCard ? firstIssueChildInColumnByParent : tryGetRankableIssueId(firstIssueIdInColumn);
    const lastIssueId = isMoveGroupCard ? lastIssueChildInColumnByParent : tryGetRankableIssueId(lastIssueIdInColumn);
    const isFirst = issueId === firstIssueId;
    const isLast = issueId === lastIssueId;
    const canMoveToBacklog = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_MOVE_TO_BACKLOG_CONTEXT_MENU_ITEM);
    const isMoveToBacklogEnabled = (0, $67sX6.useBoardSelector)((state)=>canMoveToBacklog && (0, $k8auG.isBacklogEnabled)(state) && !(0, $ebHh7.isSprintsEnabled)(state) && !selectedCardsContainSubtasks);
    const fireAnalyticsEnd = (0, $5uXOq.useCallback)((isRankChange = true)=>{
        if (selectedCardIds.length !== 1) return;
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd($0de9ffe9ad3e7cbb$var$FIELD_KEY, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.SPRINT_TYPE),
                ...isRankChange ? {
                    hasRankChanged: true
                } : {
                    actionTaken: 'moveFromBoardToBacklog'
                }
            }
        });
    }, [
        createAnalyticsEvent,
        selectedCardIds.length
    ]);
    const onMoveToBacklog = (0, $67sX6.useBoardActionCreator)(()=>{
        const issueIdsToMove = selectedCardIds;
        const issueKeysToMove = selectedCardIds.map((cardId)=>allIssues[String(cardId)].key);
        const firstColumnId = allIssues[String(selectedCardIds[0])].columnId;
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd(false);
        return (0, $cIqUn.issueMoveToBacklogRequest)(issueIdsToMove, issueKeysToMove, firstColumnId);
    });
    const onMoveToTop = (0, $67sX6.useBoardActionCreator)(()=>{
        if (isSelected && selectedCardIds.length > 1) return (0, $71oFY.bulkIssueRankTransitionRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: firstIssueId,
            rankAfterIssueId: null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd();
        return (0, $71oFY.issueRankTransitionRequest)({
            issueIds: [
                issueId
            ],
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: firstIssueId,
            rankAfterIssueId: null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
    });
    const onMoveToBottom = (0, $67sX6.useBoardActionCreator)(()=>{
        if (isSelected && selectedCardIds.length > 1) return (0, $71oFY.bulkIssueRankTransitionRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: null,
            rankAfterIssueId: lastIssueId,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd();
        return (0, $71oFY.issueRankTransitionRequest)({
            issueIds: [
                issueId
            ],
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: null,
            rankAfterIssueId: lastIssueId,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
    });
    const onMoveDown = (0, $67sX6.useBoardActionCreator)(()=>{
        if (isSelected && selectedCardIds.length > 1) return (0, $71oFY.bulkIssueRankTransitionRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: null,
            rankAfterIssueId: nextIssueId,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd();
        return (0, $71oFY.issueRankTransitionRequest)({
            issueIds: [
                issueId
            ],
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: null,
            rankAfterIssueId: nextIssueId,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
    });
    const onMoveUp = (0, $67sX6.useBoardActionCreator)(()=>{
        if (isSelected && selectedCardIds.length > 1) return (0, $71oFY.bulkIssueRankTransitionRequest)({
            issueIds: selectedCardIds,
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: previousIssueId,
            rankAfterIssueId: null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
        if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) fireAnalyticsEnd();
        return (0, $71oFY.issueRankTransitionRequest)({
            issueIds: [
                issueId
            ],
            sourceColumnId: selectedIssue.columnId,
            destinationColumnId: selectedIssue.columnId,
            rankBeforeIssueId: previousIssueId,
            rankAfterIssueId: null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
    });
    const onMouseEnter = (0, $5uXOq.useCallback)(()=>{
        (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart($0de9ffe9ad3e7cbb$var$FIELD_KEY, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.SPRINT_TYPE),
                ...(0, $4R6GH.fg)('one_event_fast_follow_fg') && {
                    isContextMenuEditing: true
                }
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return (0, $iPDOH.useMoveToContent)({
        isMoveToBacklogEnabled: isMoveToBacklogEnabled,
        isMoveToTopActionVisible: !isFirst,
        isMoveToBottomActionVisible: !isLast,
        isMoveUpActionVisible: !isFirst && previousIssueId !== undefined,
        isMoveDownActionVisible: !isLast && nextIssueId !== undefined,
        onMoveToBacklog: onMoveToBacklog,
        onMoveToTop: onMoveToTop,
        onMoveToBottom: onMoveToBottom,
        onMoveUp: onMoveUp,
        onMoveDown: onMoveDown,
        ...selectedCardIds.length === 1 && (0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            onMouseEnter: onMouseEnter
        }
    });
};

});
parcelRegister("iPDOH", function(module, exports) {

$parcel$export(module.exports, "useMoveToContent", () => $9f5450737192f911$export$ba5a2e46cd05ad01);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $4R6GH = parcelRequire("4R6GH");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");

var $cZdmg = parcelRequire("cZdmg");
const $9f5450737192f911$export$ba5a2e46cd05ad01 = ({ onMoveToBacklog: onMoveToBacklog, onMoveToTop: onMoveToTop, onMoveToBottom: onMoveToBottom, onMoveUp: onMoveUp, onMoveDown: onMoveDown, isMoveUpActionVisible: isMoveUpActionVisible, isMoveDownActionVisible: isMoveDownActionVisible, isMoveToBacklogEnabled: isMoveToBacklogEnabled, isMoveToTopActionVisible: isMoveToTopActionVisible, isMoveToBottomActionVisible: isMoveToBottomActionVisible, onMouseEnter: onMouseEnter })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const moveToActions = [];
    const { setScreenReaderText: setScreenReaderText } = (0, $cZdmg.useScreenReader)();
    if (isMoveToBacklogEnabled) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $aqBCK.MOVE_TO_BACKLOG_MENU_ID),
        label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $kOuTq.default).backlog) : formatMessage((0, $kOuTq.default).backlogOld),
        onClick: onMoveToBacklog
    });
    if (isMoveToTopActionVisible) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $aqBCK.MOVE_TO_TOP_OF_COLUMN_MENU_ID),
        label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $kOuTq.default).topOfTheColumn) : formatMessage((0, $kOuTq.default).topOfTheColumnOld),
        onClick: ()=>{
            setScreenReaderText?.((0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $kOuTq.default).movedToTopOfTheColumn) : formatMessage((0, $kOuTq.default).movedToTopOfTheColumnOld));
            onMoveToTop();
        }
    });
    if ((0, $4R6GH.fg)('move_work_item_context_menu')) {
        if (isMoveUpActionVisible) moveToActions.push({
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $aqBCK.MOVE_UP_WITHIN_COLUMN_MENU_ID),
            label: formatMessage((0, $kOuTq.default).up),
            onClick: ()=>{
                if (onMoveUp) {
                    setScreenReaderText?.(formatMessage((0, $kOuTq.default).movedUp));
                    onMoveUp();
                }
            }
        });
        if (isMoveDownActionVisible) moveToActions.push({
            type: (0, $1HF4Y.MenuNodeType).Item,
            id: (0, $aqBCK.MOVE_DOWN_WITHIN_COLUMN_MENU_ID),
            label: formatMessage((0, $kOuTq.default).down),
            onClick: ()=>{
                if (onMoveDown) {
                    setScreenReaderText?.(formatMessage((0, $kOuTq.default).movedDown));
                    onMoveDown();
                }
            }
        });
    }
    if (isMoveToBottomActionVisible) moveToActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: (0, $aqBCK.MOVE_TO_BOTTOM_OF_COLUMN_MENU_ID),
        label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $kOuTq.default).bottomOfTheColumn) : formatMessage((0, $kOuTq.default).bottomOfTheColumnOld),
        onClick: ()=>{
            setScreenReaderText?.((0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $kOuTq.default).movedToBottomOfTheColumn) : formatMessage((0, $kOuTq.default).movedToBottomOfTheColumnOld));
            onMoveToBottom();
        }
    });
    return moveToActions.length > 0 ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: (0, $4R6GH.fg)('move_work_item_context_menu') ? formatMessage((0, $kOuTq.default).moveWorkItem) : formatMessage((0, $kOuTq.default).moveTo),
            id: (0, $aqBCK.MOVE_TO_MENU_ID),
            children: moveToActions,
            onMouseEnter: onMouseEnter
        }
    ] : [];
};

});


parcelRegister("iokTG", function(module, exports) {

$parcel$export(module.exports, "useRemoveFromSprint", () => $d535047d7535e08e$export$eafff7a110781470);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $g4tDr = parcelRequire("g4tDr");

var $5fc53 = parcelRequire("5fc53");

var $2NMNM = parcelRequire("2NMNM");

var $1HF4Y = parcelRequire("1HF4Y");

var $2xFXk = parcelRequire("2xFXk");

var $5G4Hb = parcelRequire("5G4Hb");

var $67sX6 = parcelRequire("67sX6");

var $kc6Ry = parcelRequire("kc6Ry");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");
const $d535047d7535e08e$export$24a921d394b5e6a = ({ isRemoveFromSprintEnabled: isRemoveFromSprintEnabled, onRemoveFromSprint: onRemoveFromSprint, shouldFireAnalytics: shouldFireAnalytics })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (shouldFireAnalytics) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.SPRINT_TYPE], {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.SPRINT_TYPE),
                actionTaken: 'remove'
            }
        });
        onRemoveFromSprint();
    }, [
        createAnalyticsEvent,
        onRemoveFromSprint,
        shouldFireAnalytics
    ]);
    if (!isRemoveFromSprintEnabled) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).removeFromSprint),
            id: (0, $aqBCK.REMOVE_FROM_SPRINT_MENU_ID),
            onClick: onClick
        }
    ];
};
const $d535047d7535e08e$export$eafff7a110781470 = ({ issueId: issueId, selectedCardIds: selectedCardIds })=>{
    const canRemoveFromSprint = (0, $67sX6.useBoardSelector)((state)=>(0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).REMOVE_FROM_SPRINT));
    const issue = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueById)(state, issueId));
    const isBaseType = (0, $67sX6.useBoardSelector)((0, $67Z81.getProjectIssueTypes))[issue?.typeId]?.hierarchyLevelType === (0, $g4tDr.BASE_HIERARCHY_TYPE);
    // TODO: add bulk remove from sprint once feature is added in UIF
    const onRemoveFromSprint = (0, $67sX6.useBoardActionCreator)(()=>(0, $5G4Hb.removeFromSprintRequest)(issueId));
    return $d535047d7535e08e$export$24a921d394b5e6a({
        isRemoveFromSprintEnabled: canRemoveFromSprint && isBaseType,
        onRemoveFromSprint: onRemoveFromSprint,
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            shouldFireAnalytics: selectedCardIds?.length === 1
        }
    });
};

});

parcelRegister("fg8U1", function(module, exports) {

$parcel$export(module.exports, "useViewIssueSearch", () => $b1bd69fa79323c9d$export$25bfc6e740013d37);

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $lVJAU = parcelRequire("lVJAU");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");
const $b1bd69fa79323c9d$export$e025d73d45de7b90 = ({ isViewInIssueSearchVisible: isViewInIssueSearchVisible, onViewIssueSearch: onViewIssueSearch })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!isViewInIssueSearchVisible) return [];
    return [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $kOuTq.default).viewInIssueSearchIssueTermRefresh : (0, $kOuTq.default).viewInIssueSearch),
            id: (0, $aqBCK.VIEW_IN_ISSUE_SEARCH_MENU_ID),
            onClick: onViewIssueSearch
        }
    ];
};
const $b1bd69fa79323c9d$export$25bfc6e740013d37 = ({ isMultiSelectMode: isMultiSelectMode })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const selectedIssueKeys = (0, $67sX6.useBoardSelector)((0, $9OPlz.selectedIssueKeysSelector));
    const onViewIssueSearch = ()=>{
        const url = `/issues/?jql=${encodeURIComponent(`key IN (${selectedIssueKeys.join(',')})`)}`;
        push(url);
    };
    return $b1bd69fa79323c9d$export$e025d73d45de7b90({
        onViewIssueSearch: onViewIssueSearch,
        isViewInIssueSearchVisible: isMultiSelectMode
    });
};

});

parcelRegister("9nGbv", function(module, exports) {

$parcel$export(module.exports, "useChangeStatus", () => $b2460f4af717d5dc$export$7177276b620649c3);

var $2NMNM = parcelRequire("2NMNM");

var $8ikZj = parcelRequire("8ikZj");

var $5fc53 = parcelRequire("5fc53");

var $ctrpc = parcelRequire("ctrpc");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $67sX6 = parcelRequire("67sX6");

var $lIysR = parcelRequire("lIysR");

var $71oFY = parcelRequire("71oFY");

var $vAfHD = parcelRequire("vAfHD");

var $9NcAi = parcelRequire("9NcAi");
const $b2460f4af717d5dc$var$FIELD_KEY = (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STATUS_TYPE];
const $b2460f4af717d5dc$export$7177276b620649c3 = ({ issueId: issueId })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({});
    const allIssues = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardIssuesSelector));
    const issue = allIssues[String(issueId)];
    const { transitionsByStatusName: transitionsByStatusName } = (0, $67sX6.useBoardSelector)((state)=>issue ? (0, $lIysR.cardTransitionsColumnsSelector)(state, issue) : {
            transitionsByStatusName: new Map()
        });
    const getSourceStatus = (0, $4R6GH.fg)('one_event_iteration_3') ? (0, $67sX6.useBoardSelector)((0, $lIysR.cardTransitionSourceStatusSelector)) : ()=>null;
    const onChangeStatus = (0, $67sX6.useBoardActionCreator)((targetStatusName)=>{
        const transition = transitionsByStatusName.get(targetStatusName);
        if (!transition) throw new Error(`No transition found for status: ${targetStatusName}`);
        const { destinationColumnId: destinationColumnId, transitionId: transitionId } = transition;
        const sourceStatus = (0, $4R6GH.fg)('one_event_iteration_3') ? getSourceStatus(issue.id) : null;
        (0, $4R6GH.fg)('one_event_iteration_3') && (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd($b2460f4af717d5dc$var$FIELD_KEY, {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $5fc53.STATUS_TYPE),
                oldValId: issue?.statusId,
                newValId: transition.targetStatusId,
                oldStatusCategoryId: (0, $gULOk.categoryIdForStatusCategory)(sourceStatus?.category),
                newStatusCategoryId: (0, $gULOk.categoryIdForStatusCategory)(transition.targetStatusCategory),
                ...(0, $4R6GH.fg)('one_event_status_update_fix') && {
                    isContextMenuEditing: true,
                    isIssueViewEditing: false
                }
            }
        });
        return (0, $71oFY.issueRankTransitionRequest)({
            issueIds: [
                issue.id
            ],
            sourceColumnId: issue.columnId,
            destinationColumnId: destinationColumnId,
            transitionId: transitionId,
            rankBeforeIssueId: null,
            rankAfterIssueId: null,
            sourceSwimlaneId: null,
            destinationSwimlaneId: null,
            isSourceDone: false,
            isDestinationDone: false,
            analyticsEvent: analyticsEvent
        });
    });
    return (0, $9NcAi.useChangeStatusContent)({
        onChangeStatus: onChangeStatus,
        transitionsByStatusName: transitionsByStatusName
    });
};

});
parcelRegister("9NcAi", function(module, exports) {

$parcel$export(module.exports, "useChangeStatusContent", () => $864c093871d510b6$export$c25d13b1c2c9b7f6);

var $koVbs = parcelRequire("koVbs");

var $1HF4Y = parcelRequire("1HF4Y");

var $aqBCK = parcelRequire("aqBCK");

var $kOuTq = parcelRequire("kOuTq");

var $cZdmg = parcelRequire("cZdmg");
const $864c093871d510b6$export$c25d13b1c2c9b7f6 = ({ onChangeStatus: onChangeStatus, transitionsByStatusName: transitionsByStatusName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const changeStatusActions = [];
    const { setScreenReaderText: setScreenReaderText } = (0, $cZdmg.useScreenReader)();
    for (const [statusName] of transitionsByStatusName.entries())changeStatusActions.push({
        type: (0, $1HF4Y.MenuNodeType).Item,
        id: `${(0, $aqBCK.CHANGE_STATUS_MENU_ID)}${statusName}`,
        label: statusName,
        onClick: ()=>{
            setScreenReaderText(formatMessage((0, $kOuTq.default).changedStatusTo, {
                statusName: statusName
            }));
            onChangeStatus(statusName);
        }
    });
    return changeStatusActions.length > 0 ? [
        {
            type: (0, $1HF4Y.MenuNodeType).Item,
            label: formatMessage((0, $kOuTq.default).changeStatus),
            id: (0, $aqBCK.CHANGE_STATUS_MENU_ID),
            children: changeStatusActions
        }
    ] : [];
};

});



parcelRegister("2H35T", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $c0209f570fa75393$export$471e3cf08f140899);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $dzmFY = parcelRequire("dzmFY");

var $iDGXn = parcelRequire("iDGXn");

var $67sX6 = parcelRequire("67sX6");

var $4vVV6 = parcelRequire("4vVV6");

var $5tA4K = parcelRequire("5tA4K");

var $d2i8f = parcelRequire("d2i8f");
const $c0209f570fa75393$export$471e3cf08f140899 = ({ id: id, typeId: typeId, issueKey: issueKey, summary: summary, onIssueUnlink: onIssueUnlink })=>{
    const shouldShowIssueLinksStats = (0, $iDGXn.useShowIssueLinksStats)();
    const issueLinksCount = (0, $67sX6.useBoardSelector)((state)=>(0, $5tA4K.getIssueLinksStatsForCard)(state)(`${id}`));
    const isLoadingIssueLinkStats = (0, $67sX6.useBoardSelector)((state)=>(0, $5tA4K.getIsLoadingIssueLinksStatsForCard)(state)(`${id}`));
    const { canUserLinkIssue: canUserLinkIssue } = (0, $67sX6.useBoardSelector)((boardState)=>(0, $4vVV6.getIssueLinksPermissions)(boardState));
    const issueType = (0, $67sX6.useBoardSelector)((state)=>(0, $d2i8f.getIssueTypeById)(state, Number(typeId)));
    if (!id || !shouldShowIssueLinksStats || issueLinksCount <= 0 && !isLoadingIssueLinkStats) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzmFY.IssueLinksStats), {
        issueLinksCount: issueLinksCount,
        issueKey: issueKey,
        issueId: `${id}`,
        issueSummary: summary,
        issueType: issueType,
        isLoading: isLoadingIssueLinkStats,
        feedbackCollectorPrefix: "board",
        onIssueUnlink: onIssueUnlink,
        canUserLinkIssue: canUserLinkIssue,
        withDueDate: false,
        sourceProductType: (0, $2vSU6.SOFTWARE_PROJECT)
    });
};

});
parcelRegister("dzmFY", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $d6d4cb6e75560e61$export$471e3cf08f140899);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $3APXE = parcelRequire("3APXE");
const $d6d4cb6e75560e61$export$471e3cf08f140899 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-issue-links-stats",
        packageName: "jiraIssueLinksStats",
        teamName: "jira-werewolves",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3APXE.IssueLinksStats), props));

});
parcelRegister("3APXE", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStats", () => $7d164ade27960df7$export$471e3cf08f140899);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $eaGfl = parcelRequire("eaGfl");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $iXVV6 = parcelRequire("iXVV6");

var $efvDm = parcelRequire("efvDm");

var $7dRcU = parcelRequire("7dRcU");

var $hq3QC = parcelRequire("hq3QC");


var $kL33h = parcelRequire("kL33h");
const $7d164ade27960df7$export$471e3cf08f140899 = ({ issueLinksCount: issueLinksCount, testId: testId, issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueType: issueType, onIssueUnlink: onIssueUnlink, feedbackCollectorPrefix: feedbackCollectorPrefix, isLoading: isLoading = false, canUserLinkIssue: canUserLinkIssue, withDueDate: withDueDate = false, maxIssueLinksStatsCount: maxIssueLinksStatsCount = (0, $07ef59ce637b0eaa$export$1e94b9630d01edd3), sourceProductType: sourceProductType, isLinkIssuePopupEnabled: isLinkIssuePopupEnabled = false, onSuccessfulIssueLink: onSuccessfulIssueLink = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const { isFocusOnIssueLinksStats: isFocusOnIssueLinksStats, focusOnIssueLinks: focusOnIssueLinks } = (0, $hq3QC.useFocusOnIssueLinksStats)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "issueLinksStats",
        attributes: {
            application: sourceProductType && (0, $efvDm.getApplicationForProject)(sourceProductType)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7dRcU.IssueLinkedStatsContainer), {
        isGlobal: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d164ade27960df7$var$issueStatsRowStyles,
        testId: testId,
        onClick: (event)=>event.stopPropagation(),
        onBlur: (event)=>event.stopPropagation()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true,
        space: "space.050"
    }, isLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7d164ade27960df7$var$skeletonLoaderStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eaGfl.default), {
        isShimmering: true,
        width: "100%",
        testId: testId ? `${testId}.skeleton-loader` : undefined
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kL33h.IssueLinksStatsButton), {
        issueKey: issueKey,
        issueId: issueId,
        issueSummary: issueSummary,
        issueType: issueType,
        issueLinkCount: issueLinksCount,
        isFocusOnTrigger: isFocusOnIssueLinksStats,
        feedbackCollectorPrefix: feedbackCollectorPrefix,
        onIssueUnlink: onIssueUnlink,
        onFocusToTrigger: focusOnIssueLinks,
        canUserLinkIssue: canUserLinkIssue,
        withDueDate: withDueDate,
        maxIssueLinksStatsCount: maxIssueLinksStatsCount,
        sourceProductType: sourceProductType,
        isLinkIssuePopupEnabled: isLinkIssuePopupEnabled,
        onSuccessfulIssueLink: onSuccessfulIssueLink
    })))));
};
const $7d164ade27960df7$var$issueStatsRowStyles = (0, $8CUq3.xcss)({
    cursor: 'default',
    borderTop: 'none'
});
// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
const $7d164ade27960df7$var$skeletonLoaderStyles = (0, $8CUq3.xcss)({
    width: '29px',
    maxWidth: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    div: {
        width: '100%',
        padding: '0',
        '::after': {
            height: '23px',
            borderRadius: `${// eslint-disable-next-line @atlaskit/design-system/no-unsafe-design-token-usage -- The token value "2px" and fallback "3px" do not match and can't be replaced automatically.
            "var(--ds-border-radius-050, 3px)"}`
        }
    }
});

});
parcelRegister("hq3QC", function(module, exports) {

$parcel$export(module.exports, "useFocusOnIssueLinksStats", () => $4735d091759d52b4$export$1eb968fd055a41eb);
$parcel$export(module.exports, "useFocusOnIssueLinksStatsEffect", () => $4735d091759d52b4$export$21fe799ef0ecc038);

var $5uXOq = parcelRequire("5uXOq");
const $4735d091759d52b4$export$1eb968fd055a41eb = ()=>{
    const [isFocusOnIssueLinksStats, setIsFocusOnIssueLinksStats] = (0, $5uXOq.useState)(false);
    return {
        isFocusOnIssueLinksStats: isFocusOnIssueLinksStats,
        focusOnIssueLinks: setIsFocusOnIssueLinksStats
    };
};
const $4735d091759d52b4$export$21fe799ef0ecc038 = ({ isFocusOnTrigger: isFocusOnTrigger, onFocusToTrigger: onFocusToTrigger })=>{
    const openTriggerRef = (0, $5uXOq.useRef)(null);
    const updateRef = (0, $5uXOq.useCallback)((element)=>{
        openTriggerRef.current = element;
    }, [
        openTriggerRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isFocusOnTrigger) return;
        openTriggerRef.current?.focus();
        onFocusToTrigger(false);
    }, [
        isFocusOnTrigger,
        onFocusToTrigger,
        openTriggerRef
    ]);
    return updateRef;
};

});

const $07ef59ce637b0eaa$export$1e94b9630d01edd3 = 9;

parcelRegister("kL33h", function(module, exports) {

$parcel$export(module.exports, "IssueLinksStatsButton", () => $f6076da76b5bf322$export$dae0579b240a5f3b);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $7dRcU = parcelRequire("7dRcU");

var $lwYZK = parcelRequire("lwYZK");

var $5BMYo = parcelRequire("5BMYo");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $f6076da76b5bf322$var$noop = ()=>{};
const $f6076da76b5bf322$export$dae0579b240a5f3b = ({ issueLinkCount: issueLinkCount, issueKey: issueKey, issueId: issueId, issueSummary: issueSummary, issueType: issueType, isFocusOnTrigger: isFocusOnTrigger, feedbackCollectorPrefix: feedbackCollectorPrefix, onIssueUnlink: onIssueUnlink, onFocusToTrigger: onFocusToTrigger, canUserLinkIssue: canUserLinkIssue, withDueDate: withDueDate = false, maxIssueLinksStatsCount: maxIssueLinksStatsCount, sourceProductType: sourceProductType, onSuccessfulIssueLink: onSuccessfulIssueLink = $f6076da76b5bf322$var$noop, isLinkIssuePopupEnabled: isLinkIssuePopupEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isOpen = (0, $7dRcU.useIsIssueLinkDetailsPopupOpen)({
        openedIssueKey: issueKey
    });
    const issueLinkCountDisplay = issueLinkCount > maxIssueLinksStatsCount ? `${maxIssueLinksStatsCount}+` : issueLinkCount;
    const tooltipContent = issueLinkCount > maxIssueLinksStatsCount ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5BMYo.messages).genericMaxIssueLinksStatsTooltipLabelIssueTermRefresh : (0, $5BMYo.messages).genericMaxIssueLinksStatsTooltipLabel, {
        maxIssueLinksStatsCount: maxIssueLinksStatsCount
    }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5BMYo.messages).issueLinksTooltipLabelIssueTermRefresh : (0, $5BMYo.messages).issueLinksTooltipLabel, {
        issueLinkCount: issueLinkCount
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isOpen ? '' : tooltipContent,
        testId: "issue-links-stats.ui.issue-links-stats-button.linked-issue-stats-tooltip",
        delay: 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lwYZK.IssueLinksDetailsPopupEntryPointContainer), {
        isOpen: isOpen,
        isFocusOnTrigger: isFocusOnTrigger,
        issueId: issueId,
        issueLinkCount: issueLinkCountDisplay,
        issueSummary: issueSummary,
        issueType: issueType,
        issueKey: issueKey,
        feedbackCollectorPrefix: feedbackCollectorPrefix,
        onIssueUnlink: onIssueUnlink,
        onFocusToTrigger: onFocusToTrigger,
        canUserLinkIssue: canUserLinkIssue,
        iconLabel: tooltipContent,
        withDueDate: withDueDate,
        sourceProductType: sourceProductType,
        onSuccessfulIssueLink: onSuccessfulIssueLink,
        isLinkIssuePopupEnabled: isLinkIssuePopupEnabled
    }));
};

});
parcelRegister("lwYZK", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsPopupEntryPointContainer", () => $f91362c69c59b48b$export$b0a7e2f26787ad5d);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $eyYcL = parcelRequire("eyYcL");

var $lJosW = parcelRequire("lJosW");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $dGrdR = parcelRequire("dGrdR");

var $gwIPs = parcelRequire("gwIPs");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $HeOPt = parcelRequire("HeOPt");

var $bMyiD = parcelRequire("bMyiD");

var $jgJNO = parcelRequire("jgJNO");

var $hchBL = parcelRequire("hchBL");

var $8zOmE = parcelRequire("8zOmE");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");


var $4R6GH = parcelRequire("4R6GH");

var $7dRcU = parcelRequire("7dRcU");

var $hq3QC = parcelRequire("hq3QC");

var $aygpR = parcelRequire("aygpR");

var $cIlUQ = parcelRequire("cIlUQ");

var $7O6AD = parcelRequire("7O6AD");

var $9RuF6 = parcelRequire("9RuF6");

var $adSHj = parcelRequire("adSHj");
const $f91362c69c59b48b$var$MAX_ISSUE_LINKS_COUNT = 50;
const $f91362c69c59b48b$var$asyncIssueLinksDetailsLoad = (0, $dGrdR.metrics).interaction({
    key: 'issue-links-details-content-load'
});
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $f91362c69c59b48b$var$noop = ()=>{};
const $f91362c69c59b48b$export$b0a7e2f26787ad5d = ({ issueKey: issueKey, isOpen: isOpen, isFocusOnTrigger: isFocusOnTrigger = false, issueId: issueId, issueSummary: issueSummary, issueType: issueType, issueLinkCount: issueLinkCount, feedbackCollectorPrefix: feedbackCollectorPrefix, onIssueUnlink: onIssueUnlink, canUserLinkIssue: canUserLinkIssue, onFocusToTrigger: onFocusToTrigger = $f91362c69c59b48b$var$noop, iconLabel: iconLabel = '', withDueDate: withDueDate = false, sourceProductType: sourceProductType, onSuccessfulIssueLink: onSuccessfulIssueLink = $f91362c69c59b48b$var$noop, isLinkIssuePopupEnabled: isLinkIssuePopupEnabled = false })=>{
    const { handleOnClose: handleOnClose, handleOnOpenLinkedIssueDetailsPopup: handleOnOpenLinkedIssueDetailsPopup } = (0, $7dRcU.useIssueLinkedStatsActions)();
    const [state, { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject }] = (0, $HeOPt.useIssueLinkedModalEntrypointStore)();
    const cloudId = (0, $koeKL.useCloudId)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const linkedIssuesRef = (0, $5uXOq.useRef)(null);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            issueKey: issueKey,
            // Fetch 1 more than required so that we show view all linked issues button
            issueCount: $f91362c69c59b48b$var$MAX_ISSUE_LINKS_COUNT + 1,
            withDueDate: withDueDate,
            fields: [
                'issuetype',
                'summary',
                'status',
                ...withDueDate ? [
                    'duedate'
                ] : []
            ]
        }), [
        cloudId,
        issueKey,
        withDueDate
    ]);
    const { entryPointReferenceSubject: entryPointReferenceSubject, entryPointActions: entryPointActions, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bMyiD.issueLinksDetailsContentEntryPoint), entryPointParams, $f91362c69c59b48b$var$asyncIssueLinksDetailsLoad);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const handleButtonClicked = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        event.stopPropagation();
        setIssueLinkModalEntryPointSubject({
            issueData: null
        });
        // Click the button to open details popup, and click again to close it.
        if (isOpen) handleOnClose();
        else handleOnOpenLinkedIssueDetailsPopup(issueKey);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'button clicked', 'issueLinksStats', {
            isToOpenPopup: !isOpen
        });
        (0, $4R6GH.fg)('jfp_a11y_team_keyboard_focus_does_not_return') && register((0, $97431fdd4a86ccff$export$542a20d67952f202), linkedIssuesRef.current);
    }, [
        handleOnClose,
        handleOnOpenLinkedIssueDetailsPopup,
        isOpen,
        issueKey,
        register,
        setIssueLinkModalEntryPointSubject
    ]);
    const updateTriggerRefOnIssueLinksStatsClose = (0, $aygpR.useHandleOnIssueLinksStatsClose)({
        isIssueLinkStatsOpen: isOpen,
        isLinkIssueModalOpen: Boolean(state.issueData?.issueKey === issueKey)
    });
    const handleOnIssueUnlink = (0, $5uXOq.useCallback)((issueIds)=>{
        handleOnClose();
        onIssueUnlink?.(issueIds);
        onFocusToTrigger(true);
    }, [
        handleOnClose,
        onFocusToTrigger,
        onIssueUnlink
    ]);
    const stopEventPropagation = (event)=>event.stopPropagation();
    const onPopupKeyPressed = (0, $5uXOq.useCallback)((event)=>{
        stopEventPropagation(event);
        // According to the source code in Atlaskit/popup/src/use-close-manager.tsx#lines-61
        // The internal implementation of closing the Popup is exactly the same as below
        // And it triggers *no side effect* other than call the onClose callback directly,
        // which in this component simply calls handlePopupClose. This should be safe.
        // Review this in case any odd behaviours are observed when closing the popup with the escape key.
        if (event.key === 'Escape') handleOnClose();
    }, [
        handleOnClose
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            issueKey: issueKey,
            issueSummary: issueSummary,
            issueId: issueId,
            issueType: issueType,
            canUserLinkIssue: canUserLinkIssue,
            onIssueUnlink: handleOnIssueUnlink,
            onPopupClose: handleOnClose,
            maxIssuesToDisplay: $f91362c69c59b48b$var$MAX_ISSUE_LINKS_COUNT,
            feedbackCollectorPrefix: feedbackCollectorPrefix,
            onReady: stopMetric,
            sourceProductType: sourceProductType
        }), [
        feedbackCollectorPrefix,
        canUserLinkIssue,
        cloudId,
        handleOnClose,
        handleOnIssueUnlink,
        issueId,
        issueKey,
        issueSummary,
        issueType,
        sourceProductType,
        stopMetric
    ]);
    const openTriggerRef = (0, $hq3QC.useFocusOnIssueLinksStatsEffect)({
        isFocusOnTrigger: isFocusOnTrigger,
        onFocusToTrigger: onFocusToTrigger
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const triggerButton = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            ...triggerProps,
            appearance: "subtle",
            spacing: "compact",
            testId: `issue-links-stats.ui.issue-links-stats-button.custom-theme-button-${issueKey}`,
            ref: (element)=>{
                triggerRef(element);
                openTriggerRef(element);
                updateTriggerRefOnIssueLinksStatsClose(element);
                (0, $4R6GH.fg)('jfp_a11y_team_keyboard_focus_does_not_return') && (linkedIssuesRef.current = element);
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                triggerProps.ref(element);
            },
            isSelected: isOpen,
            onClick: handleButtonClicked,
            onContextMenu: stopEventPropagation,
            onKeyDown: stopEventPropagation,
            onMouseDown: (event)=>{
                event.preventDefault();
                event.stopPropagation();
            },
            "aria-label": formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $adSHj.messages).issueLinksButtonIssueTermRefresh : (0, $adSHj.messages).issueLinksButton, {
                issueLinkCount: issueLinkCount
            }),
            iconBefore: ()=>(0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eyYcL))), {
                    LEGACY_size: "small",
                    color: isOpen ? "var(--ds-icon-accent-blue, #1D7AFC)" : "var(--ds-icon, #44546F)",
                    label: ""
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($lJosW))), {
                    LEGACY_size: "small",
                    color: isOpen ? "var(--ds-icon-accent-blue, #1D7AFC)" : "var(--ds-icon, #44546F)",
                    label: iconLabel
                })
        }, issueLinkCount), [
        issueKey,
        isOpen,
        handleButtonClicked,
        formatMessage,
        issueLinkCount,
        iconLabel,
        triggerRef,
        openTriggerRef,
        updateTriggerRefOnIssueLinksStatsClose,
        linkedIssuesRef
    ]);
    const showLinkIssuePopup = Boolean(canUserLinkIssue && isLinkIssuePopupEnabled && state.issueData?.issueId === String(issueId) && state.issueData?.issueKey === issueKey);
    const DetailsContent = (0, $5uXOq.useCallback)(()=>{
        if (showLinkIssuePopup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9RuF6.LinkIssuePopup), {
            onSuccessfulIssueLink: onSuccessfulIssueLink
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            padding: "space.200",
            paddingInlineEnd: "space.050",
            xcss: $f91362c69c59b48b$var$ContainerStyles,
            onContextMenu: stopEventPropagation,
            onKeyDown: onPopupKeyPressed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "async-issue-links-details-content",
            runtimeProps: runtimeProps,
            packageName: "@atlassian/jira-issue-links-details-content",
            teamName: "jira-werewolves",
            errorFallback: ({ error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cIlUQ.IssueLinksDetailsErrorFallback), {
                    callback: handleOnClose,
                    error: error,
                    testId: "issue-links-stats.ui.issue-links-stats-button.issue-links-details-popup-entrypoint-container"
                }),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O6AD.IssueLinksDetailsPopupSkeleton), {
                noPadding: true,
                smallerWidth: true,
                testId: "issue-links-stats.ui.issue-links-stats-button.issue-links-details-popup-entrypoint-container.skeleton-loader"
            })
        }));
    }, [
        entryPointReferenceSubject,
        handleOnClose,
        onPopupKeyPressed,
        onSuccessfulIssueLink,
        runtimeProps,
        showLinkIssuePopup
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen || showLinkIssuePopup,
        onClose: handleOnClose,
        placement: "bottom-start",
        messageId: "issue-links-stats.ui.issue-links-stats-button.issue-links-details-popup-entrypoint-container.popup",
        messageType: "transactional",
        testId: "issue-links-stats.ui.issue-links-stats-button.issue-links-details-popup-entrypoint-container.popup",
        trigger: triggerButton,
        content: DetailsContent,
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $adSHj.messages).issueLinksPopupIssueTermRefresh : (0, $adSHj.messages).issueLinksPopup)
    });
};
$f91362c69c59b48b$export$b0a7e2f26787ad5d.displayName = 'IssueLinksDetailsPopupEntryPointContainer';
const $f91362c69c59b48b$var$ContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${(0, $gwIPs.gridSize) * 64}px`
});

});
parcelRegister("eyYcL", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::20c4153f88370509387fcb931f8e0884>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a9a2f11ac805a7dd$var$_react = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a9a2f11ac805a7dd$var$_issue = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("jB3w5")));

var $a9a2f11ac805a7dd$var$_issue2 = $a9a2f11ac805a7dd$var$_interopRequireDefault((parcelRequire("cWNOJ")));
function $a9a2f11ac805a7dd$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for IssueIcon.
 * This component is IssueIcon, with `UNSAFE_fallbackIcon` set to "IssueIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a9a2f11ac805a7dd$var$IssueIcon = (props)=>/*#__PURE__*/ $a9a2f11ac805a7dd$var$_react.default.createElement($a9a2f11ac805a7dd$var$_issue.default, Object.assign({
        LEGACY_fallbackIcon: $a9a2f11ac805a7dd$var$_issue2.default
    }, props));
$a9a2f11ac805a7dd$var$IssueIcon.Name = 'IssueIconMigration';
var $a9a2f11ac805a7dd$var$_default = module.exports.default = $a9a2f11ac805a7dd$var$IssueIcon;

});
parcelRegister("jB3w5", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1a34ab85cae43bfcc557db6c87d2e59>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e44433503bdca276$var$_react = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e44433503bdca276$var$_baseNew = $e44433503bdca276$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e44433503bdca276$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Issue".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for representing work items.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e44433503bdca276$var$IssueIcon = (props)=>/*#__PURE__*/ $e44433503bdca276$var$_react.default.createElement($e44433503bdca276$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 4a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v8a.5.5 0 0 0 .5.5h12a.5.5 0 0 0 .5-.5V4a.5.5 0 0 0-.5-.5zm8.426 1.517 1.148.966-4 4.75a.75.75 0 0 1-1.148 0l-2-2.375 1.148-.966L7 9.086z" clip-rule="evenodd"/>`
    }, props));
$e44433503bdca276$var$IssueIcon.displayName = 'IssueIcon';
var $e44433503bdca276$var$_default = module.exports.default = $e44433503bdca276$var$IssueIcon;

});

parcelRegister("cWNOJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $96d18b825901141c$var$_react = $96d18b825901141c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $96d18b825901141c$var$_issue = $96d18b825901141c$var$_interopRequireDefault((parcelRequire("jB3w5")));
function $96d18b825901141c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $96d18b825901141c$var$IssueIcon = (props)=>/*#__PURE__*/ $96d18b825901141c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M5 15.991c0 .007 14.005.009 14.005.009C18.999 16 19 8.009 19 8.009 19 8.002 4.995 8 4.995 8 5.001 8 5 15.991 5 15.991M3 8.01C3 6.899 3.893 6 4.995 6h14.01C20.107 6 21 6.902 21 8.009v7.982c0 1.11-.893 2.009-1.995 2.009H4.995A2.004 2.004 0 0 1 3 15.991z"/><path d="M10.674 14.331c.36.36.941.36 1.3 0l2.758-2.763a.92.92 0 0 0-1.301-1.298l-2.108 2.11-.755-.754a.92.92 0 0 0-1.3 1.3z"/></g></svg>`
    }, props, {
        newIcon: $96d18b825901141c$var$_issue.default
    }));
$96d18b825901141c$var$IssueIcon.displayName = 'IssueIcon';
var $96d18b825901141c$var$_default = module.exports.default = $96d18b825901141c$var$IssueIcon;

});


parcelRegister("bMyiD", function(module, exports) {

$parcel$export(module.exports, "issueLinksDetailsContentEntryPoint", () => $46c7c2f756fce2b8$export$ed55e17b62c0c3b0);

var $jGqUc = parcelRequire("jGqUc");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $46c7c2f756fce2b8$export$ed55e17b62c0c3b0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("kqWwP")), {
        moduleId: "56ed134e"
    }),
    getPreloadProps: ({ cloudId: cloudId, issueKey: issueKey, issueCount: issueCount, withDueDate: withDueDate, fields: fields })=>({
            queries: {
                issueLinksDetailsPopup: {
                    // policy can be updated to store-or-network once we have issue linking mutation through relay
                    options: {
                        fetchPolicy: 'store-and-network'
                    },
                    parameters: $jGqUc.default,
                    variables: {
                        cloudId: cloudId,
                        issueKey: issueKey,
                        issueCount: issueCount,
                        withDueDate: withDueDate,
                        fields: fields
                    }
                }
            }
        })
});

});
parcelRegister("jGqUc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3b5281d96509daab$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3911672bf59cd9c5cbbd5af9f5777951>>
 * @relayHash a08180161ec6ab9c7e11d8f628199d37
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41
const $3b5281d96509daab$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fb7810939eb3c247c90b6c590a41c138ba5abb1fafe8508efd4ed201487f6b41",
        "metadata": {},
        "name": "srcAsyncIssueLinksDetailsContentQuery",
        "operationKind": "query",
        "text": null
    }
};
var $3b5281d96509daab$export$2e2bcd8739ae039 = $3b5281d96509daab$var$node;

});

parcelRegister("kqWwP", function(module, exports) {

let $ee03a2e38ab75996$var$load = (parcelRequire("28QjX"))(4);
module.exports = $ee03a2e38ab75996$var$load("9SSqq").then(()=>parcelRequire('iD2bB'));

});


const $97431fdd4a86ccff$export$c14d5836f440dde1 = 'customfield_10047';
const $97431fdd4a86ccff$export$542a20d67952f202 = 'feedback-renderer.linked-issues-btn';

parcelRegister("aygpR", function(module, exports) {

$parcel$export(module.exports, "useHandleOnIssueLinksStatsClose", () => $206d363ff18ee153$export$99db27cbe204c383);

var $5uXOq = parcelRequire("5uXOq");

var $1XJ20 = parcelRequire("1XJ20");
const $206d363ff18ee153$export$99db27cbe204c383 = ({ isIssueLinkStatsOpen: isIssueLinkStatsOpen, isLinkIssueModalOpen: isLinkIssueModalOpen })=>{
    const openTriggerRef = (0, $5uXOq.useRef)(null);
    const previousIsIssueLinkStatsOpen = (0, $1XJ20.usePreviousWithInitial)(isIssueLinkStatsOpen);
    const previousisLinkIssueModalOpen = (0, $1XJ20.usePreviousWithInitial)(isLinkIssueModalOpen);
    const isIssueLinkStatsClosed = isIssueLinkStatsOpen === false && previousIsIssueLinkStatsOpen === true && // adding this condition here to prevent focus action when opening link issue modal from stats popup
    isLinkIssueModalOpen === false;
    const isIssueLinkModalClosed = isLinkIssueModalOpen === false && previousisLinkIssueModalOpen === true;
    const updateRef = (element)=>{
        openTriggerRef.current = element;
    };
    (0, $5uXOq.useEffect)(()=>{
        if (isIssueLinkStatsClosed || isIssueLinkModalClosed) openTriggerRef.current?.focus();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        isIssueLinkStatsOpen,
        isLinkIssueModalOpen
    ]);
    return updateRef;
};

});

parcelRegister("cIlUQ", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsErrorFallback", () => $98a00069e80b8f40$export$5489cdf86d4767fd);

var $5uXOq = parcelRequire("5uXOq");

var $fZneA = parcelRequire("fZneA");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jDj3c = parcelRequire("jDj3c");
const $98a00069e80b8f40$export$5489cdf86d4767fd = ({ callback: callback, testId: testId, error: error })=>{
    callback && callback();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    showFlag({
        id: 'async-issue-links-details-entrypoint-flag',
        type: 'error',
        testId: testId,
        title: formatMessage((0, $jDj3c.messages).issueLinksDetailsErrorFlagTitle),
        description: formatMessage((0, $jDj3c.messages).issueLinksDetailsErrorFlagDescription),
        isAutoDismiss: true,
        messageId: 'issue-links-stats.ui.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-details-error-fallback.show-flag.error',
        messageType: 'transactional'
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
        task: 'viewIssueLinksDetailsPopup',
        isClientFetchError: (0, $fZneA.isClientFetchError)(error)
    });
    // need to return an empty fragment as entrypoint fallback prop only accept ((props: { error: Error }) => ReactElement);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};

});
parcelRegister("jDj3c", function(module, exports) {

$parcel$export(module.exports, "messages", () => $299799d049ecd2fb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $299799d049ecd2fb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueLinksDetailsErrorFlagTitle: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-details-error-fallback.issue-links-details-error-flag-title",
        "defaultMessage": "We couldn't load your data"
    },
    issueLinksDetailsErrorFlagDescription: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-details-error-fallback.issue-links-details-error-flag-description",
        "defaultMessage": "Refresh the page and try again"
    }
});

});


parcelRegister("7O6AD", function(module, exports) {

$parcel$export(module.exports, "IssueLinksDetailsPopupSkeleton", () => $a2d3165178d11613$export$c2d4e4e846447365);

var $5uXOq = parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $a2d3165178d11613$export$c2d4e4e846447365 = ({ testId: testId, smallerWidth: smallerWidth, noPadding: noPadding = false })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: testId,
        xcss: smallerWidth ? $a2d3165178d11613$var$smallerWidthStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        inline: noPadding ? 'space.200' : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "60%"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "100%",
        hasIcon: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
        width: "100%",
        hasIcon: true
    })));
const $a2d3165178d11613$var$smallerWidthStyles = (0, $8CUq3.xcss)({
    width: '80%'
});

});

parcelRegister("9RuF6", function(module, exports) {

$parcel$export(module.exports, "LinkIssuePopup", () => $d8217e7ea6ae19a8$export$2d260c101478261e);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $HeOPt = parcelRequire("HeOPt");

var $1uBR4 = parcelRequire("1uBR4");

var $koeKL = parcelRequire("koeKL");
const $d8217e7ea6ae19a8$export$2d260c101478261e = ({ onSuccessfulIssueLink: onSuccessfulIssueLink })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [state, { setIssueLinkModalEntryPointSubject: setIssueLinkModalEntryPointSubject }] = (0, $HeOPt.useIssueLinkedModalEntrypointStore)();
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $1uBR4.linkIssuePopupEntryPoint), {
        cloudId: cloudId
    });
    const handleClose = ()=>{
        setIssueLinkModalEntryPointSubject({
            issueData: null
        });
        entryPointActions.unload();
    };
    const handleSuccessfulIssueLink = ()=>{
        if (onSuccessfulIssueLink && state.issueData) onSuccessfulIssueLink(Number(state.issueData.issueId));
        handleClose();
    };
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (state.issueData) entryPointActions.load();
    }, [
        entryPointActions,
        state.issueData
    ]);
    if (!state.issueData || !state.issueData.issueId || !state.issueData.issueKey) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "businessLinkIssuePopupEntryPoint",
        packageName: "@atlassian/jira-link-issue-popup",
        teamName: "jira-werewolves" // TODO ownership will be changed after warranty period https://jbusiness.atlassian.net/browse/JSWMOON-936
        ,
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: {
            issueId: state.issueData.issueId,
            issueKey: state.issueData.issueKey,
            onSuccessfulIssueLink: handleSuccessfulIssueLink,
            onClose: handleClose,
            trackOriginSource: 'JWM'
        }
    });
};

});
parcelRegister("1uBR4", function(module, exports) {

$parcel$export(module.exports, "linkIssuePopupEntryPoint", () => $54106a41849af366$export$537a4e334f2de676);

var $XczyX = parcelRequire("XczyX");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $54106a41849af366$export$537a4e334f2de676 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2RkTo")), {
        moduleId: "e0e327f9"
    }),
    getPreloadProps: ({ cloudId: cloudId })=>({
            queries: {
                issueLinksTypes: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $XczyX.default,
                    variables: {
                        cloudId: cloudId
                    }
                }
            }
        })
});

});
parcelRegister("XczyX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b447dfe339c10fb6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<2f031d559b6b4aa1484052708468df2c>>
 * @relayHash ef080d6ba522722031ef94e4887d4972
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b
const $b447dfe339c10fb6$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    }, v3 = {
        "kind": "ScalarField",
        "name": "inwards"
    }, v4 = {
        "kind": "ScalarField",
        "name": "outwards"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v2 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.inwards"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v4 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "jira.issueLinkTypes.edges.node.outwards"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "mainAsyncIssueLinksTypesQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssueLinkTypeConnection",
                            "kind": "LinkedField",
                            "name": "issueLinkTypes",
                            "plural": false,
                            "selections": [
                                {
                                    "concreteType": "JiraIssueLinkTypeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueLinkType",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                                v2 /*: any*/ ,
                                                v3 /*: any*/ ,
                                                v4 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "34d278c2e16727746e37236ed6b6c53c028ecbb07c23708312783363197eb20b",
            "metadata": {},
            "name": "mainAsyncIssueLinksTypesQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$b447dfe339c10fb6$var$node.hash = "ad0bf63495377e340f30a9f1531b3f3c";
var $b447dfe339c10fb6$export$2e2bcd8739ae039 = $b447dfe339c10fb6$var$node;

});

parcelRegister("2RkTo", function(module, exports) {

let $2150bcd5c4e36c27$var$load = (parcelRequire("28QjX"))(4);
module.exports = $2150bcd5c4e36c27$var$load("4awiX").then(()=>parcelRequire('fSK3M'));

});



parcelRegister("adSHj", function(module, exports) {

$parcel$export(module.exports, "messages", () => $551007571af18f3a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $551007571af18f3a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueLinksButton: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-button",
        "defaultMessage": "{issueLinkCount} linked {issueLinkCount, plural, one {issue} other {issues}}"
    },
    issueLinksPopup: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-popup",
        "defaultMessage": "Linked issues pop up"
    },
    issueLinksButtonIssueTermRefresh: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-button-issue-term-refresh",
        "defaultMessage": "{issueLinkCount} linked {issueLinkCount, plural, one {work item} other {work items}}"
    },
    issueLinksPopupIssueTermRefresh: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-details-popup-entrypoint-container.issue-links-popup-issue-term-refresh",
        "defaultMessage": "Linked work items pop up"
    }
});

});


parcelRegister("5BMYo", function(module, exports) {

$parcel$export(module.exports, "messages", () => $92902d3d42d277dc$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $92902d3d42d277dc$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueLinksTooltipLabel: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-tooltip-label",
        "defaultMessage": "{issueLinkCount} linked {issueLinkCount, plural, one {issue} other {issues}}"
    },
    genericMaxIssueLinksStatsTooltipLabel: {
        "id": "issue-links-stats.issue-links-stats-button.generic-max-issue-links-stats-tooltip-label",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked issues"
    },
    issueLinksTooltipLabelIssueTermRefresh: {
        "id": "issue-links-stats.issue-links-stats-button.issue-links-tooltip-label-issue-term-refresh",
        "defaultMessage": "{issueLinkCount} linked {issueLinkCount, plural, one {work item} other {work items}}"
    },
    genericMaxIssueLinksStatsTooltipLabelIssueTermRefresh: {
        "id": "issue-links-stats.issue-links-stats-button.generic-max-issue-links-stats-tooltip-label-issue-term-refresh",
        "defaultMessage": "{maxIssueLinksStatsCount}+ linked work items"
    }
});

});




parcelRegister("5tA4K", function(module, exports) {

$parcel$export(module.exports, "getIsLoadingIssueLinksStatsForCard", () => $6dd795e7304f69ea$export$4af29e5efa918449);
$parcel$export(module.exports, "getIssueLinksStatsForCard", () => $6dd795e7304f69ea$export$773558ed63cf8de4);

var $dGvGJ = parcelRequire("dGvGJ");

var $67Z81 = parcelRequire("67Z81");
const $6dd795e7304f69ea$export$cbea1814e60866f1 = (state)=>(0, $67Z81.getEntities)(state).issueLinksStats;
const $6dd795e7304f69ea$export$4af29e5efa918449 = (0, $dGvGJ.createSelector)([
    $6dd795e7304f69ea$export$cbea1814e60866f1
], (linkedIssuesStats)=>(cardId)=>linkedIssuesStats?.loadingStatisticsItems?.includes(cardId) || linkedIssuesStats?.loadingStatisticsItems?.includes(Number(cardId)));
const $6dd795e7304f69ea$export$773558ed63cf8de4 = (0, $dGvGJ.createSelector)([
    $6dd795e7304f69ea$export$cbea1814e60866f1
], (linkedIssuesStats)=>(cardId)=>{
        const issueStats = linkedIssuesStats?.statisticItems[cardId];
        let issueLinkCountSum = 0;
        issueStats?.forEach((issueStat)=>{
            issueLinkCountSum += issueStat.issueLinkCount;
        });
        return issueLinkCountSum;
    });

});


parcelRegister("hnyd8", function(module, exports) {

$parcel$export(module.exports, "IssueParentField", () => $8b77fb21fa3f5c5c$export$f323718a039167f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $krmH9 = parcelRequire("krmH9");

var $7XluA = parcelRequire("7XluA");

var $54wEF = parcelRequire("54wEF");

var $3fAi8 = parcelRequire("3fAi8");

var $7Fute = parcelRequire("7Fute");

var $jRmmq = parcelRequire("jRmmq");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $l8ruj = parcelRequire("l8ruj");

var $4R6GH = parcelRequire("4R6GH");

var $acAaD = parcelRequire("acAaD");

var $eGVUJ = parcelRequire("eGVUJ");


var $evkwq = parcelRequire("evkwq");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

var $2f454 = parcelRequire("2f454");

const $8b77fb21fa3f5c5c$var$onParentFieldWrapperClick = (e)=>e.stopPropagation();
// Prevent enter from opening issue view
const $8b77fb21fa3f5c5c$var$stopEnterPropagation = (e)=>{
    if (e.key === 'Enter') e.stopPropagation();
};
const $8b77fb21fa3f5c5c$var$TooltipTag = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b77fb21fa3f5c5c$var$TooltipWrapper, {
        ref: ref,
        ...props
    }));
const $8b77fb21fa3f5c5c$var$fieldKey = 'parent';
const $8b77fb21fa3f5c5c$var$IssueParentFieldInner = ({ issueId: issueId, issueKey: issueKey, currentProjectId: currentProjectId, projectIds: projectIds, issueParents: issueParents = [], isCompanyManaged: isCompanyManaged, parentSummary: parentSummary, onUpdate: onSuccess, onSubmit: onSubmit, onFailure: onFailure, workType: workType })=>{
    const parentFieldWrapperRef = (0, $5uXOq.useRef)(null);
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const transformedEpics = (0, $5uXOq.useMemo)(()=>issueParents ? issueParents.map((issueParent)=>({
                ...(0, $7Fute.transformToEpic)({
                    ...issueParent,
                    id: (0, $g5X3G.toIssueId)(String(issueParent.id))
                }),
                id: (0, $g5X3G.toIssueId)(String(issueParent.id))
            })) : [], [
        issueParents
    ]);
    // It makes sure the tooltip showing on mouse over the trigger button, not mouse over dropdown items
    const handleMouseOver = (e)=>{
        const { relatedTarget: relatedTarget } = e;
        if (parentFieldWrapperRef.current && relatedTarget instanceof Node && !relatedTarget.contains(parentFieldWrapperRef.current)) e.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $8b77fb21fa3f5c5c$var$fieldKey,
            fieldType: 'parent'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: parentSummary,
        tag: $8b77fb21fa3f5c5c$var$TooltipTag
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b77fb21fa3f5c5c$var$ParentFieldWrapper, {
        onClick: $8b77fb21fa3f5c5c$var$onParentFieldWrapperClick,
        onKeyDown: $8b77fb21fa3f5c5c$var$stopEnterPropagation,
        "data-testid": (0, $88c2d7648915eff7$export$83f1b0bcb0c1b3f8),
        disableClick: preventInlineEditing,
        onMouseOver: handleMouseOver,
        ref: parentFieldWrapperRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRmmq.AsyncLazyParentSwitcherField), {
        "data-testid": (0, $88c2d7648915eff7$export$dad6f927cf282b27),
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        issueId: (0, $g5X3G.toIssueId)(String(issueId)),
        epics: transformedEpics,
        /* We cannot get permission when no issue view is opened by using the useProjectPermission hook in @atlassian/jira-project-permissions-service
         * So we have to pass canUserEditIssue from the backlog to the extracted epic field to force it to be editable
         * */ forceEditable: true,
        /** Same reason as above, we need the projectId in order to
         *  open the issue parent switcher modal */ // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        currentProjectId: currentProjectId,
        projectIds: projectIds,
        isSimplifiedProject: !isCompanyManaged,
        shouldHideIfNoParent: true,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        maxWidth: "100%",
        workType: workType
    }))));
};
const $8b77fb21fa3f5c5c$var$ProgramBoardIssueParentFieldInner = ({ uniqueKey: uniqueKey, issueId: issueId, issueParents: issueParents = [], onUpdate: onSuccess, onSubmit: onSubmit, onFailure: onFailure, fallback: fallback })=>{
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $5uXOq.useContext)((0, $krmH9.ProgramBoardParentSwitcherEntrypointContext));
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('render_program_board_card_in_popup')) dispatch((0, $2f454.setInlineEditing)('parentField', issueId, true));
    }, [
        dispatch,
        issueId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        if ((0, $4R6GH.fg)('render_program_board_card_in_popup')) dispatch((0, $2f454.setInlineEditing)('parentField', issueId, false));
    }, [
        dispatch,
        issueId
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            issueKey: uniqueKey,
            issueParents: issueParents,
            onSubmit: onSubmit,
            onSuccess: onSuccess,
            onFailure: onFailure,
            onOpen: onOpen,
            onClose: onClose,
            fallback: fallback,
            preventInlineEditing: preventInlineEditing,
            onSaveField: async (_, fieldId, fieldValue)=>{
                dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
                    issueId: issueId,
                    fieldId: fieldId,
                    fieldValue: fieldValue ? fieldValue.id : null
                }));
            }
        }), [
        dispatch,
        fallback,
        issueId,
        uniqueKey,
        issueParents,
        onFailure,
        onSubmit,
        onSuccess,
        onOpen,
        onClose,
        preventInlineEditing
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: 'parent',
            fieldType: 'parent',
            origin: 'issueCard'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "program-board-parent-switcher",
        packageName: "jiraSoftwareBoard",
        runtimeProps: runtimeProps,
        fallback: fallback
    }));
};
const $8b77fb21fa3f5c5c$export$f323718a039167f = ({ shouldRenderRichField: shouldRenderRichField, isIncrementPlanningBoard: isIncrementPlanningBoard, ...props })=>{
    const uniqueKey = isIncrementPlanningBoard && props.issueKey === props.projectKey ? `${props.issueId}` : props.issueKey;
    const [issueParentFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: uniqueKey,
        fieldKey: (0, $5fc53.PARENT_TYPE)
    });
    const [{ value: parentFieldConfig }] = (0, $54wEF.useFieldConfigWithoutRefetch)(uniqueKey, (0, $5fc53.PARENT_TYPE));
    const shouldRenderRich = Boolean(shouldRenderRichField && props.currentProjectId && props.projectIds?.length && props?.issueParents?.length && issueParentFieldValue && parentFieldConfig && // on the increment planning board, we render the rich field only if the hierarchy level of issue is story
    issueParentFieldValue.id !== props.issueId);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $acAaD.IssueParentFieldStatic), {
            color: props.parentColor,
            summary: props.parentSummary,
            maxWidth: "100%"
        }), [
        props.parentColor,
        props.parentSummary
    ]);
    if (shouldRenderRich) {
        if (!isIncrementPlanningBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jRmmq.ParentSwitcherBoundary), {
            packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
            fallback: fallback,
            onError: editableField.onError
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "ng-board.inline-edit.parent-field"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b77fb21fa3f5c5c$var$IssueParentFieldInner, {
            ...props,
            ...editableField
        })));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8b77fb21fa3f5c5c$var$ProgramBoardIssueParentFieldInner, {
            ...props,
            fallback: fallback,
            ...editableField,
            uniqueKey: uniqueKey
        });
    }
    return fallback;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8b77fb21fa3f5c5c$var$ParentFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { disableClick: disableClick, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _4cvr1h6o _kqswh2mm _80om73ad _1gp47079 _bz011wje _smb41h90 _ef5q1wng _686xagmp _1di411wp",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $8b77fb21fa3f5c5c$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jRmmq", function(module, exports) {

$parcel$export(module.exports, "ParentSwitcherBoundary", () => $363a63430d7d18c1$export$5fd31a263aabeb24);
$parcel$export(module.exports, "AsyncLazyParentSwitcherField", () => $363a63430d7d18c1$export$690bf5ebb9d6daf8);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
const $363a63430d7d18c1$export$5fd31a263aabeb24 = ({ children: children, fallback: fallback, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "issue-parent-switcher",
        packageName: packageName,
        fallback: fallback ? ()=>fallback : undefined,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-parent-switcher-boundary",
        fallback: fallback
    }, children));

const $363a63430d7d18c1$export$690bf5ebb9d6daf8 = (0, $kxZPA.lazy)(()=>(parcelRequire("14G2D")).then(({ ParentSwitcherField: ParentSwitcherField })=>ParentSwitcherField), {
    moduleId: "./src/packages/issue/fields/parent-switcher/src/ui/main.tsx"
});

});
parcelRegister("14G2D", function(module, exports) {

let $0c86c6b8281cd8a0$var$load = (parcelRequire("28QjX"))(4);
module.exports = $0c86c6b8281cd8a0$var$load("7jnHK").then(()=>parcelRequire('1vozy'));

});


const $88c2d7648915eff7$export$dad6f927cf282b27 = 'software-board.board-container.board.card-container.card.issue-parent-field.parent-field-lazy';
const $88c2d7648915eff7$export$83f1b0bcb0c1b3f8 = 'software-board.board-container.board.card-container.card.issue-parent-field.parent-field-wrapper';


parcelRegister("fBeRa", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateField", () => $098b9bc6f7bd64cc$export$7a49800f92da6ebc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $cSD7y = parcelRequire("cSD7y");

var $54wEF = parcelRequire("54wEF");

var $gRk25 = parcelRequire("gRk25");

var $dKhOa = parcelRequire("dKhOa");

var $iXVV6 = parcelRequire("iXVV6");


var $g5X3G = parcelRequire("g5X3G");

var $l8ruj = parcelRequire("l8ruj");

var $3l5XM = parcelRequire("3l5XM");

var $oOIFP = parcelRequire("oOIFP");

var $eGVUJ = parcelRequire("eGVUJ");

var $6HPvp = parcelRequire("6HPvp");

var $6wLTf = parcelRequire("6wLTf");


var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

const $098b9bc6f7bd64cc$var$stopPropagation = (e)=>e.stopPropagation();
const $098b9bc6f7bd64cc$var$fieldKey = 'timeoriginalestimate';
const $098b9bc6f7bd64cc$var$OriginalEstimateFieldInner = ({ issueId: issueId, issueKey: issueKey, timeTrackingOptions: timeTrackingOptions, estimate: estimate, onFailure: onFailure, ...props })=>{
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const { fireInvalidFieldConfigError: fireInvalidFieldConfigError } = (0, $6HPvp.useFireInvalidFieldConfigError)();
    const onFailureFireError = (0, $5uXOq.useCallback)((error)=>{
        onFailure?.();
        fireInvalidFieldConfigError(error);
    }, [
        fireInvalidFieldConfigError,
        onFailure
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $098b9bc6f7bd64cc$var$fieldKey,
            fieldType: $098b9bc6f7bd64cc$var$fieldKey
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($098b9bc6f7bd64cc$var$OriginalEstimateWrapper, {
        "data-testid": (0, $3adc81d2d12051cc$export$f74bfca982b53573),
        hasValue: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimate),
        onClick: $098b9bc6f7bd64cc$var$stopPropagation,
        onKeyDown: $098b9bc6f7bd64cc$var$stopPropagation,
        disableClick: preventInlineEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gRk25.AsyncOriginalEstimateInlineEdit), {
        ...props,
        actionSubject: "inlineEdit",
        isMobile: false,
        issueId: (0, $g5X3G.toIssueId)(String(issueId)),
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        config: (0, $6wLTf.timeTrackingConfigTransformer)(timeTrackingOptions),
        fieldId: (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2),
        isEditable: true,
        isFitContainerWidthReadView: true,
        placeholder: (0, $3adc81d2d12051cc$export$55fc5ffc49a23c34),
        onFailure: onFailureFireError,
        timeTrackingValue: {}
    })));
};
const $098b9bc6f7bd64cc$export$7a49800f92da6ebc = ({ shouldRenderRichField: shouldRenderRichField, ...props })=>{
    const [{ value: originalEstimateFieldConfig }] = (0, $54wEF.useFieldConfigWithoutRefetch)(props.issueKey, (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2));
    const shouldRenderRich = Boolean(shouldRenderRichField && originalEstimateFieldConfig);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = props.estimate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3l5XM.EstimateFieldStatic), {
        value: props.estimate
    }) : null;
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dKhOa.OriginalEstimateInlineEditErrorBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback,
        onError: editableField.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.original-estimate-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($098b9bc6f7bd64cc$var$OriginalEstimateFieldInner, {
        ...props,
        ...editableField
    })));
    return fallback;
};
// prevents warning for usage of style composition - can be removed when https://product-fabric.atlassian.net/browse/APP-728 is done.
const $098b9bc6f7bd64cc$var$CompiledPropsForwarder = ({ disableClick: disableClick, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oOIFP.EstimateWrapper), rest);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $098b9bc6f7bd64cc$var$OriginalEstimateWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $098b9bc6f7bd64cc$var$CompiledPropsForwarder, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xkuvov6 _gs1n11wp _1pme4jg8 _1bt6idpf _1bb7idpf _wv4jt94y _1nf9yh40 _11yukb7n",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $098b9bc6f7bd64cc$var$OriginalEstimateWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $098b9bc6f7bd64cc$var$CompiledPropsForwarder, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1xkuairk _gs1n11wp _1pme4jg8 _1bt6idpf _1bb7idpf _wv4jt94y _1nf9yh40 _11yukb7n",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});
const $098b9bc6f7bd64cc$var$OriginalEstimateWrapper = (0, $cSD7y.componentWithFG)('fix_jira_board_card_nested_interactive_elements', $098b9bc6f7bd64cc$var$OriginalEstimateWrapperNew, $098b9bc6f7bd64cc$var$OriginalEstimateWrapperOld);

});
parcelRegister("gRk25", function(module, exports) {

$parcel$export(module.exports, "AsyncOriginalEstimateInlineEdit", () => $d12b967f73a6d5cc$export$4953f72b4b129e16);

var $kxZPA = parcelRequire("kxZPA");

const $d12b967f73a6d5cc$export$4953f72b4b129e16 = (0, $kxZPA.lazy)(()=>(parcelRequire("eioMo")), {
    moduleId: "./src/packages/issue/fields/original-estimate-inline-edit/inline-edit/src/ui/main.tsx"
});

});
parcelRegister("eioMo", function(module, exports) {

let $02af94838348a51e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $02af94838348a51e$var$load("hU4gx").then(()=>parcelRequire('hVDSB'));

});


parcelRegister("dKhOa", function(module, exports) {

$parcel$export(module.exports, "OriginalEstimateInlineEditErrorBoundary", () => $93a64576a35980c3$export$466499b8671a900);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");
const $93a64576a35980c3$export$466499b8671a900 = ({ fallback: fallback, children: children, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "original-estimate-inline-edit",
        packageName: packageName,
        teamName: "bento",
        fallback: "flag",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "original-estimate-inline-edit-error-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("3l5XM", function(module, exports) {

$parcel$export(module.exports, "EstimateFieldStatic", () => $13b9f7a9ff5b1848$export$cc501740c0f7c27a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $16T6Y = parcelRequire("16T6Y");

var $koVbs = parcelRequire("koVbs");

var $akGDz = parcelRequire("akGDz");
const $13b9f7a9ff5b1848$export$cc501740c0f7c27a = ({ value: value })=>{
    const { formatNumber: formatNumber } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($13b9f7a9ff5b1848$var$EstimateWrapper, {
        "data-testid": "software-board.common.fields.estimate-field.static.estimate-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "default"
    }, typeof value === 'number' ? formatNumber(value) : value));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $13b9f7a9ff5b1848$var$EstimateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $akGDz.Container), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_u5f3yh40",
            __cmplp.className
        ])
    });
});

});

parcelRegister("oOIFP", function(module, exports) {

$parcel$export(module.exports, "EstimateWrapper", () => $05689b28e4022562$export$1405ff72a0128840);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cSD7y = parcelRequire("cSD7y");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $05689b28e4022562$var$EstimateWrapperOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1pxtutpp _1idistnw _gs1n11wp _13jz1txw _bssb1txw _1mhz1txw _1mi81txw",
            __cmplp.hasValue ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $05689b28e4022562$var$EstimateWrapperNew = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasValue: hasValue, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4cvr1h6o _1idistnw _gs1n11wp _13jz1txw _bssb1txw _1mhz1txw _1mi81txw",
            __cmplp.hasValue ? "_1e0c1txw" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $05689b28e4022562$export$1405ff72a0128840 = (0, $cSD7y.componentWithFG)('fix_jira_board_card_nested_interactive_elements', $05689b28e4022562$var$EstimateWrapperNew, $05689b28e4022562$var$EstimateWrapperOld);

});

parcelRegister("6HPvp", function(module, exports) {

$parcel$export(module.exports, "useFireInvalidFieldConfigError", () => $795e126280e0f257$export$eb4917cb48fa47a4);

var $5uXOq = parcelRequire("5uXOq");

var $jJZqs = parcelRequire("jJZqs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
function $795e126280e0f257$export$eb4917cb48fa47a4() {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireInvalidFieldConfigError = (0, $5uXOq.useCallback)((error)=>{
        if (error instanceof (0, $jJZqs.ValidationError)) {
            const removedEstimateError = error?.errors?.find((err)=>err?.error?.includes('It is not on the appropriate screen, or unknown.'));
            if (removedEstimateError) (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'estimateField updateFailed', {
                field: removedEstimateError?.field,
                error: removedEstimateError?.error,
                isIncorrectFieldConfig: true
            });
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireInvalidFieldConfigError: fireInvalidFieldConfigError
    };
}

});

parcelRegister("6wLTf", function(module, exports) {

$parcel$export(module.exports, "timeTrackingConfigTransformer", () => $93f9193f326154c7$export$5507631896590474);
const $93f9193f326154c7$export$5507631896590474 = ({ workingHoursPerDay: workingHoursPerDay, workingDaysPerWeek: workingDaysPerWeek, defaultUnit: defaultUnit, timeFormat: timeFormat })=>({
        isTimeTrackingEnabled: true,
        daysPerWeek: workingDaysPerWeek,
        hoursPerDay: workingHoursPerDay,
        defaultUnit: defaultUnit,
        format: timeFormat
    });

});

const $3adc81d2d12051cc$export$f74bfca982b53573 = 'software-board.board-container.board.card-container.card.original-estimate-field.wrapper';
const $3adc81d2d12051cc$export$55fc5ffc49a23c34 = '2w 4d 6h 45m';
const $3adc81d2d12051cc$export$9309e44d5544ea64 = 'software-board.common.fields.estimate-field.static.estimate-wrapper';


parcelRegister("POab5", function(module, exports) {

$parcel$export(module.exports, "PriorityField", () => $b8d8939508996ee1$export$f1adf0a84590c483);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $54wEF = parcelRequire("54wEF");

var $hTfH8 = parcelRequire("hTfH8");

var $lfTZh = parcelRequire("lfTZh");

var $5fc53 = parcelRequire("5fc53");

var $iXVV6 = parcelRequire("iXVV6");

var $l8ruj = parcelRequire("l8ruj");

var $kxZPA = parcelRequire("kxZPA");

var $bdYfL = parcelRequire("bdYfL");

var $4R6GH = parcelRequire("4R6GH");

var $gQiWN = parcelRequire("gQiWN");

var $eGVUJ = parcelRequire("eGVUJ");


var $2f454 = parcelRequire("2f454");

var $evkwq = parcelRequire("evkwq");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

var $3EsnH = parcelRequire("3EsnH");


const $b8d8939508996ee1$export$dbf159d6b5b6b5ad = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("aVYod")).then(({ PriorityChipField: PriorityChipField })=>PriorityChipField), {
    moduleId: "./src/packages/issue/fields/priority-chip/src/index.tsx"
});
const $b8d8939508996ee1$var$stopClickPropagation = (e)=>{
    e.stopPropagation();
};
const $b8d8939508996ee1$var$fieldKey = 'priority';
const $b8d8939508996ee1$var$PriorityFieldInner = ({ issueKey: issueKey, priority: priority, onSaveField: onSaveField, projectId: projectId, onOpen: onOpen, onClose: onClose })=>{
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const priorityOptions = (0, $67sX6.useBoardSelector)((0, $3EsnH.getPrioritiesByProjectId))(`${projectId ?? ''}`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $b8d8939508996ee1$var$fieldKey,
            fieldType: 'priority',
            origin: 'issueCard'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8d8939508996ee1$var$PriorityFieldWrapper, {
        onClick: $b8d8939508996ee1$var$stopClickPropagation,
        onKeyDown: $b8d8939508996ee1$var$stopClickPropagation,
        testId: (0, $81997b04041bdb56$export$f304fb066edfa067),
        disableClick: preventInlineEditing
    }, !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(priority?.id) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8d8939508996ee1$export$dbf159d6b5b6b5ad, {
        issueKey: issueKey,
        onSaveField: onSaveField,
        externalPriorityOptions: priorityOptions,
        skipRefreshFieldConfig: true // @ts-expect-error-only in the IP board, the priority has the id prop, the initialValue is compatible
        ,
        initialValue: priority,
        ...(0, $4R6GH.fg)('render_program_board_card_in_popup') ? {
            onMenuOpen: onOpen,
            onMenuClose: onClose
        } : {}
    })));
};
const $b8d8939508996ee1$export$f1adf0a84590c483 = ({ shouldRenderRichField: shouldRenderRichField, priority: priority, issueKey: issueKey, ...props })=>{
    const [{ value: priorityFieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $5fc53.PRIORITY_TYPE), {
        skipRefresh: true
    });
    const shouldRenderRich = Boolean(shouldRenderRichField && priorityFieldConfig) || (0, $bdYfL.isScenarioIssue)(`${props.issueId}`);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gQiWN.PriorityFieldStatic), {
            name: priority.name,
            iconUrl: priority.iconUrl
        }), [
        priority
    ]);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('priority', props.issueId, true));
    }, [
        dispatch,
        props.issueId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('priority', props.issueId, false));
    }, [
        dispatch,
        props.issueId
    ]);
    const onSaveField = (0, $5uXOq.useCallback)(async (_, fieldId, fieldValue)=>{
        dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
            issueId: props.issueId,
            fieldId: fieldId,
            fieldValue: fieldValue?.id
        }));
    }, [
        dispatch,
        props.issueId
    ]);
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTfH8.PriorityChipFieldBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.priority-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "priority-field-inner",
        fallback: fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8d8939508996ee1$var$PriorityFieldInner, {
        ...props,
        ...editableField,
        issueKey: issueKey,
        onOpen: onOpen,
        onClose: onClose,
        priority: priority,
        onSaveField: onSaveField
    }))));
    return fallback;
};
const $b8d8939508996ee1$var$PriorityFieldWrapper = ({ disableClick: disableClick, onClick: onClick, onKeyDown: onKeyDown, testId: testId, children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        onClick: onClick,
        onKeyDown: onKeyDown,
        className: (0, $bwpsq.default)([
            "_80omtlke _1gp47079 _1di411wp",
            disableClick && "_lcxvglyw"
        ])
    }, children);
};
const $b8d8939508996ee1$var$priorityFieldWrapperStyles = null;
const $b8d8939508996ee1$var$priorityFieldWrapperDisableClickStyles = null;

});
parcelRegister("hTfH8", function(module, exports) {

$parcel$export(module.exports, "PriorityChipFieldBoundary", () => $c88604a3dedf5694$export$9d18c32154d1536);
$parcel$export(module.exports, "AsyncLazyPriorityChipField", () => $c88604a3dedf5694$export$104c599231a6d317);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");
const $c88604a3dedf5694$export$9d18c32154d1536 = ({ children: children, fallback: fallback, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue-priority-chip",
        packageName: packageName,
        render: ()=>fallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-priority-chip-boundary",
        fallback: fallback
    }, children));

const $c88604a3dedf5694$export$104c599231a6d317 = (0, $kxZPA.lazy)(()=>(parcelRequire("jqtGq")).then(({ PriorityChipField: PriorityChipField })=>PriorityChipField), {
    moduleId: "./src/packages/issue/fields/priority-chip/src/ui/main.tsx"
});

});
parcelRegister("jqtGq", function(module, exports) {

let $e247787c30f8e4e3$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e247787c30f8e4e3$var$load("9l0DZ").then(()=>parcelRequire('72HZ8'));

});


parcelRegister("gQiWN", function(module, exports) {

$parcel$export(module.exports, "PriorityFieldStatic", () => $60817fe88bf311b2$export$2ccb5d74629a741d);

var $5uXOq = parcelRequire("5uXOq");

var $7Y70r = parcelRequire("7Y70r");
const $60817fe88bf311b2$export$2ccb5d74629a741d = ({ name: name, iconUrl: iconUrl })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "software-board.common.fields.priority-field-static.wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Y70r.PriorityChipRead), {
        name: name,
        iconUrl: iconUrl
    }));
};
var $60817fe88bf311b2$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($60817fe88bf311b2$export$2ccb5d74629a741d);

});
parcelRegister("7Y70r", function(module, exports) {

$parcel$export(module.exports, "PriorityChipRead", () => $cdcd5a4499ede0a2$export$92ecdadfd000de84);

var $5uXOq = parcelRequire("5uXOq");

var $1tQVG = parcelRequire("1tQVG");
const $cdcd5a4499ede0a2$export$92ecdadfd000de84 = ({ name: name, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1tQVG.PriorityIcon), {
        name: name,
        iconUrl: iconUrl
    });

});
parcelRegister("1tQVG", function(module, exports) {

$parcel$export(module.exports, "PriorityIcon", () => $6684e89be4f617c8$export$3abf8cb3bcb0225);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $a5ldi = parcelRequire("a5ldi");
const $6684e89be4f617c8$export$3abf8cb3bcb0225 = ({ name: name, iconUrl: iconUrl })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    let priorityName = name;
    if ((0, $4R6GH.fg)('sea-2830-improve-accessibility-of-priority-field')) priorityName = formatMessage((0, $a5ldi.default).priorityTooltip, {
        name: name
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: priorityName,
        testId: "issue-field-priority-chip.common.ui.priority-icon.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6684e89be4f617c8$export$be58b4326e23250f, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6684e89be4f617c8$export$f04a61298a47a40f, {
        alt: priorityName,
        src: iconUrl
    })));
};
const $6684e89be4f617c8$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _1e0c1txw _1bah1h6o _4t3i1tcg _1bsb1tcg",
            __cmplp.className
        ])
    });
});
const $6684e89be4f617c8$export$f04a61298a47a40f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3if6fq _1bsbf6fq _s7n41ndm",
            __cmplp.className
        ])
    });
});

});
parcelRegister("a5ldi", function(module, exports) {

$parcel$export(module.exports, "default", () => $d7d1a749f620728b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d7d1a749f620728b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    priorityTooltip: {
        "id": "issue-field-priority-chip.common.priority-icon.priority-tooltip",
        "defaultMessage": "Priority: {name}"
    }
});

});




const $81997b04041bdb56$export$f304fb066edfa067 = 'software-board.board-container.board.card-container.card.priority-field.button';

parcelRegister("aVYod", function(module, exports) {

let $7f5e125d3f043e3d$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7f5e125d3f043e3d$var$load("fT1qw").then(()=>parcelRequire('h16RV'));

});


parcelRegister("9uH2Z", function(module, exports) {

$parcel$export(module.exports, "IssueStatusField", () => $b18973b83512d5dc$export$58bec2551a247e1d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $fQeLt = parcelRequire("fQeLt");

var $jobBe = parcelRequire("jobBe");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bdYfL = parcelRequire("bdYfL");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $67sX6 = parcelRequire("67sX6");

var $2f454 = parcelRequire("2f454");

var $bkAe8 = parcelRequire("bkAe8");
const $b18973b83512d5dc$var$stopPropagation = (e)=>e.stopPropagation();
const $b18973b83512d5dc$export$58bec2551a247e1d = ({ issue: issue, issueStatuses: issueStatuses, onChange: onChange, isReadOnly: isReadOnly })=>{
    const statusFieldWrapperRef = (0, $5uXOq.useRef)(null);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleChange = (0, $5uXOq.useCallback)((transition)=>{
        const isDone = (0, $bkAe8.isIssueStatusDone)(transition.to.statusCategory.id);
        onChange(String(issue.id), transition, isDone);
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issue updated', {
            isDone: isDone,
            isInlineEditing: true,
            fieldKey: 'status',
            fieldType: 'status',
            origin: 'issueCard'
        });
    }, [
        onChange,
        issue.id,
        createAnalyticsEvent
    ]);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onOpen = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('status', issue.id, true));
    }, [
        dispatch,
        issue.id
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('status', issue.id, false));
    }, [
        dispatch,
        issue.id
    ]);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.statusId) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issueStatuses[issue.statusId]) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue.projectId)) {
        const status = issueStatuses[issue.statusId];
        if (!status) return null;
        const value = {
            id: status.id.toString(),
            name: status.name,
            statusCategory: {
                id: status.categoryId
            }
        };
        const normalizedIssue = {
            id: String(issue.id),
            type: Number(issue.typeId),
            key: issue.key,
            projectId: issue.projectId,
            statusId: String(issue.statusId),
            originalStatusId: (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(issue?.originals?.statusId) ? undefined : `${issue?.originals?.statusId}`
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            attributes: {
                isInlineEditing: true,
                fieldKey: 'status',
                fieldType: 'status'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_i0dl1osq _1e0c1txw"
            ])
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            onClick: $b18973b83512d5dc$var$stopPropagation,
            onKeyDown: $b18973b83512d5dc$var$stopPropagation,
            ref: statusFieldWrapperRef,
            xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $b18973b83512d5dc$var$statusFieldWrapperStyles : $b18973b83512d5dc$var$statusFieldWrapperStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: status.name
        }, (0, $bdYfL.isScenarioIssue)(String(issue.id)) || isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fQeLt.StatusLozenge), {
            value: value
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jobBe.default), {
            issue: normalizedIssue,
            issueKey: issue.key,
            value: value,
            onChange: handleChange,
            projectId: issue.projectId,
            issueStatuses: issueStatuses,
            ...(0, $4R6GH.fg)('render_program_board_card_in_popup') ? {
                onOpen: onOpen,
                onClose: onClose
            } : {}
        }))));
    }
    return null;
};
const $b18973b83512d5dc$var$divStyles = null;
const $b18973b83512d5dc$var$statusFieldWrapperStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: `${"var(--ds-space-200, 16px)"}`,
    width: 'auto',
    alignSelf: 'flex-start',
    marginTop: 'space.negative.100',
    maxWidth: '100%'
});
const $b18973b83512d5dc$var$statusFieldWrapperStylesOld = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: `${"var(--ds-space-200, 16px)"}`,
    width: 'auto',
    alignSelf: 'flex-start',
    marginTop: 'space.negative.100'
});
var $b18973b83512d5dc$export$2e2bcd8739ae039 = $b18973b83512d5dc$export$58bec2551a247e1d;

});
parcelRegister("jobBe", function(module, exports) {

$parcel$export(module.exports, "default", () => $28848bfff17bed6a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gwIPs = parcelRequire("gwIPs");

var $7Xmbv = parcelRequire("7Xmbv");

var $hmK1M = parcelRequire("hmK1M");

var $an47R = parcelRequire("an47R");

var $7CMCs = parcelRequire("7CMCs");

var $2brZf = parcelRequire("2brZf");

var $lUJY8 = parcelRequire("lUJY8");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");


var $dPDEg = parcelRequire("dPDEg");
const $28848bfff17bed6a$export$28769ce7cf4b59f9 = ({ issue: issue, onChange: onChange, issueKey: issueKey, value: value, projectId: projectId, transitions: transitions, loading: loading, fetchTransitions: fetchTransitions, isMenuDefaultOpen: isMenuDefaultOpen, onOpen: onOpen, onClose: onClose })=>{
    const [isWorkflowModalOpen, setIsWorkflowModalOpen] = (0, $5uXOq.useState)(false);
    const [isWorkflowModalMounted, setIsWorkflowModalMounted] = (0, $5uXOq.useState)(false);
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const handleChange = (0, $5uXOq.useCallback)((transition)=>{
        onChange(transition);
    }, [
        onChange
    ]);
    const onOpenModal = (0, $5uXOq.useCallback)(()=>{
        setIsWorkflowModalOpen(true);
    }, []);
    const onCloseModal = (0, $5uXOq.useCallback)(()=>{
        setIsWorkflowModalOpen(false);
    }, []);
    const onModalMounted = (0, $5uXOq.useCallback)(()=>{
        setIsWorkflowModalMounted(true);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-plan.issue-status",
        packageName: (0, $c1b3dec1183ab43c$export$b8b9d90f9e5bd72b),
        teamName: (0, $c1b3dec1183ab43c$export$cfeee2ee86ead336),
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Xmbv.default), {
        baseUrl: tenantContext.baseUrl,
        issueKey: issueKey
    }, (workflowServiceApi)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hmK1M.default), {
            appearance: "lozenge",
            ...isMenuDefaultOpen === true ? {
                defaultOpen: true
            } : {},
            value: value,
            transitions: transitions,
            onChange: handleChange,
            isLoading: loading,
            onOpen: ()=>{
                fetchTransitions();
                const hasFetchedWorkflowService = workflowServiceApi.data && workflowServiceApi.data.hasPermission !== undefined;
                if (!hasFetchedWorkflowService) workflowServiceApi.fetch();
                if (onOpen && (0, $4R6GH.fg)('render_program_board_card_in_popup')) onOpen();
            },
            onClose: ()=>{
                if (onClose && (0, $4R6GH.fg)('render_program_board_card_in_popup')) onClose();
            },
            footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $an47R.default), {
                baseUrl: tenantContext.baseUrl,
                issueKey: issueKey,
                workflowServiceApi: workflowServiceApi,
                onOpenModal: onOpenModal,
                isModalMounted: isWorkflowModalMounted
            }),
            popperProps: {
                strategy: 'absolute',
                modifiers: [
                    {
                        name: 'zIndex',
                        enabled: true,
                        phase: 'write',
                        fn: ({ state: state })=>{
                            // eslint-disable-next-line no-param-reassign
                            state.styles.popper.zIndex = `${(0, $gwIPs.layers).modal - 1}`;
                        }
                    }
                ]
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2brZf.default), {
            onModalMounted: onModalMounted,
            issueKey: issueKey,
            issueTypeId: `${issue.type}`,
            baseUrl: tenantContext.baseUrl,
            locale: tenantContext.locale,
            cloudId: tenantContext.cloudId,
            projectId: `${projectId}`,
            isOpen: isWorkflowModalOpen,
            onClose: onCloseModal,
            scope: workflowServiceApi.data?.isSimplified === true ? (0, $lUJY8.SCOPE_PROJECT) : (0, $lUJY8.SCOPE_GLOBAL)
        }))));
};
var $28848bfff17bed6a$export$2e2bcd8739ae039 = (0, $dPDEg.transitionsProvider)($28848bfff17bed6a$export$28769ce7cf4b59f9);
const $28848bfff17bed6a$export$f71b23feb2b86ed9 = ({ props: props })=>(0, $dPDEg.transitionsProvider)($28848bfff17bed6a$export$28769ce7cf4b59f9)(props);

});
parcelRegister("7Xmbv", function(module, exports) {

$parcel$export(module.exports, "default", () => $22d0becb667fb17a$export$2e2bcd8739ae039);

var $aNP7s = parcelRequire("aNP7s");
const $22d0becb667fb17a$export$d1183e28fea9e49c = {
    data: undefined,
    loading: false,
    error: undefined,
    fetch: ()=>Promise.resolve()
};
/**
 * Gets projectData from ContainerContextSubscriber or from service
 */ const $22d0becb667fb17a$var$ViewWorkflowContextService = (props)=>{
    const { baseUrl: baseUrl, issueKey: issueKey, children: children } = props;
    return children((0, $aNP7s.useProjectViewWorkflowService)(baseUrl, issueKey));
};
var $22d0becb667fb17a$export$2e2bcd8739ae039 = $22d0becb667fb17a$var$ViewWorkflowContextService;

});
parcelRegister("aNP7s", function(module, exports) {

$parcel$export(module.exports, "useProjectViewWorkflowService", () => $ff9732a099884487$export$aa23574b54bd5f5e);

var $2vSU6 = parcelRequire("2vSU6");

var $k3PbQ = parcelRequire("k3PbQ");

var $lpwtK = parcelRequire("lpwtK");

var $g5X3G = parcelRequire("g5X3G");

var $koeKL = parcelRequire("koeKL");

var $kBWC0 = parcelRequire("kBWC0");
const $ff9732a099884487$export$d1183e28fea9e49c = {
    data: undefined,
    loading: false,
    error: undefined,
    fetch: ()=>Promise.resolve()
};
const $ff9732a099884487$var$getIssueProjectDataFromContext = (useProjectData, issueProjectKey)=>{
    if (!useProjectData || !useProjectData.data) return undefined;
    const hasIssueProjectDataInContext = useProjectData.data.key === issueProjectKey;
    if (!hasIssueProjectDataInContext) return undefined;
    return {
        projectId: (0, $g5X3G.toProjectId)(useProjectData.data.id.toString()),
        projectType: (0, $2vSU6.toProjectType)(useProjectData.data.type),
        isSimplified: useProjectData.data.isSimplified
    };
};
const $ff9732a099884487$export$aa23574b54bd5f5e = (baseUrl, issueKey)=>{
    const issueProjectKey = issueKey ? (0, $k3PbQ.extractProjectKey)(issueKey) : null;
    const useProjectData = (0, $lpwtK.useProject)();
    const projectContextData = $ff9732a099884487$var$getIssueProjectDataFromContext(useProjectData, issueProjectKey);
    const cloudId = (0, $koeKL.useCloudId)();
    const issueContextData = (0, $kBWC0.useViewWorkflowData)({
        baseUrl: baseUrl,
        projectKey: projectContextData ? undefined : issueProjectKey || undefined,
        issueKey: issueKey,
        isSimplified: projectContextData && projectContextData.isSimplified,
        cloudId: cloudId
    });
    if (!issueKey || !issueProjectKey) return {
        ...$ff9732a099884487$export$d1183e28fea9e49c
    };
    const combinedData = projectContextData || issueContextData.data ? {
        ...projectContextData,
        ...issueContextData.data
    } : undefined;
    return {
        ...issueContextData,
        data: combinedData
    };
};

});
parcelRegister("k3PbQ", function(module, exports) {

$parcel$export(module.exports, "extractProjectKey", () => $bfdd97e245e93328$export$f1a2e4721b127828);

var $g5X3G = parcelRequire("g5X3G");
const $bfdd97e245e93328$export$f1a2e4721b127828 = (issueKey)=>(0, $g5X3G.toProjectKey)(issueKey.split('-')[0]);

});

parcelRegister("kBWC0", function(module, exports) {

$parcel$export(module.exports, "useViewWorkflowData", () => $f867d69fec793925$export$d60b63dd0a193e30);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $7f4tk = parcelRequire("7f4tk");


var $gRDj0 = parcelRequire("gRDj0");

var $iaa7u = parcelRequire("iaa7u");
const $f867d69fec793925$export$7a2d7e5adacde085 = ()=>'/rest/gira/latest/?operation=nextGenViewWorkflowQuery';
const $f867d69fec793925$var$optionsGraphQlQuery = (issueKey, cloudId, projectKey)=>`
    query nextGenViewWorkflowQuery {
        permissions(issueKey:"${issueKey}", keys:["${0, $878fbedb9c4ca329$export$136fc24ec1bfcefd}", "${0, $878fbedb9c4ca329$export$624e7abc8d9cada5}"]) {
            key
            havePermission
        }
        ${projectKey ? `project(projectKey: "${projectKey}") {
            projectId
            simplified
            type
        }` : ''}
        jira {
            issueByKey(key: "${issueKey}", cloudId: "${cloudId}") {
                fieldsById(ids: ["issuetype"]) {
                    edges {
                        node {
                            ... on JiraIssueTypeField {
                                fieldId
                                issueType {
                                issueTypeId
                                }
                            }
                        }
                    }
                }
            }
        }
    }
`;
const $f867d69fec793925$export$7fe04353ef301d96 = (baseUrl, issueKey, cloudId, projectKey, isSimplified)=>(0, $7f4tk.default)($f867d69fec793925$export$7a2d7e5adacde085(), {
        method: 'POST',
        body: JSON.stringify({
            query: $f867d69fec793925$var$optionsGraphQlQuery(issueKey, cloudId, projectKey)
        })
    }).then((data)=>(0, $iaa7u.transform)(data, isSimplified));
const $f867d69fec793925$export$d60b63dd0a193e30 = ({ baseUrl: baseUrl, projectKey: projectKey, issueKey: issueKey, isSimplified: isSimplified, cloudId: cloudId })=>{
    const [dataState, setDataState] = (0, $5uXOq.useState)(undefined);
    const [errorState, setErrorState] = (0, $5uXOq.useState)(undefined);
    const [loadingState, setLoadingState] = (0, $5uXOq.useState)(false);
    const { fetchWorkflowServiceData: fetchWorkflowServiceData } = (0, $4R6GH.fg)('relay-migration-issue-fields-status') ? (0, $gRDj0.useFetchWorkflowServiceData)({
        issueKey: issueKey
    }) : {
        fetchWorkflowServiceData: ()=>undefined
    };
    const fetch = async ()=>{
        request();
        try {
            let dataRes;
            if ((0, $4R6GH.fg)('relay-migration-issue-fields-status')) dataRes = await fetchWorkflowServiceData();
            else dataRes = await $f867d69fec793925$export$7fe04353ef301d96(baseUrl, issueKey, cloudId, projectKey, isSimplified);
            success(dataRes);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData((0, $878fbedb9c4ca329$export$4bf6353caa97e8e7), ex);
            failure(ex);
        }
    };
    const request = ()=>{
        setDataState(undefined);
        setErrorState(undefined);
        setLoadingState(true);
    };
    const success = (data)=>{
        setDataState(data);
        setErrorState(undefined);
        setLoadingState(false);
    };
    const failure = (error)=>{
        setDataState(undefined);
        setErrorState(error);
        setLoadingState(false);
    };
    return {
        data: dataState,
        error: errorState,
        loading: loadingState,
        fetch: fetch
    };
};

});
const $878fbedb9c4ca329$export$71a8e2ae8cfade56 = 'issue-field.status.fetch-transitions';
const $878fbedb9c4ca329$export$25529a3376b831fd = 'issue-field.status.post-transition';
const $878fbedb9c4ca329$export$4bf6353caa97e8e7 = 'issue-field.status.fetch-view-workflow';
const $878fbedb9c4ca329$export$136fc24ec1bfcefd = 'VIEW_READONLY_WORKFLOW';
const $878fbedb9c4ca329$export$624e7abc8d9cada5 = 'ADMINISTER';

parcelRegister("gRDj0", function(module, exports) {

$parcel$export(module.exports, "useFetchWorkflowServiceData", () => $6d25929ebf7a2276$export$5625d50611791f51);

var $capbT = parcelRequire("capbT");

var $5uXOq = parcelRequire("5uXOq");

var $eiowN = parcelRequire("eiowN");

var $2vSU6 = parcelRequire("2vSU6");

var $5yJb9 = parcelRequire("5yJb9");

var $g5X3G = parcelRequire("g5X3G");

var $koeKL = parcelRequire("koeKL");
const $6d25929ebf7a2276$export$5625d50611791f51 = ({ issueKey: issueKey })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fetchWorkflowServiceData = (0, $5uXOq.useCallback)(async ()=>{
        const data = await (0, $eiowN.fetchQuery)((0, $5yJb9.default)(), (0, $capbT.default), {
            issueKey: issueKey,
            cloudId: cloudId
        }).toPromise();
        return {
            hasPermission: (data?.jira?.issueByKey?.projectField?.project?.projectStyle === 'TEAM_MANAGED_PROJECT' ? data?.jira?.issueByKey?.canReadWorkflow || data?.jira?.issueByKey?.canEditWorkflow : data?.jira?.issueByKey?.canReadWorkflow) ?? false,
            projectId: (0, $g5X3G.toProjectId)(data?.jira?.issueByKey?.projectField?.project?.projectId ?? ''),
            projectType: (0, $2vSU6.toProjectType)(data?.jira?.issueByKey?.projectField?.project?.projectType ?? ''),
            isSimplified: data?.jira?.issueByKey?.projectField?.project?.projectStyle === 'TEAM_MANAGED_PROJECT',
            issueTypeId: (0, $g5X3G.toIssueTypeId)(data?.jira?.issueByKey?.issueTypeField?.issueType?.issueTypeId ?? '')
        };
    }, [
        cloudId,
        issueKey
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            fetchWorkflowServiceData: fetchWorkflowServiceData
        }), [
        fetchWorkflowServiceData
    ]);
};

});
parcelRegister("capbT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c34c99b9dba4fa50$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b37a15a2646cf2b254e93c51233c770a>>
 * @relayHash 52ec9f41292374b8b42a659792cc636f
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04a89f473a7a99d1e53af734bfdc49e7266fc4803ed427ccf54421609fb93a8a
const $c34c99b9dba4fa50$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueKey"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "cloudId",
            "variableName": "cloudId"
        },
        {
            "kind": "Variable",
            "name": "key",
            "variableName": "issueKey"
        }
    ], v2 = {
        "alias": "canReadWorkflow",
        "args": [
            {
                "kind": "Literal",
                "name": "permission",
                "value": "VIEW_READONLY_WORKFLOW"
            }
        ],
        "kind": "ScalarField",
        "name": "hasProjectPermission",
        "storageKey": "hasProjectPermission(permission:\"VIEW_READONLY_WORKFLOW\")"
    }, v3 = {
        "alias": "canEditWorkflow",
        "args": [
            {
                "kind": "Literal",
                "name": "permission",
                "value": "EDIT_WORKFLOW"
            }
        ],
        "kind": "ScalarField",
        "name": "hasProjectPermission",
        "storageKey": "hasProjectPermission(permission:\"EDIT_WORKFLOW\")"
    }, v4 = {
        "kind": "ScalarField",
        "name": "projectId"
    }, v5 = {
        "kind": "ScalarField",
        "name": "projectType"
    }, v6 = {
        "kind": "ScalarField",
        "name": "projectStyle"
    }, v7 = {
        "kind": "ScalarField",
        "name": "issueTypeId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useWorkflowRelayQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ 
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ 
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useWorkflowRelayQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraIssue",
                            "kind": "LinkedField",
                            "name": "issueByKey",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraProjectField",
                                    "kind": "LinkedField",
                                    "name": "projectField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraProject",
                                            "kind": "LinkedField",
                                            "name": "project",
                                            "plural": false,
                                            "selections": [
                                                v4 /*: any*/ ,
                                                v5 /*: any*/ ,
                                                v6 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                {
                                    "concreteType": "JiraIssueTypeField",
                                    "kind": "LinkedField",
                                    "name": "issueTypeField",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraIssueType",
                                            "kind": "LinkedField",
                                            "name": "issueType",
                                            "plural": false,
                                            "selections": [
                                                v7 /*: any*/ ,
                                                v8 /*: any*/ 
                                            ]
                                        },
                                        v8 /*: any*/ 
                                    ]
                                },
                                v8 /*: any*/ 
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "04a89f473a7a99d1e53af734bfdc49e7266fc4803ed427ccf54421609fb93a8a",
            "metadata": {},
            "name": "useWorkflowRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$c34c99b9dba4fa50$var$node.hash = "ebdee6e1f1db415100c81dcb27198ff2";
var $c34c99b9dba4fa50$export$2e2bcd8739ae039 = $c34c99b9dba4fa50$var$node;

});


parcelRegister("iaa7u", function(module, exports) {

$parcel$export(module.exports, "transform", () => $36fc98ea47fc7430$export$51186ad6e864892a);

var $2vSU6 = parcelRequire("2vSU6");

var $g5X3G = parcelRequire("g5X3G");

// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $36fc98ea47fc7430$var$simplifiedPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $878fbedb9c4ca329$export$136fc24ec1bfcefd) && havePermission || key === (0, $878fbedb9c4ca329$export$624e7abc8d9cada5) && havePermission;
// @ts-expect-error - TS7031 - Binding element 'key' implicitly has an 'any' type. | TS7031 - Binding element 'havePermission' implicitly has an 'any' type.
const $36fc98ea47fc7430$var$classicPermissionPredicate = ({ key: key, havePermission: havePermission })=>key === (0, $878fbedb9c4ca329$export$136fc24ec1bfcefd) && havePermission;
const $36fc98ea47fc7430$export$51186ad6e864892a = ({ data: data }, isSimplifiedCached)=>{
    if (!data || !data.permissions || !data.jira) return undefined;
    const { permissions: permissions, project: project, jira: jira } = data;
    const isSimplified = project && project.simplified || isSimplifiedCached;
    const permissionPredicate = isSimplified === true ? $36fc98ea47fc7430$var$simplifiedPermissionPredicate : $36fc98ea47fc7430$var$classicPermissionPredicate;
    const issueTypeField = jira.issueByKey?.fieldsById?.edges?.find((edge)=>edge.node?.fieldId === 'issuetype');
    const result = {
        hasPermission: permissions.some(permissionPredicate),
        issueTypeId: (0, $g5X3G.toIssueTypeId)(issueTypeField?.node?.issueType?.issueTypeId ? issueTypeField.node.issueType.issueTypeId : '')
    };
    if (project) {
        result.projectId = (0, $g5X3G.toProjectId)(String(project.projectId));
        result.projectType = (0, $2vSU6.toProjectType)(project.type);
        result.isSimplified = project.simplified;
    }
    return result;
};

});




parcelRegister("hmK1M", function(module, exports) {

$parcel$export(module.exports, "StatusView", () => $f4607509f8535f3b$export$a11134e1462e763);
$parcel$export(module.exports, "default", () => $f4607509f8535f3b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $1UikQ = parcelRequire("1UikQ");

var $8Rkzz = parcelRequire("8Rkzz");

var $eTXmK = parcelRequire("eTXmK");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");
var $b9dFI = parcelRequire("b9dFI");

var $6sO8n = parcelRequire("6sO8n");

var $i0vxP = parcelRequire("i0vxP");

var $gULOk = parcelRequire("gULOk");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $1XJ20 = parcelRequire("1XJ20");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6s1PB = parcelRequire("6s1PB");

var $N7jPX = parcelRequire("N7jPX");

var $gyeeU = parcelRequire("gyeeU");

var $9qzmO = parcelRequire("9qzmO");

var $fJ83Q = parcelRequire("fJ83Q");

var $2Dz1l = parcelRequire("2Dz1l");

var $7mPT9 = parcelRequire("7mPT9");


var $17mYr = parcelRequire("17mYr");

var $44VbI = parcelRequire("44VbI");

var $kTnV4 = parcelRequire("kTnV4");

var $2NP8E = parcelRequire("2NP8E");

var $k9YKz = parcelRequire("k9YKz");

var $k92cH = parcelRequire("k92cH");

var $coyc6 = parcelRequire("coyc6");

var $rNSQs = parcelRequire("rNSQs");

var $1khYv = parcelRequire("1khYv");

var $1xqgn = parcelRequire("1xqgn");

var $hOOVM = parcelRequire("hOOVM");

var $02biC = parcelRequire("02biC");

var $4hdrg = parcelRequire("4hdrg");

var $5uNOo = parcelRequire("5uNOo");

var $axCqr = parcelRequire("axCqr");

var $lr99B = parcelRequire("lr99B");
const $f4607509f8535f3b$var$defaultPopperProps = {
    modifiers: [
        {
            name: 'offset',
            options: {
                offset: [
                    0,
                    8
                ]
            }
        },
        {
            name: 'preventOverflow',
            options: {
                padding: 5,
                rootBoundary: 'document'
            }
        }
    ],
    // makes it work inside modal-dialog
    strategy: 'fixed'
};
const $f4607509f8535f3b$var$isOptionDisabled = (option)=>('transition' in option && option.transition.isDisabled) ?? false;
const $f4607509f8535f3b$var$isTransitionOption = (option)=>'transition' in option;
const $f4607509f8535f3b$var$isFooterOption = (option)=>'type' in option;
const $f4607509f8535f3b$var$FormatTransitionOptionLabel = ({ option: option })=>{
    const { forceNoLabels: forceNoLabels = false, transitions: transitions, selectedTransition: selectedTransition, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, configureStatusSource: configureStatusSource, setIsConfigureStatusModalOpen: setIsConfigureStatusModalOpen, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $f4607509f8535f3b$var$useStatusViewContext();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const isGlobalOnly = (0, $44VbI.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    if (!(0, $4R6GH.fg)('inline_config_a11y_improvements') && (showConfigureStatusButtons || combinedInlineConfigurationExperiment.isEnabled) && projectId && projectKey) {
        const status = {
            id: option.transition.to.id,
            statusName: option.transition.to.name,
            statusCategory: (0, $gULOk.statusCategoryForId)(option.transition.to.statusCategory.id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1khYv.Transition), {
            transition: option.transition,
            hasLabel: showLabel,
            contentAfter: // To be removed when FG jira-adoption-new-edit-status-flow-inline-config is cleaned up
            !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && option.transition.id !== selectedTransition?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9YKz.EditStatusButtonOld), {
                status: status,
                projectId: projectId,
                // temporary empty string will trigger a loading state within the edit status modal
                issueTypeId: issueTypeId ?? '',
                projectKey: projectKey,
                statusNames: transitions?.map((transition)=>transition.to.name),
                onClick: ()=>setIsConfigureStatusModalOpen?.(true),
                onClose: ()=>setIsConfigureStatusModalOpen?.(false),
                onStatusUpdated: onStatusCreatedOrUpdated,
                source: configureStatusSource
            }),
            testId: "issue-field-status.ui.status-view.transition"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('jira_inline_config_option_spacing') ? $f4607509f8535f3b$var$transitionOptionStyles : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1khYv.Transition), {
        transition: option.transition,
        hasLabel: showLabel,
        testId: "issue-field-status.ui.status-view.transition"
    }));
};
const $f4607509f8535f3b$var$FormatTransitionOptionLabelForCommandPalette = ({ option: option, transitionProps: transitionProps })=>{
    const { forceNoLabels: forceNoLabels = false, transitions: transitions, selectedTransition: selectedTransition, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, configureStatusSource: configureStatusSource, setIsConfigureStatusModalOpen: setIsConfigureStatusModalOpen, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $f4607509f8535f3b$var$useStatusViewContext();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const isGlobalOnly = (0, $44VbI.isOnlyGlobalTransitions)(filteredAndOrderedTransitions || []);
    const showLabel = !(forceNoLabels || isGlobalOnly);
    if (!(0, $4R6GH.fg)('inline_config_a11y_improvements') && (showConfigureStatusButtons || combinedInlineConfigurationExperiment.isEnabled) && projectId && projectKey) {
        const status = {
            id: option.transition.to.id,
            statusName: option.transition.to.name,
            statusCategory: (0, $gULOk.statusCategoryForId)(option.transition.to.statusCategory.id)
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1khYv.Transition), {
            transition: option.transition,
            hasLabel: showLabel,
            addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
            contentAfter: // To be removed when FG jira-adoption-new-edit-status-flow-inline-config is cleaned up
            !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && option.transition.id !== selectedTransition?.id && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k9YKz.EditStatusButtonOld), {
                status: status,
                projectId: projectId,
                // temporary empty string will trigger a loading state within the edit status modal
                issueTypeId: issueTypeId ?? '',
                projectKey: projectKey,
                statusNames: transitions?.map((transition)=>transition.to.name),
                onClick: ()=>setIsConfigureStatusModalOpen?.(true),
                onClose: ()=>setIsConfigureStatusModalOpen?.(false),
                onStatusUpdated: onStatusCreatedOrUpdated,
                source: configureStatusSource
            }),
            testId: "issue-field-status.ui.status-view.transition"
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1khYv.Transition), {
        transition: option.transition,
        hasLabel: showLabel,
        addTransitionArrowSpacing: transitionProps?.addTransitionArrowSpacing,
        testId: "issue-field-status.ui.status-view.transition"
    });
};
const $f4607509f8535f3b$var$FormatTransitionOptionLabelWithCreateStatus = ({ option: option })=>{
    const { value: value, transitions: transitions, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, onClickConfigureStatus: onClickConfigureStatus, onCloseConfigureStatus: onCloseConfigureStatus, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, configureStatusSource: configureStatusSource, createStatusButtonRef: createStatusButtonRef, editStatusButtonRef: editStatusButtonRef, shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal } = $f4607509f8535f3b$var$useStatusViewContext();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const [inlineStatusConfigExp] = (0, $6s1PB.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusExperimentEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const isConfigureStatusAvailable = isInlineStatusExperimentEnabled && showConfigureStatusButtons && projectType && projectKey;
    if ((isConfigureStatusAvailable || combinedInlineConfigurationExperiment.isEnabled) && projectKey && projectType && projectId && issueTypeId && 'value' in option) switch(option.value){
        case 0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3:
            return (0, $4R6GH.fg)('inline_config_a11y_improvements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $02biC.CreateStatusOption), {
                projectId: projectId,
                projectKey: projectKey,
                projectType: projectType,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition?.to?.name),
                onClick: onClickConfigureStatus,
                onClose: onCloseConfigureStatus,
                onStatusCreated: onStatusCreatedOrUpdated,
                buttonRef: createStatusButtonRef,
                source: configureStatusSource,
                shouldTriggerModal: shouldStatusConfigTriggerModal
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NP8E.CreateStatusButton), {
                projectId: projectId,
                projectKey: projectKey,
                projectType: projectType,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition?.to?.name),
                onClick: onClickConfigureStatus,
                onClose: onCloseConfigureStatus,
                onStatusCreated: onStatusCreatedOrUpdated,
                isPressable: true,
                buttonRef: createStatusButtonRef,
                source: configureStatusSource,
                shouldTriggerModal: shouldStatusConfigTriggerModal
            });
        case 0, $4ffa16dc12cfa934$export$bc1622166baa0162:
            return transitions && value && (0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4hdrg.EditStatusOption), {
                status: (0, $9qzmO.transformServerRestStatusToStatus)(value),
                statuses: transitions.map((transition)=>(0, $9qzmO.transformServerRestStatusToStatus)(transition?.to)).filter((status, index, self)=>index === self.findIndex((t)=>t.statusName === status.statusName)),
                projectId: projectId,
                projectKey: projectKey,
                issueTypeId: issueTypeId,
                statusNames: transitions?.map((transition)=>transition?.to?.name),
                onClick: onClickConfigureStatus,
                onClose: onCloseConfigureStatus,
                onStatusUpdated: onStatusCreatedOrUpdated,
                source: configureStatusSource,
                buttonRef: editStatusButtonRef,
                shouldTriggerModal: shouldStatusConfigTriggerModal
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
        case 0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b:
            return (0, $4R6GH.fg)('inline_config_a11y_improvements') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $f4607509f8535f3b$var$manageWorkflowStyles
            }, option.label) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                xcss: $f4607509f8535f3b$var$manageWorkflowStyles
            }, option.label);
        default:
            break;
    }
    if ($f4607509f8535f3b$var$isTransitionOption(option)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$FormatTransitionOptionLabel, {
        option: option
    });
};
const $f4607509f8535f3b$var$CommandPaletteStatusViewComponent = ()=>{
    const { isLoading: isLoading, value: value, transitions: transitions, onSuccess: onSuccess, onFetch: onFetch, onUpdateStatusMutation: onUpdateStatusMutation, filteredAndOrderedTransitions: filteredAndOrderedTransitions } = $f4607509f8535f3b$var$useStatusViewContext();
    const wasFetchSuccessful = transitions != null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kTnV4.CommandPaletteStatusView), {
        transitions: filteredAndOrderedTransitions,
        currentStatus: value,
        onSuccess: onSuccess,
        wasFetchSuccessful: wasFetchSuccessful,
        renderTransition: (option, transitionProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$FormatTransitionOptionLabelForCommandPalette, {
                option: option,
                transitionProps: transitionProps
            }),
        onFetch: onFetch,
        isLoading: isLoading,
        onUpdateStatusMutation: onUpdateStatusMutation
    });
};
const $f4607509f8535f3b$var$Lozenge = ({ targetRef: targetRef, triggerProps: triggerProps })=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, error: error, value: value, statusButtonRef: statusButtonRef, isOpen: isOpen } = $f4607509f8535f3b$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (isSaving) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sO8n.default), {
        border: false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        targetRef: targetRef,
        status: value,
        error: error,
        contentRef: statusButtonRef,
        triggerProps: triggerProps
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.WrappedStatusLozenge), {
        ariaLabel: `${value.name} - ${formatMessage((0, $k92cH.default).changeStatus)}`,
        error: error,
        hasHoverState: true,
        isEditable: isEditable,
        isOpen: isOpen,
        status: value,
        targetRef: targetRef,
        contentRef: statusButtonRef,
        triggerProps: triggerProps
    });
};
const $f4607509f8535f3b$var$StatusButtonComponent = ({ targetRef: targetRef, triggerProps: triggerProps })=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, value: value, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true, isOpen: isOpen } = $f4607509f8535f3b$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const statusButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $rNSQs.StatusButton), {
        ariaLabel: `${value.name} - ${formatMessage((0, $k92cH.default).changeStatus)}`,
        isEditable: isEditable,
        isOpen: isOpen,
        status: value,
        targetRef: targetRef,
        statusButtonRef: statusButtonRef,
        shouldFitContainer: shouldFitContainer,
        triggerProps: triggerProps
    });
    return isSaving ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6sO8n.default), null, statusButton) : statusButton;
};
const $f4607509f8535f3b$var$FocusWrapper = ({ children: children })=>{
    const { isSaving: isSaving = false } = $f4607509f8535f3b$var$useStatusViewContext();
    const childWrapperRef = (0, $5uXOq.useRef)(null);
    const previousIsSaving = (0, $1XJ20.usePrevious)(isSaving);
    (0, $5uXOq.useEffect)(()=>{
        if (previousIsSaving === true && isSaving === false) childWrapperRef.current && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children.length > 0 && // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        childWrapperRef.current.children[0].focus();
    }, [
        isSaving,
        previousIsSaving
    ]); // @ts-expect-error - TS2322 - Type 'MutableRefObject<unknown>' is not assignable to type 'LegacyRef<HTMLDivElement> | undefined'.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: childWrapperRef
    }, children);
};
const $f4607509f8535f3b$var$Target = ({ targetRef: targetRef, triggerProps: triggerProps })=>{
    const { value: value, appearance: appearance, registerInCommandPalette: registerInCommandPalette } = $f4607509f8535f3b$var$useStatusViewContext();
    if (value) {
        if (appearance === 'lozenge') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$FocusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$Lozenge, {
            targetRef: targetRef,
            triggerProps: triggerProps
        }));
        if (appearance === 'button') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$FocusWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$StatusButtonComponent, {
            targetRef: targetRef,
            triggerProps: triggerProps
        })), registerInCommandPalette && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$CommandPaletteStatusViewComponent, null));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null);
};
const $f4607509f8535f3b$var$OptionWithButtonForSelect = ({ children: children, ...optionProps })=>{
    const { projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, transitions: transitions, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, configureStatusSource: configureStatusSource, menuListRef: menuListRef, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, setIsConfigureStatusModalOpen: setIsConfigureStatusModalOpen } = $f4607509f8535f3b$var$useStatusViewContext();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    if ($f4607509f8535f3b$var$isFooterOption(optionProps.data) && [
        (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3),
        (0, $4ffa16dc12cfa934$export$bc1622166baa0162),
        (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b)
    ].includes(optionProps.data.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJ83Q.OptionWithButtonStyle), {
        ...optionProps,
        innerProps: {
            ...optionProps.innerProps,
            role: 'button'
        }
    }, children);
     // To be removed when FG jira-adoption-new-edit-status-flow-inline-config is cleaned up
    if (projectId && projectKey && optionProps.data && menuListRef && $f4607509f8535f3b$var$isTransitionOption(optionProps.data) && !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOOVM.OptionWithInlineConfigButtons), {
        showEditButton: combinedInlineConfigurationExperiment.isEnabled || Boolean(showConfigureStatusButtons),
        projectId: projectId,
        projectKey: projectKey,
        // temporary empty string will trigger a loading state within the edit status modal
        issueTypeId: issueTypeId ?? '',
        statusNames: transitions?.map((transition)=>transition.to.name) ?? [],
        menuListRef: menuListRef,
        onStatusUpdated: onStatusCreatedOrUpdated,
        source: configureStatusSource,
        onOpenEditModal: ()=>setIsConfigureStatusModalOpen(true),
        onCloseEditModal: ()=>setIsConfigureStatusModalOpen(false),
        ...optionProps
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1xqgn.OptionComponent), optionProps, children);
};
const $f4607509f8535f3b$var$Footer = ()=>{
    const { footer: footer, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusButtonsEnabled: configureStatusButtonsEnabled, value: value, transitions: transitions, onClickConfigureStatus: onClickConfigureStatus, onCloseConfigureStatus: onCloseConfigureStatus, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, createStatusButtonRef: createStatusButtonRef, editStatusButtonRef: editStatusButtonRef, configureStatusSource: configureStatusSource, shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal, projectKey: projectKey, projectId: projectId, projectType: projectType, issueTypeId: issueTypeId } = $f4607509f8535f3b$var$useStatusViewContext();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const showCreateStatusButton = (combinedInlineConfigurationExperiment.isEnabled || showConfigureStatusButtons) && projectKey && projectType && projectId;
    const showEditStatusButton = showCreateStatusButton && value && transitions && (0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config');
    if (!footer && !showCreateStatusButton) return null;
    const footerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, showCreateStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NP8E.CreateStatusButton), {
        projectId: projectId,
        projectKey: projectKey,
        projectType: projectType,
        // temporary empty string will trigger a loading state within the create status modal
        issueTypeId: issueTypeId ?? '',
        statusNames: transitions?.map((transition)=>transition?.to?.name),
        onClick: onClickConfigureStatus,
        onClose: onCloseConfigureStatus,
        onStatusCreated: onStatusCreatedOrUpdated,
        buttonRef: createStatusButtonRef,
        source: configureStatusSource,
        shouldTriggerModal: shouldStatusConfigTriggerModal
    }), showEditStatusButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uNOo.EditStatusButton), {
        status: (0, $9qzmO.transformServerRestStatusToStatus)(value),
        statuses: transitions.map((transition)=>(0, $9qzmO.transformServerRestStatusToStatus)(transition?.to)).filter((status, index, self)=>index === self.findIndex((t)=>t.statusName === status.statusName)),
        projectId: projectId,
        projectKey: projectKey,
        // temporary empty string will trigger a loading state within the edit status modal
        issueTypeId: issueTypeId ?? '',
        statusNames: transitions?.map((transition)=>transition?.to?.name),
        onClick: onClickConfigureStatus,
        onClose: onCloseConfigureStatus,
        onStatusUpdated: onStatusCreatedOrUpdated,
        source: configureStatusSource,
        buttonRef: editStatusButtonRef,
        shouldTriggerModal: shouldStatusConfigTriggerModal
    }), footer);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: $f4607509f8535f3b$var$statusViewFooterStyles
    }, (0, $4R6GH.fg)('a11y_jira_issue_status_field') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", {
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _ogto7mnp _4t3it94y _1bsbt94y _kqswstnw"
        ])
    }, formatMessage((0, $k92cH.default).status)), footerContent) : footerContent);
};
const $f4607509f8535f3b$var$StatusViewContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isLoading: false,
    value: {
        id: '',
        name: '',
        statusCategory: {
            id: 0
        }
    },
    transitions: [],
    appearance: 'button',
    shouldStatusConfigTriggerModal: true,
    isOpen: false,
    setIsConfigureStatusModalOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onClickConfigureStatus: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onCloseConfigureStatus: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    menuListRef: null,
    createStatusButtonRef: null,
    editStatusButtonRef: null,
    filteredAndOrderedTransitions: []
});
const $f4607509f8535f3b$var$useStatusViewContext = ()=>{
    const context = (0, $5uXOq.useContext)($f4607509f8535f3b$var$StatusViewContext);
    if (!context) throw new Error('useStatusViewContext must be used within a StatusViewProvider');
    return context;
};
const $f4607509f8535f3b$export$a11134e1462e763 = (props)=>{
    const { isEditable: isEditable = true, isSaving: isSaving = false, isLoading: isLoading, value: value, transitions: transitions, isDefaultSelect: isDefaultSelect = false, selectedTransition: selectedTransition, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpen: onOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), customNoOptionsMessage: customNoOptionsMessage, statusButtonRef: statusButtonRef, popperProps: popperProps, fieldId: fieldId, showConfigureStatusButtons: showConfigureStatusButtons, configureStatusDialogType: configureStatusDialogType = 'modal', configureStatusPopupPlacement: configureStatusPopupPlacement = 'bottom-end', configureStatusButtonsEnabled: configureStatusButtonsEnabled, projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, defaultOpen: // for testing
    defaultOpen = false, onStatusCreatedOrUpdated: onStatusCreatedOrUpdated, onOpenManageWorkflow: onOpenManageWorkflow, configureStatusSource: configureStatusSource, autofocus: autofocus = false } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isMenuOpen, setIsMenuOpen] = (0, $5uXOq.useState)(false);
    const lastKey = (0, $5uXOq.useRef)(null);
    const selectRef = (0, $5uXOq.useRef)(null);
    const wasChanged = (0, $5uXOq.useRef)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)(configureStatusButtonsEnabled);
    const wasFetchSuccessful = transitions != null;
    const filteredAndOrderedTransitions = (0, $5uXOq.useMemo)(()=>(0, $44VbI.getFilteredOrderedTransitions)(transitions, value.id), [
        transitions,
        value.id
    ]);
    const [inlineStatusConfigExp] = (0, $6s1PB.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusExperimentEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const isConfigureStatusAvailable = isInlineStatusExperimentEnabled && showConfigureStatusButtons && projectType && projectKey;
    const createStatusButtonRef = (0, $5uXOq.useRef)(null);
    const editStatusButtonRef = (0, $5uXOq.useRef)(null);
    const menuListRef = (0, $5uXOq.useRef)(null);
    const [isConfigureStatusModalOpen, setIsConfigureStatusModalOpen] = (0, $5uXOq.useState)(false);
    const [isConfigureStatusPopupOpen, setIsConfigureStatusPopupOpen] = (0, $5uXOq.useState)(false);
    const [shouldRefocus, setShouldRefocus] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldRefocus && (0, $4R6GH.fg)('jira_issue_view_status_config_modal_redesign')) {
            statusButtonRef?.current?.focus();
            setShouldRefocus(false);
        }
    }, [
        shouldRefocus,
        statusButtonRef
    ]);
    const { Panel: ConfigureStatusPopupContent, Provider: ConfigureStatusPopupTriggerContextProvider } = (0, $2Dz1l.usePanelContext)((0, $lr99B.ConfigureStatusPanel));
    const shouldRenderSelectComponent = isDefaultSelect && !!selectedTransition;
    const shouldStatusConfigTriggerModal = !(0, $4R6GH.fg)('jira_issue_view_status_config_modal_redesign') || configureStatusDialogType === 'modal' || shouldRenderSelectComponent;
    const onCloseConfigureStatus = (0, $5uXOq.useCallback)(()=>{
        if (shouldStatusConfigTriggerModal) setIsConfigureStatusModalOpen(false);
        else setIsConfigureStatusPopupOpen(false);
        (0, $4R6GH.fg)('jira_issue_view_status_config_modal_redesign') && setShouldRefocus(true);
    }, [
        shouldStatusConfigTriggerModal
    ]);
    const onClickConfigureStatus = (0, $5uXOq.useCallback)(()=>{
        if (shouldStatusConfigTriggerModal) setIsConfigureStatusModalOpen(true);
        else setIsConfigureStatusPopupOpen(true);
    }, [
        shouldStatusConfigTriggerModal
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (autofocus) selectRef.current?.focus?.();
    }, [
        autofocus
    ]); // specifically for screen readers
    const getTransitionOptionLabel = (option)=>{
        if ($f4607509f8535f3b$var$isTransitionOption(option)) return option.transition.isGlobal ? formatMessage((0, $k92cH.default).transitionTo, {
            statusName: option.label
        }) : `${option.transition.name} \u{2192} ${option.transition.to.name}`;
        return option.label;
    };
    const mergedPopperProps = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($1UikQ)))($f4607509f8535f3b$var$defaultPopperProps, popperProps), [
        popperProps
    ]);
    const handleChangeStatus = (0, $5uXOq.useCallback)((transition)=>{
        const { hasScreen: hasScreen } = transition;
        wasChanged.current = true;
        const analyticsEvent = createAnalyticsEvent({
            action: 'transitionSelected',
            actionSubject: 'statusField'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'transitionSelectedStatusField', {
            hasScreen: hasScreen
        });
        if ((0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition')) (0, $eTXmK.default)('issue.fields.status.popup.submit');
        onChange?.(transition, analyticsEvent);
    }, [
        onChange,
        createAnalyticsEvent
    ]);
    const handleChange = (0, $5uXOq.useCallback)((option)=>{
        if ((combinedInlineConfigurationExperiment.isEnabled || isConfigureStatusAvailable) && option?.value && [
            (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3),
            (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b),
            (0, $4ffa16dc12cfa934$export$bc1622166baa0162)
        ].includes(option.value)) {
            switch(option?.value){
                case 0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3:
                    createStatusButtonRef?.current?.click();
                    setIsConfigureStatusModalOpen(true);
                    break;
                case 0, $4ffa16dc12cfa934$export$bc1622166baa0162:
                    if ((0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config')) {
                        editStatusButtonRef?.current?.click();
                        setIsConfigureStatusModalOpen(true);
                    }
                    break;
                case 0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b:
                    onOpenManageWorkflow && onOpenManageWorkflow();
                    break;
                default:
                    break;
            }
            return;
        }
        if (!(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements')) setIsMenuOpen(false);
        if (option && $f4607509f8535f3b$var$isTransitionOption(option)) handleChangeStatus(option.transition);
    }, [
        handleChangeStatus,
        isConfigureStatusAvailable,
        onOpenManageWorkflow,
        combinedInlineConfigurationExperiment.isEnabled
    ]);
    const handleOpen = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'openDropdown',
            actionSubject: 'statusField'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'openDropdownStatusField');
        onOpen?.(analyticsEvent);
        setIsOpen(true);
        combinedInlineConfigurationExperiment.fireExposure();
    }, [
        onOpen,
        combinedInlineConfigurationExperiment,
        createAnalyticsEvent
    ]);
    const handleClose = (0, $5uXOq.useCallback)(()=>{
        wasChanged.current = false;
        onClose?.();
        setIsOpen(false);
        (0, $4R6GH.fg)('jira_issue_view_status_config_modal_redesign') && setShouldRefocus(true);
    }, [
        onClose
    ]);
    const handleKeyDownForSelect = (0, $5uXOq.useCallback)((e)=>{
        lastKey.current = e.key;
    }, [
        lastKey
    ]);
    const handleCloseforSelect = (0, $5uXOq.useCallback)(()=>{
        // Prevents closing the menu when tabbing to edit status buttons
        // Preserves ability for Esc key to close menu
        if (lastKey.current !== 'Tab') setIsMenuOpen(false);
    }, [
        lastKey,
        setIsMenuOpen
    ]);
    const isStatusInlineFooterEnabled = (0, $5uXOq.useMemo)(()=>combinedInlineConfigurationExperiment.isEnabled || isInlineStatusExperimentEnabled && showConfigureStatusButtons, [
        combinedInlineConfigurationExperiment.isEnabled,
        isInlineStatusExperimentEnabled,
        showConfigureStatusButtons
    ]);
    const transformedOptions = (0, $5uXOq.useMemo)(()=>(0, $44VbI.transformOptions)(filteredAndOrderedTransitions || []), [
        filteredAndOrderedTransitions
    ]);
    const selectOptions = (0, $1xqgn.useSelectOptions)(transformedOptions, isStatusInlineFooterEnabled);
    const renderOptionWithButtonForPopupSelect = (0, $5uXOq.useCallback)(({ children: children, ...optionProps })=>{
        // To be removed when FG jira-adoption-new-edit-status-flow-inline-config is cleaned up
        if (projectId && projectKey && optionProps.data && $f4607509f8535f3b$var$isTransitionOption(optionProps.data) && !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOOVM.OptionWithInlineConfigButtons), {
            showEditButton: combinedInlineConfigurationExperiment.isEnabled || Boolean(showConfigureStatusButtons),
            projectId: projectId,
            projectKey: projectKey,
            // temporary empty string will trigger a loading state within the edit status modal
            issueTypeId: issueTypeId ?? '',
            statusNames: transitions?.map((transition)=>transition.to.name) ?? [],
            menuListRef: menuListRef,
            onStatusUpdated: onStatusCreatedOrUpdated,
            source: configureStatusSource,
            onOpenEditModal: ()=>setIsConfigureStatusModalOpen(true),
            onCloseEditModal: ()=>setIsConfigureStatusModalOpen(false),
            ...optionProps
        }, children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, optionProps, children);
    }, [
        showConfigureStatusButtons,
        projectId,
        projectKey,
        issueTypeId,
        transitions,
        menuListRef,
        onStatusCreatedOrUpdated,
        configureStatusSource,
        combinedInlineConfigurationExperiment.isEnabled
    ]);
    const getNoOptionsMessage = ()=>{
        if (customNoOptionsMessage) return customNoOptionsMessage;
        const noPermissionMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $k92cH.default).noPermissionIssueTermRefresh : (0, $k92cH.default).noPermission;
        return formatMessage(wasFetchSuccessful ? noPermissionMessage : (0, $k92cH.default).cannotLoadTransitions);
    };
    const SelectWrapper = !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? (0, $gyeeU.AtlaskitSelectInlineTabActivator) : (0, $5uXOq.Fragment);
    const selectWrapperProps = !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? {
        setIsMenuOpen: setIsMenuOpen,
        isMenuOpen: isMenuOpen
    } : // Temporary until inline_config_a11y_improvements is cleaned up
    // Needed for VR tests to pass as props cannot be added to Fragment
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    {};
    const statusPopup = shouldRenderSelectComponent ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SelectWrapper, selectWrapperProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        label: formatMessage((0, $k92cH.default).selectStatus),
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$FormatTransitionOptionLabelWithCreateStatus, {
                option: option
            }),
        getOptionLabel: getTransitionOptionLabel,
        options: selectOptions,
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $f4607509f8535f3b$var$isOptionDisabled,
        onChange: handleChange,
        value: (0, $44VbI.transformOptions)([
            selectedTransition
        ])[0],
        isSearchable: false,
        onMenuOpen: handleOpen,
        closeMenuOnSelect: true,
        ...!(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? {
            onKeyDown: handleKeyDownForSelect,
            onMenuClose: handleCloseforSelect
        } : {},
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coyc6.LoadingSpinner), null),
            ...isStatusInlineFooterEnabled && {
                Group: (0, $N7jPX.GroupComponentWithStickyFooter),
                Option: !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? $f4607509f8535f3b$var$OptionWithButtonForSelect : (0, $1xqgn.OptionComponent)
            },
            ...(0, $4R6GH.fg)('inline_config_a11y_improvements') && {
                MenuList: ({ children: children, ...menuListProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, {
                        ...menuListProps,
                        innerRef: menuListRef
                    }, children)
            }
        },
        menuIsOpen: // Remove eslint-disable-next-line when inline_config_a11y_improvements is cleaned up
        // eslint-disable-next-line no-nested-ternary
        isConfigureStatusModalOpen ? false : !(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') && (0, $4R6GH.fg)('inline_config_a11y_improvements') ? isMenuOpen : undefined,
        popperProps: mergedPopperProps,
        ref: selectRef
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        inputId: fieldId,
        noOptionsMessage: getNoOptionsMessage,
        formatOptionLabel: (option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$FormatTransitionOptionLabel, {
                option: option
            }),
        getOptionLabel: getTransitionOptionLabel,
        options: (0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') ? transformedOptions : (0, $44VbI.transformOptions)(filteredAndOrderedTransitions || []),
        target: ({ ref: ref })=>(0, $4R6GH.fg)('jsc-1931_pass_custom_ref_to_status_view') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$Target, {
                targetRef: statusButtonRef ? (0, $7mPT9.mergeRefs)(ref, statusButtonRef) : ref
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$Target, {
                targetRef: ref
            }),
        isLoading: isLoading,
        isDisabled: !isEditable,
        isOptionDisabled: $f4607509f8535f3b$var$isOptionDisabled,
        searchThreshold: 99999,
        onChange: handleChange,
        onOpen: handleOpen,
        handleClick: handleOpen,
        onClose: handleClose,
        closeMenuOnSelect: true,
        components: {
            LoadingMessage: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $coyc6.LoadingSpinner), null),
            ...(combinedInlineConfigurationExperiment.isEnabled || showConfigureStatusButtons) && (0, $4R6GH.fg)('inline_config_a11y_improvements') && {
                Option: (optionProps)=>renderOptionWithButtonForPopupSelect(optionProps)
            },
            ...(0, $4R6GH.fg)('inline_config_a11y_improvements') && {
                MenuList: ({ children: children, ...menuListProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, {
                        ...menuListProps,
                        innerRef: menuListRef
                    }, children)
            }
        },
        isOpen: isConfigureStatusModalOpen ? false : undefined,
        popperProps: mergedPopperProps,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$Footer, null),
        defaultIsOpen: defaultOpen,
        label: formatMessage((0, $k92cH.default).selectStatus),
        shouldCloseMenuOnTab: false
    });
    const contextValues = (0, $5uXOq.useMemo)(()=>({
            ...props,
            menuListRef: menuListRef,
            shouldStatusConfigTriggerModal: shouldStatusConfigTriggerModal,
            isOpen: isOpen,
            setIsConfigureStatusModalOpen: setIsConfigureStatusModalOpen,
            onClickConfigureStatus: onClickConfigureStatus,
            onCloseConfigureStatus: onCloseConfigureStatus,
            createStatusButtonRef: createStatusButtonRef,
            editStatusButtonRef: editStatusButtonRef,
            filteredAndOrderedTransitions: filteredAndOrderedTransitions
        }), [
        props,
        shouldStatusConfigTriggerModal,
        isOpen,
        setIsConfigureStatusModalOpen,
        onClickConfigureStatus,
        onCloseConfigureStatus,
        filteredAndOrderedTransitions
    ]); /* This prevents the dropdown from being accessible while saving/not editable,
                                                                                                                                                                       * because for the underlying PopupSelect, the `isDisabled` prop only prevents
                                                                                                                                                                       * the actual dropdown items from being selectable - the dropdown itself still
                                                                                                                                                                       * pops up/down.
                                                                                                                                                                       */ 
    if (isSaving || !isEditable) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$StatusViewContext.Provider, {
        value: contextValues
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$Target, null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f4607509f8535f3b$var$StatusViewContext.Provider, {
        value: contextValues
    }, isConfigureStatusPopupOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $axCqr.ConfigureStatusPopup), {
        placement: configureStatusPopupPlacement,
        renderTarget: $f4607509f8535f3b$var$Target,
        renderPopupContent: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConfigureStatusPopupContent, null),
        isTargetEditable: isEditable,
        onClose: ()=>setIsConfigureStatusPopupOpen(false)
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ConfigureStatusPopupTriggerContextProvider, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i0vxP.default), {
        onEscape: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }, statusPopup)));
};
const $f4607509f8535f3b$var$statusViewFooterStyles = (0, $8CUq3.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`
});
const $f4607509f8535f3b$var$manageWorkflowStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});
const $f4607509f8535f3b$var$visuallyHiddenLegendStyles = null;
const $f4607509f8535f3b$var$transitionOptionStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.025',
    paddingBottom: 'space.025'
});
var $f4607509f8535f3b$export$2e2bcd8739ae039 = $f4607509f8535f3b$export$a11134e1462e763;

});
parcelRegister("6sO8n", function(module, exports) {

$parcel$export(module.exports, "default", () => $d332aa7c19a695ac$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
function $d332aa7c19a695ac$export$2e2bcd8739ae039(props) {
    const { border: border, children: children } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BlanketContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$BackgroundContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$Background, {
        border: border
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$ComponentContainer, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d332aa7c19a695ac$var$SpinnerContainer, {
        role: "status",
        "aria-label": "Loading"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), null)));
}
$d332aa7c19a695ac$export$2e2bcd8739ae039.defaultProps = {
    border: true
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $d332aa7c19a695ac$var$BlanketContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c116y _2lx2vrvc _4t3i1wug",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _4t3i1osq _1bsb1osq _1e0c1txw _4cvr1h6o _1bah1h6o _vchhusvi _u5f3u2gc _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$BackgroundContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _kqswstnw _4t3i1osq _1bsb1osq _vchhusvi _ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$Background = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { border: border, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _kqswh2mm _4t3i1osq _1bsb1osq _vchhusvi _bfhk11bn",
            __cmplp.border ? "_19it1x87" : "_19itglyw",
            __cmplp.className
        ])
    });
});
const $d332aa7c19a695ac$var$ComponentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _tzy4sxj9",
            __cmplp.className
        ])
    });
});

});

parcelRegister("N7jPX", function(module, exports) {

$parcel$export(module.exports, "GroupComponentWithStickyFooter", () => $20e766b49ec0b86c$export$a4fcc8b2698425e6);
/* GroupComponentWithStickyFooter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");

const $20e766b49ec0b86c$var$groupStyles = {
    root: "_ca0qze3t"
};
const $20e766b49ec0b86c$export$a4fcc8b2698425e6 = ({ children: children, ...groupProps })=>{
    const containStickyFooterGroup = (0, $5uXOq.useMemo)(()=>{
        return groupProps.data.options.find((option)=>option.groupType === (0, $8109ad51236d2441$export$e13d614fc55c6ce9));
    }, [
        groupProps.data.options
    ]);
    if (containStickyFooterGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $20e766b49ec0b86c$var$stickyFooterGroupWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Group, {
        ...groupProps,
        innerProps: {
            ...groupProps.innerProps ?? {},
            style: {
                ...groupProps.innerProps?.style ?? {},
                paddingTop: 0
            },
            className: (0, $8109ad51236d2441$export$1ae91d219a8713ac)
        },
        xcss: $20e766b49ec0b86c$var$groupStyles.root
    }, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Group, groupProps, children);
};
const $20e766b49ec0b86c$var$stickyFooterGroupWrapper = (0, $8CUq3.xcss)({
    borderTop: `2px solid ${"var(--ds-border, #091E4224)"}`,
    backgroundColor: 'elevation.surface.overlay',
    borderBottomLeftRadius: 'border.radius.200',
    borderBottomRightRadius: 'border.radius.200',
    position: 'sticky',
    bottom: 'space.negative.100',
    marginBottom: 'space.negative.100',
    paddingTop: 'space.050'
});

});
const $8109ad51236d2441$export$e13d614fc55c6ce9 = 'STICKY_FOOTER_GROUP_TYPE';
const $8109ad51236d2441$export$1ae91d219a8713ac = 'select-sticky-footer';


parcelRegister("gyeeU", function(module, exports) {

$parcel$export(module.exports, "AtlaskitSelectInlineTabActivator", () => $77cb954647054621$export$db135681be6e3fdb);

var $5uXOq = parcelRequire("5uXOq");

var $ku1fk = parcelRequire("ku1fk");

var $dC5iT = parcelRequire("dC5iT");

var $4R6GH = parcelRequire("4R6GH");
const $77cb954647054621$export$db135681be6e3fdb = ({ setInputValue: setInputValue, setIsMenuOpen: setIsMenuOpen, inputValue: inputValue, isMenuOpen: isMenuOpen, children: children })=>{
    const selectWrapperRef = (0, $5uXOq.useRef)(null);
    const handleBlur = (0, $5uXOq.useCallback)((e)=>{
        // Always close the menu on outside focus and mouse events
        if (selectWrapperRef.current && e.target instanceof Node && // This is to make sure we only blur when focusing outside of the select
        // This is required to allow interacting with inline buttons inside the select dropdown
        !selectWrapperRef.current.contains(e.target)) {
            setInputValue?.('');
            setIsMenuOpen(false);
            return;
        }
        // Always toggle the menu open/closed on internal mousedown events
        if (e.type === 'mousedown') {
            // Reset the input value when closing the menu
            if (isMenuOpen) setInputValue?.('');
            setIsMenuOpen(!isMenuOpen);
        }
    }, [
        isMenuOpen,
        setInputValue,
        setIsMenuOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Listen to focus and mousedown events to close the select dropdown when clicking or focusing outside of it
        globalThis?.document?.addEventListener('focusin', handleBlur);
        globalThis?.document?.addEventListener('mousedown', handleBlur);
        return ()=>{
            globalThis?.document?.removeEventListener('focusin', handleBlur);
            globalThis?.document?.removeEventListener('mousedown', handleBlur);
        };
    }, [
        handleBlur
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Open the menu when the input value changes
        if (!isMenuOpen && inputValue) setIsMenuOpen(true);
    }, [
        inputValue,
        isMenuOpen,
        setIsMenuOpen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        testId: "inline-config-buttons-for-select.atlaskit-select-inline-tab-activator",
        ref: selectWrapperRef,
        onKeyDown: (e)=>{
            const openMenuKeys = [
                'ArrowDown',
                'ArrowUp',
                'Enter',
                ' '
            ];
            // Only override keydown events when the menu is open or to open the menu
            if (!isMenuOpen && !openMenuKeys.includes(e.key)) return;
            switch(e.key){
                // This is to handle closing the Select menu when pressing Escape
                case 'Escape':
                    setIsMenuOpen(false);
                    setInputValue?.('');
                    break;
                // This is to allow tabbing inside the Select menu
                // if the current focus one is last tabbable element, focus the first tabbable element
                // to prevent tabbing out of the Select menu
                case 'Tab':
                    {
                        (0, $4R6GH.fg)('inline_config_a11y_improvements') && e.stopPropagation();
                        const tabbableEls = (0, (/*@__PURE__*/$parcel$interopDefault($ku1fk)))(e.currentTarget);
                        if (tabbableEls.length < 2) return;
                        const isLastTabbable = tabbableEls[tabbableEls.length - 1] === globalThis?.document?.activeElement;
                        if (isLastTabbable) {
                            e.preventDefault();
                            tabbableEls[0].focus();
                        }
                        break;
                    }
                // This is to allow navigating inside the Select menu using Arrow keys after focusing on inline buttons
                // Because users can only continue navigating using Arrow keys if the focus is on the text input of select
                case 'ArrowDown':
                case 'ArrowUp':
                    {
                        if (!isMenuOpen) {
                            setIsMenuOpen(true);
                            return;
                        }
                        const tabbableEls = (0, (/*@__PURE__*/$parcel$interopDefault($ku1fk)))(e.currentTarget);
                        if (tabbableEls.length < 2) return;
                        tabbableEls[0].focus();
                        break;
                    }
                case 'Enter':
                case ' ':
                    if (!isMenuOpen) setIsMenuOpen(true);
                    break;
                default:
                    break;
            }
        }
    }, children);
};

});

parcelRegister("9qzmO", function(module, exports) {

$parcel$export(module.exports, "transformServerRestStatusToStatus", () => $2f20d3e5dd7a7bf3$export$f8064e1f9ab3c1e0);

var $gULOk = parcelRequire("gULOk");
const $2f20d3e5dd7a7bf3$export$f8064e1f9ab3c1e0 = (serverResStatus)=>{
    return {
        id: serverResStatus?.id ?? '',
        statusName: serverResStatus?.name ?? '',
        statusCategory: (0, $gULOk.statusCategoryForId)(serverResStatus?.statusCategory?.id)
    };
};

});

parcelRegister("fJ83Q", function(module, exports) {

$parcel$export(module.exports, "OptionWithButtonStyle", () => $bb57911f4b9388b9$export$b3382093e45b6db9);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $dC5iT = parcelRequire("dC5iT");
const $bb57911f4b9388b9$export$b3382093e45b6db9 = ({ children: children, onHover: onHover, testId: testId, ...optionProps })=>{
    const customisedGetStyles = (propertyName, props)=>{
        return {
            ...optionProps.getStyles(propertyName, props),
            boxShadow: 'none',
            cursor: 'pointer',
            padding: `${"var(--ds-space-100, 8px)"} ${"var(--ds-space-150, 12px)"}`
        };
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        onMouseOver: onHover,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
        ...optionProps,
        getStyles: customisedGetStyles
    }, children));
};

});

parcelRegister("2Dz1l", function(module, exports) {

$parcel$export(module.exports, "usePanelContext", () => $fa3d11467269518b$export$2fe6b5e489926495);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $fa3d11467269518b$export$2fe6b5e489926495({ Context: Context }, preloadedPanel) {
    const [panel, setPanel] = (0, $5uXOq.useState)(preloadedPanel);
    const Panel = (0, $5uXOq.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const handleSetPanel = (0, $5uXOq.useCallback)((panel)=>{
        setPanel(panel);
    }, []);
    const value = (0, $5uXOq.useMemo)(()=>({
            setPanel: handleSetPanel
        }), [
        handleSetPanel
    ]);
    const Provider = (0, $5uXOq.useMemo)(()=>({ children: children })=>{
            return /*#__PURE__*/ (0, $2OMIu.jsx)(Context.Provider, {
                value: value,
                children: children
            });
        }, [
        Context,
        value
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            Panel: Panel,
            Provider: Provider
        }), [
        Panel,
        Provider
    ]);
}

});

const $4ffa16dc12cfa934$export$bbd08ee543ba8cc3 = 'createStatus';
const $4ffa16dc12cfa934$export$bc1622166baa0162 = 'editStatus';
const $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b = 'manageWorkflow';

parcelRegister("44VbI", function(module, exports) {

$parcel$export(module.exports, "isOnlyGlobalTransitions", () => $d665573e03a66c7e$export$10992041bf7e444a);
$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $d665573e03a66c7e$export$707115549202b9e4);
$parcel$export(module.exports, "getLoopedTransitionsForStatus", () => $d665573e03a66c7e$export$38146914a8d06579);
$parcel$export(module.exports, "transformOptions", () => $d665573e03a66c7e$export$8f4ed8ef83bcbf04);
$parcel$export(module.exports, "getStatusShape", () => $d665573e03a66c7e$export$e2dafe47b17b2cfc);

var $8QpSo = parcelRequire("8QpSo");

var $gULOk = parcelRequire("gULOk");
const $d665573e03a66c7e$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $d665573e03a66c7e$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $d665573e03a66c7e$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $d665573e03a66c7e$var$filterLoopedTransitionsToSelf = (0, $8QpSo.default)((transitions, currentStatusId)=>transitions.filter((transition)=>!$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$d665573e03a66c7e$var$isGlobalSelfTransition(transition, currentStatusId) && !$d665573e03a66c7e$var$isInitialSelfTransition(transition, currentStatusId)));
const $d665573e03a66c7e$export$10992041bf7e444a = (transitions)=>transitions.every((t)=>t.isGlobal);
const $d665573e03a66c7e$export$707115549202b9e4 = (transitions, currentStatusId)=>$d665573e03a66c7e$var$filterLoopedTransitionsToSelf(transitions || [], currentStatusId);
const $d665573e03a66c7e$export$38146914a8d06579 = (0, $8QpSo.default)((transitions, currentStatusId)=>(transitions || []).filter((transition)=>$d665573e03a66c7e$var$isLoopedTransitionToSelf(transition, currentStatusId)));
const $d665573e03a66c7e$var$formatOptions = (options)=>options.map((t)=>({
            label: t.to.name,
            value: t.id,
            transition: t
        }));
const $d665573e03a66c7e$var$memoizedTranformOptions = (0, $8QpSo.default)($d665573e03a66c7e$var$formatOptions);
const $d665573e03a66c7e$export$8f4ed8ef83bcbf04 = (options)=>$d665573e03a66c7e$var$memoizedTranformOptions(options);
const $d665573e03a66c7e$export$e2dafe47b17b2cfc = (id, name, category)=>{
    const statusCategoryId = (0, $gULOk.StatusCategoryIds)[category] || (0, $gULOk.StatusCategoryIds)[(0, $gULOk.StatusCategoryTypes).UNDEFINED];
    return {
        id: id,
        name: name,
        statusCategory: {
            id: statusCategoryId,
            name: name
        }
    };
};

});

parcelRegister("kTnV4", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteStatusView", () => $95d268cd8622d793$export$d907a4132fe8618c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $f5h6d = parcelRequire("f5h6d");

var $3u0c5 = parcelRequire("3u0c5");

var $5p1kJ = parcelRequire("5p1kJ");

var $7C5Su = parcelRequire("7C5Su");

var $e34gT = parcelRequire("e34gT");

var $eG9rp = parcelRequire("eG9rp");

var $6NI23 = parcelRequire("6NI23");

var $1Kt4o = parcelRequire("1Kt4o");

var $fVMIs = parcelRequire("fVMIs");

var $jh7L9 = parcelRequire("jh7L9");

var $d8lE2 = parcelRequire("d8lE2");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");

var $2gCtH = parcelRequire("2gCtH");

var $c6XT1 = parcelRequire("c6XT1");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");

var $dXq4S = parcelRequire("dXq4S");


var $iokLh = parcelRequire("iokLh");

var $99Vn3 = parcelRequire("99Vn3");

var $fBoWB = parcelRequire("fBoWB");
const $95d268cd8622d793$export$d907a4132fe8618c = ({ onFetch: onFetch, wasFetchSuccessful: wasFetchSuccessful, currentStatus: currentStatus, transitions: transitions, renderTransition: renderTransition, onSuccess: onSuccess, onUpdateStatusMutation: onUpdateStatusMutation })=>{
    const issueKey = (0, $2gCtH.useIssueKey)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const subscribeCommands = (0, $fVMIs.useSubscribeCommands)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ expandedCommand: expandedCommand, isOpen: isOpen }, { setChildCommands: setChildCommands }] = (0, $d8lE2.useCommandPaletteExpandedCommand)();
    const renderHeader = (0, $5uXOq.useCallback)((base)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NI23.CommandFieldHeader), {
            ...base,
            issueKey: issueKey
        }), [
        issueKey
    ]);
    const issueAri = (0, $c6XT1.useIssueAri)();
    const { saveStatusField: saveStatusField } = (0, $99Vn3.useSaveStatusField)(issueKey, issueAri, onUpdateStatusMutation);
    const expandedCommandId = expandedCommand?.id;
    const issueId = issueAri && (0, $dXq4S.isAri)(issueAri) && (0, $4R6GH.fg)('one_event_improvements_1') ? (0, $dXq4S.getAriConfig)(issueAri).resourceId : undefined;
    const loadTransitions = (0, $5uXOq.useCallback)(()=>{
        if (!wasFetchSuccessful) return {
            commands: []
        };
        const transitionCommands = transitions.map((transition)=>({
                id: `${0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774}-${transition.id}`,
                name: transition.name,
                components: {
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, renderTransition({
                            transition: transition
                        }, {
                            addTransitionArrowSpacing: true
                        })),
                    LeftIcon: !expandedCommandId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f5h6d))), {
                            spacing: "spacious",
                            label: ""
                        }) : undefined
                },
                keywords: (0, $fBoWB.getTransitionKeywords)(transition),
                primaryAction: {
                    type: (0, $jh7L9.CommandActionType).PERFORM,
                    perform: ()=>{
                        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'issueStatus updated', {
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id,
                            hasScreen: transition.hasScreen,
                            isConditional: transition.isConditional
                        });
                        if ((0, $4R6GH.fg)('one_event_fast_follow_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $5fc53.STATUS_TYPE), {
                            analytics: createAnalyticsEvent({}),
                            attributes: {
                                isCommandPaletteEditing: true,
                                fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STATUS_TYPE],
                                oldValId: currentStatus.id,
                                oldStatusCategoryId: currentStatus.statusCategory.id,
                                newValId: transition.to.id,
                                newStatusCategoryId: transition.to.statusCategory.id,
                                ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                                    issueId: issueId
                                }
                            }
                        });
                        else if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().setAttributes((0, $5fc53.STATUS_TYPE), {
                            isCommandPaletteEditing: true,
                            fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STATUS_TYPE],
                            oldValId: currentStatus.id,
                            oldStatusCategoryId: currentStatus.statusCategory.id,
                            newValId: transition.to.id,
                            newStatusCategoryId: transition.to.statusCategory.id
                        });
                        saveStatusField(transition, ()=>{
                            onSuccess?.(transition.to, false, createAnalyticsEvent({}));
                        });
                    }
                },
                analytics: {
                    action: 'changeStatus',
                    actionCategory: (0, $5p1kJ.COMMAND_PALETTE_ISSUE_ACTIONS)
                }
            }));
        const currentCommand = expandedCommandId ? [
            {
                id: `${(0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)}-${currentStatus.id}-current`,
                name: currentStatus.name,
                components: {
                    LeftIcon: !expandedCommandId ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f5h6d))), {
                            spacing: "spacious",
                            label: formatMessage((0, $iokLh.messages).editStatus)
                        }) : undefined,
                    Name: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$TransitionWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$SelectedStatusContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                            isBold: true
                        }, currentStatus.name)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($95d268cd8622d793$var$CurrentStatusContainer, null, formatMessage((0, $iokLh.messages).current)))
                },
                primaryAction: {
                    type: (0, $jh7L9.CommandActionType).PERFORM,
                    perform: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
                }
            }
        ] : [];
        const commands = [
            ...currentCommand,
            ...transitionCommands
        ];
        return {
            commands: commands
        };
    }, [
        wasFetchSuccessful,
        transitions,
        expandedCommandId,
        currentStatus.id,
        currentStatus.name,
        currentStatus.statusCategory.id,
        renderTransition,
        createAnalyticsEvent,
        saveStatusField,
        issueId,
        onSuccess,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const { commands: commands } = loadTransitions();
        const statusCommand = {
            id: (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774),
            name: formatMessage((0, $iokLh.messages).editStatus),
            shortcut: 'd',
            placeholder: formatMessage((0, $iokLh.messages).searchTransition),
            keywords: getKeywords('changeStatusSynonyms'),
            section: (0, $e34gT.getCommandPaletteIssueActionsHeader)(issueKey),
            priority: (0, $7C5Su.getCommandPaletteIssueActionsPriority)('STATUS'),
            components: {
                LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($f5h6d))), {
                        spacing: "spacious",
                        label: ""
                    })
            },
            primaryAction: {
                type: (0, $jh7L9.CommandActionType).COMMAND_LIST,
                fallback: {
                    onNoResults: {
                        label: formatMessage((0, $iokLh.messages).fallbackNoResults)
                    }
                },
                components: {
                    Header: renderHeader
                },
                commands: commands,
                onClick: (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? ()=>{
                    (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $5fc53.STATUS_TYPE), {
                        analytics: createAnalyticsEvent({}),
                        attributes: {
                            fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STATUS_TYPE],
                            isCommandPaletteEditing: true
                        }
                    });
                } : undefined
            },
            analytics: {
                action: 'changeStatusMenu'
            }
        };
        const unsubscribe = subscribeCommands((0, $1Kt4o.COMMAND_PALETTE_REGISTRY_IDS).STATUS, [
            statusCommand
        ]);
        return ()=>unsubscribe();
    }, [
        formatMessage,
        getKeywords,
        issueKey,
        loadTransitions,
        renderHeader,
        subscribeCommands,
        expandedCommand?.id,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && onFetch) onFetch(createAnalyticsEvent({}));
    }, [
        isOpen,
        onFetch,
        createAnalyticsEvent
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen && expandedCommandId === (0, $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774)) setChildCommands(loadTransitions());
    }, [
        expandedCommandId,
        isOpen,
        loadTransitions,
        setChildCommands
    ]);
    return null;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95d268cd8622d793$var$TransitionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bah1yb4 _18u01b66 _4t3i1tcg _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95d268cd8622d793$var$SelectedStatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $95d268cd8622d793$var$CurrentStatusContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz1gjq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f5h6d", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::6235186728ffd6d81eb5818a45d0cd77>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $afb49639195a4f18$var$_react = $afb49639195a4f18$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $afb49639195a4f18$var$_task = $afb49639195a4f18$var$_interopRequireDefault((parcelRequire("4xPlE")));

var $afb49639195a4f18$var$_task2 = $afb49639195a4f18$var$_interopRequireDefault((parcelRequire("imUQY")));
function $afb49639195a4f18$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for TaskIcon.
 * This component is TaskIcon, with `UNSAFE_fallbackIcon` set to "TaskIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $afb49639195a4f18$var$TaskIcon = (props)=>/*#__PURE__*/ $afb49639195a4f18$var$_react.default.createElement($afb49639195a4f18$var$_task.default, Object.assign({
        LEGACY_fallbackIcon: $afb49639195a4f18$var$_task2.default
    }, props));
$afb49639195a4f18$var$TaskIcon.Name = 'TaskIconMigration';
var $afb49639195a4f18$var$_default = module.exports.default = $afb49639195a4f18$var$TaskIcon;

});
parcelRegister("4xPlE", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::f1fa22b134d342ddb8339c9dc89d7524>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $34f2132ab88342e6$var$_react = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $34f2132ab88342e6$var$_baseNew = $34f2132ab88342e6$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $34f2132ab88342e6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Task".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for tasks in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $34f2132ab88342e6$var$TaskIcon = (props)=>/*#__PURE__*/ $34f2132ab88342e6$var$_react.default.createElement($34f2132ab88342e6$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M1 3a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v10a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2zm2-.5a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5zm9.326 2.98-5 6a.75.75 0 0 1-1.152 0l-2.5-3 1.152-.96L6.75 9.828l4.424-5.308z" clip-rule="evenodd"/>`
    }, props));
$34f2132ab88342e6$var$TaskIcon.displayName = 'TaskIcon';
var $34f2132ab88342e6$var$_default = module.exports.default = $34f2132ab88342e6$var$TaskIcon;

});

parcelRegister("imUQY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d5f661f66d7a7026$var$_react = $d5f661f66d7a7026$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d5f661f66d7a7026$var$_task = $d5f661f66d7a7026$var$_interopRequireDefault((parcelRequire("4xPlE")));
function $d5f661f66d7a7026$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d5f661f66d7a7026$var$TaskIcon = (props)=>/*#__PURE__*/ $d5f661f66d7a7026$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M3 3.993C3 3.445 3.445 3 3.993 3h16.014c.548 0 .993.445.993.993v16.014a.994.994 0 0 1-.993.993H3.993A.994.994 0 0 1 3 20.007zM5 5v14h14V5z"/><path fill-rule="nonzero" d="M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586z"/></g></svg>`
    }, props, {
        newIcon: $d5f661f66d7a7026$var$_task.default
    }));
$d5f661f66d7a7026$var$TaskIcon.displayName = 'TaskIcon';
var $d5f661f66d7a7026$var$_default = module.exports.default = $d5f661f66d7a7026$var$TaskIcon;

});


parcelRegister("7C5Su", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsPriority", () => $235d212bb3595e05$export$5164bb42fa883371);
const $235d212bb3595e05$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY = {
    STATUS: 10,
    SUMMARY: 20,
    PARENT: 30,
    LINK_ISSUE: 40,
    CONTENT_FIRST_TAB: 50,
    PINNED_FIELDS: 60,
    DETAILS: 70,
    CONTENT_OTHER_TABS: 80,
    MORE_FIELDS: 90,
    OLD_ISSUE_FIELDS: 95,
    ADD_COMMENT: 100,
    GQL_FIELDS: 105,
    SUB_HEADER_ITEMS: 110,
    ISSUE_HEADER_ITEMS: 120
};
const $235d212bb3595e05$export$5164bb42fa883371 = (key)=>$235d212bb3595e05$var$COMMAND_PALETTE_ISSUE_ACTIONS_PRIORITY[key];

});

parcelRegister("e34gT", function(module, exports) {

$parcel$export(module.exports, "getCommandPaletteIssueActionsHeader", () => $4ea99408c4a58cd0$export$cd9931655a8cfb04);

var $5p1kJ = parcelRequire("5p1kJ");
const $4ea99408c4a58cd0$export$cd9931655a8cfb04 = (issueKey)=>`${0, $5p1kJ.COMMAND_PALETTE_ISSUE_ACTIONS}-${issueKey || ''}`;

});

parcelRegister("6NI23", function(module, exports) {

$parcel$export(module.exports, "CommandFieldHeader", () => $aaa7a329c29139ae$export$c6444eb1c6f44b2d);

var $5uXOq = parcelRequire("5uXOq");

var $luBm6 = parcelRequire("luBm6");

var $jiSaf = parcelRequire("jiSaf");

var $2w83X = parcelRequire("2w83X");
const $aaa7a329c29139ae$export$c6444eb1c6f44b2d = ({ children: children, issueKey: issueKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiSaf.components).Header, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2w83X.IssueTag), {
        issueKey: issueKey
    }), children));

});
parcelRegister("jiSaf", function(module, exports) {

$parcel$export(module.exports, "components", () => $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296);

var $5uXOq = parcelRequire("5uXOq");

var $dOktC = parcelRequire("dOktC");

var $haBRL = parcelRequire("haBRL");

var $dE25F = parcelRequire("dE25F");

var $d4iCz = parcelRequire("d4iCz");
const $44cb4d9bf5d8b8a6$var$NameComponent = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $44cb4d9bf5d8b8a6$export$9b5ac10f59f76296 = {
    CommandRow: $haBRL.CommandRow,
    Name: $44cb4d9bf5d8b8a6$var$NameComponent,
    LeftIcon: (0, $5uXOq.Fragment),
    Wrapper: (0, $5uXOq.Fragment),
    Footer: $dE25F.Footer,
    Body: (0, $dOktC.CommandPaletteBody),
    Header: $d4iCz.Header
};

});
parcelRegister("dOktC", function(module, exports) {

$parcel$export(module.exports, "NoResultsContainer", () => $2bc4c9970ded9a96$export$2ab569a6937cb4e4);
$parcel$export(module.exports, "CommandPaletteBody", () => $2bc4c9970ded9a96$export$b1023de69a8756e6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $d8lE2 = parcelRequire("d8lE2");

var $gM5ou = parcelRequire("gM5ou");

var $bYCTm = parcelRequire("bYCTm");

var $38IFv = parcelRequire("38IFv");

var $cLshs = parcelRequire("cLshs");

var $4nfzy = parcelRequire("4nfzy");

var $eKTyH = parcelRequire("eKTyH");

var $5aF2z = parcelRequire("5aF2z");

var $64ZBB = parcelRequire("64ZBB");
const $2bc4c9970ded9a96$var$CommandPaletteChildren = ({ results: results, noResultsFallback: noResultsFallback, renderAfterCommands: renderAfterCommands, resultsRefs: resultsRefs })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ isSearchFieldFocused: isSearchFieldFocused, loadingList: loadingList, registry: registry, activeRegistry: activeRegistry }, { setActiveIndex: setActiveIndex, removeCommandsById: removeCommandsById, executeCommand: executeCommand }] = (0, $d8lE2.useCommandPalette)();
    const onHoverCommand = (index)=>{
        if (index === undefined) return;
        setActiveIndex(index);
    };
    const onMouseDownCommand = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
    }, []);
    const onClickCommand = (0, $5uXOq.useCallback)((event, result)=>{
        executeCommand(result.command, {
            method: 'mouse',
            createAnalyticsEvent: createAnalyticsEvent,
            attributes: {
                ...(0, $gM5ou.getAnalyticsAttributesFromResult)(result),
                ...(0, $gM5ou.getRegistryData)(registry, activeRegistry, result?.command.id)
            }
        }, (0, $gM5ou.isSecondaryTrigger)(event));
    }, [
        activeRegistry,
        createAnalyticsEvent,
        executeCommand,
        registry
    ]);
    const localResultRefs = resultsRefs.current;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !loadingList && noResultsFallback && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$export$2ab569a6937cb4e4, {
        "data-testid": (0, $5aF2z.NO_RESULTS_TEST_ID)
    }, noResultsFallback), results.map((result, index)=>{
        if (result.isGroup) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYCTm.CommandPaletteSearchResultGroupItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            group: result.group,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$GroupContainerComponent, {
            ...(0, $4R6GH.fg)('jfp-a11y-autodev-command-pallete-group-heading') && {
                as: 'h2'
            },
            "data-testid": (0, $5aF2z.GROUP_TEST_ID),
            isFirstResult: index === 0
        }, result.renderGroup ? result.renderGroup() : result.group));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4nfzy.CommandRowErrorBoundary), {
            key: index,
            teamName: typeof registry?.teamName === 'string' ? registry.teamName : 'deliveroo',
            onError: ()=>removeCommandsById([
                    result.command.id
                ]),
            attributes: (0, $gM5ou.getRegistryData)(registry, activeRegistry, result?.command.id)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38IFv.CommandPaletteSearchResultListItem), {
            ref: (commandRef)=>{
                if (commandRef) localResultRefs[index] = commandRef;
            },
            id: result.command.id,
            active: result.active,
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eKTyH.CommandRow), {
            index: index,
            isSearchFieldFocused: isSearchFieldFocused,
            result: result,
            onHoverCommand: (ev)=>{
                // Safari is weird and likes to fire mouseover events when the mouse is not moving
                if (ev.movementX === 0 && ev.movementY === 0) return;
                onHoverCommand(result.index);
            },
            onClickCommand: (event)=>onClickCommand(event, result),
            onMouseDownCommand: onMouseDownCommand
        })));
    }), renderAfterCommands?.({}));
};
const $2bc4c9970ded9a96$export$b1023de69a8756e6 = ({ results: results, total: total, fallback: fallback, renderAfterCommands: renderAfterCommands })=>{
    const [{ activeIndex: activeIndex, isSearchFieldFocused: isSearchFieldFocused, expandedCommand: expandedCommand, search: search }, { setActiveIndex: setActiveIndex }] = (0, $d8lE2.useCommandPalette)();
    const [prevActiveIndex, setPrevActiveIndex] = (0, $5uXOq.useState)(activeIndex);
    const resultsRefs = (0, $5uXOq.useRef)([]);
    const modalBodyRef = (0, $5uXOq.useRef)(null);
    const onArrowScroll = (0, $5uXOq.useCallback)((newActiveIndex)=>{
        setActiveIndex(newActiveIndex);
    }, [
        setActiveIndex
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!modalBodyRef.current || prevActiveIndex === activeIndex) return;
        setPrevActiveIndex(activeIndex);
        const scrollTo = activeIndex > prevActiveIndex ? (0, $5aF2z.SCROLL_DIRECTION).END : (0, $5aF2z.SCROLL_DIRECTION).START;
        const scrollToIndex = (0, $64ZBB.getScrollToIndex)(results, activeIndex, scrollTo);
        const scrolledToResult = resultsRefs.current[scrollToIndex];
        if (scrolledToResult && !(0, $64ZBB.isElementVisibleInContainer)(scrolledToResult, modalBodyRef.current)) {
            const lastIndex = results.length - 1;
            const firstIndex = results.findIndex((result)=>!result.isGroup);
            if (lastIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, modalBodyRef.current.scrollHeight);
            else if (firstIndex === scrollToIndex) modalBodyRef.current.scrollTo(0, 0);
            else (0, $64ZBB.scrollResultIntoView)({
                target: scrolledToResult,
                direction: scrollTo,
                scrollContainer: modalBodyRef.current
            });
        }
    }, [
        activeIndex,
        prevActiveIndex,
        results
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!modalBodyRef.current?.scrollTo) return;
        modalBodyRef.current.scrollTo(0, 0);
    }, [
        expandedCommand,
        search
    ]);
    (0, $5uXOq.useEffect)(()=>{
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        if (!isSearchFieldFocused) return ()=>{};
        const handleArrowScroll = (ev)=>{
            if (ev.key === 'ArrowUp') {
                ev.preventDefault();
                activeIndex > 0 && onArrowScroll(activeIndex - 1);
            }
            if (ev.key === 'ArrowDown') {
                ev.preventDefault();
                activeIndex < total - 1 && onArrowScroll(activeIndex + 1);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('keydown', handleArrowScroll);
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('keydown', handleArrowScroll);
        };
    }, [
        isSearchFieldFocused,
        total,
        activeIndex,
        setActiveIndex,
        onArrowScroll
    ]);
    const noResultsFallback = (0, $5uXOq.useMemo)(()=>fallback?.onNoResults?.renderLabel?.() || fallback?.onNoResults?.label, [
        fallback
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cLshs.CommandPaletteSearchResultListWrapper), {
        ref: modalBodyRef,
        noResultsFallback: noResultsFallback
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2bc4c9970ded9a96$var$CommandPaletteChildren, {
        results: results,
        noResultsFallback: noResultsFallback,
        renderAfterCommands: renderAfterCommands,
        resultsRefs: resultsRefs
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2bc4c9970ded9a96$var$GroupContainerComponent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFirstResult: isFirstResult, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_h2xaw7": (0, $lD23V.default)(`${__cmplp.isFirstResult ? "var(--ds-space-100, 8px)" : "var(--ds-space-150, 12px)"} ${"var(--ds-space-300, 24px)"} 0 ${"var(--ds-space-300, 24px)"}`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1yt41f6d _syaz131l",
            __cmplp.className
        ])
    });
});
const $2bc4c9970ded9a96$export$2ab569a6937cb4e4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _syaz131l _ca0qxy5q _u5f3pxbi _n3tdxy5q _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bYCTm", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultGroupItem", () => $85a6ab23a77e1ea6$export$591c26128e5fd757);

var $5uXOq = parcelRequire("5uXOq");

const $85a6ab23a77e1ea6$export$591c26128e5fd757 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ group: group, ...rest }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
        id: group ? `${0, $2350562822a34d03$export$9ed1834ff36a8f29}-${group}` : undefined,
        ...rest
    }));

});
const $2350562822a34d03$export$9ffb4923f81813d9 = 'compal-menu';
const $2350562822a34d03$export$b28d6b416aaf953a = `${$2350562822a34d03$export$9ffb4923f81813d9}-item`;
const $2350562822a34d03$export$9ed1834ff36a8f29 = `${$2350562822a34d03$export$9ffb4923f81813d9}-group`;
const $2350562822a34d03$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $2350562822a34d03$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $2350562822a34d03$export$d3cd230e107fbce = 'command-palette.ui.modal.header.search-input';
const $2350562822a34d03$export$9e40a0642460a944 = 'compal-menu-screen-reader';


parcelRegister("38IFv", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListItem", () => $9082b0edc4f10018$export$1f8fa9d1eef77b32);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");


var $9gNeg = parcelRequire("9gNeg");
const $9082b0edc4f10018$export$1f8fa9d1eef77b32 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ id: id, active: active, ...rest }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: ref,
        "data-testid": (0, $2350562822a34d03$export$617744f059bfc3ba),
        "aria-current": active,
        role: "menuitem",
        id: `${(0, $2350562822a34d03$export$b28d6b416aaf953a)}-${id}`,
        ...(0, $4R6GH.fg)('a11y_enghealth_fixes_deliveroo') && {
            'aria-label': formatMessage((0, $9gNeg.messages).resultListItemAriaLabel)
        },
        ...rest
    });
});

});
parcelRegister("9gNeg", function(module, exports) {

$parcel$export(module.exports, "messages", () => $37963fcec28f3d0a$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $37963fcec28f3d0a$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    resultListItemAriaLabel: {
        "id": "command-palette.common.command-palette-search-result-list-item",
        "defaultMessage": "Command palette action item"
    }
});

});


parcelRegister("cLshs", function(module, exports) {

$parcel$export(module.exports, "CommandPaletteSearchResultListWrapper", () => $42c35fc284860d36$export$95554f6fb39a83c2);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");


var $zfug2 = parcelRequire("zfug2");

var $6LGvc = parcelRequire("6LGvc");
const $42c35fc284860d36$export$95554f6fb39a83c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ noResultsFallback: noResultsFallback, children: children, ...props }, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const resizerRef = (0, $5uXOq.useRef)(null);
    const height = (0, $6LGvc.useSmoothExpand)(resizerRef);
    (0, $5uXOq.useEffect)(()=>{
        if (ref && 'current' in ref && ref.current) {
            const currentRef = ref.current;
            currentRef.style.height = `${height}px`;
        }
    }, [
        height,
        ref
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $42c35fc284860d36$var$wrapperStyles,
        testId: (0, $2350562822a34d03$export$85eefac753ab5bdb),
        id: (0, $2350562822a34d03$export$9ffb4923f81813d9),
        role: noResultsFallback ? 'group' : 'menu',
        ref: ref,
        "aria-label": formatMessage((0, $zfug2.messages).commandPaletteSearchResultListBoxLabel),
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        ref: resizerRef,
        direction: "column",
        gap: "space.050"
    }, children));
});
const $42c35fc284860d36$var$wrapperStyles = (0, $8CUq3.xcss)({
    padding: '0',
    paddingTop: 'space.100',
    paddingBottom: 'space.100',
    transition: 'height 0.15s ease-out',
    overflowY: 'auto',
    maxHeight: '376px'
});

});
parcelRegister("zfug2", function(module, exports) {

$parcel$export(module.exports, "messages", () => $2745ea1cb0c1a200$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $2745ea1cb0c1a200$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    commandPaletteSearchResultListBoxLabel: {
        "id": "command-palette.common.command-palette-search-dropdown.command-palette-search-result-list-wrapper.command-palette-search-result-list-box-label",
        "defaultMessage": "List of commands"
    }
});

});

parcelRegister("6LGvc", function(module, exports) {

$parcel$export(module.exports, "useSmoothExpand", () => $38452c6bcba6455a$export$674ba8b02d2bfe86);

var $5uXOq = parcelRequire("5uXOq");
const $38452c6bcba6455a$var$MAX_HEIGHT = 376;
const $38452c6bcba6455a$var$STARTING_HEIGHT = 56;
const $38452c6bcba6455a$var$ADDITIONAL_HEIGHT = 16;
const $38452c6bcba6455a$export$674ba8b02d2bfe86 = (content)=>{
    const [height, setHeight] = (0, $5uXOq.useState)($38452c6bcba6455a$var$STARTING_HEIGHT);
    const callback = (0, $5uXOq.useCallback)(()=>{
        const contentClientHeight = content.current?.clientHeight;
        if (!contentClientHeight) return;
        if (contentClientHeight > $38452c6bcba6455a$var$MAX_HEIGHT) setHeight($38452c6bcba6455a$var$MAX_HEIGHT);
        else setHeight(contentClientHeight + $38452c6bcba6455a$var$ADDITIONAL_HEIGHT);
    }, [
        content
    ]);
    (0, $5uXOq.useEffect)(()=>{
        let resizeObserver;
        if (content.current && typeof ResizeObserver !== 'undefined') {
            resizeObserver = new ResizeObserver(callback);
            resizeObserver.observe(content.current);
        }
        return ()=>{
            if (resizeObserver) resizeObserver.disconnect();
        };
    }, [
        callback,
        content
    ]);
    return height;
};

});


parcelRegister("4nfzy", function(module, exports) {

$parcel$export(module.exports, "CommandRowErrorBoundary", () => $53a0c321a39d3b85$export$223f3c3c93a14a83);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");
const $53a0c321a39d3b85$export$223f3c3c93a14a83 = ({ children: children, teamName: teamName, onError: onError, attributes: attributes })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "command-palette-row",
        packageName: "jiraCommandPalette",
        fallback: "unmount",
        teamName: teamName,
        onError: onError,
        attributes: attributes
    }, children);

});

parcelRegister("eKTyH", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $9e51067b4d29f53f$export$3ef5d254c3c573e3);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");

var $haBRL = parcelRequire("haBRL");
const $9e51067b4d29f53f$export$3ef5d254c3c573e3 = ({ index: index, result: result, isSearchFieldFocused: isSearchFieldFocused, onHoverCommand: onHoverCommand, onClickCommand: onClickCommand, onMouseDownCommand: onMouseDownCommand })=>{
    const { command: command } = result;
    const isActive = !!(result.active && isSearchFieldFocused);
    const isFirstCommand = result.index === 0;
    const rowProps = {
        index: index,
        isActive: isActive,
        command: command,
        isFirstCommand: isFirstCommand,
        onMouseMove: onHoverCommand,
        onClick: onClickCommand,
        onMouseDown: onMouseDownCommand,
        analyticsAttributes: (0, $gM5ou.getAnalyticsAttributesFromResult)(result)
    };
    if (command.components?.CommandRow) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.CommandRow, rowProps);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $haBRL.CommandRow), rowProps);
};

});
parcelRegister("haBRL", function(module, exports) {

$parcel$export(module.exports, "CommandRow", () => $04586313afa284d7$export$3ef5d254c3c573e3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $dzeHJ = parcelRequire("dzeHJ");


var $3m7XM = parcelRequire("3m7XM");

var $3sBlN = parcelRequire("3sBlN");
const $04586313afa284d7$export$3ef5d254c3c573e3 = ({ index: index, command: command, isActive: isActive, isFirstCommand: isFirstCommand, analyticsAttributes: analyticsAttributes, ...rest })=>{
    const InnerContainer = $04586313afa284d7$var$CommandContainerInner;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainerWrapper, {
        "data-testid": command.id
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandContainer, {
        index: index,
        active: isActive,
        "data-active": isActive,
        "data-testid": (0, $593123af132e266c$export$b0017db5728101cc)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(InnerContainer, {
        "data-testid": (0, $593123af132e266c$export$47c379a40b00a339),
        ...rest
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconAndNameContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandIconsContainer, {
        "data-testid": (0, $593123af132e266c$export$d6dd1cf63aae711c)
    }, command.components?.LeftIcon && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        testId: (0, $593123af132e266c$export$7b41978523c7dd4a),
        alignItems: "center",
        justifyContent: "center",
        xcss: [
            $04586313afa284d7$var$iconStyles,
            isActive && $04586313afa284d7$var$iconActiveStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04586313afa284d7$var$CommandLeftIconContainer, {
        "data-testid": (0, $593123af132e266c$export$7b41978523c7dd4a),
        active: isActive
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.LeftIcon, null))), command.mode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dzeHJ.OutlinedLozenge), {
        "data-testid": (0, $593123af132e266c$export$72c5368f559dd523)
    }, command.mode)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3m7XM.RenderCommandName), {
        command: command,
        isActive: isActive
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3sBlN.RightContent), {
        command: command,
        isFirstCommand: isFirstCommand,
        isActive: isActive
    }))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04586313afa284d7$var$CommandContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _syaz1gjq _ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            !!__cmplp.active && "_syaz1fxt _bfhkfg4m _kqswh2mm _1kt9b3bt _1cs8stnw _1aukidpf _qnecidpf _19woidpf _1mp4v77o _1rus1p6i",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandContainerInner = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3v47k _n3td1b66 _19bvv47k _1e0c1txw _4cvr1h6o _80omtlke _lcxv1wug",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandIconsContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _2hwx1b66 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$iconStyles = (0, $8CUq3.xcss)({
    width: '24px',
    height: '24px',
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration, but requires bigger change in types.
    color: 'color.icon.subtle'
});
const $04586313afa284d7$var$iconActiveStyles = (0, $8CUq3.xcss)({
    // @ts-expect-error ts(2322) - this color should be set directly within icon after migration.
    color: 'color.icon'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04586313afa284d7$var$CommandLeftIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bsb1tcg _4t3i1tcg _vwz41tcg _1bah1h6o _1wpz1y6m _1f027vkz _nbgx7vkz",
            __cmplp.active ? "_syazwdcn" : "_syaz1oju",
            __cmplp.className
        ])
    });
});
const $04586313afa284d7$var$CommandLeftIconAndNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1txw _2lx2vrvc _vwz41tcg",
            __cmplp.className
        ])
    });
});

});
const $593123af132e266c$export$b0017db5728101cc = 'command-palette.ui.modal.body.command-container';
const $593123af132e266c$export$47c379a40b00a339 = 'command-palette.common.ui.command-palette-row-view.inner-container';
const $593123af132e266c$export$7b41978523c7dd4a = 'command-palette.ui.modal.body.command-left-icon-container';
const $593123af132e266c$export$72c5368f559dd523 = 'command-palette.ui.modal.body.command-mode';
const $593123af132e266c$export$d6dd1cf63aae711c = 'command-palette.ui.modal.body.command-icon-container';

parcelRegister("3m7XM", function(module, exports) {

$parcel$export(module.exports, "RenderCommandName", () => $c1bc24527d77cdc3$export$931d3f1d35f6c058);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hWZau = parcelRequire("hWZau");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $dCm1o = parcelRequire("dCm1o");

var $gGkxR = parcelRequire("gGkxR");

const $c1bc24527d77cdc3$export$931d3f1d35f6c058 = ({ command: command, isActive: isActive })=>{
    const renderCommandName = (0, $5uXOq.useCallback)(()=>{
        if (command.components?.Name) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(command.components.Name, {
            isActive: isActive
        }, command.name);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gGkxR.TruncateWithTooltipOnActive), {
            isActive: isActive
        }, command.name);
    }, [
        command,
        isActive
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandNameContainer, {
        "data-testid": (0, $c5fb72cffbe58dfe$export$1858c2a91b8b53ba),
        active: isActive
    }, command.breadcrumb?.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbContainer, {
        "data-testid": (0, $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3)
    }, command.breadcrumb.map((BreadCrumb, index, arr)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, {
            key: index
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandBreadcrumbItem, {
            isParent: index !== arr.length - 1,
            "data-testid": (0, $c5fb72cffbe58dfe$export$fb5462105b23e3e5),
            active: isActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BreadCrumb, {
            isActive: isActive
        })), index !== arr.length - 1 && ((0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            justifyContent: "center",
            xcss: $c1bc24527d77cdc3$var$iconWrapperStyles,
            alignItems: "center",
            testId: (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
            color: "currentColor",
            label: "separator"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c1bc24527d77cdc3$var$CommandChevronContainer, {
            "data-testid": (0, $c5fb72cffbe58dfe$export$4675b4d60d9881d4)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
            color: "currentColor",
            label: "separator"
        })))))) : renderCommandName());
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c1bc24527d77cdc3$var$CommandNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.active ? "_syaz1fxt" : "_syaz1gjq",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandBreadcrumbContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandBreadcrumbItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isParent: isParent, active: active, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_16eko3h": (0, $lD23V.default)(__cmplp.active ? "var(--ds-text-subtle, #44546F)" : "var(--ds-text-subtlest, #626F86)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !!__cmplp.isParent && "_syazeu41",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$CommandChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4kb7n _syaz1oju",
            __cmplp.className
        ])
    });
});
const $c1bc24527d77cdc3$var$iconWrapperStyles = (0, $8CUq3.xcss)({
    height: '24px',
    width: '24px'
});

});
parcelRegister("gGkxR", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnActive", () => $e999625ec19f201d$export$4495aca3d261add0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k5uoT = parcelRequire("k5uoT");

var $jgJNO = parcelRequire("jgJNO");

var $jgArx = parcelRequire("jgArx");


var $k7xca = parcelRequire("k7xca");
const $e999625ec19f201d$var$TooltipRenderer = ({ children: children, shouldShowTooltip: shouldShowTooltip })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: !!shouldShowTooltip,
        autoFocus: false,
        placement: "bottom-end",
        messageId: "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.popup",
        messageType: "transactional",
        popupComponent: (0, $jgArx.PopupComponent),
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.tooltip-content"
            }, children),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TriggerComponent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-active.trigger-component",
                ...triggerProps
            }),
        zIndex: (0, $k5uoT.layers).tooltip()
    });
const $e999625ec19f201d$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
const $e999625ec19f201d$export$4495aca3d261add0 = ({ children: children, isActive: isActive, customTooltip: customTooltip, showTooltip: showTooltip, preventTruncate: preventTruncate })=>{
    const containerRef = $e999625ec19f201d$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $k7xca.useTruncatedTooltip)({
        containerRef: containerRef,
        tooltipDelay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: containerRef,
        xcss: [
            $e999625ec19f201d$var$tooltipContainerStyles,
            !preventTruncate && $e999625ec19f201d$var$truncateTooltipStyles
        ]
    }, children), isActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e999625ec19f201d$var$TooltipRenderer, {
        shouldShowTooltip: showTooltip || shouldShowTruncatedTooltip
    }, showTooltip && customTooltip ? customTooltip : children));
};
const $e999625ec19f201d$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    flexGrow: 1,
    textTransform: 'none'
});
const $e999625ec19f201d$var$truncateTooltipStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("jgArx", function(module, exports) {

$parcel$export(module.exports, "TooltipComponent", () => $3c6ba86682bb18eb$export$e18e2f8e82cdc428);
$parcel$export(module.exports, "TriggerComponent", () => $3c6ba86682bb18eb$export$534fc570264a52a4);
$parcel$export(module.exports, "TooltipTrigger", () => $3c6ba86682bb18eb$export$8c610744efcf8a1d);
$parcel$export(module.exports, "PopupComponent", () => $3c6ba86682bb18eb$export$9fac2d040f3ed438);
$parcel$export(module.exports, "TruncateWithTooltipContainer", () => $3c6ba86682bb18eb$export$8cae238d61c8405a);
$parcel$export(module.exports, "TooltipContent", () => $3c6ba86682bb18eb$export$e9003e2be37ec060);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $btzsC = parcelRequire("btzsC");

var $koVbs = parcelRequire("koVbs");

var $6nFD4 = parcelRequire("6nFD4");
const $3c6ba86682bb18eb$export$e18e2f8e82cdc428 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledTooltipPrimitive, {
        ...props,
        ref: ref
    }));
const $3c6ba86682bb18eb$export$534fc570264a52a4 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$export$8c610744efcf8a1d, {
        ...props,
        role: "button",
        ref: ref,
        "aria-label": formatMessage((0, $6nFD4.messages).tooltipTriggerAriaLabel)
    });
});
const $3c6ba86682bb18eb$export$9fac2d040f3ed438 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, ...props }, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3c6ba86682bb18eb$var$StyledPopupPrimitive, {
        ...props,
        ref: ref
    }, children)); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c6ba86682bb18eb$var$StyledTooltipPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $btzsC.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3c6ba86682bb18eb$var$StyledPopupPrimitive = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbydx66 _1bsbp3fh _ca0qv77o _u5f312x7 _n3tdv77o _19bv12x7 _bfhk1j9a _16qs1cd0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$8cae238d61c8405a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _kqswh2mm _o5721q9c _1bto1l2s _1p1dglyw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$e9003e2be37ec060 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1fxt",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $3c6ba86682bb18eb$export$8c610744efcf8a1d = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6nFD4", function(module, exports) {

$parcel$export(module.exports, "messages", () => $87d1d47436abe24f$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $87d1d47436abe24f$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    tooltipTriggerAriaLabel: {
        "id": "command-palette.common.truncate-with-tooltip.components.tooltip-trigger-aria-label",
        "defaultMessage": "Command palette tool tip"
    }
});

});


const $40fe2afec35c84b7$export$f9e3e7ede9ba929d = 400;

parcelRegister("k7xca", function(module, exports) {

$parcel$export(module.exports, "useTruncatedTooltip", () => $ad951546dfa9fa2c$export$94b118b3187f12c);

var $5uXOq = parcelRequire("5uXOq");

var $gM5ou = parcelRequire("gM5ou");
const $ad951546dfa9fa2c$export$22c0312879c61300 = ()=>(0, $5uXOq.useState)(false);
const $ad951546dfa9fa2c$export$1ac6e474a0163418 = ()=>(0, $5uXOq.useState)(false);
const $ad951546dfa9fa2c$export$94b118b3187f12c = ({ containerRef: containerRef, tooltipDelay: tooltipDelay })=>{
    const [shouldShowTruncatedTooltip, setShouldShowTruncatedTooltip] = $ad951546dfa9fa2c$export$22c0312879c61300();
    const [isTruncated, setIsTruncated] = $ad951546dfa9fa2c$export$1ac6e474a0163418();
    const { setTimeoutAutoClear: setTimeoutAutoClear } = (0, $gM5ou.useSetTimeoutAutoClear)();
    const setTimeoutFunc = setTimeoutAutoClear;
    (0, $5uXOq.useEffect)(()=>{
        const container = containerRef.current;
        if (!container) return;
        if (container.offsetWidth < container.scrollWidth) setIsTruncated(true);
        else setIsTruncated(false);
    }, [
        setIsTruncated,
        containerRef
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isTruncated && tooltipDelay === 0) {
            setShouldShowTruncatedTooltip(true);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        if (isTruncated && tooltipDelay > 0) {
            setTimeoutFunc(()=>setShouldShowTruncatedTooltip(true), tooltipDelay);
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            return ()=>{};
        }
        setShouldShowTruncatedTooltip(false);
        // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
    }, [
        isTruncated,
        setShouldShowTruncatedTooltip,
        tooltipDelay,
        setTimeoutFunc
    ]);
    return {
        shouldShowTruncatedTooltip: shouldShowTruncatedTooltip
    };
};

});


const $c5fb72cffbe58dfe$export$1858c2a91b8b53ba = 'command-palette.ui.modal.body.command-name-container';
const $c5fb72cffbe58dfe$export$5e3a644e2bbe06f3 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-container';
const $c5fb72cffbe58dfe$export$fb5462105b23e3e5 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.breadcrumb-item';
const $c5fb72cffbe58dfe$export$4675b4d60d9881d4 = 'command-palette.ui.modal.modal-content.body.command-row.render-command-name.separator';


parcelRegister("3sBlN", function(module, exports) {

$parcel$export(module.exports, "RightContent", () => $a83ca30f957fd273$export$11dbab4b39f15d6b);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6s76W = parcelRequire("6s76W");

var $koVbs = parcelRequire("koVbs");

var $gM5ou = parcelRequire("gM5ou");


var $iLhkq = parcelRequire("iLhkq");

var $dSJBv = parcelRequire("dSJBv");

var $kbnU6 = parcelRequire("kbnU6");

var $lHtdH = parcelRequire("lHtdH");
const $a83ca30f957fd273$export$11dbab4b39f15d6b = ({ command: command, isActive: isActive, isFirstCommand: isFirstCommand = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const transitionStep = (0, $lHtdH.useHoverTransitionStep)(command, isActive, isFirstCommand);
    const commandHasChildren = (0, $5uXOq.useMemo)(()=>(0, $gM5ou.hasChildren)(command), [
        command
    ]);
    const shouldRenderRightContent = commandHasChildren || !!command.shortcut;
    if (!shouldRenderRightContent) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$RightContentWrapper, null, commandHasChildren && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$CommandRightChevronContainer, {
        "data-testid": (0, $0296d551a7f83620$export$e3e144c17be58a44),
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6s76W))), {
        spacing: "spacious",
        label: formatMessage((0, $iLhkq.messages).rightChevronLabel)
    })), !!command.shortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a83ca30f957fd273$var$ShortcutContainer, {
        "data-testid": (0, $0296d551a7f83620$export$f3036e9d26f81cd9),
        shouldHaveTransition: commandHasChildren,
        transitionStep: transitionStep
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dSJBv.Shortcuts), {
        shortcut: command.shortcut
    })));
};
const $a83ca30f957fd273$var$animationFadeIn = null;
const $a83ca30f957fd273$var$animationFadeOut = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$RightContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1e0c11p5 _18u01b66 _syaz1gjq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$CommandRightChevronContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _yyhykb7n _4cvr1h6o _1e0c1txw _1bsb1tcg _4t3i1tcg _5sag1ttt _1pgl1ytf _1o51q7pw _tzy4idpf _syaz1oju",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "_j7hq1wwu",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a83ca30f957fd273$var$ShortcutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldHaveTransition: shouldHaveTransition, transitionStep: transitionStep, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ii7kb7n _yyhykb7n _5sag1ttt _1pgl1ytf _1o51q7pw _1e0c1txw _1bahesu3",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT && "_j7hq1wwu",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "",
            __cmplp.shouldHaveTransition && __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).TRANSITIONING && "_j7hq1sbx",
            (__cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).FINISHED || __cmplp.transitionStep === (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT) && "_tzy4idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6s76W", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::dc9d13c7d9aac3b58cfed9b747dada0b>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b2adfad98efb792$var$_react = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $4b2adfad98efb792$var$_chevronRight = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("3dGN0")));

var $4b2adfad98efb792$var$_chevronRightLarge = $4b2adfad98efb792$var$_interopRequireDefault((parcelRequire("h1toL")));
function $4b2adfad98efb792$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronRightIcon.
 * This component is ChevronRightIcon, with `UNSAFE_fallbackIcon` set to "ChevronRightLargeIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for menu fly outs and to indicate next in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $4b2adfad98efb792$var$ChevronRightIcon = (props)=>/*#__PURE__*/ $4b2adfad98efb792$var$_react.default.createElement($4b2adfad98efb792$var$_chevronRight.default, Object.assign({
        LEGACY_fallbackIcon: $4b2adfad98efb792$var$_chevronRightLarge.default
    }, props));
$4b2adfad98efb792$var$ChevronRightIcon.Name = 'ChevronRightIconMigration';
var $4b2adfad98efb792$var$_default = module.exports.default = $4b2adfad98efb792$var$ChevronRightIcon;

});
parcelRegister("h1toL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c6495598d3d7027d$var$_react = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c6495598d3d7027d$var$_chevronRight = $c6495598d3d7027d$var$_interopRequireDefault((parcelRequire("bpC55")));
function $c6495598d3d7027d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c6495598d3d7027d$var$ChevronRightLargeIcon = (props)=>/*#__PURE__*/ $c6495598d3d7027d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M14.995 10.995a1 1 0 0 1 0 1.414l-4.593 4.593a.99.99 0 0 1-1.4-1.4l3.9-3.9-3.9-3.9a.99.99 0 0 1 1.4-1.4z"/></svg>`
    }, props, {
        newIcon: $c6495598d3d7027d$var$_chevronRight.default
    }));
$c6495598d3d7027d$var$ChevronRightLargeIcon.displayName = 'ChevronRightLargeIcon';
var $c6495598d3d7027d$var$_default = module.exports.default = $c6495598d3d7027d$var$ChevronRightLargeIcon;

});


const $0296d551a7f83620$export$f3036e9d26f81cd9 = 'command-palette.ui.modal.body.command-shortcut-container';
const $0296d551a7f83620$export$e3e144c17be58a44 = 'command-palette.ui.modal.body.command-chevron-container';

parcelRegister("iLhkq", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bf35cee6e1d1204b$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bf35cee6e1d1204b$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    rightChevronLabel: {
        "id": "command-palette.common.components.command-row.right-content.right-chevron-label",
        "defaultMessage": "Command with children icon"
    }
});

});

parcelRegister("dSJBv", function(module, exports) {

$parcel$export(module.exports, "Shortcuts", () => $57e6d30b2626ce39$export$b326d77e4b8b7664);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $bcTvL = parcelRequire("bcTvL");

var $gM5ou = parcelRequire("gM5ou");


var $esPgL = parcelRequire("esPgL");
const $57e6d30b2626ce39$var$KeyElement = ({ shortcut: shortcut })=>{
    const isLongText = shortcut && shortcut.length > 1;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $57e6d30b2626ce39$var$styles.shortcutKeyWrapper
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testid": (0, $5ecbf01f9da59a15$export$cd62afa4691c297),
        className: (0, $bwpsq.default)([
            $57e6d30b2626ce39$var$styles.lozenge,
            isLongText && $57e6d30b2626ce39$var$styles.longLozenge
        ])
    }, shortcut));
};
const $57e6d30b2626ce39$var$DivisorElement = ({ divisor: divisor })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutDivider, {
        "data-testid": (0, $5ecbf01f9da59a15$export$e06ad7c09a29974b)
    }, divisor);
const $57e6d30b2626ce39$var$SHIFT_CHAR_MAP = {
    '?': 'shift /',
    '!': 'shift 1',
    '@': 'shift 2',
    '#': 'shift 3',
    $: 'shift 4',
    '%': 'shift 5',
    '^': 'shift 6',
    '&': 'shift 7',
    '*': 'shift 8',
    '(': 'shift 9',
    ')': 'shift 0',
    _: 'shift -',
    '+': 'shift =',
    '{': 'shift [',
    '}': 'shift ]',
    ':': 'shift ;',
    '"': "shift '",
    '<': 'shift ,',
    '>': 'shift .',
    '|': 'shift \\',
    '~': 'shift `'
};
const $57e6d30b2626ce39$var$shiftModifierCheck = (shortcut)=>{
    if (shortcut.length === 1) {
        if (/[A-Z]/.test(shortcut)) return `shift ${shortcut.toLowerCase()}`;
        return $57e6d30b2626ce39$var$SHIFT_CHAR_MAP[shortcut] || shortcut;
    }
    return shortcut;
};
const $57e6d30b2626ce39$var$parseShortcut = (shortcut, replacers, acc = [], types = [])=>{
    const replacer = replacers.shift();
    if (!replacer) {
        $57e6d30b2626ce39$var$shiftModifierCheck(shortcut).split(' ').forEach((key, index, array)=>{
            acc.push({
                type: (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY,
                key: key
            });
            types.push((0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY);
            if (index < array.length - 1) {
                const separatorType = (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS;
                acc.push({
                    type: separatorType
                });
                types.push(separatorType);
            }
        });
        return [
            acc,
            types
        ];
    }
    shortcut.split(replacer.char).forEach((str, index, self)=>{
        $57e6d30b2626ce39$var$parseShortcut(str, replacers.slice(0), acc, types);
        if (index < self.length - 1) {
            acc.push({
                type: replacer.replacement
            });
            types.push(replacer.replacement);
        }
    });
    return [
        acc,
        types
    ];
};
const $57e6d30b2626ce39$export$cfaeb054b183bb20 = ()=>(0, $koVbs.default)();
const $57e6d30b2626ce39$export$b326d77e4b8b7664 = ({ shortcut: shortcut })=>{
    const { formatMessage: formatMessage } = $57e6d30b2626ce39$export$cfaeb054b183bb20();
    const [shortcuts, types] = (0, $5uXOq.useMemo)(()=>$57e6d30b2626ce39$var$parseShortcut(shortcut, (0, $gM5ou.getShortcutSpecialCharacters)()), [
        shortcut
    ]);
    const basicShortcutMessage = (0, $5uXOq.useMemo)(()=>{
        if (types.length === 3) {
            if (types[0] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY && types[2] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY) {
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN) return (0, $esPgL.messages).shortcutThen;
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR) return (0, $esPgL.messages).shortcutOr;
                if (types[1] === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).PLUS) return (0, $esPgL.messages).shortcutPlus;
            }
        }
        return null;
    }, [
        types
    ]);
    const formatTypeToMessage = (0, $5uXOq.useCallback)((type)=>{
        switch(type){
            case (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).THEN:
                return formatMessage((0, $esPgL.messages).divisorThen);
            case (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).OR:
                return formatMessage((0, $esPgL.messages).divisorOr);
            default:
                return formatMessage((0, $esPgL.messages).divisorPlus);
        }
    }, [
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$ShortcutContainer, {
        "data-testid": (0, $5ecbf01f9da59a15$export$ec8260df4f23714c),
        "aria-hidden": true
    }, basicShortcutMessage ? formatMessage(basicShortcutMessage, {
        shortcutA: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            shortcut: shortcuts[0].key
        }),
        shortcutB: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            shortcut: shortcuts[2].key
        }),
        divisor: (chunk)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
                divisor: chunk
            })
    }) : shortcuts.map((obj, index)=>{
        if (obj.type === (0, $bcTvL.SHORTCUT_ELEMENT_TYPES).KEY) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$KeyElement, {
            key: index,
            shortcut: obj.key
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($57e6d30b2626ce39$var$DivisorElement, {
            key: index,
            divisor: formatTypeToMessage(obj.type)
        });
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57e6d30b2626ce39$var$ShortcutDivider = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1b66 _otyridpf _18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $57e6d30b2626ce39$var$ShortcutContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlidpf _1o9zkb7n _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $57e6d30b2626ce39$var$styles = {
    lozenge: "_2rkoglpi _11c81u0j _1e0c1txw _4cvr1h6o _1bah1h6o _1o9zidpf _4t3i1tcg _syaz1fxt _1ul91tcg _1bsb1ris _kqswh2mm _1p1d1dk0 _1pbykb7n _1s6krwve _rfx3glpi _1cs8stnw _1kt9b3bt _154psxj9 _1aukidpf _19woidpf _oounidpf _qnecidpf _1g0v1mrw",
    longLozenge: "_18zr12x7",
    shortcutKeyWrapper: "_ca0qidpf _u5f31y44 _n3tdidpf _19bv1y44 _1ul91tcg _4t3i1tcg _1e0c1txw _4cvr1h6o _1bah1h6o"
};

});
const $5ecbf01f9da59a15$export$cd62afa4691c297 = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-icon';
const $5ecbf01f9da59a15$export$e06ad7c09a29974b = 'command-palette.ui.modal.body.shortcuts-icons.shortcut-divider';
const $5ecbf01f9da59a15$export$ec8260df4f23714c = 'command-palette.ui.modal.modal-content.body.command-row.shortcuts.shortcut-container';

parcelRegister("esPgL", function(module, exports) {

$parcel$export(module.exports, "messages", () => $4f430d579edd6c91$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $4f430d579edd6c91$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shortcutThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-then",
        "defaultMessage": "{shortcutA} <divisor>then</divisor> {shortcutB}"
    },
    shortcutOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-or",
        "defaultMessage": "{shortcutA} <divisor>or</divisor> {shortcutB}"
    },
    shortcutPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.shortcut-plus",
        "defaultMessage": "{shortcutA} <divisor>+</divisor> {shortcutB}"
    },
    divisorThen: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-then",
        "defaultMessage": "then"
    },
    divisorOr: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-or",
        "defaultMessage": "or"
    },
    divisorPlus: {
        "id": "command-palette.common.components.command-row.right-content.shortcuts.divisor-plus",
        "defaultMessage": "+"
    }
});

});


parcelRegister("kbnU6", function(module, exports) {

$parcel$export(module.exports, "TRANSITION_STEP", () => $d865f5b0afeb3acd$export$42d8d7c94c5a11e9);
$parcel$export(module.exports, "TRANSITION_INITIAL_DELAY_TIME_MS", () => $d865f5b0afeb3acd$export$82cfc253a6c33f59);
$parcel$export(module.exports, "TRANSITION_HOVER_DELAY_TIME_MS", () => $d865f5b0afeb3acd$export$e092796a9af3633b);
$parcel$export(module.exports, "TRANSITION_DURATION_MS", () => $d865f5b0afeb3acd$export$1cad4f611a1c0229);
// TODO: go/restrict-enums
// eslint-disable-next-line no-restricted-syntax
var $d865f5b0afeb3acd$export$42d8d7c94c5a11e9 = /*#__PURE__*/ function(TRANSITION_STEP) {
    TRANSITION_STEP["INITIAL"] = "initial";
    TRANSITION_STEP["DELAYING"] = "delaying";
    TRANSITION_STEP["TRANSITIONING"] = "transitioning";
    TRANSITION_STEP["FINISHED"] = "finished";
    TRANSITION_STEP["DELAYING_FADE_OUT"] = "delaying-fade-out";
    TRANSITION_STEP["TRANSITIONING_FADE_OUT"] = "transitioning-fade-out";
    return TRANSITION_STEP;
}({});
const $d865f5b0afeb3acd$export$82cfc253a6c33f59 = 600;
const $d865f5b0afeb3acd$export$e092796a9af3633b = 300;
const $d865f5b0afeb3acd$export$1cad4f611a1c0229 = 350;

});

parcelRegister("lHtdH", function(module, exports) {

$parcel$export(module.exports, "useHoverTransitionStep", () => $9c0e762a7fdf0cdc$export$eefd045a02bab4c6);

var $5uXOq = parcelRequire("5uXOq");

var $dWt6p = parcelRequire("dWt6p");

var $jcw0u = parcelRequire("jcw0u");

var $gM5ou = parcelRequire("gM5ou");

var $kbnU6 = parcelRequire("kbnU6");
const $9c0e762a7fdf0cdc$export$eefd045a02bab4c6 = (command, isActive, isFirstCommand)=>{
    const [hasTransitionedFirstCommand, setHasTransitionedFirstCommand] = (0, $5uXOq.useState)(false);
    const [transitionStep, setTransitionStep] = (0, $5uXOq.useState)((0, $kbnU6.TRANSITION_STEP).INITIAL);
    const timerRef = (0, $5uXOq.useRef)(null);
    const isReducedMotion = (0, $dWt6p.useIsReducedMotion)();
    const commandHasChildren = (0, $gM5ou.hasChildren)(command);
    (0, $5uXOq.useEffect)(()=>{
        setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
        if (timerRef.current) clearTimeout(timerRef.current);
    }, [
        command
    ]);
    const startTimerForNextStep = (nextStep, durationMs)=>{
        timerRef.current = setTimeout(()=>{
            setTransitionStep(nextStep);
            timerRef.current = null;
        }, durationMs);
    };
    const handleReducedMotionTransition = (0, $5uXOq.useCallback)(()=>{
        if (isActive) setTransitionStep((0, $kbnU6.TRANSITION_STEP).FINISHED);
        else setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
    }, [
        isActive
    ]);
    const handleWithMotionTransition = (0, $5uXOq.useCallback)(()=>{
        switch(transitionStep){
            case (0, $kbnU6.TRANSITION_STEP).INITIAL:
                if (isActive) {
                    setTransitionStep((0, $kbnU6.TRANSITION_STEP).DELAYING);
                    startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).TRANSITIONING, isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand ? (0, $kbnU6.TRANSITION_INITIAL_DELAY_TIME_MS) : (0, $kbnU6.TRANSITION_HOVER_DELAY_TIME_MS));
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).DELAYING:
                if (!isActive) {
                    timerRef.current && clearTimeout(timerRef.current);
                    timerRef.current = null;
                    setTransitionStep((0, $kbnU6.TRANSITION_STEP).INITIAL);
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).TRANSITIONING:
                if (isActive) {
                    if (isFirstCommand && !!command.shortcut && !hasTransitionedFirstCommand) setHasTransitionedFirstCommand(true);
                    if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).FINISHED, (0, $kbnU6.TRANSITION_DURATION_MS));
                }
                break;
            case (0, $kbnU6.TRANSITION_STEP).FINISHED:
                if (!isActive) setTransitionStep((0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT);
                break;
            case (0, $kbnU6.TRANSITION_STEP).DELAYING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT, (0, $kbnU6.TRANSITION_HOVER_DELAY_TIME_MS));
                break;
            case (0, $kbnU6.TRANSITION_STEP).TRANSITIONING_FADE_OUT:
                if (!timerRef.current) startTimerForNextStep((0, $kbnU6.TRANSITION_STEP).INITIAL, (0, $kbnU6.TRANSITION_DURATION_MS));
                break;
            default:
                (0, $jcw0u.default)({
                    error: new Error('Invalid transition step for command'),
                    meta: {
                        id: 'useTransitionStep',
                        packageName: 'jiraCommandPalette',
                        teamName: 'deliveroo'
                    }
                });
        }
    }, [
        command.shortcut,
        hasTransitionedFirstCommand,
        isActive,
        isFirstCommand,
        transitionStep
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (commandHasChildren) {
            if (isReducedMotion) handleReducedMotionTransition();
            else handleWithMotionTransition();
        }
    }, [
        commandHasChildren,
        isReducedMotion,
        handleReducedMotionTransition,
        handleWithMotionTransition
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isFirstCommand) setHasTransitionedFirstCommand(false);
    }, [
        isFirstCommand
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (timerRef.current) clearTimeout(timerRef.current);
        }, []);
    return transitionStep;
};

});




parcelRegister("5aF2z", function(module, exports) {

$parcel$export(module.exports, "GROUP_TEST_ID", () => $7ecce3582144481d$export$d83f892940e54128);
$parcel$export(module.exports, "NO_RESULTS_TEST_ID", () => $7ecce3582144481d$export$bf182a53106ca02e);
$parcel$export(module.exports, "SCROLL_DIRECTION", () => $7ecce3582144481d$export$a6d65a8fb7b912d6);
const $7ecce3582144481d$export$85eefac753ab5bdb = 'command-palette.ui.modal.body.command-body-container';
const $7ecce3582144481d$export$617744f059bfc3ba = 'command-palette.ui.modal.body.command-container-row';
const $7ecce3582144481d$export$d83f892940e54128 = 'command-palette.ui.modal.body.group-container';
const $7ecce3582144481d$export$707f57180c76458e = 'command-palette.ui.modal.body.spinner-container';
const $7ecce3582144481d$export$bf182a53106ca02e = 'command-palette.ui.modal.body.no-results-container';
var $7ecce3582144481d$export$a6d65a8fb7b912d6 = /*#__PURE__*/ function(SCROLL_DIRECTION) {
    SCROLL_DIRECTION["START"] = "start";
    SCROLL_DIRECTION["END"] = "end";
    return SCROLL_DIRECTION;
}({});

});

parcelRegister("64ZBB", function(module, exports) {

$parcel$export(module.exports, "isElementVisibleInContainer", () => $6b9215d3fa38a855$export$b9dc8b6556026098);
$parcel$export(module.exports, "getScrollToIndex", () => $6b9215d3fa38a855$export$56068eb4c4e3a63c);
$parcel$export(module.exports, "scrollResultIntoView", () => $6b9215d3fa38a855$export$6be8a7238febd54f);

var $gM5ou = parcelRequire("gM5ou");

var $5aF2z = parcelRequire("5aF2z");
const $6b9215d3fa38a855$export$b9dc8b6556026098 = (element, container)=>{
    const modalBodyRect = container.getBoundingClientRect();
    const elementRect = element.getBoundingClientRect();
    return elementRect.top >= modalBodyRect.top && elementRect.bottom <= modalBodyRect.bottom;
};
const $6b9215d3fa38a855$export$56068eb4c4e3a63c = (results, newActiveIndex, scrollTo)=>{
    const commandResultIndex = results.findIndex((result)=>!result.isGroup && result.index === newActiveIndex);
    if (scrollTo === (0, $5aF2z.SCROLL_DIRECTION).START && commandResultIndex > 0) {
        // Verify if there is any active command before this id
        const prevActiveCommandIndex = results.findIndex((result, index)=>index < commandResultIndex && !result.isGroup && (0, $gM5ou.hasAction)(result.command));
        if (prevActiveCommandIndex === -1) return 0;
    }
    if (scrollTo === (0, $5aF2z.SCROLL_DIRECTION).END) {
        // Verify if there is any active command after this id
        const afterActiveCommandIndex = results.findIndex((result, index)=>index > commandResultIndex && !result.isGroup && (0, $gM5ou.hasAction)(result.command));
        if (afterActiveCommandIndex === -1) return results.length - 1;
        // Scrolling down, so group headings don't need to be taken into account
        return commandResultIndex;
    }
    const isCommandAfterGroupHeading = commandResultIndex > 0 && results[commandResultIndex - 1].isGroup;
    return isCommandAfterGroupHeading ? commandResultIndex - 1 : commandResultIndex;
};
const $6b9215d3fa38a855$export$6be8a7238febd54f = ({ target: target, direction: direction, scrollContainer: scrollContainer })=>{
    const targetRect = target.getBoundingClientRect();
    const containerRect = scrollContainer.getBoundingClientRect();
    const gapScroll = 4;
    if (direction === (0, $5aF2z.SCROLL_DIRECTION).END) {
        const commandPosition = targetRect.bottom - containerRect.top;
        const amountToScroll = commandPosition - containerRect.height;
        const pos = amountToScroll + gapScroll + scrollContainer.scrollTop;
        scrollContainer.scrollTo({
            top: pos
        });
    } else {
        const commandPosition = containerRect.top - targetRect.top;
        const amountToScroll = scrollContainer.scrollTop - commandPosition;
        const pos = amountToScroll - gapScroll;
        scrollContainer.scrollTo({
            top: pos
        });
    }
};

});


parcelRegister("dE25F", function(module, exports) {

$parcel$export(module.exports, "Footer", () => $842574a5e4b1a419$export$a06f1c675e846f6f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $842574a5e4b1a419$export$a06f1c675e846f6f = ({ defaultFooterContent: defaultFooterContent, children: children })=>{
    const footerChildren = children || defaultFooterContent;
    if (!footerChildren) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($842574a5e4b1a419$var$ModalFooter, {
        "data-testid": (0, $8289a08a5c530859$export$aca3e1b45b29f2bb)
    }, footerChildren);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $842574a5e4b1a419$var$ModalFooter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _mrkb1kw7 _1o0z1kw7 _ca0qutpp _u5f3pxbi _n3tdutpp _19bvpxbi",
            __cmplp.className
        ])
    });
});

});
const $8289a08a5c530859$export$aca3e1b45b29f2bb = 'command-palette.ui.modal.footer.footer';


parcelRegister("d4iCz", function(module, exports) {

$parcel$export(module.exports, "Header", () => $82822f3e363fec07$export$8b251419efc915eb);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

const $82822f3e363fec07$export$8b251419efc915eb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $82822f3e363fec07$var$headerStyles,
        testId: (0, $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf)
    }, children);
const $82822f3e363fec07$var$headerStyles = (0, $8CUq3.xcss)({
    borderTopLeftRadius: 'inherit',
    borderTopRightRadius: 'inherit',
    padding: 'space.200',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderBottom: `solid 1px ${"var(--ds-border, #091E4224)"}`
});

});
const $cd6716f1a0c7ec9f$export$bf5b960a2e79e6cf = 'command-palette.ui.modal.header.modal-header';



parcelRegister("2w83X", function(module, exports) {

$parcel$export(module.exports, "IssueTag", () => $2ba2b027b9044740$export$a342a0ad2c552031);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $eMpK2 = parcelRequire("eMpK2");

var $jIHzq = parcelRequire("jIHzq");

var $4R6GH = parcelRequire("4R6GH");

var $2gCtH = parcelRequire("2gCtH");

var $7wNl6 = parcelRequire("7wNl6");

var $80wkc = parcelRequire("80wkc");
const $2ba2b027b9044740$export$a342a0ad2c552031 = ({ issueKey: issueKey })=>{
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const issueId = (0, $4R6GH.fg)('relay-migration-issue-fields-summary') ? (0, $2gCtH.useIssueId)() : undefined;
    const [{ value: summary }] = (0, $80wkc.useSummaryField)({
        issueKey: issueKey,
        issueId: issueId
    });
    const [{ value: issueType }] = (0, $7wNl6.useIssueTypeField)({
        issueKey: issueKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $2ba2b027b9044740$var$issueTagContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $2ba2b027b9044740$var$issueTagStyles,
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eMpK2.IssueLeftIcon), {
        issueTypeName: issueType?.name,
        iconUrl: issueType?.iconUrl
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jIHzq.TruncateWithTooltipOnHover), null, `${issueKey} ${summary}`)));
};
const $2ba2b027b9044740$var$issueTagContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    minWidth: '0'
});
const $2ba2b027b9044740$var$issueTagStyles = (0, $8CUq3.xcss)({
    maxWidth: '100%',
    padding: 'space.050',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    color: 'color.text.subtle',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1
});

});
parcelRegister("eMpK2", function(module, exports) {

$parcel$export(module.exports, "IssueLeftIcon", () => $f381ae85157eafc9$export$b1b562672a76ad84);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dXXlv = parcelRequire("dXXlv");
const $f381ae85157eafc9$export$b1b562672a76ad84 = ({ iconUrl: iconUrl, issueTypeName: issueTypeName })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("img", {
        src: iconUrl,
        alt: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $dXXlv.messages).issueIconAltTextIssueTermRefresh : (0, $dXXlv.messages).issueIconAltText, {
            issueTypeName: issueTypeName
        }),
        height: "16"
    });
};

});
parcelRegister("dXXlv", function(module, exports) {

$parcel$export(module.exports, "messages", () => $91c46772185cf0df$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $91c46772185cf0df$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    issueIconAltText: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text",
        "defaultMessage": "Icon for the issue type {issueTypeName}"
    },
    issueIconAltTextIssueTermRefresh: {
        "id": "command-palette-common.common.command.issue.issue-left-icon.issue-icon-alt-text-issue-term-refresh",
        "defaultMessage": "Icon for the work type {issueTypeName}"
    }
});

});


parcelRegister("jIHzq", function(module, exports) {

$parcel$export(module.exports, "TruncateWithTooltipOnHover", () => $386c5138d16516b4$export$b2323503daaefa);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $jgArx = parcelRequire("jgArx");


var $k7xca = parcelRequire("k7xca");
const $386c5138d16516b4$export$70f47de153e915ed = ()=>(0, $5uXOq.useRef)(null);
const $386c5138d16516b4$export$b2323503daaefa = ({ children: children })=>{
    const containerRef = $386c5138d16516b4$export$70f47de153e915ed();
    const { shouldShowTruncatedTooltip: shouldShowTruncatedTooltip } = (0, $k7xca.useTruncatedTooltip)({
        containerRef: containerRef,
        // Tooltip delay is set on the tooltip component
        tooltipDelay: 0
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: shouldShowTruncatedTooltip ? ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TooltipContent), {
                "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-content"
            }, children) : '',
        component: (0, $jgArx.TooltipComponent),
        position: "bottom-end",
        delay: (0, $40fe2afec35c84b7$export$f9e3e7ede9ba929d)
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TooltipTrigger), {
            "data-testid": "command-palette.common.ui.truncate-with-tooltip.truncate-with-tooltip-on-hover.tooltip-trigger",
            ...tooltipProps
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgArx.TruncateWithTooltipContainer), {
            ref: containerRef
        }, children)));
};

});

parcelRegister("7wNl6", function(module, exports) {

$parcel$export(module.exports, "useIssueTypeField", () => $6016ffb039edefae$export$3da96c4009e089ca);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");
const $6016ffb039edefae$export$3da96c4009e089ca = ({ issueKey: issueKey, onSuccess: onSuccess, onFailure: onFailure })=>{
    const [{ value: fieldConfig }] = (0, $54wEF.useFieldConfig)(issueKey, (0, $5fc53.ISSUE_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig, 'schema.type', (0, $5fc53.ISSUE_TYPE));
    const [{ value: value, error: error, loading: loading }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: (0, $5fc53.ISSUE_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: null,
        onSuccess: onSuccess,
        onFailure: onFailure
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig,
            loading: loading
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("lQE94", function(module, exports) {

$parcel$export(module.exports, "useContextualIssueIdForIssueKey", () => $c31e2d123e024ddc$export$76d937477b5f784a);
$parcel$export(module.exports, "useEditField", () => $c31e2d123e024ddc$export$343e962d356c0af1);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $3BIWb = parcelRequire("3BIWb");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $ctrpc = parcelRequire("ctrpc");

var $d6AeP = parcelRequire("d6AeP");

var $2gCtH = parcelRequire("2gCtH");

var $afs7f = parcelRequire("afs7f");

var $15WDX = parcelRequire("15WDX");

var $biQrn = parcelRequire("biQrn");

var $8zOmE = parcelRequire("8zOmE");

var $3fAi8 = parcelRequire("3fAi8");

var $99cgx = parcelRequire("99cgx");
/**
 * Some responses contain `fields` property without `fieldKey`.
 * We must avoid changing the state of this fields by checking `fieldKey` property in the `fields`.
 * @param response
 * @param fieldKey
 */ const $c31e2d123e024ddc$var$getFieldValue = (response, fieldKey)=>{
    if (!response) return null;
    if (response.fields) {
        if (Object.hasOwnProperty.call(response.fields, fieldKey)) return response.fields[fieldKey];
        return null;
    }
    return response;
};
const $c31e2d123e024ddc$var$shouldCallSetFieldValue = (response, fieldKey)=>{
    if (!response) return false;
    if (response.fields) return !!Object.hasOwnProperty.call(response.fields, fieldKey);
    return true;
};
const $c31e2d123e024ddc$export$3796d3fdbc2e6b54 = (fieldOptions)=>{
    // di-ignore - Please fix parent-switcher examples
    const baseUrl = '';
    const { issueKey: issueKey, issueId: issueId, fieldKey: fieldKey, fieldType: fieldType, initialValue: initialValue, analyticsFieldKeyAlias: analyticsFieldKeyAlias, analyticsFieldTypeAlias: analyticsFieldTypeAlias, mapNonOptimisticResponse: mapNonOptimisticResponse = $c31e2d123e024ddc$var$getFieldValue, saveField: saveField = (0, $99cgx.defaultSaveField), saveFieldById: saveFieldById = (0, $99cgx.defaultSaveFieldById), addValuesToField: addValuesToField = (0, $99cgx.defaultAddValuesToField), removeValuesFromField: removeValuesFromField = (0, $99cgx.defaultRemoveValuesFromField), onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = fieldOptions;
    // We need to track the mounted state as it is possible that a component
    // using this hook can be unmounted before the async edit operation is completed.
    // Causing a react warning about setting state on an unmounted component.
    const isMounted = (0, $biQrn.useIsMounted)();
    const [fieldPersistedValue, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: fieldKey
    });
    const fieldValue = fieldPersistedValue !== undefined ? fieldPersistedValue : initialValue;
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [loading, setLoading] = (0, $5uXOq.useState)(false);
    const resetError = (0, $5uXOq.useCallback)(()=>{
        if (isMounted.current) setError(null);
    }, [
        setError,
        isMounted
    ]);
    const editFieldValue = (0, $5uXOq.useCallback)(async (editOperation, editOperationType, valuesForOperation, valuesForUI, meta, analyticsEvent, options = {
        isOptimistic: true
    })=>{
        let result;
        const actualFieldType = analyticsFieldTypeAlias ?? fieldType;
        const analyticsData = {
            editOperationType: editOperationType,
            issueId: issueId,
            fieldKey: analyticsFieldKeyAlias ?? fieldKey,
            fieldType: actualFieldType
        };
        if (isMounted.current) {
            setLoading(true);
            setError(null);
        }
        try {
            onSubmit(fieldValue, valuesForOperation, meta, analyticsEvent);
            if (options.isOptimistic) setFieldValue(issueKey, fieldKey, valuesForUI);
            result = await editOperation(issueKey, fieldKey, valuesForOperation, baseUrl, meta);
            const fieldValueResponse = mapNonOptimisticResponse(result, fieldKey);
            $c31e2d123e024ddc$var$shouldCallSetFieldValue(result, fieldKey) && setFieldValue(issueKey, fieldKey, fieldValueResponse);
            onSuccess(fieldValueResponse ?? valuesForOperation, analyticsEvent, meta);
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'field updated', analyticsData);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateSucceeded', analyticsData);
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd(fieldKey, {
                analytics: analyticsEvent,
                attributes: {
                    fieldType: actualFieldType,
                    isInlineEditing: !(0, $d6AeP.getIsEditFromIssueView)(analyticsEvent),
                    ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                        issueId: issueId
                    }
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (ex) {
            result = Promise.reject(ex);
            onFailure(ex, valuesForOperation);
            setFieldValue(issueKey, fieldKey, fieldValue);
            if (isMounted.current) setError(ex);
            const isValidationError = ex instanceof (0, $jJZqs.ValidationError);
            if (!isValidationError) (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-field.save-value', `Failed to update field ${fieldKey} of type ${fieldType}`, ex);
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'field updateFailed', {
                fieldKey: fieldKey,
                fieldType: analyticsFieldTypeAlias ?? fieldType,
                isValidationError: isValidationError,
                isClientFetchError: (0, $fZneA.isClientFetchError)(ex)
            });
            if ((0, $4R6GH.fg)('one_event_rules_them_all_fg')) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().endSession(fieldKey);
        }
        if (isMounted.current) setLoading(false);
        return result;
    }, [
        issueId,
        analyticsFieldKeyAlias,
        fieldKey,
        analyticsFieldTypeAlias,
        fieldType,
        isMounted,
        onSubmit,
        fieldValue,
        setFieldValue,
        issueKey,
        onSuccess,
        onFailure,
        mapNonOptimisticResponse
    ]);
    const saveValue = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveField, 'set', newValue, newValue, meta, analyticsEvent), [
        editFieldValue,
        saveField
    ]);
    const saveById = (0, $5uXOq.useCallback)(async (newValue, meta, analyticsEvent)=>editFieldValue(saveFieldById, 'set', newValue, newValue, meta, analyticsEvent, {
            isOptimistic: false
        }), [
        editFieldValue,
        saveFieldById
    ]);
    const addValues = (0, $5uXOq.useCallback)(async (valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent)=>editFieldValue(addValuesToField, 'add', valuesToAdd, expectedValuesAfterAdding, meta, analyticsEvent), [
        editFieldValue,
        addValuesToField
    ]);
    const removeValues = (0, $5uXOq.useCallback)(async (valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent)=>editFieldValue(removeValuesFromField, 'remove', valuesToRemove, expectedValuesAfterRemoval, meta, analyticsEvent), [
        editFieldValue,
        removeValuesFromField
    ]);
    return [
        {
            value: fieldValue,
            loading: loading,
            error: error
        },
        {
            saveById: saveById,
            saveValue: saveValue,
            addValues: addValues,
            removeValues: removeValues,
            resetError: resetError
        }
    ];
};
const $c31e2d123e024ddc$export$76d937477b5f784a = (issueKey)=>{
    const contextualIssueId = (0, $2gCtH.useIssueId)();
    const contextualIssueKey = (0, $2gCtH.useIssueKey)();
    return contextualIssueKey === issueKey ? contextualIssueId : null;
};
const $c31e2d123e024ddc$var$getAdditionalProperties = (meta, isEditFromIssueView)=>{
    if (!meta || typeof meta === 'object') return {
        ...meta ?? {},
        isEditFromIssueView: isEditFromIssueView
    };
    return meta;
};
const $c31e2d123e024ddc$export$343e962d356c0af1 = (fieldOptions)=>{
    const { fieldKey: fieldKey, issueId: issueIdFromFieldOptions, issueKey: issueKey, onSubmit: onSubmit = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onSuccess: onSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFailure: onFailure = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), shouldPreventIssueViewSoftRefresh: shouldPreventIssueViewSoftRefresh = false } = fieldOptions;
    const [, { fieldChanged: fieldChanged, fieldChangeFailed: fieldChangeFailed, fieldChangeRequested: fieldChangeRequested }] = (0, $15WDX.useIssueViewFieldUpdateEvents)();
    const contextualIssueId = $c31e2d123e024ddc$export$76d937477b5f784a(issueKey);
    const issueId = issueIdFromFieldOptions ?? contextualIssueId;
    const onSubmitFn = (0, $5uXOq.useCallback)((oldValue, newValue, meta, event)=>{
        onSubmit(oldValue, newValue, meta, event);
        issueId && fieldChangeRequested(issueId, fieldKey, newValue, meta);
    }, [
        fieldChangeRequested,
        fieldKey,
        issueId,
        onSubmit
    ]);
    const onSuccessFn = (0, $5uXOq.useCallback)(async (fieldValue, event, meta)=>{
        onSuccess(fieldValue);
        issueId && fieldChanged(issueId, fieldKey, fieldValue, undefined, (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? $c31e2d123e024ddc$var$getAdditionalProperties(meta, (0, $d6AeP.getIsEditFromIssueView)(event)) : meta);
        if (!shouldPreventIssueViewSoftRefresh && !(0, $d6AeP.getIsEditFromIssueView)(event)) try {
            const reason = (0, $afs7f.Reason).SoftRefresh;
            await (0, $3BIWb.default).refreshIssuePageThrowable(issueKey, reason);
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('issue.fields.use-edit-field.refresh', error instanceof Error ? error.message : 'useEditField issue refresh failed');
        }
    }, [
        fieldChanged,
        fieldKey,
        shouldPreventIssueViewSoftRefresh,
        issueId,
        issueKey,
        onSuccess
    ]);
    const onFailureFn = (0, $5uXOq.useCallback)((error, failedValue)=>{
        onFailure(error, failedValue);
        issueId && fieldChangeFailed(issueId, fieldKey);
    }, [
        fieldChangeFailed,
        fieldKey,
        issueId,
        onFailure
    ]);
    return $c31e2d123e024ddc$export$3796d3fdbc2e6b54({
        ...fieldOptions,
        onSubmit: onSubmitFn,
        onSuccess: onSuccessFn,
        onFailure: onFailureFn
    });
};

});
parcelRegister("3BIWb", function(module, exports) {

$parcel$export(module.exports, "default", () => $b65e83eb4ced9ce9$export$2e2bcd8739ae039);
const $b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT = 'legacy_refreshIssuePage';
const $b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT = 'legacy_updateIssueGlance';
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.addEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeEventListener = (event, callback)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.removeEventListener(event, callback);
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeRefreshIssueListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$addEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener = (callback)=>$b65e83eb4ced9ce9$var$removeEventListener($b65e83eb4ced9ce9$var$UPDATE_ISSUE_GLANCE_EVENT, callback);
const $b65e83eb4ced9ce9$var$refreshIssuePageThrowable = (issueKey, reason = 'ON_DEMAND')=>{
    try {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.dispatchEvent(new CustomEvent($b65e83eb4ced9ce9$var$REFRESH_ISSUE_PAGE_EVENT, {
            detail: [
                issueKey,
                {
                    mergeIntoCurrent: false,
                    reason: reason
                }
            ]
        }));
        return Promise.resolve();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        return Promise.reject(e);
    }
};
const $b65e83eb4ced9ce9$var$refreshIssuePage = (issueKey)=>// Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    $b65e83eb4ced9ce9$var$refreshIssuePageThrowable(issueKey).catch(()=>{});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b65e83eb4ced9ce9$export$2e2bcd8739ae039 = {
    addRefreshIssueListener: $b65e83eb4ced9ce9$var$addRefreshIssueListener,
    removeRefreshIssueListener: $b65e83eb4ced9ce9$var$removeRefreshIssueListener,
    addUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$addUpdateIssueGlanceListener,
    removeUpdateIssueGlanceListener: $b65e83eb4ced9ce9$var$removeUpdateIssueGlanceListener,
    refreshIssuePageThrowable: $b65e83eb4ced9ce9$var$refreshIssuePageThrowable,
    refreshIssuePage: $b65e83eb4ced9ce9$var$refreshIssuePage
};

});

parcelRegister("d6AeP", function(module, exports) {

$parcel$export(module.exports, "getIsEditFromIssueView", () => $843704b157f0fa59$export$8846558eb0b5fa3);

var $hBuqR = parcelRequire("hBuqR");

var $lhVtI = parcelRequire("lhVtI");
const $843704b157f0fa59$export$8846558eb0b5fa3 = (event)=>{
    const ISSUE_VIEW_SOURCES = [
        'fullIssueScreen',
        'boardIssueViewScreen',
        'agility-backlogScreen',
        'issueNavigatorEmbeddedIssueViewScreen',
        'globalIssueNavigatorIssueScreen',
        'mobileIssueScreen',
        'classicRoadmapScreen',
        'roadmapScreen',
        'versionDetailsIssueScreen',
        'bitbucketIssueScreen',
        'jsmQueueAgentViewSidebarScreen',
        'viewQueueIssueScreen',
        'jswModalIssueAppScreen',
        'jwmModalIssueAppScreen',
        'jswSidebarIssueAppScreen',
        'jwmSidebarIssueAppScreen'
    ];
    const { payload: { source: source } } = (0, $lhVtI.getEvent)(event);
    if (!source) return false;
    if (ISSUE_VIEW_SOURCES.includes(source)) // event originated from issue view location
    return true;
    if (source.startsWith((0, $hBuqR.PACKAGE_NAME_GASV3))) // event originated from forge app, which can only be mounted in issue view for field editing
    return true;
    return false;
};

});

parcelRegister("afs7f", function(module, exports) {

$parcel$export(module.exports, "Reason", () => $90b3aba4b3cc23bb$export$fe867595c4640fb1);
const $90b3aba4b3cc23bb$export$fe867595c4640fb1 = {
    /**
	 * Aka hard refresh, used by Ecosystem apps to refresh issue view on demand
	 * 1) Full issue view refresh
	 * 2) Hard Ecosystem apps refresh (causes remounting of the apps)
	 */ OnDemand: 'ON_DEMAND',
    /**
	 * Used by Jira internally to update issue view on demand without forcing Ecosystem apps to rerender
	 * 1) Full issue view refresh only
	 * 2) Ecosystem app aren't hard refreshed, however, if field's value has changed, Forge custom field will rerender
	 */ SoftRefresh: 'SOFT_REFRESH',
    /**
	 * Issue view refresh caused by Realtime service (Jirt)
	 */ Realtime: 'REALTIME'
};

});

parcelRegister("15WDX", function(module, exports) {

$parcel$export(module.exports, "useIssueViewFieldUpdateEvents", () => $947bdf396d8056bc$export$444af741f6d8f512);
$parcel$export(module.exports, "IssueViewFieldUpdateEventContainer", () => $947bdf396d8056bc$export$f9eb49cc2f0e28ce);

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5YMLs = parcelRequire("5YMLs");

var $3z81P = parcelRequire("3z81P");
const $947bdf396d8056bc$var$registerEventHandler = (type, eventHandler)=>({ getState: getState, setState: setState })=>{
        if (typeof eventHandler !== 'function') // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const { eventHandlers: eventHandlers } = getState();
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
        const typeEventHandlers = eventHandlers[type];
        setState({
            eventHandlers: {
                ...eventHandlers,
                [type]: typeEventHandlers.concat([
                    eventHandler
                ])
            }
        });
        return ()=>{
            const { eventHandlers: eventHandlersForUnregister } = getState();
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ onChange: OnChangeHandler[]; }'.
            const typeEventHandlersForUnregister = eventHandlersForUnregister[type];
            const newTypeEventHandlers = typeEventHandlersForUnregister.filter(// @ts-expect-error - TS7006 - Parameter 'handler' implicitly has an 'any' type.
            (handler)=>handler !== eventHandler);
            setState({
                eventHandlers: {
                    ...eventHandlersForUnregister,
                    [type]: newTypeEventHandlers
                }
            });
        };
    };
const $947bdf396d8056bc$var$fieldChanged = (issueId, fieldId, fieldValue, aggFieldChangeProps, additionalProperties)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                fieldId: // field id is required to be compatible with v1 onChange API
                fieldId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeFailed = (issueId, fieldId)=>({ getState: getState })=>{
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_FAILED
            });
        });
    };
const $947bdf396d8056bc$var$fieldChangeRequested = (issueId, fieldId, fieldValue, additionalProperties, aggFieldChangeProps)=>({ getState: getState })=>{
        let value = fieldValue;
        if (aggFieldChangeProps) value = (0, $5YMLs.transformAggToLegacy)({
            fieldValue: fieldValue,
            aggFieldChangeProps: aggFieldChangeProps
        });
        const eventHandlers = getState().eventHandlers.onChange;
        eventHandlers.forEach((eventHandler)=>{
            eventHandler({
                issueId: issueId,
                meta: {
                    fieldId: fieldId,
                    fieldValue: value,
                    additionalProperties: additionalProperties
                },
                type: (0, $3z81P.ChangeEventTypes).FIELD_CHANGE_REQUESTED
            });
        });
    };
const $947bdf396d8056bc$var$actions = {
    fieldChanged: $947bdf396d8056bc$var$fieldChanged,
    fieldChangeFailed: $947bdf396d8056bc$var$fieldChangeFailed,
    fieldChangeRequested: $947bdf396d8056bc$var$fieldChangeRequested,
    registerEventHandler: $947bdf396d8056bc$var$registerEventHandler
};
// this is a global state
const $947bdf396d8056bc$var$store = (0, $iXqE5.createStore)({
    name: 'issue-view-field-update-events',
    initialState: {
        eventHandlers: {
            onChange: []
        }
    },
    actions: $947bdf396d8056bc$var$actions
});
const $947bdf396d8056bc$export$444af741f6d8f512 = (0, $3sQ5x.createHook)($947bdf396d8056bc$var$store, {
    selector: null
});
const $947bdf396d8056bc$export$f9eb49cc2f0e28ce = (0, $gg7kZ.createContainer)($947bdf396d8056bc$var$store);

});
parcelRegister("5YMLs", function(module, exports) {

$parcel$export(module.exports, "transformAggToLegacy", () => $1da8cbd2b672325c$export$d951e3c38e10736d);

var $bMD69 = parcelRequire("bMD69");

var $5fc53 = parcelRequire("5fc53");

var $1pF6B = parcelRequire("1pF6B");

var $lTnWS = parcelRequire("lTnWS");
const $1da8cbd2b672325c$export$d951e3c38e10736d = ({ fieldValue: fieldValue, aggFieldChangeProps: aggFieldChangeProps })=>{
    if (!aggFieldChangeProps?.__typename) throw new Error('node did not have __typename');
    switch(aggFieldChangeProps.__typename){
        // These fields require context for their transform in transformAggFieldToLegacyField so need to be manually implemented
        // This is not an exhaustive list, I did a quick check is all, so best to check the transform works as expected as you migrate fields to relay
        // These are commented out because they are not implemented and due to types can't just be added here until implemented
        // case JSM_PEOPLE_GQL_FIELD:
        // case ISSUE_RESTRICTION_GQL_FIELD:
        // otherwise we can default to the existing package
        case 0, $5fc53.RADIO_GQL_FIELD:
        case 0, $5fc53.TEAM_VIEW_GQL_FIELD:
        case 0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD:
        case 0, $5fc53.MULTI_USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PEOPLE_GQL_FIELD:
        case 0, $5fc53.SECURITY_GQL_FIELD:
        case 0, $5fc53.NUMBER_GQL_FIELD:
        case 0, $5fc53.TEXT_GQL_FIELD:
        case 0, $5fc53.USER_PICKER_GQL_FIELD:
        case 0, $5fc53.PRIORITY_GQL_FIELD:
        case 0, $5fc53.URL_GQL_FIELD:
        case 0, $5fc53.DATE_PICKER_GQL_FIELD:
        case 0, $5fc53.PROJECT_GQL_FIELD:
        case 0, $5fc53.DATE_TIME_GQL_FIELD:
        case 0, $5fc53.COLOR_GQL_FIELD:
        case 0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD:
        case 0, $5fc53.ISSUE_TYPE_GQL_FIELD:
        case 0, $5fc53.VOTES_GQL_FIELD:
        case 0, $5fc53.WATCHES_GQL_FIELD:
        case 0, $5fc53.RESOLUTION_GQL_FIELD:
        case 0, $5fc53.STATUS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                [$1da8cbd2b672325c$var$getValueKey(aggFieldChangeProps.__typename)]: fieldValue,
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type
            })?.value;
        case 0, $5fc53.RICH_TEXT_GQL_FIELD:
            return (0, $lTnWS.transformAggRichTextFieldValueToLegacyFieldValue)(fieldValue, aggFieldChangeProps.renderer);
        case 0, $5fc53.PARENT_GQL_FIELD:
            return (0, $1pF6B.transformAggParentFieldValueToLegacyFieldValue)(fieldValue);
        case 0, $5fc53.SPRINT_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                ...fieldValue
            })?.value;
        case 0, $5fc53.TIME_TRACKING_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                originalEstimate: fieldValue.originalEstimate,
                remainingEstimate: fieldValue.remainingEstimate,
                timeSpent: fieldValue.timeSpent
            })?.value;
        case 0, $5fc53.CHECKBOX_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedOptions: fieldValue.selectedOptions,
                checkboxesFieldOptions: fieldValue.fieldOptions
            })?.value;
        case 0, $5fc53.COMPONENTS_GQL_FIELD:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return (0, $bMD69.transformAggFieldToLegacyField)({
                __typename: aggFieldChangeProps.__typename,
                type: aggFieldChangeProps.type,
                selectedComponentsConnection: fieldValue.selectedComponentsConnection
            })?.value;
        default:
            throw new Error('__typename not implemented');
    }
};
const $1da8cbd2b672325c$var$getValueKey = (__typename)=>{
    const VALUE_KEYS = {
        [(0, $5fc53.TEXT_GQL_FIELD)]: 'text',
        [(0, $5fc53.NUMBER_GQL_FIELD)]: 'number',
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: 'priority',
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: 'user',
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: 'date',
        [(0, $5fc53.PROJECT_GQL_FIELD)]: 'project',
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: 'dateTime',
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: 'originalEstimate',
        [(0, $5fc53.URL_GQL_FIELD)]: 'uri',
        [(0, $5fc53.SECURITY_GQL_FIELD)]: 'securityLevel',
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.WATCHES_GQL_FIELD)]: 'watch',
        [(0, $5fc53.VOTES_GQL_FIELD)]: 'vote',
        [(0, $5fc53.COLOR_GQL_FIELD)]: 'color',
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: 'selectedUsersConnection',
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: 'issueType',
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: 'resolution',
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: 'selectedGroupsConnection',
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: 'selectedGroup',
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: 'selectedTeam',
        [(0, $5fc53.STATUS_GQL_FIELD)]: 'status',
        [(0, $5fc53.RADIO_GQL_FIELD)]: 'selectedOption',
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: 'richText'
    };
    const value = VALUE_KEYS[__typename];
    if (value) return value;
    throw new Error(`Did you forget to implement getValueKey for your field type? Couldn't find a value in the map for ${__typename}`);
};

});
parcelRegister("bMD69", function(module, exports) {

$parcel$export(module.exports, "transformAggFieldToLegacyField", () => $af5e8bab0defb9c8$export$586ba15cbf3d3031);
$parcel$export(module.exports, "transformAggFieldsToLegacyFields", () => $af5e8bab0defb9c8$export$ba106ff8c087e6b1);

var $8QpSo = parcelRequire("8QpSo");

var $5fc53 = parcelRequire("5fc53");

var $9bgym = parcelRequire("9bgym");

var $6iJEF = parcelRequire("6iJEF");

var $9UrtF = parcelRequire("9UrtF");

var $hsEaK = parcelRequire("hsEaK");

var $2qu1N = parcelRequire("2qu1N");

var $16Zia = parcelRequire("16Zia");

var $iv8Rf = parcelRequire("iv8Rf");

var $hDlc2 = parcelRequire("hDlc2");

var $c3LW9 = parcelRequire("c3LW9");

var $h92P3 = parcelRequire("h92P3");

var $aeO9V = parcelRequire("aeO9V");

var $6Tnq8 = parcelRequire("6Tnq8");

var $6mbsj = parcelRequire("6mbsj");

var $d3nG3 = parcelRequire("d3nG3");

var $1xW6n = parcelRequire("1xW6n");

var $fW9XR = parcelRequire("fW9XR");

var $bKMMB = parcelRequire("bKMMB");

var $7JL37 = parcelRequire("7JL37");

var $dulCG = parcelRequire("dulCG");

var $6vno6 = parcelRequire("6vno6");

var $as0vY = parcelRequire("as0vY");

var $6dPLd = parcelRequire("6dPLd");

var $gKccZ = parcelRequire("gKccZ");

var $jnUrZ = parcelRequire("jnUrZ");

var $iJtmd = parcelRequire("iJtmd");

var $iPyq0 = parcelRequire("iPyq0");

var $384lj = parcelRequire("384lj");

var $axTS6 = parcelRequire("axTS6");

var $lfJ6H = parcelRequire("lfJ6H");

var $9UXU7 = parcelRequire("9UXU7");

var $b6BoU = parcelRequire("b6BoU");

var $gak3n = parcelRequire("gak3n");

var $i47fO = parcelRequire("i47fO");

var $gvljZ = parcelRequire("gvljZ");

var $6XFn2 = parcelRequire("6XFn2");

var $6e1Ya = parcelRequire("6e1Ya");

var $640u2 = parcelRequire("640u2");

var $hBEiJ = parcelRequire("hBEiJ");

var $1XNj2 = parcelRequire("1XNj2");

var $f6zXW = parcelRequire("f6zXW");

var $fB4wX = parcelRequire("fB4wX");

var $cXBkk = parcelRequire("cXBkk");

var $iDKu3 = parcelRequire("iDKu3");

var $aGv90 = parcelRequire("aGv90");

var $19DRh = parcelRequire("19DRh");

var $lkW3a = parcelRequire("lkW3a");

var $lQAwK = parcelRequire("lQAwK");

var $8qOI6 = parcelRequire("8qOI6");

var $cbd7V = parcelRequire("cbd7V");

var $6hj44 = parcelRequire("6hj44");

var $4nh4C = parcelRequire("4nh4C");

var $hA3EZ = parcelRequire("hA3EZ");

var $2z4xE = parcelRequire("2z4xE");

var $cO2KQ = parcelRequire("cO2KQ");

var $5sETx = parcelRequire("5sETx");

var $f454b = parcelRequire("f454b");

var $aafIf = parcelRequire("aafIf");

var $2yWre = parcelRequire("2yWre");

var $lUeQj = parcelRequire("lUeQj");

var $6SWOK = parcelRequire("6SWOK");

var $cMc7B = parcelRequire("cMc7B");

var $38GNL = parcelRequire("38GNL");

var $avV20 = parcelRequire("avV20");

var $cbXvu = parcelRequire("cbXvu");

var $aSXJi = parcelRequire("aSXJi");

var $8uxcU = parcelRequire("8uxcU");

var $arKlm = parcelRequire("arKlm");

var $hCKV6 = parcelRequire("hCKV6");

var $d8wC0 = parcelRequire("d8wC0");
// We're memoising this just in case we FF another field
const $af5e8bab0defb9c8$var$getTransformersNonMemoised = ()=>({
        [(0, $5fc53.AFFECTED_SERVICES_GQL_FIELD)]: (0, $9bgym.transformAggAffectedServicesToLegacyField),
        [(0, $5fc53.BOOLEAN_GQL_FIELD)]: (0, $9UrtF.transformAggBooleanToLegacyField),
        [(0, $5fc53.CASCADING_SELECT_GQL_FIELD)]: (0, $hsEaK.transformAggCascadingSelectToLegacyField),
        [(0, $5fc53.CHECKBOX_GQL_FIELD)]: (0, $2qu1N.transformAggCheckboxToLegacyField),
        [(0, $5fc53.CMDB_GQL_FIELD)]: (0, $16Zia.transformAggCMDBToLegacyField),
        [(0, $5fc53.MULTI_SELECT_GQL_FIELD)]: (0, $19DRh.transformAggMultipleSelectToLegacyField),
        [(0, $5fc53.COMPONENTS_GQL_FIELD)]: (0, $hDlc2.transformAggComponentsToLegacyField),
        [(0, $5fc53.CONNECT_DATE_TIME_GQL_FIELD)]: (0, $c3LW9.transformAggConnectDateTimeToLegacyField),
        [(0, $5fc53.CONNECT_MULTI_SELECT_GQL_FIELD)]: (0, $h92P3.transformAggConnectMultipleSelectToLegacyField),
        [(0, $5fc53.CONNECT_NUMBER_GQL_FIELD)]: (0, $aeO9V.transformAggConnectNumberToLegacyField),
        [(0, $5fc53.CONNECT_RICH_TEXT_GQL_FIELD)]: (0, $6Tnq8.transformAggConnectRichTextToLegacyField),
        [(0, $5fc53.CONNECT_SINGLE_SELECT_GQL_FIELD)]: (0, $6mbsj.transformAggConnectSingleSelectToLegacyField),
        [(0, $5fc53.CONNECT_TEXT_GQL_FIELD)]: (0, $d3nG3.transformAggConnectTextToLegacyField),
        [(0, $5fc53.COLOR_GQL_FIELD)]: (0, $iv8Rf.transformAggColorToLegacyField),
        [(0, $5fc53.DATE_PICKER_GQL_FIELD)]: (0, $fW9XR.transformAggDatePickerToLegacyField),
        [(0, $5fc53.DATE_TIME_GQL_FIELD)]: (0, $bKMMB.transformAggDateTimePickerToLegacyField),
        [(0, $5fc53.EPIC_LINK_GQL_FIELD)]: (0, $7JL37.transformAggEpicLinkToLegacyField),
        [(0, $5fc53.FLAG_GQL_FIELD)]: (0, $dulCG.transformAggFlagToLegacyField),
        [(0, $5fc53.FORGE_DATETIME_GQL_FIELD)]: (0, $as0vY.transformAggForgeDateTimeToLegacyField),
        [(0, $5fc53.FORGE_DATE_GQL_FIELD)]: (0, $6vno6.transformAggForgeDateToLegacyField),
        [(0, $5fc53.FORGE_GROUP_GQL_FIELD)]: (0, $6dPLd.transformAggForgeGroupToLegacyField),
        [(0, $5fc53.FORGE_GROUPS_GQL_FIELD)]: (0, $gKccZ.transformAggForgeGroupsToLegacyField),
        [(0, $5fc53.FORGE_NUMBER_GQL_FIELD)]: (0, $jnUrZ.transformAggForgeNumberToLegacyField),
        [(0, $5fc53.FORGE_OBJECT_GQL_FIELD)]: (0, $iJtmd.transformAggForgeObjectToLegacyField),
        [(0, $5fc53.FORGE_STRING_GQL_FIELD)]: (0, $iPyq0.transformAggForgeStringToLegacyField),
        [(0, $5fc53.FORGE_STRINGS_GQL_FIELD)]: (0, $384lj.transformAggForgeStringsToLegacyField),
        [(0, $5fc53.FORGE_USER_GQL_FIELD)]: (0, $axTS6.transformAggForgeUserToLegacyField),
        [(0, $5fc53.FORGE_USERS_GQL_FIELD)]: (0, $lfJ6H.transformAggForgeUsersToLegacyField),
        [(0, $5fc53.ISSUE_RESTRICTION_GQL_FIELD)]: (0, $b6BoU.transformAggIssueRestrictionToLegacyField),
        [(0, $5fc53.ISSUE_TYPE_GQL_FIELD)]: (0, $gak3n.transformAggIssueTypeToLegacyField),
        [(0, $5fc53.JSM_APPROVAL_GQL_FIELD)]: (0, $i47fO.transformAggJSMApprovalsToLegacyField),
        [(0, $5fc53.JSM_ASSETS_GQL_FIELD)]: (0, $6iJEF.transformAggAssetToLegacyField),
        [(0, $5fc53.JSM_MAJOR_INCIDENT_FIELD)]: (0, $6XFn2.transformAggJSMMajorIncidentToLegacyField),
        [(0, $5fc53.JSM_ORGANIZATION_GQL_FIELD)]: (0, $6e1Ya.transformAggJSMOrganizationToLegacyField),
        [(0, $5fc53.JSM_ENTITLEMENTS_GQL_FIELD)]: (0, $gvljZ.transformAggJSMEntitlementsToLegacyField),
        [(0, $5fc53.JSM_SENTIMENT_GQL_FIELD)]: (0, $cXBkk.transformAggJSMSentimentToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.JSM_PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.JSM_REQUEST_FEEDBACK_GQL_FIELD)]: (0, $hBEiJ.transformAggJSMRequestFeedbackToLegacyField),
        [(0, $5fc53.JSM_REQUEST_LANGUAGE_GQL_FIELD)]: (0, $1XNj2.transformAggJSMRequestLanguageToLegacyField),
        [(0, $5fc53.JSM_REQUEST_TYPE_GQL_FIELD)]: (0, $f6zXW.transformAggJSMRequestTypeToLegacyField),
        [(0, $5fc53.JSM_RESPONDERS_GQL_FIELD)]: (0, $fB4wX.transformAggJSMRespondersToLegacyField),
        [(0, $5fc53.LABEL_GQL_FIELD)]: (0, $iDKu3.transformAggLabelsNodeToLegacyField),
        [(0, $5fc53.PRIORITY_GQL_FIELD)]: (0, $6hj44.transformAggPriorityToLegacyField),
        [(0, $5fc53.MULTI_GROUP_PICKER_GQL_FIELD)]: (0, $aGv90.transformAggMultiGroupPickerToLegacyField),
        [(0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)]: // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.NUMBER_GQL_FIELD)]: (0, $8qOI6.transformAggNumberToLegacyField),
        [(0, $5fc53.ORIGINAL_ESTIMATE_GQL_FIELD)]: (0, $cbd7V.transformAggOriginalEstimateToLegacyField),
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        [(0, $5fc53.PEOPLE_GQL_FIELD)]: (0, $lkW3a.transformAggMultipleUserPickerToLegacyField),
        [(0, $5fc53.PROFORMA_FORMS_GQL_FIELD)]: (0, $4nh4C.transformAggProformaFormsToLegacyField),
        [(0, $5fc53.PROJECT_GQL_FIELD)]: (0, $hA3EZ.transformAggProjectToLegacyField),
        [(0, $5fc53.MULTI_VERSION_GQL_FIELD)]: (0, $lQAwK.transformAggMultipleVersionPickerToLegacyField),
        [(0, $5fc53.RADIO_GQL_FIELD)]: (0, $2z4xE.transformAggRadioSelectToLegacyField),
        [(0, $5fc53.RICH_TEXT_GQL_FIELD)]: (0, $5sETx.transformAggRichTextToLegacyField),
        [(0, $5fc53.RESOLUTION_GQL_FIELD)]: (0, $cO2KQ.transformAggResolutionToLegacyField),
        [(0, $5fc53.SECURITY_GQL_FIELD)]: (0, $f454b.transformAggSecurityLevelToLegacyField),
        [(0, $5fc53.SPRINT_GQL_FIELD)]: (0, $38GNL.transformAggSprintToLegacyField),
        [(0, $5fc53.STATUS_GQL_FIELD)]: (0, $avV20.transformAggStatusToLegacyField),
        [(0, $5fc53.SINGLE_GROUP_PICKER_GQL_FIELD)]: (0, $aafIf.transformAggSingleGroupPickerToLegacyField),
        [(0, $5fc53.SINGLE_SELECT_GQL_FIELD)]: (0, $lUeQj.transformAggSingleSelectToLegacyField),
        [(0, $5fc53.TEAM_GQL_FIELD)]: (0, $cbXvu.transformAggTeamToLegacyField),
        [(0, $5fc53.TEAM_VIEW_GQL_FIELD)]: (0, $aSXJi.transformAggTeamViewToLegacyField),
        [(0, $5fc53.TEXT_GQL_FIELD)]: (0, $2yWre.transformAggSingleLineTextToLegacyField),
        [(0, $5fc53.TIME_TRACKING_GQL_FIELD)]: (0, $8uxcU.transformAggTimeTrackingToLegacyField),
        [(0, $5fc53.USER_PICKER_GQL_FIELD)]: (0, $6SWOK.transformAggSingleSelectUserPickerToLegacyField),
        [(0, $5fc53.URL_GQL_FIELD)]: (0, $arKlm.transformAggUrlToLegacyField),
        [(0, $5fc53.VERSION_GQL_FIELD)]: (0, $cMc7B.transformAggSingleVersionPickerToLegacyField),
        [(0, $5fc53.VOTES_GQL_FIELD)]: (0, $hCKV6.transformAggVotesToLegacyField),
        [(0, $5fc53.WATCHES_GQL_FIELD)]: (0, $d8wC0.transformAggWatchesToLegacyField),
        [(0, $5fc53.DATA_CLASSIFICATION_FIELD)]: (0, $1xW6n.transformAggDataClassificationToLegacyField),
        [(0, $5fc53.GOALS_GQL_FIELD)]: (0, $9UXU7.transformAggGoalsToLegacyField),
        [(0, $5fc53.JCS_ORGANIZATION_GQL_FIELD)]: (0, $640u2.transformAggJCSOrganizationToLegacyField)
    });
const $af5e8bab0defb9c8$var$getTransformers = (0, $8QpSo.default)($af5e8bab0defb9c8$var$getTransformersNonMemoised);
const $af5e8bab0defb9c8$export$586ba15cbf3d3031 = (node, projectContext)=>{
    const typename = node.__typename;
    const transformer = $af5e8bab0defb9c8$var$getTransformers()[typename];
    return transformer ? transformer(node, projectContext) : undefined;
};
const $af5e8bab0defb9c8$export$ba106ff8c087e6b1 = (fields, projectField)=>{
    if (fields == null) return {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields.reduce((fieldsState, fieldEdge)=>{
        if (fieldEdge?.node != null) {
            const projectContext = projectField != null ? projectField : (0, $hA3EZ.getProjectField)(fields)?.project;
            const transformedField = $af5e8bab0defb9c8$export$586ba15cbf3d3031(fieldEdge.node, projectContext);
            if (transformedField != null) {
                const fieldData = 'key' in transformedField ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                {
                    [transformedField.key]: transformedField
                } : transformedField;
                Object.assign(fieldsState, fieldData);
            }
        }
        return fieldsState;
    }, {});
};

});
parcelRegister("9bgym", function(module, exports) {

$parcel$export(module.exports, "transformAggAffectedServicesToLegacyField", () => $0bce5d1c363f27e8$export$231e0419515441d4);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices = ({ serviceId: serviceId, name: name })=>({
        id: serviceId,
        name: name ?? undefined
    });
const $0bce5d1c363f27e8$export$231e0419515441d4 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICE_ENTITY_CF_TYPE)) return undefined;
    const hasValue = Boolean(node.selectedAffectedServicesConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAffectedServicesConnection, $0bce5d1c363f27e8$var$transformJiraServicesToLegacyServices) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SERVICE_ENTITY_CF_TYPE),
            items: 'service-entity-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});
const $650578330a102f55$export$89b8c5d86c10a68c = 'atlassian-wiki-renderer';
const $650578330a102f55$export$a4a240cb4053b29f = 'jira-text-renderer';
const $650578330a102f55$export$840ed33fa94f7693 = 'frother-control-renderer';

parcelRegister("o7K5u", function(module, exports) {

$parcel$export(module.exports, "transformAggNodeToLegacyField", () => $cfa10031dfb7ad46$export$e7ea61856a169c36);
$parcel$export(module.exports, "transformAggConnection", () => $cfa10031dfb7ad46$export$daf92cda81d86cdc);
$parcel$export(module.exports, "toLegacyConnectOption", () => $cfa10031dfb7ad46$export$b5de5f3d2de73afc);
const $cfa10031dfb7ad46$export$e7ea61856a169c36 = (node)=>({
        ari: 'id' in node ? node.id : undefined,
        key: 'fieldId' in node && !!node.fieldId ? node.fieldId : '',
        title: 'name' in node ? node.name : '',
        editable: Boolean('isEditableInIssueView' in node ? node.isEditableInIssueView : 'fieldConfig' in node && node.fieldConfig != null && 'isEditable' in node.fieldConfig && node.fieldConfig.isEditable),
        required: Boolean('fieldConfig' in node && node.fieldConfig != null && 'isRequired' in node.fieldConfig && node.fieldConfig.isRequired),
        autoCompleteUrl: 'searchUrl' in node ? node.searchUrl : null,
        allowedValues: [],
        value: null,
        schema: {
            type: 'type' in node ? node.type : '',
            custom: null,
            system: null
        },
        description: 'description' in node && node.description ? node.description : undefined
    });
const $cfa10031dfb7ad46$export$daf92cda81d86cdc = (connection, transformCallback)=>{
    const edges = connection?.edges ?? [];
    if (transformCallback) return edges.map((edge)=>edge?.node != null ? transformCallback(edge.node) : null).filter(Boolean);
    return edges.map((edge)=>edge?.node).filter(Boolean);
};
const $cfa10031dfb7ad46$export$b5de5f3d2de73afc = (node)=>{
    if (!node) return null;
    return {
        value: node.value ?? null,
        id: parseInt(node.optionId, 10)
    };
};

});


parcelRegister("6iJEF", function(module, exports) {

$parcel$export(module.exports, "transformAggAssetToLegacyField", () => $b9f6b8590a60f3b3$export$2136dcd78a2ef18f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b9f6b8590a60f3b3$export$2136dcd78a2ef18f = (node)=>{
    switch(node.type){
        case 0, $5fc53.ASSETS_CF_TYPE:
            {
                const hasValue = Boolean(node.selectedAssetsConnection?.edges?.length);
                const assetValue = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedAssetsConnection, ({ appKey: appKey, originId: originId, serializedOrigin: serializedOrigin, value: value })=>({
                        appKey: appKey,
                        originId: originId,
                        serializedOrigin: serializedOrigin,
                        value: value
                    })) : null;
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    autoCompleteUrl: node.searchUrl,
                    value: assetValue,
                    schema: {
                        custom: node.type,
                        system: null,
                        items: 'sd-asset',
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("9UrtF", function(module, exports) {

$parcel$export(module.exports, "transformAggBooleanToLegacyField", () => $474331244347ccdb$export$4bd89b95f0d10de9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $474331244347ccdb$export$4bd89b95f0d10de9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: {
                    alertLinking: {
                        enabled: node.value
                    }
                },
                schema: {
                    configuration: null,
                    items: null,
                    renderer: null,
                    custom: null,
                    system: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE),
                    type: (0, $5fc53.SERVICEDESK_INCIDENT_MANAGEMENT_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hsEaK", function(module, exports) {

$parcel$export(module.exports, "transformAggCascadingSelectToLegacyField", () => $afb6a8576bf8d731$export$a8778af5ceb1017c);


var $o7K5u = parcelRequire("o7K5u");
const $afb6a8576bf8d731$export$a8778af5ceb1017c = (node)=>{
    let value = null;
    if (node.cascadingOption) {
        const { childOptionValue: childOptionValue, parentOptionValue: parentOptionValue } = node.cascadingOption;
        const child = childOptionValue ? {
            child: {
                id: childOptionValue.optionId,
                value: childOptionValue.value
            }
        } : {};
        value = {
            // assigned in the statement above
            id: parentOptionValue?.optionId,
            value: parentOptionValue?.value,
            ...child
        };
    }
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: [],
        schema: {
            type: 'option-with-child',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2qu1N", function(module, exports) {

$parcel$export(module.exports, "transformAggCheckboxToLegacyField", () => $3efe07b8b545ea99$export$baa5afdbd8fd12d3);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3efe07b8b545ea99$export$baa5afdbd8fd12d3 = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_CHECKBOXES_CF_TYPE:
            {
                // We're inlining the transformers per field here so it'll be easy to remove them once we make the allowedValues async
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                const allowedValues = (0, $o7K5u.transformAggConnection)(node.checkboxesFieldOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: allowedValues,
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("16Zia", function(module, exports) {

$parcel$export(module.exports, "transformAggCMDBToLegacyField", () => $4d2c21f2e394ef74$export$93506453d9bb56ae);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4d2c21f2e394ef74$var$transformObjectTypeToLegacy = (attribute, workspaceId)=>({
        workspaceId: workspaceId,
        id: `${workspaceId}:${attribute.objectTypeId}`,
        name: attribute.name,
        objectSchemaId: attribute.objectSchemaId,
        objectTypeId: attribute.objectTypeId,
        // `icon` is unused
        icon: {
            id: attribute.icon.id,
            name: attribute.icon.name,
            url16: attribute.icon.url16,
            url48: attribute.icon.url48
        }
    });
const $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration = (node)=>{
    if (!node.cmdbFieldConfig) return node.isInsightAvailable === false ? {
        isInsightAvailable: node.isInsightAvailable
    } : {};
    return {
        cmdbFieldConfig: {
            multiple: node.cmdbFieldConfig.multiple,
            objectSchemaId: node.cmdbFieldConfig.objectSchemaId.split('/')[2],
            attributesDisplayedOnIssue: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesDisplayedOnIssue),
            attributesIncludedInAutoCompleteSearch: (0, $o7K5u.transformAggConnection)(node.cmdbFieldConfig?.attributesIncludedInAutoCompleteSearch)
        },
        isInsightAvailable: node.isInsightAvailable,
        wasInsightRequestSuccessful: node.wasInsightRequestSuccessful
    };
};
const $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy = (type)=>{
    switch(type){
        case 'REFERENCED_OBJECT':
            return 1;
        case 'USER':
            return 2;
        case 'GROUP':
            return 4;
        case 'PROJECT':
            return 6;
        case 'STATUS':
            return 7;
        case 'BITBUCKET_REPO':
            return 8;
        case 'OPSGENIE_TEAM':
            return 9;
        case 'DEFAULT':
            return 0;
        default:
            // eslint-disable-next-line no-console
            console.error(new Error(`Unknown attribute type found in transformObjectTypeAttributeToLegacy: ${type}. Mapping type to '-1'`));
            return -1;
    }
};
const $4d2c21f2e394ef74$var$transformReferencedObject = (node)=>({
        id: node.objectGlobalId,
        workspaceId: node.workspaceId,
        objectKey: node.objectKey,
        label: node.label,
        avatar: node.avatar,
        objectId: node.objectId
    });
const $4d2c21f2e394ef74$var$transformCmdbUser = (node)=>({
        avatarUrl: node.picture,
        displayName: node.name,
        name: node.name,
        key: node.accountId
    });
const $4d2c21f2e394ef74$var$transformCmdbGroup = (node)=>({
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbProject = (node)=>({
        avatarUrl: node.avatar?.large,
        id: Number(node.id),
        key: node.key,
        name: node.name
    });
const $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo = (node)=>({
        uuid: node.uuid,
        name: node.name,
        url: node.url,
        avatarUrl: node.avatarUrl
    });
const $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam = (node)=>({
        id: node.id,
        name: node.name,
        url: node.url
    });
const $4d2c21f2e394ef74$var$transformCmdbStatus = (node)=>({
        id: node.id,
        name: node.name,
        category: node.category
    });
const $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy = (node)=>{
    if (!node) return null;
    const defaultObjectValue = {
        displayValue: node.displayValue,
        searchValue: node.searchValue,
        ...node.value != null ? {
            value: node.value
        } : {}
    };
    if (node.referencedObject) return {
        ...defaultObjectValue,
        referencedObject: $4d2c21f2e394ef74$var$transformReferencedObject(node.referencedObject)
    };
    if (node.user) return {
        ...defaultObjectValue,
        user: $4d2c21f2e394ef74$var$transformCmdbUser(node.user)
    };
    if (node.group) return {
        ...defaultObjectValue,
        group: $4d2c21f2e394ef74$var$transformCmdbGroup(node.group)
    };
    if (node.project) return {
        ...defaultObjectValue,
        project: $4d2c21f2e394ef74$var$transformCmdbProject(node.project)
    };
    if (node.bitbucketRepo) return {
        ...defaultObjectValue,
        bitbucketRepo: $4d2c21f2e394ef74$var$transformCmdbBitbucketRepo(node.bitbucketRepo)
    };
    if (node.opsgenieTeam) return {
        ...defaultObjectValue,
        opsgenieTeam: $4d2c21f2e394ef74$var$transformCmdbOpsgenieTeam(node.opsgenieTeam)
    };
    if (node.status) return {
        ...defaultObjectValue,
        status: $4d2c21f2e394ef74$var$transformCmdbStatus(node.status)
    };
    return defaultObjectValue;
};
const $4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes = (node, workspaceId)=>{
    if (!node) return null;
    const { objectTypeAttributeId: objectTypeAttributeId, objectTypeAttribute: objectTypeAttribute } = node;
    return {
        objectTypeAttributeId: objectTypeAttributeId,
        workspaceId: workspaceId,
        objectAttributeValues: (0, $o7K5u.transformAggConnection)(node.objectAttributeValues, $4d2c21f2e394ef74$var$transformObjectAttributeValuesToLegacy),
        objectTypeAttribute: {
            id: objectTypeAttributeId,
            label: objectTypeAttribute.label,
            name: objectTypeAttribute.name,
            workspaceId: workspaceId,
            type: $4d2c21f2e394ef74$var$transformObjectTypeAttributeToLegacy(objectTypeAttribute.type),
            ...objectTypeAttribute.defaultType ? {
                defaultType: {
                    id: objectTypeAttribute.defaultType.id,
                    name: objectTypeAttribute.defaultType.name
                }
            } : {}
        }
    };
};
const $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB = (node)=>{
    if (!node) return null;
    const { label: label, objectGlobalId: objectGlobalId, objectId: objectId, objectKey: objectKey, workspaceId: workspaceId, webUrl: webUrl, avatar: avatar } = node;
    return {
        attributes: (0, $o7K5u.transformAggConnection)(node.attributes, (nodeAttribute)=>$4d2c21f2e394ef74$var$transformObjectAttributesToLegacyObjectAttributes(nodeAttribute, workspaceId)),
        avatar: avatar,
        label: label,
        id: objectGlobalId,
        objectId: objectId,
        objectKey: objectKey,
        workspaceId: workspaceId,
        links: {
            self: webUrl
        },
        objectType: $4d2c21f2e394ef74$var$transformObjectTypeToLegacy(node.objectType, workspaceId)
    };
};
const $4d2c21f2e394ef74$export$93506453d9bb56ae = (node)=>{
    if (node.type !== (0, $5fc53.CMDB_OBJECT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?` : null,
        configuration: $4d2c21f2e394ef74$var$transformCMDBConfigurationToLegacyConfiguration(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedCmdbObjectsConnection, $4d2c21f2e394ef74$var$transformJiraCMDBToLegacyCMDB),
        schema: {
            configuration: null,
            custom: (0, $5fc53.CMDB_OBJECT_CF_TYPE),
            items: 'cmdb-object-field',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iv8Rf", function(module, exports) {

$parcel$export(module.exports, "transformAggColorToLegacyField", () => $b83a62ddd17b4586$export$587c178f1b45e5e9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b83a62ddd17b4586$export$587c178f1b45e5e9 = (node)=>{
    const value = node.color?.colorKey ?? null;
    switch(node.type){
        case 0, $5fc53.EPIC_COLOR_TYPE:
        case 0, $5fc53.COLOR_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: value,
                schema: {
                    configuration: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: node.type,
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("hDlc2", function(module, exports) {

$parcel$export(module.exports, "transformAggComponentsToLegacyField", () => $315456e18e2330f5$export$97a9275777684b77);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
// @DoNotExport Flow is deriving component's type
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $315456e18e2330f5$var$transformJiraComponentToLegacyComponent = (component)=>{
    if (component == null) return null;
    return {
        id: component.componentId,
        name: component.name,
        ari: component.ari,
        metadata: component.metadata
    };
};
const $315456e18e2330f5$export$97a9275777684b77 = (node)=>{
    if (node.type !== (0, $5fc53.COMPONENTS_TYPE)) return undefined;
    const value = (0, $o7K5u.transformAggConnection)(node.selectedComponentsConnection, $315456e18e2330f5$var$transformJiraComponentToLegacyComponent);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: value,
        schema: {
            configuration: null,
            items: 'component',
            renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            custom: null,
            system: (0, $5fc53.COMPONENTS_TYPE)
        }
    };
};

});

parcelRegister("c3LW9", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectDateTimeToLegacyField", () => $e80217ec1ee321d5$export$e6d015aa746cbdaf);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e80217ec1ee321d5$export$e6d015aa746cbdaf = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    });

});

parcelRegister("h92P3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectMultipleSelectToLegacyField", () => $1bb7cdf99e93ff64$export$edf5c98d20696686);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1bb7cdf99e93ff64$export$edf5c98d20696686 = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (0, $o7K5u.toLegacyConnectOption));
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.connectMultiSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length ? value : null,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE),
            configuration: null
        }
    };
};

});

parcelRegister("aeO9V", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectNumberToLegacyField", () => $b8a5823753f7873f$export$4638a5dd3285d8f2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b8a5823753f7873f$export$4638a5dd3285d8f2 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number ?? null,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    });

});

parcelRegister("6Tnq8", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectRichTextToLegacyField", () => $f9558299012f1c2e$export$11063e1f9210f191);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f9558299012f1c2e$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $f9558299012f1c2e$var$getPlainTextValue = (node)=>{
    if (!node.richText) return null;
    if (node.richText.plainText == null) return '';
    return node.richText.plainText;
};
const $f9558299012f1c2e$export$11063e1f9210f191 = (node)=>{
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    const values = isPlainTextRenderer ? {
        value: $f9558299012f1c2e$var$getPlainTextValue(node)
    } : {
        adfValue: node.richText?.adfValue?.json || $f9558299012f1c2e$var$emptyAdfObject
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        ...values,
        schema: {
            custom: (0, $5fc53.TEXT_AREA_CF_TYPE),
            renderer: renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            configuration: null,
            items: null
        }
    };
};

});
parcelRegister("dMYPq", function(module, exports) {

$parcel$export(module.exports, "default", () => $f4fed9edf4c76e19$export$2e2bcd8739ae039);

var $2YZCu = parcelRequire("2YZCu");
const $f4fed9edf4c76e19$export$c63f561360bafed1 = 'issue.agg-field-transformers.missing-renderer';
// If the renderer is missing, log an error and return true.
// This was added as part of https://jplat.atlassian.net/browse/JIV-14881 to help identify why
// fields are sometimes missing the renderer.
const $f4fed9edf4c76e19$var$isFieldMissingRenderer = (field)=>{
    try {
        // Narrow the type of field to fields with a renderer
        if (!('renderer' in field)) return false;
        if (field?.renderer) return false;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($f4fed9edf4c76e19$export$c63f561360bafed1, `Field ${field.fieldId} of type ${field.__typename} has missing renderer: ${field.renderer}`);
        return true;
    } catch  {
        return false;
    }
};
var $f4fed9edf4c76e19$export$2e2bcd8739ae039 = $f4fed9edf4c76e19$var$isFieldMissingRenderer;

});


parcelRegister("6mbsj", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectSingleSelectToLegacyField", () => $ceb0872dd5eafe49$export$e44db7cf61369a28);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $ceb0872dd5eafe49$export$e44db7cf61369a28 = (node)=>{
    let value = null;
    if (node.fieldOption != null) value = {
        id: parseInt(node.fieldOption?.optionId, 10),
        value: node.fieldOption?.value
    };
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: (0, $o7K5u.transformAggConnection)(node.connectSingleSelectFieldOptions, (0, $o7K5u.toLegacyConnectOption)),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            custom: node.type,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("d3nG3", function(module, exports) {

$parcel$export(module.exports, "transformAggConnectTextToLegacyField", () => $145b645a3d2e801e$export$dd05277f5aa90657);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $145b645a3d2e801e$export$dd05277f5aa90657 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("1xW6n", function(module, exports) {

$parcel$export(module.exports, "transformAggDataClassificationToLegacyField", () => $1a8d4561538d1d2b$export$b5edfdc89a7a2932);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1a8d4561538d1d2b$export$b5edfdc89a7a2932 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.DATA_CLASSIFICATION_TYPE),
        value: node,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            custom: null,
            system: null,
            type: (0, $5fc53.DATA_CLASSIFICATION_TYPE)
        }
    });

});

parcelRegister("fW9XR", function(module, exports) {

$parcel$export(module.exports, "transformAggDatePickerToLegacyField", () => $c44a652aaa9bff90$export$3d6e51d37c0454a9);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $c44a652aaa9bff90$export$3d6e51d37c0454a9 = (node)=>{
    switch(node.type){
        case 0, $5fc53.DUE_DATE_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    configuration: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: null,
                    items: null
                }
            };
        case 0, $5fc53.DATE_CF_TYPE:
        case 0, $5fc53.BASELINE_START_CF_TYPE:
        case 0, $5fc53.BASELINE_END_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: typeof node.date === 'string' ? node.date : null,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE),
                    custom: node.type,
                    configuration: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    system: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("bKMMB", function(module, exports) {

$parcel$export(module.exports, "transformAggDateTimePickerToLegacyField", () => $fb29b1af2f1467e0$export$3de22f1277f0c239);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $fb29b1af2f1467e0$var$defaultSchema = {
    type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE),
    custom: null,
    system: null,
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $fb29b1af2f1467e0$export$3de22f1277f0c239 = (node)=>{
    switch(node.type){
        case 0, $5fc53.CREATED:
        case 0, $5fc53.UPDATED:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime || '',
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.RESOLUTION_DATE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    system: node.type,
                    renderer: null
                }
            };
        case 0, $5fc53.DATETIME_CF_TYPE:
        case 0, $5fc53.FIRST_RESPONSE_DATE_CF_TYPE:
        case 0, $5fc53.REQUEST_FEEDBACK_DATE_CF_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.dateTime ?? null,
                schema: {
                    ...$fb29b1af2f1467e0$var$defaultSchema,
                    custom: node.type
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("7JL37", function(module, exports) {

$parcel$export(module.exports, "transformAggEpicLinkToLegacyField", () => $3279d658ea1a4982$export$1311f30c94840aa2);

var $7SCny = parcelRequire("7SCny");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink = (epic)=>{
    if (epic == null) return null;
    return {
        id: Number(epic.issueId),
        key: epic.key || '',
        done: !!epic.done,
        name: epic.name || '',
        summary: epic.summary || '',
        color: {
            key: epic.color ?? (0, $7SCny.AgileColors).AGILE_COLOR_1
        },
        // This can only be set from cache handlers
        fromCache: false
    };
};
const $3279d658ea1a4982$export$1311f30c94840aa2 = (node)=>{
    if (node.type !== (0, $5fc53.EPIC_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl,
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        value: $3279d658ea1a4982$var$transformJiraEpicToLegacyEpicLink(node.epic),
        schema: {
            configuration: null,
            items: null,
            renderer: 'jira-text-renderer',
            type: 'any',
            custom: (0, $5fc53.EPIC_TYPE),
            system: null
        }
    };
};

});

parcelRegister("dulCG", function(module, exports) {

$parcel$export(module.exports, "transformAggFlagToLegacyField", () => $f31e97d89b497c1c$export$31555b6ea19f4c2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag = (flag)=>{
    if (flag == null || flag.isFlagged == null) return null;
    return [
        {
            value: flag.isFlagged
        }
    ];
};
const $f31e97d89b497c1c$export$31555b6ea19f4c2 = (node)=>{
    // Agg flag field comes back as multichecbox CF type instead of current graphql flagged CF type
    if (node.type !== (0, $5fc53.MULTI_CHECKBOXES_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $f31e97d89b497c1c$var$transformJiraFlagToLegacyFlag(node.flag),
        schema: {
            configuration: null,
            custom: (0, $5fc53.FLAGGED_CF_TYPE),
            items: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6vno6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateToLegacyField", () => $f5e60b2709763004$export$30fccfce22948120);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $f5e60b2709763004$export$30fccfce22948120 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.date,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATE_CF_TYPE)
        }
    };
};

});

parcelRegister("as0vY", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeDateTimeToLegacyField", () => $3520698819975afe$export$61b1f0cbd04c7b9c);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $3520698819975afe$export$61b1f0cbd04c7b9c = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.dateTime,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_DATETIME_CF_TYPE)
        }
    };
};

});

parcelRegister("6dPLd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupToLegacyField", () => $ce6b58a5b1f45912$export$60b03d63015cbb9f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $ce6b58a5b1f45912$export$60b03d63015cbb9f = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedGroup ? {
            name: node.selectedGroup.name
        } : null,
        autoCompleteUrl: null,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE)
        }
    };
};

});

parcelRegister("gKccZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeGroupsToLegacyField", () => $256d8054300c3cdf$export$2dfa4944fba5d1f5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $256d8054300c3cdf$export$2dfa4944fba5d1f5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedGroupsConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, ({ name: name })=>({
            name: name
        })) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_SINGLE_GROUP_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("jnUrZ", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeNumberToLegacyField", () => $c68528ed0dfd109c$export$5dab8986dc45db07);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c68528ed0dfd109c$export$5dab8986dc45db07 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.number,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
        }
    };
};

});

parcelRegister("iJtmd", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeObjectToLegacyField", () => $c814454c00552e79$export$fbdabdbae2a203b9);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $c814454c00552e79$export$fbdabdbae2a203b9 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = (()=>{
        if (node.object == null) return null;
        try {
            return JSON.parse(node.object);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            throw new Error('Failed to transform forge object field: node.object was invalid JSON object');
        }
    })();
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_OBJECT_CF_TYPE)
        }
    };
};

});

parcelRegister("iPyq0", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringToLegacyField", () => $29f719811f573640$export$3a581fb4b3e578bd);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $29f719811f573640$export$3a581fb4b3e578bd = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("384lj", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeStringsToLegacyField", () => $0d30cb879c19e1ba$export$418a06cb5dc6aba5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $0d30cb879c19e1ba$export$418a06cb5dc6aba5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const hasValue = Boolean(node.selectedLabelsConnection?.edges?.length);
    const value = hasValue ? (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("axTS6", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUserToLegacyField", () => $0669940239efeaff$export$bc73c7a747f907e5);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $0669940239efeaff$export$bc73c7a747f907e5 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null,
        autoCompleteUrl: node.searchUrl,
        schema: {
            configuration: null,
            items: null,
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE)
        }
    };
};

});
parcelRegister("iob0v", function(module, exports) {

$parcel$export(module.exports, "transformJiraUserToLegacyServerUser", () => $42550039db1edc00$export$d7b231260a016eaf);

const $42550039db1edc00$var$getAccountType = (objectType)=>{
    switch(objectType){
        case 'AtlassianAccountUser':
            return 0, $145004f7a92e2423$export$981400c14dd99bc0;
        case 'CustomerUser':
            return 0, $145004f7a92e2423$export$2823897fb92cd040;
        case 'AppUser':
            return 0, $145004f7a92e2423$export$1973ca62b6c5abfe;
        default:
            return 0, $145004f7a92e2423$export$d1f5101c0939e3fe;
    }
};
const $42550039db1edc00$var$generateAvatarUrls = (url)=>({
        '16x16': url,
        '24x24': url,
        '32x32': url,
        '48x48': url
    });
const $42550039db1edc00$export$d7b231260a016eaf = (user)=>{
    if (!user) return null;
    const userOptionalKeysMap = {
        emailAddress: 'email',
        locale: 'locale',
        timeZone: 'zoneinfo'
    };
    const optionalValues = {};
    Object.entries(userOptionalKeysMap).forEach(([key, aggKey])=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const aggValue = user[aggKey];
        if (aggValue !== undefined && aggValue !== null) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        optionalValues[key] = aggValue;
    });
    const avatars = user.picture != null ? {
        avatarUrl: user.picture,
        avatarUrls: $42550039db1edc00$var$generateAvatarUrls(user.picture)
    } : {};
    return {
        ...avatars,
        ...optionalValues,
        accountId: user.accountId,
        accountType: $42550039db1edc00$var$getAccountType(user.__typename),
        active: user.accountStatus === 'active',
        displayName: user.name
    };
};

});
const $145004f7a92e2423$export$981400c14dd99bc0 = 'atlassian';
const $145004f7a92e2423$export$2823897fb92cd040 = 'customer';
const $145004f7a92e2423$export$1973ca62b6c5abfe = 'app';
const $145004f7a92e2423$export$d1f5101c0939e3fe = 'unknown';



parcelRegister("lfJ6H", function(module, exports) {

$parcel$export(module.exports, "transformAggForgeUsersToLegacyField", () => $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");

var $iob0v = parcelRequire("iob0v");
const $eb3ddd1fb571c94a$export$bbfea2e2f2c853b8 = (node)=>{
    if ((0, $dMYPq.default)(node)) return undefined;
    const value = node.selectedUsersConnection?.edges?.length ? (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser)) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            items: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
            system: null,
            custom: node.type,
            renderer: node.renderer,
            type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE)
        }
    };
};

});

parcelRegister("9UXU7", function(module, exports) {

$parcel$export(module.exports, "transformAggGoalsToLegacyField", () => $a8d444f432651533$export$158301a02ae4cbe7);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a8d444f432651533$export$158301a02ae4cbe7 = (node)=>{
    if (node.type !== (0, $5fc53.GOALS_CF_TYPE)) return undefined;
    const value = node.selectedGoals ? {
        goals: node.selectedGoals?.edges?.filter((edge)=>edge?.node !== null).map((edge)=>({
                id: edge?.node?.id || '',
                name: edge?.node?.name || '',
                status: edge?.node?.status || null
            })) || [],
        totalCount: node.selectedGoals?.totalCount || 0
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.GOALS_CF_TYPE),
            items: null,
            renderer: null,
            system: null,
            type: (0, $5fc53.GOALS_CF_TYPE)
        }
    };
};

});

parcelRegister("b6BoU", function(module, exports) {

$parcel$export(module.exports, "transformAggIssueRestrictionToLegacyField", () => $d0a0e03637cc83cd$export$62db794d5816e28e);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d0a0e03637cc83cd$var$transformJiraRoleToRestriction = (role)=>{
    if (role == null) return null;
    return {
        restrictionValue: role.roleId
    };
};
const $d0a0e03637cc83cd$export$62db794d5816e28e = (node, projectContext)=>{
    if (node.type !== (0, $5fc53.ISSUE_RESTRICTION_TYPE)) return undefined;
    const roles = (0, $o7K5u.transformAggConnection)(node.selectedRolesConnection, $d0a0e03637cc83cd$var$transformJiraRoleToRestriction);
    const restrictions = roles.length > 0 ? {
        projectrole: roles
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            shouldDisplay: projectContext?.canSetIssueRestriction === true,
            issuerestrictions: restrictions
        },
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_RESTRICTION_TYPE),
            custom: null,
            system: node.type
        }
    };
};

});

parcelRegister("gak3n", function(module, exports) {

$parcel$export(module.exports, "getSystemAggJiraIssueType", () => $4f9b530de681b60e$export$b4644a0cc2f2935e);
$parcel$export(module.exports, "transformJiraIssueTypeToLegacyIssueType", () => $4f9b530de681b60e$export$2356062173546155);
$parcel$export(module.exports, "transformAggIssueTypeToLegacyField", () => $4f9b530de681b60e$export$de2eb3b47c7c887b);


var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $4f9b530de681b60e$export$d95e76b2d065f98d = {
    avatarId: 0,
    self: ''
};
const $4f9b530de681b60e$export$b4644a0cc2f2935e = (fields)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const issueTypeField = fields?.find((edge)=>edge?.node != null && edge.node.__typename === (0, $5fc53.ISSUE_TYPE_GQL_FIELD) && edge.node.type === (0, $5fc53.ISSUE_TYPE))?.node;
    if (issueTypeField == null || issueTypeField.__typename !== (0, $5fc53.ISSUE_TYPE_GQL_FIELD) || issueTypeField.type !== (0, $5fc53.ISSUE_TYPE)) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)} with ${(0, $5fc53.ISSUE_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (issueTypeField.issueType == null) throw new Error(`Failed to get system issue type: ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}.issueType is missing [${JSON.stringify(issueTypeField)}]`);
    return issueTypeField.issueType;
};
const $4f9b530de681b60e$export$2356062173546155 = (issueType)=>({
        ...$4f9b530de681b60e$export$d95e76b2d065f98d,
        id: issueType.issueTypeId,
        iconUrl: issueType.avatar?.medium ?? '',
        name: issueType.name,
        description: 'description' in issueType && issueType.description != null ? issueType.description : '',
        hierarchyLevel: issueType.hierarchy.level,
        subtask: issueType.hierarchy.level === (0, $imYFg.ISSUE_TYPE_HIERARCHY_LEVEL).SUBTASK_LEVEL
    });
const $4f9b530de681b60e$export$de2eb3b47c7c887b = (node)=>{
    if (node.type !== (0, $5fc53.ISSUE_TYPE) || node.issueType == null) throw new Error(`Failed to transform ${(0, $5fc53.ISSUE_TYPE_GQL_FIELD)}: type is not ${(0, $5fc53.ISSUE_TYPE)} or 'issueType' is empty [${JSON.stringify(node)}]`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $4f9b530de681b60e$export$2356062173546155(node.issueType),
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.ISSUE_TYPE),
            type: (0, $5fc53.ISSUE_TYPE)
        }
    };
};

});
parcelRegister("imYFg", function(module, exports) {

$parcel$export(module.exports, "ISSUE_TYPE_HIERARCHY_LEVEL", () => $ccb1a8095461a82a$export$2fe6880f0073407c);

var $g4tDr = parcelRequire("g4tDr");
const $ccb1a8095461a82a$export$2fe6880f0073407c = {
    SUBTASK_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_SUBTASK),
    BASE_LEVEL: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_BASE),
    LEVEL_ONE: (0, $g4tDr.ISSUE_HIERARCHY_LEVEL_EPIC),
    LEVEL_TWO: 2
};

});


parcelRegister("i47fO", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMApprovalsToLegacyField", () => $448e6754d8bf50d1$export$b14d30f2a9e4c343);

var $9ar3z = parcelRequire("9ar3z");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy = (approverPrincipal)=>{
    if (!approverPrincipal) return undefined;
    switch(approverPrincipal.__typename){
        case 0, $5fc53.JSM_USER_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $g5X3G.toAccountId)(approverPrincipal.user.accountId),
                name: approverPrincipal.user.name,
                meta: {
                    jiraRest: approverPrincipal.jiraRest
                },
                type: 'user',
                avatarUrl: approverPrincipal.user.picture
            };
        case 0, $5fc53.JSM_GROUP_APPROVER_PRINCIPAL_FIELD:
            return {
                id: (0, $9ar3z.toGroupId)(approverPrincipal.groupId),
                meta: {
                    memberCount: approverPrincipal.memberCount,
                    approvedCount: approverPrincipal.approvedCount
                },
                name: approverPrincipal.name,
                type: 'group'
            };
        default:
            return undefined;
    }
};
const $448e6754d8bf50d1$var$getApproverDecision = (decision)=>{
    switch(decision){
        case 0, $9ar3z.APPROVER_APPROVED:
            return 0, $9ar3z.APPROVER_APPROVED;
        case 0, $9ar3z.APPROVER_DECLINED:
            return 0, $9ar3z.APPROVER_DECLINED;
        case 0, $9ar3z.APPROVER_PENDING:
        default:
            return 0, $9ar3z.APPROVER_PENDING;
    }
};
const $448e6754d8bf50d1$var$transformApproverToLegacy = (approvalNode)=>{
    if (!approvalNode) return undefined;
    const approver = (0, $iob0v.transformJiraUserToLegacyServerUser)(approvalNode.approver);
    if (!approver) return undefined;
    return {
        approverDecision: $448e6754d8bf50d1$var$getApproverDecision(approvalNode.approverDecision),
        approver: approver
    };
};
const $448e6754d8bf50d1$var$transformConfigurationToLegacy = (configurations)=>{
    // This function contains a lot of null checks and default empty values to satisfy flow because
    // the AGG type coming back is in the shape of [JiraServiceManagementApprovalConfiguration]
    // Which means technically it can be an empty array. Even though we will always only ever
    // get 1 object back.
    const { approversConfigurations: approversConfigurations = [], condition: condition } = configurations?.[0] || {};
    const approverConfiguration = approversConfigurations[0];
    return {
        approvers: {
            type: approverConfiguration?.type ?? '',
            customFieldName: approverConfiguration?.fieldName ?? '',
            customFieldId: approverConfiguration?.fieldId ?? ''
        },
        condition: {
            type: condition?.type ?? '',
            value: condition?.value ?? ''
        }
    };
};
const $448e6754d8bf50d1$var$transformDateToLegacy = (date)=>({
        epochMillis: new Date(date).valueOf()
    });
const $448e6754d8bf50d1$var$transformStatusToLegacy = (status)=>({
        name: status.name || '',
        category: Number(status.categoryId)
    });
const $448e6754d8bf50d1$var$transformActiveApprovalToLegacy = (activeApproval)=>{
    const { id: id, configurations: configurations, status: status, createdDate: createdDate, canAnswerApproval: canAnswerApproval, pendingApprovalCount: pendingApprovalCount, name: name, finalDecision: finalDecision, approvalState: approvalState, approvedStatus: approvedStatus } = activeApproval;
    return {
        id: id,
        approvalState: approvalState,
        approvedStatus: approvedStatus,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        name: name,
        pendingApprovalCount: pendingApprovalCount,
        canAnswerApproval: canAnswerApproval,
        approverPrincipals: (0, $o7K5u.transformAggConnection)(activeApproval.approverPrincipals, $448e6754d8bf50d1$var$transformApproverPrincipalsToLegacy),
        approvers: (0, $o7K5u.transformAggConnection)(activeApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy),
        configuration: $448e6754d8bf50d1$var$transformConfigurationToLegacy(configurations),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        decisions: (0, $o7K5u.transformAggConnection)(activeApproval.decisions, $448e6754d8bf50d1$var$transformApproverToLegacy),
        excludedApprovers: (0, $o7K5u.transformAggConnection)(activeApproval.excludedApprovers, (0, $iob0v.transformJiraUserToLegacyServerUser)),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null
    };
};
const $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy = (completedApproval)=>{
    if (!completedApproval) return undefined;
    const { id: id, name: name, finalDecision: finalDecision, createdDate: createdDate, completedDate: completedDate, status: status } = completedApproval;
    return {
        id: id,
        name: name,
        finalDecision: $448e6754d8bf50d1$var$getApproverDecision(finalDecision),
        createdDate: $448e6754d8bf50d1$var$transformDateToLegacy(createdDate ?? ''),
        completedDate: $448e6754d8bf50d1$var$transformDateToLegacy(completedDate),
        status: status ? $448e6754d8bf50d1$var$transformStatusToLegacy(status) : null,
        approvers: (0, $o7K5u.transformAggConnection)(completedApproval.approvers, $448e6754d8bf50d1$var$transformApproverToLegacy)
    };
};
const $448e6754d8bf50d1$export$b14d30f2a9e4c343 = (node)=>{
    if (node.type !== (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)) return undefined;
    const activeApproval = node.activeApproval ? {
        activeApproval: $448e6754d8bf50d1$var$transformActiveApprovalToLegacy(node.activeApproval)
    } : {};
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...activeApproval,
            completedApprovals: (0, $o7K5u.transformAggConnection)(node.completedApprovalsConnection, $448e6754d8bf50d1$var$transformCompletedApprovalToLegacy)
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE),
            type: (0, $5fc53.SERVICEDESK_APPROVAL_TYPE)
        }
    };
};

});
parcelRegister("9ar3z", function(module, exports) {

$parcel$export(module.exports, "toGroupId", () => $4a7fc5eda3865b0e$export$779c261480444a4d);
$parcel$export(module.exports, "APPROVER_PENDING", () => $4a7fc5eda3865b0e$export$3b59c4db06f5829b);
$parcel$export(module.exports, "APPROVER_APPROVED", () => $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4);
$parcel$export(module.exports, "APPROVER_DECLINED", () => $4a7fc5eda3865b0e$export$b5a0d270c9cd7435);
$parcel$export(module.exports, "APPROVAL_OK", () => $4a7fc5eda3865b0e$export$2e6187b6a4348938);
const $4a7fc5eda3865b0e$export$779c261480444a4d = (x)=>x;
const $4a7fc5eda3865b0e$export$3b59c4db06f5829b = 'pending';
const $4a7fc5eda3865b0e$export$e17ae8ca1010e2a4 = 'approved';
const $4a7fc5eda3865b0e$export$b5a0d270c9cd7435 = 'declined';
const $4a7fc5eda3865b0e$export$2e6187b6a4348938 = 'OK';
const $4a7fc5eda3865b0e$export$b5d660d719b8009 = 'INSUFFICIENT_APPROVERS';

});


parcelRegister("gvljZ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMEntitlementsToLegacyField", () => $b281bef34e07e20f$export$850fadda8a5e6f27);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b281bef34e07e20f$export$850fadda8a5e6f27 = (node)=>{
    if (node.type !== (0, $5fc53.ENTITLEMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedEntitlement,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ENTITLEMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("6XFn2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMMajorIncidentToLegacyField", () => $926c732f6621d9fd$export$d4e0b2288fb31144);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $926c732f6621d9fd$export$d4e0b2288fb31144 = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.majorIncident,
        renderedValue: null,
        configuration: {},
        schema: {
            configuration: null,
            custom: (0, $5fc53.MAJOR_INCIDENT_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    });

});

parcelRegister("6e1Ya", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMOrganizationToLegacyField", () => $0e4eebb31cef7087$export$7bd14951253a7c5f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0e4eebb31cef7087$export$7bd14951253a7c5f = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATIONS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: (0, $o7K5u.transformAggConnection)(node.selectedOrganizationsConnection, (selectedNode)=>({
                id: selectedNode.organizationId,
                name: selectedNode.organizationName
            })),
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATIONS_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("640u2", function(module, exports) {

$parcel$export(module.exports, "transformAggJCSOrganizationToLegacyField", () => $84b085b51db539b3$export$81bfe5b16f9be413);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $84b085b51db539b3$export$81bfe5b16f9be413 = (node)=>{
    if (node.type !== (0, $5fc53.ORGANIZATION_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.selectedOrganization,
        schema: {
            configuration: null,
            custom: (0, $5fc53.ORGANIZATION_CF_TYPE),
            items: 'sd-customerorganization',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("hBEiJ", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestFeedbackToLegacyField", () => $841fa8e5b9308ced$export$c52c6988b335096);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $841fa8e5b9308ced$export$c52c6988b335096 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.feedback,
        schema: {
            type: 'sd-feedback',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_FEEDBACK_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("1XNj2", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestLanguageToLegacyField", () => $1edf1c9b37cdb462$export$6a53240e225f742);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $1edf1c9b37cdb462$export$6a53240e225f742 = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.language,
        allowedValues: [
            ...node.languages ?? []
        ],
        schema: {
            type: 'sd-request-lang',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: (0, $5fc53.REQUEST_LANGUAGE_CF_TYPE),
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("f6zXW", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRequestTypeToLegacyField", () => $8030de3237296d5c$export$5ffaab1383177efa);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $8030de3237296d5c$var$transformRequestTypeToLegacy = (requestType)=>{
    if (!requestType) return null;
    return {
        requestType: {
            id: parseInt(requestType.requestTypeId, 10),
            issueTypeId: requestType.issueType?.issueTypeId || '',
            name: requestType.name || '',
            icon: {
                _links: {
                    iconUrls: {
                        '48x48': requestType.avatar?.large || ''
                    }
                }
            }
        }
    };
};
const $8030de3237296d5c$export$5ffaab1383177efa = (node)=>{
    if (node.type !== (0, $5fc53.REQUEST_TYPE_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...' is not assignable to parameter of type '{ readonly avatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly id: string; readonly issueType: { ...; } | ... 1 more ... | undefined; readonly name: strin...'.
        value: $8030de3237296d5c$var$transformRequestTypeToLegacy(node.requestType),
        schema: {
            configuration: null,
            custom: (0, $5fc53.REQUEST_TYPE_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'sd-customerrequesttype'
        }
    };
};

});

parcelRegister("fB4wX", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMRespondersToLegacyField", () => $0ea07ade045943f7$export$5171c4d1ae5bcde5);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder = (responder)=>{
    if (responder == null) return undefined;
    switch(responder.__typename){
        case 0, $5fc53.JSM_USER_RESPONDER_GQL_FIELD:
            if (responder.user === null) return undefined;
            return {
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                ari: responder.user.canonicalAccountId,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                avatarUrl: responder.user.picture,
                // @ts-expect-error - 'responder.user' is possibly 'undefined'.
                name: responder.user.name,
                type: 'user'
            };
        case 0, $5fc53.JSM_TEAM_RESPONDER_FIELD:
            return {
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                ari: responder.teamId,
                // @ts-expect-error - Type 'string | null | undefined' is not assignable to type 'string | null'.
                name: responder.teamName,
                type: 'team'
            };
        default:
            return undefined;
    }
};
const $0ea07ade045943f7$export$5171c4d1ae5bcde5 = (node)=>{
    if (node.type !== (0, $5fc53.RESPONDERS_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        autoCompleteUrl: node.searchUrl != null ? `${node.searchUrl}?query=` : null,
        value: (0, $o7K5u.transformAggConnection)(node.respondersConnection, $0ea07ade045943f7$var$transformJiraResponderToLegacyResponder),
        schema: {
            configuration: null,
            custom: (0, $5fc53.RESPONDERS_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("cXBkk", function(module, exports) {

$parcel$export(module.exports, "transformAggJSMSentimentToLegacyField", () => $5dcf9f49c6a1536d$export$702d3754a4c7d90a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5dcf9f49c6a1536d$export$702d3754a4c7d90a = (node)=>{
    if (node.type !== (0, $5fc53.SENTIMENT_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.sentiment,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SENTIMENT_CF_TYPE),
            items: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("iDKu3", function(module, exports) {

$parcel$export(module.exports, "transformAggLabelsNodeToLegacyField", () => $5345161012c71e28$export$98e4f56e2e6c44fe);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $5345161012c71e28$var$defaultSchema = {
    configuration: null,
    items: 'string',
    type: (0, $5fc53.ISSUE_FIELD_MULTI_SELECT_CF_TYPE),
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $5345161012c71e28$export$98e4f56e2e6c44fe = (node)=>{
    const selectedLabels = (0, $o7K5u.transformAggConnection)(node.selectedLabelsConnection, ({ name: name })=>name);
    switch(node.type){
        case 0, $5fc53.LABELS_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.LABELS_CF_TYPE:
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                // empty value for custom labels field is null while system labels field is `[]`
                value: selectedLabels.length === 0 ? null : selectedLabels,
                schema: {
                    ...$5345161012c71e28$var$defaultSchema,
                    custom: node.type,
                    system: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("aGv90", function(module, exports) {

$parcel$export(module.exports, "transformAggMultiGroupPickerToLegacyField", () => $ee565846dd4aef42$export$f968da580693597d);


var $o7K5u = parcelRequire("o7K5u");
const $ee565846dd4aef42$export$f968da580693597d = (node)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedGroupsConnection, (groupNode)=>({
            groupId: groupNode.groupId,
            name: groupNode.name
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            type: 'array',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: 'group',
            configuration: null
        }
    };
};

});

parcelRegister("19DRh", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleSelectToLegacyField", () => $d83d25c034b1d99f$export$869fb8fbcb97e0ee);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $d83d25c034b1d99f$export$869fb8fbcb97e0ee = (node)=>{
    switch(node.type){
        case 0, $5fc53.MULTI_SELECT_CF_TYPE:
            {
                const value = (0, $o7K5u.transformAggConnection)(node.selectedOptions, (option)=>({
                        id: option.optionId,
                        value: option.value ?? null,
                        ari: option.id
                    }));
                return {
                    ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                    value: value.length ? value : null,
                    allowedValues: [],
                    schema: {
                        type: 'array',
                        renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                        custom: node.type,
                        system: null,
                        items: 'option',
                        configuration: null
                    }
                };
            }
        default:
            return undefined;
    }
};

});

parcelRegister("lkW3a", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleUserPickerToLegacyField", () => $9b1f1d40e628c968$export$cdd9991119eb040e);

var $2vSU6 = parcelRequire("2vSU6");


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $hA3EZ = parcelRequire("hA3EZ");

var $iob0v = parcelRequire("iob0v");
const $9b1f1d40e628c968$export$cdd9991119eb040e = (node, projectContext)=>{
    const value = (0, $o7K5u.transformAggConnection)(node.selectedUsersConnection, (0, $iob0v.transformJiraUserToLegacyServerUser));
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value.length > 0 ? value : null,
        schema: {
            configuration: null,
            custom: node.type,
            items: 'user',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
    switch(node.type){
        case 0, $5fc53.REQUEST_PARTICIPANTS_CF_TYPE:
            if (node.__typename === (0, $5fc53.MULTI_USER_PICKER_GQL_FIELD)) return {
                ...legacyFieldValues,
                value: value
            };
            if ((0, $hA3EZ.getProjectType)(projectContext?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
            // Empty array is the expected value when there are no request
            // participants.
            return {
                ...legacyFieldValues,
                value: value
            };
        case 0, $5fc53.PARTICIPANTS_CF_TYPE:
        case 0, $5fc53.MULTI_USER_CF_TYPE:
            return legacyFieldValues;
        case 0, $5fc53.APPROVERS_LIST_CF_TYPE:
        case 0, $5fc53.PEOPLE_CF_TYPE:
            {
                const schemaConfig = 'isMulti' in node && node.isMulti != null ? [
                    {
                        key: 'isMulti',
                        value: String(node.isMulti)
                    }
                ] : null;
                return {
                    ...legacyFieldValues,
                    autoCompleteUrl: node.searchUrl,
                    schema: {
                        ...legacyFieldValues.schema,
                        configuration: schemaConfig
                    }
                };
            }
        default:
            return undefined;
    }
};

});
parcelRegister("hA3EZ", function(module, exports) {

$parcel$export(module.exports, "getProjectType", () => $e3d5807b112803bd$export$3dd0da95519c1a33);
$parcel$export(module.exports, "getProjectField", () => $e3d5807b112803bd$export$b19207d974ad5e77);
$parcel$export(module.exports, "getSystemAggJiraProject", () => $e3d5807b112803bd$export$d100105d56da4a0a);
$parcel$export(module.exports, "isAggJiraProjectClassic", () => $e3d5807b112803bd$export$3502ed01c034e451);
$parcel$export(module.exports, "transformAggSystemProjectToProjectContext", () => $e3d5807b112803bd$export$77162d1422f22f47);
$parcel$export(module.exports, "transformAggProjectToLegacyField", () => $e3d5807b112803bd$export$30c14b802399f417);

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");



var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $o7K5u = parcelRequire("o7K5u");
const $e3d5807b112803bd$var$getProjectStatus = (status)=>{
    switch(status){
        case 'ACTIVE':
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
        case 'ARCHIVED':
            return 0, $cd476f3ecebdab63$export$4ccc35479ba9ad1;
        case 'DELETED':
            return 0, $cd476f3ecebdab63$export$a95d71e582b8bc0;
        default:
            // Based on `getProjectStatus` from src/packages/issue/issue-view/src/common/service/issue/issue-transformer.js
            return 0, $cd476f3ecebdab63$export$62113557945f790a;
    }
};
const $e3d5807b112803bd$export$3dd0da95519c1a33 = (projectType)=>{
    if (projectType === 'CUSTOMER_SERVICE' && (0, $4R6GH.fg)('jcs_project_type_m3')) return 0, $2vSU6.CUSTOMER_SERVICE_PROJECT;
    switch(projectType){
        case 'SERVICE_DESK':
            return 0, $2vSU6.SERVICE_DESK_PROJECT;
        case 'BUSINESS':
            return 0, $2vSU6.CORE_PROJECT;
        case 'SOFTWARE':
            return 0, $2vSU6.SOFTWARE_PROJECT;
        case 'PRODUCT_DISCOVERY':
            return 0, $2vSU6.PRODUCT_DISCOVERY_PROJECT;
        default:
            return null;
    }
};
const $e3d5807b112803bd$export$b19207d974ad5e77 = (fields)=>{
    /**
	 * The only way to get the type to return an optional value with `AggJiraProject` type
	 * is to re-assign the type wihtout throwing an error.
	 */ // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return fields?.find((edge)=>edge?.node?.__typename === (0, $5fc53.PROJECT_GQL_FIELD) && edge?.node?.type != null && edge.node.type === (0, $5fc53.PROJECT_TYPE))?.node;
};
const $e3d5807b112803bd$export$d100105d56da4a0a = (fields)=>{
    /**
	 * We only want the system `PROJECT_TYPE` field.
	 * For custom fields, e.g., project picker, see `transformAggProjectToLegacyField`
	 */ const projectField = $e3d5807b112803bd$export$b19207d974ad5e77(fields);
    // Needs the `PROJECT_GQL_FIELD` refinement so we can return as `AggJiraProject`
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(fields ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    return projectField.project;
};
const $e3d5807b112803bd$export$f7d5cb97957d02e3 = (project)=>project?.projectStyle === 'TEAM_MANAGED_PROJECT';
const $e3d5807b112803bd$export$3502ed01c034e451 = (project)=>!$e3d5807b112803bd$export$f7d5cb97957d02e3(project);
const $e3d5807b112803bd$var$transformAggProjectToServerProjectOption = (project)=>{
    if (project == null) return null;
    const { projectId: projectId, key: key, name: name, avatar: avatar } = project;
    return {
        name: name,
        id: projectId ?? undefined,
        key: (0, $g5X3G.toProjectKey)(key),
        avatarUrls: {
            '48x48': avatar?.large || ''
        }
    };
};
const $e3d5807b112803bd$export$77162d1422f22f47 = (project)=>{
    const { projectId: projectId, name: name, key: key, avatar: avatar, status: status, projectType: type, navigationMetadata: navigationMetadata } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform system project: projectType ${String(type)} was invalid`);
    return {
        projectId: projectId,
        projectType: projectType,
        projectName: name,
        projectKey: key,
        projectStatus: $e3d5807b112803bd$var$getProjectStatus(status),
        avatarUrl: avatar?.medium,
        isSimplified: $e3d5807b112803bd$export$f7d5cb97957d02e3(project),
        boardId: navigationMetadata?.boardId
    };
};
const $e3d5807b112803bd$export$275f121d4e6f5165 = (fields)=>{
    const project = $e3d5807b112803bd$export$d100105d56da4a0a(fields);
    return $e3d5807b112803bd$export$77162d1422f22f47(project);
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: $e3d5807b112803bd$var$transformAggProjectToServerProjectOption(node.project),
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.PROJECT_TYPE),
            custom: (0, $5fc53.PROJECT_PICKER_CF_TYPE),
            system: null
        }
    });
const $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField = (node)=>{
    // Similar issues field only exist in JSM projects
    if ($e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType) !== (0, $2vSU6.SERVICE_DESK_PROJECT)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        key: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        title: (0, $5fc53.SIMILAR_ISSUES_TYPE),
        value: node.project?.similarIssues?.featureEnabled === true,
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.SIMILAR_ISSUES_TYPE),
            custom: null,
            system: (0, $5fc53.SIMILAR_ISSUES_TYPE)
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField = (node)=>{
    if (node?.__typename !== (0, $5fc53.PROJECT_GQL_FIELD) || node?.type === null || node?.type !== (0, $5fc53.PROJECT_TYPE)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node)}]`);
    const projectField = node;
    if (projectField == null || projectField.__typename !== (0, $5fc53.PROJECT_GQL_FIELD)) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)} with ${(0, $5fc53.PROJECT_TYPE)} 'fieldId' and 'type' not found [${JSON.stringify(node ?? '')}]`);
    if (projectField.project == null) throw new Error(`Failed to get system project data: ${(0, $5fc53.PROJECT_GQL_FIELD)}.project is missing [${JSON.stringify(projectField)}]`);
    const project = projectField.project;
    const { projectType: type } = project;
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(type);
    if (projectType == null) throw new Error(`Failed to transform project: projectType ${String(project?.projectType)} was invalid`);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            projectType: projectType
        }
    };
};
const $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType = (node)=>{
    const projectType = $e3d5807b112803bd$export$3dd0da95519c1a33(node.project?.projectType);
    if (projectType === (0, $2vSU6.SERVICE_DESK_PROJECT)) // Similar issues field only exist in JSM projects
    return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
    if (projectType === (0, $2vSU6.PRODUCT_DISCOVERY_PROJECT)) return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectField(node);
    return undefined;
};
const $e3d5807b112803bd$export$30c14b802399f417 = (node)=>{
    if ((0, $4R6GH.fg)('jpd_idea_panel_in_issue_view')) switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacyFieldByType(node);
        default:
            return undefined;
    }
    else switch(node.type){
        case 0, $5fc53.PROJECT_PICKER_CF_TYPE:
            return $e3d5807b112803bd$var$transformAggProjectToLegacyProjectPickerField(node);
        case 0, $5fc53.PROJECT_TYPE:
            // For the system project, see `transformAggProjectToProjectContext`
            return $e3d5807b112803bd$var$transformAggProjectToLegacySimilarIssuesField(node);
        default:
            return undefined;
    }
};

});
const $cd476f3ecebdab63$export$62113557945f790a = 'PROJECT_ACTIVE';
const $cd476f3ecebdab63$export$4ccc35479ba9ad1 = 'PROJECT_ARCHIVED';
const $cd476f3ecebdab63$export$a95d71e582b8bc0 = 'PROJECT_TRASHED';



parcelRegister("lQAwK", function(module, exports) {

$parcel$export(module.exports, "transformAggMultipleVersionPickerToLegacyField", () => $dc0acfee4cadcdcd$export$6207ea60703068d8);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $dc0acfee4cadcdcd$var$defaultSchema = {
    configuration: null,
    custom: null,
    items: 'version',
    renderer: (0, $650578330a102f55$export$840ed33fa94f7693),
    system: null,
    type: 'array'
};
const $dc0acfee4cadcdcd$export$6207ea60703068d8 = (node)=>{
    if (node.type !== (0, $5fc53.MULTI_VERSION_CF_TYPE) && node.type !== (0, $5fc53.AFFECTS_VERSIONS_TYPE) && node.type !== (0, $5fc53.FIX_VERSIONS_TYPE)) return undefined;
    const legacyFieldValues = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: [],
        value: (0, $o7K5u.transformAggConnection)(node.selectedVersionsConnection, (0, $149sa.transformAggVersionToLegacyVersion))
    };
    switch(node.type){
        case 0, $5fc53.MULTI_VERSION_CF_TYPE:
            return {
                ...legacyFieldValues,
                value: legacyFieldValues.value.length === 0 ? null : legacyFieldValues.value,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    custom: (0, $5fc53.MULTI_VERSION_CF_TYPE)
                }
            };
        case 0, $5fc53.AFFECTS_VERSIONS_TYPE:
        case 0, $5fc53.FIX_VERSIONS_TYPE:
            return {
                ...legacyFieldValues,
                schema: {
                    ...$dc0acfee4cadcdcd$var$defaultSchema,
                    system: node.type
                }
            };
        default:
            return undefined;
    }
};

});
parcelRegister("149sa", function(module, exports) {

$parcel$export(module.exports, "transformAggVersionToLegacyVersion", () => $4617842fe98d5759$export$becef8d087e8b62b);

var $jPhQo = parcelRequire("jPhQo");
const $4617842fe98d5759$export$becef8d087e8b62b = (version)=>({
        id: version.versionId ?? '',
        name: version.name ?? '',
        description: version.description ?? '',
        archived: version.status === (0, $jPhQo.VersionStatus).ARCHIVED,
        released: version.status === (0, $jPhQo.VersionStatus).RELEASED,
        ari: version.id
    });

});
parcelRegister("jPhQo", function(module, exports) {

$parcel$export(module.exports, "VersionStatus", () => $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports




var $imYFg = parcelRequire("imYFg");

var $5fc53 = parcelRequire("5fc53");

const $b5bd69c03cab3461$export$8c6e0f93bfb5c6a4 = {
    ARCHIVED: 'ARCHIVED',
    RELEASED: 'RELEASED',
    UNRELEASED: 'UNRELEASED'
};

});



parcelRegister("8qOI6", function(module, exports) {

$parcel$export(module.exports, "transformAggNumberToLegacyField", () => $b542e2b397d83c88$export$d754a24ed0096d2f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b542e2b397d83c88$export$d754a24ed0096d2f = (node)=>{
    const fieldType = node.isStoryPointField === true ? (0, $5fc53.STORY_POINTS_TYPE) : node.type;
    switch(fieldType){
        case 0, $5fc53.NUMBER_CF_TYPE:
        case 0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE:
        case 0, $5fc53.STORY_POINTS_TYPE:
            return {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: node.number ?? null,
                schema: {
                    configuration: null,
                    items: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    custom: fieldType,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE)
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cbd7V", function(module, exports) {

$parcel$export(module.exports, "transformAggOriginalEstimateToLegacyField", () => $47597066e94f8347$export$f08d02fdc74f920e);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47597066e94f8347$export$f08d02fdc74f920e = (node)=>{
    if (node.type !== (0, $5fc53.TIME_ESTIMATE_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.originalEstimate?.timeInSeconds ?? null,
        schema: {
            configuration: null,
            custom: null,
            system: node.type,
            items: null,
            type: (0, $5fc53.ISSUE_FIELD_NUMBER_CF_TYPE),
            renderer: null
        }
    };
};

});

parcelRegister("6hj44", function(module, exports) {

$parcel$export(module.exports, "transformAggPriorityToLegacyField", () => $47c25f6616be0140$export$9e966ce605f800d2);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority = (priority)=>{
    if (priority == null) return null;
    return {
        id: priority.priorityId,
        iconUrl: String(priority.iconUrl || ''),
        name: priority.name || '',
        sequence: priority.sequence || undefined
    };
};
const $47c25f6616be0140$export$9e966ce605f800d2 = (node)=>{
    if (node.type !== (0, $5fc53.PRIORITY_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)('priorities' in node ? node.priorities : null, $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        // @ts-expect-error - Argument of type '{ readonly color: string | null | undefined; readonly iconUrl: string | null | undefined; readonly name: string | null | undefined; readonly priorityId: string; } | { readonly iconUrl: string | ... 1 more ... | undefined; readonly name: string | ... 1 more ... | undefined; readonly priorityId: string; } | { ...; } |...' is not assignable to parameter of type 'AggJiraPriority | null'.
        value: $47c25f6616be0140$var$transformJiraPriorityToLegacyPriority(node.priority),
        schema: {
            type: (0, $5fc53.PRIORITY_TYPE),
            custom: null,
            system: (0, $5fc53.PRIORITY_TYPE),
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
        }
    };
};

});

parcelRegister("4nh4C", function(module, exports) {

$parcel$export(module.exports, "transformAggProformaFormsToLegacyField", () => $27d464e5749e1114$export$fdcdbf17b0d4e36f);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $27d464e5749e1114$export$fdcdbf17b0d4e36f = (node)=>{
    if (node.type !== (0, $5fc53.PROFORMA_FORMS)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.proformaForms,
        schema: {
            configuration: null,
            items: null,
            system: (0, $5fc53.PROFORMA_FORMS),
            custom: null,
            renderer: null,
            type: (0, $5fc53.PROFORMA_FORMS)
        }
    };
};

});

parcelRegister("2z4xE", function(module, exports) {

$parcel$export(module.exports, "transformAggRadioSelectToLegacyField", () => $b545e68fef1c7c25$export$f147f1eb3a15ccfc);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b545e68fef1c7c25$export$f147f1eb3a15ccfc = (node)=>{
    if (node.type !== (0, $5fc53.RADIO_BUTTONS_CF_TYPE)) return undefined;
    const value = node.selectedOption ? {
        id: node.selectedOption?.optionId,
        value: node.selectedOption?.value,
        isDisabled: node.selectedOption?.isDisabled
    } : null;
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.radioSelectFieldOptions, (option)=>({
            id: option.optionId,
            value: option.value ?? null,
            ari: option.id
        }));
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("cO2KQ", function(module, exports) {

$parcel$export(module.exports, "transformAggResolutionToLegacyField", () => $b13d1a2c3ca9d3cb$export$179f600c7e1d0230);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b13d1a2c3ca9d3cb$var$resolutionTransformer = (resolution)=>{
    if (resolution == null) return null;
    return {
        id: resolution.resolutionId,
        name: resolution.name || ''
    };
};
const $b13d1a2c3ca9d3cb$export$179f600c7e1d0230 = (node)=>{
    if (node.type !== (0, $5fc53.RESOLUTION_TYPE)) return undefined;
    const value = $b13d1a2c3ca9d3cb$var$resolutionTransformer(node.resolution);
    const allowedValues = (0, $o7K5u.transformAggConnection)(node.resolutions, $b13d1a2c3ca9d3cb$var$resolutionTransformer);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        allowedValues: allowedValues,
        schema: {
            type: (0, $5fc53.RESOLUTION_TYPE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.RESOLUTION_TYPE),
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("5sETx", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextToLegacyField", () => $181b5722dae42ee4$export$e65ff2ce94be106e);

var $kz2lw = parcelRequire("kz2lw");


var $5fc53 = parcelRequire("5fc53");

var $fCo6Y = parcelRequire("fCo6Y");

var $o7K5u = parcelRequire("o7K5u");

var $dMYPq = parcelRequire("dMYPq");
const $181b5722dae42ee4$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $181b5722dae42ee4$var$getSchema = (aggType, renderer)=>{
    switch(aggType){
        case 0, $5fc53.TEXT_AREA_CF_TYPE:
            return {
                custom: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                system: null,
                configuration: null,
                items: null
            };
        case 0, $5fc53.DESCRIPTION_TYPE:
        case 0, $5fc53.ENVIRONMENT_TYPE:
        default:
            return {
                system: aggType,
                renderer: renderer,
                type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                custom: null,
                configuration: null,
                items: null
            };
    }
};
// Exactly match the legacy /graphql value, handling the case where the field is empty and has never been edited
// There's no functional difference between `null` or empty string when rendering the field in the issue view.
const $181b5722dae42ee4$var$getPlainTextValue = (node)=>{
    // When the field is empty and a value has never been set
    if (!node.richText) return null;
    // When the field has been set to a value, and then set back to empty
    if (node.richText?.plainText == null) return '';
    return node.richText?.plainText;
};
const $181b5722dae42ee4$export$e65ff2ce94be106e = (node)=>{
    // Description field always renders with ADF
    const { renderer: renderer } = node;
    if ((0, $dMYPq.default)(node)) return undefined;
    const isPlainTextRenderer = node.type !== (0, $5fc53.DESCRIPTION_TYPE) && renderer === (0, $650578330a102f55$export$a4a240cb4053b29f);
    if (isPlainTextRenderer) return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $181b5722dae42ee4$var$getPlainTextValue(node),
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
    const adfValueJson = node.richText?.adfValue?.json ?? null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // The usages of the collection is deprecated.
        adfValue: adfValueJson ? (0, $fCo6Y.removeCollectionFromAdf)(adfValueJson) : $181b5722dae42ee4$var$emptyAdfObject,
        value: null,
        schema: $181b5722dae42ee4$var$getSchema(node.type, renderer)
    };
};

});
parcelRegister("fCo6Y", function(module, exports) {

$parcel$export(module.exports, "emptyAdfObject", () => $79bd166f69131b05$export$202742e99f678c60);
$parcel$export(module.exports, "removeCollectionFromAdf", () => $79bd166f69131b05$export$9e9311e676291037);
$parcel$export(module.exports, "convertAdfStringToObject", () => $79bd166f69131b05$export$ee70d4eb14697455);
$parcel$export(module.exports, "isOnlyWhitespaceAdf", () => $79bd166f69131b05$export$cf4bde415465976c);
$parcel$export(module.exports, "removeNewLineCharactersFromAdf", () => $79bd166f69131b05$export$d6ce0667c33b94ff);
$parcel$export(module.exports, "removeTrailingNewLineCharacters", () => $79bd166f69131b05$export$3688e35a300432d6);
$parcel$export(module.exports, "simplifyAdf", () => $79bd166f69131b05$export$def86d25f0c7f0bc);
$parcel$export(module.exports, "hasEmojiNode", () => $79bd166f69131b05$export$8c6c40d1455b914a);
$parcel$export(module.exports, "hasMediaFileNodes", () => $79bd166f69131b05$export$9a632b58fb9b287c);
$parcel$export(module.exports, "hasMediaFileNodesUpdated", () => $79bd166f69131b05$export$80a6e90c7b29d88c);

var $lmhF9 = parcelRequire("lmhF9");
var $l1C1k = parcelRequire("l1C1k");

var $2YZCu = parcelRequire("2YZCu");
const $79bd166f69131b05$export$202742e99f678c60 = {
    type: 'doc',
    version: 1,
    content: []
};
const $79bd166f69131b05$export$9e9311e676291037 = (adf)=>{
    if (adf === null || adf === undefined) return null;
    if (adf.type === 'media' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.type === 'mediaInline' && adf.attrs) return {
        ...adf,
        attrs: {
            ...adf.attrs,
            collection: ''
        }
    };
    if (adf.content) return {
        ...adf,
        content: adf.content.map($79bd166f69131b05$export$9e9311e676291037)
    };
    return adf;
};
const $79bd166f69131b05$export$ee70d4eb14697455 = (adf)=>{
    if (typeof adf === 'string') try {
        return $79bd166f69131b05$export$9e9311e676291037(JSON.parse(adf));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('rich-content.convert-adf-to-object', 'Failed to parse rich content', error);
        return null;
    }
    return $79bd166f69131b05$export$9e9311e676291037(adf);
};
const $79bd166f69131b05$export$cf4bde415465976c = (adf)=>adf && adf.content ? adf.content.every((content)=>{
        if (content.type === 'paragraph') return !content.content || content.content.length === 0 || content.content.every((innerContent)=>innerContent.type === 'text' ? (innerContent.text || '').match(/^\s*$/) !== null : false);
        return false;
    }) : false;
const $79bd166f69131b05$export$d6ce0667c33b94ff = (adf)=>{
    if (!adf || !adf.content) return $79bd166f69131b05$export$202742e99f678c60;
    let len;
    for(len = adf.content.length - 1; len >= 0 && adf.content[len].content && adf.content[len].type === 'paragraph' && adf.content[len].content.length === 0; len -= 1){
        // if the last item of the node is of type mediaGroup, we don't want to strip newline character as
        // it practically makes it unclickable. Leave a new line character so there is still some space for ppl to click
        if (len > 0 && adf.content[len - 1].type === 'mediaGroup') break;
    }
    return {
        ...adf,
        content: adf.content.slice(0, len + 1)
    };
};
const $79bd166f69131b05$export$3688e35a300432d6 = (text)=>text.replace(/[\r\n]+$/, '');
const $79bd166f69131b05$export$def86d25f0c7f0bc = (adf)=>$79bd166f69131b05$export$cf4bde415465976c(adf) ? $79bd166f69131b05$export$202742e99f678c60 : adf;
const $79bd166f69131b05$export$8c6c40d1455b914a = (doc)=>{
    let hasEmoji = false;
    (0, $l1C1k.traverse)(doc, {
        emoji: ()=>{
            hasEmoji = true;
            return false; // stop traversing
        }
    });
    return hasEmoji;
};
const $79bd166f69131b05$export$9a632b58fb9b287c = (doc)=>{
    const mediaNodes = new Map();
    (0, $l1C1k.traverse)(doc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            mediaNodes.set(mediaNode.attrs.id, node);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            mediaNodes.set(mediaInlineNode.attrs.id, node);
        }
    });
    return mediaNodes.size > 0;
};
const $79bd166f69131b05$export$80a6e90c7b29d88c = (currentDoc, newDoc)=>{
    const currentMediaNodes = new Set();
    const newMediaNodes = new Set();
    const updatedMediaNodes = new Set();
    if (newDoc) (0, $l1C1k.traverse)(newDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            newMediaNodes.add(mediaNode.attrs.id);
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            newMediaNodes.add(mediaInlineNode.attrs.id);
        }
    });
    if (currentDoc) (0, $l1C1k.traverse)(currentDoc, {
        media: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaNode = node;
            if (mediaNode.attrs.type === 'external') return;
            currentMediaNodes.add(mediaNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaNode.attrs.id);
            }
        },
        mediaInline: (node)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const mediaInlineNode = node;
            currentMediaNodes.add(mediaInlineNode.attrs.id);
            if (newMediaNodes.size) {
                const matchedNode = newMediaNodes.has(mediaInlineNode.attrs.id);
                if (!matchedNode) updatedMediaNodes.add(mediaInlineNode.attrs.id);
            }
        }
    });
    return currentMediaNodes.size !== newMediaNodes.size || !!updatedMediaNodes.size;
};
const $79bd166f69131b05$export$ddf077301434502d = (doc)=>{
    if (doc === null || doc === undefined) return false;
    const nonSimpleTextNodes = (0, $lmhF9.filter)(doc, (node)=>node.type !== 'paragraph' && node.type !== 'doc' && node.type !== 'text');
    return nonSimpleTextNodes.length === 0;
};



const $79bd166f69131b05$export$2277e89f0b6d4ed = async (node)=>{
    // the imports here were kept async so as not to blow the bundle sizes for everyone
    const { defaultSchema: defaultSchema } = await (parcelRequire("hr7QF"));
    const { WikiMarkupTransformer: WikiMarkupTransformer } = await (parcelRequire("7y1vK"));
    const { JSONTransformer: JSONTransformer } = await (parcelRequire("76p3g"));
    const jsonTransformer = new JSONTransformer();
    const wikiMarkupTransformer = new WikiMarkupTransformer(defaultSchema);
    if (node === null || node === undefined) return '';
    const pmNode = jsonTransformer.parse(node);
    return wikiMarkupTransformer.encode(pmNode);
};

});
parcelRegister("lmhF9", function(module, exports) {

$parcel$export(module.exports, "filter", () => $cb7d90be6f5f5975$export$3dea766d36a8935f);

var $l1C1k = parcelRequire("l1C1k");
function $cb7d90be6f5f5975$export$3dea766d36a8935f(adf, callback) {
    const result = [];
    (0, $l1C1k.traverse)(adf, {
        any: (node)=>{
            if (callback(node)) result.push(node);
        }
    });
    return result;
}

});
parcelRegister("l1C1k", function(module, exports) {

$parcel$export(module.exports, "traverse", () => $b903aab814d8ed47$export$df3f009e3d155b20);
function $b903aab814d8ed47$export$735cfea22ce30f58(_visitors) {
    return true;
}
function $b903aab814d8ed47$export$df3f009e3d155b20(adf, visitors) {
    if (!$b903aab814d8ed47$export$735cfea22ce30f58(visitors)) throw new Error(`Visitors are not valid: "${Object.keys(visitors).join(', ')}"`);
    return $b903aab814d8ed47$var$traverseNode(adf, {
        node: undefined
    }, visitors, 0, 0);
}
function $b903aab814d8ed47$var$traverseNode(adfNode, parent, visitors, index, depth) {
    const visitor = visitors[adfNode.type] || visitors['any'];
    let newNode = {
        ...adfNode
    };
    if (visitor) {
        const processedNode = visitor({
            ...newNode
        }, parent, index, depth);
        if (processedNode === false) return false;
        newNode = processedNode || adfNode;
    }
    if (newNode.content) newNode.content = newNode.content.reduce((acc, node, idx)=>{
        if (!node) return acc;
        const processedNode = $b903aab814d8ed47$var$traverseNode(node, {
            node: newNode,
            parent: parent
        }, visitors, idx, depth + 1);
        if (processedNode !== false) acc.push(processedNode);
        return acc;
    }, []);
    return newNode;
}

});


parcelRegister("hr7QF", function(module, exports) {

let $cb1b0bd85c89df65$var$load = (parcelRequire("28QjX"))(4);
module.exports = $cb1b0bd85c89df65$var$load("kI93O").then(()=>parcelRequire('kOFhM'));

});

parcelRegister("7y1vK", function(module, exports) {

let $57ece16cf096b3ea$var$load = (parcelRequire("28QjX"))(4);
module.exports = $57ece16cf096b3ea$var$load("9ZhML").then(()=>parcelRequire('dN5CS'));

});

parcelRegister("76p3g", function(module, exports) {

let $52bc86acca96045c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $52bc86acca96045c$var$load("a7dPb").then(()=>parcelRequire('hYNZx'));

});



parcelRegister("f454b", function(module, exports) {

$parcel$export(module.exports, "transformAggSecurityLevelToLegacyField", () => $811c3c0495fb451c$export$45e25e2a6750ea5a);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $811c3c0495fb451c$var$transformJiraSecurityLevel = (securityLevel)=>{
    if (securityLevel == null) return null;
    return {
        id: securityLevel.securityId,
        description: securityLevel.description || '',
        name: securityLevel.name || ''
    };
};
const $811c3c0495fb451c$export$45e25e2a6750ea5a = (node)=>({
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $811c3c0495fb451c$var$transformJiraSecurityLevel(node.securityLevel),
        allowedValues: (0, $o7K5u.transformAggConnection)(node.securityLevels, $811c3c0495fb451c$var$transformJiraSecurityLevel),
        schema: {
            configuration: null,
            type: (0, $5fc53.SECURITY_LEVEL_TYPE_OVERRIDE),
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: null,
            system: (0, $5fc53.SECURITY_LEVEL_TYPE),
            items: null
        }
    });

});

parcelRegister("aafIf", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleGroupPickerToLegacyField", () => $950a9b8297396bb3$export$e6697ec5bdac9ec0);


var $o7K5u = parcelRequire("o7K5u");
const $950a9b8297396bb3$export$e6697ec5bdac9ec0 = (node)=>{
    const value = node.selectedGroup != null ? {
        groupId: node.selectedGroup.groupId,
        name: node.selectedGroup.name
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'group',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};

});

parcelRegister("2yWre", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleLineTextToLegacyField", () => $f5309f9bc8791ddf$export$31f32b3fd9e5ab6);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $f5309f9bc8791ddf$var$defaultSchema = {
    configuration: null,
    items: null,
    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f)
};
const $f5309f9bc8791ddf$export$31f32b3fd9e5ab6 = (node)=>{
    const defaultTransformedField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.text
    };
    switch(node.type){
        case 0, $5fc53.EPIC_NAME_TYPE:
        case 0, $5fc53.MESSAGE_EDIT_CF_TYPE:
        case 0, $5fc53.MESSAGE_VIEW_CF_TYPE:
        case 0, $5fc53.READ_ONLY_CF_TYPE:
        case 0, $5fc53.TEXT_CF_TYPE:
        case 0, $5fc53.USER_PROPERTY_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
                }
            };
        case 0, $5fc53.RANK_CF_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    custom: node.type,
                    system: null,
                    type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
                }
            };
        case 0, $5fc53.SUMMARY_TYPE:
            return {
                ...defaultTransformedField,
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE),
                    custom: null,
                    system: node.type
                }
            };
        case 0, $5fc53.SERVICEDESK_PRACTICES_TYPE:
            // Transform field only if the practice has a value
            return node.text != null ? {
                ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
                value: [
                    node.text
                ],
                schema: {
                    ...$f5309f9bc8791ddf$var$defaultSchema,
                    renderer: null,
                    custom: null,
                    system: node.type,
                    type: (0, $5fc53.SERVICEDESK_PRACTICES_TYPE)
                }
            } : undefined;
        default:
            return undefined;
    }
};

});

parcelRegister("lUeQj", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectToLegacyField", () => $9513f3f43c691d67$export$4e113f935e09d226);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $9513f3f43c691d67$var$getField = (node, customType)=>{
    const value = node.fieldOption != null ? {
        ari: node.fieldOption.id,
        id: node.fieldOption.optionId,
        value: node.fieldOption.value
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            type: 'option',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            custom: customType || node.type,
            system: null,
            items: null,
            configuration: null
        }
    };
};
const $9513f3f43c691d67$export$4e113f935e09d226 = (node)=>{
    switch(node.type){
        case 0, $5fc53.EPIC_STATUS_TYPE:
        case 0, $5fc53.SELECT_CF_TYPE:
            return $9513f3f43c691d67$var$getField(node);
        case 0, $5fc53.CATEGORY_TYPE:
            return $9513f3f43c691d67$var$getField(node, (0, $5fc53.SELECT_CF_TYPE));
        default:
            return undefined;
    }
};

});

parcelRegister("6SWOK", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleSelectUserPickerToLegacyField", () => $7348765074cf60a5$export$7bf73fc06c6d71be);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $iob0v = parcelRequire("iob0v");
const $7348765074cf60a5$export$7bf73fc06c6d71be = (node)=>{
    const legacyField = {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.user ? (0, $iob0v.transformJiraUserToLegacyServerUser)(node.user) : null
    };
    switch(node.type){
        case 0, $5fc53.ASSIGNEE_TYPE:
        case 0, $5fc53.REPORTER_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: null,
                    system: node.type,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        case 0, $5fc53.USER_CF_TYPE:
        case 0, $5fc53.LAST_UPDATER_OR_COMMENTER_CF_TYPE:
            return {
                ...legacyField,
                schema: {
                    type: (0, $5fc53.ISSUE_FIELD_USER_CF_TYPE),
                    custom: node.type,
                    system: null,
                    renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
                    configuration: null,
                    items: null
                }
            };
        default:
            return undefined;
    }
};

});

parcelRegister("cMc7B", function(module, exports) {

$parcel$export(module.exports, "transformAggSingleVersionPickerToLegacyField", () => $1c34fc6a70d0e0b4$export$d03f622577260442);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");

var $149sa = parcelRequire("149sa");
const $1c34fc6a70d0e0b4$export$d03f622577260442 = (node)=>{
    if (node.type !== (0, $5fc53.VERSION_CF_TYPE)) return undefined;
    const allowedValues = (0, $o7K5u.transformAggConnection)(null, (0, $149sa.transformAggVersionToLegacyVersion));
    const value = node.version ? (0, $149sa.transformAggVersionToLegacyVersion)(node.version) : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        allowedValues: allowedValues,
        value: value,
        schema: {
            configuration: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            type: (0, $5fc53.ISSUE_FIELD_VERSION_CF_TYPE),
            custom: (0, $5fc53.VERSION_CF_TYPE),
            system: null
        }
    };
};

});

parcelRegister("38GNL", function(module, exports) {

$parcel$export(module.exports, "transformAggSprintToLegacyField", () => $05e0b9d6b707c3a6$export$9b5bb05d50970021);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $05e0b9d6b707c3a6$var$SprintOptionalKeyMap = {
    goal: 'goal',
    completeDate: 'completionDate',
    startDate: 'startDate',
    endDate: 'endDate'
};
const $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint = (sprint)=>{
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const optionalValues = {};
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.keys($05e0b9d6b707c3a6$var$SprintOptionalKeyMap).forEach((key)=>{
        const aggKey = $05e0b9d6b707c3a6$var$SprintOptionalKeyMap[key];
        const aggValue = sprint[aggKey];
        if (aggValue !== undefined && aggValue !== null) optionalValues[key] = aggValue;
    });
    return {
        id: Number(sprint.sprintId),
        name: sprint.name,
        state: sprint.state?.toLowerCase(),
        boardId: Number(sprint.boardName) || 0,
        ...optionalValues
    };
};
const $05e0b9d6b707c3a6$export$9b5bb05d50970021 = (node)=>{
    if (node.type !== (0, $5fc53.SPRINT_TYPE)) return undefined;
    const sprints = (0, $o7K5u.transformAggConnection)(node.selectedSprintsConnection, $05e0b9d6b707c3a6$var$transformAggSprintToLegacySprint);
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: sprints,
        schema: {
            configuration: null,
            custom: (0, $5fc53.SPRINT_TYPE),
            items: 'json',
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'array'
        }
    };
};

});

parcelRegister("avV20", function(module, exports) {

$parcel$export(module.exports, "getStatusesDeprecatedValue", () => $e8b60f3bf3251c5a$export$b80ec59d806c2f94);
$parcel$export(module.exports, "transformAggStatusToLegacyField", () => $e8b60f3bf3251c5a$export$c80e5acb1c882c48);

var $gULOk = parcelRequire("gULOk");

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $e8b60f3bf3251c5a$export$b80ec59d806c2f94 = (fields)=>{
    const { status: status } = fields;
    if (!status || status.value == null) return {};
    const { value: value } = status;
    return {
        [value.id]: {
            id: value.id,
            name: value.name,
            statusCategory: (0, $gULOk.statusCategoryForId)(value.statusCategory?.id)
        }
    };
};
const $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus = (status)=>{
    if (status == null) return null;
    const { statusCategory: statusCategory } = status;
    return {
        id: status.statusId,
        name: status.name || '',
        statusCategory: {
            id: Number(statusCategory.statusCategoryId)
        }
    };
};
const $e8b60f3bf3251c5a$export$c80e5acb1c882c48 = (node)=>{
    if (node.type !== (0, $5fc53.STATUS_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: $e8b60f3bf3251c5a$var$transformJiraStatusToLegacyStatus(node.status),
        schema: {
            configuration: null,
            items: null,
            renderer: null,
            type: (0, $5fc53.STATUS_TYPE),
            custom: null,
            system: (0, $5fc53.STATUS_TYPE)
        }
    };
};

});

parcelRegister("cbXvu", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamToLegacyField", () => $2c8c4053c45e92fb$export$fb1b80497e96456f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $2c8c4053c45e92fb$export$fb1b80497e96456f = (node)=>{
    if (node.type !== (0, $5fc53.TEAM_CF_TYPE)) return undefined;
    const value = node.selectedTeam ? {
        id: node.selectedTeam.teamId,
        title: node.selectedTeam.name,
        isShared: node.selectedTeam.isShared,
        avatarUrl: node.selectedTeam.avatar?.medium
    } : null;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: value,
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_ANY_CF_TYPE)
        }
    };
};

});

parcelRegister("aSXJi", function(module, exports) {

$parcel$export(module.exports, "transformAggTeamViewToLegacyField", () => $b1861ddba2f2c1e6$export$6f6aaafb49bd4769);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam = (team)=>{
    if (team == null) return null;
    return {
        id: team.jiraSuppliedTeamId,
        name: team.jiraSuppliedName || '',
        isVisible: team.jiraSuppliedVisibility || false,
        avatarUrl: team.jiraSuppliedAvatar?.xsmall || '',
        isVerified: team.jiraSuppliedIsVerified || false
    };
};
const $b1861ddba2f2c1e6$export$6f6aaafb49bd4769 = (node)=>{
    if (node.type !== (0, $5fc53.TEAMS_PLATFORM_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        // @ts-expect-error - Argument of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...' is not assignable to parameter of type '{ readonly jiraSuppliedAvatar: { readonly large: string | null | undefined; readonly medium: string | null | undefined; readonly small: string | null | undefined; readonly xsmall: string | null | undefined; } | null | undefined; readonly jiraSuppliedId: string; readonly jiraSuppliedName: string | ... 1 more ... | un...'.
        value: $b1861ddba2f2c1e6$var$transformAggTeamViewToLegacyTeam(node.selectedTeam),
        schema: {
            configuration: null,
            custom: (0, $5fc53.TEAMS_PLATFORM_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: 'team'
        }
    };
};

});

parcelRegister("8uxcU", function(module, exports) {

$parcel$export(module.exports, "transformAggTimeTrackingToLegacyField", () => $63b0d60fa2cc1a3e$export$874d9bd14269ec6f);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $63b0d60fa2cc1a3e$var$getEstimateValues = (estimate, key)=>{
    if (estimate) return {
        [key]: estimate.timeInSeconds || 0
    };
    return {};
};
const $63b0d60fa2cc1a3e$export$874d9bd14269ec6f = (node)=>{
    if (node.type !== (0, $5fc53.TIME_TRACKING_TYPE)) return undefined;
    const originalEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.originalEstimate || null, 'originalEstimateSeconds');
    const remainingEstimate = $63b0d60fa2cc1a3e$var$getEstimateValues(node.remainingEstimate || null, 'remainingEstimateSeconds');
    const timeSpent = $63b0d60fa2cc1a3e$var$getEstimateValues(node.timeSpent || null, 'timeSpentSeconds');
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: {
            ...originalEstimate,
            ...remainingEstimate,
            ...timeSpent
        },
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: (0, $5fc53.TIME_TRACKING_TYPE),
            type: (0, $5fc53.TIME_TRACKING_TYPE)
        }
    };
};

});

parcelRegister("arKlm", function(module, exports) {

$parcel$export(module.exports, "transformAggUrlToLegacyField", () => $86ba2c1106803d01$export$6e950e0ec9801f6c);


var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $86ba2c1106803d01$export$6e950e0ec9801f6c = (node)=>{
    if (node.type !== (0, $5fc53.URL_CF_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.uri ?? null,
        schema: {
            configuration: null,
            custom: (0, $5fc53.URL_CF_TYPE),
            items: null,
            renderer: (0, $650578330a102f55$export$a4a240cb4053b29f),
            system: null,
            type: (0, $5fc53.ISSUE_FIELD_STRING_CF_TYPE)
        }
    };
};

});

parcelRegister("hCKV6", function(module, exports) {

$parcel$export(module.exports, "transformAggVotesToLegacyField", () => $78b4a5963398330d$export$8966614b8594736);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $78b4a5963398330d$var$transformAggVoteToLegacyVote = (vote)=>({
        votes: vote.count != null ? Number(vote.count) : 0,
        hasVoted: vote.hasVoted ?? false
    });
const $78b4a5963398330d$export$8966614b8594736 = (node)=>{
    if (node.type !== (0, $5fc53.VOTES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.vote ? $78b4a5963398330d$var$transformAggVoteToLegacyVote(node.vote) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.VOTES_TYPE),
            type: (0, $5fc53.VOTES_TYPE)
        }
    };
};

});

parcelRegister("d8wC0", function(module, exports) {

$parcel$export(module.exports, "transformAggWatchesToLegacyField", () => $a83bab4858993b2f$export$6730cb17d10d6156);

var $5fc53 = parcelRequire("5fc53");

var $o7K5u = parcelRequire("o7K5u");
const $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches = (watch)=>({
        watchCount: watch.count != null ? Number(watch.count) : 0,
        isWatching: watch.isWatching ?? false
    });
const $a83bab4858993b2f$export$6730cb17d10d6156 = (node)=>{
    if (node.type !== (0, $5fc53.WATCHES_TYPE)) return undefined;
    return {
        ...(0, $o7K5u.transformAggNodeToLegacyField)(node),
        value: node.watch ? $a83bab4858993b2f$var$transformAggWatchesToLegacyWatches(node.watch) : null,
        schema: {
            configuration: null,
            custom: null,
            items: null,
            renderer: null,
            system: (0, $5fc53.WATCHES_TYPE),
            type: (0, $5fc53.WATCHES_TYPE)
        }
    };
};

});


parcelRegister("1pF6B", function(module, exports) {

$parcel$export(module.exports, "transformAggParentFieldValueToLegacyFieldValue", () => $f8196a61a82995ed$export$d8a5feb2bb0425b4);
const $f8196a61a82995ed$export$d8a5feb2bb0425b4 = (parentIssue)=>{
    if (!parentIssue) return null;
    return {
        id: parentIssue.issueId,
        ari: parentIssue.id,
        key: parentIssue.key,
        self: parentIssue.webUrl,
        color: parentIssue.issueColorField?.color?.colorKey,
        fields: {
            summary: parentIssue.summaryField?.text,
            issuetype: {
                name: parentIssue.issueTypeField?.issueType?.name,
                iconUrl: parentIssue.issueTypeField?.issueType?.avatar?.xsmall,
                // We do not have this data
                id: '',
                self: '',
                description: '',
                subtask: false,
                avatarId: 0,
                hierarchyLevel: 0
            }
        }
    };
};

});

parcelRegister("lTnWS", function(module, exports) {

$parcel$export(module.exports, "transformAggRichTextFieldValueToLegacyFieldValue", () => $51ceecc021979aad$export$b3a2c3992977726e);

var $kz2lw = parcelRequire("kz2lw");


var $fCo6Y = parcelRequire("fCo6Y");
const $51ceecc021979aad$var$emptyAdfObject = (0, $kz2lw.getEmptyADF)();
const $51ceecc021979aad$export$b3a2c3992977726e = (richText, renderer)=>{
    if (!renderer) throw new Error('aggFieldChangeProps did not have renderer');
    if (renderer === (0, $650578330a102f55$export$a4a240cb4053b29f)) {
        if (richText.plainText !== undefined) return richText.plainText;
        return richText?.adfValue?.convertedPlainText?.plainText;
    }
    return richText?.adfValue?.json ? (0, $fCo6Y.removeCollectionFromAdf)(richText?.adfValue?.json) : $51ceecc021979aad$var$emptyAdfObject;
};

});


parcelRegister("3z81P", function(module, exports) {

$parcel$export(module.exports, "ChangeEventTypes", () => $c6ffe75554a4bac3$export$8db21fc94823e1cc);
// Copied over from `src/packages/issue/issue-view/src/model/change-type.js`
const $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED = 'FIELD_CHANGE_REQUESTED';
const $c6ffe75554a4bac3$var$FIELD_CHANGED = 'FIELD_CHANGED';
const $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED = 'FIELD_CHANGE_FAILED';
const $c6ffe75554a4bac3$export$8db21fc94823e1cc = {
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_REQUESTED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED]: $c6ffe75554a4bac3$var$FIELD_CHANGE_FAILED,
    [$c6ffe75554a4bac3$var$FIELD_CHANGED]: $c6ffe75554a4bac3$var$FIELD_CHANGED
};

});


parcelRegister("99cgx", function(module, exports) {

$parcel$export(module.exports, "defaultSaveField", () => $2a246664763defba$export$b74e6b7f831f1cb2);
$parcel$export(module.exports, "defaultSaveFieldById", () => $2a246664763defba$export$b2c49aae5d84cced);
$parcel$export(module.exports, "defaultAddValuesToField", () => $2a246664763defba$export$c46c7284cd9c5d3);
$parcel$export(module.exports, "defaultRemoveValuesFromField", () => $2a246664763defba$export$33b78476f5d734b3);

var $eusud = parcelRequire("eusud");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $2a246664763defba$var$getFieldUpdate = (fieldKey, value)=>({
        fields: {
            [fieldKey]: value
        }
    });
const $2a246664763defba$export$b74e6b7f831f1cb2 = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$b2c49aae5d84cced = async (issueKey, fieldKey, newValue, _baseUrl)=>(0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/?returnIssue=true`, {
        body: JSON.stringify($2a246664763defba$var$getFieldUpdate(fieldKey, newValue))
    });
const $2a246664763defba$export$c46c7284cd9c5d3 = async (issueKey, fieldKey, valuesToAdd, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'add',
                    value: valuesToAdd
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};
const $2a246664763defba$export$33b78476f5d734b3 = async (issueKey, fieldKey, valuesToRemove, _baseUrl)=>{
    const updateParam = {
        update: {
            [fieldKey]: [
                {
                    operation: 'remove',
                    value: valuesToRemove
                }
            ]
        }
    };
    return (0, $eusud.performPutRequest)(`/rest/api/3/issue/${issueKey}/`, {
        body: JSON.stringify(updateParam)
    });
};

});



parcelRegister("80wkc", function(module, exports) {

$parcel$export(module.exports, "useSummaryField", () => $3937341f26b89a45$export$a01f0885983ceff0);

var $9XE6b = parcelRequire("9XE6b");

var $lQE94 = parcelRequire("lQE94");

var $54wEF = parcelRequire("54wEF");

var $5fc53 = parcelRequire("5fc53");

var $4R6GH = parcelRequire("4R6GH");

var $lcPD8 = parcelRequire("lcPD8");
const $3937341f26b89a45$export$a01f0885983ceff0 = ({ issueId: issueId, issueKey: issueKey, initialValue: initialValue, onSubmit: onSubmit, onSuccess: onSuccess, onFailure: onFailure, onSaveField: onSaveField })=>{
    const [fieldConfig] = (0, $54wEF.useFieldConfig)(issueKey, (0, $5fc53.SUMMARY_TYPE));
    const fieldType = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(fieldConfig.value, 'schema.type', 'string');
    const saveField = (0, $4R6GH.fg)('relay-migration-issue-fields-summary') ? (0, $lcPD8.useSaveSummaryField)(issueId) : undefined;
    const [{ value: value, error: error }, { saveValue: saveValue, resetError: resetError }] = (0, $lQE94.useEditField)({
        fieldKey: (0, $5fc53.SUMMARY_TYPE),
        issueKey: issueKey,
        fieldType: fieldType,
        initialValue: initialValue || null,
        onSubmit: onSubmit,
        onSuccess: onSuccess,
        onFailure: onFailure,
        ...(0, $4R6GH.fg)('relay-migration-issue-fields-summary') && {
            saveField: saveField
        },
        // delete this condition and keep code inside when removing the isIncrementPlanningEnabled FF
        ...onSaveField && {
            saveField: onSaveField
        }
    });
    return [
        {
            value: value,
            error: error,
            fieldConfig: fieldConfig
        },
        {
            saveValue: saveValue,
            resetError: resetError
        }
    ];
};

});
parcelRegister("lcPD8", function(module, exports) {

$parcel$export(module.exports, "useSaveSummaryField", () => $296ba0222c720503$export$2429979662d1fc23);

var $883fO = parcelRequire("883fO");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $lBwHJ = parcelRequire("lBwHJ");

var $jJZqs = parcelRequire("jJZqs");

var $koeKL = parcelRequire("koeKL");
const $296ba0222c720503$export$2429979662d1fc23 = (issueId)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [commit] = (0, $8Uumt.useMutation)((0, $883fO.default));
    return (0, $5uXOq.useCallback)(async (_issueKey, fieldId, newValue)=>new Promise((resolve, reject)=>{
            commit({
                variables: {
                    input: {
                        id: (0, $lBwHJ.JiraIssuefieldvalueAri).create({
                            siteId: cloudId,
                            issueId: issueId || '',
                            fieldId: fieldId
                        }).toString(),
                        operation: {
                            operation: 'SET',
                            text: newValue
                        }
                    }
                },
                onCompleted (response) {
                    if (response.jira?.updateSingleLineTextField) {
                        const { success: success, errors: responseErrors } = response.jira?.updateSingleLineTextField;
                        if (success) {
                            resolve();
                            return;
                        }
                        if (responseErrors?.length) reject(responseErrors[0].message ? new (0, $jJZqs.ValidationError)(responseErrors[0].message) : new Error('Unknown error when mutating summary'));
                    } else reject(new Error('Unknown error when mutating summary'));
                },
                onError (error) {
                    reject(error);
                }
            });
        }), [
        cloudId,
        commit,
        issueId
    ]);
};

});
parcelRegister("883fO", function(module, exports) {

$parcel$export(module.exports, "default", () => $d80cb93aeec4c927$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<502aa471f5d0893ece5715d9f8b2453a>>
 * @relayHash 96311ac8cd1b2e15ed7072740a91fd80
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 24e8667d902ba1fdadfcd6a7137edc6ca942d8be00bc0084996320ad25442808
const $d80cb93aeec4c927$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "input"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "input",
            "variableName": "input"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "success"
    }, v3 = {
        "concreteType": "MutationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "message"
            }
        ]
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "FragmentSpread",
                                            "name": "singleLineTextHeading_issueFieldSingleLineTextInlineEditHeading_SingleLineTextHeadingInlineEditView"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ],
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSaveSummaryFieldMutation",
            "selections": [
                {
                    "concreteType": "JiraMutation",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": v1 /*: any*/ ,
                            "concreteType": "JiraSingleLineTextFieldPayload",
                            "kind": "LinkedField",
                            "name": "updateSingleLineTextField",
                            "plural": false,
                            "selections": [
                                v2 /*: any*/ ,
                                v3 /*: any*/ ,
                                {
                                    "concreteType": "JiraSingleLineTextField",
                                    "kind": "LinkedField",
                                    "name": "field",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "id"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "name"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "fieldId"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "isEditableInIssueView"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "type"
                                        },
                                        {
                                            "kind": "ScalarField",
                                            "name": "text"
                                        },
                                        {
                                            "concreteType": "JiraFieldConfig",
                                            "kind": "LinkedField",
                                            "name": "fieldConfig",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "ScalarField",
                                                    "name": "isRequired"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "24e8667d902ba1fdadfcd6a7137edc6ca942d8be00bc0084996320ad25442808",
            "metadata": {},
            "name": "useSaveSummaryFieldMutation",
            "operationKind": "mutation",
            "text": null
        }
    };
}();
$d80cb93aeec4c927$var$node.hash = "d7d58a3dc9f48f40fffb61682948b25d";
var $d80cb93aeec4c927$export$2e2bcd8739ae039 = $d80cb93aeec4c927$var$node;

});

parcelRegister("lBwHJ", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAri", () => $fba66c0f0a21639a$export$828c4931ae562af7);

var $gB07r = parcelRequire("gB07r");

var $9KGzW = parcelRequire("9KGzW");

var $1C2Ux = parcelRequire("1C2Ux");
// src/jira/issuefieldvalue/manifest.ts
var $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts = {
    qualifier: "ari",
    platformQualifier: "cloud",
    cloudId: new RegExp("^[a-zA-Z0-9_\\-.]{1,255}$"),
    // eslint-disable-line no-useless-escape
    resourceOwner: (0, $gB07r.JiraIssuefieldvalueAriResourceOwner),
    resourceType: (0, $gB07r.JiraIssuefieldvalueAriResourceType),
    resourceIdSlug: "{issueId}/{fieldId}",
    resourceIdSegmentFormats: {
        issueId: /[0-9]+/,
        // eslint-disable-line no-useless-escape
        fieldId: /[a-zA-Z0-9_\-]+/
    }
};
// src/jira/issuefieldvalue/index.ts
var $fba66c0f0a21639a$export$828c4931ae562af7 = class _JiraIssuefieldvalueAri extends (0, $9KGzW.RegisteredAri) {
    constructor(opts){
        super(opts);
        this._siteId = opts.cloudId || "", this._issueId = opts.resourceIdSegmentValues.issueId, this._fieldId = opts.resourceIdSegmentValues.fieldId;
    }
    get siteId() {
        return this._siteId;
    }
    get issueId() {
        return this._issueId;
    }
    get fieldId() {
        return this._fieldId;
    }
    static create(opts) {
        let derivedOpts = {
            qualifier: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.qualifier,
            platformQualifier: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.platformQualifier,
            cloudId: opts.siteId,
            resourceOwner: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.resourceOwner,
            resourceType: $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts.resourceType,
            resourceId: `${opts.issueId}/${opts.fieldId}`,
            resourceIdSegmentValues: {
                issueId: opts.issueId,
                fieldId: opts.fieldId
            }
        }, ariOpts = (0, $1C2Ux.AriParser).fromOpts(derivedOpts, $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(ariOpts);
    }
    static parse(maybeAri) {
        let opts = (0, $1C2Ux.AriParser).fromString(maybeAri, $fba66c0f0a21639a$var$jiraIssuefieldvalueAriStaticOpts);
        return new _JiraIssuefieldvalueAri(opts);
    }
    getVariables() {
        return {
            siteId: this.siteId,
            issueId: this.issueId,
            fieldId: this.fieldId
        };
    }
};

});
parcelRegister("gB07r", function(module, exports) {

$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceOwner", () => $c15031ac9edfd973$export$39e9358142fbbc64);
$parcel$export(module.exports, "JiraIssuefieldvalueAriResourceType", () => $c15031ac9edfd973$export$f9e57427271adc95);
// src/jira/issuefieldvalue/types.ts
var $c15031ac9edfd973$export$39e9358142fbbc64 = "jira", $c15031ac9edfd973$export$f9e57427271adc95 = "issuefieldvalue";

});






parcelRegister("fVMIs", function(module, exports) {

$parcel$export(module.exports, "useSubscribeCommands", () => $05800ad334e2646e$export$c13b008422be19c7);

var $fIZf0 = parcelRequire("fIZf0");
const $05800ad334e2646e$export$c13b008422be19c7 = (0, $fIZf0.useSubscribeCommandsWithRegistry);

});

parcelRegister("c6XT1", function(module, exports) {

$parcel$export(module.exports, "useIssueAri", () => $be8be2fff6370f04$export$f56776f1b409b56d);

var $2gCtH = parcelRequire("2gCtH");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");
const $be8be2fff6370f04$export$f56776f1b409b56d = ()=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const issueId = (0, $2gCtH.useIssueId)();
    return (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'issue',
        resourceId: issueId ?? ''
    });
};

});

const $ad6cc0c5d6e54b07$export$5252a6a6e4e4a774 = 'issue-field-status.ui.status-view.command-palette.issue-status';

parcelRegister("iokLh", function(module, exports) {

$parcel$export(module.exports, "messages", () => $7312d5cd39eb83d5$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $7312d5cd39eb83d5$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    editStatus: {
        "id": "issue-field-status.status-view.command-palette.edit-status",
        "defaultMessage": "Edit status"
    },
    searchTransition: {
        "id": "issue-field-status.status-view.command-palette.search-transition",
        "defaultMessage": "Search a status or transition"
    },
    current: {
        "id": "issue-field-status.status-view.command-palette.current",
        "defaultMessage": "Current"
    },
    fallbackNoResults: {
        "id": "issue-field-status.status-view.command-palette.fallback-no-results",
        "defaultMessage": "No results match your search."
    },
    fallbackError: {
        "id": "issue-field-status.status-view.command-palette.fallback-error",
        "defaultMessage": "We're having trouble loading this data. Wait a few moments, then try again."
    }
});

});

parcelRegister("99Vn3", function(module, exports) {

$parcel$export(module.exports, "useSaveStatusField", () => $6b5b0ceb4c7d618c$export$c6a3d42f97df89c9);

var $5uXOq = parcelRequire("5uXOq");

var $d8lE2 = parcelRequire("d8lE2");

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $eusud = parcelRequire("eusud");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $3fAi8 = parcelRequire("3fAi8");

var $jpZIw = parcelRequire("jpZIw");

var $dTUtq = parcelRequire("dTUtq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $luzUm = parcelRequire("luzUm");
const $6b5b0ceb4c7d618c$export$c6a3d42f97df89c9 = (issueKey, issueId, onUpdateStatusMutation)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ commandPaletteSessionId: commandPaletteSessionId }] = (0, $d8lE2.useCommandPaletteSessionId)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [, { setFieldValue: setFieldValue }] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: (0, $e9be48d6d2c01760$export$4420b7468f889692)
    });
    const onSaveSuccessfully = (0, $5uXOq.useCallback)((transition, callback)=>{
        const action = 'commandPalette';
        const actionSubject = 'changeStatus';
        const eventActionAndSubject = `${actionSubject} ${action}`;
        const event = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject
        });
        setFieldValue(issueKey, (0, $e9be48d6d2c01760$export$4420b7468f889692), transition.to);
        callback?.();
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        (0, $8zOmE.fireTrackAnalytics)(event, eventActionAndSubject, {
            transitionId: transition.id,
            commandPaletteSessionId: commandPaletteSessionId
        });
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'statusField transitioned', 'statusField');
        !(0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && showFlag({
            messageId: 'issue-field-status.ui.status-view.command-palette.use-save-status-field.show-flag.success',
            messageType: 'transactional',
            type: 'success',
            title: formatMessage((0, $luzUm.messages).successFlagMessage)
        });
    }, [
        commandPaletteSessionId,
        createAnalyticsEvent,
        formatMessage,
        issueKey,
        setFieldValue,
        showFlag
    ]);
    const onFailSave = (0, $5uXOq.useCallback)((error)=>{
        (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'commandPaletteIssueStatus',
                packageName: 'jiraIssueFieldStatus',
                teamName: 'deliveroo'
            }
        });
        showFlag({
            messageId: 'issue-field-status.ui.status-view.command-palette.use-save-status-field.show-flag.error',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $luzUm.messages).errorFlagTitle),
            description: formatMessage((0, $luzUm.messages).errorFlagDescription)
        });
    }, [
        formatMessage,
        showFlag
    ]);
    const openIssueTransitionModal = (0, $jpZIw.useOpenIssueTransitionModal)();
    const { showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag } = (0, $dTUtq.useShowFlag)();
    const saveStatusField = (0, $5uXOq.useCallback)(async (transition, callback)=>{
        try {
            if (transition.hasScreen) {
                const handleDialogSuccess = ()=>{
                    (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
                    return onSaveSuccessfully(transition, callback);
                };
                const handleDialogError = (err)=>onFailSave(err instanceof Error ? err : new Error('Something went wrong trying to update the status with screen using the command palette'));
                const transitionId = transition.id;
                openIssueTransitionModal({
                    payload: {
                        issueId: issueId,
                        issueKey: issueKey,
                        transitionId: transitionId
                    },
                    triggerPointKey: 'issue-transition-command-palette-status-field-transition',
                    onDialogSuccess: handleDialogSuccess,
                    onDialogError: handleDialogError
                });
            } else {
                if (onUpdateStatusMutation && (0, $4R6GH.fg)('relay-migration-issue-fields-status')) await onUpdateStatusMutation?.({
                    transitionId: transition.id,
                    newStatus: transition.to
                });
                else await (0, $eusud.performPostRequest)(`/rest/api/3/issue/${issueKey}/transitions`, {
                    body: JSON.stringify({
                        transition: transition
                    })
                });
                onSaveSuccessfully(transition, callback);
                (0, $4R6GH.fg)('show-modernised-issue-transition-success-flag') && showIssueTransitionSuccessFlag(issueKey, transition.to.name);
            }
        } catch (err) {
            const error = err instanceof Error ? err : new Error('Something went wrong trying to update the status using the command palette');
            onFailSave(error);
        }
    }, [
        issueId,
        issueKey,
        onFailSave,
        onSaveSuccessfully,
        onUpdateStatusMutation,
        openIssueTransitionModal,
        showIssueTransitionSuccessFlag
    ]);
    return {
        saveStatusField: saveStatusField
    };
};

});
parcelRegister("jpZIw", function(module, exports) {

$parcel$export(module.exports, "useOpenIssueTransitionModal", () => $f41d32ebe3d90af0$export$736bd10472c63b49);
$parcel$export(module.exports, "useCloseIssueTransitionModal", () => $f41d32ebe3d90af0$export$4629f18d511ad32e);
$parcel$export(module.exports, "useTriggerIssueTransitionModal", () => $f41d32ebe3d90af0$export$95a1e9702d78f223);
$parcel$export(module.exports, "default", () => $f41d32ebe3d90af0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lTEVZ = parcelRequire("lTEVZ");

var $4R6GH = parcelRequire("4R6GH");

var $6ikhl = parcelRequire("6ikhl");

var $2gCtH = parcelRequire("2gCtH");

var $ct2PA = parcelRequire("ct2PA");

var $3NlyR = parcelRequire("3NlyR");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9MiT2 = parcelRequire("9MiT2");

var $fNOVA = parcelRequire("fNOVA");

var $1btwe = parcelRequire("1btwe");

var $gjoNn = parcelRequire("gjoNn");

var $ipUU1 = parcelRequire("ipUU1");

var $jHYHS = parcelRequire("jHYHS");
const $f41d32ebe3d90af0$export$736bd10472c63b49 = ()=>{
    const { openIssueTransitionModal: openIssueTransitionModalAction, openIssueTransitionModalNew: openIssueTransitionModalNew } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { stateGet: { state: { isEnabled: isEnabled = true } = {} } = {} } = (0, $fNOVA.useIssueTransitionLabsOptIn)();
    const publish = (0, $1btwe.usePublishOpenIssueTransitionModalPubSub)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const { fireUIEvent: fireUIEvent } = (0, $3NlyR.useIssueTransitionUIAnalyticsEvent)();
    const { stateGet: { state: state } } = (0, $9MiT2.useIssueTransitionChangeboardingPreferences)();
    const { fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened } = (0, $ct2PA.useIssueTransitionsOperationalAnalyticsEvent)();
    const benefitsModal = typeof state !== 'number' ? state?.benefitsModal : undefined;
    const { isDisabled: isDisabled, nextDateToShowBenefitsModal: nextDateToShowBenefitsModal } = benefitsModal || {};
    return (0, $5uXOq.useCallback)((nextState)=>{
        try {
            const { triggerPointKey: triggerPointKey } = nextState || {};
            const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(isEnabled, triggerPointKey);
            if ((0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal')) {
                fireOperationalAnalyticsTransitionScreenOpened({
                    actionSubject: 'issueTransition triggered',
                    isBenefitsModalFGEneabled: (0, $4R6GH.fg)('modern_issue_transition_enable_benefits_modal'),
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined
                });
                openIssueTransitionModalNew({
                    nextState: nextState,
                    preferNewIssueTransitionScreen: isEnabled,
                    issueViewAnalyticsSource: source,
                    publishTriggerToOpenTransitions: publish,
                    isBenefitsModalDisabled: isDisabled,
                    dateToShowBenefitsModal: nextDateToShowBenefitsModal || undefined,
                    fireUIEvent: fireUIEvent
                });
                return;
            }
            if ((0, $4R6GH.fg)('fix-connect-app-not-loading')) {
                if (isNewITSEnabled && source === 'connect-issue') {
                    // fire UI event when issue transition is opened via connect API
                    fireUIEvent({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    publish(nextState, isEnabled);
                } else openIssueTransitionModalAction(nextState, isEnabled);
            } else if (source === 'connect-issue') {
                // fire UI event when issue transition is opened via connect API
                fireUIEvent({
                    actionSubject: 'issueTransition',
                    actionSubjectId: 'connectIssue',
                    action: 'opened'
                });
                publish(nextState, isEnabled);
            } else openIssueTransitionModalAction(nextState, isEnabled);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                attributes: {
                    transitionModalVersion: 'NEW'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    }, [
        fireOperationalAnalyticsTransitionScreenOpened,
        isEnabled,
        source,
        isDisabled,
        nextDateToShowBenefitsModal,
        openIssueTransitionModalNew,
        publish,
        fireUIEvent,
        openIssueTransitionModalAction
    ]);
};
const $f41d32ebe3d90af0$export$4629f18d511ad32e = ()=>{
    const [, { resetState: resetState }] = (0, $6ikhl.useInlineFieldsActions)();
    const { closeIssueTransitionModal: closeIssueTransitionModalAction } = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { payload: { issueKey: issueKey, transitionId: transitionId }, onDialogCancel: onDialogCancel, onDialogError: onDialogError, onDialogSuccess: onDialogSuccess } = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)((shouldOpenLegacyModal = false)=>{
        closeIssueTransitionModalAction();
        resetState();
        if (shouldOpenLegacyModal) {
            const onOpenDialog = ()=>{
                (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'legacyTransitionsScreen Switched');
            };
            (0, $ipUU1.openLegacyIssueTransitionModal)({
                issueKey: issueKey,
                isReopenScenario: true,
                transitionId: transitionId,
                onDialogCancel: onDialogCancel,
                onDialogError: onDialogError,
                onDialogSuccess: onDialogSuccess,
                onOpenDialog: onOpenDialog
            });
        }
    }, [
        closeIssueTransitionModalAction,
        createAnalyticsEvent,
        issueKey,
        onDialogCancel,
        onDialogError,
        onDialogSuccess,
        transitionId,
        resetState
    ]);
};
const $f41d32ebe3d90af0$export$95a1e9702d78f223 = ()=>{
    const state = (0, $gjoNn.useTriggerIssueTransitionModalState)();
    const actions = (0, $gjoNn.useTriggerIssueTransitionModalActions)();
    const { openIssueTransitionModalNew: openIssueTransitionModalNew, ...restActions } = actions;
    const openIssueTransitionModal = $f41d32ebe3d90af0$export$736bd10472c63b49();
    return [
        state,
        {
            ...restActions,
            openIssueTransitionModal: openIssueTransitionModal
        }
    ];
};
var $f41d32ebe3d90af0$export$2e2bcd8739ae039 = $f41d32ebe3d90af0$export$95a1e9702d78f223;

});
parcelRegister("lTEVZ", function(module, exports) {

$parcel$export(module.exports, "fireIssueTransitionErrorAnalytics", () => $63e82840dc2f165f$export$3839c9497170b08f);

var $jcw0u = parcelRequire("jcw0u");

var $4R6GH = parcelRequire("4R6GH");

var $fukJp = parcelRequire("fukJp");
const $63e82840dc2f165f$export$3839c9497170b08f = (payload)=>{
    if (!(0, $4R6GH.fg)('issue-transition-fire-error-analytics-refactor')) return (0, $jcw0u.default)(payload);
    const { attributes: attributes = {}, error: error, ...otherPayload } = payload;
    (0, $fukJp.fireErrorAnalyticsCommon)({
        ...otherPayload,
        attributes: {
            ...attributes
        },
        error: error
    });
};

});
parcelRegister("fukJp", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalyticsCommon", () => $2a45d398159543ce$export$51f199f6846377f7);

var $jcw0u = parcelRequire("jcw0u");

var $1qgAp = parcelRequire("1qgAp");
const $2a45d398159543ce$export$51f199f6846377f7 = (payload)=>{
    const { skipSentry: skipSentry = true, attributes: attributes, ...otherPayload } = payload;
    (0, $jcw0u.default)({
        ...otherPayload,
        attributes: {
            ...attributes,
            ...(0, $1qgAp.getTenantAttributes)()
        },
        skipSentry: // skiping sentry as true for fireErrorAnalytics
        skipSentry
    });
};

});
parcelRegister("1qgAp", function(module, exports) {

$parcel$export(module.exports, "getTenantAttributes", () => $b69c35ebd4c3a77a$export$bc31ff13a0bbe592);

var $j8DrX = parcelRequire("j8DrX");

var $aIZdc = parcelRequire("aIZdc");
const $b69c35ebd4c3a77a$export$bc31ff13a0bbe592 = ()=>{
    const shard = (0, $j8DrX.default)('ajs-shard');
    const region = (0, $j8DrX.default)('ajs-region');
    return {
        shard: shard,
        region: region,
        isFedRamp: (0, $aIZdc.isFedRamp)()
    };
};

});



parcelRegister("6ikhl", function(module, exports) {

$parcel$export(module.exports, "useInlineFields", () => $d56dd4f138add558$export$71d5b5acb7d7f5ce);
$parcel$export(module.exports, "useInlineField", () => $d56dd4f138add558$export$14c9655e9d9e873c);
$parcel$export(module.exports, "useInlineFieldsActions", () => $d56dd4f138add558$export$cdb4b503c6154b35);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $5rCpD = parcelRequire("5rCpD");
// Inline fields state tracks field states in create issue view as the user interacts with them
// this is particularly needed as we want to save the field's value when the user
// unfocuses the field
const $d56dd4f138add558$var$store = (0, $iXqE5.createStore)({
    name: 'forge.inline-fields-state',
    initialState: {},
    actions: $5rCpD.default
});
const $d56dd4f138add558$export$71d5b5acb7d7f5ce = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store);
const $d56dd4f138add558$export$14c9655e9d9e873c = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: (state, fieldId)=>state[fieldId]
});
const $d56dd4f138add558$export$cdb4b503c6154b35 = (0, $3sQ5x.createHook)($d56dd4f138add558$var$store, {
    selector: null
});

});
parcelRegister("5rCpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $02373df28193ad93$export$2e2bcd8739ae039);

var $hPhpd = parcelRequire("hPhpd");
const $02373df28193ad93$var$actions = {
    setFieldState: $hPhpd.setFieldState,
    resetState: $hPhpd.resetState,
    dispatchRetryFunction: $hPhpd.dispatchRetryFunction,
    dispatchFormSubmits: $hPhpd.dispatchFormSubmits
};
var $02373df28193ad93$export$2e2bcd8739ae039 = $02373df28193ad93$var$actions;

});
parcelRegister("hPhpd", function(module, exports) {

$parcel$export(module.exports, "setFieldState", () => $9eca433be421af07$export$80fd62d9217dd703);
$parcel$export(module.exports, "resetState", () => $9eca433be421af07$export$8e84bad0b35de9e8);
$parcel$export(module.exports, "dispatchRetryFunction", () => $9eca433be421af07$export$27c59f06a7c1fe26);
$parcel$export(module.exports, "dispatchFormSubmits", () => $9eca433be421af07$export$42fd5e650971333b);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state


var $9J85a = parcelRequire("9J85a");
const $9eca433be421af07$export$80fd62d9217dd703 = (data)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const stateObject = {
            status: data.status !== undefined ? data.status : currentState[data.fieldId]?.status,
            formRef: data.formRef !== undefined ? data.formRef : currentState[data.fieldId]?.formRef,
            retryFunction: data.retryFunction !== undefined ? data.retryFunction : currentState[data.fieldId]?.retryFunction
        };
        setState({
            ...getState(),
            [data.fieldId]: stateObject
        });
    };
const $9eca433be421af07$export$8e84bad0b35de9e8 = ()=>({ getState: getState, setState: setState })=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const stateToOverride = {};
        Object.getOwnPropertyNames(getState()).forEach((fieldId)=>{
            stateToOverride[fieldId] = {
                status: (0, $3e5c7761c2e3cf02$export$bbf78c43fa5268c8)
            };
        });
        setState(stateToOverride);
    };
const $9eca433be421af07$export$27c59f06a7c1fe26 = (fieldId)=>async ({ getState: getState })=>{
        const currentState = getState();
        const fieldData = currentState[fieldId];
        const retryFunction = fieldData?.retryFunction;
        retryFunction && retryFunction();
    };
const $9eca433be421af07$export$42fd5e650971333b = ()=>async ({ getState: getState })=>{
        const currentState = getState();
        Object.keys(currentState).forEach((fieldId)=>{
            if (currentState[fieldId]?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487)) {
                const formRef = currentState[fieldId]?.formRef;
                (0, $9J85a.dispatchFormSubmitAndBlurElements)(formRef);
            }
        });
    };

});
const $3e5c7761c2e3cf02$export$32bbcfb76243a487 = 'FOCUSED';
const $3e5c7761c2e3cf02$export$f81c1d6b9217380c = 'PENDING';
const $3e5c7761c2e3cf02$export$2ace7d3737836262 = 'RESOLVED';
const $3e5c7761c2e3cf02$export$9956c6a700e724c4 = 'STORED';
const $3e5c7761c2e3cf02$export$742c877aeb0f3dbd = 'FAILED';
const $3e5c7761c2e3cf02$export$bbf78c43fa5268c8 = 'IDLE';
const $3e5c7761c2e3cf02$export$ae7c16bdba5e2e15 = 10000;
const $3e5c7761c2e3cf02$export$30daef8830f2505d = 'WAIT';
const $3e5c7761c2e3cf02$export$f86e250f1a7b07c8 = 'PROCEED';
const $3e5c7761c2e3cf02$export$e784a07a62e2e0e5 = 'TIMEOUT';

parcelRegister("9J85a", function(module, exports) {

$parcel$export(module.exports, "submitForgeFormField", () => $b1c36799aab2b39a$export$7e50fee868362aa2);
$parcel$export(module.exports, "dispatchFormSubmitAndBlurElements", () => $b1c36799aab2b39a$export$4d639a8e0790daf2);
$parcel$export(module.exports, "isBlurEventTriggeredOutsideTheField", () => $b1c36799aab2b39a$export$ee23412a8bea9333);

const $b1c36799aab2b39a$export$7e50fee868362aa2 = (formRef)=>{
    formRef?.current?.requestSubmit();
};
const $b1c36799aab2b39a$export$4d639a8e0790daf2 = (formRef)=>{
    $b1c36799aab2b39a$export$7e50fee868362aa2(formRef);
    if (formRef?.current?.elements) Array.from(formRef.current.elements).forEach((element)=>{
        if ('blur' in element && typeof element.blur === 'function') element?.blur();
    });
};
const $b1c36799aab2b39a$export$ee23412a8bea9333 = (fieldState, event, divRef)=>fieldState?.status === (0, $3e5c7761c2e3cf02$export$32bbcfb76243a487) && !divRef.current?.contains(event.relatedTarget);

});




parcelRegister("ct2PA", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionsOperationalAnalyticsEvent", () => $539a3126b0b48d6d$export$4d10663856b750d0);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $539a3126b0b48d6d$export$4d10663856b750d0 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireOperationalEventIssueTransitionFieldsCount = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, fieldCount: fieldCount })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            fieldCount: fieldCount
        });
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsPermissionsUnAvailable = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject);
    }, [
        createAnalyticsEvent
    ]);
    const fireOperationalAnalyticsTransitionScreenOpened = (0, $5uXOq.useCallback)(({ actionSubject: actionSubject, isBenefitsModalFGEneabled: isBenefitsModalFGEneabled, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen, issueViewAnalyticsSource: issueViewAnalyticsSource, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal })=>{
        const analyticsEvent = createAnalyticsEvent({});
        (0, $8zOmE.fireOperationalAnalyticsDeferred)(analyticsEvent, actionSubject, {
            isBenefitsModalFGEneabled: isBenefitsModalFGEneabled,
            preferNewIssueTransitionScreen: preferNewIssueTransitionScreen,
            issueViewAnalyticsSource: issueViewAnalyticsSource,
            isBenefitsModalDisabled: isBenefitsModalDisabled,
            dateToShowBenefitsModal: dateToShowBenefitsModal
        });
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireOperationalEventIssueTransitionFieldsCount: fireOperationalEventIssueTransitionFieldsCount,
        fireOperationalAnalyticsPermissionsUnAvailable: fireOperationalAnalyticsPermissionsUnAvailable,
        fireOperationalAnalyticsTransitionScreenOpened: fireOperationalAnalyticsTransitionScreenOpened
    };
};

});

parcelRegister("3NlyR", function(module, exports) {

$parcel$export(module.exports, "useIssueTransitionUIAnalyticsEvent", () => $5656c248adec15f1$export$d0823e3d2e087672);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $5656c248adec15f1$export$d0823e3d2e087672 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const fireUIEvent = (0, $5uXOq.useCallback)(({ analyticsEvent: analyticsEvent, actionSubjectId: actionSubjectId, action: action = 'clicked', actionSubject: actionSubject, attributes: attributes = {} })=>{
        if (analyticsEvent !== undefined) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, attributes);
        else {
            const createdAnalyticsEvent = createAnalyticsEvent({
                action: action,
                actionSubject: actionSubject
            });
            (0, $8zOmE.fireUIAnalytics)(createdAnalyticsEvent, actionSubjectId, attributes);
        }
    }, [
        createAnalyticsEvent
    ]);
    return {
        fireUIEvent: fireUIEvent
    };
};

});

parcelRegister("1btwe", function(module, exports) {

$parcel$export(module.exports, "usePublishOpenIssueTransitionModalPubSub", () => $9796b79be99bbec0$export$76b6328962c9935f);

var $5uXOq = parcelRequire("5uXOq");


var $iXy8e = parcelRequire("iXy8e");
const $9796b79be99bbec0$export$76b6328962c9935f = ()=>(0, $5uXOq.useCallback)((payload, isEnabled)=>{
        (0, $iXy8e.ITSPubSub).publish((0, $10a759732c3f1985$export$283bfc4a4b25707a), {
            payload: payload,
            isEnabled: isEnabled
        });
    }, []);

});
const $10a759732c3f1985$export$283bfc4a4b25707a = 'open-issue-transition-modal';

parcelRegister("iXy8e", function(module, exports) {

$parcel$export(module.exports, "ITSPubSub", () => $c6c4e897a3edd1a2$export$a3877931259d622e);

var $da7iT = parcelRequire("da7iT");
const $c6c4e897a3edd1a2$export$a3877931259d622e = new (0, $da7iT.PubSubHub)();
const $c6c4e897a3edd1a2$export$58b86c4766378620 = ()=>({
        ...$c6c4e897a3edd1a2$export$a3877931259d622e
    });

});
parcelRegister("da7iT", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $4d1dbccbbe967a62$export$e3607828f8f2c01e);
class $4d1dbccbbe967a62$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("gjoNn", function(module, exports) {

$parcel$export(module.exports, "TriggerIssueTransitionModalContainer", () => $18f6c8628e84d111$export$8ad65e459a406a8a);
$parcel$export(module.exports, "useTriggerIssueTransitionModalActions", () => $18f6c8628e84d111$export$68de001c738e4145);
$parcel$export(module.exports, "useTriggerIssueTransitionModalState", () => $18f6c8628e84d111$export$d3aceeec551eaab5);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");

var $QnL9H = parcelRequire("QnL9H");

var $bpOxh = parcelRequire("bpOxh");
const $18f6c8628e84d111$var$store = (0, $iXqE5.createStore)({
    name: 'issue-transition.issue-transition-form.use-trigger-issue-transition-modal',
    initialState: $QnL9H.initialState,
    actions: $bpOxh
});
const $18f6c8628e84d111$export$8ad65e459a406a8a = (0, $gg7kZ.createContainer)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$68de001c738e4145 = (0, $3sQ5x.createActionsHook)($18f6c8628e84d111$var$store);
const $18f6c8628e84d111$export$d3aceeec551eaab5 = (0, $3sQ5x.createStateHook)($18f6c8628e84d111$var$store);

});
parcelRegister("QnL9H", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $b1651ed43432db50$export$d4c72bab9d6cc13a);
$parcel$export(module.exports, "OPEN_MODERN_TRANSITION_MODAL", () => $b1651ed43432db50$export$7320afd6d2c7276d);
$parcel$export(module.exports, "OPEN_LEGACY_TRANSITION_MODAL", () => $b1651ed43432db50$export$8ed7400ca8e89de2);

const $b1651ed43432db50$export$d4c72bab9d6cc13a = {
    isModalOpen: false,
    isBenefitsModalOpen: false,
    isSubsequentLoad: false,
    payload: {
        issueId: '',
        issueKey: '',
        transitionId: ''
    },
    id: 'issue-transition-dialog',
    title: null,
    fetchedIssueId: '',
    triggerPointKey: (0, $b09837015a6d4fc3$export$8d987f6e80b74000),
    openLegacyTransitionsDialog: null,
    onDialogSuccess: null,
    onDialogCancel: null,
    onDialogError: null
};
const $b1651ed43432db50$export$7320afd6d2c7276d = 'OPEN_MODERN_TRANSITION_MODAL';
const $b1651ed43432db50$export$8ed7400ca8e89de2 = 'OPEN_LEGACY_TRANSITION_MODAL';

});
const $b09837015a6d4fc3$export$ef94a84e2990361c = 'issue-transition-issue-view';
const $b09837015a6d4fc3$export$de11f84a7d32933b = 'issue-transition-board-card-transition';
const $b09837015a6d4fc3$export$6c46e4003e7b7e9c = 'issue-transition-advanced-roadmaps-jira-transition';
const $b09837015a6d4fc3$export$e77cd508fbc3b5ba = 'issue-transition-backlog-inline-transition';
const $b09837015a6d4fc3$export$4edf4c3eee5081f6 = 'issue-transition-issue-view-shortcut-dialog';
const $b09837015a6d4fc3$export$27b74e685c26e665 = 'issue-transition-command-palette-status-field-transition';
const $b09837015a6d4fc3$export$290710ac08f770c0 = 'issue-transition-issue-results-shortcut-transition';
const $b09837015a6d4fc3$export$ddade13ad1b89bf0 = 'issue-transition-status-field-trigger';
const $b09837015a6d4fc3$export$8d987f6e80b74000 = 'trigger-point-key-not-defined';
const $b09837015a6d4fc3$export$2bf0e335b815a90b = 'comment';
const $b09837015a6d4fc3$export$1b8cc53b37a62399 = 'worklog';
const $b09837015a6d4fc3$export$d624b8367eb730df = 'issuelinks';


parcelRegister("bpOxh", function(module, exports) {

$parcel$export(module.exports, "closeIssueTransitionModal", () => (parcelRequire("3KYVT")).default);
$parcel$export(module.exports, "openIssueTransitionModal", () => (parcelRequire("3cIaS")).default);
$parcel$export(module.exports, "restoreState", () => (parcelRequire("keQtD")).default);
$parcel$export(module.exports, "setFetchedIssueId", () => (parcelRequire("fb5Xn")).default);
$parcel$export(module.exports, "hideBenefitsModal", () => (parcelRequire("bemkp")).default);
$parcel$export(module.exports, "openIssueTransitionModalNew", () => (parcelRequire("bnv5t")).default);
// eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports

var $3KYVT = parcelRequire("3KYVT");

var $3cIaS = parcelRequire("3cIaS");

var $keQtD = parcelRequire("keQtD");

var $fb5Xn = parcelRequire("fb5Xn");

var $bemkp = parcelRequire("bemkp");

var $bnv5t = parcelRequire("bnv5t");

});
parcelRegister("3KYVT", function(module, exports) {

$parcel$export(module.exports, "default", () => $09ddf425c332ed49$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");
const $09ddf425c332ed49$var$closeIssueTransitionModal = ()=>({ setState: setState })=>{
        setState({
            ...(0, $QnL9H.initialState),
            isModalOpen: false,
            isSubsequentLoad: true
        });
    };
var $09ddf425c332ed49$export$2e2bcd8739ae039 = $09ddf425c332ed49$var$closeIssueTransitionModal;

});

parcelRegister("3cIaS", function(module, exports) {

$parcel$export(module.exports, "default", () => $cc7e957c004b1c31$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $cc7e957c004b1c31$var$openIssueTransitionModal = (nextState, preferNewIssueTransitionScreen = true)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $cc7e957c004b1c31$export$2e2bcd8739ae039 = $cc7e957c004b1c31$var$openIssueTransitionModal;

});
parcelRegister("eVcDT", function(module, exports) {

$parcel$export(module.exports, "default", () => $25bfe0b90f22578e$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $6BZYo = parcelRequire("6BZYo");
var $ig88W = parcelRequire("ig88W");
var $7T84i = parcelRequire("7T84i");
var $9B86Q = parcelRequire("9B86Q");
var $cQZXC = parcelRequire("cQZXC");
var $8JNtu = parcelRequire("8JNtu");

var $4tcSU = parcelRequire("4tcSU");

var $4R6GH = parcelRequire("4R6GH");

var $emTT1 = parcelRequire("emTT1");
class $25bfe0b90f22578e$export$2e2bcd8739ae039 {
    constructor({ issueId: issueId, transitionId: transitionId, issueKey: issueKey, issueKeys: issueKeys }){
        this.onDialogSuccessCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogErrorCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.onDialogCancelCallback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        this.issueId = issueId;
        this.transitionId = transitionId;
        this.issueKey = issueKey;
        this.issueKeys = issueKeys;
    }
    static{
        this.onDialogContentReady = ()=>{
            // This event fired by a dialog before the dialog itself is rendered and visible to the user
            // That's why we need to postpone sending the response to the next moment after it became visible
            setTimeout(()=>{
                (0, $emTT1.timeToRenderTransitionModal).stop();
            });
        };
    }
    onDialogSuccess(onDialogSuccessCallback) {
        this.onDialogSuccessCallback = onDialogSuccessCallback;
        return this;
    }
    onDialogError(onDialogErrorCallback) {
        this.onDialogErrorCallback = onDialogErrorCallback;
        return this;
    }
    onDialogCancel(onDialogCancelCallback) {
        this.onDialogCancelCallback = onDialogCancelCallback;
        return this;
    }
    getIssueParam() {
        if (this.issueId != null) return `id=${this.issueId}`;
        if (this.issueKey != null) return `key=${this.issueKey}`;
        return '';
    }
    getUrl() {
        const { issueKeys: issueKeys } = this;
        if (issueKeys != null) // key= is needed to be sent together with keys= because of legacy API
        return `/secure/BulkTransitionIssue!default.jspa?keys=${issueKeys.join(',')}&key=${issueKeys[0]}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&decorator=dialog&inline=true&returnUrl=`;
        return `/secure/WorkflowUIDispatcher.jspa?${this.getIssueParam()}&action=${this.transitionId}&atl_token=${(0, $4tcSU.default)() || ''}&returnUrl=`;
    }
    async show() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
        let FormDialog;
        /**
		 * Trying out different ways of load the AMD bundle for legacy issue transition dialog
		 */ /* eslint-disable jira/wrm/no-load-bridge */ if ((0, $4R6GH.fg)('legacy-its-modal-load-with-load-bridge-weak')) FormDialog = await (0, $9B86Q.loadBridgeWeak)({
            name: 'jira/dialog/form-dialog'
        });
        else if ((0, $4R6GH.fg)('legacy-its-modal-load-with-load-bridge-strict')) {
            await (0, $cQZXC.waitForHeritage)();
            FormDialog = await (0, $7T84i.loadBridgeStrict)({
                name: 'jira/dialog/form-dialog',
                wrmKeys: [
                    'wrc!jira.webresources:dialogs'
                ]
            });
        } else if ((0, $4R6GH.fg)('legacy-issue-transition-load-bridge')) {
            await (0, $8JNtu.wrmRequire)([
                'wrc!jira.webresources:dialogs'
            ]);
            FormDialog = await (0, $ig88W.loadBridgeRace)({
                name: 'jira/dialog/form-dialog',
                timeout: 2000
            });
        } else FormDialog = await (0, $6BZYo.loadBridge)({
            name: 'jira/dialog/form-dialog',
            wrmKeys: 'wrc!jira.webresources:dialogs'
        });
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        const dialog = new FormDialog({
            id: 'edit-issue-dialog',
            ajaxOptions: {
                url: this.getUrl(),
                dataType: 'json'
            },
            autoClose: true,
            widthClass: 'large',
            onDialogFinished: this.onDialogSuccessCallback,
            onUnSuccessfulSubmit: this.onDialogErrorCallback,
            shouldLoadHeritageFormDialogContext: true
        });
        const cancelNativeHandler = (event)=>{
            if (!(event instanceof CustomEvent)) return;
            const dialogElement = event.detail.popup;
            const { reason: reason } = event.detail;
            if (dialogElement.is(dialog.get$popup())) {
                if (reason === 'cancel' || reason === 'esc') this.onDialogCancelCallback(event, dialogElement, reason);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                document.removeEventListener('legacyJiraDialogContentReady', $25bfe0b90f22578e$export$2e2bcd8739ae039.onDialogContentReady);
            }
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.addEventListener('legacyJiraDialogBeforeHide', cancelNativeHandler);
        dialog.show();
    }
}

});
parcelRegister("emTT1", function(module, exports) {

$parcel$export(module.exports, "timeToRenderTransitionModal", () => $4a78c80c71ff3414$export$9d20a86383e90d09);

var $dGrdR = parcelRequire("dGrdR");
const $4a78c80c71ff3414$export$9d20a86383e90d09 = (0, $dGrdR.metrics).interaction({
    key: 'issue.time-to.render-issue-transition-screen',
    // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string; }' but required in type 'InteractionHistogramConfig'.
    histogram: {
        result: '500_1000_2500_4000_7000_10000'
    }
});

});


parcelRegister("jtjyW", function(module, exports) {

$parcel$export(module.exports, "startIssueTransitionMetrics", () => $1832266ecf87e128$export$3fc439100e136a52);

var $eTXmK = parcelRequire("eTXmK");

var $lL2Jl = parcelRequire("lL2Jl");

var $lP1Jn = parcelRequire("lP1Jn");

var $fc6nm = parcelRequire("fc6nm");
const $1832266ecf87e128$export$3fc439100e136a52 = (isSubsequentLoad)=>{
    (0, $lL2Jl.IssueTransitionLoadUFOExperience).start();
    (0, $lL2Jl.IssueTransitionUFOExperience).start();
    const issueTransitionModalLoadMetric = isSubsequentLoad ? (0, $lP1Jn.issueTransittionModalLoadSubsequent) : (0, $lP1Jn.issueTransitionModalLoad);
    if (isSubsequentLoad) (0, $eTXmK.default)('issue-transition.transition-modal-subsequent');
    else (0, $eTXmK.default)('issue-transition.transition-modal');
    issueTransitionModalLoadMetric.start();
    (0, $fc6nm.startUimTTI)();
};

});
parcelRegister("lL2Jl", function(module, exports) {

$parcel$export(module.exports, "IssueTransitionLoadUFOExperience", () => $f07939f1a4892f29$export$8fb308d8abecd81a);
$parcel$export(module.exports, "IssueTransitionSubmitUFOExpereince", () => $f07939f1a4892f29$export$bd3bf8b90a131c50);
$parcel$export(module.exports, "IssueTransitionUFOExperience", () => $f07939f1a4892f29$export$2f3b26e8acf79182);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $f07939f1a4892f29$export$8fb308d8abecd81a = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-load', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-load'
});
const $f07939f1a4892f29$export$bd3bf8b90a131c50 = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-submit', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-sumbit'
});
const $f07939f1a4892f29$export$2f3b26e8acf79182 = new (0, $duUGa.UFOExperience)('issue-transition-screen.transition-issue', {
    type: (0, $atdLB.ExperienceTypes).Experience,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom,
    category: 'issue-transition-screen.transition-issue'
});

});

parcelRegister("lP1Jn", function(module, exports) {

$parcel$export(module.exports, "issueTransitionModalLoad", () => $e48205cb6c384272$export$772fb4a8bd181fd6);
$parcel$export(module.exports, "issueTransittionModalLoadSubsequent", () => $e48205cb6c384272$export$afa89f024c56a00a);

var $dGrdR = parcelRequire("dGrdR");
const $e48205cb6c384272$export$772fb4a8bd181fd6 = (0, $dGrdR.metrics).interaction({
    key: 'issue-transition-modal'
});
const $e48205cb6c384272$export$afa89f024c56a00a = (0, $dGrdR.metrics).interaction({
    key: 'issue-transition-modal-subsequent'
});

});

parcelRegister("fc6nm", function(module, exports) {

$parcel$export(module.exports, "startUimTTI", () => $50f6a9f98192a4eb$export$ae34c17d9cd2c876);
$parcel$export(module.exports, "markIssueTransitionLoaded", () => $50f6a9f98192a4eb$export$7cc1bb35860c7c25);
$parcel$export(module.exports, "stopTTI", () => $50f6a9f98192a4eb$export$30ca4c461fab486c);
$parcel$export(module.exports, "cancelTTI", () => $50f6a9f98192a4eb$export$27f2445288b528c);
$parcel$export(module.exports, "markIframeLoad", () => $50f6a9f98192a4eb$export$7a2709fc1e33401a);
$parcel$export(module.exports, "markFieldsRegistered", () => $50f6a9f98192a4eb$export$cf3893335c93e33b);
$parcel$export(module.exports, "markOnInitResolved", () => $50f6a9f98192a4eb$export$d86f4868694f2aa7);
/**
 * For issue view, we moved similar constants to view-specific packages.
 * However, for issue-transition, such a move causes a circular dependency with @atlassian/jira-issue-transition-trigger package,
 * since view-specific/issue-transition imports trigger points related functionality from @atlassian/jira-issue-transition-trigger.
 * Therefore, for now, let's keep it here.
 */ 
var $dGrdR = parcelRequire("dGrdR");
const $50f6a9f98192a4eb$var$uimInIssueTransitionTTI = (0, $dGrdR.metrics).interaction({
    key: 'ui-modifications-in-issue-transition',
    timings: [
        {
            key: 'issue-transition-tti-delta',
            startMark: 'issue-transition-tti'
        },
        {
            key: 'script-execution',
            startMark: 'iframe-load'
        },
        {
            key: 'loading-indicators-visibility',
            startMark: 'fields-registered'
        },
        {
            key: 'time-until-oninit-resolved',
            endMark: 'oninit-resolved'
        }
    ]
});
const $50f6a9f98192a4eb$export$ae34c17d9cd2c876 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.start();
};
const $50f6a9f98192a4eb$export$7cc1bb35860c7c25 = ()=>$50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('issue-transition-tti');
const $50f6a9f98192a4eb$export$30ca4c461fab486c = (customData)=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.stop({
        customData: customData
    });
};
const $50f6a9f98192a4eb$export$27f2445288b528c = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.cancel();
};
const $50f6a9f98192a4eb$export$7a2709fc1e33401a = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('iframe-load');
};
const $50f6a9f98192a4eb$export$cf3893335c93e33b = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('fields-registered');
};
const $50f6a9f98192a4eb$export$d86f4868694f2aa7 = ()=>{
    $50f6a9f98192a4eb$var$uimInIssueTransitionTTI.mark('oninit-resolved');
};

});


parcelRegister("jHYHS", function(module, exports) {

$parcel$export(module.exports, "isNewTransitionScreenEnabled", () => $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d);

var $aIZdc = parcelRequire("aIZdc");

var $4R6GH = parcelRequire("4R6GH");
const $5f3a7dc1f1182e00$export$1f5b72e7dbe0548d = (preferNewIssueTransitionScreen, triggerPointKey)=>{
    if ((0, $aIZdc.isFedRamp)()) return true;
    if (!(0, $4R6GH.fg)('render-modern-issue-transition')) return false;
    if (!triggerPointKey) return false;
    return preferNewIssueTransitionScreen || (0, $4R6GH.fg)('issue-transition-customisation-for-srb');
};

});


parcelRegister("keQtD", function(module, exports) {

$parcel$export(module.exports, "default", () => $9984214aecd9b0cd$export$2e2bcd8739ae039);
const $9984214aecd9b0cd$var$restoreState = (stateToRestore)=>({ setState: setState })=>{
        setState(stateToRestore);
    };
var $9984214aecd9b0cd$export$2e2bcd8739ae039 = $9984214aecd9b0cd$var$restoreState;

});

parcelRegister("fb5Xn", function(module, exports) {

$parcel$export(module.exports, "default", () => $58f04f71b4951234$export$2e2bcd8739ae039);
/**
 *
 * @deprecated since we should not be using this in the log run
 * we should not call this method any where and should clean this up as soon as GIC-JIS migration is done
 * @param issueId
 * @returns
 */ const $58f04f71b4951234$var$setFetchedIssueId = (issueId)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { fetchedIssueId: fetchedIssueId } = currentState;
        if (issueId !== fetchedIssueId) setState({
            ...currentState,
            fetchedIssueId: issueId
        });
    };
var $58f04f71b4951234$export$2e2bcd8739ae039 = $58f04f71b4951234$var$setFetchedIssueId;

});

parcelRegister("bemkp", function(module, exports) {

$parcel$export(module.exports, "default", () => $66c42f9cd1814e06$export$2e2bcd8739ae039);

var $QnL9H = parcelRequire("QnL9H");

var $jtjyW = parcelRequire("jtjyW");
const $66c42f9cd1814e06$var$hideBenefitsModal = (nextAction)=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        if (nextAction === (0, $QnL9H.OPEN_MODERN_TRANSITION_MODAL)) {
            (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: true
            });
        } else if (nextAction === (0, $QnL9H.OPEN_LEGACY_TRANSITION_MODAL)) {
            const { openLegacyTransitionsDialog: openLegacyTransitionsDialog } = getState();
            setState({
                ...currentState,
                isBenefitsModalOpen: false,
                isModalOpen: false
            });
            openLegacyTransitionsDialog?.();
        }
    };
var $66c42f9cd1814e06$export$2e2bcd8739ae039 = $66c42f9cd1814e06$var$hideBenefitsModal;

});

parcelRegister("bnv5t", function(module, exports) {

$parcel$export(module.exports, "default", () => $0522276a96c69778$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");

var $4R6GH = parcelRequire("4R6GH");

var $jtjyW = parcelRequire("jtjyW");

var $jHYHS = parcelRequire("jHYHS");
const $0522276a96c69778$var$openIssueTransitionModalNew = ({ nextState: nextState, preferNewIssueTransitionScreen: preferNewIssueTransitionScreen = true, issueViewAnalyticsSource: issueViewAnalyticsSource, publishTriggerToOpenTransitions: publishTriggerToOpenTransitions, isBenefitsModalDisabled: isBenefitsModalDisabled, dateToShowBenefitsModal: dateToShowBenefitsModal, fireUIEvent: fireUIEvent })=>({ setState: setState, getState: getState })=>{
        const currentState = getState();
        const { payload: { issueKey: issueKey = '', transitionId: transitionId = '' }, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, triggerPointKey: triggerPointKey } = nextState || {
            payload: {}
        };
        let transitionModalVersion = '';
        const isNewITSEnabled = (0, $jHYHS.isNewTransitionScreenEnabled)(preferNewIssueTransitionScreen, triggerPointKey);
        try {
            if (isNewITSEnabled) {
                if (issueViewAnalyticsSource === 'connect-issue') {
                    publishTriggerToOpenTransitions?.(nextState, preferNewIssueTransitionScreen);
                    fireUIEvent?.({
                        actionSubject: 'issueTransition',
                        actionSubjectId: 'connectIssue',
                        action: 'opened'
                    });
                    return;
                }
                transitionModalVersion = 'NEW';
                (0, $jtjyW.startIssueTransitionMetrics)(currentState.isSubsequentLoad);
                setState({
                    ...currentState,
                    isModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState
                });
                return;
            }
            const currentDate = new Date();
            const showBenefitsModalOnDate = dateToShowBenefitsModal && dateToShowBenefitsModal !== 'null' ? new Date(dateToShowBenefitsModal) : new Date(-1);
            const isDateToShowBenefitsModalLessThanCurrentDate = currentDate >= showBenefitsModalOnDate;
            if (!isBenefitsModalDisabled && issueViewAnalyticsSource !== 'connect-issue' && isDateToShowBenefitsModalLessThanCurrentDate && (0, $4R6GH.fg)('render-modern-issue-transition')) {
                // add condition to show BenefitsModal
                transitionModalVersion = 'NEW';
                const callback = ()=>{
                    (0, $emTT1.timeToRenderTransitionModal).start();
                    new (0, $eVcDT.default)({
                        issueKey: issueKey,
                        transitionId: transitionId
                    }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
                };
                setState({
                    ...currentState,
                    isBenefitsModalOpen: true,
                    // making fetchedIssueId as blank to ensure we donot end up using stale issueId
                    fetchedIssueId: '',
                    ...nextState,
                    openLegacyTransitionsDialog: callback
                });
            } else {
                transitionModalVersion = 'OLD';
                (0, $emTT1.timeToRenderTransitionModal).start();
                new (0, $eVcDT.default)({
                    issueKey: issueKey,
                    transitionId: transitionId
                }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
            }
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'transitionIssueTrigger',
                    packageName: 'jiraIssueTransitionTrigger',
                    teamName: 'gryffindor'
                },
                error: error,
                attributes: {
                    transitionModalVersion: transitionModalVersion
                },
                sendToPrivacyUnsafeSplunk: true
            });
            throw error;
        }
    };
var $0522276a96c69778$export$2e2bcd8739ae039 = $0522276a96c69778$var$openIssueTransitionModalNew;

});



parcelRegister("ipUU1", function(module, exports) {

$parcel$export(module.exports, "openLegacyIssueTransitionModal", () => $f258fa9a0604f29b$export$6bfef2005bd55204);

var $8Rkzz = parcelRequire("8Rkzz");

var $eVcDT = parcelRequire("eVcDT");

var $emTT1 = parcelRequire("emTT1");

var $lTEVZ = parcelRequire("lTEVZ");
const $f258fa9a0604f29b$export$6bfef2005bd55204 = ({ issueKey: issueKey, transitionId: transitionId, onDialogSuccess: onDialogSuccess, onDialogCancel: onDialogCancel, onDialogError: onDialogError, isReopenScenario: isReopenScenario = false, onOpenDialog: onOpenDialog })=>{
    try {
        (0, $emTT1.timeToRenderTransitionModal).start();
        new (0, $eVcDT.default)({
            issueKey: issueKey,
            transitionId: transitionId
        }).onDialogSuccess(onDialogSuccess || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogCancel(onDialogCancel || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).onDialogError(onDialogError || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))).show();
        onOpenDialog?.();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
            meta: {
                id: 'transitionIssueTrigger',
                packageName: 'jiraIssueTransitionTrigger',
                teamName: 'gryffindor'
            },
            error: error,
            attributes: {
                transitionModalVersion: 'OLD',
                isReopenScenario: isReopenScenario
            },
            sendToPrivacyUnsafeSplunk: true
        });
        throw error;
    }
};

});


parcelRegister("dTUtq", function(module, exports) {

$parcel$export(module.exports, "useShowFlag", () => $4e3d7d0cd8105532$export$46b5557ad4264ef7);

var $5uXOq = parcelRequire("5uXOq");

var $lTEVZ = parcelRequire("lTEVZ");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $6OtcO = parcelRequire("6OtcO");
const $4e3d7d0cd8105532$export$46b5557ad4264ef7 = ()=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const showIssueTransitionSuccessFlag = (0, $5uXOq.useCallback)((issueKey, status)=>{
        try {
            showFlag((0, $6OtcO.getTransitionSuccessFlag)(issueKey, status, formatMessage));
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $lTEVZ.fireIssueTransitionErrorAnalytics)({
                meta: {
                    id: 'showSuccessFlag',
                    packageName: 'jiraIssueTransitionUseShowFlag',
                    teamName: 'gryffindor'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        }
    }, [
        formatMessage,
        showFlag
    ]);
    const showIssueTransitionFailureFlag = (0, $5uXOq.useCallback)((issueKey, traceId)=>showFlag((0, $6OtcO.getTransitionFailureFlag)(issueKey, formatMessage, traceId)), [
        formatMessage,
        showFlag
    ]);
    return {
        showIssueTransitionSuccessFlag: showIssueTransitionSuccessFlag,
        showIssueTransitionFailureFlag: showIssueTransitionFailureFlag
    };
};

});
parcelRegister("6OtcO", function(module, exports) {

$parcel$export(module.exports, "getTransitionSuccessFlag", () => $12ec3642dfb43880$export$8cfa71b43d733669);
$parcel$export(module.exports, "getTransitionFailureFlag", () => $12ec3642dfb43880$export$d9438db72c9548f1);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $7HGHK = parcelRequire("7HGHK");

var $4O0IR = parcelRequire("4O0IR");
const $12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID = 'issueTransitionSuccessful';
const $12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID = 'issueTransitionFailure';
const $12ec3642dfb43880$export$8cfa71b43d733669 = (issueKey, status, formatMessage)=>{
    const showLinkToIssue = Boolean(issueKey && status);
    if (showLinkToIssue) return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatusIssueTermRefresh : (0, $4O0IR.default).issueTransitionSuccessfulWithIssueKeyAndStatus, {
            issueKey: issueKey,
            status: status
        }),
        description: (0, $4O0IR.default).issueTransitionSuccessfulFlagDescription,
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessfulWithIssueKeyAndStatus`,
        messageType: 'transactional'
    };
    return {
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID),
        type: 'success',
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4O0IR.default).issueTransitionSuccessfulIssueTermRefresh : (0, $4O0IR.default).issueTransitionSuccessful),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_SUCCESS_FLAG_ID}.success.issueTransitionSuccessful`,
        messageType: 'transactional'
    };
};
const $12ec3642dfb43880$export$d9438db72c9548f1 = (issueKey, formatMessage, traceId)=>({
        id: (0, $7HGHK.toFlagId)($12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID),
        type: 'error',
        title: issueKey ? formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $4O0IR.default).issueTransitionFailureWithKeyIssueTermRefresh : (0, $4O0IR.default).issueTransitionFailureWithKey, {
            issueKey: issueKey
        }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $4O0IR.default).issueTransitionFailureIssueTermRefresh : (0, $4O0IR.default).issueTransitionFailure),
        messageId: `issue-transition-use-show-flag.ui.use-show-flag.${$12ec3642dfb43880$var$ISSUE_TRANSITION_FAILURE_FLAG_ID}.error`,
        messageType: 'transactional',
        ...traceId && (0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? {
            traceId: traceId,
            error: new Error('TransitionFailureFlag')
        } : {}
    });

});


parcelRegister("luzUm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $bd890bb183837c1d$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $bd890bb183837c1d$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    successFlagMessage: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.success-flag-message",
        "defaultMessage": "Status updated"
    },
    errorFlagTitle: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-title",
        "defaultMessage": "We're unable to edit status"
    },
    errorFlagDescription: {
        "id": "issue-field-status.status-view.command-palette.use-save-status-field.error-flag-description",
        "defaultMessage": "Wait a few moments, then try again."
    }
});

});


parcelRegister("fBoWB", function(module, exports) {

$parcel$export(module.exports, "getTransitionKeywords", () => $b56280b3569df29a$export$258538e0d3d46460);
const $b56280b3569df29a$export$258538e0d3d46460 = (transition)=>{
    if (transition.name !== transition.to.name) return `${transition.name} ${transition.to.name}`;
    return transition.name;
};

});


parcelRegister("2NP8E", function(module, exports) {

$parcel$export(module.exports, "CreateStatusButton", () => $003c9066e5f3dd12$export$d2e0b4f33d77a2b8);
/* CreateStatusButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $gKECL = parcelRequire("gKECL");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");

var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $6s1PB = parcelRequire("6s1PB");

var $67hPg = parcelRequire("67hPg");
var $8VEBs = parcelRequire("8VEBs");


var $koeKL = parcelRequire("koeKL");

var $1xqgn = parcelRequire("1xqgn");

var $5BSCo = parcelRequire("5BSCo");

var $5XThk = parcelRequire("5XThk");

var $4zzYB = parcelRequire("4zzYB");

var $lr99B = parcelRequire("lr99B");
const $003c9066e5f3dd12$export$d2e0b4f33d77a2b8 = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], isPressable: isPressable = false, onClick: onClick, onClose: onClose, onStatusCreated: onStatusCreated, buttonRef: buttonRef = null, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const combinedInlineConfigurationExperiment = (0, $1xqgn.useCombinedInlineConfigurationExperiment)();
    const [inlineStatusConfigExp] = (0, $6s1PB.UNSAFE_noExposureExp)('inline_status_add_and_rename_in_gic');
    const isInlineStatusExperimentEnabled = inlineStatusConfigExp.get('isInlineStatusConfigEnabled', false);
    const trigger = (0, $8VEBs.useTriggerContext)((0, $lr99B.ConfigureStatusPanel));
    const handleClick = (0, $5uXOq.useCallback)((_e, analyticsEvent)=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createStatusButton'); // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        (combinedInlineConfigurationExperiment.isEnabled || isInlineStatusExperimentEnabled) && _e.stopPropagation();
    }, [
        combinedInlineConfigurationExperiment.isEnabled,
        isInlineStatusExperimentEnabled,
        onClick
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createStatusButton');
    }, [
        createAnalyticsEvent
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: $5BSCo.createStatusExperience,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusCreated: onStatusCreated,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        source,
        onStatusCreated,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $5uXOq.useCallback)((ref)=>isPressable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            xcss: $003c9066e5f3dd12$var$pressableStyles,
            onClick: handleClick,
            "data-show-on-hover": true // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            ,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $4zzYB.messages).createStatus)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $003c9066e5f3dd12$var$flexContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($003c9066e5f3dd12$var$StyledButton, {
            appearance: "subtle",
            shouldFitContainer: true,
            interactionName: "issue.fields.status.create-status.popup.open",
            onClick: handleClick,
            ref: ref
        }, formatMessage((0, $4zzYB.messages).createStatus))), [
        formatMessage,
        handleClick,
        isPressable,
        onMouseDown
    ]);
    return shouldTriggerModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $gKECL.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $gKECL.asyncInlineCreateStatusModal),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XThk.CreateOrEditStatusSkeleton), {
            numFormFields: 2
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
// Move all styled/xcss/css components to the bottom
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $003c9066e5f3dd12$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4cvr1h6o _y3gn1e5h _syaz1fxt _ca0qpxbi _u5f3utpp _n3tdpxbi _19bvutpp _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $003c9066e5f3dd12$var$flexContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});
const $003c9066e5f3dd12$var$pressableStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});
parcelRegister("gKECL", function(module, exports) {

$parcel$export(module.exports, "asyncInlineCreateStatusModal", () => $7044591110f97598$export$64a761d25b20910a);

var $8p8PB = parcelRequire("8p8PB");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $7044591110f97598$export$64a761d25b20910a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2DxoZ")), {
        moduleId: "4ce02bb0"
    }),
    getPreloadProps: ({ cloudId: cloudId, projectKey: projectKey })=>({
            queries: {
                inlineCreateStatusModal: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $8p8PB.default,
                    variables: {
                        cloudId: cloudId,
                        projectKey: projectKey
                    }
                }
            }
        })
});

});
parcelRegister("8p8PB", function(module, exports) {

$parcel$export(module.exports, "default", () => $32f21baf6b88fc48$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a1c9f0ca0f32a1a7d832e77365f43e75>>
 * @relayHash 0df4748cd7c393765978be5843c7a913
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b
const $32f21baf6b88fc48$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "a6f93e860194a5c2419c4911409b28d0ab9e3c6da5d722ecc79fae56d217265b",
        "metadata": {},
        "name": "srcAsyncInlineCreateStatusQuery",
        "operationKind": "query",
        "text": null
    }
};
var $32f21baf6b88fc48$export$2e2bcd8739ae039 = $32f21baf6b88fc48$var$node;

});

parcelRegister("2DxoZ", function(module, exports) {

let $1eb9223cdb2c4a87$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1eb9223cdb2c4a87$var$load("51fo4").then(()=>parcelRequire('e1e78'));

});


parcelRegister("eSc2f", function(module, exports) {

$parcel$export(module.exports, "defaultModalProps", () => $b84f9512c4920c38$export$14c11acc66fd51b3);
const $b84f9512c4920c38$export$14c11acc66fd51b3 = {
    width: 'small'
};

});

parcelRegister("67hPg", function(module, exports) {

$parcel$export(module.exports, "Trigger", () => $f5abbb29b5666c06$export$41fb9f06171c75f4);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $3Du7S = parcelRequire("3Du7S");

var $7F2yO = parcelRequire("7F2yO");

var $kKgGa = parcelRequire("kKgGa");

var $e2pRJ = parcelRequire("e2pRJ");

var $hDhQq = parcelRequire("hDhQq");
const $f5abbb29b5666c06$var$emptyEntryPointParams = {};
const $f5abbb29b5666c06$var$emptyEntryPointProps = {};
function $f5abbb29b5666c06$export$41fb9f06171c75f4({ children: children, entryPoint: entryPoint, entryPointParams: entryPointParams, entryPointProps: entryPointProps, fallback: fallback, errorFallback: errorFallback, forwardedRef: forwardedRef, trigger: trigger }) {
    const { setPanel: setPanel } = trigger;
    const environmentProvider = (0, $e2pRJ.useRelayEnvironmentProvider)();
    const id = (0, $5uXOq.useMemo)(()=>{
        return entryPoint.root.getModuleName() || 'unknown';
    }, [
        entryPoint
    ]);
    const load = (0, $5uXOq.useCallback)(()=>(0, $8Uumt.loadEntryPoint)(environmentProvider, entryPoint, entryPointParams ?? $f5abbb29b5666c06$var$emptyEntryPointParams), [
        entryPoint,
        entryPointParams,
        environmentProvider
    ]);
    const onLoad = (0, $5uXOq.useCallback)(({ reference: entryPointReference })=>{
        setPanel(/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kKgGa.InternalEntryPointContainer), {
            id: id,
            entryPointReference: entryPointReference,
            fallback: fallback || /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hDhQq.DefaultFallback), {}),
            errorFallback: errorFallback,
            runtimeProps: entryPointProps || $f5abbb29b5666c06$var$emptyEntryPointProps
        }));
    }, [
        setPanel,
        id,
        entryPointProps,
        fallback,
        errorFallback
    ]);
    const triggerRef = (0, $7F2yO.usePressablePreloadRef)({
        load: load,
        onLoad: onLoad
    });
    const mergedRef = (0, $3Du7S.useMergeRefs)([
        triggerRef,
        forwardedRef || null
    ]);
    return children({
        ref: mergedRef
    });
}

});
parcelRegister("hDhQq", function(module, exports) {

$parcel$export(module.exports, "DefaultFallback", () => $5d43ace1d77c91f8$export$93c734e924cdbdaa);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");
function $5d43ace1d77c91f8$export$93c734e924cdbdaa() {
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {}),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $iwwXK.default), {})
        ]
    });
}

});


parcelRegister("8VEBs", function(module, exports) {

$parcel$export(module.exports, "useTriggerContext", () => $a29797495c724c30$export$454c1d7c35958f5e);

var $5uXOq = parcelRequire("5uXOq");
function $a29797495c724c30$export$454c1d7c35958f5e(panel) {
    const { setPanel: setPanel } = (0, $5uXOq.useContext)(panel.Context);
    return (0, $5uXOq.useMemo)(()=>({
            setPanel: setPanel
        }), [
        setPanel
    ]);
}

});

const $77f8834f432b7338$export$c766acff4513a976 = 'summaryView';
const $77f8834f432b7338$export$4edb790587638895 = 'listView';
const $77f8834f432b7338$export$7e2d75b13279a710 = 'listViewNoResults';
const $77f8834f432b7338$export$5e4b47163db377f = 'listViewGroupByStatus';
const $77f8834f432b7338$export$cafb161c2b21b455 = 'issueView';
const $77f8834f432b7338$export$66397ed56abea4ca = 'gicView';
const $77f8834f432b7338$export$46d07e67f98555aa = 'editStatusButton';
const $77f8834f432b7338$export$415149578ef78676 = 'deleteStatusButton';

parcelRegister("1xqgn", function(module, exports) {

$parcel$export(module.exports, "OptionComponent", () => $e4635a311355eecc$export$3e92eb7b7644ac65);
$parcel$export(module.exports, "useSelectOptions", () => $e4635a311355eecc$export$338e37f345f318fa);
$parcel$export(module.exports, "useCombinedInlineConfigurationExperiment", () => $e4635a311355eecc$export$f7858f4c698ccb67);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $fJ83Q = parcelRequire("fJ83Q");

var $3LKEA = parcelRequire("3LKEA");

var $4Gswu = parcelRequire("4Gswu");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $k92cH = parcelRequire("k92cH");
const $e4635a311355eecc$export$3e92eb7b7644ac65 = ({ children: children, ...optionProps })=>{
    if ([
        (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3),
        (0, $4ffa16dc12cfa934$export$bc1622166baa0162),
        (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b)
    ].includes(optionProps.data.type)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJ83Q.OptionWithButtonStyle), optionProps, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Gswu.OptionWithAutoKeyboardScroll), optionProps, children);
};
const $e4635a311355eecc$export$338e37f345f318fa = (targetOptions, hasFooter)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const footerOptions = (0, $5uXOq.useMemo)(()=>{
        return [
            {
                label: formatMessage((0, $k92cH.default).createStatus),
                type: (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3),
                value: (0, $4ffa16dc12cfa934$export$bbd08ee543ba8cc3)
            },
            ...(0, $4R6GH.fg)('jira-adoption-new-edit-status-flow-inline-config') ? [
                {
                    label: formatMessage((0, $k92cH.default).editStatus),
                    type: (0, $4ffa16dc12cfa934$export$bc1622166baa0162),
                    value: (0, $4ffa16dc12cfa934$export$bc1622166baa0162)
                }
            ] : [],
            {
                label: formatMessage((0, $k92cH.default).manageWorkflow),
                type: (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b),
                value: (0, $4ffa16dc12cfa934$export$4f9299d0cd8b6a8b)
            }
        ];
    }, [
        formatMessage
    ]);
    const optionsWithFooter = (0, $3LKEA.appendStickyFooterOptions)(targetOptions, footerOptions);
    if (hasFooter) return optionsWithFooter;
    return targetOptions;
};
const $e4635a311355eecc$export$f7858f4c698ccb67 = (isEligible = true)=>{
    const [combinedInlineConfigurationExperiment, fireCombinedInlineConfigurationExperimentExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('combined_adoption_configuration_experiment');
    // eslint-disable-next-line jira/ff/unsafe-no-exposure, jira/deprecations/ban-identifiers
    const [_, fireCombinedInlineConfigurationExperimentAAExposure] = (0, $6s1PB.UNSAFE_noExposureExp)('combined_adoption_configuration_experiment_aa');
    const isEnabled = Boolean(isEligible && combinedInlineConfigurationExperiment.get('isEnabled', false));
    const fireExposure = ()=>{
        if (isEligible) {
            fireCombinedInlineConfigurationExperimentExposure();
            fireCombinedInlineConfigurationExperimentAAExposure();
        }
    };
    return {
        isEnabled: isEnabled,
        fireExposure: fireExposure
    };
};

});
parcelRegister("3LKEA", function(module, exports) {

$parcel$export(module.exports, "appendStickyFooterOptions", () => $cc9569724dc25e59$export$870da2f71d38aa94);
$parcel$export(module.exports, "useAppendStickyFooterOptions", () => $cc9569724dc25e59$export$9ef0653bfb9844e7);
$parcel$export(module.exports, "scrollIntoView", () => $cc9569724dc25e59$export$53a0910f038337bd);

var $5uXOq = parcelRequire("5uXOq");

const $cc9569724dc25e59$export$870da2f71d38aa94 = (options, footerOptions)=>{
    return [
        ...options,
        {
            options: footerOptions.map((footerOption)=>{
                return {
                    ...footerOption,
                    groupType: (0, $8109ad51236d2441$export$e13d614fc55c6ce9)
                };
            })
        }
    ];
};
const $cc9569724dc25e59$export$9ef0653bfb9844e7 = (options, footerOptions)=>{
    return (0, $5uXOq.useMemo)(()=>$cc9569724dc25e59$export$870da2f71d38aa94(options, footerOptions), [
        footerOptions,
        options
    ]);
};
function $cc9569724dc25e59$export$53a0910f038337bd(menuEl, focusedEl, bottomOffset = 0) {
    const menuRect = menuEl.getBoundingClientRect();
    const focusedRect = focusedEl.getBoundingClientRect();
    const overScroll = focusedEl.offsetHeight / 3;
    if (focusedRect.bottom + overScroll > menuRect.bottom - bottomOffset) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.min(focusedEl.offsetTop + focusedEl.clientHeight - menuEl.offsetHeight + bottomOffset + overScroll, menuEl.scrollHeight - bottomOffset);
    else if (focusedRect.top - overScroll < menuRect.top) // eslint-disable-next-line no-param-reassign
    menuEl.scrollTop = Math.max(focusedEl.offsetTop - overScroll, 0);
}

});

parcelRegister("4Gswu", function(module, exports) {

$parcel$export(module.exports, "OptionWithAutoKeyboardScroll", () => $615e8210cb21f219$export$39118cd824d8af0b);

var $5uXOq = parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $7mPT9 = parcelRequire("7mPT9");

var $3LKEA = parcelRequire("3LKEA");

const $615e8210cb21f219$export$39118cd824d8af0b = ({ children: children, containerRef: containerRef, ...optionProps })=>{
    const focusedOptionRef = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        if (optionProps.isFocused) {
            // We only auto scroll for focus with keyboard only, not for focus with mouse hover
            // because mouse users will manual scroll when browsing options
            if (!focusedOptionRef.current?.parentElement || focusedOptionRef.current?.matches(':hover')) return;
            // We need to add bottom offset when scrolling which is the current height of sticky footer options group
            const stickFooterBottomOffset = globalThis?.document.querySelector(`.${(0, $8109ad51236d2441$export$1ae91d219a8713ac)}`)?.clientHeight ?? 0;
            (0, $3LKEA.scrollIntoView)(containerRef?.current ?? focusedOptionRef.current.parentElement, focusedOptionRef.current, stickFooterBottomOffset);
        }
    }, [
        containerRef,
        optionProps.isFocused
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, {
        ...optionProps,
        innerRef: (0, $7mPT9.mergeRefs)(optionProps.innerRef, focusedOptionRef)
    }, children);
};

});

parcelRegister("k92cH", function(module, exports) {

$parcel$export(module.exports, "default", () => $d361f761a404638a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d361f761a404638a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPermission: {
        "id": "issue-field-status.status-view.no-permission",
        "defaultMessage": "You don't have permission to transition this issue"
    },
    cannotLoadTransitions: {
        "id": "issue-field-status.status-view.cannot-load-transitions",
        "defaultMessage": "We couldn't load the statuses and transitions"
    },
    changeStatus: {
        "id": "issue-field-status.status-view.change-status",
        "defaultMessage": "Change status"
    },
    selectStatus: {
        "id": "issue-field-status.status-view.select-status",
        "defaultMessage": "Select status"
    },
    transitionTo: {
        "id": "issue-field-status.status-view.transition-to",
        "defaultMessage": "Transition to {statusName}"
    },
    noPermissionIssueTermRefresh: {
        "id": "issue-field-status.status-view.no-permission-issue-term-refresh",
        "defaultMessage": "You don't have permission to transition this work item"
    },
    status: {
        "id": "issue-field-status.status-view.status",
        "defaultMessage": "Status"
    },
    createStatus: {
        "id": "issue-field-status.status-view.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "issue-field-status.status-view.edit-status",
        "defaultMessage": "Edit status"
    },
    manageWorkflow: {
        "id": "issue-field-status.status-view.manage-workflow",
        "defaultMessage": "Manage workflow"
    }
});

});


parcelRegister("5BSCo", function(module, exports) {

$parcel$export(module.exports, "createStatusExperience", () => $eb41bcd877362d81$export$750cfa63c61c5008);
$parcel$export(module.exports, "editStatusExperience", () => $eb41bcd877362d81$export$1c3aa89ea6d8c93d);

var $atdLB = parcelRequire("atdLB");
var $duUGa = parcelRequire("duUGa");
const $eb41bcd877362d81$export$750cfa63c61c5008 = new (0, $duUGa.UFOExperience)('issue-view.create-status', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});
const $eb41bcd877362d81$export$1c3aa89ea6d8c93d = new (0, $duUGa.UFOExperience)('issue-view.edit-status', {
    type: (0, $atdLB.ExperienceTypes).Operation,
    performanceType: (0, $atdLB.ExperiencePerformanceTypes).Custom
});

});

parcelRegister("5XThk", function(module, exports) {

$parcel$export(module.exports, "CreateOrEditStatusSkeleton", () => $4d5fc9f016f2a62c$export$63dd5f452da576a);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");
const $4d5fc9f016f2a62c$var$COMMON_SKELETON_PROPS = {
    borderRadius: 8,
    isShimmering: true
};
const $4d5fc9f016f2a62c$export$63dd5f452da576a = ({ numFormFields: numFormFields = 2 })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: $4d5fc9f016f2a62c$var$modalSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "column",
        xcss: $4d5fc9f016f2a62c$var$headerSkeletonStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.250"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "40%",
        height: 24,
        ...$4d5fc9f016f2a62c$var$COMMON_SKELETON_PROPS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: "35%",
        height: 16,
        ...$4d5fc9f016f2a62c$var$COMMON_SKELETON_PROPS
    }))), Array.from({
        length: numFormFields
    }).map((_, idx)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.050",
            key: idx,
            xcss: $4d5fc9f016f2a62c$var$formFieldSkeletonStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "30%",
            height: 16,
            ...$4d5fc9f016f2a62c$var$COMMON_SKELETON_PROPS
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            width: "100%",
            height: 40,
            ...$4d5fc9f016f2a62c$var$COMMON_SKELETON_PROPS
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        justifyContent: "end",
        gap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: 72,
        height: 32,
        ...$4d5fc9f016f2a62c$var$COMMON_SKELETON_PROPS
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        width: 72,
        height: 32,
        ...$4d5fc9f016f2a62c$var$COMMON_SKELETON_PROPS
    }))));
const $4d5fc9f016f2a62c$var$modalSkeletonStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.overlay',
    borderRadius: '12px',
    width: '394px',
    padding: 'space.300'
});
const $4d5fc9f016f2a62c$var$headerSkeletonStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $4d5fc9f016f2a62c$var$formFieldSkeletonStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100',
    marginBottom: 'space.100'
});

});

parcelRegister("4zzYB", function(module, exports) {

$parcel$export(module.exports, "messages", () => $229b8164a902ee55$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $229b8164a902ee55$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    statusNameButtonLabel: {
        "id": "issue-field-status.status-view.transition.configure-status.status-name-button-label",
        "defaultMessage": "Edit {statusName} status"
    },
    editStatusTooltip: {
        "id": "issue-field-status.status-view.transition.configure-status.edit-status-tooltip",
        "defaultMessage": "Edit status"
    },
    createStatus: {
        "id": "issue-field-status.status-view.configure-status.create-status",
        "defaultMessage": "Create status"
    },
    editStatus: {
        "id": "issue-field-status.status-view.configure-status.edit-status",
        "defaultMessage": "Edit status"
    }
});

});

parcelRegister("lr99B", function(module, exports) {

$parcel$export(module.exports, "ConfigureStatusPanel", () => $332940da0826dbe8$export$3f3f3d137a7524e6);

var $kdMib = parcelRequire("kdMib");
const $332940da0826dbe8$export$3f3f3d137a7524e6 = (0, $kdMib.createPanel)();

});
parcelRegister("kdMib", function(module, exports) {

$parcel$export(module.exports, "createPanel", () => $0420c2463bd557b6$export$71ce2d4d67b6d9e4);

var $5uXOq = parcelRequire("5uXOq");
function $0420c2463bd557b6$export$71ce2d4d67b6d9e4() {
    const Context = /*#__PURE__*/ (0, $5uXOq.createContext)({
        setPanel: ()=>{}
    });
    return {
        Context: Context
    };
}

});



parcelRegister("k9YKz", function(module, exports) {

$parcel$export(module.exports, "EditStatusButtonOld", () => $857bcc21cac789c2$export$618af92aa265aa26);

var $5uXOq = parcelRequire("5uXOq");

var $4ChK1 = parcelRequire("4ChK1");

var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $i7SlO = parcelRequire("i7SlO");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");


var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5BSCo = parcelRequire("5BSCo");

var $4zzYB = parcelRequire("4zzYB");
const $857bcc21cac789c2$export$618af92aa265aa26 = ({ status: status, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated, source: source })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onButtonClick = (event)=>{
        onClick();
        event.stopPropagation(); // prevents transition from being selected
    };
    const onCloseModal = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineEditStatusModal',
            action: 'closed'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onClickFireAnalytics = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editStatusButton');
    };
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onCloseModal,
            status: status,
            issueTypeId: issueTypeId,
            projectId: projectId,
            projectKey: projectKey,
            editStatusExperience: $5BSCo.editStatusExperience,
            statusNames: statusNames,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated
        }), [
        onCloseModal,
        status,
        issueTypeId,
        projectId,
        projectKey,
        statusNames,
        source,
        onStatusUpdated
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            tabIndex: 0,
            xcss: $857bcc21cac789c2$var$iconButtonStyles,
            onClick: onButtonClick,
            "aria-label": formatMessage((0, $4zzYB.messages).statusNameButtonLabel, {
                statusName: status.statusName
            }),
            testId: "issue-field-status.ui.status-view.configure-status.edit-status-button",
            "data-show-on-hover": true,
            // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            onKeyDown: (event)=>{
                event.stopPropagation();
                // Fire analytics when the button is accessed via keyboard
                if (event.code === 'Enter' || event.code === 'Space') onClickFireAnalytics();
            },
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onClickFireAnalytics();
            },
            onTouchStart: ()=>{
                // Touch interaction
                onClickFireAnalytics();
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $4zzYB.messages).editStatusTooltip),
            position: "bottom"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ChK1))), {
            label: "",
            LEGACY_size: "small",
            color: "var(--ds-icon, #44546F)"
        }))));
};
const $857bcc21cac789c2$var$iconButtonStyles = (0, $8CUq3.xcss)({
    borderRadius: 'border.radius',
    outlineOffset: 'space.0',
    padding: 'space.025',
    marginInline: 'space.100',
    opacity: 0,
    transition: 'opacity 0.3s ease',
    ':focus': {
        boxShadow: 'elevation.shadow.overflow',
        opacity: 1
    },
    ':hover': {
        backgroundColor: 'color.background.neutral.subtle.hovered',
        opacity: 1
    }
});

});
parcelRegister("4ChK1", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::631c9d525a923bb24b78f7aa2d70d92c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $35c87913ec905242$var$_react = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $35c87913ec905242$var$_edit = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("5nRKm")));

var $35c87913ec905242$var$_edit2 = $35c87913ec905242$var$_interopRequireDefault((parcelRequire("gsEeL")));
function $35c87913ec905242$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for EditIcon.
 * This component is EditIcon, with `UNSAFE_fallbackIcon` set to "EditIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $35c87913ec905242$var$EditIcon = (props)=>/*#__PURE__*/ $35c87913ec905242$var$_react.default.createElement($35c87913ec905242$var$_edit.default, Object.assign({
        LEGACY_fallbackIcon: $35c87913ec905242$var$_edit2.default
    }, props));
$35c87913ec905242$var$EditIcon.Name = 'EditIconMigration';
var $35c87913ec905242$var$_default = module.exports.default = $35c87913ec905242$var$EditIcon;

});
parcelRegister("5nRKm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ce3559d453dff44735097f553c900f9f>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $3eb8cab3ab465b93$var$_react = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $3eb8cab3ab465b93$var$_baseNew = $3eb8cab3ab465b93$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $3eb8cab3ab465b93$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Edit".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for editing objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $3eb8cab3ab465b93$var$EditIcon = (props)=>/*#__PURE__*/ $3eb8cab3ab465b93$var$_react.default.createElement($3eb8cab3ab465b93$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M11.586.854a2 2 0 0 1 2.828 0l.732.732a2 2 0 0 1 0 2.828L10.01 9.551a2 2 0 0 1-.864.51l-3.189.91a.75.75 0 0 1-.927-.927l.91-3.189a2 2 0 0 1 .51-.864zm1.768 1.06a.5.5 0 0 0-.708 0l-.585.586L13.5 3.94l.586-.586a.5.5 0 0 0 0-.707zM12.439 5 11 3.56 7.51 7.052a.5.5 0 0 0-.128.217l-.54 1.89 1.89-.54a.5.5 0 0 0 .217-.127zM3 2.501a.5.5 0 0 0-.5.5v10a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5v-3H15v3a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2v-10a2 2 0 0 1 2-2h3v1.5z" clip-rule="evenodd"/>`
    }, props));
$3eb8cab3ab465b93$var$EditIcon.displayName = 'EditIcon';
var $3eb8cab3ab465b93$var$_default = module.exports.default = $3eb8cab3ab465b93$var$EditIcon;

});

parcelRegister("gsEeL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bfbe7921991bc4cb$var$_react = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $bfbe7921991bc4cb$var$_edit = $bfbe7921991bc4cb$var$_interopRequireDefault((parcelRequire("5nRKm")));
function $bfbe7921991bc4cb$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $bfbe7921991bc4cb$var$EditIcon = (props)=>/*#__PURE__*/ $bfbe7921991bc4cb$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M4.02 19.23a1 1 0 0 0 1.18 1.18l3.81-.78-4.21-4.21zm5.92-2.62-2.12-2.12L16.31 6l2.12 2.12zm9.9-9.9-2.12-2.12A2 2 0 0 0 16.31 4c-.51 0-1.02.2-1.41.59l-9.76 9.76 4.95 4.95 9.76-9.76a2 2 0 0 0 0-2.83"/></svg>`
    }, props, {
        newIcon: $bfbe7921991bc4cb$var$_edit.default
    }));
$bfbe7921991bc4cb$var$EditIcon.displayName = 'EditIcon';
var $bfbe7921991bc4cb$var$_default = module.exports.default = $bfbe7921991bc4cb$var$EditIcon;

});


parcelRegister("i7SlO", function(module, exports) {

$parcel$export(module.exports, "asyncInlineEditStatusModal", () => $bc5734c540f0c454$export$c3f451c40832a786);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $bc5734c540f0c454$export$c3f451c40832a786 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("4Ajos")).then((module)=>module.AsyncInlineEditStatusModal), {
        moduleId: "177d76fa",
        moduleName: "AsyncInlineEditStatusModal"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("4Ajos", function(module, exports) {

let $356991598dd2ef64$var$load = (parcelRequire("28QjX"))(4);
module.exports = $356991598dd2ef64$var$load("2UWfb").then(()=>parcelRequire('5zJw9'));

});



parcelRegister("coyc6", function(module, exports) {

$parcel$export(module.exports, "LoadingSpinner", () => $75fbb15d605c0a9c$export$b08b517936747730);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
const $75fbb15d605c0a9c$export$b08b517936747730 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($75fbb15d605c0a9c$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        interactionName: "issue.fields.status.options.loading"
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $75fbb15d605c0a9c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qu2gc _u5f3u2gc _n3tdu2gc _19bvu2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("rNSQs", function(module, exports) {

$parcel$export(module.exports, "StatusButton", () => $acb4d573ba7a4450$export$517b7ecb2da8e76d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $c8Oei = parcelRequire("c8Oei");

var $3bDjY = parcelRequire("3bDjY");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $9wjvq = parcelRequire("9wjvq");

var $2Z7Z6 = parcelRequire("2Z7Z6");
const $acb4d573ba7a4450$var$getButton = (categoryId)=>{
    switch(categoryId){
        case 2:
            return $acb4d573ba7a4450$var$ToDoButton;
        case 3:
            return 0, $2Z7Z6.DoneButton;
        case 4:
            return $acb4d573ba7a4450$var$InProgressButton;
        default:
            return $acb4d573ba7a4450$var$DefaultButton;
    }
};
const $acb4d573ba7a4450$var$buttonStyle = null;
const $acb4d573ba7a4450$var$buttonStyleRefresh = null;
const $acb4d573ba7a4450$export$517b7ecb2da8e76d = (props)=>{
    const { ariaLabel: ariaLabel, isEditable: isEditable, isOpen: isOpen, status: status, targetRef: targetRef, statusButtonRef: statusButtonRef, shouldFitContainer: shouldFitContainer = true, triggerProps: triggerProps = {} } = props;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const Button = $acb4d573ba7a4450$var$getButton(status.statusCategory.id);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: targetRef,
        ...triggerProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "top",
        content: status.name
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9wjvq.default), {
        status: status
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Button, {
        id: "issue.fields.status-view.status-button",
        ref: statusButtonRef,
        "aria-label": ariaLabel,
        "aria-expanded": isOpen,
        isDisabled: !isEditable,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
            label: ""
        }),
        testId: "issue-field-status.ui.status-view.status-button.status-button",
        shouldFitContainer: shouldFitContainer,
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        // When the popup is open we don't want to track the click on this button as it solely closes
        // the popup.
        // The logic here may look incorrect, but it turns out that when clicking this button the
        // `isOpen` toggle happens before the `onClick` handler that sends the press tracing.
        // We need to disable the `jira/ufo/valid-labels` lint rule
        // because for this particular interaction we only want to track
        // opening the status popup.
        // eslint-disable-next-line jira/ufo/valid-labels
        interactionName: isOpen ? 'issue.fields.status.popup.open' : undefined,
        "data-ssr-placeholder": false && (0, $4R6GH.fg)('magma-3344_status_button_ssr_placeholder') ? 'status-button' : undefined,
        "data-ssr-placeholder-replace": !false && (0, $4R6GH.fg)('magma-3344_status_button_ssr_placeholder') ? 'status-button' : undefined,
        className: (0, $bwpsq.default)([
            "_12r21pd9",
            (0, $dCm1o.isVisualRefreshEnabled)() && "_19bv12x7 _1n8wglyw _12r21wq8"
        ])
    }, status.name))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $acb4d573ba7a4450$var$InProgressComponentVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193glmqn _11a4lmqn _dntb16l4 _cp4g16l4 _5xmdlmqn _11sm16l4",
            __cmplp.className
        ])
    });
});
const $acb4d573ba7a4450$var$InProgressComponentCurrent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1mk5 _11a41mk5 _dntb1gfe _cp4g1gfe _5xmd4vzc _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $acb4d573ba7a4450$var$InProgressButton = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $acb4d573ba7a4450$var$InProgressComponentVisualRefresh, $acb4d573ba7a4450$var$InProgressComponentCurrent);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $acb4d573ba7a4450$var$ToDoButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $acb4d573ba7a4450$var$DefaultButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9wjvq", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1216c2da1b38029$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");
// TODO consolidate status id's
const $b1216c2da1b38029$var$DONE_ID = 3;
class $b1216c2da1b38029$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    componentDidUpdate(prevProps) {
        if (prevProps.status.statusCategory.id !== this.props.status.statusCategory.id) this.setState({
            shouldShow: this.props.status.statusCategory.id === $b1216c2da1b38029$var$DONE_ID
        });
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1216c2da1b38029$var$PulseContainer, {
            shouldShow: this.state.shouldShow
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            shouldShow: false
        };
    }
}
const $b1216c2da1b38029$var$PulseAnimation = /*#__PURE__*/ (0, $47bDC.keyframes)({
    to: {
        boxShadow: '0 0 0 10px rgba(0, 0, 0, 0)'
    }
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const $b1216c2da1b38029$var$PulseContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldShow: shouldShow, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1qbqnkm": (0, $lD23V.default)($b1216c2da1b38029$var$PulseAnimation)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c116y _1bsb1osq _16qs1pcf",
            __cmplp.shouldShow ? "_y44v1upg" : "_y44vglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("2Z7Z6", function(module, exports) {

$parcel$export(module.exports, "DoneButton", () => $bb0c7ad61f4c3610$export$e6559310cd173125);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");
const $bb0c7ad61f4c3610$export$b7c3a2f69225ecf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$export$97f73b7c6e2328e5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1d94 _11a41d94 _dntb16l4 _cp4g16l4 _5xmd1hek _11sm16l4",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$var$InProgressComponentVisualRefresh = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193glmqn _11a4lmqn _dntb16l4 _cp4g16l4 _5xmdlmqn _11sm16l4",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$var$InProgressComponentCurrent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1mk5 _11a41mk5 _dntb1gfe _cp4g1gfe _5xmd4vzc _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$export$8c94aeefd701630d = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $bb0c7ad61f4c3610$var$InProgressComponentVisualRefresh, $bb0c7ad61f4c3610$var$InProgressComponentCurrent);
const $bb0c7ad61f4c3610$export$5392037c0e6ad119 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1jjx _11a41jjx _dntb16l4 _cp4g16l4 _5xmd1jjx _11sm16l4",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$export$5445f55445c67248 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            !__cmplp.isSelected && "_193g1rwo _11a41rwo _dntb1gfe _cp4g1gfe _5xmd14kv _11sm1gfe",
            __cmplp.className
        ])
    });
});
const $bb0c7ad61f4c3610$export$e6559310cd173125 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $bb0c7ad61f4c3610$export$5392037c0e6ad119, $bb0c7ad61f4c3610$export$5445f55445c67248);

});


parcelRegister("1khYv", function(module, exports) {

$parcel$export(module.exports, "Transition", () => $548d8ec8e7bf977f$export$be58926105124dd4);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $6tRzQ = parcelRequire("6tRzQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $5f2o3 = parcelRequire("5f2o3");

var $cPJPi = parcelRequire("cPJPi");
const $548d8ec8e7bf977f$export$be58926105124dd4 = ({ hasLabel: hasLabel, transition: transition, addTransitionArrowSpacing: addTransitionArrowSpacing, contentAfter: contentAfter, testId: testId })=>{
    if (transition.isDisabled === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($548d8ec8e7bf977f$var$DisabledTransition, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPJPi.TransitionWithoutLabel), {
        transition: transition,
        isDisabled: true
    }), transition.unavailableReasonText != null && transition.unavailableReasonText !== '' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: transition.unavailableReasonText
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($548d8ec8e7bf977f$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        label: "",
        color: "var(--ds-text-disabled, #091E424F)",
        spacing: "spacious",
        testId: "issue-field-status.ui.status-view.transition.information-icon"
    }))));
    const transitionComponent = hasLabel ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5f2o3.TransitionWithLabel), {
        transition: transition,
        addTransitionArrowSpacing: addTransitionArrowSpacing
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cPJPi.TransitionWithoutLabel), {
        transition: transition
    });
    return contentAfter ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1yb4 _wjvokb7n"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $548d8ec8e7bf977f$var$transitionComponentStyles
    }, transitionComponent), contentAfter) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId
    }, transitionComponent);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $548d8ec8e7bf977f$var$DisabledTransition = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _1bah1yb4",
            __cmplp.className
        ])
    });
});
const $548d8ec8e7bf977f$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reoewfl _18m9ewfl _4t3io7ao _19pkr5cr",
            __cmplp.className
        ])
    });
});
const $548d8ec8e7bf977f$export$7ed12d2a5241e393 = {
    IconWrapper: $548d8ec8e7bf977f$var$IconWrapper
};
const $548d8ec8e7bf977f$var$transitionWrapperStyles = null;
const $548d8ec8e7bf977f$var$transitionComponentStyles = (0, $8CUq3.xcss)({
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("5f2o3", function(module, exports) {

$parcel$export(module.exports, "TransitionWithLabel", () => $ce0d296e0359021c$export$20d2722b94f01359);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGdV2 = parcelRequire("eGdV2");

var $bUmQV = parcelRequire("bUmQV");

var $aWse0 = parcelRequire("aWse0");

var $dCm1o = parcelRequire("dCm1o");

var $17mYr = parcelRequire("17mYr");

var $cnQeu = parcelRequire("cnQeu");
const $ce0d296e0359021c$var$getLabel = (transition, intl)=>{
    if (transition.isGlobal) {
        if (transition.name !== transition.to.name) return transition.name;
        return intl.formatMessage((0, $cnQeu.default).globalTransition);
    }
    return transition.name;
};
const $ce0d296e0359021c$export$20d2722b94f01359 = (props)=>{
    const intl = (0, $aWse0.useIntlV2)();
    const content = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$export$147422f7450ccfac, null, $ce0d296e0359021c$var$getLabel(props.transition, intl)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$export$da4545fe0ca096cf, {
        visualRefresh: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$var$VerticalCenter, {
        addTransitionArrowSpacing: props.addTransitionArrowSpacing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eGdV2))), {
        label: "",
        LEGACY_size: "small",
        testId: "issue-field-status.ui.status-view.transition.with-label.arrow-right"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    })));
    if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        gap: "space.100"
    }, content);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce0d296e0359021c$var$Wrapper, null, content);
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce0d296e0359021c$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $ce0d296e0359021c$export$147422f7450ccfac = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n",
            __cmplp.className
        ])
    });
});
const $ce0d296e0359021c$export$da4545fe0ca096cf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { visualRefresh: visualRefresh, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _1e0c1txw",
            __cmplp.visualRefresh && "_zulpu2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $ce0d296e0359021c$var$VerticalCenter = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { addTransitionArrowSpacing: addTransitionArrowSpacing, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o",
            __cmplp.addTransitionArrowSpacing ? "_18s8s8vo" : "_19pk1kw7 _2hwx1kw7 _otyr1kw7 _18u01kw7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eGdV2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::101a51255f7076752a2af1f3fc652adc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aaffc8f190d8dd35$var$_react = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $aaffc8f190d8dd35$var$_arrowRight = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("h1TKi")));

var $aaffc8f190d8dd35$var$_arrowRight2 = $aaffc8f190d8dd35$var$_interopRequireDefault((parcelRequire("8RBk4")));
function $aaffc8f190d8dd35$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ArrowRightIcon.
 * This component is ArrowRightIcon, with `UNSAFE_fallbackIcon` set to "ArrowRightIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $aaffc8f190d8dd35$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $aaffc8f190d8dd35$var$_react.default.createElement($aaffc8f190d8dd35$var$_arrowRight.default, Object.assign({
        LEGACY_fallbackIcon: $aaffc8f190d8dd35$var$_arrowRight2.default
    }, props));
$aaffc8f190d8dd35$var$ArrowRightIcon.Name = 'ArrowRightIconMigration';
var $aaffc8f190d8dd35$var$_default = module.exports.default = $aaffc8f190d8dd35$var$ArrowRightIcon;

});
parcelRegister("h1TKi", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::11b8e18b02050eefbe32dafc654ee453>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c65dc59efb96b35a$var$_react = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c65dc59efb96b35a$var$_baseNew = $c65dc59efb96b35a$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $c65dc59efb96b35a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ArrowRight".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: link to nested menu item, a linked menu item, next slide.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c65dc59efb96b35a$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $c65dc59efb96b35a$var$_react.default.createElement($c65dc59efb96b35a$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12.44 7.25 8.72 3.53l1.06-1.06 5 5a.75.75 0 0 1 0 1.06l-5 5-1.06-1.06 3.72-3.72H1v-1.5z" clip-rule="evenodd"/>`
    }, props));
$c65dc59efb96b35a$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $c65dc59efb96b35a$var$_default = module.exports.default = $c65dc59efb96b35a$var$ArrowRightIcon;

});

parcelRegister("8RBk4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $6740397d4ba98b13$var$_react = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $6740397d4ba98b13$var$_arrowRight = $6740397d4ba98b13$var$_interopRequireDefault((parcelRequire("h1TKi")));
function $6740397d4ba98b13$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $6740397d4ba98b13$var$ArrowRightIcon = (props)=>/*#__PURE__*/ $6740397d4ba98b13$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M11.793 5.793a1 1 0 0 0 0 1.414L15.586 11H6a1 1 0 0 0 0 2h9.586l-3.793 3.793a1 1 0 0 0 0 1.414c.39.39 1.024.39 1.415 0l5.499-5.5a1 1 0 0 0 .293-.679v-.057a1 1 0 0 0-.293-.678l-5.499-5.5a1 1 0 0 0-1.415 0"/></svg>`
    }, props, {
        newIcon: $6740397d4ba98b13$var$_arrowRight.default
    }));
$6740397d4ba98b13$var$ArrowRightIcon.displayName = 'ArrowRightIcon';
var $6740397d4ba98b13$var$_default = module.exports.default = $6740397d4ba98b13$var$ArrowRightIcon;

});


parcelRegister("cnQeu", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1c9e2137350f319$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a1c9e2137350f319$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    globalTransition: {
        "id": "issue-field-status.status-view.transition.with-label.global-transition",
        "defaultMessage": "Transition to"
    }
});

});


parcelRegister("cPJPi", function(module, exports) {

$parcel$export(module.exports, "TransitionWithoutLabel", () => $35e7b9f215fedcad$export$4cf2c7e5a408120e);

var $5uXOq = parcelRequire("5uXOq");

var $17mYr = parcelRequire("17mYr");
const $35e7b9f215fedcad$export$4cf2c7e5a408120e = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $17mYr.StatusLozenge), {
        status: props.transition.to,
        isDisabled: props.isDisabled
    });

});


parcelRegister("hOOVM", function(module, exports) {

$parcel$export(module.exports, "OptionWithInlineConfigButtons", () => $9d20033b25473294$export$eac5bb25b4a7c273);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4Gswu = parcelRequire("4Gswu");

var $85H79 = parcelRequire("85H79");

var $gULOk = parcelRequire("gULOk");

var $2KAtx = parcelRequire("2KAtx");

var $i7SlO = parcelRequire("i7SlO");


var $eSc2f = parcelRequire("eSc2f");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $5BSCo = parcelRequire("5BSCo");

var $4zzYB = parcelRequire("4zzYB");
const $9d20033b25473294$export$33a04d713b28e79b = ({ children: children, queryParams: queryParams })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { status: status, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames, source: source, onClose: onClose, onStatusUpdated: onStatusUpdated } = queryParams;
    const onCloseEditModal = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'inlineEditStatusModal',
            action: 'closed'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            onClose: onCloseEditModal,
            status: {
                id: status.id,
                statusName: status.statusName,
                statusCategory: status.statusCategory
            },
            issueTypeId: issueTypeId,
            projectId: projectId,
            projectKey: projectKey,
            editStatusExperience: $5BSCo.editStatusExperience,
            statusNames: statusNames,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated
        }), [
        onCloseEditModal,
        status.id,
        status.statusName,
        status.statusCategory,
        issueTypeId,
        projectId,
        projectKey,
        statusNames,
        source,
        onStatusUpdated
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            role: "button",
            xcss: $9d20033b25473294$var$inlineButtonStyles,
            ref: ref,
            "aria-label": formatMessage((0, $4zzYB.messages).statusNameButtonLabel, {
                statusName: status.statusName
            }),
            testId: "issue-field-status.ui.status-view.configure-status.edit-status-button"
        }, children));
};
const $9d20033b25473294$export$eac5bb25b4a7c273 = ({ children: children, projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames, showEditButton: showEditButton, menuListRef: menuListRef, source: source, onOpenEditModal: onOpenEditModal, onCloseEditModal: onCloseEditModal, onStatusUpdated: onStatusUpdated, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const selectOption = props.data;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Gswu.OptionWithAutoKeyboardScroll), {
        ...props,
        containerRef: menuListRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $85H79.InlineConfigButtons), {
        editActionSubjectId: "editStatusButton",
        editLabelText: formatMessage((0, $4zzYB.messages).editStatusTooltip),
        isFocused: props.isFocused,
        showEditButton: Boolean(selectOption.transition && showEditButton),
        shouldStopPropagationOnClick: true,
        queryParams: {
            status: {
                id: selectOption.transition?.to?.id ?? '',
                statusName: selectOption.transition?.to?.name ?? '',
                statusCategory: (0, $gULOk.statusCategoryForId)(selectOption.transition?.to?.statusCategory?.id) ?? ''
            },
            projectId: projectId,
            projectKey: projectKey,
            issueTypeId: issueTypeId,
            statusNames: statusNames,
            source: source,
            onClose: onCloseEditModal,
            onStatusUpdated: onStatusUpdated
        },
        EditButtonWrapper: $9d20033b25473294$export$33a04d713b28e79b,
        onEditButtonClick: ()=>{
            onOpenEditModal();
        }
    }, children));
};
const $9d20033b25473294$var$inlineButtonStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.negative.025'
});

});
parcelRegister("85H79", function(module, exports) {

$parcel$export(module.exports, "InlineConfigButtons", () => $fbf710a2c1daee3e$export$8b527b0415fd6611);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $4IrpZ = parcelRequire("4IrpZ");

var $5nRKm = parcelRequire("5nRKm");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hnvSc = parcelRequire("hnvSc");
const $fbf710a2c1daee3e$export$8b527b0415fd6611 = ({ children: children, source: source, editActionSubjectId: editActionSubjectId, deleteActionSubjectId: deleteActionSubjectId, showEditButton: showEditButton, showDeleteButton: showDeleteButton, isFocused: isFocused, EditButtonWrapper: EditButtonWrapper, DeleteButtonWrapper: DeleteButtonWrapper, queryParams: queryParams, editLabelText: editLabelText, deleteLabelText: deleteLabelText, onEditButtonClick: onEditButtonClick, onDeleteButtonClick: onDeleteButtonClick, shouldStopPropagationOnClick: shouldStopPropagationOnClick = false, buttonRef: buttonRef = null })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onFireRequiredAnalyticsForEditButtonClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), editActionSubjectId ?? '', {
            source: source
        });
    };
    const onFireRequiredAnalyticsForDeleteButtonClick = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), deleteActionSubjectId ?? '', {
            source: source
        });
    };
    const handleOnEditButtonMouseDown = (e)=>{
        // fire event on left click only
        if (e.button === 0) onFireRequiredAnalyticsForEditButtonClick();
    };
    const handleOnDeleteButtonMouseDown = (e)=>{
        // fire event on left click only
        if (e.button === 0) onFireRequiredAnalyticsForDeleteButtonClick();
    };
    const handleOnEditButtonKeyDown = (e)=>{
        if (e.code === 'Enter' || e.code === 'Space') {
            // Always stop propagation when cleaning up inline_config_a11y_improvements
            shouldStopPropagationOnClick && e.stopPropagation();
            // Remove this line when cleaning up inline_config_a11y_improvements
            buttonRef?.current?.click();
            onFireRequiredAnalyticsForEditButtonClick();
        }
    };
    const handleOnDeleteButtonKeyDown = (e)=>{
        if (e.code === 'Enter' || e.code === 'Space') {
            shouldStopPropagationOnClick && e.stopPropagation();
            onFireRequiredAnalyticsForDeleteButtonClick();
        }
    };
    const handleOnEditButtonClick = (e)=>{
        shouldStopPropagationOnClick && e.stopPropagation();
        onEditButtonClick?.(e);
    };
    const handleOnDeleteButtonClick = (e)=>{
        shouldStopPropagationOnClick && e.stopPropagation();
        onDeleteButtonClick?.(e);
    };
    const renderEditButton = ()=>{
        const iconButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            tabIndex: isFocused ? 0 : -1,
            isDisabled: !isFocused,
            appearance: "subtle",
            onClick: handleOnEditButtonClick,
            // onClick is not working well with Select component and ModalEntryPointPressableTrigger
            // Therefore, we need to handle event analytics using mouseDown, touchEnd and keyDown
            onMouseDown: handleOnEditButtonMouseDown,
            onTouchEnd: onFireRequiredAnalyticsForEditButtonClick,
            onKeyDown: handleOnEditButtonKeyDown,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($5nRKm))),
            label: editLabelText ?? formatMessage((0, $hnvSc.default).editButtonText),
            spacing: "compact"
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $fbf710a2c1daee3e$var$additionalMarginStyles
        }, iconButton);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "row",
        columnGap: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $fbf710a2c1daee3e$var$leftColumnStyle
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: isFocused ? $fbf710a2c1daee3e$var$rightColumnStyleVisible : $fbf710a2c1daee3e$var$rightColumnStyleHidden
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        direction: "row",
        columnGap: "space.050"
    }, showEditButton && EditButtonWrapper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(EditButtonWrapper, {
        queryParams: queryParams
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: editLabelText ?? formatMessage((0, $hnvSc.default).editButtonText)
    }, renderEditButton())), showDeleteButton && DeleteButtonWrapper && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DeleteButtonWrapper, {
        queryParams: queryParams
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: deleteLabelText ?? formatMessage((0, $hnvSc.default).deleteButtonText)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isDisabled: !isFocused,
        tabIndex: isFocused ? 0 : -1,
        appearance: "subtle",
        onClick: handleOnDeleteButtonClick,
        // onClick is not working well with Select component and ModalEntryPointPressableTrigger
        // Therefore, we need to handle event analytics using mouseDown, touchEnd and keyDown
        onMouseDown: handleOnDeleteButtonMouseDown,
        onTouchEnd: onFireRequiredAnalyticsForDeleteButtonClick,
        onKeyDown: handleOnDeleteButtonKeyDown,
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($4IrpZ))),
        label: deleteLabelText ?? formatMessage((0, $hnvSc.default).deleteButtonText)
    }))))));
};
const $fbf710a2c1daee3e$var$leftColumnStyle = (0, $8CUq3.xcss)({
    wordBreak: 'break-word',
    flex: 1,
    alignItems: 'center'
});
const $fbf710a2c1daee3e$var$rightColumnStyleVisible = (0, $8CUq3.xcss)({
    width: 'auto',
    height: 'auto'
});
const $fbf710a2c1daee3e$var$rightColumnStyleHidden = (0, $8CUq3.xcss)({
    width: 'auto',
    height: 'auto',
    opacity: 0
});
const $fbf710a2c1daee3e$var$additionalMarginStyles = (0, $8CUq3.xcss)({
    margin: 'space.050'
});

});
parcelRegister("hnvSc", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ce9f37a75c1baa$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $35ce9f37a75c1baa$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editButtonText: {
        "id": "inline-status-and-issue-types.inline-config-buttons-for-select.edit-button-text",
        "defaultMessage": "Edit"
    },
    deleteButtonText: {
        "id": "inline-status-and-issue-types.inline-config-buttons-for-select.delete-button-text",
        "defaultMessage": "Delete"
    }
});

});



parcelRegister("02biC", function(module, exports) {

$parcel$export(module.exports, "CreateStatusOption", () => $bf8aca9d99b3cd67$export$be2add8d223902cf);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gKECL = parcelRequire("gKECL");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");

var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $67hPg = parcelRequire("67hPg");
var $8VEBs = parcelRequire("8VEBs");


var $koeKL = parcelRequire("koeKL");

var $5BSCo = parcelRequire("5BSCo");

var $5XThk = parcelRequire("5XThk");

var $lr99B = parcelRequire("lr99B");

var $4zzYB = parcelRequire("4zzYB");
const $bf8aca9d99b3cd67$export$be2add8d223902cf = ({ projectId: projectId, projectKey: projectKey, projectType: projectType, issueTypeId: issueTypeId, statusNames: statusNames = [], onClick: onClick, onClose: onClose, onStatusCreated: onStatusCreated, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const trigger = (0, $8VEBs.useTriggerContext)((0, $lr99B.ConfigureStatusPanel));
    const handleClick = (0, $5uXOq.useCallback)((_e)=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'createStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineCreateStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'createStatusButton');
    }, [
        createAnalyticsEvent
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            projectKey: projectKey
        }), [
        cloudId,
        projectKey
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            projectType: projectType,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            workflowAssociatedIssueTypeId: issueTypeId,
            createStatusExperience: $5BSCo.createStatusExperience,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusCreated: onStatusCreated,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        projectType,
        onModalClose,
        issueTypeId,
        source,
        onStatusCreated,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $5uXOq.useCallback)((ref)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            role: "button",
            xcss: $bf8aca9d99b3cd67$var$optionStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $4zzYB.messages).createStatus)), [
        formatMessage,
        handleClick,
        onMouseDown
    ]);
    return shouldTriggerModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $gKECL.asyncInlineCreateStatusModal),
        entryPointProps: entryPointProps,
        entryPointParams: entryPointParams,
        interactionName: "create-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $gKECL.asyncInlineCreateStatusModal),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XThk.CreateOrEditStatusSkeleton), {
            numFormFields: 2
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $bf8aca9d99b3cd67$var$optionStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});

parcelRegister("4hdrg", function(module, exports) {

$parcel$export(module.exports, "EditStatusOption", () => $012e5cd697234d7f$export$9550e3e17c5a4a3a);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $i7SlO = parcelRequire("i7SlO");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");

var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $67hPg = parcelRequire("67hPg");
var $8VEBs = parcelRequire("8VEBs");


var $5BSCo = parcelRequire("5BSCo");

var $5XThk = parcelRequire("5XThk");

var $lr99B = parcelRequire("lr99B");

var $4zzYB = parcelRequire("4zzYB");
const $012e5cd697234d7f$export$9550e3e17c5a4a3a = ({ projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], status: status, statuses: statuses, onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated = Promise.resolve, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const trigger = (0, $8VEBs.useTriggerContext)((0, $lr99B.ConfigureStatusPanel));
    const handleClick = (0, $5uXOq.useCallback)((_e)=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const onMouseDown = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'editStatusButton');
    }, [
        createAnalyticsEvent
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            status: status,
            statuses: statuses,
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            issueTypeId: issueTypeId,
            editStatusExperience: $5BSCo.editStatusExperience,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated,
            shouldShowStatusSelect: true,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        issueTypeId,
        source,
        status,
        statuses,
        onStatusUpdated,
        onModalClose,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $5uXOq.useCallback)((ref)=>// eslint-disable-next-line @atlassian/a11y/interactive-element-not-keyboard-focusable
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            role: "button",
            xcss: $012e5cd697234d7f$var$optionStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            ref: ref,
            onMouseDown: (event)=>{
                if (event.button === 0) // Left mouse button was clicked
                onMouseDown();
            }
        }, formatMessage((0, $4zzYB.messages).editStatus)), [
        handleClick,
        formatMessage,
        onMouseDown
    ]);
    return shouldTriggerModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XThk.CreateOrEditStatusSkeleton), {
            numFormFields: 3
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $012e5cd697234d7f$var$optionStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    fontWeight: 'font.weight.medium'
});

});

parcelRegister("5uNOo", function(module, exports) {

$parcel$export(module.exports, "EditStatusButton", () => $4d1ec0a4b4de57d9$export$bc1c056aa3d67f87);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $i7SlO = parcelRequire("i7SlO");

var $koVbs = parcelRequire("koVbs");

var $eSc2f = parcelRequire("eSc2f");


var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $67hPg = parcelRequire("67hPg");
var $8VEBs = parcelRequire("8VEBs");

var $5BSCo = parcelRequire("5BSCo");

var $5XThk = parcelRequire("5XThk");

var $4zzYB = parcelRequire("4zzYB");

var $lr99B = parcelRequire("lr99B");
const $4d1ec0a4b4de57d9$export$bc1c056aa3d67f87 = ({ projectId: projectId, projectKey: projectKey, issueTypeId: issueTypeId, statusNames: statusNames = [], status: status, statuses: statuses, onClick: onClick, onClose: onClose, onStatusUpdated: onStatusUpdated = Promise.resolve, buttonRef: buttonRef, source: source, shouldTriggerModal: shouldTriggerModal = true })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const trigger = (0, $8VEBs.useTriggerContext)((0, $lr99B.ConfigureStatusPanel));
    const handleClick = (0, $5uXOq.useCallback)((_e)=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'editStatusButton');
        // Because we are triggering the click manually for keyboard users
        // this handler becomes the source-of-truth handler for both keyboard users and mouse users
        // However, we need to stopPropagation from here to prevent double modal for mouse users
        // When mouse user clicks the button, if we don't stop propagation here, handleChange
        // will be called which will trigger click manually again and cause double modal rendering
        _e.stopPropagation();
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const onModalClose = (0, $5uXOq.useCallback)(()=>{
        onClose();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'closed',
            actionSubject: 'inlineEditStatusModal'
        }));
    }, [
        createAnalyticsEvent,
        onClose
    ]);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            status: status,
            statuses: statuses,
            statusNames: statusNames,
            projectId: projectId,
            projectKey: projectKey,
            onClose: onModalClose,
            isNewControllerEnabled: true,
            issueTypeId: issueTypeId,
            editStatusExperience: $5BSCo.editStatusExperience,
            source: source || (0, $77f8834f432b7338$export$cafb161c2b21b455),
            onStatusUpdated: onStatusUpdated,
            shouldShowStatusSelect: true,
            isWrappedInModal: shouldTriggerModal
        }), [
        statusNames,
        projectId,
        projectKey,
        issueTypeId,
        source,
        status,
        statuses,
        onStatusUpdated,
        onModalClose,
        shouldTriggerModal
    ]);
    const getClickElement = (0, $5uXOq.useCallback)((ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $4d1ec0a4b4de57d9$var$flexContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
            testId: "issue-field-status.ui.status-view.configure-status.edit-status-button",
            xcss: $4d1ec0a4b4de57d9$var$pressableStyles,
            onClick: handleClick,
            "data-show-on-hover": true,
            // ref returned from entrypoint is of Type 'RefObject<HTMLElement>' is not assignable to type 'Ref<HTMLButtonElement>
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4d1ec0a4b4de57d9$var$textWrapperStyle
        }, formatMessage((0, $4zzYB.messages).editStatus)))), [
        handleClick,
        formatMessage
    ]);
    return shouldTriggerModal ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        interactionName: "edit-status-modal",
        modalProps: (0, $eSc2f.defaultModalProps),
        useInternalModal: true,
        forwardedRef: buttonRef
    }, ({ ref: ref })=>getClickElement(ref)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $i7SlO.asyncInlineEditStatusModal),
        entryPointProps: entryPointProps,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5XThk.CreateOrEditStatusSkeleton), {
            numFormFields: 3
        })
    }, ({ ref: ref })=>getClickElement(ref));
};
const $4d1ec0a4b4de57d9$var$flexContainerStyles = (0, $8CUq3.xcss)({
    flexGrow: 1,
    height: "var(--ds-space-500, 40px)"
});
const $4d1ec0a4b4de57d9$var$pressableStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    color: 'color.text',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    backgroundColor: 'color.background.neutral.subtle',
    alignItems: 'center',
    textAlign: 'left',
    paddingInline: 'space.150',
    fontWeight: 'font.weight.medium',
    ':hover': {
        backgroundColor: 'color.background.neutral'
    },
    ':focus-visible': {
        borderRadius: 'border.radius'
    }
});
const $4d1ec0a4b4de57d9$var$textWrapperStyle = (0, $8CUq3.xcss)({
    marginInline: 'space.025'
});

});

parcelRegister("axCqr", function(module, exports) {

$parcel$export(module.exports, "ConfigureStatusPopup", () => $b33fc64067dec64f$export$35b5c681217bd086);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jgJNO = parcelRequire("jgJNO");
const $b33fc64067dec64f$export$35b5c681217bd086 = ({ renderTarget: renderTarget, isTargetEditable: isTargetEditable, placement: placement, onClose: onClose, renderPopupContent: renderPopupContent })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $b33fc64067dec64f$var$popupContentStyles,
                role: "dialog",
                "aria-modal": "false",
                "aria-labelledby": "configure-status-form-popup-header"
            }, renderPopupContent()),
        isOpen: true,
        onClose: onClose,
        placement: placement,
        messageId: "issue-field-status.ui.status-view.configure-status.popup",
        messageType: "transactional",
        trigger: (triggerProps)=>renderTarget({
                isEditable: isTargetEditable,
                isSaving: false,
                targetRef: undefined,
                triggerProps: triggerProps
            }),
        shouldRenderToParent: true
    });
};
const $b33fc64067dec64f$var$popupContentStyles = (0, $8CUq3.xcss)({
    width: '395px'
});

});


parcelRegister("an47R", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1031d96eb0ec849$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $egJPW = parcelRequire("egJPW");

var $FEqQ9 = parcelRequire("FEqQ9");

var $2Fn8l = parcelRequire("2Fn8l");

var $fs8Mw = parcelRequire("fs8Mw");
class $a1031d96eb0ec849$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    render() {
        const { baseUrl: baseUrl, issueKey: issueKey, isModalMounted: isModalMounted, onOpenModal: onOpenModal, workflowServiceApi: workflowServiceApi, onCloseModal: onCloseModal } = this.props;
        const { isWorkflowServiceRefetching: isWorkflowServiceRefetching } = this.state;
        const { data: data, loading: loading, error: error, fetch: fetch } = workflowServiceApi;
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egJPW.default), {
            onRetry: (e)=>{
                this.onWorkflowServiceRefetch(e, fetch);
            }
        });
        if (!data) return null;
        const { isSimplified: isSimplified, projectId: projectId, issueTypeId: issueTypeId, hasPermission: hasPermission } = data;
        if (!isSimplified && (0, $4R6GH.fg)('legacy_readonly_workflow_modal_optin')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $FEqQ9.default), {
            baseUrl: baseUrl,
            issueKey: issueKey,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching
        });
        if ((0, $4R6GH.fg)('cmp_support_for_readonly_workflow_modal')) {
            if (!projectId) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-field-status.view-workflow.no-project-id', 'WorkflowServiceApi finished loading but there was no projectId');
                return null;
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Fn8l.ViewWorkflowModalDropDownTrigger), {
                issueKey: issueKey,
                projectId: projectId,
                issueTypeId: issueTypeId,
                isSimplifiedProject: isSimplified,
                hasPermission: hasPermission,
                isServiceLoading: loading,
                isServiceRefetching: isWorkflowServiceRefetching,
                onClose: onCloseModal
            });
        }
        if (isSimplified === true) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fs8Mw.default), {
            projectId: projectId,
            issueTypeId: issueTypeId,
            isModalMounted: isModalMounted,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching,
            onOpenModal: onOpenModal
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $FEqQ9.default), {
            baseUrl: baseUrl,
            issueKey: issueKey,
            hasPermission: hasPermission,
            isServiceLoading: loading,
            isServiceRefetching: isWorkflowServiceRefetching
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isWorkflowServiceRefetching: false
        }, this.onWorkflowServiceRefetch = async (e, retry)=>{
            e.stopPropagation();
            this.setState({
                isWorkflowServiceRefetching: true
            });
            await retry();
            this.setState({
                isWorkflowServiceRefetching: false
            });
        };
    }
}

});
parcelRegister("egJPW", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcc9251c728cc690$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $jlBA8 = parcelRequire("jlBA8");
const $dcc9251c728cc690$export$edf27be85e5f6da0 = ({ onRetry: onRetry })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onRetryClick = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'retryViewWorkflowButton'); // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
        onRetry(e);
    }, [
        onRetry
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "viewWorkflowError",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcc9251c728cc690$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dcc9251c728cc690$var$errorMessageWrapperStyles
    }, formatMessage((0, $jlBA8.default).errorMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcc9251c728cc690$var$ButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: "link",
        spacing: "none",
        onClick: onRetryClick,
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center'
                }
            };
        },
        interactionName: "auto-generated.jira-issue-field-status.common.ui.view-workflow.error.button"
    }, formatMessage((0, $jlBA8.default).tryAgain))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)));
};
var $dcc9251c728cc690$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $dcc9251c728cc690$export$edf27be85e5f6da0;
const $dcc9251c728cc690$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3doudwz _4t3ickbl _1e0c1txw _4cvr1h6o _ca0qidpf _u5f3utpp _n3tdidpf _19bvutpp _1bah1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $dcc9251c728cc690$var$ButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $dcc9251c728cc690$var$errorMessageWrapperStyles = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});

});
parcelRegister("jlBA8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf306506fde1ae6b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cf306506fde1ae6b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "issue-field-status.common.view-workflow.error.error-message",
        "defaultMessage": "Couldn\u2019t find the workflow."
    },
    tryAgain: {
        "id": "issue-field-status.common.view-workflow.error.try-again",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("FEqQ9", function(module, exports) {

$parcel$export(module.exports, "default", () => $97c96869b4d190e3$export$2e2bcd8739ae039);
/* eslint-disable react-hooks/exhaustive-deps, jira/wrm/no-load-bridge */ 
var $5uXOq = parcelRequire("5uXOq");

var $6BZYo = parcelRequire("6BZYo");

var $c9CKH = parcelRequire("c9CKH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $4su49 = parcelRequire("4su49");

var $fg6rA = parcelRequire("fg6rA");

var $egJPW = parcelRequire("egJPW");

var $8QPwp = parcelRequire("8QPwp");

var $hjkQi = parcelRequire("hjkQi");

var $hmnrA = parcelRequire("hmnrA");
const $97c96869b4d190e3$export$b5e9eef0cad95164 = ({ isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, issueKey: issueKey, hasPermission: hasPermission, baseUrl: baseUrl, ClassicViewWorkflowService: ClassicViewWorkflowService = (0, $hjkQi.ClassicViewWorkflowServiceWithAnalytics) })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isModalMounted, setIsModalMounted] = (0, $5uXOq.useState)(false);
    const [isLoadingModal, setIsLoadingModal] = (0, $5uXOq.useState)(false);
    const [isRefetching, setIsRefetching] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const isModalMounting = isLoadingModal && !isModalMounted;
    const isDisabled = !hasPermission || isModalMounting;
    // we do not use || isClassicServiceLoading for isLoading because we do not want to show spinner while ClassicViewWorkflowService data loads
    const isLoading = isModalMounting || isServiceRefetching || isRefetching;
    let modalApi;
    (0, $5uXOq.useEffect)(()=>{
        const modalModuleName = 'workflow-designer/view-classic-project-workflow';
        // @ts-expect-error - TS2322 - Type 'Promise<unknown>' is not assignable to type 'Promise<ClassicProjectWorkflowModalApi>'.
        modalApi = (0, $6BZYo.loadBridge)({
            // checking if module was loaded on page load
            name: modalModuleName,
            tentatives: 0,
            shouldLogError: false
        }).catch(()=>{
            (0, $4su49.asyncWrmRequire)([
                // eslint-disable-next-line jira/wrm/no-wr-prefix
                'wr!com.atlassian.jira.plugins.jira-workflow-designer:view-issue-page-workflow-designer'
            ]); // wrmRequire() does not fire catch() event
            return (0, $6BZYo.loadBridge)({
                name: modalModuleName
            });
        });
    }, []);
    const onClick = (0, $5uXOq.useCallback)((analyticsEvent, pShowFlag, workflowName, currentStepId)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
            isSimplifiedProject: false
        });
        if (!modalApi || !workflowName || !currentStepId) return;
        // modal code is being loaded only once, therefore there is no need to reset this to false
        setIsLoadingModal(true);
        setIsRefetching(false);
        modalApi.then((api)=>{
            api.showDialog(workflowName, currentStepId);
            // since there is no way to close Ak dropdown programmatically, this is the only option
            // to avoid dropdown wrong position on View workflow modal opening in Bento modal (BENTO-4660)
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.dispatchEvent((0, $c9CKH.default)('resize'));
            // @ts-expect-error - TS2345 - Argument of type '{ isModalMounted: boolean; }' is not assignable to parameter of type 'SetStateAction<boolean>'.
            setIsModalMounted({
                isModalMounted: true
            });
        }).catch(()=>{
            pShowFlag && pShowFlag((0, $hmnrA.errors).loadModalError());
            setIsLoadingModal(false);
        });
    }, // @ts-expect-error - TS2454 - Variable 'modalApi' is used before being assigned.
    [
        modalApi,
        setIsModalMounted,
        setIsRefetching,
        setIsLoadingModal
    ]);
    const onRetry = (0, $5uXOq.useCallback)((event, retry)=>{
        event.stopPropagation();
        setIsRefetching(true);
        return retry().then(()=>setIsRefetching(false));
    }, [
        setIsRefetching
    ]);
    const onMount = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter 'analyticsEvent' implicitly has an 'any' type.
    (analyticsEvent)=>{
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
            hasViewWorkflowPermission: hasPermission,
            isSimplifiedProject: false
        });
    }, [
        hasPermission
    ]);
    const getTooltipMessage = (0, $5uXOq.useCallback)((isClassicServiceLoading)=>{
        if (isServiceRefetching || isClassicServiceLoading) return formatMessage((0, $8QPwp.default).loading);
        if (!hasPermission) return formatMessage((0, $8QPwp.default).noPermission);
        return '';
    }, [
        formatMessage,
        hasPermission,
        isServiceRefetching
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ClassicViewWorkflowService, {
        issueKey: issueKey,
        baseUrl: baseUrl,
        shouldLoadOnMount: hasPermission
    }, ({ data: data, error: error, loading: isClassicServiceLoading, retry: retry })=>{
        if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egJPW.default), {
            onRetry: (event)=>{
                onRetry(event, retry);
            }
        });
        const workflowName = data ? data.workflowName : null;
        const currentStepId = data ? data.currentStepId : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fg6rA.default), {
            onMount: onMount,
            tooltipContent: getTooltipMessage(isServiceLoading || isClassicServiceLoading),
            isDisabled: isDisabled || isClassicServiceLoading,
            isLoading: isLoading,
            isInitialLoading: isServiceLoading || isClassicServiceLoading,
            onClick: (_, analyticsEvent)=>onClick(analyticsEvent, showFlag, workflowName, currentStepId)
        });
    });
};
var $97c96869b4d190e3$export$2e2bcd8739ae039 = $97c96869b4d190e3$export$b5e9eef0cad95164;

});
parcelRegister("c9CKH", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb779c21ddd2b986$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/import/no-anonymous-default-export
var $cb779c21ddd2b986$export$2e2bcd8739ae039 = (eventType, eventConstructor = 'Event', bubbles = true, cancelable = true)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const event = document.createEvent(eventConstructor);
    event.initEvent(eventType, bubbles, cancelable);
    return event;
};

});

parcelRegister("fg6rA", function(module, exports) {

$parcel$export(module.exports, "ButtonWrapper", () => $677a05abc6bdd063$export$d53c836cccbb0d90);
$parcel$export(module.exports, "default", () => $677a05abc6bdd063$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $3bDjY = parcelRequire("3bDjY");

var $aWse0 = parcelRequire("aWse0");

var $isuse = parcelRequire("isuse");

var $iQO8Y = parcelRequire("iQO8Y");
const $677a05abc6bdd063$var$WithTooltip = ({ content: content, children: children })=>{
    if (content) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        tag: "span",
        content: content
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $677a05abc6bdd063$var$ViewWorkflowButton = ({ forwardRef: forwardRef, isDisabled: isDisabled, isLoading: isLoading, isInitialLoading: isInitialLoading, onClick: onClick, onMount: onMount, tooltipContent: tooltipContent })=>{
    const intl = (0, $aWse0.useIntlV2)();
    const isDisabledColor = isDisabled === true && !isInitialLoading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($677a05abc6bdd063$var$WrapperWithoutBorder, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: onMount
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($677a05abc6bdd063$var$WithTooltip, {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($677a05abc6bdd063$export$d53c836cccbb0d90, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        testId: "issue-field-status.common.ui.view-workflow.button.view-workflow",
        shouldFitContainer: true,
        appearance: "subtle",
        spacing: "none",
        isDisabled: isDisabled,
        isLoading: isLoading,
        onClick: onClick,
        theme: (currentTheme, theme)=>{
            const buttonTheme = currentTheme(theme);
            return {
                ...buttonTheme,
                buttonStyles: {
                    ...buttonTheme.buttonStyles,
                    alignItems: 'center',
                    textAlign: 'left',
                    color: isDisabledColor ? "var(--ds-text-disabled, #091E424F)" : "var(--ds-text, #172B4D)",
                    padding: `0 ${"var(--ds-space-150, 12px)"}`
                }
            };
        },
        interactionName: "auto-generated.issue-field-status.common.ui.view-workflow.button.view-workflow.button",
        ref: forwardRef
    }, intl.formatMessage((0, $iQO8Y.default).viewWorkflow)))));
};
var $677a05abc6bdd063$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
 = $677a05abc6bdd063$var$ViewWorkflowButton;
const $677a05abc6bdd063$var$WrapperWithoutBorder = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1jfw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $677a05abc6bdd063$export$d53c836cccbb0d90 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _16jlkb7n _4t3i1osq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iQO8Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $35c1321d84301d6b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $35c1321d84301d6b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewWorkflow: {
        "id": "issue-field-status.common.view-workflow.button.view-workflow",
        "defaultMessage": "View workflow"
    }
});

});


parcelRegister("8QPwp", function(module, exports) {

$parcel$export(module.exports, "default", () => $abf08e7db398f42f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $abf08e7db398f42f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noPermission: {
        "id": "issue-field-status.common.view-workflow.no-permission",
        "defaultMessage": "You don't have permission to view this workflow."
    },
    loading: {
        "id": "issue-field-status.common.view-workflow.loading",
        "defaultMessage": "Looks like your connection is slow. We\u2019re still finding this workflow."
    }
});

});

parcelRegister("hjkQi", function(module, exports) {

$parcel$export(module.exports, "ClassicViewWorkflowServiceWithAnalytics", () => $70f45b887ec8707a$export$1a80ddaaeea6341b);

var $5uXOq = parcelRequire("5uXOq");

var $cb25w = parcelRequire("cb25w");

var $2YZCu = parcelRequire("2YZCu");

var $8zOmE = parcelRequire("8zOmE");

var $3cBFD = parcelRequire("3cBFD");
// eslint-disable-next-line jira/react/no-class-components
class $70f45b887ec8707a$var$ClassicViewWorkflowService extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            shouldLoadOnMount: true
        };
    }
    componentDidMount() {
        if (this.props.shouldLoadOnMount === true) this.load();
    }
    onLoading() {
        this.setState({
            data: undefined,
            error: undefined,
            loading: true
        });
    }
    onLoadSucceeded(data) {
        this.setState({
            data: data,
            error: undefined,
            loading: false
        });
    }
    onLoadFailed(error) {
        this.setState({
            data: undefined,
            error: error,
            loading: false
        });
    }
    fireAnalytics() {
        const analyticsEvent = this.props.createAnalyticsEvent({
            action: 'requested'
        });
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'classicViewWorkflowData requested');
    }
    render() {
        return this.props.children({
            ...this.state,
            retry: this.load
        });
    }
    constructor(...args){
        super(...args), this.state = {
            data: undefined,
            error: undefined,
            loading: false
        }, this.load = async ()=>{
            this.onLoading();
            const { baseUrl: baseUrl, issueKey: issueKey } = this.props;
            try {
                this.fireAnalytics();
                const data = await (0, $3cBFD.getViewWorkflowData)(baseUrl, issueKey);
                this.onLoadSucceeded(data);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-field.status.classic-view-workflow-service.fetch', 'Failed to fetch classic view workflow data.', {
                    errorReason: error.message && error.message === 'TransformError' ? 'transform' : 'fetch'
                });
                this.onLoadFailed(error);
            }
        };
    }
}
const $70f45b887ec8707a$export$1a80ddaaeea6341b = (0, $cb25w.default)()(// @ts-expect-error - TS2345 - Argument of type 'typeof ClassicViewWorkflowService' is not assignable to parameter of type '(((props: WithAnalyticsEventsProps) => ReactElement<any, string | ((props: any) => ReactElement<any, any> | null) | (new (props: any) => Component<any, any, any>)> | null) & typeof ClassicViewWorkflowService) | ((new (props: WithAnalyticsEventsProps) => Component<...>) & typeof ClassicViewWorkflowService)'.
$70f45b887ec8707a$var$ClassicViewWorkflowService);

});
parcelRegister("3cBFD", function(module, exports) {

$parcel$export(module.exports, "getViewWorkflowData", () => $5ed8320c2b2d6086$export$fa1a6ac9833b0597);

var $eusud = parcelRequire("eusud");
const $5ed8320c2b2d6086$var$query = `
query classicViewWorkflowQuery($issueKey: String!) {
    viewIssue(issueKey: $issueKey) {
        workflow {
            name
            step {
                id
            }
        }
    }
}
`;
const $5ed8320c2b2d6086$export$3361e9be8093ddcc = (response)=>{
    if (response.data && response.data.viewIssue && response.data.viewIssue.workflow) return {
        workflowName: response.data.viewIssue.workflow.name,
        currentStepId: response.data.viewIssue.workflow.step.id
    };
    throw new Error('TransformError');
};
const $5ed8320c2b2d6086$export$fa1a6ac9833b0597 = (_baseUrl, issueKey)=>(0, $eusud.performPostRequest)('/rest/gira/1/', {
        body: JSON.stringify({
            query: $5ed8320c2b2d6086$var$query,
            variables: {
                issueKey: issueKey
            }
        })
    }).then($5ed8320c2b2d6086$export$3361e9be8093ddcc);

});


parcelRegister("hmnrA", function(module, exports) {

$parcel$export(module.exports, "errors", () => $48a9f2e4a5356e03$export$30f3b02011db23c0);

var $01p0t = parcelRequire("01p0t");
const $48a9f2e4a5356e03$export$30f3b02011db23c0 = {
    loadModalError: $01p0t.loadModalError
};

});
parcelRegister("01p0t", function(module, exports) {

$parcel$export(module.exports, "loadModalError", () => $5eb36f16aa3374eb$export$51c6a1172e47844f);

var $7VHMR = parcelRequire("7VHMR");
const $5eb36f16aa3374eb$var$messages = (0, $7VHMR.defineMessages)({
    title: {
        "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.title",
        "defaultMessage": "We couldn't load the workflow"
    },
    description: {
        "id": "issue-field-status.view-workflow.classic.flags.errors.load-modal-error.description",
        "defaultMessage": "Check your connection, then try reloading the page."
    }
});
const $5eb36f16aa3374eb$export$51c6a1172e47844f = ()=>({
        type: 'error',
        title: $5eb36f16aa3374eb$var$messages.title,
        description: $5eb36f16aa3374eb$var$messages.description,
        messageId: 'issue-field-status.ui.view-workflow.classic.flags.errors.load-modal-error.flag.error',
        messageType: 'transactional'
    });

});



parcelRegister("2Fn8l", function(module, exports) {

$parcel$export(module.exports, "ViewWorkflowModalDropDownTrigger", () => $5a46620a956691e0$export$1c337688ee874e1d);

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $2KAtx = parcelRequire("2KAtx");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lDsR4 = parcelRequire("lDsR4");

var $fg6rA = parcelRequire("fg6rA");

var $8QPwp = parcelRequire("8QPwp");
const $5a46620a956691e0$export$1c337688ee874e1d = ({ hasPermission: hasPermission, isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, ...selfProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSimplifiedProject = selfProps.isSimplifiedProject;
    const onMount = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'viewWorkflowTrigger mounted', {
            hasViewWorkflowPermission: hasPermission,
            isSimplifiedProject: isSimplifiedProject
        });
    }, [
        createAnalyticsEvent,
        hasPermission,
        isSimplifiedProject
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'viewWorkflowTrigger',
            action: 'clicked'
        }), {
            isSimplifiedProject: isSimplifiedProject
        });
    }, [
        createAnalyticsEvent,
        isSimplifiedProject
    ]);
    const { tooltip: tooltip, isDisabled: isDisabled, isLoading: isLoading } = (0, $5uXOq.useMemo)(()=>{
        if (isServiceLoading || isServiceRefetching) return {
            tooltip: formatMessage((0, $8QPwp.default).loading),
            isDisabled: true,
            isLoading: isServiceRefetching
        };
        if (hasPermission !== true) return {
            tooltip: formatMessage((0, $8QPwp.default).noPermission),
            isDisabled: true,
            isLoading: false
        };
        // Empty tooltip means no tooltip
        return {
            tooltip: '',
            isDisabled: false
        };
    }, [
        isServiceLoading,
        isServiceRefetching,
        hasPermission,
        formatMessage
    ]);
    const modalProps = (0, $5uXOq.useMemo)(()=>{
        return {
            autoFocus: false,
            width: '100%',
            testId: 'issue-field-status.ui.view-workflow.read-view-modal'
        };
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2KAtx.ModalEntryPointPressableTrigger), {
        entryPoint: (0, $lDsR4.entryPoint),
        entryPointProps: selfProps,
        interactionName: "open-read-view-workflow-modal",
        modalProps: modalProps,
        useInternalModal: true
    }, ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fg6rA.default), {
            forwardRef: ref,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isInitialLoading: !!isServiceLoading,
            onMount: onMount,
            onClick: onClick,
            tooltipContent: tooltip
        }));
};

});
parcelRegister("lDsR4", function(module, exports) {

$parcel$export(module.exports, "entryPoint", () => $3b8f29a56db722f3$export$6333901e831d7af0);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $3b8f29a56db722f3$export$6333901e831d7af0 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("i4w9O")), {
        moduleId: "16c65716"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("i4w9O", function(module, exports) {

let $d2818b7fbd3c9ffe$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d2818b7fbd3c9ffe$var$load("ffQaD"),
    $d2818b7fbd3c9ffe$var$load("kvRbA"),
    $d2818b7fbd3c9ffe$var$load("4JkjK")
]).then(()=>parcelRequire('jhZ7l'));

});



parcelRegister("fs8Mw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3ac5fbf25b060715$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $g5X3G = parcelRequire("g5X3G");

var $fg6rA = parcelRequire("fg6rA");

var $8QPwp = parcelRequire("8QPwp");
// eslint-disable-next-line jira/react/no-class-components
class $3ac5fbf25b060715$var$ViewWorkflowSimplified extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            hasPermission: false
        };
    }
    getTooltipMessage() {
        const { isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, hasPermission: hasPermission, intl: intl } = this.props;
        if (isServiceLoading || isServiceRefetching) return intl.formatMessage((0, $8QPwp.default).loading);
        if (hasPermission !== true) return intl.formatMessage((0, $8QPwp.default).noPermission);
        return '';
    }
    render() {
        const { isServiceLoading: isServiceLoading, isServiceRefetching: isServiceRefetching, hasPermission: hasPermission, isModalMounted: isModalMounted } = this.props;
        const { isLoadingModal: isLoadingModal } = this.state;
        const isModalMounting = isLoadingModal && !isModalMounted;
        const isDisabled = hasPermission !== true || isModalMounting;
        const isLoading = isServiceRefetching || isModalMounting;
        const tooltipContent = this.getTooltipMessage();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fg6rA.default), {
            onMount: this.onMount,
            tooltipContent: tooltipContent,
            isDisabled: isDisabled,
            isLoading: isLoading,
            isInitialLoading: isServiceLoading,
            onClick: this.onClick
        });
    }
    constructor(...args){
        super(...args), this.state = {
            isLoadingModal: false
        }, this.onMount = (analyticsEvent)=>{
            const { hasPermission: hasPermission } = this.props;
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'viewWorkflowTrigger mounted', {
                hasViewWorkflowPermission: hasPermission,
                isSimplifiedProject: true
            });
        }, this.onClick = (event, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'viewWorkflowTrigger', {
                isSimplifiedProject: true
            });
            this.setState({
                // modal code is being loaded only once, therefore there is no need to reset this to false
                isLoadingModal: true
            });
            const { issueTypeId: issueTypeId = (0, $g5X3G.toIssueTypeId)(''), projectId: projectId = (0, $g5X3G.toProjectId)(''), onOpenModal: onOpenModal } = this.props;
            onOpenModal(issueTypeId, projectId);
        };
    }
}
var $3ac5fbf25b060715$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($3ac5fbf25b060715$var$ViewWorkflowSimplified);

});


parcelRegister("2brZf", function(module, exports) {

$parcel$export(module.exports, "default", () => $de90987dda80794f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l0sjw = parcelRequire("l0sjw");

var $hgJxR = parcelRequire("hgJxR");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");

const $de90987dda80794f$export$de1fcbea0facb135 = (0, $kxZPA.lazy)(()=>(parcelRequire("7vLAh")), {
    moduleId: "./src/packages/issue/workflow-readonly-modal/src/index.tsx"
});
class $de90987dda80794f$export$3d7b4a64bc1f330f extends (0, $5uXOq.Component) {
    static getDerivedStateFromProps(props, state) {
        return {
            shouldMountWorkflow: state.shouldMountWorkflow || props.isOpen
        };
    }
    render() {
        const { issueKey: issueKey, issueTypeId: issueTypeId, baseUrl: baseUrl, locale: locale, cloudId: cloudId, projectId: projectId, isOpen: isOpen, onModalMounted: onModalMounted, onClose: onClose, scope: scope } = this.props;
        const { shouldMountWorkflow: shouldMountWorkflow } = this.state;
        return shouldMountWorkflow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hgJxR.WorkflowReadonlyModalBoundary), {
            packageName: "issue"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l0sjw.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
            until: isOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de90987dda80794f$export$de1fcbea0facb135, {
            onMounted: onModalMounted,
            issueKey: issueKey,
            issueTypeId: issueTypeId,
            baseUrl: baseUrl,
            locale: locale,
            isOpen: isOpen,
            cloudId: cloudId,
            projectId: projectId,
            onClose: onClose,
            scope: scope
        }))));
    }
    constructor(...args){
        super(...args), this.state = {
            shouldMountWorkflow: false
        };
    }
}
var $de90987dda80794f$export$2e2bcd8739ae039 = $de90987dda80794f$export$3d7b4a64bc1f330f;

});
parcelRegister("l0sjw", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f5b4df3c1787ede$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4eKbI = parcelRequire("4eKbI");

var $cEm1b = parcelRequire("cEm1b");
function $3f5b4df3c1787ede$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentProfilerContext = (0, $5uXOq.useContext)((0, $cEm1b.ProfilerContext));
    const ignoredRLLProfilerContext = (0, $5uXOq.useMemo)(()=>({
            ...parentProfilerContext,
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackMounted () {},
            // Replace with lodash/noop
            // eslint-disable-next-line @typescript-eslint/no-empty-function
            placeholderFallBackUnmounted () {}
        }), [
        parentProfilerContext
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignore) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, kids);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4eKbI.default), {
        ignore: ignore
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cEm1b.ProfilerContext).Provider, {
        value: ignoredRLLProfilerContext
    }, kids));
}

});
parcelRegister("4eKbI", function(module, exports) {

$parcel$export(module.exports, "default", () => $fd3e682addb0cb4a$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6wxJn = parcelRequire("6wxJn");
function $fd3e682addb0cb4a$export$2e2bcd8739ae039({ children: children, ignore: ignore = true }) {
    const parentContext = (0, $5uXOq.useContext)((0, $6wxJn.default));
    const ignoredInteractionContext = (0, $5uXOq.useMemo)(()=>{
        if (!parentContext) return null;
        return {
            ...parentContext,
            hold (...args) {
                if (!ignore) return parentContext.hold(...args);
            }
        };
    }, [
        parentContext,
        ignore
    ]);
    // react-18: Use children directly
    const kids = children != null ? children : null;
    if (!ignoredInteractionContext) return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2OMIu.Fragment), {
        children: kids
    });
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6wxJn.default).Provider, {
        value: ignoredInteractionContext,
        children: kids
    });
}

});


parcelRegister("hgJxR", function(module, exports) {

$parcel$export(module.exports, "WorkflowReadonlyModalBoundary", () => $d71a221e31d14d82$export$62f00f305552896d);

var $5uXOq = parcelRequire("5uXOq");

var $gjEtj = parcelRequire("gjEtj");

var $lzG9C = parcelRequire("lzG9C");
const $d71a221e31d14d82$export$62f00f305552896d = ({ children: children, packageName: packageName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "workflow-readonly-modal",
        metricKey: (0, $lzG9C.LOAD_START_MARK_KEY),
        packageName: packageName
    }, children);

});
parcelRegister("lzG9C", function(module, exports) {

$parcel$export(module.exports, "LOAD_START_MARK_KEY", () => $02ae2fc96a3ed3bf$export$37312a67c3e314c6);
$parcel$export(module.exports, "LOAD_END_MARK_KEY", () => $02ae2fc96a3ed3bf$export$45d73db12b3f4402);
$parcel$export(module.exports, "DIAGRAM_RENDERING_START_MARK_KEY", () => $02ae2fc96a3ed3bf$export$b251f321d9285754);
$parcel$export(module.exports, "READY_MARK_KEY", () => $02ae2fc96a3ed3bf$export$9ec2b1585f998431);
$parcel$export(module.exports, "ERROR_LOGGER_PATTERN", () => $02ae2fc96a3ed3bf$export$63291eb9eb8d2af2);
$parcel$export(module.exports, "APP_NAME", () => $02ae2fc96a3ed3bf$export$5b6c28c7dca07ad7);
$parcel$export(module.exports, "transitionType", () => $02ae2fc96a3ed3bf$export$331d6399b2e33350);
$parcel$export(module.exports, "WORKFLOW_EXPERIENCE_IDENTIFIER", () => $02ae2fc96a3ed3bf$export$4c39956c777a6352);
$parcel$export(module.exports, "EXPERIENCE_OPENED_START_EVENT", () => $02ae2fc96a3ed3bf$export$ded295b2866c666f);
$parcel$export(module.exports, "EXPERIENCE_OPENED_SUCCESS_EVENT", () => $02ae2fc96a3ed3bf$export$375ec45005c7d160);
const $02ae2fc96a3ed3bf$export$37312a67c3e314c6 = 'WORKFLOW_READONLY_MODAL_LOAD_START_MARK_KEY';
const $02ae2fc96a3ed3bf$export$45d73db12b3f4402 = 'WORKFLOW_READONLY_MODAL_LOAD_END_MARK_KEY';
const $02ae2fc96a3ed3bf$export$b251f321d9285754 = 'DIAGRAM_RENDERING_START_MARK_KEY';
const $02ae2fc96a3ed3bf$export$9ec2b1585f998431 = 'WORKFLOW_READONLY_MODAL_READY_MARK_KEY';
const $02ae2fc96a3ed3bf$export$63291eb9eb8d2af2 = '#workflow-readonly-modal#';
const $02ae2fc96a3ed3bf$export$5b6c28c7dca07ad7 = 'jira.fe.spa.transition.workflow-readonly-modal';
const $02ae2fc96a3ed3bf$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $02ae2fc96a3ed3bf$export$54227ee7dff570d1 = {
    CHANGE_ASSIGNEE: 'system:change-assignee',
    UPDATE_FIELD: 'system:update-field'
};
const $02ae2fc96a3ed3bf$export$4c39956c777a6352 = 'workflowBentoModal';
const $02ae2fc96a3ed3bf$export$ded295b2866c666f = 'openedStart';
const $02ae2fc96a3ed3bf$export$375ec45005c7d160 = 'openedSuccess';

});


parcelRegister("7vLAh", function(module, exports) {

let $578056e629300b91$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $578056e629300b91$var$load("kVX56"),
    $578056e629300b91$var$load("gULGT")
]).then(()=>parcelRequire('fpGoV'));

});


parcelRegister("lUJY8", function(module, exports) {

$parcel$export(module.exports, "START_NODE_ID", () => $9b2ad0bd1b0ec248$export$e117396b0784c7cc);
$parcel$export(module.exports, "transitionType", () => $9b2ad0bd1b0ec248$export$331d6399b2e33350);
$parcel$export(module.exports, "SCOPE_GLOBAL", () => $9b2ad0bd1b0ec248$export$9bb188cec3fcc43d);
$parcel$export(module.exports, "SCOPE_PROJECT", () => $9b2ad0bd1b0ec248$export$54c3a1cc8eb1bc43);
$parcel$export(module.exports, "ALL_OPERATION", () => $9b2ad0bd1b0ec248$export$d3dc8e33b7258fc5);
$parcel$export(module.exports, "STATUS_CATEGORY_WEIGHTS", () => $9b2ad0bd1b0ec248$export$8fc40e3c53b7f30e);
$parcel$export(module.exports, "ANY_OPERATION", () => $9b2ad0bd1b0ec248$export$804f62993e553350);
$parcel$export(module.exports, "errorSeverity", () => $9b2ad0bd1b0ec248$export$927c560a42a52ce0);

var $gULOk = parcelRequire("gULOk");
const $9b2ad0bd1b0ec248$export$e117396b0784c7cc = 'START';
const $9b2ad0bd1b0ec248$export$331d6399b2e33350 = {
    INITIAL: 'INITIAL',
    GLOBAL: 'GLOBAL',
    DIRECTED: 'DIRECTED'
};
const $9b2ad0bd1b0ec248$export$9bb188cec3fcc43d = 'GLOBAL';
const $9b2ad0bd1b0ec248$export$54c3a1cc8eb1bc43 = 'PROJECT';
const $9b2ad0bd1b0ec248$export$d3dc8e33b7258fc5 = 'ALL';
const $9b2ad0bd1b0ec248$export$8fc40e3c53b7f30e = {
    [(0, $gULOk.TODO)]: 1,
    [(0, $gULOk.IN_PROGRESS)]: 2,
    [(0, $gULOk.DONE)]: 3,
    [(0, $gULOk.UNDEFINED)]: 4
};
const $9b2ad0bd1b0ec248$export$804f62993e553350 = 'ANY';
const $9b2ad0bd1b0ec248$export$927c560a42a52ce0 = {
    WARNING: 'WARNING',
    ERROR: 'ERROR'
};

});

const $c1b3dec1183ab43c$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $c1b3dec1183ab43c$export$b8b9d90f9e5bd72b = 'jiraPortfolio3PlanIssueStatus';
const $c1b3dec1183ab43c$export$7930b6315c134d49 = 'services';

parcelRegister("dPDEg", function(module, exports) {

$parcel$export(module.exports, "transitionsProvider", () => $208dcd21b25f44bf$export$2f81aa12f4ac86b3);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $koVbs = parcelRequire("koVbs");

var $8DSSe = parcelRequire("8DSSe");


var $9mZ55 = parcelRequire("9mZ55");

var $gVXyD = parcelRequire("gVXyD");
const $208dcd21b25f44bf$export$2f81aa12f4ac86b3 = (ComposedComponent)=>function(props) {
        const { issueKey: issueKey, issueStatuses: issueStatuses, issue: issue } = props;
        const { formatMessage: formatMessage } = (0, $koVbs.default)();
        const [loading, setLoading] = (0, $5uXOq.useState)(false);
        const [transitions, setTransitions] = (0, $5uXOq.useState)(null);
        const fetchTransitions = (0, $5uXOq.useCallback)(()=>{
            if (loading) return;
            setLoading(true);
            setTransitions(null);
            (0, $8DSSe.default)(`/rest/api/2/issue/${issueKey}/transitions?sortByOpsBarAndStatus=true`, {
                method: 'GET'
            }).then((response)=>{
                setLoading(false);
                if (response.ok) return response.json();
                throw new Error(`Response not ok. Statuscode: ${response.status}`);
            }) // eslint-disable-next-line @typescript-eslint/no-explicit-any
            .then((result)=>{
                const transitionsFromServer = (0, $gVXyD.getFilteredOrderedTransitions)(result.transitions || [], issue.statusId);
                setTransitions((0, $gVXyD.addOriginalTransitions)(issue, (0, $gVXyD.removeTransitionsToCurrentAndOriginalStatus)(issue, transitionsFromServer, issueStatuses), issueStatuses, formatMessage((0, $9mZ55.default).originalTransitionStatusName)));
            }).catch((err)=>{
                setLoading(false);
                (0, $jcw0u.default)({
                    error: err,
                    meta: {
                        id: (0, $c1b3dec1183ab43c$export$7930b6315c134d49),
                        packageName: (0, $c1b3dec1183ab43c$export$b8b9d90f9e5bd72b),
                        teamName: (0, $c1b3dec1183ab43c$export$cfeee2ee86ead336)
                    },
                    attributes: {
                        serviceName: 'fetchTransitions'
                    },
                    sendToPrivacyUnsafeSplunk: true
                });
                setTransitions(null);
            });
        }, [
            issueKey,
            issue,
            issueStatuses,
            loading,
            formatMessage
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComposedComponent, {
            ...props,
            transitions: transitions,
            loading: loading,
            fetchTransitions: fetchTransitions
        });
    };

});
parcelRegister("8DSSe", function(module, exports) {

$parcel$export(module.exports, "AgressiveFetchError", () => $4e5396fa7984e1d2$export$a09f0e985c649de4);
$parcel$export(module.exports, "aggressiveFetch", () => $4e5396fa7984e1d2$export$624e87556f86a679);
$parcel$export(module.exports, "default", () => $4e5396fa7984e1d2$export$2e2bcd8739ae039);

var $bCilb = parcelRequire("bCilb");
var $lTdwg = parcelRequire("lTdwg");

var $4ENQh = parcelRequire("4ENQh");

var $fb9D1 = parcelRequire("fb9D1");

var $idmiV = parcelRequire("idmiV");
const $4e5396fa7984e1d2$export$8467c5933bf19410 = 'common.fetch.XHR_UNAUTHORIZED_ERROR';
const $4e5396fa7984e1d2$export$b8ec1360093ba0e8 = 'response not ok';
const $4e5396fa7984e1d2$var$headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json'
};
const $4e5396fa7984e1d2$var$defaultOptions = {
    credentials: 'same-origin',
    headers: $4e5396fa7984e1d2$var$headers
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $4e5396fa7984e1d2$var$castBody = (body)=>{
    const type = $lTdwg.default(body);
    switch(type){
        case 'String':
            return body;
        case 'Object':
            return JSON.stringify(body);
        case 'Number':
            return `${body}`;
        default:
            throw new Error(`Unsupported body type: ${type}`);
    }
};
const $4e5396fa7984e1d2$var$enhanceOptions = $bCilb.default({
    body: $4e5396fa7984e1d2$var$castBody
});
const $4e5396fa7984e1d2$var$checkAuthorized = (response)=>{
    if (!response?.ok && response.status === 401) {
        (0, $idmiV.reload)();
        throw new Error(`${$4e5396fa7984e1d2$export$8467c5933bf19410}:${response.url}`);
    }
    return response;
};
function $4e5396fa7984e1d2$var$fetch(url, { isUrlVerbatim: isUrlVerbatim, profile: profile, ...options }) {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const request = window.fetch(isUrlVerbatim ? url : (0, $fb9D1.proxyContextSafeUrl)(url), $4e5396fa7984e1d2$var$enhanceOptions({
        ...$4e5396fa7984e1d2$var$defaultOptions,
        ...options
    })).then($4e5396fa7984e1d2$var$checkAuthorized);
    if (profile) {
        const finishProfile = (0, $4ENQh.monitor).startProfileConcurrent(profile);
        return request.then((response)=>{
            finishProfile();
            return response;
        });
    }
    return request;
}
class $4e5396fa7984e1d2$export$a09f0e985c649de4 extends Error {
    constructor(message, { request: request, response: response }){
        super(message);
        this.request = request;
        this.response = response;
    }
}
async function $4e5396fa7984e1d2$export$624e87556f86a679(url, { profile: profile, ...options }, errMessage = 'aggressiveFetch failed') {
    const request = new Request(url, $4e5396fa7984e1d2$var$enhanceOptions({
        ...$4e5396fa7984e1d2$var$defaultOptions,
        ...options
    }));
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    let finishProfile = ()=>{};
    if (profile) finishProfile = (0, $4ENQh.monitor).startProfileConcurrent(profile);
    const response = await $4e5396fa7984e1d2$var$fetch(url, options);
    finishProfile();
    $4e5396fa7984e1d2$var$checkAuthorized(response);
    if (!response?.ok) throw new $4e5396fa7984e1d2$export$a09f0e985c649de4(`${errMessage}: ${response.status}: ${$4e5396fa7984e1d2$export$b8ec1360093ba0e8}`, {
        request: request,
        response: response
    });
    if (options.json && response.status !== 204) try {
        return await response.json();
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        throw new $4e5396fa7984e1d2$export$a09f0e985c649de4(`${errMessage}: ${response.status}: ${err.message}`, {
            request: request,
            response: response
        });
    }
}
var $4e5396fa7984e1d2$export$2e2bcd8739ae039 = $4e5396fa7984e1d2$var$fetch;

});
parcelRegister("bCilb", function(module, exports) {

$parcel$export(module.exports, "default", () => $8751785f1870d240$export$2e2bcd8739ae039);

var $c9RLn = parcelRequire("c9RLn");
/**
 * Creates a new object by recursively evolving a shallow copy of `object`,
 * according to the `transformation` functions. All non-primitive properties
 * are copied by reference.
 *
 * A `transformation` function will not be invoked if its corresponding key
 * does not exist in the evolved object.
 *
 * @func
 * @memberOf R
 * @since v0.9.0
 * @category Object
 * @sig {k: (v -> v)} -> {k: v} -> {k: v}
 * @param {Object} transformations The object specifying transformation functions to apply
 *        to the object.
 * @param {Object} object The object to be transformed.
 * @return {Object} The transformed object.
 * @example
 *
 *      const tomato = {firstName: '  Tomato ', data: {elapsed: 100, remaining: 1400}, id:123};
 *      const transformations = {
 *        firstName: R.trim,
 *        lastName: R.trim, // Will not get invoked.
 *        data: {elapsed: R.add(1), remaining: R.add(-1)}
 *      };
 *      R.evolve(transformations, tomato); //=> {firstName: 'Tomato', data: {elapsed: 101, remaining: 1399}, id:123}
 */ var $8751785f1870d240$var$evolve = /*#__PURE__*/ (0, $c9RLn.default)(function evolve(transformations, object) {
    var result = object instanceof Array ? [] : {};
    var transformation, key, type;
    for(key in object){
        transformation = transformations[key];
        type = typeof transformation;
        result[key] = type === 'function' ? transformation(object[key]) : transformation && type === 'object' ? evolve(transformation, object[key]) : object[key];
    }
    return result;
});
var $8751785f1870d240$export$2e2bcd8739ae039 = $8751785f1870d240$var$evolve;

});
parcelRegister("c9RLn", function(module, exports) {

$parcel$export(module.exports, "default", () => $8da0078a7b144f9d$export$2e2bcd8739ae039);

var $ccUYa = parcelRequire("ccUYa");

var $iU24A = parcelRequire("iU24A");
function $8da0078a7b144f9d$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $iU24A.default)(a) ? f2 : (0, $ccUYa.default)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $iU24A.default)(a) && (0, $iU24A.default)(b) ? f2 : (0, $iU24A.default)(a) ? (0, $ccUYa.default)(function(_a) {
                    return fn(_a, b);
                }) : (0, $iU24A.default)(b) ? (0, $ccUYa.default)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}

});
parcelRegister("ccUYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e32cbf2c9cb3af3$export$2e2bcd8739ae039);

var $iU24A = parcelRequire("iU24A");
function $8e32cbf2c9cb3af3$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $iU24A.default)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}

});
parcelRegister("iU24A", function(module, exports) {

$parcel$export(module.exports, "default", () => $dc2f10a18a9bb545$export$2e2bcd8739ae039);
function $dc2f10a18a9bb545$export$2e2bcd8739ae039(a) {
    return a != null && typeof a === 'object' && a['@@functional/placeholder'] === true;
}

});




parcelRegister("lTdwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $fef938ace5d66616$export$2e2bcd8739ae039);

var $ccUYa = parcelRequire("ccUYa");
/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */ var $fef938ace5d66616$var$type = /*#__PURE__*/ (0, $ccUYa.default)(function type(val) {
    return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});
var $fef938ace5d66616$export$2e2bcd8739ae039 = $fef938ace5d66616$var$type;

});

parcelRegister("4ENQh", function(module, exports) {

$parcel$export(module.exports, "SPA_APP_NAME", () => $7022219d2d87e7c6$export$3121747bb6e73d1c);
$parcel$export(module.exports, "TTI_SLO", () => $7022219d2d87e7c6$export$748427380a6493b0);
$parcel$export(module.exports, "ARJ_EARLY_PRELOAD_PREFIX", () => $7022219d2d87e7c6$export$1b60784a15ad91a9);
$parcel$export(module.exports, "monitor", () => $7022219d2d87e7c6$export$ec5b303098bc4b7f);

var $99gkn = parcelRequire("99gkn");

var $aOr3t = parcelRequire("aOr3t");

var $bFU4G = parcelRequire("bFU4G");

var $21pfT = parcelRequire("21pfT");
var $dGrdR = parcelRequire("dGrdR");

var $4dRjY = parcelRequire("4dRjY");

var $2SVPM = parcelRequire("2SVPM");

var $fdim1 = parcelRequire("fdim1");

var $6NgSc = parcelRequire("6NgSc");
const $7022219d2d87e7c6$export$3121747bb6e73d1c = 'advanced-roadmaps';
const $7022219d2d87e7c6$export$748427380a6493b0 = 4000;
const $7022219d2d87e7c6$export$2a97570d48bcd64d = 1000;
const $7022219d2d87e7c6$export$1b60784a15ad91a9 = 'jira.fe-spa.advanced-roadmaps.early-preload';
const $7022219d2d87e7c6$var$INTERACTION_PREFIX = $7022219d2d87e7c6$export$3121747bb6e73d1c;
const $7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD = 'arj-early-preload';
const $7022219d2d87e7c6$var$PRODUCT_PREFIX = 'jira.fe-spa.advanced-roadmaps.product';
const $7022219d2d87e7c6$var$taskKeyToInteractionKey = (taskKey)=>`${$7022219d2d87e7c6$var$INTERACTION_PREFIX}.${taskKey.toLowerCase()}`;
const $7022219d2d87e7c6$export$4726438eb4db5074 = '__initial_render__';
const $7022219d2d87e7c6$var$MAX_ENTRIES_PER_MARK = 5;
class $7022219d2d87e7c6$export$3de16b9a4e4a99f4 {
    constructor(options){
        this.featureFlags = [];
        this.profiles = new Map();
        this.timings = [];
        this.tasks = new Map();
        this.contextualAnalyticsData = {
            planId: '',
            scenarioId: ''
        };
        this.browserMetrics = (options || {}).browserMetrics || (0, $21pfT.browserMetrics);
        this.metrics = (options || {}).metrics || (0, $dGrdR.metrics);
        this.resetInitialRenderTask();
        (0, $fdim1.injectCallbackIntoGetBooleanFeatureFlag)((flag)=>{
            this.registerBooleanFeatureFlag(flag);
        });
    }
    initializeContextualAnalyticsData(data) {
        this.contextualAnalyticsData = {
            ...data
        };
    }
    addContextualAnalyticsData(newData) {
        this.contextualAnalyticsData = {
            ...this.contextualAnalyticsData,
            ...newData
        };
    }
    /**
	 * Add initial render stats to the ongoing UFO initial load metric
	 *
	 */ finishInitialRender(options) {
        // Retrieve the task in which all the initial render stats are stored.
        const task = this.tasks.get($7022219d2d87e7c6$export$4726438eb4db5074);
        if (!task) return;
        // Extract and record the early preload timings
        this.recordEarlyPreloadTimings();
        const bm3Marks = {};
        this.timings.forEach(({ key: key, startTime: startTime, endTime: endTime })=>{
            bm3Marks[`${key}:start`] = startTime;
            bm3Marks[`${key}:end`] = endTime;
        });
        const bm3CustomTimings = this.timings.map(({ key: key })=>({
                key: key,
                startMark: `${key}:start`,
                endMark: `${key}:end`
            }));
        (0, $aOr3t.addBM3TimingsToUFO)(bm3Marks, bm3CustomTimings);
        // Record the product stop in the UFO
        (0, $2SVPM.stopInitialPageLoadTimingFromPerformanceMarkStart)('product', (0, $4dRjY.PRODUCT_START_MARK), true);
        // Add custom data to UFO
        const { scalingFactors: scalingFactors } = options;
        const customData = this.collectCustomData({
            scalingFactors: scalingFactors
        }, task.executionTimes, task.marks);
        (0, $99gkn.addUFOCustomData)(customData);
        /**
		 * Record the custom TTI value in UFO. UFO will use this TTI value. If this is not provided it, will use TTAI.
		 * The key is only used to create [bm3_tti] mark. The TTI value is recorded using `stopTime`.
		 * As we are using UFO metric names, we don't need seperate keys here.
		 * platform/packages/react-ufo/ufo-create-payload/src/index.ts#74
		 */ (0, $bFU4G.addApdexToAll)({
            key: 'plans',
            stopTime: performance.now()
        });
        // Reset the initial render data.
        this.resetInitialRenderTask();
    }
    /**
	 * Start measuring the task and timed functions within.
	 *
	 * Task is a single report unit. Always pair `startTask` with `finishTask`, or the corresponding
	 * analytics event will not be sent. Tasks are re-entrant, starting the same task before it's
	 * finished has no effect, the monitor just continues to collect data. However, people looking
	 * at the data would most likely imply 1:1 start/finish correspondence, so please don't abuse
	 * re-entrance property.
	 *
	 * When timed function is executed within a task its timing is added to task's extra attributes,
	 * as well as provided scaleFactors and registered perf feature flags. Tasks support nesting,
	 * timed functions are reported for all running tasks.
	 *
	 * We track function timing in `executionTimes` instead of using `BrowserMetrics.setMark` as it
	 * gets ugly fast due to the need to keep track of start and end of multiple invocations encoded
	 * in mark keys.
	 *
	 * At the moment all the tasks are reported as `custom` metrics as it's a majority of our use-cases
	 * but we must add support for `interaction` metrics.
	 */ startTask(taskKey, options, customStartTime) {
        if (this.tasks.has(taskKey)) return;
        const interaction = this.metrics.custom({
            key: $7022219d2d87e7c6$var$taskKeyToInteractionKey(taskKey),
            featureFlags: this.featureFlags,
            slo: {
                threshold: $7022219d2d87e7c6$export$2a97570d48bcd64d
            }
        });
        customStartTime !== undefined ? interaction.start({
            startTime: customStartTime
        }) : interaction.start();
        const justOptions = options || {
            scalingFactors: {}
        };
        const executionTimes = new Map();
        const marks = new Set();
        const task = {
            interaction: interaction,
            options: justOptions,
            executionTimes: executionTimes,
            marks: marks
        };
        this.tasks.set(taskKey, task);
        this.setMark(`${taskKey}_start`);
    }
    /**
	 * Finish measuring the task, prepare and send corresponding analytics event.
	 */ finishTask(taskKey, options) {
        const task = this.tasks.get(taskKey);
        if (!task) return;
        const { sloSuccessThreshold: sloSuccessThreshold = $7022219d2d87e7c6$export$2a97570d48bcd64d, scalingFactors: scalingFactors } = options || {};
        // NOTE BM3 doesn't support setting SLO after interaction instantiation.
        // We violate its contract and set private field directly from here.
        // We do it only for the sake of Monitor's API backward compatibility.
        // We must move SLO into startTask ASAP and remove this abomination.
        if (typeof task.interaction.config !== 'undefined') task.interaction.config.slo.threshold = sloSuccessThreshold;
        if (scalingFactors) // @ts-expect-error No overload matches this call.
        Object.assign(task.options.scalingFactors, scalingFactors);
        const customData = this.collectCustomData(task.options, task.executionTimes, task.marks);
        task.interaction.stop({
            customData: customData
        });
        this.tasks.delete(taskKey);
        this.setMark(`${taskKey}_end`);
    }
    /**
	 * Decorate a function as a task, synchronously (task is finished as soon as the function returns).
	 */ timeTask(task, taskKey, options) {
        return (...args)=>{
            this.startTask(taskKey, options);
            const result = task(...args);
            this.finishTask(taskKey);
            return result;
        };
    }
    /**
	 * Mark a synchronous function as a timed one.
	 *
	 * When the function is executed in the presence of running tasks, its timing is reported to all of them.
	 *
	 * TODO Have a register of timed functions to warn on name clashes.
	 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    timeFunction(fn, fnKey) {
        return (...args)=>{
            this.startProfile(fnKey);
            const result = fn(...args);
            this.finishProfile(fnKey);
            return result;
        };
    }
    /**
	 * Start measuring execution time from the current point to the corresponding `finishProfile` call.
	 *
	 * When the profile is finished in the presence of running tasks, its timing is reported to all of them.
	 * *Do not* use it if the same profile could be potentially started concurrently,
	 * use `startProfileConcurrent` instead.
	 */ startProfile(profileKey) {
        if (this.profiles.has(profileKey)) return;
        this.profiles.set(profileKey, {
            start: performance.now()
        });
    }
    /**
	 * Finish profile and record its execution time to all running tasks.
	 *
	 * Use it only together with `startProfile`.
	 * To finish profile started by `startProfileConcurrent` use the returned function instead.
	 */ finishProfile(profileKey) {
        const profile = this.profiles.get(profileKey);
        if (!profile) return;
        this.recordProfile(profileKey, profile);
        this.profiles.delete(profileKey);
    }
    /**
	 * Start measuring execution time from the current point to the call of the returned function.
	 *
	 * When the profile is finish in the presence of running tasks, its timing is reported to all of them.
	 * This method is safe for the potentially concurrent multiple entries by the cost of the need
	 * to pass finish function down to the profile finish point.
	 * *Do not* use `finishProfile` method for the profile started by `startProfileConcurrent`.
	 */ startProfileConcurrent(profileKey) {
        const profile = {
            start: performance.now()
        };
        return ()=>this.recordProfile(profileKey, profile);
    }
    /**
	 * Register a boolean flag to be added as an extra attribute to emitted events.
	 */ registerBooleanFeatureFlag(flag) {
        this.featureFlags.push(flag);
    }
    /**
	 * Register a mark to be reported to all tasks running at that moment.
	 */ setMark(markKey) {
        if (!performance.mark) return;
        performance.mark(markKey);
        for (const { marks: marks } of this.tasks.values())marks.add(markKey);
    }
    // Private.
    /**
	 * Create a fake task to track initial render info
	 */ resetInitialRenderTask() {
        const executionTimes = new Map();
        const marks = new Set();
        const task = {
            interaction: {},
            options: {
                scalingFactors: {}
            },
            executionTimes: executionTimes,
            marks: marks
        };
        this.tasks.set($7022219d2d87e7c6$export$4726438eb4db5074, task);
    }
    /**
	 * Record profile execution time to all running tasks.
	 */ recordProfile(profileKey, profile) {
        const profileEnd = performance.now();
        const measurement = {
            start: profile.start,
            end: profileEnd
        };
        for (const { executionTimes: executionTimes } of this.tasks.values()){
            const times = executionTimes.get(profileKey);
            if (times) times.push(measurement);
            else executionTimes.set(profileKey, [
                measurement
            ]);
        }
    }
    /**
	 * Record custom profile execution time to all running tasks
	 */ recordCustomProfile(profileKey, customProfile) {
        const measurement = {
            ...customProfile
        };
        for (const { executionTimes: executionTimes } of this.tasks.values()){
            const times = executionTimes.get(profileKey);
            if (times) times.push(measurement);
            else executionTimes.set(profileKey, [
                measurement
            ]);
        }
    }
    /**
	 * Records the timing for preload requests
	 */ recordEarlyPreloadTimings() {
        const resources = [
            '',
            'backlog',
            'info-metadata',
            'initial-checks-for-report',
            'plan-info-for-report'
        ];
        this.timings.push(...resources.map((resource)=>{
            /**
				 * Recording the performance information of the API before returning
				 * the response.
				 */ const start = Math.floor((0, $6NgSc.extractStartTime)(`${$7022219d2d87e7c6$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:start`));
            const end = Math.ceil((0, $6NgSc.extractStartTime)(`${$7022219d2d87e7c6$export$1b60784a15ad91a9}${resource ? `.${resource}` : ''}:end`));
            return {
                key: resource ? `${$7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD}/${resource}` : $7022219d2d87e7c6$var$ARJ_EARLY_PRELOAD,
                startTime: start,
                endTime: end
            };
        }));
    }
    recordProductTimings() {
        const resources = [
            'parse-json'
        ];
        this.timings.push(...resources.map((resource)=>{
            /**
				 * Recording the performance information for preprocessing product data
				 */ const start = Math.floor((0, $6NgSc.extractStartTime)(`${$7022219d2d87e7c6$var$PRODUCT_PREFIX}.${resource}:start`));
            const end = Math.ceil((0, $6NgSc.extractStartTime)(`${$7022219d2d87e7c6$var$PRODUCT_PREFIX}.${resource}:end`));
            return {
                key: `product/${resource}`,
                startTime: start,
                endTime: end
            };
        }));
    }
    /**
	 * Enrich task report with feature flags, scaling factors, and execution time stats.
	 *
	 * Reported stats: min, max, mean, standard deviation, number of runs.
	 *
	 * Note that dots in feature flag names (and any other attributes) will be replaced by underscores in Splunk.
	 * (TODO confirm if this is still true in BM3 case)
	 */ collectCustomData(options, executionTimes, marks) {
        const pageStart = this.pageStart();
        const report = {
            ...this.contextualAnalyticsData,
            scalingFactors: {},
            executionTimes: {},
            marks: {}
        };
        const scalingFactors = options.scalingFactors || {};
        for (const factor of Object.keys(scalingFactors))report.scalingFactors[factor] = scalingFactors[factor];
        for (const [fnKey, allTimes] of executionTimes){
            // Skip leftovers from the previous route.
            const times = allTimes.filter(({ start: start })=>start >= pageStart);
            const n = times.length;
            if (n > 0) {
                const start = times[0].start;
                let lastEnd = start;
                let min = Infinity;
                let max = -Infinity;
                let sum = 0;
                // eslint-disable-next-line @typescript-eslint/no-shadow
                for (const { start: start, end: end } of times){
                    const duration = end - start;
                    sum += duration;
                    min = Math.min(min, duration);
                    max = Math.max(max, duration);
                    lastEnd = Math.max(lastEnd, end);
                }
                const mean = sum / n;
                let devSum = 0;
                // eslint-disable-next-line @typescript-eslint/no-shadow
                for (const { start: start, end: end } of times){
                    const dev = end - start - mean;
                    devSum += dev * dev;
                }
                const stddev = n > 1 ? Math.sqrt(devSum / (n - 1)) : 0;
                report.executionTimes[fnKey] = {
                    start: start - pageStart,
                    end: lastEnd - pageStart,
                    min: min,
                    max: max,
                    mean: mean,
                    stddev: stddev,
                    count: n,
                    sum: sum
                };
            }
        }
        if (performance.getEntriesByName) for (const mark of marks){
            let i = 0;
            for (const m of performance.getEntriesByName(mark) || []){
                if (i > $7022219d2d87e7c6$var$MAX_ENTRIES_PER_MARK) break;
                const start = m.startTime - pageStart;
                // Skip leftovers from the previous route.
                if (start >= 0) {
                    report.marks[`${mark}_${i}`] = start;
                    i++;
                }
            }
        }
        return report;
    }
    /** When the most recent page transition started.
	 *
	 * It will be 0 on initial load.
	 */ pageStart() {
        return this.browserMetrics.getPageLoadMetric()?.startTime || 0;
    }
}
const $7022219d2d87e7c6$export$ec5b303098bc4b7f = new $7022219d2d87e7c6$export$3de16b9a4e4a99f4();

});
parcelRegister("fdim1", function(module, exports) {

$parcel$export(module.exports, "injectCallbackIntoGetBooleanFeatureFlag", () => $944db6b8bf5461ba$export$fe8eedb8c1059343);
$parcel$export(module.exports, "getBooleanFeatureFlag", () => $944db6b8bf5461ba$export$a4658325ccb88f03);

var $co1wz = parcelRequire("co1wz");
const $944db6b8bf5461ba$var$callbacks = [];
const $944db6b8bf5461ba$export$fe8eedb8c1059343 = (callback)=>{
    $944db6b8bf5461ba$var$callbacks.push(callback);
};
const $944db6b8bf5461ba$export$d930a8564fce9bcd = (flag)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const urlParams = new URLSearchParams(window.location.search);
    const ffOverrides = urlParams.get('ffOverrides');
    if (ffOverrides === undefined || ffOverrides === null) return null;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const item = ffOverrides.split(',').find((item)=>item.startsWith(`${flag}:`));
    return item !== undefined && item.split(':')[1] || null;
};
const $944db6b8bf5461ba$export$a4658325ccb88f03 = (flag, defaultValue = false, storybookDefault = true)=>{
    for (const cb of $944db6b8bf5461ba$var$callbacks)cb(flag, defaultValue, storybookDefault);
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window?.STORYBOOK_ENV) {
        const overrideValue = $944db6b8bf5461ba$export$d930a8564fce9bcd(flag);
        if (overrideValue !== null) return overrideValue === 'true';
        return storybookDefault;
    }
    return (0, $co1wz.ff)(flag, defaultValue);
};
const $944db6b8bf5461ba$export$757bc67afadef4a0 = (featureFlagName, defaultValue, possibleValues = [], storybookDefault)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window?.STORYBOOK_ENV) {
        const overrideValue = $944db6b8bf5461ba$export$d930a8564fce9bcd(featureFlagName);
        if (overrideValue !== null) return overrideValue;
        return typeof storybookDefault === 'string' ? storybookDefault : defaultValue;
    }
    return (0, $co1wz.getMultivariateFeatureFlag)(featureFlagName, defaultValue, possibleValues);
};

});

parcelRegister("6NgSc", function(module, exports) {

$parcel$export(module.exports, "extractStartTime", () => $b554ac6908eada1d$export$97ed9769a496ce6e);
const $b554ac6908eada1d$export$97ed9769a496ce6e = (markName)=>(performance.getEntriesByName(markName, 'mark')[0] || {
        startTime: 0
    }).startTime;

});


parcelRegister("fb9D1", function(module, exports) {

$parcel$export(module.exports, "proxyContextSafeUrl", () => $b99acc067b5c8cc7$export$ff2a151586ba6aa1);
/**
 * All API calls in the confluence macro need to be wrapped in a proxy if the Jira and Confluence have different base urls.
 * Note this should be used for api calls only, not for links.
 */ const $b99acc067b5c8cc7$export$ff2a151586ba6aa1 = (url)=>`${// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.integrationApiUrl || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.AJS && window.AJS.contextPath && window.AJS.contextPath() || ''}${url}`;

});

parcelRegister("idmiV", function(module, exports) {

$parcel$export(module.exports, "PLAN_PAGES", () => $71b9c13c38b023cf$export$aa80e59bd6a86321);
$parcel$export(module.exports, "buildManageViewsPath", () => $71b9c13c38b023cf$export$163eb352faa92361);
$parcel$export(module.exports, "redirect", () => $71b9c13c38b023cf$export$89e12c5b50f7529d);
$parcel$export(module.exports, "openInNewTab", () => $71b9c13c38b023cf$export$9e52b10d57ddf9e3);
$parcel$export(module.exports, "reload", () => $71b9c13c38b023cf$export$32da5b5043dcd88c);
$parcel$export(module.exports, "redirectToSettingsSubPage", () => $71b9c13c38b023cf$export$30c1dc5285e5b7c5);
$parcel$export(module.exports, "redirectToIssueSourceSetup", () => $71b9c13c38b023cf$export$c1647ef31d453e4e);
$parcel$export(module.exports, "userAgent", () => $71b9c13c38b023cf$export$3dcce53a3755dc8c);
$parcel$export(module.exports, "getLocation", () => $71b9c13c38b023cf$export$e7fd20fad3cf4b5f);
$parcel$export(module.exports, "parseQueryParams", () => $71b9c13c38b023cf$export$67c4cee80a3410cd);
$parcel$export(module.exports, "getQueryParameters", () => $71b9c13c38b023cf$export$2c02b58bdf58d1c3);
$parcel$export(module.exports, "getPathParams", () => $71b9c13c38b023cf$export$da250964c4d72448);
$parcel$export(module.exports, "updateQueryString", () => $71b9c13c38b023cf$export$a725689b9dc0457f);
$parcel$export(module.exports, "redirectToNewScenario", () => $71b9c13c38b023cf$export$11f26f7d7225123e);
$parcel$export(module.exports, "isReportView", () => $71b9c13c38b023cf$export$60b6d4de09d53c54);
$parcel$export(module.exports, "getReportView", () => $71b9c13c38b023cf$export$37ee7678f5ae0af5);
$parcel$export(module.exports, "isEmbedReportView", () => $71b9c13c38b023cf$export$cf369e206dbfd4ce);
$parcel$export(module.exports, "isConfluenceReportView", () => $71b9c13c38b023cf$export$62a9a65b5c5c27e);
$parcel$export(module.exports, "isConfluenceReportProxyView", () => $71b9c13c38b023cf$export$b990f18079f6b40d);
$parcel$export(module.exports, "isExportView", () => $71b9c13c38b023cf$export$cf7a8de77e0c8209);
$parcel$export(module.exports, "isExportPreview", () => $71b9c13c38b023cf$export$ad6637fa30ef33ef);
$parcel$export(module.exports, "getNonTimelineWidth", () => $71b9c13c38b023cf$export$9bd1947787a14301);
$parcel$export(module.exports, "getExportTimelineDateRange", () => $71b9c13c38b023cf$export$fc5fb6d4b5cb9b11);
$parcel$export(module.exports, "isPageUnloading", () => $71b9c13c38b023cf$export$806b710b4d1b901c);
$parcel$export(module.exports, "getPlanUrl", () => $71b9c13c38b023cf$export$c64539b90bced4a);

var $3T6Xo = parcelRequire("3T6Xo");

var $gKZoD = parcelRequire("gKZoD");

var $fb9D1 = parcelRequire("fb9D1");

var $TTKUQ = parcelRequire("TTKUQ");
const $71b9c13c38b023cf$export$7b854f4176fe4984 = {
    PLAN: 'plan',
    SETTINGS: 'settings'
};
const $71b9c13c38b023cf$export$aa80e59bd6a86321 = {
    ROADMAP: 'backlog',
    RELEASES: 'releases',
    TEAMS: 'teams',
    DEPENDENCIES_REPORT: 'dependencies'
};
const $71b9c13c38b023cf$export$50ce986ba03069e4 = {
    ROADMAP: `${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}/${$71b9c13c38b023cf$export$aa80e59bd6a86321.ROADMAP}`,
    RELEASES: `${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}/${$71b9c13c38b023cf$export$aa80e59bd6a86321.RELEASES}`,
    TEAMS: `${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}/${$71b9c13c38b023cf$export$aa80e59bd6a86321.TEAMS}`,
    DEPENDENCIES_REPORT: `${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}/${$71b9c13c38b023cf$export$aa80e59bd6a86321.DEPENDENCIES_REPORT}`
};
const $71b9c13c38b023cf$export$331e0cdfec693a91 = {
    CUSTOM_FIELDS: 'customFields',
    EXCLUSION_RULES: 'setExclusionRules',
    ISSUE_SOURCES: 'issueSources',
    PERMISSIONS: 'permissions',
    REMOVED_ISSUES: 'removedIssues',
    SAVED_VIEWS: 'savedViews',
    SCENARIOS: 'scenarios',
    AUTO_SCHEDULER: 'auto-scheduler',
    SCHEDULING: 'scheduling',
    SOURCES: 'sources',
    FIND_YOUR_ISSUE: 'findYourIssue'
};
const $71b9c13c38b023cf$export$f8b09fb9bf12a66d = {
    CUSTOM_FIELDS: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.CUSTOM_FIELDS}`,
    EXCLUSION_RULES: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.EXCLUSION_RULES}`,
    ISSUE_SOURCES: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.ISSUE_SOURCES}`,
    PERMISSIONS: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.PERMISSIONS}`,
    REMOVED_ISSUES: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.REMOVED_ISSUES}`,
    SAVED_VIEWS: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.SAVED_VIEWS}`,
    SCENARIOS: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.SCENARIOS}`,
    AUTO_SCHEDULER: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.AUTO_SCHEDULER}`,
    SCHEDULING: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.SCHEDULING}`,
    SOURCES: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.SOURCES}`,
    FIND_YOUR_ISSUE: `/${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${$71b9c13c38b023cf$export$331e0cdfec693a91.FIND_YOUR_ISSUE}`
};
const $71b9c13c38b023cf$export$163eb352faa92361 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))($71b9c13c38b023cf$export$331e0cdfec693a91.SAVED_VIEWS)}`;
const $71b9c13c38b023cf$export$92e12da00cfa0a30 = (planId, scenarioId)=>`/jira/plans/${planId}/scenarios/${scenarioId}/settings/${(0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))($71b9c13c38b023cf$export$331e0cdfec693a91.REMOVED_ISSUES)}`;
const $71b9c13c38b023cf$export$89e12c5b50f7529d = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.href = url;
};
const $71b9c13c38b023cf$export$9e52b10d57ddf9e3 = (url)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.open(url, '_blank')?.focus();
};
const $71b9c13c38b023cf$export$32da5b5043dcd88c = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.reload();
};
const $71b9c13c38b023cf$export$91c50705ae840697 = (planId, scenarioId)=>{
    $71b9c13c38b023cf$export$89e12c5b50f7529d((0, $fb9D1.proxyContextSafeUrl)(`/jira/plans/${planId}/scenarios/${scenarioId}`));
};
const $71b9c13c38b023cf$export$fac3bf18cd62bfe3 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.hash = `#${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}`;
};
const $71b9c13c38b023cf$export$30c1dc5285e5b7c5 = (page)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.hash = `#${$71b9c13c38b023cf$export$7b854f4176fe4984.SETTINGS}/${page}`;
};
const $71b9c13c38b023cf$export$8ccbd58c5a1933be = (tab)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.hash = `#${$71b9c13c38b023cf$export$7b854f4176fe4984.PLAN}${tab}`;
};
const $71b9c13c38b023cf$export$c1647ef31d453e4e = (planId)=>{
    $71b9c13c38b023cf$export$89e12c5b50f7529d((0, $fb9D1.proxyContextSafeUrl)(`/secure/PortfolioPlanSetup.jspa?id=${planId}&3.0plan`));
};
const $71b9c13c38b023cf$export$3dcce53a3755dc8c = globalThis.navigator?.userAgent || 'unknown';
const $71b9c13c38b023cf$export$e7fd20fad3cf4b5f = ()=>window.location;
const $71b9c13c38b023cf$export$67c4cee80a3410cd = (rawParams)=>{
    if (!rawParams) return {};
    const result = {};
    rawParams.slice(1) // ignore '?'
    .split('&').map((queryParam)=>{
        const keyValue = queryParam.split('=');
        return {
            key: keyValue[0],
            value: keyValue[1]
        };
    }).forEach((keyValue)=>{
        result[keyValue.key] = keyValue.value;
    });
    return result;
};
const $71b9c13c38b023cf$export$2c02b58bdf58d1c3 = ()=>$71b9c13c38b023cf$export$67c4cee80a3410cd(window.location.search);
const $71b9c13c38b023cf$export$62c1abd9d82e0215 = (path)=>{
    const pathparams = [
        'id',
        'sid',
        'r'
    ];
    const paramToPathNameMap = {
        id: 'plans',
        sid: 'scenarios',
        r: 'reports'
    };
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/consistent-type-assertions
    const params = {};
    pathparams.forEach((param)=>{
        const regex = new RegExp(`/${paramToPathNameMap[param]}/(\\w+)`, 'g');
        const matches = Array.from(path.matchAll(regex), (match)=>match[1]);
        params[param] = matches[0];
    });
    return params;
};
const $71b9c13c38b023cf$export$da250964c4d72448 = ()=>$71b9c13c38b023cf$export$62c1abd9d82e0215(window.location.pathname);
const $71b9c13c38b023cf$export$a725689b9dc0457f = (locationSearch, newParams)=>{
    const currentParams = $71b9c13c38b023cf$export$67c4cee80a3410cd(locationSearch);
    const updatedParams = {
        ...currentParams,
        ...newParams
    };
    const searchString = Object.keys(updatedParams).filter((key)=>updatedParams[key] !== undefined).map((key)=>`${key}=${updatedParams[key]}`).join('&');
    return `?${searchString}`;
};
const $71b9c13c38b023cf$export$11f26f7d7225123e = (browserHistory, sid)=>{
    const regex = new RegExp('(/scenarios/)\\w+', 'g');
    /* eslint-disable jira/jira-ssr/no-unchecked-globals-usage */ const url = `${window.location.pathname.replace(regex, (_, $1)=>`${$1}${sid}`)}${window.location.search}${window.location.hash}`;
    /* eslint-enable jira/jira-ssr/no-unchecked-globals-usage */ browserHistory.push(url);
};
const $71b9c13c38b023cf$export$60b6d4de09d53c54 = ()=>{
    (0, $gKZoD.di)(window);
    return window && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (window.location.pathname.includes('reports') || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.includes('PortfolioEmbeddedReportView') || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.includes('PlanEmbeddedReport') || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.includes('PortfolioRoadmapConfluence'));
};
const $71b9c13c38b023cf$export$37ee7678f5ae0af5 = ()=>{
    const pathname = globalThis.window.location.pathname;
    if (pathname) {
        if (pathname.includes('reports')) return 'REPORT';
        if (pathname.includes('PlanEmbeddedReport')) return 'IFRAME';
        if (pathname.includes('PortfolioRoadmapConfluence')) return 'MACRO';
    }
    return 'NONE';
};
const $71b9c13c38b023cf$export$cf369e206dbfd4ce = ()=>window && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    (window.location.pathname.includes('PortfolioEmbeddedReportView') || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window.location.pathname.includes('PlanEmbeddedReport'));
const $71b9c13c38b023cf$export$62a9a65b5c5c27e = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.location.pathname.indexOf('PortfolioRoadmapConfluence') !== -1;
const $71b9c13c38b023cf$export$b990f18079f6b40d = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window && window.location.pathname.indexOf('/plugins/servlet/PortfolioRoadmapConfluence') !== -1;
const $71b9c13c38b023cf$export$cf7a8de77e0c8209 = ()=>{
    (0, $gKZoD.di)(window);
    return Boolean(// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.indexOf('plans') !== -1 && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.indexOf('scenarios') !== -1 && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.indexOf('/export') !== -1) || // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    Boolean(window?.location.href.indexOf('forceExportMode=1') !== -1);
};
const $71b9c13c38b023cf$export$ad6637fa30ef33ef = ()=>// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    Boolean(window?.location.href.indexOf('startInPreviewMode=1') !== -1);
const $71b9c13c38b023cf$export$2399fb6b8ed70468 = ()=>{
    const params = $71b9c13c38b023cf$export$2c02b58bdf58d1c3();
    const width = parseInt(params.scopeWidth || (0, $TTKUQ.EXPORT_VIEW_DEFAULT_SCOPE_WIDTH), 10);
    return Number.isNaN(width) ? (0, $TTKUQ.EXPORT_VIEW_DEFAULT_SCOPE_WIDTH) : width;
};
const $71b9c13c38b023cf$export$661aa4dfe4b50072 = ()=>{
    const params = $71b9c13c38b023cf$export$2c02b58bdf58d1c3();
    const width = parseInt(params.fieldsWidth || (0, $TTKUQ.EXPORT_VIEW_DEFAULT_FIELDS_WIDTH), 10);
    return Number.isNaN(width) ? (0, $TTKUQ.EXPORT_VIEW_DEFAULT_FIELDS_WIDTH) : width;
};
const $71b9c13c38b023cf$export$9bd1947787a14301 = ()=>$71b9c13c38b023cf$export$2399fb6b8ed70468() + $71b9c13c38b023cf$export$661aa4dfe4b50072();
const $71b9c13c38b023cf$export$fc5fb6d4b5cb9b11 = ()=>{
    const params = $71b9c13c38b023cf$export$2c02b58bdf58d1c3();
    const fromDate = parseInt(params.fromDate || '', 10);
    const toDate = parseInt(params.toDate || '', 10);
    return {
        fromDate: Number.isNaN(fromDate) ? undefined : fromDate,
        toDate: Number.isNaN(toDate) ? undefined : toDate
    };
};
// Firefox has a bad habit of terminating network requests on the unloading page before stopping
// JS execution. As a result fetch throws an error which we don't know what to do with except as
// to show to the user as an error flag and try to log it.
// We workaround it by swallowing any fetch failures if the page started to unload,
// as well as not reporting unhandled exceptions via Flags.
let $71b9c13c38b023cf$var$isPageUnloadingFlag = false;
if (typeof window !== 'undefined') window.addEventListener('beforeunload', ()=>{
    $71b9c13c38b023cf$var$isPageUnloadingFlag = true;
});
const $71b9c13c38b023cf$export$806b710b4d1b901c = ()=>$71b9c13c38b023cf$var$isPageUnloadingFlag;
const $71b9c13c38b023cf$export$c64539b90bced4a = ({ planId: planId, scenarioId: scenarioId, confluenceMacroType: confluenceMacroType })=>{
    const baseUrl = scenarioId != null ? `/jira/plans/${planId}/scenarios/${scenarioId}/` : `/jira/plans/${planId}/`;
    switch(confluenceMacroType){
        case 0, $TTKUQ.DEPENDENCY_REPORT_SHARE_TYPE:
            return `${baseUrl}${$71b9c13c38b023cf$export$aa80e59bd6a86321.DEPENDENCIES_REPORT}`;
        default:
            return `${baseUrl}${$71b9c13c38b023cf$export$aa80e59bd6a86321.ROADMAP}`;
    }
};

});
parcelRegister("TTKUQ", function(module, exports) {

$parcel$export(module.exports, "DefaultDateFormat", () => $5e0415637054ea24$export$14ae725d0cc7daa1);
$parcel$export(module.exports, "EXPORT_FILE_DATE_FORMAT", () => $5e0415637054ea24$export$363270f5bff80927);
$parcel$export(module.exports, "SCENARIO_ISSUE_ID_PREFIX", () => $5e0415637054ea24$export$c8c7cce628cf5c4e);
$parcel$export(module.exports, "DIRECTIONS", () => $5e0415637054ea24$export$4aabe0d20c9c03b3);
$parcel$export(module.exports, "PLANNING_UNITS", () => $5e0415637054ea24$export$c56f9fa2106f4847);
$parcel$export(module.exports, "CROSS_PROJECT_RELEASE", () => $5e0415637054ea24$export$7b04eb9e81ba1c56);
$parcel$export(module.exports, "NONE", () => $5e0415637054ea24$export$c53d0f541b41b88e);
$parcel$export(module.exports, "RELEASE", () => $5e0415637054ea24$export$5c698591c0e586a2);
$parcel$export(module.exports, "ASCENDING", () => $5e0415637054ea24$export$6e386ac144cffab5);
$parcel$export(module.exports, "DEFAULT", () => $5e0415637054ea24$export$e6952b12ade67489);
$parcel$export(module.exports, "LINES", () => $5e0415637054ea24$export$e0de529f548a9140);
$parcel$export(module.exports, "COUNT", () => $5e0415637054ea24$export$d61684373eacdf61);
$parcel$export(module.exports, "ENTITY", () => $5e0415637054ea24$export$fa20de1d199f87ac);
$parcel$export(module.exports, "narrowToEntity", () => $5e0415637054ea24$export$eb963fe6f04e7a9f);
$parcel$export(module.exports, "SCENARIO_TYPE", () => $5e0415637054ea24$export$6952e648aa2551c8);
$parcel$export(module.exports, "GROUPING", () => $5e0415637054ea24$export$a9c30cbc241a4f57);
$parcel$export(module.exports, "STRING", () => $5e0415637054ea24$export$a0e01ba2ebef17f2);
$parcel$export(module.exports, "ISSUE_FIELD_TYPES", () => $5e0415637054ea24$export$a8827164bd516a88);
$parcel$export(module.exports, "SORT_DIRECTION", () => $5e0415637054ea24$export$2e66878530bcbbc7);
$parcel$export(module.exports, "COMPLETED_SPRINTS_GROUP", () => $5e0415637054ea24$export$cc61be5f9aa609ee);
$parcel$export(module.exports, "COMPLETED_RELEASES_GROUP", () => $5e0415637054ea24$export$93d3dc39c0269fe3);
$parcel$export(module.exports, "RELEASE_STATUSES", () => $5e0415637054ea24$export$7082e4b62554b72d);
$parcel$export(module.exports, "RELEASE_STATUSES_APPEARANCE_SPA", () => $5e0415637054ea24$export$311d2f5af921faaa);
$parcel$export(module.exports, "CustomFieldTypes", () => $5e0415637054ea24$export$331c42b4f42400fb);
$parcel$export(module.exports, "CustomFieldTypesToDataType", () => $5e0415637054ea24$export$fea945adb3660cc7);
$parcel$export(module.exports, "CustomFields", () => $5e0415637054ea24$export$a1d1fd7da6e94a65);
$parcel$export(module.exports, "PREVIEW_OPACITY", () => $5e0415637054ea24$export$8ffcc37b9e9dd572);
$parcel$export(module.exports, "ISSUE_STATUS_CATEGORIES_CONST", () => $5e0415637054ea24$export$16f1a8408ee71016);
$parcel$export(module.exports, "ISSUE_STATUS_CATEGORIES", () => $5e0415637054ea24$export$2b1f4448b6b508db);
$parcel$export(module.exports, "ISSUE_STATUS_APPEARANCE", () => $5e0415637054ea24$export$86fc137548f2fce5);
$parcel$export(module.exports, "SPRINT_STATES", () => $5e0415637054ea24$export$73a0206a4dc59760);
$parcel$export(module.exports, "EXTERNAL_SPRINT", () => $5e0415637054ea24$export$f1b6d0605ff9b7e6);
$parcel$export(module.exports, "DEFAULT_FIELD_WIDTH", () => $5e0415637054ea24$export$e5d805200f62f81d);
$parcel$export(module.exports, "SCOPE_ROW_HEIGHT", () => $5e0415637054ea24$export$6edf6d7514b31ffa);
$parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_SCOPE_WIDTH", () => $5e0415637054ea24$export$a705d305be7bd15d);
$parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_FIELDS_WIDTH", () => $5e0415637054ea24$export$9a8b9408dd2830b);
$parcel$export(module.exports, "EXPORT_VIEW_DEFAULT_TIMELINE_WIDTH", () => $5e0415637054ea24$export$4cd768253686885b);
$parcel$export(module.exports, "NUM_ISSUES_IN_EXPORT_PREVIEW", () => $5e0415637054ea24$export$36a3ce28e91ef989);
$parcel$export(module.exports, "AUTO_SCHEDULE_OVERWRITE", () => $5e0415637054ea24$export$de3ef5bf994b7018);
$parcel$export(module.exports, "ISSUE_VALUES", () => $5e0415637054ea24$export$f9c0c7ff9184db0);
$parcel$export(module.exports, "PlanningUnits", () => $5e0415637054ea24$export$448fe702ac76034a);
$parcel$export(module.exports, "UNDEFINED_KEY", () => $5e0415637054ea24$export$75989ea7860b85e9);
$parcel$export(module.exports, "STICKY_HEADER_CONTAINER_PREFIX", () => $5e0415637054ea24$export$6bc4f75201f6f12e);
$parcel$export(module.exports, "CHECKBOX_STATES", () => $5e0415637054ea24$export$e3c19de1b019757c);
$parcel$export(module.exports, "PLUGIN_PERMISSION", () => $5e0415637054ea24$export$3bf3c26d6d69f3b1);
$parcel$export(module.exports, "SHARE_AS", () => $5e0415637054ea24$export$40628b030ac72445);
$parcel$export(module.exports, "SCHEDULE_MODE", () => $5e0415637054ea24$export$5b1b1523594baa6e);
$parcel$export(module.exports, "INSTANCE_USER_ROLE", () => $5e0415637054ea24$export$b4d5766fd1973953);
$parcel$export(module.exports, "PLAN_USER_ROLE", () => $5e0415637054ea24$export$183f45c476faaff2);
$parcel$export(module.exports, "ISSUE_LINK_DIRECTION", () => $5e0415637054ea24$export$deea8c9ae0e3c1ca);
$parcel$export(module.exports, "ISSUE_SOURCE_TYPES", () => $5e0415637054ea24$export$86e2f9653c14c34);
$parcel$export(module.exports, "PERFORMANCE_KEYS", () => $5e0415637054ea24$export$f048d91ccaf92408);
$parcel$export(module.exports, "PROFILE_KEYS", () => $5e0415637054ea24$export$4eb5c0330ef8fab4);
$parcel$export(module.exports, "PACKAGE_NAME", () => $5e0415637054ea24$export$b8b9d90f9e5bd72b);
$parcel$export(module.exports, "ERROR_REPORTING_PACKAGE", () => $5e0415637054ea24$export$f27a837467ec20e5);
$parcel$export(module.exports, "ERROR_REPORTING_TEAM", () => $5e0415637054ea24$export$cfeee2ee86ead336);
$parcel$export(module.exports, "MAX_BULK_CHANGE_ISSUES", () => $5e0415637054ea24$export$bf7af18c7898a31);
$parcel$export(module.exports, "DEPENDENCY_SETTINGS", () => $5e0415637054ea24$export$37e30ab04b9b1705);
$parcel$export(module.exports, "HORIZONTAL_SCROLL_OFFSET", () => $5e0415637054ea24$export$e24665e8d921f93e);
$parcel$export(module.exports, "PROJECT_TYPE_KEY", () => $5e0415637054ea24$export$22ed55708a9d1966);
$parcel$export(module.exports, "ZOOM_LEVELS", () => $5e0415637054ea24$export$8b7222fa92892b49);
$parcel$export(module.exports, "TIMELINE_MODES", () => $5e0415637054ea24$export$bbbec7054427e57b);
$parcel$export(module.exports, "CUSTOM_DATE_RANGES", () => $5e0415637054ea24$export$b0f7807f8d64b44a);
$parcel$export(module.exports, "VALID_LEADING_TIME_FOR_DEPENDENCIES", () => $5e0415637054ea24$export$46a3b4b81e5a44ac);
$parcel$export(module.exports, "NOTIFY_WATCHERS_KEY", () => $5e0415637054ea24$export$954b02519e22ad3c);
$parcel$export(module.exports, "TIMELINE_SHARE_TYPE", () => $5e0415637054ea24$export$cb60c924e8198091);
$parcel$export(module.exports, "DEPENDENCY_REPORT_SHARE_TYPE", () => $5e0415637054ea24$export$16c8656f8d888a96);
$parcel$export(module.exports, "SECTION_KEYS", () => $5e0415637054ea24$export$d37ffa307efd6838);
$parcel$export(module.exports, "SECTION_ITEM_KEYS", () => $5e0415637054ea24$export$cb4feb832f4bb576);
$parcel$export(module.exports, "ORIGINAL_STATUS_TRANSITION", () => $5e0415637054ea24$export$ce125fc0306b71a0);
$parcel$export(module.exports, "BREAKDOWN_SPRINT_CAPACITY_BY", () => $5e0415637054ea24$export$c773c9bd947df9ae);
$parcel$export(module.exports, "IPH_IDS", () => $5e0415637054ea24$export$253194752488840a);
$parcel$export(module.exports, "COMMON_FILTER_OPERATORS", () => $5e0415637054ea24$export$2086c86412edabb8);

var $flnZx = parcelRequire("flnZx");


const $5e0415637054ea24$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
const $5e0415637054ea24$export$1d279fd478aab274 = 'dd/MMM/yy';
const $5e0415637054ea24$export$10b28f765b682c36 = 'yyyy-MM-dd';
const $5e0415637054ea24$export$ce46174a69ff80b3 = 'DD MMM YYYY h:mma';
const $5e0415637054ea24$export$4255b3d650213d61 = 'D MMM';
const $5e0415637054ea24$export$cc2582ada357cd5 = 'D MMM YYYY';
const $5e0415637054ea24$export$363270f5bff80927 = 'DDMMYYYY';
const $5e0415637054ea24$export$c8c7cce628cf5c4e = 'SCEN-';
const $5e0415637054ea24$export$4aabe0d20c9c03b3 = {
    AFTER: 'after',
    BEFORE: 'before'
};
const $5e0415637054ea24$export$c56f9fa2106f4847 = {
    STORY_POINTS: 'StoryPoints',
    DAYS: 'Days',
    HOURS: 'Hours'
};
const $5e0415637054ea24$export$f8f7545d2bb78afb = 'ASSIGNEE';
const $5e0415637054ea24$export$6d7021166edc895c = 'REPORTER';
const $5e0415637054ea24$export$af1e30ebbae9df3b = 'COMPONENT';
const $5e0415637054ea24$export$3d393c30a30490eb = 'GOALS';
const $5e0415637054ea24$export$a75a0417fc96ea63 = 'IDEAS';
const $5e0415637054ea24$export$7b04eb9e81ba1c56 = 'CROSS_PROJECT_RELEASE';
const $5e0415637054ea24$export$76a449e52fa0e1e8 = 'ISSUE';
const $5e0415637054ea24$export$37aee82a3cb1e8f7 = 'LABEL';
const $5e0415637054ea24$export$c53d0f541b41b88e = 'NONE';
const $5e0415637054ea24$export$fe791c4fa892e400 = 'PROJECT';
const $5e0415637054ea24$export$5c698591c0e586a2 = 'RELEASE';
const $5e0415637054ea24$export$84ba8fa7099b85b = 'RESOURCE';
const $5e0415637054ea24$export$bc8b984358922f81 = 'TEAM';
const $5e0415637054ea24$export$c3d7e0f1e63de60e = 'RANK';
const $5e0415637054ea24$export$6e386ac144cffab5 = 'ASCENDING';
const $5e0415637054ea24$export$f634ff5a7f1c8f3 = 'DESCENDING';
const $5e0415637054ea24$export$a316570a0dbfd2b0 = 'SPRINT';
const $5e0415637054ea24$export$3e0a40c59fa4032 = 'PLANNED_CAPACITY';
const $5e0415637054ea24$export$e6952b12ade67489 = 'default';
const $5e0415637054ea24$export$e0de529f548a9140 = 'lines';
const $5e0415637054ea24$export$d61684373eacdf61 = 'count';
const $5e0415637054ea24$export$af9ba62f05a7ca74 = 'FOCUS_AREA';
const $5e0415637054ea24$export$fa20de1d199f87ac = {
    ISSUE: $5e0415637054ea24$export$76a449e52fa0e1e8,
    RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
    CROSS_PROJECT_RELEASE: $5e0415637054ea24$export$7b04eb9e81ba1c56,
    TEAM: $5e0415637054ea24$export$bc8b984358922f81,
    RESOURCE: $5e0415637054ea24$export$84ba8fa7099b85b,
    PLANNED_CAPACITY: $5e0415637054ea24$export$3e0a40c59fa4032,
    SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0,
    NONE: $5e0415637054ea24$export$c53d0f541b41b88e
};
const $5e0415637054ea24$var$allowableEntities = Object.values($5e0415637054ea24$export$fa20de1d199f87ac);
function $5e0415637054ea24$export$eb963fe6f04e7a9f(value) {
    return $5e0415637054ea24$var$allowableEntities.includes(value);
}
const $5e0415637054ea24$export$6952e648aa2551c8 = {
    ADDED: 'ADDED',
    UPDATED: 'UPDATED',
    DELETED: 'DELETED',
    DELETEDFROMJIRA: 'DELETEDFROMJIRA',
    NONE: 'NONE',
    MULTIPLE: 'MULTIPLE',
    EXCLUDED: 'EXCLUDED',
    ADDEDEXISTING: 'ADDEDEXISTING',
    UNKNOWN: 'UNKNOWN'
};
const $5e0415637054ea24$export$a9c30cbc241a4f57 = {
    NONE: $5e0415637054ea24$export$c53d0f541b41b88e,
    ASSIGNEE: $5e0415637054ea24$export$f8f7545d2bb78afb,
    COMPONENT: $5e0415637054ea24$export$af1e30ebbae9df3b,
    GOALS: $5e0415637054ea24$export$3d393c30a30490eb,
    IDEAS: $5e0415637054ea24$export$a75a0417fc96ea63,
    LABEL: $5e0415637054ea24$export$37aee82a3cb1e8f7,
    PROJECT: $5e0415637054ea24$export$fe791c4fa892e400,
    RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
    REPORTER: $5e0415637054ea24$export$6d7021166edc895c,
    TEAM: $5e0415637054ea24$export$bc8b984358922f81,
    SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0,
    FOCUS_AREA: $5e0415637054ea24$export$af9ba62f05a7ca74
};
const $5e0415637054ea24$export$a0e01ba2ebef17f2 = 'string';
const $5e0415637054ea24$export$501a7fac1df67a49 = 'date';
const $5e0415637054ea24$export$4e8bcd47a31d751c = 'number';
const $5e0415637054ea24$export$a8827164bd516a88 = {
    DATE: $5e0415637054ea24$export$501a7fac1df67a49,
    STRING: $5e0415637054ea24$export$a0e01ba2ebef17f2,
    NUMBER: $5e0415637054ea24$export$4e8bcd47a31d751c
};
const $5e0415637054ea24$export$2e66878530bcbbc7 = {
    ASCENDING: $5e0415637054ea24$export$6e386ac144cffab5,
    DESCENDING: $5e0415637054ea24$export$f634ff5a7f1c8f3
};
const $5e0415637054ea24$export$cc61be5f9aa609ee = 'COMPLETED_SPRINTS_GROUP';
const $5e0415637054ea24$export$93d3dc39c0269fe3 = 'COMPLETED_RELEASES_GROUP';
const $5e0415637054ea24$var$UNRELEASED = '0';
const $5e0415637054ea24$var$RELEASED = '1';
const $5e0415637054ea24$var$OFFTRACK = '2';
const $5e0415637054ea24$var$ONTRACK = '3';
const $5e0415637054ea24$export$7082e4b62554b72d = {
    UNRELEASED: $5e0415637054ea24$var$UNRELEASED,
    RELEASED: $5e0415637054ea24$var$RELEASED,
    OFFTRACK: $5e0415637054ea24$var$OFFTRACK,
    ONTRACK: $5e0415637054ea24$var$ONTRACK
};
const $5e0415637054ea24$export$311d2f5af921faaa = {
    [$5e0415637054ea24$var$UNRELEASED]: 'inprogress',
    [$5e0415637054ea24$var$RELEASED]: 'success',
    [$5e0415637054ea24$var$OFFTRACK]: 'removed',
    [$5e0415637054ea24$var$ONTRACK]: 'inprogress'
};
const $5e0415637054ea24$export$331c42b4f42400fb = {
    AssetObject: 'com.atlassian.jira.plugins.cmdb:cmdb-object-cftype',
    TextField: 'com.atlassian.jira.plugin.system.customfieldtypes:textfield',
    SingleSelect: 'com.atlassian.jira.plugin.system.customfieldtypes:select',
    MultiSelect: 'com.atlassian.jira.plugin.system.customfieldtypes:multiselect',
    DatePicker: 'com.atlassian.jira.plugin.system.customfieldtypes:datepicker',
    NumberField: 'com.atlassian.jira.plugin.system.customfieldtypes:float',
    MultiCheckboxes: 'com.atlassian.jira.plugin.system.customfieldtypes:multicheckboxes',
    RadioButtons: 'com.atlassian.jira.plugin.system.customfieldtypes:radiobuttons',
    UserPicker: 'com.atlassian.jira.plugin.system.customfieldtypes:userpicker',
    Url: 'com.atlassian.jira.plugin.system.customfieldtypes:url',
    Labels: 'com.atlassian.jira.plugin.system.customfieldtypes:labels'
};
const $5e0415637054ea24$export$fea945adb3660cc7 = {
    [$5e0415637054ea24$export$331c42b4f42400fb.DatePicker]: $5e0415637054ea24$export$a8827164bd516a88.DATE,
    [$5e0415637054ea24$export$331c42b4f42400fb.NumberField]: $5e0415637054ea24$export$a8827164bd516a88.NUMBER,
    [$5e0415637054ea24$export$331c42b4f42400fb.SingleSelect]: $5e0415637054ea24$export$a8827164bd516a88.STRING
};
const $5e0415637054ea24$export$a1d1fd7da6e94a65 = {
    WritableFields: [
        $5e0415637054ea24$export$331c42b4f42400fb.DatePicker,
        $5e0415637054ea24$export$331c42b4f42400fb.Labels,
        $5e0415637054ea24$export$331c42b4f42400fb.MultiCheckboxes,
        $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
        $5e0415637054ea24$export$331c42b4f42400fb.NumberField,
        $5e0415637054ea24$export$331c42b4f42400fb.RadioButtons,
        $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
        $5e0415637054ea24$export$331c42b4f42400fb.TextField,
        $5e0415637054ea24$export$331c42b4f42400fb.UserPicker
    ],
    ReadOnlyFields: [
        $5e0415637054ea24$export$331c42b4f42400fb.Url,
        $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
    ],
    FilterableFields: [
        $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
        $5e0415637054ea24$export$331c42b4f42400fb.Labels,
        $5e0415637054ea24$export$331c42b4f42400fb.MultiCheckboxes,
        $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
        $5e0415637054ea24$export$331c42b4f42400fb.RadioButtons,
        $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
    ],
    GroupableSingleValueFields: [
        $5e0415637054ea24$export$331c42b4f42400fb.SingleSelect,
        $5e0415637054ea24$export$331c42b4f42400fb.UserPicker
    ],
    GroupableMultiValueFields: [
        $5e0415637054ea24$export$331c42b4f42400fb.Labels,
        $5e0415637054ea24$export$331c42b4f42400fb.MultiSelect,
        $5e0415637054ea24$export$331c42b4f42400fb.AssetObject
    ]
};
const $5e0415637054ea24$export$8ffcc37b9e9dd572 = 0.5;
const $5e0415637054ea24$export$16f1a8408ee71016 = {
    TODO: 2,
    INPROGRESS: 4,
    DONE: 3
};
const $5e0415637054ea24$export$2b1f4448b6b508db = {
    TODO: 2,
    INPROGRESS: 4,
    DONE: 3
};
const $5e0415637054ea24$export$86fc137548f2fce5 = {
    [$5e0415637054ea24$export$2b1f4448b6b508db.TODO]: 'default',
    [$5e0415637054ea24$export$2b1f4448b6b508db.INPROGRESS]: 'inprogress',
    [$5e0415637054ea24$export$2b1f4448b6b508db.DONE]: 'success'
};
const $5e0415637054ea24$export$73a0206a4dc59760 = {
    CLOSED: 'CLOSED',
    ACTIVE: 'ACTIVE',
    FUTURE: 'FUTURE'
};
const $5e0415637054ea24$export$f1b6d0605ff9b7e6 = 'EXTERNAL_SPRINT';
const $5e0415637054ea24$export$8c8dab1ad613072e = 3000;
const $5e0415637054ea24$export$e5d805200f62f81d = {
    SMALL: 64,
    MEDIUM: 128,
    LARGE: 160,
    EXTRALARGE: 240
};
const $5e0415637054ea24$export$6edf6d7514b31ffa = 40;
const $5e0415637054ea24$export$a705d305be7bd15d = 440;
const $5e0415637054ea24$export$9a8b9408dd2830b = 600;
const $5e0415637054ea24$export$4cd768253686885b = 900;
const $5e0415637054ea24$export$36a3ce28e91ef989 = 20;
const $5e0415637054ea24$export$f777897e7e87cb69 = 'ALL_VALUES';
const $5e0415637054ea24$export$2933446418f07e42 = 'EMPTY_VALUES_ONLY';
const $5e0415637054ea24$export$de3ef5bf994b7018 = {
    ALL_VALUES: $5e0415637054ea24$export$f777897e7e87cb69,
    EMPTY_VALUES_ONLY: $5e0415637054ea24$export$2933446418f07e42
};
const $5e0415637054ea24$export$f9c0c7ff9184db0 = {
    SPRINT: $5e0415637054ea24$export$a316570a0dbfd2b0,
    RELEASE: $5e0415637054ea24$export$5c698591c0e586a2,
    TEAM: $5e0415637054ea24$export$bc8b984358922f81
};
const $5e0415637054ea24$export$448fe702ac76034a = {
    storyPoints: 'StoryPoints',
    days: 'Days',
    hours: 'Hours'
};
const $5e0415637054ea24$export$75989ea7860b85e9 = 'UNDEFINED';
const $5e0415637054ea24$export$6bc4f75201f6f12e = 'sticky-header-cell';
const $5e0415637054ea24$export$e3c19de1b019757c = {
    CHECKED: 'checked',
    UNCHECKED: 'unchecked',
    INDETERMINATE: 'indeterminate'
};
const $5e0415637054ea24$export$3bf3c26d6d69f3b1 = {
    VIEWER: 'Viewer',
    FULL_EDITOR: 'FullEditor',
    NON_PUBLISHING_EDITOR: 'NonPublishingEditor'
};
const $5e0415637054ea24$export$40628b030ac72445 = {
    LINK: 'Link',
    EMBED: 'Embed',
    CONFLUENCE: 'Confluence',
    CSV: 'Csv',
    PNG: 'Png',
    DEPENDENCY_REPORT_CONFLUENCE: 'DependencyReportConfluence'
};
const $5e0415637054ea24$export$5b1b1523594baa6e = {
    kanban: 'Kanban',
    scrum: 'Scrum'
};
const $5e0415637054ea24$export$b4d5766fd1973953 = {
    ADMIN: 'Admin',
    EDITOR: 'Editor',
    VIEWER: 'Viewer',
    RESTRICTED_USER: 'Restricted'
};
const $5e0415637054ea24$export$183f45c476faaff2 = {
    EDITOR: 'Editor',
    VIEWER: 'Viewer',
    REPORT_CONSUMER: 'ReportConsumer',
    CONFLUENCE_CONSUMER: 'ConfluenceConsumer'
};
const $5e0415637054ea24$export$deea8c9ae0e3c1ca = {
    OUTWARD: 'outward',
    INWARD: 'inward'
};
const $5e0415637054ea24$export$86e2f9653c14c34 = {
    PROJECT: 'Project',
    BOARD: 'Board',
    FILTER: 'Filter'
};
const $5e0415637054ea24$export$5b6c28c7dca07ad7 = 'portfolio-3';
const $5e0415637054ea24$export$d39436cd641938a9 = 'portfolio-3.create-plan-wizard';
const $5e0415637054ea24$export$f048d91ccaf92408 = {
    COMMIT_CHANGES_TIME_TO_SAVE: 'commit-changes.time-to-save',
    COMMIT_CHANGES_TIME_TO_PERSIST: 'commit-changes.time-to-persist',
    TIME_TO_REVERT_ISSUES: 'commit-changes.time-to-revert-issues',
    RENDER_APP: 'page-plan.render-app',
    EXPORT_PNG: {
        INITIAL_PREVIEW: 'page-plan.export-png.initial-preview',
        SUBSEQUENT_PREVIEW: 'page-plan.export-png.subsequent-preview',
        EXPORT: 'page-plan.export-png.export'
    }
};
const $5e0415637054ea24$export$4eb5c0330ef8fab4 = {
    RENDER: {
        SCOPE_TABLE: 'renderScopeTable'
    },
    EXPORT_PNG: {
        INITIAL_LOAD: 'page-plan.export-png.profile.initial-load',
        REACT_RENDER: 'page-plan.export-png.profile.react-render',
        PREPARE_FOR_EXPORT: 'page-plan.export-png.profile.prepare-for-export',
        CANVAS_RENDER: 'page-plan.export-png.profile.canvas-render'
    }
};
const $5e0415637054ea24$export$b8b9d90f9e5bd72b = 'jiraPortfolio3Portfolio';
const $5e0415637054ea24$export$f27a837467ec20e5 = {
    APP: 'app',
    ROADMAP: 'roadmapTab',
    TEAMS: 'teamsTab',
    RELEASES: 'releasesTab',
    DEPENDENCIES: 'dependenciesTab',
    DEPENDENCIES_KNOWN_ERRORS: 'dependenciesTabKnownErrors',
    SETTINGS: 'settings',
    REDUX: 'redux',
    REDUX_SAGA: 'reduxSaga',
    PLAN_WIZARD: 'planWizard',
    UNHANDLED: 'unhandled',
    ENVIRONMENT: 'environment',
    GIC: 'GIC',
    SUMMARY: 'summaryTab'
};
const $5e0415637054ea24$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $5e0415637054ea24$export$bf7af18c7898a31 = 100;
const $5e0415637054ea24$export$37e30ab04b9b1705 = {
    DEFAULT: $5e0415637054ea24$export$e6952b12ade67489,
    LINES: $5e0415637054ea24$export$e0de529f548a9140,
    COUNT: $5e0415637054ea24$export$d61684373eacdf61
};
const $5e0415637054ea24$export$e24665e8d921f93e = 1e6;
const $5e0415637054ea24$export$22ed55708a9d1966 = {
    SOFTWARE: 'software',
    WORK_MANAGEMENT: 'business',
    SERVICE_MANAGEMENT: 'service_desk',
    PRODUCT_DISCOVERY: 'product_discovery'
};
const $5e0415637054ea24$export$8b7222fa92892b49 = {
    WEEKS: 'weeks',
    MONTHS: 'months',
    QUARTERS: 'quarters',
    YEARS: 'years'
};
const $5e0415637054ea24$export$bbbec7054427e57b = {
    ...$5e0415637054ea24$export$8b7222fa92892b49,
    CUSTOM: 'custom'
};
const $5e0415637054ea24$export$b0f7807f8d64b44a = {
    SMALL: 14,
    MEDIUM: 93,
    LARGE: 364
};
const $5e0415637054ea24$export$46a3b4b81e5a44ac = (0, $flnZx.ONE_DAY);
const $5e0415637054ea24$export$e433769a2e1c823 = 1 / 7 * 100;
const $5e0415637054ea24$export$954b02519e22ad3c = 'jira.user.arj.notify.watchers';
const $5e0415637054ea24$export$cb60c924e8198091 = 'timeline';
const $5e0415637054ea24$export$16c8656f8d888a96 = 'dependency-report';
const $5e0415637054ea24$export$d37ffa307efd6838 = {
    MAIN: 'main-sections',
    FIELD: 'fields-section',
    LIST_MAIN: 'list-main-sections',
    LIST_FIELD: 'list-fields-section'
};
const $5e0415637054ea24$export$cb4feb832f4bb576 = {
    SCOPE: 'scope-column',
    FIELDS: 'fields-column',
    TIMELINE: 'timeline-column'
};
const $5e0415637054ea24$export$ce125fc0306b71a0 = {
    id: '__original_status_transition_id__',
    name: '__original_status_transition_name__'
};
const $5e0415637054ea24$export$c773c9bd947df9ae = {
    STATUS: 'status',
    ESTIMATE: 'estimate'
};
const $5e0415637054ea24$export$253194752488840a = {
    AUTO_SCHEDULE: '72BaKCMhh1aBiQprnER3pL',
    SHARE_CONFLUENCE: '8xdMiPoU4Fr4KWxzGJdXL',
    WARNING_CENTER: '5NX3sX9eqNEXSGhi4cMQ4L',
    SAVED_VIEWS: '636NO7TUPjErcJvohzMo9f',
    MANAGE_SAVED_VIEWS: '59mAhBw1bktXGV50c5c3ax',
    DEPENDENCIES: '2HQv4dgTi14DCpGY1YU2ZF',
    SUMMARY: '2lAziig1qpzuPCelr0CWB3',
    TEAMS: '30yplH4RxkjUZwmNwOxT2k',
    TEAM_CAPACITY: '1iT8GgcEZ2tikuwlnTq8Ij',
    DEPENDENCIES_REPORT: '2N5Dc7LkkoTjytZVPp9PQV',
    ISSUE_SOURCE: '1HTUp4iLEAeRVWDAI6pCaB',
    EXCLUSION_RULES: '2okV00HG5KCXjcw9oxv2kv',
    PERMISSIONS: '2GnX12bqw32MnTSVnDooC',
    CUSTOM_FIELDS: '4S9gFYWDfbdgLwhcZIBOW0',
    SCENARIOS: '4tBiVqshAtrDLFhfcoSEDQ',
    RELEASES: '5YkAr1SYxGsHpkixiYo4Et'
};
const $5e0415637054ea24$export$2086c86412edabb8 = {
    IS: '=',
    ISNOT: '!='
};
const $5e0415637054ea24$export$b72ec9959ddfc0fc = {
    BEFORE: 'before',
    AFTER: 'after',
    BETWEEN: 'between'
};
const $5e0415637054ea24$export$1af2856f066ee3a0 = {
    ...$5e0415637054ea24$export$2086c86412edabb8,
    ...$5e0415637054ea24$export$b72ec9959ddfc0fc
};

});
parcelRegister("flnZx", function(module, exports) {

$parcel$export(module.exports, "ONE_HOUR", () => $baaac68c54c7e711$export$82541edf19e5e3b0);
$parcel$export(module.exports, "ONE_DAY", () => $baaac68c54c7e711$export$a97a1358cbb650ab);
$parcel$export(module.exports, "ONE_WEEK", () => $baaac68c54c7e711$export$8187f416f1cc43d8);
$parcel$export(module.exports, "isISOCompatible", () => $baaac68c54c7e711$export$19585d8c4023da60);
$parcel$export(module.exports, "dateDiffFromUTC", () => $baaac68c54c7e711$export$c0a5d57ff50684cd);
$parcel$export(module.exports, "endOfUtcDay", () => $baaac68c54c7e711$export$28816be40db3c661);
$parcel$export(module.exports, "startOfUtcDay", () => $baaac68c54c7e711$export$5232bbb29ed7bb90);
$parcel$export(module.exports, "startOfUtcWeek", () => $baaac68c54c7e711$export$beda72ac2de463b);
$parcel$export(module.exports, "startOfUtcMonth", () => $baaac68c54c7e711$export$6f42959055abfd71);
$parcel$export(module.exports, "buildStartOfUtcQuarter", () => $baaac68c54c7e711$export$2fc2f60e244962d8);
$parcel$export(module.exports, "buildStartOfUtcYear", () => $baaac68c54c7e711$export$d9d30b5ea3d906ae);
$parcel$export(module.exports, "distanceInWordsWithPolarity", () => $baaac68c54c7e711$export$6c9763c5fdf1d9bf);
$parcel$export(module.exports, "distanceInWordsToNowWithPolarity", () => $baaac68c54c7e711$export$2b43273db3dc8a06);
$parcel$export(module.exports, "endOfUtcWeek", () => $baaac68c54c7e711$export$cd5772ae045b582a);
$parcel$export(module.exports, "endOfUtcMonth", () => $baaac68c54c7e711$export$7eaba70871f25263);
$parcel$export(module.exports, "buildEndOfUtcQuarter", () => $baaac68c54c7e711$export$15d62cfd22087517);
$parcel$export(module.exports, "buildEndOfUtcYear", () => $baaac68c54c7e711$export$ea7270449a050df5);
$parcel$export(module.exports, "getWorkingMillionSecondsBetweenTwoDates", () => $baaac68c54c7e711$export$11174f5b39020529);
$parcel$export(module.exports, "convertShortFormatDate", () => $baaac68c54c7e711$export$51353e55e1015915);
$parcel$export(module.exports, "distanceInWordsByShortFormat", () => $baaac68c54c7e711$export$6fd795612f323dcc);
$parcel$export(module.exports, "getRelativeDates", () => $baaac68c54c7e711$export$f1b9e31b5813ebf9);
$parcel$export(module.exports, "getWeekStartDay", () => $baaac68c54c7e711$export$99291c0265ff1d37);

var $9XE6b = parcelRequire("9XE6b");

var $cRGLB = parcelRequire("cRGLB");

var $gwejS = parcelRequire("gwejS");
var $3DR3e = parcelRequire("3DR3e");
var $16v6W = parcelRequire("16v6W");
var $2kh23 = parcelRequire("2kh23");
var $jNuzB = parcelRequire("jNuzB");
var $2753q = parcelRequire("2753q");
var $pyK8a = parcelRequire("pyK8a");
var $kAAot = parcelRequire("kAAot");
var $4PxOH = parcelRequire("4PxOH");

var $7myQy = parcelRequire("7myQy");

var $1p96B = parcelRequire("1p96B");

var $gh61P = parcelRequire("gh61P");


const $baaac68c54c7e711$export$82541edf19e5e3b0 = 3600000;
const $baaac68c54c7e711$export$a97a1358cbb650ab = 86400000;
const $baaac68c54c7e711$export$8187f416f1cc43d8 = 7 * $baaac68c54c7e711$export$a97a1358cbb650ab;
const $baaac68c54c7e711$export$3ff59674890cae52 = $baaac68c54c7e711$export$a97a1358cbb650ab - 1;
const $baaac68c54c7e711$export$5dddd410b460512a = /^\d{4}-\d{2}-\d{2}\s?/; // YYYY/MM/DD, YYYY/MM/DD GMT+0000
const $baaac68c54c7e711$export$f5b73408663c3e14 = /^\d{2}\/\w{3}\/\d{2}\s?/; // DD/MMM/YY, DD/MMM/YY GMT+0000
const $baaac68c54c7e711$export$63484a545c40ee32 = /^\d{2}\/\w{3}\/\d{4}\s?/; // DD/MMM/YYYY, DD/MMM/YYYY GMT+0000
const $baaac68c54c7e711$export$ce02ba817385328 = (str)=>new Date(`${str} UTC`).getTime();
const $baaac68c54c7e711$export$f7a957134186c558 = (date)=>{
    if ($baaac68c54c7e711$export$5dddd410b460512a.test(date)) {
        const trimmedDate = date.substring(0, 10);
        return new Date(trimmedDate);
    }
    if ($baaac68c54c7e711$export$63484a545c40ee32.test(date)) {
        const trimmedDate = date.substring(0, 11);
        const parsedDate = (0, $2753q.default)(trimmedDate, 'dd/MMM/yyyy', new Date());
        const time = parsedDate.getTime();
        const timeOffset = parsedDate.getTimezoneOffset() * 60000;
        return new Date(time - timeOffset);
    }
    // convert DD/MMM/YY to ISO Date for datepicker
    if ($baaac68c54c7e711$export$f5b73408663c3e14.test(date)) {
        const trimmedDate = date.substring(0, 9);
        const parsedDate = (0, $2753q.default)(trimmedDate, 'dd/MMM/yy', new Date());
        const time = parsedDate.getTime();
        const timeOffset = parsedDate.getTimezoneOffset() * 60000;
        return new Date(time - timeOffset);
    }
    throw new Error(`Non ISO date format provided to create UTC date: ${date}`);
};
const $baaac68c54c7e711$export$19585d8c4023da60 = (date)=>$baaac68c54c7e711$export$f5b73408663c3e14.test(date) || $baaac68c54c7e711$export$5dddd410b460512a.test(date);
const $baaac68c54c7e711$export$c0a5d57ff50684cd = ()=>{
    const now = new Date();
    const tzInHours = -now.getTimezoneOffset() / 60; // Timezone offset is in minutes, time in timezone +10:00 has -600 timezone offset
    const utcHours = (now.getHours() + now.getMinutes() / 60 - tzInHours + 24) % 24;
    if (utcHours + tzInHours > 24) return 1;
    if (utcHours + tzInHours < 0) return -1;
    return 0;
};
const $baaac68c54c7e711$export$28816be40db3c661 = (date)=>new Date($7myQy.default(Number, date) ? date : $baaac68c54c7e711$export$f7a957134186c558(date.toString())).setUTCHours(23, 59, 59, 999);
const $baaac68c54c7e711$export$5232bbb29ed7bb90 = (date)=>new Date($7myQy.default(Number, date) ? date : $baaac68c54c7e711$export$f7a957134186c558(date.toString())).setUTCHours(0, 0, 0, 0);
const $baaac68c54c7e711$export$beda72ac2de463b = (value)=>{
    const startOfDay = $baaac68c54c7e711$export$5232bbb29ed7bb90(new Date(value).getTime());
    const dayOfWeek = new Date(startOfDay).getUTCDay();
    const millisecondsToSubstract = $baaac68c54c7e711$export$a97a1358cbb650ab * dayOfWeek;
    const date = new Date(startOfDay - millisecondsToSubstract);
    const year = date.getUTCFullYear();
    const month = (0, (/*@__PURE__*/$parcel$interopDefault($cRGLB)))(`${date.getUTCMonth() + 1}`, 2, '0'); // Add 1 to compensate for zero-index
    const day = (0, (/*@__PURE__*/$parcel$interopDefault($cRGLB)))(`${date.getUTCDate()}`, 2, '0');
    const startOfWeek = new Date(`${year}-${month}-${day}T00:00:00Z`);
    return startOfWeek;
};
const $baaac68c54c7e711$export$6f42959055abfd71 = (value)=>{
    const date = new Date(value);
    const year = date.getUTCFullYear();
    const month = (0, (/*@__PURE__*/$parcel$interopDefault($cRGLB)))(`${date.getUTCMonth() + 1}`, 2, '0'); // Add 1 to compensate for zero-index
    const startOfMonth = new Date(`${year}-${month}-01T00:00:00Z`);
    return startOfMonth;
};
const $baaac68c54c7e711$export$f8d6d59f9413fa73 = (value)=>{
    const date = new Date(value);
    const year = date.getUTCFullYear();
    const UTCmonth = date.getUTCMonth();
    let month;
    if (UTCmonth >= 0 && UTCmonth <= 2) month = '01';
    else if (UTCmonth >= 3 && UTCmonth <= 5) month = '04';
    else if (UTCmonth >= 6 && UTCmonth <= 8) month = '07';
    else month = '10';
    const startOfQuarter = new Date(`${year}-${month}-01T00:00:00Z`);
    return startOfQuarter;
};
const $baaac68c54c7e711$export$2fc2f60e244962d8 = (fyStartMonth)=>(value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1; // UTC month starts from 0
        const nextFYStartMonth = fyStartMonth + 12;
        let firstMonthOfThisQuarter = nextFYStartMonth;
        // stop when month >= firstMonthOfThisQuarter
        while(month < firstMonthOfThisQuarter)firstMonthOfThisQuarter -= 3;
        const willWrapToPreviousYear = firstMonthOfThisQuarter < 1;
        const dateString = `${willWrapToPreviousYear ? year - 1 : year}-${willWrapToPreviousYear ? 12 + firstMonthOfThisQuarter : `0${firstMonthOfThisQuarter}`.slice(-2)}-01T00:00:00Z`;
        return new Date(dateString);
    };
const $baaac68c54c7e711$export$fea0669370045ef2 = (value)=>{
    const date = new Date(value);
    const startOfYear = new Date(`${date.getUTCFullYear()}-01-01T00:00:00Z`);
    return startOfYear;
};
const $baaac68c54c7e711$export$d9d30b5ea3d906ae = (fyStartMonth)=>(value)=>{
        const date = new Date(value);
        const currentUtcYear = date.getUTCFullYear();
        const currentUtcMonth = date.getUTCMonth() + 1; // zero-based
        return new Date(`${currentUtcYear - (currentUtcMonth >= fyStartMonth ? 0 : 1)}-${`0${fyStartMonth}`.slice(-2)}-01T00:00:00Z`);
    };
const $baaac68c54c7e711$export$55d224f4c8cb5e91 = ()=>{
    if (Date.prototype.__msh_oldSetFullYear) // Need to disable linting and flow because we're overwriting a native method
    /* eslint-disable no-extend-native */ Date.prototype.setFullYear = function setFullYear(...args) {
        const d = new Date(this);
        d.__msh_oldSetFullYear && d.__msh_oldSetFullYear.call(d, ...args);
        if (d.getMonth() !== this.getMonth()) this.setDate(28);
        return this.__msh_oldSetFullYear ? this.__msh_oldSetFullYear.call(this, ...args) : Number.NaN;
    };
};
const $baaac68c54c7e711$export$b767725b8ed07921 = ()=>{
    if (globalThis.document) {
        if (globalThis.document.readyState === 'loading') // This happens in production. JSCal2 is loaded after Portfolio, so we need to execute our fix after DOMContentLoaded
        globalThis.document.addEventListener('DOMContentLoaded', $baaac68c54c7e711$export$55d224f4c8cb5e91);
        else // This happens in in development (i.e. `gulp watch`). JSCal2 is already loaded and DOMContentLoaded has already fired.
        // So we immediately execute the fix.
        $baaac68c54c7e711$export$55d224f4c8cb5e91();
    }
};
$baaac68c54c7e711$export$b767725b8ed07921();
const $baaac68c54c7e711$export$6c9763c5fdf1d9bf = (fromDate, toDate, locale)=>{
    const sign = new Date(fromDate).getTime() < new Date(toDate).getTime() ? '+' : '-';
    const distanceStr = (0, $2kh23.default)(toDate, fromDate, {
        locale: locale !== undefined ? (0, $1p96B.getLocale)(locale) : undefined
    });
    return distanceStr.split(' ').map((str)=>Number.isNaN(Number(str)) ? str : `${sign}${str}`).join(' ');
};
const $baaac68c54c7e711$export$2b43273db3dc8a06 = (locale, date)=>$baaac68c54c7e711$export$6c9763c5fdf1d9bf(Date.now(), date, locale);
const $baaac68c54c7e711$export$cd5772ae045b582a = (value)=>{
    const startOfWeek = $baaac68c54c7e711$export$beda72ac2de463b(value);
    const endOfWeek = startOfWeek.getTime() + 7 * $baaac68c54c7e711$export$a97a1358cbb650ab - 1;
    return new Date(endOfWeek);
};
const $baaac68c54c7e711$export$7eaba70871f25263 = (value)=>{
    const date = new Date(value);
    let year = date.getUTCFullYear();
    let month = date.getUTCMonth();
    month++;
    if (month > 11) {
        month = 0;
        year++;
    }
    const paddedMonth = (0, (/*@__PURE__*/$parcel$interopDefault($cRGLB)))(`${month + 1}`, 2, '0'); // Add 1 to compensate for zero-index
    const firstDayOfNextYear = new Date(`${year}-${paddedMonth}-01T00:00:00.000Z`);
    const endOfYear = new Date(firstDayOfNextYear.getTime() - 1);
    return endOfYear;
};
const $baaac68c54c7e711$export$893511aa1d64d04 = (value)=>{
    const date = new Date(value);
    const year = date.getUTCFullYear();
    const UTCmonth = date.getUTCMonth();
    let month;
    let day = '31';
    if (UTCmonth >= 0 && UTCmonth <= 2) month = '03';
    else if (UTCmonth >= 3 && UTCmonth <= 5) {
        month = '06';
        day = '30';
    } else if (UTCmonth >= 6 && UTCmonth <= 8) {
        month = '09';
        day = '30';
    } else month = '12';
    const lastDayOfQuarter = new Date(`${year}-${month}-${day}T23:59:59.999Z`);
    return lastDayOfQuarter;
};
const $baaac68c54c7e711$export$15d62cfd22087517 = (fyStartMonth)=>(value)=>{
        const date = new Date(value);
        const year = date.getUTCFullYear();
        const month = date.getUTCMonth() + 1; // UTC month starts from 0
        const nextFYStartMonth = fyStartMonth + 12;
        let firstMonthOfThisQuarter = nextFYStartMonth;
        while(month < firstMonthOfThisQuarter)firstMonthOfThisQuarter -= 3;
        const firstMonthOfNextQuarter = firstMonthOfThisQuarter + 3;
        const willWrapToNextYear = firstMonthOfNextQuarter > 12;
        if (willWrapToNextYear) return new Date(new Date(`${year + 1}-0${firstMonthOfNextQuarter % 12}-01T00:00:00Z`).getTime() - 1);
        return new Date(new Date(`${year}-${`0${firstMonthOfNextQuarter}`.slice(-2)}-01T00:00:00Z`).getTime() - 1);
    };
const $baaac68c54c7e711$export$73a64972c33eed9e = (value)=>{
    const date = new Date(value);
    const currentUtcYear = date.getUTCFullYear();
    return new Date(`${currentUtcYear}-12-31T23:59:59.999Z`);
};
const $baaac68c54c7e711$export$ea7270449a050df5 = (fyStartMonth)=>(value)=>{
        const date = new Date(value);
        const currentUtcYear = date.getUTCFullYear();
        const currentUtcMonth = date.getUTCMonth() + 1; // zero-based
        return new Date(new Date(`${currentUtcYear + (currentUtcMonth >= fyStartMonth ? 1 : 0)}-${`0${fyStartMonth}`.slice(-2)}-01T00:00:00Z`).getTime() - 1);
    };
const $baaac68c54c7e711$export$66ad6b2cba030df5 = (startTime, endTime)=>(0, $jNuzB.default)($baaac68c54c7e711$export$beda72ac2de463b(startTime), $baaac68c54c7e711$export$beda72ac2de463b(endTime));
const $baaac68c54c7e711$export$dbbb7786eda0de5f = (value)=>{
    const startTimeOfUtcWeek = $baaac68c54c7e711$export$beda72ac2de463b(value).getTime();
    return {
        start: startTimeOfUtcWeek + $baaac68c54c7e711$export$a97a1358cbb650ab,
        end: startTimeOfUtcWeek + 6 * $baaac68c54c7e711$export$a97a1358cbb650ab
    };
};
const $baaac68c54c7e711$export$11174f5b39020529 = (startTime, endTime)=>{
    const { start: startWorkingTimeOfStartTime, end: endWorkingTimeOfStartTime } = $baaac68c54c7e711$export$dbbb7786eda0de5f(startTime);
    // if the startTime and endTime is in the same week
    if ($baaac68c54c7e711$export$66ad6b2cba030df5(startTime, endTime)) {
        if (endTime < startWorkingTimeOfStartTime || startTime > endWorkingTimeOfStartTime) return 0;
        return Math.min(endWorkingTimeOfStartTime, endTime) - Math.max(startWorkingTimeOfStartTime, startTime);
    }
    const { start: startWorkingTimeOfEndTime, end: endWorkingTimeOfEndTime } = $baaac68c54c7e711$export$dbbb7786eda0de5f(endTime);
    const weeks = Math.floor((startWorkingTimeOfEndTime - endWorkingTimeOfStartTime) / $baaac68c54c7e711$export$8187f416f1cc43d8);
    const workingMillionSecondsOfMiddleWeeks = weeks * (5 * $baaac68c54c7e711$export$a97a1358cbb650ab);
    const workingMillionSecondsOfFirstWeek = startTime > endWorkingTimeOfStartTime ? 0 : endWorkingTimeOfStartTime - Math.max(startTime, startWorkingTimeOfStartTime);
    const workingMillionSecondsOfLastWeek = endTime < startWorkingTimeOfEndTime ? 0 : Math.min(endTime, endWorkingTimeOfEndTime) - startWorkingTimeOfEndTime;
    return workingMillionSecondsOfFirstWeek + workingMillionSecondsOfLastWeek + workingMillionSecondsOfMiddleWeeks;
};
/**
 * Unify the singular and plural english date unit to singular unit. like months -> month, days -> day, years -> year
 * @param unitStr
 * @returns
 */ const $baaac68c54c7e711$var$getUnifiedEnglishDateUnit = (unitStr)=>{
    const regx = /((\w+)(?=s))|([^s]+)/g;
    const resultArr = unitStr.match(regx);
    if (Array.isArray(resultArr) && resultArr.length > 0) return resultArr[0];
    return unitStr;
};
const $baaac68c54c7e711$export$51353e55e1015915 = (number, unit, localeStr)=>new Intl.NumberFormat(localeStr, {
        style: 'unit',
        unit: unit,
        unitDisplay: 'narrow'
    }).format(number);
const $baaac68c54c7e711$export$6fd795612f323dcc = (fromDate, toDate, localeStr)=>{
    const sign = new Date(fromDate).getTime() < new Date(toDate).getTime() ? '+' : '-';
    // step1: get the distanceStr which is only english without locale
    const distanceStr = (0, $2kh23.default)(toDate, fromDate);
    // step2: split to array, the last element of this array is the unit, it can be day/days, 'year/years','month/months'
    const distanceStrArray = distanceStr.split(' ');
    const locale = (0, $1p96B.getLocale)(localeStr);
    if (distanceStrArray.length === 2) {
        // step3: unitfy the english unit day/days->day, 'year/years'->year,'month/months'->month
        const unit = $baaac68c54c7e711$var$getUnifiedEnglishDateUnit(distanceStrArray[1]);
        const number = distanceStrArray[0];
        // step4: callconvertShortFormatDate(Number(number), unit, locale.code) to i18n the dates. English unit is for the  new Intl.NumberFormat method
        return `${sign}${$baaac68c54c7e711$export$51353e55e1015915(Number(number), unit, locale.code)}`;
    }
    if (distanceStrArray.length === 3) {
        // get the localised suffix which can be above/almost/over, refer to https://date-fns.org/v2.30.0/docs/formatDistance
        const suffix = (0, $2kh23.default)(toDate, fromDate, {
            locale: locale
        }).split(' ')[0];
        const number = distanceStrArray[1];
        const unit = $baaac68c54c7e711$var$getUnifiedEnglishDateUnit(distanceStrArray[2]);
        return `${suffix} ${sign}${$baaac68c54c7e711$export$51353e55e1015915(Number(number), unit, locale.code)}`;
    }
    return distanceStr;
};
const $baaac68c54c7e711$export$f1b9e31b5813ebf9 = ({ toNowUnitCount: toNowUnitCount = 0, fromNowUnitCount: fromNowUnitCount = 0, toNowUnit: toNowUnit, fromNowUnit: fromNowUnit }, today)=>{
    const start = toNowUnit === (0, $gh61P.DateUnits).WEEKS ? (0, $4PxOH.default)(today, toNowUnitCount) : (0, $kAAot.default)(today, toNowUnitCount);
    const end = fromNowUnit === (0, $gh61P.DateUnits).WEEKS ? (0, $16v6W.default)(today, fromNowUnitCount) : (0, $3DR3e.default)(today, fromNowUnitCount);
    // relative time range should include current day
    // if relative time range is 0 before the current day amd 0 after the current day
    // then timeline should include at least 1 day
    if (toNowUnitCount === 0 && fromNowUnitCount === 0) return {
        start: $baaac68c54c7e711$export$5232bbb29ed7bb90(start.getTime()),
        end: $baaac68c54c7e711$export$28816be40db3c661(end.getTime())
    };
    // if relative time range is any range before the current day and any range after the current day
    // or only before the current day then add the current day
    if (toNowUnitCount && fromNowUnitCount || toNowUnitCount) return {
        start: $baaac68c54c7e711$export$5232bbb29ed7bb90((0, $gwejS.default)(start, 1).getTime()),
        end: $baaac68c54c7e711$export$28816be40db3c661(end.getTime())
    };
    return {
        start: $baaac68c54c7e711$export$5232bbb29ed7bb90(start.getTime()),
        end: $baaac68c54c7e711$export$28816be40db3c661((0, $pyK8a.default)(end, 1).getTime())
    };
};
const $baaac68c54c7e711$export$99291c0265ff1d37 = (locale)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $1p96B.getLocale)(locale), 'options.weekStartsOn', (0, $gh61P.DEFAULT_WEEK_START_DAY));

});
parcelRegister("cRGLB", function(module, exports) {

var $9tfrR = parcelRequire("9tfrR");

var $ifYxh = parcelRequire("ifYxh");

var $kPZpS = parcelRequire("kPZpS");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */ function $95db9be3f601d040$var$padStart(string, length, chars) {
    string = $jJVtR(string);
    length = $kPZpS(length);
    var strLength = length ? $ifYxh(string) : 0;
    return length && strLength < length ? $9tfrR(length - strLength, chars) + string : string;
}
module.exports = $95db9be3f601d040$var$padStart;

});
parcelRegister("9tfrR", function(module, exports) {

var $kkyYH = parcelRequire("kkyYH");

var $kHBB0 = parcelRequire("kHBB0");

var $gvFfr = parcelRequire("gvFfr");

var $axH2S = parcelRequire("axH2S");

var $ifYxh = parcelRequire("ifYxh");

var $jx6Tp = parcelRequire("jx6Tp");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $6e52ce3a438da7ad$var$nativeCeil = Math.ceil;
/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */ function $6e52ce3a438da7ad$var$createPadding(length, chars) {
    chars = chars === undefined ? ' ' : $kHBB0(chars);
    var charsLength = chars.length;
    if (charsLength < 2) return charsLength ? $kkyYH(chars, length) : chars;
    var result = $kkyYH(chars, $6e52ce3a438da7ad$var$nativeCeil(length / $ifYxh(chars)));
    return $axH2S(chars) ? $gvFfr($jx6Tp(result), 0, length).join('') : result.slice(0, length);
}
module.exports = $6e52ce3a438da7ad$var$createPadding;

});
parcelRegister("kkyYH", function(module, exports) {
/** Used as references for various `Number` constants. */ var $ecd0ced035e30e58$var$MAX_SAFE_INTEGER = 9007199254740991;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $ecd0ced035e30e58$var$nativeFloor = Math.floor;
/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */ function $ecd0ced035e30e58$var$baseRepeat(string, n) {
    var result = '';
    if (!string || n < 1 || n > $ecd0ced035e30e58$var$MAX_SAFE_INTEGER) return result;
    // Leverage the exponentiation by squaring algorithm for a faster repeat.
    // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
    do {
        if (n % 2) result += string;
        n = $ecd0ced035e30e58$var$nativeFloor(n / 2);
        if (n) string += string;
    }while (n);
    return result;
}
module.exports = $ecd0ced035e30e58$var$baseRepeat;

});



parcelRegister("7myQy", function(module, exports) {

$parcel$export(module.exports, "default", () => $55c59e4aaf37a546$export$2e2bcd8739ae039);

var $c9RLn = parcelRequire("c9RLn");
/**
 * See if an object (`val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */ var $55c59e4aaf37a546$var$is = /*#__PURE__*/ (0, $c9RLn.default)(function is(Ctor, val) {
    return val != null && val.constructor === Ctor || val instanceof Ctor;
});
var $55c59e4aaf37a546$export$2e2bcd8739ae039 = $55c59e4aaf37a546$var$is;

});

parcelRegister("gh61P", function(module, exports) {

$parcel$export(module.exports, "longDateFormat", () => $874bf1b243ba3957$export$7bc415832e79e22c);
$parcel$export(module.exports, "dateMonthFormat", () => $874bf1b243ba3957$export$f9c3f52e4a5f8635);
$parcel$export(module.exports, "longDateTimeFormat", () => $874bf1b243ba3957$export$f2f390060309965);
$parcel$export(module.exports, "shortDateFormat", () => $874bf1b243ba3957$export$1a445e44d9863af);
$parcel$export(module.exports, "weekdayFormat", () => $874bf1b243ba3957$export$faf60e60fca9bed1);
$parcel$export(module.exports, "weekdayFormatLong", () => $874bf1b243ba3957$export$a28e4d9035dd351c);
$parcel$export(module.exports, "DateUnits", () => $874bf1b243ba3957$export$c7e7da0fa6bb60a7);
$parcel$export(module.exports, "DATE_UNIT_MAX_VALUES", () => $874bf1b243ba3957$export$637d8b0948b783c7);
$parcel$export(module.exports, "CUSTOM_TIME_RANGE_TYPES", () => $874bf1b243ba3957$export$78e07fecfaf51c7b);
$parcel$export(module.exports, "DefaultDateFormat", () => $874bf1b243ba3957$export$14ae725d0cc7daa1);
$parcel$export(module.exports, "IsoDateFormat", () => $874bf1b243ba3957$export$7288711b5316ff78);
$parcel$export(module.exports, "DEFAULT_WEEK_START_DAY", () => $874bf1b243ba3957$export$845e1054649a85c2);
/**
 * UTC Long format of a date, eg "13 Jul 2023"
 */ const $874bf1b243ba3957$export$7bc415832e79e22c = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$f9c3f52e4a5f8635 = {
    day: '2-digit',
    month: 'short',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$352fb2bc78f82ff2 = {
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$f2f390060309965 = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$1a445e44d9863af = {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$faf60e60fca9bed1 = {
    weekday: 'short',
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$a28e4d9035dd351c = {
    weekday: 'long',
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    timeZone: 'UTC'
};
const $874bf1b243ba3957$export$c7e7da0fa6bb60a7 = {
    DAYS: 'days',
    MONTHS: 'months',
    WEEKS: 'weeks'
};
const $874bf1b243ba3957$export$637d8b0948b783c7 = {
    [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.DAYS]: 3650,
    [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.WEEKS]: 520,
    [$874bf1b243ba3957$export$c7e7da0fa6bb60a7.MONTHS]: 120
};
const $874bf1b243ba3957$export$78e07fecfaf51c7b = {
    FIXED: 'fixed',
    RELATIVE: 'relative'
};
const $874bf1b243ba3957$export$14ae725d0cc7daa1 = 'DD/MMM/YY';
const $874bf1b243ba3957$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $874bf1b243ba3957$export$845e1054649a85c2 = 0; // Sunday

});





parcelRegister("9mZ55", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd5b89c0c726ee75$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cd5b89c0c726ee75$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    originalTransitionStatusName: {
        "id": "portfolio-3-plan-issue-status.ui.original-transition-status-name",
        "defaultMessage": "Transition to"
    }
});

});

parcelRegister("gVXyD", function(module, exports) {

$parcel$export(module.exports, "getFilteredOrderedTransitions", () => $293a8a105e0fe616$export$707115549202b9e4);
$parcel$export(module.exports, "removeTransitionsToCurrentAndOriginalStatus", () => $293a8a105e0fe616$export$91fa646e6c6bbddf);
$parcel$export(module.exports, "addOriginalTransitions", () => $293a8a105e0fe616$export$bfbef01cd993b505);

var $4nDwW = parcelRequire("4nDwW");

var $dGANR = parcelRequire("dGANR");
const $293a8a105e0fe616$var$isGlobalSelfTransition = (transition, currentStatusId)=>transition.isGlobal && transition.to.id === currentStatusId;
const $293a8a105e0fe616$var$isInitialSelfTransition = (transition, currentStatusId)=>transition.isInitial && transition.to.id === currentStatusId;
const $293a8a105e0fe616$var$isLoopedTransitionToSelf = (transition, currentStatusId)=>transition.to.id === currentStatusId && transition.isLooped === true;
const $293a8a105e0fe616$var$filterLoopedTransitionsToSelf = (transitions, currentStatusId)=>transitions.filter((transition)=>!$293a8a105e0fe616$var$isLoopedTransitionToSelf(transition, currentStatusId) && !$293a8a105e0fe616$var$isGlobalSelfTransition(transition, currentStatusId) && !$293a8a105e0fe616$var$isInitialSelfTransition(transition, currentStatusId));
const $293a8a105e0fe616$export$707115549202b9e4 = (transitions = [], currentStatusId)=>{
    if (currentStatusId) // filter out the transition without target status or the statusCategory of target status is null and
    // filter out looped invalid transitions
    return $293a8a105e0fe616$var$filterLoopedTransitionsToSelf(transitions.filter((transition)=>!!transition.to && !!transition.to.statusCategory) || [], currentStatusId);
    return transitions || [];
};
const $293a8a105e0fe616$export$91fa646e6c6bbddf = (issue, serverTransitions, issueStatusesById)=>{
    const isCurrentIssueStatusExisted = (0, $4nDwW.isDefined)(issue.statusId) && (0, $4nDwW.isDefined)(issueStatusesById[issue.statusId]);
    const isOriginalIssueStatusExisted = (0, $4nDwW.isDefined)(issue.originalStatusId) && (0, $4nDwW.isDefined)(issueStatusesById[issue.originalStatusId]);
    if (isOriginalIssueStatusExisted || isCurrentIssueStatusExisted) {
        const result = serverTransitions.filter((transition)=>transition.to.id !== issue.statusId && transition.to.id !== issue.originalStatusId);
        return result;
    }
    return serverTransitions;
};
const $293a8a105e0fe616$export$bfbef01cd993b505 = (issue, serverTransitions, issueStatusesById, originalTransitionName)=>{
    if ((0, $4nDwW.isDefined)(issue.originalStatusId) && (0, $4nDwW.isDefined)(issueStatusesById[issue.originalStatusId])) {
        const originalTransition = {
            id: (0, $dGANR.ORIGINAL_STATUS_TRANSITION).id,
            isConditional: false,
            isGlobal: true,
            isInitial: false,
            hasScreen: false,
            name: originalTransitionName,
            to: {
                id: issue.originalStatusId,
                name: issueStatusesById[issue.originalStatusId].name,
                statusCategory: {
                    id: issueStatusesById[issue.originalStatusId].categoryId
                }
            }
        };
        return serverTransitions.concat(originalTransition);
    }
    return serverTransitions;
};

});
parcelRegister("4nDwW", function(module, exports) {

$parcel$export(module.exports, "chain", () => $9335a76542a4a558$export$e08e3b67e392101e);
$parcel$export(module.exports, "fromPairs", () => $9335a76542a4a558$export$8995636b7242f090);
$parcel$export(module.exports, "values", () => $9335a76542a4a558$export$68c286be0e7e55b7);
$parcel$export(module.exports, "groupBy", () => $9335a76542a4a558$export$3f063810d7bf01bd);
$parcel$export(module.exports, "indexBy", () => $9335a76542a4a558$export$e620e98009814b79);
$parcel$export(module.exports, "sortWith", () => $9335a76542a4a558$export$a9e7d1a6fdcfefde);
$parcel$export(module.exports, "ascend", () => $9335a76542a4a558$export$417c3e637c1bc965);
$parcel$export(module.exports, "descend", () => $9335a76542a4a558$export$748246bdd9c122ea);
$parcel$export(module.exports, "isDefined", () => $9335a76542a4a558$export$4e62c701997796c1);
$parcel$export(module.exports, "filterDefined", () => $9335a76542a4a558$export$68250b7674019b05);
$parcel$export(module.exports, "filterMap", () => $9335a76542a4a558$export$a04c6c6965dd4709);
$parcel$export(module.exports, "valuesLength", () => $9335a76542a4a558$export$745491ed4818e2e8);
$parcel$export(module.exports, "valuesKeysLength", () => $9335a76542a4a558$export$44e3e1a05911fec9);
$parcel$export(module.exports, "mapValues", () => $9335a76542a4a558$export$825e789796ab7275);
$parcel$export(module.exports, "pickBy", () => $9335a76542a4a558$export$b460b275d6c6aa0);
$parcel$export(module.exports, "pluck", () => $9335a76542a4a558$export$c44985b87d605eff);
$parcel$export(module.exports, "mapObject", () => $9335a76542a4a558$export$d6051a0f7a227332);
$parcel$export(module.exports, "move", () => $9335a76542a4a558$export$d947e5f4f4c48d48);
$parcel$export(module.exports, "mapGroupsToIds", () => $9335a76542a4a558$export$28674149d4fdfa90);
$parcel$export(module.exports, "mergeDeepLeft", () => $9335a76542a4a558$export$2b6ce6ba81025b39);
// This module contains counterparts to Ramda functions missing/ill-typed in flow-typed
// It's okay if they are less generic (non-curried, work only over array etc.)

var $gOcYF = parcelRequire("gOcYF");
var $2rMKg = parcelRequire("2rMKg");
function $9335a76542a4a558$export$e08e3b67e392101e(callback, array) {
    const result = [];
    for (const elements of array.map(callback))Array.prototype.push.apply(result, elements);
    return result;
}
function $9335a76542a4a558$export$8995636b7242f090(pairs) {
    const result = {};
    for (const [k, v] of pairs)result[k] = v;
    return result;
}
const $9335a76542a4a558$export$68c286be0e7e55b7 = (object)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    Object.values(object);
function $9335a76542a4a558$export$3f063810d7bf01bd(keyFn, array) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const element of array){
        const key = keyFn(element);
        if (!result[key]) result[key] = [];
        result[key].push(element);
    }
    return result;
}
function $9335a76542a4a558$export$e620e98009814b79(keyFn, array) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const result = {};
    for (const element of array){
        const key = keyFn(element);
        result[key] = element;
    }
    return result;
}
function $9335a76542a4a558$export$a9e7d1a6fdcfefde(comparators) {
    return (array)=>[
            ...array
        ].sort((a, b)=>{
            let comparison = 0;
            for (const comparator of comparators){
                comparison = comparator(a, b);
                if (comparison !== 0) return comparison;
            }
            return comparison;
        });
}
function $9335a76542a4a558$export$417c3e637c1bc965(keyFn) {
    return (a, b)=>{
        const keyA = keyFn(a);
        const keyB = keyFn(b);
        if (typeof keyA === 'number' && typeof keyB === 'number') {
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        }
        if (typeof keyA === 'string' && typeof keyB === 'string') {
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        }
        throw new Error('keyFn must return number or string consistently');
    };
}
function $9335a76542a4a558$export$748246bdd9c122ea(keyFn) {
    return (a, b)=>{
        const keyA = keyFn(a);
        const keyB = keyFn(b);
        if (typeof keyA === 'number' && typeof keyB === 'number') {
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
        }
        if (typeof keyA === 'string' && typeof keyB === 'string') {
            if (keyA > keyB) return -1;
            if (keyA < keyB) return 1;
            return 0;
        }
        throw new Error('keyFn must return number or string consistently');
    };
}
function $9335a76542a4a558$export$448332262467e042(array) {
    let counter = array.length;
    const result = [
        ...array
    ];
    while(counter > 0){
        const index = Math.floor(Math.random() * counter);
        counter -= 1;
        const temp = result[counter];
        result[counter] = result[index];
        result[index] = temp;
    }
    return result;
}
function $9335a76542a4a558$export$66c1ae025e96b4bc(array) {
    const reversed = [];
    for(let i = array.length - 1; i >= 0; i -= 1)reversed.push(array[i]);
    return reversed;
}
function $9335a76542a4a558$export$4e62c701997796c1(thing) {
    return thing !== undefined && thing !== null;
}
function $9335a76542a4a558$export$68250b7674019b05(array) {
    const filtered = [];
    for (const e of array)if ($9335a76542a4a558$export$4e62c701997796c1(e)) filtered.push(e);
    return filtered;
}
function $9335a76542a4a558$export$a04c6c6965dd4709(filter, map, array) {
    const result = [];
    for(let i = 0; i < array.length; i++){
        const element = array[i];
        if (filter(element)) result.push(map(element, i));
    }
    return result;
}
function $9335a76542a4a558$export$745491ed4818e2e8(object) {
    let result = 0;
    for (const array of Object.values(object))result += array.length;
    return result;
}
function $9335a76542a4a558$export$44e3e1a05911fec9(object) {
    let result = 0;
    for (const child of Object.values(object))result += Object.keys(child).length;
    return result;
}
function $9335a76542a4a558$export$825e789796ab7275(f, object) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const k of Object.keys(object))// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    result[k] = object[k].map(f);
    return result;
}
function $9335a76542a4a558$export$b460b275d6c6aa0(// eslint-disable-next-line @typescript-eslint/no-explicit-any
f, obj) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return Object.entries(obj).reduce((acc, [key, value])=>{
        if (f(value, key)) {
            acc[key] = value;
            return acc;
        }
        return acc;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    }, {});
}
function $9335a76542a4a558$export$c44985b87d605eff(prop, array) {
    return array.map((x)=>x[prop]);
}
function $9335a76542a4a558$export$d6051a0f7a227332(f, object) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const result = {};
    for (const k of Object.keys(object))result[k] = f(k, object[k]);
    return result;
}
function $9335a76542a4a558$export$d947e5f4f4c48d48(fromIndex, toIndex, array) {
    return $gOcYF.default(fromIndex, toIndex, array);
}
function $9335a76542a4a558$export$28674149d4fdfa90(object) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return $9335a76542a4a558$export$825e789796ab7275($2rMKg.default('id'), object);
}
function $9335a76542a4a558$var$isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}
function $9335a76542a4a558$export$2b6ce6ba81025b39(left, right) {
    const result = {
        ...right
    };
    for (const [key, leftValue] of Object.entries(left)){
        const rightValue = result[key];
        result[key] = $9335a76542a4a558$var$isObject(leftValue) && $9335a76542a4a558$var$isObject(rightValue) ? $9335a76542a4a558$export$2b6ce6ba81025b39(leftValue, rightValue) : leftValue;
    }
    return result;
}

});
parcelRegister("gOcYF", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3cb61e65a9bbbf5$export$2e2bcd8739ae039);

var $IYMZh = parcelRequire("IYMZh");
/**
 * Move an item, at index `from`, to index `to`, in a list of elements.
 * A new list will be created containing the new elements order.
 *
 * @func
 * @memberOf R
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @param {Number} from The source index
 * @param {Number} to The destination index
 * @param {Array} list The list which will serve to realise the move
 * @return {Array} The new list reordered
 * @example
 *
 *      R.move(0, 2, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['b', 'c', 'a', 'd', 'e', 'f']
 *      R.move(-1, 0, ['a', 'b', 'c', 'd', 'e', 'f']); //=> ['f', 'a', 'b', 'c', 'd', 'e'] list rotation
 */ var $c3cb61e65a9bbbf5$var$move = /*#__PURE__*/ (0, $IYMZh.default)(function(from, to, list) {
    var length = list.length;
    var result = list.slice();
    var positiveFrom = from < 0 ? length + from : from;
    var positiveTo = to < 0 ? length + to : to;
    var item = result.splice(positiveFrom, 1);
    return positiveFrom < 0 || positiveFrom >= list.length || positiveTo < 0 || positiveTo >= list.length ? list : [].concat(result.slice(0, positiveTo)).concat(item).concat(result.slice(positiveTo, list.length));
});
var $c3cb61e65a9bbbf5$export$2e2bcd8739ae039 = $c3cb61e65a9bbbf5$var$move;

});
parcelRegister("IYMZh", function(module, exports) {

$parcel$export(module.exports, "default", () => $087343a0f2c6357f$export$2e2bcd8739ae039);

var $ccUYa = parcelRequire("ccUYa");

var $c9RLn = parcelRequire("c9RLn");

var $iU24A = parcelRequire("iU24A");
function $087343a0f2c6357f$export$2e2bcd8739ae039(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return (0, $iU24A.default)(a) ? f3 : (0, $c9RLn.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return (0, $iU24A.default)(a) && (0, $iU24A.default)(b) ? f3 : (0, $iU24A.default)(a) ? (0, $c9RLn.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $iU24A.default)(b) ? (0, $c9RLn.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $ccUYa.default)(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return (0, $iU24A.default)(a) && (0, $iU24A.default)(b) && (0, $iU24A.default)(c) ? f3 : (0, $iU24A.default)(a) && (0, $iU24A.default)(b) ? (0, $c9RLn.default)(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : (0, $iU24A.default)(a) && (0, $iU24A.default)(c) ? (0, $c9RLn.default)(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : (0, $iU24A.default)(b) && (0, $iU24A.default)(c) ? (0, $c9RLn.default)(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : (0, $iU24A.default)(a) ? (0, $ccUYa.default)(function(_a) {
                    return fn(_a, b, c);
                }) : (0, $iU24A.default)(b) ? (0, $ccUYa.default)(function(_b) {
                    return fn(a, _b, c);
                }) : (0, $iU24A.default)(c) ? (0, $ccUYa.default)(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}

});


parcelRegister("2rMKg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c83ea276f4e80cb$export$2e2bcd8739ae039);

var $c9RLn = parcelRequire("c9RLn");

var $fZhYM = parcelRequire("fZhYM");
/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig s -> {s: a} -> a | Undefined
 * @param {String} p The property name
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */ var $1c83ea276f4e80cb$var$prop = /*#__PURE__*/ (0, $c9RLn.default)(function prop(p, obj) {
    return (0, $fZhYM.default)([
        p
    ], obj);
});
var $1c83ea276f4e80cb$export$2e2bcd8739ae039 = $1c83ea276f4e80cb$var$prop;

});
parcelRegister("fZhYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ba3a7fdd4184b2df$export$2e2bcd8739ae039);

var $c9RLn = parcelRequire("c9RLn");
/**
 * Retrieve the value at a given path.
 *
 * @func
 * @memberOf R
 * @since v0.2.0
 * @category Object
 * @typedefn Idx = String | Int
 * @sig [Idx] -> {a} -> a | Undefined
 * @param {Array} path The path to use.
 * @param {Object} obj The object to retrieve the nested property from.
 * @return {*} The data at `path`.
 * @see R.prop
 * @example
 *
 *      R.path(['a', 'b'], {a: {b: 2}}); //=> 2
 *      R.path(['a', 'b'], {c: {b: 2}}); //=> undefined
 */ var $ba3a7fdd4184b2df$var$path = /*#__PURE__*/ (0, $c9RLn.default)(function path(paths, obj) {
    var val = obj;
    var idx = 0;
    while(idx < paths.length){
        if (val == null) return;
        val = val[paths[idx]];
        idx += 1;
    }
    return val;
});
var $ba3a7fdd4184b2df$export$2e2bcd8739ae039 = $ba3a7fdd4184b2df$var$path;

});






parcelRegister("bkAe8", function(module, exports) {

$parcel$export(module.exports, "isIssueStatusDone", () => $636539b78583f90c$export$2dc0f9bdc08016b6);

var $gULOk = parcelRequire("gULOk");
const $636539b78583f90c$export$2dc0f9bdc08016b6 = (statusCategoryId)=>{
    const doneStatusCategoryId = (0, $gULOk).StatusCategoryIds[(0, $gULOk).StatusCategoryTypes.DONE];
    return doneStatusCategoryId && doneStatusCategoryId === statusCategoryId;
};

});


parcelRegister("2Gmm7", function(module, exports) {

$parcel$export(module.exports, "StoryPointField", () => $9ab8262f440c5e30$export$879127080cbdde1d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $hGgHi = parcelRequire("hGgHi");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8ikZj = parcelRequire("8ikZj");

var $54wEF = parcelRequire("54wEF");

var $4AyyJ = parcelRequire("4AyyJ");

var $4dw4p = parcelRequire("4dw4p");

var $5fc53 = parcelRequire("5fc53");

var $4jAPy = parcelRequire("4jAPy");

var $7hE3x = parcelRequire("7hE3x");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $gBj4V = parcelRequire("gBj4V");

var $l8ruj = parcelRequire("l8ruj");

var $3l5XM = parcelRequire("3l5XM");

var $oOIFP = parcelRequire("oOIFP");

var $eGVUJ = parcelRequire("eGVUJ");

var $6HPvp = parcelRequire("6HPvp");

var $6wLTf = parcelRequire("6wLTf");


var $evkwq = parcelRequire("evkwq");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

var $bSSdD = parcelRequire("bSSdD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $2f454 = parcelRequire("2f454");


var $jiQZW = parcelRequire("jiQZW");
const $9ab8262f440c5e30$var$stopPropagation = (e)=>e.stopPropagation();
const $9ab8262f440c5e30$var$fieldKey = 'storyPoints';
const $9ab8262f440c5e30$var$StoryPointFieldInner = ({ issueId: issueId, issueKey: issueKey, storyPointFieldId: storyPointFieldId, estimate: estimate, onFailure: onFailure, dialogPlacement: dialogPlacement, showTooltip: showTooltip, tooltipMessage: tooltipMessage, editInputLabel: editInputLabel, ...props })=>{
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const timeTrackingOptions = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.getTimeTrackingOptions)(state));
    const planningUnit = (0, $67sX6.useBoardSelector)((state)=>(0, $67Z81.getPlanningUnit)(state));
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    const storyPointKey = storyPointFieldId || '';
    const { fireInvalidFieldConfigError: fireInvalidFieldConfigError } = (0, $6HPvp.useFireInvalidFieldConfigError)();
    const onFailureFireError = (0, $5uXOq.useCallback)((error)=>{
        onFailure?.();
        fireInvalidFieldConfigError(error);
    }, [
        fireInvalidFieldConfigError,
        onFailure
    ]);
    const onEdit = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('estimate', issueId, true));
    }, [
        dispatch,
        issueId
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.setInlineEditing)('estimate', issueId, false));
    }, [
        dispatch,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            isInlineEditing: true,
            fieldKey: $9ab8262f440c5e30$var$fieldKey,
            fieldType: 'number',
            origin: 'issueCard'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ab8262f440c5e30$var$StorypointsEstimateWrapper, {
        "data-testid": (0, $189f09162dc8d67b$export$c872a8f05adaccec),
        onClick: $9ab8262f440c5e30$var$stopPropagation,
        onKeyDown: $9ab8262f440c5e30$var$stopPropagation,
        hasValue: !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(estimate),
        disableClick: preventInlineEditing,
        isIncrementPlanningBoard: isIncrementPlanningBoard
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4AyyJ.AsyncLazyNumberFieldInlineEdit), {
        editButtonLabel: formatMessage((0, $jiQZW.default).editButtonLabel, {
            storyPoints: estimate
        }),
        ...(0, $4R6GH.fg)('one_event_rules_them_all_fg') && {
            componentAnalyticsData: {
                fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STORY_POINTS_TYPE],
                isInlineEditing: true
            }
        },
        ...props,
        actionSubject: "inlineEdit",
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        fieldKey: storyPointKey,
        analyticsFieldKeyAlias: "storyPoints",
        onFailure: onFailureFireError,
        dialogPlacement: dialogPlacement,
        showTooltip: showTooltip,
        tooltipMessage: tooltipMessage,
        label: editInputLabel,
        ...(0, $4R6GH.fg)('render_program_board_card_in_popup') ? {
            onEdit: onEdit,
            onConfirm: onClose,
            onCancel: onClose,
            onEscape: onClose
        } : {},
        ...isIncrementPlanningBoard && {
            min: 0,
            saveField: async (_, fieldId, fieldValue)=>{
                const getFieldValue = ()=>{
                    if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldValue) || fieldValue === '') return fieldValue;
                    if (planningUnit === (0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT)) return Number(fieldValue) * (0, $gBj4V.SECONDS_PER_HOUR);
                    if (planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT)) {
                        const workingHoursPerDay = (0, $6wLTf.timeTrackingConfigTransformer)(timeTrackingOptions).hoursPerDay || (0, $gBj4V.defaultTimeTrackingOptions).workingHoursPerDay;
                        return Number(fieldValue) * workingHoursPerDay * (0, $gBj4V.SECONDS_PER_HOUR);
                    }
                    return fieldValue;
                };
                dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
                    issueId: issueId,
                    fieldId: fieldId,
                    fieldValue: getFieldValue()
                })); // to make ts happy
                return undefined;
            }
        }
    })));
};
const $9ab8262f440c5e30$export$879127080cbdde1d = ({ shouldRenderRichField: shouldRenderRichField, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const storyPointKey = props.storyPointFieldId || '';
    const [{ value: storyPointFieldConfig }] = (0, $54wEF.useFieldConfigWithoutRefetch)(props.issueKey, storyPointKey);
    const shouldRenderRich = Boolean(shouldRenderRichField && storyPointFieldConfig);
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const issueParents = (0, $67sX6.useBoardSelector)((state)=>(0, $bSSdD.issueParentIdsSelector)(state));
    const isIssueParent = !!issueParents && issueParents.includes(`${props.issueId}`); // remove this check condition and body when cleaning up FG program_board_misc_improvements
    if (isIncrementPlanningBoard && isIssueParent && !(0, $4R6GH.fg)('program_board_misc_improvements')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hE3x.default), {
        value: props.estimate,
        workType: props.workType
    });
    const fallback = props.estimate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3l5XM.EstimateFieldStatic), {
        value: props.estimate
    }) : null;
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4dw4p.NumberInlineEditErrorBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback,
        onError: editableField.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.story-point-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9ab8262f440c5e30$var$StoryPointFieldInner, {
        ...props,
        ...editableField,
        showTooltip: (0, $4R6GH.fg)('program_board_misc_improvements') ? isIncrementPlanningBoard && isIssueParent : false,
        tooltipMessage: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $jiQZW.default).tooltipForEpicEstimateIssueTermRefresh : (0, $jiQZW.default).tooltipForEpicEstimate),
        editInputLabel: formatMessage((0, $jiQZW.default).ariaLabel)
    })));
    return fallback;
}; // prevents warning for usage of style composition - can be removed when https://product-fabric.atlassian.net/browse/APP-728 is done.
const $9ab8262f440c5e30$var$CompiledPropsForwarder = ({ disableClick: disableClick, isIncrementPlanningBoard: isIncrementPlanningBoard, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $oOIFP.EstimateWrapper), rest); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9ab8262f440c5e30$var$StorypointsEstimateWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $9ab8262f440c5e30$var$CompiledPropsForwarder, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h _gx371q9c _1bt61i6y _1bb7idpf _wv4j6up6 _1nf9idpf _gs1n11wp",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.isIncrementPlanningBoard && "_rhradabe",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4AyyJ", function(module, exports) {

$parcel$export(module.exports, "AsyncLazyNumberFieldInlineEdit", () => $48549bb820c37e94$export$914a596381b1e227);

var $kxZPA = parcelRequire("kxZPA");

const $48549bb820c37e94$export$914a596381b1e227 = (0, $kxZPA.lazy)(()=>(parcelRequire("idDsA")), {
    moduleId: "./src/packages/issue/fields/number-inline-edit/inline-edit/src/ui/index.tsx"
});

});
parcelRegister("idDsA", function(module, exports) {

let $d4380cdb7016b8f5$var$load = (parcelRequire("28QjX"))(4);
module.exports = $d4380cdb7016b8f5$var$load("l0olp").then(()=>parcelRequire('8gjIO'));

});


parcelRegister("4dw4p", function(module, exports) {

$parcel$export(module.exports, "NumberInlineEditErrorBoundary", () => $5c0f4f3a40f5e6b4$export$3e0d6107a3584b0b);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");
const $5c0f4f3a40f5e6b4$export$3e0d6107a3584b0b = ({ fallback: fallback, children: children, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "number-inline-edit",
        packageName: packageName,
        teamName: "bento",
        fallback: "flag",
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "number-inline-edit-error-boundary",
        fallback: fallback
    }, children));

});

parcelRegister("7hE3x", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf3f95453cbc0dbe$export$2e2bcd8739ae039);
// remove this whole component and corresponding folder when clean up the fg program_board_misc_improvements

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $MHKc7 = parcelRequire("MHKc7");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");


var $5KKS9 = parcelRequire("5KKS9");
const $cf3f95453cbc0dbe$var$EpicStoryPoint = ({ value: value, workType: workType })=>{
    const { formatMessage: formatMessage, formatNumber: formatNumber } = (0, $koVbs.default)();
    if (value === undefined) return null;
    const content = (()=>{
        if (workType && (0, $6s1PB.expVal)('jira-itr-m4-exp-3', 'isEnabled', false)) return formatMessage((0, $5KKS9.default).tooltipIssueTerminologyRefreshM4, {
            workType: workType
        });
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5KKS9.default).tooltipIssueTermRefresh : (0, $5KKS9.default).tooltip);
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
        paddingInlineEnd: "space.025",
        testId: (0, $c936dea51a10e560$export$4e5fcfb49483954e)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content,
        position: "auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        style: $cf3f95453cbc0dbe$var$badgeStyles
    }, formatNumber(Number(value)))));
};
var $cf3f95453cbc0dbe$export$2e2bcd8739ae039 = $cf3f95453cbc0dbe$var$EpicStoryPoint;
const $cf3f95453cbc0dbe$var$badgeStyles = {
    backgroundColor: "var(--ds-background-disabled, #091E4208)",
    color: "var(--ds-text-disabled, #091E424F)"
};

});
const $c936dea51a10e560$export$4e5fcfb49483954e = 'portfolio-3-plan-increment-common.ui.epic-story-point.epic-story-point';

parcelRegister("5KKS9", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfbadea35953c7a8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bfbadea35953c7a8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "portfolio-3-plan-increment-common.ui.epic-story-point.tooltip",
        "defaultMessage": "This issue has been estimated, but isn't included in capacity calculations."
    },
    tooltipIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.epic-story-point.tooltip-issue-term-refresh",
        "defaultMessage": "This work item has been estimated, but isn't included in capacity calculations."
    },
    tooltipIssueTerminologyRefreshM4: {
        "id": "portfolio-3-plan-increment-common.ui.epic-story-point.tooltip-issue-terminology-refresh-m4",
        "defaultMessage": "This {workType} has been estimated, but isn't included in capacity calculations."
    }
});

});


const $189f09162dc8d67b$export$c872a8f05adaccec = 'software-board.board-container.board.card-container.card.story-point-field.wrapper';

parcelRegister("jiQZW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bacf0c46e83690a6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bacf0c46e83690a6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editButtonLabel: {
        "id": "software.main.board-container.board.card-container.card.story-point-field.edit-button-label",
        "defaultMessage": "Story point estimate: {storyPoints}"
    },
    tooltipForEpicEstimate: {
        "id": "software.main.board-container.board.card-container.card.story-point-field.tooltip-for-epic-estimate",
        "defaultMessage": "This issue isn\u2019t included in capacity calculations"
    },
    tooltipForEpicEstimateIssueTermRefresh: {
        "id": "software.main.board-container.board.card-container.card.story-point-field.tooltip-for-epic-estimate-issue-term-refresh",
        "defaultMessage": "This work item isn\u2019t included in capacity calculations"
    },
    ariaLabel: {
        "id": "software.main.board-container.board.card-container.card.story-point-field.aria-label",
        "defaultMessage": "Edit story point estimate"
    }
});

});


parcelRegister("UJNvI", function(module, exports) {

$parcel$export(module.exports, "Summary", () => $2340dd6536b8099b$export$46453a0401d6cd1a);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $54wEF = parcelRequire("54wEF");

var $3fAi8 = parcelRequire("3fAi8");

var $eH4Q8 = parcelRequire("eH4Q8");

var $k2s1j = parcelRequire("k2s1j");

var $gVhaI = parcelRequire("gVhaI");

var $iXVV6 = parcelRequire("iXVV6");

var $1vEOb = parcelRequire("1vEOb");

var $5fc53 = parcelRequire("5fc53");

var $g5X3G = parcelRequire("g5X3G");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $eGVUJ = parcelRequire("eGVUJ");


var $2f454 = parcelRequire("2f454");

var $evkwq = parcelRequire("evkwq");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

var $63LqY = parcelRequire("63LqY");
const $2340dd6536b8099b$var$stopPropagation = (e)=>e.stopPropagation();
// Prevent enter from opening issue view
const $2340dd6536b8099b$var$stopEnterPropagation = (e)=>{
    if (e.key === 'Enter') e.stopPropagation();
};
const $2340dd6536b8099b$var$SummaryInner = ({ shouldMenuRender: shouldMenuRender, highlight: highlight, issueId: issueId, issueKey: issueKey, text: text, onSizeChange: onSizeChange, isSummaryEditing: isSummaryEditing, dialogPlacement: dialogPlacement, setIsSummaryEditing: setIsSummaryEditing, onSubmit: onSubmit, onUpdate: onUpdate, onFailure: onFailure })=>{
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const highlightText = (0, $5uXOq.useMemo)(()=>highlight && (0, $gVhaI.shouldHighlightText)(text, highlight) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gVhaI.HighlightText), {
            phrases: highlight,
            content: text
        }) : undefined, [
        highlight,
        text
    ]);
    const preventInlineEditing = (0, $67sX6.useBoardSelector)((state)=>(0, $k8auG.getPreventInlineEditing)(state));
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (onSizeChange) requestAnimationFrame(onSizeChange);
    }, [
        isSummaryEditing,
        onSizeChange
    ]);
    const onEditStateChange = (0, $5uXOq.useCallback)((newIsEditing)=>{
        dispatch((0, $2f454.setInlineEditing)('summary', issueId, newIsEditing));
        setIsSummaryEditing(newIsEditing);
    }, [
        setIsSummaryEditing,
        dispatch,
        issueId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2340dd6536b8099b$var$Wrapper, {
        shouldMenuRender: shouldMenuRender,
        isSummaryEditing: isSummaryEditing,
        onClick: isSummaryEditing ? $2340dd6536b8099b$var$stopPropagation : undefined,
        onKeyDown: $2340dd6536b8099b$var$stopEnterPropagation,
        disableClick: preventInlineEditing && !isSummaryEditing
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            origin: 'issueCard'
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eH4Q8.AsyncSummaryInlineEdit), {
        disableSummaryUnderlineText: (0, $dCm1o.isVisualRefreshEnabled)(),
        disableSummaryTooltip: (0, $dCm1o.isVisualRefreshEnabled)(),
        issueId: issueId.toString(),
        issueKey: issueKey,
        highlightText: highlightText,
        onChange: onSizeChange,
        onEditStateChange: onEditStateChange,
        onCancel: onSizeChange,
        onSubmit: onSubmit,
        onUpdate: onUpdate,
        onFailure: onFailure,
        dialogPlacement: dialogPlacement,
        ...isIncrementPlanningBoard && {
            disableSummaryUnderlineText: true,
            onSaveField: async (_, fieldId, fieldValue)=>{
                dispatch((0, $evkwq.issueIncrementPlanningUpdate)({
                    issueId: issueId,
                    fieldId: fieldId,
                    fieldValue: fieldValue
                }));
            }
        }
    })));
};
const $2340dd6536b8099b$export$46453a0401d6cd1a = ({ shouldRenderRichField: shouldRenderRichField, ...props })=>{
    const [issueSummaryFieldValue] = (0, $3fAi8.useFieldValue)({
        issueKey: (0, $g5X3G.toIssueKey)(props.issueKey),
        fieldKey: (0, $5fc53.SUMMARY_TYPE)
    });
    const [{ value: summaryFieldConfig }] = (0, $54wEF.useFieldConfigWithoutRefetch)(props.issueKey, (0, $5fc53.SUMMARY_TYPE));
    const shouldRenderRich = shouldRenderRichField && issueSummaryFieldValue && summaryFieldConfig;
    const editableField = (0, $eGVUJ.useEditableField)({
        isExperienceAvailable: shouldRenderRich
    });
    const fallback = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1vEOb.CardSummary), props), [
        props
    ]);
    if (shouldRenderRich) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k2s1j.SummaryInlineEditErrorBoundary), {
        packageName: (0, $dcbb2bce513725b3$export$b8b9d90f9e5bd72b),
        fallback: fallback,
        onError: editableField.onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "ng-board.inline-edit.summary-field"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2340dd6536b8099b$var$SummaryInner, {
        ...props,
        ...editableField
    })));
    return fallback;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2340dd6536b8099b$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { shouldMenuRender: shouldMenuRender, isSummaryEditing: isSummaryEditing, disableClick: disableClick, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1osq _4t3i1osq _1x82h2mm _155o11wp _ogi711wp _1uv97079 _cbvav77o _p2gzr5cr",
            __cmplp.shouldMenuRender && !__cmplp.isSummaryEditing && "_2hwxxy5q",
            __cmplp.disableClick && "_lcxvglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eH4Q8", function(module, exports) {

$parcel$export(module.exports, "AsyncSummaryInlineEdit", () => $bc592fb83a4636c2$export$54e29fccbbfceca7);

var $kxZPA = parcelRequire("kxZPA");

const $bc592fb83a4636c2$export$54e29fccbbfceca7 = (0, $kxZPA.lazy)(()=>(parcelRequire("2vkbx")).then(({ SummaryInlineEdit: SummaryInlineEdit })=>SummaryInlineEdit), {
    moduleId: "./src/packages/issue/fields/summary-components/summary-inline-edit/src/ui/main.tsx"
});

});
parcelRegister("2vkbx", function(module, exports) {

let $1d2e2260d7c03d84$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1d2e2260d7c03d84$var$load("5gvI2").then(()=>parcelRequire('gZthY'));

});


parcelRegister("k2s1j", function(module, exports) {

$parcel$export(module.exports, "SummaryInlineEditErrorBoundary", () => $e1487f9683c49508$export$831a097b152bf340);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");
const $e1487f9683c49508$export$831a097b152bf340 = ({ fallback: fallback, children: children, packageName: packageName, onError: onError })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "summary-inline-edit",
        packageName: packageName,
        teamName: "bento",
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, fallback),
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "summary-inline-edit-error-boundary",
        fallback: fallback
    }, children));

});


parcelRegister("aLb7D", function(module, exports) {

$parcel$export(module.exports, "transformToIssueFieldValues", () => $ceb271d5f92ec596$export$b419a5d0413eaa90);
$parcel$export(module.exports, "transformToIssueFieldConfigValues", () => $ceb271d5f92ec596$export$f834c80091db4807);
$parcel$export(module.exports, "getShouldShowLabels", () => $ceb271d5f92ec596$export$d29f8cc4773bd66e);
$parcel$export(module.exports, "transformStatusesStateToIssueStatusesById", () => $ceb271d5f92ec596$export$ce0932a778978aa);
$parcel$export(module.exports, "shouldShowDueDate", () => $ceb271d5f92ec596$export$e7879c38e0e95d87);

var $gULOk = parcelRequire("gULOk");

var $fhSLy = parcelRequire("fhSLy");

var $7Fute = parcelRequire("7Fute");

var $b8gJu = parcelRequire("b8gJu");

var $5fc53 = parcelRequire("5fc53");


var $jeb8M = parcelRequire("jeb8M");
const $ceb271d5f92ec596$export$b419a5d0413eaa90 = ({ issue: { summary: summary, priority: priority }, assignee: assignee, parent: parent, estimateExtended: estimateExtended })=>({
        summary: summary,
        ...parent && {
            parent: (0, $7Fute.getParentShape)(String(parent.id), parent.key, parent.summary, {
                id: parent.issueType.id,
                name: parent.issueType.name,
                iconUrl: parent.issueType.iconUrl
            }, parent.color),
            [(0, $5fc53.HIERARCHY_LEVEL_ABOVE)]: (0, $7Fute.getHierarchyShape)({
                id: parent.issueType.id,
                name: parent.issueType.name,
                iconUrl: parent.issueType.iconUrl
            })
        },
        ...assignee && {
            assignee: (0, $fhSLy.getUserShape)(assignee.id, assignee.displayName, assignee.avatarUrl || '')
        },
        ...estimateExtended && estimateExtended.fieldId && {
            [estimateExtended.fieldId]: estimateExtended.value
        },
        ...priority && {
            [(0, $5fc53.PRIORITY_TYPE)]: priority
        }
    });
const $ceb271d5f92ec596$export$f834c80091db4807 = ({ issue: { key: key, summary: summary }, estimateExtended: estimateExtended, isEditable: isEditable })=>{
    const summaryConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.SUMMARY_CONFIG_TITLE),
        schema: {
            type: 'string',
            custom: null,
            customId: null,
            system: (0, $5fc53.SUMMARY_TYPE),
            renderer: 'jira-text-renderer'
        }
    };
    const storyPointConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.STORY_POINT_CONFIG_TITLE),
        schema: {
            type: 'number',
            custom: (0, $5fc53.STORY_POINT_ESTIMATE_CF_TYPE),
            customId: estimateExtended?.fieldId ? parseInt(estimateExtended.fieldId.replace('customfield_', ''), 10) : null,
            system: null,
            renderer: 'jira-text-renderer'
        }
    };
    const originalEstimateConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.ORIGINAL_ESTIMATE_CONFIG_TITLE),
        schema: {
            type: 'number',
            custom: null,
            customId: null,
            system: (0, $5fc53.TIME_ESTIMATE_TYPE),
            renderer: null
        }
    };
    const assigneeConfig = {
        autoCompleteUrl: `${(0, $jeb8M.USER_FETCH_URL)}?issueKey=${key}&query=`,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.ASSIGNEE_CONFIG_TITLE),
        schema: {
            type: 'user',
            custom: null,
            customId: null,
            system: (0, $5fc53.ASSIGNEE_TYPE),
            renderer: 'jira-text-renderer'
        }
    };
    const parentConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: true,
        title: (0, $jeb8M.PARENT_CONFIG_TITLE),
        schema: {
            type: 'array',
            custom: null,
            customId: null,
            system: (0, $5fc53.PARENT_TYPE),
            renderer: null
        }
    };
    const priorityConfig = {
        autoCompleteUrl: null,
        allowedValues: [],
        isEditable: isEditable,
        isRequired: false,
        title: (0, $jeb8M.PRIORITY_CONFIG_TITLE),
        schema: {
            type: 'priority',
            custom: null,
            customId: null,
            system: (0, $5fc53.PRIORITY_TYPE),
            renderer: 'null'
        }
    };
    return {
        ...summary && {
            summary: summaryConfig
        },
        parent: parentConfig,
        assignee: assigneeConfig,
        ...estimateExtended?.fieldId && (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2) === estimateExtended.fieldId && {
            [estimateExtended.fieldId]: originalEstimateConfig
        },
        ...estimateExtended?.fieldId && (0, $e9be48d6d2c01760$export$5fbd3b15555b9ef2) !== estimateExtended.fieldId && {
            [estimateExtended.fieldId]: storyPointConfig
        },
        priority: priorityConfig
    };
};
const $ceb271d5f92ec596$export$d29f8cc4773bd66e = (viewSettingsShowLabels, isCMPBoard)=>{
    // TMP
    if (!isCMPBoard) return viewSettingsShowLabels;
    // CMP
    return false; // disregard viewSettings.showLabel in CMP to avoid double labels // CMP now renders labels from custom fields
};
const $ceb271d5f92ec596$export$ce0932a778978aa = (statusesState)=>{
    const issueStatusesById = {};
    for (const [key, status] of Object.entries(statusesState)){
        const categoryId = (0, $gULOk.categoryIdForStatusCategory)(status.category);
        const issueStatus = {
            categoryId: categoryId,
            id: String(status.id),
            name: status.name
        };
        issueStatusesById[key] = issueStatus;
    }
    return issueStatusesById;
};
const $ceb271d5f92ec596$export$e7879c38e0e95d87 = ({ viewSettingsShowDueDate: viewSettingsShowDueDate, isCMPBoard: isCMPBoard, boardType: boardType })=>{
    if (!viewSettingsShowDueDate) return false;
    return !isCMPBoard || boardType === (0, $b8gJu.BoardView).JSW_BOARD;
};

});
parcelRegister("jeb8M", function(module, exports) {

$parcel$export(module.exports, "USER_FETCH_URL", () => $1021a6385a9ca75c$export$496c8518e21a3f4);
$parcel$export(module.exports, "SUMMARY_CONFIG_TITLE", () => $1021a6385a9ca75c$export$3b4b8fdfebc45db9);
$parcel$export(module.exports, "STORY_POINT_CONFIG_TITLE", () => $1021a6385a9ca75c$export$279da72db146d908);
$parcel$export(module.exports, "ORIGINAL_ESTIMATE_CONFIG_TITLE", () => $1021a6385a9ca75c$export$7708961ea0c1cd86);
$parcel$export(module.exports, "ASSIGNEE_CONFIG_TITLE", () => $1021a6385a9ca75c$export$90703b6e9220b971);
$parcel$export(module.exports, "PARENT_CONFIG_TITLE", () => $1021a6385a9ca75c$export$3fa469ea6c8e4dd4);
$parcel$export(module.exports, "PRIORITY_CONFIG_TITLE", () => $1021a6385a9ca75c$export$7e2d029a62fca5f1);

var $3hUhs = parcelRequire("3hUhs");
const $1021a6385a9ca75c$export$496c8518e21a3f4 = '/rest/api/2/user/assignable/search';
const $1021a6385a9ca75c$export$3b4b8fdfebc45db9 = 'Summary';
const $1021a6385a9ca75c$export$279da72db146d908 = 'Story point estimate';
const $1021a6385a9ca75c$export$7708961ea0c1cd86 = 'Original estimate';
const $1021a6385a9ca75c$export$90703b6e9220b971 = 'Assignee';
const $1021a6385a9ca75c$export$3fa469ea6c8e4dd4 = 'Parent';
const $1021a6385a9ca75c$export$7e2d029a62fca5f1 = 'Priority';
const $1021a6385a9ca75c$export$3ec753f69f84781c = (0, $3hUhs.sharedStyles).zIndex.stickySwimlaneBar + 1;

});





parcelRegister("52TPO", function(module, exports) {

$parcel$export(module.exports, "useShouldRenderCardLite", () => $ecc0d54d655bdd17$export$dfe7863e47060af4);

var $5uXOq = parcelRequire("5uXOq");

var $kir0S = parcelRequire("kir0S");
const $ecc0d54d655bdd17$export$dfe7863e47060af4 = (isScrolling)=>{
    const { isInitialRender: isInitialRender } = (0, $kir0S.default)();
    const previouslyRenderedLiteCard = (0, $5uXOq.useRef)(false);
    if (isScrolling && (isInitialRender || previouslyRenderedLiteCard.current)) {
        previouslyRenderedLiteCard.current = true;
        return true;
    }
    previouslyRenderedLiteCard.current = false;
    return false;
};

});
parcelRegister("kir0S", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a060b75ae68d73c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $9a060b75ae68d73c$var$useRenderState = ()=>{
    const isInitialRender = (0, $5uXOq.useRef)(true);
    (0, $5uXOq.useEffect)(()=>{
        isInitialRender.current = false;
    }, []);
    return {
        isInitialRender: isInitialRender.current
    };
};
var $9a060b75ae68d73c$export$2e2bcd8739ae039 = $9a060b75ae68d73c$var$useRenderState;

});



parcelRegister("g94HQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $80b237a582f17b1a$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $biEfA = parcelRequire("biEfA");

var $7gWdR = parcelRequire("7gWdR");

var $3bDjY = parcelRequire("3bDjY");


var $3eGwD = parcelRequire("3eGwD");

var $guFRy = parcelRequire("guFRy");

var $1fZVH = parcelRequire("1fZVH");

var $4R6GH = parcelRequire("4R6GH");

var $67sX6 = parcelRequire("67sX6");

var $3UY9S = parcelRequire("3UY9S");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $drQJq = parcelRequire("drQJq");

var $bQegf = parcelRequire("bQegf");

var $bvghy = parcelRequire("bvghy");
const $80b237a582f17b1a$var$CARD_PADDING = 14;
const $80b237a582f17b1a$var$CARD_GROUP_HEADER_HEIGHT_WITH_PARENT = 3;
const $80b237a582f17b1a$var$CARD_GROUP_HEADER_HEIGHT = 29;
const $80b237a582f17b1a$export$9acc0474485b44b2 = ({ issueIdGroup: { issueIds: issueIds, isAttachedToParent: isAttachedToParent, parentId: parentId }, parentKey: parentKey, parentSummary: parentSummary, isRankable: isRankable, index: cardGroupIndex, offsetTop: offsetTop, ...props })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const containerRef = (0, $5uXOq.useRef)(null);
    const [closestEdge, setClosestEdge] = (0, $5uXOq.useState)(null);
    const batchSetClosestEdge = (0, $5uXOq.useCallback)((edge)=>autobatch(()=>setClosestEdge(edge)), [
        autobatch
    ]);
    const getPlatformIssueById = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformIssueSelector));
    const issueChildren = (0, $67sX6.useBoardSelector)((0, $3UY9S.getIssueChildren));
    const cardHeightCache = (0, $bvghy.useCardHeightCache)();
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: cardHeightCache,
            getCacheKey: (index)=>issueIds[index]
        }), [
        issueIds,
        cardHeightCache
    ]);
    const { rows: rows, totalSize: totalSize, isScrolling: isScrolling } = (0, $guFRy.useVirtual)({
        rowCount: issueIds.length,
        getDefaultRowSize: ()=>(0, $3eGwD.DEFAULT_CARD_HEIGHT),
        offsetTop: offsetTop + (isAttachedToParent ? $80b237a582f17b1a$var$CARD_GROUP_HEADER_HEIGHT_WITH_PARENT : $80b237a582f17b1a$var$CARD_GROUP_HEADER_HEIGHT),
        cacheOptions: cacheOptions
    });
    const cardContainerProps = (0, $5uXOq.useRef)(props);
    cardContainerProps.current = props;
    const renderCard = (0, $5uXOq.useCallback)((issueEntry, index)=>!(0, $3eGwD.isIssueEntryGroup)(issueEntry) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $drQJq.default), {
            ...cardContainerProps.current,
            key: issueEntry.issueId,
            id: issueEntry.issueId,
            index: index,
            groupParentId: parentId
        }), [
        parentId
    ]);
    const issueEntries = (0, $5uXOq.useMemo)(()=>issueIds.map((issueId)=>({
                type: 'issue',
                issueId: issueId
            })), [
        issueIds
    ]);
    const renderer = (0, $bQegf.useRowRenderer)({
        cardEntries: issueEntries,
        footer: null,
        footerIndex: issueEntries.length,
        placeholder: null,
        renderCard: renderCard,
        showFooter: false
    });
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.dropTargetForElements)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            element: containerRef.current,
            getIsSticky: ()=>true,
            getData: ({ input: input, element: element })=>{
                const issueChild = getPlatformIssueById(issueIds[0]);
                return (0, $biEfA.attachClosestEdge)({
                    type: (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
                    cardId: parentId,
                    cardIndex: cardGroupIndex,
                    columnId: issueChild?.columnId,
                    swimlaneId: issueChild?.swimlaneId
                }, {
                    input: input,
                    element: element,
                    allowedEdges: [
                        'top',
                        'bottom'
                    ]
                });
            },
            canDrop: (args)=>args.source.data.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) && isRankable && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                !(args.source.data.cardId in issueChildren),
            onDrag: ({ self: self })=>{
                batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragEnter: ({ self: self })=>{
                batchSetClosestEdge((0, $biEfA.extractClosestEdge)(self.data));
            },
            onDragLeave: ()=>batchSetClosestEdge(null),
            onDrop: ()=>batchSetClosestEdge(null)
        }), [
        issueChildren,
        issueIds,
        parentId,
        cardGroupIndex,
        getPlatformIssueById,
        isRankable,
        batchSetClosestEdge
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupContainer, {
        ref: containerRef,
        isAttachedToParent: isAttachedToParent,
        "data-testid": "software-board.board-container.board.card-group.card-group"
    }, !isAttachedToParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: parentSummary
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupHeader, {
        "data-testid": "software-board.board-container.board.card-group.card-group-header",
        "aria-hidden": true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupHeaderKey, null, parentKey), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupHeaderSummary, null, parentSummary))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupDroppableContainer, {
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            minHeight: totalSize
        }
    }, rows.map(({ index: index, top: top, forceRemeasure: forceRemeasure, measure: measure })=>renderer({
            index: index,
            isScrolling: isScrolling,
            forceRemeasure: forceRemeasure,
            measure: measure,
            offsetTop: top - offsetTop,
            style: {
                position: 'absolute',
                top: top - offsetTop,
                width: `calc(100% - ${$80b237a582f17b1a$var$CARD_PADDING}px)`,
                contain: 'style',
                marginTop: (0, $4R6GH.fg)('tanuki_padding_margin_use_token') ? "var(--ds-space-0, 0px)" : '0px'
            }
        }))), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$var$CardGroupDropIndicator, {
        edge: closestEdge
    }));
};
const $80b237a582f17b1a$var$ConnectedCardGroup = (props)=>{
    const parent = (0, $67sX6.useBoardSelector)((state)=>{
        const { parentId: parentId } = props.issueIdGroup;
        return (0, $d2i8f.getIssueById)(state, parentId) || (0, $67Z81.getMissingParents)(state)[parentId];
    });
    const isRankable = (0, $67sX6.useBoardSelector)((0, $67Z81.isBoardRankable));
    return !!parent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($80b237a582f17b1a$export$9acc0474485b44b2, {
        ...props,
        parentKey: parent.key,
        parentSummary: parent.summary,
        isRankable: isRankable
    });
};
var $80b237a582f17b1a$export$2e2bcd8739ae039 = $80b237a582f17b1a$var$ConnectedCardGroup;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $80b237a582f17b1a$var$CardGroupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isAttachedToParent: isAttachedToParent, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189et94y _1dqonqa1 _1h6dmuej _ca0q12x7 _u5f312x7 _n3td12x7 _19bv12x7 _otyrv77o _bfhk11bn",
            __cmplp.isAttachedToParent ? "_2rkohyhq" : "_2rkoi2wt",
            __cmplp.isAttachedToParent ? "_19pkr5cr" : "_19pkv77o",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupDroppableContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _1e0c1txw _2lx21bp4 _2mzuglyw",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupHeaderKey = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _2hwx1b66 _k48pmoej",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupHeaderSummary = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1e0c1o8l _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupDropIndicator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { edge: edge, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _1ltvidpf _1xi2idpf _4t3iyh40 _1pbycs5v _bfhkbku0 _lcxvglyw _rfx31ssb _3l88yh40 _kzdanqa1 _15m613er _1kt9b3bt _1cs8stnw _kfgt1y44 _1mp41y44 _1aukj39m _qnec16fl",
            __cmplp.edge === 'bottom' && "_94n51n1a",
            __cmplp.edge === 'top' && "_154i1n1a",
            __cmplp.className
        ])
    });
});
const $80b237a582f17b1a$var$CardGroupHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _otyr1b66 _syaz131l _1e0c1txw _1n261q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("bQegf", function(module, exports) {

$parcel$export(module.exports, "useRowRenderer", () => $51be9651e76214f7$export$809172435aa53585);

var $5uXOq = parcelRequire("5uXOq");

var $3eGwD = parcelRequire("3eGwD");


var $5gjnk = parcelRequire("5gjnk");
const $51be9651e76214f7$var$getKey = (index, footerIndex, cardEntry)=>{
    if (index === footerIndex) return 0, $7455914ed26b7de2$export$a57c8b25e45b243f;
    if (cardEntry) return (0, $3eGwD.isIssueEntryGroup)(cardEntry) ? (0, $3eGwD.getIssueEntryGroupKey)(cardEntry) : cardEntry.issueId;
    return 0, $7455914ed26b7de2$export$3eeaa9cdb48b7cc4;
};
const $51be9651e76214f7$export$809172435aa53585 = ({ cardEntries: cardEntries, footer: footer, renderCard: renderCard, footerIndex: footerIndex, placeholder: placeholder, showFooter: showFooter })=>(0, $5uXOq.useCallback)(({ index: index, isScrolling: isScrolling, style: style, measure: measure, forceRemeasure: forceRemeasure, offsetTop: offsetTop })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gjnk.default), {
            rowStyle: style,
            index: index,
            footerIndex: footerIndex,
            cardEntries: cardEntries,
            footer: footer,
            measure: measure,
            forceRemeasure: forceRemeasure,
            key: $51be9651e76214f7$var$getKey(index, footerIndex, cardEntries[index]),
            renderCard: renderCard,
            isScrolling: isScrolling,
            placeholder: placeholder,
            showFooter: showFooter,
            offsetTop: offsetTop
        }), [
        footerIndex,
        cardEntries,
        footer,
        renderCard,
        placeholder,
        showFooter
    ]);

});
const $7455914ed26b7de2$export$a57c8b25e45b243f = 'footer';
const $7455914ed26b7de2$export$3eeaa9cdb48b7cc4 = 'virtual_list_dnd_key';

parcelRegister("5gjnk", function(module, exports) {

$parcel$export(module.exports, "default", () => $0774629240aef2f4$export$2e2bcd8739ae039);
/* eslint-disable jira/react/no-style-attribute */ 
var $5uXOq = parcelRequire("5uXOq");

var $58K4A = parcelRequire("58K4A");

var $i8wwL = parcelRequire("i8wwL");

var $2m0b6 = parcelRequire("2m0b6");

var $7D59a = parcelRequire("7D59a");

var $1eicd = parcelRequire("1eicd");
const $0774629240aef2f4$var$RowRenderer = ({ index: index, footerIndex: footerIndex, cardEntries: cardEntries, rowStyle: rowStyle, forceRemeasure: forceRemeasure, measure: measure, footer: footer, renderCard: renderCard, isScrolling: isScrolling, placeholder: placeholder, showFooter: showFooter, offsetTop: offsetTop })=>{
    const onResize = (0, $7D59a.useEvent)(()=>{
        forceRemeasure(rowRef.current);
    });
    const rowRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (rowRef.current) measure(rowRef.current);
    }, [
        rowRef,
        measure
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: rowRef,
        onResize: onResize
    });
    const { isOverColumn: isOverColumn } = (0, $i8wwL.useIsCardOverColumn)();
    // If we have nothing to show except the placeholder
    if (cardEntries.length === 0 && !!placeholder && !showFooter) // Just measure the DIV once we have the ref which is good enough to determine its proper height
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        style: rowStyle,
        ref: rowRef
    }, placeholder));
    // Handle the footer specific use case
    if (index === footerIndex) return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1eicd.ElementSizeMeasurer), {
        style: rowStyle,
        onResize: measure,
        showFooter: showFooter
    }, isOverColumn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58K4A.CardDropIndicator), {
        edge: "top",
        style: {
            top: '-1px'
        }
    }), showFooter && footer));
    const cardEntry = cardEntries[index];
    // If there is no cardEntry
    // This will happen if we are attempting to render a footer but showFooter is false.
    if (cardEntry == null) return null;
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        style: rowStyle,
        ref: rowRef
    }, renderCard(cardEntry, index, isScrolling, onResize, offsetTop)));
};
var $0774629240aef2f4$export$2e2bcd8739ae039 = $0774629240aef2f4$var$RowRenderer;

});
parcelRegister("1eicd", function(module, exports) {

$parcel$export(module.exports, "ElementSizeMeasurer", () => $54855d4096fe50af$export$fc67fd6b0f89895b);

var $5uXOq = parcelRequire("5uXOq");
const $54855d4096fe50af$export$fc67fd6b0f89895b = ({ onResize: onResize, children: children, style: style, showFooter: showFooter })=>{
    const resizeObserver = (0, $5uXOq.useRef)(null);
    const onElement = (0, $5uXOq.useCallback)((element)=>{
        // If we have an existing resize observer, disconnect it before we
        // re-create it
        resizeObserver.current?.disconnect();
        if (element == null) // Do nothing
        return;
        // Anytime we enter this function, we want to rebind the ResizeObserver since
        // our calback has changed (see below dependencies)
        resizeObserver.current = new ResizeObserver(()=>{
            onResize?.(element);
        });
        resizeObserver.current.observe(element);
    }, [
        resizeObserver,
        onResize
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            // If we are unmounting, cleanup the resize observer by disconnecting it
            resizeObserver.current?.disconnect();
        }, [
        resizeObserver
    ]);
    return showFooter ? // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        style: style,
        ref: onElement
    }, children) : // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        style: style,
        ref: onElement,
        "aria-hidden": "true"
    }, children);
};

});



parcelRegister("bvghy", function(module, exports) {

$parcel$export(module.exports, "useCardHeightCache", () => $e49e2d845ff8f15a$export$bd41b84dc563782c);

var $5uXOq = parcelRequire("5uXOq");
const $e49e2d845ff8f15a$var$CARD_HEIGHTS_CACHE = new Map();
const $e49e2d845ff8f15a$export$bd41b84dc563782c = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $e49e2d845ff8f15a$var$CARD_HEIGHTS_CACHE;
const $e49e2d845ff8f15a$export$201114c49d4ccb5a = ()=>{
    (0, $5uXOq.useEffect)(()=>()=>{
            // Only run the cleanup if the FF is enabled.
            $e49e2d845ff8f15a$var$CARD_HEIGHTS_CACHE.clear();
        }, []);
};

});


parcelRegister("5nhUs", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f8f925568a0eb6d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $hULKg = parcelRequire("hULKg");

var $5rzqz = parcelRequire("5rzqz");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");

var $67Z81 = parcelRequire("67Z81");

var $ap9Jk = parcelRequire("ap9Jk");

var $7CPxV = parcelRequire("7CPxV");
const $1f8f925568a0eb6d$var$EmptyCMPKanbanBoardMessage = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { projectsWithCreatePermission: projectsWithCreatePermission } = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueProjectsPermissionGroup));
    const hasCreateIssuePermission = projectsWithCreatePermission.length > 0;
    const hasBacklog = (0, $67sX6.useBoardSelector)((0, $k8auG.isBacklogEnabled));
    const [, { openIssueCreateModal: openIssueCreateModal }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const isJSMBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector)) === (0, $2vSU6.SERVICE_DESK_PROJECT);
    const renderTitleText = ()=>{
        if (isJSMBoard) return formatMessage((0, $7CPxV.default).jsmEmptyStateTitle);
        if (hasCreateIssuePermission) return hasBacklog ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).titleWithPermissionAndBacklogIssueTermRefresh : (0, $7CPxV.default).titleWithPermissionAndBacklog) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).titleWithPermissionNoBacklogIssueTermRefresh : (0, $7CPxV.default).titleWithPermissionNoBacklog);
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).titleNoPermissionIssueTermRefresh : (0, $7CPxV.default).titleNoPermission);
    };
    const renderAction = ()=>{
        if (hasCreateIssuePermission) {
            const openIssueCreate = ()=>{
                openIssueCreateModal({
                    payload: {
                        project: {
                            projectId: String(projectsWithCreatePermission[0])
                        }
                    },
                    triggerPointKey: (0, $hULKg.CREATE_ISSUE_ACTIVE_SPRINT_EMPTY_VIEW)
                });
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                onClick: openIssueCreate,
                testId: "software-board.board-container.board.column.empty-cmp-kanban-dialog.button"
            }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).buttonIssueTermRefresh : (0, $7CPxV.default).button));
        }
        return isJSMBoard ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$TextStyle, null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).descriptionNoPermissionIssueTermRefresh : (0, $7CPxV.default).descriptionNoPermission));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($ap9Jk))),
        alt: "empty kanban board"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$TitleStyle, {
        hasCreateIssuePermission: hasCreateIssuePermission,
        hasDescription: isJSMBoard
    }, renderTitleText()), isJSMBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1f8f925568a0eb6d$var$DescriptionContainer, {
        hasCreateIssuePermission: hasCreateIssuePermission
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7CPxV.default).jsmEmptyStateDescriptionIssueTermRefresh : (0, $7CPxV.default).jsmEmptyStateDescription)), renderAction());
};
var $1f8f925568a0eb6d$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $1f8f925568a0eb6d$var$EmptyCMPKanbanBoardMessage;
const $1f8f925568a0eb6d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q _1e0c1txw _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8f925568a0eb6d$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1qr7 _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $1f8f925568a0eb6d$var$getMargin = (hasCreateIssuePermission, hasDescription)=>{
    if (hasDescription) return "var(--ds-space-100, 8px)";
    return hasCreateIssuePermission ? "var(--ds-space-300, 24px)" : "var(--ds-space-100, 8px)";
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8f925568a0eb6d$var$TitleStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCreateIssuePermission: hasCreateIssuePermission, hasDescription: hasDescription, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _k48pmoej _otyru2gc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8f925568a0eb6d$var$TextStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1f8f925568a0eb6d$var$DescriptionContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hasCreateIssuePermission: hasCreateIssuePermission, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o",
            __cmplp.hasCreateIssuePermission ? "_otyr1ejb" : "_otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ap9Jk", function(module, exports) {
module.exports = new URL("empty-cmp-kanban-board.d2af34d0.svg", import.meta.url).toString();

});

parcelRegister("7CPxV", function(module, exports) {

$parcel$export(module.exports, "default", () => $1c97705f1f833a2e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1c97705f1f833a2e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    titleWithPermissionAndBacklog: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-with-permission-and-backlog",
        "defaultMessage": "Create and move issues from the backlog to get started."
    },
    titleWithPermissionNoBacklog: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-with-permission-no-backlog",
        "defaultMessage": "Create an issue to get started."
    },
    titleNoPermission: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-no-permission",
        "defaultMessage": "No issues yet"
    },
    descriptionNoPermission: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.description-no-permission",
        "defaultMessage": "Once your team has issues to work on, you'll see them here"
    },
    button: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.button",
        "defaultMessage": "Create issue"
    },
    jsmEmptyStateTitle: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.jsm-empty-state-title",
        "defaultMessage": "Visualize your work with a board"
    },
    jsmEmptyStateDescription: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.jsm-empty-state-description",
        "defaultMessage": "Track all issues in your project, or view specific issues using filters."
    },
    titleWithPermissionAndBacklogIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-with-permission-and-backlog-issue-term-refresh",
        "defaultMessage": "Create and move work items from the backlog to get started."
    },
    titleWithPermissionNoBacklogIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-with-permission-no-backlog-issue-term-refresh",
        "defaultMessage": "Create a work item to get started."
    },
    titleNoPermissionIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.title-no-permission-issue-term-refresh",
        "defaultMessage": "No work items yet"
    },
    descriptionNoPermissionIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.description-no-permission-issue-term-refresh",
        "defaultMessage": "Once your team has work items to work on, you'll see them here"
    },
    buttonIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.button-issue-term-refresh",
        "defaultMessage": "Create work item"
    },
    jsmEmptyStateDescriptionIssueTermRefresh: {
        "id": "software.main.board-container.board.column.empty-cmp-kanban-dialog.jsm-empty-state-description-issue-term-refresh",
        "defaultMessage": "Use filters to view specific work items, or track all work in your project."
    }
});

});


parcelRegister("dRpFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f4fb246fb7165a4$export$2e2bcd8739ae039);

var $gJBT6 = parcelRequire("gJBT6");

var $8Rkzz = parcelRequire("8Rkzz");

var $5rFbt = parcelRequire("5rFbt");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");


var $63VRQ = parcelRequire("63VRQ");

var $1vXOx = parcelRequire("1vXOx");

var $kc6Ry = parcelRequire("kc6Ry");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $lBlo2 = parcelRequire("lBlo2");

var $9FKJv = parcelRequire("9FKJv");
const $0f4fb246fb7165a4$export$f6225909f8fcd89c = (0, $2OMDV.AnalyticsEventToProps)('columnHeader', {
    onEditStart: 'editStarted',
    onEditCancel: 'editCanceled',
    onHeaderClick: 'clicked'
})((0, $9FKJv.default));
const $0f4fb246fb7165a4$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnIndex)=>({
        columnIndex: columnIndex + 1
    }));
const $0f4fb246fb7165a4$var$EMPTY_LIST = [];
const $0f4fb246fb7165a4$var$mapStateToProps = (state, ownProps)=>{
    const column = (0, $fyeGd.getColumnById)(state, ownProps.id);
    const columnIndex = (0, $fyeGd.getColumnIndex)(state, ownProps.id);
    const getCardsCount = ()=>{
        /**
		 * We do NOT display cards count in column headers of increment planning boards
		 * Therefore we set cardsCount={undefined} which eventually hides the issue count
		 * in board-kit/src/common/ui/column-header/editable-title/column-title ({!!visibleCount && <CountWrapper />})
		 * */ const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        if (isIncrementPlanningBoard) return undefined;
        // in non-incremental planning boards, the issue count is displayed in column headers
        return false ? (0, $5mTgl.getColumnIssuesCountWithLimit)(state, ownProps.id) : (0, $5mTgl.getColumnIssuesCount)(state, ownProps.id);
    };
    const totalCardsCount = (0, $5mTgl.getColumnTotalIssuesCount)(state, ownProps.id);
    const showTotalCardsCount = false || (0, $5mTgl.hasWorkFiltersSelector)(state);
    const lozenges = column?.type === (0, $5rFbt.ColumnType).STATUS ? (0, $fyeGd.getColumnLozenges)(totalCardsCount, column?.maxIssueCount, column?.minIssueCount) : $0f4fb246fb7165a4$var$EMPTY_LIST;
    const canRenameColumns = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$b5cf1ddd753a0a1c] && (0, $5mTgl.isInlineColumnEditEnabled)(state);
    const OverlayContent = !(0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).HIDE_COLUMN_HEADER_OVERLAY) && (0, $9OPlz.draggingCardTargetColumnIdSelector)(state) === ownProps.id && (0, $9OPlz.draggingCardHoverIntentSelector)(state) ? (0, $lBlo2.default) : undefined;
    return {
        title: column?.name ?? '',
        lozenges: lozenges,
        index: columnIndex,
        cardsCount: getCardsCount(),
        totalCardsCount: totalCardsCount,
        showTotalCardsCount: showTotalCardsCount,
        // disable "column edit" feature (for all columns) during column update.
        // JIRA API does not support multi columns updates at the same time
        isDone: (0, $fyeGd.isDoneColumn)(column),
        isRenamable: canRenameColumns && !(0, $5mTgl.isAnyColumnUpdating)(state),
        isDisabled: (0, $5mTgl.isAnyColumnUpdating)(state),
        // copy ownProps or set default values
        showShadowOnScroll: ownProps.showShadowOnScroll || false,
        menu: ownProps.menu || null,
        validateRename: (0, $fyeGd.makeValidateColumnSelector)(state),
        // analytics
        externalId: 'board.column-header',
        externalValues: $0f4fb246fb7165a4$var$getExternalValues(columnIndex),
        onEditStart: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onEditCancel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onHeaderClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        OverlayContent: OverlayContent,
        isLastColumn: (0, $fyeGd.isLastColumn)(state)(ownProps.id)
    };
};
const $0f4fb246fb7165a4$var$ConnectedHeaderWithAnalytics = (0, $bC2fB.connect)($0f4fb246fb7165a4$var$mapStateToProps, (dispatch)=>({
        onRename: (columnId, title, analyticsEvent)=>{
            dispatch((0, $63VRQ.columnRenameRequest)(columnId, title, analyticsEvent));
        },
        onEditStart: (analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent),
        onEditCancel: (columnId, type, analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
                columnId: columnId,
                type: type
            }),
        onHeaderClick: (analyticsEvent)=>(0, $8zOmE.fireUIAnalytics)(analyticsEvent)
    }))($0f4fb246fb7165a4$export$f6225909f8fcd89c);
var $0f4fb246fb7165a4$export$2e2bcd8739ae039 = $0f4fb246fb7165a4$var$ConnectedHeaderWithAnalytics;

});
parcelRegister("lBlo2", function(module, exports) {

$parcel$export(module.exports, "default", () => $427a5a447ae7148b$export$2e2bcd8739ae039);

var $gULOk = parcelRequire("gULOk");

var $kkSEu = parcelRequire("kkSEu");

var $bC2fB = parcelRequire("bC2fB");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");
const $427a5a447ae7148b$var$mapStateToProps = (state)=>{
    const activeTransitionName = (0, $lIysR.activeTransitionNameSelector)(state);
    const destinationStatus = (0, $lIysR.activeTransitionDestinationStatusSelector)(state);
    return {
        source: activeTransitionName || '',
        sourceStatus: (0, $9OPlz.draggingCardSourceStatusSelector)(state),
        isTransitionGlobal: (0, $lIysR.isActiveTransitionGlobalSelector)(state),
        target: destinationStatus && destinationStatus.name || '',
        targetStatusCategory: destinationStatus && destinationStatus.category || (0, $gULOk.UNDEFINED)
    };
};
var $427a5a447ae7148b$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($427a5a447ae7148b$var$mapStateToProps, {})((0, $kkSEu.default));

});
parcelRegister("kkSEu", function(module, exports) {

$parcel$export(module.exports, "default", () => $1dd9a8cfbc4fe651$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h1TKi = parcelRequire("h1TKi");

var $8RBk4 = parcelRequire("8RBk4");

var $2EwJD = parcelRequire("2EwJD");
const $1dd9a8cfbc4fe651$var$ColumnHeaderTransitionOverlay = /*#__PURE__*/ (0, $5uXOq.memo)(({ isTransitionGlobal: isTransitionGlobal, target: target, targetStatusCategory: targetStatusCategory, source: source, sourceStatus: sourceStatus })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd9a8cfbc4fe651$var$Container, {
        "data-testid": "platform-board-kit.ui.column.column-header-transition-overlay.container"
    }, isTransitionGlobal && sourceStatus && sourceStatus.category ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: sourceStatus.category,
        name: sourceStatus.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1dd9a8cfbc4fe651$var$TransitionNameContainer, null, source), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1TKi))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8RBk4))),
        LEGACY_size: "small",
        color: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: targetStatusCategory,
        name: target
    })));
var $1dd9a8cfbc4fe651$export$2e2bcd8739ae039 = $1dd9a8cfbc4fe651$var$ColumnHeaderTransitionOverlay;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1dd9a8cfbc4fe651$var$TransitionNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1p1dangw _k48p1wq8 _syaz131l",
            __cmplp.className
        ])
    });
});
const $1dd9a8cfbc4fe651$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q71kw7 _11c8dcr7 _kqswstnw _1bsbr0r7 _4t3ickbl _1pbyegat _4cvr1h6o _1bah1e5h _1e0c1txw _18u019bv _17kn15vq _1hrp15vq _pxtlidpf _136lidpf _1xi51wug _x3fa1l2s _10ca1q9c",
            __cmplp.className
        ])
    });
});
const $1dd9a8cfbc4fe651$export$7ed12d2a5241e393 = {
    Container: $1dd9a8cfbc4fe651$var$Container
};

});
parcelRegister("2EwJD", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd41c6095391bfc6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3u0c5 = parcelRequire("3u0c5");

var $gULOk = parcelRequire("gULOk");
const $cd41c6095391bfc6$var$statusCategoryToAppearenceMap = {
    [(0, $gULOk.UNDEFINED)]: 'default',
    [(0, $gULOk.TODO)]: 'default',
    [(0, $gULOk.DONE)]: 'success',
    [(0, $gULOk.IN_PROGRESS)]: 'inprogress'
};
class $cd41c6095391bfc6$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isActive: false
        };
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            testId: "common-components-status-lozenge.status-lozenge",
            isBold: this.props.isActive,
            appearance: $cd41c6095391bfc6$var$statusCategoryToAppearenceMap[this.props.category],
            maxWidth: this.props.isFullWidth ? '100%' : undefined
        }, this.props.name);
    }
}

});



parcelRegister("9FKJv", function(module, exports) {

$parcel$export(module.exports, "default", () => $3aec8f195c0804ac$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $9dZ1c = parcelRequire("9dZ1c");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $4R6GH = parcelRequire("4R6GH");

var $16E0T = parcelRequire("16E0T");

var $a3p8w = parcelRequire("a3p8w");

var $3t5QD = parcelRequire("3t5QD");

var $jOXuX = parcelRequire("jOXuX");


var $2xFXk = parcelRequire("2xFXk");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $63LqY = parcelRequire("63LqY");

var $aXl6d = parcelRequire("aXl6d");
const $3aec8f195c0804ac$var$ColumnHeaderView = (props)=>{
    const { isDone: isDone, isLastColumn: isLastColumn, ...otherProps } = props;
    const isCMPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard));
    const isIncrementPlanningBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const isFlexibleColumns = (0, $63LqY.useCapability)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS);
    const shouldRemoveSpaceForMenu = isCMPBoard || isIncrementPlanningBoard;
    const hasGrouping = (0, $aXl6d.useHasGroupingStyle)();
    const { ref: tailorBoardColumnsNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4), (0, $4R6GH.fg)('board_nudge_bugfix') && isLastColumn);
    const renderBoardKitColumnHeader = (columnHeaderWrapperRef)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16E0T.default), {
            columnHeaderWrapperRef: columnHeaderWrapperRef,
            isDone: isDone,
            ...otherProps,
            isCMPBoard: isCMPBoard,
            shouldRemoveSpaceForMenu: shouldRemoveSpaceForMenu,
            isFlexibleColumns: isFlexibleColumns,
            isMatrixLayout: hasGrouping
        });
    if (isLastColumn) {
        if ((0, $4R6GH.fg)('board_nudge_bugfix')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: "DoneNotLastColumnMessage"
        }, renderBoardKitColumnHeader(tailorBoardColumnsNudgeRef)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
            engagementId: "DoneNotLastColumnMessage"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a3p8w.TailorBoardColumnsAsyncChildless), null));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
            conditionsToApplyWrapper: !isCMPBoard && (0, $jOXuX.isTailoredOnboardingEnabled)(),
            Wrapper: (0, $a3p8w.TailorBoardColumnsAsync)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
            name: "DoneNotLastColumnMessage"
        }, renderBoardKitColumnHeader())), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
            engagementId: "DoneNotLastColumnMessage"
        }));
    }
    if (isDone) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "DoneColumnMessage"
    }, renderBoardKitColumnHeader()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: "DoneColumnMessage"
    }));
    return renderBoardKitColumnHeader();
};
var $3aec8f195c0804ac$export$2e2bcd8739ae039 = $3aec8f195c0804ac$var$ColumnHeaderView;

});
parcelRegister("a3p8w", function(module, exports) {

$parcel$export(module.exports, "TailorBoardColumnsAsync", () => $f5a655db25e59df8$export$e4d6b2cdb1678ee0);
$parcel$export(module.exports, "TailorBoardColumnsAsyncChildless", () => $f5a655db25e59df8$export$ae5357db2691b909);

var $5uXOq = parcelRequire("5uXOq");

var $9dZ1c = parcelRequire("9dZ1c");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4R6GH = parcelRequire("4R6GH");

var $7XYc4 = parcelRequire("7XYc4");

var $cE2Qr = parcelRequire("cE2Qr");



var $7oe20 = parcelRequire("7oe20");
const $f5a655db25e59df8$var$runtimeProps = {};
const $f5a655db25e59df8$var$entryPointParams = {};
const $f5a655db25e59df8$var$TailorBoardColumnsAsyncOld = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7oe20.tailorBoardColumnsNudgeEntryPoint), $f5a655db25e59df8$var$entryPointParams);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
    }, [
        entryPointActions
    ]);
    const { ref: tailorBoardColumnsNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: tailorBoardColumnsNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$573d4bf1da6d2bc6),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $f5a655db25e59df8$var$runtimeProps
    }));
};
const $f5a655db25e59df8$var$TailorBoardColumnsAsyncNew = ({ children: children })=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7oe20.tailorBoardColumnsNudgeEntryPoint), $f5a655db25e59df8$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    const { ref: tailorBoardColumnsNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4), true);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: tailorBoardColumnsNudgeRef
    }, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$573d4bf1da6d2bc6),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $f5a655db25e59df8$var$runtimeProps
    }));
};
const $f5a655db25e59df8$export$e4d6b2cdb1678ee0 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('tailored_onboarding_m3_gate'), $f5a655db25e59df8$var$TailorBoardColumnsAsyncNew, $f5a655db25e59df8$var$TailorBoardColumnsAsyncOld);
const $f5a655db25e59df8$export$ae5357db2691b909 = ()=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $7oe20.tailorBoardColumnsNudgeEntryPoint), $f5a655db25e59df8$var$entryPointParams);
    const [nudgeStep] = (0, $cE2Qr.useNudgeStep)();
    const [hasNudgeActive] = (0, $cE2Qr.useHasNudgeActive)();
    const firstLoadRef = (0, $5uXOq.useRef)(true);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (firstLoadRef.current && hasNudgeActive && nudgeStep === (0, $6784cbc7d62e5d7c$export$6ffa29e74c0304c4)) {
            entryPointActions.load();
            firstLoadRef.current = false;
        }
    }, [
        entryPointActions,
        hasNudgeActive,
        nudgeStep
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: (0, $dbbf68c32d8c4308$export$573d4bf1da6d2bc6),
        packageName: "jiraBoardOnboarding",
        entryPointReferenceSubject: entryPointReferenceSubject,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null),
        runtimeProps: $f5a655db25e59df8$var$runtimeProps
    }));
};

});
parcelRegister("7oe20", function(module, exports) {

$parcel$export(module.exports, "tailorBoardColumnsNudgeEntryPoint", () => $279fd837d49de3a4$export$13278346f7fe314b);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $279fd837d49de3a4$export$13278346f7fe314b = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5QwO6")), {
        moduleId: "d4273c47"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5QwO6", function(module, exports) {

let $441b41e2adc548fb$var$load = (parcelRequire("28QjX"))(4);
module.exports = $441b41e2adc548fb$var$load("cKVf8").then(()=>parcelRequire('38BJH'));

});





parcelRegister("iTH7p", function(module, exports) {

$parcel$export(module.exports, "default", () => $ea88f6081a2d2640$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $gJBT6 = parcelRequire("gJBT6");

var $az4zD = parcelRequire("az4zD");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");


var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $lw9Ef = parcelRequire("lw9Ef");
const $ea88f6081a2d2640$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((columnIndex)=>({
        columnIndex: columnIndex + 1
    }));
const $ea88f6081a2d2640$export$c31df4bd766f9c35 = (state, ownProps)=>{
    const columnIndex = (0, $fyeGd.getColumnIndex)(state, ownProps.columnId);
    const hasDoneIssues = (0, $d2i8f.getDoneIssuesInColumn)(state)(ownProps.columnId).length > 0;
    const isClearDoneIssueVisible = !(0, $ebHh7.isSprintsEnabled)(state) && hasDoneIssues && !(0, $67Z81.getIsCMPBoard)(state);
    const anyColumnUpdating = (0, $5mTgl.isAnyColumnUpdating)(state);
    const isVisible = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && ((0, $5mTgl.isInlineColumnEditEnabled)(state) || isClearDoneIssueVisible) && !anyColumnUpdating;
    return {
        externalId: 'platform.board.column.meatball',
        externalValues: $ea88f6081a2d2640$var$getExternalValues(columnIndex),
        isDisabled: !isVisible
    };
};
const $ea88f6081a2d2640$var$connector = (0, $bC2fB.connect)($ea88f6081a2d2640$export$c31df4bd766f9c35, {});
const $ea88f6081a2d2640$var$ConnectedMenu = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('dropdownMenuItem', {
    onOpenChange: 'opened'
}), $ea88f6081a2d2640$var$connector)((0, $lw9Ef.default));
const $ea88f6081a2d2640$var$MenuWithIntl = (0, $az4zD.injectIntlV2)($ea88f6081a2d2640$var$ConnectedMenu);
var $ea88f6081a2d2640$export$2e2bcd8739ae039 = $ea88f6081a2d2640$var$MenuWithIntl;

});
parcelRegister("lw9Ef", function(module, exports) {

$parcel$export(module.exports, "default", () => $4802bcd7783f0508$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $1I7E8 = parcelRequire("1I7E8");

var $BLPHT = parcelRequire("BLPHT");
var $aRoVz = parcelRequire("aRoVz");

var $bJeNF = parcelRequire("bJeNF");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $cE2Qr = parcelRequire("cE2Qr");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $3t5QD = parcelRequire("3t5QD");

var $9kssn = parcelRequire("9kssn");

var $dCm1o = parcelRequire("dCm1o");

var $lu5k0 = parcelRequire("lu5k0");

var $7mPT9 = parcelRequire("7mPT9");

var $fMLbE = parcelRequire("fMLbE");

var $hyV8h = parcelRequire("hyV8h");

var $1dfpa = parcelRequire("1dfpa");

var $6NYsr = parcelRequire("6NYsr");

var $j0bcP = parcelRequire("j0bcP");

var $4Ys5a = parcelRequire("4Ys5a");
const $4802bcd7783f0508$export$63c08433f699fdb7 = (props)=>{
    const { columnId: columnId, externalValues: externalValues, title: title, onOpenChange: onOpenChange, onVisibilityChange: onVisibilityChange, intl: { formatMessage: formatMessage }, isDisabled: isDisabled = false, isDefaultOpen: isDefaultOpen = false } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isDefaultOpen);
    const [isOnboardingDismissed] = (0, $cE2Qr.useIsDismissed)();
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const moreActionsButtonRef = (0, $5uXOq.useRef)(null);
    const handleOpenChange = (attrs)=>{
        setIsOpen(attrs.isOpen);
        onOpenChange(attrs);
    };
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        onOpenChange({
            isOpen: false
        });
    }, [
        onOpenChange
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
        onOpenChange({
            isOpen: false
        });
    }, [
        onOpenChange
    ]);
    const toggleMenu = (open)=>()=>{
            if (onVisibilityChange) {
                onVisibilityChange(open);
                setIsOpen(open);
            }
        };
    const onTriggerClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((open)=>!open);
    }, []);
    const popupRenderTrigger = (triggerProps)=>{
        return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
            label: formatMessage((0, $4Ys5a.default).dropdownMenuAriaLabel, {
                heading: title
            }),
            testId: "software-board.board-container.board.column.header.menu.column-menu-trigger",
            onClick: onTriggerClick,
            ...(0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? {
                isTooltipDisabled: false,
                tooltip: {
                    content: formatMessage((0, $4Ys5a.default).moreActionsTooltip),
                    hideTooltipOnClick: true
                }
            } : {}
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "More actions",
                color: "var(--ds-icon, #44546F)"
            }),
            testId: "software-board.board-container.board.column.header.menu.column-menu-trigger",
            onClick: onTriggerClick,
            "aria-label": formatMessage((0, $4Ys5a.default).dropdownMenuAriaLabelOld, {
                heading: title
            })
        });
    };
    const renderTrigger = ({ triggerRef: triggerRef, ...triggerProps })=>{
        const ref = (0, $7mPT9.mergeRefs)(moreActionsButtonRef, triggerRef);
        return (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            ...triggerProps,
            ref: ref,
            appearance: "subtle",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))),
            testId: "software-board.board-container.board.column.header.menu.column-menu-trigger",
            label: formatMessage((0, $4Ys5a.default).dropdownMenuAriaLabel, {
                heading: title
            }),
            ...(0, $4R6GH.fg)('visual-refresh-meatball-menu-button-tooltips') ? {
                isTooltipDisabled: false,
                tooltip: {
                    content: formatMessage((0, $4Ys5a.default).moreActionsTooltip),
                    hideTooltipOnClick: true
                }
            } : {}
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            appearance: "subtle",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bJeNF))), {
                label: "More actions",
                color: "var(--ds-icon, #44546F)"
            }),
            testId: "software-board.board-container.board.column.header.menu.column-menu-trigger",
            "aria-label": formatMessage((0, $4Ys5a.default).dropdownMenuAriaLabelOld, {
                heading: title
            }),
            ref: ref
        });
    };
    const handleMenuItemClick = (0, $5uXOq.useCallback)(()=>{
        // To get return focus on Delete modal cancel or dismiss
        setReturnFocusTo(moreActionsButtonRef);
        handleClick();
    }, [
        handleClick,
        setReturnFocusTo
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j0bcP.ColumnHeaderMenuGroup), {
            columnId: columnId,
            isDisabled: isDisabled,
            onClick: handleClick,
            onMenuItemClick: handleMenuItemClick
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
            action: "toggled",
            actionSubject: "dropdownMenu"
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)), [
        columnId,
        isDisabled,
        handleClick,
        handleMenuItemClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4802bcd7783f0508$var$MeatballMenuButtonBackground, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "columnSettings",
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        attributes: {
            columnId: columnId,
            columnIndex: externalValues.columnIndex
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3t5QD.ConditionalNudgeWrapper), {
        Wrapper: (0, $9kssn.BoardInProgressColumnNudgeAsync),
        conditionsToApplyWrapper: !isOnboardingDismissed && externalValues.columnIndex === 2,
        onShow: toggleMenu(true),
        onHide: toggleMenu(false)
    }, (0, $4R6GH.fg)('horizn_490_consolidate_old_issues_in_board') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-end",
        trigger: popupRenderTrigger,
        content: content
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isOpen,
        onOpenChange: handleOpenChange,
        trigger: renderTrigger,
        placement: "bottom-end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NYsr.default), {
        columnId: columnId,
        direction: "left",
        isDisabled: isDisabled,
        onClick: handleClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NYsr.default), {
        columnId: columnId,
        direction: "right",
        isDisabled: isDisabled,
        onClick: handleClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dfpa.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleMenuItemClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMLbE.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hyV8h.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleMenuItemClick
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "toggled",
        actionSubject: "dropdownMenu"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null)))));
};
const $4802bcd7783f0508$export$684af8e980532017 = (Menu)=>(props)=>props.isDisabled ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, props);
const $4802bcd7783f0508$export$5453d852c5696a78 = $4802bcd7783f0508$export$684af8e980532017($4802bcd7783f0508$export$63c08433f699fdb7);
var $4802bcd7783f0508$export$2e2bcd8739ae039 = $4802bcd7783f0508$export$5453d852c5696a78;
const $4802bcd7783f0508$var$MeatballBackgroundAnimation = /*#__PURE__*/ (0, $47bDC.keyframes)({
    '0%': {
        opacity: 0
    },
    '100%': {
        opacity: 1
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4802bcd7783f0508$var$MeatballMenuButtonBackground = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-150y470-0"
})({
    animation: `${$4802bcd7783f0508$var$MeatballBackgroundAnimation} 0.2s ease forwards`,
    background: "var(--ds-background-neutral, #091E420F)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    borderRadius: `${(0, $gwIPs.borderRadius)}px`
});

});
parcelRegister("9kssn", function(module, exports) {

$parcel$export(module.exports, "BoardInProgressColumnNudgeAsync", () => $72c66e4455352260$export$3f0f67bcde6861c2);

var $5uXOq = parcelRequire("5uXOq");

var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $72c66e4455352260$var$BoardInProgressColumnNudgeLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("4BhR8")).then((exportedModule)=>exportedModule.BoardInProgressNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/kanban-onboarding-tour/board-in-progress-column/index.tsx"
});
const $72c66e4455352260$export$3f0f67bcde6861c2 = ({ children: children, ...restProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $dbbf68c32d8c4308$export$f2fe211acb4aa81a),
        fallback: children,
        attributes: {
            nudgeId: (0, $dbbf68c32d8c4308$export$4db327e1949c2108)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-kanban-onboarding-board-in-progress-column-nudge",
        fallback: children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($72c66e4455352260$var$BoardInProgressColumnNudgeLazy, restProps, children)));
$72c66e4455352260$export$3f0f67bcde6861c2.displayName = 'BoardInProgressColumnNudgeAsync';

});
parcelRegister("4BhR8", function(module, exports) {

let $359877ef0b1751d4$var$load = (parcelRequire("28QjX"))(4);
module.exports = $359877ef0b1751d4$var$load("2z8ya").then(()=>parcelRequire('jxAnH'));

});


parcelRegister("fMLbE", function(module, exports) {

$parcel$export(module.exports, "default", () => $0b89d206e63a02bd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $chc6P = parcelRequire("chc6P");

var $8QpSo = parcelRequire("8QpSo");

var $7Jxgt = parcelRequire("7Jxgt");

var $k12ix = parcelRequire("k12ix");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $aHYmi = parcelRequire("aHYmi");

var $4G04L = parcelRequire("4G04L");

var $iuuJH = parcelRequire("iuuJH");

var $hz3OZ = parcelRequire("hz3OZ");

var $hnvrw = parcelRequire("hnvrw");

var $2f454 = parcelRequire("2f454");

var $fyeGd = parcelRequire("fyeGd");

var $3UY9S = parcelRequire("3UY9S");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $egWyf = parcelRequire("egWyf");
const $0b89d206e63a02bd$export$c31df4bd766f9c35 = ()=>{
    const doneCardsChildrenFactory = (0, $8QpSo.default)((doneCards, state)=>(0, (/*@__PURE__*/$parcel$interopDefault($chc6P)))(doneCards, (issue)=>(0, $3UY9S.getChildrenOfParent)(state)(issue.id)));
    return (state, ownProps)=>{
        const { columnId: columnId } = ownProps;
        const doneCards = (0, $d2i8f.getDoneIssuesInColumn)(state)(columnId);
        const boardId = (0, $67Z81.rapidViewIdSelector)(state);
        const resolvedIssuesUrl = (0, $hnvrw.getResolvedIssuesUrl)((0, $67Z81.contextPathSelector)(state), (0, $67Z81.projectKeySelector)(state));
        const columnIndex = (0, $fyeGd.getColumnIndex)(state, columnId);
        const column = (0, $fyeGd.getColumnById)(state, columnId);
        const isLastColumn = (0, $fyeGd.isDoneColumn)(column);
        const numColumnsOnBoard = (0, $5mTgl.workColumnsSelector)(state).length;
        // Indirectly these sub-tasks will be cleared, so we'll collect them to perform the optimistic
        // update
        const doneCardsChildren = doneCardsChildrenFactory(doneCards, state);
        const isVisible = !(0, $ebHh7.isSprintsEnabled)(state) && (0, $d2i8f.makeDoesColumnContainDoneCardsSelector)(state)(columnId) && !(0, $67Z81.getIsCMPBoard)(state);
        const isSubtaskSwimlaneModeSelected = (0, $45cXl.getSwimlaneMode)(state) === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id;
        const isDisabled = ownProps.isDisabled || isSubtaskSwimlaneModeSelected;
        return {
            isVisible: isVisible,
            isDisabled: isDisabled,
            isLastColumn: isLastColumn,
            doneCards: doneCards,
            doneCardsChildren: doneCardsChildren,
            boardId: boardId,
            resolvedIssuesUrl: resolvedIssuesUrl,
            columnIndex: columnIndex,
            numColumnsOnBoard: numColumnsOnBoard
        };
    };
};
const $0b89d206e63a02bd$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $0b89d206e63a02bd$var$onClickFactory = (0, $8QpSo.default)((doneCards, doneCardsChildren, dispatch, onClick, isLastColumn, columnIndex, numColumnsOnBoard, numDoneCards, numDoneCardsChildren, clearCards, boardId, resolvedIssuesUrl)=>(event, analyticsEvent)=>{
        const concurrentId = (0, $7Jxgt.v4)();
        (0, $hz3OZ.cardsClearInteraction)(concurrentId).start();
        const doneCardIds = doneCards.map((card)=>card.id);
        const action = (0, $2f454.cardClear)(doneCardIds, doneCardsChildren);
        const { meta: { optimistic: { id: optimisticId } } } = action;
        dispatch(action);
        (0, $4G04L.scheduleAfterRender)(()=>{
            (0, $hz3OZ.cardsClearInteraction)(concurrentId).mark('feedback');
        });
        onClick(event, analyticsEvent);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clearIssueDropdownMenuItem', {
            isLastColumn: isLastColumn,
            columnIndex: columnIndex,
            numColumnsOnBoard: numColumnsOnBoard,
            numParentIssues: numDoneCards,
            numSubtasks: numDoneCardsChildren
        });
        clearCards({
            boardId: boardId,
            cardIds: doneCardIds,
            resolvedIssuesUrl: resolvedIssuesUrl,
            onUndo: (undoPromise, retry)=>{
                const undoConcurrentId = (0, $7Jxgt.v4)();
                (0, $hz3OZ.cardsUnclearInteraction)(undoConcurrentId).start();
                dispatch((0, $2f454.cardClearUndo)(undoPromise, retry, optimisticId));
                (0, $4G04L.scheduleAfterRender)(()=>{
                    (0, $hz3OZ.cardsUnclearInteraction)(undoConcurrentId).mark('feedback');
                });
                undoPromise.then(()=>{
                    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issues uncleared', 'issuesUncleared', {
                        numParentIssues: numDoneCards,
                        numSubtasks: numDoneCardsChildren
                    });
                    (0, $4G04L.scheduleAfterRender)(()=>{
                        (0, $hz3OZ.cardsUnclearInteraction)(undoConcurrentId).stop({
                            customData: (0, $k12ix.getNormalisedPerformanceFFs)()
                        });
                    });
                }).catch(()=>{
                    (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issues unclearFailed');
                });
            },
            onUndoFlagDismissed: ()=>{
                dispatch((0, $2f454.cardClearSuccess)(optimisticId));
            }
        }).then(()=>{
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issues cleared', 'issuesCleared', {
                numParentIssues: numDoneCards,
                numSubtasks: numDoneCardsChildren
            });
            (0, $4G04L.scheduleAfterRender)(()=>{
                (0, $hz3OZ.cardsClearInteraction)(concurrentId).stop({
                    customData: (0, $k12ix.getNormalisedPerformanceFFs)()
                });
            });
        }).catch(()=>{
            dispatch((0, $2f454.cardClearFailure)(optimisticId));
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'issues clearFailed');
        });
    });
const $0b89d206e63a02bd$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { onClick: onClick, clearCards: clearCards } = ownProps;
    const { dispatch: dispatch } = dispatchProps;
    const { isVisible: isVisible, isDisabled: isDisabled, doneCards: doneCards, boardId: boardId, doneCardsChildren: doneCardsChildren, isLastColumn: isLastColumn, columnIndex: columnIndex, numColumnsOnBoard: numColumnsOnBoard, resolvedIssuesUrl: resolvedIssuesUrl } = stateProps;
    const numDoneCards = doneCards.length;
    const numDoneCardsChildren = doneCardsChildren.length;
    return {
        isVisible: isVisible,
        numDoneCards: numDoneCards,
        isDisabled: isDisabled,
        onClick: $0b89d206e63a02bd$var$onClickFactory(doneCards, doneCardsChildren, dispatch, onClick, isLastColumn, columnIndex, numColumnsOnBoard, numDoneCards, numDoneCardsChildren, clearCards, boardId, resolvedIssuesUrl)
    };
};
const $0b89d206e63a02bd$var$ItemClearAllWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('dropdownMenuItem', {
    onClick: 'clicked'
})((0, $egWyf.default));
const $0b89d206e63a02bd$var$HideableItem = ({ isVisible: isVisible, onClick: onClick, numDoneCards: numDoneCards, isDisabled: isDisabled })=>isVisible ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b89d206e63a02bd$var$ItemClearAllWithAnalytics, {
        onClick: onClick,
        numDoneCards: numDoneCards,
        isDisabled: isDisabled
    }) : null;
const $0b89d206e63a02bd$var$ConnectedClearMenuItem = (0, $bC2fB.connect)($0b89d206e63a02bd$export$c31df4bd766f9c35, $0b89d206e63a02bd$export$9e6a17cf56877796, $0b89d206e63a02bd$export$9d1611c77c2fe928)($0b89d206e63a02bd$var$HideableItem);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$0b89d206e63a02bd$export$2e2bcd8739ae039 = (props)=>{
    const [clearCards] = (0, $aHYmi.useClearCards)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0b89d206e63a02bd$var$ConnectedClearMenuItem, {
        ...props,
        clearCards: clearCards
    });
};

});
parcelRegister("aHYmi", function(module, exports) {

$parcel$export(module.exports, "useClearCards", () => $500604bfe83c7b49$export$4536e3f12af4ca28);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $4tEQ4 = parcelRequire("4tEQ4");

var $lbgzx = parcelRequire("lbgzx");

var $1m9QN = parcelRequire("1m9QN");

var $5DKw8 = parcelRequire("5DKw8");
const $500604bfe83c7b49$export$4536e3f12af4ca28 = ()=>{
    const [clearMutation] = (0, $1m9QN.useClearCardsMutation)();
    const [unclearCards] = (0, $5DKw8.useUnclearCards)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const flagId = (0, $5uXOq.useRef)();
    const onDismissFlag = (0, $5uXOq.useCallback)(()=>{
        if (flagId.current) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        dismissFlag(flagId.current);
    }, [
        dismissFlag
    ]);
    const callback = (0, $5uXOq.useCallback)(({ cardIds: cardIds, boardId: boardId, onUndo: onUndo, onUndoFlagDismissed: onUndoFlagDismissed, resolvedIssuesUrl: resolvedIssuesUrl })=>{
        const clearMutationPromise = clearMutation({
            variables: {
                cardIds: cardIds,
                boardId: boardId
            }
        });
        const onUndoCallback = ()=>{
            unclearCards({
                cardIds: cardIds,
                boardId: boardId,
                onUndo: onUndo
            });
        };
        clearMutationPromise.then(()=>{
            flagId.current = showFlag({
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbgzx.default), {
                        resolvedIssuesUrl: resolvedIssuesUrl,
                        numDoneCards: cardIds.length,
                        onUndo: ()=>{
                            onUndoCallback();
                            onDismissFlag();
                        },
                        onDismiss: ()=>{
                            onUndoFlagDismissed && onUndoFlagDismissed();
                            onDismissFlag();
                        },
                        ...props
                    })
            });
        }).catch((error)=>{
            showFlag((0, $4tEQ4.getErrorFlag)(error));
        });
        return clearMutationPromise;
    }, [
        clearMutation,
        onDismissFlag,
        showFlag,
        unclearCards
    ]);
    return [
        callback
    ];
};

});
parcelRegister("lbgzx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9122bd0d211e432f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2Yv61 = parcelRequire("2Yv61");

var $2hXfb = parcelRequire("2hXfb");

var $6s1PB = parcelRequire("6s1PB");

var $7R4eB = parcelRequire("7R4eB");

var $f2BYd = parcelRequire("f2BYd");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");

var $lDOSI = parcelRequire("lDOSI");
const $9122bd0d211e432f$var$UndoFlag = ({ intl: { formatMessage: formatMessage }, onUndo: onUndo, onDismiss: onDismiss, numDoneCards: numDoneCards, resolvedIssuesUrl: resolvedIssuesUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "flag",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2BYd.default), {
        onDismissed: onDismiss
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
        messageId: "software-board-clearing.common.ui.undo-flag.auto-dismiss-flag",
        messageType: "transactional",
        id: "software-board-clearing.ui.undo-flag",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
            color: "var(--ds-icon-discovery, #8270DB)",
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
            LEGACY_primaryColor: "var(--ds-icon-discovery, #8270DB)",
            label: ""
        }),
        actions: [
            {
                content: formatMessage((0, $lDOSI.default).undo),
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clearIssuesFlagUndoClearIssuesLink');
                    onUndo();
                }
            },
            {
                content: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lDOSI.default).viewIssuesIssueTermRefresh : (0, $lDOSI.default).viewIssues),
                href: resolvedIssuesUrl,
                onClick: (_, analyticsEvent)=>{
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clearIssuesFlagViewIssuesLink');
                }
            }
        ],
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lDOSI.default).titleIssueTermRefresh : (0, $lDOSI.default).title, {
            numDoneCards: numDoneCards
        }),
        description: formatMessage((0, $lDOSI.default).description, {
            numDoneCards: numDoneCards
        })
    })));
var $9122bd0d211e432f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($9122bd0d211e432f$var$UndoFlag);

});
parcelRegister("f2BYd", function(module, exports) {

$parcel$export(module.exports, "default", () => $3780c7e328dbb70e$export$2e2bcd8739ae039);

var $3KRpp = parcelRequire("3KRpp");
var // eslint-disable-next-line @atlassian/eng-health/no-barrel-files/disallow-reexports
$3780c7e328dbb70e$export$2e2bcd8739ae039 = (0, $3KRpp.FlagGroup);

});

parcelRegister("lDOSI", function(module, exports) {

$parcel$export(module.exports, "default", () => $16186a699408e99d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $16186a699408e99d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-board-clearing.common.undo-flag.title",
        "defaultMessage": "{numDoneCards, plural, one {Issue cleared from board} other {{numDoneCards} done issues cleared}}"
    },
    description: {
        "id": "software-board-clearing.common.undo-flag.description",
        "defaultMessage": "{numDoneCards, plural, one {It is still in your project, and you can search for it later if you need to.} other {They\u2019re still in your project, and you can search for them later if you need to.}}"
    },
    undo: {
        "id": "software-board-clearing.common.undo-flag.undo",
        "defaultMessage": "Undo"
    },
    viewIssues: {
        "id": "software-board-clearing.common.undo-flag.view-issues",
        "defaultMessage": "View done issues"
    },
    titleIssueTermRefresh: {
        "id": "software-board-clearing.common.undo-flag.title-issue-term-refresh",
        "defaultMessage": "{numDoneCards, plural, one {Work item cleared from board} other {{numDoneCards} done work items cleared}}"
    },
    viewIssuesIssueTermRefresh: {
        "id": "software-board-clearing.common.undo-flag.view-issues-issue-term-refresh",
        "defaultMessage": "View everything marked as done"
    }
});

});


parcelRegister("1m9QN", function(module, exports) {

$parcel$export(module.exports, "useClearCardsMutation", () => $b86eb0f67d9b1f7f$export$8e192ef7c7961fa6);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $b86eb0f67d9b1f7f$export$7473a9a03a67999e = (0, $5cllN.default)`
    mutation SoftwareBoardClearCards($boardId: ID!, $cardIds: [ID!]!) {
        clearCards(input: { boardId: $boardId, cardIds: $cardIds }) {
            clearedCardIds
        }
    }
`;
const $b86eb0f67d9b1f7f$export$8e192ef7c7961fa6 = ()=>(0, $5tTFS.useMutation)($b86eb0f67d9b1f7f$export$7473a9a03a67999e);

});

parcelRegister("5DKw8", function(module, exports) {

$parcel$export(module.exports, "useUnclearCards", () => $7e3afb1b0787ecbf$export$1fe06fa658396c74);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $cCTcJ = parcelRequire("cCTcJ");

var $5YqMH = parcelRequire("5YqMH");

var $39X7C = parcelRequire("39X7C");
const $7e3afb1b0787ecbf$export$1fe06fa658396c74 = ()=>{
    const [unclearMutation] = (0, $39X7C.useUnclearCardsMutation)();
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    const errorFlagId = (0, $5uXOq.useRef)();
    const onDismissUndoErrorFlag = (0, $5uXOq.useCallback)(()=>{
        if (errorFlagId.current) // @ts-expect-error - TS2345 - Argument of type 'unknown' is not assignable to parameter of type 'string'.
        dismissFlag(errorFlagId.current);
    }, [
        dismissFlag
    ]);
    const callback = (0, $5uXOq.useCallback)(({ cardIds: cardIds, boardId: boardId, onUndo: onUndo, retry: retry })=>{
        const unclearMutationPromise = unclearMutation({
            variables: {
                cardIds: cardIds.map(String),
                boardId: String(boardId)
            }
        });
        unclearMutationPromise.then(()=>{
            retry === true && showFlag((0, $5YqMH.default)());
        }).catch(()=>{
            errorFlagId.current = showFlag({
                render: (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cCTcJ.default), {
                        onDismissFlag: onDismissUndoErrorFlag,
                        onRetry: ()=>callback({
                                cardIds: cardIds,
                                boardId: boardId,
                                onUndo: onUndo,
                                retry: true
                            }),
                        ...props
                    })
            });
        });
        onUndo && onUndo(unclearMutationPromise, !!retry);
    }, [
        onDismissUndoErrorFlag,
        showFlag,
        unclearMutation
    ]);
    return [
        callback
    ];
};

});
parcelRegister("cCTcJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $f168e1da31227080$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $1wpPp = parcelRequire("1wpPp");

var $az4zD = parcelRequire("az4zD");

var $gPMiB = parcelRequire("gPMiB");
function $f168e1da31227080$var$UndoErrorFlag({ intl: { formatMessage: formatMessage }, onRetry: onRetry, onDismissFlag: onDismissFlag }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1wpPp.default), {
        messageId: "software-board-clearing.common.ui.undo-error-flag.error-flag",
        messageType: "transactional",
        id: "undo-clear-error",
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gPMiB.default).titleIssueTermRefresh : (0, $gPMiB.default).title),
        description: formatMessage((0, $gPMiB.default).description),
        actions: [
            {
                content: formatMessage((0, $gPMiB.default).tryAgain),
                onClick: ()=>{
                    onRetry();
                    onDismissFlag();
                }
            }
        ]
    });
}
var $f168e1da31227080$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($f168e1da31227080$var$UndoErrorFlag);

});
parcelRegister("gPMiB", function(module, exports) {

$parcel$export(module.exports, "default", () => $a686a0f1a58782f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a686a0f1a58782f6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-board-clearing.common.undo-error-flag.title",
        "defaultMessage": "We couldn\u2019t restore your cleared issues."
    },
    description: {
        "id": "software-board-clearing.common.undo-error-flag.description",
        "defaultMessage": "Please check your connection."
    },
    tryAgain: {
        "id": "software-board-clearing.common.undo-error-flag.try-again",
        "defaultMessage": "Try again"
    },
    titleIssueTermRefresh: {
        "id": "software-board-clearing.common.undo-error-flag.title-issue-term-refresh",
        "defaultMessage": "We couldn\u2019t restore your cleared work items."
    }
});

});


parcelRegister("5YqMH", function(module, exports) {

$parcel$export(module.exports, "default", () => $29857646ea9debd4$export$2e2bcd8739ae039);

var $6s1PB = parcelRequire("6s1PB");

var $lmI0r = parcelRequire("lmI0r");
const $29857646ea9debd4$var$UndoSuccessFlag = {
    messageId: 'software-board-clearing.common.ui.undo-success-flag.undo-success-flag.success.flag.success',
    messageType: 'transactional',
    title: (0, $lmI0r.default).title,
    type: 'success',
    isAutoDismiss: true
};
const $29857646ea9debd4$var$UndoSuccessFlagIssueTermRefresh = {
    messageId: 'software-board-clearing.common.ui.undo-success-flag.undo-success-flag-issue-term-refresh.success.flag.issue-term-refresh-success',
    messageType: 'transactional',
    title: (0, $lmI0r.default).titleIssueTermRefresh,
    type: 'success',
    isAutoDismiss: true
};
const $29857646ea9debd4$var$getUndoSuccessFlagConfigurations = ()=>{
    return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? $29857646ea9debd4$var$UndoSuccessFlagIssueTermRefresh : $29857646ea9debd4$var$UndoSuccessFlag;
};
var $29857646ea9debd4$export$2e2bcd8739ae039 = $29857646ea9debd4$var$getUndoSuccessFlagConfigurations;

});
parcelRegister("lmI0r", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba39561928a01ce$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1ba39561928a01ce$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software-board-clearing.common.undo-success-flag.title",
        "defaultMessage": "We have restored your cleared issues"
    },
    titleIssueTermRefresh: {
        "id": "software-board-clearing.common.undo-success-flag.title-issue-term-refresh",
        "defaultMessage": "We have restored your cleared work items"
    }
});

});


parcelRegister("39X7C", function(module, exports) {

$parcel$export(module.exports, "useUnclearCardsMutation", () => $4414cfd486952a48$export$be434ee83fc040d1);

var $5tTFS = parcelRequire("5tTFS");

var $5cllN = parcelRequire("5cllN");
const $4414cfd486952a48$export$7473a9a03a67999e = (0, $5cllN.default)`
    mutation SoftwareBoardUnclearCards($boardId: ID!, $cardIds: [ID!]!) {
        unclearCards(input: { boardId: $boardId, cardIds: $cardIds }) {
            message
            statusCode
        }
    }
`;
const $4414cfd486952a48$export$be434ee83fc040d1 = ()=>(0, $5tTFS.useMutation)($4414cfd486952a48$export$7473a9a03a67999e);

});



parcelRegister("hnvrw", function(module, exports) {

$parcel$export(module.exports, "getResolvedIssuesUrl", () => $fde7b6b408203dc7$export$1df843d83726e46b);
$parcel$export(module.exports, "getOldIssuesUrl", () => $fde7b6b408203dc7$export$6fc0da5ddeff094d);
const $fde7b6b408203dc7$var$appendAgilityReferrer = (url)=>`${url}&referrer=agility`;
const $fde7b6b408203dc7$export$628e089b9efd0cc4 = (contextPath, projectKey)=>`${contextPath}/projects/${projectKey}/issues`;
const $fde7b6b408203dc7$export$52a00adb39521b8b = (contextPath, projectKey)=>`${contextPath}/jira/software/projects/${projectKey}/issues/`;
const $fde7b6b408203dc7$export$1df843d83726e46b = (contextPath, projectKey)=>$fde7b6b408203dc7$var$appendAgilityReferrer(`${$fde7b6b408203dc7$export$52a00adb39521b8b(contextPath, projectKey)}?filter=doneissues`);
const $fde7b6b408203dc7$export$6fc0da5ddeff094d = (contextPath, projectKey)=>`${contextPath}/issues/?jql=${encodeURIComponent(`project = ${projectKey} AND (fixVersion in unreleasedVersions() OR fixVersion is EMPTY) AND statusCategory = Done AND updated <= -2w ORDER BY Rank ASC`)}`;

});

parcelRegister("egWyf", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0bfb7b8ca1e3e21$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $3bDjY = parcelRequire("3bDjY");

var $kJpBP = parcelRequire("kJpBP");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $5e9QP = parcelRequire("5e9QP");
const $e0bfb7b8ca1e3e21$export$27a5bd065ad55220 = ({ onClick: onClick, numDoneCards: numDoneCards, isDisabled: isDisabled })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnClick = (event)=>{
        onClick(event, createAnalyticsEvent({
            actionSubject: 'dropdownMenuItem',
            action: 'clicked'
        }));
    };
    const menuItemClearAll = (0, $4R6GH.fg)('horizn_490_consolidate_old_issues_in_board') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: handleOnClick,
        isDisabled: isDisabled,
        "data-testid": "software-board.board-container.board.column.header.menu.item-clear-all",
        role: "menuitem"
    }, formatMessage((0, $5e9QP.default).labelRemoveRightNow)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleOnClick,
        isDisabled: isDisabled,
        "data-testid": "software-board.board-container.board.column.header.menu.item-clear-all"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $5e9QP.default).labelIssueTermRefresh : (0, $5e9QP.default).label, {
        numDoneCards: numDoneCards
    }));
    if (isDisabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $5e9QP.default).tooltip)
    }, menuItemClearAll);
    return menuItemClearAll;
};
var $e0bfb7b8ca1e3e21$export$2e2bcd8739ae039 = $e0bfb7b8ca1e3e21$export$27a5bd065ad55220;

});
parcelRegister("5e9QP", function(module, exports) {

$parcel$export(module.exports, "default", () => $36518315b7680ab8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $36518315b7680ab8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software.main.board-container.board.column.header.menu.item-clear-all.label",
        "defaultMessage": "{numDoneCards, plural, one {Clear 1 Done issue} other {Clear {numDoneCards} Done issues}}"
    },
    tooltip: {
        "id": "software.main.board-container.board.column.header.menu.item-clear-all.tooltip",
        "defaultMessage": "Unavailable when grouping by subtask"
    },
    labelIssueTermRefresh: {
        "id": "software.main.board-container.board.column.header.menu.item-clear-all.label-issue-term-refresh",
        "defaultMessage": "{numDoneCards, plural, one {Clear 1 Done work item} other {Clear {numDoneCards} Done work items}}"
    },
    labelRemoveRightNow: {
        "id": "software.main.board-container.board.column.header.menu.item-clear-all.label-remove-right-now",
        "defaultMessage": "Remove right now"
    }
});

});



parcelRegister("hyV8h", function(module, exports) {

$parcel$export(module.exports, "default", () => $557d95e634861f29$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");


var $63F6h = parcelRequire("63F6h");

var $1vXOx = parcelRequire("1vXOx");

var $5mTgl = parcelRequire("5mTgl");

var $hopHY = parcelRequire("hopHY");
const $557d95e634861f29$var$mapStateToProps = (state, props)=>({
        isDisabled: props.isDisabled || !(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || !(0, $5mTgl.isInlineColumnEditEnabled)(state),
        isLastRemainingColumn: (0, $5mTgl.isLastRemainingColumn)(state),
        hasIssues: (0, $5mTgl.doesColumnHaveIssuesSelector)(state)(props.columnId),
        hasIssuesNotOnBoard: (0, $5mTgl.hasIssuesNotOnBoard)(state)(props.columnId)
    });
const $557d95e634861f29$var$mapDispatchToProps = {
    columnDelete: $63F6h.columnDelete
};
const $557d95e634861f29$var$onClickFactory = (0, $8QpSo.default)((onClick, dispatchPropsColumnDelete, columnId, hasIssues, statePropsHasIssuesNotOnBoard)=>()=>{
        onClick();
        dispatchPropsColumnDelete(columnId, hasIssues, statePropsHasIssuesNotOnBoard);
    });
const $557d95e634861f29$var$mergeProps = (stateProps, dispatchProps, props)=>({
        isDisabled: stateProps.isDisabled,
        isLastRemainingColumn: stateProps.isLastRemainingColumn,
        onClick: $557d95e634861f29$var$onClickFactory(props.onClick, dispatchProps.columnDelete, props.columnId, stateProps.hasIssues, stateProps.hasIssuesNotOnBoard)
    });
const $557d95e634861f29$var$connector = (0, $bC2fB.connect)($557d95e634861f29$var$mapStateToProps, $557d95e634861f29$var$mapDispatchToProps, $557d95e634861f29$var$mergeProps);
const $557d95e634861f29$var$ColumnDeleteMenuItemWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('columnSettingsDeleteMenuItem', {
    onClick: 'clicked'
})((0, $hopHY.default));
var $557d95e634861f29$export$2e2bcd8739ae039 = $557d95e634861f29$var$connector($557d95e634861f29$var$ColumnDeleteMenuItemWithAnalytics);

});
parcelRegister("hopHY", function(module, exports) {

$parcel$export(module.exports, "default", () => $b437cd12b63fd37e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $3bDjY = parcelRequire("3bDjY");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $ewsTZ = parcelRequire("ewsTZ");
const $b437cd12b63fd37e$var$DATA_TEST_ID = 'software-board.board-container.board.column.header.menu.item-delete.dropdown-item';
const $b437cd12b63fd37e$export$301cfb4be78b5e8c = ({ isLastRemainingColumn: isLastRemainingColumn, isDisabled: isDisabled, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnClick = (0, $5uXOq.useCallback)(()=>{
        onClick();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'columnSettingsDeleteMenuItem',
            action: 'clicked'
        }));
    }, [
        onClick,
        createAnalyticsEvent
    ]);
    const renderDropdownItem = (0, $5uXOq.useCallback)((disabled)=>(0, $4R6GH.fg)('horizn_490_consolidate_old_issues_in_board') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            "data-testid": $b437cd12b63fd37e$var$DATA_TEST_ID,
            isDisabled: disabled,
            onClick: handleOnClick,
            role: "menuitem"
        }, formatMessage((0, $ewsTZ.default).delete)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            "data-testid": $b437cd12b63fd37e$var$DATA_TEST_ID,
            isDisabled: disabled,
            onClick: handleOnClick
        }, formatMessage((0, $ewsTZ.default).delete)), [
        formatMessage,
        handleOnClick
    ]);
    return isLastRemainingColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $ewsTZ.default).lastColumn)
    }, renderDropdownItem(true)) : renderDropdownItem(isDisabled);
};
const $b437cd12b63fd37e$var$hideableMenuItem = (MenuItem)=>(props)=>!props.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, props) : null;
var $b437cd12b63fd37e$export$2e2bcd8739ae039 = $b437cd12b63fd37e$var$hideableMenuItem($b437cd12b63fd37e$export$301cfb4be78b5e8c);

});
parcelRegister("ewsTZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa674a2de77eae11$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fa674a2de77eae11$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    delete: {
        "id": "software.main.board-container.board.column.header.menu.item-delete.delete",
        "defaultMessage": "Delete"
    },
    lastColumn: {
        "id": "software.main.board-container.board.column.header.menu.item-delete.last-column",
        "defaultMessage": "The last column can't be deleted"
    }
});

});



parcelRegister("1dfpa", function(module, exports) {

$parcel$export(module.exports, "default", () => $418b172c815c723d$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");


var $9eeht = parcelRequire("9eeht");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $cbScZ = parcelRequire("cbScZ");
const $418b172c815c723d$export$c31df4bd766f9c35 = (state, props)=>({
        isDisabled: props.isDisabled || !(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || !(0, $5mTgl.isInlineColumnEditEnabled)(state) || (0, $67Z81.getIsCMPBoard)(state) && !(0, $5mTgl.boardColumnConstraintTypeSelector)(state)
    });
const $418b172c815c723d$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $418b172c815c723d$var$onClickFactory = (0, $8QpSo.default)((dispatch, columnId, onClick)=>()=>{
        dispatch((0, $9eeht.columnOpenLimitsModal)(columnId));
        onClick();
    });
const $418b172c815c723d$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { columnId: columnId, onClick: onClick } = ownProps;
    const { dispatch: dispatch } = dispatchProps;
    const { isDisabled: isDisabled } = stateProps;
    return {
        isDisabled: isDisabled,
        onClick: $418b172c815c723d$var$onClickFactory(dispatch, columnId, onClick)
    };
};
const $418b172c815c723d$var$connector = (0, $bC2fB.connect)($418b172c815c723d$export$c31df4bd766f9c35, $418b172c815c723d$export$9e6a17cf56877796, $418b172c815c723d$export$9d1611c77c2fe928);
var $418b172c815c723d$export$2e2bcd8739ae039 = $418b172c815c723d$var$connector((0, $cbScZ.default));

});
parcelRegister("cbScZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9f3e674e825776f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $5vXbo = parcelRequire("5vXbo");
const $d9f3e674e825776f$export$2f25159957e16b83 = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return (0, $4R6GH.fg)('horizn_490_consolidate_old_issues_in_board') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-board.board-container.board.column.header.menu.item-limits",
        isDisabled: props.isDisabled,
        onClick: props.onClick,
        role: "menuitem"
    }, formatMessage((0, $5vXbo.default).displayText)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        "data-testid": "software-board.board-container.board.column.header.menu.item-limits",
        isDisabled: props.isDisabled,
        onClick: props.onClick
    }, formatMessage((0, $5vXbo.default).displayText));
};
const $d9f3e674e825776f$export$398d8a1ba03cb49f = (MenuItem)=>(props)=>!props.isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(MenuItem, props) : null;
var $d9f3e674e825776f$export$2e2bcd8739ae039 = $d9f3e674e825776f$export$398d8a1ba03cb49f($d9f3e674e825776f$export$2f25159957e16b83);

});
parcelRegister("5vXbo", function(module, exports) {

$parcel$export(module.exports, "default", () => $0f5d70e141274817$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0f5d70e141274817$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.board-container.board.column.header.menu.item-limits.display-text",
        "defaultMessage": "Set column limit"
    }
});

});



parcelRegister("6NYsr", function(module, exports) {

$parcel$export(module.exports, "default", () => $69308e798e68b4c7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2OMDV = parcelRequire("2OMDV");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $55fEr = parcelRequire("55fEr");

var $63LqY = parcelRequire("63LqY");

var $67sX6 = parcelRequire("67sX6");

var $aCAYr = parcelRequire("aCAYr");
const $69308e798e68b4c7$var$ItemMoveWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('dropdownMenuItem', {
    onClick: 'clicked'
})((0, $aCAYr.default));
const $69308e798e68b4c7$var$ItemMove = (props)=>{
    const { columnId: columnId, direction: direction, isDisabled: _isDisabled, onClick: _onClick } = props;
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const orderedColumnIds = (0, $67sX6.useBoardSelector)((0, $67Z81.getOrderedColumnIds));
    const sourceColumnIndex = orderedColumnIds?.indexOf(columnId);
    const numColumnsOnBoard = (0, $67sX6.useBoardSelector)((0, $5mTgl.workColumnsSelector)).length;
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const isOutOfBound = ()=>{
        if (direction === 'left') return sourceColumnIndex === 0;
        if (direction === 'right') return sourceColumnIndex === numColumnsOnBoard - 1;
        return false;
    };
    const isDisabled = _isDisabled || isOutOfBound() || !!isIPBoard;
    const destinationColumnIndex = direction === 'left' ? sourceColumnIndex - 1 : sourceColumnIndex + 1;
    const onClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        if (!isIPBoard) dispatch((0, $55fEr.columnRankRequest)(Number(columnId), orderedColumnIds[destinationColumnIndex], sourceColumnIndex, analyticsEvent));
        _onClick(event, analyticsEvent);
    }, [
        columnId,
        destinationColumnIndex,
        dispatch,
        isIPBoard,
        _onClick,
        orderedColumnIds,
        sourceColumnIndex
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($69308e798e68b4c7$var$ItemMoveWithAnalytics, {
        isDisabled: isDisabled,
        direction: direction,
        onClick: onClick
    });
};
var $69308e798e68b4c7$export$2e2bcd8739ae039 = $69308e798e68b4c7$var$ItemMove;

});
parcelRegister("aCAYr", function(module, exports) {

$parcel$export(module.exports, "default", () => $64b78b01171b4634$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $cZdmg = parcelRequire("cZdmg");

var $9xan6 = parcelRequire("9xan6");
const $64b78b01171b4634$export$dd266048993b1cf8 = ({ onClick: onClick, isDisabled: isDisabled, direction: direction })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { setScreenReaderText: setScreenReaderText } = (0, $cZdmg.useScreenReader)();
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: direction === 'left' ? 'columnSettingsMoveLeftMenuItem' : 'columnSettingsMoveRightMenuItem',
            action: 'clicked'
        });
        setScreenReaderText?.(formatMessage((0, $9xan6.default).columnMoved, {
            direction: direction
        }));
        onClick(event, analyticsEvent);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        createAnalyticsEvent,
        direction,
        onClick,
        setScreenReaderText,
        formatMessage
    ]);
    if (isDisabled) return null;
    return (0, $4R6GH.fg)('horizn_490_consolidate_old_issues_in_board') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: handleOnClick,
        isDisabled: isDisabled,
        role: "menuitem",
        "data-testid": `software-board.board-container.board.column.header.menu.item-move-${direction}.dropdown-item`
    }, direction === 'left' ? formatMessage((0, $9xan6.default).moveLeft) : formatMessage((0, $9xan6.default).moveRight)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        onClick: handleOnClick,
        isDisabled: isDisabled,
        "data-testid": `software-board.board-container.board.column.header.menu.item-move-${direction}.dropdown-item`
    }, direction === 'left' ? formatMessage((0, $9xan6.default).moveLeft) : formatMessage((0, $9xan6.default).moveRight));
};
var $64b78b01171b4634$export$2e2bcd8739ae039 = $64b78b01171b4634$export$dd266048993b1cf8;

});
parcelRegister("9xan6", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d62e7328e44f4a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4d62e7328e44f4a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveLeft: {
        "id": "software.main.board-container.board.column.header.menu.item-move-left.label",
        "defaultMessage": "Move column to the left"
    },
    moveRight: {
        "id": "software.main.board-container.board.column.header.menu.item-move-right.label",
        "defaultMessage": "Move column to the right"
    },
    columnMoved: {
        "id": "software.main.board-container.board.column.header.menu.item-moved.screen-reader",
        "defaultMessage": "Column moved to the {direction}"
    }
});

});



parcelRegister("j0bcP", function(module, exports) {

$parcel$export(module.exports, "ColumnHeaderMenuGroup", () => $4672fdc4230ad808$export$56ff751a2835794a);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $42CjB = parcelRequire("42CjB");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $3Qiip = parcelRequire("3Qiip");

var $hWZau = parcelRequire("hWZau");

var $koVbs = parcelRequire("koVbs");

var $fMLbE = parcelRequire("fMLbE");

var $hyV8h = parcelRequire("hyV8h");

var $1dfpa = parcelRequire("1dfpa");

var $6NYsr = parcelRequire("6NYsr");

var $3ySRG = parcelRequire("3ySRG");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $72Zqu = parcelRequire("72Zqu");
const $4672fdc4230ad808$export$56ff751a2835794a = ({ columnId: columnId, isDisabled: isDisabled = false, onClick: handleClick, onMenuItemClick: handleMenuItemClick })=>{
    const oldDoneIssuesCutoff = (0, $67sX6.useBoardSelector)((0, $67Z81.getOldDoneIssuesCutoffForTMPKanbanBoard));
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const stopEventPropagation = (0, $5uXOq.useCallback)((event)=>event.stopPropagation(), []);
    const removeDoneItemButtonRef = (0, $5uXOq.useRef)(null);
    const iconAfterMenuGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hWZau))), {
        label: "",
        LEGACY_size: "medium",
        spacing: "spacious"
    });
    const [isRemoveDoneItemOpen, setIsRemoveDoneItemOpen] = (0, $5uXOq.useState)(false);
    const handleOpenRemoveDoneItemClick = (0, $5uXOq.useCallback)(()=>{
        setIsRemoveDoneItemOpen(true);
    }, []);
    const handleCloseRemoveDoneItemClick = (0, $5uXOq.useCallback)(()=>{
        setIsRemoveDoneItemOpen(false);
        setTimeout(()=>{
            removeDoneItemButtonRef.current?.focus();
        }, 100);
    }, []);
    if (isRemoveDoneItemOpen) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        onClick: stopEventPropagation,
        role: "menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.0",
        justifyContent: "start",
        alignItems: "center",
        xcss: $4672fdc4230ad808$var$RemoveDoneItemHeaderStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        as: "h3",
        size: "xxsmall"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Qiip))),
        onClick: handleCloseRemoveDoneItemClick,
        spacing: "compact",
        appearance: "subtle",
        label: formatMessage((0, $72Zqu.default).removeDoneItemsBackButton)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        role: "presentation",
        xcss: $4672fdc4230ad808$var$TextSpacingStyle
    }, formatMessage((0, $72Zqu.default).headingRemoveDoneItemsAfter)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        isList: true
    }, oldDoneIssuesCutoff?.options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3ySRG.ItemOldDoneCutoffSelect), {
            key: option.value,
            option: option,
            selectedValue: oldDoneIssuesCutoff.oldDoneIssuesCutoff,
            onClick: handleCloseRemoveDoneItemClick
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fMLbE.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleClick
    })));
    const selectedLabel = oldDoneIssuesCutoff?.options.find((option)=>option.value === oldDoneIssuesCutoff.oldDoneIssuesCutoff)?.label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        onClick: stopEventPropagation,
        role: "menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, oldDoneIssuesCutoff && !isDisabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        iconAfter: iconAfterMenuGroup,
        onClick: handleOpenRemoveDoneItemClick,
        role: "menuitem",
        ref: removeDoneItemButtonRef,
        testId: "software-board.board-container.board.column.header.menu.menu-group.update-old-done-issues-cutoff"
    }, formatMessage((0, $72Zqu.default).removeDoneItemsAfter, {
        days: selectedLabel
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NYsr.default), {
        columnId: columnId,
        direction: "left",
        isDisabled: isDisabled,
        onClick: handleClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6NYsr.default), {
        columnId: columnId,
        direction: "right",
        isDisabled: isDisabled,
        onClick: handleClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1dfpa.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleMenuItemClick
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hyV8h.default), {
        columnId: columnId,
        isDisabled: isDisabled,
        onClick: handleMenuItemClick
    })));
};
const $4672fdc4230ad808$var$RemoveDoneItemHeaderStyle = (0, $8CUq3.xcss)({
    paddingBlock: 'space.150',
    paddingLeft: 'space.200',
    paddingRight: 'space.600'
});
const $4672fdc4230ad808$var$TextSpacingStyle = (0, $8CUq3.xcss)({
    marginLeft: 'space.100'
});

});
parcelRegister("3Qiip", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::50eb0536eed3191cdc1ef30e9478909d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2cc46ba193f64324$var$_react = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $2cc46ba193f64324$var$_chevronLeft = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("lRheX")));

var $2cc46ba193f64324$var$_chevronLeft2 = $2cc46ba193f64324$var$_interopRequireDefault((parcelRequire("nHhrH")));
function $2cc46ba193f64324$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChevronLeftIcon.
 * This component is ChevronLeftIcon, with `UNSAFE_fallbackIcon` set to "ChevronLeftIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $2cc46ba193f64324$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $2cc46ba193f64324$var$_react.default.createElement($2cc46ba193f64324$var$_chevronLeft.default, Object.assign({
        LEGACY_fallbackIcon: $2cc46ba193f64324$var$_chevronLeft2.default
    }, props));
$2cc46ba193f64324$var$ChevronLeftIcon.Name = 'ChevronLeftIconMigration';
var $2cc46ba193f64324$var$_default = module.exports.default = $2cc46ba193f64324$var$ChevronLeftIcon;

});
parcelRegister("lRheX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::29f3eb59553566fe46c3ae42f5cce545>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $fe9bebc953515e63$var$_react = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $fe9bebc953515e63$var$_baseNew = $fe9bebc953515e63$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $fe9bebc953515e63$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for collapse side nav and to indicate previous in dates.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $fe9bebc953515e63$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $fe9bebc953515e63$var$_react.default.createElement($fe9bebc953515e63$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m4.06 6 3.97-3.97L6.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$fe9bebc953515e63$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $fe9bebc953515e63$var$_default = module.exports.default = $fe9bebc953515e63$var$ChevronLeftIcon;

});

parcelRegister("nHhrH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0473b8ae11c957a6$var$_react = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0473b8ae11c957a6$var$_chevronLeft = $0473b8ae11c957a6$var$_interopRequireDefault((parcelRequire("ks8FD")));
function $0473b8ae11c957a6$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0473b8ae11c957a6$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $0473b8ae11c957a6$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M13.706 9.698a.99.99 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .99.99 0 0 0 0-1.407l-2.318-2.297z"/></svg>`
    }, props, {
        newIcon: $0473b8ae11c957a6$var$_chevronLeft.default
    }));
$0473b8ae11c957a6$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $0473b8ae11c957a6$var$_default = module.exports.default = $0473b8ae11c957a6$var$ChevronLeftIcon;

});
parcelRegister("ks8FD", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9d5b8c4a4b8259ad2ac099d079c39acc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ee3d25fb52825f26$var$_react = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ee3d25fb52825f26$var$_baseNew = $ee3d25fb52825f26$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ee3d25fb52825f26$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ee3d25fb52825f26$var$ChevronLeftIcon = (props)=>/*#__PURE__*/ $ee3d25fb52825f26$var$_react.default.createElement($ee3d25fb52825f26$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" d="m9.97 1.47-6 6a.75.75 0 0 0-.052 1.004l.052.056 6 6 1.06-1.06L5.56 8l5.47-5.47z"/>`
    }, props));
$ee3d25fb52825f26$var$ChevronLeftIcon.displayName = 'ChevronLeftIcon';
var $ee3d25fb52825f26$var$_default = module.exports.default = $ee3d25fb52825f26$var$ChevronLeftIcon;

});



parcelRegister("3ySRG", function(module, exports) {

$parcel$export(module.exports, "ItemOldDoneCutoffSelect", () => $cd15202db19f14d8$export$bdea03b4dad3fa72);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $ky7e4 = parcelRequire("ky7e4");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koVbs = parcelRequire("koVbs");

var $67sX6 = parcelRequire("67sX6");

var $bdfJC = parcelRequire("bdfJC");

var $kfVbm = parcelRequire("kfVbm");
const $cd15202db19f14d8$export$bdea03b4dad3fa72 = (props)=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { option: option, selectedValue: selectedValue, onClick: onClick } = props;
    const iconCheckmark = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ky7e4))), {
        label: formatMessage((0, $kfVbm.default).selected),
        LEGACY_size: "medium",
        spacing: "spacious",
        color: "var(--ds-text-selected, #0C66E4)"
    });
    const handleOnClick = (0, $5uXOq.useCallback)((event)=>{
        const analyticsEvent = createAnalyticsEvent({
            actionSubject: 'dropdownMenuItem',
            action: 'clicked'
        });
        dispatch((0, $bdfJC.updateOldDoneIssuesCutoffRequest)(option.value));
        onClick(event, analyticsEvent);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
    }, [
        createAnalyticsEvent,
        dispatch,
        option.value,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        key: option.value,
        iconAfter: option.value === selectedValue ? iconCheckmark : null,
        onClick: handleOnClick,
        role: "menuitem"
    }, option.label);
};

});
parcelRegister("ky7e4", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4eca488eebd24f6b0c74ed2566069d9c>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ef5c96854bbf6178$var$_react = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ef5c96854bbf6178$var$_checkMark = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("bjo8S")));

var $ef5c96854bbf6178$var$_check = $ef5c96854bbf6178$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $ef5c96854bbf6178$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: table cells, checkboxes.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ef5c96854bbf6178$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $ef5c96854bbf6178$var$_react.default.createElement($ef5c96854bbf6178$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $ef5c96854bbf6178$var$_check.default
    }, props));
$ef5c96854bbf6178$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $ef5c96854bbf6178$var$_default = module.exports.default = $ef5c96854bbf6178$var$CheckMarkIcon;

});

parcelRegister("kfVbm", function(module, exports) {

$parcel$export(module.exports, "default", () => $1214dac153600617$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1214dac153600617$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    selected: {
        "id": "software.main.board-container.board.column.header.menu.item-old-done-cutoff-select.selected",
        "defaultMessage": "Selected"
    }
});

});


parcelRegister("72Zqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $022c247fb65a2f3a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $022c247fb65a2f3a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    headingRemoveDoneItemsAfter: {
        "id": "software.main.board-container.board.column.header.menu.menu-group.heading-remove-done-items-after",
        "defaultMessage": "Remove done items after"
    },
    selected: {
        "id": "software.main.board-container.board.column.header.menu.menu-group.selected",
        "defaultMessage": "Selected"
    },
    removeDoneItemsBackButton: {
        "id": "software.main.board-container.board.column.header.menu.menu-group.remove-done-items-back-button",
        "defaultMessage": "Back"
    },
    removeDoneItemsAfter: {
        "id": "software.main.board-container.board.column.header.menu.menu-group.remove-done-items-after",
        "defaultMessage": "Remove done items after {days}"
    }
});

});


parcelRegister("4Ys5a", function(module, exports) {

$parcel$export(module.exports, "default", () => $94e65005fa282389$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $94e65005fa282389$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownMenuAriaLabelOld: {
        "id": "software.main.board-container.board.column.header.menu.dropdown-menu-aria-label-old",
        "defaultMessage": "{heading} column"
    },
    dropdownMenuAriaLabel: {
        "id": "software.main.board-container.board.column.header.menu.dropdown-menu-aria-label",
        "defaultMessage": "{heading} column more actions"
    },
    moreActionsTooltip: {
        "id": "software.main.board-container.board.column.header.menu.more-actions-tooltip",
        "defaultMessage": "More actions"
    }
});

});



parcelRegister("50AZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $b553d312e832c6de$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $8QpSo = parcelRequire("8QpSo");

var $5rFbt = parcelRequire("5rFbt");


var $Gd7Ss = parcelRequire("Gd7Ss");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");


var $iuuJH = parcelRequire("iuuJH");

var $2f454 = parcelRequire("2f454");

var $63VRQ = parcelRequire("63VRQ");

var $1vXOx = parcelRequire("1vXOx");

var $kc6Ry = parcelRequire("kc6Ry");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");


var $dwtg8 = parcelRequire("dwtg8");
const $b553d312e832c6de$var$isCardDroppableFactory = (0, $8QpSo.default)((isIncrementPlanningBoard, isCMPBoard, swimlaneId, isRankable, id, showTransitionZonesOnThisColumn, draggingCardHoverIntent)=>(draggableCardData)=>{
        if (isIncrementPlanningBoard) return true;
        if (isCMPBoard) {
            if (swimlaneId && draggableCardData.swimlaneId !== swimlaneId) return false;
            if (!isRankable && draggableCardData.columnId === id) return false;
        }
        if (showTransitionZonesOnThisColumn && !draggingCardHoverIntent) return false;
        // Childless cards cannot be moved to a subtask type swimlane and vice-versa
        const sourceSwimlaneId = draggableCardData.swimlaneId;
        if (swimlaneId && (swimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS) && sourceSwimlaneId !== (0, $iuuJH.SWIMLANE_CHILDLESS) || swimlaneId !== (0, $iuuJH.SWIMLANE_CHILDLESS) && sourceSwimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS))) return false;
        return true;
    });
const $b553d312e832c6de$export$c31df4bd766f9c35 = ()=>{
    return (state, ownProps)=>{
        const { id: id, isLastSwimlane: isLastSwimlane, swimlaneId: swimlaneId } = ownProps;
        const column = (0, $fyeGd.getColumnById)(state, id);
        const childrenDropZoneType = ownProps.dropZoneType || (0, $5mTgl.getCardDndType)(state)(isLastSwimlane);
        const draggingCardSourceColumnId = (0, $9OPlz.draggingCardSourceColumnIdSelector)(state);
        const draggingCardSourceSwimlaneId = (0, $9OPlz.draggingCardSourceSwimlaneIdSelector)(state);
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        const anyColumnUpdating = (0, $5mTgl.isAnyColumnUpdating)(state);
        const hasDropZones = (0, $9OPlz.hasNonGlobalTransitions)(state) || (0, $fyeGd.hasMultipleStatusesPerColumn)(state) || (0, $lIysR.hasDifferentIssueTypeTransitionsInColumns)(state);
        const shouldShowDropZoneForSwimlane = ()=>{
            if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return (0, $5mTgl.isSwimlaneTransitionZoneEnabledForSubtask)(state)(isLastSwimlane);
            return true;
        };
        const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        const isRankable = (0, $67Z81.isBoardRankable)(state);
        const isDraggingSubtask = (0, $5mTgl.isDraggingSubtaskSelector)(state);
        const shouldDisableRank = !(0, $67Z81.isBoardRankable)(state);
        const hasNoTransition = isCMPBoard && (0, $9OPlz.hasNoTransitionSelector)(state);
        const isSourceColumn = draggingCardSourceColumnId === id;
        // for a multi-project board, when at lease one project is not rankable, we should show the transition zones
        const hasOneNotRankableProject = (0, $67Z81.isBoardRankable)(state) && Object.values((0, $67Z81.getIssueProjects)(state)).some((project)=>!project.canRank);
        // Software CMP projects are the only ones that can disable the transition in same column.
        const disableTransitionsInSameColumn = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).DISABLE_TRANSITION_IN_SAME_COLUMN) && isSourceColumn;
        const disableTransitionAcrossSwimlane = swimlaneId && swimlaneId !== draggingCardSourceSwimlaneId;
        const shouldShowTransitionZones = ()=>{
            if (isIncrementPlanningBoard) return false;
            if (anyColumnUpdating || draggingCardSourceColumnId == null || !shouldShowDropZoneForSwimlane()) return false;
            if (isCMPBoard) {
                if (disableTransitionAcrossSwimlane || disableTransitionsInSameColumn) return false;
                if (isDraggingSubtask || shouldDisableRank || hasNoTransition || hasOneNotRankableProject) return true;
            }
            return hasDropZones || (0, $9OPlz.hasConditionsOnTransitions)(state);
        };
        const showTransitionZonesOnThisColumn = column?.type === (0, $5rFbt.ColumnType).STATUS && shouldShowTransitionZones();
        const draggingCardHoverIntent = (0, $9OPlz.draggingCardHoverIntentSelector)(state);
        const isDraggingOverThisColumnWithHoverIntent = showTransitionZonesOnThisColumn && (0, $9OPlz.draggingCardTargetColumnIdSelector)(state) === id && draggingCardHoverIntent;
        const TransitionZones = showTransitionZonesOnThisColumn ? (0, $dwtg8.default) : undefined;
        const shouldDisableDrop = ()=>{
            if (isIncrementPlanningBoard) return false;
            if (isCMPBoard) {
                if (shouldDisableRank && draggingCardSourceColumnId === id) return true;
                if (disableTransitionAcrossSwimlane) return true;
            }
            return anyColumnUpdating || (0, $9OPlz.isDragInSnapMode)(state) && hasDropZones || showTransitionZonesOnThisColumn && (0, $lIysR.shouldDisableDropOnColumn)(state)(id);
        };
        const isDraggable = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$1d4594bb2516d9ef] && !isIncrementPlanningBoard && !anyColumnUpdating && (0, $5mTgl.isInlineColumnEditEnabled)(state) && !swimlaneId && (0, $9OPlz.getAnyCardEditingSummary)(state) === false;
        return {
            isDraggable: isDraggable,
            appearance: (0, $5mTgl.getColumnTheme)(state, id),
            isUpdating: (0, $5mTgl.isColumnUpdating)(state)(id),
            isDone: (0, $fyeGd.isDoneColumn)(column),
            isFlexible: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS),
            // passing ownProps
            id: ownProps.id,
            header: ownProps.header || null,
            children: ownProps.children || null,
            draggableIndex: ownProps.draggableIndex,
            footer: ownProps.footer || null,
            childrenDropZoneType: childrenDropZoneType,
            dropZoneMode: !false ? (0, $04f8b478903fce7b$export$32109232c094e11e) : (0, $04f8b478903fce7b$export$f64308b4d686711f),
            isLastSwimlane: ownProps.isLastSwimlane,
            isOutlined: isDraggingOverThisColumnWithHoverIntent,
            TransitionZones: TransitionZones,
            isDropDisabled: shouldDisableDrop(),
            swimlaneId: swimlaneId,
            isCardDroppable: $b553d312e832c6de$var$isCardDroppableFactory(isIncrementPlanningBoard, isCMPBoard, swimlaneId, isRankable, id, showTransitionZonesOnThisColumn, draggingCardHoverIntent)
        };
    };
};
const $b553d312e832c6de$var$mapDispatchToProps = (dispatch, ownProps)=>({
        dispatch: dispatch,
        onRename: (0, $3f2cs.bindActionCreators)((0, $63VRQ.columnRenameRequest), dispatch),
        onDragLeave: (dragType)=>{
            if (dragType === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) dispatch((0, $2f454.cardDragOverTransitionRequest)(null, ownProps.id, false));
        }
    });
var $b553d312e832c6de$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($b553d312e832c6de$export$c31df4bd766f9c35, $b553d312e832c6de$var$mapDispatchToProps)((0, $Gd7Ss.default));

});
parcelRegister("Gd7Ss", function(module, exports) {

$parcel$export(module.exports, "default", () => $7be4bd693aecce41$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i8wwL = parcelRequire("i8wwL");

var $fPZsD = parcelRequire("fPZsD");
const $7be4bd693aecce41$var$DraggableColumnMain = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8wwL.ColumnEdgeContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fPZsD.DraggableColumn), props));
var $7be4bd693aecce41$export$2e2bcd8739ae039 = $7be4bd693aecce41$var$DraggableColumnMain;

});
parcelRegister("fPZsD", function(module, exports) {

$parcel$export(module.exports, "DraggableColumn", () => $6d54eab38a21fed6$export$a80792b86712355c);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lmBAt = parcelRequire("lmBAt");

var $b8gJu = parcelRequire("b8gJu");

var $3kNE6 = parcelRequire("3kNE6");

var $5B6CN = parcelRequire("5B6CN");

var $gn6gY = parcelRequire("gn6gY");

var $lLx27 = parcelRequire("lLx27");
const $6d54eab38a21fed6$export$a80792b86712355c = (props)=>{
    const { id: id, isOutlined: isOutlined, swimlaneId: swimlaneId, TransitionZones: TransitionZones, isFlexible: isFlexible, isDraggable: isDraggable = false, isDropDisabled: isDropDisabled = false, isUpdating: isUpdating = false, isCollapsed: isCollapsed = false, header: header, draggableIndex: draggableIndex, appearance: appearance = (0, $3kNE6.ColumnTheme).Default, footer: footer = null, onDragLeave: onDragLeave, isCardDroppable: isCardDroppable, children: children, isMatrixLayout: isMatrixLayout } = props;
    const wrapperRef = (0, $5uXOq.useRef)(null);
    const { dragPreview: dragPreview, closestEdge: closestEdge } = (0, $gn6gY.useDraggableColumn)({
        isDraggable: isDraggable,
        elementRef: wrapperRef,
        columnId: id,
        swimlaneId: swimlaneId,
        columnIndex: draggableIndex,
        renderPreview: ()=>header,
        onDragLeave: onDragLeave,
        isCardDroppable: isCardDroppable,
        isMatrixLayout: isMatrixLayout
    });
    const handleOnMouseDown = (0, $5uXOq.useCallback)(()=>{
        // Clear any text selection to prevent unexpected dragging behaviour
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.getSelection()?.removeAllRanges();
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d54eab38a21fed6$export$1f99da106a398c44, {
        ref: wrapperRef,
        isCollapsed: isCollapsed,
        isFlexible: isFlexible,
        "data-component-selector": (0, $b8gJu.DRAGGABLE_COLUMN_SELECTOR_NAME),
        onMouseDown: handleOnMouseDown,
        // TODO: change to data-test-id to make integration tests work
        "data-testid": "platform-board-kit.ui.column.draggable-column.styled-wrapper",
        isMatrixLayout: isMatrixLayout
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d54eab38a21fed6$export$96bd54359ad61258, {
        isMatrixLayout: isMatrixLayout,
        isCollapsed: isCollapsed,
        isFlexible: isFlexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLx27.default), {
        id: id,
        swimlaneId: swimlaneId,
        isDraggable: isDraggable,
        isDragging: false,
        isDropDisabled: isDropDisabled,
        isOutlined: isOutlined,
        isUpdating: isUpdating,
        appearance: appearance,
        header: header,
        footer: footer,
        TransitionZones: TransitionZones,
        isCollapsed: isCollapsed,
        isFlexible: isFlexible,
        isMatrixLayout: isMatrixLayout
    }, children)), closestEdge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5B6CN.ColumnDropIndicator), {
        edge: closestEdge
    }), dragPreview);
};
const $6d54eab38a21fed6$export$1f99da106a398c44 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, isMatrixLayout: isMatrixLayout, isCollapsed: isCollapsed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v564stkc _kqswh2mm _1e0c1txw _2lx21bp4 _1wpz1wug",
            __cmplp.isFlexible ? "_16jlkb7n _1o9zkb7n _i0dlf1ug" : "_16jlkb7n _1o9zkb7n _i0dl1wug",
            !__cmplp.isMatrixLayout && "_1ul91t53 _p12f1t53",
            __cmplp.isCollapsed && !__cmplp.isFlexible && "_1ul91ex1 _p12f1ex1",
            __cmplp.isFlexible && "_1ul91qnl _p12f1osq",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ex1 _p12f1osq",
            __cmplp.className
        ])
    });
});
const $6d54eab38a21fed6$export$96bd54359ad61258 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDragging: isDragging, isCollapsed: isCollapsed, isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoi2wt _16jlkb7n _1o9zkb7n _i0dl1wug _v564stkc _1e0c1txw _2lx21bp4 _1wpz1wug _njlpl5mv _p12f1ogy _1ul91ogy",
            !(0, $lmBAt.getIsSoftwareThemingEnabled)() && "_18u01b66 _2hwx1b66",
            __cmplp.isDragging ? "_16qs1cd0" : "_16qsglyw",
            __cmplp.isCollapsed ? "_bfhk18uv" : "_bfhkm7j4",
            __cmplp.isCollapsed && !__cmplp.isFlexible && "_1ul91ylp _p12f1ylp",
            __cmplp.isFlexible && "_1ul91w81 _p12fglyw",
            __cmplp.isCollapsed && __cmplp.isFlexible && "_1ul91ylp _p12fglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("lLx27", function(module, exports) {

$parcel$export(module.exports, "default", () => $c37fcde6ece8122b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7nsd3 = parcelRequire("7nsd3");

var $47bDC = parcelRequire("47bDC");

var $5vD8v = parcelRequire("5vD8v");

var $hGgHi = parcelRequire("hGgHi");

var $645AZ = parcelRequire("645AZ");

var $3kNE6 = parcelRequire("3kNE6");

var $g503o = parcelRequire("g503o");

var $guHkC = parcelRequire("guHkC");

var $43IRS = parcelRequire("43IRS");
const $c37fcde6ece8122b$var$cardListCssClass = '__board-test-hook__column';
class $c37fcde6ece8122b$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            isDragging: false,
            isDropDisabled: false,
            isUpdating: false,
            isOutlined: false,
            isCollapsed: false,
            appearance: 'default',
            footer: null
        };
    }
    static{
        this.contextType = (0, $43IRS.TransitionZoneIndicatorContainerContext);
    }
    renderPortalTransitionZone() {
        const { id: id, swimlaneId: swimlaneId, TransitionZones: TransitionZones } = this.props;
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(TransitionZones)) return null;
        if (this.context) {
            const ref = this.context.getRef(id);
            if (ref && ref.current) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($7nsd3))).createPortal(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TransitionZones, {
                columnId: id,
                swimlaneId: swimlaneId
            }), ref.current);
        }
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TransitionZones, {
            columnId: id,
            swimlaneId: swimlaneId
        });
    }
    renderAkColumn(theme) {
        const { isDragging: isDragging, isDraggable: isDraggable, isOutlined: isOutlined, isUpdating: isUpdating, header: header, appearance: appearance, TransitionZones: TransitionZones, isCollapsed: isCollapsed, isFlexible: isFlexible } = this.props; // FIXME: This needs to be checked - done as part of typescript upgrade.
        // It can be more than ReactNode and typescript is not happy about this!
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const children = this.props.children;
        const renderChildren = ()=>{
            // If you want to use render props this component will give you back the props and some droppable
            // context for the external component to consume
            // Example: src/packages/software/board/board-container/board/columns-container/column/view.js
            if (!false && (0, (/*@__PURE__*/$parcel$interopDefault($5vD8v)))(this.props.children)) {
                // Our v-list under this column will need visibility over droppableProps
                const renderFunction = this.props.children || (()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null));
                return renderFunction(this.props);
            } // Fallback to generic non-virtualized implementation
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c37fcde6ece8122b$export$d969c1f3d7d90ef3 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            , {
                className: "__board-test-hook__card-list-container"
            }, children, this.props.footer);
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $47bDC.ThemeProvider), {
            theme: theme
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c37fcde6ece8122b$var$StyledColumnWrapper // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        , {
            className: $c37fcde6ece8122b$var$cardListCssClass,
            isCollapsed: isCollapsed,
            isFlexible: isFlexible,
            appearance: appearance ?? (0, $3kNE6.ColumnTheme).Default
        }, header && /*#__PURE__*/ (0, $5uXOq.cloneElement)(header, {
            isDragging: isDragging,
            isDraggable: isDraggable,
            isUpdating: isUpdating,
            appearance: appearance
        }), TransitionZones && this.renderPortalTransitionZone(), renderChildren(), isOutlined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c37fcde6ece8122b$export$5beeae30d1389e5, {
            withHeader: !!header
        }), isUpdating && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $guHkC.Overlay), {
            appearance: appearance ?? (0, $3kNE6.ColumnTheme).Default
        })));
    }
    render() {
        const columnTheme = this.getTheme(this.props.appearance);
        return this.renderAkColumn(columnTheme);
    }
    constructor(...args){
        super(...args), this.getTheme = (theme)=>{
            if (theme && (0, $g503o.columnThemes)[theme]) return (0, $g503o.columnThemes)[theme];
            return (0, $g503o.columnThemes).default;
        };
    }
}
const $c37fcde6ece8122b$var$outlineWidth = 2;
const $c37fcde6ece8122b$export$5beeae30d1389e5 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { withHeader: withHeader, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_xbj9jl": (0, $lD23V.default)(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            `calc(100% - ${__cmplp.withHeader ? (0, $645AZ.columnHeaderHeight) : 0}) + ${$c37fcde6ece8122b$var$outlineWidth * 2}px)`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko12x7 _189eyh40 _1dqonqa1 _1h6d1p6i _kqswstnw _1pbykb7n _18u01i6y _lcxvglyw _1ltvv77o _1bsbmslj _4t3i78vx",
            __cmplp.withHeader ? "_154i1lfg" : "_154iidpf",
            __cmplp.className
        ])
    });
});
const $c37fcde6ece8122b$export$d969c1f3d7d90ef3 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDisabled: isDisabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _ca0q1l7b _u5f314y2 _n3td14y2 _19bv14y2 _1tkeys9h",
            __cmplp.isDisabled ? "_tzy4105o" : "_tzy4kb7n",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $c37fcde6ece8122b$var$StyledColumnWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $g503o.ColumnWrapper), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});



const $04f8b478903fce7b$export$32109232c094e11e = 'virtual';
const $04f8b478903fce7b$export$f64308b4d686711f = 'standard';

parcelRegister("dwtg8", function(module, exports) {

$parcel$export(module.exports, "default", () => $369d4c4f4f82e4b2$export$2e2bcd8739ae039);

var $3JOCw = parcelRequire("3JOCw");

var $vNXgH = parcelRequire("vNXgH");

var $8QpSo = parcelRequire("8QpSo");

var $6s1PB = parcelRequire("6s1PB");

var $lyM0I = parcelRequire("lyM0I");

var $bC2fB = parcelRequire("bC2fB");

var $iuuJH = parcelRequire("iuuJH");

var $2f454 = parcelRequire("2f454");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $3Rsmm = parcelRequire("3Rsmm");
const $369d4c4f4f82e4b2$var$checkIfTransitionIsEqual = (source, target)=>Object.keys(source).filter((key)=>key !== 'transitionId').every((key)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        source[key] === // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        target[key]);
const $369d4c4f4f82e4b2$export$c31df4bd766f9c35 = ()=>{
    const deduplicatedTransitionsFactory = (0, $8QpSo.default)((transitions)=>(0, (/*@__PURE__*/$parcel$interopDefault($vNXgH)))(transitions, $369d4c4f4f82e4b2$var$checkIfTransitionIsEqual));
    return (state, ownProps)=>{
        const { columnId: columnId, swimlaneId: swimlaneId } = ownProps;
        const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
        const sourceColumnId = (0, $9OPlz.draggingCardSourceColumnIdSelector)(state) || 0;
        const { transitions: transitions, isLoading: isLoading } = (0, $lIysR.draggingIssueTransitionsForColumnSelector)(state)(Number(columnId));
        const sourceStatus = (0, $9OPlz.draggingCardSourceStatusSelector)(state);
        const showAllTransitionZones = (0, $lIysR.makeGetShowAllTransitionZones)(state)(swimlaneId);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
        // Determine IF there are duplicate target dropzones. This can be done if there are multiple
        // transitions that have the same target status Id.
        const shouldShowTransitionNames = (0, (/*@__PURE__*/$parcel$interopDefault($3JOCw)))(transitions, 'targetStatusId').length !== transitions.length;
        // We can still get duplicates here that we don't want to render. If they have the same transition name,
        // targetStatusId and isGlobal we DO NOT want to render them because they are fundamentally identical.
        const deduplicatedTransitions = deduplicatedTransitionsFactory(transitions);
        return {
            columnId: columnId,
            sourceColumnId: sourceColumnId,
            hasSwimlanes: hasSwimlanes,
            hoverIntent: (0, $9OPlz.draggingCardHoverIntentSelector)(state),
            columnDraggingOver: (0, $9OPlz.draggingCardTargetColumnIdSelector)(state) || null,
            notAvailableMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Rsmm.default).notAvailableMessageIssueTermRefresh : (0, $3Rsmm.default).notAvailableMessage,
            noTransitionMessage: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $3Rsmm.default).noTransitionMessageIssueTermRefresh : (0, $3Rsmm.default).noTransitionMessage,
            transitions: deduplicatedTransitions,
            isLoading: isLoading,
            sourceStatus: sourceStatus,
            showAllTransitionZones: showAllTransitionZones,
            shouldRenderFullColumnTransitionZone: isCMPBoard,
            hideSourceStatusInLabel: !shouldShowTransitionNames
        };
    };
};
const $369d4c4f4f82e4b2$export$9e6a17cf56877796 = (dispatch, { columnId: columnId, swimlaneId: swimlaneId })=>({
        onCardDragOver: (transitionId, hoverIntent)=>dispatch((0, $2f454.cardDragOverTransitionRequest)(transitionId, Number(columnId), hoverIntent)),
        onTransitionSelected: (transitionId)=>dispatch((0, $2f454.cardDragSelectedTransition)(transitionId, Number(columnId), swimlaneId))
    });
const $369d4c4f4f82e4b2$var$ConnectedColumnTransitionZonesContainer = (0, $bC2fB.connect)($369d4c4f4f82e4b2$export$c31df4bd766f9c35, $369d4c4f4f82e4b2$export$9e6a17cf56877796)((0, $lyM0I.ColumnTransitionZonesContainer));
var $369d4c4f4f82e4b2$export$2e2bcd8739ae039 = $369d4c4f4f82e4b2$var$ConnectedColumnTransitionZonesContainer;

});
parcelRegister("lyM0I", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZonesContainer", () => $35a2ac94dcf5015c$export$169a50ebb52c9a6);

var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $lFKmC = parcelRequire("lFKmC");

var $7gWdR = parcelRequire("7gWdR");

var $a2e2Q = parcelRequire("a2e2Q");

var $6cG4N = parcelRequire("6cG4N");

var $1fZVH = parcelRequire("1fZVH");

var $645AZ = parcelRequire("645AZ");

var $eEwGl = parcelRequire("eEwGl");

var $iVZBo = parcelRequire("iVZBo");

var $1oeFK = parcelRequire("1oeFK");


var $kMJOb = parcelRequire("kMJOb");
const $35a2ac94dcf5015c$export$169a50ebb52c9a6 = ({ columnId: columnId, swimlaneId: swimlaneId, columnDraggingOver: columnDraggingOver, onCardDragOver: onCardDragOver, hoverIntent: hoverIntent, onTransitionSelected: onTransitionSelected, hasSwimlanes: hasSwimlanes, sourceStatus: sourceStatus, notAvailableMessage: notAvailableMessage, noTransitionMessage: noTransitionMessage, isLoading: isLoading, shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, hideSourceStatusInLabel: hideSourceStatusInLabel, transitions: allTransitions, sourceColumnId: sourceColumnId, showAllTransitionZones: showAllTransitionZones })=>{
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [allowSelfColumnTransitions, setAllowSelfColumnTransitions] = (0, $5uXOq.useState)(false);
    const containerRef = (0, $5uXOq.useRef)(null);
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const hoverIntentOnThisColumn = hoverIntent && columnDraggingOver === columnId;
    const debouncedOnDragOverTransition = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((transitionId, hoverIntentOnZone)=>{
            if (!hoverIntentOnThisColumn) onCardDragOver(transitionId, hoverIntentOnZone);
        }, (0, $ff2886b69dd99cbd$export$c28377001f14d9d)), [
        hoverIntentOnThisColumn,
        onCardDragOver
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            debouncedOnDragOverTransition.cancel();
        }, [
        debouncedOnDragOverTransition
    ]);
    const onHoverOverTransitionToZone = (0, $5uXOq.useCallback)(()=>{
        setAllowSelfColumnTransitions(true);
    }, []);
    const renderTransitions = (transitions)=>{
        if (isLoading) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eEwGl.LoadingContainer), null);
        if (transitions.length === 0 && noTransitionMessage) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iVZBo.NoTransitionContainer), {
            noTransitionMessage: noTransitionMessage
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$819ff6ae0287a04, {
            hasSwimlanes: hasSwimlanes,
            zoneCount: transitions.length,
            shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
            "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.inner-container"
        }, transitions.map(({ transitionId: transitionId, transitionName: transitionName, targetStatusName: targetStatusName, targetStatusCategory: targetStatusCategory, isAvailable: isAvailable, targetStatusId: targetStatusId, isGlobal: isGlobal })=>{
            const filteredSourceStatus = sourceStatus?.id === targetStatusId ? null : sourceStatus;
            const filteredTransitionName = sourceStatus?.id === targetStatusId ? null : transitionName;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kMJOb.ColumnTransitionZone), {
                key: transitionId,
                isHidden: hoverIntent,
                transitionId: transitionId,
                transitionName: filteredTransitionName,
                targetStatusName: targetStatusName,
                onDragOver: debouncedOnDragOverTransition,
                targetStatusCategory: targetStatusCategory,
                isTransitionAvailable: isAvailable,
                isTransitionGlobal: isGlobal,
                notAvailableMessage: notAvailableMessage,
                sourceStatus: filteredSourceStatus,
                onTransitionSelection: onTransitionSelected,
                hideSourceStatusInLabel: hideSourceStatusInLabel,
                columnId: columnId,
                swimlaneId: swimlaneId
            });
        }));
    };
    (0, $5uXOq.useEffect)(()=>{
        if (!containerRef.current || isLoading || allTransitions.length === 0) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: containerRef.current,
            onDragLeave: ()=>{
                autobatch(()=>setAllowSelfColumnTransitions(false));
            }
        });
    }, [
        isLoading,
        allTransitions.length,
        allowSelfColumnTransitions,
        onCardDragOver,
        autobatch
    ]);
    let transitions = allTransitions;
    if (!showAllTransitionZones && columnId === sourceColumnId) {
        transitions = allTransitions.filter((t)=>!t.isGlobal || sourceStatus && t.targetStatusId !== sourceStatus.id);
        if (transitions.length === 0) return null;
    }
    if (!showAllTransitionZones && columnId === sourceColumnId && !allowSelfColumnTransitions && !hoverIntent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1oeFK.default), {
        onHover: onHoverOverTransitionToZone
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($35a2ac94dcf5015c$export$fb3bf400d073b5dd, {
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.outer-transition-container",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.outer-container",
        isHidden: !shouldRenderFullColumnTransitionZone && hoverIntent,
        hasSwimlanes: hasSwimlanes,
        shouldRenderFullColumnTransitionZone: Boolean(shouldRenderFullColumnTransitionZone),
        innerRef: containerRef,
        theme: hasSoftwareTheming ? {
            background: (0, $6cG4N.Tokens).COLOR_ELEVATION_SURFACE_SUNKEN
        } : undefined
    }, renderTransitions(transitions));
};
const $35a2ac94dcf5015c$export$819ff6ae0287a04 = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1064em4-0"
})`--full-column-height:calc( var(--board-scroll-element-height) * 1px - ${(0, $645AZ.columnHeaderHeight) + 8}px );position:sticky;width:100%;display:flex;flex-direction:column;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? (0, $645AZ.columnHeaderHeight) * 2 : (0, $645AZ.columnHeaderHeight)}px;transition:opacity 0.2s;background-color:${({ theme: theme })=>theme.background};height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : '100%'};max-height:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone, zoneCount: zoneCount })=>shouldRenderFullColumnTransitionZone ? 'var(--full-column-height)' : `${zoneCount * (0, $645AZ.columnHeaderHeight) * 2}px`};`;
const $35a2ac94dcf5015c$export$fb3bf400d073b5dd = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1064em4-1"
})`position:absolute;top:${({ hasSwimlanes: hasSwimlanes })=>hasSwimlanes ? 0 : (0, $645AZ.columnHeaderHeight)}px;height:100%;width:100%;z-index:${({ shouldRenderFullColumnTransitionZone: shouldRenderFullColumnTransitionZone })=>shouldRenderFullColumnTransitionZone ? (0, $645AZ.zIndex).fullColumnHeightTransitionZones : (0, $645AZ.zIndex).transitionZones};background-color:${({ theme: theme })=>theme.background};border-radius:${(0, $645AZ.layout).cardListRadius}px;${({ isHidden: isHidden })=>isHidden && 'display: none;'};`;

});
parcelRegister("eEwGl", function(module, exports) {

$parcel$export(module.exports, "LoadingContainer", () => $de32ae575a1b0c8f$export$5e3f251c730829);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");
function $de32ae575a1b0c8f$export$5e3f251c730829() {
    const [showSpinner, setShowSpinner] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>setShowSpinner(true), 1000);
        return ()=>clearTimeout(timeoutId);
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($de32ae575a1b0c8f$var$Wrapper, null, showSpinner ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    }) : null);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $de32ae575a1b0c8f$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _1e0c1txw _4t3i16xz _4cvr1h6o _1bah1h6o",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iVZBo", function(module, exports) {

$parcel$export(module.exports, "NoTransitionContainer", () => $160bf4691616f8f9$export$35d96e22ed839fc);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $koVbs = parcelRequire("koVbs");

var $fqH6b = parcelRequire("fqH6b");
function $160bf4691616f8f9$export$35d96e22ed839fc({ noTransitionMessage: noTransitionMessage }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = formatMessage(noTransitionMessage);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($160bf4691616f8f9$var$Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($160bf4691616f8f9$var$Img, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($fqH6b))),
        role: "presentation",
        alt: message
    }), message);
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $160bf4691616f8f9$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _kqsw1if8 _1e0c1txw _2lx21bp4 _4t3i16xz _4cvr1h6o _1bah1h6o _y3gn1h6o _syaz131l _ca0q1ejb _u5f31ejb _n3td1ejb _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $160bf4691616f8f9$var$Img = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1tcg _1bsb1tcg _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("fqH6b", function(module, exports) {
module.exports = new URL("restricted.65d4317c.svg", import.meta.url).toString();

});


parcelRegister("1oeFK", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f746fcf61f7b3f9$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $7gWdR = parcelRequire("7gWdR");

var $7VHMR = parcelRequire("7VHMR");
var $koVbs = parcelRequire("koVbs");

var $1fZVH = parcelRequire("1fZVH");

var $645AZ = parcelRequire("645AZ");
const $3f746fcf61f7b3f9$var$hoverIntentDelayMs = 100;
const $3f746fcf61f7b3f9$var$messages = (0, $7VHMR.defineMessages)({
    transitionTo: {
        "id": "platform-board-kit.column.column-transition-zones-container.transition-to-zone.transition-to",
        "defaultMessage": "Transition To..."
    }
});
const $3f746fcf61f7b3f9$var$ColumnTransitionToZone = ({ onHover: onHover })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const autobatch = (0, $1fZVH.useAutobatch)();
    const [isDraggingOver, setIsDraggingOver] = (0, $5uXOq.useState)(false);
    const batchSetIsDraggingOver = (0, $5uXOq.useCallback)((draggingOver)=>{
        autobatch(()=>setIsDraggingOver(draggingOver));
    }, [
        autobatch
    ]);
    const containerRef = (0, $5uXOq.useRef)(null);
    const previousInputPosition = (0, $5uXOq.useRef)(null);
    const debouncedHoverIntent = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(onHover, $3f746fcf61f7b3f9$var$hoverIntentDelayMs), [
        onHover
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!containerRef.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: containerRef.current,
            onDragEnter: ()=>{
                batchSetIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    debouncedHoverIntent();
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                debouncedHoverIntent.cancel();
                batchSetIsDraggingOver(false);
            }
        });
    }, [
        batchSetIsDraggingOver,
        debouncedHoverIntent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3f746fcf61f7b3f9$var$TransitionToZone, {
        isDraggingOver: isDraggingOver,
        ref: containerRef,
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone.transition-to-zone",
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-to-zone"
    }, formatMessage($3f746fcf61f7b3f9$var$messages.transitionTo));
};
var $3f746fcf61f7b3f9$export$2e2bcd8739ae039 = $3f746fcf61f7b3f9$var$ColumnTransitionToZone;
const $3f746fcf61f7b3f9$var$ttZoneHeight = (0, $645AZ.minCardHeight) * 0.5 - 5;
const $3f746fcf61f7b3f9$var$ttZoneMargin = (0, $645AZ.layout).adg3smallGutter * 0.5;
const $3f746fcf61f7b3f9$var$ttZoneMarginTop = -($3f746fcf61f7b3f9$var$ttZoneHeight + (0, $645AZ.layout).adg3smallGutter);
const $3f746fcf61f7b3f9$var$TransitionToZone = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isDraggingOver: isDraggingOver, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk13i4 _2hwx1y44 _otyr1y44 _18u01y44 _2rkoi2wt _kqsw1if8 _y3gn1h6o _lcxv4shg _154iidpf _4t3ildb6 _vwz4ldb6 _1bsbzd3w _1pbyzo7u",
            __cmplp.isDraggingOver ? "_19it1ttf" : "_19it1ttf",
            __cmplp.isDraggingOver ? "_bfhki1yw" : "_bfhkfg4m",
            __cmplp.className
        ])
    });
});

});

const $ff2886b69dd99cbd$export$c28377001f14d9d = 350;
const $ff2886b69dd99cbd$export$b2112118f902d683 = 45;

parcelRegister("kMJOb", function(module, exports) {

$parcel$export(module.exports, "ColumnTransitionZone", () => $93d5ae56cae270b2$export$627a5fcef77c9034);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $7gWdR = parcelRequire("7gWdR");

var $1fZVH = parcelRequire("1fZVH");

var $7D59a = parcelRequire("7D59a");


var $645AZ = parcelRequire("645AZ");

var $9EXcX = parcelRequire("9EXcX");
const $93d5ae56cae270b2$export$627a5fcef77c9034 = ({ onDragOver: onDragOverProp, transitionId: transitionId, isTransitionAvailable: isTransitionAvailable, isHidden: isHidden, LabelComponent: LabelComponent = (0, $9EXcX.default), targetStatusName: targetStatusName, transitionName: transitionName, targetStatusCategory: targetStatusCategory, sourceStatus: sourceStatus, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, hideSourceStatusInLabel: hideSourceStatusInLabel, onTransitionSelection: onTransitionSelection, columnId: columnId, swimlaneId: swimlaneId })=>{
    const zoneRef = (0, $5uXOq.useRef)(null);
    const previousInputPosition = (0, $5uXOq.useRef)(null);
    const autobatch = (0, $1fZVH.useAutobatch)();
    const onDragOver = (0, $7D59a.useEvent)(onDragOverProp);
    const [isDraggingOver, setIsDraggingOver] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!zoneRef.current) return undefined;
        return (0, $7gWdR.dropTargetForElements)({
            element: zoneRef.current,
            getData: ()=>({
                    type: (0, $25c2ea87c2b04bf9$export$2927f4d423091b16),
                    columnId: columnId,
                    swimlaneId: swimlaneId,
                    transitionId: transitionId
                }),
            onDragEnter: ()=>{
                onDragOver(transitionId, false);
                setIsDraggingOver(true);
            },
            onDrag: ({ location: { current: { input: input } } })=>{
                if (previousInputPosition.current?.x !== input.clientX || previousInputPosition.current?.y !== input.clientY) {
                    onDragOver(transitionId, true);
                    previousInputPosition.current = {
                        x: input.clientX,
                        y: input.clientY
                    };
                }
            },
            onDragLeave: (_args)=>{
                onDragOver(null, false);
                setIsDraggingOver(false);
            },
            onDrop: ()=>{
                if (isHidden || !isTransitionAvailable) return;
                autobatch(()=>onTransitionSelection(transitionId));
            }
        });
    }, [
        autobatch,
        columnId,
        isHidden,
        isTransitionAvailable,
        onTransitionSelection,
        swimlaneId,
        transitionId,
        onDragOver
    ]);
    const labelEl = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LabelComponent, {
        source: hideSourceStatusInLabel ? null : transitionName,
        sourceStatus: hideSourceStatusInLabel ? null : sourceStatus,
        target: targetStatusName,
        targetStatusCategory: targetStatusCategory,
        isTransitionAvailable: isTransitionAvailable,
        isTransitionGlobal: isTransitionGlobal,
        showMessage: false,
        notAvailableMessage: notAvailableMessage
    });
    const commonProps = {
        isDraggingOver: isDraggingOver,
        isTransitionAvailable: isTransitionAvailable
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93d5ae56cae270b2$export$2de257552dc02bf, {
        ref: zoneRef,
        ...commonProps,
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container",
        "data-component-selector": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.compiled-transition-zones-container"
    }, labelEl);
};
const $93d5ae56cae270b2$var$borderWidth = 2;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $93d5ae56cae270b2$var$borderRadius = `${(0, $645AZ.layout).cardListRadius}px`;
const $93d5ae56cae270b2$var$getAvailableBorderColour = (props)=>props.isDraggingOver ? "var(--ds-border-brand, #0C66E4)" : "var(--ds-border-focused, #388BFF)";
const $93d5ae56cae270b2$var$getDraggingBackgroundColour = (props)=>props.isDraggingOver ? "var(--ds-background-selected-hovered, #CCE0FF)" : "var(--ds-background-selected, #E9F2FF)";
const $93d5ae56cae270b2$var$getBorder = (props)=>({
        border: `${$93d5ae56cae270b2$var$borderWidth}px solid ${!props.isTransitionAvailable ? "var(--ds-background-accent-red-subtler, #FFD5D2)" : $93d5ae56cae270b2$var$getAvailableBorderColour(props)}`
    });
const $93d5ae56cae270b2$var$getBackgroundColor = (props)=>({
        backgroundColor: `${!props.isTransitionAvailable ? "var(--ds-background-danger, #FFECEB)" : $93d5ae56cae270b2$var$getDraggingBackgroundColour(props)}`
    });
const $93d5ae56cae270b2$export$2de257552dc02bf = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTransitionAvailable: isTransitionAvailable, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_177x0if": (0, $lD23V.default)(`${$93d5ae56cae270b2$var$borderWidth}px solid ${!__cmplp.isTransitionAvailable ? "var(--ds-background-accent-red-subtler, #FFD5D2)" : $93d5ae56cae270b2$var$getAvailableBorderColour(__cmplp)}`),
            "--_1v6vhty": (0, $lD23V.default)($93d5ae56cae270b2$var$getDraggingBackgroundColour(__cmplp)),
            "--_1lnby5": (0, $lD23V.default)($93d5ae56cae270b2$var$borderRadius)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _ca0q14y2 _u5f314y2 _n3td14y2 _19bv14y2 _19itk9w5 _2lx21bp4 _1tkeidpf _1e0c1txw _4cvr1h6o _1bah1h6o _kqswh2mm _lcxv4shg _1jc111eo _e6mdhnez _kh711qt3 _am38glyw",
            !__cmplp.isTransitionAvailable ? "_bfhk1gly" : "_bfhkikgw",
            __cmplp.className
        ])
    });
});
const $93d5ae56cae270b2$export$7ed12d2a5241e393 = {
    getBackgroundColor: $93d5ae56cae270b2$var$getBackgroundColor,
    getBorder: $93d5ae56cae270b2$var$getBorder
};

});
parcelRegister("9EXcX", function(module, exports) {

$parcel$export(module.exports, "default", () => $a3a289d543cac7bd$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h1TKi = parcelRequire("h1TKi");

var $hMVoD = parcelRequire("hMVoD");

var $8RBk4 = parcelRequire("8RBk4");

var $7nnPp = parcelRequire("7nnPp");

var $2EwJD = parcelRequire("2EwJD");

var $az4zD = parcelRequire("az4zD");

var $dxWFc = parcelRequire("dxWFc");
const $a3a289d543cac7bd$var$ColumnTransitionLabel = /*#__PURE__*/ (0, $5uXOq.memo)(({ source: source, target: target, targetStatusCategory: targetStatusCategory, isTransitionAvailable: isTransitionAvailable, isTransitionGlobal: isTransitionGlobal, notAvailableMessage: notAvailableMessage, showMessage: showMessage, sourceStatus: sourceStatus, intl: { formatMessage: formatMessage } })=>{
    const shouldRenderSource = source || sourceStatus; /**
                                                      * check null against the source and the sourceStatus.
                                                      * if they are all null. Do not display the source and arrow
                                                      * e.g.
                                                      * label with source: TO DO -> IN PROGRESS
                                                      * label without source: IN PROGRESS
                                                      */ 
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelPositioningWrapper, {
        "data-testid": "platform-board-kit.ui.column.column-transition-zones-container.transition-zone.label.label-positioning-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$TransitionRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineWrapper, null, shouldRenderSource && isTransitionGlobal && sourceStatus?.category ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: sourceStatus.category,
        name: sourceStatus.name
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null, source)), shouldRenderSource && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($h1TKi))), {
        label: "arrow",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($8RBk4))),
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-text, #172B4D)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$InlineFlex, null, !isTransitionAvailable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dxWFc.default), {
        label: "",
        size: "small",
        primaryColor: "var(--ds-icon-subtlest, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        label: formatMessage(notAvailableMessage),
        color: "var(--ds-text-danger, #AE2E24)",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
        LEGACY_size: "small",
        LEGACY_primaryColor: "var(--ds-text-danger, #AE2E24)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2EwJD.default), {
        category: targetStatusCategory,
        name: target,
        isFullWidth: !shouldRenderSource
    }))), !isTransitionAvailable && showMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelRow, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($a3a289d543cac7bd$var$LabelMessage, null, formatMessage(notAvailableMessage))));
});
var $a3a289d543cac7bd$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $az4zD.injectIntlV2)($a3a289d543cac7bd$var$ColumnTransitionLabel);
const $a3a289d543cac7bd$var$LabelRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _p12f1osq _1bto1l2s _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$LabelPositioningWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c1txw _4cvr1h6o _1bah1h6o _p12f1osq _1bto1l2s _1n261g80",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$InlineWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _p12fn7od _o572n7od _1bto1l2s _s7n4nkob _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$TransitionRow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _s7n4nkob _p12f1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$InlineFlex = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _o572n7od _1bto1l2s _s7n4nkob _p12f1osq _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $a3a289d543cac7bd$var$LabelMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _19pku2gc _y3gn1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("dxWFc", function(module, exports) {

$parcel$export(module.exports, "default", () => $66e9d55c435dacfd$export$2e2bcd8739ae039);
/**
 * Based on custom icon example:
 * https://atlassian.design/components/icon/custom-icon/examples
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $66e9d55c435dacfd$var$LightningGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label'],
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: props.className
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "currentColor",
        fillRule: "evenodd",
        clipRule: "evenodd",
        d: "M10.5115 3.99997H15.1546C15.4191 3.99997 15.6335 4.22318 15.6335 4.49852C15.6335 4.57648 15.616 4.65335 15.5823 4.72296L13.6197 8.7755C13.5006 9.02137 13.5955 9.32116 13.8317 9.44512C13.8986 9.48021 13.9724 9.49849 14.0473 9.49849H17.521C17.7855 9.49849 17.9999 9.7217 17.9999 9.99704C17.9999 10.1411 17.9401 10.2781 17.8358 10.3728L7.9973 19.3057C7.79797 19.4867 7.49545 19.4652 7.3216 19.2577C7.20098 19.1137 7.16999 18.9107 7.24181 18.7349L9.20627 13.9262C9.30979 13.6728 9.19639 13.38 8.95299 13.2723C8.89372 13.246 8.82998 13.2325 8.76557 13.2325H6.47884C6.21435 13.2325 5.99994 13.0093 5.99994 12.7339C5.99994 12.6552 6.01784 12.5777 6.05218 12.5075L10.0849 4.2721C10.1667 4.1051 10.3315 3.99997 10.5115 3.99997Z"
    }));
const $66e9d55c435dacfd$var$LightningBolt = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        ...props,
        glyph: $66e9d55c435dacfd$var$LightningGlyph
    });
var $66e9d55c435dacfd$export$2e2bcd8739ae039 = $66e9d55c435dacfd$var$LightningBolt;

});




parcelRegister("3Rsmm", function(module, exports) {

$parcel$export(module.exports, "default", () => $481a687e8c533277$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $481a687e8c533277$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    notAvailableMessage: {
        "id": "software.main.board-container.board.column.transition-zones-container.not-available-message",
        "defaultMessage": "A workflow rule prevents you from moving the issue this way."
    },
    noTransitionMessage: {
        "id": "software.main.board-container.board.column.transition-zones-container.no-transition-message",
        "defaultMessage": "You can't move this issue to this column due to workflow configurations or permissions."
    },
    notAvailableMessageIssueTermRefresh: {
        "id": "software.main.board-container.board.column.transition-zones-container.not-available-message-issue-term-refresh",
        "defaultMessage": "A workflow rule prevents you from moving the work item this way."
    },
    noTransitionMessageIssueTermRefresh: {
        "id": "software.main.board-container.board.column.transition-zones-container.no-transition-message-issue-term-refresh",
        "defaultMessage": "You can't move this work item to this column due to workflow configurations or permissions."
    }
});

});



parcelRegister("lBRY4", function(module, exports) {

$parcel$export(module.exports, "default", () => $54056611b5d48913$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $hjSul = parcelRequire("hjSul");

var $aKlQV = parcelRequire("aKlQV");

var $er2JZ = parcelRequire("er2JZ");

var $1gnEU = parcelRequire("1gnEU");
const $54056611b5d48913$var$NoActiveSprintMessage = ()=>{
    const intl = (0, $koVbs.default)();
    const backlogUrl = (0, $aKlQV.useBacklogUrl)() || '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54056611b5d48913$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54056611b5d48913$var$Image, {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($er2JZ))),
        alt: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54056611b5d48913$var$TitleStyle, null, intl.formatMessage((0, $1gnEU.default).title)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54056611b5d48913$var$TextStyle, null, intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1gnEU.default).descriptionIssueTermRefresh : (0, $1gnEU.default).description)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        component: (0, $hjSul.Link),
        href: backlogUrl
    }, intl.formatMessage((0, $1gnEU.default).button)));
};
var $54056611b5d48913$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $54056611b5d48913$var$NoActiveSprintMessage;
const $54056611b5d48913$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qxy5q _u5f3xy5q _n3tdxy5q _19bvxy5q _1e0c1txw _4cvr1h6o _2lx21bp4",
            __cmplp.className
        ])
    });
});
const $54056611b5d48913$var$Image = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1qr7 _4t3i1qr7",
            __cmplp.className
        ])
    });
});
const $54056611b5d48913$var$TextStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1h6o _otyr1ejb",
            __cmplp.className
        ])
    });
});
const $54056611b5d48913$var$TitleStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $54056611b5d48913$var$TextStyle, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej _otyru2gc",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aKlQV", function(module, exports) {

$parcel$export(module.exports, "useBacklogUrl", () => $0e9c32fa4d0631b2$export$b5198977ee15e8a7);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");
const $0e9c32fa4d0631b2$export$b5198977ee15e8a7 = (additionalParams = [])=>{
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const isCMPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard));
    const contextPath = (0, $67sX6.useBoardSelector)((0, $67Z81.contextPathSelector));
    const [{ data: data, error: error }] = (0, $4DPZY.useContainerContext)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!data || error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('useBacklogUrl', 'Failed getting container context');
            return null;
        }
        const url = (0, $gSBIZ.isUserContext)(data) ? `${contextPath}/jira/people/${data.user.accountId}` : `${contextPath}/jira/software${isCMPBoard ? '/c' : ''}/projects/${data.project.key}`;
        return `${url}/boards/${boardId}/backlog${additionalParams.length ? `?${additionalParams.join('&')}` : ''}`;
    }, [
        additionalParams,
        boardId,
        contextPath,
        data,
        error,
        isCMPBoard
    ]);
};

});

parcelRegister("er2JZ", function(module, exports) {
module.exports = new URL("agile.52407441.svg", import.meta.url).toString();

});

parcelRegister("1gnEU", function(module, exports) {

$parcel$export(module.exports, "default", () => $14b2046274c87bd6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14b2046274c87bd6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.board-container.board.column.no-active-sprint-dialog.title",
        "defaultMessage": "Get started in the backlog"
    },
    description: {
        "id": "software.main.board-container.board.column.no-active-sprint-dialog.description",
        "defaultMessage": "Plan and start a sprint to see issues here."
    },
    button: {
        "id": "software.main.board-container.board.column.no-active-sprint-dialog.button",
        "defaultMessage": "Go to Backlog"
    },
    descriptionIssueTermRefresh: {
        "id": "software.main.board-container.board.column.no-active-sprint-dialog.description-issue-term-refresh",
        "defaultMessage": "Plan and start a sprint to see work here."
    }
});

});


parcelRegister("hXOH1", function(module, exports) {

$parcel$export(module.exports, "default", () => $c3d132e84ce6bf43$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $hGgHi = parcelRequire("hGgHi");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $645AZ = parcelRequire("645AZ");

var $4jAPy = parcelRequire("4jAPy");

var $jgcLy = parcelRequire("jgcLy");

var $iTu9h = parcelRequire("iTu9h");

var $esu6n = parcelRequire("esu6n");

var $4kOHs = parcelRequire("4kOHs");

var $bL0WB = parcelRequire("bL0WB");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");

var $5mTgl = parcelRequire("5mTgl");

var $eeRMo = parcelRequire("eeRMo");

var $8qFMV = parcelRequire("8qFMV");
const $c3d132e84ce6bf43$var$IterationColumnHeader = ({ swimlaneId: swimlaneId, columnId: columnId, planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay, capacityInfo: capacityInfo, hideTotalCapacity: hideTotalCapacity, isReadOnly: isReadOnly, totalIssues: totalIssues, visibleIssues: visibleIssues })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { totalCapacity: totalCapacity, usedCapacity: usedCapacity, defaultCapacity: defaultCapacity } = capacityInfo;
    const onChangeCapacity = (0, $5uXOq.useCallback)((capacity)=>{
        dispatch((0, $bL0WB.updateIterationCapacityRequest)({
            capacity: capacity,
            planningUnit: planningUnit,
            workingHoursPerDay: workingHoursPerDay,
            iterationId: columnId,
            teamId: swimlaneId,
            totalCapacity: totalCapacity,
            defaultCapacity: defaultCapacity
        }));
    }, [
        dispatch,
        planningUnit,
        workingHoursPerDay,
        columnId,
        swimlaneId,
        totalCapacity,
        defaultCapacity
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgcLy.default), {
        columnId: columnId,
        totalCapacity: totalCapacity,
        usedCapacity: usedCapacity,
        defaultCapacity: defaultCapacity,
        planningConfig: {
            planningUnit: planningUnit,
            workingHoursPerDay: workingHoursPerDay
        },
        onChangeCapacity: onChangeCapacity,
        hideTotalCapacity: hideTotalCapacity,
        isReadOnly: isReadOnly,
        visibleIssues: visibleIssues,
        totalIssues: totalIssues
    });
};
const $c3d132e84ce6bf43$var$SprintColumnHeader = ({ sprint: sprint, swimlaneId: swimlaneId, columnId: columnId, planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay, sprintCapacity: sprintCapacity, isReadOnly: isReadOnly })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const overlappedSprintPerTeam = (0, $67sX6.useBoardSelector)((0, $cPGP0.getOverlappedSprintPerTeam));
    const overlappedSprints = (0, $7uUwQ.getIn)(overlappedSprintPerTeam, [
        swimlaneId,
        sprint.id
    ]);
    const column = (0, $67sX6.useBoardSelector)((state)=>(0, $esu6n.getDateRangeColumn)((0, $fyeGd.getColumnById)(state, columnId)));
    const onChangeCapacity = (0, $5uXOq.useCallback)((capacity)=>{
        dispatch((0, $4kOHs.updatePlannedCapacityRequest)({
            capacity: capacity,
            planningUnit: planningUnit,
            workingHoursPerDay: workingHoursPerDay,
            iterationId: sprint.id,
            teamId: swimlaneId,
            totalCapacity: sprintCapacity.totalCapacity,
            defaultCapacity: sprintCapacity.defaultCapacity
        }));
    }, [
        dispatch,
        planningUnit,
        workingHoursPerDay,
        sprint,
        swimlaneId,
        sprintCapacity.totalCapacity,
        sprintCapacity.defaultCapacity
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTu9h.default), {
        sprint: sprint,
        totalCapacity: sprintCapacity.totalCapacity,
        usedCapacity: sprintCapacity.usedCapacity,
        doneCapacity: sprintCapacity.doneCapacity,
        defaultCapacity: sprintCapacity.defaultCapacity,
        planningConfig: {
            planningUnit: planningUnit,
            workingHoursPerDay: workingHoursPerDay
        },
        overlappedSprints: overlappedSprints,
        columnDateRange: column?.dateRange,
        onChangeCapacity: onChangeCapacity,
        isReadOnly: isReadOnly
    });
};
const $c3d132e84ce6bf43$var$ProgramSwimlaneColumnHeader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ count: count, columnId: columnId, swimlaneId: swimlaneId, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel }, headerRef)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const isExternalTeam = (0, $67sX6.useBoardSelector)((state)=>(0, $cPGP0.getTeamById)(state)(swimlaneId)?.isPlanTeam) === false;
    const isScenarioTeam = (0, $67sX6.useBoardSelector)((state)=>(0, $cPGP0.getTeamById)(state)(swimlaneId)?.isOnlyInScenario) === true;
    const sprint = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.getTeamSwimlaneColumnSprint)(state, columnId, swimlaneId));
    const sprintCapacityPerTeam = (0, $67sX6.useBoardSelector)((0, $cPGP0.getSprintCapacityInfo));
    const sprintCapacity = sprint && (0, $7uUwQ.getIn)(sprintCapacityPerTeam, [
        swimlaneId,
        sprint.id
    ]);
    const iterationCapacityPerTeam = (0, $67sX6.useBoardSelector)((0, $cPGP0.getIterationCapacityInfo));
    const capacity = (0, $7uUwQ.getIn)(iterationCapacityPerTeam, [
        swimlaneId,
        columnId
    ]);
    const { timeTrackingOptions: { workingHoursPerDay: workingHoursPerDay } } = (0, $67sX6.useBoardSelector)((0, $67Z81.getBoardConfig));
    const incrementConfig = (0, $67sX6.useBoardSelector)((0, $67Z81.getIncrementConfig));
    const total = (0, $67sX6.useBoardSelector)((state)=>(0, $5mTgl.getTeamSwimlaneColumnTotalIssuesCount)(state, columnId, swimlaneId));
    const visibleIssues = (0, $5uXOq.useMemo)(()=>count !== total ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8qFMV.default).visibleIssueCountIssueTermRefresh : (0, $8qFMV.default).visibleIssueCount, {
            count: count,
            total: total
        }) : formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $8qFMV.default).totalIssueCountIssueTermRefresh : (0, $8qFMV.default).totalIssueCount, {
            total: total
        }), [
        count,
        total,
        formatMessage
    ]);
    const planningUnit = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(incrementConfig?.planningUnit) ? (0, $4jAPy.IP_BOARD_STORY_POINTS_PLANNING_UNIT) : incrementConfig.planningUnit;
    const [headerToMeasure, setHeaderToMeasure] = (0, $5uXOq.useState)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (headerRef && typeof headerRef !== 'function' && headerRef.current) setHeaderToMeasure(headerRef);
    }, [
        headerRef
    ]);
    const renderHeaderMeasurement = ()=>headerToMeasure !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eeRMo.HeaderMeasurement), {
            columnId: columnId,
            isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
            headerRef: headerToMeasure
        });
    if (swimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(sprint) && capacity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: headerRef,
        xcss: isUnscheduledWorkColumnPanel ? [
            $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
            $c3d132e84ce6bf43$var$unscheduledColumnHeaderOuterStyles
        ] : $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles
    }, renderHeaderMeasurement(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d132e84ce6bf43$var$IterationColumnHeader, {
        visibleIssues: count,
        totalIssues: total,
        swimlaneId: swimlaneId,
        columnId: columnId,
        planningUnit: planningUnit,
        workingHoursPerDay: workingHoursPerDay,
        capacityInfo: capacity,
        hideTotalCapacity: isExternalTeam || swimlaneId === (0, $4jAPy.SWIMLANE_TEAMLESS) || isScenarioTeam,
        isReadOnly: isReadOnly
    }));
    if (sprint && sprintCapacity) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: isUnscheduledWorkColumnPanel ? [
            $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
            $c3d132e84ce6bf43$var$unscheduledColumnHeaderOuterStyles
        ] : $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
        ref: headerRef
    }, renderHeaderMeasurement(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c3d132e84ce6bf43$var$SprintColumnHeader, {
        sprint: sprint,
        swimlaneId: swimlaneId,
        columnId: columnId,
        planningUnit: planningUnit,
        workingHoursPerDay: workingHoursPerDay,
        sprintCapacity: sprintCapacity,
        isReadOnly: isReadOnly
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: isUnscheduledWorkColumnPanel ? [
            $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
            $c3d132e84ce6bf43$var$unscheduledColumnHeaderOuterStyles
        ] : $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles,
        ref: headerRef
    }, renderHeaderMeasurement(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $c3d132e84ce6bf43$var$columnHeaderWrapper,
            $c3d132e84ce6bf43$var$storyPointCapacityAndIssueCountStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c3d132e84ce6bf43$var$issueCountStyles
    }, visibleIssues)));
});
// main board columns header height, plus swimlane header height,
// minus the 8px gutter which gets removed from the top of the swimlane header on scroll
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c3d132e84ce6bf43$var$stickyOffset = `calc(${(0, $645AZ.swimlaneHeaderHeight) + (0, $645AZ.columnHeaderHeight)}px - ${"var(--ds-space-100, 8px)"})`;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $c3d132e84ce6bf43$var$unscheduledColumnStickyOffset = `calc(${(0, $645AZ.unscheduledColumnHeaderHeight) + (0, $645AZ.columnHeaderHeight)}px - ${"var(--ds-space-100, 8px)"})`;
const $c3d132e84ce6bf43$var$programSwimlaneColumnHeaderOuterStyles = (0, $8CUq3.xcss)({
    position: 'sticky',
    backgroundColor: 'elevation.surface',
    paddingTop: 'space.075',
    // zIndex of 1 is required to ensure the column header is above the column and below the swimlane header
    zIndex: '1',
    top: `${$c3d132e84ce6bf43$var$stickyOffset}`
});
const $c3d132e84ce6bf43$var$unscheduledColumnHeaderOuterStyles = (0, $8CUq3.xcss)({
    top: `${$c3d132e84ce6bf43$var$unscheduledColumnStickyOffset}`
});
const $c3d132e84ce6bf43$var$columnHeaderWrapper = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    borderTopLeftRadius: 'border.radius.100',
    borderTopRightRadius: 'border.radius.100',
    paddingBlock: 'space.050'
});
const $c3d132e84ce6bf43$var$storyPointCapacityAndIssueCountStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.200'
});
const $c3d132e84ce6bf43$var$issueCountStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    height: `${"var(--ds-space-400, 32px)"}`,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
var $c3d132e84ce6bf43$export$2e2bcd8739ae039 = $c3d132e84ce6bf43$var$ProgramSwimlaneColumnHeader;

});
parcelRegister("jgcLy", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcd711f0ad554261$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bopR4 = parcelRequire("bopR4");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $4jAPy = parcelRequire("4jAPy");

var $gZK1Z = parcelRequire("gZK1Z");

var $bdYfL = parcelRequire("bdYfL");

var $1FRDE = parcelRequire("1FRDE");
const $dcd711f0ad554261$var$IterationColumnHeader = ({ columnId: columnId, totalCapacity: totalCapacity, usedCapacity: usedCapacity, defaultCapacity: defaultCapacity, planningConfig: { planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay }, onChangeCapacity: onChangeCapacity, isReadOnly: isReadOnly, hideTotalCapacity: hideTotalCapacity, visibleIssues: visibleIssues, totalIssues: totalIssues })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isEditViewMode, setIsEditViewMode] = (0, $5uXOq.useState)(false);
    const total = (0, $bdYfL.convertCapacity)(totalCapacity ?? defaultCapacity, planningUnit, workingHoursPerDay);
    const unitLabel = (0, $bdYfL.getCapacityUnitMessage)(planningUnit, formatMessage, total);
    const showOverCapacityStyle = usedCapacity > total;
    const visibleIssuesMsg = (0, $5uXOq.useMemo)(()=>{
        if (visibleIssues !== totalIssues) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1FRDE.default).visibleIssueCountIssueTermRefresh : (0, $1FRDE.default).visibleIssueCount, {
            visibleIssues: visibleIssues,
            totalIssues: totalIssues
        });
        return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $1FRDE.default).totalIssueCountIssueTermRefresh : (0, $1FRDE.default).totalIssueCount, {
            totalIssues: totalIssues
        });
    }, [
        visibleIssues,
        totalIssues,
        formatMessage
    ]);
    let innerContent;
    let tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignInline: "center",
        shouldWrap: true,
        space: "space.025"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, usedCapacity), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, total), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, unitLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "(", visibleIssuesMsg, ")"));
    const unitContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.capacity-unit"
    }, unitLabel));
    const usedCapacityContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $dcd711f0ad554261$var$capacityWrapperStyle,
            $dcd711f0ad554261$var$usedCapacityWrapperStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.allocated-capacity"
    }, usedCapacity));
    if (columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID) || hideTotalCapacity) {
        tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignInline: "center",
            shouldWrap: true,
            space: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, usedCapacity), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, unitLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "(", visibleIssuesMsg, ")"));
        innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            alignBlock: "center",
            xcss: $dcd711f0ad554261$var$capacityContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $dcd711f0ad554261$var$capacityWrapperStyle
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "inherit",
            testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.allocated-capacity"
        }, usedCapacity)), unitContent);
    } else if (isReadOnly) innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: showOverCapacityStyle ? [
            $dcd711f0ad554261$var$overCapacityStyles,
            $dcd711f0ad554261$var$capacityContainerStyles
        ] : $dcd711f0ad554261$var$capacityContainerStyles
    }, usedCapacityContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $dcd711f0ad554261$var$capacityWrapperStyle
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: "inherit",
        testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.total-capacity-read-only"
    }, total)), unitContent);
    else innerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: showOverCapacityStyle ? [
            $dcd711f0ad554261$var$overCapacityStyles,
            $dcd711f0ad554261$var$capacityContainerStyles
        ] : $dcd711f0ad554261$var$capacityContainerStyles
    }, usedCapacityContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, "/"), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        xcss: $dcd711f0ad554261$var$inlineEditStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        defaultValue: total,
        keepEditViewOpenOnBlur: true,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.total-capacity-edit",
                min: 0,
                max: 99999,
                width: "60",
                "aria-label": formatMessage((0, $gZK1Z.default).editCapacityLabel),
                isCompact: true,
                autoFocus: true,
                type: "number",
                ...planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT) && {
                    step: 0.1
                }
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: showOverCapacityStyle ? [
                    $dcd711f0ad554261$var$readViewContainerStyles,
                    $dcd711f0ad554261$var$overCapacityStyles,
                    $dcd711f0ad554261$var$capacityWrapperStyle
                ] : [
                    $dcd711f0ad554261$var$readViewContainerStyles,
                    $dcd711f0ad554261$var$capacityWrapperStyle
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "inherit",
                testId: "portfolio-3-plan-increment-common.ui.iteration-column-header.total-capacity-read-only"
            }, total)),
        onEdit: ()=>{
            setIsEditViewMode(true);
        },
        onCancel: ()=>{
            setIsEditViewMode(false);
        },
        onConfirm: (value)=>{
            setIsEditViewMode(false);
            onChangeCapacity(value);
        },
        editButtonLabel: formatMessage((0, $gZK1Z.default).editCapacityLabel),
        confirmButtonLabel: formatMessage((0, $gZK1Z.default).confirmButtonLabel),
        cancelButtonLabel: formatMessage((0, $gZK1Z.default).cancelButtonLabel)
    })), unitContent));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isEditViewMode ? null : tooltipContent,
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: [
            $dcd711f0ad554261$var$columnHeaderWrapper,
            $dcd711f0ad554261$var$storyPointCapacityAndIssueCountStyles
        ]
    }, innerContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $dcd711f0ad554261$var$issueCountStyles
    }, "(", visibleIssuesMsg, ")")));
};
const $dcd711f0ad554261$var$columnHeaderWrapper = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    borderTopLeftRadius: 'border.radius.100',
    borderTopRightRadius: 'border.radius.100',
    paddingBlock: 'space.050'
});
const $dcd711f0ad554261$var$storyPointCapacityAndIssueCountStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.200'
});
const $dcd711f0ad554261$var$capacityContainerStyles = (0, $8CUq3.xcss)({
    whiteSpace: 'nowrap',
    flexShrink: 0,
    maxWidth: '100%',
    display: 'flex',
    gap: 'space.050',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $dcd711f0ad554261$var$readViewContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $dcd711f0ad554261$var$capacityWrapperStyle = (0, $8CUq3.xcss)({
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
});
const $dcd711f0ad554261$var$usedCapacityWrapperStyle = (0, $8CUq3.xcss)({
    border: `${"var(--ds-space-025, 2px)"} solid transparent`
});
const $dcd711f0ad554261$var$overCapacityStyles = (0, $8CUq3.xcss)({
    color: 'color.text.warning'
});
const $dcd711f0ad554261$var$inlineEditStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.negative.100',
    flexShrink: 0
});
const $dcd711f0ad554261$var$issueCountStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    paddingTop: 'space.075',
    paddingBottom: 'space.075',
    height: "var(--ds-space-400, 32px)",
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis'
});
var $dcd711f0ad554261$export$2e2bcd8739ae039 = $dcd711f0ad554261$var$IterationColumnHeader;

});
parcelRegister("bopR4", function(module, exports) {

$parcel$export(module.exports, "default", () => $9fb3572edb783a8f$export$2e2bcd8739ae039);
/* inline-edit.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $7O4UO = parcelRequire("7O4UO");

var $efXp3 = parcelRequire("efXp3");

var $VSDnB = parcelRequire("VSDnB");

var $3Lty3 = parcelRequire("3Lty3");

var $jldZL = parcelRequire("jldZL");

var $1PDuf = parcelRequire("1PDuf");

var $pZGLJ = parcelRequire("pZGLJ");

var $6LLMl = parcelRequire("6LLMl");
const $9fb3572edb783a8f$var$fieldStyles = null;
const $9fb3572edb783a8f$var$analyticsAttributes = {
    componentName: 'inlineEdit',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $9fb3572edb783a8f$var$InnerInlineEdit = (props)=>{
    const { startWithEditViewOpen: startWithEditViewOpen = false, keepEditViewOpenOnBlur: keepEditViewOpenOnBlur = false, hideActionButtons: hideActionButtons = false, isRequired: isRequired = false, readViewFitContainerWidth: readViewFitContainerWidth = false, editButtonLabel: editButtonLabel = 'Edit', editLabel: editLabel = 'edit', confirmButtonLabel: confirmButtonLabel = 'Confirm', cancelButtonLabel: cancelButtonLabel = 'Cancel', defaultValue: defaultValue, isEditing: isEditing, label: label, validate: validate, readView: readView, editView: editView, analyticsContext: analyticsContext, onConfirm: providedOnConfirm, onCancel: providedOnCancel, onEdit: providedOnEdit, testId: testId } = props;
    const wasFocusReceivedSinceLastBlurRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const [isEditingState, setEditingState] = (0, $5uXOq.useState)(startWithEditViewOpen);
    const timerRef = (0, $5uXOq.useRef)();
    const { editButtonRef: editButtonRef, editViewRef: editViewRef, shouldBeEditing: shouldBeEditing, doNotFocusOnEditButton: doNotFocusOnEditButton } = (0, $pZGLJ.default)(isEditing, isEditingState);
    const onCancel = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(false);
        providedOnCancel?.();
    }, [
        isControlled,
        providedOnCancel
    ]);
    const onEditRequested = (0, $5uXOq.useCallback)(()=>{
        if (isControlled) setEditingState(true);
        providedOnEdit?.();
        if (shouldBeEditing && editViewRef.current) editViewRef.current.focus();
    }, [
        isControlled,
        shouldBeEditing,
        editViewRef,
        providedOnEdit
    ]);
    const onConfirm = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (value, analyticsEvent)=>{
            if (isControlled) setEditingState(false);
            providedOnConfirm(value, analyticsEvent);
        },
        action: 'confirmed',
        analyticsData: analyticsContext,
        ...$9fb3572edb783a8f$var$analyticsAttributes
    });
    const onCancelClick = (0, $5uXOq.useCallback)((event)=>{
        event.preventDefault();
        onCancel();
    }, [
        onCancel
    ]);
    const tryAutoSubmitWhenBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!isFieldInvalid && !wasFocusReceivedSinceLastBlurRef.current && formRef.current) {
            doNotFocusOnEditButton();
            if (formRef.current.checkValidity()) onSubmit();
        }
    }, [
        doNotFocusOnEditButton
    ]); /**
                                 * If keepEditViewOpenOnBlur prop is set to false, will call confirmIfUnfocused() which
                                 *  confirms the value, if the focus is not transferred to the action buttons.
                                 *
                                 *  When you're in `editing` state, the focus will be on the input field. And if you use keyboard
                                 *  to navigate to `submit` button, this function will be invoked. Then function `onEditViewWrapperFocus`
                                 *  will be called, the timeout used here is making sure `onEditViewWrapperFocus` is always called before
                                 *  `autoSubmitWhenBlur`.
                                 *
                                 *  There are two paths here the function can be triggered:
                                 *
                                 *  - focus on input first, and then use keyboard to `submit`
                                 *  - focus on input first, and then click anywhere else on the page (outside of edit view wrapper) to `submit` (auto save).
                                 */ 
    const onEditViewWrapperBlur = (0, $5uXOq.useCallback)((isFieldInvalid, onSubmit, formRef)=>{
        if (!keepEditViewOpenOnBlur) {
            wasFocusReceivedSinceLastBlurRef.current = false;
            timerRef.current = setTimeout(()=>tryAutoSubmitWhenBlur(isFieldInvalid, onSubmit, formRef), 0);
        }
    }, [
        keepEditViewOpenOnBlur,
        tryAutoSubmitWhenBlur
    ]); /**
                                                        * Gets called when focus is transferred to the editView, or action buttons.
                                                        *
                                                        * There are three paths here the function can be called:
                                                        *
                                                        * - when a user click the `editView`
                                                        * - when a user use keyboard to tab into `editView`
                                                        * - when a user use keyboard to tab into `submit` when they were on input field.
                                                        */ 
    const onEditViewWrapperFocus = (0, $5uXOq.useCallback)(()=>{
        wasFocusReceivedSinceLastBlurRef.current = true;
    }, []);
    const concatenatedEditButtonLabel = ()=>{
        if (label) return `${editButtonLabel}, ${label}, ${editLabel}`;
        return `${editButtonLabel}, ${editLabel}`;
    };
    const renderReadView = ()=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LLMl.default), {
            editButtonLabel: concatenatedEditButtonLabel(),
            onEditRequested: onEditRequested,
            postReadViewClick: doNotFocusOnEditButton,
            editButtonRef: editButtonRef,
            readViewFitContainerWidth: readViewFitContainerWidth,
            readView: readView,
            testId: testId
        });
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
        onSubmit: (data)=>onConfirm(data.inlineEdit),
        children: ({ formProps: { onKeyDown: onKeyDown, onSubmit: onSubmit, ref: formRef }, reset: reset })=>/*#__PURE__*/ (0, $2OMIu.jsx)("form", {
                /**
                 * It is not normally acceptable to add key handlers to non-interactive elements
                 * as this is an accessibility anti-pattern. However, because this instance is
                 * to add support for keyboard functionality instead of creating an inaccessible
                 * custom element, we can add role="presentation" so that there is no negative
                 * impacts to assistive technologies.
                 */ role: "presentation",
                onKeyDown: (e)=>{
                    onKeyDown(e);
                    if (e.key === 'Esc' || e.key === 'Escape') {
                        reset();
                        onCancel();
                    }
                },
                onSubmit: onSubmit,
                ref: formRef,
                // This is because due to some default focus being applied to the form element, the inline edit component
                // was being focused automatically and causing scroll issues in issue view
                // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
                className: (0, $VSDnB.fg)('platform_design_system_inline_edit_dont_focus') ? 'dont-default-focus' : undefined,
                children: shouldBeEditing ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: defaultValue,
                    validate: validate,
                    isRequired: isRequired,
                    children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
                            onBlur: (e)=>{
                                if (!e.currentTarget.contains(e.relatedTarget)) onEditViewWrapperBlur(fieldProps.isInvalid, onSubmit, formRef);
                            },
                            onFocus: onEditViewWrapperFocus,
                            className: (0, $bwpsq.default)([
                                "_p12f1osq _kqswh2mm"
                            ]),
                            children: [
                                editView({
                                    ...fieldProps,
                                    errorMessage: error
                                }, editViewRef),
                                !hideActionButtons ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1PDuf.default), {
                                    testId: testId,
                                    cancelButtonLabel: cancelButtonLabel,
                                    confirmButtonLabel: confirmButtonLabel,
                                    onMouseDown: ()=>{
                                        /**
             * Prevents focus on edit button only if mouse is used to click button, but not when keyboard is used
             */ doNotFocusOnEditButton();
                                    },
                                    onCancelClick: (e)=>{
                                        reset();
                                        onCancelClick(e);
                                    }
                                }) : /**
           * This is to allow Ctrl + Enter to submit without action buttons
           */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                                    hidden: true,
                                    type: "submit",
                                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                                        children: "Submit"
                                    })
                                })
                            ]
                        })
                }, "edit-view" // used for reset to default value
                ) : /**
       * Field is used here only for the label and spacing
       */ /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
                    name: "inlineEdit",
                    label: label,
                    defaultValue: "",
                    isRequired: isRequired,
                    children: renderReadView
                }, "read-view" // used for reset to default value
                )
            })
    });
};
const $9fb3572edb783a8f$var$InlineEdit = (props)=>{
    // eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    return /*#__PURE__*/ (0, $2OMIu.jsx)($9fb3572edb783a8f$var$InnerInlineEdit, {
        ...props
    });
}; // eslint-disable-next-line @repo/internal/react/require-jsdoc
var $9fb3572edb783a8f$export$2e2bcd8739ae039 = $9fb3572edb783a8f$var$InlineEdit;

});
parcelRegister("7O4UO", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e20204ce79b642c$export$2e2bcd8739ae039);
/* field.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
parcelRequire("3joPi");

var $9KnKW = parcelRequire("9KnKW");

var $dRN65 = parcelRequire("dRN65");

var $efXp3 = parcelRequire("efXp3");

var $2x3Cb = parcelRequire("2x3Cb");

var $kxqHl = parcelRequire("kxqHl");

var $6cAn5 = parcelRequire("6cAn5");
const $7e20204ce79b642c$var$fieldWrapperStyles = null;
function $7e20204ce79b642c$var$isEvent(event) {
    return Boolean(event && event.target);
}
function $7e20204ce79b642c$var$isFunction(x) {
    return typeof x === 'function';
}
function $7e20204ce79b642c$var$usePreviousRef(current) {
    const ref = (0, $5uXOq.useRef)(current);
    // will be updated on the next render
    (0, $5uXOq.useEffect)(()=>{
        ref.current = current;
    });
    // return the existing current (pre render)
    return ref;
}
function $7e20204ce79b642c$var$isShallowEqual(previousValue, currentValue) {
    if (previousValue === currentValue) return true;
    // not checking functions
    if (typeof previousValue === 'function' && typeof currentValue === 'function') return true;
    if (Array.isArray(previousValue) && Array.isArray(currentValue)) return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    if (typeof previousValue === 'object' && typeof currentValue === 'object') return JSON.stringify(previousValue) === JSON.stringify(currentValue);
    return false;
}
function $7e20204ce79b642c$export$2e2bcd8739ae039(props) {
    const { registerField: registerField, getCurrentValue: getCurrentValue } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const isDisabled = (0, $5uXOq.useContext)((0, $efXp3.IsDisabledContext)) || props.isDisabled || false;
    const defaultValue = $7e20204ce79b642c$var$isFunction(props.defaultValue) ? props.defaultValue() : props.defaultValue;
    const latestPropsRef = $7e20204ce79b642c$var$usePreviousRef(props);
    /**
   * HACK: defaultValue can potentially be an array or object which cannot be
   * passed directly into a `useEffect` dependency array, since it will trigger
   * the hook every time.
   */ const isDefaultValueChanged = !$7e20204ce79b642c$var$isShallowEqual(latestPropsRef.current.defaultValue, props.defaultValue);
    const [state, setState] = (0, $5uXOq.useState)({
        fieldProps: {
            onChange: ()=>{},
            onBlur: ()=>{},
            onFocus: ()=>{},
            /* Previously, defaultValue was being set as undefined in Field.defaultProps, which
       * effectively made it an optional prop to external consumers of Field. However the
       * prop types defined defaultValue as required, so inside the component it was not
       * valid for defaultValue to be undefined. We need to suppress the error
       * after changing defaultValue to explicitly be an optional prop.
       * If default value has changed we are using new default value.
       * Otherwise we need to check if we already have value for this field
       * (because we are using changing key prop to re-run field level validation, and that
       * cause the component re-mounting) to not override the actual value with the default value.
       */ // @ts-ignore
            value: isDefaultValueChanged ? defaultValue : getCurrentValue(props.name) ?? defaultValue
        },
        error: undefined,
        valid: false,
        meta: {
            dirty: false,
            dirtySinceLastSubmit: false,
            touched: false,
            valid: false,
            validating: false,
            submitting: false,
            submitFailed: false,
            error: undefined,
            submitError: undefined
        }
    });
    const latestStateRef = $7e20204ce79b642c$var$usePreviousRef(state);
    (0, $5uXOq.useEffect)(()=>{
        typeof $6cAn5;
        function fieldStateToMeta(value = {}) {
            return {
                dirty: value.dirty || false,
                dirtySinceLastSubmit: value.dirtySinceLastSubmit || false,
                touched: value.touched || false,
                valid: value.valid || false,
                submitting: value.submitting || false,
                submitFailed: value.submitFailed || false,
                error: value.error,
                submitError: value.submitError,
                validating: !!value.validating
            };
        }
        const unregister = registerField(latestPropsRef.current.name, /**
     * Similar as for setting initial state value.
     * Additionally we are checking if the default value is a function,
     * it is used in checkbox fields, where fields with same name and
     * defaultIsChecked should create array of values. In this situation we can't
     * override the default value on re-registering, but also we don't need to change
     * the key prop to re-run validation.
     */ // @ts-ignore
        isDefaultValueChanged || // @ts-ignore
        $7e20204ce79b642c$var$isFunction(latestPropsRef.current.defaultValue) ? latestPropsRef.current.defaultValue : latestStateRef.current.fieldProps.value, (fieldState)=>{
            /**
       * Do not update dirtySinceLastSubmit until submission has finished.
       */ const modifiedDirtySinceLastSubmit = fieldState.submitting ? latestStateRef.current.meta.dirtySinceLastSubmit : fieldState.dirtySinceLastSubmit;
            /**
       * Do not update submitFailed until submission has finished.
       */ const modifiedSubmitFailed = fieldState.submitting ? latestStateRef.current.meta.submitFailed : fieldState.submitFailed;
            /**
       * Do not use submitError if the value has changed.
       */ const modifiedSubmitError = modifiedDirtySinceLastSubmit && latestPropsRef.current.validate ? undefined : fieldState.submitError;
            const modifiedError = modifiedSubmitError || (fieldState.touched || fieldState.dirty) && fieldState.error;
            /**
       * If there has been a submit error, then use logic in modifiedError to determine validity,
       * so we can determine when there is a submit error which we do not want to display
       * because the value has been changed.
       */ const modifiedValid = modifiedSubmitFailed ? modifiedError === undefined : fieldState.valid;
            function getTransform(eventOrValue, currentValue) {
                if (latestPropsRef.current.transform) return latestPropsRef.current.transform(eventOrValue, currentValue);
                if ($7e20204ce79b642c$var$isEvent(eventOrValue)) {
                    const { currentTarget: currentTarget } = eventOrValue;
                    if (currentTarget.type === 'checkbox') {
                        if (currentTarget.checked) return currentTarget.value || true;
                        return currentTarget.value ? undefined : false;
                    } else if (currentTarget) return currentTarget.value;
                } else return eventOrValue;
            }
            setState({
                fieldProps: {
                    onChange: (e)=>{
                        fieldState.change(getTransform(e, fieldState.value));
                    },
                    onBlur: fieldState.blur,
                    onFocus: fieldState.focus,
                    value: fieldState.value
                },
                error: modifiedError || undefined,
                /**
         * The following parameters are optionally typed in final-form to indicate that not all parameters need
         * to be subscribed to. We cast them as booleans (using || false), since this is what they are semantically.
         */ valid: modifiedValid || false,
                meta: fieldStateToMeta(fieldState)
            });
        }, {
            dirty: true,
            dirtySinceLastSubmit: true,
            touched: true,
            valid: true,
            submitting: true,
            submitFailed: true,
            value: true,
            error: true,
            submitError: true,
            validating: true
        }, {
            getValidator: ()=>function validate(value, formState, fieldState) {
                    const supplied = latestPropsRef.current.validate;
                    if (supplied && fieldState) return supplied(value, formState, fieldStateToMeta(fieldState));
                }
        });
        return unregister;
    }, [
        latestPropsRef,
        latestStateRef,
        registerField,
        props.name,
        isDefaultValueChanged
    ]);
    const uid = (0, $9KnKW.useId)();
    const fieldId = (0, $5uXOq.useMemo)(()=>{
        return props.id ? props.id : `${props.name}-${uid}`;
    }, [
        props.id,
        props.name,
        uid
    ]);
    const getDescribedBy = ()=>{
        let value = '';
        if (state.error) value += `${fieldId}-error `;
        if (state.valid) value += `${fieldId}-valid `;
        return `${value}${fieldId}-helper`;
    };
    const extendedFieldProps = {
        ...state.fieldProps,
        name: props.name,
        isDisabled: isDisabled,
        isInvalid: Boolean(state.error),
        isRequired: Boolean(props.isRequired),
        'aria-invalid': state.error ? 'true' : 'false',
        'aria-describedby': getDescribedBy(),
        'aria-labelledby': `${fieldId}-label`,
        id: fieldId
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": props.testId,
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: [
            props.label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2x3Cb.Label), {
                htmlFor: fieldId,
                id: `${fieldId}-label`,
                testId: props.testId && `${props.testId}--label`,
                children: [
                    props.label,
                    props.isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kxqHl.default), {}),
                    props.elementAfterLabel
                ]
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Provider, {
                value: fieldId,
                children: props.children({
                    fieldProps: extendedFieldProps,
                    error: state.error,
                    valid: state.valid,
                    meta: state.meta
                })
            })
        ]
    });
}

});
parcelRegister("dRN65", function(module, exports) {

$parcel$export(module.exports, "FieldId", () => $706cd4dbd4574fd7$export$3c4232819458a302);

var $5uXOq = parcelRequire("5uXOq");
const $706cd4dbd4574fd7$export$3c4232819458a302 = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);

});

parcelRegister("efXp3", function(module, exports) {

$parcel$export(module.exports, "FormContext", () => $987e2ff089e89967$export$c24727297075ec6a);
$parcel$export(module.exports, "IsDisabledContext", () => $987e2ff089e89967$export$c17cf6b332a82dbc);
$parcel$export(module.exports, "default", () => $987e2ff089e89967$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lqWDn = parcelRequire("lqWDn");

var $8tHJX = parcelRequire("8tHJX");

var $gZL7V = parcelRequire("gZL7V");
const $987e2ff089e89967$export$c24727297075ec6a = /*#__PURE__*/ (0, $5uXOq.createContext)({
    registerField: function() {
        return ()=>{};
    },
    getCurrentValue: ()=>undefined,
    subscribe: function() {
        return ()=>{};
    }
});
const $987e2ff089e89967$export$c17cf6b332a82dbc = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
function $987e2ff089e89967$export$2e2bcd8739ae039(props) {
    const formRef = (0, $5uXOq.useRef)(null);
    const onSubmitRef = (0, $5uXOq.useRef)(props.onSubmit);
    onSubmitRef.current = props.onSubmit;
    const [form] = (0, $5uXOq.useState)(()=>{
        // Types here would break the existing API
        const finalForm = (0, $lqWDn.createForm)({
            onSubmit: (...args)=>onSubmitRef.current(...args),
            destroyOnUnregister: true,
            initialValues: {},
            mutators: {
                setDefaultValue: ([name, defaultValue], state)=>{
                    if (state.formState.initialValues) {
                        const initialValues = state.formState.initialValues;
                        const values = state.formState.values;
                        const value = name && typeof defaultValue === 'function' ? defaultValue(initialValues[name]) : defaultValue;
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(initialValues, name, value);
                        (0, (/*@__PURE__*/$parcel$interopDefault($gZL7V)))(values, name, value);
                    }
                }
            }
        });
        (0, $8tHJX.default)(()=>formRef.current ? Array.from(formRef.current.querySelectorAll('input')) : [])(finalForm);
        return finalForm;
    });
    const [state, setState] = (0, $5uXOq.useState)({
        dirty: false,
        submitting: false
    });
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = form.subscribe(({ dirty: dirty, submitting: submitting })=>{
            setState({
                dirty: dirty,
                submitting: submitting
            });
        }, {
            dirty: true,
            submitting: true
        });
        return unsubscribe;
    }, [
        form
    ]);
    const registerField = (0, $5uXOq.useCallback)((name, defaultValue, subscriber, subscription, config)=>{
        form.pauseValidation();
        const unsubscribe = form.registerField(name, subscriber, subscription, config);
        form.mutators.setDefaultValue(name, defaultValue);
        form.resumeValidation();
        return unsubscribe;
    }, [
        form
    ]);
    const handleSubmit = (e)=>{
        if (e) e.preventDefault();
        form.submit();
    };
    const handleReset = (initialValues)=>{
        form.reset(initialValues);
    };
    const handleKeyDown = (e)=>{
        if (e.key === 'Enter' && (e.ctrlKey || e.metaKey) && formRef.current) {
            const submitButton = formRef.current.querySelector('button:not([type]), button[type="submit"], input[type="submit"]');
            if (submitButton) submitButton.click();
            e.preventDefault();
        }
    };
    const { isDisabled: isDisabled = false, children: children } = props;
    const { dirty: dirty, submitting: submitting } = state;
    /**
	 * This method is needed in FormContext to use it on the field level
	 * to check the current value of the field in case of the component re-mounting.
	 */ const getCurrentValue = (0, $5uXOq.useCallback)((name)=>{
        const formState = form.getState();
        return formState?.values[name] || undefined;
    }, [
        form
    ]);
    const FormContextValue = (0, $5uXOq.useMemo)(()=>{
        return {
            registerField: registerField,
            getCurrentValue: getCurrentValue,
            subscribe: form.subscribe
        };
    }, [
        registerField,
        getCurrentValue,
        form.subscribe
    ]);
    const childrenContent = (()=>{
        if (typeof children === 'function') {
            const result = children.length > 0 ? children({
                formProps: {
                    onSubmit: handleSubmit,
                    ref: formRef,
                    onKeyDown: handleKeyDown
                },
                dirty: dirty,
                reset: handleReset,
                submitting: submitting,
                disabled: isDisabled,
                getState: ()=>form.getState(),
                getValues: ()=>form.getState().values,
                setFieldValue: form.change
            }) : children();
            return result === undefined ? null : result;
        }
        return children;
    })();
    return /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c24727297075ec6a.Provider, {
        value: FormContextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)($987e2ff089e89967$export$c17cf6b332a82dbc.Provider, {
            value: isDisabled,
            children: childrenContent
        })
    });
}

});
parcelRegister("lqWDn", function(module, exports) {

$parcel$export(module.exports, "getIn", () => $f9a9822f8af64e2a$export$c52e5867d5879e24);
$parcel$export(module.exports, "FORM_ERROR", () => $f9a9822f8af64e2a$export$97cd7fc25dd32915);
$parcel$export(module.exports, "ARRAY_ERROR", () => $f9a9822f8af64e2a$export$735bebc8ffabf28a);
$parcel$export(module.exports, "fieldSubscriptionItems", () => $f9a9822f8af64e2a$export$41e855cb628c1b55);
$parcel$export(module.exports, "formSubscriptionItems", () => $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3);
$parcel$export(module.exports, "version", () => $f9a9822f8af64e2a$export$83d89fbfd8236492);
$parcel$export(module.exports, "createForm", () => $f9a9822f8af64e2a$export$f681a8129d2e9d28);

var $bS32t = parcelRequire("bS32t");

var $ddEsc = parcelRequire("ddEsc");
//      
var $f9a9822f8af64e2a$var$charCodeOfDot = ".".charCodeAt(0);
var $f9a9822f8af64e2a$var$reEscapeChar = /\\(\\)?/g;
var $f9a9822f8af64e2a$var$rePropName = RegExp(// Match anything that isn't a dot or bracket.
"[^.[\\]]+|\\[(?:([^\"'][^[]*)|([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2)\\]|(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $f9a9822f8af64e2a$var$stringToPath = function stringToPath(string) {
    var result = [];
    if (string.charCodeAt(0) === $f9a9822f8af64e2a$var$charCodeOfDot) result.push("");
    string.replace($f9a9822f8af64e2a$var$rePropName, function(match, expression, quote, subString) {
        var key = match;
        if (quote) key = subString.replace($f9a9822f8af64e2a$var$reEscapeChar, "$1");
        else if (expression) key = expression.trim();
        result.push(key);
    });
    return result;
};
var $f9a9822f8af64e2a$var$keysCache = {};
var $f9a9822f8af64e2a$var$keysRegex = /[.[\]]+/;
var $f9a9822f8af64e2a$var$toPath = function toPath(key) {
    if (key === null || key === undefined || !key.length) return [];
    if (typeof key !== "string") throw new Error("toPath() expects a string");
    if ($f9a9822f8af64e2a$var$keysCache[key] == null) {
        /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */ if (key.endsWith("[]")) // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
        $f9a9822f8af64e2a$var$keysCache[key] = key.split($f9a9822f8af64e2a$var$keysRegex).filter(Boolean);
        else // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
        $f9a9822f8af64e2a$var$keysCache[key] = $f9a9822f8af64e2a$var$stringToPath(key);
    }
    return $f9a9822f8af64e2a$var$keysCache[key];
};
//      
var $f9a9822f8af64e2a$export$c52e5867d5879e24 = function getIn(state, complexKey) {
    // Intentionally using iteration rather than recursion
    var path = $f9a9822f8af64e2a$var$toPath(complexKey);
    var current = state;
    for(var i = 0; i < path.length; i++){
        var key = path[i];
        if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) return undefined;
        current = current[key];
    }
    return current;
};
function $f9a9822f8af64e2a$var$_toPropertyKey(arg) {
    var key = $f9a9822f8af64e2a$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $f9a9822f8af64e2a$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
var $f9a9822f8af64e2a$var$setInRecursor = function setInRecursor(current, index, path, value1, destroyArrays) {
    if (index >= path.length) // end of recursion
    return value1;
    var key = path[index];
    // determine type of key
    if (isNaN(key)) {
        var _extends2;
        // object set
        if (current === undefined || current === null) {
            var _ref;
            // recurse
            var _result = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
            // delete or create an object
            return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
        }
        if (Array.isArray(current)) throw new Error("Cannot set a non-numeric property on an array");
        // current exists, so make a copy of all its values, and add/update the new one
        var _result2 = setInRecursor(current[key], index + 1, path, value1, destroyArrays);
        if (_result2 === undefined) {
            var numKeys = Object.keys(current).length;
            if (current[key] === undefined && numKeys === 0) // object was already empty
            return undefined;
            if (current[key] !== undefined && numKeys <= 1) {
                // only key we had was the one we are deleting
                if (!isNaN(path[index - 1]) && !destroyArrays) // we are in an array, so return an empty object
                return {};
                else return undefined;
            }
            current[key];
            var _final = (0, $ddEsc.default)(current, [
                key
            ].map($f9a9822f8af64e2a$var$_toPropertyKey));
            return _final;
        }
        // set result in key
        return (0, $bS32t.default)({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
    }
    // array set
    var numericKey = Number(key);
    if (current === undefined || current === null) {
        // recurse
        var _result3 = setInRecursor(undefined, index + 1, path, value1, destroyArrays);
        // if nothing returned, delete it
        if (_result3 === undefined) return undefined;
        // create an array
        var _array = [];
        _array[numericKey] = _result3;
        return _array;
    }
    if (!Array.isArray(current)) throw new Error("Cannot set a numeric property on an object");
    // recurse
    var existingValue = current[numericKey];
    var result = setInRecursor(existingValue, index + 1, path, value1, destroyArrays);
    // current exists, so make a copy of all its values, and add/update the new one
    var array = [].concat(current);
    if (destroyArrays && result === undefined) {
        array.splice(numericKey, 1);
        if (array.length === 0) return undefined;
    } else array[numericKey] = result;
    return array;
};
var $f9a9822f8af64e2a$export$e6bdf135a54e021b = function setIn(state, key, value1, destroyArrays) {
    if (destroyArrays === void 0) destroyArrays = false;
    if (state === undefined || state === null) throw new Error("Cannot call setIn() with " + String(state) + " state");
    if (key === undefined || key === null) throw new Error("Cannot call setIn() with " + String(key) + " key");
    // Recursive function needs to accept and return State, but public API should
    // only deal with Objects
    return $f9a9822f8af64e2a$var$setInRecursor(state, 0, $f9a9822f8af64e2a$var$toPath(key), value1, destroyArrays);
};
var $f9a9822f8af64e2a$export$97cd7fc25dd32915 = "FINAL_FORM/form-error";
var $f9a9822f8af64e2a$export$735bebc8ffabf28a = "FINAL_FORM/array-error";
//      
/**
 * Converts internal field state to published field state
 */ function $f9a9822f8af64e2a$var$publishFieldState(formState, field) {
    var errors = formState.errors, initialValues = formState.initialValues, lastSubmittedValues = formState.lastSubmittedValues, submitErrors = formState.submitErrors, submitFailed = formState.submitFailed, submitSucceeded = formState.submitSucceeded, submitting = formState.submitting, values = formState.values;
    var active = field.active, blur = field.blur, change = field.change, data = field.data, focus = field.focus, modified = field.modified, modifiedSinceLastSubmit = field.modifiedSinceLastSubmit, name = field.name, touched = field.touched, validating = field.validating, visited = field.visited;
    var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(values, name);
    var error = $f9a9822f8af64e2a$export$c52e5867d5879e24(errors, name);
    if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) error = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
    var submitError = submitErrors && $f9a9822f8af64e2a$export$c52e5867d5879e24(submitErrors, name);
    var initial = initialValues && $f9a9822f8af64e2a$export$c52e5867d5879e24(initialValues, name);
    var pristine = field.isEqual(initial, value1);
    var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(lastSubmittedValues, name), value1));
    var valid = !error && !submitError;
    return {
        active: active,
        blur: blur,
        change: change,
        data: data,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        error: error,
        focus: focus,
        initial: initial,
        invalid: !valid,
        length: Array.isArray(value1) ? value1.length : undefined,
        modified: modified,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        name: name,
        pristine: pristine,
        submitError: submitError,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitting: submitting,
        touched: touched,
        valid: valid,
        value: value1,
        visited: visited,
        validating: validating
    };
}
//      
var $f9a9822f8af64e2a$export$41e855cb628c1b55 = [
    "active",
    "data",
    "dirty",
    "dirtySinceLastSubmit",
    "error",
    "initial",
    "invalid",
    "length",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitError",
    "submitFailed",
    "submitSucceeded",
    "submitting",
    "touched",
    "valid",
    "value",
    "visited",
    "validating"
];
//      
var $f9a9822f8af64e2a$var$shallowEqual = function shallowEqual(a, b) {
    if (a === b) return true;
    if (typeof a !== "object" || !a || typeof b !== "object" || !b) return false;
    var keysA = Object.keys(a);
    var keysB = Object.keys(b);
    if (keysA.length !== keysB.length) return false;
    var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
    for(var idx = 0; idx < keysA.length; idx++){
        var key = keysA[idx];
        if (!bHasOwnProperty(key) || a[key] !== b[key]) return false;
    }
    return true;
};
//      
function $f9a9822f8af64e2a$var$subscriptionFilter(dest, src, previous, subscription, keys, shallowEqualKeys) {
    var different = false;
    keys.forEach(function(key) {
        if (subscription[key]) {
            dest[key] = src[key];
            if (!previous || (~shallowEqualKeys.indexOf(key) ? !$f9a9822f8af64e2a$var$shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) different = true;
        }
    });
    return different;
}
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys$1 = [
    "data"
];
/**
 * Filters items in a FieldState based on a FieldSubscription
 */ var $f9a9822f8af64e2a$var$filterFieldState = function filterFieldState(state, previousState, subscription, force) {
    var result = {
        blur: state.blur,
        change: state.change,
        focus: state.focus,
        name: state.name
    };
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$41e855cb628c1b55, $f9a9822f8af64e2a$var$shallowEqualKeys$1) || !previousState;
    return different || force ? result : undefined;
};
//      
var $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3 = [
    "active",
    "dirty",
    "dirtyFields",
    "dirtyFieldsSinceLastSubmit",
    "dirtySinceLastSubmit",
    "error",
    "errors",
    "hasSubmitErrors",
    "hasValidationErrors",
    "initialValues",
    "invalid",
    "modified",
    "modifiedSinceLastSubmit",
    "pristine",
    "submitting",
    "submitError",
    "submitErrors",
    "submitFailed",
    "submitSucceeded",
    "touched",
    "valid",
    "validating",
    "values",
    "visited"
];
//      
var $f9a9822f8af64e2a$var$shallowEqualKeys = [
    "touched",
    "visited"
];
/**
 * Filters items in a FormState based on a FormSubscription
 */ function $f9a9822f8af64e2a$var$filterFormState(state, previousState, subscription, force) {
    var result = {};
    var different = $f9a9822f8af64e2a$var$subscriptionFilter(result, state, previousState, subscription, $f9a9822f8af64e2a$export$f1ff97b9d1c7a3c3, $f9a9822f8af64e2a$var$shallowEqualKeys) || !previousState;
    return different || force ? result : undefined;
}
//      
var $f9a9822f8af64e2a$var$memoize = function memoize(fn) {
    var lastArgs;
    var lastResult;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        if (!lastArgs || args.length !== lastArgs.length || args.some(function(arg, index) {
            return !$f9a9822f8af64e2a$var$shallowEqual(lastArgs[index], arg);
        })) {
            lastArgs = args;
            lastResult = fn.apply(void 0, args);
        }
        return lastResult;
    };
};
var $f9a9822f8af64e2a$var$isPromise = function(obj) {
    return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
};
var $f9a9822f8af64e2a$export$83d89fbfd8236492 = "4.20.10";
var $f9a9822f8af64e2a$export$480bc304a47a3b09 = [
    "debug",
    "initialValues",
    "keepDirtyOnReinitialize",
    "mutators",
    "onSubmit",
    "validate",
    "validateOnBlur"
];
var $f9a9822f8af64e2a$var$tripleEquals = function tripleEquals(a, b) {
    return a === b;
};
var $f9a9822f8af64e2a$var$hasAnyError = function hasAnyError(errors) {
    return Object.keys(errors).some(function(key) {
        var value1 = errors[key];
        if (value1 && typeof value1 === "object" && !(value1 instanceof Error)) return hasAnyError(value1);
        return typeof value1 !== "undefined";
    });
};
function $f9a9822f8af64e2a$var$convertToExternalFormState(_ref) {
    var active = _ref.active, dirtySinceLastSubmit = _ref.dirtySinceLastSubmit, modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit, error = _ref.error, errors = _ref.errors, initialValues = _ref.initialValues, pristine = _ref.pristine, submitting = _ref.submitting, submitFailed = _ref.submitFailed, submitSucceeded = _ref.submitSucceeded, submitError = _ref.submitError, submitErrors = _ref.submitErrors, valid = _ref.valid, validating = _ref.validating, values = _ref.values;
    return {
        active: active,
        dirty: !pristine,
        dirtySinceLastSubmit: dirtySinceLastSubmit,
        modifiedSinceLastSubmit: modifiedSinceLastSubmit,
        error: error,
        errors: errors,
        hasSubmitErrors: !!(submitError || submitErrors && $f9a9822f8af64e2a$var$hasAnyError(submitErrors)),
        hasValidationErrors: !!(error || $f9a9822f8af64e2a$var$hasAnyError(errors)),
        invalid: !valid,
        initialValues: initialValues,
        pristine: pristine,
        submitting: submitting,
        submitFailed: submitFailed,
        submitSucceeded: submitSucceeded,
        submitError: submitError,
        submitErrors: submitErrors,
        valid: valid,
        validating: validating > 0,
        values: values
    };
}
function $f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
    var notification = filter(state, lastState, subscription, force);
    if (notification) {
        subscriber(notification);
        return true;
    }
    return false;
}
function $f9a9822f8af64e2a$var$notify(_ref2, state, lastState, filter, force) {
    var entries = _ref2.entries;
    Object.keys(entries).forEach(function(key) {
        var entry = entries[Number(key)];
        // istanbul ignore next
        if (entry) {
            var subscription = entry.subscription, subscriber = entry.subscriber, notified = entry.notified;
            if ($f9a9822f8af64e2a$var$notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) entry.notified = true;
        }
    });
}
function $f9a9822f8af64e2a$export$f681a8129d2e9d28(config) {
    if (!config) throw new Error("No config specified");
    var debug = config.debug, destroyOnUnregister = config.destroyOnUnregister, keepDirtyOnReinitialize = config.keepDirtyOnReinitialize, initialValues = config.initialValues, mutators = config.mutators, onSubmit = config.onSubmit, validate = config.validate, validateOnBlur = config.validateOnBlur;
    if (!onSubmit) throw new Error("No onSubmit function specified");
    var state = {
        subscribers: {
            index: 0,
            entries: {}
        },
        fieldSubscribers: {},
        fields: {},
        formState: {
            asyncErrors: {},
            dirtySinceLastSubmit: false,
            modifiedSinceLastSubmit: false,
            errors: {},
            initialValues: initialValues && (0, $bS32t.default)({}, initialValues),
            invalid: false,
            pristine: true,
            submitting: false,
            submitFailed: false,
            submitSucceeded: false,
            resetWhileSubmitting: false,
            valid: true,
            validating: 0,
            values: initialValues ? (0, $bS32t.default)({}, initialValues) : {}
        },
        lastFormState: undefined
    };
    var inBatch = 0;
    var validationPaused = false;
    var validationBlocked = false;
    var preventNotificationWhileValidationPaused = false;
    var nextAsyncValidationKey = 0;
    var asyncValidationPromises = {};
    var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
        return function(result) {
            delete asyncValidationPromises[key];
            return result;
        };
    };
    var changeValue = function changeValue(state, name, mutate) {
        var before = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name);
        var after = mutate(before);
        state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, after) || {};
    };
    var renameField = function renameField(state, from, to) {
        if (state.fields[from]) {
            var _extends2, _extends3;
            state.fields = (0, $bS32t.default)({}, state.fields, (_extends2 = {}, _extends2[to] = (0, $bS32t.default)({}, state.fields[from], {
                name: to,
                // rebind event handlers
                blur: function blur() {
                    return api.blur(to);
                },
                change: function change(value1) {
                    return api.change(to, value1);
                },
                focus: function focus() {
                    return api.focus(to);
                },
                lastFieldState: undefined
            }), _extends2));
            delete state.fields[from];
            state.fieldSubscribers = (0, $bS32t.default)({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
            delete state.fieldSubscribers[from];
            var value1 = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, from);
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, from, undefined) || {};
            state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, to, value1);
            delete state.lastFormState;
        }
    };
    // bind state to mutators
    var getMutatorApi = function getMutatorApi(key) {
        return function() {
            // istanbul ignore next
            if (mutators) {
                // ^^ causes branch coverage warning, but needed to appease the Flow gods
                var mutatableState = {
                    formState: state.formState,
                    fields: state.fields,
                    fieldSubscribers: state.fieldSubscribers,
                    lastFormState: state.lastFormState
                };
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
                var returnValue = mutators[key](args, mutatableState, {
                    changeValue: changeValue,
                    getIn: $f9a9822f8af64e2a$export$c52e5867d5879e24,
                    renameField: renameField,
                    resetFieldState: api.resetFieldState,
                    setIn: $f9a9822f8af64e2a$export$e6bdf135a54e021b,
                    shallowEqual: $f9a9822f8af64e2a$var$shallowEqual
                });
                state.formState = mutatableState.formState;
                state.fields = mutatableState.fields;
                state.fieldSubscribers = mutatableState.fieldSubscribers;
                state.lastFormState = mutatableState.lastFormState;
                runValidation(undefined, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                return returnValue;
            }
        };
    };
    var mutatorsApi = mutators ? Object.keys(mutators).reduce(function(result, key) {
        result[key] = getMutatorApi(key);
        return result;
    }, {}) : {};
    var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
        var promises = [];
        if (validate) {
            var errorsOrPromise = validate((0, $bS32t.default)({}, state.formState.values)); // clone to avoid writing
            if ($f9a9822f8af64e2a$var$isPromise(errorsOrPromise)) promises.push(errorsOrPromise.then(function(errors) {
                return setErrors(errors, true);
            }));
            else setErrors(errorsOrPromise, false);
        }
        return promises;
    };
    var getValidators = function getValidators(field) {
        return Object.keys(field.validators).reduce(function(result, index) {
            var validator = field.validators[Number(index)]();
            if (validator) result.push(validator);
            return result;
        }, []);
    };
    var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
        var promises = [];
        var validators = getValidators(field);
        if (validators.length) {
            var error;
            validators.forEach(function(validator) {
                var errorOrPromise = validator($f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? $f9a9822f8af64e2a$var$publishFieldState(state.formState, state.fields[field.name]) : undefined);
                if (errorOrPromise && $f9a9822f8af64e2a$var$isPromise(errorOrPromise)) {
                    field.validating = true;
                    var promise = errorOrPromise.then(function(error) {
                        if (state.fields[field.name]) {
                            state.fields[field.name].validating = false;
                            setError(error);
                        }
                    }); // errors must be resolved, not rejected
                    promises.push(promise);
                } else if (!error) // first registered validator wins
                error = errorOrPromise;
            });
            setError(error);
        }
        return promises;
    };
    var runValidation = function runValidation(fieldChanged, callback) {
        if (validationPaused) {
            validationBlocked = true;
            callback();
            return;
        }
        var fields = state.fields, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var fieldKeys = Object.keys(safeFields);
        if (!validate && !fieldKeys.some(function(key) {
            return getValidators(safeFields[key]).length;
        })) {
            callback();
            return; // no validation rules
        }
        // pare down field keys to actually validate
        var limitedFieldLevelValidation = false;
        if (fieldChanged) {
            var changedField = safeFields[fieldChanged];
            if (changedField) {
                var validateFields = changedField.validateFields;
                if (validateFields) {
                    limitedFieldLevelValidation = true;
                    fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [
                        fieldChanged
                    ];
                }
            }
        }
        var recordLevelErrors = {};
        var asyncRecordLevelErrors = {};
        var fieldLevelErrors = {};
        var promises = [].concat(runRecordLevelValidation(function(errors, wasAsync) {
            if (wasAsync) asyncRecordLevelErrors = errors || {};
            else recordLevelErrors = errors || {};
        }), fieldKeys.reduce(function(result, name) {
            return result.concat(runFieldLevelValidation(fields[name], function(error) {
                fieldLevelErrors[name] = error;
            }));
        }, []));
        var hasAsyncValidations = promises.length > 0;
        var asyncValidationPromiseKey = ++nextAsyncValidationKey;
        var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));
        // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
        if (hasAsyncValidations) asyncValidationPromises[asyncValidationPromiseKey] = promise;
        var processErrors = function processErrors(afterAsync) {
            var merged = (0, $bS32t.default)({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
             : formState.asyncErrors);
            var forEachError = function forEachError(fn) {
                fieldKeys.forEach(function(name) {
                    if (fields[name]) {
                        // make sure field is still registered
                        // field-level errors take precedent over record-level errors
                        var recordLevelError = $f9a9822f8af64e2a$export$c52e5867d5879e24(recordLevelErrors, name);
                        var errorFromParent = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                        var hasFieldLevelValidation = getValidators(safeFields[name]).length;
                        var fieldLevelError = fieldLevelErrors[name];
                        fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
                    }
                });
            };
            forEachError(function(name, error) {
                merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, error) || {};
            });
            forEachError(function(name, error) {
                if (error && error[$f9a9822f8af64e2a$export$735bebc8ffabf28a]) {
                    var existing = $f9a9822f8af64e2a$export$c52e5867d5879e24(merged, name);
                    var copy = [].concat(existing);
                    copy[$f9a9822f8af64e2a$export$735bebc8ffabf28a] = error[$f9a9822f8af64e2a$export$735bebc8ffabf28a];
                    merged = $f9a9822f8af64e2a$export$e6bdf135a54e021b(merged, name, copy);
                }
            });
            if (!$f9a9822f8af64e2a$var$shallowEqual(formState.errors, merged)) formState.errors = merged;
            if (afterAsync) formState.asyncErrors = asyncRecordLevelErrors;
            formState.error = recordLevelErrors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
        };
        if (hasAsyncValidations) {
            // async validations are running, ensure validating is true before notifying
            state.formState.validating++;
            callback();
        }
        // process sync errors
        processErrors(false);
        // sync errors have been set. notify listeners while we wait for others
        callback();
        if (hasAsyncValidations) {
            var afterPromise = function afterPromise() {
                state.formState.validating--;
                callback();
                // field async validation may affect formState validating
                // so force notifyFormListeners if validating is still 0 after callback finished
                // and lastFormState validating is true
                if (state.formState.validating === 0 && state.lastFormState.validating) notifyFormListeners();
            };
            promise.then(function() {
                if (nextAsyncValidationKey > asyncValidationPromiseKey) // if this async validator has been superseded by another, ignore its results
                return;
                processErrors(true);
            }).then(afterPromise, afterPromise);
        }
    };
    var notifyFieldListeners = function notifyFieldListeners(name) {
        if (inBatch) return;
        var fields = state.fields, fieldSubscribers = state.fieldSubscribers, formState = state.formState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var notifyField = function notifyField(name) {
            var field = safeFields[name];
            var fieldState = $f9a9822f8af64e2a$var$publishFieldState(formState, field);
            var lastFieldState = field.lastFieldState;
            field.lastFieldState = fieldState;
            var fieldSubscriber = fieldSubscribers[name];
            if (fieldSubscriber) $f9a9822f8af64e2a$var$notify(fieldSubscriber, fieldState, lastFieldState, $f9a9822f8af64e2a$var$filterFieldState, lastFieldState === undefined);
        };
        if (name) notifyField(name);
        else Object.keys(safeFields).forEach(notifyField);
    };
    var markAllFieldsTouched = function markAllFieldsTouched() {
        Object.keys(state.fields).forEach(function(key) {
            state.fields[key].touched = true;
        });
    };
    var hasSyncErrors = function hasSyncErrors() {
        return !!(state.formState.error || $f9a9822f8af64e2a$var$hasAnyError(state.formState.errors));
    };
    var calculateNextFormState = function calculateNextFormState() {
        var fields = state.fields, formState = state.formState, lastFormState = state.lastFormState;
        var safeFields = (0, $bS32t.default)({}, fields);
        var safeFieldKeys = Object.keys(safeFields);
        // calculate dirty/pristine
        var foundDirty = false;
        var dirtyFields = safeFieldKeys.reduce(function(result, key) {
            var dirty = !safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
            if (dirty) {
                foundDirty = true;
                result[key] = true;
            }
            return result;
        }, {});
        var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function(result, key) {
            // istanbul ignore next
            var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
            if (!safeFields[key].isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(nonNullLastSubmittedValues, key))) result[key] = true;
            return result;
        }, {});
        formState.pristine = !foundDirty;
        formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function(value1) {
            return value1;
        }));
        formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues && // Object.values would treat values as mixed (facebook/flow#2221)
        Object.keys(safeFields).some(function(value1) {
            return safeFields[value1].modifiedSinceLastSubmit;
        }));
        formState.valid = !formState.error && !formState.submitError && !$f9a9822f8af64e2a$var$hasAnyError(formState.errors) && !(formState.submitErrors && $f9a9822f8af64e2a$var$hasAnyError(formState.submitErrors));
        var nextFormState = $f9a9822f8af64e2a$var$convertToExternalFormState(formState);
        var _safeFieldKeys$reduce = safeFieldKeys.reduce(function(result, key) {
            result.modified[key] = safeFields[key].modified;
            result.touched[key] = safeFields[key].touched;
            result.visited[key] = safeFields[key].visited;
            return result;
        }, {
            modified: {},
            touched: {},
            visited: {}
        }), modified = _safeFieldKeys$reduce.modified, touched = _safeFieldKeys$reduce.touched, visited = _safeFieldKeys$reduce.visited;
        nextFormState.dirtyFields = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
        nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
        nextFormState.modified = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
        nextFormState.touched = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
        nextFormState.visited = lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
        return lastFormState && $f9a9822f8af64e2a$var$shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
    };
    var callDebug = function callDebug() {
        return debug && true && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function(result, key) {
            result[key] = state.fields[key];
            return result;
        }, {}));
    };
    var notifying = false;
    var scheduleNotification = false;
    var notifyFormListeners = function notifyFormListeners() {
        if (notifying) scheduleNotification = true;
        else {
            notifying = true;
            callDebug();
            if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
                var lastFormState = state.lastFormState;
                var nextFormState = calculateNextFormState();
                if (nextFormState !== lastFormState) {
                    state.lastFormState = nextFormState;
                    $f9a9822f8af64e2a$var$notify(state.subscribers, nextFormState, lastFormState, $f9a9822f8af64e2a$var$filterFormState);
                }
            }
            notifying = false;
            if (scheduleNotification) {
                scheduleNotification = false;
                notifyFormListeners();
            }
        }
    };
    var beforeSubmit = function beforeSubmit() {
        return Object.keys(state.fields).some(function(name) {
            return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
        });
    };
    var afterSubmit = function afterSubmit() {
        return Object.keys(state.fields).forEach(function(name) {
            return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
        });
    };
    var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
        return Object.keys(state.fields).forEach(function(key) {
            return state.fields[key].modifiedSinceLastSubmit = false;
        });
    };
    // generate initial errors
    runValidation(undefined, function() {
        notifyFormListeners();
    });
    var api = {
        batch: function batch(fn) {
            inBatch++;
            fn();
            inBatch--;
            notifyFieldListeners();
            notifyFormListeners();
        },
        blur: function blur(name) {
            var fields = state.fields, formState = state.formState;
            var previous = fields[name];
            if (previous) {
                // can only blur registered fields
                delete formState.active;
                fields[name] = (0, $bS32t.default)({}, previous, {
                    active: false,
                    touched: true
                });
                if (validateOnBlur) runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
                else {
                    notifyFieldListeners();
                    notifyFormListeners();
                }
            }
        },
        change: function change(name, value1) {
            var fields = state.fields, formState = state.formState;
            if ($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, name) !== value1) {
                changeValue(state, name, function() {
                    return value1;
                });
                var previous = fields[name];
                if (previous) // only track modified for registered fields
                fields[name] = (0, $bS32t.default)({}, previous, {
                    modified: true,
                    modifiedSinceLastSubmit: !!formState.lastSubmittedValues
                });
                if (validateOnBlur) {
                    notifyFieldListeners();
                    notifyFormListeners();
                } else runValidation(name, function() {
                    notifyFieldListeners();
                    notifyFormListeners();
                });
            }
        },
        get destroyOnUnregister () {
            return !!destroyOnUnregister;
        },
        set destroyOnUnregister (value){
            destroyOnUnregister = value;
        },
        focus: function focus(name) {
            var field = state.fields[name];
            if (field && !field.active) {
                state.formState.active = name;
                field.active = true;
                field.visited = true;
                notifyFieldListeners();
                notifyFormListeners();
            }
        },
        mutators: mutatorsApi,
        getFieldState: function getFieldState(name) {
            var field = state.fields[name];
            return field && field.lastFieldState;
        },
        getRegisteredFields: function getRegisteredFields() {
            return Object.keys(state.fields);
        },
        getState: function getState() {
            return calculateNextFormState();
        },
        initialize: function initialize(data) {
            var fields = state.fields, formState = state.formState;
            var safeFields = (0, $bS32t.default)({}, fields);
            var values = typeof data === "function" ? data(formState.values) : data;
            if (!keepDirtyOnReinitialize) formState.values = values;
            /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */ // save dirty values
            var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function(result, key) {
                var field = safeFields[key];
                var pristine = field.isEqual($f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key), $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.initialValues || {}, key));
                if (!pristine) result[key] = $f9a9822f8af64e2a$export$c52e5867d5879e24(formState.values, key);
                return result;
            }, {}) : {};
            // update initalValues and values
            formState.initialValues = values;
            formState.values = values;
            // restore the dirty values
            Object.keys(savedDirtyValues).forEach(function(key) {
                formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(formState.values, key, savedDirtyValues[key]) || {};
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        isValidationPaused: function isValidationPaused() {
            return validationPaused;
        },
        pauseValidation: function pauseValidation(preventNotification) {
            if (preventNotification === void 0) preventNotification = true;
            validationPaused = true;
            preventNotificationWhileValidationPaused = preventNotification;
        },
        registerField: function registerField(name, subscriber, subscription, fieldConfig) {
            if (subscription === void 0) subscription = {};
            if (!state.fieldSubscribers[name]) state.fieldSubscribers[name] = {
                index: 0,
                entries: {}
            };
            var index = state.fieldSubscribers[name].index++;
            // save field subscriber callback
            state.fieldSubscribers[name].entries[index] = {
                subscriber: $f9a9822f8af64e2a$var$memoize(subscriber),
                subscription: subscription,
                notified: false
            };
            // create initial field state if not exists
            var field = state.fields[name] || {
                active: false,
                afterSubmit: fieldConfig && fieldConfig.afterSubmit,
                beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
                data: fieldConfig && fieldConfig.data || {},
                isEqual: fieldConfig && fieldConfig.isEqual || $f9a9822f8af64e2a$var$tripleEquals,
                lastFieldState: undefined,
                modified: false,
                modifiedSinceLastSubmit: false,
                name: name,
                touched: false,
                valid: true,
                validateFields: fieldConfig && fieldConfig.validateFields,
                validators: {},
                validating: false,
                visited: false
            };
            // Mutators can create a field in order to keep the field states
            // We must update this field when registerField is called afterwards
            field.blur = field.blur || function() {
                return api.blur(name);
            };
            field.change = field.change || function(value1) {
                return api.change(name, value1);
            };
            field.focus = field.focus || function() {
                return api.focus(name);
            };
            state.fields[name] = field;
            var haveValidator = false;
            var silent = fieldConfig && fieldConfig.silent;
            var notify = function notify() {
                if (silent && state.fields[name]) notifyFieldListeners(name);
                else {
                    notifyFormListeners();
                    notifyFieldListeners();
                }
            };
            if (fieldConfig) {
                haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
                if (fieldConfig.getValidator) state.fields[name].validators[index] = fieldConfig.getValidator;
                var noValueInFormState = $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === undefined;
                if (fieldConfig.initialValue !== undefined && (noValueInFormState || $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.values, name) === $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name))) {
                    state.formState.initialValues = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.initialValues || {}, name, fieldConfig.initialValue);
                    state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.initialValue);
                    runValidation(undefined, notify);
                }
                // only use defaultValue if we don't yet have any value for this field
                if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && $f9a9822f8af64e2a$export$c52e5867d5879e24(state.formState.initialValues, name) === undefined && noValueInFormState) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, fieldConfig.defaultValue);
            }
            if (haveValidator) runValidation(undefined, notify);
            else notify();
            return function() {
                var validatorRemoved = false;
                // istanbul ignore next
                if (state.fields[name]) {
                    // state.fields[name] may have been removed by a mutator
                    validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
                    delete state.fields[name].validators[index];
                }
                var hasFieldSubscribers = !!state.fieldSubscribers[name];
                if (hasFieldSubscribers) // state.fieldSubscribers[name] may have been removed by a mutator
                delete state.fieldSubscribers[name].entries[index];
                var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
                if (lastOne) {
                    delete state.fieldSubscribers[name];
                    delete state.fields[name];
                    if (validatorRemoved) state.formState.errors = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.errors, name, undefined) || {};
                    if (destroyOnUnregister) state.formState.values = $f9a9822f8af64e2a$export$e6bdf135a54e021b(state.formState.values, name, undefined, true) || {};
                }
                if (!silent) {
                    if (validatorRemoved) runValidation(undefined, function() {
                        notifyFormListeners();
                        notifyFieldListeners();
                    });
                    else if (lastOne) // values or errors may have changed
                    notifyFormListeners();
                }
            };
        },
        reset: function reset(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            if (state.formState.submitting) state.formState.resetWhileSubmitting = true;
            state.formState.submitFailed = false;
            state.formState.submitSucceeded = false;
            delete state.formState.submitError;
            delete state.formState.submitErrors;
            delete state.formState.lastSubmittedValues;
            api.initialize(initialValues || {});
        },
        /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */ resetFieldState: function resetFieldState(name) {
            state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                active: false,
                lastFieldState: undefined,
                modified: false,
                touched: false,
                valid: true,
                validating: false,
                visited: false
            });
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
        },
        /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */ restart: function restart(initialValues) {
            if (initialValues === void 0) initialValues = state.formState.initialValues;
            api.batch(function() {
                for(var name in state.fields){
                    api.resetFieldState(name);
                    state.fields[name] = (0, $bS32t.default)({}, state.fields[name], {
                        active: false,
                        lastFieldState: undefined,
                        modified: false,
                        modifiedSinceLastSubmit: false,
                        touched: false,
                        valid: true,
                        validating: false,
                        visited: false
                    });
                }
                api.reset(initialValues);
            });
        },
        resumeValidation: function resumeValidation() {
            validationPaused = false;
            preventNotificationWhileValidationPaused = false;
            if (validationBlocked) // validation was attempted while it was paused, so run it now
            runValidation(undefined, function() {
                notifyFieldListeners();
                notifyFormListeners();
            });
            validationBlocked = false;
        },
        setConfig: function setConfig(name, value1) {
            switch(name){
                case "debug":
                    debug = value1;
                    break;
                case "destroyOnUnregister":
                    destroyOnUnregister = value1;
                    break;
                case "initialValues":
                    api.initialize(value1);
                    break;
                case "keepDirtyOnReinitialize":
                    keepDirtyOnReinitialize = value1;
                    break;
                case "mutators":
                    mutators = value1;
                    if (value1) {
                        Object.keys(mutatorsApi).forEach(function(key) {
                            if (!(key in value1)) delete mutatorsApi[key];
                        });
                        Object.keys(value1).forEach(function(key) {
                            mutatorsApi[key] = getMutatorApi(key);
                        });
                    } else Object.keys(mutatorsApi).forEach(function(key) {
                        delete mutatorsApi[key];
                    });
                    break;
                case "onSubmit":
                    onSubmit = value1;
                    break;
                case "validate":
                    validate = value1;
                    runValidation(undefined, function() {
                        notifyFieldListeners();
                        notifyFormListeners();
                    });
                    break;
                case "validateOnBlur":
                    validateOnBlur = value1;
                    break;
                default:
                    throw new Error("Unrecognised option " + name);
            }
        },
        submit: function submit() {
            var formState = state.formState;
            if (formState.submitting) return;
            delete formState.submitErrors;
            delete formState.submitError;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            if (hasSyncErrors()) {
                markAllFieldsTouched();
                resetModifiedAfterSubmit();
                state.formState.submitFailed = true;
                notifyFormListeners();
                notifyFieldListeners();
                return; // no submit for you!!
            }
            var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
            if (asyncValidationPromisesKeys.length) {
                // still waiting on async validation to complete...
                Promise.all(asyncValidationPromisesKeys.map(function(key) {
                    return asyncValidationPromises[Number(key)];
                })).then(api.submit, console.error);
                return;
            }
            var submitIsBlocked = beforeSubmit();
            if (submitIsBlocked) return;
            var resolvePromise;
            var completeCalled = false;
            var complete = function complete(errors) {
                formState.submitting = false;
                var resetWhileSubmitting = formState.resetWhileSubmitting;
                if (resetWhileSubmitting) formState.resetWhileSubmitting = false;
                if (errors && $f9a9822f8af64e2a$var$hasAnyError(errors)) {
                    formState.submitFailed = true;
                    formState.submitSucceeded = false;
                    formState.submitErrors = errors;
                    formState.submitError = errors[$f9a9822f8af64e2a$export$97cd7fc25dd32915];
                    markAllFieldsTouched();
                } else {
                    if (!resetWhileSubmitting) {
                        formState.submitFailed = false;
                        formState.submitSucceeded = true;
                    }
                    afterSubmit();
                }
                notifyFormListeners();
                notifyFieldListeners();
                completeCalled = true;
                if (resolvePromise) resolvePromise(errors);
                return errors;
            };
            formState.submitting = true;
            formState.submitFailed = false;
            formState.submitSucceeded = false;
            formState.lastSubmittedValues = (0, $bS32t.default)({}, formState.values);
            resetModifiedAfterSubmit();
            // onSubmit is either sync, callback or async with a Promise
            var result = onSubmit(formState.values, api, complete);
            if (!completeCalled) {
                if (result && $f9a9822f8af64e2a$var$isPromise(result)) {
                    // onSubmit is async with a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return result.then(complete, function(error) {
                        complete();
                        throw error;
                    });
                } else if (onSubmit.length >= 3) {
                    // must be async, so we should return a Promise
                    notifyFormListeners(); // let everyone know we are submitting
                    notifyFieldListeners(); // notify fields also
                    return new Promise(function(resolve) {
                        resolvePromise = resolve;
                    });
                } else // onSubmit is sync
                complete(result);
            }
        },
        subscribe: function subscribe(subscriber, subscription) {
            if (!subscriber) throw new Error("No callback given.");
            if (!subscription) throw new Error("No subscription provided. What values do you want to listen to?");
            var memoized = $f9a9822f8af64e2a$var$memoize(subscriber);
            var subscribers = state.subscribers;
            var index = subscribers.index++;
            subscribers.entries[index] = {
                subscriber: memoized,
                subscription: subscription,
                notified: false
            };
            var nextFormState = calculateNextFormState();
            $f9a9822f8af64e2a$var$notifySubscriber(memoized, subscription, nextFormState, nextFormState, $f9a9822f8af64e2a$var$filterFormState, true);
            return function() {
                delete subscribers.entries[index];
            };
        }
    };
    return api;
}

});

parcelRegister("8tHJX", function(module, exports) {

$parcel$export(module.exports, "default", () => $62c2f612c5adb35a$export$2e2bcd8739ae039);

var $lqWDn = parcelRequire("lqWDn");
//      
/**
 * Predicate to identify inputs that can have focus() called on them
 */ var $62c2f612c5adb35a$var$isFocusableInput = function isFocusableInput(wtf) {
    return !!(wtf && typeof wtf.focus === 'function');
};
//      
/**
 * Gets all the inputs inside all forms on the page
 */ var $62c2f612c5adb35a$var$getAllInputs = function getAllInputs() {
    if (typeof document === 'undefined') return [];
    return Array.prototype.slice.call(document.forms).reduce(function(accumulator, form) {
        return accumulator.concat(Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput));
    }, []);
};
//      
/**
 * Finds the input by looking if the name attribute path is existing in the errors object
 */ var $62c2f612c5adb35a$var$findInput = function findInput(inputs, errors) {
    return inputs.find(function(input) {
        return input.name && (0, $lqWDn.getIn)(errors, input.name);
    });
};
//      
var $62c2f612c5adb35a$var$noop = function noop() {};
var $62c2f612c5adb35a$var$createDecorator = function createDecorator(getInputs, findInput$$1) {
    return function(form) {
        var focusOnFirstError = function focusOnFirstError(errors) {
            if (!getInputs) getInputs = $62c2f612c5adb35a$var$getAllInputs;
            if (!findInput$$1) findInput$$1 = $62c2f612c5adb35a$var$findInput;
            var firstInput = findInput$$1(getInputs(), errors);
            if (firstInput) firstInput.focus();
        }; // Save original submit function
        var originalSubmit = form.submit; // Subscribe to errors, and keep a local copy of them
        var state = {};
        var unsubscribe = form.subscribe(function(nextState) {
            state = nextState;
        }, {
            errors: true,
            submitErrors: true
        }); // What to do after submit
        var afterSubmit = function afterSubmit() {
            var _state = state, errors = _state.errors, submitErrors = _state.submitErrors;
            if (errors && Object.keys(errors).length) focusOnFirstError(errors);
            else if (submitErrors && Object.keys(submitErrors).length) focusOnFirstError(submitErrors);
        }; // Rewrite submit function
        form.submit = function() {
            var result = originalSubmit.call(form);
            if (result && typeof result.then === 'function') // async
            result.then(afterSubmit, $62c2f612c5adb35a$var$noop);
            else // sync
            afterSubmit();
            return result;
        };
        return function() {
            unsubscribe();
            form.submit = originalSubmit;
        };
    };
};
//      
/**
 * Generates a function to get all the inputs in a form with the specified name
 */ var $62c2f612c5adb35a$export$a53c79cbd9f0d029 = function getFormInputs(name) {
    return function() {
        if (typeof document === 'undefined') return [];
         // $FlowFixMe
        var form = document.forms[name];
        return form && form.length ? Array.prototype.slice.call(form).filter($62c2f612c5adb35a$var$isFocusableInput) : []; // cast cheat to get from HTMLFormElement children to FocusableInput
    };
};
var //
$62c2f612c5adb35a$export$2e2bcd8739ae039 = $62c2f612c5adb35a$var$createDecorator;

});


parcelRegister("2x3Cb", function(module, exports) {

$parcel$export(module.exports, "Label", () => $987b76a5b7a0ea9b$export$b04be29aa201d4f5);
$parcel$export(module.exports, "Legend", () => $987b76a5b7a0ea9b$export$ed247974535929c7);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $987b76a5b7a0ea9b$var$fieldsetLabelStyles = null;
const $987b76a5b7a0ea9b$export$b04be29aa201d4f5 = ({ children: children, htmlFor: htmlFor, id: id, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        id: id,
        htmlFor: htmlFor,
        "data-testid": testId,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
const $987b76a5b7a0ea9b$export$ed247974535929c7 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("legend", {
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1o8l _syaz1gjq _k48pmoej _6rth1b66 _1pfhze3t"
        ]),
        children: children
    });
};

});

parcelRegister("kxqHl", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55ac25356e81a33$export$2e2bcd8739ae039);
/* required-asterisk.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d55ac25356e81a33$var$requiredIndicatorStyles = null;
function $d55ac25356e81a33$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": "true",
        title: "required",
        className: (0, $bwpsq.default)([
            "_syaz1ick _ect41gqc _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("1PDuf", function(module, exports) {

$parcel$export(module.exports, "default", () => $55d92d54fb10d87e$export$2e2bcd8739ae039);
/* buttons.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/design-system/no-nested-styles */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $42CjB = parcelRequire("42CjB");

var $lLLkM = parcelRequire("lLLkM");

var $bjGSs = parcelRequire("bjGSs");

var $hl2pN = parcelRequire("hl2pN");
const $55d92d54fb10d87e$var$buttonsContainerStyles = null;
const $55d92d54fb10d87e$var$buttonWrapperBaseStyles = null;
const $55d92d54fb10d87e$var$Buttons = ({ confirmButtonLabel: confirmButtonLabel, cancelButtonLabel: cancelButtonLabel, onMouseDown: onMouseDown, onCancelClick: onCancelClick, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswstnw _1o9zidpf _152t1osq _rjxpidpf _1pfh12x7"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    type: "submit",
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($hl2pN))), {
                            ...iconProps,
                            LEGACY_size: "small"
                        }),
                    onMouseDown: onMouseDown,
                    label: confirmButtonLabel,
                    testId: testId && `${testId}--confirm`
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                tabIndex: -1,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _11c82smr _vchhusvi _1bsbxy5q _1pby1kze _bfhk1bhr _16qs1mxi _1mpy1b66 _1nlxe0lp _l2uv1d38 _7mfv1dzg _szlb1x4z"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($bjGSs))), {
                            ...iconProps,
                            LEGACY_size: "small",
                            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($lLLkM)))
                        }),
                    label: cancelButtonLabel,
                    onClick: onCancelClick,
                    onMouseDown: onMouseDown,
                    testId: testId && `${testId}--cancel`
                })
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$55d92d54fb10d87e$export$2e2bcd8739ae039 = $55d92d54fb10d87e$var$Buttons;

});
parcelRegister("hl2pN", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::9db35ecad695c835ed46bfa4bbde0dff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c9f6456416d52b22$var$_react = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c9f6456416d52b22$var$_checkMark = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("f22iM")));

var $c9f6456416d52b22$var$_check = $c9f6456416d52b22$var$_interopRequireDefault((parcelRequire("kbxJz")));
function $c9f6456416d52b22$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CheckMarkIcon.
 * This component is CheckMarkIcon, with `UNSAFE_fallbackIcon` set to "CheckIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: 📦 @atlaskit/icon/utility/check-mark
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $c9f6456416d52b22$var$CheckMarkIcon = (props)=>/*#__PURE__*/ $c9f6456416d52b22$var$_react.default.createElement($c9f6456416d52b22$var$_checkMark.default, Object.assign({
        LEGACY_fallbackIcon: $c9f6456416d52b22$var$_check.default
    }, props));
$c9f6456416d52b22$var$CheckMarkIcon.Name = 'CheckMarkIconMigration';
var $c9f6456416d52b22$var$_default = module.exports.default = $c9f6456416d52b22$var$CheckMarkIcon;

});


parcelRegister("pZGLJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d5aa752dd00081f6$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
const $d5aa752dd00081f6$var$usePrevious = (value)=>{
    const ref = (0, $5uXOq.useRef)();
    (0, $5uXOq.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref.current;
};
const $d5aa752dd00081f6$var$useButtonFocusHook = (isEditing, isEditingState)=>{
    const editButtonRef = (0, $5uXOq.useRef)(null);
    const editViewRef = (0, $5uXOq.useRef)();
    const preventFocusOnEditButtonRef = (0, $5uXOq.useRef)(false);
    const isControlled = typeof isEditing === 'undefined';
    const shouldBeEditing = isControlled ? isEditingState : isEditing;
    const prevIsEditing = $d5aa752dd00081f6$var$usePrevious(shouldBeEditing);
    (0, $5uXOq.useEffect)(()=>{
        if (isEditingState && editViewRef.current) editViewRef.current.focus();
    }, [
        editViewRef,
        isEditingState
    ]);
    (0, $5uXOq.useEffect)(()=>{
        /**
		 * This logic puts the focus on the edit button after confirming using
		 * the confirm button or using the keyboard to confirm, but not when
		 * it is confirmed by wrapper blur
		 */ if (prevIsEditing && !shouldBeEditing) {
            if (preventFocusOnEditButtonRef && preventFocusOnEditButtonRef.current) preventFocusOnEditButtonRef.current = false;
            else if (editButtonRef && editButtonRef.current) // @ts-ignore
            editButtonRef.current.focus();
        }
    }, [
        prevIsEditing,
        shouldBeEditing
    ]);
    const doNotFocusOnEditButton = ()=>preventFocusOnEditButtonRef.current = true;
    return {
        editButtonRef: editButtonRef,
        editViewRef: editViewRef,
        shouldBeEditing: shouldBeEditing,
        doNotFocusOnEditButton: doNotFocusOnEditButton
    };
};
var $d5aa752dd00081f6$export$2e2bcd8739ae039 = $d5aa752dd00081f6$var$useButtonFocusHook;

});

parcelRegister("6LLMl", function(module, exports) {

$parcel$export(module.exports, "default", () => $1ba9adf9a6463766$export$2e2bcd8739ae039);
/* read-view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $3Lty3 = parcelRequire("3Lty3");
const $1ba9adf9a6463766$var$readViewContainerStyles = null;
const $1ba9adf9a6463766$var$editButtonStyles = {
    root: "_12ji1r31 _1qu2glyw _12y3idpf _189e1grb _1dqoglyw _1h6d3acm _1e0c1ule _19pkze3t _2hwxze3t _otyrze3t _18u0ze3t _ca0qze3t _u5f3ze3t _n3tdze3t _19bvze3t _r06hglyw _bfhk18uv _vwz4kb7n _1xp41p6i _14ly1bk5 _1j8znqa1 _mizu1r31 _ra3xglyw _128midpf"
};
const $1ba9adf9a6463766$var$readViewWrapperStyles = null;
const $1ba9adf9a6463766$var$readViewFitContainerWidthStyles = null;
const $1ba9adf9a6463766$var$DRAG_THRESHOLD = 5;
const $1ba9adf9a6463766$var$ReadView = ({ editButtonLabel: editButtonLabel, onEditRequested: onEditRequested, postReadViewClick: postReadViewClick, editButtonRef: editButtonRef, readViewFitContainerWidth: readViewFitContainerWidth, readView: readView, testId: testId })=>{
    const startX = (0, $5uXOq.useRef)(0);
    const startY = (0, $5uXOq.useRef)(0);
    const mouseHasMovedAfterMouseDown = (event)=>{
        return Math.abs(startX.current - event.clientX) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD || Math.abs(startY.current - event.clientY) >= $1ba9adf9a6463766$var$DRAG_THRESHOLD;
    };
    const onReadViewClick = (event)=>{
        const element = event.target;
        /**
     * If a link is clicked in the read view, default action should be taken
     */ if (element.tagName.toLowerCase() !== 'a' && !mouseHasMovedAfterMouseDown(event)) {
            event.preventDefault();
            onEditRequested();
            postReadViewClick();
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        className: (0, $bwpsq.default)([
            "_vwz4kb7n"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Lty3.default), {
                xcss: $1ba9adf9a6463766$var$editButtonStyles.root,
                onClick: onEditRequested,
                ref: editButtonRef,
                testId: testId && `${testId}--edit-button`,
                "aria-label": editButtonLabel
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                /**
     * It is not normally acceptable to add click handlers to non-interactive elements
     * as this is an accessibility anti-pattern. However, because this instance is
     * account for clicking on links that may be embedded within inline-edit and not
     * creating an inaccessible custom element, we can add role="presentation" so that
     * there is no negative impacts to assistive technologies.
     * (Why links are embeeded in inline-edit is for another day...)
     */ role: "presentation",
                onClick: onReadViewClick,
                onMouseDown: (e)=>{
                    startX.current = e.clientX;
                    startY.current = e.clientY;
                },
                "data-read-view-fit-container-width": readViewFitContainerWidth,
                className: (0, $bwpsq.default)([
                    "_2rko1sit _v564thzt _1h6d3acm _1dqonqa1 _189e1bk5 _1e0c1o8l _vchhusvi _1bsb1wug _p12f1osq _irr314ae",
                    readViewFitContainerWidth && "_1bsb1osq"
                ]),
                children: readView()
            })
        ]
    });
};
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$1ba9adf9a6463766$export$2e2bcd8739ae039 = $1ba9adf9a6463766$var$ReadView;

});


parcelRegister("1FRDE", function(module, exports) {

$parcel$export(module.exports, "default", () => $4dc1d1a18332e8bc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4dc1d1a18332e8bc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    visibleIssueCount: {
        "id": "portfolio-3-plan-increment-common.ui.iteration-column-header.visible-issue-count",
        "defaultMessage": "{visibleIssues} / {totalIssues} {totalIssues, plural, one {issue} other {issues}}"
    },
    totalIssueCount: {
        "id": "portfolio-3-plan-increment-common.ui.iteration-column-header.total-issue-count",
        "defaultMessage": "{totalIssues} {totalIssues, plural, one {issue} other {issues}}"
    },
    visibleIssueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.iteration-column-header.visible-issue-count-issue-term-refresh",
        "defaultMessage": "{visibleIssues} / {totalIssues} {totalIssues, plural, one {work item} other {work items}}"
    },
    totalIssueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.iteration-column-header.total-issue-count-issue-term-refresh",
        "defaultMessage": "{totalIssues} {totalIssues, plural, one {work item} other {work items}}"
    }
});

});


parcelRegister("iTu9h", function(module, exports) {

$parcel$export(module.exports, "default", () => $48abf14083456c29$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6icp6 = parcelRequire("6icp6");

var $hGgHi = parcelRequire("hGgHi");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $bU3PY = parcelRequire("bU3PY");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $jgJNO = parcelRequire("jgJNO");

var $8zOmE = parcelRequire("8zOmE");

var $3spCR = parcelRequire("3spCR");

var $4R6GH = parcelRequire("4R6GH");

var $bdYfL = parcelRequire("bdYfL");

var $a5i1n = parcelRequire("a5i1n");

var $5jKdL = parcelRequire("5jKdL");

var $73G9T = parcelRequire("73G9T");
const $48abf14083456c29$var$getSprintStyles = (state, isOverloaded)=>{
    if (isOverloaded && state !== (0, $3spCR.SPRINT_STATES).CLOSED && (0, $4R6GH.fg)('update_sp_calculation_to_include_completed_sprints') || !(0, $4R6GH.fg)('update_sp_calculation_to_include_completed_sprints') && isOverloaded) return (0, $8CUq3.xcss)({
        backgroundColor: 'color.background.danger',
        color: 'color.text.danger',
        ':hover': {
            backgroundColor: 'color.background.danger.hovered'
        }
    });
    switch(state){
        case (0, $3spCR.SPRINT_STATES).CLOSED:
            return (0, $8CUq3.xcss)({
                backgroundColor: 'color.background.accent.gray.subtlest',
                color: 'color.text.subtlest',
                ':hover': {
                    backgroundColor: 'color.background.accent.gray.subtlest.hovered'
                }
            });
        case (0, $3spCR.SPRINT_STATES).ACTIVE:
            return (0, $8CUq3.xcss)({
                backgroundColor: 'color.background.selected',
                color: 'color.text.brand',
                ':hover': {
                    backgroundColor: 'color.background.selected.hovered'
                }
            });
        case (0, $3spCR.SPRINT_STATES).FUTURE:
        default:
            return (0, $8CUq3.xcss)({
                backgroundColor: 'color.background.accent.gray.subtler',
                color: 'color.text.subtle',
                ':hover': {
                    backgroundColor: 'color.background.neutral.pressed'
                }
            });
    }
};
const $48abf14083456c29$var$CapacityBar = ({ totalCapacity: totalCapacity, usedCapacity: usedCapacity })=>{
    const isOverloadedBar = usedCapacity > totalCapacity;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko1l7b _4t3iv47k _1bsb14y2 _bfhkvuon _1e0c1txw _4cvresu3 _2hwx12x7"
        ])
    }, isOverloadedBar ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_2rko14y2 _1bsb1osq _bfhkybec _4t3i1osq"
        ])
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div" // eslint-disable-next-line jira/react/no-style-attribute
    , {
        style: {
            height: `${totalCapacity === 0 ? 100 : usedCapacity / totalCapacity * 100}%`
        },
        className: (0, $bwpsq.default)([
            "_2rko14y2 _1bsb1osq _bfhk8emd"
        ])
    }));
};
const $48abf14083456c29$var$OverlappedDatesWarningIcon = ({ sprint: sprint, overlappedSprints: overlappedSprints })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const warningIconTooltip = (()=>{
        let content;
        if (overlappedSprints.length === 1) content = formatMessage((0, $5jKdL.default).warningForSprintDatesOverlappedWithOneSprint, {
            sprintName: sprint.name,
            anotherSprintName: overlappedSprints[0].sprintName,
            days: (0, (/*@__PURE__*/$parcel$interopDefault($6icp6)))(overlappedSprints[0].time / 86400000, 1)
        });
        else content = formatMessage((0, $5jKdL.default).warningForSprintDatesOverlappedWithMoreThanOneSprint, {
            sprintName: sprint.name,
            otherSprints: overlappedSprints.slice(0, overlappedSprints.length - 1).map((s)=>s.sprintName).join(', '),
            lastSprint: overlappedSprints[overlappedSprints.length - 1].sprintName
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $48abf14083456c29$var$WarningTooltip,
            backgroundColor: "color.background.neutral.bold"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "strong",
            size: "UNSAFE_small"
        }, formatMessage((0, $5jKdL.default).overlappingDatesWarningTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $48abf14083456c29$var$tooltipParagraphStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p",
            size: "UNSAFE_small"
        }, content)));
    })();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
    ), {
        xcss: (0, $8CUq3.xcss)({
            marginTop: 'space.025'
        }),
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.overlapping-warning-icon"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: warningIconTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        spacing: "spacious",
        color: "var(--ds-icon-warning, #E56910)",
        label: formatMessage((0, $5jKdL.default).overlappingDatesWarningLabel)
    })));
};
const $48abf14083456c29$var$SprintColumnHeader = ({ sprint: sprint, usedCapacity: usedCapacity, doneCapacity: doneCapacity, totalCapacity: totalCapacity, defaultCapacity: defaultCapacity, planningConfig: planningConfig, overlappedSprints: overlappedSprints, columnDateRange: columnDateRange, onChangeCapacity: onChangeCapacity, isReadOnly: isReadOnly, isOpen: isOpen // only for testing
 })=>{
    const { planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay } = planningConfig;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const formatDateRange = (0, $a5i1n.useFormatDateRange)();
    const [flyoutOpen, setFlyoutOpen] = (0, $5uXOq.useState)(false);
    const capacity = (0, $bdYfL.convertCapacity)(totalCapacity ?? defaultCapacity, planningUnit, workingHoursPerDay);
    const getSprintStateLabel = (state)=>{
        switch(state){
            case (0, $3spCR.SPRINT_STATES).CLOSED:
                return formatMessage((0, $5jKdL.default).completedSprint);
            case (0, $3spCR.SPRINT_STATES).ACTIVE:
                return formatMessage((0, $5jKdL.default).activeSprint);
            case (0, $3spCR.SPRINT_STATES).FUTURE:
            default:
                return formatMessage((0, $5jKdL.default).futureSprint);
        }
    };
    const endDate = sprint.completedDate ? sprint.completedDate : sprint.endDate;
    const dateRange = sprint.startDate && endDate ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatDateRange(sprint.startDate, endDate), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null)) : null;
    const capacityAllocatedLabel = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage((0, $5jKdL.default).capacityAllocatedLabel, {
        usedCapacity: usedCapacity,
        totalCapacity: capacity,
        unit: (0, $bdYfL.getCapacityUnitMessage)(planningUnit, formatMessage, capacity)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), getSprintStateLabel(sprint.state));
    const tooltipContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $48abf14083456c29$var$tooltipStyles,
        backgroundColor: "color.background.neutral.bold"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong",
        size: "UNSAFE_small"
    }, sprint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        size: "UNSAFE_small"
    }, dateRange), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $48abf14083456c29$var$tooltipParagraphStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p",
        size: "UNSAFE_small",
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.allocated"
    }, capacityAllocatedLabel)));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen ?? flyoutOpen,
        onClose: ()=>setFlyoutOpen(false),
        placement: "bottom-start",
        messageId: "portfolio-3-plan-increment-common.ui.sprint-column-header.popup",
        messageType: "transactional",
        content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $73G9T.default), {
                onFlyoutClose: ()=>setFlyoutOpen(false),
                usedCapacity: usedCapacity,
                totalCapacity: totalCapacity,
                doneCapacity: doneCapacity,
                defaultCapacity: defaultCapacity,
                sprint: sprint,
                planningConfig: planningConfig,
                iterationEndDate: columnDateRange?.end,
                iterationStartDate: columnDateRange?.start,
                onChangeCapacity: onChangeCapacity,
                isReadOnly: isReadOnly
            }),
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                onClick: ()=>{
                    setFlyoutOpen(true);
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                        action: 'opened',
                        actionSubject: 'sprintFlyout'
                    }));
                },
                appearance: "subtle",
                spacing: "none",
                shouldFitContainer: true,
                testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-column-header",
                ...triggerProps
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: [
                    $48abf14083456c29$var$columnHeaderWrapper,
                    $48abf14083456c29$var$sprintWrapperStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: tooltipContent,
                hideTooltipOnClick: true
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                alignBlock: "center" // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
                ,
                xcss: [
                    $48abf14083456c29$var$sprintBaseStyles,
                    $48abf14083456c29$var$getSprintStyles(sprint.state, usedCapacity > capacity)
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48abf14083456c29$var$CapacityBar, {
                usedCapacity: usedCapacity,
                totalCapacity: capacity
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_1reo15vq _18m915vq _16jlkb7n _1o9zkb7n _i0dlf1ug _1bto1l2s _o5721q9c _y3gn1e5h"
                ])
            }, sprint.name), !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(overlappedSprints) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($48abf14083456c29$var$OverlappedDatesWarningIcon, {
                sprint: sprint,
                overlappedSprints: overlappedSprints
            })))))
    });
};
const $48abf14083456c29$var$tooltipStyles = (0, $8CUq3.xcss)({
    textAlign: 'center'
});
const $48abf14083456c29$var$tooltipParagraphStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150'
});
const $48abf14083456c29$var$sprintWrapperStyles = (0, $8CUq3.xcss)({
    padding: 'space.050'
});
const $48abf14083456c29$var$columnHeaderWrapper = (0, $8CUq3.xcss)({
    backgroundColor: 'elevation.surface.sunken',
    borderTopLeftRadius: 'border.radius.100',
    borderTopRightRadius: 'border.radius.100',
    paddingTop: 'space.050',
    paddingBottom: 'space.050'
});
const $48abf14083456c29$var$sprintBaseStyles = (0, $8CUq3.xcss)({
    fontWeight: "var(--ds-font-weight-medium, 500)",
    height: "var(--ds-space-400, 32px)",
    borderRadius: 'border.radius.100',
    padding: 'space.075',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis'
});
const $48abf14083456c29$var$barWrapperStyle = null;
const $48abf14083456c29$var$usedCapacityStyle = null;
const $48abf14083456c29$var$overloadedCapacityStyle = null;
const $48abf14083456c29$var$sprintNameWrapperStyle = null;
const $48abf14083456c29$var$WarningTooltip = (0, $8CUq3.xcss)({
    padding: 'space.050'
});
var $48abf14083456c29$export$2e2bcd8739ae039 = $48abf14083456c29$var$SprintColumnHeader;

});
parcelRegister("a5i1n", function(module, exports) {

$parcel$export(module.exports, "useFormatDateUTC", () => $a4313f0c7db8b7e2$export$827a028fe155a73d);
$parcel$export(module.exports, "useFormatDateRange", () => $a4313f0c7db8b7e2$export$5db7b709812b7bc8);

var $5uXOq = parcelRequire("5uXOq");

var $1p96B = parcelRequire("1p96B");

var $aipk9 = parcelRequire("aipk9");

var $DVljb = parcelRequire("DVljb");
const $a4313f0c7db8b7e2$export$827a028fe155a73d = (intl, showYear = false, showTime = false, showTimeZoneName = false)=>(0, $5uXOq.useCallback)((date)=>{
        const dateTimeFormatOptions = {
            day: '2-digit',
            month: 'short',
            timeZone: 'UTC',
            ...showYear && {
                year: 'numeric'
            },
            ...showTime && {
                hour: 'numeric',
                minute: '2-digit',
                hour12: true
            },
            ...showTimeZoneName && {
                timeZoneName: 'short'
            }
        };
        return (0, $aipk9.formatTimestampWithIntl)(intl, date, dateTimeFormatOptions);
    }, [
        intl,
        showYear,
        showTime,
        showTimeZoneName
    ]);
const $a4313f0c7db8b7e2$export$fc5db2b57ab9d291 = ()=>{
    const locale = (0, $DVljb.useLocale)();
    return (0, $5uXOq.useCallback)((date, showYear = false)=>showYear ? (0, $1p96B.formatWithLocale)(date, 'd MMM yyyy', locale) : (0, $1p96B.formatWithLocale)(date, 'd MMM', locale), [
        locale
    ]);
};
const $a4313f0c7db8b7e2$export$5db7b709812b7bc8 = ()=>{
    const formatDate = $a4313f0c7db8b7e2$export$fc5db2b57ab9d291();
    return (0, $5uXOq.useCallback)((startDate, endDate)=>{
        const isDifferentYear = new Date(startDate).getUTCFullYear() !== new Date(endDate).getUTCFullYear();
        return `${formatDate(startDate, isDifferentYear)} \u{2013} ${formatDate(endDate, isDifferentYear)}`;
    }, [
        formatDate
    ]);
};

});
parcelRegister("aipk9", function(module, exports) {

$parcel$export(module.exports, "getDayLabel", () => $da1491eee903a2d8$export$77c6667acb2335c);
$parcel$export(module.exports, "getMonthLabel", () => $da1491eee903a2d8$export$5492c4ce9d26d774);
$parcel$export(module.exports, "formatDateUTC", () => $da1491eee903a2d8$export$f6ec9a122d9a3697);
$parcel$export(module.exports, "formatTimestampWithIntl", () => $da1491eee903a2d8$export$a70c08d756ec4ebf);
$parcel$export(module.exports, "formatDateWithIntl", () => $da1491eee903a2d8$export$41d39199b76e5fba);
$parcel$export(module.exports, "useDateFormatter", () => $da1491eee903a2d8$export$85fd5fdf27bacc79);

var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $koVbs = parcelRequire("koVbs");

var $gh61P = parcelRequire("gh61P");
const $da1491eee903a2d8$export$32db56fbc0b29120 = (day)=>{
    switch(day){
        case 0:
            return 'Sunday';
        case 1:
            return 'Monday';
        case 2:
            return 'Tuesday';
        case 3:
            return 'Wednesday';
        case 4:
            return 'Thursday';
        case 5:
            return 'Friday';
        default:
            return 'Saturday';
    }
};
const $da1491eee903a2d8$export$e5b0222dbac9656 = (month)=>{
    switch(month){
        case 0:
            return 'January';
        case 1:
            return 'February';
        case 2:
            return 'March';
        case 3:
            return 'April';
        case 4:
            return 'May';
        case 5:
            return 'June';
        case 6:
            return 'July';
        case 7:
            return 'August';
        case 8:
            return 'September';
        case 9:
            return 'October';
        case 10:
            return 'November';
        default:
            return 'December';
    }
};
const $da1491eee903a2d8$export$77c6667acb2335c = (day)=>$da1491eee903a2d8$export$32db56fbc0b29120(day).substr(0, 3);
const $da1491eee903a2d8$export$5492c4ce9d26d774 = (month)=>$da1491eee903a2d8$export$e5b0222dbac9656(month).substr(0, 3);
const $da1491eee903a2d8$export$b27aef2de915d062 = (format)=>{
    let stringFormat = format;
    let match;
    let parts = [];
    const DATE_FORMATS_SPLIT = /((?:[^YMDHhmsaAZzE']+)|(?:'(?:[^']|'')*')|(?:E+|Y+|M+|D+|H+|h+|m+|s+|a|A|Z|z))(.*)/;
    const slice = [].slice;
    const concatMethod = (array1, array2, index)=>array1.concat(slice.call(array2, index));
    while(stringFormat){
        match = DATE_FORMATS_SPLIT.exec(stringFormat);
        if (match) {
            parts = concatMethod(parts, match, 1);
            stringFormat = parts.pop();
        } else {
            parts.push(format);
            stringFormat = null;
        }
    }
    return parts;
};
const $da1491eee903a2d8$export$f6ec9a122d9a3697 = (time, format)=>{
    const date = new Date(time);
    if (!(0, $jovBr.default)(date)) throw new Error('Date passed to formatDateUTC function is not valid');
    // get individual values
    const dayOfWeekIndex = date.getUTCDay();
    const month = date.getUTCMonth();
    const fullYear = date.getUTCFullYear().toString();
    const fullMonth = $da1491eee903a2d8$export$e5b0222dbac9656(month);
    const shortMonth = $da1491eee903a2d8$export$5492c4ce9d26d774(month);
    const digitMonth = month + 1;
    const hour = date.getUTCHours();
    const minutes = date.getUTCMinutes();
    const seconds = date.getUTCSeconds();
    const formatArray = $da1491eee903a2d8$export$b27aef2de915d062(format);
    // TODO: getFormatVal is hardcoded to date-fns v.1.x.x format should be reimplemented by owners team
    // pick individual parts of the date format
    const getFormatVal = (part)=>{
        let val;
        switch(part){
            case 'YYYY':
                // 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
                val = fullYear.padStart(4, '0');
                break;
            case 'YY':
                // 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01)
                val = fullYear.padStart(4, '0').substr(-2);
                break;
            case 'MMMM':
                // Month in year (January-December)
                val = fullMonth;
                break;
            case 'MMM':
                // Month in year (Jan-Dec)
                val = shortMonth;
                break;
            case 'MM':
                // Month in year (01-12)
                val = digitMonth.toString().padStart(2, '0');
                break;
            case 'M':
                // Month in year (1-12)
                val = digitMonth;
                break;
            case 'EEEE':
                // Day in Week,(Sunday-Saturday)
                val = $da1491eee903a2d8$export$32db56fbc0b29120(dayOfWeekIndex);
                break;
            case 'EEE':
                // Day in Week, (Sun-Sat)
                val = $da1491eee903a2d8$export$77c6667acb2335c(dayOfWeekIndex);
                break;
            case 'DD':
                // Day in month (01-31)
                val = date.getUTCDate().toString().padStart(2, '0');
                break;
            case 'D':
                // Day in month (1-31)
                val = date.getUTCDate();
                break;
            case 'hh':
                // Hour in AM/PM (01-12)
                val = 12;
                if (hour !== 0) {
                    const diff = hour - 12;
                    val = diff > 0 ? diff.toString().padStart(2, '0') : hour.toString().padStart(2, '0');
                }
                break;
            case 'h':
                // Hour in AM/PM, (1-12)
                val = 12;
                if (hour !== 0) val = hour > 12 ? hour - 12 : hour;
                break;
            case 'HH':
                // Hour in day (00-23)
                val = hour.toString().padStart(2, '0');
                break;
            case 'H':
                // Hour in day (0-23)
                val = hour;
                break;
            case 'mm':
                // Minute in hour (00-59)
                val = minutes.toString().padStart(2, '0');
                break;
            case 'm':
                // Minute in hour (0-59)
                val = minutes;
                break;
            case 'ss':
                // Seconds in minute (00-59)
                val = seconds.toString().padStart(2, '0');
                break;
            case 's':
                // Seconds in minute (0-59)
                val = seconds;
                break;
            case 'a':
                val = hour >= 12 ? 'pm' : 'am';
                break;
            case 'A':
                val = hour >= 12 ? 'PM' : 'AM';
                break;
            default:
                val = part;
        }
        val = typeof val !== 'undefined' ? val.toString() : part;
        return val;
    };
    let dateVal = '';
    formatArray.forEach((part)=>{
        dateVal += getFormatVal(part);
    });
    return dateVal;
};
const $da1491eee903a2d8$export$a70c08d756ec4ebf = (intl, timestamp, // eslint-disable-next-line @typescript-eslint/no-explicit-any
formatOptions = (0, $gh61P.longDateFormat))=>intl.formatDate(timestamp, formatOptions);
const $da1491eee903a2d8$export$41d39199b76e5fba = (intl, iso, // eslint-disable-next-line @typescript-eslint/no-explicit-any
formatOptions = (0, $gh61P.longDateFormat))=>{
    const date = new Date(iso);
    return intl.formatDate(date.getTime(), formatOptions);
};
const $da1491eee903a2d8$export$85fd5fdf27bacc79 = ()=>{
    const intl = (0, $koVbs.default)();
    const formatTimestamp = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (timestamp, formatOptions)=>$da1491eee903a2d8$export$a70c08d756ec4ebf(intl, timestamp, formatOptions), [
        intl
    ]);
    const formatDate = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (iso, formatOptions)=>{
        const date = new Date(iso);
        return $da1491eee903a2d8$export$a70c08d756ec4ebf(intl, date.getTime(), formatOptions);
    }, [
        intl
    ]);
    return {
        formatTimestamp: formatTimestamp,
        formatDate: formatDate
    };
};

});


parcelRegister("5jKdL", function(module, exports) {

$parcel$export(module.exports, "default", () => $087cc8d537ef798f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $087cc8d537ef798f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    visibleIssueCount: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.visible-issue-count",
        "defaultMessage": "{count} / {total} {total, plural, one {issue} other {issues}}"
    },
    totalIssueCount: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.total-issue-count",
        "defaultMessage": "{total} {total, plural, one {issue} other {issues}}"
    },
    completedSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    activeSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.active-sprint",
        "defaultMessage": "Active sprint"
    },
    futureSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.future-sprint",
        "defaultMessage": "Future sprint"
    },
    overlappingDatesWarningTitle: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.overlapping-dates-warning-title",
        "defaultMessage": "Overlapping sprint dates"
    },
    overlappingDatesWarningLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.overlapping-dates-warning-label",
        "defaultMessage": "Warning icon for the overlapping sprint dates"
    },
    warningForSprintDatesOverlappedWithOneSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.warning-for-sprint-dates-overlapped-with-one-sprint",
        "defaultMessage": "{sprintName} overlaps with {anotherSprintName} by about {days} {days, plural, one {day} other {days}}"
    },
    warningForSprintDatesOverlappedWithMoreThanOneSprint: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.warning-for-sprint-dates-overlapped-with-more-than-one-sprint",
        "defaultMessage": "{sprintName} overlaps with {otherSprints} and {lastSprint}"
    },
    capacityAllocatedLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.capacity-allocated-label",
        "defaultMessage": "{usedCapacity}/{totalCapacity} {unit} allocated"
    },
    visibleIssueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.visible-issue-count-issue-term-refresh",
        "defaultMessage": "{count} / {total} {total, plural, one {work item} other {work items}}"
    },
    totalIssueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.total-issue-count-issue-term-refresh",
        "defaultMessage": "{total} {total, plural, one {work item} other {work items}}"
    }
});

});

parcelRegister("73G9T", function(module, exports) {

$parcel$export(module.exports, "default", () => $6cc5b1f0251868be$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $42CjB = parcelRequire("42CjB");

var $l1N8i = parcelRequire("l1N8i");

var $2jwCH = parcelRequire("2jwCH");

var $6tRzQ = parcelRequire("6tRzQ");

var $1Ul8T = parcelRequire("1Ul8T");

var $igBVO = parcelRequire("igBVO");

var $bopR4 = parcelRequire("bopR4");

var $3u0c5 = parcelRequire("3u0c5");

var $c8oLN = parcelRequire("c8oLN");
var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $kY99m = parcelRequire("kY99m");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $4jAPy = parcelRequire("4jAPy");

var $gZK1Z = parcelRequire("gZK1Z");

var $bdYfL = parcelRequire("bdYfL");

var $a5i1n = parcelRequire("a5i1n");

var $c26pB = parcelRequire("c26pB");
const $6cc5b1f0251868be$var$sprintStatusAppearanceMap = {
    ACTIVE: 'inprogress',
    CLOSED: 'success',
    FUTURE: 'default'
};
const $6cc5b1f0251868be$var$GOAL_LIMIT = 190;
const $6cc5b1f0251868be$var$percentage = (count, total)=>total === 0 ? 0 : Math.round(count / total * 100);
const $6cc5b1f0251868be$var$ProgressBar = ({ progressInfo: progressInfo, progressPercentage: progressPercentage, progressWidth: progressWidth, additionalBarStyles: additionalBarStyles })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        spread: "space-between",
        shouldWrap: true,
        rowSpace: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "semibold",
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.progress-info"
    }, progressInfo), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "semibold"
    }, progressPercentage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $6cc5b1f0251868be$var$barStyles,
            $6cc5b1f0251868be$var$progressBarStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        // eslint-disable-next-line @atlaskit/design-system/consistent-css-prop-usage
        xcss: [
            $6cc5b1f0251868be$var$barStyles,
            additionalBarStyles
        ],
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            width: `${progressWidth}%`
        }
    })));
const $6cc5b1f0251868be$var$SprintDate = ({ dateLabel: dateLabel, hasSprintDate: hasSprintDate, date: date, tooltipContent: tooltipContent, iconLabel: iconLabel })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        shouldWrap: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtle"
    }, dateLabel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        xcss: $6cc5b1f0251868be$var$dateContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: hasSprintDate ? 'span' : 'em'
    }, date), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltipContent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($6tRzQ))), {
        label: iconLabel,
        LEGACY_size: "medium",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }))));
const $6cc5b1f0251868be$var$getProgressBarLabel = (planningUnit, isDone)=>{
    const labelType = isDone ? 'Done' : 'Allocated';
    switch(planningUnit){
        case 0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT:
            return (0, $c26pB.default)[`sprintDays${labelType}Label`];
        case 0, $4jAPy.IP_BOARD_HOURS_PLANNING_UNIT:
            return (0, $c26pB.default)[`sprintHours${labelType}Label`];
        default:
            return (0, $c26pB.default)[`sprintPoints${labelType}Label`];
    }
};
const $6cc5b1f0251868be$var$Goal = ({ goal: goal })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (!goal) return null;
    const isOverLimit = goal.length > $6cc5b1f0251868be$var$GOAL_LIMIT;
    return isOverLimit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: goal,
        position: "auto"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $c26pB.default).sprintGoalEllipsed, {
        goal: goal.substring(0, $6cc5b1f0251868be$var$GOAL_LIMIT).trim()
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, goal);
};
const $6cc5b1f0251868be$var$SprintCapacityFlyout = ({ onFlyoutClose: onFlyoutClose, sprint: sprint, totalCapacity: totalCapacity, usedCapacity: usedCapacity, doneCapacity: doneCapacity, defaultCapacity: defaultCapacity, iterationEndDate: iterationEndDate, iterationStartDate: iterationStartDate, planningConfig: { planningUnit: planningUnit, workingHoursPerDay: workingHoursPerDay }, onChangeCapacity: onChangeCapacity, isReadOnly: isReadOnly })=>{
    const intl = (0, $koVbs.default)();
    const total = (0, $bdYfL.convertCapacity)(totalCapacity ?? defaultCapacity, planningUnit, workingHoursPerDay);
    const allocatedPercentage = $6cc5b1f0251868be$var$percentage(usedCapacity, total);
    const donePercentage = $6cc5b1f0251868be$var$percentage(doneCapacity, usedCapacity);
    const formatDateBasic = (0, $a5i1n.useFormatDateUTC)(intl, true);
    const formatDateExtended = (0, $a5i1n.useFormatDateUTC)(intl, true, true, true);
    const sprintStart = sprint.startDate || iterationStartDate;
    const sprintEnd = sprint.completedDate || sprint.endDate || iterationEndDate;
    const sprintStateLabel = (0, $bdYfL.getSprintStateLabel)(sprint.state, intl.formatMessage);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.150",
        xcss: $6cc5b1f0251868be$var$stackStyles,
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-flyout"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        spread: "space-between"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($igBVO))), {
        label: "",
        LEGACY_size: "small",
        color: "var(--ds-icon-subtle, #626F86)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "semibold",
        color: "color.text.subtlest"
    }, intl.formatMessage((0, $c26pB.default).titleForSprintCapacityFlyout))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        onClick: onFlyoutClose,
        appearance: "subtle",
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($2jwCH))),
        label: intl.formatMessage((0, $c26pB.default).closeIconLabel)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: $6cc5b1f0251868be$var$sprintStatusAppearanceMap[sprint.state]
    }, sprintStateLabel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "small",
        as: "h2"
    }, sprint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$Goal, {
        goal: sprint.goal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c8oLN.default), {
        block: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.150",
        spread: "space-between",
        grow: "fill",
        alignBlock: "center",
        xcss: $6cc5b1f0251868be$var$capacityInfoEditStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center",
        xcss: $6cc5b1f0251868be$var$capacityInfoStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1Ul8T))), {
        label: intl.formatMessage((0, $c26pB.default).sprintCapacityOverviewLabel),
        LEGACY_size: "medium",
        spacing: "spacious",
        color: "var(--ds-icon, #44546F)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, intl.formatMessage((0, $c26pB.default).sprintCapacityLabel, {
        planningUnit: (0, $bdYfL.getCapacityUnitMessage)(planningUnit, intl.formatMessage)
    }))), isReadOnly ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $6cc5b1f0251868be$var$readViewContainerStyles
        ],
        testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-capacity-read-only"
    }, total) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bopR4.default), {
        defaultValue: total,
        keepEditViewOpenOnBlur: true,
        editView: ({ errorMessage: errorMessage, ...fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldProps,
                min: 0,
                max: 99999,
                width: "64",
                "aria-label": intl.formatMessage((0, $gZK1Z.default).editCapacityLabel),
                autoFocus: true,
                type: "number",
                isCompact: true,
                ...planningUnit === (0, $4jAPy.IP_BOARD_DAYS_PLANNING_UNIT) && {
                    step: 0.1
                }
            }),
        readView: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: [
                    $6cc5b1f0251868be$var$readViewContainerStyles
                ],
                testId: "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-capacity-read-view"
            }, total),
        onConfirm: (value)=>{
            onChangeCapacity(value);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'edited',
                actionSubject: 'sprintCapacity'
            }));
        },
        editButtonLabel: intl.formatMessage((0, $gZK1Z.default).editCapacityLabel),
        confirmButtonLabel: intl.formatMessage((0, $gZK1Z.default).confirmButtonLabel),
        cancelButtonLabel: intl.formatMessage((0, $gZK1Z.default).cancelButtonLabel)
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$ProgressBar, {
        progressInfo: intl.formatMessage($6cc5b1f0251868be$var$getProgressBarLabel(planningUnit, false), {
            numerator: usedCapacity,
            denominatorCount: total
        }),
        progressPercentage: `${allocatedPercentage}%`,
        progressWidth: usedCapacity < total ? allocatedPercentage : 100,
        additionalBarStyles: usedCapacity > total ? $6cc5b1f0251868be$var$overloadedBarStyles : $6cc5b1f0251868be$var$allocatedBarStyles
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$ProgressBar, {
        progressInfo: intl.formatMessage($6cc5b1f0251868be$var$getProgressBarLabel(planningUnit, true), {
            numerator: doneCapacity,
            denominatorCount: usedCapacity
        }),
        progressPercentage: `${donePercentage}%`,
        progressWidth: donePercentage,
        additionalBarStyles: $6cc5b1f0251868be$var$doneBarStyles
    }), sprintStart && sprintEnd && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$SprintDate, {
        dateLabel: intl.formatMessage((0, $c26pB.default).sprintStartDateLabel),
        hasSprintDate: !!sprint.startDate,
        date: formatDateBasic(sprintStart),
        tooltipContent: formatDateExtended(sprintStart),
        iconLabel: intl.formatMessage((0, $c26pB.default).sprintStartDateInfoIconLabel)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cc5b1f0251868be$var$SprintDate, {
        dateLabel: intl.formatMessage((0, $c26pB.default).sprintEndDateLabel),
        hasSprintDate: !!sprint.endDate,
        date: formatDateBasic(sprintEnd),
        tooltipContent: formatDateExtended(sprintEnd),
        iconLabel: intl.formatMessage((0, $c26pB.default).sprintEndDateInfoIconLabel)
    })), (!sprint.startDate || !sprint.endDate) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), null, intl.formatMessage((0, $c26pB.default).sprintDatesMissing, {
        sprintName: sprint.name
    }))));
};
var $6cc5b1f0251868be$export$2e2bcd8739ae039 = $6cc5b1f0251868be$var$SprintCapacityFlyout;
const $6cc5b1f0251868be$var$capacityInfoEditStyles = (0, $8CUq3.xcss)({
    marginBlockEnd: 'space.200'
});
const $6cc5b1f0251868be$var$capacityInfoStyles = (0, $8CUq3.xcss)({
    marginBlockStart: 'space.250'
});
const $6cc5b1f0251868be$var$readViewContainerStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.050',
    paddingInline: 'space.075',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: '20px'
});
const $6cc5b1f0251868be$var$stackStyles = (0, $8CUq3.xcss)({
    width: '290px',
    padding: 'space.150'
});
const $6cc5b1f0251868be$var$barStyles = (0, $8CUq3.xcss)({
    height: '6px',
    borderRadius: 'border.radius.100'
});
const $6cc5b1f0251868be$var$progressBarStyles = (0, $8CUq3.xcss)({
    width: '100%',
    backgroundColor: 'color.background.neutral'
});
const $6cc5b1f0251868be$var$allocatedBarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.neutral.bold'
});
const $6cc5b1f0251868be$var$doneBarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.success.bold'
});
const $6cc5b1f0251868be$var$overloadedBarStyles = (0, $8CUq3.xcss)({
    backgroundColor: 'color.background.danger.bold'
});
const $6cc5b1f0251868be$var$dateContainerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 1
});

});
parcelRegister("2jwCH", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e514a79fafb6c57d068e94d2350d1008>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1af6a969f6ce5e7d$var$_react = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $1af6a969f6ce5e7d$var$_close = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("i28qQ")));

var $1af6a969f6ce5e7d$var$_close2 = $1af6a969f6ce5e7d$var$_interopRequireDefault((parcelRequire("2C7j9")));
function $1af6a969f6ce5e7d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloseIcon.
 * This component is CloseIcon, with `UNSAFE_fallbackIcon` set to "EditorCloseIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for closing an element.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1af6a969f6ce5e7d$var$CloseIcon = (props)=>/*#__PURE__*/ $1af6a969f6ce5e7d$var$_react.default.createElement($1af6a969f6ce5e7d$var$_close.default, Object.assign({
        LEGACY_fallbackIcon: $1af6a969f6ce5e7d$var$_close2.default
    }, props));
$1af6a969f6ce5e7d$var$CloseIcon.Name = 'CloseIconMigration';
var $1af6a969f6ce5e7d$var$_default = module.exports.default = $1af6a969f6ce5e7d$var$CloseIcon;

});

parcelRegister("1Ul8T", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::572539e0e383af35886df9b58f6a5d20>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $163b6be0bd32a404$var$_react = $163b6be0bd32a404$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $163b6be0bd32a404$var$_alignLeft = $163b6be0bd32a404$var$_interopRequireDefault((parcelRequire("i6luQ")));

var $163b6be0bd32a404$var$_overview = $163b6be0bd32a404$var$_interopRequireDefault((parcelRequire("KdRgS")));
function $163b6be0bd32a404$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for AlignLeftIcon.
 * This component is AlignLeftIcon, with `UNSAFE_fallbackIcon` set to "OverviewIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $163b6be0bd32a404$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $163b6be0bd32a404$var$_react.default.createElement($163b6be0bd32a404$var$_alignLeft.default, Object.assign({
        LEGACY_fallbackIcon: $163b6be0bd32a404$var$_overview.default
    }, props));
$163b6be0bd32a404$var$AlignLeftIcon.Name = 'AlignLeftIconMigration';
var $163b6be0bd32a404$var$_default = module.exports.default = $163b6be0bd32a404$var$AlignLeftIcon;

});
parcelRegister("i6luQ", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::06cb7603567c67e47d6263787f51f223>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d2d976446b240c09$var$_react = $d2d976446b240c09$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d2d976446b240c09$var$_baseNew = $d2d976446b240c09$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $d2d976446b240c09$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "AlignLeft".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: align text left, align content left, summary.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d2d976446b240c09$var$AlignLeftIcon = (props)=>/*#__PURE__*/ $d2d976446b240c09$var$_react.default.createElement($d2d976446b240c09$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M15 3.5H1V2h14zm0 5.25H1v-1.5h14zM8 14H1v-1.5h7z" clip-rule="evenodd"/>`
    }, props));
$d2d976446b240c09$var$AlignLeftIcon.displayName = 'AlignLeftIcon';
var $d2d976446b240c09$var$_default = module.exports.default = $d2d976446b240c09$var$AlignLeftIcon;

});

parcelRegister("KdRgS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $08af0bf1cbfb8ac8$var$_react = $08af0bf1cbfb8ac8$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $08af0bf1cbfb8ac8$var$_alignLeft = $08af0bf1cbfb8ac8$var$_interopRequireDefault((parcelRequire("i6luQ")));
function $08af0bf1cbfb8ac8$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $08af0bf1cbfb8ac8$var$OverviewIcon = (props)=>/*#__PURE__*/ $08af0bf1cbfb8ac8$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.01 18c.546 0 .99-.444.99-1a1 1 0 0 0-.99-1H3.99A.993.993 0 0 0 3 17a1 1 0 0 0 .99 1zM3 7c0 .552.445 1 .993 1h16.014A.994.994 0 0 0 21 7c0-.552-.445-1-.993-1H3.993A.994.994 0 0 0 3 7m10.998 6A1 1 0 0 0 15 12c0-.552-.456-1-1.002-1H4.002A1 1 0 0 0 3 12c0 .552.456 1 1.002 1z"/></svg>`
    }, props, {
        newIcon: $08af0bf1cbfb8ac8$var$_alignLeft.default
    }));
$08af0bf1cbfb8ac8$var$OverviewIcon.displayName = 'OverviewIcon';
var $08af0bf1cbfb8ac8$var$_default = module.exports.default = $08af0bf1cbfb8ac8$var$OverviewIcon;

});


parcelRegister("igBVO", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::305b05d245740b98a659dd24d0c99f12>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d4c724fd848b96af$var$_react = $d4c724fd848b96af$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $d4c724fd848b96af$var$_sprint = $d4c724fd848b96af$var$_interopRequireDefault((parcelRequire("8mG85")));

var $d4c724fd848b96af$var$_sprint2 = $d4c724fd848b96af$var$_interopRequireDefault((parcelRequire("iyo13")));
function $d4c724fd848b96af$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SprintIcon.
 * This component is SprintIcon, with `UNSAFE_fallbackIcon` set to "SprintIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $d4c724fd848b96af$var$SprintIcon = (props)=>/*#__PURE__*/ $d4c724fd848b96af$var$_react.default.createElement($d4c724fd848b96af$var$_sprint.default, Object.assign({
        LEGACY_fallbackIcon: $d4c724fd848b96af$var$_sprint2.default
    }, props));
$d4c724fd848b96af$var$SprintIcon.Name = 'SprintIconMigration';
var $d4c724fd848b96af$var$_default = module.exports.default = $d4c724fd848b96af$var$SprintIcon;

});
parcelRegister("8mG85", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::3028194b67909de4178ae7b995e8e7b7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $61710ed7f2aa84a3$var$_react = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $61710ed7f2aa84a3$var$_baseNew = $61710ed7f2aa84a3$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $61710ed7f2aa84a3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Sprint".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sprints in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $61710ed7f2aa84a3$var$SprintIcon = (props)=>/*#__PURE__*/ $61710ed7f2aa84a3$var$_react.default.createElement($61710ed7f2aa84a3$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A4.75 4.75 0 0 0 8 11h5.44l-2.22-2.22 1.06-1.06 3.5 3.5a.75.75 0 0 1 0 1.06l-3.5 3.5-1.06-1.06 2.22-2.22H0V11h3.938A6.25 6.25 0 1 1 14.25 6.25h-1.5A4.75 4.75 0 0 0 8 1.5" clip-rule="evenodd"/>`
    }, props));
$61710ed7f2aa84a3$var$SprintIcon.displayName = 'SprintIcon';
var $61710ed7f2aa84a3$var$_default = module.exports.default = $61710ed7f2aa84a3$var$SprintIcon;

});

parcelRegister("iyo13", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d81e080f0024ae1d$var$_react = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d81e080f0024ae1d$var$_sprint = $d81e080f0024ae1d$var$_interopRequireDefault((parcelRequire("8mG85")));
function $d81e080f0024ae1d$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d81e080f0024ae1d$var$SprintIcon = (props)=>/*#__PURE__*/ $d81e080f0024ae1d$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="m17.717 17.137-1.436-1.438a1.003 1.003 0 0 1 1.418-1.418l3.007 3.01a1 1 0 0 1 0 1.417l-3.007 3.01a1.003 1.003 0 0 1-1.417-1.42l1.3-1.3-6.072-.003A8 8 0 0 1 4 11.01C4 6.587 7.582 3 12 3s8 3.587 8 8.01a8 8 0 0 1-.789 3.451l-1.438-1.44a6.1 6.1 0 0 0 .345-2.01A6.12 6.12 0 0 0 12 4.884a6.12 6.12 0 0 0-6.118 6.125 6.12 6.12 0 0 0 5.647 6.102zm-12.163-.119c.561.759 1.456 1.49 2.457 1.981L3.937 19C3.42 19 3 18.552 3 18s.42-1 .937-1l1.614.005z"/></svg>`
    }, props, {
        newIcon: $d81e080f0024ae1d$var$_sprint.default
    }));
$d81e080f0024ae1d$var$SprintIcon.displayName = 'SprintIcon';
var $d81e080f0024ae1d$var$_default = module.exports.default = $d81e080f0024ae1d$var$SprintIcon;

});


parcelRegister("92Z2l", function(module, exports) {

$parcel$export(module.exports, "default", () => $a97355a0cc6aeb06$export$2e2bcd8739ae039);
/* section-message.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
var $414Wj = parcelRequire("414Wj");

var $3HeRx = parcelRequire("3HeRx");
const $a97355a0cc6aeb06$var$sectionMessageStyles = {
    container: "_2rkoglpi _1nmz1hna",
    bleed: "_1mou1i6y _1e0c1txw",
    content: "_11c82smr _syaz1fxt",
    actionsContainer: "_11c82smr"
};
/**
 * __Section message__
 *
 * A section message is used to alert users to a particular section of the screen.
 *
 * - [Examples](https://atlassian.design/components/section-message/examples)
 * - [Code](https://atlassian.design/components/section-message/code)
 * - [Usage](https://atlassian.design/components/section-message/usage)
 */ const $a97355a0cc6aeb06$var$SectionMessage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function SectionMessage({ children: children, appearance: appearance = 'information', actions: actions, title: title, icon: icon, testId: testId }, ref) {
    const { primaryIconColor: primaryColor, backgroundColor: secondaryColor, Icon: Icon } = (0, $3HeRx.getAppearanceIconStyles)(appearance, icon);
    const actionElements = actions && actions.type === (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment ? actions.props.children : actions;
    const actionsArray = (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Children.toArray(actionElements);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        as: "section",
        backgroundColor: $a97355a0cc6aeb06$var$appearanceMap[appearance],
        padding: "space.200",
        testId: testId,
        ref: ref,
        xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.container,
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.200",
            alignBlock: "stretch",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.bleed,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                        size: "medium",
                        primaryColor: primaryColor,
                        secondaryColor: secondaryColor,
                        // props for new icon
                        LEGACY_size: "medium",
                        color: primaryColor,
                        spacing: "spacious"
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                    space: "space.100",
                    testId: testId && `${testId}--content`,
                    children: [
                        !!title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                            as: "h2",
                            size: "small",
                            children: title
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: $a97355a0cc6aeb06$var$sectionMessageStyles.content,
                            children: children
                        }),
                        actionsArray.length > 0 && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                            shouldWrap: true,
                            testId: testId && `${testId}--actions`,
                            separator: "\xb7",
                            space: "space.100",
                            rowSpace: "space.0",
                            // Only use a list role if more than one action is present
                            role: actionsArray.length > 1 ? 'list' : undefined,
                            xcss: (0, $VSDnB.fg)('platform_ads_explicit_font_styles') && $a97355a0cc6aeb06$var$sectionMessageStyles.actionsContainer,
                            children: actionsArray.map((action, id)=>// Only use a listitem role if more than one action is present
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                                    role: actionsArray.length > 1 ? 'listitem' : undefined,
                                    children: action
                                }, id))
                        })
                    ]
                })
            ]
        })
    });
});
const $a97355a0cc6aeb06$var$appearanceMap = {
    information: 'color.background.information',
    warning: 'color.background.warning',
    error: 'color.background.danger',
    success: 'color.background.success',
    discovery: 'color.background.discovery'
};
$a97355a0cc6aeb06$var$SectionMessage.displayName = 'SectionMessage';
var $a97355a0cc6aeb06$export$2e2bcd8739ae039 = $a97355a0cc6aeb06$var$SectionMessage;

});
parcelRegister("3HeRx", function(module, exports) {

$parcel$export(module.exports, "getAppearanceIconStyles", () => $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dD7Zc = parcelRequire("dD7Zc");

var $1jWct = parcelRequire("1jWct");

var $dg0Fl = parcelRequire("dg0Fl");

var $c2i4s = parcelRequire("c2i4s");

var $bU3PY = parcelRequire("bU3PY");

const $d1d7dced94bb00f5$var$appearanceIconSchema = {
    information: {
        backgroundColor: `var(--ds-background-information, ${(0, $829f609a65d26a98$export$226de0355ed012f8)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($1jWct))),
        primaryIconColor: `var(--ds-icon-information, ${(0, $829f609a65d26a98$export$a6ee3d71bc067634)})`
    },
    warning: {
        backgroundColor: `var(--ds-background-warning, ${(0, $829f609a65d26a98$export$8d9596b529bbb9cf)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))),
        primaryIconColor: `var(--ds-icon-warning, ${(0, $829f609a65d26a98$export$874739ea9e379ab6)})`
    },
    error: {
        backgroundColor: `var(--ds-background-danger, ${(0, $829f609a65d26a98$export$4b84fd0e2c617bd)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dD7Zc))),
        primaryIconColor: `var(--ds-icon-danger, ${(0, $829f609a65d26a98$export$2837b5a1a71d5c02)})`
    },
    success: {
        backgroundColor: `var(--ds-background-success, ${(0, $829f609a65d26a98$export$8a6341c32b6a3ee6)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($c2i4s))),
        primaryIconColor: `var(--ds-icon-success, ${(0, $829f609a65d26a98$export$6fa04827ac68a4fb)})`
    },
    discovery: {
        backgroundColor: `var(--ds-background-discovery, ${(0, $829f609a65d26a98$export$363e4475840015bb)})`,
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($dg0Fl))),
        primaryIconColor: `var(--ds-icon-discovery, ${(0, $829f609a65d26a98$export$147899de772240ec)})`
    }
};
function $d1d7dced94bb00f5$export$e9b82d2e21ac0c1f(appearance, icon) {
    const appearanceIconStyles = $d1d7dced94bb00f5$var$appearanceIconSchema[appearance] || $d1d7dced94bb00f5$var$appearanceIconSchema.information;
    const AppearanceIcon = ({ size: size, primaryColor: primaryColor, secondaryColor: secondaryColor })=>/*#__PURE__*/ (0, $2OMIu.jsx)(appearanceIconStyles.Icon, {
            LEGACY_size: size,
            color: primaryColor,
            spacing: "spacious",
            LEGACY_primaryColor: primaryColor,
            LEGACY_secondaryColor: secondaryColor,
            label: appearance
        });
    const Icon = icon || AppearanceIcon;
    return {
        ...appearanceIconStyles,
        Icon: Icon
    };
}

});


parcelRegister("c26pB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8267e765f2d5d52a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8267e765f2d5d52a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sprintGoalEllipsed: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-goal-ellipsed",
        "defaultMessage": "{goal}..."
    },
    titleForSprintCapacityFlyout: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.title-for-sprint-capacity-flyout",
        "defaultMessage": "SPRINT"
    },
    sprintCapacityLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-capacity-label",
        "defaultMessage": "Sprint capacity ({planningUnit})"
    },
    sprintPointsAllocatedLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-points-allocated-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# point allocated} other {# points allocated}}"
    },
    sprintPointsDoneLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-points-done-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# point done} other {# points done}}"
    },
    sprintDaysAllocatedLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-days-allocated-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# day allocated} other {# days allocated}}"
    },
    sprintDaysDoneLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-days-done-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# day done} other {# days done}}"
    },
    sprintHoursAllocatedLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-hours-allocated-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# hour allocated} other {# hours allocated}}"
    },
    sprintHoursDoneLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-hours-done-label",
        "defaultMessage": "{numerator}/{denominatorCount, plural, one {# hour done} other {# hours done}}"
    },
    sprintStartDateLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-start-date-label",
        "defaultMessage": "Sprint start date"
    },
    sprintEndDateLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-end-date-label",
        "defaultMessage": "Sprint end date"
    },
    sprintDatesMissing: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-dates-missing",
        "defaultMessage": "{sprintName} has no start or end date. We've inferred dates based on your program board."
    },
    sprintCapacityOverviewLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-capacity-overview-label",
        "defaultMessage": "Sprint capacity overview"
    },
    sprintStartDateInfoIconLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-start-date-info-icon-label",
        "defaultMessage": "Sprint start date info"
    },
    sprintEndDateInfoIconLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.sprint-end-date-info-icon-label",
        "defaultMessage": "Sprint end date info"
    },
    closeIconLabel: {
        "id": "portfolio-3-plan-increment-common.ui.sprint-column-header.sprint-capacity-flyout.close-icon-label",
        "defaultMessage": "Close"
    }
});

});



parcelRegister("eeRMo", function(module, exports) {

$parcel$export(module.exports, "HeaderMeasurement", () => $89293d32499e7ce9$export$9cfc0bf0e92f5e76);

var $5uXOq = parcelRequire("5uXOq");

var $600T9 = parcelRequire("600T9");

var $2m0b6 = parcelRequire("2m0b6");

var $9Ik53 = parcelRequire("9Ik53");
const $89293d32499e7ce9$var$useMeasureHeaderForDependencies = ({ columnId: columnId, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, headerRef: headerRef })=>{
    const { scrollLeft: scrollLeft } = (0, $9Ik53.useScrollState)();
    // Hold a ref to the scrollLeft value because we're interested in the value being up to date, but
    // not interested in re-firing the useEffect every time the user scrolls horizontally on the board
    const scrollLeftRef = (0, $5uXOq.useRef)(scrollLeft);
    (0, $5uXOq.useEffect)(()=>{
        scrollLeftRef.current = scrollLeft;
    }, [
        scrollLeft
    ]);
    const [{ dependencyLinesContainerPosition: dependencyLinesContainerPosition }, { updateColumnPositionMap: updateColumnPositionMap }] = (0, $600T9.useDependencyLinks)();
    const measureAndUpdateHeaderPosition = (0, $5uXOq.useCallback)(()=>{
        if (!isUnscheduledWorkColumnPanel && headerRef && headerRef.current && dependencyLinesContainerPosition) {
            const { x: x, width: width, height: height } = headerRef.current.getBoundingClientRect();
            updateColumnPositionMap({
                x: x + scrollLeftRef.current,
                width: width,
                height: height
            }, columnId);
        }
    }, [
        isUnscheduledWorkColumnPanel,
        columnId,
        headerRef,
        updateColumnPositionMap,
        dependencyLinesContainerPosition
    ]);
    (0, $5uXOq.useEffect)(()=>{
        measureAndUpdateHeaderPosition();
    }, [
        measureAndUpdateHeaderPosition
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: headerRef,
        onResize: measureAndUpdateHeaderPosition
    });
};
const $89293d32499e7ce9$export$9cfc0bf0e92f5e76 = ({ columnId: columnId, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, headerRef: headerRef })=>{
    $89293d32499e7ce9$var$useMeasureHeaderForDependencies({
        columnId: columnId,
        isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
        headerRef: headerRef
    });
    return null;
};

});
parcelRegister("600T9", function(module, exports) {

$parcel$export(module.exports, "useDependencyLinks", () => $0fc18713c0225ca6$export$c63c11963c509d47);
$parcel$export(module.exports, "useIPDependencyLines", () => $0fc18713c0225ca6$export$aadd1ba1a70b5a);

var $74ySO = parcelRequire("74ySO");

var $hGgHi = parcelRequire("hGgHi");

var $vNXgH = parcelRequire("vNXgH");

var $2YZCu = parcelRequire("2YZCu");

var $645AZ = parcelRequire("645AZ");

var $4jAPy = parcelRequire("4jAPy");

var $3eGwD = parcelRequire("3eGwD");

var $3sQ5x = parcelRequire("3sQ5x");
var $6dDSs = parcelRequire("6dDSs");
var $iXqE5 = parcelRequire("iXqE5");
const $0fc18713c0225ca6$var$initialState = {
    dependencyLinesContainerPosition: {
        x: 0
    },
    issuesWithIssueLinkPositionMap: new Map(),
    swimlanePositionMap: new Map(),
    columnPositionMap: new Map(),
    activeLine: null
};
const $0fc18713c0225ca6$var$LINE_VERTICAL_OFFSET = 8;
const $0fc18713c0225ca6$var$actions = {
    // We save the board position because we want to draw lines relative to the board, not the viewport
    // Add the board's left and top positions from line calculations to offset the board
    updateDependencyLinesContainerPosition: (dependencyLinesContainerPosition)=>({ setState: setState })=>{
            setState({
                dependencyLinesContainerPosition: dependencyLinesContainerPosition
            });
        },
    updateIssuesWithIssueLinkPositions: (issueEntries, issuesWithIssueLinksIds, issuePositions, isUnscheduledWorkColumnPanel, swimlaneId)=>({ setState: setState, getState: getState })=>{
            if (!isUnscheduledWorkColumnPanel && issuePositions) {
                const { swimlanePositionMap: swimlanePositionMap } = getState();
                if (swimlanePositionMap === undefined || (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(swimlaneId)) return;
                const swimlanePosition = swimlanePositionMap.get(swimlaneId);
                if (swimlanePosition === undefined) return;
                const issueIdsWithLinks = issueEntries.reduce((acc, issueEntry, index)=>{
                    if ((0, $3eGwD.isIssueEntryIssue)(issueEntry) && (0, (/*@__PURE__*/$parcel$interopDefault($74ySO)))(issuesWithIssueLinksIds, issueEntry.issueId)) acc.push({
                        issueId: String(issueEntry.issueId),
                        index: index
                    });
                    return acc;
                }, []);
                const { issuesWithIssueLinkPositionMap: issuesWithIssueLinkPositionMap } = getState();
                const newIssuesWithIssueLinkPositionMap = new Map(issuesWithIssueLinkPositionMap);
                issueIdsWithLinks.forEach(({ issueId: issueId, index: index })=>{
                    const issuePosition = issuePositions[index];
                    if (issuePosition) {
                        // Don't cache the issue position if relativeTop is negative, as it will draw the line upward of the screen
                        const relativeTop = issuePosition.top - swimlanePosition.swimlanePosition.top;
                        if (relativeTop >= 0) newIssuesWithIssueLinkPositionMap.set(issueId, {
                            ...issuePosition,
                            relativeTop: relativeTop
                        });
                    }
                });
                setState({
                    issuesWithIssueLinkPositionMap: newIssuesWithIssueLinkPositionMap
                });
            }
        },
    updateSwimlanePositions: (swimlanePositions, visibleSwimlanePositions, swimlaneIds, collapsedSwimlaneIds)=>({ setState: setState })=>{
            const newSwimlanePositionMap = new Map();
            swimlaneIds.forEach((swimlaneId, index)=>{
                const swimlanePosition = swimlanePositions[index];
                const isVisible = visibleSwimlanePositions.some((visibleSwimlane)=>visibleSwimlane.index === index);
                const isCollapsed = collapsedSwimlaneIds.includes(swimlaneId);
                if (swimlaneId && swimlanePosition) newSwimlanePositionMap.set(swimlaneId, {
                    isCollapsed: isCollapsed,
                    isVisible: isVisible,
                    swimlanePosition: swimlanePosition
                });
            });
            setState({
                swimlanePositionMap: newSwimlanePositionMap
            });
        },
    updateColumnPositionMap: (columnPosition, columnId)=>({ setState: setState, getState: getState })=>{
            const { columnPositionMap: columnPositionMap } = getState();
            const newColumnPositionMap = new Map(columnPositionMap);
            newColumnPositionMap.set(columnId, columnPosition);
            setState({
                columnPositionMap: newColumnPositionMap
            });
        },
    setActiveLine: (activeLine)=>({ setState: setState })=>{
            setState({
                activeLine: activeLine
            });
        }
};
const $0fc18713c0225ca6$var$Store = (0, $iXqE5.createStore)({
    name: 'dependencyLineStore',
    initialState: $0fc18713c0225ca6$var$initialState,
    actions: $0fc18713c0225ca6$var$actions
});
const $0fc18713c0225ca6$export$c63c11963c509d47 = (0, $3sQ5x.createHook)($0fc18713c0225ca6$var$Store);
const $0fc18713c0225ca6$var$swimlaneColumnIssueEntriesKey = (swimlaneId, columnId)=>`${swimlaneId}-${columnId}`;
const $0fc18713c0225ca6$var$calculateEstimatedCardPosition = (cardIndex, swimlanePositionTop, columnHeaderHeight, edgeOffset)=>swimlanePositionTop + (0, $3eGwD.DEFAULT_CARD_HEIGHT) * cardIndex + columnHeaderHeight + (0, $645AZ.swimlaneHeaderHeight) + (0, $3eGwD.DEFAULT_CARD_HEIGHT) / 2 + edgeOffset;
const $0fc18713c0225ca6$var$getYPosition = (issue, issuesWithIssueLinkPositionMap, swimlanePositionMap, columnPositionMap, edge, getOrderedIssueIdsForColumn, swimlaneColumnIssueEntriesCache)=>{
    const swimlaneId = issue.teamId ?? (0, $4jAPy.SWIMLANE_TEAMLESS);
    const swimlanePosition = swimlanePositionMap.get(swimlaneId);
    // When the page loads, it is possible that we try to get this data before it's ready - returning a default value to begin with
    if (issuesWithIssueLinkPositionMap === undefined || swimlanePosition === undefined) return 0;
    const issuePosition = issuesWithIssueLinkPositionMap.get(String(issue.id));
    const columnHeaderHeight = columnPositionMap.get(issue.columnId)?.height ?? 0;
    const edgeOffset = edge === 'left' ? $0fc18713c0225ca6$var$LINE_VERTICAL_OFFSET : -$0fc18713c0225ca6$var$LINE_VERTICAL_OFFSET;
    if (issuePosition) {
        const top = swimlanePosition.swimlanePosition.top + issuePosition.relativeTop + columnHeaderHeight + (0, $645AZ.swimlaneHeaderHeight);
        return top + issuePosition.height / 2 + edgeOffset;
    }
    // if the swimlane the issue belongs to is offscreen and we haven't gotten the card position yet, we do an estimate based on the issue's position in the column
    if (swimlanePosition.isVisible === false) {
        const cachedSwimlaneColumnIssueEntries = swimlaneColumnIssueEntriesCache.get($0fc18713c0225ca6$var$swimlaneColumnIssueEntriesKey(swimlaneId, issue.columnId));
        if (cachedSwimlaneColumnIssueEntries) {
            const index = cachedSwimlaneColumnIssueEntries.indexOf(issue.id);
            if (index !== -1) return $0fc18713c0225ca6$var$calculateEstimatedCardPosition(index, swimlanePosition.swimlanePosition.top, columnHeaderHeight, edgeOffset);
        }
        const orderedIssueIdsInColumn = getOrderedIssueIdsForColumn(issue.columnId, swimlaneId);
        swimlaneColumnIssueEntriesCache.set($0fc18713c0225ca6$var$swimlaneColumnIssueEntriesKey(swimlaneId, issue.columnId), orderedIssueIdsInColumn);
        const index = orderedIssueIdsInColumn.indexOf(issue.id);
        if (index !== -1) return $0fc18713c0225ca6$var$calculateEstimatedCardPosition(index, swimlanePosition.swimlanePosition.top, columnHeaderHeight, edgeOffset);
    }
    // If the swimlane is visible, we should theoretically have the issue position and not gotten here.
    (0, $2YZCu.default).safeErrorWithoutCustomerData('plan-increment-common.useDependencyLinks.getYPosition', 'Failed to find the y position of an issue when calculating dependency line positions.');
    // Return a default value in case we can't find the y position of the card we're trying to draw to.
    return 0;
};
const $0fc18713c0225ca6$var$getXPosition = (issue, dependencyLinesContainerPosition, columnPositionMap, edge)=>{
    const columnPosition = columnPositionMap.get(issue.columnId);
    if (columnPosition) return columnPosition.x + (edge === 'left' ? (0, $3eGwD.CARD_LEFT_RIGHT_MARGIN) : -(0, $3eGwD.CARD_LEFT_RIGHT_MARGIN)) + (edge === 'left' ? 0 : columnPosition.width) - dependencyLinesContainerPosition.x;
    // Return a default value in case we can't find the x position of the card we're trying to draw to.
    return 0;
};
const $0fc18713c0225ca6$var$getIssuePosition = (state, issue, edge = 'right', getOrderedIssueIdsForColumn, swimlaneColumnIssueEntriesCache)=>{
    const { dependencyLinesContainerPosition: dependencyLinesContainerPosition, issuesWithIssueLinkPositionMap: issuesWithIssueLinkPositionMap, swimlanePositionMap: swimlanePositionMap, columnPositionMap: columnPositionMap } = state;
    const yPosition = $0fc18713c0225ca6$var$getYPosition(issue, issuesWithIssueLinkPositionMap, swimlanePositionMap, columnPositionMap, edge, getOrderedIssueIdsForColumn, swimlaneColumnIssueEntriesCache);
    const xPosition = $0fc18713c0225ca6$var$getXPosition(issue, dependencyLinesContainerPosition, columnPositionMap, edge);
    return {
        id: String(issue.id),
        y: yPosition,
        x: xPosition,
        color: 'DARK_GREY'
    };
};
// Arbitrary number - this affects the curvature of the drawn dependency line only.
const $0fc18713c0225ca6$var$ITEM_HEIGHT = 40;
const $0fc18713c0225ca6$var$getDependencyLine = ({ state: state, from: from, to: to, isOfftrack: isOfftrack, getOrderedIssueIdsForColumn: getOrderedIssueIdsForColumn, swimlaneColumnIssueEntriesCache: swimlaneColumnIssueEntriesCache })=>({
        itemHeight: $0fc18713c0225ca6$var$ITEM_HEIGHT,
        isOverlapping: isOfftrack,
        from: $0fc18713c0225ca6$var$getIssuePosition(state, from, 'right', getOrderedIssueIdsForColumn, swimlaneColumnIssueEntriesCache),
        to: $0fc18713c0225ca6$var$getIssuePosition(state, to, 'left', getOrderedIssueIdsForColumn, swimlaneColumnIssueEntriesCache)
    });
// The list of issues passed in should have already filtered out issues from the unscheduled column.
// If either end of the issue link is undefined, those issues are not in the board.
const $0fc18713c0225ca6$var$issuesAreInBoard = (sourceIssue, destinationIssue)=>sourceIssue !== undefined && destinationIssue !== undefined;
// If either issue in the link belongs to a swimlane that is collapsed, we should not draw that line
const $0fc18713c0225ca6$var$issuesSwimlanesAreNotCollapsed = (sourceIssue, destinationIssue, swimlanePositionMap)=>{
    const sourceSwimlaneId = sourceIssue?.teamId ?? (0, $4jAPy.SWIMLANE_TEAMLESS);
    const destinationSwimlaneId = destinationIssue?.teamId ?? (0, $4jAPy.SWIMLANE_TEAMLESS);
    const sourceSwimlane = swimlanePositionMap.get(sourceSwimlaneId);
    const destinationSwimlane = swimlanePositionMap.get(destinationSwimlaneId);
    return sourceSwimlane && destinationSwimlane && !sourceSwimlane.isCollapsed && !destinationSwimlane.isCollapsed;
};
const $0fc18713c0225ca6$export$c9ae9143e2c98177 = (state, issuesWithLinksById, showOffTrackDependencies, issueIdsToShowDependencies, getOrderedIssueIdsForColumn)=>{
    const { swimlanePositionMap: swimlanePositionMap } = state;
    if (!issuesWithLinksById || Object.values(issuesWithLinksById).length === 0 || !showOffTrackDependencies && issueIdsToShowDependencies.length === 0) return [];
    const filteredIssues = [];
    if (issueIdsToShowDependencies.length) issueIdsToShowDependencies.forEach((id)=>{
        const issue = issuesWithLinksById[id];
        if (issue) filteredIssues.push(issue);
    });
    if (showOffTrackDependencies) Object.values(issuesWithLinksById).forEach((issue)=>{
        if (issue.issueLinks && issue.issueLinks.length) {
            const offTrackLinks = issue.issueLinks.filter((link)=>link.isOfftrack);
            if (offTrackLinks.length) {
                const issueWithOfftrackLinks = {
                    ...issue,
                    issueLinks: offTrackLinks
                };
                filteredIssues.push(issueWithOfftrackLinks);
            }
        }
    });
    const uniqueIssueLinkIds = new Set();
    /**
	 * Use a cache for the lookup of issue entries in a particular swimlane/column
	 * because the lookup involves looping over many issues in the state and processing the data.
	 * This is necessary for calculating the estimated position of a card if it is offscreen and hasn't yet been rendered onscreen.
	 */ const swimlaneColumnIssueEntriesCache = new Map();
    const overlayDependencies = filteredIssues.reduce((acc, issue)=>{
        if (!issue.issueLinks) return acc;
        // We need to ensure we only include a single entry when there are multiple issue link types
        // between the same source and destination issue so that we don't unnecessarily render multiple lines.
        // We don't need to be opinionated about which one we choose, as the user can click on
        // the line to ascertain the details of the different issue links.
        const uniqueSourceDestinationIssueLinks = (0, (/*@__PURE__*/$parcel$interopDefault($vNXgH)))(issue.issueLinks, (a, b)=>a.sourceId === b.sourceId && a.destinationId === b.destinationId);
        uniqueSourceDestinationIssueLinks.forEach((issueLink)=>{
            // Every issue link appears twice, so we don't want to handle ones we have already handled.
            if (uniqueIssueLinkIds.has(issueLink.id)) return;
            uniqueIssueLinkIds.add(issueLink.id);
            const sourceIssue = issuesWithLinksById[issueLink.sourceId];
            const destinationIssue = issuesWithLinksById[issueLink.destinationId];
            if ($0fc18713c0225ca6$var$issuesAreInBoard(sourceIssue, destinationIssue) && $0fc18713c0225ca6$var$issuesSwimlanesAreNotCollapsed(sourceIssue, destinationIssue, swimlanePositionMap)) acc.push($0fc18713c0225ca6$var$getDependencyLine({
                state: state,
                from: sourceIssue,
                to: destinationIssue,
                isOfftrack: !!issueLink.isOfftrack,
                getOrderedIssueIdsForColumn: getOrderedIssueIdsForColumn,
                swimlaneColumnIssueEntriesCache: swimlaneColumnIssueEntriesCache
            }));
        });
        return acc;
    }, []);
    return overlayDependencies;
};
const $0fc18713c0225ca6$var$getDependencyLines = (0, $6dDSs.createSelector)((state)=>state, (_, props)=>props, (state, { issuesWithLinksById: issuesWithLinksById, showOffTrackDependencies: showOffTrackDependencies, issueIdsToShowDependencies: issueIdsToShowDependencies, getOrderedIssueIdsForColumn: getOrderedIssueIdsForColumn })=>{
    return $0fc18713c0225ca6$export$c9ae9143e2c98177(state, issuesWithLinksById, showOffTrackDependencies, issueIdsToShowDependencies, getOrderedIssueIdsForColumn);
});
const $0fc18713c0225ca6$export$aadd1ba1a70b5a = (0, $3sQ5x.createHook)($0fc18713c0225ca6$var$Store, {
    selector: $0fc18713c0225ca6$var$getDependencyLines
});

});
parcelRegister("74ySO", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");

var $hTJwX = parcelRequire("hTJwX");

var $agVdz = parcelRequire("agVdz");

var $kPZpS = parcelRequire("kPZpS");

var $dMEgP = parcelRequire("dMEgP");
/* Built-in method references for those with the same name as other `lodash` methods. */ var $5263f72d78aeaf9c$var$nativeMax = Math.max;
/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */ function $5263f72d78aeaf9c$var$includes(collection, value, fromIndex, guard) {
    collection = $hTJwX(collection) ? collection : $dMEgP(collection);
    fromIndex = fromIndex && !guard ? $kPZpS(fromIndex) : 0;
    var length = collection.length;
    if (fromIndex < 0) fromIndex = $5263f72d78aeaf9c$var$nativeMax(length + fromIndex, 0);
    return $agVdz(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && $2wwA6(collection, value, fromIndex) > -1;
}
module.exports = $5263f72d78aeaf9c$var$includes;

});



parcelRegister("8qFMV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cace9106fadeb38d$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cace9106fadeb38d$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    visibleIssueCount: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.visible-issue-count",
        "defaultMessage": "{count} / {total} {total, plural, one {issue} other {issues}}"
    },
    totalIssueCount: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.total-issue-count",
        "defaultMessage": "{total} {total, plural, one {issue} other {issues}}"
    },
    completedSprint: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.completed-sprint",
        "defaultMessage": "Completed sprint"
    },
    activeSprint: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.active-sprint",
        "defaultMessage": "Active sprint"
    },
    futureSprint: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.future-sprint",
        "defaultMessage": "Future sprint"
    },
    visibleIssueCountIssueTermRefresh: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.visible-issue-count-issue-term-refresh",
        "defaultMessage": "{count} / {total} {total, plural, one {work item} other {work items}}"
    },
    totalIssueCountIssueTermRefresh: {
        "id": "software.main.board-container.board.column.program-swimlane-column-header.total-issue-count-issue-term-refresh",
        "defaultMessage": "{total} {total, plural, one {work item} other {work items}}"
    }
});

});


parcelRegister("2lkEP", function(module, exports) {

$parcel$export(module.exports, "FastVirtualList", () => $4f0f63c9193536a4$export$32fc6f03ada9e09e);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $g503o = parcelRequire("g503o");

var $600T9 = parcelRequire("600T9");

var $3eGwD = parcelRequire("3eGwD");

var $g7BZG = parcelRequire("g7BZG");

var $guFRy = parcelRequire("guFRy");

var $lmBAt = parcelRequire("lmBAt");

var $c1haS = parcelRequire("c1haS");

var $63LqY = parcelRequire("63LqY");

var $bQegf = parcelRequire("bQegf");

var $htqkB = parcelRequire("htqkB");

var $bvghy = parcelRequire("bvghy");

var $bfNGc = parcelRequire("bfNGc");

var $5b8dQ = parcelRequire("5b8dQ");
const $4f0f63c9193536a4$export$32fc6f03ada9e09e = ({ name: name, offsetTop: offsetTop, issueEntries: issueEntries = [], issuesWithIssueLinksIds: issuesWithIssueLinksIds = [], footer: footer, placeholder: placeholder, renderCard: renderCard, showFooter: showFooter, columnId: columnId, swimlaneId: swimlaneId, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel })=>{
    const isIpBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const cardHeightCache = (0, $bvghy.useCardHeightCache)();
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: cardHeightCache,
            getCacheKey: (index)=>{
                const issueEntry = issueEntries[index];
                if (!issueEntry) return undefined;
                if ((0, $3eGwD.isIssueEntryGroup)(issueEntry)) return (0, $3eGwD.getIssueEntryGroupKey)(issueEntry);
                return issueEntry.issueId;
            }
        }), [
        issueEntries,
        cardHeightCache
    ]);
    const rowCount = (0, $bfNGc.useRowCount)({
        placeholder: placeholder,
        issues: issueEntries
    });
    /**
   * versioning by the order of issue ids order excluding subtasks
   */ const version = (0, $5uXOq.useMemo)(()=>issueEntries.map((issueEntry)=>(0, $3eGwD.isIssueEntryIssue)(issueEntry) ? issueEntry.issueId : issueEntry.parentId).toString(), [
        issueEntries
    ]);
    const getDefaultRowSize = (0, $5uXOq.useCallback)((index)=>{
        if (isJSWBoard && !isIpBoard && showFooter && (0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('fix_board_content_rendering_delay')) return index === issueEntries.length ? (0, $3eGwD.DEFAULT_INLINE_CARD_CREATE_HEIGHT) : (0, $3eGwD.DEFAULT_CARD_HEIGHT);
        return index === issueEntries.length ? 0 : (0, $3eGwD.DEFAULT_CARD_HEIGHT);
    }, [
        issueEntries.length,
        isJSWBoard,
        isIpBoard,
        showFooter
    ]);
    const { rows: rows, totalSize: totalSize, scrollTo: scrollTo, isScrolling: isScrolling, rowStates: rowStates } = (0, $guFRy.useVirtual)({
        rowCount: rowCount,
        overscanHeight: (0, $3eGwD.DEFAULT_CARD_HEIGHT),
        getDefaultRowSize: getDefaultRowSize,
        offsetTop: offsetTop,
        cacheOptions: cacheOptions,
        version: version
    });
    (0, $g7BZG.useRemeasureOnResize)({
        rows: rows
    });
    (0, $htqkB.useAutoScrollCard)(issueEntries, scrollTo);
    (0, $5b8dQ.useScrollToUnscheduledColumnICC)(columnId, swimlaneId, issueEntries.length, scrollTo);
    const [_, { updateIssuesWithIssueLinkPositions: updateIssuesWithIssueLinkPositions }] = (0, $600T9.useDependencyLinks)();
    (0, $5uXOq.useEffect)(()=>{
        if (isIpBoard) updateIssuesWithIssueLinkPositions(issueEntries, issuesWithIssueLinksIds, rowStates, isUnscheduledWorkColumnPanel, swimlaneId);
    }, [
        isIpBoard,
        isUnscheduledWorkColumnPanel,
        issueEntries,
        issuesWithIssueLinksIds,
        swimlaneId,
        rowStates,
        updateIssuesWithIssueLinkPositions
    ]);
    // If there are no cards in a swimlane, it will be hidden. However, when we do render
    // columns and there is no ICC, placeholder or cards we want it to have a minimum
    // height to make it render in a cleaner fashion.
    const height = Math.max((0, $3eGwD.DEFAULT_CARD_HEIGHT), totalSize);
    const renderer = (0, $bQegf.useRowRenderer)({
        cardEntries: issueEntries,
        footer: footer,
        footerIndex: issueEntries.length,
        placeholder: placeholder,
        renderCard: renderCard,
        showFooter: showFooter
    });
    const style = (0, $5uXOq.useMemo)(()=>({
            minHeight: height,
            margin: `${"var(--ds-space-050, 4px)"} ${0, $3eGwD.CARD_LEFT_RIGHT_MARGIN}px`,
            backgroundColor: (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $g503o.columnThemes).default.backgroundNew : (0, $g503o.columnThemes).default.background
        }), [
        height
    ]);
    const convertedName = name?.split(' ').join('-').toLowerCase() ?? '';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f0f63c9193536a4$var$FastVirtualListWrapper, {
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop
        style: style,
        "aria-labelledby": (0, $4R6GH.fg)('remove_aria_labelled_by_on_column_ul') ? undefined : `platform-board-kit.ui.column-title-${convertedName}`,
        "data-testid": "software-board.board-container.board.virtual-board.fast-virtual-list.fast-virtual-list-wrapper"
    }, rows.map(({ index: index, top: top, forceRemeasure: forceRemeasure, measure: measure })=>renderer({
            index: index,
            isScrolling: isScrolling,
            forceRemeasure: forceRemeasure,
            measure: measure,
            offsetTop: top,
            style: {
                position: 'absolute',
                top: top - offsetTop,
                width: '100%',
                contain: 'style',
                marginTop: (0, $4R6GH.fg)('tanuki_padding_margin_use_token') ? "var(--ds-space-0, 0px)" : '0px'
            }
        })));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4f0f63c9193536a4$var$FastVirtualListWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "ul", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _kqswh2mm _njlpp9nq _2mzuglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g7BZG", function(module, exports) {

$parcel$export(module.exports, "useRemeasureOnResize", () => $249ff1189d8a41a0$export$b613f422d3967fcc);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");

var $9Ik53 = parcelRequire("9Ik53");

var $4x4g5 = parcelRequire("4x4g5");
const $249ff1189d8a41a0$var$observerCount = new Map();
const $249ff1189d8a41a0$export$741acf1aabe74b99 = new Set();
const $249ff1189d8a41a0$export$62bdf76975b21c04 = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(()=>{
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        $249ff1189d8a41a0$export$741acf1aabe74b99.forEach((remeasure)=>remeasure());
    });
}, 200);
const $249ff1189d8a41a0$var$resizeObserver = new (0, $4x4g5.RemeasureObserver)($249ff1189d8a41a0$export$62bdf76975b21c04);
function $249ff1189d8a41a0$export$b613f422d3967fcc({ rows: rows }) {
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    (0, $5uXOq.useEffect)(()=>{
        if (!scrollElement) return undefined;
        const operations = rows.map((row)=>()=>row.forceRemeasure());
        operations.forEach((operation)=>{
            $249ff1189d8a41a0$export$741acf1aabe74b99.add(operation);
        });
        $249ff1189d8a41a0$var$resizeObserver.observe(scrollElement);
        $249ff1189d8a41a0$var$observerCount.set(scrollElement, ($249ff1189d8a41a0$var$observerCount.get(scrollElement) ?? 0) + 1);
        return ()=>{
            operations.forEach((operation)=>{
                $249ff1189d8a41a0$export$741acf1aabe74b99.delete(operation);
            });
            $249ff1189d8a41a0$var$observerCount.set(scrollElement, ($249ff1189d8a41a0$var$observerCount.get(scrollElement) ?? 0) - 1);
            const refCount = $249ff1189d8a41a0$var$observerCount.get(scrollElement) ?? 0;
            if (refCount <= 0) {
                $249ff1189d8a41a0$var$resizeObserver.unobserve(scrollElement);
                $249ff1189d8a41a0$var$observerCount.delete(scrollElement);
            }
        };
    }, [
        rows,
        scrollElement
    ]);
}

});
parcelRegister("4x4g5", function(module, exports) {

$parcel$export(module.exports, "RemeasureObserver", () => $84c7085ea2b075ea$export$7cd4445ae3acab20);
/**
 * Wrap resize observer for mocking on tests
 */ class $84c7085ea2b075ea$export$7cd4445ae3acab20 {
    constructor(callback){
        this.resizeObserver = null;
        if (typeof ResizeObserver !== 'undefined') this.resizeObserver = new ResizeObserver(callback);
    }
    observe(element) {
        this.resizeObserver?.observe(element);
    }
    unobserve(element) {
        this.resizeObserver?.unobserve(element);
    }
}

});


parcelRegister("htqkB", function(module, exports) {

$parcel$export(module.exports, "useAutoScrollCard", () => $e7fab663bec031c7$export$b61f82894f7693a4);

var $5uXOq = parcelRequire("5uXOq");

var $3eGwD = parcelRequire("3eGwD");

var $d1i1b = parcelRequire("d1i1b");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");
const $e7fab663bec031c7$export$b61f82894f7693a4 = (issueEntries, scrollTo)=>{
    const autoScroll = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardAutoScroll));
    const dispatch = (0, $67sX6.useBoardDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        const autoScrollIssueId = autoScroll?.issueId;
        if (!autoScrollIssueId) return;
        // NOTE: Auto scrolling to a subtask may not work as expected
        const issueIndex = issueEntries.findIndex((issueEntry)=>(0, $3eGwD.isIssueEntryGroup)(issueEntry) ? issueEntry.issueIds.includes(autoScrollIssueId) : issueEntry.issueId === autoScrollIssueId);
        if (issueIndex === -1) return;
        return scrollTo(issueIndex, {
            immediate: true,
            onComplete: ()=>dispatch((0, $d1i1b.cardAutoScroll)(null))
        });
    }, [
        autoScroll,
        dispatch,
        issueEntries,
        scrollTo
    ]);
};

});

parcelRegister("bfNGc", function(module, exports) {

$parcel$export(module.exports, "useRowCount", () => $ac1cfc1c897aa8a6$export$970871f1c0f66ab9);
const $ac1cfc1c897aa8a6$export$970871f1c0f66ab9 = ({ placeholder: placeholder, issues: issues })=>{
    const numberOfRows = issues.length + 1;
    // If we aren't provided with any rows, we want to render the placeholder. Just put the count as 1.
    if (numberOfRows === 0 && placeholder) return 1;
    return numberOfRows;
};

});

parcelRegister("5b8dQ", function(module, exports) {

$parcel$export(module.exports, "useScrollToUnscheduledColumnICC", () => $051cc55ef6160350$export$afd20280ad61fab9);

var $5uXOq = parcelRequire("5uXOq");

var $5rFbt = parcelRequire("5rFbt");

var $d1i1b = parcelRequire("d1i1b");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");
const $051cc55ef6160350$export$afd20280ad61fab9 = (columnId, swimlaneId, issueCount, scrollTo)=>{
    const isIncrementPlanningBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const autoScroll = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardAutoScroll));
    const autoScrollSwimlaneId = autoScroll?.unscheduledColumnSwimlaneId;
    const isImmediate = autoScroll?.isImmediate;
    const dispatch = (0, $67sX6.useBoardDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (isIncrementPlanningBoard && autoScrollSwimlaneId && swimlaneId && columnId === (0, $5rFbt.UNSCHEDULED_COLUMN_ID) && swimlaneId === autoScrollSwimlaneId) scrollTo(issueCount, {
            immediate: isImmediate,
            hasVirtualisedChildren: true,
            onComplete: ()=>{
                dispatch((0, $d1i1b.cardAutoScrollUnscheduledColumnIcc)(null));
            }
        });
    }, [
        isIncrementPlanningBoard,
        autoScrollSwimlaneId,
        isImmediate,
        issueCount,
        scrollTo,
        columnId,
        swimlaneId,
        dispatch
    ]);
};

});


parcelRegister("7p3wz", function(module, exports) {

$parcel$export(module.exports, "default", () => $308e9ef4b82bad3f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $99gkn = parcelRequire("99gkn");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");


var $2Z6La = parcelRequire("2Z6La");

var $l8ruj = parcelRequire("l8ruj");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $8FKBU = parcelRequire("8FKBU");

var $f8Y0z = parcelRequire("f8Y0z");

var $luEdd = parcelRequire("luEdd");
const $308e9ef4b82bad3f$var$Footer = /*#__PURE__*/ (0, $5uXOq.memo)(({ isLastSwimlane: isLastSwimlane, isInitialColumn: isInitialColumn, canShowIccNudge: canShowIccNudge, isColumnIccEnabled: isColumnIccEnabled, showDoneCardsButton: showDoneCardsButton, columnId: columnId, swimlaneId: swimlaneId, cardIndex: cardIndex, openInitialColumnIcc: openInitialColumnIcc, limitJql: limitJql, columnName: columnName })=>{
    const { initialProjectId: projectId } = (0, $2Z6La.useIccContext)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const isCompanyManaged = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsCMPBoard));
    if (!isColumnIccEnabled && !showDoneCardsButton) return null;
    const ariaLabelMessage = (0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $luEdd.default).triggerAriaLabelIssueTermRefresh : (0, $luEdd.default).triggerAriaLabel;
    const icc = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f8Y0z.default), {
        showOnHover: !isInitialColumn,
        canShowIccNudge: canShowIccNudge,
        triggerAppearance: (0, $7462c685f739ed5a$export$dda6912361cddac9),
        triggerAriaLabel: formatMessage(ariaLabelMessage, {
            columnName: columnName
        }),
        columnId: columnId,
        swimlaneId: swimlaneId,
        cardIndex: cardIndex,
        // TODO-BOARD-REFACTOR-TYPES: should stay open is not a property you can pass in. It's calculated internally in the `mergeStateToProps`
        shouldStayOpen: openInitialColumnIcc,
        isLastSwimlane: isLastSwimlane,
        onChangeFormVisible: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        // TODO-BOARD-REFACTOR-TYPES
        // @ts-expect-error projectID expects number but it is number | null
        projectId: projectId,
        isFooter: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isColumnIccEnabled && (isInitialColumn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
        name: "icc-button-in-footer"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99gkn.default), {
        data: {
            isCompanyManaged: isCompanyManaged
        }
    }), icc) : icc), showDoneCardsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8FKBU.default), {
        limitJql: limitJql
    }));
});
var $308e9ef4b82bad3f$export$2e2bcd8739ae039 = $308e9ef4b82bad3f$var$Footer;

});
parcelRegister("8FKBU", function(module, exports) {

$parcel$export(module.exports, "default", () => $873e90b05562b927$export$2e2bcd8739ae039);

var $3f2cs = parcelRequire("3f2cs");

var $hGgHi = parcelRequire("hGgHi");

var $5EjyB = parcelRequire("5EjyB");

var $bC2fB = parcelRequire("bC2fB");

var $hnvrw = parcelRequire("hnvrw");

var $e1q2I = parcelRequire("e1q2I");

var $67Z81 = parcelRequire("67Z81");
const $873e90b05562b927$export$987548e0054ee734 = (url)=>{
    const [path, jqlQuery] = url.split('?jql=');
    const encodedJqlQuery = encodeURIComponent(jqlQuery);
    return `${path}?jql=${encodedJqlQuery}`;
};
const $873e90b05562b927$export$c31df4bd766f9c35 = (state, ownProps)=>{
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const { limitJql: limitJql } = ownProps;
    const getUrl = ()=>{
        if (isCMPBoard) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(limitJql)) return $873e90b05562b927$export$987548e0054ee734(limitJql);
            return (0, $hnvrw.getOldIssuesUrl)((0, $67Z81.contextPathSelector)(state), (0, $67Z81.projectKeySelector)(state));
        }
        return (0, $hnvrw.getResolvedIssuesUrl)((0, $67Z81.contextPathSelector)(state), (0, $67Z81.projectKeySelector)(state));
    };
    return {
        url: getUrl(),
        isCMPBoard: isCMPBoard
    };
};
const $873e90b05562b927$var$connector = (0, $bC2fB.connect)($873e90b05562b927$export$c31df4bd766f9c35, (dispatch)=>({
        onClick: (0, $3f2cs.bindActionCreators)((0, $e1q2I.doneIssuesButtonClick), dispatch)
    }));
var $873e90b05562b927$export$2e2bcd8739ae039 = $873e90b05562b927$var$connector((0, $5EjyB.default));

});
parcelRegister("5EjyB", function(module, exports) {

$parcel$export(module.exports, "default", () => $f6d5fe5db4b4b3b7$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $1GGwS = parcelRequire("1GGwS");

var $hyOJh = parcelRequire("hyOJh");

var $tvuR8 = parcelRequire("tvuR8");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $dCm1o = parcelRequire("dCm1o");

var $9Q22S = parcelRequire("9Q22S");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f6d5fe5db4b4b3b7$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q19bv _u5f319bv _n3td19bv _19bv19bv _y3gn1h6o",
            __cmplp.className
        ])
    });
});
class $f6d5fe5db4b4b3b7$export$b1de088ebae9cb6c extends (0, $5uXOq.PureComponent) {
    constructor(...args){
        super(...args), // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onClick = (e, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'findClearedIssues');
            this.props.onClick();
        }, this.renderButton = (intl)=>{
            const oldIssuesSearchLink = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Q22S.default).oldIssuesSearchLinkIssueTermRefresh : (0, $9Q22S.default).oldIssuesSearchLink;
            const findDoneClearedCardsLink = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Q22S.default).findDoneClearedCardsLinkIssueTermRefresh : (0, $9Q22S.default).findDoneClearedCardsLink;
            const message = intl.formatMessage(this.props.isCMPBoard ? oldIssuesSearchLink : findDoneClearedCardsLink);
            if ((0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
                href: this.props.url,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))),
                appearance: "subtle",
                spacing: "compact",
                onClick: this.onClick
            }, message);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                appearance: "subtle",
                spacing: "compact",
                href: this.props.url,
                onClick: this.onClick,
                iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyOJh))), {
                    label: "",
                    color: "var(--ds-text-subtle, #44546F)",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($tvuR8))),
                    LEGACY_size: "small"
                })
            }, message);
        }, this.render = ()=>{
            const { intl: intl } = this.props;
            const oldIssuesSearchMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Q22S.default).oldIssuesSearchMessageIssueTermRefresh : (0, $9Q22S.default).oldIssuesSearchMessage;
            const doneClearedCardsTooltip = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9Q22S.default).doneClearedCardsTooltipIssueTermRefresh : (0, $9Q22S.default).doneClearedCardsTooltip;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f6d5fe5db4b4b3b7$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: intl.formatMessage(this.props.isCMPBoard ? oldIssuesSearchMessage : doneClearedCardsTooltip)
            }, this.renderButton(intl)));
        };
    }
}
var $f6d5fe5db4b4b3b7$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($f6d5fe5db4b4b3b7$export$b1de088ebae9cb6c);

});
parcelRegister("9Q22S", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbaaa5f719e5fa57$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dbaaa5f719e5fa57$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    findDoneClearedCardsLink: {
        "id": "platform-board-kit.card.done-cards-button.find-done-cleared-cards-link",
        "defaultMessage": "See all Done issues"
    },
    doneClearedCardsTooltip: {
        "id": "platform-board-kit.card.done-cards-button.done-cleared-cards-tooltip",
        "defaultMessage": "Done issues cleared from the board can be viewed here."
    },
    oldIssuesSearchLink: {
        "id": "platform-board-kit.card.done-cards-button.old-issues-search-link",
        "defaultMessage": "See older issues"
    },
    oldIssuesSearchMessage: {
        "id": "platform-board-kit.card.done-cards-button.old-issues-search-message",
        "defaultMessage": "View older issues that have been cleared from the board"
    },
    findDoneClearedCardsLinkIssueTermRefresh: {
        "id": "platform-board-kit.card.done-cards-button.find-done-cleared-cards-link-issue-term-refresh",
        "defaultMessage": "View done work items"
    },
    doneClearedCardsTooltipIssueTermRefresh: {
        "id": "platform-board-kit.card.done-cards-button.done-cleared-cards-tooltip-issue-term-refresh",
        "defaultMessage": "Everything marked as done can be viewed here."
    },
    oldIssuesSearchLinkIssueTermRefresh: {
        "id": "platform-board-kit.card.done-cards-button.old-issues-search-link-issue-term-refresh",
        "defaultMessage": "See older work items"
    },
    oldIssuesSearchMessageIssueTermRefresh: {
        "id": "platform-board-kit.card.done-cards-button.old-issues-search-message-issue-term-refresh",
        "defaultMessage": "View older work items that have been cleared from the board"
    }
});

});



parcelRegister("luEdd", function(module, exports) {

$parcel$export(module.exports, "default", () => $dbff7b82807b269a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dbff7b82807b269a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    triggerAriaLabel: {
        "id": "software.main.board-container.board.columns-container.column.footer.trigger-aria-label",
        "defaultMessage": "Create issue in {columnName}"
    },
    triggerAriaLabelIssueTermRefresh: {
        "id": "software.main.board-container.board.columns-container.column.footer.trigger-aria-label-issue-term-refresh",
        "defaultMessage": "Create work item in {columnName}"
    }
});

});




parcelRegister("aanra", function(module, exports) {

$parcel$export(module.exports, "useSetViewModeFromLocalStorage", () => $2713765183b57c29$export$2ed50744becdad7d);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $3eGwD = parcelRequire("3eGwD");
const $2713765183b57c29$export$2ed50744becdad7d = ()=>{
    const [, { setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const localStorageViewMode = (0, $3eGwD.getBoardDetailViewMode)();
    const viewMode = (0, $2gCtH.useViewMode)();
    (0, $5uXOq.useEffect)(()=>{
        if (localStorageViewMode === 'MODAL') setDetailViewAsModal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    // Sync the localStorage value with viewMode from jira-issue-context-service (the source of truth).
    (0, $5uXOq.useEffect)(()=>{
        if (viewMode && viewMode !== localStorageViewMode) (0, $3eGwD.setBoardDetailViewMode)(viewMode);
    }, [
        localStorageViewMode,
        viewMode
    ]);
};

});


parcelRegister("f3HGL", function(module, exports) {

$parcel$export(module.exports, "SwimlaneMoveToDoneButton", () => $fbba48641cc9262b$export$71546524403b0606);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $koVbs = parcelRequire("koVbs");

var $c79wa = parcelRequire("c79wa");

var $4gHuj = parcelRequire("4gHuj");

var $67sX6 = parcelRequire("67sX6");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $aBJH6 = parcelRequire("aBJH6");
const $fbba48641cc9262b$export$71546524403b0606 = ({ id: id })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { values: swimlaneValues } = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneSelector))(id) || {};
    const openMoveToDoneModal = (0, $5uXOq.useCallback)(()=>{
        if (swimlaneValues?.type === (0, $c79wa.STORY) && swimlaneValues?.parentId) dispatch((0, $4gHuj.issueChildrenInFinalColumnRequest)(swimlaneValues.parentId));
    }, [
        dispatch,
        swimlaneValues
    ]);
    const isParentDone = (0, $67sX6.useBoardSelector)((0, $4jZ56.isSwimlaneBySubtaskParentDoneSelector))(id);
    const areAllParentChildrenDone = (0, $67sX6.useBoardSelector)((0, $4jZ56.areSwimlaneBySubtaskParentChildrenDoneSelector))(swimlaneValues);
    return !isParentDone && areAllParentChildrenDone ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: openMoveToDoneModal
    }, formatMessage((0, $aBJH6.default).moveToDoneLabel)) : null;
};

});
parcelRegister("aBJH6", function(module, exports) {

$parcel$export(module.exports, "default", () => $a8a3a6fc7e8916a3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a8a3a6fc7e8916a3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    moveToDoneLabel: {
        "id": "software.main.board-container.board.swimlane-move-to-done.move-to-done-label",
        "defaultMessage": "Move to Done"
    }
});

});


parcelRegister("eBkhA", function(module, exports) {

$parcel$export(module.exports, "IncrementPlanningSwimlane", () => $0240f506b2cb0ef2$export$ceb111e513902c92);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");

var $koVbs = parcelRequire("koVbs");

var $bdYfL = parcelRequire("bdYfL");

var $4jAPy = parcelRequire("4jAPy");

var $c1Y5g = parcelRequire("c1Y5g");

var $67sX6 = parcelRequire("67sX6");

var $k50Aq = parcelRequire("k50Aq");

var $5mTgl = parcelRequire("5mTgl");

var $4jZ56 = parcelRequire("4jZ56");

var $1vXOx = parcelRequire("1vXOx");

var $2FiSG = parcelRequire("2FiSG");

var $ebF5k = parcelRequire("ebF5k");
const $0240f506b2cb0ef2$export$ceb111e513902c92 = ({ id: id, innerRef: innerRef, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, top: top, children: children })=>{
    const [isCreateButtonVisible, setIsCreateButtonVisible] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const showCreateButton = (0, $5uXOq.useCallback)(()=>{
        setIsCreateButtonVisible(true);
    }, [
        setIsCreateButtonVisible
    ]);
    const hideCreateButton = (0, $5uXOq.useCallback)(()=>{
        setIsCreateButtonVisible(false);
    }, [
        setIsCreateButtonVisible
    ]);
    const swimlaneId = (0, $bdYfL.truncateUnscheduledWorkSwimlaneId)(id, isUnscheduledWorkColumnPanel);
    const { imageUrl: imageUrl, name: name, values: values, message: message } = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneSelector))(swimlaneId) || {};
    const isIncrementPlanningBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const collapsed = (0, $67sX6.useBoardSelector)((0, $4jZ56.getIsSwimlaneCollapsed))(id);
    const getSprintAssociationButton = ()=>!isUnscheduledWorkColumnPanel && !isIncrementPlanningBoardReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FiSG.default), {
            teamId: swimlaneId
        });
    const getCustomRightContent = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: [
                $0240f506b2cb0ef2$var$SwimlaneRightContentContainerStyles,
                isCreateButtonVisible ? $0240f506b2cb0ef2$var$visibleButton : $0240f506b2cb0ef2$var$hiddenButton
            ],
            testId: "software-board.board-container.board.increment-planning-swimlane.create-unscheduled-issue-button"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ebF5k.default), {
            teamId: swimlaneId
        }));
    const onToggle = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        dispatch((0, $k50Aq.swimlaneToggle)(id));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'IPBoardSwimlaneBar');
    }, [
        dispatch,
        id
    ]);
    const swimlaneName = name || (message ? formatMessage(message) : '');
    const swimlaneValues = values && values.type === (0, $4jAPy.TEAM) ? values : undefined;
    const swimlane = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1Y5g.IncrementPlanningSwimlaneHeaderContent), {
        id: swimlaneId,
        name: swimlaneName,
        collapsed: collapsed,
        onToggle: onToggle,
        isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel,
        values: swimlaneValues,
        iconImageUrl: imageUrl,
        innerRef: innerRef,
        customLeftContent: getSprintAssociationButton(),
        customRightContent: getCustomRightContent(),
        top: top
    }, children);
    return isUnscheduledWorkColumnPanel ? // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        onMouseEnter: showCreateButton,
        onMouseLeave: hideCreateButton,
        onFocus: showCreateButton,
        onBlur: hideCreateButton
    }, swimlane) : swimlane;
};
const $0240f506b2cb0ef2$var$visibleButton = (0, $8CUq3.xcss)({
    opacity: 1
});
const $0240f506b2cb0ef2$var$hiddenButton = (0, $8CUq3.xcss)({
    opacity: 0
});
const $0240f506b2cb0ef2$var$SwimlaneRightContentContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'flex-end',
    paddingRight: 'space.100'
});

});
parcelRegister("c1Y5g", function(module, exports) {

$parcel$export(module.exports, "IncrementPlanningSwimlaneHeaderContent", () => $965058dd007b0e46$export$df5dae817bb879);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $c781K = parcelRequire("c781K");

var $h8cgU = parcelRequire("h8cgU");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $ujWmd = parcelRequire("ujWmd");

var $dC5iT = parcelRequire("dC5iT");
var $bgrar = parcelRequire("bgrar");
var $5ILhZ = parcelRequire("5ILhZ");
var $8CUq3 = parcelRequire("8CUq3");

var $fuhQD = parcelRequire("fuhQD");

var $4R6GH = parcelRequire("4R6GH");

var $dCm1o = parcelRequire("dCm1o");

var $645AZ = parcelRequire("645AZ");

var $6h59K = parcelRequire("6h59K");
// These styles are unbounded as they use custom values not tokenised in the design system
const $965058dd007b0e46$var$unboundedStyles = {
    SwimlaneHeader: "_2rko1l7b _1pbycs5v _4t3i1ylp _ca0qv77o _19pk1i6y _otyrv77o _bfhkvuon _80omtlke _kqsw1if8",
    SwimlaneHeaderUnscheduled: "_154i1wqb _1ul91osq _p12f1osq",
    SwimlaneHeaderScheduled: "_154i1ylp _1ul9cv93 _p12f1ndm",
    SwimlaneNameText: "_1reo15vq _18m915vq _11c82smr _o5721q9c _1bto1l2s"
};
const $965058dd007b0e46$export$df5dae817bb879 = ({ id: id, name: name, collapsed: collapsed, onToggle: onToggle, values: values, iconImageUrl: iconImageUrl, innerRef: innerRef, customLeftContent: customLeftContent, customRightContent: customRightContent, top: top, isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, children: children })=>{
    const getTeamIcon = ()=>iconImageUrl ? /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
            size: "small",
            src: iconImageUrl
        }) : /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
            xcss: $965058dd007b0e46$var$TeamIconWrapperStyles
        }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($c781K))), {
            label: "",
            LEGACY_size: "small",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($h8cgU))),
            color: "var(--ds-icon, #44546F)"
        }));
    const getManagedTeamIcon = ()=>{
        if (values?.verified) return /*#__PURE__*/ $5uXOq.createElement((0, $fuhQD.VerifiedTeamIcon), {
            showTooltip: true
        });
        return null;
    };
    const renderChevronIcon = ()=>{
        if (collapsed) return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
            xcss: (0, $dCm1o.isVisualRefreshEnabled)() && $965058dd007b0e46$var$IconSpacing
        }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)",
            color: "var(--ds-icon, #44546F)",
            label: ""
        }));
        return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
            xcss: (0, $dCm1o.isVisualRefreshEnabled)() && $965058dd007b0e46$var$IconSpacing
        }, /*#__PURE__*/ $5uXOq.createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)",
            color: "var(--ds-icon, #44546F)",
            label: ""
        }));
    };
    const toggleColumns = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onToggle(event, analyticsEvent);
    }, [
        onToggle
    ]);
    return /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $965058dd007b0e46$var$SwimlaneWrapperStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            top: `${top}px`
        },
        ref: innerRef,
        testId: "portfolio-3-plan-increment-common.ui.swimlane-header-content.swimlane-wrapper"
    }, /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $965058dd007b0e46$var$unboundedStyles.SwimlaneHeader,
            isUnscheduledWorkColumnPanel && $965058dd007b0e46$var$unboundedStyles.SwimlaneHeaderUnscheduled,
            !isUnscheduledWorkColumnPanel && $965058dd007b0e46$var$unboundedStyles.SwimlaneHeaderScheduled
        ])
    }, /*#__PURE__*/ $5uXOq.createElement((0, $bgrar.default), {
        xcss: (0, $4R6GH.fg)('plans_managed_teams_indicator_program_enabled') ? $965058dd007b0e46$var$SwimlaneGridStyles : $965058dd007b0e46$var$SwimlaneGridStylesOld
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: $965058dd007b0e46$var$SwimlaneHeaderChevronTeamIconStyles
    }, renderChevronIcon(), " ", getTeamIcon()), /*#__PURE__*/ $5uXOq.createElement((0, $5ILhZ.default), {
        xcss: $965058dd007b0e46$var$SwimlaneHeaderToggleButtonStyles,
        onClick: toggleColumns,
        "aria-expanded": !collapsed,
        // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/no-imported-style-values
        style: {
            height: `${(0, $645AZ.swimlaneHeaderHeight)}px`
        }
    }, /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        testId: "portfolio-3-plan-increment-common.ui.swimlane-header-content.summary-section",
        xcss: $965058dd007b0e46$var$IncrementPlanningBoardSummaryWrapperStyle
    }, /*#__PURE__*/ $5uXOq.createElement("h1" // Use h1 here instead of Text primitive to support truncation on unscheduled work column
    , {
        // Due to accessibility ordering of headings we have to use a styled h1
        className: (0, $bwpsq.default)([
            $965058dd007b0e46$var$unboundedStyles.SwimlaneNameText
        ])
    }, name)), (0, $4R6GH.fg)('plans_managed_teams_indicator_program_enabled') && getManagedTeamIcon()), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('plans_managed_teams_indicator_program_enabled') ? $965058dd007b0e46$var$LeftContentStyles : $965058dd007b0e46$var$LeftContentStylesOld
    }, /*#__PURE__*/ $5uXOq.createElement((0, $6h59K.TeamLozenge), {
        id: id,
        values: values
    }), customLeftContent), /*#__PURE__*/ $5uXOq.createElement((0, $dC5iT.default), {
        xcss: (0, $4R6GH.fg)('plans_managed_teams_indicator_program_enabled') ? $965058dd007b0e46$var$RightContentStyles : $965058dd007b0e46$var$RightContentStylesOld
    }, customRightContent))), !collapsed && children);
};
const $965058dd007b0e46$var$SwimlaneGridStyles = (0, $8CUq3.xcss)({
    position: 'sticky',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, auto) minmax(0, auto) minmax(0, auto) 1fr',
    gridTemplateRows: '1fr',
    alignItems: 'center',
    width: '100%'
});
// delete this style when removing the "plans_managed_teams_indicator_program_enabled" feature gate
const $965058dd007b0e46$var$SwimlaneGridStylesOld = (0, $8CUq3.xcss)({
    position: 'sticky',
    display: 'grid',
    gridTemplateColumns: 'minmax(0, auto) minmax(0, auto) 1fr',
    gridTemplateRows: '1fr',
    alignItems: 'center',
    width: '100%'
});
const $965058dd007b0e46$var$SwimlaneHeaderToggleButtonStyles = (0, $8CUq3.xcss)({
    gridTemplateColumns: 'subgrid',
    display: 'grid',
    alignItems: 'center',
    gridColumn: '1/-1',
    gridRow: '1',
    position: 'relative',
    appearance: 'none',
    border: 'none',
    background: 'none',
    outline: 'none',
    gap: 'space.100',
    ':focus': {
        // @ts-expect-error We need a negative outline offset on the outline of the swimlane header when it's focused.
        outlineOffset: "var(--ds-space-negative-025, -2px)"
    }
});
const $965058dd007b0e46$var$SwimlaneHeaderChevronTeamIconStyles = (0, $8CUq3.xcss)({
    gridColumn: '1',
    gridRow: '1',
    display: 'flex',
    paddingLeft: 'space.050',
    gap: 'space.050',
    alignItems: 'center'
});
const $965058dd007b0e46$var$IncrementPlanningBoardSummaryWrapperStyle = (0, $8CUq3.xcss)({
    gridColumn: '2',
    minWidth: '0',
    display: 'block'
});
const $965058dd007b0e46$var$IconSpacing = (0, $8CUq3.xcss)({
    margin: 'space.050'
});
const $965058dd007b0e46$var$TeamIconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '24px',
    width: '24px',
    margin: 'space.025',
    borderRadius: '50%',
    backgroundColor: 'color.background.neutral'
});
const $965058dd007b0e46$var$SwimlaneWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    width: '100%'
});
const $965058dd007b0e46$var$LeftContentStyles = (0, $8CUq3.xcss)({
    gridColumn: '4',
    gridRow: '1',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 'space.150',
    gap: 'space.150'
});
// delete this style when removing the "plans_managed_teams_indicator_program_enabled" feature gate
const $965058dd007b0e46$var$LeftContentStylesOld = (0, $8CUq3.xcss)({
    gridColumn: '3',
    gridRow: '1',
    display: 'flex',
    alignItems: 'center',
    paddingLeft: 'space.150',
    gap: 'space.150'
});
const $965058dd007b0e46$var$RightContentStyles = (0, $8CUq3.xcss)({
    gridColumn: '5',
    gridRow: '1'
});
// delete this style when removing the "plans_managed_teams_indicator_program_enabled" feature gate
const $965058dd007b0e46$var$RightContentStylesOld = (0, $8CUq3.xcss)({
    gridColumn: '4',
    gridRow: '1'
});

});
parcelRegister("6h59K", function(module, exports) {

$parcel$export(module.exports, "TeamLozenge", () => $2e2979de02094f8d$export$f3039d328491b536);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $fVnbM = parcelRequire("fVnbM");

var $3bDjY = parcelRequire("3bDjY");

var $3u0c5 = parcelRequire("3u0c5");

var $koVbs = parcelRequire("koVbs");

var $1FeOe = parcelRequire("1FeOe");

var $4jAPy = parcelRequire("4jAPy");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $1lsFe = parcelRequire("1lsFe");
const $2e2979de02094f8d$export$f3039d328491b536 = ({ id: id, values: values })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (values && values.type === (0, $4jAPy.TEAM)) {
        const isExternal = !values.isPlanTeam;
        const isPlanOnly = (0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(values.externalId);
        const isTeamLessSwimlane = id === (0, $4jAPy.SWIMLANE_TEAMLESS) || id === (0, $bdYfL.appendUnscheduledWorkSwimlaneIdSuffix)((0, $4jAPy.SWIMLANE_TEAMLESS));
        const isKanban = values.planningStyle === (0, $4jAPy.KANBAN_TEAM);
        const lozengeContents = {
            external: {
                lozenge: (0, $1FeOe.default).externalLozenge,
                tooltipTitle: (0, $1FeOe.default).externalTeamTooltipTitle,
                tooltipContent: (0, $1FeOe.default).externalTeamTooltipContent,
                testId: 'software-board.board-container.board.swimlane.external'
            },
            planOnly: {
                lozenge: (0, $1FeOe.default).planOnlyLozenge,
                tooltipTitle: (0, $1FeOe.default).planOnlyTeamTooltipTitle,
                tooltipContent: (0, $1FeOe.default).planOnlyTeamTooltipContent,
                testId: 'software-board.board-container.board.swimlane.plan-only'
            },
            kanban: {
                lozenge: (0, $1FeOe.default).kanbanLozenge,
                tooltipTitle: undefined,
                tooltipContent: undefined,
                testId: 'software-board.board-container.board.swimlane.kanban'
            }
        };
        let lozengeContent;
        if (isExternal) lozengeContent = lozengeContents.external;
        else if (isKanban) lozengeContent = lozengeContents.kanban;
        else if (isPlanOnly && !isTeamLessSwimlane) lozengeContent = lozengeContents.planOnly;
        if (lozengeContent) {
            const { tooltipTitle: tooltipTitle, tooltipContent: tooltipContent, lozenge: lozenge, testId: testId } = lozengeContent;
            const lozengeComponent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
                testId: testId
            }, formatMessage(lozenge));
            if (tooltipTitle && tooltipContent) {
                const tooltip = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    padding: "space.100",
                    xcss: $2e2979de02094f8d$var$TeamTooltipStyles,
                    role: "tooltip"
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "p",
                    color: "inherit",
                    id: `${id}-tooltip`
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, formatMessage(tooltipTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "p"
                }, formatMessage(tooltipContent))));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: tooltip
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
                    spacing: "none",
                    "aria-label": formatMessage((0, $1lsFe.default).lozengeButtonLabel),
                    appearance: "subtle",
                    "aria-describedby": `${id}-tooltip`
                }, lozengeComponent));
            }
            return lozengeComponent;
        }
    }
    return null;
};
const $2e2979de02094f8d$var$TeamTooltipStyles = (0, $8CUq3.xcss)({
    textAlign: 'center'
});

});
parcelRegister("1FeOe", function(module, exports) {

$parcel$export(module.exports, "default", () => $c55bd7875b5fafe8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c55bd7875b5fafe8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    externalLozengeShort: {
        "id": "portfolio-3-plan-increment-common.external-lozenge-short",
        "defaultMessage": "EXT"
    },
    externalLozenge: {
        "id": "portfolio-3-plan-increment-common.external-lozenge",
        "defaultMessage": "EXTERNAL"
    },
    externalTeamTooltipTitle: {
        "id": "portfolio-3-plan-increment-common.external-team-tooltip-title",
        "defaultMessage": "Team currently not in this plan"
    },
    externalTeamTooltipContent: {
        "id": "portfolio-3-plan-increment-common.external-team-tooltip-content",
        "defaultMessage": "This team isn't included in your plan, but has issues assigned to it."
    },
    planOnlyLozenge: {
        "id": "portfolio-3-plan-increment-common.plan-only-lozenge",
        "defaultMessage": "PLAN-ONLY"
    },
    planOnlyTeamTooltipTitle: {
        "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-title",
        "defaultMessage": "Plan-only team"
    },
    planOnlyTeamTooltipContent: {
        "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-content",
        "defaultMessage": "A plan-only team can only be used within this plan. It won't appear in JQL filters or on your issue screens."
    },
    kanbanLozenge: {
        "id": "portfolio-3-plan-increment-common.kanban-lozenge",
        "defaultMessage": "KANBAN"
    },
    weeksOption: {
        "id": "portfolio-3-plan-increment-common.weeks-option",
        "defaultMessage": "{count} {count, plural, one {week} other {weeks}}"
    },
    externalTeamTooltipContentIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.external-team-tooltip-content-issue-term-refresh",
        "defaultMessage": "This team isn\u2019t included in your plan, but has work assigned to it."
    },
    planOnlyTeamTooltipContentIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.plan-only-team-tooltip-content-issue-term-refresh",
        "defaultMessage": "A plan-only team can only be used within this plan. It won\u2019t appear in JQL filters or on your work items."
    }
});

});

parcelRegister("1lsFe", function(module, exports) {

$parcel$export(module.exports, "default", () => $9479ce934c9556eb$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9479ce934c9556eb$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    lozengeButtonLabel: {
        "id": "software.main.board-container.board.swimlane.increment-planning-swimlane-content.lozenge-button-label",
        "defaultMessage": "More info about team details"
    }
});

});



parcelRegister("2FiSG", function(module, exports) {

$parcel$export(module.exports, "default", () => $a30dd9a5687ac795$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $gccSB = parcelRequire("gccSB");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $igBVO = parcelRequire("igBVO");

var $e4yMr = parcelRequire("e4yMr");

var $dS3PR = parcelRequire("dS3PR");

var $6s1PB = parcelRequire("6s1PB");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $8zOmE = parcelRequire("8zOmE");

var $jbAX5 = parcelRequire("jbAX5");

var $67sX6 = parcelRequire("67sX6");

var $cPGP0 = parcelRequire("cPGP0");

var $9yiQF = parcelRequire("9yiQF");
const $a30dd9a5687ac795$var$SprintAssociationButton = ({ teamId: teamId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const team = (0, $67sX6.useBoardSelector)((0, $cPGP0.getTeamById))(teamId);
    const isAssociated = team?.sprintByIterationId && Object.keys(team?.sprintByIterationId).length > 0;
    const onClickHandler = (0, $5uXOq.useCallback)((e)=>{
        // stop the click event bubble to prevent triggering the collapse of the swimlane header
        e.stopPropagation();
        dispatch((0, $jbAX5.openTeamAssociationModal)(teamId));
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'syncSprints', {
            mode: isAssociated ? 'change' : 'add'
        });
    }, [
        createAnalyticsEvent,
        isAssociated,
        dispatch,
        teamId
    ]);
    const onEnterHandler = (0, $5uXOq.useCallback)((e)=>{
        // stop the key enter event bubble to prevent triggering the collapse of the swimlane header
        if (e.key === 'Enter') onClickHandler(e);
    }, [
        onClickHandler
    ]); /**
                         * Not showing for
                         * -- Unassigned swimlane
                         * -- External teams (means outside of the plan)
                         * -- Kanban teams
                         * -- Undefined team - happens after a scenario team is committed to Jira
                         */ 
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(teamId) || teamId === (0, $4jAPy.SWIMLANE_TEAMLESS) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(team) || !team.isPlanTeam || team.planningStyle === (0, $4jAPy.KANBAN_TEAM)) return null;
     // check if the team is a scenario added plan-only team, we will revisit the logic for the sceanrio TWP team in https://hello.jira.atlassian.cloud/browse/JPO-28308
    if ((0, $bdYfL.isScenarioPlanonlyTeamCheck)(teamId)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p",
        color: "color.text.subtlest"
    }, formatMessage((0, $9yiQF.default).scenarioTeamWarning, {
        strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
                as: "strong"
            }, chunks)
    }));
    if (team.issueSourceType === null) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        as: "p",
        color: "color.text.subtlest"
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9yiQF.default).noIssueSourceWarningIssueTermRefresh : (0, $9yiQF.default).noIssueSourceWarning));
    if (team.planningStyle === (0, $4jAPy.SCRUM_TEAM) && team.issueSourceType !== (0, $4jAPy.BOARD_ISSUE_SOURCE)) {
        const helpOnClick = (e)=>{
            // stop the click event bubble to prevent triggering the collapse of the swimlane header
            e.stopPropagation();
        };
        const helpOnEnter = (e)=>{
            // stop the key enter event bubble to prevent triggering the collapse of the swimlane header
            if (e.key === 'Enter') e.stopPropagation();
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
            as: "p",
            color: "color.text.subtlest"
        }, formatMessage((0, $9yiQF.default).nonBoardTeamWarning, {
            link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
                    articleId: (0, $4jAPy.IPH_IDS).CAPACITY_PLANNING,
                    appearance: "link",
                    spacing: "none",
                    fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                        href: (0, $4jAPy.DOC_LINKS).CAPACITY_PLANNING,
                        target: "_blank"
                    }, chunks),
                    onClick: helpOnClick,
                    onKeyDown: helpOnEnter
                }, chunks)
        }));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        testId: "software-board.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.button",
        onClick: onClickHandler,
        onKeyDown: onEnterHandler,
        appearance: "subtle",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($igBVO))), {
            label: "",
            LEGACY_primaryColor: "var(--ds-text-subtle, #44546F)",
            color: "var(--ds-icon, #44546F)"
        })
    }, formatMessage(isAssociated ? (0, $9yiQF.default).changeSprints : (0, $9yiQF.default).addSprints));
};
var $a30dd9a5687ac795$export$2e2bcd8739ae039 = $a30dd9a5687ac795$var$SprintAssociationButton;

});
parcelRegister("9yiQF", function(module, exports) {

$parcel$export(module.exports, "default", () => $2313818b2a3c2e15$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2313818b2a3c2e15$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noIssueSourceWarning: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.no-issue-source-warning",
        "defaultMessage": "Associate this team with an issue source to view its iterations"
    },
    scenarioTeamWarning: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.scenario-team-warning",
        "defaultMessage": "Save this team using the <strong>Review changes</strong> button to view their capacity"
    },
    nonBoardTeamWarning: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.non-board-team-warning",
        "defaultMessage": "To plan with this team's sprints, <link>make sure your plan is setup for capacity planning.</link>"
    },
    changeSprints: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.change-sprints",
        "defaultMessage": "Change sprints"
    },
    addSprints: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.add-sprints",
        "defaultMessage": "Add sprints"
    },
    noIssueSourceWarningIssueTermRefresh: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.sprint-association-btn.no-issue-source-warning-issue-term-refresh",
        "defaultMessage": "Associate this team with a work item source to view its iterations"
    }
});

});


parcelRegister("ebF5k", function(module, exports) {

$parcel$export(module.exports, "default", () => $d3e910274f5cdf85$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $dZbEw = parcelRequire("dZbEw");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $2f454 = parcelRequire("2f454");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $9UXXB = parcelRequire("9UXXB");

var $4jZ56 = parcelRequire("4jZ56");

var $7qhY9 = parcelRequire("7qhY9");
const $d3e910274f5cdf85$var$CreateUnscheduledIssueButton = ({ teamId: teamId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const isCollapsed = (0, $67sX6.useBoardSelector)((state)=>(0, $4jZ56.isSwimlaneCollapsed)(state, teamId));
    const isOpen = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.isUnscheduledColumnICCOpen)(state, teamId, (0, $5rFbt.UNSCHEDULED_COLUMN_ID)));
    const isIccEnabled = (0, $67sX6.useBoardSelector)((state)=>(0, $9UXXB.isIccEnabledForColumnOrSwimlane)(state, teamId, (0, $5rFbt.UNSCHEDULED_COLUMN_ID)));
    const onClick = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $2f454.initiateIccInUnscheduledColumn)(teamId, isCollapsed));
    }, [
        dispatch,
        teamId,
        isCollapsed
    ]);
    if (!isIccEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        spacing: "compact",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))),
        label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7qhY9.default).labelIssueTermRefresh : (0, $7qhY9.default).label),
        isTooltipDisabled: false,
        onClick: onClick,
        isDisabled: !isCollapsed && isOpen
    });
};
var $d3e910274f5cdf85$export$2e2bcd8739ae039 = $d3e910274f5cdf85$var$CreateUnscheduledIssueButton;

});
parcelRegister("7qhY9", function(module, exports) {

$parcel$export(module.exports, "default", () => $5500bb8b1d4ce0f5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5500bb8b1d4ce0f5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.create-unscheduled-issue-button.label",
        "defaultMessage": "Create issue"
    },
    labelIssueTermRefresh: {
        "id": "software.main.board-container.board.swimlane.increment-planning-buttons.create-unscheduled-issue-button.label-issue-term-refresh",
        "defaultMessage": "Create work item"
    }
});

});



parcelRegister("hASys", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3a9b932b2e638b8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $gJBT6 = parcelRequire("gJBT6");

var $8QpSo = parcelRequire("8QpSo");

var $ujWmd = parcelRequire("ujWmd");

var $dOvpK = parcelRequire("dOvpK");

var $5rFbt = parcelRequire("5rFbt");

var $6s1PB = parcelRequire("6s1PB");

var $az4zD = parcelRequire("az4zD");

var $eQFsF = parcelRequire("eQFsF");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");

var $bC2fB = parcelRequire("bC2fB");

var $iuuJH = parcelRequire("iuuJH");

var $c79wa = parcelRequire("c79wa");

var $dW1HX = parcelRequire("dW1HX");

var $k50Aq = parcelRequire("k50Aq");

var $fyeGd = parcelRequire("fyeGd");

var $bSSdD = parcelRequire("bSSdD");

var $d2i8f = parcelRequire("d2i8f");

var $36pz7 = parcelRequire("36pz7");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $7xi98 = parcelRequire("7xi98");
const $b3a9b932b2e638b8$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((boardId, projectId)=>({
        boardId: boardId,
        projectId: projectId
    }), (boardId, projectId)=>`${boardId}.${projectId}`);
const $b3a9b932b2e638b8$var$getIcon = (isCMPBoard, swimlaneMode, imageUrl)=>{
    if (!imageUrl) return null;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_ASSIGNEE_UNASSIGNED_FIRST).id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        size: "small",
        src: imageUrl,
        name: ""
    });
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id || swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3a9b932b2e638b8$var$IssueTypeIcon, {
        src: imageUrl,
        alt: ""
    });
    if (isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3a9b932b2e638b8$var$ProjectIcon, {
        src: imageUrl,
        alt: ""
    });
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_REQUEST_TYPE).id) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b3a9b932b2e638b8$var$RequestTypeIcon, {
        src: imageUrl,
        alt: ""
    });
    return null;
};
const $b3a9b932b2e638b8$var$SPOTLIGHT_TARGET_ID = 'board-swimlane-header';
const $b3a9b932b2e638b8$export$daa269000985481c = (message, intl, swimlaneMode, state)=>{
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) return intl.formatMessage(message, {
        issueParentTypeName: (0, $bSSdD.firstParentIssueTypeNameSelector)(state)
    });
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return intl.formatMessage(message);
    return intl.formatMessage(message);
};
const $b3a9b932b2e638b8$export$3b1d11829730098 = (state, mode, issueId)=>{
    if (mode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id) {
        const swimlaneHeaderIssue = (0, $bSSdD.getIssueParents)(state)[issueId];
        return swimlaneHeaderIssue && swimlaneHeaderIssue.status ? swimlaneHeaderIssue.status : null;
    } // In CMP Kanplan, in a case of parent task in plan board but its subtasks in kanban board
    // when grouping by stories, swimlane header should look up in the the parent tasks (aka missing parent)
    if ((0, $67Z81.getIsCMPBoard)(state) && mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) {
        const swimlaneHeaderMissingParent = (0, $67Z81.getMissingParents)(state)[Number(issueId)];
        if (swimlaneHeaderMissingParent) return swimlaneHeaderMissingParent.status;
    }
    const swimlaneHeaderIssue = (0, $67Z81.getIssues)(state)[issueId]; // Fetch the column that contains the given statusId
    const swimlaneHeaderIssueColumn = swimlaneHeaderIssue && swimlaneHeaderIssue.statusId ? // @ts-expect-error - TS2554 - Expected 1 arguments, but got 2.
    (0, $fyeGd.columnByStatusIdSelector)(state, swimlaneHeaderIssue.statusId) : null; // Get the status for the swimlane header issue
    return (swimlaneHeaderIssueColumn && swimlaneHeaderIssueColumn.type === (0, $5rFbt.ColumnType).STATUS ? swimlaneHeaderIssueColumn.statuses : []).find((status)=>swimlaneHeaderIssue && status.id === swimlaneHeaderIssue.statusId) || null;
};
const $b3a9b932b2e638b8$export$280bd66a9186f8d5 = (swimlaneId, mode, intl)=>{
    if (mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && swimlaneId === (0, $iuuJH.SWIMLANE_CHILDLESS)) return intl.formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $7xi98.default).childlessTooltipIssueTermRefresh : (0, $7xi98.default).childlessTooltip);
    return null;
};
const $b3a9b932b2e638b8$export$c31df4bd766f9c35 = ()=>{
    // memoization is used instead of weak map due to keys being potentially null
    const getIconFactory = (0, $8QpSo.default)((swimlaneMode, imageUrl, isCMPBoard)=>$b3a9b932b2e638b8$var$getIcon(isCMPBoard, swimlaneMode, imageUrl));
    const issueParentFactory = (0, $8QpSo.default)((issueParent)=>issueParent ? {
            summary: issueParent.summary,
            color: issueParent.color
        } : null);
    const assigneeFactory = (0, $8QpSo.default)((assignee)=>assignee ? {
            avatarUrl: assignee.avatarUrl,
            name: assignee.displayName
        } : null);
    return (state, ownProps)=>{
        const { intl: intl } = ownProps;
        const { imageUrl: imageUrl, name: name, message: message, cardAmount: cardAmount, issueKey: issueKey, mode: mode, assigneeAccountId: assigneeAccountId, projectKey: projectKey, isFlagged: isFlagged } = (0, $5mTgl.platformSwimlaneSelector)(state)(ownProps.id) || {};
        const swimlaneMode = (0, $45cXl.getSwimlaneMode)(state);
        const isSwimlaneHeaderClickable = mode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id || mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id || mode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id;
        const issuesWithoutSwimlaneHeaderName = message ? $b3a9b932b2e638b8$export$daa269000985481c(message, intl, swimlaneMode, state) : null;
        const getParent = (0, $5mTgl.makeGetIssueParentForSwimlaneHeader)(state);
        const issueParent = getParent(ownProps.id);
        const assignee = mode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && assigneeAccountId ? (0, $36pz7.getPerson)(state, assigneeAccountId) : null;
        const issueStatus = $b3a9b932b2e638b8$export$3b1d11829730098(state, mode, ownProps.id);
        const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state); // isDone here is used by the Swimlane component to show issue key strikethrough i.e. indicate issue resolution.
        // Moving away from `isSwimlaneBySubtaskParentDoneSelector` as it's very specific to covering all the edge cases required to correctly show the "Move to Done" button. It incorrectly strikethroughs issues when the issue is not resolved.
        // This change will also strikethrough here correctly for TMP (which previously we weren't doing at all).
        const isDone = (0, $d2i8f.isDoneIssueSelector)(state)(ownProps.id);
        const icon = getIconFactory(swimlaneMode, imageUrl, isCMPBoard);
        return {
            icon: icon,
            spotlightTargetId: ownProps.isFirstSwimlane && mode === (0, $iuuJH.SWIMLANE_BY_PARENT_ISSUE).id ? $b3a9b932b2e638b8$var$SPOTLIGHT_TARGET_ID : '',
            name: name || issuesWithoutSwimlaneHeaderName,
            // Don't show card amount for increment planning board
            showCardAmount: true,
            cardAmount: cardAmount,
            issueKey: issueKey,
            issueStatus: issueStatus,
            isSwimlaneHeaderClickable: isSwimlaneHeaderClickable,
            collapsed: (0, $4jZ56.isSwimlaneCollapsed)(state, ownProps.id),
            externalId: 'software.board.swimlane',
            externalValues: $b3a9b932b2e638b8$var$getExternalValues((0, $67Z81.rapidViewIdSelector)(state), (0, $67Z81.projectIdSelector)(state)),
            swimlaneMode: swimlaneMode,
            issueParent: issueParentFactory(issueParent),
            assignee: assigneeFactory(assignee),
            summaryTooltip: $b3a9b932b2e638b8$export$280bd66a9186f8d5(ownProps.id, swimlaneMode, intl),
            isSubtask: swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id && ownProps.id !== (0, $c79wa.ChildlessSwimlane).id,
            link: isCMPBoard && swimlaneMode === (0, $iuuJH.SWIMLANE_BY_PROJECT).id && projectKey ? `/browse/${projectKey}` : undefined,
            projectKey: projectKey,
            isFlagged: isFlagged,
            isDone: isDone,
            customRightContent: ownProps.customRightContent
        };
    };
};
const $b3a9b932b2e638b8$var$mapDispatchToProps = {
    swimlaneToggle: $k50Aq.swimlaneToggle,
    openIssueModal: $dW1HX.openIssueModal
};
const $b3a9b932b2e638b8$var$onClickFactory = (0, $8QpSo.default)((issueKey, dispatchPropsOpenIssueModal, swimlaneMode)=>(analyticsEvent)=>{
        if (issueKey) dispatchPropsOpenIssueModal(issueKey);
        (0, $dOvpK.fireUiAnalytics)(analyticsEvent, {
            name: 'board',
            attributes: {
                swimlaneMode: swimlaneMode
            }
        });
    });
const $b3a9b932b2e638b8$var$onToggleFactory = (0, $8QpSo.default)((dispatchPropsWwimlaneToggle, id)=>(event, analyticsEvent)=>{
        dispatchPropsWwimlaneToggle(id);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'boardSwimlaneBar');
    });
const $b3a9b932b2e638b8$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>({
        children: ownProps.children,
        wrapperStyle: ownProps.wrapperStyle,
        innerRef: ownProps.innerRef,
        ...stateProps,
        onClick: $b3a9b932b2e638b8$var$onClickFactory(stateProps.issueKey, dispatchProps.openIssueModal, stateProps.swimlaneMode),
        onToggle: $b3a9b932b2e638b8$var$onToggleFactory(dispatchProps.swimlaneToggle, ownProps.id),
        isMatrixLayout: ownProps.isMatrixLayout,
        isThemed: ownProps.isThemed
    });
var $b3a9b932b2e638b8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $2OMDV.AnalyticsEventToProps)('swimlaneBar', {
    onToggle: 'toggled'
}), (0, $bC2fB.connect)($b3a9b932b2e638b8$export$c31df4bd766f9c35, $b3a9b932b2e638b8$var$mapDispatchToProps, $b3a9b932b2e638b8$export$9d1611c77c2fe928), (0, $az4zD.injectIntlV2))((0, $eQFsF.default));
const $b3a9b932b2e638b8$var$IssueTypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob _4t3i1k92",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a9b932b2e638b8$var$ProjectIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _s7n4nkob _1bsbgktf _4t3igktf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b3a9b932b2e638b8$var$RequestTypeIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_s7n4nkob _4t3if6fq",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eQFsF", function(module, exports) {

$parcel$export(module.exports, "default", () => $4cb655d4a4e9962b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $jZ4fr = parcelRequire("jZ4fr");

var $fW62l = parcelRequire("fW62l");

var $ujWmd = parcelRequire("ujWmd");

var $9ADwJ = parcelRequire("9ADwJ");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $iyN9w = parcelRequire("iyN9w");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $3u0c5 = parcelRequire("3u0c5");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $dqoiX = parcelRequire("dqoiX");

var $8oe80 = parcelRequire("8oe80");

var $gULOk = parcelRequire("gULOk");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $az4zD = parcelRequire("az4zD");

var $7SCny = parcelRequire("7SCny");

var $iHPnC = parcelRequire("iHPnC");

var $k3Hho = parcelRequire("k3Hho");

var $dCm1o = parcelRequire("dCm1o");

var $hjSul = parcelRequire("hjSul");

var $6cG4N = parcelRequire("6cG4N");

var $lmBAt = parcelRequire("lmBAt");

var $cSD7y = parcelRequire("cSD7y");

var $645AZ = parcelRequire("645AZ");

var $agZSd = parcelRequire("agZSd");

var $ijnF0 = parcelRequire("ijnF0");

var $eF5Y9 = parcelRequire("eF5Y9");

var $04c3l = parcelRequire("04c3l");
const $4cb655d4a4e9962b$var$AVATAR_BORDER_COLOR = 'transparent';
const $4cb655d4a4e9962b$var$LOZENGE_THEMES = (0, $iHPnC.transformColorToTheme)((colorSchema)=>colorSchema.textBackground);
const $4cb655d4a4e9962b$var$Wrapper = ({ children: children, isMatrixLayout: isMatrixLayout })=>{
    if (isMatrixLayout) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: // eslint-disable-next-line no-nested-ternary
        (0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? $4cb655d4a4e9962b$var$innerWrapperStylesM2Themed.root : (0, $lmBAt.getIsSoftwareThemingEnabled)() ? $4cb655d4a4e9962b$var$innerWrapperStyles.root : $4cb655d4a4e9962b$var$innerWrapperStylesOld.root
    }, children);
    return children;
};
const $4cb655d4a4e9962b$var$getLozengeThemeByColor = (color)=>// This uses schema from src/packages/issue/epic-color/src/common/constants.js
    $4cb655d4a4e9962b$var$LOZENGE_THEMES[color] || $4cb655d4a4e9962b$var$LOZENGE_THEMES[0, $7SCny.PURPLE]; // eslint-disable-next-line jira/react/no-class-components
class $4cb655d4a4e9962b$var$Swimlane extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            issueKey: null,
            issueParent: null,
            issueStatus: null,
            isSwimlaneHeaderClickable: false,
            collapsed: false,
            spotlightTargetId: '',
            assignee: null,
            icon: null,
            customSwimlaneContent: null,
            customRightContent: null,
            summaryTooltip: null,
            onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isSubtask: false,
            link: undefined,
            projectKey: undefined,
            isFlagged: false,
            isDone: false,
            wrapperStyles: {},
            lozenge: null,
            showCardAmount: true,
            isUnscheduledWorkColumnPanel: false,
            isMatrixLayout: false
        };
    }
    getSwimlaneContent() {
        const { intl: { formatMessage: formatMessage }, showCardAmount: showCardAmount, cardAmount: cardAmount, icon: icon, name: name, collapsed: collapsed, isSwimlaneHeaderClickable: isSwimlaneHeaderClickable, issueKey: issueKey, issueParent: issueParent, issueStatus: issueStatus, assignee: assignee, customSwimlaneContent: customSwimlaneContent, summaryTooltip: summaryTooltip, isSubtask: isSubtask, link: link, projectKey: projectKey, isFlagged: isFlagged, isDone: isDone, lozenge: lozenge, swimlaneMode: swimlaneMode, customLeftContent: customLeftContent, isThemed: isThemed } = this.props;
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(customSwimlaneContent)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, customSwimlaneContent);
        const issueCountMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $eF5Y9.default).issueCountIssueTermRefresh : (0, $eF5Y9.default).issueCount;
        const cardsAmountLabel = showCardAmount ? formatMessage(isSubtask ? (0, $eF5Y9.default).subtaskCount : issueCountMessage, {
            count: cardAmount || 0
        }) : null;
        const summary = projectKey ? `${name} (${projectKey})` : name;
        const swimlaneHeaderContentId = `boardkit-swimlane-header-${issueKey}`;
        const oldHeaderContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (icon || issueParent && swimlaneMode) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            alignItems: "center",
            gap: "space.050"
        }, icon, issueParent && swimlaneMode === 'SWIMLANE_BY_PARENT_ISSUE' && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: issueParent.summary
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$ColorBox, {
            color: $4cb655d4a4e9962b$var$getLozengeThemeByColor(issueParent.color)
        }))), issueKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k3Hho.CardKey), {
            text: issueKey,
            stopEventPropagation: false,
            isDone: isDone
        }), summaryTooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: summaryTooltip,
            "data-testid": "platform-board-kit.ui.swimlane.tooltip"
        }, isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: (0, $4R6GH.fg)('jira_theming_milestone_1_improvements') ? $4cb655d4a4e9962b$var$summarySectionStyles : $4cb655d4a4e9962b$var$summarySectionStylesOld,
            testId: "platform-board-kit.ui.swimlane.summary-section"
        }, summary) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SummarySection, {
            "data-testid": "platform-board-kit.ui.swimlane.summary-section"
        }, summary)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $04c3l.TruncatedTooltip), {
            content: summary
        }, ({ ref: ref })=>isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: (0, $4R6GH.fg)('jira_theming_milestone_1_improvements') ? $4cb655d4a4e9962b$var$summarySectionStyles : $4cb655d4a4e9962b$var$summarySectionStylesOld,
                ref: ref,
                testId: "platform-board-kit.ui.swimlane.summary-section"
            }, summary) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SummarySection, {
                ref: ref,
                "data-testid": "platform-board-kit.ui.swimlane.summary-section"
            }, summary)), lozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$LozengeWrapper, null, lozenge), customLeftContent, showCardAmount && (isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4cb655d4a4e9962b$var$swimlaneIssuesAmountStyles
        }, `(${cardsAmountLabel})`) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneIssuesAmount, null, `(${cardsAmountLabel})`)), swimlaneMode !== 'SWIMLANE_BY_PARENT_ISSUE' && issueParent && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijnF0.default), {
            color: issueParent.color
        }, issueParent.summary), issueStatus && (issueStatus.name || '').toString().length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$StatusSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), null, formatMessage((0, $eF5Y9.default).statusLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: issueStatus.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
            appearance: (0, $agZSd.getLozengeAppearanceByStatus)(issueStatus && issueStatus.category ? issueStatus.category : (0, $gULOk.UNDEFINED)),
            testId: "platform-board-kit.ui.swimlane.lozenge",
            isBold: (0, $dCm1o.isVisualRefreshEnabled)()
        }, issueStatus.name))), isFlagged && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($9ADwJ))), {
            label: formatMessage((0, $eF5Y9.default).flagged),
            color: "var(--ds-icon-danger, #C9372C)",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyN9w))),
            LEGACY_primaryColor: "var(--ds-icon-danger, #C9372C)",
            LEGACY_size: "small"
        }), assignee && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$AvatarWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: assignee.name
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
            src: assignee.avatarUrl,
            name: assignee.name,
            size: "small",
            borderColor: $4cb655d4a4e9962b$var$AVATAR_BORDER_COLOR
        }))));
        const headerContent = (0, $4R6GH.fg)('tanuki_a11y_q4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            id: swimlaneHeaderContentId,
            className: (0, $bwpsq.default)([
                $4cb655d4a4e9962b$var$headerContentStyles.root
            ])
        }, oldHeaderContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            gap: "space.100",
            alignItems: "center",
            xcss: $4cb655d4a4e9962b$var$oldheaderContentStyles
        }, oldHeaderContent);
        const handleHeaderKeydownHandler = (event)=>{
            if (event.code === 'Enter' || event.code === 'Space') {
                event.preventDefault();
                this.onLinkClick(event, undefined);
            }
        };
        const renderHeader = ()=>{
            if (isSwimlaneHeaderClickable) {
                if (issueKey) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$LinkButtonWithAnalytics, {
                    "data-testid": "platform-board-kit.ui.swimlane.link-button",
                    onClick: this.onLinkClick
                }, (0, $4R6GH.fg)('tanuki_a11y_q4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    "aria-labelledby": swimlaneHeaderContentId,
                    xcss: $4cb655d4a4e9962b$var$swimlaneContentWrapper.pseudo,
                    role: "button",
                    onClick: this.onLinkClick,
                    tabIndex: 0,
                    onKeyDown: handleHeaderKeydownHandler
                }), headerContent);
                if (link) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$LinkWithAnalytics, {
                    href: link,
                    onClick: this.onLinkClick,
                    onKeyDown: this.onSwimlaneHeaderKeyDown
                }, headerContent);
            }
            return headerContent;
        };
        const renderChevronIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: [
                    (0, $dCm1o.isVisualRefreshEnabled)() && $4cb655d4a4e9962b$var$iconSpacing
                ]
            }, collapsed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
                LEGACY_primaryColor: "var(--ds-icon, #44546F)",
                color: "var(--ds-icon, #44546F)",
                label: ""
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
                LEGACY_primaryColor: "var(--ds-icon, #44546F)",
                color: "var(--ds-icon, #44546F)",
                label: ""
            }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneContent, {
            onClick: this.toggleColumns,
            "data-testid": "platform-board-kit.ui.swimlane.swimlane-content",
            ...!(0, $4R6GH.fg)('tanuki_a11y_q4') ? {
                role: 'button',
                tabIndex: 0,
                onKeyDown: this.onKeyDown,
                'aria-expanded': !collapsed,
                'aria-labelledby': swimlaneHeaderContentId
            } : {},
            className: (0, $bwpsq.default)([
                $4cb655d4a4e9962b$var$swimlaneContentWrapper.root
            ])
        }, (0, $4R6GH.fg)('tanuki_a11y_q4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4cb655d4a4e9962b$var$swimlaneContentWrapper.pseudo,
            role: "button",
            onClick: this.toggleColumns,
            tabIndex: 0,
            onKeyDown: this.onKeyDown,
            "aria-expanded": !collapsed,
            "aria-labelledby": swimlaneHeaderContentId,
            testId: "platform-board-kit.ui.swimlane.swimlane-content-pseudo"
        }), renderChevronIcon(), renderHeader());
    }
    render() {
        const { children: children, collapsed: collapsed, wrapperStyle: wrapperStyle, innerRef: innerRef, isMatrixLayout: isMatrixLayout } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "platform-board-kit.ui.swimlane.swimlane-wrapper" // eslint-disable-next-line jira/react/no-style-attribute, @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
            ,
            style: wrapperStyle,
            ref: innerRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$Wrapper, {
            isMatrixLayout: isMatrixLayout
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneShadow, {
            isSoftwareThemingEnabled: (0, $lmBAt.getIsSoftwareThemingEnabled)()
        }), (0, $lmBAt.getIsSoftwareThemingEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            className: (0, $bwpsq.default)([
                "_1e0c1ule _bfhkdhxl _4t3iyh40 _kqswh2mm _154i1ylp _1pbycs5v _lcxvglyw _19pk1i6y _2hwxidpf _otyridpf _18u0idpf"
            ])
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneShadowMaskOld, null)), this.renderSwimlaneBar(), !collapsed && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            testId: "platform-board-kit.ui.swimlane.swimlane-columns"
        }, children)));
    }
    constructor(...args){
        super(...args), this.onKeyDown = (event)=>{
            if ((event.code === 'Enter' || event.code === 'Space') && (0, $4R6GH.fg)('tanuki_a11y_q4')) {
                event.preventDefault(); // Just like toggleColumns, this is always undefined since the emitting element never has a UIAnalyticsEvent
                this.props.onToggle(undefined);
            } else if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
                event.preventDefault(); // Just like toggleColumns, this is always undefined since the emitting element never has a UIAnalyticsEvent
                this.props.onToggle(undefined);
            }
        }, this.onSwimlaneHeaderKeyDown = (event, analyticsEvent)=>{
            if ((event.code === 'Enter' || event.code === 'Space') && (0, $4R6GH.fg)('tanuki_a11y_q4')) {
                event.preventDefault();
                this.onLinkClick(event, undefined);
            } else if (event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('enter') || event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('space')) {
                event.preventDefault();
                this.onLinkClick(event, analyticsEvent);
            }
        }, this.onLinkClick = (e, analyticsEvent)=>{
            e.stopPropagation();
            this.props.onClick(analyticsEvent);
        }, this.toggleColumns = (_)=>{
            // TODO: Remove this comment post fg/tanuki_a11y_q4 clean up
            // I've confirmed that this analytic event is always undefined since emitting element never has a UIAnalyticsEvent
            this.props.onToggle(undefined);
        }, this.renderSwimlaneInner = ()=>{
            const { isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, spotlightTargetId: spotlightTargetId, customRightContent: customRightContent } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                testId: "platform-board-kit.ui.swimlane.swimlane-inner",
                xcss: [
                    $4cb655d4a4e9962b$var$SwimlaneInnerStyles,
                    isUnscheduledWorkColumnPanel && $4cb655d4a4e9962b$var$SwimlaneInnerSingleColumnWidthStyles,
                    !isUnscheduledWorkColumnPanel && $4cb655d4a4e9962b$var$SwimlaneInnerFullWidthStyles
                ]
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
                name: spotlightTargetId
            }, this.getSwimlaneContent()), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
                engagementId: spotlightTargetId
            }), Boolean(customRightContent) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4cb655d4a4e9962b$var$SwimlaneRightContentContainer, null, customRightContent));
        }, this.renderSwimlaneBar = ()=>{
            const { isUnscheduledWorkColumnPanel: isUnscheduledWorkColumnPanel, isThemed: isThemed } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                className: (0, $bwpsq.default)([
                    "_1e0c1txw _4cvr1h6o _80omtlke _kqsw1if8 _1pbycs5v _ca0qv77o _4t3i10mc _19pk1i6y _otyrv77o _154i9h4j _nt751r31 _49pcglyw _1hvw1o36 _7ehi64oc",
                    isUnscheduledWorkColumnPanel && "_154i1wqb",
                    isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? "_bfhkdhxl _otyrn7od" : "_2rko1l7b _bfhkvuon"
                ]),
                style: {
                    "--_1scwsif": (0, $lD23V.default)((0, $lmBAt.getIsSoftwareThemingM2Enabled)() ? 0 : `${$4cb655d4a4e9962b$var$headerHeight}px`)
                }
            }, this.renderSwimlaneInner());
        };
    }
}
var $4cb655d4a4e9962b$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($4cb655d4a4e9962b$var$Swimlane);
const $4cb655d4a4e9962b$var$swimlaneShadowSize = 2;
const $4cb655d4a4e9962b$var$headerHeight = (0, $645AZ.swimlaneHeaderHeight);
const $4cb655d4a4e9962b$var$innerWrapperStylesOld = {
    root: "_2rkoi2wt _bfhkvuon _otyru2gc _n3td1b66"
};
const $4cb655d4a4e9962b$var$innerWrapperStyles = {
    root: "_2rkoi2wt _bfhkdhxl _otyru2gc _n3td1b66"
};
const $4cb655d4a4e9962b$var$innerWrapperStylesM2Themed = {
    root: "_2rkoi2wt _bfhkdhxl _otyru2gc _19bv1b66 _u5f31b66 _n3td1b66"
}; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1e0c116y _1ul9idpf _4cvr1h6o _18u0v77o _p12f1osq",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$SwimlaneInnerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    gap: 'space.100',
    alignItems: 'center',
    flex: 1
});
const $4cb655d4a4e9962b$var$SwimlaneInnerSingleColumnWidthStyles = (0, $8CUq3.xcss)({
    minWidth: '100%',
    maxWidth: '100%'
});
const $4cb655d4a4e9962b$var$SwimlaneInnerFullWidthStyles = (0, $8CUq3.xcss)({
    // So things dont overlap on smaller screens
    minWidth: '700px',
    maxWidth: `min(100%, calc(var(--board-scroll-element-width, 2000) * 1px - ${"var(--ds-space-500, 40px)"})`
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $4cb655d4a4e9962b$var$SwimlaneShadow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSoftwareThemingEnabled: isSoftwareThemingEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _bfhk10xm _tzy4sxj9 _4t3iyh40 _kqsw1if8 _154iys9h _1pbycs5v _lcxvglyw",
            __cmplp.isSoftwareThemingEnabled ? "_2hwx12x7" : "_18s81cy0",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneShadowMaskOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1ule _bfhkvuon _4t3iyh40 _kqswh2mm _154i1ylp _1pbycs5v _lcxvglyw _19pk1i6y _2hwxidpf _otyridpf _18u0idpf",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$SwimlaneShadowMaskStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$AvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1f4h",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneIssuesAmount = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz1gjq",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$swimlaneIssuesAmountStyles = (0, $8CUq3.xcss)({
    font: "var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    // @ts-expect-error - need to apply custom tokens for sufficient text contrast in themed projects
    color: (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ 
});
const $4cb655d4a4e9962b$var$swimlaneBarStyles = null; // TODO: combine this style into swimlaneBarStyles above on cleanup of getIsSoftwareThemingEnabled
const $4cb655d4a4e9962b$var$swimlaneThemingStyles = null;
const $4cb655d4a4e9962b$var$swimlaneThemingStylesOld = null;
const $4cb655d4a4e9962b$var$swimlaneBarUnscheduledColumnStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$LinkButtonOld = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _19itglyw _11c81kw7 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvidpf _80omtlke _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$LinkButton = (0, $cSD7y.componentWithFG)('tanuki_a11y_q4', ({ children: children, 'data-testid': testId, onClick: onClick })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": testId,
        onClick: onClick,
        className: (0, $bwpsq.default)([
            $4cb655d4a4e9962b$var$linkButtonContainerStyles.root
        ])
    }, children);
}, $4cb655d4a4e9962b$var$LinkButtonOld); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$Link = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $hjSul.Link), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11q7glyw _19itglyw _11c81kw7 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvidpf _80omtlke _4bfu18uv _9oik18uv _1hmsglyw _1bnxglyw _ajmmnqa1 _jf4cnqa1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SummarySection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1reo15vq _18m915vq _1ul9idpf _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$summarySectionStyles = (0, $8CUq3.xcss)({
    flex: 1,
    minWidth: '0px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // @ts-expect-error - need to apply custom tokens for sufficient text contrast in themed projects
    color: (0, $6cG4N.Tokens).COLOR_TEXT /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ ,
    ':hover': {
        textDecoration: 'underline'
    }
});
const $4cb655d4a4e9962b$var$summarySectionStylesOld = (0, $8CUq3.xcss)({
    flex: 1,
    minWidth: '0px',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    // @ts-expect-error - need to apply custom tokens for sufficient text contrast in themed projects
    color: (0, $6cG4N.Tokens).COLOR_TEXT /* eslint-disable-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values */ 
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$StatusSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _13t37vkz _11ko1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$SwimlaneRightContentContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3 _ca0qidpf _u5f3u2gc _n3tdidpf _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u0u2gc _1e0c1o8l",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$LinkButtonWithAnalytics = (0, $8oe80.default)('swimlaneHeader', {
    onClick: 'clicked'
})($4cb655d4a4e9962b$var$LinkButton);
const $4cb655d4a4e9962b$var$LinkWithAnalytics = (0, $8oe80.default)('swimlaneHeader', {
    onClick: 'clicked'
})($4cb655d4a4e9962b$var$Link); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4cb655d4a4e9962b$var$ColorBox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkogqwt _bfhk1cj8 _1bsb1k92 _4t3i1k92",
            __cmplp.className
        ])
    });
});
const $4cb655d4a4e9962b$var$oldheaderContentStyles = (0, $8CUq3.xcss)({
    minWidth: '0'
});
const $4cb655d4a4e9962b$var$headerContentStyles = {
    root: "_zulpu2gc _1e0c1txw _vchhusvi _4cvr1h6o _1ul9idpf"
};
const $4cb655d4a4e9962b$var$iconSpacing = (0, $8CUq3.xcss)({
    margin: 'space.050',
    width: '20px',
    display: 'flex',
    justifyContent: 'center'
});
const $4cb655d4a4e9962b$var$swimlaneContentWrapper = {
    root: "_kqswh2mm",
    pseudo: "_kqswstnw _154iidpf _1ltvidpf _1xi2idpf _94n5idpf _1pby1mrw"
};
const $4cb655d4a4e9962b$var$linkButtonContainerStyles = {
    root: "_kqswh2mm _ca0qze3t _u5f3u2gc _n3tdze3t _19bvze3t _1ul9idpf _syaz1fxt"
};

});
parcelRegister("iyN9w", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d83187a0eb7b20f4$var$_react = $d83187a0eb7b20f4$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d83187a0eb7b20f4$var$_flagFilled = $d83187a0eb7b20f4$var$_interopRequireDefault((parcelRequire("9ADwJ")));
function $d83187a0eb7b20f4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d83187a0eb7b20f4$var$FlagFilledIcon = (props)=>/*#__PURE__*/ $d83187a0eb7b20f4$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" d="M6 12.235v6.446c0 .537.45.977 1 .977s1-.44 1-.977v-5.778c1.17-.341 2.389-.045 3.768.29.982.238 2.036.495 3.13.495a5.7 5.7 0 0 0 2.547-.567 1 1 0 0 0 .563-.9V5.466a.998.998 0 0 0-1.437-.9c-1.345.654-2.731.317-4.331-.071-1.729-.42-3.687-.895-5.678.072A1 1 0 0 0 6 5.466z"/></svg>`
    }, props, {
        newIcon: $d83187a0eb7b20f4$var$_flagFilled.default
    }));
$d83187a0eb7b20f4$var$FlagFilledIcon.displayName = 'FlagFilledIcon';
var $d83187a0eb7b20f4$var$_default = module.exports.default = $d83187a0eb7b20f4$var$FlagFilledIcon;

});

parcelRegister("agZSd", function(module, exports) {

$parcel$export(module.exports, "getLozengeAppearanceByStatus", () => $4b5deb45e4e97e76$export$d5b9b4e40fc0bd79);

var $gULOk = parcelRequire("gULOk");

var $b8gJu = parcelRequire("b8gJu");
const $4b5deb45e4e97e76$export$d5b9b4e40fc0bd79 = (statusCategory)=>{
    switch((0, $gULOk).categoryIdForStatusCategory(statusCategory)){
        case 3:
            return (0, $b8gJu.LOZENGE_APPEARANCE).success;
        case 4:
            return (0, $b8gJu.LOZENGE_APPEARANCE).inprogress;
        default:
            return (0, $b8gJu.LOZENGE_APPEARANCE).default;
    }
};

});

parcelRegister("ijnF0", function(module, exports) {

$parcel$export(module.exports, "default", () => $60a16ddda3229b58$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3u0c5 = parcelRequire("3u0c5");

var $7SCny = parcelRequire("7SCny");

var $iHPnC = parcelRequire("iHPnC");

var $dCm1o = parcelRequire("dCm1o");
const $60a16ddda3229b58$var$LOZENGE_THEMES = (0, $iHPnC.transformColorToTheme)((colorSchema)=>({
        color: colorSchema.text,
        backgroundColor: colorSchema.textBackground
    }));
const $60a16ddda3229b58$var$getLozengeThemeByColor = (color)=>// This uses schema from src/packages/issue/epic-color/src/common/constants.js
    $60a16ddda3229b58$var$LOZENGE_THEMES[color] || $60a16ddda3229b58$var$LOZENGE_THEMES[0, $7SCny.PURPLE];
const $60a16ddda3229b58$var$CardEpic = (props)=>{
    // This uses schema from src/packages/issue/epic-color/src/common/constants.js
    const { color: color = (0, $7SCny.PURPLE), children: children } = props;
    /* eslint-disable jira/react/no-style-attribute */ return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($60a16ddda3229b58$var$LozengeWrapper, {
        "data-testid": "platform-board-kit.ui.swimlane.epic.lozenge"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
        style: $60a16ddda3229b58$var$getLozengeThemeByColor(color),
        isBold: (0, $dCm1o.isVisualRefreshEnabled)()
    }, children));
/* eslint-enable jira/react/no-style-attribute */ };
var $60a16ddda3229b58$export$2e2bcd8739ae039 = $60a16ddda3229b58$var$CardEpic;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $60a16ddda3229b58$var$LozengeWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _13t37vkz",
            __cmplp.className
        ])
    });
});

});

parcelRegister("eF5Y9", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fe6c107f7569dab$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $1fe6c107f7569dab$var$messages = (0, $7VHMR.defineMessages)({
    issueCount: {
        "id": "platform-board-kit.swimlane.issue-count",
        "defaultMessage": "{count, plural,\n            =0 {no issues}\n            one {# issue}\n            other {# issues}\n        }"
    },
    subtaskCount: {
        "id": "platform-board-kit.swimlane.subtask-count",
        "defaultMessage": "{count, plural,\n            =0 {no subtasks}\n            one {# subtask}\n            other {# subtasks}\n        }"
    },
    statusLozenge: {
        "id": "platform-board-kit.swimlane.status-lozenge",
        "defaultMessage": "status"
    },
    flagged: {
        "id": "platform-board-kit.swimlane.flagged",
        "defaultMessage": "Flagged"
    },
    issueCountIssueTermRefresh: {
        "id": "platform-board-kit.swimlane.issue-count-issue-term-refresh",
        "defaultMessage": "{count, plural,\n\t\t\t=0 {no work items}\n\t\t\tone {# work item}\n\t\t\tother {# work items}\n\t\t}"
    }
});
var $1fe6c107f7569dab$export$2e2bcd8739ae039 = $1fe6c107f7569dab$var$messages;

});

parcelRegister("04c3l", function(module, exports) {

$parcel$export(module.exports, "TruncatedTooltip", () => $5f43bb8a6d27d99a$export$ba96758b60231242);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");
const $5f43bb8a6d27d99a$export$ba96758b60231242 = ({ children: children, ...props })=>{
    const ref = (0, $5uXOq.useRef)(null);
    const [isOverflown, setIsOverflown] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (!ref.current) return;
        const element = ref.current;
        setIsOverflown(element.scrollWidth > element.clientWidth);
    }, [
        ref,
        children
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $5f43bb8a6d27d99a$var$tooltipOverflowStyles
    }, isOverflown ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), props, children({
        ref: ref
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children({
        ref: ref
    })));
};
const $5f43bb8a6d27d99a$var$tooltipOverflowStyles = (0, $8CUq3.xcss)({
    flex: 1,
    minWidth: '0'
});

});


parcelRegister("7xi98", function(module, exports) {

$parcel$export(module.exports, "default", () => $59f36d3a8673cec7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $59f36d3a8673cec7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    childlessTooltip: {
        "id": "software.main.board-container.board.swimlane.childless-tooltip",
        "defaultMessage": "Issues without a subtask or visible parent"
    },
    childlessTooltipIssueTermRefresh: {
        "id": "software.main.board-container.board.swimlane.childless-tooltip-issue-term-refresh",
        "defaultMessage": "Work items without a subtask or visible parent"
    },
    lozengeButtonLabel: {
        "id": "software.main.board-container.board.swimlane.lozeng-button-label",
        "defaultMessage": "More info about team details"
    }
});

});



parcelRegister("cxtbC", function(module, exports) {

$parcel$export(module.exports, "default", () => $e8481e06a31ed841$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e8481e06a31ed841$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    columnHeader: {
        "id": "software.main.board-container.board.unscheduled-work-swimlanes-container.column-header",
        "defaultMessage": "Drag issues to schedule"
    },
    closeColumnLabel: {
        "id": "software.main.board-container.board.unscheduled-work-swimlanes-container.close-column-label",
        "defaultMessage": "Hide unscheduled work"
    },
    columnHeaderIssueTermRefresh: {
        "id": "software.main.board-container.board.unscheduled-work-swimlanes-container.column-header-issue-term-refresh",
        "defaultMessage": "Drag work items to schedule"
    },
    filterIssuesHelpLink: {
        "id": "software.main.board-container.board.unscheduled-work-swimlanes-container.filter-issues-help-link",
        "defaultMessage": "Too many issues?"
    },
    filterIssuesHelpLinkIssueTermRefresh: {
        "id": "software.main.board-container.board.unscheduled-work-swimlanes-container.filter-issues-help-link-issue-term-refresh",
        "defaultMessage": "Too many work items?"
    }
});

});



parcelRegister("btiFk", function(module, exports) {

$parcel$export(module.exports, "default", () => $33eba21358e49b67$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $2Ysq2 = parcelRequire("2Ysq2");

var $fruR3 = parcelRequire("fruR3");

var $fyeGd = parcelRequire("fyeGd");

var $1SUmd = parcelRequire("1SUmd");
const $33eba21358e49b67$var$mapDispatchToProps = (dispatch)=>{
    const onCancel = ()=>{
        dispatch((0, $2Ysq2.backlogEnableCancel)());
    };
    const onConfirm = (push, refresh)=>{
        dispatch((0, $2Ysq2.backlogEnableConfirm)(push, refresh));
    };
    return {
        onCancel: onCancel,
        onConfirm: onConfirm
    };
};
var $33eba21358e49b67$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        isOpen: (0, $fruR3.isDialogVisibleSelector)(state),
        initialColumn: (0, $fyeGd.initialColumnSelector)(state)
    }), $33eba21358e49b67$var$mapDispatchToProps)((0, $1SUmd.default));

});
parcelRegister("fruR3", function(module, exports) {

$parcel$export(module.exports, "isDialogVisibleSelector", () => $adadf4f5013ea46a$export$c130901f07b1d4e4);

var $dGvGJ = parcelRequire("dGvGJ");

var $iuuJH = parcelRequire("iuuJH");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $absT5 = parcelRequire("absT5");

var $k8auG = parcelRequire("k8auG");
const $adadf4f5013ea46a$export$eacfcc6aba3b8af4 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getUi)
], (ui)=>Boolean(ui.backlogEnableDialog?.isOpen));
const $adadf4f5013ea46a$export$c130901f07b1d4e4 = (0, $dGvGJ.createSelector)([
    $adadf4f5013ea46a$export$eacfcc6aba3b8af4,
    (0, $k8auG.isBacklogEnabled),
    (0, $absT5.getFirstColumnIssueIds),
    (0, $45cXl.getSwimlaneMode),
    (0, $67Z81.getIsCMPBoard)
], (isOpen, backlogEnabled, firstColumnIssueIds, swimlaneMode, isCMPBoard)=>{
    if (isCMPBoard) return false;
    if (swimlaneMode === (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return false;
    const firstColumnMoreThen19Issues = firstColumnIssueIds.length > 19;
    return isOpen && !backlogEnabled && firstColumnMoreThen19Issues;
});

});

parcelRegister("1SUmd", function(module, exports) {

$parcel$export(module.exports, "default", () => $efcd1b367eca4a68$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $ldJSL = parcelRequire("ldJSL");
var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $eHJxW = parcelRequire("eHJxW");

var $gwIPs = parcelRequire("gwIPs");

var $eGLgs = parcelRequire("eGLgs");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $az4zD = parcelRequire("az4zD");

var $1J3t1 = parcelRequire("1J3t1");

var $3hUhs = parcelRequire("3hUhs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $5y0F0 = parcelRequire("5y0F0");

var $4oA6v = parcelRequire("4oA6v");
const $efcd1b367eca4a68$var$CoordinationStopProvider = ({ stop: stop = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children })=>children(stop);
const $efcd1b367eca4a68$export$4a4175d839a85894 = ({ intl: intl, initialColumnName: initialColumnName, onCancel: onCancel, push: push, onConfirm: onConfirm, stop: stop })=>{
    const { refresh: refresh } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    const title = intl.formatMessage((0, $4oA6v.default).title);
    const description = intl.formatMessage((0, $4oA6v.default).description, {
        initialColumnName: initialColumnName
    });
    const confirm = intl.formatMessage((0, $4oA6v.default).confirm);
    const cancel = intl.formatMessage((0, $4oA6v.default).cancel);
    const boldDescription = intl.formatMessage((0, $4oA6v.default).boldDescription);
    const onConfirmClicked = (e, analyticsEvent)=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'backlogFeatureDialogConfirm clicked');
        stop();
        onConfirm(push, refresh);
    };
    const onCancelClicked = (e, analyticsEvent)=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'backlogFeatureDialogCancel clicked');
        stop();
        onCancel();
    };
    const renderDialogContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h5"
    }, title), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$DescriptionStyle, null, description, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$BoldDescriptionStyle, null, boldDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$ButtonGroupContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onCancelClicked,
        appearance: "subtle"
    }, cancel), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        onClick: onConfirmClicked,
        appearance: "primary"
    }, confirm))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        messageId: "software-board.board-container.board.backlog-feature-dialog.jira-inline-dialog",
        messageType: "engagement",
        content: renderDialogContent,
        isOpen: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null));
};
const $efcd1b367eca4a68$var$BacklogFeatureDialogWithRouter = ({ isOpen: isOpen, initialColumn: initialColumn, ...props })=>initialColumn && isOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "backlogFeatureDialog"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "backlog-feature-dialog",
        packageName: "software-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "jira.board.backlog.feature.dialog",
        packageName: "jiraSoftwareBoard"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$StickyPosition, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
            messageId: "software-board.board-container.board.backlog-feature-dialog.coordination-client.stg-ext-459"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$var$CoordinationStopProvider, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($efcd1b367eca4a68$export$4a4175d839a85894, {
                ...props,
                initialColumnName: initialColumn.name,
                stop: stop || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
                push: push
            })))))))) : null;
var $efcd1b367eca4a68$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($efcd1b367eca4a68$var$BacklogFeatureDialogWithRouter);
const $efcd1b367eca4a68$var$COLUMN_DIALOG_Z_INDEX = (0, $3hUhs.sharedStyles).zIndex.stickyHeaders + 1;
const $efcd1b367eca4a68$var$CONTAINER_WIDTH = (0, $gwIPs.gridSize) * 42; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$StickyPosition = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1cl78iz": (0, $lD23V.default)((0, $3hUhs.sharedStyles).columnWithMarginWidth / 2, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _154ipxbi _1ltvlz7i _w4h21if8 _z2g7pxbi _7bfnqfx8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$ButtonGroupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _1bahesu3",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _o5724jg8 _1bsb2hgv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$DescriptionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_otyrpxbi",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $efcd1b367eca4a68$var$BoldDescriptionStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_k48pmoej",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4oA6v", function(module, exports) {

$parcel$export(module.exports, "default", () => $b644d43996c7dfd7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b644d43996c7dfd7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.board-container.board.backlog-feature-dialog.title",
        "defaultMessage": "Free up your board"
    },
    description: {
        "id": "software.main.board-container.board.backlog-feature-dialog.description",
        "defaultMessage": "Your {initialColumnName} column is getting quite full. Would you like to try out the "
    },
    boldDescription: {
        "id": "software.main.board-container.board.backlog-feature-dialog.bold-description",
        "defaultMessage": "Backlog?"
    },
    confirm: {
        "id": "software.main.board-container.board.backlog-feature-dialog.confirm",
        "defaultMessage": "Enable the backlog"
    },
    cancel: {
        "id": "software.main.board-container.board.backlog-feature-dialog.cancel",
        "defaultMessage": "Ignore"
    }
});

});



parcelRegister("aJnM9", function(module, exports) {

$parcel$export(module.exports, "useBoardDragDropContext", () => $4137dd08082e26dd$export$44254c39eac89ba9);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $eTXmK = parcelRequire("eTXmK");

var $7wqBZ = parcelRequire("7wqBZ");

var $dmo3v = parcelRequire("dmo3v");

var $kUU4G = parcelRequire("kUU4G");

var $x9xyg = parcelRequire("x9xyg");

var $4R6GH = parcelRequire("4R6GH");

var $8ikZj = parcelRequire("8ikZj");

var $ctrpc = parcelRequire("ctrpc");


var $6oUms = parcelRequire("6oUms");

var $i8Gbw = parcelRequire("i8Gbw");

var $5fc53 = parcelRequire("5fc53");

var $8zOmE = parcelRequire("8zOmE");

var $gULOk = parcelRequire("gULOk");



var $c79wa = parcelRequire("c79wa");

var $eu61M = parcelRequire("eu61M");

var $iDcEO = parcelRequire("iDcEO");

var $2f454 = parcelRequire("2f454");

var $55fEr = parcelRequire("55fEr");

var $67sX6 = parcelRequire("67sX6");

var $lIysR = parcelRequire("lIysR");

var $9OPlz = parcelRequire("9OPlz");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $4137dd08082e26dd$export$44254c39eac89ba9 = ({ onDragEnd: onDragEndProp })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const orderedColumnIds = (0, $67sX6.useBoardSelector)((0, $67Z81.getOrderedColumnIds));
    const getSomeTransitionsHaveConditions = (0, $67sX6.useBoardSelector)((0, $9OPlz.makeGetHasConditions));
    const boardSessionId = (0, $67sX6.useBoardSelector)((0, $67Z81.sessionIdSelector));
    const boardStore = (0, $67sX6.useBoardStore)();
    const isIPBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const overTransitionId = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.getCardDragState)(state).overTransition?.transitionId);
    const selectedTransitionId = (0, $67sX6.useBoardSelector)((state)=>(0, $9OPlz.getSelectedTransition)(state)?.transitionId);
    const cardSelection = (0, $67sX6.useBoardSelector)((0, $9OPlz.getCardSelection));
    const getSwimlaneValues = (0, $67sX6.useBoardSelector)((0, $4jZ56.makeSwimlaneValuesSelector));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const hasCustomTransitions = (0, $67sX6.useBoardSelector)((0, $9OPlz.hasNonGlobalTransitions));
    const hasMultipleStatuses = (0, $67sX6.useBoardSelector)((0, $fyeGd.hasMultipleStatusesPerColumn));
    const isHoverIntendedDuringDrag = (0, $67sX6.useBoardSelector)((state)=>hasCustomTransitions || hasMultipleStatuses ? (0, $9OPlz.isHoverIntended)(state) : false);
    const isTransitionSelected = (0, $67sX6.useBoardSelector)((state)=>{
        const transitionId = (0, $9OPlz.getSelectedTransition)(state)?.transitionId;
        return hasCustomTransitions || hasMultipleStatuses ? !!transitionId : false;
    });
    const getDestinationStatus = (0, $67sX6.useBoardSelector)((0, $lIysR.cardTransitionDestinationStatusSelector));
    const getSourceStatus = (0, $67sX6.useBoardSelector)((0, $lIysR.cardTransitionSourceStatusSelector));
    const fireAnalyticsStart = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? (0, $5uXOq.useCallback)((cardId)=>{
        // Only fire when a single card is dragged. If selected cards is different to the one being dragged, selected cards won't be included
        const shouldFireStartAnalytics = cardSelection.length <= 1 || !cardSelection.includes(cardId);
        if (shouldFireStartAnalytics) (0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsStart((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID), {
            analytics: createAnalyticsEvent({}),
            attributes: {
                fieldType: (0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID),
                isDragEditing: true,
                // remove the check of cardId on one_event_improvements_1 cleanup
                ...cardId && (0, $4R6GH.fg)('one_event_improvements_1') && {
                    issueId: cardId
                }
            }
        });
    }, [
        cardSelection,
        createAnalyticsEvent
    ]) : undefined;
    const fireAnalyticsEnd = (0, $4R6GH.fg)('one_event_rules_them_all_fg') ? (0, $5uXOq.useCallback)((cardIds, sourceSwimlaneId, destinationSwimlaneId, sourceColumnId, destinationColumnId, cardId, hasRankChanged)=>{
        const shouldFireEndAnalytics = cardSelection.length <= 1 || !cardSelection.includes(cardIds[0]);
        if (shouldFireEndAnalytics && (0, $4R6GH.fg)('one_event_rules_them_all_fg')) {
            const updatedFields = [];
            const swimlaneValues = destinationSwimlaneId ? getSwimlaneValues(destinationSwimlaneId) : undefined;
            const oldSwimlaneValues = sourceSwimlaneId ? getSwimlaneValues(sourceSwimlaneId) : undefined;
            if (sourceSwimlaneId !== destinationSwimlaneId && oldSwimlaneValues && swimlaneValues) {
                if (swimlaneValues.type === (0, $c79wa.ASSIGNEE) && oldSwimlaneValues.type === (0, $c79wa.ASSIGNEE)) updatedFields.push({
                    analytics: createAnalyticsEvent({}),
                    attributes: {
                        fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.ASSIGNEE_TYPE],
                        oldValId: oldSwimlaneValues.assigneeAccountId,
                        newValId: swimlaneValues.assigneeAccountId,
                        isDragEditing: true,
                        fieldKey: (0, $5fc53.ASSIGNEE_TYPE),
                        ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                            issueId: cardId
                        }
                    }
                });
                if (swimlaneValues.type === (0, $c79wa.PARENT) && oldSwimlaneValues.type === (0, $c79wa.PARENT) || swimlaneValues.type === (0, $c79wa.STORY) && oldSwimlaneValues.type === (0, $c79wa.STORY)) updatedFields.push({
                    analytics: createAnalyticsEvent({}),
                    attributes: {
                        fieldKey: (0, $5fc53.PARENT_TYPE),
                        fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.PARENT_TYPE],
                        oldValId: oldSwimlaneValues.parentId,
                        newValId: swimlaneValues.parentId,
                        isDragEditing: true,
                        ...(0, $4R6GH.fg)('one_event_improvements_1') && {
                            issueId: cardId
                        }
                    }
                });
            }
            if (sourceColumnId !== destinationColumnId) {
                const sourceStatus = getSourceStatus(cardIds[0]);
                const destinationStatus = getDestinationStatus(cardIds[0], Number(destinationColumnId));
                let oldStatusCategoryId;
                let newStatusCategoryId;
                if ((0, $4R6GH.fg)('one_event_improvements_1')) {
                    oldStatusCategoryId = (0, $gULOk.categoryIdForStatusCategory)(sourceStatus?.category);
                    newStatusCategoryId = (0, $gULOk.categoryIdForStatusCategory)(destinationStatus?.category);
                }
                updatedFields.push({
                    analytics: createAnalyticsEvent({}),
                    attributes: {
                        fieldKey: (0, $5fc53.STATUS_TYPE),
                        fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.STATUS_TYPE],
                        oldValId: sourceStatus?.id,
                        newValId: destinationStatus?.id,
                        isDragEditing: true,
                        // TODO: remove the check of oldStatusCategoryId & newStatusCategoryId on one_event_improvements_1 cleanup
                        ...oldStatusCategoryId && newStatusCategoryId && (0, $4R6GH.fg)('one_event_improvements_1') && {
                            oldStatusCategoryId: oldStatusCategoryId,
                            newStatusCategoryId: newStatusCategoryId
                        },
                        // remove the check of cardId on one_event_improvements_1 cleanup
                        ...cardId && (0, $4R6GH.fg)('one_event_improvements_1') && {
                            issueId: cardId
                        },
                        ...(0, $4R6GH.fg)('one_event_iteration_3') && {
                            hasRankChanged: true
                        }
                    }
                });
            }
            if (hasRankChanged && sourceColumnId === destinationColumnId && sourceSwimlaneId === destinationSwimlaneId && (0, $4R6GH.fg)('one_event_iteration_3')) updatedFields.push({
                analytics: createAnalyticsEvent({}),
                attributes: {
                    fieldKey: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.RANK_CF_TYPE],
                    fieldType: (0, $8ikZj.FIELD_TYPE_MAP)[0, $5fc53.RANK_CF_TYPE],
                    isDragEditing: true,
                    issueId: cardId,
                    hasRankChanged: true
                }
            });
            updatedFields.forEach((attributes, index)=>(0, $ctrpc.getUpdateAnalyticsFlowHelper)().fireAnalyticsEnd((0, $8ikZj.DRAG_DROP_UNKNOWN_FIELD_ID), attributes, index === updatedFields.length - 1));
        }
    }, [
        cardSelection,
        createAnalyticsEvent,
        getDestinationStatus,
        getSourceStatus,
        getSwimlaneValues
    ]) : undefined;
    const onDragStart = (0, $5uXOq.useCallback)((draggableData)=>{
        (0, $kUU4G.default)((0, $dcbb2bce513725b3$export$67cc25959ff33188));
        (0, $x9xyg.setMark)((0, $dcbb2bce513725b3$export$67cc25959ff33188));
        const draggableId = draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) ? (0, $6oUms.getCardDescriptor)(draggableData.cardId) : (0, $6oUms.getColumnDescriptor)(draggableData.columnId, draggableData.swimlaneId ?? undefined);
        dispatch((0, $eu61M.dragStart)(draggableId, 'FLUID'));
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragStarted',
            actionSubject: draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) ? 'card' : 'column'
        });
        if (fireAnalyticsStart && draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) fireAnalyticsStart(draggableData.cardId);
        if (!isIPBoard && draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) {
            const { cardId: cardId } = draggableData;
            const hasConditions = getSomeTransitionsHaveConditions(cardId);
            if (hasConditions) dispatch((0, $2f454.cardGetIssueTransitions)(cardId, analyticsEvent));
        }
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, isIPBoard ? {
            source: (0, $7e733a5d4e4331fc$export$8a5f5fbe7aeddf5)
        } : {});
    }, [
        createAnalyticsEvent,
        dispatch,
        fireAnalyticsStart,
        getSomeTransitionsHaveConditions,
        isIPBoard
    ]);
    const onDragEnd = (0, $5uXOq.useCallback)((draggableData, targetData)=>{
        onDragEndProp?.();
        (0, $7wqBZ.getLongTasksMetrics)('dnd').stop((0, $dmo3v.dndReporter), {
            type: draggableData.type,
            boardSessionId: boardSessionId,
            isPragmaticBoardEnabled: true
        });
        dispatch((0, $eu61M.dragEnd)());
        const analyticsEvent = createAnalyticsEvent({
            action: 'dragEnded',
            actionSubject: draggableData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c) ? 'card' : 'column'
        });
        let analyticAttributes;
        if (!isIPBoard) analyticAttributes = draggableData.type === 'CARD' ? {
            dndType: draggableData.type,
            hasNonGlobalTransitions: hasCustomTransitions,
            isTransitionSelected: isTransitionSelected,
            hoverIntent: isHoverIntendedDuringDrag,
            sameColumn: draggableData.columnId === targetData?.columnId
        } : {
            dndType: draggableData.type
        };
        else analyticAttributes = {
            source: (0, $7e733a5d4e4331fc$export$8a5f5fbe7aeddf5)
        };
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, analyticAttributes);
    }, [
        onDragEndProp,
        boardSessionId,
        dispatch,
        createAnalyticsEvent,
        isIPBoard,
        hasCustomTransitions,
        isTransitionSelected,
        isHoverIntendedDuringDrag
    ]);
    const onColumnMove = (0, $5uXOq.useCallback)((columnId, sourceColumnIndex, destinationColumnIndex)=>{
        if (!isIPBoard) {
            const analyticsEvent = createAnalyticsEvent({
                action: 'moved',
                actionSubject: 'column'
            });
            dispatch((0, $55fEr.columnRankRequest)(Number(columnId), orderedColumnIds[destinationColumnIndex], sourceColumnIndex, analyticsEvent));
        }
    }, [
        createAnalyticsEvent,
        dispatch,
        orderedColumnIds,
        isIPBoard
    ]);
    const onCardsMove = (0, $5uXOq.useCallback)(({ cardIds: cardIds, sourceColumnId: sourceColumnId, destinationColumnId: destinationColumnId, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, sourceSwimlaneId: sourceSwimlaneId, destinationSwimlaneId: destinationSwimlaneId, cardId: cardId })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'updated',
            actionSubject: 'issue'
        });
        if (overTransitionId && !selectedTransitionId) dispatch((0, $2f454.cardDragSelectedTransition)(overTransitionId, Number(destinationColumnId), destinationSwimlaneId ?? undefined));
        if ((0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition')) (0, $eTXmK.default)('board.card-move-swimlane.drop');
        if (fireAnalyticsEnd) {
            const isColumnChanged = sourceColumnId !== destinationColumnId;
            const hasRankChanged = !isColumnChanged && sourceCardIndex !== destinationCardIndex && sourceSwimlaneId === destinationSwimlaneId;
            fireAnalyticsEnd(cardIds, sourceSwimlaneId, destinationSwimlaneId, sourceColumnId, destinationColumnId, cardId, (0, $4R6GH.fg)('one_event_iteration_3') && hasRankChanged);
        }
        const finalDestinationCardIndex = Number.isInteger(destinationCardIndex) ? destinationCardIndex : (0, $5mTgl.getIssuesIdsForColumn)(boardStore.getState(), {
            swimlaneId: destinationSwimlaneId,
            columnId: Number(destinationColumnId)
        })?.length;
        dispatch((0, $iDcEO.cardsMove)({
            cardIds: cardIds,
            sourceColumnId: Number(sourceColumnId),
            destinationColumnId: Number(destinationColumnId),
            sourceCardIndex: sourceCardIndex,
            destinationCardIndex: finalDestinationCardIndex ?? 0,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: destinationSwimlaneId,
            analyticsEvent: analyticsEvent
        }));
    }, [
        createAnalyticsEvent,
        overTransitionId,
        selectedTransitionId,
        fireAnalyticsEnd,
        boardStore,
        dispatch
    ]);
    (0, $i8Gbw.useBoardDragDropContext)({
        onDragStart: onDragStart,
        onDragEnd: onDragEnd,
        onColumnMove: onColumnMove,
        onCardsMove: onCardsMove
    });
};

});
parcelRegister("dmo3v", function(module, exports) {

$parcel$export(module.exports, "dndReporterWithSlo", () => $4a0e33c36c54a683$export$e5a00a4133cb3d76);
$parcel$export(module.exports, "dndReporter", () => $4a0e33c36c54a683$export$62f293b5c9d6890c);

var $kUU4G = parcelRequire("kUU4G");

var $fjcgS = parcelRequire("fjcgS");

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $4a0e33c36c54a683$export$e5a00a4133cb3d76 = (sloSettings)=>(observationData, extraProps, stopTimestamp)=>{
        if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
            const { eventStartPerformanceMark: eventStartPerformanceMark } = observationData;
            if (eventStartPerformanceMark) (0, $kUU4G.default)(eventStartPerformanceMark);
            const startTimes = observationData.events.map((event)=>event.timestamp);
            const startLongTaskEndTimestamp = observationData.dragStartEndTimestamp;
            const startLongTasks = observationData.events.filter((event)=>event.timestamp < startLongTaskEndTimestamp);
            const movingLongTasks = observationData.events.filter((event)=>event.timestamp >= startLongTaskEndTimestamp && event.timestamp < stopTimestamp);
            const dropLongTasks = observationData.events.filter((event)=>event.timestamp >= stopTimestamp);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            const analyticsData = {
                ...extraProps,
                ...(0, $if7bx.generateLongTaskAnalyticsSummaryWithSlo)('start', startLongTasks, sloSettings),
                ...(0, $if7bx.generateLongTaskAnalyticsSummaryWithSlo)('moving', movingLongTasks, sloSettings),
                ...(0, $if7bx.generateLongTaskAnalyticsSummaryWithSlo)('drop', dropLongTasks, sloSettings),
                type: observationData.type || 'unknown',
                measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTimes),
                performanceFFs: (0, $k12ix.getPerformanceFFsString)()
            };
            const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
            triggerSoftwareAnalytics(`long-tasks-${observationData.type || 'dnd'}`, analyticsData);
            if (sloSettings) {
                const attributes = {
                    ...extraProps,
                    type: observationData.type || 'unknown',
                    startLongTaskSloIsSuccess: analyticsData.startLongTaskSloIsSuccess,
                    movingLongTaskSloIsSuccess: analyticsData.movingLongTaskSloIsSuccess,
                    dropLongTaskSloIsSuccess: analyticsData.dropLongTaskSloIsSuccess,
                    ...sloSettings
                };
                (0, $fjcgS.getAnalyticsWebClientPromise)().then((client)=>{
                    const payload = {
                        source: observationData.appName,
                        action: 'complete',
                        actionSubject: 'dnd operation',
                        attributes: attributes
                    };
                    client.getInstance().sendOperationalEvent(payload);
                });
            }
        }
    };
const $4a0e33c36c54a683$export$62f293b5c9d6890c = $4a0e33c36c54a683$export$e5a00a4133cb3d76();

});

parcelRegister("i8Gbw", function(module, exports) {

$parcel$export(module.exports, "useBoardDragDropContext", () => $bece2cc482ad9c63$export$44254c39eac89ba9);

var $5uXOq = parcelRequire("5uXOq");

var $biEfA = parcelRequire("biEfA");

var $7gWdR = parcelRequire("7gWdR");


var $kChOb = parcelRequire("kChOb");
const $bece2cc482ad9c63$var$availableDNDTypes = [
    (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c),
    (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91)
];
const $bece2cc482ad9c63$export$3931b9970036fda4 = (sourceColumnData, destinationColumnData, onColumnMove)=>{
    const { columnId: columnId, columnIndex: sourceColumnIndex } = sourceColumnData;
    if (!destinationColumnData || destinationColumnData.type !== (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91) || columnId === destinationColumnData.columnId) return;
    const closestEdgeOfTarget = (0, $biEfA.extractClosestEdge)(destinationColumnData);
    if (!closestEdgeOfTarget) return;
    const destinationColumnIndex = (0, $kChOb.getDestinationColumnIndex)(closestEdgeOfTarget, sourceColumnIndex, destinationColumnData.columnIndex);
    if (sourceColumnIndex !== destinationColumnIndex) onColumnMove(columnId, sourceColumnIndex, destinationColumnIndex);
};
const $bece2cc482ad9c63$export$8af04b1252e03f45 = (cardData, targetData, onCardsMove)=>{
    const { cardId: cardId, cardIndex: sourceCardIndex, columnId: sourceColumnId, swimlaneId: sourceSwimlaneId } = cardData;
    if (!targetData) return;
    if (targetData.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91) || targetData.type === (0, $25c2ea87c2b04bf9$export$2927f4d423091b16)) {
        // Drop on column or transition zone
        onCardsMove({
            cardId: cardId,
            cardIds: [
                cardId
            ],
            sourceColumnId: sourceColumnId,
            destinationColumnId: targetData.columnId,
            sourceCardIndex: sourceCardIndex,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: targetData.swimlaneId
        });
        return;
    }
    if (targetData.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) {
        // Drop against a card
        const closestEdge = (0, $biEfA.extractClosestEdge)(targetData);
        if (!closestEdge) return;
        const isSameColumnAndSwimlane = sourceColumnId === targetData.columnId && sourceSwimlaneId === targetData.swimlaneId;
        const destinationCardIndex = (0, $kChOb.getDestinationCardIndex)({
            closestEdge: closestEdge,
            sourceCardIndex: sourceCardIndex,
            destinationCardIndex: targetData.cardIndex,
            isSameColumnAndSwimlane: isSameColumnAndSwimlane
        });
        if (isSameColumnAndSwimlane && (cardId === targetData.cardId || sourceCardIndex === destinationCardIndex)) return;
        onCardsMove({
            cardId: cardId,
            cardIds: [
                cardId
            ],
            sourceColumnId: sourceColumnId,
            destinationColumnId: targetData.columnId,
            sourceCardIndex: sourceCardIndex,
            destinationCardIndex: destinationCardIndex,
            sourceSwimlaneId: sourceSwimlaneId,
            destinationSwimlaneId: targetData.swimlaneId
        });
    }
};
const $bece2cc482ad9c63$export$44254c39eac89ba9 = ({ onDragStart: onDragStart, onDragEnd: onDragEnd, onColumnMove: onColumnMove, onCardsMove: onCardsMove })=>{
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
            canMonitor: ({ source: source })=>$bece2cc482ad9c63$var$availableDNDTypes.includes(String(source.data.type)),
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            onDragStart: ({ source: source })=>onDragStart(source.data),
            onDrop: ({ location: location, source: source })=>{
                onDragEnd(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                source.data, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                location.current.dropTargets[0]?.data);
                if (!location.current.dropTargets.length) return;
                if (source.data.type === (0, $25c2ea87c2b04bf9$export$57d0ef745f304b91)) $bece2cc482ad9c63$export$3931b9970036fda4(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                source.data, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                location.current.dropTargets[0]?.data, onColumnMove);
                if (source.data.type === (0, $25c2ea87c2b04bf9$export$b05303cbde3e8c8c)) $bece2cc482ad9c63$export$8af04b1252e03f45(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                source.data, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                location.current.dropTargets[0]?.data, onCardsMove);
            }
        }), [
        onCardsMove,
        onColumnMove,
        onDragEnd,
        onDragStart
    ]);
};

});
parcelRegister("kChOb", function(module, exports) {

$parcel$export(module.exports, "getDestinationColumnIndex", () => $b99e3a1eb57bd2af$export$6effbf458397b60);
$parcel$export(module.exports, "getDestinationCardIndex", () => $b99e3a1eb57bd2af$export$730b48350489f9c4);
const $b99e3a1eb57bd2af$export$6effbf458397b60 = (closestEdge, sourceColumnIndex, destinationColumnIndex)=>{
    if (sourceColumnIndex < destinationColumnIndex) return closestEdge === 'left' ? destinationColumnIndex - 1 : destinationColumnIndex;
    return closestEdge === 'left' ? destinationColumnIndex : destinationColumnIndex + 1;
};
const $b99e3a1eb57bd2af$export$730b48350489f9c4 = ({ closestEdge: closestEdge, sourceCardIndex: sourceCardIndex, destinationCardIndex: destinationCardIndex, isSameColumnAndSwimlane: isSameColumnAndSwimlane })=>{
    if (isSameColumnAndSwimlane && sourceCardIndex < destinationCardIndex) return closestEdge === 'top' ? destinationCardIndex - 1 : destinationCardIndex;
    return closestEdge === 'top' ? destinationCardIndex : destinationCardIndex + 1;
};

});



parcelRegister("4uy3J", function(module, exports) {

$parcel$export(module.exports, "default", () => $f51523b0338b2b81$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hzgHK = parcelRequire("hzgHK");

var $4jAPy = parcelRequire("4jAPy");

var $jbAX5 = parcelRequire("jbAX5");

var $67sX6 = parcelRequire("67sX6");

var $fyeGd = parcelRequire("fyeGd");

var $67Z81 = parcelRequire("67Z81");

var $cPGP0 = parcelRequire("cPGP0");
const $f51523b0338b2b81$var$SprintAssociation = ()=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const sprintAssociationModal = (0, $67sX6.useBoardSelector)((state)=>state.ui.sprintAssociationModal);
    const isOpen = sprintAssociationModal?.isOpen;
    const teamId = isOpen ? sprintAssociationModal?.teamId || '' : '';
    const team = (0, $67sX6.useBoardSelector)((0, $cPGP0.getTeamById))(teamId);
    const planId = (0, $67sX6.useBoardSelector)((0, $67Z81.getPlanId));
    const scenarioId = (0, $67sX6.useBoardSelector)((0, $67Z81.getScenarioId));
    const incrementId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const columns = (0, $67sX6.useBoardSelector)((0, $fyeGd.getColumns));
    const onModalCloseHandler = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $jbAX5.closeTeamAssociationModal)());
    }, [
        dispatch
    ]);
    const iterations = (0, $5uXOq.useMemo)(()=>Object.values(columns || {}).filter((column)=>column.id !== 0).map((column)=>{
            if ('dateRange' in column) return {
                id: column.id,
                startDate: column.dateRange.start,
                endDate: column.dateRange.end,
                name: column.name
            };
            return {
                id: column.id,
                name: column.name,
                startDate: 0,
                endDate: 0
            };
        }), [
        columns
    ]);
    const incrementConfig = (0, $67sX6.useBoardSelector)((0, $67Z81.getIncrementConfig));
    if (!isOpen) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hzgHK.default), {
        isOpen: true,
        teamId: teamId,
        planId: planId,
        scenarioId: scenarioId,
        teamAvatarUrl: team.avatarUrl || '',
        teamName: team.name,
        incrementId: incrementId,
        sprintByIterationId: team.sprintByIterationId,
        iterations: iterations,
        onModalclose: onModalCloseHandler,
        iterationLength: incrementConfig?.iterationLength ?? (0, $4jAPy.DEFAULT_ITERATION_LENGTH)
    });
};
var $f51523b0338b2b81$export$2e2bcd8739ae039 = $f51523b0338b2b81$var$SprintAssociation;

});
parcelRegister("hzgHK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4a5d1db0c6b8c38c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4jAPy = parcelRequire("4jAPy");

var $d7X6q = parcelRequire("d7X6q");
const $4a5d1db0c6b8c38c$var$AsyncSprintAssociationDialog = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $d7X6q.syncSprintDialog), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "plan-increment-sprint-association-dialog",
        packageName: (0, $4jAPy.PACKAGE_NAME),
        teamName: (0, $4jAPy.ERROR_REPORTING_TEAM),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $4a5d1db0c6b8c38c$export$2e2bcd8739ae039 = $4a5d1db0c6b8c38c$var$AsyncSprintAssociationDialog;

});
parcelRegister("d7X6q", function(module, exports) {

$parcel$export(module.exports, "syncSprintDialog", () => $e6d696b10fe546fe$export$32b8d8af74925968);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $e6d696b10fe546fe$export$32b8d8af74925968 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("2s1ZS")).then((module)=>module.AsyncSprintAssociationDialog), {
        moduleId: "a536e7e2"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("2s1ZS", function(module, exports) {

let $1c8fbed90a72d59e$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1c8fbed90a72d59e$var$load("bEFNl").then(()=>parcelRequire('1bpWz'));

});




parcelRegister("hnOnj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3087206511b049cd$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $645AZ = parcelRequire("645AZ");

var $4CeiT = parcelRequire("4CeiT");

var $92yNu = parcelRequire("92yNu");

var $600T9 = parcelRequire("600T9");

var $4fvP4 = parcelRequire("4fvP4");

var $guFRy = parcelRequire("guFRy");

var $a2e2Q = parcelRequire("a2e2Q");

var $4R6GH = parcelRequire("4R6GH");

var $lmBAt = parcelRequire("lmBAt");

var $2xFXk = parcelRequire("2xFXk");

var $6WzWZ = parcelRequire("6WzWZ");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $j4MnI = parcelRequire("j4MnI");

var $67Z81 = parcelRequire("67Z81");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $dRpFy = parcelRequire("dRpFy");

var $iTH7p = parcelRequire("iTH7p");

var $5AKFd = parcelRequire("5AKFd");

var $grktj = parcelRequire("grktj");

var $aH5JS = parcelRequire("aH5JS");
const $3087206511b049cd$var$SwimlanesContainer = ()=>{
    const boardStore = (0, $67sX6.useBoardStore)();
    const columns = (0, $67sX6.useBoardSelector)((0, $5mTgl.columnsWithResolutionSelector));
    const swimlaneIds = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneIdsSelector));
    const collapsedSwimlaneIds = (0, $67sX6.useBoardSelector)((0, $4jZ56.getCollapsedSwimlanes));
    const isIpBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const issuesWithLinksById = (0, $67sX6.useBoardSelector)((0, $5mTgl.getIssuesEntriesWithIssueLinksInBoard));
    const issueLinkTypes = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueLinkTypes));
    const showOffTrackDependencies = (0, $67sX6.useBoardSelector)((0, $j4MnI.getShowOfftrackDependencyLines));
    const issueIdsToShowDependencies = (0, $67sX6.useBoardSelector)((0, $j4MnI.getIssueIdsToShowDependencies));
    const hasDependenciesToShow = issueIdsToShowDependencies.length > 0 || showOffTrackDependencies;
    const [menusShown, setMenusShowns] = (0, $5uXOq.useState)({});
    const isFlexible = (0, $63LqY.useCapability)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS);
    const setMenuVisibility = (columnId)=>(visible)=>{
            setMenusShowns({
                [columnId]: visible
            });
        };
    const swimlaneHeights = (0, $67sX6.useBoardSelector)((0, $5mTgl.swimlaneHeightsSelector));
    const cacheOptions = (0, $5uXOq.useMemo)(()=>({
            cache: new Map(),
            getCacheKey: (index)=>swimlaneIds[index]
        }), [
        swimlaneIds
    ]);
    const { rows: rows, totalSize: totalSize, scrollTo: scrollTo, rowStates: rowStates } = (0, $guFRy.useVirtual)({
        rowCount: swimlaneIds.length,
        getDefaultRowSize: (index)=>swimlaneHeights[swimlaneIds[index]],
        offsetTop: (0, $645AZ.columnHeaderHeight),
        cacheOptions: cacheOptions
    });
    const [_, { updateSwimlanePositions: updateSwimlanePositions }] = (0, $600T9.useDependencyLinks)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = // eslint-disable-next-line jira/ff/no-preconditioning -- we are rolling out the fast follows after the experiment has started
    (0, $4R6GH.fg)('jira_theming_milestone_1_fast_follows') && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    (0, $5uXOq.useEffect)(()=>{
        if (isIpBoard && rowStates) updateSwimlanePositions(rowStates, rows, swimlaneIds, collapsedSwimlaneIds);
    }, [
        isIpBoard,
        updateSwimlanePositions,
        rows,
        rowStates,
        swimlaneIds,
        collapsedSwimlaneIds
    ]);
    (0, $aH5JS.useAutoScrollSwimlane)(swimlaneIds, scrollTo);
    const renderSwimlanes = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, rows.map(({ index: index, top: top, forceRemeasure: forceRemeasure, measure: measure })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $grktj.default), {
                key: swimlaneIds[index],
                id: swimlaneIds[index],
                index: index,
                top: top,
                measure: measure,
                forceRemeasure: forceRemeasure,
                isLastSwimlane: index === swimlaneIds.length - 1,
                isUnscheduledWorkColumnPanel: false
            })));
    const isIPBoardReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const onUnlinkIssueAction = (0, $67sX6.useBoardActionCreator)((issueLink, issueId)=>(0, $6WzWZ.issueLinksRemoveRequest)({
            issueId: issueId,
            issueLink: issueLink
        }));
    const onUnlinkIssue = (0, $5uXOq.useCallback)(async (dependencyModalIssueLink)=>{
        if (dependencyModalIssueLink) {
            const issueLink = {
                id: dependencyModalIssueLink.itemKey,
                sourceId: dependencyModalIssueLink.sourceItemKey,
                destinationId: dependencyModalIssueLink.targetItemKey,
                linkTypeId: dependencyModalIssueLink.type
            };
            return onUnlinkIssueAction(issueLink, issueLink.sourceId);
        }
    }, [
        onUnlinkIssueAction
    ]);
    const getOrderedIssueIdsForColumn = (columnId, swimlaneId)=>{
        return (0, $5mTgl.getIssuesIdsForColumn)(boardStore.getState(), {
            columnId: columnId,
            swimlaneId: swimlaneId
        }) || [];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3087206511b049cd$var$SwimlanesContainerWrapper, {
        isFlexible: isFlexible
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CeiT.SwimlaneColumnHeaderContainer), {
        flexibleColumns: isFlexible,
        isThemed: (0, $4R6GH.fg)('dee_7519_fix_column_header_alignment') ? (0, $lmBAt.getIsSoftwareThemingEnabled)() : isSoftwareFullTheming
    }, columns.map(({ id: id }, columnIndex)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5AKFd.default), {
            id: id,
            key: id,
            header: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dRpFy.default), {
                id: id,
                isMenuShown: (0, $4R6GH.fg)('fix_board_column_hidden_context_menu') ? menusShown[id] : menusShown[id] || false,
                menu: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iTH7p.default), {
                    columnId: id,
                    onVisibilityChange: setMenuVisibility(id)
                })
            }),
            draggableIndex: columnIndex
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92yNu.default), {
        flexibleColumns: isFlexible,
        minHeight: totalSize + (0, $645AZ.columnHeaderHeight),
        isVirtualised: true
    }, renderSwimlanes()), isIpBoard && hasDependenciesToShow && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4fvP4.DependencyLines), {
        issuesWithLinksById: issuesWithLinksById,
        showOffTrackDependencies: showOffTrackDependencies,
        issueIdsToShowDependencies: issueIdsToShowDependencies,
        issueLinkTypes: issueLinkTypes,
        onUnlink: onUnlinkIssue,
        canDelete: !isIPBoardReadOnly,
        getOrderedIssueIdsForColumn: getOrderedIssueIdsForColumn
    }));
};
var $3087206511b049cd$export$2e2bcd8739ae039 = $3087206511b049cd$var$SwimlanesContainer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3087206511b049cd$var$SwimlanesContainerWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isFlexible: isFlexible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isFlexible ? "_1bsb1osq" : "_1bsb1wug",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4fvP4", function(module, exports) {

$parcel$export(module.exports, "DependencyLines", () => $1ae1da9ec61b7fe8$export$4893c4c042062b2e);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $c32Ax = parcelRequire("c32Ax");

var $g1SUQ = parcelRequire("g1SUQ");

var $600T9 = parcelRequire("600T9");

var $2m0b6 = parcelRequire("2m0b6");

var $9Ik53 = parcelRequire("9Ik53");
const $1ae1da9ec61b7fe8$export$4893c4c042062b2e = ({ issuesWithLinksById: issuesWithLinksById, issueLinkTypes: issueLinkTypes, onUnlink: onUnlink, canDelete: canDelete, showOffTrackDependencies: showOffTrackDependencies, issueIdsToShowDependencies: issueIdsToShowDependencies, getOrderedIssueIdsForColumn: getOrderedIssueIdsForColumn })=>{
    const [dependencyLinesData] = (0, $600T9.useIPDependencyLines)({
        issuesWithLinksById: issuesWithLinksById,
        showOffTrackDependencies: showOffTrackDependencies,
        issueIdsToShowDependencies: issueIdsToShowDependencies,
        getOrderedIssueIdsForColumn: getOrderedIssueIdsForColumn
    });
    const [{ activeLine: activeLine }, { updateDependencyLinesContainerPosition: updateDependencyLinesContainerPosition, setActiveLine: setActiveLine }] = (0, $600T9.useDependencyLinks)();
    const { scrollLeft: scrollLeft } = (0, $9Ik53.useScrollState)();
    // Hold a ref to the scrollLeft value because we're interested in the value being up to date, but
    // not interested in re-firing the useEffect every time the user scrolls horizontally on the board
    const scrollLeftRef = (0, $5uXOq.useRef)(scrollLeft);
    (0, $5uXOq.useEffect)(()=>{
        scrollLeftRef.current = scrollLeft;
    }, [
        scrollLeft
    ]);
    // Hold the ref to the container of the dependency lines so we can account for panels pushing in from the left
    // E.g unscheduled work panel, nav sidebar being present/collapsed.
    const dependencyLinesContainerRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (dependencyLinesContainerRef.current) {
            const { x: x } = dependencyLinesContainerRef.current.getBoundingClientRect();
            updateDependencyLinesContainerPosition({
                x: x + scrollLeftRef.current
            });
        }
    }, [
        updateDependencyLinesContainerPosition,
        dependencyLinesContainerRef
    ]);
    (0, $2m0b6.useResizeObserver)({
        ref: dependencyLinesContainerRef,
        onResize: ()=>{
            if (dependencyLinesContainerRef.current) {
                const { x: x } = dependencyLinesContainerRef.current.getBoundingClientRect();
                updateDependencyLinesContainerPosition({
                    x: x + scrollLeftRef.current
                });
            }
        }
    });
    const onDependencyClick = (event, params)=>{
        const clickedLine = {
            fromId: params.fromId,
            toId: params.toId,
            x: event.clientX,
            y: event.clientY
        };
        setActiveLine(clickedLine);
    };
    const formatLinksForModal = (links)=>{
        return links.filter((link)=>link.sourceId === activeLine?.fromId && link.destinationId === activeLine?.toId).map((link)=>{
            const { id: itemKey, sourceId: sourceId, destinationId: destinationId, isOfftrack: isOfftrack, linkTypeId: linkTypeId } = link;
            const getIssueMeta = (issue)=>{
                const { id: id, typeName: typeName, typeUrl: iconUrl, key: projectKey, summary: title } = issue;
                return {
                    id: id,
                    typeName: typeName,
                    iconUrl: iconUrl,
                    projectKey: projectKey,
                    title: title
                };
            };
            const issueLinkType = issueLinkTypes.find((type)=>type.id === linkTypeId);
            let outwardDescription = '';
            if (issueLinkType) {
                const { isOutward: isOutward, inward: inward, outward: outward } = issueLinkType;
                outwardDescription = isOutward ? outward : inward;
            }
            return {
                fromIssue: getIssueMeta(issuesWithLinksById[sourceId]),
                toIssue: getIssueMeta(issuesWithLinksById[destinationId]),
                issueLinkType: {
                    id: linkTypeId,
                    outward: outwardDescription
                },
                itemKey: itemKey,
                isOfftrack: isOfftrack
            };
        });
    };
    const currentLineLinks = activeLine ? formatLinksForModal(issuesWithLinksById[activeLine.fromId]?.issueLinks || []) : [];
    const selectedDependency = activeLine ? {
        fromId: activeLine.fromId,
        toId: activeLine.toId
    } : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c32Ax.default), {
        dependencies: dependencyLinesData,
        selectedDependency: selectedDependency,
        onDependencyClick: onDependencyClick
    }), activeLine && currentLineLinks.length && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g1SUQ.default), {
        position: {
            left: activeLine.x,
            top: activeLine.y
        },
        links: currentLineLinks,
        canDelete: canDelete,
        onUnlink: onUnlink,
        onClose: ()=>setActiveLine(null),
        simpleOverlap: true
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        ref: dependencyLinesContainerRef,
        xcss: $1ae1da9ec61b7fe8$var$measureDependencyLinesContainerStyles
    }));
};
const $1ae1da9ec61b7fe8$var$measureDependencyLinesContainerStyles = (0, $8CUq3.xcss)({
    height: '100%',
    width: '100%',
    position: 'absolute',
    top: '0',
    left: '0',
    pointerEvents: 'none'
});

});
parcelRegister("c32Ax", function(module, exports) {

$parcel$export(module.exports, "default", () => $abcd90738f5b2cb5$export$2e2bcd8739ae039);
/* eslint-disable jira/restricted/styled-components-migration */ 
var $5uXOq = parcelRequire("5uXOq");

var $47bDC = parcelRequire("47bDC");

var $8Rkzz = parcelRequire("8Rkzz");


var $9cikT = parcelRequire("9cikT");
const $abcd90738f5b2cb5$var$SvgOverlay = ({ dependencies: dependencies, selectedDependency: selectedDependency, onDependencyClick: onDependencyClick })=>{
    const selectedDependencyLine = selectedDependency && dependencies.find((dependency)=>dependency.from.id === selectedDependency.fromId && dependency.to.id === selectedDependency.toId && dependency.from.indexOnScope === selectedDependency.fromIndex && dependency.to.indexOnScope === selectedDependency.toIndex);
    return(// eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($abcd90738f5b2cb5$var$SvgContainer, {
        className: (0, $0afb8a62e53619f1$export$1e54f8b472a07d8d)
    }, dependencies.map((dependency)=>{
        if (dependency !== selectedDependencyLine) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9cikT.default), {
            key: `${dependency.from.id}-${dependency.to.id}-${dependency.from.y}-${dependency.to.y}`,
            ...dependency,
            onClick: onDependencyClick,
            isSelected: false
        });
        return null;
    }), selectedDependencyLine && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9cikT.default), {
        ...selectedDependencyLine,
        onClick: onDependencyClick,
        isSelected: true
    })));
};
$abcd90738f5b2cb5$var$SvgOverlay.defaultProps = {
    selectedDependency: undefined,
    onDependencyClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    dependencies: []
};
var $abcd90738f5b2cb5$export$2e2bcd8739ae039 = $abcd90738f5b2cb5$var$SvgOverlay;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $abcd90738f5b2cb5$var$SvgContainer = /*#__PURE__*/ (0, $47bDC.default).svg.withConfig({
    componentId: "sc-7b34v9-0"
})({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    transition: 'opacity 0.2s ease-in-out',
    overflow: 'visible',
    pointerEvents: 'none'
});

});
/**
 * Style marshal classes
 */ const $0afb8a62e53619f1$export$1e54f8b472a07d8d = 'dependencies-overlay';
const $0afb8a62e53619f1$export$cd944e09ecad5145 = 'dependency-line';

parcelRegister("9cikT", function(module, exports) {

$parcel$export(module.exports, "default", () => $7dcd03412ef5592d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ajpes = parcelRequire("ajpes");

var $eTXmK = parcelRequire("eTXmK");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $iHPnC = parcelRequire("iHPnC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $eGwbr = parcelRequire("eGwbr");

var $6k94P = parcelRequire("6k94P");
/* Even though this component represents a single line, multiple elements are used to achieve all of the requirements.
 * 1. An additional element with a larger surface area is used to capture interactions to improve the UX.
 * 2. Gradients cannot be applied to SVG elements using CSS. For this we use a linearGradient element.
 */ const $7dcd03412ef5592d$var$DependencyLine = ({ from: from, to: to, itemHeight: itemHeight, isOverlapping: isOverlapping, isSelected: isSelected, onClick: onClick })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isHovered, setIsHovered] = (0, $5uXOq.useState)(false);
    const onPathClick = (0, $5uXOq.useCallback)((event)=>{
        (0, $eTXmK.default)('timeline-dependency-clicked', event.timeStamp);
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'line'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'dependencyLine', {
            isOverlapping: isOverlapping
        });
        onClick(event, {
            fromId: from.id,
            toId: to.id,
            isOverlapping: isOverlapping,
            fromIndexOnScope: from.indexOnScope,
            toIndexOnScope: to.indexOnScope
        });
    }, [
        createAnalyticsEvent,
        isOverlapping,
        from,
        to,
        onClick
    ]);
    const onPathMouseEnter = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(true);
    }, []);
    const onPathMouseLeave = (0, $5uXOq.useCallback)(()=>{
        setIsHovered(false);
    }, []);
    const path = (0, $6k94P.getPath)(from, to, itemHeight);
    const gradientId = `linear-gradient-${from.id}-${to.id}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (isHovered || isSelected) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: gradientId,
        x1: from.x,
        x2: to.x,
        y1: from.y,
        y2: to.y,
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0%",
        stopColor: (0, $iHPnC.getValueFromColor)(from.color)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "100%",
        stopColor: (0, $iHPnC.getValueFromColor)(to.color)
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: path,
        fill: "transparent",
        strokeWidth: "2",
        stroke: $7dcd03412ef5592d$export$a73db48ef11a2bc3({
            isOverlapping: isOverlapping,
            isSelected: isSelected,
            isHovered: isHovered,
            gradientId: gradientId
        }),
        pointerEvents: "none",
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.dependency-line"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        position: "mouse",
        mousePosition: "top",
        content: formatMessage((0, $eGwbr.default).viewDetail),
        tag: "g"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7dcd03412ef5592d$var$InteractivePath // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: (0, $0afb8a62e53619f1$export$cd944e09ecad5145),
        d: path,
        stroke: "transparent",
        strokeWidth: "9",
        fill: "none",
        cursor: "pointer",
        onClick: onPathClick,
        onMouseEnter: onPathMouseEnter,
        onMouseLeave: onPathMouseLeave,
        "data-testid": "aais-dependency-lines-overlay.common.ui.line.interactive-path"
    })));
};
$7dcd03412ef5592d$var$DependencyLine.whyDidYouRender = true; // Custom memo to handle common case where 'from' and 'to' objects change reference but not value
var // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
$7dcd03412ef5592d$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7dcd03412ef5592d$var$DependencyLine, (0, (/*@__PURE__*/$parcel$interopDefault($ajpes))));
const $7dcd03412ef5592d$var$InteractivePath = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "path", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_lcxv1yxs",
            __cmplp.className
        ])
    });
});
const $7dcd03412ef5592d$export$a73db48ef11a2bc3 = ({ isOverlapping: isOverlapping, isSelected: isSelected, isHovered: isHovered, gradientId: gradientId })=>{
    const isHighlighted = isSelected || isHovered;
    if (isOverlapping) {
        if (isHighlighted) return "var(--ds-background-danger-bold-hovered, #AE2E24)";
        return "var(--ds-background-danger-bold, #C9372C)";
    }
    if (isHighlighted) return `url(#${gradientId})`;
    return "var(--ds-border-bold, #758195)";
};

});
parcelRegister("eGwbr", function(module, exports) {

$parcel$export(module.exports, "default", () => $188f0fa73c4b9066$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $188f0fa73c4b9066$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewDetail: {
        "id": "aais-dependency-lines-overlay.common.line.view-detail",
        "defaultMessage": "View dependency detail"
    }
});

});

parcelRegister("6k94P", function(module, exports) {

$parcel$export(module.exports, "getPath", () => $eb5c0917a150e0bd$export$2aa3fd96c49a84a8);

var $8QpSo = parcelRequire("8QpSo");
const $eb5c0917a150e0bd$var$calculateMidPoint = (from, to)=>({
        x: (from.x + to.x) / 2,
        y: (from.y + to.y) / 2
    });
const $eb5c0917a150e0bd$var$getY = (p1, p2, x)=>{
    const m = (p2.y - p1.y) / (p2.x - p1.x);
    return m * (x - p1.x) + p1.y;
};
// Generates half of the complex segment
const $eb5c0917a150e0bd$var$generateSegment = (start, end, offset)=>{
    const c1 = {
        x: start.x + offset.x,
        y: start.y
    };
    const c2 = {
        x: start.x + offset.x,
        y: start.y + offset.y
    };
    const s1 = {
        x: start.x,
        y: $eb5c0917a150e0bd$var$getY(c2, end, start.x)
    };
    return `M${start.x} ${start.y} C${c1.x} ${c1.y} ${c2.x} ${c2.y} ${s1.x} ${s1.y} L${s1.x} ${s1.y} ${end.x} ${end.y}`;
};
const $eb5c0917a150e0bd$var$getSegmentOffsets = (from, to, halfItemHeight)=>{
    const fromOffset = {
        x: halfItemHeight,
        y: from.y <= to.y ? halfItemHeight : -halfItemHeight
    };
    const toOffset = {
        x: -fromOffset.x,
        y: -fromOffset.y
    };
    return [
        fromOffset,
        toOffset
    ];
};
// Generates a path made up of two segments for when the dependency start is after the end
const $eb5c0917a150e0bd$var$generateComplexPath = (from, to, halfItemHeight)=>{
    const middle = $eb5c0917a150e0bd$var$calculateMidPoint(from, to);
    const [fromOffset, toOffset] = $eb5c0917a150e0bd$var$getSegmentOffsets(from, to, halfItemHeight);
    return `${$eb5c0917a150e0bd$var$generateSegment(from, middle, fromOffset)} ${$eb5c0917a150e0bd$var$generateSegment(to, middle, toOffset)}`;
};
//  Generates a single path for when the dependency start is before the end (happy case)
const $eb5c0917a150e0bd$var$generateSinglePath = (from, to, itemHeight)=>{
    const diffX = Math.abs(from.x - to.x);
    const progression = itemHeight + diffX * 0.1;
    return `M${from.x} ${from.y} C${from.x + progression} ${from.y} ${to.x - progression} ${to.y} ${to.x} ${to.y}`;
};
const $eb5c0917a150e0bd$export$2aa3fd96c49a84a8 = (0, $8QpSo.default)((from, to, itemHeight)=>from.x > to.x ? $eb5c0917a150e0bd$var$generateComplexPath(from, to, itemHeight / 2) : $eb5c0917a150e0bd$var$generateSinglePath(from, to, itemHeight));

});



parcelRegister("g1SUQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $25bf1c89593464fa$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Note: We use block comment at top of the file because we get strange error in `SSR Image Build`
/* eslint-disable @atlaskit/ui-styling-standard/no-styled,@atlaskit/ui-styling-standard/no-dynamic-styles -- To migrate as part of go/ui-styling-standard */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4R6GH = parcelRequire("4R6GH");

var $jgJNO = parcelRequire("jgJNO");

var $2OMDV = parcelRequire("2OMDV");

var $1tKcG = parcelRequire("1tKcG");

var $egeYB = parcelRequire("egeYB");
class $25bf1c89593464fa$export$55aef0c69232da84 extends (0, $5uXOq.Component) {
    componentDidUpdate() {
        const { links: links, onClose: onClose } = this.props;
        // close modal if all dependencies were removed
        if (links.length === 0) onClose();
    }
    render() {
        const { position: position, ...contentProps } = this.props;
        if (!(0, $4R6GH.fg)('plan-timeline-non-transposed')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
            isOpen: true,
            strategy: "absolute",
            onClose: contentProps.onClose,
            placement: "bottom-start",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egeYB.default), contentProps),
            trigger: ({ ref: ref })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25bf1c89593464fa$var$Anchor, {
                    top: position.top,
                    left: position.left,
                    ref: ref
                }),
            testId: "portfolio-3-dependency-line-detail.common.ui.modal.portfolio-dependency-line-detail-popup",
            messageId: "portfolio-3-dependency-line-detail.common.ui.modal.popup",
            messageType: "transactional"
        });
        // Considering removing the chart modal component when cleaning plan-timeline-non-transposed
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1tKcG.default), {
            position: position,
            content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $egeYB.default), {
                ...contentProps,
                onClose: contentProps.onClose
            }),
            onClose: contentProps.onClose
        });
    }
}
var $25bf1c89593464fa$export$2e2bcd8739ae039 = (0, $2OMDV.AnalyticsEventToProps)('tooltip', {
    onUnlink: 'unlinked'
})($25bf1c89593464fa$export$55aef0c69232da84);
const $25bf1c89593464fa$var$Anchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $lD23V.default)(`${__cmplp.left}px`),
            "--_1bsv5hl": (0, $lD23V.default)(`${__cmplp.top}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _1ltvdw55 _154ikz78",
            __cmplp.className
        ])
    });
});

});
parcelRegister("1tKcG", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7d483365831907$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $J8W7q = parcelRequire("J8W7q");
/**
 * Modals in the Chart are portalled out into a fixed position, as not to be clipped.
 */ const $ce7d483365831907$var$ChartModal = ({ position: position, content: content, testId: testId, onClose: onClose })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce7d483365831907$var$InlineDialogWrapper, {
        // eslint-disable-next-line jira/integration/enforce-data-testid-usage
        "data-test-id": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $J8W7q.default), {
        isOpen: true,
        content: // We would like to re-enable pointer events on the content of the inline dialog to allow interaction with its content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/design-system/consistent-css-prop-usage -- Ignored via go/DSP-18766
            xcss: (0, $8CUq3.xcss)({
                pointerEvents: 'initial'
            })
        }, content),
        onClose: onClose,
        closeOnScroll: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce7d483365831907$var$ModalAnchor, position)));
$ce7d483365831907$var$ChartModal.defaultProps = {
    testId: undefined
};
var $ce7d483365831907$export$2e2bcd8739ae039 = $ce7d483365831907$var$ChartModal;
// Child selector is for the nested inline dialog
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce7d483365831907$var$InlineDialogWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswstnw _154iidpf _1ltvidpf _94n5idpf _1xi2idpf _lcxvglyw _ogwtidpf _6tinidpf _1cezidpf _m3zkidpf _hc7q15vq _njtz15vq _bp7o1cd0",
            __cmplp.className
        ])
    });
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ce7d483365831907$var$ModalAnchor = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { left: left, top: top, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_t50dub": (0, $lD23V.default)(`${__cmplp.left}px`),
            "--_1bsv5hl": (0, $lD23V.default)(`${__cmplp.top}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1n9t _1ltvdw55 _154ikz78",
            __cmplp.className
        ])
    });
});

});
parcelRegister("J8W7q", function(module, exports) {

$parcel$export(module.exports, "default", () => $866e6794e0ff4648$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $eHJxW = parcelRequire("eHJxW");
const $866e6794e0ff4648$var$INLINE_DIALOG_PADDING = 32;
const $866e6794e0ff4648$var$THRESHOLD = 50;
const $866e6794e0ff4648$var$TIMEOUT = 500;
function $866e6794e0ff4648$var$WithCloseOnScroll({ isOpen: isOpen, children: children }) {
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const containerElement = document.body;
    const distanceXRef = (0, $5uXOq.useRef)(0);
    const distanceYRef = (0, $5uXOq.useRef)(0);
    const timeoutIdRef = (0, $5uXOq.useRef)();
    const shouldClose = ()=>Math.abs(distanceXRef.current) >= $866e6794e0ff4648$var$THRESHOLD || Math.abs(distanceYRef.current) >= $866e6794e0ff4648$var$THRESHOLD;
    const resetThresholdChecking = (0, $5uXOq.useCallback)(()=>{
        distanceYRef.current = 0;
        distanceXRef.current = 0;
        timeoutIdRef.current = undefined;
    }, []);
    const closeDialog = (0, $5uXOq.useCallback)(()=>containerElement?.click(), [
        containerElement
    ]);
    // Function will check if the scroll delta (both horizontal and vertical) is
    // larger than the threshold and close the dialog.
    // If the scroll delta is less than the threshold, we sum all scroll deltas in 500ms.
    // If the sum is larger than the threshold, we close the dialog.
    // Reasoning: want to prevent the dialog from closing immediately if the user accidentally scrolls a few pixels.
    const handleWheel = (0, $5uXOq.useCallback)((e)=>{
        e.stopPropagation();
        distanceXRef.current += e.deltaX;
        distanceYRef.current += e.deltaY;
        if (shouldClose()) {
            closeDialog();
            resetThresholdChecking();
        }
        if (!timeoutIdRef.current) timeoutIdRef.current = setTimeout(()=>{
            if (shouldClose()) closeDialog();
            resetThresholdChecking();
        }, $866e6794e0ff4648$var$TIMEOUT);
    }, [
        closeDialog,
        resetThresholdChecking
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isOpen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('wheel', handleWheel, {
            passive: true
        });
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('wheel', handleWheel);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window.removeEventListener('wheel', handleWheel);
    }, [
        isOpen,
        handleWheel
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
}
class $866e6794e0ff4648$export$2e2bcd8739ae039 extends (0, $5uXOq.PureComponent) {
    static{
        this.defaultProps = {
            testId: 'data-inline-dialog-content'
        };
    }
    componentDidMount() {
        this.updateContainerStyles();
    }
    componentDidUpdate() {
        this.updateContainerStyles();
    }
    render() {
        return this.props.closeOnScroll ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($866e6794e0ff4648$var$WithCloseOnScroll, {
            isOpen: this.props.isOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            ...this.props,
            messageId: "portfolio-3-common.inline-dialog.ak-inline-dialog.inline-dialog",
            messageType: "transactional"
        })) : // @ts-expect-error - TS2741 - Property 'content' is missing in type '{ children?: ReactNode; }' but required in type 'Pick<Pick<PropsWithChildren<InlineDialogProps>, "children" | "content" | "testId" | "strategy" | "isOpen" | "placement" | "onContentBlur" | "onContentClick" | "onContentFocus" | "onClose"> & RefAttributes<...> & WithContextProps, "children" | ... 10 more ... | "onClose">'.
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
            ...this.props,
            messageId: "portfolio-3-common.inline-dialog.ak-inline-dialog.inline-dialog.2",
            messageType: "transactional"
        });
    }
    constructor(...args){
        super(...args), // eslint-disable-next-line react/sort-comp
        this.updateContainerStyles = ()=>{
            const { maxWidth: maxWidth, minWidth: minWidth, isOpen: isOpen, noPaddings: noPaddings, noHorizontalScroll: noHorizontalScroll, zIndex: zIndex, overflow: overflow } = this.props;
            if (!isOpen) return;
            // eslint-disable-next-line react/no-find-dom-node
            const node = (0, $7nsd3.findDOMNode)(this);
            // this should find dialog content container,
            // keep it updated as you upgrade @atlaskit/inline-dialog
            const container = node && node.nextElementSibling;
            if (!(container instanceof HTMLElement)) return;
            if (noPaddings) container.style.padding = '0';
            if (maxWidth) {
                const width = noPaddings ? maxWidth : maxWidth + $866e6794e0ff4648$var$INLINE_DIALOG_PADDING;
                container.style.maxWidth = `${width}px`;
                container.style.overflow = 'auto';
            }
            if (minWidth) {
                const width = noPaddings ? minWidth : minWidth + $866e6794e0ff4648$var$INLINE_DIALOG_PADDING;
                container.style.minWidth = `${width}px`;
                container.style.overflow = 'auto';
            }
            if (overflow) container.style.overflow = overflow;
            if (noHorizontalScroll) container.style.maxWidth = 'initial';
            container.style.maxHeight = 'initial';
            //  custom zIndex can be used only when we have 2 or more inline dialogs and has to define their priorities
            // initially it has been added because of https://bulldog.internal.atlassian.com/browse/JPOS-4104
            container.style.zIndex = zIndex;
        };
    }
}

});


parcelRegister("egeYB", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fc7195c3567e862$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2kh23 = parcelRequire("2kh23");

var $8QpSo = parcelRequire("8QpSo");

var $bU3PY = parcelRequire("bU3PY");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $1p96B = parcelRequire("1p96B");

var $DVljb = parcelRequire("DVljb");

var $4R6GH = parcelRequire("4R6GH");

var $h7glD = parcelRequire("h7glD");

var $ejkLh = parcelRequire("ejkLh");

var $1rEpC = parcelRequire("1rEpC");

var $3wpeS = parcelRequire("3wpeS");

var $c9xwE = parcelRequire("c9xwE");
const $2fc7195c3567e862$var$createUnlinkHandler = (0, $8QpSo.default)((itemKey, type, fromId, toId, onUnlink, callback)=>()=>{
        onUnlink({
            itemKey: itemKey,
            type: type,
            sourceItemKey: fromId,
            targetItemKey: toId
        });
        if (callback) callback();
    });
const $2fc7195c3567e862$var$SimpleOverlapWarning = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Warning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        LEGACY_size: "small",
        label: "",
        color: "var(--ds-icon-warning, #E56910)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        weight: "bold",
        color: "inherit"
    }, formatMessage((0, $3wpeS.default).offTrack)));
};
const $2fc7195c3567e862$var$OverlapWarning = ({ fromIssue: fromIssue, toIssue: toIssue })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $DVljb.useLocale)();
    if (!(fromIssue && fromIssue.dueDate && fromIssue.dueDate > 0 && toIssue && toIssue.startDate && toIssue.startDate > 0)) return null;
    const leadTime = toIssue.startDate - fromIssue.dueDate;
    let overlapPeriod = null; // if "end date" of issue A is May 4, 2021 and "start date" of issue B is May 5, 2021, then leadTime = 1
    if (leadTime === 1) // we display a leadTimeMessage "less than a day"
    // note: we don't use distanceInWords as it would return 'less than a minute'
    overlapPeriod = formatMessage((0, $3wpeS.default).lessThanOneDayLeadTime);
    else overlapPeriod = (0, $2kh23.default)(fromIssue.dueDate, toIssue.startDate, {
        locale: (0, $1p96B.getLocale)(locale)
    });
    return overlapPeriod ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Warning, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$WarningIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bU3PY))), {
        LEGACY_size: "small",
        label: "",
        color: "var(--ds-icon-warning, #E56910)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        weight: "bold",
        color: "inherit"
    }, `${formatMessage((0, $3wpeS.default).overlapDatesMessage)} (${overlapPeriod})`, ' ')) : null;
};
const $2fc7195c3567e862$var$ModalContent = (props)=>{
    const { links: links, onUnlink: onUnlink, onClose: onClose, canDelete: canDelete, isOverlapping: isOverlapping, id: id, simpleOverlap: simpleOverlap = false } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    if (links.length === 0) return null;
    const { fromIssue: firstFromIssue, toIssue: firstToIssue, isOfftrack: isOfftrack } = links[0];
    let isDependenciesDatesOverlapping = false;
    if (simpleOverlap) isDependenciesDatesOverlapping = isOfftrack ?? false;
    else if (isOverlapping) // Only used on the timeline
    // On the dependencies report, isOverlapping returns the rolled up isNegativeLeadTime for the dependency line regardless of what value gets passed in here
    isDependenciesDatesOverlapping = isOverlapping(firstFromIssue.indexOnScope, firstToIssue.indexOnScope);
    const defaultOutwardDependencyDescription = formatMessage((0, $3wpeS.default).blocks);
    const shouldCloseOnUnlink = links.length <= 1;
    const LineComponent = (0, $4R6GH.fg)('plans_dep_report_reactflow_migration_enabled') ? (0, $ejkLh.default) : (0, $1rEpC.default);
    const dependenciesBlock = links.map((link, index)=>{
        const { fromIssue: fromIssue, toIssue: toIssue, issueLinkType: issueLinkType, itemKey: itemKey, isOfftrack: isChildDependencyOfftrack } = link;
        const renderOverlapWarning = ()=>{
            if (simpleOverlap) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$SimpleOverlapWarning, null);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$OverlapWarning, {
                fromIssue: fromIssue,
                toIssue: toIssue
            });
        };
        const isChildDependenciesDatesOverlapping = isChildDependencyOfftrack !== undefined && !simpleOverlap && (0, $4R6GH.fg)('plans_roll_up_child_dependency_overlap_states') ? isChildDependencyOfftrack : isDependenciesDatesOverlapping;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            key: `${issueLinkType.id}_${fromIssue.id}_${toIssue.id}`
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h7glD.default), fromIssue), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c9xwE.default), {
            label: issueLinkType.outward ?? defaultOutwardDependencyDescription,
            isOverlapping: isChildDependenciesDatesOverlapping,
            onUnlink: canDelete ? $2fc7195c3567e862$var$createUnlinkHandler(itemKey, issueLinkType.id, fromIssue.id, toIssue.id, onUnlink, shouldCloseOnUnlink ? onClose : undefined) : undefined
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h7glD.default), toIssue), isChildDependenciesDatesOverlapping && renderOverlapWarning(), index < links.length - 1 ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(LineComponent, null) : null);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Container, {
        id: id,
        "data-testid": "portfolio-3-dependency-line-detail.common.ui.content.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2fc7195c3567e862$var$Content, null, dependenciesBlock));
};
$2fc7195c3567e862$var$ModalContent.defaultProps = {
    onUnlink: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    canDelete: false
};
var $2fc7195c3567e862$export$2e2bcd8739ae039 = $2fc7195c3567e862$var$ModalContent;
const $2fc7195c3567e862$var$TOOLTIP_Z_INDEX = 13; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fc7195c3567e862$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1reo1wug _18m91wug _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi _bfhkhp5a _1bsbp3fh _16qszucj _c71l1mjv _1pbyilow",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fc7195c3567e862$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fc7195c3567e862$var$Warning = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulp1b66 _1e0c1txw _19pkutpp",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2fc7195c3567e862$var$WarningIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ae4v1h6o _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("h7glD", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa6aba85930eb9e5$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4R6GH = parcelRequire("4R6GH");

var $8RXs9 = parcelRequire("8RXs9");

var $2FvnI = parcelRequire("2FvnI");

var $jVjIH = parcelRequire("jVjIH");

var $jceGp = parcelRequire("jceGp");
const $fa6aba85930eb9e5$var$DependencyCard = (props)=>{
    const { title: title, issueKey: issueKey, projectKey: projectKey, iconUrl: iconUrl, typeName: typeName, intl: { formatMessage: formatMessage } } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Content, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$ContentLeft, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$TitleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$TypeIconContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVjIH.default), {
        src: iconUrl || '',
        alt: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $jceGp.default).iconAltTextIssueTermRefresh : (0, $jceGp.default).iconAltText, {
            typeName: typeName
        })
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$IssueLinkContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FvnI.default), {
        issueKey: issueKey,
        projectKey: projectKey
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($fa6aba85930eb9e5$var$Title, {
        title: title
    }, title)))));
};
$fa6aba85930eb9e5$var$DependencyCard.displayName = 'DependencyCard';
var $fa6aba85930eb9e5$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($fa6aba85930eb9e5$var$DependencyCard);
const $fa6aba85930eb9e5$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _kqswh2mm _ca0qu2gc _u5f3pxbi _n3tdu2gc _19bvpxbi _bfhkm7j4",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa6aba85930eb9e5$var$Content = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $fa6aba85930eb9e5$var$ContentLeft = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _2lx21bp4 _16jlkb7n",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$TitleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _kqswh2mm _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$TypeIconContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2hwxu2gc",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$Title = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1reo15vq _18m915vq _1rjcv77o _syaz1fxt _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $fa6aba85930eb9e5$var$IssueLinkContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y9ia1q9c _1txj12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2FvnI", function(module, exports) {

$parcel$export(module.exports, "default", () => $33a521d9c353e74c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jhmo0 = parcelRequire("jhmo0");
var $8CUq3 = parcelRequire("8CUq3");

var $fb9D1 = parcelRequire("fb9D1");

var $8zOmE = parcelRequire("8zOmE");
function $33a521d9c353e74c$export$2e2bcd8739ae039(props) {
    const { projectKey: projectKey, issueKey: issueKey, issueId: issueId, xcssStyles: xcssStyles, children: children, ariaLabel: ariaLabel } = props;
    const fullIssueKey = issueKey ? `${projectKey}-${issueKey}` : projectKey;
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'scopeIssueKey');
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jhmo0.default), {
        href: (0, $fb9D1.proxyContextSafeUrl)(`/browse/${fullIssueKey}`),
        rel: "noopener noreferrer",
        id: issueId && `issue-link-${issueId}`,
        xcss: [
            $33a521d9c353e74c$var$anchorStyles,
            ...xcssStyles ? [
                xcssStyles
            ] : []
        ],
        target: "_blank",
        draggable: false,
        "aria-label": ariaLabel,
        onClick: onClick
    }, children || fullIssueKey);
}
const $33a521d9c353e74c$var$anchorStyles = (0, $8CUq3.xcss)({
    outlineOffset: 'space.0'
});

});

parcelRegister("jVjIH", function(module, exports) {

$parcel$export(module.exports, "default", () => $82127cf68330cc05$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $82127cf68330cc05$var$Icon = ({ src: src, alt: alt, size: size })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($82127cf68330cc05$var$IconImage, {
        src: src,
        alt: alt,
        width: size,
        height: size
    });
$82127cf68330cc05$var$Icon.defaultProps = {
    alt: '',
    size: '16px'
};
var $82127cf68330cc05$export$2e2bcd8739ae039 = $82127cf68330cc05$var$Icon;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $82127cf68330cc05$var$IconImage = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _2rko1l7b",
            __cmplp.className
        ])
    });
});

});

parcelRegister("jceGp", function(module, exports) {

$parcel$export(module.exports, "default", () => $567d8624a9993f3b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $567d8624a9993f3b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    iconAltText: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.card.icon-alt-text",
        "defaultMessage": "{typeName} issue type"
    },
    iconAltTextIssueTermRefresh: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.card.icon-alt-text-issue-term-refresh",
        "defaultMessage": "{typeName} work type"
    }
});

});


parcelRegister("ejkLh", function(module, exports) {

$parcel$export(module.exports, "default", () => $82cf6945d1e605c6$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $82cf6945d1e605c6$var$containerStyles = null;
const $82cf6945d1e605c6$var$lineStyles = null;
const $82cf6945d1e605c6$var$Line = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ca0qpxbi _n3tdpxbi"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            "_189et94y _1dqonqa1 _1h6dmuej _1e0c1txw _vchhusvi _4t3it94y _1bsb1osq"
        ])
    }));
var $82cf6945d1e605c6$export$2e2bcd8739ae039 = $82cf6945d1e605c6$var$Line;

});

parcelRegister("1rEpC", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebcb9e341621a41c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // Delete this file when removing the

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ebcb9e341621a41c$var$Line = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebcb9e341621a41c$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebcb9e341621a41c$var$LineDiv, null));
var $ebcb9e341621a41c$export$2e2bcd8739ae039 = $ebcb9e341621a41c$var$Line;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebcb9e341621a41c$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ca0qpxbi _u5f3pxbi _n3tdpxbi _19bvpxbi",
            __cmplp.className
        ])
    });
});
const $ebcb9e341621a41c$var$LineDiv = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189et94y _1dqonqa1 _1h6ds4qr _1e0c1txw _vchhusvi _4t3it94y _1bsb1osq",
            __cmplp.className
        ])
    });
});

});

parcelRegister("3wpeS", function(module, exports) {

$parcel$export(module.exports, "default", () => $d8a703673539a6f1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d8a703673539a6f1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    blocks: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.blocks",
        "defaultMessage": "blocks"
    },
    overlapDatesMessage: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.overlap-dates-message",
        "defaultMessage": "Dates overlap"
    },
    lessThanOneDayLeadTime: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.less-than-one-day-lead-time",
        "defaultMessage": "less than 1 day"
    },
    offTrack: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.off-track",
        "defaultMessage": "Off-track"
    }
});

});

parcelRegister("c9xwE", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cab14210217549d$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jOyH3 = parcelRequire("jOyH3");

var $2ZvSj = parcelRequire("2ZvSj");
const $9cab14210217549d$var$Separator = ({ label: label, isOverlapping: isOverlapping, onUnlink: onUnlink })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$SeparatorContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Line, {
        isOverlapping: isOverlapping
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$IconWrapper, {
        isOverlapping: isOverlapping
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jOyH3))), {
        LEGACY_size: "small",
        label: label,
        color: "var(--ds-text-inverse, #FFFFFF)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$Line, {
        isOverlapping: isOverlapping
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$TextContainer, null, label), onUnlink && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9cab14210217549d$var$UnlinkButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZvSj.default), {
        onClick: onUnlink
    })));
var $9cab14210217549d$export$2e2bcd8739ae039 = $9cab14210217549d$var$Separator;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9cab14210217549d$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _kqswh2mm",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$SeparatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _18u0pxbi _2hwxu2gc _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$TextContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _16jlkb7n _4cvr1h6o _vwz4dlk8",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverlapping: isOverlapping, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsbgktf _4t3igktf _16qszucj",
            __cmplp.isOverlapping ? "_bfhks4qr" : "_bfhk1oju",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$Line = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isOverlapping: isOverlapping, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_189et94y _1dqonqa1 _4t3i19bv",
            __cmplp.isOverlapping ? "_1h6ds4qr" : "_1h6d1oju",
            __cmplp.className
        ])
    });
});
const $9cab14210217549d$var$UnlinkButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _ae4v1h6o _1n261g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jOyH3", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c2e6e563a714afa66b2c445d0695bd6>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6cd993777d46e1b$var$_react = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e6cd993777d46e1b$var$_link = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("1f9bV")));

var $e6cd993777d46e1b$var$_link2 = $e6cd993777d46e1b$var$_interopRequireDefault((parcelRequire("458iJ")));
function $e6cd993777d46e1b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LinkIcon.
 * This component is LinkIcon, with `UNSAFE_fallbackIcon` set to "LinkIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for links, urls, or copy link.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e6cd993777d46e1b$var$LinkIcon = (props)=>/*#__PURE__*/ $e6cd993777d46e1b$var$_react.default.createElement($e6cd993777d46e1b$var$_link.default, Object.assign({
        LEGACY_fallbackIcon: $e6cd993777d46e1b$var$_link2.default
    }, props));
$e6cd993777d46e1b$var$LinkIcon.Name = 'LinkIconMigration';
var $e6cd993777d46e1b$var$_default = module.exports.default = $e6cd993777d46e1b$var$LinkIcon;

});
parcelRegister("458iJ", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2f8e117d74b4de46$var$_react = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2f8e117d74b4de46$var$_link = $2f8e117d74b4de46$var$_interopRequireDefault((parcelRequire("1f9bV")));
function $2f8e117d74b4de46$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2f8e117d74b4de46$var$LinkIcon = (props)=>/*#__PURE__*/ $2f8e117d74b4de46$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="m12.856 5.457-.937.92a1 1 0 0 0 0 1.437 1.047 1.047 0 0 0 1.463 0l.984-.966c.967-.95 2.542-1.135 3.602-.288a2.54 2.54 0 0 1 .203 3.81l-2.903 2.852a2.646 2.646 0 0 1-3.696 0l-1.11-1.09L9 13.57l1.108 1.089c1.822 1.788 4.802 1.788 6.622 0l2.905-2.852a4.558 4.558 0 0 0-.357-6.82c-1.893-1.517-4.695-1.226-6.422.47"/><path d="m11.144 19.543.937-.92a1 1 0 0 0 0-1.437 1.047 1.047 0 0 0-1.462 0l-.985.966c-.967.95-2.542 1.135-3.602.288a2.54 2.54 0 0 1-.203-3.81l2.903-2.852a2.646 2.646 0 0 1 3.696 0l1.11 1.09L15 11.43l-1.108-1.089c-1.822-1.788-4.802-1.788-6.622 0l-2.905 2.852a4.558 4.558 0 0 0 .357 6.82c1.893 1.517 4.695 1.226 6.422-.47"/></g></svg>`
    }, props, {
        newIcon: $2f8e117d74b4de46$var$_link.default
    }));
$2f8e117d74b4de46$var$LinkIcon.displayName = 'LinkIcon';
var $2f8e117d74b4de46$var$_default = module.exports.default = $2f8e117d74b4de46$var$LinkIcon;

});


parcelRegister("2ZvSj", function(module, exports) {

$parcel$export(module.exports, "default", () => $3fedf5e35b4f7698$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $fVnbM = parcelRequire("fVnbM");

var $5k1dC = parcelRequire("5k1dC");

var $3bDjY = parcelRequire("3bDjY");

var $8RXs9 = parcelRequire("8RXs9");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");


var $1qzuX = parcelRequire("1qzuX");
// eslint-disable-next-line jira/react/no-class-components
class $3fedf5e35b4f7698$var$UnlinkButton extends (0, $5uXOq.Component) {
    render() {
        const { intl: { formatMessage: formatMessage } } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $1qzuX.default).unlink)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            testId: "portfolio-3-dependency-line-detail.common.ui.content.common.components.unlink-button.unlink-button",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5k1dC))), {
                label: formatMessage((0, $1qzuX.default).unlink),
                LEGACY_size: "medium",
                spacing: "spacious"
            }),
            spacing: "compact",
            appearance: "subtle",
            onClick: this.onClick
        }));
    }
    constructor(...args){
        super(...args), this.onClick = (event, analyticsEvent)=>{
            event.stopPropagation();
            this.props.onClick();
            const [actionSubject, action] = (0, $39bd3c5308a092a2$export$de7a70543cfab9e).split(' ');
            const analyticsPayload = {
                source: 'dependencyLineDetail'
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent.update({
                action: action,
                actionSubject: actionSubject
            }), analyticsPayload);
        };
    }
}
var $3fedf5e35b4f7698$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8RXs9.default), (0, $2OMDV.AnalyticsEventToProps)('button', {
    onClick: 'clicked'
}))($3fedf5e35b4f7698$var$UnlinkButton);

});
const $39bd3c5308a092a2$export$de7a70543cfab9e = 'issueDependencyLink deleted';

parcelRegister("1qzuX", function(module, exports) {

$parcel$export(module.exports, "default", () => $dac8baf8a85055d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dac8baf8a85055d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    unlink: {
        "id": "portfolio-3-dependency-line-detail.common.ui.content.common.components.unlink-button.unlink",
        "defaultMessage": "Remove dependency"
    }
});

});






parcelRegister("5AKFd", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8dbdd46bfa6ce7e$export$2e2bcd8739ae039);

var $4CeiT = parcelRequire("4CeiT");

var $bC2fB = parcelRequire("bC2fB");

var $2xFXk = parcelRequire("2xFXk");


var $1vXOx = parcelRequire("1vXOx");

var $kc6Ry = parcelRequire("kc6Ry");

var $5mTgl = parcelRequire("5mTgl");
const $c8dbdd46bfa6ce7e$export$c31df4bd766f9c35 = (state, ownProps)=>{
    const { id: id } = ownProps;
    const isDraggable = (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$1d4594bb2516d9ef] && (0, $5mTgl.isInlineColumnEditEnabled)(state) || false;
    return {
        isDraggable: isDraggable,
        flexibleColumns: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).FLEXIBLE_BOARD_COLUMNS),
        appearance: (0, $5mTgl.getColumnTheme)(state, Number(id)),
        isUpdating: (0, $5mTgl.isColumnUpdating)(state)(id),
        // passing ownProps
        id: ownProps.id,
        draggableIndex: ownProps.draggableIndex,
        header: ownProps.header || null
    };
};
var $c8dbdd46bfa6ce7e$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($c8dbdd46bfa6ce7e$export$c31df4bd766f9c35, {})((0, $4CeiT.default));

});


parcelRegister("2h6St", function(module, exports) {

$parcel$export(module.exports, "UnassignedWorkAnalytics", () => $fb7bb0edd91eccde$export$490537928615d3b3);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $67sX6 = parcelRequire("67sX6");

var $h5aFt = parcelRequire("h5aFt");

var $5mTgl = parcelRequire("5mTgl");
const $fb7bb0edd91eccde$export$490537928615d3b3 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const userHasIncompleteAssignedIssues = (0, $67sX6.useBoardSelector)((0, $h5aFt.userHasIncompleteAssignedIssuesSelector));
    const boardHasIncompleteUnassignedWork = (0, $67sX6.useBoardSelector)((0, $h5aFt.boardHasIncompleteUnassignedWorkSelector));
    const numberOfWorkItems = (0, $67sX6.useBoardSelector)((0, $5mTgl.workIssuesCountSelector));
    (0, $5uXOq.useEffect)(()=>{
        const event = createAnalyticsEvent({});
        if (numberOfWorkItems > 0) (0, $8zOmE.fireTrackAnalytics)(event, 'boardInState viewed', {
            userHasIncompleteAssignedIssues: userHasIncompleteAssignedIssues,
            boardHasIncompleteUnassignedWork: boardHasIncompleteUnassignedWork
        });
    }, [
        createAnalyticsEvent,
        userHasIncompleteAssignedIssues,
        boardHasIncompleteUnassignedWork,
        numberOfWorkItems
    ]);
    return null;
};

});
parcelRegister("h5aFt", function(module, exports) {

$parcel$export(module.exports, "userHasIncompleteAssignedIssuesSelector", () => $ac0ca169f7d5c38e$export$9bc7220098bcf10);
$parcel$export(module.exports, "numberOfUserHasCompleteAssignedIssuesSelector", () => $ac0ca169f7d5c38e$export$934e5ce704246277);
$parcel$export(module.exports, "boardHasIncompleteUnassignedWorkSelector", () => $ac0ca169f7d5c38e$export$e8008c7aa147a522);
$parcel$export(module.exports, "shouldShowUnassignedFilterNudgeSelector", () => $ac0ca169f7d5c38e$export$4d90a7c60aeaa3b);

var $dGvGJ = parcelRequire("dGvGJ");

var $iuuJH = parcelRequire("iuuJH");

var $3UY9S = parcelRequire("3UY9S");

var $36pz7 = parcelRequire("36pz7");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");
const $ac0ca169f7d5c38e$export$9bc7220098bcf10 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.workFilteredIssuesSelector),
    (0, $3UY9S.getIssueChildren),
    (0, $36pz7.getCurrentUserAccountId),
    (0, $45cXl.getSwimlaneMode)
], (issues, childrenIssue, accountId, swimlaneMode)=>{
    if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return issues.some((issue)=>!issue.isDone && issue.assigneeAccountId === accountId);
    return [
        ...issues,
        ...Object.values(childrenIssue)
    ].some((issue)=>!issue.isDone && issue.assigneeAccountId === accountId);
});
const $ac0ca169f7d5c38e$export$934e5ce704246277 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.workFilteredIssuesSelector),
    (0, $3UY9S.getIssueChildren),
    (0, $36pz7.getCurrentUserAccountId),
    (0, $45cXl.getSwimlaneMode)
], (issues, childrenIssue, accountId, swimlaneMode)=>{
    if (swimlaneMode !== (0, $iuuJH.SWIMLANE_BY_SUBTASK).id) return issues.filter((issue)=>issue.isDone && issue.assigneeAccountId === accountId).length;
    return [
        ...issues,
        ...Object.values(childrenIssue)
    ].filter((issue)=>issue.isDone && issue.assigneeAccountId === accountId).length;
});
const $ac0ca169f7d5c38e$export$e8008c7aa147a522 = (0, $dGvGJ.createSelector)([
    (0, $5mTgl.workFilteredIssuesSelector)
], (issues)=>issues.some((issue)=>!issue.isDone && (issue.assigneeAccountId === undefined || issue.assigneeAccountId === null)));
const $ac0ca169f7d5c38e$export$4d90a7c60aeaa3b = (0, $dGvGJ.createSelector)([
    $ac0ca169f7d5c38e$export$9bc7220098bcf10,
    $ac0ca169f7d5c38e$export$e8008c7aa147a522
], (userHasIncompleteAssignedIssues, boardHasIncompleteUnassignedWork)=>!userHasIncompleteAssignedIssues && boardHasIncompleteUnassignedWork);

});




parcelRegister("gGhzv", function(module, exports) {

$parcel$export(module.exports, "default", () => $91db37837dd05a9a$export$2e2bcd8739ae039);

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");


var $2f454 = parcelRequire("2f454");

var $4gHuj = parcelRequire("4gHuj");

var $dW1HX = parcelRequire("dW1HX");

var $3n65g = parcelRequire("3n65g");

var $71oFY = parcelRequire("71oFY");

var $evkwq = parcelRequire("evkwq");

var $2ON1s = parcelRequire("2ON1s");

var $fqLDH = parcelRequire("fqLDH");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5MBGv = parcelRequire("5MBGv");

var $hUbDe = parcelRequire("hUbDe");
const $91db37837dd05a9a$var$mapStateToProps = (state)=>({
        // @ts-expect-error - TS2322 - Type 'string | null | undefined' is not assignable to type 'string'.
        cardKey: (0, $fqLDH.getIssueKeyForModal)(state),
        cardId: (0, $fqLDH.getIssueIdForModal)(state),
        timestamp: (0, $fqLDH.getTimestampForModal)(state),
        externalAction: (0, $fqLDH.getExternalActionForModal)(state),
        boardSessionId: (0, $67Z81.sessionIdSelector)(state),
        activeSprints: (0, $ebHh7.activeSprintsSelector)(state),
        selectedSprints: (0, $ebHh7.getSelectedSprintsKeys)(state),
        isSprintsEnabled: (0, $ebHh7.isSprintsEnabled)(state),
        selectedIssueKey: (0, $fqLDH.getIssueKeyForModal)(state)
    });
const $91db37837dd05a9a$var$mapDispatchToProps = {
    closeIssueModal: $dW1HX.closeIssueModal,
    issueUpdateRequest: $evkwq.issueUpdateRequest,
    setIssueParentSummary: $3n65g.setIssueParentSummary,
    cardDelete: $2f454.cardDelete,
    cardDeleteOptimistic: $2f454.cardDeleteOptimistic,
    onTogglePanel: (0, $2ON1s.togglePanel),
    onCloseInsightsPanel: (0, $2ON1s.closeInsightsPanel),
    issueBentoUpdate: $evkwq.issueBentoUpdate,
    setIssueChildrenRank: $4gHuj.setIssueChildrenRank,
    setIssuesRank: $71oFY.setIssuesRank,
    onResetExternalAction: (0, $dW1HX.resetExternalAction)
};
const $91db37837dd05a9a$var$onDeleteFactory = (0, $8QpSo.default)((dispatchPropsCardDeleteOptimistic, cardId, dispatchPropsIssueUpdateRequest)=>({ issueId: issueId })=>{
        dispatchPropsCardDeleteOptimistic(Number(issueId));
        if (issueId && Number(issueId) !== cardId) dispatchPropsIssueUpdateRequest([
            cardId || 0
        ], (0, $f32ae13c2b9742f4$export$306c754c61954570));
    });
const $91db37837dd05a9a$var$onCloseFactory = (0, $8QpSo.default)((selectedIssueKey, dispatchPropsCloseIssueModal)=>()=>{
        selectedIssueKey && dispatchPropsCloseIssueModal(selectedIssueKey);
    });
const $91db37837dd05a9a$var$mergeProps = (stateProps, dispatchProps, ownProps)=>({
        ...ownProps,
        cardKey: stateProps.cardKey,
        timestamp: stateProps.timestamp,
        externalAction: stateProps.externalAction,
        boardSessionId: stateProps.boardSessionId,
        selectedIssueKey: stateProps.selectedIssueKey,
        cardId: stateProps.cardId,
        onDelete: $91db37837dd05a9a$var$onDeleteFactory(dispatchProps.cardDeleteOptimistic, stateProps.cardId, dispatchProps.issueUpdateRequest),
        onChange: dispatchProps.issueBentoUpdate,
        onClose: $91db37837dd05a9a$var$onCloseFactory(stateProps.selectedIssueKey, dispatchProps.closeIssueModal),
        onCloseInsightsClick: dispatchProps.onCloseInsightsPanel,
        onResetExternalAction: dispatchProps.onResetExternalAction,
        activeSprints: stateProps.activeSprints,
        selectedSprints: stateProps.selectedSprints,
        isSprintsEnabled: stateProps.isSprintsEnabled,
        IssueWrapper: (0, $5MBGv.default)
    });
const $91db37837dd05a9a$var$ConnectedDetailView = (0, $bC2fB.connect)($91db37837dd05a9a$var$mapStateToProps, $91db37837dd05a9a$var$mapDispatchToProps, $91db37837dd05a9a$var$mergeProps)((0, $hUbDe.default));
var $91db37837dd05a9a$export$2e2bcd8739ae039 = $91db37837dd05a9a$var$ConnectedDetailView;

});
parcelRegister("5MBGv", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc568eefd9719671$export$2e2bcd8739ae039);

var $dGvGJ = parcelRequire("dGvGJ");

var $bC2fB = parcelRequire("bC2fB");

var $ijnUs = parcelRequire("ijnUs");

var $67Z81 = parcelRequire("67Z81");

var $fpo1G = parcelRequire("fpo1G");
const $fc568eefd9719671$var$getBoardCardCountMemoized = ()=>(0, $dGvGJ.createSelector)((0, $ijnUs.getBoardCardCount), (res)=>res);
const $fc568eefd9719671$var$mapStateToPropsFactory = ()=>{
    const getBoardCardCountInstance = $fc568eefd9719671$var$getBoardCardCountMemoized();
    return (state)=>({
            boardCardCount: getBoardCardCountInstance(state),
            isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
        });
};
const $fc568eefd9719671$var$ConnectedIssueWrapper = (0, $bC2fB.connect)($fc568eefd9719671$var$mapStateToPropsFactory, {})((0, $fpo1G.default));
var $fc568eefd9719671$export$2e2bcd8739ae039 = $fc568eefd9719671$var$ConnectedIssueWrapper;

});
parcelRegister("ijnUs", function(module, exports) {

$parcel$export(module.exports, "getBoardCardCount", () => $b0f6b014cf626ab0$export$3c45ba0e35d4ef0a);

var $vAfHD = parcelRequire("vAfHD");

var $5mTgl = parcelRequire("5mTgl");
const $b0f6b014cf626ab0$export$3c45ba0e35d4ef0a = (state)=>({
        cardsCount: (0, $vAfHD.boardOrderedIssueIdsSelector)(state).length,
        visibleCardsCount: (0, $5mTgl.workFilteredIssuesSelector)(state).length
    });

});

parcelRegister("fpo1G", function(module, exports) {

$parcel$export(module.exports, "default", () => $c7a9ddf7b63aaf97$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $7wqBZ = parcelRequire("7wqBZ");

var $hUXfN = parcelRequire("hUXfN");

var $fOGZN = parcelRequire("fOGZN");

var $7eqRV = parcelRequire("7eqRV");


var $kxZPA = parcelRequire("kxZPA");

var $bWjJb = parcelRequire("bWjJb");

var $dWjj9 = parcelRequire("dWjj9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $c7a9ddf7b63aaf97$var$IssueApp = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("a03V9")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/issue-app.tsx"
});
const $c7a9ddf7b63aaf97$var$NEXT_GEN_BOARD_ANALYTICS_SOURCE = 'simple-software-board';
const $c7a9ddf7b63aaf97$var$IssueWrapper = ({ issueKey: issueKey, externalAction: externalAction, rapidViewId: rapidViewId, boardSessionId: boardSessionId, boardCardCount: boardCardCount, estimationStatistic: estimationStatistic, onResetExternalAction: onResetExternalAction, onChange: onChange, onClose: onClose, onSwitchToModal: onSwitchToModal, onIssueDeleteSuccess: onIssueDeleteSuccess, onIssueKeyChange: onIssueKeyChange, isCMPBoard: isCMPBoard })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $bWjJb.setIssueViewOpenFeedbackMark)();
    }, [
        issueKey
    ]);
    const configWithAppKey = (0, $fOGZN.simpleSoftwareBoardConfiguration)();
    const { applicationKey: applicationKey, ...configWithoutAppKey } = configWithAppKey;
    // If there's an external action to be fired, dispatch it as soon as possible
    const onSetDispatchExternalActionRef = (0, $5uXOq.useCallback)((dispatchExternalActionRef)=>{
        if (dispatchExternalActionRef && externalAction) // If a keyboard shortcut was the trigger for this external action,
        // the key may propagate into a field that is focused in the
        // issue view. setTimeout prevents this.
        setTimeout(()=>{
            externalAction && dispatchExternalActionRef(externalAction);
            // remove optional checking when cleaning up DEE-930
            onResetExternalAction && onResetExternalAction();
        });
    }, [
        externalAction,
        onResetExternalAction
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            source: `boardIssueView${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
            attributes: {
                viewMode: 'SIDEBAR'
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $c7a9ddf7b63aaf97$var$issueAppContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWjj9.PreIssueViewMountFeedbackMark), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7eqRV.IssueBoundary), {
        packageName: "software-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c7a9ddf7b63aaf97$var$IssueApp, {
        ...configWithoutAppKey,
        analyticsSource: $c7a9ddf7b63aaf97$var$NEXT_GEN_BOARD_ANALYTICS_SOURCE,
        isLoadedWithPage: true,
        issueKey: issueKey,
        onChange: onChange,
        onClose: onClose,
        rapidViewId: rapidViewId,
        viewModeOptions: {
            viewMode: 'SIDEBAR',
            viewModeSwitchEnabled: true,
            onSwitchToModal: onSwitchToModal
        },
        onIssueDeleteSuccess: onIssueDeleteSuccess,
        shouldSetInitialFocus: true,
        shouldShowCloseButton: true,
        metrics: {
            onReadyForUser: ()=>{
                (0, $7wqBZ.getLongTasksMetrics)('bento').stop((0, $hUXfN.bentoReporter), {
                    type: 'sidebar',
                    boardSessionId: boardSessionId
                });
            },
            onInteractive: ()=>{
                (0, $bWjJb.setIssueViewOpenFinishMark)(true, boardCardCount, isCMPBoard);
            }
        },
        onIssueKeyChange: onIssueKeyChange,
        history: null,
        dispatchExternalActionRef: onSetDispatchExternalActionRef,
        estimationStatistic: estimationStatistic ?? undefined
    }))));
};
var $c7a9ddf7b63aaf97$export$2e2bcd8739ae039 = $c7a9ddf7b63aaf97$var$IssueWrapper;
const $c7a9ddf7b63aaf97$var$issueAppContainerStyles = (0, $8CUq3.xcss)({
    height: '100%'
});

});
parcelRegister("hUXfN", function(module, exports) {

$parcel$export(module.exports, "bentoReporter", () => $6bde48e393b34dc9$export$b4ea9d181d8adab2);

var $k12ix = parcelRequire("k12ix");

var $cJpFl = parcelRequire("cJpFl");

var $if7bx = parcelRequire("if7bx");
const $6bde48e393b34dc9$export$b4ea9d181d8adab2 = (observationData, extra)=>{
    if ((0, $cJpFl.isExpandedObservationData)(observationData)) {
        const triggerSoftwareAnalytics = (0, $if7bx.triggerAnalytics)(`software.${observationData.appName}`);
        const startTime = observationData.events.map((event)=>event.timestamp);
        const analyticsData = {
            ...extra,
            ...(0, $if7bx.generateLongTaskAnalyticsSummary)('bento', observationData.events),
            measureTimespan: performance.now() - Math.min(observationData.startTimestamp, ...startTime),
            type: extra.type || 'unknown',
            performanceFFs: (0, $k12ix.getPerformanceFFsString)()
        };
        triggerSoftwareAnalytics('long-tasks-bento', analyticsData);
    }
};

});

parcelRegister("7eqRV", function(module, exports) {

$parcel$export(module.exports, "IssueBoundary", () => $e3c8771effba3477$export$fbf48ede0cf52b5a);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $lb0Dk = parcelRequire("lb0Dk");
const $e3c8771effba3477$export$fbf48ede0cf52b5a = ({ children: children, isEmbedView: isEmbedView = true, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "issue",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isEmbedView: isEmbedView
        })
    }, children));
const $e3c8771effba3477$export$74d408982642a541 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "issue-modal",
        ...props
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "issue-modal-boundary",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lb0Dk.IssueViewSkeleton), {
            isModalView: true
        })
    }, children));

});
parcelRegister("lb0Dk", function(module, exports) {

$parcel$export(module.exports, "IssueViewSkeleton", () => $bf9ca492e3d15685$export$49addbcdecb6e6ff);
/* IssueViewSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $iMqhh = parcelRequire("iMqhh");

var $4R6GH = parcelRequire("4R6GH");

var $hCy6k = parcelRequire("hCy6k");

var $3441h = parcelRequire("3441h");
const $bf9ca492e3d15685$var$fullpageStyles = null;
const $bf9ca492e3d15685$var$modalStyles = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth = null;
const $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth = null;
const $bf9ca492e3d15685$export$49addbcdecb6e6ff = ({ isEmbedView: isEmbedView, isModalView: isModalView })=>{
    // same as getIssueContainerMaxWidth
    const customCss = [
        (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? $bf9ca492e3d15685$var$customSpacingStylesWithIncreasedWidth : $bf9ca492e3d15685$var$customSpacingStylesWithDefaultWidth,
        isEmbedView !== true && isModalView !== true ? $bf9ca492e3d15685$var$fullpageStyles : null,
        isModalView === true ? $bf9ca492e3d15685$var$modalStyles : null
    ];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iMqhh.CompactModeProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($3441h))),
        className: (0, $bwpsq.default)([
            (0, $4R6GH.fg)('jracloud-75406-remove-excessive-padding-from-side') ? "_p12f107j _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi" : "_p12f1ypn _19pkze3t _2hwx1wug _otyrze3t _18u01wug _t6vdxy5q _hr4jxy5q _11y7uu9g _l82tpxbi _j7o0pxbi",
            isEmbedView !== true && isModalView !== true && "_uwhk1ejb",
            isModalView === true && "_19pk10j7"
        ])
    }));
};

});
parcelRegister("iMqhh", function(module, exports) {

$parcel$export(module.exports, "CompactModeContext", () => $db79d17d45755de5$export$37eeac5cc5245b18);
$parcel$export(module.exports, "CompactModeProvider", () => $db79d17d45755de5$export$10cf42790e523b8e);
$parcel$export(module.exports, "CompactModeConsumer", () => $db79d17d45755de5$export$20feb77b5b617e44);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");


var $8kj45 = parcelRequire("8kj45");

var $doZTA = parcelRequire("doZTA");

var $k1L82 = parcelRequire("k1L82");

var $hhMVP = parcelRequire("hhMVP");
const $db79d17d45755de5$export$37eeac5cc5245b18 = /*#__PURE__*/ (0, $5uXOq.createContext)(false);
const { Provider: $db79d17d45755de5$var$Provider, Consumer: $db79d17d45755de5$var$Consumer } = $db79d17d45755de5$export$37eeac5cc5245b18;
const $db79d17d45755de5$export$55a90a8e865a39b5 = 700;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY = `(max-width: ${$db79d17d45755de5$export$55a90a8e865a39b5}px)`;
const $db79d17d45755de5$export$ddd398a95f85cd75 = 850;
const $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL = `(max-width: ${$db79d17d45755de5$export$ddd398a95f85cd75}px)`;
/**
 * A utility hook which returns a key based on the route
 */ function $db79d17d45755de5$var$useRouteKey() {
    const [routeState] = (0, $doZTA.useRouter)();
    const { match: { path: path, params: params } } = routeState;
    // handle case where JSM doesn't have an issueKey on their route
    const hasIssueKey = params?.issueKey !== undefined;
    return `${path}${hasIssueKey ? '/hasIssueKey' : ''}`;
}
const $db79d17d45755de5$export$10cf42790e523b8e = ({ children: children })=>{
    const key = $db79d17d45755de5$var$useRouteKey();
    (0, $hhMVP.invalidateCacheIfRouteChanged)(key);
    let defaultState = (0, $hhMVP.getCachedIsCompactValue)(key);
    // in case there is no state change triggered
    if (defaultState === undefined) {
        defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4);
        (0, $hhMVP.setCachedIsCompactValue)(defaultState, key);
    }
    const { isInSidePanelExperiment: isInSidePanelExperiment } = (0, $k1L82.useIssueLayoutActivitySidePanel)();
    const query = isInSidePanelExperiment ? $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY_SIDE_PANEL : $db79d17d45755de5$var$COMPACT_LAYOUT_MAX_WIDTH_QUERY;
    const [isCompact, setIsCompact] = (0, $5uXOq.useState)(defaultState);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$StyledWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8kj45.ContainerQueryObserver), {
        query: query,
        onChange: (state)=>{
            (0, $hhMVP.setCachedIsCompactValue)(state, key);
            setIsCompact(state);
        },
        defaultState: defaultState
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db79d17d45755de5$var$Provider, {
        value: isCompact
    }, children));
};
const $db79d17d45755de5$export$20feb77b5b617e44 = $db79d17d45755de5$var$Consumer;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db79d17d45755de5$var$StyledWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
const $7093eea63dce9286$export$ee15e0cd1efafcb4 = false;

parcelRegister("8kj45", function(module, exports) {

$parcel$export(module.exports, "ContainerQueryObserver", () => $ed10e3c030ea0408$export$e9574287678b8467);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

const $ed10e3c030ea0408$var$QueryContext = /*#__PURE__*/ (0, $5uXOq.createContext)(undefined);
let $ed10e3c030ea0408$var$currentIdSeed = 0;
function $ed10e3c030ea0408$var$generateAttributeValue() {
    return `indicator-span-${$ed10e3c030ea0408$var$currentIdSeed++}`;
}
function $ed10e3c030ea0408$export$e9574287678b8467({ children: children, query: query, onChange: onChange, defaultState: defaultState = (0, $7093eea63dce9286$export$ee15e0cd1efafcb4) }) {
    const [active, setActive] = (0, $5uXOq.useState)(defaultState);
    const handleQueryStatusChange = (0, $5uXOq.useCallback)((isContainerQueryActive)=>{
        onChange?.(isContainerQueryActive);
        setActive(isContainerQueryActive);
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$QueryContext.Provider, {
        value: active
    }, !false && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$IntersectionIndicator, {
        query: query,
        notifyIntersectionStatusChanged: handleQueryStatusChange
    }), children);
}
function $ed10e3c030ea0408$export$b66a67697973e01() {
    const currentState = (0, $5uXOq.useContext)($ed10e3c030ea0408$var$QueryContext);
    if (currentState === undefined) throw new Error('The component must be wrapped in a ContainerQueryObserver to use useContainerQueryState');
    return currentState;
}
function $ed10e3c030ea0408$var$IntersectionIndicator({ notifyIntersectionStatusChanged: handleChange, query: query }) {
    const attributeValue = (0, $5uXOq.useMemo)(()=>$ed10e3c030ea0408$var$generateAttributeValue(), []);
    const spanRef = (0, $5uXOq.useRef)(null);
    const containerRef = (0, $5uXOq.useRef)(null);
    const currentState = $ed10e3c030ea0408$export$b66a67697973e01();
    (0, $5uXOq.useLayoutEffect)(()=>{
        const queryStatusChangedCallback = (entries)=>{
            // This means that the parent container is either empty or loading, we should not notify of any change in this case.
            if (!containerRef.current || containerRef.current.clientWidth === 0) return;
            if (entries.length > 0) {
                // only ever going to be one entry max
                const isContainerQueryActive = entries[0].isIntersecting;
                if (isContainerQueryActive !== currentState) handleChange(isContainerQueryActive);
            }
        };
        const intersectionObserver = new IntersectionObserver(queryStatusChangedCallback);
        const spanElement = spanRef.current;
        spanElement && intersectionObserver.observe(spanElement);
        return ()=>{
            spanElement && intersectionObserver.unobserve(spanElement);
            intersectionObserver.disconnect();
        };
    }, [
        currentState,
        handleChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ed10e3c030ea0408$var$ContainerToBeQueried, {
        ref: containerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("style", {
        type: "text/css"
    }, `
                    [data-container-query-indicator-id="${attributeValue}"] {
                        display: none;
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100%;
                        height: 100vh;
                        pointer-events: none;
                    }
                    @container ${query} {
                        [data-container-query-indicator-id="${attributeValue}"] {
                            display: inherit;
                        }
                    }`), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        ref: spanRef,
        "data-container-query-indicator-id": attributeValue
    }));
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ed10e3c030ea0408$var$ContainerToBeQueried = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqsw1if8 _lcxvglyw _154iidpf _7ccakre2",
            __cmplp.className
        ])
    });
});

});

parcelRegister("k1L82", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainers", () => $725285d3420dc4d6$export$d146dfa0384f99a3);
$parcel$export(module.exports, "useLayoutContainerByType", () => $725285d3420dc4d6$export$5f49a43487b268);
$parcel$export(module.exports, "useIssueLayoutGlance", () => $725285d3420dc4d6$export$fd7f0cc3d2b405e6);
$parcel$export(module.exports, "useIssueLayoutContextPanel", () => $725285d3420dc4d6$export$5962da0433486667);
$parcel$export(module.exports, "useIssueLayoutActivitySidePanel", () => $725285d3420dc4d6$export$8105ff1c0f6ac8a9);
$parcel$export(module.exports, "useIssueLayoutActions", () => $725285d3420dc4d6$export$1e5e9fc877a47cd9);

var $5uXOq = parcelRequire("5uXOq");

var $egBua = parcelRequire("egBua");

var $6s1PB = parcelRequire("6s1PB");

var $eNNkf = parcelRequire("eNNkf");

var $2gCtH = parcelRequire("2gCtH");


var $93Yeu = parcelRequire("93Yeu");

var $2vSU6 = parcelRequire("2vSU6");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $bCdIp = parcelRequire("bCdIp");

var $kI4MM = parcelRequire("kI4MM");

var $cNJ33 = parcelRequire("cNJ33");
const $725285d3420dc4d6$export$d146dfa0384f99a3 = (issueKey)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    return [
        containers
    ];
};
const $725285d3420dc4d6$export$5f49a43487b268 = (issueKey, type)=>{
    const [containers] = (0, $kI4MM.useIssueLayoutContainersStore)(issueKey);
    const container = containers.find((innerContainer)=>innerContainer.containerType === type);
    // Forge app with UI Modifications module can hide selected fields using
    // UI modifications Field API. We are removing them here from the layout fields
    const fieldsHiddenByUim = (0, $egBua.useEnabledHiddenFields)();
    return [
        (0, $cNJ33.filterOutItemsWithProvidedIds)(container?.items.nodes ?? [], fieldsHiddenByUim)
    ];
};
const $725285d3420dc4d6$export$fd7f0cc3d2b405e6 = (issueKey)=>{
    const [glance] = (0, $kI4MM.useIssueLayoutGlanceStore)(issueKey);
    return [
        glance
    ];
};
const $725285d3420dc4d6$export$5962da0433486667 = (issueKey)=>{
    const [contextPanel] = (0, $kI4MM.useIssueLayoutContextPanelStore)(issueKey);
    return [
        contextPanel
    ];
};
const $725285d3420dc4d6$export$8105ff1c0f6ac8a9 = ()=>{
    try {
        /* eslint-disable react-hooks/rules-of-hooks */ if (!(0, $4R6GH.fg)('issue-view-side-panel-activity-kill-switch')) return {
            isActivityInVerticalSidePanel: false,
            isInSidePanelExperiment: false,
            activityLayoutView: null
        };
        // Get required values
        const isFullIssueView = (0, $2gCtH.useIsFullPageIssueView)();
        const [activityLayoutView] = (0, $eNNkf.useUserPreferencesValue)((0, $31848aa9a0db89de$export$2cf981c493d79a21));
        const issueKey = (0, $2gCtH.useIssueKey)();
        const projectKey = (0, $93Yeu.useProjectKey)(issueKey);
        const projectType = (0, $93Yeu.useProjectType)(projectKey);
        const isMobile = (0, $bCdIp.default)();
        /* eslint-enable react-hooks/rules-of-hooks */ const isJiraIssue = projectType === (0, $2vSU6.SOFTWARE_PROJECT) || projectType === (0, $2vSU6.CORE_PROJECT);
        // Determine if in experiment condition based on project type, view and inline experiment evaluation
        const isInSidePanelExperiment = !isMobile && isJiraIssue && isFullIssueView && (0, $6s1PB.expVal)('issue-view-side-panel-activity', 'isActivityInSidePanel', false);
        // Compute final values directly
        const isActivityInVerticalSidePanel = isInSidePanelExperiment && activityLayoutView === 'VERTICAL';
        // Return object with named properties
        return {
            isActivityInVerticalSidePanel: Boolean(isActivityInVerticalSidePanel),
            isInSidePanelExperiment: Boolean(isInSidePanelExperiment),
            activityLayoutView: activityLayoutView
        };
    } catch (error) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('issue-view-layout.services.main', `Error in useIssueLayoutActivitySidePanel : ${error}`);
        return {
            isActivityInVerticalSidePanel: false,
            isInSidePanelExperiment: false,
            activityLayoutView: null
        };
    }
};
const $725285d3420dc4d6$export$1e5e9fc877a47cd9 = ()=>{
    const [, actions] = (0, $kI4MM.useIssueLayoutActionsStore)();
    const setIssueViewContainersLayout = (0, $5uXOq.useCallback)((issueKey, containersByType)=>{
        actions.setIssueViewContainersLayout(issueKey, containersByType);
    }, [
        actions
    ]);
    const setIssueViewLayoutGlance = (0, $5uXOq.useCallback)((issueKey, glance)=>{
        actions.setIssueViewLayoutGlance(issueKey, glance);
    }, [
        actions
    ]);
    const setIssueViewLayoutContextPanel = (0, $5uXOq.useCallback)((issueKey, newContextPanel)=>{
        actions.setIssueViewLayoutContextPanel(issueKey, newContextPanel);
    }, [
        actions
    ]);
    return [
        null,
        {
            setIssueViewContainersLayout: setIssueViewContainersLayout,
            setIssueViewLayoutGlance: setIssueViewLayoutGlance,
            setIssueViewLayoutContextPanel: setIssueViewLayoutContextPanel
        }
    ];
};

});
parcelRegister("egBua", function(module, exports) {

$parcel$export(module.exports, "useEnabledHiddenFields", () => $ea65d07999c73532$export$bb6c2b9159c3f32b);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $jrwZp = parcelRequire("jrwZp");

var $eoznE = parcelRequire("eoznE");
const $ea65d07999c73532$export$bb6c2b9159c3f32b = ()=>{
    (0, $gKZoD.di)((0, $jrwZp.useAdjustmentsEnabled), (0, $eoznE.useHiddenFields));
    const adjustmentsAreEnabled = (0, $jrwZp.useAdjustmentsEnabled)();
    const hiddenFields = (0, $eoznE.useHiddenFields)();
    return (0, $5uXOq.useMemo)(()=>{
        if (!adjustmentsAreEnabled) return [];
        return hiddenFields;
    }, [
        adjustmentsAreEnabled,
        hiddenFields
    ]);
};

});
parcelRegister("jrwZp", function(module, exports) {

$parcel$export(module.exports, "store", () => $db4845f733e81d44$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustmentsEnabled", () => $db4845f733e81d44$export$358ad850b2f6d6fe);
$parcel$export(module.exports, "useAdjustmentsContextActions", () => $db4845f733e81d44$export$4f2729981f4b81d2);
$parcel$export(module.exports, "UiModificationContextContainer", () => $db4845f733e81d44$export$5eb9c167b683d125);

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $db4845f733e81d44$var$initialState = {
    shouldUiModificationsLoad: 'unknown',
    hasFinishedLoading: false,
    adjustmentsAreEnabled: false,
    uiModificationsConsentStatus: {}
};
const $db4845f733e81d44$export$e324594224ef24da = {
    resetAdjustmentContext: ()=>({ setState: setState })=>{
            setState($db4845f733e81d44$var$initialState);
        },
    setShouldUiModificationsLoad: (status)=>({ setState: setState })=>{
            setState({
                shouldUiModificationsLoad: status
            });
        },
    setHasFinishedLoading: (hasFinishedLoading)=>({ setState: setState })=>{
            setState({
                hasFinishedLoading: hasFinishedLoading
            });
        },
    setAdjustmentsAreEnabled: (enabled)=>({ setState: setState })=>{
            setState({
                adjustmentsAreEnabled: enabled
            });
        },
    setUIModificationsConsentStatus: ({ appId: appId, status: status })=>({ setState: setState, getState: getState })=>{
            const currentConsentState = getState().uiModificationsConsentStatus;
            setState({
                uiModificationsConsentStatus: {
                    ...currentConsentState,
                    [appId]: status
                }
            });
        }
};
const $db4845f733e81d44$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-adjustments-context',
    initialState: $db4845f733e81d44$var$initialState,
    actions: $db4845f733e81d44$export$e324594224ef24da
});
const $db4845f733e81d44$export$a12f82a132dee079 = (0, $3sQ5x.createHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$358ad850b2f6d6fe = (0, $3sQ5x.createStateHook)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    selector: (state)=>state.adjustmentsAreEnabled
});
const $db4845f733e81d44$export$4f2729981f4b81d2 = (0, $3sQ5x.createActionsHook)($db4845f733e81d44$export$6f57813fe9f31bf9);
const $db4845f733e81d44$export$5eb9c167b683d125 = (0, $gg7kZ.createContainer)($db4845f733e81d44$export$6f57813fe9f31bf9, {
    displayName: 'UiModificationContextContainer'
});

});

parcelRegister("eoznE", function(module, exports) {

$parcel$export(module.exports, "useHiddenFields", () => $8c7bafd209de1659$export$de6fdc67c945e596);

var $6dDSs = parcelRequire("6dDSs");
var $3sQ5x = parcelRequire("3sQ5x");

var $1YewZ = parcelRequire("1YewZ");
const $8c7bafd209de1659$var$selectHiddenFields = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.appliedChanges, (formData, appliedChanges)=>{
    if (formData === null) return [];
    return Object.entries(formData).filter(([fieldId, field])=>appliedChanges?.[fieldId]?.isVisible !== undefined ? !appliedChanges[fieldId].isVisible : !field.isVisible).map(([fieldId])=>fieldId);
});
const $8c7bafd209de1659$export$de6fdc67c945e596 = (0, $3sQ5x.createStateHook)((0, $1YewZ.store), {
    selector: $8c7bafd209de1659$var$selectHiddenFields
});

});
parcelRegister("1YewZ", function(module, exports) {

$parcel$export(module.exports, "store", () => $cf6a6312e4141eb7$export$6f57813fe9f31bf9);
$parcel$export(module.exports, "useAdjustedField", () => $cf6a6312e4141eb7$export$df4b0714e8177e0e);
$parcel$export(module.exports, "useIssueAdjustmentsActions", () => $cf6a6312e4141eb7$export$cb9a014ec14556d8);
$parcel$export(module.exports, "useAdjustedScreenTabs", () => $cf6a6312e4141eb7$export$677b3e34bd14c681);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $3whHg = parcelRequire("3whHg");

var $hyCnL = parcelRequire("hyCnL");

var $boEP0 = parcelRequire("boEP0");

var $2NMWZ = parcelRequire("2NMWZ");

var $d30F5 = parcelRequire("d30F5");

var $8e24q = parcelRequire("8e24q");

var $cTj8m = parcelRequire("cTj8m");

var $i4uue = parcelRequire("i4uue");

var $3iUv8 = parcelRequire("3iUv8");

var $b8ZsE = parcelRequire("b8ZsE");

var $jDMtG = parcelRequire("jDMtG");

var $l0b2q = parcelRequire("l0b2q");

var $4MJXd = parcelRequire("4MJXd");

var $gHQFd = parcelRequire("gHQFd");

var $7JtDe = parcelRequire("7JtDe");
const $cf6a6312e4141eb7$var$name = 'issue-adjustments';
const $cf6a6312e4141eb7$export$d4c72bab9d6cc13a = {
    formData: null,
    screenTabs: null,
    appliedChanges: null,
    error: null,
    registeredFieldsDeprecated: {},
    registeredFields: {},
    triggerFieldInitializationKey: 0,
    // Selector checks if this is not equal 0 in the useFieldReady
    numberOfSupportedFields: 0,
    internalFormMetadata: {},
    viewType: null,
    experienceDataIsLoading: false,
    lastProcessedChange: null,
    fieldsInitialization: {
        startTime: null,
        timeoutId: undefined,
        status: 'notStarted'
    },
    appliedChangesHistory: {},
    appsErrors: {},
    notification: null
};
// triggerFieldInitializationKey, viewType and numberOfSupportedFields should not be reset on project or issue type change
const { triggerFieldInitializationKey: $cf6a6312e4141eb7$var$triggerFieldInitializationKey, viewType: $cf6a6312e4141eb7$var$scopedViewType, numberOfSupportedFields: $cf6a6312e4141eb7$var$numberOfSupportedFields, ...$cf6a6312e4141eb7$var$stateForResetAllFields } = $cf6a6312e4141eb7$export$d4c72bab9d6cc13a;
const $cf6a6312e4141eb7$export$e324594224ef24da = {
    triggerFieldInitialization: ()=>({ getState: getState, setState: setState })=>{
            setState({
                triggerFieldInitializationKey: getState().triggerFieldInitializationKey + 1
            });
        },
    processChange: $b8ZsE.processChange,
    setFieldValue: $l0b2q.setFieldValue,
    initializeField: $8e24q.initializeField,
    initializeFields: $8e24q.initializeFields,
    startFieldsInitialisationTimeout: $d30F5.startFieldsInitialisationTimeout,
    successFieldsInitalisation: $d30F5.successFieldsInitalisation,
    registerFields: $jDMtG.registerFields,
    unregisterFields: $jDMtG.unregisterFields,
    updateFields: $gHQFd.updateFields,
    clearAppliedValue: (fieldId)=>({ setState: setState, getState: getState })=>{
            const previousState = getState().appliedChanges || {};
            if (previousState[fieldId]) {
                const { value: value, ...otherFieldChanges } = previousState[fieldId];
                setState({
                    appliedChanges: {
                        ...previousState,
                        [fieldId]: otherFieldChanges
                    }
                });
            }
        },
    resetAllFields: ()=>({ setState: setState, getState: getState })=>{
            // Clear the fieldsInitialization timeout to avoid potetianl side effects.
            clearTimeout(getState().fieldsInitialization.timeoutId);
            setState($cf6a6312e4141eb7$var$stateForResetAllFields);
        },
    setError: $2NMWZ.setError,
    resetError: $2NMWZ.resetError,
    setNumberOfSupportedFields: (numberOfAllSupportedFields)=>({ setState: setState })=>{
            setState({
                numberOfSupportedFields: numberOfAllSupportedFields
            });
        },
    /**
	 * This is used to block onInit for specific case like Issue View background refresh loading.
	 */ setExperienceDataIsLoading: (experienceDataIsLoading)=>({ setState: setState })=>{
            setState({
                experienceDataIsLoading: experienceDataIsLoading
            });
        },
    setAppErrors: $3whHg.setAppErrors,
    resetAppErrors: $3whHg.resetAppErrors,
    addAppsErrors: $3whHg.addAppsErrors,
    initializeNoScreenTab: $cTj8m.initializeNoScreenTab,
    initializeScreenTabs: $i4uue.initializeScreenTabs,
    updateScreenTabs: $7JtDe.updateScreenTabs,
    updateActiveScreenTab: $4MJXd.updateActiveScreenTab,
    detectAppliedChangesConflicts: $hyCnL.detectAppliedChangesConflicts,
    collectScreenTabsAppliedChangesHistory: $boEP0.collectScreenTabsAppliedChangesHistory,
    collectFieldsAppliedChangesHistory: $boEP0.collectFieldsAppliedChangesHistory,
    setNotification: $3iUv8.setNotification,
    resetNotification: $3iUv8.resetNotification
};
const $cf6a6312e4141eb7$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: $cf6a6312e4141eb7$var$name,
    initialState: $cf6a6312e4141eb7$export$d4c72bab9d6cc13a,
    actions: $cf6a6312e4141eb7$export$e324594224ef24da
});
const $cf6a6312e4141eb7$export$37792a602e748c08 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe = {};
const $cf6a6312e4141eb7$export$c76e674a29843e21 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.appliedChanges
});
const $cf6a6312e4141eb7$export$df4b0714e8177e0e = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state, fieldId)=>state.appliedChanges?.[fieldId] || $cf6a6312e4141eb7$var$stableEmptyFieldFromIframe
});
const $cf6a6312e4141eb7$export$cb9a014ec14556d8 = (0, $3sQ5x.createActionsHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9);
const $cf6a6312e4141eb7$export$677b3e34bd14c681 = (0, $3sQ5x.createHook)($cf6a6312e4141eb7$export$6f57813fe9f31bf9, {
    selector: (state)=>state.screenTabs
});

});
parcelRegister("3whHg", function(module, exports) {

$parcel$export(module.exports, "setAppErrors", () => $87bccf3deeafaa75$export$7054e2f8e68cf0dd);
$parcel$export(module.exports, "addAppsErrors", () => $87bccf3deeafaa75$export$903d525e420c7d00);
$parcel$export(module.exports, "resetAppErrors", () => $87bccf3deeafaa75$export$24c821207687a907);
const $87bccf3deeafaa75$export$7054e2f8e68cf0dd = ({ errors: errors, appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: errors
            }
        });
    };
const $87bccf3deeafaa75$export$903d525e420c7d00 = ({ errors: errors })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        const appsErrors = Object.entries(errors).reduce((acc, [appId, appErrors])=>{
            acc[appId] = [
                ...acc[appId] ?? [],
                ...appErrors
            ];
            return acc;
        }, {
            ...previousState
        });
        setState({
            appsErrors: appsErrors
        });
    };
const $87bccf3deeafaa75$export$24c821207687a907 = ({ appId: appId })=>({ setState: setState, getState: getState })=>{
        const previousState = getState().appsErrors ?? {};
        setState({
            appsErrors: {
                ...previousState,
                [appId]: null
            }
        });
    };

});

parcelRegister("hyCnL", function(module, exports) {

$parcel$export(module.exports, "detectAppliedChangesConflicts", () => $4c0b86f075c0ff6b$export$90d94f20d157e756);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $3whHg = parcelRequire("3whHg");

var $3iUv8 = parcelRequire("3iUv8");

var $lLAXK = parcelRequire("lLAXK");
const $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL = 60000;
/**
 * Tidies up applied changes history by removing old entries by TTL.
 * It keeps the current changeId in history.
 */ const $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory = (appliedChangesHistory, changeId)=>Object.fromEntries(Object.entries(appliedChangesHistory).filter(([existingChangeId, history])=>{
        return Date.now() - history.createdAt <= $4c0b86f075c0ff6b$var$HISTORY_LOG_TTL || existingChangeId === changeId;
    }));
const $4c0b86f075c0ff6b$export$90d94f20d157e756 = ({ appId: appId, changeId: changeId })=>({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType, createAnalyticsEvent: createAnalyticsEvent })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        const tidyAppliedChangesHistory = $4c0b86f075c0ff6b$var$tidyUpAppliedChangesHistory(appliedChangesHistory, changeId);
        setState({
            appliedChangesHistory: tidyAppliedChangesHistory
        });
        const appliedChangesHistoryChangeId = tidyAppliedChangesHistory[changeId];
        const newChanges = appliedChangesHistoryChangeId?.apps[appId];
        if (!appliedChangesHistoryChangeId || !newChanges || // No need to run conflicts checks for the first item in history
        Object.keys(appliedChangesHistoryChangeId.apps).length <= 1) return;
        const lifecycleHook = changeId === (0, $19ec31e354320eb2$export$415cc1afa6445f90) ? 'onInit' : 'onChange';
        const { appErrorsMap: appErrorsMap, conflicts: conflicts } = (0, $lLAXK.collectConflicts)({
            appliedChangesHistory: appliedChangesHistoryChangeId.apps,
            newChanges: newChanges,
            appIdOfNewChanges: appId,
            lifecycleHook: lifecycleHook
        });
        if (conflicts.length) {
            (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                action: 'conflicted',
                actionSubject: 'jiraUiModifications.appliedChangesHistory',
                attributes: {
                    conflictsCount: conflicts.length,
                    conflicts: conflicts,
                    conflictedApps: Object.keys(appErrorsMap),
                    viewType: viewType
                }
            });
            dispatch((0, $3whHg.addAppsErrors)({
                errors: appErrorsMap
            }));
            dispatch((0, $3iUv8.setNotification)({
                type: 'MULTIPLE_APPS_CONFLICTS'
            }));
        }
    };

});
parcelRegister("2jyqu", function(module, exports) {

$parcel$export(module.exports, "fireOperationalEvent", () => $9253211b05747618$export$a1fb57756f0de62b);

var $gB4mS = parcelRequire("gB4mS");


const $9253211b05747618$export$a1fb57756f0de62b = (createAnalyticsEvent, eventPayload)=>{
    (0, $gB4mS.default)((0, $aded369bac156944$export$8280e5c6104c5b40))({
        ...eventPayload,
        analyticsType: (0, $6e65040b988c460f$export$12346a674644c156)
    })(createAnalyticsEvent);
};

});
const $6e65040b988c460f$export$f636b5b56f1d624a = 'Screen';
const $6e65040b988c460f$export$9d2de6eebf7462b5 = 'Drawer';
const $6e65040b988c460f$export$1171103ea9083ffa = 'Modal';
const $6e65040b988c460f$export$cae2783c9279926 = 'InlineDialog';
const $6e65040b988c460f$export$d1123261ca8831d2 = 'Dropdown';
const $6e65040b988c460f$export$a1562d08625f5d7e = 'UI';
const $6e65040b988c460f$export$947dac6c72b26f81 = 'TRACK';
const $6e65040b988c460f$export$f1d537d508d2945a = 'SCREEN';
const $6e65040b988c460f$export$12346a674644c156 = 'OPERATIONAL';
const $6e65040b988c460f$export$2ceccf177fae277c = 'analyticsBridge';

const $aded369bac156944$export$8280e5c6104c5b40 = 'ui-modifications';


const $19ec31e354320eb2$export$415cc1afa6445f90 = 'onInitChangeId';
const $19ec31e354320eb2$export$811b7f067a43b422 = 'jira:uiModifications';

parcelRegister("3iUv8", function(module, exports) {

$parcel$export(module.exports, "setNotification", () => $547ed651019edc98$export$b9c5e783593ff01d);
$parcel$export(module.exports, "resetNotification", () => $547ed651019edc98$export$caafa3945f199bc7);
const $547ed651019edc98$export$b9c5e783593ff01d = (notificationProperties)=>({ setState: setState })=>{
        setState({
            notification: {
                type: notificationProperties.type
            }
        });
    };
const $547ed651019edc98$export$caafa3945f199bc7 = ()=>({ setState: setState })=>{
        setState({
            notification: null
        });
    };

});

parcelRegister("lLAXK", function(module, exports) {

$parcel$export(module.exports, "collectConflicts", () => $5d47c6c300e4a9ca$export$a06103ec99e4e394);

var $fr1K2 = parcelRequire("fr1K2");


var $bCvSM = parcelRequire("bCvSM");

const $5d47c6c300e4a9ca$var$MESSAGE_SUFFIX = 'Modifications have been applied, but it may lead to inconsistency for the user.';
const $5d47c6c300e4a9ca$var$mapToAppErrors = ({ conflicts: conflicts, lifecycleHook: lifecycleHook })=>{
    const appErrors = conflicts.map((change)=>{
        if (change.type === (0, $78805f0b93715186$export$f674b7a3bbd94b5)) return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$877da1000325f8b5),
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified screen tabs in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
        const { fieldId: fieldId, fieldType: fieldType, property: property } = change;
        const method = (0, $bCvSM.mapFieldPropertyToApiMethod)(property);
        return {
            type: (0, $ca611ff348f89182$export$2a3fdceaae2188d5),
            cause: (0, $ca611ff348f89182$export$e4ac32edd5da2ee7),
            fieldId: fieldId,
            fieldType: fieldType,
            method: method,
            lifecycleHook: lifecycleHook,
            message: `Your and other app modified the same field: '${fieldId}' by its method: '${method}' in the '${lifecycleHook}' at the same trigger. ${$5d47c6c300e4a9ca$var$MESSAGE_SUFFIX}`
        };
    });
    return appErrors;
};
const $5d47c6c300e4a9ca$export$a06103ec99e4e394 = ({ appliedChangesHistory: appliedChangesHistory, newChanges: newChanges, appIdOfNewChanges: appIdOfNewChanges, lifecycleHook: lifecycleHook })=>{
    return Object.entries((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(appliedChangesHistory, appIdOfNewChanges)).reduce((acc, [appId, previousChanges])=>{
        const previousChangesKeys = Object.keys(previousChanges);
        // Compares previous changes with new changes keys
        const conflicts = Object.entries(newChanges).filter(([changeKey, _])=>previousChangesKeys.includes(changeKey)).map(([_, change])=>({
                ...change,
                lifecycleHook: lifecycleHook,
                appIds: [
                    appId,
                    appIdOfNewChanges
                ]
            }));
        acc.conflicts.push(...conflicts);
        // Maps conflicts to app errors
        const appErrors = $5d47c6c300e4a9ca$var$mapToAppErrors({
            conflicts: conflicts,
            lifecycleHook: lifecycleHook
        });
        if (appErrors.length > 0) {
            acc.appErrorsMap[appId] = appErrors;
            // App errors for `appIdOfNewChanges` may already exists from the previous iteration.
            // We need to merge them to avoid overwriting and keep all errors.
            acc.appErrorsMap[appIdOfNewChanges] = [
                ...acc.appErrorsMap[appIdOfNewChanges] ?? [],
                ...appErrors
            ];
        }
        return acc;
    }, {
        appErrorsMap: {},
        conflicts: []
    });
};

});
const $ca611ff348f89182$export$fd26696d109785a0 = 'SCREENTABS_VALIDATION_FAILED';
const $ca611ff348f89182$export$d1996cb46a690190 = 'FIELD_VALIDATION_FAILED';
const $ca611ff348f89182$export$8042247b663edbcc = 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD';
const $ca611ff348f89182$export$2a3fdceaae2188d5 = 'MULTIPLE_APPS_CONFLICT';
const $ca611ff348f89182$export$e4ac32edd5da2ee7 = 'FIELD';
const $ca611ff348f89182$export$877da1000325f8b5 = 'SCREENTABS';

parcelRegister("bCvSM", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyToApiMethod", () => $b1dea33557091402$export$e1cc7da28a1c4bb7);
const $b1dea33557091402$var$SET_NAME_METHOD = 'setName';
const $b1dea33557091402$var$SET_DESCRIPTION_METHOD = 'setDescription';
const $b1dea33557091402$var$SET_VISIBLE_METHOD = 'setVisible';
const $b1dea33557091402$var$SET_READ_ONLY_METHOD = 'setReadOnly';
const $b1dea33557091402$var$SET_VALUE_METHOD = 'setValue';
const $b1dea33557091402$var$SET_REQUIRED_METHOD = 'setRequired';
const $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD = 'setOptionsVisibility';
const $b1dea33557091402$export$8325709d137b2606 = {
    fieldName: $b1dea33557091402$var$SET_NAME_METHOD,
    description: $b1dea33557091402$var$SET_DESCRIPTION_METHOD,
    isVisible: $b1dea33557091402$var$SET_VISIBLE_METHOD,
    isReadOnly: $b1dea33557091402$var$SET_READ_ONLY_METHOD,
    value: $b1dea33557091402$var$SET_VALUE_METHOD,
    isRequired: $b1dea33557091402$var$SET_REQUIRED_METHOD,
    optionsVisibility: $b1dea33557091402$var$SET_OPTIONS_VISIBILITY_METHOD
};
const $b1dea33557091402$export$e1cc7da28a1c4bb7 = (fieldProperty)=>{
    const method = $b1dea33557091402$export$8325709d137b2606[fieldProperty];
    if (!method) throw new Error(`No method found for field property: ${fieldProperty}`);
    return method;
};

});

const $78805f0b93715186$export$f674b7a3bbd94b5 = 'SCREEN_TABS';
const $78805f0b93715186$export$4a9f236a0db33834 = 'FIELD';



parcelRegister("boEP0", function(module, exports) {

$parcel$export(module.exports, "collectScreenTabsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$1d2b7abeeea36239);
$parcel$export(module.exports, "collectFieldsAppliedChangesHistory", () => $f5288ff27f25fb7e$export$7d0f534e5b16dcc9);


var $3vp6H = parcelRequire("3vp6H");
const $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange = ({ currentAppliedChangesHistory: currentAppliedChangesHistory, appId: appId, changeId: changeId, newSingleAppChange: newSingleAppChange })=>{
    const appliedChangesHistoryChangeId = currentAppliedChangesHistory[changeId] ?? {};
    const appliedChangesHistoryChangeIdApp = appliedChangesHistoryChangeId.apps?.[appId] ?? {};
    return {
        ...currentAppliedChangesHistory,
        [changeId]: {
            apps: {
                ...appliedChangesHistoryChangeId.apps,
                [appId]: {
                    ...appliedChangesHistoryChangeIdApp,
                    ...newSingleAppChange
                }
            },
            createdAt: appliedChangesHistoryChangeId.createdAt ?? Date.now()
        }
    };
};
const $f5288ff27f25fb7e$export$1d2b7abeeea36239 = ({ appId: appId, changeId: changeId, screenTabs: screenTabs })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory } = getState();
        if (!screenTabs.length) return;
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: {
                tabs: {
                    type: (0, $78805f0b93715186$export$f674b7a3bbd94b5)
                }
            }
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };
const $f5288ff27f25fb7e$export$7d0f534e5b16dcc9 = ({ appId: appId, changeId: changeId, fieldsChanges: fieldsChanges })=>({ setState: setState, getState: getState })=>{
        const { appliedChangesHistory: appliedChangesHistory, internalFormMetadata: internalFormMetadata } = getState();
        const singleAppChange = (0, $3vp6H.normalizeFieldsAppliedChangesForHistory)({
            fieldsChanges: fieldsChanges,
            internalFormMetadata: internalFormMetadata
        });
        const newAppliedChangesHistory = $f5288ff27f25fb7e$var$prepareAppliedChangesHistoryForSingleChange({
            currentAppliedChangesHistory: appliedChangesHistory,
            appId: appId,
            changeId: changeId,
            newSingleAppChange: singleAppChange
        });
        setState({
            appliedChangesHistory: newAppliedChangesHistory
        });
    };

});
parcelRegister("3vp6H", function(module, exports) {

$parcel$export(module.exports, "normalizeFieldsAppliedChangesForHistory", () => $23bcfa1804fc8fad$export$8a23b3e9a1749620);

const $23bcfa1804fc8fad$var$normalizeFieldForHistory = (fieldId, fieldChanges, fieldMetadata)=>{
    // Can't type Object.keys in a better way
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(fieldChanges).reduce((acc, property)=>{
        const normalizedKey = `${fieldId}|${property}`;
        acc[normalizedKey] = {
            fieldId: fieldId,
            fieldType: fieldMetadata.fieldType,
            property: property,
            type: (0, $78805f0b93715186$export$4a9f236a0db33834)
        };
        return acc;
    }, {});
};
const $23bcfa1804fc8fad$export$8a23b3e9a1749620 = ({ fieldsChanges: fieldsChanges, internalFormMetadata: internalFormMetadata })=>{
    return Object.entries(fieldsChanges).reduce((acc, [fieldId, fieldChanges])=>{
        const fieldMetadata = internalFormMetadata[fieldId];
        if (!fieldMetadata) return acc;
        const normalizedFieldHistory = $23bcfa1804fc8fad$var$normalizeFieldForHistory(fieldId, fieldChanges, fieldMetadata);
        Object.assign(acc, normalizedFieldHistory);
        return acc;
    }, {});
};

});


parcelRegister("2NMWZ", function(module, exports) {

$parcel$export(module.exports, "setError", () => $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5);
$parcel$export(module.exports, "resetError", () => $13e2b126ca97f7fe$export$7e5930c6217b1d4e);
const $13e2b126ca97f7fe$export$b8d0bb2aa0adefe5 = (errorProperties)=>({ setState: setState })=>{
        setState({
            error: {
                errorCode: errorProperties.errorCode,
                fieldName: errorProperties.fieldName
            }
        });
    };
const $13e2b126ca97f7fe$export$7e5930c6217b1d4e = ()=>({ setState: setState })=>{
        setState({
            error: null
        });
    };

});

parcelRegister("d30F5", function(module, exports) {

$parcel$export(module.exports, "startFieldsInitialisationTimeout", () => $e08f4de833312075$export$2c0f020b89dfa30b);
$parcel$export(module.exports, "successFieldsInitalisation", () => $e08f4de833312075$export$cf768a695e83eefa);

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");

var $1FDIy = parcelRequire("1FDIy");

var $2NMWZ = parcelRequire("2NMWZ");
const $e08f4de833312075$var$getTimeout = ()=>50000;
const $e08f4de833312075$var$getFieldsInitializationTime = (startTime)=>startTime !== null ? performance.now() - startTime : null;
const $e08f4de833312075$var$isFieldInitialisationComplete = (status)=>status === 'success' || status === 'timedOut';
const $e08f4de833312075$export$2c0f020b89dfa30b = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ setState: setState, getState: getState, dispatch: dispatch })=>{
        const { fieldsInitialization: fieldsInitialization } = getState();
        if (fieldsInitialization.timeoutId === undefined && fieldsInitialization.status === 'notStarted') {
            const timeoutId = setTimeout(()=>dispatch($e08f4de833312075$export$8ce83a9201590a5e({
                    createAnalyticsEvent: createAnalyticsEvent
                })), $e08f4de833312075$var$getTimeout());
            setState({
                fieldsInitialization: {
                    startTime: performance.now(),
                    timeoutId: timeoutId,
                    status: 'inProgress'
                }
            });
        }
    };
const $e08f4de833312075$export$8ce83a9201590a5e = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { formData: formData, experienceDataIsLoading: experienceDataIsLoading, numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { startTime: startTime, status: status } = fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status) || (0, $1FDIy.selectReadyPublicDataForOnInit)(getState(), {
            viewType: viewType
        }) !== null) return;
        dispatch((0, $2NMWZ.setError)({
            errorCode: 'ON_INIT_FIELDS_INITIALIZATION_TIMEOUT'
        }));
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'timedOut',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                configuredTimeout: $e08f4de833312075$var$getTimeout(),
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: Object.keys(formData ?? {}).length,
                experienceDataIsLoading: experienceDataIsLoading,
                supportedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'timedOut'
            }
        });
    };
const $e08f4de833312075$export$cf768a695e83eefa = ({ createAnalyticsEvent: createAnalyticsEvent })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $2jyqu.fireOperationalEvent));
        const { status: status } = getState().fieldsInitialization;
        if ($e08f4de833312075$var$isFieldInitialisationComplete(status)) return;
        const { numberOfSupportedFields: numberOfSupportedFields, fieldsInitialization: fieldsInitialization } = getState();
        const { timeoutId: timeoutId, startTime: startTime } = fieldsInitialization;
        clearTimeout(timeoutId);
        (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
            action: 'success',
            actionSubject: 'jiraUiModifications.fieldsInitialization',
            attributes: {
                previousStatus: status,
                fieldsInitializationTime: $e08f4de833312075$var$getFieldsInitializationTime(startTime),
                initalizedFieldsCount: numberOfSupportedFields,
                viewType: viewType
            }
        });
        setState({
            fieldsInitialization: {
                ...fieldsInitialization,
                status: 'success'
            }
        });
    };

});
parcelRegister("1FDIy", function(module, exports) {

$parcel$export(module.exports, "selectReadyPublicDataForOnInit", () => $9ea7c26aba3c4975$export$4cadeedb8c3f31f7);

var $6dDSs = parcelRequire("6dDSs");
const $9ea7c26aba3c4975$export$4cadeedb8c3f31f7 = (0, $6dDSs.createSelector)((state)=>state.formData, (state)=>state.numberOfSupportedFields, (state)=>state.screenTabs, (state)=>state.experienceDataIsLoading, (formData, numberOfSupportedFields, screenTabsData, experienceDataIsLoading)=>{
    if (formData !== null && screenTabsData !== null && numberOfSupportedFields !== 0 && experienceDataIsLoading === false && Object.keys(formData).length === numberOfSupportedFields) return {
        formData: formData,
        screenTabsData: screenTabsData
    };
    return null;
});

});


parcelRegister("8e24q", function(module, exports) {

$parcel$export(module.exports, "initializeField", () => $c1b779e01c06a231$export$6b51e123e61a9615);
$parcel$export(module.exports, "initializeFields", () => $c1b779e01c06a231$export$4a6b4707110b0552);

var $iLSUx = parcelRequire("iLSUx");
const $c1b779e01c06a231$export$6b51e123e61a9615 = ({ field: field, metadata: metadata })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData = {} } = getState();
        const fieldMetadata = {
            allowedValues: field.allowedValues,
            isReadOnlyBySystem: field.isReadOnly,
            isRequiredBySystem: field.isRequired,
            fieldRenderer: metadata?.fieldRenderer,
            fieldType: field.fieldType
        };
        const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: fieldMetadata,
            internalFieldValue: field.value,
            fieldType: field.fieldType,
            viewType: viewType
        });
        setState({
            formData: {
                ...formData,
                [field.fieldId]: {
                    fieldId: field.fieldId,
                    fieldName: field.fieldName,
                    description: field.description,
                    isVisible: field.isVisible,
                    fieldType: field.fieldType,
                    isReadOnly: field.isReadOnly,
                    isRequired: field.isRequired,
                    value: publicValue,
                    optionsVisibility: undefined
                }
            },
            internalFormMetadata: {
                ...internalFormMetadata,
                [field.fieldId]: fieldMetadata
            }
        });
    };
const $c1b779e01c06a231$export$4a6b4707110b0552 = (fields)=>({ setState: setState }, { viewType: viewType })=>{
        const { formData: formData, internalFormMetadata: internalFormMetadata } = fields.reduce((acc, { field: field, metadata: metadata })=>{
            const fieldMetadata = {
                allowedValues: field.allowedValues,
                isReadOnlyBySystem: field.isReadOnly,
                isRequiredBySystem: field.isRequired,
                fieldRenderer: metadata?.fieldRenderer,
                fieldType: field.fieldType
            };
            const publicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
                fieldMetadata: fieldMetadata,
                internalFieldValue: field.value,
                fieldType: field.fieldType,
                viewType: viewType
            });
            acc.formData[field.fieldId] = {
                fieldId: field.fieldId,
                fieldName: field.fieldName,
                description: field.description,
                isVisible: field.isVisible,
                fieldType: field.fieldType,
                isReadOnly: field.isReadOnly,
                isRequired: field.isRequired,
                value: publicValue,
                optionsVisibility: undefined
            };
            acc.internalFormMetadata[field.fieldId] = fieldMetadata;
            return acc;
        }, {
            internalFormMetadata: {},
            formData: {}
        });
        setState({
            formData: formData,
            internalFormMetadata: internalFormMetadata,
            numberOfSupportedFields: fields.length
        });
    };

});
parcelRegister("iLSUx", function(module, exports) {

$parcel$export(module.exports, "mapFieldValueFromInternalToPublic", () => $4854c3676fce92c1$export$50806045b617d116);

var $gKZoD = parcelRequire("gKZoD");

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $4854c3676fce92c1$export$50806045b617d116 = ({ fieldMetadata: fieldMetadata, internalFieldValue: internalFieldValue, fieldType: fieldType, viewType: viewType })=>{
    (0, $gKZoD.di)((0, $cmmj3.fireErrorAnalytics), (0, $gL80q.getSupportedFieldConfiguration));
    if (fieldMetadata === undefined) throw new Error('Attempt to set value for the uninitialized field');
    let value = internalFieldValue;
    try {
        const valueTransformer = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.internalToPublicTransformers.value;
        if (valueTransformer) /**
			 * We trust that the internal field data is in the correct shape.
			 * Data that is in the incorrect shape will result in error events
			 * being logged for further investigation. In this error case we will
			 * pass `null` as the value to unblock onInit for the apps
			 *
			 * The `fieldRenderer` passed to the `valueTransformer` is used only for
			 * rich text fields and will be `undefined` for most of the executions
			 */ value = valueTransformer(internalFieldValue, fieldMetadata?.fieldRenderer);
    } catch (error) {
        value = null;
        (0, $cmmj3.fireErrorAnalytics)({
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            error: error,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return value;
};

});
parcelRegister("cmmj3", function(module, exports) {

$parcel$export(module.exports, "fireErrorAnalytics", () => $1359a69054531aa4$export$a27c21aa3ed8f0f1);

var $1nF7O = parcelRequire("1nF7O");

var $z11xo = parcelRequire("z11xo");
const $1359a69054531aa4$export$1bee4e6be783dd26 = (message)=>message.replaceAll(/\w+@[\w.]+/gi, '***@***');
const $1359a69054531aa4$export$a27c21aa3ed8f0f1 = ({ error: error, id: id, viewType: viewType, attributes: attributes = {}, event: event })=>{
    const errorType = (0, $z11xo.getErrorType)(error);
    const packageName = `${viewType}jiraUiModifications`;
    (0, $1nF7O.fireErrorAnalytics)({
        event: event,
        meta: {
            id: id,
            packageName: packageName,
            teamName: 'unbox'
        },
        error: error,
        attributes: {
            errorType: errorType,
            errorMessage: typeof error.message === 'string' ? $1359a69054531aa4$export$1bee4e6be783dd26(error.message) : error.message,
            ...attributes
        }
    });
};

});
parcelRegister("z11xo", function(module, exports) {

$parcel$export(module.exports, "getErrorType", () => $df5192e881ed2750$export$e19f9f08a6d79fd2);

var $3HlI9 = parcelRequire("3HlI9");
const $df5192e881ed2750$var$commonErrors = {
    MUST_INCLUDE_ACCOUNT_ID: 'Response ended with an error message: Requests from this source must include an accountId',
    OPERATION_ABORTED: 'The operation was aborted. ',
    CANCELLED: 'cancelled',
    UNEXPECTED_ERROR_OCCURRED: 'Response ended with an error message: An unexpected error occurred',
    NETWORK_CONNECTION_LOST: 'The network connection was lost.',
    TIMEOUT: 'The request timed out.',
    AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS: 'Response ended with an error message: Authorization failed: Principal has insufficient permissions',
    GATEWAY_TIMEOUT: 'Response ended with an error message: The underlying service call failed. The underlying service cs_extensions status code is : 504'
};
const $df5192e881ed2750$export$23de3198bfe70090 = 'DATA_CLASSIFICATION_NO_ACCESS';
const $df5192e881ed2750$export$f52aa41ccd776f01 = 'FAILED_TO_FETCH';
const $df5192e881ed2750$export$31d2ab0be67934f0 = 'AUTHORIZATION_FAILED_INSUFFICIENT_PERMISSIONS';
const $df5192e881ed2750$export$7a1bd8c001e7e9c = 'RATE_LIMITING';
const $df5192e881ed2750$export$89a175d4190df42e = 'Invoke value functions failed:';
const $df5192e881ed2750$export$215c097832f3122d = 'AGG_UNDERLYING_SERVICE_TIMEOUT';
const $df5192e881ed2750$export$dddade71b333c01d = new RegExp('The user did not consent to use the app', 'i');
const $df5192e881ed2750$var$BAD_REQUEST = 400;
const $df5192e881ed2750$var$REQUEST_TIMEOUT = 408;
const $df5192e881ed2750$export$8a5d666d6e5b82fc = (error)=>{
    // React loosely lazy chunk load error type
    if (typeof error === 'object' && error.name === 'ChunkLoadError') return true;
    // Other chunk load error types
    // In theory it should be handled by a common isClientFetchError, but it ignores TypeError error types
    const KNOWN_NETWORK_ERRORS = [
        'Failed to fetch dynamically imported module',
        'error loading dynamically imported module',
        'Importing a module script failed',
        'Cannot find module'
    ];
    const isClientFetchErrorMessage = (message)=>Boolean(message) && !!KNOWN_NETWORK_ERRORS.find((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
            // are sometimes wrapped to provide additional context, e.g.
            // "Something went wrong: ${error.message}"
            message.includes(networkErrorMessage));
    return Boolean(error) && typeof error === 'object' && (isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && error.cause && 'message' in error.cause && isClientFetchErrorMessage(String(error.cause.message)));
};
const $df5192e881ed2750$export$e19f9f08a6d79fd2 = (_error)=>{
    if (_error == null) return 'NULL_OR_UNDEFINED';
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const error = _error;
    const message = String(error instanceof Error ? error.message : error).trim();
    const isTimeoutError = (timedOutResource)=>Boolean(typeof error === 'object' && error.name === 'TimeoutError' && error.stack?.includes(timedOutResource));
    if (message === "A hidden extension shouldn't be rendered") return 'HIDDEN_EXTENSION_RENDER_ATTEMPT';
    const circuitBreakerErrorRegex = new RegExp("We couldn't show this extension", 'i');
    if (circuitBreakerErrorRegex.test(message)) return 'CIRCUIT_BREAKER_ERROR';
    const rateLimitingRegex = new RegExp("Response ended with an error message: You are trying to access '.*' too often", 'i');
    const rateLimitingDataClassificationRegex = new RegExp('Data classification request failed: Error server response: 429');
    if (rateLimitingRegex.test(message) || rateLimitingDataClassificationRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    const serverErrorRegex = new RegExp('^Error server response: (\\d+)$', 'i');
    if (serverErrorRegex.test(message)) {
        const match = message.match(serverErrorRegex);
        const statusCode = match ? match[1] : 'NO_STATUS_CODE';
        return `ERROR_SERVER_RESPONSE_${statusCode}`;
    }
    const aggGiraServerErrorRegex = new RegExp('The underlying service gira status code is: (\\d+)$', 'im');
    if (aggGiraServerErrorRegex.test(message)) {
        const match = message.match(aggGiraServerErrorRegex);
        const statusCode = match?.[1] ?? 'NO_STATUS_CODE';
        return `AGG_GIRA_ERROR_${statusCode}`;
    }
    const dataClassification404ErrorRegex = new RegExp('Data classification request failed: Error server response: 404', 'i');
    const dataClassification401ErrorRegex = new RegExp('Data classification request failed: Error server response: 401', 'i');
    if (dataClassification401ErrorRegex.test(message) || dataClassification404ErrorRegex.test(message)) return $df5192e881ed2750$export$23de3198bfe70090;
    // Add here errors related to a broken app configuration/manifest
    if (message.startsWith('Function definition is invalid.')) return 'APP_DEV_ERROR';
    const graphqlErrorRegex = new RegExp('^GraphQL error', 'i');
    if (graphqlErrorRegex.test(message)) return 'GRAPHQL_ERROR';
    if ($df5192e881ed2750$export$dddade71b333c01d.test(message)) return 'USER_DIDNT_CONSENT_ERROR';
    const aggUnderlyingServiceTimeoutRegex = new RegExp('The underlying service call timed out', 'i');
    if (aggUnderlyingServiceTimeoutRegex.test(message)) return $df5192e881ed2750$export$215c097832f3122d;
    const appValueFunction = new RegExp("The app's value function failed", 'i');
    const serverValueFunction408ErrorRegex = new RegExp('Invoke value functions failed: Error server response: 408', 'i');
    const invokeValueFunctionFailed = new RegExp($df5192e881ed2750$export$89a175d4190df42e, 'i');
    /**
	 * In case when we get bad request(400) from the BE it should be treated as an app error as there
	 * are many ways to fail the value function
	 */ const valueFunctionAppsBadRequest = invokeValueFunctionFailed.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$BAD_REQUEST;
    /**
	 * In case when we get request timeout(408) from the XIS invocation it should be treated as an app error.
	 * Error occurs when invocation exceeds 25s threshold e.g.too long time to execute request to external API
	 */ const valueFunctionTimeoutError = serverValueFunction408ErrorRegex.test(message) && 'statusCode' in error && error.statusCode === $df5192e881ed2750$var$REQUEST_TIMEOUT;
    if (appValueFunction.test(message) || valueFunctionTimeoutError || valueFunctionAppsBadRequest) return 'VALUE_FUNCTION_APP_ERROR';
    /*
	 * 	Whole message:
	 *	Fetching formatted value after edit failed: FetchError: Fetch call failed with status code: 429
	 */ const valueFunctionEditRateLimitedRegex = new RegExp('Fetch call failed with status code: 429', 'i');
    /*
	 * 	Whole message:
	 *	Invoke value functions failed: Error server response: 429
	 */ const valueFunctionInvokeRateLimitedRegex = new RegExp('Error server response: 429', 'i');
    if (valueFunctionEditRateLimitedRegex.test(message) || valueFunctionInvokeRateLimitedRegex.test(message)) return $df5192e881ed2750$export$7a1bd8c001e7e9c;
    // The full message states:
    // Extension "extension name" does not exist, the app may have changed or no longer be installed in this context
    const extensionDoesntExistRegex = new RegExp('^Extension "(.*)" does not exist', 'i');
    if (extensionDoesntExistRegex.test(message)) return 'EXTENSION_DOESNT_EXIST';
    // In case of React error message:
    // Failed to execute 'removeChild' on 'Node': The node to be removed is not a child of this node.
    const removeChildOnNodeRegex = new RegExp("^Failed to execute 'removeChild' on 'Node'", 'i');
    if (removeChildOnNodeRegex.test(message)) return 'REMOVE_CHILD_ERROR';
    if ($df5192e881ed2750$export$8a5d666d6e5b82fc(error)) return 'CHUNK_LOAD';
    if (isTimeoutError('FORGE_PROJECT_MODULE')) return 'TIMEOUT_PROJECT_MODULE';
    if (isTimeoutError('FORGE_PROJECT_SETTINGS_MODULE')) return 'TIMEOUT_PROJECT_SETTINGS_MODULE';
    if (isTimeoutError('PROJECT_CONTEXT')) return 'TIMEOUT_PROJECT_CONTEXT';
    const entry = Object.entries($df5192e881ed2750$var$commonErrors).find((arrayItem)=>String(arrayItem[1]).toLowerCase() === message.toLowerCase());
    if (entry) return entry[0];
    if ((0, $3HlI9.isClientFetchError)(error)) return $df5192e881ed2750$export$f52aa41ccd776f01;
    if (error != null && 'statusCode' in error && error.statusCode === 429) return 'RATE_LIMITING';
    return 'OTHER';
};

});
parcelRegister("3HlI9", function(module, exports) {

$parcel$export(module.exports, "isClientFetchError", () => $cbf82ad04131c769$export$2e7adc44463c3f4f);
// Copied from jira/src/packages/platform/utils/fetch/src/utils/is-error.tsx
// Exclude client connectivity and HTTP client network errors as a SLO failure
// e.g. during quick SPA transition when a network call haven't finished yet,
// or when the user's internet connection drops out.
const $cbf82ad04131c769$export$c748438cec453c9f = [
    '... is not valid JSON',
    'server with the specified hostname could not be found',
    'cannot parse response',
    'connection failure',
    'Failed to fetch',
    'in JSON at position 0',
    'JSON.parse: unexpected character at line 1 column 1 of the JSON data',
    'JSON.parse: unexpected end of data at line 1 column 1 of the JSON data',
    'Load failed',
    'Network request failed',
    'NetworkError',
    'Syntax or http error',
    'The request timed out',
    'The network connection was lost',
    'The operation was aborted',
    'Unable to fetch manifest',
    'Unexpected end of input',
    'Unexpected end of JSON input',
    'dynamically imported module',
    'Importing a module script failed'
];
const $cbf82ad04131c769$export$3876cb851aa46193 = [
    'AbortError',
    'AuthError',
    'ChunkLoadError',
    'NetworkError'
];
const $cbf82ad04131c769$var$isClientFetchErrorMessage = (message)=>Boolean(message) && $cbf82ad04131c769$export$c748438cec453c9f.some((networkErrorMessage)=>// Using `includes` here because the underlying fetch error messages
        // are sometimes wrapped to provide additional context, e.g.
        // "Something went wrong: ${error.message}"
        message.includes(networkErrorMessage));
const $cbf82ad04131c769$export$2e7adc44463c3f4f = (error)=>Boolean(error) && typeof error === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.message) || typeof error.cause === 'object' && ($cbf82ad04131c769$export$3876cb851aa46193.includes(error.cause.name) || $cbf82ad04131c769$var$isClientFetchErrorMessage(error.cause.message)));

});



parcelRegister("gL80q", function(module, exports) {

$parcel$export(module.exports, "getSupportedFieldConfiguration", () => $968cd36658e5c86e$export$8fc8d6775f1842b8);
$parcel$export(module.exports, "isFieldTypeSupported", () => $968cd36658e5c86e$export$b47920a5dd99844f);
$parcel$export(module.exports, "getConsentMessage", () => $968cd36658e5c86e$export$20eabd2b3ada6bf3);
$parcel$export(module.exports, "isExecutionContextSupported", () => $968cd36658e5c86e$export$b768d6a95f7a930);
$parcel$export(module.exports, "getAnalytics", () => $968cd36658e5c86e$export$b0297573c90085aa);
$parcel$export(module.exports, "isTriggerPointSupported", () => $968cd36658e5c86e$export$ef45e4471aa21b27);

var $cmmj3 = parcelRequire("cmmj3");

var $3OTqu = parcelRequire("3OTqu");
const $968cd36658e5c86e$var$isKeyOf = (key, object)=>object[key] !== undefined;
const $968cd36658e5c86e$var$getConfigurationByViewType = ({ viewType: viewType })=>{
    const viewConfiguration = (0, $3OTqu.getViewConfiguration)(viewType);
    if (!viewConfiguration) throw new Error(`Unsupported view type ${viewType} in getConfigurationByViewType.`);
    return viewConfiguration;
};
function $968cd36658e5c86e$export$8fc8d6775f1842b8(viewType, fieldType) {
    const fieldsConfiguration = $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldsConfiguration();
    if (!$968cd36658e5c86e$var$isKeyOf(fieldType, fieldsConfiguration)) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: new Error('Unsupported field type.'),
            id: 'getSupportedFieldConfiguration',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
        return undefined;
    }
    return fieldsConfiguration[fieldType];
}
const $968cd36658e5c86e$export$e4330d77fd93d1de = (viewType)=>$968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedFieldTypes();
function $968cd36658e5c86e$export$b47920a5dd99844f(viewType, fieldType) {
    return fieldType !== undefined && // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    $968cd36658e5c86e$export$e4330d77fd93d1de(viewType).includes(fieldType);
}
function $968cd36658e5c86e$export$20eabd2b3ada6bf3(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getConsentMessage();
}
function $968cd36658e5c86e$export$b768d6a95f7a930(context) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: context.viewType
    }).isExecutionContextSupported({
        context: context
    });
}
function $968cd36658e5c86e$export$b0297573c90085aa(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getAnalytics();
}
function $968cd36658e5c86e$export$c0728caa743a409e(viewType) {
    return $968cd36658e5c86e$var$getConfigurationByViewType({
        viewType: viewType
    }).getSupportedTriggerPointsConfiguration();
}
const $968cd36658e5c86e$export$ef45e4471aa21b27 = (viewType, triggerPoint)=>triggerPoint !== undefined && $968cd36658e5c86e$export$c0728caa743a409e(viewType).has(triggerPoint);

});
parcelRegister("3OTqu", function(module, exports) {

$parcel$export(module.exports, "getViewConfiguration", () => $b8beb3418915829f$export$176b6e68da08ffa2);
$parcel$export(module.exports, "useLoadViewConfiguration", () => $b8beb3418915829f$export$f0022a21ccd1f6be);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");
const $b8beb3418915829f$var$VIEW_CONFIGURATIONS = new Map();
const $b8beb3418915829f$export$cda1ad403b37fe70 = (viewType, configuration)=>{
    if (!$b8beb3418915829f$var$VIEW_CONFIGURATIONS.has(viewType)) $b8beb3418915829f$var$VIEW_CONFIGURATIONS.set(viewType, configuration);
};
const $b8beb3418915829f$export$176b6e68da08ffa2 = (viewType)=>$b8beb3418915829f$var$VIEW_CONFIGURATIONS.get(viewType);
const $b8beb3418915829f$export$e8091eff40c4f16e = ()=>{
    $b8beb3418915829f$var$VIEW_CONFIGURATIONS.clear();
};
const $b8beb3418915829f$export$f0022a21ccd1f6be = (viewType, configurationClass)=>{
    (0, $gKZoD.di)($b8beb3418915829f$export$cda1ad403b37fe70);
    /**
	 * Uses useState to load view configuration on component mount, before rendering.
	 */ (0, $5uXOq.useState)(()=>{
        $b8beb3418915829f$export$cda1ad403b37fe70(viewType, new configurationClass());
    });
};

});




parcelRegister("cTj8m", function(module, exports) {

$parcel$export(module.exports, "initializeNoScreenTab", () => $b87f070d69e40149$export$93459ad9bfd6c380);
const $b87f070d69e40149$export$93459ad9bfd6c380 = ()=>({ setState: setState })=>{
        setState({
            screenTabs: []
        });
    };

});

parcelRegister("i4uue", function(module, exports) {

$parcel$export(module.exports, "initializeScreenTabs", () => $559bbe3e01414de7$export$7f7be235f64f029b);
const $559bbe3e01414de7$export$7f7be235f64f029b = ({ tabs: tabs, selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: internalScreenTabs } = getState();
        const previouslySelected = internalScreenTabs?.findIndex((tab)=>tab.isActive);
        setState({
            screenTabs: tabs.map(({ id: id }, index)=>({
                    id: id,
                    isVisible: true,
                    isActive: index === selected || index === previouslySelected
                }))
        });
    };

});

parcelRegister("b8ZsE", function(module, exports) {

$parcel$export(module.exports, "processChange", () => $926b03f8c2e312a1$export$352dfcce04d66748);

var $3ZT8o = parcelRequire("3ZT8o");

var $gKZoD = parcelRequire("gKZoD");

var $gL80q = parcelRequire("gL80q");

var $l6AQO = parcelRequire("l6AQO");
const $926b03f8c2e312a1$export$352dfcce04d66748 = ({ fieldId: fieldId, fieldValue: fieldValue, eventType: eventType })=>({ setState: setState, getState: getState }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o))));
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        const fieldType = internalFormMetadata[fieldId]?.fieldType;
        if (!fieldType) return;
        const emitChangeOn = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType)?.emitChangeOn;
        if (emitChangeOn !== eventType) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        /**
		 * setTimeout justification - we need to delay the state update to the next tick to avoid batched updates.
		 * Otherwise, UIM app may not be notified about every single change.
		 */ setTimeout(()=>{
            const changeId = (0, (/*@__PURE__*/$parcel$interopDefault($3ZT8o)))();
            setState({
                lastProcessedChange: {
                    fieldId: fieldId,
                    changeId: changeId
                },
                formData: nextFormData
            });
        }, 0);
    };

});
parcelRegister("3ZT8o", function(module, exports) {

var $jJVtR = parcelRequire("jJVtR");
/** Used to generate unique IDs. */ var $2e91d6202798e8a1$var$idCounter = 0;
/**
 * Generates a unique ID. If `prefix` is given, the ID is appended to it.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {string} [prefix=''] The value to prefix the ID with.
 * @returns {string} Returns the unique ID.
 * @example
 *
 * _.uniqueId('contact_');
 * // => 'contact_104'
 *
 * _.uniqueId();
 * // => '105'
 */ function $2e91d6202798e8a1$var$uniqueId(prefix) {
    var id = ++$2e91d6202798e8a1$var$idCounter;
    return $jJVtR(prefix) + id;
}
module.exports = $2e91d6202798e8a1$var$uniqueId;

});

parcelRegister("l6AQO", function(module, exports) {

$parcel$export(module.exports, "calculateNextFormValue", () => $2b658e9f553d1ad3$export$25441a03bb8f1cb0);

var $ajpes = parcelRequire("ajpes");

var $iLSUx = parcelRequire("iLSUx");
const $2b658e9f553d1ad3$export$25441a03bb8f1cb0 = ({ internalFormMetadata: internalFormMetadata, formData: formData, fieldId: fieldId, fieldValue: fieldValue, fieldType: fieldType, viewType: viewType })=>{
    if (formData === null) return null;
    let newPublicValue;
    try {
        newPublicValue = (0, $iLSUx.mapFieldValueFromInternalToPublic)({
            fieldMetadata: internalFormMetadata[fieldId],
            internalFieldValue: fieldValue,
            fieldType: fieldType,
            viewType: viewType
        });
    } catch (e) {
        return null;
    }
    const currentPublicValue = formData[fieldId]?.value;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(newPublicValue, currentPublicValue)) return null;
    return {
        ...formData,
        [fieldId]: {
            ...formData[fieldId],
            value: newPublicValue
        }
    };
};

});


parcelRegister("jDMtG", function(module, exports) {

$parcel$export(module.exports, "registerFields", () => $5e78d8ed1ee13321$export$d4eb181b231cf88d);
$parcel$export(module.exports, "unregisterFields", () => $5e78d8ed1ee13321$export$1ca69a85bb7273de);

var $fr1K2 = parcelRequire("fr1K2");

var $kGsr8 = parcelRequire("kGsr8");
const $5e78d8ed1ee13321$export$d4eb181b231cf88d = ({ changeId: changeId, fieldsToBeRegistered: fieldsToBeRegistered, appId: appId })=>({ setState: setState, getState: getState })=>{
        if (!Array.isArray(fieldsToBeRegistered)) return;
        const { registeredFields: registeredFields } = getState();
        const appFields = registeredFields[appId] ?? {};
        const appChangeIdFields = appFields[changeId] ?? [];
        const nextRegisteredFields = {
            ...registeredFields,
            [appId]: {
                ...appFields,
                [changeId]: (0, (/*@__PURE__*/$parcel$interopDefault($kGsr8)))([
                    ...appChangeIdFields,
                    ...fieldsToBeRegistered
                ])
            }
        };
        setState({
            registeredFields: nextRegisteredFields
        });
    };
const $5e78d8ed1ee13321$export$1ca69a85bb7273de = ({ changeId: changeId, appId: appId })=>({ setState: setState, getState: getState })=>{
        const { registeredFields: registeredFields } = getState();
        const registeredAppFields = registeredFields[appId] ?? {};
        const nextRegisteredAppFields = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(registeredAppFields, changeId);
        setState({
            registeredFields: {
                ...registeredFields,
                [appId]: nextRegisteredAppFields
            }
        });
    };

});

parcelRegister("l0b2q", function(module, exports) {

$parcel$export(module.exports, "setFieldValue", () => $da1080104d423ca2$export$6556d46d2662453c);

var $l6AQO = parcelRequire("l6AQO");
const $da1080104d423ca2$export$6556d46d2662453c = ({ fieldId: fieldId, fieldType: fieldType, fieldValue: fieldValue })=>({ getState: getState, setState: setState }, { viewType: viewType })=>{
        const { internalFormMetadata: internalFormMetadata, formData: formData } = getState();
        /**
		 * We can set new field value only if the field was initialized.
		 * This checks the field metedata that indicates the successfull initialization.
		 */ if (!internalFormMetadata[fieldId]) return;
        const nextFormData = (0, $l6AQO.calculateNextFormValue)({
            internalFormMetadata: internalFormMetadata,
            formData: formData,
            fieldType: fieldType,
            fieldId: fieldId,
            fieldValue: fieldValue,
            viewType: viewType
        });
        if (nextFormData === null) return;
        setState({
            formData: nextFormData
        });
    };

});

parcelRegister("4MJXd", function(module, exports) {

$parcel$export(module.exports, "updateActiveScreenTab", () => $104b1b4dd763f6ee$export$21363496760d39cd);
const $104b1b4dd763f6ee$export$21363496760d39cd = ({ selected: selected })=>({ getState: getState, setState: setState })=>{
        const { screenTabs: screenTabs } = getState();
        if (screenTabs) setState({
            screenTabs: screenTabs.map((tab, index)=>({
                    ...tab,
                    isActive: index === selected
                }))
        });
    };

});

parcelRegister("gHQFd", function(module, exports) {

$parcel$export(module.exports, "updateFields", () => $069ce0e12537855c$export$cceae62fd4d1ef0a);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $2jyqu = parcelRequire("2jyqu");


var $ajglJ = parcelRequire("ajglJ");

var $dA2NP = parcelRequire("dA2NP");

var $fKje4 = parcelRequire("fKje4");

var $dwG9p = parcelRequire("dwG9p");

var $dRfi6 = parcelRequire("dRfi6");

var $3whHg = parcelRequire("3whHg");

var $boEP0 = parcelRequire("boEP0");

var $hzAKL = parcelRequire("hzAKL");
const $069ce0e12537855c$export$cceae62fd4d1ef0a = ({ changeId: changeId, fieldsChanges: fieldsChanges, lookupDataFromApi: lookupDataFromApi, tenantContext: tenantContext, executionContext: executionContext, environment: environment, appId: appId, intl: intl, createAnalyticsEvent: createAnalyticsEvent })=>async ({ setState: setState, getState: getState, dispatch: dispatch }, { viewType: viewType })=>{
        (0, $gKZoD.di)((0, $boEP0.collectFieldsAppliedChangesHistory));
        const appliedChanges = getState().appliedChanges ?? {};
        const formData = getState().formData ?? {};
        const { internalFormMetadata: internalFormMetadata, registeredFields: registeredFields } = getState();
        const { changesToApply: changesToApply, incomingFormData: incomingFormData, errorsByField: errorsByField, newAppliedChangesPublic: newAppliedChangesPublic } = await Object.keys(fieldsChanges).reduce(async (acc, fieldId)=>{
            // Do not update fields that are not inside initialized data.
            // Validates if the field that comes from Iframe is supported
            // - because we add to formData only the supported ones.
            const fieldData = formData[fieldId];
            const internalMetadata = internalFormMetadata[fieldId];
            const fieldIsRegistered = (0, $dA2NP.fieldWasRegistered)(registeredFields, changeId, fieldId, appId);
            // Only registered field Ids can be updated.
            if (!fieldIsRegistered || !fieldData) {
                const { fieldType: fieldType } = fieldData ?? {};
                dispatch((0, $3whHg.addAppsErrors)({
                    errors: {
                        [appId]: [
                            {
                                fieldType: fieldType,
                                fieldId: fieldId,
                                type: 'APPLY_CHANGES_FOR_UNREGISTERED_FIELD',
                                message: 'Application tried to apply changes to unregistered field'
                            }
                        ]
                    }
                }));
                (0, $2jyqu.fireOperationalEvent)(createAnalyticsEvent, {
                    action: 'unregisteredField',
                    actionSubject: 'jiraUiModifications.applyChanges',
                    attributes: {
                        message: 'Attempt to apply changes to a field that was not registered',
                        fieldId: fieldId,
                        viewType: viewType
                    }
                });
                return acc;
            }
            const lookupData = {
                [(0, $80e7f3d73b333b84$export$a1cacdcf198da901)]: internalMetadata.allowedValues,
                [(0, $80e7f3d73b333b84$export$3a106242c8f57ac2)]: lookupDataFromApi[0, $80e7f3d73b333b84$export$3a106242c8f57ac2]
            };
            // It updates properties in each field to avoid removing unchanged props for
            // selected field by another app or another onChange update.
            // Only supported properties are allowed.
            const supportedFieldChanges = await (0, $hzAKL.transformFieldChangesToInternalShape)({
                fieldType: fieldData.fieldType,
                fieldId: fieldId,
                fieldFromIframe: fieldsChanges?.[fieldId],
                lookupData: lookupData,
                viewType: viewType,
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                intl: intl
            });
            if (supportedFieldChanges.isValid === false) {
                (await acc).errorsByField[fieldId] = supportedFieldChanges.errors;
                return acc;
            }
            // It converts changes to 'public' format to update the formData
            const publicShapeChanges = (0, $dRfi6.transformFieldToIframe)(supportedFieldChanges.data, viewType, fieldData.fieldType, lookupData, fieldsChanges?.[fieldId], internalMetadata);
            const transformedFieldChanges = (0, $fKje4.mapFieldPropertyNamesToInternal)(supportedFieldChanges.data, viewType, fieldData.fieldType);
            const combinedChangesToApply = {
                ...appliedChanges[fieldId],
                ...transformedFieldChanges
            };
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(combinedChangesToApply)) {
                (await acc).newAppliedChangesPublic[fieldId] = publicShapeChanges;
                (await acc).changesToApply[fieldId] = combinedChangesToApply;
                (await acc).incomingFormData[fieldId] = {
                    ...formData[fieldId],
                    ...publicShapeChanges
                };
            }
            return acc;
        }, Promise.resolve({
            changesToApply: {
                ...appliedChanges
            },
            incomingFormData: {
                ...formData
            },
            newAppliedChangesPublic: {},
            errorsByField: {}
        }));
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(errorsByField)) throw new (0, $ajglJ.UiModificationsFieldsValidationError)('Transformation failed', {
            errors: (0, $dwG9p.prepareErrorsArray)(errorsByField)
        });
        setState({
            appliedChanges: changesToApply,
            formData: incomingFormData
        });
        dispatch((0, $boEP0.collectFieldsAppliedChangesHistory)({
            appId: appId,
            changeId: changeId,
            fieldsChanges: newAppliedChangesPublic
        }));
    };

});
const $80e7f3d73b333b84$export$a1cacdcf198da901 = 'LOOKUP_SOURCE_ALLOWED_VALUES_PROPERTY';
const $80e7f3d73b333b84$export$3a106242c8f57ac2 = 'LOOKUP_SOURCE_USERS_ASYNC_DATA';
const $80e7f3d73b333b84$export$f5d5f6bb902f1027 = '-1';
const $80e7f3d73b333b84$export$106087dcfd4fb129 = 100;

parcelRegister("ajglJ", function(module, exports) {

$parcel$export(module.exports, "UiModificationsFieldsValidationError", () => $907938b0f57574ed$export$9e8b5e552e255163);

var $2jqAp = parcelRequire("2jqAp");
class $907938b0f57574ed$export$9e8b5e552e255163 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'fields', cause);
    }
}

});
parcelRegister("2jqAp", function(module, exports) {

$parcel$export(module.exports, "UiModificationsValidationError", () => $b8ce6491bf34e535$export$6e8165c81a6a65df);
class $b8ce6491bf34e535$export$6e8165c81a6a65df extends Error {
    constructor(message, attributes, validationErrorType, cause){
        super(message, cause);
        this.attributes = attributes;
        this.validationErrorType = validationErrorType;
    }
}

});


parcelRegister("dA2NP", function(module, exports) {

$parcel$export(module.exports, "fieldWasRegistered", () => $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b);
const $aff4a3261c4c9b6e$export$fbe9157c12cb4e7b = (registeredFields, changeId, fieldId, appId)=>!!registeredFields[appId]?.[changeId]?.includes(fieldId);

});

parcelRegister("fKje4", function(module, exports) {

$parcel$export(module.exports, "mapFieldPropertyNamesToInternal", () => $620a721e65ec1dbe$export$460820f27643954e);

var $gL80q = parcelRequire("gL80q");
const $620a721e65ec1dbe$export$460820f27643954e = (properties, viewType, fieldType)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const propertyMapping = fieldConfiguration?.propertyMapping;
    if (!propertyMapping) return properties;
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return Object.keys(properties).reduce((acc, propertyName)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const propertyMappingValue = propertyMapping[propertyName];
        acc[propertyMappingValue ?? propertyName] = properties[propertyName];
        return acc;
    }, {});
};

});

parcelRegister("dwG9p", function(module, exports) {

$parcel$export(module.exports, "prepareErrorsArray", () => $8d92968018d86237$export$e1fce51bc5be90b7);
const $8d92968018d86237$export$e1fce51bc5be90b7 = (errorsById)=>Object.values(errorsById).flat();

});

parcelRegister("dRfi6", function(module, exports) {

$parcel$export(module.exports, "transformFieldToIframe", () => $cc6b08557666e682$export$aa453854f74fab);

var $cmmj3 = parcelRequire("cmmj3");

var $gL80q = parcelRequire("gL80q");
const $cc6b08557666e682$export$aa453854f74fab = (fieldChanges, viewType, fieldType, lookupData, fieldFromIframe, fieldMetadata)=>{
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldInternalToPublicTransformers = fieldConfiguration?.internalToPublicTransformers;
    const publicShapeField = {
        ...fieldChanges
    };
    if (publicShapeField.value !== undefined && fieldInternalToPublicTransformers?.value) try {
        publicShapeField.value = fieldInternalToPublicTransformers?.value(fieldChanges.value, fieldMetadata.fieldRenderer);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicValueTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    if (fieldFromIframe.optionsVisibility !== undefined && fieldInternalToPublicTransformers?.optionsVisibility) try {
        const lookupSource = fieldConfiguration?.lookupSource;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore - lookupData is not types on CI somehow
        const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
        publicShapeField.optionsVisibility = fieldInternalToPublicTransformers?.optionsVisibility(fieldFromIframe.optionsVisibility, lookupValues);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (err) {
        (0, $cmmj3.fireErrorAnalytics)({
            error: err,
            id: 'internalToPublicOptionsVisibilityTransformer',
            viewType: viewType,
            attributes: {
                fieldType: fieldType
            }
        });
    }
    return publicShapeField;
};

});

parcelRegister("hzAKL", function(module, exports) {

$parcel$export(module.exports, "transformFieldChangesToInternalShape", () => $422557008e0dbc71$export$d14f85c01e334a1);

var $gccSB = parcelRequire("gccSB");

var $gKZoD = parcelRequire("gKZoD");

var $7NDId = parcelRequire("7NDId");

var $gL80q = parcelRequire("gL80q");


var $bCvSM = parcelRequire("bCvSM");

var $2J6IF = parcelRequire("2J6IF");

var $hwDyF = parcelRequire("hwDyF");
const $422557008e0dbc71$export$d14f85c01e334a1 = async ({ fieldType: fieldType, fieldId: fieldId, fieldFromIframe: fieldFromIframe, lookupData: lookupData, viewType: viewType, tenantContext: tenantContext, executionContext: executionContext, environment: environment, intl: intl })=>{
    (0, $gKZoD.di)((0, $gL80q.getSupportedFieldConfiguration));
    const fieldConfiguration = (0, $gL80q.getSupportedFieldConfiguration)(viewType, fieldType);
    const fieldTransformers = fieldConfiguration?.publicToInternalTransformers;
    const fieldValidators = fieldConfiguration?.publicShapeValidators;
    if (!fieldFromIframe || !fieldTransformers || !fieldValidators) return {
        ...(0, $2J6IF.VALID_RESULT),
        data: {}
    };
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const validatorsArray = Object.keys(fieldValidators);
    const lookupSource = fieldConfiguration?.lookupSource;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore - lookupData is not types on CI somehow
    const lookupValues = lookupSource ? lookupData[lookupSource] : undefined;
    const fieldTransformationResults = await Promise.all(validatorsArray.map(async (propertyName)=>{
        if (!Object.prototype.hasOwnProperty.call(fieldFromIframe, propertyName)) return 0, $2J6IF.VALID_RESULT;
        const propertyValue = fieldFromIframe[propertyName];
        const transformer = fieldTransformers[propertyName];
        const fieldContext = {
            fieldId: fieldId
        };
        // We need to catch lookup values discrepancies and react accordingly
        // to how we react to validation errors - throw an error
        // if the set value wasn't found in the array of lookupValues
        try {
            const data = transformer ? await transformer(propertyValue, lookupValues, {
                tenantContext: tenantContext,
                executionContext: executionContext,
                environment: environment,
                fieldContext: fieldContext,
                intl: intl
            }) : propertyValue;
            return {
                isValid: true,
                data: {
                    [propertyName]: data
                }
            };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (err) {
            // FieldValueLookupError will be thrown from the transformer
            // when the lookup value wasn't found
            if (err instanceof (0, $7NDId.FieldValueLookupError)) {
                // For single value fields its straightforward to just pass
                // the faulty propertyValue into error message,
                // but for multi value fields we should find out the faulty values from the array
                // thats why we should propagate the faulty values as a comma separated string
                // by using the error's message
                const faultyValue = err.message || propertyValue;
                return {
                    isValid: false,
                    error: {
                        fieldId: fieldId,
                        fieldType: fieldType,
                        type: (0, $ca611ff348f89182$export$d1996cb46a690190),
                        method: (0, $bCvSM.mapFieldPropertyToApiMethod)(propertyName),
                        message: `Invalid IDs provided: ${faultyValue}`
                    }
                };
            }
            throw err;
        }
    }));
    const invalidTransformationResults = (0, $hwDyF.filterInvalidResults)(fieldTransformationResults);
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(invalidTransformationResults)) return {
        isValid: false,
        errors: invalidTransformationResults.map((result)=>result.error)
    };
    return (0, $hwDyF.mapValidResultsToFieldInternalShape)(fieldTransformationResults);
};

});
parcelRegister("7NDId", function(module, exports) {

$parcel$export(module.exports, "FieldValueLookupError", () => $64626586c22c486e$export$73c2f0689b6c4a5a);
class $64626586c22c486e$export$73c2f0689b6c4a5a extends Error {
}

});

parcelRegister("2J6IF", function(module, exports) {

$parcel$export(module.exports, "VALID_RESULT", () => $5fbccb776f84792e$export$ee79e3ab53b8db79);
const $5fbccb776f84792e$export$ee79e3ab53b8db79 = {
    isValid: true
};

});

parcelRegister("hwDyF", function(module, exports) {

$parcel$export(module.exports, "mapValidResultsToFieldInternalShape", () => $e8aa8431ce8b786b$export$a60dd8f1b025f23d);
$parcel$export(module.exports, "filterInvalidResults", () => $e8aa8431ce8b786b$export$ddd005554aecd409);
const $e8aa8431ce8b786b$export$a60dd8f1b025f23d = (results)=>results.reduce((acc, result)=>{
        if (result.isValid === true && Object.prototype.hasOwnProperty.call(result, 'data')) acc.data = {
            ...acc.data,
            ...result.data
        };
        return acc;
    }, {
        isValid: true,
        data: {}
    });
const $e8aa8431ce8b786b$export$ddd005554aecd409 = (validationResults)=>validationResults.reduce((acc, result)=>{
        if (result.isValid === false) acc.push(result);
        return acc;
    }, []);

});



parcelRegister("7JtDe", function(module, exports) {

$parcel$export(module.exports, "updateScreenTabs", () => $c6c7124cbfc0022b$export$131c67fd312b8a11);

var $gKZoD = parcelRequire("gKZoD");

var $iUvwD = parcelRequire("iUvwD");

var $50ech = parcelRequire("50ech");

var $boEP0 = parcelRequire("boEP0");

var $iiEdL = parcelRequire("iiEdL");
const $c6c7124cbfc0022b$export$131c67fd312b8a11 = ({ screenTabsChanges: screenTabsFromIframe, changeId: changeId, appId: appId })=>({ getState: getState, setState: setState, dispatch: dispatch })=>{
        (0, $gKZoD.di)((0, $boEP0.collectScreenTabsAppliedChangesHistory), (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors));
        const { screenTabs: internalScreenTabs } = getState();
        // If screenTabsFromIframe is empty it means that the app does not provide srceenTabs changes.
        if (Array.isArray(screenTabsFromIframe) && !screenTabsFromIframe.length) return;
        if (internalScreenTabs && (0, $iiEdL.screenTabsPublicToInternalValidator)(internalScreenTabs, screenTabsFromIframe)) {
            const newScreenTabs = (0, $iiEdL.screenTabsPublicToInternalTransformer)(internalScreenTabs, screenTabsFromIframe);
            setState({
                screenTabs: newScreenTabs
            });
            dispatch((0, $boEP0.collectScreenTabsAppliedChangesHistory)({
                appId: appId,
                changeId: changeId,
                screenTabs: newScreenTabs
            }));
        } else throw new (0, $iUvwD.UiModificationsScreenTabsValidationError)('Transformation failed', {
            errors: (0, $iiEdL.getScreenTabsPublicToInternalValidationErrors)(internalScreenTabs, screenTabsFromIframe).map((0, $50ech.toScreenTabsValidationError))
        });
    };

});
parcelRegister("iUvwD", function(module, exports) {

$parcel$export(module.exports, "UiModificationsScreenTabsValidationError", () => $2febbf39fb2cebbc$export$faf1f1824ee0a136);

var $2jqAp = parcelRequire("2jqAp");
class $2febbf39fb2cebbc$export$faf1f1824ee0a136 extends (0, $2jqAp.UiModificationsValidationError) {
    constructor(message, attributes, cause){
        super(message, attributes, 'screenTabs', cause);
    }
}

});

parcelRegister("50ech", function(module, exports) {

$parcel$export(module.exports, "toScreenTabsValidationError", () => $32af3bb8fe161d39$export$b2675440ade984fb);

const $32af3bb8fe161d39$export$b2675440ade984fb = (message)=>({
        message: message,
        type: (0, $ca611ff348f89182$export$fd26696d109785a0)
    });

});

parcelRegister("iiEdL", function(module, exports) {

$parcel$export(module.exports, "screenTabsPublicToInternalTransformer", () => $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc);
$parcel$export(module.exports, "screenTabsPublicToInternalValidator", () => $5d43d6affeb19d8a$export$e7a91e7e430e691a);
$parcel$export(module.exports, "getScreenTabsPublicToInternalValidationErrors", () => $5d43d6affeb19d8a$export$62d63af83dac7315);
const $5d43d6affeb19d8a$export$582443c7ead02173 = (value)=>typeof value === 'string' && value !== '';
const $5d43d6affeb19d8a$var$isValidScreenTabId = (internalScreenTabs, id)=>$5d43d6affeb19d8a$export$582443c7ead02173(id) && internalScreenTabs.find((tab)=>tab.id === id) !== undefined;
const $5d43d6affeb19d8a$var$isValidScreenTabIsActive = (isActive)=>typeof isActive === 'boolean' || typeof isActive === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabIsVisible = (isVisible)=>typeof isVisible === 'boolean' || typeof isVisible === 'undefined';
const $5d43d6affeb19d8a$var$isValidScreenTabData = (internalScreenTabs, { id: id, isVisible: isVisible, isActive: isActive })=>$5d43d6affeb19d8a$var$isValidScreenTabId(internalScreenTabs, id) && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && $5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive);
const $5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs = (acc, { isActive: isActive })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs = (acc, { isActive: isActive, isVisible: isVisible })=>{
    if ($5d43d6affeb19d8a$var$isValidScreenTabIsActive(isActive) && isActive && $5d43d6affeb19d8a$var$isValidScreenTabIsVisible(isVisible) && !isVisible) return acc + 1;
    return acc;
};
const $5d43d6affeb19d8a$export$9ca9b35e7b6a8bbc = (internalScreenTabs, screenTabsFromApp)=>{
    let numberOfActiveScreenTabs = 0;
    const internalActiveScreenTabIndex = internalScreenTabs.findIndex((tab)=>tab.isActive === true);
    const screenTabsInternalUpdated = internalScreenTabs.map((screenTabInternal)=>{
        const screenTabFromApp = screenTabsFromApp.find((tab)=>tab.id === screenTabInternal.id);
        if (!screenTabFromApp) return screenTabInternal;
        numberOfActiveScreenTabs += screenTabFromApp.isActive === true ? 1 : 0;
        return {
            id: screenTabInternal.id,
            isVisible: screenTabFromApp.isVisible ?? true,
            isActive: screenTabFromApp.isActive
        };
    });
    // if no active tab is specified. default to the first
    if (numberOfActiveScreenTabs === 0 && internalActiveScreenTabIndex === -1 && typeof screenTabsInternalUpdated[0]?.isActive !== 'undefined') screenTabsInternalUpdated[0].isActive = true;
    return screenTabsInternalUpdated;
};
const $5d43d6affeb19d8a$export$e7a91e7e430e691a = (internalScreenTabs, screenTabsFromApp)=>{
    if (!Array.isArray(screenTabsFromApp)) return false;
    const screenTabsFromAppFiltered = screenTabsFromApp.filter((data)=>$5d43d6affeb19d8a$var$isValidScreenTabData(internalScreenTabs, data));
    const numberOfActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0);
    const numberOfHiddenActiveScreenTabs = screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0);
    return numberOfActiveScreenTabs <= 1 && screenTabsFromApp.length === screenTabsFromAppFiltered.length && numberOfHiddenActiveScreenTabs === 0;
};
const $5d43d6affeb19d8a$export$62d63af83dac7315 = (internalScreenTabs, screenTabsFromApp)=>{
    if (!internalScreenTabs) return [
        'There are no screen tabs in the current view.'
    ];
    if (!Array.isArray(screenTabsFromApp)) return [
        'Your app must return screen tabs as an array.'
    ];
    const errors = [];
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfActiveScreenTabs, 0) > 1) errors.push('Only one screen tab can be in focus.');
    if (screenTabsFromApp.reduce($5d43d6affeb19d8a$var$countNumberOfHiddenActiveScreenTabs, 0) > 0) errors.push("You can't hide a screen tab that's currently in focus.");
    return errors;
};

});





parcelRegister("eNNkf", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesValue", () => $5092328ed6a09c60$export$8bd3660b16415efd);
$parcel$export(module.exports, "useUserPreferencesActions", () => $5092328ed6a09c60$export$eefe4b2985e8203e);

var $5uXOq = parcelRequire("5uXOq");

var $hLEug = parcelRequire("hLEug");

var $12pgs = parcelRequire("12pgs");
const $5092328ed6a09c60$export$8bd3660b16415efd = (userPreferenceKey)=>{
    const baseUrl = '';
    const [value, { setUserPreferenceValue: setUserPreferenceValue, deleteUserPreferenceValue: deleteUserPreferenceValue }] = (0, $hLEug.useUserPreferencesStoreValue)(userPreferenceKey);
    /**
	 * persist: boolean - if true, save the value to the server ,else just update the local state and return a promise with the new value
	 */ const setValue = (0, $5uXOq.useCallback)((newValue, persist = true)=>{
        setUserPreferenceValue(userPreferenceKey, newValue);
        if (!persist) return Promise.resolve(newValue);
        return (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, newValue);
    }, [
        baseUrl,
        setUserPreferenceValue,
        userPreferenceKey
    ]);
    const deleteValue = (0, $5uXOq.useCallback)(()=>{
        deleteUserPreferenceValue(userPreferenceKey);
        return (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
    }, [
        baseUrl,
        deleteUserPreferenceValue,
        userPreferenceKey
    ]);
    const setUserPreferences = (0, $5uXOq.useMemo)(()=>({
            setValue: setValue,
            deleteValue: deleteValue
        }), [
        setValue,
        deleteValue
    ]);
    return [
        value,
        setUserPreferences
    ];
};
const $5092328ed6a09c60$export$eefe4b2985e8203e = ()=>{
    const baseUrl = '';
    const [, actions] = (0, $hLEug.useUserPreferencesStoreActions)();
    const userPreferenceActions = (0, $5uXOq.useMemo)(()=>{
        const setUserPreferenceValue = (userPreferenceKey, value)=>{
            actions.setUserPreferenceValue(userPreferenceKey, value);
            (0, $12pgs.saveUserPreferenceValue)(baseUrl, userPreferenceKey, value);
        };
        const deleteUserPreferenceValue = (userPreferenceKey)=>{
            actions.deleteUserPreferenceValue(userPreferenceKey);
            (0, $12pgs.removeUserPreferenceValue)(baseUrl, userPreferenceKey);
        };
        const setUserPreferences = (userPreferences)=>{
            userPreferences && Object.keys(userPreferences).length !== 0 && actions.setUserPreferences(userPreferences);
        };
        return {
            setUserPreferenceValue: setUserPreferenceValue,
            setUserPreferences: setUserPreferences,
            deleteUserPreferenceValue: deleteUserPreferenceValue,
            getUserPreferenceValue: actions.getUserPreferenceValue
        };
    }, [
        actions,
        baseUrl
    ]);
    return [
        null,
        userPreferenceActions
    ];
};

});
parcelRegister("hLEug", function(module, exports) {

$parcel$export(module.exports, "useUserPreferencesStoreValue", () => $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8);
$parcel$export(module.exports, "useUserPreferencesStoreActions", () => $f08ba98a3f2bdde2$export$4d156074562bac9a);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $djdK3 = parcelRequire("djdK3");
const $f08ba98a3f2bdde2$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'user-preferences',
    initialState: {
        preferences: {}
    },
    actions: $djdK3.actions
});
const $f08ba98a3f2bdde2$var$getUserPreference = (state, userPreferenceKey)=>state.preferences[userPreferenceKey];
const $f08ba98a3f2bdde2$export$46e7eeb2fc34fab8 = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: $f08ba98a3f2bdde2$var$getUserPreference
});
const $f08ba98a3f2bdde2$export$4d156074562bac9a = (0, $3sQ5x.createHook)($f08ba98a3f2bdde2$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("djdK3", function(module, exports) {

$parcel$export(module.exports, "actions", () => $5c68f1b920b8984c$export$e324594224ef24da);
const $5c68f1b920b8984c$var$setUserPreferenceValue = (key, value)=>({ setState: setState, getState: getState })=>{
        setState({
            preferences: {
                ...getState().preferences,
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                [key]: value
            }
        });
    };
const $5c68f1b920b8984c$var$deleteUserPreferenceValue = (key)=>({ setState: setState, getState: getState })=>{
        const { [key]: _, ...preferences } = getState().preferences;
        setState({
            preferences: preferences
        });
    };
const $5c68f1b920b8984c$var$setUserPreferences = (state)=>({ setState: setState })=>{
        setState({
            preferences: state
        });
    };
const $5c68f1b920b8984c$export$df0a4f67b9888111 = (key)=>({ getState: getState })=>{
        const { preferences: preferences } = getState();
        return preferences[key];
    };
const $5c68f1b920b8984c$export$e324594224ef24da = {
    setUserPreferenceValue: $5c68f1b920b8984c$var$setUserPreferenceValue,
    deleteUserPreferenceValue: $5c68f1b920b8984c$var$deleteUserPreferenceValue,
    setUserPreferences: $5c68f1b920b8984c$var$setUserPreferences,
    getUserPreferenceValue: $5c68f1b920b8984c$export$df0a4f67b9888111
};

});


parcelRegister("12pgs", function(module, exports) {

$parcel$export(module.exports, "saveUserPreferenceValue", () => $0dfd1081a7a72732$export$bebe1b9e9f4cbf16);
$parcel$export(module.exports, "removeUserPreferenceValue", () => $0dfd1081a7a72732$export$a60a810760d07867);

var $eusud = parcelRequire("eusud");
const $0dfd1081a7a72732$export$bebe1b9e9f4cbf16 = async (baseUrl, userPreferenceKey, value)=>(0, $eusud.performPutRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`, {
        body: value
    });
const $0dfd1081a7a72732$export$a60a810760d07867 = async (baseUrl, userPreferenceKey)=>(0, $eusud.performDeleteRequest)(`${baseUrl}/rest/api/2/mypreferences?key=${userPreferenceKey}`);

});


const $31848aa9a0db89de$export$a763454c55d057f2 = 'jira.user.issue.clickthrough-banner.lastinteracted';
const $31848aa9a0db89de$export$8c6b5c30f78ab338 = 'jira.user.issue.changeboarding.lastinteracted';
const $31848aa9a0db89de$export$5530d4ea250d4125 = 'jira.user.issue.attachment.view';
const $31848aa9a0db89de$export$a274dca8eb47fc4a = 'jira.user.issue.sidebar.resize-ratio';
const $31848aa9a0db89de$export$4c9f7f9f8a4000e1 = 'jira.user.issue.filter.hide-done-subtasks';
const $31848aa9a0db89de$export$2cf981c493d79a21 = 'jira.user.issue.details.activity-layout-setting';
const $31848aa9a0db89de$export$25f5ee1223725a65 = 'jira.user.issue.comment-summaries.enabled';
const $31848aa9a0db89de$export$4936b1621439c095 = 'jira.user.issue.details.details-panel-fields-order';
const $31848aa9a0db89de$export$32a0b5eafccd5141 = 'jira.user.issue.comment-slack-flag.dismissed';

parcelRegister("kI4MM", function(module, exports) {

$parcel$export(module.exports, "useIssueLayoutContainersStore", () => $189406269e224200$export$5c4a1f63cea7b5b3);
$parcel$export(module.exports, "useIssueLayoutGlanceStore", () => $189406269e224200$export$769bbe2bda9a43ce);
$parcel$export(module.exports, "useIssueLayoutContextPanelStore", () => $189406269e224200$export$3aa9017e11451546);
$parcel$export(module.exports, "useIssueLayoutActionsStore", () => $189406269e224200$export$5513f3c310d101f5);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $kjjoM = parcelRequire("kjjoM");
const $189406269e224200$var$getIssueViewLayoutContainers = (state, issueKey)=>state[String(issueKey)]?.containers || [];
const $189406269e224200$var$getIssueViewLayoutGlance = (state, issueKey)=>state[String(issueKey)]?.glance;
const $189406269e224200$var$getIssueViewLayoutContextPanel = (state, issueKey)=>state[String(issueKey)]?.contextPanel;
const $189406269e224200$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    name: 'issue-view-layout-service',
    initialState: {},
    actions: $kjjoM
});
const $189406269e224200$export$5c4a1f63cea7b5b3 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContainers
});
const $189406269e224200$export$769bbe2bda9a43ce = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutGlance
});
const $189406269e224200$export$3aa9017e11451546 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: $189406269e224200$var$getIssueViewLayoutContextPanel
});
const $189406269e224200$export$5513f3c310d101f5 = (0, $3sQ5x.createHook)($189406269e224200$export$6f57813fe9f31bf9, {
    selector: null
});

});
parcelRegister("kjjoM", function(module, exports) {

$parcel$export(module.exports, "setIssueViewContainersLayout", () => $09c52f32f4231bd8$export$e956c64a7167b73a);
$parcel$export(module.exports, "setIssueViewLayoutGlance", () => $09c52f32f4231bd8$export$6a9b24c2efe66bb7);
$parcel$export(module.exports, "setIssueViewLayoutContextPanel", () => $09c52f32f4231bd8$export$9a04e4b958ebc410);
const $09c52f32f4231bd8$export$e956c64a7167b73a = (issueKey, containersByType)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                containers: containersByType?.containers || []
            }
        });
    };
const $09c52f32f4231bd8$export$6a9b24c2efe66bb7 = (issueKey, glance)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                glance: glance
            }
        });
    };
const $09c52f32f4231bd8$export$9a04e4b958ebc410 = (issueKey, contextPanel)=>({ getState: getState, setState: setState })=>{
        setState({
            [String(issueKey)]: {
                ...getState()[String(issueKey)],
                contextPanel: contextPanel
            }
        });
    };

});


parcelRegister("cNJ33", function(module, exports) {

$parcel$export(module.exports, "getLayoutItemId", () => $0c6b6ff40aad7732$export$fec1c0749fa149f4);
$parcel$export(module.exports, "filterOutItemsWithProvidedIds", () => $0c6b6ff40aad7732$export$355607dae809ec65);

var $41gqO = parcelRequire("41gqO");
const $0c6b6ff40aad7732$export$fec1c0749fa149f4 = (layoutItem)=>{
    switch(layoutItem.type){
        case (0, $41gqO.layoutContainerItemTypes).field:
            return layoutItem.fieldItemId;
        case (0, $41gqO.layoutContainerItemTypes).panel:
            return layoutItem.panelItemId;
        case (0, $41gqO.layoutContainerItemTypes).tab:
            return layoutItem.tabContainerId;
        default:
            return layoutItem.id;
    }
};
const $0c6b6ff40aad7732$export$355607dae809ec65 = (items, idsToBeFilteredOut)=>{
    const filteredOutIdsSet = new Set(idsToBeFilteredOut);
    return items// Filter out items with the provided Ids
    .filter((item)=>!filteredOutIdsSet.has($0c6b6ff40aad7732$export$fec1c0749fa149f4(item)))// Filter out items with the provided Ids nested in the container tab items
    .map((item)=>{
        if (item.type === (0, $41gqO.layoutContainerItemTypes).tab && item.items?.nodes) return {
            ...item,
            items: {
                // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
                nodes: $0c6b6ff40aad7732$export$355607dae809ec65(item.items.nodes, idsToBeFilteredOut)
            }
        };
        return item;
    });
};

});
parcelRegister("41gqO", function(module, exports) {

$parcel$export(module.exports, "ECOSYSTEM_GLANCE_TYPE", () => $b08b2795aecf222d$export$99ad62164189f781);
$parcel$export(module.exports, "FORGE_GLANCE_TYPE", () => $b08b2795aecf222d$export$7719ef6e9283671);
$parcel$export(module.exports, "ECOSYSTEM_CONTEXT_TYPE", () => $b08b2795aecf222d$export$bfebea5ce2e1887a);
$parcel$export(module.exports, "FORGE_CONTEXT_TYPE", () => $b08b2795aecf222d$export$be8e68fb1aed253e);
$parcel$export(module.exports, "CONTEXT_AREA", () => $b08b2795aecf222d$export$7bf561e6ab380ea1);
$parcel$export(module.exports, "CONTENT_AREA", () => $b08b2795aecf222d$export$f42c11634d75863e);
$parcel$export(module.exports, "CONTENT_REQUEST_AREA", () => $b08b2795aecf222d$export$b38842736b6dbc1d);
$parcel$export(module.exports, "REACT_KEY_SUMMARY", () => $b08b2795aecf222d$export$605c43f1b33ab69);
$parcel$export(module.exports, "CUSTOM_ITEM_TYPE", () => $b08b2795aecf222d$export$e655b77b9efe622f);
$parcel$export(module.exports, "layoutContainerItemTypes", () => $b08b2795aecf222d$export$5507f31126c8b283);
$parcel$export(module.exports, "isLayoutContainerTabItem", () => $b08b2795aecf222d$export$ad3536b13febb432);
const $b08b2795aecf222d$export$99ad62164189f781 = 'ecosystemGlance';
const $b08b2795aecf222d$export$7719ef6e9283671 = 'forgeGlance';
const $b08b2795aecf222d$export$bfebea5ce2e1887a = 'ecosystemContext';
const $b08b2795aecf222d$export$be8e68fb1aed253e = 'forgeContext';
const $b08b2795aecf222d$export$7bf561e6ab380ea1 = 'context';
const $b08b2795aecf222d$export$f42c11634d75863e = 'content';
const $b08b2795aecf222d$export$b38842736b6dbc1d = 'content-request';
const $b08b2795aecf222d$export$bc9fa2d93b5fabae = 'FIELD';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$STATUS_TYPE = 'STATUS';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$TAB_TYPE = 'TAB';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$PANEL_TYPE = 'PANEL';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_TYPE = 'ECOSYSTEM';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_TYPE = 'FORGE';
const $b08b2795aecf222d$export$605c43f1b33ab69 = 'SUMMARY';
const $b08b2795aecf222d$export$e655b77b9efe622f = 'CustomItem';
const $b08b2795aecf222d$export$5cf403de05e9bea = 'FieldSectionItem';
const $b08b2795aecf222d$export$30f7f9a86f182492 = 'TabLayout';
const $b08b2795aecf222d$export$196e597ad9a97f7a = 'PanelSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$ECOSYSTEM_SECTION_ITEM = 'EcosystemSectionItem';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $b08b2795aecf222d$var$FORGE_SECTION_ITEM = 'ForgeSectionItem';
const $b08b2795aecf222d$export$5507f31126c8b283 = {
    field: 'JiraIssueItemFieldItem',
    panel: 'JiraIssueItemPanelItem',
    tab: 'JiraIssueItemTabContainer'
};
const $b08b2795aecf222d$export$ad3536b13febb432 = (node)=>node.type === $b08b2795aecf222d$export$5507f31126c8b283.tab;

});



parcelRegister("hhMVP", function(module, exports) {

$parcel$export(module.exports, "getCachedIsCompactValue", () => $cd61c7d28b4f2500$export$c47621d55d10906c);
$parcel$export(module.exports, "setCachedIsCompactValue", () => $cd61c7d28b4f2500$export$568b2dd75c2027b4);
$parcel$export(module.exports, "invalidateCacheIfRouteChanged", () => $cd61c7d28b4f2500$export$a81477a3594bcaab);
// Cleared on window refresh, unique to each window
const $cd61c7d28b4f2500$var$cachedIsCompactValues = {};
let $cd61c7d28b4f2500$var$previousRouteKey;
function $cd61c7d28b4f2500$export$c47621d55d10906c(key) {
    return $cd61c7d28b4f2500$var$cachedIsCompactValues[key];
}
function $cd61c7d28b4f2500$export$568b2dd75c2027b4(isCompactValue, key) {
    $cd61c7d28b4f2500$var$cachedIsCompactValues[key] = isCompactValue;
}
function $cd61c7d28b4f2500$export$a81477a3594bcaab(currentRouteKey) {
    // If we navigate away from the route we can't assume that the cached value will stay valid when we come back
    if (currentRouteKey !== $cd61c7d28b4f2500$var$previousRouteKey) {
        $cd61c7d28b4f2500$var$previousRouteKey = currentRouteKey;
        delete $cd61c7d28b4f2500$var$cachedIsCompactValues[$cd61c7d28b4f2500$var$previousRouteKey];
    }
}

});


parcelRegister("3441h", function(module, exports) {
module.exports = new URL("issue-app-skeleton.tpl.e425fdce.svg", import.meta.url).toString();

});



parcelRegister("bWjJb", function(module, exports) {

$parcel$export(module.exports, "setIssueViewOpenFeedbackMark", () => $29f6b5adabb5126e$export$2c1211bae6c14a9);
$parcel$export(module.exports, "setIssueViewOpenFinishMark", () => $29f6b5adabb5126e$export$74c6496311688a4d);

var $k12ix = parcelRequire("k12ix");

var $hz3OZ = parcelRequire("hz3OZ");
const $29f6b5adabb5126e$export$2c1211bae6c14a9 = ()=>{
    (0, $hz3OZ.issueViewOpenInteraction).mark('feedback');
};
const $29f6b5adabb5126e$export$74c6496311688a4d = (isSideBar, boardCardCount, isCMPBoard)=>(0, $hz3OZ.issueViewOpenInteraction).stop({
        customData: {
            ...(0, $k12ix.getNormalisedPerformanceFFs)(),
            ...boardCardCount,
            isSideBar: isSideBar,
            isClassic: isCMPBoard
        }
    });

});

parcelRegister("dWjj9", function(module, exports) {

$parcel$export(module.exports, "PreIssueViewMountFeedbackMark", () => $60fb965de9301d5f$export$e17cfe6a40740e70);

var $5uXOq = parcelRequire("5uXOq");

var $hz3OZ = parcelRequire("hz3OZ");
const $60fb965de9301d5f$export$e17cfe6a40740e70 = ({ issueKey: issueKey })=>{
    (0, $5uXOq.useEffect)(()=>{
        (0, $hz3OZ.issueViewOpenInteraction).mark('feedbackPreMountEnd');
    }, [
        issueKey
    ]);
    return null;
};

});

parcelRegister("a03V9", function(module, exports) {

let $747cf2114c5de06c$var$load = (parcelRequire("28QjX"))(4);






module.exports = Promise.all([
    (parcelRequire("avM1e"))('jira_amplitude_sr', function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("8EtZR"),
            $747cf2114c5de06c$var$load("kVX56")
        ]);
    }, function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("6jOz3")
        ]);
    }),
    (parcelRequire("avM1e"))('details_loader_to_entrypoint_iv_llc_dev_panel', function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("84z1X")
        ]);
    }, function() {
        return Promise.all([]);
    }),
    (parcelRequire("avM1e"))('empanada_profilecard_trial_sync_trigger_import', function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("czifk"),
            $747cf2114c5de06c$var$load("l253H"),
            $747cf2114c5de06c$var$load("76n7a"),
            $747cf2114c5de06c$var$load("kvRbA"),
            $747cf2114c5de06c$var$load("ffQaD")
        ]);
    }, function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("kcs34")
        ]);
    }),
    (parcelRequire("avM1e"))('empanada_team_profilecard_trial_sync_trigger', function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("cTJTG"),
            $747cf2114c5de06c$var$load("l253H"),
            $747cf2114c5de06c$var$load("76n7a")
        ]);
    }, function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("4Qxp7")
        ]);
    }),
    (parcelRequire("avM1e"))('improve_rendering_child_issues_summary_bar', function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("juSGb")
        ]);
    }, function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("5FVQh")
        ]);
    }),
    (parcelRequire("avM1e"))('link_paste_recommendations', function() {
        return Promise.all([]);
    }, function() {
        return Promise.all([
            $747cf2114c5de06c$var$load("7ClEP")
        ]);
    }),
    $747cf2114c5de06c$var$load("3yAl4"),
    $747cf2114c5de06c$var$load("fliVL"),
    $747cf2114c5de06c$var$load("7mIf9"),
    $747cf2114c5de06c$var$load("jXweD"),
    $747cf2114c5de06c$var$load("jbxE1"),
    $747cf2114c5de06c$var$load("7imUH"),
    $747cf2114c5de06c$var$load("kVX56"),
    $747cf2114c5de06c$var$load("kNFvF"),
    $747cf2114c5de06c$var$load("ffQaD"),
    $747cf2114c5de06c$var$load("kvRbA"),
    $747cf2114c5de06c$var$load("76n7a"),
    $747cf2114c5de06c$var$load("l253H"),
    $747cf2114c5de06c$var$load("gaip1")
]).then(()=>parcelRequire('6qbjz'));

});
parcelRegister("avM1e", function(module, exports) {
"use strict";
module.exports = function(cond, ifTrue, ifFalse) {
    return globalThis.__MCOND && globalThis.__MCOND(cond) ? ifTrue() : ifFalse();
};

});




parcelRegister("hUbDe", function(module, exports) {

$parcel$export(module.exports, "default", () => $e945a1a602f86336$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2gCtH = parcelRequire("2gCtH");

var $9PAwV = parcelRequire("9PAwV");

var $g5X3G = parcelRequire("g5X3G");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $a2e2Q = parcelRequire("a2e2Q");

var $iUagi = parcelRequire("iUagi");

var $2ON1s = parcelRequire("2ON1s");

var $67sX6 = parcelRequire("67sX6");

var $6g14V = parcelRequire("6g14V");

var $63LqY = parcelRequire("63LqY");

var $7RXC2 = parcelRequire("7RXC2");

var $8nkAM = parcelRequire("8nkAM");

var $ca5yC = parcelRequire("ca5yC");
const $e945a1a602f86336$export$d51fb174c0dd91e9 = ({ parentWidth: parentWidth, cardKey: cardKey, rapidViewId: rapidViewId, isDetailViewSidebar: isDetailViewSidebar, isInsightsPanelOpen: isInsightsPanelOpen, projectId: projectId, onClose: onClose, onChange: onChange, onDelete: onDelete, onCloseInsightsClick: onCloseInsightsClick, onResetExternalAction: onResetExternalAction, timestamp: timestamp, externalAction: externalAction, boardSessionId: boardSessionId, activeSprints: activeSprints, selectedSprints: selectedSprints, isSprintsEnabled: isSprintsEnabled, estimationStatistic: estimationStatistic, IssueWrapper: IssueWrapper })=>{
    const [issueKey, setIssueKey] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const issueKeyOrCardKey = issueKey || cardKey;
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: toIssueKey })=>setIssueKey(toIssueKey), [
        setIssueKey
    ]);
    const [, { setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const isViewSettingPanelOpen = (0, $67sX6.useBoardSelector)((0, $6g14V.getViewSettingsPanel));
    const onCloseViewSettingsPanel = (0, $67sX6.useBoardActionCreator)(()=>(0, $2ON1s.closeViewSettingsPanel)());
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    if (!cardKey && !isInsightsPanelOpen && (!(0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() || !isViewSettingPanelOpen)) return null;
    const hasSprints = activeSprints != null && activeSprints.length > 0;
    return (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingPanelOpen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8nkAM.ViewSettingsPanel), {
        isPanelOpen: isViewSettingPanelOpen,
        onPanelClose: onCloseViewSettingsPanel
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9PAwV.JiraDetailPanel), null, (setDetailPanelWidth)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ca5yC.default), {
            parentWidth: parentWidth,
            useFixedMinWidth: false,
            onResize: setDetailPanelWidth,
            isThemed: isSoftwareFullTheming
        }, cardKey && isDetailViewSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e945a1a602f86336$var$DetailsWrapper, {
            isSoftwareThemingEnabled: isSoftwareFullTheming,
            "data-testid": "software-board.detail-view.issue-wrapper",
            hide: isInsightsPanelOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IssueWrapper, {
            key: issueKeyOrCardKey + timestamp,
            issueKey: (0, $g5X3G.toIssueKey)(issueKeyOrCardKey),
            onClose: onClose,
            onChange: onChange,
            onIssueDeleteSuccess: onDelete,
            rapidViewId: Number(rapidViewId),
            onSwitchToModal: setDetailViewAsModal,
            onIssueKeyChange: onIssueKeyChange,
            externalAction: externalAction,
            boardSessionId: boardSessionId,
            estimationStatistic: estimationStatistic,
            onResetExternalAction: onResetExternalAction
        })), (!isSprintsEnabled || hasSprints) && isInsightsPanelOpen ? // `isSprintsEnabled` is to check whether it's kanban
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e945a1a602f86336$var$DetailsPanelContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7RXC2.AsyncBoardInsightsPanel), {
            isSimplifiedProject: !isCMPBoard,
            isOpen: isInsightsPanelOpen,
            onClose: onCloseInsightsClick,
            rapidViewId: Number(rapidViewId),
            activeSprint: activeSprints?.[0],
            projectId: projectId,
            sprints: activeSprints,
            selectedSprints: selectedSprints,
            isSprintsEnabled: isSprintsEnabled
        }))) : null));
};
var $e945a1a602f86336$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($e945a1a602f86336$export$d51fb174c0dd91e9);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $e945a1a602f86336$var$DetailsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { hide: hide, isSoftwareThemingEnabled: isSoftwareThemingEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _4t3i1osq _1reo15vq",
            __cmplp.hide && "_1e0cglyw",
            __cmplp.isSoftwareThemingEnabled && "_bfhkvuon _qrwqpd34 _13lipd34 _16qs1cd0 _2hwx1ejb _ca0qu2gc _vchhusvi",
            __cmplp.className
        ])
    });
});
const $e945a1a602f86336$var$DetailsPanelContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _kqswh2mm _4t3i1osq _1reo15vq _18m915zi",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9PAwV", function(module, exports) {

$parcel$export(module.exports, "JiraDetailPanel", () => $90f8c6fec93ae563$export$93acb63f4e179357);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $34ck9 = parcelRequire("34ck9");

var $b71gk = parcelRequire("b71gk");

var $5e5zm = parcelRequire("5e5zm");
const $90f8c6fec93ae563$var$DetailPanel = ({ children: children, panelWidth: panelWidth })=>{
    const { setWidth: setWidth } = (0, $5e5zm.useDetailPanelActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (panelWidth !== undefined) setWidth(panelWidth);
        return ()=>setWidth(0);
    }, [
        panelWidth,
        setWidth
    ]);
    const throttleSetWidth = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50, {
            leading: true,
            trailing: true
        }), [
        setWidth
    ]);
    return typeof children === 'function' ? children(throttleSetWidth) : children;
};
const $90f8c6fec93ae563$export$93acb63f4e179357 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-detail-panel",
        packageName: "jira-bottom-right-corner-controller",
        render: ()=>typeof props.children === 'function' ? props.children((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))) : props.children
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($90f8c6fec93ae563$var$DetailPanel, props));

});

parcelRegister("7RXC2", function(module, exports) {

$parcel$export(module.exports, "AsyncBoardInsightsPanel", () => $f36a347b006f1cec$export$1ece9ee19d846df5);

var $5uXOq = parcelRequire("5uXOq");

var $eZJjh = parcelRequire("eZJjh");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $gwIPs = parcelRequire("gwIPs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $lmBAt = parcelRequire("lmBAt");

const $f36a347b006f1cec$var$LazyBoardInsightsPanel = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("jdnuo")), {
    moduleId: "./src/packages/software/board/src/view/board-panels/insights-panel/index.tsx"
});
const $f36a347b006f1cec$export$1ece9ee19d846df5 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "board-insights-panel",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: (0, $lmBAt.getIsSoftwareThemingEnabled)() ? $f36a347b006f1cec$var$containerStyles : $f36a347b006f1cec$var$containerStylesOld
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "large"
        }))
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f36a347b006f1cec$var$LazyBoardInsightsPanel, props));
const $f36a347b006f1cec$var$maxWidth = (0, $gwIPs.gridSize) * 47;
const $f36a347b006f1cec$var$containerStylesOld = (0, $8CUq3.xcss)({
    paddingBottom: 'space.025',
    marginTop: 'space.0',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$f36a347b006f1cec$var$maxWidth}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$f36a347b006f1cec$var$maxWidth}px`,
    marginLeft: 'space.150',
    marginRight: 'space.500',
    marginBottom: 'space.200'
});
const $f36a347b006f1cec$var$containerStyles = (0, $8CUq3.xcss)({
    paddingBottom: 'space.025',
    marginTop: 'space.0',
    boxSizing: 'border-box',
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    maxWidth: `${$f36a347b006f1cec$var$maxWidth}px`,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: `${$f36a347b006f1cec$var$maxWidth}px`,
    marginRight: 'space.300',
    marginBottom: 'space.300'
});

});
parcelRegister("jdnuo", function(module, exports) {

let $dfd173b4303b29b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $dfd173b4303b29b0$var$load("ffQaD"),
    $dfd173b4303b29b0$var$load("kvRbA"),
    $dfd173b4303b29b0$var$load("2jTIy")
]).then(()=>parcelRequire('luBlw'));

});


parcelRegister("8nkAM", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanel", () => $129c8c1752459575$export$3a81a9760a380951);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");


var $d6YZC = parcelRequire("d6YZC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ipmBb = parcelRequire("ipmBb");

var $a4XJc = parcelRequire("a4XJc");

var $jB6yt = parcelRequire("jB6yt");

var $2YP9W = parcelRequire("2YP9W");

var $iuuJH = parcelRequire("iuuJH");

var $3n582 = parcelRequire("3n582");

var $4RVsR = parcelRequire("4RVsR");

var $k50Aq = parcelRequire("k50Aq");

var $67sX6 = parcelRequire("67sX6");

var $4vVV6 = parcelRequire("4vVV6");

var $vAfHD = parcelRequire("vAfHD");

var $gR0bs = parcelRequire("gR0bs");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $129c8c1752459575$export$3a81a9760a380951 = ({ isPanelOpen: isPanelOpen, onPanelClose: onPanelClose })=>{
    const rapidViewId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const epicCustomName = (0, $67sX6.useBoardSelector)((0, $67Z81.getHierarchyNomenclature))?.firstLevelName;
    const hasSwimlanes = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode)) !== (0, $iuuJH.NO_SWIMLANE).id;
    const swimlaneIds = (0, $67sX6.useBoardSelector)((0, $5mTgl.platformSwimlaneIdsSelector));
    const onSwimlaneExpandAll = (0, $67sX6.useBoardActionCreator)(()=>(0, $k50Aq.swimlanesExpand)());
    const onSwimlaneCollapseAll = (0, $67sX6.useBoardActionCreator)(()=>(0, $k50Aq.swimlanesCollapse)(swimlaneIds));
    const isCompanyManaged = (0, $63LqY.useIsCMPBoard)();
    const isQuickFilterAvailable = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCustomFilters)).length > 0;
    const showFilterBarToggle = isCompanyManaged && isQuickFilterAvailable;
    const isDaysInColumnEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDaysInColumnEnabled));
    const isEstimateEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsEstimateEnabled));
    const isDueDateEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDueDateEnabled));
    const isLabelsEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIssueLabelsEnabled));
    const isPriorityEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsPriorityEnabled));
    const isDevelopmentEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDevelopmentEnabled));
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const cardExtraFields = (0, $67sX6.useBoardSelector)((0, $67Z81.getCardExtraFields));
    const firstSelectableIssueId = (0, $67sX6.useBoardSelector)((0, $gR0bs.getFirstSelectableIssueAscending));
    const { canUserLinkIssue: canUserLinkIssue, issueLinkTypes: issueLinkTypes } = (0, $67sX6.useBoardSelector)((0, $4vVV6.getIssueLinksPermissions));
    const isIssueLinkingEnabledOnInstance = canUserLinkIssue && issueLinkTypes?.length > 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const boardIssueIds = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardOrderedIssueIdsSelector));
    const onLinkedIssuesStatsToggledOn = (0, $67sX6.useBoardActionCreator)(()=>(0, $4RVsR.fetchIssueLinksStats)(boardIssueIds, {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const onShowCardCoversToggledOn = (0, $67sX6.useBoardActionCreator)(()=>(0, $3n582.fetchCardCovers)(boardIssueIds, {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const { data: isWorkSuggestionsEnabledData, update: updateWorkSuggestionsResource, loading: loadingWorkSuggestionsEnabled } = (0, $2YP9W.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const [, { doFetch: updateWorkSuggestionsEnabled }] = (0, $d6YZC.useNextBestTaskUserPreference)();
    const onToggleWorkSuggestions = (analyticsEvent)=>{
        const newOptInValue = !isWorkSuggestionsEnabledData?.hasUserOptedIn;
        updateWorkSuggestionsResource(()=>({
                hasUserOptedIn: newOptInValue
            }));
        updateWorkSuggestionsEnabled({
            hasUserOptedIn: newOptInValue
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $ba3e099a37b09fda$export$9957974f8b4d8f74), {
            hasUserOptedIn: newOptInValue
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $129c8c1752459575$var$ViewSettingWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        isViewPanelOpen: isPanelOpen,
        onViewPanelClose: onPanelClose,
        boardId: Number(rapidViewId),
        isClassic: isCompanyManaged,
        view: (0, $a4XJc.View).BOARD,
        viewAs: (0, $a4XJc.ViewAs).PANEL,
        epicCustomName: epicCustomName,
        // showdetails is true for JSW board
        showCardDetails: true,
        isSwimlanesEnabled: hasSwimlanes,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: onSwimlaneCollapseAll,
        showFilterBarToggle: showFilterBarToggle,
        isDaysInColumnEnabled: isDaysInColumnEnabled,
        isEstimateEnabled: isEstimateEnabled,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        isDueDateEnabled: isDueDateEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isDevelopmentEnabled: isDevelopmentEnabled,
        isLabelsEnabled: !isCompanyManaged && isLabelsEnabled,
        isWorkSuggestionsEnabled: !!isWorkSuggestionsEnabledData?.hasUserOptedIn,
        showWorkSuggestions: isWorkSuggestionsEnabledData != null && !loadingWorkSuggestionsEnabled && isJSWBoard,
        showLinkedIssueStatsToggle: isIssueLinkingEnabledOnInstance && Boolean(firstSelectableIssueId),
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
        cardExtraFields: cardExtraFields,
        onShowCardCoversToggledOn: onShowCardCoversToggledOn
    }));
};
const $129c8c1752459575$var$ViewSettingWrapperStyles = (0, $8CUq3.xcss)({
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingRight: 'space.500',
    paddingBottom: 'space.300',
    minWidth: '330px',
    [(0, $h9kUS.media).above.lg]: {
        minWidth: '360px'
    }
});

});
const $ba3e099a37b09fda$export$bca1afd1dbd279c8 = '/rest/api/3/mypreferences?key=next-best-task-feature';
const $ba3e099a37b09fda$export$b8b9d90f9e5bd72b = 'jiraPersonalSettingsNextBestTask';
const $ba3e099a37b09fda$export$14a3a0c00f727781 = 'updateNextBestTaskOptInPreference';
const $ba3e099a37b09fda$export$9957974f8b4d8f74 = 'jira.insights.nextBestTask.optInToggle';

parcelRegister("d6YZC", function(module, exports) {

$parcel$export(module.exports, "useNextBestTaskUserPreference", () => $3eea00ee2b5a44ce$export$e898b74b14e8af9);

var $iuEfD = parcelRequire("iuEfD");

var $5IV0G = parcelRequire("5IV0G");

const $3eea00ee2b5a44ce$var$updateNbtOptInPreference = async (fetchOptions, payload)=>{
    const response = await (0, $5IV0G.performPutRequest)((0, $ba3e099a37b09fda$export$bca1afd1dbd279c8), {
        ...fetchOptions,
        body: JSON.stringify(payload)
    });
    return response;
};
const $3eea00ee2b5a44ce$export$e898b74b14e8af9 = ()=>(0, $iuEfD.useFetch)({
        onFetch: (fetchOptions, payload)=>$3eea00ee2b5a44ce$var$updateNbtOptInPreference(fetchOptions, payload),
        analyticsTracking: {
            actionSubject: `useFetch.${(0, $ba3e099a37b09fda$export$14a3a0c00f727781)}`,
            packageName: (0, $ba3e099a37b09fda$export$b8b9d90f9e5bd72b),
            action: 'dataUpdate'
        },
        loggingKey: `${(0, $ba3e099a37b09fda$export$b8b9d90f9e5bd72b)}.${(0, $ba3e099a37b09fda$export$14a3a0c00f727781)}`,
        isAutoFetchable: false
    }, []);

});
parcelRegister("iuEfD", function(module, exports) {

$parcel$export(module.exports, "useFetch", () => $082fa94a7a9fe60c$export$d852f5f778460fa4);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $aAhmV = parcelRequire("aAhmV");

var $d6Xq4 = parcelRequire("d6Xq4");

var $bYINM = parcelRequire("bYINM");

var $lUlda = parcelRequire("lUlda");

var $dg0bO = parcelRequire("dg0bO");

var $eW4Xh = parcelRequire("eW4Xh");
const $082fa94a7a9fe60c$export$d852f5f778460fa4 = ({ onFetch: onFetch, isAutoFetchable: isAutoFetchable = true, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, initialData: initialData, isAbortable: isAbortable = true }, fetchDependencies)=>{
    const [state, dispatch] = (0, $5uXOq.useReducer)((0, $bYINM.reducer), {
        ...(0, $dg0bO.initialState),
        data: initialData
    });
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { initialized: initialized, fetched: fetched, loading: loading } = state;
    const abortControllerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(fetchDependencies);
    const isMounted = (0, $5uXOq.useRef)(true);
    const getAbortController = (0, $5uXOq.useCallback)(()=>{
        const controller = abortControllerRef.current;
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        if (!abortControllerRef.current || controller?.signal.aborted) abortControllerRef.current = new AbortController();
        return abortControllerRef.current;
    }, []);
    const callFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        // @ts-expect-error - TS2339 - Property 'signal' does not exist on type 'unknown'.
        const { signal: signal } = getAbortController();
        (0, $eW4Xh.thunks).fetch({
            onFetch: async ()=>{
                try {
                    return await onFetch({
                        signal: signal
                    }, ...args);
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                } catch (e) {
                    throw new (0, $d6Xq4.UseFetchHandledError)(isMounted.current, e);
                }
            },
            analyticsTracking: analyticsTracking,
            createAnalyticsEvent: createAnalyticsEvent,
            browserMetricsKey: browserMetricsKey,
            loggingKey: loggingKey,
            signal: signal
        })({
            actions: (0, $aAhmV.buildActionDispatchers)(dispatch)
        });
    }, [
        onFetch,
        analyticsTracking,
        browserMetricsKey,
        createAnalyticsEvent,
        loggingKey,
        getAbortController
    ]);
    const doAbort = (0, $5uXOq.useCallback)(()=>{
        if (isAbortable) // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        getAbortController().abort();
    }, [
        getAbortController,
        isAbortable
    ]);
    const doFetch = (0, $5uXOq.useCallback)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    (...args)=>{
        if (loading) doAbort();
        callFetch(...args);
    }, [
        loading,
        callFetch,
        doAbort
    ]);
    /**
	 * We need this shouldAutoFetch in concurrent mode or we callFetch twice on mount
	 * We can't do a loading check in the hasEffectsChanged useEffect because loading doesn't get updated in time
	 * So we delay it till the next cycle via useEffect
	 */ const [shouldAutoFetch, setShouldAutoFetch] = (0, $5uXOq.useState)(false);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('jira-concurrent-board-perf')) {
            if (shouldAutoFetch) {
                setShouldAutoFetch(false);
                if (!loading) callFetch();
            }
        }
    }, [
        shouldAutoFetch,
        callFetch,
        loading
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const hasEffectsChanged = (0, $lUlda.isShallowDifferent)(fetchDependenciesRef.current, fetchDependencies);
        if (!initialized && !fetched || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = fetchDependencies;
            if (hasEffectsChanged) doAbort();
            if (isAutoFetchable) {
                if ((0, $4R6GH.fg)('jira-concurrent-board-perf')) setShouldAutoFetch(true);
                else callFetch();
            } else if (initialized && hasEffectsChanged) dispatch({
                type: 'resetInitialState',
                payload: null
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        initialized,
        doAbort,
        fetched,
        callFetch,
        isAutoFetchable,
        ...fetchDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        isMounted.current = true;
        return ()=>{
            isMounted.current = false;
            doAbort();
        };
    }, [
        doAbort
    ]);
    return [
        state,
        {
            doFetch: doFetch,
            doAbort: doAbort
        }
    ];
};

});
parcelRegister("aAhmV", function(module, exports) {

$parcel$export(module.exports, "buildActionDispatchers", () => $b5443ab87e9d487f$export$5297818927df1cbf);
$parcel$export(module.exports, "buildSweetStateActionDispatchers", () => $b5443ab87e9d487f$export$25b8423a7d935d64);
$parcel$export(module.exports, "hydrateSweetStateActionsDispatchers", () => $b5443ab87e9d487f$export$7f88d514aa0ad345);

var $aTJxm = parcelRequire("aTJxm");
const $b5443ab87e9d487f$export$5297818927df1cbf = (dispatch)=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (payload)=>dispatch({
                type: strategy,
                payload: payload
            });
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$25b8423a7d935d64 = ()=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys((0, $aTJxm.strategies)).reduce((accumulator, strategy)=>{
        accumulator[strategy] = (key, initialData, payload)=>({ setState: setState, getState: getState })=>{
                const state = getState();
                const sliceState = state.fetchables[key] || initialData;
                // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
                const nextSliceState = (0, $aTJxm.strategies)[strategy](sliceState, {
                    type: strategy,
                    payload: payload
                });
                const nextState = {
                    ...state,
                    fetchables: {
                        ...state.fetchables,
                        [key]: nextSliceState
                    }
                };
                setState(nextState);
            };
        return accumulator;
    }, {});
const $b5443ab87e9d487f$export$7f88d514aa0ad345 = ({ actions: actions, key: key, initialData: initialData })=>// eslint-disable-next-line @typescript-eslint/no-explicit-any
    Object.keys(actions).reduce((accumulator, strategy)=>{
        const actionExecutor = actions[strategy];
        accumulator[strategy] = (payload)=>{
            actionExecutor(key, initialData, payload);
        };
        return accumulator;
    }, {});

});
parcelRegister("aTJxm", function(module, exports) {

$parcel$export(module.exports, "strategies", () => $e708554df9e0cc9d$export$c5491a8691a23b9e);

var $dg0bO = parcelRequire("dg0bO");
const $e708554df9e0cc9d$var$resetInitialState = ()=>(0, $dg0bO.initialState);
const $e708554df9e0cc9d$var$setFetchStart = (state)=>({
        ...state,
        initialized: true,
        loading: true,
        fetched: false,
        hasError: false,
        aborted: false
    });
const $e708554df9e0cc9d$var$setFetchEnd = (_, action)=>({
        initialized: true,
        loading: false,
        fetched: true,
        hasError: false,
        aborted: false,
        data: action.payload
    });
const $e708554df9e0cc9d$var$setError = (_, action)=>({
        error: action.payload,
        initialized: true,
        loading: false,
        fetched: false,
        hasError: true,
        aborted: false
    });
const $e708554df9e0cc9d$var$setAborted = ()=>({
        initialized: true,
        loading: false,
        fetched: false,
        hasError: false,
        aborted: true
    });
const $e708554df9e0cc9d$var$setDefault = (state)=>state;
const $e708554df9e0cc9d$export$c5491a8691a23b9e = {
    resetInitialState: $e708554df9e0cc9d$var$resetInitialState,
    setFetchStart: $e708554df9e0cc9d$var$setFetchStart,
    setFetchEnd: $e708554df9e0cc9d$var$setFetchEnd,
    setError: $e708554df9e0cc9d$var$setError,
    setAborted: $e708554df9e0cc9d$var$setAborted,
    default: $e708554df9e0cc9d$var$setDefault
};

});
parcelRegister("dg0bO", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $147c98f07a60815a$export$d4c72bab9d6cc13a);
const $147c98f07a60815a$export$d4c72bab9d6cc13a = {
    initialized: false,
    loading: false,
    fetched: false,
    hasError: false,
    aborted: false,
    error: undefined,
    data: undefined
};

});



parcelRegister("d6Xq4", function(module, exports) {

$parcel$export(module.exports, "UseFetchHandledError", () => $7de9d917d4a5c394$export$2801d9c787d65a99);
class $7de9d917d4a5c394$export$2801d9c787d65a99 extends Error {
    constructor(componentMounted, e){
        super(e?.message || 'Unknown');
        this.originalError = e;
        this.componentMounted = !!componentMounted;
    }
}

});

parcelRegister("bYINM", function(module, exports) {

$parcel$export(module.exports, "reducer", () => $82dfd012f8e9e396$export$1650419e431d3ba3);

var $aTJxm = parcelRequire("aTJxm");

var $dg0bO = parcelRequire("dg0bO");
const $82dfd012f8e9e396$export$1650419e431d3ba3 = (state = (0, $dg0bO.initialState), action)=>{
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly resetInitialState: () => { readonly initialized: false; readonly loading: false; readonly fetched: false; readonly hasError: false; readonly aborted: false; readonly error: undefined; readonly data: undefined; }; ... 4 more ...; readonly default: (state: FetchState) => FetchState; }'.
    const transformer = (0, $aTJxm.strategies)[action.type] || (0, $aTJxm.strategies).default;
    return transformer(state, action);
};

});

parcelRegister("lUlda", function(module, exports) {

$parcel$export(module.exports, "isShallowDifferent", () => $76bb872f5000fbec$export$a42e2ec7d66a0c03);
const $76bb872f5000fbec$export$a42e2ec7d66a0c03 = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);

});

parcelRegister("eW4Xh", function(module, exports) {

$parcel$export(module.exports, "thunks", () => $4eddb453cf1aa4e2$export$eb2332b8a94a914a);

var $eUcR1 = parcelRequire("eUcR1");

var $dTD3b = parcelRequire("dTD3b");

var $7lFwJ = parcelRequire("7lFwJ");
const $4eddb453cf1aa4e2$export$eb2332b8a94a914a = {
    fetch: ({ onFetch: onFetch, analyticsTracking: analyticsTracking, browserMetricsKey: browserMetricsKey, loggingKey: loggingKey, signal: signal, createAnalyticsEvent: createAnalyticsEvent })=>{
        const metricsTracker = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey
        });
        const logger = (0, $7lFwJ.loggingHandler)({
            loggingKey: loggingKey
        });
        return async ({ actions: actions })=>{
            const analyticsTracker = (0, $dTD3b.trackDataFetchAnalytics)({
                ...analyticsTracking,
                createAnalyticsEvent: createAnalyticsEvent
            });
            metricsTracker.start();
            analyticsTracker.start();
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            actions.setFetchStart();
            try {
                const data = await onFetch({
                    signal: signal
                });
                actions.setFetchEnd(data);
                metricsTracker.end();
                analyticsTracker.succeeded();
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (e) {
                metricsTracker.cancel();
                if (e.componentMounted) {
                    if (signal.aborted) {
                        // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
                        actions.setAborted();
                        analyticsTracker.aborted();
                    } else {
                        const thrownError = e.originalError;
                        actions.setError(thrownError);
                        analyticsTracker.failed(thrownError);
                        logger.error(thrownError);
                    }
                }
            }
        };
    }
};

});
parcelRegister("eUcR1", function(module, exports) {

$parcel$export(module.exports, "trackBrowserMetricsForJira", () => $ce81c3c268f844ac$export$d8b2320f7d41dc1d);

var $dGrdR = parcelRequire("dGrdR");

var $30KM0 = parcelRequire("30KM0");
const $ce81c3c268f844ac$export$d8b2320f7d41dc1d = ({ browserMetricsKey: browserMetricsKey, attributes: attributes, histogram: // Define bucket sizes for histogram. e.g.: '100_500_1000_2500_5000_10000'. Default to '500_1000_1500_4000_7000'.
histogram })=>{
    if (browserMetricsKey === null || browserMetricsKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        start: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        end: ()=>{},
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        cancel: ()=>{}
    };
    const bm3MetricsTracker = (0, $dGrdR.metrics).interaction({
        key: browserMetricsKey,
        // @ts-expect-error - TS2741 - Property '[BMInteractionMetrics.response]' is missing in type '{ result: string | undefined; }' but required in type 'InteractionHistogramConfig'.
        histogram: {
            result: histogram || (0, $30KM0.DEFAULT_HISTOGRAM_BUCKETS)
        }
    });
    const startHandler = ()=>{
        bm3MetricsTracker.start();
    };
    const endHandler = ()=>{
        bm3MetricsTracker.stop({
            customData: attributes
        });
    };
    const cancelHandler = ()=>{
        bm3MetricsTracker.cancel();
    };
    return {
        start: startHandler,
        end: endHandler,
        cancel: cancelHandler
    };
};

});
parcelRegister("30KM0", function(module, exports) {

$parcel$export(module.exports, "STORE_NAME", () => $b92906e2cd9ec8a5$export$cd79d01fb3d2f506);
$parcel$export(module.exports, "experiences", () => $b92906e2cd9ec8a5$export$9848ee2a7d21002f);
$parcel$export(module.exports, "TIMEOUT_IN_MS", () => $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b);
$parcel$export(module.exports, "DEFAULT_HISTOGRAM_BUCKETS", () => $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6);

const $b92906e2cd9ec8a5$export$cd79d01fb3d2f506 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.experience-tracker-store`;
const $b92906e2cd9ec8a5$export$9848ee2a7d21002f = {
    RENDER: 'render'
};
const $b92906e2cd9ec8a5$export$9ebf97d10ce21f3b = 7000;
const $b92906e2cd9ec8a5$export$e3b77a602bc4d0e6 = '500_1000_1500_4000_7000';

});


parcelRegister("dTD3b", function(module, exports) {

$parcel$export(module.exports, "trackDataFetchAnalytics", () => $e920ac60c98f1376$export$bc65acfb4b442c00);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $8zOmE = parcelRequire("8zOmE");

var $93kZ7 = parcelRequire("93kZ7");
const $e920ac60c98f1376$export$d14e9b22afc87cb3 = (statusCode)=>{
    if (statusCode === null) return (0, $93kZ7.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $93kZ7.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $93kZ7.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $93kZ7.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $93kZ7.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $93kZ7.statusCodeGroups).SERVER_ERRORS;
    return (0, $93kZ7.statusCodeGroups).UNKNOWN;
};
const $e920ac60c98f1376$var$includeSample = (sampleRate)=>Math.random() <= 1 / sampleRate;
const $e920ac60c98f1376$var$noopAnalytics = Object.freeze({
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    start: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    succeeded: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    failed: ()=>{},
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    aborted: ()=>{}
});
const $e920ac60c98f1376$export$bc65acfb4b442c00 = ({ action: action = 'dataFetch', actionSubject: actionSubject, packageName: packageName, createAnalyticsEvent: createAnalyticsEvent, sampleRate: sampleRate })=>{
    if (actionSubject == null) return $e920ac60c98f1376$var$noopAnalytics;
    if (sampleRate != null && !$e920ac60c98f1376$var$includeSample(sampleRate)) return $e920ac60c98f1376$var$noopAnalytics;
    // Note: Operational analytics do NOT use actionSubjectId!
    const actionSubjectAndAction = `${actionSubject} ${action}`;
    return Object.freeze({
        start: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $93kZ7.analyticsStatuses).STARTED,
                packageName: packageName
            });
        },
        succeeded: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                statusCodeGroup: '2xx',
                status: (0, $93kZ7.analyticsStatuses).SUCCEEDED,
                packageName: packageName
            });
        },
        failed: (e)=>{
            const error = e !== null && e !== undefined ? e : new Error('Unknown error, e should be present');
            if (!(0, $fZneA.isClientFetchError)(e)) {
                (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                    statusCodeGroup: $e920ac60c98f1376$export$d14e9b22afc87cb3(error instanceof (0, $jJZqs.default) ? error.statusCode : -1),
                    status: (0, $93kZ7.analyticsStatuses).FAILED,
                    packageName: packageName
                });
                return;
            }
            // No network connection error
            (0, $jcw0u.default)({
                meta: {
                    id: actionSubject,
                    packageName: packageName
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
        },
        aborted: ()=>{
            (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), actionSubjectAndAction, {
                status: (0, $93kZ7.analyticsStatuses).ABORTED,
                packageName: packageName
            });
        }
    });
};

});
parcelRegister("93kZ7", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $88683eadd8082ef6$export$fddea1bcaead87d5);
$parcel$export(module.exports, "analyticsStatuses", () => $88683eadd8082ef6$export$f0fa81eb65b496a1);
const $88683eadd8082ef6$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};
const $88683eadd8082ef6$export$f0fa81eb65b496a1 = {
    SUCCEEDED: 'succeeded',
    FAILED: 'failed',
    ABORTED: 'aborted',
    STARTED: 'started'
};

});


parcelRegister("7lFwJ", function(module, exports) {

$parcel$export(module.exports, "loggingHandler", () => $81689b1ad2d5cba4$export$f35316da257b76e4);

var $2YZCu = parcelRequire("2YZCu");

var $fZneA = parcelRequire("fZneA");
const $81689b1ad2d5cba4$export$f35316da257b76e4 = ({ loggingKey: loggingKey })=>{
    if (loggingKey === null || loggingKey === undefined) return {
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        error: ()=>{}
    };
    const errorHandler = (thrownError)=>{
        if (!(0, $fZneA.isClientFetchError)(thrownError)) (0, $2YZCu.default).safeErrorWithoutCustomerData(loggingKey, 'Error fetching data', thrownError);
    };
    return {
        error: errorHandler
    };
};

});



parcelRegister("5IV0G", function(module, exports) {

$parcel$export(module.exports, "performPutRequest", () => $f34d0f87a908aa70$export$9ead1f9103e6de6b);

var $eusud = parcelRequire("eusud");

var $3wzQ9 = parcelRequire("3wzQ9");
const $f34d0f87a908aa70$export$9ead1f9103e6de6b = (url, options = {})=>(0, $eusud.performPutRequest)(url, options).catch((error)=>{
        throw new (0, $3wzQ9.FetchUrlError)(url, error);
    });

});
parcelRegister("3wzQ9", function(module, exports) {

$parcel$export(module.exports, "FetchUrlError", () => $f57667a2adaf29d3$export$5cdfc90b27d7ab6c);

var $jJZqs = parcelRequire("jJZqs");

var $fZneA = parcelRequire("fZneA");

var $bw7Gm = parcelRequire("bw7Gm");

var $kFy8J = parcelRequire("kFy8J");
const $f57667a2adaf29d3$var$getStatusCodeGroup = (statusCode)=>{
    if (statusCode === null) return (0, $kFy8J.statusCodeGroups).UNKNOWN;
    if (statusCode >= 100 && statusCode <= 199) return (0, $kFy8J.statusCodeGroups).INFORMATIONAL_RESPONSES;
    if (statusCode >= 200 && statusCode <= 299) return (0, $kFy8J.statusCodeGroups).SUCCESS_RESPONSES;
    if (statusCode >= 300 && statusCode <= 399) return (0, $kFy8J.statusCodeGroups).REDIRECTS;
    if (statusCode >= 400 && statusCode <= 499) return (0, $kFy8J.statusCodeGroups).CLIENT_ERRORS;
    if (statusCode >= 500 && statusCode <= 599) return (0, $kFy8J.statusCodeGroups).SERVER_ERRORS;
    return (0, $kFy8J.statusCodeGroups).UNKNOWN;
};
const $f57667a2adaf29d3$var$stringifySafe = (obj)=>{
    try {
        return JSON.stringify(obj);
    } catch  {
        return null;
    }
};
class $f57667a2adaf29d3$export$5cdfc90b27d7ab6c extends (0, $jJZqs.default) {
    constructor(url, fetchError){
        if (fetchError instanceof (0, $jJZqs.default)) super(fetchError.statusCode, fetchError.message, fetchError.traceId);
        else super(-1, fetchError.message);
        this.name = 'FetchUrlError';
        this.url = (0, $bw7Gm.default)(url);
        this.aborted = fetchError.name === (0, $jJZqs.ABORT_ERROR_NAME);
        this.isClientError = (0, $fZneA.isClientFetchError)(fetchError) || this.statusCode === -1;
        this.statusCodeGroup = $f57667a2adaf29d3$var$getStatusCodeGroup(fetchError instanceof (0, $jJZqs.default) ? fetchError.statusCode : null);
        // NOTE: logging does not support nested objects!
        this.cause = $f57667a2adaf29d3$var$stringifySafe(fetchError);
    }
}

});
parcelRegister("kFy8J", function(module, exports) {

$parcel$export(module.exports, "statusCodeGroups", () => $cb89e2c05d3c28e8$export$fddea1bcaead87d5);
const $cb89e2c05d3c28e8$export$fddea1bcaead87d5 = {
    INFORMATIONAL_RESPONSES: '1xx',
    SUCCESS_RESPONSES: '2xx',
    REDIRECTS: '3xx',
    CLIENT_ERRORS: '4xx',
    SERVER_ERRORS: '5xx',
    UNKNOWN: 'unknown'
};

});




parcelRegister("jB6yt", function(module, exports) {

$parcel$export(module.exports, "default", () => $36c97328c4dc150e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $MHKc7 = parcelRequire("MHKc7");

var $jgJNO = parcelRequire("jgJNO");

var $7CMCs = parcelRequire("7CMCs");

var $1v6HV = parcelRequire("1v6HV");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");

var $hchBL = parcelRequire("hchBL");

var $duOMW = parcelRequire("duOMW");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $lngWe = parcelRequire("lngWe");

var $3uPqt = parcelRequire("3uPqt");

var $cYeCp = parcelRequire("cYeCp");

var $5iXkq = parcelRequire("5iXkq");

var $jCs82 = parcelRequire("jCs82");

var $1wxxD = parcelRequire("1wxxD");

var $8vQbt = parcelRequire("8vQbt");

var $iDGXn = parcelRequire("iDGXn");

var $3ykoc = parcelRequire("3ykoc");

var $38RF4 = parcelRequire("38RF4");

var $2ucDS = parcelRequire("2ucDS");

const $36c97328c4dc150e$var$ViewSettings = ({ view: view, boardId: boardId, isClassic: isClassic, epicCustomName: epicCustomName, showEpicAsPanel: showEpicAsPanel = false, showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, isVersionsEnabled: isVersionsEnabled = false, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, isViewPanelOpen: isViewPanelOpen = false, onViewPanelClose: onViewPanelClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), areSubtasksEnabled: areSubtasksEnabled, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, dependencyIssueOptions: dependencyIssueOptions = {}, analyticsData: analyticsData, isShowBoardNameEnabled: isShowBoardNameEnabled, shouldRenderPopupToParent: shouldRenderPopupToParent, isThemed: isThemed = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const panelRef = (0, $5uXOq.useRef)(null);
    const [{ activeViewSettingsSpotlight: activeViewSettingsSpotlight }, { setOpenViewSettings: setOpenViewSettings, onViewSettingsSpotlightEnd: onViewSettingsSpotlightEnd }] = (0, $1v6HV.useBoardWorkSuggestionsSpotlightContainer)();
    const handleViewPanelClose = ()=>{
        onViewPanelClose();
    };
    const handleClose = ()=>{
        setIsOpen(false);
        if (activeViewSettingsSpotlight === 1 && onViewSettingsSpotlightEnd) // To end the spotlight if the popup is closed
        onViewSettingsSpotlightEnd();
    };
    const handleClick = ()=>{
        setIsOpen(!isOpen);
        sendAnalyticsEvent('clicked', 'button', (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $a4XJc.ViewAs).PANEL : 'popupMenu');
    };
    const openViewSettings = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) return;
        setIsOpen(true);
        sendAnalyticsEvent('clicked', 'button', (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            isClassic: isClassic,
            app: view
        }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? (0, $a4XJc.ViewAs).PANEL : 'popupMenu');
    }, [
        sendAnalyticsEvent,
        isClassic,
        view,
        viewAs,
        isOpen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const viewSettingsBtnLG = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_LG))[0];
    const viewSettingsBtnSM = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_SM))[0];
    const viewSettingsBtnResponsive = (0, $hchBL.useGlobalRef)((0, $duOMW.VIEW_SETTINGS_BUTTON_RESPONSIVE))[0];
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    (0, $5uXOq.useEffect)(()=>{
        // register view settings panel global ref
        register((0, $3795a016b6403547$export$989661c424340ff8), panelRef.current);
        const focusOnCloseButton = ()=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const closeButton = panelRef.current?.querySelector(`[data-testid="${(0, $duOMW.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)}"]`);
            closeButton?.focus();
        };
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.activeElement === viewSettingsBtnLG) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnLG?.focus();
        }
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        if (document.activeElement === viewSettingsBtnSM) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnSM?.focus();
        }
        if (// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.activeElement === viewSettingsBtnResponsive) {
            focusOnCloseButton();
            return ()=>viewSettingsBtnResponsive?.focus();
        }
    }, [
        register,
        viewSettingsBtnLG,
        viewSettingsBtnResponsive,
        viewSettingsBtnSM
    ]);
    const conditionallyRenderViewSettingsButtonWithAria = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
            isSelected: isOpen,
            onClick: handleClick,
            isThemedButton: isThemed,
            ...props
        });
    const viewAsPopup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        messageId: "software-view-settings.ui.popup",
        messageType: "transactional",
        "data-testid": "software-view-settings.ui.popup",
        isOpen: isOpen,
        onClose: handleClose,
        placement: "bottom-end",
        content: (props)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ucDS.ViewSettingsMenu), {
                view: view,
                viewAs: (0, $a4XJc.ViewAs).POPUP,
                boardId: boardId,
                isClassic: isClassic,
                showFilterBarToggle: showFilterBarToggle,
                showEpicAsPanel: showEpicAsPanel,
                epicCustomName: epicCustomName,
                showCardDetails: showCardDetails,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                showWorkSuggestions: showWorkSuggestions,
                isVersionsEnabled: isVersionsEnabled,
                areSubtasksEnabled: areSubtasksEnabled,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
                onShowCardCoversToggledOn: onShowCardCoversToggledOn,
                dependencyIssueOptions: dependencyIssueOptions,
                onUpdate: props.update,
                onClose: props.onClose,
                analyticsData: analyticsData,
                isShowBoardNameEnabled: isShowBoardNameEnabled
            });
        },
        shouldRenderToParent: shouldRenderPopupToParent,
        trigger: ({ ref: ref, 'aria-controls': ariaControls, 'aria-expanded': ariaExpanded, 'aria-haspopup': ariaHasPopup })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
                ref: ref
            }, conditionallyRenderViewSettingsButtonWithAria({
                'aria-controls': ariaControls,
                'aria-expanded': ariaExpanded,
                'aria-haspopup': ariaHasPopup
            }))
    });
    const viewAsPanel = isViewPanelOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: panelRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lngWe.Panel), {
        title: formatMessage((0, $3ykoc.default).panelTitle),
        onClose: handleViewPanelClose
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ucDS.ViewSettingsMenu), {
        view: view,
        viewAs: (0, $a4XJc.ViewAs).PANEL,
        boardId: boardId,
        isClassic: isClassic,
        showFilterBarToggle: showFilterBarToggle,
        showEpicAsPanel: showEpicAsPanel,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isVersionsEnabled: isVersionsEnabled,
        isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
        showWorkSuggestions: showWorkSuggestions,
        areSubtasksEnabled: areSubtasksEnabled,
        onSubtasksExpandAll: onSubtasksExpandAll,
        onSubtasksCollapseAll: onSubtasksCollapseAll,
        areAllSubtasksExpanded: areAllSubtasksExpanded,
        areAllSubtasksCollapsed: areAllSubtasksCollapsed,
        isSwimlanesEnabled: isSwimlanesEnabled,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: onSwimlaneCollapseAll,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        isDaysInColumnEnabled: isDaysInColumnEnabled,
        showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
        cardExtraFields: cardExtraFields,
        isEstimateEnabled: isEstimateEnabled,
        isDueDateEnabled: isDueDateEnabled,
        isLabelsEnabled: isLabelsEnabled,
        isPriorityEnabled: isPriorityEnabled,
        isDevelopmentEnabled: isDevelopmentEnabled,
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
        onShowCardCoversToggledOn: onShowCardCoversToggledOn,
        dependencyIssueOptions: dependencyIssueOptions,
        analyticsData: analyticsData,
        isShowBoardNameEnabled: isShowBoardNameEnabled
    })));
    (0, $jCs82.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $8vQbt.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $5iXkq.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    // Initialise local storage for Increment Planning board
    (0, $1wxxD.useOnIncrementPlanningBoard)(boardId, view, dependencyIssueOptions);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: viewAs === (0, $a4XJc.ViewAs).PANEL ? 'viewSettingsPanel' : 'viewSettingsMenu',
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iDGXn.ViewSettingsContainer), {
        view: view,
        isGlobal: true
    }, viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? viewAsPanel : viewAsPopup));
};
const $36c97328c4dc150e$var$ViewSettingsWithErrorBoundary = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "errorBoundary",
        packageName: "jiraSoftwareViewSettings",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($36c97328c4dc150e$var$ViewSettings, props));
var $36c97328c4dc150e$export$2e2bcd8739ae039 = $36c97328c4dc150e$var$ViewSettingsWithErrorBoundary;

});
parcelRegister("1v6HV", function(module, exports) {

$parcel$export(module.exports, "BoardWorkSuggestionsSpotlightContainer", () => $335a8c33b51043c3$export$f2c5bcc872636b8b);
$parcel$export(module.exports, "useBoardWorkSuggestionsSpotlightContainer", () => $335a8c33b51043c3$export$bb014eea394e52e2);
$parcel$export(module.exports, "useBoardWorkSuggestionsSpotlightActions", () => $335a8c33b51043c3$export$a4afcad29be76e47);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
var $bKpgX = parcelRequire("bKpgX");

var $j2ixf = parcelRequire("j2ixf");
const $335a8c33b51043c3$var$initialState = {
    activeViewSettingsSpotlight: null,
    hasViewedViewSettingsSpotlight: true,
    openViewSettings: null,
    viewSettingsTogglePulses: false
};
const $335a8c33b51043c3$var$Store = (0, $iXqE5.createStore)({
    initialState: $335a8c33b51043c3$var$initialState,
    actions: $j2ixf.actions,
    name: 'jsw.board.work-suggestions-spotlight-store'
});
const $335a8c33b51043c3$export$272a3bae21574897 = ()=>(0, $bKpgX.defaultRegistry).deleteStore($335a8c33b51043c3$var$Store);
const $335a8c33b51043c3$export$f2c5bcc872636b8b = (0, $gg7kZ.createContainer)($335a8c33b51043c3$var$Store);
const $335a8c33b51043c3$export$bb014eea394e52e2 = (0, $3sQ5x.createHook)($335a8c33b51043c3$var$Store);
const $335a8c33b51043c3$export$a4afcad29be76e47 = (0, $3sQ5x.createActionsHook)($335a8c33b51043c3$var$Store);

});
parcelRegister("j2ixf", function(module, exports) {

$parcel$export(module.exports, "actions", () => $cfc7cb03065719c0$export$e324594224ef24da);
const $cfc7cb03065719c0$export$e324594224ef24da = {
    onViewSettingsSpotlightInit: ()=>({ setState: setState })=>{
            setState({
                hasViewedViewSettingsSpotlight: false
            });
        },
    onViewSettingsSpotlightStart: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 0
            });
        },
    onViewSettingsSpotlightNext: ()=>({ setState: setState })=>{
            setState({
                activeViewSettingsSpotlight: 1
            });
        },
    onViewSettingsSpotlightEnd: ()=>({ setState: setState })=>{
            setState({
                hasViewedViewSettingsSpotlight: true,
                activeViewSettingsSpotlight: null
            });
        },
    setOpenViewSettings: (openViewSettingsCallback)=>({ getState: getState, setState: setState })=>{
            if (!getState().openViewSettings) setState({
                openViewSettings: openViewSettingsCallback
            });
        },
    setViewSettingsTogglePulses: (viewSettingsTogglePulses)=>({ setState: setState })=>{
            setState({
                viewSettingsTogglePulses: viewSettingsTogglePulses
            });
        }
};

});


parcelRegister("lngWe", function(module, exports) {

$parcel$export(module.exports, "Panel", () => $a08ab407f5b09128$export$2ddb90ad54e5f587);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $l1N8i = parcelRequire("l1N8i");

var $84THj = parcelRequire("84THj");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $h9kUS = parcelRequire("h9kUS");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $a2e2Q = parcelRequire("a2e2Q");

var $duOMW = parcelRequire("duOMW");

var $jvrqw = parcelRequire("jvrqw");
const $a08ab407f5b09128$export$2ddb90ad54e5f587 = ({ title: title = '', onClose: onClose = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const headerTitleId = 'view-settings.ui.panel.header-title';
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "end"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            $a08ab407f5b09128$var$panelStyles,
            isSoftwareFullTheming && $a08ab407f5b09128$var$dialogStyles
        ],
        role: "dialog",
        "aria-modal": "false",
        "aria-labelledby": headerTitleId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        grow: "fill",
        spread: "space-between",
        xcss: $a08ab407f5b09128$var$headerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: (0, $4R6GH.fg)('view-settings-title-size-fix') ? 'small' : 'medium',
        as: "h2",
        id: headerTitleId
    }, title || formatMessage((0, $jvrqw.default).defaultTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a08ab407f5b09128$var$ButtonWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        spacing: "none",
        onClick: onClose,
        testId: (0, $duOMW.VIEW_SETTINGS_PANEL_CLOSE_BUTTON_TEST_ID)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $a08ab407f5b09128$var$IconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
        spacing: "spacious",
        label: formatMessage((0, $jvrqw.default).closeButtonLabel)
    }))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, children)));
};
const $a08ab407f5b09128$var$headerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.100'
});
const $a08ab407f5b09128$var$panelStyles = (0, $8CUq3.xcss)({
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    borderRadius: 'border.radius.200',
    width: '280px',
    padding: 'space.300',
    [(0, $h9kUS.media).above.lg]: {
        width: '300px'
    }
});
const $a08ab407f5b09128$var$ButtonWrapperStyles = (0, $8CUq3.xcss)({
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});
const $a08ab407f5b09128$var$IconWrapperStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: "var(--ds-space-400, 32px)",
    height: "var(--ds-space-400, 32px)"
});
const $a08ab407f5b09128$var$dialogStyles = (0, $8CUq3.xcss)({
    background: "var(--ds-surface, #FFFFFF)",
    boxShadow: 'elevation.shadow.overlay'
});

});
parcelRegister("jvrqw", function(module, exports) {

$parcel$export(module.exports, "default", () => $12af5ef45aa68e18$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $12af5ef45aa68e18$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    defaultTitle: {
        "id": "software-view-settings.common.panel.default-title",
        "defaultMessage": "View settings"
    },
    closeButtonLabel: {
        "id": "software-view-settings.common.panel.close-button-label",
        "defaultMessage": "Close"
    }
});

});


parcelRegister("5iXkq", function(module, exports) {

$parcel$export(module.exports, "useCardDetailsInitialState", () => $fd36b5bdce43621b$export$2e9f932053c78b66);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $doZTA = parcelRequire("doZTA");

var $duOMW = parcelRequire("duOMW");

var $9pP0g = parcelRequire("9pP0g");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $fd36b5bdce43621b$export$428c87746d3e32da = {
    [(0, $9pP0g.ViewSetting).SHOW_EPICS]: 'showEpics',
    [(0, $9pP0g.ViewSetting).SHOW_STATUSES]: 'showStatuses',
    [(0, $9pP0g.ViewSetting).SHOW_VERSIONS]: 'showVersions',
    [(0, $9pP0g.ViewSetting).SHOW_ASSIGNEE]: 'showAssignee',
    [(0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN]: 'showDaysInColumn',
    [(0, $9pP0g.ViewSetting).SHOW_ESTIMATE]: 'showEstimate',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY]: 'showIssueKey',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS]: 'showIssueLinksStats',
    [(0, $9pP0g.ViewSetting).SHOW_DUE_DATE]: 'showDueDate',
    [(0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE]: 'showIssueType',
    [(0, $9pP0g.ViewSetting).SHOW_PRIORITY]: 'showPriority',
    [(0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT]: 'showDevelopment',
    [(0, $9pP0g.ViewSetting).SHOW_LABELS]: 'showLabels',
    [(0, $9pP0g.ViewSetting).SHOW_CARD_COVERS]: 'showCardCovers',
    [(0, $9pP0g.ViewSetting).SHOW_BOARD_NAME]: 'showBoardName'
};
const $fd36b5bdce43621b$export$2e9f932053c78b66 = (boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const [{ location: location, query: query }, { replace: replace }] = (0, $doZTA.useRouter)();
    const { setViewSettingsCardDetails: setViewSettingsCardDetails } = (0, $iDGXn.useViewSettingsActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() || !query) return;
        const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
            boardId: boardId,
            view: view,
            isDaysInColumnEnabled: isDaysInColumnEnabled,
            isDueDateEnabled: isDueDateEnabled,
            isLabelsEnabled: isLabelsEnabled,
            isEstimateEnabled: isEstimateEnabled,
            isPriorityEnabled: isPriorityEnabled
        });
        const getInitialCardValue = (stateKey)=>{
            const queryKey = $fd36b5bdce43621b$export$428c87746d3e32da[stateKey];
            return query[queryKey] ? query[queryKey] === (0, $duOMW.QUERY_ENABLED_VALUE) : cardDetailsFromLocalStorage[stateKey];
        };
        const cardDetailsState = {
            [(0, $9pP0g.ViewSetting).SHOW_EPICS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_EPICS),
            [(0, $9pP0g.ViewSetting).SHOW_STATUSES]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_STATUSES),
            [(0, $9pP0g.ViewSetting).SHOW_VERSIONS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_VERSIONS),
            [(0, $9pP0g.ViewSetting).SHOW_ASSIGNEE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ASSIGNEE),
            [(0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DAYS_IN_COLUMN),
            [(0, $9pP0g.ViewSetting).SHOW_ESTIMATE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ESTIMATE),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_LINKS_STATS),
            [(0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE),
            [(0, $9pP0g.ViewSetting).SHOW_PRIORITY]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_PRIORITY),
            [(0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT),
            [(0, $9pP0g.ViewSetting).SHOW_DUE_DATE]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_DUE_DATE),
            [(0, $9pP0g.ViewSetting).SHOW_LABELS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_LABELS),
            [(0, $9pP0g.ViewSetting).SHOW_CARD_COVERS]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_CARD_COVERS),
            [(0, $9pP0g.ViewSetting).SHOW_BOARD_NAME]: getInitialCardValue((0, $9pP0g.ViewSetting).SHOW_BOARD_NAME)
        };
        setViewSettingsCardDetails({
            boardId: boardId,
            view: view,
            cardDetailsState: cardDetailsState
        });
        // remove card view initial settings param
        replace({
            ...location,
            search: new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(query, Object.values($fd36b5bdce43621b$export$428c87746d3e32da))).toString()
        });
    // we want to run this hook on initial render only
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
};

});

parcelRegister("jCs82", function(module, exports) {

$parcel$export(module.exports, "useOnBacklog", () => $39756d5f22d21cd8$export$9c6bcc9d56a57470);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $39756d5f22d21cd8$export$9c6bcc9d56a57470 = (boardId, view, showEpicAsPanel = false, isVersionsEnabled = false)=>{
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const showPanels = (0, $iDGXn.useShowPanels)();
    const { setViewSettingsPanels: setViewSettingsPanels } = (0, $iDGXn.useViewSettingsActions)();
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    // Sync react-sweet-state store with URL or localStorage state on mount.
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).BACKLOG) return;
        const panelsFromQuery = (0, $cYeCp.parseSearchQuery)(location.search);
        const panelsFromLocalStorage = (0, $8zmNw.getViewSettingsPanels)({
            boardId: boardId,
            view: view
        });
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are panels from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        let panelState = panelsFromLocalStorage;
        if (Object.values(panelsFromQuery).filter(Boolean).length !== 0) {
            const queryPanelState = {
                EPIC_PANEL: panelsFromQuery.EPIC_PANEL ?? false,
                VERSION_PANEL: panelsFromQuery.VERSION_PANEL ?? false
            };
            panelState = queryPanelState;
        }
        setViewSettingsPanels({
            boardId: boardId,
            view: view,
            panelState: panelState
        });
    // Removed `location.search` from the dependency array since we only want this hook to fire once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        boardId,
        isVersionsEnabled,
        setViewSettingsPanels,
        showEpicAsPanel,
        view
    ]);
    // Sync URL with react-sweet-state store on mount and when react-sweet-state store changes.
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).BACKLOG) return;
        const url = (0, $cYeCp.setPanels)(showPanels, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        location.search,
        showPanels,
        replace,
        view
    ]);
};

});

parcelRegister("1wxxD", function(module, exports) {

$parcel$export(module.exports, "useOnIncrementPlanningBoard", () => $c2daf95593322126$export$14539b3beca7ada3);

var $5uXOq = parcelRequire("5uXOq");

var $doZTA = parcelRequire("doZTA");
var $lVJAU = parcelRequire("lVJAU");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $c2daf95593322126$export$14539b3beca7ada3 = (boardId, view, dependencyIssueOptions)=>{
    const { setShowUnscheduledColumn: setShowUnscheduledColumn, setShowOfftrackDependencyLines: setShowOfftrackDependencyLines, setIssueIdsToShowDependencies: setIssueIdsToShowDependencies } = (0, $iDGXn.useViewSettingsActions)();
    const [{ location: location }] = (0, $doZTA.useRouter)();
    const { replace: replace } = (0, $lVJAU.useRouterActions)();
    const isUnscheduledColumnVisible = (0, $iDGXn.useShowUnscheduledColumn)();
    const isOfftrackDependencyLinesVisible = (0, $iDGXn.useShowOfftrackDependencyLines)();
    const issueIdsToShowDependencies = (0, $iDGXn.useIssueIdsToShowDependencies)();
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return;
        const unscheduledColumnFromLocalStorage = (0, $8zmNw.getShowUnscheduledColumn)(boardId);
        const settingsFromQuery = (0, $cYeCp.parseSearchQueryForIPBoard)(location.search);
        // Search query state takes precedence over localStorage state, which supersedes react-sweet-state state.
        // If there are IP board settings from the search query, update localStorage and react-sweet-state.
        // If not, update react-sweet-state using localStorage instead.
        const showUnscheduledColumn = settingsFromQuery.SHOW_UNSCHEDULED_COLUMN !== undefined ? settingsFromQuery.SHOW_UNSCHEDULED_COLUMN : unscheduledColumnFromLocalStorage;
        setShowUnscheduledColumn(boardId, showUnscheduledColumn);
        const offtrackDependencyLinesFromLocalStorage = (0, $8zmNw.getShowOfftrackDependencyLines)(boardId);
        const issueIdsToShowDependenciesFromLocalStorage = (0, $8zmNw.getIssueIdsToShowDependencies)(boardId);
        const showOfftrackDependencyLines = settingsFromQuery.SHOW_OFFTRACK_DEPENDENCY_LINES !== undefined ? settingsFromQuery.SHOW_OFFTRACK_DEPENDENCY_LINES : offtrackDependencyLinesFromLocalStorage;
        setShowOfftrackDependencyLines(boardId, showOfftrackDependencyLines);
        const issuesIdsToShowDependencies = settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES && settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES.length ? settingsFromQuery.ISSUE_IDS_TO_SHOW_DEPENDENCIES : issueIdsToShowDependenciesFromLocalStorage;
        const filteredIssueIds = Array.isArray(issuesIdsToShowDependencies) ? issuesIdsToShowDependencies.filter((issueId)=>dependencyIssueOptions[issueId] !== undefined) : [];
        setIssueIdsToShowDependencies(boardId, filteredIssueIds);
    }, [
        boardId,
        view,
        dependencyIssueOptions,
        location.search,
        setShowUnscheduledColumn,
        setShowOfftrackDependencyLines,
        setIssueIdsToShowDependencies
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (view !== (0, $a4XJc.View).INCREMENT_PLANNING_BOARD) return;
        const url = (0, $cYeCp.setIncrementPlanningSettingsQuery)({
            SHOW_UNSCHEDULED_COLUMN: isUnscheduledColumnVisible,
            SHOW_OFFTRACK_DEPENDENCY_LINES: isOfftrackDependencyLinesVisible,
            ISSUE_IDS_TO_SHOW_DEPENDENCIES: issueIdsToShowDependencies
        }, location);
        if (location.search !== `?${url.search}`) replace(url);
    // `Location` has a `hash` attribute which causes unnecessary calls, so we are only using `search` in the dependency array.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        view,
        isUnscheduledColumnVisible,
        isOfftrackDependencyLinesVisible,
        issueIdsToShowDependencies,
        location.search,
        replace
    ]);
};

});

parcelRegister("8vQbt", function(module, exports) {

$parcel$export(module.exports, "useSyncFromLocalStorage", () => $9a1dab6fcae5bc71$export$88f2270d613c342b);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");

var $cYeCp = parcelRequire("cYeCp");

var $8zmNw = parcelRequire("8zmNw");

var $iDGXn = parcelRequire("iDGXn");
const $9a1dab6fcae5bc71$export$88f2270d613c342b = (boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled)=>{
    const { setIsFullscreen: setIsFullscreen, setViewSettingsCardDetails: setViewSettingsCardDetails, setViewSettingsQuickFilters: setViewSettingsQuickFilters, setViewSettingsCompactMode: setViewSettingsCompactMode, setViewSettingsCardExtraFields: setViewSettingsCardExtraFields } = (0, $iDGXn.useViewSettingsActions)();
    const hasRendered = (0, $5uXOq.useRef)(false);
    if (hasRendered.current === false && (0, $4R6GH.fg)('backlog-view-settings-all-fields-setimmediate')) {
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) {
            const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
                boardId: boardId,
                view: view
            });
            setViewSettingsCardDetails({
                boardId: boardId,
                cardDetailsState: cardDetailsFromLocalStorage,
                view: view
            });
        }
        const quickFiltersFromLocalStorage = (0, $8zmNw.getViewSettingsQuickFilters)({
            boardId: boardId,
            view: view
        });
        setViewSettingsQuickFilters({
            boardId: boardId,
            view: view,
            showQuickFilters: quickFiltersFromLocalStorage
        });
        const compactModeFromLocalStorage = (0, $8zmNw.getViewSettingsCompactMode)({
            boardId: boardId,
            view: view
        });
        setViewSettingsCompactMode({
            boardId: boardId,
            view: view,
            showCompactMode: compactModeFromLocalStorage
        });
        const isFullscreenFromLocalStorage = (0, $8zmNw.getViewSettingsIsFullscreen)({
            boardId: boardId,
            view: view
        });
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreenFromLocalStorage,
            view: view
        });
        const cardExtraFieldsState = (0, $8zmNw.getViewSettingsCardExtraFields)({
            boardId: boardId,
            view: view,
            cardExtraFields: cardExtraFields
        });
        setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsState,
            view: view
        });
        hasRendered.current = true;
        return;
    }
    if ((0, $4R6GH.fg)('backlog-view-settings-all-fields-setimmediate')) return;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        // card details initial state moved to `useCardDetailsInitialState`
        if (!(0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) {
            const cardDetailsFromLocalStorage = (0, $8zmNw.getViewSettingsCardDetails)({
                boardId: boardId,
                view: view
            });
            setViewSettingsCardDetails({
                boardId: boardId,
                cardDetailsState: cardDetailsFromLocalStorage,
                view: view
            });
        }
        const quickFiltersFromLocalStorage = (0, $8zmNw.getViewSettingsQuickFilters)({
            boardId: boardId,
            view: view
        });
        setViewSettingsQuickFilters({
            boardId: boardId,
            view: view,
            showQuickFilters: quickFiltersFromLocalStorage
        });
        const compactModeFromLocalStorage = (0, $8zmNw.getViewSettingsCompactMode)({
            boardId: boardId,
            view: view
        });
        setViewSettingsCompactMode({
            boardId: boardId,
            view: view,
            showCompactMode: compactModeFromLocalStorage
        });
        const isFullscreenFromLocalStorage = (0, $8zmNw.getViewSettingsIsFullscreen)({
            boardId: boardId,
            view: view
        });
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: isFullscreenFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        isDaysInColumnEnabled,
        isDueDateEnabled,
        isLabelsEnabled,
        isEstimateEnabled,
        isPriorityEnabled,
        setIsFullscreen,
        setViewSettingsCardDetails,
        setViewSettingsCompactMode,
        setViewSettingsQuickFilters,
        setViewSettingsCardExtraFields
    ]);
    // Remove this when cleaning up backlog-view-settings-extra-fields-immediate-set
    // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $5uXOq.useEffect)(()=>{
        const cardExtraFieldsFromLocalStorage = (0, $8zmNw.getViewSettingsCardExtraFields)({
            boardId: boardId,
            view: view,
            cardExtraFields: cardExtraFields
        });
        setViewSettingsCardExtraFields({
            boardId: boardId,
            cardExtraFieldsState: cardExtraFieldsFromLocalStorage,
            view: view
        });
    }, [
        boardId,
        view,
        cardExtraFields,
        setViewSettingsCardExtraFields
    ]);
};

});

parcelRegister("3ykoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $a98a1024295d65c6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a98a1024295d65c6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    panelTitle: {
        "id": "software-view-settings.panel-title",
        "defaultMessage": "View settings"
    }
});

});

parcelRegister("38RF4", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSyncFromLocalStorageWrapper", () => $434e13d035e4d1d0$export$8c976c7ba46200ff);
$parcel$export(module.exports, "ViewSettingsButton", () => $434e13d035e4d1d0$export$805802ea39f3d804);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $42CjB = parcelRequire("42CjB");

var $4QAwn = parcelRequire("4QAwn");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");

var $1v6HV = parcelRequire("1v6HV");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $59KYj = parcelRequire("59KYj");

var $22OQR = parcelRequire("22OQR");

var $hchBL = parcelRequire("hchBL");

var $dCm1o = parcelRequire("dCm1o");

var $hCCtP = parcelRequire("hCCtP");

var $duOMW = parcelRequire("duOMW");

var $5iXkq = parcelRequire("5iXkq");

var $jCs82 = parcelRequire("jCs82");

var $8vQbt = parcelRequire("8vQbt");

var $iIMX5 = parcelRequire("iIMX5");
const $434e13d035e4d1d0$export$8c976c7ba46200ff = ({ boardId: boardId, view: view, cardExtraFields: cardExtraFields = [], isDaysInColumnEnabled: isDaysInColumnEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isEstimateEnabled: isEstimateEnabled = false, children: children, showEpicAsPanel: showEpicAsPanel = false, isVersionsEnabled: isVersionsEnabled = false, isPriorityEnabled: isPriorityEnabled = false })=>{
    (0, $jCs82.useOnBacklog)(boardId, view, showEpicAsPanel, isVersionsEnabled);
    (0, $8vQbt.useSyncFromLocalStorage)(boardId, view, cardExtraFields, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    (0, $5iXkq.useCardDetailsInitialState)(boardId, view, isDaysInColumnEnabled, isDueDateEnabled, isLabelsEnabled, isEstimateEnabled, isPriorityEnabled);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $434e13d035e4d1d0$export$805802ea39f3d804 = ({ isSelected: isSelected, onClick: onClick = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isThemedButton: isThemedButton = false, ...restProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(isSelected);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(!isOpen);
        onClick(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen,
        onClick
    ]);
    const openViewSettings = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'button'
        }), 'viewSettingsButton');
        setIsOpen(true);
        setTimeout(()=>onClick(true));
    }, [
        createAnalyticsEvent,
        onClick
    ]);
    const { setOpenViewSettings: setOpenViewSettings } = (0, $1v6HV.useBoardWorkSuggestionsSpotlightActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (setOpenViewSettings) setOpenViewSettings(openViewSettings);
    }, [
        openViewSettings,
        setOpenViewSettings
    ]);
    const onRefButtonResponsive = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $duOMW.VIEW_SETTINGS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    (0, $5uXOq.useEffect)(()=>{
        setIsOpen(isSelected);
    }, [
        isSelected
    ]);
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        const themedButton = (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
            testId: "software-view-settings.ui.view-settings-button.responsive-button",
            appearance: "default",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))),
            label: formatMessage((0, $iIMX5.default).buttonLabel),
            isSelected: isOpen,
            onClick: handleClick,
            ref: onRefButtonResponsive,
            "aria-expanded": restProps.ariaExpanded ?? isSelected,
            "aria-controls": restProps.ariaControls,
            "aria-haspopup": restProps.ariaHasPopup ?? true
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
            testId: "software-view-settings.ui.view-settings-button.responsive-button",
            appearance: "default",
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
                label: "",
                color: "currentColor",
                spacing: "spacious"
            }),
            label: formatMessage((0, $iIMX5.default).buttonLabel),
            isSelected: isOpen,
            onClick: handleClick,
            ref: onRefButtonResponsive,
            "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
            "aria-expanded": restProps.ariaExpanded ?? isSelected,
            "aria-controls": restProps.ariaControls,
            "aria-haspopup": restProps.ariaHasPopup ?? true
        });
        return isThemedButton ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage((0, $iIMX5.default).buttonLabel)
        }, themedButton) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            testId: "software-view-settings.ui.view-settings-button.icon-button",
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))),
            label: formatMessage((0, $iIMX5.default).buttonLabel),
            isSelected: isOpen,
            onClick: handleClick,
            ref: onRefButtonResponsive,
            "aria-expanded": restProps.ariaExpanded ?? isSelected,
            "aria-controls": restProps.ariaControls,
            "aria-haspopup": restProps.ariaHasPopup ?? true,
            isTooltipDisabled: false
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $59KYj.ResponsiveThemedButton), {
        testId: "software-view-settings.ui.view-settings-button.responsive-button",
        appearance: "default",
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4QAwn))), {
            label: "",
            color: "currentColor",
            spacing: "spacious"
        }),
        label: formatMessage((0, $iIMX5.default).buttonLabel),
        isSelected: isOpen,
        onClick: handleClick,
        ref: onRefButtonResponsive,
        "aria-label": formatMessage((0, $iIMX5.default).buttonLabel),
        "aria-expanded": restProps.ariaExpanded ?? isSelected,
        "aria-controls": restProps.ariaControls,
        "aria-haspopup": restProps.ariaHasPopup ?? true
    });
};

});
parcelRegister("59KYj", function(module, exports) {

$parcel$export(module.exports, "ResponsiveThemedButton", () => $04660f59ffb4326c$export$6f42949f4ea1e733);
/* ResponsiveThemedButton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $2rqOp = parcelRequire("2rqOp");

var $f5TWP = parcelRequire("f5TWP");

var $1kVqg = parcelRequire("1kVqg");
var $oGXFy = parcelRequire("oGXFy");

var $3bDjY = parcelRequire("3bDjY");
const $04660f59ffb4326c$export$4161299bcae84c4f = 'responsive-themed-button';
const $04660f59ffb4326c$export$6f42949f4ea1e733 = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, ...props }, ref)=>{
    const { icon: icon, label: label, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04660f59ffb4326c$var$CustomButton, {
        ...restProps,
        as: as,
        ref: !isAboveBreakpoint ? ref : undefined,
        appearance: appearance ?? 'default',
        iconBefore: icon,
        testId: `${testId ?? $04660f59ffb4326c$export$4161299bcae84c4f}.collapsed`,
        "aria-label": ariaLabel || label
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint ?? 'lg'
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($04660f59ffb4326c$var$CustomButton, {
        ...restProps,
        as: as,
        ref: isAboveBreakpoint ? ref : undefined,
        appearance: appearance ?? 'default',
        iconBefore: icon,
        testId: `${testId ?? $04660f59ffb4326c$export$4161299bcae84c4f}.expanded`,
        "aria-label": ariaLabel || label
    }, label)));
}));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $04660f59ffb4326c$var$CustomButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $2rqOp.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1qt3kjry _1g9h1tex _1umfuwj9 _6l8r3x59 _9se5176f _12rallho _zk5uzt2a _18vg2zyf _192e1jcw _fnp717ga _1xjgvy9e _jeiefrbu _nkzo1ag4 _1u0u14e8 _17z218zq _7n83frbu _n2ul1jo4 _1cf1r7td _1d7c1ag4 _nwukvy9e _fsjd4zrn _z1i3eyly",
            __cmplp.className
        ])
    });
});

});

parcelRegister("iIMX5", function(module, exports) {

$parcel$export(module.exports, "default", () => $77495ee3efb7180c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $77495ee3efb7180c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.view-settings-button.button-label",
        "defaultMessage": "View settings"
    }
});

});


parcelRegister("2ucDS", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsMenu", () => $24ad572d0ea302a2$export$14138a347411ebf);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $3uPqt = parcelRequire("3uPqt");

var $jlxRF = parcelRequire("jlxRF");

var $140hX = parcelRequire("140hX");

var $1ESRw = parcelRequire("1ESRw");
const $24ad572d0ea302a2$export$14138a347411ebf = ({ boardId: boardId, isClassic: isClassic, view: view, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, showEpicAsPanel: showEpicAsPanel, isVersionsEnabled: isVersionsEnabled, epicCustomName: epicCustomName = 'Epic', showFilterBarToggle: showFilterBarToggle = false, showCardDetails: showCardDetails = true, areSubtasksEnabled: areSubtasksEnabled = false, showWorkSuggestions: showWorkSuggestions = false, onSubtasksExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, isSwimlanesEnabled: isSwimlanesEnabled = false, onSwimlaneExpandAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, isDaysInColumnEnabled: isDaysInColumnEnabled = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, cardExtraFields: cardExtraFields = [], isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, dependencyIssueOptions: dependencyIssueOptions = {}, disableScrollbar: disableScrollbar = false, onUpdate: onUpdate = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onClose: onClose, analyticsData: analyticsData, isShowBoardNameEnabled: isShowBoardNameEnabled })=>{
    const sendAnalyticsEvent = (0, $3uPqt.useSendAnalyticsEvent)();
    const handleChange = (actionSubject, attributes)=>{
        sendAnalyticsEvent((0, $4cYhQ.Action).CLICKED, actionSubject, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    const incrementPlanningHandleChange = (actionSubject, attributes, action)=>{
        sendAnalyticsEvent(action ?? (0, $4cYhQ.Action).CLICKED, actionSubject, (0, $4cYhQ.AnalyticsEvent).UI_EVENT, {
            ...attributes,
            isClassic: isClassic
        }, view);
    };
    switch(view){
        case (0, $a4XJc.View).BACKLOG:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jlxRF.BacklogMenu), {
                viewAs: viewAs,
                boardId: boardId,
                onHandleChange: handleChange,
                showCardDetails: showCardDetails,
                isClassic: isClassic,
                isVersionsEnabled: isVersionsEnabled,
                showEpicAsPanel: showEpicAsPanel,
                showFilterBarToggle: showFilterBarToggle,
                epicCustomName: epicCustomName,
                areSubtasksEnabled: areSubtasksEnabled,
                areAllSubtasksExpanded: areAllSubtasksExpanded,
                areAllSubtasksCollapsed: areAllSubtasksCollapsed,
                onSubtasksExpandAll: onSubtasksExpandAll,
                onSubtasksCollapseAll: onSubtasksCollapseAll,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isPriorityEnabled: isPriorityEnabled,
                isShowBoardNameEnabled: isShowBoardNameEnabled
            });
        case (0, $a4XJc.View).BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $140hX.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isClassic: isClassic,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                showFilterBarToggle: showFilterBarToggle,
                showLinkedIssueStatsToggle: showLinkedIssueStatsToggle,
                showCardDetails: showCardDetails,
                epicCustomName: epicCustomName,
                isDaysInColumnEnabled: isDaysInColumnEnabled,
                cardExtraFields: cardExtraFields,
                isEstimateEnabled: isEstimateEnabled,
                isDueDateEnabled: isDueDateEnabled,
                isLabelsEnabled: isLabelsEnabled,
                isPriorityEnabled: isPriorityEnabled,
                isDevelopmentEnabled: isDevelopmentEnabled,
                showWorkSuggestions: showWorkSuggestions,
                onToggleWorkSuggestions: onToggleWorkSuggestions,
                isWorkSuggestionsEnabled: isWorkSuggestionsEnabled,
                onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
                onShowCardCoversToggledOn: onShowCardCoversToggledOn
            });
        case (0, $a4XJc.View).JSM_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $140hX.BoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                onHandleChange: handleChange,
                showFilterBarToggle: showFilterBarToggle,
                showCardDetails: false,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll
            });
        case (0, $a4XJc.View).INCREMENT_PLANNING_BOARD:
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1ESRw.IncrementPlanningBoardMenu), {
                viewAs: viewAs,
                boardId: boardId,
                isSwimlanesEnabled: isSwimlanesEnabled,
                dependencyIssueOptions: dependencyIssueOptions,
                onHandleChange: incrementPlanningHandleChange,
                onSwimlaneExpandAll: onSwimlaneExpandAll,
                onSwimlaneCollapseAll: onSwimlaneCollapseAll,
                onUpdate: onUpdate,
                epicCustomName: epicCustomName,
                onClose: onClose,
                disableScrollbar: disableScrollbar,
                analyticsData: analyticsData
            });
        default:
            return null;
    }
};

});
parcelRegister("jlxRF", function(module, exports) {

$parcel$export(module.exports, "BacklogMenu", () => $61210b60d484d0b3$export$baf646a48a139934);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jldZL = parcelRequire("jldZL");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $5oFIy = parcelRequire("5oFIy");

var $duOMW = parcelRequire("duOMW");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $1wNfX = parcelRequire("1wNfX");

var $e2hHN = parcelRequire("e2hHN");

var $9EmtZ = parcelRequire("9EmtZ");

var $htuq0 = parcelRequire("htuq0");

var $cYeCp = parcelRequire("cYeCp");

var $iDGXn = parcelRequire("iDGXn");

var $evv5v = parcelRequire("evv5v");

var $lWTHR = parcelRequire("lWTHR");
const $61210b60d484d0b3$export$baf646a48a139934 = ({ viewAs: viewAs, boardId: boardId, isClassic: isClassic, isVersionsEnabled: isVersionsEnabled, showEpicAsPanel: showEpicAsPanel, showFilterBarToggle: showFilterBarToggle = false, epicCustomName: epicCustomName = 'Epic', areSubtasksEnabled: areSubtasksEnabled = false, areAllSubtasksExpanded: areAllSubtasksExpanded = false, areAllSubtasksCollapsed: areAllSubtasksCollapsed = false, showCardDetails: showCardDetails = true, isEstimateEnabled: isEstimateEnabled = false, onHandleChange: onHandleChange, onSubtasksExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksExpandAll = ()=>{}, onSubtasksCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSubtasksCollapseAll = ()=>{}, cardExtraFields: cardExtraFields = [], isDueDateEnabled: isDueDateEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isShowBoardNameEnabled: isShowBoardNameEnabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const Section = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $e2hHN.PanelSection) : (0, $9UCCQ.default);
    const Group = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $1wNfX.PanelGroup) : (0, $eZUJu.default);
    const cardDetailsTitle = viewAs === (0, $a4XJc.ViewAs).PANEL ? formatMessage((0, $cACY7.default).cardFields) : formatMessage((0, $cACY7.default).cardDetails);
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowStatuses: toggleShowStatuses, toggleShowVersions: toggleShowVersions, setViewSettingsCompactMode: setViewSettingsCompactMode, toggleExtraField: toggleExtraField, toggleShowDueDate: toggleShowDueDate } = actions;
    const hasCardExtraFields = cardExtraFields.length > 0;
    const fields = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueTypeIssueTermRefresh : (0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueKeyIssueTermRefresh : (0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), isVersionsEnabled && isClassic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showVersionsToggle,
        title: formatMessage((0, $cACY7.default).cardDetailVersion),
        onChange: ()=>{
            toggleShowVersions({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_VERSIONS_TOGGLE,
                state: !state.showVersions
            });
        },
        isChecked: state.showVersions,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && isDueDateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showDueDateToggle,
        title: formatMessage((0, $cACY7.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showStatusToggle,
        title: formatMessage((0, $cACY7.default).cardDetailStatus),
        onChange: ()=>{
            toggleShowStatuses({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_STATUSES_TOGGLE,
                state: !state.showStatuses
            });
        },
        isChecked: state.showStatuses,
        viewAs: viewAs
    }), (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isEstimateEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEstimateToggle,
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showPriorityToggle,
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, isVersionsEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showVersionPanelToggle,
        title: formatMessage((0, $cACY7.default).versionPanel),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).VERSION_PANEL
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).VERSION_PANEL_TOGGLE,
                state: !state.showVersionPanel
            });
        },
        keyboardShortcut: (0, $a4XJc.KeyboardShortcut).VERSION_PANEL_SHORTCUT,
        isChecked: state.showVersionPanel,
        viewAs: viewAs
    }), showEpicAsPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showEpicPanelToggle,
        title: formatMessage((0, $cACY7.default).epicPanel, {
            epicName: epicCustomName
        }),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).EPIC_PANEL
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).EPIC_PANEL_TOGGLE,
                state: !state.showEpicPanel
            });
        },
        keyboardShortcut: (0, $a4XJc.KeyboardShortcut).ISSUE_PARENT_PANEL_SHORTCUT,
        isChecked: state.showEpicPanel,
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $cACY7.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), isShowBoardNameEnabled && (0, $6s1PB.expValEquals)('surface_origin_board_on_sprint_containers', 'cohort', 'test') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showBoardNameToggle,
        title: formatMessage((0, $cACY7.default).boardName),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).SHOW_BOARD_NAME
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_BOARD_NAME,
                state: !state.showBoardName
            });
        },
        isChecked: state.showBoardName,
        viewAs: viewAs
    }), viewAs === (0, $a4XJc.ViewAs).PANEL ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).cardDensity),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).cardLayoutSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9EmtZ.ViewSettingsRadioGroup), {
        testId: (0, $duOMW.backlogViewTestIds).cardLayoutRadioGroup,
        onSelect: (value)=>{
            setViewSettingsCompactMode({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                showCompactMode: value === 'compact'
            });
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).CARD_DENSITY,
                state: value
            });
        },
        value: state.showCompactMode ? 'compact' : 'default',
        options: [
            {
                name: 'card-layout',
                value: 'default',
                label: 'Default',
                icon: (0, $lWTHR.CardLayoutDefaultIcon)
            },
            {
                name: 'card-layout',
                value: 'compact',
                label: 'Compact',
                icon: (0, $evv5v.CardLayoutCompactIcon)
            }
        ],
        viewAs: viewAs,
        ariaLabel: formatMessage((0, $cACY7.default).cardDensity)
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.backlogViewTestIds).showCompactModeToggle,
        title: formatMessage((0, $cACY7.default).compactMode),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BACKLOG,
                setting: (0, $9pP0g.ViewSetting).COMPACT_MODE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).COMPACT_MODE_TOGGLE,
                state: !state.showCompactMode
            });
        },
        isChecked: state.showCompactMode,
        viewAs: viewAs
    })), areSubtasksEnabled && viewAs !== (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $cACY7.default).expandAllSubtasks)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $cACY7.default).collapseAllSubtasks))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.backlogViewTestIds).cardDetailsSection,
        title: cardDetailsTitle,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, cardDetailsTitle)), fields)), hasCardExtraFields && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.backlogViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.backlog.show-${field.id}-toggle-backlog`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $a4XJc.View).BACKLOG,
                    fieldId: field.id
                });
                onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                    key: `${(0, $4cYhQ.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), areSubtasksEnabled && viewAs === (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).subtasks),
        hasSeparator: true,
        "data-testId": (0, $duOMW.backlogViewTestIds).subtaskSection
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $61210b60d484d0b3$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskExpandAll,
        isDisabled: areAllSubtasksExpanded,
        onClick: ()=>{
            onSubtasksExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).expandAllSubtasks))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        testId: (0, $duOMW.backlogViewTestIds).subtaskCollapseAll,
        isDisabled: areAllSubtasksCollapsed,
        onClick: ()=>{
            onSubtasksCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SUBTASKS_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).collapseAllSubtasks)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $61210b60d484d0b3$var$buttonItemContainerPanelModeStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("cACY7", function(module, exports) {

$parcel$export(module.exports, "default", () => $32380dcb5ffcf2df$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $32380dcb5ffcf2df$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software-view-settings.common.button-label",
        "defaultMessage": "View settings"
    },
    panelSection: {
        "id": "software-view-settings.common.panel-section",
        "defaultMessage": "Panels"
    },
    versionPanel: {
        "id": "software-view-settings.common.version-panel",
        "defaultMessage": "Version panel"
    },
    epicPanel: {
        "id": "software-view-settings.common.epic-panel",
        "defaultMessage": "{epicName} panel"
    },
    generalViewSettings: {
        "id": "software-view-settings.general-settings",
        "defaultMessage": "General view settings"
    },
    quickFilters: {
        "id": "software-view-settings.common.quick-filters",
        "defaultMessage": "Quick filters"
    },
    workSuggestions: {
        "id": "software-view-settings.common.work-suggestions",
        "defaultMessage": "Work suggestions"
    },
    compactMode: {
        "id": "software-view-settings.common.compact-mode",
        "defaultMessage": "Compact mode"
    },
    cardDetails: {
        "id": "software-view-settings.common.card-details",
        "defaultMessage": "Card details"
    },
    cardFields: {
        "id": "software-view-settings.common.card-fields",
        "defaultMessage": "Fields"
    },
    cardDetailVersion: {
        "id": "software-view-settings.common.card-detail-version",
        "defaultMessage": "Version"
    },
    cardDetailStatus: {
        "id": "software-view-settings.common.card-detail-status",
        "defaultMessage": "Status"
    },
    cardDetailIssueType: {
        "id": "software-view-settings.common.card-detail-issue-type",
        "defaultMessage": "Issue type"
    },
    cardDetailIssueKey: {
        "id": "software-view-settings.common.card-detail-issue-key",
        "defaultMessage": "Issue key"
    },
    cardDetailEstimate: {
        "id": "software-view-settings.common.card-detail-estimate",
        "defaultMessage": "Estimate"
    },
    cardDetailPriority: {
        "id": "software-view-settings.common.card-detail-priority",
        "defaultMessage": "Priority"
    },
    cardDetailDevelopment: {
        "id": "software-view-settings.common.card-detail-development",
        "defaultMessage": "Development"
    },
    cardDetailAssignee: {
        "id": "software-view-settings.common.card-detail-assignee",
        "defaultMessage": "Assignee"
    },
    swimlanes: {
        "id": "software-view-settings.common.swimlanes",
        "defaultMessage": "Swimlanes"
    },
    expandAll: {
        "id": "software-view-settings.common.expand-all",
        "defaultMessage": "Expand all"
    },
    collapseAll: {
        "id": "software-view-settings.common.collapse-all",
        "defaultMessage": "Collapse all"
    },
    expandAllSwimlanes: {
        "id": "software-view-settings.common.expand-all-swimlanes",
        "defaultMessage": "Expand all Swimlanes"
    },
    collapseAllSwimlanes: {
        "id": "software-view-settings.common.collapse-all-swimlanes",
        "defaultMessage": "Collapse all Swimlanes"
    },
    openIssuesInSidebar: {
        "id": "software-view-settings.common.open-issues-in-sidebar",
        "defaultMessage": "Open issues in sidebar"
    },
    subtasks: {
        "id": "software-view-settings.common.subtasks",
        "defaultMessage": "Subtasks"
    },
    expandAllSubtasks: {
        "id": "software-view-settings.common.expand-all-subtasks",
        "defaultMessage": "Expand all"
    },
    collapseAllSubtasks: {
        "id": "software-view-settings.common.collapse-all-subtasks",
        "defaultMessage": "Collapse all"
    },
    showUnscheduledWork: {
        "id": "software-view-settings.common.show-unscheduled-work",
        "defaultMessage": "Show unscheduled work"
    },
    cardLayout: {
        "id": "software-view-settings.common.card-layout",
        "defaultMessage": "Card layout"
    },
    cardDensity: {
        "id": "software-view-settings.common.card-density",
        "defaultMessage": "Density"
    },
    daysInColumn: {
        "id": "software-view-settings.common.days-in-column",
        "defaultMessage": "Days in column"
    },
    dueDate: {
        "id": "software-view-settings.common.due-date",
        "defaultMessage": "Due date"
    },
    labels: {
        "id": "software-view-settings.common.labels",
        "defaultMessage": "Labels"
    },
    linkedIssues: {
        "id": "software-view-settings.common.linked-issues",
        "defaultMessage": "Linked issues"
    },
    cardCovers: {
        "id": "software-view-settings.common.card-covers",
        "defaultMessage": "Cover images"
    },
    toggleHint: {
        "id": "software-view-settings.common.toggle-hint",
        "defaultMessage": "Press {key} to open and close {panel}"
    },
    beta: {
        "id": "software-view-settings.common.beta",
        "defaultMessage": "Beta"
    },
    maxDependenciesError: {
        "id": "software-view-settings.common.max-dependencies-error",
        "defaultMessage": "You can only show dependencies for {maxDeps, plural, one {# issue} other {# issues}} at one time"
    },
    maxDependenciesErrorIssueTermRefresh: {
        "id": "software-view-settings.common.max-dependencies-error-issue-term-refresh",
        "defaultMessage": "You can only show dependencies for {maxDeps, plural, one {# work item} other {# work items}} at one time"
    },
    cardDetailIssueTypeIssueTermRefresh: {
        "id": "software-view-settings.common.card-detail-issue-type-issue-term-refresh",
        "defaultMessage": "Work type"
    },
    cardDetailIssueKeyIssueTermRefresh: {
        "id": "software-view-settings.common.card-detail-issue-key-issue-term-refresh",
        "defaultMessage": "Work item key"
    },
    openIssuesInSidebarIssueTermRefresh: {
        "id": "software-view-settings.common.open-issues-in-sidebar-issue-term-refresh",
        "defaultMessage": "Open work items in sidebar"
    },
    linkedIssuesIssueTermRefresh: {
        "id": "software-view-settings.common.linked-issues-issue-term-refresh",
        "defaultMessage": "Linked work items"
    },
    boardName: {
        "id": "software-view-settings.common.board-name",
        "defaultMessage": "Board name"
    }
});

});

parcelRegister("1wNfX", function(module, exports) {

$parcel$export(module.exports, "PanelGroup", () => $95e55479a51ab212$export$1d05749f6f573bb);

var $5uXOq = parcelRequire("5uXOq");
const $95e55479a51ab212$export$1d05749f6f573bb = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);

});

parcelRegister("e2hHN", function(module, exports) {

$parcel$export(module.exports, "PanelSection", () => $52c1e5c9c03f984a$export$15906978feb79aa6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $l1N8i = parcelRequire("l1N8i");

var $4R6GH = parcelRequire("4R6GH");
const $52c1e5c9c03f984a$export$15906978feb79aa6 = ({ title: title, hasSeparator: hasSeparator, children: children, testId: testId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: title ? 'space.0' : 'space.050',
        testId: testId
    }, hasSeparator && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($52c1e5c9c03f984a$var$Separator, null), title && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $52c1e5c9c03f984a$var$textStyles
    }, (0, $4R6GH.fg)('jfp_a11y_scrum_backlog_heading') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: (0, $4R6GH.fg)('view-settings-title-size-fix') ? 'xsmall' : 'medium',
        as: (0, $4R6GH.fg)('view-settings-title-size-fix') ? 'h3' : undefined
    }, title) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, title)), children);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $52c1e5c9c03f984a$var$Separator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_x3dozgxb _19pk12x7 _otyr12x7",
            __cmplp.className
        ])
    });
});
const $52c1e5c9c03f984a$var$textStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100',
    paddingBottom: 'space.100'
});

});

parcelRegister("9EmtZ", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsRadioGroup", () => $4233393bcdedbcd3$export$1e1eee2ec7833bf1);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $jouoW = parcelRequire("jouoW");

var $a4XJc = parcelRequire("a4XJc");
const $4233393bcdedbcd3$export$1e1eee2ec7833bf1 = ({ options: options, value: value, onSelect: onSelect, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, ariaLabel: ariaLabel })=>{
    const onChange = (0, $5uXOq.useCallback)((e)=>{
        onSelect(e.target.value);
    }, [
        onSelect
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL ? $4233393bcdedbcd3$var$panelContainerStyles : $4233393bcdedbcd3$var$popupContainerStyles,
        testId: testId,
        role: "radiogroup",
        "aria-label": ariaLabel
    }, options.map((option)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
            xcss: $4233393bcdedbcd3$var$radioOptionContainerStyles,
            key: option.value
        }, option.value && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jouoW.default), {
            isChecked: option.value === value,
            onChange: onChange,
            name: option.name,
            label: option.label,
            value: option.value
        }), option.icon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $4233393bcdedbcd3$var$iconContainerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            glyph: option.icon,
            label: "",
            primaryColor: "var(--ds-icon-subtle, #626F86)"
        })))));
};
const $4233393bcdedbcd3$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: '0',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $4233393bcdedbcd3$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $4233393bcdedbcd3$var$radioOptionContainerStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.075',
    alignItems: 'center',
    justifyContent: 'space-between'
});
const $4233393bcdedbcd3$var$iconContainerStyles = (0, $8CUq3.xcss)({
    opacity: 0.3
});

});
parcelRegister("jouoW", function(module, exports) {

$parcel$export(module.exports, "default", () => $5d22fafff331be84$export$2e2bcd8739ae039);
/* radio.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $VSDnB = parcelRequire("VSDnB");
const $5d22fafff331be84$var$packageName = "platform-pkg";
const $5d22fafff331be84$var$packageVersion = "0.0.0-use.local";
const $5d22fafff331be84$var$noop = (0, $eGmKJ.default);
const $5d22fafff331be84$var$labelPaddingStyles = null;
const $5d22fafff331be84$var$labelStyles = null;
const $5d22fafff331be84$var$radioStyles = null;
const $5d22fafff331be84$var$newRadioStyles = null;
const $5d22fafff331be84$var$InnerRadio = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    const { ariaLabel: ariaLabel, isDisabled: isDisabled = false, isRequired: isRequired, isInvalid: isInvalid = false, isChecked: isChecked = false, label: label, name: name, onChange: onChange = $5d22fafff331be84$var$noop, value: value, testId: testId, analyticsContext: analyticsContext, // events and all other input props
    ...rest } = props;
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'radio',
        packageName: $5d22fafff331be84$var$packageName,
        packageVersion: $5d22fafff331be84$var$packageVersion
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("label", {
        "data-testid": testId && `${testId}--radio-label`,
        "data-disabled": isDisabled ? 'true' : undefined,
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c1txw _vchhusvi _kqswh2mm _4cvr1y6m _syazj3m3 _mqf81tvo _g7st13gf"
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                ...rest,
                tabIndex: 0,
                "aria-label": ariaLabel,
                checked: isChecked,
                disabled: isDisabled,
                name: name,
                onChange: onChangeAnalytics,
                required: isRequired,
                type: "radio",
                value: value,
                "data-testid": testId && `${testId}--radio-input`,
                // use :invalid selector
                "data-invalid": isInvalid ? 'true' : undefined,
                ref: ref,
                className: (0, $bwpsq.default)([
                    "_18s8ze3t _19it3vzd _2rko1q5u _12ji1r31 _1qu2glyw _12y31o36 _v56415j1 _1e0c1txw _1bsb1tcg _4t3i1tcg _kqswh2mm _4cvr1h6o _1bah1h6o _1o9zidpf _bfhk4t47 _13diglyw _1q6qmag2 _11511fmg _1s6w1qbb _tqbwidpf _t9ec1s1q _s7n4jp4b _wstuglyw _16r2ucr4 _14mj1q5u _qc5orqeg _z0ai1cbz _1qdg1cbz _18postnw _aetrb3bt _1peq1xmd _iosizyvw _11jyzyvw _f3ett94y _19ybk8x7 _1d7pk8x7 _j5dh13gf _scgf13gf _1gcs13gf _1x1a13gf _6hp813gf _4rya1y1w _o1bd1y1w _nxi61y1w _neoe1y1w _1el21y1w _lekrzcs9 _11v7zcs9 _1f8czcs9 _s2ftzcs9 _17a1zcs9 _x48a15t7 _1ib215t7 _1yk915t7 _gdmb15t7 _pmm415t7 _y2mvehbj _1bg4jfq9 _6tjkehbj _awqnjfq9 _1rvq10ko _1p9j1fmg _x2tzhh5a _1iwzhh5a _sj8y1wq0 _jckox2ru _1dvd1fmg _60ak1dzn",
                    (0, $VSDnB.fg)('platform-visual-refresh-icons') && "_t9ec1soj _z0ai120g _1qdg120g"
                ])
            }),
            label ? /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                className: (0, $bwpsq.default)([
                    "_85i5v77o _1q51v77o _y4ti1b66 _bozg1b66"
                ]),
                children: label
            }) : null
        ]
    });
}); /**
     * __Radio__
     *
     * A radio input allows users to select only one option from a number of choices. Radio is generally displayed in a radio group.
     *
     * - [Examples](https://atlassian.design/components/radio/examples)
     * - [Code](https://atlassian.design/components/radio/code)
     * - [Usage](https://atlassian.design/components/radio/usage)
     */ 
const $5d22fafff331be84$var$Radio = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Radio(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($5d22fafff331be84$var$InnerRadio, {
        ...props,
        ref: ref
    });
}));
var $5d22fafff331be84$export$2e2bcd8739ae039 = $5d22fafff331be84$var$Radio;

});


parcelRegister("htuq0", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsToggle", () => $5bf54757b2a57348$export$aacc18ae911f8e05);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $3u0c5 = parcelRequire("3u0c5");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $dTlW6 = parcelRequire("dTlW6");

var $dqoiX = parcelRequire("dqoiX");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $cACY7 = parcelRequire("cACY7");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $5bf54757b2a57348$export$aacc18ae911f8e05 = ({ title: title, isChecked: isChecked, isDisabled: isDisabled, onChange: onChange, keyboardShortcut: keyboardShortcut, subtitleLozenge: subtitleLozenge, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, footer: footer })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}`);
    const descriptionId = `${id}-description`;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $5bf54757b2a57348$var$panelContainerStyles : $5bf54757b2a57348$var$popupContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.200",
        spread: "space-between",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.100",
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        "data-testid": testId,
        htmlFor: id
    }, title), subtitleLozenge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), {
        appearance: "new"
    }, subtitleLozenge)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $dCm1o.isVisualRefreshEnabled)() ? $5bf54757b2a57348$var$tooltipContainerStyles : $5bf54757b2a57348$var$tooltipContainerStylesOld
    }, keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, keyboardShortcut), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        id: id,
        isChecked: isChecked,
        onChange: onChange,
        isDisabled: isDisabled,
        ...keyboardShortcut && {
            descriptionId: descriptionId
        }
    }), keyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: descriptionId
    }, formatMessage((0, $cACY7.default).toggleHint, {
        key: keyboardShortcut,
        panel: title
    })))), footer);
};
const $5bf54757b2a57348$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $5bf54757b2a57348$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.100',
    marginInline: 'auto',
    minWidth: '200px'
});
const $5bf54757b2a57348$var$tooltipContainerStylesOld = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0
});
const $5bf54757b2a57348$var$tooltipContainerStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtlest',
    whiteSpace: 'nowrap',
    // eslint-disable-next-line @atlaskit/design-system/use-tokens-typography
    lineHeight: 0,
    display: 'flex',
    alignItems: 'center'
});

});

parcelRegister("evv5v", function(module, exports) {

$parcel$export(module.exports, "CardLayoutCompactIcon", () => $ca4072fbbcba385a$export$73c305db8d999c47);
// SVG with custom colours

var $5uXOq = parcelRequire("5uXOq");
const $ca4072fbbcba385a$export$73c305db8d999c47 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "58",
        height: "28",
        viewBox: "0 0 58 28",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V9.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M57 10V18H59V10H57ZM1 18V10H-1V18H1Z",
        fill: "currentColor",
        mask: "url(#path-2-inside-1_1311_59)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 18.5H57.5V26C57.5 26.8284 56.8284 27.5 56 27.5H2C1.17157 27.5 0.5 26.8284 0.5 26V18.5Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "3",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "12",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "21",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "4",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "13",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "22",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});

parcelRegister("lWTHR", function(module, exports) {

$parcel$export(module.exports, "CardLayoutDefaultIcon", () => $f330d0d9ada9ffbb$export$b1c73e945668f4c2);
// SVG with custom colours

var $5uXOq = parcelRequire("5uXOq");
const $f330d0d9ada9ffbb$export$b1c73e945668f4c2 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "58",
        height: "27",
        viewBox: "0 0 58 27",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "data-testid": props['data-testid'],
        "aria-label": props['aria-label']
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 14H58H0ZM59 25C59 26.6569 57.6569 28 56 28H2C0.343146 28 -1 26.6569 -1 25H1C1 25.5523 1.44772 26 2 26H56C56.5523 26 57 25.5523 57 25H59ZM2 28C0.343146 28 -1 26.6569 -1 25V14H1V25C1 25.5523 1.44772 26 2 26V28ZM59 14V25C59 26.6569 57.6569 28 56 28V26C56.5523 26 57 25.5523 57 25V14H59Z",
        fill: "currentColor",
        mask: "url(#path-1-inside-1_1311_46)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0.5 2C0.5 1.17157 1.17157 0.5 2 0.5H56C56.8284 0.5 57.5 1.17157 57.5 2V13.5H0.5V2Z",
        stroke: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "5",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "5",
        y: "18",
        width: "4",
        height: "4",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "6",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        x: "12",
        y: "19",
        width: "41",
        height: "2",
        rx: "1",
        fill: "currentColor"
    }));

});


parcelRegister("140hX", function(module, exports) {

$parcel$export(module.exports, "BoardMenu", () => $0229f37a37892c4a$export$17445232de9c085a);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $jldZL = parcelRequire("jldZL");

var $aIZdc = parcelRequire("aIZdc");

var $6s1PB = parcelRequire("6s1PB");

var $axmY8 = parcelRequire("axmY8");

var $2DjOQ = parcelRequire("2DjOQ");

var $koVbs = parcelRequire("koVbs");

var $2gCtH = parcelRequire("2gCtH");

var $5oFIy = parcelRequire("5oFIy");

var $4R6GH = parcelRequire("4R6GH");

var $cSD7y = parcelRequire("cSD7y");

var $duOMW = parcelRequire("duOMW");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $1wNfX = parcelRequire("1wNfX");

var $e2hHN = parcelRequire("e2hHN");

var $htuq0 = parcelRequire("htuq0");

var $cYeCp = parcelRequire("cYeCp");

var $iDGXn = parcelRequire("iDGXn");
const $0229f37a37892c4a$export$17445232de9c085a = ({ viewAs: viewAs, boardId: boardId, showFilterBarToggle: showFilterBarToggle = false, showLinkedIssueStatsToggle: showLinkedIssueStatsToggle = false, isSwimlanesEnabled: isSwimlanesEnabled = false, showCardDetails: showCardDetails = true, epicCustomName: epicCustomName = 'Epic', onHandleChange: onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, onToggleWorkSuggestions: // eslint-disable-next-line @typescript-eslint/no-empty-function
onToggleWorkSuggestions = ()=>{}, onLinkedIssuesStatsToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onLinkedIssuesStatsToggledOn = ()=>{}, onShowCardCoversToggledOn: // eslint-disable-next-line @typescript-eslint/no-empty-function
onShowCardCoversToggledOn = ()=>{}, isClassic: isClassic = false, isDaysInColumnEnabled: isDaysInColumnEnabled = false, isEstimateEnabled: isEstimateEnabled = false, isDueDateEnabled: isDueDateEnabled = false, isLabelsEnabled: isLabelsEnabled = false, isPriorityEnabled: isPriorityEnabled = false, isDevelopmentEnabled: isDevelopmentEnabled = false, isWorkSuggestionsEnabled: isWorkSuggestionsEnabled = false, showWorkSuggestions: showWorkSuggestions = false, cardExtraFields: cardExtraFields = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const { view: view } = state;
    const { toggleViewSetting: toggleViewSetting, toggleShowEpics: toggleShowEpics, toggleShowLinkedIssuesStats: toggleShowLinkedIssuesStats, toggleShowDaysInColumn: toggleShowDaysInColumn, toggleShowDueDate: toggleShowDueDate, toggleExtraField: toggleExtraField, toggleShowLabels: toggleShowLabels } = actions;
    const viewMode = (0, $2gCtH.useViewMode)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, setDetailViewAsModal: setDetailViewAsModal }] = (0, $2gCtH.useIssueContextActions)();
    const Section = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $e2hHN.PanelSection) : (0, $9UCCQ.default);
    const Group = viewAs === (0, $a4XJc.ViewAs).PANEL ? (0, $1wNfX.PanelGroup) : (0, $eZUJu.default);
    const cardDetailsTitle = viewAs === (0, $a4XJc.ViewAs).PANEL ? formatMessage((0, $cACY7.default).cardFields) : formatMessage((0, $cACY7.default).cardDetails);
    const handleBoardViewModeClick = ()=>{
        if (viewMode === 'SIDEBAR') setDetailViewAsModal();
        else setDetailViewAsSidebar();
    };
    const hasCardExtraFields = cardExtraFields.length > 0;
    const handleLinkedIssuesStatsToggleChange = (0, $5uXOq.useCallback)(()=>{
        const showIssueLinksStatsState = state.showIssueLinksStats;
        toggleShowLinkedIssuesStats({
            boardId: boardId,
            view: (0, $a4XJc.View).BOARD
        });
        onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
            key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_LINKS_STATS,
            state: !showIssueLinksStatsState
        });
        // start fetching issue links stats if the user turned on toggle
        if (!showIssueLinksStatsState) onLinkedIssuesStatsToggledOn();
    }, [
        boardId,
        onHandleChange,
        onLinkedIssuesStatsToggledOn,
        state.showIssueLinksStats,
        toggleShowLinkedIssuesStats
    ]);
    const handleShowCardCoversToggleChange = (0, $5uXOq.useCallback)(()=>{
        const showCardCoversState = state.showCardCovers;
        toggleViewSetting({
            boardId: boardId,
            view: (0, $a4XJc.View).BOARD,
            setting: (0, $9pP0g.ViewSetting).SHOW_CARD_COVERS
        });
        onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
            key: (0, $4cYhQ.ToggleKey).SHOW_CARD_COVERS,
            state: !state.showCardCovers
        });
        // start fetching card cover data if the user turned on toggle
        if (!showCardCoversState) onShowCardCoversToggledOn();
    }, [
        boardId,
        onHandleChange,
        onShowCardCoversToggledOn,
        state.showCardCovers,
        toggleViewSetting
    ]);
    const fields = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, view === (0, $a4XJc.View).BOARD && isClassic && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showCardCoversToggle,
        title: formatMessage((0, $cACY7.default).cardCovers),
        onChange: handleShowCardCoversToggleChange,
        isChecked: state.showCardCovers,
        viewAs: viewAs
    }), view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showIssueTypeToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueTypeIssueTermRefresh : (0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showIssueKeyToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).cardDetailIssueKeyIssueTermRefresh : (0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            });
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showEpicsToggle,
        title: epicCustomName,
        onChange: ()=>{
            toggleShowEpics({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            });
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), isDueDateEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDueDateToggle,
        title: formatMessage((0, $cACY7.default).dueDate),
        onChange: ()=>{
            toggleShowDueDate({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DUE_DATE,
                state: !state.showDueDate
            });
        },
        isChecked: state.showDueDate,
        viewAs: viewAs
    }), isLabelsEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showLabelsToggle,
        title: formatMessage((0, $cACY7.default).labels),
        onChange: ()=>{
            toggleShowLabels({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_LABELS,
                state: !state.showLabels
            });
        },
        isChecked: state.showLabels,
        viewAs: viewAs
    }), isEstimateEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showEstimateToggle,
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            });
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), isDaysInColumnEnabled && view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDaysInColumnToggle,
        title: formatMessage((0, $cACY7.default).daysInColumn),
        onChange: ()=>{
            toggleShowDaysInColumn({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DAYS_IN_COLUMN,
                state: !state.showDaysInColumn
            });
        },
        isChecked: state.showDaysInColumn,
        viewAs: viewAs
    }), showLinkedIssueStatsToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showLinkedIssueStatsToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).linkedIssuesIssueTermRefresh : (0, $cACY7.default).linkedIssues),
        onChange: handleLinkedIssuesStatsToggleChange,
        isChecked: state.showIssueLinksStats,
        viewAs: viewAs
    }), view === (0, $a4XJc.View).BOARD && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDevelopmentEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showDevelopmentToggle,
        title: formatMessage((0, $cACY7.default).cardDetailDevelopment),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_DEVELOPMENT
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_DEVELOPMENT,
                state: !state.showDevelopment
            });
        },
        isChecked: state.showDevelopment,
        viewAs: viewAs
    }), isPriorityEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showPriorityToggle,
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            });
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showAssigneeToggle,
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            });
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Group, {
        "data-testId": (0, $duOMW.boardViewTestIds).viewSettingsBoardMenu
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0229f37a37892c4a$var$ConditionalFieldSet, null, (0, $4R6GH.fg)('tanuki_a11y_q4') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, formatMessage((0, $cACY7.default).generalViewSettings))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).openIssuesInSidebarToggle,
        title: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).openIssuesInSidebarIssueTermRefresh : (0, $cACY7.default).openIssuesInSidebar),
        onChange: ()=>{
            handleBoardViewModeClick();
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).OPEN_ISSUES_IN_SIDEBAR_TOGGLE,
                state: viewMode === 'SIDEBAR' ? (0, $a4XJc.ViewLocation).MODAL : (0, $a4XJc.ViewLocation).SIDEBAR
            });
        },
        isChecked: viewMode === 'SIDEBAR',
        viewAs: viewAs
    }), showFilterBarToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showQuickFiltersToggle,
        title: formatMessage((0, $cACY7.default).quickFilters),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).BOARD,
                setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).QUICK_FILTERS_TOGGLE,
                state: !state.showQuickFilters
            });
        },
        isChecked: state.showQuickFilters,
        viewAs: viewAs
    }), !(0, $aIZdc.isFedRamp)() && showWorkSuggestions && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0229f37a37892c4a$var$WorkSuggestionsSpotlightTarget, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2DjOQ.ViewSettingsTogglePulse), {
        isPanelView: viewAs === (0, $a4XJc.ViewAs).PANEL
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: (0, $duOMW.boardViewTestIds).showWorkSuggestionsToggle,
        title: formatMessage((0, $cACY7.default).workSuggestions),
        onChange: (_, analyticsEvent)=>{
            onToggleWorkSuggestions(analyticsEvent);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).WORK_SUGGESTIONS_TOGGLE,
                state: !isWorkSuggestionsEnabled
            });
        },
        isChecked: isWorkSuggestionsEnabled,
        viewAs: viewAs
    }))))), isSwimlanesEnabled && viewAs !== (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        }
    }, formatMessage((0, $cACY7.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        }
    }, formatMessage((0, $cACY7.default).collapseAll))), showCardDetails && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.boardViewTestIds).cardDetailsSection,
        title: cardDetailsTitle,
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, cardDetailsTitle)), fields)), hasCardExtraFields && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        testId: (0, $duOMW.boardViewTestIds).customFieldsSection,
        hasSeparator: true
    }, cardExtraFields.map((field)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
            key: field.id,
            testId: `software-view-settings.ui.view-settings-menu.views.board.show-${field.id}-toggle-board`,
            title: field.label,
            onChange: ()=>{
                toggleExtraField({
                    boardId: boardId,
                    view: (0, $a4XJc.View).BOARD,
                    fieldId: field.id
                });
                onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                    key: `${(0, $4cYhQ.ToggleKey).SHOW_EXTRA_FIELD}_${field.id}`,
                    state: !state.cardExtraFields[field.id]
                });
            },
            isChecked: state.cardExtraFields[field.id],
            viewAs: viewAs
        }))), isSwimlanesEnabled && viewAs === (0, $a4XJc.ViewAs).PANEL && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Section, {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $0229f37a37892c4a$var$buttonItemContainerPanelModeStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneExpandAll,
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            });
        },
        "aria-label": (0, $4R6GH.fg)('jfp_a11y_team_scrum_board_non_descriptive_label') ? formatMessage((0, $cACY7.default).expandAllSwimlanes) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).expandAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": (0, $duOMW.boardViewTestIds).swimlaneCollapseAll,
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            });
        },
        "aria-label": (0, $4R6GH.fg)('jfp_a11y_team_scrum_board_non_descriptive_label') ? formatMessage((0, $cACY7.default).collapseAllSwimlanes) : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingInline: "space.100"
    }, formatMessage((0, $cACY7.default).collapseAll)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            viewSettingsState: state
        }
    }));
};
const $0229f37a37892c4a$var$ConditionalFieldSet = (0, $cSD7y.componentWithFG)('tanuki_a11y_q4', ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", null, children), ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children));
const $0229f37a37892c4a$var$WorkSuggestionsSpotlightTarget = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME)
    }, children);
const $0229f37a37892c4a$var$buttonItemContainerPanelModeStyles = (0, $8CUq3.xcss)({
    position: 'relative',
    left: '-24px',
    width: 'calc(100% + 48px)'
});

});
parcelRegister("2DjOQ", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsTogglePulse", () => $1beb4c3f15b5459d$export$1cb4eacfdb188bc8);

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1v6HV = parcelRequire("1v6HV");
const $1beb4c3f15b5459d$var$PULSE_DURATION = 7950;
const $1beb4c3f15b5459d$export$1cb4eacfdb188bc8 = ({ children: children, isPanelView: isPanelView })=>{
    const [{ viewSettingsTogglePulses: viewSettingsTogglePulses }, { setViewSettingsTogglePulses: setViewSettingsTogglePulses }] = (0, $1v6HV.useBoardWorkSuggestionsSpotlightContainer)();
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            setViewSettingsTogglePulses(false);
        }, $1beb4c3f15b5459d$var$PULSE_DURATION);
        return ()=>{
            clearTimeout(timeoutId);
            setViewSettingsTogglePulses(false);
        };
    }, [
        setViewSettingsTogglePulses
    ]);
    if (!viewSettingsTogglePulses) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    return isPanelView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$negativePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$positivePadding
    }, children))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$positivePadding
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 5
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $1beb4c3f15b5459d$var$negativePadding
    }, children)));
};
const $1beb4c3f15b5459d$var$negativePadding = (0, $8CUq3.xcss)({
    marginLeft: 'space.negative.050',
    marginRight: 'space.negative.050'
});
const $1beb4c3f15b5459d$var$positivePadding = (0, $8CUq3.xcss)({
    marginLeft: 'space.050',
    marginRight: 'space.050'
});

});


parcelRegister("1ESRw", function(module, exports) {

$parcel$export(module.exports, "IncrementPlanningBoardMenu", () => $6f58092168c61151$export$9a207652c43c8852);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $42CjB = parcelRequire("42CjB");

var $820Wv = parcelRequire("820Wv");

var $5qRwM = parcelRequire("5qRwM");

var $e4yMr = parcelRequire("e4yMr");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $jldZL = parcelRequire("jldZL");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $5Zxxp = parcelRequire("5Zxxp");

var $koVbs = parcelRequire("koVbs");

var $hsmeR = parcelRequire("hsmeR");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $cACY7 = parcelRequire("cACY7");

var $4cYhQ = parcelRequire("4cYhQ");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $kfO2I = parcelRequire("kfO2I");

var $htuq0 = parcelRequire("htuq0");

var $iDGXn = parcelRequire("iDGXn");

var $bkrRB = parcelRequire("bkrRB");
// for the view settings menu. This has been moved back to the menuGroup when rolling out jpo_a11y_pb_fixes.
// The parent wrapping div and this style can be deleted when jpo_a11y_pb_fixes is being cleaned up.
const $6f58092168c61151$var$styles = {
    menuGroupWrapper: "_c71l1ogm"
};
const $6f58092168c61151$var$MAX_OPTIONS_LENGTH = 20;
const $6f58092168c61151$var$InfoIconWithTooltip = ({ tooltipContent: tooltipContent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6f58092168c61151$var$infoIconWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($820Wv))),
        label: tooltipContent,
        appearance: "subtle",
        isTooltipDisabled: false,
        spacing: "compact"
    }));
const $6f58092168c61151$var$MAX_SELECTED_ISSUES = 10;
const $6f58092168c61151$export$9a207652c43c8852 = ({ viewAs: viewAs, boardId: boardId, isSwimlanesEnabled: isSwimlanesEnabled = false, epicCustomName: epicCustomName = 'Epic', disableScrollbar: disableScrollbar = false, onHandleChange: // hide scrollbar for storybook
onHandleChange, onSwimlaneExpandAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneExpandAll = ()=>{}, onSwimlaneCollapseAll: // eslint-disable-next-line @typescript-eslint/no-empty-function
onSwimlaneCollapseAll = ()=>{}, dependencyIssueOptions: dependencyIssueOptions = {}, onUpdate: // eslint-disable-next-line @typescript-eslint/no-empty-function
onUpdate = ()=>{}, onClose: onClose, analyticsData: analyticsData })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [state, actions] = (0, $iDGXn.useViewSettings)();
    const rightPanelState = (0, $hsmeR.useActiveRightSidebarState)();
    const issueOptions = (0, $5uXOq.useMemo)(()=>Object.values(dependencyIssueOptions).map((issue)=>({
                value: issue.id,
                label: `${issue.key} ${issue.summary}`,
                iconUrl: issue.typeUrl
            })), [
        dependencyIssueOptions
    ]);
    const [slicedOptions, setSlicedOptions] = (0, $5uXOq.useState)(issueOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(rightPanelState?.panelId)) onUpdate();
    }, [
        rightPanelState?.panelId,
        onUpdate
    ]);
    const { setShowUnscheduledColumn: setShowUnscheduledColumn, setShowOfftrackDependencyLines: setShowOfftrackDependencyLines, setIssueIdsToShowDependencies: setIssueIdsToShowDependencies, toggleViewSetting: toggleViewSetting } = actions;
    const onFormatOptionLabel = (option, formatOptionLabelMeta)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.050",
            alignBlock: "start"
        }, option.iconUrl && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: formatOptionLabelMeta.context === 'menu' ? $6f58092168c61151$var$menuIconStyles : $6f58092168c61151$var$valueIconStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5qRwM.default), {
            src: option.iconUrl,
            alt: ""
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, option.label));
    };
    const selectedIssueOptions = (0, $5uXOq.useMemo)(()=>{
        if (Array.isArray(state.issueIdsToShowDependencies)) {
            const tempDefaultIssueOptions = [];
            state.issueIdsToShowDependencies.forEach((issueId)=>{
                const issue = dependencyIssueOptions[issueId];
                if (issue) tempDefaultIssueOptions.push({
                    value: issue.id,
                    label: `${issue.key} ${issue.summary}`,
                    iconUrl: issue.typeUrl
                });
            });
            return tempDefaultIssueOptions;
        }
        return [];
    }, [
        state.issueIdsToShowDependencies,
        dependencyIssueOptions
    ]);
    const onInputChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action === 'input-change') {
            if (newValue.trim().length === 0) setSlicedOptions(issueOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
            else {
                const filteredInOptions = issueOptions.filter((o)=>(o?.label || '').toLowerCase().includes(newValue.toLowerCase()));
                setSlicedOptions(filteredInOptions.slice(0, $6f58092168c61151$var$MAX_OPTIONS_LENGTH));
            }
        }
    }, [
        issueOptions,
        setSlicedOptions
    ]);
    const getViewSettingsValidationMessage = ()=>{
        if (state.issueIdsToShowDependencies.length > $6f58092168c61151$var$MAX_SELECTED_ISSUES) return formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $cACY7.default).maxDependenciesErrorIssueTermRefresh : (0, $cACY7.default).maxDependenciesError, {
            maxDeps: $6f58092168c61151$var$MAX_SELECTED_ISSUES
        });
        return undefined;
    };
    const getMenuGroupMaxHeight = (0, $5uXOq.useMemo)(()=>{
        if ((0, $4R6GH.fg)('jpo_a11y_pb_fixes')) return {
            maxHeight: 600
        };
        return !disableScrollbar && !(0, $4R6GH.fg)('issue_cards_in_program_board') ? // when issue_cards_in_program_board is true, the maxHeight is moved to the parent div
        {
            maxHeight: 500
        } : {};
    }, [
        disableScrollbar
    ]);
    const fields = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-type-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailIssueType),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_TYPE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_TYPE,
                state: !state.showIssueType
            });
        },
        isChecked: state.showIssueType,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-issue-key-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailIssueKey),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ISSUE_KEY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ISSUE_KEY,
                state: !state.showIssueKey
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showIssueKey,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-epics-toggle",
        title: epicCustomName,
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_EPICS
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_EPICS_TOGGLE,
                state: !state.showEpics
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showEpics,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-estimate-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailEstimate),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ESTIMATE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ESTIMATE,
                state: !state.showEstimate
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showEstimate,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-assignee-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailAssignee),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_ASSIGNEE
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_ASSIGNEE,
                state: !state.showAssignee
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showAssignee,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-status-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailStatus),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_STATUSES
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_STATUSES_TOGGLE,
                state: !state.showStatuses
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showStatuses,
        viewAs: viewAs
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-priority-toggle",
        title: formatMessage((0, $cACY7.default).cardDetailPriority),
        onChange: ()=>{
            toggleViewSetting({
                boardId: boardId,
                view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
                setting: (0, $9pP0g.ViewSetting).SHOW_PRIORITY
            });
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.ToggleKey).SHOW_PRIORITY,
                state: !state.showPriority
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showPriority,
        viewAs: viewAs
    }));
    const menuGroup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
        "data-testId": "software-view-settings.ui.view-settings-menu.menu-increment-planning-board",
        ...getMenuGroupMaxHeight
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.show-unscheduled-column-toggle",
        title: formatMessage((0, $cACY7.default).showUnscheduledWork),
        onChange: ()=>{
            setShowUnscheduledColumn(boardId, !state.showUnscheduledColumn);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).UNSCHEDULED_COLUMN_TOGGLE,
                state: !state.showUnscheduledColumn
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showUnscheduledColumn,
        viewAs: viewAs
    })), isSwimlanesEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $cACY7.default).swimlanes),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.expand-all",
        onClick: ()=>{
            onSwimlaneExpandAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_EXPAND_ALL,
                state: (0, $a4XJc.ExpandableState).EXPANDED
            }, (0, $4cYhQ.Action).CLICKED);
        }
    }, formatMessage((0, $cACY7.default).expandAll)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.collapse-all",
        onClick: ()=>{
            onSwimlaneCollapseAll();
            onHandleChange((0, $4cYhQ.ActionSubject).BUTTON, {
                key: (0, $4cYhQ.ToggleKey).SWIMLANE_COLLAPSE_ALL,
                state: (0, $a4XJc.ExpandableState).COLLAPSED
            }, (0, $4cYhQ.Action).CLICKED);
        }
    }, formatMessage((0, $cACY7.default).collapseAll))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $bkrRB.default).dependencyLinesSection),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htuq0.ViewSettingsToggle), {
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.offtrack-dependencies-toggle",
        title: formatMessage((0, $bkrRB.default).showOfftrackDependencyLines),
        onChange: ()=>{
            setShowOfftrackDependencyLines(boardId, !state.showOfftrackDependencyLines);
            onHandleChange((0, $4cYhQ.ActionSubject).TOGGLE, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).SHOW_OFFTRACK_DEPENDENCY_LINES,
                state: !state.showOfftrackDependencyLines
            }, (0, $4cYhQ.Action).CLICKED);
        },
        isChecked: state.showOfftrackDependencyLines,
        viewAs: viewAs,
        footer: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Zxxp.default), {
            articleId: (0, $4jAPy.IPH_IDS).OFFTRACK_DEPENDENCIES,
            appearance: "link",
            spacing: "none",
            fallbackComponent: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: (0, $4jAPy.DOC_LINKS).OFFTRACK_DEPENDENCIES,
                target: "_blank"
            }, formatMessage((0, $bkrRB.default).offtrackDependenciesHelpLink)),
            onClick: (event)=>{
                event.stopPropagation();
                onClose && onClose(event);
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            color: "color.text.accent.blue"
        }, formatMessage((0, $bkrRB.default).offtrackDependenciesHelpLink)))
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $6f58092168c61151$var$selectWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfO2I.ViewSettingsSelect), {
        title: formatMessage((0, $bkrRB.default).showDependenciesOnIssues),
        titleIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f58092168c61151$var$InfoIconWithTooltip, {
            tooltipContent: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bkrRB.default).onlyShowScheduledIssueDependencyLinesTooltipIssueTermRefresh : (0, $bkrRB.default).onlyShowScheduledIssueDependencyLinesTooltip)
        }),
        testId: "software-view-settings.ui.view-settings-menu.views.increment-planning-board.dependency-lines-select",
        isMulti: true,
        isSearchable: true,
        options: slicedOptions,
        formatOptionLabel: onFormatOptionLabel,
        viewAs: viewAs,
        value: selectedIssueOptions,
        placeholder: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $bkrRB.default).chooseIssueIssueTermRefresh : (0, $bkrRB.default).chooseIssue),
        isInvalid: state.issueIdsToShowDependencies.length > $6f58092168c61151$var$MAX_SELECTED_ISSUES,
        validationErrorMessage: getViewSettingsValidationMessage(),
        menuIsOpen: // undefined is default value for menuIsOpen prop where it's controlled by the click. Setting it to false will prevent the menu from opening
        state.issueIdsToShowDependencies.length <= $6f58092168c61151$var$MAX_SELECTED_ISSUES ? undefined : false,
        menuPlacement: "auto" // menuPlacement is to ensure the dropdown is repositioned based on the window height
        ,
        onInputChange: onInputChange,
        onChange: (selectedOptions, actionMeta)=>{
            let selectedIssueIds = [];
            if (Array.isArray(selectedOptions)) selectedIssueIds = selectedOptions.map((option)=>option.value);
            else if (selectedOptions && 'value' in selectedOptions) selectedIssueIds = selectedOptions ? [
                selectedOptions.value
            ] : [];
            setIssueIdsToShowDependencies(boardId, selectedIssueIds);
            const id = actionMeta.action === 'select-option' ? actionMeta?.option?.value : actionMeta.removedValue?.value;
            const issue = analyticsData?.issuesWithLinksById[id ?? ''];
            const issueLinks = issue?.issueLinks;
            const attributes = (0, $bdYfL.getIssueLinksAnalytics)(issueLinks, id, analyticsData?.issueLinkTypes, analyticsData?.issuesWithLinksById, analyticsData?.issueTypes);
            onHandleChange((0, $4cYhQ.ActionSubject).SELECT, {
                key: (0, $4cYhQ.IncrementPlanningAnalyticsKey).ISSUE_IDS_TO_SHOW_DEPENDENCIES,
                NumberOfCardDependencies: issue?.issueLinks?.length || 0,
                ToggledOn: actionMeta.action === 'select-option',
                isScenarioIssue: (0, $bdYfL.isScenarioIssue)(id),
                ...attributes
            }, (0, $4cYhQ.Action).CHANGED);
        }
    }))), (0, $4R6GH.fg)('issue_cards_in_program_board') && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        title: formatMessage((0, $cACY7.default).cardFields),
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", {
        "data-testid": "software-view-settings.ui.view-settings-menu.views.increment-planning-board.fieldset"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), null, formatMessage((0, $cACY7.default).cardFields))), fields)));
    return (0, $4R6GH.fg)('issue_cards_in_program_board') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        className: (0, $bwpsq.default)([
            $6f58092168c61151$var$styles.menuGroupWrapper
        ])
    }, menuGroup) : menuGroup;
};
const $6f58092168c61151$var$menuIconStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.025',
    width: '16px',
    minWidth: '16px',
    height: '16px',
    minHeight: '16px'
});
const $6f58092168c61151$var$valueIconStyles = (0, $8CUq3.xcss)({
    width: '16px',
    minWidth: '16px',
    height: '16px',
    minHeight: '16px'
});
const $6f58092168c61151$var$selectWrapper = (0, $8CUq3.xcss)({
    width: '450px'
});
const $6f58092168c61151$var$infoIconWrapperStyles = (0, $8CUq3.xcss)({
    height: '24px',
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("820Wv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::946f7d5ec1dd58b66037bb8b983bfad0>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $5d8f3dcf908a8bd0$var$_react = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $5d8f3dcf908a8bd0$var$_information = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("jxZHv")));

var $5d8f3dcf908a8bd0$var$_panel = $5d8f3dcf908a8bd0$var$_interopRequireDefault((parcelRequire("kkuz9")));
function $5d8f3dcf908a8bd0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for InformationIcon.
 * This component is InformationIcon, with `UNSAFE_fallbackIcon` set to "EditorPanelIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $5d8f3dcf908a8bd0$var$InformationIcon = (props)=>/*#__PURE__*/ $5d8f3dcf908a8bd0$var$_react.default.createElement($5d8f3dcf908a8bd0$var$_information.default, Object.assign({
        LEGACY_fallbackIcon: $5d8f3dcf908a8bd0$var$_panel.default
    }, props));
$5d8f3dcf908a8bd0$var$InformationIcon.Name = 'InformationIconMigration';
var $5d8f3dcf908a8bd0$var$_default = module.exports.default = $5d8f3dcf908a8bd0$var$InformationIcon;

});
parcelRegister("jxZHv", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d4e114f01fe535a5a32bd9e3d0b8249d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e3b0f5e112f2bb60$var$_react = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $e3b0f5e112f2bb60$var$_baseNew = $e3b0f5e112f2bb60$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $e3b0f5e112f2bb60$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Information".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $e3b0f5e112f2bb60$var$InformationIcon = (props)=>/*#__PURE__*/ $e3b0f5e112f2bb60$var$_react.default.createElement($e3b0f5e112f2bb60$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 6A6 6 0 1 1 0 6a6 6 0 0 1 12 0m-7.5-.75H6a.75.75 0 0 1 .75.75v4h-1.5V6.75H4.5zM6 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$e3b0f5e112f2bb60$var$InformationIcon.displayName = 'InformationIcon';
var $e3b0f5e112f2bb60$var$_default = module.exports.default = $e3b0f5e112f2bb60$var$InformationIcon;

});


parcelRegister("kfO2I", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSelect", () => $3769930931d22483$export$88e7b5a47d581b96);

var $5uXOq = parcelRequire("5uXOq");

var $3T6Xo = parcelRequire("3T6Xo");

var $qfj8c = parcelRequire("qfj8c");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $7K5PP = parcelRequire("7K5PP");

var $gwIPs = parcelRequire("gwIPs");

var $a4XJc = parcelRequire("a4XJc");

var $cYeCp = parcelRequire("cYeCp");
const $3769930931d22483$export$88e7b5a47d581b96 = ({ title: title, testId: testId, viewAs: viewAs = (0, $a4XJc.ViewAs).POPUP, validationErrorMessage: validationErrorMessage, titleIcon: titleIcon, ...restProps })=>{
    const id = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}`);
    const errorId = (0, (/*@__PURE__*/$parcel$interopDefault($3T6Xo)))(`jira-software-view-settings-${title}-error`);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: viewAs === (0, $a4XJc.ViewAs).PANEL && (0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)() ? $3769930931d22483$var$panelContainerStyles : $3769930931d22483$var$popupContainerStyles,
        testId: testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $3769930931d22483$var$labelWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        htmlFor: id
    }, title), titleIcon)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        inputId: id,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: document.body,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).layer
                })
        },
        "aria-invalid": !!validationErrorMessage,
        "aria-errormessage": errorId,
        ...restProps
    }), validationErrorMessage && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-live": "polite",
        id: errorId
    }, validationErrorMessage)));
};
const $3769930931d22483$var$labelWrapperStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.050'
});
const $3769930931d22483$var$popupContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.200',
    marginInline: 'space.200',
    minWidth: '200px'
});
const $3769930931d22483$var$panelContainerStyles = (0, $8CUq3.xcss)({
    marginBlock: 'space.200',
    marginInline: 'auto',
    minWidth: '200px'
});

});
parcelRegister("qfj8c", function(module, exports) {

$parcel$export(module.exports, "HelperMessage", () => $b2d5b368fed948c9$export$8fbe3c7d0ed2c683);
$parcel$export(module.exports, "ErrorMessage", () => $b2d5b368fed948c9$export$915e9e7bd4f0f96d);
$parcel$export(module.exports, "ValidMessage", () => $b2d5b368fed948c9$export$5505afb209a532c8);
$parcel$export(module.exports, "MessageWrapper", () => $b2d5b368fed948c9$export$ec445f12f63100a5);
/* messages.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $059q9 = parcelRequire("059q9");

var $g4M8x = parcelRequire("g4M8x");

var $dRN65 = parcelRequire("dRN65");
const $b2d5b368fed948c9$var$messageStyles = null;
const $b2d5b368fed948c9$var$messageAppearanceStyles = {
    default: "_syaz1wmz",
    error: "_syaze6sf",
    valid: "_syazy73q"
};
const $b2d5b368fed948c9$var$iconWrapperStyles = {
    root: "_1e0c1txw _4t3i7vkz _4cvr1h6o"
};
const $b2d5b368fed948c9$var$IconWrapper = ({ children: children })=>/*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            $b2d5b368fed948c9$var$iconWrapperStyles.root
        ]),
        children: children
    });
const $b2d5b368fed948c9$var$messageIcons = {
    error: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($059q9))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "error"
    }),
    valid: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($g4M8x))), {
        LEGACY_margin: "0 -2px 0 0",
        color: "currentColor",
        LEGACY_size: "small",
        label: "success"
    })
};
const $b2d5b368fed948c9$var$Message = ({ children: children, appearance: appearance = 'default', fieldId: fieldId, testId: testId })=>{
    const icon = $b2d5b368fed948c9$var$messageIcons[appearance];
    const messageRef = (0, $5uXOq.useRef)(null);
    const [hasMessageWrapper, setHasMessageWrapper] = (0, $5uXOq.useState)(false);
    const { isWrapper: isWrapper } = (0, $5uXOq.useContext)($b2d5b368fed948c9$var$MessageWrapperContext);
    (0, $5uXOq.useEffect)(()=>{
        if (messageRef.current) setHasMessageWrapper(isWrapper);
    }, [
        isWrapper
    ]);
    /**
   * The wrapping span is necessary to preserve spaces between children.
   * Otherwise the flex layout of the message will remove any whitespace
   * between children.
   *
   * If the child is just a string, this is not required and we can use one
   * less DOM element.
   */ const content = typeof children === 'string' ? children : /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        children: children
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        "data-testid": testId,
        id: fieldId,
        ref: messageRef,
        // For backwards compatability, if there is a wrapper, aria-live is not needed
        "aria-live": !hasMessageWrapper ? 'polite' : undefined,
        className: (0, $bwpsq.default)([
            "_zulp12x7 _11c8dcr7 _1e0c1txw _1bah1q9y _1pfh1b66",
            $b2d5b368fed948c9$var$messageAppearanceStyles[appearance]
        ]),
        children: [
            icon && /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$IconWrapper, {
                children: icon
            }),
            content
        ]
    });
};
const $b2d5b368fed948c9$export$8fbe3c7d0ed2c683 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                fieldId: fieldId ? `${fieldId}-helper` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$915e9e7bd4f0f96d = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "error",
                fieldId: fieldId ? `${fieldId}-error` : undefined,
                testId: testId,
                children: children
            })
    });
const $b2d5b368fed948c9$export$5505afb209a532c8 = ({ children: children, testId: testId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $dRN65.FieldId).Consumer, {
        children: (fieldId)=>/*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$Message, {
                appearance: "valid",
                fieldId: fieldId ? `${fieldId}-valid` : undefined,
                testId: testId,
                children: children
            })
    });
/**
 * __Message wrapper context__
 *
 * A message wrapper context allows the children to check
 * if it is contained within the MessageWrapper.
 */ const $b2d5b368fed948c9$var$MessageWrapperContext = /*#__PURE__*/ (0, $5uXOq.createContext)({
    isWrapper: false
});
const $b2d5b368fed948c9$export$ec445f12f63100a5 = ({ children: children })=>{
    const contextValue = {
        isWrapper: true
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)($b2d5b368fed948c9$var$MessageWrapperContext.Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
            "aria-live": "polite",
            "data-testid": "message-wrapper",
            children: children
        })
    });
};

});
parcelRegister("059q9", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::98606756a92a07f2e7585c76d3cbd084>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $00f7c68b1ac9eeb3$var$_react = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $00f7c68b1ac9eeb3$var$_error = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("hAZqC")));

var $00f7c68b1ac9eeb3$var$_error2 = $00f7c68b1ac9eeb3$var$_interopRequireDefault((parcelRequire("7nnPp")));
function $00f7c68b1ac9eeb3$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ErrorIcon.
 * This component is ErrorIcon, with `UNSAFE_fallbackIcon` set to "ErrorIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $00f7c68b1ac9eeb3$var$ErrorIcon = (props)=>/*#__PURE__*/ $00f7c68b1ac9eeb3$var$_react.default.createElement($00f7c68b1ac9eeb3$var$_error.default, Object.assign({
        LEGACY_fallbackIcon: $00f7c68b1ac9eeb3$var$_error2.default
    }, props));
$00f7c68b1ac9eeb3$var$ErrorIcon.Name = 'ErrorIconMigration';
var $00f7c68b1ac9eeb3$var$_default = module.exports.default = $00f7c68b1ac9eeb3$var$ErrorIcon;

});
parcelRegister("hAZqC", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d97879d6b889ef4621929c7dd705b0ff>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ccf572dfbabebdf7$var$_react = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ccf572dfbabebdf7$var$_baseNew = $ccf572dfbabebdf7$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $ccf572dfbabebdf7$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Error".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ccf572dfbabebdf7$var$ErrorIcon = (props)=>/*#__PURE__*/ $ccf572dfbabebdf7$var$_react.default.createElement($ccf572dfbabebdf7$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M.384 5.116 5.116.384a1.25 1.25 0 0 1 1.768 0l4.732 4.732a1.25 1.25 0 0 1 0 1.768l-4.732 4.732a1.25 1.25 0 0 1-1.768 0L.384 6.884a1.25 1.25 0 0 1 0-1.768M6.75 2.5v4h-1.5v-4zM6 9.75a1 1 0 1 0 0-2 1 1 0 0 0 0 2" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$ccf572dfbabebdf7$var$ErrorIcon.displayName = 'ErrorIcon';
var $ccf572dfbabebdf7$var$_default = module.exports.default = $ccf572dfbabebdf7$var$ErrorIcon;

});


parcelRegister("g4M8x", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::d345d1980a5e7ce7680063890c36f7e3>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bb425bfe72dc5677$var$_react = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bb425bfe72dc5677$var$_success = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("hs3k8")));

var $bb425bfe72dc5677$var$_success2 = $bb425bfe72dc5677$var$_interopRequireDefault((parcelRequire("kJ541")));
function $bb425bfe72dc5677$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for SuccessIcon.
 * This component is SuccessIcon, with `UNSAFE_fallbackIcon` set to "EditorSuccessIcon".
 *
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bb425bfe72dc5677$var$SuccessIcon = (props)=>/*#__PURE__*/ $bb425bfe72dc5677$var$_react.default.createElement($bb425bfe72dc5677$var$_success.default, Object.assign({
        LEGACY_fallbackIcon: $bb425bfe72dc5677$var$_success2.default
    }, props));
$bb425bfe72dc5677$var$SuccessIcon.Name = 'SuccessIconMigration';
var $bb425bfe72dc5677$var$_default = module.exports.default = $bb425bfe72dc5677$var$SuccessIcon;

});
parcelRegister("hs3k8", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::b91b2ac4848db507d9eb71a2b738b7fc>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0347594f5084a834$var$_react = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $0347594f5084a834$var$_baseNew = $0347594f5084a834$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $0347594f5084a834$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Success".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for Helper Messages in Forms.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $0347594f5084a834$var$SuccessIcon = (props)=>/*#__PURE__*/ $0347594f5084a834$var$_react.default.createElement($0347594f5084a834$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M0 6a6 6 0 1 1 12 0A6 6 0 0 1 0 6m9.389-1.77-1.153-.96-3.174 3.808L3.765 5.52l-1.153.96 1.875 2.25a.75.75 0 0 0 1.153 0z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$0347594f5084a834$var$SuccessIcon.displayName = 'SuccessIcon';
var $0347594f5084a834$var$_default = module.exports.default = $0347594f5084a834$var$SuccessIcon;

});

parcelRegister("kJ541", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f16bf031974cd311$var$_react = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $f16bf031974cd311$var$_success = $f16bf031974cd311$var$_interopRequireDefault((parcelRequire("b0JGA")));
function $f16bf031974cd311$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $f16bf031974cd311$var$EditorSuccessIcon = (props)=>/*#__PURE__*/ $f16bf031974cd311$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 20a8 8 0 1 1 0-16 8 8 0 0 1 0 16m1.364-10.964-2.152 4.11-1.543-1.39a1 1 0 1 0-1.338 1.487l2.5 2.25a1 1 0 0 0 1.555-.279l2.75-5.25a1 1 0 0 0-1.772-.928"/></svg>`
    }, props, {
        newIcon: $f16bf031974cd311$var$_success.default
    }));
$f16bf031974cd311$var$EditorSuccessIcon.displayName = 'EditorSuccessIcon';
var $f16bf031974cd311$var$_default = module.exports.default = $f16bf031974cd311$var$EditorSuccessIcon;

});




parcelRegister("bkrRB", function(module, exports) {

$parcel$export(module.exports, "default", () => $edba0a4edd60a46b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $edba0a4edd60a46b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dependencyLinesSection: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.dependency-lines-section",
        "defaultMessage": "Dependency lines"
    },
    showOfftrackDependencyLines: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.show-offtrack-dependency-lines",
        "defaultMessage": "Show lines for all off-track dependencies"
    },
    offtrackDependenciesHelpLink: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.offtrack-dependencies-help-link",
        "defaultMessage": "What are off-track dependencies?"
    },
    showDependenciesOnIssues: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.show-dependencies-on-issues",
        "defaultMessage": "Show lines for dependencies linked to"
    },
    chooseIssue: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.choose-issue",
        "defaultMessage": "Choose issue..."
    },
    onlyShowScheduledIssueDependencyLinesTooltip: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.only-show-scheduled-issue-dependency-lines-tooltip",
        "defaultMessage": "Lines only show once an issue has been scheduled"
    },
    chooseIssueIssueTermRefresh: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.choose-issue-issue-term-refresh",
        "defaultMessage": "Choose work item..."
    },
    onlyShowScheduledIssueDependencyLinesTooltipIssueTermRefresh: {
        "id": "software-view-settings.view-settings-menu.views.increment-planning-board.only-show-scheduled-issue-dependency-lines-tooltip-issue-term-refresh",
        "defaultMessage": "Lines only show once a work item has been scheduled"
    }
});

});



const $3795a016b6403547$export$8be246eeba922980 = 'jsw-tailored-board-view-onboarding';
const $3795a016b6403547$export$a57856d4380e4bb8 = 'viewSettingsButtonTarget';
const $3795a016b6403547$export$989661c424340ff8 = 'viewSettingsPanelTarget';
const $3795a016b6403547$export$4a16d41d3ff730bf = 'addPeopleButtonTarget';



parcelRegister("ca5yC", function(module, exports) {

$parcel$export(module.exports, "default", () => $b70939e8adcdb321$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $34ck9 = parcelRequire("34ck9");

var $8RXs9 = parcelRequire("8RXs9");

var $4R6GH = parcelRequire("4R6GH");

var $jQCwr = parcelRequire("jQCwr");

var $7AVqz = parcelRequire("7AVqz");
const $b70939e8adcdb321$export$a497a0788dce8ef4 = 495;
const $b70939e8adcdb321$export$b4e0432c87affda2 = 440;
const $b70939e8adcdb321$export$177615fff7f0b5c6 = 440;
const $b70939e8adcdb321$export$db1057b88f0c8a04 = 350; // remove getMinDetailsWidthIssue and update value in MIN_DETAILS_WIDTH_ISSUE when fix_reply_editor_width is cleaned up
const $b70939e8adcdb321$var$getMinDetailsWidthIssue = ()=>{
    return (0, $4R6GH.fg)('fix_reply_editor_width') ? $b70939e8adcdb321$export$a497a0788dce8ef4 : $b70939e8adcdb321$export$b4e0432c87affda2;
};
const $b70939e8adcdb321$var$IS_DRAGGING_CLASS_NAME = 'ak-dnd-is-dragging';
class $b70939e8adcdb321$var$Resizer extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onResize: undefined,
            isThemed: false
        };
    }
    constructor(props){
        super(props), this.onWindowResize = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(()=>{
            const initValue = (0, $jQCwr.getDetailViewWidthRatio)();
            const newValue = Math.max(this.props.parentWidth * initValue, $b70939e8adcdb321$var$getMinDetailsWidthIssue());
            if (newValue === this.state.width) return;
            this.setState({
                width: newValue
            });
        }, $b70939e8adcdb321$export$db1057b88f0c8a04), this.onMouseDown = (e)=>{
            this.startX = e.pageX + (this.state.width - $b70939e8adcdb321$var$getMinDetailsWidthIssue()); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('mousemove', this.onMouseMove); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.addEventListener('mouseup', this.onMouseUp); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.classList.add($b70939e8adcdb321$var$IS_DRAGGING_CLASS_NAME);
        }, this.onMouseMove = (e)=>{
            this.extraWidth = Math.max(this.startX - e.pageX, 0);
            const newValue = Math.min($b70939e8adcdb321$var$getMinDetailsWidthIssue() + this.extraWidth, this.props.parentWidth / 2);
            if (newValue === this.state.width) return;
            this.setState({
                width: newValue
            });
        }, this.onMouseUp = ()=>{
            this.startX = 0; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('mousemove', this.onMouseMove); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('mouseup', this.onMouseUp); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            if (document.body) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body.classList.remove($b70939e8adcdb321$var$IS_DRAGGING_CLASS_NAME);
            const widthRatio = this.state.width === $b70939e8adcdb321$var$getMinDetailsWidthIssue() ? 0 : this.state.width / this.props.parentWidth;
            (0, $jQCwr.setDetailViewWidthRatio)(widthRatio);
        }, this.extraWidth = 0, this.startX = 0;
        const initValue = (0, $jQCwr.getDetailViewWidthRatio)();
        this.state = {
            width: Math.max(props.parentWidth * initValue, $b70939e8adcdb321$var$getMinDetailsWidthIssue()),
            parentWidth: props.parentWidth
        };
    }
    static getDerivedStateFromProps(nextProps, state) {
        const { parentWidth: parentWidth } = nextProps;
        if (parentWidth !== state.parentWidth) {
            const initValue = (0, $jQCwr.getDetailViewWidthRatio)();
            return {
                width: Math.max(parentWidth * initValue, $b70939e8adcdb321$var$getMinDetailsWidthIssue()),
                parentWidth: parentWidth
            };
        }
        return state;
    }
    componentDidMount() {
        const { useFixedMinWidth: useFixedMinWidth, onResize: onResize } = this.props; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', this.onWindowResize);
        onResize?.(useFixedMinWidth ? $b70939e8adcdb321$export$177615fff7f0b5c6 : this.state.width);
    }
    componentDidUpdate(prevProps, prevState) {
        const { onResize: onResize, useFixedMinWidth: useFixedMinWidth } = this.props;
        if (prevProps.useFixedMinWidth !== useFixedMinWidth || prevState.width !== this.state.width) onResize?.(useFixedMinWidth ? $b70939e8adcdb321$export$177615fff7f0b5c6 : this.state.width);
    }
    componentWillUnmount() {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.removeEventListener('resize', this.onWindowResize);
    }
    render() {
        const { children: children, useFixedMinWidth: useFixedMinWidth, isThemed: isThemed = false } = this.props;
        return(// dynamic change of values
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b70939e8adcdb321$var$Container, {
            isSoftwareThemingEnabled: isThemed,
            minWidth: useFixedMinWidth ? $b70939e8adcdb321$export$177615fff7f0b5c6 : this.state.width
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b70939e8adcdb321$var$ResizeHandle, {
            onMouseDown: this.onMouseDown,
            "data-testid": "software-board.detail-view.resizer.resize-handler",
            ...(0, $4R6GH.fg)('jfp_a11y_team_scrum_board_appropriate_role') && {
                role: 'slider',
                tabIndex: 0,
                'aria-label': `${this.props.intl.formatMessage((0, $7AVqz.default).resizeHandleLabel)}`,
                'aria-valuemin': $b70939e8adcdb321$export$b4e0432c87affda2,
                'aria-valuemax': this.state.width,
                'aria-valuenow': this.state.width
            }
        }), children));
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b70939e8adcdb321$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { minWidth: minWidth, isSoftwareThemingEnabled: isSoftwareThemingEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_7ypm2r": (0, $lD23V.default)(`${__cmplp.minWidth || 400}px`)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsb1kdj _1ul9152j _1tke1osq _c71l1osq _18m91wug _1reo15vq _1e0c1txw _2lx2vrvc _4cvr1y6m _1pbyb4wl",
            __cmplp.isSoftwareThemingEnabled ? "_ca0qt94y" : "_bfhkvuon",
            __cmplp.className
        ])
    });
});
var $b70939e8adcdb321$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($b70939e8adcdb321$var$Resizer);
const $b70939e8adcdb321$var$ResizeHandle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbftgi _80omuf7j _kqswh2mm _1wpz1fhb _qc5othzt _aetrb3bt _z0aiyh40 _1qdggktf _15l21ssb _clh31i34 _19do1b66 _18postnw _1hfkmuej _gcm1b29m _4tpub29m _1gvg1osq _1kmz1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("dHKcT", function(module, exports) {

$parcel$export(module.exports, "default", () => $de9b468cff93ea86$export$2e2bcd8739ae039);

var $az4zD = parcelRequire("az4zD");

var $bC2fB = parcelRequire("bC2fB");

var $6Pv6s = parcelRequire("6Pv6s");

var $ebHh7 = parcelRequire("ebHh7");

var $cSfDQ = parcelRequire("cSfDQ");
var $de9b468cff93ea86$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>{
    return {
        boardName: (0, $6Pv6s.boardNameSelector)(state),
        sprints: (0, $ebHh7.getSelectedOrAllSprintsSelector)(state),
        isKanbanBoard: !(0, $ebHh7.isSprintsEnabled)(state)
    };
}, {})((0, $az4zD.injectIntlV2)((0, $cSfDQ.default)));

});
parcelRegister("6Pv6s", function(module, exports) {

$parcel$export(module.exports, "boardNameSelector", () => $e5862aec7e26552e$export$6565b2df5446c7ba);
$parcel$export(module.exports, "boardTitleSelector", () => $e5862aec7e26552e$export$a7b2cfd83eec7d8b);
$parcel$export(module.exports, "isEditableSelector", () => $e5862aec7e26552e$export$c1ae0fa851a148a8);

var $dGvGJ = parcelRequire("dGvGJ");



var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $1vXOx = parcelRequire("1vXOx");
const $e5862aec7e26552e$export$6565b2df5446c7ba = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getBoardConfig)
], (boardConfig)=>boardConfig.name);
const $e5862aec7e26552e$export$a7b2cfd83eec7d8b = (0, $dGvGJ.createSelector)([
    (0, $ebHh7.getSprintEntities),
    (0, $67Z81.getBoardConfig),
    (0, $5mTgl.getWorkFilters)
], (activeSprints, boardConfig, workFilters)=>{
    const numOfActiveSprints = Object.keys(activeSprints).length;
    if (boardConfig.isSprintsEnabled === false || numOfActiveSprints === 0) return boardConfig.name;
    const selectedSprints = workFilters.values[0, $dcff40112356dfc1$export$a316570a0dbfd2b0] ?? [];
    const numOfSelectedSprints = selectedSprints?.length ?? 0;
    if (numOfActiveSprints === 1) return activeSprints[Object.keys(activeSprints)[0]].name;
    if (numOfSelectedSprints === 1 && activeSprints[selectedSprints[0]]) return activeSprints[selectedSprints[0]].name;
    if (numOfSelectedSprints > 1 && numOfSelectedSprints < numOfActiveSprints) return `${numOfSelectedSprints} sprints`;
    return 'All sprints';
});
const $e5862aec7e26552e$export$c1ae0fa851a148a8 = (0, $dGvGJ.createSelector)([
    (0, $ebHh7.activeSprintsSelector),
    (0, $1vXOx.getPermissionsSelector),
    (0, $67Z81.getIsCMPBoard)
], (activeSprints, permissions, isCMPBoard)=>(activeSprints === null || activeSprints.length === 0) && (permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] || false) && !isCMPBoard);

});

parcelRegister("cSfDQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc2ae0850ca32cc0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $id7K0 = parcelRequire("id7K0");

var $gN2Mn = parcelRequire("gN2Mn");
const $bc2ae0850ca32cc0$var$DocumentTitleWrapper = ({ intl: intl, boardName: boardName, sprints: sprints, isKanbanBoard: isKanbanBoard })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $id7K0.DocumentTitle), {
        title: intl.formatMessage((0, $gN2Mn.default).pageTitleWithSprint, {
            boardName: boardName,
            sprintCount: sprints?.length || 0,
            sprintName: sprints?.length ? sprints[0].name : '',
            isKanbanBoard: isKanbanBoard
        })
    });
};
var $bc2ae0850ca32cc0$export$2e2bcd8739ae039 = $bc2ae0850ca32cc0$var$DocumentTitleWrapper;

});
parcelRegister("id7K0", function(module, exports) {

$parcel$export(module.exports, "DocumentTitle", () => $938046587fdeeb52$export$dd5ad0b65cf665da);

var $5uXOq = parcelRequire("5uXOq");

var $cSD7y = parcelRequire("cSD7y");

var $4CAXd = parcelRequire("4CAXd");
// eslint-disable-next-line jira/react/no-class-components
class $938046587fdeeb52$var$DocumentTitleOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            TitleSubscriber: (0, $4CAXd.DocumentTitleSubscriber)
        };
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.title !== this.props.title;
    }
    render() {
        const { title: title, TitleSubscriber: TitleSubscriber = (0, $4CAXd.DocumentTitleSubscriber) } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TitleSubscriber, null, ({ contextArray: contextArray }, { setTitle: setTitle, addDocumentTitle: addDocumentTitle, removeDocumentTitle: removeDocumentTitle })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4CAXd.DocumentTitleHelperOld), {
                title: title,
                setTitle: setTitle,
                addDocumentTitle: addDocumentTitle,
                contextArray: contextArray,
                removeDocumentTitle: removeDocumentTitle,
                TitleSubscriber: TitleSubscriber
            }));
    }
}
const $938046587fdeeb52$export$dd5ad0b65cf665da = (0, $cSD7y.componentWithFG)('jira-concurrent-document-title', (0, $4CAXd.DocumentTitleHelper), $938046587fdeeb52$var$DocumentTitleOld);

});

parcelRegister("gN2Mn", function(module, exports) {

$parcel$export(module.exports, "default", () => $2583f8d6e5a3c6d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2583f8d6e5a3c6d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    pageTitle: {
        "id": "software.main.document-title.page-title",
        "defaultMessage": "{boardName} - Agile board"
    },
    pageTitleWithSprint: {
        "id": "software.main.document-title.page-board-title-with-sprint",
        "defaultMessage": "{isKanbanBoard, select, true {{boardName} - Kanban Board} other {{sprintCount, plural, =0 {{boardName} - Scrum Board} one {{sprintName} - {boardName} - Scrum Board} other {# sprints - {boardName} - Scrum Board} }} }"
    }
});

});



parcelRegister("hOou0", function(module, exports) {

$parcel$export(module.exports, "withViewExperienceTracker", () => $e6065608c6b6ea40$export$52092272c0483371);

var $5uXOq = parcelRequire("5uXOq");

var $aD4Nm = parcelRequire("aD4Nm");

const $e6065608c6b6ea40$export$52092272c0483371 = (ComponentBeingTracked)=>{
    const WithViewExperienceTracker = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
            location: (0, $dcbb2bce513725b3$export$fa0622448a6f265)
        }, ({ onExperienceSuccess: onExperienceSuccess })=>// @ts-expect-error - Type '{ onExperienceSuccess: () => void; } & Omit<T, "onExperienceSuccess">' is not assignable to type 'T'.
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ComponentBeingTracked, {
                onExperienceSuccess: onExperienceSuccess,
                ...props
            }));
    return WithViewExperienceTracker;
};

});

parcelRegister("gdLuI", function(module, exports) {

$parcel$export(module.exports, "default", () => $bfea86bc6a72f400$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $2OMDV = parcelRequire("2OMDV");

var $bC2fB = parcelRequire("bC2fB");

var $bkCF5 = parcelRequire("bkCF5");

var $dW1HX = parcelRequire("dW1HX");

var $2r32e = parcelRequire("2r32e");
var $bfea86bc6a72f400$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $bC2fB.connect)((state)=>({
        flags: state.ui.flags,
        externalId: 'software.board'
    }), {
    dismissFlag: $bkCF5.dismissFlag,
    openIssueModal: $dW1HX.openIssueModal
}), (0, $2OMDV.AnalyticsEventToProps)('Flags', {
    onPrimaryActionClick: 'primaryActionClicked'
}))((0, $2r32e.default));

});
parcelRegister("2r32e", function(module, exports) {

$parcel$export(module.exports, "default", () => $1842ebbe43eb05a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1sWm7 = parcelRequire("1sWm7");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $hMVoD = parcelRequire("hMVoD");

var $2Yv61 = parcelRequire("2Yv61");

var $b0JGA = parcelRequire("b0JGA");

var $34Rrn = parcelRequire("34Rrn");

var $btivG = parcelRequire("btivG");

var $7nnPp = parcelRequire("7nnPp");

var $2hXfb = parcelRequire("2hXfb");

var $gtreQ = parcelRequire("gtreQ");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $7R4eB = parcelRequire("7R4eB");

var $f2BYd = parcelRequire("f2BYd");

var $az4zD = parcelRequire("az4zD");

var $8zOmE = parcelRequire("8zOmE");

var $lVQn8 = parcelRequire("lVQn8");


var $bkCF5 = parcelRequire("bkCF5");

var $cW3pH = parcelRequire("cW3pH");

var $apkY5 = parcelRequire("apkY5");

var $7AVqz = parcelRequire("7AVqz");

var $3h5zX = parcelRequire("3h5zX");

var $2I1lL = parcelRequire("2I1lL");
class $1842ebbe43eb05a1$export$434ba092ed0eee4e extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            openIssueModal: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            createAnalyticsEvent: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    getIconForFlag(flag) {
        switch(flag.type){
            case 0, $587ae274b8f0e917$export$3e8caae81220a92d:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
                    color: "var(--ds-icon-warning, #E56910)",
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
                    LEGACY_primaryColor: "var(--ds-icon-warning, #E56910)",
                    label: this.props.intl.formatMessage((0, $7AVqz.default).warningLabel)
                });
            case 0, $587ae274b8f0e917$export$1d0740fae54799e6:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($b0JGA))), {
                    label: "",
                    color: "var(--ds-icon-success, #22A06B)",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($btivG))),
                    LEGACY_primaryColor: "var(--ds-icon-success, #22A06B)"
                });
            case 0, $587ae274b8f0e917$export$b80f3194b3ff34b4:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
                    label: "",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($2hXfb))),
                    color: "var(--ds-icon, #44546F)"
                });
            case 0, $587ae274b8f0e917$export$b0516b50882e8fbc:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
                    label: this.props.intl.formatMessage((0, $7AVqz.default).errorLabel),
                    color: "var(--ds-icon-danger, #C9372C)",
                    spacing: "spacious",
                    LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7nnPp))),
                    LEGACY_primaryColor: "var(--ds-icon-danger, #C9372C)"
                });
            case 0, $587ae274b8f0e917$export$f1471fc4e853391b:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($2Yv61))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon-information, #1D7AFC)"
                });
            default:
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", null);
        }
    }
    // render the error messages flag description as un-ordered list
    buildErrorMessagesNode(errorMessages) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", null, errorMessages.map((message)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                key: message
            }, message)));
    }
    getDescriptionForFlag(flag) {
        // for the flag, the description is optional, so it can be undefined,
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(flag.descriptionMessage)) return undefined;
        if (flag.type === (0, $587ae274b8f0e917$export$b0516b50882e8fbc) && flag.errorMessages && flag.errorMessages.length > 0) return this.buildErrorMessagesNode(flag.errorMessages);
        const { formatMessage: formatMessage } = this.props.intl;
        return flag.id === (0, $cW3pH.LOG_BACK_IN_SHOW) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, formatMessage(flag.descriptionMessage), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: flag.context && flag.context.url
        }, formatMessage((0, $7AVqz.default).logBackInAnchorText)))) : formatMessage(flag.descriptionMessage, flag.context);
    }
    getTraceInfoForFlag(flag) {
        if (flag.context && flag.context.error && flag.context.traceId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            "data-testid": "software-board.flags.error-hash-and-traceid"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lVQn8.ErrorHashAndTraceId), {
            error: flag.context.error,
            traceId: flag.context.traceId
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
    }
    getDescriptionWithTraceForFlag(flag) {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, this.getDescriptionForFlag(flag), this.getTraceInfoForFlag(flag));
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f2BYd.default), {
            onDismissed: this.dismissFlag
        }, this.props.flags.map(this.renderFlag));
    }
    constructor(...args){
        super(...args), this.dismissFlag = (flagId)=>{
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const flag = (0, (/*@__PURE__*/$parcel$interopDefault($1sWm7)))(this.props.flags, {
                id: flagId
            });
            if (flag) this.props.dismissFlag(flag);
        }, this.renderFlag = (flag)=>{
            const { formatMessage: formatMessage } = this.props.intl;
            if (flag.type === (0, $587ae274b8f0e917$export$b80f3194b3ff34b4)) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2I1lL.UndoFlag), {
                key: flag.id,
                flag: flag,
                icon: this.getIconForFlag(flag),
                onDismissFlag: this.dismissFlag
            });
            switch(flag.id){
                // Special render case for "Created issue is filtered" flag
                case 0, $bkCF5.FLAG_CREATED_ISSUE_IS_FILTERED:
                    {
                        const issueKey = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(flag, [
                            'context',
                            'issueKey'
                        ]);
                        return (0, $apkY5.default)({
                            id: flag.id,
                            issueKey: issueKey,
                            intl: this.props.intl,
                            onPrimaryActionClick: ()=>{
                                this.dismissFlag(flag.id);
                                const analyticsEvent = this.props.createAnalyticsEvent({
                                    action: 'issueOpened',
                                    actionSubject: 'flag'
                                });
                                const issueId = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(flag, [
                                    'context',
                                    'issueId'
                                ]);
                                // @ts-expect-error - Argument of type 'void | UIAnalyticsEvent' is not assignable to parameter of type 'UIAnalyticsEvent'.
                                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'newIssueFiltered', {
                                    issueId: issueId
                                });
                                this.props.openIssueModal(issueKey);
                            }
                        });
                    }
                case 0, $cW3pH.BOARD_LOAD_FAILURE_NO_COLUMN:
                    {
                        const canConfigureBoard = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(flag, [
                            'context',
                            'canConfigureBoard'
                        ]);
                        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3h5zX.default), {
                            key: flag.id,
                            id: flag.id,
                            canUserConfigureBoard: canConfigureBoard,
                            onDismissed: this.dismissFlag
                        });
                    }
                default:
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
                        messageId: this.props.messageId ?? `software-board.view.flags.auto-dismiss-flag.${flag.id}`,
                        messageType: this.props.messageType ?? 'transactional',
                        id: flag.id,
                        key: flag.id,
                        title: formatMessage(flag.titleMessage, flag.context),
                        description: flag.rawDescriptionMessage ?? ((0, $4R6GH.fg)('obsrve-2239-traceid-errorflag-issue-transition') ? this.getDescriptionWithTraceForFlag(flag) : this.getDescriptionForFlag(flag)),
                        icon: this.getIconForFlag(flag)
                    });
            }
        };
    }
}
var $1842ebbe43eb05a1$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($1842ebbe43eb05a1$export$434ba092ed0eee4e);

});
parcelRegister("lVQn8", function(module, exports) {

$parcel$export(module.exports, "ErrorHashAndTraceId", () => $6bb63dde5e44a95e$export$61354a7dde2c2d3c);

var $5uXOq = parcelRequire("5uXOq");

var $5oFIy = parcelRequire("5oFIy");

var $kobfu = parcelRequire("kobfu");

var $hurrh = parcelRequire("hurrh");
const $6bb63dde5e44a95e$export$61354a7dde2c2d3c = ({ error: error, traceId: traceId })=>{
    const errorHash = (0, $kobfu.getErrorHash)(error);
    const source = `Hash ${errorHash}\nTrace ${traceId}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "rendered",
        actionSubject: "errorHashAndTraceId",
        attributes: {
            errorHash: errorHash,
            traceId: traceId
        }
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "note"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hurrh.CodeBlockWithCopyButton), {
        source: source,
        copyCodeActionSubjectId: "copyErrorHashAndTraceId"
    })));
};

});
parcelRegister("hurrh", function(module, exports) {

$parcel$export(module.exports, "CodeBlockWithCopyButton", () => $e48150d967598599$export$ced1fc74d907d387);

var $5uXOq = parcelRequire("5uXOq");

var $b8Qxt = parcelRequire("b8Qxt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $irzxp = parcelRequire("irzxp");
const $e48150d967598599$export$ced1fc74d907d387 = ({ source: source, copyCodeActionSubjectId: copyCodeActionSubjectId })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e48150d967598599$var$wrapperStyles,
        role: "region"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.ActionContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $irzxp.CopyAction), {
        source: source,
        actionSubjectId: copyCodeActionSubjectId
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b8Qxt.default), {
        text: source,
        showLineNumbers: false,
        shouldWrapLongLines: false
    })));
const $e48150d967598599$var$wrapperStyles = (0, $8CUq3.xcss)({
    width: '100%',
    position: 'relative'
});

});
parcelRegister("b8Qxt", function(module, exports) {

$parcel$export(module.exports, "default", () => $4fd53c1f9dbca185$export$2e2bcd8739ae039);
/* code-block.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable @atlaskit/ui-styling-standard/no-unsafe-selectors */ /* eslint-disable @atlaskit/ui-styling-standard/no-nested-selectors */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cBeZP = parcelRequire("cBeZP");

var $7nRxN = parcelRequire("7nRxN");

var $e4VnT = parcelRequire("e4VnT");

var $1HkQx = parcelRequire("1HkQx");

var $eCBnN = parcelRequire("eCBnN");

var $9Xp6L = parcelRequire("9Xp6L");
const $4fd53c1f9dbca185$var$getCodeBlockStyles = {
    root: "_2rkoglpi _1dqoglyw _1wyb1crf _k48pi7a9 _1e0c1txw _vwz4gktf _1reo1wug _o572qvpr _1eimjvyg _bfhktkvp _syaz1fxt _ect41odn _1ozdn7od _7xinn7od _t7aun7od _1v15u2gc _ilvcu2gc _m29uu2gc _17wyu2gc _pn28u2gc _gz9fu2gc _1hmyegat _vblregat _vbulegat _wozj1yev _1agb1yev _lkm81yev _tv41hkgb _1hmimyb0 _1ra01n1a _1d4j1y44 _1f8gstnw _1pzyb3bt _j1w0ww7y _13cdh2mm _15ba126e _zvy9f705 _qcxof705 _14y71a66 _j0l11wug _1weckb7n _1na21hna _1xx2grf3 _x7c815vq _lh0y15vq _1m3815vq _qk1e15vq _12l6ysn8 _uga3ysn8 _mx8b7mnp _1kr87mnp _xo19t94y _1bemt94y _nalpstnw _151dstnw _1exb1q9c _1hgu1q9c _1mgnt94y _nhket94y _h909m7j4 _scgayz1z _ipl81e17 _jeky1l04 _1gec1a66 _1gx21e5h _1ls0df4r _vm2c1rh5 _12ok1rh5 _1ls01ule _rude1ule _1q16glyw _1io6glyw _juomusic _lcwuusic _1552u2gc _12afu2gc _28ddu2gc _1i8zu2gc _12tu1a66 _zu0j1a66 _euyxusvi _cahfusvi _zhnuidpf _1amdidpf _mbgcpf9b _bu7zpf9b _131n1giz _gy101giz _1wfuwrk5 _16kzwrk5 _9kk3moej _cjus1w1g _9k2r1m30 _nhmw1m30 _yl021m30 _eiht5x2v _t9zb5x2v _mqok1w1g _3hsg1w1g _i7ngn7od _9wu1fb2s _1xcoh55r _1t361fxt _137bh55r _1k7d1fxt _97lipnps _12nh9lu1 _1g0517qg _i2ig10m5 _326z1fxt _113p131l _1n6tpnps _tgu817qg _1k47pnps _g0lx1fxt _ys4e131l _7gp8h55r _1yvq10m5 _1vww10m5 _1rju10m5 _1v0lh55r _wmyy17qg _748n17qg _1mfn17qg _1d7e17qg _p2vr17qg _19o610m5 _kxov17qg _1np517qg _m2f517qg _1b9tpnps _1tq6pnps _1rd2pnps _1pbkpnps _k3lipnps _13zt131l _2g12fb2s _k86b10m5 _b5iy131l _gti3131l _1f0gpnps _9d3e17qg _qdiapnps _72uvpnps",
    showLineNumbers: "_170714ej _1i3h1txw _1huoidpf _1a9lidpf _20bqidpf _1oggidpf _bympidpf _9nnjidpf",
    dontShowLineNumbers: "_1i3h1ule _1huou2gc _1a9lu2gc _20bqu2gc _1oggu2gc _bympu2gc _9nnju2gc",
    shouldWrapLongLines: "_13dgkb7n",
    dontWrapLongLines: "_13dgkb7n"
};
/**
 * __Code block__
 *
 * A code block highlights an entire block of code and keeps the formatting.
 *
 * - [Examples](https://atlassian.design/components/code/code-block/examples)
 * - [Code](https://atlassian.design/components/code/code-block/code)
 * - [Usage](https://atlassian.design/components/code/code-block/usage)
 */ const $4fd53c1f9dbca185$var$CodeBlock = /*#__PURE__*/ (0, $5uXOq.memo)(function CodeBlock({ showLineNumbers: showLineNumbers = true, firstLineNumber: firstLineNumber = 1, language: providedLanguage = 'text', highlight: highlight = '', highlightedStartText: highlightedStartText = 'Highlight start', highlightedEndText: highlightedEndText = 'Highlight end', testId: testId, text: text, codeBidiWarnings: codeBidiWarnings = true, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled = true, shouldWrapLongLines: shouldWrapLongLines = false, label: label = 'Scrollable content' }) {
    const scrollableRef = (0, $5uXOq.useRef)(null);
    const [showContentFocus, setShowContentFocus] = (0, $5uXOq.useState)(false);
    const numLines = (text || '').split('\n').length + (firstLineNumber > 0 ? firstLineNumber : 1) - 1;
    const lineNumberWidth = numLines ? (0, $1HkQx.getLineNumWidth)(numLines) : 0;
    // Schedule a content focus on the target element
    // WARNING: In theory, `target` may not be available when `rafSchedule` hits in concurrent rendering
    (0, $5uXOq.useEffect)(()=>{
        const schedule = (0, $7nRxN.default)(()=>{
            const target = scrollableRef.current;
            target && setShowContentFocus(target.scrollWidth > target.clientWidth);
        });
        schedule();
        const unbindWindowEvent = (0, $cBeZP.bind)(window, {
            type: 'resize',
            listener: schedule
        });
        return unbindWindowEvent;
    }, [
        scrollableRef
    ]);
    const { getHighlightStyles: getHighlightStyles, highlightedLines: highlightedLines } = (0, $e4VnT.useHighlightLines)({
        highlight: highlight,
        testId: testId
    });
    const getLineProps = (0, $5uXOq.useCallback)((line)=>getHighlightStyles(line, highlightedLines), [
        getHighlightStyles,
        highlightedLines
    ]);
    const language = (0, $5uXOq.useMemo)(()=>(0, $eCBnN.normalizeLanguage)(providedLanguage), [
        providedLanguage
    ]);
    // https://product-fabric.atlassian.net/browse/DST-2472
    const languageToUse = text ? language : 'text';
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9Xp6L.default), {
        "data-code-lang": language,
        "data-ds--code--code-block": "",
        testId: testId,
        language: languageToUse,
        style: {
            '--ads-code-line-number-width': `calc(${lineNumberWidth} + 16px)`,
            '--ads-highlighted-start-text': highlightedStartText,
            '--ads-highlighted-end-text': highlightedEndText
        },
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber,
        lineProps: getLineProps,
        // shouldCreateParentElementForLines is needed to pass down props to each line.
        // This is necessary for both line highlighting and testId's, as each of
        // these rely on a data attribute being passed down to lines.
        shouldCreateParentElementForLines: highlight.length > 0 || !!testId,
        shouldWrapLongLines: shouldWrapLongLines,
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled,
        text: text,
        tabIndex: showContentFocus ? '0' : undefined,
        "aria-label": showContentFocus ? label : undefined,
        role: showContentFocus ? 'region' : undefined,
        scrollRef: scrollableRef,
        className: (0, $bwpsq.default)([
            $4fd53c1f9dbca185$var$getCodeBlockStyles.root,
            shouldWrapLongLines ? $4fd53c1f9dbca185$var$getCodeBlockStyles.shouldWrapLongLines : $4fd53c1f9dbca185$var$getCodeBlockStyles.dontWrapLongLines,
            showLineNumbers ? $4fd53c1f9dbca185$var$getCodeBlockStyles.showLineNumbers : $4fd53c1f9dbca185$var$getCodeBlockStyles.dontShowLineNumbers
        ])
    });
});
var $4fd53c1f9dbca185$export$2e2bcd8739ae039 = $4fd53c1f9dbca185$var$CodeBlock;

});
parcelRegister("e4VnT", function(module, exports) {

$parcel$export(module.exports, "useHighlightLines", () => $a32b74c088f4b53f$export$84415a200bdf33ed);

var $5uXOq = parcelRequire("5uXOq");
const $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ = {
    'data-ds--code--row': ''
};
const $a32b74c088f4b53f$var$getLineStyleObject = (lineNumber, testId)=>{
    return testId ? {
        'data-testid': `${testId}-line-${lineNumber}`,
        ...$a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ
    } : $a32b74c088f4b53f$var$DEFAULT_LINE_EL_ATTR_OBJ;
};
const $a32b74c088f4b53f$export$84415a200bdf33ed = ({ highlight: highlight = '', testId: testId })=>{
    const highlightedLines = (0, $5uXOq.useMemo)(()=>{
        if (!highlight) return [];
        return highlight.split(',').map((num)=>{
            if (num.indexOf('-') > 0) {
                // We found a line group, e.g. 1-3
                const [from, to] = num.split('-').map(Number)// Sort by lowest value first, highest value last.
                .sort((a, b)=>a - b);
                return Array(to + 1).fill(undefined).map((_, index)=>index).slice(from, to + 1);
            }
            return Number(num);
        }).reduce((acc, val)=>acc.concat(val), []) || [];
    }, [
        highlight
    ]);
    const getHighlightStyles = (0, $5uXOq.useCallback)((lineNumber, highlightedLines)=>{
        if (!highlight || highlightedLines.length === 0) return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
        if (highlightedLines.includes(lineNumber)) {
            const highlightedDataAttrObj = {
                'data-ds--code--row--highlight': ''
            };
            return {
                ...highlightedDataAttrObj,
                ...$a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId)
            };
        }
        return $a32b74c088f4b53f$var$getLineStyleObject(lineNumber, testId);
    }, [
        highlight,
        testId
    ]);
    return {
        getHighlightStyles: getHighlightStyles,
        highlightedLines: highlightedLines
    };
};

});

parcelRegister("1HkQx", function(module, exports) {

$parcel$export(module.exports, "getLineNumWidth", () => $a9c1aabaca189fa1$export$cb7aec0206b595d2);
const $a9c1aabaca189fa1$export$cb7aec0206b595d2 = (numLines)=>{
    return !numLines ? '1ch' : `${numLines.toFixed(0).length}ch`;
};

});

parcelRegister("eCBnN", function(module, exports) {

$parcel$export(module.exports, "normalizeLanguage", () => $d00516a0f8207944$export$f38728011c178796);

var $8QpSo = parcelRequire("8QpSo");

var $8Y2ZY = parcelRequire("8Y2ZY");
const $d00516a0f8207944$export$f38728011c178796 = (0, $8QpSo.default)((language)=>{
    if (!language) return '';
    const match = (0, $8Y2ZY.SUPPORTED_LANGUAGES).find((val)=>{
        return val.name === language || val.alias.includes(language);
    });
    // Fallback to plain monospaced text if language passed but not supported
    return match ? match.value : 'text';
});

});
parcelRegister("8Y2ZY", function(module, exports) {

$parcel$export(module.exports, "SUPPORTED_LANGUAGES", () => $012a854d92762508$export$7c77c3a9bb93870d);
// The full list of languages that can potentially be supported is found in
// https://prismjs.com/#supported-languages

const $012a854d92762508$export$7c77c3a9bb93870d = [
    {
        name: 'PHP',
        alias: [
            'php',
            'php3',
            'php4',
            'php5'
        ],
        value: 'php'
    },
    {
        name: 'Java',
        alias: [
            'java'
        ],
        value: 'java'
    },
    {
        name: 'CSharp',
        alias: [
            'csharp',
            'c#'
        ],
        value: 'cs'
    },
    {
        name: 'Python',
        alias: [
            'python',
            'py'
        ],
        value: 'python'
    },
    {
        name: 'JavaScript',
        alias: [
            'javascript',
            'js'
        ],
        value: 'javascript'
    },
    {
        name: 'Html',
        alias: [
            'html'
        ],
        value: 'xml'
    },
    {
        name: 'C++',
        alias: [
            'c++',
            'cpp',
            'clike'
        ],
        value: 'cpp'
    },
    {
        name: 'Ruby',
        alias: [
            'ruby',
            'rb',
            'duby'
        ],
        value: 'ruby'
    },
    {
        name: 'Objective-C',
        alias: [
            'objective-c',
            'objectivec',
            'obj-c',
            'objc'
        ],
        value: 'objectivec'
    },
    {
        name: 'C',
        alias: [
            'c'
        ],
        value: 'cpp'
    },
    {
        name: 'Swift',
        alias: [
            'swift'
        ],
        value: 'swift'
    },
    {
        name: 'TeX',
        alias: [
            'tex',
            'latex'
        ],
        value: 'tex'
    },
    {
        name: 'Shell',
        alias: [
            'shell',
            'bash',
            'sh',
            'ksh',
            'zsh'
        ],
        value: 'shell'
    },
    {
        name: 'Scala',
        alias: [
            'scala'
        ],
        value: 'scala'
    },
    {
        name: 'Go',
        alias: [
            'go'
        ],
        value: 'go'
    },
    {
        name: 'ActionScript',
        alias: [
            'actionscript',
            'actionscript3',
            'as'
        ],
        value: 'actionscript'
    },
    {
        name: 'ColdFusion',
        alias: [
            'coldfusion'
        ],
        value: 'xml'
    },
    {
        name: 'JavaFX',
        alias: [
            'javafx',
            'jfx'
        ],
        value: 'java'
    },
    {
        name: 'VbNet',
        alias: [
            'vbnet',
            'vb.net',
            'vfp',
            'clipper',
            'xbase'
        ],
        value: 'vbnet'
    },
    {
        name: 'JSON',
        alias: [
            'json'
        ],
        value: 'json'
    },
    {
        name: 'MATLAB',
        alias: [
            'matlab'
        ],
        value: 'matlab'
    },
    {
        name: 'Groovy',
        alias: [
            'groovy'
        ],
        value: 'groovy'
    },
    {
        name: 'SQL',
        alias: [
            'sql',
            'postgresql',
            'postgres',
            'plpgsql',
            'psql',
            'postgresql-console',
            'postgres-console',
            'tsql',
            't-sql',
            'mysql',
            'sqlite'
        ],
        value: 'sql'
    },
    {
        name: 'R',
        alias: [
            'r'
        ],
        value: 'r'
    },
    {
        name: 'Perl',
        alias: [
            'perl',
            'pl'
        ],
        value: 'perl'
    },
    {
        name: 'Lua',
        alias: [
            'lua'
        ],
        value: 'lua'
    },
    {
        name: 'Pascal',
        alias: [
            'pas',
            'pascal',
            'objectpascal',
            'delphi'
        ],
        value: 'pascal'
    },
    {
        name: 'XML',
        alias: [
            'xml'
        ],
        value: 'xml'
    },
    {
        name: 'TypeScript',
        alias: [
            'typescript',
            'ts'
        ],
        value: 'typescript'
    },
    {
        name: 'CoffeeScript',
        alias: [
            'coffeescript',
            'coffee-script',
            'coffee'
        ],
        value: 'coffeescript'
    },
    {
        name: 'Haskell',
        alias: [
            'haskell',
            'hs'
        ],
        value: 'haskell'
    },
    {
        name: 'Puppet',
        alias: [
            'puppet'
        ],
        value: 'puppet'
    },
    {
        name: 'Arduino',
        alias: [
            'arduino'
        ],
        value: 'arduino'
    },
    {
        name: 'Fortran',
        alias: [
            'fortran'
        ],
        value: 'fortran'
    },
    {
        name: 'Erlang',
        alias: [
            'erlang',
            'erl'
        ],
        value: 'erlang'
    },
    {
        name: 'PowerShell',
        alias: [
            'powershell',
            'posh',
            'ps1',
            'psm1'
        ],
        value: 'powershell'
    },
    {
        name: 'Haxe',
        alias: [
            'haxe',
            'hx',
            'hxsl'
        ],
        value: 'haxe'
    },
    {
        name: 'Elixir',
        alias: [
            'elixir',
            'ex',
            'exs'
        ],
        value: 'elixir'
    },
    {
        name: 'Verilog',
        alias: [
            'verilog',
            'v'
        ],
        value: 'verilog'
    },
    {
        name: 'Rust',
        alias: [
            'rust'
        ],
        value: 'rust'
    },
    {
        name: 'VHDL',
        alias: [
            'vhdl'
        ],
        value: 'vhdl'
    },
    {
        name: 'Sass',
        alias: [
            'sass'
        ],
        value: 'less'
    },
    {
        name: 'OCaml',
        alias: [
            'ocaml'
        ],
        value: 'ocaml'
    },
    {
        name: 'Dart',
        alias: [
            'dart'
        ],
        value: 'dart'
    },
    {
        name: 'CSS',
        alias: [
            'css'
        ],
        value: 'css'
    },
    {
        name: 'reStructuredText',
        alias: [
            'restructuredtext',
            'rst',
            'rest'
        ],
        value: 'rest'
    },
    {
        name: 'Kotlin',
        alias: [
            'kotlin'
        ],
        value: 'kotlin'
    },
    {
        name: 'D',
        alias: [
            'd'
        ],
        value: 'd'
    },
    {
        name: 'Octave',
        alias: [
            'octave'
        ],
        value: 'matlab'
    },
    {
        name: 'QML',
        alias: [
            'qbs',
            'qml'
        ],
        value: 'qml'
    },
    {
        name: 'Prolog',
        alias: [
            'prolog'
        ],
        value: 'prolog'
    },
    {
        name: 'FoxPro',
        alias: [
            'foxpro',
            'purebasic'
        ],
        value: 'purebasic'
    },
    {
        name: 'Scheme',
        alias: [
            'scheme',
            'scm'
        ],
        value: 'scheme'
    },
    {
        name: 'CUDA',
        alias: [
            'cuda',
            'cu'
        ],
        value: 'cpp'
    },
    {
        name: 'Julia',
        alias: [
            'julia',
            'jl'
        ],
        value: 'julia'
    },
    {
        name: 'Racket',
        alias: [
            'racket',
            'rkt'
        ],
        value: 'lisp'
    },
    {
        name: 'Ada',
        alias: [
            'ada',
            'ada95',
            'ada2005'
        ],
        value: 'ada'
    },
    {
        name: 'Tcl',
        alias: [
            'tcl'
        ],
        value: 'tcl'
    },
    {
        name: 'Mathematica',
        alias: [
            'mathematica',
            'mma',
            'nb'
        ],
        value: 'mathematica'
    },
    {
        name: 'Autoit',
        alias: [
            'autoit'
        ],
        value: 'autoit'
    },
    {
        name: 'StandardML',
        alias: [
            'standardmL',
            'sml',
            'standardml'
        ],
        value: 'sml'
    },
    {
        name: 'Objective-J',
        alias: [
            'objective-j',
            'objectivej',
            'obj-j',
            'objj'
        ],
        value: 'objectivec'
    },
    {
        name: 'Smalltalk',
        alias: [
            'smalltalk',
            'squeak',
            'st'
        ],
        value: 'smalltalk'
    },
    {
        name: 'Vala',
        alias: [
            'vala',
            'vapi'
        ],
        value: 'vala'
    },
    {
        name: 'LiveScript',
        alias: [
            'livescript',
            'live-script'
        ],
        value: 'livescript'
    },
    {
        name: 'XQuery',
        alias: [
            'xquery',
            'xqy',
            'xq',
            'xql',
            'xqm'
        ],
        value: 'xquery'
    },
    {
        name: 'PlainText',
        alias: [
            'text',
            'plaintext'
        ],
        value: 'text'
    },
    {
        name: 'Yaml',
        alias: [
            'yaml',
            'yml'
        ],
        value: 'yaml'
    },
    {
        name: 'GraphQL',
        alias: [
            'graphql'
        ],
        value: 'graphql'
    },
    {
        name: 'AppleScript',
        alias: [
            'applescript'
        ],
        value: 'applescript'
    },
    {
        name: 'Clojure',
        alias: [
            'clojure'
        ],
        value: 'clojure'
    },
    {
        name: 'Diff',
        alias: [
            'diff'
        ],
        value: 'diff'
    },
    {
        name: 'VisualBasic',
        alias: [
            'visualbasic'
        ],
        value: 'visual-basic'
    },
    {
        name: 'JSX',
        alias: [
            'jsx'
        ],
        value: 'jsx'
    },
    {
        name: 'TSX',
        alias: [
            'tsx'
        ],
        value: 'tsx'
    },
    {
        name: 'SplunkSPL',
        alias: [
            'splunk-spl'
        ],
        value: 'splunk-spl'
    },
    {
        name: 'Dockerfile',
        alias: [
            'docker',
            'dockerfile'
        ],
        value: 'dockerfile'
    },
    {
        name: 'HCL',
        alias: [
            'hcl',
            'terraform'
        ],
        value: 'hcl'
    },
    {
        name: 'NGINX',
        alias: [
            'nginx'
        ],
        value: 'nginx'
    },
    {
        name: 'Protocol Buffers',
        alias: [
            'protobuf',
            'proto'
        ],
        value: 'protobuf'
    },
    {
        name: 'Handlebars',
        alias: [
            'handlebars',
            'mustache'
        ],
        value: 'handlebars'
    },
    {
        name: 'Gherkin',
        alias: [
            'gherkin',
            'cucumber'
        ],
        value: 'gherkin'
    },
    {
        name: 'ABAP',
        alias: [
            'abap'
        ],
        value: 'abap'
    }
];

});


parcelRegister("9Xp6L", function(module, exports) {

$parcel$export(module.exports, "default", () => $e296c4d390ff4a21$export$2e2bcd8739ae039);
/**
 * Original library: https://github.com/react-syntax-highlighter/react-syntax-highlighter
 * All modifications by Atlassian
 */ /**
 * MIT License
 *
 * Copyright (c) 2019 Conor Hastings
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */ /**
 * __Syntax Highlighter__
 *
 * A syntax highlighter based on top of [refractor](https://github.com/wooorm/refractor).
 * @atlaskit/code uses this under-the-hood, but it is not intended for public consumption.
 * You should be using @atlaskit/code directly.
 */ 
var $c8FD2 = parcelRequire("c8FD2");
var $e296c4d390ff4a21$export$2e2bcd8739ae039 = (0, $c8FD2.default);

});
parcelRegister("c8FD2", function(module, exports) {

$parcel$export(module.exports, "default", () => $64df4f4e00539958$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lp89O = parcelRequire("lp89O");
// Uses the loader method of async bundling
// Instantiates highligher as a singleton, loading refractor only once per page (refractor/prism are singleton modules)
const $64df4f4e00539958$var$generator = (options)=>{
    const { loader: loader } = options;
    // eslint-disable-next-line @repo/internal/react/no-class-components
    class AsyncHighlighter extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).PureComponent {
        static{
            this.astGenerator = null;
        }
        static{
            this.highlightInstance = (0, $lp89O.default);
        }
        // Useful in tests
        static preload() {
            return AsyncHighlighter.loadAstGenerator();
        }
        static loadAstGenerator() {
            AsyncHighlighter.astGeneratorPromise = loader().then((astGenerator)=>{
                AsyncHighlighter.astGenerator = astGenerator;
                return astGenerator;
            });
            return AsyncHighlighter.astGeneratorPromise;
        }
        componentDidMount() {
            if (!AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.loadAstGenerator();
            if (!AsyncHighlighter.astGenerator && AsyncHighlighter.astGeneratorPromise) AsyncHighlighter.astGeneratorPromise.then(()=>{
                this.forceUpdate();
            });
        }
        render() {
            return /*#__PURE__*/ (0, $2OMIu.jsx)(AsyncHighlighter.highlightInstance, {
                ...this.props,
                astGenerator: AsyncHighlighter.astGenerator
            });
        }
    }
    return AsyncHighlighter;
};

const $64df4f4e00539958$var$asyncGenerator = $64df4f4e00539958$var$generator({
    loader: ()=>(parcelRequire("h7ZNl")).then((module)=>{
            // Webpack 3 returns module.exports as default as module, but webpack 4 returns module.exports as module.default
            return module.default || module;
        })
});
var $64df4f4e00539958$export$2e2bcd8739ae039 = $64df4f4e00539958$var$asyncGenerator;

});
parcelRegister("lp89O", function(module, exports) {

$parcel$export(module.exports, "default", () => $a813ccd1d5fae376$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iQkqt = parcelRequire("iQkqt");

var $jVB7m = parcelRequire("jVB7m");
/**
 * Takes in a code string and (in the default behaviour):
 * - Uses refractor to turn it into a tree structure with highlighting metadata
 * - Collapses this tree into lines for a renderer
 * - Passes these lines to a React renderer
 *
 * In future, the final step could have a custom renderer.
 */ const $a813ccd1d5fae376$var$Highlight = /*#__PURE__*/ (0, $5uXOq.memo)(function Highlight({ language: language = 'text', testId: testId, text: text = '', codeTagProps: codeTagProps = {
    className: `language-${language}`
}, showLineNumbers: showLineNumbers = false, firstLineNumber: firstLineNumber = 1, shouldCreateParentElementForLines: shouldCreateParentElementForLines = false, shouldWrapLongLines: shouldWrapLongLines = false, lineProps: lineProps = {}, codeBidiWarnings: codeBidiWarnings, codeBidiWarningLabel: codeBidiWarningLabel, codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled, astGenerator: astGenerator = null, ...rest }) {
    // TODO maybe we call this code or text everywhere; for now we match the API in
    // @atlaskit/codeblock
    const code = text;
    const generatorClassName = 'prismjs';
    const containerProps = {
        ...rest,
        ref: rest.scrollRef,
        'data-testid': testId,
        className: rest.className ? `${generatorClassName} ${rest.className}` : generatorClassName
    };
    if (containerProps.hasOwnProperty('scrollRef')) delete containerProps['scrollRef'];
    if (shouldWrapLongLines) codeTagProps.style = {
        whiteSpace: 'pre-wrap',
        wordBreak: 'break-word'
    };
    else codeTagProps.style = {
        whiteSpace: 'pre'
    };
    const codeBidiWarningConfig = {
        codeBidiWarnings: codeBidiWarnings,
        codeBidiWarningLabel: codeBidiWarningLabel,
        codeBidiWarningTooltipEnabled: codeBidiWarningTooltipEnabled
    };
    // Tree + logic into rows
    const rows = (0, $iQkqt.default)({
        astGenerator: astGenerator,
        code: code,
        language: language,
        shouldCreateParentElementForLines: shouldCreateParentElementForLines || !!shouldWrapLongLines,
        lineProps: lineProps,
        showLineNumbers: showLineNumbers,
        firstLineNumber: firstLineNumber
    });
    // Rows + logic into a renderer
    return (0, $jVB7m.default)({
        containerProps: containerProps,
        codeTagProps: codeTagProps,
        rows: rows,
        codeBidiWarningConfig: codeBidiWarningConfig
    });
});
var $a813ccd1d5fae376$export$2e2bcd8739ae039 = $a813ccd1d5fae376$var$Highlight;

});
parcelRegister("iQkqt", function(module, exports) {

$parcel$export(module.exports, "default", () => $55dc1424d34091d6$export$2e2bcd8739ae039);

var $eJUOt = parcelRequire("eJUOt");

var $eTMIA = parcelRequire("eTMIA");

var $8bliZ = parcelRequire("8bliZ");

var $g6MVu = parcelRequire("g6MVu");
const $55dc1424d34091d6$var$newLineRegex = /\n/g;
function $55dc1424d34091d6$var$getNewLines(str) {
    return str.match($55dc1424d34091d6$var$newLineRegex);
}
function $55dc1424d34091d6$export$2e2bcd8739ae039({ astGenerator: astGenerator, code: code, language: language, shouldCreateParentElementForLines: shouldCreateParentElementForLines, lineProps: lineProps, showLineNumbers: showLineNumbers, firstLineNumber: firstLineNumber = 1 }) {
    const codeTree = (0, $g6MVu.default)(language, code, astGenerator);
    const startingLineNumber = firstLineNumber > 0 ? firstLineNumber : 1;
    const createLine = (0, $eJUOt.default)(lineProps, shouldCreateParentElementForLines, showLineNumbers);
    const newTree = [];
    let lastLineBreakIndex = -1;
    let index = 0;
    // Seems odd we flatten the tree immediately - what work could we do on it more performantly than on the lines?
    const tree = (0, $8bliZ.default)(codeTree);
    while(index < tree.length){
        const testNode = tree[index];
        if (testNode.type === 'text') {
            index++;
            continue;
        }
        const node = testNode;
        const firstChildNode = node.children[0];
        if (firstChildNode.type === 'text') {
            const { value: value } = firstChildNode;
            const newLines = $55dc1424d34091d6$var$getNewLines(value);
            if (newLines) {
                const splitValue = value.split('\n');
                splitValue.forEach((text, i)=>{
                    const lineNumber = newTree.length + startingLineNumber;
                    const newChild = {
                        type: 'text',
                        value: `${text}\n`
                    };
                    // if it's the first line
                    if (i === 0) {
                        const children = tree.slice(lastLineBreakIndex + 1, index).concat((0, $eTMIA.default)({
                            children: [
                                newChild
                            ],
                            className: node.properties.className,
                            lineNumber: lineNumber
                        }));
                        const line = createLine(children, lineNumber);
                        newTree.push(line);
                    // if it's the last line
                    } else if (i === splitValue.length - 1) {
                        const nextNode = tree[index + 1];
                        const stringChild = nextNode && nextNode.children && nextNode.children[0];
                        // Similar to newChild above, but no newline
                        const lastLineInPreviousSpan = {
                            type: 'text',
                            value: `${text}`
                        };
                        if (stringChild) {
                            const newElem = (0, $eTMIA.default)({
                                children: [
                                    lastLineInPreviousSpan
                                ],
                                className: node.properties.className,
                                lineNumber: lineNumber
                            });
                            tree.splice(index + 1, 0, newElem);
                        } else {
                            const children = [
                                lastLineInPreviousSpan
                            ];
                            const line = createLine(children, lineNumber, node.properties.className);
                            newTree.push(line);
                        }
                    // if it's neither the first nor the last line
                    } else {
                        const children = [
                            newChild
                        ];
                        const line = createLine(children, lineNumber, node.properties.className);
                        newTree.push(line);
                    }
                });
                lastLineBreakIndex = index;
            }
        }
        index++;
    }
    if (lastLineBreakIndex !== tree.length - 1) {
        const children = tree.slice(lastLineBreakIndex + 1, tree.length);
        if (children && children.length) {
            const lineNumber = newTree.length + startingLineNumber;
            const line = createLine(children, lineNumber);
            newTree.push(line);
        }
    }
    if (shouldCreateParentElementForLines) return newTree;
    // If shouldCreateParentElementForLines was off, we still have a tree structure we need to flatten
    // We have (RefractorNode | RefractorNode[])[] but need RefractorNode[]
    // This seems like a code smell to review
    return newTree.flat(1);
}

});
parcelRegister("eJUOt", function(module, exports) {

$parcel$export(module.exports, "default", () => $b9ccdbf71436a137$export$2e2bcd8739ae039);

var $eTMIA = parcelRequire("eTMIA");

var $5FOwT = parcelRequire("5FOwT");
function $b9ccdbf71436a137$var$createLineGenerator(lineProps, shouldCreateParentElementForLines, showLineNumbers) {
    return (children, lineNumber, className = [])=>{
        // Needed for more complex line creation
        if (shouldCreateParentElementForLines || className.length > 0) return (0, $eTMIA.default)({
            children: children,
            lineNumber: lineNumber,
            showLineNumbers: showLineNumbers,
            lineProps: lineProps,
            className: className
        });
        else {
            // Simple line creation without the bells and whistles
            if (showLineNumbers && lineNumber) children.unshift((0, $5FOwT.default)(lineNumber));
            return children;
        }
    };
}
var $b9ccdbf71436a137$export$2e2bcd8739ae039 = $b9ccdbf71436a137$var$createLineGenerator;

});
parcelRegister("eTMIA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6df5b208b9d23752$export$2e2bcd8739ae039);

var $5FOwT = parcelRequire("5FOwT");
function $6df5b208b9d23752$export$2e2bcd8739ae039({ children: children, lineNumber: lineNumber, showLineNumbers: showLineNumbers, lineProps: lineProps = {}, className: className = [] }) {
    const propsPassedInFromCodeBlock = typeof lineProps === 'function' ? lineProps(lineNumber) : lineProps;
    const properties = {
        ...propsPassedInFromCodeBlock,
        className: className
    };
    let currentChildren = children;
    if (lineNumber && showLineNumbers) {
        // When syntax highlighting is NOT turned on, the entire LOC is just a single
        // child. We can then happily create the line number and the LOC as siblings...
        if (currentChildren.length === 1) currentChildren = [
            (0, $5FOwT.default)(lineNumber),
            ...currentChildren
        ];
        else // ... However, when syntax highlighting IS on, a span is created for each
        // tokenised node in the AST (eg. <span>import</span><span>React</span>).
        // When shouldWrapLongLines is true, the row becomes `display: flex` and
        // forces all its children to be equal height. This can be a source of
        // visual bugs where a LOC is broken up weirdly into segments.
        //
        //  +---------------------------------------+
        //  | row                                   |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  |  |line| |key    | |keywords| |key   | |
        //  |  |no. | |word   | |        | |word  | |
        //  |  |    | |       | |        | |      | |
        //  |  +----+ +-------+ +--------+ +------+ |
        //  +---------------------------------------+
        //
        // Nesting the children one layer deeper (i.e. creating an extra span)
        // ensures that the line number and the ENTIRE line of code are aligned by
        // the parent flexbox (the row).
        //
        //  +---------------------------------------------+
        //  | row                                         |
        //  | +----+  +--------------------------------+  |
        //  | |line|  | extra span we are creating     |  |
        //  | |no. |  |  +-------+ +--------+ +------+ |  |
        //  | |    |  |  |key    | |keywords| |key   | |  |
        //  | |    |  |  |word   | |        | |word  | |  |
        //  | |    |  |  |       | |        | |      | |  |
        //  | |    |  |  +-------+ +--------+ +------+ |  |
        //  | +----+  +--------------------------------+  |
        //  +---------------------------------------------+
        //
        currentChildren = [
            (0, $5FOwT.default)(lineNumber),
            {
                type: 'element',
                tagName: 'span',
                properties: {
                    className: []
                },
                children: currentChildren
            }
        ];
    }
    return {
        type: 'element',
        tagName: 'span',
        properties: properties,
        children: currentChildren
    };
}

});
parcelRegister("5FOwT", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6257c3f70e94feb$export$2e2bcd8739ae039);
function $c6257c3f70e94feb$export$2e2bcd8739ae039(lineNumber) {
    return {
        type: 'element',
        tagName: 'span',
        properties: {
            key: `line-number--${lineNumber}`,
            className: [
                'comment',
                'linenumber',
                'ds-line-number'
            ],
            // We're placing the lineNumber in a data-attr on an empty span (hence the
            // empty children array below). This allows CodeBlock to use CSS to
            // generate the content in a pseudo-element, which is a fix for a bug
            // where line numbers were being copied (CSS content can't be copied)
            // https://product-fabric.atlassian.net/browse/DSP-2729
            'data-ds--line-number': lineNumber
        },
        children: []
    };
}

});



parcelRegister("8bliZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c9f6debfd276481a$export$2e2bcd8739ae039);

var $eTMIA = parcelRequire("eTMIA");
function $c9f6debfd276481a$export$2e2bcd8739ae039(tree, offset = 0, className = []) {
    let newTree = [];
    for(let i = 0; i < tree.length; i++){
        const node = tree[i];
        if (node.type === 'text') newTree.push((0, $eTMIA.default)({
            children: [
                node
            ],
            lineNumber: offset,
            className: className
        }));
        else if (node.children) {
            const classNames = className.concat(node.properties.className || []);
            $c9f6debfd276481a$export$2e2bcd8739ae039(node.children, offset + 1, classNames).forEach((i)=>newTree.push(i));
        }
    }
    return newTree;
}

});

parcelRegister("g6MVu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8213b6c690eefe35$export$2e2bcd8739ae039);
function $8213b6c690eefe35$export$2e2bcd8739ae039(language, code, astGenerator) {
    if (language === 'text' || !astGenerator) return [
        {
            type: 'text',
            value: code
        }
    ];
    try {
        return astGenerator.highlight(code, language);
    } catch (e) {
        return [
            {
                type: 'text',
                value: code
            }
        ];
    }
}

});


parcelRegister("jVB7m", function(module, exports) {

$parcel$export(module.exports, "default", () => $b98c01cbb865d4c1$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $fBvqm = parcelRequire("fBvqm");
function $b98c01cbb865d4c1$export$2e2bcd8739ae039({ containerProps: containerProps, codeTagProps: codeTagProps, rows: rows, codeBidiWarningConfig: codeBidiWarningConfig }) {
    const renderedRows = rows.map((node, i)=>(0, $fBvqm.default)({
            node: node,
            codeBidiWarningConfig: codeBidiWarningConfig,
            key: `code-segment${i}`
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...containerProps,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("code", {
            ...codeTagProps,
            children: renderedRows
        })
    });
}

});
parcelRegister("fBvqm", function(module, exports) {

$parcel$export(module.exports, "default", () => $2fdda3a2c4411588$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $lrHA4 = parcelRequire("lrHA4");

var $31cgS = parcelRequire("31cgS");

var $d3zI6 = parcelRequire("d3zI6");
function $2fdda3a2c4411588$var$createClassNameString(classNames) {
    return classNames ? classNames.join(' ') : '';
}
function $2fdda3a2c4411588$export$2e2bcd8739ae039({ node: node, codeBidiWarningConfig: codeBidiWarningConfig, key: key }) {
    if (node.type === 'text') {
        const { value: value } = node;
        // occasionally a numeric value is passed when the type is text
        const textValue = `${value}`;
        if (codeBidiWarningConfig.codeBidiWarnings) {
            const decorated = (0, $31cgS.default)(textValue, ({ bidiCharacter: bidiCharacter, index: index })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $lrHA4.default), {
                    bidiCharacter: bidiCharacter,
                    label: codeBidiWarningConfig.codeBidiWarningLabel,
                    tooltipEnabled: codeBidiWarningConfig.codeBidiWarningTooltipEnabled
                }, index));
            return decorated;
        }
        return textValue;
    } else {
        const { properties: properties, tagName: tagName } = node;
        const childrenCreator = (0, $d3zI6.default)(codeBidiWarningConfig);
        const props = {
            ...properties,
            className: $2fdda3a2c4411588$var$createClassNameString(properties.className)
        };
        const children = childrenCreator(node.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(tagName, {
            key: key,
            ...props
        }, children);
    }
}

});
parcelRegister("lrHA4", function(module, exports) {

$parcel$export(module.exports, "default", () => $2e6443bd1dfeaac7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $abxiq = parcelRequire("abxiq");
function $2e6443bd1dfeaac7$export$2e2bcd8739ae039({ testId: testId, bidiCharacter: bidiCharacter, skipChildren: skipChildren, tooltipEnabled: tooltipEnabled, label: label = 'Bidirectional characters change the order that text is rendered. This could be used to obscure malicious code.' }) {
    if (tooltipEnabled) return(// Following patches, this should be updated to use the render props signature which will provide aria attributes.
    // Note: this should be tested, as initial testing did not see attributes work with current tooltip implementation.
    // @ts-ignore: [PIT-1685] Fails in post-office due to backwards incompatibility issue with React 18
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3bDjY.default), {
        content: label,
        tag: $2e6443bd1dfeaac7$var$CustomizedTagWithRef,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
            testId: testId,
            bidiCharacter: bidiCharacter,
            children: skipChildren ? null : bidiCharacter
        })
    }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $abxiq.Decorator), {
        testId: testId,
        bidiCharacter: bidiCharacter,
        children: skipChildren ? null : bidiCharacter
    });
}
const $2e6443bd1dfeaac7$var$CustomizedTagWithRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef((props, ref)=>{
    const { children: children, ...rest } = props;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        ...rest,
        ref: ref,
        children: children
    });
});

});
parcelRegister("abxiq", function(module, exports) {

$parcel$export(module.exports, "Decorator", () => $59fdc1b7b0ae96c9$export$a592b67c93d52467);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jldZL = parcelRequire("jldZL");
const $59fdc1b7b0ae96c9$var$decoration = {
    root: "_kqswh2mm _szpl2smr _dsq41wug _1xyt1b66 _123w1b66 _15nnze3t _rxygze3t _1a354jg8 _1j6r1odn _1uakf6fq _1kt9y7el _is06wx40 _1rus1tzq _1cfcvrvc _24gj1h6o _19o61h6o _cfu1116y _1rbawx40 _1xqc1rd4"
};
function $59fdc1b7b0ae96c9$export$a592b67c93d52467({ bidiCharacter: bidiCharacter, children: children, testId: testId }) {
    const bidiCharacterCode = $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $5uXOq.Fragment), {
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
                "data-testid": testId,
                "data-bidi-character-code": bidiCharacterCode,
                // This is set to true so that the content is not read out by
                // screen readers as the content includes angle brackets for
                // visual decoration purposes.
                // We use a visually hidden `mark` element below for screen readers
                "aria-hidden": "true",
                className: (0, $bwpsq.default)([
                    $59fdc1b7b0ae96c9$var$decoration.root
                ]),
                children: children
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jldZL.default), {
                testId: testId && `${testId}--visually-hidden`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)("mark", {
                    children: bidiCharacterCode
                })
            })
        ]
    });
}
function $59fdc1b7b0ae96c9$var$getBidiCharacterCode(bidiCharacter) {
    const bidiCharacterCode = bidiCharacter.codePointAt(0)?.toString(16);
    return `U+${bidiCharacterCode}`;
}

});


parcelRegister("31cgS", function(module, exports) {

$parcel$export(module.exports, "default", () => $e16562bd8c2aca9b$export$2e2bcd8739ae039);
const $e16562bd8c2aca9b$export$ecb256e6a1f5ee7e = /[\u202A-\u202E\u2066-\u2069]/g;
function $e16562bd8c2aca9b$export$2e2bcd8739ae039(originalText, decorate) {
    const matches = [
        ...originalText.matchAll($e16562bd8c2aca9b$export$ecb256e6a1f5ee7e)
    ];
    if (matches.length === 0) // No matches encountered, so we return the originalText value
    return originalText;
    let children = [];
    let mappedTo = 0;
    for (const match of matches){
        if (mappedTo !== match.index) // There were unmatched characters prior to this match which haven't been
        // mapped to the children.
        // Add them as plain text.
        children.push(originalText.substring(mappedTo, match.index));
        children.push(decorate({
            bidiCharacter: match[0],
            index: match.index
        }));
        // While index is guaranteed to be present, it needs to be asserted due
        // to a limitation of typescripts regex handling
        //
        // https://github.com/microsoft/TypeScript/issues/36788
        // Decorate bidi character
        mappedTo = match.index + match[0].length;
    }
    if (mappedTo !== originalText.length) // There is text following the final match, which needs to be mapped
    // to the children.
    // Added as plain text.
    children.push(originalText.substring(mappedTo, originalText.length));
    // return the mapped children with decorated bidi characters
    return children;
}

});

parcelRegister("d3zI6", function(module, exports) {

$parcel$export(module.exports, "default", () => $dcbc4a00f80b5d8f$export$2e2bcd8739ae039);

var $fBvqm = parcelRequire("fBvqm");
function $dcbc4a00f80b5d8f$export$2e2bcd8739ae039(codeBidiWarningConfig) {
    let childrenCount = 0;
    return (children)=>{
        childrenCount += 1;
        return children.map((child, i)=>(0, $fBvqm.default)({
                node: child,
                codeBidiWarningConfig: codeBidiWarningConfig,
                key: `code-segment-${childrenCount}-${i}`
            }));
    };
}

});




parcelRegister("h7ZNl", function(module, exports) {

let $c783064bdbac6310$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c783064bdbac6310$var$load("epeUg").then(()=>parcelRequire('5zvIl'));

});




parcelRegister("irzxp", function(module, exports) {

$parcel$export(module.exports, "CopyAction", () => $64e12044af483692$export$958df07cbf9735fc);
$parcel$export(module.exports, "ActionContainer", () => $64e12044af483692$export$37ab3bdebc286ca);

var $5uXOq = parcelRequire("5uXOq");

var $ldJSL = parcelRequire("ldJSL");

var $3Fq5M = parcelRequire("3Fq5M");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");

var $fEogx = parcelRequire("fEogx");
const $64e12044af483692$export$2ce9877c9c1aa16 = {
    PROMPT: 'Copy',
    SUCCESS: 'Copied!',
    FAILURE: 'Copy to clipboard failed'
};
const $64e12044af483692$export$958df07cbf9735fc = ({ source: source, actionSubjectId: actionSubjectId })=>{
    const [tooltipMessage, setTooltipMessage] = (0, $5uXOq.useState)($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    const handleSuccess = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.SUCCESS);
    }, [
        setTooltipMessage
    ]);
    const handleError = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.FAILURE);
    }, [
        setTooltipMessage
    ]);
    const writeToClipboard = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        actionSubjectId && (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clicked button', actionSubjectId);
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        navigator.clipboard.writeText(source).then(handleSuccess, handleError);
    }, [
        source,
        handleSuccess,
        handleError,
        actionSubjectId
    ]);
    const resetMessage = (0, $5uXOq.useCallback)(()=>{
        setTooltipMessage($64e12044af483692$export$2ce9877c9c1aa16.PROMPT);
    }, [
        setTooltipMessage
    ]);
    function shouldRender() {
        if (typeof document !== 'undefined') // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return Boolean(navigator?.clipboard?.writeText);
    }
    return shouldRender() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fEogx.Action), {
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($3Fq5M))),
        label: tooltipMessage,
        onClick: writeToClipboard,
        onMouseOver: resetMessage,
        onFocus: resetMessage,
        "aria-live": "assertive",
        "aria-atomic": "true",
        name: "Copy"
    }) : null;
};
const $64e12044af483692$var$stopPropagation = (event)=>event.stopPropagation();
const $64e12044af483692$export$37ab3bdebc286ca = ({ children: children })=>/**
	 * This element uses an `onMouseDown` to block event propagation
	 * to its parent but is not itself interactive.
	 */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $64e12044af483692$var$absolutePositionWrapperStyles,
        onMouseDown: $64e12044af483692$var$stopPropagation
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), {
        label: "actions"
    }, children));
const $64e12044af483692$var$absolutePositionWrapperStyles = (0, $8CUq3.xcss)({
    position: 'absolute',
    top: 'space.0',
    right: 'space.0',
    padding: 'space.050',
    zIndex: 'flag'
});

});
parcelRegister("fEogx", function(module, exports) {

$parcel$export(module.exports, "Action", () => $e6da05ade6347218$export$e19cd5f9376f8cee);

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $3bDjY = parcelRequire("3bDjY");
const $e6da05ade6347218$export$e19cd5f9376f8cee = ({ icon: icon, label: label, tooltipLabel: tooltipLabel, isLoading: isLoading, ...buttonProps })=>{
    const updateTooltip = (0, $5uXOq.useRef)();
    (0, $5uXOq.useLayoutEffect)(()=>{
        updateTooltip.current?.();
    }, [
        tooltipLabel,
        label
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: ({ update: update })=>{
            updateTooltip.current = update;
            return tooltipLabel || label;
        },
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        isLoading: isLoading,
        appearance: "subtle",
        icon: icon,
        label: label,
        spacing: "compact",
        ...buttonProps
    }));
};

});




parcelRegister("apkY5", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a9f0fe74b5e0197$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $34Rrn = parcelRequire("34Rrn");

var $gtreQ = parcelRequire("gtreQ");

var $6s1PB = parcelRequire("6s1PB");

var $7R4eB = parcelRequire("7R4eB");

var $3fAi8 = parcelRequire("3fAi8");

var $64qgp = parcelRequire("64qgp");

var $7AVqz = parcelRequire("7AVqz");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$8a9f0fe74b5e0197$export$2e2bcd8739ae039 = ({ id: id, issueKey: issueKey, intl: intl, onPrimaryActionClick: onPrimaryActionClick, ...props })=>{
    const { formatMessage: formatMessage } = intl;
    const [issueType] = (0, $3fAi8.useFieldValue)({
        issueKey: issueKey,
        fieldKey: 'issuetype'
    });
    const workType = issueType?.name;
    const getAction = ()=>{
        if (workType && (0, $64qgp.isWorkTypeAvgLength)(workType) && (0, $6s1PB.expVal)('jira-itr-work-type-exp-1', 'isEnabled', false)) return (0, $7AVqz.default).createdIssueIsFilteredLinkIssueTerminologyRefreshM4;
        if ((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) return (0, $7AVqz.default).createdIssueIsFilteredLinkIssueTermRefresh;
        return (0, $7AVqz.default).createdIssueIsFilteredLink;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7R4eB.default), {
        messageId: props.messageId ?? `software-backlog.flags.custom-filter-failed.warning-flag.${id}`,
        messageType: props.messageType ?? 'transactional',
        id: id,
        key: id,
        title: formatMessage((0, $7AVqz.default).createdIssueIsFilteredTitle, {
            issueKey: issueKey
        }),
        description: formatMessage((0, $7AVqz.default).createdIssueIsFilteredDescription),
        icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($34Rrn))), {
            color: "var(--ds-icon-warning, #E56910)",
            spacing: "spacious",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($gtreQ))),
            LEGACY_primaryColor: "var(--ds-icon-warning, #E56910)",
            label: formatMessage((0, $7AVqz.default).warningLabel)
        }),
        actions: [
            {
                content: formatMessage(getAction(), {
                    workType: workType
                }),
                onClick: ()=>{
                    onPrimaryActionClick(id);
                }
            }
        ]
    });
};

});

parcelRegister("3h5zX", function(module, exports) {

$parcel$export(module.exports, "default", () => $2850163593582679$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");

var $67Z81 = parcelRequire("67Z81");

var $9Frjj = parcelRequire("9Frjj");
const $2850163593582679$var$mapStateToProps = (state)=>({
        boardConfigUrl: (0, $eph8m.getColumnStatusMappingUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state))
    });
var $2850163593582679$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($2850163593582679$var$mapStateToProps, {})((0, $9Frjj.default));

});
parcelRegister("9Frjj", function(module, exports) {

$parcel$export(module.exports, "default", () => $f96fb1c45c919495$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3KRpp = parcelRequire("3KRpp");

var $koVbs = parcelRequire("koVbs");

var $7AVqz = parcelRequire("7AVqz");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$f96fb1c45c919495$export$2e2bcd8739ae039 = ({ onDismissed: onDismissed, id: id, boardConfigUrl: boardConfigUrl, canUserConfigureBoard: canUserConfigureBoard })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const actions = canUserConfigureBoard ? [
        {
            content: formatMessage((0, $7AVqz.default).manageStatusesLink),
            href: boardConfigUrl
        }
    ] : [];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3KRpp.ErrorFlag), {
        id: id,
        onDismissed: onDismissed,
        title: formatMessage((0, $7AVqz.default).noColumnFailureTitle),
        description: formatMessage(canUserConfigureBoard ? (0, $7AVqz.default).noColumnFailureAdminDescription : (0, $7AVqz.default).noColumnFailureNonAdminDescription),
        actions: actions
    });
};

});


parcelRegister("2I1lL", function(module, exports) {

$parcel$export(module.exports, "UndoFlag", () => $17c673306b86f3c5$export$bbd014b7afeff20f);

var $5uXOq = parcelRequire("5uXOq");

var $d4xRU = parcelRequire("d4xRU");

var $koVbs = parcelRequire("koVbs");

var $7D59a = parcelRequire("7D59a");

var $bkCF5 = parcelRequire("bkCF5");

var $67sX6 = parcelRequire("67sX6");

var $hv2Hm = parcelRequire("hv2Hm");
const $17c673306b86f3c5$var$DEFAULT_TIME_TO_COMPLETE = 8000;
function $17c673306b86f3c5$export$1cca3de68d9dd76a({ flag: flag, onDismissFlag: onDismissFlag }) {
    const hasDismissed = (0, $5uXOq.useRef)(false);
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const onClickUndo = (0, $7D59a.useEvent)(()=>{
        if (hasDismissed.current) return;
        hasDismissed.current = true;
        dispatch((0, $bkCF5.undoFlagPerformUndo)(flag.id));
        onDismissFlag(flag.id);
    });
    const onDismissed = (0, $7D59a.useEvent)(()=>{
        if (hasDismissed.current) return;
        hasDismissed.current = true;
        onDismissFlag(flag.id);
        dispatch((0, $bkCF5.undoFlagPerformCommit)(flag.id));
    });
    return {
        onClickUndo: onClickUndo,
        onDismissed: onDismissed
    };
}
function $17c673306b86f3c5$export$9d0f4ae0a47d1ddb(onDismissed) {
    (0, $5uXOq.useEffect)(()=>{
        const timeoutId = setTimeout(()=>{
            onDismissed();
        }, $17c673306b86f3c5$var$DEFAULT_TIME_TO_COMPLETE);
        return ()=>{
            clearTimeout(timeoutId);
            onDismissed();
        };
    }, [
        onDismissed
    ]);
}
function $17c673306b86f3c5$export$bbd014b7afeff20f({ flag: flag, icon: icon, onDismissFlag: onDismissFlag }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { onClickUndo: onClickUndo, onDismissed: onDismissed } = $17c673306b86f3c5$export$1cca3de68d9dd76a({
        flag: flag,
        onDismissFlag: onDismissFlag
    });
    $17c673306b86f3c5$export$9d0f4ae0a47d1ddb(onDismissed);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d4xRU.default), {
        id: flag.id,
        icon: icon,
        testId: "software-board.flags.undo-flag.ak-flag",
        title: formatMessage(flag.titleMessage, flag.context),
        description: formatMessage(flag.descriptionMessage, flag.context),
        actions: [
            ...flag.links.map((action)=>({
                    ...action,
                    content: formatMessage(action.content, flag.context),
                    target: '_blank'
                })),
            {
                testId: 'software-board.flags.undo-flag.ak-flag-undo-button',
                content: formatMessage((0, $hv2Hm.messages).revertChanges),
                onClick: onClickUndo
            }
        ],
        onDismissed: onDismissed
    });
}

});
parcelRegister("hv2Hm", function(module, exports) {

$parcel$export(module.exports, "messages", () => $56e5fa3c0865e8c3$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $56e5fa3c0865e8c3$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    revertChanges: {
        "id": "software.main.flags.undo-flag.revert-changes",
        "defaultMessage": "Undo"
    }
});

});




parcelRegister("lkgHI", function(module, exports) {

$parcel$export(module.exports, "default", () => $eae5c0676be4d6ed$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $5mTgl = parcelRequire("5mTgl");

var $dtbmY = parcelRequire("dtbmY");
var $eae5c0676be4d6ed$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>({
        numIssues: (0, $5mTgl.workIssuesSelector)(state).length
    }), {})((0, $dtbmY.default));

});
parcelRegister("dtbmY", function(module, exports) {

$parcel$export(module.exports, "default", () => $4352167773cab047$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dF9Z3 = parcelRequire("dF9Z3");
function $4352167773cab047$export$2e2bcd8739ae039({ numIssues: numIssues }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF9Z3.default), {
        analyticsAttributes: {
            numIssues: numIssues
        }
    });
}

});
parcelRegister("dF9Z3", function(module, exports) {

$parcel$export(module.exports, "isMacOS", () => $3300b05877fade72$export$6159e43e50a41987);
$parcel$export(module.exports, "useGlobalSearch", () => $3300b05877fade72$export$1df85516f1b3e335);
$parcel$export(module.exports, "default", () => $3300b05877fade72$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fW62l = parcelRequire("fW62l");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $3300b05877fade72$export$6159e43e50a41987 = ()=>Boolean(navigator && /^Mac/.test(navigator.platform));
const $3300b05877fade72$export$1df85516f1b3e335 = (/** Callback to be fired when global search is used */ callback, getGlobalDocument = ()=>document)=>{
    (0, $5uXOq.useEffect)(()=>{
        const trackGlobalSearch = (event)=>{
            const isMacOs = $3300b05877fade72$export$6159e43e50a41987();
            if (isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('f') && event.metaKey || !isMacOs && event.keyCode === (0, (/*@__PURE__*/$parcel$interopDefault($fW62l)))('f') && event.ctrlKey) callback({
                isMacOs: isMacOs,
                event: event
            });
        };
        getGlobalDocument().addEventListener('keydown', trackGlobalSearch);
        return ()=>getGlobalDocument().removeEventListener('keydown', trackGlobalSearch);
    }, [
        callback,
        getGlobalDocument
    ]);
};
const $3300b05877fade72$var$GlobalSearchTracker = ({ getGlobalDocument: getGlobalDocument = ()=>document, fireAnalytics: fireAnalytics = (0, $8zOmE.fireTrackAnalytics), analyticsAttributes: analyticsAttributes = {} })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onGlobalSearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'isMacOs' implicitly has an 'any' type.
    ({ isMacOs: isMacOs })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'triggered',
            actionSubject: 'globalSearch'
        });
        const attributes = {
            ...analyticsAttributes,
            isMacOs: isMacOs
        };
        fireAnalytics(analyticsEvent, 'globalSearch triggered', attributes);
    }, [
        analyticsAttributes,
        createAnalyticsEvent,
        fireAnalytics
    ]);
    $3300b05877fade72$export$1df85516f1b3e335(onGlobalSearch, getGlobalDocument);
    return null;
};
var $3300b05877fade72$export$2e2bcd8739ae039 = $3300b05877fade72$var$GlobalSearchTracker;

});



parcelRegister("7CZZJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d715143425ca28bf$export$2e2bcd8739ae039);

var $3llBT = parcelRequire("3llBT");

var $jS4lj = parcelRequire("jS4lj");

var $3HwlS = parcelRequire("3HwlS");

var $bC2fB = parcelRequire("bC2fB");

var $4R6GH = parcelRequire("4R6GH");

var $2xFXk = parcelRequire("2xFXk");


var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $kc6Ry = parcelRequire("kc6Ry");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $7tZOY = parcelRequire("7tZOY");

var $3SShY = parcelRequire("3SShY");

var $XvlUo = parcelRequire("XvlUo");

var $lFerq = parcelRequire("lFerq");

var $7jxaT = parcelRequire("7jxaT");

var $7hxB7 = parcelRequire("7hxB7");

var $7lFcC = parcelRequire("7lFcC");

var $j3072 = parcelRequire("j3072");

var $9eTg7 = parcelRequire("9eTg7");

var $3NePp = parcelRequire("3NePp");
const $d715143425ca28bf$export$c31df4bd766f9c35 = (state)=>{
    const isTabNavigation = (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const isCompleteSprintButtonVisible = (0, $9eTg7.getIsCompleteSprintButtonVisible)(state);
    // We should remove Sprint Remaining Days entirely when removing Capability.IS_TAB_NAVIGATION
    const isSprintRemainingDaysVisible = !isTabNavigation && !!(0, $ebHh7.remainingDaysSelector)(state).remainingDays;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const isIncrementPlanningBoard = (0, $67Z81.getIsIncrementPlanningBoard)(state);
    const boardType = (0, $67Z81.getBoardType)(state);
    const isJSWBoard = (0, $67Z81.getIsJSWBoard)(state);
    return {
        baseUrl: (0, $67Z81.contextPathSelector)(state),
        locale: (0, $67Z81.getLocale)(state),
        sprintGoal: (0, $ebHh7.activeSprintGoalSelector)(state),
        isMenuVisible: !!(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || isCMPBoard || (0, $3HwlS.getWillShowNav4)(),
        isHeaderCompactMode: (0, $k8auG.getIsHeaderCompactMode)(state),
        isCMPBoard: isCMPBoard,
        isJSWBoard: isJSWBoard,
        isIncrementPlanningBoard: isIncrementPlanningBoard,
        rapidViewId: (0, $67Z81.rapidViewIdSelector)(state),
        Menu: $7jxaT.default,
        ReleaseVersion: $7hxB7.default,
        isReleaseVersionVisible: isCMPBoard && boardType === 'KANBAN' && (0, $5mTgl.isReleasesFeatureEnabled)(state),
        ControlsBar: $3SShY.default,
        Title: $j3072.default,
        // New AutomationMenu is NOT just for CMP now. We should use it for TMP as well
        AutomationMenu: (0, $3llBT.BoardMenu),
        isCompleteSprintButtonVisible: isCompleteSprintButtonVisible,
        hasManageSprintPermission: (0, $ebHh7.hasManageSprintPermission)(state),
        CompleteSprintButton: $7tZOY.default,
        FavoriteButton: $lFerq.default,
        isSprintRemainingDaysVisible: isSprintRemainingDaysVisible,
        SprintRemainingDays: $7lFcC.default,
        BoardOperations: $XvlUo.default,
        BreadcrumbRenderer: $jS4lj.default,
        // For UIF this will always be true but the AutomationMenu is permission aware
        canManageAutomations: !!(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$7c16e92435670968],
        projectKey: (0, $67Z81.projectKeySelector)(state),
        projectId: (0, $67Z81.projectIdSelector)(state),
        projectName: (0, $67Z81.projectNameSelector)(state),
        projectType: 'software',
        isSprintsEnabled: (0, $ebHh7.isSprintsEnabled)(state),
        shouldShowStandupsFeature: (0, $4R6GH.fg)('jira-warepil-standup-toggle') ? (0, $k8auG.isStandupsEnabled)(state) : true,
        hasActiveSprint: (0, $ebHh7.hasActiveSprintsSelector)(state),
        selectedIssueKeys: (0, $9OPlz.selectedIssueKeysSelector)(state),
        selectedIssueIds: (0, $9OPlz.selectedIssueIdsSelector)(state),
        boardName: (0, $67Z81.getBoardName)(state),
        shouldRenderFavouriteButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_FAVOURITE_HEADER_BUTTON),
        shouldRenderAutomationButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_AUTOMATION_HEADER_BUTTON),
        shouldRenderReleaseButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_RELEASE_MENU_BUTON),
        shouldRenderFeedbackCollectorButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_FEEDBACK_COLLECTOR_BUTTON),
        shouldRenderFullscreenButton: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_FULLSCREEN_BUTTON),
        shouldRenderViewSettingsCardDetailsOption: (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_VIEW_SETTINGS_CARD_DETAILS_OPTION),
        boardType: (0, $67Z81.getBoardTypeForAnalytics)(state),
        isTabNavigation: isTabNavigation
    };
};
var $d715143425ca28bf$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($d715143425ca28bf$export$c31df4bd766f9c35, {})((0, $3NePp.default));

});
parcelRegister("3llBT", function(module, exports) {

$parcel$export(module.exports, "BoardMenu", () => $539c0d3c46b99f36$export$17445232de9c085a);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $4R6GH = parcelRequire("4R6GH");

var $b71gk = parcelRequire("b71gk");

var $2s6Sm = parcelRequire("2s6Sm");

var $kBike = parcelRequire("kBike");

var $iKM9r = parcelRequire("iKM9r");

var $7IeyM = parcelRequire("7IeyM");

var $iW6Ob = parcelRequire("iW6Ob");

var $jJ8Br = parcelRequire("jJ8Br");

var $3jcRv = parcelRequire("3jcRv");
const $539c0d3c46b99f36$var$TARGET_NAME = 'automation-menu-target';
const $539c0d3c46b99f36$var$WrappedMenuButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: $539c0d3c46b99f36$var$TARGET_NAME
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jJ8Br.default), {
        ...props,
        ref: ref
    })));
/**
 * TMP only automation menu
 * @deprecated - Use project aware menu always where possible.
 */ const $539c0d3c46b99f36$var$AutomationMenu = (props)=>{
    const { canManageAutomations: canManageAutomations = false, ...popupProps } = props;
    const popup = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jcRv.default), {
        ...popupProps,
        Trigger: $539c0d3c46b99f36$var$WrappedMenuButton,
        canManageAutomations: canManageAutomations
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "automation-menu"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kBike.MenuContextContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKM9r.SelectedIssuesContainer), null, popup)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: $539c0d3c46b99f36$var$TARGET_NAME,
        variables: {
            projectId: props.projectId,
            projectKey: props.projectKey
        }
    })));
};
const $539c0d3c46b99f36$var$ProjectAwareAutomationMenu = (props)=>{
    const project = (0, $iW6Ob.useProjectService)();
    const { isProjectAdmin: isProjectAdmin } = (0, $7IeyM.usePermissionService)(project && project.projectId);
    if (project) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($539c0d3c46b99f36$var$AutomationMenu, {
        ...props,
        isSimplified: project.isSimplified,
        isUIF: props.isUIF ?? false,
        projectType: project.projectType,
        projectId: project.projectId,
        projectKey: project.projectKey,
        canManageAutomations: isProjectAdmin
    });
    return null;
};
const $539c0d3c46b99f36$export$17445232de9c085a = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($539c0d3c46b99f36$var$ProjectAwareAutomationMenu, {
        ...props,
        items: (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $2s6Sm.boardMenuItems) : (0, $2s6Sm.boardMenuItemsOld)
    });
var $539c0d3c46b99f36$export$2e2bcd8739ae039 = $539c0d3c46b99f36$var$AutomationMenu;

});
parcelRegister("2s6Sm", function(module, exports) {

$parcel$export(module.exports, "boardMenuItems", () => $6ca9e786e4f5c84b$export$d062faac00f93181);
$parcel$export(module.exports, "boardMenuItemsOld", () => $6ca9e786e4f5c84b$export$9bbe40a6618b2606);

var $fb5SF = parcelRequire("fb5SF");

var $acknU = parcelRequire("acknU");

var $eyYcL = parcelRequire("eyYcL");

var $hPcwl = parcelRequire("hPcwl");

var $gqoFA = parcelRequire("gqoFA");

var $ktvcB = parcelRequire("ktvcB");

var $koBIe = parcelRequire("koBIe");

var $1GEsl = parcelRequire("1GEsl");
const $6ca9e786e4f5c84b$export$d062faac00f93181 = [
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eyYcL))),
        title: (0, $koBIe.default).issueTitleIssueTerminologyRefreshM4,
        description: (0, $koBIe.default).issueDescription,
        filter: (0, $1GEsl.filters).CATEGORY_ISSUE
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fb5SF))),
        title: (0, $koBIe.default).devopsTitle,
        description: (0, $koBIe.default).devopsDescription,
        filter: (0, $1GEsl.filters).CATEGORY_DEVOPS
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))),
        title: (0, $koBIe.default).devopsBuildAndDeployTitle,
        description: (0, $koBIe.default).devopsBuildAndDeployDescription,
        filter: (0, $1GEsl.filters).CATEGORY_DEVOPS
    },
    {
        Icon: (0, $ktvcB.WebhookIcon),
        title: (0, $koBIe.default).integrationTitle,
        description: (0, $koBIe.default).integrationDescription,
        filter: (0, $1GEsl.filters).CATEGORY_INTEGRATION
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($acknU))),
        title: (0, $koBIe.default).scheduleTitle,
        description: (0, $koBIe.default).scheduleDescription,
        filter: (0, $1GEsl.filters).CATEGORY_SCHEDULE
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqoFA))),
        title: (0, $koBIe.default).allTriggersTitle,
        description: (0, $koBIe.default).allTriggersDescription,
        filter: (0, $1GEsl.filters).CATEGORY_ALL
    }
];
const $6ca9e786e4f5c84b$export$9bbe40a6618b2606 = [
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($eyYcL))),
        title: (0, $koBIe.default).issueTitle,
        description: (0, $koBIe.default).issueDescription,
        filter: (0, $1GEsl.filters).CATEGORY_ISSUE
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($fb5SF))),
        title: (0, $koBIe.default).devopsTitle,
        description: (0, $koBIe.default).devopsDescription,
        filter: (0, $1GEsl.filters).CATEGORY_DEVOPS
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($hPcwl))),
        title: (0, $koBIe.default).devopsBuildAndDeployTitle,
        description: (0, $koBIe.default).devopsBuildAndDeployDescription,
        filter: (0, $1GEsl.filters).CATEGORY_DEVOPS
    },
    {
        Icon: (0, $ktvcB.WebhookIcon),
        title: (0, $koBIe.default).integrationTitle,
        description: (0, $koBIe.default).integrationDescription,
        filter: (0, $1GEsl.filters).CATEGORY_INTEGRATION
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($acknU))),
        title: (0, $koBIe.default).scheduleTitle,
        description: (0, $koBIe.default).scheduleDescription,
        filter: (0, $1GEsl.filters).CATEGORY_SCHEDULE
    },
    {
        Icon: (0, (/*@__PURE__*/$parcel$interopDefault($gqoFA))),
        title: (0, $koBIe.default).allTriggersTitle,
        description: (0, $koBIe.default).allTriggersDescription,
        filter: (0, $1GEsl.filters).CATEGORY_ALL
    }
];

});
parcelRegister("fb5SF", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0df86e9f58670341f0be02decae626a5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b0cc71de29a7bd8c$var$_react = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b0cc71de29a7bd8c$var$_pullRequest = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("hXgVM")));

var $b0cc71de29a7bd8c$var$_pullrequests = $b0cc71de29a7bd8c$var$_interopRequireDefault((parcelRequire("dMzAR")));
function $b0cc71de29a7bd8c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PullRequestIcon.
 * This component is PullRequestIcon, with `UNSAFE_fallbackIcon` set to "BitbucketPullrequestsIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for pull requests.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b0cc71de29a7bd8c$var$PullRequestIcon = (props)=>/*#__PURE__*/ $b0cc71de29a7bd8c$var$_react.default.createElement($b0cc71de29a7bd8c$var$_pullRequest.default, Object.assign({
        LEGACY_fallbackIcon: $b0cc71de29a7bd8c$var$_pullrequests.default
    }, props));
$b0cc71de29a7bd8c$var$PullRequestIcon.Name = 'PullRequestIconMigration';
var $b0cc71de29a7bd8c$var$_default = module.exports.default = $b0cc71de29a7bd8c$var$PullRequestIcon;

});
parcelRegister("dMzAR", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a08b5e30d2d36873$var$_react = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $a08b5e30d2d36873$var$_pullRequest = $a08b5e30d2d36873$var$_interopRequireDefault((parcelRequire("hXgVM")));
function $a08b5e30d2d36873$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $a08b5e30d2d36873$var$BitbucketPullrequestsIcon = (props)=>/*#__PURE__*/ $a08b5e30d2d36873$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M18 15.2V11c0-1.7-1.3-3-3-3h-1.9l.8-.8c.3-.3.3-.8 0-1.1s-.8-.3-1.1 0l-2.3 2.3c-.3.4-.3.9 0 1.2l2.3 2.3c.2.2.3.2.5.2q.3 0 .6-.3c.3-.3.3-.8 0-1.1l-.7-.7H15c.6 0 1 .4 1 1v4.2c-1.2.4-2 1.5-2 2.8 0 1.7 1.3 3 3 3s3-1.3 3-3c0-1.3-.8-2.4-2-2.8M17 19c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1M7 3C5.4 3 4 4.3 4 6c0 1.3.8 2.4 2 2.8V20c0 .6.4 1 1 1s1-.4 1-1V8.8c1.2-.4 2-1.5 2-2.8 0-1.7-1.3-3-3-3m0 4c-.5 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1"/></svg>`
    }, props, {
        newIcon: $a08b5e30d2d36873$var$_pullRequest.default
    }));
$a08b5e30d2d36873$var$BitbucketPullrequestsIcon.displayName = 'BitbucketPullrequestsIcon';
var $a08b5e30d2d36873$var$_default = module.exports.default = $a08b5e30d2d36873$var$BitbucketPullrequestsIcon;

});


parcelRegister("hPcwl", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::da6815f1e303f26a4e473874c26eef5d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $cfa0e970215956ee$var$_react = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $cfa0e970215956ee$var$_cloudArrowUp = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("ePJ5X")));

var $cfa0e970215956ee$var$_upload = $cfa0e970215956ee$var$_interopRequireDefault((parcelRequire("aPRJS")));
function $cfa0e970215956ee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for CloudArrowUpIcon.
 * This component is CloudArrowUpIcon, with `UNSAFE_fallbackIcon` set to "UploadIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: deployments in Jira.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $cfa0e970215956ee$var$CloudArrowUpIcon = (props)=>/*#__PURE__*/ $cfa0e970215956ee$var$_react.default.createElement($cfa0e970215956ee$var$_cloudArrowUp.default, Object.assign({
        LEGACY_fallbackIcon: $cfa0e970215956ee$var$_upload.default
    }, props));
$cfa0e970215956ee$var$CloudArrowUpIcon.Name = 'CloudArrowUpIconMigration';
var $cfa0e970215956ee$var$_default = module.exports.default = $cfa0e970215956ee$var$CloudArrowUpIcon;

});
parcelRegister("aPRJS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $7e385a40dadea6dc$var$_react = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $7e385a40dadea6dc$var$_cloudArrowUp = $7e385a40dadea6dc$var$_interopRequireDefault((parcelRequire("ePJ5X")));
function $7e385a40dadea6dc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $7e385a40dadea6dc$var$UploadIcon = (props)=>/*#__PURE__*/ $7e385a40dadea6dc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path d="M11.208 9.32 9.29 11.253a1 1 0 0 0 0 1.409.98.98 0 0 0 1.397 0l1.29-1.301 1.336 1.347a.98.98 0 0 0 1.397.001 1 1 0 0 0 .001-1.408l-1.965-1.98a1.08 1.08 0 0 0-1.538-.001"/><path d="m11 10.007.001 9.986c0 .557.448 1.008 1 1.007.553 0 1-.45 1-1.007L13 10.006C13 9.451 12.552 9 12 9s-1.001.451-1 1.007"/><path d="M7.938 5.481a5 5 0 0 0-.777-.063C4.356 5.419 2 7.62 2 10.499 2 13.408 4.385 16 7.1 16h2.881v-1.993H7.1c-1.657 0-3.115-1.663-3.115-3.508 0-1.778 1.469-3.087 3.104-3.087h.012c.389 0 .686.051.97.15l.17.063c.605.248.875-.246.875-.246l.15-.267c.73-1.347 2.201-2.096 3.716-2.119a4.14 4.14 0 0 1 4.069 3.644l.046.34s.071.525.665.525c.013 0 .012.005.023.005h.254c1.136 0 1.976.959 1.976 2.158 0 1.207-.987 2.342-2.07 2.342h-3.964V16h3.964C20.105 16 22 13.955 22 11.665c0-1.999-1.312-3.663-3.138-4.074-.707-2.707-3.053-4.552-5.886-4.591-1.975.021-3.901.901-5.038 2.481"/></g></svg>`
    }, props, {
        newIcon: $7e385a40dadea6dc$var$_cloudArrowUp.default
    }));
$7e385a40dadea6dc$var$UploadIcon.displayName = 'UploadIcon';
var $7e385a40dadea6dc$var$_default = module.exports.default = $7e385a40dadea6dc$var$UploadIcon;

});


parcelRegister("gqoFA", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::e01b3a49828b125b4f7b5aa036782ad5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $bf5235f9211f74df$var$_react = $bf5235f9211f74df$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $bf5235f9211f74df$var$_videoPlay = $bf5235f9211f74df$var$_interopRequireDefault((parcelRequire("b7NAp")));

var $bf5235f9211f74df$var$_vidPlay = $bf5235f9211f74df$var$_interopRequireDefault((parcelRequire("dOzZz")));
function $bf5235f9211f74df$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for VideoPlayIcon.
 * This component is VideoPlayIcon, with `UNSAFE_fallbackIcon` set to "VidPlayIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $bf5235f9211f74df$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $bf5235f9211f74df$var$_react.default.createElement($bf5235f9211f74df$var$_videoPlay.default, Object.assign({
        LEGACY_fallbackIcon: $bf5235f9211f74df$var$_vidPlay.default
    }, props));
$bf5235f9211f74df$var$VideoPlayIcon.Name = 'VideoPlayIconMigration';
var $bf5235f9211f74df$var$_default = module.exports.default = $bf5235f9211f74df$var$VideoPlayIcon;

});
parcelRegister("b7NAp", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::92409a0bcef1d03143cf6035c99e88da>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8196cfedfbf38b92$var$_react = $8196cfedfbf38b92$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8196cfedfbf38b92$var$_baseNew = $8196cfedfbf38b92$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $8196cfedfbf38b92$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "VideoPlay".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for play video in Media.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8196cfedfbf38b92$var$VideoPlayIcon = (props)=>/*#__PURE__*/ $8196cfedfbf38b92$var$_react.default.createElement($8196cfedfbf38b92$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M2 3.112C2 1.592 3.63.627 4.963 1.36l8.902 4.888c1.383.76 1.383 2.747 0 3.506l-8.902 4.888C3.63 15.373 2 14.408 2 12.888zm2.24-.438a.5.5 0 0 0-.74.438v9.776a.5.5 0 0 0 .74.438l8.903-4.888a.5.5 0 0 0 0-.876z" clip-rule="evenodd"/>`
    }, props));
$8196cfedfbf38b92$var$VideoPlayIcon.displayName = 'VideoPlayIcon';
var $8196cfedfbf38b92$var$_default = module.exports.default = $8196cfedfbf38b92$var$VideoPlayIcon;

});

parcelRegister("dOzZz", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $0298730d194eb3bc$var$_react = $0298730d194eb3bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $0298730d194eb3bc$var$_videoPlay = $0298730d194eb3bc$var$_interopRequireDefault((parcelRequire("b7NAp")));
function $0298730d194eb3bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $0298730d194eb3bc$var$VidPlayIcon = (props)=>/*#__PURE__*/ $0298730d194eb3bc$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M8.595 19.522C7.162 20.364 6 19.702 6 18.04V5.963C6 4.3 7.158 3.635 8.595 4.479l11.083 6.51c.951.559.958 1.46 0 2.023z"/></svg>`
    }, props, {
        newIcon: $0298730d194eb3bc$var$_videoPlay.default
    }));
$0298730d194eb3bc$var$VidPlayIcon.displayName = 'VidPlayIcon';
var $0298730d194eb3bc$var$_default = module.exports.default = $0298730d194eb3bc$var$VidPlayIcon;

});


parcelRegister("ktvcB", function(module, exports) {

$parcel$export(module.exports, "WebhookIcon", () => $5c349b888065cefe$export$3c46f390a1e1dd55);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");
const $5c349b888065cefe$var$glyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        fill: "none",
        viewBox: "0 0 24 24",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#a)",
        fill: "#006644"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m7 19c1.1046 0 2-0.8954 2-2s-0.89543-2-2-2-2 0.8954-2 2 0.89543 2 2 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m10.292 9.4664c0.5541 0.38447 0.9515 1.1146 0.6559 1.7208l-3.0487 6.2512-1.7976-0.8768 3.6792-7.5433c0.15274 0.16787 0.32422 0.31835 0.51122 0.44812zm2.3852-6.3867 1.7976 0.87674-0.418 0.85921c-0.4863-0.45793-1.1254-0.75531-1.8327-0.80745l0.4531-0.9285z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m12 2c2.4213 0 4.4406 1.7211 4.9013 4.0066 0.1091 0.54134-0.3474 0.99368-0.8997 0.99356-0.5524-1.1e-4 -0.9853-0.46025-1.166-0.98224-0.4068-1.1745-1.5227-2.0179-2.8356-2.0179-1.6569 0-3 1.3432-3 3 0 0.99194 0.48143 1.8714 1.2234 2.4176l-1.0041 1.7385c-1.3384-0.8972-2.2193-2.4238-2.2193-4.1561 0-2.7614 2.2386-5 5-5z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m10.403 5.7963c-0.66479 0.88215-0.48855 2.1362 0.3936 2.8009 0.8821 0.66474 2.1361 0.4885 2.8009-0.39365 0.6647-0.88214 0.4885-2.1362-0.3936-2.8009-0.8822-0.66474-2.1362-0.4885-2.8009 0.39364z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m16.036 14.163c-0.6405 0.2111-1.4628 0.0891-1.769-0.5117l-3.1576-6.1969 1.782-0.90798 3.8102 7.478c-0.226 0.021-0.4494 0.0674-0.6656 0.1386zm3.6652 5.7485-1.782 0.908-0.4346-0.8509c0.6583-0.1128 1.2804-0.4442 1.7478-0.9777l0.4688 0.9206z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m20.97 20.02c-1.4572 1.9338-4.047 2.5107-6.1496 1.503-0.4979-0.2386-0.5843-0.8754-0.2519-1.3163 0.3325-0.441 0.9605-0.51 1.486-0.3402 1.1829 0.3821 2.5281-0.0015 3.3183-1.0501 0.9971-1.3233 0.7327-3.2043-0.5905-4.2014-0.7922-0.5969-1.7843-0.7418-2.667-0.4779l-0.7842-1.8481c1.522-0.5289 3.2714-0.3138 4.6548 0.7287 2.2054 1.6619 2.646 4.7969 0.9841 7.0023z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m12 9c1.1046 0 2-0.89543 2-2s-0.8954-2-2-2-2 0.89543-2 2 0.8954 2 2 2z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m18.79 16.121c-0.4929-0.9885-1.6937-1.3903-2.6823-0.8975-0.9885 0.4929-1.3903 1.6938-0.8974 2.6823 0.4928 0.9885 1.6937 1.3903 2.6822 0.8975 0.9885-0.4929 1.3904-1.6938 0.8975-2.6823z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m9.9753 17.429c0.09691-0.6673 0.57301-1.3489 1.2473-1.3548l6.9548-0.0608 0.0174 1.9999-8.3924 0.0732c0.08208-0.2116 0.14022-0.4322 0.17291-0.6575zm-6.7799 0.7152-0.01745-1.9999 0.95543-0.0093c-0.19286 0.6395-0.17382 1.3441 0.09512 2.0004l-1.0331 0.0088z",
        clipRule: "evenodd",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m2.5311 19.232c-1.0804-2.167-0.44111-4.7421 1.3x988-6.1742 0.43571-0.3391 1.0442-0.1322 1.2905 0.3619 0.24632 0.4943 0.02783 1.0871-0.3586 1.4817-0.86977 0.8881-1.1267 2.2632-0.54083 3.4382 0.73929 1.4828 2.5406 2.0855 4.0234 1.3462 0.88773-0.4426 1.46-1.2659 1.6177-2.1736l2.0038 0.1229c-0.2058 1.5981-1.1788 3.0676-2.7291 3.8406-2.4713 1.2321-5.4735 0.2276-6.7057-2.2437z"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "a"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M0 0H24V24H0V0Z",
        fill: "#fff"
    }))));
const $5c349b888065cefe$export$3c46f390a1e1dd55 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $5c349b888065cefe$var$glyph,
        ...props
    });

});

parcelRegister("koBIe", function(module, exports) {

$parcel$export(module.exports, "default", () => $52acd386256a9726$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $52acd386256a9726$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    issueTitle: {
        "id": "automation-menu.common.issue-title",
        "defaultMessage": "Issue"
    },
    issueDescription: {
        "id": "automation-menu.common.issue-description",
        "defaultMessage": "Created, transitioned, updated and more"
    },
    devopsTitle: {
        "id": "automation-menu.common.devops-title",
        "defaultMessage": "Branch, commit or pull requests "
    },
    devopsDescription: {
        "id": "automation-menu.common.devops-description",
        "defaultMessage": "Created, merged, declined"
    },
    devopsBuildAndDeployTitle: {
        "id": "automation-menu.common.devops-build-and-deploy-title",
        "defaultMessage": "Deployment or build"
    },
    devopsBuildAndDeployDescription: {
        "id": "automation-menu.common.devops-build-and-deploy-description",
        "defaultMessage": "Succeeded, failed and more"
    },
    integrationTitle: {
        "id": "automation-menu.common.integration-title",
        "defaultMessage": "Integration"
    },
    integrationDescription: {
        "id": "automation-menu.common.integration-description",
        "defaultMessage": "Trigger rules using incoming webhooks"
    },
    scheduleTitle: {
        "id": "automation-menu.common.schedule-title",
        "defaultMessage": "Schedule"
    },
    scheduleDescription: {
        "id": "automation-menu.common.schedule-description",
        "defaultMessage": "Trigger rules on a regular schedule"
    },
    allTriggersTitle: {
        "id": "automation-menu.common.all-triggers-title",
        "defaultMessage": "View all triggers"
    },
    allTriggersDescription: {
        "id": "automation-menu.common.all-triggers-description",
        "defaultMessage": "Sprints, versions and more"
    },
    issueTitleIssueTerminologyRefreshM4: {
        "id": "automation-menu.common.issue-title-issue-terminology-refresh-m4",
        "defaultMessage": "Work item"
    }
});

});

parcelRegister("1GEsl", function(module, exports) {

$parcel$export(module.exports, "filters", () => $c8d899017f019b40$export$82462a21aead86ed);
const $c8d899017f019b40$export$82462a21aead86ed = {
    CATEGORY_DEVOPS: 'CATEGORY_DEVOPS',
    CATEGORY_ISSUE: 'CATEGORY_ISSUE',
    CATEGORY_INTEGRATION: 'CATEGORY_INTEGRATION',
    CATEGORY_SCHEDULE: 'CATEGORY_SCHEDULE',
    CATEGORY_ALL: 'CATEGORY_ALL'
};

});


parcelRegister("kBike", function(module, exports) {

$parcel$export(module.exports, "MenuContextContainer", () => $6f10e4a5b599b146$export$316c3c2e4f41b5ad);
$parcel$export(module.exports, "useMenuContext", () => $6f10e4a5b599b146$export$21c7ab35b39f78ec);
$parcel$export(module.exports, "useMenuContextActions", () => $6f10e4a5b599b146$export$f672425f83782b78);
$parcel$export(module.exports, "useCanManageAutomations", () => $6f10e4a5b599b146$export$a073587d6223d86e);
$parcel$export(module.exports, "useProjectAri", () => $6f10e4a5b599b146$export$8688254b761eadc4);
$parcel$export(module.exports, "useBaseAutomationUrl", () => $6f10e4a5b599b146$export$7b0194c88f30ff4);

var $dXq4S = parcelRequire("dXq4S");

var $g5X3G = parcelRequire("g5X3G");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $6f10e4a5b599b146$var$initialState = {
    canManageAutomations: false,
    projectAri: (0, $dXq4S.toAriOrDefault)(''),
    projectId: (0, $g5X3G.toProjectId)(''),
    baseAutomationUrl: ''
};
const $6f10e4a5b599b146$var$actions = {
    setMenuContext: (menuContext)=>({ setState: setState })=>setState(menuContext)
};
const $6f10e4a5b599b146$var$Store = (0, $iXqE5.createStore)({
    initialState: $6f10e4a5b599b146$var$initialState,
    actions: $6f10e4a5b599b146$var$actions,
    name: 'automation-menu.menu-context'
});
const $6f10e4a5b599b146$export$316c3c2e4f41b5ad = (0, $gg7kZ.createContainer)($6f10e4a5b599b146$var$Store);
const $6f10e4a5b599b146$export$21c7ab35b39f78ec = (0, $3sQ5x.createHook)($6f10e4a5b599b146$var$Store);
const $6f10e4a5b599b146$export$f672425f83782b78 = (0, $3sQ5x.createHook)($6f10e4a5b599b146$var$Store, {
    selector: null
});
const $6f10e4a5b599b146$var$getCanManageAutomations = (state)=>state.canManageAutomations;
const $6f10e4a5b599b146$export$a073587d6223d86e = (0, $3sQ5x.createHook)($6f10e4a5b599b146$var$Store, {
    selector: $6f10e4a5b599b146$var$getCanManageAutomations
});
const $6f10e4a5b599b146$var$getProjectAri = (state)=>state.projectAri;
const $6f10e4a5b599b146$export$8688254b761eadc4 = (0, $3sQ5x.createHook)($6f10e4a5b599b146$var$Store, {
    selector: $6f10e4a5b599b146$var$getProjectAri
});
const $6f10e4a5b599b146$var$getBaseAutomationUrl = (state)=>state.baseAutomationUrl;
const $6f10e4a5b599b146$export$7b0194c88f30ff4 = (0, $3sQ5x.createHook)($6f10e4a5b599b146$var$Store, {
    selector: $6f10e4a5b599b146$var$getBaseAutomationUrl
});

});

parcelRegister("iKM9r", function(module, exports) {

$parcel$export(module.exports, "SelectedIssuesContainer", () => $ea71b5558f33c193$export$738cdb08d2b14320);
$parcel$export(module.exports, "useSelectedIssues", () => $ea71b5558f33c193$export$a435421a00d3bee);
$parcel$export(module.exports, "useSelectedIssuesSubscription", () => $ea71b5558f33c193$export$4ccb9daade9f8d9e);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $ea71b5558f33c193$var$initialState = {
    selectedIssuesKeys: [],
    crossProjectSelection: false
};
const $ea71b5558f33c193$var$actions = {
    setSelectionDetails: (state)=>({ setState: setState })=>setState(state)
};
const $ea71b5558f33c193$var$Store = (0, $iXqE5.createStore)({
    initialState: $ea71b5558f33c193$var$initialState,
    actions: $ea71b5558f33c193$var$actions,
    name: 'automation-menu.selected-issues'
});
const $ea71b5558f33c193$export$738cdb08d2b14320 = (0, $gg7kZ.createContainer)($ea71b5558f33c193$var$Store);
const $ea71b5558f33c193$var$isCrossProjectScope = (selectedIssueKeys, projectKey)=>selectedIssueKeys.find((issueKey)=>!issueKey.startsWith(`${projectKey}-`)) !== undefined;
const $ea71b5558f33c193$export$a435421a00d3bee = (0, $3sQ5x.createHook)($ea71b5558f33c193$var$Store);
const $ea71b5558f33c193$var$useSelectedIssuesSubscriptionClassic = (initialIssuesSelection = [], projectKey)=>{
    const [state, { setSelectionDetails: setSelectionDetails }] = $ea71b5558f33c193$export$a435421a00d3bee();
    (0, $5uXOq.useEffect)(()=>setSelectionDetails({
            selectedIssuesKeys: initialIssuesSelection,
            crossProjectSelection: $ea71b5558f33c193$var$isCrossProjectScope(initialIssuesSelection, projectKey)
        }), // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        setSelectionDetails,
        projectKey
    ]);
    const onSelectedIssuesChanged = (0, $5uXOq.useCallback)(// make flow happy
    (event)=>{
        if (event instanceof CustomEvent) setSelectionDetails({
            selectedIssuesKeys: event.detail.selectedIssues,
            crossProjectSelection: $ea71b5558f33c193$var$isCrossProjectScope(event.detail.selectedIssues, projectKey)
        });
    }, [
        setSelectionDetails,
        projectKey
    ]);
    const subscriptionHandle = (0, $5uXOq.useRef)((0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))));
    (0, $5uXOq.useEffect)(()=>{
        if (typeof document !== 'undefined') {
            document.addEventListener('JiraAgile.selectedIssuesChanged', onSelectedIssuesChanged);
            subscriptionHandle.current = ()=>document.removeEventListener('JiraAgile.selectedIssuesChanged', onSelectedIssuesChanged);
        }
        return ()=>{
            subscriptionHandle.current();
            subscriptionHandle.current = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        };
    }, [
        onSelectedIssuesChanged
    ]);
    return state.selectedIssuesKeys;
};
const $ea71b5558f33c193$var$useSelectedIssuesSubscriptionNextGen = (selectedIssueKeys = [], projectKey)=>{
    const [state, { setSelectionDetails: setSelectionDetails }] = $ea71b5558f33c193$export$a435421a00d3bee();
    (0, $5uXOq.useEffect)(()=>setSelectionDetails({
            selectedIssuesKeys: selectedIssueKeys,
            crossProjectSelection: $ea71b5558f33c193$var$isCrossProjectScope(selectedIssueKeys, projectKey)
        }), [
        setSelectionDetails,
        selectedIssueKeys,
        projectKey
    ]);
    return state.selectedIssuesKeys;
};
const $ea71b5558f33c193$export$4ccb9daade9f8d9e = (isSimplified, initialIssuesSelection = [], selectedIssueKeys = [], projectKey)=>isSimplified ? $ea71b5558f33c193$var$useSelectedIssuesSubscriptionNextGen(selectedIssueKeys, projectKey) // eslint-disable-line react-hooks/rules-of-hooks
     : $ea71b5558f33c193$var$useSelectedIssuesSubscriptionClassic(initialIssuesSelection, projectKey); // eslint-disable-line react-hooks/rules-of-hooks

});

parcelRegister("7IeyM", function(module, exports) {

$parcel$export(module.exports, "usePermissionService", () => $615a9fd6df718b89$export$20b1e1fd563e20b6);

var $5uXOq = parcelRequire("5uXOq");

var $7f4tk = parcelRequire("7f4tk");

var $itmJb = parcelRequire("itmJb");
const $615a9fd6df718b89$var$PROJECT_ADMIN_PERMISSION = 'ADMINISTER_PROJECTS';
const $615a9fd6df718b89$var$fetchData = async (projectId)=>{
    const response = await (0, $7f4tk.default)(`/rest/api/2/mypermissions?permissions=${$615a9fd6df718b89$var$PROJECT_ADMIN_PERMISSION}&projectId=${projectId}`);
    if (response && response.permissions && response.permissions[$615a9fd6df718b89$var$PROJECT_ADMIN_PERMISSION]) return Boolean(response.permissions[$615a9fd6df718b89$var$PROJECT_ADMIN_PERMISSION].havePermission);
    return false;
};
const $615a9fd6df718b89$export$20b1e1fd563e20b6 = (projectId)=>{
    const [isProjectAdmin, setIsProjectAdmin] = (0, $5uXOq.useState)(false);
    const isGlobalAdmin = (0, $itmJb.useIsAdmin)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isGlobalAdmin && projectId != null) $615a9fd6df718b89$var$fetchData(projectId).then(setIsProjectAdmin);
    }, [
        isGlobalAdmin,
        projectId
    ]);
    return {
        isProjectAdmin: isProjectAdmin || isGlobalAdmin
    };
};

});

parcelRegister("iW6Ob", function(module, exports) {

$parcel$export(module.exports, "useProjectService", () => $a3aa0fe879fd4421$export$2f2d856d9fc7fad2);

var $4DPZY = parcelRequire("4DPZY");

var $g5X3G = parcelRequire("g5X3G");
const $a3aa0fe879fd4421$export$2f2d856d9fc7fad2 = ()=>{
    const [{ data: projectData }] = (0, $4DPZY.useContainerContext)();
    // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
    if (projectData && projectData.project) return {
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        projectKey: (0, $g5X3G.toProjectKey)(projectData.project.key),
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        projectId: (0, $g5X3G.toProjectId)(`${projectData.project.id}`),
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        projectType: projectData.project.type,
        // @ts-expect-error - TS2339 - Property 'project' does not exist on type 'ContainerContext'.
        isSimplified: projectData.project.isSimplified
    };
    return null;
};

});

parcelRegister("jJ8Br", function(module, exports) {

$parcel$export(module.exports, "default", () => $ff704efab144026a$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $4ldhu = parcelRequire("4ldhu");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $22OQR = parcelRequire("22OQR");

var $dCm1o = parcelRequire("dCm1o");

var $hrfsZ = parcelRequire("hrfsZ");

var $eBN2x = parcelRequire("eBN2x");
const $ff704efab144026a$var$MenuButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isSelected: isSelected, onClick: onClick }, ref)=>{
    const automationIconTestId = 'automation-menu.ui.button.icon';
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((event, analytics)=>{
        (0, $8zOmE.fireUIAnalytics)(analytics, 'automationMenuButton');
        onClick();
    }, [
        onClick
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $eBN2x.default).menuButtonTooltip),
        position: "top",
        isScreenReaderAnnouncementDisabled: true
    }, (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
        ref: ref,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
        onClick: onClickWithAnalytics,
        isSelected: isSelected,
        testId: "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup",
        "data-vc": "automation-menu-button" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $eBN2x.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
            label: "",
            color: "currentColor",
            spacing: "spacious",
            testId: automationIconTestId
        })
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        ref: ref,
        appearance: "subtle",
        spacing: "none",
        isSelected: isSelected,
        onClick: onClickWithAnalytics,
        testId: "automation-menu.ui.button.menu-button",
        id: "automation-menu.ui.popup" // @ts-expect-error - externalId does not exist on Button types
        ,
        externalId: "automation-menu.ui.button.menu-button",
        "aria-label": formatMessage((0, $eBN2x.default).menuButtonTooltip),
        "aria-expanded": isSelected,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ff704efab144026a$var$IconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            size: "medium",
            glyph: (0, $hrfsZ.AutomationGlyph),
            label: "",
            primaryColor: isSelected ? "var(--ds-icon-selected, #0C66E4)" : undefined,
            secondaryColor: "none",
            testId: automationIconTestId
        }))
    }));
});
var $ff704efab144026a$export$2e2bcd8739ae039 = $ff704efab144026a$var$MenuButton;
const $ff704efab144026a$var$unselectedColor = "var(--ds-text-subtle, #44546F)";
const $ff704efab144026a$var$unselectedHoverColor = "var(--ds-text-subtlest, #626F86)";
const $ff704efab144026a$var$multiplier = 4; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ff704efab144026a$var$IconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1h6o _1bsbzwfg _4t3izwfg _syaz1gjq _30l3131l",
            __cmplp.className
        ])
    });
});

});
parcelRegister("4ldhu", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::2251b011785916069b749fddb2c5cd02>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $32936cf628dec798$var$_react = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $32936cf628dec798$var$_baseNew = $32936cf628dec798$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $32936cf628dec798$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Automation".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved to represent an Automation.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $32936cf628dec798$var$AutomationIcon = (props)=>/*#__PURE__*/ $32936cf628dec798$var$_react.default.createElement($32936cf628dec798$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M10.377.102a.75.75 0 0 1 .346.847L8.985 7.25h4.265a.75.75 0 0 1 .53 1.28l-7.25 7.25a.75.75 0 0 1-1.253-.73l1.738-6.3H2.75a.75.75 0 0 1-.53-1.28L9.47.22a.75.75 0 0 1 .907-.118M7.43 7.25l1.093-3.96L4.56 7.25zm1.142 1.5-1.093 3.96 3.961-3.96z" clip-rule="evenodd"/>`
    }, props));
$32936cf628dec798$var$AutomationIcon.displayName = 'AutomationIcon';
var $32936cf628dec798$var$_default = module.exports.default = $32936cf628dec798$var$AutomationIcon;

});

parcelRegister("hrfsZ", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $7a6859ebc905c49b$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $7a6859ebc905c49b$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

parcelRegister("eBN2x", function(module, exports) {

$parcel$export(module.exports, "default", () => $70fd4abbcff5ac1b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $70fd4abbcff5ac1b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    menuButtonTooltip: {
        "id": "automation-menu.button.menu-button-tooltip",
        "defaultMessage": "Automation"
    },
    automationsMenuButtonIcon: {
        "id": "automation-menu.button.automations-menu-button-icon",
        "defaultMessage": "automations-menu-button-icon"
    }
});

});


parcelRegister("3jcRv", function(module, exports) {

$parcel$export(module.exports, "default", () => $057a86da41029200$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $3jA9Y = parcelRequire("3jA9Y");

var $4R6GH = parcelRequire("4R6GH");

var $dXq4S = parcelRequire("dXq4S");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $gOS29 = parcelRequire("gOS29");

var $kBike = parcelRequire("kBike");

var $iKM9r = parcelRequire("iKM9r");

var $4a5pt = parcelRequire("4a5pt");
const $057a86da41029200$var$Popup = ({ Trigger: Trigger, projectKey: projectKey, projectId: projectId, projectType: projectType, isSimplified: isSimplified, isUIF: isUIF, initialIssuesSelection: initialIssuesSelection, selectedIssueKeys: selectedIssueKeys, selectedIssueIds: selectedIssueIds, canManageAutomations: canManageAutomations = false })=>{
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [, { setMenuContext: setMenuContext }] = (0, $kBike.useMenuContextActions)();
    const { environment: environment, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        setMenuContext({
            canManageAutomations: canManageAutomations,
            projectAri: (0, $dXq4S.createAri)({
                resourceOwner: 'jira',
                cloudId: cloudId,
                resourceType: 'project',
                resourceId: projectId
            }),
            projectId: projectId,
            // For the URL, we want the old one for UIF/CMP and the new one for TMP
            baseAutomationUrl: (0, $gOS29.getBaseAutomationUrl)({
                projectKey: projectKey,
                projectType: projectType,
                isSimplified: isSimplified
            })
        }); // Store in a sweet state store to avoid prop drilling.
    }, [
        setMenuContext,
        canManageAutomations,
        cloudId,
        projectId,
        projectKey,
        projectType,
        isSimplified
    ]);
    // If we have a TMP OR CMP/UIF project, we need to add the newer method of subscribing
    // to issue changes (which doesn't include using the legacy bridge)
    (0, $iKM9r.useSelectedIssuesSubscription)(isSimplified || isUIF, initialIssuesSelection, selectedIssueKeys, projectKey);
    const generateAkPopup = (initialised, // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error, rules, executingRuleId, executeRule, triggerFetch)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            testId: "automation-menu.ui.popup.popup",
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4a5pt.default), {
                    initialised: initialised,
                    error: error,
                    rules: rules,
                    executingRuleId: executingRuleId,
                    executeRule: executeRule,
                    triggerFetch: triggerFetch,
                    selectedIssueIds: selectedIssueIds,
                    setClosed: ()=>setIsOpen(false)
                }),
            trigger: ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Trigger, {
                    ...triggerProps,
                    onClick: ()=>{
                        if (!isOpen) {
                            const analyticsEvent = createAnalyticsEvent({
                                actionSubject: 'automationBolt',
                                action: 'opened'
                            });
                            const attributes = (0, $4R6GH.fg)('selected-issue-id-limit') ? {
                                selectedIssueCount: selectedIssueIds?.length
                            } : {};
                            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
                        }
                        setIsOpen(!isOpen);
                    },
                    isSelected: isOpen
                }),
            shouldRenderToParent: (0, $4R6GH.fg)('ux-2931-a11y-automation-fix')
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "automationMenu",
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        attributes: {
            isSimplified: isSimplified,
            canManageAutomations: canManageAutomations
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireTrackAnalytics), {
        action: "viewed",
        actionSubject: "button",
        actionSubjectId: "automationMenuButton"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3jA9Y.ManualRulesContainer), {
        cloudId: cloudId,
        issueIds: selectedIssueIds ?? [],
        env: environment
    }, ({ triggerFetch: triggerFetch, initialised: initialised, error: error, rules: rules, invokingRuleId: invokingRuleId, invokeRuleOrShowDialog: invokeRuleOrShowDialog })=>generateAkPopup(initialised, error, rules, invokingRuleId, invokeRuleOrShowDialog, triggerFetch)));
};
var $057a86da41029200$export$2e2bcd8739ae039 = $057a86da41029200$var$Popup;

});
parcelRegister("3jA9Y", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $7dbcf6c35b47cce5$export$eb0a81e78d942dba);

var $5uXOq = parcelRequire("5uXOq");

var $deUkU = parcelRequire("deUkU");

var $4R6GH = parcelRequire("4R6GH");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $k9To8 = parcelRequire("k9To8");
const $7dbcf6c35b47cce5$export$eb0a81e78d942dba = (props)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { env: env, cloudId: cloudId, issueIds: issueIds } = props;
    let automationEnv = env;
    if (env === 'prod') automationEnv = (0, $4R6GH.fg)('automation-dev-helper') ? 'pre-prod' : 'prod';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $deUkU.ManualRulesContainer), {
        site: (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            resourceType: 'site',
            resourceId: cloudId
        }),
        query: {
            objects: issueIds?.map((id)=>(0, $dXq4S.createAri)({
                    resourceOwner: 'jira',
                    resourceType: 'issue',
                    cloudId: cloudId,
                    resourceId: id.toString()
                }))
        },
        env: automationEnv,
        onInputsModalOpened: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRuleModal',
                action: 'opened'
            });
            const attributes = {
                objectType: 'issue'
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationLifecycleStarted: (_, __, userInputs)=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'manualRule',
                action: 'tryInvoke'
            });
            const attributes = {
                objectType: 'issue',
                ruleHasInputs: Boolean(userInputs),
                objectsSelected: issueIds.length
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
        },
        onRuleInvocationSuccess: ()=>showFlag({
                type: 'info',
                title: formatMessage((0, $k9To8.default).successFlag),
                isAutoDismiss: true,
                messageId: 'automation-platform.ui.manual-rules-container.show-flag.info.success-flag',
                messageType: 'transactional'
            }),
        onRuleInvocationFailure: ()=>showFlag({
                type: 'error',
                title: formatMessage((0, $k9To8.default).failureFlagTitle),
                description: formatMessage((0, $k9To8.default).failureFlagDescription),
                isAutoDismiss: true,
                messageId: 'automation-platform.ui.manual-rules-container.show-flag.error.failure-flag',
                messageType: 'transactional'
            })
    }, props.children);
};

});
parcelRegister("deUkU", function(module, exports) {

$parcel$export(module.exports, "ManualRulesContainer", () => $9495b2e06f8b54ff$export$eb0a81e78d942dba);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $i8Qvm = parcelRequire("i8Qvm");

var $VSDnB = parcelRequire("VSDnB");

var $3ozzK = parcelRequire("3ozzK");

var $gSw9T = parcelRequire("gSw9T");
const $9495b2e06f8b54ff$export$96513fc6544cb4e5 = (env, site, query)=>{
    const [initialised, setInitialised] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [rules, setRules] = (0, $5uXOq.useState)([]);
    const transformRules = (ruleResponse)=>{
        const rulesUnsorted = Object.values(ruleResponse);
        return rulesUnsorted.sort((rule1, rule2)=>rule1.name.localeCompare(rule2.name));
    };
    const triggerFetch = async ()=>{
        setInitialised(false);
        try {
            const fetchedRules = await (0, $3ozzK.searchManuallyTriggeredRules)(env, site, query);
            setError(null);
            setRules(transformRules(fetchedRules));
        } catch (e) {
            setError(e);
            setRules([]);
        } finally{
            setInitialised(true);
        }
    };
    return [
        triggerFetch,
        initialised,
        error,
        rules
    ];
};
const $9495b2e06f8b54ff$export$eb0a81e78d942dba = (props)=>{
    (0, $gKZoD.di)((0, $i8Qvm.default), (0, $gSw9T.default), (0, $3ozzK.invokeManuallyTriggeredRule), $9495b2e06f8b54ff$export$96513fc6544cb4e5, (0, $5uXOq.useMemo), (0, $5uXOq.useState));
    const { env: env, site: site, query: query, children: children, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed, onRuleInvocationLifecycleStarted: onRuleInvocationLifecycleStarted, onRuleInvocationSuccess: onRuleInvocationSuccess, onRuleInvocationFailure: onRuleInvocationFailure, onRuleInvocationLifecycleDone: onRuleInvocationLifecycleDone } = props;
    // Initial data loading state
    const [triggerFetch, initialised, error, rules] = $9495b2e06f8b54ff$export$96513fc6544cb4e5(env, site, query);
    // We store a rule in state here if and only if a rule has user inputs, and thus
    // we need to preserve state while the input dialog is open.
    const [selectedRule, setSelectedRule] = (0, $5uXOq.useState)(null);
    const clearSelectedRule = ()=>{
        setSelectedRule(null);
    };
    // Value set when a rule is invoking, either from the dialog or without dialog
    const [invokingRuleId, setInvokingRuleId] = (0, $5uXOq.useState)(null);
    // Memoized projection of rules by id
    const rulesById = (0, $5uXOq.useMemo)(()=>rules.reduce((acc, rule)=>({
                // eslint-disable-next-line
                ...acc,
                [rule.id]: rule
            }), {}), [
        rules
    ]);
    const getRule = (id)=>rulesById[id];
    const ruleHasInputs = (rule)=>rule?.userInputPrompts?.length > 0;
    const isInvocationsToBeExcluded = (0, $VSDnB.fg)('phantom-2265_include_invocations_in_manual_rule');
    const INVOCATIONS = 'invocations';
    const SUCCESS = 'SUCCESS';
    const getFailedObjects = (response)=>isInvocationsToBeExcluded ? Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] !== SUCCESS) : Object.keys(response).filter((object)=>response[object] !== SUCCESS);
    const getSuccessfulObjects = (response)=>isInvocationsToBeExcluded ? Object.keys(response).filter((object)=>object !== INVOCATIONS && response[object] === SUCCESS) : Object.keys(response).filter((object)=>response[object] === SUCCESS);
    const handleInvocationFailure = (ruleId, successfulObjects, failedObjects)=>{
        if (onRuleInvocationFailure) onRuleInvocationFailure(ruleId, successfulObjects, failedObjects);
    };
    const invokeRule = async (ruleId, objects, userInputs)=>{
        const rule = getRule(ruleId);
        if (rule) {
            setInvokingRuleId(ruleId);
            try {
                if (onRuleInvocationLifecycleStarted) onRuleInvocationLifecycleStarted(ruleId, objects, userInputs);
                const response = await (0, $3ozzK.invokeManuallyTriggeredRule)(env, site, ruleId, objects, userInputs);
                const failedObjects = getFailedObjects(response);
                setInvokingRuleId(null);
                if (failedObjects.length === 0) {
                    if (onRuleInvocationSuccess) onRuleInvocationSuccess(ruleId, objects);
                } else {
                    const successfulObjects = getSuccessfulObjects(response);
                    handleInvocationFailure(ruleId, successfulObjects, failedObjects);
                }
            } catch (e) {
                handleInvocationFailure(ruleId, [], objects);
                setInvokingRuleId(null);
            }
        } else handleInvocationFailure(ruleId, [], objects);
        clearSelectedRule();
        if (onRuleInvocationLifecycleDone) onRuleInvocationLifecycleDone(ruleId, objects);
    };
    const invokeRuleOrShowDialog = (ruleId, objects)=>{
        const rule = getRule(ruleId);
        if (!rule) return handleInvocationFailure(ruleId, [], objects);
        if (ruleHasInputs(rule)) setSelectedRule({
            rule: rule,
            objects: objects
        });
        else invokeRule(ruleId, objects);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
        children: [
            children({
                triggerFetch: triggerFetch,
                initialised: initialised,
                error: error,
                rules: rules,
                invokingRuleId: invokingRuleId,
                invokeRuleOrShowDialog: invokeRuleOrShowDialog
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $i8Qvm.default), {
                children: selectedRule && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gSw9T.default), {
                    onInputsModalOpened: onInputsModalOpened,
                    onInputsModalClosed: onInputsModalClosed,
                    clearSelectedRule: clearSelectedRule,
                    selectedRule: selectedRule,
                    invokeRule: invokeRule
                })
            })
        ]
    });
};

});
parcelRegister("3ozzK", function(module, exports) {

$parcel$export(module.exports, "searchManuallyTriggeredRules", () => $60d395c05d97bad7$export$11e317ae81dd4223);
$parcel$export(module.exports, "invokeManuallyTriggeredRule", () => $60d395c05d97bad7$export$9a0eb4136c6b46c);

var $8lImo = parcelRequire("8lImo");
const $60d395c05d97bad7$export$11e317ae81dd4223 = async (env, site, query)=>{
    const url = await (0, $8lImo.getSearchUrl)(env, site);
    // TODO this will in the new API be a GET request instead, with the above getSearchUrl method
    // constructing a URL with the appropriate query parameters. For now, instead, we pass the
    // destructured query through as a POST body.
    const response = await (0, $8lImo.performPostRequest)(url, {
        body: JSON.stringify(query)
    });
    return response.reduce((acc, { id: id, name: name, ruleScope: ruleScope, userInputs: userInputs })=>({
            // eslint-disable-next-line
            ...acc,
            [id]: {
                id: id,
                name: name,
                ruleScope: ruleScope,
                userInputPrompts: userInputs
            }
        }), {});
};
const $60d395c05d97bad7$export$9a0eb4136c6b46c = async (env, site, ruleId, objects, userInputs)=>{
    const url = await (0, $8lImo.getInvocationUrl)(env, site, ruleId);
    const bodyRaw = {
        objects: objects
    };
    if (userInputs) bodyRaw.userInputs = userInputs;
    return (0, $8lImo.performPostRequest)(url, {
        body: JSON.stringify(bodyRaw)
    });
};

});
parcelRegister("8lImo", function(module, exports) {

$parcel$export(module.exports, "getSearchUrl", () => $1ea2f24134ab0fcb$export$7d4675b206f57488);
$parcel$export(module.exports, "getInvocationUrl", () => $1ea2f24134ab0fcb$export$e62dcf5e32cec4bf);
$parcel$export(module.exports, "performPostRequest", () => $1ea2f24134ab0fcb$export$692a4d9808143175);

var $VSDnB = parcelRequire("VSDnB");

var $jbrzS = parcelRequire("jbrzS");

var $g3zK9 = parcelRequire("g3zK9");
const $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613 = (site)=>{
    let cloudId;
    let resourceOwner;
    let resourceType;
    try {
        const ari = (0, $jbrzS.ResourceIdentifier).parse(site);
        cloudId = ari.cloudId;
        resourceOwner = ari.resourceOwner;
        resourceType = ari.resourceType;
        // Keep backwards compatibility for platform site ARIs
        if (resourceOwner === 'platform') resourceOwner = 'jira';
    } catch (error) {
        throw new Error('Attempted to parse malformed ARI: ' + site);
    }
    if (resourceType !== 'site' || cloudId === undefined) throw new Error('Not a site ARI: ' + site);
    return {
        product: resourceOwner,
        cloudId: cloudId
    };
};
const $1ea2f24134ab0fcb$export$7d4675b206f57488 = async (env, site)=>{
    const { product: product, cloudId: cloudId } = $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g3zK9.getAutomationStack)(env, cloudId);
    // TODO in the unified API, GET requests as according to Atlassian API standards will destructure the whole query into
    // query parameters as part of the URL. For now, this is considered a POST request instead and thus the query is used
    // later on as the request body.
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/search`;
};
const $1ea2f24134ab0fcb$export$e62dcf5e32cec4bf = async (env, site, ruleId)=>{
    const { product: product, cloudId: cloudId } = $1ea2f24134ab0fcb$export$1cb1c6bd5a8f1613(site);
    const automationStack = await (0, $g3zK9.getAutomationStack)(env, cloudId);
    return `/gateway/api/automation/internal-api/${product}/${cloudId}/${automationStack}/rest/v1/rules/manual/invocation/${ruleId}`;
};
const $1ea2f24134ab0fcb$var$DEFAULT_HEADER = {
    'Content-Type': 'application/json'
};
const $1ea2f24134ab0fcb$var$_performRequest = async (url, method, options = {
    headers: $1ea2f24134ab0fcb$var$DEFAULT_HEADER
})=>{
    const response = await fetch(url, {
        ...options,
        method: method
    });
    return response.json();
};
const $1ea2f24134ab0fcb$export$4a53ae1be8ec80c7 = async (url, options)=>{
    return $1ea2f24134ab0fcb$var$_performRequest(url, 'GET', options);
};
const $1ea2f24134ab0fcb$export$692a4d9808143175 = async (url, options)=>{
    return $1ea2f24134ab0fcb$var$_performRequest(url, 'POST', options);
};
const $1ea2f24134ab0fcb$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'customer_service' && (0, $VSDnB.fg)('jcs_project_type_m3')) return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    switch(projectType){
        case 'service_desk':
            return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
        case 'business':
            return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
        default:
            return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    }
};

});
parcelRegister("jbrzS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $3VFsf = parcelRequire("3VFsf");

var $aRXoY = parcelRequire("aRXoY");

$3VFsf.__exportStar((parcelRequire("8T6Ee")), module.exports);
/**
 * InvalidAriError - an error thrown if an invalid Ari is constructed
 */ class $df746fbe0ba5443e$var$InvalidAriError extends Error {
    /**
     * Construct an InvalidAriError given an error message
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {string|undefined} description - The error message
     */ constructor(ariString, description){
        super(`Invalid ari string: ${ariString}${description ? '. ' + description : ''}`);
        this.ariString = ariString;
        // Support correct inheritance in ES5
        Object.setPrototypeOf(this, $df746fbe0ba5443e$var$InvalidAriError.prototype);
    }
    /**
     * Construct an InvalidAriError given some constraint violations
     *
     * @param {string} ariString - the ARI that failed to parse
     * @param {ConstraintViolation<Object>[]} violations - The array of constraint errors
     */ static withConstraintViolations(ariString, violations) {
        return new $df746fbe0ba5443e$var$InvalidAriError(ariString, violations.map((v)=>v.toString()).join('\n'));
    }
}
module.exports.InvalidAriError = $df746fbe0ba5443e$var$InvalidAriError;
function $df746fbe0ba5443e$var$matchesSegment(value1, value2) {
    if (value1 === value2) return true;
    else if (value1 === undefined) return true;
    return false;
}
// constraints are based on draft of v2 spec https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0#AtlassianResourceIdentifierSpec(draft-2.0)-Syntax
const $df746fbe0ba5443e$var$basicCharConstraint = $aRXoY.pattern(/^[a-z][a-z.-]*$/);
/**
 * resourceType allows for capitalized letters to support Identity ARIs (`ari:cloud:identity::userGrant/<...>`)
 * It's a violation of the spec, but we still need to support that.
 * See https://hello.atlassian.net/wiki/spaces/ARCH/pages/161909310/Atlassian+Resource+Identifier+Spec+draft-2.0
 */ const $df746fbe0ba5443e$var$resourceTypeCharConstraints = $aRXoY.pattern(/^[a-z][a-z.-]*$/i);
const $df746fbe0ba5443e$var$resourceOwnerConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$basicCharConstraint
];
const $df746fbe0ba5443e$var$resourceTypeConstraints = [
    $aRXoY.lengthBetween(3, 255),
    $df746fbe0ba5443e$var$resourceTypeCharConstraints
];
const $df746fbe0ba5443e$var$cloudIdConstraints = [
    $aRXoY.lengthBetween(3, 255)
];
const $df746fbe0ba5443e$var$siteResourceType = 'site';
const $df746fbe0ba5443e$var$resourceIdChars = /[\w-._~:@#]/.source;
const $df746fbe0ba5443e$var$resourceIdConstraints = [
    $aRXoY.pattern(new RegExp(`^${$df746fbe0ba5443e$var$resourceIdChars}+(/${$df746fbe0ba5443e$var$resourceIdChars}*)*(;v=${$df746fbe0ba5443e$var$resourceIdChars}*)*$`))
];
/**
 * Returns an Ari that is of the latest version of the Ari spec that we support. Any legacy formats
 * (like those for site wide ARIs) are upgraded to their latest form.
 */ function $df746fbe0ba5443e$var$upgrade(values) {
    const { resourceId: resourceId, resourceOwner: resourceOwner, cloudId: cloudId } = values;
    // note: The new ARI spec has not defined a format for system wide contexts so we exclude them from upgrade
    if (!resourceId && cloudId) return {
        resourceOwner: resourceOwner,
        resourceType: $df746fbe0ba5443e$var$siteResourceType,
        resourceId: cloudId
    };
    else return values;
}
class $df746fbe0ba5443e$var$ResourceIdentifier {
    get cloudId() {
        if (this.resourceType === $df746fbe0ba5443e$var$siteResourceType) return this.internalCloudId ? this.internalCloudId : this.resourceId;
        return this.internalCloudId;
    }
    /**
     * Create a new Ari
     *
     * Only the resourceOwner is a required field, any other field can be omitted.
     * Older format types are converted on creation
     *
     * @param {string} values.resourceOwner - the owner of this resource (e.g. hipchat, confluence or jira)
     * @param {string|undefined} values.cloudId - the cloud id for this identifier, defined in AID
     * @param {string|undefined} values.resourceType - the resource type this Ari is associated with (e.g. conversation in hipchat)
     * @param {string|undefined} values.resourceId - a resource identifier, if this is specified the associated resourceType *must* be provided.
     *
     * @throws {InvalidAriError} if the provided segments fail to pass validation
     */ constructor(values){
        const { resourceId: resourceId, resourceOwner: resourceOwner, resourceType: resourceType, cloudId: cloudId } = $df746fbe0ba5443e$var$upgrade(values);
        this.resourceOwner = resourceOwner;
        this.internalCloudId = cloudId;
        this.resourceType = resourceType;
        this.resourceId = resourceId;
        this.validate();
    }
    /**
    * Parse a string as an Ari
    *
    * @param {string} ariString - the string to parse
    * @returns {Ari} the parsed ari
    * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
    */ static parse(ariString) {
        if (!ariString) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const match = ariString.match(/^ari:cloud:([^:/]+):([^:/]*):([^:/]*)\/(.*)$/);
        if (!match || match.length !== 5) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        const terms = match.map((a)=>a && a.length > 0 ? a : undefined);
        const resourceOwner = terms[1];
        if (!resourceOwner) throw new $df746fbe0ba5443e$var$InvalidAriError(ariString);
        return new $df746fbe0ba5443e$var$ResourceIdentifier({
            resourceOwner: resourceOwner,
            cloudId: terms[2],
            resourceType: terms[3],
            resourceId: terms[4]
        });
    }
    static parseEncoded(encodedAriString) {
        return $df746fbe0ba5443e$var$parse(decodeURIComponent(encodedAriString));
    }
    /**
     * Converts this Ari to a string.
     */ toString() {
        if (!this.ariString) {
            const resourceId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType && this.internalCloudId ? this.internalCloudId : this.resourceId || '';
            const resourceType = this.resourceType || '';
            const sanitizedCloudId = this.resourceType === $df746fbe0ba5443e$var$siteResourceType ? '' : this.internalCloudId || '';
            this.ariString = `ari:cloud:${this.resourceOwner}:${sanitizedCloudId}:${resourceType}/${resourceId}`;
        }
        return this.ariString;
    }
    /**
     * Converts this object to its json representation
     */ toJSON() {
        return this.toString();
    }
    /**
     * Checks if this context is the same as another context
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} - true if all segments of both Aris are equal, false otherwise
     */ equals(other) {
        return other instanceof $df746fbe0ba5443e$var$ResourceIdentifier && this.resourceOwner === other.resourceOwner && this.cloudId === other.cloudId && this.resourceType === other.resourceType && this.resourceId === other.resourceId;
    }
    /**
     * This method checks if the current context contains the other context.
     *
     * Note: it does that by transforming a site context  (e.g. `ari:cloud:<resource owner>:site/<cloud id>`)
     * if required to an "any" resource type context (e.g. `ari:cloud:<resource owner>:<cloud id>:/`)
     *
     * @param {Ari} other
     * @returns {boolean}
     */ contains(other) {
        return this.matches(new $df746fbe0ba5443e$var$ResourceIdentifier(other));
    }
    /**
     * Checks if this context is the same as or contains the provided context.
     *
     * Undefined segments in this ARI are treated as wildcards for matching purposes, but must exactly
     *  match if they are provided in the `other` Ari - i.e. this method is not commutative.
     *
     * e.g.
     * ```
     * parse('ari:cloud:hipchat::/').contains(parse('ari:cloud:hipchat:cloudid:conversation/blah')) === true
     * parse('ari:cloud:hipchat:cloudid:conversation/blah').contains(parse('ari:cloud:hipchat::/')) === false
     *
     * @param {Ari} other - the other parameter to match with
     * @returns {boolean} true if this Ari is the same as the other Ari, or matches the other Ari. False otherwise.
     */ matches(other) {
        return $df746fbe0ba5443e$var$matchesSegment(this.resourceOwner, other.resourceOwner) && $df746fbe0ba5443e$var$matchesSegment(this.cloudId, other.cloudId) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceType, other.resourceType)) && (this.resourceType === $df746fbe0ba5443e$var$siteResourceType && !!other.resourceType || $df746fbe0ba5443e$var$matchesSegment(this.resourceId, other.resourceId));
    }
    validateSiteWide() {
        const { resourceType: resourceType, cloudId: cloudId } = this;
        if (resourceType === $df746fbe0ba5443e$var$siteResourceType && !cloudId) return new $aRXoY.GeneralValidationError('site wide ARIs must have a cloudId');
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'resourceOwner', $df746fbe0ba5443e$var$resourceOwnerConstraints),
            $aRXoY.validateField(this, 'resourceType', $df746fbe0ba5443e$var$resourceTypeConstraints),
            $aRXoY.validateField(this, 'resourceId', $df746fbe0ba5443e$var$resourceIdConstraints),
            $aRXoY.validateField(this, 'cloudId', $df746fbe0ba5443e$var$cloudIdConstraints),
            this.validateSiteWide()
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $df746fbe0ba5443e$var$InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
        if (this.resourceId !== undefined && this.resourceType === undefined) throw new $df746fbe0ba5443e$var$InvalidAriError(this.toString(), 'The resource type must be specified if the resource id is defined.');
    }
    urlEncode() {
        return encodeURIComponent(this.toString());
    }
    urlDecode() {
        return decodeURIComponent(this.toString());
    }
}
module.exports.ResourceIdentifier = $df746fbe0ba5443e$var$ResourceIdentifier;
/**
 * Parse a string as an Ari
 *
 * @param {string} ariString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parse(ariString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parse(ariString);
}
module.exports.parse = $df746fbe0ba5443e$var$parse;
/**
 * Parse a URL encoded string as an Ari
 *
 * @param {string} encodedAriString - the string to parse
 * @returns {Ari} the parsed ari
 * @throws {InvalidAriError} if the string could not be correctly parsed as an Ari.
 */ function $df746fbe0ba5443e$var$parseEncoded(encodedAriString) {
    return $df746fbe0ba5443e$var$ResourceIdentifier.parseEncoded(encodedAriString);
}
module.exports.parseEncoded = $df746fbe0ba5443e$var$parseEncoded;

});
parcelRegister("aRXoY", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $aB0SS = parcelRequire("aB0SS");
class $7e9cee950eba220a$var$LengthConstraint {
    constructor(min, max){
        this.min = min;
        this.max = max;
    }
    get description() {
        return `length must be between ${this.min} and ${this.max}`;
    }
    isValid(value) {
        return !value || value.length >= this.min && value.length <= this.max;
    }
}
module.exports.LengthConstraint = $7e9cee950eba220a$var$LengthConstraint;
class $7e9cee950eba220a$var$RegexConstraint {
    constructor(regex){
        this.regex = regex;
    }
    get description() {
        return `value must match regex ${this.regex.source}`;
    }
    isValid(value) {
        return !value || this.regex.test(value);
    }
}
module.exports.RegexConstraint = $7e9cee950eba220a$var$RegexConstraint;
class $7e9cee950eba220a$var$GeneralValidationError {
    constructor(error){
        this.error = error;
    }
    toString() {
        return this.error;
    }
}
module.exports.GeneralValidationError = $7e9cee950eba220a$var$GeneralValidationError;
class $7e9cee950eba220a$var$ConstraintViolation {
    constructor(fieldName, value, constraints){
        this.fieldName = fieldName;
        this.value = value;
        this.constraints = constraints;
    }
    toString() {
        const constraintSummary = this.constraints.map((c)=>`  - ${c.description}`).join('\n');
        return `'${this.value}' is not a valid value for ${this.fieldName} as it violates the following constraints:\n${constraintSummary}`;
    }
}
module.exports.ConstraintViolation = $7e9cee950eba220a$var$ConstraintViolation;
function $7e9cee950eba220a$var$lengthBetween(min, max) {
    return new $7e9cee950eba220a$var$LengthConstraint(min, max);
}
module.exports.lengthBetween = $7e9cee950eba220a$var$lengthBetween;
function $7e9cee950eba220a$var$pattern(regex) {
    return new $7e9cee950eba220a$var$RegexConstraint(regex);
}
module.exports.pattern = $7e9cee950eba220a$var$pattern;
function $7e9cee950eba220a$var$validateField(object, fieldName, constraints) {
    const value = object[fieldName];
    const violatedConstraints = constraints.map((c)=>{
        return c.isValid(value) ? undefined : c;
    }).filter($aB0SS.isDefined);
    return violatedConstraints.length > 0 ? new $7e9cee950eba220a$var$ConstraintViolation(fieldName, value, violatedConstraints) : undefined;
}
module.exports.validateField = $7e9cee950eba220a$var$validateField;

});
parcelRegister("aB0SS", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hasValueAtKey = module.exports.hasPresentKey = module.exports.isFilled = module.exports.isDefined = module.exports.isPresent = void 0;
function $7b6e0ba147b061df$var$isPresent(t) {
    return t !== undefined && t !== null;
}
module.exports.isPresent = $7b6e0ba147b061df$var$isPresent;
function $7b6e0ba147b061df$var$isDefined(t) {
    return t !== undefined;
}
module.exports.isDefined = $7b6e0ba147b061df$var$isDefined;
function $7b6e0ba147b061df$var$isFilled(t) {
    return t !== null;
}
module.exports.isFilled = $7b6e0ba147b061df$var$isFilled;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a defined non-null value under the key `k`.
 *
 * @example
 * ```ts
 * const filesWithUrl = files.filter(file => file.url);
 * files[0].url // In this case, TS might still treat this as undefined/null
 *
 * const filesWithUrl = files.filter(hasPresentKey("url"));
 * files[0].url // TS will know that this is present
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasPresentKey(k) {
    return function(a) {
        return a[k] !== undefined && a[k] !== null;
    };
}
module.exports.hasPresentKey = $7b6e0ba147b061df$var$hasPresentKey;
/**
 * Returns a function that can be used to filter down objects
 * to the ones that have a specific value V under a key `k`.
 *
 * @example
 * ```ts
 * type File = { type: "image", imageUrl: string } | { type: "pdf", pdfUrl: string };
 * const files: File[] = [];
 *
 * const imageFiles = files.filter(file => file.type === "image");
 * files[0].type // In this case, TS will still treat it  as `"image" | "pdf"`
 *
 * const filesWithUrl = files.filter(hasValueKey("type", "image" as const));
 * files[0].type // TS will now know that this is "image"
 * files[0].imageUrl // TS will know this is present, because already it excluded the other union members.
 *
 * Note: the cast `as const` is necessary, otherwise TS will only know that type is a string.
 * ```
 *
 * See https://github.com/microsoft/TypeScript/issues/16069
 * why is that useful.
 */ function $7b6e0ba147b061df$var$hasValueAtKey(k, v) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(a) {
        return a[k] === v;
    };
}
module.exports.hasValueAtKey = $7b6e0ba147b061df$var$hasValueAtKey;

});


parcelRegister("8T6Ee", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kQInL = parcelRequire("kQInL");
var $67889de6c03493da$var$AppFamilyAri;
(function(AppFamilyAri) {
    AppFamilyAri.resourceOwner = 'ecosystem';
    AppFamilyAri.appResourceType = 'app';
    AppFamilyAri.environmentResourceType = 'environment';
    AppFamilyAri.extensionGroupResourceType = 'extension-group';
    AppFamilyAri.extensionResourceType = 'extension';
    AppFamilyAri.appFamilyResourceTypes = [
        AppFamilyAri.appResourceType,
        AppFamilyAri.environmentResourceType,
        AppFamilyAri.extensionGroupResourceType,
        AppFamilyAri.extensionResourceType
    ];
})($67889de6c03493da$var$AppFamilyAri = module.exports.AppFamilyAri || (module.exports.AppFamilyAri = {}));
class $67889de6c03493da$var$AppFamilyAriError extends Error {
    constructor(message, cause){
        super(message);
        this.cause = cause;
    }
}
module.exports.AppFamilyAriError = $67889de6c03493da$var$AppFamilyAriError;
class $67889de6c03493da$var$NotAppFamilyAriError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(ari, reason){
        super(`ari is not a valid App family ari: ${ari.toString()} as ${reason}`);
        this.reason = reason;
    }
}
module.exports.NotAppFamilyAriError = $67889de6c03493da$var$NotAppFamilyAriError;
class $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError extends $67889de6c03493da$var$AppFamilyAriError {
    constructor(type, ari, cause){
        super(`App family ari (${ari.toString()}) is not of expected type: ${type}`, cause);
        this.cause = cause;
    }
}
module.exports.NotExpectedAppFamilyAriTypeError = $67889de6c03493da$var$NotExpectedAppFamilyAriTypeError;
/**
 * throws NotAppFamilyAriError if not a valid app family ari
 */ function $67889de6c03493da$var$parseAppAri(ari) {
    return $kQInL.AppFamilyAriImpl.parse(ari);
}
module.exports.parseAppAri = $67889de6c03493da$var$parseAppAri;
function $67889de6c03493da$var$createAppAri(json) {
    return new $kQInL.AppFamilyAriImpl(json);
}
module.exports.createAppAri = $67889de6c03493da$var$createAppAri;

});
parcelRegister("kQInL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8T6Ee = parcelRequire("8T6Ee");

var $jbrzS = parcelRequire("jbrzS");

var $aRXoY = parcelRequire("aRXoY");
const $f2db175f2d527230$var$versionPrefix = ';v=';
const $f2db175f2d527230$var$uuidRegExpString = '[0-9A-F]{8}-[0-9A-F]{4}-4[0-9A-F]{3}-[89AB][0-9A-F]{3}-[0-9A-F]{12}';
const $f2db175f2d527230$var$uuidConstraints = [
    $aRXoY.pattern(new RegExp(`^${$f2db175f2d527230$var$uuidRegExpString}$`, 'i'))
];
const $f2db175f2d527230$var$extensionGroupIdConstraints = [
    $aRXoY.pattern(new RegExp(`^(${$f2db175f2d527230$var$uuidRegExpString}|static)$`, 'i'))
];
class $f2db175f2d527230$var$AppFamilyAriImpl {
    constructor(json){
        this.json = json;
        this.validate();
    }
    get appId() {
        return this.json.appId;
    }
    get environmentId() {
        return this.json.environmentId;
    }
    get version() {
        return this.json.version;
    }
    get extensionGroupId() {
        return this.json.extensionGroupId;
    }
    get extensionKey() {
        return this.json.extensionKey;
    }
    toJSON() {
        return this.json;
    }
    static parse(ari) {
        const { resourceOwner: resourceOwner, resourceType: resourceType, resourceId: resourceId } = ari;
        if (resourceOwner !== $8T6Ee.AppFamilyAri.resourceOwner) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceOwner (${resourceOwner}) must be ${$8T6Ee.AppFamilyAri.resourceOwner}`);
        if (!resourceType || $8T6Ee.AppFamilyAri.appFamilyResourceTypes.indexOf(resourceType) < 0) throw new $8T6Ee.NotAppFamilyAriError(ari, `resourceType must be one of ${$8T6Ee.AppFamilyAri.appFamilyResourceTypes}`);
        if (!resourceId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'resourceId is must be provided');
        const versionIndex = resourceId.indexOf($f2db175f2d527230$var$versionPrefix);
        if (versionIndex > 0 && resourceId.lastIndexOf($f2db175f2d527230$var$versionPrefix) > versionIndex) throw new $8T6Ee.NotAppFamilyAriError(ari, 'can only include one version suffix');
        const [mainResourceId, version] = resourceId.split($f2db175f2d527230$var$versionPrefix);
        const segments = mainResourceId.split('/').map($f2db175f2d527230$var$stripToUndefined);
        if (segments.length > 4) throw new $8T6Ee.NotAppFamilyAriError(ari, `no path segments can be added after extensionKey ${segments.slice(4)}`);
        const [appId, environmentId, providedExtensionGroupId, extensionKey] = segments;
        if (!appId) throw new $8T6Ee.NotAppFamilyAriError(ari, 'appId must be included');
        const extensionGroupId = providedExtensionGroupId || (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType || resourceType === $8T6Ee.AppFamilyAri.extensionResourceType ? 'static' : undefined);
        if (resourceType === $8T6Ee.AppFamilyAri.extensionResourceType && !(environmentId && providedExtensionGroupId && extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId, extensionKey must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.extensionGroupResourceType && (!(environmentId && extensionGroupId) || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId, extensionGroupId must all be provided for resourceType ${$8T6Ee.AppFamilyAri.extensionGroupResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.environmentResourceType && (!environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        else if (resourceType === $8T6Ee.AppFamilyAri.appResourceType && (environmentId || providedExtensionGroupId || extensionKey)) throw new $8T6Ee.NotAppFamilyAriError(ari, `environmentId must be provided for resourceType ${$8T6Ee.AppFamilyAri.environmentResourceType}`);
        return new $f2db175f2d527230$var$AppFamilyAriImpl({
            appId: appId,
            environmentId: environmentId,
            extensionGroupId: extensionGroupId,
            extensionKey: extensionKey,
            version: version
        });
    }
    asAppAri() {
        return this.returnIf(()=>this.isAppAri(), 'app');
    }
    asAppEnvironmentAri() {
        return this.returnIf(()=>this.isAppEnvironmentAri(), 'environment');
    }
    asExtensionGroupAri() {
        return this.returnIf(()=>this.isExtensionGroupAri(), 'extension-group');
    }
    asExtensionAri() {
        return this.returnIf(()=>this.isExtensionAri(), 'extension');
    }
    isAppAri() {
        return !this.isAtLeastAppEnvironmentAri;
    }
    isAppEnvironmentAri() {
        return this.isAtLeastAppEnvironmentAri && !this.isAtLeastExtensionGroupAri;
    }
    isExtensionGroupAri() {
        return this.isAtLeastExtensionGroupAri && !this.isExtensionAri();
    }
    isExtensionAri() {
        return this.isAtLeastExtensionGroupAri && this.extensionKey !== undefined;
    }
    returnIf(check, type) {
        if (!check()) throw new $8T6Ee.NotExpectedAppFamilyAriTypeError(type, this);
        return this; // :sadpanda:
    }
    get isAtLeastAppEnvironmentAri() {
        return this.environmentId !== undefined;
    }
    get isAtLeastExtensionGroupAri() {
        return this.isAtLeastAppEnvironmentAri && this.extensionGroupId !== undefined;
    }
    validate() {
        const constraintViolations = [
            $aRXoY.validateField(this, 'environmentId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'appId', $f2db175f2d527230$var$uuidConstraints),
            $aRXoY.validateField(this, 'extensionGroupId', $f2db175f2d527230$var$extensionGroupIdConstraints)
        ].filter((v)=>v);
        if (constraintViolations.length > 0) throw $jbrzS.InvalidAriError.withConstraintViolations(this.toString(), constraintViolations);
    }
    toAri() {
        const resourceOwner = $8T6Ee.AppFamilyAri.resourceOwner;
        const { appId: appId, environmentId: environmentId, extensionGroupId: extensionGroupId, extensionKey: extensionKey, version: version } = this.toJSON();
        function withVersion(segments) {
            const path = segments.join('/');
            if (!version) return path;
            else return `${path}${$f2db175f2d527230$var$versionPrefix}${version}`;
        }
        if (this.isExtensionAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId,
                extensionKey
            ])
        });
        else if (this.isExtensionGroupAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.extensionGroupResourceType,
            resourceId: withVersion([
                appId,
                environmentId,
                extensionGroupId
            ])
        });
        else if (this.isAppEnvironmentAri()) return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.environmentResourceType,
            resourceId: withVersion([
                appId,
                environmentId
            ])
        });
        else return new $jbrzS.ResourceIdentifier({
            resourceOwner: resourceOwner,
            resourceType: $8T6Ee.AppFamilyAri.appResourceType,
            resourceId: appId
        });
    }
    toString() {
        return this.toAri().toString();
    }
}
module.exports.AppFamilyAriImpl = $f2db175f2d527230$var$AppFamilyAriImpl;
function $f2db175f2d527230$var$stripToUndefined(str) {
    if (!str) return undefined;
    const trimmed = str.trim();
    if (trimmed.length === 0) return undefined;
    return trimmed;
}

});



parcelRegister("g3zK9", function(module, exports) {

$parcel$export(module.exports, "getAutomationStack", () => $fad0c3bb22e40c28$export$6123178d3f5fb24d);
const $fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_PREFIX = 'automationPlatform';
const $fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_STACK = 'automationStack';
const $fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL = 'https://localhost:8082/devStack.json';
const $fad0c3bb22e40c28$var$getAutomationProdStackUrl = (cloudId)=>`/gateway/api/automation/internal-api/jira/${cloudId}/pro/rest/environments`;
const $fad0c3bb22e40c28$var$getLatestPreProdStack = async (cloudId)=>{
    try {
        const response = await fetch($fad0c3bb22e40c28$var$getAutomationProdStackUrl(cloudId));
        const stacksResponse = await response.json();
        const preProdStacks = stacksResponse.prod.otherStacks.filter(({ releasedSuccessfully: releasedSuccessfully })=>!releasedSuccessfully).map(({ stack: stack })=>stack);
        const [latestPreProdStack = null] = preProdStacks;
        return latestPreProdStack;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch pre-prod stack from ${$fad0c3bb22e40c28$var$getAutomationProdStackUrl(cloudId)} with error: ${e}`);
        return null;
    }
};
const $fad0c3bb22e40c28$var$_getAutomationKeyFromLocalStorage = (key)=>{
    return window.localStorage.getItem(`${$fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_PREFIX}:${key}`);
};
const $fad0c3bb22e40c28$var$getAutomationDevStackFromLocalServer = async ()=>{
    try {
        const devStackResponse = await fetch($fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL);
        const devStack = await devStackResponse.json();
        return devStack.name;
    } catch (e) {
        // eslint-disable-next-line no-console
        console.warn(`Failed to fetch dev stack from ${$fad0c3bb22e40c28$var$AUTOMATION_DEV_STACK_URL} with error: ${e}`);
        return null;
    }
};
const $fad0c3bb22e40c28$export$48cdb3ba720a47f6 = ()=>$fad0c3bb22e40c28$var$_getAutomationKeyFromLocalStorage($fad0c3bb22e40c28$var$AUTOMATION_LOCAL_STORAGE_STACK);
const $fad0c3bb22e40c28$export$6123178d3f5fb24d = async (env, cloudId)=>{
    if (env === 'prod') return 'pro';
    if (env === 'pre-prod') {
        const stack = await $fad0c3bb22e40c28$var$getLatestPreProdStack(cloudId);
        return stack ?? 'pro';
    }
    // We fetch the dev stack name from local server (barrel webpack dev server) if it's available.
    // However, this requires that devWatch is running locally.
    // To use manual triggers without running devWatch, set the local storage value to your stack name e.g. devltan3. The full key is: automationPlatform:automationStack
    const stackOverride = await $fad0c3bb22e40c28$var$getAutomationDevStackFromLocalServer() || $fad0c3bb22e40c28$export$48cdb3ba720a47f6();
    return stackOverride || 'staging';
};

});



parcelRegister("gSw9T", function(module, exports) {

$parcel$export(module.exports, "UserInputForm", () => $2d4c6f1389454e60$export$a3f697c029ab2691);
$parcel$export(module.exports, "default", () => $2d4c6f1389454e60$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $eCeGD = parcelRequire("eCeGD");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $3lQ26 = parcelRequire("3lQ26");

var $1R1Ge = parcelRequire("1R1Ge");
var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");

var $cFwyy = parcelRequire("cFwyy");

var $1vBpb = parcelRequire("1vBpb");

var $dZuta = parcelRequire("dZuta");

var $6WPAN = parcelRequire("6WPAN");

var $7mBJV = parcelRequire("7mBJV");

var $g9On4 = parcelRequire("g9On4");

var $bDNlV = parcelRequire("bDNlV");
const $2d4c6f1389454e60$export$a3f697c029ab2691 = (props)=>{
    (0, $gKZoD.di)((0, $dZuta.default), (0, $eCeGD.default), (0, $qfj8c.ErrorMessage), (0, $efXp3.default), (0, $3lQ26.default), (0, $1R1Ge.default), (0, $7QSqG.default), (0, $juxqI.default), (0, $jgVsb.default), (0, $gofOI.default), (0, $6WPAN.default), (0, $g9On4.default), (0, $bDNlV.default));
    const { selectedRule: selectedRule, clearSelectedRule: clearSelectedRule, invokeRule: invokeRule, onInputsModalOpened: onInputsModalOpened, onInputsModalClosed: onInputsModalClosed } = props;
    const { rule: rule, objects: objects } = selectedRule;
    const { userInputPrompts: userInputPrompts } = rule;
    const getTypeOfInput = (key, prompts)=>prompts.find(({ variableName: variableName })=>variableName === key)?.inputType;
    const generateInputValue = (inputType, data)=>{
        switch(inputType){
            case (0, $1vBpb.UserInputType).DROPDOWN:
                return {
                    inputType: inputType,
                    value: data ? data.value : ''
                };
            case (0, $1vBpb.UserInputType).NUMBER:
                return {
                    inputType: inputType,
                    value: Number(data)
                };
            default:
                return {
                    inputType: inputType,
                    value: data
                };
        }
    };
    const handleSubmit = (data)=>{
        const output = Object.entries(data).reduce((acc, [key, value])=>{
            const inputType = getTypeOfInput(key, userInputPrompts);
            if (!inputType) return acc;
            acc[key] = generateInputValue(inputType, value);
            return acc;
        }, {});
        return invokeRule(rule.id, objects, output);
    };
    const handleOpen = ()=>{
        if (onInputsModalOpened) onInputsModalOpened();
    };
    const handleClose = ()=>{
        clearSelectedRule();
        if (onInputsModalClosed) onInputsModalClosed();
    };
    const generateUserInputForm = (inputPrompt)=>{
        switch(inputPrompt.inputType){
            case (0, $1vBpb.UserInputType).TEXT:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bDNlV.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $1vBpb.UserInputType).NUMBER:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6WPAN.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $1vBpb.UserInputType).DROPDOWN:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $g9On4.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $1vBpb.UserInputType).BOOLEAN:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dZuta.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            case (0, $1vBpb.UserInputType).PARAGRAPH:
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7mBJV.default), {
                    userInputPrompt: inputPrompt
                }, inputPrompt.variableName);
            default:
                return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)("br", {}),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                            children: (0, $cFwyy.default).errorInputTypeIsNotSupported.defaultMessage
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)("br", {})
                    ]
                });
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1R1Ge.default), {
        "data-testid": "automation-platform.ui.manual-rules-container.manual-triggers-form.modal",
        onClose: handleClose,
        onOpenComplete: handleOpen,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $efXp3.default), {
            onSubmit: handleSubmit,
            children: ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, $2OMIu.jsxs)("form", {
                    ...formProps,
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jgVsb.default), {
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $gofOI.default), {
                                children: rule.name
                            })
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7QSqG.default), {
                            children: [
                                (0, $cFwyy.default).inputRequiredForAction.defaultMessage,
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3lQ26.default), {
                                    children: userInputPrompts.map(generateUserInputForm)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $juxqI.default), {
                            children: [
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                    appearance: "subtle",
                                    onClick: handleClose,
                                    isDisabled: submitting,
                                    children: (0, $cFwyy.default).cancelButtonTitle.defaultMessage
                                }),
                                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eCeGD.default), {
                                    appearance: "primary",
                                    type: "submit",
                                    isLoading: submitting,
                                    autoFocus: true,
                                    children: (0, $cFwyy.default).continueButtonTitle.defaultMessage
                                })
                            ]
                        })
                    ]
                })
        })
    });
};
var $2d4c6f1389454e60$export$2e2bcd8739ae039 = $2d4c6f1389454e60$export$a3f697c029ab2691;

});
parcelRegister("3lQ26", function(module, exports) {

$parcel$export(module.exports, "default", () => $b3e71eeb72c100e3$export$2e2bcd8739ae039);
/* form-section.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $l1N8i = parcelRequire("l1N8i");
const $b3e71eeb72c100e3$var$formSectionDescriptionStyles = null;
const $b3e71eeb72c100e3$var$formSectionWrapperStyles = null;
const $b3e71eeb72c100e3$var$FormSectionWrapper = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1pfh1ejb"
        ]),
        children: children
    });
};
const $b3e71eeb72c100e3$var$FormSectionDescription = ({ children: children })=>{
    // eslint-disable-next-line @atlaskit/design-system/use-primitives
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1pfhu2gc"
        ]),
        children: children
    });
};
/**
 * __Form section__.
 *
 * A form section is used to define a section of a form layout. This contains a section title, content
 * and a description of the section.
 *
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout)
 * - [Usage](https://atlaskit.atlassian.com/packages/design-system/form/docs/layout).
 */ const $b3e71eeb72c100e3$var$FormSection = ({ children: children, description: description, title: title })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)($b3e71eeb72c100e3$var$FormSectionWrapper, {
        children: [
            title && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                size: "medium",
                children: title
            }),
            description && /*#__PURE__*/ (0, $2OMIu.jsx)($b3e71eeb72c100e3$var$FormSectionDescription, {
                children: description
            }),
            children
        ]
    });
};
var $b3e71eeb72c100e3$export$2e2bcd8739ae039 = $b3e71eeb72c100e3$var$FormSection;

});

parcelRegister("cFwyy", function(module, exports) {

$parcel$export(module.exports, "default", () => $455d55ebd61a4abd$export$2e2bcd8739ae039);
const $455d55ebd61a4abd$var$messages = {
    successFlag: {
        id: 'automation-platform.common.success-flag',
        defaultMessage: 'Your automation is in progress',
        description: 'Text for a success flag when an automation rule has been triggered'
    },
    failureFlagTitle: {
        id: 'automation-platform.common.failure-flag-title',
        defaultMessage: 'Oops we ran into a problem',
        description: 'Title for an error flag when an automation rule failed to be triggered'
    },
    failureFlagDescription: {
        id: 'automation-platform.common.failure-flag-description',
        defaultMessage: "There was a problem and we couldn't run the automation '{0}'",
        description: 'Description for an error flag when an automation rule failed to be triggered'
    },
    partialFailureFlagDescription: {
        id: 'automation-platform.common.partial-failure-flag-description',
        defaultMessage: "Couldn't run the automation against issues {0}, please ensure you have permission to view these issues",
        description: 'Description for an error flag when some issues failed to invoke because user does not have view permission'
    },
    errorInputMustNotBeEmpty: {
        id: 'automation-platform.common.error-input-must-not-be-empty',
        defaultMessage: 'Input must not be empty',
        description: 'The error message to show the value of a required field is empty'
    },
    errorInputCharacterLimitReached: {
        id: 'automation-platform.common.error-input-character-limit-reached',
        defaultMessage: 'Provided value exceeds the character limit for the field.',
        description: 'The error message to show that the character limit has been reached for the field'
    },
    inputRequiredForAction: {
        id: 'automation-platform.common.input-required-for-action',
        defaultMessage: 'Your input is required to complete this action',
        description: 'The title of the modal for user inputs'
    },
    errorInputTypeIsNotSupported: {
        id: 'automation-platform.common.error-input-type-is-not-supported',
        defaultMessage: 'Input type not supported yet',
        description: 'The error message to show when the type of user input is not recognised'
    },
    errorValueIsNotValidNumber: {
        id: 'automation-platform.common.error-value-is-not-valid-number',
        defaultMessage: 'The value is not a valid number',
        description: 'The error message for when the type of user input is number but the value is not a valid number'
    },
    cancelButtonTitle: {
        id: 'automation-platform.common.cancel-button-title',
        defaultMessage: 'Cancel',
        description: 'The cancel button title'
    },
    continueButtonTitle: {
        id: 'automation-platform.common.continue-button-title',
        defaultMessage: 'Continue',
        description: 'The continue button title'
    }
};
var $455d55ebd61a4abd$export$2e2bcd8739ae039 = $455d55ebd61a4abd$var$messages;

});

parcelRegister("1vBpb", function(module, exports) {

$parcel$export(module.exports, "UserInputType", () => $7ba154a8ce2ccf9e$export$955ccc93b55d5904);
var $7ba154a8ce2ccf9e$export$955ccc93b55d5904 = /*#__PURE__*/ function(UserInputType) {
    UserInputType["NUMBER"] = "NUMBER";
    UserInputType["TEXT"] = "TEXT";
    UserInputType["BOOLEAN"] = "BOOLEAN";
    UserInputType["DROPDOWN"] = "DROPDOWN";
    UserInputType["PARAGRAPH"] = "PARAGRAPH";
    return UserInputType;
}({});
const $7ba154a8ce2ccf9e$export$4b79f735ed858abe = 'business';
const $7ba154a8ce2ccf9e$export$417275bac62d38d2 = 'software';
const $7ba154a8ce2ccf9e$export$9c9c9eaf8c092006 = 'service_desk';
const $7ba154a8ce2ccf9e$export$e9fe9a39cc7f5103 = 'product_discovery';
const $7ba154a8ce2ccf9e$export$e9c56aa3b027d98f = 'customer_service';

});

parcelRegister("dZuta", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae94375b49c6df33$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $kkJfY = parcelRequire("kkJfY");

var $hp1g9 = parcelRequire("hp1g9");
const $ae94375b49c6df33$var$BooleanInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $kkJfY.default), (0, $hp1g9.default));
    const { variableName: variableName, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hp1g9.default), {
        name: variableName,
        defaultIsChecked: defaultValue || false,
        children: ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $kkJfY.default), {
                ...fieldProps,
                label: displayName
            })
    });
};
var $ae94375b49c6df33$export$2e2bcd8739ae039 = $ae94375b49c6df33$var$BooleanInputPrompt;

});
parcelRegister("kkJfY", function(module, exports) {

$parcel$export(module.exports, "default", () => $3106eb14f9b0a593$export$2e2bcd8739ae039);
/* checkbox.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $6QvkM = parcelRequire("6QvkM");

var $5JjdN = parcelRequire("5JjdN");

var $kag1C = parcelRequire("kag1C");
var $7xteU = parcelRequire("7xteU");
var $hsLv2 = parcelRequire("hsLv2");
var $e62YQ = parcelRequire("e62YQ");
const $3106eb14f9b0a593$var$checkboxStyles = {
    root: "_19itglyw _nd5lfibj _12ji1r31 _1qu2glyw _12y31o36 _1bsb1osq _4t3i1osq _r06hglyw _6rthze3t _1pfhze3t _12l2ze3t _ahbqze3t _tzy4idpf _r050fibj _9bg71mn3 _19op11so _a30fhteq _1610e4h9 _13wo93zu _q5a61gyf _8gq114p8 _wje2mov0 _1fo21cni _eyedglyw _1ef7js4s _1h6rjs4s _smzgj3jf _1dk7j3jf _l71j1i6y _t34a1i6y _y32gkivo _1ah9199y _1frj180l _h78e1g3k _dwvb1ps2 _1bok170n _1mhr17cl _fx2i3rva _10oaq2ws _w12s155b _15y61vek _e6ww155b _sg1j1vek _rphw18jz _y9y9mz2b _141bmz2b _255gmz2b _jj67mz2b _swhgmz2b _axq81diq _1jiz1diq _s9051diq _1efy1diq _1oav1diq _10y313gf _1wt913gf _qq8613gf _1adw13gf _12sr13gf _16jiglyw _693jglyw _1niqglyw _cl9tglyw _1jbnglyw _j1ta1hou _18qu1ps2 _1g52170n _1log17cl _32hzmz2b _1vv91diq _yjhd1hou _w1cowc43 _jdqn1onz _4y4t1onz _lvfrwc43 _g68dwc43 _13dk1onz _w1el1onz _a9yw1onz _1l3g1onz _dcdpgir2 _wobcgir2 _rp9wgir2 _9ebfwc43 _e43iwc43 _1tkuwc43 _1lehwc43 _b9q3wc43 _tu2918qt _1uxv18qt _1ufw18qt _opo918qt _1e8318qt _1k3d18qt _25yv18qt _1igz18qt _c7cc18qt _1swg18qt"
}; /**
    * __Checkbox__
    *
    * A checkbox an input control that allows a user to select one or more options from a number of choices.
    *
    * - [Examples](https://atlassian.design/components/checkbox/examples)
    * - [Code](https://atlassian.design/components/checkbox/code)
    * - [Usage](https://atlassian.design/components/checkbox/usage)
    */ 
const $3106eb14f9b0a593$var$Checkbox = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Checkbox({ isChecked: isCheckedProp, isDisabled: isDisabled = false, isInvalid: isInvalid = false, defaultChecked: defaultChecked = false, isIndeterminate: isIndeterminate = false, onChange: onChangeProps, analyticsContext: analyticsContext, label: label, name: name, value: value, isRequired: isRequired, testId: testId, xcss: xcss, className: className, ...rest }, ref) {
    const [isCheckedState, setIsCheckedState] = (0, $5uXOq.useState)(isCheckedProp !== undefined ? isCheckedProp : defaultChecked);
    const onChange = (0, $5uXOq.useCallback)((e, analyticsEvent)=>{
        setIsCheckedState(e.target.checked);
        if (onChangeProps) onChangeProps(e, analyticsEvent);
    }, [
        onChangeProps
    ]);
    const onChangeAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        componentName: 'checkbox',
        packageName: "platform-pkg",
        packageVersion: "0.0.0-use.local"
    });
    const internalRef = (0, $5uXOq.useRef)(null);
    const mergedRefs = (0, $5JjdN.default)([
        internalRef,
        ref
    ]); // Use isChecked from the state if it is controlled
    const isChecked = isCheckedProp === undefined ? isCheckedState : isCheckedProp;
    (0, $5uXOq.useEffect)(()=>{
        if (internalRef.current) internalRef.current.indeterminate = isIndeterminate;
    }, [
        isIndeterminate
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $7xteU.default), {
        isDisabled: isDisabled,
        label: label,
        id: rest.id ? `${rest.id}-label` : undefined,
        testId: testId && `${testId}--checkbox-label`,
        // When there is more usage of this pattern we'll update the lint rule.
        xcss: xcss,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input" // It is necessary only for Safari. It allows to render focus styles.
            , {
                tabIndex: 0,
                ...rest,
                type: "checkbox",
                ref: mergedRefs,
                disabled: isDisabled,
                checked: isChecked,
                value: value,
                name: name,
                required: isRequired,
                className: (0, $bwpsq.default)([
                    $3106eb14f9b0a593$var$checkboxStyles.root,
                    className
                ]),
                onChange: onChangeAnalytics,
                "aria-invalid": isInvalid ? 'true' : undefined,
                "data-testid": testId && `${testId}--hidden-checkbox`,
                "data-invalid": isInvalid ? 'true' : undefined
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kag1C.default), {
                isIndeterminate: isIndeterminate,
                isChecked: isChecked
            }),
            label && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $hsLv2.default), {
                children: [
                    label,
                    isRequired && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $e62YQ.default), {})
                ]
            })
        ]
    });
}));
$3106eb14f9b0a593$var$Checkbox.displayName = 'Checkbox';
var $3106eb14f9b0a593$export$2e2bcd8739ae039 = $3106eb14f9b0a593$var$Checkbox;

});
parcelRegister("kag1C", function(module, exports) {

$parcel$export(module.exports, "default", () => $a0746a27410bc168$export$2e2bcd8739ae039);
/* checkbox-icon.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");
function $a0746a27410bc168$var$getIcon(isIndeterminate, isChecked) {
    if (isIndeterminate) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M7.75 12.75H16.25V11.25H7.75V12.75Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
            fill: "inherit",
            x: "8",
            y: "11",
            width: "8",
            height: "2",
            rx: "1"
        });
    }
    if (isChecked) {
        // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
            fill: "inherit"
        });
        else return /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
            d: "M9.707 11.293a1 1 0 1 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L11 12.586l-1.293-1.293z",
            fill: "inherit"
        });
    }
    // No icon
    return null;
}
/**
 * __Checkbox icon__
 *
 * A checkbox icon is the visual representation of checkbox state,
 * which is shown instead of the native input.
 *
 * @internal
 */ const $a0746a27410bc168$var$CheckboxIcon = /*#__PURE__*/ (0, $5uXOq.memo)(({ isIndeterminate: isIndeterminate, isChecked: isChecked })=>{
    const icon = (0, $5uXOq.useMemo)(()=>$a0746a27410bc168$var$getIcon(isIndeterminate, isChecked), [
        isIndeterminate,
        isChecked
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        primaryColor: "var(--checkbox-background-color)",
        secondaryColor: "var(--checkbox-tick-color)",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)("g", {
            fillRule: "evenodd",
            children: [
                // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
                (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "5.5",
                    y: "5.5",
                    width: "13",
                    height: "13",
                    rx: "1.5"
                }) : /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                    fill: "currentColor",
                    x: "6",
                    y: "6",
                    width: "12",
                    height: "12",
                    rx: "2"
                }),
                icon
            ]
        })
    });
});
var $a0746a27410bc168$export$2e2bcd8739ae039 = $a0746a27410bc168$var$CheckboxIcon;

});

parcelRegister("7xteU", function(module, exports) {

$parcel$export(module.exports, "default", () => $7b368d644c230660$export$2e2bcd8739ae039);
/* label.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $7b368d644c230660$var$baseStyles = null;
const $7b368d644c230660$var$textLabelLayoutStyles = null;
const $7b368d644c230660$var$disabledStyles = null;
const $7b368d644c230660$var$labelStyles = null;
function $7b368d644c230660$export$2e2bcd8739ae039({ children: children, isDisabled: isDisabled, testId: testId, label: label, id: id, xcss: xcss }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("label", {
        className: (0, $bwpsq.default)([
            "_11c82smr _1e0c11p5 _1ejihkll _umai184x _syazj3m3 _80om73ad",
            label && "_zulp1nu5 _yv0ey09t",
            isDisabled && "_syaz1tvo _80om13gf",
            "_h5e3mag2 _1nzs11d3 _1eszzyvw _yp0jhh5a _ay2w1y1w _d51u10ko _phft1fmg _1g1funzk _l6wkzyvw _1dikhh5a _1sfg1q3k _fpdj1y1w _1yjc194a _oaj11fmg _1j3h1q3k _eawb1dzn _1rda1qbb _18q015t7 _13hr3acm",
            xcss
        ]),
        "data-testid": testId,
        "data-disabled": isDisabled || undefined,
        id: id,
        children: children
    });
}

});

parcelRegister("hsLv2", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce636d67b4ff1120$export$2e2bcd8739ae039);
/* label-text.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $ce636d67b4ff1120$var$labelTextStyles = null;
function $ce636d67b4ff1120$export$2e2bcd8739ae039({ children: children }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        className: (0, $bwpsq.default)([
            "_nd5l11ig _1wpz1h6o"
        ]),
        children: children
    });
}

});

parcelRegister("e62YQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d2156c28a3894cac$export$2e2bcd8739ae039);
/* required-indicator.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $d2156c28a3894cac$var$requiredIndicatorStyles = null;
function $d2156c28a3894cac$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $2OMIu.jsx)("span", {
        "aria-hidden": true,
        className: (0, $bwpsq.default)([
            "_syaz1gtz _bozgv77o"
        ]),
        children: "*"
    });
}

});


parcelRegister("hp1g9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9ccbe97401ecc0bf$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $7O4UO = parcelRequire("7O4UO");
/**
 * __Checkbox field__
 *
 * A checkbox field is a form field that lets users select an item. Users can check or uncheck the checkbox.
 *
 * - [Examples] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Code] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 * - [Usage] https://atlaskit.atlassian.com/packages/design-system/form/docs/fields#checkboxfield-reference
 */ const $9ccbe97401ecc0bf$var$CheckboxField = (props)=>{
    const { children: children, defaultIsChecked: defaultIsChecked = false, value: value, ...rest } = props;
    // Maintains a memoised list of the default values
    const defaultValue = (0, $5uXOq.useCallback)((currentValue = [])=>defaultIsChecked && value !== undefined ? [
            ...currentValue,
            value
        ] : currentValue, [
        value,
        defaultIsChecked
    ]);
    return value !== undefined ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultValue,
        transform: (event, currentValue)=>event.currentTarget.checked && currentValue ? [
                ...currentValue,
                value
            ] : currentValue.filter((v)=>v !== value),
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: !!fieldValue.find((v)=>v === value),
                    value: value
                },
                ...others
            })
    }) : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        ...rest,
        defaultValue: defaultIsChecked,
        transform: (event)=>event.currentTarget.checked,
        children: ({ fieldProps: { value: fieldValue, ...otherFieldProps }, ...others })=>children({
                fieldProps: {
                    ...otherFieldProps,
                    isChecked: fieldValue,
                    value: value
                },
                ...others
            })
    });
};
$9ccbe97401ecc0bf$var$CheckboxField.defaultProps = {
    defaultIsChecked: false
};
var $9ccbe97401ecc0bf$export$2e2bcd8739ae039 = $9ccbe97401ecc0bf$var$CheckboxField;

});


parcelRegister("6WPAN", function(module, exports) {

$parcel$export(module.exports, "default", () => $e22492a7312b03b7$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $cFwyy = parcelRequire("cFwyy");
var $e22492a7312b03b7$export$b8e9cd941e8016ac = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["INVALID_NUMBER"] = "INVALID_NUMBER";
    return Errors;
}({});
const $e22492a7312b03b7$export$c6cbc3bbef9e5a54 = (isRequired, value)=>{
    if (isRequired && !value) return "EMPTY";
    if (value && Number.isNaN(Number(value))) return "INVALID_NUMBER";
    return undefined;
};
const $e22492a7312b03b7$var$NumberInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $kY99m.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const generateErrorMessage = (error)=>{
        switch(error){
            case "EMPTY":
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                    children: (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage
                });
            case "INVALID_NUMBER":
                return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                    children: (0, $cFwyy.default).errorValueIsNotValidNumber.defaultMessage
                });
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        "aria-required": required,
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: (value)=>$e22492a7312b03b7$export$c6cbc3bbef9e5a54(required, value),
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
                        ...fieldProps
                    }),
                    generateErrorMessage(error)
                ]
            })
    }, variableName);
};
var $e22492a7312b03b7$export$2e2bcd8739ae039 = $e22492a7312b03b7$var$NumberInputPrompt;

});

parcelRegister("7mBJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0425f45ac938ac$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $6LCpJ = parcelRequire("6LCpJ");

var $cFwyy = parcelRequire("cFwyy");
var $0c0425f45ac938ac$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    Errors["CHARACTER_LIMIT"] = "CHARACTER_LIMIT";
    return Errors;
}($0c0425f45ac938ac$var$Errors || {});
const $0c0425f45ac938ac$var$MAX_PARAGRAPH_CHARACTER_LIMIT = 5000;
const $0c0425f45ac938ac$var$ParagraphInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $6LCpJ.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        if (value && value?.trim().length === 0) return "EMPTY";
        if (value && value.length > $0c0425f45ac938ac$var$MAX_PARAGRAPH_CHARACTER_LIMIT) return "CHARACTER_LIMIT";
        return undefined;
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $6LCpJ.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                        children: (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage
                    }),
                    error === "CHARACTER_LIMIT" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                        children: (0, $cFwyy.default).errorInputCharacterLimitReached.defaultMessage
                    })
                ]
            })
    });
};
var $0c0425f45ac938ac$export$2e2bcd8739ae039 = $0c0425f45ac938ac$var$ParagraphInputPrompt;

});
parcelRegister("6LCpJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $934f91ac04cc5aeb$export$2e2bcd8739ae039);
/* text-area.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $VSDnB = parcelRequire("VSDnB");
const $934f91ac04cc5aeb$var$packageName = "platform-pkg";
const $934f91ac04cc5aeb$var$packageVersion = "0.0.0-use.local";
const $934f91ac04cc5aeb$var$analyticsParams = {
    componentName: 'textArea',
    packageName: $934f91ac04cc5aeb$var$packageName,
    packageVersion: $934f91ac04cc5aeb$var$packageVersion
};
const $934f91ac04cc5aeb$var$lineHeightBase = 20;
const $934f91ac04cc5aeb$var$lineHeightCompact = 16;
const $934f91ac04cc5aeb$var$compactVerticalPadding = 2;
const $934f91ac04cc5aeb$var$verticalPadding = 6;
const $934f91ac04cc5aeb$var$transitionDuration = '0.2s';
const $934f91ac04cc5aeb$var$borderWidth = 2;
const $934f91ac04cc5aeb$var$baseStyles = null;
const $934f91ac04cc5aeb$var$appearanceStyles = {
    standard: "_1dqonqa1 _kp821elr _1ltx1j9a _1bqs13gt _z1pvsyzs _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _17km1v6z _wg601v6z _858u1p6i _jomrr01l _7ehiq049 _186j1p6i _qu18syzs",
    subtle: "_1dqonqa1 _kp823acm _1ltx18uv _19wt1elr _12ym1d5g _19qkv77o _1dbiv77o _1etu1v6z _zedr1v6z _1itd12x7 _1a4912x7 _wg601v6z _17km1v6z _858u1p6i _jomrr01l _7ehiq049",
    none: "_1dqoglyw _kp823acm _1ltx18uv _19wt3acm _12ym18uv _19qkv77o _zedr12x7 _1dbiv77o _1etu12x7 _1itd12x7 _wg6012x7 _1a4912x7 _17km12x7 _858u3acm _jomr18uv _7ehinruj"
};
const $934f91ac04cc5aeb$var$fontStyles = {
    default: "_ect41gqc",
    monospace: "_ect41odn _1tn22smr _14mdudxr",
    large: "_11c81ixg _1tn22smr"
};
const $934f91ac04cc5aeb$var$resizeStyles = {
    horizontal: "_14zg1e08",
    vertical: "_14zg1e54",
    auto: "_14zg1hrf",
    smart: "_14zgglyw",
    none: "_14zgglyw"
};
const $934f91ac04cc5aeb$var$setSmartHeight = (el)=>{
    // Always reset height to auto before calculating new height
    el.style.height = 'auto';
    const borderHeight = $934f91ac04cc5aeb$var$borderWidth;
    const paddingBoxHeight = el.scrollHeight;
    const borderBoxHeight = paddingBoxHeight + borderHeight * 2;
    el.style.height = `${borderBoxHeight}px`;
};
const $934f91ac04cc5aeb$var$InnerTextArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const ourRef = (0, $5uXOq.useRef)(null);
    const { resize: resize = 'smart', appearance: appearance = 'standard', isCompact: isCompact = false, isRequired: isRequired = false, isReadOnly: isReadOnly = false, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isMonospaced: isMonospaced = false, minimumRows: minimumRows = 2, testId: testId, maxHeight: maxHeight = '50vh', onBlur: onBlur, onFocus: onFocus, onChange: onChange, value: value, style: style, ...rest } = props;
    const borderHeight = (0, $5uXOq.useMemo)(()=>appearance === 'none' ? 2 : 1, [
        appearance
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
    }, [
        resize,
        value
    ]);
    const onBlurWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onBlur && onBlur(event);
        },
        action: 'blurred',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const onFocusWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: (event)=>{
            onFocus && onFocus(event);
        },
        action: 'focused',
        ...$934f91ac04cc5aeb$var$analyticsParams
    });
    const getTextAreaRef = (elementRef)=>{
        ourRef.current = elementRef;
        if (ref && typeof ref === 'object') // @ts-ignore
        ref.current = elementRef;
        if (ref && typeof ref === 'function') ref(elementRef);
    };
    const handleOnChange = (0, $5uXOq.useCallback)((e)=>{
        const el = ourRef.current;
        if (resize === 'smart' && el) $934f91ac04cc5aeb$var$setSmartHeight(el);
        onChange && onChange(e);
    }, [
        onChange,
        resize
    ]);
    const controlProps = {
        'data-invalid': isInvalid ? isInvalid : undefined,
        'data-compact': isCompact ? isCompact : undefined,
        'data-testid': testId ? testId : undefined
    };
    const compactMinHeightStyles = null;
    return /*#__PURE__*/ (0, $2OMIu.jsx)("textarea", {
        ...controlProps,
        value: value,
        disabled: isDisabled,
        readOnly: isReadOnly,
        required: isRequired,
        ref: getTextAreaRef,
        onChange: handleOnChange,
        onBlur: onBlurWithAnalytics,
        onFocus: onFocusWithAnalytics,
        rows: minimumRows,
        ...rest,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _16jlkb7n _1o9zkb7n _i0dl1osq _2rko1sit _11c82smr _12ji1r31 _1qu2glyw _12y31o36 _1reo1wug _18m91wug _v564r5cv _189ee4h9 _1e0c1ule _vchhusvi _1bsb1osq _1ul9idpf _p12f1osq _kqswh2mm _syazj3m3 _slp31hna _153g78r2 _usy4mag2 _1a2sr6rt _vbqb9jg2 _j5dh13gf _cfjqkb7n _k3o7n7od _1goxglyw _13xeglyw _1fra78r2 _ibjd10ko _6zpvr6rt _19k01y1w _1idr1wmz _1lep9jg2 _nmhq1fiz _1n388sxn _1luh194a _ndzbr01l _1vj01cu8",
            $934f91ac04cc5aeb$var$appearanceStyles[appearance],
            (0, $VSDnB.fg)('platform_design_system_team_safari_input_fix') && $934f91ac04cc5aeb$var$fontStyles['large'],
            $934f91ac04cc5aeb$var$fontStyles[isMonospaced ? 'monospace' : 'default'],
            $934f91ac04cc5aeb$var$resizeStyles[resize],
            "_uzq71i7i _16lwuel1"
        ]),
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop
            ...style,
            maxHeight: maxHeight,
            "--_6ny3x7": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightCompact * minimumRows + $934f91ac04cc5aeb$var$compactVerticalPadding * 2 + borderHeight * 2, "px"),
            "--_eorxnz": (0, $lD23V.default)($934f91ac04cc5aeb$var$lineHeightBase * minimumRows + $934f91ac04cc5aeb$var$verticalPadding * 2 + borderHeight * 2, "px")
        }
    });
}); /**
     * __Text area__
     *
     * A text area lets users enter long form text which spans over multiple lines.
     *
     * - [Examples](https://atlassian.design/components/textarea/examples)
     * - [Code](https://atlassian.design/components/textarea/code)
     * - [Usage](https://atlassian.design/components/textarea/usage)
     */ 
const $934f91ac04cc5aeb$var$TextArea = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function TextArea(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($934f91ac04cc5aeb$var$InnerTextArea, {
        ref: ref,
        ...props
    });
}));
$934f91ac04cc5aeb$var$TextArea.displayName = 'TextArea';
var $934f91ac04cc5aeb$export$2e2bcd8739ae039 = $934f91ac04cc5aeb$var$TextArea;

});


parcelRegister("g9On4", function(module, exports) {

$parcel$export(module.exports, "default", () => $b944eed42d17fa4b$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $7K5PP = parcelRequire("7K5PP");

var $cFwyy = parcelRequire("cFwyy");
var $b944eed42d17fa4b$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($b944eed42d17fa4b$var$Errors || {});
const $b944eed42d17fa4b$var$SelectInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $7K5PP.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>{
        if (required && !value) return "EMPTY";
        return undefined;
    };
    const selectOptions = defaultValue.map((value)=>({
            label: value,
            value: value
        }));
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                        isClearable: true,
                        isSearchable: true,
                        options: selectOptions,
                        menuPosition: "fixed",
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                        children: (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $b944eed42d17fa4b$export$2e2bcd8739ae039 = $b944eed42d17fa4b$var$SelectInputPrompt;

});

parcelRegister("bDNlV", function(module, exports) {

$parcel$export(module.exports, "default", () => $95844140411f95a2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");

var $kY99m = parcelRequire("kY99m");

var $cFwyy = parcelRequire("cFwyy");
var $95844140411f95a2$var$Errors = /*#__PURE__*/ function(Errors) {
    Errors["EMPTY"] = "EMPTY";
    return Errors;
}($95844140411f95a2$var$Errors || {});
const $95844140411f95a2$var$TextInputPrompt = ({ userInputPrompt: userInputPrompt })=>{
    (0, $gKZoD.di)((0, $qfj8c.ErrorMessage), (0, $7O4UO.default), (0, $kY99m.default));
    const { variableName: variableName, required: required, displayName: displayName, defaultValue: defaultValue } = userInputPrompt;
    const validate = (value)=>required && !value ? "EMPTY" : undefined;
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7O4UO.default), {
        name: variableName,
        label: displayName,
        defaultValue: defaultValue,
        isRequired: required,
        validate: validate,
        children: ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kY99m.default), {
                        ...fieldProps
                    }),
                    error === "EMPTY" && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $qfj8c.ErrorMessage), {
                        children: (0, $cFwyy.default).errorInputMustNotBeEmpty.defaultMessage
                    })
                ]
            })
    });
};
var $95844140411f95a2$export$2e2bcd8739ae039 = $95844140411f95a2$var$TextInputPrompt;

});



parcelRegister("k9To8", function(module, exports) {

$parcel$export(module.exports, "default", () => $ef3572ada154aadf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ef3572ada154aadf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    successFlag: {
        "id": "automation-platform.common.success-flag",
        "defaultMessage": "Your automation is in progress"
    },
    failureFlagTitle: {
        "id": "automation-platform.common.failure-flag-title",
        "defaultMessage": "Oops we ran into a problem"
    },
    failureFlagDescription: {
        "id": "automation-platform.common.failure-flag-description",
        "defaultMessage": "There was a problem and we couldn't run the automation \"{0}\""
    },
    partialFailureFlagDescription: {
        "id": "automation-platform.common.partial-failure-flag-description",
        "defaultMessage": "Couldn't run the automation against issues \"{0}\", please ensure you have permission to view these issues"
    },
    errorInputMustNotBeEmpty: {
        "id": "automation-platform.common.error-input-must-not-be-empty",
        "defaultMessage": "Input must not be empty"
    },
    errorInputCharacterLimitReached: {
        "id": "automation-platform.common.error-input-character-limit-reached",
        "defaultMessage": "Provided value exceeds the character limit for the field."
    },
    inputRequiredForAction: {
        "id": "automation-platform.common.input-required-for-action",
        "defaultMessage": "Your input is required to complete this action"
    },
    errorInputTypeIsNotSupported: {
        "id": "automation-platform.common.error-input-type-is-not-supported",
        "defaultMessage": "Input type not supported yet"
    },
    errorValueIsNotValidNumber: {
        "id": "automation-platform.common.error-value-is-not-valid-number",
        "defaultMessage": "The value is not a valid number"
    },
    cancelButtonTitle: {
        "id": "automation-platform.common.cancel-button-title",
        "defaultMessage": "Cancel"
    },
    continueButtonTitle: {
        "id": "automation-platform.common.continue-button-title",
        "defaultMessage": "Continue"
    }
});

});


parcelRegister("gOS29", function(module, exports) {

$parcel$export(module.exports, "getBaseAutomationUrl", () => $b61a7afc01657dc2$export$8e479e490e1e69bc);
const $b61a7afc01657dc2$export$8e479e490e1e69bc = ({ projectKey: projectKey, projectType: projectType, isSimplified: isSimplified })=>{
    /**
	 * Confusing mapping of urls here.
	 * Classic Projects - always under /automate
	 * Next Gen Projects - under /automation for all project types except JSD
	 */ if (projectType === 'service_desk') return `/jira/servicedesk/projects/${projectKey}/settings/automate`;
    if (projectType === 'business') return `/jira/core/projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
    return `/jira/software/${isSimplified ? '' : 'c/'}projects/${projectKey}/settings/${isSimplified ? 'automation' : 'automate'}`;
};

});

parcelRegister("4a5pt", function(module, exports) {

$parcel$export(module.exports, "default", () => $405c068c4e98f089$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $h5xhD = parcelRequire("h5xhD");

var $6K5bC = parcelRequire("6K5bC");

var $9LkAS = parcelRequire("9LkAS");

var $dpyBt = parcelRequire("dpyBt");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $9OXo1 = parcelRequire("9OXo1");

var $4R6GH = parcelRequire("4R6GH");

var $hdfW8 = parcelRequire("hdfW8");

var $kBike = parcelRequire("kBike");

var $btB4j = parcelRequire("btB4j");

var $XHOES = parcelRequire("XHOES");
const $405c068c4e98f089$var$RunRule = (props)=>{
    const { initialised: initialised, error: rulesError, rules: rules, executingRuleId: executingRuleId, executeRule: executeRule, triggerFetch: triggerFetch, selectedIssueIds: selectedIssueIds, setClosed: setClosed } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [{ canManageAutomations: canManageAutomations, projectAri: projectAri }] = (0, $kBike.useMenuContext)();
    const { environment: environment, cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const [baseAutomationUrl] = (0, $kBike.useBaseAutomationUrl)();
    const [{ data: recommendations, error: recommendationsError, loading: loading, fetched: fetched }] = (0, $6K5bC.useAutomationRecommendations)({
        env: environment,
        cloudId: cloudId,
        target: projectAri,
        shouldFetch: canManageAutomations
    });
    // Note: fetched is false if the request errors
    const initialisedRecommendations = !loading && fetched || recommendationsError != null || !canManageAutomations;
    const hasRecommendation = !!(recommendations && recommendations?.data.length > 0);
    const error = rulesError || recommendationsError;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($405c068c4e98f089$var$Container, {
        role: "dialog",
        "aria-modal": "false",
        "aria-labelledby": "automation-menu.ui.popup",
        "data-testid": "automation-menu.ui.popup.run-rule.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(event, 'automationMenuContent mounted')
    }), (0, $4R6GH.fg)('ux-2931-a11y-automation-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("h2", {
        "data-testid": "automation-menu.ui.popup.run-rule.menu-header",
        className: (0, $bwpsq.default)([
            $405c068c4e98f089$var$headerStyles.root
        ])
    }, formatMessage((0, $XHOES.default).automationHeader).toUpperCase()) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($405c068c4e98f089$var$Header, {
        "data-testid": "automation-menu.ui.popup.run-rule.menu-header"
    }, formatMessage((0, $XHOES.default).automationHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h5xhD.default), null, selectedIssueIds && selectedIssueIds.length > 0 || error ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $btB4j.default), {
        initialised: initialised && initialisedRecommendations,
        executingRuleId: executingRuleId,
        error: error,
        rules: rules,
        executeRule: executeRule,
        triggerFetch: triggerFetch,
        selectedIssueIds: selectedIssueIds,
        recommendations: recommendations?.data,
        setClosed: setClosed
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdfW8.ConditionalRecommendation), {
        initialised: initialisedRecommendations,
        canManageAutomations: canManageAutomations,
        baseAutomationUrl: baseAutomationUrl,
        recommendations: recommendations?.data,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dpyBt.NoIssueSelectedEmptyState), null),
        setClosed: setClosed
    }), canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9LkAS.default), {
        baseAutomationUrl: baseAutomationUrl,
        hasSeparator: !hasRecommendation
    })));
};
var $405c068c4e98f089$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $405c068c4e98f089$var$RunRule;
const $405c068c4e98f089$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv47k _1bsbp59q",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $405c068c4e98f089$var$Header = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h5", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxv47k _otyridpf _18u0v47k _syaz131l _1p1dangw",
            __cmplp.className
        ])
    });
});
const $405c068c4e98f089$var$headerStyles = {
    root: "_11c8140y _18u0v47k _syaz131l"
};

});
parcelRegister("h5xhD", function(module, exports) {

$parcel$export(module.exports, "default", () => $92a58bdbbfac4ce9$export$2e2bcd8739ae039);
/* popup-menu-group.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eZUJu = parcelRequire("eZUJu");
/**
 * @deprecated refer to MenuGroup, explicitly set maxWidth and minWidth
 */ const $92a58bdbbfac4ce9$var$PopupMenuGroup = ({ maxWidth: maxWidth = 800, minWidth: minWidth = 320, ...rest })=>// eslint-disable-next-line @repo/internal/react/no-unsafe-spread-props
    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eZUJu.default), {
        maxWidth: maxWidth,
        minWidth: minWidth,
        ...rest
    });
var $92a58bdbbfac4ce9$export$2e2bcd8739ae039 = $92a58bdbbfac4ce9$var$PopupMenuGroup;

});

parcelRegister("6K5bC", function(module, exports) {

$parcel$export(module.exports, "useAutomationRecommendations", () => $8e732ed9cb28fcc2$export$48a061abff796477);

var $iuEfD = parcelRequire("iuEfD");

var $48DMb = parcelRequire("48DMb");

var $c4l9J = parcelRequire("c4l9J");

var $c5wox = parcelRequire("c5wox");
const $8e732ed9cb28fcc2$var$fetchRecommendation = async ({ env: env, cloudId: cloudId, target: target }, options)=>{
    const url = await (0, $c5wox.getAutomationRecommendationsUrl)({
        env: env,
        cloudId: cloudId,
        target: target
    });
    const response = await (0, $48DMb.fetchJson)(url, options);
    return response;
};
const $8e732ed9cb28fcc2$export$48a061abff796477 = ({ env: env, cloudId: cloudId, target: target, shouldFetch: shouldFetch = true })=>(0, $iuEfD.useFetch)({
        onFetch: (options)=>$8e732ed9cb28fcc2$var$fetchRecommendation({
                env: env,
                cloudId: cloudId,
                target: target
            }, options),
        analyticsTracking: {
            actionSubject: `useFetch.${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}`,
            packageName: (0, $c4l9J.PACKAGE_NAME)
        },
        loggingKey: `${(0, $c4l9J.PACKAGE_NAME)}.${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}`,
        isAutoFetchable: shouldFetch
    }, [
        env,
        cloudId,
        target,
        shouldFetch
    ]);

});
parcelRegister("48DMb", function(module, exports) {

$parcel$export(module.exports, "fetchJson", () => $cfd862e6e9d86034$export$6d71b655afe1638d);

var $7f4tk = parcelRequire("7f4tk");

var $3wzQ9 = parcelRequire("3wzQ9");
const $cfd862e6e9d86034$export$6d71b655afe1638d = async (url, options = {})=>(0, $7f4tk.default)(url, options).catch((error)=>{
        throw new (0, $3wzQ9.FetchUrlError)(url, error);
    });

});

parcelRegister("c4l9J", function(module, exports) {

$parcel$export(module.exports, "AUTOMATION_MORE_DETAILS_URL", () => $ac484d837db7bb47$export$6f6eeff13d6dfe71);
$parcel$export(module.exports, "templateRecommendationPriority", () => $ac484d837db7bb47$export$202bed908b983e2d);
$parcel$export(module.exports, "AUTOMATION_RECOMMENDATIONS_PREFIX", () => $ac484d837db7bb47$export$4c17f46a32923c89);
$parcel$export(module.exports, "PACKAGE_NAME", () => $ac484d837db7bb47$export$b8b9d90f9e5bd72b);
const $ac484d837db7bb47$export$6f6eeff13d6dfe71 = 'https://support.atlassian.com/cloud-automation/docs/jira-automation-triggers/#Manual-trigger-from-issue';
const $ac484d837db7bb47$export$202bed908b983e2d = [
    'devops_template_6',
    'security_template_1',
    'devops_template_10',
    'devops_template_8'
];
const $ac484d837db7bb47$var$AUTOMATION_PREFIX = 'automation';
const $ac484d837db7bb47$export$4c17f46a32923c89 = `${$ac484d837db7bb47$var$AUTOMATION_PREFIX}.recommendations`;
const $ac484d837db7bb47$export$b8b9d90f9e5bd72b = 'jiraAutomationPlatform';

});


parcelRegister("9LkAS", function(module, exports) {

$parcel$export(module.exports, "default", () => $0eb68b9b7b7c2a06$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $23Uzi = parcelRequire("23Uzi");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");
const $0eb68b9b7b7c2a06$export$a06f1c675e846f6f = ({ baseAutomationUrl: baseAutomationUrl })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $23Uzi.default), {
        baseAutomationUrl: baseAutomationUrl,
        onCreateAutomationFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.createAutomation', {
                userType: 'admin'
            });
        },
        onManageAutomationsFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.manageAutomations', {
                userType: 'admin'
            });
        },
        onAuditLogFooterLinkClicked: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.adminFooter.auditLog', {
                userType: 'admin'
            });
        }
    });
};
var $0eb68b9b7b7c2a06$export$2e2bcd8739ae039 = $0eb68b9b7b7c2a06$export$a06f1c675e846f6f;

});
parcelRegister("23Uzi", function(module, exports) {

$parcel$export(module.exports, "default", () => $54004c2cfe1fb1a6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $5LWLA = parcelRequire("5LWLA");

var $dZbEw = parcelRequire("dZbEw");

var $34OIV = parcelRequire("34OIV");

var $3Z96c = parcelRequire("3Z96c");
var $9UCCQ = parcelRequire("9UCCQ");

var $8M6yJ = parcelRequire("8M6yJ");

var $cVoxq = parcelRequire("cVoxq");
const $54004c2cfe1fb1a6$var$handleOptionalCallback = (optionalEvent)=>{
    if (optionalEvent) optionalEvent();
};
var $54004c2cfe1fb1a6$export$2e2bcd8739ae039 = ({ baseAutomationUrl: baseAutomationUrl, createAutomationComponentFilter: createAutomationComponentFilter, onCreateAutomationFooterLinkClicked: onCreateAutomationFooterLinkClicked, onManageAutomationsFooterLinkClicked: onManageAutomationsFooterLinkClicked, onAuditLogFooterLinkClicked: onAuditLogFooterLinkClicked })=>{
    (0, $gKZoD.di)((0, (/*@__PURE__*/$parcel$interopDefault($34OIV))), (0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), (0, $5LWLA.default), (0, $8M6yJ.MenuIcon), (0, $9UCCQ.default));
    const componentFilter = createAutomationComponentFilter ? `?componentFilterCriteria=${createAutomationComponentFilter}` : '';
    const createNewRuleUrl = `${baseAutomationUrl}#/rule/new/__NEW__TRIGGER${componentFilter}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $9UCCQ.default), {
        hasSeparator: true,
        isList: true,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                onClick: ()=>$54004c2cfe1fb1a6$var$handleOptionalCallback(onCreateAutomationFooterLinkClicked),
                href: createNewRuleUrl,
                testId: "create-automation-link",
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6yJ.MenuIcon), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                        label: "",
                        color: "currentColor"
                    })
                }),
                children: (0, $cVoxq.default).createAutomationItem.defaultMessage
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                onClick: ()=>$54004c2cfe1fb1a6$var$handleOptionalCallback(onManageAutomationsFooterLinkClicked),
                href: baseAutomationUrl,
                testId: "manage-automations-link",
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6yJ.MenuIcon), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6yJ.ManageRulesGlyph), {})
                }),
                children: (0, $cVoxq.default).manageAutomationsItem.defaultMessage
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $3Z96c.default), {
                onClick: ()=>{
                    $54004c2cfe1fb1a6$var$handleOptionalCallback(onAuditLogFooterLinkClicked);
                },
                href: `${baseAutomationUrl}#tab/audit-log`,
                testId: "audit-log-link",
                iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $8M6yJ.MenuIcon), {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($34OIV))), {
                        label: "",
                        color: "currentColor"
                    })
                }),
                children: (0, $cVoxq.default).auditLogItem.defaultMessage
            })
        ]
    });
};

});
parcelRegister("8M6yJ", function(module, exports) {

$parcel$export(module.exports, "MenuIcon", () => $401a40ce500dda11$export$46e1d66043f363e6);
$parcel$export(module.exports, "TriggerIcon", () => $401a40ce500dda11$export$1cb264166623d4aa);
$parcel$export(module.exports, "ManualTriggerGlyph", () => $401a40ce500dda11$export$4514e29f70245d75);
$parcel$export(module.exports, "ManageRulesGlyph", () => $401a40ce500dda11$export$85ca00d4fc5d86c3);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $4ldhu = parcelRequire("4ldhu");

var $ggICg = parcelRequire("ggICg");

var $dp8JX = parcelRequire("dp8JX");
const $401a40ce500dda11$export$46e1d66043f363e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbzwfg _4t3izwfg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $401a40ce500dda11$export$1cb264166623d4aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $401a40ce500dda11$export$46e1d66043f363e6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz16rs _bfhk16iv",
            __cmplp.className
        ])
    });
});
const $401a40ce500dda11$export$4514e29f70245d75 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($dp8JX))), {
        color: "currentColor",
        ...props
    });
const $401a40ce500dda11$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($ggICg))), {
        label: "",
        ...props,
        color: "currentColor"
    });
const $401a40ce500dda11$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($4ldhu))), {
        color: "currentColor",
        ...props
    });
const $401a40ce500dda11$export$fdd32c4638a0c3ae = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "black",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
                fill: "white"
            })
        ]
    });
const $401a40ce500dda11$export$9d08b452ddec60a4 = (props)=>/*#__PURE__*/ (0, $2OMIu.jsxs)("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                width: "24",
                height: "24",
                fill: "white",
                fillOpacity: "0.01"
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
                fill: "black"
            })
        ]
    });

});
parcelRegister("dp8JX", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::c8cbf4ab2d75c385e37fe01f50c4f5b5>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c2463c982d0f116$var$_react = $9c2463c982d0f116$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c2463c982d0f116$var$_baseNew = $9c2463c982d0f116$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c2463c982d0f116$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PresenterMode".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for presenter mode in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c2463c982d0f116$var$PresenterModeIcon = (props)=>/*#__PURE__*/ $9c2463c982d0f116$var$_react.default.createElement($9c2463c982d0f116$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M4.909 2.5a2.409 2.409 0 0 0-1.054 4.576l-.657 1.348a3.909 3.909 0 1 1 5.226-5.226l-1.348.657A2.41 2.41 0 0 0 4.909 2.5m-.19 2.22a.75.75 0 0 1 .786-.175l9 3.25a.75.75 0 0 1 .02 1.403l-3.822 1.505-1.505 3.822a.75.75 0 0 1-1.403-.02l-3.25-9a.75.75 0 0 1 .175-.785M6.5 6.498l2.032 5.629.896-2.277a.75.75 0 0 1 .423-.423l2.276-.896z" clip-rule="evenodd"/>`
    }, props));
$9c2463c982d0f116$var$PresenterModeIcon.displayName = 'PresenterModeIcon';
var $9c2463c982d0f116$var$_default = module.exports.default = $9c2463c982d0f116$var$PresenterModeIcon;

});


parcelRegister("cVoxq", function(module, exports) {

$parcel$export(module.exports, "default", () => $91468585851f89bb$export$2e2bcd8739ae039);
const $91468585851f89bb$var$messages = {
    manageAutomationsItem: {
        id: 'automation-platform.footer.manage-automations-item',
        defaultMessage: 'Manage automations',
        description: 'Label for the manage automations item which is a link to project automation'
    },
    createAutomationItem: {
        id: 'automation-platform.footer.create-automation-item',
        defaultMessage: 'Create automation',
        description: 'Label for the create automation item which is a link to rule creation in project automation'
    },
    auditLogItem: {
        id: 'automation-platform.footer.audit-log-item',
        defaultMessage: 'Audit log',
        description: 'Label for the audit log item which is a link to audit log in project automation'
    }
};
var $91468585851f89bb$export$2e2bcd8739ae039 = $91468585851f89bb$var$messages;

});



parcelRegister("dpyBt", function(module, exports) {

$parcel$export(module.exports, "NoIssueSelectedEmptyState", () => $db7c56a98a7ee662$export$5acac91646e0441f);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cgL5K = parcelRequire("cgL5K");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");

var $496Xl = parcelRequire("496Xl");

var $3BRG9 = parcelRequire("3BRG9");
const $db7c56a98a7ee662$var$isMacOS = (platform)=>/Mac/i.test(platform);
const $db7c56a98a7ee662$var$getSelectKey = ()=>{
    if ((0, $4R6GH.fg)('jfp-magma-undefined-navigator') ? $db7c56a98a7ee662$var$isMacOS(globalThis.navigator?.platform || '') : $db7c56a98a7ee662$var$isMacOS(typeof window !== 'undefined' && window && window.navigator && // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
    window.navigator.platform || // eslint-disable-line jira/jira-ssr/no-unchecked-globals-usage
    '')) return "\u2318";
    return 'Ctrl';
};
const $db7c56a98a7ee662$export$5acac91646e0441f = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db7c56a98a7ee662$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db7c56a98a7ee662$var$EmptyState, null, (0, $496Xl.emptyState)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db7c56a98a7ee662$var$Message, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $3BRG9.default).noIssuesSelectedIssueTerminologyRefreshM4 : (0, $3BRG9.default).noIssuesSelected,
        values: {
            ctrl: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, $db7c56a98a7ee662$var$getSelectKey()),
            click: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                    as: "strong"
                }, chunks)
        }
    })));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db7c56a98a7ee662$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fp59q _n3td1b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db7c56a98a7ee662$var$EmptyState = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3ipo3b _19pku2gc _2hwxu2gc _otyru2gc _18u0u2gc _1e0c1txw _2lx21bp4 _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $db7c56a98a7ee662$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _y3gn1h6o _o5721g80",
            __cmplp.className
        ])
    });
});

});
parcelRegister("496Xl", function(module, exports) {

$parcel$export(module.exports, "emptyState", () => $f9ed1860665726da$export$252465da46a2ae40);

var $5uXOq = parcelRequire("5uXOq");
const $f9ed1860665726da$export$252465da46a2ae40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
    width: "310",
    height: "216",
    viewBox: "0 0 310 216",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M146.796 0.793168C184.309 4.00611 210.67 26.1894 238.211 45.7988C267.21 66.447 301.878 85.3411 307.51 115.226C313.793 148.564 306.332 189.973 268.75 207.848C232.392 225.141 189.627 193.51 146.796 191.668C109.02 190.042 69.0787 214.216 37.9175 197.917C5.07549 180.738 1.68294 145.502 0.653 115.226C-0.411134 83.9451 3.45664 50.6107 32.1423 28.1492C61.1366 5.44611 105.414 -2.75118 146.796 0.793168Z",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
    filter: "url(#filter0_dd_1925_24982)"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "21",
    y: "15.3633",
    width: "268",
    height: "180",
    rx: "8",
    fill: "var(--ds-surface, #FFFFFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "249",
    y: "31.3633",
    width: "20",
    height: "20",
    rx: "4",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M260.334 36.6966L257.667 46.03",
    stroke: "var(--ds-link-pressed, #0055CC)",
    strokeWidth: "1.5",
    strokeLinecap: "round"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M260.334 36.6966L255.667 41.3633H262.334L257.667 46.03",
    stroke: "var(--ds-link-pressed, #0055CC)",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "37",
    y: "59.3633",
    width: "72",
    height: "84",
    rx: "4",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "41",
    y: "63.3633",
    width: "22",
    height: "4",
    rx: "2",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "42",
    y: "72.3633",
    width: "62",
    height: "30",
    rx: "3",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    stroke: "var(--ds-background-accent-blue-subtle, #579DFF)",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "47",
    y: "77.3633",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "47",
    y: "85.3633",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "89",
    y: "87.3633",
    width: "12",
    height: "12",
    rx: "6",
    fill: "url(#pattern0)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "41",
    y: "107.363",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, #FFFFFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "47",
    y: "113.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "47",
    y: "121.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "117",
    y: "59.3633",
    width: "72",
    height: "120",
    rx: "4",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "121",
    y: "63.3633",
    width: "22",
    height: "4",
    rx: "2",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "121",
    y: "71.3633",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, #FFFFFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "77.3633",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "85.3633",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "122",
    y: "108.363",
    width: "62",
    height: "30",
    rx: "3",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    stroke: "var(--ds-background-accent-blue-subtle, #579DFF)",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "113.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "121.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "169",
    y: "123.363",
    width: "12",
    height: "12",
    rx: "6",
    fill: "url(#pattern1)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "121",
    y: "143.363",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, #FFFFFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "149.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "127",
    y: "157.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "197",
    y: "59.3633",
    width: "72",
    height: "120",
    rx: "4",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "201",
    y: "63.3633",
    width: "22",
    height: "4",
    rx: "2",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "201",
    y: "71.3633",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, #FFFFFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "77.3633",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "85.3633",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "202",
    y: "108.363",
    width: "62",
    height: "30",
    rx: "3",
    fill: "var(--ds-background-accent-blue-subtlest, #E9F2FF)",
    stroke: "var(--ds-background-accent-blue-subtle, #579DFF)",
    strokeWidth: "2"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "113.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "121.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-blue-subtle, #579DFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "249",
    y: "123.363",
    width: "12",
    height: "12",
    rx: "6",
    fill: "url(#pattern2)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "201",
    y: "143.363",
    width: "64",
    height: "32",
    rx: "4",
    fill: "var(--ds-surface, #FFFFFF)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "149.363",
    width: "52",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    x: "207",
    y: "157.363",
    width: "24",
    height: "2",
    rx: "1",
    fill: "var(--ds-background-accent-gray-subtlest, #F1F2F4)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("filter", {
    id: "filter0_dd_1925_24982",
    x: "9",
    y: "11.3633",
    width: "292",
    height: "204",
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feFlood", {
    floodOpacity: "0",
    result: "BackgroundImageFix"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feOffset", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feGaussianBlur", {
    stdDeviation: "0.5"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.31 0"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1925_24982"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feOffset", {
    dy: "8"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feGaussianBlur", {
    stdDeviation: "6"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0352941 0 0 0 0 0.117647 0 0 0 0 0.258824 0 0 0 0.15 0"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_1925_24982",
    result: "effect2_dropShadow_1925_24982"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_1925_24982",
    result: "shape"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
    xlinkHref: "#image0_1925_24982",
    transform: "scale(0.0025)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("pattern", {
    id: "pattern1",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
    xlinkHref: "#image1_1925_24982",
    transform: "scale(0.0025)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("pattern", {
    id: "pattern2",
    patternContentUnits: "objectBoundingBox",
    width: "1",
    height: "1"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("use", {
    xlinkHref: "#image2_1925_24982",
    transform: "scale(0.0025)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
    id: "image0_1925_24982",
    width: "400",
    height: "400",
    xlinkHref: "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQAASABIAAD/4QBYRXhpZgAATU0AKgAAAAgAAgESAAMAAAABAAEAAIdpAAQAAAABAAAAJgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAABkKADAAQAAAABAAABkAAAAAD/7QA4UGhvdG9zaG9wIDMuMAA4QklNBAQAAAAAAAA4QklNBCUAAAAAABDUHYzZjwCyBOmACZjs+EJ+/8AAEQgBkAGQAwERAAIRAQMRAf/EAB8AAAEFAQEBAQEBAAAAAAAAAAABAgMEBQYHCAkKC//EALUQAAIBAwMCBAMFBQQEAAABfQECAwAEEQUSITFBBhNRYQcicRQygZGhCCNCscEVUtHwJDNicoIJChYXGBkaJSYnKCkqNDU2Nzg5OkNERUZHSElKU1RVVldYWVpjZGVmZ2hpanN0dXZ3eHl6g4SFhoeIiYqSk5SVlpeYmZqio6Slpqeoqaqys7S1tre4ubrCw8TFxsfIycrS09TV1tfY2drh4uPk5ebn6Onq8fLz9PX29/j5+v/EAB8BAAMBAQEBAQEBAQEAAAAAAAABAgMEBQYHCAkKC//EALURAAIBAgQEAwQHBQQEAAECdwABAgMRBAUhMQYSQVEHYXETIjKBCBRCkaGxwQkjM1LwFWJy0QoWJDThJfEXGBkaJicoKSo1Njc4OTpDREVGR0hJSlNUVVZXWFlaY2RlZmdoaWpzdHV2d3h5eoKDhIWGh4iJipKTlJWWl5iZmqKjpKWmp6ipqrKztLW2t7i5usLDxMXGx8jJytLT1NXW19jZ2uLj5OXm5+jp6vLz9PX29/j5+v/bAEMAAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/bAEMBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAQEBAf/dAAQAMv/aAAwDAQACEQMRAD8A+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/Q+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/R+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/S+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/T+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/U+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/V+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAP/W+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDmNV8aeFNFZk1LXtNt5Vzut1nW5uVx/etrXzrhfbdCMngZwazlWpQ0lUin1V7teqV3+EfnZickuv6/8McJffHDwZasVtk1fUv7r21nHDEcepvbi1mAP/XEn1HBrCWMorbnl6R0/8mqRa+5/LRE+0j2f3/8A2j/rtexzU/7QFmrH7L4YuZl7GfVIrZvxWOxugP8Avr8qzeOXSk/nK34Jv8/uF7Tsvx/+5/18iif2gZ93y+FYgvodYct/31/Zqj/x38urT9ef/Ppf+Bi9o+y+/wD+59ieL9oFSwE3hVlXu0Wsh2H0R9MQHj/poPxyTT+vd6X/AJOP2j7fj/8AczctPjz4alIW80rWbTP8US2l1Gp7lj9pgkwP9mJmPoOatY2m94TXpZ/+5Iv52+S+0/aLs/v/APuZ2enfFDwLqbKkWvW1tI2Pk1FJ9PCk9jNdxRWxP+7cMPpkbto4mjL7ai/714/jt+MfzHzx7/1/Xr38o9zBcW91Es1tPDcwvyk0EiSxOPVZIyyt+BP61smmrpprundfgV/X9f1+ZNTAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD/1/iev9mACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAztU1bTNFtHvtVvrewtU4M1zIEDMRkRxrnfLKwB2xRLJI+PlQ4w0ynGCvKSiu7/Tu/QG0jwrxL8draEvb+FtP+1sCV/tLU1eK3PbdBZRyR3EgIOVe4kt2UjDQOD8vFUxq2pRv/ektPkvaX+96dpX93N1Oy+9//czxHW/HHirxCzDU9ZvHhbI+yQP9ksgvYG1thDFJgcBpfMkIzucksW451qtT45trtsvuTt99/Vfahyb3b/L8NP677nJ1kIKACgAoAKACgAoA0dO1fVNHm+0aVqN7p83GXs7mWAuB2kEbqJFPQo4ZSOCDkiqjKUXeMnF907f5X/rfYD1zQPjh4j08pFrlvb65bjAMoCWN+oGBkSQR/ZZMDna9sHc/enG411U8ZUj8aU16csvvUrffH7ty1N9dvXX/ANIf5/dc968M/EXwt4q2Q2N99mv3wP7M1ALa3hY/ww5d4bo9eLaaVwoy6Jmu2niKVXSLtL+WWj+Wsk/lK/e90o2pRf8AwX+tlf7tPO53NblBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAH//0Piev9mACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgDxnxx8X9M0Az6boQi1bWELRyTZLabYSDhhLIjKbudDwYIGEaNkSzo6NE/HWxUYXjTtOfV/Zj/5Mrv00XW1miJTS0W/5fg7/AHrt1Pl3W9f1jxFdm+1m/nvpzkJ5jARQKTkx28CbYYI887Io0Unk5Ykt505zqO85OT8+notl6K3ztczbb1f9f1/W5j1AjobDwvrN/tZLU28R/wCWt2TAuD0IUgzMCO6Quv8AtDNXGnOWy07vT/N/cvvD+v63/L7zrrTwFbLhr69lmPdLdFhX6F381mH0WM/Tg1qqH80vuVvxaf5fcH9f1/X5HQ2/hfQrfBXT45GHe4aSfP1WV3j/ACjA+nWtFSgul/N/0l+H3AasdhYQ8Q2VpEP+mdtDH/6Cg9PX8sCqUIraMV6Jfp/X4gWBHGBgRoB6BVx+XH+fXGadl2X3AMe2tpBiS3hcejxIwP8A30pH6fieKOWL6J/Jfr/X4AZ02g6NcAiTTLPnqY4UgY/V4fLb8cnHoal04PeK+Wn5AYl14H0ebJt2ubNuwjk86PPuk++Q/hMvvnGah0YvZtfj+av87/LqBy194H1ODc1pJDeoOig+ROf+ASMYuB6TZPQA1m6MltaX5/kl+Lv5AcjcWtzaSGK6glt5B/BKjI2PUbgNynswyD2PNYtW0ej8wIQSCCCQQcgjqD6jpyPr+VAHrXhH4veIPD3lWmps+u6UuF8u5lP2+3Tp/o1629nVB92C6EqYAjjeBTuXqpYqpTspe/Hz+Jej5tbdmvLTTltTa31Xr/8Aay/rvf3fqLw34r0PxXZ/a9HvFmKhftFrJiO9tGb+C5tySy85CyoWgkKnypZQN1elTqwqq8H6pqzXquaX4O3mzRST2+7r+S/Ly1sdHWgwoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA//R+J6/2YAKACgAoAKACgAoAKACgAoAKACgAoAKACgCOWWKCKSaaRIYYUeWWWV1jjijjUs8kjsQqIigszMQqqCSQATQ2krt2S3b0QHyz8Rvi1caq0+ieGJpLbSvmiutSTdHc6iOVeO3PD29kehb5Z7leG8qEtHL5mIxTleFN2hs5dZel3ovRXfV62MpTb20X5/+Sq33v13PCa4iDf0fw5qGsEPGvkWgOHu5QdnB5ESfK0zjGMIQgIw8iHhrhTlPbRd3t+t/6TtdMD1LSvDemaSFeOLz7kYJupwryBu5iXG2EZ6bBvwcM7Y3V0xpxjru+7/Ta39XvuH9f1/wF99zfrQAoAKACgAoAKACgAoAKAK9za215GYbqCK4jP8ABKgcD3XIyrejKVYdQcgFU4qStJJrz/Ts/TUDg9V8DRtul0mXY3J+yTsSh9opydy9gFl3gk5MqgYXCVHrB/8Abr/Ru9/m/m/tB53dWlzZTNBdwyQTL1SRdpI5AZT910P8LoWRsZDHq2DTWj3An03U9Q0e8h1DTLuayvIG3RzwPtYeqMPuyRPjbJFIHikX5ZEZflZxlKLUotxa2a/pX81999gu1t/l/X9dz6u+H/xYsfEph0nWvK07XWAjicHZZam+OPILE/Z7p8c2rsVkbH2Z2ZxCnp0MVGpaM/dnsv5Zdre9pJ9rLpa9+WOsZ30ej9dP/SY/n5aX972OussKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA//0viev9mACgAoAKACgAoAKACgAoAKACgAoAKACgBGZVUsxCqoLMzEBVUDJJJwAAMkknAHJxQB8lfFH4lSeIJ5tB0SYpoUEmy5uIyQdXmjbrkf8uEbgGGP/l4dRcSEqIlTy8TiPaPkg/cT1a+2/vXurouXXd205cpSvp0/P8F+bvvpY8VAzwOSeAB3rjIPRfD3g7eI73V0IU/NFYngsOzXJzlR3EA56eYcB423p0r2lLRfy9/Nvs97dtHuwPSURY1VEVURAFVEAVVUcBVVcAADgADA6cV0pW0Wi8gHUAFABQAUAFABQAUAFABQAUAFABQBQ1DTLLVITBeQrKvOx/uyxMf4opB8yH1/hbADhhxUyhGa1Xz2a9H/AMOu6d7AeS674Zu9IYzR7rmwJ+WdV+aLJwFuFXhTngSAeW5I5RjsblnTcNd1fdfr2f3/AI2if1/X9P8ANR5kEqQykggggg4II5BBGCCDyCD+WKzA+mfhh8VWu2t/Dvii5BuTth0zVpmwblvupaX8jNj7QeFgumI884jmLTlXn9HDYm9qdR67Rk+vZSd9+idk311fvaRn0fyf9L8br8Pe+hq7zQKACgAoAKACgAoAKACgAoAKACgAoAKACgD/0/iev9mACgAoAKACgAoAKACgAoAKACgAoAKACgD51+Mnj4wiXwhpE2JJEH9uXMTcpG4DLpiMDkNIpD3uOkRS2JPm3CLwYuvb91B6/ba6f3U+Za9Xo+38yM5y+yvn/Vv1f4+780gZ4HJPAA715xmeq+F/C62ix6jqMYa7bD28DjItQeRJIp63B6qCP3PUfvc+V00qdvelq3su3m/Py1tvu7RNPn+X+f42+do93W4BQAUAFABQAUAFABQAUAFABQAUAFABQAUAIyq6sjqGVgVZWAKsrDBVgcgggkEEYIODnJoA8r8TeFTZCTUNNQtaZLT24+ZrYd5I+paAH7wPzRdfmjDNFy1KVvejt21uv816vTzA4SsQPqf4S/Eb+1YovDGuXBOpwpt0u8lb5tQgjXP2WZ2JLXsCKTG5ObmFfmLTxO0vp4XEcyVOb95fDJ/aX8r7yXom/Ve9pCXR/L5dNvxv8up7zXaaBQAUAFABQAUAFABQAUAFABQAUAFABQB//9T4nr/ZgAoAKACgAoAKACgAoAKACgAoAKACgDifH/i2Lwf4fuL9SjajcE2mlQsNwe8kViJXTIzDaoDPLnCvtSEsrTIaxr1fZU3LeT0ivPXX0W7+7qKTsvPp/Vn+X3XPhqeea5mmuLiR5p7iWSaeaRi8kssrF5JJGOSzu7FmYnJJJOcmvGbbbb1bd2+7/H8/vMDv/B3h8SFdXvEyit/oMTjhnU4NywI6IwxDnOXBkyNqFtqVNP3n30Xp1D+v6/r9D0yukAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoACM8HkHgg96APJvFnhz7A7ajYx4spW/fRIOLWVjwVA6QSMcKMARP8Au8hGjSuWrT5dV8L/AAf+T/rcDjYJ5rWeG5t5XhuLeWOaCaNiskUsTB45EYYKujgMpB4IzxgVkm0007NO6a6NbMD7d+HfjOPxloa3EpRNWsSltqsC4A80qTFdxqPuwXiqzquAI5UmhG5YkdvYw9b20LvSUdJL8pej17a3XROW0ZXXmt/6svu19Tvq3KCgAoAKACgAoAKACgAoAKACgAoAKAP/1fiev9mACgAoAKACgAoAKACgAoAKACgAoAKAPij4peKj4n8T3CwSb9L0gyafp4VsxyFHxd3a44P2qdfkcH5raK2zgivHxNX2tR2d4R0j28382t7LS2iMZO78lotb/ov19dDkdA0ltX1GKAg/Z4/31047QqeUB4w8rYjXHI3F+QjCsoQ55W6dfT/N7K3r0JPco40iRI41VI41VERRhURQAqqBgAKBgADp6V2pJKy2QD6ACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAjlijnjkhlRZIpUaORG5VkYYZT14IP+GMZpNJppq6e6f9P8vvA8P1/R30a/eD5mtpcy2sh6tETjYx6eZEfkfpn5XwA4Fcc48krdOnp+F33svuuH9f1t+X3Gx4C8VS+EfEVpqG5jYzEWmqQjJEllM675Ao6y2zBbiHHJaPy8hJHDXQq+yqKX2XpL/C9+2q3Xp1vYqLs/Lr/Wv9aaXufdMciSxpLE6yRyoskciEMjo6hkdGGQyspDKQcEEEZ4r2jYfQAUAFABQAUAFABQAUAFABQAUAFAH/1viev9mACgAoAKACgAoAKACgAoAKACgAoA4L4l+IT4b8I6ldQyeXe3gGmWDA4Zbi8Vw8iHs9vapcXCHDfPEoI5FYYip7OlJ9Ze7H1fXeOyu1ruul/emTsn939b/12vc+HK8YxPaPCWljTtLSV1xc3224lPdYyP8AR4+g+7Gxcg8h5HHGML10o2in1lr/AJf5gdRWoBQAUAFABQAUAFAE9ta3N7PFa2dvPd3U7BIba2hknnmc9EihiVpJGPZUVicdP72VatRw9KdbEVaVCjTXNUrVqkKVKEf5p1JuMIrzk0iowlOSjCMpyeijGLlJ+iWr+X+R6vo37Pvx48Qqsmh/Bb4ratEwyJ7D4feK7m2weha5j0poFB7FnAPbOTt+JzDxS8NMqbjmXiFwTgpp2dLE8U5JSrXWllRnjfaya1uox089z1KOQZ7iFehk2a1V/NTy/FSj/wCBKlbXpdry397rl/ZD/agaPzR8Bviht9G8Jaokn/fp4BKOv9z8BghfCl47eDcZcj8TODW+8c8wUo/+DI1JQf3/AH3Sj1rhPiZq/wDYWZ/PC1U/u5G/66aowdT/AGaP2idGDPqXwK+LttEoy05+HfiyW2UAZO65g0qS3GACSDMCAM84Jb08H4v+FOPajhPErgWtOTtGl/rXklOs/SjUx0Kz/wDAPLS6MKvDfEFHWpkebRX839n4px/8CjSlH7383vHyXVdD1rQbj7Jrmj6po11z/o2q6fd6dcfKcN+5vIYJPlJAPycE89a+4wWY5dmdL2+W4/BZhR0/fYLFUcXS11X7yhUqQ1Wq116X3PKq0a1CXLWpVaMv5atOVOX3SjF/1015suu0yCgAoAKACgAoAKACgDA8SaSNW02WNVzdW4ae0IHzGRR80XUZEyApjON/luc7KzqQ54+a1X+XzD+v63vf+rbnh1cYH2B8GPEjaz4YbS7mTfeeH5EtBk5dtOlUvYMT38rZPaKAAFit4s5JzXq4OpzU+R7wdv8At16rq9tVstEu7NYO6t1X5f162+do+wV1lhQAUAFABQAUAFABQAUAFABQAUAf/9f4nr/ZgAoAKACgAoAKACgAoAKACgAoAKAPl34860Z9V0nQY2/d2Fq9/cAHg3N63lxI4/vQ28G9T/dujyckL5uNnecYX+FXfrLvq9bLst+tzKb1t2/r+tfuseLaJYf2lqlnaMCY3l3zf9cYgZZRnBxuVCgP95l68BuOEeaSXS+vXT8P672sQe9gAAADAHAA6Aeg6dPp+VdwBQAUAFABQBt+HfDXiHxdq9n4f8K6Fq/iTXdQk8qx0fQtOvNV1O7k7rb2NjDPcykDltkZCLlmworzs1zfKsiwGIzTOsywOUZbhIe0xOPzLF0MFg6EP5quJxNSlShd6LmldvRJt2NsPh8Ri6sKGFoVcRXqO0KNCnOrUm+0YQTk/kvusz9Mfg9/wSo+M3jSC01b4oa/o3wp0qfZKdKMY8UeMDCcOBNp1jcW+i6cZkIVftGvTXtq5Iu9KR4zC38f8e/TX4A4eqV8DwbleP42xtK8Fjuf+xshVTWL9nisTSrZhi/ZyV37LLYYetGzoY1xmpx/Sco8Ls4xkYVczxFHK6UrP2VvrWMto/epwlCjSuv5q8qkXpOkmuU/S/4a/wDBNz9lz4fw28mp+E7/AOJGsRbWbVfHmqz30DP1dU8P6Yuk+HWty3Mcd9peoTIgCNdOS7v/ACFxf9Lbxn4oqVYYPPMNwlgJ3SwXDOCpYaoo3fK5ZnjXjs1VZR0lPDY3D0pS95UY2hGP6Pl3h1wxgFF1MJUzGsrN1cdVlON+tqFL2WH5b7KdGbSsnJ2977O8M+CPBngu1Wx8HeEfDPhSzRBGtp4b0HStDthGOiCDTLW2j2j0xjPJz/D/AD9nHEXEHENZ4jP89zjO8Q5Obr5vmeNzKq5veXtMZWrT5ne1739PtfY4bBYPBx5MJhMNhYJW5cPQpUY27WpQgvwOnrxjpCgAoAz9T0nStatJLDWNM0/VrGX/AFtlqdnbX9pJwR+8trqOWF+CR8ydCRxk7urB47G5fXjisBi8VgcTD4MRg8RVw1eH+GrRnCpHVJ6SWxnUpUq0XCtTp1YPeFSEakX6xldP7vvsfMXj79iD9lr4ipO2sfCDwzpF7PuP9p+DYpvBV5HM3W5KeGpdNsbqYnLN/aFleRyOS8scrYdf2Phj6RfjPwpKmsBx5nGOw9NpfU+IJ0+IcPOmv+XPNnEcXiaFO2i+q16E4R92nKKR81juCuGMwUvbZRhqU5f8vMGng5qT+1/szpQlL/r5GafW+58BfFP/AIJD6fKlzffBj4oXNrN8z2/hz4jWiXNs7HLCMeKfD1nDPbRIfkjSXwzfSFSpluiys8v9PcF/TsxUJUcN4g8G0a9PSNXNuE68qNaKWnM8lzTEVadWcl705QznDwTvyUWmoQ+EzTwmptSnk+ZyhLeOHzCHPF+X1mhCEopbJPDTb6zVry/Lv4xfstfHb4EySv8AETwBq1hoyS+XH4q0xU1zwpPubbEf7d0s3FnZSXHWGz1RrDUGGc2aFWC/2XwF4z+GviVCEeFOKMDicwlDmnkuMcsuzunZc01/ZmMVGviI0tqmIwX1rCrS1eSaZ+ZZvwxnmRtvMMBVhRTssVS/f4WXb9/T5owcukKrp1P7mh8+1+pHgBQAUAFABQAUAeK+LdO+wavMyLtgvB9qix0DOSJk6ADEwZgoGFR0HPFcdWPLN9nqvn/wbgdX8INabSfGllA0m221mOXS51J+UySjzbM4PG/7XFDErfeCzOB94q2uFnyVkr6T91/P4fnzJLrvbreNRdpL7v6+Z9n165sFABQAUAFABQAUAFABQAUAFABQB//Q+J6/2YAKACgAoAKACgAoAKACgAoAKACgD4R+IOpHVfGniK7LblXUprOIg5Uw6diwiK+gdLcSdFyWJIyTXiV5c9apL+80vSPurv0X/DbGD3fr1NDwDahp7+9Yf6qKK3jJ9ZmMkmPdRDGPo+O5qqC95y7K33/5W/HzEenV0gFABQAUAfph+y5/wTc+IfxkhsPGPxQm1D4Y/Dy48q5s7aW0UeN/FFm+HWXS9NvI2i0LT548tBq+tQSSzK0U9jot9Zzpdr/IHjN9LfhXgGpisg4Mp4XjHiql7SjXrQrt8OZNiI+64YzF4eanmeKpS0qYHL6sIU5KpTxOPw2IpvDn6Rwx4dZhnCp4zM3Uy3L5WlCLhbG4mL2dKnPShTktY1q0XzJpwpThJTP3j+EHwJ+FXwK0FfD/AMMvCGm+HoXjjTUNTEf2vxBrUiAEz61rtzv1HUHLgyJDLMtlalmjsbW1gCRV/mjx34lca+JWZvNOMc9xeaVIzk8Lg3L2GV5dCWnssvy2jy4TCxUbRlUhB4iuo8+JrV6jc5fuWU5HleR0Pq+W4Snh00vaVbc9es11rV5c1So76pOShHanCK0PXa+EPWCgAoAKACgAoAKACgAoAhuLe3u4JrW7ghurW5ikguLa4iSaC4glQpLDNDIrRyxSIWSSN1ZHRirKQSG0pVatCpTrUalSjWozjVpVaU5U6lKpCSlCpTqRalCcJJSjOLUoySaaaTFKMZxlCcVKMk4yjJKUZRas1KLummtGmrNb3ufmn+0f/wAEz/hR8VI73xF8KRZfCXxy6yTfZLC0P/CBa1cHLhL/AEK2QtoEkjbYxfeHUjtoVMk0+h6jO26v688Jvpf8b8FTw+Vca/WOOOG4uFP22JrL/WbL6StHmwuZVppZnGCvJ4bNpTq1Xywp5nhKcXGX5xxD4b5VmiqYjK+TKsc7y5YR/wBgrS7ToRu6Denv4dKMd3RqybPwh+MnwH+KfwE8R/8ACNfE3wtd6FcTGZtK1NNt5oGvW8LANdaJrNvus76NVeJ5oA8d/ZedFHqFnZzsIl/0s4A8S+C/E3Kf7X4OzqhmVKmqaxuDlfD5nllWom1QzHL6tsRhptxnGnVtLDYj2c5YWviaS9qfh2cZHmeRYj6tmWFnQk7+yqr36FeKes6FZe5NapuN1UhzJVIQk1E8fr7w8gKACgAoA4jx1Z+dpkN4oy1nOAx9IbjEbf8AkUQVjXjeKl2f4Pv87dfvuB5fZ3Utjd2t7A22ezuYLqFh/DLbyrLG3fo6A9PzrmTaaa3TTXqgP0QtriO7tre6iOYrmCK4iPrHNGsiH8VYGveTTSa2aTXozoJ6YBQAUAFABQAUAFABQAUAFABQB//R+J6/2YAKACgAoAKACgAoAKACgAoAKAIbiZba3nuH+5BDLM2f7sSM7evZT2/Ok3ZN9k392oH50yyvPLLNId0k0jyyMf4nkYux79WJPX868Bu+vV6nOeu+CYPK0RZMc3N1PLnuQpWAfgDCcfU8DOW6qK9x+cn+n9dP1kHX1sAUAa2g6DrXijWdM8O+HNKv9b13WryDT9K0nTLaW8v9QvblwkNta20KtLLLIx4CjgZZiqK7Vw5nmeXZNl+MzbNsbhsuy3L8PUxWOx2MrQoYXC4ejHmqVq1Wo4whCKW7er0V20pa0KFbFVqeHw9KdavWnGnSpU4uU6k5OyjGKTbb9NN3ZJn9CX7G/wDwTs8OfCNNK+I3xmttO8WfE4LDfaX4dcRX/hnwJOQskTAENb694mtTgvqb+bpml3Q/4k0VxcW1vrk/+Wfj79KzNuOZY3hPw/rYvI+Duaph8bmsXUw2ccS003GaveNbLMnrJaYOPJjMZR/3+cKVarl0P33hDw+w+UqlmOcRp4rMrKdLDvlqYbAy3XeNfEx0vV1pUpfwVNxhWl+pFfxifpwUAFABQAUAFABQAUAFABQAUAFABQBw/wARPht4G+LHha/8F/EPw3pvijw5qK/vrDUYiWgnVWWK+0+7iKXmmalbB2NrqOnz297bFm8qdAzBvo+FOLuJOCM6wvEPCub4vJs2wj/d4nCzVqlNuLnhsVQnzYfGYSrypVsJiqVbD1Ulz03ZOPFmGXYLNcLUweYYanicPU+KFRX5ZdJ05JqdOpG/u1Kcozj0bvY/nj/bC/4J++LPgCL7x58P5dR8bfCQSPLdzvCs3iTwPGzfJH4jjtY44r7SBkLF4jtLaCGJ/wBzqtrp7/ZLjUv9UvAX6UWR+J7w3DPFMMJw7xy4xhQpxqOnlHEckvellUq9Sc8Nj21eeU161SpOP7zA1sUvbUsL+AcXcBYrIefHZe6mNyq7c2482IwKb0WI5bKdHosTGEUnpVhC8Jz/ADjr+sz87CgAoAytdg+06PqUOMk2kzqPV4V86P8A8fjFRUV4S9G/u1A8EriA+8fAF0bzwV4ZmJLEaRaW5J5JNon2Q5PUn9xyTyTknrXt0HejTf8AcS+7Ty7f8Pubx+FeiOvrUYUAFABQAUAFABQAUAFABQAUAf/S+J6/2YAKACgAoAKACgAoAKACgAoAKAMHxVKYfC/iSYHBi0HWJAfQpp9wwx05yPX8qzq/wqn/AF7n/wCkv0/P7hS2fo/yPz9rwzA908NR+XoWmr6weZ/39kkl/wDZ67aekI+n5u/n/XbYDcqwNvw14b17xjr+keFvC+k3uu+IdevoNN0jSNOhae8v725cJFBDGOOSS0kjlIoYleaaSOFHdfOzfN8syDLMdnWc47D5blWWYarjMfjsXUVLD4bD0Y806lSb/wDAYwipTqTcadOE6koQlvhsNXxlelhcLSnXxFecadKlTXNOc5OySX4tuyiruTSTZ/TD+xb+xT4d/Zs0CLxN4mjsfEHxj1uyC6xraqtxZ+FbW4TMvhzwxI8YKIA3l6trChLjVpVMaeTpyxW7/wCQP0hPpDZt4uZnPJ8nlicr4By7EN4DLm3Sr51WpSahm2cxjNqUm1z4HAS5qWBg1J8+KlOqf0fwbwZh+HKCxOJUK+cV4fvq1lKGFjJa4bDN7LpVrJKVV6K1NRifelfzMfdBQAUAFABQAUAFABQAUAFABQAUAFABQAUARTQw3MMtvcRRXFvcRSQzwTRpLDNDKhSWKWJwySRSIzJJG6sjoxVgQSKunUqUqkKtKc6VWlONSnUpylCpTqQkpQnCcWpQnCSUoyi1KMkmmmkxSipJxklKMk4yjJJqSas009GmtGno1oz8Hf28f+Cf0fg2HVfjP8CdFkPhSMT6h448AafG0p8MJlpbnxD4YtUQyHw4g3Saro8W86AoN5YodCWeDRf9Lvo0fShln9TBeH3iVmEf7bm6eF4c4oxc4wWcS0hRyrOK0morNpO0MFj52/tR2w+Jl/aThVzD8N454CWDVXOMjov6qr1MbgKau8MtXLEYaOr+rrerRTfsNZ0/3ClGh+O1f3ufkQUARyp5kUseMh43THruUjHb19fypPZ+jA+c64APt34UsW+H/h0nr5V+v4Lqt8o9ewH/ANbpXsYX+BT/AO3vwnI2h8K+f5/1/TPQ66CgoAKACgAoAKACgAoAKACgAoA//9P4nr/ZgAoAKACgAoAKACgAoAKACgAoA5vxkN3hHxSAMk+HNbwB3P8AZt1j9azrfwqv/Xuf/pLFLZ+h8B14Zge86B/yBdLx/wA+UHT/AHBn8c9feu2n8EfQP6/rf+u2xuQQT3U8Nrawy3NzcyxwW9vBG80888ziOKGGKMNJLLLIypHGis7uwVQWIFFWrTo06latUhSpUoTq1atWcadOlTpxcp1Kk5NRhCEU5TnJqMYpttJNjjGUpKMU5Sk1GMYpuUpN2SSV223ZJJXb0Vz+k39gn9i+1+AXhyH4i+P7GG4+MXijT13QSqky+ANFu0DnQbNvmX+3bxCv/CR6hE7CMgaNYt9khvbrVf8AI36TX0g63idm1ThThfE1KXAOTYp2qQcqb4nzGhJxWZ4iN7/2bQkn/ZOFmk5f8jDExVeeHo4L+jOBeDo5Dh1mGPhGWb4mns0msBRmr+wg+leS/wB4qL/rzBqEZyq/o9X8mH6GFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFACEBgVYBlYEMpGQQeCCDkEEcEEc+9NNppptNO6a3T7rbVev3AfgP/wAFCf2G18Az6n8c/g9o+zwNdzNd+PPCOmwHZ4OvZ5MyeIdHtYlAj8LXkz51CyiGzw7dP51ug0SfytF/08+iz9JB8T08H4b8e4/m4jowVDhnPcXU97P8PTj7mVY+vOXvZ1h6cbYXEz97NaEfZ1XLMqTnmH4Rx/wSsDKpneUUbYKcnPHYSnHTCTk9cRRgtsNNu9SC0w8neKVGVqH5EV/dZ+TDXYKjseiqzH6AEn1/l+dJ7P0YHzjXAB9y/DKEweA/DaEEbrKSbn0uLu4uAfxEoI9q9nDK1CmvJv75N+ff/htjaHwr5/n8/wCu1rHd1uUFABQAUAFABQAUAFABQAUAFAH/1Piev9mACgAoAKACgAoAKACgAoAKACgDK12EXGiaxbkgCfStQhJb7oEtpMmT04G7nnp6VM1eE13jJfemJ7P0f9dfy+8/PSvBMD3LwxIJNB01h2haP8YppIj+RTFdlL+HH5/mw/r+v6/I/bn/AIJjfslw63cwftIfEHTPN03S72aD4V6Tew5hvtVs5HgvvGssUilZINHuo5LDw+SHH9rxX2pBYptL024f+Afpi+ONTLqNXwk4XxnJi8bh6dTjXHYepaphsFiIKph+HYTg+aFTH0JQxWaWt/sFTDYRudPG4unD9h8NeFI1pR4ix9O9OlNxyulNaTqwdp4xq1mqUk6eHu/4qnU9104OX7q1/myft4UAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBWvLO01C0utPv7W3vbG+tp7O9sruGO4tbu0uYmhubW5t5VaKe3uIZHimhlVo5Y2ZHUqzBtaFevha9HFYatVw+Jw1WnXw+IoVJ0q9CvRmqlKtRqwcZ06tKpGM6dSEozhOKlFppMmcIVITp1IxnTnGUJwmlKM4STUoyi004yTaaaaa0ad2j+ZH9vD9kaf8AZx8dR+IvCltPL8I/HN7cyeG5f3k3/CL6vhrm78H31wxZikUQku/D9xcMZr3SkmgeW6u9Jv7l/wDYf6NHjpT8WeGpZTndWnT464bw9GGbQ9yn/bWAvGjQz/DUlZKVSfLRzWlSSp4bGyp1Iwo0Mdh6Uf5s454Tlw7jliMLGTynGzk8O9X9Vq6ylg5y6pK88PKVpTpKUW5ypVJR/PfVZvs+mahNnBjs7ll/3vJbYO3VsD/HpX9NTdoyfk/6+/8Ay6nwh8/VwgfoP4dsjpugaJp7DDWWk6dauMYPmQWkUchI45Lqxbjqe1e7Tjy04R/ljFfNL5dfL7jdbI2asYUAFABQAUAFABQAUAFABQAUAf/V+J6/2YAKACgAoAKACgAoAKACgAoAKAOU8dXp0/wd4kugdrrpF5DG3dZbuI2kTD3WSZSOvI5B6VlWly0aj/uNfN6L8WKXwv8Arc+Cq8QwPuP9iX4Jaj+0d8TfDHw0tWmt9JivrnWPGWowY8zSfBmmy2lxq94hKuI7i7kvLfRdMdkeMavqVj5y+SXZfzbxf8SsJ4U+HudcV1vZ1MfBLLsgwdT4cdn2Op1FgKElePNRoqlXzDGJSU3gcFivZ3qKCPoOGcjqcQ5xhsvjzRotuvjKkd6WEpOPtpJ62lJyjRpuzXtatO9ldx/sG8P6Do/hbQ9H8NeHtOttI0HQNNstH0fS7NPLtbDTdPt47WztIF5IjggiSNSxZ227nZnZmb/D7NMzx+dZlj83zXFVsdmWZ4vEY/H4yvLmrYrF4qrKtiK9SXWdSrOUna0Ve0UopI/quhQo4WhRw2HpxpUKFOFKjTgrRhTpxUYRS10UUlv5u9zXrhNQoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA81+L3wq8J/Gv4eeJfht40tPtOi+IrJoBcRqhvdJ1GI+bput6ZI6sIdR0q8WK7tnwY5CjW1yk1pPcQP8AXcCca554ecVZRxbw/X9jmGU4lVPZScvq+Ows/cxmXYyEWnUwmNw7nQrRTU4qSq0p069OlUh52bZXhM5y/E5djIc1HEQ5eZfHSqLWnWpv7NSlNKcXs7csrwk4y/j3/aR+G/ib4HeK/F3ww8XQ+Treh6wumC4jR0ttV05yL7TtbsN+GbT9X0wQXlsWHmRx3IgnEdzHKlf7j8Fca5N4g8IZLxdkVXnwGdYWFb2UpRlWwWKg3TxuX4rlso4rA4qnVw1ay5Zyp+0p81KcKk/5SzfK8Tk2Y4rLcWrVsNUceZJqFWm/epVqd9XTq03Gcb6pSs7STjH508IaYNZ8UaDprANHc6naidT3topBPdDqOTbxyheevHOa+npR56kI95JP0vr+B5y1a9fX/P8Artuffte4bhQAUAFABQAUAFABQAUAFABQAUAf/9b4nr/ZgAoAKACgAoAKACgAoAKACgAoA8y+MExi8AawoOPPl0yH04/tK0lI/EREH269a5sW7UJebiv/ACZP9PL8LSmfwv8Ar+vx/G8fiyvIMT9W/wDgjjrJ039rq508yFV8QfCjxrpax7sK8kOpeF9c+7nBYJojN0JwnoDt/kr6aODeK8HaVdK/9ncX5JjG/wCVTwua5fd9tcco/wDb1urP0bwuq+z4mcf+f+W4ukvO1TD1ref8G9tNr9Gpf1S1/k4f0UFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAfzof8FwoNHj8e/AS4t7O3i1658J+NV1a+jjC3N5pltq2hf2Fb3MgP7yKxuZ9ee1DLmM31yAxDBV/0n+gpXzCfDnH+Hq4itPK6Gc5LVwWFlK9Chja+CxyzGtSh9mpiaNDLY1ne0lh6Wiabl+G+LcaKxuTTjCKrywuKVWol786UatL2MZPqoSlXcdNOeW90fh3pt/c6VqFlqVm4S6sLqC7t2IyolgkEiB1/iQldroeHQsp4Jr+8otxakt4tNeqd/L8/LS5+RJ2d+39ef5feffPh3XLXxHoun61acRX0CyNHnLQTqTHc27nu0E6SRE8Btm5cqwNe5TmqkIzWiktuz6rrs/v30vY2Tur/ANfp+Xnpc2qsYUAFABQAUAFABQAUAFABQAUAf//X+J6/2YAKACgAoAKACgAoAKACgAoAKAPK/jMpPgPUCP4LzTWP0N5Gv82H+SK5sX/Al6x/Nf10/NSifw/P+v61/Jx+M68gyPuv/gmn4rHhH9tf4I3Ukmy21nVfEHhS5UnAlPifwlr2jWEZPPI1a60+VR/E0arxkmvwT6TuUvOPA/jqlCLlVwWEy7NqbX2VlecZfjcRL/wjo4mL7KTfRH2HAWJ+rcWZTJv3atSthpef1jDVqUF/4MlB9b2t1vH+xWv8Yj+oAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD+XX/gs74uj1v8Aah8MeGLeUPF4J+FGgWl3HnJi1fXdc8Ra5Pn036Tc6GwU8/xZIYBf9VPoT5NLA+Fea5rUhyzzzi3MKtGX8+DwGBy7A0/XlxlPHq+3TdM/nvxUxKq8Q4fDxd1hMtoxkv5atatXqy9L0pUXv92h+RNf2IfmZ9LfAPV3eDXdCkYlIHt9TtVJztEwNteAA9FDRWjADjc7k4LZb0cDLSpDtaS+ekvyj0++5pB7r5/1/S+f2foqu80CgAoAKACgAoAKACgAoAKACgD/0Piev9mACgAoAKACgAoAKACgAoAKACgDz/4pWxu/AXiKNRlo7e2uR7C0v7W5c9/+WcLg+xPTrWGJV6FTySf3ST8uif8AwdiZ/C/66/1/TPh+vGMTtfht40vfhx8RPAnxB03eb/wP4w8NeLbRUba0k/h3WLPVo4cnA2zNaCJ1b5HR2V8ozCvD4nyShxLw3n/DuJ5fq+fZLmeT1nJXUaeZYKthJT2bvBVudNLmTinGzSOvAYueBx2DxtO/PhMVQxMLdZUKsKiXRa8tnfSz1vex/d5pWp2Ot6Xpus6ZOl1purWFnqen3Uf+rubG/t47q0nT/YmgljkX2av8C8Xha+BxWJwWKpyo4nCYithcRSl8VKvh6kqVanL+9CpCUX5o/sKnUhVp06tN81OpCNSEltKE4qUWvVNMv1zlhQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAfxO/tofEtPi7+1N8b/HNvcC70698dalo2i3KtujuNA8IpD4R0G5ixwI7rSdDs7pVGOZyTli5r/cXwS4YfB/hRwLkNSm6OJoZDhsbjqTVpU8wziU84x9KfVypYvH1qTbv/AA7KySR/J/FWPWZ8RZvjIy5oTxlSlSktpUcNbDUZLylSowl89dz5hr9TPnz2f4FytH4xuox92fQbxGH+7eafKD7kFMduGP0bswT/AHr84P8ANf1/w5cN/l/X9a/jeP1zXqGoUAFABQAUAFABQAUAFABQAUAf/9H4nr/ZgAoAKACgAoAKACgAoAKACgAoAzdZsBqmj6rprDI1DTr2z9cfabaWEHtyC4IOcgjIwQKmceaEo/zRa+9Caumu/wDXl+f3H55EEEgggg4IPUH0PTkfT8q8EwEoA/sC/wCCZfxf/wCFu/sh/Ds3d19p174cC6+Fmu5ffIh8Jpbjw6X3EyEyeDb3w40kj533Hn4ZtrGv8a/pQ8G/6neMXEio0vZYDiV0uK8BaNoyWcSqvMbW91KOdUMzjGMbctP2a5Vc/pzgDM/7T4ZwPNLmrYHmy6trdr6tb2F73euFnQu76yva9j7+r+ez7QKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPnD9rr4uj4Gfs3fF34lRXItdV0XwjfWPhmXeEceLPELR+HvC7xr9+T7PrmqWN3Mkfzi1t55MoiO6/pfg9wc+PPEzg7hidJ1sJjs4oV80ja8f7Iy5SzHNVJ7R9pgMLXowlLT2tWnH3pSjCXhcTZn/ZGRZnj1LlqUsNOFB3s/rNe1DDtdXatUhJpWfLFu6tc/iPJJJJJJJySeSSepJ7kmv8Ac1K2i0S0SXQ/kwSgD2f4FxF/GN04HEOg3rk+m680+MfUneeOOMnthuvBfxn5Qf5xX6+f43jUPi9P6/r/AIc+ua9U2CgAoAKACgAoAKACgAoAKACgD//S+J6/2YAKACgAoAKACgAoAKACgAoAKACgD8/fFNmNP8S6/YqMJa6zqUMY6fuku5REcdsx7T+NeFUjy1Jx/lnJfJP5dPL7jne7XZtf1q/z+4wagD9j/wDgjZ8dP+EK+NviX4K6veeVofxe0Y3uhRyyYih8ceD7e71C3jiD4jhOr+G5NcinZWD3d3pmjWwWRxEq/wAXfTT4C/tzgbLON8HR5sfwdjvYY+UI+9PIs5qUcPUlO3vT+p5nHASpppxpUcVjqrcFz8/6j4W5x9UzavlNWdqOZ0ueim9FjMLGU0ld2XtcO6yk95Sp0o+8+VR/pxr/AC4P38KACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKAPwI/4LYfG4R2vwu/Z80m8HmXEk3xP8ZwRSfMsEP2zQPBlnPs6pNM/ibUJ7WYjDWuj3YRswuv8AoP8AQd4Gcq3FXiLjKHu0oQ4WySpOOjqVPY5hnVanzaKUIRyvD060OlXGUW178T8Z8WM2tHL8kpz+JvMMVFdEuajhYu2tm3iJuL6xpSs7Rkfz7V/oifioUAfQXwAti2peIrzHEFjY2270N1cTS4/H7Hnr2713YFe9Ul0UUvvd/wBO+nncuG7fl+f/AA3b7j6er0jUKACgAoAKACgAoAKACgAoAKAP/9P4nr/ZgAoAKACgAoAKACgAoAKACgAoAKAPhr4mwiDx34kQfxXsc343Fpb3B/Myk14uIVq1Rf3r/er/AKmEt36s4SsRHUeCfGOv/D3xh4X8d+Fr1tP8SeD9e0rxJol4uSINS0e9hvrQyIGTzYGlgWO5gZhHcW7SQSZjkdW8rPMly/iPJs1yDNqCxOWZzl+LyzHUXb38LjaE6FZRbUuSooTcqdRLmp1FCpG0oxcejCYqvgcVh8Zhp8lfC1qdejPtUpTU43Wl4tq0ovSUbp3TaP7g/gf8WdA+Ofwl8BfFnwyyjS/G3h6z1Y2okEz6XqY3Wut6JcSL8r3Wh61b3+kXTLhWuLKRkyjIa/wo464RzDgPi/iDhHNE/reR5jWwftXFwji8NpVwOOpxeqpY/BVMPjKSd2qdeClZqx/W+UZlRzfLcHmWHf7vF0I1OW93TqfDVoyenvUasZ0pd3G6ummeq18meiFABQAUAFABQAUAFABQAUAFABQAUAFABQAUAFABQBn6tqum6FpWp65rF7b6bpGjafearquo3cgitbDTdOtpbu+vbmU8R29rawyzzSHhI0Zj0NdGEwmJx+LwuBwVCpicZjcRQwmEw1GPPVxGJxNSNGhQpRWsqlWrOFOEVvKSXUirUp0adStVmqdKlCdSpOTtGFOEXKc5PooxTbfZeR/EN+0z8aNR/aD+OvxI+LV8Z1t/FPiG4bQbOcnfpnhXTUj0rwtprJkok1poVnYpeGIIk1+bq52h53Lf7peF3BGH8OuAuGeEKCg6mVZdTWYVqfw4rNsU5YvNcSnZScKuPr13R5nKUMOqVLmahE/krP8ANZ53nGPzKfMo4iu/Ywk7unhqaVPD0+140Yx57KKc+aVryZ4RX3x44UAfVnwGsvK8OatfkYa81fyVPdorK1hKn3Hm3MyjnqrdK9PAxtTlL+advlFLX7218vJmsNm/P8v+H7fee6V2lhQAUAFABQAUAFABQAUAFABQB//U+J6/2YAKACgAoAKACgAoAKACgAoAKACgD4j+LHHxA8Q/9dNP/XSLA+/+fTpXj4r+PU/7d/8ASI+n9d9zGXxP1/rt/Xfc87rnJCgD90f+CN/7T39g+Jdd/Zi8Waht0vxbJeeLPhnJcy/Ja+J7S08zxN4bhZySqa5pVoutWECmKCK+0fVAqy3msorfwX9NHws+v5ZgPFLKMM5YvKI0Mo4ojSjrVyqrW5cszOaVrywOLrPA4idp1J4fGYVycaGCfL+v+F3EHsa9bh/Ez/d4lzxOXuT0jiIxviKCvsq1OKqwSslOnU3nVSP6L6/zbP3EKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgD8hv+Cvf7SA+GfwUsfgr4d1AQ+MPjO0sOsrBLi6034caXNG2tSSBG3wjxNqAtfD8IlXyb/S18TQqS8D7f7F+hz4aPijjmvxvmWHc8m4JUJ4J1IXpYriXFQksDGPN7s3leH9rmM3F8+HxTyyb0qRUvzLxNz36hlMMpoTtis1uqvK7Sp4Gm17Vu2q+sT5aKTVp0/rC1sfy8V/qmfz4FABQB9w/C/T/7O8C6BGRh7m2k1BzjBb+0J5buIn6W8sKg91UV7OGjy0Id2nL/AMCd126Nf8Hc2irRX3/f9/8AXbVHf1uUFABQAUAFABQAUAFABQAUAFAH/9X4nr/ZgAoAKACgAoAKACgAoAKACgAoAKAPhv4nyeb488SNnOLyKP8A782drDj8PLx+HtXjYnWvU9fySXl/Xfcxl8T9fzODrAkKAN7wt4n17wV4l0Dxh4X1K40fxJ4X1jTte0LVbRgtxp+q6VdxXtjdxZDKzQ3EMb7JFaOQAxyIyM6N5+bZVgM8yvMMmzXDU8Zlma4LE5fj8JVV6eIwmLozoYilK1mlOnUkuaLUou0ouMkmbYfEVsJiKOKw9SVKvh6sK1GpH4oVKclOElutJJOzVns73P7S/wBkn9o7QP2o/gl4X+J2lfZrTWnj/sXxzoMEhc+HfGmmwwDWNPCszyCyuRNBq+jPI7yS6NqNg8xS58+JP8RvF/w1zDwq45zXhbF+1rYGMvr2Q5hUjb+0skxU6n1PENqMY+3pclTB42MEoQxuGxCp3pKE5f1Zw1ntHiHKcPmFPljVa9li6Kf8DFU0vawV23ySuqlJu7dKcG3zcyj9L1+YHvBQAUAFABQAUAFABQAUAFABQAUAFABQAUAFAGD4q8T6D4J8Na/4w8Ualb6P4c8MaPqOva5ql0223sNK0q1lvb66kxlmENvC7CNA0kjbY41Z2VW9DKcrx+eZnl+TZVhqmMzLNMZhsvwGEpK9TEYvF1Y0aFKPROdScVzStGK96TUU2Y4jEUcJh62KxFSNKhh6U61apLSMKdOLlOT32itkrvZXbR/FB+1H8fdd/aW+N3jT4saz59vaave/YPCujzOGHh7wdpZe38PaMoV3iWaK0/0zU3g2xXetXup3yopu2Ff7h+FPh9gPDDgXJOEcF7OpWwdD6xm2Npxt/aOdYpRqZljW2lNwlW/c4VVLzpYGhhcO3+5R/KHEWc1s/wA3xeZVeZQqz5MNSl/y4wtO6oUtG1dR96o1ZSrTqTt7x8+V+iniBQBLBBJczw20I3S3EscES/3pJXCIO/VmA6fnQlfTq9AP0RsbSOwsrOxh/wBVZWtvaRdv3dvEkKcc4+VB3/OvfiuWMY9IpL7lby/L7joX9f1p+X3FqmAUAFABQAUAFABQAUAFABQAUAf/1viev9mACgAoAKACgAoAKACgAoAKACgAoA+BPGVx9q8W+JZ85D67qgQ/9M0vZo4v/IaLXh1XerUf/Tyf/pRg936nNVmIKACgD74/4J8/tfXn7KfxfibXri4l+Enj+Sw0T4iaegeYaYscsiaT4zsoEy7XvhuW6na7hiSV7/Q7rU7SOCa9GnSWv8+/SJ8G6Pi1wbNZfTpw4v4ejiMdw5iHyweKcoRljMkr1JWiqGZxpU1RnOUI4fH0sLVlUjQeIjP7LgrieXDmZp1nKWW41wpY6Cu/Z2b9nioRW86Dk+ZJNzoyqRSc+Rx/r9sL+x1WxstU0y7ttQ03UrS2v9Pv7KeO5s72xvIUuLS7tLmFmiuLa5gkSaCeJmjlidJEYqwLf434jD18JXr4XFUauHxOGrVMPiMPXpypVqFejN061GtSmlOnVpVIyhUpzSlCcXGSTTR/TkJwqQhUpyjOnOMZwnBqUZwkk4yjJNpxkmmmm01qm7plusSgoAKACgAoAKACgAoAKACgAoAKACgAoAKAPwV/4LJ/tOXFhpnhv9mXwjqTRHW1h8XfE+S1lKtLplpc48LeGJWRiHt7nU7a51vVIWVWWfSdFRX2Ndxt/e/0J/Dajj8xzvxMzTDKpDJp/wBhcNe1gpQjmWIoKrm+YU+ZJxrYXAV8NgsPOLlGUMyxqtGdKEj8e8U89lSo4XIcPUs8QvreP5Xr7GE7Yai9vdqVYTqzW96NLeLaP56a/wBIT8QCgAoA7b4caf8A2n438OW5G5Y9QS+cH7u3TUk1Ahs8YY2wXB67sc52tth481amv71//Afe/Qcd16/09O2591V7RuFABQAUAFABQAUAFABQAUAFABQB/9f4nr/ZgAoAKACgAoAKACgAoAKACgAoAZLIkMUk0hwkSPI59ERSzHt0APf8qG7a9FqB+dFxM1zcT3D/AH7iaWZ+/wA0rs7c9+WNeA3dt93c5yGkAUAFABQB/Qb/AMEkv205b2K2/ZW+JeqGSWyt57j4Oa3fSAu9nBvuNQ+H9zO775DZxmTUvCpkDmOyTUtH86K3stDsq/zl+mJ4L0sFUfizw3hVChjMRSw3GeEoxtCnjKzVLBcQQgkowjjKnJgczacVLGTwWJVOpWxmOrn7b4acUyqRXDmOqOU6cZTyurLd04pyq4Jvd+ySdXD32p+1p3jClShL986/gE/YwoAKACgAoAKACgAoAKACgAoAKACgAoA8g+MnxRsfhn4Yubw3Fums3dvcnTlndBFZwwRM93rF5v8AkSz06P8AefvAUnn8uI4iE8sHVg8JWxuIo4ehSqVqtarTo0qVKDnUrVqs1ClRpwj706lWclCEYptt2V20jDE14YenKcpKKjGUnKTsoxirynJvRKKV3dr5XufxefHn4nXnxi+LXjX4gXU9xcRa3q8w0xrp3ecaPZ4s9MabzPmW4uLWFLy9H8V9c3UhLM7NX+5HhLwPT8OvD3hrhRKH1vA4GNbNakLNVc4x0pYzM5Kab9pTp4qtUw+Hm3f6rRoR0UYn8n8Q5pLOc4x2YNvkrVnGgnf3cPSXs6KtpZunFTmkrc8pPS7PIa/RjxgoAKAPavgVZef4svLtlytho1wyt/dnubi1gT6ZhNz27Y4ya7MFG9Vv+WD+9tL8r9/xvG4b+i/r+tPzUvravUNQoAKACgAoAKACgAoAKACgAoAKAP/Q+J6/2YAKACgAoAKACgAoAKACgAoAKAOY8a3v9n+EfEl2DtaPRr9I26Ymnt3ggP8A3+lT69O9Z1pctKo/7kkvVqy/FoUtn6HwNXhmAUAFABQAUAbXhzxDrHhPX9H8T+H72bTdb0DUrTVtLvoGKyW17YzJPBIOzLvQCSNspLGzRSAo7q3mZ1k+XcQ5RmWR5vhoYzLM2wWIy/HYap8NXDYqlKlVinvCajLmp1I2nSqRjUptTjGUd8Nia2DxFHFYebp18PVhVpTW8ZwlzRfVNXVnFq0k3F3TZ/YR+xh+1lo37RPw28N3+oXMNv4pls/sl5G0oJm1bT40XVNMlLfMNStG/wBIi8zZJqelzWmppHulmSL/ABD8VvDrMvDHjTOOFscp1KOEre3yzGSjyxzHKMS5TwGOhoov2lJOliY0/doY2licPduk0f1Tw3ntDPssw2NptKpOPJXp3u6WIhpVpPW6afvQurzpShPTmufb1fmx9AFABQAUAFABQAUAFABQAUAFABQBxfjvxzo/gHQ5tX1SQPMweLTNOR1W51O8C/LBCDuKxISr3VyUZLaE7iryNDFLdODqSUV83/Ku7+7RaXel1qyKlRU48z36LZt/c9uvbzbSl+AP/BQv9oXVrLwbeaRLqO/xh8UTcaWUhcqNH8HW+BqyW0WWNvbXMc0WiW0bgG4ivNTuRNJdwTSt/X/0SvDJcW8dLifH4dzyHgd0cfH2kb08XxDVcnlNFN2UngpU6maVXCTdKrhsFTqQVPExPy7xDz14HK3gqc7YvNOak7PWlg46YiXRr2icaEbr3lOq03KDPwxr/VY/AwoAKACgD6S/Z/tsJ4ovCOraVbIf90X8so/HfCenbnORXoYFfxH/AIV/6U3r9369DSn1Po6vQNAoAKACgAoAKACgAoAKACgAoAKAP//R+J6/2YAKACgAoAKACgAoAKACgAoAKAPK/jLe/ZPAl9FnDaheadZLzgnFyt6wHB6x2bgjjKk81zYuVqLX8zjH8b/kn3/G8Znt8/v/AK+X6S+M68gxCgAoAKACgAoA+xP2Nfj3N8HPiLBpWq6jLZeDvGF1ZWl9c+e8K6BrsUgXRfEcUoYfZlhmf7HqU6NEFsplvJXc6ZAlfzR9Jvwj/wCIkcGvN8ow3teLeFKWIxmXxpwvWzTLHH2mY5PonKrVlGCxeXQtOX1yk8NSUPr1aZ9twPxF/YuZLD4io45fj5Qp1m37uHr3tRxO9opN+zrS/wCfcud83soqP9Uvwg+OMHiFbbw34vuIrbXcJDp+rOUitdZ4wkVwfljt9TbgLjbBfMcR+VcFIZ/8iK9BwblBe79qOt4fe7tb32t1TWsf6Qo11K0ZtKXR7KXr5/8ApX91q0vpeuU6goAKACgAoAKACgAoAKACgDz74g/EjQPh7ppudSlFzqc8bnTNGhkUXd9IMqrt8r/ZbNH/ANfeSLsUKyRJPcFIH0p05VHZbLeXRfld9lf17xzqVY01d6vpHq/8l52flZ6S/Nr4l/EubUBrfjrxzq0Vppuk2N1f3U0jMmn6PpVmklw8FpDyyxRoDsjXzLm7nbLNPcy5f6PJcmx+dZnl+SZPhKuNzPNMZQwOBwtJXq4jFYmpGlShraMU5SXNOTVOnBSqTnCEZSj5GLxdOhRrYvFVI0qNCnOrVnL4adOC5pPu9FokuaTaSTb97+b742/FTU/jH8Rdd8a3/mw2lzN9i0DTpG3DSfD1m8i6ZYgAlBMUZ7u+aPCS6jdXky/LKFT/AGr8KfD3AeGPBGUcK4P2dTE0af1vOcbCNv7RzrFRg8fi22oydNShDDYRTXPTwWHw1KV5Qbl/Mef5xVzzNMTj6nNGE5ezw1Ju/scNTbVGnpdc1m51LaOrOpJW5rHk1fox4wUAFABQB9WfASLHhvWJ8f6zXGiz/wBcbCzfH4faP1969PAr93N/37fdFf5msNn6/wBef9adT3Su0sKACgAoAKACgAoAKACgAoAKACgD/9L4nr/ZgAoAKACgAoAKACgAoAKACgAoA8A+P15s0nw/p+f+PnUbu8x6/YbZIQfw/tAj8a4cdL3ace8nL7lb/wBuZnU6f1/W/wDVj5erzTMKACgAoAKACgAoA/bb9in42N8Sfh5/wiOu3pn8YeAIrewleeTNzqvhph5ejamWY755rMIdJv5AGYNb2N1cyNNqIr/KX6VPhVHgXjX/AFlyjC+x4Z4yqV8ZThShbD5dnsXz5ngEorkpUsU5rMsHD3ItVsXh6FONHA2j++cBZ881yz6jiKnNjctjCm3J3lWwj0oVW3rKULexqPV+5TnJuVS5+s3w0/aB1Lw+tvo3jD7RrOjIFit9TQiTVtOjHCrNvx/aVrGO0ji8iTOyW5RYrVP5Pq4dSvKnpLdr7L9NdG/nHyVz9GpYhxtGd5LpL7S9V1/8Ci/wUfs3RNf0bxJYR6noWpWup2MvSe1kD7GwCYp4ziW3nUEb4J0imTo6CuOUZRdpJp+f9a/K/q9ztjKMleLuvL+tH629Fsa9SMKACgAoAKACgCG4uILSCW5up4ba3gRpZri4kSGCGNBlpJZZGWONFHLO7KoHJP8AdAPmb4h/tFaXpiz6X4HEer6jho31qVW/sq0b7pa0jYb9SmU52yHy7EHZIrXsZMddVPDN61PdX8u7fq01ZP0v5R2OWpiUtKfvP+bovRWd387ectWfG+q6tqeuX9xqmr31xqGoXT757q6kMkjnoqjPyxxouEihjCRRIFjjRUVVXtSUUlFWS2S/p/n63ucTbbbbbb3b/p/n95+R37eHx5bVNRHwW8MXv/Et0qW3vfHNzbyfLe6sm240/wAPl0JDwaUDHfajHllbU2tYHEU+lyq3+i/0QvCBYDAvxTz/AAv+3ZjTrYXhKhWh72Fy6V6WMzpRkrxrZg1PCYKfuuOAjiKsfaUcwpyj+NeInETrVVkOEn+6ouNTMJRf8SsrSpYe6dnGjpUqLrVcIvllRkpfmvX91H5WFABQAUAFAH1x8Chjwddn+94gvT/5I6Yv/stepgv4Uv8Ar4//AEmJrDb5ntFdhYUAFABQAUAFABQAUAFABQAUAFAH/9P4nr/ZgAoAKACgAoAKACgAoAKACgAoA+Wvj7db9b0Kyz/x76VNdY9Ptd28Wfx+xfpXmY5+/CPaF/vdv/bTKe6/r+vu++54JXEQFABQAUAFABQAUAemfCH4n618IPH2ieONE3Stp8xg1TTjIY4tY0S6KLqWlznlQLiJRJbyukgtb6G0vBG72yCvg/ErgHKvEvg7NuE81SprGU/bZfjeRTqZZmuHU5YHMKS0bdGpJwrwjKLxGEq4jDOSjWmz1skzavkmZYfMKHvOlJxq0r2jXoTsqtGXbmjrGTT5KihUs3BH9CngvxjoHj/wvo3jDwxerf6LrtnHeWcwwJI92VntLqIM3kXtlOslreW7HdBcxSxNkpmv8WuKeGc44N4gzThnPsLLCZrlGKnhcTTd3CdvepYjDzaXtsLiqMoYjC10uWtQq06iUVJRj/S+Ax2GzLCUMdhKiqUMRTU4S6rpKE19mpTknCpF6xnFroeh6D4k17wvejUNA1W80q7wA8lrJhJkU5EdzAwe3uog3zeTcxyRZ5KkgbfnpRjNWklJb2f6NNNdNU/vO2MpQd4tp+X6rr87+jvY+lvC37T13CsVv4w0NbxVAVtS0RkguWA43S6dct9nlkblmaG8tIweEgAIC808KvsSt5S2+9NPTzTv5anTDFNaTjfzi7P7rSV/mk/K75fcNI+Nvw01hU2eJINPmYAtb6vDcac0RP8AC9xPELEkd/Ku5R7gYNYSoVY/Zb84u/8Awf8AyWPrszeNelL7Vv8AFdfnp/5Np53tLtIfGHhK5UPb+KfDs6sMq0Ot6bIpHqClywP+euDth05reE0/OMl/l+X3XNOeD2nH/wACi/6/rsRz+NvBtqpe58WeGoFHUy67pic+gDXILNxwoBJ6AcUezm9oT/8AAZP+v67CdSC3nH/wKP8AwL/f91zjtU+N/wAMtKDb/EsN/KBkQ6Xa3l+Xx2WeGA2YP/XS5T1GeatUKr+zbzbS/wAn/wCSffe5Dr0o/av6Jv8A4H/k7+Vjx7xF+1DGFki8KeHHZzkJfa/MqqvUZ/s2wZi+eoJ1OPGPmRskLtHCv7cvlFfjdvt0t890YyxX8sPnJ/oo/lLz8j5y8VfEDxd40lL+INZubqAPvi0+Ii202Aj7pjsYNkBdB8onlSS4I+9Mxya6YU4QXuxt57t/N6/copdtjmnUnP4pNrtsvuSS/N+erONqyD5t/aa+PNh8EPAs9xaTQTeOPEMVxYeENMfbI0dxs2XGu3cJznTtHEiSlXAW8vWtLEYSaeaD9z8BfCDGeLHF1KjiaValwnktShjOJcfHmgp0eZyo5RhqqWmNzN05U1KMk8NhY4jF6zpUqdf5XiziKnw/l8pQlGWYYlSp4Kk9bStaWJnH/n3QupWfxz5KaupTlH8Ery8utQu7q/vrma8vr65nvLy7uZHmuLq6uZXmuLmeVyzyzTzO8ssjszu7MzEkk1/sNhcNh8FhsPg8JQpYbCYShSw2Fw1CEadHD4ehTjSo0KNOKUadKlThGnThFKMYRUUkkkfznOc6k51KkpTqVJSnOcm3Kc5vmlKTerlJttt6tu73K1bkhQAUAFABQB9c/Apt3g27H9zX71T+Nlpr/wAnH+QK9TBfwpf9fH/6TE1hs/X9F/X/AAx7PXYWFABQAUAFABQAUAFABQAUAFABQB//1Piev9mACgAoAKACgAoAKACgAoAKACgD4/8AjfN5vjbZn/j20ewh+m57m4x/5Hz+P1rycY71vSMV+v6+f6Ryn8X9af1v0/WXj9cpAUAFABQAUAFABQAUAfWH7L37Suo/A/XW0jWjc6j8Odeu431mwj3S3Gi3jBIR4g0mIkgypGqJqVmgH9oWsUe3N1bW1fzp9IDwKwXixk8cyypUMDxvk+HnHK8ZO1OjmuFi5Vf7GzGpyu1OU5TngMTL/csRUnzNYeviEfZcI8VVeH8Q6OI56uV4mademvelQm/d+s0Vde8kkqsP+XkErJzhBn7haDr2jeKNH0/xB4e1K01jRdVto7vT9RsZVmtrqCTOGR15DKwaOWKQJNBMkkM0ccsbov8Ak5m+T5pkGZ43Js6wOJyzNMurzw2NwOLpulXw9aG8Zxe8ZRcZ06keanVpShVpSlTnCcv6Aw2JoYuhSxOGqwr0K0VOnVpy5oTi+qfRp6OLs4yTjJJpo1q802CgAoAKACgAoAKAPGvjV8cPB3wQ8Mya34juVutVuo5k8PeGbaZF1TXbxAMJGpEhtdPhZkN/qc0Zt7SNgqie8ltbO4/UPCvwn4n8V8+hlWR0JUMuw86Us7z6vTk8BlGFm9ZTl7qxGNqxU1g8BSkq2JnFybo4aniMRS8LPuIMDw/hHiMTJTrzUlhcJGS9tiai6JfYpRbXta0k4wWiUpyhCf4NfEz4k+KPix4v1Lxl4svPtOoXzeXbW0RdbHSdOiZzaaTpkLMxgsbRXbYpLSzTPNd3Ms93c3E7/wCv/AfAvD/h1w1geF+HML7DBYSPPXr1OWWLzLG1IxWJzHH1Yxj7bF4mUY8z0hSpRpYahTo4ahRow/nbNc1xmc42rjsbPmq1NIxjpTo0k3yUaUXflpwu7atyk5Tm5TlJnA19ieaFABQAUAFABQB9XfAWUHwxq8HePXpJT9JtPsUHH1gP1/CvTwL/AHc1/fv98V/kaw2fr/X9f5HuVdpYUAFABQAUAFABQAUAFABQAUAFAH//1fiev9mACgAoAKACgAoAKACgAoAKACgD4w+MjZ8e6oP7ttpi/wDkhbt/7N7/AK4XyMX/AB5/9u/+kx/r+kYz+J/L8jy6uYkKAD/P+f8AP8jQAuD/AJPvj+f+PpQAYP8Annvj+dABg/5x/n2+vHUUAGD/AJ/z6c/TnsaADB9/wGf8/wCT6UAGD/nH+fb68daAPf8A4H/tGePvgbqJGizjWPC13MJdV8IanNL/AGZcs21ZLqwkXfJpGplRtF7bI0cxWNb+1vY4YkT8b8WfA/g7xawSea0nlnEGGpOnl3EuApU/r9CKu4YfGQdoZlgFN831Wu4Tpc1R4PE4WdWpOX0nD/FGZcP1f9nl7fCTlzVsDVk/ZTfWdN6ujWsre0hpKyVSM4xUT9fvhJ+1F8J/i5Fa2um65H4f8TzKol8J+I5IrDUjcHhotNuHcWOtKWDGL+z7iW78kCW5srNiY1/zR8SPo/8AiN4bVMRiMflNTOcgpSk4cR5JCpjcAqK1jUx9GEfreVSSaVT67Rp4ZVX7OhisSlGcv23JeLsmzpQhSxCw2Lkkng8U1Sq83VUpNunXV78vs5ObSvKnDY+iq/ET6cKACgAoAzdX1nSNAsLjVdd1XTtF0u1Xfc6jqt7bafY26/3pru7lhgjB6DfIMngZPFd2W5XmWc4yjl+UZfjs0x+Ily0MFl2Fr43F1pdqWHw1OrVqPb4YO3XcyrV6GGpyrYitSoUoayq1qkKVOP8AinNxivm0fBXxm/by8I+G4rvRfhNbJ4x14b4T4hvYp7fwrYPjBlto2eC/1yWNgVURJZacxKSx394gMLf2F4X/AEPuJc8qYbNfEavLhjJ3y1f7EwtSlW4hxkNGoV5KNfB5RTqRabdSeKx0fepVMHhptVYfnOe+IuCwsalDJoLHYnWP1mpGSwdN9XBXhUxDXSyhS2kpyiuWX5TeMPGfinx/r974m8Yaze67rd82Zry9fdsjDN5drawIFt7Kyg3FbeytIoLaBfliiQE7v9EeGeFuH+DcnwuQcM5XhcoyrCJ+ywuFhbmnJL2mIxFWTnWxWKrNJ18ViJ1K9aSTqTdon47jsdi8xxNTF42vUxGIqP3p1Hey6QhFe7TpxvaFOCjCK0SOYwf/ANfHt/P/AD1r3zkDB/yffH8/8fSgAwf8898fzoAMH/OP8+3146igAwf8/wCfTn6c9jQAYI/z/n/PPcUAJQB9Lfs/3GbfxRak/wCrm0q4UZ6+cl/G5A9vITJz/EOua9HAvSovOD+/m6fJdfuNKfX5f1/X6H0VXeaBQAUAFABQAUAFABQAUAFABQAUAf/W+J6/2YAKACgAoAKACgAoAKACgAoAKAPjL4yx7PHmot/z1tNMk/Kyii/9pV5GLX7+Xmov8Lfp/VjGfxM8srmJCgB6EA88A+2cfy/n37YFH9f1t/Xe1gLflZ9Py9vdz25/nnGGAFEX+cDHYdv845HNAAYv8j/OevH6feNACeUT2H4n+mQfb/x3g5KgB5RHY/gv/wBme3H5HnowAvl/7J/yP8n68dqAEER7/ltP1/8Arfr3FAC+WRz0/P6/y+v58qAe1eDP2h/jZ4ChhtfDfxD1yKwgwItN1R4Ne06KMAfubez16LUYrWEr/BZi32kl02uSW/KeKfA/wp4xqVcRnnBWUTxla7qY/L4Vsmx1So9fa1sVlFbAVMTVT+1ifb3taalFKEvfwHFGf5bGMMLmeIVOOkaVZxxNJL+WNPEQqRgv8HJ5W3j73pf7fvxrswiX2k+AtYUAB5bnRtXtbh+AN2/T9et7dWJ+Y/6Ky4PCgba/Hcf9DDwqxTlLB5nxlljbbjChmmW4ihG/2eXG5LiK8kr6XxCfeT1Po6XiVn9NJVKOW1+8p0K0ZPz/AHWKpRV/8D/A1Zv+ChPxaKMIfCPw7jcjCu9l4kmCnpkoviaDdyOPmX0PJxXnU/oTeG8ZJ1eJuN6kU7uMMXkNNyXZSlw9Utfvy+lr3Nn4nZ017uByuL7uni5f+7sf67fa881/9tr9oLXI2itfEGjeG43yHGgeH9PSQqT0WfWBrN1ERwA8M0Ug+7vJLNX2uTfRN8GMpnGpiMlzTPZws4vOc6xsoKStrKjljyzD1L9YVaVSm9bxVk4+ZifEDiXEJqGKoYVPdYbC0k7dlKv7eS/7dkn0ur3Pm/xR4x8Y+Nbv7d4v8T6/4lugzNHLrOp3uoiDceVto7meSK1jA+VYrdIo0XAVCuBX7pw/wnwxwphvqnDXD+T5Fh2lGcMqy/C4J1bbSrzoU41MRNvV1K86tST1lNuzPlcXj8dj5+0xuLxGLn0detOry+UFJ2gvKMUu1tEcx5f+yf8AI/yfrx2r6A5BBEe/5bT9f/rfr3FAAYv84P19R2/w4PKgB5WfT8vb3c9uf55xhgBRF/nAx2Hb/OORzQAGL/I/znrx+n3jQAnlE9h+J/pkH2/8d4OSoBWlG07fTk8Y+nr0GO5yMdMGj+v6/r8wIqAPf/2eYr+88S6/ZWNrcXe3w3NqlylvG0rRW+nX9lHJcOiBm8qFb5nlkCkRR75JNsaO69OFrU6VRKpOMPa2pw5nZSqPWME3pzNJ8qdrv3VdtIuG/wAj6hr1zUKACgAoAKACgAoAKACgAoAKACgD/9f4nr/ZgAoAKACgAoAKACgAoAKACgAoA+SPjra+T4us7gD5bvRLVifWSG6vYWH4RrD+fQYy3l41Wqp/zQXys2v60+8ynv8AI8WrjICgAoA1bJvPHlH/AFiD5f8AaQenUEqcZ4yQc4IDbj+v6/4a3poH9f1/XqX/ALM3cfr7/Qd/1444CgAbVvp9T/8AY+nv0BHo1H9f1qv67auJ/X9aP+u+ikC1b6/Tp6/3e59/un3LUf1/Wr/rvo5H9f1ov67aqKm1f0/8d/yevH056gUX9fufp/X37Dt/V16/1924C2buv5D2x/P/AB9aLr+n8vz/AMgs/P7vn+X+Y37K3b8vx+h7/L/jyGBDhbN9D7Hn8tgHX9eOFOVH/V3b+v6Y18/kr/1/SA2r+hP1x/ge/P8AiBhhf1Z3/r+mD+fzVv6/pCfZm7j9ff6Dv+vHHAUEBtW+n1P/ANj6e/QEejUf1/Wq/rtq4n9f1o/676KQLVvr9Onr/d7n3+6fctR/X9av+u+jkf1/Wi/rtqoqbV/T/wAd/wAnrx9OeoFF/X7n6f19+w7f1dev9fduAtm7r+Q9sfz/AMfWi6/p/L8/8gs/P7vn+X+Y37K3b8vx+h7/AC/48hgQ4WzfQ+x5/LYB1/XjhTlR/wBXdv6/pjXz+Sv/AF/SA2r+hP1x/ge/P+IGGF/Vnf8Ar+mD+fzVv6/pCfZm7j9ff6Dv+vHHAUEBtW+n1P8A9j6e/QEejUf1/Wq/rtq4n9f1o/676KUcsXkRtK54UZ+p7KMgcscAc/dPOetHy/L/AD6evpfTmP6/rRf121UcBiWYsepJJ/H0/wA8UAJQB9UfsWeJR4Z/aQ+HryuEtdcn1XwzdAkDzP7b0e+tbCPnjnV/7OODndt2jBYGvKzul7XLcRbemoVV/wBuTi5f+Sc39WKi7SX3f18z9fvih+zlonij7TrPg/7P4f19t0stiF8vRNTlOS26KNWOm3Uh58+2RrZ35mtQ8r3S+RlHFOIwnLQxvNicMrRVS/NiKK8nK3tYL+SbUkvhqJJQNj4U8QeHNb8LanPo/iDTbnTNQtz88FwmA6EkLNbyqXhubeTB8u4t5ZYZMHZIcGv0TDYrD4ylGvhqsK1KW0ovZ9Yyi/ehJdYzSkuqQf1/W/5/fcxK6ACgAoAKACgAoAKACgAoAKAP/9D4nr/ZgAoAKACgAoAKACgAoAKACgDovDHhPxB4y1SLSPDmmz6jePhn8sbYLWInabi8uX2wWtup4MszoGbEce6RkR+XF4zDYGi6+KqxpU1tf4pvflpxXvTk/wCWKb66JSYf1/X9fmjh/wBtL4DzfDPwr8N/FM2onUr+/wBR1nQ9eeGPZp1rPNaWeo6RbWRdFnkwtprRmuJ9huNsRjtrYRuJfl8LnizbFV4Qo+ypUqcZUeZ3qzXO1OVRJyjHeFoRb5dbzndOOdTp8/6/E/PWvSMwoAKAHxyNE6yIdrIQyn3Hr1yD0IIwRkHIJoA9A0x4NStxLGAJEws8eACj46gAE7GILISW4BGQyMah3Wl/TS/l3Tv1639XYtWfT11t59mvLfTySuaP2D2z7dff9fu++cdzRzdG3fvt/d7Lr72/lprOL5eqWnbf+93fT3dvPXSElFgP7v4H/Db6/L16fL/tUXa813X/AO2/srm9e92pFk/J9n/+wvtPl9O1k4odP9iPoCP88foPpQpX8/8AwH/5Nf8AD9rWinG3l/4F/wDIP/hu97ycLAkfdz9R7e4Pbn+ec4ZNq+0vw7t9Jd9N/TVcxSTtuvx7JdY9tdvXR8on2Htg/gP+A9o/w/LHSml1Vvnf/F/O+v6vXVSTfR3+Vv8AD/Iun6LTRxT7B7H6E/j/ALP0+vpg0Xf/AAyv/Xdd1buKy/4d2/rs+zv2F+wf7P8AXtnuSP8APOV5ZOXm/nG3W3TX/Lde8hqPkvlK/S/XT/PZ+6wFgP7n6Y/kvrz16cjs1F30a/Ppb+a/ntr/AIm4hZdU/wAut/5beW+n+FKQn2D2z7dff9fu++cdzT5ujbv32/u9l197fy01nE5eqWnbf+93fT3dvPXSElFgP7v4H/Db6/L16fL/ALVF2vNd1/8Atv7K5vXvdqRZPyfZ/wD7C+0+X07WTih0/wBiPoCP88foPpQpX8//AAH/AOTX/D9rWinG3l/4F/8AIP8A4bve8nCwJH3c/Ue3uD25/nnOGTavtL8O7fSXfTf01XMUk7br8eyXWPbXb10fKJ9h7YP4D/gPaP8AD8sdKaXVW+d/8X876/q9dVJN9Hf5W/w/yLp+i00cU+wex+hP4/7P0+vpg0Xf/DK/9d13Vu4rL/h3b+uz7O/YX7B/s/17Z7kj/POV5ZOXm/nG3W3TX/Lde8hqPkvlK/S/XT/PZ+6wFgP7n6Y/kvrz16cjs1F30a/Ppb+a/ntr/ibiFl1T/Lrf+W3lvp/hSkJ9g9s+3X3/AF+775x3NPm6Nu/fb+72XX3t/LTWcTl6padt/wC93fT3dvPXSEuF1q7Sac28BHkwMQxHSSUcMR0BVOUQjryRlSpqlfq7/wBeet3119LEO3RW/r9OmnrfQxaYgoA6fwT4gm8J+MvCXii3LCfw34m0LXodhw3maRqlrfoATxktbgc8c4PBrKvTVWhWpPapSqU3/wBvwcfPv208xrdep/UzX5YbnJeMfA3hnx3ph0vxJp0d3GA5tbpMRX+nysMefY3agyQPkKXT5oJtgS5hnjGyu3A5hi8uq+2wtVwbtzwetOql9mpDaS3s/ijvCUXqH9f1v/Xbc+Afid8CPE3gBp9SsRL4g8LqS/8AadtEftenxnkLq1om4wqnK/boS9m+A0htXlS3r9KyjiLCZko0qjWGxj09jKXuVX3oTduZvf2cuWotkpxjzh6/1/SPCq+hAKACgAoAKACgAoAKACgD/9H4nr/ZgAoAKACgAoAKACgAoAKAPob4X/s++IfG32fV9e8/w74ZfZKkske3VdVhPI/s61lXEEEi8rqF0vllXSS2t7xC5T5nN+JcLgOajh+XFYtXTin+5pSWn72cXeUk/wDl1D3tGpSpaOR+B97eFvCPh7wZpcekeHNNg060TaZCg33F3KBg3F7dPme6uG/56TM21cRxhIlSNfzjGY3FY+s62Kqyqze19Iwj/LTgrRhHyjvu7tthY+a/24PBT+Mv2dvFz28Xm3vhC403xpaIFzhNHme31aTPVBBoGoavOWAOfL2HarM69mR1/YZjRvpGspUH/wBvq8PvqRgum/opTNXj6a/18vX9Y/z71+gmIUAFABQBf07UJ9NuUuYDnGFkjJ+SaMkFo3+uMq2MqwDDBApNX3/r8vz+4adtv6/P8vvPa9Ke11i0S8s23IflkU43wyjBaKRd2QykhvRlIddwYFsneLt083+mttFbfbvoaq0lfZ+S/XS+rutPW1jS/s4/3c/Uf/XJ689Oh7nKMm3/AMM/66aemg0l/wAOv666+uoh00/3R+Xtn/Z7/pxxQn8vRL/Nevr2bvEa+fq3/k/T07pWko05v7n5AemPQ9/fr6n52H6t+v8Aw79f87Xk16W9P+GXp/le0T+zmH8B/Ee+PQ9uP055DIA/s4/3fy+ufQf/AK/TACu7/r+u2npp1YrL+v676+uvRB/Zp7ISff8AP9Tx+PuaLv8Ar+u2npp0QWX9f1319derD+zW/uYP+T+jcfh7Ci/r9/y/LT/hgt6fd8/z1/4cT+zm9CPw/H+9nrz0/UhaL/03/XTT09Qt/SX9ddfX0F/s4/3c/Uf/AFyevPToe5yjDb/4Z/1009NASX/Dr+uuvrqIdNP90fl7Z/2e/wCnHFCfy9Ev816+vZu8Rr5+rf8Ak/T07pWko05v7n5AemPQ9/fr6n52H6t+v/Dv1/zteTXpb0/4Zen+V7RP7OYfwH8R749D24/TnkMgD+zj/d/L659B/wDr9MAK7v8Ar+u2npp1YrL+v676+uvRB/Zp7ISff8/1PH4+5ou/6/rtp6adEFl/X9d9fXXqw/s1v7mD/k/o3H4ewov6/f8AL8tP+GC3p93z/PX/AIc4Txdqyach022b/TZlHnsp5toWGduQeJphyAcFIzvwC0b1cE99Uul+v4dtPPv0Ik+mjfW3T8e+vl2ukzy6tDMKACgByqXZUUZZ2CqPUscAfmaAP6vQCAATkgAE+p9e3Xr0/Kvyc6BaAEZQwKsAysCrKwBDAjBBB4II4IPBHBoTtqtGtU10A+W/ih+zdpPiD7RrXgcW+h6y26WbSDiLRdRfkn7OqAjSrl+g8ofYHYKGgti0lxX2GUcVVsNy0Mw58RQVoxrLXEUl3ldr20V/eaqJXalO0YBr/X6f8G/6R+Gdb0PV/DmpXGka5p9zpmo2rbZrW6jKOAfuyIfuTQSAboZ4WkhmTDxSOhDV+hYfEUMVSjXw9WFalNXjODuvNPROMltKMkpRekknoH9f1/X5mVWwBQAUAFABQAUAFAH/0viev9mACgAoAKACgAoAKACgD61/Zt8M/DTWp5LvVpBqfjWykkmttE1WONbC3tozmO/023LOmqzIvzzyT7msX2sllFshvp/i+KsXmtCKhRXscBUSjPEUW3VnNrWlVkrOjF7RUbe0V06krypxW/yf3/0/yPuuvzsYUAZ+raXY65pWp6LqcC3Wm6xp97peoWz/AHLix1C2ltLuBuvyywTSRtx0bvVQlKEozi7ShJSi10lF3T+TVwP5g/iL4K1H4c+OvFfgbVQ323wxrl/pLSsu0XUFvM32K/jBwfJ1Gya3voCQMwXEZwucV+n4avHE0KVeHw1YRnbs2vej6xleL80YNWdv6/X8/vOLrcQUAFABQBuaBr154fvVurY+ZExVbq1ckQ3UQP3WxnbIoJMUoG6NmP3kaSN00nv/AF+K/P77DTaf9f5P8vuufT3h+70vxLYLf6ZIHUEJPA5Cz2s2MmKeIFtrf3XBKSpzGzoMri01v/X5/np5myae39fl+Wvkbv8AZB/ukfRePTrkduf93njAKoYh0j/Z/EqPp3c/X9TknDAB/ZGP4R+Ax/IH0/PkZ6MAH9kjrtP5Z757svf2574ztoAU6R7E+xH4/wDPTHXj9PuigAGkf7IB/wB38f757/yzzwGAD+yPUZ/D8f74HXj6ccAkKAH9kD+7+f8Ahkj2+ny8gAsAH9kH+6R9F49OuR25/wB3njAKgCHSP9n8So+ndz9f1OScMAH9kY/hH4DH8gfT8+RnowAf2SOu0/lnvnuy9/bnvjO2gBTpHsT7Efj/AM9MdeP0+6KAPPPHHiSz8L25tLcxza1cR5hgwGW0jYcXVyA5Awf9RCeZWG4gRKTVxjfXovLf8V+TJlK3r67fKz/NHzfNNLcSyTzyPLNK7SSyOdzu7klmYnqSef8A9VamJHQAUAFAHVeBdKbXfG/g7REQyPrHirw9pSRgZLtqGr2doqAcZLGYLjPOe1Y4ifs6FefSFGpP/wABg359u33gv6/rX8vvP6lq/LToCgAoA8V+Lfxk0j4b2LWdsYNT8WXUWbHSt+6OzVx8l/quxg8Nsv3obcFLi9I2xFIfMuIvfyXIq+a1FUnzUcFCX7ytbWo1vTo3XvSe0p2cae75pKMJH9X7fp+EvTc/ODXde1bxNqt3rWuXs2oalfSGSe4mbJPZI40AVIYIUAjggiVIoY1WONAgwv6lh8NQwlGGHw9ONKlTVowj+Lbd3KUnrKUnKUm7tt/Cf1/X9fkZFbgFABQAUAFABQAUAf/T+J6/2YAKACgAoAKACgAoAKALVjfXmmXltqGn3U9lfWkyT2t3ayvDcW80ZykkUqEMjqehB9QcgmoqU4VYSp1IRqU5pxnCaUoyi9007pp+n3gfefwi/aHsPEotfD3jWWDS/EB2QWmrHZBpmsvwqrN0j0/UZDj5MLZ3UmRA0EkkNm35znfDFTC8+KwClWwyvKdHWVWgt249atKK63dSC+LnSnUD+v6/D1+R9R18gAUAfj7/AMFH/hRJp/iPw18YNMtT9h8QW8XhbxPLGvyxa3psMkmiXlwQMl9R0iOawDk7EXQoEIDzIW+w4bxalTq4OT96m3VpJ9YSdppf4Z2la3229bMzmtn3/r+tPvufmDX1BmFABQAUAFAG1oPiDVPDeoR6jpdwYpUIEsTZe3uosgtBcxZAlibHqrocPE6SBXRNXVv+D/l+f3WGm1qv6/r+tj7D8CeNtA8cQrbwlLHXI491xpEzL5j7Vy81jJ8ou4Bglgv7+ADdNCqFHbJxa9P685fffy105dVJPTZ+t/u92P8AXa3velf2N/sfhxnp/jx/ve5qSg/sg9Nh/FR/u/3vw6fqdtACf2Pj+D8gfX6jvx9eOByoAp0Yn+A5/wB38fUjr/hyMlgBBo5/ufkvP8x3/wDHvTAKgC/2Mw52H8f++v75+v5jnowADRyf4CfwwOv0Pc5+hzzyGAFOjH/nn+Q+vfA78frxkBQBP7G/2Pw4z0/x4/3vc0AH9kHpsP4qP93+9+HT9TtoAT+x8fwfkD6/Ud+PrxwOVAPE/iR8SNN8LifR9FeK/wDEIzHM4CyWmkk53G4ILJNeoT8toMiJxm6wF8iWoxv6f1trH77+Wn2olK1119f/ALV6/NfqfJt1dXN7cTXd3NJc3NxI0s88rF5JJGOSzMeSegHQADAAAxWxkV6ACgAoAKAPpL9kPww3iv8AaM+F1lsLQ6ZrzeJ53xlYV8LWV1r8DvwcB73T7WBD/wA9Zo+RyV83OKvsstxUusoeyXn7WUab+6Mm+m3laVRV2vW/3fd/XfY/our85NgoA+Wvi9+0NYeHFuvDvgieDU/EHzwXerqEuNN0ZvuusB+aLUNRjORsAeztZOJ2nkSS1X7DJOGamKcMVmEZUsNpKFB3jVrro5bOnSe9/dnNfDyJxmB8HXt9eald3F/qF1Pe3t3K891dXMrzXE80hy8ksshLu7HqWPsMYr9Fp04UoRp04Rp04JRhCCUYxitkkrJJen3AVasAoAKACgAoAKACgAoA/9T4nr/ZgAoAKACgAoAKACgAoAKACgD6V+Ff7RGs+Evs2ieK/tGveHE2Qw3RbzdY0iIYVRDJKyC/s4xx9luH86JAotrhI4ktX+UzjhihjefEYPlw2Kd3KFuWhXf95Lm9nN/8/ILlb1nTk5OcQ+8dA8RaJ4o02HV9A1K11TT5x8s9tJu2PgFoZ4jiW2uEBHmW9wkU0ZOHjXIr86xOFxGDqyoYmlOjUj9ma3X80X8MovpKLlF9JPeQcl8XPhxpfxZ+HXirwBq2xIdf0ySGzu3TedN1eBlutH1NAPmJsNShtrh0UqZoUlt2OyVxTwmJlhMTSxEN6ck5L+aD0nD/ALei2vJu62E1dW/r9Pz8tLn80Xibw5rHhDxDrPhfxBZSafregald6VqdnJ96C7s5mhlCsPllicr5kE8ZMU8LRzRM0bozfpdKrCtThVpvmhUipRfdPb5910ej2MDDrQAoAKACgAoAmt7ie1niubWaW2uIJFlgngkeGaGVDuSSKWNleN1IBV0ZWBGQcj5QD6j+Hf7QxtBDpXj+CW9txtji8Q2UKNexL90f2lZrhbxVBy11a7LnC5e2vJmeSolDt/X/AJMvut819nRT7/nr/wCkv77+eux9j6DJoXifT49V8P6lZavp8uAtzZSiVUfAJimVcSW86AjzLe4SKaNjh41I21nZre/3W/r+u5omnsbR0HuE/Tn19R9Pr6ZJVAL/AGCSPufgfp9T34/xwSwADQf+mYB+n4fz5/DPpQAh0E/3Afwz2+o+n4446qAKNByPuY+v09Mn6fpzjLAB/YJH8HHsp/xHbn6emQVAE/sDP8H/AI7z/wCzev8A31xzzQBz/iO78O+ENOfVfEmp2ekWSZCyXTFZJ3XnybW3RWuLycgZEFtFLKfvBQBimlfb+v6/4PRg2lufE/xI+P17rvn6T4LiuNE0lt0c2qykJrF8mSCIPLZhpkDjnMbveOArGa13SQNooLd79raffzP8tfK5k5vpt3/qKt97t+J83Ekkkkkkkkk5JJ5JJPJJPUn+tWQJQAUAFABQAUAfp5/wTT8CteeKvH/xGuYM2+iaNaeFNMmcZRr/AFu5TUtSaA4IE1nZaVZxStlSsOqhRuEj7fl+JsRalh8MnrObrTX92C5YX8nKUn6w8i4LVv8Aq/8Aw3l91z9avEHiLRPC2mT6xr+o22madbj557h8F3IJWGCJQ01zcSYPl29vHLNJg7Imwdvy+GwuIxlWNDDUp1qstoxWy6ylJ+7CK6ym1FdWjU+Dvip+0PrHi9bnQ/CouNB8OPvhnud3l6xq8RyGWaSNmFhZyjAa0t3aWVMi4uWike1X9FyfhihgXDEYzlxGKVpRha9ChLe8U7OpUj0qSjaL1hTTSmH9f1/X6nzVX1YBQAUAFABQAUAFABQAUAFAH//V+J6/2YAKACgAoAKACgAoAKACgAoAKAOp8J+NPEngjUl1Tw3qc9hOdouIQfMs76JTnyL60fMNzFydu9fMiLGSB45Qrrx43AYTMKXscVSjUjq4y2qU3/NTmmpRfe2j2kmm1IPuT4d/tI+F/E/kab4pEXhbW32xieWQnQryU4GYbyRt2ns5yfJ1A+Sg2ot9M7BW/Pcz4VxmE5quDbxlBXfLGNsTBdnTWlW381Jcz3dOKQf1f+reXTXysfIn/BQb4BNqlpb/AB28JWQmnsba20/x/DaIJGudMQJDo/ifbGAZPsCFNM1OYGUjTzpk+2O10+8no4fx/JJ4Cs7KTcqHNpyz1dSk72tzO8oq3xKa0comc49V8/8APf8AT56WPyNr64zCgAoAKACgAoAKAN3w/wCJvEHhW+XUvDmsaho14uMzWFzJD5qqciO4iVvKuock7oLiOWFs4aM0mk9/6/r8Rptbf18up9W+DP2wNe09IbXxt4csvEEShUfVNJkXSNSIHWae0MVxpt1L1Ajt00qMjAJGPmlwX9K/486/L7y/aPqv0/8AbH+FvQ+mvDv7SfwS19Ylm8RXPh26lA/0TxDpl3a7CeSHvrOO/wBKTacAl75cg8EgELDg1/X6Xf5+ehSmn5ev+do/l932vZNM8QeBtbVX0fxh4V1NXAZf7P8AEGk3ZwexSC7ZlYE4KuFZT8hUHIWWraFHRfYLELv+1WmzG7cbmHbgd8+ZjHqdx/u99ygHOar4i8B6GpbWvGPhTSgBnGoeINIs2PU4VJ71XZj0VUVmI+UK+Ms0m9v6/rQLpb/n/XZnj3iX9pH4KeHA6ReIpvEV0gObXw1p018Dxgbb64+w6U2TxhNQcgDLbcqaahJ/8H/h1f8ArveMucV/wP8AOz/4Hna0vmHxp+19r+oCa18D+HrLw9bsGRNU1Ypq2rY/hmhtgsem2kmeTHPHqyZ5DEn5aUO/5W/Hnf5fcS59vxd/w5F+f3nyhrviHXPE1/JqniDVb7WL+XO65v7iSd1UkkRxByUghUn93BCEhjHEcaKNtaJW0IbvqzGoEFABQAUAFABQBLBBNczRW9tDLcXE8iRQQQRvLNNLIwWOOKJAzySOxCoiAszEAckUN21eiWrb6Afsv8EvH/h39n74HeG/CGi2i67491aOfxP4o3B4dK0vXdcSJxZ6hMNkt3eaRpkWmaVcW1izRNPYThr2FwUXw5ZBis3x1TE4pvC4OLVOkrJ4irShe0oQd1TjOTlNSqpSSkmqUkzaCsvXX7/+B6/LY8s8WeNPEvjfUW1PxJqk+oTAsIIWPl2dlGxz5NjaR7YLaPhd3loJJSu+d5ZCzt9hgsBhMvpKjhaMacdOZ71KjX2qk23KT9dI3tFKNlGjlq7ACgAoAKACgAoAKACgAoAKACgD/9b4nr/ZgAoAKACgAoAKACgAoAKACgAoAKACgD0rwj8VvFvhK1m0iO5h1vwzdwTWd/4X1+P+0tGurG6jaG6tFglzJaxXEMksckdtLHBLvb7TBOpZK8jH5JgMwftKlN0sQmnHE0GqdZSXwyk1FxnZpfxIyeloyja4f1/Xc+DviT8JLuy1vVdV8EaXcTeGLq5mu7HR1uPt2q6LBL++bTjlIpdTgtHZrayuolkvLi3jie6gjmZ3fN4XEUYxVRqs0rOrTjy81tOaVO7lBtayUZThH+foYuDXmvT/AO2l/Wutvd8Klhlt5ZIJ4pIJonaOWGVGjljdThkkjcB0dTwysAQeCBjFZJ31Wq8iSOgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKALNpZ3eoXMNnYWtze3lw/l29raQS3NzPIQSEhghV5ZXwCdqKxwCe2VTaSu2ku70X4+f9age0+GvgZr9/5Vz4juYdBtG2sbNCl7rEqEK4BiiY2liJBvic3Vyb20lAMmlyqCG3p4etU2i6cf56icfJ2p8rm2t9VTjJbTX2qUG/Jff+F4/n932vovw54S8O+E4PJ0LTYraVozHPqM2LnVrtSNri41B18xI5VCGazs1s9NeRFlFksg3r6FLCUqTUmnUqJ3U568r/uR5eWNukkuezs5y15dVFL/AIbX9fz8tTo66hhQAUAFABQAUAFABQAUAFABQAUAFAH/1/iev9mACgAoAKACgAoAKACgAoAKACgAoAKACgAoA57XvCvh/wASxeXrWl214wUJHcFTFeQqG3BYbyEx3MSbuWjSVY36OrA4rGph6NRtyglJ39+PuyvaybtpK3RTUku2rE4p9P0/r+meK658BImDS+G9aeNuNtlrCb4yS2WIv7SJXjRVOEjbT53JHzTDJK8U8FNXdOSmu0vdkl2+Fxk36wXqQ6fZ6en/ANu/y+88e1n4e+MdDLm90K9kgTzCbuxj/tC18uM4Msktp532dGHzL9qW3cr1QEELyThOn/EhKHnJe7r0U9YN+jfysyHFr+v+H26/fpexxdSIKACgAoAKACgAoAKACgAoAKACgAoAUAkgAEknAA5JJ6ADuSaAPQdH+FnjnWdjx6FcafbMUJutZxpUYjkGVnjgu9l9dwHp5tjaXIzng4Y1UIzqfwoSqdnH4dN17R2p3XZyT9bpSai30f5HsWgfAbSrYRzeJdVn1OYbS1jpY+xWCuj8rJezo97e28qcERW2jzx87ZSSCvVDA1H/ABJxgu0Pfm01/M4KMJJ7q1SOmjd7FqHf8F+vP38lfyuez6PoWi+HoGttD0uz0uGRQkv2WLE9wivvRLu8laS9vRExzEb25uWjydrjJ3dtPDUaTUowTmvty96eqs7N6Q5uqgoxd/hX2bUUv61/W3pf7zVrcYUAFABQAUAFABQAUAFABQAUAFABQAUAFAH/0Piev9mACgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA5/WPCnhvXw/9r6Lp97JIoRrmS3RL0KM4VL+Hy7yMAkkCOdOTnPasJ4ahPV00ne7cLwbb3b5HHmf+J/d9pOKfT9DzvUvgd4Pu972Muq6TIVxGkF2l1aq3994r6G4upOuNq30Yx0xkmueWBT+CrKOuvPFT06JckaT++/4k+zXf8P8A7df13tc4K9+AOrIB/ZviHTbps/ML+1u9PUD1DW39qFjnoCqj1YcGsZYKsr2cJJbWk1J/J0lFd9Z+V3Yn2b7r7v8A7f8Ay/SXJXnwb8eWsvlw6ba6imM+fZ6lZJF9Nt/LYz5/7Yc9s4xWLoV4puVKa9OWbfmlTc3+Fxckl0/r8bffp5nO3fw/8bWT+XL4X1mQ882dlLqCADqTLYfaowPckZ7Z4qOSdm3TqJLdyp1Ir75Riv8APfT7Ss+z+7+v69DMk8LeJ4cmXw7rsQHUyaRfpj67oBj/ADyetZ88f5o/ev1F/X9f1+Rmvp9/G/lyWV3G/dHtplf/AL5ZAf0H45xT5o2vzK3e6t/kA4abqLfdsL1vpazn69I/p/k0uaP80fvX9f16h+ZpweE/FVyu628M+ILhezQaNqMq/mlsR/8Ar7ZoU4N2U4t9lKLf3f1+AGnZ/DzxxeyGKLwtrET/APT/AGj6Wn4Sal9kjP4Px3x/FpyTaTVOpJPrGnOS++Kl+XrfTldn2f3f1/XqdLafBXx5cSbLiy0/TVOCJbvVbOeM59tLk1KQY7ho1PoDglrVCu0nGjNp93CDXqqjjL8OltLNyfJLt+P/AA1/v8tDsNP/AGf7t1zq3ie0tpAfuaZps+oRsOuBPd3GkuhPQk2rhTkgSADdrHB121d04xe/vycl/wBuqi4t/wDcSz8tx+zfdfd/9uvy+47zS/gn4IsWD3kWp60xXDxX9+9vbbv70SaVHp1yhPOQ95KvTAGDu3jgF9urJtP7CjBNdmpQqv5pr8UUqa7v7v8A7d/l956Npeg6Hom06Po+maZIsflefZWNvb3Tx/3JrxIxdXA/67yyHqSSSTXRDDUIbUotp3Tneo0/7rqOTj8ml9yKSS2X6/j8v6sa1bjCgAoAKACgAoAKACgAoAKACgAoAKACgAoAKACgAoA//9k="
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
    id: "image1_1925_24982",
    width: "400",
    height: "400",
    xlinkHref: "data:image/jpeg;base64,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"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("image", {
    id: "image2_1925_24982",
    width: "400",
    height: "400",
    xlinkHref: "data:image/jpeg;base64,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"
})));

});

parcelRegister("3BRG9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6dbafbd5e43a25ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6dbafbd5e43a25ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noIssuesSelected: {
        "id": "automation-platform.no-issue-selected-empty-state.no-issues-selected",
        "defaultMessage": "To automate one or more issues, select them by holding <ctrl>Ctrl</ctrl> + <click>click</click>"
    },
    noIssuesSelectedIssueTerminologyRefreshM4: {
        "id": "automation-platform.no-issue-selected-empty-state.no-issues-selected-issue-terminology-refresh-m4",
        "defaultMessage": "To automate one or more work items, select them by holding <ctrl>Ctrl</ctrl> + <click>click</click>"
    }
});

});


parcelRegister("hdfW8", function(module, exports) {

$parcel$export(module.exports, "ConditionalRecommendation", () => $b39f4565e2a87f5f$export$9cb37ac3cdac20e0);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9UCCQ = parcelRequire("9UCCQ");

var $g677E = parcelRequire("g677E");

var $1f7yD = parcelRequire("1f7yD");
const $b39f4565e2a87f5f$export$9cb37ac3cdac20e0 = ({ initialised: initialised = true, canManageAutomations: canManageAutomations, baseAutomationUrl: baseAutomationUrl, setClosed: setClosed, recommendations: recommendations, fallback: fallback = null })=>{
    if (!initialised) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1f7yD.default), null);
    if (!canManageAutomations || !recommendations || recommendations.length === 0) return fallback != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, fallback) : null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b39f4565e2a87f5f$var$RecommendationSection, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g677E.AutomationRecommendation), {
        baseAutomationUrl: baseAutomationUrl,
        templates: recommendations,
        setClosed: setClosed
    }));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b39f4565e2a87f5f$var$RecommendationSection = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1ywuglyw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("g677E", function(module, exports) {

$parcel$export(module.exports, "AutomationRecommendation", () => $bf63027f9142e78a$export$2b9d333083758335);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hjSul = parcelRequire("hjSul");

var $672zM = parcelRequire("672zM");

var $c4l9J = parcelRequire("c4l9J");


var $5gact = parcelRequire("5gact");

var $cI3SV = parcelRequire("cI3SV");

var $9bjx6 = parcelRequire("9bjx6");

var $6Jatd = parcelRequire("6Jatd");
// atlaskit button passes type="button" to the component you specify which makes it render a button, this prevents that
const $bf63027f9142e78a$var$ForceLink = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        ref: ref,
        ...props,
        type: "a"
    }));
const $bf63027f9142e78a$var$UnsafeAutomationRecommendation = ({ baseAutomationUrl: baseAutomationUrl, templates: templates, setClosed: setClosed })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const template = (0, $5uXOq.useMemo)(()=>(0, $6Jatd.findHighestPriorityTemplate)(templates), [
        templates
    ]);
    if (!template) return null;
    const handleBuildRuleClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}.buildRuleLink`, {
            templateId: template.id.value
        });
        setClosed();
    };
    const handleTemplatesClick = ()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'link'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}.templatesLink`, {
            templateId: template.id.value
        });
        setClosed();
    };
    const ruleUrl = `${baseAutomationUrl}#/rule/template?templateId=${template.id.value}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $7f26dd86084c5c4b$export$a3821bc63538b210),
        sourceType: (0, $4d5e0871c06cee03$export$d1123261ca8831d2),
        attributes: {
            templateId: template.id.value
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.250",
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        backgroundColor: 'color.background.information',
        xcss: $bf63027f9142e78a$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5gact.ExplainerSection), {
        templateId: template.id.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9bjx6.TemplateSection), {
        template: template
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "primary",
        spacing: "compact",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            size: "medium",
            glyph: (0, $672zM.AutomationGlyph),
            label: "",
            primaryColor: "var(--ds-icon-inverse, #FFFFFF)",
            secondaryColor: "none"
        }),
        component: $bf63027f9142e78a$var$ForceLink,
        href: ruleUrl,
        onClick: handleBuildRuleClick
    }, formatMessage((0, $cI3SV.default).createRule)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hjSul.Link), {
        href: `${baseAutomationUrl}#/tab/rule-library#`,
        onClick: handleTemplatesClick
    }, formatMessage((0, $cI3SV.default).viewTemplates))))));
};
const $bf63027f9142e78a$export$2b9d333083758335 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: `${(0, $c4l9J.AUTOMATION_RECOMMENDATIONS_PREFIX)}.panel`,
        packageName: (0, $c4l9J.PACKAGE_NAME),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bf63027f9142e78a$var$UnsafeAutomationRecommendation, props));
const $bf63027f9142e78a$var$styles = (0, $8CUq3.xcss)({
    whiteSpace: 'normal'
});

});
parcelRegister("672zM", function(module, exports) {

$parcel$export(module.exports, "AutomationGlyph", () => $a4448ef378c847a2$export$3b6023946faff8bc);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");
const $a4448ef378c847a2$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M14 5L7 12H17L10 19",
        stroke: "currentColor",
        strokeWidth: "2",
        strokeLinecap: "round",
        strokeLinejoin: "round"
    }));

});

const $7f26dd86084c5c4b$export$a3821bc63538b210 = 'jiraAutomationRecommendationsPanel';

parcelRegister("5gact", function(module, exports) {

$parcel$export(module.exports, "ExplainerSection", () => $144a2fa485be937f$export$41c214c36f49000d);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $cgL5K = parcelRequire("cgL5K");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $9hYQ4 = parcelRequire("9hYQ4");
const $144a2fa485be937f$export$41c214c36f49000d = ({ templateId: templateId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const heading = ((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $9hYQ4.headingMessagesMapping) : (0, $9hYQ4.headingMessagesMappingOld))[templateId];
    const description = ((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $9hYQ4.descriptionsMessagesMapping) : (0, $9hYQ4.descriptionsMessagesMappingOld))[templateId];
    if (!heading || !description) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "div"
    }, formatMessage(heading)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage(description)));
};

});
parcelRegister("9hYQ4", function(module, exports) {

$parcel$export(module.exports, "headingMessagesMapping", () => $c8b40daff1a9ad47$export$48b39c5f71867b6f);
$parcel$export(module.exports, "descriptionsMessagesMapping", () => $c8b40daff1a9ad47$export$8aee906b64e36a66);
$parcel$export(module.exports, "headingMessagesMappingOld", () => $c8b40daff1a9ad47$export$c7ef407d0b783db9);
$parcel$export(module.exports, "descriptionsMessagesMappingOld", () => $c8b40daff1a9ad47$export$543f330b1e930feb);

var $fB1iJ = parcelRequire("fB1iJ");
const $c8b40daff1a9ad47$export$48b39c5f71867b6f = {
    devops_template_10: (0, $fB1iJ.default).failedDeploymentsHeading,
    // deploymentFailsTemplate
    security_template_1: (0, $fB1iJ.default).criticalVulnerabilitiesHeadingIssueTerminologyRefreshM4,
    // criticalVulnerabilityTemplate
    devops_template_8: (0, $fB1iJ.default).successfulDeploymentsHeadingIssueTerminologyRefreshM4,
    // deploymentSuccessfulTemplate
    devops_template_6: (0, $fB1iJ.default).versionsCreatedHeading // versionCreatedTemplate
};
const $c8b40daff1a9ad47$export$8aee906b64e36a66 = {
    devops_template_10: (0, $fB1iJ.default).failedDeploymentsDescriptionIssueTerminologyRefreshM4,
    // deploymentFailsTemplate
    security_template_1: (0, $fB1iJ.default).criticalVulnerabilitiesDescriptionIssueTerminologyRefreshM4,
    // criticalVulnerabilityTemplate
    devops_template_8: (0, $fB1iJ.default).successfulDeploymentsDescriptionIssueTerminologyRefreshM4,
    // deploymentSuccessfulTemplate
    devops_template_6: (0, $fB1iJ.default).versionsCreatedDescriptionIssueTerminologyRefreshM4 // versionCreatedTemplate
};
const $c8b40daff1a9ad47$export$c7ef407d0b783db9 = {
    devops_template_10: (0, $fB1iJ.default).failedDeploymentsHeading,
    // deploymentFailsTemplate
    security_template_1: (0, $fB1iJ.default).criticalVulnerabilitiesHeading,
    // criticalVulnerabilityTemplate
    devops_template_8: (0, $fB1iJ.default).successfulDeploymentsHeading,
    // deploymentSuccessfulTemplate
    devops_template_6: (0, $fB1iJ.default).versionsCreatedHeading // versionCreatedTemplate
};
const $c8b40daff1a9ad47$export$543f330b1e930feb = {
    devops_template_10: (0, $fB1iJ.default).failedDeploymentsDescription,
    // deploymentFailsTemplate
    security_template_1: (0, $fB1iJ.default).criticalVulnerabilitiesDescription,
    // criticalVulnerabilityTemplate
    devops_template_8: (0, $fB1iJ.default).successfulDeploymentsDescription,
    // deploymentSuccessfulTemplate
    devops_template_6: (0, $fB1iJ.default).versionsCreatedDescription // versionCreatedTemplate
};

});
parcelRegister("fB1iJ", function(module, exports) {

$parcel$export(module.exports, "default", () => $96986feff0a6e1b8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $96986feff0a6e1b8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    successfulDeploymentsHeading: {
        "id": "automation-platform.automation-recommendation.explainer-section.successful-deployments-heading",
        "defaultMessage": "Move issues to done for successful deployments"
    },
    failedDeploymentsHeading: {
        "id": "automation-platform.automation-recommendation.explainer-section.failed-deployments-heading",
        "defaultMessage": "Notify your team about failed deployments"
    },
    versionsCreatedHeading: {
        "id": "automation-platform.automation-recommendation.explainer-section.versions-created-heading",
        "defaultMessage": "Create feature flags for assigned versions"
    },
    criticalVulnerabilitiesHeading: {
        "id": "automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-heading",
        "defaultMessage": "Create issues for security vulnerabilities"
    },
    successfulDeploymentsDescription: {
        "id": "automation-platform.automation-recommendation.explainer-section.successful-deployments-description",
        "defaultMessage": "We found issues with successful deployments for this project. Create a rule to automatically move issues to done."
    },
    failedDeploymentsDescription: {
        "id": "automation-platform.automation-recommendation.explainer-section.failed-deployments-description",
        "defaultMessage": "We found issues with failed deployments in this project. Create a rule to automatically notify the right people when this happens."
    },
    versionsCreatedDescription: {
        "id": "automation-platform.automation-recommendation.explainer-section.versions-created-description",
        "defaultMessage": "We found issues with assigned versions for this project. Create a rule to automatically create feature flags."
    },
    criticalVulnerabilitiesDescription: {
        "id": "automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-description",
        "defaultMessage": "We found security vulnerabilities in this project. Create a rule to automatically create issues."
    },
    successfulDeploymentsHeadingIssueTerminologyRefreshM4: {
        "id": "automation-platform.automation-recommendation.explainer-section.successful-deployments-heading-issue-terminology-refresh-m4",
        "defaultMessage": "Move work items to done for successful deployments"
    },
    criticalVulnerabilitiesHeadingIssueTerminologyRefreshM4: {
        "id": "automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-heading-issue-terminology-refresh-m4",
        "defaultMessage": "Create work items for security vulnerabilities"
    },
    successfulDeploymentsDescriptionIssueTerminologyRefreshM4: {
        "id": "automation-platform.automation-recommendation.explainer-section.successful-deployments-description-issue-terminology-refresh-m4",
        "defaultMessage": "We found work items with successful deployments for this project. Create a rule to automatically move work items to done."
    },
    failedDeploymentsDescriptionIssueTerminologyRefreshM4: {
        "id": "automation-platform.automation-recommendation.explainer-section.failed-deployments-description-issue-terminology-refresh-m4",
        "defaultMessage": "We found work items with failed deployments in this project. Create a rule to automatically notify the right people when this happens."
    },
    versionsCreatedDescriptionIssueTerminologyRefreshM4: {
        "id": "automation-platform.automation-recommendation.explainer-section.versions-created-description-issue-terminology-refresh-m4",
        "defaultMessage": "We found work items with assigned versions for this project. Create a rule to automatically create feature flags."
    },
    criticalVulnerabilitiesDescriptionIssueTerminologyRefreshM4: {
        "id": "automation-platform.automation-recommendation.explainer-section.critical-vulnerabilities-description-issue-terminology-refresh-m4",
        "defaultMessage": "We found security vulnerabilities in this project. Create a rule to automatically create work items."
    }
});

});



parcelRegister("cI3SV", function(module, exports) {

$parcel$export(module.exports, "default", () => $668d5f2abe0d22a7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $668d5f2abe0d22a7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createRule: {
        "id": "automation-platform.automation-recommendation.create-rule",
        "defaultMessage": "Create rule"
    },
    viewTemplates: {
        "id": "automation-platform.automation-recommendation.view-templates",
        "defaultMessage": "See more templates"
    }
});

});

parcelRegister("9bjx6", function(module, exports) {

$parcel$export(module.exports, "TemplateSection", () => $683cf8d86854d6bb$export$139a945789e7fc73);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $iyAO0 = parcelRequire("iyAO0");

var $hRf4g = parcelRequire("hRf4g");

var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $al3cm = parcelRequire("al3cm");
const $683cf8d86854d6bb$var$ElevatedIcon = ({ icons: icons })=>{
    const Icon = (0, $al3cm.templateIcons)[icons[0].src];
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($683cf8d86854d6bb$var$ElevatedIconWrapper, null, Icon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Icon, {
        label: icons[0].altText
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyAO0)))
    }));
};
const $683cf8d86854d6bb$export$139a945789e7fc73 = ({ template: template })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.200"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $683cf8d86854d6bb$var$iconContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($683cf8d86854d6bb$var$ElevatedIcon, {
        icons: template.trigger.icons
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($683cf8d86854d6bb$var$RightArrow, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($683cf8d86854d6bb$var$ElevatedIcon, {
        icons: template.action.icons
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, template.description));
const $683cf8d86854d6bb$var$iconContainerStyles = (0, $8CUq3.xcss)({
    flexShrink: 0
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $683cf8d86854d6bb$var$ElevatedIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko19bv _1e0c1txw _4cvr1h6o _1bah1h6o _4t3i1jfw _1bsb1jfw _bfhku67f _syazalr3 _16qszucj",
            __cmplp.className
        ])
    });
});
const $683cf8d86854d6bb$var$RightArrow = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _4t3i1jfw _1bsb1ul9 _1e0c1txw _4cvr1h6o _1bah1h6o _1kt9bjq5",
            __cmplp.className
        ])
    });
});

});
parcelRegister("iyAO0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d827f3c4ac5b3696$var$_react = $d827f3c4ac5b3696$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");
function $d827f3c4ac5b3696$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d827f3c4ac5b3696$var$PresenceActiveIcon = (props)=>/*#__PURE__*/ $d827f3c4ac5b3696$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><circle cx="12" cy="12" r="6" fill="currentcolor" fill-rule="evenodd"/></svg>`
    }, props));
$d827f3c4ac5b3696$var$PresenceActiveIcon.displayName = 'PresenceActiveIcon';
var $d827f3c4ac5b3696$var$_default = module.exports.default = $d827f3c4ac5b3696$var$PresenceActiveIcon;

});

parcelRegister("al3cm", function(module, exports) {

$parcel$export(module.exports, "templateIcons", () => $59e51829b880161b$export$59e85fdfb9a6ad0);

var $faod6 = parcelRequire("faod6");

var $hPcwl = parcelRequire("hPcwl");

var $dT90B = parcelRequire("dT90B");

var $kNp5F = parcelRequire("kNp5F");

var $5PBuP = parcelRequire("5PBuP");

var $gyKXQ = parcelRequire("gyKXQ");

var $gYis3 = parcelRequire("gYis3");
const $59e51829b880161b$export$59e85fdfb9a6ad0 = {
    LaunchDarklyIcon: $kNp5F.default,
    SecurityIcon: $5PBuP.default,
    SlackIcon: $gyKXQ.default,
    SoftwareIcon: (0, $dT90B.default),
    TransitionIcon: $gYis3.default,
    UploadIcon: (/*@__PURE__*/$parcel$interopDefault($hPcwl)),
    EditorAddIcon: (/*@__PURE__*/$parcel$interopDefault($faod6))
};

});
parcelRegister("dT90B", function(module, exports) {

$parcel$export(module.exports, "default", () => $c91f8566c4c1abe1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $c91f8566c4c1abe1$var$JiraGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        clipPath: "url(#clip0_1159_30547)"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M20.2546 3H11.0742C11.0742 5.24582 12.9315 7.07382 15.2134 7.07382H16.9115V8.66678C16.9115 10.9126 18.7688 12.7406 21.0506 12.7406V3.78343C21.0506 3.33948 20.7057 3 20.2546 3Z",
        fill: "#2684FF"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.7175 7.4917H6.53711C6.53711 9.73752 8.39442 11.5655 10.6763 11.5655H12.3744V13.1846C12.3744 15.4304 14.2317 17.2584 16.5135 17.2584V8.27513C16.5135 7.8573 16.1686 7.4917 15.7175 7.4917Z",
        fill: "url(#paint0_linear_1159_30547)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M11.1804 12.0093H2C2 14.2551 3.85731 16.0831 6.13915 16.0831H7.83726V17.6761C7.83726 19.9219 9.69457 21.7499 11.9764 21.7499V12.7927C11.9764 12.3488 11.605 12.0093 11.1804 12.0093Z",
        fill: "url(#paint1_linear_1159_30547)"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint0_linear_1159_30547",
        x1: "16.3182",
        y1: "7.51424",
        x2: "12.479",
        y2: "11.5369",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.176",
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#0C66E4"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
        id: "paint1_linear_1159_30547",
        x1: "12.0362",
        y1: "12.0393",
        x2: "7.59319",
        y2: "16.4316",
        gradientUnits: "userSpaceOnUse"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "0.176",
        stopColor: "#0052CC"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
        offset: "1",
        stopColor: "#2684FF"
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
        id: "clip0_1159_30547"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
        width: "24",
        height: "24",
        fill: "white"
    }))));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $c91f8566c4c1abe1$var$JiraIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($c91f8566c4c1abe1$var$JiraGlyph, null)
    });
var $c91f8566c4c1abe1$export$2e2bcd8739ae039 = $c91f8566c4c1abe1$var$JiraIcon;

});
parcelRegister("h77XT", function(module, exports) {

$parcel$export(module.exports, "default", () => $694f3d02d551890d$export$2e2bcd8739ae039);
$parcel$export(module.exports, "SVG", () => $694f3d02d551890d$export$13f4b12aafeba5d6);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $694f3d02d551890d$var$CustomIcon = (props)=>{
    const { glyph: Glyph, testId: testId, label: label } = props;
    const glyphProps = {
        children: Glyph ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Glyph, {
            role: "presentation"
        }) : null
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($694f3d02d551890d$export$be58b4326e23250f, {
        "data-testid": testId,
        role: label ? 'img' : 'presentation',
        "aria-label": label || undefined,
        ...glyphProps
    });
};
var $694f3d02d551890d$export$2e2bcd8739ae039 = $694f3d02d551890d$var$CustomIcon;
const $694f3d02d551890d$export$13f4b12aafeba5d6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "svg", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _c71l1osq _p12f1osq _lcxvglyw _s7n4yfq0",
            __cmplp.className
        ])
    });
});
const $694f3d02d551890d$export$be58b4326e23250f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf",
            __cmplp.className
        ])
    });
});

});


parcelRegister("kNp5F", function(module, exports) {

$parcel$export(module.exports, "default", () => $096dc7f76c3dd41e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
// Because this is a logo it should be presented on white and design tokens are not used
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $096dc7f76c3dd41e$var$LaunchDarklyGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24px",
        width: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#172B4D",
        fillRule: "nonzero",
        d: "M12.12 21.994a.448.448 0 0 1-.393-.247.422.422 0 0 1 .04-.448l4.654-6.468-8.154 3.365a.422.422 0 0 1-.175.038.44.44 0 0 1-.416-.316.427.427 0 0 1 .184-.485l7.166-4.27-12.62-.732a.435.435 0 0 1-.404-.436c0-.23.177-.42.404-.435l12.627-.732-7.17-4.27a.437.437 0 0 1 .237-.8c.06 0 .12.013.175.037l8.149 3.368-4.654-6.467a.427.427 0 0 1-.041-.45.446.446 0 0 1 .395-.246c.114 0 .223.048.302.131l9.276 9.362a.716.716 0 0 1 0 1.005l-9.28 9.365a.421.421 0 0 1-.302.131Z"
    }));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $096dc7f76c3dd41e$var$LaunchDarklyIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($096dc7f76c3dd41e$var$LaunchDarklyGlyph, null)
    });
var $096dc7f76c3dd41e$export$2e2bcd8739ae039 = $096dc7f76c3dd41e$var$LaunchDarklyIcon;

});

parcelRegister("5PBuP", function(module, exports) {

$parcel$export(module.exports, "default", () => $1889db2f995005fa$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $1889db2f995005fa$var$SecurityGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24px",
        width: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#000",
        fillRule: "nonzero",
        d: "M10.778 5.04 5.38 7.74l.556 5.007a5.555 5.555 0 0 0 2.293 3.908l2.549 1.82V5.04Zm2.222 0v13.435l2.55-1.82a5.556 5.556 0 0 0 2.292-3.908l.556-5.008L13 5.04ZM3 6.444 11.889 2l8.889 4.444-.728 6.549a7.778 7.778 0 0 1-3.21 5.47l-4.305 3.076a1.111 1.111 0 0 1-1.292 0l-4.306-3.076a7.778 7.778 0 0 1-3.21-5.47L3 6.444Z"
    }));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $1889db2f995005fa$var$SecurityIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1889db2f995005fa$var$SecurityGlyph, null)
    });
var $1889db2f995005fa$export$2e2bcd8739ae039 = $1889db2f995005fa$var$SecurityIcon;

});

parcelRegister("gyKXQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a9988a2c2f3c520$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $2a9988a2c2f3c520$var$SlackGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24px",
        width: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "none",
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#E01E5A",
        d: "M6.258 14.613c0 1.145-.935 2.081-2.08 2.081a2.086 2.086 0 0 1-2.081-2.08c0-1.146.935-2.081 2.08-2.081h2.081v2.08ZM7.306 14.613c0-1.145.936-2.08 2.081-2.08s2.08.935 2.08 2.08v5.21c0 1.145-.935 2.08-2.08 2.08a2.086 2.086 0 0 1-2.08-2.08v-5.21Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#36C5F0",
        d: "M9.387 6.258a2.086 2.086 0 0 1-2.08-2.08c0-1.146.935-2.081 2.08-2.081s2.08.935 2.08 2.08v2.081h-2.08ZM9.387 7.306c1.145 0 2.08.936 2.08 2.081s-.935 2.08-2.08 2.08h-5.21a2.086 2.086 0 0 1-2.08-2.08c0-1.145.935-2.08 2.08-2.08h5.21Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#2EB67D",
        d: "M17.742 9.387c0-1.145.936-2.08 2.08-2.08 1.146 0 2.082.935 2.082 2.08s-.936 2.08-2.081 2.08h-2.08v-2.08ZM16.693 9.387c0 1.145-.935 2.08-2.08 2.08a2.086 2.086 0 0 1-2.081-2.08v-5.21c0-1.145.935-2.08 2.08-2.08 1.146 0 2.081.935 2.081 2.08v5.21Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        fill: "#ECB22E",
        d: "M14.613 17.742c1.145 0 2.081.936 2.081 2.08 0 1.146-.936 2.082-2.08 2.082a2.086 2.086 0 0 1-2.081-2.081v-2.08h2.08ZM14.613 16.693a2.086 2.086 0 0 1-2.08-2.08c0-1.146.935-2.081 2.08-2.081h5.21c1.145 0 2.08.935 2.08 2.08 0 1.146-.935 2.081-2.08 2.081h-5.21Z"
    })));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $2a9988a2c2f3c520$var$SlackIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a9988a2c2f3c520$var$SlackGlyph, null)
    });
var $2a9988a2c2f3c520$export$2e2bcd8739ae039 = $2a9988a2c2f3c520$var$SlackIcon;

});

parcelRegister("gYis3", function(module, exports) {

$parcel$export(module.exports, "default", () => $54c60324bc0ad48a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $h77XT = parcelRequire("h77XT");
/* eslint-disable @atlaskit/design-system/ensure-design-token-usage */ const $54c60324bc0ad48a$var$TransitionGlyph = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.SVG), {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 24 24",
        height: "24px",
        width: "24px"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "#000",
        fillRule: "nonzero"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M5 2a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2ZM19 16a3 3 0 1 0 0 6 3 3 0 0 0 0-6Zm0 2a1 1 0 1 1 0 2 1 1 0 0 1 0-2Z"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10 4a3 3 0 0 1 2.995 2.824L13 7v10a1 1 0 0 0 .883.993L14 18h3v2h-3a3 3 0 0 1-2.995-2.824L11 17V7a1 1 0 0 0-.883-.993L10 6H7V4h3Z"
    })));
/* eslint-enable @atlaskit/design-system/ensure-design-token-usage */ const $54c60324bc0ad48a$var$TransitionIcon = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h77XT.default), {
        ...props,
        glyph: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($54c60324bc0ad48a$var$TransitionGlyph, null)
    });
var $54c60324bc0ad48a$export$2e2bcd8739ae039 = $54c60324bc0ad48a$var$TransitionIcon;

});



parcelRegister("6Jatd", function(module, exports) {

$parcel$export(module.exports, "findHighestPriorityTemplate", () => $55ee6ddbe8599deb$export$e6e3175570d5e4e);

var $c4l9J = parcelRequire("c4l9J");
const $55ee6ddbe8599deb$export$e6e3175570d5e4e = (templates)=>{
    const templateMap = Object.fromEntries(templates.map((template)=>[
            template.id.value,
            template
        ]));
    const templateId = (0, $c4l9J.templateRecommendationPriority).find((id)=>templateMap[id]);
    return templateId ? templateMap[templateId] : null;
};

});


parcelRegister("1f7yD", function(module, exports) {

$parcel$export(module.exports, "default", () => $b1aaacaa2160f00c$export$2e2bcd8739ae039);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $ehatR = parcelRequire("ehatR");
const $b1aaacaa2160f00c$var$SkeletonLine = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonContainer, {
        "data-testid": "automation-menu.common.ui.skeleton.container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehatR.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonIcon, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonText, null));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b1aaacaa2160f00c$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b1aaacaa2160f00c$var$SkeletonLine, null));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1aaacaa2160f00c$var$SkeletonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pku2gc _2hwxv47k _otyru2gc _18u0v47k _1e0c1txw",
            __cmplp.className
        ])
    });
});
const $b1aaacaa2160f00c$var$SkeletonIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rkoyh40 _189eyh40 _1dqonqa1 _1h6d3acm _1bsb7vkz _4t3i7vkz _1e0c1o8l _bfhk1r31 _tzy4nh7s",
            __cmplp.className
        ])
    });
});
const $b1aaacaa2160f00c$var$shimmer = null;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $b1aaacaa2160f00c$var$SkeletonText = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1bsbp3fh _4t3i7vkz _19pk1b66 _18u0utpp _5sag9cwz _1o51q7pw _tip812c5 _j7hq1nls _1pglp3kn _bfhkn82g _1itk1kpv _12vemgnk",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ehatR", function(module, exports) {

$parcel$export(module.exports, "default", () => $00d70fc458c66b77$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $00d70fc458c66b77$var$MenuIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
var $00d70fc458c66b77$export$2e2bcd8739ae039 = $00d70fc458c66b77$var$MenuIcon;

});



parcelRegister("btB4j", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd6eb028e3c61c3b$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9UCCQ = parcelRequire("9UCCQ");

var $eae50 = parcelRequire("eae50");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $isuse = parcelRequire("isuse");

var $1f7yD = parcelRequire("1f7yD");

var $kBike = parcelRequire("kBike");

var $cIflZ = parcelRequire("cIflZ");

var $kRcYM = parcelRequire("kRcYM");

var $2OBLh = parcelRequire("2OBLh");
// when this mounts. This is how we ensure lazy load behaviour of the menu.
const $dd6eb028e3c61c3b$var$FetchRulesContainer = (props)=>{
    const { triggerFetch: triggerFetch, children: children } = props;
    (0, $5uXOq.useEffect)(()=>{
        triggerFetch(); // Ignore exhaustive dep here to ensure no call to useEffect on re-render
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $dd6eb028e3c61c3b$export$1d156886dc7aaa5b = 50;
const $dd6eb028e3c61c3b$var$ManualRules = (props)=>{
    const { triggerFetch: triggerFetch, initialised: initialised, error: error, rules: rules, executeRule: executeRule, setClosed: setClosed, executingRuleId: executingRuleId, selectedIssueIds: selectedIssueIds, recommendations: recommendations } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [canManageAutomations] = (0, $kBike.useCanManageAutomations)();
    if (error) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd6eb028e3c61c3b$var$ErrorStateContainer, {
        canManageAutomations: canManageAutomations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(event, 'ruleErrorState mounted')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $cIflZ.default).errorHeader),
        description: formatMessage((0, $cIflZ.default).errorDescription),
        maxImageHeight: (0, $2OBLh.errorImageHeight)
    }));
    if (selectedIssueIds && selectedIssueIds.length > $dd6eb028e3c61c3b$export$1d156886dc7aaa5b && (0, $4R6GH.fg)('selected-issue-id-limit')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "selectedIssuesLimitExceeded",
        attributes: {
            selectedIssueCount: selectedIssueIds.length
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd6eb028e3c61c3b$var$ErrorStateContainer, {
        canManageAutomations: canManageAutomations
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eae50.default), {
        header: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $cIflZ.default).issueSelectionLimitExceededHeaderIssueTerminologyRefreshM4 : (0, $cIflZ.default).issueSelectionLimitExceededHeader),
        description: formatMessage((0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $cIflZ.default).issueSelectionLimitExceededDescriptionIssueTerminologyRefreshM4 : (0, $cIflZ.default).issueSelectionLimitExceededDescription, {
            limit: $dd6eb028e3c61c3b$export$1d156886dc7aaa5b
        }),
        maxImageHeight: (0, $2OBLh.errorImageHeight)
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dd6eb028e3c61c3b$var$FetchRulesContainer, {
        triggerFetch: triggerFetch
    }, initialised ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kRcYM.default), {
        rules: rules,
        executingRuleId: executingRuleId,
        executeRule: executeRule,
        selectedIssueIds: selectedIssueIds,
        recommendations: recommendations,
        setClosed: setClosed
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1f7yD.default), null)));
};
var $dd6eb028e3c61c3b$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
 = $dd6eb028e3c61c3b$var$ManualRules;
const $dd6eb028e3c61c3b$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _c71l1feq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $dd6eb028e3c61c3b$var$ErrorStateContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $dd6eb028e3c61c3b$var$Container, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.canManageAutomations ? "_19pk1stb _2hwx7vkz _otyr1stb _18u07vkz" : "_19pkidpf _2hwx7vkz _otyridpf _18u07vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("eae50", function(module, exports) {

$parcel$export(module.exports, "default", () => $da809c0c454ce05f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $hTEpF = parcelRequire("hTEpF");

var $az4zD = parcelRequire("az4zD");

var $97INH = parcelRequire("97INH");

var $lNvSq = parcelRequire("lNvSq");

var $63TJV = parcelRequire("63TJV");
function $da809c0c454ce05f$export$edf27be85e5f6da0(props) {
    const { header: header, description: description, size: size, onRetry: onRetry, isLoading: isLoading, intl: { formatMessage: formatMessage }, errorImage: errorImage, isSubtle: isSubtle, imageWidth: imageWidth, maxImageHeight: maxImageHeight, retryMessage: retryMessage, renderErrorImage: renderErrorImage, headingLevel: headingLevel } = props;
    const buttonAppearance = isSubtle ? 'default' : 'primary';
    const defaultImageUrl = isSubtle ? (0, (/*@__PURE__*/$parcel$interopDefault($97INH))) : (0, (/*@__PURE__*/$parcel$interopDefault($lNvSq)));
    const fallbackImage = errorImage || defaultImageUrl;
    let imageUrl;
    if (renderErrorImage) imageUrl = undefined;
    else imageUrl = fallbackImage;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        testId: "common-components-error-state.empty-state",
        width: size,
        imageWidth: imageWidth,
        imageUrl: imageUrl,
        header: header,
        description: description,
        isLoading: isLoading,
        maxImageHeight: maxImageHeight,
        primaryAction: !onRetry ? null : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: buttonAppearance,
            isDisabled: isLoading,
            onClick: onRetry
        }, formatMessage(retryMessage)),
        renderImage: renderErrorImage,
        headingLevel: headingLevel
    });
}
$da809c0c454ce05f$export$edf27be85e5f6da0.defaultProps = {
    header: '',
    size: 'wide',
    isLoading: false,
    isSubtle: false,
    retryMessage: (0, $63TJV.default).retry
};
var $da809c0c454ce05f$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($da809c0c454ce05f$export$edf27be85e5f6da0);

});
parcelRegister("97INH", function(module, exports) {
module.exports = new URL("error-subtle.580d9941.svg", import.meta.url).toString();

});

parcelRegister("lNvSq", function(module, exports) {
module.exports = new URL("error.4fa1b24b.svg", import.meta.url).toString();

});

parcelRegister("63TJV", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbeb04399739f055$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbeb04399739f055$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    retry: {
        "id": "common.components.error-state.retry-action",
        "defaultMessage": "Try again"
    }
});

});


parcelRegister("cIflZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $a4845bc7e0af88c7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a4845bc7e0af88c7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorHeader: {
        "id": "automation-menu.popup.run-rule.manual-rules.error-header",
        "defaultMessage": "We're having some trouble"
    },
    errorDescription: {
        "id": "automation-menu.popup.run-rule.manual-rules.error-description",
        "defaultMessage": "It's taking us longer than expected to show this content. It's probably a temporary problem. Try refreshing or navigating to another page."
    },
    issueSelectionLimitExceededHeader: {
        "id": "automation-menu.popup.run-rule.manual-rules.issue-selection-limit-exceeded-header",
        "defaultMessage": "Too many issues selected"
    },
    issueSelectionLimitExceededDescription: {
        "id": "automation-menu.popup.run-rule.manual-rules.issue-selection-limit-exceeded-description",
        "defaultMessage": "The maximum amount of issues you can select on a board is {limit, number}. Please deselect some issues and try again."
    },
    issueSelectionLimitExceededHeaderIssueTerminologyRefreshM4: {
        "id": "automation-menu.popup.run-rule.manual-rules.issue-selection-limit-exceeded-header-issue-terminology-refresh-m4",
        "defaultMessage": "Too many work items selected"
    },
    issueSelectionLimitExceededDescriptionIssueTerminologyRefreshM4: {
        "id": "automation-menu.popup.run-rule.manual-rules.issue-selection-limit-exceeded-description-issue-terminology-refresh-m4",
        "defaultMessage": "The maximum amount of work items you can select on a board is {limit, number}. Please deselect some and try again."
    }
});

});

parcelRegister("kRcYM", function(module, exports) {

$parcel$export(module.exports, "default", () => $6e62bc5491b5d974$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $99M5v = parcelRequire("99M5v");

var $9UCCQ = parcelRequire("9UCCQ");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $hdfW8 = parcelRequire("hdfW8");

var $ehatR = parcelRequire("ehatR");

var $27KWI = parcelRequire("27KWI");

var $kBike = parcelRequire("kBike");

var $7Fexc = parcelRequire("7Fexc");

var $2DY8U = parcelRequire("2DY8U");

var $6qr2W = parcelRequire("6qr2W");
const $6e62bc5491b5d974$var$RulesContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _c71l1feq _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $6e62bc5491b5d974$var$AddIcon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $ehatR.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_bfhk11bn _syazwdcn",
            __cmplp.className
        ])
    });
});
const $6e62bc5491b5d974$var$RuleList = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { rules: rules, executingRuleId: executingRuleId, executeRule: executeRule, setClosed: setClosed, selectedIssueIds: selectedIssueIds, recommendations: recommendations } = props;
    const [canManageAutomations] = (0, $kBike.useCanManageAutomations)();
    const [baseAutomationUrl] = (0, $kBike.useBaseAutomationUrl)();
    if (rules.length === 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdfW8.ConditionalRecommendation), {
        canManageAutomations: canManageAutomations,
        baseAutomationUrl: baseAutomationUrl,
        recommendations: recommendations,
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Fexc.default), null),
        setClosed: setClosed
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6e62bc5491b5d974$var$RulesContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(event, 'ruleList mounted')
    }), rules.map((rule)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6qr2W.default), {
            key: `manual-rule-${rule.id}`,
            rule: rule,
            isExecuting: rule.id === executingRuleId,
            executeRule: executeRule,
            selectedIssueIds: selectedIssueIds
        })), canManageAutomations && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $27KWI.default), {
        itemKey: "CREATE_MANUAL_RULE",
        href: `${baseAutomationUrl}#rule/new?componentFilterCriteria=QUICK_ACTIONS`,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6e62bc5491b5d974$var$AddIcon, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($99M5v))), {
            LEGACY_size: "small",
            label: ""
        }))
    }, formatMessage((0, $2DY8U.default).createManualRule))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hdfW8.ConditionalRecommendation), {
        canManageAutomations: canManageAutomations,
        baseAutomationUrl: baseAutomationUrl,
        recommendations: recommendations,
        setClosed: setClosed
    }));
};
var $6e62bc5491b5d974$export$2e2bcd8739ae039 = $6e62bc5491b5d974$var$RuleList;

});
parcelRegister("27KWI", function(module, exports) {

$parcel$export(module.exports, "default", () => $5616b0cf2eb85557$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3Z96c = parcelRequire("3Z96c");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
const $5616b0cf2eb85557$var$LinkItemWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('link', {
    onClick: 'clicked'
})(({ createAnalyticsEvent: createAnalyticsEvent, ...otherProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), otherProps));
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5616b0cf2eb85557$export$2e2bcd8739ae039 = ({ itemKey: itemKey, onClick: onClick, ...otherProps })=>{
    const onClickWithAnalytics = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        onClick && onClick();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'automationMenuLinkItem', {
            itemKey: itemKey
        });
    }, [
        itemKey,
        onClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5616b0cf2eb85557$var$LinkItemWithAnalytics, {
        ...otherProps,
        onClick: onClickWithAnalytics
    });
};

});

parcelRegister("7Fexc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b0b693dca48adecf$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $ha3Dq = parcelRequire("ha3Dq");

var $8zOmE = parcelRequire("8zOmE");
var $isuse = parcelRequire("isuse");

var $kBike = parcelRequire("kBike");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b0b693dca48adecf$export$2e2bcd8739ae039 = ()=>{
    const [canManageAutomations] = (0, $kBike.useCanManageAutomations)();
    const [baseAutomationUrl] = (0, $kBike.useBaseAutomationUrl)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $isuse.MountEvent), {
        onMount: (event)=>(0, $8zOmE.fireOperationalAnalyticsDeferred)(event, 'ruleEmptyState mounted')
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ha3Dq.NoRuleForSelectedIssuesEmptyState), {
        baseAutomationUrl: baseAutomationUrl,
        canManageAutomations: canManageAutomations
    })));
};

});
parcelRegister("ha3Dq", function(module, exports) {

$parcel$export(module.exports, "NoRuleForSelectedIssuesEmptyState", () => $76b4cb49ebd7ceef$export$7738f307426350cb);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $c4l9J = parcelRequire("c4l9J");

var $8Xv4X = parcelRequire("8Xv4X");

var $nK22f = parcelRequire("nK22f");
const $76b4cb49ebd7ceef$export$7738f307426350cb = (props)=>{
    const { baseAutomationUrl: baseAutomationUrl, canManageAutomations: canManageAutomations } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76b4cb49ebd7ceef$var$Container, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76b4cb49ebd7ceef$var$EmptyState, null, (0, $8Xv4X.emptyState)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($76b4cb49ebd7ceef$var$Message, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $4R6GH.fg)('jira-issue-terminology-update-m4') ? (0, $nK22f.default).noRuleForSelectedIssuesIssueTerminologyRefreshM4 : (0, $nK22f.default).noRuleForSelectedIssues)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $76b4cb49ebd7ceef$var$buttonContainerStyles
    }, canManageAutomations ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "default",
        href: `${baseAutomationUrl}#rule/new?componentFilterCriteria=QUICK_ACTIONS`,
        onClick: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'button',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'emptyStateAddRuleButton');
        }
    }, formatMessage((0, $nK22f.default).addRuleCta)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        onClick: ()=>{
            const analyticsEvent = createAnalyticsEvent({
                actionSubject: 'link',
                action: 'clicked'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manualRulesActionsMenu.emptyState.contantYourAdmin', {
                userType: 'endUser'
            });
        },
        href: (0, $c4l9J.AUTOMATION_MORE_DETAILS_URL)
    }, formatMessage((0, $nK22f.default).learnMoreAboutAutomation))));
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76b4cb49ebd7ceef$var$Container = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12fp59q _1e0c1ule _y3gn1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76b4cb49ebd7ceef$var$EmptyState = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3it9kd _1bsbys9h _1e0c1o8l",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $76b4cb49ebd7ceef$var$Message = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qutpp _u5f3utpp _n3tdutpp _19bvutpp _y3gn1h6o",
            __cmplp.className
        ])
    });
});
const $76b4cb49ebd7ceef$var$buttonContainerStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});

});
parcelRegister("8Xv4X", function(module, exports) {

$parcel$export(module.exports, "emptyState", () => $b679f47d798806d1$export$252465da46a2ae40);

var $5uXOq = parcelRequire("5uXOq");
const $b679f47d798806d1$export$252465da46a2ae40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
    width: "80",
    height: "72",
    viewBox: "0 0 80 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
    clipPath: "url(#clip0_1935_27815)"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    width: "80",
    height: "72",
    fill: "var(--ds-surface, #FFFFFF)",
    fillOpacity: "0.01"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M40.6568 71.9811C40.2977 71.9924 39.9385 72 39.5794 72.0038C39.0773 72.0076 38.668 71.6094 38.668 71.1165C38.6641 70.6349 39.0542 70.2367 39.5446 70.2215C39.5523 70.2215 39.5639 70.2215 39.5716 70.2215C41.8617 70.2102 44.1864 69.9675 46.4224 69.501C46.9128 69.3987 47.3956 69.7058 47.4998 70.1874C47.6041 70.669 47.2913 71.143 46.8008 71.2454C44.7889 71.6587 42.7228 71.909 40.6568 71.9811Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M34.6674 71.6815C34.6172 71.6815 34.5631 71.6815 34.509 71.6739C32.107 71.3478 29.7359 70.7752 27.4536 69.9713C26.9825 69.8044 26.7353 69.2963 26.9052 68.8298C27.0752 68.3672 27.5965 68.1245 28.0676 68.2914C30.2302 69.0536 32.4777 69.5958 34.7562 69.903C35.2543 69.9713 35.6019 70.4187 35.5324 70.9079C35.4745 71.3478 35.0999 71.6663 34.6674 71.6815Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M51.3921 69.9106C51.0098 69.9219 50.6468 69.6982 50.5078 69.3266C50.334 68.864 50.5735 68.352 51.0446 68.1814C53.1994 67.4002 55.2771 66.3953 57.2273 65.197C57.652 64.9354 58.212 65.0605 58.4785 65.4776C58.7449 65.8948 58.6175 66.4446 58.1927 66.7063C56.1382 67.969 53.9448 69.0308 51.6779 69.8537C51.5814 69.8916 51.4887 69.9068 51.3921 69.9106Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M23.2668 68.0563C23.1124 68.06 22.954 68.0297 22.8112 67.9539C20.6756 66.839 18.6443 65.5004 16.783 63.9798C16.3968 63.665 16.3427 63.1038 16.6633 62.7246C16.9838 62.3454 17.5553 62.2923 17.9415 62.6071C19.7102 64.0518 21.6333 65.3184 23.6607 66.3764C24.1048 66.6077 24.2709 67.1462 24.0353 67.5822C23.877 67.878 23.5796 68.0487 23.2668 68.0563Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M13.8216 60.821C13.5629 60.8286 13.3003 60.73 13.1149 60.529C11.4891 58.7619 10.0448 56.8279 8.82451 54.7764C8.56964 54.3517 8.71638 53.8056 9.1489 53.5554C9.58141 53.3051 10.1375 53.4492 10.3924 53.8739C11.5509 55.8192 12.9218 57.6546 14.4627 59.3307C14.7986 59.6947 14.7716 60.2598 14.397 60.5897C14.231 60.7376 14.0263 60.8134 13.8216 60.821Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M69.3952 54.9281C69.233 54.9319 69.0631 54.8978 68.9125 54.8106C68.4761 54.5641 68.3255 54.0218 68.5765 53.5933C69.7196 51.6328 70.658 49.551 71.3647 47.4084C71.5192 46.9382 72.0328 46.6842 72.5078 46.8358C72.9867 46.9875 73.2454 47.4919 73.0909 47.9583C72.3456 50.2184 71.3531 52.4102 70.1483 54.4769C69.9899 54.7575 69.7003 54.9167 69.3952 54.9281Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M7.45285 50.863C7.08213 50.8744 6.72685 50.662 6.5801 50.3056C5.66873 48.1024 4.98906 45.8006 4.5604 43.4571C4.47158 42.9717 4.79983 42.5091 5.29414 42.4219C5.78844 42.3346 6.25957 42.657 6.34839 43.1424C6.75774 45.3645 7.40265 47.5487 8.26382 49.6382C8.45305 50.0932 8.22907 50.6165 7.76179 50.7985C7.66139 50.8365 7.55712 50.8592 7.45285 50.863Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M73.4469 43.8515C73.3851 43.8553 73.3233 43.8515 73.2616 43.8401C72.7673 43.7567 72.4351 43.2978 72.5201 42.8124C72.9063 40.5979 73.0569 38.3264 72.9758 36.0626L72.9719 35.9867C72.9526 35.4937 73.3465 35.0804 73.8485 35.0652C74.3506 35.0463 74.7715 35.4331 74.7869 35.926L74.7908 36.0019C74.8758 38.3871 74.7136 40.7799 74.3081 43.1158C74.2347 43.5367 73.8679 43.8363 73.4469 43.8515Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M4.95089 39.3389C4.44886 39.3579 4.02793 38.99 4.01249 38.4971V38.4591C3.92753 36.0853 4.08586 33.7039 4.48748 31.3831C4.57244 30.8978 5.03971 30.5716 5.53401 30.6513C6.02832 30.7347 6.36043 31.1935 6.27933 31.6789C5.90088 33.8821 5.74641 36.1422 5.82751 38.3909C5.84682 38.8877 5.45292 39.3199 4.95089 39.3389Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M73.3733 32.0164C72.9292 32.0316 72.5315 31.7244 72.4504 31.2846C72.0371 29.0624 71.3922 26.8782 70.5272 24.7925C70.338 24.3375 70.562 23.8142 71.0254 23.6284C71.4888 23.4426 72.0217 23.6625 72.2109 24.1176C73.1223 26.317 73.8058 28.6225 74.2383 30.966C74.3272 31.4514 74.0028 31.9141 73.5085 32.0051C73.4621 32.0089 73.4197 32.0126 73.3733 32.0164Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M6.59195 27.7011C6.48769 27.7049 6.38342 27.6897 6.27915 27.6594C5.8003 27.5077 5.54156 27.0033 5.69603 26.5369C6.44135 24.2768 7.42609 22.0812 8.63096 20.0145C8.87811 19.586 9.4342 19.4382 9.87058 19.6808C10.307 19.9235 10.4576 20.4696 10.2104 20.8981C9.0712 22.8586 8.13279 24.9404 7.42609 27.0868C7.30252 27.4508 6.96268 27.6897 6.59195 27.7011Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M69.2106 20.9929C68.8862 21.0043 68.5696 20.845 68.3958 20.553C67.2334 18.6115 65.8625 16.7761 64.3178 15.1C63.9818 14.736 64.0088 14.1709 64.3834 13.841C64.7542 13.5111 65.3296 13.5377 65.6655 13.9055C67.2952 15.6726 68.7395 17.6028 69.9637 19.6505C70.2185 20.0752 70.0718 20.6213 69.6393 20.8715C69.5041 20.9474 69.3574 20.9853 69.2106 20.9929Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M12.2073 17.307C12.0026 17.3146 11.7941 17.2539 11.6165 17.1174C11.2226 16.814 11.1492 16.2528 11.4581 15.866C12.9488 13.9889 14.6363 12.2597 16.4823 10.7202C16.8646 10.4016 17.4361 10.4471 17.7644 10.8226C18.0887 11.198 18.0424 11.7592 17.6601 12.0815C15.9107 13.5415 14.3042 15.1872 12.8908 16.9657C12.7209 17.1818 12.466 17.2994 12.2073 17.307Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M61.4486 12.0322C61.2324 12.0398 61.0161 11.9716 60.8385 11.8275C59.0659 10.3865 57.1428 9.11993 55.1115 8.06195C54.6674 7.83063 54.4975 7.29216 54.7331 6.85607C54.9686 6.41998 55.517 6.25692 55.9611 6.48445C58.0966 7.59552 60.1279 8.93033 61.9931 10.4509C62.3793 10.7657 62.4334 11.3269 62.1129 11.7061C61.9429 11.9109 61.6958 12.0209 61.4486 12.0322Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M21.0928 9.41569C20.78 9.42707 20.4711 9.27918 20.2896 8.99857C20.0231 8.58144 20.1505 8.03159 20.5753 7.76994C22.6298 6.50338 24.8194 5.44161 27.0901 4.61493C27.5612 4.44429 28.0826 4.6794 28.2564 5.14203C28.4301 5.60466 28.1907 6.11659 27.7196 6.28724C25.5686 7.0684 23.491 8.07709 21.5408 9.27918C21.4018 9.3664 21.2473 9.4119 21.0928 9.41569Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M51.0371 6.20383C50.9251 6.20762 50.8092 6.19246 50.7011 6.15074C48.5385 5.39233 46.2871 4.85386 44.0087 4.5467C43.5105 4.47844 43.163 4.03098 43.2325 3.5418C43.302 3.05262 43.7615 2.71134 44.2558 2.77959C46.6579 3.10192 49.029 3.67073 51.3113 4.47086C51.7824 4.63771 52.0295 5.14585 51.8596 5.61227C51.7322 5.96493 51.3962 6.19246 51.0371 6.20383Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M32.1911 4.99037C31.7586 5.00554 31.3647 4.71355 31.272 4.28505C31.1677 3.80346 31.4805 3.32945 31.971 3.22706C34.3305 2.73409 36.7789 2.47623 39.1886 2.45727C39.6906 2.45348 40.1 2.85165 40.1038 3.34462C40.1077 3.83 39.7176 4.22438 39.2272 4.24334C39.2195 4.24334 39.2079 4.24334 39.2002 4.24334C36.9102 4.25471 34.5854 4.50499 32.3494 4.97141C32.2954 4.98279 32.2413 4.98658 32.1911 4.99037Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M73.6824 12.9651C73.5858 12.9385 73.5202 12.8513 73.5318 12.7527C73.5395 12.6958 73.5472 12.639 73.5549 12.5821C73.5742 12.4721 73.5974 12.3546 73.6283 12.2332C73.7442 11.7971 73.9566 11.4065 74.2616 11.0615C74.5667 10.7164 75.007 10.4282 75.5746 10.2045L76.5323 9.82146C77.1039 9.59773 77.4553 9.22611 77.5943 8.71418C77.6445 8.52837 77.66 8.33876 77.6407 8.14158C77.6214 7.94439 77.5634 7.75858 77.4592 7.58793C77.3549 7.41729 77.212 7.26182 77.0228 7.1253C76.8336 6.98879 76.6019 6.8864 76.3238 6.81435C76.0226 6.73851 75.7561 6.72713 75.5167 6.78022C75.2773 6.83331 75.0649 6.92811 74.8795 7.06084C74.6941 7.19356 74.5397 7.3642 74.4161 7.56897C74.2887 7.77374 74.196 7.99369 74.1342 8.22121C74.1149 8.28947 74.0994 8.35772 74.0879 8.4184C74.0531 8.59662 73.8716 8.7028 73.694 8.64971L72.2149 8.20604C72.0759 8.16433 71.9793 8.03161 71.9948 7.8913C71.9986 7.84579 72.0064 7.80029 72.0141 7.75479C72.0373 7.62585 72.0643 7.50451 72.0952 7.38316C72.211 6.94707 72.408 6.54132 72.686 6.16591C72.9641 5.79049 73.3078 5.48334 73.7171 5.24444C74.1265 5.00554 74.5899 4.85006 75.1151 4.77422C75.6403 4.69838 76.2118 4.74388 76.8336 4.90315C77.4785 5.07 78.0191 5.3089 78.4555 5.61985C78.8957 5.9308 79.2394 6.27967 79.4904 6.66267C79.7415 7.04946 79.8998 7.459 79.9616 7.89509C80.0234 8.33118 80.0002 8.75589 79.8882 9.16923C79.7144 9.82146 79.4132 10.341 78.9923 10.7278C78.5675 11.1146 78.0616 11.4179 77.4669 11.6341L76.6598 11.9336C76.4319 12.0057 76.0921 12.1536 75.8102 12.4569C75.7832 12.4873 75.6673 12.6124 75.5515 12.8058C75.4665 12.9499 75.4047 13.0902 75.3622 13.2116C75.3275 13.3102 75.2194 13.3633 75.1189 13.3367L73.6824 12.9651ZM72.5007 15.191C72.5972 14.8308 72.8058 14.5578 73.1301 14.3682C73.4545 14.1785 73.7982 14.1293 74.1651 14.2241C74.532 14.3189 74.81 14.5274 75.0031 14.8497C75.1962 15.1721 75.2425 15.5134 75.146 15.8736C75.0494 16.2338 74.837 16.5031 74.5088 16.6889C74.1805 16.8709 73.833 16.9164 73.47 16.8216C73.1031 16.7268 72.8251 16.522 72.6397 16.2073C72.4505 15.8888 72.4041 15.5513 72.5007 15.191Z",
    fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M7.14805 8.0847C7.05537 8.05436 6.99358 7.95956 7.01289 7.86476C7.02447 7.80788 7.03606 7.751 7.04764 7.69412C7.07468 7.58415 7.10557 7.47038 7.14805 7.35283C7.2948 6.92433 7.53036 6.54891 7.86247 6.22659C8.19072 5.90047 8.64641 5.6464 9.23339 5.4568L10.2143 5.13826C10.7974 4.95245 11.1759 4.60737 11.3496 4.10303C11.4114 3.92101 11.4423 3.73141 11.4346 3.53422C11.4307 3.33703 11.3805 3.14743 11.2917 2.9692C11.2029 2.79097 11.0677 2.62791 10.8862 2.48002C10.7086 2.33213 10.4807 2.21458 10.2104 2.12357C9.91692 2.02497 9.6466 1.99843 9.40717 2.03635C9.16388 2.07427 8.94763 2.1539 8.75454 2.27525C8.56145 2.3966 8.39539 2.55586 8.25637 2.75305C8.10963 2.95024 8.0015 3.1626 7.92426 3.38633C7.90109 3.45458 7.88178 3.51905 7.86634 3.57972C7.81999 3.75416 7.63077 3.84896 7.45699 3.78449L6.0127 3.24602C5.87753 3.19672 5.79258 3.05642 5.81575 2.91611C5.82347 2.87061 5.83506 2.8251 5.84664 2.7796C5.87753 2.65446 5.91229 2.53311 5.95477 2.41556C6.10152 1.98705 6.3255 1.59647 6.63058 1.24002C6.93565 0.883562 7.29866 0.599157 7.71959 0.386801C8.14438 0.174445 8.61938 0.049307 9.14457 0.0113863C9.67363 -0.0265344 10.2413 0.0530991 10.8476 0.254079C11.4771 0.462642 12.0023 0.735671 12.4193 1.07696C12.8364 1.41824 13.1569 1.78607 13.3809 2.18803C13.6049 2.58999 13.7362 3.00712 13.7671 3.447C13.798 3.88688 13.7439 4.3078 13.6049 4.71355C13.3848 5.35441 13.0527 5.85117 12.6008 6.20763C12.1529 6.56408 11.6238 6.83332 11.0175 7.01154L10.1911 7.25424C9.9594 7.31112 9.60798 7.43626 9.30677 7.72066C9.27587 7.751 9.1523 7.86855 9.02486 8.05057C8.92832 8.19088 8.8588 8.3236 8.8086 8.44115C8.76998 8.53596 8.65799 8.58525 8.55759 8.55112L7.14805 8.0847ZM5.81575 10.2272C5.93546 9.87456 6.1633 9.6129 6.49928 9.44605C6.83525 9.2792 7.18281 9.25266 7.54195 9.37021C7.90109 9.48777 8.16369 9.71529 8.33361 10.049C8.50352 10.3827 8.52669 10.7278 8.40698 11.0804C8.28727 11.4331 8.05556 11.691 7.71573 11.8502C7.37589 12.0095 7.02834 12.0322 6.66919 11.9147C6.31005 11.7971 6.04745 11.5734 5.8814 11.2435C5.7192 10.9212 5.69603 10.5799 5.81575 10.2272Z",
    fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    opacity: "0.3",
    d: "M4.78519 68.4013C4.69251 68.4355 4.58438 68.4013 4.53804 68.3141C4.51101 68.2648 4.48397 68.2117 4.45694 68.1586C4.40674 68.0563 4.3604 67.9463 4.31406 67.8325C4.15572 67.4116 4.0978 66.9717 4.148 66.5167C4.1982 66.0616 4.38743 65.58 4.7234 65.0719L5.28336 64.2187C5.61933 63.7143 5.6927 63.21 5.50348 62.7132C5.43396 62.535 5.33742 62.3682 5.20612 62.2165C5.07482 62.0648 4.92035 61.9472 4.73499 61.8638C4.54962 61.7804 4.34109 61.7387 4.10552 61.7311C3.86996 61.7273 3.61894 61.7728 3.35248 61.8714C3.06285 61.9776 2.83501 62.1179 2.66895 62.2999C2.5029 62.4781 2.38704 62.6753 2.31367 62.8877C2.2403 63.1 2.21326 63.3275 2.22871 63.5664C2.24416 63.8053 2.29436 64.0367 2.37932 64.2604C2.40635 64.3287 2.42952 64.3893 2.45655 64.4462C2.53379 64.6093 2.44497 64.8027 2.27119 64.8595L0.803726 65.3298C0.664703 65.3753 0.510233 65.3184 0.440722 65.1932C0.417551 65.1515 0.398243 65.1098 0.375072 65.0681C0.317146 64.9505 0.266943 64.833 0.224464 64.7192C0.0661322 64.2983 -0.0111028 63.8546 -0.00337928 63.3882C0.00434421 62.9218 0.10475 62.4781 0.301699 62.0534C0.494786 61.6287 0.784418 61.2381 1.17059 60.8817C1.55677 60.5252 2.05107 60.237 2.6535 60.0209C3.27911 59.7933 3.85837 59.6834 4.39901 59.6909C4.93966 59.6985 5.42624 59.7895 5.85876 59.9602C6.29127 60.1346 6.65814 60.3811 6.96322 60.7034C7.26829 61.0258 7.49614 61.386 7.64675 61.788C7.88617 62.4212 7.9441 63.0166 7.82439 63.5702C7.70467 64.1239 7.46524 64.6586 7.1061 65.1743L6.61952 65.8758C6.47664 66.0654 6.28355 66.3764 6.22948 66.7821C6.22562 66.8238 6.20245 66.9907 6.22176 67.2106C6.23721 67.3775 6.2681 67.5254 6.30672 67.6467C6.33761 67.7453 6.27969 67.8515 6.17928 67.8894L4.78519 68.4013ZM5.12116 70.8889C4.98986 70.5401 5.00145 70.1988 5.15592 69.8575C5.31039 69.52 5.56526 69.2849 5.92054 69.156C6.27583 69.027 6.62724 69.0422 6.97094 69.1977C7.3185 69.3531 7.55793 69.6072 7.68922 69.9561C7.82052 70.3049 7.80508 70.6462 7.64288 70.9799C7.48069 71.3136 7.22195 71.545 6.87053 71.6739C6.51525 71.8028 6.1677 71.7914 5.82786 71.6398C5.48803 71.4881 5.25246 71.2378 5.12116 70.8889Z",
    fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M57.6792 50.6582L54.9181 48.0303L51.1992 51.8034L53.9604 54.4313C54.6671 55.1025 55.1614 55.9558 55.3931 56.8924C55.6248 57.829 56.1229 58.6823 56.8258 59.3534L68.0364 70.0092C69.7356 71.6246 72.4427 71.5791 74.0878 69.9144C75.7329 68.2458 75.6866 65.5876 73.9913 63.9722L62.7806 53.3165C62.0739 52.6453 61.1896 52.1864 60.228 51.9893C59.2703 51.7883 58.3859 51.3256 57.6792 50.6582Z",
    fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M60.1198 51.9551C59.2046 51.7466 58.3588 51.2991 57.683 50.6544L56.8412 49.8543C55.7792 48.8456 54.0878 48.8722 53.0605 49.915C52.0333 50.9578 52.0603 52.6187 53.1223 53.6274L53.9642 54.4275C54.64 55.0722 55.1227 55.8837 55.366 56.7748C56.2735 56.0998 57.1308 55.3528 57.9379 54.5337C58.7373 53.726 59.4633 52.8614 60.1198 51.9551Z",
    fill: "var(--ds-icon-disabled, #091E424F)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M39.3701 59.1563C33.396 59.2511 27.7424 57.0555 23.452 52.9752C14.5893 44.553 14.3614 30.621 22.9384 21.9182C27.0936 17.7052 32.6738 15.3313 38.6441 15.2327C44.6182 15.1379 50.2718 17.3336 54.5622 21.4138C58.8565 25.4941 61.2701 30.9736 61.3705 36.8362C61.467 42.7025 59.2311 48.2541 55.0758 52.4671C50.9245 56.6876 45.3442 59.0615 39.3701 59.1563ZM38.7329 20.4772C34.1838 20.5492 29.9397 22.358 26.7731 25.5661C20.2429 32.1909 20.4166 42.7973 27.1631 49.2097C30.4302 52.3154 34.736 53.9877 39.2852 53.9156C43.8343 53.8436 48.0784 52.0348 51.245 48.8267C54.4078 45.6186 56.1108 41.3904 56.0374 36.9234C55.964 32.4563 54.122 28.2888 50.855 25.1793C47.5841 22.0774 43.2821 20.4051 38.7329 20.4772Z",
    fill: "url(#paint0_linear_1935_27815)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
    d: "M45.9242 32.316L43.862 30.3252C43.5569 30.0332 43.0703 30.037 42.7691 30.3365L38.9885 34.1172L35.1383 30.4048C34.8332 30.1128 34.3466 30.1166 34.0454 30.4162L32.018 32.4411C31.7207 32.7407 31.7245 33.2185 32.0296 33.5143L35.8798 37.2267L32.0991 41.0074C31.8018 41.307 31.8056 41.7848 32.1107 42.0806L34.1729 44.0714C34.4779 44.3634 34.9645 44.3596 35.2657 44.06L39.0464 40.2793L42.8966 43.9918C43.2016 44.2838 43.6882 44.28 43.9894 43.9804L46.0168 41.9554C46.3142 41.6559 46.3103 41.1781 46.0053 40.8823L42.1551 37.1698L45.9357 33.3892C46.2331 33.0896 46.2292 32.608 45.9242 32.316Z",
    fill: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("defs", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("linearGradient", {
    id: "paint0_linear_1935_27815",
    x1: "23.1941",
    y1: "52.727",
    x2: "54.2487",
    y2: "21.1016",
    gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
    offset: "0.5572",
    stopColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)"
}), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("stop", {
    offset: "0.966",
    stopColor: "var(--ds-background-accent-gray-subtler, #DCDFE4)",
    /* "#E9EBEF" */ stopOpacity: "0.5"
})), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("clipPath", {
    id: "clip0_1935_27815"
}, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("rect", {
    width: "80",
    height: "72",
    fill: "var(--ds-surface, #FFFFFF)"
}))));

});

parcelRegister("nK22f", function(module, exports) {

$parcel$export(module.exports, "default", () => $13f76caff4110611$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $13f76caff4110611$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noRuleForSelectedIssues: {
        "id": "automation-platform.no-rule-for-issues-empty-state.no-rule-for-selected-issues",
        "defaultMessage": "Available automations can't be used with the issues you've selected"
    },
    addRuleCta: {
        "id": "automation-platform.no-rule-for-issues-empty-state.add-rule-cta",
        "defaultMessage": "Add a manually triggered automation"
    },
    learnMoreAboutAutomation: {
        "id": "automation-platform.no-rule-for-issues-empty-state.learn-more-about-automation",
        "defaultMessage": "Learn more about Automation"
    },
    noRuleForSelectedIssuesIssueTerminologyRefreshM4: {
        "id": "automation-platform.no-rule-for-issues-empty-state.no-rule-for-selected-issues-issue-terminology-refresh-m4",
        "defaultMessage": "Available automations can't be used with the work items you've selected"
    }
});

});



parcelRegister("2DY8U", function(module, exports) {

$parcel$export(module.exports, "default", () => $a69fcab250eff39e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a69fcab250eff39e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    createManualRule: {
        "id": "automation-menu.popup.run-rule.manual-rules.rule-list.create-manual-rule",
        "defaultMessage": "Add a manually triggered automation"
    }
});

});

parcelRegister("6qr2W", function(module, exports) {

$parcel$export(module.exports, "default", () => $5b3fc400ff1e9739$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $eZJjh = parcelRequire("eZJjh");

var $1noc6 = parcelRequire("1noc6");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $27KWI = parcelRequire("27KWI");

var $kBike = parcelRequire("kBike");

var $iKM9r = parcelRequire("iKM9r");
const $5b3fc400ff1e9739$var$isRuleDisabled = (rule, isExecuting, noIssuesSelected, crossProjectSelection, projectAri)=>{
    if (isExecuting || noIssuesSelected) return true;
    if (crossProjectSelection) {
        const scopeAris = rule.ruleScope.resources;
        // Disable if we have a cross project selection AND the rule is a SINGLE project rule.
        return scopeAris.length === 1 && scopeAris.includes(projectAri);
    }
    return false;
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5b3fc400ff1e9739$export$2e2bcd8739ae039 = ({ isExecuting: isExecuting, rule: rule, executeRule: executeRule, selectedIssueIds: selectedIssueIds })=>{
    const [{ selectedIssuesKeys: selectedIssuesKeys, crossProjectSelection: crossProjectSelection }] = (0, $iKM9r.useSelectedIssues)();
    const [projectAri] = (0, $kBike.useProjectAri)();
    const cloudId = (0, $koeKL.useCloudId)();
    const selectedIssueAris = (selectedIssueIds ?? []).map((id)=>(0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            resourceType: 'issue',
            cloudId: cloudId,
            resourceId: id.toString()
        }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $27KWI.default), {
        testId: `automation-menu.popup.run-rule.${rule.id}`,
        itemKey: "MANUAL_RULE",
        isDisabled: $5b3fc400ff1e9739$var$isRuleDisabled(rule, isExecuting, selectedIssuesKeys.length === 0, crossProjectSelection, projectAri),
        iconBefore: isExecuting ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1noc6.MenuIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
            size: "small"
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1noc6.TriggerIcon), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
            size: "small",
            glyph: (0, $1noc6.ManualTriggerGlyph),
            label: ""
        })),
        onClick: ()=>executeRule(rule.id, selectedIssueAris)
    }, rule.name);
};

});
parcelRegister("1noc6", function(module, exports) {

$parcel$export(module.exports, "ManualTriggerGlyph", () => $6325cb76caa5baa0$export$4514e29f70245d75);
$parcel$export(module.exports, "AutomationGlyphBlack", () => $6325cb76caa5baa0$export$9d08b452ddec60a4);
$parcel$export(module.exports, "MenuIcon", () => $6325cb76caa5baa0$export$46e1d66043f363e6);
$parcel$export(module.exports, "TriggerIcon", () => $6325cb76caa5baa0$export$1cb264166623d4aa);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7paD5 = parcelRequire("7paD5");
const $6325cb76caa5baa0$export$4514e29f70245d75 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: 24,
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m21.192 19.778-4.9498-4.9498c-0.3905-0.3905-1.0237-0.3905-1.4142 0-0.3905 0.3906-0.3905 1.0237 0 1.4143l4.9498 4.9497c0.3905 0.3905 1.0237 0.3905 1.4142 0s0.3905-1.0237 0-1.4142z",
        fill: "currentColor"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m8.7738 8.1319 11.685 4.305c0.2591 0.0955 0.3917 0.3829 0.2963 0.6421-0.025 0.0679-0.0645 0.1295-0.1156 0.1807l-7.3802 7.3801c-0.1952 0.1953-0.5118 0.1953-0.7071 0-0.0511-0.0512-0.0906-0.1128-0.1156-0.1807l-4.3051-11.685c-0.09546-0.25911 0.03721-0.54656 0.29632-0.64202 0.11157-0.0411 0.23414-0.0411 0.34571 0z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "m4.2218 4.2218c1.9526-1.9526 5.1184-1.9526 7.0711 0 0.5977 0.59776 1.0125 1.3092 1.2443 2.0648 0.1974 0.6437-0.4389 1.1502-1.0873 0.96899l-0.2172-0.06069c-0.3475-0.09709-0.6037-0.38008-0.7563-0.70702-0.1439-0.30836-0.3432-0.59728-0.59773-0.85184-1.1716-1.1716-3.0711-1.1716-4.2426 0-1.1716 1.1716-1.1716 3.0711 0 4.2426 0.2547 0.25469 0.54381 0.45399 0.85236 0.59799 0.32725 0.1527 0.61051 0.4091 0.70752 0.7569l0.06045 0.2168c0.18082 0.6483-0.32561 1.2843-0.96914 1.087-0.75578-0.2317-1.4675-0.6466-2.0654-1.2445-1.9526-1.9526-1.9526-5.1184 0-7.071z",
        clipRule: "evenodd",
        fill: "currentColor",
        fillRule: "evenodd"
    }));
const $6325cb76caa5baa0$export$85ca00d4fc5d86c3 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7paD5))), {
        size: "small",
        ...props
    });
const $6325cb76caa5baa0$export$3b6023946faff8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.3789 4.62256C9.99914 4.62173 9.65331 4.84087 9.49192 5.18458L6.11523 12.3762C5.97308 12.679 5.9956 13.0334 6.17494 13.3157C6.35428 13.598 6.66553 13.7691 7 13.7691H8.79182L6.40251 18.1304C6.17135 18.5523 6.28163 19.0798 6.66249 19.3738C7.04335 19.6677 7.58152 19.6408 7.93117 19.3103L16.8269 10.902C17.1178 10.6269 17.2117 10.2023 17.0637 9.83032C16.9157 9.45832 16.5558 9.21418 16.1555 9.21418H14.547L17.0353 6.24031C17.2787 5.94947 17.3319 5.5441 17.1717 5.20034C17.0116 4.85658 16.6671 4.63646 16.2879 4.63562L10.3789 4.62256Z",
        stroke: "currentColor",
        strokeWidth: "1.95489",
        strokeLinejoin: "round"
    }));
const $6325cb76caa5baa0$export$fdd32c4638a0c3ae = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "var(--ds-text-inverse, #FFFFFF)"
    }));
const $6325cb76caa5baa0$export$9d08b452ddec60a4 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        width: "24",
        height: "24",
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M10.1838 4.78749C10.2664 4.61167 10.4433 4.49957 10.6375 4.5L17.0011 4.51406C17.1951 4.51449 17.3713 4.62709 17.4532 4.80294C17.5352 4.97879 17.508 5.18614 17.3835 5.33492L13.9446 9.44482H16.8597C17.0645 9.44482 17.2486 9.5697 17.3243 9.76C17.4 9.95029 17.352 10.1675 17.2032 10.3082L7.62319 19.3634C7.44433 19.5324 7.16903 19.5462 6.97421 19.3958C6.77938 19.2454 6.72297 18.9756 6.84122 18.7598L9.86254 13.2448H7C6.82891 13.2448 6.66969 13.1573 6.57795 13.0129C6.48621 12.8685 6.47469 12.6872 6.54741 12.5323L10.1838 4.78749Z",
        fill: "var(--ds-text, #172B4D)"
    }));
const $6325cb76caa5baa0$export$46e1d66043f363e6 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1y44 _1bsb1tcg _4t3i1tcg _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $6325cb76caa5baa0$export$1cb264166623d4aa = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $6325cb76caa5baa0$export$46e1d66043f363e6, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz17hp _bfhkn729",
            __cmplp.className
        ])
    });
});

});



parcelRegister("2OBLh", function(module, exports) {

$parcel$export(module.exports, "errorImageHeight", () => $813d9d6077efcbd3$export$2d8373672f57f277);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9UCCQ = parcelRequire("9UCCQ");

var $gwIPs = parcelRequire("gwIPs");
const $813d9d6077efcbd3$export$2d8373672f57f277 = (0, $gwIPs.gridSize) * 14;
const $813d9d6077efcbd3$export$42a852a2b6b56249 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $9UCCQ.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo1wug _18m91wug _c71l1feq",
            __cmplp.className
        ])
    });
});
const $813d9d6077efcbd3$export$3c552bcab5076086 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $813d9d6077efcbd3$export$42a852a2b6b56249, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.canManageAutomations ? "_19pk1stb _2hwx7vkz _otyr1stb _18u07vkz" : "_19pkidpf _2hwx7vkz _otyridpf _18u07vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("XHOES", function(module, exports) {

$parcel$export(module.exports, "default", () => $49e6343aa16ac86b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $49e6343aa16ac86b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    automationHeader: {
        "id": "automation-menu.popup.run-rule.automation-header",
        "defaultMessage": "Automation"
    }
});

});




parcelRegister("7tZOY", function(module, exports) {

$parcel$export(module.exports, "default", () => $a854114828988163$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dCm1o = parcelRequire("dCm1o");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $gJ3ZJ = parcelRequire("gJ3ZJ");
const $a854114828988163$export$bd1899d755aff74a = (sprints)=>{
    if ((0, $dCm1o.isVisualRefreshEnabled)()) {
        if (sprints && sprints[0]?.daysRemaining != null && sprints[0].daysRemaining <= 0) return 'primary';
    }
    // FIXME next dev actively working in this area
    // not urgent bc (null <= 0) => true so no crash
    // @ts-expect-error TS2531: Object is possibly 'null'.
    if (sprints && sprints[0]?.daysRemaining <= 0) return 'primary';
    return 'default';
};
const $a854114828988163$var$mapStateToProps = (state)=>{
    const activeSprints = (0, $ebHh7.activeSprintsSelector)(state);
    return {
        activeSprints: activeSprints,
        appearance: $a854114828988163$export$bd1899d755aff74a(activeSprints),
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        selectedSprintIds: (0, $ebHh7.getSelectedSprintsKeys)(state),
        sourceIssueNo: (0, $5mTgl.workIssuesSelector)(state).length,
        isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
    };
};
var $a854114828988163$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($a854114828988163$var$mapStateToProps, {})((0, $gJ3ZJ.CompleteSprintButton));

});
parcelRegister("gJ3ZJ", function(module, exports) {

$parcel$export(module.exports, "CompleteSprintButton", () => $9e150ec798a2c3f9$export$8d02575f5278cc77);

var $5uXOq = parcelRequire("5uXOq");

var $jj52j = parcelRequire("jj52j");
var $it1wb = parcelRequire("it1wb");
var $gn1v9 = parcelRequire("gn1v9");

var $hZ1SC = parcelRequire("hZ1SC");

var $47gW9 = parcelRequire("47gW9");

var $ivDCs = parcelRequire("ivDCs");

var $4mO32 = parcelRequire("4mO32");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dAfqg = parcelRequire("dAfqg");

var $bOsIL = parcelRequire("bOsIL");

var $iKdRC = parcelRequire("iKdRC");


var $b0yad = parcelRequire("b0yad");

var $koeKL = parcelRequire("koeKL");

var $lVJAU = parcelRequire("lVJAU");

var $dCm1o = parcelRequire("dCm1o");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $CFxE9 = parcelRequire("CFxE9");

var $aKlQV = parcelRequire("aKlQV");

var $ayk9K = parcelRequire("ayk9K");

var $lguBA = parcelRequire("lguBA");
const $9e150ec798a2c3f9$export$8d02575f5278cc77 = ({ activeSprints: activeSprints, appearance: appearance, boardId: boardId, selectedSprintIds: selectedSprintIds, sourceIssueNo: sourceIssueNo, isCMPBoard: isCMPBoard, isDisabled: isDisabled, overrideAppearance: overrideAppearance })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const jiraProjectAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira',
        cloudId: cloudId,
        resourceType: 'project',
        resourceId: String(project?.projectId)
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const boardIdAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const showRetrosModal = (0, $hZ1SC.useShowCreateRetroOrCrossSellModal)();
    const backlogUrl = (0, $aKlQV.useBacklogUrl)([
        'sprintCompleted'
    ]) || '';
    const onCompleted = (0, $5uXOq.useCallback)(()=>{
        push(backlogUrl);
        // Set the flag to load the retros modal when we get to the backlog if the checkbox was ticked
        showRetrosModal();
        // Since the sprint modals don't go through redux we need to fire their invalidations manually
        (0, $b0yad.triggerResourceCacheInvalidation)((0, $8631d6ce464ccf2e$export$9b8283d5878d2491), 'COMPLETE_SPRINT_MODAL_COMPLETE');
    }, [
        backlogUrl,
        push,
        showRetrosModal
    ]);
    const activeSprintIds = (0, $5uXOq.useMemo)(()=>{
        // Use selected sprint ids if present, otherwise use all active sprints
        const sprintIds = (selectedSprintIds && selectedSprintIds.length > 0 ? selectedSprintIds : activeSprints?.map(({ id: id })=>id.toString())) ?? [];
        return sprintIds.map((sprintId)=>(0, $dXq4S.createAri)({
                cloudId: cloudId,
                resourceId: sprintId,
                resourceOwner: 'jira-software',
                resourceType: 'sprint'
            }));
    }, [
        activeSprints,
        cloudId,
        selectedSprintIds
    ]);
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            jiraProjectAri: jiraProjectAri,
            // Date of 12 weeks ago as we want to fetch deployments date updated at most 12 weeks ago for deployments report nudge on sprint completion
            updatedFromDeploymentsDate: (0, $jj52j.default)((0, $it1wb.default)((0, $gn1v9.default)(Date.now(), {
                weeks: 12
            }))),
            boardId: boardIdAri,
            activeSprintIds: activeSprintIds,
            isCompanyManaged: isCMPBoard
        }), [
        activeSprintIds,
        boardIdAri,
        isCMPBoard,
        jiraProjectAri
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bOsIL.completeSprintModalEntryPoint), entryPointParams, (0, $CFxE9.completeSprintModalLoad));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    let sprintId = selectedSprintIds?.[0];
    if (!sprintId && activeSprints) sprintId = activeSprints?.[0]?.id.toString();
    const props = (0, $5uXOq.useMemo)(()=>({
            analyticsSource: 'simple-software-board',
            boardId: boardIdAri,
            onCompleted: onCompleted,
            sourceIssueNo: sourceIssueNo,
            sprintId: sprintId,
            selectedSprintIds: selectedSprintIds,
            onReady: stopMetric,
            isCompanyManaged: isCMPBoard
        }), [
        boardIdAri,
        onCompleted,
        sourceIssueNo,
        sprintId,
        selectedSprintIds,
        stopMetric,
        isCMPBoard
    ]);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (isCMPBoard) {
            const analyticsEvent = createAnalyticsEvent({});
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, 'completeSprintButton mounted');
        }
    }, [
        isCMPBoard,
        createAnalyticsEvent
    ]);
    let appliedAppearance = appearance;
    if (overrideAppearance && (0, $dCm1o.isVisualRefreshEnabled)()) appliedAppearance = overrideAppearance;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isDisabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ayk9K.DisabledButtonHelper), null, formatMessage((0, $lguBA.default).completeSprintButton)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iKdRC.ModalTriggerButton), {
        testId: "software-board.header.complete-sprint-button",
        appearance: appliedAppearance,
        ref: triggerRef,
        ...(0, $lmBAt.getIsSoftwareThemingEnabled)() && {
            isThemed: isSoftwareFullTheming
        }
    }, formatMessage((0, $lguBA.default).completeSprintButton)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "complete-sprint-modal",
        teamName: "a4t-pandora",
        packageName: "jiraSoftwareCompleteSprintModalRelay",
        entryPointActions: entryPointActions,
        runtimeProps: props
    }));
};

});
parcelRegister("hZ1SC", function(module, exports) {

$parcel$export(module.exports, "useShowCreateRetroOrCrossSellModal", () => $b6bc1441fa7da9d1$export$3918442dc3bc3c6b);

var $5uXOq = parcelRequire("5uXOq");

var $cyA39 = parcelRequire("cyA39");

var $hqBSi = parcelRequire("hqBSi");

var $4R6GH = parcelRequire("4R6GH");

var $9LoyA = parcelRequire("9LoyA");
const $b6bc1441fa7da9d1$export$3918442dc3bc3c6b = ()=>{
    const [retrosState, retrosActions] = (0, $9LoyA.useRetros)();
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    const { hasAccess: hasAccess } = (0, $cyA39.useUserHasConfluenceAccess)();
    return (0, $5uXOq.useCallback)(()=>{
        if (!retrosState.shouldCreateRetro) return;
        let action = retrosActions.setLoadCreateRetroModal;
        if (licensedProducts.confluence && !hasAccess && (0, $4R6GH.fg)('jira_sprint_completion_cross_join_confluence')) action = retrosActions.setLoadCrossJoinModal;
        action(true);
    }, [
        licensedProducts,
        hasAccess,
        retrosState.shouldCreateRetro,
        retrosActions
    ]);
};

});
parcelRegister("cyA39", function(module, exports) {

$parcel$export(module.exports, "useUserHasConfluenceAccess", () => $e1d1047ca6c0e736$export$bddce71054147149);

var $5uXOq = parcelRequire("5uXOq");

var $8QpSo = parcelRequire("8QpSo");

var $eNf8a = parcelRequire("eNf8a");

var $imVeH = parcelRequire("imVeH");

var $jcw0u = parcelRequire("jcw0u");

var $koeKL = parcelRequire("koeKL");

var $9KYrx = parcelRequire("9KYrx");

var $cu7Vs = parcelRequire("cu7Vs");

var $cpyFY = parcelRequire("cpyFY");

var $8o1o1 = parcelRequire("8o1o1");
const $e1d1047ca6c0e736$var$TIME_TO_LIVE = 1800000; // 30 minutes
const $e1d1047ca6c0e736$var$storage = (0, $eNf8a.createSessionStorageProvider)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_PROVIDER_KEY));
const $e1d1047ca6c0e736$export$704f81dd3d993adb = (0, $8QpSo.default)((0, $cu7Vs.fetchConfluenceUserPermissions));
const $e1d1047ca6c0e736$export$bddce71054147149 = (embeddedConfluenceSource, skip = false)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fireAnalyticsEvent = (0, $8o1o1.useEmbeddedPageTracking)();
    const tenantHasConfluence = (0, $imVeH.useTenantHasConfluence)();
    const [hasAccess, setHasAccess] = (0, $5uXOq.useState)(false);
    const permitted = (0, $5uXOq.useMemo)(()=>(0, $cpyFY.getSessionStorageData)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage)?.permitted, []);
    const getConfluencePermissions = (0, $5uXOq.useCallback)(async ()=>{
        try {
            if (!cloudId) return;
            const response = await $e1d1047ca6c0e736$export$704f81dd3d993adb(cloudId);
            fireAnalyticsEvent({
                action: 'success',
                eventName: 'userConfluenceAccess',
                embeddedConfluenceSource: embeddedConfluenceSource
            });
            (0, $cpyFY.setSessionStorageData)({
                key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
                value: response,
                ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
                storage: $e1d1047ca6c0e736$var$storage
            });
            setHasAccess(response?.permitted);
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'userConfluenceAccess',
                    teamName: 'confluence-better-together'
                },
                attributes: {
                    embeddedConfluenceSource: embeddedConfluenceSource
                },
                error: new Error(`Failed to get user confluence access status: ${error}`)
            });
        }
    }, [
        cloudId,
        embeddedConfluenceSource,
        fireAnalyticsEvent
    ]);
    const refetchHasAccess = (0, $5uXOq.useCallback)(async ()=>{
        (0, $cpyFY.setSessionStorageData)({
            key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
            storage: $e1d1047ca6c0e736$var$storage
        });
        $e1d1047ca6c0e736$export$704f81dd3d993adb.clear();
        await getConfluencePermissions();
    }, [
        getConfluencePermissions
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (skip) return;
        if (!(0, $cpyFY.getSessionStorageData)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage)) (0, $cpyFY.setSessionStorageData)({
            key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
            value: {},
            ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
            storage: $e1d1047ca6c0e736$var$storage
        });
        if (!(0, $cpyFY.isStorageKeyExpired)((0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY), $e1d1047ca6c0e736$var$storage) && permitted !== undefined) {
            setHasAccess(permitted);
            return;
        }
        if (!tenantHasConfluence) {
            (0, $cpyFY.setSessionStorageData)({
                key: (0, $9KYrx.CONFLUENCE_ACCESS_STORAGE_KEY),
                value: {
                    permitted: false
                },
                ttl: $e1d1047ca6c0e736$var$TIME_TO_LIVE,
                storage: $e1d1047ca6c0e736$var$storage
            });
            setHasAccess(false);
            return;
        }
        getConfluencePermissions();
    }, [
        embeddedConfluenceSource,
        fireAnalyticsEvent,
        getConfluencePermissions,
        permitted,
        skip,
        tenantHasConfluence
    ]);
    return {
        hasAccess: hasAccess,
        refetchHasAccess: refetchHasAccess
    };
};

});
parcelRegister("imVeH", function(module, exports) {

$parcel$export(module.exports, "useTenantHasConfluence", () => $734552c5f3b177b5$export$964fe2dd9242a588);

var $4Pf62 = parcelRequire("4Pf62");

var $hqBSi = parcelRequire("hqBSi");
const $734552c5f3b177b5$export$964fe2dd9242a588 = ()=>{
    const licensedProducts = (0, $hqBSi.useLicensedProducts)();
    return Boolean(licensedProducts[(0, $4Pf62.LICENSED_PRODUCTS).CONFLUENCE]);
};

});

parcelRegister("cu7Vs", function(module, exports) {

$parcel$export(module.exports, "fetchConfluenceUserPermissions", () => $c0391b42dbea5292$export$e1aee708fe0c56c2);

var $7f4tk = parcelRequire("7f4tk");
const $c0391b42dbea5292$export$e1aee708fe0c56c2 = async (cloudId)=>{
    const response = (0, $7f4tk.default)('/gateway/api/permissions/permitted', {
        method: 'POST',
        body: JSON.stringify({
            resourceId: `ari:cloud:confluence::site/${cloudId}`,
            permissionId: 'write'
        }),
        headers: {
            Accept: 'application/json'
        }
    });
    return response;
};

});

parcelRegister("cpyFY", function(module, exports) {

$parcel$export(module.exports, "getSessionStorageData", () => $bcceba29d01fe1ab$export$af84d82ff1eea56d);
$parcel$export(module.exports, "setSessionStorageData", () => $bcceba29d01fe1ab$export$be8cb7c8f1a1db6b);
$parcel$export(module.exports, "isStorageKeyExpired", () => $bcceba29d01fe1ab$export$59dd918a314efec0);
const $bcceba29d01fe1ab$var$createTTLTimestamp = (ttl)=>Date.now() + ttl;
const $bcceba29d01fe1ab$export$af84d82ff1eea56d = (key, storage)=>storage.get(key);
const $bcceba29d01fe1ab$export$be8cb7c8f1a1db6b = ({ key: key, value: value, ttl: ttl, storage: storage })=>{
    const expiresAt = $bcceba29d01fe1ab$var$createTTLTimestamp(ttl);
    storage.set(key, {
        ...value,
        expiresAt: expiresAt
    });
};
const $bcceba29d01fe1ab$export$59dd918a314efec0 = (key, storage)=>{
    if (!$bcceba29d01fe1ab$export$af84d82ff1eea56d(key, storage)) return true;
    const expiresAt = $bcceba29d01fe1ab$export$af84d82ff1eea56d(key, storage)?.expiresAt;
    return expiresAt ? new Date().getTime() >= expiresAt : true;
};
const $bcceba29d01fe1ab$export$47001de47bd4a961 = (key, storage)=>storage.remove(key);

});

parcelRegister("8o1o1", function(module, exports) {

$parcel$export(module.exports, "useEmbeddedPageTracking", () => $66febf67b379b5c1$export$9fcd107e4ed1de75);

var $5uXOq = parcelRequire("5uXOq");

var $2vSU6 = parcelRequire("2vSU6");

var $2gCtH = parcelRequire("2gCtH");

var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $j8Srb = parcelRequire("j8Srb");
const $66febf67b379b5c1$var$getParentProduct = (projectType)=>{
    switch(projectType){
        case 0, $2vSU6.SERVICE_DESK_PROJECT:
            return 'JSM';
        case 0, $2vSU6.SOFTWARE_PROJECT:
            return 'JSW';
        case 0, $2vSU6.CORE_PROJECT:
            return 'JWM';
        default:
            return 'JSW';
    }
};
const $66febf67b379b5c1$export$9fcd107e4ed1de75 = ()=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const source = (0, $2gCtH.useAnalyticsSource)();
    const trackEmbeddedConfluence = (0, $5uXOq.useCallback)(({ eventName: eventName, action: action, actionSubject: actionSubject, projectType: projectType, embeddedConfluenceSource: embeddedConfluenceSource = 'jiraIssueView', eventType: eventType = 'ui', userHasConfluenceAccess: userHasConfluenceAccess, tenantHasConfluence: tenantHasConfluence, crossJoinStatus: crossJoinStatus, originProduct: originProduct, requestedProduct: requestedProduct })=>{
        const analyticsEvent = createAnalyticsEvent({
            action: action,
            actionSubject: actionSubject ?? `${eventName}`
        });
        const attributes = {
            parentProduct: $66febf67b379b5c1$var$getParentProduct(projectType),
            tenantEditions: tenantContext?.appEditions,
            productEntitlementDetails: tenantContext?.productEntitlementDetails,
            embeddedConfluenceSource: embeddedConfluenceSource,
            jiraIssueSurfaceArea: source,
            userHasConfluenceAccess: userHasConfluenceAccess,
            tenantHasConfluence: tenantHasConfluence,
            crossJoinStatus: crossJoinStatus,
            originProduct: originProduct,
            requestedProduct: requestedProduct
        };
        (0, $j8Srb.fireEmbeddedConfluenceAnalytics)({
            analyticsEvent: analyticsEvent,
            attributes: attributes,
            eventType: eventType,
            eventName: `${actionSubject ?? eventName} ${action}`
        });
    }, [
        source,
        tenantContext,
        createAnalyticsEvent
    ]);
    return trackEmbeddedConfluence;
};

});
parcelRegister("j8Srb", function(module, exports) {

$parcel$export(module.exports, "fireEmbeddedConfluenceAnalytics", () => $da71518e42bc9539$export$864bc2da9014e8e9);

var $8zOmE = parcelRequire("8zOmE");
const $da71518e42bc9539$export$864bc2da9014e8e9 = ({ analyticsEvent: analyticsEvent, attributes: attributes, eventType: eventType, eventName: eventName })=>{
    switch(eventType){
        case 'ui':
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
        case 'operational':
            (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        case 'track':
            (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, `${eventName}`, attributes);
            break;
        default:
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, attributes);
            break;
    }
};

});



parcelRegister("9LoyA", function(module, exports) {

$parcel$export(module.exports, "useRetros", () => $27c0746d7d3517fa$export$70e27f56232e4ea8);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $bkZLr = parcelRequire("bkZLr");

var $c85ZN = parcelRequire("c85ZN");

const $27c0746d7d3517fa$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    initialState: $c85ZN.initialState,
    actions: $bkZLr.default,
    name: 'create-retros'
});
const $27c0746d7d3517fa$export$70e27f56232e4ea8 = (0, $3sQ5x.createHook)($27c0746d7d3517fa$export$390f32400eaf98c9);

});
parcelRegister("bkZLr", function(module, exports) {

$parcel$export(module.exports, "default", () => $48222d4aa85b1c99$export$2e2bcd8739ae039);

var $8LQ84 = parcelRequire("8LQ84");

var $1QOns = parcelRequire("1QOns");

var $agVdz = parcelRequire("agVdz");

var $jJZqs = parcelRequire("jJZqs");

var $4R6GH = parcelRequire("4R6GH");

var $42TYq = parcelRequire("42TYq");

var $b7gdg = parcelRequire("b7gdg");

var $c85ZN = parcelRequire("c85ZN");
const $48222d4aa85b1c99$var$resetState = ()=>({ setState: setState })=>{
        setState((0, $c85ZN.initialState));
    };
const $48222d4aa85b1c99$var$resetCreatedData = ()=>({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            ...state,
            createRetroPage: (0, $c85ZN.initialState).createRetroPage,
            createWhiteboard: (0, $c85ZN.initialState).createWhiteboard
        });
    };
const $48222d4aa85b1c99$var$setSprintId = (sprintId)=>({ setState: setState })=>{
        setState({
            sprintId: sprintId
        });
    };
const $48222d4aa85b1c99$var$setShouldCreateRetro = (shouldCreateRetro)=>({ setState: setState })=>{
        setState({
            shouldCreateRetro: shouldCreateRetro
        });
    };
const $48222d4aa85b1c99$var$setLoadCreateRetroModal = (loadCreateRetroModal)=>({ setState: setState })=>{
        setState({
            loadCreateRetroModal: loadCreateRetroModal
        });
    };
const $48222d4aa85b1c99$var$setLoadCrossFlowModal = (loadCrossFlowModal)=>({ setState: setState })=>{
        setState({
            loadCrossFlowModal: loadCrossFlowModal
        });
    };
const $48222d4aa85b1c99$var$setLoadCrossJoinModal = (loadCrossJoinModal)=>({ setState: setState })=>{
        setState({
            loadCrossJoinModal: loadCrossJoinModal
        });
    };
const $48222d4aa85b1c99$var$setIsRetroLinked = (isRetroLinked)=>({ setState: setState })=>{
        setState({
            isRetroLinked: isRetroLinked
        });
    };
const $48222d4aa85b1c99$var$setIsRetroLinking = (isRetroLinking)=>({ setState: setState })=>{
        setState({
            isRetroLinking: isRetroLinking
        });
    };
const $48222d4aa85b1c99$var$setRetroLinkingError = (retroLinkingError)=>({ setState: setState })=>{
        setState({
            retroLinkingError: retroLinkingError
        });
    };
const $48222d4aa85b1c99$var$setIsRetroPublished = (isRetroPublished)=>({ setState: setState })=>{
        setState({
            isRetroPublished: isRetroPublished
        });
    };
const $48222d4aa85b1c99$var$setConfluenceData = (data)=>({ getState: getState, setState: setState })=>{
        const { confluenceData: confluenceData } = getState();
        setState({
            confluenceData: {
                ...confluenceData,
                ...data
            }
        });
    };
const $48222d4aa85b1c99$var$setRetroType = (retroType)=>({ setState: setState })=>{
        setState({
            retroType: retroType
        });
    };
const $48222d4aa85b1c99$var$createRetroPage = (cloudId, spaceKey, parentPageId, sprintId, blueprintId)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createRetroPage: {
                ...state.createRetroPage,
                loading: true,
                error: undefined
            }
        });
        try {
            const retroPage = await (0, $42TYq.createRetro)(cloudId, spaceKey, parentPageId, sprintId, blueprintId, (0, $4R6GH.fg)('confluence_live_pages_enabled_in_jira'));
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    data: retroPage
                }
            });
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                createRetroPage: {
                    ...state.createRetroPage,
                    loading: false,
                    error: error
                }
            });
        }
    };
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $48222d4aa85b1c99$var$isConfluenceWhiteboardsError = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(error) && (0, (/*@__PURE__*/$parcel$interopDefault($8LQ84)))(error.errors) && // eslint-disable-next-line @typescript-eslint/no-explicit-any
    error.errors.every((e)=>(0, (/*@__PURE__*/$parcel$interopDefault($1QOns)))(e) && (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(e.title) && (0, (/*@__PURE__*/$parcel$interopDefault($agVdz)))(e.code));
const $48222d4aa85b1c99$var$isConfluenceWhiteboardsDisabled = async (error)=>{
    if (!(error instanceof (0, $jJZqs.default) && error.originalResponse)) return false;
    const errorResponse = await error.originalResponse.json();
    // Check for title until more specific error code is available (CBT-3079)
    return $48222d4aa85b1c99$var$isConfluenceWhiteboardsError(errorResponse) && errorResponse.errors[0].title === 'Whiteboards are not enabled';
};
const $48222d4aa85b1c99$var$createRetroWhiteboard = (cloudId, spaceId, parentId, templateKey)=>async ({ getState: getState, setState: setState })=>{
        const state = getState();
        setState({
            createWhiteboard: {
                ...state.createWhiteboard,
                loading: true,
                error: undefined
            }
        });
        try {
            const whiteboard = await (0, $b7gdg.createWhiteboard)(cloudId, spaceId, parentId, templateKey);
            setState({
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    data: whiteboard
                }
            });
        } catch (error) {
            setState({
                isWhiteboardsDisabled: state.isWhiteboardsDisabled || await $48222d4aa85b1c99$var$isConfluenceWhiteboardsDisabled(error),
                createWhiteboard: {
                    ...state.createWhiteboard,
                    loading: false,
                    error: error instanceof Error ? error : undefined
                }
            });
        }
    };
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$48222d4aa85b1c99$export$2e2bcd8739ae039 = {
    resetState: $48222d4aa85b1c99$var$resetState,
    resetCreatedData: $48222d4aa85b1c99$var$resetCreatedData,
    setSprintId: $48222d4aa85b1c99$var$setSprintId,
    setShouldCreateRetro: $48222d4aa85b1c99$var$setShouldCreateRetro,
    setLoadCreateRetroModal: $48222d4aa85b1c99$var$setLoadCreateRetroModal,
    setLoadCrossFlowModal: $48222d4aa85b1c99$var$setLoadCrossFlowModal,
    setLoadCrossJoinModal: $48222d4aa85b1c99$var$setLoadCrossJoinModal,
    setIsRetroLinked: $48222d4aa85b1c99$var$setIsRetroLinked,
    setIsRetroLinking: $48222d4aa85b1c99$var$setIsRetroLinking,
    setRetroLinkingError: $48222d4aa85b1c99$var$setRetroLinkingError,
    setIsRetroPublished: $48222d4aa85b1c99$var$setIsRetroPublished,
    setConfluenceData: $48222d4aa85b1c99$var$setConfluenceData,
    createRetroPage: $48222d4aa85b1c99$var$createRetroPage,
    setRetroType: $48222d4aa85b1c99$var$setRetroType,
    createRetroWhiteboard: $48222d4aa85b1c99$var$createRetroWhiteboard
};

});
parcelRegister("42TYq", function(module, exports) {

$parcel$export(module.exports, "createRetro", () => $f4242736fa792950$export$a63913da797715a6);

var $7f4tk = parcelRequire("7f4tk");


var $cYuHt = parcelRequire("cYuHt");
const $f4242736fa792950$export$a63913da797715a6 = async (cloudId, spaceKey, parentPageId, sprintId, blueprintId, isLiveDoc)=>{
    const [sprint] = await Promise.all([
        (0, $cYuHt.getSprint)(sprintId)
    ]);
    const title = `Retrospective: ${sprint.name}`;
    if (!blueprintId) throw new Error('User attempted to create a Confluence page retro, but no retro blueprint was found');
    return (0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/rest/create-dialog/1.0/content/blueprint/${(0, $63b79f4ff36af7f3$export$48a96ef844462313)}/instance`, {
        method: 'POST',
        body: JSON.stringify({
            content: {
                type: 'page',
                title: title,
                status: 'draft',
                ancestors: parentPageId ? [
                    {
                        id: parentPageId
                    }
                ] : undefined,
                space: {
                    key: spaceKey
                },
                // these values are required to create an NCS page
                metadata: {
                    properties: {
                        editor: {
                            value: 'v2'
                        }
                    },
                    frontend: {
                        embedded: true
                    }
                },
                ...isLiveDoc && {
                    subType: 'live'
                }
            },
            contentBlueprintSpec: {
                context: {
                    spaceKey: spaceKey,
                    parentPageId: parentPageId
                },
                blueprintId: blueprintId
            }
        })
    });
};

});
const $63b79f4ff36af7f3$export$48a96ef844462313 = 'com.atlassian.confluence.plugins.confluence-software-blueprints:retrospectives-blueprint';

parcelRegister("cYuHt", function(module, exports) {

$parcel$export(module.exports, "getSprint", () => $28d2a59892eb2d5b$export$4402d4ed26f26131);

var $7f4tk = parcelRequire("7f4tk");
const $28d2a59892eb2d5b$export$4402d4ed26f26131 = async (sprintId)=>(0, $7f4tk.default)(`/rest/agile/1.0/sprint/${sprintId}`);

});


parcelRegister("b7gdg", function(module, exports) {

$parcel$export(module.exports, "createWhiteboard", () => $ed7d58a2374be2eb$export$36ce0aac6b5c6804);

var $7f4tk = parcelRequire("7f4tk");
const $ed7d58a2374be2eb$export$36ce0aac6b5c6804 = async (cloudId, spaceId, parentId, templateKey)=>(0, $7f4tk.default)(`/gateway/api/ex/confluence/${cloudId}/wiki/api/v2/whiteboards`, {
        method: 'POST',
        body: JSON.stringify({
            spaceId: spaceId,
            parentId: parentId || null,
            templateKey: templateKey
        })
    });

});

parcelRegister("c85ZN", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $c4ef19a54ae6936a$export$d4c72bab9d6cc13a);

var $kGefV = parcelRequire("kGefV");
const $c4ef19a54ae6936a$export$d4c72bab9d6cc13a = {
    sprintId: undefined,
    shouldCreateRetro: false,
    loadCreateRetroModal: false,
    loadCrossFlowModal: false,
    loadCrossJoinModal: false,
    isRetroLinked: false,
    isRetroLinking: false,
    isRetroPublished: false,
    isWhiteboardsDisabled: false,
    retroLinkingError: undefined,
    retroType: (0, $kGefV.RetroTypes).WHITEBOARD,
    confluenceData: {
        spaceKey: undefined,
        parentPageId: undefined,
        spaceId: undefined
    },
    createRetroPage: {
        data: undefined,
        loading: false,
        error: undefined
    },
    createWhiteboard: {
        data: undefined,
        loading: false,
        error: undefined
    }
};

});
parcelRegister("kGefV", function(module, exports) {

$parcel$export(module.exports, "RetroTypes", () => $030b4200896d24ad$export$1da38a077679bab0);
const $030b4200896d24ad$export$1da38a077679bab0 = {
    WHITEBOARD: 'whiteboard',
    PAGE: 'page'
};

});





parcelRegister("bOsIL", function(module, exports) {

$parcel$export(module.exports, "completeSprintModalEntryPoint", () => $da8db933301c2e65$export$e19f219885fe8c5f);

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $j4C5v = parcelRequire("j4C5v");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $da8db933301c2e65$export$e19f219885fe8c5f = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aAjI0")), {
        moduleId: "3d417b0d"
    }),
    getPreloadProps: ({ jiraProjectAri: jiraProjectAri, updatedFromDeploymentsDate: updatedFromDeploymentsDate, boardId: boardId, activeSprintIds: activeSprintIds })=>({
            queries: {
                completeSprintMetadata: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $j4C5v.default,
                    variables: {
                        jiraProjectAri: jiraProjectAri,
                        updatedFromDeploymentsDate: updatedFromDeploymentsDate,
                        boardId: boardId,
                        activeSprintIds: activeSprintIds,
                        isCssReductionEnabled: // eslint-disable-next-line jira/ff/no-preconditioning
                        (0, $4R6GH.fg)('incomplete_issues_when_closing_a_sprint_gate') && (0, $6s1PB.expValEquals)('incomplete_issues_when_closing_a_sprint', 'cohort', 'test')
                    }
                }
            }
        })
});

});
parcelRegister("j4C5v", function(module, exports) {

$parcel$export(module.exports, "default", () => $65bc3007e99f5743$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<7bf9edb2c7b6d9d66214e51140f8e3c1>>
 * @relayHash 27527c08f2750b205f0c72f03077cd6e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fdad91f830d5bcb6a2dba58d5b2d28d9cceb4f17e31ee5115b4e9591b0f830ac
const $65bc3007e99f5743$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "fdad91f830d5bcb6a2dba58d5b2d28d9cceb4f17e31ee5115b4e9591b0f830ac",
        "metadata": {},
        "name": "mainCompleteSprintMetadataQuery",
        "operationKind": "query",
        "text": null
    }
};
var $65bc3007e99f5743$export$2e2bcd8739ae039 = $65bc3007e99f5743$var$node;

});

parcelRegister("aAjI0", function(module, exports) {

let $7b4c8df082673dee$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7b4c8df082673dee$var$load("1xx1S").then(()=>parcelRequire('4gPTd'));

});


parcelRegister("ayk9K", function(module, exports) {

$parcel$export(module.exports, "DisabledButtonHelper", () => $12f5cf9ffee1da1f$export$7407340f59537358);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $jldZL = parcelRequire("jldZL");

var $hCCtP = parcelRequire("hCCtP");

var $koVbs = parcelRequire("koVbs");

var $gWjRm = parcelRequire("gWjRm");

var $jBWTK = parcelRequire("jBWTK");
const $12f5cf9ffee1da1f$var$A11Y_HELPER_TEXT_ID = 'software-backlog.card-list.common.sprint-actions.disabled-button-helper.disabled-button-trigger.a11y-helper-text';
const $12f5cf9ffee1da1f$export$7407340f59537358 = (props)=>{
    const { children: children } = props;
    const [isDisabledButtonPopupOpen, setIsDisabledButtonPopupOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onDisabledButtonPopupClose = (0, $5uXOq.useCallback)(()=>{
        setIsDisabledButtonPopupOpen(false);
    }, []);
    const handleDisabledButtonClick = (0, $5uXOq.useCallback)(()=>{
        setIsDisabledButtonPopupOpen((prevState)=>!prevState);
    }, []);
    const disabledButtonTrigger = ({ ...triggerProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedButtonNew), {
            ...triggerProps,
            isSelected: isDisabledButtonPopupOpen,
            onClick: handleDisabledButtonClick,
            testId: "software-board.header.common.sprint-actions.disabled-button-helper.disabled-button-trigger",
            "aria-describedby": $12f5cf9ffee1da1f$var$A11Y_HELPER_TEXT_ID,
            "aria-disabled": true
        }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isDisabledButtonPopupOpen,
        onClose: onDisabledButtonPopupClose,
        content: (0, $gWjRm.default),
        trigger: disabledButtonTrigger,
        placement: "bottom-end",
        testId: "software-board.header.common.sprint-actions.disabled-button-helper.disabled-button-popup"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jldZL.default), {
        id: $12f5cf9ffee1da1f$var$A11Y_HELPER_TEXT_ID,
        testId: "software-board.header.common.sprint-actions.disabled-button-helper.a-11-y-sr-text"
    }, formatMessage((0, $jBWTK.messages).disabledButtonHelperHeading), "\xa0", formatMessage((0, $jBWTK.messages).disabledButtonHelperBody)));
};

});
parcelRegister("gWjRm", function(module, exports) {

$parcel$export(module.exports, "default", () => $293b471ca2ad9fab$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $l1N8i = parcelRequire("l1N8i");

var $a3mGm = parcelRequire("a3mGm");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $jBWTK = parcelRequire("jBWTK");
const $293b471ca2ad9fab$var$DisabledButtonContent = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        xcss: $293b471ca2ad9fab$var$widthWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($a3mGm))), {
        spacing: "spacious",
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockStart: "space.050"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xsmall",
        as: "h2"
    }, formatMessage((0, $jBWTK.messages).disabledButtonHelperHeading))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $jBWTK.messages).disabledButtonHelperBody))));
};
const $293b471ca2ad9fab$var$widthWrapperStyles = (0, $8CUq3.xcss)({
    /**
   * fixed width to keep title on a single line
   */ width: '410px',
    padding: 'space.250'
});
var $293b471ca2ad9fab$export$2e2bcd8739ae039 = $293b471ca2ad9fab$var$DisabledButtonContent;

});
parcelRegister("a3mGm", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::766864a6ad12ee0b57d7ed41e0a75cca>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $751bc76853fe58bc$var$_react = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $751bc76853fe58bc$var$_lockLocked = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("bwyQI")));

var $751bc76853fe58bc$var$_lock = $751bc76853fe58bc$var$_interopRequireDefault((parcelRequire("3G2gB")));
function $751bc76853fe58bc$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for LockLockedIcon.
 * This component is LockLockedIcon, with `UNSAFE_fallbackIcon` set to "LockIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $751bc76853fe58bc$var$LockLockedIcon = (props)=>/*#__PURE__*/ $751bc76853fe58bc$var$_react.default.createElement($751bc76853fe58bc$var$_lockLocked.default, Object.assign({
        LEGACY_fallbackIcon: $751bc76853fe58bc$var$_lock.default
    }, props));
$751bc76853fe58bc$var$LockLockedIcon.Name = 'LockLockedIconMigration';
var $751bc76853fe58bc$var$_default = module.exports.default = $751bc76853fe58bc$var$LockLockedIcon;

});
parcelRegister("bwyQI", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::86c9de42fef4ccbc35a6164a0094138a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $863db7350f859785$var$_react = $863db7350f859785$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $863db7350f859785$var$_baseNew = $863db7350f859785$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $863db7350f859785$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "LockLocked".
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: secure password in textfields, locked page in Confluence.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $863db7350f859785$var$LockLockedIcon = (props)=>/*#__PURE__*/ $863db7350f859785$var$_react.default.createElement($863db7350f859785$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5A2.5 2.5 0 0 0 5.5 4v3h5V4A2.5 2.5 0 0 0 8 1.5M12 7V4a4 4 0 0 0-8 0v3a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2M4 8.5a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V9a.5.5 0 0 0-.5-.5zM7.25 13v-3h1.5v3z" clip-rule="evenodd"/>`
    }, props));
$863db7350f859785$var$LockLockedIcon.displayName = 'LockLockedIcon';
var $863db7350f859785$var$_default = module.exports.default = $863db7350f859785$var$LockLockedIcon;

});

parcelRegister("3G2gB", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $2ad70d7fd26028c0$var$_react = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $2ad70d7fd26028c0$var$_lockLocked = $2ad70d7fd26028c0$var$_interopRequireDefault((parcelRequire("bwyQI")));
function $2ad70d7fd26028c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $2ad70d7fd26028c0$var$LockIcon = (props)=>/*#__PURE__*/ $2ad70d7fd26028c0$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M16 11V9h-2V7.002A2 2 0 0 0 12 5c-1.102 0-2 .898-2 2.002V9H8v2H7v8h10v-8zm-2 0h-4V9h4zM8 9V7.002A4.004 4.004 0 0 1 12 3a4 4 0 0 1 4 4.002V9h.994A2.01 2.01 0 0 1 19 11.009v7.982c0 1.11-.897 2.009-2.006 2.009H7.006A2.01 2.01 0 0 1 5 18.991V11.01C5 9.899 5.897 9 7.006 9zm0 0h2v2H8zm6 0h2v2h-2z"/><circle cx="12" cy="15" r="2"/></g></svg>`
    }, props, {
        newIcon: $2ad70d7fd26028c0$var$_lockLocked.default
    }));
$2ad70d7fd26028c0$var$LockIcon.displayName = 'LockIcon';
var $2ad70d7fd26028c0$var$_default = module.exports.default = $2ad70d7fd26028c0$var$LockIcon;

});


parcelRegister("jBWTK", function(module, exports) {

$parcel$export(module.exports, "messages", () => $fc2900df644b4df1$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $fc2900df644b4df1$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    disabledButtonHelperHeading: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button-disabled-info-heading",
        "defaultMessage": "You don't have 'Manage sprints' permission"
    },
    disabledButtonHelperBody: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button-disabled-info-body",
        "defaultMessage": "Ask an administrator to grant you the permission for all projects in the board filter."
    }
});

});



parcelRegister("lguBA", function(module, exports) {

$parcel$export(module.exports, "default", () => $28a5b44185024b93$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28a5b44185024b93$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    completeSprintButton: {
        "id": "software.main.header.complete-sprint-button.complete-sprint-button",
        "defaultMessage": "Complete sprint"
    }
});

});



parcelRegister("3SShY", function(module, exports) {

$parcel$export(module.exports, "default", () => $acd9e78f3f54051f$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $dC5iT = parcelRequire("dC5iT");
var $kgoHi = parcelRequire("kgoHi");
var $h9kUS = parcelRequire("h9kUS");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $2ZySJ = parcelRequire("2ZySJ");

var $iDGXn = parcelRequire("iDGXn");

var $1393U = parcelRequire("1393U");

var $k9JTq = parcelRequire("k9JTq");

var $dCm1o = parcelRequire("dCm1o");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $7CMCs = parcelRequire("7CMCs");

var $3O3s8 = parcelRequire("3O3s8");

var $2xFXk = parcelRequire("2xFXk");

var $gKBVc = parcelRequire("gKBVc");

var $63LqY = parcelRequire("63LqY");

var $67sX6 = parcelRequire("67sX6");

var $69EQQ = parcelRequire("69EQQ");

var $9eTg7 = parcelRequire("9eTg7");

var $5mTgl = parcelRequire("5mTgl");

var $7Nu6k = parcelRequire("7Nu6k");

var $ikdur = parcelRequire("ikdur");

var $fUeOV = parcelRequire("fUeOV");

var $hkLPk = parcelRequire("hkLPk");

var $7Nytu = parcelRequire("7Nytu");

var $fjK71 = parcelRequire("fjK71");
const $acd9e78f3f54051f$var$ControlsBar = ({ rapidViewId: rapidViewId, isSprintsEnabled: isSprintsEnabled, hasActiveSprint: hasActiveSprint, customFiltersQueryRef: customFiltersQueryRef, boardFilterRefinementQueryRef: boardFilterRefinementQueryRef, leftHandSideActions: leftHandSideActions, showCardDetails: showCardDetails = true, isActiveStandup: isActiveStandup, setIsActiveStandup: setIsActiveStandup, boardType: boardType, children: children })=>{
    const appEditions = (0, $k9JTq.useAppEditions)();
    const showInsightsButton = !isSprintsEnabled || hasActiveSprint;
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isFilterBarVisible = (0, $iDGXn.useShowQuickFilters)();
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const shouldRenderFullscreenMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_FULLSCREEN_MENU_ITEM);
    const shouldRenderFullscreenButton = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_FULLSCREEN_BUTTON);
    const isEmbedView = (0, $gKBVc.useIsEmbedView)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const isStandupDisabled = (0, $9eTg7.shouldDisableStandup)({
        boardType: boardType,
        isSprintsEnabled: isSprintsEnabled,
        hasActiveSprint: hasActiveSprint
    });
    const shouldShowNewRefinementBar = (0, $67sX6.useBoardSelector)((0, $5mTgl.isFilterRefinementEnabled));
    const shouldRenderGroupBy = ()=>{
        /**
     * Increment Planning board only has one swimlane grouping - Team (rendered by default).
     * We don't allow users to switch to a different grouping therefore we're not rendering the SwimlaneSwitcher.
     */ if (isIncrementPlanningBoard) return false;
        return true;
    };
    /*
   * lg and above -> filter bar grows, actions do not shrink or grow. Actions at full size.
   * will adapt to screen size by putting things into more.
   * md -> lg: filter bar has basis of 70%, actions shrink and wrap onto two lines (with small buttons grouped together) if they can't fit in the remaining space.
   * sm and below -> actions grow and wraps above the filter bar. Filter bar and actions grow.
   */ if (isTabNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: (0, $lmBAt.getIsSoftwareThemingM2Enabled)('blurry-background') ? $acd9e78f3f54051f$var$outerBoxStyles : $acd9e78f3f54051f$var$outerBoxStylesOld
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $acd9e78f3f54051f$var$combinedFilterAndActionStyles,
        testId: "software-board.header.controls-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $acd9e78f3f54051f$var$filterBarWrapperStyles
    }, shouldShowNewRefinementBar ? boardFilterRefinementQueryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acd9e78f3f54051f$var$ErrorBoundaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nu6k.BoardFilterRefinement), {
        boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
        isActiveStandup: isActiveStandup
    })) : /* @ts-expect-error - TS2741 - Property 'screenName' is missing in type '{ customFiltersQueryRef: PreloadedQuery<viewBoardCustomFiltersQuery, Record<string, unknown>> | null | undefined; }' */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikdur.default), {
        isActiveStandup: isActiveStandup,
        customFiltersQueryRef: customFiltersQueryRef
    }), isFilterBarVisible && isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUeOV.default), null)), (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $acd9e78f3f54051f$var$rightSideActionsStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        justifyContent: "end",
        alignItems: "center"
    }, leftHandSideActions, shouldRenderGroupBy() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nytu.default), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), (0, $lmBAt.getIsSoftwareThemingEnabled)() && {
        isThemed: isSoftwareFullTheming
    }), showInsightsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69EQQ.default), {
        boardId: rapidViewId,
        edition: appEditions.software,
        isSprintsEnabled: isSprintsEnabled
    }), !shouldRenderFullscreenMenuItem && shouldRenderFullscreenButton && !isEmbedView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkLPk.FullscreenButton), {
        boardId: Number(rapidViewId),
        shouldRenderContent: !isActiveStandup
    }), !isIncrementPlanningBoard && isJSWBoard && isActiveStandup && (0, $6s1PB.expVal)('jira-in-product-standups', 'is_enabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1393U.StandupControlButtons), {
        isStandupDisabled: isStandupDisabled,
        isActiveStandup: isActiveStandup,
        setIsActiveStandup: setIsActiveStandup,
        boardId: Number(rapidViewId)
    }), !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjK71.default), {
        showCardDetails: showCardDetails
    })), !isActiveStandup && children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $acd9e78f3f54051f$var$rightSideActionsStyles
    }, shouldRenderGroupBy() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nytu.default), null), leftHandSideActions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        justifyContent: "end",
        alignItems: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), (0, $lmBAt.getIsSoftwareThemingEnabled)() && {
        isThemed: isSoftwareFullTheming
    }), showInsightsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69EQQ.default), {
        boardId: rapidViewId,
        edition: appEditions.software,
        isSprintsEnabled: isSprintsEnabled
    }), !shouldRenderFullscreenMenuItem && shouldRenderFullscreenButton && !isEmbedView && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkLPk.FullscreenButton), {
        boardId: Number(rapidViewId),
        shouldRenderContent: !isActiveStandup
    }), !isIncrementPlanningBoard && isJSWBoard && (0, $6s1PB.expVal)('jira-in-product-standups', 'is_enabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1393U.StandupControlButtons), {
        isStandupDisabled: isStandupDisabled,
        isActiveStandup: isActiveStandup,
        setIsActiveStandup: setIsActiveStandup,
        boardId: Number(rapidViewId)
    }), !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjK71.default), {
        showCardDetails: showCardDetails
    })), !isActiveStandup && children)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $acd9e78f3f54051f$var$styles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        gap: "space.100",
        justifyContent: "end",
        alignItems: "center",
        testId: "software-board.header.controls-bar"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acd9e78f3f54051f$var$FilterBarWrapper, null, shouldShowNewRefinementBar ? boardFilterRefinementQueryRef && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($acd9e78f3f54051f$var$ErrorBoundaryWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nu6k.BoardFilterRefinement), {
        boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
        isActiveStandup: isActiveStandup
    })) : /* @ts-expect-error - TS2741 - Property 'screenName' is missing in type '{ customFiltersQueryRef: PreloadedQuery<viewBoardCustomFiltersQuery, Record<string, unknown>> | null | undefined; }' */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ikdur.default), {
        isActiveStandup: isActiveStandup,
        customFiltersQueryRef: customFiltersQueryRef
    })), shouldRenderGroupBy() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Nytu.default), null), leftHandSideActions, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2ZySJ.ImportWorkButton), (0, $lmBAt.getIsSoftwareThemingEnabled)() && {
        isThemed: isSoftwareFullTheming
    }), showInsightsButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $69EQQ.default), {
        boardId: rapidViewId,
        edition: appEditions.software,
        isSprintsEnabled: isSprintsEnabled
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjK71.default), {
        showCardDetails: showCardDetails
    }), children), isFilterBarVisible && isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fUeOV.default), null));
};
const $acd9e78f3f54051f$var$ErrorBoundaryWrapper = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-filter-refinement",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        sendToPrivacyUnsafeSplunk: true,
        // eslint-disable-next-line jira/react-no-inline-function-prop
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3O3s8.default), null)
    }, children);
var $acd9e78f3f54051f$export$2e2bcd8739ae039 = $acd9e78f3f54051f$var$ControlsBar;
const $acd9e78f3f54051f$var$outerBoxStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.200',
    position: 'relative'
});
const $acd9e78f3f54051f$var$outerBoxStylesOld = (0, $8CUq3.xcss)({
    marginBottom: 'space.200'
});
const $acd9e78f3f54051f$var$styles = (0, $8CUq3.xcss)({
    marginBottom: 'space.400'
});
const $acd9e78f3f54051f$var$filterBarWrapperStyles = (0, $8CUq3.xcss)({
    flex: '1 1 auto',
    display: 'flex',
    flexDirection: 'column',
    // minimum width required for expanded search + More button + clear filters
    minWidth: '468px',
    justifyContent: 'end'
});
const $acd9e78f3f54051f$var$rightSideActionsStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    flex: '1 0 auto',
    gap: 'space.100',
    justifyContent: 'flex-end',
    alignItems: 'start'
});
const $acd9e78f3f54051f$var$combinedFilterAndActionStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    justifyContent: 'space-between',
    gap: 'space.100',
    flexWrap: 'wrap-reverse',
    alignItems: 'stretch',
    [(0, $h9kUS.media).above.lg]: {
        flexWrap: 'nowrap'
    }
});
// If updating this component, also update filterBarWrapperStyles
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $acd9e78f3f54051f$var$FilterBarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul9idpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2ZySJ", function(module, exports) {

$parcel$export(module.exports, "ImportWorkButton", () => $650ab30d4dd366bc$export$311dc74043c51081);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $kxZPA = parcelRequire("kxZPA");

var $lfTZh = parcelRequire("lfTZh");

var $4R6GH = parcelRequire("4R6GH");


var $8kda3 = parcelRequire("8kda3");

const $650ab30d4dd366bc$export$1d333e4178627a87 = (0, $kxZPA.lazy)(()=>(parcelRequire("k1rmU")).then(({ ImportWorkButtonInternal: ImportWorkButtonInternal })=>ImportWorkButtonInternal), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-invites/src/ui/import-work-button/index.tsx"
});
const $650ab30d4dd366bc$var$ImportWorkButtonWithTargeting = ({ isThemed: isThemed })=>{
    const isTargeted = (0, $8kda3.useIsTargetedForRaisingAwarenessOfImporter)();
    const inner = isTargeted ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($650ab30d4dd366bc$export$1d333e4178627a87, {
        isThemed: isThemed
    }) : null;
    if ((0, $4R6GH.fg)('jfp-magma-fix-misaligned-suspense-boundaries')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "ImportWorkButtonWithTargeting"
    }, inner);
    return inner;
};
const $650ab30d4dd366bc$export$311dc74043c51081 = ({ isThemed: isThemed })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "importWorkButton",
        packageName: (0, $daef8268a41061ca$export$b8b9d90f9e5bd72b),
        teamName: (0, $daef8268a41061ca$export$d57b6b390e78d90f),
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($650ab30d4dd366bc$var$ImportWorkButtonWithTargeting, {
        isThemed: isThemed
    }));

});
const $daef8268a41061ca$export$b8b9d90f9e5bd72b = 'jiraSoftwareOnboardingInvites';
const $daef8268a41061ca$export$d57b6b390e78d90f = 'jlove-makkuro';
const $daef8268a41061ca$export$719991a6cc456f06 = 'software-onboarding-invites.ui.import-work-button.button';

parcelRegister("8kda3", function(module, exports) {

$parcel$export(module.exports, "useIsTargetedForRaisingAwarenessOfImporter", () => $8571e29361584ab7$export$c45655b60f7ebf1c);

var $2vSU6 = parcelRequire("2vSU6");

var $9y6jE = parcelRequire("9y6jE");

var $dAfqg = parcelRequire("dAfqg");

var $ldyPw = parcelRequire("ldyPw");

var $k9JTq = parcelRequire("k9JTq");

var $cNd4s = parcelRequire("cNd4s");
const $8571e29361584ab7$export$c45655b60f7ebf1c = ()=>{
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const { software: edition } = (0, $k9JTq.useAppEditions)();
    const isWithin30Day = (0, $9y6jE.useIsFirstActivationDateWithinLast30Days)();
    const isSoftwareProject = data?.projectType === (0, $2vSU6.SOFTWARE_PROJECT);
    return data?.simplified && isSiteAdmin && isWithin30Day && edition === (0, $ldyPw.FREE_EDITION) && isSoftwareProject;
};

});
parcelRegister("9y6jE", function(module, exports) {

$parcel$export(module.exports, "useIsFirstActivationDateWithinLast30Days", () => $e7cd4e878e1b25bc$export$f561835faf21b733);

var $dkqym = parcelRequire("dkqym");

var $at4B6 = parcelRequire("at4B6");
const $e7cd4e878e1b25bc$export$f561835faf21b733 = ()=>{
    const firstActivationDate = (0, $dkqym.useFirstActivationDateMs)();
    return (0, $at4B6.isWithinLast30Days)(firstActivationDate);
};

});
parcelRegister("at4B6", function(module, exports) {

$parcel$export(module.exports, "isWithinLast30Days", () => $6d4f0d42d84e1d91$export$550dea1ca60eaa64);

var $iS3m6 = parcelRequire("iS3m6");
const $6d4f0d42d84e1d91$export$550dea1ca60eaa64 = (0, $iS3m6.isWithinLast)({
    days: 30
});

});
parcelRegister("iS3m6", function(module, exports) {

$parcel$export(module.exports, "isWithinLast", () => $8541d32f174f7876$export$15bc1a874225842d);

var $59y5F = parcelRequire("59y5F");

var $dQChl = parcelRequire("dQChl");

var $2xkYZ = parcelRequire("2xkYZ");
const $8541d32f174f7876$export$15bc1a874225842d = (duration)=>(date)=>{
        if (!(0, $59y5F.default)(date)) return false;
        const end = Date.now();
        const start = (0, $2xkYZ.default)(duration)(end);
        // `isValid` precludes a nullable date.
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return (0, $dQChl.default)({
            start: start,
            end: end
        })(date);
    };

});




parcelRegister("k1rmU", function(module, exports) {

let $e93921727731164a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e93921727731164a$var$load("etx49").then(()=>parcelRequire('eK5YJ'));

});


parcelRegister("1393U", function(module, exports) {

$parcel$export(module.exports, "StandupControlButtons", () => $a4b50c953e845558$export$effd663aaa9a2bf4);

var $5uXOq = parcelRequire("5uXOq");

var $bPA7p = parcelRequire("bPA7p");

var $4t4Ir = parcelRequire("4t4Ir");
const $a4b50c953e845558$export$effd663aaa9a2bf4 = ({ isActiveStandup: isActiveStandup, setIsActiveStandup: setIsActiveStandup, isStandupDisabled: isStandupDisabled, boardId: boardId, render: render })=>{
    return isActiveStandup ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bPA7p.EndStandupButton), {
        render: render,
        setIsActiveStandup: setIsActiveStandup,
        boardId: boardId
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4t4Ir.StartStandupButton), {
        render: render,
        isStandupDisabled: isStandupDisabled,
        setIsActiveStandup: setIsActiveStandup,
        boardId: boardId
    });
};

});
parcelRegister("bPA7p", function(module, exports) {

$parcel$export(module.exports, "EndStandupButton", () => $f6c7407ca4cb16c0$export$2709cff9d915e6db);

var $5uXOq = parcelRequire("5uXOq");

var $hCCtP = parcelRequire("hCCtP");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $dCm1o = parcelRequire("dCm1o");

var $gbfZY = parcelRequire("gbfZY");
const $f6c7407ca4cb16c0$export$2709cff9d915e6db = ({ setIsActiveStandup: setIsActiveStandup, boardId: boardId, render: render })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { setIsFullscreen: setIsFullscreenNav3 } = (0, $iDGXn.useViewSettingsActions)();
    const [, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const exitFullscreen = (0, $5uXOq.useCallback)(()=>{
        (0, $3HwlS.getWillShowNav4)() ? setIsFullscreen(false) : setIsFullscreenNav3({
            boardId: boardId,
            isFullscreen: false,
            view: (0, $a4XJc.View).BOARD
        });
    }, [
        boardId,
        setIsFullscreen,
        setIsFullscreenNav3
    ]);
    const handleExitStandupOld = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'exitStandup');
        exitFullscreen();
        setIsActiveStandup(false);
    };
    const handleExitStandup = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), 'exitStandup');
        exitFullscreen();
        setIsActiveStandup(false);
    };
    if (render && (0, $dCm1o.isVisualRefreshEnabled)()) return render({
        isDisabled: false,
        onClick: handleExitStandup,
        label: formatMessage((0, $gbfZY.default).endStandupButton)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedButtonNew), {
        onClick: (__, analyticsEvent)=>handleExitStandupOld(analyticsEvent)
    }, formatMessage((0, $gbfZY.default).endStandupButton));
};

});
parcelRegister("gbfZY", function(module, exports) {

$parcel$export(module.exports, "default", () => $af19942960201f27$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $af19942960201f27$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    endStandupButton: {
        "id": "standups.control-buttons.end-standup-button.end-standup-button",
        "defaultMessage": "End stand-up"
    }
});

});


parcelRegister("4t4Ir", function(module, exports) {

$parcel$export(module.exports, "StartStandupButton", () => $a39a5cfe8dd462a1$export$fe5db2ceb09d92ff);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $dCm1o = parcelRequire("dCm1o");

var $hCCtP = parcelRequire("hCCtP");

var $47gW9 = parcelRequire("47gW9");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $5E2gE = parcelRequire("5E2gE");

var $lIeg9 = parcelRequire("lIeg9");
const $a39a5cfe8dd462a1$export$fe5db2ceb09d92ff = ({ setIsActiveStandup: setIsActiveStandup, isStandupDisabled: isStandupDisabled, boardId: boardId, render: render })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { entryPointActions: entryPointActions } = (0, $5uXOq.useContext)((0, $5E2gE.StandupEntryPointContext));
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const { setIsFullscreen: setIsFullscreenNav3 } = (0, $iDGXn.useViewSettingsActions)();
    const [, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const enterFullscreen = (0, $5uXOq.useCallback)(()=>{
        (0, $3HwlS.getWillShowNav4)() ? setIsFullscreen(true) : setIsFullscreenNav3({
            boardId: boardId,
            isFullscreen: true,
            view: (0, $a4XJc.View).BOARD
        });
    }, [
        boardId,
        setIsFullscreen,
        setIsFullscreenNav3
    ]);
    const handleStartStandupOld = (analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'startStandup');
        enterFullscreen();
        setIsActiveStandup(true);
    };
    const handleStartStandup = ()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked',
            source: `jiraStandupsStartStandupButton${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`
        }), 'startStandup');
        enterFullscreen();
        setIsActiveStandup(true);
    };
    if (render && (0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jiraStandupsStartStandupButton",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, render({
        isDisabled: isStandupDisabled,
        ref: triggerRef,
        onClick: handleStartStandup,
        label: formatMessage((0, $lIeg9.default).startStandupButton)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            isStandupDisabled: isStandupDisabled
        }
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "jiraStandupsStartStandupButton",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isStandupDisabled ? formatMessage((0, $lIeg9.default).disabledButtonTooltip) : null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedButtonNew), {
        isDisabled: isStandupDisabled,
        ref: triggerRef,
        onClick: (__, analyticsEvent)=>handleStartStandupOld(analyticsEvent)
    }, formatMessage((0, $lIeg9.default).startStandupButton))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
        attributes: {
            isStandupDisabled: isStandupDisabled
        }
    }));
};

});
parcelRegister("5E2gE", function(module, exports) {

$parcel$export(module.exports, "StandupEntryPointContext", () => $87450d443c36211f$export$66552b8e540e0b2b);
$parcel$export(module.exports, "StandupEntryPointContextProvider", () => $87450d443c36211f$export$943440c649300e6f);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $l37qh = parcelRequire("l37qh");

var $1mezY = parcelRequire("1mezY");
const $87450d443c36211f$export$66552b8e540e0b2b = (0, $l37qh.createUseEntryPointContext)();
const $87450d443c36211f$export$943440c649300e6f = ({ children: children })=>{
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $1mezY.jiraStandupEntryPoint), {});
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87450d443c36211f$export$66552b8e540e0b2b.Provider, {
        value: entryPointResult
    }, children);
};

});
parcelRegister("1mezY", function(module, exports) {

$parcel$export(module.exports, "jiraStandupEntryPoint", () => $20b2e16533aca3fb$export$e1b42fdba7af5e78);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $20b2e16533aca3fb$export$e1b42fdba7af5e78 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("k99kg")), {
        moduleId: "1749eef2"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("k99kg", function(module, exports) {

let $eaabe1ce35e1f3ae$var$load = (parcelRequire("28QjX"))(4);
module.exports = $eaabe1ce35e1f3ae$var$load("kk1YF").then(()=>parcelRequire('eN97g'));

});



parcelRegister("lIeg9", function(module, exports) {

$parcel$export(module.exports, "default", () => $c302fcb244bfcbe4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c302fcb244bfcbe4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    startStandupButton: {
        "id": "standups.control-buttons.start-standup-button.start-standup-button",
        "defaultMessage": "Start stand-up"
    },
    disabledButtonTooltip: {
        "id": "standups.control-buttons.start-standup-button.disabled-button-tooltip",
        "defaultMessage": "A sprint needs to be started in the backlog before you can begin stand-up"
    }
});

});



parcelRegister("3O3s8", function(module, exports) {

$parcel$export(module.exports, "default", () => $f8f72a115d570c0b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $hMVoD = parcelRequire("hMVoD");

var $5ILhZ = parcelRequire("5ILhZ");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $4CzTQ = parcelRequire("4CzTQ");
const $f8f72a115d570c0b$export$19cde72f8d0f2573 = (_, analyticsEvent)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterRefinementRefreshButton');
    if (typeof window !== 'undefined') window.location.reload();
};
const $f8f72a115d570c0b$var$ErrorComponent = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.100",
        xcss: $f8f72a115d570c0b$var$errorComponentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        label: "",
        color: "var(--ds-icon-danger, #C9372C)"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $4CzTQ.default).errorMessage, {
        link: (linkText)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ILhZ.default), {
                onClick: $f8f72a115d570c0b$export$19cde72f8d0f2573,
                xcss: $f8f72a115d570c0b$var$linkStyles
            }, linkText)
    })));
};
const $f8f72a115d570c0b$var$linkStyles = (0, $8CUq3.xcss)({
    color: 'color.link',
    textDecoration: 'underline',
    font: "var(--ds-font-body, normal 400 14px/20px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)",
    backgroundColor: 'color.background.neutral.subtle',
    padding: 'space.0',
    ':hover': {
        textDecoration: 'none'
    },
    ':active': {
        color: 'color.link.pressed'
    }
});
const $f8f72a115d570c0b$var$errorComponentStyles = (0, $8CUq3.xcss)({
    height: '32px'
});
var $f8f72a115d570c0b$export$2e2bcd8739ae039 = $f8f72a115d570c0b$var$ErrorComponent;

});
parcelRegister("4CzTQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $c6aef8777c285e5c$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c6aef8777c285e5c$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorMessage: {
        "id": "filter-refinement.filter-popup.error.error-message",
        "defaultMessage": "Something went wrong. <link>Refresh the page</link> and try again."
    }
});

});


parcelRegister("69EQQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $31b988c799e1e8c3$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $bC2fB = parcelRequire("bC2fB");

var $2ON1s = parcelRequire("2ON1s");

var $k8auG = parcelRequire("k8auG");

var $6g14V = parcelRequire("6g14V");

var $hNzgP = parcelRequire("hNzgP");
const $31b988c799e1e8c3$var$mapStateToProps = (state, ownProps)=>({
        isInsightsPanelOpen: (0, $6g14V.getInsightsPanel)(state),
        boardId: ownProps.boardId,
        edition: ownProps?.edition,
        isSprintsEnabled: ownProps.isSprintsEnabled,
        isHeaderCompactMode: (0, $k8auG.getIsHeaderCompactMode)(state)
    });
const $31b988c799e1e8c3$var$mapDispatchToProps = {
    onToggleInsightsPanel: (0, $2ON1s.togglePanel)
};
var $31b988c799e1e8c3$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($31b988c799e1e8c3$var$mapStateToProps, $31b988c799e1e8c3$var$mapDispatchToProps)((0, $hNzgP.InsightsButton));

});
parcelRegister("hNzgP", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $c976da2056b8fe89$export$95e4a3c3bc863d9c);

var $5uXOq = parcelRequire("5uXOq");

var $4IRtU = parcelRequire("4IRtU");

var $5HeQO = parcelRequire("5HeQO");

var $7BuUr = parcelRequire("7BuUr");

var $dAfqg = parcelRequire("dAfqg");

var $046Kp = parcelRequire("046Kp");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $2xFXk = parcelRequire("2xFXk");


var $2ON1s = parcelRequire("2ON1s");

var $67sX6 = parcelRequire("67sX6");

var $63LqY = parcelRequire("63LqY");
const $c976da2056b8fe89$var$InsightsButtonCommon = (props)=>{
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isVisibleForSoftware = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_INSIGHT_BUTTON);
    const isVisibleForServiceDesk = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_JSM_BOARD_INSIGHT_BUTTON);
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const closeViewSettingsPanelAction = (0, $67sX6.useBoardActionCreator)(()=>(0, $2ON1s.closeViewSettingsPanel)());
    const { isInsightsPanelOpen: isInsightsPanelOpen, onToggleInsightsPanel: onToggleInsightsPanel, boardId: boardId, edition: edition, isSprintsEnabled: isSprintsEnabled, isHeaderCompactMode: isHeaderCompactMode } = props;
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const onToggleInsightsPanelHandler = (0, $5uXOq.useCallback)(()=>{
        onToggleInsightsPanel((0, $8cd646738f5ee7ac$export$29d7f2210b16d662));
        closeViewSettingsPanelAction();
    }, [
        closeViewSettingsPanelAction,
        onToggleInsightsPanel
    ]);
    if (!isSupported) return null;
    // this is only because of flow, it will never happen
    if (!edition) return null;
    if (isVisibleForServiceDesk) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $046Kp.ServicedeskBoardInsightsButton), {
        isSimplifiedProject: !isCMPBoard,
        isOpen: isInsightsPanelOpen,
        boardId: Number(boardId),
        edition: edition,
        projectId: project?.projectId,
        onToggle: onToggleInsightsPanelHandler,
        ...(0, $lmBAt.getIsSoftwareThemingEnabled)() && {
            isThemed: isSoftwareFullTheming
        }
    });
    if (isVisibleForSoftware) {
        if (isSprintsEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4IRtU.BoardInsightsButton), {
            isSimplifiedProject: !isCMPBoard,
            isOpen: isInsightsPanelOpen,
            isCompact: isHeaderCompactMode,
            boardId: Number(boardId),
            edition: edition,
            onToggle: onToggleInsightsPanelHandler,
            ...(0, $lmBAt.getIsSoftwareThemingEnabled)() && {
                isThemed: isSoftwareFullTheming
            }
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5HeQO.KanbanBoardInsightsButton), {
            isSimplifiedProject: !isCMPBoard,
            isOpen: isInsightsPanelOpen,
            isCompact: isHeaderCompactMode,
            boardId: Number(boardId),
            edition: edition,
            onToggle: onToggleInsightsPanelHandler,
            ...(0, $lmBAt.getIsSoftwareThemingEnabled)() && {
                isThemed: isSoftwareFullTheming
            }
        });
    }
    return null;
};
const $c976da2056b8fe89$export$95e4a3c3bc863d9c = $c976da2056b8fe89$var$InsightsButtonCommon;

});
parcelRegister("4IRtU", function(module, exports) {

$parcel$export(module.exports, "BoardInsightsButton", () => $28fa7d49554cc6cb$export$804ff759e12a79a5);

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $3bDjY = parcelRequire("3bDjY");

var $ioD1B = parcelRequire("ioD1B");

var $6s1PB = parcelRequire("6s1PB");

var $4Fbrj = parcelRequire("4Fbrj");


var $9Y7dM = parcelRequire("9Y7dM");


var $9YlLW = parcelRequire("9YlLW");

var $7BuUr = parcelRequire("7BuUr");

var $0241A = parcelRequire("0241A");

var $6OlO8 = parcelRequire("6OlO8");

var $cOddg = parcelRequire("cOddg");

var $1UEsW = parcelRequire("1UEsW");

var $gkPFQ = parcelRequire("gkPFQ");

var $2KxPr = parcelRequire("2KxPr");

var $6f6NP = parcelRequire("6f6NP");

var $ebnTF = parcelRequire("ebnTF");

var $apoVO = parcelRequire("apoVO");

var $g5uUm = parcelRequire("g5uUm");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");

var $l60Zc = parcelRequire("l60Zc");

var $hCKQh = parcelRequire("hCKQh");
const $28fa7d49554cc6cb$var$BoardInsightsButtonComponent = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId, isThemed: isThemed })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const [isOnboardingApplicable, setIsOnboardingApplicable] = (0, $5uXOq.useState)(false);
    const markOnboardingApplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(true), []);
    const markOnboardingInapplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(false), []);
    const [isDueDatePulseActive, setisDueDatePulseActive] = (0, $5uXOq.useState)(false);
    const { coordinationClient: coordinationClient, shouldStartPulse: shouldStartPulse, stopPulse: stopPulse } = (0, $9YlLW.useDueDatePulse)();
    const [messageFinished, setIsMessageFinished] = (0, $5uXOq.useState)(false);
    const [{ info: { isAnyLevelOfAdmin: isAnyLevelOfAdmin, isProjectType: isProjectType, uniqueId: uniqueId }, data: { hasPermission: hasPermission } }, { onDataUpdatedCallback: onDataUpdatedCallback, refreshUniqueId: refreshUniqueId, updateIsDeepLinking: updateIsDeepLinking }] = (0, $6f6NP.useInsightsContainer)();
    const [, { doUpdate: doUpdate }] = (0, $6f6NP.useInsightsContainer)();
    const onDismissClickHandler = (0, $5uXOq.useCallback)(()=>{
        setIsMessageFinished(true);
        stopPulse(true);
    }, [
        stopPulse
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        isOpen,
        updateIsDeepLinking
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) {
            if (messageFinished) doUpdate({
                isPulsing: false
            });
        }
        if (shouldStartPulse) {
            setisDueDatePulseActive(true);
            doUpdate({
                isPulsing: true
            });
        } else if (messageFinished) setisDueDatePulseActive(false);
    }, [
        doUpdate,
        isOpen,
        messageFinished,
        shouldStartPulse
    ]);
    // refresh experience when insights (panel) is closed
    (0, $0241A.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    const currentPermissionStatus = (0, $ebnTF.getTextValue)(hasPermission, (0, $9Y7dM.permissionStatus).LOADING);
    const renderTooltip = (0, $5uXOq.useCallback)(({ children: children })=>{
        const message = (0, $6s1PB.expVal)('jira_enable_insights_terminology_refresh', 'isEnabled', false) ? formatMessage((0, $hCKQh.default).tooltipTerminologyRefresh) : formatMessage((0, $hCKQh.default).tooltip);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: message
        }, children);
    }, [
        formatMessage
    ]);
    const isPulseShowing = isDueDatePulseActive && !messageFinished;
    // eslint-disable-next-line no-nested-ternary
    const location = (0, $6s1PB.expVal)('jira_enable_insights_terminology_refresh', 'isEnabled', false) ? (0, $f43e6cbc56ecd5ed$export$a26d014939cffdb) : (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $f43e6cbc56ecd5ed$export$9fd46aa549776647) : undefined;
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            boardId: boardId,
            frameworkType: (0, $4Fbrj.boardType).SCRUM,
            edition: edition,
            experienceId: uniqueId,
            projectId: projectId,
            userLocation: userLocation
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkPFQ.InsightsSpotlight), {
        onOpenInsightsPanel: ()=>!isOpen && onToggle(),
        onDismiss: markOnboardingInapplicable,
        isOnboardingApplicable: isOnboardingApplicable
    }), currentPermissionStatus === (0, $9Y7dM.permissionStatus).LOADING && (isSimplifiedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckSimplifiedDataPermission), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckClassicViewAggregatedDataPermission), {
        boardId: boardId,
        userLocation: userLocation,
        onPermissionLoaded: onDataUpdatedCallback('hasPermission'),
        onInsightsEnabledWithoutPermission: markOnboardingApplicable
    })), isPulseShowing && (0, $6s1PB.expVal)('jira_enable_due_date_ifa', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button-due-date-tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: shouldStartPulse,
        onClick: ()=>onDismissClickHandler()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        isInsightsPanelOpen: isOpen,
        isCompact: isCompact,
        boardId: boardId,
        onToggle: onToggle,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        renderTooltip: renderTooltip,
        location: location,
        isThemed: isThemed
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        isInsightsPanelOpen: isOpen,
        isCompact: isCompact,
        boardId: boardId,
        onToggle: onToggle,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        renderTooltip: renderTooltip,
        location: location,
        isThemed: isThemed
    }))) : null;
};
const $28fa7d49554cc6cb$var$BoardInsightsButtonWithContainer = (props)=>{
    const scope = (0, $6OlO8.buildBoardScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apoVO.InsightsContainer), {
        scope: scope,
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28fa7d49554cc6cb$var$BoardInsightsButtonComponent, props));
};
const $28fa7d49554cc6cb$var$BoardInsightsButtonFinal = $28fa7d49554cc6cb$var$BoardInsightsButtonWithContainer;
const $28fa7d49554cc6cb$var$SafeBoardInsightsButton = (0, $2KxPr.withComponentSafety)($28fa7d49554cc6cb$var$BoardInsightsButtonFinal, {
    condition: ({ boardId: boardId })=>(0, $9YlLW.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $l60Zc.BOARD_BUTTON_ID),
    message: ({ boardId: boardId })=>`Board button received invalid boardId: ${boardId}`
});
const $28fa7d49554cc6cb$export$804ff759e12a79a5 = (0, $1UEsW.WithInsightsErrorBoundary)($28fa7d49554cc6cb$var$SafeBoardInsightsButton, (0, $b0e6fec6a4686296$export$1269ea4f2b198811), (0, $b0e6fec6a4686296$export$d3996f57ffa8448f));

});
parcelRegister("4Fbrj", function(module, exports) {

$parcel$export(module.exports, "JIRA_INSIGHTS", () => $fea73e8d1542f4b4$export$74798a8d8755efe8);
$parcel$export(module.exports, "INSIGHTS_BEACON", () => $fea73e8d1542f4b4$export$36aafe55be325e9c);
$parcel$export(module.exports, "INSIGHTS_PANEL", () => $fea73e8d1542f4b4$export$29d7f2210b16d662);
$parcel$export(module.exports, "EXPERIENCE_TIMEOUT_MILLIS", () => $fea73e8d1542f4b4$export$b50c2fb16a87be63);
$parcel$export(module.exports, "DATA_FETCH_ACTION", () => $fea73e8d1542f4b4$export$4857a322416ea6fc);
$parcel$export(module.exports, "CLIENT_ERROR", () => $fea73e8d1542f4b4$export$cb2bfe2a50a1ece2);
$parcel$export(module.exports, "RENDER_ACTION", () => $fea73e8d1542f4b4$export$e902262516430940);
$parcel$export(module.exports, "dataFetchSuccess", () => $fea73e8d1542f4b4$export$d392c424a6c74b59);
$parcel$export(module.exports, "dataFetchFail", () => $fea73e8d1542f4b4$export$8d035b8b8e3383e);
$parcel$export(module.exports, "INSIGHTS_PANEL_EXPERIENCE", () => $fea73e8d1542f4b4$export$3ea7cf58d679b8d9);
$parcel$export(module.exports, "ERROR_BOUNDARY_HIT", () => $fea73e8d1542f4b4$export$680b36a84ba453e0);
$parcel$export(module.exports, "boardType", () => $fea73e8d1542f4b4$export$6796f2a60fb31770);
$parcel$export(module.exports, "BOARD_KANBAN_PANEL_EXPERIENCE", () => $fea73e8d1542f4b4$export$36467f64abcaaaa5);
$parcel$export(module.exports, "INSIGHTS_BUTTON", () => $fea73e8d1542f4b4$export$28ab2964530cf411);
$parcel$export(module.exports, "INSIGHTS_BUTTON_LG", () => $fea73e8d1542f4b4$export$8a355daa8d0cf830);
$parcel$export(module.exports, "INSIGHTS_BUTTON_SM", () => $fea73e8d1542f4b4$export$f8c16af1b950b647);
$parcel$export(module.exports, "INSIGHTS_BUTTON_RESPONSIVE", () => $fea73e8d1542f4b4$export$e80ae42ddabf80c5);

const $fea73e8d1542f4b4$export$74798a8d8755efe8 = (0, $b0e6fec6a4686296$export$d3996f57ffa8448f);
const $fea73e8d1542f4b4$export$36aafe55be325e9c = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.beacon`;
const $fea73e8d1542f4b4$export$29d7f2210b16d662 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.panel`;
const $fea73e8d1542f4b4$export$8a1dfa6c0a610c5f = `${$fea73e8d1542f4b4$export$29d7f2210b16d662}.help`;
const $fea73e8d1542f4b4$export$956c91960ecaaf52 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.location`;
const $fea73e8d1542f4b4$export$b50c2fb16a87be63 = 60000;
const $fea73e8d1542f4b4$export$4857a322416ea6fc = 'dataFetch';
const $fea73e8d1542f4b4$export$cb2bfe2a50a1ece2 = 'clientError';
const $fea73e8d1542f4b4$export$e902262516430940 = 'render';
const $fea73e8d1542f4b4$export$d392c424a6c74b59 = {
    successful: true
};
const $fea73e8d1542f4b4$export$8d035b8b8e3383e = {
    successful: false
};
const $fea73e8d1542f4b4$export$3ea7cf58d679b8d9 = 'panel';
const $fea73e8d1542f4b4$export$680b36a84ba453e0 = 'error-boundary-hit';
const $fea73e8d1542f4b4$export$6796f2a60fb31770 = {
    SCRUM: 'scrum',
    KANBAN: 'kanban'
};
const $fea73e8d1542f4b4$export$36467f64abcaaaa5 = `${$fea73e8d1542f4b4$export$74798a8d8755efe8}.board.${$fea73e8d1542f4b4$export$6796f2a60fb31770.KANBAN}-panel`;
const $fea73e8d1542f4b4$export$28ab2964530cf411 = 'insights-show-insights-button.ui.insights-button';
const $fea73e8d1542f4b4$export$8a355daa8d0cf830 = 'insights-show-insights-button.ui.insights-button-large';
const $fea73e8d1542f4b4$export$f8c16af1b950b647 = 'insights-show-insights-button.ui.insights-button-small';
const $fea73e8d1542f4b4$export$e80ae42ddabf80c5 = 'insights-show-insights-button.ui.insights-button-responsive';

});

parcelRegister("9Y7dM", function(module, exports) {

$parcel$export(module.exports, "permissionStatus", () => $0d3bfc9bd66c1fa3$export$b7019a8563593449);
const $0d3bfc9bd66c1fa3$export$b7019a8563593449 = {
    LOADING: 'LOADING',
    ALLOWED: 'ALLOWED',
    DISALLOWED: 'DISALLOWED'
};

});

const $f43e6cbc56ecd5ed$export$596021054ee994de = 'backlog';
const $f43e6cbc56ecd5ed$export$20548c7afd11b51e = 'kanban';
const $f43e6cbc56ecd5ed$export$a26d014939cffdb = 'scrum';
const $f43e6cbc56ecd5ed$export$7278886766e0567e = 'backlog-visual-refresh';
const $f43e6cbc56ecd5ed$export$c54b080144f4f954 = 'kanban-visual-refresh';
const $f43e6cbc56ecd5ed$export$9fd46aa549776647 = 'scrum-visual-refresh';

parcelRegister("9YlLW", function(module, exports) {

$parcel$export(module.exports, "getMessageFromEstimationUnit", () => $74b4eed620b03a26$export$680a8efbdf2f2020);
$parcel$export(module.exports, "getCommonMessageDescriptorFromEstimationUnit", () => $74b4eed620b03a26$export$c0f3281b1c14f2e6);
$parcel$export(module.exports, "getEstimatedUnit", () => $74b4eed620b03a26$export$120f64ac447e3a5a);
$parcel$export(module.exports, "getUpdatedEstimation", () => $74b4eed620b03a26$export$5ec90264a55fd048);
$parcel$export(module.exports, "getPermissionEnum", () => $74b4eed620b03a26$export$8e09a9f3c4b56097);
$parcel$export(module.exports, "isValidBoardId", () => $74b4eed620b03a26$export$e168d1e9d0082d6a);
$parcel$export(module.exports, "useDueDatePulse", () => $74b4eed620b03a26$export$9698ff82f4fc10e6);

var $5uXOq = parcelRequire("5uXOq");

var $e4eHl = parcelRequire("e4eHl");

var $kbqIt = parcelRequire("kbqIt");

var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");


var $cpUUk = parcelRequire("cpUUk");

var $koeKL = parcelRequire("koeKL");

var $8uXQO = parcelRequire("8uXQO");
const $74b4eed620b03a26$export$680a8efbdf2f2020 = ({ estimationUnit: estimationUnit, messages: messages })=>{
    if (!messages[estimationUnit]) throw new Error(`Unsupported estimationUnit: ${estimationUnit} for ${JSON.stringify(messages)}`);
    return messages[estimationUnit];
};
const $74b4eed620b03a26$export$c0f3281b1c14f2e6 = (estimationUnit)=>{
    let issueTermRefreshSuffix = '';
    if (estimationUnit === 'ISSUE_COUNT' && (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false)) issueTermRefreshSuffix = 'IssueTermRefresh';
    const estimationUnitCamelCase = (0, (/*@__PURE__*/$parcel$interopDefault($e4eHl)))(estimationUnit);
    const labelDescriptorName = `${estimationUnitCamelCase}Label${issueTermRefreshSuffix}`;
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    if (!(0, $8uXQO.messages)[labelDescriptorName]) throw new Error(`Unsupported estimationUnit: ${estimationUnit}, label not found for ${labelDescriptorName}} in ${JSON.stringify(Object.keys((0, $8uXQO.messages)))}`);
    // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ issueCountLabel: MessageDescriptorV2; storyPointsLabel: MessageDescriptorV2; timeOriginalEstimateLabel: MessageDescriptorV2; sprints: MessageDescriptorV2; issueCount: MessageDescriptorV2; storyPoints: MessageDescriptorV2; }'.
    return (0, $8uXQO.messages)[labelDescriptorName];
};
const $74b4eed620b03a26$export$120f64ac447e3a5a = (estimationUnit, estimation)=>{
    // these endpoints returning null shouldn't happen, so let's degrade gracefully
    switch(estimationUnit){
        case (0, $cpUUk.EstimationUnit).ISSUE_COUNT:
            return estimation.issueCount || 0;
        case (0, $cpUUk.EstimationUnit).STORY_POINTS:
            return estimation.storyPoints != null ? parseFloat(estimation.storyPoints.toFixed(1)) : 0;
        case (0, $cpUUk.EstimationUnit).TIME_TRACKING:
            return estimation.time || 0;
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74b4eed620b03a26$export$5ec90264a55fd048 = (estimationUnit, estimation, value)=>{
    switch(estimationUnit){
        case (0, $cpUUk.EstimationUnit).ISSUE_COUNT:
            return {
                ...estimation,
                issueCount: value
            };
        case (0, $cpUUk.EstimationUnit).STORY_POINTS:
            return {
                ...estimation,
                storyPoints: value
            };
        case (0, $cpUUk.EstimationUnit).TIME_TRACKING:
            return {
                ...estimation,
                time: value
            };
        default:
            throw new Error(`Unexpected estimation type: ${estimationUnit}`);
    }
};
const $74b4eed620b03a26$export$8e09a9f3c4b56097 = (value, defaultValue)=>value === null || value === undefined ? defaultValue : value;
const $74b4eed620b03a26$export$8081780e7051e8dd = (boardId)=>`print-halfway-alert-${boardId ?? (0, $b298cf836b53195d$export$bc8ae8b96c2da16b)}`;
const $74b4eed620b03a26$export$9eca4630c417f1b = (boardId)=>`auto-expand-halfway-alert-${boardId ?? (0, $b298cf836b53195d$export$bc8ae8b96c2da16b)}`;
const $74b4eed620b03a26$export$e168d1e9d0082d6a = ({ boardId: boardId })=>{
    // BoardId must be a positive integer
    if (boardId === undefined || boardId === null || // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    !(Number.isInteger(boardId) && boardId > 0)) return false;
    return true;
};
const $74b4eed620b03a26$export$2e033b8f7ea3f02a = ({ boardId: boardId })=>{
    if (typeof boardId !== 'string') return false;
    return /^[0-9]+$/.test(boardId) && Number.parseInt(boardId, 10) > 0;
};
const $74b4eed620b03a26$export$9698ff82f4fc10e6 = ()=>{
    const DUE_DATE_EXPERIMENT_ENGAGEMENT_ID = 'jira-insights-due-tab-button-pulse';
    const STARGATE_URL = '/gateway/api';
    const cloudId = (0, $koeKL.useCloudId)();
    const coordinationClient = (0, $5uXOq.useMemo)(// eslint-disable-next-line jira/choreographer/choreographer-context-required
    ()=>new (0, $eGLgs.CoordinationClient)(cloudId, STARGATE_URL, false, '', 'engagement'), [
        cloudId
    ]);
    const [shouldStartPulse, stopPulse] = (0, $kbqIt.useCoordination)(coordinationClient, DUE_DATE_EXPERIMENT_ENGAGEMENT_ID);
    return {
        coordinationClient: coordinationClient,
        shouldStartPulse: shouldStartPulse,
        stopPulse: stopPulse
    };
};

});
const $b298cf836b53195d$export$5c425db6689b9aae = 'no-account-id';
const $b298cf836b53195d$export$bc8ae8b96c2da16b = 'no-board-id';

parcelRegister("cpUUk", function(module, exports) {

$parcel$export(module.exports, "EstimationUnit", () => $e74c6047a4f07896$export$65cc899e447718b8);
const $e74c6047a4f07896$export$65cc899e447718b8 = {
    STORY_POINTS: 'STORY_POINTS',
    ISSUE_COUNT: 'ISSUE_COUNT',
    TIME_TRACKING: 'TIME_TRACKING',
    OTHER: 'OTHER'
};
const $e74c6047a4f07896$export$c17e0027053340c = 'OTHER';

});

parcelRegister("8uXQO", function(module, exports) {

$parcel$export(module.exports, "messages", () => $34dd4dbb16b250cb$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $34dd4dbb16b250cb$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    storyPoints: {
        "id": "insights-common.common.story-points",
        "defaultMessage": "{value, plural, one {point} other {points}}"
    },
    issueCount: {
        "id": "insights-common.common.issue-count",
        "defaultMessage": "{value, plural, one {issue} other {issues}}"
    },
    sprints: {
        "id": "insights-common.common.sprints",
        "defaultMessage": "{sprintCount, plural, one {sprint} other {sprints}}"
    },
    timeTrackingLabel: {
        "id": "insights-common.common.time-tracking-label",
        "defaultMessage": "time estimation"
    },
    storyPointsLabel: {
        "id": "insights-common.common.story-points-label",
        "defaultMessage": "story points"
    },
    issueCountLabel: {
        "id": "insights-common.common.issue-count-label",
        "defaultMessage": "issue count"
    },
    issueCountIssueTermRefresh: {
        "id": "insights-common.common.issue-count-issue-term-refresh",
        "defaultMessage": "{value, plural, one {work item} other {work items}}"
    },
    issueCountLabelIssueTermRefresh: {
        "id": "insights-common.common.issue-count-label-issue-term-refresh",
        "defaultMessage": "work item count"
    }
});

});


parcelRegister("7BuUr", function(module, exports) {

$parcel$export(module.exports, "useIsCurrentBrowserSupported", () => $8c56e783e1a84cd8$export$e2f83ae69f04608f);

var $5uXOq = parcelRequire("5uXOq");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8c56e783e1a84cd8$var$isDefined = (value)=>value !== null && value !== undefined;
const $8c56e783e1a84cd8$var$isCurrentBrowserSupported = ()=>{
    // Supported from:
    // Chrome 66
    // Safari 12.1
    // Edge 16
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (!$8c56e783e1a84cd8$var$isDefined(window?.AbortController)) return false;
    return true;
};
const $8c56e783e1a84cd8$export$e2f83ae69f04608f = ()=>{
    const isSupported = (0, $5uXOq.useMemo)(()=>$8c56e783e1a84cd8$var$isCurrentBrowserSupported(), []);
    return isSupported;
};

});

parcelRegister("0241A", function(module, exports) {

$parcel$export(module.exports, "useValueChangeEffect", () => $bc4d44bb107dee16$export$7dd9a2cc149d56b3);

var $5uXOq = parcelRequire("5uXOq");
const $bc4d44bb107dee16$export$7dd9a2cc149d56b3 = ({ listener: listener, callback: callback }, deps = [])=>{
    const previous = (0, $5uXOq.useRef)(listener);
    (0, $5uXOq.useEffect)(()=>{
        if (listener !== previous.current) callback(listener, previous.current);
        previous.current = listener;
    /* We do not memoize the callback as this will change every render
		 * But it is important to pass in all dependencies used in the callback */ // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        listener,
        ...deps
    ]);
};

});

parcelRegister("6OlO8", function(module, exports) {

$parcel$export(module.exports, "buildBoardScopeName", () => $9fd1aa0f281e7d95$export$7cfa8d622acbc99f);
$parcel$export(module.exports, "buildBacklogScopeName", () => $9fd1aa0f281e7d95$export$68610636ce5df399);

const $9fd1aa0f281e7d95$export$7cfa8d622acbc99f = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $b0e6fec6a4686296$export$8e66b21ec141a0bd) : (0, $b0e6fec6a4686296$export$c9290acd1ba498ff)}-boardId:${boardId}`;
const $9fd1aa0f281e7d95$export$68610636ce5df399 = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $b0e6fec6a4686296$export$75eb9639a5b0ba25) : (0, $b0e6fec6a4686296$export$2fd6d7f902b01d67)}-boardId:${boardId}`;

});

parcelRegister("cOddg", function(module, exports) {

$parcel$export(module.exports, "CheckClassicViewAggregatedDataPermission", () => $09f9796263d4f1f9$export$379f6e97a42d4a9d);
$parcel$export(module.exports, "CheckSimplifiedDataPermission", () => $09f9796263d4f1f9$export$b5e65dc6f010c84c);

var $5uXOq = parcelRequire("5uXOq");

var $4R6GH = parcelRequire("4R6GH");


var $9Y7dM = parcelRequire("9Y7dM");

var $dfjss = parcelRequire("dfjss");

var $iuEfD = parcelRequire("iuEfD");

var $6WV5x = parcelRequire("6WV5x");

var $47u1P = parcelRequire("47u1P");

var $7aoh6 = parcelRequire("7aoh6");
const $09f9796263d4f1f9$export$379f6e97a42d4a9d = ({ boardId: boardId, userLocation: userLocation, onPermissionLoaded: onPermissionLoaded, onInsightsEnabledWithoutPermission: onInsightsEnabledWithoutPermission })=>{
    const eventFrom = (0, $dfjss.getBoardOrBacklogFromLocation)(userLocation);
    const actionSubject = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${eventFrom}`;
    const [{ data: hasPermission, loading: loading, fetched: fetched, aborted: aborted, hasError: hasError }] = (0, $iuEfD.useFetch)({
        onFetch: (options)=>(0, $6WV5x.fetchInsightPermission)({
                boardId: boardId
            }, options),
        browserMetricsKey: `${actionSubject}.${(0, $7aoh6.INSIGHT_PERMISSION_ACTION_SUBJECT_ID)}`,
        analyticsTracking: {
            actionSubject: `${actionSubject}.${(0, $7aoh6.INSIGHT_PERMISSION_ACTION_SUBJECT_ID)}`,
            packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
        },
        loggingKey: (0, $7aoh6.INSIGHT_PERMISSION_ACTION_SUBJECT_ID)
    }, []);
    const [_, setShouldUseJQLData] = (0, $47u1P.useLocalStorage)((0, $7aoh6.USE_JQL_STORAGE).namespace, (0, $7aoh6.USE_JQL_STORAGE).key, {
        defaultValue: false
    });
    (0, $5uXOq.useEffect)(()=>{
        if (loading) onPermissionLoaded((0, $9Y7dM.permissionStatus).LOADING);
        if (fetched && !hasError && !aborted) {
            if (hasPermission) {
                onPermissionLoaded((0, $9Y7dM.permissionStatus).ALLOWED);
                setShouldUseJQLData((0, $4R6GH.fg)('insights-use_jql_query_for_enabled_users'));
            } else {
                onPermissionLoaded((0, $9Y7dM.permissionStatus).ALLOWED);
                onInsightsEnabledWithoutPermission?.();
                setShouldUseJQLData(true);
            }
        }
        if (hasError || aborted) onPermissionLoaded((0, $9Y7dM.permissionStatus).DISALLOWED);
    }, [
        fetched,
        loading,
        aborted,
        hasPermission,
        hasError,
        onPermissionLoaded,
        setShouldUseJQLData,
        onInsightsEnabledWithoutPermission
    ]);
    return null;
};
const $09f9796263d4f1f9$export$b5e65dc6f010c84c = ()=>{
    const [_, setShouldUseJQLData] = (0, $47u1P.useLocalStorage)('jira-insights-should-use-jql', 'shouldUseJQLQuery', {
        defaultValue: false
    });
    (0, $5uXOq.useEffect)(()=>{
        setShouldUseJQLData((0, $4R6GH.fg)('insights-use_jql_query_for_enabled_users'));
    }, [
        setShouldUseJQLData
    ]);
    return null;
};

});
parcelRegister("dfjss", function(module, exports) {

$parcel$export(module.exports, "getBoardOrBacklogFromLocation", () => $8952e8de617aa53a$export$bb6a57ca7b7487bb);

const $8952e8de617aa53a$var$locations = {
    [(0, $b117e2ebd359768a$export$743304c0b847bdee)]: (0, $b117e2ebd359768a$export$dedbdcc35e955187),
    [(0, $b117e2ebd359768a$export$47ae5cd4a7ee5f2a)]: (0, $b117e2ebd359768a$export$dedbdcc35e955187),
    [(0, $b117e2ebd359768a$export$40705e2848d2f6a5)]: (0, $b117e2ebd359768a$export$9b8283d5878d2491),
    [(0, $b117e2ebd359768a$export$f995350d8da9bb90)]: (0, $b117e2ebd359768a$export$9b8283d5878d2491)
};
const $8952e8de617aa53a$export$bb6a57ca7b7487bb = (userLocation)=>// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly "software:software-backlog": "backlog"; readonly "classic-software:rapidboard-backlog": "backlog"; readonly "software:software-boards": "board"; readonly "classic-software:rapidboard-board": "board"; }'.
    $8952e8de617aa53a$var$locations[userLocation] || (0, $b117e2ebd359768a$export$5f4028218eaee319);

});
const $b117e2ebd359768a$export$dedbdcc35e955187 = 'backlog';
const $b117e2ebd359768a$export$9b8283d5878d2491 = 'board';
const $b117e2ebd359768a$export$5f4028218eaee319 = 'unknown';
const $b117e2ebd359768a$export$47ae5cd4a7ee5f2a = 'classic-software:rapidboard-backlog';
const $b117e2ebd359768a$export$f995350d8da9bb90 = 'classic-software:rapidboard-board';
const $b117e2ebd359768a$export$743304c0b847bdee = 'software:software-backlog';
const $b117e2ebd359768a$export$40705e2848d2f6a5 = 'software:software-boards';


parcelRegister("6WV5x", function(module, exports) {

$parcel$export(module.exports, "fetchInsightPermission", () => $3d7ce849d39a845d$export$a465feaffcf65c97);

var $48DMb = parcelRequire("48DMb");
const $3d7ce849d39a845d$export$a465feaffcf65c97 = async ({ boardId: boardId }, options)=>{
    const response = await (0, $48DMb.fetchJson)(`/rest/internal/board/${boardId}/insight-permission`, options);
    return response && response.allowed;
};

});

parcelRegister("47u1P", function(module, exports) {

$parcel$export(module.exports, "useLocalStorage", () => $4772a73a96e71e67$export$86e2cef2561044ac);
$parcel$export(module.exports, "useLocalStorageWithExpiry", () => $4772a73a96e71e67$export$9c89ac8256e92fbb);

var $5uXOq = parcelRequire("5uXOq");

var $bSSG7 = parcelRequire("bSSG7");
const $4772a73a96e71e67$var$isSetStateFunction = (setStateAction)=>typeof setStateAction === 'function';
const $4772a73a96e71e67$export$86e2cef2561044ac = (namespace, key, options)=>{
    const localStorage = (0, $bSSG7.createLocalStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$9c89ac8256e92fbb = (namespace, key, ttlInMs, options)=>{
    const localStorage = (0, $bSSG7.createLocalExpirableStorageProvider)(namespace);
    const initialValue = localStorage.get(key) ?? options?.defaultValue;
    // used to trigger re-render of components
    const [value, setValueInState] = (0, $5uXOq.useState)(initialValue);
    const setValue = (0, $5uXOq.useCallback)((setStateAction)=>{
        if ($4772a73a96e71e67$var$isSetStateFunction(setStateAction)) setValueInState((prevVal)=>{
            const newVal = setStateAction(prevVal);
            localStorage.set(key, newVal, Date.now() + ttlInMs);
            return newVal;
        });
        else {
            localStorage.set(key, setStateAction, Date.now() + ttlInMs);
            setValueInState(setStateAction);
        }
    }, [
        key,
        localStorage,
        ttlInMs
    ]);
    return [
        value,
        setValue
    ];
};
const $4772a73a96e71e67$export$436c2fd92113c067 = (namespace, key, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$86e2cef2561044ac(namespace, key, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};
const $4772a73a96e71e67$export$db70e245473ac2a = (namespace, key, ttlInMs, options)=>{
    const [state, setState] = $4772a73a96e71e67$export$9c89ac8256e92fbb(namespace, key, ttlInMs, options);
    return [
        state,
        // This is for batch update
        (objectKey, value)=>setState((prevState)=>({
                    ...prevState,
                    [objectKey]: value
                }))
    ];
};

});

parcelRegister("7aoh6", function(module, exports) {

$parcel$export(module.exports, "INSIGHT_PERMISSION_ACTION_SUBJECT_ID", () => $4de57a9072cf4c55$export$5dad270161d08a8c);
$parcel$export(module.exports, "USE_JQL_STORAGE", () => $4de57a9072cf4c55$export$36d083914f36b177);
const $4de57a9072cf4c55$export$5dad270161d08a8c = 'check-insight-permission';
const $4de57a9072cf4c55$export$36d083914f36b177 = {
    namespace: 'jira-insights-should-use-jql',
    key: 'shouldUseJQLQuery'
};

});


parcelRegister("1UEsW", function(module, exports) {

$parcel$export(module.exports, "WithInsightsErrorBoundary", () => $0d7082c2a6c6ecc7$export$b240a041e4bface8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $7CMCs = parcelRequire("7CMCs");

var $93jKl = parcelRequire("93jKl");

var $1OjhZ = parcelRequire("1OjhZ");

var $4Fbrj = parcelRequire("4Fbrj");


var $1s62S = parcelRequire("1s62S");
const $0d7082c2a6c6ecc7$var$insightsExperience = {
    experience: (0, $4Fbrj.JIRA_INSIGHTS)
};
const $0d7082c2a6c6ecc7$export$eff352405fe6db90 = ({ id: id, packageName: packageName, children: children, onError: onError = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: id,
        packageName: packageName,
        teamName: "helios-headcoach",
        fallback: "flag",
        onError: onError
    }, children);
};
const $0d7082c2a6c6ecc7$var$BaseInsightsErrorBoundaryWithExperienceTracker = ({ children: children })=>{
    const onFail = (0, $93jKl.useExperienceFail)($0d7082c2a6c6ecc7$var$insightsExperience);
    const { fail: fail } = (0, $1s62S.useInsightsExperience)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
        id: (0, $b0e6fec6a4686296$export$1269ea4f2b198811),
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f),
        onError: (...args)=>{
            onFail(...args);
            const [, error] = args;
            fail((0, $4Fbrj.ERROR_BOUNDARY_HIT), error);
        }
    }, children);
};
const $0d7082c2a6c6ecc7$export$cf848bf84642a299 = ({ children: children, experienceIdsToTrack: experienceIdsToTrack = [] })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1s62S.InsightsExperienceTracker), {
        experienceId: (0, $4Fbrj.INSIGHTS_PANEL_EXPERIENCE),
        experienceIdsToCollect: experienceIdsToTrack || [],
        timeoutInMs: (0, $4Fbrj.EXPERIENCE_TIMEOUT_MILLIS),
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1OjhZ.ExperienceTrackerProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$var$BaseInsightsErrorBoundaryWithExperienceTracker, null, children)));
const $0d7082c2a6c6ecc7$export$b240a041e4bface8 = (Component, id, packageName)=>(props)=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0d7082c2a6c6ecc7$export$eff352405fe6db90, {
            id: id,
            packageName: packageName
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props));
    };

});
parcelRegister("1s62S", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTracker", () => $86531a62d14892a7$export$9c32e0183f3330c4);
$parcel$export(module.exports, "useInsightsExperience", () => $86531a62d14892a7$export$6a440957407835a0);
$parcel$export(module.exports, "StartInsightsExperience", () => $86531a62d14892a7$export$d8f7e3f6742303b4);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");

var $dfjss = parcelRequire("dfjss");

var $cfDZ3 = parcelRequire("cfDZ3");

var $30KM0 = parcelRequire("30KM0");

var $2Siis = parcelRequire("2Siis");

var $eUcR1 = parcelRequire("eUcR1");

var $2B9C9 = parcelRequire("2B9C9");

var $bSClU = parcelRequire("bSClU");

var $dfzOH = parcelRequire("dfzOH");
const $86531a62d14892a7$export$9c32e0183f3330c4 = ({ ufoExperience: ufoExperience, experienceId: experienceId, experienceIdsToCollect: experienceIdsToCollect, timeoutInMs: timeoutInMs = (0, $30KM0.TIMEOUT_IN_MS), attributes: attributes, children: children, packageName: packageName })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const eventFrom = (0, $dfjss.getBoardOrBacklogFromLocation)(userLocation);
    const ufoErrorLogger = (0, $dfzOH.useUfoErrorLogger)({
        eventFrom: eventFrom,
        ufoExperience: ufoExperience
    });
    const insightsPackage = packageName;
    const insightsExperience = `${insightsPackage}.${eventFrom}.${experienceId}`;
    const metricsTracker = (0, $bSClU.useMetricsMemo)(()=>{
        const browserMetricsKey = `${insightsExperience}.${(0, $30KM0.experiences).RENDER}`;
        const metricsAttributes = {
            ...attributes,
            userLocation: userLocation
        };
        const service = (0, $eUcR1.trackBrowserMetricsForJira)({
            browserMetricsKey: browserMetricsKey,
            attributes: metricsAttributes
        });
        return {
            start: ()=>{
                service.start();
                ufoExperience?.start().catch(ufoErrorLogger);
            },
            end: ()=>{
                service.end();
                ufoExperience?.success().catch(ufoErrorLogger);
            },
            cancel: (error)=>{
                // send message to splunk here
                if (error) (0, $2YZCu.default).safeErrorWithoutCustomerData(browserMetricsKey, 'Insights experience failed', new (0, $2Siis.ExperienceError)(error, metricsAttributes));
                service.cancel();
                ufoExperience?.failure().catch(ufoErrorLogger);
            }
        };
    }, [
        insightsExperience,
        userLocation,
        attributes,
        ufoExperience
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2B9C9.InsightsExperienceTrackerStoreContainer), {
        scope: insightsExperience,
        experienceIdsToCollect: experienceIdsToCollect,
        timeoutInMs: timeoutInMs,
        metricsTracker: metricsTracker,
        ufoExperience: ufoExperience
    }, children);
};
const $86531a62d14892a7$export$6a440957407835a0 = ()=>{
    const [, actions] = (0, $2B9C9.useInsightsExperienceTracker)();
    const [isExperienceOwner, setExperienceOwner] = (0, $5uXOq.useState)(false);
    // we only need to expose start, fail and success
    const returnActions = (0, $5uXOq.useMemo)(()=>({
            start: ()=>{
                setExperienceOwner(true);
                actions.start();
            },
            fail: actions.fail,
            success: actions.success
        }), [
        actions,
        setExperienceOwner
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            if (isExperienceOwner === true) actions.reset();
        }, [
        isExperienceOwner,
        actions
    ]);
    return returnActions;
};
const $86531a62d14892a7$export$d8f7e3f6742303b4 = ()=>{
    const { start: start } = $86531a62d14892a7$export$6a440957407835a0();
    (0, $5uXOq.useLayoutEffect)(()=>{
        start();
    }, [
        start
    ]);
    return null;
};

});
parcelRegister("2Siis", function(module, exports) {

$parcel$export(module.exports, "ExperienceError", () => $e57b689d183ecfd7$export$14d796af4fae7309);
class $e57b689d183ecfd7$export$14d796af4fae7309 extends Error {
    constructor(error, extraProps){
        super(error.message);
        this.name = error.name;
        this.stack = error.stack;
        Object.assign(this, {
            ...error
        });
        Object.assign(this, extraProps);
    }
}

});

parcelRegister("2B9C9", function(module, exports) {

$parcel$export(module.exports, "InsightsExperienceTrackerStoreContainer", () => $aa56c148ed849f26$export$ed39ab6b8cf88c60);
$parcel$export(module.exports, "useInsightsExperienceTracker", () => $aa56c148ed849f26$export$941e72d49b686b93);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $30KM0 = parcelRequire("30KM0");

var $fKAQw = parcelRequire("fKAQw");

var $k8iQN = parcelRequire("k8iQN");
const $aa56c148ed849f26$var$Store = (0, $iXqE5.createStore)({
    initialState: // @ts-expect-error - TS2322 - Type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to type 'State'.
    $k8iQN.initialState,
    actions: $fKAQw.actions,
    name: (0, $30KM0.STORE_NAME)
});
const $aa56c148ed849f26$export$ed39ab6b8cf88c60 = (0, $gg7kZ.createContainer)($aa56c148ed849f26$var$Store);
const $aa56c148ed849f26$export$941e72d49b686b93 = (0, $3sQ5x.createHook)($aa56c148ed849f26$var$Store);

});
parcelRegister("fKAQw", function(module, exports) {

$parcel$export(module.exports, "actions", () => $e0f25a0ee99bb826$export$e324594224ef24da);

var $4Fbrj = parcelRequire("4Fbrj");

var $k8iQN = parcelRequire("k8iQN");
const $e0f25a0ee99bb826$var$success = (experienceId)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasTimedOut) return;
        if (!experienceIdsToCollect.includes(experienceId)) return;
        if (state.eventsSuccess.includes(experienceId)) return;
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_success`);
        const nextEventsSuccess = [
            ...state.eventsSuccess,
            experienceId
        ];
        const shouldSetHasCompleted = nextEventsSuccess.length === experienceIdsToCollect.length && !currentStatus.hasCompleted;
        const nextState = {
            status: shouldSetHasCompleted ? {
                ...currentStatus,
                hasCompleted: true
            } : currentStatus,
            timeoutId: state.timeoutId,
            eventsSuccess: [
                ...state.eventsSuccess,
                experienceId
            ],
            eventsFail: state.eventsFail
        };
        setState(nextState);
        if (shouldSetHasCompleted) {
            if (state.timeoutId) clearTimeout(state.timeoutId);
            metricsTracker.end();
        }
    };
const $e0f25a0ee99bb826$var$fail = (experienceId, error)=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect, ufoExperience: ufoExperience })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!experienceId) return;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted) return;
        if (!experienceIdsToCollect.includes(experienceId) && // Panel level error boundary hits do not pass in an experienceId,
        // so we accept the constant "error-boundary-hit" in addition to the experienceIds
        // Note: Insight level error boundary hits do pass in experienceId
        experienceId !== (0, $4Fbrj.ERROR_BOUNDARY_HIT)) return;
        if (state.timeoutId) clearTimeout(state.timeoutId);
        if (ufoExperience != null) ufoExperience.mark(`${experienceId}_fail`);
        const nextEventsFail = [
            ...state.eventsFail,
            experienceId
        ];
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true
            },
            timeoutId: state.timeoutId,
            eventsSuccess: state.eventsSuccess,
            eventsFail: nextEventsFail
        };
        setState(nextState);
        metricsTracker.cancel(error);
    };
const $e0f25a0ee99bb826$var$timeout = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        const currentStatus = state.status;
        if (!currentStatus.hasStarted || currentStatus.hasCompleted || currentStatus.hasFailed) return;
        const nextState = {
            status: {
                ...currentStatus,
                hasFailed: true,
                hasTimedOut: true
            },
            eventsSuccess: state.eventsSuccess,
            eventsFail: state.eventsFail
        };
        setState(nextState);
        metricsTracker.cancel();
    };
const $e0f25a0ee99bb826$var$start = ()=>({ getState: getState, setState: setState, dispatch: dispatch }, { timeoutInMs: timeoutInMs, metricsTracker: metricsTracker, experienceIdsToCollect: experienceIdsToCollect })=>{
        const state = getState();
        const currentStatus = state.status;
        if (currentStatus.hasCompleted || currentStatus.hasStarted || currentStatus.hasFailed || currentStatus.hasTimedOut || experienceIdsToCollect.length === 0) return;
        const timeoutId = setTimeout(()=>{
            dispatch($e0f25a0ee99bb826$var$timeout());
        }, timeoutInMs);
        const nextState = {
            status: {
                ...currentStatus,
                hasStarted: true
            },
            timeoutId: timeoutId,
            eventsSuccess: [],
            eventsFail: []
        };
        // @ts-expect-error - TS2345 - Argument of type '{ status: { hasStarted: boolean; hasFailed: boolean; hasCompleted: boolean; hasTimedOut: boolean; }; timeoutId: NodeJS.Timeout; eventsSuccess: never[]; eventsFail: never[]; }' is not assignable to parameter of type 'Partial<State>'.
        setState(nextState);
        metricsTracker.start();
    };
const $e0f25a0ee99bb826$var$reset = ()=>({ getState: getState, setState: setState }, { metricsTracker: metricsTracker })=>{
        const state = getState();
        if (state.timeoutId) clearTimeout(state.timeoutId);
        const currentStatus = state.status;
        if (currentStatus.hasStarted && !currentStatus.hasCompleted && !currentStatus.hasFailed && !currentStatus.hasTimedOut) metricsTracker.cancel();
        // @ts-expect-error - TS2345 - Argument of type '{ readonly status: { readonly hasFailed: false; readonly hasCompleted: false; readonly hasStarted: false; readonly hasTimedOut: false; }; readonly timeoutId: null; readonly eventsSuccess: readonly []; readonly eventsFail: readonly []; }' is not assignable to parameter of type 'Partial<State>'.
        setState((0, $k8iQN.initialState));
    };
const $e0f25a0ee99bb826$export$e324594224ef24da = {
    reset: $e0f25a0ee99bb826$var$reset,
    start: $e0f25a0ee99bb826$var$start,
    timeout: $e0f25a0ee99bb826$var$timeout,
    success: $e0f25a0ee99bb826$var$success,
    fail: $e0f25a0ee99bb826$var$fail
};

});
parcelRegister("k8iQN", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $7bb650eee945c3d9$export$d4c72bab9d6cc13a);
const $7bb650eee945c3d9$export$d4c72bab9d6cc13a = {
    status: {
        hasFailed: false,
        hasCompleted: false,
        hasStarted: false,
        hasTimedOut: false
    },
    timeoutId: null,
    eventsSuccess: [],
    eventsFail: []
};

});



parcelRegister("bSClU", function(module, exports) {

$parcel$export(module.exports, "useMetricsMemo", () => $5617a8526f2df6be$export$f5d771045a704f1f);

var $5uXOq = parcelRequire("5uXOq");
const $5617a8526f2df6be$var$isShallowDifferent = (arrayA, arrayB)=>arrayA.length !== arrayB.length || arrayA.some((currentElement, index)=>currentElement !== arrayB[index]);
const $5617a8526f2df6be$export$f5d771045a704f1f = (f, deps)=>{
    const metricsTrackerRef = (0, $5uXOq.useRef)();
    const fetchDependenciesRef = (0, $5uXOq.useRef)(deps);
    (0, $5uXOq.useMemo)(()=>{
        const hasEffectsChanged = $5617a8526f2df6be$var$isShallowDifferent(fetchDependenciesRef.current, deps);
        if (!metricsTrackerRef.current || hasEffectsChanged) {
            if (hasEffectsChanged) fetchDependenciesRef.current = deps;
            // @ts-expect-error - TS2554 - Expected 1 arguments, but got 0.
            metricsTrackerRef.current = f();
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
    // @ts-expect-error - TS2322 - Type 'unknown' is not assignable to type 'T'.
    return metricsTrackerRef.current;
};

});

parcelRegister("dfzOH", function(module, exports) {

$parcel$export(module.exports, "useUfoErrorLogger", () => $b799d4cddaf33695$export$688547a52c1d762b);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");


var $30KM0 = parcelRequire("30KM0");
// Replace with lodash/noop
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $b799d4cddaf33695$var$noop = ()=>{};
const $b799d4cddaf33695$export$688547a52c1d762b = ({ eventFrom: eventFrom, ufoExperience: ufoExperience })=>{
    const ufoErrorLogger = (0, $5uXOq.useCallback)((error)=>(0, $2YZCu.default).safeErrorWithoutCustomerData(`${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.${eventFrom}.${ufoExperience?.id || 'unknown'}.${(0, $30KM0.experiences).RENDER}`, 'Insights experience failed', error), [
        eventFrom,
        ufoExperience
    ]);
    return ufoExperience ? ufoErrorLogger : $b799d4cddaf33695$var$noop;
};

});



parcelRegister("gkPFQ", function(module, exports) {

$parcel$export(module.exports, "InsightsSpotlight", () => $7a791a009d9ba36f$export$f441a5f6be0f18a);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $ehdJY = parcelRequire("ehdJY");

var $bMiSe = parcelRequire("bMiSe");
const $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID = 'jira-insights-open-up-message';
const $7a791a009d9ba36f$export$f441a5f6be0f18a = ({ onOpenInsightsPanel: onOpenInsightsPanel, onDismiss: onDismiss, isOnboardingApplicable: isOnboardingApplicable })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, isOnboardingApplicable && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7a791a009d9ba36f$var$CoordinationStopProvider, null, (stopEngagementMessage)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
            actions: [
                {
                    onClick: ()=>{
                        stopEngagementMessage?.();
                        onOpenInsightsPanel();
                        onDismiss();
                    },
                    text: formatMessage((0, $bMiSe.default).viewButtonLabel)
                },
                {
                    onClick: ()=>{
                        stopEngagementMessage?.();
                        onDismiss();
                    },
                    text: formatMessage((0, $bMiSe.default).skipButtonLabel)
                }
            ],
            messageType: "engagement",
            messageId: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID,
            target: "jira-insights-button",
            key: $7a791a009d9ba36f$var$INSIGHTS_OPEN_UP_MESSAGE_ID,
            targetRadius: 3,
            dialogPlacement: "bottom right"
        }, formatMessage((0, $bMiSe.default).spotlightContent)))));
};
const $7a791a009d9ba36f$var$CoordinationStopProvider = ({ stop: stop, children: children })=>children(stop);

});
parcelRegister("bMiSe", function(module, exports) {

$parcel$export(module.exports, "default", () => $b00d0f1af606d21a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b00d0f1af606d21a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    skipButtonLabel: {
        "id": "insights-common.insights-spotlight.skip-button-label",
        "defaultMessage": "Skip"
    },
    viewButtonLabel: {
        "id": "insights-common.insights-spotlight.view-button-label",
        "defaultMessage": "View insights"
    },
    spotlightContent: {
        "id": "insights-common.insights-spotlight.spotlight-content",
        "defaultMessage": "Insights have made it to your board and backlog, so you can monitor work and make informed decisions using real-time data."
    }
});

});


parcelRegister("2KxPr", function(module, exports) {

$parcel$export(module.exports, "withComponentSafety", () => $3fc106ae6756d120$export$cb70221ec28d89b);

var $5uXOq = parcelRequire("5uXOq");

var $2YZCu = parcelRequire("2YZCu");
/* condition must return true for component to render */ function $3fc106ae6756d120$export$cb70221ec28d89b(Component, { condition: condition, location: location, message: message = ()=>'withComponentSafety blocked render', Fallback: Fallback = ()=>null }) {
    return (props)=>{
        const isSafe = condition(props);
        const formattedMessage = message(props);
        (0, $5uXOq.useEffect)(()=>{
            if (!isSafe) (0, $2YZCu.default).safeErrorWithoutCustomerData(location, formattedMessage);
        }, [
            isSafe,
            formattedMessage
        ]);
        // @ts-expect-error - Type 'Props' is not assignable to type 'IntrinsicAttributes & Props'.
        return isSafe ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Component, props) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Fallback, props);
    };
}

});

parcelRegister("6f6NP", function(module, exports) {

$parcel$export(module.exports, "useInsightsContainer", () => $19bd560421a87b26$export$8ecf81d0c059927c);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $1NrMQ = parcelRequire("1NrMQ");

var $j8sJY = parcelRequire("j8sJY");
const $19bd560421a87b26$export$8ecf81d0c059927c = ()=>{
    const [containerState, actions] = (0, $j8sJY.useInsightsStoreContainer)();
    const memoCallbacksRef = (0, $5uXOq.useRef)({});
    const toggleAction = actions.toggleProp;
    (0, $1NrMQ.useIsAnyLevelOfAdmin)({
        onIsAnyLevelOfAdminUpdated: actions.setInfo
    });
    const { loading: loading, data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isProjectType = !loading && projectContext != null;
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { isPanelOpen } }, { onToggleCallback }) => {
            <HidePanelButton onClick={onToggleCallback('isPanelOpen')}
            <Panel isPanelOpen={isPanelOpen} />
          }}
        <InsightsContainer>
    */ const onToggleCallback = (0, $5uXOq.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (propName && !callbacksMap[propName]) // this will prevent recreate the callback on each render
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = ()=>toggleAction(propName);
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        toggleAction
    ]);
    const updateContainerAction = actions.updateContainer;
    /*
      This will create a memoized function callback scoped to the current scope + propName so we can easily
      call this function from the onClick of any of the composed components.
      ex:
        <InsightsContainer>
          {({ data: { settings } }, { onDataUpdatedCallback }) => {
            <LoadPanelSettings onLoad={onDataUpdatedCallback('settings')}
            <Panel settings={settings} />
          }}
        <InsightsContainer>
    */ const onDataUpdatedCallback = (0, $5uXOq.useCallback)((propName)=>{
        if (!memoCallbacksRef.current) memoCallbacksRef.current = {};
        const callbacksMap = memoCallbacksRef.current;
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        if (!callbacksMap[propName]) // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        callbacksMap[propName] = (data)=>// this will prevent recreate the callback on each render
            updateContainerAction({
                [propName]: data
            });
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{}'.
        return callbacksMap[propName];
    }, [
        updateContainerAction
    ]);
    const state = (0, $5uXOq.useMemo)(()=>({
            ...containerState,
            info: {
                ...containerState.info,
                isProjectType: isProjectType
            }
        }), [
        containerState,
        isProjectType
    ]);
    return [
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        state,
        {
            onDataUpdatedCallback: // preferred usage is onDataUpdatedCallback and onToggleCallback
            onDataUpdatedCallback,
            onToggleCallback: onToggleCallback,
            // when we need a big customization and onDataUpdatedCallback and onToggleCallback do not fit
            // to solve the problem, we can use the original implementation onUpdate and onToggle
            doUpdate: actions.updateContainer,
            doToggle: actions.toggleProp,
            doClean: actions.cleanState,
            // pass through actions (from insights container)
            refreshUniqueId: actions.refreshUniqueId,
            updateIsDeepLinking: actions.updateIsDeepLinking
        }
    ];
};

});
parcelRegister("1NrMQ", function(module, exports) {

$parcel$export(module.exports, "useIsAnyLevelOfAdmin", () => $ca08f41fafaf028c$export$b29f514064315678);

var $5uXOq = parcelRequire("5uXOq");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $cNd4s = parcelRequire("cNd4s");
const $ca08f41fafaf028c$export$b29f514064315678 = ({ onIsAnyLevelOfAdminUpdated: onIsAnyLevelOfAdminUpdated })=>{
    const { data: projectContext } = (0, $dAfqg.useProjectContext)();
    const isSiteAdmin = (0, $cNd4s.useIsSiteAdmin)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = !!projectContext?.isProjectAdmin;
    (0, $5uXOq.useEffect)(()=>{
        onIsAnyLevelOfAdminUpdated({
            isAnyLevelOfAdmin: !!(isSiteAdmin || isAdmin || isProjectAdmin)
        });
    }, [
        isProjectAdmin,
        isSiteAdmin,
        isAdmin,
        onIsAnyLevelOfAdminUpdated
    ]);
};

});

parcelRegister("j8sJY", function(module, exports) {

$parcel$export(module.exports, "InsightsStoreContainer", () => $1089c091fa1f71a9$export$4b6f97ed14dce97c);
$parcel$export(module.exports, "useInsightsStoreContainer", () => $1089c091fa1f71a9$export$bd382fb3f9d0551e);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");


var $hXuQC = parcelRequire("hXuQC");

var $keDMh = parcelRequire("keDMh");
const $1089c091fa1f71a9$var$Store = (0, $iXqE5.createStore)({
    initialState: $keDMh.initialState,
    actions: $hXuQC.actions,
    name: (0, $622cc15065a8e93c$export$cd79d01fb3d2f506)
});
const $1089c091fa1f71a9$export$4b6f97ed14dce97c = (0, $gg7kZ.createContainer)($1089c091fa1f71a9$var$Store);
const $1089c091fa1f71a9$export$bd382fb3f9d0551e = (0, $3sQ5x.createHook)($1089c091fa1f71a9$var$Store);

});
const $622cc15065a8e93c$export$cd79d01fb3d2f506 = 'jira.insights.container-store';

parcelRegister("hXuQC", function(module, exports) {

$parcel$export(module.exports, "actions", () => $dfa05910dfd04d9d$export$e324594224ef24da);

var $7Jxgt = parcelRequire("7Jxgt");

var $keDMh = parcelRequire("keDMh");
const $dfa05910dfd04d9d$var$updateContainer = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                ...data
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$toggleProp = (propsName)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            info: state.info,
            data: {
                ...state.data,
                [propsName]: !state.data[propsName]
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$setInfo = (data)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                ...data
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$refreshUniqueId = ()=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                uniqueId: (0, $7Jxgt.v4)()
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$var$cleanState = ()=>({ setState: setState })=>{
        setState((0, $keDMh.initialState));
    };
const $dfa05910dfd04d9d$var$updateIsDeepLinking = (isDeepLinking)=>({ setState: setState, getState: getState })=>{
        const state = getState();
        const nextState = {
            data: state.data,
            info: {
                ...state.info,
                isDeepLinking: isDeepLinking
            }
        };
        setState(nextState);
    };
const $dfa05910dfd04d9d$export$e324594224ef24da = {
    setInfo: $dfa05910dfd04d9d$var$setInfo,
    cleanState: $dfa05910dfd04d9d$var$cleanState,
    toggleProp: $dfa05910dfd04d9d$var$toggleProp,
    updateContainer: $dfa05910dfd04d9d$var$updateContainer,
    refreshUniqueId: $dfa05910dfd04d9d$var$refreshUniqueId,
    updateIsDeepLinking: $dfa05910dfd04d9d$var$updateIsDeepLinking
};

});
parcelRegister("keDMh", function(module, exports) {

$parcel$export(module.exports, "initialState", () => $2bb5e17d6b3cb888$export$d4c72bab9d6cc13a);

var $7Jxgt = parcelRequire("7Jxgt");

const $2bb5e17d6b3cb888$var$SSR_UNIQUE_ID = 'ssr-unique-id';
const $2bb5e17d6b3cb888$export$d4c72bab9d6cc13a = {
    info: {
        uniqueId: (0, $cdb023d06c7f62fa$export$19d68f5aa485d903) ? $2bb5e17d6b3cb888$var$SSR_UNIQUE_ID : (0, $7Jxgt.v4)(),
        isDeepLinking: true
    },
    data: {}
};

});




parcelRegister("ebnTF", function(module, exports) {

$parcel$export(module.exports, "getTextValue", () => $ab366a2319b78816$export$6ca03cb7b75bfa13);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $ab366a2319b78816$var$isUndefinedOrNull = (value)=>value === null || value === undefined;
const $ab366a2319b78816$export$96252741c837b909 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$22a0d6ac9d3db3b9 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$6ca03cb7b75bfa13 = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;
const $ab366a2319b78816$export$e1a3353b722e75de = (value, defaultValue)=>$ab366a2319b78816$var$isUndefinedOrNull(value) ? defaultValue : value;

});

parcelRegister("apoVO", function(module, exports) {

$parcel$export(module.exports, "InsightsContainer", () => $8769e024218efab1$export$af2273df1febba45);

var $5uXOq = parcelRequire("5uXOq");

var $j8sJY = parcelRequire("j8sJY");

var $6f6NP = parcelRequire("6f6NP");
const $8769e024218efab1$var$buildScopeName = (scope, packageName)=>`${scope}-${packageName}`;
const $8769e024218efab1$var$ChildrenWrapperWithHook = ({ children: children })=>{
    const [state, actions] = (0, $6f6NP.useInsightsContainer)();
    return children(state, actions);
};
const $8769e024218efab1$export$af2273df1febba45 = ({ scope: scope, packageName: packageName, children: children })=>{
    const insightsStoreContainerScope = $8769e024218efab1$var$buildScopeName(scope, packageName);
    if (typeof children === 'function') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8sJY.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8769e024218efab1$var$ChildrenWrapperWithHook, null, children));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $j8sJY.InsightsStoreContainer), {
        scope: insightsStoreContainerScope
    }, children);
};

});

parcelRegister("g5uUm", function(module, exports) {

$parcel$export(module.exports, "InsightsButton", () => $98922b077d0d412f$export$943e069e37d25a04);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $bZNwM = parcelRequire("bZNwM");

var $5Fk4Z = parcelRequire("5Fk4Z");

var $3TyLU = parcelRequire("3TyLU");
var $1kVqg = parcelRequire("1kVqg");

var $42CjB = parcelRequire("42CjB");

var $hCCtP = parcelRequire("hCCtP");

var $7CMCs = parcelRequire("7CMCs");

var $4Fbrj = parcelRequire("4Fbrj");


var $7BuUr = parcelRequire("7BuUr");

var $koVbs = parcelRequire("koVbs");

var $3HwlS = parcelRequire("3HwlS");

var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $hchBL = parcelRequire("hchBL");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $2Mspb = parcelRequire("2Mspb");
const $98922b077d0d412f$var$actionSubjectId = 'toggleInsightsPanel';
const $98922b077d0d412f$var$TooltipWrapper = ({ children: children, render: render })=>render != null ? render({
        children: children
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
const $98922b077d0d412f$var$buttonTestId = 'insights-show-insights-button.ui.insights-button';
const $98922b077d0d412f$var$buttonForHiddenTestId = 'insights-show-insights-button.ui.button-test-id-hide';
const $98922b077d0d412f$export$2fdc3445dd252e1 = ({ clickEventAnalytics: clickEventAnalytics, iconAfter: iconAfter, isCompact: isCompact = false, isHidden: isHidden = false, isInsightsPanelOpen: isInsightsPanelOpen, isOnboardingDisabled: isOnboardingDisabled = false, onToggle: onToggle, renderTooltip: renderTooltip, location: location, isThemed: isThemed = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRefSmall = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_SM), ref);
    }, [
        register
    ]);
    const onRefButtonLarge = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_LG), ref);
    }, [
        register
    ]);
    const onRefButtonResponsive = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON_RESPONSIVE), ref);
    }, [
        register
    ]);
    const onRefButton = (0, $5uXOq.useCallback)((ref)=>{
        register((0, $4Fbrj.INSIGHTS_BUTTON), ref);
    }, [
        register
    ]);
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const isDisabled = isOnboardingDisabled;
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, $98922b077d0d412f$var$actionSubjectId, {
            action: isInsightsPanelOpen ? 'close' : 'open',
            isDisabled: isDisabled,
            ...clickEventAnalytics?.attributes || {}
        });
        onToggle(analyticsEvent);
    }, [
        clickEventAnalytics,
        isDisabled,
        isInsightsPanelOpen,
        onToggle
    ]);
    const buttonLabelMap = {
        [(0, $f43e6cbc56ecd5ed$export$596021054ee994de)]: {
            open: (0, $2Mspb.default).showInsightsBacklogTerminologyRefresh,
            closed: (0, $2Mspb.default).hideInsightsBacklogTerminologyRefresh
        },
        [(0, $f43e6cbc56ecd5ed$export$20548c7afd11b51e)]: {
            open: (0, $2Mspb.default).showInsightsKanbanTerminologyRefresh,
            closed: (0, $2Mspb.default).hideInsightsKanbanTerminologyRefresh
        },
        [(0, $f43e6cbc56ecd5ed$export$a26d014939cffdb)]: {
            open: (0, $2Mspb.default).showInsightsScrumTerminologyRefresh,
            closed: (0, $2Mspb.default).hideInsightsScrumTerminologyRefresh
        },
        [(0, $f43e6cbc56ecd5ed$export$7278886766e0567e)]: {
            open: (0, $2Mspb.default).backlogInsightsLabel,
            closed: (0, $2Mspb.default).backlogInsightsLabel
        },
        [(0, $f43e6cbc56ecd5ed$export$c54b080144f4f954)]: {
            open: (0, $2Mspb.default).kanbanInsightsLabel,
            closed: (0, $2Mspb.default).kanbanInsightsLabel
        },
        [(0, $f43e6cbc56ecd5ed$export$9fd46aa549776647)]: {
            open: (0, $2Mspb.default).scrumInsightsLabel,
            closed: (0, $2Mspb.default).scrumInsightsLabel
        },
        default: {
            open: (0, $2Mspb.default).showInsights,
            closed: (0, $2Mspb.default).hideInsights
        }
    };
    const { open: open, closed: closed } = buttonLabelMap[location ?? 'default'] || buttonLabelMap.default;
    const label = isInsightsPanelOpen ? formatMessage(open) : formatMessage(closed);
    if (!isSupported) return null;
    const showInsightsButton = !isHidden;
    if (!showInsightsButton) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        action: "hidden",
        actionSubject: "button",
        actionSubjectId: $98922b077d0d412f$var$actionSubjectId
    });
    const iconColor = isInsightsPanelOpen ? undefined : "var(--ds-icon, #44546F)";
    const IconButtonComponent = isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $hCCtP.ThemedIconButton) : (0, $42CjB.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        action: "rendered",
        actionSubject: "button",
        actionSubjectId: $98922b077d0d412f$var$actionSubjectId
    }), (0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButton,
        isTooltipDisabled: false
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        iconAfter: typeof iconAfter === 'function' ? iconAfter : undefined,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButtonResponsive
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
        interactionName: "show-insights-button",
        icon: (0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))),
        label: label,
        isSelected: isInsightsPanelOpen,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButton
    }))) : isCompact ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        appearance: "subtle",
        spacing: "none",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: label,
            color: iconColor
        }),
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefSmall
    }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: "",
            color: iconColor
        }),
        iconAfter: typeof iconAfter === 'object' ? // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        iconAfter : undefined,
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonTestId,
        ref: onRefButtonLarge
    }, label))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3TyLU.Hide), {
        above: "lg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$var$TooltipWrapper, {
        render: renderTooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        interactionName: "show-insights-button",
        isSelected: isInsightsPanelOpen,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($bZNwM))), {
            label: label,
            color: iconColor
        }),
        onClick: onClick,
        testId: $98922b077d0d412f$var$buttonForHiddenTestId,
        ref: onRefSmall
    })))))));
};
const $98922b077d0d412f$export$943e069e37d25a04 = (props)=>{
    const packageName = props?.packageName ? props.packageName : (0, $4Fbrj.JIRA_INSIGHTS);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "button",
        packageName: packageName,
        teamName: "helios-headcoach",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($98922b077d0d412f$export$2fdc3445dd252e1, props));
};

});
parcelRegister("bZNwM", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::82e1d157ecf30f62ef37497818841c29>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $8bbbcf5ce8764439$var$_react = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $8bbbcf5ce8764439$var$_chartTrend = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("7EZ5v")));

var $8bbbcf5ce8764439$var$_graphLine = $8bbbcf5ce8764439$var$_interopRequireDefault((parcelRequire("gSPJV")));
function $8bbbcf5ce8764439$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ChartTrendIcon.
 * This component is ChartTrendIcon, with `UNSAFE_fallbackIcon` set to "GraphLineIcon".
 *
 * Category: multi-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Multi purpose - Known uses: charts, reports in Jira, and sprint insights.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $8bbbcf5ce8764439$var$ChartTrendIcon = (props)=>/*#__PURE__*/ $8bbbcf5ce8764439$var$_react.default.createElement($8bbbcf5ce8764439$var$_chartTrend.default, Object.assign({
        LEGACY_fallbackIcon: $8bbbcf5ce8764439$var$_graphLine.default
    }, props));
$8bbbcf5ce8764439$var$ChartTrendIcon.Name = 'ChartTrendIconMigration';
var $8bbbcf5ce8764439$var$_default = module.exports.default = $8bbbcf5ce8764439$var$ChartTrendIcon;

});
parcelRegister("gSPJV", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c4a9d2eb82ff139c$var$_react = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $c4a9d2eb82ff139c$var$_chartTrend = $c4a9d2eb82ff139c$var$_interopRequireDefault((parcelRequire("7EZ5v")));
function $c4a9d2eb82ff139c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $c4a9d2eb82ff139c$var$GraphLineIcon = (props)=>/*#__PURE__*/ $c4a9d2eb82ff139c$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor"><path d="M21 17H5c-.55 0-1-.45-1-1.01V6a1 1 0 1 0-2 0v9.99A3 3 0 0 0 5 19h16a1 1 0 0 0 0-2m-3-8v3a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1h-4a1 1 0 0 0 0 2z"/><path d="M13.293 13.707a1 1 0 0 0 1.414 0l4-4a1 1 0 1 0-1.414-1.414L14 11.586l-2.293-2.293a1 1 0 0 0-1.414 0l-4 4a1 1 0 0 0 1.414 1.414L11 11.414z"/></g></svg>`
    }, props, {
        newIcon: $c4a9d2eb82ff139c$var$_chartTrend.default
    }));
$c4a9d2eb82ff139c$var$GraphLineIcon.displayName = 'GraphLineIcon';
var $c4a9d2eb82ff139c$var$_default = module.exports.default = $c4a9d2eb82ff139c$var$GraphLineIcon;

});


parcelRegister("3TyLU", function(module, exports) {

$parcel$export(module.exports, "Hide", () => $f53ed0348d5d3206$export$bed28288a051538);
/**
 * @jsxRuntime classic
 * @jsx jsx
 */ 
var $f8Sb3 = parcelRequire("f8Sb3");

var $8CUq3 = parcelRequire("8CUq3");

var $2pf2j = parcelRequire("2pf2j");
const $f53ed0348d5d3206$var$hideAboveQueries = (0, $2pf2j.UNSAFE_buildAboveMediaQueryCSS)({
    display: 'none'
});
const $f53ed0348d5d3206$var$hideBelowQueries = (0, $2pf2j.UNSAFE_buildBelowMediaQueryCSS)({
    display: 'none'
});
const $f53ed0348d5d3206$export$bed28288a051538 = ({ above: above, below: below, children: children, as: AsElement = 'div', xcss: xcss })=>{
    const resolvedStyles = (0, $8CUq3.parseXcss)(xcss);
    return /*#__PURE__*/ (0, $f8Sb3.jsx)(AsElement, {
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: resolvedStyles.static,
        css: [
            above && $f53ed0348d5d3206$var$hideAboveQueries[above],
            below && $f53ed0348d5d3206$var$hideBelowQueries[below],
            resolvedStyles.emotion
        ]
    }, children);
};

});

parcelRegister("6lmg7", function(module, exports) {

$parcel$export(module.exports, "ResponsiveButton", () => $aeaed609d1db7293$export$47e82d861696e68c);
$parcel$export(module.exports, "ResponsiveLinkButton", () => $aeaed609d1db7293$export$50fd17babcd996ef);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");
var $42CjB = parcelRequire("42CjB");
var $1GGwS = parcelRequire("1GGwS");
var $krXdA = parcelRequire("krXdA");

var $f5TWP = parcelRequire("f5TWP");

var $1kVqg = parcelRequire("1kVqg");
var $oGXFy = parcelRequire("oGXFy");

var $3bDjY = parcelRequire("3bDjY");

var $hCCtP = parcelRequire("hCCtP");

const $aeaed609d1db7293$export$47e82d861696e68c = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});
const $aeaed609d1db7293$export$50fd17babcd996ef = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { icon: icon, label: label, iconAfter: iconAfter, breakpoint: breakpoint = 'lg', appearance: appearance, testId: testId, 'aria-label': ariaLabel, iconButtonSpacing: iconButtonSpacing, buttonSpacing: buttonSpacing, isThemed: isThemed, ...restProps } = props;
    const mediaQueryBreakpoint = (0, $oGXFy.UNSAFE_useMediaQuery)(`above.${breakpoint}`, (event)=>setIsAboveBreakpoint(event.matches));
    const [isAboveBreakpoint, setIsAboveBreakpoint] = (0, $5uXOq.useState)(mediaQueryBreakpoint?.matches);
    const IconButtonComponent = isThemed ? (0, $hCCtP.ThemedLinkIconButton) : (0, $krXdA.default);
    const ButtonComponent = isThemed ? (0, $hCCtP.ThemedLinkButton) : (0, $1GGwS.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(IconButtonComponent, {
        ...restProps,
        icon: icon,
        appearance: appearance ?? 'default',
        label: label,
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.collapsed`,
        href: restProps.href,
        ref: !isAboveBreakpoint ? ref : undefined,
        spacing: iconButtonSpacing
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: breakpoint
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        ...restProps,
        iconBefore: icon,
        iconAfter: iconAfter,
        appearance: appearance ?? 'default',
        testId: `${testId ?? (0, $7c15fdea32a398a0$export$9c51afe8741be906)}.expanded`,
        href: restProps.href,
        ref: isAboveBreakpoint ? ref : undefined,
        "aria-label": ariaLabel,
        spacing: buttonSpacing
    }, label)));
});

});
const $7c15fdea32a398a0$export$9c51afe8741be906 = 'responsive-button.ui.responsive-button';


parcelRegister("2Mspb", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c41f59518ad2b73$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2c41f59518ad2b73$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showInsights: {
        "id": "insights-show-insights-button.show-insights",
        "defaultMessage": "Insights"
    },
    hideInsights: {
        "id": "insights-show-insights-button.hide-insights",
        "defaultMessage": "Insights"
    },
    showInsightsBacklogTerminologyRefresh: {
        "id": "insights-show-insights-button.show-insights-backlog-terminology-refresh",
        "defaultMessage": "Planning health"
    },
    hideInsightsBacklogTerminologyRefresh: {
        "id": "insights-show-insights-button.hide-insights-backlog-terminology-refresh",
        "defaultMessage": "Planning health"
    },
    showInsightsKanbanTerminologyRefresh: {
        "id": "insights-show-insights-button.show-insights-kanban-terminology-refresh",
        "defaultMessage": "Work health"
    },
    hideInsightsKanbanTerminologyRefresh: {
        "id": "insights-show-insights-button.hide-insights-kanban-terminology-refresh",
        "defaultMessage": "Work health"
    },
    showInsightsScrumTerminologyRefresh: {
        "id": "insights-show-insights-button.show-insights-scrum-terminology-refresh",
        "defaultMessage": "Sprint health"
    },
    hideInsightsScrumTerminologyRefresh: {
        "id": "insights-show-insights-button.hide-insights-scrum-terminology-refresh",
        "defaultMessage": "Sprint health"
    },
    scrumInsightsLabel: {
        "id": "insights-show-insights-button.scrum-insights-label",
        "defaultMessage": "Sprint insights"
    },
    kanbanInsightsLabel: {
        "id": "insights-show-insights-button.kanban-insights-label",
        "defaultMessage": "Board insights"
    },
    backlogInsightsLabel: {
        "id": "insights-show-insights-button.insights-label",
        "defaultMessage": "Backlog insights"
    }
});

});


parcelRegister("l60Zc", function(module, exports) {

$parcel$export(module.exports, "BOARD_BUTTON_ID", () => $6c2b5aa903c2ea94$export$a964db0cf65f63e0);

const $6c2b5aa903c2ea94$export$a964db0cf65f63e0 = `${(0, $b0e6fec6a4686296$export$d3996f57ffa8448f)}.board-button`;

});

parcelRegister("hCKQh", function(module, exports) {

$parcel$export(module.exports, "default", () => $7678bdc7a84a3fea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7678bdc7a84a3fea$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "insights-board-button.tooltip",
        "defaultMessage": "Sprint insights"
    },
    tooltipTerminologyRefresh: {
        "id": "insights-board-button.tooltip-terminology-refresh",
        "defaultMessage": "Sprint health"
    }
});

});


parcelRegister("5HeQO", function(module, exports) {

$parcel$export(module.exports, "KanbanBoardInsightsButton", () => $b668dbb2fb6c3ea3$export$42d054b6930214e);

var $5uXOq = parcelRequire("5uXOq");

var $k6T4f = parcelRequire("k6T4f");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $3bDjY = parcelRequire("3bDjY");

var $ioD1B = parcelRequire("ioD1B");

var $6s1PB = parcelRequire("6s1PB");

var $4Fbrj = parcelRequire("4Fbrj");


var $9Y7dM = parcelRequire("9Y7dM");


var $9YlLW = parcelRequire("9YlLW");

var $7BuUr = parcelRequire("7BuUr");

var $0241A = parcelRequire("0241A");

var $6OlO8 = parcelRequire("6OlO8");

var $cOddg = parcelRequire("cOddg");

var $1UEsW = parcelRequire("1UEsW");

var $gkPFQ = parcelRequire("gkPFQ");

var $2KxPr = parcelRequire("2KxPr");

var $6f6NP = parcelRequire("6f6NP");

var $ebnTF = parcelRequire("ebnTF");

var $apoVO = parcelRequire("apoVO");

var $g5uUm = parcelRequire("g5uUm");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");

var $l60Zc = parcelRequire("l60Zc");

var $lKVmh = parcelRequire("lKVmh");
const $b668dbb2fb6c3ea3$var$ButtonTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const message = (0, $6s1PB.expVal)('jira_enable_insights_terminology_refresh', 'isEnabled', false) ? formatMessage((0, $lKVmh.default).tooltipTerminologyRefresh) : formatMessage((0, $lKVmh.default).tooltip);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: message
    }, children);
};
const $b668dbb2fb6c3ea3$var$KanbanBoardInsightsButtonComponent = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId, isThemed: isThemed })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const [isOnboardingApplicable, setIsOnboardingApplicable] = (0, $5uXOq.useState)(false);
    const markOnboardingApplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(true), []);
    const markOnboardingInapplicable = (0, $5uXOq.useCallback)(()=>setIsOnboardingApplicable(false), []);
    const [isDueDatePulseActive, setisDueDatePulseActive] = (0, $5uXOq.useState)(false);
    const { coordinationClient: coordinationClient, shouldStartPulse: shouldStartPulse, stopPulse: stopPulse } = (0, $9YlLW.useDueDatePulse)();
    const [messageFinished, setIsMessageFinished] = (0, $5uXOq.useState)(false);
    const [{ info: { isAnyLevelOfAdmin: isAnyLevelOfAdmin, isProjectType: isProjectType, uniqueId: uniqueId }, data: { hasPermission: hasPermission } }, { onDataUpdatedCallback: onDataUpdatedCallback, refreshUniqueId: refreshUniqueId, updateIsDeepLinking: updateIsDeepLinking }] = (0, $6f6NP.useInsightsContainer)();
    const [, { doUpdate: doUpdate }] = (0, $6f6NP.useInsightsContainer)();
    const onDismissClickHandler = (0, $5uXOq.useCallback)(()=>{
        setIsMessageFinished(true);
        stopPulse(true);
    }, [
        stopPulse
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        isOpen,
        updateIsDeepLinking
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) {
            if (messageFinished) doUpdate({
                isPulsing: false
            });
        }
        if (shouldStartPulse) {
            setisDueDatePulseActive(true);
            doUpdate({
                isPulsing: true
            });
        } else if (messageFinished) setisDueDatePulseActive(false);
    }, [
        doUpdate,
        isOpen,
        messageFinished,
        shouldStartPulse
    ]);
    // refresh experience when insights (panel) is closed
    (0, $0241A.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    const currentPermissionStatus = (0, $ebnTF.getTextValue)(hasPermission, (0, $9Y7dM.permissionStatus).LOADING);
    const isPulseShowing = isDueDatePulseActive && !messageFinished;
    // eslint-disable-next-line no-nested-ternary
    const location = (0, $6s1PB.expVal)('jira_enable_insights_terminology_refresh', 'isEnabled', false) ? (0, $f43e6cbc56ecd5ed$export$20548c7afd11b51e) : (0, $dCm1o.isVisualRefreshEnabled)() ? (0, $f43e6cbc56ecd5ed$export$c54b080144f4f954) : undefined;
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            edition: edition,
            boardId: boardId,
            userLocation: userLocation,
            projectId: projectId,
            frameworkType: (0, $4Fbrj.boardType).KANBAN,
            experienceId: uniqueId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gkPFQ.InsightsSpotlight), {
        onOpenInsightsPanel: ()=>!isOpen && onToggle(),
        onDismiss: markOnboardingInapplicable,
        isOnboardingApplicable: isOnboardingApplicable
    }), currentPermissionStatus === (0, $9Y7dM.permissionStatus).LOADING && (isSimplifiedProject ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckSimplifiedDataPermission), null) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cOddg.CheckClassicViewAggregatedDataPermission), {
        boardId: boardId,
        userLocation: userLocation,
        onPermissionLoaded: onDataUpdatedCallback('hasPermission'),
        onInsightsEnabledWithoutPermission: markOnboardingApplicable
    })), isPulseShowing && (0, $6s1PB.expVal)('jira_enable_due_date_ifa', 'isEnabled', false) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient.enableChoreographer
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "jira-insights-button-due-date-tab"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
        radius: 3,
        pulse: isPulseShowing,
        onClick: ()=>onDismissClickHandler()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        isInsightsPanelOpen: isOpen,
        isCompact: isCompact,
        boardId: boardId,
        onToggle: onToggle,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        renderTooltip: $b668dbb2fb6c3ea3$var$ButtonTooltip,
        location: location,
        isThemed: isThemed
    })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        isInsightsPanelOpen: isOpen,
        isCompact: isCompact,
        boardId: boardId,
        onToggle: onToggle,
        isAnyLevelOfAdmin: !isSimplifiedProject && isAnyLevelOfAdmin,
        isHidden: !isProjectType,
        isOnboardingDisabled: !isSimplifiedProject ? currentPermissionStatus !== (0, $9Y7dM.permissionStatus).ALLOWED : undefined,
        renderTooltip: $b668dbb2fb6c3ea3$var$ButtonTooltip,
        location: location,
        isThemed: isThemed
    }))) : null;
};
const $b668dbb2fb6c3ea3$var$KanbanBoardInsightsButtonWithContainer = (props)=>{
    const scope = (0, $6OlO8.buildBoardScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apoVO.InsightsContainer), {
        scope: scope,
        packageName: (0, $b0e6fec6a4686296$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b668dbb2fb6c3ea3$var$KanbanBoardInsightsButtonComponent, props));
};
const $b668dbb2fb6c3ea3$var$SafeKanbanBoardInsightsButton = (0, $2KxPr.withComponentSafety)($b668dbb2fb6c3ea3$var$KanbanBoardInsightsButtonWithContainer, {
    condition: ({ boardId: boardId })=>(0, $9YlLW.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $l60Zc.BOARD_BUTTON_ID),
    message: ({ boardId: boardId })=>`Board button received invalid boardId: ${boardId}`
});
const $b668dbb2fb6c3ea3$export$42d054b6930214e = (0, $1UEsW.WithInsightsErrorBoundary)($b668dbb2fb6c3ea3$var$SafeKanbanBoardInsightsButton, (0, $b0e6fec6a4686296$export$1269ea4f2b198811), (0, $b0e6fec6a4686296$export$d3996f57ffa8448f));

});
parcelRegister("lKVmh", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb556a8eb9a8ceb8$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $eb556a8eb9a8ceb8$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "insights-board-button.kanban-button.tooltip",
        "defaultMessage": "Board insights"
    },
    tooltipTerminologyRefresh: {
        "id": "insights-board-button.kanban-button.tooltip-terminology-refresh",
        "defaultMessage": "Work health"
    }
});

});


parcelRegister("046Kp", function(module, exports) {

$parcel$export(module.exports, "ServicedeskBoardInsightsButton", () => $db31cb55f3113dc9$export$6f71131b25281bb3);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $4Fbrj = parcelRequire("4Fbrj");

var $9YlLW = parcelRequire("9YlLW");

var $7BuUr = parcelRequire("7BuUr");

var $0241A = parcelRequire("0241A");

var $1UEsW = parcelRequire("1UEsW");

var $2KxPr = parcelRequire("2KxPr");

var $6f6NP = parcelRequire("6f6NP");

var $apoVO = parcelRequire("apoVO");

var $g5uUm = parcelRequire("g5uUm");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $iXVV6 = parcelRequire("iXVV6");


var $cngc7 = parcelRequire("cngc7");

var $lOogP = parcelRequire("lOogP");
const $db31cb55f3113dc9$var$ButtonTooltip = ({ children: children })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $lOogP.default).tooltip)
    }, children);
};
const $db31cb55f3113dc9$export$8d02a93abfd1986e = ({ isCompact: isCompact = false, isSimplifiedProject: isSimplifiedProject, isOpen: isOpen, boardId: boardId, onToggle: onToggle, edition: edition, projectId: projectId, isThemed: isThemed })=>{
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isSupported = (0, $7BuUr.useIsCurrentBrowserSupported)();
    const [{ info: { isProjectType: isProjectType, uniqueId: uniqueId } }, { refreshUniqueId: refreshUniqueId, updateIsDeepLinking: updateIsDeepLinking }] = (0, $6f6NP.useInsightsContainer)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isOpen) updateIsDeepLinking(false);
    }, [
        updateIsDeepLinking,
        isOpen,
        isSimplifiedProject
    ]);
    // refresh experience when insights (panel) is closed
    (0, $0241A.useValueChangeEffect)({
        listener: isOpen,
        callback: (current, previous)=>{
            if (current === false && previous === true) refreshUniqueId();
        }
    }, [
        refreshUniqueId
    ]);
    return isSupported ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: {
            edition: edition,
            boardId: boardId,
            userLocation: userLocation,
            projectId: projectId,
            frameworkType: (0, $4Fbrj.boardType).KANBAN,
            experienceId: uniqueId
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g5uUm.InsightsButton), {
        isInsightsPanelOpen: isOpen,
        isCompact: isCompact,
        boardId: boardId,
        onToggle: onToggle,
        isHidden: !isProjectType,
        renderTooltip: $db31cb55f3113dc9$var$ButtonTooltip,
        isThemed: isThemed
    }))) : null;
};
const $db31cb55f3113dc9$var$ServicedeskBoardInsightsButtonWithContainer = (props)=>{
    const scope = (0, $cngc7.buildBoardScopeName)({
        isSimplifiedProject: props.isSimplifiedProject,
        boardId: props.boardId
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $db31cb55f3113dc9$var$serviceDeskInsightStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $apoVO.InsightsContainer), {
        scope: scope,
        packageName: (0, $c5cb7bd255e35dd6$export$d3996f57ffa8448f)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($db31cb55f3113dc9$export$8d02a93abfd1986e, props)));
};
const $db31cb55f3113dc9$var$SafeServicedeskBoardInsightsButton = (0, $2KxPr.withComponentSafety)($db31cb55f3113dc9$var$ServicedeskBoardInsightsButtonWithContainer, {
    condition: ({ boardId: boardId })=>(0, $9YlLW.isValidBoardId)({
            boardId: boardId
        }),
    location: (0, $c5cb7bd255e35dd6$export$a964db0cf65f63e0),
    message: ({ boardId: boardId })=>`Servicedesk Board button received invalid boardId: ${boardId}`
});
const $db31cb55f3113dc9$export$6f71131b25281bb3 = (0, $1UEsW.WithInsightsErrorBoundary)($db31cb55f3113dc9$var$SafeServicedeskBoardInsightsButton, (0, $c5cb7bd255e35dd6$export$98cd6374d35728ad), (0, $c5cb7bd255e35dd6$export$d3996f57ffa8448f));
const $db31cb55f3113dc9$var$serviceDeskInsightStyle = (0, $8CUq3.xcss)({
    marginRight: 'space.100'
});

});
const $c5cb7bd255e35dd6$export$d3996f57ffa8448f = 'servicedesk.insights';
const $c5cb7bd255e35dd6$export$c9290acd1ba498ff = `${$c5cb7bd255e35dd6$export$d3996f57ffa8448f}.board`;
const $c5cb7bd255e35dd6$export$8e66b21ec141a0bd = `${$c5cb7bd255e35dd6$export$d3996f57ffa8448f}.board-simplified`;
const $c5cb7bd255e35dd6$export$a964db0cf65f63e0 = `${$c5cb7bd255e35dd6$export$d3996f57ffa8448f}.board-button`;
const $c5cb7bd255e35dd6$export$98cd6374d35728ad = `${$c5cb7bd255e35dd6$export$d3996f57ffa8448f}.error-boundary`;

parcelRegister("cngc7", function(module, exports) {

$parcel$export(module.exports, "buildBoardScopeName", () => $e2134cc890abde88$export$7cfa8d622acbc99f);

const $e2134cc890abde88$export$7cfa8d622acbc99f = ({ isSimplifiedProject: isSimplifiedProject, boardId: boardId })=>`${isSimplifiedProject ? (0, $c5cb7bd255e35dd6$export$8e66b21ec141a0bd) : (0, $c5cb7bd255e35dd6$export$c9290acd1ba498ff)}-boardId:${boardId}`;

});

parcelRegister("lOogP", function(module, exports) {

$parcel$export(module.exports, "default", () => $08a91f27f343c4ee$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $08a91f27f343c4ee$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "servicedesk-board-button.tooltip",
        "defaultMessage": "Board insights"
    }
});

});




parcelRegister("9eTg7", function(module, exports) {

$parcel$export(module.exports, "shouldDisableStandup", () => $59c567bfc1207d3d$export$e534c1f6327a8e09);
$parcel$export(module.exports, "getIsCompleteSprintButtonVisible", () => $59c567bfc1207d3d$export$c683535c091a9e79);

var $ebHh7 = parcelRequire("ebHh7");
const $59c567bfc1207d3d$export$e534c1f6327a8e09 = ({ boardType: boardType, isSprintsEnabled: isSprintsEnabled, hasActiveSprint: hasActiveSprint })=>{
    if (boardType === 'Kanban') return false;
    return isSprintsEnabled && !hasActiveSprint;
};
function $59c567bfc1207d3d$export$c683535c091a9e79(state) {
    // allow the render of a disabled button if no permissions to manage the sprint
    return (0, $ebHh7.hasActiveSprintsSelector)(state);
}

});

parcelRegister("7Nu6k", function(module, exports) {

$parcel$export(module.exports, "BoardFilterRefinement", () => $0d1dae21c688c823$export$bf90a9d64f2df7e3);

var $8ibCb = parcelRequire("8ibCb");

var $ae01E = parcelRequire("ae01E");

var $5uXOq = parcelRequire("5uXOq");

var $ajpes = parcelRequire("ajpes");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $6s1PB = parcelRequire("6s1PB");

var $7mRzW = parcelRequire("7mRzW");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $koeKL = parcelRequire("koeKL");

var $koVbs = parcelRequire("koVbs");

var $1othz = parcelRequire("1othz");


var $05fhZ = parcelRequire("05fhZ");

var $3oCwY = parcelRequire("3oCwY");

var $26Asg = parcelRequire("26Asg");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $7CMCs = parcelRequire("7CMCs");

var $fZneA = parcelRequire("fZneA");

var $kobfu = parcelRequire("kobfu");

var $6cG4N = parcelRequire("6cG4N");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $hCCtP = parcelRequire("hCCtP");

var $1XJ20 = parcelRequire("1XJ20");

var $67sX6 = parcelRequire("67sX6");

var $dnW4F = parcelRequire("dnW4F");

var $8yiLS = parcelRequire("8yiLS");

var $5mTgl = parcelRequire("5mTgl");

var $67Z81 = parcelRequire("67Z81");


var $45cXl = parcelRequire("45cXl");

var $cjoN4 = parcelRequire("cjoN4");

var $1vXOx = parcelRequire("1vXOx");


var $jWrFu = parcelRequire("jWrFu");
const $0d1dae21c688c823$var$CHANGEBOARDING_MESSAGE_ID = 'jira-filter-refinement-for-tmp-boards';
const $0d1dae21c688c823$var$useAddPeopleButtonProps = ()=>{
    const canInviteOthersToProject = (0, $67sX6.useBoardSelector)((0, $67Z81.getCanInviteOthersToProject));
    const permissions = (0, $67sX6.useBoardSelector)((0, $1vXOx.getPermissionsSelector));
    const projectId = (0, $67sX6.useBoardSelector)((0, $67Z81.projectIdSelector));
    const projectKey = (0, $67sX6.useBoardSelector)((0, $67Z81.projectKeySelector));
    const projectName = (0, $67sX6.useBoardSelector)((0, $67Z81.projectNameSelector));
    return (0, $5uXOq.useMemo)(()=>{
        const isAddPeopleButtonEnabled = (permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] || canInviteOthersToProject && (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment')) && !(0, $dCm1o.isVisualRefreshEnabled)();
        return {
            isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
            projectId: projectId,
            projectKey: projectKey,
            projectName: projectName
        };
    }, [
        canInviteOthersToProject,
        permissions,
        projectId,
        projectKey,
        projectName
    ]);
};
const $0d1dae21c688c823$export$bf90a9d64f2df7e3 = ({ boardFilterRefinementQueryRef: boardFilterRefinementQueryRef, isActiveStandup: isActiveStandup })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = // eslint-disable-next-line jira/ff/no-preconditioning -- we are rolling out the fast follows after the experiment has started
    (0, $4R6GH.fg)('jira_theming_milestone_1_fast_follows') && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const assignees = (0, $67sX6.useBoardSelector)((0, $5mTgl.orderedWorkAssigneesByAccountIdSelector));
    const isBoardLoaded = (0, $67sX6.useBoardSelector)((0, $5mTgl.isBoardConfigLoaded));
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const jql = (0, $67sX6.useBoardSelector)((0, $5mTgl.getJqlFilter));
    const hasActiveOptimistic = (0, $67sX6.useBoardSelector)((0, $5mTgl.hasAnyActiveOptimistic));
    const jqlFilterActive = (0, $67sX6.useBoardSelector)((0, $5mTgl.isJqlFilterActive));
    const selectedCustomFilters = (0, $67sX6.useBoardSelector)((0, $5mTgl.getSelectedCustomFilters));
    const customFiltersActive = (0, $67sX6.useBoardSelector)((0, $8yiLS.isCustomFiltersActive));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const workFilters = (0, $67sX6.useBoardSelector)((0, $5mTgl.getWorkFilters));
    const boardFilterRefinementQueryData = (0, $8Uumt.usePreloadedQuery)((0, $ae01E.default), boardFilterRefinementQueryRef);
    const [filterRefinementFragment, refetch] = (0, $8Uumt.useRefetchableFragment)((0, $8ibCb.default), boardFilterRefinementQueryData);
    const scope = (0, $5uXOq.useMemo)(()=>({
            board: {
                boardId: Number(boardId),
                swimlaneStrategy: swimlaneMode && (0, $cjoN4.swimlaneModeToStrategiesFilterRefinement)[swimlaneMode]
            }
        }), [
        boardId,
        swimlaneMode
    ]);
    const [suspenselessRefetch] = (0, $1othz.useSuspenselessRefetch)((0, $26Asg.default), refetch, {
        fetchPolicy: 'network-only'
    });
    /* eslint-disable react-hooks/rules-of-hooks */ if ((0, $4R6GH.fg)('update_assingee_after_inline_edit_fix')) {
        const previousAssignees = (0, $5uXOq.useRef)(assignees);
        // When we detect a change in board issue assignees after initial load, we perform a refetch to get the latest values
        // We wait till board doesn't have active optimistic updates in flight
        (0, $5uXOq.useEffect)(()=>{
            if (isBoardLoaded && !hasActiveOptimistic && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(assignees, previousAssignees.current)) {
                previousAssignees.current = assignees;
                suspenselessRefetch({
                    cloudId: cloudId,
                    scope: scope
                });
            }
        }, [
            assignees,
            cloudId,
            hasActiveOptimistic,
            isBoardLoaded,
            previousAssignees,
            scope,
            suspenselessRefetch
        ]);
    } else {
        const previousAssignees = (0, $1XJ20.usePrevious)(assignees);
        // When we detect a change in board issue assignees after initial load, we perform a refetch to get the latest values
        (0, $5uXOq.useEffect)(()=>{
            if (isBoardLoaded && !(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(assignees, previousAssignees)) suspenselessRefetch({
                cloudId: cloudId,
                scope: scope
            });
        }, [
            assignees,
            cloudId,
            isBoardLoaded,
            previousAssignees,
            scope,
            suspenselessRefetch
        ]);
    }
    /* eslint-enable react-hooks/rules-of-hooks */ const fireFilterBarChangedEvent = (0, $5uXOq.useCallback)((filterType)=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'changeFilterBar', {
            filterType: filterType
        });
    }, [
        createAnalyticsEvent
    ]);
    const onSearch = (0, $5uXOq.useCallback)((newJql)=>{
        const newFilters = {
            // Remove all workFilters if jql is empty
            ...newJql.trim() !== '' ? workFilters.values : {},
            [(0, $dcff40112356dfc1$export$68d693c35a8d8866)]: selectedCustomFilters,
            [(0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)]: newJql
        };
        dispatch((0, $dnW4F.setAllFilters)(newFilters, (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)));
        fireFilterBarChangedEvent((0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f));
    }, [
        dispatch,
        fireFilterBarChangedEvent,
        selectedCustomFilters,
        workFilters.values
    ]);
    const onCustomFilterChange = (0, $5uXOq.useCallback)((customFilters)=>{
        const newFilters = {
            ...workFilters.values,
            [(0, $dcff40112356dfc1$export$68d693c35a8d8866)]: customFilters,
            [(0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)]: jql
        };
        dispatch((0, $dnW4F.setAllFilters)(newFilters, (0, $dcff40112356dfc1$export$68d693c35a8d8866)));
        fireFilterBarChangedEvent((0, $dcff40112356dfc1$export$68d693c35a8d8866));
    }, [
        dispatch,
        fireFilterBarChangedEvent,
        jql,
        workFilters.values
    ]);
    const onClear = (0, $5uXOq.useCallback)(()=>{
        dispatch((0, $dnW4F.setAllFilters)({}, (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)));
        fireFilterBarChangedEvent((0, $15a528573ccd89ae$export$6c4d37c7f376a1de));
    }, [
        dispatch,
        fireFilterBarChangedEvent
    ]);
    const hasFiltersApplied = jqlFilterActive || customFiltersActive;
    const addPeopleButtonProps = $0d1dae21c688c823$var$useAddPeopleButtonProps();
    const onError = (_, error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            screenName: 'board',
            task: 'loadCustomFilters',
            isNetworkError: (0, $fZneA.isClientFetchError)(error),
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: (0, $4R6GH.fg)('filter-refinement-board-fix-button-spacing') ? 'space.100' : 'space.075',
        shouldWrap: true,
        xcss: isSoftwareFullTheming && $0d1dae21c688c823$var$themedStyling
    }, isSoftwareFullTheming ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7mRzW.default), {
        debounce: 0,
        defaultJql: jql || '',
        onSearch: onSearch,
        fragmentRef: filterRefinementFragment,
        searchFieldPlaceholder: formatMessage((0, $jWrFu.default).filterRefinementSearchFieldPlaceholder),
        scope: scope,
        changeboardingMessageId: $0d1dae21c688c823$var$CHANGEBOARDING_MESSAGE_ID,
        showAssigneeFilter: !isActiveStandup,
        ...addPeopleButtonProps,
        isSoftwareFullTheming: isSoftwareFullTheming
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7mRzW.default), {
        debounce: 0,
        defaultJql: jql || '',
        onSearch: onSearch,
        fragmentRef: filterRefinementFragment,
        searchFieldPlaceholder: formatMessage((0, $jWrFu.default).filterRefinementSearchFieldPlaceholder),
        scope: scope,
        changeboardingMessageId: $0d1dae21c688c823$var$CHANGEBOARDING_MESSAGE_ID,
        showAssigneeFilter: !isActiveStandup,
        ...addPeopleButtonProps
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "custom-filter-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: 'board'
        },
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $05fhZ.default), {
        screenName: "board",
        onChange: onCustomFilterChange,
        selectedFilters: selectedCustomFilters,
        customFiltersFragmentRef: boardFilterRefinementQueryData,
        removeOuterPadding: true
    })), hasFiltersApplied && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oCwY.default), {
        onClick: onClear
    }));
};
const $0d1dae21c688c823$var$themedStyling = (0, $8CUq3.xcss)({
    // @ts-expect-error --ds-background-input does not exist as a key
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/no-unsafe-design-token-usage
    '--ds-background-input': (0, $6cG4N.Tokens).COLOR_BACKGROUND_INPUT,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/no-unsafe-design-token-usage
    '--ds-background-input-pressed': (0, $6cG4N.Tokens).COLOR_BACKGROUND_INPUT,
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values, @atlaskit/design-system/no-unsafe-design-token-usage
    '--ds-background-input-hovered': (0, $6cG4N.Tokens).COLOR_BACKGROUND_INPUT
});

});
parcelRegister("8ibCb", function(module, exports) {

$parcel$export(module.exports, "default", () => $10fe7aedf9c6bc51$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<97e62843878afb25d77ce5a74b084c17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck

var $26Asg = parcelRequire("26Asg");
const $10fe7aedf9c6bc51$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scope"
        }
    ],
    "kind": "Fragment",
    "metadata": {
        "refetch": {
            "fragmentPathInResult": [],
            "operation": (0, $26Asg.default)
        }
    },
    "name": "boardFilterRefinement_softwareBoard",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "scope"
                }
            ],
            "kind": "FragmentSpread",
            "name": "ui_filterRefinement_FilterRefinement"
        }
    ],
    "type": "Query"
};
$10fe7aedf9c6bc51$var$node.hash = "9bf0ca6b005e985814f36248385113e3";
var $10fe7aedf9c6bc51$export$2e2bcd8739ae039 = $10fe7aedf9c6bc51$var$node;

});
parcelRegister("26Asg", function(module, exports) {

$parcel$export(module.exports, "default", () => $51f2f8c47b0f2211$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<6e5b5eaa7644cca661922cc1817c57d5>>
 * @relayHash 873051a74587d6c49f05196ce773f399
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 6ff904961b309477abb532380594e59bfdf262d775e0e87da6eb4e5fe33ed6e9
const $51f2f8c47b0f2211$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scope"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    }, v3 = {
        "kind": "ScalarField",
        "name": "__typename"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "boardFilterRefinementRefetchQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "boardFilterRefinement_softwareBoard"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "boardFilterRefinementRefetchQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "jqlTerm",
                                            "value": "assignee"
                                        },
                                        v2 /*: any*/ 
                                    ],
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v3 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jqlTerm"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v3 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "id"
                                                                        }
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "6ff904961b309477abb532380594e59bfdf262d775e0e87da6eb4e5fe33ed6e9",
            "metadata": {},
            "name": "boardFilterRefinementRefetchQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$51f2f8c47b0f2211$var$node.hash = "9bf0ca6b005e985814f36248385113e3";
var $51f2f8c47b0f2211$export$2e2bcd8739ae039 = $51f2f8c47b0f2211$var$node;

});


parcelRegister("ae01E", function(module, exports) {

$parcel$export(module.exports, "default", () => $810133a175ef8429$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b788e8986813dbe366efc5cf8d5552df>>
 * @relayHash 5c749d389bf268ee9226560ad568adcf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06

var $eiowN = parcelRequire("eiowN");
const $810133a175ef8429$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "boardId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "filterRefinementScope"
    }, v3 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v4 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "filterRefinementScope"
    }, v5 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v6 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v7 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "boardFilterRefinementQuery",
            "selections": [
                {
                    "args": [
                        v3 /*: any*/ ,
                        v4 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "boardFilterRefinement_softwareBoard"
                },
                {
                    "args": v5 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "boardFilterRefinementQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v3 /*: any*/ 
                            ],
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        {
                                            "kind": "Literal",
                                            "name": "first",
                                            "value": 100
                                        },
                                        {
                                            "kind": "Literal",
                                            "name": "jqlTerm",
                                            "value": "assignee"
                                        },
                                        v4 /*: any*/ 
                                    ],
                                    "concreteType": "JiraJqlFieldValueConnection",
                                    "kind": "LinkedField",
                                    "name": "fieldValues",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "JiraJqlFieldValueEdge",
                                            "kind": "LinkedField",
                                            "name": "edges",
                                            "plural": true,
                                            "selections": [
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "node",
                                                    "plural": false,
                                                    "selections": [
                                                        v6 /*: any*/ ,
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "jqlTerm"
                                                        },
                                                        {
                                                            "kind": "ScalarField",
                                                            "name": "displayName"
                                                        },
                                                        {
                                                            "kind": "InlineFragment",
                                                            "selections": [
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "user",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v6 /*: any*/ ,
                                                                        {
                                                                            "kind": "ScalarField",
                                                                            "name": "picture"
                                                                        },
                                                                        v7 /*: any*/ 
                                                                    ]
                                                                }
                                                            ],
                                                            "type": "JiraJqlUserFieldValue"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                },
                {
                    "args": v5 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v7 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v7 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "9283dbd6d43bd23893ba0d1fb905c533d07635b370710c93db0ea67cb8b41e06",
            "metadata": {},
            "name": "boardFilterRefinementQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$810133a175ef8429$var$node.hash = "76e69ce3a16eaa498d6a510d99a80a5c";
(0, $eiowN.PreloadableQueryRegistry).set($810133a175ef8429$var$node.params.id, $810133a175ef8429$var$node);
var $810133a175ef8429$export$2e2bcd8739ae039 = $810133a175ef8429$var$node;

});

parcelRegister("7mRzW", function(module, exports) {

$parcel$export(module.exports, "default", () => $6ee1abd0b3407e7a$export$2e2bcd8739ae039);

var $ijJNp = parcelRequire("ijJNp");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $f5TWP = parcelRequire("f5TWP");

var $8Ec39 = parcelRequire("8Ec39");

var $jDrwg = parcelRequire("jDrwg");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $7CMCs = parcelRequire("7CMCs");

var $hOHOl = parcelRequire("hOHOl");

var $hZ2JJ = parcelRequire("hZ2JJ");


var $35aD0 = parcelRequire("35aD0");

var $c73Ug = parcelRequire("c73Ug");

var $8ukYE = parcelRequire("8ukYE");

var $3O3s8 = parcelRequire("3O3s8");
const $6ee1abd0b3407e7a$var$Filter = ({ debounce: debounce = 500, defaultJql: defaultJql, onSearch: onSearch, ...props })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleOnSearch = (0, $5uXOq.useCallback)((updateJql, fieldType, amountOfSelectedOptionOfFieldType)=>{
        onSearch && onSearch(updateJql);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'changed',
            actionSubject: 'filterRefinement',
            actionSubjectId: 'changedFilterRefinement',
            attributes: {
                source: (0, $c2106d117ddd8c57$export$a3821bc63538b210),
                fieldType: fieldType,
                amountOfSelectedOptionsOfFieldType: amountOfSelectedOptionOfFieldType
            }
        });
    }, [
        onSearch,
        createAnalyticsEvent
    ]);
    const [handleSearchDebounced] = (0, $jDrwg.default)(handleOnSearch, debounce);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $c2106d117ddd8c57$export$a3821bc63538b210),
        packageName: (0, $c2106d117ddd8c57$export$b8b9d90f9e5bd72b),
        teamName: (0, $c2106d117ddd8c57$export$d57b6b390e78d90f),
        sendToPrivacyUnsafeSplunk: true,
        fallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3O3s8.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hOHOl.AstContainer), {
        defaultJql: defaultJql,
        onJqlChange: handleSearchDebounced
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6ee1abd0b3407e7a$var$FilterRefinement, {
        ...props,
        defaultJql: defaultJql
    })));
};
const $6ee1abd0b3407e7a$var$FilterRefinement = ({ defaultJql: defaultJql, fragmentRef: fragmentRef, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectId: projectId, projectKey: projectKey, projectName: projectName, scope: scope, searchFieldPlaceholder: searchFieldPlaceholder, showAssigneeFilter: showAssigneeFilter = true, changeboardingMessageId: changeboardingMessageId, isSoftwareFullTheming: isSoftwareFullTheming })=>{
    const numberOfSelectedValues = (0, $hZ2JJ.useNumberOfSelectedValues)();
    const data = (0, $8Uumt.useFragment)((0, $ijJNp.default), fragmentRef);
    const analyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            isAssigneeFilterRendered: showAssigneeFilter,
            numberOfSelectedValues: numberOfSelectedValues,
            changeboardingMessageId: changeboardingMessageId
        }), [
        numberOfSelectedValues,
        showAssigneeFilter,
        changeboardingMessageId
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8Ec39.default), {
        name: "filter-refinement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $c2106d117ddd8c57$export$a3821bc63538b210),
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            ...analyticsAttributes,
            isDefaultJql: defaultJql !== undefined
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        space: "space.075"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8ukYE.default), {
        inputLabel: searchFieldPlaceholder
    }), showAssigneeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $35aD0.AssigneePicker), {
        fragmentRef: data,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        projectKey: projectKey,
        projectId: projectId,
        projectName: projectName
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c73Ug.FilterPopup), {
        scope: scope,
        changeboardingMessageId: changeboardingMessageId,
        isSoftwareFullTheming: isSoftwareFullTheming
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "screen",
        action: "viewed",
        actionSubjectId: "filterRefinement"
    })));
};
var $6ee1abd0b3407e7a$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6ee1abd0b3407e7a$var$Filter);

});
parcelRegister("ijJNp", function(module, exports) {

$parcel$export(module.exports, "default", () => $2bbc2e50185d67d8$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<fe92ddba5b4701ee4c883cf0ddaa04ad>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $2bbc2e50185d67d8$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scope"
        }
    ],
    "kind": "Fragment",
    "name": "ui_filterRefinement_FilterRefinement",
    "selections": [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "cloudId",
                    "variableName": "cloudId"
                },
                {
                    "kind": "Variable",
                    "name": "scope",
                    "variableName": "scope"
                }
            ],
            "kind": "FragmentSpread",
            "name": "assigneePicker_filterRefinement"
        }
    ],
    "type": "Query"
};
$2bbc2e50185d67d8$var$node.hash = "3a7cc5342cef1417af0126b6a4c255eb";
var $2bbc2e50185d67d8$export$2e2bcd8739ae039 = $2bbc2e50185d67d8$var$node;

});

parcelRegister("jDrwg", function(module, exports) {

$parcel$export(module.exports, "default", () => $049f084810e3e7c4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");
function $049f084810e3e7c4$export$2e2bcd8739ae039(callback, delay, options) {
    const optionsRef = (0, $5uXOq.useRef)(options);
    // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
    const callbackRef = (0, $5uXOq.useRef)((...args)=>{
        callback(...args);
    });
    callbackRef.current = callback;
    const debouncedCallBack = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/no-explicit-any
    ()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((...args)=>callbackRef.current(...args), delay, optionsRef.current), [
        delay
    ]);
    (0, $5uXOq.useEffect)(()=>debouncedCallBack.cancel, [
        debouncedCallBack
    ]);
    return [
        debouncedCallBack,
        debouncedCallBack.cancel
    ];
}

});

parcelRegister("35aD0", function(module, exports) {

$parcel$export(module.exports, "AssigneePicker", () => $a8750aeed8a7b9fd$export$7b6a3e006e99ad57);

var $fwC9k = parcelRequire("fwC9k");

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8Uumt = parcelRequire("8Uumt");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $1beWO = parcelRequire("1beWO");

var $g5X3G = parcelRequire("g5X3G");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $90yGq = parcelRequire("90yGq");


var $d8C6F = parcelRequire("d8C6F");

var $hZ2JJ = parcelRequire("hZ2JJ");

var $hOHOl = parcelRequire("hOHOl");
const $a8750aeed8a7b9fd$var$useAssignees = (data)=>{
    return (0, $5uXOq.useMemo)(()=>{
        const result = [];
        data.jira?.jqlBuilder?.fieldValues.edges?.forEach((edge)=>{
            if (edge?.node != null) {
                // empty is normalized to lowercase for easier AST and analytics matching
                const id = edge.node.__typename === 'JiraJqlEmptyFieldValue' ? 'empty' : edge.node.jqlTerm;
                result.push({
                    id: (0, $g5X3G.toAccountId)(id),
                    displayName: edge.node.displayName,
                    avatarUrl: edge.node.user?.picture
                });
            }
        });
        return result;
    }, [
        data.jira?.jqlBuilder?.fieldValues?.edges
    ]);
};
const $a8750aeed8a7b9fd$var$AddPeopleModal = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
function $a8750aeed8a7b9fd$var$getAnalyticsData(currentUserAccountId, avatarAccountId, amountOfSelectedOptionsOfFieldType) {
    return {
        action: 'clicked',
        actionSubject: 'avatar',
        actionSubjectId: 'chooseAssignee',
        attributes: {
            isMe: avatarAccountId === currentUserAccountId,
            isUnassigned: avatarAccountId === 'empty',
            amountOfSelectedOptionsOfFieldType: amountOfSelectedOptionsOfFieldType
        }
    };
}
const $a8750aeed8a7b9fd$export$7b6a3e006e99ad57 = ({ fragmentRef: fragmentRef, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled = false, projectId: projectId, projectKey: projectKey, projectName: projectName })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const currentUserAccountId = (0, $90yGq.useAccountId)();
    // TODO: shared assignee picker doesn't have pagination, re-evaluate number of field values we fetch based on data
    const data = (0, $8Uumt.useFragment)((0, $fwC9k.default), fragmentRef);
    const assignees = $a8750aeed8a7b9fd$var$useAssignees(data);
    const selectedAssignees = (0, $hZ2JJ.useSelectedValues)((0, $c2106d117ddd8c57$export$f8f7545d2bb78afb));
    const { addValueToClause: addValueToClause, removeValueFromClause: removeValueFromClause, getTotalCount: getTotalCount } = (0, $d8C6F.useClauseUpdater)((0, $c2106d117ddd8c57$export$f8f7545d2bb78afb));
    const { updateJql: updateJql } = (0, $hOHOl.useASTActions)();
    (0, $5uXOq.useEffect)(()=>{
        if (assignees.length === 0) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'filterRefinementAssigneePicker emptyAssigneeList');
    }, [
        assignees.length,
        createAnalyticsEvent
    ]);
    const onToggle = (0, $5uXOq.useCallback)((accountId)=>{
        updateJql({
            jql: selectedAssignees.includes(accountId) ? removeValueFromClause(accountId) : addValueToClause(accountId),
            fieldType: (0, $c2106d117ddd8c57$export$f8f7545d2bb78afb),
            amountOfSelectedOptionsOfFieldType: getTotalCount()
        });
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), $a8750aeed8a7b9fd$var$getAnalyticsData(currentUserAccountId, accountId, getTotalCount()));
    }, [
        addValueToClause,
        createAnalyticsEvent,
        currentUserAccountId,
        getTotalCount,
        removeValueFromClause,
        selectedAssignees,
        updateJql
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            isAddPeopleButtonEnabled && $a8750aeed8a7b9fd$var$ContainerStyleWithAddPeopleButton
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1beWO.default), {
        screenName: (0, $c2106d117ddd8c57$export$a3821bc63538b210),
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        maxUsers: 7,
        onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onToggle: onToggle,
        // only used in AddPeopleModal, setting to -1 to avoid typescript problem
        projectId: projectId ?? -1,
        projectKey: projectKey,
        selectedUsers: selectedAssignees,
        projectName: projectName,
        users: assignees,
        // no need to add people modal, since it is already within AssigneeFilter
        AddPeopleModal: $a8750aeed8a7b9fd$var$AddPeopleModal
    }));
};
const $a8750aeed8a7b9fd$var$ContainerStyleWithAddPeopleButton = (0, $8CUq3.xcss)({
    // to align with 10px spacing between people avatars and addPeople button
    paddingInlineEnd: 'space.025',
    display: 'flex',
    alignItems: 'center'
});

});
parcelRegister("fwC9k", function(module, exports) {

$parcel$export(module.exports, "default", () => $c20c7900ad7c4597$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<52a2cbe0bf0080bd25fb7f62eeb10dbb>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $c20c7900ad7c4597$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scope"
        }
    ],
    "kind": "Fragment",
    "name": "assigneePicker_filterRefinement",
    "selections": [
        {
            "concreteType": "JiraQuery",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        }
                    ],
                    "concreteType": "JiraJqlBuilder",
                    "kind": "LinkedField",
                    "name": "jqlBuilder",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "RequiredField",
                            "field": {
                                "args": [
                                    {
                                        "kind": "Literal",
                                        "name": "first",
                                        "value": 100
                                    },
                                    {
                                        "kind": "Literal",
                                        "name": "jqlTerm",
                                        "value": "assignee"
                                    },
                                    {
                                        "kind": "Variable",
                                        "name": "scope",
                                        "variableName": "scope"
                                    }
                                ],
                                "concreteType": "JiraJqlFieldValueConnection",
                                "kind": "LinkedField",
                                "name": "fieldValues",
                                "plural": false,
                                "selections": [
                                    {
                                        "concreteType": "JiraJqlFieldValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                            {
                                                "kind": "LinkedField",
                                                "name": "node",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "__typename"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "jqlTerm"
                                                    },
                                                    {
                                                        "kind": "ScalarField",
                                                        "name": "displayName"
                                                    },
                                                    {
                                                        "kind": "InlineFragment",
                                                        "selections": [
                                                            {
                                                                "kind": "LinkedField",
                                                                "name": "user",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "ScalarField",
                                                                        "name": "picture"
                                                                    }
                                                                ]
                                                            }
                                                        ],
                                                        "type": "JiraJqlUserFieldValue"
                                                    }
                                                ]
                                            }
                                        ]
                                    }
                                ]
                            },
                            "action": "THROW",
                            "path": "jira.jqlBuilder.fieldValues"
                        }
                    ]
                }
            ]
        }
    ],
    "type": "Query"
};
$c20c7900ad7c4597$var$node.hash = "389e11e86ee7322e3518b7a34bf6edd9";
var $c20c7900ad7c4597$export$2e2bcd8739ae039 = $c20c7900ad7c4597$var$node;

});

parcelRegister("1beWO", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f4b1966602deeb5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $6s1PB = parcelRequire("6s1PB");

var $2OMDV = parcelRequire("2OMDV");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $12hlA = parcelRequire("12hlA");


var $efvDm = parcelRequire("efvDm");

var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $cpQgt = parcelRequire("cpQgt");

var $j6etC = parcelRequire("j6etC");

var $eJpZk = parcelRequire("eJpZk");

var $lAu6N = parcelRequire("lAu6N");
const $6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics = (0, $2OMDV.AnalyticsEventToProps)('StatelessAssigneeFilterWithAnalytics', {
    onAddPeopleClick: 'clicked'
})((0, $lAu6N.default));
$6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics.displayName = 'StatelessAssigneeFilterWithAnalytics';
const $6f4b1966602deeb5$export$804bfdea59f89629 = (baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, jswEdition, analyticsEvent, screenName, fireTriggerClickEvent)=>{
    const openAddPeopleModal = ()=>{
        setShowAddPeopleModal(!showAddPeopleModal);
    };
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (jswEdition === (0, $ldyPw.toEdition)((0, $ldyPw.FREE_EDITION))) (0, $j6etC.getRemainingSeats)(baseUrl, (0, $c06e1abca7c13910$export$1346c9aa3cbb477d)).then((remainingSeats)=>{
        if (remainingSeats === 0) {
            // When the JSW Free instance is at the user limit and
            // the user is enrolled in the auto-upgrade experiment, fire an exposure event
            if (expConfig.get('cohort', 'not-enrolled') !== 'not-enrolled') {
                const [, fireExposureEvent] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
                fireExposureEvent();
            }
            fireTriggerClickEvent();
            // If the user is in the auto-upgrade experiment variation cohort, show the invite modal.
            // Otherwise, show the upsell dialog.
            if (expConfig.get('cohort', 'not-enrolled') === 'variation') openAddPeopleModal();
            else {
                setShowUpSell(!showUpSell);
                if (!showUpSell) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, `${screenName}AssigneeFilterAddPeople`);
            }
        } else {
            fireTriggerClickEvent();
            openAddPeopleModal();
        }
    }).catch((e)=>{
        fireTriggerClickEvent();
        openAddPeopleModal();
        throw e;
    });
    else {
        fireTriggerClickEvent();
        // If not on JSW Free, always show the invite modal
        openAddPeopleModal();
    }
};
const $6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper = (props)=>{
    const { children: children, showUpsellDialog: showUpsellDialog, setShowUpsellDialog: setShowUpsellDialog, screenName: screenName } = props;
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_allow_project_invite_past_10th_user_on_free');
    if (expConfig.get('cohort', 'not-enrolled') === 'variation') // When the user is in the experiment variation cohort, we won't be showing the upsell dialog.
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
    const onUpgradeDialogClose = ()=>{
        setShowUpsellDialog(false);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cpQgt.default), {
        isOpen: showUpsellDialog,
        onClose: onUpgradeDialogClose,
        touchpointId: `${screenName || ''}${screenName ? 'A' : 'a'}ssigneeFilterAddPeople`,
        onUpFlowDismiss: onUpgradeDialogClose
    }, children);
};
const $6f4b1966602deeb5$export$20e0939737a940df = (props)=>{
    const { users: users, maxUsers: maxUsers, AddPeopleModal: AddPeopleModal, screenName: screenName, selectedUsers: selectedUsers, onToggle: onToggle, projectId: projectId, isAddPeopleButtonEnabled: isAddPeopleButtonEnabled, projectName: projectName, projectKey: projectKey, onAssigneeMenuOpen: onAssigneeMenuOpen, shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge, onClickUnassignedFilterNudge: onClickUnassignedFilterNudge } = props;
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const [showAddPeopleModal, setShowAddPeopleModal] = (0, $5uXOq.useState)(false);
    const [showUpSell, setShowUpSell] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const appEdition = (0, $ldyPw.getEdition)((0, $efvDm.JIRA_SOFTWARE), tenantContext.appEditions);
    const onAddPeopleClick = (0, $5uXOq.useCallback)((analyticsEvent)=>{
        const fireAddPeopleClickEvent = ()=>{
            // If neither the upsell dialog nor the invite modal is currently open,
            // then the user is trying to open one of them. When this happens,
            // we fire an analytics event.
            if (!showAddPeopleModal && !showUpSell) {
                const event = createAnalyticsEvent({
                    action: 'clicked',
                    actionSubject: 'button',
                    source: screenName
                });
                (0, $8zOmE.fireUIAnalytics)(event, 'assigneeFilterAddPeople');
            }
        };
        $6f4b1966602deeb5$export$804bfdea59f89629(tenantContext.baseUrl, setShowUpSell, showUpSell, setShowAddPeopleModal, showAddPeopleModal, appEdition, analyticsEvent, screenName || '', fireAddPeopleClickEvent);
    }, [
        createAnalyticsEvent,
        tenantContext.baseUrl,
        showUpSell,
        showAddPeopleModal,
        appEdition,
        screenName
    ]);
    const onAddPeopleModalClose = (0, $5uXOq.useCallback)(()=>{
        setShowAddPeopleModal(false);
    }, []);
    const showAddPeopleButton = AddPeopleModal !== undefined && isAddPeopleButtonEnabled;
    const addButtonRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$ConditionalUpsellDialogWrapper, {
        showUpsellDialog: showUpSell,
        setShowUpsellDialog: setShowUpSell,
        screenName: screenName
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6f4b1966602deeb5$var$StatelessAssigneeFilterWithAnalytics, {
        peopleRef: addButtonRef,
        users: users,
        maxUsers: maxUsers,
        selectedUsers: selectedUsers,
        onToggle: onToggle,
        onAddPeopleClick: onAddPeopleClick,
        showAddPeopleButton: showAddPeopleButton,
        screenName: screenName || '',
        projectId: projectId,
        onAssigneeMenuOpen: onAssigneeMenuOpen,
        shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge,
        onClickUnassignedFilterNudge: onClickUnassignedFilterNudge
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eJpZk.Analytics), {
        baseUrl: tenantContext.baseUrl,
        projectId: projectId,
        screenName: screenName || '',
        showAddPeopleButton: showAddPeopleButton
    }), AddPeopleModal && showAddPeopleModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $12hlA.default), {
        inviteRef: addButtonRef,
        appEdition: appEdition,
        cloudId: tenantContext.cloudId,
        isOpen: true,
        onClose: onAddPeopleModalClose,
        jiraProjectName: projectName,
        projectId: projectId,
        jiraProjectKey: projectKey,
        isSiteAdmin: tenantContext.isSiteAdmin
    }));
};
$6f4b1966602deeb5$export$20e0939737a940df.defaultProps = {
    users: [],
    selectedUsers: [],
    maxUsers: 5,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    AddPeopleModal: undefined,
    isAddPeopleButtonEnabled: false,
    projectId: -1
};
const $6f4b1966602deeb5$var$AssigneeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($6f4b1966602deeb5$export$20e0939737a940df);
$6f4b1966602deeb5$var$AssigneeFilterComponent.displayName = 'AssigneeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<{ isAddPeopleButtonEnabled: boolean; readonly projectId: number; } & CommonAssigneeFilterProps & { AddPeopleModal: ComponentType<{ onClose: () => void; isOpen: boolean; }> | undefined; }>'.
$6f4b1966602deeb5$var$AssigneeFilterComponent.whyDidYouRender = true;
var $6f4b1966602deeb5$export$2e2bcd8739ae039 = $6f4b1966602deeb5$var$AssigneeFilterComponent;

});
parcelRegister("12hlA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0bc8c7c74346f034$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $0bc8c7c74346f034$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("dc1Hs")), {
    ssr: false,
    moduleId: "./src/packages/project-settings/invite-people-modal-project/src/index.tsx"
});
const $0bc8c7c74346f034$export$6a02a79fa2b0ddab = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-project-invite-people-modal",
        packageName: "jira-project-invite-people-modal",
        teamName: "groot-growth"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-invite-people-modal",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0bc8c7c74346f034$var$LazyComponent, props)));
var $0bc8c7c74346f034$export$2e2bcd8739ae039 = $0bc8c7c74346f034$export$6a02a79fa2b0ddab;

});
parcelRegister("dc1Hs", function(module, exports) {

let $99adb6ea021a0d60$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $99adb6ea021a0d60$var$load("76n7a"),
    $99adb6ea021a0d60$var$load("l253H"),
    $99adb6ea021a0d60$var$load("ffQaD"),
    $99adb6ea021a0d60$var$load("kvRbA"),
    $99adb6ea021a0d60$var$load("kNFvF"),
    $99adb6ea021a0d60$var$load("jLXj7")
]).then(()=>parcelRequire('3dNZP'));

});


parcelRegister("cpQgt", function(module, exports) {

$parcel$export(module.exports, "default", () => $1fee2ed613b7661e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $9yOBd = parcelRequire("9yOBd");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $iMd5l = parcelRequire("iMd5l");

var $cVzoY = parcelRequire("cVzoY");

var $34Vv8 = parcelRequire("34Vv8");

var $eHJxW = parcelRequire("eHJxW");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");


var $ldyPw = parcelRequire("ldyPw");

var $9OXo1 = parcelRequire("9OXo1");

var $2hXCB = parcelRequire("2hXCB");

var $02gpZ = parcelRequire("02gpZ");

var $4J6oz = parcelRequire("4J6oz");


var $de8ma = parcelRequire("de8ma");
const $1fee2ed613b7661e$var$fireCTAButtonAnalytics = (analyticsEvent, actionSubjectId, touchpointId, currentEdition)=>{
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, actionSubjectId, {
        currentEdition: currentEdition,
        touchpointId: touchpointId,
        targetEdition: (0, $4J6oz.applicationEditionToUpFlowEdition)((0, $ldyPw.STANDARD_EDITION)),
        isGrandfathered: false,
        isSiteAdmin: true,
        upFlowVariateFlag: 'experiment'
    });
};
const $1fee2ed613b7661e$var$showTryNowButton = (onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: "primary",
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label);
const $1fee2ed613b7661e$var$showLearnMoreButton = (appearance, onClick, label, href, target)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9yOBd.default), {
        appearance: appearance,
        onClick: onClick,
        href: href,
        target: target,
        rel: "noopener"
    }, label); // TODO split this file in to proper tangerine app structure, it's getting too big
const $1fee2ed613b7661e$var$UpgradeToAddUsersDialog = (props)=>{
    const { children: children, isOpen: isOpen, onClose: onClose, intl: intl, touchpointId: touchpointId, onUpFlowDismiss: onUpFlowDismiss } = props;
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const explicitlyLicensedProducts = (0, $cVzoY.default)(tenantContext);
    const hasOnlyJSW = explicitlyLicensedProducts.length === 1 && explicitlyLicensedProducts[0] === (0, $c06e1abca7c13910$export$1346c9aa3cbb477d);
    const [upFlowIframeState, setUpFlowIframeState] = (0, $5uXOq.useState)(null);
    const currentEdition = (0, $4J6oz.applicationEditionToUpFlowEdition)((0, $iMd5l.getProductEdition)(explicitlyLicensedProducts[0], tenantContext));
    const upgradeButtonOnClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $2hXCB.mapActionIdFromType)[0, $2hXCB.UPGRADE];
        $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $2hXCB.UPGRADE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const learnMoreButtonOnClick = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7006 - Parameter '_' implicitly has an 'any' type.
    (_, analyticsEvent)=>{
        const actionSubjectId = (0, $2hXCB.mapActionIdFromType)[0, $2hXCB.LEARN_MORE];
        $1fee2ed613b7661e$var$fireCTAButtonAnalytics(analyticsEvent, actionSubjectId, touchpointId, currentEdition);
        hasOnlyJSW && setUpFlowIframeState((0, $2hXCB.LEARN_MORE));
    }, [
        currentEdition,
        hasOnlyJSW,
        touchpointId
    ]);
    const onUpFlowIframeClose = (0, $5uXOq.useCallback)(()=>{
        setUpFlowIframeState(null);
        onUpFlowDismiss();
    }, [
        onUpFlowDismiss
    ]);
    const learnMoreButtonAppearance = tenantContext.isSiteAdmin ? 'link' : 'primary';
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: touchpointId,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eHJxW.JiraInlineDialog), {
        messageId: "up-flow-upgrade-to-add-users-dialog.inline-dialog",
        messageType: "transactional",
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "changeEditionGateway",
            sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), {
            attributes: {
                isSiteAdmin: tenantContext.isSiteAdmin,
                source: touchpointId
            }
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, intl.formatMessage((0, $de8ma.default).upgradeToAddUsersHeader)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1fee2ed613b7661e$var$MultiLineParagraph, null, intl.formatMessage((0, $de8ma.default).upgradeToAddUsersContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $1fee2ed613b7661e$var$buttonBarStyles
        }, tenantContext.isSiteAdmin ? $1fee2ed613b7661e$var$showTryNowButton(// @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        upgradeButtonOnClick, intl.formatMessage((0, $de8ma.default).upgradeButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$cfca87b5d4683694), hasOnlyJSW ? undefined : '_blank') : null, $1fee2ed613b7661e$var$showLearnMoreButton(learnMoreButtonAppearance, // @ts-expect-error - TS2345 - Argument of type '(_: any, analyticsEvent: UIAnalyticsEventInterface) => void' is not assignable to parameter of type '() => void'.
        learnMoreButtonOnClick, intl.formatMessage((0, $de8ma.default).learnMoreButtonLabel), hasOnlyJSW ? undefined : (0, $9996ddd22815931e$export$997e23a0aec74966), hasOnlyJSW ? undefined : '_blank')), upFlowIframeState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $02gpZ.UpFlowIFrame), {
            targetEdition: (0, $ldyPw.STANDARD_EDITION),
            product: explicitlyLicensedProducts[0],
            flow: upFlowIframeState,
            touchpointId: touchpointId,
            experienceTrackingEnabled: true,
            onClose: onUpFlowIframeClose
        })),
        isOpen: isOpen,
        onClose: onClose,
        placement: "bottom-start"
    }, children));
};
var $1fee2ed613b7661e$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)((0, $34Vv8.default)($1fee2ed613b7661e$var$UpgradeToAddUsersDialog));
const $1fee2ed613b7661e$var$buttonBarStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1fee2ed613b7661e$var$MultiLineParagraph = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "p", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5726vc6",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2hXCB", function(module, exports) {

$parcel$export(module.exports, "LEARN_MORE", () => $a61f434346a6f772$export$1979295cc80a7ec1);
$parcel$export(module.exports, "WORKFLOW_EDIT_PERMISSION_LEARN_MORE", () => $a61f434346a6f772$export$779203acbfa8bf12);
$parcel$export(module.exports, "UPGRADE", () => $a61f434346a6f772$export$fe5b785cab515b6e);
$parcel$export(module.exports, "mapActionIdFromType", () => $a61f434346a6f772$export$2bf527ee1645dc7d);
const $a61f434346a6f772$export$1979295cc80a7ec1 = 'learn-more';
const $a61f434346a6f772$export$779203acbfa8bf12 = 'workflow-edit-permission-learn-more';
const $a61f434346a6f772$export$fe5b785cab515b6e = 'upgrade';
const $a61f434346a6f772$export$2bf527ee1645dc7d = {
    [$a61f434346a6f772$export$1979295cc80a7ec1]: 'freeLearnMore',
    [$a61f434346a6f772$export$779203acbfa8bf12]: 'workflowEditLearnMore',
    [$a61f434346a6f772$export$fe5b785cab515b6e]: 'freeTryNow'
};

});

parcelRegister("02gpZ", function(module, exports) {

$parcel$export(module.exports, "UpFlowIFrame", () => $6cdd801078d648f3$export$e9eafd8c579e773d);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


var $4J6oz = parcelRequire("4J6oz");

var $g6ckq = parcelRequire("g6ckq");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6cdd801078d648f3$var$UpFlowIFrameLazy = (0, $kxZPA.lazy)(()=>(parcelRequire("jFIm4")), {
    moduleId: "./src/packages/growth/up-flow/up-flow-iframe/src/main.tsx"
});
const $6cdd801078d648f3$export$e9eafd8c579e773d = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
        packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
        teamName: "luna-growth",
        fallback: (0, $g6ckq.ChunkLoadErrorFlag),
        attributes: (0, $4J6oz.addChunkLoadErrorAnalyticsAttribute)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "flow-iframe-lazy",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6cdd801078d648f3$var$UpFlowIFrameLazy, props)));

});
const $abaf639d63a27f10$export$c73007a11ea7e52 = 'jiraUpFlowIframe';
const $abaf639d63a27f10$export$cb7e587097a78810 = 'upsell-edition';
const $abaf639d63a27f10$export$fb320338324d1328 = 'upflowIFrame';
const $abaf639d63a27f10$export$782491eab0c2154d = 'INITIATE_SPA_CLOSE';
const $abaf639d63a27f10$export$dc3263ec2276f3f3 = 'START_EDITION_POLLING';
const $abaf639d63a27f10$export$8a7c66f5574473bd = 'FINISH_EDITION_POLLING';
const $abaf639d63a27f10$export$c012ea75b4437aea = 'TRACK_EXPERIENCE_FAIL';
const $abaf639d63a27f10$export$1b2e801262ba754 = 'TRACK_EXPERIENCE_SUCCESS';
const $abaf639d63a27f10$export$b6cceaecfde9dc91 = 'SPA_READY';

parcelRegister("4J6oz", function(module, exports) {

$parcel$export(module.exports, "applicationEditionToUpFlowEdition", () => $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1);
$parcel$export(module.exports, "jiraUpFlowIframeUpgradePlanInteraction", () => $7e87fb5ffa0cfceb$export$7d4045a899f62dfd);
$parcel$export(module.exports, "addChunkLoadErrorAnalyticsAttribute", () => $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2);
$parcel$export(module.exports, "handleError", () => $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58);

var $5uXOq = parcelRequire("5uXOq");

var $dGrdR = parcelRequire("dGrdR");

var $jcw0u = parcelRequire("jcw0u");

var $ldyPw = parcelRequire("ldyPw");

var $bCf8q = parcelRequire("bCf8q");



var $ajCo3 = parcelRequire("ajCo3");
const $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7 = (attributes, error)=>{
    (0, $jcw0u.default)({
        meta: {
            // We use the same ID for all errors in the package for easier
            // management in data portal, and use attributes to identify an error instead.
            id: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            packageName: (0, $abaf639d63a27f10$export$c73007a11ea7e52),
            teamName: 'luna-growth'
        },
        attributes: {
            ...attributes
        },
        error: error
    });
};
const $7e87fb5ffa0cfceb$export$b48ea9d6b982b3e1 = (applicationEdition)=>{
    if (applicationEdition === (0, $ldyPw.FREE_EDITION)) return 0, $4c0643787f48cf65$export$e69af2c4378638a2;
    if (applicationEdition === (0, $ldyPw.STANDARD_EDITION)) return 0, $4c0643787f48cf65$export$7bc7dd5faba7ad6b;
    return 0, $4c0643787f48cf65$export$3fd0bbb8c68dc4c7;
};
const $7e87fb5ffa0cfceb$export$7d4045a899f62dfd = (0, $dGrdR.metrics).interaction({
    key: `${(0, $abaf639d63a27f10$export$c73007a11ea7e52)}.upgrade.plan`
});
const $7e87fb5ffa0cfceb$export$94ee0b5fca1e74d2 = (error)=>({
        chunkLoadError: (0, $bCf8q.isLoaderError)(error)
    });
const $7e87fb5ffa0cfceb$export$d3da1ecaf1206c58 = (subject, onClose, apiError)=>{
    $7e87fb5ffa0cfceb$export$e4e69593f7c9f3b7({
        subject: subject,
        message: apiError?.message || ''
    }, apiError);
    $7e87fb5ffa0cfceb$export$7d4045a899f62dfd.cancel();
    onClose();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ajCo3.CommerceApiErrorFlag), null);
};

});
const $4c0643787f48cf65$export$e69af2c4378638a2 = 'free';
const $4c0643787f48cf65$export$7bc7dd5faba7ad6b = 'standard';
const $4c0643787f48cf65$export$3fd0bbb8c68dc4c7 = 'premium';

parcelRegister("ajCo3", function(module, exports) {

$parcel$export(module.exports, "CommerceApiErrorFlag", () => $0ee877bbb47ef7cb$export$7ee77c445dd775b4);

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $cPOtr = parcelRequire("cPOtr");
const $0ee877bbb47ef7cb$export$7ee77c445dd775b4 = ()=>{
    const flagKey = (0, $7HGHK.toFlagId)('commerce-api-error');
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $cPOtr.default).title,
        description: (0, $cPOtr.default).description,
        isAutoDismiss: true,
        messageId: 'up-flow-iframe.common.ui.commerce-api-error-flag.show-flag.error',
        messageType: 'transactional'
    });
    return null;
};

});
parcelRegister("cPOtr", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8891414a165fed2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c8891414a165fed2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.title",
        "defaultMessage": "We can't upgrade your plan right now"
    },
    description: {
        "id": "up-flow-iframe.common.commerce-api-error-flag.description",
        "defaultMessage": "Try again, or if this keeps happening try contacting support"
    }
});

});



parcelRegister("g6ckq", function(module, exports) {

$parcel$export(module.exports, "ChunkLoadErrorFlag", () => $590350b4061b001a$export$7a9d9407b3a5f50e);

var $pa9q9 = parcelRequire("pa9q9");

var $7HGHK = parcelRequire("7HGHK");

var $bCf8q = parcelRequire("bCf8q");

var $kgvbW = parcelRequire("kgvbW");
const $590350b4061b001a$export$7a9d9407b3a5f50e = ({ error: error })=>{
    const flagKey = (0, $7HGHK.toFlagId)('chunk-load-error');
    const { showFlag: showFlag, dismissFlag: dismissFlag } = (0, $pa9q9.useFlagsService)();
    if ((0, $bCf8q.isLoaderError)(error)) showFlag({
        id: flagKey,
        key: flagKey,
        type: 'error',
        title: (0, $kgvbW.default).title,
        description: (0, $kgvbW.default).description,
        isAutoDismiss: true,
        messageId: 'up-flow-iframe.ui.chunk-load-error-flag.show-flag.error',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $kgvbW.default).refreshPageButton,
                onClick: ()=>{
                    dismissFlag(flagKey);
                    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                    window.location.reload();
                }
            }
        ]
    });
    return null;
};

});
parcelRegister("kgvbW", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae312d01f0160cd3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae312d01f0160cd3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "up-flow-iframe.chunk-load-error-flag.title",
        "defaultMessage": "Something went wrong"
    },
    description: {
        "id": "up-flow-iframe.chunk-load-error-flag.description",
        "defaultMessage": "Refresh the page and try again."
    },
    refreshPageButton: {
        "id": "up-flow-iframe.chunk-load-error-flag.refresh-page-button",
        "defaultMessage": "Refresh page"
    }
});

});


parcelRegister("jFIm4", function(module, exports) {

let $e52440a08cd37502$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $e52440a08cd37502$var$load("7mIf9"),
    $e52440a08cd37502$var$load("jXweD"),
    $e52440a08cd37502$var$load("76n7a"),
    $e52440a08cd37502$var$load("l253H"),
    $e52440a08cd37502$var$load("kVX56"),
    $e52440a08cd37502$var$load("kH0d9")
]).then(()=>parcelRequire('1W7nw'));

});


const $9996ddd22815931e$export$997e23a0aec74966 = 'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';
const $9996ddd22815931e$export$30ce584c3652886c = 'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects/#Edit-Workflows';
const $9996ddd22815931e$export$cfca87b5d4683694 = '/admin/billing/applications';

parcelRegister("de8ma", function(module, exports) {

$parcel$export(module.exports, "default", () => $fc942e740b757f44$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $fc942e740b757f44$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    upgradeToAddUsersHeader: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-header",
        "defaultMessage": "Upgrade to add users"
    },
    upgradeToAddUsersContent: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-to-add-users-content",
        "defaultMessage": "You've reached the maximum number of users for your plan.\nRemove existing users or upgrade to grow your team."
    },
    upgradeButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.upgrade-button-label",
        "defaultMessage": "Try it now"
    },
    learnMoreButtonLabel: {
        "id": "up-flow-upgrade-to-add-users-dialog.learn-more-button-label",
        "defaultMessage": "Learn more"
    }
});

});


parcelRegister("j6etC", function(module, exports) {

$parcel$export(module.exports, "getRemainingSeats", () => $1d52ab7e56655772$export$6397e3bbf35b34e3);

var $eusud = parcelRequire("eusud");
const $1d52ab7e56655772$var$toRemainingSeats = (json)=>json.remainingSeat;
const $1d52ab7e56655772$export$6397e3bbf35b34e3 = (baseUrl, applicationKey)=>(0, $eusud.performGetRequest)(`/rest/internal/2/invite-user/application/remaining-seat?key=${applicationKey}`).then((json)=>$1d52ab7e56655772$var$toRemainingSeats(json));

});

parcelRegister("eJpZk", function(module, exports) {

$parcel$export(module.exports, "Analytics", () => $981a920c7dd6e4e8$export$2b3af6baec22bd98);

var $5uXOq = parcelRequire("5uXOq");

var $2NMNM = parcelRequire("2NMNM");

var $1sLR4 = parcelRequire("1sLR4");

var $1zwpK = parcelRequire("1zwpK");

var $iqJSe = parcelRequire("iqJSe");
const $981a920c7dd6e4e8$export$2b3af6baec22bd98 = (props)=>{
    const { projectId: projectId, baseUrl: baseUrl, showAddPeopleButton: showAddPeopleButton, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (projectId >= 0 && showAddPeopleButton) Promise.all([
            (0, $1zwpK.getUserProjectRoles)(baseUrl, projectId),
            (0, $1sLR4.getProjectAccessLevel)(baseUrl, projectId)
        ]) // eslint-disable-next-line @typescript-eslint/no-explicit-any
        .then(([roleData, projectAccessLevel])=>{
            const projectRoleNames = roleData === null || roleData.projectRoleNames === null ? null : (0, $iqJSe.reduceCustomRoles)(roleData.projectRoleNames);
            (0, $iqJSe.fireAddPeopleRenderedEvent)(createAnalyticsEvent, screenName, projectId, projectRoleNames, projectAccessLevel);
        });
    }, [
        baseUrl,
        createAnalyticsEvent,
        projectId,
        screenName,
        showAddPeopleButton
    ]);
    return null;
};

});
parcelRegister("1sLR4", function(module, exports) {

$parcel$export(module.exports, "getProjectAccessLevel", () => $6d37e68816b91c3b$export$f5f97c28ee230e06);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $6d37e68816b91c3b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/internal/simplified/1.0/accesslevel/project/${projectId}`;
const $6d37e68816b91c3b$var$transform = (data)=>data.value;
const $6d37e68816b91c3b$export$f5f97c28ee230e06 = (baseUrl, projectId)=>{
    const request = ()=>(0, $eusud.performGetRequest)($6d37e68816b91c3b$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>$6d37e68816b91c3b$var$transform(data)).catch((error)=>{
        const attributes = error instanceof (0, $jJZqs.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchProjectAccessLevel',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("1zwpK", function(module, exports) {

$parcel$export(module.exports, "getUserProjectRoles", () => $845d77939718574b$export$3b587d1e1fe73b9d);

var $jcw0u = parcelRequire("jcw0u");

var $jJZqs = parcelRequire("jJZqs");

var $eusud = parcelRequire("eusud");
const $845d77939718574b$var$MEMBER_ROLE_NAME = 'Member';
const $845d77939718574b$var$VIEWER_ROLE_NAME = 'Viewer';
const $845d77939718574b$var$userProjectRoleNames = (data)=>data.map((projectRole)=>projectRole.name);
const $845d77939718574b$export$5a1a2e9d57f47aee = (data)=>data.some((role)=>role.name === $845d77939718574b$var$MEMBER_ROLE_NAME);
const $845d77939718574b$export$10eeb2d34050404e = (data)=>data.some((role)=>role.admin);
const $845d77939718574b$export$a4d7f3415bee4b75 = (data)=>data.some((role)=>role.name !== $845d77939718574b$var$VIEWER_ROLE_NAME && role.name !== $845d77939718574b$var$MEMBER_ROLE_NAME && !role.admin);
const $845d77939718574b$export$128fa18b7194ef = (baseUrl, projectId)=>`${baseUrl}/rest/api/3/project/${projectId}/roledetails?excludeConnectAddons=true&currentMember=true`;
const $845d77939718574b$export$3b587d1e1fe73b9d = (baseUrl, projectId)=>{
    const request = ()=>(0, $eusud.performGetRequest)($845d77939718574b$export$128fa18b7194ef(baseUrl, projectId));
    return request().then((data)=>({
            isMember: $845d77939718574b$export$5a1a2e9d57f47aee(data),
            isJiraAdmin: $845d77939718574b$export$10eeb2d34050404e(data),
            hasCustomRole: $845d77939718574b$export$a4d7f3415bee4b75(data),
            projectRoleNames: $845d77939718574b$var$userProjectRoleNames(data)
        })).catch((error)=>{
        const attributes = error instanceof (0, $jJZqs.default) ? {
            statusCode: error.statusCode,
            traceId: error.traceId
        } : {
            errorMessage: error.message
        };
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchUserProjectRoles',
                packageName: 'jiraFilters',
                teamName: 'a4t-tanuki'
            },
            error: error,
            attributes: attributes,
            sendToPrivacyUnsafeSplunk: true
        });
        return Promise.resolve(null);
    });
};

});

parcelRegister("iqJSe", function(module, exports) {

$parcel$export(module.exports, "fireAddPeopleRenderedEvent", () => $131644081500a421$export$8014b0c4810b7867);
$parcel$export(module.exports, "reduceCustomRoles", () => $131644081500a421$export$7f2d1c0dab5190f9);

var $8zOmE = parcelRequire("8zOmE");
const $131644081500a421$var$defaultProjectRoles = [
    'Administrator',
    'Member',
    'Viewer'
];
const $131644081500a421$export$ecf9824f02c8a125 = 'Custom Role';
const $131644081500a421$export$8014b0c4810b7867 = (createAnalyticsEvent, source, projectId, userProjectRoles, projectAccessLevel)=>{
    const analyticsEvent = createAnalyticsEvent({
        action: 'rendered',
        actionSubject: 'addPeopleButton',
        source: source
    });
    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, {
        projectId: projectId,
        userProjectRoles: userProjectRoles,
        projectAccessLevel: projectAccessLevel
    });
};
const $131644081500a421$export$7f2d1c0dab5190f9 = (userProjectRoles)=>{
    let hasCustomRole = false;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const modifiedProjectRoles = userProjectRoles.reduce((acc, role)=>{
        const isDefaultRole = $131644081500a421$var$defaultProjectRoles.includes(role);
        hasCustomRole = hasCustomRole || !isDefaultRole;
        if (isDefaultRole) acc.push(role);
        return acc;
    }, []);
    if (hasCustomRole) modifiedProjectRoles.push($131644081500a421$export$ecf9824f02c8a125);
    return modifiedProjectRoles;
};

});


parcelRegister("lAu6N", function(module, exports) {

$parcel$export(module.exports, "default", () => $020a81e9686d5942$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $k6T4f = parcelRequire("k6T4f");

var $az4zD = parcelRequire("az4zD");

var $dCm1o = parcelRequire("dCm1o");

var $kpzS0 = parcelRequire("kpzS0");

var $4R6GH = parcelRequire("4R6GH");

var $i9wmu = parcelRequire("i9wmu");

var $gQDFP = parcelRequire("gQDFP");

var $kfN7T = parcelRequire("kfN7T");

var $a43Dp = parcelRequire("a43Dp");

var $2eCzd = parcelRequire("2eCzd");

var $mafYu = parcelRequire("mafYu");
const $020a81e9686d5942$var$AssigneeFilter = (props)=>{
    const { users: users, selectedUsers: selectedUsers, maxUsers: maxUsers, onAddPeopleClick: onAddPeopleClick, showAddPeopleButton: showAddPeopleButton, onToggle: onToggle, onAssigneeMenuOpen: onAssigneeMenuOpen, intl: { formatMessage: formatMessage }, peopleRef: peopleRef, shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge, onClickUnassignedFilterNudge: onClickUnassignedFilterNudge } = props;
    const mainList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(0, maxUsers - 1) : users.slice(0), [
        users,
        maxUsers
    ]);
    const moreList = (0, $5uXOq.useMemo)(()=>users.length > maxUsers ? users.slice(maxUsers - 1) : [], [
        users,
        maxUsers
    ]);
    const { unassignedFilterNudgeRef: unassignedFilterNudgeRef } = (0, $4R6GH.fg)('unassigned_filter_kill_switch') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $kpzS0.useUnassignedFilterNudge)(!!shouldShowUnassignedFilterNudge && selectedUsers.length === 0) : {
        unassignedFilterNudgeRef: undefined
    };
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const handleShowMoreButtonClose = ()=>{
        setIsDropdownOpen(false);
    };
    const handleShowMoreButtonOpen = ()=>{
        setIsDropdownOpen(true);
        onAssigneeMenuOpen();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "fieldset",
        xcss: [
            (0, $dCm1o.isVisualRefreshEnabled)() ? $020a81e9686d5942$var$fieldsetStyles : $020a81e9686d5942$var$fieldsetStylesOld,
            isDropdownOpen && (0, $4R6GH.fg)('tanuki_a11y_q4') && $020a81e9686d5942$var$fieldsetStyleWhenDropdownOpen
        ],
        "data-test-id": "filters.ui.filters.assignee.stateless.assignee-filter",
        testId: "filters.ui.filters.assignee.stateless.assignee-filter" // eslint-disable-next-line react/jsx-props-no-spreading
        ,
        ...!(0, $4R6GH.fg)('tanuki_a11y_q4') && {
            style: {
                // Ensure layering of avatars does not conflict with anything else in the DOM tree
                zIndex: 0
            }
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarFilterLegend, {
        id: (0, $gQDFP.FILTER_PREFIX)
    }, formatMessage((0, $2eCzd.default).label)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($020a81e9686d5942$var$AvatarsList, null, mainList.map((user, index)=>unassignedFilterNudgeRef && user.id === (0, $gQDFP.UNASSIGNED_ID) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            key: user.id,
            ref: unassignedFilterNudgeRef
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
            radius: 24,
            testId: "filters.ui.filters.assignee.stateless.unassigned-filter-nudge"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a43Dp.default), {
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        }))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a43Dp.default), {
            key: user.id,
            zIndex: maxUsers - index,
            user: user,
            isSelected: selectedUsers.includes(user.id),
            onToggle: onToggle
        })), moreList.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $mafYu.default), {
        users: moreList,
        selectedUsers: selectedUsers,
        onItemActivated: onToggle,
        onOpen: (0, $4R6GH.fg)('tanuki_a11y_q4') ? handleShowMoreButtonOpen : onAssigneeMenuOpen,
        onClose: (0, $4R6GH.fg)('tanuki_a11y_q4') ? handleShowMoreButtonClose : undefined
    }), showAddPeopleButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kfN7T.default), {
        peopleButtonRef: peopleRef,
        onClick: onAddPeopleClick
    }), unassignedFilterNudgeRef && onClickUnassignedFilterNudge && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i9wmu.default), {
        onFilterClick: onClickUnassignedFilterNudge
    })));
};
$020a81e9686d5942$var$AssigneeFilter.defaultProps = {
    onAddPeopleClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onAssigneeMenuOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showAddPeopleButton: false
};
var $020a81e9686d5942$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($020a81e9686d5942$var$AssigneeFilter);
const $020a81e9686d5942$var$fieldsetStyles = (0, $8CUq3.xcss)({
    flexShrink: 0,
    border: 0
});
const $020a81e9686d5942$var$fieldsetStylesOld = (0, $8CUq3.xcss)({
    flexShrink: 0,
    border: 0,
    marginLeft: 'space.150'
});
const $020a81e9686d5942$var$fieldsetStyleWhenDropdownOpen = (0, $8CUq3.xcss)({
    zIndex: 'navigation'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $020a81e9686d5942$var$AvatarsList = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx2vrvc _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $020a81e9686d5942$var$AvatarFilterLegend = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "legend", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _kqswstnw _4t3it94y _1bsbt94y _ogto7mnp _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("kpzS0", function(module, exports) {

$parcel$export(module.exports, "useUnassignedFilterNudge", () => $7d0e9863f15e3edb$export$188562ecba3103e0);

var $9dZ1c = parcelRequire("9dZ1c");

var $4R6GH = parcelRequire("4R6GH");

var $6s1PB = parcelRequire("6s1PB");

var $cWw2k = parcelRequire("cWw2k");

var $LLfvm = parcelRequire("LLfvm");
const $7d0e9863f15e3edb$export$188562ecba3103e0 = (shouldShowUnassignedFilterNudge)=>{
    const { ref: unassignedFilterNudgeRef } = (0, $9dZ1c.useRegisterNudgeTarget)((0, $cWw2k.UNASSIGNED_FILTER_NUDGE_ID), shouldShowUnassignedFilterNudge && (0, $4R6GH.fg)('unassigned_filter_kill_switch'));
    const { isDismissed: isDismissed } = (0, $LLfvm.useDismissal)();
    if (!(0, $4R6GH.fg)('unassigned_filter_kill_switch')) return {
        unassignedFilterNudgeRef: undefined
    };
    const showUnassignedFilterNudge = (!isDismissed && shouldShowUnassignedFilterNudge && (0, $6s1PB.expValEquals)('software_business_board_unassigned_filter_ga', 'isEnabled', true)) === true;
    return {
        unassignedFilterNudgeRef: showUnassignedFilterNudge ? unassignedFilterNudgeRef : undefined
    };
};

});
parcelRegister("cWw2k", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "UNASSIGNED_FILTER_NUDGE_ID", () => $324eab48e202eedd$export$1169d60cf6ebc1dd);
$parcel$export(module.exports, "default", () => $324eab48e202eedd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eX4sQ = parcelRequire("eX4sQ");

var $84THj = parcelRequire("84THj");

var $42CjB = parcelRequire("42CjB");

var $5ujeO = parcelRequire("5ujeO");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSWNW = parcelRequire("cSWNW");

var $gwIPs = parcelRequire("gwIPs");

var $LLfvm = parcelRequire("LLfvm");

var $hIQwn = parcelRequire("hIQwn");
const $324eab48e202eedd$export$1169d60cf6ebc1dd = 'unassigned-filter-nudge';
const $324eab48e202eedd$var$UNASSIGNED_FILTER_NUDGE_ANALYTICS_ID = 'unassignedFilterNudge';
const $324eab48e202eedd$var$renderSpotlight = ({ onDismiss: onDismiss, onClick: onClick, formatMessage: formatMessage })=>{
    return /*#__PURE__*/ (0, $5uXOq.forwardRef)((_, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
            ref: ref
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
            heading: formatMessage((0, $hIQwn.default).header),
            headingAfterElement: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                icon: (iconProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
                        ...iconProps,
                        color: "var(--ds-icon-inverse, #FFFFFF)"
                    }),
                onClick: ()=>onDismiss(false),
                label: formatMessage((0, $hIQwn.default).dismissIconLabel),
                appearance: "subtle"
            }),
            actions: [
                {
                    text: formatMessage((0, $hIQwn.default).turnOnUnassignedFilter),
                    onClick: onClick
                }
            ],
            width: 374
        }, formatMessage((0, $hIQwn.default).content))));
};
const $324eab48e202eedd$var$PortalledNudgeWithChoreograph = (0, $cSWNW.withChoreographedRender)((0, $eX4sQ.PortalledNudge));
const $324eab48e202eedd$var$UnassignedFilterNudge = ({ props: { onFilterClick: onFilterClick } })=>{
    const [isHidden, setIsHidden] = (0, $5uXOq.useState)(false);
    const { hide: hide, dismiss: dismiss, hideCount: hideCount } = (0, $LLfvm.useDismissal)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onRender = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'nudgeSpotlightCard viewed', $324eab48e202eedd$var$UNASSIGNED_FILTER_NUDGE_ANALYTICS_ID, {
            viewedCount: hideCount + 1
        });
    }, [
        createAnalyticsEvent,
        hideCount
    ]);
    const onHide = (0, $5uXOq.useCallback)(()=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'button clicked', $324eab48e202eedd$var$UNASSIGNED_FILTER_NUDGE_ANALYTICS_ID, {
            isClickOutside: true,
            hideCount: hideCount + 1
        });
        setIsHidden(true);
        hide();
    }, [
        createAnalyticsEvent,
        hide,
        hideCount
    ]);
    const onDismiss = (0, $5uXOq.useCallback)((turnOnUnassignedFilter)=>{
        const event = createAnalyticsEvent({});
        (0, $8zOmE.fireUIAnalytics)(event, 'button clicked', $324eab48e202eedd$var$UNASSIGNED_FILTER_NUDGE_ANALYTICS_ID, {
            isClickOutside: false,
            hideCount: hideCount + 1,
            turnOnUnassignedFilter: turnOnUnassignedFilter
        });
        setIsHidden(true);
        dismiss();
    }, [
        createAnalyticsEvent,
        dismiss,
        hideCount
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        onFilterClick();
        onDismiss(true);
    }, [
        onDismiss,
        onFilterClick
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($324eab48e202eedd$var$PortalledNudgeWithChoreograph, {
        key: "unassigneeAvatarSpotlight",
        nudgeTargetId: $324eab48e202eedd$export$1169d60cf6ebc1dd,
        hidden: isHidden,
        setHidden: onHide,
        onOutsideClick: onHide,
        spotlightCard: $324eab48e202eedd$var$renderSpotlight({
            onDismiss: onDismiss,
            onClick: onClick,
            formatMessage: formatMessage
        }),
        position: "bottom-start",
        pulseBorderRadius: 24,
        onRender: onRender,
        messageId: $324eab48e202eedd$export$1169d60cf6ebc1dd,
        zIndex: (0, $gwIPs.layers).card
    });
};
var $324eab48e202eedd$export$2e2bcd8739ae039 = $324eab48e202eedd$var$UnassignedFilterNudge;

});
parcelRegister("LLfvm", function(module, exports) {

$parcel$export(module.exports, "useDismissal", () => $97b8aa505af0168a$export$b3877935e036662a);

var $5uXOq = parcelRequire("5uXOq");

var $1Wlq3 = parcelRequire("1Wlq3");

var $bXemr = parcelRequire("bXemr");

const $97b8aa505af0168a$export$b3877935e036662a = ()=>{
    const [hasSeenItKey, { setHasSeen: setHasSeen }] = (0, $1Wlq3.useHasSeenIt)({
        hasSeenItKey: (0, $f78b94b69e842dbc$export$f8315ba7d2f36d9d),
        skipFetch: false
    });
    const dismissalState = (0, $bXemr.getDismissalLocalStorageState)();
    const hide = (0, $5uXOq.useCallback)(()=>{
        const currentCount = (dismissalState.count ?? 0) + 1;
        // if the user dismisses the nudge 3 times, don't show it again
        if (currentCount > 2) {
            setHasSeen((0, $f78b94b69e842dbc$export$f8315ba7d2f36d9d));
            (0, $bXemr.clearDismissalLocalStorageState)();
            return;
        }
        (0, $bXemr.setDismissalLocalStorageState)({
            count: currentCount,
            dismissUntil: new Date().setHours(23, 59, 59, 999)
        });
    }, [
        dismissalState?.count,
        setHasSeen
    ]);
    const dismiss = (0, $5uXOq.useCallback)(()=>{
        setHasSeen((0, $f78b94b69e842dbc$export$f8315ba7d2f36d9d));
    }, [
        setHasSeen
    ]);
    return {
        isDismissed: !hasSeenItKey || hasSeenItKey.fetchStatus !== 'fetched' ? true : hasSeenItKey.value === true || dismissalState.count > 2 || dismissalState.dismissUntil >= Date.now(),
        hide: hide,
        dismiss: dismiss,
        hideCount: dismissalState?.count ?? 0
    };
};

});
parcelRegister("1Wlq3", function(module, exports) {

$parcel$export(module.exports, "useHasSeenIt", () => $5ab7c0bc4c83a238$export$e45ad3bcdc52605d);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $a6dLQ = parcelRequire("a6dLQ");
// Store inits empty - small optimization in case consumers aren't fetching/needing any keys due to
// what's rendered on the page or code FF'd off etc., keys will be added after first get / set
const $5ab7c0bc4c83a238$var$initialState = {};
// Temporary store we can use for onboarding experiments since have-i-seen-it services is recommended NOT to be used
// Later hopefully we can use Post office/the choreographer/choreographed components instead which should add "seen-it"
// functionality (will be later down the track - they are focusing on solving message collisions first)
const $5ab7c0bc4c83a238$var$store = (0, $iXqE5.createStore)({
    name: 'jira-onboarding-has-seen-it',
    initialState: $5ab7c0bc4c83a238$var$initialState,
    actions: $a6dLQ.actions
});
const $5ab7c0bc4c83a238$export$ef53ed8cd1582794 = (0, $3sQ5x.createHook)($5ab7c0bc4c83a238$var$store, {
    selector: (state, hasSeenItKey)=>{
        return state[hasSeenItKey];
    }
});
const $5ab7c0bc4c83a238$export$e45ad3bcdc52605d = ({ hasSeenItKey: hasSeenItKey, skipFetch: skipFetch = false })=>{
    const useLastFetchedHasSeenItResult = $5ab7c0bc4c83a238$export$ef53ed8cd1582794(hasSeenItKey);
    const [, { fetchHasSeen: fetchHasSeen }] = useLastFetchedHasSeenItResult;
    (0, $5uXOq.useEffect)(()=>{
        if (skipFetch) return;
        fetchHasSeen(hasSeenItKey);
    }, [
        fetchHasSeen,
        hasSeenItKey,
        skipFetch
    ]);
    return useLastFetchedHasSeenItResult;
};

});
parcelRegister("a6dLQ", function(module, exports) {

$parcel$export(module.exports, "actions", () => $617ab3ab1d9db18e$export$e324594224ef24da);

var $4IhVM = parcelRequire("4IhVM");

var $jC5HS = parcelRequire("jC5HS");
const $617ab3ab1d9db18e$export$e324594224ef24da = {
    fetchHasSeen: $4IhVM.fetchHasSeen,
    setHasSeen: $jC5HS.setHasSeen
};

});
parcelRegister("4IhVM", function(module, exports) {

$parcel$export(module.exports, "fetchHasSeen", () => $f019b2d8921642bd$export$e26ab58aa13c0861);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $b8sW5 = parcelRequire("b8sW5");
const $f019b2d8921642bd$export$e26ab58aa13c0861 = (hasSeenKey)=>async ({ getState: getState, setState: setState })=>{
        const currentState = getState();
        const currentStateForHasSeenKey = currentState[hasSeenKey];
        if (currentStateForHasSeenKey?.fetchStatus === 'fetched' || currentStateForHasSeenKey?.fetchStatus === 'fetching' || // currently no retry on error
        currentStateForHasSeenKey?.fetchStatus === 'errored') return;
        setState({
            [hasSeenKey]: {
                fetchStatus: 'fetching'
            }
        });
        const response = await (0, $b8sW5.performFetchHasSeenRequest)(hasSeenKey);
        if (response === 'errored') setState({
            [hasSeenKey]: {
                fetchStatus: 'errored'
            }
        });
        else setState({
            [hasSeenKey]: {
                fetchStatus: 'fetched',
                value: response
            }
        });
    };

});
parcelRegister("b8sW5", function(module, exports) {

$parcel$export(module.exports, "performFetchHasSeenRequest", () => $8438e8b78f570762$export$a32677d9d29a038c);

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $gfZHU = parcelRequire("gfZHU");
const $8438e8b78f570762$export$a32677d9d29a038c = async (hasSeenKey)=>{
    try {
        const response = await (0, $aHuqL.userPreferenceAPI).get((0, $gfZHU.createHasSeenPrefixedKey)(hasSeenKey));
        // if response is null, it means the user has not interacted with the feature yet
        if (response === null) return false;
        return response;
    } catch (error) {
        if (error instanceof Error) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'performFetchHasSeenRequest',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true,
            attributes: {
                hasSeenKey: hasSeenKey
            }
        });
        return 'errored';
    }
};

});
parcelRegister("gfZHU", function(module, exports) {

$parcel$export(module.exports, "createHasSeenPrefixedKey", () => $b2f6ddeacfc2ba3f$export$9d92579e0f0fa92e);
const $b2f6ddeacfc2ba3f$export$9d92579e0f0fa92e = (key)=>{
    return `hasSeen-${key}`;
};

});



parcelRegister("jC5HS", function(module, exports) {

$parcel$export(module.exports, "setHasSeen", () => $ced548b195db50e5$export$17c72042607ae07a);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $ayei7 = parcelRequire("ayei7");
const $ced548b195db50e5$export$17c72042607ae07a = (hasSeenKey)=>async ({ setState: setState })=>{
        setState({
            [hasSeenKey]: {
                fetchStatus: 'fetched',
                value: true
            }
        });
        await (0, $ayei7.performSetHasSeenRequest)(hasSeenKey);
    };

});
parcelRegister("ayei7", function(module, exports) {

$parcel$export(module.exports, "performSetHasSeenRequest", () => $ae7ced80c3bbdf32$export$47d7ab51cd61b6bf);

var $jcw0u = parcelRequire("jcw0u");

var $aHuqL = parcelRequire("aHuqL");

var $gfZHU = parcelRequire("gfZHU");
const $ae7ced80c3bbdf32$export$47d7ab51cd61b6bf = async (hasSeenKey)=>{
    try {
        await (0, $aHuqL.userPreferenceAPI).set((0, $gfZHU.createHasSeenPrefixedKey)(hasSeenKey), true);
    } catch (error) {
        if (error instanceof Error) (0, $jcw0u.default)({
            error: error,
            meta: {
                id: 'performSetHasSeenRequest',
                packageName: 'jiraOnboardingCore',
                teamName: 'jlove-makkuro'
            },
            sendToPrivacyUnsafeSplunk: true,
            skipSentry: true,
            attributes: {
                hasSeenKey: hasSeenKey
            }
        });
    }
};

});




parcelRegister("bXemr", function(module, exports) {

$parcel$export(module.exports, "getDismissalLocalStorageState", () => $f13d7837aebc3820$export$618769f4481a782d);
$parcel$export(module.exports, "setDismissalLocalStorageState", () => $f13d7837aebc3820$export$43925291024c3f94);
$parcel$export(module.exports, "clearDismissalLocalStorageState", () => $f13d7837aebc3820$export$72901a35bb8540a8);

var $bSSG7 = parcelRequire("bSSG7");

const $f13d7837aebc3820$export$1621c8e1c66f77cd = (0, $bSSG7.createLocalStorageProvider)((0, $f78b94b69e842dbc$export$f610b3e19aab9ad3));
const $f13d7837aebc3820$export$618769f4481a782d = ()=>({
        count: $f13d7837aebc3820$export$1621c8e1c66f77cd.get((0, $f78b94b69e842dbc$export$1c5aea45d8141b3a)) ?? 0,
        dismissUntil: $f13d7837aebc3820$export$1621c8e1c66f77cd.get((0, $f78b94b69e842dbc$export$ef05e80525b51370)) ?? 0
    });
const $f13d7837aebc3820$export$43925291024c3f94 = (dismissalState)=>{
    $f13d7837aebc3820$export$1621c8e1c66f77cd.set((0, $f78b94b69e842dbc$export$1c5aea45d8141b3a), dismissalState.count);
    $f13d7837aebc3820$export$1621c8e1c66f77cd.set((0, $f78b94b69e842dbc$export$ef05e80525b51370), dismissalState.dismissUntil);
};
const $f13d7837aebc3820$export$72901a35bb8540a8 = ()=>{
    $f13d7837aebc3820$export$1621c8e1c66f77cd.remove((0, $f78b94b69e842dbc$export$1c5aea45d8141b3a));
    $f13d7837aebc3820$export$1621c8e1c66f77cd.remove((0, $f78b94b69e842dbc$export$ef05e80525b51370));
};

});
const $f78b94b69e842dbc$export$1c5aea45d8141b3a = 'dismissed-count';
const $f78b94b69e842dbc$export$ef05e80525b51370 = 'dismiss-until';
const $f78b94b69e842dbc$export$f610b3e19aab9ad3 = 'unassigned-filter-spotlight';
const $f78b94b69e842dbc$export$f8315ba7d2f36d9d = 'unassignedFilterNudgeSeenItFlag';



parcelRegister("hIQwn", function(module, exports) {

$parcel$export(module.exports, "default", () => $b96055235773b526$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b96055235773b526$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    header: {
        "id": "software-filters.filters.assignee.stateless.unassigned-filter-nudge.header",
        "defaultMessage": "Find available work faster"
    },
    dismissIconLabel: {
        "id": "software-filters.filters.assignee.stateless.unassigned-filter-nudge.dismiss-icon-label",
        "defaultMessage": "Dismiss"
    },
    turnOnUnassignedFilter: {
        "id": "software-filters.filters.assignee.stateless.unassigned-filter-nudge.turn-on-unassigned-filter",
        "defaultMessage": "Turn on unassigned filter"
    },
    content: {
        "id": "software-filters.filters.assignee.stateless.unassigned-filter-nudge.content",
        "defaultMessage": "See everything unassigned and choose your next work item."
    }
});

});



parcelRegister("i9wmu", function(module, exports) {

$parcel$export(module.exports, "default", () => $7da3753592df93f0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $bn5li = parcelRequire("bn5li");
const $7da3753592df93f0$var$entryPointParams = {};
const $7da3753592df93f0$var$AsyncUnassignedFilterNudge = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $bn5li.asyncUnassignedFilterNudge), $7da3753592df93f0$var$entryPointParams);
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    if (!hasLoadedEntrypoint.current) {
        entryPointActions.load();
        hasLoadedEntrypoint.current = true;
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        packageName: "UnassignedFilterNudge",
        id: "UnassignedFilterNudge",
        teamName: "jira-warepil",
        fallback: "unmount",
        runtimeProps: props
    });
};
var $7da3753592df93f0$export$2e2bcd8739ae039 = $7da3753592df93f0$var$AsyncUnassignedFilterNudge;

});
parcelRegister("bn5li", function(module, exports) {

$parcel$export(module.exports, "asyncUnassignedFilterNudge", () => $010fd537150770fe$export$e18caff2cfd81210);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $010fd537150770fe$export$e18caff2cfd81210 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("cWw2k"))), {
        moduleId: "750523bb"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("gQDFP", function(module, exports) {

$parcel$export(module.exports, "FILTER_PREFIX", () => $4ab71e27db0ec1f1$export$d6acfe0d617669c3);
$parcel$export(module.exports, "Z_INDEX", () => $4ab71e27db0ec1f1$export$42310dd57a41067);
$parcel$export(module.exports, "UNASSIGNED_ID", () => $4ab71e27db0ec1f1$export$bdab9bfb39981463);
const $4ab71e27db0ec1f1$export$d6acfe0d617669c3 = 'assignee';
const $4ab71e27db0ec1f1$export$42310dd57a41067 = {
    SELECTED: 1,
    ADD: 2,
    MENU: 3,
    HOVER: 4
};
const $4ab71e27db0ec1f1$export$e70f7f4a08e4d8fb = 10;
const $4ab71e27db0ec1f1$export$75297e3804621b0 = 36;
const $4ab71e27db0ec1f1$export$bdab9bfb39981463 = 'unassigned';

});

parcelRegister("kfN7T", function(module, exports) {

$parcel$export(module.exports, "default", () => $66a6af3ecba65952$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $vIiRg = parcelRequire("vIiRg");

var $3nHDn = parcelRequire("3nHDn");

var $8RXs9 = parcelRequire("8RXs9");

var $cE2Qr = parcelRequire("cE2Qr");

var $hchBL = parcelRequire("hchBL");

var $2XCFo = parcelRequire("2XCFo");

var $gQDFP = parcelRequire("gQDFP");

var $k1LTw = parcelRequire("k1LTw");

var $cWMNe = parcelRequire("cWMNe");

var $7oMpD = parcelRequire("7oMpD");

var $ihiH5 = parcelRequire("ihiH5");
const $66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET = 'addPeopleButtonTarget';
const $66a6af3ecba65952$var$AddUsersButton = (props)=>{
    const { intl: { formatMessage: formatMessage }, onClick: onClickProp, peopleButtonRef: peopleButtonRef } = props;
    const onClick = (0, $5uXOq.useCallback)((event)=>{
        (0, $cWMNe.onBlur)(event);
        onClickProp();
    }, [
        onClickProp
    ]);
    const [, { register: register }] = (0, $hchBL.useGlobalRefStoreActions)();
    const onRef = (0, $5uXOq.useCallback)((ref)=>{
        register($66a6af3ecba65952$var$ADD_PEOPLE_BUTTON_TARGET, ref);
    }, [
        register
    ]);
    const [isDismissed] = (0, $cE2Qr.useIsDismissed)();
    const NudgeTooltip = !isDismissed ? (0, $2XCFo.AssigneeFilterAddPeopleButtonWrapperNudgeAsync) : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonWrapper, {
        ref: onRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(NudgeTooltip, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ihiH5.AddPeopleTooltip), {
        content: formatMessage((0, $7oMpD.default).addPeople)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$ActionAvatarWrapper, {
        ref: peopleButtonRef,
        "data-test-id": "filters.ui.filters.assignee.stateless.add-button",
        "data-testid": "filters.ui.filters.assignee.stateless.add-button",
        "data-pollinator-filter-bar-add-people": true,
        id: `${(0, $gQDFP.FILTER_PREFIX)}-add-person`,
        "aria-label": formatMessage((0, $7oMpD.default).addPeople),
        onClick: onClick,
        "aria-describedby": (0, $gQDFP.FILTER_PREFIX)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($66a6af3ecba65952$var$AddButtonAvatarSpacer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3nHDn))), {
        LEGACY_size: "medium",
        spacing: "spacious",
        label: formatMessage((0, $7oMpD.default).addPeople)
    }))))));
};
$66a6af3ecba65952$var$AddUsersButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $66a6af3ecba65952$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, $8RXs9.default)($66a6af3ecba65952$var$AddUsersButton);
const $66a6af3ecba65952$var$AddButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_18u01b66",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a6af3ecba65952$var$ActionAvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatar), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $66a6af3ecba65952$var$AddButtonAvatarSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $lD23V.default)((0, $vIiRg.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko12pq _1ul912pq _1bsb1wug _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _vchhusvi _bfhkm7j4 _1p9v18uv",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $66a6af3ecba65952$export$7ed12d2a5241e393 = {
    ActionAvatarWrapper: $66a6af3ecba65952$var$ActionAvatarWrapper
};

});
parcelRegister("3nHDn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::0c28ad36bcbed963277bba2e64773578>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $27655de63feeadee$var$_react = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $27655de63feeadee$var$_personAdd = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("fvfvk")));

var $27655de63feeadee$var$_inviteTeam = $27655de63feeadee$var$_interopRequireDefault((parcelRequire("ijaND")));
function $27655de63feeadee$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for PersonAddIcon.
 * This component is PersonAddIcon, with `UNSAFE_fallbackIcon` set to "InviteTeamIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $27655de63feeadee$var$PersonAddIcon = (props)=>/*#__PURE__*/ $27655de63feeadee$var$_react.default.createElement($27655de63feeadee$var$_personAdd.default, Object.assign({
        LEGACY_fallbackIcon: $27655de63feeadee$var$_inviteTeam.default
    }, props));
$27655de63feeadee$var$PersonAddIcon.Name = 'PersonAddIconMigration';
var $27655de63feeadee$var$_default = module.exports.default = $27655de63feeadee$var$PersonAddIcon;

});
parcelRegister("fvfvk", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::a7c8caaba4b6537db98d2e63ce6d8f75>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $b495c71cb30b2c7c$var$_react = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $b495c71cb30b2c7c$var$_baseNew = $b495c71cb30b2c7c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $b495c71cb30b2c7c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "PersonAdd".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for adding a user to an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $b495c71cb30b2c7c$var$PersonAddIcon = (props)=>/*#__PURE__*/ $b495c71cb30b2c7c$var$_react.default.createElement($b495c71cb30b2c7c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M5 1.5a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5M1 4a4 4 0 1 1 8 0 4 4 0 0 1-8 0m11.25 4.75V11h1.5V8.75H16v-1.5h-2.25V5h-1.5v2.25H10v1.5zm-8.5 1.75a2.25 2.25 0 0 0-2.25 2.25V15H0v-2.25A3.75 3.75 0 0 1 3.75 9h2.5A3.75 3.75 0 0 1 10 12.75V15H8.5v-2.25a2.25 2.25 0 0 0-2.25-2.25z" clip-rule="evenodd"/>`
    }, props));
$b495c71cb30b2c7c$var$PersonAddIcon.displayName = 'PersonAddIcon';
var $b495c71cb30b2c7c$var$_default = module.exports.default = $b495c71cb30b2c7c$var$PersonAddIcon;

});

parcelRegister("ijaND", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $d54260e58fec7f9a$var$_react = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $d54260e58fec7f9a$var$_personAdd = $d54260e58fec7f9a$var$_interopRequireDefault((parcelRequire("fvfvk")));
function $d54260e58fec7f9a$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $d54260e58fec7f9a$var$InviteTeamIcon = (props)=>/*#__PURE__*/ $d54260e58fec7f9a$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><rect width="2" height="6" x="18" y="5" rx="1"/><rect width="6" height="2" x="16" y="7" rx="1"/><path d="M5 14c0-1.105.902-2 2.009-2h7.982c1.11 0 2.009.894 2.009 2.006v4.44c0 3.405-12 3.405-12 0z"/><circle cx="11" cy="7" r="4"/></g></svg>`
    }, props, {
        newIcon: $d54260e58fec7f9a$var$_personAdd.default
    }));
$d54260e58fec7f9a$var$InviteTeamIcon.displayName = 'InviteTeamIcon';
var $d54260e58fec7f9a$var$_default = module.exports.default = $d54260e58fec7f9a$var$InviteTeamIcon;

});


parcelRegister("2XCFo", function(module, exports) {

$parcel$export(module.exports, "AssigneeFilterAddPeopleButtonWrapperNudgeAsync", () => $ca2358eaf62c0b1a$export$4e4097c2567f79b7);

var $5uXOq = parcelRequire("5uXOq");


var $bBbEG = parcelRequire("bBbEG");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("iuXxq")).then((exportedModule)=>exportedModule.AssigneeFilterAddPeopleButtonWrapperNudge), {
    ssr: false,
    moduleId: "./src/packages/software/onboarding-nudges/src/ui/assignee-filter-add-people/index.tsx"
});
const $ca2358eaf62c0b1a$export$4e4097c2567f79b7 = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBbEG.OnboardingNudgeErrorBoundary), {
        id: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98),
        fallback: children,
        attributes: {
            nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-onboarding-assignee-filter-add-people-nudge",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ca2358eaf62c0b1a$var$AssigneeFilterAddPeopleButtonLazy, {
        nudgeId: (0, $6784cbc7d62e5d7c$export$92c7f0eacc8d8d98)
    }, children)));

});
parcelRegister("iuXxq", function(module, exports) {

let $d779366393ccec97$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $d779366393ccec97$var$load("76n7a"),
    $d779366393ccec97$var$load("l253H"),
    $d779366393ccec97$var$load("gYUWo")
]).then(()=>parcelRequire('1Pog6'));

});


parcelRegister("k1LTw", function(module, exports) {

$parcel$export(module.exports, "AvatarWrapper", () => $03be4aba8d3a8915$export$f7513421c53ce141);
$parcel$export(module.exports, "ActionAvatar", () => $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb);
$parcel$export(module.exports, "ActionAvatarSpacer", () => $03be4aba8d3a8915$export$d1aac2da5f30c370);
$parcel$export(module.exports, "AvatarBorder", () => $03be4aba8d3a8915$export$398a7826f6fd570e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $5uXOq = parcelRequire("5uXOq");

var $vIiRg = parcelRequire("vIiRg");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");

var $cSD7y = parcelRequire("cSD7y");

var $gQDFP = parcelRequire("gQDFP");
const $03be4aba8d3a8915$export$483a2b43be170225 = {
    position: 'absolute',
    width: '100%',
    height: '100%',
    padding: 0,
    border: 0,
    opacity: 0,
    overflow: 'hidden',
    'white-space': 'nowrap',
    cursor: 'pointer'
};
const $03be4aba8d3a8915$export$471e4f36da481c66 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isTanukiSpaceTokenFix: isTanukiSpaceTokenFix, zIndex: zIndex, jiggle: jiggle, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_10xi207": (0, $lD23V.default)(__cmplp.zIndex + (0, $gQDFP.Z_INDEX).SELECTED),
            "--_3qw8s9": (0, $lD23V.default)(__cmplp.zIndex),
            "--_1rh09jt": (0, $lD23V.default)(__cmplp.zIndex + (0, $gQDFP.Z_INDEX).HOVER)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _11q7glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _v5644a6k _2rko1ssb _19itidpf _12ji1r31 _1qu2glyw _12y3idpf _1e0c116y _4cvr1h6o _4t3i1ylp _kqswh2mm _s7n4jp4b _11cpidpf _rk8t1bgr _1dig1bgr _yt1x1bgr _qa15stnw _1tfxstnw _ixiwstnw _1wnsb3bt _h10pb3bt _1boqb3bt _328d1osq _cqfi1osq _rtz31osq _1mhnidpf _44x7idpf _l3jaidpf _1rky1n1a _1a071n1a _1wtq1n1a _1xpg1n1a _ti301n1a _1j2w1n1a _s1sf1mrw _1v981mrw _x2d61mrw _1pcqvab1 _1qb3vab1 _1b1bvab1 _vdzntlke _1virtlke _1y7ctlke",
            __cmplp.isTanukiSpaceTokenFix ? "_18u0x0bf" : "_18u014id",
            __cmplp.selected ? "_1pby1ho9" : "_1pby1hh6",
            __cmplp.jiggle ? "_1bvqr915 _66dkr915 _1llwr915" : "_1bvq1kli _66dk1kli _1llw1kli",
            __cmplp.jiggle ? "_n3lxmyb0 _gabdmyb0 _9di1myb0" : "_n3lxidpf _gabdidpf _9di1idpf",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$var$AvatarWrapperBaseWithRef = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($03be4aba8d3a8915$export$471e4f36da481c66, {
        ...props,
        isTanukiSpaceTokenFix: true,
        ref: ref
    });
});
const $03be4aba8d3a8915$var$AvatarWrapperOld = (0, $cSD7y.componentWithFG)('tanuki_padding_margin_use_token', $03be4aba8d3a8915$var$AvatarWrapperBaseWithRef, $03be4aba8d3a8915$export$471e4f36da481c66);
const $03be4aba8d3a8915$export$7d5adb020315f211 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = $03be4aba8d3a8915$var$AvatarWrapperOld, style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itidpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _11q7glyw _12ji1r31 _1qu2glyw _12y3idpf _4t3in7od",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$f7513421c53ce141 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $03be4aba8d3a8915$export$7d5adb020315f211, $03be4aba8d3a8915$var$AvatarWrapperOld);
const $03be4aba8d3a8915$export$1a5d4fdc8fa41cfb = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "button", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwxidpf _otyridpf _18u0idpf _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _2rko1ssb _v5644dm8 _189eyh40 _1dqonqa1 _1h6d15cr _bfhkm7j4 _80omtlke _nt751r31 _49pcglyw _1hvw1o36 _7ehi1y2g _irr315ej",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$d1aac2da5f30c370 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_1lu4wzb": (0, $lD23V.default)((0, $vIiRg.AVATAR_SIZES).medium, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1e0c1txw _4cvr1h6o _1bah1h6o _1bsb12pq _4t3i12pq _bfhk18uv _syaz1fxt _vwz412pq",
            __cmplp.className
        ])
    });
});
const $03be4aba8d3a8915$export$398a7826f6fd570e = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _189eyh40 _1dqonqa1",
            __cmplp.selected ? __cmplp.isSoftwareFullTheming ? "_1h6deyly" : "_1h6dbku0" : "_1h6d3acm",
            __cmplp.className
        ])
    });
});

});

parcelRegister("cWMNe", function(module, exports) {

$parcel$export(module.exports, "onBlur", () => $3b2d077e6f2bec18$export$5e446bc31724fca4);
$parcel$export(module.exports, "useOnKeyPress", () => $3b2d077e6f2bec18$export$49f6dd346c7dfb52);

var $5uXOq = parcelRequire("5uXOq");
const $3b2d077e6f2bec18$export$5e446bc31724fca4 = (event)=>{
    event.currentTarget.blur();
};
const $3b2d077e6f2bec18$export$49f6dd346c7dfb52 = (callback)=>(0, $5uXOq.useCallback)((event)=>{
        if (event.key === 'Enter') callback(event);
    }, [
        callback
    ]);

});

parcelRegister("7oMpD", function(module, exports) {

$parcel$export(module.exports, "default", () => $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $84bb6f0a7c1ddc3e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    addPeople: {
        "id": "software-filters.filters.assignee.stateless.add-button.add-people",
        "defaultMessage": "Add people"
    }
});

});

parcelRegister("ihiH5", function(module, exports) {

$parcel$export(module.exports, "AddPeopleTooltip", () => $936c019622c243d2$export$7d4858372ded9f0e);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");
const $936c019622c243d2$export$7d4858372ded9f0e = ({ content: content, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($936c019622c243d2$var$TooltipWrapper, null, children));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $936c019622c243d2$var$TooltipWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_12ji1r31 _1qu2glyw _12y3idpf _1e0c1o8l _kqswh2mm _4t3i14no",
            __cmplp.className
        ])
    });
});

});


parcelRegister("a43Dp", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ed3a89d7efd9a4$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $ujWmd = parcelRequire("ujWmd");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $joX8T = parcelRequire("joX8T");

var $8RXs9 = parcelRequire("8RXs9");

var $2WENx = parcelRequire("2WENx");

var $dCm1o = parcelRequire("dCm1o");

var $50XJX = parcelRequire("50XJX");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $k1LTw = parcelRequire("k1LTw");

var $cWMNe = parcelRequire("cWMNe");

var $f0vy0 = parcelRequire("f0vy0");

var $iv6Wk = parcelRequire("iv6Wk");
const $68ed3a89d7efd9a4$var$type = 'assignee';
const $68ed3a89d7efd9a4$var$Avatar = (props)=>{
    const { user: user, isSelected: isSelected, zIndex: zIndex, intl: intl } = props;
    const { formatMessage: formatMessage } = intl;
    const { isSoftwareFullTheming: isSoftwareFullTheming } = // eslint-disable-next-line jira/ff/no-preconditioning -- fast follows will rollout after the experiment has started
    (0, $4R6GH.fg)('jira_theming_milestone_1_fast_follows') && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    const userIdentifier = user.id;
    const checkboxId = `${$68ed3a89d7efd9a4$var$type}-${userIdentifier}`;
    const onToggle = (0, $5uXOq.useCallback)(()=>{
        props.onToggle(user.id);
    }, [
        props,
        user.id
    ]);
    const onKeyPress = (0, $cWMNe.useOnKeyPress)(onToggle);
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $joX8T.VARIATION);
    const altTextWithPresence = formatMessage(user.presence === 'online' ? (0, $iv6Wk.default).presenceOnlineLabel : (0, $iv6Wk.default).presenceOfflineLabel, {
        name: user.displayName
    });
    const isUnassignedIconExperimentEnabled = userIdentifier === 'unassigned' && (0, $6s1PB.expVal)('thor_unassigned_icon_update_milestone1_experiment', 'isUnassignedIconUpdated', false);
    const avatarWithTooltip = isRealtimePresenceEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f0vy0.default), {
        content: user.displayName,
        presence: user.presence,
        tag: "span"
    }, isUnassignedIconExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50XJX.UnassignedAvatar), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        isSelected: isSelected,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence,
        isSoftwareFullTheming: isSoftwareFullTheming
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.presence ? altTextWithPresence : user.displayName,
        presence: user.presence
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: user.displayName,
        tag: "span"
    }, isUnassignedIconExperimentEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $50XJX.UnassignedAvatar), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        isSelected: isSelected,
        name: user.displayName,
        presence: user.presence,
        isSoftwareFullTheming: isSoftwareFullTheming
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        testId: "filters.ui.filters.assignee.stateless.avatar.ak-avatar",
        size: (0, $dCm1o.isVisualRefreshEnabled)() ? 'small' : 'medium',
        as: "span",
        src: user.avatarUrl,
        name: user.displayName,
        presence: user.presence
    }));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarWrapper), {
        selected: isSelected,
        zIndex: zIndex
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarInputCheckbox, {
        "aria-label": formatMessage((0, $iv6Wk.default).inputCheckboxLabel, {
            username: user.displayName
        }),
        type: "checkbox",
        id: checkboxId,
        name: $68ed3a89d7efd9a4$var$type,
        value: userIdentifier,
        defaultChecked: isSelected,
        onChange: onToggle,
        onKeyPress: onKeyPress,
        onClick: (0, $cWMNe.onBlur)
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k1LTw.AvatarBorder), {
        selected: isSelected,
        isSoftwareFullTheming: isSoftwareFullTheming,
        "aria-hidden": (0, $4R6GH.fg)('tanuki_a11y_q4') ? true : undefined
    }, (0, $4R6GH.fg)('tanuki_a11y_q4') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "label",
        testId: "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId,
        xcss: [
            (0, $dCm1o.isVisualRefreshEnabled)() ? $68ed3a89d7efd9a4$var$avatarLabelBaseWithVrStyles : $68ed3a89d7efd9a4$var$avatarLabelBaseStyles,
            isUnassignedIconExperimentEnabled && $68ed3a89d7efd9a4$var$unassignedAvatarLabelStyles
        ]
    }, avatarWithTooltip) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ed3a89d7efd9a4$var$AvatarLabel, {
        "data-test-id": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        "data-testid": "filters.ui.filters.assignee.stateless.avatar.assignee-filter-avatar",
        htmlFor: checkboxId
    }, avatarWithTooltip)));
};
$68ed3a89d7efd9a4$var$Avatar.defaultProps = {
    isSelected: false,
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $68ed3a89d7efd9a4$export$2e2bcd8739ae039 = (0, $8RXs9.default)($68ed3a89d7efd9a4$var$Avatar);
const $68ed3a89d7efd9a4$var$avatarLabelBaseStyles = (0, $8CUq3.xcss)({
    height: '36px',
    display: 'block',
    cursor: 'pointer'
});
const $68ed3a89d7efd9a4$var$avatarLabelBaseWithVrStyles = (0, $8CUq3.xcss)({
    height: '28px',
    display: 'block',
    cursor: 'pointer'
});
const $68ed3a89d7efd9a4$var$unassignedAvatarLabelStyles = (0, $8CUq3.xcss)({
    marginBottom: 'space.025'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68ed3a89d7efd9a4$var$AvatarLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_vwz4idpf _1e0c1ule _80omtlke",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
const $68ed3a89d7efd9a4$var$AvatarInputCheckbox = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "input", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _kqswstnw _1bsb1osq _4t3i1osq _tzy4idpf _o5721q9c _80omtlke _1xp4aqb7",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
const $68ed3a89d7efd9a4$export$7ed12d2a5241e393 = {
    AvatarInputCheckbox: $68ed3a89d7efd9a4$var$AvatarInputCheckbox
};

});
parcelRegister("2WENx", function(module, exports) {

$parcel$export(module.exports, "useRealtimePresenceExperiment", () => $ef9e8ab383852170$export$ba964695877b24);

var $4mBKK = parcelRequire("4mBKK");

var $6s1PB = parcelRequire("6s1PB");

var $dkqym = parcelRequire("dkqym");
const $ef9e8ab383852170$export$ba964695877b24 = ()=>{
    const firstActivationDateMs = (0, $dkqym.useFirstActivationDateMs)();
    const [expConfig] = (0, $6s1PB.UNSAFE_noExposureExp)('jsw_board_real-time_collaboration_through_presence');
    return {
        experimentCohort: !firstActivationDateMs || (0, $4mBKK.default)(new Date(), firstActivationDateMs) < 30 ? 'not-enrolled' : expConfig.get('cohort', 'not-enrolled')
    };
};

});

parcelRegister("50XJX", function(module, exports) {

$parcel$export(module.exports, "UnassignedAvatar", () => $57eaa8bd14ba9db4$export$7348d55d91bdac19);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $ujWmd = parcelRequire("ujWmd");

var $1bKdn = parcelRequire("1bKdn");

var $koVbs = parcelRequire("koVbs");
const $57eaa8bd14ba9db4$var$selectedStyles = null;
const $57eaa8bd14ba9db4$var$themedSelectedStyles = null;
const $57eaa8bd14ba9db4$var$unSelectedStyles = null;
const $57eaa8bd14ba9db4$var$nestedSvgStylesMap = {
    xsmall: "_w8l57vkz _17527vkz",
    small: "_w8l51tcg _17521tcg",
    medium: "_w8l5zwfg _1752zwfg",
    large: "_w8l51ylp _17521ylp",
    xlarge: "_w8l5ckbl _1752ckbl",
    xxlarge: "_w8l58vuz _17528vuz"
};
const $57eaa8bd14ba9db4$var$baseStyles = null;
const $57eaa8bd14ba9db4$export$7348d55d91bdac19 = ({ isSelected: isSelected = false, size: size = 'medium', testId: testId, isSoftwareFullTheming: isSoftwareFullTheming, ...restAvatarProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        size: size,
        testId: testId,
        ...restAvatarProps
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("span", {
        "data-testId": testId ? `${testId}--inner` : undefined,
        className: (0, $bwpsq.default)([
            "_2rko1ssb _1h6d1r31 _1dqogq9o _189et94y _1e0c116y _1bah1h6o _4cvr1h6o _19pkv77o _2hwxv77o _otyrv77o _18u0v77o _16qs10ak _syaz1t05",
            isSelected ? "_1h6d1yqz _syaz1qo3" : "_30l31a2l",
            $57eaa8bd14ba9db4$var$nestedSvgStylesMap[size],
            isSelected && isSoftwareFullTheming && "_1h6deyly _syazeyly"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1bKdn))), {
        label: formatMessage({
            id: 'unassigned',
            defaultMessage: 'unassigned'
        }),
        color: "currentColor",
        testId: testId && `${testId}--inner--person`,
        spacing: "spacious"
    })));
};

});

parcelRegister("f0vy0", function(module, exports) {

$parcel$export(module.exports, "default", () => $fff18090899dca54$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3bDjY = parcelRequire("3bDjY");

var $koVbs = parcelRequire("koVbs");

var $hf0Xf = parcelRequire("hf0Xf");
const $fff18090899dca54$var$PresenceTooltip = ({ presence: presence, content: content, children: children, ...restProps })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const contentWithPresence = presence === 'online' ? formatMessage((0, $hf0Xf.default).presenceToolTipOnline, {
        name: String(content)
    }) : formatMessage((0, $hf0Xf.default).presenceToolTipOffline, {
        name: String(content)
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: presence ? contentWithPresence : content,
        ...restProps
    }, children);
};
var $fff18090899dca54$export$2e2bcd8739ae039 = $fff18090899dca54$var$PresenceTooltip;

});
parcelRegister("hf0Xf", function(module, exports) {

$parcel$export(module.exports, "default", () => $14a1fa5c7f46c36b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $14a1fa5c7f46c36b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    presenceToolTipOnline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-online",
        "defaultMessage": "{name} is online"
    },
    presenceToolTipOffline: {
        "id": "software-filters.common.presence-tooltip.presence-tool-tip-offline",
        "defaultMessage": "{name} is offline"
    }
});

});


parcelRegister("iv6Wk", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a7903d4e27c8480$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2a7903d4e27c8480$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    presenceOnlineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-online-label",
        "defaultMessage": "{name} (online)"
    },
    presenceOfflineLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.presence-offline-label",
        "defaultMessage": "{name} (offline)"
    },
    avatarInputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.avatar-input-checkbox-label",
        "defaultMessage": "assignee filter avatar"
    },
    inputCheckboxLabel: {
        "id": "software-filters.filters.assignee.stateless.avatar.input-checkbox-label",
        "defaultMessage": "Filter assignees by {username}"
    }
});

});


parcelRegister("2eCzd", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a3184a04c19fde7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $0a3184a04c19fde7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.assignee.stateless.label",
        "defaultMessage": "Filter by assignee"
    },
    showMoreButton: {
        "id": "software-filters.filters.assignee.stateless.show-more",
        "defaultMessage": "Show more assignees"
    }
});

});

parcelRegister("mafYu", function(module, exports) {

$parcel$export(module.exports, "default", () => $bb88f751cbd22241$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $8Rkzz = parcelRequire("8Rkzz");

var $vIiRg = parcelRequire("vIiRg");
var $ujWmd = parcelRequire("ujWmd");

var $BLPHT = parcelRequire("BLPHT");
var $jFrow = parcelRequire("jFrow");

var $3bDjY = parcelRequire("3bDjY");

var $joX8T = parcelRequire("joX8T");

var $2WENx = parcelRequire("2WENx");

var $g5X3G = parcelRequire("g5X3G");

var $dCm1o = parcelRequire("dCm1o");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $4R6GH = parcelRequire("4R6GH");

var $gQDFP = parcelRequire("gQDFP");

var $k1LTw = parcelRequire("k1LTw");

var $f0vy0 = parcelRequire("f0vy0");
const $bb88f751cbd22241$var$ShowMoreButton = (props)=>{
    const { users: users, selectedUsers: selectedUsers, onOpen: onOpen, onItemActivated: onItemActivatedProps, onClose: onClose } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onOpenChange = (0, $5uXOq.useCallback)(({ isOpen: isOpenDropDown })=>{
        if (isOpenDropDown) {
            onOpen();
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'showMoreAssignee');
        } else onClose && onClose();
    }, [
        onOpen,
        createAnalyticsEvent,
        onClose
    ]);
    const isSelected = (0, $5uXOq.useMemo)(()=>users.some((user)=>selectedUsers.includes(user.id)), [
        users,
        selectedUsers
    ]);
    const { experimentCohort: experimentCohort } = (0, $2WENx.useRealtimePresenceExperiment)();
    const isRealtimePresenceEnabled = experimentCohort === (0, $joX8T.VARIATION);
    const dropdownItems = (0, $5uXOq.useMemo)(()=>users.map(({ id: id, displayName: displayName, avatarUrl: avatarUrl, presence: presence })=>/*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$ItemWrapper, {
                key: id
            }, /*#__PURE__*/ $5uXOq.createElement((0, $jFrow.default), {
                id: id,
                isSelected: selectedUsers.includes(id),
                onClick: ()=>{
                    onItemActivatedProps((0, $g5X3G.toAccountId)(String(id)));
                }
            }, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$ItemContent, null, isRealtimePresenceEnabled ? /*#__PURE__*/ $5uXOq.createElement((0, $f0vy0.default), {
                content: displayName,
                presence: presence
            }, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))) : /*#__PURE__*/ $5uXOq.createElement((0, $3bDjY.default), {
                content: displayName
            }, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$DropdownAvatarWrapper, null, /*#__PURE__*/ $5uXOq.createElement((0, $ujWmd.default), {
                size: "small",
                src: avatarUrl,
                name: displayName,
                presence: presence
            }))), /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$TextContentWrapper, null, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$TextContent, null, displayName)))))), [
        users,
        selectedUsers,
        onItemActivatedProps,
        isRealtimePresenceEnabled
    ]);
    return /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$DropdownMenuWrapper, null, /*#__PURE__*/ $5uXOq.createElement((0, $BLPHT.default), {
        onOpenChange: onOpenChange,
        shouldRenderToParent: (0, $4R6GH.fg)('tanuki_a11y_q4'),
        trigger: ({ triggerRef: triggerRef, 'aria-expanded': ariaExpanded, ...triggerProps })=>/*#__PURE__*/ $5uXOq.createElement((0, $k1LTw.AvatarWrapper), {
                ...triggerProps,
                as: "button",
                "aria-expanded": ariaExpanded,
                ref: triggerRef,
                zIndex: (0, $gQDFP.Z_INDEX).MENU,
                "data-testid": "filters.ui.filters.assignee.stateless.show-more-button.assignee-filter-show-more"
            }, /*#__PURE__*/ $5uXOq.createElement((0, $k1LTw.AvatarBorder), {
                selected: isSelected
            }, /*#__PURE__*/ $5uXOq.createElement((0, $k1LTw.ActionAvatar), {
                as: "div",
                tabIndex: -1
            }, (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer, null, `+${users.length}`) : /*#__PURE__*/ $5uXOq.createElement((0, $k1LTw.ActionAvatarSpacer), null, `+${users.length}`))))
    }, /*#__PURE__*/ $5uXOq.createElement($bb88f751cbd22241$var$DropdownItemsWrapper, null, dropdownItems)));
};
$bb88f751cbd22241$var$ShowMoreButton.defaultProps = {
    onItemActivated: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onOpen: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $bb88f751cbd22241$export$2e2bcd8739ae039 = $bb88f751cbd22241$var$ShowMoreButton;
const $bb88f751cbd22241$var$dropdownMenuWrapperStyle = {
    root: "_1e0c116y _4cvr1h6o _18u0x0bf",
    withoutTanukiA11yQ4: "_1pbyidpf",
    withTanukiA11yQ4: "_1pbykb7n"
};
const $bb88f751cbd22241$var$DropdownMenuWrapper = ({ children: children })=>{
    return /*#__PURE__*/ $5uXOq.createElement("div", {
        className: (0, $bwpsq.default)([
            $bb88f751cbd22241$var$dropdownMenuWrapperStyle.root,
            (0, $4R6GH.fg)('tanuki_a11y_q4') ? $bb88f751cbd22241$var$dropdownMenuWrapperStyle.withTanukiA11yQ4 : $bb88f751cbd22241$var$dropdownMenuWrapperStyle.withoutTanukiA11yQ4
        ])
    }, children);
};
// The old menu dropdown has a max-width of 300px but the new one has 800px.
// We have to set the max-width in the wrapper to keep the same style.
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $bb88f751cbd22241$var$DropdownItemsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1mjv _ca0q1b66 _u5f3ze3t _n3td1b66 _19bvze3t",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ItemWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_v6yzze3t _1kf0utpp _156mze3t _m6t6utpp _1ipkze3t _1kdcze3t _3glyze3t _1w2uze3t",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ItemContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bto1l2s",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$DropdownAvatarWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _18u0v77o",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$TextContentWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c1txw _19pkze3t _2hwxu2gc _otyrze3t _18u0u2gc _ca0qu2gc _u5f3ze3t _n3tdu2gc _19bvze3t",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$TextContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $bb88f751cbd22241$var$ShowMoreButtonAvatarSpacer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k1LTw.ActionAvatarSpacer), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: {
            ...__cmpls,
            "--_wiw70x": (0, $lD23V.default)((0, $vIiRg.AVATAR_SIZES).small, "px")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _1bsb1yj7 _4t3i1yj7 _t9ec1win",
            __cmplp.className
        ])
    });
});

});
parcelRegister("jFrow", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d90ebe7a2adf26d$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $j7LBE = parcelRequire("j7LBE");

var $kJpBP = parcelRequire("kJpBP");

var $VSDnB = parcelRequire("VSDnB");

var $hEtee = parcelRequire("hEtee");

var $6PlGW = parcelRequire("6PlGW");

var $l7Q0F = parcelRequire("l7Q0F");

var $6cAn5 = parcelRequire("6cAn5");
/**
 * __Dropdown item checkbox__
 *
 * A dropdown item checkbox creates groups that have multiple selections.
 *
 * - [Examples](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/examples)
 * - [Code](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/code)
 * - [Usage](https://atlassian.design/components/dropdown-menu/dropdown-item-checkbox/usage)
 */ const $9d90ebe7a2adf26d$var$DropdownItemCheckbox = ({ children: children, defaultSelected: defaultSelected, description: description, id: id, isDisabled: isDisabled, isSelected: isSelected, onClick: providedOnClick = (0, $eGmKJ.default), shouldDescriptionWrap: shouldDescriptionWrap = true, shouldTitleWrap: shouldTitleWrap = true, testId: testId, interactionName: interactionName, // DSP-13312 TODO: remove spread props in future major release
...rest })=>{
    typeof $6cAn5;
    const [selected, setSelected] = (0, $6PlGW.default)({
        id: id,
        isSelected: isSelected,
        defaultSelected: defaultSelected
    });
    const onClickHandler = (0, $5uXOq.useCallback)((event)=>{
        setSelected((selected)=>!selected);
        providedOnClick(event);
    }, [
        providedOnClick,
        setSelected
    ]);
    const itemRef = (0, $l7Q0F.default)();
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $j7LBE.SELECTION_STYLE_CONTEXT_DO_NOT_USE).Provider, {
        value: "none",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $kJpBP.default), {
            "aria-checked": selected,
            description: description,
            iconBefore: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $hEtee.default), {
                checked: selected
            }),
            id: id,
            isDisabled: isDisabled,
            isSelected: selected,
            onClick: onClickHandler,
            ref: itemRef,
            role: "menuitemcheckbox",
            shouldDescriptionWrap: shouldDescriptionWrap,
            shouldTitleWrap: shouldTitleWrap,
            testId: testId,
            ...(0, $VSDnB.fg)('platform_button_item-add-ufo-metrics') && {
                interactionName: interactionName
            },
            ...rest,
            children: children
        })
    });
};
var $9d90ebe7a2adf26d$export$2e2bcd8739ae039 = $9d90ebe7a2adf26d$var$DropdownItemCheckbox;

});
parcelRegister("hEtee", function(module, exports) {

$parcel$export(module.exports, "default", () => $181f17e87025e1b2$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $dV6Te = parcelRequire("dV6Te");

var $VSDnB = parcelRequire("VSDnB");

/**
 * __Checkbox icon__
 *
 * Used to visually represent the selected state in DropdownItemCheckbox
 *
 * @internal
 */ const $181f17e87025e1b2$var$CheckboxIcon = ({ checked: checked })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dV6Te.default), {
        label: "",
        size: "medium",
        primaryColor: checked ? `var(--ds-background-selected-bold, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-background-input, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})`,
        secondaryColor: checked ? `var(--ds-icon-inverse, ${0, $829f609a65d26a98$export$e655ef011c4aa1a2})` : 'transparent',
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("g", {
            fillRule: "evenodd",
            children: // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
            (0, $VSDnB.fg)('platform-visual-refresh-icons') ? /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        x: "5.5",
                        y: "5.5",
                        width: "13",
                        height: "13",
                        rx: "1.5",
                        fill: "currentColor"
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        fillRule: "evenodd",
                        clipRule: "evenodd",
                        d: "M16.3262 9.48011L15.1738 8.51984L10.75 13.8284L8.82616 11.5198L7.67383 12.4801L10.1738 15.4801C10.3163 15.6511 10.5274 15.75 10.75 15.75C10.9726 15.75 11.1837 15.6511 11.3262 15.4801L16.3262 9.48011Z",
                        fill: "inherit"
                    })
                ]
            }) : /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $2OMIu.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)("rect", {
                        fill: "currentColor",
                        x: "6",
                        y: "6",
                        width: "12",
                        height: "12",
                        rx: "2",
                        stroke: checked ? `var(--ds-border-selected, ${0, $829f609a65d26a98$export$b3de0ae08da2ce64})` : `var(--ds-border-input, ${0, $829f609a65d26a98$export$d6447c357493214f})`,
                        strokeWidth: 1
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsx)("path", {
                        d: "M9.707 11.293a1 1 0 10-1.414 1.414l2 2a1 1 0 001.414 0l4-4a1 1 0 10-1.414-1.414L11 12.586l-1.293-1.293z",
                        fill: "inherit"
                    })
                ]
            })
        })
    });
};
var $181f17e87025e1b2$export$2e2bcd8739ae039 = $181f17e87025e1b2$var$CheckboxIcon;

});

parcelRegister("6PlGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $3e2d30248a719600$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $5MgQz = parcelRequire("5MgQz");

var $iY6id = parcelRequire("iY6id");
/**
 * Custom hook to handle checkbox state for dropdown menu.
 * It works in tandem with the selection store context when the
 * component is uncontrolled.
 */ const $3e2d30248a719600$var$useCheckboxState = ({ isSelected: isSelected, id: id, defaultSelected: defaultSelected })=>{
    const { setItemState: setItemState, getItemState: getItemState } = (0, $5uXOq.useContext)((0, $iY6id.SelectionStoreContext));
    const groupId = (0, $5uXOq.useContext)((0, $5MgQz.CheckboxGroupContext));
    const persistedIsSelected = getItemState(groupId, id);
    const [localIsSelected, setLocalIsSelected] = (0, $5uXOq.useState)(// Initial state is set depending on value being defined or not.
    // This state is only utilised if the checkbox is uncontrolled.
    ()=>persistedIsSelected !== undefined ? persistedIsSelected : defaultSelected || false);
    const setLocalState = (0, $5uXOq.useCallback)((newValue)=>{
        const nextValue = newValue(persistedIsSelected);
        setLocalIsSelected(nextValue);
        setItemState(groupId, id, nextValue);
    }, [
        setItemState,
        persistedIsSelected,
        groupId,
        id
    ]);
    // Checkbox is controlled - do nothing!
    if (typeof isSelected === 'boolean') return [
        isSelected,
        ()=>false
    ];
    // Checkbox is going through its first render pass!
    if (persistedIsSelected === undefined) // Set the item so we have this state to access next time the checkbox renders (either by mounting or re-rendering!)
    setItemState(groupId, id, defaultSelected || false);
    // Return the value and setter!
    // Remember this flow is only returned if the checkbox is uncontrolled.
    return [
        localIsSelected,
        setLocalState
    ];
};
var $3e2d30248a719600$export$2e2bcd8739ae039 = $3e2d30248a719600$var$useCheckboxState;

});
parcelRegister("5MgQz", function(module, exports) {

$parcel$export(module.exports, "CheckboxGroupContext", () => $155fc86a3d14dca7$export$baf37c4be89255b8);

var $5uXOq = parcelRequire("5uXOq");
const $155fc86a3d14dca7$export$baf37c4be89255b8 = /*#__PURE__*/ (0, $5uXOq.createContext)('');

});






parcelRegister("d8C6F", function(module, exports) {

$parcel$export(module.exports, "useClauseUpdater", () => $28be89695ad437ea$export$6e3e389b99373b75);

var $5uXOq = parcelRequire("5uXOq");

var $LpImS = parcelRequire("LpImS");

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");

var $4R6GH = parcelRequire("4R6GH");

var $hOHOl = parcelRequire("hOHOl");

var $8zf6J = parcelRequire("8zf6J");

var $lPhuO = parcelRequire("lPhuO");
const $28be89695ad437ea$var$getOperand = (selectedValue)=>{
    if (selectedValue === (0, $49b29ef7baa2a152$export$1c46dca02aac24dd)) return (0, $iEIQF.default).keywordOperand();
    return (0, $iEIQF.default).byText.valueOperand(selectedValue);
};
const $28be89695ad437ea$var$getOperands = (selectedValues)=>selectedValues.map((selectedValue)=>$28be89695ad437ea$var$getOperand(selectedValue));
const $28be89695ad437ea$var$getOperandValues = (operand)=>{
    if (!operand) return [];
    if (operand.operandType === (0, $49b29ef7baa2a152$export$fabec4aebba3f4df)) {
        const values = [];
        for(let i = 0; i < operand.values.length; i++)values.push(...$28be89695ad437ea$var$getOperandValues(operand.values[i]));
        return values;
    }
    if (operand.operandType === (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) return [
        operand.text
    ];
    if (operand.operandType === (0, $49b29ef7baa2a152$export$f6049126fd97001f)) return [
        operand.value
    ];
    return [
        operand.function.value
    ];
};
const $28be89695ad437ea$var$getInitialTotalCount = (clause)=>{
    if (clause?.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && clause.operand) return $28be89695ad437ea$var$getOperandValues(clause.operand).length;
    return 0;
};
const $28be89695ad437ea$var$createTerminalClause = (clauseName, selectedValues)=>(0, $iEIQF.default).terminalClause((0, $iEIQF.default).field(clauseName), (0, $iEIQF.default).operator(selectedValues.length > 1 ? (0, $bzbto.OPERATOR_IN) : (0, $bzbto.OPERATOR_EQUALS)), selectedValues.length > 1 ? (0, $iEIQF.default).listOperand($28be89695ad437ea$var$getOperands(selectedValues)) : $28be89695ad437ea$var$getOperand(selectedValues[0]));
const $28be89695ad437ea$export$6e3e389b99373b75 = (clauseName)=>{
    const ast = (0, $hOHOl.useAST)();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const jql = (0, $4R6GH.fg)('filter_refinement_error_logging') ? (0, $hOHOl.useJQL)() : '';
    const clauseMap = (0, $hOHOl.useClauseMap)();
    const clauses = clauseMap[clauseName.toLowerCase()];
    if (clauses && clauses.length > 1) {
        if ((0, $4R6GH.fg)('filter_refinement_error_logging')) throw new (0, $8zf6J.UnsupportedRefinementError)(jql, `Too many clauses on update for ${clauseName}`);
        else throw new (0, $lPhuO.UnsupportedRefinementErrorOld)(`Too many clauses on update for ${clauseName}`);
    }
    const totalCount = (0, $5uXOq.useRef)($28be89695ad437ea$var$getInitialTotalCount(clauses?.[0]));
    const addValueToClause = (0, $5uXOq.useCallback)((selectedValue)=>{
        if (!selectedValue) return ast.represents;
        if (clauses?.length) {
            const [clause] = clauses;
            if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && clause.operand) {
                const existingValues = $28be89695ad437ea$var$getOperandValues(clause.operand);
                clause.replace($28be89695ad437ea$var$createTerminalClause(clauseName, [
                    ...existingValues,
                    selectedValue
                ]));
                totalCount.current = existingValues.length + 1;
            } else {
                clause.replace($28be89695ad437ea$var$createTerminalClause(clauseName, [
                    selectedValue
                ]));
                totalCount.current = 1;
            }
        } else if ((0, $4R6GH.fg)('fix_duplicated_clauses_in_filter_refinement_jql')) {
            // This mitigates a race condition where multiple concurrent modifications to the AST
            // can result in duplicated clauses for the same field making it to the final JQL string
            // (which throws an error on the UI) – we will explore better longer term solutions as
            // part of https://jplat.atlassian.net/browse/EM-9488
            const astClone = (0, (/*@__PURE__*/$parcel$interopDefault($LpImS)))(ast);
            astClone.query?.appendClause($28be89695ad437ea$var$createTerminalClause(clauseName, [
                selectedValue
            ]), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            totalCount.current = 1;
            return (0, $l0V05.print)(astClone, {
                operatorCase: 'upper'
            });
        } else {
            ast.query?.appendClause($28be89695ad437ea$var$createTerminalClause(clauseName, [
                selectedValue
            ]), (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
            totalCount.current = 1;
        }
        return (0, $l0V05.print)(ast, {
            operatorCase: 'upper'
        });
    }, [
        clauses,
        ast,
        clauseName
    ]);
    const removeValueFromClause = (0, $5uXOq.useCallback)((selectedValue)=>{
        if (!selectedValue) return ast.represents;
        if (clauses?.length) {
            const [clause] = clauses;
            if (clause.clauseType === (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a) && clause.operand) {
                const existingValues = $28be89695ad437ea$var$getOperandValues(clause.operand);
                const newSelectedValues = existingValues.filter((value)=>value !== selectedValue);
                if (newSelectedValues.length) {
                    clause.replace($28be89695ad437ea$var$createTerminalClause(clauseName, newSelectedValues));
                    totalCount.current = newSelectedValues.length;
                } else {
                    clause.remove();
                    totalCount.current = 0;
                }
            } else {
                clause.remove();
                totalCount.current = 0;
            }
        } else totalCount.current = 0;
        return (0, $l0V05.print)(ast, {
            operatorCase: 'upper'
        });
    }, [
        clauses,
        ast,
        clauseName
    ]);
    const removeClause = (0, $5uXOq.useCallback)(()=>{
        if (clauses?.length) {
            const [clause] = clauses;
            clause.remove();
        }
        totalCount.current = 0;
        return (0, $l0V05.print)(ast, {
            operatorCase: 'upper'
        });
    }, [
        ast,
        clauses
    ]);
    const getTotalCount = (0, $5uXOq.useCallback)(()=>{
        return totalCount.current;
    }, []);
    return {
        addValueToClause: addValueToClause,
        removeValueFromClause: removeValueFromClause,
        removeClause: removeClause,
        getTotalCount: getTotalCount
    };
};

});


parcelRegister("c73Ug", function(module, exports) {

$parcel$export(module.exports, "FilterPopup", () => $23e82092abb69f47$export$e8105bc3bb8d0384);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $eCeGD = parcelRequire("eCeGD");

var $jX361 = parcelRequire("jX361");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $k6T4f = parcelRequire("k6T4f");

var $3bDjY = parcelRequire("3bDjY");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $47gW9 = parcelRequire("47gW9");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $7mPT9 = parcelRequire("7mPT9");

var $jgJNO = parcelRequire("jgJNO");

var $koeKL = parcelRequire("koeKL");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ioD1B = parcelRequire("ioD1B");

var $eGLgs = parcelRequire("eGLgs");

var $14XJw = parcelRequire("14XJw");

var $4R6GH = parcelRequire("4R6GH");


var $hOHOl = parcelRequire("hOHOl");

var $hZ2JJ = parcelRequire("hZ2JJ");

var $hk6EP = parcelRequire("hk6EP");

var $3JhIN = parcelRequire("3JhIN");

var $3b1XM = parcelRequire("3b1XM");

var $iHttZ = parcelRequire("iHttZ");

var $7AeDc = parcelRequire("7AeDc");

var $eyBlI = parcelRequire("eyBlI");
const $23e82092abb69f47$var$POPUP_HEIGHT = '380px';
const $23e82092abb69f47$var$POPUP_WIDTH = '600px';
const $23e82092abb69f47$export$e8105bc3bb8d0384 = ({ scope: scope, changeboardingMessageId: changeboardingMessageId, isSoftwareFullTheming: isSoftwareFullTheming })=>{
    const jql = (0, $hOHOl.useJQL)();
    const numberOfSelectedValues = (0, $hZ2JJ.useNumberOfSelectedValues)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isFeedbackOpen, setFeedbackIsOpen] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const cloudId = (0, $koeKL.useCloudId)();
    const { data: orgId } = (0, $14XJw.useOrgId)();
    const coordinationClient = (0, $5uXOq.useMemo)(()=>changeboardingMessageId ? new (0, $eGLgs.CoordinationClient)(cloudId, '/gateway/api', false, orgId, 'engagement') : undefined, [
        changeboardingMessageId,
        cloudId,
        orgId
    ]); // TODO: Remove this once we have a new changeboarding flow and gate filter-refinement-changeboarding-second-page is rolled out
    const [isMessageActive, setIsMessageActive] = (0, $5uXOq.useState)(false); // These are introduced with the filter-refinement-changeboarding-second-page gate for the new changeboarding flow
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(null);
    const startSpotlight = (0, $5uXOq.useCallback)((isActive)=>setActiveSpotlight(isActive ? 0 : null), []);
    const nextSpotlight = (0, $5uXOq.useCallback)(()=>setActiveSpotlight((activeSpotlight || 0) + 1), [
        activeSpotlight
    ]);
    const endSpotlight = (0, $5uXOq.useCallback)(()=>setActiveSpotlight(null), []);
    (0, $5uXOq.useEffect)(()=>{
        if (changeboardingMessageId) coordinationClient?.start(changeboardingMessageId).then((isActive)=>(0, $4R6GH.fg)('filter-refinement-changeboarding-second-page') ? startSpotlight(isActive) : setIsMessageActive(isActive)).catch(()=>(0, $4R6GH.fg)('filter-refinement-changeboarding-second-page') ? endSpotlight() : setIsMessageActive(false));
    }, [
        coordinationClient,
        changeboardingMessageId,
        startSpotlight,
        endSpotlight
    ]);
    const closeChangeboarding = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        // Stop propagation avoid closing filter popup when dismissing changeboarding
        event.stopPropagation();
        if (changeboardingMessageId) {
            coordinationClient?.stop(changeboardingMessageId);
            (0, $4R6GH.fg)('filter-refinement-changeboarding-second-page') ? endSpotlight() : setIsMessageActive(false);
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterRefinementChangeboardingClosed');
        }
    }, [
        coordinationClient,
        changeboardingMessageId,
        endSpotlight
    ]);
    const runtimeProps = (0, $5uXOq.useMemo)(()=>({
            onCloseChangeboarding: closeChangeboarding,
            isMessageActive: isMessageActive,
            activeSpotlight: activeSpotlight,
            changeboardingMessageId: changeboardingMessageId,
            onTriggerNextSpotlight: nextSpotlight,
            onTriggerEndSpotlight: endSpotlight
        }), [
        closeChangeboarding,
        isMessageActive,
        activeSpotlight,
        changeboardingMessageId,
        nextSpotlight,
        endSpotlight
    ]);
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            cloudId: cloudId,
            jqlContext: jql,
            scope: scope,
            onFeedbackClick: setFeedbackIsOpen
        }), [
        cloudId,
        jql,
        scope,
        setFeedbackIsOpen
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3b1XM.filterPopupContentEntryPoint), entryPointParams);
    const triggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions, !isOpen);
    const onClick = (0, $5uXOq.useCallback)((_, analyticsEvent)=>{
        setIsOpen((open)=>!open);
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filter');
    }, []);
    const onKeyboardShortcutTriggered = (0, $5uXOq.useCallback)(()=>{
        entryPointActions.load();
        setIsOpen((open)=>!open);
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            action: 'pressed',
            actionSubject: 'keyboardShortcut'
        }), 'filterPopup');
    }, [
        createAnalyticsEvent,
        entryPointActions
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        // don't close the popup when the feedback modal is still open
        !isFeedbackOpen && setIsOpen(false);
    }, [
        isFeedbackOpen
    ]);
    const formattedTooltipContent = (0, $5uXOq.useMemo)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $23e82092abb69f47$var$tooltipContentStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $iHttZ.default).tooltipMessage,
            values: {
                inline: (parts)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
                        xcss: $23e82092abb69f47$var$keyboardShortcutTagStyles
                    }, parts)
            }
        }));
    }, []);
    const trigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6T4f.Pulse), {
            radius: 3,
            pulse: (0, $4R6GH.fg)('filter-refinement-changeboarding-second-page') ? activeSpotlight !== null && activeSpotlight !== 1 : isMessageActive
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formattedTooltipContent
        }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                interactionName: "filter-popup-load-content",
                ...tooltipProps,
                ...triggerProps,
                iconBefore: (0, (/*@__PURE__*/$parcel$interopDefault($jX361))),
                iconAfter: ()=>numberOfSelectedValues > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                        as: "span",
                        paddingInlineEnd: "space.050",
                        paddingInlineStart: "space.025"
                    }, isSoftwareFullTheming && (0, $4R6GH.fg)('jira_theming_milestone_1_fast_follows') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
                        "data-testid": "filter-refinement.ui.filter-popup.badge",
                        className: (0, $bwpsq.default)([
                            "_2rkoglpi _11c81o8v _18zr1b66 _bfhk1vcy _syaz1p4p _1ul9pxbi _19bv1b66 _u5f31b66 _y3gn1h6o _1e0c116y _1bah1h6o _1kz6184x"
                        ])
                    }, numberOfSelectedValues) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
                        appearance: "primary",
                        testId: "filter-refinement.ui.filter-popup.badge"
                    }, numberOfSelectedValues)),
                isSelected: isOpen || numberOfSelectedValues > 0,
                ref: (0, $7mPT9.mergeRefs)(triggerRef, triggerProps.ref),
                onClick: onClick,
                testId: "filter-refinement.ui.filter-popup.button"
            }, formatMessage((0, $iHttZ.default).filterButton)))), [
        isMessageActive,
        activeSpotlight,
        isOpen,
        triggerRef,
        onClick,
        formatMessage,
        numberOfSelectedValues,
        formattedTooltipContent,
        isSoftwareFullTheming
    ]);
    const clickRetry = (0, $5uXOq.useCallback)(async ()=>{
        // opening and closing the popup to trigger the content to re-render if the retry is successful
        // otherwise content will remain showing errorFallback
        setIsOpen(false);
        entryPointActions.unload();
        await entryPointActions.load();
        setIsOpen(true);
    }, [
        entryPointActions
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
            entryPointReferenceSubject: entryPointReferenceSubject,
            id: "jira-filter-refinement-filter-popup-content",
            packageName: (0, $c2106d117ddd8c57$export$b8b9d90f9e5bd72b),
            teamName: (0, $c2106d117ddd8c57$export$d57b6b390e78d90f),
            errorFallback: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $23e82092abb69f47$var$containerStyles
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7AeDc.ErrorMessage), {
                    onClick: ()=>clickRetry(),
                    errorType: "fields"
                })),
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3JhIN.default), null),
            runtimeProps: runtimeProps
        }), [
        clickRetry,
        entryPointReferenceSubject,
        runtimeProps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hk6EP.SelectedFieldContainer), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ioD1B.ChoreographerContextProvider), {
        isChoreographed: coordinationClient?.enableChoreographer ?? false
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eyBlI.default), {
        onShortcutTriggered: onKeyboardShortcutTriggered
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: onClose,
        trigger: trigger,
        content: content,
        placement: "bottom-start" // unfortunately if we render to parent we are limited by page content z-index which is lower
        ,
        // than sidenav z-index and will make the popup appear below the sidenav on small screens
        // see https://jplat.atlassian.net/browse/EM-9105
        shouldRenderToParent: false,
        testId: "filter-refinement.ui.filter-popup",
        messageId: "filter-refinement.ui.filter-popup.popup",
        messageType: "transactional" // shouldUseCaptureOnOutsideClick allow popup to close by triggering onClose function
        ,
        // when clicking an atlaskit dropdown (known bug)
        // https://atlassian.slack.com/archives/CFJ9DU39U/p1704237711295599?thread_ts=1703624547.647969&cid=CFJ9DU39U
        shouldUseCaptureOnOutsideClick: true
    })));
};
const $23e82092abb69f47$var$containerStyles = (0, $8CUq3.xcss)({
    height: $23e82092abb69f47$var$POPUP_HEIGHT,
    width: $23e82092abb69f47$var$POPUP_WIDTH,
    color: 'color.text.subtle'
});
const $23e82092abb69f47$var$keyboardShortcutTagStyles = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    height: '16px',
    padding: 'space.050',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'space.075',
    color: 'color.text.inverse',
    borderColor: 'color.border.inverse',
    borderRadius: '3px',
    borderWidth: '1px',
    borderStyle: 'solid',
    textAlign: 'center'
});
const $23e82092abb69f47$var$tooltipContentStyles = (0, $8CUq3.xcss)({
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    columnGap: 'space.050',
    paddingInline: 'space.075',
    paddingBlock: 'space.025'
});
const $23e82092abb69f47$var$themedBadgeStyles = null;

});
parcelRegister("hk6EP", function(module, exports) {

$parcel$export(module.exports, "SelectedFieldContainer", () => $2d8948ecdc91c4cf$export$26fc63c9db330723);
$parcel$export(module.exports, "useSelectedFieldActions", () => $2d8948ecdc91c4cf$export$6e71256ae83b238b);
$parcel$export(module.exports, "useSelectedFieldState", () => $2d8948ecdc91c4cf$export$501cfe9e4a61d8b3);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $3sQ5x = parcelRequire("3sQ5x");
var $gg7kZ = parcelRequire("gg7kZ");
var $iXqE5 = parcelRequire("iXqE5");
const $2d8948ecdc91c4cf$export$d4c72bab9d6cc13a = {
    selectedField: undefined,
    fetchKey: 0
};
const $2d8948ecdc91c4cf$export$26fc63c9db330723 = (0, $gg7kZ.createContainer)();
const $2d8948ecdc91c4cf$var$Store = (0, $iXqE5.createStore)({
    containedBy: $2d8948ecdc91c4cf$export$26fc63c9db330723,
    initialState: $2d8948ecdc91c4cf$export$d4c72bab9d6cc13a,
    actions: {
        update: (field)=>({ setState: setState })=>{
                setState({
                    selectedField: field
                });
            },
        increaseKey: ()=>({ setState: setState, getState: getState })=>{
                setState({
                    fetchKey: getState().fetchKey + 1
                });
            }
    }
});
const $2d8948ecdc91c4cf$export$6e71256ae83b238b = (0, $3sQ5x.createActionsHook)($2d8948ecdc91c4cf$var$Store);
const $2d8948ecdc91c4cf$export$501cfe9e4a61d8b3 = (0, $3sQ5x.createStateHook)($2d8948ecdc91c4cf$var$Store);

});

parcelRegister("3JhIN", function(module, exports) {

$parcel$export(module.exports, "default", () => $778d2970107ad0da$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iwwXK = parcelRequire("iwwXK");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");

var $fNobW = parcelRequire("fNobW");

var $7LhdE = parcelRequire("7LhdE");
const $778d2970107ad0da$var$POPUP_HEIGHT = '380px';
const $778d2970107ad0da$var$POPUP_WIDTH = '600px';
const $778d2970107ad0da$export$fd74b00a71fbbd32 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "filter-popup-fallback"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $778d2970107ad0da$var$fallbackContentStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $778d2970107ad0da$var$FullHeightStyle
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $778d2970107ad0da$var$leftBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $778d2970107ad0da$var$flexGrowStyles
    }, Array.from({
        length: 4
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iwwXK.default), {
            isShimmering: true,
            key: index,
            width: "120px"
        }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $778d2970107ad0da$var$clearAllStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        width: "65px",
        height: "9px"
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $778d2970107ad0da$var$rightBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LhdE.default), null)))));
};
var $778d2970107ad0da$export$2e2bcd8739ae039 = $778d2970107ad0da$export$fd74b00a71fbbd32;
const $778d2970107ad0da$var$flexGrowStyles = (0, $8CUq3.xcss)({
    flex: 1
});
const $778d2970107ad0da$var$clearAllStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.300',
    paddingBottom: 'space.100'
});
const $778d2970107ad0da$var$fallbackContentStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.250',
    // keep height and width the same as popup content
    height: $778d2970107ad0da$var$POPUP_HEIGHT,
    width: $778d2970107ad0da$var$POPUP_WIDTH
});
const $778d2970107ad0da$var$leftBoxStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.250',
    width: '240px',
    display: 'flex',
    flexDirection: 'column'
});
const $778d2970107ad0da$var$rightBoxStyles = (0, $8CUq3.xcss)({
    paddingInline: 'space.250',
    width: '360px',
    display: 'flex',
    flexDirection: 'column',
    borderLeft: `1px solid ${"var(--ds-border, #091E4224)"}`
});
const $778d2970107ad0da$var$FullHeightStyle = (0, $8CUq3.xcss)({
    // the grey border line right needs to fill full height
    alignItems: 'stretch',
    height: '100%'
});

});
parcelRegister("7LhdE", function(module, exports) {

$parcel$export(module.exports, "default", () => $e0b79cfc916e9ddd$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $1DVhQ = parcelRequire("1DVhQ");

var $fNobW = parcelRequire("fNobW");
const $e0b79cfc916e9ddd$export$bf5676622311cf11 = ()=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fNobW.default), {
        name: "filter-select-fallback-skeleton"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e0b79cfc916e9ddd$var$flexGrowStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.400"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        width: "320px",
        height: "32px",
        borderRadius: "3px"
    }), Array.from({
        length: 4
    }, (_, index)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
            isShimmering: true,
            key: index,
            width: "120px",
            height: "9px"
        })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlockEnd: "space.150"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center",
        spread: "space-between",
        grow: "fill"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        width: "65px",
        height: "9px"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1DVhQ.default), {
        isShimmering: true,
        width: "35px",
        height: "9px"
    }))));
};
var $e0b79cfc916e9ddd$export$2e2bcd8739ae039 = $e0b79cfc916e9ddd$export$bf5676622311cf11;
const $e0b79cfc916e9ddd$var$flexGrowStyles = (0, $8CUq3.xcss)({
    flex: 1
});

});


parcelRegister("3b1XM", function(module, exports) {

$parcel$export(module.exports, "filterPopupContentEntryPoint", () => $1b98292f5c7c3d77$export$e291256b77dbc63a);

var $cxz6s = parcelRequire("cxz6s");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $1b98292f5c7c3d77$export$e291256b77dbc63a = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aI4ih")), {
        moduleId: "1e01de8d"
    }),
    getPreloadProps: ({ cloudId: cloudId, jqlContext: jqlContext, scope: scope, onFeedbackClick: onFeedbackClick })=>({
            queries: {
                filterRefinementBasicFields: {
                    options: {
                        fetchPolicy: 'store-or-network'
                    },
                    parameters: $cxz6s.default,
                    variables: {
                        cloudId: cloudId,
                        jqlContext: jqlContext,
                        scope: scope
                    }
                }
            },
            extraProps: {
                scope: scope,
                onFeedbackClick: onFeedbackClick
            }
        })
});

});
parcelRegister("cxz6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $0d2879e66ec852fd$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<b7164ef3da5dac4645c7ba4f971a3940>>
 * @relayHash 7ee60f991e19b3350fd56f78e329edaf
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4b6d01b54a80a6f305eec59cbde819a6e3d77e9f44d65db14ef4425cf88285c8

var $eiowN = parcelRequire("eiowN");
const $0d2879e66ec852fd$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "jqlContext"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "scope"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "cloudId",
        "variableName": "cloudId"
    }, v2 = {
        "kind": "Variable",
        "name": "jqlContext",
        "variableName": "jqlContext"
    }, v3 = {
        "kind": "Variable",
        "name": "scope",
        "variableName": "scope"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "ui_filterRefinementBasicFieldsQuery",
            "selections": [
                {
                    "args": [
                        v1 /*: any*/ ,
                        v2 /*: any*/ ,
                        v3 /*: any*/ 
                    ],
                    "kind": "FragmentSpread",
                    "name": "ui_filterRefinement_FilterPopupContent"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "ui_filterRefinementBasicFieldsQuery",
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                v1 /*: any*/ 
                            ],
                            "concreteType": "JiraJqlBuilder",
                            "kind": "LinkedField",
                            "name": "jqlBuilder",
                            "plural": false,
                            "selections": [
                                {
                                    "args": [
                                        v2 /*: any*/ ,
                                        v3 /*: any*/ 
                                    ],
                                    "kind": "LinkedField",
                                    "name": "fields",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "ScalarField",
                                            "name": "__typename"
                                        },
                                        {
                                            "kind": "InlineFragment",
                                            "selections": [
                                                {
                                                    "concreteType": "JiraJqlFieldEdge",
                                                    "kind": "LinkedField",
                                                    "name": "edges",
                                                    "plural": true,
                                                    "selections": [
                                                        {
                                                            "concreteType": "JiraJqlField",
                                                            "kind": "LinkedField",
                                                            "name": "node",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "displayName"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "jqlTerm"
                                                                },
                                                                {
                                                                    "kind": "ScalarField",
                                                                    "name": "type"
                                                                }
                                                            ]
                                                        }
                                                    ]
                                                }
                                            ],
                                            "type": "JiraJqlFieldConnection"
                                        }
                                    ]
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        "params": {
            "id": "4b6d01b54a80a6f305eec59cbde819a6e3d77e9f44d65db14ef4425cf88285c8",
            "metadata": {},
            "name": "ui_filterRefinementBasicFieldsQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$0d2879e66ec852fd$var$node.hash = "91f7a7d682ec5f25027ad0c9c9a2b35c";
(0, $eiowN.PreloadableQueryRegistry).set($0d2879e66ec852fd$var$node.params.id, $0d2879e66ec852fd$var$node);
var $0d2879e66ec852fd$export$2e2bcd8739ae039 = $0d2879e66ec852fd$var$node;

});

parcelRegister("aI4ih", function(module, exports) {

let $7cc1581b68654585$var$load = (parcelRequire("28QjX"))(4);
module.exports = $7cc1581b68654585$var$load("eLZz0").then(()=>parcelRequire('eXvfk'));

});


parcelRegister("iHttZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $923be56be5869b46$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $923be56be5869b46$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterButton: {
        "id": "filter-refinement.filter-popup.filter-button",
        "defaultMessage": "Filter"
    },
    tooltipMessage: {
        "id": "filter-refinement.filter-popup.tooltip-message",
        "defaultMessage": "Filter <inline>Shift</inline> + <inline>F</inline>"
    }
});

});

parcelRegister("7AeDc", function(module, exports) {

$parcel$export(module.exports, "ErrorMessage", () => $b37cf5bc3d112c9b$export$915e9e7bd4f0f96d);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $hMVoD = parcelRequire("hMVoD");

var $dC5iT = parcelRequire("dC5iT");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");

var $koVbs = parcelRequire("koVbs");

var $1dypl = parcelRequire("1dypl");
const $b37cf5bc3d112c9b$var$POPUP_HEIGHT = '380px';
const $b37cf5bc3d112c9b$export$915e9e7bd4f0f96d = ({ onClick: onClick, errorType: errorType, spacing: spacing = 'default', showSecondaryText: showSecondaryText = true, buttonLabel: buttonLabel, setHeight: setHeight })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const ref = (0, $5uXOq.useRef)(null);
    // used for fieldValuesPagination error to calculate height of atlaskit select component
    (0, $5uXOq.useLayoutEffect)(()=>{
        if (ref && ref.current && setHeight) setHeight(ref.current.clientHeight);
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        alignInline: "center",
        alignBlock: "center",
        space: spacing === 'default' ? 'space.150' : 'space.0',
        xcss: [
            $b37cf5bc3d112c9b$var$containerStyles,
            spacing === 'default' ? $b37cf5bc3d112c9b$var$defaultStyles : $b37cf5bc3d112c9b$var$compactStyles
        ],
        ref: ref,
        testId: "filter-refinement.ui.filter-popup.filter-popup-content.ui.error-message.stack"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hMVoD))), {
        label: ""
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100",
        paddingInline: "space.400",
        xcss: [
            $b37cf5bc3d112c9b$var$textCenterStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, formatMessage((0, $1dypl.default).errorPrimaryMessage))), showSecondaryText && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        paddingBlock: "space.100",
        paddingInline: "space.400",
        xcss: [
            $b37cf5bc3d112c9b$var$textCenterStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        color: "color.text.subtle"
    }, formatMessage((0, $1dypl.default).errorSecondaryMessage)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
        onClick: (_, analyticsEvent)=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'filterDialogErrorRefreshButton', {
                errorType: errorType
            });
            onClick();
        },
        spacing: spacing,
        testId: "filter-refinement.ui.filter-popup.filter-popup-content.ui.error-message.button"
    }, formatMessage(buttonLabel || (0, $1dypl.default).retryButtonLabel))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireUiAnalytics), {
        actionSubject: "errorMessage",
        action: "viewed",
        actionSubjectId: "filterDialogErrorMessage",
        attributes: {
            errorType: errorType
        }
    }));
};
const $b37cf5bc3d112c9b$var$containerStyles = (0, $8CUq3.xcss)({
    color: 'color.text.subtle'
});
const $b37cf5bc3d112c9b$var$defaultStyles = (0, $8CUq3.xcss)({
    paddingBlock: 'space.250',
    height: $b37cf5bc3d112c9b$var$POPUP_HEIGHT
});
const $b37cf5bc3d112c9b$var$compactStyles = (0, $8CUq3.xcss)({
    paddingTop: 'space.100'
});
const $b37cf5bc3d112c9b$var$textCenterStyles = (0, $8CUq3.xcss)({
    textAlign: 'center'
});

});
parcelRegister("1dypl", function(module, exports) {

$parcel$export(module.exports, "default", () => $e909b2e158547e04$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $e909b2e158547e04$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorPrimaryMessage: {
        "id": "filter-refinement.filter-popup.filter-popup-content.error-message.error-primary-message",
        "defaultMessage": "Something went wrong."
    },
    errorSecondaryMessage: {
        "id": "filter-refinement.filter-popup.filter-popup-content.error-message.error-secondary-message",
        "defaultMessage": "Refresh and try again."
    },
    retryButtonLabel: {
        "id": "filter-refinement.filter-popup.filter-popup-content.error-message.retry-button-label",
        "defaultMessage": "Refresh"
    }
});

});


parcelRegister("eyBlI", function(module, exports) {

$parcel$export(module.exports, "default", () => $715f98ebfd6f51eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $jX361 = parcelRequire("jX361");

var $koVbs = parcelRequire("koVbs");

var $879xD = parcelRequire("879xD");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $2FAoR = parcelRequire("2FAoR");
const $715f98ebfd6f51eb$var$KeyboardShortcuts = ({ onShortcutTriggered: onShortcutTriggered })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const keyMap = (0, $5uXOq.useMemo)(()=>({
            F: {
                callback: onShortcutTriggered,
                registerInCommandPalette: {
                    id: 'filter-refinement-open-filter-popup',
                    name: formatMessage((0, $2FAoR.default).openFilterPopup),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($jX361))), {
                                label: formatMessage((0, $2FAoR.default).openFilterPopup),
                                color: "var(--ds-icon, #44546F)"
                            })
                    },
                    priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).openFilterPopup,
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions
                }
            }
        }), [
        formatMessage,
        getKeywords,
        onShortcutTriggered
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: keyMap
    });
};
var $715f98ebfd6f51eb$export$2e2bcd8739ae039 = $715f98ebfd6f51eb$var$KeyboardShortcuts;

});
parcelRegister("2FAoR", function(module, exports) {

$parcel$export(module.exports, "default", () => $da38b36dc52f47a2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $da38b36dc52f47a2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    openFilterPopup: {
        "id": "filter-refinement.search-field.keyboard-shortcuts.open-filter-popup",
        "defaultMessage": "Filter work items"
    }
});

});



parcelRegister("8ukYE", function(module, exports) {

$parcel$export(module.exports, "default", () => $d404a4d5d7415424$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $2xSAL = parcelRequire("2xSAL");

var $hOHOl = parcelRequire("hOHOl");


var $91Ixh = parcelRequire("91Ixh");

var $lj1vv = parcelRequire("lj1vv");
const $d404a4d5d7415424$var$debounceOnChange = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))(({ onChange: onChange, targetValue: targetValue })=>{
    onChange(targetValue);
}, 500, {
    leading: false,
    trailing: true
});
const $d404a4d5d7415424$var$searchFieldContainerStyles = (0, $8CUq3.xcss)({
    width: '100%',
    maxWidth: '160px'
});
const $d404a4d5d7415424$var$SearchField = ({ inputLabel: inputLabel, isDisabled: isDisabled = false })=>{
    const ast = (0, $hOHOl.useAST)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const textSearchInputClause = (0, $hOHOl.useTextSearchInputClause)();
    const { updateJql: updateJql } = (0, $hOHOl.useASTActions)();
    const searchRef = (0, $5uXOq.useRef)(null);
    const valueWithSpecialCharacters = (0, $5uXOq.useRef)();
    const value = (0, $5uXOq.useMemo)(()=>(0, $lj1vv.getValue)(textSearchInputClause, valueWithSpecialCharacters.current) || '', [
        textSearchInputClause
    ]);
    const handleSearch = (0, $5uXOq.useCallback)((newSearchValue)=>{
        const unsupportedCharacters = (0, $lj1vv.getUnsupportedCharacters)(newSearchValue);
        valueWithSpecialCharacters.current = unsupportedCharacters?.length ? newSearchValue : undefined;
        const updatedSearchString = (0, $lj1vv.update)(ast, textSearchInputClause, newSearchValue);
        updateJql({
            jql: updatedSearchString,
            fieldType: (0, $c2106d117ddd8c57$export$b2dcd38723ba8c75)
        });
        if (unsupportedCharacters) (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'filterRefinement searchWithUnsupportedCharacters', {
            unsupportedCharacters: [
                ...new Set(unsupportedCharacters)
            ]
        });
    }, [
        ast,
        createAnalyticsEvent,
        textSearchInputClause,
        updateJql
    ]);
    const handleChange = (0, $5uXOq.useCallback)((targetValue)=>{
        $d404a4d5d7415424$var$debounceOnChange({
            onChange: handleSearch,
            targetValue: targetValue
        });
    }, [
        handleSearch
    ]);
    const handleFocus = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), {
            action: 'focused',
            actionSubject: 'input',
            actionSubjectId: 'search',
            attributes: {
                keyboardShortcut: 'false'
            }
        });
    }, [
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $91Ixh.default), {
        searchRef: searchRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        xcss: $d404a4d5d7415424$var$searchFieldContainerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        onChange: handleChange,
        onFocus: handleFocus,
        value: value,
        placeholder: inputLabel,
        placeholderAlwaysVisible: true,
        isCompact: true,
        isResponsive: true,
        inputRef: searchRef,
        isDisabled: isDisabled,
        showIconBeforeInput: true,
        shouldFitContainerWidth: true,
        testId: "filter-refinement.ui.search-field"
    })));
};
var $d404a4d5d7415424$export$2e2bcd8739ae039 = $d404a4d5d7415424$var$SearchField;

});
parcelRegister("91Ixh", function(module, exports) {

$parcel$export(module.exports, "default", () => $42187178d301da46$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $gKZoD = parcelRequire("gKZoD");

var $kdfZa = parcelRequire("kdfZa");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $879xD = parcelRequire("879xD");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $jKL6D = parcelRequire("jKL6D");
const $42187178d301da46$var$KeyboardShortcuts = ({ searchRef: searchRef })=>{
    (0, $gKZoD.di)(requestAnimationFrame);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const focusSearchInputOnShortcut = (0, $5uXOq.useCallback)(()=>{
        if (searchRef?.current) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                searchRef.current?.focus();
            });
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'focused',
                actionSubject: 'input'
            }), 'search', {
                keyPressed: 'f',
                keyboardShortcut: true
            });
        }
    }, [
        searchRef,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInputOnShortcut,
                registerInCommandPalette: {
                    id: 'filter-refinement-search-field-focus-search-input',
                    name: formatMessage((0, $jKL6D.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kdfZa))), {
                                label: formatMessage((0, $jKL6D.default).searchCurrentPage),
                                color: "var(--ds-icon, #44546F)"
                            })
                    },
                    priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        }
    });
};
var $42187178d301da46$export$2e2bcd8739ae039 = $42187178d301da46$var$KeyboardShortcuts;

});
parcelRegister("jKL6D", function(module, exports) {

$parcel$export(module.exports, "default", () => $87812d7dddfec99f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $87812d7dddfec99f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    searchCurrentPage: {
        "id": "filter-refinement.search-field.keyboard-shortcuts.search-current-page",
        "defaultMessage": "Search on current page"
    }
});

});


parcelRegister("lj1vv", function(module, exports) {

$parcel$export(module.exports, "getUnsupportedCharacters", () => $73c1f1716d001c51$export$370943be1a92c506);
$parcel$export(module.exports, "getValue", () => $73c1f1716d001c51$export$bf7199a9ebcb84a9);
$parcel$export(module.exports, "update", () => $73c1f1716d001c51$export$722fbec263ad908a);

var $iEIQF = parcelRequire("iEIQF");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");


var $e2qHI = parcelRequire("e2qHI");
const $73c1f1716d001c51$export$125e49598117a72 = (text)=>text ? `"${text.replace(/"/g, '\\"')}"` : '';
const $73c1f1716d001c51$export$fbd15c27bb7e257c = (text)=>text.replace(/\\/g, '\\\\');
const $73c1f1716d001c51$var$UNSUPPORTED_CHARACTERS = /[+\-&|!(){}[\]^~*?\\:]/g;
// JQL engine ignores + - & | ! ( ) { } [ ] ^ ~ * ? \ : special characters, so we need to remove them
// more info in https://confluence.atlassian.com/jirasoftwareserver/search-syntax-for-text-fields-939938747.html
const $73c1f1716d001c51$var$removeUnsupportedCharacters = (text)=>text.replace($73c1f1716d001c51$var$UNSUPPORTED_CHARACTERS, ' ').trim();
const $73c1f1716d001c51$export$370943be1a92c506 = (text)=>!(0, $e2qHI.isIssueKeyValue)(text) ? text.match($73c1f1716d001c51$var$UNSUPPORTED_CHARACTERS) : null;
const $73c1f1716d001c51$export$791c88541a44cd7f = (text)=>{
    /*
	 * If the last character is a space, we don't need to add a wildcard
	 * because adding a wildcard after space will not match any issue
	 *
	 * If the last character is a quote, we don't need to add a wildcard
	 * this way we allow users to do exact match searches
	 */ const lastChar = text[text.length - 1];
    if (!lastChar || lastChar === ' ' || lastChar === '"') return text;
    return `${text}*`;
};
const $73c1f1716d001c51$export$a22775fa5e2eebd9 = (compoundClause)=>{
    if (!compoundClause) return true;
    try {
        compoundClause.accept(new (0, $e2qHI.TextSearchInputVisitor)());
        return true;
    } catch (e) {
        return false;
    }
};
const $73c1f1716d001c51$export$bf7199a9ebcb84a9 = (textSearchInputClause, valueWithSpecialCharacters)=>{
    if (!textSearchInputClause) return valueWithSpecialCharacters || undefined;
    let quotedKeyword = textSearchInputClause.accept(new (0, $e2qHI.TextSearchInputVisitor)());
    if (quotedKeyword && quotedKeyword[quotedKeyword.length - 1] === '*') quotedKeyword = quotedKeyword.slice(0, -1);
    if (!valueWithSpecialCharacters) return quotedKeyword;
    return $73c1f1716d001c51$var$removeUnsupportedCharacters(valueWithSpecialCharacters) === quotedKeyword ? valueWithSpecialCharacters : quotedKeyword;
};
const $73c1f1716d001c51$var$createTextSearchInputClause = ({ quotedKeyword: quotedKeyword, isIssueKey: isIssueKey })=>{
    const textSearchInputClause = (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $c2106d117ddd8c57$export$b2dcd38723ba8c75)), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_LIKE)), (0, $iEIQF.default).byText.valueOperand(quotedKeyword));
    if (isIssueKey) {
        const issueKeyClause = (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field((0, $c2106d117ddd8c57$export$5daa28d10e23592)), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), (0, $iEIQF.default).byText.valueOperand(quotedKeyword));
        return (0, $iEIQF.default).compoundClause((0, $iEIQF.default).compoundOperator((0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753)), [
            textSearchInputClause,
            issueKeyClause
        ]);
    }
    return textSearchInputClause;
};
const $73c1f1716d001c51$var$getQuotedKeyword = (val)=>{
    if (val === undefined || val === null || val === '') return {
        quotedKeyword: undefined,
        isIssueKey: false
    };
    const isIssueKey = (0, $e2qHI.isIssueKeyValue)(val);
    const quotedKeyword = isIssueKey ? $73c1f1716d001c51$export$125e49598117a72($73c1f1716d001c51$export$fbd15c27bb7e257c(val)) : $73c1f1716d001c51$export$125e49598117a72($73c1f1716d001c51$export$791c88541a44cd7f($73c1f1716d001c51$export$fbd15c27bb7e257c($73c1f1716d001c51$var$removeUnsupportedCharacters(val))));
    return {
        quotedKeyword: quotedKeyword,
        isIssueKey: isIssueKey
    };
};
const $73c1f1716d001c51$export$722fbec263ad908a = (ast, textSearchInputClause, val)=>{
    if (!$73c1f1716d001c51$export$a22775fa5e2eebd9(textSearchInputClause)) return ast.represents;
    const { quotedKeyword: quotedKeyword, isIssueKey: isIssueKey } = $73c1f1716d001c51$var$getQuotedKeyword(val);
    if (quotedKeyword) {
        const newTextSearchInputClause = $73c1f1716d001c51$var$createTextSearchInputClause({
            quotedKeyword: quotedKeyword,
            isIssueKey: isIssueKey
        });
        if (textSearchInputClause) textSearchInputClause.replace(newTextSearchInputClause);
        else ast.query?.appendClause(newTextSearchInputClause, (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
    } else if (textSearchInputClause) textSearchInputClause.remove();
    else return ast.represents;
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};

});
parcelRegister("e2qHI", function(module, exports) {

$parcel$export(module.exports, "isIssueKeyValue", () => $6b80b08b71af9da7$export$ac7a009e7c9d6434);
$parcel$export(module.exports, "TextSearchInputVisitor", () => $6b80b08b71af9da7$export$d5784d52b31adc66);

var $bv7J5 = parcelRequire("bv7J5");
var $bzbto = parcelRequire("bzbto");

const $6b80b08b71af9da7$var$areTerminalClauses = (clauses)=>{
    for (const clause of clauses){
        if (clause.clauseType !== (0, $e9a0ef16a223cbc7$export$ae56b4ef248a2b6a)) return false;
    }
    return true;
};
const $6b80b08b71af9da7$var$ISSUE_KEY_REGEXP = new RegExp('^[A-Z][A-Z0-9]+-[0-9]+$', 'i');
const $6b80b08b71af9da7$export$ac7a009e7c9d6434 = (value)=>value !== undefined && value !== null && $6b80b08b71af9da7$var$ISSUE_KEY_REGEXP.test(value);
class $6b80b08b71af9da7$export$d5784d52b31adc66 extends (0, $bv7J5.AbstractJastVisitor) {
    defaultResult() {
        throw new Error('Invalid search input clause');
    }
    constructor(...args){
        super(...args), this.visitCompoundClause = (compoundClause)=>{
            // Only allow one compound clause with 2 or 3 terminal clauses using OR operator
            if (compoundClause.clauses.length > 2 || compoundClause.clauses.length < 1 || compoundClause.operator.value !== (0, $3cef51f82b2cbe1d$export$7b8f0a728d79a753) || !$6b80b08b71af9da7$var$areTerminalClauses(compoundClause.clauses)) throw new Error('Invalid search input clause');
            const valueMap = {};
            const value = compoundClause.clauses.reduce((result, terminalClause)=>{
                const clauseFieldName = terminalClause.field.value.toLowerCase();
                // Use same fieldName for key and issuekey (they are aliases)
                const fieldName = clauseFieldName === 'key' ? 'issuekey' : clauseFieldName;
                // Check if there are duplicated fields
                if (valueMap[fieldName]) throw new Error(`Duplicated field ${fieldName}`);
                else valueMap[fieldName] = true;
                return this.aggregateResult(terminalClause.accept(this), result);
            }, undefined);
            // Check if all required fields are present
            if (!valueMap[0, $c2106d117ddd8c57$export$b2dcd38723ba8c75] || valueMap.issuekey !== undefined && !valueMap.issuekey) throw new Error('Missing required field in search input');
            return value;
        }, this.visitTerminalClause = (terminalClause)=>{
            const fieldName = terminalClause.field.value.toLowerCase();
            // Only allow terminal clause with value operand
            if (terminalClause.operand?.operandType !== (0, $49b29ef7baa2a152$export$38accfc5a5d1c113)) throw new Error(`Invalid operandType ${terminalClause.operand?.operandType}`);
            if (fieldName === (0, $c2106d117ddd8c57$export$b2dcd38723ba8c75)) {
                if (terminalClause.operator?.value !== (0, $bzbto.OPERATOR_LIKE)) throw new Error(`Invalid operator in ${fieldName}`);
                return terminalClause.operand.value;
            }
            // Issue key check
            if (fieldName === 'issuekey' || fieldName === 'key') {
                if (terminalClause.operator?.value !== (0, $bzbto.OPERATOR_EQUALS)) throw new Error(`Invalid operator in ${fieldName}`);
                if (!$6b80b08b71af9da7$export$ac7a009e7c9d6434(terminalClause.operand.value)) throw new Error(`Invalid value in ${fieldName}`);
                return terminalClause.operand.value;
            }
            throw new Error(`Invalid field ${fieldName}`);
        }, this.aggregateResult = (aggregate, nextResult)=>{
            // We only allow using same value in all terminal clauses
            if (nextResult !== undefined && aggregate !== nextResult) throw new Error('Mismatched values in search input');
            return aggregate;
        };
    }
}

});




parcelRegister("1othz", function(module, exports) {

$parcel$export(module.exports, "useSuspenselessRefetchStateless", () => $7714fce489d6815b$export$ae1adabf094b2244);
$parcel$export(module.exports, "useSuspenselessRefetch", () => $7714fce489d6815b$export$c7ce5f64dc007896);
// eslint-disable-next-line jira/restricted/react-18

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $biQrn = parcelRequire("biQrn");

var $4R6GH = parcelRequire("4R6GH");

var $c1haS = parcelRequire("c1haS");
const $7714fce489d6815b$var$useInFlightRequests = ({ setIsLoading: setIsLoading })=>{
    const inFlightRequestsRef = (0, $5uXOq.useRef)([]);
    return (0, $5uXOq.useMemo)(()=>({
            onNewRequest: (request)=>{
                inFlightRequestsRef.current.push(request);
            },
            onRequestFinish: (request, /**
				 * Called only if the request hasn't been superceded by a more recent request's success / failure
				 */ onIfRequestIsRelevant)=>{
                // find the first occurrence of this request
                const inFlightRequestIndex = inFlightRequestsRef.current.indexOf(request);
                // If the current request is still considered "in flight"
                if (inFlightRequestIndex !== -1) {
                    onIfRequestIsRelevant?.();
                    // Cut out the current and all proceeding requests from the in-flight queue
                    inFlightRequestsRef.current = inFlightRequestsRef.current.slice(inFlightRequestIndex + 1);
                    // Update isLoading to reflect the current number of in-flight requests
                    setIsLoading?.(!!inFlightRequestsRef.current.length);
                }
            }
        }), [
        setIsLoading
    ]);
};
const $7714fce489d6815b$var$useTransitionNoop = ()=>[
        null,
        null
    ];
const $7714fce489d6815b$export$ae1adabf094b2244 = (// Relay-generated query from the @refetchable annotation in a useRefetchableFragment
// or usePaginationFragment
query, // Refetch function from a useRefetchableFragment or usePaginationFragment
// (which ordinarily would trigger suspense)
refetch, { setIsLoading: setIsLoading, setLastFetchError: setLastFetchError, fetchPolicy: fetchPolicy = 'store-or-network', networkCacheConfig: networkCacheConfig } = {})=>{
    const environment = (0, $8Uumt.useRelayEnvironment)();
    const isMounted = (0, $biQrn.useIsMounted)();
    const { onNewRequest: onNewRequest, onRequestFinish: onRequestFinish } = $7714fce489d6815b$var$useInFlightRequests({
        setIsLoading: setIsLoading
    });
    const useTransitionFG = (0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('jira-concurrent-suspenseless-refetch') // Done to prevent react-hooks/rules-of-hooks eslint error that is being ratcheted against
     ? (0, $5uXOq.useTransition) : $7714fce489d6815b$var$useTransitionNoop;
    const [_, startTransition] = useTransitionFG();
    return (0, $5uXOq.useCallback)((variables)=>{
        if (isMounted.current) setIsLoading?.(true);
        onNewRequest(variables);
        return (0, $8Uumt.fetchQuery)(environment, query, variables, {
            fetchPolicy: fetchPolicy,
            networkCacheConfig: networkCacheConfig
        }).subscribe({
            complete () {
                if (isMounted.current) {
                    if (startTransition && (0, $c1haS.getIsConcurrentEnabled)() && (0, $4R6GH.fg)('jira-concurrent-suspenseless-refetch')) // we need concurrent mode for useTransition to work
                    startTransition(()=>{
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    });
                    else {
                        setLastFetchError?.(null);
                        onRequestFinish(variables, ()=>{
                            refetch(variables, {
                                fetchPolicy: 'store-only'
                            });
                        });
                    }
                }
            },
            error (e) {
                if (isMounted.current) onRequestFinish(variables, ()=>setLastFetchError?.(e));
            }
        });
    }, [
        environment,
        fetchPolicy,
        isMounted,
        networkCacheConfig,
        onNewRequest,
        onRequestFinish,
        query,
        refetch,
        setIsLoading,
        setLastFetchError,
        startTransition
    ]);
};
const $7714fce489d6815b$export$c7ce5f64dc007896 = (query, refetch, options)=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [lastFetchError, setLastFetchError] = (0, $5uXOq.useState)(null);
    const refetchFunction = $7714fce489d6815b$export$ae1adabf094b2244(query, refetch, {
        ...options,
        setIsLoading: setIsLoading,
        setLastFetchError: setLastFetchError
    });
    return [
        refetchFunction,
        isLoading,
        lastFetchError
    ];
};

});

parcelRegister("05fhZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $17d2b93146d18158$export$2e2bcd8739ae039);

var $fKrqu = parcelRequire("fKrqu");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $9vASA = parcelRequire("9vASA");

var $5oFIy = parcelRequire("5oFIy");
const $17d2b93146d18158$var$CustomFilterRelay = ({ customFiltersFragmentRef: customFiltersFragmentRef, screenName: screenName, ...props })=>{
    const { boardScope: boardScope } = (0, $8Uumt.useFragment)((0, $fKrqu.default), customFiltersFragmentRef);
    // each item in an array is nullable & an object's keys readonly in relay's generated type
    const filters = (0, $5uXOq.useMemo)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    ()=>boardScope?.customFilters.filter(Boolean) || [], [
        boardScope?.customFilters
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vASA.default), {
        ...props,
        filters: filters
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
        actionSubject: "ui",
        action: "taskSuccess",
        attributes: {
            screenName: screenName,
            task: 'loadCustomFilters',
            customFiltersCount: filters.length
        }
    }));
};
var $17d2b93146d18158$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($17d2b93146d18158$var$CustomFilterRelay);

});
parcelRegister("fKrqu", function(module, exports) {

$parcel$export(module.exports, "default", () => $d300f59e5c1532b6$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<27f6e515959b3fa71c98f3b9ea403490>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $d300f59e5c1532b6$var$node = {
    "argumentDefinitions": [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ],
    "kind": "Fragment",
    "name": "customFilter_softwareFilters_CustomFilterRelay",
    "selections": [
        {
            "kind": "RequiredField",
            "field": {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "boardId",
                        "variableName": "boardId"
                    }
                ],
                "concreteType": "BoardScope",
                "kind": "LinkedField",
                "name": "boardScope",
                "plural": false,
                "selections": [
                    {
                        "kind": "RequiredField",
                        "field": {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "id"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.id"
                                },
                                {
                                    "kind": "RequiredField",
                                    "field": {
                                        "kind": "ScalarField",
                                        "name": "name"
                                    },
                                    "action": "THROW",
                                    "path": "boardScope.customFilters.name"
                                }
                            ]
                        },
                        "action": "THROW",
                        "path": "boardScope.customFilters"
                    }
                ]
            },
            "action": "THROW",
            "path": "boardScope"
        }
    ],
    "type": "Query"
};
$d300f59e5c1532b6$var$node.hash = "ae7389daa2b7626fc0f4f542c785e41f";
var $d300f59e5c1532b6$export$2e2bcd8739ae039 = $d300f59e5c1532b6$var$node;

});

parcelRegister("9vASA", function(module, exports) {

$parcel$export(module.exports, "default", () => $0c0f814f674e18a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $4R6GH = parcelRequire("4R6GH");

var $96s6B = parcelRequire("96s6B");

var $78uGw = parcelRequire("78uGw");
const $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED = 10;
const $0c0f814f674e18a1$var$CustomFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], showLink: showLink = false, manageUrl: manageUrl = '', onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false, isCompanyManaged: isCompanyManaged = false, isPanelToggleChecked: isPanelToggleChecked = false, onTogglePanel: onTogglePanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), removeOuterPadding: removeOuterPadding = false, showPanelToggle: showPanelToggle = false, shouldReturnFocus: shouldReturnFocus, isTriggerDisabled: isTriggerDisabled = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $78uGw.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED
    });
    const onLinkItemClick = (0, $5uXOq.useCallback)(()=>{
        (0, $14uhY.setReturnToProjectUrl)();
    }, []);
    const filterLabel = isCompanyManaged ? (0, $78uGw.default).labelCmp : (0, $78uGw.default).label;
    const manageLinkTitle = isCompanyManaged ? (0, $78uGw.default).manageLinkTitleCmp : (0, $78uGw.default).manageLinkTitle;
    const toggleLabel = isCompanyManaged ? formatMessage((0, $78uGw.default).toggleLabelCmp) : undefined;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isTriggerDisabled: isTriggerDisabled && (0, $4R6GH.fg)('tnk_disable_custom_filter_when_there_are_5k_issues'),
        shouldReturnFocus: shouldReturnFocus,
        buttonType: "QuickFilters",
        "data-testid": "filters.ui.filters.custom.assignee-filter",
        label: formatMessage(filterLabel),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        showLink: showLink,
        url: manageUrl,
        useHrefForUrl: isCompanyManaged,
        linkTitle: formatMessage(manageLinkTitle),
        maxSelectionAllowed: isCompanyManaged ? undefined : $0c0f814f674e18a1$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested,
        onLinkItemClick: onLinkItemClick,
        showPanelToggle: showPanelToggle,
        onTogglePanel: onTogglePanel,
        isPanelToggleChecked: isPanelToggleChecked,
        toggleLabel: toggleLabel,
        removeOuterPadding: removeOuterPadding,
        placeholder: formatMessage(isCompanyManaged ? (0, $78uGw.default).placeholderCmp : (0, $78uGw.default).placeholder),
        shouldCloseMenuOnTab: showPanelToggle ? false : undefined
    });
};
const $0c0f814f674e18a1$var$CustomFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($0c0f814f674e18a1$var$CustomFilter);
$0c0f814f674e18a1$var$CustomFilterComponent.displayName = 'CustomFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$0c0f814f674e18a1$var$CustomFilterComponent.whyDidYouRender = true;
var $0c0f814f674e18a1$export$2e2bcd8739ae039 = $0c0f814f674e18a1$var$CustomFilterComponent;

});
parcelRegister("96s6B", function(module, exports) {

$parcel$export(module.exports, "default", () => $51e7460acbb65361$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $2NMNM = parcelRequire("2NMNM");

var $itpgN = parcelRequire("itpgN");
var $bChGW = parcelRequire("bChGW");
var $b9dFI = parcelRequire("b9dFI");

var $dqoiX = parcelRequire("dqoiX");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $8C9C3 = parcelRequire("8C9C3");

var $dF38k = parcelRequire("dF38k");

var $73s29 = parcelRequire("73s29");

var $d9hVL = parcelRequire("d9hVL");

var $4Mv0u = parcelRequire("4Mv0u");

var $ijTad = parcelRequire("ijTad");
const $51e7460acbb65361$var$MenuListWrapper = ({ children: children, ...rest })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        "data-testid": "filters.common.ui.list.menu-list-wrapper"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).MenuList, rest, children));
const $51e7460acbb65361$export$fa71ab09534e6447 = ({ isOpen: defaultIsOpen, isTriggerDisabled: isTriggerDisabled, isNested: isNested, isLoading: isLoading, isAsyncSearch: isAsyncSearch, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, label: label, toggleLabel: toggleLabel, buttonType: buttonType, values: values, selectedValues: selectedValueIds, onChange: onChange, onInputChange: onInputChange, onOpenChange: onOpenChange, removeOuterPadding: removeOuterPadding, noOptionsMessage: noOptionsMessage, menuGroupTitle: menuGroupTitle, inputValue: inputValue, maxSelectionAllowed: maxSelectionAllowed, maxSelectionReachedTooltip: maxSelectionReachedTooltip, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, CustomOptionLabel: CustomOptionLabel, placeholder: placeholder, shouldReturnFocus: shouldReturnFocus, shouldCloseMenuOnTab: shouldCloseMenuOnTab, ...footerProps })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const firstRender = (0, $5uXOq.useRef)(true);
    const options = (0, $5uXOq.useMemo)(()=>(0, $ijTad.getOptionsFromProps)({
            values: values,
            menuGroupTitle: menuGroupTitle
        }), [
        values,
        menuGroupTitle
    ]);
    const { optionsWithSelectedSection: optionsWithSelectedSection, updateSelectedOptionGroup: updateSelectedOptionGroup, shouldTrackExperimentEvents: shouldTrackExperimentEvents } = (0, $ijTad.useGetOptionsWithSelectedOptionGroup)();
    if (firstRender.current === true && defaultIsOpen === true) updateSelectedOptionGroup({
        isOpen: defaultIsOpen,
        options: options,
        selectedValueIds: selectedValueIds
    });
    if (firstRender.current === true) firstRender.current = false;
    const { selectedIdLookup: selectedIdLookup, selectedOptions: selectedOptions } = (0, $5uXOq.useMemo)(()=>(0, $ijTad.getSelectedOptionsFromProps)({
            values: values,
            selectedValueIds: selectedValueIds
        }), [
        values,
        selectedValueIds
    ]);
    const previousSelectedCount = (0, $5uXOq.useRef)(selectedValueIds.length);
    /* Cannot return null here for async search as this would cause the
   * filter to disappear completely when fetch returns no results.
   */ if (!showMenuIfValuesAreEmpty && !isAsyncSearch && values.length === 0) return null;
    // ================= //
    // === Callbacks === //
    // ================= //
    const onChangeHandler = (selected)=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        onChange(selected);
        // Temporary analytics for the experiment
        if (shouldTrackExperimentEvents.current === true) {
            if (selected.length > previousSelectedCount.current) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filterItem',
                action: 'selected',
                actionSubjectId: 'listFilter'
            }));
            else if (selected.length < previousSelectedCount.current) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'filterItem',
                action: 'deselected',
                actionSubjectId: 'listFilter'
            }));
            previousSelectedCount.current = selected.length;
        }
    };
    const onOpenChangeHandler = (isOpen)=>{
        const analyticsEvent = createAnalyticsEvent((0, $8C9C3.OPEN_CHANGE_PAYLOAD));
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $8C9C3.OPEN_CHANGE_SUBJECT_ID));
        onOpenChange(isOpen);
        updateSelectedOptionGroup({
            isOpen: isOpen,
            options: options,
            selectedValueIds: selectedValueIds
        });
    };
    const isOptionDisabled = (option)=>selectedOptions.length >= maxSelectionAllowed && !selectedIdLookup.has(option.value.toString());
    // ============== //
    // === RENDER === //
    // ============== //
    // Select expects a function that returns a string, rather than a string primitive
    const getNoOptionsMessage = noOptionsMessage === undefined ? noOptionsMessage : ()=>noOptionsMessage;
    const renderTrigger = (popupProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4Mv0u.default), {
            ...popupProps,
            isDisabled: isTriggerDisabled,
            shouldReturnFocus: shouldReturnFocus,
            buttonType: buttonType,
            label: label,
            selectedCount: selectedOptions.length,
            removeOuterPadding: removeOuterPadding,
            isNested: isNested,
            onMouseEnter: onMouseEnterToTriggerButton
        });
    const renderFooter = ()=>(footerProps.showLink || footerProps.showPanelToggle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dF38k.default), {
            label: label,
            toggleLabel: toggleLabel,
            ...footerProps
        });
    const renderOption = (option)=>{
        const { label: optionLabel, iconUrl: iconUrl, subLabel: subLabel, value: value } = option;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d9hVL.default), {
            label: optionLabel,
            subLabel: subLabel,
            iconUrl: iconUrl,
            value: String(value),
            isDisabled: isOptionDisabled(option),
            maxSelectionReachedTooltip: maxSelectionReachedTooltip,
            CustomOptionLabel: CustomOptionLabel ?? (0, $d9hVL.DefaultOptionLabel)
        });
    };
    const onKeyDown = (event)=>{
        if (event.key === 'Escape') event.stopPropagation();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b9dFI.default), {
        label: (0, $4R6GH.fg)('tanuki_a11y_fixes_drop_2') ? formatMessage((0, $73s29.default).selectFilters, {
            label: label
        }) : undefined,
        "aria-label": `Select ${label} filters`,
        // testId="filters.common.ui.list.menu-list-wrapper"
        isMulti: true,
        isLoading: isLoading,
        backspaceRemovesValue: true,
        hideSelectedOptions: false,
        closeMenuOnSelect: false,
        defaultIsOpen: defaultIsOpen,
        options: optionsWithSelectedSection || options,
        value: selectedOptions,
        inputValue: inputValue,
        noOptionsMessage: getNoOptionsMessage,
        placeholder: placeholder ?? formatMessage((0, $73s29.default).placeholder),
        target: renderTrigger,
        footer: renderFooter(),
        formatOptionLabel: renderOption,
        components: {
            Option: (0, $itpgN.CheckboxOption),
            DropdownIndicator: null,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            MenuList: $51e7460acbb65361$var$MenuListWrapper
        },
        popperProps: {
            placement: isNested ? 'right-start' : 'bottom-start',
            // to render popup next to the trigger element to achieve DOM order
            strategy: 'fixed'
        },
        onChange: onChangeHandler,
        onInputChange: onInputChange,
        isOptionDisabled: isOptionDisabled,
        onMenuOpen: ()=>onOpenChangeHandler(true),
        onMenuClose: ()=>onOpenChangeHandler(false),
        onKeyDown: onKeyDown,
        ...(0, $ijTad.getSearchableProps)({
            isAsyncSearch: isAsyncSearch,
            optionsCount: values.length,
            isNested: isNested
        }),
        // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
        styles: optionsWithSelectedSection ? {
            group: (base, props)=>{
                const borderStyles = props.data.label === formatMessage((0, $73s29.default).selectedItemsGroupLabel) ? {
                    borderBottom: `1px solid ${"var(--ds-border, #091E4224)"}`
                } : {};
                return {
                    ...base,
                    ...borderStyles,
                    padding: 0
                };
            },
            groupHeading: (base, props)=>{
                if (props.data.label === formatMessage((0, $73s29.default).selectedItemsGroupLabel)) // Make the text screen reader only
                return 0, $dqoiX.visuallyHiddenStyles;
                return base;
            }
        } : undefined,
        shouldCloseMenuOnTab: shouldCloseMenuOnTab
    });
};
$51e7460acbb65361$export$fa71ab09534e6447.defaultProps = {
    isOpen: false,
    isNested: false,
    isTriggerDisabled: false,
    isLoading: false,
    isAsyncSearch: false,
    isPanelToggleChecked: false,
    showLink: false,
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    useHrefForUrl: false,
    values: [],
    selectedValues: [],
    menuGroupTitle: undefined,
    noOptionsMessage: undefined,
    maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
    url: undefined,
    linkTitle: undefined,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onOpenChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onMouseEnterToTriggerButton: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    shouldCloseMenuOnTab: true
};
var $51e7460acbb65361$export$2e2bcd8739ae039 = $51e7460acbb65361$export$fa71ab09534e6447;

});
parcelRegister("8C9C3", function(module, exports) {

$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH", () => $e9228ce7bf573a8c$export$84ae3fb9fdba8a12);
$parcel$export(module.exports, "FILTER_MENU_MIN_WIDTH_ON_NESTED", () => $e9228ce7bf573a8c$export$920d89f17cd2fe3d);
$parcel$export(module.exports, "FILTER_MENU_MAX_WIDTH", () => $e9228ce7bf573a8c$export$6ea791ab71b8fa00);
$parcel$export(module.exports, "FILTER_SEARCH_THRESHOLD", () => $e9228ce7bf573a8c$export$1d287c6a8b81eb5b);
$parcel$export(module.exports, "OPEN_CHANGE_PAYLOAD", () => $e9228ce7bf573a8c$export$2f5981b7dbafe3a4);
$parcel$export(module.exports, "OPEN_CHANGE_SUBJECT_ID", () => $e9228ce7bf573a8c$export$b94e5dc1a8a1409);
$parcel$export(module.exports, "MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD", () => $e9228ce7bf573a8c$export$1c112a3da89526d7);

var $gwIPs = parcelRequire("gwIPs");
const $e9228ce7bf573a8c$export$84ae3fb9fdba8a12 = (0, $gwIPs.gridSize) * 21;
const $e9228ce7bf573a8c$export$920d89f17cd2fe3d = (0, $gwIPs.gridSize) * 25;
const $e9228ce7bf573a8c$export$6ea791ab71b8fa00 = (0, $gwIPs.gridSize) * 48;
const $e9228ce7bf573a8c$export$1d287c6a8b81eb5b = 9;
const $e9228ce7bf573a8c$export$2f5981b7dbafe3a4 = {
    action: 'clicked',
    actionSubject: 'dropdownMenu'
};
const $e9228ce7bf573a8c$export$b94e5dc1a8a1409 = 'filterList';
const $e9228ce7bf573a8c$export$1c112a3da89526d7 = 9;

});

parcelRegister("dF38k", function(module, exports) {

$parcel$export(module.exports, "default", () => $2deb009ebf7ebceb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $8zOmE = parcelRequire("8zOmE");

var $8wifS = parcelRequire("8wifS");

var $l6YPM = parcelRequire("l6YPM");
const $2deb009ebf7ebceb$var$FilterListFooter = ({ isPanelToggleChecked: isPanelToggleChecked, showLink: showLink, showPanelToggle: showPanelToggle, useHrefForUrl: useHrefForUrl, url: url, label: label, toggleLabel: toggleLabel, linkTitle: linkTitle, toggleRef: toggleRef, onTogglePanel: onTogglePanel, onLinkItemClick: onLinkItemClick })=>{
    const onToggleHandler = (_, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent);
        onTogglePanel();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, (showPanelToggle || showLink && url && linkTitle) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$HorizontalSeparator, {
        role: "presentation",
        "data-testid": "filters.common.ui.list.footer.horizintal-separator"
    }), showPanelToggle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2deb009ebf7ebceb$var$PanelToggleContainer, {
        "data-testid": "filters.common.ui.list.footer.panel-toggle"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l6YPM.default), {
        label: toggleLabel || label,
        panelType: label,
        isChecked: isPanelToggleChecked,
        toggleRef: toggleRef,
        onToggle: onToggleHandler
    })), showLink && url && linkTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8wifS.default), {
        url: url,
        linkTitle: linkTitle,
        onClick: onLinkItemClick,
        useHref: useHrefForUrl
    }));
};
$2deb009ebf7ebceb$var$FilterListFooter.defaultProps = {
    url: undefined,
    linkTitle: undefined,
    showPanel: false,
    showLink: false,
    toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $2deb009ebf7ebceb$export$2e2bcd8739ae039 = $2deb009ebf7ebceb$var$FilterListFooter;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2deb009ebf7ebceb$var$HorizontalSeparator = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "hr", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19itglyw _19pkidpf _2hwxidpf _otyridpf _18u0idpf _4t3iv77o _bfhk15ej",
            __cmplp.className
        ])
    });
});
const $2deb009ebf7ebceb$var$PanelToggleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q12x7 _u5f3pxbi _n3td12x7 _19bvpxbi _1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("8wifS", function(module, exports) {

$parcel$export(module.exports, "default", () => $8743d62747e29a3c$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $6B7KL = parcelRequire("6B7KL");

var $8oe80 = parcelRequire("8oe80");

var $8zOmE = parcelRequire("8zOmE");

var $lVJAU = parcelRequire("lVJAU");
const $8743d62747e29a3c$var$DropdownItem = (0, $8oe80.default)('dropdownItem', {
    onClick: 'clicked'
})((0, $6B7KL.default));
const $8743d62747e29a3c$var$linkWrapperStyles = null;
const $8743d62747e29a3c$export$532cb6865ebe8946 = ({ url: url, linkTitle: linkTitle, onClick: onClick, useHref: useHref = false })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const onDropdownClick = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'clickLinkFromFilters');
        onClick && onClick();
        if (!useHref) push(url);
    }, [
        useHref,
        onClick,
        push,
        url
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        role: "menu",
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq _n3td1b66 _n3ag1osq _c7j0u2gc _1xjuutpp _16i11v6z _1b6mutpp _hjpp1osq _rbt3u2gc _nf5outpp _rayj1v6z _1uurv47k"
        ])
    }, useHref ? /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
        href: url,
        onClick: onDropdownClick
    }, linkTitle) : /* @ts-expect-error - Type '(event: SyntheticEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void' is not assignable to type '(e: MouseEvent<Element, MouseEvent> | KeyboardEvent<Element>, args_1: UIAnalyticsEvent) => any'. */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8743d62747e29a3c$var$DropdownItem, {
        onClick: onDropdownClick
    }, linkTitle));
};
var $8743d62747e29a3c$export$2e2bcd8739ae039 = $8743d62747e29a3c$export$532cb6865ebe8946;

});

parcelRegister("l6YPM", function(module, exports) {

$parcel$export(module.exports, "default", () => $4ad247e508ffc141$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $3u0c5 = parcelRequire("3u0c5");

var $dTlW6 = parcelRequire("dTlW6");

var $8oe80 = parcelRequire("8oe80");

var $ousew = parcelRequire("ousew");
var $8RXs9 = parcelRequire("8RXs9");

var $3XFdo = parcelRequire("3XFdo");

var $gCuaO = parcelRequire("gCuaO");
const $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID = 'filters.common.ui.list.panel-toggle.toggle-checkbox';
const $4ad247e508ffc141$var$TOGGLE_HINT_ID = 'filters.common.ui.list.panel-toggle.toggle-hint';
const $4ad247e508ffc141$var$PanelToggle = (props)=>{
    const { isChecked: isChecked, panelType: panelType, onToggle: onToggle, ariaLabel: ariaLabel, intl: { formatMessage: formatMessage }, toggleRef: toggleRef = null, label: label } = props;
    const panelToggleKeyboardShortcut = (0, $3XFdo.getKeyboardShortcutForPanel)(panelType);
    const toggleLabel = label || formatMessage((0, $gCuaO.default).toggleLabel, {
        panelType: panelType
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleControl, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dTlW6.default), {
        label: ariaLabel,
        id: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID,
        ref: toggleRef,
        onChange: onToggle,
        isChecked: isChecked,
        testId: "filters.common.ui.list.panel-toggle.panel-toggle",
        descriptionId: $4ad247e508ffc141$var$TOGGLE_HINT_ID
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleLabel, {
        htmlFor: $4ad247e508ffc141$var$TOGGLE_CHECKBOX_ID
    }, toggleLabel)), panelToggleKeyboardShortcut && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4ad247e508ffc141$var$PanelToggleHint, {
        id: $4ad247e508ffc141$var$TOGGLE_HINT_ID
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
        ...(0, $gCuaO.default).toggleHint,
        values: {
            kbd: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3u0c5.default), null, chunks),
            key: panelToggleKeyboardShortcut
        }
    })));
};
$4ad247e508ffc141$var$PanelToggle.defaultProps = {
    isChecked: false,
    panelType: '',
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $4ad247e508ffc141$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $8RXs9.default), (0, $5uXOq.memo), (0, $8oe80.default)('filterPanelToggle', {
    onToggle: 'toggled'
}))($4ad247e508ffc141$var$PanelToggle);
const $4ad247e508ffc141$var$PanelToggleContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c116y _4cvr1h6o _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleControl = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zkb7n _i0dl1wug _18u0v77o _1reo15vq _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $4ad247e508ffc141$var$PanelToggleHint = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "small", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _syaz131l _o5721q9c _19pkidpf _19bv12x7",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3XFdo", function(module, exports) {

$parcel$export(module.exports, "getKeyboardShortcutForPanel", () => $5bd9980697730d58$export$fa36ece4b5d88abc);

const $5bd9980697730d58$var$panelShortcuts = {
    Epic: (0, $570f28ac9bf58edd$export$9b094cdf6fd7589e),
    Version: (0, $570f28ac9bf58edd$export$6f416a1fb11a53d9)
};
const $5bd9980697730d58$export$fa36ece4b5d88abc = (panelType)=>$5bd9980697730d58$var$panelShortcuts[panelType];

});
const $570f28ac9bf58edd$export$a10c132b86ae798b = 'Epic';
const $570f28ac9bf58edd$export$41073ac826c57195 = 'Version';
const $570f28ac9bf58edd$export$9b094cdf6fd7589e = 'E';
const $570f28ac9bf58edd$export$6f416a1fb11a53d9 = 'V';


parcelRegister("gCuaO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2063ebcfe536a9b7$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2063ebcfe536a9b7$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    toggleAccessibilityLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-accessibility-label",
        "defaultMessage": "Toggle panel"
    },
    toggleLabel: {
        "id": "software-filters.common.list.panel-toggle.toggle-label",
        "defaultMessage": "{panelType} panel"
    },
    toggleHint: {
        "id": "software-filters.common.list.panel-toggle.toggle-hint",
        "defaultMessage": "Press <kbd>{key}</kbd> to open and close"
    }
});

});



parcelRegister("73s29", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a49ecd68dc207cc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6a49ecd68dc207cc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    placeholder: {
        "id": "software-filters.common.list.placeholder",
        "defaultMessage": "Search filters\u2026"
    },
    anounceMessage: {
        "id": "software-filters.common.list.anounce-message",
        "defaultMessage": "When selecting from the {field} filter, content in the backlog board will automatically update"
    },
    selectedItemsGroupLabel: {
        "id": "software-filters.common.list.selected-items-group-label",
        "defaultMessage": "Selected Items"
    },
    selectFilters: {
        "id": "software-filters.common.list.select-filter",
        "defaultMessage": "Select {label} filters"
    }
});

});

parcelRegister("d9hVL", function(module, exports) {

$parcel$export(module.exports, "DefaultOptionLabel", () => $3a4e6a305ebc1d35$export$86f820b2f37564e5);
$parcel$export(module.exports, "default", () => $3a4e6a305ebc1d35$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");
const $3a4e6a305ebc1d35$export$86f820b2f37564e5 = ({ label: label, iconUrl: iconUrl })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, iconUrl !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$Icon, {
        src: iconUrl,
        role: "presentation"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionLabel, null, label));
const $3a4e6a305ebc1d35$var$ListFilterOption = ({ label: label, subLabel: subLabel, iconUrl: iconUrl, value: value, maxSelectionReachedTooltip: maxSelectionReachedTooltip, isDisabled: isDisabled, CustomOptionLabel: CustomOptionLabel })=>{
    const content = isDisabled && maxSelectionReachedTooltip ? maxSelectionReachedTooltip : label;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: content
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionWrapper, {
        "data-testid": "filters.common.ui.list.option"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomOptionLabel, {
        label: label,
        value: value,
        iconUrl: iconUrl
    })), subLabel !== undefined && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($3a4e6a305ebc1d35$var$SelectOptionSubLabel, null, subLabel));
};
$3a4e6a305ebc1d35$var$ListFilterOption.defaultProps = {
    iconUrl: undefined,
    isDisabled: false
};
var $3a4e6a305ebc1d35$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($3a4e6a305ebc1d35$var$ListFilterOption);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $3a4e6a305ebc1d35$var$SelectOptionWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _1bah1y6m",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$SelectOptionLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$SelectOptionSubLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c81o8v _1bto1l2s _o5721q9c _syaz131l",
            __cmplp.className
        ])
    });
});
const $3a4e6a305ebc1d35$var$Icon = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "img", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _1bsb7vkz _4t3i7vkz _u5f3u2gc",
            __cmplp.className
        ])
    });
});

});

parcelRegister("4Mv0u", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd436e148f99ab3e$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $16T6Y = parcelRequire("16T6Y");

var $fVnbM = parcelRequire("fVnbM");

var $6Ingq = parcelRequire("6Ingq");

var $ebd3R = parcelRequire("ebd3R");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $22OQR = parcelRequire("22OQR");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $7mPT9 = parcelRequire("7mPT9");

var $iXVV6 = parcelRequire("iXVV6");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");
const $bd436e148f99ab3e$var$badgeStyles = {
    root: "_2rkoglpi _11c81o8v _18zr1b66 _bfhk1vcy _syaz1p4p _1ul91tcg _y3gn1h6o _1e0c116y _1bah1h6o _1kz6184x",
    textWrapper: "_1reo15vq _18m915vq _p12f68cl _o5721q9c _1bto1l2s",
    trigger: "_ca0q12x7 _n3td12x7",
    triggerWithCount: "_1e0c1txw _4cvr1h6o"
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $bd436e148f99ab3e$var$FilterListTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ isOpen: isOpen, isNested: isNested, isDisabled: isDisabled, removeOuterPadding: removeOuterPadding, label: label, buttonType: buttonType, selectedCount: selectedCount, onMouseEnter: onMouseEnter, shouldReturnFocus: shouldReturnFocus, ...popupProps }, ref)=>{
    const { isSoftwareFullTheming: isThemed } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const testId = `filters.common.ui.list.${label.toLowerCase().replace(/ /g, '-')}-filter`;
    const primaryColor = !isOpen ? "var(--ds-icon-subtle, #626F86)" : undefined;
    const primaryColorOld = isOpen ? "var(--ds-icon-selected, #0C66E4)" : "var(--ds-icon, #44546F)";
    const isIconDisabled = isDisabled && (0, $4R6GH.fg)('tnk_disable_custom_filter_when_there_are_5k_issues');
    const IconComponent = isNested ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($ebd3R))),
        LEGACY_primaryColor: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColorOld,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? {
            color: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColor
        } : !isThemed && {
            color: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColorOld
        }
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
        label: "",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
        LEGACY_primaryColor: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColorOld,
        ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? {
            color: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColor
        } : !isThemed && {
            color: isIconDisabled ? "var(--ds-icon-disabled, #091E424F)" : primaryColorOld
        }
    });
    const inputRef = (0, $5uXOq.useRef)();
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (shouldReturnFocus && buttonType === 'QuickFilters' && isMounted.current) inputRef?.current?.focus();
        else isMounted.current = true;
    }, [
        shouldReturnFocus,
        buttonType
    ]);
    const conditionalRef = buttonType === 'QuickFilters' ? (0, $7mPT9.mergeRefs)(ref, inputRef) : ref;
    // eslint-disable-next-line no-nested-ternary
    const ButtonComponent = isThemed ? (0, $22OQR.ThemedButton) : (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $fVnbM.default) : $bd436e148f99ab3e$var$StyledButton;
    const countContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selectedCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$CountWrapper, {
        isNested: isNested,
        "data-testid": `${testId}-badge`
    }, isThemed ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bd436e148f99ab3e$var$badgeStyles.root
    }, selectedCount, " ") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
        appearance: "primary"
    }, selectedCount)));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            !isNested && !removeOuterPadding && $bd436e148f99ab3e$var$horizontalPaddingStyles
        ]
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "dropDownMenu",
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        attributes: {
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        ...popupProps,
        ref: conditionalRef,
        isSelected: isOpen || (0, $dCm1o.isVisualRefreshEnabled)() && selectedCount > 0,
        shouldFitContainer: isNested,
        appearance: (0, $dCm1o.isVisualRefreshEnabled)() && !isNested ? 'default' : 'subtle',
        onMouseEnter: onMouseEnter,
        iconAfter: (0, $dCm1o.isVisualRefreshEnabled)() && selectedCount > 0 ? undefined : IconComponent,
        isDisabled: isDisabled || false,
        ...isThemed && isNested && (0, $lmBAt.getIsSoftwareThemingEnabled)() && {
            css: {
                borderRadius: '0 !important',
                paddingRight: `${"var(--ds-space-050, 4px)"} !important`,
                '&:focus': {
                    outlineOffset: '-2px'
                }
            }
        },
        isNested: isNested
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: label,
        hideTooltipOnClick: true,
        tag: "span"
    }, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: selectedCount > 0 ? $bd436e148f99ab3e$var$badgeStyles.triggerWithCount : $bd436e148f99ab3e$var$badgeStyles.trigger,
        testId: testId,
        as: "span"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $bd436e148f99ab3e$var$badgeStyles.textWrapper
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        ...isOpen || selectedCount > 0 ? {
            color: 'inherit'
        } : {
            color: 'color.text.subtle'
        },
        weight: "medium"
    }, label)), countContent) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerContainer, {
        "data-testid": testId
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bd436e148f99ab3e$var$TriggerLabel, null, label), countContent)))));
});
var $bd436e148f99ab3e$export$2e2bcd8739ae039 = $bd436e148f99ab3e$var$FilterListTrigger;
const $bd436e148f99ab3e$var$horizontalPaddingStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-dynamic-styles -- Ignored via go/DSP-18766
const $bd436e148f99ab3e$var$StyledButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $fVnbM.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "",
            __cmplp.isNested && "_2rkogrf3 _u5f3ns44 _1bg412gs",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$CountWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isNested: isNested, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l",
            __cmplp.isNested ? "_18u01wug _19bvftgi" : "_19bv1y44",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
});
const $bd436e148f99ab3e$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _p12f68cl _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});

parcelRegister("ijTad", function(module, exports) {

$parcel$export(module.exports, "getOptionsFromProps", () => $a5603fd49981b3bf$export$ecd68164c475a713);
$parcel$export(module.exports, "getSelectedOptionsFromProps", () => $a5603fd49981b3bf$export$94d5b7a6f69b418);
$parcel$export(module.exports, "getSearchableProps", () => $a5603fd49981b3bf$export$62d9d395b3dd2ae8);
$parcel$export(module.exports, "useGetOptionsWithSelectedOptionGroup", () => $a5603fd49981b3bf$export$2729924204b6e540);

var $5uXOq = parcelRequire("5uXOq");

var $5JAlL = parcelRequire("5JAlL");

var $koVbs = parcelRequire("koVbs");

var $8C9C3 = parcelRequire("8C9C3");

var $73s29 = parcelRequire("73s29");
const $a5603fd49981b3bf$var$isValueGroupOption = (value)=>'options' in value;
const $a5603fd49981b3bf$export$67e7296d7bc3550c = (values)=>values.every((value)=>!$a5603fd49981b3bf$var$isValueGroupOption(value));
const $a5603fd49981b3bf$export$ecd68164c475a713 = ({ values: values, menuGroupTitle: menuGroupTitle })=>{
    // menuGroupTitle should be deprecated
    if (menuGroupTitle && $a5603fd49981b3bf$export$67e7296d7bc3550c(values)) return [
        {
            label: menuGroupTitle,
            options: values
        }
    ];
    return values;
};
const $a5603fd49981b3bf$export$94d5b7a6f69b418 = ({ values: values, selectedValueIds: selectedValueIds })=>{
    const selectedIdLookup = selectedValueIds.reduce((acc, cur)=>{
        acc.add(cur);
        return acc;
    }, new Set());
    const valuesToLook = values.flatMap((value)=>$a5603fd49981b3bf$var$isValueGroupOption(value) ? value.options : [
            value
        ]);
    const selectedOptions = valuesToLook.filter(({ value: value })=>selectedIdLookup.has(value));
    return {
        selectedIdLookup: selectedIdLookup,
        selectedOptions: selectedOptions
    };
};
const $a5603fd49981b3bf$export$62d9d395b3dd2ae8 = ({ optionsCount: optionsCount, isAsyncSearch: isAsyncSearch, defaultSearchThreshold: defaultSearchThreshold = (0, $8C9C3.FILTER_SEARCH_THRESHOLD), isNested: isNested })=>{
    // Search input should always be visible for async selects
    const searchThreshold = isAsyncSearch ? -1 : defaultSearchThreshold;
    const isSearchable = optionsCount > searchThreshold;
    // Due to renderToParent the grid size will change so, incresing the min width for low resolutions
    const filterMenuMinWidth = isNested ? (0, $8C9C3.FILTER_MENU_MIN_WIDTH_ON_NESTED) : (0, $8C9C3.FILTER_MENU_MIN_WIDTH);
    const maxMenuWidth = (0, $8C9C3.FILTER_MENU_MAX_WIDTH);
    // Set the min and max width to be the same so updated search results don't cause the menu to resize
    const minMenuWidth = isSearchable ? maxMenuWidth : filterMenuMinWidth;
    // Don't filter anything on the frontend for async selects
    const filter = (0, $5JAlL.createFilter)({
        stringify: (option)=>option.label
    });
    const filterOption = isAsyncSearch ? undefined : filter;
    return {
        minMenuWidth: minMenuWidth,
        maxMenuWidth: maxMenuWidth,
        searchThreshold: searchThreshold,
        filterOption: filterOption
    };
};
const $a5603fd49981b3bf$export$2729924204b6e540 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [optionsWithSelectedSection, setOptionsWithSelectedSection] = (0, $5uXOq.useState)(null);
    const shouldTrackExperimentEvents = (0, $5uXOq.useRef)(false);
    const updateSelectedOptionGroup = ({ isOpen: isOpen, options: options, selectedValueIds: selectedValueIds })=>{
        if (// To avoid annoyingly shifting items around while the user has the dropdown open, when only shuffle items on an opening
        isOpen === true && // At least for now, scope this change so we only have a selected items section if the options don't have any existing groupings
        $a5603fd49981b3bf$export$67e7296d7bc3550c(options) && (options.length > (0, $8C9C3.MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD) || optionsWithSelectedSection !== null)) {
            if (selectedValueIds.length === 0 || options.length <= (0, $8C9C3.MAKE_IT_EASIER_TO_DESELECT_FILTER_ITEMS_THRESHOLD)) {
                setOptionsWithSelectedSection(null);
                shouldTrackExperimentEvents.current = false;
            } else {
                // reorder selected parents to be at the top
                const selected = options.filter((option)=>selectedValueIds.includes(option.value));
                const unselected = options.filter((option)=>!selectedValueIds.includes(option.value));
                const optionsWithSelectedOptionGroup = [
                    {
                        label: formatMessage((0, $73s29.default).selectedItemsGroupLabel),
                        options: selected
                    },
                    {
                        label: '',
                        options: unselected
                    }
                ];
                setOptionsWithSelectedSection(optionsWithSelectedOptionGroup);
                shouldTrackExperimentEvents.current = true;
            }
        }
    };
    return {
        optionsWithSelectedSection: optionsWithSelectedSection,
        updateSelectedOptionGroup: updateSelectedOptionGroup,
        shouldTrackExperimentEvents: shouldTrackExperimentEvents
    };
};

});


parcelRegister("78uGw", function(module, exports) {

$parcel$export(module.exports, "default", () => $cad440f119fd51b3$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cad440f119fd51b3$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.custom.label",
        "defaultMessage": "Custom filters"
    },
    placeholder: {
        "id": "software-filters.filters.custom.placeholder",
        "defaultMessage": "Search custom filters..."
    },
    labelCmp: {
        "id": "software-filters.filters.custom.label-cmp",
        "defaultMessage": "Quick filters"
    },
    placeholderCmp: {
        "id": "software-filters.filters.custom.placeholder-cmp",
        "defaultMessage": "Search quick filters..."
    },
    manageLinkTitle: {
        "id": "software-filters.filters.custom.manage-link-title",
        "defaultMessage": "Manage custom filters"
    },
    manageLinkTitleCmp: {
        "id": "software-filters.filters.custom.manage-link-title-cmp",
        "defaultMessage": "Manage quick filters"
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.custom.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed} custom filters"
    },
    toggleLabelCmp: {
        "id": "software-filters.filters.custom.toggle-label-cmp",
        "defaultMessage": "Show quick filters"
    }
});

});



parcelRegister("3oCwY", function(module, exports) {

$parcel$export(module.exports, "default", () => $195137f112bf0000$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $22OQR = parcelRequire("22OQR");

var $a2e2Q = parcelRequire("a2e2Q");

var $aVUro = parcelRequire("aVUro");
const $195137f112bf0000$var$ClearFilterButton = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSoftwareFullTheming: isThemed } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const ButtonComponent = isThemed ? (0, $22OQR.ThemedButton) : (0, $fVnbM.default);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: [
            !(0, $dCm1o.isVisualRefreshEnabled)() && $195137f112bf0000$var$styledClearFilterStyles
        ],
        "data-test-id": "filters.ui.filters.clear-button.ak-button",
        testId: "filters.ui.filters.clear-button.ak-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
        appearance: "subtle",
        onClick: props.onClick
    }, props.label || formatMessage((0, $aVUro.default).label)));
};
$195137f112bf0000$var$ClearFilterButton.defaultProps = {
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $195137f112bf0000$export$2e2bcd8739ae039 = $195137f112bf0000$var$ClearFilterButton;
const $195137f112bf0000$var$styledClearFilterStyles = (0, $8CUq3.xcss)({
    paddingLeft: 'space.050',
    paddingRight: 'space.050'
});

});
parcelRegister("aVUro", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfdad8f510b5e904$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfdad8f510b5e904$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.clear-button.label",
        "defaultMessage": "Clear filters"
    }
});

});


parcelRegister("jWrFu", function(module, exports) {

$parcel$export(module.exports, "default", () => $8496d7266285a778$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8496d7266285a778$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterRefinementSearchFieldPlaceholder: {
        "id": "software.main.header.controls-bar.filter-refinement.search-field.placeholder",
        "defaultMessage": "Search board"
    }
});

});


parcelRegister("ikdur", function(module, exports) {

$parcel$export(module.exports, "default", () => $51c4d7313dd1a25f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $7wqBZ = parcelRequire("7wqBZ");

var $6s1PB = parcelRequire("6s1PB");

var $2gCtH = parcelRequire("2gCtH");

var $bC2fB = parcelRequire("bC2fB");

var $dCm1o = parcelRequire("dCm1o");




var $d1i1b = parcelRequire("d1i1b");

var $cY26q = parcelRequire("cY26q");

var $dnW4F = parcelRequire("dnW4F");

var $Nogwi = parcelRequire("Nogwi");

var $1vXOx = parcelRequire("1vXOx");

var $bSSdD = parcelRequire("bSSdD");

var $fqLDH = parcelRequire("fqLDH");

var $d2i8f = parcelRequire("d2i8f");

var $6aPPq = parcelRequire("6aPPq");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $fFtOA = parcelRequire("fFtOA");

var $flbsC = parcelRequire("flbsC");
const $51c4d7313dd1a25f$var$isTMPBoardAddPeopleExperimentEnabled = (state)=>{
    const canInviteOthersToProject = (0, $67Z81.getCanInviteOthersToProject)(state);
    return canInviteOthersToProject && (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment');
};
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $51c4d7313dd1a25f$var$EMPTY_LIST = [];
const $51c4d7313dd1a25f$export$c31df4bd766f9c35 = (state, ownProps)=>({
        customFiltersQueryRef: ownProps.customFiltersQueryRef,
        isActiveStandup: ownProps.isActiveStandup,
        assignees: (0, $67Z81.getIsCMPBoard)(state) ? (0, $5mTgl.orderedWorkAssigneesAlphabeticallySelector)(state) : (0, $5mTgl.orderedWorkAssigneesByAccountIdSelector)(state),
        filter: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $5mTgl.getWorkFilters)(state), [
            'values'
        ]),
        issueParentsLabel: (0, $67Z81.getHierarchyNomenclature)(state) ? (0, $67Z81.getHierarchyNomenclature)(state)?.firstLevelName : (0, $bSSdD.firstParentIssueTypeNameSelector)(state),
        issueParents: (0, $bSSdD.filteredIssueParentsToListItemSelector)(state),
        isAnyModalOpen: (0, $6aPPq.isAnyModalOpenSelector)(state),
        isIssueModalShowing: (0, $fqLDH.isIssueModalShowingSelector)(state),
        labels: (0, $d2i8f.issueLabelsSelector)(state),
        issueTypes: (0, $d2i8f.sortedIssueTypeSelector)(state),
        issueTypeGroups: (0, $67Z81.getIsIncrementPlanningBoard)(state) ? (0, $d2i8f.issueTypeGroupSelector)(state) : $51c4d7313dd1a25f$var$EMPTY_LIST,
        isGroupIssueTypesEnabled: (0, $67Z81.getIsIncrementPlanningBoard)(state),
        issueProjects: (0, $67Z81.getIssueProjects)(state),
        maxAvatars: (0, $7e733a5d4e4331fc$export$360e7ca29749d455),
        isAddPeopleButtonEnabled: (0, $67Z81.getIsCMPBoard)(state) ? (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && !(0, $dCm1o.isVisualRefreshEnabled)() : ((0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || $51c4d7313dd1a25f$var$isTMPBoardAddPeopleExperimentEnabled(state)) && !(0, $dCm1o.isVisualRefreshEnabled)(),
        isCustomFilterManageLinkEnabled: (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && !(0, $67Z81.getIsCMPBoard)(state),
        isVersionFilterSpotlightEnabled: (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && !(0, $67Z81.getIsCMPBoard)(state),
        AddPeopleModal: $fFtOA.default,
        externalId: 'software.board',
        projectId: (0, $67Z81.projectIdSelector)(state),
        projectName: (0, $67Z81.projectNameSelector)(state),
        projectKey: (0, $67Z81.projectKeySelector)(state),
        boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
        isCustomFiltersLoading: (0, $5mTgl.isFilteredCardsLoading)(state),
        sprints: (0, $ebHh7.getSprintsSelector)(state)
    });
const $51c4d7313dd1a25f$var$getOnChange = (0, $8QpSo.default)((dispatch)=>(filters, filterType, _, analyticsEvent)=>{
        if (filterType !== (0, $dcff40112356dfc1$export$68d693c35a8d8866)) (0, $7wqBZ.getLongTasksMetrics)('filter').start('board');
        if (filterType === (0, $dcff40112356dfc1$export$a316570a0dbfd2b0)) {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const sprintFilterIds = filters[0, $dcff40112356dfc1$export$a316570a0dbfd2b0];
            dispatch((0, $Nogwi.selectSprint)({
                sprintFilterIds: sprintFilterIds
            }));
        }
        return dispatch((0, $dnW4F.setAllFilters)(filters, filterType, analyticsEvent));
    });
const $51c4d7313dd1a25f$var$mapDispatchToProps = (dispatch)=>({
        onSearchFieldFocus: (...args)=>dispatch((0, $dnW4F.searchFieldFocus)(...args)),
        onExtraAvatarMenuOpen: (...args)=>dispatch((0, $dnW4F.extraAvatarMenuOpen)(...args)),
        onFilterPanelMounted: (...args)=>dispatch((0, $dnW4F.filterPanelMounted)(...args)),
        onChange: $51c4d7313dd1a25f$var$getOnChange(dispatch),
        onClearAllButtonClicked: ()=>{
            dispatch((0, $dnW4F.clearAllFiltersClicked)()); // used just for the analytics event, has no reducer
            dispatch((0, $cY26q.clearFilteredCards)());
            dispatch((0, $d1i1b.cardAutoScrollRequestOnFilter)());
        }
    });
const $51c4d7313dd1a25f$var$withAnyModalOpen = (WrappedComponent)=>(props)=>{
        const viewMode = (0, $2gCtH.useViewMode)();
        const isDetailViewModal = viewMode === 'MODAL';
        const { isAnyModalOpen: isAnyModalOpen, isIssueModalShowing: isIssueModalShowing, ...restProps } = props;
        const isIssueDetailViewModalOpen = isIssueModalShowing && isDetailViewModal;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...restProps,
            isAnyModalOpen: isIssueDetailViewModalOpen || isAnyModalOpen
        });
    };
var // @ts-expect-error - TS2345 - Property 'values' is missing in type 'Filters' but required in type 'FilterState'.
$51c4d7313dd1a25f$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($51c4d7313dd1a25f$export$c31df4bd766f9c35, $51c4d7313dd1a25f$var$mapDispatchToProps)($51c4d7313dd1a25f$var$withAnyModalOpen((0, $flbsC.default)));

});
parcelRegister("6aPPq", function(module, exports) {

$parcel$export(module.exports, "isAnyModalOpenSelector", () => $e3e52dc8e9842893$export$f3a16e4558c34e30);

var $dGvGJ = parcelRequire("dGvGJ");

var $fruR3 = parcelRequire("fruR3");

var $absT5 = parcelRequire("absT5");

var $fyeGd = parcelRequire("fyeGd");

var $eDggU = parcelRequire("eDggU");

var $9w3Ae = parcelRequire("9w3Ae");

var $iejYF = parcelRequire("iejYF");

var $fqLDH = parcelRequire("fqLDH");

var $5mTgl = parcelRequire("5mTgl");
const $e3e52dc8e9842893$export$f3a16e4558c34e30 = (0, $dGvGJ.createSelector)([
    (0, $fqLDH.isIssueModalShowingSelector),
    (0, $fruR3.isDialogVisibleSelector),
    (0, $absT5.isDialogVisibleSelector),
    (0, $5mTgl.getColumnDeleteModalIsOpen),
    (0, $5mTgl.isIssueDeleteModalOpen),
    (0, $9w3Ae.isAddLabelModalOpen),
    (0, $eDggU.isAssignIssueParentModalOpen),
    (0, $fyeGd.getUiColumnLimitsModalOpen),
    (0, $iejYF.isIssueFlagWithCommentModalOpen)
], (issueModalShowing, backlogIssueMoveDialogOpen, backlogEnableDialogOpen, columnDeleteModalIsOpen, issueDeleteModalOpen, addLabelModalOpen, assignIssueParentModalOpen, uiColumnLimitsModalOpen, issueFlagWithCommentModalOpen)=>backlogIssueMoveDialogOpen || backlogEnableDialogOpen || columnDeleteModalIsOpen || issueDeleteModalOpen || addLabelModalOpen || assignIssueParentModalOpen || uiColumnLimitsModalOpen || issueFlagWithCommentModalOpen);

});
parcelRegister("9w3Ae", function(module, exports) {

$parcel$export(module.exports, "isAddLabelModalOpen", () => $6f58d943d2694d80$export$b19f40379d7cd607);
$parcel$export(module.exports, "getIssuesForAddLabelModal", () => $6f58d943d2694d80$export$de028143a378279f);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $67Z81 = parcelRequire("67Z81");

var $vAfHD = parcelRequire("vAfHD");
const $6f58d943d2694d80$var$getUiAddLabelModal = (state)=>(0, $67Z81.getUi)(state).issueAddLabelModal;
const $6f58d943d2694d80$export$b19f40379d7cd607 = (state)=>Boolean($6f58d943d2694d80$var$getUiAddLabelModal(state)?.isOpen);
// @ts-expect-error - TS2339 - Property 'issueIds' does not exist on type 'AddLabelModalState'.
const $6f58d943d2694d80$var$getSelectedIssueIds = (state)=>$6f58d943d2694d80$var$getUiAddLabelModal(state).issueIds;
const $6f58d943d2694d80$var$noSelectedIssues = (0, $7uUwQ.freeze)([]);
const $6f58d943d2694d80$export$de028143a378279f = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    $6f58d943d2694d80$var$getSelectedIssueIds
], (allIssues, issueIds)=>{
    if (issueIds) return issueIds.map((id)=>({
            // Cast issueId here as number for now, until we need the add label feature in ARJ Increment planning board
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            id: allIssues[id].id,
            key: allIssues[id].key
        }));
    return $6f58d943d2694d80$var$noSelectedIssues;
});

});

parcelRegister("iejYF", function(module, exports) {

$parcel$export(module.exports, "isIssueFlagWithCommentModalOpen", () => $2ee44c2c343afad4$export$8dc99e4636e5b7d8);
$parcel$export(module.exports, "getFlagForFlagWithCommentModal", () => $2ee44c2c343afad4$export$13067e0b8f26b41d);
$parcel$export(module.exports, "getIssuesForFlagWithCommentModal", () => $2ee44c2c343afad4$export$ca31613ec956e54a);

var $7uUwQ = parcelRequire("7uUwQ");

var $dGvGJ = parcelRequire("dGvGJ");

var $a4GLz = parcelRequire("a4GLz");

var $9OPlz = parcelRequire("9OPlz");

var $67Z81 = parcelRequire("67Z81");

var $vAfHD = parcelRequire("vAfHD");

var $d2i8f = parcelRequire("d2i8f");
const $2ee44c2c343afad4$var$getUiFlagWithCommentModal = (state)=>(0, $67Z81.getUi)(state).issueFlagWithCommentModal;
const $2ee44c2c343afad4$export$8dc99e4636e5b7d8 = (state)=>Boolean($2ee44c2c343afad4$var$getUiFlagWithCommentModal(state)?.isOpen);
const $2ee44c2c343afad4$var$getIssueId = (state)=>$2ee44c2c343afad4$var$getUiFlagWithCommentModal(state)?.issueId;
const $2ee44c2c343afad4$var$getSelectedIssueIds = (state)=>{
    const issueId = $2ee44c2c343afad4$var$getIssueId(state);
    if (issueId) return (0, $9OPlz.isCardSelected)(state)(issueId) ? (0, $9OPlz.getCardSelection)(state) : [
        issueId
    ];
    return undefined;
};
const $2ee44c2c343afad4$export$13067e0b8f26b41d = (state)=>{
    const issueId = $2ee44c2c343afad4$var$getIssueId(state);
    if (issueId) return (0, $d2i8f.isIssueFlagged)(state, issueId) ? (0, $a4GLz.REMOVE) : (0, $a4GLz.ADD);
    return 0, $a4GLz.ADD;
};
const $2ee44c2c343afad4$var$noSelectedIssues = (0, $7uUwQ.freeze)([]);
const $2ee44c2c343afad4$export$ca31613ec956e54a = (0, $dGvGJ.createSelector)([
    (0, $vAfHD.boardIssuesSelector),
    $2ee44c2c343afad4$var$getSelectedIssueIds
], (allIssues, issueIds)=>{
    if (issueIds) return issueIds.map((id)=>({
            id: allIssues[id].id,
            key: allIssues[id].key,
            summary: allIssues[id].summary,
            type: {
                id: String(allIssues[id].typeId),
                name: allIssues[id].typeName ?? '',
                iconUrl: allIssues[id].typeUrl ?? ''
            }
        }));
    return $2ee44c2c343afad4$var$noSelectedIssues;
});

});
parcelRegister("a4GLz", function(module, exports) {

$parcel$export(module.exports, "ADD", () => $65b7e6dbe70f8139$export$bb6389024b71c2ae);
$parcel$export(module.exports, "REMOVE", () => $65b7e6dbe70f8139$export$29d55e1f664a246b);
$parcel$export(module.exports, "FLAG_REMOVED_PREFIX", () => $65b7e6dbe70f8139$export$43b00f69c32e9a5);
$parcel$export(module.exports, "FLAG_ADDED_PREFIX", () => $65b7e6dbe70f8139$export$625f394c78645dcd);
const $65b7e6dbe70f8139$export$bb6389024b71c2ae = 'ADD';
const $65b7e6dbe70f8139$export$29d55e1f664a246b = 'REMOVE';
const $65b7e6dbe70f8139$export$43b00f69c32e9a5 = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_off:',
                        id: 'atlassian-flag_off',
                        text: ':flag_off:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag removed '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};
const $65b7e6dbe70f8139$export$625f394c78645dcd = {
    content: [
        {
            type: 'paragraph',
            content: [
                {
                    type: 'emoji',
                    attrs: {
                        shortName: ':flag_on:',
                        id: 'atlassian-flag_on',
                        text: ':flag_on:'
                    }
                },
                {
                    type: 'text',
                    text: ' Flag added '
                }
            ]
        }
    ],
    type: 'doc',
    version: 1
};

});



parcelRegister("fFtOA", function(module, exports) {

$parcel$export(module.exports, "default", () => $cae350cfbd888e25$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $2uACv = parcelRequire("2uACv");
var $cae350cfbd888e25$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state, ownProps)=>({
        projectId: (0, $67Z81.projectIdSelector)(state),
        projectKey: (0, $67Z81.projectKeySelector)(state),
        baseUrl: (0, $67Z81.contextPathSelector)(state),
        locale: (0, $67Z81.getLocale)(state),
        isOpen: ownProps.isOpen,
        onClose: ownProps.onClose || (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        allowFlags: true,
        onAddSuccess: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onError: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }), ()=>({}))((0, $2uACv.default));

});
parcelRegister("2uACv", function(module, exports) {

$parcel$export(module.exports, "default", () => $23ef1a5b1befb75a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fjJ1B = parcelRequire("fjJ1B");

var $kxZPA = parcelRequire("kxZPA");
var $6Lg6A = parcelRequire("6Lg6A");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $23ef1a5b1befb75a$var$AddPeopleModal = (0, $kxZPA.lazy)(()=>(parcelRequire("4XHmI")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$23ef1a5b1befb75a$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjJ1B.AddPeopleModalBoundary), {
        packageName: "software-board"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6Lg6A.LazyWait), {
        until: props.isOpen
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23ef1a5b1befb75a$var$AddPeopleModal, {
        ...props,
        analyticsPrefix: "software.board",
        isAdmin: true,
        projectType: "software"
    })));

});
parcelRegister("fjJ1B", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d4cefe384a250f$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AddPeopleModalBoundary", () => $05d4cefe384a250f$export$374b95de0cd72a02);

var $5uXOq = parcelRequire("5uXOq");

var $gAeCk = parcelRequire("gAeCk");

var $7CMCs = parcelRequire("7CMCs");

var $gjEtj = parcelRequire("gjEtj");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


const $05d4cefe384a250f$var$LazyComponent = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4XHmI")), {
    moduleId: "./src/packages/permissions-administration/components/project-add-people/src/index.tsx"
});
const $05d4cefe384a250f$export$c4cbbeec160c9988 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-project-add-people-dialog",
        packageName: "project-add-people"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "project-add-people-dialog",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gAeCk.default), {
            metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce)
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($05d4cefe384a250f$var$LazyComponent, props)));
var $05d4cefe384a250f$export$2e2bcd8739ae039 = $05d4cefe384a250f$export$c4cbbeec160c9988;
const $05d4cefe384a250f$export$374b95de0cd72a02 = ({ children: children, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        id: "add-people-modal",
        metricKey: (0, $f7307e9423a0bb88$export$b68a44ad9e8d6ce),
        ...props
    }, children);

});
const $f7307e9423a0bb88$export$b68a44ad9e8d6ce = 'ADD_PEOPLE_LOAD_START_MARK_KEY';
const $f7307e9423a0bb88$export$656613627a47a509 = 'ADD_PEOPLE_LOAD_END_MARK_KEY';
const $f7307e9423a0bb88$export$61762786d0849c64 = 'ADD_PEOPLE_READY_MARK_KEY';

parcelRegister("4XHmI", function(module, exports) {

let $39ce4f92c98d2430$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $39ce4f92c98d2430$var$load("kNFvF"),
    $39ce4f92c98d2430$var$load("ffQaD"),
    $39ce4f92c98d2430$var$load("kvRbA"),
    $39ce4f92c98d2430$var$load("76n7a"),
    $39ce4f92c98d2430$var$load("l253H"),
    $39ce4f92c98d2430$var$load("jJdCl")
]).then(()=>parcelRequire('jd2mv'));

});




parcelRegister("flbsC", function(module, exports) {

$parcel$export(module.exports, "default", () => $c8c1ccd5d67d8850$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");


var $aD4Nm = parcelRequire("aD4Nm");

var $2i4sA = parcelRequire("2i4sA");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $efvDm = parcelRequire("efvDm");

var $8KmrC = parcelRequire("8KmrC");

var $9OXo1 = parcelRequire("9OXo1");

var $dCm1o = parcelRequire("dCm1o");

var $4R6GH = parcelRequire("4R6GH");

var $2xFXk = parcelRequire("2xFXk");

var $gNaDq = parcelRequire("gNaDq");

var $aGYrC = parcelRequire("aGYrC");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $d2i8f = parcelRequire("d2i8f");

var $67Z81 = parcelRequire("67Z81");

var $63LqY = parcelRequire("63LqY");

var $3Vjgs = parcelRequire("3Vjgs");

var $b9W8W = parcelRequire("b9W8W");


var $brhcU = parcelRequire("brhcU");
const $c8c1ccd5d67d8850$var$defaultProps = {
    versions: []
};
const $c8c1ccd5d67d8850$var$FilterBarWrapper = ({ customFiltersQueryRef: customFiltersQueryRef, isActiveStandup: isActiveStandup, ...props })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const isJSMBoard = (0, $63LqY.useIsJSMBoard)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isVersionsFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_VERSIONS_FILTER);
    const isComponentsFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_COMPONENTS_FILTER);
    const isStatusCategoriesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_STATUS_CATEGORIES_FILTER);
    const isIssueParentsFeatureEnabled = isIncrementPlanningBoard ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ISSUE_PARENTS_FILTER) : undefined;
    const isLabelsFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_LABELS_FILTER);
    const isIssueProjectsFeatureEnabled = isIncrementPlanningBoard ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ISSUE_PROJECTS_FILTER) : undefined;
    const isDependenciesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_DEPENDENCIES_FILTER);
    const isIssueTypesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_ISSUE_TYPES_FILTER);
    const isSprintsFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_SPRINTS_FILTER);
    const isRequestTypesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_REQUEST_TYPES_FILTER);
    const isStatusesFeatureEnabled = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_STATUSES_FILTER);
    const projectType = (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector));
    const requestTypes = (0, $67sX6.useBoardSelector)((0, $d2i8f.requestTypesSelector));
    const statuses = (0, $67sX6.useBoardSelector)((0, $d2i8f.statusesSelector));
    const isBoardSwitcherReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    const { shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge } = (0, $4R6GH.fg)('unassigned_filter_kill_switch') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $3Vjgs.useShouldShowUnassignedFilter)() : {
        shouldShowUnassignedFilterNudge: false
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2i4sA.ViewExperienceTrackingProvider), {
        experience: (0, $70866c33bb205617$export$d339888a30f06bf4),
        application: (0, $efvDm.getApplicationForProject)(projectType),
        edition: tenantContext.appEditions.software,
        analyticsSource: (0, $fcf97b7a09088940$export$cd16d39c55c569d0),
        experienceId: (0, $70866c33bb205617$export$b110169935468339),
        additionalAttributes: {
            isClassic: isCMPBoard,
            isUIF: true
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aD4Nm.ExperienceTracker), {
        location: (0, $70866c33bb205617$export$dc37b1e8e15e9923)
    }, ({ onExperienceSuccess: onExperienceSuccess })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8KmrC.default), {
            ...$c8c1ccd5d67d8850$var$defaultProps,
            ...props,
            screenName: "board",
            isCompanyManaged: isCMPBoard,
            isJSMBoard: isJSMBoard,
            showSearchFilterChangeboarding: !isCMPBoard,
            hijackBrowserDefaultSearch: !isCMPBoard,
            onChangeInteractionFeedback: (0, $aGYrC.setInteractionFeedbackMark),
            onChangeInteractionStart: (0, $aGYrC.setInteractionStartMark),
            onCustomFilterChangeInteractionFeedback: (0, $gNaDq.setCustomFilterInteractionFeedbackMark),
            onCustomFilterChangeInteractionStart: (0, $gNaDq.setCustomFilterInteractionStartMark),
            customFiltersQueryRef: customFiltersQueryRef,
            // @ts-expect-error - TS2345 - Type 'CustomFiltersQueryRef | undefined' is not assignable to type 'PreloadedQuery<viewBoardCustomFiltersQuery, Record<string, unknown>>'.
            CustomFilter: (0, $b9W8W.BoardCustomFilter),
            showAssigneeFilter: !isIncrementPlanningBoard && !isActiveStandup,
            showBoardSwitcher: isIncrementPlanningBoard,
            isBoardSwitcherReadOnly: isBoardSwitcherReadOnly,
            showCustomFilters: isCMPBoard,
            onExperienceSuccess: onExperienceSuccess,
            placeholder: (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $brhcU.default).filterPlaceholder) : formatMessage((0, $brhcU.default).textFilter),
            screenReaderInstruction: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $brhcU.default).screenReaderInstructionIssueTermRefresh : (0, $brhcU.default).screenReaderInstruction),
            statuses: statuses,
            requestTypes: requestTypes,
            isUnassignedAssigneeOptionEnabled: true,
            isVersionsFeatureEnabled: isVersionsFeatureEnabled,
            isComponentsFeatureEnabled: isComponentsFeatureEnabled,
            isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled,
            isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled,
            isLabelsFeatureEnabled: isLabelsFeatureEnabled,
            isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled,
            isDependenciesFeatureEnabled: isDependenciesFeatureEnabled,
            isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled,
            isSprintsFeatureEnabled: isSprintsFeatureEnabled,
            isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled,
            isStatusesFeatureEnabled: isStatusesFeatureEnabled,
            shouldShowUnassignedFilterNudge: !props.isAnyModalOpen && shouldShowUnassignedFilterNudge
        }))));
};
var $c8c1ccd5d67d8850$export$2e2bcd8739ae039 = $c8c1ccd5d67d8850$var$FilterBarWrapper;

});
const $fcf97b7a09088940$export$53d41ff2666118e1 = 'agility-backlog';
const $fcf97b7a09088940$export$7552fe2669628499 = 'bitbucket-issue';
const $fcf97b7a09088940$export$41a718da0a8636f4 = 'connect-issue';
const $fcf97b7a09088940$export$cebf0bc8b2ccaf57 = 'core-issue';
const $fcf97b7a09088940$export$5e91e17726e54450 = 'jiraCalendar';
const $fcf97b7a09088940$export$2dac1950892123f5 = 'jiraTimeline';
const $fcf97b7a09088940$export$82540942fb014b0a = 'business-calendar';
const $fcf97b7a09088940$export$7ca28938a07e0c33 = 'business-list';
const $fcf97b7a09088940$export$f6cf06aaaeb58a54 = 'business-timeline';
const $fcf97b7a09088940$export$b2c0462ff17aa26e = 'business-board';
const $fcf97b7a09088940$export$a607850ebccd28ac = 'business-approvals';
const $fcf97b7a09088940$export$1da6cede3561048f = 'business-files';
const $fcf97b7a09088940$export$b19f949fb9713614 = 'full-issue';
const $fcf97b7a09088940$export$a5132300c5214280 = 'embed-issue';
const $fcf97b7a09088940$export$710114090a811b37 = 'global-issue-navigator-issue';
const $fcf97b7a09088940$export$ce88447986394f2d = 'mobile-issue';
const $fcf97b7a09088940$export$6a90d9196d330040 = 'project-issue-navigator';
const $fcf97b7a09088940$export$2247c9059c171db1 = 'roadmap-issue';
const $fcf97b7a09088940$export$cd16d39c55c569d0 = 'simple-software-board';
const $fcf97b7a09088940$export$f72626bf0d75dfad = 'software-backlog-issue';
const $fcf97b7a09088940$export$778b4609e784cb27 = 'software-deployments-issue';
const $fcf97b7a09088940$export$5b73d694a6048002 = 'version-detail-issue';
const $fcf97b7a09088940$export$accce97178e4e049 = 'software-cycle-time-report-issue';
const $fcf97b7a09088940$export$21b5b7189add7861 = 'software-incidents-issue';
const $fcf97b7a09088940$export$9c5d81b901471b27 = 'software-issue';
const $fcf97b7a09088940$export$1735f6ad917dc411 = 'change-calendar';
const $fcf97b7a09088940$export$7063ee6d0035a982 = 'queues-issue-view';
const $fcf97b7a09088940$export$5bd5011b6596a0e7 = 'reports-issue-view';
const $fcf97b7a09088940$export$9dfa9e993d3e0520 = 'forge-full-page-extension';
const $fcf97b7a09088940$export$14a8072f422804fd = 'issue-navigator-next';
const $fcf97b7a09088940$export$5f3c20fe2ff6c0a2 = 'staffing-issue';

parcelRegister("8KmrC", function(module, exports) {

$parcel$export(module.exports, "default", () => $2622f927d259b739$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $ajpes = parcelRequire("ajpes");

var $8Rkzz = parcelRequire("8Rkzz");

var $fr1K2 = parcelRequire("fr1K2");

var $x9xyg = parcelRequire("x9xyg");

var $6RCeq = parcelRequire("6RCeq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");


var $kbfkr = parcelRequire("kbfkr");

var $361on = parcelRequire("361on");
const $2622f927d259b739$var$clearAndSetPerformanceMark = (markKey)=>{
    if ((0, $6RCeq.default) && (0, $6RCeq.default).clearMarks) (0, $6RCeq.default).clearMarks(markKey);
    (0, $x9xyg.setMark)(markKey);
};
const $2622f927d259b739$var$useDebouncedOnChange = (onChange, createAnalyticsEvent)=>{
    const debouncedOnChange = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((filters, filterType, attributes)=>{
            if (createAnalyticsEvent) {
                const analyticsEvent = createAnalyticsEvent({
                    action: 'changed',
                    actionSubject: 'filterBar'
                });
                (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'changeFilterBar', {
                    ...attributes,
                    filterType: filterType
                });
                onChange((0, $361on.getNormalizedFilters)(filters), filterType, attributes, analyticsEvent);
            } else onChange((0, $361on.getNormalizedFilters)(filters), filterType, attributes);
        }, 5), [
        onChange,
        createAnalyticsEvent
    ]);
    return debouncedOnChange;
};
const $2622f927d259b739$var$useOnChangeFilterValues = (filter, onChange, // @ts-expect-error - TS7006 - Parameter 'onChangeInteractionStart' implicitly has an 'any' type.
onChangeInteractionStart, // @ts-expect-error - TS7006 - Parameter 'onCustomFilterChangeInteractionStart' implicitly has an 'any' type.
onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged)=>{
    const [localFilter, setFilters] = (0, $5uXOq.useState)(filter);
    (0, $5uXOq.useEffect)(()=>{
        setFilters(filter);
    }, [
        filter
    ]);
    const debouncedOnChange = $2622f927d259b739$var$useDebouncedOnChange(onChange, createAnalyticsEvent);
    const onChangeFilterValues = (0, $5uXOq.useCallback)((filters, fieldType, attributes)=>{
        if (fieldType !== null) {
            $2622f927d259b739$var$clearAndSetPerformanceMark('filterBarStart');
            (0, $361on.onFilterChangeStartInteraction)(fieldType, onChangeInteractionStart, onCustomFilterChangeInteractionStart);
            const values = filters[fieldType] ?? [];
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
            let updatedFilter = {
                ...localFilter,
                [fieldType]: values
            };
            if (values.length === 0) {
                isCompanyManaged && onClearCustomFilterInteractionStart();
                updatedFilter = (0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(localFilter, fieldType);
            }
            setFilters(updatedFilter);
            // fieldType could in theory not be accurate on a final debounced call,
            // however there's only a 5ms window during which this may happen.
            debouncedOnChange(updatedFilter, fieldType, attributes);
        }
    }, [
        onChangeInteractionStart,
        onCustomFilterChangeInteractionStart,
        setFilters,
        localFilter,
        debouncedOnChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    const clearFilter = (0, $5uXOq.useCallback)(()=>{
        const emptyFilters = {
            TEXT: undefined,
            ASSIGNEE: undefined,
            LABEL: undefined,
            SPRINT: undefined,
            ISSUE_PARENT: undefined,
            ISSUE_PROJECT: undefined,
            ISSUE_TYPE: undefined,
            VERSION: undefined,
            REQUEST_TYPE: undefined,
            STATUS_CATEGORY: undefined,
            STATUS: undefined,
            CUSTOM_FILTER: undefined,
            DEPENDENCIES: undefined
        };
        isCompanyManaged && onClearCustomFilterInteractionStart();
        setFilters(emptyFilters);
        // A 2nd `null` argument is required so that the analytics event doesn't get treated as the
        // filter type on filter analytics.
        onChange((0, $361on.getNormalizedFilters)(emptyFilters), null, undefined);
    }, [
        onChange,
        isCompanyManaged,
        onClearCustomFilterInteractionStart
    ]);
    return [
        localFilter,
        onChangeFilterValues,
        clearFilter
    ];
};
const $2622f927d259b739$var$SoftwareFilters = (props)=>{
    const { filter: filter, onChange: onChange, onClearAllButtonClicked: onClearAllButtonClicked, onChangeInteractionFeedback: onChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCustomFilterChangeInteractionFeedback: onCustomFilterChangeInteractionFeedback = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCustomFilterChangeInteractionStart: onCustomFilterChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onExperienceSuccess: onExperienceSuccess = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isCompanyManaged: isCompanyManaged = false, onClearCustomFilterInteractionStart: onClearCustomFilterInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [localFilters, onChangeFilterValues, clearFilter] = $2622f927d259b739$var$useOnChangeFilterValues(filter, onChange, onChangeInteractionStart, onCustomFilterChangeInteractionStart, createAnalyticsEvent, onClearCustomFilterInteractionStart, isCompanyManaged);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
    }, [
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filter, localFilters)) {
            $2622f927d259b739$var$clearAndSetPerformanceMark('filterBarStop');
            onChangeInteractionFeedback();
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($ajpes)))(filter.CUSTOM_FILTER, localFilters.CUSTOM_FILTER)) onCustomFilterChangeInteractionFeedback();
        }
    }, [
        filter,
        localFilters,
        onChangeInteractionFeedback,
        onCustomFilterChangeInteractionFeedback
    ]);
    $2622f927d259b739$var$clearAndSetPerformanceMark('oldFilterBarStop');
    const onClear = (0, $5uXOq.useCallback)((event, analyticsEvent)=>{
        // we always have to pass void entityType, so analytics events will always be as third argument
        clearFilter();
        onClearAllButtonClicked && onClearAllButtonClicked(event, analyticsEvent);
        const customAnalyticsEvent = createAnalyticsEvent({
            action: 'changed',
            actionSubject: 'filterBar'
        });
        (0, $8zOmE.fireUIAnalytics)(customAnalyticsEvent, 'changeFilterBar', {
            filterType: (0, $15a528573ccd89ae$export$6c4d37c7f376a1de)
        });
    }, [
        clearFilter,
        onClearAllButtonClicked,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kbfkr.default), {
        ...props,
        filter: localFilters,
        onClearAllButtonClicked: onClear,
        onChange: onChangeFilterValues
    });
};
var $2622f927d259b739$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2622f927d259b739$var$SoftwareFilters);

});
parcelRegister("kbfkr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb7c802f0a442491$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $lFKmC = parcelRequire("lFKmC");

var $9XE6b = parcelRequire("9XE6b");

var $hGgHi = parcelRequire("hGgHi");

var $8Rkzz = parcelRequire("8Rkzz");

var $hqTkp = parcelRequire("hqTkp");

var $gKZoD = parcelRequire("gKZoD");

var $eQfWH = parcelRequire("eQfWH");

var $26g7Y = parcelRequire("26g7Y");

var $MHKc7 = parcelRequire("MHKc7");

var $eZJjh = parcelRequire("eZJjh");

var $kY99m = parcelRequire("kY99m");

var $dqoiX = parcelRequire("dqoiX");

var $5p1kJ = parcelRequire("5p1kJ");

var $5rVQI = parcelRequire("5rVQI");

var $eG9rp = parcelRequire("eG9rp");

var $879xD = parcelRequire("879xD");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $6CjZR = parcelRequire("6CjZR");

var $1beWO = parcelRequire("1beWO");

var $3oCwY = parcelRequire("3oCwY");

var $7j6PN = parcelRequire("7j6PN");

var $8bg0N = parcelRequire("8bg0N");

var $kgqZV = parcelRequire("kgqZV");

var $efv79 = parcelRequire("efv79");

var $jKPI1 = parcelRequire("jKPI1");

var $hHL6f = parcelRequire("hHL6f");

var $2fsdj = parcelRequire("2fsdj");

var $bLWKp = parcelRequire("bLWKp");

var $hpA0D = parcelRequire("hpA0D");

var $g65Ek = parcelRequire("g65Ek");

var $jdA4J = parcelRequire("jdA4J");

var $cSFZv = parcelRequire("cSFZv");

var $3f9TT = parcelRequire("3f9TT");

var $aMFc7 = parcelRequire("aMFc7");

var $fJnmW = parcelRequire("fJnmW");

var $koVbs = parcelRequire("koVbs");

var $cTi8P = parcelRequire("cTi8P");

var $2m0b6 = parcelRequire("2m0b6");

var $2xSAL = parcelRequire("2xSAL");

var $g5X3G = parcelRequire("g5X3G");

var $fUHZ2 = parcelRequire("fUHZ2");

var $90yGq = parcelRequire("90yGq");

var $dCm1o = parcelRequire("dCm1o");

var $k9JTq = parcelRequire("k9JTq");

var $ldyPw = parcelRequire("ldyPw");

var $6cG4N = parcelRequire("6cG4N");

var $a2e2Q = parcelRequire("a2e2Q");


var $cM4EP = parcelRequire("cM4EP");

var $2FvdY = parcelRequire("2FvdY");

var $kH9yv = parcelRequire("kH9yv");

var $bBMqL = parcelRequire("bBMqL");

var $l38sT = parcelRequire("l38sT");

var $649U3 = parcelRequire("649U3");
const $cb7c802f0a442491$var$EMPTY_ARRAY = [];
const $cb7c802f0a442491$var$MIN_VISIBLE_USERS = 2;
const $cb7c802f0a442491$var$USER_AVATAR_WIDTH = 30;
const $cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS = 7;
const $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH = 510;
const $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT = 1440;
const $cb7c802f0a442491$var$SEARCH_ISSUE_DESCRIPTION_SCREEN_READER_ID = 'search-issue-description';
const $cb7c802f0a442491$var$SoftwareFiltersStateless = (props)=>{
    (0, $gKZoD.di)(requestAnimationFrame);
    const { filter: filter, issueParentsLabel: issueParentsLabel, assignees: assignees = [], issueParents: issueParents = [], versions: versions = [], components: components = [], labels: labels = [], issueProjects: issueProjects = {}, issueTypes: issueTypes = [], issueTypeGroups: issueTypeGroups = [], statuses: statuses = [], requestTypes: requestTypes = [], onChange: onChange, onSearchFieldFocus: onSearchFieldFocus = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onExtraAvatarMenuOpen: onExtraAvatarMenuOpen = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onFilterPanelMounted: onFilterPanelMounted = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onClearAllButtonClicked: onClearAllButtonClicked = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onToggleParentPanel: onToggleParentPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onToggleVersionsPanel: onToggleVersionsPanel = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isIssueParentPanelToggleChecked: isIssueParentPanelToggleChecked = false, isVersionPanelToggleChecked: isVersionPanelToggleChecked = false, isAnyModalOpen: isAnyModalOpen = false, AddPeopleModal: AddPeopleModal, showPanelToggle: /**
     * @deprecated `showPanelToggle` used to control visibility of all panel toggles. Use `panelToggleVisibility` instead to control each panel toggle visibility.
     */ showPanelToggle = false, panelToggleVisibility: panelToggleVisibility, showParentIssueMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty = false, showSearchFilterChangeboarding: showSearchFilterChangeboarding = false, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isVersionsFeatureEnabled: isVersionsFeatureEnabled = false, isComponentsFeatureEnabled: isComponentsFeatureEnabled = false, isStatusCategoriesFeatureEnabled: isStatusCategoriesFeatureEnabled = true, isIssueParentsFeatureEnabled: isIssueParentsFeatureEnabled = true, isLabelsFeatureEnabled: isLabelsFeatureEnabled = true, isIssueProjectsFeatureEnabled: isIssueProjectsFeatureEnabled = false, isIssueTypesFeatureEnabled: isIssueTypesFeatureEnabled = true, isSprintsFeatureEnabled: isSprintsFeatureEnabled = true, isRequestTypesFeatureEnabled: isRequestTypesFeatureEnabled = false, isStatusesFeatureEnabled: isStatusesFeatureEnabled = false, isGroupIssueTypesEnabled: isGroupIssueTypesEnabled = false, isDependenciesFeatureEnabled: isDependenciesFeatureEnabled = false, onChangeInteractionStart: onChangeInteractionStart = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), projectId: projectId, projectName: projectName, projectKey: projectKey, boardId: boardId, statusCategories: statusCategories = [], customFiltersQueryRef: customFiltersQueryRef, CustomFilter: CustomFilter, showAssigneeFilter: showAssigneeFilter = true, showCustomFilters: showCustomFilters = false, showBoardSwitcher: showBoardSwitcher = false, isBoardSwitcherReadOnly: isBoardSwitcherReadOnly = true, versionFilterRelayQueryRef: versionFilterRelayQueryRef, VersionFilterRelay: VersionFilterRelay, isVersionFilterRelayEnabled: isVersionFilterRelayEnabled = false, isUnassignedAssigneeOptionEnabled: isUnassignedAssigneeOptionEnabled = false, isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled = false, isUnassignedLabelOptionEnabled: isUnassignedLabelOptionEnabled = false, isUnassignedComponentOptionEnabled: isUnassignedComponentOptionEnabled = false, isCustomFiltersLoading: isCustomFiltersLoading = false, placeholder: placeholder = '', screenReaderInstruction: screenReaderInstruction = '', sprints: sprints = [], isAddPeopleButtonEnabled: isAddPeopleButtonEnabled = false, isCustomFilterManageLinkEnabled: isCustomFilterManageLinkEnabled = false, jqlFilters: jqlFilters = [], isCompanyManaged: isCompanyManaged = false, isJSMBoard: isJSMBoard = false, hasMultipleProjects: hasMultipleProjects = false, isGoalsFeatureOptionEnabled: isGoalsFeatureOptionEnabled = false, goals: goals = [], shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge = false } = props;
    const accountId = (0, $90yGq.useAccountId)();
    const isAsyncFilterLoading = isCustomFiltersLoading;
    const [screenReaderInstructionForFilters, setScreenReaderInstructionForFilters] = (0, $5uXOq.useState)(false);
    const { software: software } = (0, $k9JTq.useAppEditions)();
    const shouldDisableAddPeople = isCompanyManaged && software === (0, $ldyPw.FREE_EDITION);
    const keepUnassignedUserOnTop = isUnassignedAssigneeOptionEnabled && screenName === 'board' && (0, $4R6GH.fg)('unassigned_filter_kill_switch');
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const allAssignees = (0, $5uXOq.useMemo)(()=>{
        if (!isUnassignedAssigneeOptionEnabled) return assignees;
        const unassignedUser = {
            id: (0, $g5X3G.toAccountId)((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
            displayName: formatMessage((0, $l38sT.default).unassignedAssigneeDisplayName),
            avatarUrl: undefined
        };
        if (keepUnassignedUserOnTop) return [
            unassignedUser,
            ...assignees
        ];
        return [
            ...assignees,
            unassignedUser
        ];
    }, [
        isUnassignedAssigneeOptionEnabled,
        formatMessage,
        keepUnassignedUserOnTop,
        assignees
    ]);
    const allVersions = (0, $5uXOq.useMemo)(()=>isUnassignedVersionOptionEnabled && versions.length ? [
            {
                id: (0, $15a528573ccd89ae$export$ac95b4b2317d4b33),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedVersionLabelIssueTermRefresh : (0, $l38sT.default).unassignedVersionLabel)
            },
            ...versions
        ] : versions, [
        versions,
        isUnassignedVersionOptionEnabled,
        formatMessage
    ]);
    const unassignedOption = (0, $5uXOq.useMemo)(()=>({
            label: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedLabelLabelIssueTermRefresh : (0, $l38sT.default).unassignedLabelLabel),
            value: (0, $15a528573ccd89ae$export$81ef49afbbead0a1)
        }), [
        formatMessage
    ]);
    const allComponents = (0, $5uXOq.useMemo)(()=>isUnassignedComponentOptionEnabled && components.length ? [
            {
                id: (0, $15a528573ccd89ae$export$4b7c755e61199a36),
                name: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).unassignedComponentLabelIssueTermRefresh : (0, $l38sT.default).unassignedComponentLabel)
            },
            ...components
        ] : components, [
        components,
        isUnassignedComponentOptionEnabled,
        formatMessage
    ]);
    (0, $5uXOq.useEffect)(()=>{
        onFilterPanelMounted();
    }, [
        onFilterPanelMounted
    ]); // go/jfe-eslint
    // eslint-disable-next-line react-hooks/exhaustive-deps
    const onSearchChange = (0, $5uXOq.useCallback)((0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((newText)=>{
        onChangeInteractionStart();
        onChange({
            [(0, $15a528573ccd89ae$export$d597759d33be802e)]: newText
        }, (0, $15a528573ccd89ae$export$d597759d33be802e), undefined);
    }, 300), [
        onChange,
        onChangeInteractionStart
    ]);
    const assigneeValue = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(filter, [
            (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
        ], $cb7c802f0a442491$var$EMPTY_ARRAY), [
        filter
    ]);
    const onToggleAssignee = (0, $5uXOq.useCallback)((entryId)=>{
        setScreenReaderInstructionForFilters(true);
        setTimeout(()=>{
            setScreenReaderInstructionForFilters(false);
        });
        const withoutValue = (0, (/*@__PURE__*/$parcel$interopDefault($hqTkp)))(assigneeValue, entryId);
        const newFilterValue = withoutValue.length === assigneeValue.length ? withoutValue.concat(entryId) : withoutValue;
        onChange({
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: (0, $g5X3G.toAccountIdArray)(newFilterValue)
        }, (0, $15a528573ccd89ae$export$f8f7545d2bb78afb), {
            isUnassignedFilterCta: false,
            // part of experiment unassigned_filter_kill_switch
            isUnassignedSelected: newFilterValue.includes((0, $15a528573ccd89ae$export$12e572fd459c10dc)),
            isOnlyCurrentUserSelected: accountId && newFilterValue.length === 1 && newFilterValue[0] === accountId
        });
    }, [
        assigneeValue,
        onChange,
        accountId
    ]);
    const onClickUnassignedFilterNudge = (0, $5uXOq.useCallback)(()=>{
        setScreenReaderInstructionForFilters(true);
        setTimeout(()=>{
            setScreenReaderInstructionForFilters(false);
        });
        accountId && onChange({
            [(0, $15a528573ccd89ae$export$f8f7545d2bb78afb)]: [
                (0, $15a528573ccd89ae$export$12e572fd459c10dc),
                accountId
            ]
        }, (0, $15a528573ccd89ae$export$f8f7545d2bb78afb), {
            isUnassignedFilterCta: true,
            isUnassignedSelected: true,
            isOnlyCurrentUserSelected: false
        });
    }, [
        onChange,
        accountId
    ]);
    const onChangeParents = (0, $5uXOq.useCallback)((parentIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$2a4f270075a033de)]: parentIds
        }, (0, $15a528573ccd89ae$export$2a4f270075a033de), attributes);
    }, [
        onChange
    ]);
    const onChangeVersions = (0, $5uXOq.useCallback)((versionIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$a4ad2735b021c132)]: (0, $g5X3G.toVersionIdArray)(versionIds)
        }, (0, $15a528573ccd89ae$export$a4ad2735b021c132), attributes);
    }, [
        onChange
    ]);
    const onChangeComponents = (0, $5uXOq.useCallback)((componentIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$af1e30ebbae9df3b)]: (0, $g5X3G.toComponentIdArray)(componentIds)
        }, (0, $15a528573ccd89ae$export$af1e30ebbae9df3b), attributes);
    }, [
        onChange
    ]);
    const onChangeLabels = (0, $5uXOq.useCallback)((newLabels, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)]: newLabels
        }, (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueProjects = (0, $5uXOq.useCallback)((newProjects, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$401f4b6eda6a369c)]: newProjects
        }, (0, $15a528573ccd89ae$export$401f4b6eda6a369c), attributes);
    }, [
        onChange
    ]);
    const onChangeIssueTypes = (0, $5uXOq.useCallback)((issueTypeIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$ebb48b08205007c5)]: issueTypeIds
        }, (0, $15a528573ccd89ae$export$ebb48b08205007c5), attributes);
    }, [
        onChange
    ]);
    const onChangeStatusCategories = (0, $5uXOq.useCallback)((newStatusCategories, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$f863b019d19144f4)]: newStatusCategories
        }, (0, $15a528573ccd89ae$export$f863b019d19144f4), attributes);
    }, [
        onChange
    ]);
    const onChangeCustomFilters = (0, $5uXOq.useCallback)((newCustomFilters, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$68d693c35a8d8866)]: newCustomFilters
        }, (0, $15a528573ccd89ae$export$68d693c35a8d8866), attributes);
    }, [
        onChange
    ]);
    const onChangeSprints = (0, $5uXOq.useCallback)((newSprintIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$a316570a0dbfd2b0)]: newSprintIds
        }, (0, $15a528573ccd89ae$export$a316570a0dbfd2b0), attributes);
    }, [
        onChange
    ]);
    const onChangeStatuses = (0, $5uXOq.useCallback)((newStatuses, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$e50006273435e7d4)]: newStatuses
        }, (0, $15a528573ccd89ae$export$e50006273435e7d4), attributes);
    }, [
        onChange
    ]);
    const onChangeRequestTypes = (0, $5uXOq.useCallback)((newRequestTypeIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$92ab80c1dc9baf44)]: newRequestTypeIds
        }, (0, $15a528573ccd89ae$export$92ab80c1dc9baf44), attributes);
    }, [
        onChange
    ]);
    const onChangeQuickFilters = (0, $5uXOq.useCallback)((newQuickFilters, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$1ea95b94fb0c51d9)]: newQuickFilters
        }, (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9), attributes);
    }, [
        onChange
    ]);
    const onChangeGoals = (0, $5uXOq.useCallback)((goalIds, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$871e58afc769b358)]: goalIds
        }, (0, $15a528573ccd89ae$export$871e58afc769b358), attributes);
    }, [
        onChange
    ]);
    const onChangeDependencies = (0, $5uXOq.useCallback)((dependencyOptions, attributes)=>{
        onChange({
            [(0, $15a528573ccd89ae$export$db362e2d293fe52e)]: dependencyOptions
        }, (0, $15a528573ccd89ae$export$db362e2d293fe52e), attributes);
    }, [
        onChange
    ]);
    const isClearButtonVisible = (0, $5uXOq.useMemo)(()=>filter && Object.keys(filter).length > 0, [
        filter
    ]);
    const searchInputRef = (0, $5uXOq.useRef)(null);
    const fireShortcutAnalytics = (0, $fUHZ2.useShortcutAnalytics)(screenName);
    const focusSearchInput = (0, $5uXOq.useCallback)(()=>{
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchInputRef) && !(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(searchInputRef.current)) {
            // This is the same way the global search input prevents
            // the shortcut from being fed into the input
            // See: src/packages/navigation-apps/atlassian-navigation/src/ui/integrations/keyboard-shortcuts/index.tsx
            requestAnimationFrame(()=>{
                searchInputRef.current && searchInputRef.current.focus();
            });
            const analyticsPayload = {
                id: 'focusSearchField',
                key: 'f',
                attributes: {}
            };
            fireShortcutAnalytics(analyticsPayload);
        }
    }, [
        fireShortcutAnalytics,
        searchInputRef
    ]); // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const isUserBoard = window.location.pathname.startsWith('/jira/people/');
    const customFilterManageUrl = (0, $649U3.getManageCustomFiltersUrl)(projectKey, boardId.toString(), isCompanyManaged, isUserBoard, isJSMBoard);
    const showEpicPanelToggle = panelToggleVisibility ? panelToggleVisibility.showEpicPanelToggle : showPanelToggle;
    const isMounted = (0, $5uXOq.useRef)(false);
    (0, $5uXOq.useEffect)(()=>{
        if (isMounted.current) {
            if (!isClearButtonVisible) {
                setScreenReaderInstructionForFilters(true);
                setTimeout(()=>{
                    setScreenReaderInstructionForFilters(false);
                }, 1000);
            }
        } else isMounted.current = true;
    }, [
        isClearButtonVisible
    ]);
    const parentFilter = {
        id: (0, $15a528573ccd89ae$export$2a4f270075a033de),
        isStatic: false,
        isHidden: !isIssueParentsFeatureEnabled,
        renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bLWKp.default), {
                key: "ParentFilter",
                isNested: isNested,
                label: issueParentsLabel,
                parents: issueParents,
                selectedParents: filter[0, $15a528573ccd89ae$export$2a4f270075a033de],
                isToggleChecked: isIssueParentPanelToggleChecked,
                onChange: onChangeParents,
                onTogglePanel: onToggleParentPanel,
                showPanelToggle: showEpicPanelToggle,
                showMenuIfValuesAreEmpty: showParentIssueMenuIfValuesAreEmpty
            })
    };
    const showVersionsPanelToggle = panelToggleVisibility ? panelToggleVisibility.showVersionsPanelToggle : showPanelToggle;
    const versionFilter = {
        id: (0, $15a528573ccd89ae$export$a4ad2735b021c132),
        isStatic: false,
        hidden: !isVersionsFeatureEnabled,
        renderer: (isNested)=>{
            const versionFilterProps = {
                isNested: isNested,
                isToggleChecked: isVersionPanelToggleChecked,
                onChange: onChangeVersions,
                onTogglePanel: onToggleVersionsPanel,
                selectedVersions: filter[0, $15a528573ccd89ae$export$a4ad2735b021c132] ?? $cb7c802f0a442491$var$EMPTY_ARRAY,
                // RLSS-3020 Spotlight will be cleanup soon
                isSpotlightEnabled: false,
                showPanelToggle: showVersionsPanelToggle,
                isVersionsFeatureEnabled: isVersionsFeatureEnabled
            };
            if (isVersionFilterRelayEnabled) {
                if ((0, $4R6GH.fg)('force_show_empty_parent_and_version_filter_options')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBMqL.default), {
                    key: "VersionFilterRelayBoundary",
                    screenName: screenName,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                        versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                        hasMultipleProjects: hasMultipleProjects,
                        isLoading: true,
                        ...versionFilterProps
                    })
                }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(VersionFilterRelay, {
                    versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                    isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                    hasMultipleProjects: hasMultipleProjects,
                    ...versionFilterProps
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                    versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                    hasMultipleProjects: hasMultipleProjects,
                    isLoading: true,
                    ...versionFilterProps
                }));
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bBMqL.default), {
                    key: "VersionFilterRelayBoundary",
                    screenName: screenName,
                    fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                        versions: $cb7c802f0a442491$var$EMPTY_ARRAY,
                        hasMultipleProjects: hasMultipleProjects,
                        isLoading: true,
                        ...versionFilterProps
                    })
                }, versionFilterRelayQueryRef != null && VersionFilterRelay != null ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(VersionFilterRelay, {
                    versionFilterRelayQueryRef: versionFilterRelayQueryRef,
                    isUnassignedVersionOptionEnabled: isUnassignedVersionOptionEnabled,
                    hasMultipleProjects: hasMultipleProjects,
                    ...versionFilterProps
                }) : null);
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aMFc7.default), {
                key: "VersionFilter",
                versions: allVersions,
                ...versionFilterProps
            });
        }
    };
    let overflowItemsBefore = [
        {
            id: (0, $15a528573ccd89ae$export$f863b019d19144f4),
            isStatic: false,
            isHidden: !isStatusCategoriesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSFZv.default), {
                    key: "StatusCategoryFilter",
                    isNested: isNested,
                    statusCategories: statusCategories,
                    selectedStatusCategories: filter[0, $15a528573ccd89ae$export$f863b019d19144f4],
                    onChange: onChangeStatusCategories
                })
        },
        /**
   * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
   * please refer to src/packages/software/board/src/services/filter/filter-url-bindings.tsx
   */ {
            id: (0, $15a528573ccd89ae$export$401f4b6eda6a369c),
            isStatic: false,
            isHidden: !isIssueProjectsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efv79.default), {
                    isNested: isNested,
                    issueProjects: issueProjects,
                    key: "IssueProjectFilter",
                    onChange: onChangeIssueProjects,
                    selectedProjects: filter[0, $15a528573ccd89ae$export$401f4b6eda6a369c]
                })
        },
        versionFilter,
        parentFilter,
        {
            id: (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7),
            isStatic: false,
            isHidden: !isLabelsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2fsdj.default), {
                    key: "LabelFilter",
                    isNested: isNested,
                    ...isUnassignedLabelOptionEnabled && labels.length ? {
                        unassignedOption: unassignedOption
                    } : undefined,
                    labels: labels,
                    selectedLabels: filter[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7],
                    onChange: onChangeLabels
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$ebb48b08205007c5),
            isStatic: false,
            isHidden: !isIssueTypesFeatureEnabled,
            renderer: (isNested)=>isGroupIssueTypesEnabled ? // In the program board, we could have multiple issue types with the same hierarchy level and names coming from multiple TWP project. We group them so there's no visually duplicated items in the dropdown
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKPI1.default), {
                    key: "IssueTypeGroupFilter",
                    isNested: isNested,
                    issueTypeGroups: issueTypeGroups,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hHL6f.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    issueTypes: issueTypes,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$af1e30ebbae9df3b),
            isStatic: false,
            isHidden: !isComponentsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7j6PN.default), {
                    key: "ComponentFilter",
                    isNested: isNested,
                    components: allComponents,
                    onChange: onChangeComponents,
                    selectedComponents: filter[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$a316570a0dbfd2b0),
            isStatic: false,
            isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdA4J.default), {
                    key: "SprintFilter",
                    isNested: isNested,
                    sprints: sprints,
                    selectedSprints: filter[0, $15a528573ccd89ae$export$a316570a0dbfd2b0],
                    onChange: onChangeSprints
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$e50006273435e7d4),
            isStatic: false,
            isHidden: !isStatusesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3f9TT.default), {
                    key: "StatusFilter",
                    isNested: isNested,
                    statuses: statuses,
                    selectedStatuses: filter[0, $15a528573ccd89ae$export$e50006273435e7d4],
                    onChange: onChangeStatuses
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$92ab80c1dc9baf44),
            isStatic: false,
            isHidden: !isRequestTypesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g65Ek.default), {
                    key: "RequestTypeFilter",
                    isNested: isNested,
                    requestTypes: requestTypes,
                    selectedRequestTypes: filter[0, $15a528573ccd89ae$export$92ab80c1dc9baf44],
                    onChange: onChangeRequestTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$68d693c35a8d8866),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM4EP.default), {
                    key: "CustomFilterBoundary",
                    screenName: screenName,
                    customFiltersQueryRef: customFiltersQueryRef
                }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomFilter, {
                    isNested: isNested,
                    customFiltersQueryRef: customFiltersQueryRef,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$68d693c35a8d8866],
                    filters: jqlFilters,
                    onChange: onChangeCustomFilters,
                    showLink: isCustomFilterManageLinkEnabled,
                    manageUrl: customFilterManageUrl,
                    screenName: screenName
                }))
        },
        {
            id: (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9),
            isStatic: false,
            isHidden: showCustomFilters,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpA0D.default), {
                    key: "QuickFilter",
                    isNested: isNested,
                    filters: jqlFilters,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$1ea95b94fb0c51d9],
                    onChange: onChangeQuickFilters
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$871e58afc769b358),
            isStatic: false,
            isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgqZV.default), {
                    key: "GoalFilter",
                    isNested: isNested,
                    goals: goals,
                    selectedGoals: filter[0, $15a528573ccd89ae$export$871e58afc769b358],
                    onChange: onChangeGoals
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$db362e2d293fe52e),
            isStatic: false,
            isHidden: !isDependenciesFeatureEnabled,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bg0N.default), {
                    key: "DependenciesFilter",
                    onChange: onChangeDependencies,
                    selectedValues: filter[0, $15a528573ccd89ae$export$db362e2d293fe52e]
                })
        }
    ];
    if ((0, $dCm1o.isVisualRefreshEnabled)()) overflowItemsBefore = [
        versionFilter,
        parentFilter,
        {
            id: (0, $15a528573ccd89ae$export$ebb48b08205007c5),
            isStatic: false,
            isHidden: !isIssueTypesFeatureEnabled,
            renderer: (isNested)=>isGroupIssueTypesEnabled ? // In the program board, we could have multiple issue types with the same hierarchy level and names coming from multiple TWP project. We group them so there's no visually duplicated items in the dropdown
                /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jKPI1.default), {
                    key: "IssueTypeGroupFilter",
                    isNested: isNested,
                    issueTypeGroups: issueTypeGroups,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hHL6f.default), {
                    key: "IssueTypeFilter",
                    isNested: isNested,
                    issueTypes: issueTypes,
                    selectedIssueTypes: filter[0, $15a528573ccd89ae$export$ebb48b08205007c5],
                    onChange: onChangeIssueTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7),
            isStatic: false,
            isHidden: !isLabelsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2fsdj.default), {
                    key: "LabelFilter",
                    isNested: isNested,
                    ...isUnassignedLabelOptionEnabled && labels.length ? {
                        unassignedOption: unassignedOption
                    } : undefined,
                    labels: labels,
                    selectedLabels: filter[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7],
                    onChange: onChangeLabels
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$e50006273435e7d4),
            isStatic: false,
            isHidden: !isStatusesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3f9TT.default), {
                    key: "StatusFilter",
                    isNested: isNested,
                    statuses: statuses,
                    selectedStatuses: filter[0, $15a528573ccd89ae$export$e50006273435e7d4],
                    onChange: onChangeStatuses
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$f863b019d19144f4),
            isStatic: false,
            isHidden: !isStatusCategoriesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cSFZv.default), {
                    key: "StatusCategoryFilter",
                    isNested: isNested,
                    statusCategories: statusCategories,
                    selectedStatusCategories: filter[0, $15a528573ccd89ae$export$f863b019d19144f4],
                    onChange: onChangeStatusCategories
                })
        },
        /**
     * the "Project" filter is currently only used by the Increment Planning board of Advanced Roadmaps
     * please refer to src/packages/software/board/src/services/filter/filter-url-bindings.tsx
     */ {
            id: (0, $15a528573ccd89ae$export$401f4b6eda6a369c),
            isStatic: false,
            isHidden: !isIssueProjectsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efv79.default), {
                    isNested: isNested,
                    issueProjects: issueProjects,
                    key: "IssueProjectFilter",
                    onChange: onChangeIssueProjects,
                    selectedProjects: filter[0, $15a528573ccd89ae$export$401f4b6eda6a369c]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$af1e30ebbae9df3b),
            isStatic: false,
            isHidden: !isComponentsFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7j6PN.default), {
                    key: "ComponentFilter",
                    isNested: isNested,
                    components: allComponents,
                    onChange: onChangeComponents,
                    selectedComponents: filter[0, $15a528573ccd89ae$export$af1e30ebbae9df3b]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$a316570a0dbfd2b0),
            isStatic: false,
            isHidden: !isSprintsFeatureEnabled || sprints.length <= 1,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jdA4J.default), {
                    key: "SprintFilter",
                    isNested: isNested,
                    sprints: sprints,
                    selectedSprints: filter[0, $15a528573ccd89ae$export$a316570a0dbfd2b0],
                    onChange: onChangeSprints
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$871e58afc769b358),
            isStatic: false,
            isHidden: !isGoalsFeatureOptionEnabled || goals.length === 0,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgqZV.default), {
                    key: "GoalFilter",
                    isNested: isNested,
                    goals: goals,
                    selectedGoals: filter[0, $15a528573ccd89ae$export$871e58afc769b358],
                    onChange: onChangeGoals
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$db362e2d293fe52e),
            isStatic: false,
            isHidden: !isDependenciesFeatureEnabled,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8bg0N.default), {
                    key: "DependenciesFilter",
                    onChange: onChangeDependencies,
                    selectedValues: filter[0, $15a528573ccd89ae$export$db362e2d293fe52e]
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$92ab80c1dc9baf44),
            isStatic: false,
            isHidden: !isRequestTypesFeatureEnabled,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g65Ek.default), {
                    key: "RequestTypeFilter",
                    isNested: isNested,
                    requestTypes: requestTypes,
                    selectedRequestTypes: filter[0, $15a528573ccd89ae$export$92ab80c1dc9baf44],
                    onChange: onChangeRequestTypes
                })
        },
        {
            id: (0, $15a528573ccd89ae$export$68d693c35a8d8866),
            isStatic: false,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cM4EP.default), {
                    key: "CustomFilterBoundary",
                    screenName: screenName,
                    customFiltersQueryRef: customFiltersQueryRef
                }, (!!customFiltersQueryRef || showCustomFilters) && !!CustomFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CustomFilter, {
                    isNested: isNested,
                    customFiltersQueryRef: customFiltersQueryRef,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$68d693c35a8d8866],
                    filters: jqlFilters,
                    onChange: onChangeCustomFilters,
                    showLink: isCustomFilterManageLinkEnabled,
                    manageUrl: customFilterManageUrl,
                    screenName: screenName
                }))
        },
        {
            id: (0, $15a528573ccd89ae$export$1ea95b94fb0c51d9),
            isStatic: false,
            isHidden: showCustomFilters,
            renderer: (isNested)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpA0D.default), {
                    key: "QuickFilter",
                    isNested: isNested,
                    filters: jqlFilters,
                    selectedFilters: filter[0, $15a528573ccd89ae$export$1ea95b94fb0c51d9],
                    onChange: onChangeQuickFilters
                })
        }
    ];
    const overflowItemsAfter = [
        {
            id: 'CLEAR_BUTTON',
            // The CLEAR_BUTTON should be non-static until a filter is added, else it causes the More button to appear
            // in the filter bar on small window sizes, due to overflow calculations in <OverflowHandler />
            isStatic: isClearButtonVisible,
            isHidden: !isClearButtonVisible,
            renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3oCwY.default), {
                    key: "ClearButton",
                    onClick: onClearAllButtonClicked
                })
        }
    ];
    if (isAsyncFilterLoading) overflowItemsAfter.push({
        id: 'SPINNER',
        isStatic: true,
        isHidden: !isAsyncFilterLoading,
        renderer: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($cb7c802f0a442491$var$SpinnerContainer, {
                key: "SpinnerContainer"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            }))
    });
    const { getKeywords: getKeywords } = (0, $eG9rp.useCommandKeywords)();
    const [maxVisibleUsers, setMaxVisibleUsers] = (0, $5uXOq.useState)($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
    const [showLargeSearchFilter, setShowLargeSearchFilter] = (0, $5uXOq.useState)(true);
    const filterBarRef = (0, $5uXOq.useRef)(null);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        if (!filterBarRef.current || !searchInputRef.current) return;
        const completeFilterBarWidth = filterBarRef.current.offsetWidth; // complete bar with input + filter controls
        const searchInputWidth = searchInputRef.current.offsetWidth; // only the input
        const remainingWidth = completeFilterBarWidth - searchInputWidth; // remaining room for avatar, etc.
        // Handle avatar overflow
        if (remainingWidth < $cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH) {
            const usersToReduce = Math.ceil(($cb7c802f0a442491$var$MIN_FILTER_BAR_WIDTH - remainingWidth) / $cb7c802f0a442491$var$USER_AVATAR_WIDTH);
            const newMax = Math.max($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS - usersToReduce, $cb7c802f0a442491$var$MIN_VISIBLE_USERS);
            setMaxVisibleUsers(newMax);
        } else setMaxVisibleUsers($cb7c802f0a442491$var$DEFAULT_VISIBLE_USERS);
         // Handle search field width
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        setShowLargeSearchFilter(window.innerWidth >= $cb7c802f0a442491$var$LARGE_SEARCH_FILTER_BREAKPOINT);
    }, []);
    (0, $2m0b6.useResizeObserver)({
        ref: filterBarRef,
        onResize: onResize
    });
    (0, $2m0b6.useResizeObserver)({
        ref: searchInputRef,
        onResize: onResize
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJnmW.FilterBar), {
        ref: filterBarRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $879xD.CommandShortcuts), {
        keyMap: {
            f: {
                callback: focusSearchInput,
                registerInCommandPalette: {
                    id: 'software-filters-stateless-focus-search-input',
                    name: formatMessage((0, $l38sT.default).searchCurrentPage),
                    keywords: getKeywords('pageSearchSynonyms'),
                    priority: (0, $5rVQI.COMMAND_PALETTE_QUICK_ACTIONS_PRIORITY).searchOnCurrentPage,
                    section: (0, $5p1kJ.COMMAND_PALETTE_SECTIONS).quickActions,
                    components: {
                        LeftIcon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($eQfWH))), {
                                spacing: "spacious",
                                label: formatMessage((0, $l38sT.default).searchCurrentPage)
                            })
                    },
                    analytics: {
                        action: 'searchCurrentPage'
                    }
                }
            }
        },
        location: "software.filters.keyboard-shortcuts"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        id: $cb7c802f0a442491$var$SEARCH_ISSUE_DESCRIPTION_SCREEN_READER_ID
    }, screenReaderInstruction || formatMessage((0, $l38sT.default).screenReaderInstruction)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, screenReaderInstructionForFilters ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status",
        "aria-relevant": "all"
    }, formatMessage((0, $l38sT.default).screenReaderInstructionForFilters)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dqoiX.ScreenReaderText), {
        "data-testid": "software-filters.ui.stateless.screen-reader-instruction",
        id: "software-filters.ui.stateless.screen-reader-instruction",
        role: "status"
    })), hijackBrowserDefaultSearch === true && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2FvdY.default), {
        onFocusSearch: focusSearchInput,
        isAnyModalOpen: isAnyModalOpen
    }), showSearchFilterChangeboarding === true ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kH9yv.default), {
        hijackBrowserDefaultSearch: hijackBrowserDefaultSearch,
        screenName: screenName,
        isCompanyManaged: isCompanyManaged
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: $cb7c802f0a442491$var$SEARCH_ISSUE_DESCRIPTION_SCREEN_READER_ID,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
        value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).textFilterIssueTermRefresh : (0, $l38sT.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field",
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            reducedHeight: true
        } : {}
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2xSAL.SearchField), {
        placeholderAlwaysVisible: true,
        describedById: $cb7c802f0a442491$var$SEARCH_ISSUE_DESCRIPTION_SCREEN_READER_ID,
        isAlwaysExpanded: showLargeSearchFilter,
        searchIconVisible: false,
        renderCustomSearchField: $cb7c802f0a442491$var$CustomSearchInput,
        value: filter[0, $15a528573ccd89ae$export$d597759d33be802e] || '',
        placeholder: placeholder || formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $l38sT.default).textFilterIssueTermRefresh : (0, $l38sT.default).textFilter),
        onChange: onSearchChange,
        onFocus: onSearchFieldFocus,
        inputRef: searchInputRef,
        maxLength: 255,
        testId: "software-filters.ui.stateless.search-field",
        ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
            reducedHeight: true
        } : {}
    }), showBoardSwitcher && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cTi8P.default), {
        boardId: boardId,
        isReadOnly: isBoardSwitcherReadOnly
    }), showAssigneeFilter && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1beWO.default), {
        maxUsers: maxVisibleUsers,
        users: allAssignees,
        screenName: screenName,
        selectedUsers: assigneeValue,
        onToggle: onToggleAssignee,
        onAssigneeMenuOpen: onExtraAvatarMenuOpen,
        AddPeopleModal: shouldDisableAddPeople ? undefined : AddPeopleModal,
        projectId: projectId,
        projectName: projectName,
        isAddPeopleButtonEnabled: isAddPeopleButtonEnabled,
        projectKey: projectKey,
        shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge,
        onClickUnassignedFilterNudge: onClickUnassignedFilterNudge
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fJnmW.ListFilterContainerNextGen // eslint-disable-next-line jira/integration/test-id-by-folder-structure
    ), {
        "data-testid": "software-filters.ui.list-filter-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6CjZR.default), {
        itemsBefore: overflowItemsBefore,
        itemsAfter: overflowItemsAfter,
        selectedItems: filter
    })));
};
const $cb7c802f0a442491$var$customSearchInputStyles = null;
const $cb7c802f0a442491$var$customSearchInputStylesForTheming = null; // TODO: remove on visual-refresh cleanup
const $cb7c802f0a442491$var$customSearchInputStylesOld = null;
const $cb7c802f0a442491$var$CustomSearchInput = ({ textFieldProps: textFieldProps, searchIcon: searchIcon })=>{
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides
    ), {
        ...textFieldProps,
        elemAfterInput: searchIcon,
        elemBeforeInput: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), {
            paddingInlineStart: "space.100",
            paddingBlockStart: "space.025"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($26g7Y)) // @ts-expect-error - TS2322
        ), {
            color: isSoftwareFullTheming ? (0, $6cG4N.Tokens).COLOR_TEXT_SUBTLE : "var(--ds-icon, #44546F)",
            LEGACY_size: "small",
            label: ""
        })),
        autoComplete: "off",
        testId: "software-filters.ui.stateless.search-field",
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1hxm12x7 _1twg1b66 _12sv7vkz" : "_2rkoq1pp _u5f3ze3t _19bvze3t _1tsv1b66 _ahgx1b66 _hh221b66 _1s0f1b66 _1srlxy5q",
            isSoftwareFullTheming && "_bfhkjjc1 _sg3vjjc1 _w15ajjc1"
        ])
    });
};
var $cb7c802f0a442491$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = /*#__PURE__*/ (0, $5uXOq.memo)($cb7c802f0a442491$var$SoftwareFiltersStateless);
const $cb7c802f0a442491$var$SpinnerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19bv1b66 _4t3i1osq _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6CjZR", function(module, exports) {

$parcel$export(module.exports, "default", () => $0aef8f88c53fc825$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $47bDC = parcelRequire("47bDC");

var $16T6Y = parcelRequire("16T6Y");

var $fVnbM = parcelRequire("fVnbM");

var $c8Oei = parcelRequire("c8Oei");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $gSExi = parcelRequire("gSExi");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $dCm1o = parcelRequire("dCm1o");

var $22OQR = parcelRequire("22OQR");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $7Hgp8 = parcelRequire("7Hgp8");

var $AOaWd = parcelRequire("AOaWd");

var $5yCxu = parcelRequire("5yCxu");
const $0aef8f88c53fc825$var$OverflowHandler = ({ itemsBefore: itemsBefore, itemsAfter: itemsAfter, selectedItems: selectedItems = {} })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const overflowContainerRef = (0, $5uXOq.useRef)(null);
    const overflowContainerUlRef = (0, $5uXOq.useRef)(null);
    const moreFilterRef = (0, $5uXOq.useRef)(null);
    const moreFilterLiRef = (0, $5uXOq.useRef)(null);
    const elementsRef = (0, $5uXOq.useRef)({});
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    // There is a flickering bug switching to/from the "more" button https://jplat.atlassian.net/browse/BLU-3488
    // Additional information can also be found in https://jbusiness.atlassian.net/browse/JVRQ-426
    // But can't reproduce in Storybook + lot of pending changes, so won't fix for now.
    // I suspect this is related to this out-of-rerender memorization of data.
    // Next person actively working on this file is welcome to check. See also investigation notes in the ticket above.
    const prevOverflowContainerWidthRef = (0, $5uXOq.useRef)(0);
    const elementsWidthRef = (0, $5uXOq.useRef)({});
    const visibleElementsRef = (0, $5uXOq.useRef)({});
    const prevElementsWidthRef = (0, $5uXOq.useRef)({});
    const [{ overflowableHideState: overflowableHideState, isMoreDropdownHidden: isMoreDropdownHidden }, setOverflowState] = (0, $5uXOq.useState)({
        overflowableHideState: {},
        isMoreDropdownHidden: true
    });
    const { renderedOverflowableItems: renderedOverflowableItems, staticItems: staticItems, renderedItemsBefore: renderedItemsBefore, renderedItemsAfter: renderedItemsAfter } = (0, $5uXOq.useMemo)(()=>{
        const theOverflowable = [];
        const theStatic = [];
        const theRenderedBefore = [];
        const theRenderedAfter = [];
        const categoriseItems = ({ isRenderedBefore: isRenderedBefore })=>{
            (isRenderedBefore ? itemsBefore : itemsAfter).forEach((item)=>{
                const { isStatic: isStatic, isHidden: isHidden = false } = item;
                // Exclude hidden overflowable items from rendering
                if (!isStatic && isHidden) return;
                (isStatic ? theStatic : theOverflowable).push(item);
                (isRenderedBefore ? theRenderedBefore : theRenderedAfter).push(item);
            });
        };
        categoriseItems({
            isRenderedBefore: true
        });
        categoriseItems({
            isRenderedBefore: false
        });
        return {
            renderedOverflowableItems: theOverflowable,
            staticItems: theStatic,
            renderedItemsBefore: theRenderedBefore,
            renderedItemsAfter: theRenderedAfter
        };
    }, [
        itemsBefore,
        itemsAfter
    ]);
    /**
   * Calculate the count for "More" dropdown.
   * It excludes the selected items of the visible items.
   */ const selectedOverflowItemsCount = (0, $5uXOq.useMemo)(()=>(0, $5yCxu.getSelectedItemsCount)(overflowableHideState, selectedItems), [
        overflowableHideState,
        selectedItems
    ]);
    const onResize = (0, $5uXOq.useCallback)(()=>{
        const overflowContainer = (0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up') ? overflowContainerUlRef?.current : overflowContainerRef?.current;
        const moreFilter = (0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up') ? moreFilterLiRef?.current : moreFilterRef?.current;
        const shouldRecomputeOverflow = (0, $5yCxu.getShouldRecomputeOverflow)(prevOverflowContainerWidthRef.current, overflowContainer?.offsetWidth ?? 0, prevElementsWidthRef.current, elementsWidthRef.current);
        if (!overflowContainer || !moreFilter || !renderedOverflowableItems.length || !shouldRecomputeOverflow) return;
        // Store the widths for comparison
        prevOverflowContainerWidthRef.current = overflowContainer.offsetWidth;
        prevElementsWidthRef.current = {
            ...elementsWidthRef.current
        };
        setOverflowState((0, $5yCxu.calcOverflow)(overflowContainer, moreFilter, // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        renderedOverflowableItems, staticItems, elementsRef.current));
    }, [
        renderedOverflowableItems,
        staticItems
    ]);
    (0, $AOaWd.useResizeObserver)((0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up') ? overflowContainerUlRef : overflowContainerRef, onResize);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(!isOpen);
    }, [
        isOpen,
        setIsOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const triggerLabel = formatMessage((0, $7Hgp8.default).more);
    const triggerTooltipText = formatMessage((0, $7Hgp8.default).moreFiltersTooltip);
    const buttonToolTip = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: triggerTooltipText,
            hideTooltipOnClick: true,
            tag: "span"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerContainer, {
            "data-testid": "filters.common.ui.overflow-handler.trigger-container"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$TriggerLabel, null, triggerLabel), selectedOverflowItemsCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$BadgeContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $16T6Y.default), {
            appearance: "primary"
        }, selectedOverflowItemsCount)))), [
        selectedOverflowItemsCount,
        triggerTooltipText,
        triggerLabel
    ]);
    const content = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$PopupContainer, null, renderedOverflowableItems.map(({ id: id, renderer: renderer })=>Boolean(overflowableHideState[id]) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5uXOq.Fragment), {
                key: id
            }, renderer(true)))), [
        renderedOverflowableItems,
        overflowableHideState
    ]);
    const renderItems = (items)=>items.map(({ id: id, isStatic: isStatic, isHidden: isHidden = false, renderer: renderer })=>{
            const isItemHidden = isStatic ? isHidden : Boolean(overflowableHideState[id]);
            if ((0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up')) {
                const isLiElementHidden = elementsRef?.current?.[id]?.offsetWidth === 0;
                return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
                    key: id,
                    ref: (element)=>{
                        elementsRef.current[id] = element;
                        if (element) {
                            elementsWidthRef.current[id] = element.offsetWidth;
                            if (!isHidden) visibleElementsRef.current[id] = {
                                width: element.offsetWidth,
                                height: element.offsetHeight
                            };
                        }
                    },
                    // This ensures elements that do not occupy space are not announced/counted by screen readers
                    "aria-hidden": isItemHidden || isLiElementHidden,
                    className: (0, $bwpsq.default)([
                        isItemHidden || isLiElementHidden ? "_1o9zidpf _1f49cs5v _3um015vq _lcxvglyw _19pkidpf" : "_1o9zidpf _1f49kb7n _3um0ewfl _lcxv1wug _19pkidpf"
                    ])
                }, renderer(false));
            }
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
                key: id,
                innerRef: (element)=>{
                    elementsRef.current[id] = element;
                    if (element) {
                        elementsWidthRef.current[id] = element.offsetWidth;
                        if (!isHidden) visibleElementsRef.current[id] = {
                            width: element.offsetWidth,
                            height: element.offsetHeight
                        };
                    }
                },
                "aria-hidden": isItemHidden,
                isHidden: isItemHidden
            }, renderer(false));
        });
    const { isSoftwareFullTheming: isThemed } = (0, $a2e2Q.useSoftwareProjectTheming)();
    const ButtonComponent = isThemed ? (0, $22OQR.ThemedButton) : (0, $fVnbM.default);
    if ((0, $4R6GH.fg)('jfp_a11y_team_fix_filters_missing_list_mark_up')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("ul", {
        ref: overflowContainerUlRef,
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr" : "_1e0c1txw _1ul9idpf",
            "_qtt8glyw _ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19pkidpf"
        ])
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("li", {
        ref: moreFilterLiRef,
        "aria-hidden": isMoreDropdownHidden,
        className: (0, $bwpsq.default)([
            isMoreDropdownHidden ? "_1o9zidpf _1f49cs5v _3um015vq _lcxvglyw _19pkidpf" : "_1o9zidpf _1f49kb7n _3um0ewfl _lcxv1wug _19pkidpf",
            (0, $dCm1o.isVisualRefreshEnabled)() && "_2hwx1b66"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
                ...triggerProps,
                appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    label: "",
                    ...!(isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)()) && {
                        color: "var(--ds-icon, #44546F)"
                    }
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        ref: overflowContainerRef,
        className: (0, $bwpsq.default)([
            (0, $dCm1o.isVisualRefreshEnabled)() ? "_1e0c1txw _1ul9idpf _19pkidpf _2hwxr5cr _otyridpf _18u0r5cr" : "_1e0c1txw _1ul9idpf"
        ])
    }, renderItems(renderedItemsBefore), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($0aef8f88c53fc825$var$ItemWrapper, {
        innerRef: moreFilterRef,
        "aria-hidden": isMoreDropdownHidden,
        isHidden: isMoreDropdownHidden,
        shouldAddRightMargin: (0, $dCm1o.isVisualRefreshEnabled)()
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.Popup), {
        trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
                ...triggerProps,
                appearance: (0, $dCm1o.isVisualRefreshEnabled)() ? 'default' : 'subtle',
                isSelected: isOpen,
                iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))), {
                    label: "",
                    ...!(isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)()) && {
                        color: "var(--ds-icon, #44546F)"
                    }
                }),
                onClick: onClick
            }, buttonToolTip),
        shouldRenderToParent: true,
        shouldFlip: true,
        isOpen: isOpen,
        placement: "bottom-start",
        content: content,
        onClose: onClose
    })), renderItems(renderedItemsAfter));
};
var $0aef8f88c53fc825$export$2e2bcd8739ae039 = $0aef8f88c53fc825$var$OverflowHandler;
const $0aef8f88c53fc825$var$overflowContainerStylesOld = null;
const $0aef8f88c53fc825$var$overflowContainerStyles = null;
const $0aef8f88c53fc825$var$UlBoxStyles = null;
const $0aef8f88c53fc825$var$liItemHiddenStyles = null;
const $0aef8f88c53fc825$var$liItemVisibleStyles = null;
const $0aef8f88c53fc825$var$liItemWithRightMarginStyles = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$PopupContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1b66 _u5f3idpf _n3td1b66 _19bvidpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_o5721q9c",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$BadgeContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1o8l _19bv1b66",
            __cmplp.className
        ])
    });
});
const $0aef8f88c53fc825$var$ItemWrapperControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "sc-1krxkwp-0"
})((props)=>({
        flexShrink: 0,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        order: props.isHidden ? 2 : 1,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        visibility: props.isHidden ? 'hidden' : 'visible',
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
        pointerEvents: props.isHidden ? 'none' : 'auto'
    })); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $0aef8f88c53fc825$var$ItemWrapperExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isHidden: isHidden, shouldAddRightMargin: shouldAddRightMargin, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1vahmbr": (0, $lD23V.default)(__cmplp.shouldAddRightMargin && "var(--ds-space-050, 4px)")
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1o9zidpf _2hwx6yr2",
            __cmplp.isHidden ? "_1f49cs5v" : "_1f49kb7n",
            __cmplp.isHidden ? "_3um015vq" : "_3um0ewfl",
            __cmplp.isHidden ? "_lcxvglyw" : "_lcxv1wug",
            __cmplp.className
        ])
    });
});
const $0aef8f88c53fc825$var$ItemWrapper = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $0aef8f88c53fc825$var$ItemWrapperExperiment, $0aef8f88c53fc825$var$ItemWrapperControl);

});
parcelRegister("7Hgp8", function(module, exports) {

$parcel$export(module.exports, "default", () => $cea3021c9215d69b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cea3021c9215d69b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    more: {
        "id": "software-filters.common.overflow-handler.more",
        "defaultMessage": "More"
    },
    moreFiltersTooltip: {
        "id": "software-filters.common.overflow-handler.more-filters-tooltip",
        "defaultMessage": "More filters"
    }
});

});

parcelRegister("AOaWd", function(module, exports) {

$parcel$export(module.exports, "useResizeObserver", () => $d7fe9cd69e6a83c0$export$683480f191c0e3ea);

var $5uXOq = parcelRequire("5uXOq");
let $d7fe9cd69e6a83c0$var$resizeObserver;
const $d7fe9cd69e6a83c0$var$callbacks = new Map();
const $d7fe9cd69e6a83c0$var$runCallbacks = (entries)=>{
    entries.forEach((entry)=>{
        const { target: target } = entry;
        const callback = $d7fe9cd69e6a83c0$var$callbacks.get(target);
        callback?.(entry);
    });
};
const $d7fe9cd69e6a83c0$var$observeElement = (target, callback)=>{
    if (typeof ResizeObserver === 'undefined') return;
    if (!$d7fe9cd69e6a83c0$var$resizeObserver) $d7fe9cd69e6a83c0$var$resizeObserver = new ResizeObserver($d7fe9cd69e6a83c0$var$runCallbacks);
    $d7fe9cd69e6a83c0$var$callbacks.set(target, callback);
    $d7fe9cd69e6a83c0$var$resizeObserver.observe(target);
};
const $d7fe9cd69e6a83c0$var$unobserveElement = (target)=>{
    if (!$d7fe9cd69e6a83c0$var$resizeObserver) return;
    $d7fe9cd69e6a83c0$var$callbacks.delete(target);
    $d7fe9cd69e6a83c0$var$resizeObserver.unobserve(target);
};
const $d7fe9cd69e6a83c0$export$683480f191c0e3ea = (ref, callback)=>{
    (0, $5uXOq.useLayoutEffect)(()=>{
        const element = ref.current;
        element && $d7fe9cd69e6a83c0$var$observeElement(element, callback);
        return ()=>{
            element && $d7fe9cd69e6a83c0$var$unobserveElement(element);
        };
    }, [
        ref,
        callback
    ]);
};

});

parcelRegister("5yCxu", function(module, exports) {

$parcel$export(module.exports, "calcOverflow", () => $6dfc047016dbaaed$export$7128ab9dfe00f62e);
$parcel$export(module.exports, "getShouldRecomputeOverflow", () => $6dfc047016dbaaed$export$2544af09d06b9c65);
$parcel$export(module.exports, "getSelectedItemsCount", () => $6dfc047016dbaaed$export$b0e31612dc0df344);

var $gccSB = parcelRequire("gccSB");
const $6dfc047016dbaaed$export$1fed873882a661c5 = (items, itemElements, spaceLimit)=>{
    const hideState = {};
    let usedSpace = 0;
    let isOverflowingAssumed = false;
    items.forEach(({ id: id })=>{
        const element = itemElements[id];
        if (element) {
            const { offsetWidth: space } = element;
            if ((spaceLimit === undefined || usedSpace + space < spaceLimit) && !isOverflowingAssumed) usedSpace += space;
            else {
                if (!isOverflowingAssumed) isOverflowingAssumed = true;
                hideState[id] = true;
            }
        }
    });
    return {
        usedSpace: usedSpace,
        hideState: hideState
    };
};
const $6dfc047016dbaaed$export$7128ab9dfe00f62e = ({ offsetWidth: availableSpace }, { offsetWidth: moreFilterSpace }, renderedOverflowableItems, staticItems, itemElements)=>{
    const { usedSpace: staticSpace } = $6dfc047016dbaaed$export$1fed873882a661c5(staticItems, itemElements);
    const maxOverflowableSpace = renderedOverflowableItems.reduce((maxSpace, { id: id })=>maxSpace + (itemElements[id]?.offsetWidth ?? 0), 0);
    const isOverflowing = maxOverflowableSpace + staticSpace > availableSpace;
    let overflowableHideState = {};
    if (isOverflowing) {
        const spaceLimit = Math.max(availableSpace - moreFilterSpace - staticSpace, 0);
        const { hideState: hideState } = $6dfc047016dbaaed$export$1fed873882a661c5(renderedOverflowableItems, itemElements, spaceLimit);
        overflowableHideState = hideState;
    }
    return {
        overflowableHideState: overflowableHideState,
        isMoreDropdownHidden: !isOverflowing
    };
};
const $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD = 25; // Width of count badge
const $6dfc047016dbaaed$export$2544af09d06b9c65 = (prevContainerWidth, currContainerWidth, prevElementsWidthRef, currElementsWidthRef)=>{
    const currItemIds = Object.keys(currElementsWidthRef);
    const prevItemIds = Object.keys(prevElementsWidthRef);
    if (prevItemIds.length !== currItemIds.length || prevContainerWidth !== currContainerWidth) return true;
    const hasItemsWidthChange = currItemIds.some((id)=>prevElementsWidthRef[id] === undefined || Math.abs(prevElementsWidthRef[id] - currElementsWidthRef[id]) > $6dfc047016dbaaed$var$BADGE_WIDTH_THRESHOLD);
    return hasItemsWidthChange;
};
const $6dfc047016dbaaed$export$b0e31612dc0df344 = (itemsHiddenState, selectedItems)=>{
    if ((0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(selectedItems) || (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(itemsHiddenState)) return 0;
    return Object.entries(selectedItems).reduce((acc, [key, value])=>{
        if (value === undefined || itemsHiddenState[key] !== true) return acc;
        // selectedItem could be "any" value, if the value is not an Array, it will be counted as 1
        return Array.isArray(value) ? acc + value.length : acc + 1;
    }, 0);
};

});


parcelRegister("7j6PN", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bf5bd4e554fcb50$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $cTznA = parcelRequire("cTznA");
const $1bf5bd4e554fcb50$var$ComponentFilter = ({ components: components = [], selectedComponents: selectedComponents = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>components.map((component)=>({
                label: component.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(component.id)
            })), [
        components
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
            label: formatMessage((0, $cTznA.default).label),
            values: values,
            selectedValues: (0, $g5X3G.toStringArray)(selectedComponents),
            onChange: onChangeCallback,
            isNested: isNested,
            placeholder: formatMessage((0, $cTznA.default).placeholder)
        }), [
        formatMessage,
        onChangeCallback,
        selectedComponents,
        values,
        isNested
    ]);
};
var $1bf5bd4e554fcb50$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($1bf5bd4e554fcb50$var$ComponentFilter);

});
parcelRegister("cTznA", function(module, exports) {

$parcel$export(module.exports, "default", () => $798caf1923191bc1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $798caf1923191bc1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.component.label",
        "defaultMessage": "Components"
    },
    placeholder: {
        "id": "software-filters.filters.component.placeholder",
        "defaultMessage": "Search component filters..."
    }
});

});


parcelRegister("8bg0N", function(module, exports) {

$parcel$export(module.exports, "default", () => $6a3ccb8efb497741$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $1k18w = parcelRequire("1k18w");

var $kIDH3 = parcelRequire("kIDH3");
const $6a3ccb8efb497741$var$DependenciesFilter = ({ isOpen: isOpen = false, onChange: // only used for VR testing purposes
onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), selectedValues: selectedValues = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        onChange(entries.map(({ value: value })=>value));
    }, [
        onChange
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        label: formatMessage((0, $1k18w.default).label),
        onChange: onChangeValue,
        values: [
            {
                // Change label back to  formatMessage(messages.dependencyType) when adding
                // new filter by options such as cross-team and specific dependencies
                label: '',
                options: [
                    {
                        label: formatMessage((0, $1k18w.default).offTrack),
                        value: (0, $kIDH3.DependencyFilterOption).OFF_TRACK
                    },
                    {
                        label: formatMessage((0, $1k18w.default).onTrack),
                        value: (0, $kIDH3.DependencyFilterOption).ON_TRACK
                    }
                ]
            }
        ],
        selectedValues: selectedValues,
        placeholder: formatMessage((0, $1k18w.default).placeholder)
    });
};
$6a3ccb8efb497741$var$DependenciesFilter.displayName = 'DependenciesFilter';
$6a3ccb8efb497741$var$DependenciesFilter.whyDidYouRender = true;
var $6a3ccb8efb497741$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($6a3ccb8efb497741$var$DependenciesFilter);

});
parcelRegister("1k18w", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6bab5f988dfca5a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b6bab5f988dfca5a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.dependencies.label",
        "defaultMessage": "Dependencies"
    },
    placeholder: {
        "id": "software-filters.filters.dependencies.placeholder",
        "defaultMessage": "Search dependencies filters..."
    },
    dependencyType: {
        "id": "software-filters.filters.dependencies.dependency-type",
        "defaultMessage": "Dependency type"
    },
    offTrack: {
        "id": "software-filters.filters.dependencies.off-track",
        "defaultMessage": "Off-track"
    },
    onTrack: {
        "id": "software-filters.filters.dependencies.on-track",
        "defaultMessage": "On-track"
    }
});

});


parcelRegister("kgqZV", function(module, exports) {

$parcel$export(module.exports, "default", () => $089e7ae732d57721$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $4Xk2W = parcelRequire("4Xk2W");

var $8Rkzz = parcelRequire("8Rkzz");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $2Ywmz = parcelRequire("2Ywmz");

var $3uePO = parcelRequire("3uePO");

var $96s6B = parcelRequire("96s6B");

var $9vXUM = parcelRequire("9vXUM");

var $BZHAT = parcelRequire("BZHAT");
const $089e7ae732d57721$var$EMPTY_ARRAY = [];
const $089e7ae732d57721$var$GoalCustomOptionLabel = ({ label: label, value: value })=>{
    const goalContext = (0, $5uXOq.useContext)((0, $9vXUM.GoalFilterContext));
    const goalState = goalContext.goals[value]?.state;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.050",
        alignBlock: "center",
        alignInline: "start",
        grow: "fill"
    }, goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2Ywmz.GoalIcon), {
        state: goalState.value
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "span",
        xcss: $089e7ae732d57721$var$goalLabelStyles
    }, label), goalState && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3uePO.GoalTracker), {
        label: goalState.label,
        score: goalState.score,
        value: goalState.value
    }));
};
const $089e7ae732d57721$var$GoalFilter = ({ goals: goals, selectedGoals: selectedGoals = $089e7ae732d57721$var$EMPTY_ARRAY, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onInputChange: onInputChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onOpenChange: onOpenChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onMouseEnterToTriggerButton: onMouseEnterToTriggerButton = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty = false, inputValue: inputValue, isLoading: isLoading = false, isNested: isNested = false, isOpen: isOpen = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>goals.map((goal)=>({
                label: goal.name,
                value: goal.id,
                data: goal.state
            })), [
        goals
    ]);
    const goalsHash = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($4Xk2W)))(goals, (goal)=>goal.id), [
        goals
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vXUM.GoalFilterContext).Provider, {
        value: {
            goals: goalsHash
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $BZHAT.default).label),
        values: values,
        isOpen: isOpen,
        selectedValues: selectedGoals,
        isPanelToggleChecked: false,
        onChange: onChangeCallback,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $BZHAT.default).noGoals),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: false,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
        placeholder: formatMessage((0, $BZHAT.default).placeholder),
        CustomOptionLabel: $089e7ae732d57721$var$GoalCustomOptionLabel,
        showPanelToggle: false,
        showLink: false,
        useHrefForUrl: false,
        maxSelectionAllowed: Number.MAX_SAFE_INTEGER,
        onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onLinkItemClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        toggleRef: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    }));
};
var $089e7ae732d57721$export$2e2bcd8739ae039 = $089e7ae732d57721$var$GoalFilter;
const $089e7ae732d57721$var$goalLabelStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("2Ywmz", function(module, exports) {

$parcel$export(module.exports, "GoalIcon", () => $7be6a95607230c54$export$134cbcd70c6693b8);

var $5uXOq = parcelRequire("5uXOq");

var $5LWLA = parcelRequire("5LWLA");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $koVbs = parcelRequire("koVbs");

var $6yf6t = parcelRequire("6yf6t");

var $4UrMe = parcelRequire("4UrMe");
const $7be6a95607230c54$var$GoalGlyph = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        ...props,
        xmlns: "http://www.w3.org/2000/svg",
        width: "18",
        height: "18",
        viewBox: "0 0 18 18"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("g", {
        fill: "currentColor",
        fillRule: "evenodd"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16 9C16 12.866 12.866 16 9 16C5.13401 16 2 12.866 2 9C2 5.13401 5.13401 2 9 2C12.866 2 16 5.13401 16 9ZM18 9C18 13.9706 13.9706 18 9 18C4.02944 18 0 13.9706 0 9C0 4.02944 4.02944 0 9 0C13.9706 0 18 4.02944 18 9ZM11 9C11 10.1046 10.1046 11 9 11C7.89543 11 7 10.1046 7 9C7 7.89543 7.89543 7 9 7C10.1046 7 11 7.89543 11 9ZM13 9C13 11.2091 11.2091 13 9 13C6.79086 13 5 11.2091 5 9C5 6.79086 6.79086 5 9 5C11.2091 5 13 6.79086 13 9Z",
        fillRule: "evenodd"
    })));
const $7be6a95607230c54$export$134cbcd70c6693b8 = ({ state: state, ariaLabel: ariaLabel })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $7be6a95607230c54$var$iconContainerStyles,
        // eslint-disable-next-line jira/react/no-style-attribute
        style: {
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
            backgroundColor: (0, $6yf6t.mapStateToBgColor)(state)
        },
        "aria-label": ariaLabel
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5LWLA.default), {
        glyph: $7be6a95607230c54$var$GoalGlyph,
        label: formatMessage((0, $4UrMe.default).goalIconLabel),
        primaryColor: (0, $6yf6t.mapStateToColor)(state)
    }));
};
const $7be6a95607230c54$var$iconContainerStyles = (0, $8CUq3.xcss)({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '24px',
    minWidth: '24px',
    height: '24px',
    borderRadius: 'border.radius',
    marginRight: 'space.025'
});

});
parcelRegister("6yf6t", function(module, exports) {

$parcel$export(module.exports, "mapStateToBgColor", () => $6a435c3af325b8dc$export$931dac3fa53640b1);
$parcel$export(module.exports, "mapStateToColor", () => $6a435c3af325b8dc$export$163d1ee1b3b2aead);
$parcel$export(module.exports, "mapScoreToBgColor", () => $6a435c3af325b8dc$export$525ec0d5be9572a4);
$parcel$export(module.exports, "extractStatusLabelWithoutScore", () => $6a435c3af325b8dc$export$88bbcb3741dee92d);
const $6a435c3af325b8dc$export$931dac3fa53640b1 = (state)=>{
    switch(state){
        case 'off_track':
            return "var(--ds-background-accent-red-subtlest, #FFECEB)";
        case 'at_risk':
            return "var(--ds-background-accent-yellow-subtlest, #FFF7D6)";
        case 'on_track':
            return "var(--ds-background-accent-green-subtlest, #DCFFF1)";
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return "var(--ds-background-accent-gray-subtlest, #F1F2F4)";
    }
};
const $6a435c3af325b8dc$export$163d1ee1b3b2aead = (state)=>{
    switch(state){
        case 'off_track':
            return "var(--ds-text-accent-red, #AE2E24)";
        case 'at_risk':
            return "var(--ds-text-accent-orange, #A54800)";
        case 'on_track':
            return "var(--ds-text-accent-green, #216E4E)";
        case 'archived':
        case 'cancelled':
        case 'done':
        case 'paused':
        case 'pending':
        default:
            return "var(--ds-text-accent-gray, #44546F)";
    }
};
const $6a435c3af325b8dc$export$525ec0d5be9572a4 = (score)=>{
    if (score < 0.4) return "var(--ds-background-danger-bold, #C9372C)";
    if (score < 0.7) return "var(--ds-background-accent-orange-bolder, #C25100)";
    return "var(--ds-background-success-bold, #1F845A)";
};
const $6a435c3af325b8dc$export$88bbcb3741dee92d = (fullLabel)=>fullLabel.split(' - ')[0];

});

parcelRegister("4UrMe", function(module, exports) {

$parcel$export(module.exports, "default", () => $2ec31bd513378ade$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $2ec31bd513378ade$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    goalIconLabel: {
        "id": "software-goals.goal.icon.goal-icon-label",
        "defaultMessage": "Goal"
    }
});

});


parcelRegister("3uePO", function(module, exports) {

$parcel$export(module.exports, "GoalTracker", () => $ec22661ff8271891$export$c0fdf469f92e8578);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6yf6t = parcelRequire("6yf6t");

var $aabh6 = parcelRequire("aabh6");
const $ec22661ff8271891$export$c0fdf469f92e8578 = ({ value: value, label: label, score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ec22661ff8271891$var$Tracker, {
        backgroundColor: (0, $6yf6t.mapStateToBgColor)(value),
        color: (0, $6yf6t.mapStateToColor)(value)
    }, (0, $6yf6t.extractStatusLabelWithoutScore)(label), score !== undefined && score !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aabh6.Score), {
        score: score
    }));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $ec22661ff8271891$var$Tracker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor),
            "--_xexnhp": (0, $lD23V.default)(__cmplp.color)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _11c81o8v _3fcw1q9c _bfhk3qkl _ca0q1b66 _u5f31b66 _n3td1b66 _19bv1b66 _k48pmoej _syaz1cj8 _1p1dangw _1e0c1ule _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});
parcelRegister("aabh6", function(module, exports) {

$parcel$export(module.exports, "Score", () => $08dbd54fe256bc26$export$6735cf84ecd2736);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $6yf6t = parcelRequire("6yf6t");
const $08dbd54fe256bc26$export$6735cf84ecd2736 = ({ score: score })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($08dbd54fe256bc26$var$ScoreContainer, {
        backgroundColor: (0, $6yf6t.mapScoreToBgColor)(score)
    }, score);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $08dbd54fe256bc26$var$ScoreContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { backgroundColor: backgroundColor, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_1hphqkz": (0, $lD23V.default)(__cmplp.backgroundColor)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1l7b _1e0c116y _bfhk3qkl _syaz15cr _18u01b66 _ca0qidpf _u5f31b66 _n3tdidpf _19bv1b66 _4t3i7vkz",
            __cmplp.className
        ])
    });
});

});


parcelRegister("9vXUM", function(module, exports) {

$parcel$export(module.exports, "GoalFilterContext", () => $c20e77c82f0ed08e$export$f656d92d95229cd2);

var $5uXOq = parcelRequire("5uXOq");
const $c20e77c82f0ed08e$export$f656d92d95229cd2 = /*#__PURE__*/ (0, $5uXOq.createContext)({
    goals: {}
});

});

parcelRegister("BZHAT", function(module, exports) {

$parcel$export(module.exports, "default", () => $dfb7fe3166051b6f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $dfb7fe3166051b6f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noGoals: {
        "id": "software-filters.filters.goals.no-goals",
        "defaultMessage": "There are no matching goals"
    },
    placeholder: {
        "id": "software-filters.filters.goals.placeholder",
        "defaultMessage": "Choose goals"
    },
    label: {
        "id": "software-filters.filters.goals.label",
        "defaultMessage": "Goals"
    }
});

});


parcelRegister("efv79", function(module, exports) {

$parcel$export(module.exports, "default", () => $7e07b1cd691dec67$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $4c4ZP = parcelRequire("4c4ZP");
const $7e07b1cd691dec67$var$IssueProjectFilter = ({ isOpen: isOpen = false, isNested: // only used for VR testing purposes
isNested = false, issueProjects: issueProjects = {}, onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), selectedProjects: selectedProjects = [] })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>Object.values(issueProjects).map(({ avatar: avatar, id: id, name: name })=>({
                iconUrl: avatar,
                label: name,
                value: String(id)
            })).sort((a, b)=>a.label.localeCompare(b.label)), [
        issueProjects
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toProjectId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        isNested: isNested,
        label: formatMessage((0, $4c4ZP.default).label),
        onChange: onChangeValue,
        selectedValues: selectedProjects.map(String),
        values: values,
        placeholder: formatMessage((0, $4c4ZP.default).placeholder)
    });
};
$7e07b1cd691dec67$var$IssueProjectFilter.displayName = 'IssueProjectFilter';
$7e07b1cd691dec67$var$IssueProjectFilter.whyDidYouRender = true;
var $7e07b1cd691dec67$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($7e07b1cd691dec67$var$IssueProjectFilter);

});
parcelRegister("4c4ZP", function(module, exports) {

$parcel$export(module.exports, "default", () => $01676d3e9ff29bbf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $01676d3e9ff29bbf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-project.label",
        "defaultMessage": "Project"
    },
    placeholder: {
        "id": "software-filters.filters.issue-project.placeholder",
        "defaultMessage": "Search project filters..."
    }
});

});


parcelRegister("jKPI1", function(module, exports) {

$parcel$export(module.exports, "default", () => $6442616aa336213b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $hF6jn = parcelRequire("hF6jn");
const $6442616aa336213b$var$IssueTypeGroupFilter = ({ isOpen: isOpen = false, issueTypeGroups: issueTypeGroups = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const issueTypeGroupByIssueType = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.flatMap((group)=>group.issueTypes.map((issueType)=>[
                    issueType,
                    group
                ]))), [
        issueTypeGroups
    ]);
    const issueTypeGroupByGroupKey = (0, $5uXOq.useMemo)(()=>new Map(issueTypeGroups.map((group)=>[
                group.key,
                group
            ])), [
        issueTypeGroups
    ]);
    const values = (0, $5uXOq.useMemo)(()=>issueTypeGroups.map((group)=>({
                label: group.name,
                value: group.key,
                iconUrl: group.iconUrl
            })), [
        issueTypeGroups
    ]);
    const selectGroupsByKeys = (0, $5uXOq.useCallback)((keys)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(keys.flatMap((key)=>issueTypeGroupByGroupKey.get(key)?.issueTypes).filter(Boolean), analyticAttributes);
    }, [
        onChange,
        issueTypeGroupByGroupKey,
        isNested
    ]);
    const selectedGroups = (0, $5uXOq.useMemo)(()=>Array.from(new Set(selectedIssueTypes.map((key)=>issueTypeGroupByIssueType.get(key)))), [
        issueTypeGroupByIssueType,
        selectedIssueTypes
    ]);
    const selectedGroupKeys = selectedGroups.map((group)=>group?.key).filter(Boolean);
    const selectedGroupsAllIssueTypes = selectedGroups.flatMap((group)=>group?.issueTypes).filter(Boolean);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const entryValues = entries.map(({ value: value })=>value);
        selectGroupsByKeys(entryValues);
    }, [
        selectGroupsByKeys
    ]);
    // early exit if we have only one issue type group
    if (issueTypeGroups.length <= 1) return null;
    // if there's mismatch between the filters in the url and the issue groups, e.g. when the url is manually edited or when an issue of a new type is created, we would apply the whole group
    if (selectedGroupsAllIssueTypes.length !== selectedIssueTypes.length) {
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(selectedGroupsAllIssueTypes, analyticAttributes);
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        isOpen: isOpen,
        label: formatMessage((0, $hF6jn.default).label),
        values: values,
        selectedValues: selectedGroupKeys,
        onChange: onChangeCallback,
        isNested: isNested,
        placeholder: formatMessage((0, $hF6jn.default).placeholder)
    });
};
$6442616aa336213b$var$IssueTypeGroupFilter.displayName = 'IssueTypeGroupFilter';
$6442616aa336213b$var$IssueTypeGroupFilter.whyDidYouRender = true;
var $6442616aa336213b$export$2e2bcd8739ae039 = $6442616aa336213b$var$IssueTypeGroupFilter;

});
parcelRegister("hF6jn", function(module, exports) {

$parcel$export(module.exports, "default", () => $1d157749564d70c9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $1d157749564d70c9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type-group.label",
        "defaultMessage": "Type"
    },
    placeholder: {
        "id": "software-filters.filters.issue-type-group.placeholder",
        "defaultMessage": "Search type filters..."
    }
});

});


parcelRegister("hHL6f", function(module, exports) {

$parcel$export(module.exports, "default", () => $2b5fa2dd02736e8c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $lcsGW = parcelRequire("lcsGW");
const $2b5fa2dd02736e8c$var$IssueTypeFilter = ({ issueTypes: issueTypes = [], selectedIssueTypes: selectedIssueTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>issueTypes.map((issueType)=>({
                label: issueType.name,
                value: issueType.id,
                iconUrl: issueType.iconUrl
            })), [
        issueTypes
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>(0, $g5X3G.toIssueTypeId)(entry.value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one issue type
    if (issueTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $lcsGW.default).label),
        values: values,
        selectedValues: selectedIssueTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested,
        placeholder: formatMessage((0, $lcsGW.default).placeholder)
    });
};
const $2b5fa2dd02736e8c$var$IssueTypeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($2b5fa2dd02736e8c$var$IssueTypeFilter);
$2b5fa2dd02736e8c$var$IssueTypeFilterComponent.displayName = 'IssueTypeFilter';
// @ts-expect-error TS2339: Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$2b5fa2dd02736e8c$var$IssueTypeFilterComponent.whyDidYouRender = true;
var $2b5fa2dd02736e8c$export$2e2bcd8739ae039 = $2b5fa2dd02736e8c$var$IssueTypeFilterComponent;

});
parcelRegister("lcsGW", function(module, exports) {

$parcel$export(module.exports, "default", () => $418d852f97677c87$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $418d852f97677c87$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.issue-type.label",
        "defaultMessage": "Type"
    },
    placeholder: {
        "id": "software-filters.filters.issue-type.placeholder",
        "defaultMessage": "Search type filters..."
    }
});

});


parcelRegister("2fsdj", function(module, exports) {

$parcel$export(module.exports, "default", () => $2f5c968fce1f630e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $bvI90 = parcelRequire("bvI90");
const $2f5c968fce1f630e$var$LabelFilter = ({ labels: labels = [], selectedLabels: selectedLabels = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false, unassignedOption: unassignedOption })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>{
        const options = labels.map((label)=>({
                label: label,
                value: label
            }));
        unassignedOption && options.unshift(unassignedOption);
        return options;
    }, [
        labels,
        unassignedOption
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $bvI90.default).label),
        values: values,
        selectedValues: selectedLabels,
        onChange: onChangeMapValues,
        isNested: isNested,
        placeholder: formatMessage((0, $bvI90.default).placeholder)
    });
};
const $2f5c968fce1f630e$var$LabelFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($2f5c968fce1f630e$var$LabelFilter);
$2f5c968fce1f630e$var$LabelFilterComponent.displayName = 'LabelFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$2f5c968fce1f630e$var$LabelFilterComponent.whyDidYouRender = true;
var $2f5c968fce1f630e$export$2e2bcd8739ae039 = $2f5c968fce1f630e$var$LabelFilterComponent;

});
parcelRegister("bvI90", function(module, exports) {

$parcel$export(module.exports, "default", () => $7299efb383111469$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7299efb383111469$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.label.label",
        "defaultMessage": "Label"
    },
    placeholder: {
        "id": "software-filters.filters.label.placeholder",
        "defaultMessage": "Search label filters..."
    }
});

});


parcelRegister("bLWKp", function(module, exports) {

$parcel$export(module.exports, "default", () => $31db5ca9c486657a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $az4zD = parcelRequire("az4zD");

var $iXVV6 = parcelRequire("iXVV6");

var $g5X3G = parcelRequire("g5X3G");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $bmKPg = parcelRequire("bmKPg");

var $96s6B = parcelRequire("96s6B");

var $9oo3F = parcelRequire("9oo3F");
const $31db5ca9c486657a$var$ParentFilter = (props)=>{
    const { label: label, parents: parents, selectedParents: selectedParents, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, onInputChange: onInputChange, onOpenChange: onOpenChange, onMouseEnterToTriggerButton: onMouseEnterToTriggerButton, intl: { formatMessage: formatMessage }, showPanelToggle: showPanelToggle, showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty, inputValue: inputValue, isLoading: isLoading, isAsyncSearch: isAsyncSearch, isNested: isNested, isOpen: isOpen } = props;
    const [boardId] = (0, $bmKPg.usePathParam)('boardId');
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const values = (0, $5uXOq.useMemo)(()=>parents.map((parent)=>({
                label: parent.name,
                value: parent.id,
                subLabel: parent.key
            })), [
        parents
    ]);
    const onChange = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map((entry)=>(0, $g5X3G.toIssueId)(entry.value)), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $9pP0g.ViewSetting).EPIC_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "epicPanelToggle",
        attributes: {
            isOpen: !isToggleChecked,
            filterType: label
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: label,
        toggleLabel: formatMessage((0, $9oo3F.default).toggleLabel, {
            parentName: label?.toLowerCase()
        }),
        values: values,
        isOpen: isOpen,
        showPanelToggle: showPanelToggle,
        selectedValues: selectedParents.map(String),
        isPanelToggleChecked: isToggleChecked,
        onChange: onChange,
        inputValue: inputValue,
        isLoading: isLoading,
        onInputChange: onInputChange,
        onTogglePanel: handleTogglePanel,
        onOpenChange: onOpenChange,
        noOptionsMessage: formatMessage((0, $9oo3F.default).noParentIssues, {
            parentName: label
        }),
        showMenuIfValuesAreEmpty: showMenuIfValuesAreEmpty,
        isAsyncSearch: isAsyncSearch,
        isNested: isNested,
        onMouseEnterToTriggerButton: onMouseEnterToTriggerButton,
        placeholder: formatMessage((0, $9oo3F.default).placeholder, {
            parentName: label
        }),
        shouldCloseMenuOnTab: showPanelToggle ? false : undefined
    }));
};
$31db5ca9c486657a$var$ParentFilter.defaultProps = {
    selectedParents: [],
    isToggleChecked: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onInputChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    showPanelToggle: false,
    showMenuIfValuesAreEmpty: false,
    isLoading: false,
    isAsyncSearch: false,
    isNested: false
};
var $31db5ca9c486657a$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($31db5ca9c486657a$var$ParentFilter);

});
parcelRegister("9oo3F", function(module, exports) {

$parcel$export(module.exports, "default", () => $9506229386ae6ee1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9506229386ae6ee1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noParentIssues: {
        "id": "software-filters.filters.parent.no-parent-issues",
        "defaultMessage": "Your project has no {parentName}"
    },
    toggleLabel: {
        "id": "software-filters.filters.parent.toggle-label",
        "defaultMessage": "Show {parentName} panel"
    },
    placeholder: {
        "id": "software-filters.filters.parent.placeholder",
        "defaultMessage": "Search {parentName} filters..."
    }
});

});


parcelRegister("hpA0D", function(module, exports) {

$parcel$export(module.exports, "default", () => $779f77cd70091738$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aWse0 = parcelRequire("aWse0");

var $96s6B = parcelRequire("96s6B");

var $6DAJ4 = parcelRequire("6DAJ4");
const $779f77cd70091738$var$MAX_SELECTION_ALLOWED = 10;
const $779f77cd70091738$var$QuickFilter = ({ filters: filters = [], selectedFilters: selectedFilters = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const values = (0, $5uXOq.useMemo)(()=>filters.map((filter)=>({
                label: filter.name,
                value: filter.id
            })), [
        filters
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    const maxSelectionReachedTooltip = formatMessage((0, $6DAJ4.default).maxSelectionReachedTooltip, {
        maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $6DAJ4.default).label),
        values: values,
        selectedValues: selectedFilters,
        onChange: onChangeMapValues,
        maxSelectionAllowed: $779f77cd70091738$var$MAX_SELECTION_ALLOWED,
        maxSelectionReachedTooltip: maxSelectionReachedTooltip,
        isNested: isNested,
        placeholder: formatMessage((0, $6DAJ4.default).placeholder)
    });
};
const $779f77cd70091738$var$QuickFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($779f77cd70091738$var$QuickFilter);
$779f77cd70091738$var$QuickFilterComponent.displayName = 'QuickFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$779f77cd70091738$var$QuickFilterComponent.whyDidYouRender = true;
var $779f77cd70091738$export$2e2bcd8739ae039 = $779f77cd70091738$var$QuickFilterComponent;

});
parcelRegister("6DAJ4", function(module, exports) {

$parcel$export(module.exports, "default", () => $28d3824050b576c4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $28d3824050b576c4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.quick.label",
        "defaultMessage": "Quick filters"
    },
    placeholder: {
        "id": "software-filters.filters.quick.placeholder",
        "defaultMessage": "Search quick filters..."
    },
    maxSelectionReachedTooltip: {
        "id": "software-filters.filters.quick.max-selection-reached-tooltip",
        "defaultMessage": "You can't select more than {maxSelectionAllowed, plural, one {# quick filter} other {# quick filters}}"
    }
});

});


parcelRegister("g65Ek", function(module, exports) {

$parcel$export(module.exports, "default", () => $ccc78a455db68a11$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $96s6B = parcelRequire("96s6B");

var $e0XMB = parcelRequire("e0XMB");
const $ccc78a455db68a11$var$RequestTypeFilter = ({ requestTypes: requestTypes = [], selectedRequestTypes: selectedRequestTypes = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>requestTypes.map((requestType)=>({
                label: requestType.name,
                value: requestType.id,
                iconUrl: requestType.iconUrl
            })), [
        requestTypes
    ]);
    const onChangeCallback = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (requestTypes.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $e0XMB.default).label),
        values: values,
        selectedValues: selectedRequestTypes.map(String),
        onChange: onChangeCallback,
        isNested: isNested,
        placeholder: formatMessage((0, $e0XMB.default).placeholder)
    });
};
const $ccc78a455db68a11$var$RequestTypeFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($ccc78a455db68a11$var$RequestTypeFilter);
$ccc78a455db68a11$var$RequestTypeFilterComponent.displayName = 'RequestTypeFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$ccc78a455db68a11$var$RequestTypeFilterComponent.whyDidYouRender = true;
var $ccc78a455db68a11$export$2e2bcd8739ae039 = $ccc78a455db68a11$var$RequestTypeFilterComponent;

});
parcelRegister("e0XMB", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c7eddbc8ad682f0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c7eddbc8ad682f0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.request-type.label",
        "defaultMessage": "Request type"
    },
    placeholder: {
        "id": "software-filters.filters.request-type.placeholder",
        "defaultMessage": "Search request type filters..."
    }
});

});


parcelRegister("jdA4J", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6cedc5f723f1df5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $96s6B = parcelRequire("96s6B");

var $6TH6s = parcelRequire("6TH6s");
const $b6cedc5f723f1df5$var$SprintFilter = ({ sprints: sprints = [], selectedSprints: selectedSprints = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'sprintFilter rendered', {
            numberOfSprints: sprints.length
        });
    }, [
        createAnalyticsEvent,
        sprints
    ]);
    const values = (0, $5uXOq.useMemo)(()=>sprints.map((sprint)=>({
                label: sprint.name,
                value: sprint.id.toString()
            })), [
        sprints
    ]);
    const onChangeMapValues = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map((entry)=>entry.value), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $6TH6s.default).label),
        values: values,
        selectedValues: selectedSprints,
        onChange: onChangeMapValues,
        isNested: isNested,
        placeholder: formatMessage((0, $6TH6s.default).placeholder)
    });
};
const $b6cedc5f723f1df5$var$SprintFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($b6cedc5f723f1df5$var$SprintFilter);
$b6cedc5f723f1df5$var$SprintFilterComponent.displayName = 'SprintFilter';
var $b6cedc5f723f1df5$export$2e2bcd8739ae039 = $b6cedc5f723f1df5$var$SprintFilterComponent;

});
parcelRegister("6TH6s", function(module, exports) {

$parcel$export(module.exports, "default", () => $a136882e810c6f5b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $a136882e810c6f5b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.sprint.label",
        "defaultMessage": "Sprint"
    },
    placeholder: {
        "id": "software-filters.filters.sprint.placeholder",
        "defaultMessage": "Search sprint filters..."
    }
});

});


parcelRegister("cSFZv", function(module, exports) {

$parcel$export(module.exports, "default", () => $746f8d9f8aa82396$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $aWse0 = parcelRequire("aWse0");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $5qiVm = parcelRequire("5qiVm");
const $746f8d9f8aa82396$var$StatusCategoryFilter = ({ statusCategories: statusCategories = [], selectedStatusCategories: selectedStatusCategories = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $aWse0.useIntlV2)();
    const values = (0, $5uXOq.useMemo)(()=>statusCategories.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statusCategories
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toIssueStatusCategoryId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $5qiVm.default).label),
        values: values,
        selectedValues: selectedStatusCategories.map(String),
        onChange: onChangeValue,
        isNested: isNested,
        placeholder: formatMessage((0, $5qiVm.default).placeholder)
    });
};
const $746f8d9f8aa82396$var$StatusCategoryFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($746f8d9f8aa82396$var$StatusCategoryFilter);
$746f8d9f8aa82396$var$StatusCategoryFilterComponent.displayName = 'StatusCategoryFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$746f8d9f8aa82396$var$StatusCategoryFilterComponent.whyDidYouRender = true;
var $746f8d9f8aa82396$export$2e2bcd8739ae039 = $746f8d9f8aa82396$var$StatusCategoryFilterComponent;

});
parcelRegister("5qiVm", function(module, exports) {

$parcel$export(module.exports, "default", () => $16c5f1e62f5bac0b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $16c5f1e62f5bac0b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.status-category.label",
        "defaultMessage": "Status category"
    },
    placeholder: {
        "id": "software-filters.filters.status-category.placeholder",
        "defaultMessage": "Search status category filters..."
    }
});

});


parcelRegister("3f9TT", function(module, exports) {

$parcel$export(module.exports, "default", () => $45ecaaab2e5e2a52$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $koVbs = parcelRequire("koVbs");

var $g5X3G = parcelRequire("g5X3G");

var $96s6B = parcelRequire("96s6B");

var $33ioU = parcelRequire("33ioU");
const $45ecaaab2e5e2a52$var$StatusFilter = ({ statuses: statuses = [], selectedStatuses: selectedStatuses = [], onChange: onChange = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), isNested: isNested = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const values = (0, $5uXOq.useMemo)(()=>statuses.map(({ id: id, name: name })=>({
                label: name,
                value: id
            })), [
        statuses
    ]);
    const onChangeValue = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        onChange(entries.map(({ value: value })=>(0, $g5X3G.toIssueStatusId)(value)), analyticAttributes);
    }, [
        onChange,
        isNested
    ]);
    // early exit if we have only one option
    if (values.length <= 1) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
        label: formatMessage((0, $33ioU.default).label),
        values: values,
        selectedValues: selectedStatuses.map(String),
        onChange: onChangeValue,
        isNested: isNested,
        placeholder: formatMessage((0, $33ioU.default).placeholder)
    });
};
const $45ecaaab2e5e2a52$var$StatusFilterComponent = /*#__PURE__*/ (0, $5uXOq.memo)($45ecaaab2e5e2a52$var$StatusFilter);
$45ecaaab2e5e2a52$var$StatusFilterComponent.displayName = 'StatusFilter';
// @ts-expect-error - TS2339 - Property 'whyDidYouRender' does not exist on type 'NamedExoticComponent<Props>'.
$45ecaaab2e5e2a52$var$StatusFilterComponent.whyDidYouRender = true;
var $45ecaaab2e5e2a52$export$2e2bcd8739ae039 = $45ecaaab2e5e2a52$var$StatusFilterComponent;

});
parcelRegister("33ioU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ee3eff355f28d572$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ee3eff355f28d572$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    label: {
        "id": "software-filters.filters.status.label",
        "defaultMessage": "Status"
    },
    placeholder: {
        "id": "software-filters.filters.status.placeholder",
        "defaultMessage": "Search status filters..."
    }
});

});


parcelRegister("aMFc7", function(module, exports) {

$parcel$export(module.exports, "default", () => $119ce63ee3cabcee$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $b71gk = parcelRequire("b71gk");

var $7iJwP = parcelRequire("7iJwP");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $g5X3G = parcelRequire("g5X3G");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $bmKPg = parcelRequire("bmKPg");

var $96s6B = parcelRequire("96s6B");

var $gfbKZ = parcelRequire("gfbKZ");
const $119ce63ee3cabcee$var$VersionFilter = (props)=>{
    const { versions: versions, selectedVersions: selectedVersions, isToggleChecked: isToggleChecked, onTogglePanel: onTogglePanel, isSpotlightEnabled: isSpotlightEnabled, showPanelToggle: showPanelToggle, isNested: isNested, toggleRef: toggleRef, hasMultipleProjects: hasMultipleProjects, isLoading: isLoading } = props;
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const [boardId] = (0, $bmKPg.usePathParam)('boardId');
    const values = (0, $5uXOq.useMemo)(()=>versions.map((version)=>({
                label: version.name,
                // Casting to string normalises the id that may potentially be a number.
                value: String(version.id),
                subLabel: hasMultipleProjects ? version.projectKey : undefined
            })), [
        versions,
        hasMultipleProjects
    ]);
    const onChange = (0, $5uXOq.useCallback)((entries)=>{
        const analyticAttributes = {
            isNested: isNested
        };
        props.onChange(entries.map(({ value: value })=>value), analyticAttributes);
    }, [
        props,
        isNested
    ]);
    const handleTogglePanel = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            setting: (0, $9pP0g.ViewSetting).VERSION_PANEL
        });
        onTogglePanel();
    }, [
        boardId,
        onTogglePanel,
        toggleViewSetting
    ]);
    const renderContent = (0, $5uXOq.useMemo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $96s6B.default), {
            label: formatMessage((0, $gfbKZ.default).label),
            toggleLabel: formatMessage((0, $gfbKZ.default).toggleLabel),
            values: values,
            showPanelToggle: showPanelToggle,
            selectedValues: (0, $g5X3G.toStringArray)(selectedVersions),
            isPanelToggleChecked: isToggleChecked,
            onChange: onChange,
            onTogglePanel: handleTogglePanel,
            noOptionsMessage: formatMessage(values.length === 0 ? (0, $gfbKZ.default).noUnreleasedVersions : (0, $gfbKZ.default).noMatchingVersions),
            showMenuIfValuesAreEmpty: true,
            isNested: isNested,
            toggleRef: toggleRef,
            isLoading: isLoading,
            placeholder: formatMessage((0, $gfbKZ.default).placeholder),
            shouldCloseMenuOnTab: showPanelToggle ? false : undefined
        }), [
        formatMessage,
        values,
        showPanelToggle,
        selectedVersions,
        isToggleChecked,
        onChange,
        isNested,
        toggleRef,
        handleTogglePanel,
        isLoading
    ]);
    if (isSpotlightEnabled) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "fusionBacklogVersionsPanel"
    }, renderContent, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        engagementId: "fusionBacklogVersionsPanel"
    })));
    return renderContent;
};
$119ce63ee3cabcee$var$VersionFilter.displayName = 'VersionFilter';
$119ce63ee3cabcee$var$VersionFilter.whyDidYouRender = true;
const $119ce63ee3cabcee$var$ErrorWrapper = (props)=>{
    if (!props.isVersionsFeatureEnabled) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7iJwP.default), {
        id: "jira.backlog.version.filter",
        packageName: "jiraFilters"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a),
        sourceName: "versionFilter",
        attributes: {
            isVersionPanelOpen: props.isToggleChecked
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($119ce63ee3cabcee$var$VersionFilter, props), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
};
$119ce63ee3cabcee$var$ErrorWrapper.defaultProps = {
    versions: [],
    selectedVersions: [],
    isToggleChecked: false,
    isSpotlightEnabled: false,
    showPanelToggle: true,
    isVersionsFeatureEnabled: false,
    onChange: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    onTogglePanel: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isNested: false
};
var $119ce63ee3cabcee$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($119ce63ee3cabcee$var$ErrorWrapper);

});
parcelRegister("gfbKZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $3f065e16be4d58f9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3f065e16be4d58f9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    noUnreleasedVersions: {
        "id": "software-filters.filters.version.no-unreleased-versions",
        "defaultMessage": "No unreleased versions in this project"
    },
    noMatchingVersions: {
        "id": "software-filters.filters.version.no-matching-versions",
        "defaultMessage": "No matching versions"
    },
    label: {
        "id": "software-filters.filters.version.label",
        "defaultMessage": "Version"
    },
    placeholder: {
        "id": "software-filters.filters.version.placeholder",
        "defaultMessage": "Search version filters..."
    },
    toggleLabel: {
        "id": "software-filters.filters.version.toggle-label",
        "defaultMessage": "Show version panel"
    }
});

});


parcelRegister("fJnmW", function(module, exports) {

$parcel$export(module.exports, "FilterBar", () => $fcc1c800bf761f9d$export$56a20ec2552ffba2);
$parcel$export(module.exports, "ListFilterContainerNextGen", () => $fcc1c800bf761f9d$export$4a72bd88f9845459);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $7XYc4 = parcelRequire("7XYc4");

var $dCm1o = parcelRequire("dCm1o");
const $fcc1c800bf761f9d$export$9ea8cdcfa806101a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$35dfe29d505ceb8f = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _kqswh2mm _4cvr1h6o _1ul9idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$56a20ec2552ffba2 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fcc1c800bf761f9d$export$35dfe29d505ceb8f, $fcc1c800bf761f9d$export$9ea8cdcfa806101a);
const $fcc1c800bf761f9d$export$847557029097218a = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1hftutpp _1uf81b66 _1o94h2mm _79vbb3bt _lpsrstnw _9uwn1ssb _41sd7vkz _be5h1i34 _4amot94y _1omzidpf _rhj9dh45",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$6fe98dc7be67e1c2 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1hftv77o _1uf81b66 _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$595be9b8d0603674 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jx1txw _1o94h2mm _yj55idpf",
            __cmplp.className
        ])
    });
});
const $fcc1c800bf761f9d$export$4a72bd88f9845459 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $fcc1c800bf761f9d$export$595be9b8d0603674, $fcc1c800bf761f9d$export$6fe98dc7be67e1c2);

});

parcelRegister("cTi8P", function(module, exports) {

$parcel$export(module.exports, "default", () => $e898d158ecdd3c47$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $4mO32 = parcelRequire("4mO32");

var $4jAPy = parcelRequire("4jAPy");

var $3Qsxg = parcelRequire("3Qsxg");
const $e898d158ecdd3c47$var$AsyncBoardSwitcher = (props)=>{
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $3Qsxg.syncBoardSwitcher), {});
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        entryPointActions.load();
        return ()=>{
            entryPointActions.unload();
        };
    }, [
        entryPointActions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "plan-increment-board-switcher",
        packageName: (0, $4jAPy.PACKAGE_NAME),
        teamName: (0, $4jAPy.ERROR_REPORTING_TEAM),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};
var $e898d158ecdd3c47$export$2e2bcd8739ae039 = $e898d158ecdd3c47$var$AsyncBoardSwitcher;

});
parcelRegister("3Qsxg", function(module, exports) {

$parcel$export(module.exports, "syncBoardSwitcher", () => $afceff36abed190f$export$e13b401cdb60e3ed);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $afceff36abed190f$export$e13b401cdb60e3ed = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>Promise.resolve((parcelRequire("2C9Uz"))).then((module)=>module.AsyncBoardSwitcher), {
        moduleId: "2623f17b"
    }),
    getPreloadProps: ()=>({})
});

});


parcelRegister("cM4EP", function(module, exports) {

$parcel$export(module.exports, "default", () => $93fab47741ff1022$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $i2Rm5 = parcelRequire("i2Rm5");

var $kobfu = parcelRequire("kobfu");

var $fZneA = parcelRequire("fZneA");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");
var $5oFIy = parcelRequire("5oFIy");
var $2NMNM = parcelRequire("2NMNM");

var $5a0Nh = parcelRequire("5a0Nh");

var $7Oku1 = parcelRequire("7Oku1");
class $93fab47741ff1022$export$876b3e4acf4df22c extends (0, $5uXOq.Component) {
    static{
        this.getDerivedStateFromError = (error)=>({
                error: error,
                isRelayValidationError: (0, $7Oku1.isRelayValidationError)(error)
            });
    }
    static getDerivedStateFromProps({ customFiltersQueryRef: customFiltersQueryRef }, state) {
        if (state.error && !state.aggErrors && customFiltersQueryRef) {
            const capturedGQLErrorsInfo = (0, $5a0Nh.stopCaptureGraphQlErrors)(customFiltersQueryRef.fetchKey.toString());
            const validGQLErrorsInfo = capturedGQLErrorsInfo.find((err)=>err.meta.operationName === customFiltersQueryRef.name);
            if (validGQLErrorsInfo?.errors.length) return {
                ...state,
                aggErrors: validGQLErrorsInfo.errors,
                aggErrorsMeta: validGQLErrorsInfo.meta
            };
        }
        return null;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null,
            aggErrors: null,
            aggErrorsMeta: null,
            isRelayValidationError: false
        };
    }
    getCommonErrorAttributes(error) {
        return {
            task: 'loadCustomFilters',
            screenName: this.props.screenName,
            isNetworkError: false,
            isRelayValidationError: this.state.isRelayValidationError,
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message,
            stack: error.stack
        };
    }
    render() {
        const { error: error, aggErrors: aggErrors, aggErrorsMeta: aggErrorsMeta, isRelayValidationError: isRelayValidationError } = this.state;
        const { children: children } = this.props;
        if (!error) return children;
        if (aggErrors?.length) {
            const aggError = new (0, $7Oku1.AGGErrors)(aggErrors, aggErrorsMeta?.requestId);
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
                eventName: "ui taskFail",
                attributes: {
                    traceId: aggError.traceId,
                    statusCode: aggError.statusCode,
                    ...this.getCommonErrorAttributes(aggError)
                }
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
                id: "custom-filter-dropdown",
                error: aggError
            }));
        }
        if (isRelayValidationError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireOperationalAnalytics), {
            eventName: "ui taskFail",
            attributes: {
                ...this.getCommonErrorAttributes(error)
            }
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i2Rm5.ErrorFlagRenderer), {
            id: "custom-filter-dropdown",
            error: error
        }));
        // If this isn't an AGG or Relay error, let the upper error boundary handle it
        throw error;
    }
}
const $93fab47741ff1022$var$CustomFilterBoundary = (props)=>{
    const { children: children, screenName: screenName } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onError = (_, error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), 'ui taskFail', {
            screenName: screenName,
            task: 'loadCustomFilters',
            isNetworkError: (0, $fZneA.isClientFetchError)(error),
            hash: (0, $kobfu.getErrorHash)(error) ?? '',
            errorMessage: error.message
        });
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "custom-filter-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        },
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($93fab47741ff1022$export$876b3e4acf4df22c, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "custom-filter-boundary",
        fallback: null
    }, children)));
};
var $93fab47741ff1022$export$2e2bcd8739ae039 = $93fab47741ff1022$var$CustomFilterBoundary;

});
parcelRegister("7Oku1", function(module, exports) {

$parcel$export(module.exports, "isRelayValidationError", () => $8940bd8b67d2f481$export$f450dbe0abffdade);
$parcel$export(module.exports, "AGGErrors", () => $8940bd8b67d2f481$export$60d8267243755b9c);

var $ht021 = parcelRequire("ht021");
const $8940bd8b67d2f481$export$321834dc4377cb7 = 'Relay: Missing @required value at path';
const $8940bd8b67d2f481$export$f450dbe0abffdade = (error)=>error.message.includes($8940bd8b67d2f481$export$321834dc4377cb7);
class $8940bd8b67d2f481$export$60d8267243755b9c extends (0, $ht021.default) {
    constructor(errors, traceId){
        // this is used to generate same 'hash' for error flag and sla event attribute
        super(errors[0].message, {
            cause: errors[0]
        }), this.name = 'AGGError';
        this.graphQLErrors = errors;
        this.traceId = traceId;
        this.statusCode = errors[0].extensions?.statusCode ?? undefined;
    }
}

});


parcelRegister("2FvdY", function(module, exports) {

$parcel$export(module.exports, "default", () => $fb1987110dd76b24$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dF9Z3 = parcelRequire("dF9Z3");
const $fb1987110dd76b24$var$HijackBrowserDefaultSearch = ({ onFocusSearch: onFocusSearch, isAnyModalOpen: isAnyModalOpen = false })=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onGlobalSearch = (0, $5uXOq.useCallback)(// @ts-expect-error - TS7031 - Binding element 'event' implicitly has an 'any' type.
    ({ event: event })=>{
        // Do not hijack browser default search when any modal is open
        if (isAnyModalOpen) return;
        // Hijacks default browser search and directs user to search in filter bar
        event.preventDefault();
        onFocusSearch();
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'hijackBrowserDefaultSearch triggered');
    }, [
        createAnalyticsEvent,
        isAnyModalOpen,
        onFocusSearch
    ]);
    (0, $dF9Z3.useGlobalSearch)(onGlobalSearch);
    return null;
};
var $fb1987110dd76b24$export$2e2bcd8739ae039 = $fb1987110dd76b24$var$HijackBrowserDefaultSearch;

});

parcelRegister("kH9yv", function(module, exports) {

$parcel$export(module.exports, "default", () => $333f125f896ef4d8$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $5ujeO = parcelRequire("5ujeO");
var $k6T4f = parcelRequire("k6T4f");

var $MHKc7 = parcelRequire("MHKc7");

var $6s1PB = parcelRequire("6s1PB");

var $ousew = parcelRequire("ousew");
var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dF9Z3 = parcelRequire("dF9Z3");

var $ew9g5 = parcelRequire("ew9g5");

var $gtlfw = parcelRequire("gtlfw");
const $333f125f896ef4d8$var$SearchFilterChangeboarding = ({ children: children, hijackBrowserDefaultSearch: hijackBrowserDefaultSearch = false, screenName: screenName, isCompanyManaged: isCompanyManaged = false })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isVisible, setIsVisible] = (0, $5uXOq.useState)(false);
    const hasShown = (0, $5uXOq.useRef)(false);
    const onGlobalSearch = (0, $5uXOq.useCallback)(()=>{
        if (!hasShown.current) {
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding shown', {
                isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
            });
            setIsVisible(true);
            hasShown.current = true;
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') (0, $ew9g5.setUserSeenSearchFieldChangeboarding)(screenName);
        }
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const onDismiss = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'searchFilterChangeboarding dismissed', {
            isHijackBrowserDefaultSearchEnabled: hijackBrowserDefaultSearch
        });
        setIsVisible(false);
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch
    ]);
    const actions = (0, $5uXOq.useMemo)(()=>[
            {
                text: formatMessage((0, $gtlfw.default).changeboardingConfirmButton),
                onClick: onDismiss
            }
        ], [
        formatMessage,
        onDismiss
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const getUserSeenSearchFieldChangeboarding = async ()=>{
            if (screenName === 'backlog' || screenName === 'board' || screenName === 'roadmap') {
                const seen = await (0, $ew9g5.hasUserSeenSearchFieldChangeboarding)(createAnalyticsEvent({}), screenName);
                if (seen) hasShown.current = true;
            }
        };
        getUserSeenSearchFieldChangeboarding();
    }, [
        createAnalyticsEvent,
        hijackBrowserDefaultSearch,
        screenName
    ]);
    const changeBoardingMessage = ()=>{
        const ctrlKey = (0, $dF9Z3.isMacOS)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Cmnd") : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "Ctrl");
        return hijackBrowserDefaultSearch ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gtlfw.default).hijackingDefaultSearchMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "F"),
                ctrlKey: ctrlKey
            }
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), {
            ...(0, $gtlfw.default).changeboardingMessage,
            values: {
                key: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Code, null, "f")
            }
        });
    };
    let spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, changeBoardingMessage()));
    if (isCompanyManaged) spotlightCard = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ujeO.default), {
        heading: formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gtlfw.default).changeboardingUifMessageHeadingIssueTermRefresh : (0, $gtlfw.default).changeboardingUifMessageHeading),
        actions: actions,
        width: 300
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $MHKc7.default), null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $gtlfw.default).changeboardingUifMessageIssueTermRefresh : (0, $gtlfw.default).changeboardingUifMessage)));
    (0, $dF9Z3.useGlobalSearch)(onGlobalSearch);
    if (isVisible) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$ChangeboardingContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$Pulse, null, children), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($333f125f896ef4d8$var$SpolightCardContainer, null, spotlightCard));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
var $333f125f896ef4d8$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $333f125f896ef4d8$var$SearchFilterChangeboarding;
const $333f125f896ef4d8$var$Pulse = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $k6T4f.Pulse), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1pbyowjs",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$ChangeboardingContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm",
            __cmplp.className
        ])
    });
});
const $333f125f896ef4d8$var$spotlightAnimation = null; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$SpolightCardContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y44v18t4 _kqswstnw _1pbyowjs _19pku2gc _tzy4idpf _o5724jg8",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $333f125f896ef4d8$var$Code = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "code", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _2rko1l7b _bfhk1bhr _syaz1fxt _1e0c1nu9 _1reo1wug _o5721jtm _ca0qv77o _u5f31b66 _n3tdv77o _19bv1b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("ew9g5", function(module, exports) {

$parcel$export(module.exports, "hasUserSeenSearchFieldChangeboarding", () => $f70c479b04e71cf2$export$b5010e3edd313ae1);
$parcel$export(module.exports, "setUserSeenSearchFieldChangeboarding", () => $f70c479b04e71cf2$export$fba51361338c8f18);

var $i205g = parcelRequire("i205g");

var $8zOmE = parcelRequire("8zOmE");
const $f70c479b04e71cf2$var$changeboardingFlags = {
    board: 'jsw.filters.board.search-field-changeboarding.shown',
    backlog: 'jsw.filters.backlog.search-field-changeboarding.shown'
};
const $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN = 31536000000; // ~ 365 days
const $f70c479b04e71cf2$export$b5010e3edd313ae1 = (analyticsEvent, screenName)=>(0, $i205g.getFlags)({
        // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
        [$f70c479b04e71cf2$var$changeboardingFlags[screenName]]: {}
    })// @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ readonly board: "jsw.filters.board.search-field-changeboarding.shown"; readonly backlog: "jsw.filters.backlog.search-field-changeboarding.shown"; }'.
    .then((res)=>res[$f70c479b04e71cf2$var$changeboardingFlags[screenName]].status).catch(()=>{
        (0, $8zOmE.fireTrackAnalytics)(analyticsEvent, 'searchFilterChangeboarding checkSeenFailed');
        return false;
    });
const $f70c479b04e71cf2$export$fba51361338c8f18 = (screenName)=>(0, $i205g.setFlag)($f70c479b04e71cf2$var$changeboardingFlags[screenName], $f70c479b04e71cf2$var$CHANGEBOARDING_TTL_SEEN);

});
parcelRegister("i205g", function(module, exports) {

$parcel$export(module.exports, "getFlags", () => $2e5c55e74efea073$export$d5815430bcc75df0);
$parcel$export(module.exports, "setFlag", () => $2e5c55e74efea073$export$5e165df1e30a1331);

var $dPSWJ = parcelRequire("dPSWJ");

var $sLb2Q = parcelRequire("sLb2Q");

var $4Pf62 = parcelRequire("4Pf62");

var $1nokx = parcelRequire("1nokx");

var $7UyIQ = parcelRequire("7UyIQ");
const $2e5c55e74efea073$export$442e3330dfabd1f5 = 3600000; // 1 hour
const $2e5c55e74efea073$export$4d45fa66d41a8ca9 = 2592000000; // ~1 month
const $2e5c55e74efea073$export$d5815430bcc75df0 = async (request)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    const flagKeys = Object.keys(request);
    const retrieveFlagKeysLookup = (0, (/*@__PURE__*/$parcel$interopDefault($sLb2Q)))(flagKeys);
    if (!atlassianAccountId || isAnonymous) return (0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(retrieveFlagKeysLookup, ()=>({
            status: true,
            lastSeenDate: null
        }));
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const flags = {};
    if (0, $7UyIQ.default) flagKeys.forEach((flagKey)=>{
        // @ts-expect-error - Object is possibly 'null'.
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value) {
            delete retrieveFlagKeysLookup[flagKey];
            flags[flagKey] = value;
        }
    });
    const retrieveFlagKeys = Object.keys(retrieveFlagKeysLookup);
    if (retrieveFlagKeys.length > 0) Object.assign(flags, await (0, $1nokx.getFlags)(atlassianAccountId, retrieveFlagKeys));
    if (0, $7UyIQ.default) {
        const now = Date.now();
        retrieveFlagKeys.forEach((flagKey)=>{
            // Not sure whats going wrong here - but i assume `apiGetFlags` may not always return all `retrieveFalgKeys`
            // and so `flags[flagKey]` can be undefined - so we have to guard against it
            if (!flags[flagKey]) return;
            const { status: status } = flags[flagKey];
            const ttlNotSeen = request[flagKey].ttlNotSeen || $2e5c55e74efea073$export$442e3330dfabd1f5;
            const ttlSeen = request[flagKey].ttlSeen || $2e5c55e74efea073$export$4d45fa66d41a8ca9;
            // @ts-expect-error - TS2531: Object is possibly 'null'.
            (0, $7UyIQ.default).set(flagKey, flags[flagKey], now + (status ? ttlSeen : ttlNotSeen));
        });
    }
    return flags;
};
const $2e5c55e74efea073$export$5e165df1e30a1331 = async (flagKey, ttl = $2e5c55e74efea073$export$4d45fa66d41a8ca9)=>{
    const { atlassianAccountId: atlassianAccountId, isAnonymous: isAnonymous } = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
    if (!atlassianAccountId || isAnonymous) return;
    if (0, $7UyIQ.default) {
        const value = (0, $7UyIQ.default).get(flagKey);
        if (value && value.status) return;
        const now = new Date();
        (0, $7UyIQ.default).set(flagKey, {
            status: true,
            lastSeenDate: now.toISOString()
        }, now.getTime() + ttl);
    }
    await (0, $1nokx.setFlag)(atlassianAccountId, flagKey);
};

});
parcelRegister("sLb2Q", function(module, exports) {

var $hsOo6 = parcelRequire("hsOo6");

var $dVL8S = parcelRequire("dVL8S");
/**
 * This method is like `_.fromPairs` except that it accepts two arrays,
 * one of property identifiers and one of corresponding values.
 *
 * @static
 * @memberOf _
 * @since 0.4.0
 * @category Array
 * @param {Array} [props=[]] The property identifiers.
 * @param {Array} [values=[]] The property values.
 * @returns {Object} Returns the new object.
 * @example
 *
 * _.zipObject(['a', 'b'], [1, 2]);
 * // => { 'a': 1, 'b': 2 }
 */ function $056736098c9e0b45$var$zipObject(props, values) {
    return $dVL8S(props || [], values || [], $hsOo6);
}
module.exports = $056736098c9e0b45$var$zipObject;

});
parcelRegister("dVL8S", function(module, exports) {
/**
 * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
 *
 * @private
 * @param {Array} props The property identifiers.
 * @param {Array} values The property values.
 * @param {Function} assignFunc The function to assign values.
 * @returns {Object} Returns the new object.
 */ function $a2452aab1e6d9d16$var$baseZipObject(props, values, assignFunc) {
    var index = -1, length = props.length, valsLength = values.length, result = {};
    while(++index < length){
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
    }
    return result;
}
module.exports = $a2452aab1e6d9d16$var$baseZipObject;

});


parcelRegister("1nokx", function(module, exports) {

$parcel$export(module.exports, "setFlag", () => $4c27c5726c27889e$export$5e165df1e30a1331);
$parcel$export(module.exports, "getFlags", () => $4c27c5726c27889e$export$d5815430bcc75df0);

var $dPSWJ = parcelRequire("dPSWJ");

var $jJZqs = parcelRequire("jJZqs");
const $4c27c5726c27889e$export$c1f083639d344e75 = 'https://have-i-seen-it.us-east-1.prod.public.atl-paas.net';
const $4c27c5726c27889e$export$5e165df1e30a1331 = (userKey, flagKey)=>{
    const data = {
        userKey: userKey,
        flagKey: flagKey
    };
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flag`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(data)
    }).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return undefined;
    });
};
const $4c27c5726c27889e$var$convertToDates = (response)=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(response, ({ status: status, lastSeenDate: lastSeenDate })=>({
            status: status,
            lastSeenDate: lastSeenDate ? new Date(lastSeenDate) : null
        }));
const $4c27c5726c27889e$export$d5815430bcc75df0 = (userKey, flagKeys)=>{
    const params = new URLSearchParams();
    flagKeys.forEach((flagKey)=>params.append('flagKey', flagKey));
    params.append('userKey', userKey);
    return fetch(`${$4c27c5726c27889e$export$c1f083639d344e75}/flags?${params.toString()}`).then((response)=>{
        if (!response.ok) throw new (0, $jJZqs.default)(response.status, response.statusText);
        return response.json();
    }).then((response)=>$4c27c5726c27889e$var$convertToDates(response));
};

});

parcelRegister("7UyIQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $158da724691281b4$export$2e2bcd8739ae039);

var $eNf8a = parcelRequire("eNf8a");

var $4Pf62 = parcelRequire("4Pf62");

var $2YZCu = parcelRequire("2YZCu");
/**
 * Return an ExpirableStorage to be used with the "have i seen it" service.
 *
 * If the user is anonymous, return null.
 */ const $158da724691281b4$var$createStorage = ()=>{
    let storage = null;
    try {
        let context;
        try {
            context = (0, $4Pf62.getTenantContext_DEPRECATED_DO_NOT_USE)();
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (e) {
            return storage;
        }
        const { atlassianAccountId: atlassianAccountId } = context;
        if (atlassianAccountId) storage = (0, $eNf8a.createSessionExpirableStorageProvider)(`have-i-seen-it-${atlassianAccountId.replace(/:/g, '_')}`);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e) {
        (0, $2YZCu.default).safeErrorWithoutCustomerData('have-i-seen-it.storage', 'Failed to initialize storage.');
    }
    return storage;
};
var $158da724691281b4$export$2e2bcd8739ae039 = $158da724691281b4$var$createStorage();

});



parcelRegister("gtlfw", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e167f73d4db9857$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8e167f73d4db9857$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    changeboardingMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-message",
        "defaultMessage": "For quick access to search, use {key} on your keyboard anywhere in Jira. It takes you directly to the search field."
    },
    changeboardingUifMessageHeading: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading",
        "defaultMessage": "Search for an issue"
    },
    changeboardingUifMessage: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message",
        "defaultMessage": "The backlog loads issues as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    },
    hijackingDefaultSearchMessage: {
        "id": "software-filters.search-filter-changeboarding.hijacking-default-search-message",
        "defaultMessage": "{ ctrlKey } + { key } takes you directly to the search field, just like keyboard shortcut { key }. Both shortcuts give you quick access to our optimized search."
    },
    changeboardingConfirmButton: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-confirm-button",
        "defaultMessage": "OK"
    },
    changeboardingUifMessageHeadingIssueTermRefresh: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-heading-issue-term-refresh",
        "defaultMessage": "Search for a work item"
    },
    changeboardingUifMessageIssueTermRefresh: {
        "id": "software-filters.search-filter-changeboarding.changeboarding-uif-message-issue-term-refresh",
        "defaultMessage": "The backlog loads work items as you scroll to help increase performance. If you struggle to find results using a keyboard shortcut, try entering the keyword here instead."
    }
});

});


parcelRegister("bBMqL", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4b1c241e667722$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");
const $cf4b1c241e667722$var$VersionFilterRelayBoundary = ({ fallback: fallback = null, children: children, screenName: screenName })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "version-filter-relay-dropdown",
        packageName: "software-filters",
        teamName: "a4t-tanuki",
        fallback: "flag",
        extraEventData: {
            screenName: screenName
        }
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "version-filter-relay-boundary",
        fallback: fallback
    }, children));
var $cf4b1c241e667722$export$2e2bcd8739ae039 = $cf4b1c241e667722$var$VersionFilterRelayBoundary;

});

parcelRegister("l38sT", function(module, exports) {

$parcel$export(module.exports, "default", () => $4c71ac6a8ffa9b82$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $4c71ac6a8ffa9b82$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textFilter: {
        "id": "software-filters.stateless.text-filter",
        "defaultMessage": "Filter issues"
    },
    screenReaderInstruction: {
        "id": "software-filters.stateless.screen-reader-instruction",
        "defaultMessage": "Results will be filtered below as you type to search or apply filters."
    },
    screenReaderInstructionForFilters: {
        "id": "software-filters.stateless.screen-reader-instruction-for-filters",
        "defaultMessage": "Content below has been updated"
    },
    searchCurrentPage: {
        "id": "software-filters.stateless.search-current-page",
        "defaultMessage": "Search on current page"
    },
    goToSection: {
        "id": "software-filters.stateless.go-to-section",
        "defaultMessage": "Go to"
    },
    unassignedAssigneeDisplayName: {
        "id": "software-filters.stateless.unassigned-assignee-display-name",
        "defaultMessage": "Unassigned"
    },
    unassignedVersionLabel: {
        "id": "software-filters.stateless.unassigned-version-label",
        "defaultMessage": "Issues without version"
    },
    unassignedLabelLabel: {
        "id": "software-filters.stateless.unassigned-label-label",
        "defaultMessage": "Issues without label"
    },
    unassignedComponentLabel: {
        "id": "software-filters.stateless.unassigned-component-label",
        "defaultMessage": "Issues without component"
    },
    textFilterIssueTermRefresh: {
        "id": "software-filters.stateless.text-filter-issue-term-refresh",
        "defaultMessage": "Filter work items"
    },
    unassignedVersionLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-version-label-issue-term-refresh",
        "defaultMessage": "Work items without version"
    },
    unassignedLabelLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-label-label-issue-term-refresh",
        "defaultMessage": "Work items without label"
    },
    unassignedComponentLabelIssueTermRefresh: {
        "id": "software-filters.stateless.unassigned-component-label-issue-term-refresh",
        "defaultMessage": "Work items without component "
    }
});

});

parcelRegister("649U3", function(module, exports) {

$parcel$export(module.exports, "getManageCustomFiltersUrl", () => $224b64cdfcbfd0e3$export$84a62bf03b005a81);

var $e5wyW = parcelRequire("e5wyW");

var $4R6GH = parcelRequire("4R6GH");
const $224b64cdfcbfd0e3$export$84a62bf03b005a81 = (0, $e5wyW.functionWithCondition)(()=>// This is temporary - cleanup is scheduled for next week:
    // eslint-disable-next-line jira/ff/no-preconditioning
    (0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route'), $224b64cdfcbfd0e3$var$getManageCustomFiltersUrlNew, $224b64cdfcbfd0e3$var$getManageCustomFiltersUrlOld);
function $224b64cdfcbfd0e3$var$getManageCustomFiltersUrlNew(projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, // For testing purposes
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
pathname = window.location.pathname) {
    const NEW_SETTINGS_PATH = '/settings/quickFilters';
    if (isJSMBoard) // JSM Boards use their usual URL all the time.
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
    if (isCompanyManaged) {
        if (isUserBoard) return pathname.endsWith('/backlog') ? `${pathname.replace('/backlog', '')}${NEW_SETTINGS_PATH}?from-backlog=1` : `${pathname}${NEW_SETTINGS_PATH}`;
        return `/jira/software/c/projects/${projectKey}/boards/${boardId}${NEW_SETTINGS_PATH}${pathname.endsWith('backlog') ? '?from-backlog=1' : ''}`;
    }
    return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
}
function $224b64cdfcbfd0e3$var$getManageCustomFiltersUrlOld(projectKey, boardId, isCompanyManaged, isUserBoard, isJSMBoard, // For testing purposes
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
pathname = window.location.pathname) {
    if (isJSMBoard) return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}?config=quickFilters`;
    if (isCompanyManaged) {
        if (isUserBoard) return `${pathname}?config=quickFilters`;
        return `/jira/software/c/projects/${projectKey}/boards/${boardId}${pathname.endsWith('backlog') ? '/backlog' : ''}?config=quickFilters`;
    }
    return `/jira/software/projects/${projectKey}/settings/boards/${boardId}/custom-filters`;
}

});


parcelRegister("361on", function(module, exports) {

$parcel$export(module.exports, "getNormalizedFilters", () => $d5949234e82f3596$export$459be3406d78c3a5);
$parcel$export(module.exports, "onFilterChangeStartInteraction", () => $d5949234e82f3596$export$568db3ec08ca631b);

var $7uUwQ = parcelRequire("7uUwQ");

var $gccSB = parcelRequire("gccSB");

const $d5949234e82f3596$export$459be3406d78c3a5 = (filters)=>{
    const chainedFilters = (0, $7uUwQ.chain)({}).setIn([
        (0, $15a528573ccd89ae$export$d597759d33be802e)
    ], filters[0, $15a528573ccd89ae$export$d597759d33be802e] ? filters[0, $15a528573ccd89ae$export$d597759d33be802e] : undefined).setIn([
        (0, $15a528573ccd89ae$export$37aee82a3cb1e8f7)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7]) ? filters[0, $15a528573ccd89ae$export$37aee82a3cb1e8f7] : undefined).setIn([
        (0, $15a528573ccd89ae$export$2a4f270075a033de)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$2a4f270075a033de]) ? filters[0, $15a528573ccd89ae$export$2a4f270075a033de] : undefined).setIn([
        (0, $15a528573ccd89ae$export$f8f7545d2bb78afb)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb]) ? filters[0, $15a528573ccd89ae$export$f8f7545d2bb78afb] : undefined).setIn([
        (0, $15a528573ccd89ae$export$ebb48b08205007c5)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$ebb48b08205007c5]) ? filters[0, $15a528573ccd89ae$export$ebb48b08205007c5] : undefined).setIn([
        (0, $15a528573ccd89ae$export$a4ad2735b021c132)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$a4ad2735b021c132]) ? filters[0, $15a528573ccd89ae$export$a4ad2735b021c132] : undefined).setIn([
        (0, $15a528573ccd89ae$export$a316570a0dbfd2b0)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0]) ? filters[0, $15a528573ccd89ae$export$a316570a0dbfd2b0] : undefined).setIn([
        (0, $15a528573ccd89ae$export$92ab80c1dc9baf44)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$92ab80c1dc9baf44]) ? filters[0, $15a528573ccd89ae$export$92ab80c1dc9baf44] : undefined).setIn([
        (0, $15a528573ccd89ae$export$e50006273435e7d4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$e50006273435e7d4]) ? filters[0, $15a528573ccd89ae$export$e50006273435e7d4] : undefined).setIn([
        (0, $15a528573ccd89ae$export$68d693c35a8d8866)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$68d693c35a8d8866]) ? filters[0, $15a528573ccd89ae$export$68d693c35a8d8866] : undefined).setIn([
        (0, $15a528573ccd89ae$export$f863b019d19144f4)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$f863b019d19144f4]) ? filters[0, $15a528573ccd89ae$export$f863b019d19144f4] : undefined).setIn([
        (0, $15a528573ccd89ae$export$401f4b6eda6a369c)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$401f4b6eda6a369c]) ? filters[0, $15a528573ccd89ae$export$401f4b6eda6a369c] : undefined).setIn([
        (0, $15a528573ccd89ae$export$db362e2d293fe52e)
    ], !(0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(filters[0, $15a528573ccd89ae$export$db362e2d293fe52e]) ? filters[0, $15a528573ccd89ae$export$db362e2d293fe52e] : undefined);
    return chainedFilters.value();
};
const $d5949234e82f3596$export$568db3ec08ca631b = (filterType, onChangeInteractionStart, onCustomFilterChangeInteractionStart)=>{
    if (filterType === (0, $15a528573ccd89ae$export$68d693c35a8d8866)) onCustomFilterChangeInteractionStart();
    else onChangeInteractionStart();
};

});


parcelRegister("aGYrC", function(module, exports) {

$parcel$export(module.exports, "setInteractionFeedbackMark", () => $8d93a4680b7cb24a$export$2a56340540433ea3);
$parcel$export(module.exports, "setInteractionStartMark", () => $8d93a4680b7cb24a$export$1da8f59ae62c0e17);

var $hz3OZ = parcelRequire("hz3OZ");
const $8d93a4680b7cb24a$export$2a56340540433ea3 = ()=>{
    (0, $hz3OZ.filterInteraction).mark('feedback');
};
const $8d93a4680b7cb24a$export$1da8f59ae62c0e17 = ()=>{
    (0, $hz3OZ.filterInteraction).start();
};

});

parcelRegister("3Vjgs", function(module, exports) {

$parcel$export(module.exports, "useShouldShowUnassignedFilter", () => $4d6ee958ae154a83$export$4cd540b66996f7eb);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $h5aFt = parcelRequire("h5aFt");

var $5mTgl = parcelRequire("5mTgl");
const $4d6ee958ae154a83$export$4cd540b66996f7eb = ()=>{
    const isLoaded = (0, $67sX6.useBoardSelector)((0, $5mTgl.isBoardConfigLoaded));
    const numberOfCompleteIssues = (0, $67sX6.useBoardSelector)((0, $h5aFt.numberOfUserHasCompleteAssignedIssuesSelector));
    const shouldShowNudge = (0, $67sX6.useBoardSelector)((0, $h5aFt.shouldShowUnassignedFilterNudgeSelector));
    const prevBoardStatsRef = (0, $5uXOq.useRef)({
        shouldShowNudge: shouldShowNudge,
        numberOfCompleteIssues: null,
        shouldShowUnassignedFilterNudge: isLoaded && shouldShowNudge
    });
    (0, $5uXOq.useEffect)(()=>{
        if (isLoaded) {
            const prevBoardStats = prevBoardStatsRef.current;
            const shouldShowUnassignedFilterNudge = shouldShowNudge && (prevBoardStats.numberOfCompleteIssues === null || prevBoardStats.numberOfCompleteIssues + 1 === numberOfCompleteIssues);
            prevBoardStatsRef.current = {
                shouldShowNudge: shouldShowNudge,
                numberOfCompleteIssues: shouldShowUnassignedFilterNudge ? prevBoardStats.numberOfCompleteIssues : numberOfCompleteIssues,
                shouldShowUnassignedFilterNudge: shouldShowUnassignedFilterNudge
            };
        }
    }, [
        isLoaded,
        numberOfCompleteIssues,
        shouldShowNudge
    ]);
    return {
        shouldShowUnassignedFilterNudge: prevBoardStatsRef.current.shouldShowUnassignedFilterNudge
    };
};

});

parcelRegister("b9W8W", function(module, exports) {

$parcel$export(module.exports, "BoardCustomFilter", () => $5c951ba878a18e63$export$cc2433dd642ef843);

var $5uXOq = parcelRequire("5uXOq");

var $9vASA = parcelRequire("9vASA");

var $a4XJc = parcelRequire("a4XJc");

var $9pP0g = parcelRequire("9pP0g");

var $iDGXn = parcelRequire("iDGXn");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $ckZbM = parcelRequire("ckZbM");
const $5c951ba878a18e63$var$BoardCustomFilterRedux = (props)=>{
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const filters = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCustomFilters));
    const isFilterBarVisible = (0, $iDGXn.useShowQuickFilters)();
    const { toggleViewSetting: toggleViewSetting } = (0, $iDGXn.useViewSettingsActions)();
    const onToggleIsFilterBarVisible = (0, $5uXOq.useCallback)(()=>{
        if (boardId) toggleViewSetting({
            boardId: Number(boardId),
            view: (0, $a4XJc.View).BOARD,
            setting: (0, $9pP0g.ViewSetting).QUICK_FILTERS
        });
    }, [
        boardId,
        toggleViewSetting
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9vASA.default), {
        ...props,
        filters: filters,
        isPanelToggleChecked: isFilterBarVisible,
        onTogglePanel: onToggleIsFilterBarVisible,
        showPanelToggle: props.isCompanyManaged
    });
};
const $5c951ba878a18e63$export$cc2433dd642ef843 = (props)=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    if (isCMPBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5c951ba878a18e63$var$BoardCustomFilterRedux, {
        ...props,
        isCompanyManaged: true
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ckZbM.BoardCustomFilterRelay), props);
};

});
parcelRegister("ckZbM", function(module, exports) {

$parcel$export(module.exports, "BoardCustomFilterRelay", () => $bfb3750039921446$export$1f37f3529982b959);

var $e59ii = parcelRequire("e59ii");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $05fhZ = parcelRequire("05fhZ");
const $bfb3750039921446$export$1f37f3529982b959 = ({ customFiltersQueryRef: customFiltersQueryRef, ...props })=>{
    const customFiltersFragmentRef = (0, $8Uumt.usePreloadedQuery)((0, $e59ii.default), customFiltersQueryRef);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $05fhZ.default), {
        customFiltersFragmentRef: customFiltersFragmentRef,
        ...props
    });
};

});
parcelRegister("e59ii", function(module, exports) {

$parcel$export(module.exports, "default", () => $1bec6ab78b3c2929$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<d66617b87c0114dec14f52268752a6b1>>
 * @relayHash fa277d121f8f09e75035802d7ede6889
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b

var $eiowN = parcelRequire("eiowN");
const $1bec6ab78b3c2929$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "id"
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "viewBoardCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "kind": "FragmentSpread",
                    "name": "customFilter_softwareFilters_CustomFilterRelay"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "viewBoardCustomFiltersQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "CustomFilter",
                            "kind": "LinkedField",
                            "name": "customFilters",
                            "plural": true,
                            "selections": [
                                v2 /*: any*/ ,
                                {
                                    "kind": "ScalarField",
                                    "name": "name"
                                }
                            ]
                        },
                        v2 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "a079984b25df71d288de249187cdd59463b205124f1a0a13756db6b3207ef56b",
            "metadata": {},
            "name": "viewBoardCustomFiltersQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$1bec6ab78b3c2929$var$node.hash = "059c408527e2b921d6b2e3d9305090e3";
(0, $eiowN.PreloadableQueryRegistry).set($1bec6ab78b3c2929$var$node.params.id, $1bec6ab78b3c2929$var$node);
var $1bec6ab78b3c2929$export$2e2bcd8739ae039 = $1bec6ab78b3c2929$var$node;

});



const $70866c33bb205617$export$d339888a30f06bf4 = 'viewBoardFilterBar';
const $70866c33bb205617$export$dc37b1e8e15e9923 = 'ng-board-filter-bar';
const $70866c33bb205617$export$b110169935468339 = 'ng-board-filter-bar';

parcelRegister("brhcU", function(module, exports) {

$parcel$export(module.exports, "default", () => $c33f97ad431348d9$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c33f97ad431348d9$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    textFilter: {
        "id": "software.main.header.controls-bar.filter-bar.text-filter",
        "defaultMessage": "Search"
    },
    screenReaderInstruction: {
        "id": "software.main.header.controls-bar.filter-bar.screen-reader-instruction",
        "defaultMessage": "As you type to search or apply filters, the board updates with issues to match."
    },
    filterPlaceholder: {
        "id": "software.main.header.controls-bar.filter-bar.filter-placeholder",
        "defaultMessage": "Search board"
    },
    screenReaderInstructionIssueTermRefresh: {
        "id": "software.main.header.controls-bar.filter-bar.screen-reader-instruction-issue-term-refresh",
        "defaultMessage": "As you type to search or apply filters, the board updates with work items to match."
    }
});

});



parcelRegister("fUeOV", function(module, exports) {

$parcel$export(module.exports, "default", () => $0163544a3dd31482$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $9XE6b = parcelRequire("9XE6b");

var $iU0UM = parcelRequire("iU0UM");


var $dnW4F = parcelRequire("dnW4F");

var $67sX6 = parcelRequire("67sX6");

var $5mTgl = parcelRequire("5mTgl");
const $0163544a3dd31482$var$FilterSelectionBar = ()=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const allSelectedWorkFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $67sX6.useBoardSelector)((0, $5mTgl.getWorkFilters)), 'values');
    const selectedCustomFilters = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(allSelectedWorkFilters, (0, $dcff40112356dfc1$export$68d693c35a8d8866));
    const selectedCustomFiltersSet = (0, $5uXOq.useMemo)(()=>new Set(selectedCustomFilters), [
        selectedCustomFilters
    ]);
    const allCustomFilters = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCustomFilters));
    const onChange = (0, $5uXOq.useCallback)((filters, analyticsEvent)=>{
        dispatch((0, $dnW4F.setAllFilters)({
            ...allSelectedWorkFilters,
            ...filters
        }, (0, $dcff40112356dfc1$export$68d693c35a8d8866), analyticsEvent));
    }, [
        allSelectedWorkFilters,
        dispatch
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iU0UM.default), {
        filters: allCustomFilters,
        selectedFilters: selectedCustomFiltersSet,
        onChange: onChange
    });
};
var $0163544a3dd31482$export$2e2bcd8739ae039 = $0163544a3dd31482$var$FilterSelectionBar;

});
parcelRegister("iU0UM", function(module, exports) {

$parcel$export(module.exports, "default", () => $8822a2681eb1c63b$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $koVbs = parcelRequire("koVbs");

var $a2e2Q = parcelRequire("a2e2Q");

var $caqPj = parcelRequire("caqPj");

var $euWQZ = parcelRequire("euWQZ");
const $8822a2681eb1c63b$var$FilterSelectionBar = ({ onChange: onChange, selectedFilters: selectedFilters, filters: filters })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $a2e2Q.useSoftwareProjectTheming)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("fieldset", {
        "data-testid": "software-filters.ui.filter-selection-bar.filter-selection-bar",
        className: (0, $bwpsq.default)([
            "_1reo1g80 _18m91g80 _zulpu2gc _qtt8glyw _1bsb1osq _1e0c1txw _19pku2gc _1n261g80"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("legend", {
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c"
        ])
    }, formatMessage((0, $euWQZ.default).filterToolBarAriaLabel)), filters.map((filter)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $caqPj.default), {
            key: `filter-option-${filter.id}`,
            onChange: onChange,
            selectedFilters: selectedFilters,
            filter: filter,
            isThemed: isSoftwareFullTheming
        })));
};
var $8822a2681eb1c63b$export$2e2bcd8739ae039 = $8822a2681eb1c63b$var$FilterSelectionBar;
const $8822a2681eb1c63b$var$styles = null;

});
parcelRegister("caqPj", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ef490007e1102a8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $2NMNM = parcelRequire("2NMNM");

var $hCCtP = parcelRequire("hCCtP");

var $lmBAt = parcelRequire("lmBAt");

var $4R6GH = parcelRequire("4R6GH");

var $a38Ao = parcelRequire("a38Ao");

var $5MHig = parcelRequire("5MHig");
const $8ef490007e1102a8$var$FilterOption = (props)=>{
    const { onChange: onChange, selectedFilters: selectedFilters, filter: filter, isThemed: isThemed } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isSelected = (0, $5uXOq.useMemo)(()=>selectedFilters.has(filter.id), [
        selectedFilters,
        filter
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        if (isSelected) selectedFilters.delete(filter.id);
        else selectedFilters.add(filter.id);
        onChange({
            CUSTOM_FILTER: Array.from(selectedFilters)
        }, createAnalyticsEvent({}));
    }, [
        onChange,
        filter,
        isSelected,
        selectedFilters,
        createAnalyticsEvent
    ]);
    const id = (0, $4R6GH.fg)('jsw-cmp-quick-filter-same-name-issue') ? `checkbox-id-${filter.name}-${filter.id}` : `checkbox-id-${filter.name}`;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: filter.description,
        position: "bottom",
        "data-testid": "software-filters.ui.filter-selection-bar.filter-option.tooltip"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8ef490007e1102a8$var$maxWidthWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $a38Ao.default), {
        id: id,
        checked: isSelected,
        onChange: onClick
    }), isThemed && (0, $lmBAt.getIsSoftwareThemingEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedButtonWrapper), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        id: id,
        isSelected: isSelected,
        component: (0, $5MHig.default)
    }, filter.name)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        id: id,
        isSelected: isSelected,
        component: (0, $5MHig.default)
    }, filter.name)));
};
var $8ef490007e1102a8$export$2e2bcd8739ae039 = $8ef490007e1102a8$var$FilterOption;
const $8ef490007e1102a8$var$maxWidthWrapperStyles = (0, $8CUq3.xcss)({
    maxWidth: '380px'
});

});
parcelRegister("a38Ao", function(module, exports) {

$parcel$export(module.exports, "default", () => $9843dc35bcc8c6ea$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $9843dc35bcc8c6ea$var$HiddenCheckbox = (props)=>{
    const { id: id, checked: checked, onChange: onChange } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("input", {
        id: id,
        type: "checkbox",
        checked: checked,
        onChange: onChange,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f3idpf _n3tdidpf _19bvidpf _19itidpf _1reo15vq _18m915vq _1bsbt94y _4t3it94y _kqswstnw _ogto7mnp _o5721q9c _81qxugt7 _ui4mv77o"
        ])
    });
};
var $9843dc35bcc8c6ea$export$2e2bcd8739ae039 = $9843dc35bcc8c6ea$var$HiddenCheckbox;
const $9843dc35bcc8c6ea$var$styles = null;

});

parcelRegister("5MHig", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd0acb68a7fed3bf$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");
const $dd0acb68a7fed3bf$var$Label = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("label", {
        ref: ref,
        htmlFor: props.id,
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
        className: (0, $bwpsq.default)([
            "_uiztglyw",
            props.className
        ]),
        // eslint-disable-next-line react/no-children-prop
        children: props.children
    }));
var $dd0acb68a7fed3bf$export$2e2bcd8739ae039 = $dd0acb68a7fed3bf$var$Label;
const $dd0acb68a7fed3bf$var$styles = null;

});


parcelRegister("euWQZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $d55c59fbc57ecf3b$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d55c59fbc57ecf3b$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    filterToolBarAriaLabel: {
        "id": "software-filters.filter-selection-bar.filter-tool-bar-aria-label",
        "defaultMessage": "filter tool bar"
    }
});

});



parcelRegister("hkLPk", function(module, exports) {

$parcel$export(module.exports, "FullscreenButton", () => $491ac5a3bdbb4c25$export$305be705ce696d42);

var $5uXOq = parcelRequire("5uXOq");

var $99BAr = parcelRequire("99BAr");

var $iDGXn = parcelRequire("iDGXn");

var $2xFXk = parcelRequire("2xFXk");

var $63LqY = parcelRequire("63LqY");
const $491ac5a3bdbb4c25$var$getFullscreenRefs = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
    Array.from(document.querySelectorAll('[data-fullscreen-id]'));
const $491ac5a3bdbb4c25$export$305be705ce696d42 = ({ boardId: boardId, shouldRenderContent: shouldRenderContent })=>{
    const { setIsFullscreen: setIsFullscreen } = (0, $iDGXn.useViewSettingsActions)();
    const isFullscreen = (0, $iDGXn.useIsFullscreen)();
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const handleFullscreenToggle = (0, $5uXOq.useCallback)((wasFullscreen)=>{
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: !wasFullscreen
        });
    }, [
        boardId,
        setIsFullscreen
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99BAr.default), {
        testId: "software-board.header.controls-bar.fullscreen-button.fullscreen-button",
        getCustomRefs: $491ac5a3bdbb4c25$var$getFullscreenRefs,
        withContainerStyles: false,
        onToggle: handleFullscreenToggle,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: isTabNavigation,
        shouldRenderContent: shouldRenderContent
    });
};

});
parcelRegister("99BAr", function(module, exports) {

$parcel$export(module.exports, "default", () => $d6d923fac0cd07eb$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $gucb2 = parcelRequire("gucb2");

const $d6d923fac0cd07eb$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: analyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle, isHidden: isHidden })=>{
    const [isFullscreenState, setIsFullscreenState] = (0, $5uXOq.useState)(isFullscreenProp ?? defaultFullscreen);
    const isFullscreen = isFullscreenProp ?? isFullscreenState;
    const handleToggle = (wasFullscreen, globalStyle)=>{
        onToggle(wasFullscreen, globalStyle);
        setIsFullscreenState(!wasFullscreen);
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gucb2.default), {
        testId: testId,
        onToggle: handleToggle,
        getCustomRefs: getCustomRefs,
        analyticsAttributes: analyticsAttributes,
        withContainerStyles: withContainerStyles,
        defaultFullscreen: defaultFullscreen,
        isFullscreen: isFullscreen,
        renderAsResponsiveButton: renderAsResponsiveButton,
        shouldRenderContent: shouldRenderContent,
        isSubtle: isSubtle,
        isHidden: isHidden
    });
};
$d6d923fac0cd07eb$var$FullscreenButton.defaultProps = {
    onToggle: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    getCustomRefs: ()=>[],
    analyticsAttributes: {}
};
var $d6d923fac0cd07eb$export$2e2bcd8739ae039 = $d6d923fac0cd07eb$var$FullscreenButton;

});
parcelRegister("gucb2", function(module, exports) {

$parcel$export(module.exports, "default", () => $f59079bf3589c5a6$export$2e2bcd8739ae039);
/* main.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $42CjB = parcelRequire("42CjB");

var $5JpK2 = parcelRequire("5JpK2");

var $j2iKG = parcelRequire("j2iKG");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $3Tty1 = parcelRequire("3Tty1");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $3HwlS = parcelRequire("3HwlS");

var $8zOmE = parcelRequire("8zOmE");

var $22OQR = parcelRequire("22OQR");

var $6lmg7 = parcelRequire("6lmg7");

var $dCm1o = parcelRequire("dCm1o");

var $gydfO = parcelRequire("gydfO");
const $f59079bf3589c5a6$var$removeFullScreenStyle = (customRefs)=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    document.getElementById('fullscreen-global-style')?.remove();
    if (customRefs) customRefs.forEach((ref)=>{
        if (ref !== null) ref.classList.remove('fullscreen');
    });
};
const $f59079bf3589c5a6$var$FullscreenButton = ({ testId: testId, onToggle: onToggle, getCustomRefs: getCustomRefs, analyticsAttributes: extraAnalyticsAttributes, withContainerStyles: withContainerStyles = true, defaultFullscreen: defaultFullscreen = false, isFullscreen: isFullscreenProp, renderAsResponsiveButton: renderAsResponsiveButton = false, shouldRenderContent: shouldRenderContent = true, isSubtle: isSubtle = false, isHidden: isHidden })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const customRefElements = (0, $5uXOq.useRef)(null);
    const [isFullscreenLayout, { setIsFullscreen: setIsFullScreenLayout }] = (0, $g7crU.useIsFullscreen)();
    let globalStyle = null;
    if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) {
        if (!false) globalStyle = document.createElement('style');
    } else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    globalStyle = document.createElement('style');
    const isFullscreen = (0, $3HwlS.getWillShowNav4)() ? isFullscreenLayout : isFullscreenProp;
    const handleKeysInFullScreen = (0, $5uXOq.useCallback)((e)=>{
        // Ignore if it looks like the user is typing something
        if (e.target instanceof HTMLElement && ([
            'INPUT',
            'TEXTAREA',
            'SELECT'
        ].includes(e.target.tagName.toUpperCase()) || e.target.hasAttribute('contenteditable'))) return;
         // Prevent shortcuts
        const shortcutKeysToPrevent = [
            '/',
            // search
            'h' // help
        ];
        if (shortcutKeysToPrevent.includes(e.key)) e.stopPropagation();
        const navigationShortcuts = [
            '1',
            '2',
            '3',
            '4' // number keys
        ];
        if (!(0, $3HwlS.getWillShowNav4)() && navigationShortcuts.includes(e.key)) {
            // In Nav4 these keyboard shortcuts are rendered by the tab navigation
            // so they are not available in fullscreen mode
            onToggle(true, globalStyle ?? undefined);
            const customRefs = customRefElements.current;
            $f59079bf3589c5a6$var$removeFullScreenStyle(customRefs);
        }
    }, [
        globalStyle,
        onToggle
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isFullscreen) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.addEventListener('keydown', handleKeysInFullScreen, true);
        else // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window?.removeEventListener('keydown', handleKeysInFullScreen, true);
         // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        return ()=>window?.removeEventListener('keydown', handleKeysInFullScreen, true);
    }, [
        isFullscreen,
        handleKeysInFullScreen
    ]);
    const createFullScreenStyle = (0, $5uXOq.useCallback)(()=>{
        const customElements = customRefElements.current;
        const hiddenStyles = "#ak-jira-navigation, #ak-side-navigation, #right-sidebar-panel-wrapper, [data-skip-link-wrapper='true'] { display: none }"; // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const hiddenStylesNode = document.createTextNode(hiddenStyles);
        if (globalStyle) {
            globalStyle.id = 'fullscreen-global-style';
            globalStyle.appendChild(hiddenStylesNode);
        }
        if (customElements) customElements.forEach((ref)=>{
            if (ref !== null) ref.classList.add('fullscreen');
        });
        if (globalStyle) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.head?.appendChild(globalStyle);
    }, [
        globalStyle
    ]);
    const onClick = (event, analyticsEvent)=>{
        if ((0, $3HwlS.getWillShowNav4)()) {
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreenLayout
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            setIsFullScreenLayout(!isFullscreenLayout);
            onToggle(!isFullscreenLayout);
        } else {
            customRefElements.current = getCustomRefs();
            const customElements = customRefElements.current;
            const analyticsAttributes = {
                ...extraAnalyticsAttributes,
                expandToFullscreen: !isFullscreen
            };
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'fullscreenButton', analyticsAttributes);
            onToggle(isFullscreen, globalStyle ?? undefined);
            if (isFullscreen) $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
            else createFullScreenStyle();
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        customRefElements.current = getCustomRefs();
        const customElements = customRefElements.current;
        if (isFullscreen) createFullScreenStyle();
        else $f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
        return ()=>$f59079bf3589c5a6$var$removeFullScreenStyle(customElements);
    }, [
        createFullScreenStyle,
        getCustomRefs,
        isFullscreen
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (defaultFullscreen) createFullScreenStyle();
         // Empty dependency array to only apply fullscreen styling once (on mount).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []); // remove this useEffect when cleaning up blu-5747-fullscreen-in-nav-header
    (0, $5uXOq.useEffect)(()=>{
        // exit fullscreen mode when moving to a different page
        return ()=>{
            if ((0, $3HwlS.getWillShowNav4)() && !(0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) setIsFullScreenLayout(false);
        }; // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    const renderButtonWithTooltip = ()=>{
        if ((0, $dCm1o.isVisualRefreshEnabled)()) {
            if ((0, $4R6GH.fg)('blu-5747-fullscreen-in-nav-header')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $f59079bf3589c5a6$var$KeyboardShortcutContainer
                }, formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                    xcss: $f59079bf3589c5a6$var$KeyboardShortcut
                }, formatMessage((0, $gydfO.default).fullScreenShortcut))),
                position: "top"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22OQR.ThemedButton), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                onClick: onClick,
                "aria-keyshortcuts": "Z",
                iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))), {
                    label: formatMessage((0, $gydfO.default).exitFullScreen),
                    spacing: "spacious",
                    color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
                }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
                    label: formatMessage((0, $gydfO.default).enterFullScreen),
                    spacing: "spacious",
                    color: (0, $4R6GH.fg)('camptasks1101-update-color-tokens-of-icons') ? "var(--ds-icon-subtle, #626F86)" : 'currentColor'
                }),
                appearance: isSubtle ? 'subtle' : 'default',
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            }));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
                ...withContainerStyles ? {
                    testId: testId
                } : {
                    testId: 'platform.ui.fullscreen-button.fullscreen-button'
                },
                label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
                onClick: onClick,
                icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))),
                appearance: isSubtle ? 'subtle' : 'default',
                isTooltipDisabled: false,
                "aria-hidden": isHidden,
                tabIndex: isHidden ? -1 : 0
            });
        }
        if (renderAsResponsiveButton && !(0, $dCm1o.isVisualRefreshEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6lmg7.ResponsiveButton), {
            label: isFullscreen ? formatMessage((0, $gydfO.default).exitFullScreen) : formatMessage((0, $gydfO.default).enterFullScreen),
            icon: isFullscreen ? (0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))) : (0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))),
            onClick: onClick,
            testId: testId ?? 'platform.ui.fullscreen-button.fullscreen-button',
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: formatMessage(isFullscreen ? (0, $gydfO.default).exitFullScreen : (0, $gydfO.default).enterFullScreen),
            position: "top-end"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...withContainerStyles ? {
                testId: testId
            } : {
                testId: 'platform.ui.fullscreen-button.fullscreen-button'
            },
            appearance: "subtle",
            onClick: onClick,
            iconBefore: isFullscreen ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($j2iKG))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).exitFullScreen),
                spacing: "spacious"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5JpK2))), {
                color: "var(--ds-icon, #44546F)",
                label: formatMessage((0, $gydfO.default).enterFullScreen),
                spacing: "spacious"
            }),
            "aria-hidden": isHidden,
            tabIndex: isHidden ? -1 : 0
        }));
    };
    const keyMap = {
        z: {
            callback: ()=>{
                setIsFullScreenLayout(!isFullscreenLayout);
            }
        }
    };
    if (!shouldRenderContent) return null;
    return withContainerStyles ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f59079bf3589c5a6$var$FullscreenButtonContainer, {
        "data-testid": "platform.ui.fullscreen-button.fullscreen-button"
    }, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, renderButtonWithTooltip(), (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: keyMap
    }));
};
var $f59079bf3589c5a6$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $f59079bf3589c5a6$var$FullscreenButton;
const $f59079bf3589c5a6$var$FullscreenButtonContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2rko1sit _1e0c116y _bfhk1bhr _16qs1cd0",
            __cmplp.className
        ])
    });
});
const $f59079bf3589c5a6$var$KeyboardShortcutContainer = (0, $8CUq3.xcss)({
    display: 'flex',
    lineHeight: 'space.200',
    alignItems: 'center',
    paddingBottom: 'space.025',
    paddingTop: 'space.025'
});
const $f59079bf3589c5a6$var$KeyboardShortcut = (0, $8CUq3.xcss)({
    border: `1px solid ${"var(--ds-text-inverse, #FFFFFF)"}`,
    borderRadius: '2px',
    marginLeft: 'space.050',
    paddingTop: 'space.025',
    paddingBottom: 'space.025',
    paddingRight: 'space.100',
    paddingLeft: 'space.100',
    lineHeight: 'space.200'
});

});
parcelRegister("5JpK2", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::95f2961def649e58284c9134f09a8716>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $42c51f70ef43f1c0$var$_react = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $42c51f70ef43f1c0$var$_growDiagonal = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("l14Zy")));

var $42c51f70ef43f1c0$var$_actualSize = $42c51f70ef43f1c0$var$_interopRequireDefault((parcelRequire("6LXPU")));
function $42c51f70ef43f1c0$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for GrowDiagonalIcon.
 * This component is GrowDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesActualSizeIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for increasing the size of an element when height and width are changed concurrently.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $42c51f70ef43f1c0$var$GrowDiagonalIcon = (props)=>/*#__PURE__*/ $42c51f70ef43f1c0$var$_react.default.createElement($42c51f70ef43f1c0$var$_growDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $42c51f70ef43f1c0$var$_actualSize.default
    }, props));
$42c51f70ef43f1c0$var$GrowDiagonalIcon.Name = 'GrowDiagonalIconMigration';
var $42c51f70ef43f1c0$var$_default = module.exports.default = $42c51f70ef43f1c0$var$GrowDiagonalIcon;

});

parcelRegister("j2iKG", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::1977529ed36a56b31b9b9f03121ff6d7>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ddbcbff50c42c269$var$_react = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $ddbcbff50c42c269$var$_shrinkDiagonal = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("8KRBa")));

var $ddbcbff50c42c269$var$_fitToPage = $ddbcbff50c42c269$var$_interopRequireDefault((parcelRequire("2bcm3")));
function $ddbcbff50c42c269$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShrinkDiagonalIcon.
 * This component is ShrinkDiagonalIcon, with `UNSAFE_fallbackIcon` set to "MediaServicesFitToPageIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for shrinking the height and width of modals, panels, media, or objects.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $ddbcbff50c42c269$var$ShrinkDiagonalIcon = (props)=>/*#__PURE__*/ $ddbcbff50c42c269$var$_react.default.createElement($ddbcbff50c42c269$var$_shrinkDiagonal.default, Object.assign({
        LEGACY_fallbackIcon: $ddbcbff50c42c269$var$_fitToPage.default
    }, props));
$ddbcbff50c42c269$var$ShrinkDiagonalIcon.Name = 'ShrinkDiagonalIconMigration';
var $ddbcbff50c42c269$var$_default = module.exports.default = $ddbcbff50c42c269$var$ShrinkDiagonalIcon;

});

parcelRegister("gydfO", function(module, exports) {

$parcel$export(module.exports, "default", () => $50014cef8f43c127$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $50014cef8f43c127$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    enterFullScreen: {
        "id": "platform.fullscreen-button.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "platform.fullscreen-button.exit-full-screen",
        "defaultMessage": "Exit full screen"
    },
    fullScreenShortcut: {
        "id": "platform.fullscreen-button.full-screen-shortcut",
        "defaultMessage": "Z"
    }
});

});




parcelRegister("7Nytu", function(module, exports) {

$parcel$export(module.exports, "default", () => $0060f62fca5ba1d1$export$2e2bcd8739ae039);

var $basmW = parcelRequire("basmW");

var $gJBT6 = parcelRequire("gJBT6");

var $bC2fB = parcelRequire("bC2fB");


var $k50Aq = parcelRequire("k50Aq");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $b22uy = parcelRequire("b22uy");
const $0060f62fca5ba1d1$var$getExternalValues = (0, (/*@__PURE__*/$parcel$interopDefault($gJBT6)))((boardId, projectId)=>({
        boardId: boardId,
        projectId: projectId
    }), (boardId, projectId)=>`${boardId}.${projectId}`);
const $0060f62fca5ba1d1$var$connector = (0, $bC2fB.connect)((state)=>({
        externalId: 'software.board.swimlane',
        externalValues: $0060f62fca5ba1d1$var$getExternalValues((0, $67Z81.rapidViewIdSelector)(state), (0, $67Z81.projectIdSelector)(state)),
        swimlaneModes: (0, $45cXl.getSwimlaneModes)(state),
        currentSwimlaneMode: (0, $45cXl.getSwimlaneMode)(state),
        isUserProjectAdmin: (0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] && !(0, $67Z81.getIsCMPBoard)(state)
    }), (dispatch)=>({
        setSwimlaneMode: (swimlaneModeId)=>{
            dispatch((0, $k50Aq.swimlaneModeChangeRequest)(swimlaneModeId));
        }
    }), (stateProps, dispatchProps, ownProps)=>{
    const { isUserProjectAdmin: isUserProjectAdmin, ...restStateProps } = stateProps;
    return {
        ...ownProps,
        ...dispatchProps,
        ...restStateProps
    };
});
var $0060f62fca5ba1d1$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($0060f62fca5ba1d1$var$connector)((0, $b22uy.default));

});
parcelRegister("b22uy", function(module, exports) {

$parcel$export(module.exports, "default", () => $68ae893d6be01501$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $6Ingq = parcelRequire("6Ingq");

var $hORKG = parcelRequire("hORKG");

var $3bDjY = parcelRequire("3bDjY");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $4R6GH = parcelRequire("4R6GH");

var $22OQR = parcelRequire("22OQR");

var $gwIPs = parcelRequire("gwIPs");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $iuuJH = parcelRequire("iuuJH");

var $f3Btq = parcelRequire("f3Btq");
const $68ae893d6be01501$var$SwimlaneSwitch = ({ swimlaneModes: swimlaneModes, setSwimlaneMode: setSwimlaneMode, currentSwimlaneMode: currentSwimlaneMode })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const dropdownMenuRef = (0, $5uXOq.useRef)(null);
    const onCloseFocusHandler = ()=>{
        requestAnimationFrame(()=>dropdownMenuRef.current?.querySelector('button')?.focus());
    };
    const onDropdownOpenChange = ({ isOpen: isOpen })=>{
        setIsDropdownOpen(isOpen);
        if (!isOpen) onCloseFocusHandler();
    };
    const renderTrigger = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>{
        const swimlaneMode = swimlaneModes.find(({ id: id })=>id === currentSwimlaneMode) || (0, $iuuJH.NO_SWIMLANE);
        let swimlaneModeText = formatMessage(swimlaneMode.message, swimlaneMode.values);
        if ((0, $dCm1o.isVisualRefreshEnabled)()) swimlaneModeText = swimlaneMode && swimlaneMode.id !== (0, $iuuJH.NO_SWIMLANE).id ? formatMessage(swimlaneMode.message, swimlaneMode.values) : '';
        const isSelected = triggerProps.isSelected || (0, $dCm1o.isVisualRefreshEnabled)() && Boolean(swimlaneModeText);
        // Hide the icon if there is swimlane mode text
        const iconAfter = (0, $dCm1o.isVisualRefreshEnabled)() && swimlaneModeText ? undefined : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
            LEGACY_size: "medium",
            ...(0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') && !isSelected && {
                color: "var(--ds-icon-subtle, #626F86)"
            },
            ...!(0, $lmBAt.getIsSoftwareThemingEnabled)() && {
                LEGACY_primaryColor: "var(--ds-icon, #44546F)",
                color: "var(--ds-icon, #44546F)"
            }
        });
        const ButtonComponent = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $22OQR.ThemedButton) : (0, $fVnbM.default);
        const triggerContent = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !(0, $dCm1o.isVisualRefreshEnabled)() && swimlaneModeText, (0, $dCm1o.isVisualRefreshEnabled)() && formatMessage((0, $f3Btq.default).groupCardsBy), swimlaneModeText && (0, $dCm1o.isVisualRefreshEnabled)() && `: ${swimlaneModeText}`);
        const trigger = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ButtonComponent, {
            ...triggerProps,
            ref: triggerRef,
            id: "swimlane-switch-menu-trigger",
            "aria-label": (0, $dCm1o.isVisualRefreshEnabled)() ? formatMessage((0, $f3Btq.default).groupCardsByAccessability, {
                label: swimlaneModeText
            }) : undefined,
            iconAfter: iconAfter,
            isSelected: isSelected
        }, (0, $dCm1o.isVisualRefreshEnabled)() && (0, $4R6GH.fg)('visual-refresh-headers-buttons') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $68ae893d6be01501$var$triggerStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            ...isSelected ? {
                color: 'inherit'
            } : {
                color: 'color.text.subtle'
            },
            weight: "medium"
        }, triggerContent)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ae893d6be01501$var$TriggerContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ae893d6be01501$var$TriggerLabel, null, triggerContent)));
        return isDropdownOpen ? trigger : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: swimlaneModeText
        }, trigger);
    }, [
        currentSwimlaneMode,
        formatMessage,
        isDropdownOpen,
        swimlaneModes
    ]);
    const onDropdownItemClick = (0, $5uXOq.useCallback)((swimlaneModeId)=>()=>{
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                actionSubject: 'dropdownItem',
                action: 'clicked'
            }), {
                name: 'setSwimlaneMode',
                swimlaneMode: swimlaneModeId
            });
            setSwimlaneMode(swimlaneModeId);
        }, [
        setSwimlaneMode,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ae893d6be01501$var$SwimlaneSwitchContainer, {
        "data-testid": "software-board.header.controls-bar.swimlane-switch",
        ref: dropdownMenuRef
    }, !(0, $dCm1o.isVisualRefreshEnabled)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($68ae893d6be01501$var$SwimlaneSwitchLabel, {
        htmlFor: "swimlane-switch-menu-trigger"
    }, formatMessage((0, $f3Btq.default).groupCardsByOld)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        isOpen: isDropdownOpen,
        onOpenChange: onDropdownOpenChange,
        trigger: renderTrigger,
        placement: "bottom-end",
        ...(0, $4R6GH.fg)('tanuki_a11y_fixes_drop_2') ? {
            shouldRenderToParent: true
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), null, swimlaneModes.map(({ id: id, message: message, values: values })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
            key: id,
            "data-testid": "software-board.header.controls-bar.swimlane-switch.dropdown-item",
            onClick: onDropdownItemClick(id)
        }, formatMessage(message, values))))));
};
var $68ae893d6be01501$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $68ae893d6be01501$var$SwimlaneSwitch;
const $68ae893d6be01501$var$SwimlaneSwitchContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68ae893d6be01501$var$SwimlaneSwitchLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "label", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c81o8v _syaz131l _1p1dangw _ca0qidpf _u5f3u2gc _n3tdidpf _19bvu2gc",
            __cmplp.className
        ])
    });
});
const $68ae893d6be01501$var$triggerStyles = (0, $8CUq3.xcss)({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values, @atlaskit/ui-styling-standard/no-unsafe-values
    maxWidth: `${(0, $gwIPs.gridSize) * 15}px`,
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68ae893d6be01501$var$TriggerContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $68ae893d6be01501$var$TriggerLabel = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _p12f68cl _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
});

});
parcelRegister("f3Btq", function(module, exports) {

$parcel$export(module.exports, "default", () => $233854cd8bbff9a4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $233854cd8bbff9a4$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    groupCardsByOld: {
        "id": "software.main.header.controls-bar.swimlane-switch.group-cards-by-old",
        "defaultMessage": "Group by"
    },
    groupCardsBy: {
        "id": "software.main.header.controls-bar.swimlane-switch.group-cards-by",
        "defaultMessage": "Group"
    },
    groupCardsByAccessability: {
        "id": "software.main.header.controls-bar.swimlane-switch.group-cards-by-accessability",
        "defaultMessage": "Group by {label}"
    }
});

});



parcelRegister("fjK71", function(module, exports) {

$parcel$export(module.exports, "default", () => $0a9dc3df02e64325$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $bdYfL = parcelRequire("bdYfL");


var $iuuJH = parcelRequire("iuuJH");

var $bRqd3 = parcelRequire("bRqd3");

var $2ON1s = parcelRequire("2ON1s");

var $k50Aq = parcelRequire("k50Aq");

var $6g14V = parcelRequire("6g14V");

var $67Z81 = parcelRequire("67Z81");

var $45cXl = parcelRequire("45cXl");

var $5mTgl = parcelRequire("5mTgl");

var $7Rvok = parcelRequire("7Rvok");
const $0a9dc3df02e64325$export$c31df4bd766f9c35 = (state)=>{
    const hasSwimlanes = (0, $45cXl.getSwimlaneMode)(state) !== (0, $iuuJH.NO_SWIMLANE).id;
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const isViewSettingPanelOpen = (0, $6g14V.getViewSettingsPanel)(state);
    return {
        rapidViewId: Number((0, $67Z81.rapidViewIdSelector)(state)),
        swimlaneIds: (0, $5mTgl.platformSwimlaneIdsSelector)(state),
        isClassic: isCMPBoard,
        hasSwimlanes: hasSwimlanes,
        epicCustomName: (0, $67Z81.getHierarchyNomenclature)(state)?.firstLevelName,
        isViewSettingPanelOpen: isViewSettingPanelOpen
    };
};
const $0a9dc3df02e64325$var$mapDispatchToProps = (dispatch)=>({
        onSwimlaneExpandAll: ()=>{
            dispatch((0, $k50Aq.swimlanesExpand)());
        },
        onSwimlaneCollapseAll: (swimlaneIds, isIPBoard)=>{
            // For the program board, we want to collapse all the swimlanes in the unplanned work column as well
            const swimlanesToCollapseIds = isIPBoard ? swimlaneIds.reduce((acc, id)=>{
                acc.push(id, (0, $bdYfL.appendUnscheduledWorkSwimlaneIdSuffix)(id));
                return acc;
            }, []) : swimlaneIds;
            dispatch((0, $k50Aq.swimlanesCollapse)(swimlanesToCollapseIds));
        },
        onSetShowUnscheduledColumn: (isVisible)=>{
            dispatch((0, $bRqd3.setShowUnscheduledColumn)(isVisible));
        },
        onSetShowOfftrackDependencyLines: (isVisible)=>{
            dispatch((0, $bRqd3.setShowOfftrackDependencyLines)(isVisible));
        },
        onSetIssueIdsToShowDependencies: (issueIds)=>{
            dispatch((0, $bRqd3.setIssueIdsToShowDependencies)(issueIds));
        },
        onTogglePanel: ()=>{
            dispatch((0, $2ON1s.togglePanel)((0, $8cd646738f5ee7ac$export$ba1da943283b9900)));
            dispatch((0, $2ON1s.closeInsightsPanel)());
        }
    });
var $0a9dc3df02e64325$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($0a9dc3df02e64325$export$c31df4bd766f9c35, $0a9dc3df02e64325$var$mapDispatchToProps)((0, $7Rvok.ViewSettings));

});
parcelRegister("7Rvok", function(module, exports) {

$parcel$export(module.exports, "ViewSettings", () => $8e553db342ec60bd$export$4d0b6d35abb3362d);

var $5uXOq = parcelRequire("5uXOq");

var $dPSWJ = parcelRequire("dPSWJ");

var $2vSU6 = parcelRequire("2vSU6");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");


var $d6YZC = parcelRequire("d6YZC");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ipmBb = parcelRequire("ipmBb");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $jB6yt = parcelRequire("jB6yt");

var $38RF4 = parcelRequire("38RF4");

var $8vM1G = parcelRequire("8vM1G");

var $2YP9W = parcelRequire("2YP9W");

var $a2e2Q = parcelRequire("a2e2Q");

var $lmBAt = parcelRequire("lmBAt");

var $iUagi = parcelRequire("iUagi");

var $3n582 = parcelRequire("3n582");

var $4RVsR = parcelRequire("4RVsR");

var $67sX6 = parcelRequire("67sX6");

var $4vVV6 = parcelRequire("4vVV6");

var $vAfHD = parcelRequire("vAfHD");

var $gR0bs = parcelRequire("gR0bs");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $8e553db342ec60bd$export$caf439d171aab0ca = ()=>(0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector)) === (0, $2vSU6.SERVICE_DESK_PROJECT);
const $8e553db342ec60bd$export$4d0b6d35abb3362d = ({ rapidViewId: rapidViewId, isClassic: isClassic, hasSwimlanes: hasSwimlanes, showCardDetails: showCardDetails, epicCustomName: epicCustomName, swimlaneIds: swimlaneIds, isViewSettingPanelOpen: isViewSettingPanelOpen, onSwimlaneExpandAll: onSwimlaneExpandAll, onSwimlaneCollapseAll: onSwimlaneCollapseAll, onSetShowUnscheduledColumn: onSetShowUnscheduledColumn, onSetShowOfftrackDependencyLines: onSetShowOfftrackDependencyLines, onSetIssueIdsToShowDependencies: onSetIssueIdsToShowDependencies, onTogglePanel: onTogglePanel })=>{
    const isIPBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIncrementPlanningBoard));
    const handleSwimlaneCollapseAll = (0, $5uXOq.useCallback)(()=>{
        onSwimlaneCollapseAll(swimlaneIds, isIPBoard);
    }, [
        onSwimlaneCollapseAll,
        swimlaneIds,
        isIPBoard
    ]);
    const isCompanyManaged = (0, $63LqY.useIsCMPBoard)();
    const isQuickFilterAvailable = (0, $67sX6.useBoardSelector)((0, $5mTgl.getCustomFilters)).length > 0;
    const showFilterBarToggle = isCompanyManaged && (!(0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() || isQuickFilterAvailable);
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isJSMBoard = $8e553db342ec60bd$export$caf439d171aab0ca();
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const showUnscheduledColumn = (0, $iDGXn.useShowUnscheduledColumn)();
    const showOfftrackDependencyLines = (0, $iDGXn.useShowOfftrackDependencyLines)();
    const issueIdsToShowDependencies = (0, $iDGXn.useIssueIdsToShowDependencies)();
    const isDaysInColumnEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDaysInColumnEnabled));
    const isDueDateEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsDueDateEnabled));
    const isLabelsEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsIssueLabelsEnabled));
    const cardExtraFields = (0, $67sX6.useBoardSelector)((0, $67Z81.getCardExtraFields));
    const isEstimateEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsEstimateEnabled));
    const isPriorityEnabled = (0, $67sX6.useBoardSelector)((0, $67Z81.getIsPriorityEnabled));
    const canEdit = (0, $67sX6.useBoardSelector)((0, $67Z81.getCanEditBoard));
    const canInvite = (0, $67sX6.useBoardSelector)((0, $67Z81.getCanInviteOthersToProject));
    const { canUserLinkIssue: canUserLinkIssue, issueLinkTypes: issueLinkTypes } = (0, $67sX6.useBoardSelector)((0, $4vVV6.getIssueLinksPermissions));
    const firstSelectableIssueId = (0, $67sX6.useBoardSelector)((0, $gR0bs.getFirstSelectableIssueAscending));
    const issues = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssues));
    const issuesWithLinksById = (0, $67sX6.useBoardSelector)((0, $5mTgl.getIssuesEntriesWithIssueLinks));
    const issueLinkTypesForBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueLinkTypes));
    const issueTypes = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueTypes));
    // this is a hacky way to aviod cyclic dependency between view-settings and software board. It can go away if Issue type and CardType type gets extracted to board common.
    const issuesWithLinksByIdAnalytics = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(issuesWithLinksById, (i)=>({
                typeId: i.typeId,
                issueLinks: i.issueLinks
            })), [
        issuesWithLinksById
    ]);
    const issueTypesAnalytics = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($dPSWJ)))(issueTypes, (t)=>({
                hierarchyLevelType: t.hierarchyLevelType
            })), [
        issueTypes
    ]);
    const isIssueLinkingEnabledOnInstance = canUserLinkIssue && issueLinkTypes?.length > 0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const boardIssueIds = (0, $67sX6.useBoardSelector)((0, $vAfHD.boardOrderedIssueIdsSelector));
    const onLinkedIssuesStatsToggledOn = (0, $67sX6.useBoardActionCreator)(()=>(0, $4RVsR.fetchIssueLinksStats)(boardIssueIds, {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const onShowCardCoversToggledOn = (0, $67sX6.useBoardActionCreator)(()=>(0, $3n582.fetchCardCovers)(boardIssueIds, {
            analyticsEvent: createAnalyticsEvent({})
        }));
    const [, { doFetch: updateWorkSuggestionsEnabled }] = (0, $d6YZC.useNextBestTaskUserPreference)();
    const { data: isWorkSuggestionsEnabledData, update: updateWorkSuggestionsResource, loading: loadingWorkSuggestionsEnabled } = (0, $2YP9W.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const onToggleWorkSuggestions = (analyticsEvent)=>{
        const newOptInValue = !isWorkSuggestionsEnabledData?.hasUserOptedIn;
        updateWorkSuggestionsResource(()=>({
                hasUserOptedIn: newOptInValue
            }));
        updateWorkSuggestionsEnabled({
            hasUserOptedIn: newOptInValue
        });
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, (0, $ba3e099a37b09fda$export$9957974f8b4d8f74), {
            hasUserOptedIn: newOptInValue
        });
    };
    const { isSoftwareFullTheming: isSoftwareFullTheming } = (0, $lmBAt.getIsSoftwareThemingEnabled)() ? (0, $a2e2Q.useSoftwareProjectTheming)() : {
        isSoftwareFullTheming: false
    };
    (0, $5uXOq.useEffect)(()=>{
        // Setting the unscheduled column visibility state in IP board based on the value from view settings package
        if (isIncrementPlanningBoard) {
            onSetShowUnscheduledColumn(showUnscheduledColumn);
            onSetShowOfftrackDependencyLines(showOfftrackDependencyLines);
            onSetIssueIdsToShowDependencies(issueIdsToShowDependencies);
        }
    }, [
        isIncrementPlanningBoard,
        showUnscheduledColumn,
        showOfftrackDependencyLines,
        issueIdsToShowDependencies,
        onSetShowUnscheduledColumn,
        onSetShowOfftrackDependencyLines,
        onSetIssueIdsToShowDependencies
    ]);
    if (isIncrementPlanningBoard) {
        const analytics = {
            // Move the object into ViewSettingsPopup when cleaning up FG
            analyticsData: {
                issuesWithLinksById: issuesWithLinksByIdAnalytics,
                issueLinkTypes: issueLinkTypesForBoard,
                issueTypes: issueTypesAnalytics
            }
        };
        // Increment planning settings only have unscheduled column toggle and swimlane expand/collapse
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
            boardId: rapidViewId,
            isClassic: isClassic,
            view: (0, $a4XJc.View).INCREMENT_PLANNING_BOARD,
            isSwimlanesEnabled: hasSwimlanes,
            onSwimlaneExpandAll: onSwimlaneExpandAll,
            onSwimlaneCollapseAll: handleSwimlaneCollapseAll,
            dependencyIssueOptions: issues,
            shouldRenderPopupToParent: (0, $4R6GH.fg)('jpo_a11y_pb_fixes') ? true : undefined,
            ...(0, $4R6GH.fg)('issue_cards_in_program_board') ? {
                epicCustomName: epicCustomName,
                isEstimateEnabled: isEstimateEnabled,
                isPriorityEnabled: isPriorityEnabled
            } : {},
            ...analytics
        });
    }
    if ((0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isJSMBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        boardId: rapidViewId,
        isClassic: isClassic,
        view: (0, $a4XJc.View).JSM_BOARD,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isSwimlanesEnabled: hasSwimlanes,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: handleSwimlaneCollapseAll,
        showFilterBarToggle: showFilterBarToggle
    });
    const renderAdditionalFieldSpotlight = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsSyncFromLocalStorageWrapper), {
            boardId: rapidViewId,
            view: (0, $a4XJc.View).BOARD,
            isDaysInColumnEnabled: isDaysInColumnEnabled,
            cardExtraFields: cardExtraFields,
            isDueDateEnabled: isDueDateEnabled,
            isLabelsEnabled: isLabelsEnabled,
            isEstimateEnabled: isEstimateEnabled,
            isPriorityEnabled: isPriorityEnabled
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $38RF4.ViewSettingsButton), {
            isSelected: isViewSettingPanelOpen || false,
            onClick: onTogglePanel,
            ...(0, $lmBAt.getIsSoftwareThemingEnabled)() && {
                isThemedButton: isSoftwareFullTheming
            }
        }));
    if ((0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelOnboarding), {
        isViewSettingPanelOpen: isViewSettingPanelOpen,
        onTogglePanel: onTogglePanel
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8vM1G.ViewSettingsPanelButtonSpotlight), null, renderAdditionalFieldSpotlight()));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jB6yt.default), {
        boardId: rapidViewId,
        isClassic: isClassic,
        view: (0, $a4XJc.View).BOARD,
        epicCustomName: epicCustomName,
        showCardDetails: showCardDetails,
        isSwimlanesEnabled: hasSwimlanes,
        onSwimlaneExpandAll: onSwimlaneExpandAll,
        onSwimlaneCollapseAll: handleSwimlaneCollapseAll,
        showFilterBarToggle: showFilterBarToggle,
        isWorkSuggestionsEnabled: !!isWorkSuggestionsEnabledData?.hasUserOptedIn,
        showWorkSuggestions: isWorkSuggestionsEnabledData != null && !loadingWorkSuggestionsEnabled && isJSWBoard,
        onToggleWorkSuggestions: onToggleWorkSuggestions,
        showLinkedIssueStatsToggle: isIssueLinkingEnabledOnInstance && Boolean(firstSelectableIssueId),
        onLinkedIssuesStatsToggledOn: onLinkedIssuesStatsToggledOn,
        isAddPeopleButtonEnabled: canEdit || canInvite && (0, $6s1PB.expValEquals)('open_invite_for_open_tmp_projects', 'cohort', 'experiment'),
        onShowCardCoversToggledOn: onShowCardCoversToggledOn
    });
};

});
parcelRegister("8vM1G", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsPanelOnboarding", () => $2f6bb1e464f0a6ca$export$215da70478ebbc7);
$parcel$export(module.exports, "ViewSettingsPanelButtonSpotlight", () => $2f6bb1e464f0a6ca$export$67c31a192079fb3c);

var $5uXOq = parcelRequire("5uXOq");

var $vIiRg = parcelRequire("vIiRg");

var $5Fk4Z = parcelRequire("5Fk4Z");
var $1QiBP = parcelRequire("1QiBP");

var $eGLgs = parcelRequire("eGLgs");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $hchBL = parcelRequire("hchBL");

var $ehdJY = parcelRequire("ehdJY");

var $cYeCp = parcelRequire("cYeCp");


var $jnjYD = parcelRequire("jnjYD");
const $2f6bb1e464f0a6ca$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $2f6bb1e464f0a6ca$var$ViewSettingsPanelOnboardingBase = ({ onTogglePanel: onTogglePanel, isViewSettingPanelOpen: isViewSettingPanelOpen })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [viewSettingsPanelRef] = (0, $hchBL.useGlobalRef)((0, $3795a016b6403547$export$989661c424340ff8));
    const [addPeopleButtonRef] = (0, $hchBL.useGlobalRef)((0, $3795a016b6403547$export$4a16d41d3ff730bf));
    const [activeSpotlight, setActiveSpotlight] = (0, $5uXOq.useState)(0);
    const next = (0, $5uXOq.useCallback)(()=>setActiveSpotlight((current)=>current !== null ? current + 1 : 0), []);
    const renderSpotlight = (0, $5uXOq.useCallback)((stop)=>{
        const finalStepActions = [
            {
                text: formatMessage((0, $jnjYD.default).doneStepButton),
                onClick: ()=>{
                    isViewSettingPanelOpen && onTogglePanel();
                    (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDone');
                    setActiveSpotlight(null);
                    stop && stop();
                }
            }
        ];
        const isAddPeopleButtonAvailable = Boolean(addPeopleButtonRef);
        const numberOfSpotlights = isAddPeopleButtonAvailable ? 3 : 2;
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$a57856d4380e4bb8),
                target: (0, $3795a016b6403547$export$a57856d4380e4bb8),
                heading: formatMessage((0, $jnjYD.default).viewSettingsButtonStepTitle),
                actionsBeforeElement: `1/${numberOfSpotlights}`,
                actions: [
                    {
                        text: formatMessage((0, $jnjYD.default).nextStepButton),
                        onClick: ()=>{
                            !isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $jnjYD.default).dismissStepButton),
                        onClick: ()=>{
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ],
                targetRadius: 3,
                targetBgColor: "var(--ds-surface, #FFFFFF)",
                dialogPlacement: "bottom right",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $jnjYD.default).viewSettingsButtonStepContent)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$989661c424340ff8),
                targetNode: viewSettingsPanelRef,
                actionsBeforeElement: `2/${numberOfSpotlights}`,
                actions: isAddPeopleButtonAvailable ? [
                    {
                        text: formatMessage((0, $jnjYD.default).nextStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightNext');
                            next();
                        }
                    },
                    {
                        text: formatMessage((0, $jnjYD.default).dismissStepButton),
                        onClick: ()=>{
                            isViewSettingPanelOpen && onTogglePanel();
                            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({}), 'button clicked', 'jswViewSettingsPanelSpotlightDismiss');
                            setActiveSpotlight(null);
                            stop && stop();
                        }
                    }
                ] : finalStepActions,
                targetRadius: 10,
                targetBgColor: "var(--ds-surface, #FFFFFF)",
                dialogPlacement: "left top",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight.1",
                messageType: "engagement"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $jnjYD.default).viewSettingsPanelFirstPartContent)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $jnjYD.default).viewSettingsPanelSecondPartContentIssueTermRefresh : (0, $jnjYD.default).viewSettingsPanelSecondPartContent)))),
            isAddPeopleButtonAvailable ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                key: (0, $3795a016b6403547$export$4a16d41d3ff730bf),
                targetNode: addPeopleButtonRef,
                heading: formatMessage((0, $jnjYD.default).addPeopleButtonStepTitle),
                actionsBeforeElement: `3/${numberOfSpotlights}`,
                actions: finalStepActions,
                targetRadius: (0, $vIiRg.AVATAR_SIZES).medium,
                targetBgColor: "var(--ds-surface, #FFFFFF)",
                dialogPlacement: "bottom left",
                messageId: "software-view-settings.ui.view-settings-panel-onboarding.jira-spotlight.2",
                messageType: "engagement"
            }, formatMessage((0, $jnjYD.default).addPeopleButtonStepContent)) : null
        ];
        return activeSpotlight != null ? spotlights[activeSpotlight] : null;
    }, [
        activeSpotlight,
        createAnalyticsEvent,
        formatMessage,
        isViewSettingPanelOpen,
        next,
        onTogglePanel,
        viewSettingsPanelRef,
        addPeopleButtonRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $3795a016b6403547$export$8be246eeba922980),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2f6bb1e464f0a6ca$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderSpotlight(stop))));
};
const $2f6bb1e464f0a6ca$export$215da70478ebbc7 = (0, $7XYc4.componentWithCondition)((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled), $2f6bb1e464f0a6ca$var$ViewSettingsPanelOnboardingBase, ()=>null);
const $2f6bb1e464f0a6ca$export$67c31a192079fb3c = ({ children: children })=>{
    if ((0, $cYeCp.isViewSettingsPanelAndTailoredViewExperimentEnabled)()) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: (0, $3795a016b6403547$export$a57856d4380e4bb8)
    }, children);
    return children;
};

});
parcelRegister("jnjYD", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d14ba5d33834aaf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6d14ba5d33834aaf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    viewSettingsButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-title",
        "defaultMessage": "Customize your view"
    },
    viewSettingsButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-button-step-content",
        "defaultMessage": "Use view settings to simplify the look and feel of your board and backlog."
    },
    viewSettingsPanelFirstPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-first-part-content",
        "defaultMessage": "Switch on what you need, and switch off what you don\u2019t."
    },
    viewSettingsPanelSecondPartContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content",
        "defaultMessage": "Choose to show or hide panels, filters, and issue fields, and change the density of your view."
    },
    addPeopleButtonStepTitle: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-title",
        "defaultMessage": "Share your view"
    },
    addPeopleButtonStepContent: {
        "id": "software-view-settings.view-settings-panel-onboarding.add-people-button-step-content",
        "defaultMessage": "Now when you add a new teammate to Jira, you can share your view settings so they see what you see. Includes view settings and filters."
    },
    nextStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.next-step-button",
        "defaultMessage": "Next"
    },
    dismissStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.dismiss-step-button",
        "defaultMessage": "Dismiss"
    },
    doneStepButton: {
        "id": "software-view-settings.view-settings-panel-onboarding.done-step-button",
        "defaultMessage": "Done"
    },
    viewSettingsPanelSecondPartContentIssueTermRefresh: {
        "id": "software-view-settings.view-settings-panel-onboarding.view-settings-panel-second-part-content-issue-term-refresh",
        "defaultMessage": "Choose to show or hide panels, filters, and fields, and change the density of your view."
    }
});

});





parcelRegister("XvlUo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cf6aedc51c9a9b1$export$2e2bcd8739ae039);

var $eCgfP = parcelRequire("eCgfP");

var $bC2fB = parcelRequire("bC2fB");


var $cW3pH = parcelRequire("cW3pH");

var $k8auG = parcelRequire("k8auG");
const $9cf6aedc51c9a9b1$export$c31df4bd766f9c35 = (state)=>({
        operations: (0, $k8auG.operationsSelector)(state)
    });
const $9cf6aedc51c9a9b1$export$9e6a17cf56877796 = (dispatch)=>({
        onModalClose: ()=>{
            dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$a0b8ab2c9a9afaaa)));
        }
    });
const $9cf6aedc51c9a9b1$var$ConnectedExtension = (0, $bC2fB.connect)($9cf6aedc51c9a9b1$export$c31df4bd766f9c35, $9cf6aedc51c9a9b1$export$9e6a17cf56877796)((0, $eCgfP.default));
var $9cf6aedc51c9a9b1$export$2e2bcd8739ae039 = $9cf6aedc51c9a9b1$var$ConnectedExtension;

});
parcelRegister("eCgfP", function(module, exports) {

$parcel$export(module.exports, "default", () => $30adade8afbc4e74$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $9AYKy = parcelRequire("9AYKy");
function $30adade8afbc4e74$export$2e2bcd8739ae039(props) {
    if (props.isTabNavigation) {
        if (props.operations.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AYKy.default), {
                key: op.url,
                operation: op,
                onModalClose: props.onModalClose,
                isTabNavigation: true
            })));
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.operations.map((op)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($30adade8afbc4e74$var$OperationWrapper, {
            key: op.url
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9AYKy.default), {
            operation: op,
            onModalClose: props.onModalClose
        }))));
}
$30adade8afbc4e74$export$2e2bcd8739ae039.defaultProps = {
    operations: [],
    onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
    isTabNavigation: false
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $30adade8afbc4e74$var$OperationWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_2hwxu2gc _1xoqidpf",
            __cmplp.className
        ])
    });
});

});
parcelRegister("9AYKy", function(module, exports) {

$parcel$export(module.exports, "default", () => $40b405f55a447be3$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $hRf4g = parcelRequire("hRf4g");

var $8vDvO = parcelRequire("8vDvO");

var $kJpBP = parcelRequire("kJpBP");

var $3bDjY = parcelRequire("3bDjY");

var $jjlQu = parcelRequire("jjlQu");

var $gwIPs = parcelRequire("gwIPs");

var $3HwlS = parcelRequire("3HwlS");
const $40b405f55a447be3$var$iconSize = (0, $gwIPs.gridSize) * 3;
class $40b405f55a447be3$export$2e2bcd8739ae039 extends (0, $5uXOq.Component) {
    static{
        // go/jfe-eslint
        // eslint-disable-next-line react/sort-comp
        this.defaultProps = {
            operation: {},
            onModalClose: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            isTabNavigation: false
        };
    }
    static{
        this.getFallbackIcon = (name)=>(0, $3HwlS.getWillShowNav4)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                label: name,
                color: "var(--ds-icon, #44546F)"
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8vDvO))), {
                LEGACY_size: "medium",
                spacing: "spacious",
                label: name
            });
    }
    /*
   * ABE-22: The reason for using this 'invisible' anchor with an href is needed, instead of simply
   * passing the href to the component which would then have an underlying anchor, is that the
   * styleClasses list of classes here are needed to trigger the ecosystem addon modal to come
   * up on click. This is in contrast to the component behaviour of a vanilla anchor that
   * currently does not support custom classes, which would redirect to a Jira 404 error page.
   */ renderEcosystemModalLink() {
        const { url: url, styleClass: styleClass } = this.props.operation;
        return(// go/jfe-eslint
        // eslint-disable-next-line @atlaskit/design-system/no-html-anchor, jsx-a11y/anchor-has-content
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: url,
            // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
            className: styleClass,
            ref: this.setEcosystemModalLinkRef,
            // eslint-disable-next-line jira/react/no-style-attribute
            style: {
                // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                display: 'none'
            }
        }));
    }
    renderIcon() {
        const { icon: icon, name: name } = this.props.operation;
        return icon && icon.url ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jjlQu.default), {
            title: name,
            url: icon.url,
            width: $40b405f55a447be3$var$iconSize,
            height: $40b405f55a447be3$var$iconSize,
            fallback: ()=>$40b405f55a447be3$export$2e2bcd8739ae039.getFallbackIcon(name || '')
        }) : $40b405f55a447be3$export$2e2bcd8739ae039.getFallbackIcon(name || '');
    }
    renderButton() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactChild | undefined'.
            iconBefore: name ? icon : null,
            testId: "common-components-ecosystem-operations.ecosystem-operation.button"
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40b405f55a447be3$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    renderMenuItem() {
        const { name: name } = this.props.operation;
        const icon = this.renderIcon();
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            key: name,
            onClick: this.clickEcosystemModalLinkRef,
            iconBefore: name ? icon : null,
            testId: "common-components-ecosystem-operations.ecosystem-operation.button-item"
        }, name || /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($40b405f55a447be3$var$OnlyIconWrapper, null, icon), this.renderEcosystemModalLink());
    }
    render() {
        const { tooltip: tooltip } = this.props.operation;
        const content = this.props.isTabNavigation ? this.renderMenuItem() : this.renderButton();
        if (tooltip) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: tooltip
        }, content);
        return content;
    }
    constructor(...args){
        super(...args), /* not used yet TOTEM-818 */ this.onModalClose = ()=>this.props.onModalClose(), this.setEcosystemModalLinkRef = (element)=>{
            this.ecosystemModalLinkRef = element;
        }, this.clickEcosystemModalLinkRef = ()=>{
            this.ecosystemModalLinkRef && this.ecosystemModalLinkRef.click();
        };
    }
}
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $40b405f55a447be3$var$OnlyIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4",
            __cmplp.className
        ])
    });
});

});



parcelRegister("lFerq", function(module, exports) {

$parcel$export(module.exports, "default", () => $6be9ad20c9c4766b$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $jzjy1 = parcelRequire("jzjy1");

var $hcObS = parcelRequire("hcObS");

var $4041n = parcelRequire("4041n");

var $2NMNM = parcelRequire("2NMNM");

var $67sX6 = parcelRequire("67sX6");

var $k8auG = parcelRequire("k8auG");
const $6be9ad20c9c4766b$export$8d5dab2ad1e19ea0 = (props)=>{
    const { itemId: itemId, itemType: itemType } = props;
    const isFavoriteInitial = (0, $67sX6.useBoardSelector)((0, $k8auG.isFavouriteSelector));
    const { items: items, changeFavorite: changeFavorite } = (0, $5uXOq.useContext)((0, $4041n.FavoriteChangeContext));
    const changeItem = items[itemType]?.[itemId];
    const isFavorite = changeItem ? changeItem.value : isFavoriteInitial ?? false;
    const isPending = changeItem ? changeItem.pending : isFavoriteInitial === undefined;
    const skipAnimation = (0, $5uXOq.useRef)(true);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    (0, $5uXOq.useEffect)(()=>{
        if (isFavoriteInitial !== undefined) {
            skipAnimation.current = false;
            const item = items[itemType];
            if (item && !item[itemId]) item[itemId] = {
                id: itemId,
                type: itemType,
                value: isFavoriteInitial,
                pending: false
            };
        }
    }, [
        isFavoriteInitial,
        itemId,
        itemType,
        items
    ]);
    const onClick = (0, $5uXOq.useCallback)(()=>{
        const analyticsEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'favouriteButton'
        });
        changeFavorite({
            id: itemId,
            type: itemType,
            value: !isFavorite
        }, analyticsEvent);
    }, [
        changeFavorite,
        createAnalyticsEvent,
        isFavorite,
        itemId,
        itemType
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hcObS.default), {
        ...props,
        isFavorite: isFavorite,
        pending: isPending,
        onClick: onClick,
        skipAnimation: skipAnimation.current
    });
};
var $6be9ad20c9c4766b$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))((0, $jzjy1.AnalyticsSubject)('board'))($6be9ad20c9c4766b$export$8d5dab2ad1e19ea0);

});

parcelRegister("7jxaT", function(module, exports) {

$parcel$export(module.exports, "default", () => $27d2c5865b3087c1$export$2e2bcd8739ae039);

var $3HwlS = parcelRequire("3HwlS");

var $bC2fB = parcelRequire("bC2fB");

var $4R6GH = parcelRequire("4R6GH");

var $2xFXk = parcelRequire("2xFXk");


var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $kc6Ry = parcelRequire("kc6Ry");

var $4gt6L = parcelRequire("4gt6L");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $5mTgl = parcelRequire("5mTgl");

var $a7rpP = parcelRequire("a7rpP");
const $27d2c5865b3087c1$export$c31df4bd766f9c35 = (state)=>{
    const permissions = (0, $1vXOx.getPermissionsSelector)(state);
    const isCMPBoard = (0, $67Z81.getIsCMPBoard)(state);
    const boardType = (0, $67Z81.getBoardType)(state);
    return {
        isDisabled: !permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] || isCMPBoard,
        projectKey: (0, $67Z81.projectKeySelector)(state),
        issueTypeId: (0, $4gt6L.firstIssueTypeIdSelector)(state) || '',
        isEditSprintItemVisible: (0, $ebHh7.activeSprintsSelector)(state)?.[0]?.canUpdateSprint ?? false,
        isCardMediaSwitchEnabled: false,
        isConfigureBoardEnabled: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !isCMPBoard,
        isManageCustomFiltersEnabled: permissions[0, $e525e6c25695c9df$export$aadc620ce91112df] === true && !isCMPBoard,
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        sprintId: (0, $ebHh7.activeSprintsSelector)(state)?.[0]?.id,
        isReleaseVersionVisible: isCMPBoard && boardType === 'KANBAN' && (0, $5mTgl.isReleasesFeatureEnabled)(state) && (0, $kc6Ry.getCapability)(state)((0, $2xFXk.Capability).RENDER_BOARD_RELEASE_MENU_BUTON),
        hasOperations: (0, $3HwlS.getWillShowNav4)() && (0, $k8auG.operationsSelector)(state).length > 0,
        shouldShowStandupsFeature: (0, $4R6GH.fg)('jira-warepil-standup-toggle') ? (0, $k8auG.isStandupsEnabled)(state) : true
    };
};
const $27d2c5865b3087c1$export$9e6a17cf56877796 = {};
var $27d2c5865b3087c1$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($27d2c5865b3087c1$export$c31df4bd766f9c35, $27d2c5865b3087c1$export$9e6a17cf56877796)((0, $a7rpP.default));

});
parcelRegister("a7rpP", function(module, exports) {

$parcel$export(module.exports, "default", () => $8897bbc801abac9f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $8U6zd = parcelRequire("8U6zd");

var $3oUqw = parcelRequire("3oUqw");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $hCCtP = parcelRequire("hCCtP");

var $3Tty1 = parcelRequire("3Tty1");

var $47gW9 = parcelRequire("47gW9");

var $4mO32 = parcelRequire("4mO32");

var $jDKvL = parcelRequire("jDKvL");

var $koVbs = parcelRequire("koVbs");

var $g7crU = parcelRequire("g7crU");

var $dXq4S = parcelRequire("dXq4S");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $aCKi5 = parcelRequire("aCKi5");

var $fNWqR = parcelRequire("fNWqR");

var $e8X1M = parcelRequire("e8X1M");

var $bsWqi = parcelRequire("bsWqi");

var $34djr = parcelRequire("34djr");

var $koeKL = parcelRequire("koeKL");

var $dCm1o = parcelRequire("dCm1o");

var $7mPT9 = parcelRequire("7mPT9");

var $1393U = parcelRequire("1393U");

var $6s1PB = parcelRequire("6s1PB");

var $2xFXk = parcelRequire("2xFXk");

var $hz3OZ = parcelRequire("hz3OZ");

var $63LqY = parcelRequire("63LqY");

var $9eTg7 = parcelRequire("9eTg7");

var $90DyW = parcelRequire("90DyW");

var $6w38i = parcelRequire("6w38i");

var $eNd21 = parcelRequire("eNd21");

var $bdV6X = parcelRequire("bdV6X");

var $21vu4 = parcelRequire("21vu4");

var $efqda = parcelRequire("efqda");

var $lLint = parcelRequire("lLint");

var $7EoeF = parcelRequire("7EoeF");

var $iiKcf = parcelRequire("iiKcf");

var $7IClo = parcelRequire("7IClo");

var $1YHJ6 = parcelRequire("1YHJ6");

var $gqdF8 = parcelRequire("gqdF8");

var $c1wgv = parcelRequire("c1wgv");
const $8897bbc801abac9f$var$BoardMenuWithForgeRuntimeContainer = ({ isCardMediaSwitchEnabled: isCardMediaSwitchEnabled, isConfigureBoardEnabled: isConfigureBoardEnabled, isDisabled: isDisabled, isEditSprintItemVisible: isEditSprintItemVisible, isManageCustomFiltersEnabled: isManageCustomFiltersEnabled, issueTypeId: issueTypeId, projectKey: projectKey, boardId: boardId, sprintId: sprintId, isReleaseVersionVisible: isReleaseVersionVisible, hasOperations: hasOperations, boardType: boardType, isActiveStandup: isActiveStandup, hasActiveSprint: hasActiveSprint, isSprintsEnabled: isSprintsEnabled, rapidViewId: rapidViewId, setIsActiveStandup: setIsActiveStandup, shouldShowStandupsFeature: shouldShowStandupsFeature })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [isPopupOpen, setIsPopupOpen] = (0, $5uXOq.useState)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const moreActionsTriggerRef = (0, $5uXOq.useRef)(null);
    const [isFullscreen, { setIsFullscreen: setIsFullscreen }] = (0, $g7crU.useIsFullscreen)();
    const isJSMBoard = (0, $63LqY.useIsJSMBoard)();
    const canEditBoard = (0, $63LqY.useCanEditBoard)();
    const visualRefreshEnabled = (0, $dCm1o.isVisualRefreshEnabled)();
    const isJSWBoard = // eslint-disable-next-line react-hooks/rules-of-hooks
    visualRefreshEnabled ? (0, $63LqY.useIsJSWBoard)() : undefined;
    const isIncrementPlanningBoard = visualRefreshEnabled ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $63LqY.useIsIncrementPlanningBoard)() : undefined;
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const shouldRenderBoardMoreMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_MORE_MENU_ITEM);
    // move the Enter Fullscreen action in dropdown if Nav4 && EAP for Software projects only
    const shouldRenderFullscreenMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_FULLSCREEN_MENU_ITEM);
    const shouldRenderBoardSettingsMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_BOARD_SETTINGS_MENU_ITEM);
    const shouldRenderCreateBoardMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_CREATE_BOARD_MENU_ITEM);
    const shouldRenderEditSprintMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_EDIT_SPRINT_MENU_ITEM);
    const shouldRenderManageWorkflowMenuItem = (0, $63LqY.useCapability)((0, $2xFXk.Capability).RENDER_MANAGE_WORKFLOW_MENU_ITEM);
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const cloudId = (0, $koeKL.useCloudId)();
    const isConnectAppsVisible = (0, $fNWqR.useHasToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: 'work',
        itemLocations: (0, $21vu4.boardConnectAppLocations)
    }) || (hasOperations ?? false);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsPopupOpen(false);
    }, [
        setIsPopupOpen
    ]);
    const onPopupClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'popupMenu',
            action: 'toggled'
        }), 'boardHeaderMenu');
        setIsPopupOpen(!isPopupOpen);
    }, [
        setIsPopupOpen,
        createAnalyticsEvent,
        isPopupOpen
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)(({ ref: ref, ...triggerProps })=>{
        const triggerRef = (0, $7mPT9.mergeRefs)(ref, moreActionsTriggerRef);
        if ((0, $dCm1o.isVisualRefreshEnabled)() || isTabNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
            ...triggerProps,
            ref: triggerRef,
            icon: (0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))),
            isTooltipDisabled: false,
            label: formatMessage((0, $gqdF8.default).iconButtonLabel),
            onClick: onPopupClick,
            testId: "software-board.header.menu.icon-button",
            isSelected: isPopupOpen
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            ref: triggerRef,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8U6zd))), {
                label: (0, $dCm1o.isVisualRefreshEnabled)() ? '' : 'More actions',
                color: "var(--ds-icon, #44546F)",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3oUqw))),
                LEGACY_primaryColor: "var(--ds-icon, #44546F)"
            }),
            "aria-label": formatMessage((0, $dCm1o.isVisualRefreshEnabled)() ? (0, $gqdF8.default).iconButtonLabel : (0, $gqdF8.default).dropdownAriaLabel),
            onClick: onPopupClick,
            isSelected: isPopupOpen,
            testId: "software-board.header.menu.button"
        });
    }, [
        formatMessage,
        onPopupClick,
        isPopupOpen,
        isTabNavigation
    ]);
    const boardAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const toggleFullscreen = (0, $5uXOq.useCallback)(()=>{
        setIsFullscreen(!isFullscreen);
        onClose();
    }, [
        isFullscreen,
        setIsFullscreen,
        onClose
    ]);
    const shortcutsKeyMap = {
        z: {
            callback: toggleFullscreen
        }
    };
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({
            boardId: boardAri,
            sprintId: (0, $dXq4S.createAri)({
                resourceOwner: 'jira-software',
                cloudId: cloudId,
                resourceType: 'sprint',
                resourceId: String(sprintId)
            }),
            fetchSprints: true,
            isCompanyManaged: isCMPBoard
        }), [
        boardAri,
        cloudId,
        sprintId,
        isCMPBoard
    ]);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, stopMetric: stopMetric } = (0, $4mO32.useEntryPoint)((0, $bsWqi.editSprintModalEntryPoint), entryPointParams, (0, $hz3OZ.editSprintModalLoad));
    const editSprintModalTriggerRef = (0, $47gW9.useEntryPointButtonTrigger)(entryPointActions);
    const renderReleaseDropdownItem = (0, $5uXOq.useCallback)(()=>isReleaseVersionVisible && isTabNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c1wgv.default), {
            rapidViewId: boardId
        }), [
        boardId,
        isReleaseVersionVisible,
        isTabNavigation
    ]);
    const popupContentStandupButtonRender = (0, $5uXOq.useCallback)(({ label: label, isDisabled: isButtonDisabled, onClick: onButtonClicked, ref: ref })=>{
        const handleButtonClick = ()=>{
            setIsPopupOpen(false);
            onButtonClicked();
        };
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            ref: ref,
            isDisabled: isButtonDisabled,
            onClick: handleButtonClick
        }, label);
    }, []);
    const popupContent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
            maxWidth: isTabNavigation ? 240 : undefined
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, shouldRenderFullscreenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aCKi5.ShortcutLabel), {
                text: "Z"
            }),
            onClick: toggleFullscreen,
            "aria-keyshortcuts": "Z"
        }, isFullscreen ? formatMessage((0, $gqdF8.default).exitFullScreen) : formatMessage((0, $gqdF8.default).enterFullScreen)), !isIncrementPlanningBoard && isJSWBoard && visualRefreshEnabled && shouldShowStandupsFeature && (0, $6s1PB.expVal)('jira-in-product-standups', 'is_enabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1393U.StandupControlButtons), {
            isStandupDisabled: (0, $9eTg7.shouldDisableStandup)({
                boardType: boardType,
                isSprintsEnabled: isSprintsEnabled,
                hasActiveSprint: hasActiveSprint
            }),
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup,
            boardId: Number(rapidViewId),
            render: popupContentStandupButtonRender
        }), isEditSprintItemVisible && shouldRenderEditSprintMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lLint.EditSprintMenuItem), {
            ref: editSprintModalTriggerRef,
            onClick: onClose
        }), shouldRenderManageWorkflowMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $34djr.default), {
            projectKey: projectKey,
            isDisabled: isDisabled,
            issueTypeId: issueTypeId
        }), !isCMPBoard && isManageCustomFiltersEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1YHJ6.default), null) : null, !isCMPBoard && isCardMediaSwitchEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $90DyW.default), {
            isDisabled: isDisabled,
            onClick: onClose
        }) : null, !isCMPBoard && isConfigureBoardEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6w38i.default), null) : null, shouldRenderBoardSettingsMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eNd21.default), null), isCMPBoard && !isTabNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
            boardId: boardId,
            projectKey: projectKey,
            location: "board-tools-1",
            onClickWebItem: onClose,
            mode: "work"
        }), shouldRenderCreateBoardMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efqda.default), {
            onClosePopup: onClose
        }), isCMPBoard && !isTabNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
            boardId: boardId,
            projectKey: projectKey,
            location: "view-actions-work",
            mode: "work",
            onClickWebItem: onClose
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
            boardId: boardId,
            projectKey: projectKey,
            location: "view-actions-print",
            onClickWebItem: onClose,
            mode: "work"
        })), renderReleaseDropdownItem()), isTabNavigation && isConnectAppsVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bdV6X.BoardConnectItems), {
            projectKey: projectKey,
            boardId: boardId,
            onClickWebItem: onClose,
            isTabNavigation: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iiKcf.default), null));
    }, [
        boardId,
        editSprintModalTriggerRef,
        isCMPBoard,
        isJSWBoard,
        isIncrementPlanningBoard,
        isCardMediaSwitchEnabled,
        isConfigureBoardEnabled,
        isConnectAppsVisible,
        isDisabled,
        isEditSprintItemVisible,
        isManageCustomFiltersEnabled,
        isTabNavigation,
        issueTypeId,
        onClose,
        projectKey,
        renderReleaseDropdownItem,
        shouldRenderBoardSettingsMenuItem,
        shouldRenderCreateBoardMenuItem,
        shouldRenderEditSprintMenuItem,
        shouldRenderManageWorkflowMenuItem,
        shouldRenderFullscreenMenuItem,
        isFullscreen,
        toggleFullscreen,
        formatMessage,
        isActiveStandup,
        boardType,
        isSprintsEnabled,
        hasActiveSprint,
        rapidViewId,
        setIsActiveStandup,
        popupContentStandupButtonRender,
        visualRefreshEnabled,
        shouldShowStandupsFeature
    ]);
    const onEditSprintModalClose = (0, $5uXOq.useCallback)((status)=>{
        //  Timeout is required because onClose callback called on Modal onClose instead of onCloseComplete
        setTimeout(()=>moreActionsTriggerRef.current?.focus(), status ? 50 : 400);
    }, []);
    // hide the meatball menu button if user doesn't have edit board permission for JSM project
    if (isJSMBoard && !canEditBoard) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7IClo.BoardActionForgeRuntimeContainer), {
        onAppsFinishLoading: onClose
    }), isEditSprintItemVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7EoeF.default), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        entryPointActions: entryPointActions,
        onReady: stopMetric,
        onClose: onEditSprintModalClose
    }), (shouldRenderFullscreenMenuItem || shouldRenderBoardMoreMenuItem || isTabNavigation && isConnectAppsVisible) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isPopupOpen,
        onClose: onClose,
        placement: "bottom-end",
        content: popupContent,
        trigger: popupTrigger,
        shouldRenderToParent: true,
        testId: "software-board.header.menu.popup"
    }), shouldRenderFullscreenMenuItem && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Tty1.default), {
        keyMap: shortcutsKeyMap
    })));
};
const $8897bbc801abac9f$var$BoardMenu = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jDKvL.ForgeAppsContainer), {
        scope: "board-action"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8897bbc801abac9f$var$BoardMenuWithForgeRuntimeContainer, props));
};
var $8897bbc801abac9f$export$2e2bcd8739ae039 = $8897bbc801abac9f$var$BoardMenu;

});
parcelRegister("jDKvL", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsContainer", () => $b68f39b65da4eb25$export$9d26afcb39445b8e);
$parcel$export(module.exports, "useForgeApps", () => $b68f39b65da4eb25$export$a48819842c5a2f15);
$parcel$export(module.exports, "useIsAppLoading", () => $b68f39b65da4eb25$export$24db0add8de543af);
$parcel$export(module.exports, "useIsAnyAppLoading", () => $b68f39b65da4eb25$export$f65d61db50b49f3);

var $7Jxgt = parcelRequire("7Jxgt");

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $b68f39b65da4eb25$export$9d26afcb39445b8e = (0, $gg7kZ.createContainer)();
const $b68f39b65da4eb25$var$actions = {
    openApp: (appId, extension, action, extensionData = {})=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: [
                    ...openedApps.filter((app)=>app.id !== appId || app.action !== action),
                    {
                        id: appId,
                        extension: extension,
                        extensionData: extensionData,
                        action: action,
                        uuid: (0, $7Jxgt.v4)(),
                        isLoading: true
                    }
                ]
            });
        },
    setAppLoaded: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.map((app)=>app.id === appId && app.action === action && app.isLoading ? {
                        ...app,
                        isLoading: false
                    } : app)
            });
        },
    closeApps: ()=>({ setState: setState })=>{
            setState({
                openedApps: []
            });
        },
    closeApp: (appId, action)=>({ setState: setState, getState: getState })=>{
            const openedApps = getState().openedApps;
            setState({
                openedApps: openedApps.filter((app)=>app.id !== appId || app.action !== action)
            });
        }
};
const $b68f39b65da4eb25$var$Store = (0, $iXqE5.createStore)({
    containedBy: $b68f39b65da4eb25$export$9d26afcb39445b8e,
    initialState: {
        openedApps: []
    },
    actions: $b68f39b65da4eb25$var$actions
});
const $b68f39b65da4eb25$export$a48819842c5a2f15 = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store);
const $b68f39b65da4eb25$var$isAppLoading = (state, { appId: appId, action: action })=>{
    return state.openedApps.some((app)=>app.id === appId && app.action === action && app.isLoading);
};
const $b68f39b65da4eb25$export$24db0add8de543af = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store, {
    selector: $b68f39b65da4eb25$var$isAppLoading
});
const $b68f39b65da4eb25$var$isAnyAppLoading = (state)=>state.openedApps.some((app)=>app.isLoading);
const $b68f39b65da4eb25$export$f65d61db50b49f3 = (0, $3sQ5x.createHook)($b68f39b65da4eb25$var$Store, {
    selector: $b68f39b65da4eb25$var$isAnyAppLoading
});

});

parcelRegister("aCKi5", function(module, exports) {

$parcel$export(module.exports, "ShortcutLabel", () => $e8926de4a65ad47f$export$dfa0cc182ab7b0c3);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $e8926de4a65ad47f$export$dfa0cc182ab7b0c3 = ({ text: text })=>// For A11y add `aria-keyshortcuts={yourShortcut}` to the element you are adding this label to
    // Added `aria-hidden` for the screen readers to ignore the label element
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        "aria-hidden": true,
        xcss: $e8926de4a65ad47f$var$ShortcutLabelComponentStyles
    }, text);
const $e8926de4a65ad47f$var$ShortcutLabelComponentStyles = (0, $8CUq3.xcss)({
    display: 'inline-block',
    backgroundColor: 'color.background.neutral',
    borderRadius: 'border.radius.100',
    font: 'font.body.UNSAFE_small',
    paddingTop: 'space.050',
    paddingBottom: 'space.050',
    paddingLeft: 'space.100',
    paddingRight: 'space.100'
});

});

parcelRegister("fNWqR", function(module, exports) {

$parcel$export(module.exports, "useFetchedToolSections", () => $08c1f6f26ff4abdf$export$32bd6c5ac0419028);
$parcel$export(module.exports, "useHasToolSections", () => $08c1f6f26ff4abdf$export$54be06d39c052cd5);
$parcel$export(module.exports, "useFetchedSprintActions", () => $08c1f6f26ff4abdf$export$d58666d3ff237ccd);

var $5uXOq = parcelRequire("5uXOq");

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");

var $fjfkx = parcelRequire("fjfkx");

var $78UP2 = parcelRequire("78UP2");

var $lEUlW = parcelRequire("lEUlW");
const $08c1f6f26ff4abdf$export$390f32400eaf98c9 = (0, $iXqE5.createStore)({
    name: '@atlassian/jira-software-connect-toolbar',
    initialState: {
        toolSections: null,
        key: null,
        isLoading: false,
        sprintActions: null
    },
    actions: $lEUlW
});
const $08c1f6f26ff4abdf$export$d5aeb5eefb04c978 = (0, $3sQ5x.createHook)($08c1f6f26ff4abdf$export$390f32400eaf98c9, {
    selector: (state)=>state.toolSections
});
function $08c1f6f26ff4abdf$export$32bd6c5ac0419028({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    const [toolSections, { fetchExtensionData: fetchExtensionData }] = $08c1f6f26ff4abdf$export$d5aeb5eefb04c978();
    (0, $5uXOq.useEffect)(()=>{
        fetchExtensionData({
            boardId: boardId,
            projectKey: projectKey,
            mode: mode
        });
    }, [
        boardId,
        fetchExtensionData,
        mode,
        projectKey
    ]);
    return toolSections;
}
function $08c1f6f26ff4abdf$export$54be06d39c052cd5({ boardId: boardId, projectKey: projectKey, mode: mode = 'work', itemLocations: itemLocations = [] }) {
    const toolSections = $08c1f6f26ff4abdf$export$32bd6c5ac0419028({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const relevantSections = (0, $fjfkx.useConnectPluginSections)(toolSections ?? []);
    const hasRelevantSections = relevantSections ? relevantSections.length > 0 : false;
    const hasTargetSections = itemLocations.some((location)=>((toolSections && (0, $78UP2.findSection)(toolSections, location)?.subItems?.filter((item)=>item.id != null).length) ?? 0) > 0);
    return hasTargetSections || hasRelevantSections;
}
const $08c1f6f26ff4abdf$export$fa6cceef0215e684 = (0, $3sQ5x.createHook)($08c1f6f26ff4abdf$export$390f32400eaf98c9, {
    selector: (state)=>state.sprintActions
});
const $08c1f6f26ff4abdf$export$d58666d3ff237ccd = ({ sprintId: sprintId })=>{
    const [sprintActions, { fetchSprintActionsData: fetchSprintActionsData }] = $08c1f6f26ff4abdf$export$fa6cceef0215e684();
    (0, $5uXOq.useEffect)(()=>{
        fetchSprintActionsData({
            sprintId: sprintId
        });
    }, [
        fetchSprintActionsData,
        sprintId
    ]);
    return sprintActions;
};

});
parcelRegister("fjfkx", function(module, exports) {

$parcel$export(module.exports, "useConnectPluginSections", () => $761d5c3db4b1e977$export$9f557e5e5102c0b2);
$parcel$export(module.exports, "BoardToolsView", () => $761d5c3db4b1e977$export$a97914bd35ac0c68);

var $5uXOq = parcelRequire("5uXOq");

var $2NYED = parcelRequire("2NYED");

var $88pw4 = parcelRequire("88pw4");
function $761d5c3db4b1e977$export$9f557e5e5102c0b2(toolSections) {
    return (0, $5uXOq.useMemo)(()=>toolSections?.filter((section)=>section.id !== 'board-tools-section'), [
        toolSections
    ]);
}
function $761d5c3db4b1e977$export$a97914bd35ac0c68({ toolSections: toolSections, mode: mode = 'button', onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false }) {
    const relevantSections = $761d5c3db4b1e977$export$9f557e5e5102c0b2(toolSections);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, relevantSections?.map((section)=>section.type === 'webItem' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolWebItemView), {
            key: section.id,
            subItem: section,
            mode: mode,
            onClickWebItem: mode === 'dropdown-item' ? onClickWebItem : undefined,
            isTabNavigation: isTabNavigation
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $88pw4.BoardToolSectionView), {
            key: section.id,
            section: section,
            isMenuItem: mode === 'dropdown-item' && isTabNavigation,
            isTabNavigation: isTabNavigation
        })));
}

});
parcelRegister("2NYED", function(module, exports) {

$parcel$export(module.exports, "BoardToolWebItemView", () => $d8e9f6c964974fcf$export$37f386501b29905e);
$parcel$export(module.exports, "BoardToolSubItem", () => $d8e9f6c964974fcf$export$dbbc4e042bbab47e);

var $5uXOq = parcelRequire("5uXOq");

var $1GGwS = parcelRequire("1GGwS");

var $BLPHT = parcelRequire("BLPHT");

var $hRf4g = parcelRequire("hRf4g");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $3Z96c = parcelRequire("3Z96c");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $7CMCs = parcelRequire("7CMCs");

var $3HwlS = parcelRequire("3HwlS");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");

var $hrlU6 = parcelRequire("hrlU6");

const $d8e9f6c964974fcf$export$87f324ad8d8a087a = (0, $kxZPA.lazy)(()=>(parcelRequire("8lzLG")).then(({ BoardToolWebPanelView: BoardToolWebPanelView })=>({
            default: BoardToolWebPanelView
        })), {
    moduleId: "./src/packages/software/connect-toolbar/src/common/ui/tool-sections/board-tool-section-view/board-tool-sub-item/board-tool-web-panel-view/index.tsx"
});
function $d8e9f6c964974fcf$export$37f386501b29905e({ subItem: subItem, mode: mode = 'dropdown-item', onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false }) {
    const { url: url, cssClass: cssClass, label: label } = subItem;
    const webItemRef = (0, $5uXOq.useRef)(null);
    const onWebItemClick = (e)=>{
        /**
     * When using the Board & Backlog header menu (the rightmost meatball menu),
     * the button gets unmounted because the menu closes upon clicking the button.
     * As a result, webItemRef.current becomes null when connectHost.triggerWebItem is called.
     * Therefore, we need to store the webItemRef in a variable for proper reference.
     */ const currentNode = webItemRef.current;
        (0, $hrlU6.withConnectHost)((connectHost)=>{
            if (currentNode) connectHost.triggerWebItem(currentNode, cssClass ?? '', url);
        });
        if ((0, $hrlU6.isConnectDialogWebItem)(cssClass ?? '')) {
            e.preventDefault();
            e.stopPropagation();
            if (onClickWebItem) onClickWebItem();
        }
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, mode === 'dropdown-item' ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: isTabNavigation ? label : undefined
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        onClick: onWebItemClick,
        iconBefore: (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
            label: label,
            color: "var(--ds-icon, #44546F)"
        }),
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        ref: webItemRef,
        href: url
    }, label)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.link-item",
        onClick: onWebItemClick,
        ref: webItemRef,
        href: url
    }, label));
}
function $d8e9f6c964974fcf$export$dbbc4e042bbab47e({ subItem: subItem, onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if (subItem.type === 'webItem') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$37f386501b29905e, {
        onClickWebItem: onClickWebItem,
        subItem: subItem,
        isTabNavigation: isTabNavigation
    });
    if (subItem.type === 'section') {
        const content = subItem.subItems?.map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$dbbc4e042bbab47e, {
                key: item.id,
                subItem: item,
                isTabNavigation: isTabNavigation
            }));
        if (subItem.label === '') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, content);
        if (isTabNavigation) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: subItem.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    ...triggerProps,
                    iconBefore: (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                        label: subItem.label,
                        color: "var(--ds-icon, #44546F)"
                    }),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.popup-menu-trigger"
                }, subItem.label)),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
                    maxWidth: 240,
                    onClick: (e)=>e.stopPropagation()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, content))
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
            placement: "right-end",
            trigger: subItem.label,
            testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.board-tool-sub-item.dropdown-menu"
        }, content);
    }
    if (subItem.type === 'webPanel') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-tool-web-panel-view",
        packageName: "@atlassian/jira-software-connect-toolbar",
        teamName: "a4t-tanuki"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: "Loading..."
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($d8e9f6c964974fcf$export$87f324ad8d8a087a, {
        webPanel: subItem
    })));
    return null;
}

});
parcelRegister("8lzLG", function(module, exports) {

let $613c07acd0b27ec7$var$load = (parcelRequire("28QjX"))(4);
module.exports = $613c07acd0b27ec7$var$load("fSRZj").then(()=>parcelRequire('cvEOi'));

});


parcelRegister("88pw4", function(module, exports) {

$parcel$export(module.exports, "BoardToolSectionView", () => $298a4a1ba5bb50fb$export$c57d75d82c2414d5);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");

var $hRf4g = parcelRequire("hRf4g");

var $hORKG = parcelRequire("hORKG");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $3bDjY = parcelRequire("3bDjY");

var $3HwlS = parcelRequire("3HwlS");

var $2NYED = parcelRequire("2NYED");
function $298a4a1ba5bb50fb$export$c57d75d82c2414d5({ section: section, isMenuItem: isMenuItem = false, isTabNavigation: isTabNavigation = false }) {
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    if (isTabNavigation) {
        const content = ()=>section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
                    key: subItem.id,
                    subItem: subItem
                }));
        return isMenuItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "left-start",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: section.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                    ...triggerProps,
                    iconBefore: (0, $3HwlS.getWillShowNav4)() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hRf4g))), {
                        label: section.label,
                        color: "var(--ds-icon, #44546F)"
                    }),
                    iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                        label: "",
                        color: "var(--ds-icon, #44546F)"
                    }),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.popup-menu-trigger"
                }, section.label)),
            content: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
                    maxWidth: 240,
                    onClick: (e)=>e.stopPropagation()
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, content()))
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
            isOpen: isOpen,
            onClose: ()=>setIsOpen(false),
            placement: "bottom-end",
            trigger: (triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                    content: section.label
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                    ...triggerProps,
                    isSelected: isOpen,
                    iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($hORKG))),
                    onClick: ()=>setIsOpen(!isOpen),
                    testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.popup-menu-trigger"
                }, section.label)),
            content: content
        });
    }
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        trigger: section.label,
        testId: "software-connect-toolbar.common.ui.tool-sections.board-tool-section-view.dropdown-menu"
    }, section.subItems?.map((subItem)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            key: subItem.id,
            subItem: subItem
        })));
}

});


parcelRegister("78UP2", function(module, exports) {

$parcel$export(module.exports, "findSection", () => $003eeb674acde218$export$967ce3543c950aeb);
function $003eeb674acde218$export$967ce3543c950aeb(toolSections, location) {
    for(let i = 0; i < toolSections.length; i += 1){
        const item = toolSections[i];
        if (item.type === 'section' && item.id === location) return item;
        if (item.type === 'section' && item.subItems != null) {
            const candidate = $003eeb674acde218$export$967ce3543c950aeb(item.subItems, location);
            if (candidate != null) return candidate;
        }
    }
    return null;
}

});

parcelRegister("lEUlW", function(module, exports) {

$parcel$export(module.exports, "fetchExtensionData", () => $5344c8cf4b3b110f$export$5fe98ae96d282610);
$parcel$export(module.exports, "fetchSprintActionsData", () => $5344c8cf4b3b110f$export$d50a304a5f5a89a3);

var $2YZCu = parcelRequire("2YZCu");

var $agj21 = parcelRequire("agj21");

var $b1Aqw = parcelRequire("b1Aqw");
const $5344c8cf4b3b110f$export$5fe98ae96d282610 = ({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' })=>async ({ getState: getState, setState: setState })=>{
        const key = JSON.stringify([
            projectKey,
            boardId,
            mode
        ]);
        const state = getState();
        if (state.key === key && state.isLoading) return;
        if (state.key !== key) setState({
            toolSections: null,
            isLoading: true,
            key: key
        });
        else setState({
            isLoading: true
        });
        try {
            const response = await (0, $b1Aqw.fetchCMPExtensionData)({
                boardId: boardId,
                projectKey: projectKey,
                mode: mode
            });
            setState({
                toolSections: response.sections,
                key: key,
                isLoading: false
            });
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('software.extension.board-tools', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                isLoading: false
            });
        }
    };
const $5344c8cf4b3b110f$export$d50a304a5f5a89a3 = ({ sprintId: sprintId })=>async ({ getState: getState, setState: setState })=>{
        const { sprintActions: sprintActions } = getState();
        const findActions = sprintActions?.[sprintId] || {
            isLoading: false,
            hasLoaded: false
        };
        if (findActions.isLoading || findActions.hasLoaded) return;
        // set loading to true to prevent multiple requests
        setState({
            sprintActions: {
                ...sprintActions,
                [sprintId]: {
                    isLoading: true,
                    hasLoaded: false
                }
            }
        });
        try {
            const response = await (0, $b1Aqw.fetchCMPSprintActionsData)({
                sprintId: sprintId
            });
            const actionsForSprint = (0, $agj21.transformSprintActionsResponse)(response);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        ...actionsForSprint,
                        isLoading: false,
                        hasLoaded: true
                    }
                }
            });
        } catch (error) {
            (0, $2YZCu.default).safeErrorWithoutCustomerData('software.extension.sprint-actions', error instanceof Error ? error.message : String(error), error instanceof Error ? error : undefined);
            setState({
                sprintActions: {
                    ...getState().sprintActions,
                    [sprintId]: {
                        isLoading: false,
                        hasLoaded: false
                    }
                }
            });
        }
    };

});
parcelRegister("agj21", function(module, exports) {

$parcel$export(module.exports, "transformSprintActionsResponse", () => $96e521c26ac919f8$export$bb626d8539383296);
const $96e521c26ac919f8$export$8b3475589327aa1c = (sprintAction)=>({
        id: sprintAction.id,
        type: 'webItem',
        label: sprintAction.name,
        url: sprintAction.url,
        cssClass: sprintAction.styleClass
    });
const $96e521c26ac919f8$export$5365f133b30aefb1 = (sprintAction)=>Boolean(sprintAction.url);
const $96e521c26ac919f8$export$1d427bb13100a4da = (section)=>section.groupId === 'sprint-move-actions' || section.groupId === 'sprint-edit-action' || section.groupId === 'sprint-delete-action';
const $96e521c26ac919f8$export$bb626d8539383296 = (sprintActionsResponse)=>{
    const result = {};
    sprintActionsResponse.sections.filter($96e521c26ac919f8$export$1d427bb13100a4da).forEach((section)=>{
        const actions = section.actions.filter($96e521c26ac919f8$export$5365f133b30aefb1).map($96e521c26ac919f8$export$8b3475589327aa1c);
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        result[section.groupId] = actions;
    });
    return result;
};

});

parcelRegister("b1Aqw", function(module, exports) {

$parcel$export(module.exports, "fetchCMPExtensionData", () => $ce9155dcdaa49b1d$export$aa96aae4fab07720);
$parcel$export(module.exports, "fetchCMPSprintActionsData", () => $ce9155dcdaa49b1d$export$2a796a8235b7b986);

var $7f4tk = parcelRequire("7f4tk");
function $ce9155dcdaa49b1d$export$aa96aae4fab07720({ boardId: boardId, projectKey: projectKey, mode: mode = 'work' }) {
    return (0, $7f4tk.default)(`/rest/greenhopper/1.0/xboard/toolSections?mode=${mode}&rapidViewId=${boardId}&selectedProjectKey=${projectKey}&_=${Date.now()}&operation=CMPExtensionData`);
}
function $ce9155dcdaa49b1d$export$2a796a8235b7b986({ sprintId: sprintId }) {
    return (0, $7f4tk.default)(`/rest/greenhopper/1.0/xboard/plan/sprints/actions?sprintId=${sprintId}&_=${Date.now()}`);
}

});



parcelRegister("e8X1M", function(module, exports) {

$parcel$export(module.exports, "BoardConnectMenuItems", () => $7ffeafe4bb5b3117$export$d8d46adb5b629caf);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $2NYED = parcelRequire("2NYED");

var $fjfkx = parcelRequire("fjfkx");

var $fNWqR = parcelRequire("fNWqR");

var $78UP2 = parcelRequire("78UP2");
function $7ffeafe4bb5b3117$var$BoardConnectMenuItemsInner({ projectKey: projectKey, boardId: boardId, location: location, mode: mode, onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false }) {
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    const targetSection = (0, $5uXOq.useMemo)(()=>toolSections && location && (0, $78UP2.findSection)(toolSections, location), [
        toolSections,
        location
    ]);
    if (!location && isTabNavigation) return toolSections ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjfkx.BoardToolsView), {
        toolSections: toolSections,
        mode: "dropdown-item",
        onClickWebItem: onClickWebItem,
        isTabNavigation: isTabNavigation
    }) : null;
    if (!toolSections || !targetSection) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, targetSection.subItems?.filter((item)=>item.id != null) // built-in items don't have IDs set
    .map((item)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2NYED.BoardToolSubItem), {
            onClickWebItem: onClickWebItem,
            key: item.id,
            subItem: item,
            isTabNavigation: isTabNavigation
        })) ?? null);
}
function $7ffeafe4bb5b3117$export$d8d46adb5b629caf(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-menu-items",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($7ffeafe4bb5b3117$var$BoardConnectMenuItemsInner, props));
}

});

parcelRegister("bsWqi", function(module, exports) {

$parcel$export(module.exports, "editSprintModalEntryPoint", () => $505b0c872e6b9936$export$62497640baecc927);

var $58I1r = parcelRequire("58I1r");

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $505b0c872e6b9936$export$62497640baecc927 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("aKr3o")), {
        moduleId: "c7ce165f"
    }),
    getPreloadProps: ({ boardId: boardId, sprintId: sprintId, fetchSprints: fetchSprints })=>({
            queries: {
                editSprintModal: {
                    options: {
                        fetchPolicy: 'network-only'
                    },
                    parameters: $58I1r.default,
                    variables: {
                        boardId: boardId,
                        sprintId: sprintId,
                        fetchSprints: fetchSprints
                    }
                }
            }
        })
});

});
parcelRegister("58I1r", function(module, exports) {

$parcel$export(module.exports, "default", () => $b86022cd8e5ea5c2$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<a6471efb4cf0d88bef3ca4f275ac9826>>
 * @relayHash a7c5c4d6570548dfbbb896009ae5fc47
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b
const $b86022cd8e5ea5c2$var$node = {
    "kind": "PreloadableConcreteRequest",
    "params": {
        "id": "90bffcc09f8865bee8f7861946866baaa79e714bb9afc19568bc71a86050977b",
        "metadata": {},
        "name": "uiJiraSoftwareEditSprintModalQuery",
        "operationKind": "query",
        "text": null
    }
};
var $b86022cd8e5ea5c2$export$2e2bcd8739ae039 = $b86022cd8e5ea5c2$var$node;

});

parcelRegister("aKr3o", function(module, exports) {

let $7d332f8faf9241b0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $7d332f8faf9241b0$var$load("ffQaD"),
    $7d332f8faf9241b0$var$load("kvRbA"),
    $7d332f8faf9241b0$var$load("6hU84")
]).then(()=>parcelRequire('cqAIL'));

});


parcelRegister("34djr", function(module, exports) {

$parcel$export(module.exports, "default", () => $cf4b01ed125ead2e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $kJpBP = parcelRequire("kJpBP");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $02Psx = parcelRequire("02Psx");

var $5y0F0 = parcelRequire("5y0F0");

var $bD5EH = parcelRequire("bD5EH");
const $cf4b01ed125ead2e$var$ManageWorkflowMenuItem = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { isDisabled: isDisabled, projectKey: projectKey, issueTypeId: issueTypeId } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5y0F0.RouterActions), null, ({ push: push })=>{
        const onClick = issueTypeId ? ()=>push((0, $02Psx.getNextgenSettingsWorkflowUrl)((0, $2vSU6.SOFTWARE_PROJECT), projectKey, issueTypeId)) : (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            isDisabled: isDisabled || !issueTypeId,
            onClick: onClick
        }, formatMessage((0, $bD5EH.default).displayText));
    });
};
var $cf4b01ed125ead2e$export$2e2bcd8739ae039 = $cf4b01ed125ead2e$var$ManageWorkflowMenuItem;

});
parcelRegister("bD5EH", function(module, exports) {

$parcel$export(module.exports, "default", () => $da7e090061393796$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $da7e090061393796$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software-manage-workflow-menu-item.display-text",
        "defaultMessage": "Manage workflow"
    }
});

});


parcelRegister("90DyW", function(module, exports) {

$parcel$export(module.exports, "default", () => $bca6cd54de9a6900$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");


var $bRqd3 = parcelRequire("bRqd3");

var $1vXOx = parcelRequire("1vXOx");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $9dhHU = parcelRequire("9dhHU");
const $bca6cd54de9a6900$export$c31df4bd766f9c35 = (state, props = {
    isDisabled: false,
    onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
})=>({
        isMediaEnabled: (0, $5mTgl.isCardMediaEnabled)(state),
        isDisabled: props.isDisabled || !(0, $1vXOx.getPermissionsSelector)(state)[0, $e525e6c25695c9df$export$aadc620ce91112df] || (0, $67Z81.getIsCMPBoard)(state)
    });
const $bca6cd54de9a6900$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
const $bca6cd54de9a6900$var$onClickFactory = (0, $8QpSo.default)((dispatch, isMediaEnabled, onClick)=>()=>{
        dispatch((0, $bRqd3.cardMediaToggleRequest)(!isMediaEnabled));
        onClick();
    });
const $bca6cd54de9a6900$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { isMediaEnabled: isMediaEnabled, isDisabled: isDisabled } = stateProps;
    const { dispatch: dispatch } = dispatchProps;
    const { onClick: onClick } = ownProps;
    return {
        isMediaEnabled: isMediaEnabled,
        isDisabled: isDisabled,
        onClick: $bca6cd54de9a6900$var$onClickFactory(dispatch, isMediaEnabled, onClick)
    };
};
const $bca6cd54de9a6900$var$connector = (0, $bC2fB.connect)($bca6cd54de9a6900$export$c31df4bd766f9c35, $bca6cd54de9a6900$export$9e6a17cf56877796, $bca6cd54de9a6900$export$9d1611c77c2fe928);
var $bca6cd54de9a6900$export$2e2bcd8739ae039 = $bca6cd54de9a6900$var$connector((0, $9dhHU.default));

});
parcelRegister("9dhHU", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c71a2cd7b5093e7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $ousew = parcelRequire("ousew");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $3Awmo = parcelRequire("3Awmo");
const $5c71a2cd7b5093e7$var$MediaCardEnableItem = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        key: "card-media-enable",
        isDisabled: props.isDisabled,
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3Awmo.default).showCover));
};
const $5c71a2cd7b5093e7$var$MediaCardDisableItem = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        key: "card-media-disable",
        isDisabled: props.isDisabled,
        onClick: props.onClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ousew.default), (0, $3Awmo.default).hideCover));
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$5c71a2cd7b5093e7$export$2e2bcd8739ae039 = (props)=>{
    const { isMediaEnabled: isMediaEnabled, ...otherProps } = props;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const mediaCardProps = {
        ...otherProps,
        onClick: ()=>{
            props.onClick();
            const event = createAnalyticsEvent({
                action: 'toggle',
                actionSubject: 'cardCoverImageVisibilityToggleMenuItem'
            });
            (0, $8zOmE.fireUIAnalytics)(event, {
                isEnabled: !isMediaEnabled
            });
        }
    };
    return isMediaEnabled ? $5c71a2cd7b5093e7$var$MediaCardDisableItem(mediaCardProps) : $5c71a2cd7b5093e7$var$MediaCardEnableItem(mediaCardProps);
};

});
parcelRegister("3Awmo", function(module, exports) {

$parcel$export(module.exports, "default", () => $edfebe170e0504c5$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $edfebe170e0504c5$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    showCover: {
        "id": "software.main.header.menu.card-media-item.show-cover",
        "defaultMessage": "Show cover images"
    },
    hideCover: {
        "id": "software.main.header.menu.card-media-item.hide-cover",
        "defaultMessage": "Hide cover images"
    }
});

});



parcelRegister("6w38i", function(module, exports) {

$parcel$export(module.exports, "default", () => $678d102715044776$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");

var $67Z81 = parcelRequire("67Z81");

var $2dZ2i = parcelRequire("2dZ2i");
const $678d102715044776$var$mapStateToProps = (state)=>({
        url: (0, $eph8m.getColumnStatusMappingUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state))
    });
var $678d102715044776$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($678d102715044776$var$mapStateToProps, {})((0, $2dZ2i.default));

});
parcelRegister("2dZ2i", function(module, exports) {

$parcel$export(module.exports, "default", () => $d46df2c8fd18d915$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $az4zD = parcelRequire("az4zD");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lVJAU = parcelRequire("lVJAU");

var $d1Bsi = parcelRequire("d1Bsi");
const $d46df2c8fd18d915$export$cc501cfa2aa02d4e = ({ intl: intl, url: url })=>{
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'menuItem',
            action: 'clicked'
        }), 'clickConfigureBoardItem');
        (0, $14uhY.setReturnToProjectUrl)();
        push(url);
    }, [
        push,
        url,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: onClick
    }, intl.formatMessage((0, $d1Bsi.default).displayText));
};
var $d46df2c8fd18d915$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($d46df2c8fd18d915$export$cc501cfa2aa02d4e);

});
parcelRegister("d1Bsi", function(module, exports) {

$parcel$export(module.exports, "default", () => $5e772f6c83682696$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $5e772f6c83682696$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.configure-board-item.display-text",
        "defaultMessage": "Configure board"
    }
});

});



parcelRegister("eNd21", function(module, exports) {

$parcel$export(module.exports, "default", () => $c2a8ffa6d7137790$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $3Z96c = parcelRequire("3Z96c");

var $2vSU6 = parcelRequire("2vSU6");

var $koVbs = parcelRequire("koVbs");

var $4DPZY = parcelRequire("4DPZY");

var $gSBIZ = parcelRequire("gSBIZ");

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");

var $beOOr = parcelRequire("beOOr");

var $e5wyW = parcelRequire("e5wyW");

var $bSSG7 = parcelRequire("bSSG7");

var $67sX6 = parcelRequire("67sX6");

var $kv0Sc = parcelRequire("kv0Sc");
// TODO Add an app prefix to separate apps
const $c2a8ffa6d7137790$var$storageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
function $c2a8ffa6d7137790$export$444102a091dc311d() {
    const defaultValue = 'default';
    let value;
    try {
        if ((0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration')) value = $c2a8ffa6d7137790$var$storageProvider.get('selectedConfigTab');
        else value = localStorage.getItem('selectedConfigTab');
        return value ? JSON.parse(value) : defaultValue;
    } catch (err) {
        return defaultValue;
    }
}
function $c2a8ffa6d7137790$export$41cd2e3ea8f815d6({ containerData: containerData, boardId: boardId, selectedConfigTab: selectedConfigTab }) {
    // containerData should never be null, but we are being defensive here.
    if (containerData == null) return '';
    if ((0, $gSBIZ.isProjectContext)(containerData) && containerData.project.type === (0, $2vSU6.SERVICE_DESK_PROJECT)) return `/jira/servicedesk/projects/${containerData.project.key}/boards/${boardId}/?config=${selectedConfigTab}`;
    return (0, $gSBIZ.isUserContext)(containerData) ? `/jira/people/${containerData.user.accountId}/boards/${boardId}/?config=${selectedConfigTab}` : `/jira/software/c/projects/${containerData.project.key}/boards/${boardId}/?config=${selectedConfigTab}`;
}
function $c2a8ffa6d7137790$var$useConfigureBoardUrl() {
    const boardId = (0, $67sX6.useBoardSelector)((state)=>state.configuration.rapidViewId);
    // Read the current settings tab from localStorage to redirect.
    const selectedConfigTab = (0, $5uXOq.useMemo)($c2a8ffa6d7137790$export$444102a091dc311d, []);
    const [{ data: containerData }] = (0, $4DPZY.useContainerContext)();
    const configureBoardUrl = (0, $5uXOq.useMemo)(()=>$c2a8ffa6d7137790$export$41cd2e3ea8f815d6({
            containerData: containerData,
            boardId: boardId,
            selectedConfigTab: selectedConfigTab
        }), [
        boardId,
        containerData,
        selectedConfigTab
    ]);
    return configureBoardUrl;
}
const $c2a8ffa6d7137790$var$useBoardSettingsUrlFn = (0, $e5wyW.functionWithCondition)(()=>((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete this line when cleaning up blu-7261
    (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route'), $c2a8ffa6d7137790$var$useBoardSettingsNew, $c2a8ffa6d7137790$var$useConfigureBoardUrl);
function $c2a8ffa6d7137790$var$useBoardSettingsNew() {
    const settingsUrl = (0, $beOOr.useBoardSettingsUrl)();
    const view = $c2a8ffa6d7137790$export$444102a091dc311d();
    return `${settingsUrl}/${view === 'default' ? 'filter' : view}`;
}
const $c2a8ffa6d7137790$var$ConfigureBoardMenuItem = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const configureBoardUrl = $c2a8ffa6d7137790$var$useBoardSettingsUrlFn();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3Z96c.default), {
        href: configureBoardUrl,
        "data-testid": "software-board.header.menu.configure-board.custom-item"
    }, formatMessage((0, $kv0Sc.default).displayText));
};
var $c2a8ffa6d7137790$export$2e2bcd8739ae039 = $c2a8ffa6d7137790$var$ConfigureBoardMenuItem;

});
parcelRegister("beOOr", function(module, exports) {

$parcel$export(module.exports, "useBoardSettingsUrl", () => $d3a20dcbc1b57686$export$e1ea57ffba968ed5);

var $4IPB4 = parcelRequire("4IPB4");

var $h2QE2 = parcelRequire("h2QE2");
function $d3a20dcbc1b57686$export$e1ea57ffba968ed5() {
    return (0, $h2QE2.getBoardSettingsUrl)((0, $4IPB4.useBoardUrl)());
}

});
parcelRegister("4IPB4", function(module, exports) {

$parcel$export(module.exports, "useBoardUrl", () => $d4170d0ca473b3a2$export$66c8e3658ad37452);

var $5uXOq = parcelRequire("5uXOq");

var $edUVe = parcelRequire("edUVe");

var $b2XdI = parcelRequire("b2XdI");


var $4R6GH = parcelRequire("4R6GH");

var $5w1T1 = parcelRequire("5w1T1");

var $1ilU2 = parcelRequire("1ilU2");

var $dd29Z = parcelRequire("dd29Z");

var $h2QE2 = parcelRequire("h2QE2");

var $f1x6A = parcelRequire("f1x6A");

var $3rvKk = parcelRequire("3rvKk");
function $d4170d0ca473b3a2$export$66c8e3658ad37452(isCMPBoard) {
    const match = (0, $edUVe.useMatch)();
    const { project: project, user: user } = (0, $f1x6A.useBoardAndLocationContext)();
    const isJSMBoard = (0, $3rvKk.useIsJSMBoard)();
    const { queue: queue } = (0, $4R6GH.fg)('jsm_views_configuration_migration') ? (0, $5w1T1.useCurrentQueue)() : {
        queue: undefined
    };
    const isReallyCMPBoard = isCMPBoard !== undefined ? isCMPBoard : !project?.simplified;
    const projectKey = match.params.projectKey ?? '';
    const boardId = match.params.boardId ?? '';
    const category = (0, $1ilU2.toItsmPractice)(match.params.practiceType);
    const { data: jsmFeaturesData } = (0, $4R6GH.fg)('jsm_views_configuration_migration') ? (0, $b2XdI.default)() : {
        data: null
    };
    const isBoardEnabled = isJSMBoard && (0, $4R6GH.fg)('jsm_views_configuration_migration') ? jsmFeaturesData?.['jsm-board']?.status === (0, $3bae7046e293c392$export$e927a5d1b72f0b68) : true;
    return (0, $5uXOq.useMemo)(()=>{
        if (!projectKey && !boardId) throw new Error('useBoardUrl() can only be used with board URLs');
        if (user) return (0, $h2QE2.getUserBoardUrl)(user.accountId, boardId);
        if (queue && (0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag')) return `/jira/servicedesk/projects/${projectKey}/${(0, $dd29Z.getQueueFragment)(queue.id, category)}/board/${boardId}`;
        if (isJSMBoard) return isBoardEnabled || !(0, $4R6GH.fg)('jsm_views_configuration_migration') ? (0, $h2QE2.getJSMBoardUrl)(projectKey, boardId) : (0, $h2QE2.getJSMCalendarUrl)(projectKey, boardId);
        return (0, $h2QE2.getBoardUrl)(projectKey, boardId, isReallyCMPBoard);
    }, [
        boardId,
        isJSMBoard,
        isReallyCMPBoard,
        projectKey,
        user,
        isBoardEnabled,
        queue,
        category
    ]);
}

});
parcelRegister("b2XdI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b693b7ac6b5692db$export$2e2bcd8739ae039);

var $6sNnq = parcelRequire("6sNnq");

var $2YP9W = parcelRequire("2YP9W");
const $b693b7ac6b5692db$var$useServiceProjectFeatures = ()=>(0, $2YP9W.useResource)((0, $6sNnq.featuresResource));
var $b693b7ac6b5692db$export$2e2bcd8739ae039 = $b693b7ac6b5692db$var$useServiceProjectFeatures;

});
parcelRegister("6sNnq", function(module, exports) {

$parcel$export(module.exports, "featuresResource", () => $d0a02e466fb63798$export$16f81cc9da2c6c47);

var $9XE6b = parcelRequire("9XE6b");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");


const $d0a02e466fb63798$var$getDataLoader = ()=>(parcelRequire("eYpiZ"));
const $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS = 86400000;
const $d0a02e466fb63798$export$16f81cc9da2c6c47 = (0, $2M1hQ.createResource)({
    type: (0, $68b2e6d16c6e9952$export$3441b129810f29ed),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $d0a02e466fb63798$var$getDataLoader,
    maxAge: $d0a02e466fb63798$var$ONE_DAY_IN_MILLIS
});

});
const $68b2e6d16c6e9952$export$3441b129810f29ed = 'SERVICEDESK_FEATURES';

parcelRegister("eYpiZ", function(module, exports) {

let $ae6a4c5f12900e23$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $ae6a4c5f12900e23$var$load("kVX56"),
    $ae6a4c5f12900e23$var$load("izbMG")
]).then(()=>parcelRequire('frQmB'));

});



const $3bae7046e293c392$export$b45a36df7873757 = 'alerts';
const $3bae7046e293c392$export$a7952c5a5c371ddd = 'oncall';
const $3bae7046e293c392$export$de0bca182bc46c7f = 'services';
const $3bae7046e293c392$export$ed849d1eb34423e5 = 'similarIssues';
const $3bae7046e293c392$export$d4a1ed8524773042 = 'sentiment-analysis';
const $3bae7046e293c392$export$46f600f4680e5fd0 = 'jsm-ai-context';
const $3bae7046e293c392$export$3d2ce10d3ca55e3c = 'automaticallySetRequestType';
const $3bae7046e293c392$export$cae2404f62c0f4d7 = 'change-management';
const $3bae7046e293c392$export$31ffe79c2b019cf = 'incident-management';
const $3bae7046e293c392$export$3a20074cc38cbf69 = 'problem-management';
const $3bae7046e293c392$export$a364d86306d4a6d4 = 'service-request';
const $3bae7046e293c392$export$71f1a79e03f525 = 'post-incident-review';
const $3bae7046e293c392$export$6860c7a26d6d6d35 = 'csm-customer-context';
const $3bae7046e293c392$export$7c5ee80fcb40e9d3 = 'developer-escalation';
const $3bae7046e293c392$export$28fc94ee6c61f632 = 'products-and-entitlements';
const $3bae7046e293c392$export$93b42272f76473c9 = 'jsm-views';
const $3bae7046e293c392$export$1eb399d8c2d53748 = 'jsm-board';
const $3bae7046e293c392$export$abbcecf25bfa1e87 = 'jsm-calendar';
const $3bae7046e293c392$export$891877b4a4d60ea2 = 'jsm-project-summary';
const $3bae7046e293c392$export$34136c6420474672 = 'journey-builder';
const $3bae7046e293c392$export$66ede2c1de447f8f = 'developer-escalation';
const $3bae7046e293c392$export$c54f3fef3b7893c1 = 'request-type-category'; // remove when cleaning request_type_table_uplift
const $3bae7046e293c392$export$1ee9c534405b9b35 = 'playbooks';
const $3bae7046e293c392$export$ac0832132e8992d7 = 'automation-discoverability';
const $3bae7046e293c392$export$fc77e86331b0e2c7 = 'jcs-customer-support-escalation';
const $3bae7046e293c392$export$e927a5d1b72f0b68 = 'ENABLED';
const $3bae7046e293c392$export$8cd212c10b4124d2 = 'DISABLED';

parcelRegister("5w1T1", function(module, exports) {

$parcel$export(module.exports, "useCurrentQueue", () => $373598bd9a60294b$export$6828a0f92648828d);

var $5uXOq = parcelRequire("5uXOq");

var $bmKPg = parcelRequire("bmKPg");
var $2YP9W = parcelRequire("2YP9W");

var $1ilU2 = parcelRequire("1ilU2");

var $1WlLE = parcelRequire("1WlLE");
const $373598bd9a60294b$export$6828a0f92648828d = ()=>{
    const [queueId] = (0, $bmKPg.usePathParam)('queueId');
    const [practiceType] = (0, $bmKPg.usePathParam)('practiceType');
    const category = (0, $1ilU2.toItsmPractice)(practiceType);
    const { data: allData, loading: loading, error: error, refresh: refresh, update: update } = (0, $2YP9W.useResource)((0, $1WlLE.queuesNavigationItems));
    const categorizedQueues = (0, $5uXOq.useMemo)(()=>allData?.[category]?.queues, [
        allData,
        category
    ]);
    const selectedQueue = categorizedQueues?.find((queue)=>queue.id === Number(queueId));
    const updateCurrentQueue = (data)=>{
        update((currentData)=>({
                ...currentData,
                [category]: {
                    ...currentData[category],
                    queues: categorizedQueues.map((queue)=>{
                        if (queue.id === Number(queueId)) return {
                            ...queue,
                            ...data
                        };
                        return queue;
                    })
                }
            }));
    };
    return {
        queue: selectedQueue,
        loading: loading,
        error: error,
        refreshQueue: refresh,
        updateCurrentQueue: updateCurrentQueue
    };
};

});
parcelRegister("1ilU2", function(module, exports) {

$parcel$export(module.exports, "toItsmPractice", () => $27eaa4458d2c6986$export$1b27246f3c7494c);
$parcel$export(module.exports, "isValidItsmPractice", () => $27eaa4458d2c6986$export$357b94e419749e3d);

var $oCMSG = parcelRequire("oCMSG");
const $27eaa4458d2c6986$export$1b27246f3c7494c = (practiceString)=>{
    switch(practiceString){
        case 'incidents':
            return 0, $oCMSG.INCIDENTS;
        case 'changes':
            return 0, $oCMSG.CHANGES;
        case 'service-requests':
            return 0, $oCMSG.SERVICE_REQUEST;
        case 'problems':
            return 0, $oCMSG.PROBLEMS;
        case 'post-incident-reviews':
            return 0, $oCMSG.POST_INCIDENT_REVIEWS;
        default:
            return 0, $oCMSG.NO_CATEGORY;
    }
};
const $27eaa4458d2c6986$export$357b94e419749e3d = (practiceString)=>{
    switch(practiceString){
        case 0, $oCMSG.INCIDENTS:
        case 0, $oCMSG.CHANGES:
        case 0, $oCMSG.SERVICE_REQUEST:
        case 0, $oCMSG.PROBLEMS:
        case 0, $oCMSG.POST_INCIDENT_REVIEWS:
        case 0, $oCMSG.NO_CATEGORY:
            return true;
        default:
            return false;
    }
};

});

parcelRegister("1WlLE", function(module, exports) {

$parcel$export(module.exports, "queuesNavigationItems", () => $c68314f43531feff$export$4fed8be571897bef);
$parcel$export(module.exports, "priorityGroupResource", () => $c68314f43531feff$export$1f9ab301771fe42e);
$parcel$export(module.exports, "priorityGroupByProjectIdResource", () => $c68314f43531feff$export$f6133a181a1ec201);
$parcel$export(module.exports, "issueListSsrResource", () => $c68314f43531feff$export$3d03cbaac8581e65);

var $9XE6b = parcelRequire("9XE6b");

var $jcw0u = parcelRequire("jcw0u");


var $jthxb = parcelRequire("jthxb");

var $1nb22 = parcelRequire("1nb22");

var $2M1hQ = parcelRequire("2M1hQ");

var $8w6CZ = parcelRequire("8w6CZ");

var $fRrvi = parcelRequire("fRrvi");

const $c68314f43531feff$var$getDataLoader = ()=>(parcelRequire("a2czB"));

const $c68314f43531feff$var$getPriorityGroupDataLoader = ()=>(parcelRequire("dY0qY"));

const $c68314f43531feff$var$fetchIssueListDataLoader = ()=>(parcelRequire("jyyvg"));
const $c68314f43531feff$var$getCombinedProjectKeyAndQueueId = ({ match: match, query: query })=>`${(0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0]}-${(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.queueId', '')}`;
const $c68314f43531feff$export$4fed8be571897bef = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS),
    getKey: ({ match: match, query: query })=>// projectKey from url path/query or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $c68314f43531feff$var$getDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS)
});
const $c68314f43531feff$export$1f9ab301771fe42e = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getDataLoader: $c68314f43531feff$var$getPriorityGroupDataLoader,
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    /**
	 * This resource will not load in SSR. Because priority group data resides in the JSM Kukama microservice.
	 * If we wanna fetch this resource during SSR, the request we're making from Tesseract -> Kukama is S2S, where Tesseract needs to know cookies information.
	 * We initially skipped SSR for fetching this resource, because we couldn’t retrieve the request cookie from JFE.
	 * Iiuc, the Jira team doesnt doesnt support this due to security concerns (the info is from JSM Queues team).
	 */ isBrowserOnly: true
});
const $c68314f43531feff$export$f6133a181a1ec201 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS),
    getKey: ({ match: match, query: query })=>// projectKey from url path or browse/{issueKey}
        (0, $1nb22.getProjectKeyId)(match, query).projectKey || (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(match, 'params.issueKey', '').split('-')[0],
    getData: async ({ match: match, query: query, dependencies: dependencies }, { tenantContext: { cloudId: cloudId } })=>{
        const { projectKey: projectKey } = (0, $1nb22.getProjectKeyId)(match, query);
        try {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            const { projectId: projectId } = await (0, $jthxb.consumeDependency)(dependencies, (0, $0f463a88567f1621$export$80a60a092d9ab81));
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(projectId, projectKey, cloudId);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetchProjectContextError',
                    packageName: 'jiraRouterResourcesServiceDeskQueues',
                    teamName: 'jsm-flash'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            return (0, $fRrvi.getPriorityGroupDataByProjectId)(undefined, projectKey, cloudId);
        }
    },
    maxAge: (0, $8w6CZ.ONE_DAY_IN_MILLIS),
    isBrowserOnly: true,
    depends: [
        (0, $0f463a88567f1621$export$80a60a092d9ab81)
    ]
});
const $c68314f43531feff$export$3d03cbaac8581e65 = (0, $2M1hQ.createResource)({
    type: (0, $8w6CZ.RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR),
    getKey: $c68314f43531feff$var$getCombinedProjectKeyAndQueueId,
    getDataLoader: $c68314f43531feff$var$fetchIssueListDataLoader,
    maxAge: 0,
    // run this resource from server only
    skipBrowser: true
});

});
const $0f463a88567f1621$export$80a60a092d9ab81 = 'PROJECT_CONTEXT';

parcelRegister("jthxb", function(module, exports) {

$parcel$export(module.exports, "consumeDependency", () => $c406e66b8b597668$export$a973ef9e17a326f);
async function $c406e66b8b597668$export$a973ef9e17a326f(dependencies, key) {
    // There is an inflight request, the response is source of truth
    if (dependencies[key]?.loading) return dependencies[key]?.promise;
    if (dependencies[key]?.error) // Our dependency errored out the last time it ran, we don't have the data
    throw dependencies[key]?.error;
    // Last response is what we want
    return dependencies[key]?.data;
}

});

parcelRegister("8w6CZ", function(module, exports) {

$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_NAVIGATION_ITEMS", () => $a4c66eaf20e13a4d$export$a401e6d6b205c72b);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_PRIORITY_GROUPS", () => $a4c66eaf20e13a4d$export$2064262c540606ba);
$parcel$export(module.exports, "RESOURCE_TYPE_SERVICEDESK_QUEUES_ISSUE_LIST_SSR", () => $a4c66eaf20e13a4d$export$2733615da5b906f0);
$parcel$export(module.exports, "ONE_DAY_IN_MILLIS", () => $a4c66eaf20e13a4d$export$5a00268156ea5027);
const $a4c66eaf20e13a4d$export$a401e6d6b205c72b = 'SERVICEDESK_QUEUES_NAVIGATION_ITEMS';
const $a4c66eaf20e13a4d$export$2064262c540606ba = 'SERVICEDESK_QUEUES_PRIORITY_GROUPS';
const $a4c66eaf20e13a4d$export$2733615da5b906f0 = 'SERVICEDESK_QUEUES_ISSUE_LIST_SSR';
const $a4c66eaf20e13a4d$export$5a00268156ea5027 = 86400000;

});

parcelRegister("fRrvi", function(module, exports) {

$parcel$export(module.exports, "getPriorityGroupDataByProjectId", () => $2d01df2d1057a1ad$export$cf2bd2ec601ed920);

var $fn8B5 = parcelRequire("fn8B5");

var $bFU4G = parcelRequire("bFU4G");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $4R6GH = parcelRequire("4R6GH");
const $2d01df2d1057a1ad$var$fetchGroupsByKey = async (projectKey, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectIdOrKey=${projectKey}${(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints') ? '&operation=fetchPriorityGroups' : ''}`);
};
const $2d01df2d1057a1ad$var$fetchGroupsById = async (projectId, cloudId)=>{
    return (0, $7f4tk.default)(`/gateway/api/jsm/queues/cloudid/${cloudId}/api/v1/groups?projectId=${projectId}${(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints') ? '&operation=fetchPriorityGroupsByProjectId' : ''}`);
};
const $2d01df2d1057a1ad$export$cf2bd2ec601ed920 = async (projectId, projectKey, cloudId)=>{
    const fetchStartTime = performance.now();
    let data;
    if (projectId) {
        data = await $2d01df2d1057a1ad$var$fetchGroupsById(projectId, cloudId);
        if (!(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints')) (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroupsByProjectId', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    } else {
        (0, $jcw0u.default)({
            meta: {
                id: 'fetchPriorityGroupsProjectIdUndefined',
                packageName: 'jiraRouterResourcesServiceDeskQueues',
                teamName: 'jsm-flash'
            },
            sendToPrivacyUnsafeSplunk: true
        });
        data = await $2d01df2d1057a1ad$var$fetchGroupsByKey(projectKey, cloudId);
        if (!(0, $4R6GH.fg)('add-operation-query-param-to-queues-endpoints')) (0, $bFU4G.addSpanToAll)('fetch', 'fetchPriorityGroups', [
            {
                name: 'network'
            }
        ], fetchStartTime, performance.now());
    }
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const processedData = (0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(data.results.map((group)=>({
            ...group,
            queues: group.queueIds || []
        })), 'category'); // eslint-disable-line @typescript-eslint/no-explicit-any
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return processedData;
};

});

parcelRegister("a2czB", function(module, exports) {

let $74e3d816256db699$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $74e3d816256db699$var$load("kVX56"),
    $74e3d816256db699$var$load("aG1rf")
]).then(()=>parcelRequire('lini2'));

});

parcelRegister("dY0qY", function(module, exports) {

let $a2b13728cd2933bf$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a2b13728cd2933bf$var$load("dg10h").then(()=>parcelRequire('etJR3'));

});

parcelRegister("jyyvg", function(module, exports) {

let $e3cbf4eb1d60bd0a$var$load = (parcelRequire("28QjX"))(4);
module.exports = $e3cbf4eb1d60bd0a$var$load("3pKue").then(()=>parcelRequire('bmzqI'));

});



parcelRegister("dd29Z", function(module, exports) {

$parcel$export(module.exports, "QUEUE_ROUTES", () => $10cfdb56a53da9cf$export$410a6306dae101ca);
$parcel$export(module.exports, "navigate", () => $10cfdb56a53da9cf$export$ff7962acd6052c28);
$parcel$export(module.exports, "getQueueFragment", () => $10cfdb56a53da9cf$export$954f428fa284c7);
$parcel$export(module.exports, "getEditQueueFragment", () => $10cfdb56a53da9cf$export$86f6a6d69e87f843);
$parcel$export(module.exports, "getCloneQueueFragment", () => $10cfdb56a53da9cf$export$7a487d215c9c3f76);
$parcel$export(module.exports, "getQueueIssueFragment", () => $10cfdb56a53da9cf$export$773cefb51b60b161);
$parcel$export(module.exports, "getIssueFragment", () => $10cfdb56a53da9cf$export$a796bfaff67c9fae);
$parcel$export(module.exports, "getQueueUrl", () => $10cfdb56a53da9cf$export$a29b42a005fecf0);
$parcel$export(module.exports, "getEditQueueUrlFromManageQueue", () => $10cfdb56a53da9cf$export$91152835d12ca65f);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("6hSeW");
parcelRequire("9o0uh");
parcelRequire("fPS7b");
parcelRequire("c66Ur");

var $5viSR = parcelRequire("5viSR");

var $oCMSG = parcelRequire("oCMSG");

var $hzd6p = parcelRequire("hzd6p");
const $10cfdb56a53da9cf$var$LOCATION = 'servicedesk.common.navigation.queues';
let $10cfdb56a53da9cf$var$navigatorPromise;
const $10cfdb56a53da9cf$var$getPushStateNavigator = ()=>{
    if (!$10cfdb56a53da9cf$var$navigatorPromise) $10cfdb56a53da9cf$var$navigatorPromise = (0, $hzd6p.createPushStateNavigator)();
    return $10cfdb56a53da9cf$var$navigatorPromise;
};
const $10cfdb56a53da9cf$export$410a6306dae101ca = {
    [(0, $oCMSG.INCIDENTS)]: 'section/incidents',
    [(0, $oCMSG.CHANGES)]: 'section/changes',
    [(0, $oCMSG.SERVICE_REQUEST)]: 'section/service-requests',
    [(0, $oCMSG.PROBLEMS)]: 'section/problems',
    [(0, $oCMSG.POST_INCIDENT_REVIEWS)]: 'section/post-incident-reviews',
    [(0, $oCMSG.NO_CATEGORY)]: 'queues'
};
const $10cfdb56a53da9cf$var$fromCategory = (category)=>$10cfdb56a53da9cf$export$410a6306dae101ca[category || (0, $oCMSG.NO_CATEGORY)];
const $10cfdb56a53da9cf$export$ff7962acd6052c28 = (projectKey, fragment)=>{
    (0, $5viSR.emitSignal)($10cfdb56a53da9cf$var$LOCATION, {
        projectKey: projectKey,
        fragment: fragment
    });
    return (0, $kVLXA.Observable).fromPromise($10cfdb56a53da9cf$var$getPushStateNavigator()).mergeMap((pushStateNavigator)=>{
        pushStateNavigator.navigateToFragment(fragment);
        return (0, $kVLXA.Observable).empty();
    }).catch(()=>(0, $kVLXA.Observable).empty());
};
const $10cfdb56a53da9cf$export$954f428fa284c7 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/${queueId}` : `${categoryString}`;
};
const $10cfdb56a53da9cf$export$86f6a6d69e87f843 = (queueId, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/edit`;
const $10cfdb56a53da9cf$export$7a487d215c9c3f76 = (queueId, category)=>{
    const categoryString = $10cfdb56a53da9cf$var$fromCategory(category);
    return queueId != null ? `${categoryString}/custom/new?parentId=${queueId}` : `${categoryString}/custom/new`;
};
const $10cfdb56a53da9cf$export$773cefb51b60b161 = (queueId, issueKey, category)=>`${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}/${issueKey}`;
const $10cfdb56a53da9cf$export$a796bfaff67c9fae = (issueKey)=>`${$10cfdb56a53da9cf$export$954f428fa284c7()}/issue/${issueKey}`;
const $10cfdb56a53da9cf$export$a29b42a005fecf0 = ({ projectKey: projectKey, category: category, queueId: queueId, queryParams: queryParams })=>{
    const urlSearchParams = new URLSearchParams();
    if (queryParams) Object.entries(queryParams).forEach(([key, value])=>{
        urlSearchParams.set(key, value);
    });
    const formattedQueryParams = urlSearchParams.toString() ? `?${urlSearchParams.toString()}` : '';
    return `/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$954f428fa284c7(queueId, category)}${formattedQueryParams}`;
};
const $10cfdb56a53da9cf$export$91152835d12ca65f = (queueId, projectKey, category)=>`/jira/servicedesk/projects/${projectKey}/${$10cfdb56a53da9cf$export$86f6a6d69e87f843(queueId, category)}`;

});
parcelRegister("5viSR", function(module, exports) {

$parcel$export(module.exports, "emitSignal", () => $8dc3d00171ca741d$export$a8a72bca1918549c);
/**
 * A signalling mechanism for Cypress tests.
 *
 * This acts as a bridge between the storybook application and cypress for
 * checking behaviours which cannot be asserted on via the DOM or are
 * otherwise not reflected in application state.
 *
 * This is the 'emit' side of the story. It should be used by
 * production-facing code to emit a signal.
 */ const $8dc3d00171ca741d$var$isProduction = ()=>true;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $8dc3d00171ca741d$var$registerSignal = (signal, meta)=>{
    window.cySignals.allSignals.push(signal);
    const signalsByName = window.cySignals.signalsByName;
    if (signalsByName[signal]) signalsByName[signal].push(meta);
    else signalsByName[signal] = [
        meta
    ];
};
const $8dc3d00171ca741d$var$initCySignals = ()=>{
    window.cySignals = {
        signalsByName: {},
        allSignals: []
    };
};
const $8dc3d00171ca741d$export$a8a72bca1918549c = (signal, meta = {})=>{
    if ($8dc3d00171ca741d$var$isProduction()) return;
    if (!window.cySignals) $8dc3d00171ca741d$var$initCySignals();
    $8dc3d00171ca741d$var$registerSignal(signal, meta);
};

});

parcelRegister("hzd6p", function(module, exports) {

$parcel$export(module.exports, "createPushStateNavigator", () => $ddde70bc55609ded$export$d3bf579f8e5cd838);
// eslint-disable-next-line jira/wrm/no-load-bridge

var $6BZYo = parcelRequire("6BZYo");
const $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE = 'servicedesk/internal-api/core/util/push-state-navigator/push-state-navigator';
// Try to require push-state-navigator over 500ms, otherwise we'll fallback.
const $ddde70bc55609ded$var$REQUIRE_TIMEOUT = 100;
const $ddde70bc55609ded$var$REQUIRE_RETRIES = 5;
const $ddde70bc55609ded$export$d3bf579f8e5cd838 = ()=>// eslint-disable-next-line jira/wrm/no-load-bridge
    (0, $6BZYo.loadBridge)({
        name: $ddde70bc55609ded$var$PUSH_STATE_NAVIGATOR_MODULE,
        timeout: $ddde70bc55609ded$var$REQUIRE_TIMEOUT,
        tentatives: $ddde70bc55609ded$var$REQUIRE_RETRIES
    });

});


parcelRegister("h2QE2", function(module, exports) {

$parcel$export(module.exports, "getBoardSettingsHref", () => $34db911e1caaedb7$export$8d54870ff0bbaead);
$parcel$export(module.exports, "isSelected", () => $34db911e1caaedb7$export$e4d153b3e021fb47);
$parcel$export(module.exports, "getBoardUrl", () => $34db911e1caaedb7$export$505a9f131607d070);
$parcel$export(module.exports, "getJSMBoardUrl", () => $34db911e1caaedb7$export$3416b472014eed93);
$parcel$export(module.exports, "getJSMCalendarUrl", () => $34db911e1caaedb7$export$16e1d659b389d4ae);
$parcel$export(module.exports, "getUserBoardUrl", () => $34db911e1caaedb7$export$45f8e28589795b6f);
$parcel$export(module.exports, "getBoardSettingsUrl", () => $34db911e1caaedb7$export$222cc43a27cdf5b1);

var $4R6GH = parcelRequire("4R6GH");

var $3HwlS = parcelRequire("3HwlS");
function $34db911e1caaedb7$export$8d54870ff0bbaead(view, location) {
    if (((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    !$34db911e1caaedb7$var$isServiceDeskLocation(location) && (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) {
        const basePath = location.pathname.slice(0, location.pathname.lastIndexOf('/'));
        const query = location.search ? location.search : '';
        return `${basePath}/${view}${query}`;
    }
    return `${location.pathname}?config=${view}`;
}
function $34db911e1caaedb7$export$e4d153b3e021fb47(view, queryConfig = '', pathConfig = '') {
    if (((0, $4R6GH.fg)('blu-7261-change-blu-5799-to-support-nav3') || (0, $3HwlS.getWillShowNav4)()) && // Delete line when cleaning up blu-7261
    (0, $4R6GH.fg)('blu-5799-jira-software-board-entrypoint-route')) return pathConfig === view;
    return queryConfig === view;
}
function $34db911e1caaedb7$export$505a9f131607d070(projectKey, boardId, isCMPBoard) {
    return `/jira/software${isCMPBoard ? '/c' : ''}/projects/${projectKey}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$3416b472014eed93(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$16e1d659b389d4ae(projectKey, boardId) {
    return `/jira/servicedesk/projects/${projectKey}/boards/${boardId}/calendar`;
}
function $34db911e1caaedb7$export$45f8e28589795b6f(accountId, boardId) {
    return `/jira/people/${accountId}/boards/${boardId}`;
}
function $34db911e1caaedb7$export$222cc43a27cdf5b1(ordinaryBoardUrl) {
    return `${ordinaryBoardUrl}/settings`;
}
function $34db911e1caaedb7$var$isServiceDeskLocation(location) {
    return location.pathname.includes('/servicedesk');
}

});

parcelRegister("f1x6A", function(module, exports) {

$parcel$export(module.exports, "useBoardAndLocationContext", () => $e82659e28181f12f$export$d2a945b4dfcaff34);

var $gpXo6 = parcelRequire("gpXo6");

var $1J3t1 = parcelRequire("1J3t1");

var $l5L5h = parcelRequire("l5L5h");
const $e82659e28181f12f$export$d2a945b4dfcaff34 = ()=>{
    const isUserLocated = (0, $l5L5h.useIsUserLocatedBoard)();
    // This hook returns project data + board info for project-located boards
    const { data: projectData, error: projectError } = (0, $1J3t1.useJiraSoftwareProjectNavigation)();
    // This hook returns user-located board data
    const { data: userData, error: userError } = (0, $gpXo6.useJiraUserBoardNavigationResource)();
    return {
        project: projectData?.project,
        user: userData?.owner,
        board: isUserLocated ? userData?.boardInfo : projectData?.boardInfo,
        error: isUserLocated ? userError : projectError
    };
};

});
parcelRegister("gpXo6", function(module, exports) {

$parcel$export(module.exports, "useJiraUserBoardNavigationResource", () => $c3c49f06ba708347$export$517acde8347261e3);

var $7xTO3 = parcelRequire("7xTO3");

var $2YP9W = parcelRequire("2YP9W");
const $c3c49f06ba708347$export$517acde8347261e3 = ()=>(0, $2YP9W.useResource)((0, $7xTO3.staticJSWUserBoardSidebarNavigationResource));

});

parcelRegister("l5L5h", function(module, exports) {

$parcel$export(module.exports, "useIsUserLocatedBoard", () => $c0b41c629510b7e8$export$374923c4a1431d8c);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");
const $c0b41c629510b7e8$var$userLocatedBoardRoutes = [
    'rapidboard-user-board',
    'rapidboard-user-backlog',
    'rapidboard-user-board-settings'
];
const $c0b41c629510b7e8$export$374923c4a1431d8c = ()=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    return (0, $5uXOq.useMemo)(()=>$c0b41c629510b7e8$var$userLocatedBoardRoutes.includes(name), [
        name
    ]);
};

});


parcelRegister("3rvKk", function(module, exports) {

$parcel$export(module.exports, "useIsJSMBoard", () => $f7b28d846fd7ab2d$export$caf439d171aab0ca);

var $5uXOq = parcelRequire("5uXOq");

var $6jY6G = parcelRequire("6jY6G");

var $4R6GH = parcelRequire("4R6GH");

var $k0iPT = parcelRequire("k0iPT");
const $f7b28d846fd7ab2d$export$caf439d171aab0ca = ()=>{
    const { name: name } = (0, $6jY6G.useCurrentRoute)();
    const isJSMBoardRoute = (routeName)=>(0, $4R6GH.fg)('jsm_views_inside_queues_-_main_flag') ? (0, $k0iPT.JSM_BOARD_ROUTES_SET).has(routeName) : routeName === 'servicedesk-boards';
    return (0, $5uXOq.useMemo)(()=>isJSMBoardRoute(name), [
        name
    ]);
};

});



parcelRegister("kv0Sc", function(module, exports) {

$parcel$export(module.exports, "default", () => $b50cc02a262fb48e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b50cc02a262fb48e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.configure-board.display-text",
        "defaultMessage": "Configure board"
    }
});

});


parcelRegister("bdV6X", function(module, exports) {

$parcel$export(module.exports, "BoardConnectItems", () => $1ed5b591520f1d61$export$2843ddf118c543ac);

var $5uXOq = parcelRequire("5uXOq");

var $9UCCQ = parcelRequire("9UCCQ");

var $e8X1M = parcelRequire("e8X1M");

var $63LqY = parcelRequire("63LqY");

var $XvlUo = parcelRequire("XvlUo");
const $1ed5b591520f1d61$export$2843ddf118c543ac = ({ projectKey: projectKey, boardId: boardId, onClickWebItem: onClickWebItem, isTabNavigation: isTabNavigation = false })=>{
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const isJSMBoard = (0, $63LqY.useIsJSMBoard)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: !isJSMBoard
    }, isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "board-tools-1",
        onClickWebItem: onClickWebItem,
        mode: "work",
        isTabNavigation: isTabNavigation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-work",
        onClickWebItem: onClickWebItem,
        mode: "work",
        isTabNavigation: isTabNavigation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        location: "view-actions-print",
        onClickWebItem: onClickWebItem,
        mode: "work",
        isTabNavigation: isTabNavigation
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e8X1M.BoardConnectMenuItems), {
        boardId: boardId,
        projectKey: projectKey,
        mode: "work",
        onClickWebItem: onClickWebItem,
        isTabNavigation: isTabNavigation
    })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $XvlUo.default), {
        isTabNavigation: isTabNavigation
    }));
};

});

parcelRegister("21vu4", function(module, exports) {

$parcel$export(module.exports, "boardConnectAppLocations", () => $3d27c1dae6543156$export$4fc7c66ae06f20d1);
const $3d27c1dae6543156$export$4fc7c66ae06f20d1 = [
    'board-tools-1',
    'view-actions-work',
    'view-actions-print'
];

});

parcelRegister("efqda", function(module, exports) {

$parcel$export(module.exports, "default", () => $324183c5f56f46d8$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $1ADgn = parcelRequire("1ADgn");

var $koVbs = parcelRequire("koVbs");

var $khMyE = parcelRequire("khMyE");
const $324183c5f56f46d8$var$CreateBoardMenuItem = ({ onClosePopup: onClosePopup })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const onClickCreateBoard = ()=>{
        (0, $1ADgn.default)();
        onClosePopup && onClosePopup();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        "data-testid": "software-board.header.menu.create-board.button-item",
        onClick: onClickCreateBoard
    }, formatMessage((0, $khMyE.default).displayText));
};
var $324183c5f56f46d8$export$2e2bcd8739ae039 = $324183c5f56f46d8$var$CreateBoardMenuItem;

});
parcelRegister("khMyE", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce7cc2adf8eb6675$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ce7cc2adf8eb6675$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.create-board.display-text",
        "defaultMessage": "Create board"
    }
});

});


parcelRegister("lLint", function(module, exports) {

$parcel$export(module.exports, "EditSprintMenuItem", () => $0c56def4fd7ae197$export$89ed9bac4a921099);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $3aOh4 = parcelRequire("3aOh4");
const $0c56def4fd7ae197$export$89ed9bac4a921099 = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ref: ref,
        onClick: props.onClick
    }, formatMessage((0, $3aOh4.default).displayText));
});

});
parcelRegister("3aOh4", function(module, exports) {

$parcel$export(module.exports, "default", () => $150148a037e296f6$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $150148a037e296f6$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.edit-sprint-item.display-text",
        "defaultMessage": "Edit sprint"
    }
});

});


parcelRegister("7EoeF", function(module, exports) {

$parcel$export(module.exports, "default", () => $339808e1c6584852$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $e0GMz = parcelRequire("e0GMz");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $2yCiv = parcelRequire("2yCiv");
const $339808e1c6584852$var$mapStateToProps = (state)=>({
        boardId: Number((0, $67Z81.rapidViewIdSelector)(state)),
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        sprintId: (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))((0, $ebHh7.activeSprintsSelector)(state), [
            0,
            'id'
        ])
    });
const $339808e1c6584852$export$9e6a17cf56877796 = (dispatch)=>({
        dispatch: dispatch
    });
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $339808e1c6584852$var$noop = ()=>{};
const $339808e1c6584852$var$onSubmitFactory = (0, $8QpSo.default)((dispatch, onClose)=>(data, submitPromise)=>{
        const { name: name, goal: goal, startDate: startDate, endDate: endDate, sprintId: sprintId } = data;
        const action = (0, $e0GMz.editSprintRequest)(sprintId, name, goal, startDate, endDate);
        const { meta: { optimistic: { id: optimisticId } } } = action;
        dispatch(action);
        submitPromise.then((response)=>{
            const daysRemaining = response.editSprint?.sprint?.daysRemaining;
            // @ts-expect-error TS2345: Argument of type 'number | null | undefined' is not assignable to parameter of type 'number'.
            dispatch((0, $e0GMz.editSprintSuccess)(optimisticId, sprintId, daysRemaining));
            onClose?.('SUCCESS');
        }).catch(()=>{
            dispatch((0, $e0GMz.editSprintFailure)(optimisticId));
            onClose?.('FAILURE');
        });
    });
const $339808e1c6584852$export$9d1611c77c2fe928 = (stateProps, dispatchProps, ownProps)=>{
    const { dispatch: dispatch } = dispatchProps;
    return {
        ...stateProps,
        ...ownProps,
        onClose: ownProps.onClose ?? $339808e1c6584852$var$noop,
        onSubmit: $339808e1c6584852$var$onSubmitFactory(dispatch, ownProps.onClose)
    };
};
var $339808e1c6584852$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($339808e1c6584852$var$mapStateToProps, $339808e1c6584852$export$9e6a17cf56877796, $339808e1c6584852$export$9d1611c77c2fe928)((0, $2yCiv.EditSprintModalEntryPoint));

});
parcelRegister("2yCiv", function(module, exports) {

$parcel$export(module.exports, "EditSprintModalEntryPoint", () => $8c7b4e0d2e3c41f2$export$a12e2c4b0037e424);

var $5uXOq = parcelRequire("5uXOq");

var $ivDCs = parcelRequire("ivDCs");

var $dXq4S = parcelRequire("dXq4S");

var $koeKL = parcelRequire("koeKL");

var $63LqY = parcelRequire("63LqY");
const $8c7b4e0d2e3c41f2$export$a12e2c4b0037e424 = ({ boardId: boardId, onClose: onClose, onSubmit: onSubmit, entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject, onReady: onReady })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const isCompanyManaged = (0, $63LqY.useIsCMPBoard)();
    const boardAri = (0, $dXq4S.createAri)({
        resourceOwner: 'jira-software',
        cloudId: cloudId,
        resourceType: 'board',
        resourceId: String(boardId)
    });
    const props = (0, $5uXOq.useMemo)(()=>({
            boardAri: boardAri,
            onClose: onClose,
            onSubmit: onSubmit,
            fetchSprints: true,
            isCompanyManaged: isCompanyManaged,
            ...onReady ? {
                onReady: onReady
            } : undefined
        }), [
        boardAri,
        onClose,
        onSubmit,
        onReady,
        isCompanyManaged
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ivDCs.ModalEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "edit-sprint-modal",
        teamName: "a4t-pandora",
        packageName: "jiraSoftwareEditSprintModalRelay",
        entryPointActions: entryPointActions,
        runtimeProps: props
    });
};

});


parcelRegister("iiKcf", function(module, exports) {

$parcel$export(module.exports, "default", () => $443c63f643f704ca$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $k8auG = parcelRequire("k8auG");

var $3Jb5y = parcelRequire("3Jb5y");
const $443c63f643f704ca$var$mapStateToProps = (state)=>({
        extensionData: (0, $k8auG.getBoardActionExtensionData)(state)
    });
var $443c63f643f704ca$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($443c63f643f704ca$var$mapStateToProps)((0, $3Jb5y.BoardForgeActionMenuItems));

});
parcelRegister("3Jb5y", function(module, exports) {

$parcel$export(module.exports, "BoardForgeActionMenuItems", () => $4346d5df08deeb1b$export$4909ed82b3086b50);

var $5uXOq = parcelRequire("5uXOq");


var $b71gk = parcelRequire("b71gk");

var $bv8Hu = parcelRequire("bv8Hu");

var $k2DRb = parcelRequire("k2DRb");

var $5bkvv = parcelRequire("5bkvv");

var $2YP9W = parcelRequire("2YP9W");
const $4346d5df08deeb1b$var$ForgeActionMenuItems = (props)=>{
    const { loading: loading, data: extensions } = (0, $2YP9W.useResource)((0, $5bkvv.forgeBoardModuleResource));
    if (loading || !extensions || extensions.length === 0) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bv8Hu.ForgeActionMenuItems), {
        module: (0, $k2DRb.BOARD_ACTION_MODULE),
        analyticsSource: (0, $fcf97b7a09088940$export$cd16d39c55c569d0),
        testId: "software-board.header.menu.forge-items",
        extensions: extensions,
        extensionData: props.extensionData
    });
};
const $4346d5df08deeb1b$export$4909ed82b3086b50 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: "software",
        id: "forge-items"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4346d5df08deeb1b$var$ForgeActionMenuItems, {
        extensionData: props.extensionData
    }));

});
parcelRegister("bv8Hu", function(module, exports) {

$parcel$export(module.exports, "ForgeActionMenuItems", () => $28755ab592a11290$export$6d48af8c1ac00cc9);

var $5uXOq = parcelRequire("5uXOq");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $jDKvL = parcelRequire("jDKvL");

var $h0JHu = parcelRequire("h0JHu");

var $5cmSg = parcelRequire("5cmSg");

var $jgJNO = parcelRequire("jgJNO");

var $l1LNZ = parcelRequire("l1LNZ");

var $5jnXk = parcelRequire("5jnXk");
const $28755ab592a11290$var$stopPropagation = (e)=>e.stopPropagation();
const $28755ab592a11290$var$useExtensions = (data)=>{
    return (0, $5uXOq.useMemo)(()=>data.filter((0, $5cmSg.isExtensionVisible)).sort(({ properties: { title: titleA } }, { properties: { title: titleB } })=>titleA.localeCompare(titleB)), [
        data
    ]);
};
const $28755ab592a11290$export$6d48af8c1ac00cc9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ extensions: rawExtensions, extensionData: extensionData, testId: testId, analyticsSource: analyticsSource, module: module })=>{
    const extensions = $28755ab592a11290$var$useExtensions(rawExtensions);
    const [, { closeApps: closeApps }] = (0, $jDKvL.useForgeApps)();
    // Close all Forge apps when the data is re-fetched
    (0, $5uXOq.useEffect)(()=>{
        closeApps();
    }, [
        extensions,
        closeApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
        hasSeparator: true,
        testId: testId
    }, extensions.map((extension)=>{
        const actions = extension.properties.actions ?? [];
        if (actions.length > 0) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$export$b84e0d11207da93f, {
            key: extension.id,
            extension: extension,
            extensionData: extensionData,
            analyticsSource: analyticsSource,
            module: module
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$export$9907687a0b943b6b, {
            key: extension.id,
            extension: extension,
            extensionData: extensionData,
            icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1LNZ.ForgeIcon), {
                url: extension.properties.icon
            }),
            title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
                extensionName: extension.properties.title,
                extensionEnvType: extension.environmentType,
                extensionEnvKey: extension.environmentKey,
                autoTruncate: true
            }),
            tooltip: extension.properties.tooltip,
            analyticsSource: analyticsSource,
            module: module
        });
    }));
});
const $28755ab592a11290$export$9907687a0b943b6b = ({ extension: extension, extensionData: extensionData, title: title, actionKey: actionKey, tooltip: tooltip, icon: icon, analyticsSource: analyticsSource, module: module })=>{
    const { fireUiTriggerClickedEvent: fireUiTriggerClickedEvent, TriggerAnalyticsWrapper: TriggerAnalyticsWrapper, ForgeScreenEvent: ForgeScreenEvent } = (0, $5jnXk.useActionMenuAnalyticsComponents)({
        extension: extension,
        analyticsSource: analyticsSource,
        module: module
    });
    const [, { openApp: openApp }] = (0, $jDKvL.useForgeApps)();
    const { id: id } = extension;
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        fireUiTriggerClickedEvent();
        openApp(id, extension, actionKey, extensionData);
    }, [
        fireUiTriggerClickedEvent,
        openApp,
        id,
        extension,
        actionKey,
        extensionData
    ]);
    const [isAppLoading] = (0, $jDKvL.useIsAppLoading)({
        appId: id,
        action: actionKey
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerAnalyticsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$var$TooltipEnabledButtonItem, {
        iconBefore: icon,
        iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$var$LoadingIndicator, {
            isLoading: isAppLoading
        }),
        onClick: handleClick,
        tooltip: tooltip
    }, title, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgeScreenEvent, null)));
};
const $28755ab592a11290$export$b84e0d11207da93f = ({ extension: extension, extensionData: extensionData, analyticsSource: analyticsSource, module: module })=>{
    const { fireUiTriggerClickedEvent: fireUiTriggerClickedEvent, TriggerAnalyticsWrapper: TriggerAnalyticsWrapper, ForgeScreenEvent: ForgeScreenEvent } = (0, $5jnXk.useActionMenuAnalyticsComponents)({
        extension: extension,
        analyticsSource: analyticsSource,
        module: module
    });
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const handleClose = (0, $5uXOq.useCallback)(()=>setIsOpen(false), [
        setIsOpen
    ]);
    const toggleMenu = (0, $5uXOq.useCallback)(()=>{
        fireUiTriggerClickedEvent();
        setIsOpen((opened)=>!opened);
    }, [
        setIsOpen,
        fireUiTriggerClickedEvent
    ]);
    const title = extension.properties?.title ?? '';
    const icon = extension.properties?.icon;
    const tooltip = extension.properties?.tooltip;
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(TriggerAnalyticsWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$var$TooltipEnabledButtonItem, {
            ...triggerProps,
            tooltip: tooltip,
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1LNZ.ForgeIcon), {
                url: icon
            }),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: toggleMenu
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h0JHu.ExtensionTitle), {
            extensionName: title,
            extensionEnvType: extension.environmentType,
            extensionEnvKey: extension.environmentKey,
            autoTruncate: true
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgeScreenEvent, null))), [
        TriggerAnalyticsWrapper,
        tooltip,
        icon,
        toggleMenu,
        title,
        extension.environmentType,
        extension.environmentKey,
        ForgeScreenEvent
    ]);
    const popupContent = (0, $5uXOq.useCallback)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
            maxWidth: 240,
            onClick: $28755ab592a11290$var$stopPropagation
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), null, (extension.properties.actions ?? []).map((action)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($28755ab592a11290$export$9907687a0b943b6b, {
                key: action.key,
                title: action.title,
                tooltip: action.tooltip,
                actionKey: action.key,
                extension: extension,
                extensionData: extensionData,
                analyticsSource: analyticsSource,
                module: module
            })))), [
        extension,
        extensionData,
        analyticsSource,
        module
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgJNO.JiraPopup), {
        isOpen: isOpen,
        onClose: handleClose,
        placement: "left-start",
        messageId: "forge-ui-action-apps.ui.action-menu.popup",
        messageType: "transactional",
        trigger: popupTrigger,
        content: popupContent,
        shouldRenderToParent: true
    });
};
const $28755ab592a11290$var$LoadingIndicator = /*#__PURE__*/ (0, $5uXOq.memo)(({ isLoading: isLoading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $28755ab592a11290$var$indicatorStyle
    }, isLoading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    }));
});
const $28755ab592a11290$var$TooltipEnabledButtonItem = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ tooltip: tooltip, ...props }, ref)=>{
    return tooltip ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: tooltip
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ...props,
        ref: ref
    })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        ...props,
        ref: ref
    });
});
const $28755ab592a11290$var$indicatorStyle = (0, $8CUq3.xcss)({
    width: "var(--ds-space-150, 12px)"
});

});
parcelRegister("5jnXk", function(module, exports) {

$parcel$export(module.exports, "useActionMenuAnalyticsComponents", () => $a6ed3a4f0f134747$export$f12e5e0ff16730d6);

var $5uXOq = parcelRequire("5uXOq");

var $1rTGO = parcelRequire("1rTGO");

var $8uOa6 = parcelRequire("8uOa6");

var $2RhPB = parcelRequire("2RhPB");

var $9BrHy = parcelRequire("9BrHy");

var $8kVg1 = parcelRequire("8kVg1");

var $hBuqR = parcelRequire("hBuqR");

var $4R6GH = parcelRequire("4R6GH");
const $a6ed3a4f0f134747$var$getAnalyticsAttributes = (extension)=>{
    const { moduleType: moduleType, ...attrs } = (0, $2RhPB.getAnalyticsAttributesFromExtension)(extension);
    return attrs;
};
const $a6ed3a4f0f134747$export$a2f2d30e960414ce = (attributes)=>{
    const { module: module, extensionId: extensionId, source: source } = attributes;
    return {
        fireUiTriggerClickedEvent: $a6ed3a4f0f134747$var$makeFireUiTriggerClickedEvent(module, extensionId, source),
        ViewAnalyticsWrapper: $a6ed3a4f0f134747$var$makeViewAnalyticsWrapper(attributes),
        TriggerAnalyticsWrapper: $a6ed3a4f0f134747$var$makeTriggerAnalyticsWrapper(attributes),
        ForgeScreenEvent: $a6ed3a4f0f134747$var$makeScreenEvent(attributes)
    };
};
const $a6ed3a4f0f134747$export$f12e5e0ff16730d6 = ({ module: module, analyticsSource: analyticsSource, extension: extension })=>{
    const extensionAnalyticsAttributes = (0, $5uXOq.useMemo)(()=>({
            ...$a6ed3a4f0f134747$var$getAnalyticsAttributes(extension),
            source: analyticsSource,
            module: module,
            extensionId: extension.id
        }), [
        extension,
        analyticsSource,
        module
    ]);
    return (0, $5uXOq.useMemo)(()=>$a6ed3a4f0f134747$export$a2f2d30e960414ce(extensionAnalyticsAttributes), [
        extensionAnalyticsAttributes
    ]);
};
const $a6ed3a4f0f134747$var$makeViewAnalyticsWrapper = (props)=>{
    return /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), props, children));
};
const $a6ed3a4f0f134747$var$makeTriggerAnalyticsWrapper = (props)=>{
    return /*#__PURE__*/ (0, $5uXOq.memo)(({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
            ...props,
            moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
        }, children));
};
const $a6ed3a4f0f134747$var$makeScreenEvent = (attributes)=>{
    return /*#__PURE__*/ (0, $5uXOq.memo)(()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeScreenEvent), {
            attributes: attributes
        }));
};
const $a6ed3a4f0f134747$var$makeFireUiTriggerClickedEvent = (module, extensionId, source)=>{
    const triggerEventId = (0, $4R6GH.fg)('ditto-fcf-support-new-manifest-on-frontend') ? (0, $9BrHy.getEventId)({
        module: module,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    }) : (0, $9BrHy.getEventIdOld)({
        module: module,
        moduleType: (0, $hBuqR.MODULE_TYPE_TRIGGER)
    });
    return ()=>{
        (0, $8kVg1.forgeModulesConcurrentLoadTime)(extensionId).start({
            startTime: performance.now()
        });
        return (0, $8uOa6.fireUiEvent)((0, $hBuqR.UI_ACTIONS).CLICKED, {
            id: triggerEventId,
            source: source
        });
    };
};

});




parcelRegister("7IClo", function(module, exports) {

$parcel$export(module.exports, "BoardActionForgeRuntimeContainer", () => $df16e3c051ad99c6$export$b64e0f15984a27b9);

var $5uXOq = parcelRequire("5uXOq");


var $b71gk = parcelRequire("b71gk");

var $84ZsI = parcelRequire("84ZsI");

var $9tkeo = parcelRequire("9tkeo");

var $k2DRb = parcelRequire("k2DRb");
const $df16e3c051ad99c6$export$b64e0f15984a27b9 = /*#__PURE__*/ (0, $5uXOq.memo)(({ onAppsFinishLoading: onAppsFinishLoading })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        packageName: "software",
        id: "forge-board-action-runtime-container"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $84ZsI.ActionMenuForgeRuntimeContainer), {
        onAppsFinishLoading: onAppsFinishLoading,
        forgeAppRenderer: (0, $9tkeo.AsyncBoardAction),
        module: (0, $k2DRb.BOARD_ACTION_MODULE),
        analyticsSource: (0, $fcf97b7a09088940$export$cd16d39c55c569d0)
    }));
});

});
parcelRegister("84ZsI", function(module, exports) {

$parcel$export(module.exports, "ActionMenuForgeRuntimeContainer", () => $167dc37a25b2fd5f$export$a65c809543ceb95a);

var $5uXOq = parcelRequire("5uXOq");

var $jDKvL = parcelRequire("jDKvL");

var $bfAsP = parcelRequire("bfAsP");

var $1rTGO = parcelRequire("1rTGO");

var $2RhPB = parcelRequire("2RhPB");
const $167dc37a25b2fd5f$export$a65c809543ceb95a = ({ onAppsFinishLoading: onAppsFinishLoading, forgeAppRenderer: ForgeAppRenderer, analyticsSource: analyticsSource, module: module })=>{
    const [isAnyForgeAppLoading] = (0, $jDKvL.useIsAnyAppLoading)();
    (0, $5uXOq.useEffect)(()=>{
        // this is to close the dropdown when all forge apps are loaded
        if (onAppsFinishLoading && !isAnyForgeAppLoading) onAppsFinishLoading();
    }, [
        isAnyForgeAppLoading,
        onAppsFinishLoading
    ]);
    const AdaptedForgeAppRenderer = (0, $5uXOq.useMemo)(()=>{
        return $167dc37a25b2fd5f$var$makeForgeAppRenderer(ForgeAppRenderer, module, analyticsSource);
    }, [
        ForgeAppRenderer,
        analyticsSource,
        module
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bfAsP.ForgeAppsRuntimeContainer), {
        forgeAppRenderer: AdaptedForgeAppRenderer
    });
};
const $167dc37a25b2fd5f$var$makeForgeAppRenderer = (Renderer, module, analyticsSource)=>{
    return ({ handleError: baseHandleError, app: app, localId: localId, closeApp: closeApp, setLoaded: setLoaded })=>{
        const handleError = (0, $5uXOq.useCallback)(()=>{
            baseHandleError && baseHandleError();
        }, [
            baseHandleError
        ]);
        const analyticsAttributes = (0, $5uXOq.useMemo)(()=>{
            return {
                source: analyticsSource,
                ...(0, $2RhPB.getAnalyticsAttributesFromExtension)(app.extension)
            };
        }, [
            app.extension
        ]);
        const rendererProps = (0, $5uXOq.useMemo)(()=>({
                localId: localId,
                extension: app.extension,
                extensionData: app.extensionData,
                onClose: closeApp,
                analyticsAttributes: analyticsAttributes,
                onLoad: setLoaded,
                onInitialRender: setLoaded,
                onError: handleError
            }), [
            analyticsAttributes,
            app.extension,
            app.extensionData,
            closeApp,
            handleError,
            localId,
            setLoaded
        ]);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1rTGO.ForgeAnalyticsWrapper), {
            module: module,
            attributes: analyticsAttributes,
            shouldFireInitializedEvent: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Renderer, rendererProps));
    };
};

});
parcelRegister("bfAsP", function(module, exports) {

$parcel$export(module.exports, "ForgeAppsRuntimeContainer", () => $4f172c8b740168bb$export$db56fac1456ccba8);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $4siKa = parcelRequire("4siKa");

var $koVbs = parcelRequire("koVbs");

var $jDKvL = parcelRequire("jDKvL");

var $xd3DV = parcelRequire("xd3DV");
const $4f172c8b740168bb$var$toTargetForgeApp = (app)=>{
    return {
        id: app.id,
        extension: app.extension,
        extensionData: app.action ? {
            ...app.extensionData,
            action: app.action
        } : app.extensionData
    };
};
const $4f172c8b740168bb$var$BaseForgeAppRenderer = ({ app: app, setAppLoaded: setAppLoaded, setAppClose: setAppClose, renderer: ForgeAppRendererComponent })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const localId = app.extensionData.action ? `${app.id},action:${app.extensionData.action}` : app.id;
    const setLoaded = (0, $5uXOq.useCallback)(()=>{
        app.isLoading && setAppLoaded(app.id, app.action);
    }, [
        app.id,
        app.action,
        app.isLoading,
        setAppLoaded
    ]);
    const closeApp = (0, $5uXOq.useCallback)(()=>{
        setAppClose(app.id, app.action);
    }, [
        app.id,
        app.action,
        setAppClose
    ]);
    const targetApp = (0, $5uXOq.useMemo)(()=>$4f172c8b740168bb$var$toTargetForgeApp(app), [
        app
    ]);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const handleError = (0, $5uXOq.useCallback)((msg)=>{
        showFlag({
            key: localId,
            type: 'error',
            title: formatMessage((0, $xd3DV.messages).appErrorTitle),
            description: msg ?? formatMessage((0, $xd3DV.messages).appErrorDescription),
            messageId: 'forge-action-apps-controller.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        showFlag,
        localId,
        formatMessage
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ForgeAppRendererComponent, {
        localId: localId,
        app: targetApp,
        setLoaded: setLoaded,
        closeApp: closeApp,
        isLoading: app.isLoading,
        handleError: handleError
    });
};
const $4f172c8b740168bb$export$db56fac1456ccba8 = ({ forgeAppRenderer: forgeAppRenderer })=>{
    const [{ openedApps: openedApps }, { setAppLoaded: setAppLoaded, closeApps: closeApps, closeApp: closeApp }] = (0, $jDKvL.useForgeApps)();
    (0, $5uXOq.useEffect)(()=>{
        return ()=>{
            closeApps();
        };
    }, [
        closeApps
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4siKa.InvisibleDiv), null, openedApps.map((app)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4f172c8b740168bb$var$BaseForgeAppRenderer, {
            key: app.uuid,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            app: app,
            setAppLoaded: setAppLoaded,
            setAppClose: closeApp,
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            renderer: forgeAppRenderer
        })));
};

});
parcelRegister("4siKa", function(module, exports) {

$parcel$export(module.exports, "InvisibleDiv", () => $cfdc7368b5d9a379$export$22ef238a7bbeac70);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $cfdc7368b5d9a379$export$22ef238a7bbeac70 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0cglyw",
            __cmplp.className
        ])
    });
});
const $cfdc7368b5d9a379$export$1442582cffa6fcb7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isVisible: isVisible, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ $5uXOq.createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_4t3i1osq",
            __cmplp.isVisible ? "_1e0c1ule" : "_1e0cglyw",
            __cmplp.className
        ])
    });
});

});

parcelRegister("xd3DV", function(module, exports) {

$parcel$export(module.exports, "messages", () => $f35d1e21793a4908$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $f35d1e21793a4908$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    appErrorTitle: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-title",
        "defaultMessage": "App Error"
    },
    appErrorDescription: {
        "id": "forge-ui-controllers.action-apps-controller.app-error-description",
        "defaultMessage": "An error occurred while loading the app"
    }
});

});



parcelRegister("9tkeo", function(module, exports) {

$parcel$export(module.exports, "AsyncBoardAction", () => $af1cfd701199cab6$export$fcddcb100b558857);

var $5uXOq = parcelRequire("5uXOq");

var $k2DRb = parcelRequire("k2DRb");

var $lfTZh = parcelRequire("lfTZh");

var $jVbVW = parcelRequire("jVbVW");
const $af1cfd701199cab6$export$fcddcb100b558857 = (props)=>{
    const { extensionData: extensionData } = props;
    const extensionDataValue = (0, $5uXOq.useMemo)(()=>({
            ...extensionData,
            type: (0, $k2DRb.BOARD_ACTION_MODULE)
        }), [
        extensionData
    ]);
    const extraProps = (0, $5uXOq.useMemo)(()=>({
            module: (0, $k2DRb.BOARD_ACTION_MODULE),
            extensionData: extensionDataValue,
            contextToken: (0, $k2DRb.CONTEXT_TOKEN_TYPE_JIRA)
        }), [
        extensionDataValue
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "board-action",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jVbVW.LazyBoardViewForgeExtension), {
        ...props,
        ...extraProps
    }));
};

});
parcelRegister("jVbVW", function(module, exports) {

$parcel$export(module.exports, "LazyBoardViewForgeExtension", () => $38bcce0ad2eac1db$export$d461d27cd7978a77);

var $1rTGO = parcelRequire("1rTGO");

var $kxZPA = parcelRequire("kxZPA");

const $38bcce0ad2eac1db$var$getModule = ()=>(parcelRequire("4xtB4"));
const $38bcce0ad2eac1db$export$d461d27cd7978a77 = (0, $1rTGO.withMetrics)(// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
(0, $kxZPA.lazyForPaint)(()=>$38bcce0ad2eac1db$var$getModule().then((module)=>module.BoardViewForgeExtension), {
    ssr: false
}));

});
parcelRegister("4xtB4", function(module, exports) {

let $34e133cda4d02ef4$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $34e133cda4d02ef4$var$load("3yAl4"),
    $34e133cda4d02ef4$var$load("76n7a"),
    $34e133cda4d02ef4$var$load("l253H"),
    $34e133cda4d02ef4$var$load("kNFvF"),
    $34e133cda4d02ef4$var$load("ffQaD"),
    $34e133cda4d02ef4$var$load("kvRbA"),
    $34e133cda4d02ef4$var$load("jqTxj")
]).then(()=>parcelRequire('lfpoU'));

});




parcelRegister("1YHJ6", function(module, exports) {

$parcel$export(module.exports, "default", () => $012fb41392553103$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $eph8m = parcelRequire("eph8m");

var $67Z81 = parcelRequire("67Z81");

var $3ObFy = parcelRequire("3ObFy");
const $012fb41392553103$var$mapStateToProps = (state)=>({
        url: (0, $eph8m.getManageCustomFiltersUrl)((0, $67Z81.projectKeySelector)(state), (0, $67Z81.rapidViewIdSelector)(state))
    });
var $012fb41392553103$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($012fb41392553103$var$mapStateToProps, {})((0, $3ObFy.default));

});
parcelRegister("3ObFy", function(module, exports) {

$parcel$export(module.exports, "default", () => $67c4176b164ed573$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $kJpBP = parcelRequire("kJpBP");

var $koVbs = parcelRequire("koVbs");

var $14uhY = parcelRequire("14uhY");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lVJAU = parcelRequire("lVJAU");

var $gUhnv = parcelRequire("gUhnv");
const $67c4176b164ed573$export$538689bb697618b7 = ({ url: url })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { push: push } = (0, $lVJAU.useRouterActions)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const onClick = (0, $5uXOq.useCallback)(()=>{
        (0, $14uhY.setReturnToProjectUrl)();
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'menuItem',
            action: 'clicked'
        }), 'clickBoardManageCustomFilterItem');
        push(url);
    }, [
        push,
        url,
        createAnalyticsEvent
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
        onClick: onClick
    }, formatMessage((0, $gUhnv.default).displayText));
};
var $67c4176b164ed573$export$2e2bcd8739ae039 = $67c4176b164ed573$export$538689bb697618b7;

});
parcelRegister("gUhnv", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac51b0d7e8a8b529$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ac51b0d7e8a8b529$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    displayText: {
        "id": "software.main.header.menu.manage-custom-filters-item.display-text",
        "defaultMessage": "Manage custom filters"
    }
});

});



parcelRegister("gqdF8", function(module, exports) {

$parcel$export(module.exports, "default", () => $7410cc88dcfd0526$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7410cc88dcfd0526$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    buttonLabel: {
        "id": "software.main.header.menu.button-label",
        "defaultMessage": "More"
    },
    dropdownAriaLabel: {
        "id": "software.main.header.menu.dropdown-aria-label",
        "defaultMessage": "Board"
    },
    iconButtonLabel: {
        "id": "software.main.header.menu.icon-button-label",
        "defaultMessage": "More actions"
    },
    enterFullScreen: {
        "id": "software.main.header.menu.enter-full-screen",
        "defaultMessage": "Enter full screen"
    },
    exitFullScreen: {
        "id": "software.main.header.menu.exit-full-screen",
        "defaultMessage": "Exit full screen"
    }
});

});

parcelRegister("c1wgv", function(module, exports) {

$parcel$export(module.exports, "default", () => $0adf111359e2d498$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");

var $3dGN0 = parcelRequire("3dGN0");

var $kJpBP = parcelRequire("kJpBP");
var $eZUJu = parcelRequire("eZUJu");
var $9UCCQ = parcelRequire("9UCCQ");

var $1I7E8 = parcelRequire("1I7E8");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lu5k0 = parcelRequire("lu5k0");


var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $afSe5 = parcelRequire("afSe5");

var $ecPxM = parcelRequire("ecPxM");

var $49Sni = parcelRequire("49Sni");

var $25859 = parcelRequire("25859");
const $0adf111359e2d498$var$DROPDOWN_MENU_ITEM_TEST_ID = 'software-board.header.release-version.menu-item';
const $0adf111359e2d498$var$ReleaseVersion = ({ rapidViewId: rapidViewId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const [isNewVersionModalOpen, setIsNewVersionModalOpen] = (0, $5uXOq.useState)(false);
    const closeNewVersionReleaseModal = (0, $5uXOq.useCallback)(()=>setIsNewVersionModalOpen(false), [
        setIsNewVersionModalOpen
    ]);
    const isMultiProjectBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.hasMultipleProjects));
    const releaseButtonRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const [selectedVersion, setSelectedVersion] = (0, $5uXOq.useState)(null);
    const closeReleaseModal = (0, $5uXOq.useCallback)(()=>setSelectedVersion(null), [
        setSelectedVersion
    ]);
    const { releaseState: releaseState, versionMenuItems: versionMenuItems, hasIssuesWithoutVersion: hasIssuesWithoutVersion, lastColumnName: lastColumnName } = (0, $67sX6.useBoardSelector)((0, $afSe5.getFilteredVersionsSelector));
    const onPopupClick = (0, $5uXOq.useCallback)(()=>{
        if (isOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'board.release.menu-open',
            action: 'release menu item clicked'
        }));
        setIsOpen(!isOpen);
    }, [
        createAnalyticsEvent,
        isOpen
    ]);
    const onClose = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    const popupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>{
        const isDisabled = releaseState === (0, $52aa71c793d1ece4$export$6d221b2e277927d7);
        setReturnFocusTo(releaseButtonRef);
        const tooltipContent = !isOpen && releaseState === (0, $52aa71c793d1ece4$export$e927a5d1b72f0b68) ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $25859.default).tooltipReleaseIssueTermRefresh : (0, $25859.default).tooltipRelease, {
            columnName: lastColumnName
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isDisabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $25859.default).tooltipDisabledIssueTermRefresh : (0, $25859.default).tooltipDisabled) : tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            ...triggerProps,
            "aria-label": formatMessage((0, $25859.default).title),
            ref: (0, $7mPT9.mergeRefs)(triggerProps.ref, releaseButtonRef),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))), {
                label: "",
                color: "var(--ds-icon, #44546F)"
            }),
            isDisabled: isDisabled,
            testId: "software-board.header.menu.release-version.button",
            onClick: onPopupClick
        }, formatMessage((0, $25859.default).title)));
    }, [
        formatMessage,
        isOpen,
        onPopupClick,
        lastColumnName,
        releaseState,
        setReturnFocusTo
    ]);
    const handleNewVersionClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'board.release.create-new-version',
            action: 'create version menu item clicked'
        }));
        setIsNewVersionModalOpen(true);
        setIsOpen(false);
    }, [
        setIsOpen,
        setIsNewVersionModalOpen,
        createAnalyticsEvent
    ]);
    const versionMenuItemElems = (0, $5uXOq.useMemo)(()=>versionMenuItems.map((versionItem)=>{
            const handleClick = ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: 'board.release.version',
                    action: 'version menu item clicked'
                }));
                setSelectedVersion(versionItem);
                setIsOpen(false);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
                key: `${versionItem.id} ${versionItem.projectKey}`,
                onClick: handleClick,
                testId: $0adf111359e2d498$var$DROPDOWN_MENU_ITEM_TEST_ID
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: versionItem.name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0adf111359e2d498$var$versionMenuItemContainer
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $0adf111359e2d498$var$versionNameContainer
            }, versionItem.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                color: "color.text.subtlest"
            }, isMultiProjectBoard && versionItem.projectKey))));
        }), [
        createAnalyticsEvent,
        isMultiProjectBoard,
        versionMenuItems
    ]);
    const content = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZUJu.default), {
            maxWidth: 240
        }, versionMenuItemElems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
            testId: "software-board.header.menu.release-version.menu-group",
            title: formatMessage((0, $25859.default).version)
        }, versionMenuItemElems) : null, releaseState === (0, $52aa71c793d1ece4$export$119cd2a68105fcb3) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            isDisabled: true,
            testId: $0adf111359e2d498$var$DROPDOWN_MENU_ITEM_TEST_ID,
            shouldTitleWrap: true
        }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $25859.default).nothingToReleaseIssueTermRefresh : (0, $25859.default).nothingToRelease, {
            columnName: lastColumnName
        })) : null, hasIssuesWithoutVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9UCCQ.default), {
            hasSeparator: versionMenuItems.length > 0
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJpBP.default), {
            iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
                LEGACY_size: "small",
                label: "",
                color: "var(--ds-icon, #44546F)"
            }),
            onClick: handleNewVersionClick,
            testId: $0adf111359e2d498$var$DROPDOWN_MENU_ITEM_TEST_ID
        }, formatMessage((0, $25859.default).menuItemCreateVersion))));
    }, [
        handleNewVersionClick,
        formatMessage,
        versionMenuItemElems,
        releaseState,
        lastColumnName,
        hasIssuesWithoutVersion,
        versionMenuItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selectedVersion !== null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $49Sni.ReleaseVersionModal), {
        setModalClosed: closeReleaseModal,
        versionId: selectedVersion.id,
        versionName: selectedVersion.name,
        projectKey: selectedVersion.projectKey
    }), isNewVersionModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ecPxM.NewVersionReleaseModal), {
        boardId: rapidViewId,
        setModalClosed: closeNewVersionReleaseModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        placement: "left-start",
        isOpen: isOpen,
        onClose: onClose,
        trigger: popupTrigger,
        content: content
    }));
};
var $0adf111359e2d498$export$2e2bcd8739ae039 = $0adf111359e2d498$var$ReleaseVersion;
const $0adf111359e2d498$var$versionMenuItemContainer = (0, $8CUq3.xcss)({
    display: 'inline-flex',
    overflow: 'hidden',
    justifyContent: 'space-between',
    width: '100%'
});
const $0adf111359e2d498$var$versionNameContainer = (0, $8CUq3.xcss)({
    flexGrow: 1,
    marginRight: 'space.100',
    textOverflow: 'ellipsis',
    overflowX: 'hidden',
    whiteSpace: 'nowrap',
    width: '200px'
});

});
const $52aa71c793d1ece4$export$e927a5d1b72f0b68 = 'ENABLED';
const $52aa71c793d1ece4$export$6d221b2e277927d7 = 'NO_PERMISSION';
const $52aa71c793d1ece4$export$119cd2a68105fcb3 = 'NO_AVAILABLE_ISSUE_OR_VERSION';

parcelRegister("afSe5", function(module, exports) {

$parcel$export(module.exports, "getFilteredVersionsSelector", () => $f2c89b4fc8c3d1f0$export$f090f051a8da1de0);

var $dGvGJ = parcelRequire("dGvGJ");

var $gccSB = parcelRequire("gccSB");



var $1vXOx = parcelRequire("1vXOx");

var $fyeGd = parcelRequire("fyeGd");

var $vAfHD = parcelRequire("vAfHD");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $f2c89b4fc8c3d1f0$export$db548bb45f42db43 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjects),
    (0, $67Z81.getVersionData)
], (projects, versionData)=>{
    const { versionsPerProject: versionsPerProject } = versionData;
    const versionMenuItemEntities = {};
    Object.keys(versionsPerProject).flatMap((id)=>versionsPerProject[id].filter((version)=>version.released === false).forEach((activeVersion)=>{
            versionMenuItemEntities[activeVersion.id] = {
                id: activeVersion.id.toString(),
                name: activeVersion.name,
                projectKey: projects[id]?.key
            };
        }));
    return versionMenuItemEntities;
});
const $f2c89b4fc8c3d1f0$export$f090f051a8da1de0 = (0, $dGvGJ.createSelector)([
    $f2c89b4fc8c3d1f0$export$db548bb45f42db43,
    (0, $67Z81.getOrderedColumnIds),
    (0, $fyeGd.getColumns),
    (0, $5mTgl.getFilteredIssueIdsByColumn),
    (0, $vAfHD.boardIssuesSelector),
    (0, $1vXOx.getPermissionsSelector)
], (activeVersions, orderedColumnIds, allColumns, filteredIssueIdsByColumn, allIssues, boardPermissions)=>{
    // always release issues in the right most column
    const lastColumnId = orderedColumnIds[orderedColumnIds.length - 1];
    const lastColumnName = allColumns[lastColumnId]?.name;
    const canRelease = boardPermissions[0, $e525e6c25695c9df$export$172db259b98bcef1];
    if (!canRelease) return {
        releaseState: (0, $52aa71c793d1ece4$export$6d221b2e277927d7),
        versionMenuItems: [],
        hasIssuesWithoutVersion: false,
        lastColumnName: lastColumnName
    };
    const filteredIssueIds = filteredIssueIdsByColumn[lastColumnId];
    if (!filteredIssueIds || filteredIssueIds.length === 0 || !lastColumnId) return {
        releaseState: (0, $52aa71c793d1ece4$export$119cd2a68105fcb3),
        versionMenuItems: [],
        hasIssuesWithoutVersion: false,
        lastColumnName: lastColumnName
    };
    const hasIssuesWithoutVersion = filteredIssueIds.some((issueId)=>!allIssues[issueId]?.fixVersions?.length);
    const versionMenuItems = (0, (/*@__PURE__*/$parcel$interopDefault($gccSB)))(activeVersions) ? new Set() : new Set(filteredIssueIds.flatMap((issueId)=>allIssues[issueId]?.fixVersions ?? []).map((versionId)=>activeVersions[versionId]).filter((version)=>version != null));
    return {
        releaseState: (0, $52aa71c793d1ece4$export$e927a5d1b72f0b68),
        versionMenuItems: [
            ...versionMenuItems
        ],
        hasIssuesWithoutVersion: hasIssuesWithoutVersion,
        lastColumnName: lastColumnName
    };
});

});

parcelRegister("ecPxM", function(module, exports) {

$parcel$export(module.exports, "NewVersionReleaseModal", () => $1fc039fa710414a6$export$7062404577e2a78d);

var $5uXOq = parcelRequire("5uXOq");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $k8Na9 = parcelRequire("k8Na9");


var $cW3pH = parcelRequire("cW3pH");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $9TBWv = parcelRequire("9TBWv");
const $1fc039fa710414a6$export$7062404577e2a78d = ({ setModalClosed: setModalClosed, boardId: boardId })=>{
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const orderedColumnIds = (0, $67sX6.useBoardSelector)((0, $67Z81.getOrderedColumnIds));
    const lastColumnId = orderedColumnIds[orderedColumnIds.length - 1];
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const [serverErrorsInState, setServerErrors] = (0, $5uXOq.useState)(undefined);
    const onNewVersionReleased = (0, $5uXOq.useCallback)((versionName)=>{
        dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$3b24bb12b5615667)));
        setModalClosed();
        showFlag({
            messageId: 'software-board.modals.new-version-release-modal.show-flag.success.release-success',
            messageType: 'transactional',
            type: 'success',
            title: formatMessage((0, $9TBWv.default).releaseSuccessFlagTitle, {
                versionName: versionName
            }),
            isAutoDismiss: true
        });
    }, [
        dispatch,
        formatMessage,
        setModalClosed,
        showFlag
    ]);
    const onNewVersionReleaseError = (0, $5uXOq.useCallback)(async (serverErrors)=>{
        setServerErrors(serverErrors);
        if (!serverErrors?.name) {
            showFlag({
                messageId: 'software-board.modals.new-version-release-modal.show-flag.error.release-failed',
                messageType: 'transactional',
                type: 'error',
                title: formatMessage((0, $9TBWv.default).releaseFailedFlagTitle),
                description: serverErrors?.genericMessage ?? formatMessage((0, $9TBWv.default).releaseFailedFlagDescription),
                isAutoDismiss: true
            });
            // generally when this is the case, we created a version
            // but failed to release it/assign issues vissues to it
            setModalClosed();
        }
    }, [
        formatMessage,
        setModalClosed,
        setServerErrors,
        showFlag
    ]);
    const onFetchModalError = (0, $5uXOq.useCallback)(()=>{
        setModalClosed();
        showFlag({
            messageId: 'software-board.modals.new-version-release-modal.show-flag.error.release-failed.1',
            messageType: 'transactional',
            type: 'error',
            title: formatMessage((0, $9TBWv.default).releaseFailedFlagTitle),
            description: formatMessage((0, $9TBWv.default).releaseFailedFlagDescription),
            isAutoDismiss: true
        });
    }, [
        formatMessage,
        setModalClosed,
        showFlag
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k8Na9.default), {
        boardId: boardId,
        columnId: lastColumnId.toString(),
        onCancel: setModalClosed,
        onSuccess: onNewVersionReleased,
        onError: onNewVersionReleaseError,
        onFetchModalError: onFetchModalError,
        serverErrors: serverErrorsInState
    });
};

});
parcelRegister("k8Na9", function(module, exports) {

$parcel$export(module.exports, "default", () => $6d41083831eec823$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $6d41083831eec823$var$LazyNewVersionReleaseModal = (0, $kxZPA.lazy)(()=>(parcelRequire("foN8L")).then((NewVersionReleaseModal)=>NewVersionReleaseModal), {
    moduleId: "./src/packages/software/new-version-release-modal/src/ui/index.tsx"
});
const $6d41083831eec823$var$NewVersionReleaseModalAsync = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-jira-software-new-version-release-modal",
        packageName: "jiraSoftwareNewVersionReleaseModal",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "software-new-version-release-modal",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6d41083831eec823$var$LazyNewVersionReleaseModal, props)));
var $6d41083831eec823$export$2e2bcd8739ae039 = $6d41083831eec823$var$NewVersionReleaseModalAsync;

});
parcelRegister("foN8L", function(module, exports) {

let $b35f372b4243b733$var$load = (parcelRequire("28QjX"))(4);
module.exports = $b35f372b4243b733$var$load("SiuII").then(()=>parcelRequire('5UanI'));

});


parcelRegister("9TBWv", function(module, exports) {

$parcel$export(module.exports, "default", () => $818e7676c2a8968e$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $818e7676c2a8968e$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    dropdownAriaLabel: {
        "id": "software.main.header.release-version.dropdown-aria-label",
        "defaultMessage": "Release"
    },
    title: {
        "id": "software.main.header.release-version.title",
        "defaultMessage": "Release"
    },
    version: {
        "id": "software.main.header.release-version.version",
        "defaultMessage": "Version"
    },
    tooltipRelease: {
        "id": "software.main.header.release-version.tooltip-release",
        "defaultMessage": "Release a version with issues in the {columnName} column"
    },
    tooltipDisabled: {
        "id": "software.main.header.release-version.tooltip-disabled",
        "defaultMessage": "There are no issues to be released"
    },
    nothingToRelease: {
        "id": "software.main.header.release-version.nothing-to-release",
        "defaultMessage": "To release a version, move issues to the {columnName} column"
    },
    menuItemCreateVersion: {
        "id": "software.main.header.release-version.menu-item-create-version",
        "defaultMessage": "Create version"
    },
    releaseSuccessFlagTitle: {
        "id": "software.main.header.release-version.release-success-flag-title",
        "defaultMessage": "{versionName} released"
    },
    releaseFailedFlagTitle: {
        "id": "software.main.header.release-version.release-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    releaseFailedFlagDescription: {
        "id": "software.main.header.release-version.release-failed-flag-description",
        "defaultMessage": "We weren\u2019t able to complete this release. Please refresh the page and try again."
    },
    tooltipReleaseIssueTermRefresh: {
        "id": "software.main.header.release-version.tooltip-release-issue-term-refresh",
        "defaultMessage": "Release a version with work items in the {columnName} column"
    },
    tooltipDisabledIssueTermRefresh: {
        "id": "software.main.header.release-version.tooltip-disabled-issue-term-refresh",
        "defaultMessage": "There are no work items to be released"
    },
    nothingToReleaseIssueTermRefresh: {
        "id": "software.main.header.release-version.nothing-to-release-issue-term-refresh",
        "defaultMessage": "To release a version, move work items to the {columnName} column"
    }
});

});


parcelRegister("49Sni", function(module, exports) {

$parcel$export(module.exports, "ReleaseVersionModal", () => $2b5ce79e2dfa47bd$export$92e7033ce50ddfd8);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $i8Qvm = parcelRequire("i8Qvm");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $30y8c = parcelRequire("30y8c");


var $cW3pH = parcelRequire("cW3pH");

var $67sX6 = parcelRequire("67sX6");

var $9TBWv = parcelRequire("9TBWv");
const $2b5ce79e2dfa47bd$export$92e7033ce50ddfd8 = ({ setModalClosed: setModalClosed, versionId: versionId, versionName: versionName, projectKey: projectKey })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const handleError = ()=>{
        showFlag({
            messageId: 'software-board.modals.release-version-modal.show-flag.error',
            messageType: 'transactional',
            type: 'error',
            title: (0, $9TBWv.default).releaseFailedFlagTitle,
            description: (0, $9TBWv.default).releaseFailedFlagDescription,
            isAutoDismiss: true
        });
        setModalClosed();
    };
    const handleSuccess = ()=>{
        showFlag({
            messageId: 'software-board.modals.release-version-modal.show-flag.success',
            messageType: 'transactional',
            type: 'success',
            title: formatMessage((0, $9TBWv.default).releaseSuccessFlagTitle, {
                versionName: versionName
            }),
            isAutoDismiss: true
        });
        dispatch((0, $cW3pH.workRefreshData)((0, $dcbb2bce513725b3$export$3b24bb12b5615667)));
        setModalClosed();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $30y8c.default), {
        // eslint-disable-next-line jira/deprecations/no-base-url
        baseUrl: "",
        projectKey: projectKey,
        versionId: versionId,
        onOpened: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onCancel: setModalClosed,
        onSuccess: handleSuccess,
        onError: handleError
    }));
};

});
parcelRegister("30y8c", function(module, exports) {

$parcel$export(module.exports, "default", () => $2147be28d3fbd035$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $kxZPA = parcelRequire("kxZPA");
var $7hSN4 = parcelRequire("7hSN4");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $2147be28d3fbd035$var$ReleaseVersionModal = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("e5o7Z")), {
    ssr: false,
    moduleId: "./src/packages/releases/versions/src/release-version-modal/index.tsx"
});
const $2147be28d3fbd035$var$AsyncReleaseVersionModal = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "async-jira-version-modals-release-version-modal",
        packageName: (0, $71a059cf91522abc$export$595d93fed3fb6b04),
        teamName: "nova",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7hSN4.LazySuspense), {
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2147be28d3fbd035$var$ReleaseVersionModal, props)));
var $2147be28d3fbd035$export$2e2bcd8739ae039 = $2147be28d3fbd035$var$AsyncReleaseVersionModal;

});
const $71a059cf91522abc$export$595d93fed3fb6b04 = 'jiraReleasesVersions';
const $71a059cf91522abc$export$6c87c1302bf5163c = 'directories.versions.error';

parcelRegister("e5o7Z", function(module, exports) {

let $a4143f9a27c162b1$var$load = (parcelRequire("28QjX"))(4);
module.exports = $a4143f9a27c162b1$var$load("kL5hO").then(()=>parcelRequire('lqWUw'));

});



parcelRegister("25859", function(module, exports) {

$parcel$export(module.exports, "default", () => $114f3d309367bf67$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $114f3d309367bf67$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "software.main.header.menu.release-version.title",
        "defaultMessage": "Release"
    },
    version: {
        "id": "software.main.header.menu.release-version.version",
        "defaultMessage": "Version"
    },
    tooltipRelease: {
        "id": "software.main.header.menu.release-version.tooltip-release",
        "defaultMessage": "Release a version with issues in the {columnName} column"
    },
    tooltipDisabled: {
        "id": "software.main.header.menu.release-version.tooltip-disabled",
        "defaultMessage": "There are no issues to be released"
    },
    nothingToRelease: {
        "id": "software.main.header.menu.release-version.nothing-to-release",
        "defaultMessage": "To release a version, move issues to the {columnName} column"
    },
    menuItemCreateVersion: {
        "id": "software.main.header.menu.release-version.menu-item-create-version",
        "defaultMessage": "Create version"
    },
    releaseSuccessFlagTitle: {
        "id": "software.main.header.menu.release-version.release-success-flag-title",
        "defaultMessage": "{versionName} released"
    },
    releaseFailedFlagTitle: {
        "id": "software.main.header.menu.release-version.release-failed-flag-title",
        "defaultMessage": "Something went wrong"
    },
    releaseFailedFlagDescription: {
        "id": "software.main.header.menu.release-version.release-failed-flag-description",
        "defaultMessage": "We weren\u2019t able to complete this release. Please refresh the page and try again."
    },
    tooltipReleaseIssueTermRefresh: {
        "id": "software.main.header.menu.release-version.tooltip-release-issue-term-refresh",
        "defaultMessage": "Release a version with work items in the {columnName} column"
    },
    tooltipDisabledIssueTermRefresh: {
        "id": "software.main.header.menu.release-version.tooltip-disabled-issue-term-refresh",
        "defaultMessage": "There are no work items to be released"
    },
    nothingToReleaseIssueTermRefresh: {
        "id": "software.main.header.menu.release-version.nothing-to-release-issue-term-refresh",
        "defaultMessage": "To release a version, move work items to the {columnName} column"
    }
});

});




parcelRegister("7hxB7", function(module, exports) {

$parcel$export(module.exports, "default", () => $83bc29dac12334ad$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fVnbM = parcelRequire("fVnbM");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $dZbEw = parcelRequire("dZbEw");

var $7ymNM = parcelRequire("7ymNM");

var $6Ingq = parcelRequire("6Ingq");

var $hORKG = parcelRequire("hORKG");

var $3bDjY = parcelRequire("3bDjY");

var $6s1PB = parcelRequire("6s1PB");

var $koVbs = parcelRequire("koVbs");

var $7mPT9 = parcelRequire("7mPT9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $lu5k0 = parcelRequire("lu5k0");


var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");

var $afSe5 = parcelRequire("afSe5");

var $ecPxM = parcelRequire("ecPxM");

var $49Sni = parcelRequire("49Sni");

var $9TBWv = parcelRequire("9TBWv");
const $83bc29dac12334ad$var$DROPDOWN_MENU_ITEM_TEST_ID = 'software-board.header.release-version.menu-item';
const $83bc29dac12334ad$var$ReleaseVersion = ({ rapidViewId: rapidViewId })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [isDropdownOpen, setIsDropdownOpen] = (0, $5uXOq.useState)(false);
    const [isNewVersionModalOpen, setIsNewVersionModalOpen] = (0, $5uXOq.useState)(false);
    const closeNewVersionReleaseModal = (0, $5uXOq.useCallback)(()=>setIsNewVersionModalOpen(false), [
        setIsNewVersionModalOpen
    ]);
    const isMultiProjectBoard = (0, $67sX6.useBoardSelector)((0, $67Z81.hasMultipleProjects));
    const releaseButtonRef = (0, $5uXOq.useRef)(null);
    const { setReturnFocusTo: setReturnFocusTo } = (0, $lu5k0.useModalDialogActions)();
    const [selectedVersion, setSelectedVersion] = (0, $5uXOq.useState)(null);
    const closeReleaseModal = ()=>setSelectedVersion(null);
    const { releaseState: releaseState, versionMenuItems: versionMenuItems, hasIssuesWithoutVersion: hasIssuesWithoutVersion, lastColumnName: lastColumnName } = (0, $67sX6.useBoardSelector)((0, $afSe5.getFilteredVersionsSelector));
    const dropdownMenuTrigger = (0, $5uXOq.useCallback)(({ triggerRef: triggerRef, ...triggerProps })=>{
        const isDisabled = releaseState === (0, $52aa71c793d1ece4$export$6d221b2e277927d7);
        setReturnFocusTo(releaseButtonRef);
        const tooltipContent = !isDropdownOpen && releaseState === (0, $52aa71c793d1ece4$export$e927a5d1b72f0b68) ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9TBWv.default).tooltipReleaseIssueTermRefresh : (0, $9TBWv.default).tooltipRelease, {
            columnName: lastColumnName
        }) : null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
            content: isDisabled ? formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9TBWv.default).tooltipDisabledIssueTermRefresh : (0, $9TBWv.default).tooltipDisabled) : tooltipContent
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            ...triggerProps,
            "aria-label": formatMessage((0, $9TBWv.default).dropdownAriaLabel),
            ref: (0, $7mPT9.mergeRefs)(triggerRef, releaseButtonRef),
            iconAfter: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hORKG))), {
                label: "",
                LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6Ingq))),
                LEGACY_size: "medium",
                color: "var(--ds-icon, #44546F)"
            }),
            isDisabled: isDisabled,
            testId: "software-board.header.release-version.trigger"
        }, formatMessage((0, $9TBWv.default).title)));
    }, [
        formatMessage,
        isDropdownOpen,
        lastColumnName,
        releaseState,
        setReturnFocusTo
    ]);
    const onDropdownOpenChange = (0, $5uXOq.useCallback)((attrs)=>{
        if (attrs.isOpen) (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'board.release.dropdown-open',
            action: 'button clicked'
        }));
        setIsDropdownOpen(attrs.isOpen);
    }, [
        createAnalyticsEvent
    ]);
    const handleNewVersionClick = (0, $5uXOq.useCallback)(()=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'board.release.create-new-version',
            action: 'menu item clicked'
        }));
        setIsNewVersionModalOpen(true);
        setIsDropdownOpen(false);
    }, [
        setIsDropdownOpen,
        setIsNewVersionModalOpen,
        createAnalyticsEvent
    ]);
    const versionMenuItemElems = (0, $5uXOq.useMemo)(()=>versionMenuItems.map((versionItem)=>{
            const handleClick = ()=>{
                (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                    actionSubject: 'board.release.version',
                    action: 'menu item clicked'
                }));
                setSelectedVersion(versionItem);
                setIsDropdownOpen(false);
            };
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
                key: `${versionItem.id} ${versionItem.projectKey}`,
                onClick: handleClick,
                testId: $83bc29dac12334ad$var$DROPDOWN_MENU_ITEM_TEST_ID
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
                content: versionItem.name
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83bc29dac12334ad$var$VersionMenuItemContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83bc29dac12334ad$var$VersionNameContainer, null, versionItem.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($83bc29dac12334ad$var$ProjectKeyContainer, null, isMultiProjectBoard && versionItem.projectKey))));
        }), [
        createAnalyticsEvent,
        isMultiProjectBoard,
        versionMenuItems
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, selectedVersion != null && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $49Sni.ReleaseVersionModal), {
        setModalClosed: closeReleaseModal,
        versionId: selectedVersion.id,
        versionName: selectedVersion.name,
        projectKey: selectedVersion.projectKey
    }), isNewVersionModalOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ecPxM.NewVersionReleaseModal), {
        boardId: rapidViewId,
        setModalClosed: closeNewVersionReleaseModal
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        placement: "bottom-end",
        isOpen: isDropdownOpen,
        onOpenChange: onDropdownOpenChange,
        trigger: dropdownMenuTrigger,
        shouldRenderToParent: true
    }, versionMenuItemElems.length ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        testId: "software-board.header.release-version.menu-group",
        title: formatMessage((0, $9TBWv.default).version)
    }, versionMenuItemElems) : null, releaseState === (0, $52aa71c793d1ece4$export$119cd2a68105fcb3) ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isDisabled: true,
        testId: $83bc29dac12334ad$var$DROPDOWN_MENU_ITEM_TEST_ID
    }, formatMessage((0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $9TBWv.default).nothingToReleaseIssueTermRefresh : (0, $9TBWv.default).nothingToRelease, {
        columnName: lastColumnName
    })) : null, hasIssuesWithoutVersion && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: versionMenuItems.length > 0
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        elemBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dZbEw))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($7ymNM))),
            LEGACY_size: "small",
            color: "var(--ds-icon, #44546F)"
        }),
        onClick: handleNewVersionClick,
        testId: $83bc29dac12334ad$var$DROPDOWN_MENU_ITEM_TEST_ID
    }, formatMessage((0, $9TBWv.default).menuItemCreateVersion)))));
};
var $83bc29dac12334ad$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $83bc29dac12334ad$var$ReleaseVersion;
const $83bc29dac12334ad$var$VersionMenuItemContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _1e0c116y _1bah1yb4 _1bsb1osq",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83bc29dac12334ad$var$VersionNameContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_16jlkb7n _2hwxu2gc _1bto1l2s _1reo15vq _o5721q9c _1bsbuuw1",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $83bc29dac12334ad$var$ProjectKeyContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syaz131l",
            __cmplp.className
        ])
    });
});

});

parcelRegister("7lFcC", function(module, exports) {

$parcel$export(module.exports, "default", () => $eb6348c67d3dccec$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $67Z81 = parcelRequire("67Z81");

var $ebHh7 = parcelRequire("ebHh7");

var $3t2Tt = parcelRequire("3t2Tt");
var $eb6348c67d3dccec$export$2e2bcd8739ae039 = (0, $bC2fB.connect)((state)=>{
    const { remainingDays: remainingDays, startDate: startDate, endDate: endDate } = (0, $ebHh7.remainingDaysSelector)(state);
    const locale = (0, $67Z81.getLocale)(state);
    return {
        remainingDays: remainingDays,
        startDate: startDate,
        endDate: endDate,
        locale: locale
    };
}, {})((0, $3t2Tt.default));

});
parcelRegister("3t2Tt", function(module, exports) {

$parcel$export(module.exports, "default", () => $9462eb0268ad061f$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $47bDC = parcelRequire("47bDC");

var $l1N8i = parcelRequire("l1N8i");

var $hyKRO = parcelRequire("hyKRO");

var $6uqJA = parcelRequire("6uqJA");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $3bDjY = parcelRequire("3bDjY");

var $lzeFL = parcelRequire("lzeFL");

var $gSExi = parcelRequire("gSExi");

var $b71gk = parcelRequire("b71gk");

var $4R6GH = parcelRequire("4R6GH");

var $aWse0 = parcelRequire("aWse0");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $2xFXk = parcelRequire("2xFXk");

var $63LqY = parcelRequire("63LqY");

var $cRGYm = parcelRequire("cRGYm");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $9462eb0268ad061f$var$AsyncTooltipContent = (0, $kxZPA.lazy)(()=>(parcelRequire("2F1Cl")), {
    moduleId: "./src/packages/software/board/src/view/header/sprint-remaining-days/tooltip-content/index.tsx"
});
const $9462eb0268ad061f$var$RemainingDays = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$SprintRemainingDaysStyled, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RecentIconWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($hyKRO))), {
        testId: "software-board.header.sprint-remaining-days.clock-icon",
        label: "",
        spacing: "spacious",
        LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($6uqJA))),
        color: "var(--ds-icon, #44546F)"
    })), label);
const $9462eb0268ad061f$var$RemainingDaysNoIcon = ({ label: label })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$SprintRemainingDaysStyled, null, label);
const $9462eb0268ad061f$export$76ca2692cceeb7eb = (props)=>{
    const intl = (0, $aWse0.useIntlV2)();
    const { remainingDays: remainingDays, startDate: startDate, endDate: endDate, locale: locale = (0, $lzeFL.defaultLocale) } = props;
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const contentHeader = intl.formatMessage((0, $cRGYm.default).remainingDays, {
        remainingDays: remainingDays
    });
    const label = !isTabNavigation ? intl.formatMessage((0, $cRGYm.default).remainingDaysLabel, {
        remainingDays: remainingDays
    }) : contentHeader;
    if (remainingDays === null) return null;
    if (startDate === null || endDate === null || locale === null) return isTabNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RemainingDaysNoIcon, {
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RemainingDays, {
        label: label
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "async.software-board.sprint-remaining-days",
            packageName: "software-board"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "software-board-sprint-remaining-tooltip",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
                size: "small"
            })
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$AsyncTooltipContent, {
            contentHeader: contentHeader,
            startDate: startDate,
            locale: locale,
            endDate: endDate
        })))
    }, isTabNavigation ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RemainingDaysNoIcon, {
        label: label
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$RemainingDays, {
        label: label
    }));
};
var $9462eb0268ad061f$export$2e2bcd8739ae039 = $9462eb0268ad061f$export$76ca2692cceeb7eb;
const $9462eb0268ad061f$var$SprintRemainingDaysStyledWrapper = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "div",
        xcss: $9462eb0268ad061f$var$sprintRemainingDaysWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
        size: "xxsmall",
        as: "div"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9462eb0268ad061f$var$SprintRemainingDaysStyledExperiment, props)));
const $9462eb0268ad061f$var$sprintRemainingDaysWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.0',
    marginRight: 'space.100',
    marginLeft: 'space.050'
}); // TODO: migrate to object syntax. Autofix is available for many cases. Remove the eslint-disable for @atlaskit/design-system/no-styled-tagged-template-expression to check.
// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9462eb0268ad061f$var$SprintRemainingDaysStyledControl = /*#__PURE__*/ (0, $47bDC.default).div.withConfig({
    componentId: "qyp7iu-0"
})`font:${"var(--ds-font-body-UNSAFE_small, normal 400 12px/16px ui-sans-serif, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Ubuntu, \"Helvetica Neue\", sans-serif)"};color:${"var(--ds-text-subtlest, #626F86)"};display:flex;align-items:center;margin-top:0;margin-right:${"var(--ds-space-100, 8px)"};margin-left:${"var(--ds-space-050, 4px)"};`; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9462eb0268ad061f$var$SprintRemainingDaysStyledExperiment = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8dcr7 _1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $9462eb0268ad061f$var$SprintRemainingDaysStyled = (0, $gSExi.styledComponentWithCondition)(()=>(0, $4R6GH.fg)('jsw_compiled_migration_tanuki'), $9462eb0268ad061f$var$SprintRemainingDaysStyledWrapper, $9462eb0268ad061f$var$SprintRemainingDaysStyledControl); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9462eb0268ad061f$var$RecentIconWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "span", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_syazwdcn _1e0c1txw _4cvr1h6o _u5f31b66",
            __cmplp.className
        ])
    });
});

});
parcelRegister("6uqJA", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $4b9a484973717fe2$var$_react = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $4b9a484973717fe2$var$_clock = $4b9a484973717fe2$var$_interopRequireDefault((parcelRequire("hyKRO")));
function $4b9a484973717fe2$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $4b9a484973717fe2$var$EmojiFrequentIcon = (props)=>/*#__PURE__*/ $4b9a484973717fe2$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><path fill="currentcolor" fill-rule="evenodd" d="M12 4c-4.412 0-8 3.588-8 8s3.588 8 8 8 8-3.588 8-8-3.588-8-8-8m0 14.222A6.23 6.23 0 0 1 5.778 12 6.23 6.23 0 0 1 12 5.778 6.23 6.23 0 0 1 18.222 12 6.23 6.23 0 0 1 12 18.222m.889-6.59V8.448c0-.489-.4-.889-.889-.889s-.889.4-.889.89v3.555c0 .248.103.471.268.633l2.195 2.194a.89.89 0 0 0 1.257 0 .89.89 0 0 0 0-1.256z"/></svg>`
    }, props, {
        newIcon: $4b9a484973717fe2$var$_clock.default
    }));
$4b9a484973717fe2$var$EmojiFrequentIcon.displayName = 'EmojiFrequentIcon';
var $4b9a484973717fe2$var$_default = module.exports.default = $4b9a484973717fe2$var$EmojiFrequentIcon;

});

parcelRegister("cRGYm", function(module, exports) {

$parcel$export(module.exports, "default", () => $cbd993171ad6a1ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $cbd993171ad6a1ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    remainingDaysLabel: {
        "id": "software.main.header.sprint-remaining-days.remaining-days-label",
        "defaultMessage": "{remainingDays} {remainingDays, plural, one {day} other {days}}"
    },
    remainingDays: {
        "id": "software.main.header.sprint-remaining-days.remaining-days",
        "defaultMessage": "{remainingDays} {remainingDays, plural, one {day} other {days}} remaining"
    },
    startDate: {
        "id": "software.main.header.sprint-remaining-days.start-date",
        "defaultMessage": "Start date:"
    },
    endDate: {
        "id": "software.main.header.sprint-remaining-days.end-date",
        "defaultMessage": "Projected end date:"
    },
    invalidDate: {
        "id": "software.main.header.sprint-remaining-days.invalid-date",
        "defaultMessage": "Invalid date"
    }
});

});

parcelRegister("2F1Cl", function(module, exports) {

let $1f00aa525e06372b$var$load = (parcelRequire("28QjX"))(4);
module.exports = $1f00aa525e06372b$var$load("g6c6a").then(()=>parcelRequire('hcmRy'));

});



parcelRegister("j3072", function(module, exports) {

$parcel$export(module.exports, "default", () => $6b43f922e98e2b49$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $7buQq = parcelRequire("7buQq");

var $6Pv6s = parcelRequire("6Pv6s");

var $e4D5B = parcelRequire("e4D5B");
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b43f922e98e2b49$var$mapStateToProps = (state)=>({
        canEdit: (0, $6Pv6s.isEditableSelector)(state),
        boardTitle: (0, $6Pv6s.boardTitleSelector)(state)
    });
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const $6b43f922e98e2b49$var$mapDispatchToProps = (dispatch)=>({
        onSubmit: (title)=>{
            dispatch((0, $7buQq.renameBoardRequest)(title));
        }
    });
var $6b43f922e98e2b49$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($6b43f922e98e2b49$var$mapStateToProps, $6b43f922e98e2b49$var$mapDispatchToProps)((0, $e4D5B.default));

});
parcelRegister("e4D5B", function(module, exports) {

$parcel$export(module.exports, "default", () => $9b647abde50484fb$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ // eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $2nvJN = parcelRequire("2nvJN");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");

var $kY99m = parcelRequire("kY99m");

var $b71gk = parcelRequire("b71gk");

var $az4zD = parcelRequire("az4zD");

var $lfTZh = parcelRequire("lfTZh");

var $8zOmE = parcelRequire("8zOmE");

var $kxZPA = parcelRequire("kxZPA");

var $8K1gU = parcelRequire("8K1gU");
const $9b647abde50484fb$var$boardTitleMaxChars = 30;

const $9b647abde50484fb$export$97bda0f90d93904c = (0, $kxZPA.lazy)(()=>(parcelRequire("hmRlM")), {
    moduleId: "../platform/packages/design-system/inline-edit/src/index.ts"
}); // eslint-disable-next-line jira/react/no-class-components
class $9b647abde50484fb$var$Title extends (0, $5uXOq.Component) {
    render() {
        const { intl: { formatMessage: formatMessage }, canEdit: canEdit } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$LimitWidthStyle, {
            "data-testid": "software-board.header.title.container"
        }, canEdit ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$EditableMarginCorrect, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "inline-edit",
            packageName: "software-board",
            render: this.renderReadOnlyView
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "inline-edit",
            fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $9b647abde50484fb$var$loadingEditorWrapperStyles
            }, this.renderReadView())
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$export$97bda0f90d93904c, {
            editView: this.renderEditView,
            readView: this.renderReadView,
            onConfirm: this.onConfirm,
            defaultValue: this.props.boardTitle,
            editButtonLabel: formatMessage((0, $8K1gU.default).currentTitleAriaLabel, {
                currentTitle: this.props.boardTitle
            }),
            label: "",
            hideActionButtons: true
        })))) : this.renderReadOnlyView());
    }
    constructor(...args){
        super(...args), this.onConfirm = (editValue, analyticsEvent)=>{
            const { boardTitle: boardTitle } = this.props;
            if (editValue !== null) {
                const newTitle = (0, (/*@__PURE__*/$parcel$interopDefault($2nvJN)))(editValue);
                if (newTitle !== '' && newTitle !== boardTitle) {
                    this.props.onSubmit(newTitle);
                    (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'boardName');
                }
            }
        }, this.renderEditView = (fieldProps)=>{
            const { errorMessage: errorMessage, ...fieldPropsWithoutErrorMessage } = fieldProps;
            const { intl: { formatMessage: formatMessage }, boardTitle: boardTitle } = this.props;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$TextFieldWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                ...fieldPropsWithoutErrorMessage,
                "aria-label": formatMessage((0, $8K1gU.default).currentTitleAriaLabel, {
                    currentTitle: boardTitle
                }),
                autoFocus: true,
                maxLength: $9b647abde50484fb$var$boardTitleMaxChars
            }));
        }, this.renderReadView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$ReadContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$TruncatingTextStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$ReadHeading, null, this.props.boardTitle))), this.renderReadOnlyView = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$TruncatingTextStyle, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9b647abde50484fb$var$HeadingStyle, null, this.props.boardTitle));
    }
}
var $9b647abde50484fb$export$2e2bcd8739ae039 = (0, $az4zD.injectIntlV2)($9b647abde50484fb$var$Title);
const $9b647abde50484fb$var$boardTitleMaxWidth = 420; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$TextFieldWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1nb5nf1z _13gg1wug",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$LimitWidthStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_p12f1pna _19pkv77o _otyrv77o",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$ReadContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o _19pku2gc _2hwxidpf _otyru2gc _18u0idpf",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$TruncatingTextStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _16jlidpf _1o9zkb7n _i0dl1wug _o5721q9c _1bto1l2s",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$EditableMarginCorrect = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pk1l04",
            __cmplp.className
        ])
    });
});
const $9b647abde50484fb$var$loadingEditorWrapperStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150',
    marginBottom: 'space.100'
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$HeadingStyle = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _k48p1wq8 _1e0c1txw",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $9b647abde50484fb$var$ReadHeading = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "h1", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _1reo15vq _18m915vq _1bto1l2s _o5721q9c",
            __cmplp.className
        ])
    });
});

});
parcelRegister("2nvJN", function(module, exports) {

var $kHBB0 = parcelRequire("kHBB0");

var $6wH7T = parcelRequire("6wH7T");

var $gvFfr = parcelRequire("gvFfr");

var $4TR1Q = parcelRequire("4TR1Q");

var $c2mKc = parcelRequire("c2mKc");

var $jx6Tp = parcelRequire("jx6Tp");

var $jJVtR = parcelRequire("jJVtR");
/**
 * Removes leading and trailing whitespace or specified characters from `string`.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to trim.
 * @param {string} [chars=whitespace] The characters to trim.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
 * @returns {string} Returns the trimmed string.
 * @example
 *
 * _.trim('  abc  ');
 * // => 'abc'
 *
 * _.trim('-_-abc-_-', '_-');
 * // => 'abc'
 *
 * _.map(['  foo  ', '  bar  '], _.trim);
 * // => ['foo', 'bar']
 */ function $1bb6592c97235e03$var$trim(string, chars, guard) {
    string = $jJVtR(string);
    if (string && (guard || chars === undefined)) return $6wH7T(string);
    if (!string || !(chars = $kHBB0(chars))) return string;
    var strSymbols = $jx6Tp(string), chrSymbols = $jx6Tp(chars), start = $c2mKc(strSymbols, chrSymbols), end = $4TR1Q(strSymbols, chrSymbols) + 1;
    return $gvFfr(strSymbols, start, end).join('');
}
module.exports = $1bb6592c97235e03$var$trim;

});
parcelRegister("4TR1Q", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the last unmatched string symbol.
 */ function $39156edc40ecb497$var$charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while(index-- && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $39156edc40ecb497$var$charsEndIndex;

});

parcelRegister("c2mKc", function(module, exports) {

var $2wwA6 = parcelRequire("2wwA6");
/**
 * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
 * that is not found in the character symbols.
 *
 * @private
 * @param {Array} strSymbols The string symbols to inspect.
 * @param {Array} chrSymbols The character symbols to find.
 * @returns {number} Returns the index of the first unmatched string symbol.
 */ function $8c37507367fba30b$var$charsStartIndex(strSymbols, chrSymbols) {
    var index = -1, length = strSymbols.length;
    while(++index < length && $2wwA6(chrSymbols, strSymbols[index], 0) > -1);
    return index;
}
module.exports = $8c37507367fba30b$var$charsStartIndex;

});


parcelRegister("8K1gU", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce37f0d1c4f30729$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ce37f0d1c4f30729$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    currentTitleAriaLabel: {
        "id": "software.main.header.title.current-title-aria-label",
        "defaultMessage": "{currentTitle}, edit board title"
    }
});

});



parcelRegister("3NePp", function(module, exports) {

$parcel$export(module.exports, "default", () => $8da52fecfa0b4b84$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $cb25w = parcelRequire("cb25w");

var $c0aEF = parcelRequire("c0aEF");

var $2s6Sm = parcelRequire("2s6Sm");

var $cS37j = parcelRequire("cS37j");

var $eXQym = parcelRequire("eXQym");

var $6s1PB = parcelRequire("6s1PB");

var $7XYc4 = parcelRequire("7XYc4");

var $4R6GH = parcelRequire("4R6GH");

var $8zOmE = parcelRequire("8zOmE");

var $8qMCq = parcelRequire("8qMCq");

var $g5X3G = parcelRequire("g5X3G");

var $e0kZI = parcelRequire("e0kZI");

var $1393U = parcelRequire("1393U");

var $l8ruj = parcelRequire("l8ruj");

var $dCm1o = parcelRequire("dCm1o");

var $lmBAt = parcelRequire("lmBAt");

var $a2e2Q = parcelRequire("a2e2Q");

var $U0mgX = parcelRequire("U0mgX");

var $hpoCd = parcelRequire("hpoCd");

var $6OUMO = parcelRequire("6OUMO");

var $dNht2 = parcelRequire("dNht2");

var $7Zg4V = parcelRequire("7Zg4V");

var $58Nil = parcelRequire("58Nil");

var $9eTg7 = parcelRequire("9eTg7");
class $8da52fecfa0b4b84$export$8b251419efc915eb extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            sprintGoal: null,
            selectedIssueKeys: [],
            isThemed: false
        };
    }
    renderSprintGoalNavV3() {
        return this.props.sprintGoal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $58Nil.SprintGoal), {
            goal: this.props.sprintGoal
        });
    }
    renderBaseActionsNavV3() {
        const { baseUrl: baseUrl, isCMPBoard: isCMPBoard, hasActiveSprint: hasActiveSprint, isSprintsEnabled: isSprintsEnabled, isIncrementPlanningBoard: isIncrementPlanningBoard, ReleaseVersion: ReleaseVersion, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible, hasManageSprintPermission: hasManageSprintPermission, CompleteSprintButton: CompleteSprintButton, FavoriteButton: FavoriteButton, isSprintRemainingDaysVisible: isSprintRemainingDaysVisible, SprintRemainingDays: SprintRemainingDays, BoardOperations: BoardOperations, AutomationMenu: AutomationMenu, rapidViewId: rapidViewId, canManageAutomations: canManageAutomations, projectKey: projectKey, projectId: projectId, projectType: projectType, selectedIssueKeys: selectedIssueKeys, selectedIssueIds: selectedIssueIds, isReleaseVersionVisible: isReleaseVersionVisible, isHeaderCompactMode: isHeaderCompactMode, isEmbedView: isEmbedView, boardName: boardName, shouldRenderAutomationButton: shouldRenderAutomationButton, shouldRenderFavouriteButton: shouldRenderFavouriteButton, shouldRenderReleaseButton: shouldRenderReleaseButton, shouldRenderFeedbackCollectorButton: shouldRenderFeedbackCollectorButton, shouldRenderFullscreenButton: shouldRenderFullscreenButton, boardType: boardType, createAnalyticsEvent: createAnalyticsEvent, isJSWBoard: isJSWBoard, isActiveStandup: isActiveStandup, setIsActiveStandup: setIsActiveStandup, shouldShowStandupsFeature: shouldShowStandupsFeature } = this.props;
        const automationMenu = shouldRenderAutomationButton && !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AutomationMenu, {
            items: (0, $2s6Sm.boardMenuItems),
            projectType: projectType,
            projectId: (0, $g5X3G.toProjectId)(`${projectId}`),
            projectKey: (0, $g5X3G.toProjectKey)(projectKey),
            isSimplified: true // Ignored in project aware BoardMenu
            ,
            isUIF: isCMPBoard,
            canManageAutomations: canManageAutomations,
            selectedIssueKeys: selectedIssueKeys,
            // Cast issueId as number[] for now, until we need AutomationMenu for ARJ Increment planning board
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            selectedIssueIds: selectedIssueIds,
            key: "automationButton"
        });
        const favButton = shouldRenderFavouriteButton && !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(FavoriteButton, {
            key: "favouriteButton",
            baseUrl: baseUrl,
            itemId: rapidViewId,
            itemType: (0, $eXQym.BOARDS_ITEM_TYPE),
            favoriteItemName: boardName,
            tooltipPosition: "top"
        });
        const fullscreenButton = shouldRenderFullscreenButton && !isEmbedView ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hpoCd.FullscreenButton), {
            boardId: Number(rapidViewId),
            shouldRenderContent: !isActiveStandup,
            key: "fullscreenButton"
        }) : null;
        const showShareButton = !isIncrementPlanningBoard;
        const shareContentType = `${boardType}_board`;
        const onShareButtonClick = ()=>{
            const analyticsEvent = createAnalyticsEvent({
                action: 'clicked',
                actionSubject: 'button'
            });
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'shareContentType', {
                contentType: shareContentType
            });
        };
        const shareButton = showShareButton && !isActiveStandup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dNht2.JswShareButton), {
            poSpotlightShareButtonId: "po-spotlight-share-button",
            projectId: (0, $g5X3G.toProjectId)(`${projectId}`),
            key: "shareButton",
            shareContentType: shareContentType,
            onTriggerButtonClick: onShareButtonClick
        });
        const sprintRemainingDays = !isHeaderCompactMode && isSprintRemainingDaysVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(SprintRemainingDays, {
            key: "SprintRemainingButton"
        });
        const isStandupDisabled = (0, $9eTg7.shouldDisableStandup)({
            boardType: boardType,
            isSprintsEnabled: isSprintsEnabled,
            hasActiveSprint: hasActiveSprint
        });
        const standupControlButton = !isIncrementPlanningBoard && isJSWBoard && shouldShowStandupsFeature && (0, $6s1PB.expVal)('jira-in-product-standups', 'is_enabled', false) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1393U.StandupControlButtons), {
            ...(0, $4R6GH.fg)('concurrent-rendering-fix-unique-list-key') ? {
                key: 'StandupControlButton'
            } : {},
            isStandupDisabled: isStandupDisabled,
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup,
            boardId: Number(rapidViewId)
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$ActionsWrapper, null, shouldRenderFeedbackCollectorButton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $U0mgX.default), null), sprintRemainingDays, isSprintRemainingDaysVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6OUMO.Separator), {
            key: "sprint-info-separator"
        }), (0, $dCm1o.isVisualRefreshEnabled)() ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $c0aEF.default), {
            space: "space.100",
            alignInline: "center"
        }, [
            automationMenu,
            favButton,
            shareButton,
            fullscreenButton,
            standupControlButton
        ]) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$IconButtonWrapper, null, [
            automationMenu,
            favButton,
            shareButton,
            fullscreenButton,
            standupControlButton
        ]), !isEmbedView && !isHeaderCompactMode && isCompleteSprintButtonVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompleteSprintButton, {
            ...(0, $dCm1o.isVisualRefreshEnabled)() ? {
                overrideAppearance: 'primary'
            } : {},
            isDisabled: !hasManageSprintPermission
        }), !isHeaderCompactMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BoardOperations, null), shouldRenderReleaseButton && !isHeaderCompactMode && isReleaseVersionVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ReleaseVersion, {
            rapidViewId: rapidViewId
        }), !isHeaderCompactMode && isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e0kZI.BoardConnectToolbar), {
            boardId: rapidViewId,
            projectKey: projectKey,
            mode: "work"
        }));
    }
    renderBaseActionsNavV4() {
        const { CompleteSprintButton: CompleteSprintButton, hasActiveSprint: hasActiveSprint, isCompleteSprintButtonVisible: isCompleteSprintButtonVisible, isEmbedView: isEmbedView, isHeaderCompactMode: isHeaderCompactMode, shouldRenderFeedbackCollectorButton: shouldRenderFeedbackCollectorButton, hasManageSprintPermission: hasManageSprintPermission } = this.props;
        const actions = [];
        if ((0, $dCm1o.isVisualRefreshEnabled)()) {
            const shouldRenderCompleteSprintButton = !isEmbedView && !isHeaderCompactMode && isCompleteSprintButtonVisible;
            if (shouldRenderCompleteSprintButton) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompleteSprintButton, {
                key: "completeSprintButton",
                overrideAppearance: "primary",
                isDisabled: !hasManageSprintPermission
            }));
            const shouldRenderSprintControls = hasActiveSprint; // note: this also checks if sprints are enabled
            if (shouldRenderSprintControls) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Zg4V.SprintDetailsButton), {
                key: "sprintPopup"
            }));
            if (shouldRenderFeedbackCollectorButton) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $U0mgX.default), {
                key: "feedbackButton"
            }));
        } else {
            if (shouldRenderFeedbackCollectorButton) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $U0mgX.default), {
                key: "feedbackButton"
            }));
            const shouldRenderSprintControls = hasActiveSprint; // note: this also checks if sprints are enabled
            if (shouldRenderSprintControls) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Zg4V.SprintDetailsButton), {
                key: "sprintPopup"
            }));
            const shouldRenderCompleteSprintButton = !isEmbedView && !isHeaderCompactMode && isCompleteSprintButtonVisible;
            if (shouldRenderCompleteSprintButton) actions.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(CompleteSprintButton, {
                key: "completeSprintButton",
                isDisabled: !hasManageSprintPermission
            }));
        }
        if (actions.length === 0) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$ActionsWrapper, null, actions);
    }
    renderMenu() {
        const { isEmbedView: isEmbedView, isMenuVisible: isMenuVisible, Menu: Menu, boardType: boardType, isActiveStandup: isActiveStandup, hasActiveSprint: hasActiveSprint, isSprintsEnabled: isSprintsEnabled, rapidViewId: rapidViewId, setIsActiveStandup: setIsActiveStandup } = this.props;
        if (!isMenuVisible || isEmbedView) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Menu, {
            rapidViewId: Number(rapidViewId),
            boardType: boardType,
            isActiveStandup: isActiveStandup,
            isSprintsEnabled: isSprintsEnabled,
            hasActiveSprint: hasActiveSprint,
            setIsActiveStandup: setIsActiveStandup
        });
    }
    renderBaseActionsAndMenu() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$ActionsWrapper, null, this.renderBaseActionsNavV3(), this.renderMenu());
    }
    render() {
        const { ControlsBar: ControlsBar, Title: Title, BreadcrumbRenderer: BreadcrumbRenderer, isSprintsEnabled: isSprintsEnabled, hasActiveSprint: hasActiveSprint, customFiltersQueryRef: customFiltersQueryRef, boardFilterRefinementQueryRef: boardFilterRefinementQueryRef, rapidViewId: rapidViewId, isHeaderCompactMode: isHeaderCompactMode, isIncrementPlanningBoard: isIncrementPlanningBoard, shouldRenderViewSettingsCardDetailsOption: shouldRenderViewSettingsCardDetailsOption, projectKey: projectKey, projectName: projectName, isTabNavigation: isTabNavigation, isActiveStandup: isActiveStandup, setIsActiveStandup: setIsActiveStandup, boardType: boardType, isThemed: isThemed } = this.props;
        /**
     * In Advanced Roadmaps, we're embedding the JSW board into an "Increment" page
     * which already has a <PageHeader /> with its own breadcrumbs and call-to-action buttons
     * therefore all we need is the <ControlsBar />, nothing else.
     */ if (isIncrementPlanningBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "software-board-header"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$IncrementPlanningHeaderWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ControlsBar, {
            customFiltersQueryRef: null,
            hasActiveSprint: false,
            isSprintsEnabled: false,
            leftHandSideActions: isTabNavigation && (0, $4R6GH.fg)('remove_plans_fullscreen_button_in_tabs_nav') ? null : this.renderBaseActionsNavV3(),
            rapidViewId: Number(rapidViewId),
            showCardDetails: shouldRenderViewSettingsCardDetailsOption,
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup,
            boardType: boardType
        }, this.renderMenu())));
        const breadcrumbs = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$export$c7432936d9c50db7, {
            "data-fullscreen-id": "fullscreen-board-breadcrumbs"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(BreadcrumbRenderer, null), projectKey && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8qMCq.default), {
            projectKey: projectKey,
            projectName: projectName
        }));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l8ruj.default), {
            name: "software-board-header"
        }, isTabNavigation ? /* FY25 Nav v4 aka. Tab Nav caused the "reshuffle" of the header:
       * - automationMenu, shareButton, fullscreenButton => now above the tabs
       * - sprint details & controls => moved to a flyout under a new button
       * - extensions / connect apps => moved into menu
       * ALSO we remove the "isHeaderCompactMode" logic = moved outside of this func
       */ /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$HeaderWrapperNavV4, {
            isThemed: isThemed
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ControlsBar, {
            isSprintsEnabled: isSprintsEnabled,
            hasActiveSprint: hasActiveSprint,
            customFiltersQueryRef: customFiltersQueryRef,
            boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
            // @ts-expect-error TS2322 - RapidViewId is string but controls expect number
            rapidViewId: rapidViewId,
            leftHandSideActions: (0, $dCm1o.isVisualRefreshEnabled)() ? this.renderBaseActionsNavV4() : null,
            showCardDetails: shouldRenderViewSettingsCardDetailsOption,
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup,
            boardType: boardType
        }, !(0, $dCm1o.isVisualRefreshEnabled)() && this.renderBaseActionsNavV4(), this.renderMenu())) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$var$HeaderWrapperNavV3, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cS37j.default), {
            truncateTitle: true,
            disableTitleStyles: true,
            bottomBar: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ControlsBar, {
                isSprintsEnabled: isSprintsEnabled,
                hasActiveSprint: hasActiveSprint,
                customFiltersQueryRef: customFiltersQueryRef,
                boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
                // @ts-expect-error TS2322 - RapidViewId is string but controls expect number
                rapidViewId: rapidViewId,
                leftHandSideActions: isHeaderCompactMode && this.renderBaseActionsNavV3(),
                showCardDetails: shouldRenderViewSettingsCardDetailsOption,
                isActiveStandup: isActiveStandup,
                setIsActiveStandup: setIsActiveStandup,
                boardType: boardType
            }, isHeaderCompactMode && this.renderMenu()),
            actions: !isHeaderCompactMode && this.renderBaseActionsAndMenu(),
            breadcrumbs: breadcrumbs
        }, !isHeaderCompactMode && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Title, null), this.renderSprintGoalNavV3()))));
    }
}
const $8da52fecfa0b4b84$var$HeaderWrapper = (props)=>{
    const { hasSoftwareTheming: hasSoftwareTheming } = (0, $lmBAt.getIsSoftwareThemingM2Enabled)('blurry-background') ? // eslint-disable-next-line react-hooks/rules-of-hooks
    (0, $a2e2Q.useSoftwareProjectTheming)() : {
        hasSoftwareTheming: false
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($8da52fecfa0b4b84$export$8b251419efc915eb, {
        ...props,
        isThemed: hasSoftwareTheming
    });
};
var $8da52fecfa0b4b84$export$2e2bcd8739ae039 = (0, $7XYc4.componentWithCondition)(()=>(0, $lmBAt.getIsSoftwareThemingM2Enabled)('blurry-background'), (0, $cb25w.default)()($8da52fecfa0b4b84$var$HeaderWrapper), (0, $cb25w.default)()($8da52fecfa0b4b84$export$8b251419efc915eb));
const $8da52fecfa0b4b84$export$c7432936d9c50db7 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _11w3glyw",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_zulpu2gc _1e0c1txw _1bah1h6o _4cvr1h6o",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV3Old = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31jfw _n3tdidpf _19bv1jfw",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV3New = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31ejb _n3tdidpf _19bv1ejb",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV3 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $8da52fecfa0b4b84$var$HeaderWrapperNavV3New, $8da52fecfa0b4b84$var$HeaderWrapperNavV3Old);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8da52fecfa0b4b84$var$HeaderWrapperNavV4Old = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0q1ejb _u5f31jfw _n3tdidpf _19bv1jfw",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV4New = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemed: isThemed, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qv47k _u5f31ejb _n3tdidpf _19bv1ejb",
            (__cmplp.isThemed ?? false) && "_11q71iew _otyrpxbi _kqswh2mm _1kt9b3bt _1cs8stnw _kfgt1osq _1mp41osq _m9csad7r _1aukidpf _qnecidpf",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$HeaderWrapperNavV4 = (0, $7XYc4.componentWithCondition)((0, $dCm1o.isVisualRefreshEnabled), $8da52fecfa0b4b84$var$HeaderWrapperNavV4New, $8da52fecfa0b4b84$var$HeaderWrapperNavV4Old);
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $8da52fecfa0b4b84$var$IncrementPlanningHeaderWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_ca0qidpf _u5f31ejb _n3tdidpf _19bv1jfw",
            __cmplp.className
        ])
    });
});
const $8da52fecfa0b4b84$var$IconButtonWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o",
            __cmplp.className
        ])
    });
});

});
parcelRegister("cS37j", function(module, exports) {

$parcel$export(module.exports, "default", () => $2a15efb09f101ecb$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ /* This is a wrapper around @atlaskit/page-header to patch a bug where text alignment
 in actions is incorrect. This common component is no longer necessary when
 https://ecosystem.atlassian.net/browse/AK-6385 is resolved.
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $57MwZ = parcelRequire("57MwZ");
const $2a15efb09f101ecb$var$PageHeader = ({ actions: actions, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $57MwZ.default), {
        ...props,
        // @ts-expect-error - TS2322 - Type 'Element | null' is not assignable to type 'ReactElement<any, string | JSXElementConstructor<any>> | undefined'.
        actions: actions ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($2a15efb09f101ecb$var$ActionsWrapper, null, actions) : null
    });
var $2a15efb09f101ecb$export$2e2bcd8739ae039 = $2a15efb09f101ecb$var$PageHeader;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2a15efb09f101ecb$var$ActionsWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_y3gn1e5h",
            __cmplp.className
        ])
    });
});

});
parcelRegister("57MwZ", function(module, exports) {

$parcel$export(module.exports, "default", () => $9694e728fd1ea060$export$2e2bcd8739ae039);
// TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $eeGIy = parcelRequire("eeGIy");
/**
 * __Page header__
 *
 * A page header defines the top of a page. It contains a title and can be optionally combined with
 * breadcrumbs buttons, search, and filters.
 *
 * - [Examples](https://atlassian.design/components/page-header/examples)
 * - [Code](https://atlassian.design/components/page-header/code)
 * - [Usage](https://atlassian.design/components/page-header/usage)
 */ const $9694e728fd1ea060$var$PageHeader = ({ innerRef: innerRef, breadcrumbs: breadcrumbs, actions: actions, bottomBar: bottomBar, children: children, id: id, disableTitleStyles: disableTitleStyles = false, truncateTitle: truncateTitle = false, testId: testId })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.OuterWrapper), {
        children: [
            breadcrumbs,
            /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.TitleWrapper), {
                truncateTitle: truncateTitle,
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.TitleContainer), {
                        truncateTitle: truncateTitle,
                        children: disableTitleStyles ? children : /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.StyledTitleWrapper), {
                            ref: innerRef,
                            truncateTitle: truncateTitle,
                            id: id,
                            testId: testId,
                            children: children
                        })
                    }),
                    actions && /*#__PURE__*/ (0, $2OMIu.jsx)((0, $eeGIy.ActionsWrapper), {
                        children: actions
                    })
                ]
            }),
            bottomBar && /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $eeGIy.BottomBarWrapper), {
                children: [
                    " ",
                    bottomBar,
                    " "
                ]
            })
        ]
    });
};
var $9694e728fd1ea060$export$2e2bcd8739ae039 = $9694e728fd1ea060$var$PageHeader;

});
parcelRegister("eeGIy", function(module, exports) {

$parcel$export(module.exports, "OuterWrapper", () => $0c196d37a4e8266c$export$edaaad985a878983);
$parcel$export(module.exports, "StyledTitleWrapper", () => $0c196d37a4e8266c$export$284be1ee64a3465c);
$parcel$export(module.exports, "TitleWrapper", () => $0c196d37a4e8266c$export$585a3b23e887288b);
$parcel$export(module.exports, "TitleContainer", () => $0c196d37a4e8266c$export$35e09ba17cc51c69);
$parcel$export(module.exports, "ActionsWrapper", () => $0c196d37a4e8266c$export$c8223871eecc8f3a);
$parcel$export(module.exports, "BottomBarWrapper", () => $0c196d37a4e8266c$export$6330225854c30dc);
/* styled.tsx generated by @compiled/babel-plugin v0.36.1 */ // TODO: Remove this eslint-disable when prop names have been renamed.
// This rule is here as prop name changes are a major as they are used
// by our consumers. The prop name concerned here is truncateTitle.
// This can be done in the next lite-mode conversion.
/* eslint-disable @repo/internal/react/boolean-prop-naming-convention */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
const $0c196d37a4e8266c$var$styles = {
    bottomBar: "_1pfhpxbi"
};
const $0c196d37a4e8266c$var$truncateStyles = null;
const $0c196d37a4e8266c$var$outerStyles = null;
const $0c196d37a4e8266c$var$titleStyles = null;
const $0c196d37a4e8266c$var$titleWrapperStyles = null;
const $0c196d37a4e8266c$var$titleWrapperTruncateStyles = null;
const $0c196d37a4e8266c$var$titleContainerStyles = null;
const $0c196d37a4e8266c$var$actionStyles = null;
const $0c196d37a4e8266c$var$titleContainerTruncateStyles = null;
const $0c196d37a4e8266c$export$edaaad985a878983 = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_6rthpxbi _1pfh1ejb _12l2idpf _ahbqidpf"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$284be1ee64a3465c = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).forwardRef(({ children: children, id: id, truncateTitle: truncateTitle, testId: testId }, ref)=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("h1", {
        ref: ref,
        tabIndex: -1,
        id: id,
        "data-testid": testId && `${testId}--title`,
        className: (0, $bwpsq.default)([
            "_11c8nf1z _12ji1r31 _1qu2glyw _12y31o36 _syaz1fxt _1dyz4jg8 _1pfhidpf",
            truncateTitle && "_1reo15vq _18m915vq _1bto1l2s _o5721q9c"
        ]),
        children: children
    });
});
const $0c196d37a4e8266c$export$585a3b23e887288b = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1y6m _1n261g80",
            truncateTitle && "_1n261q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$35e09ba17cc51c69 = ({ children: children, truncateTitle: truncateTitle })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlkb7n _1o9zidpf _i0dl1wug _1ul9idpf _p12f1osq _6rthu2gc",
            truncateTitle && "_1o9zkb7n"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$c8223871eecc8f3a = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            "_16jlidpf _1o9zidpf _i0dl1wug _p12f1osq _6rthu2gc _ahbq1wug _bozgxy5q _o5721q9c"
        ]),
        children: children
    });
};
const $0c196d37a4e8266c$export$6330225854c30dc = ({ children: children })=>{
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        xcss: $0c196d37a4e8266c$var$styles.bottomBar,
        children: children
    });
};

});



parcelRegister("8qMCq", function(module, exports) {

$parcel$export(module.exports, "default", () => $87b5bc435d98c94f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lUz5s = parcelRequire("lUz5s");

var $hgsSB = parcelRequire("hgsSB");

var $2XiUm = parcelRequire("2XiUm");
const $87b5bc435d98c94f$var$ErrorBoundary = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        teamName: (0, $lUz5s.APP_TEAM_NAME),
        id: "projectCreateImportProgress",
        packageName: (0, $hgsSB.APP_IDENTIFIER),
        fallback: "unmount"
    }, children);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$87b5bc435d98c94f$export$2e2bcd8739ae039 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($87b5bc435d98c94f$var$ErrorBoundary, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2XiUm.default), props));

});
parcelRegister("lUz5s", function(module, exports) {

$parcel$export(module.exports, "X2C_SERVICE_URL_PREFIX", () => $c689fb2a7c606375$export$e8e1caec1dfda22c);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $c689fb2a7c606375$export$2cea7f14750b8c19);
$parcel$export(module.exports, "APP_TEAM_NAME", () => $c689fb2a7c606375$export$a5a8ee89d936ca29);
$parcel$export(module.exports, "INITIAL_MIGRATION_STATUS", () => $c689fb2a7c606375$export$7198445d3ab0721e);
$parcel$export(module.exports, "FEEDBACK_GROUP_ID", () => $c689fb2a7c606375$export$14b33d63628336c2);
$parcel$export(module.exports, "IMPORT_TYPE_PARAM_KEY", () => $c689fb2a7c606375$export$85c452e39fc36d3d);
$parcel$export(module.exports, "WORKSPACE_ID_PARAM_KEY", () => $c689fb2a7c606375$export$ad63f63c74460d35);
$parcel$export(module.exports, "ENTITY_ID_PARAM_KEY", () => $c689fb2a7c606375$export$a14f08973e10eb93);

var $y3A0q = parcelRequire("y3A0q");
const $c689fb2a7c606375$export$e8e1caec1dfda22c = '/gateway/api/jira-x2c-service/api/v1';
const $c689fb2a7c606375$export$2cea7f14750b8c19 = 'jira-business.project-create-importer-common';
const $c689fb2a7c606375$export$a5a8ee89d936ca29 = 'x2c-wolverine';
const $c689fb2a7c606375$export$7198445d3ab0721e = {
    overallProgress: 0.05,
    overallStatus: (0, $y3A0q.Status).READY,
    createdIssues: 0,
    totalIssues: 0,
    detailedProgress: {
        dataTransformStatus: (0, $y3A0q.Status).READY,
        userImportStatus: (0, $y3A0q.Status).READY,
        projectCreateStatus: (0, $y3A0q.Status).READY
    }
};
const $c689fb2a7c606375$export$14b33d63628336c2 = 'jwm-feedback-importer';
const $c689fb2a7c606375$export$85c452e39fc36d3d = 'importType';
const $c689fb2a7c606375$export$ad63f63c74460d35 = 'workspaceId';
const $c689fb2a7c606375$export$a14f08973e10eb93 = 'entityId';

});
parcelRegister("y3A0q", function(module, exports) {

$parcel$export(module.exports, "Status", () => $c053cc3f623c4541$export$96e9906d6d93a972);
const $c053cc3f623c4541$export$96e9906d6d93a972 = {
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED'
};

});


parcelRegister("hgsSB", function(module, exports) {

$parcel$export(module.exports, "IMPORT_IN_PROGRESS_FLAG_ID", () => $3f5b74842571fa2d$export$3ee01c364a42b386);
$parcel$export(module.exports, "IMPORT_SUCCESS_FLAG_ID", () => $3f5b74842571fa2d$export$b4a552f4abf9b350);
$parcel$export(module.exports, "IMPORT_PARTIAL_SUCCESS_FLAG_ID", () => $3f5b74842571fa2d$export$62eac7116dbcab91);
$parcel$export(module.exports, "IMPORT_ADVANCED_ERRORS_FLAG_ID", () => $3f5b74842571fa2d$export$18a16c13a76c4a32);
$parcel$export(module.exports, "BASE_POLLING_INTERVAL_MS", () => $3f5b74842571fa2d$export$aa34325aa01d2f38);
$parcel$export(module.exports, "APP_IDENTIFIER", () => $3f5b74842571fa2d$export$2cea7f14750b8c19);
$parcel$export(module.exports, "CONTACT_SUPPORT_URL", () => $3f5b74842571fa2d$export$2c16bd1d8b68b11f);
const $3f5b74842571fa2d$export$3ee01c364a42b386 = 'import-in-progress-flag';
const $3f5b74842571fa2d$export$b4a552f4abf9b350 = 'import-success-flag';
const $3f5b74842571fa2d$export$62eac7116dbcab91 = 'import-partial-success-flag';
const $3f5b74842571fa2d$export$18a16c13a76c4a32 = 'import-advanced-errors-error-flag';
const $3f5b74842571fa2d$export$aa34325aa01d2f38 = 5000;
const $3f5b74842571fa2d$export$2cea7f14750b8c19 = 'jira-business.project-create-import-progress';
const $3f5b74842571fa2d$export$2c16bd1d8b68b11f = 'https://support.atlassian.com/contact/#/?inquiry_category=technical_issues&is_cloud=true&product_key=jira-work-management&support_type=customer';

});

parcelRegister("2XiUm", function(module, exports) {

$parcel$export(module.exports, "default", () => $f36303d1eb77403c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");

var $dfBUy = parcelRequire("dfBUy");

var $1O9Yy = parcelRequire("1O9Yy");

var $gChKN = parcelRequire("gChKN");

var $9qb4V = parcelRequire("9qb4V");
const $f36303d1eb77403c$var$ImportProgressFlag = ({ migrationId: migrationId, onSuccess: onSuccess, onFail: onFail })=>{
    (0, $9qb4V.useTrackMigrationStatus)((0, $1O9Yy.EXPERIENCES).IMPORT_PART_2, migrationId, onSuccess, onFail);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null);
};
const $f36303d1eb77403c$var$ImportProgress = ({ projectKey: projectKey, projectName: projectName })=>{
    const { fetchMigrationId: fetchMigrationId, removeMigrationId: removeMigrationId } = (0, $dfBUy.useMigrationIdManager)();
    const [migrationId, setMigrationId] = (0, $5uXOq.useState)(undefined);
    const { onSuccess: onSuccess, onFail: onFail } = (0, $gChKN.useFlags)({
        projectKey: projectKey,
        projectName: projectName,
        migrationId: migrationId,
        removeMigrationId: removeMigrationId
    });
    (0, $5uXOq.useEffect)(()=>{
        setMigrationId(fetchMigrationId(projectKey));
    }, [
        fetchMigrationId,
        projectKey
    ]);
    if (!migrationId) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: (0, $1O9Yy.X2C_SCREENS).ImportProgressBar,
        sourceType: (0, $4d5e0871c06cee03$export$f636b5b56f1d624a)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($f36303d1eb77403c$var$ImportProgressFlag, {
        onSuccess: onSuccess,
        onFail: onFail,
        migrationId: migrationId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null));
};
var $f36303d1eb77403c$export$2e2bcd8739ae039 = $f36303d1eb77403c$var$ImportProgress;

});
parcelRegister("dfBUy", function(module, exports) {

$parcel$export(module.exports, "useMigrationIdManager", () => $89bd768709492155$export$b6df8a64ae5b060b);

var $5uXOq = parcelRequire("5uXOq");

var $7uUwQ = parcelRequire("7uUwQ");

var $9zHJW = parcelRequire("9zHJW");
const $89bd768709492155$export$b6df8a64ae5b060b = ()=>{
    const fetchMigrationId = (0, $5uXOq.useCallback)((projectKey)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        return migrationIdStore[projectKey];
    }, []);
    const storeMigrationId = (0, $5uXOq.useCallback)((projectKey, migrationId)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        (0, $9zHJW.setMigrationIdStore)({
            ...migrationIdStore,
            [projectKey]: migrationId
        });
    }, []);
    const removeMigrationId = (0, $5uXOq.useCallback)((projectKey)=>{
        const migrationIdStore = (0, $9zHJW.getMigrationIdStore)();
        if (!(projectKey in migrationIdStore)) return;
        const newMigrationIdStore = (0, $7uUwQ.unset)(migrationIdStore, projectKey);
        if (Object.keys(newMigrationIdStore).length === 0) {
            (0, $9zHJW.removeMigrationIdStore)();
            return;
        }
        (0, $9zHJW.setMigrationIdStore)(newMigrationIdStore);
    }, []);
    return {
        fetchMigrationId: fetchMigrationId,
        storeMigrationId: storeMigrationId,
        removeMigrationId: removeMigrationId
    };
};

});
parcelRegister("9zHJW", function(module, exports) {

$parcel$export(module.exports, "getMigrationIdStore", () => $7568774462293954$export$caa1665a7b4680f6);
$parcel$export(module.exports, "setMigrationIdStore", () => $7568774462293954$export$d5f201daa9ea05b7);
$parcel$export(module.exports, "removeMigrationIdStore", () => $7568774462293954$export$7a4ecb0a9136dcec);

var $bSSG7 = parcelRequire("bSSG7");

var $4R6GH = parcelRequire("4R6GH");
const $7568774462293954$var$MIGRATION_ID_STORE_KEY = 'X2C-Migration-Id-Store';
const $7568774462293954$var$localStorageProvider = (0, $bSSG7.createLocalStorageProvider)('', false);
const $7568774462293954$export$caa1665a7b4680f6 = ()=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? JSON.parse($7568774462293954$var$localStorageProvider.get($7568774462293954$var$MIGRATION_ID_STORE_KEY) || '{}') : JSON.parse(localStorage.getItem($7568774462293954$var$MIGRATION_ID_STORE_KEY) || '{}');
const $7568774462293954$export$d5f201daa9ea05b7 = (migrationIdStore)=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $7568774462293954$var$localStorageProvider.set($7568774462293954$var$MIGRATION_ID_STORE_KEY, JSON.stringify(migrationIdStore)) : localStorage.setItem($7568774462293954$var$MIGRATION_ID_STORE_KEY, JSON.stringify(migrationIdStore));
const $7568774462293954$export$7a4ecb0a9136dcec = ()=>(0, $4R6GH.fg)('jfp-vulcan-browser-storage-migration') ? $7568774462293954$var$localStorageProvider.remove($7568774462293954$var$MIGRATION_ID_STORE_KEY) : localStorage.removeItem($7568774462293954$var$MIGRATION_ID_STORE_KEY);

});


parcelRegister("1O9Yy", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCES", () => $9a9e8a67185abd0f$export$a2008ed3b02411a3);
$parcel$export(module.exports, "X2C_SCREENS", () => $9a9e8a67185abd0f$export$ff4b3425b39a0344);
const $9a9e8a67185abd0f$export$a2008ed3b02411a3 = {
    IMPORT_PART_2: 'projectCreateImporterImportPart2',
    IMPORT_PART_JSW: 'projectCreateImporterImportPart2JSW'
};
const $9a9e8a67185abd0f$export$ff4b3425b39a0344 = {
    ImportProgressBar: 'projectCreateImportProgressBar'
};

});

parcelRegister("gChKN", function(module, exports) {

$parcel$export(module.exports, "useFlags", () => $29ab02dd8dae572d$export$2879604e6aec4ab);

var $5uXOq = parcelRequire("5uXOq");

var $jPxJ7 = parcelRequire("jPxJ7");

var $pa9q9 = parcelRequire("pa9q9");

var $lpwtK = parcelRequire("lpwtK");

var $hgsSB = parcelRequire("hgsSB");

var $fz15h = parcelRequire("fz15h");

var $blRqr = parcelRequire("blRqr");
const $29ab02dd8dae572d$export$2879604e6aec4ab = ({ projectKey: projectKey, projectName: projectName, migrationId: migrationId, removeMigrationId: removeMigrationId })=>{
    const { showFlag: showFlag, dismissFlag: dismissFlag, hasFlag: hasFlag } = (0, $pa9q9.useFlagsService)();
    const openFeedbackModal = (0, $jPxJ7.useFeedbackCollector)();
    const { data: data } = (0, $lpwtK.useProject)();
    const name = data?.name || '';
    const handleDownloadLogsClick = (0, $fz15h.useDownloadLogs)(migrationId, projectName || name);
    const dismissInProgressFlag = (0, $5uXOq.useCallback)(()=>{
        dismissFlag((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID));
    }, [
        dismissFlag
    ]);
    const onSuccess = (0, $5uXOq.useCallback)((migrationStatus)=>{
        if (!hasFlag?.((0, $hgsSB.IMPORT_SUCCESS_FLAG_ID))) {
            dismissInProgressFlag();
            removeMigrationId(projectKey || projectName);
            showFlag((0, $blRqr.getSuccessFlag)(migrationStatus, projectName || name, openFeedbackModal));
        }
    }, // omit openFeedbackModal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        dismissInProgressFlag,
        hasFlag,
        migrationId,
        projectKey,
        removeMigrationId,
        showFlag
    ]);
    const onFail = (0, $5uXOq.useCallback)((migrationStatus)=>{
        if (migrationStatus.hasErrorLogs) {
            if (!hasFlag?.((0, $hgsSB.IMPORT_ADVANCED_ERRORS_FLAG_ID)) && migrationId) {
                dismissInProgressFlag();
                removeMigrationId(projectKey);
                showFlag((0, $blRqr.getAdvancedErrorFlag)({
                    migrationStatus: migrationStatus,
                    projectName: projectName || name,
                    onDownloadLogsClick: handleDownloadLogsClick
                }));
            }
            return;
        }
        if (!hasFlag?.((0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID))) {
            dismissInProgressFlag();
            removeMigrationId(projectKey);
            showFlag((0, $blRqr.getPartialSuccessFlag)(migrationStatus, openFeedbackModal));
        }
    }, // omit openFeedbackModal
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        handleDownloadLogsClick,
        dismissInProgressFlag,
        hasFlag,
        migrationId,
        projectKey,
        removeMigrationId,
        showFlag
    ]);
    (0, $5uXOq.useEffect)(()=>()=>{
            dismissFlag((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID));
            dismissFlag((0, $hgsSB.IMPORT_SUCCESS_FLAG_ID));
            dismissFlag((0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID));
        }, [
        dismissFlag
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!migrationId || hasFlag?.((0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID))) return;
        showFlag((0, $blRqr.getInProgressFlag)());
    }, [
        hasFlag,
        migrationId,
        showFlag
    ]);
    return {
        onSuccess: onSuccess,
        onFail: onFail
    };
};

});
parcelRegister("jPxJ7", function(module, exports) {

$parcel$export(module.exports, "useFeedbackCollector", () => $11c0bec8448c2614$export$4be696be8a3bff13);

var $5uXOq = parcelRequire("5uXOq");

var $e4yMr = parcelRequire("e4yMr");

var $4R6GH = parcelRequire("4R6GH");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $6jY6G = parcelRequire("6jY6G");

var $dAfqg = parcelRequire("dAfqg");

var $itmJb = parcelRequire("itmJb");

var $9OXo1 = parcelRequire("9OXo1");

var $5XRYo = parcelRequire("5XRYo");

var $5Dn32 = parcelRequire("5Dn32");
const $11c0bec8448c2614$export$698ff856156a88fe = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5XRYo.default).canContactPrompt), ' ', (0, $4R6GH.fg)('replace-anchor-with-link__wanjel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $5XRYo.default).canContactPromptLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
        href: "https://www.atlassian.com/legal/privacy-policy",
        target: "_blank",
        rel: "noopener noreferrer"
    }, formatMessage((0, $5XRYo.default).canContactPromptLink))));
});
const $11c0bec8448c2614$export$4f77effad9540593 = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return(// eslint-disable-next-line @atlaskit/design-system/use-primitives-text
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5XRYo.default).enrollInResearchPrompt, {
        link: (0, $4R6GH.fg)('replace-anchor-with-link__wanjel') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $5XRYo.default).enrollInResearchLink)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("a", {
            href: "https://www.atlassian.com/research-group",
            target: "_blank",
            rel: "noopener noreferrer"
        }, formatMessage((0, $5XRYo.default).enrollInResearchLink))
    })));
});
const $11c0bec8448c2614$export$4be696be8a3bff13 = ({ projectType: projectType = 'business' } = {})=>{
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const { licensedProducts: licensedProducts } = (0, $9OXo1.useTenantContext)();
    const route = (0, $6jY6G.useCurrentRoute)();
    const { data: project } = (0, $dAfqg.useProjectContext)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const getFeedbackContext = (0, $5uXOq.useCallback)((feedbackGroupId)=>{
        const baseFeedbackContext = [
            {
                id: (0, $7iULw.EntryKeys).INLINE_FEEDBACK_ID,
                value: feedbackGroupId
            },
            {
                id: (0, $7iULw.EntryKeys).ROUTE_NAME,
                value: route.name ?? 'unknown'
            },
            {
                id: (0, $7iULw.EntryKeys).ROUTE_GROUP,
                value: route.group ?? 'unknown'
            },
            {
                id: (0, $7iULw.EntryKeys).IS_ADMIN,
                value: isAdmin
            },
            {
                id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
                value: project?.projectType || projectType
            },
            {
                id: (0, $7iULw.EntryKeys).SUPPORTED_PROJECT_TYPES,
                value: (0, $5Dn32.licensedProductsToString)(licensedProducts)
            }
        ];
        // Only send project specific information if project is available
        if (project) baseFeedbackContext.push({
            id: (0, $7iULw.EntryKeys).IS_SIMPLIFIED_PROJECT,
            value: project.simplified
        });
        return baseFeedbackContext;
    }, [
        isAdmin,
        licensedProducts,
        project,
        projectType,
        route.group,
        route.name
    ]);
    return (0, $5uXOq.useCallback)((feedbackGroupId, onClose, triggerRef)=>{
        const feedbackContext = getFeedbackContext(feedbackGroupId);
        openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: feedbackGroupId,
            canBeContactedLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$698ff856156a88fe, null),
            enrolInResearchLabel: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($11c0bec8448c2614$export$4f77effad9540593, null),
            feedbackContext: feedbackContext,
            onClose: onClose,
            ...triggerRef != null ? {
                triggerRef: triggerRef
            } : {}
        });
    }, [
        getFeedbackContext,
        openFeedbackCollector
    ]);
};

});
parcelRegister("5XRYo", function(module, exports) {

$parcel$export(module.exports, "default", () => $6c924dc8de5075ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $6c924dc8de5075ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    canContactPrompt: {
        "id": "business-feedback-collector.can-contact-prompt",
        "defaultMessage": "Atlassian may contact me about this feedback."
    },
    canContactPromptLink: {
        "id": "business-feedback-collector.can-contact-prompt-link",
        "defaultMessage": "Privacy policy"
    },
    enrollInResearchPrompt: {
        "id": "business-feedback-collector.enroll-in-research-prompt",
        "defaultMessage": "I'd like to help improve Atlassian products by joining the {link}"
    },
    enrollInResearchLink: {
        "id": "business-feedback-collector.enroll-in-research-link",
        "defaultMessage": "Atlassian Research Group"
    }
});

});

parcelRegister("5Dn32", function(module, exports) {

$parcel$export(module.exports, "licensedProductsToString", () => $0dd3b476597799f0$export$f57a7f1d32485807);
const $0dd3b476597799f0$export$f57a7f1d32485807 = (licensedProducts)=>Object.keys(licensedProducts).map((productKey)=>licensedProducts[productKey] ? productKey : '').join(', ');

});


parcelRegister("fz15h", function(module, exports) {

$parcel$export(module.exports, "useDownloadLogs", () => $6d31cbbfee4870f9$export$178888e79b080a89);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $bGO0w = parcelRequire("bGO0w");

var $koeKL = parcelRequire("koeKL");
const $6d31cbbfee4870f9$export$bb3b75778e3e272 = (fileUrl, fileName)=>{
    // Need to create a link to trigger the download instead of redirecting
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName;
    link.click();
};
const $6d31cbbfee4870f9$export$178888e79b080a89 = (migrationId, projectName)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const fileName = (0, $bGO0w.useErrorLogFileName)(projectName);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    return (0, $5uXOq.useCallback)(()=>{
        if (!migrationId) return;
        const url = (0, $bGO0w.createDownloadLogsUrl)({
            cloudId: cloudId,
            migrationId: migrationId,
            fileName: fileName
        });
        const uiEvent = createAnalyticsEvent({
            action: 'clicked',
            actionSubject: 'downloadX2CLogsLink'
        });
        (0, $8zOmE.fireUIAnalytics)(uiEvent);
        $6d31cbbfee4870f9$export$bb3b75778e3e272(url, fileName);
    }, [
        migrationId,
        cloudId,
        createAnalyticsEvent,
        fileName
    ]);
};

});
parcelRegister("bGO0w", function(module, exports) {

$parcel$export(module.exports, "isSynthetic", () => $c62bab4235c79636$export$947749d756ccb0a);
$parcel$export(module.exports, "createDownloadLogsUrl", () => $c62bab4235c79636$export$441dc85364beea74);
$parcel$export(module.exports, "useErrorLogFileName", () => $c62bab4235c79636$export$b3518e4126b755e4);

var $4R6GH = parcelRequire("4R6GH");

var $j8DrX = parcelRequire("j8DrX");

var $koVbs = parcelRequire("koVbs");

var $lUz5s = parcelRequire("lUz5s");

var $gUE7k = parcelRequire("gUE7k");
const $c62bab4235c79636$export$947749d756ccb0a = ()=>// Filter out synthetic tests using all known ways
    (0, $j8DrX.default)('ajs-is-synthetic') === 'true' || (0, $4R6GH.fg)('is_synthetic_tenant');
const $c62bab4235c79636$export$441dc85364beea74 = ({ cloudId: cloudId, migrationId: migrationId, fileName: fileName })=>`${0, $lUz5s.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/${migrationId}/logs?${new URLSearchParams({
        fileName: fileName
    }).toString()}`;
const $c62bab4235c79636$export$b3518e4126b755e4 = (projectName)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return formatMessage((0, $gUE7k.default).errorLogFileName, {
        projectName: projectName.replace(/[&*()[\];'"?!() ]/g, '_')
    });
};

});
parcelRegister("gUE7k", function(module, exports) {

$parcel$export(module.exports, "default", () => $393e9c07e06134e1$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $393e9c07e06134e1$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    errorLogFileName: {
        "id": "project-create-importer-common.common.error-log-file-name",
        "defaultMessage": "{projectName}_import_error_log.zip"
    }
});

});



parcelRegister("blRqr", function(module, exports) {

$parcel$export(module.exports, "getSuccessFlag", () => $079ea54cd024905b$export$dbe4723f1df81b00);
$parcel$export(module.exports, "getAdvancedErrorFlag", () => $079ea54cd024905b$export$3bf6b82a650cc3f6);
$parcel$export(module.exports, "getPartialSuccessFlag", () => $079ea54cd024905b$export$368940990df88cd9);
$parcel$export(module.exports, "getInProgressFlag", () => $079ea54cd024905b$export$fc9c6c786fccb031);

var $6s1PB = parcelRequire("6s1PB");

var $lUz5s = parcelRequire("lUz5s");

var $hgsSB = parcelRequire("hgsSB");

var $2rCPm = parcelRequire("2rCPm");
const $079ea54cd024905b$export$dbe4723f1df81b00 = (migrationStatus, projectName, openFeedbackModal)=>({
        id: (0, $hgsSB.IMPORT_SUCCESS_FLAG_ID),
        type: 'success',
        isAutoDismiss: false,
        title: [
            (0, $2rCPm.default).importSuccessFlagTitle,
            {
                projectName: projectName
            }
        ],
        description: [
            (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2rCPm.default).importSuccessDescriptionIssueTermRefresh : (0, $2rCPm.default).importSuccessDescription,
            {
                count: migrationStatus.createdIssues
            }
        ],
        messageId: `project-create-import-progress.common.utils.use-flags.getSuccessFlag.${projectName}`,
        messageType: 'transactional',
        actions: [
            {
                content: (0, $2rCPm.default).refreshPage,
                // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
                onClick: ()=>window.location.reload()
            },
            {
                content: (0, $2rCPm.default).giveFeedback,
                onClick: ()=>openFeedbackModal((0, $lUz5s.FEEDBACK_GROUP_ID))
            }
        ]
    });
const $079ea54cd024905b$export$3bf6b82a650cc3f6 = ({ projectName: projectName, migrationStatus: migrationStatus, onDownloadLogsClick: onDownloadLogsClick })=>({
        id: (0, $hgsSB.IMPORT_ADVANCED_ERRORS_FLAG_ID),
        type: 'error',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importAdvancedErrorTitle,
        description: [
            (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $2rCPm.default).importAdvancedErrorDescriptionIssueTermRefresh : (0, $2rCPm.default).importAdvancedErrorDescription,
            {
                failed: migrationStatus.totalIssues - migrationStatus.createdIssues,
                total: migrationStatus.totalIssues,
                projectName: projectName
            }
        ],
        messageId: `project-create-import-progress.common.utils.use-flags.getAdvancedErrorFlag.${projectName}`,
        messageType: 'transactional',
        actions: [
            {
                content: (0, $2rCPm.default).downloadLogs,
                onClick: onDownloadLogsClick
            },
            {
                content: (0, $2rCPm.default).contactSupport,
                href: (0, $hgsSB.CONTACT_SUPPORT_URL),
                target: '_blank'
            }
        ]
    });
const $079ea54cd024905b$export$368940990df88cd9 = (migrationStatus, openFeedbackModal)=>({
        id: (0, $hgsSB.IMPORT_PARTIAL_SUCCESS_FLAG_ID),
        type: 'info',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importPartialSuccessTitle,
        description: (0, $2rCPm.default).importPartialSuccessDescription,
        messageId: 'project-create-import-progress.common.utils.use-flags.flag.info.get-partial-success-flag',
        messageType: 'transactional',
        actions: [
            {
                content: (0, $2rCPm.default).contactSupport,
                href: (0, $hgsSB.CONTACT_SUPPORT_URL),
                target: '_blank'
            },
            {
                content: (0, $2rCPm.default).giveFeedback,
                onClick: ()=>openFeedbackModal((0, $lUz5s.FEEDBACK_GROUP_ID))
            }
        ]
    });
const $079ea54cd024905b$export$fc9c6c786fccb031 = ()=>({
        id: (0, $hgsSB.IMPORT_IN_PROGRESS_FLAG_ID),
        type: 'info',
        isAutoDismiss: false,
        title: (0, $2rCPm.default).importingInProgressTitle,
        description: (0, $2rCPm.default).importingInProgressDescription,
        messageId: 'project-create-import-progress.common.utils.use-flags.flag.info.get-in-progress-flag',
        messageType: 'transactional'
    });

});
parcelRegister("2rCPm", function(module, exports) {

$parcel$export(module.exports, "default", () => $d9f9fa85f2d5ed95$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $d9f9fa85f2d5ed95$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    importingInProgressTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.importing-in-progress-title",
        "defaultMessage": "We\u2019re importing your data"
    },
    importingInProgressDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.importing-in-progress-description",
        "defaultMessage": "You won't see any imported data yet, but feel free to work on other things while we get this done. Return to this page to check the progress of your import."
    },
    importSuccessDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-description",
        "defaultMessage": "Refresh the page to see the {count, plural, one {# issue} other {# issues}} in your new project."
    },
    importSuccessFlagTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-flag-title",
        "defaultMessage": "{projectName} is ready!"
    },
    importPartialSuccessTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-partial-success-title",
        "defaultMessage": "We couldn\u2019t import all your data"
    },
    importAdvancedErrorTitle: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-title",
        "defaultMessage": "We can't seem to import all your data"
    },
    importAdvancedErrorDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-description",
        "defaultMessage": "See the error log to understand why {failed} of your {total} {total, plural, one {issue} other {issues}} failed."
    },
    importPartialSuccessDescription: {
        "id": "project-create-import-progress.common.utils.use-flags.import-partial-success-description",
        "defaultMessage": "Try again in a few minutes. If you continue experiencing problems with your import, contact support."
    },
    contactSupport: {
        "id": "project-create-import-progress.common.utils.use-flags.contact-support",
        "defaultMessage": "Contact Support"
    },
    downloadLogs: {
        "id": "project-create-import-progress.common.utils.use-flags.download-logs",
        "defaultMessage": "Download logs"
    },
    giveFeedback: {
        "id": "project-create-import-progress.common.utils.use-flags.give-feedback",
        "defaultMessage": "Give feedback"
    },
    refreshPage: {
        "id": "project-create-import-progress.common.utils.use-flags.refresh-page",
        "defaultMessage": "Refresh page"
    },
    importSuccessDescriptionIssueTermRefresh: {
        "id": "project-create-import-progress.common.utils.use-flags.import-success-description-issue-term-refresh",
        "defaultMessage": "Refresh the page to see the {count, plural, one {# work item} other {# work items}} in your new project."
    },
    importAdvancedErrorDescriptionIssueTermRefresh: {
        "id": "project-create-import-progress.common.utils.use-flags.import-advanced-error-description-issue-term-refresh",
        "defaultMessage": "See the error log to understand why {failed} of your {total} {total, plural, one {work item} other {work items}} failed."
    }
});

});



parcelRegister("9qb4V", function(module, exports) {

$parcel$export(module.exports, "useTrackMigrationStatus", () => $b3e371579e4bd3ba$export$840ba962ebf22de);

var $5uXOq = parcelRequire("5uXOq");

var $y3A0q = parcelRequire("y3A0q");

var $av6CA = parcelRequire("av6CA");

var $97g70 = parcelRequire("97g70");

var $hgsSB = parcelRequire("hgsSB");
const $b3e371579e4bd3ba$export$840ba962ebf22de = (experience, migrationId, onSuccess, onFail)=>{
    const { migrationStatus: migrationStatus } = (0, $97g70.usePollMigrationStatus)(migrationId, (0, $hgsSB.BASE_POLLING_INTERVAL_MS));
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $av6CA.useExperienceTracker)(experience);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceStart();
    }, [
        onExperienceStart
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (migrationStatus.overallStatus === (0, $y3A0q.Status).SUCCESS) {
            onExperienceSuccess();
            onSuccess && onSuccess(migrationStatus);
            return;
        }
        if (migrationStatus.overallStatus === (0, $y3A0q.Status).FAILED) {
            onExperienceFail((0, $hgsSB.APP_IDENTIFIER), {
                name: 'Import Failed',
                message: 'Issue Import Failed'
            }, {
                migrationId: migrationId
            });
            onFail && onFail(migrationStatus);
        }
    }, [
        migrationId,
        migrationStatus,
        onExperienceFail,
        onExperienceSuccess,
        onFail,
        onSuccess
    ]);
    return {
        migrationStatus: migrationStatus
    };
};

});
parcelRegister("av6CA", function(module, exports) {

$parcel$export(module.exports, "useExperienceTracker", () => $21b8d38806d1cf23$export$cdefb2a8b53f879f);

var $5uXOq = parcelRequire("5uXOq");

var $7Jxgt = parcelRequire("7Jxgt");

var $93jKl = parcelRequire("93jKl");

var $kaHBi = parcelRequire("kaHBi");

var $3bQtK = parcelRequire("3bQtK");

var $fZneA = parcelRequire("fZneA");

var $lGpwc = parcelRequire("lGpwc");
const $21b8d38806d1cf23$var$analyticsSource = 'ProjectCreateImporter';
const $21b8d38806d1cf23$export$cdefb2a8b53f879f = (experience)=>{
    const onExperienceStart = (0, $kaHBi.useExperienceStart)({
        experienceId: (0, $7Jxgt.v4)(),
        experience: experience,
        analyticsSource: $21b8d38806d1cf23$var$analyticsSource
    });
    const onExperienceSuccess = (0, $3bQtK.useExperienceSuccess)({
        experience: experience,
        attributes: {}
    });
    const onFail = (0, $93jKl.useExperienceFail)({
        experience: experience,
        attributes: {}
    });
    const onExperienceFail = (0, $5uXOq.useCallback)((location, error, extraAttributes)=>{
        if ((0, $fZneA.isClientFetchError)(error) || (0, $fZneA.isHttpClientErrorResponse)(error)) {
            onExperienceSuccess();
            return;
        }
        onFail(location, error, {
            errorName: (0, $lGpwc.extractErrorName)(error),
            errorMessage: (0, $lGpwc.extractErrorMessage)(error),
            statusCode: (0, $lGpwc.extractStatusCode)(error),
            traceId: (0, $lGpwc.extractTraceId)(error),
            buildKey: (0, $lGpwc.getBuildKey)(),
            ...extraAttributes || {}
        });
    }, [
        onExperienceSuccess,
        onFail
    ]);
    return [
        onExperienceStart,
        onExperienceSuccess,
        onExperienceFail
    ];
};

});
parcelRegister("lGpwc", function(module, exports) {

$parcel$export(module.exports, "getBuildKey", () => $0b1b329ab61a1369$export$14551268fbd9a06f);
$parcel$export(module.exports, "extractStatusCode", () => $0b1b329ab61a1369$export$1fdf7c1c0741a7e7);
$parcel$export(module.exports, "extractTraceId", () => $0b1b329ab61a1369$export$431eacb6aecbacdf);
$parcel$export(module.exports, "extractErrorName", () => $0b1b329ab61a1369$export$ebcf8325c79b7706);
$parcel$export(module.exports, "extractErrorMessage", () => $0b1b329ab61a1369$export$8cc545829c7461b0);

var $9XE6b = parcelRequire("9XE6b");
const $0b1b329ab61a1369$export$ba068cc3610b559d = 'NOT_PRESENT';
const $0b1b329ab61a1369$export$14551268fbd9a06f = ()=>window.BUILD_KEY;
const $0b1b329ab61a1369$export$1fdf7c1c0741a7e7 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'statusCode'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$431eacb6aecbacdf = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'traceId'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$ebcf8325c79b7706 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'name'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);
const $0b1b329ab61a1369$export$8cc545829c7461b0 = (error)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(error, [
        'message'
    ], $0b1b329ab61a1369$export$ba068cc3610b559d);

});


parcelRegister("97g70", function(module, exports) {

$parcel$export(module.exports, "usePollMigrationStatus", () => $4c6504a7ae7fd778$export$523c1933cb8cd7a6);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $7f4tk = parcelRequire("7f4tk");

var $koeKL = parcelRequire("koeKL");

var $lUz5s = parcelRequire("lUz5s");

var $9E3iL = parcelRequire("9E3iL");

var $y3A0q = parcelRequire("y3A0q");

var $bGO0w = parcelRequire("bGO0w");

var $av6CA = parcelRequire("av6CA");

var $5wfyT = parcelRequire("5wfyT");
const $4c6504a7ae7fd778$export$84e2f2da851426a9 = 1800000;
const $4c6504a7ae7fd778$export$a1301e284b39cd56 = 1.3;
const $4c6504a7ae7fd778$var$getX2CMigrationStatusUrl = (cloudId, migrationId)=>`${0, $lUz5s.X2C_SERVICE_URL_PREFIX}/${cloudId}/import/${migrationId}/status`;
const $4c6504a7ae7fd778$export$7edd275ea1b9d090 = (cloudId, migrationId)=>(0, $7f4tk.default)($4c6504a7ae7fd778$var$getX2CMigrationStatusUrl(cloudId, migrationId), {
        method: 'GET',
        headers: {
            'x-issynthetic-traffic': String((0, $bGO0w.isSynthetic)())
        }
    });
const $4c6504a7ae7fd778$export$523c1933cb8cd7a6 = (migrationId, basePollingIntervalMs)=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const [migrationStatus, setMigrationStatus] = (0, $5uXOq.useState)((0, $lUz5s.INITIAL_MIGRATION_STATUS));
    const [onExperienceStart, onExperienceSuccess, onExperienceFail] = (0, $av6CA.useExperienceTracker)((0, $9E3iL.EXPERIENCES).POLLING);
    const getPollingRetryStatus = (0, $5uXOq.useCallback)(async ()=>{
        if (!migrationId) return false;
        try {
            onExperienceStart();
            (0, $9E3iL.pollingInteractionMetric).start();
            const containerTransferStatus = await $4c6504a7ae7fd778$export$7edd275ea1b9d090(cloudId, migrationId);
            const status = (0, $5wfyT.calculateMigrationStatus)(containerTransferStatus);
            setMigrationStatus(status);
            (0, $9E3iL.pollingInteractionMetric).stop();
            onExperienceSuccess();
            return status.overallStatus !== (0, $y3A0q.Status).SUCCESS && status.overallStatus !== (0, $y3A0q.Status).FAILED;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            (0, $9E3iL.pollingInteractionMetric).stop();
            onExperienceFail((0, $lUz5s.APP_IDENTIFIER), error, {
                migrationId: migrationId
            });
            (0, $jcw0u.default)({
                meta: {
                    id: 'fetch-migration-status-error',
                    packageName: (0, $lUz5s.APP_IDENTIFIER),
                    teamName: (0, $lUz5s.APP_TEAM_NAME)
                },
                sendToPrivacyUnsafeSplunk: true,
                error: error
            });
            if ((0, $5wfyT.isRetryable)(error)) return true;
            setMigrationStatus({
                ...migrationStatus,
                overallStatus: (0, $y3A0q.Status).FAILED
            });
            return false;
        }
    }, [
        cloudId,
        migrationId,
        migrationStatus,
        onExperienceFail,
        onExperienceStart,
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (migrationId) (0, $5wfyT.withExponentialBackoff)(getPollingRetryStatus, basePollingIntervalMs, $4c6504a7ae7fd778$export$84e2f2da851426a9, $4c6504a7ae7fd778$export$a1301e284b39cd56);
    // Only setup new polling if migrationId or interval changes
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        migrationId,
        basePollingIntervalMs
    ]);
    return {
        migrationStatus: migrationStatus
    };
};

});
parcelRegister("9E3iL", function(module, exports) {

$parcel$export(module.exports, "EXPERIENCES", () => $19021017c40d5b8e$export$a2008ed3b02411a3);
$parcel$export(module.exports, "pollingInteractionMetric", () => $19021017c40d5b8e$export$40607ce86ffe9e76);

var $dGrdR = parcelRequire("dGrdR");

var $lUz5s = parcelRequire("lUz5s");
const $19021017c40d5b8e$export$a2008ed3b02411a3 = {
    POLLING: 'projectCreateImporterPolling'
};
const $19021017c40d5b8e$var$POLLING_ITERACTION_METRIC_KEY = `${(0, $lUz5s.APP_IDENTIFIER)}.polling`;
const $19021017c40d5b8e$export$40607ce86ffe9e76 = (0, $dGrdR.metrics).interaction({
    key: $19021017c40d5b8e$var$POLLING_ITERACTION_METRIC_KEY,
    histogram: {
        result: '200_500_1000_2000_3000_4000_5000_10000',
        response: '200_500_1000_2000_3000_4000_5000_10000'
    }
});

});

parcelRegister("5wfyT", function(module, exports) {

$parcel$export(module.exports, "calculateMigrationStatus", () => $3eb6aec6bd421b16$export$214c69f9b592e736);
$parcel$export(module.exports, "isRetryable", () => $3eb6aec6bd421b16$export$f146c102d7613638);
$parcel$export(module.exports, "withExponentialBackoff", () => $3eb6aec6bd421b16$export$20eaa22f2295996f);

var $9XE6b = parcelRequire("9XE6b");

var $lUz5s = parcelRequire("lUz5s");

var $y3A0q = parcelRequire("y3A0q");

var $hmhzd = parcelRequire("hmhzd");
const $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY = 'jiraImport';
const $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY = 'jiraX2CProjectImport';
const $3eb6aec6bd421b16$var$JIRA_DATA_TRANSFORM_OPERATION_KEY = 'jiraDataTransform';
const $3eb6aec6bd421b16$var$ALL_USER_IMPORT_OPERATION_KEY = 'allUserImport';
const $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY = 'jira/classic:project';
const $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY = 'jira:issue';
const $3eb6aec6bd421b16$var$QUEUES_ENTITY_KEY = 'jira/servicedesk:queue';
const $3eb6aec6bd421b16$var$PROGRESS_WEIGHTING = {
    jiraImport: 0.5,
    allUserImport: 0.3,
    jiraProjectFinalise: 0.1,
    jiraDataTransfer: 0.1
};
const $3eb6aec6bd421b16$var$isFailedStatus = (status)=>status === (0, $hmhzd.TransferStatus).FAILED || status === (0, $hmhzd.TransferStatus).INCOMPLETE || status === (0, $hmhzd.TransferStatus).CANCELLED || status === (0, $hmhzd.TransferStatus).SKIPPED;
const $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'completed',
        'created'
    ], 0);
const $3eb6aec6bd421b16$var$getFailedJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'completed',
        'failed'
    ], 0);
const $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity = (transfer, entityKey)=>(0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(transfer, [
        'progressProperties',
        'completedEntityCounts',
        entityKey,
        'totalEntities'
    ], 0);
const $3eb6aec6bd421b16$export$37d331774442a79a = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return {
        createdIssues: 0,
        totalIssues: 0
    };
    return {
        createdIssues: $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY),
        totalIssues: $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$ISSUE_ENTITY_KEY)
    };
};
const $3eb6aec6bd421b16$var$transformTranferStatusToStatus = (transferStatus)=>{
    if ($3eb6aec6bd421b16$var$isFailedStatus(transferStatus)) return (0, $y3A0q.Status).FAILED;
    if (transferStatus === (0, $hmhzd.TransferStatus).SUCCESS) return (0, $y3A0q.Status).SUCCESS;
    if (transferStatus === (0, $hmhzd.TransferStatus).IN_PROGRESS) return (0, $y3A0q.Status).IN_PROGRESS;
    return (0, $y3A0q.Status).READY;
};
const $3eb6aec6bd421b16$var$getStatusForOperation = (containerTransferStatus, operationKey)=>{
    const transfer = containerTransferStatus.transfers?.find((t)=>t.operationKey === operationKey);
    return transfer?.businessStatus ? $3eb6aec6bd421b16$var$transformTranferStatusToStatus(transfer.businessStatus) : (0, $y3A0q.Status).READY;
};
const $3eb6aec6bd421b16$var$getProjectCreateStatus = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return (0, $y3A0q.Status).READY;
    const createdProjectEntities = $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    const totalProjectEntities = $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    const failedProjectEntities = $3eb6aec6bd421b16$var$getFailedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$PROJECT_ENTITY_KEY);
    if (failedProjectEntities !== 0) return (0, $y3A0q.Status).FAILED;
    if (createdProjectEntities === 0) return (0, $y3A0q.Status).READY;
    if (createdProjectEntities === totalProjectEntities) return (0, $y3A0q.Status).SUCCESS;
    return (0, $y3A0q.Status).IN_PROGRESS;
};
const $3eb6aec6bd421b16$var$getQueuesCreateStatus = (containerTransferStatus)=>{
    const jiraImportTransfer = containerTransferStatus.transfers?.find((transfer)=>transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_OPERATION_KEY || transfer.operationKey === $3eb6aec6bd421b16$var$JIRA_IMPORT_V4_OPERATION_KEY);
    if (!jiraImportTransfer) return (0, $y3A0q.Status).READY;
    const createdQueuesEntities = $3eb6aec6bd421b16$var$getCreatedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$QUEUES_ENTITY_KEY);
    const totalQueuesEntities = $3eb6aec6bd421b16$var$getTotalJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$QUEUES_ENTITY_KEY);
    const failedQueuesEntities = $3eb6aec6bd421b16$var$getFailedJiraImportCountForEntity(jiraImportTransfer, $3eb6aec6bd421b16$var$QUEUES_ENTITY_KEY);
    if (totalQueuesEntities === 0) return undefined;
    if (failedQueuesEntities !== 0) return (0, $y3A0q.Status).FAILED;
    if (createdQueuesEntities === 0) return (0, $y3A0q.Status).READY;
    if (createdQueuesEntities === totalQueuesEntities) return (0, $y3A0q.Status).SUCCESS;
    return (0, $y3A0q.Status).IN_PROGRESS;
};
const $3eb6aec6bd421b16$export$ad5f54dfa4c25e4b = (containerTransferStatus)=>({
        dataTransformStatus: $3eb6aec6bd421b16$var$getStatusForOperation(containerTransferStatus, $3eb6aec6bd421b16$var$JIRA_DATA_TRANSFORM_OPERATION_KEY),
        userImportStatus: $3eb6aec6bd421b16$var$getStatusForOperation(containerTransferStatus, $3eb6aec6bd421b16$var$ALL_USER_IMPORT_OPERATION_KEY),
        projectCreateStatus: $3eb6aec6bd421b16$var$getProjectCreateStatus(containerTransferStatus),
        queueCreationStatus: $3eb6aec6bd421b16$var$getQueuesCreateStatus(containerTransferStatus)
    });
const $3eb6aec6bd421b16$var$getProgressForTransfer = (transfer)=>{
    if (transfer.businessStatus === (0, $hmhzd.TransferStatus).SUCCESS) return 1;
    if (transfer.businessStatus === (0, $hmhzd.TransferStatus).READY) return 0;
    if (transfer.progressProperties === undefined || transfer.progressProperties === null) return 0;
    const { createdEntities: createdEntities, totalEntities: totalEntities } = transfer.progressProperties;
    if (createdEntities === undefined || totalEntities === undefined) return 0;
    return createdEntities / totalEntities;
};
const $3eb6aec6bd421b16$var$calculateProgress = (containerTransferStatus)=>{
    let progress = 0;
    containerTransferStatus.transfers?.forEach((transfer)=>{
        const weighting = $3eb6aec6bd421b16$var$PROGRESS_WEIGHTING[transfer.operationKey] || 0;
        progress += $3eb6aec6bd421b16$var$getProgressForTransfer(transfer) * weighting;
    });
    return progress;
};
const $3eb6aec6bd421b16$export$214c69f9b592e736 = (containerTransferStatus)=>{
    if (containerTransferStatus.businessStatus === (0, $hmhzd.TransferStatus).READY) return 0, $lUz5s.INITIAL_MIGRATION_STATUS;
    const issueStats = $3eb6aec6bd421b16$export$37d331774442a79a(containerTransferStatus);
    const detailedProgress = $3eb6aec6bd421b16$export$ad5f54dfa4c25e4b(containerTransferStatus);
    if (containerTransferStatus.businessStatus === (0, $hmhzd.TransferStatus).SUCCESS) return {
        overallProgress: 1,
        overallStatus: (0, $y3A0q.Status).SUCCESS,
        detailedProgress: detailedProgress,
        ...issueStats
    };
    const progress = $3eb6aec6bd421b16$var$calculateProgress(containerTransferStatus);
    if ($3eb6aec6bd421b16$var$isFailedStatus(containerTransferStatus.businessStatus)) {
        const migrationFailedStatus = {
            overallProgress: progress,
            overallStatus: (0, $y3A0q.Status).FAILED,
            detailedProgress: detailedProgress,
            ...issueStats
        };
        return {
            ...migrationFailedStatus,
            hasErrorLogs: containerTransferStatus.hasErrorLogs
        };
    }
    return {
        overallProgress: progress,
        overallStatus: (0, $y3A0q.Status).IN_PROGRESS,
        detailedProgress: detailedProgress,
        ...issueStats
    };
};
const $3eb6aec6bd421b16$export$f146c102d7613638 = (error)=>error?.statusCode === 429 || error?.statusCode === 503 || error?.name === 'NetworkError';
const $3eb6aec6bd421b16$var$waitTimeMs = (ms)=>new Promise((resolve)=>setTimeout(resolve, ms));
const $3eb6aec6bd421b16$export$c3c863e65cddb513 = (baseIntervalMs, maxPollingIntervalMs, exponentialBase, retryCount)=>{
    const time = baseIntervalMs * exponentialBase ** retryCount;
    return time > maxPollingIntervalMs ? maxPollingIntervalMs : time;
};
const $3eb6aec6bd421b16$export$20eaa22f2295996f = (callback, baseIntervalMs, maxPollingInterval, exponentialBase, retryCount = 0)=>callback().then((shouldRetry)=>shouldRetry && $3eb6aec6bd421b16$var$waitTimeMs($3eb6aec6bd421b16$export$c3c863e65cddb513(baseIntervalMs, maxPollingInterval, exponentialBase, retryCount)).then(()=>$3eb6aec6bd421b16$export$20eaa22f2295996f(callback, baseIntervalMs, maxPollingInterval, exponentialBase, retryCount + 1)));

});
parcelRegister("hmhzd", function(module, exports) {

$parcel$export(module.exports, "TransferStatus", () => $7f1b77f714ac571e$export$91301ebb6ad45fab);
const $7f1b77f714ac571e$export$7d7a98f44861e6f7 = {
    JIRA_PROJECT: 'JiraProject',
    SITE: 'Site'
};
const $7f1b77f714ac571e$export$91301ebb6ad45fab = {
    READY: 'READY',
    IN_PROGRESS: 'IN_PROGRESS',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    SKIPPED: 'SKIPPED',
    INCOMPLETE: 'INCOMPLETE',
    CANCELLED: 'CANCELLED'
};

});






parcelRegister("e0kZI", function(module, exports) {

$parcel$export(module.exports, "BoardConnectToolbar", () => $4677f90b43f839a0$export$afbfa45d45a0cda1);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $fjfkx = parcelRequire("fjfkx");

var $fNWqR = parcelRequire("fNWqR");
function $4677f90b43f839a0$var$BoardConnectToolbarInner({ boardId: boardId, projectKey: projectKey, mode: mode }) {
    const toolSections = (0, $fNWqR.useFetchedToolSections)({
        boardId: boardId,
        projectKey: projectKey,
        mode: mode
    });
    if (!toolSections) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fjfkx.BoardToolsView), {
        toolSections: toolSections
    });
}
function $4677f90b43f839a0$export$afbfa45d45a0cda1(props) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "board-connect-toolbar",
        packageName: "@atlassian/jira-software-board-connect-toolbar",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4677f90b43f839a0$var$BoardConnectToolbarInner, props));
}

});

parcelRegister("U0mgX", function(module, exports) {

$parcel$export(module.exports, "default", () => $e4ec8a787bc20212$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $fVnbM = parcelRequire("fVnbM");

var $5dqGX = parcelRequire("5dqGX");

var $3g1Fk = parcelRequire("3g1Fk");

var $1kVqg = parcelRequire("1kVqg");

var $3bDjY = parcelRequire("3bDjY");

var $2vSU6 = parcelRequire("2vSU6");

var $7iULw = parcelRequire("7iULw");

var $dseDh = parcelRequire("dseDh");

var $koVbs = parcelRequire("koVbs");

var $9OXo1 = parcelRequire("9OXo1");

var $67sX6 = parcelRequire("67sX6");

var $67Z81 = parcelRequire("67Z81");


var $8MbKE = parcelRequire("8MbKE");
const $e4ec8a787bc20212$var$getAdditionalFeedbackEntries = ({ isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, projectType: projectType, boardType: boardType, environment: environment, cloudId: cloudId, boardId: boardId, appEdition: appEdition })=>[
        {
            id: (0, $7iULw.EntryKeys).IS_ADMIN,
            value: isAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).IS_SITE_ADMIN,
            value: isSiteAdmin.toString()
        },
        {
            id: (0, $7iULw.EntryKeys).PROJECT_TYPE,
            value: projectType
        },
        {
            id: (0, $7iULw.EntryKeys).BOARD_TYPE,
            value: boardType
        },
        {
            id: 'ENV',
            value: environment
        },
        {
            id: 'CLOUD_ID',
            value: cloudId
        },
        {
            id: 'BOARD_ID',
            value: boardId
        },
        {
            id: 'JIRA_SOFTWARE_EDITION',
            value: appEdition
        }
    ];
const $e4ec8a787bc20212$var$FeedbackButton = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const projectType = (0, $67sX6.useBoardSelector)((0, $67Z81.projectTypeSelector));
    const isServiceDeskProject = projectType === (0, $2vSU6.SERVICE_DESK_PROJECT);
    // Details needed by JSW feedback collector
    const { isAdmin: isAdmin, isSiteAdmin: isSiteAdmin, environment: environment, cloudId: cloudId, appEditions: appEditions } = (0, $9OXo1.useTenantContext)();
    const boardType = (0, $67sX6.useBoardSelector)((0, $67Z81.getBoardTypeForAnalytics));
    const boardId = (0, $67sX6.useBoardSelector)((0, $67Z81.rapidViewIdSelector));
    const { openFeedbackCollector: openFeedbackCollector } = (0, $dseDh.useFeedbackCollectorActions)();
    const onClick = ()=>openFeedbackCollector({
            entrypointId: (0, $7iULw.ENTRYPOINT_ID_JIRA_PLATFORM),
            feedbackGroupId: isServiceDeskProject ? (0, $30a039470bd29ca5$export$719fab391286fbcd) : (0, $30a039470bd29ca5$export$e34a1c8584d4a8b3),
            feedbackContext: !isServiceDeskProject ? $e4ec8a787bc20212$var$getAdditionalFeedbackEntries({
                isAdmin: isAdmin,
                isSiteAdmin: isSiteAdmin,
                projectType: projectType,
                boardType: boardType,
                environment: environment ?? 'UNKNOWN',
                cloudId: cloudId,
                boardId: boardId,
                appEdition: appEditions.software
            }) : []
        });
    const compactFeedbackButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: formatMessage((0, $8MbKE.default).feedbackButtonLabel),
        position: "top"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5dqGX))), {
            label: formatMessage((0, $8MbKE.default).feedbackButtonLabel),
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g1Fk))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: "software-board.header.feedback-collector-button.feedback-button"
    }));
    const fullscreenFeedbackButton = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        onClick: onClick,
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5dqGX))), {
            label: "",
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($3g1Fk))),
            LEGACY_primaryColor: "var(--ds-icon, #44546F)",
            color: "var(--ds-icon, #44546F)"
        }),
        testId: "software-board.header.feedback-collector-button.feedback-button"
    }, formatMessage((0, $8MbKE.default).feedbackButtonLabel));
    if (isServiceDeskProject) return compactFeedbackButton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        below: "lg"
    }, compactFeedbackButton), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1kVqg.Show), {
        above: "lg"
    }, fullscreenFeedbackButton));
};
var $e4ec8a787bc20212$export$2e2bcd8739ae039 = $e4ec8a787bc20212$var$FeedbackButton;

});
const $30a039470bd29ca5$export$719fab391286fbcd = 'jsm.board';
const $30a039470bd29ca5$export$e34a1c8584d4a8b3 = 'jsw.board';

parcelRegister("8MbKE", function(module, exports) {

$parcel$export(module.exports, "default", () => $bc8976dda4abe2f2$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $bc8976dda4abe2f2$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    feedbackButtonLabel: {
        "id": "software.main.header.feedback-collector-button.feedback-button-label",
        "defaultMessage": "Give feedback"
    }
});

});


parcelRegister("hpoCd", function(module, exports) {

$parcel$export(module.exports, "FullscreenButton", () => $381e6d1de1164ff8$export$305be705ce696d42);

var $5uXOq = parcelRequire("5uXOq");

var $99BAr = parcelRequire("99BAr");

var $a4XJc = parcelRequire("a4XJc");

var $iDGXn = parcelRequire("iDGXn");

var $63LqY = parcelRequire("63LqY");
const $381e6d1de1164ff8$var$getFullscreenRefs = ()=>// eslint-disable-next-line @typescript-eslint/consistent-type-assertions, jira/jira-ssr/no-unchecked-globals-usage
    Array.from(document.querySelectorAll('[data-fullscreen-id]'));
const $381e6d1de1164ff8$export$305be705ce696d42 = ({ boardId: boardId, shouldRenderContent: shouldRenderContent })=>{
    const { setIsFullscreen: setIsFullscreen } = (0, $iDGXn.useViewSettingsActions)();
    const isFullscreen = (0, $iDGXn.useIsFullscreen)();
    const view = (0, $63LqY.useIsIncrementPlanningBoard)() ? (0, $a4XJc.View).INCREMENT_PLANNING_BOARD : (0, $a4XJc.View).BOARD;
    const handleFullscreenToggle = (0, $5uXOq.useCallback)((wasFullscreen)=>{
        setIsFullscreen({
            boardId: boardId,
            isFullscreen: !wasFullscreen,
            view: view
        });
    }, [
        boardId,
        setIsFullscreen,
        view
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $99BAr.default), {
        testId: "software-board.header.fullscreen-button.fullscreen-button",
        getCustomRefs: $381e6d1de1164ff8$var$getFullscreenRefs,
        withContainerStyles: false,
        onToggle: handleFullscreenToggle,
        isFullscreen: isFullscreen,
        shouldRenderContent: shouldRenderContent
    });
};

});

parcelRegister("6OUMO", function(module, exports) {

$parcel$export(module.exports, "Separator", () => $8aeb6a9a658476c8$export$1ff3c3f08ae963c0);

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");
var $8CUq3 = parcelRequire("8CUq3");
const $8aeb6a9a658476c8$export$1ff3c3f08ae963c0 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $8aeb6a9a658476c8$var$separatorStyles
    });
const $8aeb6a9a658476c8$var$separatorStyles = (0, $8CUq3.xcss)({
    height: "var(--ds-space-300, 24px)",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
    borderRight: `1px solid ${"var(--ds-border, #091E4224)"}`
});

});

parcelRegister("dNht2", function(module, exports) {

$parcel$export(module.exports, "JswShareButton", () => $9f4c91afe3771d74$export$54c54e47ce207cc8);

var $5uXOq = parcelRequire("5uXOq");

var $jZ4fr = parcelRequire("jZ4fr");

var $imZsD = parcelRequire("imZsD");
var $5Fk4Z = parcelRequire("5Fk4Z");

var $koVbs = parcelRequire("koVbs");

var $dXq4S = parcelRequire("dXq4S");

var $5GqLe = parcelRequire("5GqLe");

var $iL8EU = parcelRequire("iL8EU");

var $9j8is = parcelRequire("9j8is");

var $koeKL = parcelRequire("koeKL");

var $bdr6Y = parcelRequire("bdr6Y");
const $9f4c91afe3771d74$export$54c54e47ce207cc8 = ({ projectId: projectId, shareContentType: shareContentType, onTriggerButtonClick: onTriggerButtonClick, poSpotlightShareButtonId: poSpotlightShareButtonId })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { shareIntegrations: shareIntegrations } = (0, $9j8is.useShareIntegrations)('board');
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $imZsD.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5Fk4Z.default), {
        name: "ccEcoBoardBacklogShare"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iL8EU.ShareButton), {
        integrationType: (0, $5GqLe.integrationTypes).CLASSIC_BOARD,
        triggerButtonStyle: "icon-only",
        productId: "jira",
        subProductId: "jira-software",
        shareTitle: formatMessage((0, $bdr6Y.default).shareTitle),
        shareFormTitle: formatMessage((0, $bdr6Y.default).shareFormTitle),
        shareContentType: shareContentType,
        objectAri: (0, $dXq4S.createAri)({
            resourceOwner: 'jira',
            cloudId: cloudId,
            resourceType: 'project',
            resourceId: projectId
        }),
        copyTooltipText: formatMessage((0, $bdr6Y.default).shareTooltipText),
        shareIntegrations: shareIntegrations,
        shareFormHelperMessage: formatMessage((0, $bdr6Y.default).shareHelperMessage),
        onTriggerButtonClick: onTriggerButtonClick,
        poSpotlightShareButtonId: poSpotlightShareButtonId
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jZ4fr.EngagementSpotlight), {
        name: "ccEcoBoardBacklogShare"
    })));
};

});
parcelRegister("5GqLe", function(module, exports) {

$parcel$export(module.exports, "integrationTypes", () => $0970fea694a8095f$export$a7359bcfb0ca8e98);
const $0970fea694a8095f$export$a7359bcfb0ca8e98 = {
    BENTO_ISSUE: 'bentoIssue',
    CLASSIC_BOARD: 'classicBoard',
    NEXTGEN_BOARD: 'nextGenBoard',
    ROADMAP: 'roadmap',
    TIMELINE: 'timeline',
    LIST: 'list',
    CALENDAR: 'calendar',
    BOARD: 'board',
    FORM: 'form',
    SUMMARY: 'summary',
    ATTACHMENTS: 'attachments',
    DEPENDENCIES: 'dependencies',
    INCREMENT: 'increment',
    QUEUE: 'queue'
};

});

parcelRegister("iL8EU", function(module, exports) {

$parcel$export(module.exports, "ShareLoadingPlaceholder", () => $4e5335f44d688bbf$export$5619d05bf511476b);
$parcel$export(module.exports, "ShareButtonAnalyticsWrapperWithGating", () => $4e5335f44d688bbf$export$593c5080db936480);
$parcel$export(module.exports, "ShareButton", () => $4e5335f44d688bbf$export$e980dfbc2840e8bc);
$parcel$export(module.exports, "ShareButtonAsync", () => $4e5335f44d688bbf$export$3585ee2128ae4c25);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $fVnbM = parcelRequire("fVnbM");

var $kOEld = parcelRequire("kOEld");

var $42CjB = parcelRequire("42CjB");

var $1PVpv = parcelRequire("1PVpv");

var $empdx = parcelRequire("empdx");

var $b71gk = parcelRequire("b71gk");

var $koVbs = parcelRequire("koVbs");

var $cfDZ3 = parcelRequire("cfDZ3");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

var $itmJb = parcelRequire("itmJb");

var $4R6GH = parcelRequire("4R6GH");

var $dAfqg = parcelRequire("dAfqg");

var $7XYc4 = parcelRequire("7XYc4");

var $67hPg = parcelRequire("67hPg");
var $kNJSJ = parcelRequire("kNJSJ");

var $7CMCs = parcelRequire("7CMCs");

var $iXVV6 = parcelRequire("iXVV6");

var $2vSU6 = parcelRequire("2vSU6");

var $Kpokz = parcelRequire("Kpokz");

var $8BVfN = parcelRequire("8BVfN");
const $4e5335f44d688bbf$export$5619d05bf511476b = ({ triggerButtonStyle: triggerButtonStyle = 'icon-only' })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "subtle",
        iconBefore: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($kOEld))), {
            LEGACY_size: "medium",
            spacing: "spacious",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            color: "var(--ds-icon, #44546F)"
        }),
        isDisabled: true
    }, triggerButtonStyle === 'icon-with-text' ? formatMessage((0, $Kpokz.messages).shareTriggerButtonText) : null));
};

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4e5335f44d688bbf$var$ShareButtonBase = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("654QT")), {
    ssr: false,
    moduleId: "./src/packages/growth/share-button/src/ui/index.tsx"
});
const $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper = ({ children: children })=>{
    const { data: data } = (0, $dAfqg.useProjectContext)();
    const projectKey = data?.projectKey || '';
    const projectType = data?.projectType;
    const projectStyle = data?.simplified ? (0, $2vSU6.TEAM_MANAGED_PROJECT) : (0, $2vSU6.COMPANY_MANAGED_PROJECT);
    const userLocation = (0, $cfDZ3.getUserLocation)();
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const isProjectAdmin = data?.isProjectAdmin || false;
    const analyticsData = (0, $5uXOq.useMemo)(()=>{
        const projectContextData = projectKey ? {
            projectType: projectType,
            projectStyle: projectStyle,
            isProjectAdmin: isProjectAdmin
        } : undefined;
        return {
            isAdmin: isAdmin,
            userLocation: userLocation,
            ...projectContextData
        };
    }, [
        projectKey,
        projectType,
        projectStyle,
        isProjectAdmin,
        userLocation,
        isAdmin
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        attributes: analyticsData
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1PVpv.FabricElementsAnalyticsContext), {
        data: analyticsData
    }, children));
};
const $4e5335f44d688bbf$export$593c5080db936480 = (0, $7XYc4.componentWithCondition)(()=>(0, $4R6GH.fg)('jsw-smart-access-extended-analytics-enabled'), $4e5335f44d688bbf$var$ShareButtonAnalyticsWrapper, (0, $5uXOq.Fragment));
const $4e5335f44d688bbf$export$e980dfbc2840e8bc = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.share.button",
        packageName: "share-button"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-button",
        fallback: props.renderCustomTriggerButton === undefined ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$5619d05bf511476b, {
            triggerButtonStyle: props.triggerButtonStyle
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(props.renderCustomTriggerButton, {
            isDisabled: true,
            onClick: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        })
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$export$593c5080db936480, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4e5335f44d688bbf$var$ShareButtonBase, props))));
const $4e5335f44d688bbf$export$3585ee2128ae4c25 = (props)=>{
    const { Panel: Panel, trigger: trigger } = (0, $kNJSJ.usePanel)();
    const entryPointParams = (0, $5uXOq.useMemo)(()=>({}), []);
    const entryPointProps = (0, $5uXOq.useMemo)(()=>({
            ...props
        }), [
        props
    ]);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: props.errorBoundaryId,
        packageName: "jiraShareButton",
        teamName: props.teamName,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $67hPg.Trigger), {
        trigger: trigger,
        entryPoint: (0, $8BVfN.shareButtonEntryPoint),
        entryPointParams: entryPointParams,
        entryPointProps: entryPointProps
    }, ({ ref: ref })=>!isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $42CjB.default), {
            // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
            ref: ref,
            testId: "share-button.button",
            label: formatMessage((0, $Kpokz.messages).shareTriggerButtonText),
            appearance: "default",
            icon: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($empdx))), {
                    spacing: "spacious",
                    label: "",
                    color: "var(--ds-icon, #44546F)"
                }),
            onClick: ()=>setIsOpen(true)
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Panel, null));
};

});
parcelRegister("kOEld", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eddb3c8fd23121248d7a9663e3c0819a>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f277c50ed79b6741$var$_react = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $f277c50ed79b6741$var$_share = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("empdx")));

var $f277c50ed79b6741$var$_share2 = $f277c50ed79b6741$var$_interopRequireDefault((parcelRequire("jZX0t")));
function $f277c50ed79b6741$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Migration Icon component for ShareIcon.
 * This component is ShareIcon, with `UNSAFE_fallbackIcon` set to "ShareIcon".
 *
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $f277c50ed79b6741$var$ShareIcon = (props)=>/*#__PURE__*/ $f277c50ed79b6741$var$_react.default.createElement($f277c50ed79b6741$var$_share.default, Object.assign({
        LEGACY_fallbackIcon: $f277c50ed79b6741$var$_share2.default
    }, props));
$f277c50ed79b6741$var$ShareIcon.Name = 'ShareIconMigration';
var $f277c50ed79b6741$var$_default = module.exports.default = $f277c50ed79b6741$var$ShareIcon;

});
parcelRegister("empdx", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::ccb1509d7e2270e6a953aebace8cfd49>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $a746ae65a0e1944c$var$_react = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $a746ae65a0e1944c$var$_baseNew = $a746ae65a0e1944c$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $a746ae65a0e1944c$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "Share".
 * Category: single-purpose
 * Location: @atlaskit/icon
 * Usage guidance: Single purpose - Reserved for sharing an object.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $a746ae65a0e1944c$var$ShareIcon = (props)=>/*#__PURE__*/ $a746ae65a0e1944c$var$_react.default.createElement($a746ae65a0e1944c$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M12 2.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2m-2.5 1a2.5 2.5 0 1 1 .73 1.765L6.212 7.567a2.5 2.5 0 0 1 0 .866l4.016 2.302a2.5 2.5 0 1 1-.692 1.332L5.521 9.766a2.5 2.5 0 1 1 0-3.53l4.016-2.302A2.5 2.5 0 0 1 9.5 3.5M3.75 7a1 1 0 1 0 0 2 1 1 0 0 0 0-2M12 11.5a1 1 0 1 0 0 2 1 1 0 0 0 0-2" clip-rule="evenodd"/>`
    }, props));
$a746ae65a0e1944c$var$ShareIcon.displayName = 'ShareIcon';
var $a746ae65a0e1944c$var$_default = module.exports.default = $a746ae65a0e1944c$var$ShareIcon;

});

parcelRegister("jZX0t", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e8f17c524b03e26b$var$_react = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $c7fbr = parcelRequire("c7fbr");

var $e8f17c524b03e26b$var$_share = $e8f17c524b03e26b$var$_interopRequireDefault((parcelRequire("empdx")));
function $e8f17c524b03e26b$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
const $e8f17c524b03e26b$var$ShareIcon = (props)=>/*#__PURE__*/ $e8f17c524b03e26b$var$_react.default.createElement($c7fbr.IconFacade, Object.assign({
        dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill="currentcolor" fill-rule="evenodd"><path fill-rule="nonzero" d="M6 15a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m12-4a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2m0 14a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-2a1 1 0 1 1 0-2 1 1 0 0 1 0 2"/><path d="m7 13.562 8.66 5 1-1.732-8.66-5z"/><path d="m7 10.83 1 1.732 8.66-5-1-1.732z"/></g></svg>`
    }, props, {
        newIcon: $e8f17c524b03e26b$var$_share.default
    }));
$e8f17c524b03e26b$var$ShareIcon.displayName = 'ShareIcon';
var $e8f17c524b03e26b$var$_default = module.exports.default = $e8f17c524b03e26b$var$ShareIcon;

});


parcelRegister("kNJSJ", function(module, exports) {

$parcel$export(module.exports, "usePanel", () => $0ef0a2f3e739e762$export$9168a42f32e3d071);

var $5uXOq = parcelRequire("5uXOq");
function $0ef0a2f3e739e762$export$9168a42f32e3d071(preloadedPanel) {
    const [panel, setPanel] = (0, $5uXOq.useState)(preloadedPanel);
    const Panel = (0, $5uXOq.useMemo)(()=>{
        const PanelComponent = ()=>panel ?? null;
        return PanelComponent;
    }, [
        panel
    ]);
    const trigger = (0, $5uXOq.useMemo)(()=>({
            setPanel: (panel)=>setPanel(panel)
        }), [
        setPanel
    ]);
    return (0, $5uXOq.useMemo)(()=>({
            Panel: Panel,
            trigger: trigger
        }), [
        Panel,
        trigger
    ]);
}

});

parcelRegister("Kpokz", function(module, exports) {

$parcel$export(module.exports, "messages", () => $026d1258a1c95d57$export$defe85febe8b728c);

var $7VHMR = parcelRequire("7VHMR");
const $026d1258a1c95d57$export$defe85febe8b728c = (0, $7VHMR.defineMessages)({
    shareTriggerButtonText: {
        "id": "share-button.share-trigger-button-text",
        "defaultMessage": "Share"
    }
});

});

parcelRegister("8BVfN", function(module, exports) {

$parcel$export(module.exports, "shareButtonEntryPoint", () => $735d063ad5974451$export$ad8b1559c594245d);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $735d063ad5974451$export$ad8b1559c594245d = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>{
        if (!false) return (parcelRequire("hOSYl"));
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        return Promise.resolve({
            default: ()=>null
        });
    }, {
        moduleId: "50ae946e"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("hOSYl", function(module, exports) {

let $cf91bf8abe9208e0$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $cf91bf8abe9208e0$var$load("76n7a"),
    $cf91bf8abe9208e0$var$load("l253H"),
    $cf91bf8abe9208e0$var$load("kNFvF"),
    $cf91bf8abe9208e0$var$load("ffQaD"),
    $cf91bf8abe9208e0$var$load("kvRbA"),
    $cf91bf8abe9208e0$var$load("lMH7t")
]).then(()=>parcelRequire('8kufr'));

});


parcelRegister("654QT", function(module, exports) {

let $46d6f9397665366f$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $46d6f9397665366f$var$load("76n7a"),
    $46d6f9397665366f$var$load("l253H"),
    $46d6f9397665366f$var$load("kNFvF"),
    $46d6f9397665366f$var$load("ffQaD"),
    $46d6f9397665366f$var$load("kvRbA"),
    $46d6f9397665366f$var$load("61BKk")
]).then(()=>parcelRequire('7aU9g'));

});


parcelRegister("9j8is", function(module, exports) {

$parcel$export(module.exports, "useShareIntegrations", () => $d021f3111fd4c646$export$58a9f7a7ab3466f4);

var $5uXOq = parcelRequire("5uXOq");

var $aIZdc = parcelRequire("aIZdc");

var $bCdIp = parcelRequire("bCdIp");

var $pa9q9 = parcelRequire("pa9q9");

var $koeKL = parcelRequire("koeKL");

var $2UEtd = parcelRequire("2UEtd");

var $aMZmw = parcelRequire("aMZmw");
const $d021f3111fd4c646$export$58a9f7a7ab3466f4 = (shareContentType)=>{
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const cloudId = (0, $koeKL.useCloudId)();
    const ineligibilityReasons = (0, $5uXOq.useMemo)(()=>{
        const reasons = [];
        if ((0, $bCdIp.default)()) reasons.push('notDesktop');
        // All Share to Slack must be disabled in FedRAMP environment as
        // Slack Jira Integration app is not available in FedRAMP
        if ((0, $aIZdc.isFedRamp)()) reasons.push('isFedRAMP');
        return reasons;
    }, []);
    const shareIntegrations = (0, $5uXOq.useMemo)(()=>ineligibilityReasons.length === 0 ? [
            {
                type: 'Slack',
                Icon: (0, $aMZmw.default),
                Content: ({ onClose: onClose, changeTab: changeTab })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2UEtd.ShareToSlack), {
                        showFlag: showFlag,
                        product: "jira",
                        channel: "productAnalytics",
                        onClose: onClose,
                        cloudId: cloudId,
                        changeTab: changeTab,
                        shareContentType: shareContentType
                    })
            }
        ] : [], [
        ineligibilityReasons.length,
        showFlag,
        cloudId,
        shareContentType
    ]);
    return {
        shareIntegrations: shareIntegrations
    };
};

});
parcelRegister("2UEtd", function(module, exports) {

$parcel$export(module.exports, "ShareToSlack", () => $168b88234834bfea$export$2cc56764fd9edb21);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eZJjh = parcelRequire("eZJjh");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $3xc3R = parcelRequire("3xc3R");

const $168b88234834bfea$export$2cc56764fd9edb21 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async-share-to-slack",
        packageName: "integrations"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "share-to-slack",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlackLoader, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($168b88234834bfea$var$StyledShareToSlack, props)));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled
const $168b88234834bfea$var$StyledShareToSlackLoader = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $eZJjh.default), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf _2hwx1wug _otyridpf _18u01wug _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $168b88234834bfea$var$StyledShareToSlack = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = (0, $3xc3R.LazyShareToSlack), style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkmgjw _2hwx10v4 _otyrmgjw _18u010v4",
            __cmplp.className
        ])
    });
});

});
parcelRegister("3xc3R", function(module, exports) {

$parcel$export(module.exports, "LazyShareToSlack", () => $0733f18014b5074d$export$24281652e6b89b3b);

var $kxZPA = parcelRequire("kxZPA");

const $0733f18014b5074d$export$24281652e6b89b3b = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("lkjYU")), {
    ssr: false,
    moduleId: "../platform/packages/growth/integrations/src/share-to-slack/ui/index.tsx"
});

});
parcelRegister("lkjYU", function(module, exports) {

let $f86af723f983b7c6$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f86af723f983b7c6$var$load("kNFvF"),
    $f86af723f983b7c6$var$load("ff9v5")
]).then(()=>parcelRequire('2B8HF'));

});



parcelRegister("aMZmw", function(module, exports) {

$parcel$export(module.exports, "default", () => $a1ef732ae0096135$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$a1ef732ae0096135$export$2e2bcd8739ae039 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("svg", {
        width: "16",
        height: "16",
        viewBox: "4 4 16 16",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M7.50403 13.8563C7.50403 14.727 6.79278 15.4382 5.92212 15.4382C5.05146 15.4382 4.34021 14.727 4.34021 13.8563C4.34021 12.9857 5.05146 12.2744 5.92212 12.2744H7.50403V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M8.30115 13.8563C8.30115 12.9857 9.0124 12.2744 9.88307 12.2744C10.7537 12.2744 11.465 12.9857 11.465 13.8563V17.8172C11.465 18.6879 10.7537 19.3991 9.88307 19.3991C9.0124 19.3991 8.30115 18.6879 8.30115 17.8172V13.8563Z",
        fill: "#E01E5A"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.88307 7.50415C9.0124 7.50415 8.30115 6.79291 8.30115 5.92224C8.30115 5.05158 9.0124 4.34033 9.88307 4.34033C10.7537 4.34033 11.465 5.05158 11.465 5.92224V7.50415H9.88307Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M9.88304 8.30127C10.7537 8.30127 11.465 9.01251 11.465 9.88317C11.465 10.7538 10.7537 11.4651 9.88304 11.4651H5.92212C5.05146 11.4651 4.34021 10.7538 4.34021 9.88317C4.34021 9.01251 5.05146 8.30127 5.92212 8.30127H9.88304Z",
        fill: "#36C5F0"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M16.2354 9.88317C16.2354 9.01251 16.9466 8.30127 17.8172 8.30127C18.6879 8.30127 19.3991 9.01251 19.3991 9.88317C19.3991 10.7538 18.6879 11.4651 17.8172 11.4651H16.2354V9.88317Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M15.4381 9.88316C15.4381 10.7538 14.7269 11.4651 13.8562 11.4651C12.9855 11.4651 12.2743 10.7538 12.2743 9.88316V5.92225C12.2743 5.05158 12.9855 4.34033 13.8562 4.34033C14.7269 4.34033 15.4381 5.05158 15.4381 5.92225V9.88316Z",
        fill: "#2EB67D"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13.8562 16.2354C14.7269 16.2354 15.4381 16.9466 15.4381 17.8172C15.4381 18.6879 14.7269 19.3991 13.8562 19.3991C12.9855 19.3991 12.2743 18.6879 12.2743 17.8172V16.2354H13.8562Z",
        fill: "#ECB22E"
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("path", {
        d: "M13.8562 15.4382C12.9855 15.4382 12.2743 14.727 12.2743 13.8563C12.2743 12.9857 12.9855 12.2744 13.8562 12.2744H17.8171C18.6878 12.2744 19.399 12.9857 19.399 13.8563C19.399 14.727 18.6878 15.4382 17.8171 15.4382H13.8562Z",
        fill: "#ECB22E"
    }));

});


parcelRegister("bdr6Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $35ed0bdfd14f71ae$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $35ed0bdfd14f71ae$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    shareTitle: {
        "id": "software.main.header.share-button.share-title",
        "defaultMessage": "Board"
    },
    shareFormTitle: {
        "id": "software.main.header.share-button.share-form-title",
        "defaultMessage": "Share"
    },
    shareTooltipText: {
        "id": "software.main.header.share-button.share-tooltip-text",
        "defaultMessage": "Embed this link in other Atlassian products such as Confluence"
    },
    shareHelperMessage: {
        "id": "software.main.header.share-button.share-helper-message",
        "defaultMessage": "This view, along with any applied groups and filters are shared"
    }
});

});


parcelRegister("7Zg4V", function(module, exports) {

$parcel$export(module.exports, "SprintDetailsButton", () => $3b80e396624f0689$export$b264f9dec3a284a5);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $ebHh7 = parcelRequire("ebHh7");

var $kQIxA = parcelRequire("kQIxA");
const $3b80e396624f0689$export$b264f9dec3a284a5 = ()=>{
    const selectedSprints = (0, $67sX6.useBoardSelector)((0, $ebHh7.getSelectedOrAllSprintsSelector));
    const activeSprints = (0, $67sX6.useBoardSelector)((0, $ebHh7.activeSprintsSelector));
    // IN THEORY the selector can return an empty array as well as null (accordign to typedef).
    // HOWEVER, in practice this selector is a bit "complicated"
    // so the "empty array" situation should never happen.
    // Anyway, let's be defensive and handle both null and empty.
    if (!activeSprints?.length) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kQIxA.default), {
        activeSprints: activeSprints,
        selectedSprints: selectedSprints
    });
};

});
parcelRegister("kQIxA", function(module, exports) {

$parcel$export(module.exports, "default", () => $5be944c29dbca8a4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1I7E8 = parcelRequire("1I7E8");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");

var $8L2oS = parcelRequire("8L2oS");

var $4R6GH = parcelRequire("4R6GH");

var $bW6nO = parcelRequire("bW6nO");

var $lbeD3 = parcelRequire("lbeD3");

var $bAl3b = parcelRequire("bAl3b");
function $5be944c29dbca8a4$var$SprintDetails(props) {
    const { activeSprints: activeSprints, selectedSprints: selectedSprints } = props;
    const [isOpen, togglePopup, closePopup] = (0, $8L2oS.usePopupController)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderPopupTrigger = (0, $5uXOq.useCallback)((triggerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5be944c29dbca8a4$var$ConfiguredPopupTrigger, {
            isOpen: isOpen,
            togglePopup: togglePopup,
            selectedSprintsCount: selectedSprints.length,
            activeSprintsCount: activeSprints.length,
            ...triggerProps
        }), [
        isOpen,
        togglePopup,
        selectedSprints,
        activeSprints
    ]);
    const renderPopupContent = (0, $5uXOq.useCallback)(()=>{
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lbeD3.default), {
            selectedSprints: selectedSprints,
            activeSprintCount: activeSprints.length
        });
    }, [
        selectedSprints,
        activeSprints
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1I7E8.default), {
        isOpen: isOpen,
        onClose: closePopup,
        placement: "bottom-end",
        content: renderPopupContent,
        trigger: renderPopupTrigger,
        role: "dialog",
        label: formatMessage((0, $bW6nO.default).ariaLabel),
        ...(0, $4R6GH.fg)('tanuki_a11y_q4') ? {
            shouldRenderToParent: true
        } : {}
    });
}
const $5be944c29dbca8a4$var$ConfiguredPopupTrigger = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const { isOpen: isOpen, togglePopup: togglePopup, selectedSprintsCount: selectedSprintsCount, activeSprintsCount: activeSprintsCount, ...triggerProps } = props;
    const onClick = (_, analyticsEvent)=>{
        togglePopup();
        (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'sprintDetailsButton');
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bAl3b.default), {
        ref: ref,
        ...triggerProps,
        isSelected: isOpen,
        // by the spec, the "sprint details" control
        // only appear when there are active sprints
        // this "isDisabled" check is just a safety / defensive programming
        isDisabled: Math.max(selectedSprintsCount, activeSprintsCount) === 0,
        // the `onClick` function is coming from useCallback() so it's not less stable than the caller
        onClick: onClick,
        analyticsContext: {
            attributes: {
                intent: isOpen ? 'close' : 'open',
                activeSprintsCount: activeSprintsCount,
                selectedSprintsCount: selectedSprintsCount
            }
        }
    });
});
var $5be944c29dbca8a4$export$2e2bcd8739ae039 = $5be944c29dbca8a4$var$SprintDetails;

});
parcelRegister("8L2oS", function(module, exports) {

$parcel$export(module.exports, "usePopupController", () => $2f9ec79b1227b61c$export$55fb67b4e2c495d8);

var $5uXOq = parcelRequire("5uXOq");
const $2f9ec79b1227b61c$export$55fb67b4e2c495d8 = (defaultState = false)=>{
    // TODO one day useBoolean https://hello.atlassian.net/wiki/spaces/JFP/blog/2024/09/01/4131392637/PSA+Write+less+code+-+useBoolean+hook
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultState);
    const togglePopup = (0, $5uXOq.useCallback)(()=>{
        setIsOpen((pendingIsOpen)=>!pendingIsOpen);
    }, [
        setIsOpen
    ]);
    const closePopup = (0, $5uXOq.useCallback)(()=>{
        setIsOpen(false);
    }, [
        setIsOpen
    ]);
    return [
        isOpen,
        togglePopup,
        closePopup
    ];
};

});

parcelRegister("bW6nO", function(module, exports) {

$parcel$export(module.exports, "default", () => $b4dcc1a29e78f595$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $b4dcc1a29e78f595$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    ariaLabel: {
        "id": "software.main.header.sprint-controls.sprint-details.ariaLabel",
        "defaultMessage": "Popup with details about the current active sprints"
    }
});

});

parcelRegister("lbeD3", function(module, exports) {

$parcel$export(module.exports, "default", () => $5f8b7922ef61dda0$export$2e2bcd8739ae039);
/** Popup with active sprint details
 * spec: https://www.figma.com/design/YnMz1EvyBCySecvWX4FvHC/%F0%9F%A7%AD-%5BSpork%5D-Jira-navigation-refresh---Components-%26-patterns?node-id=11291-21447&node-type=FRAME&t=76M0RECVACsXpZVQ-0
 */ 
var $5uXOq = parcelRequire("5uXOq");

var $jovBr = parcelRequire("jovBr");

var $7jns1 = parcelRequire("7jns1");

var $3joPi = parcelRequire("3joPi");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $3bDjY = parcelRequire("3bDjY");

var $7CMCs = parcelRequire("7CMCs");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $1p96B = parcelRequire("1p96B");

var $leRCk = parcelRequire("leRCk");


var $j7XWQ = parcelRequire("j7XWQ");
const $5f8b7922ef61dda0$var$MS_IN_HOURS = 3600000;
/* NOTE: this popup is a good candidate for lazy-loading
 * However this is not implemented yet because:
 * - the popup content is small, vanilla and doesn't do any fetch
 * - the new (FY25Q2) guidance is to use Relay EntryPoint for lazy-loading
 *   which has less benefits in this Redux board (but still doable apparently)
 * - discussion https://atlassian.slack.com/archives/C074SJM8K7H/p1730676225049169
 * Next dev adding features, feel free to revisit and implement lazy-loading!
 */ const $5f8b7922ef61dda0$var$PopupContent = (props)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { selectedSprints: selectedSprints, activeSprintCount: activeSprintCount = selectedSprints.length } = props;
    if (!activeSprintCount) // by the spec, this should never happen
    // because the "sprint details" control only appear
    // when there are active sprints
    return null;
    const stackElements = [];
    if (activeSprintCount > 1) stackElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        key: "selectionIndicator",
        size: "small",
        weight: "bold",
        color: "color.text.subtlest"
    }, formatMessage((0, $j7XWQ.default).sprintSelection, {
        selectedCount: selectedSprints.length,
        totalCount: activeSprintCount
    })));
    if (selectedSprints.length === 1) stackElements.push(/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$2019f0e05924df02, {
        key: "singleSprint",
        sprint: selectedSprints[0]
    }));
    else stackElements.push(...selectedSprints.map((sprint)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$95842b7ac79e8187, {
            key: sprint.id,
            sprint: sprint
        })));
    // Rationale for error boundary:
    // - this component does complex date manipulation: we don't want to blow up the full page in case of an issue
    // - errors could be hard to track without it since it's a popup = React portal outside the board tree
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "jira-software-board-header-sprint-details-popup-content",
        teamName: "Jira Cosmos",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        padding: "space.200",
        xcss: $5f8b7922ef61dda0$var$containerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.200"
    }, stackElements)));
};
var $5f8b7922ef61dda0$export$2e2bcd8739ae039 = $5f8b7922ef61dda0$var$PopupContent;
function $5f8b7922ef61dda0$export$2019f0e05924df02({ sprint: sprint }) {
    const sprintGoalRef = (0, $5uXOq.useRef)(null);
    const canToolTipAppear = ()=>{
        const element = sprintGoalRef.current;
        (0, $3joPi.default)(element);
        // Only showing the tooltip for this item when
        // the element has been clamped.
        return element.scrollHeight > element.clientHeight;
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "article"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$var$TitleDetailsStack, null, (0, $4R6GH.fg)('jfp-a11y-team_autodev_header_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong",
        maxLines: 1
    }, sprint.name)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong",
        maxLines: 1
    }, sprint.name), sprint.goal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: sprint.goal,
        // don't need a screen reader announcement as the
        // tooltip content is the same as the items content
        isScreenReaderAnnouncementDisabled: true,
        canAppear: canToolTipAppear
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        ref: sprintGoalRef,
        maxLines: 2
    }, sprint.goal))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$76ca2692cceeb7eb, {
        sprint: sprint
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$ac179a0be748f2bb, {
        sprint: sprint
    })));
}
function $5f8b7922ef61dda0$export$95842b7ac79e8187({ sprint: sprint }) {
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "article"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        space: "space.100"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$var$TitleDetailsStack, null, (0, $4R6GH.fg)('jfp-a11y-team_autodev_header_fixes') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        as: "h2"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong",
        maxLines: 1
    }, sprint.name)) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong",
        maxLines: 1
    }, sprint.name), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$export$76ca2692cceeb7eb, {
        sprint: sprint,
        color: "color.text.subtlest"
    }))));
}
function $5f8b7922ef61dda0$export$76ca2692cceeb7eb({ sprint: sprint, color: color = 'color.text' }) {
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        color: color
    }, formatMessage((0, $j7XWQ.default).remainingDays, {
        remainingDays: sprint.daysRemaining
    })));
}
function $5f8b7922ef61dda0$export$ac179a0be748f2bb({ sprint: sprint }) {
    const { formatMessage: formatMessage, locale: locale } = (0, $koVbs.default)();
    const [{ data: loggedInUser }] = (0, $leRCk.useUserSubscriber)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        space: "space.300"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$var$TitleDetailsStack, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtlest"
    }, formatMessage((0, $j7XWQ.default).startDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, $5f8b7922ef61dda0$var$formatSprintDate({
        sprintDate: sprint.startDate,
        currentTimezone: loggedInUser?.timeZone,
        locale: locale,
        formatMessage: formatMessage
    }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($5f8b7922ef61dda0$var$TitleDetailsStack, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        size: "small",
        weight: "bold",
        color: "color.text.subtlest"
    }, formatMessage((0, $j7XWQ.default).endDate)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), null, $5f8b7922ef61dda0$var$formatSprintDate({
        sprintDate: sprint.endDate,
        currentTimezone: loggedInUser?.timeZone,
        locale: locale,
        formatMessage: formatMessage
    }))));
}
const $5f8b7922ef61dda0$var$TitleDetailsStack = ({ children: children })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, children);
};
function $5f8b7922ef61dda0$var$formatSprintDate({ sprintDate: sprintDate, currentTimezone: currentTimezone, locale: locale, formatMessage: formatMessage }) {
    if (!sprintDate) // should never happen since we're dealing with active sprints
    // which get dates auto-assigned on start.
    // this test is for appeasing Typescript
    return '';
    // we're doing fancy date manipulation above, not worth blowing up the whole screen, so let's be resilient
    try {
        const utcOffsetInHours = Math.floor((0, $7jns1.default)(currentTimezone || Intl.DateTimeFormat().resolvedOptions().timeZone || 'utc') / $5f8b7922ef61dda0$var$MS_IN_HOURS);
        const dateObject = (0, $1p96B.setNumberOffsetToISODate)(sprintDate, utcOffsetInHours);
        if (!(0, $jovBr.default)(dateObject)) {
            // should never happen, but some tests use invalid dates such as "yesterday"
            if (typeof sprintDate === 'string') return sprintDate; // better than nothing
            return formatMessage((0, $j7XWQ.default).invalidDate);
        }
        return (0, $1p96B.formatWithLocale)(dateObject, (0, $dcbb2bce513725b3$export$ad42fdc358b8c597), locale);
    } catch  {
        return formatMessage((0, $j7XWQ.default).invalidDate);
    }
}
const $5f8b7922ef61dda0$var$containerStyles = (0, $8CUq3.xcss)({
    width: '280px',
    maxBlockSize: '340px',
    // 5 sprints summary = no scroll, >5 = scroll
    overflowBlock: 'auto'
});

});
parcelRegister("j7XWQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $299b8da8af1dbb56$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $299b8da8af1dbb56$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    sprintSelection: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.sprint-selection",
        "defaultMessage": "{totalCount, plural, one {Sprints {selectedCount} of {totalCount}} other {Sprints {selectedCount} of {totalCount}}}"
    },
    remainingDays: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.remaining-days",
        "defaultMessage": "{remainingDays} {remainingDays, plural, one {day} other {days}} left"
    },
    startDate: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.start-date",
        "defaultMessage": "Start date"
    },
    endDate: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.end-date",
        "defaultMessage": "End date"
    },
    invalidDate: {
        "id": "software.main.header.sprint-controls.sprint-details.popup-content.invalid-date",
        "defaultMessage": "Invalid date"
    }
});

});


parcelRegister("bAl3b", function(module, exports) {

$parcel$export(module.exports, "default", () => $b563359b2bdc6c83$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8mG85 = parcelRequire("8mG85");

var $iyo13 = parcelRequire("iyo13");

var $hCCtP = parcelRequire("hCCtP");

var $koVbs = parcelRequire("koVbs");

var $4R6GH = parcelRequire("4R6GH");

var $eisBO = parcelRequire("eisBO");
const $b563359b2bdc6c83$var$TOOLTIP_OPTIONS = {
    hideTooltipOnClick: true
};
const $b563359b2bdc6c83$var$SprintDetailsTriggerButton = /*#__PURE__*/ (0, $5uXOq.forwardRef)((extraProps, ref)=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const renderIcon = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8mG85))), {
            LEGACY_fallbackIcon: (0, (/*@__PURE__*/$parcel$interopDefault($iyo13))),
            LEGACY_size: "small",
            label: (0, $4R6GH.fg)('tanuki_a11y_q4') ? '' : formatMessage((0, $eisBO.default).tooltip)
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCCtP.ThemedIconButton), {
        ref: ref,
        icon: renderIcon,
        label: formatMessage((0, $eisBO.default).tooltip),
        isTooltipDisabled: false,
        tooltip: $b563359b2bdc6c83$var$TOOLTIP_OPTIONS,
        testId: "software-board.header.sprint-controls.sprint-details.trigger-button.icon-button",
        ...extraProps
    });
});
var $b563359b2bdc6c83$export$2e2bcd8739ae039 = $b563359b2bdc6c83$var$SprintDetailsTriggerButton;

});
parcelRegister("eisBO", function(module, exports) {

$parcel$export(module.exports, "default", () => $f0ff7454a1278e17$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f0ff7454a1278e17$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    tooltip: {
        "id": "software.main.header.sprint-controls.sprint-details.trigger-button.tooltip",
        "defaultMessage": "Sprint details"
    }
});

});




parcelRegister("58Nil", function(module, exports) {

$parcel$export(module.exports, "SprintGoal", () => $188cf19b94d308c9$export$c6e24e98bd6ba09c);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $3bDjY = parcelRequire("3bDjY");

var $4R6GH = parcelRequire("4R6GH");
const $188cf19b94d308c9$export$c6e24e98bd6ba09c = ({ goal: goal })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: goal,
        position: "bottom-end"
    }, (tooltipProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($188cf19b94d308c9$var$SprintGoalContent, {
            tabIndex: 0,
            "aria-label": goal,
            ...tooltipProps,
            ...(0, $4R6GH.fg)('tmp_filter_refinement_sprint_goals') && {
                'data-testid': 'software-board.header.sprint-goal.sprint-goal-content'
            }
        }, goal));
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $188cf19b94d308c9$var$SprintGoalContent = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _11c8dcr7 _1bto1l2s _o5721q9c _syaz131l _19pkv77o _otyrv77o _1bsb1ns9 _p12f1osq",
            __cmplp.className
        ])
    });
});

});



parcelRegister("eqAt8", function(module, exports) {

$parcel$export(module.exports, "default", () => $42f28e1393d0787c$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $42f28e1393d0787c$var$AfterPaintPrefetchIssues = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("6kNPf")), {
    ssr: false,
    moduleId: "./src/packages/software/board/src/view/prefetch-issues/index.tsx"
});
const $42f28e1393d0787c$export$2552ea6166f76129 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "async.software-board.prfetch-issues",
        packageName: "jiraSoftwareBoardPrefetchIssues"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "prefetch-issues",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($42f28e1393d0787c$var$AfterPaintPrefetchIssues, null)));
var $42f28e1393d0787c$export$2e2bcd8739ae039 = $42f28e1393d0787c$export$2552ea6166f76129;

});
parcelRegister("6kNPf", function(module, exports) {

let $49cb42a9e8bece4c$var$load = (parcelRequire("28QjX"))(4);
module.exports = $49cb42a9e8bece4c$var$load("civw8").then(()=>parcelRequire('92Qej'));

});


parcelRegister("jFKZt", function(module, exports) {

$parcel$export(module.exports, "default", () => $981a733f2c308762$export$2e2bcd8739ae039);

var $8Rkzz = parcelRequire("8Rkzz");

var $8QpSo = parcelRequire("8QpSo");

var $bC2fB = parcelRequire("bC2fB");

var $dd8Xx = parcelRequire("dd8Xx");


var $5fK3R = parcelRequire("5fK3R");

var $d315K = parcelRequire("d315K");

var $8yiLS = parcelRequire("8yiLS");

var $irkFn = parcelRequire("irkFn");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");
const $981a733f2c308762$var$mapStateToProps = (state)=>({
        cloudId: (0, $67Z81.cloudIdSelector)(state),
        projectId: (0, $67Z81.projectIdSelector)(state),
        boardId: (0, $67Z81.rapidViewIdSelector)(state),
        channels: (0, $irkFn.realtimeChannelSelector)(state),
        currentUserId: (0, $67Z81.currentUserAccountIdSelector)(state),
        // If custom filters or JQL are active on this board, we actually need to listen to the granular
        // issue create and issue update events since BSI updated event does not give us enough context
        isCustomFiltersActive: (0, $8yiLS.isCustomFiltersActive)(state),
        isJqlFilterActive: (0, $5mTgl.isJqlFilterActive)(state),
        isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
    });
const $981a733f2c308762$var$mapDispatchToProps = {
    createRealtimeEventAction: (0, $d315K.dispatchRealtimeEvent)
};
const $981a733f2c308762$var$onReceiveFactory = (0, $8QpSo.default)((createRealtimeEventAction)=>(event)=>{
        if (event) createRealtimeEventAction(event);
    });
const $981a733f2c308762$export$9d1611c77c2fe928 = (stateProps, dispatchProps)=>{
    let events = (0, $5fK3R.REALTIME_EVENTS); // issue events
    // If the FF is enabled for listening to BSI updated, we also need to determine if we need to
    // still listen to some of the old events specifically for custom filters
    if (!stateProps.isCMPBoard) events = stateProps.isCustomFiltersActive || stateProps.isJqlFilterActive ? (0, $5fK3R.REALTIME_EVENTS_WITH_BSI // BSI + issue create + issue updated
    ) : (0, $5fK3R.BOARD_SCOPE_ISSUES_UPDATED_EVENT); // just BSI
    return {
        appId: (0, $dcbb2bce513725b3$export$d76071d5de2774fc),
        channels: stateProps.channels,
        events: // The board scope issues updated event is designed to replace all of the individual events and is produced by
        // barbel whenever it sees a SPRINT or issue specific change
        events,
        onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
        onReceive: $981a733f2c308762$var$onReceiveFactory(dispatchProps.createRealtimeEventAction),
        onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
    };
};
var $981a733f2c308762$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($981a733f2c308762$var$mapStateToProps, $981a733f2c308762$var$mapDispatchToProps, $981a733f2c308762$export$9d1611c77c2fe928)((0, $dd8Xx.default));

});
parcelRegister("dd8Xx", function(module, exports) {

$parcel$export(module.exports, "default", () => $9a980bab3107478f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $4R6GH = parcelRequire("4R6GH");

var $2YZCu = parcelRequire("2YZCu");

var $j5YhT = parcelRequire("j5YhT");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $cSD7y = parcelRequire("cSD7y");

var $90yGq = parcelRequire("90yGq");

var $b32lf = parcelRequire("b32lf");

var $jiRmc = parcelRequire("jiRmc");

var $jFysZ = parcelRequire("jFysZ");


var $43Yto = parcelRequire("43Yto");
const $9a980bab3107478f$var$LOG_LOCATION = 'jira-realtime';
// eslint-disable-next-line jira/react/no-class-components
class $9a980bab3107478f$var$RealtimeOld extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onReceive: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    render() {
        const { appId: appId, events: events, onJoin: onJoin, onLeave: onLeave, channels: channels, onReceive: onReceive } = this.props;
        if ((0, $4R6GH.fg)('jirt-log-unsupported-channels')) this.logUnsupportedChannels(channels, appId);
        if ((0, $4R6GH.fg)('jirt-use-graphql-subscriptions')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFysZ.RealtimeSubscriptions), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels,
            events: events,
            onReceive: onReceive
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiRmc.RealtimeProvider), {
            appId: appId,
            onJoin: onJoin,
            onLeave: onLeave,
            channels: channels
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b32lf.RealtimeClient), {
            appId: appId,
            events: events,
            onReceive: this.onEventReceive
        }));
    }
    constructor(...args){
        super(...args), this.onEventReceive = (eventType, payload)=>{
            const event = {
                type: eventType,
                payload: payload
            };
            this.props.onReceive(event);
        }, this.logUnsupportedChannels = (channels, appId)=>{
            const unsupportedChannels = channels.filter((channel)=>!(0, $j5YhT.JiraProjectAri).check(channel));
            if (unsupportedChannels.length > 0) (0, $2YZCu.default).safeWarnWithoutCustomerData($9a980bab3107478f$var$LOG_LOCATION, 'Unsupported channels', {
                source: (0, $4R6GH.fg)('jirt-use-graphql-subscriptions') ? (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df) : (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: appId,
                unsupportedChannels: unsupportedChannels?.join(', ')
            });
        };
    }
}
function $9a980bab3107478f$var$RealtimeNew({ appId: appId, channels: channels, events: events, onJoin: onJoin = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onReceive: onReceive = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onLeave: onLeave = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) }) {
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const logUnsupportedChannels = (0, $5uXOq.useCallback)(()=>{
        const unsupportedChannels = channels.filter((channel)=>!(0, $j5YhT.JiraProjectAri).check(channel));
        if (unsupportedChannels.length > 0) (0, $2YZCu.default).safeWarnWithoutCustomerData($9a980bab3107478f$var$LOG_LOCATION, 'Unsupported channels', {
            source: (0, $4R6GH.fg)('jirt-use-graphql-subscriptions') ? (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df) : (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
            appId: appId,
            unsupportedChannels: unsupportedChannels?.join(', ')
        });
    }, [
        appId,
        channels
    ]);
    const onEventReceive = (0, $5uXOq.useCallback)((eventType, payload, analyticsEvent)=>{
        const event = {
            type: eventType,
            payload: payload
        };
        (0, $8zOmE.fireOperationalAnalytics)(analyticsEvent, `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).EVENT_RECEIVED}`, {
            source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
            eventType: eventType,
            appId: appId,
            isTriggeredBySameUser: payload?.atlassianId === atlassianAccountId
        });
        onReceive(event);
    }, [
        appId,
        atlassianAccountId,
        onReceive
    ]);
    const onError = (0, $5uXOq.useCallback)((error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).FAILURE}`, {
            source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
            appId: appId,
            channels: channels,
            events: events,
            error: error.message
        });
    }, [
        appId,
        channels,
        createAnalyticsEvent,
        events
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, $4R6GH.fg)('jirt-log-unsupported-channels')) logUnsupportedChannels();
    }, [
        channels,
        appId,
        logUnsupportedChannels
    ]);
    if ((0, $4R6GH.fg)('jirt-use-graphql-subscriptions')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jFysZ.RealtimeSubscriptions), {
        appId: appId,
        onJoin: onJoin,
        onLeave: onLeave,
        channels: channels,
        events: events,
        onReceive: onReceive
    });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jiRmc.RealtimeProvider), {
        appId: appId,
        onJoin: onJoin,
        onLeave: onLeave,
        channels: channels,
        onError: onError
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b32lf.RealtimeClient), {
        appId: appId,
        events: events,
        onReceive: onEventReceive
    }));
}
const $9a980bab3107478f$var$Realtime = (0, $cSD7y.componentWithFG)('jirt-convert-class-to-functional-component', $9a980bab3107478f$var$RealtimeNew, $9a980bab3107478f$var$RealtimeOld);
var $9a980bab3107478f$export$2e2bcd8739ae039 = $9a980bab3107478f$var$Realtime;

});
parcelRegister("b32lf", function(module, exports) {

$parcel$export(module.exports, "RealtimeClient", () => $89de761bbc8dc49a$export$e680ceb7b9fcc184);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $2OMDV = parcelRequire("2OMDV");

var $2YZCu = parcelRequire("2YZCu");

var $4R6GH = parcelRequire("4R6GH");

var $43Yto = parcelRequire("43Yto");


var $50Ssb = parcelRequire("50Ssb");

var $iwG6l = parcelRequire("iwG6l");
const $89de761bbc8dc49a$var$LOG_LOCATION = 'jira-realtime-client-fps';
// eslint-disable-next-line jira/react/no-class-components
class $89de761bbc8dc49a$var$RealtimeClientView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            children: null
        };
    }
    componentDidMount() {
        this.subscribeToPropEvents();
    }
    componentDidUpdate(prevProps) {
        if (this.props.client !== prevProps.client || this.props.events !== prevProps.events) {
            const removedEvents = prevProps.events.filter((prevEvent)=>!this.props.events.includes(prevEvent));
            removedEvents.forEach(this.unSubscribeToEvent);
            this.subscribeToPropEvents();
        }
    }
    componentWillUnmount() {
        this.unsubscribeToPropEvents();
    }
    render() {
        return this.props.children;
    }
    constructor(...args){
        super(...args), this.onReceiveEvent = (event, payload)=>{
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) (0, $2YZCu.default).safeInfoWithoutCustomerData($89de761bbc8dc49a$var$LOG_LOCATION, 'Event received', {
                source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: this.props?.appId,
                eventType: String(event)
            });
            // @ts-expect-error - TS2554 - Expected 3 arguments, but got 2.
            this.props.onReceive(event, payload);
        }, this.subscribeToEvent = (eventName)=>{
            this.props.client?.on(eventName, this.onReceiveEvent);
        }, this.unSubscribeToEvent = (eventName)=>{
            this.props.client?.off(eventName, this.onReceiveEvent);
        }, this.subscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.subscribeToEvent);
        }, this.unsubscribeToPropEvents = ()=>{
            if (this.props.client) this.props.events.forEach(this.unSubscribeToEvent);
        };
    }
}
const $89de761bbc8dc49a$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)((0, $43Yto.analyticsComponent), {
    onReceive: (0, $43Yto.analyticEvents).EVENT_RECEIVED
});
const $89de761bbc8dc49a$export$e680ceb7b9fcc184 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($89de761bbc8dc49a$var$withAnalytics, (0, $iwG6l.withPubSubClient), (0, $50Ssb.asClientOnly))($89de761bbc8dc49a$var$RealtimeClientView);
var $89de761bbc8dc49a$export$2e2bcd8739ae039 = $89de761bbc8dc49a$export$e680ceb7b9fcc184;

});
parcelRegister("43Yto", function(module, exports) {

$parcel$export(module.exports, "analyticsComponent", () => $e9d4cd49d7351075$export$b6860299007c6993);
$parcel$export(module.exports, "analyticEvents", () => $e9d4cd49d7351075$export$959fab53eba8917d);
const $e9d4cd49d7351075$export$b6860299007c6993 = 'jiraRealtime';
const $e9d4cd49d7351075$export$959fab53eba8917d = {
    EVENT_RECEIVED: 'eventReceived',
    FAILURE: 'errorReceived',
    JOINED_CHANNEL: 'joinedChannel',
    LEFT_CHANNEL: 'leftChannel'
};

});

const $cd8288ab589b4c19$export$4854d3ddf830ca94 = 'fps';
const $cd8288ab589b4c19$export$f7ec9b25c28de3df = 'subscriptions';

parcelRegister("50Ssb", function(module, exports) {

$parcel$export(module.exports, "asClientOnly", () => $ccf1df230f4f0e4b$export$95cd02374de3431);

var $5uXOq = parcelRequire("5uXOq");
function $ccf1df230f4f0e4b$export$95cd02374de3431(WrappedComponent) {
    return (props)=>{
        if (false) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $ccf1df230f4f0e4b$export$2e2bcd8739ae039 = $ccf1df230f4f0e4b$export$95cd02374de3431;

});

parcelRegister("iwG6l", function(module, exports) {

$parcel$export(module.exports, "withPubSubClient", () => $9fb4f4e8a5d3670b$export$32d968d4900ae3cd);

var $5uXOq = parcelRequire("5uXOq");

var $bYYrF = parcelRequire("bYYrF");
function $9fb4f4e8a5d3670b$export$32d968d4900ae3cd(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Consumer), null, ({ client: client })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
                ...props,
                client: client
            }));
}
var $9fb4f4e8a5d3670b$export$2e2bcd8739ae039 = $9fb4f4e8a5d3670b$export$32d968d4900ae3cd;

});
parcelRegister("bYYrF", function(module, exports) {

$parcel$export(module.exports, "Provider", () => $9398e66c20b16e31$export$2881499e37b75b9a);
$parcel$export(module.exports, "Consumer", () => $9398e66c20b16e31$export$b3bffd4bb7da6b8f);

var $5uXOq = parcelRequire("5uXOq");
const $9398e66c20b16e31$var$defaultContext = {
    client: null
};
const { Provider: $9398e66c20b16e31$export$2881499e37b75b9a, Consumer: $9398e66c20b16e31$export$b3bffd4bb7da6b8f } = /*#__PURE__*/ (0, $5uXOq.createContext)($9398e66c20b16e31$var$defaultContext);

});



parcelRegister("jiRmc", function(module, exports) {

$parcel$export(module.exports, "RealtimeProvider", () => $db014a952af56f77$export$64d242981d970821);

var $5uXOq = parcelRequire("5uXOq");

var $basmW = parcelRequire("basmW");

var $8Rkzz = parcelRequire("8Rkzz");

var $2YZCu = parcelRequire("2YZCu");

var $2OMDV = parcelRequire("2OMDV");

var $fjcgS = parcelRequire("fjcgS");

var $4R6GH = parcelRequire("4R6GH");


var $bYYrF = parcelRequire("bYYrF");

var $43Yto = parcelRequire("43Yto");


var $1eGpy = parcelRequire("1eGpy");

var $FPIEb = parcelRequire("FPIEb");
const $db014a952af56f77$var$LOG_LOCATION = 'jira-realtime-provider-fps';

const $db014a952af56f77$var$createPubSubClient = (host, analyticsClient)=>(parcelRequire("PCZCF")).then((module)=>{
        const Client = module.default;
        return new Client({
            product: (0, $dd367d66c147872b$export$13ac40d1a5475532),
            url: `${host}`,
            apsProtocol: {
                enabled: true
            },
            analyticsClient: analyticsClient
        });
    });
const $db014a952af56f77$export$c127c26e30518ed5 = (appId, client, channels, onHandler, onError)=>client.join(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, `[${appId}]: Failed to join channel`, error);
        if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) onError?.(error);
    });
const $db014a952af56f77$export$e6c41c8aa28ddeb9 = (appId, client, channels, onHandler, onError)=>client.leave(channels).then(onHandler) // eslint-disable-next-line @typescript-eslint/no-explicit-any
    .catch((error)=>{
        // Ideally anonymous users shouldn't get there.
        // Ignoring 401 status codes until it is fixed on the app level.
        if (error && error.code === 401) return;
        (0, $2YZCu.default).safeErrorWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, `[${appId}]: Failed to left channel`, error);
        if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) onError?.(error);
    });
// eslint-disable-next-line jira/react/no-class-components
class $db014a952af56f77$var$RealtimeProviderView extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = {
            host: (0, $dd367d66c147872b$export$92ffb25149c24a33),
            onJoin: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))),
            onLeave: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
        };
    }
    componentDidMount() {
        const { appId: appId, host: host, channels: channels, onError: onError } = this.props;
        this.isComponentMounted = true;
        (0, $fjcgS.getAnalyticsWebClientPromise)().then((analyticsClient)=>$db014a952af56f77$var$createPubSubClient(host, analyticsClient.getInstance())).then((pubSubClient)=>$db014a952af56f77$export$c127c26e30518ed5(appId, pubSubClient, channels, this.onJoinChannel, onError).then(()=>{
                if (this.isComponentMounted) this.setState({
                    client: pubSubClient
                });
            }));
    }
    componentDidUpdate({ channels: prevChannels }) {
        const { appId: appId, channels: newChannels, onError: onError } = this.props;
        const { client: client } = this.state;
        if (client && newChannels !== prevChannels) {
            const removedChannels = prevChannels.filter((channel)=>!newChannels.includes(channel));
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) {
                if (removedChannels.length > 0) {
                    $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel, onError);
                    $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel, onError);
                }
            } else {
                $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, removedChannels, this.onLeaveChannel, onError);
                $db014a952af56f77$export$c127c26e30518ed5(appId, client, newChannels, this.onJoinChannel, onError);
            }
        }
    }
    componentWillUnmount() {
        const { appId: appId, channels: channels, onError: onError } = this.props;
        const { client: client } = this.state;
        this.isComponentMounted = false;
        if (client) $db014a952af56f77$export$e6c41c8aa28ddeb9(appId, client, channels, this.onLeaveChannel, onError);
    }
    render() {
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bYYrF.Provider), {
            value: {
                client: this.state.client
            }
        }, this.props.children);
    }
    constructor(...args){
        super(...args), this.state = {
            client: null
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onJoinChannel = (result)=>{
            const { onJoin: onJoin } = this.props;
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) (0, $2YZCu.default).safeInfoWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, 'Joined channel', {
                source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: this.props?.appId,
                channels: result?.channels?.join(', ') ?? ''
            });
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onJoin(Array.from(result?.channels ?? []));
        }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.onLeaveChannel = (result)=>{
            const { onLeave: onLeave } = this.props;
            if ((0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) (0, $2YZCu.default).safeInfoWithoutCustomerData($db014a952af56f77$var$LOG_LOCATION, 'Left channel', {
                source: (0, $cd8288ab589b4c19$export$4854d3ddf830ca94),
                appId: this.props?.appId,
                channels: result?.channels?.join(', ') ?? ''
            });
            // @ts-expect-error - TS2554 - Expected 2 arguments, but got 1.
            onLeave(Array.from(result?.channels ?? []));
        }, this.isComponentMounted = false;
    }
}
const $db014a952af56f77$var$withAnalytics = (0, $2OMDV.AnalyticsEventToProps)((0, $43Yto.analyticsComponent), {
    onJoin: (0, $43Yto.analyticEvents).JOINED_CHANNEL,
    onLeave: (0, $43Yto.analyticEvents).LEFT_CHANNEL
});
const $db014a952af56f77$export$64d242981d970821 = (0, (/*@__PURE__*/$parcel$interopDefault($basmW)))($db014a952af56f77$var$withAnalytics, (0, $1eGpy.withHost), (0, $FPIEb.withRuntimeProvider))($db014a952af56f77$var$RealtimeProviderView);
var $db014a952af56f77$export$2e2bcd8739ae039 = $db014a952af56f77$export$64d242981d970821;

});
const $dd367d66c147872b$export$92ffb25149c24a33 = '/gateway/api/pubsub';
const $dd367d66c147872b$export$13ac40d1a5475532 = 'JIRA';

parcelRegister("1eGpy", function(module, exports) {

$parcel$export(module.exports, "withHost", () => $af5e53f160713d44$export$b2d89aaea1461cd9);

var $5uXOq = parcelRequire("5uXOq");

var $4h0Jz = parcelRequire("4h0Jz");
function $af5e53f160713d44$export$b2d89aaea1461cd9(WrappedComponent) {
    return (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, {
            ...props,
            host: (0, $4h0Jz.getDefaultPubSubHost)()
        });
}
var $af5e53f160713d44$export$2e2bcd8739ae039 = $af5e53f160713d44$export$b2d89aaea1461cd9;

});
parcelRegister("4h0Jz", function(module, exports) {

$parcel$export(module.exports, "getDefaultPubSubHost", () => $15272668181566a5$export$f795b2d9ba365882);
$parcel$export(module.exports, "buildChannelString", () => $15272668181566a5$export$354e43de513ff5);

var $j8DrX = parcelRequire("j8DrX");

const $15272668181566a5$export$f795b2d9ba365882 = ()=>(0, $j8DrX.default)('ajs-fabric-realtime-url') || (0, $dd367d66c147872b$export$92ffb25149c24a33);
const $15272668181566a5$export$354e43de513ff5 = (cloudId, projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`;

});


parcelRegister("FPIEb", function(module, exports) {

$parcel$export(module.exports, "withRuntimeProvider", () => $5962bf1fe62742cb$export$4b38d0b01368c3f4);

var $5uXOq = parcelRequire("5uXOq");
function $5962bf1fe62742cb$export$4b38d0b01368c3f4(WrappedComponent) {
    return (props)=>{
        if (false) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, props.children);
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(WrappedComponent, props);
    };
}
var $5962bf1fe62742cb$export$2e2bcd8739ae039 = $5962bf1fe62742cb$export$4b38d0b01368c3f4;

});

parcelRegister("PCZCF", function(module, exports) {

let $09b302b7286410da$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $09b302b7286410da$var$load("76n7a"),
    $09b302b7286410da$var$load("l253H"),
    $09b302b7286410da$var$load("kpnGY")
]).then(()=>parcelRequire('9uh43'));

});


parcelRegister("jFysZ", function(module, exports) {

$parcel$export(module.exports, "RealtimeSubscriptions", () => $03883409ac785040$export$ecba46e7f0609959);

var $5uXOq = parcelRequire("5uXOq");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $j5YhT = parcelRequire("j5YhT");

var $hMvRp = parcelRequire("hMvRp");

var $90yGq = parcelRequire("90yGq");

var $4R6GH = parcelRequire("4R6GH");


var $cnhn5 = parcelRequire("cnhn5");

var $43Yto = parcelRequire("43Yto");

var $4w2WY = parcelRequire("4w2WY");

var $1H73m = parcelRequire("1H73m");
const $03883409ac785040$var$getProjectIdsToSubscribe = (channels)=>channels?.filter((projectAri)=>(0, $j5YhT.JiraProjectAri).check(projectAri))?.map((projectAri)=>(0, $j5YhT.JiraProjectAri).parse(projectAri))?.map((data)=>data.projectId)?.filter(Boolean) ?? [];
const $03883409ac785040$var$getIssueEventToSubscribe = (events)=>events?.filter(Boolean)?.filter((event)=>(0, $cnhn5.SUBSCRIPTION_SUPPORTED_EVENTS).has(event)) ?? [];
const $03883409ac785040$var$getBoardEventToSubscribe = (events)=>events?.filter(Boolean)?.filter((event)=>(0, $cnhn5.BOARD_SUPPORTED_EVENTS).has(event)) ?? [];
const $03883409ac785040$export$ecba46e7f0609959 = /*#__PURE__*/ (0, $5uXOq.memo)((props)=>{
    const { appId: appId, channels: channels, events: events, onJoin: onJoin, onReceive: onReceive, onLeave: onLeave } = props;
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const isVisible = (0, $hMvRp.usePageVisibility)();
    const projectIds = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getProjectIdsToSubscribe(channels), [
        channels
    ]);
    const issueEvents = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getIssueEventToSubscribe(events), [
        events
    ]);
    const boardEvents = (0, $5uXOq.useMemo)(()=>$03883409ac785040$var$getBoardEventToSubscribe(events), [
        events
    ]);
    const handleOnJoin = (0, $5uXOq.useCallback)(()=>{
        onJoin(channels);
    }, [
        onJoin,
        channels
    ]);
    const handleOnReceive = (0, $5uXOq.useCallback)((event)=>{
        const { type: type, payload: { atlassianId: atlassianId } } = event;
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).EVENT_RECEIVED}`, {
            source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
            eventType: type,
            appId: appId,
            channels: channels,
            isTriggeredBySameUser: atlassianId === atlassianAccountId
        });
        onReceive(event);
    }, [
        appId,
        atlassianAccountId,
        channels,
        createAnalyticsEvent,
        onReceive
    ]);
    const handleOnLeave = (0, $5uXOq.useCallback)(()=>{
        onLeave(channels);
    }, [
        channels,
        onLeave
    ]);
    const handleOnError = (0, $5uXOq.useCallback)((error)=>{
        (0, $8zOmE.fireOperationalAnalytics)(createAnalyticsEvent({}), `${(0, $43Yto.analyticsComponent)} ${(0, $43Yto.analyticEvents).FAILURE}`, {
            source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
            appId: appId,
            channels: channels,
            events: issueEvents,
            error: error.message
        });
    }, [
        channels,
        appId,
        issueEvents,
        createAnalyticsEvent
    ]);
    const shouldRenderIssueSubscription = projectIds?.length > 0 && issueEvents?.length > 0;
    const shouldRenderBoardIssueSubscription = projectIds?.length > 0 && boardEvents?.length > 0;
    // Do not render the component on server-side
    // rendering to avoid hydration issues
    if (false && (0, $4R6GH.fg)('jirt-convert-class-to-functional-component')) return null;
    // Do not render the component when the page or tab is not visible
    // this will force the subscription components to unsubscribe
    // and avoid unnecessary data transfer when the user is not visualizing
    // the page. The subscription will be re-established when the page
    // or tab is visible again.
    if (!isVisible) return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldRenderIssueSubscription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4w2WY.IssueSubscription), {
        appId: appId,
        projectIds: projectIds,
        events: issueEvents,
        onJoin: handleOnJoin,
        onReceive: handleOnReceive,
        onLeave: handleOnLeave,
        onError: handleOnError
    }), shouldRenderBoardIssueSubscription && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1H73m.BoardIssueSubscription), {
        appId: appId,
        projectIds: projectIds,
        events: boardEvents,
        onJoin: handleOnJoin,
        onReceive: handleOnReceive,
        onLeave: handleOnLeave,
        onError: handleOnError
    }));
});

});
parcelRegister("4w2WY", function(module, exports) {

$parcel$export(module.exports, "IssueSubscription", () => $77e279b1082e054b$export$97b721965fbe4764);

var $hBgv0 = parcelRequire("hBgv0");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $8S2Xh = parcelRequire("8S2Xh");

var $2YZCu = parcelRequire("2YZCu");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $bkbBi = parcelRequire("bkbBi");

const $77e279b1082e054b$var$LOG_LOCATION = 'jira-realtime-issue-subscription';
const $77e279b1082e054b$export$97b721965fbe4764 = /*#__PURE__*/ (0, $5uXOq.memo)(({ appId: appId, projectIds: projectIds, events: events, onJoin: onJoin, onReceive: onReceive, onError: onError, onLeave: onLeave })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const defaultAttributes = {
        source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
        cloudId: cloudId,
        appId: appId,
        atlassianAccountId: atlassianAccountId
    };
    (0, $8Uumt.useSubscription)((0, $5uXOq.useMemo)(()=>({
            subscription: (0, $hBgv0.default),
            variables: {
                cloudId: cloudId,
                atlassianAccountId: String(atlassianAccountId),
                events: events,
                projectIds: projectIds
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onNext: (response)=>{
                const payload = response?.jira?.onJirtIssueSubscription;
                if (!payload) {
                    (0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Subscription started', defaultAttributes);
                    onJoin();
                    return;
                }
                if (!(0, $bkbBi.isSubscriptionEventType)(payload.type)) {
                    (0, $2YZCu.default).safeErrorWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Invalid event type', {
                        ...defaultAttributes,
                        eventType: payload.type
                    });
                    return;
                }
                const issueId = Number((0, $8S2Xh.JiraIssueAri).parse(payload.resource).issueId);
                const realtimeEvent = {
                    type: payload.type,
                    payload: {
                        atlassianId: String(payload.actionerAccountId),
                        projectId: payload.project?.id,
                        issueId: issueId
                    }
                };
                (0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Event received', {
                    ...defaultAttributes,
                    eventType: payload.type,
                    projectId: payload.project?.id,
                    issueId: issueId,
                    resource: payload.resource,
                    triggeredBy: String(payload.actionerAccountId),
                    receivedBy: atlassianAccountId,
                    isTriggeredBySameUser: String(payload.actionerAccountId) === atlassianAccountId
                });
                onReceive(realtimeEvent);
            },
            onCompleted: ()=>{
                (0, $2YZCu.default).safeInfoWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, 'Subscription completed', {
                    ...defaultAttributes,
                    receivedBy: atlassianAccountId
                });
                onLeave();
            },
            onError: (error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($77e279b1082e054b$var$LOG_LOCATION, `[${appId}] Subscription failure`, error);
                onError(error);
            }
        }), // Given React hooks require dependencies to be stable, but this cannot be guaranteed by consumers.
    // To ensure the subscription is created only once and not recreated on every re-render,
    // an empty dependency array is used intentionally. This approach ensures stability and avoids unnecessary resubscriptions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []));
    return null;
});

});
parcelRegister("hBgv0", function(module, exports) {

$parcel$export(module.exports, "default", () => $dd668aee84be2330$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<328c09410a7466f00f74849cd5dfcec8>>
 * @relayHash 92106690bb7e678270694af845fb5480
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID be83f504300a405b42e65dceb83cbdf64f2aa7ee3b9778d98ae12ae09488c068
const $dd668aee84be2330$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "events"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIds"
    }, v4 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "atlassianAccountId",
                            "variableName": "atlassianAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "events",
                            "variableName": "events"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraJirtEventPayload",
                    "kind": "LinkedField",
                    "name": "onJirtIssueSubscription",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "actionerAccountId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        },
                        {
                            "concreteType": "JiraIssueStreamHubEventPayloadProject",
                            "kind": "LinkedField",
                            "name": "project",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "id"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "IssueSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "IssueSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "be83f504300a405b42e65dceb83cbdf64f2aa7ee3b9778d98ae12ae09488c068",
            "metadata": {},
            "name": "IssueSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$dd668aee84be2330$var$node.hash = "1288b7ac81835d68c9265e8c3bdfa3d5";
var $dd668aee84be2330$export$2e2bcd8739ae039 = $dd668aee84be2330$var$node;

});

parcelRegister("bkbBi", function(module, exports) {

$parcel$export(module.exports, "isSubscriptionEventType", () => $461958717eae170a$export$cec76ac77e3d331);
$parcel$export(module.exports, "isBoardIssueEventType", () => $461958717eae170a$export$4bc59bf28171f69e);

var $cnhn5 = parcelRequire("cnhn5");
function $461958717eae170a$export$cec76ac77e3d331(type) {
    return typeof type === 'string' && (0, $cnhn5.SUBSCRIPTION_SUPPORTED_EVENTS).has(type);
}
function $461958717eae170a$export$4bc59bf28171f69e(type) {
    return typeof type === 'string' && (0, $cnhn5.BOARD_SUPPORTED_EVENTS).has(type);
}

});


parcelRegister("1H73m", function(module, exports) {

$parcel$export(module.exports, "BoardIssueSubscription", () => $70818e6682d73c66$export$20d42873ce3eb6aa);

var $jonoc = parcelRequire("jonoc");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $2YZCu = parcelRequire("2YZCu");

var $90yGq = parcelRequire("90yGq");

var $koeKL = parcelRequire("koeKL");

var $bkbBi = parcelRequire("bkbBi");

const $70818e6682d73c66$var$LOG_LOCATION = 'jira-realtime-board-issue-subscription';
const $70818e6682d73c66$export$20d42873ce3eb6aa = /*#__PURE__*/ (0, $5uXOq.memo)(({ appId: appId, projectIds: projectIds, events: events, onJoin: onJoin, onReceive: onReceive, onError: onError, onLeave: onLeave })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const atlassianAccountId = (0, $90yGq.useAccountId)();
    const defaultAttributes = {
        source: (0, $cd8288ab589b4c19$export$f7ec9b25c28de3df),
        cloudId: cloudId,
        appId: appId,
        atlassianAccountId: atlassianAccountId
    };
    (0, $8Uumt.useSubscription)((0, $5uXOq.useMemo)(()=>({
            subscription: (0, $jonoc.default),
            variables: {
                cloudId: cloudId,
                atlassianAccountId: String(atlassianAccountId),
                events: events,
                projectIds: projectIds
            },
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            onNext: (response)=>{
                const payload = response?.jira?.onJirtBoardIssueSubscription;
                if (!payload) {
                    (0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Subscription started', defaultAttributes);
                    onJoin();
                    return;
                }
                if (!(0, $bkbBi.isBoardIssueEventType)(payload.type)) {
                    (0, $2YZCu.default).safeErrorWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Invalid event type', {
                        ...defaultAttributes,
                        eventType: payload.type
                    });
                    return;
                }
                const boardId = Number(payload.boardId);
                const projectId = payload.projectId;
                const realtimeEvent = {
                    type: payload.type,
                    payload: {
                        boardId: boardId,
                        projectId: projectId,
                        atlassianId: String(payload.actionerAccountId)
                    }
                };
                (0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Event received', {
                    ...defaultAttributes,
                    eventType: payload.type,
                    projectId: projectId,
                    boardId: boardId,
                    resource: payload.resource,
                    triggeredBy: String(payload.actionerAccountId),
                    receivedBy: atlassianAccountId,
                    isTriggeredBySameUser: String(payload.actionerAccountId) === atlassianAccountId
                });
                onReceive(realtimeEvent);
            },
            onCompleted: ()=>{
                (0, $2YZCu.default).safeInfoWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, 'Subscription completed', {
                    ...defaultAttributes,
                    receivedBy: atlassianAccountId
                });
                onLeave();
            },
            onError: (error)=>{
                (0, $2YZCu.default).safeErrorWithoutCustomerData($70818e6682d73c66$var$LOG_LOCATION, `[${appId}] Subscription failure`, error);
                onError(error);
            }
        }), // Given React hooks require dependencies to be stable, but this cannot be guaranteed by consumers.
    // To ensure the subscription is created only once and not recreated on every re-render,
    // an empty dependency array is used intentionally. This approach ensures stability and avoids unnecessary resubscriptions.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []));
    return null;
});

});
parcelRegister("jonoc", function(module, exports) {

$parcel$export(module.exports, "default", () => $d72e7cd29e30a9cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<730097d6ae65b73af54d4da2e8d8c906>>
 * @relayHash 7ea059724811cea589537e314b11add7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 81051b9ef9e2b791f6b496bd28a23ed422f62b88a3e8eec5abb4c22716c6b69a
const $d72e7cd29e30a9cc$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "atlassianAccountId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "cloudId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "events"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "projectIds"
    }, v4 = [
        {
            "concreteType": "JiraSubscription",
            "kind": "LinkedField",
            "name": "jira",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "atlassianAccountId",
                            "variableName": "atlassianAccountId"
                        },
                        {
                            "kind": "Variable",
                            "name": "cloudId",
                            "variableName": "cloudId"
                        },
                        {
                            "kind": "Variable",
                            "name": "events",
                            "variableName": "events"
                        },
                        {
                            "kind": "Variable",
                            "name": "projectIds",
                            "variableName": "projectIds"
                        }
                    ],
                    "concreteType": "JiraJirtBoardScoreIssueEventPayload",
                    "kind": "LinkedField",
                    "name": "onJirtBoardIssueSubscription",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "type"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "resource"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "boardId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "cloudId"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "issueId"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "BoardIssueSubscription",
            "selections": v4 /*: any*/ ,
            "type": "Subscription"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "BoardIssueSubscription",
            "selections": v4 /*: any*/ 
        },
        "params": {
            "id": "81051b9ef9e2b791f6b496bd28a23ed422f62b88a3e8eec5abb4c22716c6b69a",
            "metadata": {},
            "name": "BoardIssueSubscription",
            "operationKind": "subscription",
            "text": null
        }
    };
}();
$d72e7cd29e30a9cc$var$node.hash = "fe89207b97768c1d05529ecc19effa77";
var $d72e7cd29e30a9cc$export$2e2bcd8739ae039 = $d72e7cd29e30a9cc$var$node;

});




parcelRegister("5fK3R", function(module, exports) {

$parcel$export(module.exports, "REALTIME_EVENTS", () => $f9587590828c909c$export$a45e758f2a5806e6);
$parcel$export(module.exports, "REALTIME_EVENTS_WITH_BSI", () => $f9587590828c909c$export$6294460c3b78650e);
$parcel$export(module.exports, "BOARD_SCOPE_ISSUES_UPDATED_EVENT", () => $f9587590828c909c$export$94c8ec37f7a855a9);

var $cnhn5 = parcelRequire("cnhn5");
const $f9587590828c909c$export$a45e758f2a5806e6 = [
    (0, $cnhn5.ISSUE_ASSIGNED_EVENT),
    (0, $cnhn5.ISSUE_CREATED_EVENT),
    (0, $cnhn5.ISSUE_DELETED_EVENT),
    (0, $cnhn5.ISSUE_TRANSITIONED_EVENT),
    (0, $cnhn5.ISSUE_UPDATED_EVENT)
];
const $f9587590828c909c$export$6294460c3b78650e = [
    (0, $cnhn5.ISSUE_CREATED_EVENT),
    (0, $cnhn5.ISSUE_UPDATED_EVENT),
    (0, $cnhn5.BOARD_SCOPE_ISSUES_UPDATED)
];
const $f9587590828c909c$export$94c8ec37f7a855a9 = [
    (0, $cnhn5.BOARD_SCOPE_ISSUES_UPDATED)
];

});

parcelRegister("irkFn", function(module, exports) {

$parcel$export(module.exports, "realtimeChannelSelector", () => $136c021b0909277e$export$5a1e23dccf0fc573);

var $dGvGJ = parcelRequire("dGvGJ");

var $67Z81 = parcelRequire("67Z81");
const $136c021b0909277e$export$5a1e23dccf0fc573 = (0, $dGvGJ.createSelector)([
    (0, $67Z81.getIssueProjectIds),
    (0, $67Z81.cloudIdSelector)
], (projectIds, cloudId)=>projectIds.map((projectId)=>`ari:cloud:jira:${cloudId}:project/${projectId}`));

});


parcelRegister("i9WnN", function(module, exports) {

$parcel$export(module.exports, "default", () => $6415380cdd366f97$export$2e2bcd8739ae039);
/* view.tsx generated by @compiled/babel-plugin v0.36.1 */ /* eslint-disable jira/deprecations/no-base-url */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $34ck9 = parcelRequire("34ck9");

var $7gWdR = parcelRequire("7gWdR");

var $41Tr4 = parcelRequire("41Tr4");

var $gJlZe = parcelRequire("gJlZe");

var $5ZW09 = parcelRequire("5ZW09");

var $hP2lu = parcelRequire("hP2lu");


var $x9xyg = parcelRequire("x9xyg");

var $7Q2kM = parcelRequire("7Q2kM");

var $iepkZ = parcelRequire("iepkZ");

var $4mO32 = parcelRequire("4mO32");

var $b71gk = parcelRequire("b71gk");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $krmH9 = parcelRequire("krmH9");

var $j8DrX = parcelRequire("j8DrX");

var $hkiaF = parcelRequire("hkiaF");

var $axmY8 = parcelRequire("axmY8");

var $02beV = parcelRequire("02beV");

var $22vqd = parcelRequire("22vqd");

var $2gCtH = parcelRequire("2gCtH");

var $b052x = parcelRequire("b052x");

var $3HwlS = parcelRequire("3HwlS");

var $lfTZh = parcelRequire("lfTZh");

var $jqUpd = parcelRequire("jqUpd");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $f7Y15 = parcelRequire("f7Y15");

var $11dfA = parcelRequire("11dfA");

var $7LEyz = parcelRequire("7LEyz");

var $5fQw9 = parcelRequire("5fQw9");

var $9hLEH = parcelRequire("9hLEH");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $4bO80 = parcelRequire("4bO80");

var $5E2gE = parcelRequire("5E2gE");

var $3U6yu = parcelRequire("3U6yu");

var $lmBAt = parcelRequire("lmBAt");

var $kJ1Ne = parcelRequire("kJ1Ne");

var $2xFXk = parcelRequire("2xFXk");


var $8TCLJ = parcelRequire("8TCLJ");

var $7V9GI = parcelRequire("7V9GI");

var $gKBVc = parcelRequire("gKBVc");

var $4wbGn = parcelRequire("4wbGn");

var $gUmfi = parcelRequire("gUmfi");

var $iUagi = parcelRequire("iUagi");



var $7mkyN = parcelRequire("7mkyN");

var $2f454 = parcelRequire("2f454");

var $dnW4F = parcelRequire("dnW4F");

var $dW1HX = parcelRequire("dW1HX");

var $2ON1s = parcelRequire("2ON1s");

var $67sX6 = parcelRequire("67sX6");

var $6g14V = parcelRequire("6g14V");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");

var $94kuB = parcelRequire("94kuB");

var $bxz0l = parcelRequire("bxz0l");

var $8R2g1 = parcelRequire("8R2g1");

var $ewLux = parcelRequire("ewLux");
const $6415380cdd366f97$var$IssueLinksHandlerContainer = ({ children: children, onIssueOpen: onIssueOpen, isGlobal: isGlobal })=>{
    if (onIssueOpen && isGlobal) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b052x.IssueLinksHandlerContainer), {
        onIssueOpen: onIssueOpen,
        isGlobal: isGlobal
    }, children);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, children);
};
const $6415380cdd366f97$var$usePpsSurveyEvent = (isReady)=>{
    const dontSendServeyEvent = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [selectedIssue] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    (0, $5uXOq.useEffect)(()=>{
        if (!isReady || dontSendServeyEvent.current) return;
        // we only want this to run once
        dontSendServeyEvent.current = true;
        if (selectedIssue) // we are only interested in board view without issue selected
        return;
        (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'ppsSurvey ready', {
            experience: 'board',
            experienceType: isCMPBoard ? 'cmp' : 'tmp'
        });
    }, [
        isReady,
        isCMPBoard,
        createAnalyticsEvent,
        selectedIssue,
        dontSendServeyEvent
    ]);
};
const $6415380cdd366f97$export$27a5bd065ad55220 = (props)=>{
    const { isCacheHit: isCacheHit, hasModals: hasModals = true, hasFlags: hasFlags = true, rapidViewId: rapidViewId, estimationStatistic: estimationStatistic, DocumentTitle: DocumentTitle, Header: Header, Modals: Modals, Flags: Flags, ViewTracker: ViewTracker, xsrfToken: xsrfToken, PrefetchIssues: PrefetchIssues, Realtime: Realtime, baseUrl: baseUrl, AddBoardToHistory: AddBoardToHistory, projectKey: projectKey, GlobalSearchTracker: GlobalSearchTracker, hasMinimap: hasMinimap = true, isInsightsPanelOpen: isInsightsPanelOpen, Board: Board, DetailView: DetailView, customFiltersQueryRef: customFiltersQueryRef, boardFilterRefinementQueryRef: boardFilterRefinementQueryRef, projectId: projectId, currentUserAccountId: currentUserAccountId, issueLimitExceeded: issueLimitExceeded, savedFilterId: savedFilterId, selectedSprintsOrAllSprints: selectedSprintsOrAllSprints, externalActionForIssueView: externalActionForIssueView } = props;
    const { onExperienceSuccess: onExperienceSuccess } = props;
    const [width, setWidth] = (0, $5uXOq.useState)(0);
    const throttledSetWidth = (0, (/*@__PURE__*/$parcel$interopDefault($34ck9)))(setWidth, 50);
    const viewMode = (0, $2gCtH.useViewMode)();
    const isDetailViewSidebar = viewMode === 'SIDEBAR';
    const isCMPBoard = (0, $63LqY.useIsCMPBoard)();
    const canEditBoard = (0, $63LqY.useCanEditBoard)();
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const columnDropIndicatorContainerRef = (0, $5uXOq.useRef)(null);
    const isViewSettingPanelOpen = (0, $67sX6.useBoardSelector)((0, $6g14V.getViewSettingsPanel));
    const shouldShowAdminInaccessibleBoard = (0, $hP2lu.useShouldShowAdminInaccessibleBoard)((0, $f7Y15.uifBoardResource));
    const isJSWBoard = (0, $63LqY.useIsJSWBoard)();
    const isEmbedView = (0, $gKBVc.useIsEmbedView)();
    const [isActiveStandup, setIsActiveStandup] = (0, $8TCLJ.useActiveStandup)();
    const shouldShowStandupPanel = isActiveStandup && !isIncrementPlanningBoard && isJSWBoard && (0, $6s1PB.expVal)('jira-in-product-standups', 'is_enabled', false);
    const isNewFilterRefinementBar = (0, $67sX6.useBoardSelector)((0, $5mTgl.isFilterRefinementEnabled));
    const issueCount = (0, $67sX6.useBoardSelector)((0, $67Z81.getIssueCount));
    const shouldShowIssueLimitFlags = (0, $63LqY.useCapability)((0, $2xFXk.Capability).SHOW_ISSUE_LIMIT_FLAGS);
    const shouldShowPublicFormsChangeboardingModal = (0, $63LqY.useCapability)((0, $2xFXk.Capability).SHOW_PUBLIC_FORMS_CHANGEBOARDING_MODAL) && canEditBoard;
    const isTabNavigation = (0, $63LqY.useCapability)((0, $2xFXk.Capability).IS_TAB_NAVIGATION);
    const [selectedIssue] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const assignees = (0, $67sX6.useBoardSelector)((0, $5mTgl.orderedWorkAssigneesByAccountIdSelector));
    const workFilters = (0, $67sX6.useBoardSelector)((0, $5mTgl.getWorkFilters));
    const setAssigneeFilter = (0, $5uXOq.useCallback)((id)=>{
        if (isNewFilterRefinementBar) {
            const newJql = (0, $94kuB.replaceAssignee)(workFilters.values[0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f] || '', id);
            dispatch((0, $dnW4F.setAllFilters)({
                ...workFilters.values,
                ...id ? {
                    [(0, $dcff40112356dfc1$export$f8f7545d2bb78afb)]: [
                        id
                    ]
                } : {
                    [(0, $dcff40112356dfc1$export$f8f7545d2bb78afb)]: []
                },
                [(0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)]: newJql
            }, (0, $dcff40112356dfc1$export$dc9697aa7b3a6d6f)));
        } else dispatch((0, $dnW4F.setFilters)((0, $dcff40112356dfc1$export$f8f7545d2bb78afb), id ? [
            id
        ] : []));
    }, [
        dispatch,
        isNewFilterRefinementBar,
        workFilters.values
    ]);
    const currentlyFilteredAssignee = (0, $67sX6.useBoardSelector)((state)=>state.ui.workFilters?.values?.ASSIGNEE?.[0] || null);
    // This change is added because on this branch there's no router resource
    const isLoaded = (0, $67sX6.useBoardSelector)((state)=>{
        return !state.configuration.isCMPBoard || (0, $5mTgl.isBoardConfigLoaded)(state);
    });
    const wrapperHeightOffset = isIncrementPlanningBoard ? `(${0, $81918a2ef6db1f93$export$d60454526e2281af} + ${0, $7e733a5d4e4331fc$export$85243b761a28eea7})` : (0, $81918a2ef6db1f93$export$d60454526e2281af);
    // Consolidate all of program board empty states into a hook
    const programBoardEmptyStates = (0, $gUmfi.useProgramBoardEmptyStates)(`calc(100vh - ${wrapperHeightOffset})`);
    const shouldMountStorageLimitsBanner = (0, $63LqY.useIsFreeJswProject)();
    const isSyntheticTenant = (0, $5uXOq.useCallback)(()=>(0, $j8DrX.default)('ajs-is-synthetic') === 'true', []);
    $6415380cdd366f97$var$usePpsSurveyEvent(isLoaded);
    (0, $5uXOq.useEffect)(()=>{
        onExperienceSuccess();
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        document.body?.classList.add('spb');
        (0, $x9xyg.setMark)((0, $dcbb2bce513725b3$export$e3639dbf0033629d));
        return ()=>{
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            document.body?.classList.remove('spb');
        };
    }, [
        onExperienceSuccess
    ]);
    (0, $5uXOq.useEffect)(()=>(0, $7gWdR.monitorForElements)({
            onDragStart: ({ location: location })=>{
                (0, $41Tr4.autoScroller).start({
                    input: location.current.input
                });
            },
            onDrop: ()=>{
                (0, $41Tr4.autoScroller).stop();
            },
            onDrag: ({ location: location })=>{
                (0, $41Tr4.autoScroller).updateInput({
                    input: location.current.input
                });
            }
        }), []);
    (0, $7V9GI.useGICSidebarForcer)();
    (0, $4wbGn.useOpenTeamAssociationModal)();
    const entryPointResult = (0, $4mO32.useEntryPoint)((0, $jqUpd.planIssueModal), {});
    const onIssueOpen = (0, $5uXOq.useCallback)((issueId, issueKey)=>{
        if (isDetailViewSidebar) {
            dispatch((0, $2ON1s.closeInsightsPanel)());
            (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && dispatch((0, $2ON1s.closeViewSettingsPanel)());
        }
        /**
     * If the issueKey is present, then the open modal action can be called directly.
     * used by Next Best Task to show issues that are not on the board.
     */ if (issueKey) dispatch((0, $dW1HX.openIssueModal)(issueKey));
        else dispatch((0, $2f454.cardClick)(issueId, false, false));
    }, [
        dispatch,
        isDetailViewSidebar
    ]);
    // Only render the program board empty states if it's not null
    if (programBoardEmptyStates) return programBoardEmptyStates;
    // Show a message to admin users if the board is inaccessible due to filter permissions and how to update it
    if (shouldShowAdminInaccessibleBoard) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5ZW09.AsyncAdminInaccessibleBoard), {
        rapidViewId: rapidViewId,
        skeleton: (0, $11dfA.NextGenBoardSkeleton)
    });
    // TODO FEBO-357 Fix when skeleton appears
    if (!isLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $11dfA.NextGenBoardSkeleton), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8R2g1.CmpBoardSlaTracker), null));
    const renderBoardSizeLimitEmptyState = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7LEyz.default), {
            projectKey: projectKey,
            isCMPBoard: isCMPBoard,
            savedFilterId: savedFilterId
        });
    const renderBoard = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$SizeDetectorWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gJlZe.WidthObserver), {
            setWidth: throttledSetWidth
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$BoardArea, {
            "data-test-id": "software-board.board-area",
            "data-testid": "software-board.board-area"
        }, shouldShowStandupPanel && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $4bO80.AsyncJiraStandups), {
            boardId: Number(rapidViewId),
            setIsActiveStandup: setIsActiveStandup,
            assignees: assignees,
            setAssigneeFilter: setAssigneeFilter,
            currentlyFilteredAssignee: currentlyFilteredAssignee
        }), Board && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Board, {
            hasMinimap: hasMinimap,
            isCacheHit: isCacheHit
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            packageName: "jiraDevelopmentDetailsLoader",
            id: "devDetailsDialogLoader",
            extraEventData: {
                teamName: 'nova'
            }
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Q2kM.DevDetailsDialogLoaderAsync), {
            scopeId: "software-board.board"
        })), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bxz0l.ForceRecalculateSubscribers), null)), !isIncrementPlanningBoard && (isDetailViewSidebar || isInsightsPanelOpen || (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && isViewSettingPanelOpen) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DetailView, {
            isDetailViewSidebar: isDetailViewSidebar,
            isInsightsPanelOpen: isInsightsPanelOpen,
            // @ts-expect-error TS2322 - XSRF token possibly is dead code
            xsrfToken: xsrfToken,
            rapidViewId: rapidViewId,
            parentWidth: width,
            projectId: projectId,
            estimationStatistic: estimationStatistic
        })));
    const boardContents = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, isCMPBoard && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8R2g1.CmpBoardSlaTracker), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(GlobalSearchTracker, null), !isIncrementPlanningBoard && DocumentTitle && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(DocumentTitle, null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $02beV.NextBestTaskContainer), {
            accountId: currentUserAccountId,
            boardId: rapidViewId,
            isCMPBoard: isCMPBoard,
            sprints: selectedSprintsOrAllSprints,
            onIssueOpen: onIssueOpen
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hkiaF.UserPropertiesContainer), {
            scope: (0, $axmY8.NEXT_BEST_TASK_USER_PROPERTIES_SCOPE),
            accountId: currentUserAccountId
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$IssueLinksHandlerContainer, {
            onIssueOpen: onIssueOpen,
            isGlobal: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $22vqd.ViewSettingsSpotlightContainer), {
            shouldShowSpotlight: (!selectedIssue || isDetailViewSidebar) && isJSWBoard
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5E2gE.StandupEntryPointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$ViewWrapper, null, shouldMountStorageLimitsBanner && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3U6yu.StorageLimitsBanner), null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Header, {
            customFiltersQueryRef: customFiltersQueryRef,
            boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
            isEmbedView: isEmbedView,
            isActiveStandup: isActiveStandup,
            setIsActiveStandup: setIsActiveStandup
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$ColumnDropIndicatorContainer, {
            ref: columnDropIndicatorContainerRef
        }), issueLimitExceeded ? renderBoardSizeLimitEmptyState() : renderBoard())))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(PrefetchIssues, null), ViewTracker && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(ViewTracker, null), hasFlags && Flags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Flags, null), hasModals && selectedIssue && !isIncrementPlanningBoard && !isDetailViewSidebar && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ewLux.default), {
            rapidViewId: Number(rapidViewId),
            externalAction: externalActionForIssueView
        }), hasModals && Modals && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
            id: "async-board-modals",
            packageName: "software-board"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
            name: "board-modals",
            fallback: null
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Modals, null))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(AddBoardToHistory, {
            baseUrl: baseUrl,
            boardId: rapidViewId
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Realtime, null));
    const renderBoardContentsWithContextProviders = ()=>{
        if (isIncrementPlanningBoard) {
            if ((0, $4R6GH.fg)('issue_view_in_program_board')) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krmH9.ProgramBoardParentSwitcherEntrypointContextProvider), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7mkyN.PlanModalEntrypointContext).Provider, {
                value: entryPointResult
            }, boardContents()));
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $krmH9.ProgramBoardParentSwitcherEntrypointContextProvider), null, boardContents());
        }
        return boardContents();
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($6415380cdd366f97$var$Wrapper, {
        height: (0, $3HwlS.getWillShowNav4)() ? '100%' : `calc(100vh - ${wrapperHeightOffset})`,
        "data-test-id": "software-board.board",
        "data-testid": "software-board.board",
        isThemingEnabled: (0, $lmBAt.getIsSoftwareThemingEnabled)()
    }, renderBoardContentsWithContextProviders()), shouldShowIssueLimitFlags && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5fQw9.default), {
        boardId: rapidViewId,
        isCMP: isCMPBoard,
        isProjectAdmin: canEditBoard,
        projectKey: projectKey,
        views: [
            {
                view: 'BOARD',
                issueCount: issueCount
            }
        ]
    }), !isTabNavigation && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9hLEH.default), {
        boardId: rapidViewId,
        projectKey: projectKey,
        isCMPBoard: isCMPBoard
    }), isSyntheticTenant() && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iepkZ.AsyncLaunchToolchainSpotlight), {
        projectId: projectId,
        projectKey: projectKey
    }), shouldShowPublicFormsChangeboardingModal && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kJ1Ne.default), {
        projectId: projectId.toString()
    }));
};
var $6415380cdd366f97$export$2e2bcd8739ae039 = $6415380cdd366f97$export$27a5bd065ad55220;
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $6415380cdd366f97$var$Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    const { isThemingEnabled: isThemingEnabled, ...__cmpldp } = __cmplp;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmpldp,
        style: {
            ...__cmpls,
            "--_8jvb0j": (0, $lD23V.default)(__cmplp.height)
        },
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4t3i1474 _vchhusvi _1e0c1txw",
            !__cmplp.isThemingEnabled && "_bfhkvuon",
            __cmplp.className
        ])
    });
});
const $6415380cdd366f97$var$ViewWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _2lx21bp4 _vchhusvi _1bsb1osq",
            __cmplp.className
        ])
    });
});
const $6415380cdd366f97$var$BoardArea = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4t3i1osq",
            __cmplp.className
        ])
    });
});
const $6415380cdd366f97$var$SizeDetectorWrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1reo15vq _18m915vq _4t3i1osq _c71l1osq",
            __cmplp.className
        ])
    });
});
const $6415380cdd366f97$var$ColumnDropIndicatorContainer = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_kqswh2mm _4t3iidpf _1bsb1osq _19pkidpf _2hwx1jfw _otyridpf _18u01jfw",
            __cmplp.className
        ])
    });
});

});
parcelRegister("41Tr4", function(module, exports) {

$parcel$export(module.exports, "createAutoScroller", () => $109b883638d1460e$export$fbda4b72e803ec38);
$parcel$export(module.exports, "autoScroller", () => $109b883638d1460e$export$d19940cfc7560cd8);

var $bKki5 = parcelRequire("bKki5");
const $109b883638d1460e$var$scrollElement = (element, change)=>{
    element.scrollBy(change.x, change.y);
};
const $109b883638d1460e$var$scrollWindow = (change)=>{
    window.scrollBy(change.x, change.y);
};
const $109b883638d1460e$export$fbda4b72e803ec38 = ()=>{
    let dragging = null;
    function tryScroll(fakeScrollCallback) {
        if (dragging == null) return;
        (0, $bKki5.scroll)({
            input: dragging.latestInput,
            dragStartTime: dragging.dragStartTime,
            shouldUseTimeDampening: dragging.shouldUseTimeDampening,
            behavior: dragging.behavior,
            scrollElement: fakeScrollCallback ?? $109b883638d1460e$var$scrollElement,
            scrollWindow: fakeScrollCallback ?? $109b883638d1460e$var$scrollWindow
        });
    }
    // Every animation frame use the latest user input to scroll
    // We do this loop manually rather than in response to `onDrag`
    // events as `onDrag` can drop to 50-100ms between events when
    // the user is not actively moving their pointer
    function loop() {
        if (!dragging) return;
        dragging.loopFrameId = requestAnimationFrame(()=>{
            tryScroll();
            loop();
        });
    }
    const start = ({ input: input, behavior: behavior = 'window-then-container' })=>{
        const dragStartTime = Date.now();
        dragging = {
            dragStartTime: dragStartTime,
            latestInput: input,
            loopFrameId: null,
            shouldUseTimeDampening: false,
            behavior: behavior
        };
        // we only use time dampening when auto scrolling starts on lift.
        const fakeScrollCallback = ()=>{
            if (dragging) dragging.shouldUseTimeDampening = true;
        };
        tryScroll(fakeScrollCallback);
        loop();
    };
    function updateInput({ input: input }) {
        if (!dragging) return;
        dragging.latestInput = input;
    }
    const stop = ()=>{
        // can be called defensively
        if (!dragging) return;
        if (dragging.loopFrameId) cancelAnimationFrame(dragging.loopFrameId);
        dragging = null;
    };
    return {
        start: start,
        updateInput: updateInput,
        stop: stop
    };
};
const $109b883638d1460e$export$d19940cfc7560cd8 = $109b883638d1460e$export$fbda4b72e803ec38();

});
parcelRegister("bKki5", function(module, exports) {

$parcel$export(module.exports, "scroll", () => $fa05b34874c18386$export$209876d7b1ac8f3);
parcelRequire("i6e0j");
var $kKgsQ = parcelRequire("kKgsQ");

var $8IFZn = parcelRequire("8IFZn");

var $cd0ri = parcelRequire("cd0ri");

var $bUPhs = parcelRequire("bUPhs");

var $2tkrf = parcelRequire("2tkrf");

var $lVsVC = parcelRequire("lVsVC");
const $fa05b34874c18386$export$209876d7b1ac8f3 = ({ input: input, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening, scrollElement: scrollElement, scrollWindow: scrollWindow, behavior: behavior })=>{
    const tryScrollWindow = ()=>{
        const viewport = (0, $lVsVC.default)();
        const windowScrollChange = (0, $2tkrf.default)({
            dragStartTime: dragStartTime,
            viewport: viewport,
            center: {
                x: input.clientX + viewport.scroll.current.x,
                y: input.clientY + viewport.scroll.current.y
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (windowScrollChange) {
            scrollWindow(windowScrollChange);
            return true;
        }
        return false;
    };
    const tryScrollContainer = ()=>{
        const over = (0, $kKgsQ.getElementFromPointWithoutHoneypot)({
            x: input.clientX,
            y: input.clientY
        });
        const closestScrollable = (0, $8IFZn.getClosestScrollableElement)(over);
        if (!closestScrollable) return false;
        const scrollable = (0, $cd0ri.getScrollable)({
            closestScrollable: closestScrollable
        });
        const scrollableScrollChange = (0, $bUPhs.default)({
            dragStartTime: dragStartTime,
            scrollable: scrollable,
            center: {
                x: input.clientX,
                y: input.clientY
            },
            shouldUseTimeDampening: shouldUseTimeDampening
        });
        if (scrollableScrollChange) {
            scrollElement(closestScrollable, scrollableScrollChange);
            return true;
        }
        return false;
    };
    if (behavior === 'container-only') tryScrollContainer();
    if (behavior === 'window-only') tryScrollWindow();
    if (behavior === 'container-then-window') tryScrollContainer() || tryScrollWindow();
    if (behavior === 'window-then-container') tryScrollWindow() || tryScrollContainer();
};

});
parcelRegister("i6e0j", function(module, exports) {

$parcel$export(module.exports, "getElementFromPointWithoutHoneypot", () => (parcelRequire("kKgsQ")).getElementFromPointWithoutHoneypot);

var $kKgsQ = parcelRequire("kKgsQ");

});

parcelRegister("8IFZn", function(module, exports) {

$parcel$export(module.exports, "getClosestScrollableElement", () => $d89049a655de884c$export$f39f407dd5a0ebdb);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $d89049a655de884c$var$isEqual = (base)=>(value)=>base === value;
const $d89049a655de884c$var$isScroll = $d89049a655de884c$var$isEqual('scroll');
const $d89049a655de884c$var$isAuto = $d89049a655de884c$var$isEqual('auto');
const $d89049a655de884c$var$isEither = (overflow, fn)=>fn(overflow.overflowX) || fn(overflow.overflowY);
const $d89049a655de884c$var$isElementScrollable = (el)=>{
    const style = window.getComputedStyle(el);
    const overflow = {
        overflowX: style.overflowX,
        overflowY: style.overflowY
    };
    return $d89049a655de884c$var$isEither(overflow, $d89049a655de884c$var$isScroll) || $d89049a655de884c$var$isEither(overflow, $d89049a655de884c$var$isAuto);
};
const $d89049a655de884c$export$f39f407dd5a0ebdb = (el)=>{
    // cannot do anything else!
    if (!el) return null;
    // not allowing us to go higher then body
    if (el === document.body || el === document.documentElement) return null;
    if (!$d89049a655de884c$var$isElementScrollable(el)) // keep recursing
    return $d89049a655de884c$export$f39f407dd5a0ebdb(el.parentElement);
    // success!
    return el;
};

});

parcelRegister("cd0ri", function(module, exports) {

$parcel$export(module.exports, "getScrollable", () => $3bb4723f24ee5351$export$9b7238c949d126e9);

var $3YKxB = parcelRequire("3YKxB");
const $3bb4723f24ee5351$export$9b7238c949d126e9 = ({ closestScrollable: closestScrollable })=>{
    const rect = closestScrollable.getBoundingClientRect();
    const scrollPosition = {
        x: closestScrollable.scrollLeft,
        y: closestScrollable.scrollTop
    };
    return {
        container: (0, $3YKxB.getRect)(rect),
        scroll: {
            current: scrollPosition,
            max: {
                x: closestScrollable.scrollWidth - closestScrollable.clientWidth,
                y: closestScrollable.scrollHeight - closestScrollable.clientHeight
            }
        }
    };
};

});
parcelRegister("3YKxB", function(module, exports) {

$parcel$export(module.exports, "getRect", () => $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe);
$parcel$export(module.exports, "expand", () => $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72);
$parcel$export(module.exports, "createBox", () => $2e5b13c1f6ee9f8a$export$6459fc9e86be362e);
$parcel$export(module.exports, "offset", () => $2e5b13c1f6ee9f8a$export$cc800923e997bb8);
$parcel$export(module.exports, "withScroll", () => $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae);
$parcel$export(module.exports, "calculateBox", () => $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1);
$parcel$export(module.exports, "getBox", () => $2e5b13c1f6ee9f8a$export$34928e660d2a8702);

var $3joPi = parcelRequire("3joPi");
var $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe = function getRect(_ref) {
    var top = _ref.top, right = _ref.right, bottom = _ref.bottom, left = _ref.left;
    var width = right - left;
    var height = bottom - top;
    var rect = {
        top: top,
        right: right,
        bottom: bottom,
        left: left,
        width: width,
        height: height,
        x: left,
        y: top,
        center: {
            x: (right + left) / 2,
            y: (bottom + top) / 2
        }
    };
    return rect;
};
var $2e5b13c1f6ee9f8a$export$9f77e0932fb78f72 = function expand(target, expandBy) {
    return {
        top: target.top - expandBy.top,
        left: target.left - expandBy.left,
        bottom: target.bottom + expandBy.bottom,
        right: target.right + expandBy.right
    };
};
var $2e5b13c1f6ee9f8a$export$8b1f3092f5e28575 = function shrink(target, shrinkBy) {
    return {
        top: target.top + shrinkBy.top,
        left: target.left + shrinkBy.left,
        bottom: target.bottom - shrinkBy.bottom,
        right: target.right - shrinkBy.right
    };
};
var $2e5b13c1f6ee9f8a$var$shift = function shift(target, shiftBy) {
    return {
        top: target.top + shiftBy.y,
        left: target.left + shiftBy.x,
        bottom: target.bottom + shiftBy.y,
        right: target.right + shiftBy.x
    };
};
var $2e5b13c1f6ee9f8a$var$noSpacing = {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
};
var $2e5b13c1f6ee9f8a$export$6459fc9e86be362e = function createBox(_ref2) {
    var borderBox = _ref2.borderBox, _ref2$margin = _ref2.margin, margin = _ref2$margin === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$margin, _ref2$border = _ref2.border, border = _ref2$border === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$border, _ref2$padding = _ref2.padding, padding = _ref2$padding === void 0 ? $2e5b13c1f6ee9f8a$var$noSpacing : _ref2$padding;
    var marginBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$9f77e0932fb78f72(borderBox, margin));
    var paddingBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(borderBox, border));
    var contentBox = $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe($2e5b13c1f6ee9f8a$export$8b1f3092f5e28575(paddingBox, padding));
    return {
        marginBox: marginBox,
        borderBox: $2e5b13c1f6ee9f8a$export$4b834cebd9e5cebe(borderBox),
        paddingBox: paddingBox,
        contentBox: contentBox,
        margin: margin,
        border: border,
        padding: padding
    };
};
var $2e5b13c1f6ee9f8a$var$parse = function parse(raw) {
    var value = raw.slice(0, -2);
    var suffix = raw.slice(-2);
    if (suffix !== 'px') return 0;
    var result = Number(value);
    !!isNaN(result) && (0, $3joPi.default)(false);
    return result;
};
var $2e5b13c1f6ee9f8a$var$getWindowScroll = function getWindowScroll() {
    return {
        x: window.pageXOffset,
        y: window.pageYOffset
    };
};
var $2e5b13c1f6ee9f8a$export$cc800923e997bb8 = function offset(original, change) {
    var borderBox = original.borderBox, border = original.border, margin = original.margin, padding = original.padding;
    var shifted = $2e5b13c1f6ee9f8a$var$shift(borderBox, change);
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: shifted,
        border: border,
        margin: margin,
        padding: padding
    });
};
var $2e5b13c1f6ee9f8a$export$1d0caec378d7d0ae = function withScroll(original, scroll) {
    if (scroll === void 0) scroll = $2e5b13c1f6ee9f8a$var$getWindowScroll();
    return $2e5b13c1f6ee9f8a$export$cc800923e997bb8(original, scroll);
};
var $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1 = function calculateBox(borderBox, styles) {
    var margin = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.marginTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.marginRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.marginBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.marginLeft)
    };
    var padding = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.paddingTop),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.paddingRight),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.paddingBottom),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.paddingLeft)
    };
    var border = {
        top: $2e5b13c1f6ee9f8a$var$parse(styles.borderTopWidth),
        right: $2e5b13c1f6ee9f8a$var$parse(styles.borderRightWidth),
        bottom: $2e5b13c1f6ee9f8a$var$parse(styles.borderBottomWidth),
        left: $2e5b13c1f6ee9f8a$var$parse(styles.borderLeftWidth)
    };
    return $2e5b13c1f6ee9f8a$export$6459fc9e86be362e({
        borderBox: borderBox,
        margin: margin,
        padding: padding,
        border: border
    });
};
var $2e5b13c1f6ee9f8a$export$34928e660d2a8702 = function getBox(el) {
    var borderBox = el.getBoundingClientRect();
    var styles = window.getComputedStyle(el);
    return $2e5b13c1f6ee9f8a$export$b8dfc5d4e552b8e1(borderBox, styles);
};

});


parcelRegister("bUPhs", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac1c10c5ae151830$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $g2R1U = parcelRequire("g2R1U");

var $elgbz = parcelRequire("elgbz");
var $ac1c10c5ae151830$export$2e2bcd8739ae039 = ({ scrollable: scrollable, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $elgbz.default)({
        dragStartTime: dragStartTime,
        container: scrollable.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $g2R1U.canScrollScrollable)(scrollable, scroll) ? scroll : null;
};

});
parcelRegister("g2R1U", function(module, exports) {

$parcel$export(module.exports, "canScrollWindow", () => $e4b7c0460454dc35$export$cbd1e6fd5e887f10);
$parcel$export(module.exports, "canScrollScrollable", () => $e4b7c0460454dc35$export$57c21b61d76c9819);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $72Pcv = parcelRequire("72Pcv");
const $e4b7c0460454dc35$var$smallestSigned = (0, $72Pcv.apply)((value)=>{
    if (value === 0) return 0;
    return value > 0 ? 1 : -1;
});
const $e4b7c0460454dc35$export$6b13012b06f8f95b = (()=>{
    const getRemainder = (target, max)=>{
        if (target < 0) return target;
        if (target > max) return target - max;
        return 0;
    };
    return ({ current: current, max: max, change: change })=>{
        const targetScroll = (0, $72Pcv.add)(current, change);
        const overlap = {
            x: getRemainder(targetScroll.x, max.x),
            y: getRemainder(targetScroll.y, max.y)
        };
        if ((0, $72Pcv.isEqual)(overlap, (0, $72Pcv.origin))) return null;
        return overlap;
    };
})();
const $e4b7c0460454dc35$export$dbc3ad6130556cf6 = ({ max: rawMax, current: current, change: change })=>{
    // It is possible for the max scroll to be greater than the current scroll
    // when there are scrollbars on the cross axis. We adjust for this by
    // increasing the max scroll point if needed
    // This will allow movements backwards even if the current scroll is greater than the max scroll
    const max = {
        x: Math.max(current.x, rawMax.x),
        y: Math.max(current.y, rawMax.y)
    };
    // Only need to be able to move the smallest amount in the desired direction
    const smallestChange = $e4b7c0460454dc35$var$smallestSigned(change);
    const overlap = $e4b7c0460454dc35$export$6b13012b06f8f95b({
        max: max,
        current: current,
        change: smallestChange
    });
    // no overlap at all - we can move there!
    if (!overlap) return true;
    // if there was an x value, but there is no x overlap - then we can scroll on the x!
    if (smallestChange.x !== 0 && overlap.x === 0) return true;
    // if there was an y value, but there is no y overlap - then we can scroll on the y!
    if (smallestChange.y !== 0 && overlap.y === 0) return true;
    return false;
};
const $e4b7c0460454dc35$export$cbd1e6fd5e887f10 = (viewport, change)=>$e4b7c0460454dc35$export$dbc3ad6130556cf6({
        current: viewport.scroll.current,
        max: viewport.scroll.max,
        change: change
    });
const $e4b7c0460454dc35$export$2f1f3b9e315c6096 = (viewport, change)=>{
    if (!$e4b7c0460454dc35$export$cbd1e6fd5e887f10(viewport, change)) return null;
    const max = viewport.scroll.max;
    const current = viewport.scroll.current;
    return $e4b7c0460454dc35$export$6b13012b06f8f95b({
        current: current,
        max: max,
        change: change
    });
};
const $e4b7c0460454dc35$export$57c21b61d76c9819 = (scrollable, change)=>{
    return $e4b7c0460454dc35$export$dbc3ad6130556cf6({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};
const $e4b7c0460454dc35$export$d88a6b2979421049 = (scrollable, change)=>{
    if (!$e4b7c0460454dc35$export$57c21b61d76c9819(scrollable, change)) return null;
    return $e4b7c0460454dc35$export$6b13012b06f8f95b({
        current: scrollable.scroll.current,
        max: scrollable.scroll.max,
        change: change
    });
};

});
parcelRegister("72Pcv", function(module, exports) {

$parcel$export(module.exports, "origin", () => $6ab9ddd38a038691$export$f710a83a91838a36);
$parcel$export(module.exports, "apply", () => $6ab9ddd38a038691$export$5635d7ef4b8fee1c);
$parcel$export(module.exports, "isEqual", () => $6ab9ddd38a038691$export$248d38f6296296c5);
$parcel$export(module.exports, "add", () => $6ab9ddd38a038691$export$e16d8520af44a096);
$parcel$export(module.exports, "subtract", () => $6ab9ddd38a038691$export$4e2d2ead65e5f7e3);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $6ab9ddd38a038691$export$f710a83a91838a36 = {
    x: 0,
    y: 0
};
const $6ab9ddd38a038691$export$5635d7ef4b8fee1c = (fn)=>(point)=>({
            x: fn(point.x),
            y: fn(point.y)
        });
const $6ab9ddd38a038691$export$248d38f6296296c5 = (point1, point2)=>point1.x === point2.x && point1.y === point2.y;
const $6ab9ddd38a038691$export$e16d8520af44a096 = (point1, point2)=>({
        x: point1.x + point2.x,
        y: point1.y + point2.y
    });
const $6ab9ddd38a038691$export$4e2d2ead65e5f7e3 = (point1, point2)=>({
        x: point1.x - point2.x,
        y: point1.y - point2.y
    });

});


parcelRegister("elgbz", function(module, exports) {

$parcel$export(module.exports, "default", () => $7bd53a776b729d8f$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8x8E3 = parcelRequire("8x8E3");

var $72Pcv = parcelRequire("72Pcv");

var $3hu7o = parcelRequire("3hu7o");
// will replace -0 and replace with +0
const $7bd53a776b729d8f$var$clean = (0, $72Pcv.apply)((value)=>value === 0 ? 0 : value);
var $7bd53a776b729d8f$export$2e2bcd8739ae039 = ({ dragStartTime: dragStartTime, container: container, center: center, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    // get distance to each edge
    const distanceToEdges = {
        top: center.y - container.top,
        right: container.right - center.x,
        bottom: container.bottom - center.y,
        left: center.x - container.left
    };
    // 1. Figure out which x,y values are the best target
    // 2. Can the container scroll in that direction at all?
    // If no for both directions, then return null
    // 3. Is the center close enough to a edge to start a drag?
    // 4. Based on the distance, calculate the speed at which a scroll should occur
    // The lower distance value the faster the scroll should be.
    // Maximum speed value should be hit before the distance is 0
    // Negative values to not continue to increase the speed
    const y = (0, $3hu7o.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $8x8E3.vertical),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const x = (0, $3hu7o.default)({
        container: container,
        distanceToEdges: distanceToEdges,
        dragStartTime: dragStartTime,
        axis: (0, $8x8E3.horizontal),
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    const required = $7bd53a776b729d8f$var$clean({
        x: x,
        y: y
    });
    // nothing required
    if ((0, $72Pcv.isEqual)(required, (0, $72Pcv.origin))) return null;
    return required;
};

});
parcelRegister("8x8E3", function(module, exports) {

$parcel$export(module.exports, "minScroll", () => $bf32c7b0b1170f48$export$67e2de1e1e796844);
$parcel$export(module.exports, "vertical", () => $bf32c7b0b1170f48$export$32f8a6eb41d46820);
$parcel$export(module.exports, "horizontal", () => $bf32c7b0b1170f48$export$641ecd0b2bc39508);
const $bf32c7b0b1170f48$export$67e2de1e1e796844 = 1;
const $bf32c7b0b1170f48$export$32f8a6eb41d46820 = {
    direction: 'vertical',
    start: 'top',
    end: 'bottom',
    size: 'height',
    scrollAxis: 'scrollTop'
};
const $bf32c7b0b1170f48$export$641ecd0b2bc39508 = {
    direction: 'horizontal',
    start: 'left',
    end: 'right',
    size: 'width',
    scrollAxis: 'scrollLeft'
};
const $bf32c7b0b1170f48$export$1a8fc111f6979e7a = [
    $bf32c7b0b1170f48$export$641ecd0b2bc39508.direction,
    $bf32c7b0b1170f48$export$32f8a6eb41d46820.direction
];

});

parcelRegister("3hu7o", function(module, exports) {

$parcel$export(module.exports, "default", () => $a9df84024ef20482$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $TN11L = parcelRequire("TN11L");

var $h91se = parcelRequire("h91se");
var $a9df84024ef20482$export$2e2bcd8739ae039 = ({ container: container, distanceToEdges: distanceToEdges, dragStartTime: dragStartTime, axis: axis, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const thresholds = (0, $TN11L.default)(container, axis);
    const isCloserToEnd = distanceToEdges[axis.end] < distanceToEdges[axis.start];
    if (isCloserToEnd) return (0, $h91se.default)({
        distanceToEdge: distanceToEdges[axis.end],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return -1 * (0, $h91se.default)({
        distanceToEdge: distanceToEdges[axis.start],
        thresholds: thresholds,
        dragStartTime: dragStartTime,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
};

});
parcelRegister("TN11L", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3b60bb9d8221ac4$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");
const $e3b60bb9d8221ac4$export$79446fee27934459 = (container, axis)=>{
    const startScrollingFrom = container[axis.size] * (0, $2gHPS.default).startFromPercentage;
    const maxScrollValueAt = container[axis.size] * (0, $2gHPS.default).maxScrollAtPercentage;
    const thresholds = {
        startScrollingFrom: startScrollingFrom,
        maxScrollValueAt: maxScrollValueAt
    };
    return thresholds;
};
var $e3b60bb9d8221ac4$export$2e2bcd8739ae039 = $e3b60bb9d8221ac4$export$79446fee27934459;

});
parcelRegister("2gHPS", function(module, exports) {

$parcel$export(module.exports, "default", () => $372e7e4331f931a5$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd
// Values used to control how the fluid auto scroll feels
const $372e7e4331f931a5$var$config = {
    // percentage distance from edge of container:
    startFromPercentage: 0.25,
    maxScrollAtPercentage: 0.05,
    // pixels per frame
    maxPixelScroll: 28,
    // A function used to ease a percentage value
    // A simple linear function would be: (percentage) => percentage;
    // percentage is between 0 and 1
    // result must be between 0 and 1
    ease: (percentage)=>Math.pow(percentage, 2),
    durationDampening: {
        // ms: how long to dampen the speed of an auto scroll from the start of a drag
        stopDampeningAt: 1200,
        // ms: when to start accelerating the reduction of duration dampening
        accelerateAt: 360
    }
};
var $372e7e4331f931a5$export$2e2bcd8739ae039 = $372e7e4331f931a5$var$config;

});


parcelRegister("h91se", function(module, exports) {

$parcel$export(module.exports, "default", () => $46ce8abe6474bdaa$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $8x8E3 = parcelRequire("8x8E3");

var $edWdS = parcelRequire("edWdS");

var $7vxL6 = parcelRequire("7vxL6");
const $46ce8abe6474bdaa$export$bf7199a9ebcb84a9 = ({ distanceToEdge: distanceToEdge, thresholds: thresholds, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $7vxL6.getValueFromDistance)(distanceToEdge, thresholds);
    // not enough distance to trigger a minimum scroll
    // we can bail here
    if (scroll === 0) return 0;
    // Dampen an auto scroll speed based on duration of drag
    if (!shouldUseTimeDampening) return scroll;
    // Once we know an auto scroll should occur based on distance,
    // we must let at least 1px through to trigger a scroll event an
    // another auto scroll call
    return Math.max((0, $edWdS.dampenValueByTime)(scroll, dragStartTime), (0, $8x8E3.minScroll));
};
var $46ce8abe6474bdaa$export$2e2bcd8739ae039 = $46ce8abe6474bdaa$export$bf7199a9ebcb84a9;

});
parcelRegister("edWdS", function(module, exports) {

$parcel$export(module.exports, "dampenValueByTime", () => $b46522d5c480b17a$export$2fe468ff7a999ed6);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");

var $8x8E3 = parcelRequire("8x8E3");

var $5yDwA = parcelRequire("5yDwA");
const $b46522d5c480b17a$var$accelerateAt = (0, $2gHPS.default).durationDampening.accelerateAt;
const $b46522d5c480b17a$var$stopAt = (0, $2gHPS.default).durationDampening.stopDampeningAt;
const $b46522d5c480b17a$export$2fe468ff7a999ed6 = (proposedScroll, dragStartTime)=>{
    const startOfRange = dragStartTime;
    const endOfRange = $b46522d5c480b17a$var$stopAt;
    const now = Date.now();
    const runTime = now - startOfRange;
    // we have finished the time dampening period
    if (runTime >= $b46522d5c480b17a$var$stopAt) return proposedScroll;
    // Up to this point we know there is a proposed scroll
    // but we have not reached our accelerate point
    // Return the minimum amount of scroll
    if (runTime < $b46522d5c480b17a$var$accelerateAt) return 0, $8x8E3.minScroll;
    const betweenAccelerateAtAndStopAtPercentage = (0, $5yDwA.getPercentage)({
        startOfRange: $b46522d5c480b17a$var$accelerateAt,
        endOfRange: endOfRange,
        current: runTime
    });
    const scroll = proposedScroll * (0, $2gHPS.default).ease(betweenAccelerateAtAndStopAtPercentage);
    return Math.ceil(scroll);
};

});
parcelRegister("5yDwA", function(module, exports) {

$parcel$export(module.exports, "getPercentage", () => $9599504fdea7da9c$export$6712e0f6cd0ea03);
// Source: https://github.com/atlassian/react-beautiful-dnd
const $9599504fdea7da9c$export$6712e0f6cd0ea03 = ({ startOfRange: startOfRange, endOfRange: endOfRange, current: current })=>{
    const range = endOfRange - startOfRange;
    if (range === 0) /**
		 * Detected distance range of 0 in the auto scroller
		 * This is unexpected and would cause a divide by 0 issue.
		 * Not allowing an auto scroll
		 */ return 0;
    const currentInRange = current - startOfRange;
    const percentage = currentInRange / range;
    return percentage;
};

});


parcelRegister("7vxL6", function(module, exports) {

$parcel$export(module.exports, "getValueFromDistance", () => $fa6f09f36cc6d31c$export$f3e495573a199c91);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $2gHPS = parcelRequire("2gHPS");

var $8x8E3 = parcelRequire("8x8E3");

var $5yDwA = parcelRequire("5yDwA");
const $fa6f09f36cc6d31c$export$f3e495573a199c91 = (distanceToEdge, thresholds)=>{
    /*
  // This function only looks at the distance to one edge
  // Example: looking at bottom edge
  |----------------------------------|
  |                                  |
  |                                  |
  |                                  |
  |                                  |
  |                                  | => no scroll in this range
  |                                  |
  |                                  |
  |  startScrollingFrom (eg 100px)   |
  |                                  |
  |                                  | => increased scroll value the closer to maxScrollValueAt
  |  maxScrollValueAt (eg 10px)      |
  |                                  | => max scroll value in this range
  |----------------------------------|
  */ // too far away to auto scroll
    if (distanceToEdge > thresholds.startScrollingFrom) return 0;
    // use max speed when on or over boundary
    if (distanceToEdge <= thresholds.maxScrollValueAt) return (0, $2gHPS.default).maxPixelScroll;
    // when just going on the boundary return the minimum integer
    if (distanceToEdge === thresholds.startScrollingFrom) return 0, $8x8E3.minScroll;
    // to get the % past startScrollingFrom we will calculate
    // the % the value is from maxScrollValueAt and then invert it
    const percentageFromMaxScrollValueAt = (0, $5yDwA.getPercentage)({
        startOfRange: thresholds.maxScrollValueAt,
        endOfRange: thresholds.startScrollingFrom,
        current: distanceToEdge
    });
    const percentageFromStartScrollingFrom = 1 - percentageFromMaxScrollValueAt;
    const scroll = (0, $2gHPS.default).maxPixelScroll * (0, $2gHPS.default).ease(percentageFromStartScrollingFrom);
    // scroll will always be a positive integer
    return Math.ceil(scroll);
};

});





parcelRegister("2tkrf", function(module, exports) {

$parcel$export(module.exports, "default", () => $d272222f271a432a$export$2e2bcd8739ae039);
// Source: https://github.com/atlassian/react-beautiful-dnd

var $g2R1U = parcelRequire("g2R1U");

var $elgbz = parcelRequire("elgbz");
var $d272222f271a432a$export$2e2bcd8739ae039 = ({ viewport: viewport, center: center, dragStartTime: dragStartTime, shouldUseTimeDampening: shouldUseTimeDampening })=>{
    const scroll = (0, $elgbz.default)({
        dragStartTime: dragStartTime,
        container: viewport.container,
        center: center,
        shouldUseTimeDampening: shouldUseTimeDampening
    });
    return scroll && (0, $g2R1U.canScrollWindow)(viewport, scroll) ? scroll : null;
};

});

parcelRegister("lVsVC", function(module, exports) {

$parcel$export(module.exports, "default", () => $3afd8185a3fe1873$export$2e2bcd8739ae039);

var $3YKxB = parcelRequire("3YKxB");

var $bsp0B = parcelRequire("bsp0B");

var $feNdz = parcelRequire("feNdz");
var $3afd8185a3fe1873$export$2e2bcd8739ae039 = ()=>{
    const scroll = (0, $feNdz.default)();
    const maxScroll = (0, $bsp0B.default)();
    const top = scroll.y;
    const left = scroll.x;
    // window.innerHeight: includes scrollbars (not what we want)
    // document.clientHeight gives us the correct value when using the html5 doctype
    const doc = document.documentElement;
    // Using these values as they do not consider scrollbars
    // padding box, without scrollbar
    const width = doc.clientWidth;
    const height = doc.clientHeight;
    // Computed
    const right = left + width;
    const bottom = top + height;
    const container = (0, $3YKxB.getRect)({
        top: top,
        left: left,
        right: right,
        bottom: bottom
    });
    const viewport = {
        container: container,
        scroll: {
            current: scroll,
            max: maxScroll
        }
    };
    return viewport;
};

});
parcelRegister("bsp0B", function(module, exports) {

$parcel$export(module.exports, "default", () => $e50ed177aa05ce5d$export$2e2bcd8739ae039);

var $bX8yW = parcelRequire("bX8yW");
var $e50ed177aa05ce5d$export$2e2bcd8739ae039 = ()=>{
    const doc = document.documentElement;
    const maxScroll = (0, $bX8yW.default)({
        // unclipped padding box, with scrollbar
        scrollHeight: doc.scrollHeight,
        scrollWidth: doc.scrollWidth,
        // clipped padding box, without scrollbar
        width: doc.clientWidth,
        height: doc.clientHeight
    });
    return maxScroll;
};

});
parcelRegister("bX8yW", function(module, exports) {

$parcel$export(module.exports, "default", () => $2927a2a5ef61b637$export$2e2bcd8739ae039);

var $72Pcv = parcelRequire("72Pcv");
var $2927a2a5ef61b637$export$2e2bcd8739ae039 = ({ scrollHeight: scrollHeight, scrollWidth: scrollWidth, height: height, width: width })=>{
    const maxScroll = (0, $72Pcv.subtract)(// full size
    {
        x: scrollWidth,
        y: scrollHeight
    }, // viewport size
    {
        x: width,
        y: height
    });
    const adjustedMaxScroll = {
        x: Math.max(0, maxScroll.x),
        y: Math.max(0, maxScroll.y)
    };
    return adjustedMaxScroll;
};

});


parcelRegister("feNdz", function(module, exports) {

$parcel$export(module.exports, "default", () => $31ea253008c58ece$export$2e2bcd8739ae039);
var // The browsers update document.documentElement.scrollTop and window.pageYOffset
// differently as the window scrolls.
// Webkit
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
// Chrome
// documentElement.scrollTop: update with fractional value
// window.pageYOffset: update with fractional value
// FireFox
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// IE11 (same as firefox)
// documentElement.scrollTop: updates to whole number
// window.pageYOffset: updates to whole number
// Edge (same as webkit)
// documentElement.scrollTop: no update. Stays at 0
// window.pageYOffset: updates to whole number
$31ea253008c58ece$export$2e2bcd8739ae039 = ()=>({
        x: window.pageXOffset,
        y: window.pageYOffset
    });

});




parcelRegister("5ZW09", function(module, exports) {

$parcel$export(module.exports, "AsyncAdminInaccessibleBoard", () => $bcf1c6c59cc68dbc$export$516550003e785216);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $bcf1c6c59cc68dbc$var$AdminInaccessibleBoard = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("gDwkl")), {
    ssr: false,
    moduleId: "./src/packages/software/admin-inaccessible-board/src/ui/main.tsx"
});
const $bcf1c6c59cc68dbc$export$516550003e785216 = (props)=>{
    const Skeleton = props.skeleton;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        packageName: "jiraAdminInaccessibleBoard",
        id: "async-admin-inaccessible-board",
        sendToPrivacyUnsafeSplunk: true,
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "admin-inaccessible-board",
        fallback: Skeleton && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Skeleton, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($bcf1c6c59cc68dbc$var$AdminInaccessibleBoard, props)));
};

});
parcelRegister("gDwkl", function(module, exports) {

let $c1c95d6168a4dd52$var$load = (parcelRequire("28QjX"))(4);
module.exports = $c1c95d6168a4dd52$var$load("3fI2Z").then(()=>parcelRequire('2Bz5k'));

});


parcelRegister("hP2lu", function(module, exports) {

$parcel$export(module.exports, "useShouldShowAdminInaccessibleBoard", () => $7a289048e0431de9$export$1a15223f3cf409b4);

var $3vXOY = parcelRequire("3vXOY");

var $itmJb = parcelRequire("itmJb");

var $2YP9W = parcelRequire("2YP9W");
const $7a289048e0431de9$export$1a15223f3cf409b4 = (resource)=>{
    const isAdmin = (0, $itmJb.useIsAdmin)();
    const data = (0, $2YP9W.useResource)(resource);
    const statusCode = data.error ? (0, $3vXOY.extractStatusCode)(data.error) : null;
    return isAdmin && statusCode === 404;
};

});

// We need to move away from using these variables directly as it results in a brittle hard to evolve system.
// This doesn't use @atlassian/jira-navigation-system as it results in a hard-to-debug cycle.
// These variables are inlined to reduce TS Complexity - Please reach out to #help-jfp-squads if you need more information.
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT = 'var(--bannerHeight, 0px)';
const $81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT = 'var(--topNavigationHeight, 0px)';
const $81918a2ef6db1f93$export$638757b621fbf475 = `${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_TOP_NAVIGATION_HEIGHT} + ${$81918a2ef6db1f93$var$UNSAFE_DO_NOT_USE_BANNER_HEIGHT}`;
const $81918a2ef6db1f93$export$d60454526e2281af = `(${$81918a2ef6db1f93$export$638757b621fbf475})`;

parcelRegister("7Q2kM", function(module, exports) {

$parcel$export(module.exports, "DevDetailsDialogLoaderAsync", () => $1e951f8230b07137$export$f5ffc0f323543e16);
$parcel$export(module.exports, "default", () => $1e951f8230b07137$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $1e951f8230b07137$var$DevDetailDialogLoaderWithContainer = (0, $kxZPA.lazy)(()=>(parcelRequire("yNiJl")), {
    ssr: false,
    moduleId: "./src/packages/development/details-loader/src/ui/index-old.tsx"
});
const $1e951f8230b07137$export$f5ffc0f323543e16 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "dev-detail-dialog-loader-with-container",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($1e951f8230b07137$var$DevDetailDialogLoaderWithContainer, props));
$1e951f8230b07137$export$f5ffc0f323543e16.defaultProps = {
    onCloseDevDetailDialog: (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz)))
};
var $1e951f8230b07137$export$2e2bcd8739ae039 = $1e951f8230b07137$export$f5ffc0f323543e16;

});
parcelRegister("yNiJl", function(module, exports) {

let $06896b433283881c$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $06896b433283881c$var$load("76n7a"),
    $06896b433283881c$var$load("l253H"),
    $06896b433283881c$var$load("drDbh")
]).then(()=>parcelRequire('26nI6'));

});


parcelRegister("iepkZ", function(module, exports) {

$parcel$export(module.exports, "AsyncLaunchToolchainSpotlight", () => $744e85c113b2a238$export$9ef3659da7a0bb31);

var $5uXOq = parcelRequire("5uXOq");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $744e85c113b2a238$var$ContainerLinking = (0, $kxZPA.lazy)(()=>(parcelRequire("AGoOb")), {
    moduleId: "./src/packages/devops/launch-toolchain-spotlight/src/ui/main.tsx"
});
const $744e85c113b2a238$export$9ef3659da7a0bb31 = ({ projectId: projectId, projectKey: projectKey })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "cotainer-linking",
        fallback: null
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($744e85c113b2a238$var$ContainerLinking, {
        projectId: projectId,
        projectKey: projectKey
    }));

});
parcelRegister("AGoOb", function(module, exports) {

let $06e4407e1cf7fd75$var$load = (parcelRequire("28QjX"))(4);
module.exports = $06e4407e1cf7fd75$var$load("kxSRI").then(()=>parcelRequire('ikW1t'));

});


parcelRegister("22vqd", function(module, exports) {

$parcel$export(module.exports, "ViewSettingsSpotlightContainer", () => $9998ac09b293c088$export$36e4c70f2ffee21d);

var $5uXOq = parcelRequire("5uXOq");

var $1QiBP = parcelRequire("1QiBP");

var $cgL5K = parcelRequire("cgL5K");

var $eGLgs = parcelRequire("eGLgs");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $ipmBb = parcelRequire("ipmBb");

var $ehdJY = parcelRequire("ehdJY");

var $2YP9W = parcelRequire("2YP9W");

var $axmY8 = parcelRequire("axmY8");

var $1v6HV = parcelRequire("1v6HV");

var $ht7qk = parcelRequire("ht7qk");
const $9998ac09b293c088$var$ViewSettingsSpotlightContainerInner = ({ onStop: onStop })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const clickedOnNext = (0, $5uXOq.useRef)(false);
    const hadInitSpotlight = (0, $5uXOq.useRef)(false);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const [{ activeViewSettingsSpotlight: activeViewSettingsSpotlight, hasViewedViewSettingsSpotlight: hasViewedViewSettingsSpotlight, openViewSettings: openViewSettings }, { onViewSettingsSpotlightInit: onViewSettingsSpotlightInit, onViewSettingsSpotlightNext: onViewSettingsSpotlightNext, onViewSettingsSpotlightEnd: onViewSettingsSpotlightEnd }] = (0, $1v6HV.useBoardWorkSuggestionsSpotlightContainer)();
    const fireAnalytic = (action)=>{
        (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
            actionSubject: 'button',
            action: 'clicked'
        }), `${(0, $axmY8.NEXT_BEST_TASK_ANALYTICS)}.spotlight.action`, {
            action: action
        });
    };
    const end = (action)=>{
        fireAnalytic(action);
        onViewSettingsSpotlightEnd();
        onStop?.();
    };
    const next = ()=>{
        fireAnalytic('next');
        if (clickedOnNext.current) // Don't want user to click on multiple times and re-trigger this.
        return;
        if (openViewSettings) {
            openViewSettings();
            // It has problem with view settings popup (not panel),
            // if we are not adding setTimeout in here for some reason
            setTimeout(()=>{
                onViewSettingsSpotlightNext();
            });
        }
        clickedOnNext.current = true;
    };
    const shouldIgnoreSpotlight = activeViewSettingsSpotlight === null || hasViewedViewSettingsSpotlight;
    (0, $5uXOq.useEffect)(()=>{
        // If we render this component we will set has view spotlight to false
        if (hasViewedViewSettingsSpotlight && !hadInitSpotlight.current) {
            onViewSettingsSpotlightInit();
            hadInitSpotlight.current = true;
        }
    }, [
        hasViewedViewSettingsSpotlight,
        onViewSettingsSpotlightInit
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!shouldIgnoreSpotlight) (0, $8zOmE.fireScreenAnalytics)(createAnalyticsEvent({}), {
            step: activeViewSettingsSpotlight + 1
        });
    }, [
        createAnalyticsEvent,
        shouldIgnoreSpotlight,
        activeViewSettingsSpotlight
    ]);
    const renderWorkSuggestionsSpotlight = ()=>{
        if (shouldIgnoreSpotlight) return null;
        const spotlights = [
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                // if no onOpenViewSettings callback only show one step and end
                actionsBeforeElement: openViewSettings ? '1/2' : '1/1',
                actions: openViewSettings ? [
                    // If we have view settings open callback show next button
                    // otherwise show ok button
                    {
                        onClick: ()=>next(),
                        text: formatMessage((0, $ht7qk.default).next)
                    }
                ] : [
                    {
                        onClick: ()=>end('dismiss'),
                        text: formatMessage((0, $ht7qk.default).dismiss)
                    }
                ],
                target: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME),
                key: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_PANEL_NAME),
                dialogPlacement: "right top",
                targetRadius: 8,
                messageId: "insights-next-best-task.ui.view-settings-spotlight.jira-spotlight",
                messageType: "engagement"
            }, formatMessage((0, $ht7qk.default).workSuggestionsViewSettingsPanelSpotlight)),
            /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ehdJY.JiraSpotlight), {
                actionsBeforeElement: "2/2",
                actions: [
                    {
                        onClick: ()=>end('ok'),
                        text: formatMessage((0, $ht7qk.default).ok)
                    }
                ],
                target: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME),
                key: (0, $axmY8.WORK_SUGGESTIONS_VIEW_SETTINGS_SPOTLIGHT_VIEW_SETTINGS_STEP_NAME),
                targetRadius: 3,
                targetBgColor: "var(--ds-background-input, #FFFFFF)",
                dialogPlacement: "bottom right",
                messageId: "insights-next-best-task.ui.view-settings-spotlight.jira-spotlight.1",
                messageType: "engagement"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                as: "span"
            }, formatMessage((0, $ht7qk.default).workSuggestionsViewSettingsSettingsSpotlight, {
                b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
                        weight: "bold",
                        as: "strong"
                    }, chunks)
            })))
        ];
        return spotlights[activeViewSettingsSpotlight];
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, !hasViewedViewSettingsSpotlight && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1QiBP.default), null, renderWorkSuggestionsSpotlight()));
};
const $9998ac09b293c088$export$83d026e3dd5706d = ({ stop: stop, children: children })=>children(stop);
const $9998ac09b293c088$export$36e4c70f2ffee21d = ({ children: children, shouldShowSpotlight: shouldShowSpotlight })=>{
    const { data: isWorkSuggestionsEnabledData, loading: loadingWorkSuggestionsEnabled } = (0, $2YP9W.useResource)((0, $ipmBb.nextBestTaskFeatureResource));
    const hadOptedIn = !!isWorkSuggestionsEnabledData?.hasUserOptedIn;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1v6HV.BoardWorkSuggestionsSpotlightContainer), null, children, shouldShowSpotlight && !loadingWorkSuggestionsEnabled && hadOptedIn && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eGLgs.default), {
        messageId: (0, $axmY8.WORK_SUGGESTIONS_SPOTLIGHT_MESSAGE_ID),
        messageType: "engagement"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9998ac09b293c088$export$83d026e3dd5706d, null, (stop)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
            sourceName: "workSuggestionsSpotlight",
            sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($9998ac09b293c088$var$ViewSettingsSpotlightContainerInner, {
            onStop: stop
        })))));
};

});
parcelRegister("ht7qk", function(module, exports) {

$parcel$export(module.exports, "default", () => $c0429fecf856e9c0$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $c0429fecf856e9c0$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    workSuggestionsViewSettingsPanelSpotlight: {
        "id": "insights-next-best-task.view-settings-spotlight.work-suggestions-view-settings-panel-spotlight",
        "defaultMessage": "If we have suggestions for what you can work on next, you\u2019ll see them on the board when you select your avatar."
    },
    workSuggestionsViewSettingsSettingsSpotlight: {
        "id": "insights-next-best-task.view-settings-spotlight.work-suggestions-view-settings-settings-spotlight",
        "defaultMessage": "To switch <b>Work suggestions</b> on or off, use the toggle in <b>View settings</b>."
    },
    next: {
        "id": "insights-next-best-task.view-settings-spotlight.next",
        "defaultMessage": "Next"
    },
    ok: {
        "id": "insights-next-best-task.view-settings-spotlight.ok",
        "defaultMessage": "OK"
    },
    dismiss: {
        "id": "insights-next-best-task.view-settings-spotlight.dismiss",
        "defaultMessage": "Dismiss"
    }
});

});


parcelRegister("b052x", function(module, exports) {

$parcel$export(module.exports, "IssueLinksHandlerContainer", () => $bda04b2b06c21a24$export$a3ee14e17fe2bf67);
$parcel$export(module.exports, "useOnIssueOpen", () => $bda04b2b06c21a24$export$9bb7155db54ab61f);
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state

var $gg7kZ = parcelRequire("gg7kZ");
var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $bda04b2b06c21a24$export$d4c72bab9d6cc13a = {
    // Replace with lodash/noop
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    onIssueOpen: ()=>{}
};
const $bda04b2b06c21a24$var$actions = {};
const $bda04b2b06c21a24$export$6f57813fe9f31bf9 = (0, $iXqE5.createStore)({
    initialState: $bda04b2b06c21a24$export$d4c72bab9d6cc13a,
    actions: $bda04b2b06c21a24$var$actions,
    name: 'issue-links-handler-store'
});
const $bda04b2b06c21a24$var$onPropsChange = ({ setState: setState }, { onIssueOpen: onIssueOpen })=>{
    setState({
        onIssueOpen: onIssueOpen
    });
};
const $bda04b2b06c21a24$export$a3ee14e17fe2bf67 = (0, $gg7kZ.createContainer)($bda04b2b06c21a24$export$6f57813fe9f31bf9, {
    onInit: ()=>$bda04b2b06c21a24$var$onPropsChange,
    onUpdate: ()=>$bda04b2b06c21a24$var$onPropsChange
});
const $bda04b2b06c21a24$export$9bb7155db54ab61f = (0, $3sQ5x.createStateHook)($bda04b2b06c21a24$export$6f57813fe9f31bf9, {
    selector: (state)=>state.onIssueOpen
});

});

parcelRegister("jqUpd", function(module, exports) {

$parcel$export(module.exports, "planIssueModal", () => $5f9b3fe3781cec99$export$3975a421a6ca7502);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $5f9b3fe3781cec99$export$3975a421a6ca7502 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("21Pvm")).then((module)=>module.AsyncPlanIssueModal), {
        moduleId: "6c079fa3"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("21Pvm", function(module, exports) {

let $17a3a092502534b8$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $17a3a092502534b8$var$load("fliVL"),
    $17a3a092502534b8$var$load("ffQaD"),
    $17a3a092502534b8$var$load("kvRbA"),
    $17a3a092502534b8$var$load("76n7a"),
    $17a3a092502534b8$var$load("l253H"),
    $17a3a092502534b8$var$load("jTe76")
]).then(()=>parcelRequire('hPbBf'));

});


parcelRegister("5fQw9", function(module, exports) {

$parcel$export(module.exports, "default", () => $9cbb5d72cb5df9c7$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7CMCs = parcelRequire("7CMCs");

var $ijYb7 = parcelRequire("ijYb7");
const $9cbb5d72cb5df9c7$var$App = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "app",
        packageName: "jiraSoftwareIssueLimitFlags",
        teamName: "a4t-tanuki",
        fallback: "flag"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ijYb7.IssueLimitFlags), props));
var $9cbb5d72cb5df9c7$export$2e2bcd8739ae039 = $9cbb5d72cb5df9c7$var$App;

});
parcelRegister("ijYb7", function(module, exports) {

$parcel$export(module.exports, "ISSUE_APPROACHING_LIMIT", () => $07c13de1d345d403$export$998713d4130be32d);
$parcel$export(module.exports, "IssueLimitFlags", () => $07c13de1d345d403$export$739da16e22409e4d);

var $5uXOq = parcelRequire("5uXOq");

var $e2T54 = parcelRequire("e2T54");

var $ir9Ry = parcelRequire("ir9Ry");
const $07c13de1d345d403$export$998713d4130be32d = 4500;
const $07c13de1d345d403$var$ISSUE_REACHED_LIMIT = 5000;
const $07c13de1d345d403$export$739da16e22409e4d = ({ isProjectAdmin: isProjectAdmin, ...flagProps })=>{
    const [limitReachedFlagShown, setLimitReachedFlagShown] = (0, $5uXOq.useState)(false);
    const limitReachedViews = flagProps.views.filter((view)=>view.issueCount >= $07c13de1d345d403$var$ISSUE_REACHED_LIMIT);
    const limitApproachingViews = flagProps.views.filter((view)=>view.issueCount >= $07c13de1d345d403$export$998713d4130be32d && view.issueCount < $07c13de1d345d403$var$ISSUE_REACHED_LIMIT);
    const shouldShowLimitReachedFlag = limitReachedViews.length > 0;
    const shouldShowLimitApproachingFlag = limitApproachingViews.length > 0 && !limitReachedFlagShown;
    (0, $5uXOq.useEffect)(()=>{
        if (shouldShowLimitReachedFlag && !limitReachedFlagShown) setLimitReachedFlagShown(true);
    }, [
        limitReachedFlagShown,
        shouldShowLimitReachedFlag
    ]);
    // Check to ensure permission is defined. If value is not boolean, then it likely
    // means it has not yet been loaded
    if (typeof isProjectAdmin !== 'boolean') return null;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, shouldShowLimitApproachingFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e2T54.LimitApproachingFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitApproachingViews
    }), shouldShowLimitReachedFlag && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ir9Ry.LimitReachedFlag), {
        ...flagProps,
        isProjectAdmin: isProjectAdmin,
        views: limitReachedViews
    }));
};

});
parcelRegister("e2T54", function(module, exports) {

$parcel$export(module.exports, "LimitApproachingFlag", () => $da6681a9a2d62d46$export$c8f47c0b0c12451c);

var $5uXOq = parcelRequire("5uXOq");

var $1jWct = parcelRequire("1jWct");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $8g67F = parcelRequire("8g67F");

var $bvUMO = parcelRequire("bvUMO");
const $da6681a9a2d62d46$var$LIMIT_APPROACHING_FLAG_ID = 'jsw-issue-approaching-reached-flag';
const $da6681a9a2d62d46$export$c8f47c0b0c12451c = ({ isCMP: isCMP, isProjectAdmin: isProjectAdmin, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const flagActions = (0, $8g67F.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'approaching'
    });
    const views = flagViews.map((v)=>v.view);
    (0, $5uXOq.useEffect)(()=>{
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $bvUMO.default).boardLimitApproachingFlagTitle : (0, $bvUMO.default).backlogLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagTitle;
            if (views.includes('BACKLOG')) return (0, $bvUMO.default).tmpBacklogLimitApproachingFlagTitle;
            if (views.includes('SPRINTS')) return (0, $bvUMO.default).tmpSprintsLimitApproachingFlagTitle;
            if (views.includes('BOARD')) return (0, $bvUMO.default).boardLimitApproachingFlagTitle;
            return (0, $bvUMO.default).boardLimitApproachingFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') {
                    const boardLimitApproachingAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).boardLimitApproachingAdminFlagBodyIssueTermRefresh : (0, $bvUMO.default).boardLimitApproachingAdminFlagBody;
                    const boardLimitApproachingEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).boardLimitApproachingEndUserFlagBodyIssueTermRefresh : (0, $bvUMO.default).boardLimitApproachingEndUserFlagBody;
                    return isProjectAdmin ? boardLimitApproachingAdminFlagBodyMessage : boardLimitApproachingEndUserFlagBodyMessage;
                }
                const backlogLimitApproachingAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).backlogLimitApproachingAdminFlagBodyIssueTermRefresh : (0, $bvUMO.default).backlogLimitApproachingAdminFlagBody;
                const backlogLimitApproachingEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).backlogLimitApproachingEndUserFlagBodyIssueTermRefresh : (0, $bvUMO.default).backlogLimitApproachingEndUserFlagBody;
                return isProjectAdmin ? backlogLimitApproachingAdminFlagBodyMessage : backlogLimitApproachingEndUserFlagBodyMessage;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogSprintsLimitApproachingFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogBoardLimitApproachingFlagBody;
            if (views.includes('BACKLOG')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBacklogLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBacklogLimitApproachingFlagBody;
            if (views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpSprintsLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpSprintsLimitApproachingFlagBody;
            if (views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBoardLimitApproachingFlagBody;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $bvUMO.default).tmpBoardLimitApproachingFlagBodyIssueTermRefresh : (0, $bvUMO.default).tmpBoardLimitApproachingFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                messageId: 'software-issue-limit-flags.ui.limit-approaching-flag.show-flag.info',
                messageType: 'transactional',
                id: $da6681a9a2d62d46$var$LIMIT_APPROACHING_FLAG_ID,
                type: 'info',
                title: flagTitle,
                description: flagDescription,
                isAutoDismiss: false,
                actions: flagActions,
                icon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($1jWct))), {
                    spacing: "spacious",
                    color: "var(--ds-icon-information, #1D7AFC)",
                    label: ""
                }),
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitApproachingFlag');
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitApproachingFlag');
        }
        setFlagShown(true);
    }, [
        showFlag,
        isProjectAdmin,
        flagActions,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        views
    ]);
    return null;
};

});
parcelRegister("8g67F", function(module, exports) {

$parcel$export(module.exports, "useFlagActions", () => $fc75b95d4a7d68f1$export$38e4a892c359139d);

var $5uXOq = parcelRequire("5uXOq");

var $6s1PB = parcelRequire("6s1PB");

var $e5wyW = parcelRequire("e5wyW");

var $5Zxxp = parcelRequire("5Zxxp");

var $8zOmE = parcelRequire("8zOmE");

var $fR4iU = parcelRequire("fR4iU");
const $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL = 'https://support.atlassian.com/jira-software-cloud/docs/issue-limits-in-company-managed-projects/';
const $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID = '1KMwTxMBNiDPhaHMDlfT4u';
function $fc75b95d4a7d68f1$export$d53148a666867fe1(flagSource) {
    return {
        content: (0, $fR4iU.default).editFilterCta,
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        href: `${window.location.pathname}?config=filter`,
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'editBoardFilter', {
                flagSource: flagSource
            });
        }
    };
}
function $fc75b95d4a7d68f1$export$72a228c0f924aef1(flagSource) {
    return {
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh : (0, $fR4iU.default).viewMoreInfoCta,
        href: $fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_SUPPORT_ARTICLE_URL,
        target: '_blank',
        onClick: (_, analyticsEvent)=>{
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitSupportArticle', {
                flagSource: flagSource
            });
        }
    };
}
function $fc75b95d4a7d68f1$export$d49a14b48e551259(flagSource, setIPHArticleId) {
    return {
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh : (0, $fR4iU.default).viewMoreInfoCta,
        onClick: (_, analyticsEvent)=>{
            setIPHArticleId($fc75b95d4a7d68f1$var$CMP_ISSUE_LIMIT_IPH_ARTICLE_ID);
            if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'cmpIssueLimitIph', {
                flagSource: flagSource
            });
        }
    };
}
const $fc75b95d4a7d68f1$export$226a1330ff7e389b = (projectKey)=>({
        content: (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $fR4iU.default).seeIssuesInSearchCtaIssueTermRefresh : (0, $fR4iU.default).seeIssuesInSearchCta,
        href: `/issues/?jql=${encodeURIComponent(`project = ${projectKey} ORDER BY rank ASC`)}`
    });
const $fc75b95d4a7d68f1$var$selector = (0, $e5wyW.functionWithCondition)(()=>(0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false), ()=>({
        content: (0, $fR4iU.default).viewMoreInfoCtaIssueTermRefresh,
        href: 'TBD'
    }), ()=>({
        content: (0, $fR4iU.default).viewMoreInfoCta,
        href: 'TBD'
    }));
const $fc75b95d4a7d68f1$export$2ca20f1de5f009d2 = $fc75b95d4a7d68f1$var$selector();
const $fc75b95d4a7d68f1$export$38e4a892c359139d = ({ isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, flagType: flagType })=>{
    const setIPHArticleId = (0, $5Zxxp.useHelpPanelLink)();
    const flagSource = flagType === 'approaching' ? 'jswIssueLimitApproachingFlag' : 'jswIssueLimitReachedFlag';
    return (0, $5uXOq.useMemo)(()=>{
        if (isCMP) {
            if (isProjectAdmin) return [
                $fc75b95d4a7d68f1$export$d53148a666867fe1(flagSource),
                $fc75b95d4a7d68f1$export$d49a14b48e551259(flagSource, setIPHArticleId)
            ];
            return [
                $fc75b95d4a7d68f1$export$72a228c0f924aef1(flagSource)
            ];
        }
        return [
            $fc75b95d4a7d68f1$export$226a1330ff7e389b(projectKey),
            $fc75b95d4a7d68f1$export$2ca20f1de5f009d2
        ];
    }, [
        isCMP,
        projectKey,
        isProjectAdmin,
        flagSource,
        setIPHArticleId
    ]);
};

});
parcelRegister("fR4iU", function(module, exports) {

$parcel$export(module.exports, "default", () => $8a85e2fb64f1664f$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8a85e2fb64f1664f$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    editFilterCta: {
        "id": "software-issue-limit-flags.common.edit-filter-cta",
        "defaultMessage": "Edit filter"
    },
    viewMoreInfoCta: {
        "id": "software-issue-limit-flags.common.view-more-info-cta",
        "defaultMessage": "More about issue limits"
    },
    seeIssuesInSearchCta: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta",
        "defaultMessage": "See issues in search"
    },
    viewMoreInfoCtaIssueTermRefresh: {
        "id": "software-issue-limit-flags.common.view-more-info-cta-issue-term-refresh",
        "defaultMessage": "More about work item limits "
    },
    seeIssuesInSearchCtaIssueTermRefresh: {
        "id": "software-issue-limit-flags.common.see-issues-in-search-cta-issue-term-refresh",
        "defaultMessage": "See everything in search"
    }
});

});


parcelRegister("bvUMO", function(module, exports) {

$parcel$export(module.exports, "default", () => $ae0496ade39ae6cf$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $ae0496ade39ae6cf$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    backlogLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-flag-title",
        "defaultMessage": "Your board is almost full"
    },
    boardLimitApproachingAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body",
        "defaultMessage": "The board can display up to 5000 issues. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBacklogLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-title",
        "defaultMessage": "Your backlog is almost full"
    },
    tmpSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your sprint section is almost full"
    },
    tmpBacklogSprintsLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and sprint sections are almost full"
    },
    tmpBacklogBoardLimitApproachingFlagTitle: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-title",
        "defaultMessage": "Your backlog and board sections are almost full"
    },
    tmpBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body",
        "defaultMessage": "The board can only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body",
        "defaultMessage": "The backlog can display up to 5000 issues. It might be time to move some issues."
    },
    tmpSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body",
        "defaultMessage": "We can only display up to 5000 issues across all your sprints. It might be time to move some issues."
    },
    tmpBacklogSprintsLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    tmpBacklogBoardLimitApproachingFlagBody: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 issues. It might be time to move some issues."
    },
    backlogLimitApproachingAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 work items. Edit your board filter to refine what's included and excluded."
    },
    backlogLimitApproachingEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.backlog-limit-approaching-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 work items. The admin who created the board filter can refine what's included and excluded."
    },
    boardLimitApproachingAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The board can display up to 5000 work items. Edit your board filter to refine what's included and excluded."
    },
    boardLimitApproachingEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.board-limit-approaching-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The board can display up to 5000 work items. The admin who created the board filter can refine what's included and excluded."
    },
    tmpBoardLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-board-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display up to 5000 work items. It might be time to move some work."
    },
    tmpBacklogLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can display up to 5000 work items. It might be time to move some work."
    },
    tmpSprintsLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-sprints-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "We can only display up to 5000 work items across all your sprints. It might be time to move some work."
    },
    tmpBacklogSprintsLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-sprints-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and sprint sections can each only display up to 5000 work items. It might be time to move some work."
    },
    tmpBacklogBoardLimitApproachingFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-approaching-flag.tmp-backlog-board-limit-approaching-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and board sections can each only display up to 5000 work items. It might be time to move some work."
    }
});

});


parcelRegister("ir9Ry", function(module, exports) {

$parcel$export(module.exports, "LimitReachedFlag", () => $48372b37d055d7b1$export$b4f3bdfaaded5337);

var $a6ceQ = parcelRequire("a6ceQ");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $1WQct = parcelRequire("1WQct");

var $6s1PB = parcelRequire("6s1PB");

var $pa9q9 = parcelRequire("pa9q9");

var $koVbs = parcelRequire("koVbs");

var $8zOmE = parcelRequire("8zOmE");
var $2NMNM = parcelRequire("2NMNM");

var $9OXo1 = parcelRequire("9OXo1");

var $8g67F = parcelRequire("8g67F");

var $lSfuc = parcelRequire("lSfuc");
const $48372b37d055d7b1$var$LIMIT_REACHED_FLAG_ID = 'jsw-issue-limit-reached-flag';
const $48372b37d055d7b1$export$b4f3bdfaaded5337 = ({ boardId: boardId, isProjectAdmin: isProjectAdmin, isCMP: isCMP, projectKey: projectKey, views: flagViews })=>{
    const [flagShown, setFlagShown] = (0, $5uXOq.useState)(false);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagService)();
    const { cloudId: cloudId } = (0, $9OXo1.useTenantContext)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const views = flagViews.map((flagView)=>flagView.view);
    const shouldFetchTotalCount = views.length === 1 && [
        'BACKLOG',
        'BOARD'
    ].includes(views[0]);
    const data = (0, $8Uumt.useLazyLoadQuery)((0, $a6ceQ.default), {
        cloudId: cloudId,
        issueSearchInput: {
            customInput: {
                jiraSoftwareInput: {
                    context: views[0] === 'BOARD' ? 'BOARD' : 'BACKLOG',
                    jiraEntityId: (0, $1WQct.JiraSoftwareBoardAri).create({
                        boardId: boardId.toString(),
                        siteId: cloudId
                    }).toString()
                }
            }
        },
        skip: !shouldFetchTotalCount
    }, {
        fetchPolicy: 'network-only'
    });
    const totalCount = data.jira?.issueSearchTotalCount;
    const flagActions = (0, $8g67F.useFlagActions)({
        isProjectAdmin: isProjectAdmin,
        isCMP: isCMP,
        projectKey: projectKey,
        flagType: 'reached'
    });
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchTotalCount && typeof totalCount !== 'number') return;
        const getFlagTitle = ()=>{
            if (isCMP) return views[0] === 'BOARD' ? (0, $lSfuc.default).boardLimitReachedFlagTitle : (0, $lSfuc.default).backlogLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagTitle;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagTitle;
            if (views.includes('BACKLOG')) return (0, $lSfuc.default).tmpBacklogLimitReachedFlagTitle;
            if (views.includes('SPRINTS')) return (0, $lSfuc.default).tmpSprintsLimitReachedFlagTitle;
            if (views.includes('BOARD')) return (0, $lSfuc.default).boardLimitReachedFlagTitle;
            return (0, $lSfuc.default).boardLimitReachedFlagTitle;
        };
        const getFlagMessage = ()=>{
            if (isCMP) {
                if (views[0] === 'BOARD') {
                    const boardLimitReachedAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).boardLimitReachedAdminFlagBodyIssueTermRefresh : (0, $lSfuc.default).boardLimitReachedAdminFlagBody;
                    const boardLimitReachedEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).boardLimitReachedEndUserFlagBodyIssueTermRefresh : (0, $lSfuc.default).boardLimitReachedEndUserFlagBody;
                    return isProjectAdmin ? boardLimitReachedAdminFlagBodyMessage : boardLimitReachedEndUserFlagBodyMessage;
                }
                const backlogLimitReachedAdminFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).backlogLimitReachedAdminFlagBodyIssueTermRefresh : (0, $lSfuc.default).backlogLimitReachedAdminFlagBody;
                const backlogLimitReachedEndUserFlagBodyMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).backlogLimitReachedEndUserFlagBodyIssueTermRefresh : (0, $lSfuc.default).backlogLimitReachedEndUserFlagBody;
                return isProjectAdmin ? backlogLimitReachedAdminFlagBodyMessage : backlogLimitReachedEndUserFlagBodyMessage;
            }
            if (views.includes('BACKLOG') && views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogSprintsLimitReachedFlagBody;
            if (views.includes('BACKLOG') && views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogBoardLimitReachedFlagBody;
            if (views.includes('BACKLOG')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBacklogLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBacklogLimitReachedFlagBody;
            if (views.includes('SPRINTS')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpSprintsLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpSprintsLimitReachedFlagBody;
            if (views.includes('BOARD')) return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBoardLimitReachedFlagBody;
            return (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $lSfuc.default).tmpBoardLimitReachedFlagBodyIssueTermRefresh : (0, $lSfuc.default).tmpBoardLimitReachedFlagBody;
        };
        const flagTitle = getFlagTitle();
        const flagDescription = getFlagMessage();
        if (!flagShown) {
            showFlag({
                messageId: 'software-issue-limit-flags.ui.limit-reached-flag.show-flag.warning',
                messageType: 'transactional',
                id: $48372b37d055d7b1$var$LIMIT_REACHED_FLAG_ID,
                type: 'warning',
                title: flagTitle,
                description: formatMessage(flagDescription, {
                    issueCount: totalCount
                }),
                isAutoDismiss: false,
                actions: flagActions,
                onDismissed: (_, analyticsEvent)=>{
                    if (analyticsEvent) (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'jswIssueLimitReachedFlag', {
                        totalIssueCount: totalCount
                    });
                }
            });
            (0, $8zOmE.fireTrackAnalytics)(createAnalyticsEvent({}), 'flag shown', 'jswIssueLimitReachedFlag', {
                totalIssueCount: totalCount
            });
            setFlagShown(true);
        }
    }, [
        formatMessage,
        showFlag,
        isProjectAdmin,
        flagActions,
        totalCount,
        flagShown,
        createAnalyticsEvent,
        isCMP,
        shouldFetchTotalCount,
        views
    ]);
    return null;
};

});
parcelRegister("a6ceQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $e6258a09992b1b59$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<f0e08b1c167d3c20088a2c2a02e0608d>>
 * @relayHash 16968863187b798a94c81fb2f3c02587
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256
const $e6258a09992b1b59$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "cloudId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "issueSearchInput"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "skip"
        }
    ], v1 = [
        {
            "condition": "skip",
            "kind": "Condition",
            "passingValue": false,
            "selections": [
                {
                    "concreteType": "JiraQuery",
                    "kind": "LinkedField",
                    "name": "jira",
                    "plural": false,
                    "selections": [
                        {
                            "args": [
                                {
                                    "kind": "Variable",
                                    "name": "cloudId",
                                    "variableName": "cloudId"
                                },
                                {
                                    "kind": "Variable",
                                    "name": "issueSearchInput",
                                    "variableName": "issueSearchInput"
                                }
                            ],
                            "kind": "ScalarField",
                            "name": "issueSearchTotalCount"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "limitReachedFlagTotalIssueCountQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "id": "1d92172fafa12a38c14a21764204ae490c41baf36eb55b3ec10622230a6ef256",
            "metadata": {},
            "name": "limitReachedFlagTotalIssueCountQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$e6258a09992b1b59$var$node.hash = "1b2bcb6691b0c1b0f0f93eb3b32f4323";
var $e6258a09992b1b59$export$2e2bcd8739ae039 = $e6258a09992b1b59$var$node;

});

parcelRegister("lSfuc", function(module, exports) {

$parcel$export(module.exports, "default", () => $3cabc45eb3d95785$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $3cabc45eb3d95785$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    backlogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    backlogLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-flag-title",
        "defaultMessage": "Your board is full"
    },
    boardLimitReachedAdminFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBacklogSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-title",
        "defaultMessage": "Your backlog and sprint sections are full"
    },
    tmpSprintsLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-title",
        "defaultMessage": "Your sprint section is full"
    },
    tmpBacklogLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-title",
        "defaultMessage": "Your backlog is full"
    },
    tmpBacklogBoardLimitReachedFlagTitle: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-title",
        "defaultMessage": "Your backlog and board sections are full"
    },
    tmpBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body",
        "defaultMessage": "The board can only display 5000 issues, and your current board contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 issues. It's time to move some issues."
    },
    tmpSprintsLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body",
        "defaultMessage": "We can only display 5000 issues across all your sprints. It's time to move some issues."
    },
    tmpBacklogLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body",
        "defaultMessage": "The backlog can only display 5000 issues, and your current backlog contains {issueCount}. It's time to move some issues."
    },
    tmpBacklogBoardLimitReachedFlagBody: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body",
        "defaultMessage": "Your backlog and board sections can each only display 5000 issues. It's time to move some issues."
    },
    backlogLimitReachedAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 work items, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    backlogLimitReachedEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.backlog-limit-reached-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 work items, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    boardLimitReachedAdminFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-admin-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 work items, and your current filter contains {issueCount}. Edit your filter to refine what's included and excluded."
    },
    boardLimitReachedEndUserFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.board-limit-reached-end-user-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 work items, and the current filter contains {issueCount}. An admin will need to edit the board filter to refine what's included and excluded."
    },
    tmpBoardLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-board-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "The board can only display 5000 work items, and your current board contains {issueCount}. It's time to move some work."
    },
    tmpBacklogSprintsLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-sprints-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and sprint sections can each only display 5000 work items. It's time to move some work."
    },
    tmpSprintsLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-sprints-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "We can only display 5000 work items across all your sprints. It's time to move some work."
    },
    tmpBacklogLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "The backlog can only display 5000 work items, and your current backlog contains {issueCount}. It's time to move some work."
    },
    tmpBacklogBoardLimitReachedFlagBodyIssueTermRefresh: {
        "id": "software-issue-limit-flags.limit-reached-flag.tmp-backlog-board-limit-reached-flag-body-issue-term-refresh",
        "defaultMessage": "Your backlog and board sections can each only display 5000 work items. It's time to move some work."
    }
});

});




parcelRegister("9hLEH", function(module, exports) {

$parcel$export(module.exports, "default", () => $25af9d0222a23099$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $25af9d0222a23099$var$LazyProjectKeyboardShortcuts = (0, $kxZPA.lazy)(()=>(parcelRequire("kGfv3")), {
    moduleId: "./src/packages/software/keyboard-shortcuts/src/ui/project-shortcuts/main.tsx"
});
/**
 * Binds keyboard shortcuts to navigate to the respective experience when enabled:
 * 1 - Backlog
 * 2 - Board
 * 3 - Reports
 * 4 - Timeline
 */ const $25af9d0222a23099$var$ProjectKeyboardShortcuts = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: "jira-software-keyboard-shortcuts-project-shortcuts",
        packageName: "jira-software-keyboard-shortcuts",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "jira-software-keyboard-shortcuts",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($25af9d0222a23099$var$LazyProjectKeyboardShortcuts, props)));
var $25af9d0222a23099$export$2e2bcd8739ae039 = $25af9d0222a23099$var$ProjectKeyboardShortcuts;

});
parcelRegister("kGfv3", function(module, exports) {

let $f0e3c0d8d61be037$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $f0e3c0d8d61be037$var$load("76n7a"),
    $f0e3c0d8d61be037$var$load("l253H"),
    $f0e3c0d8d61be037$var$load("2vWSI")
]).then(()=>parcelRequire('9pQJj'));

});


parcelRegister("4bO80", function(module, exports) {

$parcel$export(module.exports, "AsyncJiraStandups", () => $05fe86126f017ca6$export$ef4254228f6901a);

var $5uXOq = parcelRequire("5uXOq");

var $7XluA = parcelRequire("7XluA");

var $5E2gE = parcelRequire("5E2gE");

var $2k1C7 = parcelRequire("2k1C7");
const $05fe86126f017ca6$export$ef4254228f6901a = (props)=>{
    const { entryPointReferenceSubject: entryPointReferenceSubject } = (0, $5uXOq.useContext)((0, $5E2gE.StandupEntryPointContext));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        id: "jira-rituals-standups",
        packageName: "jiraRitualsStandups",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2k1C7.LoadingStandupPanel), null),
        entryPointReferenceSubject: entryPointReferenceSubject,
        runtimeProps: props
    });
};

});
parcelRegister("2k1C7", function(module, exports) {

$parcel$export(module.exports, "LoadingStandupPanel", () => $32c0a49d820a629b$export$e1d0857cb84b4ad3);

var $5uXOq = parcelRequire("5uXOq");

var $kgoHi = parcelRequire("kgoHi");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");
const $32c0a49d820a629b$export$e1d0857cb84b4ad3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kgoHi.default), {
        xcss: $32c0a49d820a629b$var$spinnerWrapperStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "large"
    }));
const $32c0a49d820a629b$var$spinnerWrapperStyles = (0, $8CUq3.xcss)({
    height: '100%',
    marginLeft: 'space.300',
    zIndex: 'card',
    minWidth: '272px',
    background: "var(--ds-surface, #FFFFFF)",
    borderRadius: 'border.radius.300',
    border: `1px solid ${"var(--ds-border, #091E4224)"}`,
    marginRight: 'space.negative.300',
    alignItems: 'center',
    justifyContent: 'center'
});

});


parcelRegister("3U6yu", function(module, exports) {

$parcel$export(module.exports, "StorageLimitsBanner", () => $281484b8f4d3a170$export$3250e2c90ae56dd9);

var $5uXOq = parcelRequire("5uXOq");

var $b71gk = parcelRequire("b71gk");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");


// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $281484b8f4d3a170$var$LazyStorageLimitBanner = (0, $kxZPA.lazyAfterPaint)(()=>(parcelRequire("kVI8q")), {
    ssr: false,
    moduleId: "./src/packages/growth/storage-limits/src/ui/index.tsx"
});
const $281484b8f4d3a170$export$3250e2c90ae56dd9 = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $b71gk.default), {
        id: (0, $59503b90ac06f221$export$5dec3c05c01dac30),
        packageName: (0, $59503b90ac06f221$export$b8b9d90f9e5bd72b),
        teamName: "growth-tako",
        render: ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "storage-limits-banner",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($281484b8f4d3a170$var$LazyStorageLimitBanner, props)));

});
const $59503b90ac06f221$export$bab748d4654ac4a5 = 0.9;
const $59503b90ac06f221$export$b8b9d90f9e5bd72b = 'jiraGrowthStorageLimits';
const $59503b90ac06f221$export$df9953733f41292a = 'storageLimitsBanner';
const $59503b90ac06f221$export$5dec3c05c01dac30 = 'asyncStorageLimitsBanner';
const $59503b90ac06f221$export$3aad3de2cc377789 = 'jira_software_free_is_ccp_billing_admins';

parcelRegister("kVI8q", function(module, exports) {

let $f3cb5dc84edc109f$var$load = (parcelRequire("28QjX"))(4);
module.exports = $f3cb5dc84edc109f$var$load("a5EaQ").then(()=>parcelRequire('iMYa9'));

});


parcelRegister("kJ1Ne", function(module, exports) {

$parcel$export(module.exports, "default", () => $ce599d26c9577203$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $i8Qvm = parcelRequire("i8Qvm");

var $8uFbT = parcelRequire("8uFbT");

var $4mO32 = parcelRequire("4mO32");

var $7XluA = parcelRequire("7XluA");

var $7CMCs = parcelRequire("7CMCs");

var $AeWM3 = parcelRequire("AeWM3");

var $aXhsp = parcelRequire("aXhsp");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $e43Es = parcelRequire("e43Es");

var $56rNw = parcelRequire("56rNw");

var $6P8fi = parcelRequire("6P8fi");

const $ce599d26c9577203$var$entryPointParams = {};
const $ce599d26c9577203$var$PublicFormChangeboardingModalRoot = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7CMCs.JSErrorBoundary), {
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: "unmount"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $AeWM3.ApolloClientProvider), {
        client: (0, $aXhsp.default)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ce599d26c9577203$var$PublicFormChangeboardingModalContainer, props))));
};
const $ce599d26c9577203$var$PublicFormChangeboardingModalContainer = ({ projectId: projectId })=>{
    const { isActive: isTriggerActive } = (0, $8uFbT.useTrigger)((0, $1a3ee76b747d2e0b$export$dc7ed530d378527));
    const data = (0, $e43Es.useGetData)({
        projectId: projectId,
        isEnabled: isTriggerActive && (0, $4R6GH.fg)('jira_forms_public_access_changeboarding_gate')
    });
    const hasLoadedEntrypoint = (0, $5uXOq.useRef)(false);
    const { entryPointActions: entryPointActions, entryPointReferenceSubject: entryPointReferenceSubject } = (0, $4mO32.useEntryPoint)((0, $56rNw.asyncChangeboardingModalEntryPoint), $ce599d26c9577203$var$entryPointParams);
    const shouldLoadModal = isTriggerActive && data && !data.projectHasPublicForm && data.isPublicFormEnabledForSite && data.canAdministerProject && data.projectHasFormNavItem;
    (0, $5uXOq.useEffect)(()=>{
        if (data?.projectHasPublicForm || data?.isPublicFormEnabledForSite === false) (0, $6P8fi.emitMessageEvent)({
            action: 'filter'
        });
    }, [
        data?.projectHasPublicForm,
        data?.isPublicFormEnabledForSite
    ]);
    // eslint-disable-next-line @atlassian/react-entrypoint/no-load-in-hooks
    (0, $5uXOq.useEffect)(()=>{
        if (!hasLoadedEntrypoint.current && shouldLoadModal) {
            if (!(0, $6s1PB.expVal)('jira_forms_public_access_changeboarding', 'isEnabled', false)) {
                // if in control cohort, snooze the post office message and check again later
                // as experiment gradually rolls out
                (0, $6P8fi.emitMessageEvent)({
                    action: 'snooze'
                });
                return;
            }
            entryPointActions.load();
            hasLoadedEntrypoint.current = true;
        }
    }, [
        entryPointActions,
        shouldLoadModal
    ]);
    if (!data || !data.project || !shouldLoadModal) return null;
    const firstFormIdInProject = data.forms?.[0]?.formId;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7XluA.JiraEntryPointContainer), {
        entryPointReferenceSubject: entryPointReferenceSubject,
        id: "public-forms-changeboarding-modal",
        packageName: "@atlassian/jira-public-forms-changeboarding-modal",
        teamName: "a4t-tanuki",
        fallback: null,
        errorFallback: "unmount",
        runtimeProps: {
            firstFormIdInProject: firstFormIdInProject,
            project: data.project
        }
    });
};
var $ce599d26c9577203$export$2e2bcd8739ae039 = $ce599d26c9577203$var$PublicFormChangeboardingModalRoot;

});
parcelRegister("aXhsp", function(module, exports) {

$parcel$export(module.exports, "default", () => $d88f4e626c9babc0$export$2e2bcd8739ae039);

var $9XE6b = parcelRequire("9XE6b");

var $ivfDv = parcelRequire("ivfDv");

var $e3a3O = parcelRequire("e3a3O");

var $clSzL = parcelRequire("clSzL");

var $h4ppL = parcelRequire("h4ppL");

var $JPsIz = parcelRequire("JPsIz");

var $lC4FX = parcelRequire("lC4FX");

var $cuKXc = parcelRequire("cuKXc");

var $2YZCu = parcelRequire("2YZCu");

var $dxpxC = parcelRequire("dxpxC");

var $l0T7c = parcelRequire("l0T7c");

var $9g713 = parcelRequire("9g713");


const $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID = 'gira';
const $d88f4e626c9babc0$var$CACHE_NAME = `apollo-cache/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}`;
const $d88f4e626c9babc0$var$LOG_NAMESPACE = `apollo.${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}.error.graphql`;
// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
const $d88f4e626c9babc0$var$isSsrSuccessful = ()=>false ? true : !window || !window.SPA_STATE;
const $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY = 'networkErrorsCounter';
const $d88f4e626c9babc0$export$851a7159daf49c89 = new (0, $ivfDv.IntrospectionFragmentMatcher)({
    introspectionQueryResultData: (/*@__PURE__*/$parcel$interopDefault($l0T7c))
});
const $d88f4e626c9babc0$var$errorLink = (0, $h4ppL.onError)(({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    // Ignore network errors as they will be logged in the retry link
    (0, $9g713.reportErrors)({
        graphQLErrors: graphQLErrors,
        operation: operation
    });
    // Skip default error logging if analytics context data is defined for the query.
    const errorAnalytics = (0, $9g713.getErrorAnalyticsContext)(operation.getContext());
    if (errorAnalytics !== undefined) return;
    if (graphQLErrors) {
        if (Array.isArray(graphQLErrors)) graphQLErrors.map(({ message: message, locations: locations, path: path })=>(0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[GraphQL error]: Message: ${message}, Location: ${locations}, Path: ${path}`, {
                message: JSON.stringify(message),
                path: JSON.stringify(path),
                locations: JSON.stringify(locations)
            }));
        else (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, '[GraphQL error]: Unexpected error message format', {
            message: JSON.stringify(graphQLErrors)
        });
    }
    if (networkError) {
        const occuredNetworkErrorsBefore = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(operation.getContext(), [
            $d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY
        ], 0);
        (0, $2YZCu.default).safeErrorWithoutCustomerData($d88f4e626c9babc0$var$LOG_NAMESPACE, `[Network error]: ${networkError}, attempt ${occuredNetworkErrorsBefore + 1}`);
        operation.setContext({
            [$d88f4e626c9babc0$var$NETWORK_ERRORS_COUNTER_KEY]: occuredNetworkErrorsBefore + 1
        });
    }
});
const $d88f4e626c9babc0$var$retryLinkWithFama = new (0, $lC4FX.RetryLink)({
    delay: {
        initial: 300,
        max: 120000,
        jitter: true
    },
    attempts: (count, operation, networkError)=>{
        const retry = count < 5 && networkError && !networkError.statusCode;
        // Don't report any error if we're going to attempt a retry
        if (!retry) (0, $9g713.reportErrors)({
            networkError: networkError,
            operation: operation
        });
        return retry;
    }
});
class $d88f4e626c9babc0$var$CancelableRequestLink extends (0, $clSzL.ApolloLink) {
    constructor(){
        super();
        this.inFlightRequestControllers = {};
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    request(operation, forward) {
        const context = operation.getContext();
        if (!context.cancelable) return forward(operation);
        const key = JSON.stringify([
            operation.operationName,
            operation.query
        ]); // Equivalent to `operation.toKey` less the _actual_ variables
        this.inFlightRequestControllers[key]?.abort(); // Always abort the previous request
        const abortController = new AbortController();
        operation.setContext({
            ...context,
            fetchOptions: {
                signal: abortController.signal
            } // HttpLink passes this directly to fetch implementation
        });
        this.inFlightRequestControllers[key] = abortController;
        const cleanup = ()=>{
            // This callback may be called long after the request is replaced
            if (this.inFlightRequestControllers[key] === abortController) delete this.inFlightRequestControllers[key];
        };
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return new (0, $clSzL.Observable)((observer)=>{
            const subscription = forward(operation).subscribe({
                next: observer.next.bind(observer),
                // @ts-expect-error - TS7006 - Parameter 'error' implicitly has an 'any' type.
                error: (error)=>{
                    observer.error(error);
                    cleanup();
                },
                complete: observer.complete.bind(observer)
            });
            return ()=>{
                subscription?.unsubscribe();
                cleanup();
            };
        });
    }
}
const $d88f4e626c9babc0$var$cache = new (0, $ivfDv.InMemoryCache)({
    cacheRedirects: {
        Query: {
            ...(0, $cuKXc.fragmentCacheRedirect)()
        }
    },
    fragmentMatcher: $d88f4e626c9babc0$export$851a7159daf49c89,
    dataIdFromObject: (object)=>object.id && `${object.id}${object.__typename}`
})// eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
.restore(!$d88f4e626c9babc0$var$isSsrSuccessful() && window.SPA_STATE[$d88f4e626c9babc0$var$CACHE_NAME] || {});
const $d88f4e626c9babc0$export$de66868aab9e79ea = (baseUrl)=>new (0, $e3a3O.ApolloClient)({
        name: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
        ssrMode: $d88f4e626c9babc0$var$isSsrSuccessful(),
        // @ts-expect-error - TS2345 - Argument of type '{ name: string; ssrMode: boolean; addTypename: boolean; link: ApolloLink; cache: InMemoryCache; connectToDevTools: boolean; }' is not assignable to parameter of type 'ApolloClientOptions<NormalizedCacheObject>'.
        addTypename: true,
        link: (0, $clSzL.ApolloLink).from([
            $d88f4e626c9babc0$var$retryLinkWithFama,
            $d88f4e626c9babc0$var$errorLink,
            (0, $dxpxC.UFOLoggerLink),
            (0, $cuKXc.fragmentLinkState)($d88f4e626c9babc0$var$cache),
            ...!$d88f4e626c9babc0$var$isSsrSuccessful() ? [
                new $d88f4e626c9babc0$var$CancelableRequestLink()
            ] : [],
            new (0, $JPsIz.HttpLink)({
                uri: ({ operationName: operationName })=>`${baseUrl}/rest/${$d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID}/1/?operation=${encodeURIComponent(operationName)}`,
                credentials: 'same-origin',
                // @ts-expect-error - TS2345 - Argument of type '{ uri: ({ operationName }: Operation) => string; credentials: string; abortErrorDoesNotCauseError: boolean; }' is not assignable to parameter of type 'Options'.
                abortErrorDoesNotCauseError: !$d88f4e626c9babc0$var$isSsrSuccessful()
            })
        ].filter(Boolean)),
        cache: $d88f4e626c9babc0$var$cache,
        connectToDevTools: false
    });
var $d88f4e626c9babc0$export$2e2bcd8739ae039 = {
    clientId: $d88f4e626c9babc0$var$GIRA_APOLLO_CLIENT_ID,
    clientCreator: $d88f4e626c9babc0$export$de66868aab9e79ea
};

});
parcelRegister("l0T7c", function(module, exports) {
module.exports = JSON.parse("{\"__schema\":{\"types\":[{\"kind\":\"UNION\",\"name\":\"AllActivityFeedItemUnion\",\"possibleTypes\":[{\"name\":\"HistoryItem\"},{\"name\":\"CommentItem\"},{\"name\":\"WorklogItem\"},{\"name\":\"IncidentItem\"},{\"name\":\"ApprovalItem\"},{\"name\":\"HiddenCommentItem\"}]},{\"kind\":\"UNION\",\"name\":\"ApprovalActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ApprovalCreated\"},{\"name\":\"ApproverDecision\"},{\"name\":\"ApprovalCompleted\"}]},{\"kind\":\"UNION\",\"name\":\"ConfluencePageUnion\",\"possibleTypes\":[{\"name\":\"ConfluencePage\"},{\"name\":\"FailedRemoteLink\"}]},{\"kind\":\"UNION\",\"name\":\"GQLCategorizedField\",\"possibleTypes\":[{\"name\":\"GQLSortableField\"},{\"name\":\"GQLSearchableField\"}]},{\"kind\":\"UNION\",\"name\":\"GadgetParameters\",\"possibleTypes\":[{\"name\":\"VotedGadgetParameters\"},{\"name\":\"AssignedToMeGadgetParameters\"},{\"name\":\"WatchedGadgetParameters\"},{\"name\":\"InProgressGadgetParameters\"},{\"name\":\"FilterResultsGadgetParameters\"},{\"name\":\"TwoDimensionalStatisticsParameters\"},{\"name\":\"PieChartParameters\"},{\"name\":\"IssueStatisticsParameters\"},{\"name\":\"WorkloadPieChartParameters\"},{\"name\":\"ActivityStreamGadgetParameters\"},{\"name\":\"CreatedVsResolvedGadgetParameters\"},{\"name\":\"SprintGadgetParameters\"},{\"name\":\"ProjectsGadgetParameters\"},{\"name\":\"ConnectGadgetParameters\"},{\"name\":\"NotConfiguredGadgetParameters\"},{\"name\":\"UnsupportedGadgetParameters\"}]},{\"kind\":\"UNION\",\"name\":\"GroupByFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"UserField\"},{\"name\":\"LabelsField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"FloatCustomField\"}]},{\"kind\":\"UNION\",\"name\":\"GroupSectionItem\",\"possibleTypes\":[{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"HistoryValue\",\"possibleTypes\":[{\"name\":\"AssigneeFieldValue\"},{\"name\":\"PriorityFieldValue\"},{\"name\":\"StatusFieldValue\"},{\"name\":\"WorkLogFieldValue\"},{\"name\":\"RespondersFieldValue\"},{\"name\":\"GenericFieldValue\"}]},{\"kind\":\"UNION\",\"name\":\"IncidentActivityValueUnion\",\"possibleTypes\":[{\"name\":\"ResponderAlertAssignedValue\"},{\"name\":\"AlertValue\"},{\"name\":\"ResponderAlertPriorityChangedValue\"},{\"name\":\"IccSessionValue\"},{\"name\":\"IccSessionInvitationValue\"},{\"name\":\"StakeholderUpdatedValue\"},{\"name\":\"IncidentStakeholderActionValue\"}]},{\"kind\":\"UNION\",\"name\":\"IssueFieldUnion\",\"possibleTypes\":[{\"name\":\"PriorityField\"},{\"name\":\"StatusField\"},{\"name\":\"IssueTypeField\"},{\"name\":\"ProjectComponentsField\"},{\"name\":\"LabelsField\"},{\"name\":\"WatchersField\"},{\"name\":\"UserField\"},{\"name\":\"TextField\"},{\"name\":\"VersionsField\"},{\"name\":\"DateField\"},{\"name\":\"DateTimeField\"},{\"name\":\"IssueKeyField\"},{\"name\":\"ProjectField\"},{\"name\":\"ResolutionField\"},{\"name\":\"TimeTrackingField\"},{\"name\":\"TimeOriginalEstimateField\"},{\"name\":\"TimeEstimateField\"},{\"name\":\"TimeSpentField\"},{\"name\":\"StoryPointsField\"},{\"name\":\"EpicLinkField\"},{\"name\":\"EpicNameField\"},{\"name\":\"ColorField\"},{\"name\":\"EpicColorField\"},{\"name\":\"SprintCustomField\"},{\"name\":\"SelectCustomField\"},{\"name\":\"FlaggedCustomField\"},{\"name\":\"UserPickerCustomField\"},{\"name\":\"TextAreaCustomField\"},{\"name\":\"FloatCustomField\"},{\"name\":\"DatePickerCustomField\"},{\"name\":\"TextFieldCustomField\"},{\"name\":\"MultiSelectCustomField\"},{\"name\":\"LabelsCustomField\"},{\"name\":\"MultiUserPickerCustomField\"},{\"name\":\"PeopleCustomField\"},{\"name\":\"UrlCustomField\"},{\"name\":\"VersionCustomField\"},{\"name\":\"GroupPickerCustomField\"},{\"name\":\"MultiVersionCustomField\"},{\"name\":\"MultiGroupPickerCustomField\"},{\"name\":\"CheckBoxesCustomField\"},{\"name\":\"RadioButtonsCustomField\"},{\"name\":\"DateTimeCustomField\"},{\"name\":\"SeverityField\"},{\"name\":\"AffectedServicesField\"},{\"name\":\"TechLeadField\"},{\"name\":\"AttachmentsField\"},{\"name\":\"GlancesField\"},{\"name\":\"SecurityLevelField\"},{\"name\":\"IssueLinksField\"},{\"name\":\"IssuesInEpicField\"},{\"name\":\"SubtasksField\"},{\"name\":\"ChildIssuesField\"},{\"name\":\"CascadingSelectCustomField\"},{\"name\":\"CmdbField\"},{\"name\":\"SLACustomField\"},{\"name\":\"ProjectCustomField\"},{\"name\":\"EpicStatusField\"},{\"name\":\"ParentField\"},{\"name\":\"JWMCategoryCustomField\"},{\"name\":\"CommentSummaryField\"}]},{\"kind\":\"UNION\",\"name\":\"IssueSections\",\"possibleTypes\":[{\"name\":\"PrimarySecondaryContextSections\"},{\"name\":\"JsdSections\"}]},{\"kind\":\"UNION\",\"name\":\"JiraActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraColorBackground\"},{\"name\":\"JiraGradientBackground\"},{\"name\":\"JiraMediaBackground\"},{\"name\":\"JiraAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraAtlassianIntelligenceAction\",\"possibleTypes\":[{\"name\":\"JiraAccessAtlassianIntelligenceFeature\"},{\"name\":\"JiraEnableAtlassianIntelligenceDeepLink\"},{\"name\":\"JiraContactOrgAdminToEnableAtlassianIntelligence\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraBoardResult\",\"possibleTypes\":[{\"name\":\"JiraBoard\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraChildIssues\",\"possibleTypes\":[{\"name\":\"JiraChildIssuesWithinLimit\"},{\"name\":\"JiraChildIssuesExceedingLimit\"}]},{\"kind\":\"UNION\",\"name\":\"JiraCommentVisibility\",\"possibleTypes\":[{\"name\":\"JiraRoleVisibility\"},{\"name\":\"JiraGroupVisibility\"}]},{\"kind\":\"UNION\",\"name\":\"JiraConfluencePageContent\",\"possibleTypes\":[{\"name\":\"JiraConfluencePageContentDetails\"},{\"name\":\"JiraConfluencePageContentError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraContainerNavigationResult\",\"possibleTypes\":[{\"name\":\"JiraContainerNavigation\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraDefaultUnsplashImagesPageResult\",\"possibleTypes\":[{\"name\":\"JiraDefaultUnsplashImagesPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFavourite\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraPlan\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraServiceManagementQueue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldFormatConfig\",\"possibleTypes\":[{\"name\":\"JiraNumberFieldFormatConfig\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFieldSetViewResult\",\"possibleTypes\":[{\"name\":\"JiraFieldSetView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraFormattingExpression\",\"possibleTypes\":[{\"name\":\"JiraFormattingSingleValueOperand\"},{\"name\":\"JiraFormattingTwoValueOperand\"},{\"name\":\"JiraFormattingMultipleValueOperand\"},{\"name\":\"JiraFormattingNoValueOperand\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGlobalPermissionGrantsResult\",\"possibleTypes\":[{\"name\":\"JiraGlobalPermissionGrantsList\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGrantTypeValue\",\"possibleTypes\":[{\"name\":\"JiraDefaultGrantTypeValue\"},{\"name\":\"JiraUserGrantTypeValue\"},{\"name\":\"JiraProjectRoleGrantTypeValue\"},{\"name\":\"JiraGroupGrantTypeValue\"},{\"name\":\"JiraIssueFieldGrantTypeValue\"}]},{\"kind\":\"UNION\",\"name\":\"JiraGroupLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateAdditionalServicesResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateAdditionalServices\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateFieldsResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateFields\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueCreateLayoutResult\",\"possibleTypes\":[{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueExportEvent\",\"possibleTypes\":[{\"name\":\"JiraIssueExportTaskSubmitted\"},{\"name\":\"JiraIssueExportTaskProgress\"},{\"name\":\"JiraIssueExportTaskCompleted\"},{\"name\":\"JiraIssueExportTaskTerminated\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"},{\"name\":\"JiraIssueItemGroupContainer\"},{\"name\":\"JiraIssueItemTabContainer\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemContainersResult\",\"possibleTypes\":[{\"name\":\"JiraIssueItemContainers\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemGroupContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"},{\"name\":\"JiraIssueItemPanelItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueItemTabContainerItem\",\"possibleTypes\":[{\"name\":\"JiraIssueItemFieldItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayout\",\"possibleTypes\":[{\"name\":\"JiraDefaultIssueLayout\"},{\"name\":\"JiraIssueCreateLayout\"},{\"name\":\"JiraLegacyIssueLayout\"},{\"name\":\"JsdDefaultIssueLayout\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldConfigurationHiddenIn\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInGlobal\"},{\"name\":\"JiraIssueLayoutFieldConfigurationHiddenInLayoutOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutFieldPanelItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutItemConfiguration\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutContainerConfiguration\"},{\"name\":\"JiraIssueLayoutFieldItemConfiguration\"},{\"name\":\"JiraIssueLayoutGroupContainerConfiguration\"},{\"name\":\"JiraIssueLayoutTabContainerConfiguration\"},{\"name\":\"JiraIssueLayoutPanelItemConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwner\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutIssueTypeOwner\"},{\"name\":\"JiraIssueLayoutRequestTypeOwner\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueLayoutOwners\",\"possibleTypes\":[{\"name\":\"JiraIssueLayoutOwnersResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueResult\",\"possibleTypes\":[{\"name\":\"JiraIssue\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByFilterResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByFilter\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchByJqlResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchByJql\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraCustomIssueSearchError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraIssueSearchViewResult\",\"possibleTypes\":[{\"name\":\"JiraIssueSearchView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJQLGenerationError\",\"possibleTypes\":[{\"name\":\"JiraInvalidJqlError\"},{\"name\":\"JiraInvalidSyntaxError\"},{\"name\":\"JiraServerError\"},{\"name\":\"JiraUIExposedError\"},{\"name\":\"JiraUsageLimitExceededError\"},{\"name\":\"JiraUnsupportedLanguageError\"},{\"name\":\"JiraGeneratedJqlInvalidError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyItem\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkItem\"},{\"name\":\"JiraJourneyStatusDependency\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyParentIssueValueType\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJourneyTriggerConfiguration\",\"possibleTypes\":[{\"name\":\"JiraJourneyWorkdayIntegrationTriggerConfiguration\"},{\"name\":\"JiraJourneyParentIssueTriggerConfiguration\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraJqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JiraJqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedField\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraJqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JiraJqlQueryHydratedValue\"},{\"name\":\"JiraJqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraMediaUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraMediaUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraNavigationItemResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"JiraSoftwareBuiltInNavigationItem\"},{\"name\":\"JiraAppNavigationItem\"},{\"name\":\"JiraShortcutNavigationItem\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOnSuggestedChildIssueResult\",\"possibleTypes\":[{\"name\":\"JiraSuggestedIssue\"},{\"name\":\"JiraSuggestedChildIssueStatus\"},{\"name\":\"JiraSuggestedChildIssueError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraOverviewPlanMigrationStateResult\",\"possibleTypes\":[{\"name\":\"JiraOverviewPlanMigrationState\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraPermissionSchemeViewResult\",\"possibleTypes\":[{\"name\":\"JiraPermissionSchemeView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectConfiguration\",\"possibleTypes\":[{\"name\":\"JiraProjectConfigurationResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectNavigationMetadata\",\"possibleTypes\":[{\"name\":\"JiraSoftwareProjectNavigationMetadata\"},{\"name\":\"JiraServiceManagementProjectNavigationMetadata\"},{\"name\":\"JiraWorkManagementProjectNavigationMetadata\"}]},{\"kind\":\"UNION\",\"name\":\"JiraProjectsUsingField\",\"possibleTypes\":[{\"name\":\"JiraProjectsUsingFieldResult\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraRemoteIssueLink\",\"possibleTypes\":[{\"name\":\"JiraIssueRemoteIssueLink\"},{\"name\":\"JiraConfluenceRemoteIssueLink\"},{\"name\":\"JiraWebRemoteIssueLink\"},{\"name\":\"JiraCustomRemoteIssueLink\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSearchableEntity\",\"possibleTypes\":[{\"name\":\"JiraProject\"},{\"name\":\"JiraSystemFilter\"},{\"name\":\"JiraCustomFilter\"},{\"name\":\"JiraBoard\"},{\"name\":\"JiraDashboard\"},{\"name\":\"JiraIssue\"},{\"name\":\"JiraServiceManagementQueue\"},{\"name\":\"JiraPlan\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSectionLayoutItem\",\"possibleTypes\":[{\"name\":\"JiraGroupLayout\"},{\"name\":\"JiraTabLayout\"},{\"name\":\"JiraFieldLayoutItem\"},{\"name\":\"JiraEcosystemLayoutItem\"},{\"name\":\"JiraForgeLayoutItem\"},{\"name\":\"JiraPanelLayoutItem\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementApproverPrincipal\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserApproverPrincipal\"},{\"name\":\"JiraServiceManagementGroupApproverPrincipal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementEntitledEntity\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementEntitlementCustomer\"},{\"name\":\"JiraServiceManagementEntitlementOrganization\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementRequestTypePreviewField\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementTextPreviewField\"},{\"name\":\"JiraServiceManagementTextAreaPreviewField\"},{\"name\":\"JiraServiceManagementDueDatePreviewField\"},{\"name\":\"JiraServiceManagementDatePreviewField\"},{\"name\":\"JiraServiceManagementDateTimePreviewField\"},{\"name\":\"JiraServiceManagementAttachmentPreviewField\"},{\"name\":\"JiraServiceManagementSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiSelectPreviewField\"},{\"name\":\"JiraServiceManagementMultiUserPickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiServicePickerPreviewField\"},{\"name\":\"JiraServiceManagementMultiCheckboxesPreviewField\"},{\"name\":\"JiraServiceManagementPeoplePreviewField\"},{\"name\":\"JiraServiceManagementUnknownPreviewField\"}]},{\"kind\":\"UNION\",\"name\":\"JiraServiceManagementResponder\",\"possibleTypes\":[{\"name\":\"JiraServiceManagementUserResponder\"},{\"name\":\"JiraServiceManagementTeamResponder\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityEditGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraShareableEntityShareGrant\",\"possibleTypes\":[{\"name\":\"JiraShareableEntityGroupGrant\"},{\"name\":\"JiraShareableEntityProjectRoleGrant\"},{\"name\":\"JiraShareableEntityProjectGrant\"},{\"name\":\"JiraShareableEntityAnonymousAccessGrant\"},{\"name\":\"JiraShareableEntityAnyLoggedInUserGrant\"},{\"name\":\"JiraShareableEntityUnknownProjectGrant\"},{\"name\":\"JiraShareableEntityUserGrant\"}]},{\"kind\":\"UNION\",\"name\":\"JiraSpreadsheetGroupFieldValue\",\"possibleTypes\":[{\"name\":\"AtlassianAccountUser\"},{\"name\":\"JiraOption\"},{\"name\":\"JiraStatus\"},{\"name\":\"JiraPriority\"},{\"name\":\"JiraStoryPoint\"},{\"name\":\"JiraGoal\"}]},{\"kind\":\"UNION\",\"name\":\"JiraUnsplashImageSearchPageResult\",\"possibleTypes\":[{\"name\":\"JiraUnsplashImageSearchPage\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraVersionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraVersionResult\",\"possibleTypes\":[{\"name\":\"JiraVersion\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementActiveBackgroundDetailsResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementColorBackground\"},{\"name\":\"JiraWorkManagementGradientBackground\"},{\"name\":\"JiraWorkManagementMediaBackground\"},{\"name\":\"JiraWorkManagementAttachmentBackground\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementBackgroundUploadTokenResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementBackgroundUploadToken\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementCategoryOptionConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementCategoryOptionConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFieldConfigurationConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFieldConfigurationConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementFilterConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementFilterConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementGiraOverviewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementGiraOverview\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementSavedViewResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementSavedView\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JiraWorkManagementViewItemConnectionResult\",\"possibleTypes\":[{\"name\":\"JiraWorkManagementViewItemConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlFieldConnectionResult\",\"possibleTypes\":[{\"name\":\"JqlFieldConnection\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlHydratedQueryResult\",\"possibleTypes\":[{\"name\":\"JqlHydratedQuery\"},{\"name\":\"QueryError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedFieldResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedField\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"JqlQueryHydratedValueResult\",\"possibleTypes\":[{\"name\":\"JqlQueryHydratedValue\"},{\"name\":\"JqlQueryHydratedError\"}]},{\"kind\":\"UNION\",\"name\":\"LayoutDefiner\",\"possibleTypes\":[{\"name\":\"FieldLayoutScreen\"},{\"name\":\"JiraRequestType\"}]},{\"kind\":\"UNION\",\"name\":\"MediaUploadTokenUnion\",\"possibleTypes\":[{\"name\":\"MediaUploadToken\"},{\"name\":\"FailedMediaUploadToken\"}]},{\"kind\":\"UNION\",\"name\":\"MergedFieldUnion\",\"possibleTypes\":[{\"name\":\"IssueTypeField\"},{\"name\":\"StatusField\"}]},{\"kind\":\"UNION\",\"name\":\"ProjectCategoryGadgetUnion\",\"possibleTypes\":[{\"name\":\"ProjectsGadgetItem\"},{\"name\":\"CategoriesGadgetItem\"}]},{\"kind\":\"UNION\",\"name\":\"RemoteIssueDetailsUnion\",\"possibleTypes\":[{\"name\":\"AssociatedIssueWrapper\"},{\"name\":\"FailedRemoteIssue\"}]},{\"kind\":\"UNION\",\"name\":\"SectionItem\",\"possibleTypes\":[{\"name\":\"GroupLayout\"},{\"name\":\"TabLayout\"},{\"name\":\"FieldSectionItem\"},{\"name\":\"EcosystemSectionItem\"},{\"name\":\"ForgeSectionItem\"},{\"name\":\"PanelSectionItem\"}]},{\"kind\":\"UNION\",\"name\":\"TimeSeriesChartAdditionalPropertiesUnion\",\"possibleTypes\":[{\"name\":\"CreatedVsResolvedProperties\"}]}]}}");

});

parcelRegister("9g713", function(module, exports) {

$parcel$export(module.exports, "getErrorAnalyticsContext", () => $a87e716199660ede$export$bd030713895ed5e2);
$parcel$export(module.exports, "reportErrors", () => $a87e716199660ede$export$a78ebe1911f50d41);

var $9XE6b = parcelRequire("9XE6b");

var $e3a3O = parcelRequire("e3a3O");

var $jcw0u = parcelRequire("jcw0u");
const $a87e716199660ede$export$15d632fe38832073 = 'giraErrorAnalytics';
const $a87e716199660ede$export$fc6a71db0f9a33f9 = (errorAnalytics, context = {})=>({
        ...context,
        [$a87e716199660ede$export$15d632fe38832073]: errorAnalytics
    });
const $a87e716199660ede$export$bd030713895ed5e2 = (context)=>{
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    const errorAnalytics = (0, (/*@__PURE__*/$parcel$interopDefault($9XE6b)))(context, [
        $a87e716199660ede$export$15d632fe38832073
    ], undefined);
    if (typeof errorAnalytics === 'object' && typeof errorAnalytics.id === 'string' && (errorAnalytics.packageName === undefined || typeof errorAnalytics.packageName === 'string') && (errorAnalytics.teamName === undefined || typeof errorAnalytics.teamName === 'string') && (errorAnalytics.attributes === undefined || typeof errorAnalytics.attributes === 'object') && (errorAnalytics.sendToPrivacyUnsafeSplunk === undefined || typeof errorAnalytics.sendToPrivacyUnsafeSplunk === 'boolean')) return {
        id: errorAnalytics.id,
        packageName: errorAnalytics.packageName,
        teamName: errorAnalytics.teamName,
        attributes: errorAnalytics.attributes,
        sendToPrivacyUnsafeSplunk: errorAnalytics.sendToPrivacyUnsafeSplunk
    };
    return undefined;
};
const $a87e716199660ede$export$a78ebe1911f50d41 = ({ graphQLErrors: graphQLErrors, networkError: networkError, operation: operation })=>{
    const errorAnalytics = $a87e716199660ede$export$bd030713895ed5e2(operation.getContext());
    // Refine mixed type to Array | void
    if (graphQLErrors !== undefined && !Array.isArray(graphQLErrors)) return;
    const hasGraphQLError = graphQLErrors !== undefined && graphQLErrors.length > 0;
    const hasNetworkError = networkError !== undefined;
    // Only report errors using the JFE analytics pipeline if analytics context data is defined for the query.
    if (errorAnalytics === undefined || !hasGraphQLError && !hasNetworkError) return;
    const { id: id, packageName: packageName, teamName: teamName, attributes: attributes, sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk } = errorAnalytics;
    const error = new (0, $e3a3O.ApolloError)({
        // Above Array.isArray check will refine the type to a read-only array. We need this spread to keep flow happy.
        graphQLErrors: graphQLErrors ? [
            ...graphQLErrors
        ] : undefined,
        networkError: networkError
    });
    const attributesWithOperationName = {
        ...attributes,
        operationName: operation.operationName,
        hasGraphQLError: hasGraphQLError,
        hasNetworkError: hasNetworkError
    };
    (0, $jcw0u.default)({
        error: error,
        meta: {
            id: id,
            packageName: packageName,
            teamName: teamName
        },
        attributes: attributesWithOperationName,
        sendToPrivacyUnsafeSplunk: sendToPrivacyUnsafeSplunk
    });
};

});


parcelRegister("e43Es", function(module, exports) {

$parcel$export(module.exports, "useGetData", () => $41a4c09c49cfff36$export$1f47bbb09bba389a);

var $5tTFS = parcelRequire("5tTFS");

var $j5YhT = parcelRequire("j5YhT");

var $koeKL = parcelRequire("koeKL");

var $lHhTR = parcelRequire("lHhTR");
const $41a4c09c49cfff36$var$getProjectHasFormNavItem = (data)=>{
    if (!data.jira?.containerNavigation) return false;
    if (!('navigationItems' in data.jira.containerNavigation)) return false;
    return data.jira.containerNavigation.navigationItems?.edges?.some((node)=>node?.node?.typeKey === 'FORMS') ?? false;
};
const $41a4c09c49cfff36$var$getProjectHasPublicForm = (data)=>{
    return data.jiraBusinessFormsByProjectId?.nodes?.some((node)=>node?.accessLevel === 'public') ?? false;
};
const $41a4c09c49cfff36$export$1f47bbb09bba389a = ({ projectId: projectId, isEnabled: isEnabled })=>{
    const cloudId = (0, $koeKL.useCloudId)();
    const projectAri = (0, $j5YhT.JiraProjectAri).create({
        siteId: cloudId,
        projectId: projectId
    });
    const { data: data } = (0, $5tTFS.useQuery)((0, $lHhTR.GET_DATA_QUERY), {
        variables: {
            projectId: projectId,
            projectAri: projectAri.toString()
        },
        fetchPolicy: 'network-only',
        skip: !isEnabled
    });
    if (!data) return undefined;
    const projectHasFormNavItem = $41a4c09c49cfff36$var$getProjectHasFormNavItem(data);
    const isPublicFormEnabledForSite = data.jiraBusinessFormsByProjectId?.publicFormsEnabled ?? null;
    const canAdministerProject = data.jira?.jiraProject?.administerProject?.canPerform ?? false;
    const projectHasPublicForm = $41a4c09c49cfff36$var$getProjectHasPublicForm(data);
    const firstStoryLevelIssueTypeId = data.jira?.jiraProject?.issueTypes?.edges?.[0]?.node?.issueTypeId ?? null;
    return {
        forms: data.jiraBusinessFormsByProjectId?.nodes,
        project: data.jira?.jiraProject,
        projectHasFormNavItem: projectHasFormNavItem,
        isPublicFormEnabledForSite: isPublicFormEnabledForSite,
        canAdministerProject: canAdministerProject,
        projectHasPublicForm: projectHasPublicForm,
        firstStoryLevelIssueTypeId: firstStoryLevelIssueTypeId
    };
};

});
parcelRegister("lHhTR", function(module, exports) {

$parcel$export(module.exports, "GET_DATA_QUERY", () => $91b4b63945405a40$export$d51f8ada234b77b5);

var $5cllN = parcelRequire("5cllN");
const $91b4b63945405a40$export$d51f8ada234b77b5 = (0, $5cllN.default)`
query getPublicFormChangeboardingData ($projectId: Long!, $projectAri: ID!) {
    jira {
        containerNavigation(
            input: {scopeId: $projectAri}
        ) {
            ... on JiraContainerNavigation {
                id
                navigationItems(first: 100) {
                    edges {
                        node {
                            typeKey
                            id
                        }
                    }
                }
            }
        }

        jiraProject(id: $projectAri) {
            id
            projectId
            key
            name
            projectType
			tmpBoardId
            administerProject: action(type: EDIT_PROJECT_CONFIG) {
              canPerform
            }
            issueTypes(
                first: 1,
                filter: { minHierarchyLevel: 0, maxHierarchyLevel: 0 }
            ) {
                edges {
                    node {
                        id
                        name
                        issueTypeId
                    }
                }
            }
        }
    }

    jiraBusinessFormsByProjectId(projectId: $projectId, first: 50) {
        publicFormsEnabled
        nodes {
            formId
            accessLevel
        }
    }
}
`;

});


parcelRegister("56rNw", function(module, exports) {

$parcel$export(module.exports, "asyncChangeboardingModalEntryPoint", () => $b9ad34f87b7a83a9$export$6f32a80685928724);

var $eufEc = parcelRequire("eufEc");

var $fEDBv = parcelRequire("fEDBv");

const $b9ad34f87b7a83a9$export$6f32a80685928724 = (0, $fEDBv.createEntryPoint)({
    root: (0, $eufEc.JSResourceForInteraction)(()=>(parcelRequire("5amqL")), {
        moduleId: "75239bc3",
        moduleName: "PublicFormChangeboardingModal"
    }),
    getPreloadProps: ()=>({})
});

});
parcelRegister("5amqL", function(module, exports) {

let $3c2f49339d697107$var$load = (parcelRequire("28QjX"))(4);
module.exports = $3c2f49339d697107$var$load("2lsjy").then(()=>parcelRequire('8no1X'));

});


parcelRegister("6P8fi", function(module, exports) {

$parcel$export(module.exports, "getFormBuilderUrl", () => $d9991abb643263eb$export$1a0bdbdcca54ab65);
$parcel$export(module.exports, "emitMessageEvent", () => $d9991abb643263eb$export$3d0d0251b849dca6);

const $d9991abb643263eb$var$SOFTWARE_TMP_PREFIX = '/jira/software';
const $d9991abb643263eb$var$SOFTWARE_CMP_PREFIX = '/jira/software/c';
const $d9991abb643263eb$var$BUSINESS_PREFIX = '/jira/core';
const $d9991abb643263eb$export$36e24695f02d4503 = (project)=>{
    if (project.projectType === 'SOFTWARE') {
        if (project.tmpBoardId !== null) return $d9991abb643263eb$var$SOFTWARE_TMP_PREFIX;
        return $d9991abb643263eb$var$SOFTWARE_CMP_PREFIX;
    }
    return $d9991abb643263eb$var$BUSINESS_PREFIX;
};
const $d9991abb643263eb$export$1a0bdbdcca54ab65 = ({ project: project, formId: formId })=>{
    return `${$d9991abb643263eb$export$36e24695f02d4503(project)}/projects/${project.key}/form/${formId}/builder`;
};
const $d9991abb643263eb$export$3d0d0251b849dca6 = (eventDetails)=>{
    const event = new CustomEvent((0, $1a3ee76b747d2e0b$export$e223524d7b4aee73), {
        detail: eventDetails
    });
    if (typeof document !== 'undefined') document.dispatchEvent(event);
};

});
const $1a3ee76b747d2e0b$export$ca3d56c0d6d21363 = 'jira_business_public-forms-changeboarding';
const $1a3ee76b747d2e0b$export$3b45ec1a607f2838 = 'SHOULD_SHOW_FORM_BUILDER_SPOTLIGHTING';
const $1a3ee76b747d2e0b$export$64e47a95ce32c8b2 = 'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_ACCESS_STEP';
const $1a3ee76b747d2e0b$export$51318ec2f5085d87 = 'PUBLIC_FORM_CHANGEBOARDING_SPOTLIGHTS_FORM_FIELD_STEP';
const $1a3ee76b747d2e0b$export$e223524d7b4aee73 = 'jira-forms-public-forms-changeboarding-event';
const $1a3ee76b747d2e0b$export$dc7ed530d378527 = 'jira-forms-public-forms-changeboarding-trigger-id';



parcelRegister("8TCLJ", function(module, exports) {

$parcel$export(module.exports, "useActiveStandup", () => $cf2c386c440d0536$export$81669f46a3a180e0);

var $5uXOq = parcelRequire("5uXOq");
const $cf2c386c440d0536$export$81669f46a3a180e0 = ()=>{
    const [isActiveStandup, setIsActiveStandup] = (0, $5uXOq.useState)(false);
    return [
        isActiveStandup,
        setIsActiveStandup
    ];
};

});

parcelRegister("7V9GI", function(module, exports) {

$parcel$export(module.exports, "useGICSidebarForcer", () => $b9ee71960aa9a5de$export$23d2fbe817b1786c);

var $5uXOq = parcelRequire("5uXOq");

var $2gCtH = parcelRequire("2gCtH");

var $5eGnF = parcelRequire("5eGnF");

var $9svjh = parcelRequire("9svjh");

var $5rzqz = parcelRequire("5rzqz");
const $b9ee71960aa9a5de$export$23d2fbe817b1786c = ()=>{
    const [{ minimizableModalView: minimizableModalView, isModalOpen: isModalOpen }] = (0, $5rzqz.useTriggerIssueCreateModal)();
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar, resetDetailView: resetDetailView }] = (0, $2gCtH.useIssueContextActions)();
    const { subscribe: subscribe } = (0, $9svjh.useGICLifeCycleEvents)();
    /*
    Force issue view into sidebar when gic modal is docked or minimized.
    In the case where a gic modal is opened inside a issue view modal, we prevent forcing the issue view into sidebar as this causes weird visual artifacts.
    This is the only scenario where the issue view and gic modal are opened both simultaneously in modal state.
    */ (0, $5uXOq.useEffect)(()=>{
        if (isModalOpen && (minimizableModalView === 'mini' || minimizableModalView === 'minimized')) // Force TMP issue view into sidebar (without saving to local storage)
        setDetailViewAsSidebar(false);
    }, [
        isModalOpen,
        minimizableModalView,
        setDetailViewAsSidebar
    ]);
    (0, $5uXOq.useEffect)(()=>subscribe((0, $5eGnF.GIC_LIFECYCLE_EVENTS).MODAL_CLOSED, async ()=>{
            // Reset TMP issue-view's view mode to its previous state
            resetDetailView();
        }), [
        resetDetailView,
        subscribe
    ]);
};

});
parcelRegister("5eGnF", function(module, exports) {

$parcel$export(module.exports, "GIC_LIFECYCLE_EVENTS", () => $700db8c378cd19d9$export$876003a5b887f37e);
const $700db8c378cd19d9$export$876003a5b887f37e = {
    MODAL_OPENED: 'MODAL_OPENED',
    MODAL_CLOSED: 'MODAL_CLOSED',
    MODAL_KEEP_EDITING_EXISTING_ISSUE: 'MODAL_KEEP_EDITING',
    MODAL_DISCARD_EXISTING_IN_PROGRESS_ISSUE: 'MODAL_DISCARD',
    MODAL_DISCARD_SUGGESTED_ISSUE: 'MODAL_DISCARD_SUGGESTED_ISSUE',
    MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES: 'MODAL_DISCARD_SUGGESTED_ISSUE_CHANGES',
    MODAL_DISCARD_ALL_SUGGESTED_ISSUES: 'MODAL_DISCARD_ALL_SUGGESTED_ISSUES',
    CREATE_FORM_FIELD_CONFIG_UPDATE: 'CREATE_FORM_FIELD_CONFIG_UPDATE',
    CREATE_FORM_FIELD_VALUE_CHANGE: 'CREATE_FORM_FIELD_VALUE_CHANGE',
    ISSUE_CREATE_SUCCESS: 'ISSUE_CREATE_SUCCESS',
    PROJECT_FIELD_VALUE_CHANGE: 'PROJECT_FIELD_VALUE_CHANGE',
    ISSUE_TYPE_FIELD_VALUE_CHANGE: 'ISSUE_TYPE_FIELD_VALUE_CHANGE',
    RESET_FORM_FIELDS_FOR_CREATE_ANOTHER: 'RESET_FORM_FIELDS_FOR_CREATE_ANOTHER',
    USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE: 'USE_TRIGGER_ISSUE_CREATE_MODAL_STATE_CHANGE',
    STATUS_FIELD_STATE_CHANGE: 'STATUS_FIELD_STATE_CHANGE',
    CREATE_FORM_FIELD_BLUR: 'CREATE_FORM_FIELD_BLUR',
    CLASSIFICATION_LEVEL_FIELD_CHANGE: 'CLASSIFICATION_LEVEL_FIELD_CHANGE',
    FORM_CONTEXT_STATE_CHANGE: 'FORM_CONTEXT_STATE_CHANGE'
};

});

parcelRegister("9svjh", function(module, exports) {

$parcel$export(module.exports, "useGICLifeCycleEvents", () => $d9b2e43e4699b192$export$e3ff72f196296fcc);

var $1mrD8 = parcelRequire("1mrD8");
const $d9b2e43e4699b192$var$GICLifeCycleEventsService = new (0, $1mrD8.PubSubHub)();
const $d9b2e43e4699b192$export$e3ff72f196296fcc = ()=>({
        ...$d9b2e43e4699b192$var$GICLifeCycleEventsService
    });

});
parcelRegister("1mrD8", function(module, exports) {

$parcel$export(module.exports, "PubSubHub", () => $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e);
class $6e9a69c6f6f4fcfe$export$e3607828f8f2c01e {
    constructor(){
        this.subscribers = {};
        this.subscribe = (event, subscriber)=>{
            let subs = this.subscribers[event];
            if (!subs) {
                subs = [];
                this.subscribers[event] = subs;
            }
            subs?.push(subscriber);
            return ()=>this.unsubscribe(event, subscriber);
        };
        this.unsubscribe = (event, subscriber)=>{
            const subs = this.subscribers[event];
            if (subs) this.subscribers[event] = subs.filter((subscription)=>subscription !== subscriber);
        };
        this.publish = (event, data)=>{
            const subs = this.subscribers[event];
            if (subs?.length) subs?.forEach((subscriber)=>subscriber(data));
        };
        this.clearAll = ()=>{
            this.subscribers = {};
        };
    }
}

});



parcelRegister("4wbGn", function(module, exports) {

$parcel$export(module.exports, "useOpenTeamAssociationModal", () => $317ac2d769460958$export$e01903ed0148a5de);

var $5uXOq = parcelRequire("5uXOq");

var $jbAX5 = parcelRequire("jbAX5");

var $67sX6 = parcelRequire("67sX6");

var $fyeGd = parcelRequire("fyeGd");

var $cPGP0 = parcelRequire("cPGP0");

var $63LqY = parcelRequire("63LqY");
const $317ac2d769460958$export$e01903ed0148a5de = ()=>{
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const teams = (0, $67sX6.useBoardSelector)((0, $cPGP0.getTeams));
    const numberOfIterations = Object.keys((0, $67sX6.useBoardSelector)((0, $fyeGd.getColumns))).length - 1;
    const dispatch = (0, $67sX6.useBoardDispatch)();
    (0, $5uXOq.useEffect)(()=>{
        if (isIncrementPlanningBoard && teams) {
            const teamArray = Object.values(teams);
            if (teamArray.length > 0) for (const team of teamArray){
                const numberOfTeamIterations = team.sprintByIterationId && Object.keys(team.sprintByIterationId).length;
                if (numberOfTeamIterations && numberOfTeamIterations > 0 && numberOfTeamIterations < numberOfIterations) {
                    dispatch((0, $jbAX5.openTeamAssociationModal)(team.id));
                    return;
                }
            }
        }
    }, [
        dispatch,
        isIncrementPlanningBoard,
        numberOfIterations,
        teams
    ]);
};

});

parcelRegister("gUmfi", function(module, exports) {

$parcel$export(module.exports, "useProgramBoardEmptyStates", () => $88ede5aca63c85b8$export$f2d7e0ff237d24ef);

var $5uXOq = parcelRequire("5uXOq");

var $jgOYa = parcelRequire("jgOYa");

var $SDugp = parcelRequire("SDugp");

var $ffPNU = parcelRequire("ffPNU");

var $67sX6 = parcelRequire("67sX6");

var $1vXOx = parcelRequire("1vXOx");

var $k8auG = parcelRequire("k8auG");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $63LqY = parcelRequire("63LqY");
const $88ede5aca63c85b8$export$f2d7e0ff237d24ef = (height)=>{
    const isIncrementPlanningBoard = (0, $63LqY.useIsIncrementPlanningBoard)();
    const isIncrementPlanning404 = (0, $67sX6.useBoardSelector)((0, $k8auG.isIpBoardFailed));
    const planId = (0, $67sX6.useBoardSelector)((0, $67Z81.getPlanId));
    const boardScopeFilter = (0, $67sX6.useBoardSelector)((0, $67Z81.getBoardScopeFilter));
    const isReadOnly = (0, $67sX6.useBoardSelector)((0, $1vXOx.isIncrementPlanningReadOnly));
    // This change is added because on this branch there's no router resource
    const isLoaded = (0, $67sX6.useBoardSelector)((0, $5mTgl.isBoardConfigLoaded));
    return (0, $5uXOq.useMemo)(()=>{
        if (!isIncrementPlanningBoard) return null;
        if (isIncrementPlanning404) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $SDugp.default), null);
        /**
		 * In program boards of Plans, we always use the JSW board header in compact mode,
		 * therefore we use a different board skeleton which does NOT include placeholders
		 * for page breadcrumbs, page title and board top header actions.
		 */ if (!isLoaded) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ffPNU.ProgramBoardSkeleton), null);
        // Show error screen if custom field not set correctly in program board
        if (boardScopeFilter && boardScopeFilter.filterFieldError) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgOYa.default), {
            height: height,
            planId: planId,
            boardScopeFilter: boardScopeFilter,
            isReadOnly: isReadOnly
        });
        return null;
    }, [
        isIncrementPlanningBoard,
        isIncrementPlanning404,
        isLoaded,
        boardScopeFilter,
        planId,
        isReadOnly,
        height
    ]);
};

});
parcelRegister("jgOYa", function(module, exports) {

$parcel$export(module.exports, "default", () => $23f67c0860ec24b3$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $4jAPy = parcelRequire("4jAPy");

var $75MXX = parcelRequire("75MXX");

var $1waMP = parcelRequire("1waMP");

var $7Vlm5 = parcelRequire("7Vlm5");

var $9j19P = parcelRequire("9j19P");
const $23f67c0860ec24b3$var$ProgramBoardCustomFieldError = ({ planId: planId, height: height, boardScopeFilter: boardScopeFilter, isReadOnly: isReadOnly })=>{
    let errorScreen;
    switch(boardScopeFilter.filterFieldError){
        case (0, $4jAPy.FILTER_FIELD_ERROR).NOT_IN_PLAN:
            errorScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1waMP.default), {
                planId: planId,
                customFieldId: boardScopeFilter.filterFieldId,
                customFieldName: boardScopeFilter.filterFieldName,
                isReadOnly: isReadOnly
            });
            break;
        case (0, $4jAPy.FILTER_FIELD_ERROR).OPTION_NOT_FOUND:
            errorScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7Vlm5.default), {
                customFieldName: boardScopeFilter.filterFieldName,
                isReadOnly: isReadOnly
            });
            break;
        case (0, $4jAPy.FILTER_FIELD_ERROR).NOT_FOUND:
            errorScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $75MXX.default), {
                isReadOnly: isReadOnly
            });
            break;
        default:
            errorScreen = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9j19P.default), {
                customFieldName: boardScopeFilter.filterFieldName,
                isReadOnly: isReadOnly
            });
            break;
    }
    if (height) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($23f67c0860ec24b3$var$Wrapper, {
        height: height
    }, errorScreen);
    return errorScreen;
};
// Need to use style attribute as it's dynamic values.
// See https://atlassian.design/components/eslint-plugin-ui-styling-standard/no-dynamic-styles/usage
const $23f67c0860ec24b3$var$styles = null;
const $23f67c0860ec24b3$var$Wrapper = ({ height: height, children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", {
        style: {
            height: height
        },
        className: (0, $bwpsq.default)([
            "_1e0c1txw _4cvr1h6o"
        ])
    }, children);
var $23f67c0860ec24b3$export$2e2bcd8739ae039 = $23f67c0860ec24b3$var$ProgramBoardCustomFieldError;

});
parcelRegister("75MXX", function(module, exports) {

$parcel$export(module.exports, "default", () => $05d7af701bfd033e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $kjIEI = parcelRequire("kjIEI");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gZK1Z = parcelRequire("gZK1Z");

var $9TVV0 = parcelRequire("9TVV0");

var $2C9Uz = parcelRequire("2C9Uz");

var $4xTtj = parcelRequire("4xTtj");
const $05d7af701bfd033e$var$ProgramBoardCustomFieldNotFound = ({ isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { incrementId: incrementId } = (0, $9TVV0.usePlanPathParams)();
    const renderPrimaryAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Uz.default), {
            boardId: Number(incrementId),
            triggerLabel: formatMessage((0, $gZK1Z.default).backToBoards),
            isReadOnly: isReadOnly
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $kjIEI.default)),
        header: formatMessage((0, $4xTtj.default).title),
        description: formatMessage((0, $4xTtj.default).description),
        primaryAction: renderPrimaryAction()
    }));
};
var $05d7af701bfd033e$export$2e2bcd8739ae039 = $05d7af701bfd033e$var$ProgramBoardCustomFieldNotFound;

});
parcelRegister("kjIEI", function(module, exports) {

$parcel$export(module.exports, "default", () => $b511ca53b54ba8ce$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = 748pv5qrn493bqk8kv9zvsnq
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/748pv5qrn493bqk8kv9zvsnq

var $dCLgq = parcelRequire("dCLgq");

var $aKIsO = parcelRequire("aKIsO");

var $47SnX = parcelRequire("47SnX");
/** @deprecated cf. https://hello.atlassian.net/wiki/spaces/IMKT/pages/743859674/Empty+state+and+Error+state+guidelines */ const $b511ca53b54ba8ce$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($47SnX)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($aKIsO))
});
var $b511ca53b54ba8ce$export$2e2bcd8739ae039 = $b511ca53b54ba8ce$var$Illustration;
// for advanced use only
const $b511ca53b54ba8ce$export$a179c88182cb9d56 = [
    0,
    0,
    208,
    190
];

});
parcelRegister("aKIsO", function(module, exports) {
module.exports = new URL("search-no-results-old-darkmode.41158025.svg", import.meta.url).toString();

});

parcelRegister("47SnX", function(module, exports) {
module.exports = new URL("search-no-results-old.10b14394.svg", import.meta.url).toString();

});


parcelRegister("iVgQf", function(module, exports) {

$parcel$export(module.exports, "getAkEmptyStateRenderImageFn", () => $7affac5c7e698fc8$export$ebf64b9217c1b2a3);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
var $lD23V = parcelRequire("lD23V");

var $4Bpvs = parcelRequire("4Bpvs");
function $7affac5c7e698fc8$export$ebf64b9217c1b2a3(JiraIllustration = (0, $4Bpvs.default)) {
    return ({ maxImageWidth: // we strictly follow EmptyState's defaults
    maxImageWidth = 160, maxImageHeight: maxImageHeight = 160, imageWidth: imageWidth, imageHeight: imageHeight })=>{
        // This wrapper emulates EmptyState's private "HeaderImage" styling
        // @see platform/packages/design-system/empty-state/src/empty-state.tsx
        // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
        const Wrapper = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
                ...__cmplp,
                style: {
                    ...__cmpls,
                    "--_yv3y2x": (0, $lD23V.default)(maxImageWidth, "px"),
                    "--_nq7wev": (0, $lD23V.default)(maxImageHeight, "px")
                },
                ref: __cmplr,
                className: (0, $bwpsq.default)([
                    "_1e0c1ule _p12f1x6a _c71lc3ce _19pkidpf _2hwx1wug _otyr1ejb _18u01wug",
                    __cmplp.className
                ])
            });
        });
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(Wrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(JiraIllustration, {
            alt: "",
            role: "presentation",
            width: imageWidth || 'auto',
            height: imageHeight || 'auto'
        }));
    };
}

});
parcelRegister("4Bpvs", function(module, exports) {

$parcel$export(module.exports, "default", () => $029e22a35a3f42f7$export$2e2bcd8739ae039);
$parcel$export(module.exports, "srcLight", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("gZXfK")))));
$parcel$export(module.exports, "srcDark", () => (/*@__PURE__*/$parcel$interopDefault((parcelRequire("ieXL6")))));
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = tgxxcm73mk6phg9ttfj3rvpf
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/tgxxcm73mk6phg9ttfj3rvpf

var $dCLgq = parcelRequire("dCLgq");

var $ieXL6 = parcelRequire("ieXL6");

var $gZXfK = parcelRequire("gZXfK");
const $029e22a35a3f42f7$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($gZXfK)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($ieXL6))
});
var $029e22a35a3f42f7$export$2e2bcd8739ae039 = $029e22a35a3f42f7$var$Illustration;
// for advanced use only
const $029e22a35a3f42f7$export$a179c88182cb9d56 = [
    0,
    0,
    235,
    210
];

});
parcelRegister("ieXL6", function(module, exports) {
module.exports = new URL("generic-empty-state-darkmode.27f5dcf1.svg", import.meta.url).toString();

});

parcelRegister("gZXfK", function(module, exports) {
module.exports = new URL("generic-empty-state.1b007192.svg", import.meta.url).toString();

});



parcelRegister("9TVV0", function(module, exports) {

$parcel$export(module.exports, "useIncrementsLink", () => $9c909061939eb868$export$a07f720473256a7f);
$parcel$export(module.exports, "usePlanPathParams", () => $9c909061939eb868$export$c7baf9eb4a95d70);

var $bmKPg = parcelRequire("bmKPg");
const $9c909061939eb868$export$a07f720473256a7f = ()=>{
    const [planId] = (0, $bmKPg.usePathParam)('planId');
    const [scenarioId] = (0, $bmKPg.usePathParam)('scenarioId');
    return `/jira/plans/${planId}/scenarios/${scenarioId}/program`;
};
const $9c909061939eb868$export$c7baf9eb4a95d70 = ()=>{
    const [planId] = (0, $bmKPg.usePathParam)('planId');
    const [scenarioId] = (0, $bmKPg.usePathParam)('scenarioId');
    const [incrementId] = (0, $bmKPg.usePathParam)('incrementId');
    return {
        planId: planId,
        scenarioId: scenarioId,
        incrementId: incrementId
    };
};

});

parcelRegister("2C9Uz", function(module, exports) {

$parcel$export(module.exports, "default", () => $61593dc1a66f4fa0$export$2e2bcd8739ae039);
$parcel$export(module.exports, "AsyncBoardSwitcher", () => $61593dc1a66f4fa0$export$a950beb4c411b3b6);

var $5uXOq = parcelRequire("5uXOq");

var $fn8B5 = parcelRequire("fn8B5");

var $2NMNM = parcelRequire("2NMNM");

var $eCeGD = parcelRequire("eCeGD");

var $BLPHT = parcelRequire("BLPHT");
var $6B7KL = parcelRequire("6B7KL");
var $aRoVz = parcelRequire("aRoVz");

var $c8Oei = parcelRequire("c8Oei");

var $dC5iT = parcelRequire("dC5iT");
var $h9kUS = parcelRequire("h9kUS");
var $luBm6 = parcelRequire("luBm6");
var $8CUq3 = parcelRequire("8CUq3");

var $cSD7y = parcelRequire("cSD7y");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $7CnwK = parcelRequire("7CnwK");

var $8zOmE = parcelRequire("8zOmE");

var $bmKPg = parcelRequire("bmKPg");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $6hxv7 = parcelRequire("6hxv7");

var $IewZo = parcelRequire("IewZo");

var $fzC6q = parcelRequire("fzC6q");
const $61593dc1a66f4fa0$var$BoardItemOld = ({ board: { id: id, name: name }, currentId: currentId, analyticsEvent: analyticsEvent })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isSelected: id === currentId,
        key: `active-board-${id}`,
        href: (0, $bdYfL.getBoardUrl)(id),
        title: name,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'switchProgramBoard');
        },
        UNSAFE_shouldDisableRouterLink: true
    }, name);
const $61593dc1a66f4fa0$var$BoardItemNew = ({ board: { id: id, name: name }, currentId: currentId, analyticsEvent: analyticsEvent })=>{
    const isEmbed = (0, $7CnwK.useIsPlanEmbed)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        isSelected: id === currentId,
        key: `active-board-${id}`,
        href: (0, $bdYfL.getBoardUrl)(id, isEmbed),
        title: name,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'switchProgramBoard');
        },
        UNSAFE_shouldDisableRouterLink: true
    }, name);
};
const $61593dc1a66f4fa0$var$BoardItem = (0, $cSD7y.componentWithFG)('smart_links_for_plans', $61593dc1a66f4fa0$var$BoardItemNew, $61593dc1a66f4fa0$var$BoardItemOld);
const $61593dc1a66f4fa0$export$35db6e1ecbb84429 = ({ boardId: boardId, defaultOpen: defaultOpen, onOpenCreateModal: onOpenCreateModal, triggerLabel: triggerLabel, isReadOnly: isReadOnly, returnFocusRef: returnFocusRef })=>{
    const [planId] = (0, $bmKPg.usePathParam)('planId');
    const [scenarioId] = (0, $bmKPg.usePathParam)('scenarioId');
    const { increments: increments, isLoading: isLoading } = (0, $6hxv7.useFetchIncrements)({
        planId: planId
    });
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const analyticsEvent = createAnalyticsEvent({
        action: 'clicked',
        actionSubject: 'dropdownItem'
    });
    const currentBoard = (0, $5uXOq.useMemo)(()=>increments?.find(({ id: id })=>id === boardId), [
        increments,
        boardId
    ]);
    const groupedOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($fn8B5)))(increments, 'status'), [
        increments
    ]);
    const activeOptions = groupedOptions.ACTIVE;
    const pastOptions = groupedOptions.PAST;
    const triggerContent = triggerLabel ?? currentBoard?.name;
    const activeBoardLimit = (0, $4R6GH.fg)('jpo_adjust_program_board_active_limit') ? (0, $4jAPy.MAX_ACTIVE_BOARDS) : (0, $4jAPy.MAX_ACTIVE_BOARDS_OLD);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $BLPHT.default), {
        trigger: ({ triggerRef: triggerRef, ...props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                ref: triggerRef,
                xcss: $61593dc1a66f4fa0$var$triggerStyles
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
                ...props,
                ref: returnFocusRef,
                isLoading: isLoading,
                iconAfter: (0, (/*@__PURE__*/$parcel$interopDefault($c8Oei))),
                testId: "portfolio-3-plan-increment-common.ui.board-switcher.trigger-button"
            }, triggerContent ?? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
                xcss: $61593dc1a66f4fa0$var$placeholderStyles
            }))),
        returnFocusRef: returnFocusRef,
        shouldRenderToParent: true,
        isLoading: isLoading,
        placement: "bottom-start",
        defaultOpen: defaultOpen,
        ...(0, $4R6GH.fg)('jpo_adjust_program_board_active_limit') ? {
            shouldFlip: false
        } : {}
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
        xcss: (0, $4R6GH.fg)('jpo_adjust_program_board_active_limit') ? $61593dc1a66f4fa0$var$boardGroupStyles : $61593dc1a66f4fa0$var$boardGroupStylesOld
    }, activeOptions && activeOptions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        title: `${formatMessage((0, $fzC6q.default).activeGroupLabel)} (${activeOptions.length}/${activeBoardLimit})`
    }, activeOptions.map((board)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61593dc1a66f4fa0$var$BoardItem, {
            key: `active-board-${board.id}`,
            board: board,
            currentId: currentBoard?.id,
            analyticsEvent: analyticsEvent
        }))), pastOptions && pastOptions.length > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        title: formatMessage((0, $fzC6q.default).pastGroupLabel)
    }, pastOptions.map((board)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61593dc1a66f4fa0$var$BoardItem, {
            key: `past-board-${board.id}`,
            board: board,
            currentId: currentBoard?.id,
            analyticsEvent: analyticsEvent
        })))), !isReadOnly && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $aRoVz.default), {
        hasSeparator: true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        testId: "portfolio-3-plan-increment-common.ui.board-switcher.create-button",
        isDisabled: activeOptions && activeOptions.length >= activeBoardLimit,
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'createProgramBoard');
            onOpenCreateModal();
        }
    }, formatMessage((0, $fzC6q.default).createProgramBoard)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6B7KL.default), {
        testId: "portfolio-3-plan-increment-common.ui.board-switcher.manage-button",
        href: (0, $bdYfL.getManageBoardSettingsUrl)(planId, scenarioId),
        title: formatMessage((0, $fzC6q.default).manageProgramBoardsTitle),
        onClick: ()=>{
            (0, $8zOmE.fireUIAnalytics)(analyticsEvent, 'manageProgramBoards');
        },
        UNSAFE_shouldDisableRouterLink: true
    }, formatMessage((0, $fzC6q.default).manageProgramBoards))));
};
const $61593dc1a66f4fa0$var$BoardSwitcher = ({ boardId: boardId, defaultOpen: defaultOpen, triggerLabel: triggerLabel, isReadOnly: isReadOnly })=>{
    const [isCreateBoardModalOpen, setIsCreateBoardModalOpen] = (0, $5uXOq.useState)(false);
    const openCreateBoardModal = ()=>{
        setIsCreateBoardModalOpen(true);
    };
    const closeCreateBoardModal = ()=>{
        setIsCreateBoardModalOpen(false);
    };
    const onIncrementCreated = (newBoard)=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.replace((0, $bdYfL.getBoardUrl)(newBoard.id));
    };
    const returnFocusRef = (0, $5uXOq.useRef)(null);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $IewZo.default), {
        onIncrementCreated: onIncrementCreated,
        isOpen: isCreateBoardModalOpen,
        onClose: closeCreateBoardModal,
        returnFocusRef: returnFocusRef
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61593dc1a66f4fa0$export$35db6e1ecbb84429, {
        boardId: boardId,
        defaultOpen: defaultOpen,
        onOpenCreateModal: openCreateBoardModal,
        triggerLabel: triggerLabel,
        isReadOnly: isReadOnly,
        returnFocusRef: returnFocusRef
    }));
};
var $61593dc1a66f4fa0$export$2e2bcd8739ae039 = $61593dc1a66f4fa0$var$BoardSwitcher;
const $61593dc1a66f4fa0$export$a950beb4c411b3b6 = ({ props: props })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($61593dc1a66f4fa0$var$BoardSwitcher, props);
const $61593dc1a66f4fa0$var$boardGroupStylesOld = (0, $8CUq3.xcss)({
    maxHeight: '600px',
    overflow: 'auto',
    textAlign: 'left'
});
const $61593dc1a66f4fa0$var$boardGroupStyles = (0, $8CUq3.xcss)({
    maxHeight: '400px',
    overflow: 'auto',
    textAlign: 'left'
});
const $61593dc1a66f4fa0$var$triggerStyles = (0, $8CUq3.xcss)({
    marginLeft: 'space.200',
    maxWidth: '175px',
    [(0, $h9kUS.media).above.md]: {
        maxWidth: '240px'
    },
    [(0, $h9kUS.media).above.lg]: {
        maxWidth: '280px'
    }
});
const $61593dc1a66f4fa0$var$placeholderStyles = (0, $8CUq3.xcss)({
    width: '80px'
});

});
parcelRegister("7CnwK", function(module, exports) {

$parcel$export(module.exports, "isPlanEmbed", () => $cd3a4216f2726f2c$export$263395d7e2de6252);
$parcel$export(module.exports, "useIsPlanEmbed", () => $cd3a4216f2726f2c$export$b9d3e01e19575c1f);

var $lODMY = parcelRequire("lODMY");
const $cd3a4216f2726f2c$export$72c92e5434325ff3 = (path)=>{
    const embedPathRegex = /^\/jira\/plans\/\d+\/scenarios\/\d+\/(timeline|summary|calendar|program\/\d+|dependencies)\/embed$/;
    return embedPathRegex.test(path);
};
const $cd3a4216f2726f2c$export$263395d7e2de6252 = ()=>window && $cd3a4216f2726f2c$export$72c92e5434325ff3(window.location.pathname);
const $cd3a4216f2726f2c$export$b9d3e01e19575c1f = (0, $lODMY.createRouterSelector)(({ location: { pathname: pathname } })=>$cd3a4216f2726f2c$export$72c92e5434325ff3(pathname));

});

parcelRegister("6hxv7", function(module, exports) {

$parcel$export(module.exports, "useFetchIncrements", () => $8d1e4e92884d6028$export$6a3590fbd5adac6d);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $8d1e4e92884d6028$export$6a3590fbd5adac6d = ({ planId: planId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(true);
    const [increments, setIncrements] = (0, $5uXOq.useState)(null);
    const removeIncrement = (incrementId)=>{
        if (!increments) return;
        const index = increments?.findIndex((increment)=>increment.id === incrementId);
        if (index !== undefined && index > -1) {
            const newIncrements = [
                ...increments
            ];
            newIncrements.splice(index, 1);
            setIncrements(newIncrements);
        }
    };
    const updateIncrement = (incrementId, updates)=>{
        if (!increments) return;
        const index = increments?.findIndex((increment)=>increment.id === incrementId);
        if (index !== undefined && index > -1) {
            const newIncrements = [
                ...increments
            ];
            newIncrements[index] = {
                ...newIncrements[index],
                ...updates
            };
            setIncrements(newIncrements);
        }
    };
    (0, $5uXOq.useEffect)(()=>{
        (async ()=>{
            try {
                if (!planId) throw new Error('planId is empty in the fetch increments request');
                const res = await (0, $eusud.performGetRequest)(`/rest/jpo/2.0/plans/${planId}/increments`);
                if (res && Array.isArray(res)) setIncrements(res);
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            } catch (error) {
                (0, $jcw0u.default)({
                    meta: {
                        id: (0, $4jAPy.SERVICES_ERROR_ID),
                        packageName: (0, $4jAPy.PACKAGE_NAME),
                        teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
                    },
                    attributes: {
                        serviceName: 'useFetchIncrements'
                    },
                    error: error,
                    sendToPrivacyUnsafeSplunk: true
                });
            } finally{
                setIsLoading(false);
            }
        })();
    }, [
        setIncrements,
        setIsLoading,
        planId
    ]);
    return {
        isLoading: isLoading,
        increments: increments,
        removeIncrement: removeIncrement,
        updateIncrement: updateIncrement
    };
};

});

parcelRegister("IewZo", function(module, exports) {

$parcel$export(module.exports, "default", () => $ebca1acda4a784ab$export$2e2bcd8739ae039);
/* index.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $fWqG2 = parcelRequire("fWqG2");

var $2NMNM = parcelRequire("2NMNM");

var $fVnbM = parcelRequire("fVnbM");

var $ldJSL = parcelRequire("ldJSL");

var $htnpT = parcelRequire("htnpT");

var $efXp3 = parcelRequire("efXp3");
var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $3lQ26 = parcelRequire("3lQ26");

var $l1N8i = parcelRequire("l1N8i");

var $84THj = parcelRequire("84THj");

var $e4yMr = parcelRequire("e4yMr");

var $7QSqG = parcelRequire("7QSqG");
var $juxqI = parcelRequire("juxqI");
var $jgVsb = parcelRequire("jgVsb");
var $gofOI = parcelRequire("gofOI");
var $i8Qvm = parcelRequire("i8Qvm");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $luBm6 = parcelRequire("luBm6");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $92Z2l = parcelRequire("92Z2l");

var $7K5PP = parcelRequire("7K5PP");

var $kY99m = parcelRequire("kY99m");

var $7NYq5 = parcelRequire("7NYq5");

var $hO2mG = parcelRequire("hO2mG");

var $gwIPs = parcelRequire("gwIPs");

var $6s1PB = parcelRequire("6s1PB");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $iXVV6 = parcelRequire("iXVV6");
var $5oFIy = parcelRequire("5oFIy");
var $8zOmE = parcelRequire("8zOmE");

var $DVljb = parcelRequire("DVljb");

var $4jAPy = parcelRequire("4jAPy");

var $bdYfL = parcelRequire("bdYfL");

var $1FeOe = parcelRequire("1FeOe");

var $ivHJ6 = parcelRequire("ivHJ6");

var $h9qPG = parcelRequire("h9qPG");

var $1bxch = parcelRequire("1bxch");

var $7pWV1 = parcelRequire("7pWV1");

var $84ylG = parcelRequire("84ylG");

var $7gW1a = parcelRequire("7gW1a");

var $iHezY = parcelRequire("iHezY");
const $ebca1acda4a784ab$var$DOC_LINK = 'https://support.atlassian.com/jira-software-cloud/docs/create-a-new-program-board-in-your-plan/';
const $ebca1acda4a784ab$var$IncrementCreation = ({ onIncrementCreated: onIncrementCreated, isOpen: isOpen = false, onClose: onClose, returnFocusRef: returnFocusRef })=>{
    const { saving: saving, error: error, save: save } = (0, $ivHJ6.useIncrementCreationService)();
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const locale = (0, $DVljb.useLocale)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $2NMNM.useAnalyticsEvents)();
    const handleCancelButtonClick = (0, $5uXOq.useCallback)(()=>{
        onClose();
    }, [
        onClose
    ]);
    const focusRef = (0, $5uXOq.useRef)();
    const getStartDate = (0, $5uXOq.useCallback)(()=>(0, $7gW1a.getNextQuarterStartDate)(new Date()), []);
    const handleSubmitForm = (0, $5uXOq.useCallback)(async (data)=>{
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        const errorMessages = {};
        if ((data.name?.length || 0) < 1) errorMessages.name = formatMessage((0, $iHezY.default).nameEmptyError);
        if ((data.start?.length || 0) < 1) errorMessages.start = (0, $4R6GH.fg)('jpo_a11y_pb_fixes') ? formatMessage((0, $iHezY.default).startDateAndTimeEmptyError) : formatMessage((0, $iHezY.default).startDateEmptyError);
        if (!(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(data.filterFieldId) && (0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(data.filterFieldValue)) errorMessages.filterFieldValue = formatMessage((0, $iHezY.default).fieldValueEmptyError);
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(data.name) || (0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(data.start) || Object.keys(errorMessages).length > 0) return errorMessages;
        const newBoard = {
            name: data.name,
            start: new Date(data.start).getTime(),
            iterationsCount: data.iterationsCount?.value,
            iterationLength: data.iterationLength?.value,
            filterFieldId: data.filterFieldId?.value,
            filterFieldValue: data.filterFieldValue?.value
        };
        const result = await save(newBoard);
        if (result !== undefined) {
            const attributes = {
                iterationLength: data.iterationLength?.value,
                iterationsCount: data.iterationsCount?.value,
                ...(0, $4R6GH.fg)('program_board_misc_improvements') && {
                    newScopeFilterType: (0, $bdYfL.getBoardScopeFilterType)(result.boardScopeFilter)
                }
            };
            onIncrementCreated(result);
            (0, $8zOmE.fireUIAnalytics)(createAnalyticsEvent({
                action: 'added',
                actionSubject: 'programBoard'
            }), {
                ...attributes
            });
            onClose();
        }
    }, [
        save,
        onIncrementCreated,
        onClose,
        formatMessage,
        createAnalyticsEvent
    ]);
    const scopeFilterMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iHezY.default).scopeFilterDescriptionIssueTermRefresh : (0, $iHezY.default).scopeFilterDescription;
    const scopeFilterDescription = formatMessage(scopeFilterMessage, {
        bold: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("b", null, chunks),
        link: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
                href: (0, $4jAPy.DOC_LINKS).PROGRAM_BOARD_RECOMMENDATIONS,
                target: "_blank"
            }, chunks)
    });
    const iterationLengthOptions = [
        {
            label: formatMessage((0, $1FeOe.default).weeksOption, {
                count: 1
            }),
            value: 1
        },
        {
            label: formatMessage((0, $1FeOe.default).weeksOption, {
                count: 2
            }),
            value: 2
        },
        {
            label: formatMessage((0, $1FeOe.default).weeksOption, {
                count: 3
            }),
            value: 3
        },
        {
            label: formatMessage((0, $1FeOe.default).weeksOption, {
                count: 4
            }),
            value: 4
        }
    ];
    const defaultLengthOption = iterationLengthOptions.find(({ value: value })=>value === (0, $4jAPy.DEFAULT_ITERATION_LENGTH));
    const filterHeadingMessage = (0, $6s1PB.expVal)('issue-terminology-refresh-m2-replace', 'isEnabled', false) ? (0, $iHezY.default).scopeFilterHeadingIssueTermRefresh : (0, $iHezY.default).scopeFilterHeading;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $iXVV6.ContextualAnalyticsData), {
        sourceName: "incrementCreation",
        sourceType: (0, $4d5e0871c06cee03$export$1171103ea9083ffa)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $i8Qvm.default), null, isOpen && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7NYq5.JiraModal), {
        messageId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.modal",
        messageType: "transactional",
        onClose: handleCancelButtonClick,
        autoFocus: focusRef,
        shouldReturnFocus: returnFocusRef || true
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $jgVsb.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gofOI.default), null, formatMessage((0, $iHezY.default).addIncrementTitle)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $ebca1acda4a784ab$var$paragraphStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, formatMessage((0, $iHezY.default).addIncrementDescriptionNew), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("br", null), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $e4yMr.default), {
        href: $ebca1acda4a784ab$var$DOC_LINK,
        target: "_blank"
    }, formatMessage((0, $iHezY.default).doclink)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebca1acda4a784ab$var$ModalClose, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
        appearance: "link",
        spacing: "none",
        onClick: handleCancelButtonClick
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($84THj))), {
        spacing: "spacious",
        label: formatMessage((0, $iHezY.default).closeModal),
        color: "var(--ds-text-subtle, #44546F)"
    })))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $efXp3.default), {
        onSubmit: handleSubmitForm
    }, ({ formProps: formProps, submitting: submitting })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($ebca1acda4a784ab$var$FormStyled, formProps, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7QSqG.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $luBm6.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$FieldBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            "aria-required": true,
            name: "name",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-field",
            label: formatMessage((0, $iHezY.default).nameShort),
            defaultValue: ""
        }, // eslint-disable-next-line @typescript-eslint/no-shadow
        ({ fieldProps: fieldProps, error: error, valid: valid })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kY99m.default), {
                autoComplete: "off",
                placeholder: formatMessage((0, $iHezY.default).namePlaceholder),
                maxLength: 255,
                ...fieldProps,
                ref: focusRef
            }), valid || error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), {
                testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.user-submission-error"
            }, error)))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$FieldBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            "aria-required": true,
            name: "start",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-field",
            label: formatMessage((0, $iHezY.default).startDateShort),
            defaultValue: getStartDate()
        }, // eslint-disable-next-line @typescript-eslint/no-shadow
        ({ fieldProps: fieldProps, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $htnpT.default), {
                ...fieldProps,
                locale: locale,
                datePickerProps: {
                    weekStartDay: (0, $7gW1a.getWeekStartDay)(locale),
                    ...(0, $4R6GH.fg)('jpo_a11y_pb_fixes') && {
                        label: formatMessage((0, $iHezY.default).startDateShort)
                    }
                },
                timePickerProps: {
                    times: (0, $hO2mG.getDefaultTimes)(),
                    ...(0, $4R6GH.fg)('jpo_a11y_pb_fixes') && {
                        label: formatMessage((0, $iHezY.default).startTime)
                    }
                },
                testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-picker"
            }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$FieldBoxStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $iHezY.default).iterationLength),
            name: "iterationLength",
            defaultValue: defaultLengthOption
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
                ...fieldProps,
                options: iterationLengthOptions,
                styles: {
                    menuPortal: (base)=>({
                            ...base,
                            zIndex: (0, $gwIPs.layers).modal
                        })
                },
                menuPortalTarget: document.body
            }))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$FieldBoxStyles
        }, ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
            label: formatMessage((0, $iHezY.default).iterationsCount),
            name: "iterationsCount",
            defaultValue: (0, $4jAPy.ITERATIONS_COUNT_OPTIONS).find(({ value: value })=>value === (0, $4jAPy.DEFAULT_ITERATIONS_COUNT))
        }, ({ fieldProps: fieldProps })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $84ylG.default), fieldProps))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1bxch.default), null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lQ26.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $l1N8i.default), {
            size: "medium",
            as: "h2"
        }, formatMessage(filterHeadingMessage)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$paragraphStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, scopeFilterDescription)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
            spread: "space-between",
            space: "space.100"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9qPG.ScopeFilterField), {
            shouldFetchCustomFields: isOpen
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $h9qPG.ScopeFilterValue), null))), !(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(error) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3lQ26.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $92Z2l.default), {
            appearance: "error"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
            xcss: $ebca1acda4a784ab$var$paragraphStyles
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
            as: "p"
        }, formatMessage((0, $iHezY.default).errorLabel)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $juxqI.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7pWV1.default), {
            initialStartDate: getStartDate()
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ldJSL.default), null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            appearance: "subtle",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.cancel-button",
            onClick: handleCancelButtonClick,
            isDisabled: saving || submitting
        }, formatMessage((0, $iHezY.default).cancel)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $fVnbM.default), {
            type: "submit",
            testId: "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.submit-button",
            appearance: "primary",
            isDisabled: saving || submitting
        }, formatMessage((0, $iHezY.default).submit)))))), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $5oFIy.FireScreenAnalytics), null))));
};
var $ebca1acda4a784ab$export$2e2bcd8739ae039 // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
 = $ebca1acda4a784ab$var$IncrementCreation;
const $ebca1acda4a784ab$var$ModalClose = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_1wpz1y6m",
            __cmplp.className
        ])
    });
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $ebca1acda4a784ab$var$FormStyled = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: C = "form", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $bwpsq.default)([
            "_19pkidpf",
            __cmplp.className
        ])
    });
});
const $ebca1acda4a784ab$var$FieldBoxStyles = (0, $8CUq3.xcss)({
    width: '50%'
});
const $ebca1acda4a784ab$var$paragraphStyles = (0, $8CUq3.xcss)({
    marginTop: 'space.150'
});

});
parcelRegister("fWqG2", function(module, exports) {

var $lVx1a = parcelRequire("lVx1a");


var $b9b0f74db222943d$var$func = $lVx1a('isNil', (parcelRequire("hGgHi")), (parcelRequire("bUoRH")));

$b9b0f74db222943d$var$func.placeholder = (parcelRequire("aPsMW"));
module.exports = $b9b0f74db222943d$var$func;

});
parcelRegister("bUoRH", function(module, exports) {
module.exports = {
    'cap': false,
    'curry': false,
    'fixed': false,
    'immutable': false,
    'rearg': false
};

});


parcelRegister("htnpT", function(module, exports) {

$parcel$export(module.exports, "default", () => $fa2698ee0cdd579e$export$2e2bcd8739ae039);

var $VSDnB = parcelRequire("VSDnB");

var $cKsfY = parcelRequire("cKsfY");

var $9Lqvx = parcelRequire("9Lqvx");

var $hB1kl = parcelRequire("hB1kl");
const $fa2698ee0cdd579e$var$DateTimePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-time-picker-use-functional-component'), (0, $hB1kl.default), (0, $9Lqvx.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$fa2698ee0cdd579e$export$2e2bcd8739ae039 = $fa2698ee0cdd579e$var$DateTimePicker;

});
parcelRegister("cKsfY", function(module, exports) {

$parcel$export(module.exports, "componentWithCondition", () => $8f027f90da2b6bac$export$6e8ea24b15199873);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");
function $8f027f90da2b6bac$export$6e8ea24b15199873(condition, ComponentTrue, ComponentFalse) {
    const ComponentWithCondition = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>condition() ? /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentTrue, {
            ...props,
            ref: ref
        }) : /*#__PURE__*/ (0, $2OMIu.jsx)(ComponentFalse, {
            ...props,
            ref: ref
        }));
    if (ComponentTrue.name !== '') ComponentWithCondition.displayName = `ComponentWithCondition[${condition.name}]`;
    return ComponentWithCondition;
}

});

parcelRegister("9Lqvx", function(module, exports) {

$parcel$export(module.exports, "default", () => $597f1543018f8252$export$2e2bcd8739ae039);
/* date-time-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
const $597f1543018f8252$var$DatePicker = (0, $cKsfY.componentWithCondition)(()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $597f1543018f8252$var$packageName = "platform-pkg";
const $597f1543018f8252$var$packageVersion = "0.0.0-use.local";
const $597f1543018f8252$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_19itglyw _v564vrg3 _1e0c1txw _4cvr1h6o _i0dl1kw7 _bfhk1kw7 _syaz131l _6rthe4h9 _1pfhe4h9 _12l2e4h9 _ahbqe4h9 _85i512x7 _1q5112x7 _y4tiu2gc _bozg1b66 _30l31gjq"
}; // react-select overrides (via @atlaskit/select).
const $597f1543018f8252$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $597f1543018f8252$var$dateTimePickerDefaultProps = {
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $597f1543018f8252$export$3b559a1219cb3c27 = 'Date';
const $597f1543018f8252$export$d82cc7e53d68a428 = 'Time'; // eslint-disable-next-line @repo/internal/react/no-class-components
class $597f1543018f8252$export$732a1726f0a3523b extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    static{
        this.defaultProps = $597f1543018f8252$var$dateTimePickerDefaultProps;
    }
    parseValue(value, dateValue, timeValue, zoneValue) {
        if (this.props.parseValue) {
            const parsedFromFn = this.props.parseValue(value, dateValue, timeValue, zoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: dateValue,
                timeValue: timeValue,
                zoneValue: zoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }
    onValueChange({ dateValue: dateValue, timeValue: timeValue, zoneValue: zoneValue }) {
        this.setState({
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        });
        if (dateValue && timeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, zoneValue);
            const { zoneValue: parsedZone } = this.parseValue(value, dateValue, timeValue, zoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(dateValue, timeValue, parsedZone);
            this.setState({
                value: valueWithValidZone
            });
            this.props.onChange?.(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (this.getValue()) {
            this.setState({
                value: ''
            });
            this.props.onChange?.('');
        }
    }
    render() {
        const { 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerProps = {}, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, locale: locale = 'en-US', name: name = '', spacing: spacing = 'default', testId: testId, timePickerProps: timePickerProps = {} } = this.props;
        const value = this.getValue();
        const { isFocused: isFocused } = this.state;
        const parsedValues = this.getParsedValues();
        const dateValue = parsedValues?.dateValue;
        const timeValue = parsedValues?.timeValue;
        const datePickerSelectProps = datePickerProps?.selectProps;
        const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
        const datePickerLabel = datePickerProps.label || $597f1543018f8252$export$3b559a1219cb3c27;
        const mergedDatePickerSelectProps = {
            ...datePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, datePickerSelectProps?.styles)
        };
        const timePickerSelectProps = timePickerProps?.selectProps;
        const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
        const timePickerLabel = timePickerProps.label || $597f1543018f8252$export$d82cc7e53d68a428;
        const mergedTimePickerSelectProps = {
            ...timePickerSelectProps,
            styles: (0, $7VXAu.mergeStyles)($597f1543018f8252$var$styles, timePickerSelectProps?.styles)
        }; // Render DateTimePicker's IconContainer when a value has been filled
        // Don't use Date or TimePicker's because they can't be customised
        const isClearable = Boolean(dateValue || timeValue);
        return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8JNJx.DateTimePickerContainer), {
            appearance: appearance,
            isDisabled: isDisabled,
            isFocused: isFocused,
            isInvalid: isInvalid,
            testId: testId,
            innerProps: innerProps,
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.datePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)($597f1543018f8252$var$DatePicker, {
                        appearance: appearance,
                        "aria-describedby": datePickerAriaDescribedBy,
                        autoFocus: datePickerProps.autoFocus || autoFocus,
                        dateFormat: datePickerProps.dateFormat,
                        defaultIsOpen: datePickerProps.defaultIsOpen,
                        defaultValue: datePickerProps.defaultValue,
                        disabled: datePickerProps.disabled,
                        disabledDateFilter: datePickerProps.disabledDateFilter,
                        formatDisplayLabel: datePickerProps.formatDisplayLabel,
                        hideIcon: datePickerProps.hideIcon || true,
                        icon: datePickerProps.icon,
                        id: datePickerProps.id || id,
                        innerProps: datePickerProps.innerProps,
                        isDisabled: datePickerProps.isDisabled || isDisabled,
                        isInvalid: datePickerProps.isInvalid || isInvalid,
                        isRequired: datePickerProps.isRequired || isRequired,
                        isOpen: datePickerProps.isOpen,
                        label: datePickerLabel,
                        locale: datePickerProps.locale || locale,
                        maxDate: datePickerProps.maxDate,
                        minDate: datePickerProps.minDate,
                        name: datePickerProps.name,
                        nextMonthLabel: datePickerProps.nextMonthLabel,
                        onBlur: this.onDateBlur,
                        onChange: this.onDateChange,
                        onFocus: this.onDateFocus,
                        parseInputValue: datePickerProps.parseInputValue,
                        placeholder: datePickerProps.placeholder,
                        previousMonthLabel: datePickerProps.previousMonthLabel,
                        selectProps: mergedDatePickerSelectProps,
                        shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                        spacing: datePickerProps.spacing || spacing,
                        testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                        value: dateValue,
                        weekStartDay: datePickerProps.weekStartDay
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.timePickerContainerStyles
                    ]),
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdTq6.default), {
                        appearance: timePickerProps.appearance || appearance,
                        "aria-describedby": timePickerAriaDescribedBy,
                        autoFocus: timePickerProps.autoFocus,
                        defaultIsOpen: timePickerProps.defaultIsOpen,
                        defaultValue: timePickerProps.defaultValue,
                        formatDisplayLabel: timePickerProps.formatDisplayLabel,
                        hideIcon: timePickerProps.hideIcon || true,
                        id: timePickerProps.id,
                        innerProps: timePickerProps.innerProps,
                        isDisabled: timePickerProps.isDisabled || isDisabled,
                        isInvalid: timePickerProps.isInvalid || isInvalid,
                        isOpen: timePickerProps.isOpen,
                        isRequired: timePickerProps.isRequired || isRequired,
                        label: timePickerLabel,
                        locale: timePickerProps.locale || locale,
                        name: timePickerProps.name,
                        onBlur: this.onTimeBlur,
                        onChange: this.onTimeChange,
                        onFocus: this.onTimeFocus,
                        parseInputValue: timePickerProps.parseInputValue,
                        placeholder: timePickerProps.placeholder,
                        selectProps: mergedTimePickerSelectProps,
                        spacing: timePickerProps.spacing || spacing,
                        testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                        timeFormat: timePickerProps.timeFormat,
                        timeIsEditable: timePickerProps.timeIsEditable,
                        times: timePickerProps.times,
                        value: timeValue
                    })
                }),
                isClearable && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsxs)("button", {
                    onClick: this.onClear,
                    "data-testid": testId && `${testId}--icon--container`,
                    tabIndex: -1,
                    type: "button",
                    className: (0, $bwpsq.default)([
                        $597f1543018f8252$var$compiledStyles.iconContainerStyles
                    ]),
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
                            LEGACY_size: "small",
                            color: "currentColor",
                            label: clearControlLabel
                        }),
                        ' '
                    ]
                }) : null
            ]
        });
    }
    constructor(...args){
        super(...args), this.state = {
            dateValue: this.props.datePickerProps?.defaultValue || '',
            isFocused: false,
            timeValue: this.props.timePickerProps?.defaultValue || '',
            value: this.props.defaultValue || '',
            zoneValue: ''
        } // All state needs to be accessed via this function so that the state is mapped from props
        , // correctly to allow controlled/uncontrolled usage.
        this.getParsedValues = ()=>this.parseValue(this.getValue(), this.state.dateValue, this.state.timeValue, this.state.zoneValue), this.getValue = ()=>this.props.value ?? this.state.value, this.onDateBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.datePickerProps?.onBlur) this.props.datePickerProps.onBlur(event);
        }, this.onTimeBlur = (event)=>{
            this.setState({
                isFocused: false
            });
            this.props.onBlur?.(event);
            if (this.props.timePickerProps?.onBlur) this.props.timePickerProps.onBlur(event);
        }, this.onDateFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.datePickerProps?.onFocus) this.props.datePickerProps.onFocus(event);
        }, this.onTimeFocus = (event)=>{
            this.setState({
                isFocused: true
            });
            this.props.onFocus?.(event);
            if (this.props.timePickerProps?.onFocus) this.props.timePickerProps.onFocus(event);
        }, this.onDateChange = (dateValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: dateValue,
                timeValue: parsedValues.timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange(dateValue);
        }, this.onTimeChange = (timeValue)=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: parsedValues.dateValue,
                timeValue: timeValue,
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange(timeValue);
        }, this.onClear = ()=>{
            const parsedValues = this.getParsedValues();
            this.onValueChange({
                dateValue: '',
                timeValue: '',
                zoneValue: parsedValues.zoneValue
            });
            if (this.props.datePickerProps?.onChange) this.props.datePickerProps.onChange('');
            if (this.props.timePickerProps?.onChange) this.props.timePickerProps.onChange('');
        };
    }
}
const $597f1543018f8252$var$DateTimePicker = (0, $994MI.default)({
    componentName: 'dateTimePicker',
    packageName: $597f1543018f8252$var$packageName,
    packageVersion: $597f1543018f8252$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'changed',
        actionSubject: 'dateTimePicker',
        attributes: {
            componentName: 'dateTimePicker',
            packageName: $597f1543018f8252$var$packageName,
            packageVersion: $597f1543018f8252$var$packageVersion
        }
    })
})($597f1543018f8252$export$732a1726f0a3523b));
var $597f1543018f8252$export$2e2bcd8739ae039 = $597f1543018f8252$var$DateTimePicker;

});
parcelRegister("jHBnA", function(module, exports) {

$parcel$export(module.exports, "EmptyComponent", () => $91948b176ea23188$export$5e30e9a24d6c1203);
$parcel$export(module.exports, "placeholderDatetime", () => $91948b176ea23188$export$fff8babee5abe3e2);
$parcel$export(module.exports, "defaultTimes", () => $91948b176ea23188$export$b42ffb9f09b1861b);
$parcel$export(module.exports, "defaultTimeFormat", () => $91948b176ea23188$export$9e6d8fcf62256b85);
$parcel$export(module.exports, "defaultDateFormat", () => $91948b176ea23188$export$75032c84f56650eb);
$parcel$export(module.exports, "padToTwo", () => $91948b176ea23188$export$a7de57e5b672ccdb);
$parcel$export(module.exports, "formatDateTimeZoneIntoIso", () => $91948b176ea23188$export$2eeb05a2ecc2ce0a);
/**
 * This component is used to hide portions of Select component.
 */ const $91948b176ea23188$export$5e30e9a24d6c1203 = ()=>null;
const $91948b176ea23188$export$fff8babee5abe3e2 = new Date(1993, 1, 18, 13);
const $91948b176ea23188$export$b42ffb9f09b1861b = [
    '09:00',
    '09:30',
    '10:00',
    '10:30',
    '11:00',
    '11:30',
    '12:00',
    '12:30',
    '13:00',
    '13:30',
    '14:00',
    '14:30',
    '15:00',
    '15:30',
    '16:00',
    '16:30',
    '17:00',
    '17:30',
    '18:00'
];
const $91948b176ea23188$export$9e6d8fcf62256b85 = 'h:mma';
const $91948b176ea23188$export$75032c84f56650eb = 'YYYY/MM/DD';
function $91948b176ea23188$export$a7de57e5b672ccdb(number) {
    return number <= 99 ? `0${number}`.slice(-2) : `${number}`;
}
function $91948b176ea23188$export$2eeb05a2ecc2ce0a(date, time, zone) {
    // 12:00 => 12:00, 1:00 => 01:00
    const needsLeadingZero = /^\d:/;
    const sanitizedTime = needsLeadingZero.test(time) ? `0${time}` : time;
    return `${date}T${sanitizedTime}${zone}`;
}

});

parcelRegister("8JNJx", function(module, exports) {

$parcel$export(module.exports, "DateTimePickerContainer", () => $346cb403038f00ec$export$83034b1f07ab0b20);
/* date-time-picker-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $346cb403038f00ec$var$isInvalidBorderStyles = null;
const $346cb403038f00ec$var$isFocusedBorderStyles = null;
const $346cb403038f00ec$var$isFocusedStyles = null;
const $346cb403038f00ec$var$subtleBgStyles = null;
const $346cb403038f00ec$var$subtleFocusedBgStyles = null;
const $346cb403038f00ec$var$noBgStyles = null;
const $346cb403038f00ec$var$hoverStyles = null;
const $346cb403038f00ec$var$isInvalidHoverStyles = null;
const $346cb403038f00ec$var$isDisabledStyles = null;
const $346cb403038f00ec$var$newBorderStyles = null;
const $346cb403038f00ec$var$baseContainerStyles = null;
const $346cb403038f00ec$export$83034b1f07ab0b20 = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ children: children, isDisabled: isDisabled, isFocused: isFocused, appearance: appearance, isInvalid: isInvalid, innerProps: innerProps, testId: testId }, ref)=>{
    const notFocusedOrIsDisabled = !(isFocused || isDisabled);
    // we cannot use Box or Flex primitives because these do not allow ...innerProps to be passed
    return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        ...innerProps,
        "data-testid": testId,
        ref: ref,
        className: (0, $bwpsq.default)([
            "_2rkoglpi _v564r5cv _1e0c1txw _bfhk1j9a _d0altlke",
            "_19it1k9g",
            isDisabled && "_1h6d13gt _bfhksyzs _d0al73ad",
            isFocused && "_bfhkr01l",
            appearance === 'subtle' && isFocused && "_1h6d3acm _bfhkxbh0",
            appearance === 'subtle' && !isFocused && "_1h6d3acm _bfhk18uv",
            isFocused && "_1h6d1p6i _16qsq049",
            isInvalid && "_1h6d1bqt",
            notFocusedOrIsDisabled && isInvalid && "_4cvx1bqt _irr31d5g",
            notFocusedOrIsDisabled && !isInvalid && "_4cvx1elr _irr31d5g",
            appearance === 'none' && "_1h6d3acm _bfhk18uv _4cvx3acm _irr318uv"
        ]),
        children: children
    });
});

});

parcelRegister("2ucUe", function(module, exports) {

$parcel$export(module.exports, "convertTokens", () => $ca6f20a476eda5dc$export$4d5430175be73d45);
// https://github.com/date-fns/date-fns-upgrade/blob/master/src/v2/convertTokens/index.ts
const $ca6f20a476eda5dc$var$tokensMap = {
    // 'D MMMM': '',
    // 'Do MMMM': '',
    // 'DD MMMM': '',
    M: 'L',
    Mo: 'Mo',
    MM: 'LL',
    MMM: 'LLL',
    MMMM: 'LLLL',
    Q: 'q',
    Qo: 'qo',
    D: 'd',
    Do: 'do',
    DD: 'dd',
    DDD: 'D',
    DDDo: 'Do',
    DDDD: 'DDD',
    d: 'i',
    do: 'io',
    dd: 'iiiiii',
    ddd: 'iii',
    dddd: 'iiii',
    A: 'a',
    a: 'a',
    aa: 'aaaa',
    E: 'i',
    W: 'I',
    Wo: 'Io',
    WW: 'II',
    YY: 'yy',
    YYYY: 'yyyy',
    GG: 'RR',
    GGGG: 'RRRR',
    H: 'H',
    HH: 'HH',
    h: 'h',
    hh: 'hh',
    m: 'm',
    mm: 'mm',
    s: 's',
    ss: 'ss',
    S: 'S',
    SS: 'SS',
    SSS: 'SSS',
    Z: 'xxx',
    ZZ: 'xx',
    X: 't',
    x: 'T'
};
const $ca6f20a476eda5dc$var$v1tokens = Object.keys($ca6f20a476eda5dc$var$tokensMap).sort().reverse();
const $ca6f20a476eda5dc$var$tokensRegExp = new RegExp(// v1 escape string (unsure the purpose of post-pipe capture group)
"(\\[[^\\[]*\\])|(\\\\)?('.+'|" + // All v1 tokens
$ca6f20a476eda5dc$var$v1tokens.join('|') + '|.)', 'g');
function $ca6f20a476eda5dc$export$4d5430175be73d45(format) {
    const tokensCaptures = format.match($ca6f20a476eda5dc$var$tokensRegExp);
    if (!tokensCaptures) return format;
    return tokensCaptures.reduce((parsed, tokenString, index)=>{
        const v2token = $ca6f20a476eda5dc$var$tokensMap[tokenString];
        if (!v2token) {
            const escapedCaptures = tokenString.match(/^\[(.+)\]$/);
            if (escapedCaptures) parsed.escapedTextBuffer.push(escapedCaptures[1]);
            else parsed.escapedTextBuffer.push(tokenString);
        }
        const endOfString = index === tokensCaptures.length - 1;
        if (parsed.escapedTextBuffer.length && (v2token || endOfString)) {
            // This allows double parentheses to be rendered correctly
            // according to date-fns's spec.
            // https://date-fns.org/v2.29.3/docs/format
            //
            // We have to keep the single quote and then remove it because
            // browser support for lookahead/behind is low and causes breaking
            // errors (HOT-104152)
            const filteredEscapedTextBuffer = parsed.escapedTextBuffer.map((token)=>token[0] === "'" && token.slice(-1) === "'" ? token.slice(1, -1) : token).filter((token)=>token !== "'").join('');
            parsed.formatBuffer.push(`'${filteredEscapedTextBuffer}'`);
            parsed.escapedTextBuffer = [];
        }
        if (v2token) parsed.formatBuffer.push(v2token);
        return parsed;
    }, {
        formatBuffer: [],
        escapedTextBuffer: []
    }).formatBuffer.join('');
}

});

parcelRegister("2TI0z", function(module, exports) {

$parcel$export(module.exports, "default", () => $19201d0a1f7d7d54$export$2e2bcd8739ae039);
/* date-picker-class.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $gB4mS = parcelRequire("gB4mS");
var $994MI = parcelRequire("994MI");
var $cb25w = parcelRequire("cb25w");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $19201d0a1f7d7d54$var$packageName = "platform-pkg";
const $19201d0a1f7d7d54$var$packageVersion = "0.0.0-use.local";
const $19201d0a1f7d7d54$var$datePickerDefaultProps = {
    defaultIsOpen: false,
    defaultValue: '',
    disabled: [],
    disabledDateFilter: (_)=>false,
    locale: 'en-US',
    // These disables are here for proper typing when used as defaults. They
    // should *not* use the `noop` function.
    /* eslint-disable @repo/internal/react/use-noop */ onBlur: (_event)=>{},
    onChange: (_value)=>{},
    onFocus: (_event)=>{} /* eslint-enable @repo/internal/react/use-noop */ 
};
const $19201d0a1f7d7d54$var$styles = {
    pickerContainerStyles: "_kqswh2mm",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o"
}; // eslint-disable-next-line @repo/internal/react/no-class-components
class $19201d0a1f7d7d54$export$df43d21f5faca9f7 extends (0, $5uXOq.Component) {
    static{
        this.defaultProps = $19201d0a1f7d7d54$var$datePickerDefaultProps;
    }
    constructor(props){
        super(props), this.containerRef = null, this.calendarRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), this.calendarButtonRef = /*#__PURE__*/ (0, $5uXOq.createRef)(), // correctly to allow controlled/uncontrolled usage.
        this.getValue = ()=>this.props.value ?? this.state.value, this.getIsOpen = ()=>this.props.isOpen ?? this.state.isOpen, this.onCalendarChange = ({ iso: iso })=>{
            this.setState({
                calendarValue: (0, $5RLF6.getParsedISO)({
                    iso: iso
                })
            });
        }, this.onCalendarSelect = ({ iso: iso })=>{
            this.setState({
                selectInputValue: '',
                isOpen: false,
                calendarValue: iso,
                value: iso,
                wasOpenedFromCalendarButton: false
            });
            this.props.onChange(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
            // on the inner input of Select itself, which would require a lot of
            // extra stuff in the Select component for only this one thing. While
            // this would be more "React-y", it doesn't seem to pose any other
            // benefits. Performance-wise, we are only searching within the
            // container, so it's quick.
            if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
            else {
                const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                innerCombobox?.focus();
            }
            this.setState({
                isOpen: false
            });
        }, this.onInputClick = ()=>{
            if (!this.props.isDisabled && !this.getIsOpen()) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onContainerBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (!this.containerRef?.contains(newlyFocusedElement)) {
                this.setState({
                    isOpen: false,
                    shouldSetFocusOnCurrentDay: false,
                    wasOpenedFromCalendarButton: false
                });
                this.props.onBlur(event);
            }
        }, this.onContainerFocus = ()=>{
            this.setState({
                shouldSetFocusOnCurrentDay: false
            });
        }, this.onSelectBlur = (event)=>{
            const newlyFocusedElement = event.relatedTarget;
            if (this.state.clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else if (!this.containerRef?.contains(newlyFocusedElement)) // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            this.setState({
                isOpen: false,
                isFocused: false,
                wasOpenedFromCalendarButton: false
            });
        }, this.onSelectFocus = (event)=>{
            const { clearingFromIcon: clearingFromIcon } = this.state;
            const value = this.getValue();
            if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
            this.setState({
                clearingFromIcon: false
            });
            else this.setState({
                // Don't open when focused into via keyboard if the calendar button is present
                isOpen: !this.props.shouldShowCalendarButton,
                calendarValue: value,
                isFocused: true,
                wasOpenedFromCalendarButton: false
            });
            this.props.onFocus(event);
        }, this.onTextInput = (event)=>{
            const inputValue = event.target.value;
            if (inputValue) {
                const parsed = (0, $5RLF6.parseDate)(inputValue, {
                    parseInputValue: this.props.parseInputValue,
                    dateFormat: this.props.dateFormat,
                    l10n: this.state.l10n
                }); // Only try to set the date if we have month & day
                if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
                // this is the format expected by the @atlaskit/calendar component
                this.setState({
                    calendarValue: (0, $6AqCE.getShortISOString)(parsed)
                });
            }
            this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
        }, this.onInputKeyDown = (event)=>{
            const { calendarValue: calendarValue } = this.state;
            const value = this.getValue();
            const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
            if (!this.state.isOpen && (keyPressed === 'enter' || keyPressed === ' ')) this.setState({
                isOpen: true,
                wasOpenedFromCalendarButton: false
            });
            switch(keyPressed){
                case 'escape':
                    // Yes, this is not ideal. The alternative is to be able to place a ref
                    // on the inner input of Select itself, which would require a lot of
                    // extra stuff in the Select component for only this one thing. While
                    // this would be more "React-y", it doesn't seem to pose any other
                    // benefits. Performance-wise, we are only searching within the
                    // container, so it's quick.
                    if (this.state.wasOpenedFromCalendarButton) this.calendarButtonRef.current?.focus();
                    else {
                        const innerCombobox = this.containerRef?.querySelector('[role="combobox"]');
                        innerCombobox?.focus();
                    }
                    this.setState({
                        isOpen: false,
                        shouldSetFocusOnCurrentDay: false,
                        wasOpenedFromCalendarButton: false
                    });
                    break;
                case 'backspace':
                case 'delete':
                    {
                        const inputCount = 0;
                        if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) // If being cleared from keyboard, don't change behaviour
                        this.setState({
                            clearingFromIcon: false,
                            value: ''
                        });
                        break;
                    }
                case 'enter':
                    if (!this.state.isOpen) return;
                     // Prevent form submission when a date is selected
                    // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                    // for more details.
                    event.preventDefault();
                    if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                        disabled: this.props.disabled
                    })) {
                        // Get a safe `calendarValue` in case the value exceeds the maximum
                        // allowed by ISO 8601
                        const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                        const valueChanged = safeCalendarValue !== value;
                        this.setState({
                            selectInputValue: '',
                            isOpen: false,
                            value: safeCalendarValue,
                            calendarValue: safeCalendarValue,
                            wasOpenedFromCalendarButton: false
                        });
                        if (valueChanged) this.props.onChange(safeCalendarValue);
                    }
                    break;
                case 'arrowdown':
                case 'arrowup':
                    if (!this.state.shouldSetFocusOnCurrentDay) this.setState({
                        isOpen: true,
                        shouldSetFocusOnCurrentDay: true
                    });
                    break;
                default:
                    break;
            }
        }, this.onCalendarButtonKeyDown = (e)=>{
            // Don't allow an arrow up or down to open the menu, since the input key
            // down handler is actually on the parent.
            if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
             // We want to stop this from triggering other keydown events, particularly
            // for space and enter presses. Otherwise, it opens and then closes
            // immediately.
            if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
                e.stopPropagation();
                this.setState({
                    isKeyDown: true,
                    wasOpenedFromCalendarButton: true
                });
            }
        } // This event handler is triggered from both keydown and click. It's weird.
        , this.onCalendarButtonClick = (e)=>{
            this.setState({
                isOpen: !this.state.isOpen,
                wasOpenedFromCalendarButton: true
            }, ()=>{
                // We don't want the focus to move if this is a click event
                if (!this.state.isKeyDown) return;
                this.setState({
                    isKeyDown: false
                }); // Focus on the first button within the calendar
                this.calendarRef?.current?.querySelector('button')?.focus();
            });
            e.stopPropagation();
        }, this.onClear = ()=>{
            let changedState = {
                value: '',
                calendarValue: this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date())
            };
            if (!this.props.hideIcon) changedState = {
                ...changedState,
                clearingFromIcon: true
            };
            this.setState(changedState);
            this.props.onChange('');
        } // `unknown` is used because `value` is unused so it does not matter.
        , this.onSelectChange = (_value, action)=>{
            // Used for native clear event in React Select
            // Triggered when clicking ClearIndicator or backspace with no value
            if (action.action === 'clear') this.onClear();
        }, this.handleSelectInputChange = (selectInputValue, actionMeta)=>{
            const onInputChange = this.props.selectProps?.onInputChange;
            if (onInputChange) onInputChange(selectInputValue, actionMeta);
            this.setState({
                selectInputValue: selectInputValue
            });
        }, this.getContainerRef = (ref)=>{
            const oldRef = this.containerRef;
            this.containerRef = ref; // Cause a re-render if we're getting the container ref for the first time
            // as the layered menu requires it for dimension calculation
            if (oldRef == null && ref != null) this.forceUpdate();
        };
        this.state = {
            isKeyDown: false,
            isOpen: this.props.defaultIsOpen,
            isFocused: false,
            clearingFromIcon: false,
            selectInputValue: this.props.selectProps?.inputValue || '',
            value: this.props.value || this.props.defaultValue,
            calendarValue: this.props.value || this.props.defaultValue || (0, $6AqCE.getShortISOString)(new Date()),
            l10n: (0, $7qZ1x.createLocalizationProvider)(this.props.locale),
            locale: this.props.locale,
            shouldSetFocusOnCurrentDay: false,
            wasOpenedFromCalendarButton: false
        };
    }
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.locale !== prevState.locale) return {
            l10n: (0, $7qZ1x.createLocalizationProvider)(nextProps.locale),
            locale: nextProps.locale
        };
        else return null;
    }
    render() {
        const { appearance: appearance = 'default', 'aria-describedby': ariaDescribedBy, autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', disabled: disabled, disabledDateFilter: disabledDateFilter, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', locale: locale, maxDate: maxDate, minDate: minDate, name: name = '', nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', testId: testId, weekStartDay: weekStartDay } = this.props;
        const { calendarValue: calendarValue, selectInputValue: selectInputValue } = this.state;
        const value = this.getValue();
        let actualSelectInputValue;
        actualSelectInputValue = selectInputValue;
        const menuIsOpen = this.getIsOpen() && !isDisabled;
        const showClearIndicator = Boolean((value || selectInputValue) && !hideIcon);
        let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
        if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $19201d0a1f7d7d54$var$styles.dropdownIndicatorStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                    ...props
                })
            });
        const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
        const SingleValue = (0, $dBs4v.makeSingleValue)({
            lang: this.props.locale
        });
        const selectComponents = {
            DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
            // Only use this new container component if the calendar button is shown.
            // Otherwise, it throws errors downstream for some reason
            ...shouldShowCalendarButton ? {
                IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                        ...props,
                        showClearIndicator: showClearIndicator
                    })
            } : {},
            Menu: $gtijU.Menu,
            SingleValue: SingleValue,
            ...!showClearIndicator && {
                ClearIndicator: (0, $jHBnA.EmptyComponent)
            },
            ...selectProps.components
        };
        const { styles: selectStyles = {} } = selectProps;
        const disabledStyle = isDisabled ? {
            pointerEvents: 'none',
            color: "var(--ds-icon-disabled, inherit)"
        } : {};
        const calendarProps = {
            calendarContainerRef: this.containerRef,
            calendarDisabled: disabled,
            calendarDisabledDateFilter: disabledDateFilter,
            calendarMaxDate: maxDate,
            calendarMinDate: minDate,
            calendarRef: this.calendarRef,
            calendarValue: value && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(value)),
            calendarView: calendarValue,
            onCalendarChange: this.onCalendarChange,
            onCalendarSelect: this.onCalendarSelect,
            calendarLocale: locale,
            calendarWeekStartDay: weekStartDay,
            shouldSetFocusOnCurrentDay: this.state.shouldSetFocusOnCurrentDay,
            menuInnerWrapper: this.props.menuInnerWrapper
        }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
        const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
            control: (base)=>({
                    ...base,
                    ...disabledStyle
                }),
            indicatorsContainer: (base)=>({
                    ...base,
                    paddingLeft: "var(--ds-space-025, 2px)",
                    // ICON_PADDING = 2
                    paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
                })
        });
        const initialValue = value ? {
            label: (0, $5RLF6.formatDate)(value, {
                formatDisplayLabel: this.props.formatDisplayLabel,
                dateFormat: this.props.dateFormat,
                l10n: this.state.l10n
            }),
            value: value
        } : null; // `label` takes precedence of the `inputLabel`
        const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
        return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
            ...innerProps,
            role: "presentation",
            onBlur: this.onContainerBlur,
            onFocus: this.onContainerFocus,
            onClick: this.onInputClick,
            onInput: this.onTextInput,
            onKeyDown: this.onInputKeyDown,
            ref: this.getContainerRef,
            "data-testid": testId && `${testId}--container`,
            className: (0, $bwpsq.default)([
                $19201d0a1f7d7d54$var$styles.pickerContainerStyles
            ]),
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                    name: name,
                    type: "hidden",
                    value: value,
                    "data-testid": testId && `${testId}--input`
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                    appearance: this.props.appearance,
                    "aria-describedby": ariaDescribedBy,
                    label: label || undefined,
                    autoFocus: autoFocus,
                    clearControlLabel: clearControlLabel,
                    closeMenuOnSelect: true,
                    enableAnimation: false,
                    inputId: id,
                    inputValue: actualSelectInputValue,
                    isDisabled: isDisabled,
                    isRequired: isRequired,
                    menuIsOpen: menuIsOpen,
                    onBlur: this.onSelectBlur,
                    onChange: this.onSelectChange,
                    onFocus: this.onSelectFocus,
                    onInputChange: this.handleSelectInputChange,
                    placeholder: (0, $5RLF6.getPlaceholder)({
                        placeholder: this.props.placeholder,
                        l10n: this.state.l10n
                    }),
                    styles: mergedStyles,
                    value: initialValue,
                    ...selectProps,
                    // up when you alter some of the properties in the `selectComponents`
                    // object. These errors are still present, and I suspect have always
                    // been present, without changing the unrelated code. Ignoring as the
                    // component still works as expected despite this error. And also
                    // because the select refresh team may solve it later.
                    components: selectComponents,
                    // selectProps or not and what wil be overwritten
                    isClearable: true,
                    isInvalid: isInvalid,
                    spacing: spacing,
                    testId: testId,
                    // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                    calendarContainerRef: calendarProps.calendarContainerRef,
                    calendarDisabled: calendarProps.calendarDisabled,
                    calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                    calendarLocale: calendarProps.calendarLocale,
                    calendarMaxDate: calendarProps.calendarMaxDate,
                    calendarMinDate: calendarProps.calendarMinDate,
                    calendarRef: calendarProps.calendarRef,
                    calendarValue: calendarProps.calendarValue,
                    calendarView: calendarProps.calendarView,
                    calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                    nextMonthLabel: nextMonthLabel,
                    onCalendarChange: calendarProps.onCalendarChange,
                    onCalendarSelect: calendarProps.onCalendarSelect,
                    previousMonthLabel: previousMonthLabel,
                    shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                    menuInnerWrapper: calendarProps.menuInnerWrapper
                }),
                shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9KnKW.IdProvider), {
                    prefix: "open-calendar-label--",
                    children: ({ id: openCalendarLabelId })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                            xcss: (0, $3JT92.cx)($19201d0a1f7d7d54$var$styles.iconContainerStyles, value && !hideIcon ? $19201d0a1f7d7d54$var$styles.iconSpacingWithClearButtonStyles : $19201d0a1f7d7d54$var$styles.iconSpacingWithoutClearButtonStyles),
                            children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                                appearance: "subtle",
                                label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                                "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                                id: openCalendarLabelId,
                                icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                                        ...iconProps,
                                        color: "var(--ds-icon, #44546F)"
                                    }),
                                onClick: this.onCalendarButtonClick,
                                onKeyDown: this.onCalendarButtonKeyDown,
                                ref: this.calendarButtonRef,
                                testId: testId && `${testId}--open-calendar-button`
                            })
                        })
                }) : null
            ]
        });
    }
}
const $19201d0a1f7d7d54$var$DatePicker = (0, $994MI.default)({
    componentName: 'datePicker',
    packageName: $19201d0a1f7d7d54$var$packageName,
    packageVersion: $19201d0a1f7d7d54$var$packageVersion
})((0, $cb25w.default)({
    onChange: (0, $gB4mS.default)('atlaskit')({
        action: 'selectedDate',
        actionSubject: 'datePicker',
        attributes: {
            componentName: 'datePicker',
            packageName: $19201d0a1f7d7d54$var$packageName,
            packageVersion: $19201d0a1f7d7d54$var$packageVersion
        }
    })
})($19201d0a1f7d7d54$export$df43d21f5faca9f7));
var $19201d0a1f7d7d54$export$2e2bcd8739ae039 = $19201d0a1f7d7d54$var$DatePicker;

});
parcelRegister("7qZ1x", function(module, exports) {

$parcel$export(module.exports, "createLocalizationProvider", () => $71bdd27445bf5301$export$ea56ca58f08ffa52);

var $lCAti = parcelRequire("lCAti");

var $is0Fy = parcelRequire("is0Fy");

var $1cWOp = parcelRequire("1cWOp");
const $71bdd27445bf5301$export$ea56ca58f08ffa52 = (locale, formatterOptions)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const formatDate = (date)=>Intl.DateTimeFormat(normalizedLocale).format(date);
    const formatTime = (date)=>Intl.DateTimeFormat(normalizedLocale, {
            hour: 'numeric',
            minute: 'numeric'
        }).format(date);
    const getDays = (weekStartDay = 0, length)=>{
        const dayFormatter = Intl.DateTimeFormat(normalizedLocale, {
            weekday: length
        });
        // Right now there is no way to find out first day of the week based on Intl (locale)
        // api. Check issue here: https://github.com/tc39/ecma402/issues/6
        // So we rotate the weekdays based on #weekStartDay parameter.
        const weekdays = [
            0,
            1,
            2,
            3,
            4,
            5,
            6
        ];
        const rotatedWeekdays = weekStartDay > 0 ? [
            ...weekdays.slice(weekStartDay),
            ...weekdays.slice(0, weekStartDay)
        ] : weekdays;
        return rotatedWeekdays.map((day)=>{
            // Some short days are longer than 3 characters but are unique if the first
            // three non-white characters are used.
            const result = dayFormatter// Date range chosen which has a Sun-Sat range so we can extract the names
            .format(new Date(2000, 9, day + 1, 12))// \u200E matches on the Left-to-Right Mark character in IE/Edge
            .replace(/[\s\u200E]/g, '');
            // If short days, only return first three characters. Else return whole thing
            if (length === 'short') return result.substring(0, 3);
            else return result;
        });
    };
    const getDaysShort = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'short');
    };
    const getDaysLong = (weekStartDay = 0)=>{
        return getDays(weekStartDay, 'long');
    };
    const getMonthsLong = ()=>{
        const monthFormatter = Intl.DateTimeFormat(normalizedLocale, {
            month: 'long'
        });
        return [
            0,
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9,
            10,
            11
        ].map((month)=>// Date chosen for no real reason, the only important part is the month
            // Using 2020 'cos Safari has a faulty implementation when we use the year 2000
            // Intl.DateTimeFormat("en-US", { month: 'long'}).format(new Date(2000, 3, 1))
            // should give "April" but gives "March" in Safari
            monthFormatter.format(new Date(2020, month, 1)));
    };
    const parseDate = (date, options = {})=>(0, $is0Fy.createDateParser)(normalizedLocale)(date, options);
    const formatToParts = (date = new Date())=>{
        const formatter = new Intl.DateTimeFormat(normalizedLocale, formatterOptions);
        /**
		 * Safari has a bug that returns the wrong month for years 2005 and before.
		 * The error occurs when the passed date has been created with numbers, like new Date(2000, 3, 1)
		 * Not all the months fail in each year. To ensure the correct output,
		 * we select 2020 as the base year for the whole date,
		 * then we replace in the result the original input year
		 */ const fixedDate = new Date(date);
        fixedDate.setFullYear(2020);
        const fixedParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(fixedDate));
        const originalParts = (0, $1cWOp.toFormattedParts)(formatter.formatToParts(date));
        if (fixedParts.year) fixedParts.year = originalParts.year;
        /**
		 * Chrome has a bug that returns hour="00" when it's 12:00pm in certain languages
		 * We fix it by detecting the real time with getHours method
		 */ if (fixedParts.hour === '00' && fixedDate.getHours() === 12) fixedParts.hour = '12';
        return fixedParts;
    };
    return {
        getDaysShort: getDaysShort,
        getDaysLong: getDaysLong,
        getMonthsLong: getMonthsLong,
        formatDate: formatDate,
        formatTime: formatTime,
        parseDate: parseDate,
        formatToParts: formatToParts
    };
};

});
parcelRegister("lCAti", function(module, exports) {

$parcel$export(module.exports, "normalizeLocale", () => $13af55a9724edafd$export$dca0327c9b9c6498);
const $13af55a9724edafd$export$dca0327c9b9c6498 = (locale)=>locale.replace(/_/g, '-');

});

parcelRegister("is0Fy", function(module, exports) {

$parcel$export(module.exports, "createDateParser", () => $d8bb223589902df4$export$cfa2ef2687faeda2);

var $lCAti = parcelRequire("lCAti");

var $3wYKB = parcelRequire("3wYKB");
const $d8bb223589902df4$var$INVALID_DATE = new Date(NaN);
const $d8bb223589902df4$var$INVARIANT = {
    year: 1993,
    month: 2,
    day: 18
};
const $d8bb223589902df4$var$INVARIANT_DATE = (0, $3wYKB.toDate)($d8bb223589902df4$var$INVARIANT);
const $d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX = /(\d+)[^\d]+(\d+)[^\d]+(\d+)\.?/;
const $d8bb223589902df4$var$DATE_PARSER_REGEX = /(\d+)[^\d]*(\d+)?[^\d]*(\d+)?\.?/;
// Internet Explorer returns non-printing characters when formatting a date
const $d8bb223589902df4$var$stripExtras = (str)=>str.replace(/\u200E/g, '');
const $d8bb223589902df4$var$extractDateParts = (matchResult)=>{
    return matchResult// Get the 3 capture groups
    .splice(1, 4)// Convert them to numbers
    .map((datePart)=>parseInt(datePart, 10));
};
const $d8bb223589902df4$export$cfa2ef2687faeda2 = (locale)=>{
    // Intl.DateFormat expects locales in the format of 'la-CO' however it is
    // common for locale to be provided in the format of 'la_CO', where 'la' is
    // language and 'CO' is country.
    const normalizedLocale = (0, $lCAti.normalizeLocale)(locale);
    const dateFormatter = Intl.DateTimeFormat(normalizedLocale);
    // Generate a date string from a hard coded date, this allows us to determine
    // the year/month/day position for the provided locale.
    const rawDateString = dateFormatter.format($d8bb223589902df4$var$INVARIANT_DATE);
    const shortDate = $d8bb223589902df4$var$stripExtras(rawDateString);
    // Extract the date pieces from the locale formatted date string
    const formatMatch = shortDate.match($d8bb223589902df4$var$FORMAT_EXTRACTOR_REGEX);
    if (!formatMatch) throw new Error('Unable to create DateParser');
    const formatParts = $d8bb223589902df4$var$extractDateParts(formatMatch);
    // Find the year/month/day positions of the locale formatted invariant date
    const yearPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.year);
    const monthPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.month);
    const dayPosition = formatParts.indexOf($d8bb223589902df4$var$INVARIANT.day);
    return (date, options = {})=>{
        const dateMatch = $d8bb223589902df4$var$stripExtras(date).match($d8bb223589902df4$var$DATE_PARSER_REGEX);
        if (!dateMatch) return $d8bb223589902df4$var$INVALID_DATE;
        const dateParts = $d8bb223589902df4$var$extractDateParts(dateMatch);
        // Use the previously extracted year/month/day positions to extract each
        // date piece.
        const extractedDate = {
            year: dateParts[yearPosition],
            month: dateParts[monthPosition],
            day: dateParts[dayPosition]
        };
        const normalizedDate = (0, $3wYKB.normalizeDate)(extractedDate, options?.defaultFirstDay);
        if (!(0, $3wYKB.isValid)(normalizedDate)) return $d8bb223589902df4$var$INVALID_DATE;
        return (0, $3wYKB.toDate)(normalizedDate);
    };
};

});
parcelRegister("3wYKB", function(module, exports) {

$parcel$export(module.exports, "toDate", () => $121d324fc62f760d$export$e67a095c620b86fe);
$parcel$export(module.exports, "isValid", () => $121d324fc62f760d$export$1ea939691cdc45b8);
$parcel$export(module.exports, "normalizeDate", () => $121d324fc62f760d$export$fcc71269590ba0a8);
/**
 * A numerical representation of a date:
 *  - year: any positive integer
 *  - month: 1 - 12 (Jan - Dec)
 *  - day: 1 - [28, 29, 30, 31] (depending on month)
 */ const $121d324fc62f760d$export$abe96da78d4f59dd = (date)=>({
        year: date.getFullYear(),
        month: date.getMonth() + 1,
        day: date.getDate()
    });
const $121d324fc62f760d$export$e67a095c620b86fe = (date)=>// The 'proper' month is stored in a DateObj but Date expects month index
    new Date(date.year, date.month - 1, date.day);
const $121d324fc62f760d$export$553d7fa8e3805fc0 = (year)=>{
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
};
const $121d324fc62f760d$export$f645ddd439eb259d = (year, month)=>{
    // February depends on leap year
    if (month === 2 && $121d324fc62f760d$export$553d7fa8e3805fc0(year)) return 29;
    return [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][month - 1];
};
const $121d324fc62f760d$export$1ea939691cdc45b8 = (date)=>{
    const { year: year, month: month, day: day } = date;
    const daysInMonth = $121d324fc62f760d$export$f645ddd439eb259d(year, month);
    return 1 <= month && month <= 12 && 1 <= day && day <= daysInMonth;
};
const $121d324fc62f760d$export$fcc71269590ba0a8 = (date, defaultFirstDay = false)=>{
    const now = $121d324fc62f760d$export$abe96da78d4f59dd(new Date());
    const { year: year, month: month, day: day } = date;
    // 19 should evaluate to 2019
    const fullYear = year < 100 ? 2000 + year : year;
    // Missing date pieces are filled in with their current date values
    const normalizedYear = !isNaN(fullYear) ? fullYear : now.year;
    const normalizedMonth = !isNaN(month) && month !== 0 ? month : now.month;
    const normalizedDay = !isNaN(day) && day !== 0 ? day : month !== 0 && defaultFirstDay ? 1 : now.day;
    return {
        year: normalizedYear,
        month: normalizedMonth,
        day: normalizedDay
    };
};

});


parcelRegister("1cWOp", function(module, exports) {

$parcel$export(module.exports, "toFormattedParts", () => $56bd04270448c035$export$9b7ca29af37c192);
const $56bd04270448c035$export$9b7ca29af37c192 = (rawParts)=>rawParts.reduce((result, datePart)=>({
            ...result,
            [datePart.type]: datePart.value
        }), {});

});


parcelRegister("5RLF6", function(module, exports) {

$parcel$export(module.exports, "isDateDisabled", () => $e0db4b6edb7dbfac$export$d38e7e283938128c);
$parcel$export(module.exports, "getParsedISO", () => $e0db4b6edb7dbfac$export$38db26406d1a1ee2);
$parcel$export(module.exports, "parseDate", () => $e0db4b6edb7dbfac$export$6b862160d295c8e);
$parcel$export(module.exports, "formatDate", () => $e0db4b6edb7dbfac$export$3ae94a2503e890a1);
$parcel$export(module.exports, "getPlaceholder", () => $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0);
/**
 * Everything in this file is to smooth out the migration of the new date picker
 * (https://product-fabric.atlassian.net/browse/DSP-20682). When that ticket is
 * complete, all of these functions will ilkely be merged back into the date
 * picker. Please do not pre-optimize and put these back into the date picker
 * unless you are working on the DTP Refresh and you have a good reason to do
 * so, thank you!
 *
 * All variables within the `di` objects are dependency injections. They should
 * be read from within the component at the end of the day. But because we are
 * extracting them, we have to inject them in every place manually. When we
 * re-introduce them to the components, we can likely remove the `di` variables
 * and instead use internal variables.
 *
 * If component _only_ has injected variables, it is fully internal and was
 * broken out to be it's own function.
 */ 
var $k7m40 = parcelRequire("k7m40");
var $5I2ju = parcelRequire("5I2ju");
var $eZDAP = parcelRequire("eZDAP");

var $2ucUe = parcelRequire("2ucUe");

var $jHBnA = parcelRequire("jHBnA");
const $e0db4b6edb7dbfac$export$d38e7e283938128c = (date, di)=>{
    const { disabled: disabled } = di;
    return disabled.indexOf(date) > -1;
};
const $e0db4b6edb7dbfac$export$38db26406d1a1ee2 = (di)=>{
    const { iso: iso } = di;
    const [year, month, date] = iso.split('-');
    let newIso = iso;
    const parsedDate = parseInt(date, 10);
    const parsedMonth = parseInt(month, 10);
    const parsedYear = parseInt(year, 10);
    const lastDayInMonth = (0, $5I2ju.default)(new Date(parsedYear, parsedMonth - 1)).getDate();
    if (lastDayInMonth < parsedDate) newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(lastDayInMonth)}`;
    else newIso = `${parsedYear}-${(0, $jHBnA.padToTwo)(parsedMonth)}-${(0, $jHBnA.padToTwo)(parsedDate)}`;
    return newIso;
};
const $e0db4b6edb7dbfac$export$6b862160d295c8e = (date, di)=>{
    const { parseInputValue: parseInputValue, dateFormat: dateFormat, l10n: l10n } = di;
    if (parseInputValue) return parseInputValue(date, dateFormat || (0, $jHBnA.defaultDateFormat));
    return l10n.parseDate(date);
};
const $e0db4b6edb7dbfac$export$3ae94a2503e890a1 = (value, di)=>{
    const { formatDisplayLabel: formatDisplayLabel, dateFormat: dateFormat, l10n: l10n } = di;
    if (formatDisplayLabel) return formatDisplayLabel(value, dateFormat || (0, $jHBnA.defaultDateFormat));
    const date = (0, $eZDAP.default)(value);
    return dateFormat ? (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(dateFormat)) : l10n.formatDate(date);
};
const $e0db4b6edb7dbfac$export$d3f5c5e0a5023fa0 = (di)=>{
    const { placeholder: placeholder, l10n: l10n } = di;
    return placeholder || l10n.formatDate((0, $jHBnA.placeholderDatetime));
};

});

parcelRegister("iaQLg", function(module, exports) {

$parcel$export(module.exports, "IndicatorsContainer", () => $d73476b891de3e0c$export$d0ffd7e649cab6f);
/* indicators-container.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $bChGW = parcelRequire("bChGW");
const $d73476b891de3e0c$var$styles = {
    calendarButtonInclusionStyles: "_ahbqxy5q",
    calendarButtonOnlyInclusionStyles: "_ahbq1ejb"
};
const $d73476b891de3e0c$export$d0ffd7e649cab6f = ({ showClearIndicator: showClearIndicator, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        className: (0, $bwpsq.default)([
            showClearIndicator ? $d73476b891de3e0c$var$styles.calendarButtonInclusionStyles : $d73476b891de3e0c$var$styles.calendarButtonOnlyInclusionStyles
        ]),
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).IndicatorsContainer, {
            ...rest
        })
    });

});

parcelRegister("gtijU", function(module, exports) {

$parcel$export(module.exports, "Menu", () => $e800a879ee1613fc$export$d9b273488cd8ce6f);
/* menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $1f0Hs = parcelRequire("1f0Hs");

var $9MHPe = parcelRequire("9MHPe");

var $avHVh = parcelRequire("avHVh");
/**
 * @param isos A series of ISO dates.
 * @returns The last valid date within the array of ISO strings.
 */ function $e800a879ee1613fc$var$getValidDate(isos) {
    return isos.reduce((acc, iso)=>{
        const date = (0, $eZDAP.default)(iso);
        return (0, $jovBr.default)(date) ? {
            day: date.getDate(),
            month: date.getMonth() + 1,
            year: date.getFullYear()
        } : acc;
    }, {});
}
const $e800a879ee1613fc$var$menuStyles = null;
const $e800a879ee1613fc$export$d9b273488cd8ce6f = ({ selectProps: selectProps, innerProps: innerProps })=>{
    const { calendarValue: calendarValue, calendarView: calendarView, menuInnerWrapper: MenuInnerWrapper } = selectProps;
    const { day: day, month: month, year: year } = $e800a879ee1613fc$var$getValidDate([
        calendarValue,
        calendarView
    ]);
    const onMenuMouseDown = (event)=>{
        if (event.button !== 0) return;
        event.stopPropagation();
        event.preventDefault();
    };
    const Wrapper = typeof MenuInnerWrapper === 'function' ? MenuInnerWrapper : (0, $5uXOq.Fragment);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $9MHPe.Layering), {
        isDisabled: false,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
            inputValue: selectProps.inputValue,
            containerRef: selectProps.calendarContainerRef,
            content: /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                ...innerProps,
                onMouseDown: onMenuMouseDown,
                className: (0, $bwpsq.default)([
                    "_2rkoglpi _1reo15vq _18m915vq _1pbyowjs _bfhk1bhr _16qs1cd0"
                ]),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)(Wrapper, {
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1f0Hs.default), {
                        day: day,
                        month: month,
                        year: year,
                        disabled: selectProps.calendarDisabled,
                        disabledDateFilter: selectProps.calendarDisabledDateFilter,
                        minDate: selectProps.calendarMinDate,
                        maxDate: selectProps.calendarMaxDate,
                        nextMonthLabel: selectProps.nextMonthLabel,
                        onChange: selectProps.onCalendarChange,
                        onSelect: selectProps.onCalendarSelect,
                        previousMonthLabel: selectProps.previousMonthLabel,
                        ref: selectProps.calendarRef,
                        selected: [
                            selectProps.calendarValue
                        ],
                        shouldSetFocusOnCurrentDay: selectProps.shouldSetFocusOnCurrentDay,
                        locale: selectProps.calendarLocale,
                        testId: selectProps.testId && `${selectProps.testId}--calendar`,
                        weekStartDay: selectProps.calendarWeekStartDay
                    })
                })
            }),
            testId: selectProps.testId
        })
    });
};

});
parcelRegister("1f0Hs", function(module, exports) {

$parcel$export(module.exports, "default", () => $16abbcd9b9109722$export$2e2bcd8739ae039);
/* calendar.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $9KnKW = parcelRequire("9KnKW");

var $MHKc7 = parcelRequire("MHKc7");
var $414Wj = parcelRequire("414Wj");

var $ePz3p = parcelRequire("ePz3p");

var $lJWdi = parcelRequire("lJWdi");

var $avO9B = parcelRequire("avO9B");

var $iioJV = parcelRequire("iioJV");

var $jihAA = parcelRequire("jihAA");

var $bbnGB = parcelRequire("bbnGB");

var $hbcve = parcelRequire("hbcve");

var $2TGJ3 = parcelRequire("2TGJ3");

var $f9D1v = parcelRequire("f9D1v");

var $9efze = parcelRequire("9efze");
const $16abbcd9b9109722$var$styles = {
    box: "_1e0c1o8l _uiztglyw"
};
const $16abbcd9b9109722$var$analyticsAttributes = {
    componentName: 'calendar',
    packageName: "platform-pkg",
    packageVersion: "0.0.0-use.local"
};
const $16abbcd9b9109722$var$InnerCalendar = /*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar({ day: day, defaultDay: defaultDay = 0, defaultMonth: defaultMonth = 0, defaultPreviouslySelected: defaultPreviouslySelected = (0, $iioJV.blankStringArray), defaultSelected: defaultSelected = (0, $iioJV.blankStringArray), defaultYear: defaultYear = 0, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDate, maxDate: maxDate, month: month, nextMonthLabel: nextMonthLabel, onBlur: onBlur = (0, $eGmKJ.default), onChange: onChange = (0, $eGmKJ.default), onFocus: onFocus = (0, $eGmKJ.default), onSelect: onSelect = (0, $eGmKJ.default), previouslySelected: previouslySelected, previousMonthLabel: previousMonthLabel, selected: selected, shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay = false, today: today, locale: locale = 'en-US', year: year, analyticsContext: analyticsContext, weekStartDay: weekStartDay = 0, testId: testId, className: className, style: style, tabIndex: tabIndex = 0 }, ref) {
    const { day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], today: [todayValue], selected: [selectedValue, setSelectedValue], previous: [previouslySelectedValue, setPreviouslySelectedValue] } = (0, $jihAA.default)({
        day: day,
        defaultDay: defaultDay,
        month: month,
        defaultMonth: defaultMonth,
        year: year,
        defaultYear: defaultYear,
        today: today,
        selected: selected,
        defaultSelected: defaultSelected,
        previouslySelected: previouslySelected,
        defaultPreviouslySelected: defaultPreviouslySelected
    });
    const [shouldSetFocus, setShouldSetFocus] = (0, $5uXOq.useState)(false);
    const onChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChange,
        action: 'changed',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { navigate: navigate, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear } = (0, $2TGJ3.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        shouldSetFocus: [
            shouldSetFocus,
            setShouldSetFocus
        ],
        onChange: onChangeWithAnalytics
    });
    const onSelectWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onSelect,
        action: 'selected',
        analyticsData: analyticsContext,
        ...$16abbcd9b9109722$var$analyticsAttributes
    });
    const { handleClickDay: handleClickDay, handleContainerKeyDown: handleContainerKeyDown } = (0, $f9D1v.default)({
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            ,
            setPreviouslySelectedValue
        ],
        onSelect: onSelectWithAnalytics,
        navigate: navigate
    });
    const { handleContainerBlur: handleContainerBlur, handleContainerFocus: handleContainerFocus } = (0, $bbnGB.default)({
        onFocus: onFocus,
        onBlur: onBlur
    });
    const { monthsLong: monthsLong, daysShort: daysShort, daysLong: daysLong } = (0, $9efze.default)({
        locale: locale,
        weekStartDay: weekStartDay
    });
    const weeks = (0, $hbcve.default)({
        day: dayValue,
        month: monthValue,
        year: yearValue,
        today: todayValue,
        selected: selectedValue,
        previouslySelected: previouslySelectedValue,
        disabled: disabled,
        disabledDateFilter: disabledDateFilter,
        minDate: minDate,
        maxDate: maxDate,
        daysLong: daysLong,
        weekStartDay: weekStartDay
    });
    const getNextMonthHeading = ()=>{
        // Next month is (currentMonth - 1) + 1, or just currentMonth in this
        // instance.
        const nextMonth = monthValue % 12;
        const showNextYear = monthValue === 12;
        return `${monthsLong[nextMonth]} ${showNextYear ? yearValue + 1 : yearValue}`;
    };
    const getNextYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const nextYear = yearValue + 1;
        return `${monthsLong[thisMonth]} ${nextYear}`;
    };
    const getPreviousMonthHeading = ()=>{
        // Previous month is (monthValue - 1) - 1. Need to add 12 so the modulo
        // works as expected and stays positive.
        const previousMonth = (monthValue + 12 - 2) % 12;
        const showPreviousYear = monthValue === 1;
        return `${monthsLong[previousMonth]} ${showPreviousYear ? yearValue - 1 : yearValue}`;
    };
    const getPreviousYearHeading = ()=>{
        // Months are held in Date object as zero-indexed
        const thisMonth = (monthValue - 1) % 12;
        const previousYear = yearValue - 1;
        return `${monthsLong[thisMonth]} ${previousYear}`;
    };
    const headerId = (0, $9KnKW.useId)();
    return(// eslint-disable-next-line jsx-a11y/no-static-element-interactions
    /*#__PURE__*/ (0, $2OMIu.jsx)("div" // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop -- Ignored via go/DSP-18766
    , {
        className: className,
        style: style,
        onBlur: handleContainerBlur,
        onFocus: handleContainerFocus,
        "data-testid": testId && `${testId}--container`,
        ref: ref,
        children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $16abbcd9b9109722$var$styles.box,
            padding: "space.200",
            "aria-label": "calendar",
            testId: testId && `${testId}--calendar`,
            children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $414Wj.default), {
                space: "space.150",
                children: [
                    /*#__PURE__*/ (0, $2OMIu.jsx)((0, $ePz3p.default // The month number needs to be translated to index in the month
                    ), {
                        // name array e.g. 1 (January) -> 0
                        monthLongTitle: monthsLong[monthValue - 1],
                        year: yearValue,
                        nextMonthLabel: nextMonthLabel,
                        previousMonthLabel: previousMonthLabel,
                        nextMonthHeading: getNextMonthHeading(),
                        nextYearHeading: getNextYearHeading(),
                        previousMonthHeading: getPreviousMonthHeading(),
                        previousYearHeading: getPreviousYearHeading(),
                        handleClickNextMonth: handleClickNextMonth,
                        handleClickNextYear: handleClickNextYear,
                        handleClickPrevMonth: handleClickPrevMonth,
                        handleClickPrevYear: handleClickPrevYear,
                        headerId: headerId,
                        tabIndex: tabIndex,
                        testId: testId
                    }),
                    /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $MHKc7.default), {
                        role: "grid",
                        onKeyDown: handleContainerKeyDown,
                        "aria-labelledby": headerId,
                        testId: testId && `${testId}--calendar-dates`,
                        children: [
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $avO9B.default), {
                                daysShort: daysShort,
                                testId: testId
                            }),
                            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $lJWdi.default), {
                                weeks: weeks,
                                handleClickDay: handleClickDay,
                                monthsLong: monthsLong,
                                shouldSetFocus: shouldSetFocus || shouldSetFocusOnCurrentDay,
                                tabIndex: tabIndex,
                                testId: testId
                            })
                        ]
                    })
                ]
            })
        })
    }));
});
/**
 * __Calendar__
 *
 * A calendar is used for date selection.
 *
 * - [Examples](https://atlassian.design/components/calendar/examples)
 * - [Code](https://atlassian.design/components/calendar/code)
 * - [Usage](https://atlassian.design/components/calendar/usage)
 */ const $16abbcd9b9109722$var$Calendar = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Calendar(props, ref) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)($16abbcd9b9109722$var$InnerCalendar, {
        ...props,
        ref: ref
    });
}));
$16abbcd9b9109722$var$Calendar.displayName = 'Calendar';
var $16abbcd9b9109722$export$2e2bcd8739ae039 = $16abbcd9b9109722$var$Calendar;

});
parcelRegister("ePz3p", function(module, exports) {

$parcel$export(module.exports, "default", () => $995afee12cb828f6$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $42CjB = parcelRequire("42CjB");

var $9KnKW = parcelRequire("9KnKW");

var $l1N8i = parcelRequire("l1N8i");

var $iPF0X = parcelRequire("iPF0X");

var $dq6Kz = parcelRequire("dq6Kz");

var $lRheX = parcelRequire("lRheX");

var $3dGN0 = parcelRequire("3dGN0");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");
const $995afee12cb828f6$var$Header = /*#__PURE__*/ (0, $5uXOq.memo)(function Header({ monthLongTitle: monthLongTitle, year: year, previousMonthLabel: previousMonthLabel = 'Previous month', previousYearLabel: previousYearLabel = 'Previous year', previousMonthHeading: previousMonthHeading, previousYearHeading: previousYearHeading, nextMonthLabel: nextMonthLabel = 'Next month', nextYearLabel: nextYearLabel = 'Next year', nextMonthHeading: nextMonthHeading, nextYearHeading: nextYearHeading, handleClickPrevMonth: handleClickPrevMonth, handleClickPrevYear: handleClickPrevYear, handleClickNextMonth: handleClickNextMonth, handleClickNextYear: handleClickNextYear, headerId: headerId, tabIndex: tabIndex, testId: testId }) {
    const announceId = (0, $9KnKW.useId)();
    // All of this is because `aria-atomic` is not fully supported for different
    // assistive technologies. We want the value of the current month and year to
    // be announced, but *only* if that value has been interacted with since
    // being mounted. This allows us to conditionally apply the `aria-live`
    // attribute.  Without this, the `aria-live` property is set on mount and
    // overrides the default input's readout in downstream consumers (e.g.
    // datetime picker).
    const [hasInteractedWithMonthOrYear, setHasInteractedWithMonthOrYear] = (0, $5uXOq.useState)(false);
    const handlePrevMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevMonth(e);
    };
    const handlePrevYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickPrevYear(e);
    };
    const handleNextMonthInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextMonth(e);
    };
    const handleNextYearInteraction = (e)=>{
        if (!hasInteractedWithMonthOrYear) setHasInteractedWithMonthOrYear(true);
        handleClickNextYear(e);
    };
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
        paddingInline: "space.100",
        children: /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
            space: "space.0",
            alignBlock: "center",
            spread: "space-between",
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "start",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevYearInteraction,
                            testId: testId && `${testId}--previous-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($iPF0X))),
                            label: `${previousYearLabel}, ${previousYearHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handlePrevMonthInteraction,
                            testId: testId && `${testId}--previous-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($lRheX))),
                            label: `${previousMonthLabel}, ${previousMonthHeading}`
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                    "aria-live": hasInteractedWithMonthOrYear ? 'polite' : undefined,
                    id: announceId,
                    testId: testId && `${testId}--current-month-year--container`,
                    children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $l1N8i.default), {
                        size: "xsmall",
                        as: "h2",
                        id: headerId,
                        testId: testId && `${testId}--current-month-year`,
                        children: `${monthLongTitle} ${year}`
                    })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $c0aEF.default), {
                    space: "space.100",
                    alignBlock: "end",
                    children: [
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextMonthInteraction,
                            testId: testId && `${testId}--next-month`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($3dGN0))),
                            label: `${nextMonthLabel}, ${nextMonthHeading}`
                        }),
                        /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                            appearance: "subtle",
                            spacing: "compact",
                            tabIndex: tabIndex,
                            onClick: handleNextYearInteraction,
                            testId: testId && `${testId}--next-year`,
                            icon: (0, (/*@__PURE__*/$parcel$interopDefault($dq6Kz))),
                            label: `${nextYearLabel}, ${nextYearHeading}`
                        })
                    ]
                })
            ]
        })
    });
});
$995afee12cb828f6$var$Header.displayName = 'Header';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$995afee12cb828f6$export$2e2bcd8739ae039 = $995afee12cb828f6$var$Header;

});
parcelRegister("iPF0X", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::4694b4334ad7c5c52e5a3aa3cac3904d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $db5cce05fac9743f$var$_react = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $db5cce05fac9743f$var$_baseNew = $db5cce05fac9743f$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $db5cce05fac9743f$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleLeft".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $db5cce05fac9743f$var$ChevronDoubleLeftIcon = (props)=>/*#__PURE__*/ $db5cce05fac9743f$var$_react.default.createElement($db5cce05fac9743f$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m2.31 6 3.97-3.97L5.22.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06zm4.75 0 3.97-3.97L9.97.97l-4.5 4.5a.75.75 0 0 0 0 1.06l4.5 4.5 1.06-1.06z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$db5cce05fac9743f$var$ChevronDoubleLeftIcon.displayName = 'ChevronDoubleLeftIcon';
var $db5cce05fac9743f$var$_default = module.exports.default = $db5cce05fac9743f$var$ChevronDoubleLeftIcon;

});

parcelRegister("dq6Kz", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::efb038f49280a8a959174d8021780f6d>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9c52f081c61754ba$var$_react = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("5uXOq")));

var $9c52f081c61754ba$var$_baseNew = $9c52f081c61754ba$var$_interopRequireDefault((parcelRequire("fEaCe")));
function $9c52f081c61754ba$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "ChevronDoubleRight".
 * Category: utility
 * Location: @atlaskit/icon
 * Usage guidance: Reserved for calendar year button.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $9c52f081c61754ba$var$ChevronDoubleRightIcon = (props)=>/*#__PURE__*/ $9c52f081c61754ba$var$_react.default.createElement($9c52f081c61754ba$var$_baseNew.default, Object.assign({
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="m6.78.97 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5-1.06-1.06L9.69 6 5.72 2.03zm-4.75 0 4.5 4.5a.75.75 0 0 1 0 1.06l-4.5 4.5L.97 9.97 4.94 6 .97 2.03z" clip-rule="evenodd"/>`,
        type: 'utility'
    }, props));
$9c52f081c61754ba$var$ChevronDoubleRightIcon.displayName = 'ChevronDoubleRightIcon';
var $9c52f081c61754ba$var$_default = module.exports.default = $9c52f081c61754ba$var$ChevronDoubleRightIcon;

});


parcelRegister("lJWdi", function(module, exports) {

$parcel$export(module.exports, "default", () => $43f22a52ec309eeb$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $dC5iT = parcelRequire("dC5iT");

var $1q4y8 = parcelRequire("1q4y8");

var $h581D = parcelRequire("h581D");
const $43f22a52ec309eeb$var$WeekDays = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekDays({ weeks: weeks, handleClickDay: handleClickDay, monthsLong: monthsLong, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dC5iT.default), {
        role: "rowgroup",
        testId: testId && `${testId}--month`,
        children: weeks.map((week, i)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
                testId: testId && `${testId}--week`,
                children: week.values.map((weekDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $1q4y8.default), {
                        isDisabled: weekDay.isDisabled,
                        isFocused: weekDay.isFocused,
                        isToday: weekDay.isToday,
                        dayLong: weekDay.weekDayName,
                        month: weekDay.month,
                        monthLong: monthsLong[weekDay.month - 1],
                        onClick: handleClickDay,
                        isPreviouslySelected: weekDay.isPreviouslySelected,
                        isSelected: weekDay.isSelected,
                        isSibling: weekDay.isSiblingMonth,
                        year: weekDay.year,
                        shouldSetFocus: shouldSetFocus,
                        tabIndex: tabIndex,
                        testId: testId,
                        children: weekDay.day
                    }, `${week.id}-${weekDay.id}`))
            }, i))
    });
});
$43f22a52ec309eeb$var$WeekDays.displayName = 'WeekDays';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$43f22a52ec309eeb$export$2e2bcd8739ae039 = $43f22a52ec309eeb$var$WeekDays;

});
parcelRegister("1q4y8", function(module, exports) {

$parcel$export(module.exports, "default", () => $d70b02566a310b79$export$2e2bcd8739ae039);
/* date.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $eGmKJ = parcelRequire("eGmKJ");

var $joKkQ = parcelRequire("joKkQ");
const $d70b02566a310b79$var$dateCellSiblingStyle = null;
const $d70b02566a310b79$var$dateCellTodayStyle = null;
const $d70b02566a310b79$var$dateCellPrevSelectedStyle = null;
const $d70b02566a310b79$var$dateCellSelectedStyle = null;
const $d70b02566a310b79$var$dateCellDisabledStyle = null;
const $d70b02566a310b79$var$dateCellStyles = null;
const $d70b02566a310b79$var$Date = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(function Date({ children: day, isDisabled: isDisabled = false, isFocused: isFocused = false, isToday: isToday = false, dayLong: dayLong, month: month, monthLong: monthLong, onClick: onClick = (0, $eGmKJ.default), isPreviouslySelected: isPreviouslySelected = false, isSelected: isSelected = false, isSibling: isSibling = false, year: year, shouldSetFocus: shouldSetFocus, tabIndex: tabIndex, testId: testId }, _ref) {
    const dateRef = (0, $5uXOq.useRef)({
        day: day,
        month: month,
        year: year,
        isDisabled: isDisabled
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: day,
            month: month,
            year: year,
            isDisabled: isDisabled
        };
    }, [
        day,
        month,
        year,
        isDisabled
    ]);
    const focusRef = (0, $5uXOq.useRef)(null);
    (0, $5uXOq.useEffect)(()=>{
        if (isFocused && shouldSetFocus && focusRef.current) focusRef.current.focus();
    }, [
        isFocused,
        shouldSetFocus
    ]);
    const handleClick = (0, $5uXOq.useCallback)(()=>{
        const { day: dayValue, month: monthValue, year: yearValue, isDisabled: isDisabledValue } = dateRef.current;
        if (!isDisabledValue) onClick({
            day: dayValue,
            month: monthValue,
            year: yearValue
        });
    }, [
        onClick
    ]);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        role: "gridcell",
        alignItems: "center",
        children: /*#__PURE__*/ (0, $2OMIu.jsx)("button", {
            "aria-current": isToday ? 'date' : undefined,
            "aria-disabled": isDisabled || undefined,
            "aria-label": `${day}, ${dayLong} ${monthLong} ${year}`,
            "aria-pressed": isSelected ? 'true' : 'false',
            tabIndex: isFocused ? tabIndex : -1,
            type: "button",
            onClick: handleClick,
            ref: focusRef,
            "data-disabled": isDisabled || undefined,
            "data-focused": isFocused || undefined,
            "data-prev-selected": isPreviouslySelected || undefined,
            "data-selected": isSelected || undefined,
            "data-sibling": isSibling || undefined,
            "data-today": isToday || undefined,
            "data-testid": testId && (isSelected ? `${testId}--selected-day` : `${testId}--day`),
            className: (0, $bwpsq.default)([
                "_kkk2n7od _2rko1l7b _11c82smr _1h6d3acm _1dqonqa1 _189eyh40 _1e0c1ule _kqswh2mm _16jlkb7n _bfhk18uv _syazj3m3 _80omtlke _85i51b66 _1q511b66 _y4tirdoj _bozgrdoj _y3gn1h6o _pojj194a _10knnqa1 _1wysyh40 _irr314ae _30l3j3m3 _1di61l7b _9h8hj3m3",
                isSibling && "_syaz1wmz _30l31wmz",
                isToday && "_syaz1ldt _k48p1igg _1ywu1ule _1qdgyh40 _18postnw _1hfk1r31 _aetrb3bt _1gufv77o _1czdv77o _g0nfv77o",
                isPreviouslySelected && "_bfhk29zg _syazc8hx _30l3c8hx",
                isSelected && "_bfhk1p4p _syazqueg _irr3quvt _30l31uqy",
                isDisabled && "_syaz7dlb _80om13gf _irr318uv _30l37dlb"
            ]),
            children: day
        })
    });
}));
$d70b02566a310b79$var$Date.displayName = 'Date';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$d70b02566a310b79$export$2e2bcd8739ae039 = $d70b02566a310b79$var$Date;

});
parcelRegister("joKkQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $975a473d4552aaa0$export$2e2bcd8739ae039);
/* grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");
const $975a473d4552aaa0$var$rowGapMap = {
    'space.0': "_1p57ze3t",
    'space.025': "_1p57v77o",
    'space.050': "_1p571b66",
    'space.075': "_1p5712x7",
    'space.100': "_1p57u2gc",
    'space.150': "_1p57utpp",
    'space.200': "_1p57pxbi",
    'space.250': "_1p57v47k",
    'space.300': "_1p571ejb",
    'space.400': "_1p57xy5q",
    'space.500': "_1p571jfw",
    'space.600': "_1p57oahv",
    'space.800': "_1p57xncg",
    'space.1000': "_1p571epz"
};
const $975a473d4552aaa0$var$columnGapMap = {
    'space.0': "_gy1pze3t",
    'space.025': "_gy1pv77o",
    'space.050': "_gy1p1b66",
    'space.075': "_gy1p12x7",
    'space.100': "_gy1pu2gc",
    'space.150': "_gy1putpp",
    'space.200': "_gy1ppxbi",
    'space.250': "_gy1pv47k",
    'space.300': "_gy1p1ejb",
    'space.400': "_gy1pxy5q",
    'space.500': "_gy1p1jfw",
    'space.600': "_gy1poahv",
    'space.800': "_gy1pxncg",
    'space.1000': "_gy1p1epz"
};
const $975a473d4552aaa0$var$justifyContentMap = {
    start: "_1bahv2br",
    center: "_1bah1h6o",
    end: "_1bahh9n0",
    'space-between': "_1bah1yb4",
    'space-around': "_1bah1b1v",
    'space-evenly': "_1bahitcz",
    stretch: "_1bah1fhb"
};
const $975a473d4552aaa0$var$alignContentMap = {
    start: "_ae4vv2br",
    center: "_ae4v1h6o",
    end: "_ae4vh9n0",
    'space-between': "_ae4v1yb4",
    'space-around': "_ae4v1b1v",
    'space-evenly': "_ae4vitcz",
    stretch: "_ae4v1fhb"
};
const $975a473d4552aaa0$var$alignItemsMap = {
    start: "_4cvrv2br",
    center: "_4cvr1h6o",
    baseline: "_4cvr1q9y",
    end: "_4cvrh9n0",
    stretch: "_4cvr1fhb"
};
const $975a473d4552aaa0$var$baseStyles = {
    root: "_1e0c11p5 _vchhusvi"
};
const $975a473d4552aaa0$var$gridAutoFlowMap = {
    row: "_wij2vrvc",
    column: "_wij21bp4",
    dense: "_wij218l3",
    'row dense': "_wij2j5tq",
    'column dense': "_wij2adhi"
};
/**
 * __Grid__
 *
 * `Grid` is a primitive component that implements the CSS Grid API.
 *
 * - [Examples](https://atlassian.design/components/primitives/grid/examples)
 * - [Code](https://atlassian.design/components/primitives/grid/code)
 *
 * @example
 * ```tsx
 * import { Grid, Box } from '@atlaskit/primitives'
 *
 * const Component = () => (
 *   <Grid gap="space.100" gridColumns="1fr 1fr">
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *     <Box padding="space.100" backgroundColor="neutral"></Box>
 *   </Grid>
 * )
 * ```
 */ const $975a473d4552aaa0$var$Grid = /*#__PURE__*/ (0, $5uXOq.memo)(/*#__PURE__*/ (0, $5uXOq.forwardRef)(({ as: as, alignItems: alignItems, alignContent: alignContent, justifyContent: justifyContent, gap: gap, columnGap: columnGap, rowGap: rowGap, children: children, id: id, role: role, testId: testId, autoFlow: autoFlow, xcss: xcss }, ref)=>{
    const Component = as || 'div';
    return /*#__PURE__*/ (0, $2OMIu.jsx)(Component, {
        id: id,
        role: role,
        className: (0, $bwpsq.default)([
            $975a473d4552aaa0$var$baseStyles.root,
            gap && $975a473d4552aaa0$var$columnGapMap[gap],
            columnGap && $975a473d4552aaa0$var$columnGapMap[columnGap],
            gap && $975a473d4552aaa0$var$rowGapMap[gap],
            rowGap && $975a473d4552aaa0$var$rowGapMap[rowGap],
            alignItems && $975a473d4552aaa0$var$alignItemsMap[alignItems],
            alignContent && $975a473d4552aaa0$var$alignContentMap[alignContent],
            justifyContent && $975a473d4552aaa0$var$justifyContentMap[justifyContent],
            autoFlow && $975a473d4552aaa0$var$gridAutoFlowMap[autoFlow],
            xcss
        ]),
        "data-testid": testId,
        ref: ref,
        children: children
    });
}));
$975a473d4552aaa0$var$Grid.displayName = 'Grid';
var $975a473d4552aaa0$export$2e2bcd8739ae039 = $975a473d4552aaa0$var$Grid;

});


parcelRegister("h581D", function(module, exports) {

$parcel$export(module.exports, "default", () => $5c8aba25f4ae00ff$export$2e2bcd8739ae039);
/* week-day-grid.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $joKkQ = parcelRequire("joKkQ");
const $5c8aba25f4ae00ff$var$styles = {
    templateColumns: "_yv0eloeq"
};
/**
 * __Week day grid__
 *
 * A week day grid aligns elements in a 7 wide grid layout.
 *
 */ const $5c8aba25f4ae00ff$var$WeekDayGrid = ({ testId: testId, children: children, isHidden: isHidden })=>{
    const row = /*#__PURE__*/ (0, $2OMIu.jsx)((0, $joKkQ.default), {
        testId: testId,
        xcss: $5c8aba25f4ae00ff$var$styles.templateColumns,
        role: "row",
        children: children
    });
    return isHidden ? /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
        "aria-hidden": "true",
        children: row
    }) : row;
};
var $5c8aba25f4ae00ff$export$2e2bcd8739ae039 = $5c8aba25f4ae00ff$var$WeekDayGrid;

});


parcelRegister("avO9B", function(module, exports) {

$parcel$export(module.exports, "default", () => $f29b1b1295ce3a84$export$2e2bcd8739ae039);
/* week-header.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $MHKc7 = parcelRequire("MHKc7");
var $dS3PR = parcelRequire("dS3PR");

var $h581D = parcelRequire("h581D");
const $f29b1b1295ce3a84$var$styles = {
    columnHeader: "_1ul98pqr _o5721q9c _1e0c1txw _1bah1h6o"
};
const $f29b1b1295ce3a84$var$WeekHeader = /*#__PURE__*/ (0, $5uXOq.memo)(function WeekHeader({ daysShort: daysShort, testId: testId }) {
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $h581D.default), {
        isHidden: true,
        testId: testId && `${testId}--column-headers`,
        children: daysShort.map((shortDay)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                padding: "space.100",
                xcss: $f29b1b1295ce3a84$var$styles.columnHeader,
                role: "columnheader",
                testId: testId && `${testId}--column-header`,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $dS3PR.default), {
                    weight: "bold",
                    size: "UNSAFE_small",
                    align: "center",
                    color: "color.text.subtle",
                    children: shortDay
                })
            }, shortDay))
    });
});
$f29b1b1295ce3a84$var$WeekHeader.displayName = 'WeekHeader';
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$f29b1b1295ce3a84$export$2e2bcd8739ae039 = $f29b1b1295ce3a84$var$WeekHeader;

});

parcelRegister("iioJV", function(module, exports) {

$parcel$export(module.exports, "arrowKeys", () => $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a);
$parcel$export(module.exports, "daysPerWeek", () => $85c2ac8e9452c4bf$export$3ae905d9742bef55);
$parcel$export(module.exports, "monthsPerYear", () => $85c2ac8e9452c4bf$export$c9b7c010035d60c6);
$parcel$export(module.exports, "blankStringArray", () => $85c2ac8e9452c4bf$export$8fa20d70624f8b9d);
const $85c2ac8e9452c4bf$export$8b15eca9c6d5c48a = {
    ArrowDown: 'down',
    ArrowLeft: 'left',
    ArrowRight: 'right',
    ArrowUp: 'up'
};
const $85c2ac8e9452c4bf$export$3ae905d9742bef55 = 7;
const $85c2ac8e9452c4bf$export$c9b7c010035d60c6 = 12;
const $85c2ac8e9452c4bf$export$8fa20d70624f8b9d = [];

});

parcelRegister("jihAA", function(module, exports) {

$parcel$export(module.exports, "default", () => $654a69afe715a212$export$2e2bcd8739ae039);

var $33etG = parcelRequire("33etG");

var $f8qry = parcelRequire("f8qry");

var $3EtUb = parcelRequire("3EtUb");
function $654a69afe715a212$export$2e2bcd8739ae039({ day: day, defaultDay: defaultDay, month: month, defaultMonth: defaultMonth, year: year, defaultYear: defaultYear, today: today, selected: selected, defaultSelected: defaultSelected, previouslySelected: previouslySelected, defaultPreviouslySelected: defaultPreviouslySelected }) {
    const { current: { thisDay: thisDay, thisMonth: thisMonth, thisYear: thisYear } } = (0, $f8qry.default)(()=>{
        const now = new Date();
        const thisDay = now.getDate();
        const thisMonth = now.getMonth() + 1;
        const thisYear = now.getFullYear();
        return {
            thisDay: thisDay,
            thisMonth: thisMonth,
            thisYear: thisYear
        };
    });
    const [dayValue, setDayValue] = (0, $33etG.default)(day, ()=>defaultDay || thisDay);
    const [monthValue, setMonthValue] = (0, $33etG.default)(month, ()=>defaultMonth || thisMonth);
    const [yearValue, setYearValue] = (0, $33etG.default)(year, ()=>defaultYear || thisYear);
    const [todayValue] = (0, $33etG.default)(today, ()=>today || `${thisYear}-${(0, $3EtUb.default)(thisMonth)}-${(0, $3EtUb.default)(thisDay)}`);
    const [selectedValue, setSelectedValue] = (0, $33etG.default)(selected, ()=>defaultSelected);
    const [previouslySelectedValue, setPreviouslySelectedValue] = (0, $33etG.default)(previouslySelected, ()=>defaultPreviouslySelected);
    return {
        day: [
            dayValue,
            setDayValue
        ],
        month: [
            monthValue,
            setMonthValue
        ],
        year: [
            yearValue,
            setYearValue
        ],
        today: [
            todayValue
        ],
        selected: [
            selectedValue,
            setSelectedValue
        ],
        previous: [
            previouslySelectedValue,
            setPreviouslySelectedValue
        ]
    };
}

});
parcelRegister("3EtUb", function(module, exports) {

$parcel$export(module.exports, "default", () => $cd804e1790f6d755$export$2e2bcd8739ae039);
function $cd804e1790f6d755$export$2e2bcd8739ae039(num) {
    return num < 10 ? `0${num}` : `${num}`;
}

});


parcelRegister("bbnGB", function(module, exports) {

$parcel$export(module.exports, "default", () => $8ccb38b64bb63461$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");
function $8ccb38b64bb63461$export$2e2bcd8739ae039({ onBlur: onBlur, onFocus: onFocus }) {
    const handleContainerBlur = (0, $5uXOq.useCallback)((event)=>{
        onBlur(event);
    }, [
        onBlur
    ]);
    const handleContainerFocus = (0, $5uXOq.useCallback)((event)=>{
        onFocus(event);
    }, [
        onFocus
    ]);
    return {
        handleContainerBlur: handleContainerBlur,
        handleContainerFocus: handleContainerFocus
    };
}

});

parcelRegister("hbcve", function(module, exports) {

$parcel$export(module.exports, "default", () => $0fe53b5f3382c02e$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eZDAP = parcelRequire("eZDAP");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $5wbTt = parcelRequire("5wbTt");
function $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, { month: month, year: year, weekStartDay: weekStartDay }) {
    const shouldDisplaySixthWeek = calendar.length % 6;
    const calendarLastValue = calendar[calendar.length - 1];
    return (0, $5uXOq.useMemo)(()=>{
        // Some months jump between 5 and 6 weeks to display. In some cases 4 (Feb
        // with the 1st on a Monday etc). This ensures the UI doesn't jump around by
        // catering to always showing 6 weeks.
        if (shouldDisplaySixthWeek) {
            const lastDayIsSibling = calendarLastValue.siblingMonth;
            const sliceStart = lastDayIsSibling ? (0, $iioJV.daysPerWeek) : 0;
            return (0, $5wbTt.default)(year, month, {
                weekStartDay: weekStartDay
            }).slice(sliceStart, sliceStart + (0, $iioJV.daysPerWeek)).map((date)=>({
                    ...date,
                    siblingMonth: true
                }));
        }
    }, [
        calendarLastValue,
        month,
        shouldDisplaySixthWeek,
        weekStartDay,
        year
    ]);
}
function $0fe53b5f3382c02e$export$2e2bcd8739ae039({ day: day, daysLong: daysLong, month: month, year: year, today: today, disabled: disabled, disabledDateFilter: disabledDateFilter, minDate: minDateString, maxDate: maxDateString, selected: selected, previouslySelected: previouslySelected, weekStartDay: weekStartDay }) {
    const calendar = (0, $5uXOq.useMemo)(()=>(0, $5wbTt.default)(year, month - 1, {
            weekStartDay: weekStartDay
        }), [
        month,
        weekStartDay,
        year
    ]);
    const calendarWithSixthWeek = $0fe53b5f3382c02e$var$useGetCalendarWithSixthWeek(calendar, {
        month: month,
        year: year,
        weekStartDay: weekStartDay
    });
    if (calendarWithSixthWeek) calendar.push(...calendarWithSixthWeek);
    const minDate = minDateString ? (0, $eZDAP.default)(minDateString) : undefined;
    const maxDate = maxDateString ? (0, $eZDAP.default)(maxDateString) : undefined;
    const needJsDate = minDateString || maxDateString;
    return (0, $5uXOq.useMemo)(()=>{
        const weeks = [];
        calendar.forEach((date)=>{
            const dateAsString = (0, $6ASl9.default)(date, {
                fixMonth: true
            });
            const JSDate = needJsDate ? (0, $eZDAP.default)(dateAsString) : undefined;
            let week;
            if (date.weekDay === weekStartDay) {
                week = {
                    id: dateAsString,
                    values: []
                };
                weeks.push(week);
            } else week = weeks[weeks.length - 1];
            const weekDayOffset = (date.weekDay - weekStartDay) % 7;
            // Define a bunch of `const`s
            const weekDayName = daysLong[weekDayOffset];
            const isDisabledByArray = disabled ? disabled.indexOf(dateAsString) > -1 : false;
            const isDisabledByFilter = disabledDateFilter ? disabledDateFilter(dateAsString) : false;
            const isDisabledByMin = minDate && JSDate ? JSDate < minDate : false;
            const isDisabledByMax = maxDate && JSDate ? JSDate > maxDate : false;
            const isDisabled = isDisabledByArray || isDisabledByFilter || isDisabledByMin || isDisabledByMax;
            const isFocused = day === date.day && !date.siblingMonth;
            const isPreviouslySelected = !isDisabled && previouslySelected.indexOf(dateAsString) > -1;
            const isSelected = !isDisabled && selected.indexOf(dateAsString) > -1;
            const isSiblingMonth = !!date.siblingMonth;
            const isToday = today === dateAsString;
            week.values.push({
                id: dateAsString,
                isDisabled: isDisabled,
                isFocused: isFocused,
                isToday: isToday,
                month: date.month + 1,
                isPreviouslySelected: isPreviouslySelected,
                isSelected: isSelected,
                isSiblingMonth: isSiblingMonth,
                year: date.year,
                day: date.day,
                weekDayName: weekDayName
            });
        });
        return weeks;
    }, [
        calendar,
        day,
        disabled,
        disabledDateFilter,
        minDate,
        maxDate,
        needJsDate,
        previouslySelected,
        selected,
        today,
        weekStartDay,
        daysLong
    ]);
}

});
parcelRegister("6ASl9", function(module, exports) {

$parcel$export(module.exports, "default", () => $b6ae62fd51c4538f$export$2e2bcd8739ae039);

var $3EtUb = parcelRequire("3EtUb");
function $b6ae62fd51c4538f$export$2e2bcd8739ae039(date, options) {
    return `${date.year}-${(0, $3EtUb.default)(date.month + (options && options.fixMonth ? 1 : 0))}-${(0, $3EtUb.default)(date.day)}`;
}

});

parcelRegister("5wbTt", function(module, exports) {

$parcel$export(module.exports, "default", () => $3dff1ed1384abe91$export$2e2bcd8739ae039);
/**
 * Logic taken from https://github.com/WesSouza/calendar-base which is not maintained for quite sometime.
 * This will help us fixing any issue we might get or any new functionality we might want to support.
 * Not changing much code below. Just removed those parts which we don't need.
 */ 
var $iioJV = parcelRequire("iioJV");

var $9Zmg7 = parcelRequire("9Zmg7");
function $3dff1ed1384abe91$export$2e2bcd8739ae039(year, month, { weekStartDay: weekStartDay = 0 } = {
    weekStartDay: 0
}) {
    const date = new Date(Date.UTC(year, month, 1, 0, 0, 0, 0));
    const utcYear = date.getUTCFullYear();
    const utcMonth = date.getUTCMonth();
    const calendar = [];
    const firstDay = date.getUTCDay();
    const firstDate = -(((0, $iioJV.daysPerWeek) - weekStartDay + firstDay) % (0, $iioJV.daysPerWeek));
    const lastDate = (0, $9Zmg7.default)(utcYear, utcMonth);
    const lastDay = (lastDate - firstDate) % (0, $iioJV.daysPerWeek);
    const lastDateOfPreviousMonth = (0, $9Zmg7.default)(utcYear, utcMonth - 1);
    let dateCounter = firstDate;
    let currentDay;
    let currentDate;
    let currentDateObject = null;
    let calculatedMonth;
    let calculatedYear;
    const maxDateCount = lastDate - dateCounter + (lastDay !== 0 ? (0, $iioJV.daysPerWeek) - lastDay : 0) + firstDate;
    while(dateCounter < maxDateCount){
        currentDate = dateCounter + 1;
        currentDay = ((dateCounter < 1 ? (0, $iioJV.daysPerWeek) + dateCounter : dateCounter) + firstDay) % (0, $iioJV.daysPerWeek);
        if (currentDate < 1 || currentDate > lastDate) {
            if (currentDate < 1) {
                calculatedMonth = utcMonth - 1;
                calculatedYear = utcYear;
                if (calculatedMonth < 0) {
                    calculatedMonth = (0, $iioJV.monthsPerYear) - 1;
                    calculatedYear--;
                }
                currentDate = lastDateOfPreviousMonth + currentDate;
            } else if (currentDate > lastDate) {
                calculatedMonth = utcMonth + 1;
                calculatedYear = utcYear;
                if (calculatedMonth > (0, $iioJV.monthsPerYear) - 1) {
                    calculatedMonth = 0;
                    calculatedYear++;
                }
                currentDate = dateCounter - lastDate + 1;
            }
            if (calculatedMonth !== undefined && calculatedYear !== undefined) currentDateObject = {
                day: currentDate,
                weekDay: currentDay,
                month: calculatedMonth,
                year: calculatedYear,
                siblingMonth: true
            };
        } else currentDateObject = {
            day: currentDate,
            weekDay: currentDay,
            month: utcMonth,
            year: utcYear
        };
        calendar.push(currentDateObject);
        dateCounter++;
    }
    return calendar;
}

});
parcelRegister("9Zmg7", function(module, exports) {

$parcel$export(module.exports, "default", () => $878800070b837d93$export$2e2bcd8739ae039);
function $878800070b837d93$export$2e2bcd8739ae039(year, month) {
    return new Date(year, month + 1, 0).getDate();
}

});



parcelRegister("2TGJ3", function(module, exports) {

$parcel$export(module.exports, "default", () => $caae4eff24f6e8d0$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");

var $9Zmg7 = parcelRequire("9Zmg7");
const $caae4eff24f6e8d0$var$getNextMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === (0, $iioJV.monthsPerYear)) {
        month = 1;
        year += 1;
    } else month += 1;
    return {
        month: month,
        year: year
    };
};
const $caae4eff24f6e8d0$var$getPrevMonth = (monthValue, yearValue)=>{
    let month = monthValue;
    let year = yearValue;
    if (month === 1) {
        month = (0, $iioJV.monthsPerYear);
        year -= 1;
    } else month -= 1;
    return {
        month: month,
        year: year
    };
};
function $caae4eff24f6e8d0$export$2e2bcd8739ae039({ day: [dayValue, setDayValue], month: [monthValue, setMonthValue], year: [yearValue, setYearValue], shouldSetFocus: [_shouldSetFocus, setShouldSetFocus], onChange: onChange }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnChange = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day, type: type })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        const isFocusableType = [
            'up',
            'down',
            'left',
            'right'
        ].includes(type);
        onChange({
            day: day,
            month: month,
            year: year,
            iso: iso,
            type: type
        });
        setDayValue(day);
        setMonthValue(month);
        setYearValue(year);
        setShouldSetFocus(isFocusableType);
    }, [
        onChange,
        setDayValue,
        setMonthValue,
        setYearValue,
        setShouldSetFocus
    ]);
    const navigate = (0, $5uXOq.useCallback)((type)=>{
        const { day: day, month: month, year: year } = dateRef.current;
        if (type === 'down') {
            const next = day + (0, $iioJV.daysPerWeek);
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: next - daysInMonth,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'left') {
            const prev = day - 1;
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1);
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        } else if (type === 'right') {
            const next = day + 1;
            const daysInMonth = (0, $9Zmg7.default)(year, month - 1);
            if (next > daysInMonth) {
                const { month: nextMonth, year: nextYear } = $caae4eff24f6e8d0$var$getNextMonth(month, year);
                triggerOnChange({
                    year: nextYear,
                    month: nextMonth,
                    day: 1,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: next,
                type: type
            });
        } else if (type === 'up') {
            const prev = day - (0, $iioJV.daysPerWeek);
            if (prev < 1) {
                const { month: prevMonth, year: prevYear } = $caae4eff24f6e8d0$var$getPrevMonth(month, year);
                const prevDay = (0, $9Zmg7.default)(prevYear, prevMonth - 1) + prev;
                triggerOnChange({
                    year: prevYear,
                    month: prevMonth,
                    day: prevDay,
                    type: type
                });
            } else triggerOnChange({
                year: year,
                month: month,
                day: prev,
                type: type
            });
        }
    }, [
        triggerOnChange
    ]);
    const handleClickNextMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getNextMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'nextMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickNextYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year + 1,
            type: 'nextYear'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevMonth = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = {
            ...dateRef.current,
            ...$caae4eff24f6e8d0$var$getPrevMonth(dateRef.current.month, dateRef.current.year)
        };
        triggerOnChange({
            day: day,
            month: month,
            year: year,
            type: 'prevMonth'
        });
    }, [
        triggerOnChange
    ]);
    const handleClickPrevYear = (0, $5uXOq.useCallback)(()=>{
        const { day: day, month: month, year: year } = dateRef.current;
        triggerOnChange({
            day: day,
            month: month,
            year: year - 1,
            type: 'prevYear'
        });
    }, [
        triggerOnChange
    ]);
    return {
        navigate: navigate,
        handleClickNextMonth: handleClickNextMonth,
        handleClickNextYear: handleClickNextYear,
        handleClickPrevMonth: handleClickPrevMonth,
        handleClickPrevYear: handleClickPrevYear
    };
}

});

parcelRegister("f9D1v", function(module, exports) {

$parcel$export(module.exports, "default", () => $42ec54640e7b9de4$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $iioJV = parcelRequire("iioJV");

var $6ASl9 = parcelRequire("6ASl9");
function $42ec54640e7b9de4$export$2e2bcd8739ae039({ day: [dayValue], month: [monthValue], year: [yearValue], selected: [selectedValue, setSelectedValue], previous: [, setPreviouslySelectedValue], onSelect: onSelect, navigate: navigate }) {
    const dateRef = (0, $5uXOq.useRef)({
        day: dayValue,
        month: monthValue,
        year: yearValue
    });
    (0, $5uXOq.useEffect)(()=>{
        dateRef.current = {
            day: dayValue,
            month: monthValue,
            year: yearValue
        };
    }, [
        dayValue,
        monthValue,
        yearValue
    ]);
    const triggerOnSelect = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        const iso = (0, $6ASl9.default)({
            year: year,
            month: month,
            day: day
        });
        onSelect({
            day: day,
            month: month,
            year: year,
            iso: iso
        });
        setPreviouslySelectedValue(selectedValue);
        setSelectedValue([
            iso
        ]);
    }, [
        onSelect,
        selectedValue,
        setPreviouslySelectedValue,
        setSelectedValue
    ]);
    const handleClickDay = (0, $5uXOq.useCallback)(({ year: year, month: month, day: day })=>{
        triggerOnSelect({
            year: year,
            month: month,
            day: day
        });
    }, [
        triggerOnSelect
    ]);
    const handleContainerKeyDown = (0, $5uXOq.useCallback)((e)=>{
        const { key: key } = e;
        const arrowKey = (0, $iioJV.arrowKeys)[key];
        if (key === 'Enter' || key === ' ') {
            e.preventDefault();
            triggerOnSelect(dateRef.current);
        } else if (arrowKey) {
            e.preventDefault();
            navigate(arrowKey);
        }
    }, [
        triggerOnSelect,
        navigate
    ]);
    return {
        handleClickDay: handleClickDay,
        handleContainerKeyDown: handleContainerKeyDown
    };
}

});

parcelRegister("9efze", function(module, exports) {

$parcel$export(module.exports, "default", () => $fbd6f430b06675a1$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $7qZ1x = parcelRequire("7qZ1x");
function $fbd6f430b06675a1$export$2e2bcd8739ae039({ locale: locale, weekStartDay: weekStartDay }) {
    const l10n = (0, $5uXOq.useMemo)(()=>(0, $7qZ1x.createLocalizationProvider)(locale), [
        locale
    ]);
    const monthsLong = (0, $5uXOq.useMemo)(()=>l10n.getMonthsLong(), [
        l10n
    ]);
    const daysShort = (0, $5uXOq.useMemo)(()=>l10n.getDaysShort(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    const daysLong = (0, $5uXOq.useMemo)(()=>l10n.getDaysLong(weekStartDay), [
        l10n,
        weekStartDay
    ]);
    return {
        monthsLong: monthsLong,
        daysShort: daysShort,
        daysLong: daysLong
    };
}

});


parcelRegister("avHVh", function(module, exports) {

$parcel$export(module.exports, "default", () => $ac07968b7cb494a9$export$2e2bcd8739ae039);
/* fixed-layer.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $eGmKJ = parcelRequire("eGmKJ");

var $5owSH = parcelRequire("5owSH");

var $gkD4s = parcelRequire("gkD4s");
var $4oNEb = parcelRequire("4oNEb");
var $1V7PR = parcelRequire("1V7PR");
const $ac07968b7cb494a9$var$styles = {
    root: "_bfhk18uv _kqswstnw _154ize3t",
    popperStyles: "_1pbyowjs"
};
class $ac07968b7cb494a9$export$2e2bcd8739ae039 extends (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Component {
    componentDidUpdate(prevProps) {
        if (prevProps.inputValue !== this.props.inputValue) this.update();
    }
    render() {
        const { containerRef: containerRef, content: content, testId: testId } = this.props;
        // Wait for containerRef callback to cause a re-render
        if (!containerRef) return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {});
        const divStyles = {
            height: containerRef.getBoundingClientRect().height,
            // Don't block the clear button
            width: containerRef.getBoundingClientRect().width - parseInt((0, $5owSH.sizes).small.slice(0, -2)) - 8
        };
        return(/* Need to wrap layer in a fixed position div so that it will render its content as fixed
       * We need to set the intial top value to where the container is and zIndex so that it still
       * applies since we're creating a new stacking context. */ /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $gkD4s.Manager), {
            children: [
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $1V7PR.Reference), {
                    children: ({ ref: ref })=>/*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            "data-layer-child": true,
                            style: divStyles,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.root
                            ])
                        })
                }),
                /*#__PURE__*/ (0, $2OMIu.jsx)((0, $4oNEb.Popper), {
                    children: ({ ref: ref, style: style, update: update })=>{
                        this.update = update;
                        return /*#__PURE__*/ (0, $2OMIu.jsx)("div", {
                            ref: ref,
                            // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
                            style: style,
                            "data-testid": testId && `${testId}--popper--container`,
                            className: (0, $bwpsq.default)([
                                $ac07968b7cb494a9$var$styles.popperStyles
                            ]),
                            children: content
                        });
                    }
                })
            ]
        }));
    }
    constructor(...args){
        super(...args), this.update = (0, $eGmKJ.default);
    }
}

});
parcelRegister("5owSH", function(module, exports) {

$parcel$export(module.exports, "sizes", () => $7ad0abb26ad673d7$export$c647cb0ee6e282fe);
const $7ad0abb26ad673d7$export$c647cb0ee6e282fe = {
    small: '16px',
    medium: '24px',
    large: '32px',
    xlarge: '48px'
};
const $7ad0abb26ad673d7$export$7bd66fc94c81bf84 = {
    small: 'small',
    medium: 'medium',
    large: 'large',
    xlarge: 'xlarge'
};
const $7ad0abb26ad673d7$export$62ad7b0c781000e9 = {
    small: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.small
    },
    medium: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.medium
    },
    large: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.large
    },
    xlarge: {
        width: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge,
        height: $7ad0abb26ad673d7$export$c647cb0ee6e282fe.xlarge
    }
};

});



parcelRegister("6AqCE", function(module, exports) {

$parcel$export(module.exports, "getShortISOString", () => $caee16c105163c22$export$77d5bc49fed7ef14);
$parcel$export(module.exports, "getSafeCalendarValue", () => $caee16c105163c22$export$ff525416014fb67d);

var $k7m40 = parcelRequire("k7m40");

var $2ucUe = parcelRequire("2ucUe");
function $caee16c105163c22$export$77d5bc49fed7ef14(date) {
    return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)('YYYY-MM-DD'));
}
function $caee16c105163c22$export$ff525416014fb67d(calendarValue) {
    // If `calendarValue` has a year that is greater than 9999, default to
    // today's date
    const yearIsOverLimit = calendarValue.match(/^\d{5,}/);
    if (yearIsOverLimit) return $caee16c105163c22$export$77d5bc49fed7ef14(new Date());
    return calendarValue;
}

});

parcelRegister("dBs4v", function(module, exports) {

$parcel$export(module.exports, "makeSingleValue", () => $9661917c82165ad2$export$6e30bf8cb1347b56);

var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");
const $9661917c82165ad2$export$6e30bf8cb1347b56 = ({ lang: lang })=>({ children: children, className: className, clearValue: clearValue, cx: cx, data: data, getStyles: getStyles, getValue: getValue, hasValue: hasValue, isDisabled: isDisabled, isMulti: isMulti, isRtl: isRtl, options: options, selectOption: selectOption, selectProps: selectProps, setValue: setValue, ...rest })=>{
        return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).SingleValue, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            data: data,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: {
                lang: lang
            },
            isDisabled: isDisabled,
            isMulti: isMulti,
            isRtl: isRtl,
            options: options,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        });
    };

});


parcelRegister("jcbUF", function(module, exports) {

$parcel$export(module.exports, "default", () => $48f5b21daaca02ab$export$2e2bcd8739ae039);
/* date-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $bwpsq = parcelRequire("bwpsq");

var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $3JT92 = parcelRequire("3JT92");

var $9KnKW = parcelRequire("9KnKW");

var $acknU = parcelRequire("acknU");

var $7qZ1x = parcelRequire("7qZ1x");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");

var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $5RLF6 = parcelRequire("5RLF6");

var $iaQLg = parcelRequire("iaQLg");

var $gtijU = parcelRequire("gtijU");

var $6AqCE = parcelRequire("6AqCE");

var $dBs4v = parcelRequire("dBs4v");
const $48f5b21daaca02ab$var$packageName = "platform-pkg";
const $48f5b21daaca02ab$var$packageVersion = "0.0.0-use.local";
const $48f5b21daaca02ab$var$styles = {
    pickerContainerStyle: "_kqswh2mm",
    dropdownIndicatorStyles: "_1ul91k8s _1tke1k8s _1e0c1txw _4cvr1h6o _1bah1h6o",
    iconContainerStyles: "_v564vrg3 _1e0c1txw _4t3i1osq _kqswstnw _4cvr1h6o _i0dl1kw7 _syaz131l _152tze3t _rjxpze3t _30l31gjq",
    iconSpacingWithClearButtonStyles: "_12l2xy5q",
    iconSpacingWithoutClearButtonStyles: "_12l21b66"
};
const $48f5b21daaca02ab$var$analyticsAttributes = {
    componentName: 'datePicker',
    packageName: $48f5b21daaca02ab$var$packageName,
    packageVersion: $48f5b21daaca02ab$var$packageVersion
}; /**
    * __Date picker__
    *
    * A date picker allows the user to select a particular date.
    *
    * - [Examples](https://atlassian.design/components/datetime-picker/date-picker/examples)
    * - [Code](https://atlassian.design/components/datetime-picker/date-picker/code)
    * - [Usage](https://atlassian.design/components/datetime-picker/date-picker/usage)
    */ 
const $48f5b21daaca02ab$var$DatePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, forwardedRef)=>{
    const containerRef = (0, $5uXOq.useRef)(null);
    const calendarRef = (0, $5uXOq.useRef)(null);
    const calendarButtonRef = (0, $5uXOq.useRef)(null);
    const { appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'Clear', hideIcon: hideIcon = false, openCalendarLabel: openCalendarLabel = 'Open calendar', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', disabled: disabled = [], disabledDateFilter: disabledDateFilter = (_)=>false, icon: Icon = (0, (/*@__PURE__*/$parcel$interopDefault($acknU))), id: id = '', innerProps: innerProps = {}, inputLabel: inputLabel = 'Date picker', inputLabelId: inputLabelId, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, label: label = '', name: name = '', onBlur: // eslint-disable-next-line @repo/internal/react/use-noop
    onBlur = (_event)=>{}, // eslint-disable-next-line @repo/internal/react/use-noop
    onChange: onChangeProp = (_value)=>{}, onFocus: // eslint-disable-next-line @repo/internal/react/use-noop
    onFocus = (_event)=>{}, selectProps: selectProps = {}, shouldShowCalendarButton: shouldShowCalendarButton, spacing: spacing = 'default', locale: propLocale = 'en-US', value: propValue, isOpen: isOpenProp, maxDate: maxDate, minDate: minDate, weekStartDay: weekStartDay, formatDisplayLabel: formatDisplayLabel, testId: testId, 'aria-describedby': ariaDescribedBy, placeholder: placeholder, nextMonthLabel: nextMonthLabel, previousMonthLabel: previousMonthLabel, ...rest } = props;
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    const [selectInputValue, setSelectInputValue] = (0, $5uXOq.useState)(selectProps.inputValue);
    const [value, setValue] = (0, $5uXOq.useState)(propValue || defaultValue);
    const [calendarValue, setCalendarValue] = (0, $5uXOq.useState)(propValue || defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
    const [l10n, setL10n] = (0, $5uXOq.useState)((0, $7qZ1x.createLocalizationProvider)(propLocale));
    const [locale, setLocale] = (0, $5uXOq.useState)(propLocale);
    const [shouldSetFocusOnCurrentDay, setShouldSetFocusOnCurrentDay] = (0, $5uXOq.useState)(false);
    const [isKeyDown, setIsKeyDown] = (0, $5uXOq.useState)(false);
    const [wasOpenedFromCalendarButton, setWasOpenedFromCalendarButton] = (0, $5uXOq.useState)(false); // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>!x, true);
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$48f5b21daaca02ab$var$analyticsAttributes
    });
    if (propLocale !== locale) {
        setL10n((0, $7qZ1x.createLocalizationProvider)(propLocale));
        setLocale(propLocale);
    }
    (0, $5uXOq.useEffect)(()=>{
        // We don't want the focus to move if this is a click event
        if (!isKeyDown) return;
        if (isOpen && wasOpenedFromCalendarButton) {
            setIsKeyDown(false); // Focus on the first button within the calendar
            calendarRef?.current?.querySelector('button')?.focus();
        }
    }, [
        isKeyDown,
        calendarRef,
        isOpen,
        wasOpenedFromCalendarButton
    ]);
    const getValue = ()=>propValue ?? value;
    const getIsOpen = ()=>isOpenProp ?? isOpen;
    const onCalendarChange = ({ iso: iso })=>{
        setCalendarValue((0, $5RLF6.getParsedISO)({
            iso: iso
        }));
    };
    const onCalendarSelect = ({ iso: iso })=>{
        setSelectInputValue('');
        setIsOpen(false);
        setCalendarValue(iso);
        setValue(iso);
        setWasOpenedFromCalendarButton(false);
        onChangePropWithAnalytics(iso); // Yes, this is not ideal. The alternative is to be able to place a ref
        // on the inner input of Select itself, which would require a lot of
        // extra stuff in the Select component for only this one thing. While
        // this would be more "React-y", it doesn't seem to pose any other
        // benefits. Performance-wise, we are only searching within the
        // container, so it's quick.
        if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
        else {
            const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
            innerCombobox?.focus();
        }
        setIsOpen(false);
    };
    const onInputClick = ()=>{
        if (!isDisabled && !getIsOpen()) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onContainerBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (!containerRef?.current?.contains(newlyFocusedElement)) {
            setIsOpen(false);
            setShouldSetFocusOnCurrentDay(false);
            setWasOpenedFromCalendarButton(false);
            onBlur(event);
        }
    };
    const onContainerFocus = ()=>{
        setShouldSetFocusOnCurrentDay(false);
    };
    const onSelectBlur = (event)=>{
        const newlyFocusedElement = event.relatedTarget;
        if (clearingFromIcon) // Don't close menu if blurring after the user has clicked clear
        setClearingFromIcon(false);
        else if (!containerRef?.current?.contains(newlyFocusedElement)) {
            // Don't close menu if focus is staying within the date picker's
            // container. Makes keyboard accessibility of calendar possible
            setIsOpen(false);
            setIsFocused(false);
            setWasOpenedFromCalendarButton(false);
        }
    };
    const onSelectFocus = (event)=>{
        const value = getValue();
        if (clearingFromIcon) // Don't open menu if focussing after the user has clicked clear
        setClearingFromIcon(false);
        else {
            // Don't open when focused into via keyboard if the calendar button is present
            setIsOpen(!shouldShowCalendarButton);
            setCalendarValue(value);
            setIsFocused(true);
            setWasOpenedFromCalendarButton(false);
        }
        onFocus(event);
    };
    const onTextInput = (event)=>{
        const inputValue = event.target.value;
        if (inputValue) {
            const parsed = (0, $5RLF6.parseDate)(inputValue, {
                parseInputValue: rest?.parseInputValue,
                dateFormat: rest?.dateFormat,
                l10n: l10n
            }); // Only try to set the date if we have month & day
            if (parsed && (0, $jovBr.default)(parsed)) // We format the parsed date to YYYY-MM-DD here because
            // this is the format expected by the @atlaskit/calendar component
            setCalendarValue((0, $6AqCE.getShortISOString)(parsed));
        }
        setIsOpen(true);
        setWasOpenedFromCalendarButton(false);
    };
    const onInputKeyDown = (event)=>{
        const value = getValue();
        const keyPressed = event.key.toLowerCase(); // If the input is focused and the calendar is not visible, handle space and enter clicks
        if (!isOpen && (keyPressed === 'enter' || keyPressed === ' ')) {
            setIsOpen(true);
            setWasOpenedFromCalendarButton(false);
        }
        switch(keyPressed){
            case 'escape':
                // Yes, this is not ideal. The alternative is to be able to place a ref
                // on the inner input of Select itself, which would require a lot of
                // extra stuff in the Select component for only this one thing. While
                // this would be more "React-y", it doesn't seem to pose any other
                // benefits. Performance-wise, we are only searching within the
                // container, so it's quick.
                if (wasOpenedFromCalendarButton) calendarButtonRef.current?.focus();
                else {
                    const innerCombobox = containerRef?.current?.querySelector('[role="combobox"]');
                    innerCombobox?.focus();
                }
                setIsOpen(false);
                setShouldSetFocusOnCurrentDay(false);
                setWasOpenedFromCalendarButton(false);
                break;
            case 'backspace':
            case 'delete':
                {
                    const inputCount = 0;
                    if (value && event.target instanceof HTMLInputElement && event.target.value.length <= inputCount) {
                        // If being cleared from keyboard, don't change behaviour
                        setClearingFromIcon(false);
                        setValue('');
                    }
                    break;
                }
            case 'enter':
                if (!isOpen) return;
                 // Prevent form submission when a date is selected
                // using enter. See https://product-fabric.atlassian.net/browse/DSP-2501
                // for more details.
                event.preventDefault();
                if (!(0, $5RLF6.isDateDisabled)(calendarValue, {
                    disabled: disabled
                })) {
                    // Get a safe `calendarValue` in case the value exceeds the maximum
                    // allowed by ISO 8601
                    const safeCalendarValue = (0, $6AqCE.getSafeCalendarValue)(calendarValue);
                    const valueChanged = safeCalendarValue !== value;
                    setSelectInputValue('');
                    setIsOpen(false);
                    setValue(safeCalendarValue);
                    setCalendarValue(safeCalendarValue);
                    setWasOpenedFromCalendarButton(wasOpenedFromCalendarButton);
                    if (valueChanged) onChangePropWithAnalytics(safeCalendarValue);
                }
                break;
            case 'arrowdown':
            case 'arrowup':
                if (!shouldSetFocusOnCurrentDay) {
                    setIsOpen(true);
                    setShouldSetFocusOnCurrentDay(true);
                }
                break;
            default:
                break;
        }
    };
    const onCalendarButtonKeyDown = (e)=>{
        // Don't allow an arrow up or down to open the menu, since the input key
        // down handler is actually on the parent.
        if (e.type === 'keydown' && (e.key === 'ArrowDown' || e.key === 'ArrowUp')) e.stopPropagation();
         // We want to stop this from triggering other keydown events, particularly
        // for space and enter presses. Otherwise, it opens and then closes
        // immediately.
        if (e.type === 'keydown' && (e.key === ' ' || e.key === 'Enter')) {
            e.stopPropagation();
            setIsKeyDown(true);
            setWasOpenedFromCalendarButton(true);
        }
    }; // This event handler is triggered from both keydown and click. It's weird.
    const onCalendarButtonClick = (e)=>{
        setIsOpen(!isOpen);
        setWasOpenedFromCalendarButton(true);
        e.stopPropagation();
    };
    const onClear = ()=>{
        setValue('');
        setCalendarValue(defaultValue || (0, $6AqCE.getShortISOString)(new Date()));
        if (!hideIcon) setClearingFromIcon(true);
        onChangePropWithAnalytics('');
    }; // `unknown` is used because `value` is unused so it does not matter.
    const onSelectChange = (_value, action)=>{
        // Used for native clear event in React Select
        // Triggered when clicking ClearIndicator or backspace with no value
        if (action.action === 'clear') onClear();
    };
    const handleSelectInputChange = (selectInputValue, actionMeta)=>{
        if (selectProps.onInputChange) selectProps.onInputChange(selectInputValue, actionMeta);
        setSelectInputValue(selectInputValue);
    };
    const getContainerRef = (0, $5uXOq.useCallback)((ref)=>{
        const oldRef = containerRef.current;
        containerRef.current = ref; // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef == null && ref != null) forceUpdate();
    }, [
        containerRef
    ]);
    const getterValue = getValue();
    let actualSelectInputValue;
    actualSelectInputValue = selectInputValue;
    const menuIsOpen = getIsOpen() && !isDisabled;
    const showClearIndicator = Boolean((getterValue || selectInputValue) && !hideIcon);
    let clearIndicator = Icon; // eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
    if ((0, $VSDnB.fg)('platform-visual-refresh-icons')) clearIndicator = (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
            xcss: $48f5b21daaca02ab$var$styles.dropdownIndicatorStyles,
            children: /*#__PURE__*/ (0, $2OMIu.jsx)(Icon, {
                ...props
            })
        });
    const dropDownIcon = appearance === 'subtle' || hideIcon || showClearIndicator ? null : clearIndicator;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: propLocale
    });
    const selectComponents = {
        ...selectProps.components,
        DropdownIndicator: shouldShowCalendarButton ? (0, $jHBnA.EmptyComponent) : dropDownIcon,
        // Only use this new container component if the calendar button is shown.
        // Otherwise, it throws errors downstream for some reason
        ...shouldShowCalendarButton ? {
            IndicatorsContainer: (props)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $iaQLg.IndicatorsContainer), {
                    ...props,
                    showClearIndicator: showClearIndicator
                })
        } : {},
        Menu: $gtijU.Menu,
        SingleValue: SingleValue,
        ...!showClearIndicator && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const { styles: selectStyles = {} } = selectProps;
    const disabledStyle = isDisabled ? {
        pointerEvents: 'none',
        color: "var(--ds-icon-disabled, inherit)"
    } : {};
    const calendarProps = {
        calendarContainerRef: containerRef.current,
        calendarDisabled: disabled,
        calendarDisabledDateFilter: disabledDateFilter,
        calendarMaxDate: maxDate,
        calendarMinDate: minDate,
        calendarRef: calendarRef,
        calendarValue: getterValue && (0, $6AqCE.getShortISOString)((0, $eZDAP.default)(getterValue)),
        calendarView: calendarValue,
        onCalendarChange: onCalendarChange,
        onCalendarSelect: onCalendarSelect,
        calendarLocale: locale,
        calendarWeekStartDay: weekStartDay,
        shouldSetFocusOnCurrentDay: shouldSetFocusOnCurrentDay,
        /**
     * This overrides the inner wrapper the Calendar.
     * @private Please use this with extreme caution, this API may be changed in the future.
     */ menuInnerWrapper: props?.menuInnerWrapper
    }; // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base,
                ...disabledStyle
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: "var(--ds-space-025, 2px)",
                // ICON_PADDING = 2
                paddingRight: "var(--ds-space-075, 6px)" // 8 - ICON_PADDING = 6
            })
    });
    const initialValue = getterValue ? {
        label: (0, $5RLF6.formatDate)(getterValue, {
            formatDisplayLabel: formatDisplayLabel,
            dateFormat: rest?.dateFormat,
            l10n: l10n
        }),
        value: getterValue
    } : null; // `label` takes precedence of the `inputLabel`
    const fullopenCalendarLabel = label || inputLabel ? `${label || inputLabel}, ${openCalendarLabel}` : openCalendarLabel;
    const openCalendarLabelId = `open-calendar-label--${(0, $9KnKW.useId)()}`;
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        "data-testid": testId && `${testId}--container`,
        onBlur: onContainerBlur,
        onFocus: onContainerFocus,
        onClick: onInputClick,
        onInput: onTextInput,
        onKeyDown: onInputKeyDown,
        ref: getContainerRef,
        role: "presentation",
        className: (0, $bwpsq.default)([
            $48f5b21daaca02ab$var$styles.pickerContainerStyle
        ]),
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: getterValue,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $7K5PP.default), {
                appearance: appearance,
                "aria-describedby": ariaDescribedBy,
                label: label || undefined,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                closeMenuOnSelect: true,
                enableAnimation: false,
                inputId: id,
                inputValue: actualSelectInputValue,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: menuIsOpen,
                onBlur: onSelectBlur,
                onChange: onSelectChange,
                onFocus: onSelectFocus,
                onInputChange: handleSelectInputChange,
                placeholder: (0, $5RLF6.getPlaceholder)({
                    placeholder: placeholder,
                    l10n: l10n
                }),
                // @ts-ignore -- Type 'OptionType' is not assignable to type '{ label: string; value: string; }'
                styles: mergedStyles,
                value: initialValue,
                ...selectProps,
                // up when you alter some of the properties in the `selectComponents`
                // object. These errors are still present, and I suspect have always
                // been present, without changing the unrelated code. Ignoring as the
                // component still works as expected despite this error. And also
                // because the select refresh team may solve it later.
                components: selectComponents,
                // selectProps or not and what wil be overwritten
                isClearable: true,
                isInvalid: isInvalid,
                spacing: spacing,
                testId: testId,
                // @ts-ignore --  Property 'calendarContainerRef' does not exist on type 'IntrinsicAttributes & LibraryManagedAttributes<(<Option extends unknown = OptionType, IsMulti extends boolean = false>(props: AtlaskitSelectProps<Option, IsMulti> & { ...; }) => Element), AtlaskitSelectProps<...> & { ...; }>'.
                calendarContainerRef: calendarProps.calendarContainerRef,
                calendarDisabled: calendarProps.calendarDisabled,
                calendarDisabledDateFilter: calendarProps.calendarDisabledDateFilter,
                calendarLocale: calendarProps.calendarLocale,
                calendarMaxDate: calendarProps.calendarMaxDate,
                calendarMinDate: calendarProps.calendarMinDate,
                calendarRef: calendarProps.calendarRef,
                calendarValue: calendarProps.calendarValue,
                calendarView: calendarProps.calendarView,
                calendarWeekStartDay: calendarProps.calendarWeekStartDay,
                nextMonthLabel: nextMonthLabel,
                onCalendarChange: calendarProps.onCalendarChange,
                onCalendarSelect: calendarProps.onCalendarSelect,
                previousMonthLabel: previousMonthLabel,
                shouldSetFocusOnCurrentDay: calendarProps.shouldSetFocusOnCurrentDay,
                menuInnerWrapper: calendarProps.menuInnerWrapper
            }),
            shouldShowCalendarButton && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: (0, $3JT92.cx)($48f5b21daaca02ab$var$styles.iconContainerStyles, value && !hideIcon ? $48f5b21daaca02ab$var$styles.iconSpacingWithClearButtonStyles : $48f5b21daaca02ab$var$styles.iconSpacingWithoutClearButtonStyles),
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: !inputLabelId ? fullopenCalendarLabel : openCalendarLabel,
                    "aria-labelledby": inputLabelId ? `${inputLabelId} ${openCalendarLabelId}` : undefined,
                    id: openCalendarLabelId,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($acknU))), {
                            ...iconProps,
                            color: "var(--ds-icon, #44546F)"
                        }),
                    onClick: onCalendarButtonClick,
                    onKeyDown: onCalendarButtonKeyDown,
                    ref: calendarButtonRef,
                    testId: testId && `${testId}--open-calendar-button`
                })
            }) : null
        ]
    });
});
var $48f5b21daaca02ab$export$2e2bcd8739ae039 = $48f5b21daaca02ab$var$DatePicker;

});

parcelRegister("jdTq6", function(module, exports) {

$parcel$export(module.exports, "default", () => $420c0ce16dc216b4$export$2e2bcd8739ae039);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");

var $6QvkM = parcelRequire("6QvkM");

var $eGmKJ = parcelRequire("eGmKJ");

var $7qZ1x = parcelRequire("7qZ1x");

var $iOwNT = parcelRequire("iOwNT");
var $7K5PP = parcelRequire("7K5PP");
var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $imOgG = parcelRequire("imOgG");

var $j537G = parcelRequire("j537G");

var $2ucUe = parcelRequire("2ucUe");

var $dBs4v = parcelRequire("dBs4v");
const $420c0ce16dc216b4$var$packageName = "platform-pkg";
const $420c0ce16dc216b4$var$packageVersion = "0.0.0-use.local";
const $420c0ce16dc216b4$var$menuStyles = {
    /* Need to remove default absolute positioning as that causes issues with position fixed */ position: 'static',
    /* Need to add overflow to the element with max-height, otherwise causes overflow issues in IE11 */ overflowY: 'auto',
    /* React-Popper has already offset the menu so we need to reset the margin, otherwise the offset value is doubled */ margin: 0
};
const $420c0ce16dc216b4$var$analyticsAttributes = {
    componentName: 'timePicker',
    packageName: $420c0ce16dc216b4$var$packageName,
    packageVersion: $420c0ce16dc216b4$var$packageVersion
};
/**
 * __Time picker__
 *
 * A time picker allows the user to select a specific time.
 *
 * - [Examples](https://atlassian.design/components/datetime-picker/time-picker/examples)
 * - [Code](https://atlassian.design/components/datetime-picker/time-picker/code)
 * - [Usage](https://atlassian.design/components/datetime-picker/time-picker/usage)
 */ const $420c0ce16dc216b4$var$TimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear timepicker', defaultIsOpen: defaultIsOpen = false, defaultValue: defaultValue = '', formatDisplayLabel: formatDisplayLabel, hideIcon: hideIcon = false, id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, isOpen: providedIsOpen, label: label = '', locale: locale = 'en-US', name: name = '', onBlur: providedOnBlur = (0, $eGmKJ.default), onChange: providedOnChange = (0, $eGmKJ.default), onFocus: providedOnFocus = (0, $eGmKJ.default), parseInputValue: parseInputValue = (time, _timeFormat)=>(0, $j537G.default)(time), placeholder: placeholder, selectProps: selectProps = {}, spacing: spacing = 'default', testId: testId, timeFormat: timeFormat, timeIsEditable: timeIsEditable = false, times: times = (0, $jHBnA.defaultTimes), value: providedValue }, ref)=>{
    const [containerRef, setContainerRef] = (0, $5uXOq.useState)(null);
    /**
   * When being cleared from the icon the TimePicker is blurred.
   * This variable defines whether the default onMenuOpen or onMenuClose
   * events should behave as normal
   */ const [clearingFromIcon, setClearingFromIcon] = (0, $5uXOq.useState)(false);
    // TODO: Remove isFocused? Does it do anything?
    const [_, setIsFocused] = (0, $5uXOq.useState)(false);
    const [isOpen, setIsOpen] = (0, $5uXOq.useState)(defaultIsOpen);
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue);
    // Hack to force update: https://legacy.reactjs.org/docs/hooks-faq.html#is-there-something-like-forceupdate
    const [, forceUpdate] = (0, $5uXOq.useReducer)((x)=>x + 1, 0);
    const providedOnChangeWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: providedOnChange,
        action: 'selectedTime',
        ...$420c0ce16dc216b4$var$analyticsAttributes
    });
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (providedIsOpen) setIsOpen(providedIsOpen);
    }, [
        providedIsOpen
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, action)=>{
        const rawValue = newValue ? newValue.value || newValue : '';
        const finalValue = rawValue.toString();
        setValue(finalValue);
        if (action && action.action === 'clear') setClearingFromIcon(true);
        providedOnChangeWithAnalytics(finalValue);
    }, [
        providedOnChangeWithAnalytics
    ]);
    /**
   * Only allow custom times if timeIsEditable prop is true
   */ const onCreateOption = (inputValue)=>{
        if (timeIsEditable) {
            let sanitizedInput;
            try {
                sanitizedInput = parseInputValue(inputValue, timeFormat || (0, $jHBnA.defaultTimeFormat));
            } catch (e) {
                return; // do nothing, the main validation should happen in the form
            }
            const includesSeconds = !!(timeFormat && /[:.]?(s|ss)/.test(timeFormat));
            const formatFormat = includesSeconds ? 'HH:mm:ss' : 'HH:mm';
            const formattedValue = (0, $k7m40.default)(sanitizedInput, formatFormat) || '';
            setValue(formattedValue);
            providedOnChangeWithAnalytics(formattedValue);
        } else providedOnChangeWithAnalytics(inputValue);
    };
    const onMenuOpen = ()=>{
        // Don't open menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(true);
    };
    const onMenuClose = ()=>{
        // Don't close menu after the user has clicked clear
        if (clearingFromIcon) setClearingFromIcon(false);
        else setIsOpen(false);
    };
    const setInternalContainerRef = (ref)=>{
        const oldRef = containerRef;
        setContainerRef(ref);
        // Cause a re-render if we're getting the container ref for the first time
        // as the layered menu requires it for dimension calculation
        if (oldRef === null && ref !== null) forceUpdate();
    };
    const onBlur = (event)=>{
        setIsFocused(false);
        providedOnBlur(event);
    };
    const onFocus = (event)=>{
        setIsFocused(true);
        providedOnFocus(event);
    };
    const onSelectKeyDown = (event)=>{
        const { key: key } = event;
        const keyPressed = key.toLowerCase();
        if (clearingFromIcon && (keyPressed === 'backspace' || keyPressed === 'delete')) // If being cleared from keyboard, don't change behaviour
        setClearingFromIcon(false);
    };
    const ICON_PADDING = 2;
    const GRID_SIZE = 8;
    const l10n = (0, $7qZ1x.createLocalizationProvider)(locale);
    const { styles: selectStyles = {}, ...otherSelectProps } = selectProps;
    const SelectComponent = timeIsEditable ? (0, $iOwNT.default) : (0, $7K5PP.default);
    /**
   * There are multiple props that can change how the time is formatted.
   * The priority of props used is:
   *   1. formatDisplayLabel
   *   2. timeFormat
   *   3. locale
   */ const formatTime = (time)=>{
        if (formatDisplayLabel) return formatDisplayLabel(time, timeFormat || (0, $jHBnA.defaultTimeFormat));
        const date = (0, $j537G.default)(time);
        if (!(date instanceof Date)) return '';
        if (!(0, $jovBr.default)(date)) return time;
        if (timeFormat) return (0, $k7m40.default)(date, (0, $2ucUe.convertTokens)(timeFormat));
        return l10n.formatTime(date);
    };
    const options = times.map((time)=>{
        return {
            label: formatTime(time),
            value: time
        };
    });
    let initialValue;
    if (providedValue !== null && providedValue !== undefined && providedValue !== '') initialValue = {
        label: formatTime(providedValue),
        value: providedValue
    };
    else if (providedValue !== '' && value) initialValue = {
        label: formatTime(value),
        value: value
    };
    else initialValue = null;
    const SingleValue = (0, $dBs4v.makeSingleValue)({
        lang: locale
    });
    const selectComponents = {
        DropdownIndicator: (0, $jHBnA.EmptyComponent),
        Menu: (0, $imOgG.FixedLayerMenu),
        SingleValue: SingleValue,
        ...hideIcon && {
            ClearIndicator: (0, $jHBnA.EmptyComponent)
        }
    };
    const renderIconContainer = Boolean(!hideIcon && value);
    // @ts-ignore -- Argument of type 'StylesConfig<OptionType, false, GroupBase<OptionType>>' is not assignable to parameter of type 'StylesConfig<OptionType, boolean, GroupBase<OptionType>>'.
    const mergedStyles = (0, $7VXAu.mergeStyles)(selectStyles, {
        control: (base)=>({
                ...base
            }),
        menu: (base)=>({
                ...base,
                ...$420c0ce16dc216b4$var$menuStyles,
                // Fixed positioned elements no longer inherit width from their parent, so we must explicitly set the
                // menu width to the width of our container
                width: containerRef ? containerRef.getBoundingClientRect().width : 'auto'
            }),
        indicatorsContainer: (base)=>({
                ...base,
                paddingLeft: renderIconContainer ? ICON_PADDING : 0,
                paddingRight: renderIconContainer ? GRID_SIZE - ICON_PADDING : 0
            })
    });
    return /*#__PURE__*/ (0, $2OMIu.jsxs)("div", {
        ...innerProps,
        ref: setInternalContainerRef,
        "data-testid": testId && `${testId}--container`,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`,
                onKeyDown: onSelectKeyDown
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)(SelectComponent, {
                "aria-describedby": ariaDescribedBy,
                "aria-label": label || undefined,
                appearance: appearance,
                autoFocus: autoFocus,
                clearControlLabel: clearControlLabel,
                components: selectComponents,
                inputId: id,
                isClearable: true,
                isDisabled: isDisabled,
                isRequired: isRequired,
                menuIsOpen: isOpen && !isDisabled,
                menuPlacement: "auto",
                openMenuOnFocus: true,
                onBlur: onBlur,
                onCreateOption: onCreateOption,
                onChange: onChange,
                options: options,
                onFocus: onFocus,
                onMenuOpen: onMenuOpen,
                onMenuClose: onMenuClose,
                placeholder: placeholder || l10n.formatTime((0, $jHBnA.placeholderDatetime)),
                styles: mergedStyles,
                value: initialValue,
                spacing: spacing,
                // We need this to get things to work, even though it's not supported.
                // @ts-ignore
                fixedLayerRef: containerRef,
                isInvalid: isInvalid,
                testId: testId,
                ...otherSelectProps
            })
        ]
    });
});
var $420c0ce16dc216b4$export$2e2bcd8739ae039 = $420c0ce16dc216b4$var$TimePicker;

});
parcelRegister("iOwNT", function(module, exports) {

$parcel$export(module.exports, "default", () => $59b6485f0cb008dd$export$2e2bcd8739ae039);

var $9OU1i = parcelRequire("9OU1i");

var $3c98u = parcelRequire("3c98u");
const $59b6485f0cb008dd$var$CreatableSelect = (0, $3c98u.default)((0, $9OU1i.default));
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$59b6485f0cb008dd$export$2e2bcd8739ae039 = $59b6485f0cb008dd$var$CreatableSelect;

});
parcelRegister("9OU1i", function(module, exports) {

$parcel$export(module.exports, "default", () => $b29f1caecd9c7d5a$export$2e2bcd8739ae039);
$parcel$export(module.exports, "useCreatable", () => (parcelRequire("2HH7Y")).default);

var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $2QhWf = parcelRequire("2QhWf");

var $2HH7Y = parcelRequire("2HH7Y");

var $9uJ4X = parcelRequire("9uJ4X");
const $b29f1caecd9c7d5a$var$CreatableSelect = /*#__PURE__*/ (0, $5uXOq.forwardRef)((props, ref)=>{
    const creatableProps = (0, $9uJ4X.default)(props);
    const selectProps = (0, $2HH7Y.default)(creatableProps);
    return /*#__PURE__*/ (0, $2OMIu.jsx)((0, $2QhWf.default), {
        ref: ref,
        ...selectProps
    });
});
var // eslint-disable-next-line @repo/internal/react/require-jsdoc
$b29f1caecd9c7d5a$export$2e2bcd8739ae039 = $b29f1caecd9c7d5a$var$CreatableSelect;

});
parcelRegister("2HH7Y", function(module, exports) {

$parcel$export(module.exports, "default", () => $994aeb783b6f955a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eEtcC = parcelRequire("eEtcC");

var $gyjU7 = parcelRequire("gyjU7");
const $994aeb783b6f955a$var$compareOption = (inputValue = '', option, accessors)=>{
    const candidate = String(inputValue).toLowerCase();
    const optionValue = String(accessors.getOptionValue(option)).toLowerCase();
    const optionLabel = String(accessors.getOptionLabel(option)).toLowerCase();
    return optionValue === candidate || optionLabel === candidate;
};
const $994aeb783b6f955a$var$builtins = {
    formatCreateLabel: (inputValue)=>`Create "${inputValue}"`,
    isValidNewOption: (inputValue, selectValue, selectOptions, accessors)=>!(!inputValue || selectValue.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors)) || selectOptions.some((option)=>$994aeb783b6f955a$var$compareOption(inputValue, option, accessors))),
    getNewOptionData: (inputValue, optionLabel)=>({
            label: optionLabel,
            value: inputValue,
            __isNew__: true
        })
};
function $994aeb783b6f955a$export$2e2bcd8739ae039({ allowCreateWhileLoading: allowCreateWhileLoading = false, createOptionPosition: createOptionPosition = 'last', formatCreateLabel: formatCreateLabel = $994aeb783b6f955a$var$builtins.formatCreateLabel, isValidNewOption: isValidNewOption = $994aeb783b6f955a$var$builtins.isValidNewOption, getNewOptionData: //@ts-ignore
getNewOptionData = $994aeb783b6f955a$var$builtins.getNewOptionData, onCreateOption: onCreateOption, options: propsOptions = [], onChange: propsOnChange, ...restSelectProps }) {
    const { getOptionValue: getOptionValue = (0, $eEtcC.getOptionValue), getOptionLabel: getOptionLabel = (0, $eEtcC.getOptionLabel), inputValue: inputValue, isLoading: isLoading, isMulti: isMulti, value: value, name: name } = restSelectProps;
    const newOption = (0, $5uXOq.useMemo)(()=>isValidNewOption(inputValue, (0, $gyjU7.cleanValue)(value), propsOptions, {
            getOptionValue: getOptionValue,
            getOptionLabel: getOptionLabel
        }) ? getNewOptionData(inputValue, formatCreateLabel(inputValue)) : undefined, [
        formatCreateLabel,
        getNewOptionData,
        getOptionLabel,
        getOptionValue,
        inputValue,
        isValidNewOption,
        propsOptions,
        value
    ]);
    const options = (0, $5uXOq.useMemo)(()=>(allowCreateWhileLoading || !isLoading) && newOption ? createOptionPosition === 'first' ? [
            newOption,
            ...propsOptions
        ] : [
            ...propsOptions,
            newOption
        ] : propsOptions, [
        allowCreateWhileLoading,
        createOptionPosition,
        isLoading,
        newOption,
        propsOptions
    ]);
    const onChange = (0, $5uXOq.useCallback)((newValue, actionMeta)=>{
        if (actionMeta.action !== 'select-option') return propsOnChange(newValue, actionMeta);
        const valueArray = Array.isArray(newValue) ? newValue : [
            newValue
        ];
        if (valueArray[valueArray.length - 1] === newOption) {
            if (onCreateOption) onCreateOption(inputValue);
            else {
                const newOptionData = getNewOptionData(inputValue, inputValue);
                const newActionMeta = {
                    action: 'create-option',
                    name: name,
                    option: newOptionData
                };
                propsOnChange((0, $gyjU7.valueTernary)(isMulti, [
                    ...(0, $gyjU7.cleanValue)(value),
                    newOptionData
                ], newOptionData), newActionMeta);
            }
            return;
        }
        propsOnChange(newValue, actionMeta);
    }, [
        getNewOptionData,
        inputValue,
        isMulti,
        name,
        newOption,
        onCreateOption,
        propsOnChange,
        value
    ]);
    return {
        ...restSelectProps,
        options: options,
        onChange: onChange
    };
}

});



parcelRegister("imOgG", function(module, exports) {

$parcel$export(module.exports, "FixedLayerMenu", () => $cf860f703ecf4b3d$export$982ad994195b4356);
/* fixed-layer-menu.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");
parcelRequire("5uXOq");

var $bChGW = parcelRequire("bChGW");

var $avHVh = parcelRequire("avHVh");
const $cf860f703ecf4b3d$export$982ad994195b4356 = ({ className: className, clearValue: clearValue, cx: cx, getStyles: getStyles, getValue: getValue, hasValue: hasValue, innerProps: innerProps, innerRef: innerRef, isLoading: isLoading, isMulti: isMulti, isRtl: isRtl, maxMenuHeight: maxMenuHeight, menuPlacement: menuPlacement, menuPosition: menuPosition, menuShouldScrollIntoView: menuShouldScrollIntoView, minMenuHeight: minMenuHeight, options: options, placement: placement, selectOption: selectOption, selectProps: selectProps, setValue: setValue, children: children, ...rest })=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, $avHVh.default), {
        inputValue: selectProps.inputValue,
        //@ts-ignore react-select unsupported props
        containerRef: selectProps.fixedLayerRef,
        content: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $bChGW.components).Menu, {
            ...rest,
            // eslint-disable-next-line @atlaskit/design-system/no-unsafe-style-overrides, @atlaskit/ui-styling-standard/no-classname-prop
            className: className,
            clearValue: clearValue,
            cx: cx,
            getStyles: getStyles,
            getValue: getValue,
            hasValue: hasValue,
            innerProps: innerProps,
            innerRef: innerRef,
            isLoading: isLoading,
            isMulti: isMulti,
            isRtl: isRtl,
            maxMenuHeight: maxMenuHeight,
            menuPlacement: menuPlacement,
            menuPosition: menuPosition,
            menuShouldScrollIntoView: menuShouldScrollIntoView,
            minMenuHeight: minMenuHeight,
            options: options,
            placement: placement,
            selectOption: selectOption,
            selectProps: selectProps,
            setValue: setValue,
            children: children
        }),
        //@ts-ignore react-select unsupported props
        testId: selectProps.testId
    });

});

parcelRegister("j537G", function(module, exports) {

$parcel$export(module.exports, "default", () => $b5e493719c30ce57$export$2e2bcd8739ae039);
const $b5e493719c30ce57$var$map24 = {
    '12': '12',
    '01': '13',
    '02': '14',
    '03': '15',
    '04': '16',
    '05': '17',
    '06': '18',
    '07': '19',
    '08': '20',
    '09': '21',
    '10': '22',
    '11': '23'
};
function $b5e493719c30ce57$export$1ea939691cdc45b8(timeString) {
    /**
	 * Regex match for `12:34`, `12:34:56`, `1:23:56 p`, `1:23:56PM`, and a bit more…
	 */ const time = timeString.trim().match(/([012]?[\d])(?::([0-5][\d]))?(?::([0-5][\d]))?\s*([ap]m?)?/i);
    /**
	 * Regex match for `1234`, `12:34`, `12.34`, `123456`, `12:34:56`, `12.34.56`
	 */ const time24hr = timeString.trim().match(/([012][\d])[:.]?([0-5][\d])([:.]?([0-5][\d]))?/);
    /**
	 * Convert `2:34:56 pm` down to `23456`
	 */ const num = timeString.replace(/[^0-9]/g, '');
    const includesSeconds = time && time[1] !== undefined && time[2] !== undefined && time[3] !== undefined || time24hr && time24hr[1] !== undefined && time24hr[2] !== undefined && time24hr[4] !== undefined;
    if (!time && !time24hr) return false;
    if (time && !time[1]) return false;
    if (num.length > 6) return false;
    if (num.length > 4 && !includesSeconds) return false;
    if (num.length === 2 && parseInt(num, 10) > 12) return false;
    return true;
}
function $b5e493719c30ce57$export$49c81d9f91c512ce(time) {
    return time.replace(/[:.]/g, '');
}
function $b5e493719c30ce57$var$formatSemi24(time) {
    if (time.length === 1) return `0${time}00`;
    if (time.length === 2) return `${time}00`;
    if (time.length === 3 || time.length === 5) return `0${time}`;
    return time;
}
function $b5e493719c30ce57$var$checkHour(hour, meridiem) {
    if (hour > '24') return null;
    if (hour === '12' && meridiem === 'a') return '00';
    if (hour < '12' && meridiem === 'p') return $b5e493719c30ce57$var$map24[hour];
    return hour;
}
function $b5e493719c30ce57$var$checkMinuteSecond(value) {
    if (value > '59') return null;
    return value;
}
function $b5e493719c30ce57$export$6137ce2c9c5166bb(time) {
    const timeArray = time.toLowerCase().split(/(p|a)/i);
    const meridiem = timeArray[1];
    const semi24 = $b5e493719c30ce57$var$formatSemi24(timeArray[0].trim());
    const hour = $b5e493719c30ce57$var$checkHour(semi24.substring(0, 2), meridiem);
    const minute = $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(2, 4));
    const seconds = semi24.length === 6 && $b5e493719c30ce57$var$checkMinuteSecond(semi24.substring(4, 6));
    if (!hour || !minute) return null;
    return {
        hour: parseInt(hour, 10),
        minute: parseInt(minute, 10),
        seconds: parseInt(seconds || '0', 10) || 0
    };
}
function $b5e493719c30ce57$var$assignToDate(time) {
    const dateTime = new Date();
    dateTime.setHours(time.hour);
    dateTime.setMinutes(time.minute);
    // milliseconds is not supported
    dateTime.setSeconds(time.seconds || 0, 0);
    return dateTime;
}
function $b5e493719c30ce57$export$2e2bcd8739ae039(time) {
    const trimmedTime = time.toString().trim();
    if (!$b5e493719c30ce57$export$1ea939691cdc45b8(trimmedTime)) throw RangeError('invalid time format');
    const time1 = $b5e493719c30ce57$export$49c81d9f91c512ce(trimmedTime);
    const time2 = $b5e493719c30ce57$export$6137ce2c9c5166bb(time1);
    if (!time2) throw RangeError('invalid time format');
    return $b5e493719c30ce57$var$assignToDate(time2);
}

});



parcelRegister("hB1kl", function(module, exports) {

$parcel$export(module.exports, "default", () => $9d24b25c52c40a49$export$2e2bcd8739ae039);
/* date-time-picker-fc.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $2OMIu = parcelRequire("2OMIu");

var $5uXOq = parcelRequire("5uXOq");

var $k7m40 = parcelRequire("k7m40");
var $jovBr = parcelRequire("jovBr");
var $eZDAP = parcelRequire("eZDAP");

var $6QvkM = parcelRequire("6QvkM");

var $42CjB = parcelRequire("42CjB");

var $cQz2U = parcelRequire("cQz2U");

var $VSDnB = parcelRequire("VSDnB");

var $MHKc7 = parcelRequire("MHKc7");
var $c0aEF = parcelRequire("c0aEF");

var $7VXAu = parcelRequire("7VXAu");

var $jHBnA = parcelRequire("jHBnA");

var $8JNJx = parcelRequire("8JNJx");

var $cKsfY = parcelRequire("cKsfY");

var $2ucUe = parcelRequire("2ucUe");

var $2TI0z = parcelRequire("2TI0z");

var $jcbUF = parcelRequire("jcbUF");

var $jdTq6 = parcelRequire("jdTq6");
const $9d24b25c52c40a49$var$DatePicker = (0, $cKsfY.componentWithCondition)(// eslint-disable-next-line @atlaskit/platform/ensure-feature-flag-prefix
()=>(0, $VSDnB.fg)('dst-date-picker-use-functional-component'), (0, $jcbUF.default), (0, $2TI0z.default));
const $9d24b25c52c40a49$var$packageName = "platform-pkg";
const $9d24b25c52c40a49$var$packageVersion = "0.0.0-use.local";
const $9d24b25c52c40a49$var$analyticsAttributes = {
    componentName: 'dateTimePicker',
    packageName: $9d24b25c52c40a49$var$packageName,
    packageVersion: $9d24b25c52c40a49$var$packageVersion
};
const $9d24b25c52c40a49$var$compiledStyles = {
    datePickerContainerStyles: "_i0dl1ssb _16jlkb7n _1o9zidpf",
    timePickerContainerStyles: "_i0dl1ssb _16jlkb7n",
    iconContainerStyles: "_1e0c1txw _4cvr1h6o _i0dl1kw7"
}; // react-select overrides (via @atlaskit/select).
const $9d24b25c52c40a49$var$styles = {
    control: (style)=>({
            ...style,
            backgroundColor: 'transparent',
            border: 2,
            borderRadius: 0,
            paddingLeft: 0,
            ':hover': {
                backgroundColor: 'transparent',
                cursor: 'inherit'
            }
        })
};
const $9d24b25c52c40a49$export$3b559a1219cb3c27 = 'Date';
const $9d24b25c52c40a49$export$d82cc7e53d68a428 = 'Time'; /**
                                                   * __Date time picker__
                                                   *
                                                   * A date time picker allows the user to select an associated date and time.
                                                   *
                                                   * - [Examples](https://atlassian.design/components/datetime-picker/examples)
                                                   * - [Code](https://atlassian.design/components/datetime-picker/code)
                                                   * - [Usage](https://atlassian.design/components/datetime-picker/usage)
                                                   */ 
const $9d24b25c52c40a49$var$DateTimePicker = /*#__PURE__*/ (0, $5uXOq.forwardRef)(({ 'aria-describedby': ariaDescribedBy, appearance: appearance = 'default', autoFocus: autoFocus = false, clearControlLabel: clearControlLabel = 'clear', datePickerProps: datePickerPropsWithSelectProps = {}, defaultValue: defaultValue = '', id: id = '', innerProps: innerProps = {}, isDisabled: isDisabled = false, isInvalid: isInvalid = false, isRequired: isRequired = false, name: name = '', onBlur: // These disables are here for proper typing when used as defaults. They
// should *not* use the `noop` function.
/* eslint-disable @repo/internal/react/use-noop */ onBlur = (_event)=>{}, onChange: onChangeProp = (_value)=>{}, onFocus: onFocus = (_event)=>{}, /* eslint-enable @repo/internal/react/use-noop */ parseValue: providedParseValue, spacing: spacing = 'default', locale: locale = 'en-US', testId: testId, timePickerProps: timePickerPropsWithSelectProps = {}, value: providedValue }, ref)=>{
    const [dateValue, setDateValue] = (0, $5uXOq.useState)(datePickerPropsWithSelectProps?.defaultValue || '');
    const [isFocused, setIsFocused] = (0, $5uXOq.useState)(false);
    const [timeValue, setTimeValue] = (0, $5uXOq.useState)(timePickerPropsWithSelectProps?.defaultValue || '');
    const [value, setValue] = (0, $5uXOq.useState)(defaultValue || '');
    const [zoneValue, setZoneValue] = (0, $5uXOq.useState)('');
    (0, $5uXOq.useEffect)(()=>{
        if (providedValue) setValue(providedValue);
    }, [
        providedValue
    ]);
    const parseValue = (0, $5uXOq.useCallback)((value, providedDateValue, providedTimeValue, providedZoneValue)=>{
        if (providedParseValue) {
            const parsedFromFn = providedParseValue(value, providedDateValue, providedTimeValue, providedZoneValue); // This handles cases found in Jira where the parse function actually does
            // nothing and returns undefined. The previous `getSafeState` function
            // just spread the values over the state, but if it returned `undefined`,
            // it would just rely on the previous state values. Considering this is
            // what is input to this function anyway, this is a safe way to handle
            // this, colocate the behavior, and not rely on `getSafeState`.
            return parsedFromFn || {
                dateValue: providedDateValue,
                timeValue: providedTimeValue,
                zoneValue: providedZoneValue
            };
        }
        const parsed = (0, $eZDAP.default)(value);
        return (0, $jovBr.default)(parsed) ? {
            dateValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('YYYY-MM-DD')),
            timeValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('HH:mm')),
            zoneValue: (0, $k7m40.default)(parsed, (0, $2ucUe.convertTokens)('ZZ'))
        } : {
            dateValue: dateValue,
            timeValue: timeValue,
            zoneValue: zoneValue
        };
    }, [
        providedParseValue,
        dateValue,
        timeValue,
        zoneValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        setDateValue(parsedValues.dateValue);
        setTimeValue(parsedValues.timeValue);
        setZoneValue(parsedValues.zoneValue);
    }, [
        value,
        dateValue,
        timeValue,
        zoneValue,
        parseValue
    ]);
    const onDateBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (datePickerPropsWithSelectProps?.onBlur) datePickerPropsWithSelectProps.onBlur(event);
    };
    const onTimeBlur = (event)=>{
        setIsFocused(false);
        onBlur(event);
        if (timePickerPropsWithSelectProps?.onBlur) timePickerPropsWithSelectProps.onBlur(event);
    };
    const onDateFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (datePickerPropsWithSelectProps?.onFocus) datePickerPropsWithSelectProps.onFocus(event);
    };
    const onTimeFocus = (event)=>{
        setIsFocused(false);
        onFocus(event);
        if (timePickerPropsWithSelectProps?.onFocus) timePickerPropsWithSelectProps.onFocus(event);
    };
    const onDateChange = (dateValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: dateValue,
            providedTimeValue: parsedValues.timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange(dateValue);
    };
    const onTimeChange = (timeValue)=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: parsedValues.dateValue,
            providedTimeValue: timeValue,
            providedZoneValue: parsedValues.zoneValue
        });
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange(timeValue);
    };
    const onClear = ()=>{
        const parsedValues = parseValue(value, dateValue, timeValue, zoneValue);
        onValueChange({
            providedDateValue: '',
            providedTimeValue: '',
            providedZoneValue: parsedValues.zoneValue
        });
        if (datePickerPropsWithSelectProps?.onChange) datePickerPropsWithSelectProps.onChange('');
        if (timePickerPropsWithSelectProps?.onChange) timePickerPropsWithSelectProps.onChange('');
    };
    const onChangePropWithAnalytics = (0, $6QvkM.usePlatformLeafEventHandler)({
        fn: onChangeProp,
        action: 'selectedDate',
        actionSubject: 'datePicker',
        ...$9d24b25c52c40a49$var$analyticsAttributes
    });
    const onValueChange = ({ providedDateValue: providedDateValue, providedTimeValue: providedTimeValue, providedZoneValue: providedZoneValue })=>{
        setDateValue(providedDateValue);
        setTimeValue(providedTimeValue);
        setZoneValue(providedZoneValue);
        if (providedDateValue && providedTimeValue) {
            const value = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, providedZoneValue);
            const { zoneValue: parsedZone } = parseValue(value, providedDateValue, providedTimeValue, providedZoneValue);
            const valueWithValidZone = (0, $jHBnA.formatDateTimeZoneIntoIso)(providedDateValue, providedTimeValue, parsedZone);
            setValue(valueWithValidZone);
            onChangePropWithAnalytics(valueWithValidZone); // If the date or time value was cleared when there is an existing datetime value, then clear the value.
        } else if (value) {
            setValue('');
            onChangePropWithAnalytics('');
        }
    };
    const { selectProps: datePickerSelectProps, ...datePickerProps } = datePickerPropsWithSelectProps;
    const datePickerAriaDescribedBy = datePickerProps['aria-describedby'] || ariaDescribedBy;
    const datePickerLabel = datePickerProps.label || $9d24b25c52c40a49$export$3b559a1219cb3c27;
    const mergedDatePickerSelectProps = {
        ...datePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, datePickerSelectProps?.styles)
    };
    const { selectProps: timePickerSelectProps, ...timePickerProps } = timePickerPropsWithSelectProps;
    const timePickerAriaDescribedBy = timePickerProps['aria-describedby'] || ariaDescribedBy;
    const timePickerLabel = timePickerProps.label || $9d24b25c52c40a49$export$d82cc7e53d68a428;
    const mergedTimePickerSelectProps = {
        ...timePickerSelectProps,
        styles: (0, $7VXAu.mergeStyles)($9d24b25c52c40a49$var$styles, timePickerSelectProps?.styles)
    }; // Render DateTimePicker's IconContainer when a value has been filled
    // Don't use Date or TimePicker's because they can't be customised
    const isClearable = Boolean(dateValue || timeValue);
    return /*#__PURE__*/ (0, $2OMIu.jsxs)((0, $8JNJx.DateTimePickerContainer), {
        appearance: appearance,
        isDisabled: isDisabled,
        isFocused: isFocused,
        isInvalid: isInvalid,
        testId: testId,
        innerProps: innerProps,
        children: [
            /*#__PURE__*/ (0, $2OMIu.jsx)("input", {
                name: name,
                type: "hidden",
                value: value,
                "data-testid": testId && `${testId}--input`
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.datePickerContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)($9d24b25c52c40a49$var$DatePicker, {
                    appearance: appearance,
                    "aria-describedby": datePickerAriaDescribedBy,
                    autoFocus: datePickerProps.autoFocus || autoFocus,
                    dateFormat: datePickerProps.dateFormat,
                    defaultIsOpen: datePickerProps.defaultIsOpen,
                    defaultValue: datePickerProps.defaultValue,
                    disabled: datePickerProps.disabled,
                    disabledDateFilter: datePickerProps.disabledDateFilter,
                    formatDisplayLabel: datePickerProps.formatDisplayLabel,
                    hideIcon: datePickerProps.hideIcon || true,
                    icon: datePickerProps.icon,
                    id: datePickerProps.id || id,
                    innerProps: datePickerProps.innerProps,
                    inputLabel: datePickerProps.inputLabel,
                    inputLabelId: datePickerProps.inputLabelId,
                    isDisabled: datePickerProps.isDisabled || isDisabled,
                    isInvalid: datePickerProps.isInvalid || isInvalid,
                    isOpen: datePickerProps.isOpen,
                    isRequired: datePickerProps.isRequired || isRequired,
                    label: datePickerLabel,
                    locale: datePickerProps.locale || locale,
                    maxDate: datePickerProps.maxDate,
                    minDate: datePickerProps.minDate,
                    name: datePickerProps.name,
                    nextMonthLabel: datePickerProps.nextMonthLabel,
                    onBlur: onDateBlur,
                    onChange: onDateChange,
                    onFocus: onDateFocus,
                    openCalendarLabel: datePickerProps.openCalendarLabel,
                    parseInputValue: datePickerProps.parseInputValue,
                    placeholder: datePickerProps.placeholder,
                    previousMonthLabel: datePickerProps.previousMonthLabel,
                    selectProps: mergedDatePickerSelectProps,
                    shouldShowCalendarButton: datePickerProps.shouldShowCalendarButton,
                    spacing: datePickerProps.spacing || spacing,
                    testId: testId && `${testId}--datepicker` || datePickerProps.testId,
                    value: dateValue,
                    weekStartDay: datePickerProps.weekStartDay
                })
            }),
            /*#__PURE__*/ (0, $2OMIu.jsx)((0, $MHKc7.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.timePickerContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $jdTq6.default), {
                    appearance: timePickerProps.appearance || appearance,
                    "aria-describedby": timePickerAriaDescribedBy,
                    autoFocus: timePickerProps.autoFocus,
                    defaultIsOpen: timePickerProps.defaultIsOpen,
                    defaultValue: timePickerProps.defaultValue,
                    formatDisplayLabel: timePickerProps.formatDisplayLabel,
                    hideIcon: timePickerProps.hideIcon || true,
                    id: timePickerProps.id,
                    innerProps: timePickerProps.innerProps,
                    isDisabled: timePickerProps.isDisabled || isDisabled,
                    isInvalid: timePickerProps.isInvalid || isInvalid,
                    isOpen: timePickerProps.isOpen,
                    isRequired: timePickerProps.isRequired || isRequired,
                    label: timePickerLabel,
                    locale: timePickerProps.locale || locale,
                    name: timePickerProps.name,
                    onBlur: onTimeBlur,
                    onChange: onTimeChange,
                    onFocus: onTimeFocus,
                    parseInputValue: timePickerProps.parseInputValue,
                    placeholder: timePickerProps.placeholder,
                    selectProps: mergedTimePickerSelectProps,
                    spacing: timePickerProps.spacing || spacing,
                    testId: timePickerProps.testId || testId && `${testId}--timepicker`,
                    timeFormat: timePickerProps.timeFormat,
                    timeIsEditable: timePickerProps.timeIsEditable,
                    times: timePickerProps.times,
                    value: timeValue
                })
            }),
            isClearable && !isDisabled ? /*#__PURE__*/ (0, $2OMIu.jsx)((0, $c0aEF.default), {
                xcss: $9d24b25c52c40a49$var$compiledStyles.iconContainerStyles,
                children: /*#__PURE__*/ (0, $2OMIu.jsx)((0, $42CjB.default), {
                    appearance: "subtle",
                    label: clearControlLabel,
                    icon: (iconProps)=>/*#__PURE__*/ (0, $2OMIu.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cQz2U))), {
                            ...iconProps,
                            color: "var(--ds-text-subtlest, #626F86)",
                            LEGACY_size: "small"
                        }),
                    onClick: onClear,
                    testId: testId && `${testId}--icon--container`,
                    tabIndex: -1
                })
            }) : null
        ]
    });
});
var $9d24b25c52c40a49$export$2e2bcd8739ae039 = $9d24b25c52c40a49$var$DateTimePicker;

});


parcelRegister("7NYq5", function(module, exports) {

$parcel$export(module.exports, "JiraModal", () => $d308ab9275c4cac7$export$3782fcca1f68992e);

var $5uXOq = parcelRequire("5uXOq");

var $1R1Ge = parcelRequire("1R1Ge");

var $10xFf = parcelRequire("10xFf");

var $c0dQj = parcelRequire("c0dQj");

var $1WAOl = parcelRequire("1WAOl");
const $d308ab9275c4cac7$export$3782fcca1f68992e = (props)=>{
    if ((0, $10xFf.shouldBeChoreographed)(props)) {
        if ((0, $c0dQj.isMobileAndInViewPanelIterationExperiment)()) return null;
        const { messageType: messageType, ...rest } = props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1WAOl.ChoreographerModal), rest);
    }
    const { messageType: messageType, messageId: messageId, onMessageDisposition: onMessageDisposition, ...rest } = props;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1R1Ge.default), rest);
};
$d308ab9275c4cac7$export$3782fcca1f68992e.displayName = 'JiraModal';

});
parcelRegister("1WAOl", function(module, exports) {

$parcel$export(module.exports, "ChoreographerModal", () => $ae3d8c3c4e97b978$export$3f5d627caa6fc630);
// eslint-disable-next-line @typescript-eslint/no-restricted-imports

var $1R1Ge = parcelRequire("1R1Ge");

var $cSWNW = parcelRequire("cSWNW");
const $ae3d8c3c4e97b978$export$3f5d627caa6fc630 = (0, $cSWNW.withChoreographedRender)((0, $1R1Ge.default));

});


parcelRegister("hO2mG", function(module, exports) {

$parcel$export(module.exports, "getDayOptions", () => $b6e9dfed9f9dd9c8$export$c9a4384ba880408a);
$parcel$export(module.exports, "getDefaultTimes", () => $b6e9dfed9f9dd9c8$export$951e947e785c998d);
$parcel$export(module.exports, "createEmptyIntervalValue", () => $b6e9dfed9f9dd9c8$export$f1cb5eeb3e4452b1);
$parcel$export(module.exports, "getDayValue", () => $b6e9dfed9f9dd9c8$export$3a1562e64a58f62b);
$parcel$export(module.exports, "getTimeValue", () => $b6e9dfed9f9dd9c8$export$9ea65b90e29638cb);

var $gwejS = parcelRequire("gwejS");

var $k7m40 = parcelRequire("k7m40");

var $jovBr = parcelRequire("jovBr");

var $1GF3c = parcelRequire("1GF3c");
const $b6e9dfed9f9dd9c8$var$dayLabelFormat = {
    default: 'EEEE',
    compact: 'EEE'
};
const $b6e9dfed9f9dd9c8$export$c9a4384ba880408a = (params = {
    weekStartDay: 1
}, variant = 'default')=>{
    if (params.weekStartDay > 8) params.weekStartDay = params.weekStartDay % 8;
    const firstDOW = (0, $1GF3c.default)(new Date(), {
        weekStartsOn: params.weekStartDay - 1
    });
    const weekDays = Array.from(Array(7)).map((e, i)=>({
            label: (0, $k7m40.default)((0, $gwejS.default)(firstDOW, i), $b6e9dfed9f9dd9c8$var$dayLabelFormat[variant]),
            value: (i + params.weekStartDay - 1) % 7 + 1
        }));
    return weekDays;
};
const $b6e9dfed9f9dd9c8$export$951e947e785c998d = ()=>{
    return [
        ...Array(24).keys()
    ].map((time)=>{
        let newTime = time.toString();
        if (newTime.length === 1) newTime = `0${time}`;
        return [
            `${newTime}:00`,
            `${newTime}:30`
        ];
    }).flatMap((time)=>time);
};
const $b6e9dfed9f9dd9c8$export$f1cb5eeb3e4452b1 = ()=>{
    return {
        startDay: null,
        startHour: null,
        startMinute: null,
        endDay: null,
        endHour: null,
        endMinute: null
    };
};
const $b6e9dfed9f9dd9c8$export$3a1562e64a58f62b = (value, variant = 'default')=>{
    if (value) {
        if (value.day) {
            const dayOptions = $b6e9dfed9f9dd9c8$export$c9a4384ba880408a(undefined, variant);
            const dayValue = dayOptions.find((day)=>day.value === value.day);
            return dayValue || undefined;
        }
    }
    return undefined;
};
const $b6e9dfed9f9dd9c8$export$9ea65b90e29638cb = (value)=>{
    if (!value) return;
    const { hour: hour, minute: minute } = value;
    if (hour === null || hour === undefined || minute === null || minute === undefined) return;
    if (hour > 24 || minute > 60) return;
    const date = new Date();
    date.setHours(hour, minute);
    if (!(0, $jovBr.default)(date)) return;
    return (0, $k7m40.default)(date, 'HH:mm');
};

});

parcelRegister("ivHJ6", function(module, exports) {

$parcel$export(module.exports, "useIncrementCreationService", () => $48d17f38e228d167$export$cd3734bd633c5dea);

var $5uXOq = parcelRequire("5uXOq");

var $ld2hZ = parcelRequire("ld2hZ");

var $eusud = parcelRequire("eusud");

var $bmKPg = parcelRequire("bmKPg");
const $48d17f38e228d167$export$cd3734bd633c5dea = ()=>{
    const [planId] = (0, $bmKPg.usePathParam)('planId');
    const request = (0, $5uXOq.useCallback)((requestData)=>(0, $eusud.performPostRequest)(`/rest/jpo/2.0/plans/${planId}/increments`, {
            body: JSON.stringify(requestData)
        }), [
        planId
    ]);
    const { loading: loading, error: error, data: data, fetch: fetch } = (0, $ld2hZ.useService)(request);
    return {
        saving: loading,
        error: error,
        data: data,
        save: fetch
    };
};

});
parcelRegister("ld2hZ", function(module, exports) {

$parcel$export(module.exports, "useService", () => $b3ad55f76ff82cb6$export$6de4685a6c88b4e9);
$parcel$export(module.exports, "useLoadingStatusService", () => $b3ad55f76ff82cb6$export$c963713a27525aaf);

var $5uXOq = parcelRequire("5uXOq");
const $b3ad55f76ff82cb6$export$6de4685a6c88b4e9 = (request, initialState = {})=>{
    const [state, setState] = (0, $5uXOq.useState)({
        loading: false,
        data: undefined,
        error: undefined,
        ...initialState
    });
    const fetch = (0, $5uXOq.useCallback)(async (requestData)=>{
        setState({
            loading: true,
            error: undefined,
            data: undefined
        });
        try {
            const data = await request(requestData);
            setState({
                loading: false,
                error: undefined,
                data: data
            });
            return data;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        } catch (error) {
            setState({
                loading: false,
                error: error,
                data: undefined
            });
            return undefined;
        }
    }, [
        request
    ]);
    return {
        ...state,
        fetch: fetch
    };
};
const $b3ad55f76ff82cb6$export$c963713a27525aaf = (request, initialState = {})=>{
    const [loadingStatus, setLoadingStatus] = (0, $5uXOq.useState)('idle');
    const { data: data, loading: loading, error: error, fetch: fetch } = $b3ad55f76ff82cb6$export$6de4685a6c88b4e9(request, initialState);
    (0, $5uXOq.useEffect)(()=>{
        if (loading) setLoadingStatus('started');
        else if (error) setLoadingStatus('error');
        else if (data) setLoadingStatus('success');
    }, [
        data,
        loading,
        error
    ]);
    return {
        data: data,
        loadingStatus: loadingStatus,
        error: error,
        fetch: fetch
    };
};

});


parcelRegister("h9qPG", function(module, exports) {

$parcel$export(module.exports, "ScopeFilterValue", () => $e78f1b983b9b97c5$export$c05b3e6305ac65cd);
$parcel$export(module.exports, "ScopeFilterField", () => $e78f1b983b9b97c5$export$7f20c193b296fdf0);

var $5uXOq = parcelRequire("5uXOq");

var $lFKmC = parcelRequire("lFKmC");

var $fWqG2 = parcelRequire("fWqG2");

var $ujWmd = parcelRequire("ujWmd");

var $qfj8c = parcelRequire("qfj8c");
var $7O4UO = parcelRequire("7O4UO");
var $bUa6y = parcelRequire("bUa6y");

var $dC5iT = parcelRequire("dC5iT");
var $f5TWP = parcelRequire("f5TWP");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $bChGW = parcelRequire("bChGW");
var $7K5PP = parcelRequire("7K5PP");

var $3bDjY = parcelRequire("3bDjY");

var $gwIPs = parcelRequire("gwIPs");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $5sUih = parcelRequire("5sUih");

var $4OuBK = parcelRequire("4OuBK");

var $emGA4 = parcelRequire("emGA4");

var $3hAHQ = parcelRequire("3hAHQ");
const $e78f1b983b9b97c5$var$OptionComponent = ({ project: project, label: label })=>{
    const projectElements = !(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(project) && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span"
    }, "\xa0("), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $ujWmd.default), {
        appearance: "square",
        size: "xsmall",
        name: project.key,
        src: project.avatar
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "span"
    }, "\xa0", project.key, ")"));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $f5TWP.default), {
        alignBlock: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e78f1b983b9b97c5$var$OptionStyles
    }, label), projectElements);
};
const $e78f1b983b9b97c5$var$BoardScopeFilterControl = ({ children: children, ...props })=>{
    const selectedValue = props.getValue();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: selectedValue.length > 0 && selectedValue[0].label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Control, props, children));
};
const $e78f1b983b9b97c5$var$BoardScopeFilterSingleValue = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).SingleValue, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e78f1b983b9b97c5$var$OptionComponent, {
        label: props.data.label,
        project: props.data.project
    }));
const $e78f1b983b9b97c5$var$BoardScopeFilterOption = (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3bDjY.default), {
        content: props.data.label
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bChGW.components).Option, props, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($e78f1b983b9b97c5$var$OptionComponent, {
        label: props.data.label,
        project: props.data.project
    })));
const $e78f1b983b9b97c5$export$c05b3e6305ac65cd = ({ defaultValue: defaultValue, onCustomFieldValuesFetched: onCustomFieldValuesFetched })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { planId: planId, scenarioId: scenarioId } = (0, $5uXOq.useContext)((0, $5sUih.default));
    const formState = (0, $bUa6y.useFormState)();
    const previousFieldId = (0, $5uXOq.useRef)(undefined);
    const fieldId = formState?.values?.filterFieldId?.value;
    const { values: customFieldValues, isLoading: isLoading, fetchCustomFieldValues: fetchCustomFieldValues } = (0, $4OuBK.useFetchCustomFieldValues)({
        planId: planId,
        scenarioId: scenarioId,
        fieldId: fieldId
    });
    const currentFieldValue = formState?.values.filterFieldValue ?? defaultValue;
    (0, $5uXOq.useEffect)(()=>{
        if (customFieldValues && onCustomFieldValuesFetched && (0, $4R6GH.fg)('program_board_scope_filter_editing')) onCustomFieldValuesFetched();
    }, [
        customFieldValues,
        onCustomFieldValuesFetched
    ]);
    const debouncedLoadOptions = (0, $5uXOq.useMemo)(()=>(0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))((query)=>{
            fetchCustomFieldValues(query);
        }, 200), [
        fetchCustomFieldValues
    ]);
    const customFieldValueOptions = (0, $5uXOq.useMemo)(()=>{
        const returnedValues = (customFieldValues || []).map((v)=>({
                label: v.value,
                value: v.value
            }));
        if (defaultValue && (0, $4R6GH.fg)('program_board_scope_filter_editing')) {
            const isDefaultOptionIncluded = (customFieldValues || []).find((v)=>v.value === defaultValue);
            if (!isDefaultOptionIncluded) returnedValues.push({
                label: defaultValue,
                value: defaultValue
            });
        }
        return returnedValues;
    }, [
        customFieldValues,
        defaultValue
    ]);
    const valueOfSelect = (0, $5uXOq.useMemo)(()=>customFieldValueOptions.find((v)=>v.value === currentFieldValue?.value), [
        customFieldValueOptions,
        currentFieldValue
    ]);
    const onInputChangeHandler = (0, $5uXOq.useCallback)((query, actionMeta)=>{
        if (actionMeta.action !== 'input-change') return;
        debouncedLoadOptions(query);
    }, [
        debouncedLoadOptions
    ]);
    const onChangeHandler = (0, $5uXOq.useCallback)((newValue, actionMeta, onChange)=>{
        if (actionMeta.action === 'clear') debouncedLoadOptions('');
        onChange(newValue, actionMeta);
    }, [
        debouncedLoadOptions
    ]);
    const onFocusHandler = (0, $5uXOq.useCallback)((event, onFocus)=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(valueOfSelect)) {
            debouncedLoadOptions('');
            onFocus(event);
        }
    }, [
        debouncedLoadOptions,
        valueOfSelect
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (previousFieldId.current !== fieldId) {
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(fieldId)) debouncedLoadOptions('');
            previousFieldId.current = fieldId;
        }
    }, [
        fieldId,
        debouncedLoadOptions
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e78f1b983b9b97c5$var$FieldBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        "aria-required": true,
        name: "filterFieldValue",
        testId: "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.custom-field-value",
        label: formatMessage((0, $3hAHQ.default).scopeFilterFieldValueLabel),
        isDisabled: (0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(fieldId),
        defaultValue: (0, $4R6GH.fg)('program_board_scope_filter_editing') ? customFieldValueOptions.find((v)=>v.label === defaultValue) : undefined
    }, ({ fieldProps: { id: id, value: value, onChange: onChange, onFocus: onFocus, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            isLoading: isLoading,
            isClearable: true,
            inputId: id,
            closeMenuOnScroll: true,
            openMenuOnFocus: true,
            options: customFieldValueOptions,
            onInputChange: onInputChangeHandler,
            value: valueOfSelect,
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    })
            },
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: document.body,
            placeholder: formatMessage((0, $3hAHQ.default).scopeFilterFieldValuePlaceholder),
            controlShouldRenderValue: !(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(valueOfSelect),
            components: {
                ...(0, (/*@__PURE__*/$parcel$interopDefault($fWqG2)))(valueOfSelect) && {
                    ClearIndicator: ()=>null
                }
            },
            "aria-label": formatMessage((0, $3hAHQ.default).scopeFilterFieldValueLabel),
            onChange: (newValue, actionMeta)=>onChangeHandler(newValue, actionMeta, onChange),
            onFocus: (event)=>onFocusHandler(event, onFocus),
            filterOption: ()=>true,
            ...rest
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))));
};
const $e78f1b983b9b97c5$export$7f20c193b296fdf0 = ({ shouldFetchCustomFields: shouldFetchCustomFields, defaultValue: defaultValue, onCustomFieldsFetched: onCustomFieldsFetched })=>{
    const { planId: planId } = (0, $5uXOq.useContext)((0, $5sUih.default));
    const { customFields: customFields, fetchCustomFields: fetchCustomFields, isLoading: isLoadingCustomFields } = (0, $emGA4.useFetchCustomFields)({
        planId: planId
    });
    const customFieldOptions = (0, $5uXOq.useMemo)(()=>{
        if (isLoadingCustomFields) return [];
        return (customFields || []).map((f)=>({
                label: f.title,
                value: f.id,
                project: f.project
            }));
    }, [
        customFields,
        isLoadingCustomFields
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onCustomFieldsFetched && customFields && (0, $4R6GH.fg)('program_board_scope_filter_editing')) onCustomFieldsFetched();
    }, [
        customFields,
        onCustomFieldsFetched
    ]);
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    (0, $5uXOq.useEffect)(()=>{
        if (shouldFetchCustomFields) fetchCustomFields();
    }, [
        fetchCustomFields,
        shouldFetchCustomFields
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $e78f1b983b9b97c5$var$FieldBoxStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7O4UO.default), {
        "aria-required": true,
        name: "filterFieldId",
        testId: "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.custom-field",
        label: formatMessage((0, $3hAHQ.default).scopeFilterFieldLabel),
        defaultValue: (0, $4R6GH.fg)('program_board_scope_filter_editing') ? customFieldOptions.find((v)=>v.value === defaultValue) : undefined
    }, ({ fieldProps: { id: id, ...rest }, error: error })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
            inputId: id,
            isLoading: isLoadingCustomFields,
            isClearable: true,
            isSearchable: true,
            closeMenuOnScroll: true,
            styles: {
                menuPortal: (base)=>({
                        ...base,
                        zIndex: (0, $gwIPs.layers).modal
                    })
            },
            // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            menuPortalTarget: document.body,
            placeholder: formatMessage((0, $3hAHQ.default).scopeFilterFieldPlaceholder),
            options: customFieldOptions,
            components: {
                Option: $e78f1b983b9b97c5$var$BoardScopeFilterOption,
                SingleValue: $e78f1b983b9b97c5$var$BoardScopeFilterSingleValue,
                Control: $e78f1b983b9b97c5$var$BoardScopeFilterControl
            },
            ...rest
        }), error && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $qfj8c.ErrorMessage), null, error))));
};
const $e78f1b983b9b97c5$var$FieldBoxStyles = (0, $8CUq3.xcss)({
    width: '50%'
});
const $e78f1b983b9b97c5$var$OptionStyles = (0, $8CUq3.xcss)({
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap'
});

});
parcelRegister("bUa6y", function(module, exports) {

$parcel$export(module.exports, "useFormState", () => $0ed03f14f588391e$export$606f11b2eb45ecc6);

var $5uXOq = parcelRequire("5uXOq");

var $efXp3 = parcelRequire("efXp3");
// Constantized to avoid a new object reference built every call
const $0ed03f14f588391e$var$defaultSubscriptionConfig = {
    values: true
};
/**
 * Build a simple hash for a given subscription object for use in a `useMemo` dependencies array.
 * This is because `{ values: true } !== { values: true }`, but `'values:true|' === 'values:true|'`
 *
 * @example { values: true, dirty: false } => 'values:true|dirty:false|'
 */ const $0ed03f14f588391e$var$getSubscriptionHash = (subscriptionConfig)=>{
    let hash = '';
    for(const key in subscriptionConfig)if (subscriptionConfig.hasOwnProperty(key)) hash += `${key}:${subscriptionConfig[key]}|`;
    return hash;
};
const $0ed03f14f588391e$export$606f11b2eb45ecc6 = (subscriptionConfig = $0ed03f14f588391e$var$defaultSubscriptionConfig)=>{
    const { subscribe: subscribe } = (0, $5uXOq.useContext)((0, $efXp3.FormContext));
    const [state, setState] = (0, $5uXOq.useState)();
    /**
	 * A hash for us to shallow compare the subscriptionConfig object to react to shallow changes, but avoid referential changes.
	 * We avoid computing the hash if the subscription config has referential equality altogether.
	 */ const subscriptionConfigHash = (0, $5uXOq.useMemo)(()=>$0ed03f14f588391e$var$getSubscriptionHash(subscriptionConfig), [
        subscriptionConfig
    ]);
    /**
	 * Return a memoized version of the subscription config to only react to shallow changes, not referential changes.
	 * Eg. calling `useFormState({ values: true })` twice will result in two different objects by reference, but not by shallow comparison.
	 * This will ensure we don't re-subscribe to the form state when the subscription config is the same.
	 */ const config = (0, $5uXOq.useMemo)(()=>subscriptionConfig, // eslint-disable-next-line react-hooks/exhaustive-deps -- intentionally controlled with a hash to have an explicit shallow comparison
    [
        subscriptionConfigHash
    ]);
    (0, $5uXOq.useEffect)(()=>{
        const unsubscribe = subscribe((formState)=>{
            setState(formState);
        }, config);
        return ()=>unsubscribe();
    }, [
        subscribe,
        config
    ]);
    return state;
};

});

parcelRegister("4OuBK", function(module, exports) {

$parcel$export(module.exports, "useFetchCustomFieldValues", () => $453183d0cc86877a$export$4fffb4b733c3194d);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $453183d0cc86877a$export$4fffb4b733c3194d = ({ planId: planId, scenarioId: scenarioId, fieldId: fieldId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [values, setValues] = (0, $5uXOq.useState)(null);
    const fetchCustomFieldValues = (0, $5uXOq.useCallback)(async (query = '')=>{
        try {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(planId)) throw new Error('planId is empty in the creation IP board');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(scenarioId)) throw new Error('scenarioId is empty in the creation IP board');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldId)) throw new Error('fieldId is empty in the creation IP board');
            setIsLoading(true);
            const url = `/rest/jpo/2.0/plans/${planId}/increments/scenarios/${scenarioId}/fieldId/${fieldId}/scopeFilterValues?query=${query}`;
            // eslint-disable-next-line @typescript-eslint/no-shadow
            const values = await (0, $eusud.performGetRequest)(url);
            setValues(values || []);
            setError(null);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: (0, $4jAPy.SERVICES_ERROR_ID),
                    packageName: (0, $4jAPy.PACKAGE_NAME),
                    teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
                },
                attributes: {
                    serviceName: 'useFetchCustomFieldValues'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(error);
            setValues(null);
        } finally{
            setIsLoading(false);
        }
    }, [
        planId,
        scenarioId,
        fieldId
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(fieldId)) setValues(null);
    }, [
        fieldId
    ]);
    return {
        isLoading: isLoading,
        error: error,
        values: values,
        fetchCustomFieldValues: fetchCustomFieldValues
    };
};

});

parcelRegister("emGA4", function(module, exports) {

$parcel$export(module.exports, "useFetchCustomFields", () => $d9a80884ad89eec5$export$61fa1c8b082f394e);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $d9a80884ad89eec5$export$61fa1c8b082f394e = ({ planId: planId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [customFields, setCustomFields] = (0, $5uXOq.useState)(null);
    const fetchCustomFields = (0, $5uXOq.useCallback)(async ()=>{
        try {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(planId)) throw new Error('planId is empty in the fetch custom fields request');
            setIsLoading(true);
            const rawCustomFields = await (0, $eusud.performGetRequest)(`/rest/jpo/2.0/plans/${planId}/increments/scopeFilterFields`);
            setCustomFields(rawCustomFields || []);
            setError(null);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: (0, $4jAPy.SERVICES_ERROR_ID),
                    packageName: (0, $4jAPy.PACKAGE_NAME),
                    teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
                },
                attributes: {
                    serviceName: 'useFetchCustomFields'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(error);
            setCustomFields(null);
        } finally{
            setIsLoading(false);
        }
    }, [
        planId
    ]);
    return {
        isLoading: isLoading,
        error: error,
        customFields: customFields,
        fetchCustomFields: fetchCustomFields
    };
};

});

parcelRegister("3hAHQ", function(module, exports) {

$parcel$export(module.exports, "default", () => $cb8b6a4ca7c13973$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $cb8b6a4ca7c13973$var$messages = (0, $7VHMR.defineMessages)({
    scopeFilterFieldValueLabel: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.scope-filter-field-value-label",
        "defaultMessage": "Value"
    },
    scopeFilterFieldValuePlaceholder: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.scope-filter-field-value-placeholder",
        "defaultMessage": "Select value"
    },
    scopeFilterFieldLabel: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.scope-filter-field-label",
        "defaultMessage": "Field"
    },
    scopeFilterFieldPlaceholder: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.board-scope-filter.scope-filter-field-placeholder",
        "defaultMessage": "Select field"
    }
});
var $cb8b6a4ca7c13973$export$2e2bcd8739ae039 = $cb8b6a4ca7c13973$var$messages;

});


parcelRegister("1bxch", function(module, exports) {

$parcel$export(module.exports, "default", () => $8e0056041ef7689f$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $dS3PR = parcelRequire("dS3PR");

var $koVbs = parcelRequire("koVbs");

var $aipk9 = parcelRequire("aipk9");

var $kjUWA = parcelRequire("kjUWA");
const $8e0056041ef7689f$var$CalculatedBoardEndDate = ()=>{
    const intl = (0, $koVbs.default)();
    const formState = (0, $bUa6y.useFormState)({
        values: true,
        pristine: true,
        dirty: true
    });
    const columnDuration = formState?.values?.iterationLength?.value;
    const numberOfColumns = formState?.values?.iterationsCount?.value;
    const start = formState?.values?.start;
    const getEndDate = ()=>{
        if (!columnDuration || !numberOfColumns || !start) return null;
        const startDate = new Date(start);
        const programDurationMS = columnDuration * numberOfColumns * 604800000;
        return (0, $aipk9.formatDateWithIntl)(intl, startDate.getTime() + programDurationMS);
    };
    return columnDuration && numberOfColumns && start && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        size: "small",
        as: "p"
    }, intl.formatMessage((0, $kjUWA.default).estimatedEndDate), ' ', /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dS3PR.default), {
        weight: "semibold",
        size: "small"
    }, getEndDate()));
};
var $8e0056041ef7689f$export$2e2bcd8739ae039 = $8e0056041ef7689f$var$CalculatedBoardEndDate;

});
parcelRegister("kjUWA", function(module, exports) {

$parcel$export(module.exports, "default", () => $6f3dbe5e8ba5cfea$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $6f3dbe5e8ba5cfea$var$messages = (0, $7VHMR.defineMessages)({
    estimatedEndDate: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.calculated-end-date.estimated-end-date",
        "defaultMessage": "Estimated board end date:"
    }
});
var $6f3dbe5e8ba5cfea$export$2e2bcd8739ae039 = $6f3dbe5e8ba5cfea$var$messages;

});


parcelRegister("7pWV1", function(module, exports) {

$parcel$export(module.exports, "default", () => $b8e067dd53de6e3a$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $dC5iT = parcelRequire("dC5iT");
var $cgL5K = parcelRequire("cgL5K");
var $8CUq3 = parcelRequire("8CUq3");

var $eZJjh = parcelRequire("eZJjh");

var $4R6GH = parcelRequire("4R6GH");

var $koVbs = parcelRequire("koVbs");

var $4jAPy = parcelRequire("4jAPy");

var $5sUih = parcelRequire("5sUih");

var $7GiTF = parcelRequire("7GiTF");

var $jiKCm = parcelRequire("jiKCm");
const $b8e067dd53de6e3a$var$IssueCountText = ({ children: children })=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dC5iT.default), {
        xcss: $b8e067dd53de6e3a$var$issueCountStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "p"
    }, children));
const $b8e067dd53de6e3a$var$shouldRefetchIssueCount = (startDate, issueCountVisible, filterFieldId, filterFieldValue, lastStartDate, lastFilterFieldValue)=>{
    // startDate is always required
    if (!startDate) return false;
    const filterIsValid = !filterFieldId || filterFieldId && filterFieldValue;
    const countEmptyOrValuesChanged = !issueCountVisible || lastStartDate.current !== startDate || !!filterFieldId && !!filterFieldValue && lastFilterFieldValue.current !== filterFieldValue;
    if (// Fetch field values if count is empty (initial state) or values is changed, and the filter field and values are valid
    countEmptyOrValuesChanged && filterIsValid) return true;
    return false;
};
const $b8e067dd53de6e3a$var$IssueCount = ({ initialStartDate: initialStartDate, onIssueCountUpdated: onIssueCountUpdated })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { planId: planId, scenarioId: scenarioId } = (0, $5uXOq.useContext)((0, $5sUih.default));
    const formState = (0, $bUa6y.useFormState)();
    const [issueCountVisible, setIssueCountVisible] = (0, $5uXOq.useState)(false);
    const startDate = formState?.values?.start;
    const filterFieldId = formState?.values?.filterFieldId?.value;
    const filterFieldValue = formState?.values?.filterFieldValue?.value;
    const lastStartDate = (0, $5uXOq.useRef)(initialStartDate);
    const lastFilterField = (0, $5uXOq.useRef)(undefined);
    const lastFilterFieldValue = (0, $5uXOq.useRef)(undefined);
    const { issueCount: issueCount, fetchIssueCount: fetchIssueCount, isLoading: isLoadingIssueCount } = (0, $7GiTF.useFetchIssueCount)({
        planId: planId,
        scenarioId: scenarioId,
        // iterationsCount and iterationLength are not used by the backend when counting issues, hence only default value is needed
        iterationsCount: (0, $4jAPy.DEFAULT_ITERATIONS_COUNT),
        iterationLength: (0, $4jAPy.DEFAULT_ITERATION_LENGTH),
        start: new Date(startDate).getTime(),
        filterFieldId: filterFieldId,
        filterFieldValue: filterFieldValue
    });
    (0, $5uXOq.useEffect)(()=>{
        if ($b8e067dd53de6e3a$var$shouldRefetchIssueCount(startDate, issueCountVisible, filterFieldId, filterFieldValue, lastStartDate, lastFilterFieldValue)) {
            fetchIssueCount();
            setIssueCountVisible(true);
            if (lastStartDate.current !== startDate) lastStartDate.current = startDate;
            if (lastFilterField.current !== filterFieldId) lastFilterField.current = filterFieldId;
            if (lastFilterFieldValue.current !== filterFieldValue) lastFilterFieldValue.current = filterFieldValue;
        }
    }, [
        fetchIssueCount,
        filterFieldId,
        lastFilterField,
        filterFieldValue,
        lastFilterFieldValue,
        issueCountVisible,
        lastStartDate,
        startDate
    ]);
    // hide issue count if any values were cleared, otherwise the count is not accurate
    (0, $5uXOq.useEffect)(()=>{
        if (!startDate || // check if it was fetched and then cleared for the below two fields
        !filterFieldId && lastFilterField.current || !filterFieldValue && lastFilterFieldValue.current) setIssueCountVisible(false);
    }, [
        startDate,
        filterFieldId,
        lastFilterField,
        filterFieldValue,
        lastFilterFieldValue
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (onIssueCountUpdated && issueCountVisible && issueCount !== null && (0, $4R6GH.fg)('program_board_scope_filter_editing')) onIssueCountUpdated(issueCount);
    }, [
        issueCount,
        issueCountVisible,
        onIssueCountUpdated
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($b8e067dd53de6e3a$var$IssueCountText, null, formatMessage((0, $4R6GH.fg)('jira-issue-terminology-refresh-m3') ? (0, $jiKCm.default).issueCountIssueTermRefresh : (0, $jiKCm.default).issueCount), ' ', isLoadingIssueCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eZJjh.default), {
        size: "small"
    }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $cgL5K.default), {
        as: "strong"
    }, issueCountVisible ? issueCount : '-'));
};
var $b8e067dd53de6e3a$export$2e2bcd8739ae039 = $b8e067dd53de6e3a$var$IssueCount;
const $b8e067dd53de6e3a$var$issueCountStyles = (0, $8CUq3.xcss)({
    marginRight: 'auto'
});

});
parcelRegister("7GiTF", function(module, exports) {

$parcel$export(module.exports, "useFetchIssueCount", () => $c031d978f0ab7ef2$export$4690e93e2d7a84f9);

var $5uXOq = parcelRequire("5uXOq");

var $hGgHi = parcelRequire("hGgHi");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $c031d978f0ab7ef2$export$4690e93e2d7a84f9 = ({ planId: planId, scenarioId: scenarioId, start: start, iterationsCount: iterationsCount, iterationLength: iterationLength, filterFieldId: filterFieldId, filterFieldValue: filterFieldValue })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(null);
    const [issueCount, setIssueCount] = (0, $5uXOq.useState)(null);
    const fetchIssueCount = (0, $5uXOq.useCallback)(async ()=>{
        try {
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(planId)) throw new Error('planId is empty in the fetch issue count request');
            if ((0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(scenarioId)) throw new Error('scenarioId is empty in the fetch issue count request');
            setIsLoading(true);
            const payload = {
                start: start,
                iterationsCount: iterationsCount,
                iterationLength: iterationLength,
                filterFieldId: filterFieldId,
                filterFieldValue: // We don't clear the field value if the filter field is not set, so we should only send the value when the field id is defined
                filterFieldId ? filterFieldValue : undefined
            };
            const options = {
                body: JSON.stringify(payload)
            };
            const { issueCount: responseIssueCount } = await (0, $eusud.performPostRequest)(`/rest/jpo/2.0/plans/${planId}/increment/board/preview/scenarios/${scenarioId}/countIssues`, options);
            setIssueCount(responseIssueCount);
            setError(null);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-shadow
        } catch (error) {
            (0, $jcw0u.default)({
                meta: {
                    id: (0, $4jAPy.SERVICES_ERROR_ID),
                    packageName: (0, $4jAPy.PACKAGE_NAME),
                    teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
                },
                attributes: {
                    serviceName: 'useFetchIssueCount'
                },
                error: error,
                sendToPrivacyUnsafeSplunk: true
            });
            setError(error);
            setIssueCount(null);
        } finally{
            setIsLoading(false);
        }
    }, [
        planId,
        scenarioId,
        start,
        iterationsCount,
        iterationLength,
        filterFieldId,
        filterFieldValue
    ]);
    return {
        isLoading: isLoading,
        error: error,
        issueCount: issueCount,
        fetchIssueCount: fetchIssueCount
    };
};

});

parcelRegister("jiKCm", function(module, exports) {

$parcel$export(module.exports, "default", () => $ad5c16479c4854f4$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $ad5c16479c4854f4$var$messages = (0, $7VHMR.defineMessages)({
    issueCount: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.issue-count.issue-count",
        "defaultMessage": "Issue count:"
    },
    issueCountIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.issue-count.issue-count-issue-term-refresh",
        "defaultMessage": "Work item count:"
    }
});
var $ad5c16479c4854f4$export$2e2bcd8739ae039 = $ad5c16479c4854f4$var$messages;

});


parcelRegister("84ylG", function(module, exports) {

$parcel$export(module.exports, "default", () => $c485b4be4a973372$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $bUa6y = parcelRequire("bUa6y");

var $7K5PP = parcelRequire("7K5PP");

var $gwIPs = parcelRequire("gwIPs");

var $4jAPy = parcelRequire("4jAPy");

var $2Ukhf = parcelRequire("2Ukhf");
function $c485b4be4a973372$var$isObjKey(key) {
    return key in (0, $2Ukhf.iterationLengthCountOptionsMap);
}
const $c485b4be4a973372$var$IterationsCountField = (fieldProps)=>{
    const formState = (0, $bUa6y.useFormState)();
    const selectedDuration = Number(formState?.values?.iterationLength?.value ?? (0, $4jAPy.DEFAULT_ITERATION_LENGTH));
    const prevDuration = (0, $5uXOq.useRef)(selectedDuration);
    const optionsForSelectedDuration = (0, $5uXOq.useMemo)(()=>{
        const optionsSettings = $c485b4be4a973372$var$isObjKey(selectedDuration) && (0, $2Ukhf.iterationLengthCountOptionsMap)[selectedDuration];
        const options = optionsSettings ? (0, $4jAPy.ITERATIONS_COUNT_OPTIONS).filter((o)=>o.value >= optionsSettings.min && o.value <= optionsSettings.max) : [];
        return options;
    }, [
        selectedDuration
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (prevDuration.current !== selectedDuration) {
            const defaultValue = $c485b4be4a973372$var$isObjKey(selectedDuration) ? (0, $2Ukhf.iterationLengthCountOptionsMap)[selectedDuration].default : (0, $4jAPy.DEFAULT_ITERATIONS_COUNT);
            const defaultOption = (0, $4jAPy.ITERATIONS_COUNT_OPTIONS).find((o)=>o.value === defaultValue);
            if (defaultOption) {
                fieldProps.onChange(defaultOption);
                prevDuration.current = selectedDuration;
            }
        }
    }, [
        selectedDuration,
        fieldProps,
        optionsForSelectedDuration
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $7K5PP.default), {
        ...fieldProps,
        options: optionsForSelectedDuration,
        styles: {
            menuPortal: (base)=>({
                    ...base,
                    zIndex: (0, $gwIPs.layers).modal
                })
        },
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        menuPortalTarget: document.body
    });
};
var $c485b4be4a973372$export$2e2bcd8739ae039 = $c485b4be4a973372$var$IterationsCountField;

});
parcelRegister("2Ukhf", function(module, exports) {

$parcel$export(module.exports, "iterationLengthCountOptionsMap", () => $2d792066a3160e4e$export$14cde6092cffa40f);
const $2d792066a3160e4e$export$14cde6092cffa40f = {
    1: {
        min: 7,
        max: 13,
        default: 12
    },
    2: {
        min: 5,
        max: 8,
        default: 6
    },
    3: {
        min: 4,
        max: 6,
        default: 4
    },
    4: {
        min: 3,
        max: 4,
        default: 3
    }
};

});


parcelRegister("7gW1a", function(module, exports) {

$parcel$export(module.exports, "getWeekStartDay", () => $74e5775b893e9e56$export$99291c0265ff1d37);
$parcel$export(module.exports, "getNextQuarterStartDate", () => $74e5775b893e9e56$export$31c7b6297e06a9e);

var $1p96B = parcelRequire("1p96B");
const $74e5775b893e9e56$export$99291c0265ff1d37 = (locale)=>(0, $1p96B.getLocale)(locale)?.options?.weekStartsOn || 0;
const $74e5775b893e9e56$export$31c7b6297e06a9e = (date)=>{
    const today = date ?? new Date();
    const QUARTER_STARTS = [
        1,
        4,
        7,
        10
    ];
    let month;
    let isNextYear = false;
    // if today is the start of a quarter, return today, otherwise return the start of the next quarter
    if (today.getDate() === 1 && QUARTER_STARTS.includes(today.getMonth() + 1)) month = today.getMonth() + 1;
    else {
        const nextStart = QUARTER_STARTS.find((q)=>q > today.getMonth());
        month = nextStart ?? QUARTER_STARTS[0];
        isNextYear = month === QUARTER_STARTS[0];
    }
    const year = today.getFullYear() + (isNextYear ? 1 : 0);
    return `${year}-${`0${month}`.slice(-2)}-01T12:00:00`;
};

});

parcelRegister("iHezY", function(module, exports) {

$parcel$export(module.exports, "default", () => $e3fa946ecd4fb771$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
const $e3fa946ecd4fb771$var$messages = (0, $7VHMR.defineMessages)({
    addIncrementTitle: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.add-increment-title",
        "defaultMessage": "Create a program board"
    },
    addIncrementDescriptionNew: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.add-increment-description-new",
        "defaultMessage": "Schedule work across multiple teams and iterations for the next quarter. "
    },
    doclink: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.doclink",
        "defaultMessage": "See how to configure your program board"
    },
    nameShort: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-short",
        "defaultMessage": "Board name (required)"
    },
    startDateShort: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-short",
        "defaultMessage": "Start date"
    },
    startTime: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-time",
        "defaultMessage": "Start time"
    },
    namePlaceholder: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-placeholder",
        "defaultMessage": "e.g.Q1FY24"
    },
    submit: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.submit",
        "defaultMessage": "Create"
    },
    cancel: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.cancel",
        "defaultMessage": "Cancel"
    },
    errorLabel: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.error-label",
        "defaultMessage": "We couldn\u2019t create your board. Refresh the page and try again. "
    },
    closeModal: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.close-modal",
        "defaultMessage": "Close modal"
    },
    scopeFilterHeading: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.scope-filter-heading",
        "defaultMessage": "What issues do you want to include?"
    },
    scopeFilterHeadingIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.scope-filter-heading-issue-term-refresh",
        "defaultMessage": "What work items do you want to include?"
    },
    scopeFilterDescription: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.scope-filter-description",
        "defaultMessage": "Select a field to filter which issues from your plan are added to your program board. You can use the <bold>Label</bold> field or a custom field that\u2019s been added to your plan. <link>Read more about program boards.</link>"
    },
    scopeFilterDescriptionIssueTermRefresh: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.scope-filter-description-issue-term-refresh",
        "defaultMessage": "Select a field to filter which work items from your plan are added to your program board. You can use the <bold>Label</bold> field or a custom field that\u2019s been added to your plan. <link>Read more about program boards.</link>"
    },
    nameEmptyError: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.name-empty-error",
        "defaultMessage": "Name is required"
    },
    startDateEmptyError: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-empty-error",
        "defaultMessage": "Start date is required"
    },
    startDateAndTimeEmptyError: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.start-date-and-time-empty-error",
        "defaultMessage": "Start date and time is required"
    },
    fieldValueEmptyError: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.field-value-empty-error",
        "defaultMessage": "Field value is required when you select Field"
    },
    iterationLength: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.iteration-length",
        "defaultMessage": "Column duration"
    },
    iterationsCount: {
        "id": "portfolio-3-plan-increment-common.ui.increment-forms.creation-modal.iterations-count",
        "defaultMessage": "Number of columns"
    }
});
var $e3fa946ecd4fb771$export$2e2bcd8739ae039 = $e3fa946ecd4fb771$var$messages;

});


parcelRegister("fzC6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $98227ef8895a8a29$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $98227ef8895a8a29$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    activeGroupLabel: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.active-group-label",
        "defaultMessage": "Active"
    },
    pastGroupLabel: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.past-group-label",
        "defaultMessage": "Past"
    },
    createProgramBoard: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.create-program-board",
        "defaultMessage": "Create a new program board"
    },
    manageProgramBoards: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.manage-program-boards",
        "defaultMessage": "Manage program boards"
    },
    manageProgramBoardsTitle: {
        "id": "portfolio-3-plan-increment-common.ui.board-switcher.manage-program-boards-title",
        "defaultMessage": "Navigate to Program board settings page"
    }
});

});


parcelRegister("4xTtj", function(module, exports) {

$parcel$export(module.exports, "default", () => $142cf36e132bee65$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $142cf36e132bee65$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-found.title",
        "defaultMessage": "This board\u2019s custom field has been deleted."
    },
    description: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-found.description",
        "defaultMessage": "The custom field used to create this board has been deleted from your site by an administrator, and can\u2019t be restored."
    },
    createNewBoard: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-found.create-new-board",
        "defaultMessage": "Create new board"
    },
    imgAlt: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-found.img-alt",
        "defaultMessage": "Drawing of a magnifying glass with a cross mark"
    }
});

});


parcelRegister("1waMP", function(module, exports) {

$parcel$export(module.exports, "default", () => $00e38a48db5d2286$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $eCeGD = parcelRequire("eCeGD");

var $hTEpF = parcelRequire("hTEpF");

var $pa9q9 = parcelRequire("pa9q9");

var $kJXh6 = parcelRequire("kJXh6");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gZK1Z = parcelRequire("gZK1Z");

var $9TVV0 = parcelRequire("9TVV0");

var $6TZ9z = parcelRequire("6TZ9z");

var $2C9Uz = parcelRequire("2C9Uz");

var $dD7Gs = parcelRequire("dD7Gs");
const $00e38a48db5d2286$var$ProgramBoardCustomFieldNotInPlan = ({ planId: planId, customFieldId: customFieldId, customFieldName: customFieldName, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { showFlag: showFlag } = (0, $pa9q9.useFlagsService)();
    const customFieldIdRegex = /\d+/g;
    const customFieldIdMatch = customFieldId.match(customFieldIdRegex);
    const { isLoading: isRestoringField, error: error, isSuccessful: isSuccessful, restoreCustomField: restoreCustomField } = (0, $6TZ9z.useRestoreCustomField)({
        planId: planId,
        customFieldId: customFieldIdMatch && customFieldIdMatch.length > 0 ? customFieldIdMatch[0] : undefined
    });
    const { incrementId: incrementId } = (0, $9TVV0.usePlanPathParams)();
    const flagId = 'ip-board-custom-field-not-in-plan-error-flag';
    (0, $5uXOq.useEffect)(()=>{
        if (isSuccessful) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.location.reload();
    }, [
        isSuccessful
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (error) showFlag({
            id: flagId,
            description: formatMessage((0, $dD7Gs.default).errorFlagDescription),
            title: formatMessage((0, $dD7Gs.default).errorFlagTitle),
            isAutoDismiss: true,
            appearance: 'error',
            type: 'error',
            messageId: 'portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.show-flag.error',
            messageType: 'transactional'
        });
    }, [
        error,
        showFlag,
        formatMessage
    ]);
    const renderPrimaryAction = ()=>{
        if (isReadOnly) return null;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $eCeGD.default), {
            appearance: "primary",
            isDisabled: isRestoringField,
            onClick: ()=>{
                restoreCustomField();
            }
        }, formatMessage((0, $dD7Gs.default).restoreField));
    };
    const renderSecondaryAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Uz.default), {
            boardId: Number(incrementId),
            triggerLabel: formatMessage((0, $gZK1Z.default).backToBoards),
            isReadOnly: isReadOnly
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $kJXh6.default)),
        header: formatMessage((0, $dD7Gs.default).title, {
            fieldName: customFieldName
        }),
        description: formatMessage((0, $dD7Gs.default).description),
        maxImageWidth: 300,
        primaryAction: renderPrimaryAction(),
        secondaryAction: renderSecondaryAction()
    });
};
var $00e38a48db5d2286$export$2e2bcd8739ae039 = $00e38a48db5d2286$var$ProgramBoardCustomFieldNotInPlan;

});
parcelRegister("kJXh6", function(module, exports) {

$parcel$export(module.exports, "default", () => $1a2101bcb4b9e7b0$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = xhrhgx9ztn67hcmphgkp38fw
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/xhrhgx9ztn67hcmphgkp38fw

var $dCLgq = parcelRequire("dCLgq");

var $1EcPm = parcelRequire("1EcPm");
const $1a2101bcb4b9e7b0$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($1EcPm)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($1EcPm))
});
var $1a2101bcb4b9e7b0$export$2e2bcd8739ae039 = $1a2101bcb4b9e7b0$var$Illustration;
// for advanced use only
const $1a2101bcb4b9e7b0$export$a179c88182cb9d56 = [
    0,
    0,
    565,
    267
];

});
parcelRegister("1EcPm", function(module, exports) {
module.exports = new URL("integration.4d030b1d.svg", import.meta.url).toString();

});


parcelRegister("6TZ9z", function(module, exports) {

$parcel$export(module.exports, "useRestoreCustomField", () => $ed1ff562953eadc4$export$94fceaa5994f25d5);

var $5uXOq = parcelRequire("5uXOq");

var $jcw0u = parcelRequire("jcw0u");

var $eusud = parcelRequire("eusud");

var $4jAPy = parcelRequire("4jAPy");
const $ed1ff562953eadc4$export$94fceaa5994f25d5 = ({ planId: planId, customFieldId: customFieldId })=>{
    const [isLoading, setIsLoading] = (0, $5uXOq.useState)(false);
    const [error, setError] = (0, $5uXOq.useState)(undefined);
    const [isSuccessful, setIsSuccessful] = (0, $5uXOq.useState)(false);
    // eslint-disable-next-line @typescript-eslint/no-shadow
    const handleError = (error)=>{
        setIsSuccessful(false);
        setError(error);
        (0, $jcw0u.default)({
            meta: {
                id: (0, $4jAPy.SERVICES_ERROR_ID),
                packageName: (0, $4jAPy.PACKAGE_NAME),
                teamName: (0, $4jAPy.ERROR_REPORTING_TEAM)
            },
            attributes: {
                serviceName: 'useRestoreCustomField'
            },
            error: error,
            sendToPrivacyUnsafeSplunk: true
        });
    };
    const restoreCustomField = async ()=>{
        if (isLoading) return;
        if (!planId) {
            handleError(new Error('planId is empty in the restore custom field request'));
            return;
        }
        if (!customFieldId) {
            handleError(new Error('customFieldId is empty in the restore custom field request'));
            return;
        }
        setIsLoading(true);
        try {
            await (0, $eusud.performPostRequest)('/rest/jpo/1.0/customfield/add', {
                body: JSON.stringify({
                    planId: planId,
                    planCustomFields: [
                        {
                            customFieldId: customFieldId,
                            filteringAllowed: true
                        }
                    ]
                })
            });
            setIsSuccessful(true);
        // eslint-disable-next-line @typescript-eslint/no-shadow
        } catch (error) {
            handleError(new Error('Failed to restore custom field in Program board', {
                cause: error
            }));
        } finally{
            setIsLoading(false);
        }
    };
    return {
        restoreCustomField: restoreCustomField,
        isLoading: isLoading,
        isSuccessful: isSuccessful,
        error: error
    };
};

});

parcelRegister("dD7Gs", function(module, exports) {

$parcel$export(module.exports, "default", () => $8988c65e6011c124$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $8988c65e6011c124$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.title",
        "defaultMessage": "The custom field \"{fieldName}\" was removed from your plan."
    },
    description: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.description",
        "defaultMessage": "Without this field, your program board can't load."
    },
    restoreField: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.restore-field",
        "defaultMessage": "Restore this field"
    },
    imgAlt: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.img-alt",
        "defaultMessage": "Drawing of two people connecting plugs"
    },
    errorFlagTitle: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.error-flag-title",
        "defaultMessage": "Something went wrong"
    },
    errorFlagDescription: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.not-in-plan.error-flag-description",
        "defaultMessage": "There was an error when restoring custom field in program board. Please try refreshing the page."
    }
});

});


parcelRegister("7Vlm5", function(module, exports) {

$parcel$export(module.exports, "default", () => $641b25fcd25dadec$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $kjIEI = parcelRequire("kjIEI");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gZK1Z = parcelRequire("gZK1Z");

var $9TVV0 = parcelRequire("9TVV0");

var $2C9Uz = parcelRequire("2C9Uz");

var $5caHe = parcelRequire("5caHe");
const $641b25fcd25dadec$var$ProgramBoardCustomFieldOptionNotFound = ({ customFieldName: customFieldName, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { incrementId: incrementId } = (0, $9TVV0.usePlanPathParams)();
    const renderPrimaryAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Uz.default), {
            boardId: Number(incrementId),
            triggerLabel: formatMessage((0, $gZK1Z.default).backToBoards),
            isReadOnly: isReadOnly
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $kjIEI.default)),
        header: formatMessage((0, $5caHe.default).title, {
            fieldName: customFieldName
        }),
        description: // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
        /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, formatMessage((0, $5caHe.default).description, {
            fieldName: customFieldName
        })),
        primaryAction: renderPrimaryAction()
    });
};
var $641b25fcd25dadec$export$2e2bcd8739ae039 = $641b25fcd25dadec$var$ProgramBoardCustomFieldOptionNotFound;

});
parcelRegister("5caHe", function(module, exports) {

$parcel$export(module.exports, "default", () => $f03151f1cf451863$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $f03151f1cf451863$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.option-not-found.title",
        "defaultMessage": "The custom field \"{fieldName}\" has changed."
    },
    description: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.option-not-found.description",
        "defaultMessage": "The custom field \"{fieldName}\" was used to create your board, but it\u2019s since been edited. In order to use your board, your site administrator needs to update the \"{fieldName}\" field configuration."
    },
    imgAlt: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.option-not-found.img-alt",
        "defaultMessage": "Drawing of a magnifying glass with a cross mark"
    }
});

});


parcelRegister("9j19P", function(module, exports) {

$parcel$export(module.exports, "default", () => $bd9d70855f1855a5$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $hTEpF = parcelRequire("hTEpF");

var $kjIEI = parcelRequire("kjIEI");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $gZK1Z = parcelRequire("gZK1Z");

var $9TVV0 = parcelRequire("9TVV0");

var $2C9Uz = parcelRequire("2C9Uz");

var $ioiHo = parcelRequire("ioiHo");
const $bd9d70855f1855a5$var$ProgramBoardCustomFieldTrashed = ({ customFieldName: customFieldName, isReadOnly: isReadOnly })=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const { incrementId: incrementId } = (0, $9TVV0.usePlanPathParams)();
    const renderPrimaryAction = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $2C9Uz.default), {
            boardId: Number(incrementId),
            triggerLabel: formatMessage((0, $gZK1Z.default).backToBoards),
            isReadOnly: isReadOnly
        });
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $kjIEI.default)),
        header: formatMessage((0, $ioiHo.default).title, {
            fieldName: customFieldName
        }),
        description: formatMessage((0, $ioiHo.default).description, {
            // eslint-disable-next-line @atlaskit/design-system/use-primitives-text
            Paragraph: (content)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement("p", null, content),
            fieldName: customFieldName
        }),
        primaryAction: renderPrimaryAction()
    });
};
var $bd9d70855f1855a5$export$2e2bcd8739ae039 = $bd9d70855f1855a5$var$ProgramBoardCustomFieldTrashed;

});
parcelRegister("ioiHo", function(module, exports) {

$parcel$export(module.exports, "default", () => $9708ca471f23227a$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $9708ca471f23227a$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.trashed.title",
        "defaultMessage": "The custom field \"{fieldName}\" has been deleted from your site."
    },
    description: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.trashed.description",
        "defaultMessage": "<Paragraph>This board was configured using the \"{fieldName}\" custom field, which has been deleted from your site by an administrator.</Paragraph><Paragraph>Custom fields can be restored for up to 60 days after they were moved to the trash. Contact your site administrator to see if this is possible in order to restore your board. If the custom field was deleted more than 60 days ago, you\u2019ll need to make a new board.</Paragraph>"
    },
    imgAlt: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.custom-field.trashed.img-alt",
        "defaultMessage": "Drawing of a magnifying glass with a cross mark"
    }
});

});



parcelRegister("SDugp", function(module, exports) {

$parcel$export(module.exports, "default", () => $4f7f1d6838d59fea$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $1GGwS = parcelRequire("1GGwS");

var $hTEpF = parcelRequire("hTEpF");

var $bUmQV = parcelRequire("bUmQV");

var $4R6GH = parcelRequire("4R6GH");

var $fqCXD = parcelRequire("fqCXD");

var $iVgQf = parcelRequire("iVgQf");

var $koVbs = parcelRequire("koVbs");

var $5jgat = parcelRequire("5jgat");

var $c3WQb = parcelRequire("c3WQb");

var $2YP9W = parcelRequire("2YP9W");

var $bdYfL = parcelRequire("bdYfL");

var $9TVV0 = parcelRequire("9TVV0");

var $cGhMs = parcelRequire("cGhMs");
const $4f7f1d6838d59fea$var$ProgramBoard404 = ()=>{
    const { formatMessage: formatMessage } = (0, $koVbs.default)();
    const planId = (0, $bdYfL.getPlanId)();
    // If the user lands on the 404 page we should invalidate the cache of the last visited
    // program board and refetch a valid one from the server so they are routed to the appropriate
    // program board when next accessing /program route
    const { refresh: refetchLastViewedProgramBoardId } = (0, $2YP9W.useResource)((0, $c3WQb.advancedRoadmapsLastVisitedProgramBoardIdResource));
    const incrementsLink = (0, $9TVV0.useIncrementsLink)();
    (0, $5uXOq.useEffect)(()=>{
        refetchLastViewedProgramBoardId();
    }, [
        refetchLastViewedProgramBoardId
    ]);
    const renderPrimaryAction = ()=>{
        if ((0, $5jgat.isEmbedSmartLinkView)() && (0, $4R6GH.fg)('smart_links_for_plans')) return null;
        if (planId) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
            href: incrementsLink,
            appearance: "primary"
        }, formatMessage((0, $cGhMs.default).viewCurrentBoard));
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $1GGwS.default), {
            href: (0, $bdYfL.urls).managePortfolio,
            appearance: "primary"
        }, formatMessage((0, $cGhMs.default).viewAllPlans));
    };
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $bUmQV.default), {
        alignItems: "center",
        justifyContent: "center"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hTEpF.default), {
        renderImage: (0, $iVgQf.getAkEmptyStateRenderImageFn)((0, $fqCXD.default)),
        header: formatMessage((0, $cGhMs.default).title404),
        description: formatMessage((0, $cGhMs.default).description404),
        primaryAction: renderPrimaryAction()
    }));
};
var $4f7f1d6838d59fea$export$2e2bcd8739ae039 = $4f7f1d6838d59fea$var$ProgramBoard404;

});
parcelRegister("fqCXD", function(module, exports) {

$parcel$export(module.exports, "default", () => $e09649ccf4cf5eef$export$2e2bcd8739ae039);
// THIS FILE WAS AUTO-GENERATED. MODIFY WITH CAUTION. See README.md
// brandfolder asset id = xj97zncrmb3cj96ggxfn
// brandfolder url = https://brandfolder.com/atlassian-brand-creative-library/atlassian-public-asset-library/#!asset/xj97zncrmb3cj96ggxfn

var $dCLgq = parcelRequire("dCLgq");

var $eoGUj = parcelRequire("eoGUj");

var $lwH2d = parcelRequire("lwH2d");
const $e09649ccf4cf5eef$var$Illustration = (0, $dCLgq.createIllustration)({
    srcLight: (/*@__PURE__*/$parcel$interopDefault($lwH2d)),
    srcDark: (/*@__PURE__*/$parcel$interopDefault($eoGUj))
});
var $e09649ccf4cf5eef$export$2e2bcd8739ae039 = $e09649ccf4cf5eef$var$Illustration;
// for advanced use only
const $e09649ccf4cf5eef$export$a179c88182cb9d56 = [
    0,
    0,
    245,
    180
];

});
parcelRegister("eoGUj", function(module, exports) {
module.exports = new URL("map-darkmode.65c31cec.svg", import.meta.url).toString();

});

parcelRegister("lwH2d", function(module, exports) {
module.exports = new URL("map.d526d3ce.svg", import.meta.url).toString();

});


parcelRegister("5jgat", function(module, exports) {

$parcel$export(module.exports, "isEmbedSmartLinkView", () => $cdc5cbb71bc67330$export$3ede2a0e58c65203);

var $gKZoD = parcelRequire("gKZoD");
const $cdc5cbb71bc67330$export$3ede2a0e58c65203 = ()=>{
    (0, $gKZoD.di)(window);
    return window && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.includes('plans') && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.includes('scenarios') && // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    window?.location.pathname.includes('/embed');
};

});

parcelRegister("c3WQb", function(module, exports) {

$parcel$export(module.exports, "advancedRoadmapsReduxStoreStateResource", () => $20c66b93015d9910$export$6ca262338f199e4b);
$parcel$export(module.exports, "advancedRoadmapsScenarioIdResource", () => $20c66b93015d9910$export$aec847b4ce72891);
$parcel$export(module.exports, "advancedRoadmapsPlanPageInitialChecksResource", () => $20c66b93015d9910$export$7431e46c7ad56c3d);
$parcel$export(module.exports, "advancedRoadmapsPlanReportPageInitialChecksResource", () => $20c66b93015d9910$export$bf0c5395c73cc255);
$parcel$export(module.exports, "advancedRoadmapsLastVisitedProgramBoardIdResource", () => $20c66b93015d9910$export$f5b159e1fb19e04e);

var $hGgHi = parcelRequire("hGgHi");

var $eusud = parcelRequire("eusud");

var $2M1hQ = parcelRequire("2M1hQ");

const $20c66b93015d9910$export$6ca262338f199e4b = (0, $2M1hQ.createResource)({
    type: 'ADVANCED_ROADMAPS_REDUX_STORE_STATE',
    getKey: ({ match: match })=>{
        const { params: params, query: query } = match;
        if (params.planId != null && params.scenarioId != null) return `${params.planId}:${params.scenarioId}`;
        if (params.reportId != null) return params.reportId;
        if (query.r != null) return query.r;
        throw new Error('Unable to get resource key for ADVANCED_ROADMAPS_REDUX_STORE_STATE.');
    },
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    getData: async ()=>undefined,
    isBrowserOnly: true,
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$aec847b4ce72891 = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$a0893d695ebee984),
    getKey: ({ query: query })=>`scenarioId_${query.id}`,
    getData: async ({ query: query })=>{
        const planId = query.id;
        const { id: id } = await (0, $eusud.performGetRequest)(`/rest/jpo/1.0/scenarios/${planId}`);
        return {
            scenarioId: id
        };
    },
    maxAge: 0
});
const $20c66b93015d9910$export$7431e46c7ad56c3d = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$68390102872336b6),
    getKey: ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        return `planPageInitialChecks_${planId != null ? planId : ''}_${scenarioId != null ? scenarioId : ''}`;
    },
    getData: async ({ match: match })=>{
        const { planId: planId, scenarioId: scenarioId } = match.params;
        // @ts-expect-error - TS2367 - This condition will always return 'false' since the types '"null"' and '"undefined"' have no overlap.
        if (planId == null || planId === 'null' && planId === 'undefined' && planId === '') throw new Error('Plan cannot be loaded without a planId');
        let url = `/rest/jpo/1.0/plans/${planId}/checks`;
        if (scenarioId != null && scenarioId !== 'null' && scenarioId !== 'undefined' && scenarioId !== '') url = `${url}?sid=${scenarioId}`;
        const response = await (0, $eusud.performGetRequest)(url);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$bf0c5395c73cc255 = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$a00e869cafd63140),
    getKey: ({ match: match })=>`planReportPageInitialChecks_${match.params.reportId == null ? '' : match.params.reportId}`,
    getData: async ({ match: match })=>{
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const initialPlanChecksPromise = window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        delete window.__ARJ_INITIAL_PLAN_REPORT_CHECKS_PROMISE__;
        if (initialPlanChecksPromise) {
            const response = await initialPlanChecksPromise;
            return response;
        }
        const { reportId: reportId } = match.params;
        const response = await (0, $eusud.performGetRequest)(`/rest/jpo/1.0/reportinfo/generic/${reportId == null ? '' : reportId}/checks`);
        return response;
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});
const $20c66b93015d9910$export$f5b159e1fb19e04e = (0, $2M1hQ.createResource)({
    type: (0, $025c2a539475c8ec$export$179a0d35e95a4d61),
    getKey: ({ query: query, match: match })=>`lastVisitedProgramBoardId_${query.id}_${match.params.planId}_${match.params.scenarioId}`,
    getData: async ({ match: match })=>{
        // Sometimes currentPlanId isn't yet ready - we retry a few times to check if it has loaded in before making the request
        const RETRIES = 3;
        const DELAY = 500;
        const attemptFetch = async (remainingRetries)=>{
            const currentPlanId = match.params.planId;
            if (!(0, (/*@__PURE__*/$parcel$interopDefault($hGgHi)))(currentPlanId)) {
                const defaultBoardIdResponse = await (0, $eusud.performGetRequest)(`/rest/jpo/2.0/plans/${currentPlanId}/increments/default`);
                if (defaultBoardIdResponse === null) return {
                    boardId: null
                };
                const { id: id } = defaultBoardIdResponse;
                return {
                    boardId: id
                };
            }
            if (remainingRetries > 0) {
                await new Promise((resolve)=>setTimeout(resolve, DELAY));
                return attemptFetch(remainingRetries - 1);
            }
            throw new Error('Attempted to get the last visited program board of a plan without a plan id after multiple retries.');
        };
        return attemptFetch(RETRIES);
    },
    // Invalidation is implemented here: src/packages/platform/ui/layouts/jira-plan-layout/src/ui/resources-invalidate/index.tsx
    maxAge: Infinity
});

});
const $025c2a539475c8ec$export$68390102872336b6 = 'ADVANCED_ROADMAPS_PLAN_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a00e869cafd63140 = 'ADVANCED_ROADMAPS_REPORT_INITIAL_CHECKS';
const $025c2a539475c8ec$export$a0893d695ebee984 = 'ADVANCED_ROADMAPS_SCENARIO_ID';
const $025c2a539475c8ec$export$179a0d35e95a4d61 = 'ADVANCED_ROADMAPS_LAST_VISITED_PROGRAM_BOARD_ID';


parcelRegister("cGhMs", function(module, exports) {

$parcel$export(module.exports, "default", () => $7622546e3a8a37dc$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $7622546e3a8a37dc$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    title404: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.empty-404.title-404",
        "defaultMessage": "Where\u2019d it go?"
    },
    description404: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.empty-404.description-404",
        "defaultMessage": "We couldn\u2019t find that program board. It might have been deleted by its owner or the URL might be wrong."
    },
    viewAllPlans: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.empty-404.view-all-plans",
        "defaultMessage": "View all plans"
    },
    viewCurrentBoard: {
        "id": "portfolio-3-plan-increment-common.ui.error-screens.empty-404.view-current-board",
        "defaultMessage": "View current board"
    }
});

});


parcelRegister("ffPNU", function(module, exports) {

$parcel$export(module.exports, "ProgramBoardSkeleton", () => $9119c107c4a90142$export$c41c6e2b3c2381b3);
/* ProgramBoardSkeleton.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $bwpsq = parcelRequire("bwpsq");

var $5uXOq = parcelRequire("5uXOq");

var $hCy6k = parcelRequire("hCy6k");

var $9zaht = parcelRequire("9zaht");
const $9119c107c4a90142$var$customCssStyles = null;
const $9119c107c4a90142$export$c41c6e2b3c2381b3 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $hCy6k.AppSkeletonImage), {
        src: (0, (/*@__PURE__*/$parcel$interopDefault($9zaht))),
        className: (0, $bwpsq.default)([
            "_2zz1idpf"
        ])
    });

});
parcelRegister("9zaht", function(module, exports) {
module.exports = new URL("program-board-app-skeleton.tpl.74f398b1.svg", import.meta.url).toString();

});



parcelRegister("94kuB", function(module, exports) {

$parcel$export(module.exports, "replaceAssignee", () => $00d8d365641a2e6b$export$4219890613423590);

var $iEIQF = parcelRequire("iEIQF");
var $eK6AG = parcelRequire("eK6AG");
var $bzbto = parcelRequire("bzbto");
var $l0V05 = parcelRequire("l0V05");
var $7CDw0 = parcelRequire("7CDw0");
const $00d8d365641a2e6b$export$4219890613423590 = (jql, assignee)=>{
    const ast = new (0, $eK6AG.JastBuilder)().build(jql);
    let clause;
    (0, $7CDw0.walkAST)({
        enterTerminalClause (terminalClause) {
            if (terminalClause.field.value.toLowerCase() === 'assignee') clause = terminalClause;
        }
    }, ast);
    if (assignee) {
        const newClause = (0, $iEIQF.default).terminalClause((0, $iEIQF.default).field('assignee'), (0, $iEIQF.default).operator((0, $bzbto.OPERATOR_EQUALS)), assignee === 'unassigned' ? (0, $iEIQF.default).valueOperand((0, $49b29ef7baa2a152$export$1c46dca02aac24dd)) : (0, $iEIQF.default).valueOperand(assignee));
        if (clause) clause.replace(newClause);
        else ast.query?.appendClause(newClause, (0, $3cef51f82b2cbe1d$export$6d6d48d210d3ca97));
    } else if (clause) clause.remove();
    return (0, $l0V05.print)(ast, {
        operatorCase: 'upper'
    });
};

});

parcelRegister("bxz0l", function(module, exports) {

$parcel$export(module.exports, "ForceRecalculateSubscribers", () => $d2a57e612cbb128d$export$7e571696ac12cb6f);

var $5uXOq = parcelRequire("5uXOq");

var $687vG = parcelRequire("687vG");

var $67sX6 = parcelRequire("67sX6");

var $45cXl = parcelRequire("45cXl");

var $4jZ56 = parcelRequire("4jZ56");

var $5mTgl = parcelRequire("5mTgl");
const $d2a57e612cbb128d$export$7e571696ac12cb6f = /*#__PURE__*/ (0, $5uXOq.memo)(()=>{
    const filteredCards = (0, $67sX6.useBoardSelector)((0, $5mTgl.workFilteredIssuesSelector));
    const swimlaneMode = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneMode));
    const collapsedSwimlaneIds = (0, $67sX6.useBoardSelector)((0, $4jZ56.getCollapsedSwimlanes));
    (0, $5uXOq.useLayoutEffect)(()=>{
        (0, $687vG.runRecalculateSubscribers)();
    }, [
        filteredCards,
        swimlaneMode,
        collapsedSwimlaneIds
    ]);
    return null;
});

});
parcelRegister("687vG", function(module, exports) {

$parcel$export(module.exports, "runRecalculateSubscribers", () => $c63364c275b5d8f7$export$c385874db128c328);
$parcel$export(module.exports, "useElementOffset", () => $c63364c275b5d8f7$export$35f58fcda6094144);

var $5uXOq = parcelRequire("5uXOq");

var $7nsd3 = parcelRequire("7nsd3");

var $lFKmC = parcelRequire("lFKmC");

var $iASWI = parcelRequire("iASWI");

var $9Ik53 = parcelRequire("9Ik53");
const $c63364c275b5d8f7$var$MINIMUM_OFFSET_DIFF = 0.05;
const $c63364c275b5d8f7$export$658605f405ffebd5 = new Set();
const $c63364c275b5d8f7$export$c385874db128c328 = ()=>{
    const recalculateSubscribersArr = Array.from($c63364c275b5d8f7$export$658605f405ffebd5);
    const changes = recalculateSubscribersArr.map((subscriber)=>({
            newOffsetTop: subscriber.measureOffsetTop(),
            subscriber: subscriber
        })).filter(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>Math.abs((subscriber.offsetTopRef.current ?? 0) - newOffsetTop) > $c63364c275b5d8f7$var$MINIMUM_OFFSET_DIFF);
    if (!changes.length) return 0;
    (0, $7nsd3.unstable_batchedUpdates)(()=>{
        changes.forEach(({ subscriber: subscriber, newOffsetTop: newOffsetTop })=>{
            subscriber.onChange(newOffsetTop);
        });
    });
    return changes.length;
};
// Debounced version of the call used because during DND, the ResizeObserver can
// crash due to being triggered too much
const $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers = (0, (/*@__PURE__*/$parcel$interopDefault($lFKmC)))($c63364c275b5d8f7$export$c385874db128c328, 50);
let $c63364c275b5d8f7$var$resizeObserver = null;
if (typeof ResizeObserver !== 'undefined') $c63364c275b5d8f7$var$resizeObserver = new ResizeObserver($c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers);
let $c63364c275b5d8f7$var$intersectionObserver = null;
if (typeof IntersectionObserver !== 'undefined') $c63364c275b5d8f7$var$intersectionObserver = new IntersectionObserver($c63364c275b5d8f7$export$c385874db128c328, {
    // Will fire every 1/5000 size visibility change.
    // A list with more than 5000 rows will fail to detect single row
    // changes.
    // A list with 5000 rows will only detect 1 row shifts at a time.
    threshold: (0, (/*@__PURE__*/$parcel$interopDefault($iASWI)))(5000).map((i, _, arr)=>i / arr.length)
});
function $c63364c275b5d8f7$export$99c4e73123d23bda({ initialOffset: initialOffset, ref: ref }) {
    const [offsetTop, setOffsetTop] = (0, $5uXOq.useState)(initialOffset);
    const previousOffsetTopRef = (0, $5uXOq.useRef)(initialOffset);
    const { scrollElement: scrollElement } = (0, $9Ik53.useScrollState)();
    (0, $5uXOq.useEffect)(()=>{
        const el = ref.current;
        if (!el) throw new Error('Invariant failed, observed element is null on mount');
        const onChange = (size)=>{
            setOffsetTop(size);
            previousOffsetTopRef.current = size;
        };
        const measureOffsetTop = ()=>{
            if (!el || !scrollElement) return previousOffsetTopRef.current;
            // scrollElement defaults to Window.
            // This default value is normally only seen in Storybook.
            if (scrollElement instanceof Window || // FIXME JIV-14148 - unclear behavior in Storybook mount strict - Window is not Window
            !scrollElement.getBoundingClientRect) return 0;
            return el.getBoundingClientRect().top - scrollElement.getBoundingClientRect().top + scrollElement.scrollTop;
        };
        onChange(measureOffsetTop());
        const recalculateGroup = {
            measureOffsetTop: measureOffsetTop,
            onChange: onChange,
            offsetTop: previousOffsetTopRef.current,
            offsetTopRef: previousOffsetTopRef
        };
        $c63364c275b5d8f7$export$658605f405ffebd5.add(recalculateGroup);
        $c63364c275b5d8f7$var$resizeObserver?.observe(el);
        $c63364c275b5d8f7$var$intersectionObserver?.observe(el);
        const onResize = ()=>{
            $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers();
        };
        if ($c63364c275b5d8f7$export$658605f405ffebd5.size === 1) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.addEventListener('resize', onResize);
        return ()=>{
            $c63364c275b5d8f7$export$658605f405ffebd5.delete(recalculateGroup);
            $c63364c275b5d8f7$var$resizeObserver?.unobserve(el);
            $c63364c275b5d8f7$var$intersectionObserver?.unobserve(el);
            if ($c63364c275b5d8f7$export$658605f405ffebd5.size === 0) // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
            window.removeEventListener('resize', onResize);
            // Fire once when we clean this up since when we unmount an element we also
            // want to trigger the callback (e.g. removing a column or cardlist)
            $c63364c275b5d8f7$var$debouncedRunRecalculateSubscribers();
        };
    }, [
        ref,
        scrollElement
    ]);
    return offsetTop;
}
function $c63364c275b5d8f7$export$35f58fcda6094144({ initialOffset: initialOffset }) {
    const ref = (0, $5uXOq.useRef)(null);
    const offsetTop = $c63364c275b5d8f7$export$99c4e73123d23bda({
        initialOffset: initialOffset,
        ref: ref
    });
    return {
        ref: ref,
        offsetTop: offsetTop
    };
}

});


parcelRegister("8R2g1", function(module, exports) {

$parcel$export(module.exports, "BoardSlaTracker", () => $26d2bc915d9cd7ab$export$149af6dcca3f86a2);
$parcel$export(module.exports, "CmpBoardSlaTracker", () => $26d2bc915d9cd7ab$export$66ca48f8a9bbca65);

var $5uXOq = parcelRequire("5uXOq");

var $f7Y15 = parcelRequire("f7Y15");

var $01j5n = parcelRequire("01j5n");

var $2YP9W = parcelRequire("2YP9W");

const $26d2bc915d9cd7ab$export$149af6dcca3f86a2 = (props)=>{
    if (!props.boardData) return null;
    const { boardData: { error: boardDataError, loading: boardDataLoading }, location: location } = props;
    // do nothing until all endpoints are loaded
    if (boardDataLoading === true) return null;
    if (boardDataError) // eslint-disable-next-line @typescript-eslint/consistent-type-assertions, @typescript-eslint/no-explicit-any
    return (0, $01j5n.default)(boardDataError, location ?? (0, $dcbb2bce513725b3$export$fa0622448a6f265));
    // return null when no errors
    return null;
};
const $26d2bc915d9cd7ab$export$66ca48f8a9bbca65 = ()=>{
    const boardData = (0, $2YP9W.useResource)((0, $f7Y15.uifBoardResource));
    const hasFired = (0, $5uXOq.useRef)(false);
    if (hasFired.current || !boardData || !boardData.error || boardData.data || boardData.loading) return null;
    hasFired.current = true;
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($26d2bc915d9cd7ab$export$149af6dcca3f86a2, {
        boardData: boardData,
        location: (0, $dcbb2bce513725b3$export$3ccc579abb61693b)
    });
};

});

parcelRegister("ewLux", function(module, exports) {

$parcel$export(module.exports, "default", () => $53835cd30dd39058$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $3f2cs = parcelRequire("3f2cs");

var $dGvGJ = parcelRequire("dGvGJ");

var $bC2fB = parcelRequire("bC2fB");

var $ijnUs = parcelRequire("ijnUs");

var $2f454 = parcelRequire("2f454");

var $dW1HX = parcelRequire("dW1HX");

var $evkwq = parcelRequire("evkwq");

var $2ON1s = parcelRequire("2ON1s");

var $67Z81 = parcelRequire("67Z81");

var $5mTgl = parcelRequire("5mTgl");

var $ahgeK = parcelRequire("ahgeK");
const $53835cd30dd39058$var$getBoardCardCountMemoized = ()=>(0, $dGvGJ.createSelector)((0, $ijnUs.getBoardCardCount), (res)=>res);
const $53835cd30dd39058$var$mapStateToPropsFactory = ()=>{
    const getBoardCardCountInstance = $53835cd30dd39058$var$getBoardCardCountMemoized();
    return (state)=>({
            boardSessionId: (0, $67Z81.sessionIdSelector)(state),
            boardCardCount: getBoardCardCountInstance(state),
            estimationStatistic: (0, $5mTgl.getEstimationStatistic)(state),
            rapidViewMap: (0, $5mTgl.getFilteredIssueKeysAsRapidViewMap)(state),
            isCMPBoard: (0, $67Z81.getIsCMPBoard)(state)
        });
};
const $53835cd30dd39058$var$mapDispatchToProps = (dispatch)=>(0, $3f2cs.bindActionCreators)({
        onClose: (0, $dW1HX.closeIssueModal),
        onChange: (0, $evkwq.issueBentoUpdate),
        onDelete: (0, $2f454.cardDeleteOptimistic),
        onUpdateRequest: (0, $evkwq.issueUpdateRequest),
        onSwitchToSidebarAction: (0, $2ON1s.closeInsightsPanel),
        onResetExternalAction: (0, $dW1HX.resetExternalAction),
        onCloseViewSettingsPanel: (0, $2ON1s.closeViewSettingsPanel)
    }, dispatch);
var $53835cd30dd39058$export$2e2bcd8739ae039 = (0, $bC2fB.connect)($53835cd30dd39058$var$mapStateToPropsFactory, $53835cd30dd39058$var$mapDispatchToProps)(// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
(0, $ahgeK.default));

});
parcelRegister("ahgeK", function(module, exports) {

$parcel$export(module.exports, "default", () => $4d297a00179472ab$export$2e2bcd8739ae039);
// eslint-disable-next-line jira/restricted/react-component-props

var $5uXOq = parcelRequire("5uXOq");

var $daJ0i = parcelRequire("daJ0i");



var $7wqBZ = parcelRequire("7wqBZ");

var $hUXfN = parcelRequire("hUXfN");

var $x9xyg = parcelRequire("x9xyg");

var $2gCtH = parcelRequire("2gCtH");

var $fOGZN = parcelRequire("fOGZN");

var $gjEtj = parcelRequire("gjEtj");


var $g5X3G = parcelRequire("g5X3G");

var $5knXz = parcelRequire("5knXz");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $kxZPA = parcelRequire("kxZPA");

var $iUagi = parcelRequire("iUagi");


var $bWjJb = parcelRequire("bWjJb");


var $dWjj9 = parcelRequire("dWjj9");

// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
const $4d297a00179472ab$var$IssueModal = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("4wE4G")), {
    ssr: false,
    moduleId: "./src/packages/issue/issue-view/src/views/issue-details/modal-issue-app.tsx"
});
$4d297a00179472ab$var$IssueModal.preload();
const $4d297a00179472ab$var$IssueWrapper = (props)=>{
    const { onChange: onChange, onClose: onClose, onDelete: onDelete, onUpdateRequest: onUpdateRequest, rapidViewId: rapidViewId, estimationStatistic: estimationStatistic, externalAction: externalAction, boardSessionId: boardSessionId, boardCardCount: boardCardCount, onSwitchToSidebarAction: onSwitchToSidebarAction, onCloseViewSettingsPanel: onCloseViewSettingsPanel, onResetExternalAction: onResetExternalAction, rapidViewMap: rapidViewMap, isCMPBoard: isCMPBoard } = props;
    const configWithAppKey = (0, $fOGZN.simpleSoftwareBoardConfiguration)();
    const { applicationKey: applicationKey, ...configWithoutAppKey } = configWithAppKey;
    const [issueKey, setIssueKey] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const [, { setDetailViewAsSidebar: setDetailViewAsSidebar }] = (0, $2gCtH.useIssueContextActions)();
    const { showEnforcementIfPendingToShow: showEnforcementIfPendingToShow } = (0, $5knXz.useStorageEnforcement)();
    const onIssueKeyChange = (0, $5uXOq.useCallback)(({ toIssueKey: nextIssueKey })=>setIssueKey(nextIssueKey), [
        setIssueKey
    ]);
    const onIssueDelete = (0, $5uXOq.useCallback)(({ issueKey: key, issueId: id })=>{
        const issueId = Number(id);
        onDelete(issueId);
        if (issueId && issueKey !== key) onUpdateRequest([
            issueId
        ], (0, $f32ae13c2b9742f4$export$306c754c61954570));
    }, [
        issueKey,
        onDelete,
        onUpdateRequest
    ]);
    // If there's an external action to be fired, dispatch it as soon as possible
    const onSetDispatchExternalActionRef = (0, $5uXOq.useCallback)((dispatchExternalActionRef)=>{
        if (dispatchExternalActionRef && externalAction) // If a keyboard shortcut was the trigger for this external action,
        // the key may propagate into a field that is focused in the
        // issue view. setTimeout prevents this.
        setTimeout(()=>{
            dispatchExternalActionRef(externalAction);
            // remove optional checking when cleaning up DEE-930
            onResetExternalAction && onResetExternalAction();
        });
    }, [
        externalAction,
        onResetExternalAction
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (!issueKey) return;
        (0, $x9xyg.setMark)((0, $2c6627b73a80e690$export$c1802e9feef87e19));
        (0, $bWjJb.setIssueViewOpenFeedbackMark)();
    }, [
        issueKey
    ]);
    if (!issueKey) return null;
    const onSwitchToSidebar = (willSave)=>{
        setDetailViewAsSidebar(willSave);
        onSwitchToSidebarAction();
        (0, $iUagi.isViewSettingAsPanelExpEnabledWithNoExposure)() && onCloseViewSettingsPanel();
    };
    const onCloseWithStorageLimitEnforcement = ()=>{
        onClose();
        showEnforcementIfPendingToShow();
    };
    const issueModal = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($4d297a00179472ab$var$IssueModal, {
        ...configWithoutAppKey,
        analyticsSource: (0, $fcf97b7a09088940$export$cd16d39c55c569d0),
        issueKey: (0, $g5X3G.toIssueKey)(issueKey),
        onClose: onCloseWithStorageLimitEnforcement,
        onChange: onChange,
        onIssueDeleteSuccess: onIssueDelete,
        rapidViewId: rapidViewId,
        rapidViewMap: rapidViewMap,
        boardType: (0, $976eff6d67d3515b$export$9a958daafd9a03ed),
        boardId: rapidViewId,
        viewModeOptions: {
            viewMode: 'MODAL',
            viewModeSwitchEnabled: true,
            onSwitchToSidebar: onSwitchToSidebar
        },
        metrics: {
            onReadyForUser: ()=>{
                (0, $7wqBZ.getLongTasksMetrics)('bento').stop((0, $hUXfN.bentoReporter), {
                    type: 'modal',
                    boardSessionId: boardSessionId
                });
            },
            onInteractive: ()=>{
                (0, $bWjJb.setIssueViewOpenFinishMark)(false, boardCardCount, isCMPBoard);
            }
        },
        onIssueKeyChange: onIssueKeyChange,
        history: null,
        dispatchExternalActionRef: onSetDispatchExternalActionRef,
        estimationStatistic: estimationStatistic
    });
    const issueViewApp = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $dWjj9.PreIssueViewMountFeedbackMark), {
        issueKey: issueKey
    }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gjEtj.ModalBoundary), {
        packageName: "software-board",
        id: "board-issue-modal"
    }, issueModal));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $daJ0i.default), {
        data: {
            source: `boardIssueView${(0, $4d5e0871c06cee03$export$f636b5b56f1d624a)}`,
            attributes: {
                viewMode: 'MODAL'
            }
        }
    }, issueViewApp);
};
var $4d297a00179472ab$export$2e2bcd8739ae039 = $4d297a00179472ab$var$IssueWrapper;

});
// Backend types
const $976eff6d67d3515b$export$9a958daafd9a03ed = 'agility-board';
// suppressed to allow migration to typescript-eslint v8 - this is a new error reported with v8 and is only used as a type
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const $976eff6d67d3515b$var$CORE_BOARD = 'core-board';
const $976eff6d67d3515b$export$b4e9cdb19cfa0abb = 'kanban';
const $976eff6d67d3515b$export$4498412e32a31fb6 = 'scrum';

const $2c6627b73a80e690$export$c1802e9feef87e19 = 'SOFTWARE_ISSUE_SKELETON_MOUNTED_MARK';

parcelRegister("4wE4G", function(module, exports) {

let $34b93c87a1499f7b$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $34b93c87a1499f7b$var$load("76n7a"),
    $34b93c87a1499f7b$var$load("l253H"),
    $34b93c87a1499f7b$var$load("ffQaD"),
    $34b93c87a1499f7b$var$load("kvRbA"),
    $34b93c87a1499f7b$var$load("kNFvF"),
    $34b93c87a1499f7b$var$load("bWP0X")
]).then(()=>parcelRequire('2555l'));

});




parcelRegister("ctiKF", function(module, exports) {

let $9146bd3081c3a493$var$load = (parcelRequire("28QjX"))(4);

module.exports = Promise.all([
    (parcelRequire("avM1e"))('lazy_load_issue_delete_modal', function() {
        return Promise.all([
            $9146bd3081c3a493$var$load("cUIkh")
        ]);
    }, function() {
        return Promise.all([
            $9146bd3081c3a493$var$load("8x7hL")
        ]);
    }),
    $9146bd3081c3a493$var$load("ciUHS")
]).then(()=>parcelRequire('8DdSU'));

});


parcelRegister("iyXvX", function(module, exports) {

$parcel$export(module.exports, "default", () => $b61a31527b0cdb78$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $67sX6 = parcelRequire("67sX6");

var $9OPlz = parcelRequire("9OPlz");

var $hBAEg = parcelRequire("hBAEg");
const $b61a31527b0cdb78$var$SelectedIssuesSync = ()=>{
    const selectedIssueKeys = (0, $67sX6.useBoardSelector)((0, $9OPlz.selectedIssueKeysSelector));
    const selectedIssueIds = (0, $67sX6.useBoardSelector)((0, $9OPlz.selectedIssueIdsSelector));
    const [, { setSelectedIssueKeys: setSelectedIssueKeys, setSelectedIssueIds: setSelectedIssueIds }] = (0, $hBAEg.default)();
    (0, $5uXOq.useEffect)(()=>{
        setSelectedIssueKeys(selectedIssueKeys);
        setSelectedIssueIds(selectedIssueIds);
    }, [
        selectedIssueKeys,
        setSelectedIssueKeys,
        selectedIssueIds,
        setSelectedIssueIds
    ]);
    return null;
};
var $b61a31527b0cdb78$export$2e2bcd8739ae039 = $b61a31527b0cdb78$var$SelectedIssuesSync;

});
parcelRegister("hBAEg", function(module, exports) {

$parcel$export(module.exports, "default", () => $1f303d334ccc7fed$export$2e2bcd8739ae039);

var $3sQ5x = parcelRequire("3sQ5x");
var $iXqE5 = parcelRequire("iXqE5");
const $1f303d334ccc7fed$var$initialState = {
    selectedIssueKeys: [],
    selectedIssueIds: []
};
const $1f303d334ccc7fed$var$actions = {
    setSelectedIssueKeys: (issueKeys)=>({ setState: setState })=>{
            setState({
                selectedIssueKeys: issueKeys
            });
        },
    setSelectedIssueIds: (issueIds)=>({ setState: setState })=>{
            setState({
                selectedIssueIds: issueIds
            });
        }
};
const $1f303d334ccc7fed$var$Store = (0, $iXqE5.createStore)({
    initialState: $1f303d334ccc7fed$var$initialState,
    actions: $1f303d334ccc7fed$var$actions,
    name: 'selected-issues-sync'
});
const $1f303d334ccc7fed$var$useSelectedIssuesSync = (0, $3sQ5x.createHook)($1f303d334ccc7fed$var$Store);
var $1f303d334ccc7fed$export$2e2bcd8739ae039 = $1f303d334ccc7fed$var$useSelectedIssuesSync;

});


parcelRegister("buSp0", function(module, exports) {

$parcel$export(module.exports, "SwimlaneModeFromUrl", () => $7f8ae55f4a029bda$export$4f8eefe54ea059b8);

var $5uXOq = parcelRequire("5uXOq");

var $fr1K2 = parcelRequire("fr1K2");

var $doZTA = parcelRequire("doZTA");

var $cjoN4 = parcelRequire("cjoN4");

var $k50Aq = parcelRequire("k50Aq");

var $67sX6 = parcelRequire("67sX6");

var $45cXl = parcelRequire("45cXl");
const $7f8ae55f4a029bda$export$176805c664ae8df3 = 'groupBy';
const $7f8ae55f4a029bda$export$4f8eefe54ea059b8 = ()=>{
    const [{ location: location, query: query }, { replace: replace }] = (0, $doZTA.useRouter)();
    const dispatch = (0, $67sX6.useBoardDispatch)();
    const availableSwimlanes = (0, $67sX6.useBoardSelector)((0, $45cXl.getSwimlaneModes));
    (0, $5uXOq.useEffect)(()=>{
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const queryValue = query[$7f8ae55f4a029bda$export$176805c664ae8df3];
        if (!queryValue) return;
        const swimlaneModeId = (0, $cjoN4.swimlaneStrategiesToMode)[queryValue] || null;
        if (availableSwimlanes.find((swimlane)=>swimlane.id === swimlaneModeId)) dispatch((0, $k50Aq.swimlaneModeChangeRequest)(swimlaneModeId));
        // Remove groupBy from search params
        replace({
            ...location,
            search: new URLSearchParams((0, (/*@__PURE__*/$parcel$interopDefault($fr1K2)))(query, $7f8ae55f4a029bda$export$176805c664ae8df3)).toString()
        });
    }, [
        availableSwimlanes,
        dispatch,
        location,
        query,
        replace
    ]);
    return null;
};

});

parcelRegister("4zzhM", function(module, exports) {

$parcel$export(module.exports, "default", () => $ead5ebe25ede66e1$export$2e2bcd8739ae039);

var $bC2fB = parcelRequire("bC2fB");

var $dW1HX = parcelRequire("dW1HX");

var $gNhLO = parcelRequire("gNhLO");
const $ead5ebe25ede66e1$var$mapDispatchToProps = {
    onOpenIssueModal: (0, $dW1HX.openIssueModal),
    onCloseIssueModal: (0, $dW1HX.closeIssueModal)
};
var $ead5ebe25ede66e1$export$2e2bcd8739ae039 = (0, $bC2fB.connect)(null, $ead5ebe25ede66e1$var$mapDispatchToProps)((0, $gNhLO.default));

});
parcelRegister("gNhLO", function(module, exports) {

$parcel$export(module.exports, "default", () => $2c5e468b97351ce9$export$2e2bcd8739ae039);

var $5uXOq = parcelRequire("5uXOq");

var $8Rkzz = parcelRequire("8Rkzz");

var $jQ7vZ = parcelRequire("jQ7vZ");

var $67sX6 = parcelRequire("67sX6");

var $fqLDH = parcelRequire("fqLDH");
const $2c5e468b97351ce9$export$6cfa8b91c03902d6 = ({ onOpenIssueModal: onOpenIssueModal = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))), onCloseIssueModal: onCloseIssueModal = (0, (/*@__PURE__*/$parcel$interopDefault($8Rkzz))) })=>{
    const isInitialMount = (0, $5uXOq.useRef)(true);
    const [selectedIssue] = (0, $jQ7vZ.useQueryParam)('selectedIssue');
    const issueModal = (0, $67sX6.useBoardSelector)((0, $fqLDH.getIssueModal));
    const issueModalRef = (0, $5uXOq.useRef)(issueModal);
    (0, $5uXOq.useEffect)(()=>{
        if (issueModalRef.current !== issueModal) issueModalRef.current = issueModal;
    }, [
        issueModal
    ]);
    (0, $5uXOq.useEffect)(()=>{
        if (isInitialMount.current) isInitialMount.current = false;
        else if (selectedIssue) {
            if (issueModalRef?.current?.selectedIssueKey) onOpenIssueModal(selectedIssue, issueModalRef?.current?.externalAction);
            else onOpenIssueModal(selectedIssue);
        } else onCloseIssueModal(null);
    }, [
        selectedIssue,
        onOpenIssueModal,
        onCloseIssueModal
    ]);
    return null;
};
var $2c5e468b97351ce9$export$2e2bcd8739ae039 = /*#__PURE__*/ (0, $5uXOq.memo)($2c5e468b97351ce9$export$6cfa8b91c03902d6);

});




parcelRegister("8XaG5", function(module, exports) {

$parcel$export(module.exports, "NoSoftwareLicense", () => $a7a9d469bc380dc9$export$97e3c9c160f8ea89);

var $5uXOq = parcelRequire("5uXOq");

var $g0Gtc = parcelRequire("g0Gtc");

var $d31Su = parcelRequire("d31Su");
const $a7a9d469bc380dc9$export$97e3c9c160f8ea89 = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $g0Gtc.ExperienceSuccessTracker), {
        location: "ng-board-context-query"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $d31Su.AsyncNoSoftwareLicense), null));

});
parcelRegister("d31Su", function(module, exports) {

$parcel$export(module.exports, "AsyncNoSoftwareLicense", () => $dcd2c1aef082694d$export$52d8964299339cae);

var $5uXOq = parcelRequire("5uXOq");

var $kb4zh = parcelRequire("kb4zh");

var $lfTZh = parcelRequire("lfTZh");

var $kxZPA = parcelRequire("kxZPA");

const $dcd2c1aef082694d$var$LazyNoSoftwareLicense = (0, $kxZPA.lazyForPaint)(()=>(parcelRequire("rkyoD")), {
    moduleId: "./src/packages/spa-apps/common/src/error-screens/no-software-license/index.tsx"
});
const $dcd2c1aef082694d$export$52d8964299339cae = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $lfTZh.default), {
        name: "no-software-license",
        fallback: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $kb4zh.default), null)
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement($dcd2c1aef082694d$var$LazyNoSoftwareLicense, null));

});
parcelRegister("rkyoD", function(module, exports) {

let $052277489b40dfb1$var$load = (parcelRequire("28QjX"))(4);
module.exports = Promise.all([
    $052277489b40dfb1$var$load("kNFvF"),
    $052277489b40dfb1$var$load("1EEDl")
]).then(()=>parcelRequire('eX102'));

});



parcelRegister("eantU", function(module, exports) {

$parcel$export(module.exports, "default", () => $464e02af7f354def$export$2e2bcd8739ae039);

var $7VHMR = parcelRequire("7VHMR");
var $464e02af7f354def$export$2e2bcd8739ae039 = (0, $7VHMR.defineMessages)({
    boardWithUnmappedColumnFlagTitle: {
        "id": "spa-apps.next-gen-board.board.board-with-router-cmp.board-with-unmapped-column-flag-title",
        "defaultMessage": "We couldn't load your board"
    },
    boardWithUnmappedColumnFlagDescriptionForUser: {
        "id": "spa-apps.next-gen-board.board.board-with-router-cmp.board-with-unmapped-column-flag-description-for-user",
        "defaultMessage": "The board doesn't have any statuses mapped to its columns. Ask your admin to map statuses to columns in board settings."
    },
    boardWithUnmappedColumnFlagDescriptionForAdmin: {
        "id": "spa-apps.next-gen-board.board.board-with-router-cmp.board-with-unmapped-column-flag-description-for-admin",
        "defaultMessage": "The board doesn't have any statuses mapped to its columns. Ensure that at least 1 status is mapped to a column."
    },
    navigateToBoardSettingsCta: {
        "id": "spa-apps.next-gen-board.board.board-with-router-cmp.navigate-to-board-settings-cta",
        "defaultMessage": "Board settings"
    }
});

});


parcelRegister("kCEVs", function(module, exports) {

$parcel$export(module.exports, "BoardWithRouterRelay", () => $0b48d943eb448fb6$export$97d4107e2ddca4c2);

var $29r6q = parcelRequire("29r6q");

var $5uXOq = parcelRequire("5uXOq");

var $8Uumt = parcelRequire("8Uumt");

var $gEFwt = parcelRequire("gEFwt");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $5qQ9I = parcelRequire("5qQ9I");

var $9kARR = parcelRequire("9kARR");

var $9dbF6 = parcelRequire("9dbF6");

var $6XsPQ = parcelRequire("6XsPQ");

var $9OXo1 = parcelRequire("9OXo1");

var $bmKPg = parcelRequire("bmKPg");

var $7FT8M = parcelRequire("7FT8M");

var $k6PKo = parcelRequire("k6PKo");

var $8XaG5 = parcelRequire("8XaG5");
const $0b48d943eb448fb6$export$97d4107e2ddca4c2 = ({ hasSoftwareLicense: hasSoftwareLicense, boardQueryReference: boardQueryReference })=>{
    const [paramBoardId] = (0, $bmKPg.usePathParam)('boardId');
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const boardId = Number(paramBoardId);
    const aggData = (0, $8Uumt.usePreloadedQuery)(/* eslint-disable @atlassian/relay/unused-fields */ (0, $29r6q.default), /* eslint-enable @atlassian/relay/unused-fields */ boardQueryReference);
    const boardData = {
        data: (0, $7FT8M.transformAggToSwagData)(aggData),
        loading: false,
        error: null
    };
    const isCacheMiss = (0, $9kARR.useGetHasSuspended)();
    const isCacheHit = !isCacheMiss;
    const { projectLocation: projectLocation } = boardData.data || {};
    const response = (0, $ao2h1.useRelayResource)((0, $5qQ9I.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    if (!hasSoftwareLicense) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XaG5.NoSoftwareLicense), null);
    return(// @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XsPQ.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
            /* eslint-disable-next-line jira/deprecations/no-base-url */ baseUrl: tenantContext.baseUrl,
            projectKey: projectLocation.key,
            projectName: projectLocation.name,
            projectId: projectLocation.id,
            isSimplifiedProject: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
            subProduct: "software"
        }), (0, $4R6GH.fg)('jfp-magma-taskfail-event-multi-firing-board-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6PKo.BoardApp), {
            rapidViewId: boardId,
            projectKey: projectLocation.key,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT),
            context: {
                tenantContext: tenantContext
            },
            boardData: boardData,
            history: history,
            isCacheHit: isCacheHit,
            customFiltersQueryRef: customFiltersQueryRef
        }) : (0, $k6PKo.renderBoardApp)({
            rapidViewId: boardId,
            projectKey: projectLocation.key,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT),
            context: {
                tenantContext: tenantContext
            },
            boardData: boardData,
            history: history,
            isCacheHit: isCacheHit,
            customFiltersQueryRef: customFiltersQueryRef
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
            projectKey: projectLocation.key
        })))));
};

});
parcelRegister("29r6q", function(module, exports) {

$parcel$export(module.exports, "default", () => $821625877dab08cc$export$2e2bcd8739ae039);
/**
 * @generated SignedSource<<3a7e7a486467a3013ee642ee950bfe70>>
 * @relayHash 1b45667561f9430ea4e961757485983b
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67

var $eiowN = parcelRequire("eiowN");
const $821625877dab08cc$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "boardId"
        }
    ], v1 = [
        {
            "kind": "Variable",
            "name": "boardId",
            "variableName": "boardId"
        }
    ], v2 = {
        "kind": "ScalarField",
        "name": "userSwimlaneStrategy"
    }, v3 = {
        "kind": "ScalarField",
        "name": "name"
    }, v4 = {
        "kind": "ScalarField",
        "name": "swimlaneStrategy"
    }, v5 = {
        "kind": "ScalarField",
        "name": "hasClearedCards"
    }, v6 = {
        "kind": "ScalarField",
        "name": "rankCustomFieldId"
    }, v7 = {
        "kind": "ScalarField",
        "name": "accountId"
    }, v8 = {
        "kind": "ScalarField",
        "name": "picture"
    }, v9 = {
        "kind": "ScalarField",
        "name": "id"
    }, v10 = {
        "kind": "ScalarField",
        "name": "maxCardCount"
    }, v11 = {
        "kind": "ScalarField",
        "name": "category"
    }, v12 = {
        "kind": "ScalarField",
        "name": "transitionId"
    }, v13 = {
        "kind": "ScalarField",
        "name": "isGlobal"
    }, v14 = {
        "kind": "ScalarField",
        "name": "isInitial"
    }, v15 = {
        "kind": "ScalarField",
        "name": "hasConditions"
    }, v16 = {
        "kind": "ScalarField",
        "name": "isDone"
    }, v17 = {
        "kind": "ScalarField",
        "name": "flagged"
    }, v18 = {
        "kind": "ScalarField",
        "name": "done"
    }, v19 = {
        "kind": "ScalarField",
        "name": "parentId"
    }, v20 = {
        "kind": "ScalarField",
        "name": "storyPoints"
    }, v21 = {
        "kind": "ScalarField",
        "name": "value"
    }, v22 = {
        "kind": "ScalarField",
        "name": "valueAsText"
    }, v23 = {
        "kind": "ScalarField",
        "name": "key"
    }, v24 = {
        "kind": "ScalarField",
        "name": "summary"
    }, v25 = {
        "kind": "ScalarField",
        "name": "labels"
    }, v26 = {
        "kind": "ScalarField",
        "name": "iconUrl"
    }, v27 = {
        "kind": "ScalarField",
        "name": "dueDate"
    }, v28 = {
        "kind": "ScalarField",
        "name": "complete"
    }, v29 = {
        "kind": "ScalarField",
        "name": "total"
    }, v30 = {
        "kind": "ScalarField",
        "name": "hierarchyLevelType"
    }, v31 = {
        "kind": "ScalarField",
        "name": "enabled"
    }, v32 = [
        {
            "kind": "Literal",
            "name": "state",
            "value": [
                "ACTIVE"
            ]
        }
    ], v33 = {
        "kind": "ScalarField",
        "name": "goal"
    }, v34 = {
        "kind": "ScalarField",
        "name": "startDate"
    }, v35 = {
        "kind": "ScalarField",
        "name": "endDate"
    }, v36 = {
        "kind": "ScalarField",
        "name": "daysRemaining"
    }, v37 = {
        "kind": "ScalarField",
        "name": "status"
    }, v38 = {
        "kind": "ScalarField",
        "name": "toggle"
    }, v39 = {
        "kind": "ScalarField",
        "name": "color"
    }, v40 = {
        "kind": "ScalarField",
        "name": "permissions"
    }, v41 = {
        "concreteType": "EstimationConfig",
        "kind": "LinkedField",
        "name": "estimation",
        "plural": false,
        "selections": [
            {
                "concreteType": "CurrentEstimation",
                "kind": "LinkedField",
                "name": "current",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "customFieldId"
                    }
                ]
            }
        ]
    }, v42 = {
        "kind": "ScalarField",
        "name": "__typename"
    }, v43 = [
        v42 /*: any*/ ,
        v7 /*: any*/ ,
        v3 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ 
    ], v44 = {
        "concreteType": "CardStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": [
            v9 /*: any*/ ,
            v3 /*: any*/ ,
            v11 /*: any*/ 
        ]
    }, v45 = [
        v9 /*: any*/ 
    ], v46 = {
        "concreteType": "CardStatus",
        "kind": "LinkedField",
        "name": "status",
        "plural": false,
        "selections": v45 /*: any*/ 
    }, v47 = {
        "concreteType": "Estimate",
        "kind": "LinkedField",
        "name": "estimate",
        "plural": false,
        "selections": [
            v20 /*: any*/ ,
            {
                "concreteType": "OriginalEstimate",
                "kind": "LinkedField",
                "name": "originalEstimate",
                "plural": false,
                "selections": [
                    v21 /*: any*/ ,
                    v22 /*: any*/ 
                ]
            }
        ]
    }, v48 = [
        v9 /*: any*/ ,
        v3 /*: any*/ ,
        v26 /*: any*/ 
    ], v49 = {
        "concreteType": "CardType",
        "kind": "LinkedField",
        "name": "type",
        "plural": false,
        "selections": v48 /*: any*/ 
    }, v50 = {
        "concreteType": "CardPriority",
        "kind": "LinkedField",
        "name": "priority",
        "plural": false,
        "selections": [
            v3 /*: any*/ ,
            v26 /*: any*/ 
        ]
    }, v51 = {
        "concreteType": "CardType",
        "kind": "LinkedField",
        "name": "cardTypes",
        "plural": true,
        "selections": [
            v9 /*: any*/ ,
            v3 /*: any*/ ,
            v26 /*: any*/ ,
            v30 /*: any*/ 
        ]
    }, v52 = [
        v31 /*: any*/ 
    ], v53 = {
        "concreteType": "InlineCardCreateConfig",
        "kind": "LinkedField",
        "name": "inlineCardCreate",
        "plural": false,
        "selections": v52 /*: any*/ 
    }, v54 = {
        "concreteType": "SoftwareCard",
        "kind": "LinkedField",
        "name": "cards",
        "plural": true,
        "selections": v45 /*: any*/ 
    };
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "boardWithRouterRelayQuery",
            "selections": [
                {
                    "kind": "RequiredField",
                    "field": {
                        "args": v1 /*: any*/ ,
                        "concreteType": "BoardScope",
                        "kind": "LinkedField",
                        "name": "boardScope",
                        "plural": false,
                        "selections": [
                            v2 /*: any*/ ,
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareBoard",
                                    "kind": "LinkedField",
                                    "name": "board",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v4 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.swimlaneStrategy"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v5 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.hasClearedCards"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v6 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.board.rankCustomFieldId"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "kind": "LinkedField",
                                                "name": "assignees",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v7 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.accountId"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v8 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.assignees.picture"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.assignees"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "Column",
                                                "kind": "LinkedField",
                                                "name": "columns",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.name"
                                                    },
                                                    v10 /*: any*/ ,
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "ColumnStatus",
                                                            "kind": "LinkedField",
                                                            "name": "columnStatus",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v11 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.status.category"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.columnStatus.status"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "SoftwareCardTypeTransition",
                                                                        "kind": "LinkedField",
                                                                        "name": "cardTypeTransitions",
                                                                        "plural": true,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v12 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.transitionId"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "CardStatus",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "status",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.status.id"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.status"
                                                                            },
                                                                            {
                                                                                "concreteType": "CardStatus",
                                                                                "kind": "LinkedField",
                                                                                "name": "originStatus",
                                                                                "plural": false,
                                                                                "selections": [
                                                                                    {
                                                                                        "kind": "RequiredField",
                                                                                        "field": v9 /*: any*/ ,
                                                                                        "action": "THROW",
                                                                                        "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.originStatus.id"
                                                                                    }
                                                                                ]
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": {
                                                                                    "concreteType": "CardType",
                                                                                    "kind": "LinkedField",
                                                                                    "name": "cardType",
                                                                                    "plural": false,
                                                                                    "selections": [
                                                                                        {
                                                                                            "kind": "RequiredField",
                                                                                            "field": v9 /*: any*/ ,
                                                                                            "action": "THROW",
                                                                                            "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.cardType.id"
                                                                                        }
                                                                                    ]
                                                                                },
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.cardType"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v13 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.isGlobal"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v14 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.isInitial"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v15 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.columnStatus.cardTypeTransitions.hasConditions"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.columnStatus.cardTypeTransitions"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.columnStatus"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v16 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.isDone"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v14 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.isInitial"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "SoftwareCard",
                                                            "kind": "LinkedField",
                                                            "name": "cards",
                                                            "plural": true,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v17 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.flagged"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v18 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.done"
                                                                },
                                                                v19 /*: any*/ ,
                                                                {
                                                                    "concreteType": "Sprint",
                                                                    "kind": "LinkedField",
                                                                    "name": "activeSprint",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v9 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.activeSprint.id"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "concreteType": "Estimate",
                                                                    "kind": "LinkedField",
                                                                    "name": "estimate",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        v20 /*: any*/ ,
                                                                        {
                                                                            "concreteType": "OriginalEstimate",
                                                                            "kind": "LinkedField",
                                                                            "name": "originalEstimate",
                                                                            "plural": false,
                                                                            "selections": [
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v21 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "boardScope.board.columns.cards.estimate.originalEstimate.value"
                                                                                },
                                                                                {
                                                                                    "kind": "RequiredField",
                                                                                    "field": v22 /*: any*/ ,
                                                                                    "action": "THROW",
                                                                                    "path": "boardScope.board.columns.cards.estimate.originalEstimate.valueAsText"
                                                                                }
                                                                            ]
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v23 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.key"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v24 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.summary"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v25 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.labels"
                                                                },
                                                                {
                                                                    "kind": "LinkedField",
                                                                    "name": "assignee",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v7 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.assignee.accountId"
                                                                        }
                                                                    ]
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardType",
                                                                        "kind": "LinkedField",
                                                                        "name": "type",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.id"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v3 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.name"
                                                                            },
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v26 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.type.iconUrl"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.type"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": {
                                                                        "concreteType": "CardStatus",
                                                                        "kind": "LinkedField",
                                                                        "name": "status",
                                                                        "plural": false,
                                                                        "selections": [
                                                                            {
                                                                                "kind": "RequiredField",
                                                                                "field": v9 /*: any*/ ,
                                                                                "action": "THROW",
                                                                                "path": "boardScope.board.columns.cards.status.id"
                                                                            }
                                                                        ]
                                                                    },
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.columns.cards.status"
                                                                },
                                                                {
                                                                    "concreteType": "CardPriority",
                                                                    "kind": "LinkedField",
                                                                    "name": "priority",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v3 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.priority.name"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v26 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.priority.iconUrl"
                                                                        }
                                                                    ]
                                                                },
                                                                v27 /*: any*/ ,
                                                                {
                                                                    "concreteType": "ChildCardsMetadata",
                                                                    "kind": "LinkedField",
                                                                    "name": "childCardsMetadata",
                                                                    "plural": false,
                                                                    "selections": [
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v28 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.childCardsMetadata.complete"
                                                                        },
                                                                        {
                                                                            "kind": "RequiredField",
                                                                            "field": v29 /*: any*/ ,
                                                                            "action": "THROW",
                                                                            "path": "boardScope.board.columns.cards.childCardsMetadata.total"
                                                                        }
                                                                    ]
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.columns.cards"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.columns"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardTypes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.iconUrl"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v30 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardTypes.hierarchyLevelType"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cardTypes"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "InlineCardCreateConfig",
                                                "kind": "LinkedField",
                                                "name": "inlineCardCreate",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v31 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.inlineCardCreate.enabled"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.inlineCardCreate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cardChildren",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v17 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.flagged"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v18 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.done"
                                                    },
                                                    v19 /*: any*/ ,
                                                    {
                                                        "concreteType": "Estimate",
                                                        "kind": "LinkedField",
                                                        "name": "estimate",
                                                        "plural": false,
                                                        "selections": [
                                                            v20 /*: any*/ ,
                                                            {
                                                                "concreteType": "OriginalEstimate",
                                                                "kind": "LinkedField",
                                                                "name": "originalEstimate",
                                                                "plural": false,
                                                                "selections": [
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v21 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cardChildren.estimate.originalEstimate.value"
                                                                    },
                                                                    {
                                                                        "kind": "RequiredField",
                                                                        "field": v22 /*: any*/ ,
                                                                        "action": "THROW",
                                                                        "path": "boardScope.board.cardChildren.estimate.originalEstimate.valueAsText"
                                                                    }
                                                                ]
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v23 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.key"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v24 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.summary"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v25 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.labels"
                                                    },
                                                    {
                                                        "kind": "LinkedField",
                                                        "name": "assignee",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v7 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.accountId"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v8 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.assignee.picture"
                                                            }
                                                        ]
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "type",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.id"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v3 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.name"
                                                                },
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v26 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.type.iconUrl"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.type"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "status",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v9 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.cardChildren.status.id"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cardChildren.status"
                                                    },
                                                    {
                                                        "concreteType": "CardPriority",
                                                        "kind": "LinkedField",
                                                        "name": "priority",
                                                        "plural": false,
                                                        "selections": [
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v3 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.priority.name"
                                                            },
                                                            {
                                                                "kind": "RequiredField",
                                                                "field": v26 /*: any*/ ,
                                                                "action": "THROW",
                                                                "path": "boardScope.board.cardChildren.priority.iconUrl"
                                                            }
                                                        ]
                                                    },
                                                    v27 /*: any*/ 
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cardChildren"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.board.cards.id"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.cards"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "BoardEditConfig",
                                                "kind": "LinkedField",
                                                "name": "editConfig",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "InlineColumnEditConfig",
                                                            "kind": "LinkedField",
                                                            "name": "inlineColumnEdit",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v31 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.editConfig.inlineColumnEdit.enabled"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.editConfig.inlineColumnEdit"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": {
                                                            "concreteType": "InlineCardCreateConfig",
                                                            "kind": "LinkedField",
                                                            "name": "inlineCardCreate",
                                                            "plural": false,
                                                            "selections": [
                                                                {
                                                                    "kind": "RequiredField",
                                                                    "field": v31 /*: any*/ ,
                                                                    "action": "THROW",
                                                                    "path": "boardScope.board.editConfig.inlineCardCreate.enabled"
                                                                }
                                                            ]
                                                        },
                                                        "action": "THROW",
                                                        "path": "boardScope.board.editConfig.inlineCardCreate"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.board.editConfig"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.board"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "args": v32 /*: any*/ ,
                                    "concreteType": "Sprint",
                                    "kind": "LinkedField",
                                    "name": "sprints",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.name"
                                        },
                                        v33 /*: any*/ ,
                                        {
                                            "kind": "RequiredField",
                                            "field": v34 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.startDate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v35 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.endDate"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v36 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.sprints.daysRemaining"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "SoftwareCard",
                                                "kind": "LinkedField",
                                                "name": "cards",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.sprints.cards.id"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.sprints.cards"
                                        }
                                    ],
                                    "storageKey": "sprints(state:[\"ACTIVE\"])"
                                },
                                "action": "THROW",
                                "path": "boardScope.sprints"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "BoardFeature",
                                    "kind": "LinkedField",
                                    "name": "features",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v37 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.status"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v38 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.toggle"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v11 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.features.category"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.features"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "SoftwareProject",
                                    "kind": "LinkedField",
                                    "name": "projectLocation",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v3 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.name"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardTypes",
                                                "plural": true,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.iconUrl"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v30 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.projectLocation.cardTypes.hierarchyLevelType"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.projectLocation.cardTypes"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.projectLocation"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CardParent",
                                    "kind": "LinkedField",
                                    "name": "cardParents",
                                    "plural": true,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v9 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.id"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v23 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.key"
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": v24 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.summary"
                                        },
                                        {
                                            "concreteType": "CardStatus",
                                            "kind": "LinkedField",
                                            "name": "status",
                                            "plural": false,
                                            "selections": [
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v9 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.id"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v3 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.name"
                                                },
                                                {
                                                    "kind": "RequiredField",
                                                    "field": v11 /*: any*/ ,
                                                    "action": "THROW",
                                                    "path": "boardScope.cardParents.status.category"
                                                }
                                            ]
                                        },
                                        {
                                            "kind": "RequiredField",
                                            "field": {
                                                "concreteType": "CardType",
                                                "kind": "LinkedField",
                                                "name": "cardType",
                                                "plural": false,
                                                "selections": [
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v9 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.id"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v3 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.name"
                                                    },
                                                    {
                                                        "kind": "RequiredField",
                                                        "field": v26 /*: any*/ ,
                                                        "action": "THROW",
                                                        "path": "boardScope.cardParents.cardType.iconUrl"
                                                    }
                                                ]
                                            },
                                            "action": "THROW",
                                            "path": "boardScope.cardParents.cardType"
                                        },
                                        v39 /*: any*/ 
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.cardParents"
                            },
                            {
                                "kind": "RequiredField",
                                "field": {
                                    "concreteType": "CurrentUser",
                                    "kind": "LinkedField",
                                    "name": "currentUser",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "kind": "RequiredField",
                                            "field": v40 /*: any*/ ,
                                            "action": "THROW",
                                            "path": "boardScope.currentUser.permissions"
                                        }
                                    ]
                                },
                                "action": "THROW",
                                "path": "boardScope.currentUser"
                            },
                            v41 /*: any*/ 
                        ]
                    },
                    "action": "THROW",
                    "path": "boardScope"
                }
            ],
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "boardWithRouterRelayQuery",
            "selections": [
                {
                    "args": v1 /*: any*/ ,
                    "concreteType": "BoardScope",
                    "kind": "LinkedField",
                    "name": "boardScope",
                    "plural": false,
                    "selections": [
                        v2 /*: any*/ ,
                        {
                            "concreteType": "SoftwareBoard",
                            "kind": "LinkedField",
                            "name": "board",
                            "plural": false,
                            "selections": [
                                v3 /*: any*/ ,
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                {
                                    "kind": "LinkedField",
                                    "name": "assignees",
                                    "plural": true,
                                    "selections": v43 /*: any*/ 
                                },
                                {
                                    "concreteType": "Column",
                                    "kind": "LinkedField",
                                    "name": "columns",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v3 /*: any*/ ,
                                        v10 /*: any*/ ,
                                        {
                                            "concreteType": "ColumnStatus",
                                            "kind": "LinkedField",
                                            "name": "columnStatus",
                                            "plural": true,
                                            "selections": [
                                                v44 /*: any*/ ,
                                                {
                                                    "concreteType": "SoftwareCardTypeTransition",
                                                    "kind": "LinkedField",
                                                    "name": "cardTypeTransitions",
                                                    "plural": true,
                                                    "selections": [
                                                        v12 /*: any*/ ,
                                                        v3 /*: any*/ ,
                                                        v46 /*: any*/ ,
                                                        {
                                                            "concreteType": "CardStatus",
                                                            "kind": "LinkedField",
                                                            "name": "originStatus",
                                                            "plural": false,
                                                            "selections": v45 /*: any*/ 
                                                        },
                                                        {
                                                            "concreteType": "CardType",
                                                            "kind": "LinkedField",
                                                            "name": "cardType",
                                                            "plural": false,
                                                            "selections": v45 /*: any*/ 
                                                        },
                                                        v13 /*: any*/ ,
                                                        v14 /*: any*/ ,
                                                        v15 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        },
                                        v16 /*: any*/ ,
                                        v14 /*: any*/ ,
                                        {
                                            "concreteType": "SoftwareCard",
                                            "kind": "LinkedField",
                                            "name": "cards",
                                            "plural": true,
                                            "selections": [
                                                v9 /*: any*/ ,
                                                v17 /*: any*/ ,
                                                v18 /*: any*/ ,
                                                v19 /*: any*/ ,
                                                {
                                                    "concreteType": "Sprint",
                                                    "kind": "LinkedField",
                                                    "name": "activeSprint",
                                                    "plural": false,
                                                    "selections": v45 /*: any*/ 
                                                },
                                                v47 /*: any*/ ,
                                                v23 /*: any*/ ,
                                                v24 /*: any*/ ,
                                                v25 /*: any*/ ,
                                                {
                                                    "kind": "LinkedField",
                                                    "name": "assignee",
                                                    "plural": false,
                                                    "selections": [
                                                        v42 /*: any*/ ,
                                                        v7 /*: any*/ ,
                                                        v9 /*: any*/ 
                                                    ]
                                                },
                                                v49 /*: any*/ ,
                                                v46 /*: any*/ ,
                                                v50 /*: any*/ ,
                                                v27 /*: any*/ ,
                                                {
                                                    "concreteType": "ChildCardsMetadata",
                                                    "kind": "LinkedField",
                                                    "name": "childCardsMetadata",
                                                    "plural": false,
                                                    "selections": [
                                                        v28 /*: any*/ ,
                                                        v29 /*: any*/ 
                                                    ]
                                                }
                                            ]
                                        }
                                    ]
                                },
                                v51 /*: any*/ ,
                                v53 /*: any*/ ,
                                {
                                    "concreteType": "SoftwareCard",
                                    "kind": "LinkedField",
                                    "name": "cardChildren",
                                    "plural": true,
                                    "selections": [
                                        v9 /*: any*/ ,
                                        v17 /*: any*/ ,
                                        v18 /*: any*/ ,
                                        v19 /*: any*/ ,
                                        v47 /*: any*/ ,
                                        v23 /*: any*/ ,
                                        v24 /*: any*/ ,
                                        v25 /*: any*/ ,
                                        {
                                            "kind": "LinkedField",
                                            "name": "assignee",
                                            "plural": false,
                                            "selections": v43 /*: any*/ 
                                        },
                                        v49 /*: any*/ ,
                                        v46 /*: any*/ ,
                                        v50 /*: any*/ ,
                                        v27 /*: any*/ 
                                    ]
                                },
                                v54 /*: any*/ ,
                                {
                                    "concreteType": "BoardEditConfig",
                                    "kind": "LinkedField",
                                    "name": "editConfig",
                                    "plural": false,
                                    "selections": [
                                        {
                                            "concreteType": "InlineColumnEditConfig",
                                            "kind": "LinkedField",
                                            "name": "inlineColumnEdit",
                                            "plural": false,
                                            "selections": v52 /*: any*/ 
                                        },
                                        v53 /*: any*/ 
                                    ]
                                },
                                v9 /*: any*/ 
                            ]
                        },
                        {
                            "args": v32 /*: any*/ ,
                            "concreteType": "Sprint",
                            "kind": "LinkedField",
                            "name": "sprints",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v3 /*: any*/ ,
                                v33 /*: any*/ ,
                                v34 /*: any*/ ,
                                v35 /*: any*/ ,
                                v36 /*: any*/ ,
                                v54 /*: any*/ 
                            ],
                            "storageKey": "sprints(state:[\"ACTIVE\"])"
                        },
                        {
                            "concreteType": "BoardFeature",
                            "kind": "LinkedField",
                            "name": "features",
                            "plural": true,
                            "selections": [
                                v23 /*: any*/ ,
                                v37 /*: any*/ ,
                                v38 /*: any*/ ,
                                v11 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "SoftwareProject",
                            "kind": "LinkedField",
                            "name": "projectLocation",
                            "plural": false,
                            "selections": [
                                v9 /*: any*/ ,
                                v23 /*: any*/ ,
                                v3 /*: any*/ ,
                                v51 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CardParent",
                            "kind": "LinkedField",
                            "name": "cardParents",
                            "plural": true,
                            "selections": [
                                v9 /*: any*/ ,
                                v23 /*: any*/ ,
                                v24 /*: any*/ ,
                                v44 /*: any*/ ,
                                {
                                    "concreteType": "CardType",
                                    "kind": "LinkedField",
                                    "name": "cardType",
                                    "plural": false,
                                    "selections": v48 /*: any*/ 
                                },
                                v39 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "CurrentUser",
                            "kind": "LinkedField",
                            "name": "currentUser",
                            "plural": false,
                            "selections": [
                                v40 /*: any*/ 
                            ]
                        },
                        v41 /*: any*/ ,
                        v9 /*: any*/ 
                    ]
                }
            ]
        },
        "params": {
            "id": "ab366f74068bb048193650cda464a839daec6f71dd9d1e7ee8874e9f9959ba67",
            "metadata": {},
            "name": "boardWithRouterRelayQuery",
            "operationKind": "query",
            "text": null
        }
    };
}();
$821625877dab08cc$var$node.hash = "72f5b0ae535a7d894e92c5d09606d166";
(0, $eiowN.PreloadableQueryRegistry).set($821625877dab08cc$var$node.params.id, $821625877dab08cc$var$node);
var $821625877dab08cc$export$2e2bcd8739ae039 = $821625877dab08cc$var$node;

});

parcelRegister("6XsPQ", function(module, exports) {

$parcel$export(module.exports, "HistoryAdapter", () => $c364a1ba7d823379$export$d852f51b8427aefc);

var $5uXOq = parcelRequire("5uXOq");

var $1bQGJ = parcelRequire("1bQGJ");

var $8oKIZ = parcelRequire("8oKIZ");
// eslint-disable-next-line jira/react/no-class-components
class $c364a1ba7d823379$var$HistoryAdapterComponent extends (0, $5uXOq.Component) {
    constructor(props){
        super(props);
        this.compatibleHistory = (0, $8oKIZ.createReactRouterCompatibleHistory)(props.history);
    }
    shouldComponentUpdate(nextProps) {
        return nextProps.children !== this.props.children;
    }
    componentWillUnmount() {
        this.compatibleHistory.destroy && this.compatibleHistory.destroy();
    }
    render() {
        const { children: children } = this.props;
        return children(this.compatibleHistory);
    }
}
const $c364a1ba7d823379$export$d852f51b8427aefc = (0, $1bQGJ.withRouter)($c364a1ba7d823379$var$HistoryAdapterComponent);

});
parcelRegister("8oKIZ", function(module, exports) {

$parcel$export(module.exports, "createReactRouterCompatibleHistory", () => $e043da36553b4806$export$2df73cd79c2401bf);

var $bxYf9 = parcelRequire("bxYf9");
const $e043da36553b4806$export$2df73cd79c2401bf = (history)=>{
    let cleaned = false;
    let listeners = [];
    // @ts-expect-error - TS2304 - Cannot find name 'HistoryAction'.
    const listen = (callback)=>{
        if (cleaned) // Replace with lodash/noop
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        return ()=>{};
        const unsubscribe = (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(history.listen(callback));
        const listener = {
            unsubscribe: unsubscribe
        };
        listeners.push(listener);
        return (0, (/*@__PURE__*/$parcel$interopDefault($bxYf9)))(()=>{
            listener.unsubscribe();
        });
    };
    const cleanup = ()=>{
        listeners.forEach(({ unsubscribe: unsubscribe })=>{
            unsubscribe();
        });
        cleaned = true;
        listeners = [];
    };
    return {
        get length () {
            return history.length;
        },
        get location () {
            return history.location;
        },
        get action () {
            return history.action;
        },
        get index () {
            return history.index;
        },
        get entries () {
            return history.entries;
        },
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        push: (path, state)=>history.push(path, state),
        // @ts-expect-error - TS7006 - Parameter 'state' implicitly has an 'any' type.
        replace: (path, state)=>history.replace(path, state),
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        go: (n)=>history.go(n),
        goBack: ()=>history.goBack(),
        goForward: ()=>history.goForward(),
        // @ts-expect-error - TS7019 - Rest parameter 'args' implicitly has an 'any[]' type.
        createHref: (...args)=>history.createHref(...args),
        // Memory only
        // @ts-expect-error - TS7006 - Parameter 'n' implicitly has an 'any' type.
        canGo: (n)=>{
            if (history.canGo) return history.canGo(n);
            return true;
        },
        listen: listen,
        // @ts-expect-error - TS7006 - Parameter 'blocker' implicitly has an 'any' type.
        block: (blocker)=>history.block(blocker),
        destroy: cleanup
    };
};

});


parcelRegister("7FT8M", function(module, exports) {

$parcel$export(module.exports, "transformAggToSwagData", () => $0967d8b4618688d9$export$7285a1393f8c650c);

var $8QpSo = parcelRequire("8QpSo");

var $dXq4S = parcelRequire("dXq4S");
const $0967d8b4618688d9$export$79640a85913af5aa = (ari)=>{
    const possibleAri = (0, $dXq4S.toAri)(ari);
    if (possibleAri) return (0, $dXq4S.getAriConfig)(possibleAri).resourceId;
    return ari;
};
const $0967d8b4618688d9$var$getBoard = (data)=>{
    const { boardScope: { board: board } } = data;
    return {
        name: board.name,
        swimlaneStrategy: board.swimlaneStrategy,
        rankCustomFieldId: board.rankCustomFieldId,
        assignees: board.assignees.filter(Boolean).map((assignee)=>({
                accountId: assignee.accountId,
                displayName: assignee.name,
                avatarUrl: assignee.picture
            })),
        // @ts-expect-error - TS2322 - Type '{ id: string; name: string; maxIssueCount: number | null; status: { id: string; name: string; }[]; columnStatus: { status: { readonly category: string; readonly id: string; readonly name: string; }; transitions: { ...; }[]; }[]; isInitial: boolean; isDone: boolean; cards: { ...; }[]; }[]' is not assignable to type 'readonly ColumnWithCardsGQL[]'.
        columns: board.columns.filter(Boolean).map((column)=>({
                id: column.id,
                name: column.name,
                maxIssueCount: column.maxCardCount,
                status: column.columnStatus.map((cs)=>({
                        id: cs.status.id,
                        name: cs.status.name
                    })),
                columnStatus: column.columnStatus.map((cs)=>({
                        status: cs.status,
                        transitions: cs.cardTypeTransitions.map((transition)=>({
                                id: transition.transitionId,
                                name: transition.name,
                                status: transition.status,
                                originStatus: transition.originStatus,
                                cardType: transition.cardType,
                                isGlobal: transition.isGlobal,
                                isInitial: transition.isInitial,
                                hasConditions: transition.hasConditions
                            }))
                    })),
                isInitial: column.isInitial,
                isDone: column.isDone,
                cards: column.cards.filter(Boolean).map((card)=>({
                        id: $0967d8b4618688d9$export$79640a85913af5aa(card.id),
                        activeSprint: card.activeSprint ? {
                            id: $0967d8b4618688d9$export$79640a85913af5aa(card.activeSprint.id)
                        } : null,
                        issue: {
                            id: $0967d8b4618688d9$export$79640a85913af5aa(card.id),
                            key: card.key,
                            summary: card.summary,
                            labels: card.labels.filter(Boolean),
                            type: card.type,
                            status: card.status,
                            assignee: card.assignee ? {
                                accountId: card.assignee.accountId
                            } : null
                        },
                        flagged: card.flagged,
                        done: card.done,
                        parentId: card.parentId != null ? $0967d8b4618688d9$export$79640a85913af5aa(card.parentId) : null,
                        estimate: card.estimate ? card.estimate : null,
                        priority: card.priority,
                        dueDate: card.dueDate,
                        childIssuesMetadata: card.childCardsMetadata
                    }))
            })),
        // @ts-expect-error - TS2322 - Type '({ readonly hierarchyLevelType: AGG$CardTypeHierarchyLevelType; readonly iconUrl: string; readonly id: string; readonly name: string; } | null)[]' is not assignable to type 'readonly IssueTypeGQL[]'.
        issueTypes: board.cardTypes.filter(Boolean),
        // @ts-expect-error - TS2322 - Type '{ id: string; issue: { assignee: { accountId: string; displayName: string; avatarUrl: AGG$URL; } | null; id: string; key: string; summary: string; labels: (string | null)[]; status: { readonly id: string; }; type: { ...; }; }; ... 5 more ...; dueDate: string | null; }[]' is not assignable to type 'readonly CardChildGQL[]'.
        issueChildren: board.cardChildren.filter(Boolean).map((card)=>({
                id: $0967d8b4618688d9$export$79640a85913af5aa(card.id),
                issue: {
                    assignee: card.assignee != null ? {
                        accountId: card.assignee.accountId,
                        displayName: card.assignee.name,
                        avatarUrl: card.assignee.picture
                    } : null,
                    id: $0967d8b4618688d9$export$79640a85913af5aa(card.id),
                    key: card.key,
                    summary: card.summary,
                    labels: card.labels.filter(Boolean),
                    status: card.status,
                    type: card.type
                },
                flagged: card.flagged,
                done: card.done,
                parentId: card.parentId != null ? $0967d8b4618688d9$export$79640a85913af5aa(card.parentId) : null,
                estimate: card.estimate ? card.estimate : null,
                priority: card.priority,
                dueDate: card.dueDate
            })),
        cards: board.cards.filter(Boolean).map((card)=>({
                id: $0967d8b4618688d9$export$79640a85913af5aa(card.id)
            })),
        editConfig: {
            inlineColumnEdit: board.editConfig.inlineColumnEdit,
            inlineIssueCreate: board.editConfig.inlineCardCreate
        },
        hasClearedIssues: board.hasClearedCards,
        inlineIssueCreate: board.inlineCardCreate
    };
};
const $0967d8b4618688d9$export$7285a1393f8c650c = (0, $8QpSo.default)((data)=>{
    const { boardScope: boardScope } = data;
    return {
        userSwimlaneStrategy: boardScope.userSwimlaneStrategy,
        board: $0967d8b4618688d9$var$getBoard(data),
        sprints: boardScope.sprints.filter(Boolean).map((sprint)=>({
                ...sprint,
                goal: sprint.goal || '',
                id: $0967d8b4618688d9$export$79640a85913af5aa(sprint.id),
                cards: sprint.cards.filter(Boolean)
            })),
        // @ts-expect-error - TS2322 - Type '({ readonly category: string; readonly key: AGG$SoftwareBoardFeatureKey; readonly status: BoardFeatureStatus; readonly toggle: BoardFeatureToggleStatus; } | null)[]' is not assignable to type 'readonly BoardFeatureGQL[]'.
        features: boardScope.features.filter(Boolean),
        projectLocation: {
            id: $0967d8b4618688d9$export$79640a85913af5aa(boardScope.projectLocation.id),
            key: boardScope.projectLocation.key,
            name: boardScope.projectLocation.name,
            isSimplifiedProject: true,
            // @ts-expect-error - TS2322 - Type '({ readonly hierarchyLevelType: AGG$CardTypeHierarchyLevelType; readonly iconUrl: string; readonly id: string; readonly name: string; } | null)[]' is not assignable to type 'readonly IssueTypeGQL[]'.
            issueTypes: boardScope.projectLocation.cardTypes.filter(Boolean)
        },
        issueParents: boardScope.cardParents.filter(Boolean).map((cardParent)=>({
                id: $0967d8b4618688d9$export$79640a85913af5aa(cardParent.id),
                key: cardParent.key,
                summary: cardParent.summary,
                issue: {
                    status: cardParent.status
                },
                issueType: cardParent.cardType,
                color: cardParent.color
            })),
        currentUser: {
            permissions: boardScope.currentUser.permissions.filter(Boolean)
        },
        estimation: boardScope.estimation
    };
});

});


parcelRegister("6Zotr", function(module, exports) {

$parcel$export(module.exports, "BoardWithRouter", () => $7afc6accdedf8e8f$export$80a10a58d5111cf6);

var $5uXOq = parcelRequire("5uXOq");

var $gEFwt = parcelRequire("gEFwt");

var $2vSU6 = parcelRequire("2vSU6");

var $4R6GH = parcelRequire("4R6GH");

var $3mYHL = parcelRequire("3mYHL");

var $ao2h1 = parcelRequire("ao2h1");

var $dMC1b = parcelRequire("dMC1b");

var $5qQ9I = parcelRequire("5qQ9I");

var $9dbF6 = parcelRequire("9dbF6");

var $6XsPQ = parcelRequire("6XsPQ");

var $9OXo1 = parcelRequire("9OXo1");

var $6s1PB = parcelRequire("6s1PB");

var $bmKPg = parcelRequire("bmKPg");
var $ieDtd = parcelRequire("ieDtd");
var $2YP9W = parcelRequire("2YP9W");

var $0z6W8 = parcelRequire("0z6W8");

var $12Sv5 = parcelRequire("12Sv5");

var $k6PKo = parcelRequire("k6PKo");

var $8XaG5 = parcelRequire("8XaG5");
const $7afc6accdedf8e8f$export$80a10a58d5111cf6 = ({ hasSoftwareLicense: hasSoftwareLicense })=>{
    const isUserBoard = (0, $12Sv5.useIsUserBoardRoute)();
    const [paramBoardId] = (0, $bmKPg.usePathParam)('boardId');
    const [projectKey] = (0, $bmKPg.usePathParam)('projectKey');
    const boardState = (0, $2YP9W.useResource)((0, $dMC1b.boardResource));
    const tenantContext = (0, $9OXo1.useTenantContext)();
    const boardId = Number(paramBoardId);
    const isCacheHitRef = (0, $5uXOq.useRef)(boardState.data != null);
    const isCacheHit = isCacheHitRef.current;
    const boardData = {
        data: boardState.data,
        loading: boardState.loading,
        error: boardState.error
    };
    const { key: key, id: id, name: name } = boardData.data?.projectLocation || {};
    const projectDetails = {
        key: key,
        id: id,
        name: name
    };
    const projectKeyFromContext = projectDetails.key || projectKey || '';
    const response = (0, $ao2h1.useRelayResource)((0, $5qQ9I.customFiltersResource));
    const customFiltersQueryRef = response.queryReference;
    let boardFilterRefinementQueryRef;
    if ((0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false)) {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const { queryReference: queryReference } = (0, $ao2h1.useRelayResource)((0, $5qQ9I.boardFilterRefinementResource));
        boardFilterRefinementQueryRef = queryReference;
    }
    const [selectedIssue] = (0, $ieDtd.useQueryParam)('selectedIssue');
    (0, $5uXOq.useEffect)(()=>{
        if (selectedIssue) (0, $0z6W8.updatePageloadName)('next-gen-board-with-issue-view');
    }, [
        selectedIssue
    ]);
    return hasSoftwareLicense ? // @ts-expect-error - TS2739 - Type '{ children: (history: any) => Element; }' is missing the following properties from type 'RouteContext': location, query, route, match, action
    /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $6XsPQ.HistoryAdapter), null, (history)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $gEFwt.default), {
            /* eslint-disable-next-line jira/deprecations/no-base-url */ baseUrl: tenantContext.baseUrl,
            projectKey: projectKeyFromContext,
            projectName: projectDetails.name ?? projectKey,
            projectId: projectDetails.id,
            isSimplifiedProject: true
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).Fragment, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $9dbF6.SubProductUpdater), {
            subProduct: "software"
        }), (0, $4R6GH.fg)('jfp-magma-taskfail-event-multi-firing-board-fix') ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $k6PKo.BoardApp), {
            rapidViewId: boardId,
            projectKey: projectKeyFromContext,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT),
            context: {
                tenantContext: tenantContext
            },
            boardData: boardData,
            history: history,
            isCacheHit: isCacheHit,
            customFiltersQueryRef: customFiltersQueryRef,
            boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
            isCMPBoard: false,
            isUserBoard: isUserBoard
        }) : (0, $k6PKo.renderBoardApp)({
            rapidViewId: boardId,
            projectKey: projectKeyFromContext,
            projectType: (0, $2vSU6.SOFTWARE_PROJECT),
            context: {
                tenantContext: tenantContext
            },
            boardData: boardData,
            history: history,
            isCacheHit: isCacheHit,
            customFiltersQueryRef: customFiltersQueryRef,
            boardFilterRefinementQueryRef: boardFilterRefinementQueryRef,
            isCMPBoard: false,
            isUserBoard: isUserBoard
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $3mYHL.default), {
            projectKey: projectKey || projectKeyFromContext || null
        })))) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($5uXOq))).createElement((0, $8XaG5.NoSoftwareLicense), null);
};

});
parcelRegister("dMC1b", function(module, exports) {

$parcel$export(module.exports, "boardResource", () => $73a4b6179bd7e4aa$export$286b76e0f2661cfb);

var $2M1hQ = parcelRequire("2M1hQ");


var $11pNz = parcelRequire("11pNz");
const $73a4b6179bd7e4aa$export$286b76e0f2661cfb = (0, $2M1hQ.createResource)({
    type: (0, $a00fc8fb83f2948a$export$a38ac7339e3f31db),
    getKey: ({ match: match })=>match.params.boardId || '',
    getDataLoader: ()=>Promise.resolve({
            default: (0, $11pNz.default)
        }),
    // SSR doesn't care about this and we can't check FFs here because its not in the render path
    maxAge: 3600000
});

});
parcelRegister("11pNz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "getEarlyPreload", () => $9b1c3000d033b19c$export$fed0052f40119df3);
$parcel$export(module.exports, "fetchData", () => $9b1c3000d033b19c$export$8134c072fddab6a5);
$parcel$export(module.exports, "default", () => $9b1c3000d033b19c$export$2e2bcd8739ae039);

var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $iR3GG = parcelRequire("iR3GG");

var $cNrxd = parcelRequire("cNrxd");

var $9NiTW = parcelRequire("9NiTW");

var $3RV1W = parcelRequire("3RV1W");

var $6s1PB = parcelRequire("6s1PB");

var $luzsA = parcelRequire("luzsA");
const $9b1c3000d033b19c$export$fed0052f40119df3 = ()=>{
    // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
    if (window.__JSW_BOARD_DATA_PROMISE__) {
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        const earlyPreloadPromise = window.__JSW_BOARD_DATA_PROMISE__;
        // eslint-disable-next-line jira/jira-ssr/no-unchecked-globals-usage
        window.__JSW_BOARD_DATA_PROMISE__ = null;
        return earlyPreloadPromise.then((preload)=>{
            if (preload.errors && preload.errors.length || !preload.data?.boardScope) throw new (0, $cNrxd.SwagError)({
                graphQLErrors: preload.errors,
                errorMessage: 'Board critical early fetch failed'
            });
            return preload.data.boardScope;
        });
    }
    return null;
};
const $9b1c3000d033b19c$export$8134c072fddab6a5 = (baseUrl, boardId, filterJql)=>{
    const earlyPreload = $9b1c3000d033b19c$export$fed0052f40119df3();
    if (earlyPreload != null) return earlyPreload;
    return (0, $luzsA.fetchBoardData)(baseUrl, boardId || '', filterJql);
};
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$9b1c3000d033b19c$export$2e2bcd8739ae039 = async ({ match: match, query: query }, { tenantContext: tenantContext })=>{
    if (!(0, $9NiTW.checkAuthentication)(tenantContext) || !match.params.boardId) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.next-gen.software-boards-data.getData',
        message: 'Current user is not authenticated',
        name: 'AuthenticationError',
        skipSentry: true
    });
    if (!(0, $3RV1W.checkLicense)(tenantContext, 'software')) throw (0, $iR3GG.createResourceError)({
        component: 'spa.view.routes.next-gen.software-boards-data.getData',
        message: 'License check failed',
        name: 'AuthenticationError',
        skipSentry: true
    });
    const { baseUrl: baseUrl } = tenantContext;
    const filterJql = (0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false) ? query.jql : undefined;
    try {
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiStartMark));
        const data = await $9b1c3000d033b19c$export$8134c072fddab6a5(baseUrl, match.params.boardId, filterJql);
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (error) {
        throw (0, $iR3GG.createResourceError)({
            component: 'spa.view.routes.next-gen.software-boards.getData',
            message: 'An error was thrown while prefetching board data',
            name: 'ResourceError'
        }, error);
    }
};

});
parcelRegister("iR3GG", function(module, exports) {

$parcel$export(module.exports, "createResourceError", () => $d895341acba1e817$export$13487d18466bc8a5);

var $2YZCu = parcelRequire("2YZCu");
class $d895341acba1e817$var$ResourceErrorClass extends Error {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(message, options){
        super(message);
        this.name = options.name || 'ResourceError';
        this.skipSentry = options.skipSentry;
    }
}
const $d895341acba1e817$export$13487d18466bc8a5 = ({ name: name = 'ResourceError', message: message = '', component: component = '', skipSentry: skipSentry = false }, // eslint-disable-next-line @typescript-eslint/no-explicit-any
errorOverride)=>{
    (0, $2YZCu.default).safeErrorWithoutCustomerData(component, message, errorOverride);
    if (errorOverride) return errorOverride;
    return new $d895341acba1e817$var$ResourceErrorClass(message, {
        name: name,
        skipSentry: skipSentry
    });
};

});

parcelRegister("luzsA", function(module, exports) {

$parcel$export(module.exports, "fetchBoardData", () => $9dbb7d1ba2164e90$export$c454496371605af);
/* eslint-disable jira/import-whitelist */ /**
 * This is a duplicate of ./index.js with a reduced surface area to limit bundle
 * size for testing a new approach to route-based critical data fetching.
 * See https://jdog.jira-dev.com/jira/software/projects/SPAF/boards/3052?selectedIssue=SPAF-22
 */ 
var $x9xyg = parcelRequire("x9xyg");

var $8PRuf = parcelRequire("8PRuf");

var $71VJw = parcelRequire("71VJw");
const $9dbb7d1ba2164e90$export$c454496371605af = (baseUrl, rapidViewId, filterJql)=>(0, $71VJw.default)(baseUrl, rapidViewId, filterJql).toPromise().then((data)=>{
        (0, $x9xyg.setMark)((0, $8PRuf.prefetchApiReadyMark));
        return data;
    });

});
parcelRegister("71VJw", function(module, exports) {

$parcel$export(module.exports, "default", () => $b81dd50241c07ede$export$2e2bcd8739ae039);

var $kVLXA = parcelRequire("kVLXA");
parcelRequire("fp4O3");
parcelRequire("fPS7b");

var $4R6GH = parcelRequire("4R6GH");

var $fy8gS = parcelRequire("fy8gS");

var $cBLvH = parcelRequire("cBLvH");

var $6s1PB = parcelRequire("6s1PB");

var $l9rGV = parcelRequire("l9rGV");
const $b81dd50241c07ede$export$ba14d9a5a581e827 = (result)=>(0, $kVLXA.Observable).of(result.boardScope);
var // eslint-disable-next-line jira/import/no-anonymous-default-export
$b81dd50241c07ede$export$2e2bcd8739ae039 = (contextPath, boardId, filterJql)=>(0, $cBLvH.query$)(contextPath, (0, $fy8gS.softwareBoardScopeCriticalDataOperationName), (0, $fy8gS.getBoardScopeGraphqlQuery)(), {
        boardId: boardId,
        useBackendIccConfig: (0, $4R6GH.fg)('use_backend_tmp_icc_config_'),
        showIssueTransition: (0, $4R6GH.fg)('issue_transition_screen_in_jsw_tmp_board'),
        hasJqlFilter: Boolean((0, $6s1PB.expVal)('filter_refinement_in_tmp_board', 'isEnabled', false) && filterJql),
        filterJql: filterJql
    }, (0, $l9rGV.boardScopeDataCriticalAnalyticsOptions)).flatMap($b81dd50241c07ede$export$ba14d9a5a581e827);

});
parcelRegister("l9rGV", function(module, exports) {

$parcel$export(module.exports, "boardScopeDataCriticalAnalyticsOptions", () => $704c21e5cce64332$export$6d18ac14fb11db9a);
const $704c21e5cce64332$var$APP_METRIC_KEY = 'software.next-gen.boards';
const $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_METRIC_KEY = `${$704c21e5cce64332$var$APP_METRIC_KEY}.boardscope.critical`;
const $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_SLO = 1000;
const $704c21e5cce64332$export$6d18ac14fb11db9a = {
    analyticKey: $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_METRIC_KEY,
    slo: $704c21e5cce64332$var$BOARD_SCOPE_CRITICAL_SLO
};

});








const $08d1cd363c5f7148$export$b8b9d90f9e5bd72b = 'jiraPortfolio3CreateNewPlanWizardDrawer';
const $08d1cd363c5f7148$export$cfeee2ee86ead336 = 'advanced-roadmaps';
const $08d1cd363c5f7148$export$f27a837467ec20e5 = 'planWizard';
const $08d1cd363c5f7148$export$6afdd25b4da87159 = 30;
const $08d1cd363c5f7148$export$9a977208af30ffae = 'create-plan-wizard.load-time';
const $08d1cd363c5f7148$export$a8e537ef0c1e2586 = 'Days';
const $08d1cd363c5f7148$export$2a59d0fbc784e5c1 = '1';
const $08d1cd363c5f7148$export$7288711b5316ff78 = 'YYYY-MM-DD';
const $08d1cd363c5f7148$export$14ae725d0cc7daa1 = 'DD/MMM/YY';


//# sourceMappingURL=async-next-gen-board.d36a0a25.js.map
